var _d = Object.defineProperty;
var bd = (e, n, o) => n in e ? _d(e, n, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[n] = o;
var fi = (e, n, o) => (bd(e, typeof n != "symbol" ? n + "" : n, o), o);
const global$1 = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {};
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
var cachedSetTimeout = defaultSetTimout, cachedClearTimeout = defaultClearTimeout;
typeof global$1.setTimeout == "function" && (cachedSetTimeout = setTimeout);
typeof global$1.clearTimeout == "function" && (cachedClearTimeout = clearTimeout);
function runTimeout(e) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(e, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(e, 0);
  try {
    return cachedSetTimeout(e, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, e, 0);
    } catch {
      return cachedSetTimeout.call(this, e, 0);
    }
  }
}
function runClearTimeout(e) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(e);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(e);
  try {
    return cachedClearTimeout(e);
  } catch {
    try {
      return cachedClearTimeout.call(null, e);
    } catch {
      return cachedClearTimeout.call(this, e);
    }
  }
}
var queue$1 = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue$1 = currentQueue.concat(queue$1) : queueIndex = -1, queue$1.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var e = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var n = queue$1.length; n; ) {
      for (currentQueue = queue$1, queue$1 = []; ++queueIndex < n; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, n = queue$1.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(e);
  }
}
function nextTick$1(e) {
  var n = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var o = 1; o < arguments.length; o++)
      n[o - 1] = arguments[o];
  queue$1.push(new Item(e, n)), queue$1.length === 1 && !draining && runTimeout(drainQueue);
}
function Item(e, n) {
  this.fun = e, this.array = n;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var title = "browser", platform$4 = "browser", browser$e = !0, env = {}, argv = [], version$7 = "", versions = {}, release = {}, config$2 = {};
function noop$6() {
}
var on = noop$6, addListener = noop$6, once$1 = noop$6, off = noop$6, removeListener = noop$6, removeAllListeners = noop$6, emit$2 = noop$6;
function binding(e) {
  throw new Error("process.binding is not supported");
}
function cwd() {
  return "/";
}
function chdir(e) {
  throw new Error("process.chdir is not supported");
}
function umask() {
  return 0;
}
var performance = global$1.performance || {}, performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function hrtime(e) {
  var n = performanceNow.call(performance) * 1e-3, o = Math.floor(n), u = Math.floor(n % 1 * 1e9);
  return e && (o = o - e[0], u = u - e[1], u < 0 && (o--, u += 1e9)), [o, u];
}
var startTime = /* @__PURE__ */ new Date();
function uptime() {
  var e = /* @__PURE__ */ new Date(), n = e - startTime;
  return n / 1e3;
}
var browser$1$1 = {
  nextTick: nextTick$1,
  title,
  browser: browser$e,
  env,
  argv,
  version: version$7,
  versions,
  on,
  addListener,
  once: once$1,
  off,
  removeListener,
  removeAllListeners,
  emit: emit$2,
  binding,
  cwd,
  chdir,
  umask,
  hrtime,
  platform: platform$4,
  release,
  config: config$2,
  uptime
};
function makeMap(e, n) {
  const o = /* @__PURE__ */ Object.create(null), u = e.split(",");
  for (let c = 0; c < u.length; c++)
    o[u[c]] = !0;
  return n ? (c) => !!o[c.toLowerCase()] : (c) => !!o[c];
}
const EMPTY_OBJ = browser$1$1.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, EMPTY_ARR = browser$1$1.env.NODE_ENV !== "production" ? Object.freeze([]) : [], NOOP = () => {
}, NO$1 = () => !1, onRE = /^on[^a-z]/, isOn = (e) => onRE.test(e), isModelListener = (e) => e.startsWith("onUpdate:"), extend$5 = Object.assign, remove = (e, n) => {
  const o = e.indexOf(n);
  o > -1 && e.splice(o, 1);
}, hasOwnProperty$4 = Object.prototype.hasOwnProperty, hasOwn$1 = (e, n) => hasOwnProperty$4.call(e, n), isArray$7 = Array.isArray, isMap = (e) => toTypeString(e) === "[object Map]", isSet$2 = (e) => toTypeString(e) === "[object Set]", isDate$5 = (e) => toTypeString(e) === "[object Date]", isRegExp$3 = (e) => toTypeString(e) === "[object RegExp]", isFunction$7 = (e) => typeof e == "function", isString$5 = (e) => typeof e == "string", isSymbol = (e) => typeof e == "symbol", isObject$8 = (e) => e !== null && typeof e == "object", isPromise$1 = (e) => isObject$8(e) && isFunction$7(e.then) && isFunction$7(e.catch), objectToString = Object.prototype.toString, toTypeString = (e) => objectToString.call(e), toRawType = (e) => toTypeString(e).slice(8, -1), isPlainObject$5 = (e) => toTypeString(e) === "[object Object]", isIntegerKey = (e) => isString$5(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, isReservedProp = /* @__PURE__ */ makeMap(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), isBuiltInDirective = /* @__PURE__ */ makeMap(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), cacheStringFunction = (e) => {
  const n = /* @__PURE__ */ Object.create(null);
  return (o) => n[o] || (n[o] = e(o));
}, camelizeRE = /-(\w)/g, camelize = cacheStringFunction((e) => e.replace(camelizeRE, (n, o) => o ? o.toUpperCase() : "")), hyphenateRE = /\B([A-Z])/g, hyphenate = cacheStringFunction(
  (e) => e.replace(hyphenateRE, "-$1").toLowerCase()
), capitalize = cacheStringFunction(
  (e) => e.charAt(0).toUpperCase() + e.slice(1)
), toHandlerKey = cacheStringFunction(
  (e) => e ? `on${capitalize(e)}` : ""
), hasChanged = (e, n) => !Object.is(e, n), invokeArrayFns = (e, n) => {
  for (let o = 0; o < e.length; o++)
    e[o](n);
}, def = (e, n, o) => {
  Object.defineProperty(e, n, {
    configurable: !0,
    enumerable: !1,
    value: o
  });
}, looseToNumber = (e) => {
  const n = parseFloat(e);
  return isNaN(n) ? e : n;
}, toNumber = (e) => {
  const n = isString$5(e) ? Number(e) : NaN;
  return isNaN(n) ? e : n;
};
let _globalThis;
const getGlobalThis = () => _globalThis || (_globalThis = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global$1 < "u" ? global$1 : {}), GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console", isGloballyWhitelisted = /* @__PURE__ */ makeMap(GLOBALS_WHITE_LISTED);
function normalizeStyle(e) {
  if (isArray$7(e)) {
    const n = {};
    for (let o = 0; o < e.length; o++) {
      const u = e[o], c = isString$5(u) ? parseStringStyle(u) : normalizeStyle(u);
      if (c)
        for (const d in c)
          n[d] = c[d];
    }
    return n;
  } else {
    if (isString$5(e))
      return e;
    if (isObject$8(e))
      return e;
  }
}
const listDelimiterRE = /;(?![^(]*\))/g, propertyDelimiterRE = /:([^]+)/, styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(e) {
  const n = {};
  return e.replace(styleCommentRE, "").split(listDelimiterRE).forEach((o) => {
    if (o) {
      const u = o.split(propertyDelimiterRE);
      u.length > 1 && (n[u[0].trim()] = u[1].trim());
    }
  }), n;
}
function normalizeClass(e) {
  let n = "";
  if (isString$5(e))
    n = e;
  else if (isArray$7(e))
    for (let o = 0; o < e.length; o++) {
      const u = normalizeClass(e[o]);
      u && (n += u + " ");
    }
  else if (isObject$8(e))
    for (const o in e)
      e[o] && (n += o + " ");
  return n.trim();
}
function normalizeProps(e) {
  if (!e)
    return null;
  let { class: n, style: o } = e;
  return n && !isString$5(n) && (e.class = normalizeClass(n)), o && (e.style = normalizeStyle(o)), e;
}
const HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS), isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS), specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
function includeBooleanAttr(e) {
  return !!e || e === "";
}
function looseCompareArrays(e, n) {
  if (e.length !== n.length)
    return !1;
  let o = !0;
  for (let u = 0; o && u < e.length; u++)
    o = looseEqual(e[u], n[u]);
  return o;
}
function looseEqual(e, n) {
  if (e === n)
    return !0;
  let o = isDate$5(e), u = isDate$5(n);
  if (o || u)
    return o && u ? e.getTime() === n.getTime() : !1;
  if (o = isSymbol(e), u = isSymbol(n), o || u)
    return e === n;
  if (o = isArray$7(e), u = isArray$7(n), o || u)
    return o && u ? looseCompareArrays(e, n) : !1;
  if (o = isObject$8(e), u = isObject$8(n), o || u) {
    if (!o || !u)
      return !1;
    const c = Object.keys(e).length, d = Object.keys(n).length;
    if (c !== d)
      return !1;
    for (const m in e) {
      const v = e.hasOwnProperty(m), S = n.hasOwnProperty(m);
      if (v && !S || !v && S || !looseEqual(e[m], n[m]))
        return !1;
    }
  }
  return String(e) === String(n);
}
function looseIndexOf(e, n) {
  return e.findIndex((o) => looseEqual(o, n));
}
const toDisplayString = (e) => isString$5(e) ? e : e == null ? "" : isArray$7(e) || isObject$8(e) && (e.toString === objectToString || !isFunction$7(e.toString)) ? JSON.stringify(e, replacer, 2) : String(e), replacer = (e, n) => n && n.__v_isRef ? replacer(e, n.value) : isMap(n) ? {
  [`Map(${n.size})`]: [...n.entries()].reduce((o, [u, c]) => (o[`${u} =>`] = c, o), {})
} : isSet$2(n) ? {
  [`Set(${n.size})`]: [...n.values()]
} : isObject$8(n) && !isArray$7(n) && !isPlainObject$5(n) ? String(n) : n;
function warn$1(e, ...n) {
  console.warn(`[Vue warn] ${e}`, ...n);
}
let activeEffectScope;
class EffectScope {
  constructor(n = !1) {
    this.detached = n, this._active = !0, this.effects = [], this.cleanups = [], this.parent = activeEffectScope, !n && activeEffectScope && (this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  run(n) {
    if (this._active) {
      const o = activeEffectScope;
      try {
        return activeEffectScope = this, n();
      } finally {
        activeEffectScope = o;
      }
    } else
      browser$1$1.env.NODE_ENV !== "production" && warn$1("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    activeEffectScope = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    activeEffectScope = this.parent;
  }
  stop(n) {
    if (this._active) {
      let o, u;
      for (o = 0, u = this.effects.length; o < u; o++)
        this.effects[o].stop();
      for (o = 0, u = this.cleanups.length; o < u; o++)
        this.cleanups[o]();
      if (this.scopes)
        for (o = 0, u = this.scopes.length; o < u; o++)
          this.scopes[o].stop(!0);
      if (!this.detached && this.parent && !n) {
        const c = this.parent.scopes.pop();
        c && c !== this && (this.parent.scopes[this.index] = c, c.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function effectScope(e) {
  return new EffectScope(e);
}
function recordEffectScope(e, n = activeEffectScope) {
  n && n.active && n.effects.push(e);
}
function getCurrentScope() {
  return activeEffectScope;
}
function onScopeDispose(e) {
  activeEffectScope ? activeEffectScope.cleanups.push(e) : browser$1$1.env.NODE_ENV !== "production" && warn$1(
    "onScopeDispose() is called when there is no active effect scope to be associated with."
  );
}
const createDep = (e) => {
  const n = new Set(e);
  return n.w = 0, n.n = 0, n;
}, wasTracked = (e) => (e.w & trackOpBit) > 0, newTracked = (e) => (e.n & trackOpBit) > 0, initDepMarkers = ({ deps: e }) => {
  if (e.length)
    for (let n = 0; n < e.length; n++)
      e[n].w |= trackOpBit;
}, finalizeDepMarkers = (e) => {
  const { deps: n } = e;
  if (n.length) {
    let o = 0;
    for (let u = 0; u < n.length; u++) {
      const c = n[u];
      wasTracked(c) && !newTracked(c) ? c.delete(e) : n[o++] = c, c.w &= ~trackOpBit, c.n &= ~trackOpBit;
    }
    n.length = o;
  }
}, targetMap = /* @__PURE__ */ new WeakMap();
let effectTrackDepth = 0, trackOpBit = 1;
const maxMarkerBits = 30;
let activeEffect;
const ITERATE_KEY = Symbol(browser$1$1.env.NODE_ENV !== "production" ? "iterate" : ""), MAP_KEY_ITERATE_KEY = Symbol(browser$1$1.env.NODE_ENV !== "production" ? "Map key iterate" : "");
class ReactiveEffect {
  constructor(n, o = null, u) {
    this.fn = n, this.scheduler = o, this.active = !0, this.deps = [], this.parent = void 0, recordEffectScope(this, u);
  }
  run() {
    if (!this.active)
      return this.fn();
    let n = activeEffect, o = shouldTrack;
    for (; n; ) {
      if (n === this)
        return;
      n = n.parent;
    }
    try {
      return this.parent = activeEffect, activeEffect = this, shouldTrack = !0, trackOpBit = 1 << ++effectTrackDepth, effectTrackDepth <= maxMarkerBits ? initDepMarkers(this) : cleanupEffect(this), this.fn();
    } finally {
      effectTrackDepth <= maxMarkerBits && finalizeDepMarkers(this), trackOpBit = 1 << --effectTrackDepth, activeEffect = this.parent, shouldTrack = o, this.parent = void 0, this.deferStop && this.stop();
    }
  }
  stop() {
    activeEffect === this ? this.deferStop = !0 : this.active && (cleanupEffect(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function cleanupEffect(e) {
  const { deps: n } = e;
  if (n.length) {
    for (let o = 0; o < n.length; o++)
      n[o].delete(e);
    n.length = 0;
  }
}
function effect(e, n) {
  e.effect && (e = e.effect.fn);
  const o = new ReactiveEffect(e);
  n && (extend$5(o, n), n.scope && recordEffectScope(o, n.scope)), (!n || !n.lazy) && o.run();
  const u = o.run.bind(o);
  return u.effect = o, u;
}
function stop(e) {
  e.effect.stop();
}
let shouldTrack = !0;
const trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack), shouldTrack = !1;
}
function resetTracking() {
  const e = trackStack.pop();
  shouldTrack = e === void 0 ? !0 : e;
}
function track(e, n, o) {
  if (shouldTrack && activeEffect) {
    let u = targetMap.get(e);
    u || targetMap.set(e, u = /* @__PURE__ */ new Map());
    let c = u.get(o);
    c || u.set(o, c = createDep());
    const d = browser$1$1.env.NODE_ENV !== "production" ? { effect: activeEffect, target: e, type: n, key: o } : void 0;
    trackEffects(c, d);
  }
}
function trackEffects(e, n) {
  let o = !1;
  effectTrackDepth <= maxMarkerBits ? newTracked(e) || (e.n |= trackOpBit, o = !wasTracked(e)) : o = !e.has(activeEffect), o && (e.add(activeEffect), activeEffect.deps.push(e), browser$1$1.env.NODE_ENV !== "production" && activeEffect.onTrack && activeEffect.onTrack(
    extend$5(
      {
        effect: activeEffect
      },
      n
    )
  ));
}
function trigger(e, n, o, u, c, d) {
  const m = targetMap.get(e);
  if (!m)
    return;
  let v = [];
  if (n === "clear")
    v = [...m.values()];
  else if (o === "length" && isArray$7(e)) {
    const $ = Number(u);
    m.forEach((E, O) => {
      (O === "length" || O >= $) && v.push(E);
    });
  } else
    switch (o !== void 0 && v.push(m.get(o)), n) {
      case "add":
        isArray$7(e) ? isIntegerKey(o) && v.push(m.get("length")) : (v.push(m.get(ITERATE_KEY)), isMap(e) && v.push(m.get(MAP_KEY_ITERATE_KEY)));
        break;
      case "delete":
        isArray$7(e) || (v.push(m.get(ITERATE_KEY)), isMap(e) && v.push(m.get(MAP_KEY_ITERATE_KEY)));
        break;
      case "set":
        isMap(e) && v.push(m.get(ITERATE_KEY));
        break;
    }
  const S = browser$1$1.env.NODE_ENV !== "production" ? { target: e, type: n, key: o, newValue: u, oldValue: c, oldTarget: d } : void 0;
  if (v.length === 1)
    v[0] && (browser$1$1.env.NODE_ENV !== "production" ? triggerEffects(v[0], S) : triggerEffects(v[0]));
  else {
    const $ = [];
    for (const E of v)
      E && $.push(...E);
    browser$1$1.env.NODE_ENV !== "production" ? triggerEffects(createDep($), S) : triggerEffects(createDep($));
  }
}
function triggerEffects(e, n) {
  const o = isArray$7(e) ? e : [...e];
  for (const u of o)
    u.computed && triggerEffect(u, n);
  for (const u of o)
    u.computed || triggerEffect(u, n);
}
function triggerEffect(e, n) {
  (e !== activeEffect || e.allowRecurse) && (browser$1$1.env.NODE_ENV !== "production" && e.onTrigger && e.onTrigger(extend$5({ effect: e }, n)), e.scheduler ? e.scheduler() : e.run());
}
function getDepFromReactive(e, n) {
  var o;
  return (o = targetMap.get(e)) == null ? void 0 : o.get(n);
}
const isNonTrackableKeys = /* @__PURE__ */ makeMap("__proto__,__v_isRef,__isVue"), builtInSymbols = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(isSymbol)
), get$1$1 = /* @__PURE__ */ createGetter(), shallowGet = /* @__PURE__ */ createGetter(!1, !0), readonlyGet = /* @__PURE__ */ createGetter(!0), shallowReadonlyGet = /* @__PURE__ */ createGetter(!0, !0), arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
  const e = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((n) => {
    e[n] = function(...o) {
      const u = toRaw(this);
      for (let d = 0, m = this.length; d < m; d++)
        track(u, "get", d + "");
      const c = u[n](...o);
      return c === -1 || c === !1 ? u[n](...o.map(toRaw)) : c;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((n) => {
    e[n] = function(...o) {
      pauseTracking();
      const u = toRaw(this)[n].apply(this, o);
      return resetTracking(), u;
    };
  }), e;
}
function hasOwnProperty$3(e) {
  const n = toRaw(this);
  return track(n, "has", e), n.hasOwnProperty(e);
}
function createGetter(e = !1, n = !1) {
  return function(u, c, d) {
    if (c === "__v_isReactive")
      return !e;
    if (c === "__v_isReadonly")
      return e;
    if (c === "__v_isShallow")
      return n;
    if (c === "__v_raw" && d === (e ? n ? shallowReadonlyMap : readonlyMap : n ? shallowReactiveMap : reactiveMap).get(u))
      return u;
    const m = isArray$7(u);
    if (!e) {
      if (m && hasOwn$1(arrayInstrumentations, c))
        return Reflect.get(arrayInstrumentations, c, d);
      if (c === "hasOwnProperty")
        return hasOwnProperty$3;
    }
    const v = Reflect.get(u, c, d);
    return (isSymbol(c) ? builtInSymbols.has(c) : isNonTrackableKeys(c)) || (e || track(u, "get", c), n) ? v : isRef(v) ? m && isIntegerKey(c) ? v : v.value : isObject$8(v) ? e ? readonly(v) : reactive(v) : v;
  };
}
const set$1 = /* @__PURE__ */ createSetter(), shallowSet = /* @__PURE__ */ createSetter(!0);
function createSetter(e = !1) {
  return function(o, u, c, d) {
    let m = o[u];
    if (isReadonly(m) && isRef(m) && !isRef(c))
      return !1;
    if (!e && (!isShallow$1(c) && !isReadonly(c) && (m = toRaw(m), c = toRaw(c)), !isArray$7(o) && isRef(m) && !isRef(c)))
      return m.value = c, !0;
    const v = isArray$7(o) && isIntegerKey(u) ? Number(u) < o.length : hasOwn$1(o, u), S = Reflect.set(o, u, c, d);
    return o === toRaw(d) && (v ? hasChanged(c, m) && trigger(o, "set", u, c, m) : trigger(o, "add", u, c)), S;
  };
}
function deleteProperty(e, n) {
  const o = hasOwn$1(e, n), u = e[n], c = Reflect.deleteProperty(e, n);
  return c && o && trigger(e, "delete", n, void 0, u), c;
}
function has$1(e, n) {
  const o = Reflect.has(e, n);
  return (!isSymbol(n) || !builtInSymbols.has(n)) && track(e, "has", n), o;
}
function ownKeys$g(e) {
  return track(e, "iterate", isArray$7(e) ? "length" : ITERATE_KEY), Reflect.ownKeys(e);
}
const mutableHandlers = {
  get: get$1$1,
  set: set$1,
  deleteProperty,
  has: has$1,
  ownKeys: ownKeys$g
}, readonlyHandlers = {
  get: readonlyGet,
  set(e, n) {
    return browser$1$1.env.NODE_ENV !== "production" && warn$1(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      e
    ), !0;
  },
  deleteProperty(e, n) {
    return browser$1$1.env.NODE_ENV !== "production" && warn$1(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      e
    ), !0;
  }
}, shallowReactiveHandlers = /* @__PURE__ */ extend$5(
  {},
  mutableHandlers,
  {
    get: shallowGet,
    set: shallowSet
  }
), shallowReadonlyHandlers = /* @__PURE__ */ extend$5(
  {},
  readonlyHandlers,
  {
    get: shallowReadonlyGet
  }
), toShallow = (e) => e, getProto$1 = (e) => Reflect.getPrototypeOf(e);
function get$2(e, n, o = !1, u = !1) {
  e = e.__v_raw;
  const c = toRaw(e), d = toRaw(n);
  o || (n !== d && track(c, "get", n), track(c, "get", d));
  const { has: m } = getProto$1(c), v = u ? toShallow : o ? toReadonly : toReactive;
  if (m.call(c, n))
    return v(e.get(n));
  if (m.call(c, d))
    return v(e.get(d));
  e !== c && e.get(n);
}
function has(e, n = !1) {
  const o = this.__v_raw, u = toRaw(o), c = toRaw(e);
  return n || (e !== c && track(u, "has", e), track(u, "has", c)), e === c ? o.has(e) : o.has(e) || o.has(c);
}
function size(e, n = !1) {
  return e = e.__v_raw, !n && track(toRaw(e), "iterate", ITERATE_KEY), Reflect.get(e, "size", e);
}
function add(e) {
  e = toRaw(e);
  const n = toRaw(this);
  return getProto$1(n).has.call(n, e) || (n.add(e), trigger(n, "add", e, e)), this;
}
function set(e, n) {
  n = toRaw(n);
  const o = toRaw(this), { has: u, get: c } = getProto$1(o);
  let d = u.call(o, e);
  d ? browser$1$1.env.NODE_ENV !== "production" && checkIdentityKeys(o, u, e) : (e = toRaw(e), d = u.call(o, e));
  const m = c.call(o, e);
  return o.set(e, n), d ? hasChanged(n, m) && trigger(o, "set", e, n, m) : trigger(o, "add", e, n), this;
}
function deleteEntry(e) {
  const n = toRaw(this), { has: o, get: u } = getProto$1(n);
  let c = o.call(n, e);
  c ? browser$1$1.env.NODE_ENV !== "production" && checkIdentityKeys(n, o, e) : (e = toRaw(e), c = o.call(n, e));
  const d = u ? u.call(n, e) : void 0, m = n.delete(e);
  return c && trigger(n, "delete", e, void 0, d), m;
}
function clear() {
  const e = toRaw(this), n = e.size !== 0, o = browser$1$1.env.NODE_ENV !== "production" ? isMap(e) ? new Map(e) : new Set(e) : void 0, u = e.clear();
  return n && trigger(e, "clear", void 0, void 0, o), u;
}
function createForEach(e, n) {
  return function(u, c) {
    const d = this, m = d.__v_raw, v = toRaw(m), S = n ? toShallow : e ? toReadonly : toReactive;
    return !e && track(v, "iterate", ITERATE_KEY), m.forEach(($, E) => u.call(c, S($), S(E), d));
  };
}
function createIterableMethod(e, n, o) {
  return function(...u) {
    const c = this.__v_raw, d = toRaw(c), m = isMap(d), v = e === "entries" || e === Symbol.iterator && m, S = e === "keys" && m, $ = c[e](...u), E = o ? toShallow : n ? toReadonly : toReactive;
    return !n && track(
      d,
      "iterate",
      S ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
    ), {
      // iterator protocol
      next() {
        const { value: O, done: T } = $.next();
        return T ? { value: O, done: T } : {
          value: v ? [E(O[0]), E(O[1])] : E(O),
          done: T
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(e) {
  return function(...n) {
    if (browser$1$1.env.NODE_ENV !== "production") {
      const o = n[0] ? `on key "${n[0]}" ` : "";
      console.warn(
        `${capitalize(e)} operation ${o}failed: target is readonly.`,
        toRaw(this)
      );
    }
    return e === "delete" ? !1 : this;
  };
}
function createInstrumentations() {
  const e = {
    get(d) {
      return get$2(this, d);
    },
    get size() {
      return size(this);
    },
    has,
    add,
    set,
    delete: deleteEntry,
    clear,
    forEach: createForEach(!1, !1)
  }, n = {
    get(d) {
      return get$2(this, d, !1, !0);
    },
    get size() {
      return size(this);
    },
    has,
    add,
    set,
    delete: deleteEntry,
    clear,
    forEach: createForEach(!1, !0)
  }, o = {
    get(d) {
      return get$2(this, d, !0);
    },
    get size() {
      return size(this, !0);
    },
    has(d) {
      return has.call(this, d, !0);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(!0, !1)
  }, u = {
    get(d) {
      return get$2(this, d, !0, !0);
    },
    get size() {
      return size(this, !0);
    },
    has(d) {
      return has.call(this, d, !0);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(!0, !0)
  };
  return ["keys", "values", "entries", Symbol.iterator].forEach((d) => {
    e[d] = createIterableMethod(
      d,
      !1,
      !1
    ), o[d] = createIterableMethod(
      d,
      !0,
      !1
    ), n[d] = createIterableMethod(
      d,
      !1,
      !0
    ), u[d] = createIterableMethod(
      d,
      !0,
      !0
    );
  }), [
    e,
    o,
    n,
    u
  ];
}
const [
  mutableInstrumentations,
  readonlyInstrumentations,
  shallowInstrumentations,
  shallowReadonlyInstrumentations
] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(e, n) {
  const o = n ? e ? shallowReadonlyInstrumentations : shallowInstrumentations : e ? readonlyInstrumentations : mutableInstrumentations;
  return (u, c, d) => c === "__v_isReactive" ? !e : c === "__v_isReadonly" ? e : c === "__v_raw" ? u : Reflect.get(
    hasOwn$1(o, c) && c in u ? o : u,
    c,
    d
  );
}
const mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(!1, !1)
}, shallowCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(!1, !0)
}, readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(!0, !1)
}, shallowReadonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(!0, !0)
};
function checkIdentityKeys(e, n, o) {
  const u = toRaw(o);
  if (u !== o && n.call(e, u)) {
    const c = toRawType(e);
    console.warn(
      `Reactive ${c} contains both the raw and reactive versions of the same object${c === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const reactiveMap = /* @__PURE__ */ new WeakMap(), shallowReactiveMap = /* @__PURE__ */ new WeakMap(), readonlyMap = /* @__PURE__ */ new WeakMap(), shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : targetTypeMap(toRawType(e));
}
function reactive(e) {
  return isReadonly(e) ? e : createReactiveObject(
    e,
    !1,
    mutableHandlers,
    mutableCollectionHandlers,
    reactiveMap
  );
}
function shallowReactive(e) {
  return createReactiveObject(
    e,
    !1,
    shallowReactiveHandlers,
    shallowCollectionHandlers,
    shallowReactiveMap
  );
}
function readonly(e) {
  return createReactiveObject(
    e,
    !0,
    readonlyHandlers,
    readonlyCollectionHandlers,
    readonlyMap
  );
}
function shallowReadonly(e) {
  return createReactiveObject(
    e,
    !0,
    shallowReadonlyHandlers,
    shallowReadonlyCollectionHandlers,
    shallowReadonlyMap
  );
}
function createReactiveObject(e, n, o, u, c) {
  if (!isObject$8(e))
    return browser$1$1.env.NODE_ENV !== "production" && console.warn(`value cannot be made reactive: ${String(e)}`), e;
  if (e.__v_raw && !(n && e.__v_isReactive))
    return e;
  const d = c.get(e);
  if (d)
    return d;
  const m = getTargetType(e);
  if (m === 0)
    return e;
  const v = new Proxy(
    e,
    m === 2 ? u : o
  );
  return c.set(e, v), v;
}
function isReactive(e) {
  return isReadonly(e) ? isReactive(e.__v_raw) : !!(e && e.__v_isReactive);
}
function isReadonly(e) {
  return !!(e && e.__v_isReadonly);
}
function isShallow$1(e) {
  return !!(e && e.__v_isShallow);
}
function isProxy(e) {
  return isReactive(e) || isReadonly(e);
}
function toRaw(e) {
  const n = e && e.__v_raw;
  return n ? toRaw(n) : e;
}
function markRaw(e) {
  return def(e, "__v_skip", !0), e;
}
const toReactive = (e) => isObject$8(e) ? reactive(e) : e, toReadonly = (e) => isObject$8(e) ? readonly(e) : e;
function trackRefValue(e) {
  shouldTrack && activeEffect && (e = toRaw(e), browser$1$1.env.NODE_ENV !== "production" ? trackEffects(e.dep || (e.dep = createDep()), {
    target: e,
    type: "get",
    key: "value"
  }) : trackEffects(e.dep || (e.dep = createDep())));
}
function triggerRefValue(e, n) {
  e = toRaw(e);
  const o = e.dep;
  o && (browser$1$1.env.NODE_ENV !== "production" ? triggerEffects(o, {
    target: e,
    type: "set",
    key: "value",
    newValue: n
  }) : triggerEffects(o));
}
function isRef(e) {
  return !!(e && e.__v_isRef === !0);
}
function ref(e) {
  return createRef(e, !1);
}
function shallowRef(e) {
  return createRef(e, !0);
}
function createRef(e, n) {
  return isRef(e) ? e : new RefImpl(e, n);
}
class RefImpl {
  constructor(n, o) {
    this.__v_isShallow = o, this.dep = void 0, this.__v_isRef = !0, this._rawValue = o ? n : toRaw(n), this._value = o ? n : toReactive(n);
  }
  get value() {
    return trackRefValue(this), this._value;
  }
  set value(n) {
    const o = this.__v_isShallow || isShallow$1(n) || isReadonly(n);
    n = o ? n : toRaw(n), hasChanged(n, this._rawValue) && (this._rawValue = n, this._value = o ? n : toReactive(n), triggerRefValue(this, n));
  }
}
function triggerRef(e) {
  triggerRefValue(e, browser$1$1.env.NODE_ENV !== "production" ? e.value : void 0);
}
function unref(e) {
  return isRef(e) ? e.value : e;
}
function toValue(e) {
  return isFunction$7(e) ? e() : unref(e);
}
const shallowUnwrapHandlers = {
  get: (e, n, o) => unref(Reflect.get(e, n, o)),
  set: (e, n, o, u) => {
    const c = e[n];
    return isRef(c) && !isRef(o) ? (c.value = o, !0) : Reflect.set(e, n, o, u);
  }
};
function proxyRefs(e) {
  return isReactive(e) ? e : new Proxy(e, shallowUnwrapHandlers);
}
class CustomRefImpl {
  constructor(n) {
    this.dep = void 0, this.__v_isRef = !0;
    const { get: o, set: u } = n(
      () => trackRefValue(this),
      () => triggerRefValue(this)
    );
    this._get = o, this._set = u;
  }
  get value() {
    return this._get();
  }
  set value(n) {
    this._set(n);
  }
}
function customRef(e) {
  return new CustomRefImpl(e);
}
function toRefs(e) {
  browser$1$1.env.NODE_ENV !== "production" && !isProxy(e) && console.warn("toRefs() expects a reactive object but received a plain one.");
  const n = isArray$7(e) ? new Array(e.length) : {};
  for (const o in e)
    n[o] = propertyToRef(e, o);
  return n;
}
class ObjectRefImpl {
  constructor(n, o, u) {
    this._object = n, this._key = o, this._defaultValue = u, this.__v_isRef = !0;
  }
  get value() {
    const n = this._object[this._key];
    return n === void 0 ? this._defaultValue : n;
  }
  set value(n) {
    this._object[this._key] = n;
  }
  get dep() {
    return getDepFromReactive(toRaw(this._object), this._key);
  }
}
class GetterRefImpl {
  constructor(n) {
    this._getter = n, this.__v_isRef = !0, this.__v_isReadonly = !0;
  }
  get value() {
    return this._getter();
  }
}
function toRef(e, n, o) {
  return isRef(e) ? e : isFunction$7(e) ? new GetterRefImpl(e) : isObject$8(e) && arguments.length > 1 ? propertyToRef(e, n, o) : ref(e);
}
function propertyToRef(e, n, o) {
  const u = e[n];
  return isRef(u) ? u : new ObjectRefImpl(
    e,
    n,
    o
  );
}
class ComputedRefImpl {
  constructor(n, o, u, c) {
    this._setter = o, this.dep = void 0, this.__v_isRef = !0, this.__v_isReadonly = !1, this._dirty = !0, this.effect = new ReactiveEffect(n, () => {
      this._dirty || (this._dirty = !0, triggerRefValue(this));
    }), this.effect.computed = this, this.effect.active = this._cacheable = !c, this.__v_isReadonly = u;
  }
  get value() {
    const n = toRaw(this);
    return trackRefValue(n), (n._dirty || !n._cacheable) && (n._dirty = !1, n._value = n.effect.run()), n._value;
  }
  set value(n) {
    this._setter(n);
  }
}
function computed$1(e, n, o = !1) {
  let u, c;
  const d = isFunction$7(e);
  d ? (u = e, c = browser$1$1.env.NODE_ENV !== "production" ? () => {
    console.warn("Write operation failed: computed value is readonly");
  } : NOOP) : (u = e.get, c = e.set);
  const m = new ComputedRefImpl(u, c, d || !c, o);
  return browser$1$1.env.NODE_ENV !== "production" && n && !o && (m.effect.onTrack = n.onTrack, m.effect.onTrigger = n.onTrigger), m;
}
const stack = [];
function pushWarningContext(e) {
  stack.push(e);
}
function popWarningContext() {
  stack.pop();
}
function warn(e, ...n) {
  if (browser$1$1.env.NODE_ENV === "production")
    return;
  pauseTracking();
  const o = stack.length ? stack[stack.length - 1].component : null, u = o && o.appContext.config.warnHandler, c = getComponentTrace();
  if (u)
    callWithErrorHandling(
      u,
      o,
      11,
      [
        e + n.join(""),
        o && o.proxy,
        c.map(
          ({ vnode: d }) => `at <${formatComponentName(o, d.type)}>`
        ).join(`
`),
        c
      ]
    );
  else {
    const d = [`[Vue warn]: ${e}`, ...n];
    c.length && d.push(`
`, ...formatTrace(c)), console.warn(...d);
  }
  resetTracking();
}
function getComponentTrace() {
  let e = stack[stack.length - 1];
  if (!e)
    return [];
  const n = [];
  for (; e; ) {
    const o = n[0];
    o && o.vnode === e ? o.recurseCount++ : n.push({
      vnode: e,
      recurseCount: 0
    });
    const u = e.component && e.component.parent;
    e = u && u.vnode;
  }
  return n;
}
function formatTrace(e) {
  const n = [];
  return e.forEach((o, u) => {
    n.push(...u === 0 ? [] : [`
`], ...formatTraceEntry(o));
  }), n;
}
function formatTraceEntry({ vnode: e, recurseCount: n }) {
  const o = n > 0 ? `... (${n} recursive calls)` : "", u = e.component ? e.component.parent == null : !1, c = ` at <${formatComponentName(
    e.component,
    e.type,
    u
  )}`, d = ">" + o;
  return e.props ? [c, ...formatProps(e.props), d] : [c + d];
}
function formatProps(e) {
  const n = [], o = Object.keys(e);
  return o.slice(0, 3).forEach((u) => {
    n.push(...formatProp(u, e[u]));
  }), o.length > 3 && n.push(" ..."), n;
}
function formatProp(e, n, o) {
  return isString$5(n) ? (n = JSON.stringify(n), o ? n : [`${e}=${n}`]) : typeof n == "number" || typeof n == "boolean" || n == null ? o ? n : [`${e}=${n}`] : isRef(n) ? (n = formatProp(e, toRaw(n.value), !0), o ? n : [`${e}=Ref<`, n, ">"]) : isFunction$7(n) ? [`${e}=fn${n.name ? `<${n.name}>` : ""}`] : (n = toRaw(n), o ? n : [`${e}=`, n]);
}
function assertNumber$a(e, n) {
  browser$1$1.env.NODE_ENV !== "production" && e !== void 0 && (typeof e != "number" ? warn(`${n} is not a valid number - got ${JSON.stringify(e)}.`) : isNaN(e) && warn(`${n} is NaN - the duration expression might be incorrect.`));
}
const ErrorTypeStrings = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  [0]: "setup function",
  [1]: "render function",
  [2]: "watcher getter",
  [3]: "watcher callback",
  [4]: "watcher cleanup function",
  [5]: "native event handler",
  [6]: "component event handler",
  [7]: "vnode hook",
  [8]: "directive hook",
  [9]: "transition hook",
  [10]: "app errorHandler",
  [11]: "app warnHandler",
  [12]: "ref function",
  [13]: "async component loader",
  [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function callWithErrorHandling(e, n, o, u) {
  let c;
  try {
    c = u ? e(...u) : e();
  } catch (d) {
    handleError(d, n, o);
  }
  return c;
}
function callWithAsyncErrorHandling(e, n, o, u) {
  if (isFunction$7(e)) {
    const d = callWithErrorHandling(e, n, o, u);
    return d && isPromise$1(d) && d.catch((m) => {
      handleError(m, n, o);
    }), d;
  }
  const c = [];
  for (let d = 0; d < e.length; d++)
    c.push(callWithAsyncErrorHandling(e[d], n, o, u));
  return c;
}
function handleError(e, n, o, u = !0) {
  const c = n ? n.vnode : null;
  if (n) {
    let d = n.parent;
    const m = n.proxy, v = browser$1$1.env.NODE_ENV !== "production" ? ErrorTypeStrings[o] : o;
    for (; d; ) {
      const $ = d.ec;
      if ($) {
        for (let E = 0; E < $.length; E++)
          if ($[E](e, m, v) === !1)
            return;
      }
      d = d.parent;
    }
    const S = n.appContext.config.errorHandler;
    if (S) {
      callWithErrorHandling(
        S,
        null,
        10,
        [e, m, v]
      );
      return;
    }
  }
  logError(e, o, c, u);
}
function logError(e, n, o, u = !0) {
  if (browser$1$1.env.NODE_ENV !== "production") {
    const c = ErrorTypeStrings[n];
    if (o && pushWarningContext(o), warn(`Unhandled error${c ? ` during execution of ${c}` : ""}`), o && popWarningContext(), u)
      throw e;
    console.error(e);
  } else
    console.error(e);
}
let isFlushing = !1, isFlushPending = !1;
const queue = [];
let flushIndex = 0;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null, postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
const RECURSION_LIMIT = 100;
function nextTick(e) {
  const n = currentFlushPromise || resolvedPromise;
  return e ? n.then(this ? e.bind(this) : e) : n;
}
function findInsertionIndex(e) {
  let n = flushIndex + 1, o = queue.length;
  for (; n < o; ) {
    const u = n + o >>> 1;
    getId(queue[u]) < e ? n = u + 1 : o = u;
  }
  return n;
}
function queueJob(e) {
  (!queue.length || !queue.includes(
    e,
    isFlushing && e.allowRecurse ? flushIndex + 1 : flushIndex
  )) && (e.id == null ? queue.push(e) : queue.splice(findInsertionIndex(e.id), 0, e), queueFlush());
}
function queueFlush() {
  !isFlushing && !isFlushPending && (isFlushPending = !0, currentFlushPromise = resolvedPromise.then(flushJobs));
}
function invalidateJob(e) {
  const n = queue.indexOf(e);
  n > flushIndex && queue.splice(n, 1);
}
function queuePostFlushCb(e) {
  isArray$7(e) ? pendingPostFlushCbs.push(...e) : (!activePostFlushCbs || !activePostFlushCbs.includes(
    e,
    e.allowRecurse ? postFlushIndex + 1 : postFlushIndex
  )) && pendingPostFlushCbs.push(e), queueFlush();
}
function flushPreFlushCbs(e, n = isFlushing ? flushIndex + 1 : 0) {
  for (browser$1$1.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()); n < queue.length; n++) {
    const o = queue[n];
    if (o && o.pre) {
      if (browser$1$1.env.NODE_ENV !== "production" && checkRecursiveUpdates(e, o))
        continue;
      queue.splice(n, 1), n--, o();
    }
  }
}
function flushPostFlushCbs(e) {
  if (pendingPostFlushCbs.length) {
    const n = [...new Set(pendingPostFlushCbs)];
    if (pendingPostFlushCbs.length = 0, activePostFlushCbs) {
      activePostFlushCbs.push(...n);
      return;
    }
    for (activePostFlushCbs = n, browser$1$1.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), activePostFlushCbs.sort((o, u) => getId(o) - getId(u)), postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++)
      browser$1$1.env.NODE_ENV !== "production" && checkRecursiveUpdates(e, activePostFlushCbs[postFlushIndex]) || activePostFlushCbs[postFlushIndex]();
    activePostFlushCbs = null, postFlushIndex = 0;
  }
}
const getId = (e) => e.id == null ? 1 / 0 : e.id, comparator$2 = (e, n) => {
  const o = getId(e) - getId(n);
  if (o === 0) {
    if (e.pre && !n.pre)
      return -1;
    if (n.pre && !e.pre)
      return 1;
  }
  return o;
};
function flushJobs(e) {
  isFlushPending = !1, isFlushing = !0, browser$1$1.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), queue.sort(comparator$2);
  const n = browser$1$1.env.NODE_ENV !== "production" ? (o) => checkRecursiveUpdates(e, o) : NOOP;
  try {
    for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
      const o = queue[flushIndex];
      if (o && o.active !== !1) {
        if (browser$1$1.env.NODE_ENV !== "production" && n(o))
          continue;
        callWithErrorHandling(o, null, 14);
      }
    }
  } finally {
    flushIndex = 0, queue.length = 0, flushPostFlushCbs(e), isFlushing = !1, currentFlushPromise = null, (queue.length || pendingPostFlushCbs.length) && flushJobs(e);
  }
}
function checkRecursiveUpdates(e, n) {
  if (!e.has(n))
    e.set(n, 1);
  else {
    const o = e.get(n);
    if (o > RECURSION_LIMIT) {
      const u = n.ownerInstance, c = u && getComponentName(u.type);
      return warn(
        `Maximum recursive updates exceeded${c ? ` in component <${c}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`
      ), !0;
    } else
      e.set(n, o + 1);
  }
}
let isHmrUpdating = !1;
const hmrDirtyComponents = /* @__PURE__ */ new Set();
browser$1$1.env.NODE_ENV !== "production" && (getGlobalThis().__VUE_HMR_RUNTIME__ = {
  createRecord: tryWrap(createRecord),
  rerender: tryWrap(rerender),
  reload: tryWrap(reload)
});
const map$1 = /* @__PURE__ */ new Map();
function registerHMR(e) {
  const n = e.type.__hmrId;
  let o = map$1.get(n);
  o || (createRecord(n, e.type), o = map$1.get(n)), o.instances.add(e);
}
function unregisterHMR(e) {
  map$1.get(e.type.__hmrId).instances.delete(e);
}
function createRecord(e, n) {
  return map$1.has(e) ? !1 : (map$1.set(e, {
    initialDef: normalizeClassComponent(n),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function normalizeClassComponent(e) {
  return isClassComponent(e) ? e.__vccOpts : e;
}
function rerender(e, n) {
  const o = map$1.get(e);
  o && (o.initialDef.render = n, [...o.instances].forEach((u) => {
    n && (u.render = n, normalizeClassComponent(u.type).render = n), u.renderCache = [], isHmrUpdating = !0, u.update(), isHmrUpdating = !1;
  }));
}
function reload(e, n) {
  const o = map$1.get(e);
  if (!o)
    return;
  n = normalizeClassComponent(n), updateComponentDef(o.initialDef, n);
  const u = [...o.instances];
  for (const c of u) {
    const d = normalizeClassComponent(c.type);
    hmrDirtyComponents.has(d) || (d !== o.initialDef && updateComponentDef(d, n), hmrDirtyComponents.add(d)), c.appContext.propsCache.delete(c.type), c.appContext.emitsCache.delete(c.type), c.appContext.optionsCache.delete(c.type), c.ceReload ? (hmrDirtyComponents.add(d), c.ceReload(n.styles), hmrDirtyComponents.delete(d)) : c.parent ? queueJob(c.parent.update) : c.appContext.reload ? c.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    );
  }
  queuePostFlushCb(() => {
    for (const c of u)
      hmrDirtyComponents.delete(
        normalizeClassComponent(c.type)
      );
  });
}
function updateComponentDef(e, n) {
  extend$5(e, n);
  for (const o in e)
    o !== "__file" && !(o in n) && delete e[o];
}
function tryWrap(e) {
  return (n, o) => {
    try {
      return e(n, o);
    } catch (u) {
      console.error(u), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let devtools, buffer$2 = [], devtoolsNotInstalled = !1;
function emit$1(e, ...n) {
  devtools ? devtools.emit(e, ...n) : devtoolsNotInstalled || buffer$2.push({ event: e, args: n });
}
function setDevtoolsHook(e, n) {
  var o, u;
  devtools = e, devtools ? (devtools.enabled = !0, buffer$2.forEach(({ event: c, args: d }) => devtools.emit(c, ...d)), buffer$2 = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  !((u = (o = window.navigator) == null ? void 0 : o.userAgent) != null && u.includes("jsdom")) ? ((n.__VUE_DEVTOOLS_HOOK_REPLAY__ = n.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((d) => {
    setDevtoolsHook(d, n);
  }), setTimeout(() => {
    devtools || (n.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, devtoolsNotInstalled = !0, buffer$2 = []);
  }, 3e3)) : (devtoolsNotInstalled = !0, buffer$2 = []);
}
function devtoolsInitApp(e, n) {
  emit$1("app:init", e, n, {
    Fragment,
    Text: Text$1,
    Comment,
    Static
  });
}
function devtoolsUnmountApp(e) {
  emit$1("app:unmount", e);
}
const devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook(
  "component:added"
  /* COMPONENT_ADDED */
), devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook(
  "component:updated"
  /* COMPONENT_UPDATED */
), _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook(
  "component:removed"
  /* COMPONENT_REMOVED */
), devtoolsComponentRemoved = (e) => {
  devtools && typeof devtools.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !devtools.cleanupBuffer(e) && _devtoolsComponentRemoved(e);
};
function createDevtoolsComponentHook(e) {
  return (n) => {
    emit$1(
      e,
      n.appContext.app,
      n.uid,
      n.parent ? n.parent.uid : void 0,
      n
    );
  };
}
const devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook(
  "perf:start"
  /* PERFORMANCE_START */
), devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook(
  "perf:end"
  /* PERFORMANCE_END */
);
function createDevtoolsPerformanceHook(e) {
  return (n, o, u) => {
    emit$1(e, n.appContext.app, n.uid, n, o, u);
  };
}
function devtoolsComponentEmit(e, n, o) {
  emit$1(
    "component:emit",
    e.appContext.app,
    e,
    n,
    o
  );
}
function emit(e, n, ...o) {
  if (e.isUnmounted)
    return;
  const u = e.vnode.props || EMPTY_OBJ;
  if (browser$1$1.env.NODE_ENV !== "production") {
    const {
      emitsOptions: E,
      propsOptions: [O]
    } = e;
    if (E)
      if (!(n in E))
        (!O || !(toHandlerKey(n) in O)) && warn(
          `Component emitted event "${n}" but it is neither declared in the emits option nor as an "${toHandlerKey(n)}" prop.`
        );
      else {
        const T = E[n];
        isFunction$7(T) && (T(...o) || warn(
          `Invalid event arguments: event validation failed for event "${n}".`
        ));
      }
  }
  let c = o;
  const d = n.startsWith("update:"), m = d && n.slice(7);
  if (m && m in u) {
    const E = `${m === "modelValue" ? "model" : m}Modifiers`, { number: O, trim: T } = u[E] || EMPTY_OBJ;
    T && (c = o.map((y) => isString$5(y) ? y.trim() : y)), O && (c = o.map(looseToNumber));
  }
  if (browser$1$1.env.NODE_ENV !== "production" && devtoolsComponentEmit(e, n, c), browser$1$1.env.NODE_ENV !== "production") {
    const E = n.toLowerCase();
    E !== n && u[toHandlerKey(E)] && warn(
      `Event "${E}" is emitted in component ${formatComponentName(
        e,
        e.type
      )} but the handler is registered for "${n}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${hyphenate(n)}" instead of "${n}".`
    );
  }
  let v, S = u[v = toHandlerKey(n)] || // also try camelCase event handler (#2249)
  u[v = toHandlerKey(camelize(n))];
  !S && d && (S = u[v = toHandlerKey(hyphenate(n))]), S && callWithAsyncErrorHandling(
    S,
    e,
    6,
    c
  );
  const $ = u[v + "Once"];
  if ($) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[v])
      return;
    e.emitted[v] = !0, callWithAsyncErrorHandling(
      $,
      e,
      6,
      c
    );
  }
}
function normalizeEmitsOptions(e, n, o = !1) {
  const u = n.emitsCache, c = u.get(e);
  if (c !== void 0)
    return c;
  const d = e.emits;
  let m = {}, v = !1;
  if (!isFunction$7(e)) {
    const S = ($) => {
      const E = normalizeEmitsOptions($, n, !0);
      E && (v = !0, extend$5(m, E));
    };
    !o && n.mixins.length && n.mixins.forEach(S), e.extends && S(e.extends), e.mixins && e.mixins.forEach(S);
  }
  return !d && !v ? (isObject$8(e) && u.set(e, null), null) : (isArray$7(d) ? d.forEach((S) => m[S] = null) : extend$5(m, d), isObject$8(e) && u.set(e, m), m);
}
function isEmitListener(e, n) {
  return !e || !isOn(n) ? !1 : (n = n.slice(2).replace(/Once$/, ""), hasOwn$1(e, n[0].toLowerCase() + n.slice(1)) || hasOwn$1(e, hyphenate(n)) || hasOwn$1(e, n));
}
let currentRenderingInstance = null, currentScopeId = null;
function setCurrentRenderingInstance(e) {
  const n = currentRenderingInstance;
  return currentRenderingInstance = e, currentScopeId = e && e.type.__scopeId || null, n;
}
function pushScopeId(e) {
  currentScopeId = e;
}
function popScopeId() {
  currentScopeId = null;
}
const withScopeId = (e) => withCtx;
function withCtx(e, n = currentRenderingInstance, o) {
  if (!n || e._n)
    return e;
  const u = (...c) => {
    u._d && setBlockTracking(-1);
    const d = setCurrentRenderingInstance(n);
    let m;
    try {
      m = e(...c);
    } finally {
      setCurrentRenderingInstance(d), u._d && setBlockTracking(1);
    }
    return browser$1$1.env.NODE_ENV !== "production" && devtoolsComponentUpdated(n), m;
  };
  return u._n = !0, u._c = !0, u._d = !0, u;
}
let accessedAttrs = !1;
function markAttrsAccessed() {
  accessedAttrs = !0;
}
function renderComponentRoot(e) {
  const {
    type: n,
    vnode: o,
    proxy: u,
    withProxy: c,
    props: d,
    propsOptions: [m],
    slots: v,
    attrs: S,
    emit: $,
    render: E,
    renderCache: O,
    data: T,
    setupState: y,
    ctx: V,
    inheritAttrs: M
  } = e;
  let G, k;
  const F = setCurrentRenderingInstance(e);
  browser$1$1.env.NODE_ENV !== "production" && (accessedAttrs = !1);
  try {
    if (o.shapeFlag & 4) {
      const ue = c || u;
      G = normalizeVNode(
        E.call(
          ue,
          ue,
          O,
          d,
          y,
          T,
          V
        )
      ), k = S;
    } else {
      const ue = n;
      browser$1$1.env.NODE_ENV !== "production" && S === d && markAttrsAccessed(), G = normalizeVNode(
        ue.length > 1 ? ue(
          d,
          browser$1$1.env.NODE_ENV !== "production" ? {
            get attrs() {
              return markAttrsAccessed(), S;
            },
            slots: v,
            emit: $
          } : { attrs: S, slots: v, emit: $ }
        ) : ue(
          d,
          null
          /* we know it doesn't need it */
        )
      ), k = n.props ? S : getFunctionalFallthrough(S);
    }
  } catch (ue) {
    blockStack.length = 0, handleError(ue, e, 1), G = createVNode(Comment);
  }
  let X = G, ee;
  if (browser$1$1.env.NODE_ENV !== "production" && G.patchFlag > 0 && G.patchFlag & 2048 && ([X, ee] = getChildRoot(G)), k && M !== !1) {
    const ue = Object.keys(k), { shapeFlag: Q } = X;
    if (ue.length) {
      if (Q & 7)
        m && ue.some(isModelListener) && (k = filterModelListeners(
          k,
          m
        )), X = cloneVNode(X, k);
      else if (browser$1$1.env.NODE_ENV !== "production" && !accessedAttrs && X.type !== Comment) {
        const Y = Object.keys(S), pe = [], oe = [];
        for (let ne = 0, H = Y.length; ne < H; ne++) {
          const C = Y[ne];
          isOn(C) ? isModelListener(C) || pe.push(C[2].toLowerCase() + C.slice(3)) : oe.push(C);
        }
        oe.length && warn(
          `Extraneous non-props attributes (${oe.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`
        ), pe.length && warn(
          `Extraneous non-emits event listeners (${pe.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return o.dirs && (browser$1$1.env.NODE_ENV !== "production" && !isElementRoot(X) && warn(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), X = cloneVNode(X), X.dirs = X.dirs ? X.dirs.concat(o.dirs) : o.dirs), o.transition && (browser$1$1.env.NODE_ENV !== "production" && !isElementRoot(X) && warn(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), X.transition = o.transition), browser$1$1.env.NODE_ENV !== "production" && ee ? ee(X) : G = X, setCurrentRenderingInstance(F), G;
}
const getChildRoot = (e) => {
  const n = e.children, o = e.dynamicChildren, u = filterSingleRoot(n);
  if (!u)
    return [e, void 0];
  const c = n.indexOf(u), d = o ? o.indexOf(u) : -1, m = (v) => {
    n[c] = v, o && (d > -1 ? o[d] = v : v.patchFlag > 0 && (e.dynamicChildren = [...o, v]));
  };
  return [normalizeVNode(u), m];
};
function filterSingleRoot(e) {
  let n;
  for (let o = 0; o < e.length; o++) {
    const u = e[o];
    if (isVNode(u)) {
      if (u.type !== Comment || u.children === "v-if") {
        if (n)
          return;
        n = u;
      }
    } else
      return;
  }
  return n;
}
const getFunctionalFallthrough = (e) => {
  let n;
  for (const o in e)
    (o === "class" || o === "style" || isOn(o)) && ((n || (n = {}))[o] = e[o]);
  return n;
}, filterModelListeners = (e, n) => {
  const o = {};
  for (const u in e)
    (!isModelListener(u) || !(u.slice(9) in n)) && (o[u] = e[u]);
  return o;
}, isElementRoot = (e) => e.shapeFlag & 7 || e.type === Comment;
function shouldUpdateComponent(e, n, o) {
  const { props: u, children: c, component: d } = e, { props: m, children: v, patchFlag: S } = n, $ = d.emitsOptions;
  if (browser$1$1.env.NODE_ENV !== "production" && (c || v) && isHmrUpdating || n.dirs || n.transition)
    return !0;
  if (o && S >= 0) {
    if (S & 1024)
      return !0;
    if (S & 16)
      return u ? hasPropsChanged(u, m, $) : !!m;
    if (S & 8) {
      const E = n.dynamicProps;
      for (let O = 0; O < E.length; O++) {
        const T = E[O];
        if (m[T] !== u[T] && !isEmitListener($, T))
          return !0;
      }
    }
  } else
    return (c || v) && (!v || !v.$stable) ? !0 : u === m ? !1 : u ? m ? hasPropsChanged(u, m, $) : !0 : !!m;
  return !1;
}
function hasPropsChanged(e, n, o) {
  const u = Object.keys(n);
  if (u.length !== Object.keys(e).length)
    return !0;
  for (let c = 0; c < u.length; c++) {
    const d = u[c];
    if (n[d] !== e[d] && !isEmitListener(o, d))
      return !0;
  }
  return !1;
}
function updateHOCHostEl({ vnode: e, parent: n }, o) {
  for (; n && n.subTree === e; )
    (e = n.vnode).el = o, n = n.parent;
}
const isSuspense = (e) => e.__isSuspense, SuspenseImpl = {
  name: "Suspense",
  // In order to make Suspense tree-shakable, we need to avoid importing it
  // directly in the renderer. The renderer checks for the __isSuspense flag
  // on a vnode's type and calls the `process` method, passing in renderer
  // internals.
  __isSuspense: !0,
  process(e, n, o, u, c, d, m, v, S, $) {
    e == null ? mountSuspense(
      n,
      o,
      u,
      c,
      d,
      m,
      v,
      S,
      $
    ) : patchSuspense(
      e,
      n,
      o,
      u,
      c,
      m,
      v,
      S,
      $
    );
  },
  hydrate: hydrateSuspense,
  create: createSuspenseBoundary,
  normalize: normalizeSuspenseChildren
}, Suspense = SuspenseImpl;
function triggerEvent(e, n) {
  const o = e.props && e.props[n];
  isFunction$7(o) && o();
}
function mountSuspense(e, n, o, u, c, d, m, v, S) {
  const {
    p: $,
    o: { createElement: E }
  } = S, O = E("div"), T = e.suspense = createSuspenseBoundary(
    e,
    c,
    u,
    n,
    O,
    o,
    d,
    m,
    v,
    S
  );
  $(
    null,
    T.pendingBranch = e.ssContent,
    O,
    null,
    u,
    T,
    d,
    m
  ), T.deps > 0 ? (triggerEvent(e, "onPending"), triggerEvent(e, "onFallback"), $(
    null,
    e.ssFallback,
    n,
    o,
    u,
    null,
    // fallback tree will not have suspense context
    d,
    m
  ), setActiveBranch(T, e.ssFallback)) : T.resolve(!1, !0);
}
function patchSuspense(e, n, o, u, c, d, m, v, { p: S, um: $, o: { createElement: E } }) {
  const O = n.suspense = e.suspense;
  O.vnode = n, n.el = e.el;
  const T = n.ssContent, y = n.ssFallback, { activeBranch: V, pendingBranch: M, isInFallback: G, isHydrating: k } = O;
  if (M)
    O.pendingBranch = T, isSameVNodeType(T, M) ? (S(
      M,
      T,
      O.hiddenContainer,
      null,
      c,
      O,
      d,
      m,
      v
    ), O.deps <= 0 ? O.resolve() : G && (S(
      V,
      y,
      o,
      u,
      c,
      null,
      // fallback tree will not have suspense context
      d,
      m,
      v
    ), setActiveBranch(O, y))) : (O.pendingId++, k ? (O.isHydrating = !1, O.activeBranch = M) : $(M, c, O), O.deps = 0, O.effects.length = 0, O.hiddenContainer = E("div"), G ? (S(
      null,
      T,
      O.hiddenContainer,
      null,
      c,
      O,
      d,
      m,
      v
    ), O.deps <= 0 ? O.resolve() : (S(
      V,
      y,
      o,
      u,
      c,
      null,
      // fallback tree will not have suspense context
      d,
      m,
      v
    ), setActiveBranch(O, y))) : V && isSameVNodeType(T, V) ? (S(
      V,
      T,
      o,
      u,
      c,
      O,
      d,
      m,
      v
    ), O.resolve(!0)) : (S(
      null,
      T,
      O.hiddenContainer,
      null,
      c,
      O,
      d,
      m,
      v
    ), O.deps <= 0 && O.resolve()));
  else if (V && isSameVNodeType(T, V))
    S(
      V,
      T,
      o,
      u,
      c,
      O,
      d,
      m,
      v
    ), setActiveBranch(O, T);
  else if (triggerEvent(n, "onPending"), O.pendingBranch = T, O.pendingId++, S(
    null,
    T,
    O.hiddenContainer,
    null,
    c,
    O,
    d,
    m,
    v
  ), O.deps <= 0)
    O.resolve();
  else {
    const { timeout: F, pendingId: X } = O;
    F > 0 ? setTimeout(() => {
      O.pendingId === X && O.fallback(y);
    }, F) : F === 0 && O.fallback(y);
  }
}
let hasWarned = !1;
function createSuspenseBoundary(e, n, o, u, c, d, m, v, S, $, E = !1) {
  browser$1$1.env.NODE_ENV !== "production" && !hasWarned && (hasWarned = !0, console[console.info ? "info" : "log"](
    "<Suspense> is an experimental feature and its API will likely change."
  ));
  const {
    p: O,
    m: T,
    um: y,
    n: V,
    o: { parentNode: M, remove: G }
  } = $;
  let k;
  const F = isVNodeSuspensible(e);
  F && n != null && n.pendingBranch && (k = n.pendingId, n.deps++);
  const X = e.props ? toNumber(e.props.timeout) : void 0;
  browser$1$1.env.NODE_ENV !== "production" && assertNumber$a(X, "Suspense timeout");
  const ee = {
    vnode: e,
    parent: n,
    parentComponent: o,
    isSVG: m,
    container: u,
    hiddenContainer: c,
    anchor: d,
    deps: 0,
    pendingId: 0,
    timeout: typeof X == "number" ? X : -1,
    activeBranch: null,
    pendingBranch: null,
    isInFallback: !0,
    isHydrating: E,
    isUnmounted: !1,
    effects: [],
    resolve(ue = !1, Q = !1) {
      if (browser$1$1.env.NODE_ENV !== "production") {
        if (!ue && !ee.pendingBranch)
          throw new Error(
            "suspense.resolve() is called without a pending branch."
          );
        if (ee.isUnmounted)
          throw new Error(
            "suspense.resolve() is called on an already unmounted suspense boundary."
          );
      }
      const {
        vnode: Y,
        activeBranch: pe,
        pendingBranch: oe,
        pendingId: ne,
        effects: H,
        parentComponent: C,
        container: w
      } = ee;
      if (ee.isHydrating)
        ee.isHydrating = !1;
      else if (!ue) {
        const se = pe && oe.transition && oe.transition.mode === "out-in";
        se && (pe.transition.afterLeave = () => {
          ne === ee.pendingId && T(oe, w, fe, 0);
        });
        let { anchor: fe } = ee;
        pe && (fe = V(pe), y(pe, C, ee, !0)), se || T(oe, w, fe, 0);
      }
      setActiveBranch(ee, oe), ee.pendingBranch = null, ee.isInFallback = !1;
      let P = ee.parent, J = !1;
      for (; P; ) {
        if (P.pendingBranch) {
          P.effects.push(...H), J = !0;
          break;
        }
        P = P.parent;
      }
      J || queuePostFlushCb(H), ee.effects = [], F && n && n.pendingBranch && k === n.pendingId && (n.deps--, n.deps === 0 && !Q && n.resolve()), triggerEvent(Y, "onResolve");
    },
    fallback(ue) {
      if (!ee.pendingBranch)
        return;
      const { vnode: Q, activeBranch: Y, parentComponent: pe, container: oe, isSVG: ne } = ee;
      triggerEvent(Q, "onFallback");
      const H = V(Y), C = () => {
        ee.isInFallback && (O(
          null,
          ue,
          oe,
          H,
          pe,
          null,
          // fallback tree will not have suspense context
          ne,
          v,
          S
        ), setActiveBranch(ee, ue));
      }, w = ue.transition && ue.transition.mode === "out-in";
      w && (Y.transition.afterLeave = C), ee.isInFallback = !0, y(
        Y,
        pe,
        null,
        // no suspense so unmount hooks fire now
        !0
        // shouldRemove
      ), w || C();
    },
    move(ue, Q, Y) {
      ee.activeBranch && T(ee.activeBranch, ue, Q, Y), ee.container = ue;
    },
    next() {
      return ee.activeBranch && V(ee.activeBranch);
    },
    registerDep(ue, Q) {
      const Y = !!ee.pendingBranch;
      Y && ee.deps++;
      const pe = ue.vnode.el;
      ue.asyncDep.catch((oe) => {
        handleError(oe, ue, 0);
      }).then((oe) => {
        if (ue.isUnmounted || ee.isUnmounted || ee.pendingId !== ue.suspenseId)
          return;
        ue.asyncResolved = !0;
        const { vnode: ne } = ue;
        browser$1$1.env.NODE_ENV !== "production" && pushWarningContext(ne), handleSetupResult(ue, oe, !1), pe && (ne.el = pe);
        const H = !pe && ue.subTree.el;
        Q(
          ue,
          ne,
          // component may have been moved before resolve.
          // if this is not a hydration, instance.subTree will be the comment
          // placeholder.
          M(pe || ue.subTree.el),
          // anchor will not be used if this is hydration, so only need to
          // consider the comment placeholder case.
          pe ? null : V(ue.subTree),
          ee,
          m,
          S
        ), H && G(H), updateHOCHostEl(ue, ne.el), browser$1$1.env.NODE_ENV !== "production" && popWarningContext(), Y && --ee.deps === 0 && ee.resolve();
      });
    },
    unmount(ue, Q) {
      ee.isUnmounted = !0, ee.activeBranch && y(
        ee.activeBranch,
        o,
        ue,
        Q
      ), ee.pendingBranch && y(
        ee.pendingBranch,
        o,
        ue,
        Q
      );
    }
  };
  return ee;
}
function hydrateSuspense(e, n, o, u, c, d, m, v, S) {
  const $ = n.suspense = createSuspenseBoundary(
    n,
    u,
    o,
    e.parentNode,
    document.createElement("div"),
    null,
    c,
    d,
    m,
    v,
    !0
    /* hydrating */
  ), E = S(
    e,
    $.pendingBranch = n.ssContent,
    o,
    $,
    d,
    m
  );
  return $.deps === 0 && $.resolve(!1, !0), E;
}
function normalizeSuspenseChildren(e) {
  const { shapeFlag: n, children: o } = e, u = n & 32;
  e.ssContent = normalizeSuspenseSlot(
    u ? o.default : o
  ), e.ssFallback = u ? normalizeSuspenseSlot(o.fallback) : createVNode(Comment);
}
function normalizeSuspenseSlot(e) {
  let n;
  if (isFunction$7(e)) {
    const o = isBlockTreeEnabled && e._c;
    o && (e._d = !1, openBlock()), e = e(), o && (e._d = !0, n = currentBlock, closeBlock());
  }
  if (isArray$7(e)) {
    const o = filterSingleRoot(e);
    browser$1$1.env.NODE_ENV !== "production" && !o && warn("<Suspense> slots expect a single root node."), e = o;
  }
  return e = normalizeVNode(e), n && !e.dynamicChildren && (e.dynamicChildren = n.filter((o) => o !== e)), e;
}
function queueEffectWithSuspense(e, n) {
  n && n.pendingBranch ? isArray$7(e) ? n.effects.push(...e) : n.effects.push(e) : queuePostFlushCb(e);
}
function setActiveBranch(e, n) {
  e.activeBranch = n;
  const { vnode: o, parentComponent: u } = e, c = o.el = n.el;
  u && u.subTree === o && (u.vnode.el = c, updateHOCHostEl(u, c));
}
function isVNodeSuspensible(e) {
  var n;
  return ((n = e.props) == null ? void 0 : n.suspensible) != null && e.props.suspensible !== !1;
}
function watchEffect(e, n) {
  return doWatch(e, null, n);
}
function watchPostEffect(e, n) {
  return doWatch(
    e,
    null,
    browser$1$1.env.NODE_ENV !== "production" ? extend$5({}, n, { flush: "post" }) : { flush: "post" }
  );
}
function watchSyncEffect(e, n) {
  return doWatch(
    e,
    null,
    browser$1$1.env.NODE_ENV !== "production" ? extend$5({}, n, { flush: "sync" }) : { flush: "sync" }
  );
}
const INITIAL_WATCHER_VALUE = {};
function watch(e, n, o) {
  return browser$1$1.env.NODE_ENV !== "production" && !isFunction$7(n) && warn(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), doWatch(e, n, o);
}
function doWatch(e, n, { immediate: o, deep: u, flush: c, onTrack: d, onTrigger: m } = EMPTY_OBJ) {
  var v;
  browser$1$1.env.NODE_ENV !== "production" && !n && (o !== void 0 && warn(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), u !== void 0 && warn(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const S = (ue) => {
    warn(
      "Invalid watch source: ",
      ue,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, $ = getCurrentScope() === ((v = currentInstance) == null ? void 0 : v.scope) ? currentInstance : null;
  let E, O = !1, T = !1;
  if (isRef(e) ? (E = () => e.value, O = isShallow$1(e)) : isReactive(e) ? (E = () => e, u = !0) : isArray$7(e) ? (T = !0, O = e.some((ue) => isReactive(ue) || isShallow$1(ue)), E = () => e.map((ue) => {
    if (isRef(ue))
      return ue.value;
    if (isReactive(ue))
      return traverse(ue);
    if (isFunction$7(ue))
      return callWithErrorHandling(ue, $, 2);
    browser$1$1.env.NODE_ENV !== "production" && S(ue);
  })) : isFunction$7(e) ? n ? E = () => callWithErrorHandling(e, $, 2) : E = () => {
    if (!($ && $.isUnmounted))
      return y && y(), callWithAsyncErrorHandling(
        e,
        $,
        3,
        [V]
      );
  } : (E = NOOP, browser$1$1.env.NODE_ENV !== "production" && S(e)), n && u) {
    const ue = E;
    E = () => traverse(ue());
  }
  let y, V = (ue) => {
    y = X.onStop = () => {
      callWithErrorHandling(ue, $, 4);
    };
  }, M;
  if (isInSSRComponentSetup)
    if (V = NOOP, n ? o && callWithAsyncErrorHandling(n, $, 3, [
      E(),
      T ? [] : void 0,
      V
    ]) : E(), c === "sync") {
      const ue = useSSRContext();
      M = ue.__watcherHandles || (ue.__watcherHandles = []);
    } else
      return NOOP;
  let G = T ? new Array(e.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
  const k = () => {
    if (X.active)
      if (n) {
        const ue = X.run();
        (u || O || (T ? ue.some(
          (Q, Y) => hasChanged(Q, G[Y])
        ) : hasChanged(ue, G))) && (y && y(), callWithAsyncErrorHandling(n, $, 3, [
          ue,
          // pass undefined as the old value when it's changed for the first time
          G === INITIAL_WATCHER_VALUE ? void 0 : T && G[0] === INITIAL_WATCHER_VALUE ? [] : G,
          V
        ]), G = ue);
      } else
        X.run();
  };
  k.allowRecurse = !!n;
  let F;
  c === "sync" ? F = k : c === "post" ? F = () => queuePostRenderEffect(k, $ && $.suspense) : (k.pre = !0, $ && (k.id = $.uid), F = () => queueJob(k));
  const X = new ReactiveEffect(E, F);
  browser$1$1.env.NODE_ENV !== "production" && (X.onTrack = d, X.onTrigger = m), n ? o ? k() : G = X.run() : c === "post" ? queuePostRenderEffect(
    X.run.bind(X),
    $ && $.suspense
  ) : X.run();
  const ee = () => {
    X.stop(), $ && $.scope && remove($.scope.effects, X);
  };
  return M && M.push(ee), ee;
}
function instanceWatch(e, n, o) {
  const u = this.proxy, c = isString$5(e) ? e.includes(".") ? createPathGetter(u, e) : () => u[e] : e.bind(u, u);
  let d;
  isFunction$7(n) ? d = n : (d = n.handler, o = n);
  const m = currentInstance;
  setCurrentInstance(this);
  const v = doWatch(c, d.bind(u), o);
  return m ? setCurrentInstance(m) : unsetCurrentInstance(), v;
}
function createPathGetter(e, n) {
  const o = n.split(".");
  return () => {
    let u = e;
    for (let c = 0; c < o.length && u; c++)
      u = u[o[c]];
    return u;
  };
}
function traverse(e, n) {
  if (!isObject$8(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), isRef(e))
    traverse(e.value, n);
  else if (isArray$7(e))
    for (let o = 0; o < e.length; o++)
      traverse(e[o], n);
  else if (isSet$2(e) || isMap(e))
    e.forEach((o) => {
      traverse(o, n);
    });
  else if (isPlainObject$5(e))
    for (const o in e)
      traverse(e[o], n);
  return e;
}
function validateDirectiveName(e) {
  isBuiltInDirective(e) && warn("Do not use built-in directive ids as custom directive id: " + e);
}
function withDirectives(e, n) {
  const o = currentRenderingInstance;
  if (o === null)
    return browser$1$1.env.NODE_ENV !== "production" && warn("withDirectives can only be used inside render functions."), e;
  const u = getExposeProxy(o) || o.proxy, c = e.dirs || (e.dirs = []);
  for (let d = 0; d < n.length; d++) {
    let [m, v, S, $ = EMPTY_OBJ] = n[d];
    m && (isFunction$7(m) && (m = {
      mounted: m,
      updated: m
    }), m.deep && traverse(v), c.push({
      dir: m,
      instance: u,
      value: v,
      oldValue: void 0,
      arg: S,
      modifiers: $
    }));
  }
  return e;
}
function invokeDirectiveHook(e, n, o, u) {
  const c = e.dirs, d = n && n.dirs;
  for (let m = 0; m < c.length; m++) {
    const v = c[m];
    d && (v.oldValue = d[m].value);
    let S = v.dir[u];
    S && (pauseTracking(), callWithAsyncErrorHandling(S, o, 8, [
      e.el,
      v,
      e,
      n
    ]), resetTracking());
  }
}
function useTransitionState() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return onMounted(() => {
    e.isMounted = !0;
  }), onBeforeUnmount(() => {
    e.isUnmounting = !0;
  }), e;
}
const TransitionHookValidator = [Function, Array], BaseTransitionPropsValidators = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: TransitionHookValidator,
  onEnter: TransitionHookValidator,
  onAfterEnter: TransitionHookValidator,
  onEnterCancelled: TransitionHookValidator,
  // leave
  onBeforeLeave: TransitionHookValidator,
  onLeave: TransitionHookValidator,
  onAfterLeave: TransitionHookValidator,
  onLeaveCancelled: TransitionHookValidator,
  // appear
  onBeforeAppear: TransitionHookValidator,
  onAppear: TransitionHookValidator,
  onAfterAppear: TransitionHookValidator,
  onAppearCancelled: TransitionHookValidator
}, BaseTransitionImpl = {
  name: "BaseTransition",
  props: BaseTransitionPropsValidators,
  setup(e, { slots: n }) {
    const o = getCurrentInstance(), u = useTransitionState();
    let c;
    return () => {
      const d = n.default && getTransitionRawChildren(n.default(), !0);
      if (!d || !d.length)
        return;
      let m = d[0];
      if (d.length > 1) {
        let M = !1;
        for (const G of d)
          if (G.type !== Comment) {
            if (browser$1$1.env.NODE_ENV !== "production" && M) {
              warn(
                "<transition> can only be used on a single element or component. Use <transition-group> for lists."
              );
              break;
            }
            if (m = G, M = !0, browser$1$1.env.NODE_ENV === "production")
              break;
          }
      }
      const v = toRaw(e), { mode: S } = v;
      if (browser$1$1.env.NODE_ENV !== "production" && S && S !== "in-out" && S !== "out-in" && S !== "default" && warn(`invalid <transition> mode: ${S}`), u.isLeaving)
        return emptyPlaceholder(m);
      const $ = getKeepAliveChild(m);
      if (!$)
        return emptyPlaceholder(m);
      const E = resolveTransitionHooks(
        $,
        v,
        u,
        o
      );
      setTransitionHooks($, E);
      const O = o.subTree, T = O && getKeepAliveChild(O);
      let y = !1;
      const { getTransitionKey: V } = $.type;
      if (V) {
        const M = V();
        c === void 0 ? c = M : M !== c && (c = M, y = !0);
      }
      if (T && T.type !== Comment && (!isSameVNodeType($, T) || y)) {
        const M = resolveTransitionHooks(
          T,
          v,
          u,
          o
        );
        if (setTransitionHooks(T, M), S === "out-in")
          return u.isLeaving = !0, M.afterLeave = () => {
            u.isLeaving = !1, o.update.active !== !1 && o.update();
          }, emptyPlaceholder(m);
        S === "in-out" && $.type !== Comment && (M.delayLeave = (G, k, F) => {
          const X = getLeavingNodesForType(
            u,
            T
          );
          X[String(T.key)] = T, G._leaveCb = () => {
            k(), G._leaveCb = void 0, delete E.delayedLeave;
          }, E.delayedLeave = F;
        });
      }
      return m;
    };
  }
}, BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(e, n) {
  const { leavingVNodes: o } = e;
  let u = o.get(n.type);
  return u || (u = /* @__PURE__ */ Object.create(null), o.set(n.type, u)), u;
}
function resolveTransitionHooks(e, n, o, u) {
  const {
    appear: c,
    mode: d,
    persisted: m = !1,
    onBeforeEnter: v,
    onEnter: S,
    onAfterEnter: $,
    onEnterCancelled: E,
    onBeforeLeave: O,
    onLeave: T,
    onAfterLeave: y,
    onLeaveCancelled: V,
    onBeforeAppear: M,
    onAppear: G,
    onAfterAppear: k,
    onAppearCancelled: F
  } = n, X = String(e.key), ee = getLeavingNodesForType(o, e), ue = (pe, oe) => {
    pe && callWithAsyncErrorHandling(
      pe,
      u,
      9,
      oe
    );
  }, Q = (pe, oe) => {
    const ne = oe[1];
    ue(pe, oe), isArray$7(pe) ? pe.every((H) => H.length <= 1) && ne() : pe.length <= 1 && ne();
  }, Y = {
    mode: d,
    persisted: m,
    beforeEnter(pe) {
      let oe = v;
      if (!o.isMounted)
        if (c)
          oe = M || v;
        else
          return;
      pe._leaveCb && pe._leaveCb(
        !0
        /* cancelled */
      );
      const ne = ee[X];
      ne && isSameVNodeType(e, ne) && ne.el._leaveCb && ne.el._leaveCb(), ue(oe, [pe]);
    },
    enter(pe) {
      let oe = S, ne = $, H = E;
      if (!o.isMounted)
        if (c)
          oe = G || S, ne = k || $, H = F || E;
        else
          return;
      let C = !1;
      const w = pe._enterCb = (P) => {
        C || (C = !0, P ? ue(H, [pe]) : ue(ne, [pe]), Y.delayedLeave && Y.delayedLeave(), pe._enterCb = void 0);
      };
      oe ? Q(oe, [pe, w]) : w();
    },
    leave(pe, oe) {
      const ne = String(e.key);
      if (pe._enterCb && pe._enterCb(
        !0
        /* cancelled */
      ), o.isUnmounting)
        return oe();
      ue(O, [pe]);
      let H = !1;
      const C = pe._leaveCb = (w) => {
        H || (H = !0, oe(), w ? ue(V, [pe]) : ue(y, [pe]), pe._leaveCb = void 0, ee[ne] === e && delete ee[ne]);
      };
      ee[ne] = e, T ? Q(T, [pe, C]) : C();
    },
    clone(pe) {
      return resolveTransitionHooks(pe, n, o, u);
    }
  };
  return Y;
}
function emptyPlaceholder(e) {
  if (isKeepAlive(e))
    return e = cloneVNode(e), e.children = null, e;
}
function getKeepAliveChild(e) {
  return isKeepAlive(e) ? e.children ? e.children[0] : void 0 : e;
}
function setTransitionHooks(e, n) {
  e.shapeFlag & 6 && e.component ? setTransitionHooks(e.component.subTree, n) : e.shapeFlag & 128 ? (e.ssContent.transition = n.clone(e.ssContent), e.ssFallback.transition = n.clone(e.ssFallback)) : e.transition = n;
}
function getTransitionRawChildren(e, n = !1, o) {
  let u = [], c = 0;
  for (let d = 0; d < e.length; d++) {
    let m = e[d];
    const v = o == null ? m.key : String(o) + String(m.key != null ? m.key : d);
    m.type === Fragment ? (m.patchFlag & 128 && c++, u = u.concat(
      getTransitionRawChildren(m.children, n, v)
    )) : (n || m.type !== Comment) && u.push(v != null ? cloneVNode(m, { key: v }) : m);
  }
  if (c > 1)
    for (let d = 0; d < u.length; d++)
      u[d].patchFlag = -2;
  return u;
}
function defineComponent(e, n) {
  return isFunction$7(e) ? (
    // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (() => extend$5({ name: e.name }, n, { setup: e }))()
  ) : e;
}
const isAsyncWrapper = (e) => !!e.type.__asyncLoader;
function defineAsyncComponent(e) {
  isFunction$7(e) && (e = { loader: e });
  const {
    loader: n,
    loadingComponent: o,
    errorComponent: u,
    delay: c = 200,
    timeout: d,
    // undefined = never times out
    suspensible: m = !0,
    onError: v
  } = e;
  let S = null, $, E = 0;
  const O = () => (E++, S = null, T()), T = () => {
    let y;
    return S || (y = S = n().catch((V) => {
      if (V = V instanceof Error ? V : new Error(String(V)), v)
        return new Promise((M, G) => {
          v(V, () => M(O()), () => G(V), E + 1);
        });
      throw V;
    }).then((V) => {
      if (y !== S && S)
        return S;
      if (browser$1$1.env.NODE_ENV !== "production" && !V && warn(
        "Async component loader resolved to undefined. If you are using retry(), make sure to return its return value."
      ), V && (V.__esModule || V[Symbol.toStringTag] === "Module") && (V = V.default), browser$1$1.env.NODE_ENV !== "production" && V && !isObject$8(V) && !isFunction$7(V))
        throw new Error(`Invalid async component load result: ${V}`);
      return $ = V, V;
    }));
  };
  return defineComponent({
    name: "AsyncComponentWrapper",
    __asyncLoader: T,
    get __asyncResolved() {
      return $;
    },
    setup() {
      const y = currentInstance;
      if ($)
        return () => createInnerComp($, y);
      const V = (F) => {
        S = null, handleError(
          F,
          y,
          13,
          !u
          /* do not throw in dev if user provided error component */
        );
      };
      if (m && y.suspense || isInSSRComponentSetup)
        return T().then((F) => () => createInnerComp(F, y)).catch((F) => (V(F), () => u ? createVNode(u, {
          error: F
        }) : null));
      const M = ref(!1), G = ref(), k = ref(!!c);
      return c && setTimeout(() => {
        k.value = !1;
      }, c), d != null && setTimeout(() => {
        if (!M.value && !G.value) {
          const F = new Error(
            `Async component timed out after ${d}ms.`
          );
          V(F), G.value = F;
        }
      }, d), T().then(() => {
        M.value = !0, y.parent && isKeepAlive(y.parent.vnode) && queueJob(y.parent.update);
      }).catch((F) => {
        V(F), G.value = F;
      }), () => {
        if (M.value && $)
          return createInnerComp($, y);
        if (G.value && u)
          return createVNode(u, {
            error: G.value
          });
        if (o && !k.value)
          return createVNode(o);
      };
    }
  });
}
function createInnerComp(e, n) {
  const { ref: o, props: u, children: c, ce: d } = n.vnode, m = createVNode(e, u, c);
  return m.ref = o, m.ce = d, delete n.vnode.ce, m;
}
const isKeepAlive = (e) => e.type.__isKeepAlive, KeepAliveImpl = {
  name: "KeepAlive",
  // Marker for special handling inside the renderer. We are not using a ===
  // check directly on KeepAlive in the renderer, because importing it directly
  // would prevent it from being tree-shaken.
  __isKeepAlive: !0,
  props: {
    include: [String, RegExp, Array],
    exclude: [String, RegExp, Array],
    max: [String, Number]
  },
  setup(e, { slots: n }) {
    const o = getCurrentInstance(), u = o.ctx;
    if (!u.renderer)
      return () => {
        const F = n.default && n.default();
        return F && F.length === 1 ? F[0] : F;
      };
    const c = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Set();
    let m = null;
    browser$1$1.env.NODE_ENV !== "production" && (o.__v_cache = c);
    const v = o.suspense, {
      renderer: {
        p: S,
        m: $,
        um: E,
        o: { createElement: O }
      }
    } = u, T = O("div");
    u.activate = (F, X, ee, ue, Q) => {
      const Y = F.component;
      $(F, X, ee, 0, v), S(
        Y.vnode,
        F,
        X,
        ee,
        Y,
        v,
        ue,
        F.slotScopeIds,
        Q
      ), queuePostRenderEffect(() => {
        Y.isDeactivated = !1, Y.a && invokeArrayFns(Y.a);
        const pe = F.props && F.props.onVnodeMounted;
        pe && invokeVNodeHook(pe, Y.parent, F);
      }, v), browser$1$1.env.NODE_ENV !== "production" && devtoolsComponentAdded(Y);
    }, u.deactivate = (F) => {
      const X = F.component;
      $(F, T, null, 1, v), queuePostRenderEffect(() => {
        X.da && invokeArrayFns(X.da);
        const ee = F.props && F.props.onVnodeUnmounted;
        ee && invokeVNodeHook(ee, X.parent, F), X.isDeactivated = !0;
      }, v), browser$1$1.env.NODE_ENV !== "production" && devtoolsComponentAdded(X);
    };
    function y(F) {
      resetShapeFlag(F), E(F, o, v, !0);
    }
    function V(F) {
      c.forEach((X, ee) => {
        const ue = getComponentName(X.type);
        ue && (!F || !F(ue)) && M(ee);
      });
    }
    function M(F) {
      const X = c.get(F);
      !m || !isSameVNodeType(X, m) ? y(X) : m && resetShapeFlag(m), c.delete(F), d.delete(F);
    }
    watch(
      () => [e.include, e.exclude],
      ([F, X]) => {
        F && V((ee) => matches(F, ee)), X && V((ee) => !matches(X, ee));
      },
      // prune post-render after `current` has been updated
      { flush: "post", deep: !0 }
    );
    let G = null;
    const k = () => {
      G != null && c.set(G, getInnerChild(o.subTree));
    };
    return onMounted(k), onUpdated(k), onBeforeUnmount(() => {
      c.forEach((F) => {
        const { subTree: X, suspense: ee } = o, ue = getInnerChild(X);
        if (F.type === ue.type && F.key === ue.key) {
          resetShapeFlag(ue);
          const Q = ue.component.da;
          Q && queuePostRenderEffect(Q, ee);
          return;
        }
        y(F);
      });
    }), () => {
      if (G = null, !n.default)
        return null;
      const F = n.default(), X = F[0];
      if (F.length > 1)
        return browser$1$1.env.NODE_ENV !== "production" && warn("KeepAlive should contain exactly one component child."), m = null, F;
      if (!isVNode(X) || !(X.shapeFlag & 4) && !(X.shapeFlag & 128))
        return m = null, X;
      let ee = getInnerChild(X);
      const ue = ee.type, Q = getComponentName(
        isAsyncWrapper(ee) ? ee.type.__asyncResolved || {} : ue
      ), { include: Y, exclude: pe, max: oe } = e;
      if (Y && (!Q || !matches(Y, Q)) || pe && Q && matches(pe, Q))
        return m = ee, X;
      const ne = ee.key == null ? ue : ee.key, H = c.get(ne);
      return ee.el && (ee = cloneVNode(ee), X.shapeFlag & 128 && (X.ssContent = ee)), G = ne, H ? (ee.el = H.el, ee.component = H.component, ee.transition && setTransitionHooks(ee, ee.transition), ee.shapeFlag |= 512, d.delete(ne), d.add(ne)) : (d.add(ne), oe && d.size > parseInt(oe, 10) && M(d.values().next().value)), ee.shapeFlag |= 256, m = ee, isSuspense(X.type) ? X : ee;
    };
  }
}, KeepAlive = KeepAliveImpl;
function matches(e, n) {
  return isArray$7(e) ? e.some((o) => matches(o, n)) : isString$5(e) ? e.split(",").includes(n) : isRegExp$3(e) ? e.test(n) : !1;
}
function onActivated(e, n) {
  registerKeepAliveHook(e, "a", n);
}
function onDeactivated(e, n) {
  registerKeepAliveHook(e, "da", n);
}
function registerKeepAliveHook(e, n, o = currentInstance) {
  const u = e.__wdc || (e.__wdc = () => {
    let c = o;
    for (; c; ) {
      if (c.isDeactivated)
        return;
      c = c.parent;
    }
    return e();
  });
  if (injectHook(n, u, o), o) {
    let c = o.parent;
    for (; c && c.parent; )
      isKeepAlive(c.parent.vnode) && injectToKeepAliveRoot(u, n, o, c), c = c.parent;
  }
}
function injectToKeepAliveRoot(e, n, o, u) {
  const c = injectHook(
    n,
    e,
    u,
    !0
    /* prepend */
  );
  onUnmounted(() => {
    remove(u[n], c);
  }, o);
}
function resetShapeFlag(e) {
  e.shapeFlag &= -257, e.shapeFlag &= -513;
}
function getInnerChild(e) {
  return e.shapeFlag & 128 ? e.ssContent : e;
}
function injectHook(e, n, o = currentInstance, u = !1) {
  if (o) {
    const c = o[e] || (o[e] = []), d = n.__weh || (n.__weh = (...m) => {
      if (o.isUnmounted)
        return;
      pauseTracking(), setCurrentInstance(o);
      const v = callWithAsyncErrorHandling(n, o, e, m);
      return unsetCurrentInstance(), resetTracking(), v;
    });
    return u ? c.unshift(d) : c.push(d), d;
  } else if (browser$1$1.env.NODE_ENV !== "production") {
    const c = toHandlerKey(ErrorTypeStrings[e].replace(/ hook$/, ""));
    warn(
      `${c} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const createHook = (e) => (n, o = currentInstance) => (
  // post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
  (!isInSSRComponentSetup || e === "sp") && injectHook(e, (...u) => n(...u), o)
), onBeforeMount = createHook("bm"), onMounted = createHook("m"), onBeforeUpdate = createHook("bu"), onUpdated = createHook("u"), onBeforeUnmount = createHook("bum"), onUnmounted = createHook("um"), onServerPrefetch = createHook("sp"), onRenderTriggered = createHook(
  "rtg"
), onRenderTracked = createHook(
  "rtc"
);
function onErrorCaptured(e, n = currentInstance) {
  injectHook("ec", e, n);
}
const COMPONENTS = "components", DIRECTIVES = "directives";
function resolveComponent(e, n) {
  return resolveAsset(COMPONENTS, e, !0, n) || e;
}
const NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function resolveDynamicComponent(e) {
  return isString$5(e) ? resolveAsset(COMPONENTS, e, !1) || e : e || NULL_DYNAMIC_COMPONENT;
}
function resolveDirective(e) {
  return resolveAsset(DIRECTIVES, e);
}
function resolveAsset(e, n, o = !0, u = !1) {
  const c = currentRenderingInstance || currentInstance;
  if (c) {
    const d = c.type;
    if (e === COMPONENTS) {
      const v = getComponentName(
        d,
        !1
        /* do not include inferred name to avoid breaking existing code */
      );
      if (v && (v === n || v === camelize(n) || v === capitalize(camelize(n))))
        return d;
    }
    const m = (
      // local registration
      // check instance[type] first which is resolved for options API
      resolve(c[e] || d[e], n) || // global registration
      resolve(c.appContext[e], n)
    );
    if (!m && u)
      return d;
    if (browser$1$1.env.NODE_ENV !== "production" && o && !m) {
      const v = e === COMPONENTS ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : "";
      warn(`Failed to resolve ${e.slice(0, -1)}: ${n}${v}`);
    }
    return m;
  } else
    browser$1$1.env.NODE_ENV !== "production" && warn(
      `resolve${capitalize(e.slice(0, -1))} can only be used in render() or setup().`
    );
}
function resolve(e, n) {
  return e && (e[n] || e[camelize(n)] || e[capitalize(camelize(n))]);
}
function renderList(e, n, o, u) {
  let c;
  const d = o && o[u];
  if (isArray$7(e) || isString$5(e)) {
    c = new Array(e.length);
    for (let m = 0, v = e.length; m < v; m++)
      c[m] = n(e[m], m, void 0, d && d[m]);
  } else if (typeof e == "number") {
    browser$1$1.env.NODE_ENV !== "production" && !Number.isInteger(e) && warn(`The v-for range expect an integer value but got ${e}.`), c = new Array(e);
    for (let m = 0; m < e; m++)
      c[m] = n(m + 1, m, void 0, d && d[m]);
  } else if (isObject$8(e))
    if (e[Symbol.iterator])
      c = Array.from(
        e,
        (m, v) => n(m, v, void 0, d && d[v])
      );
    else {
      const m = Object.keys(e);
      c = new Array(m.length);
      for (let v = 0, S = m.length; v < S; v++) {
        const $ = m[v];
        c[v] = n(e[$], $, v, d && d[v]);
      }
    }
  else
    c = [];
  return o && (o[u] = c), c;
}
function createSlots(e, n) {
  for (let o = 0; o < n.length; o++) {
    const u = n[o];
    if (isArray$7(u))
      for (let c = 0; c < u.length; c++)
        e[u[c].name] = u[c].fn;
    else
      u && (e[u.name] = u.key ? (...c) => {
        const d = u.fn(...c);
        return d && (d.key = u.key), d;
      } : u.fn);
  }
  return e;
}
function renderSlot(e, n, o = {}, u, c) {
  if (currentRenderingInstance.isCE || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.isCE)
    return n !== "default" && (o.name = n), createVNode("slot", o, u && u());
  let d = e[n];
  browser$1$1.env.NODE_ENV !== "production" && d && d.length > 1 && (warn(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), d = () => []), d && d._c && (d._d = !1), openBlock();
  const m = d && ensureValidVNode(d(o)), v = createBlock(
    Fragment,
    {
      key: o.key || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      m && m.key || `_${n}`
    },
    m || (u ? u() : []),
    m && e._ === 1 ? 64 : -2
  );
  return !c && v.scopeId && (v.slotScopeIds = [v.scopeId + "-s"]), d && d._c && (d._d = !0), v;
}
function ensureValidVNode(e) {
  return e.some((n) => isVNode(n) ? !(n.type === Comment || n.type === Fragment && !ensureValidVNode(n.children)) : !0) ? e : null;
}
function toHandlers(e, n) {
  const o = {};
  if (browser$1$1.env.NODE_ENV !== "production" && !isObject$8(e))
    return warn("v-on with no argument expects an object value."), o;
  for (const u in e)
    o[n && /[A-Z]/.test(u) ? `on:${u}` : toHandlerKey(u)] = e[u];
  return o;
}
const getPublicInstance = (e) => e ? isStatefulComponent(e) ? getExposeProxy(e) || e.proxy : getPublicInstance(e.parent) : null, publicPropertiesMap = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ extend$5(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => browser$1$1.env.NODE_ENV !== "production" ? shallowReadonly(e.props) : e.props,
    $attrs: (e) => browser$1$1.env.NODE_ENV !== "production" ? shallowReadonly(e.attrs) : e.attrs,
    $slots: (e) => browser$1$1.env.NODE_ENV !== "production" ? shallowReadonly(e.slots) : e.slots,
    $refs: (e) => browser$1$1.env.NODE_ENV !== "production" ? shallowReadonly(e.refs) : e.refs,
    $parent: (e) => getPublicInstance(e.parent),
    $root: (e) => getPublicInstance(e.root),
    $emit: (e) => e.emit,
    $options: (e) => resolveMergedOptions(e),
    $forceUpdate: (e) => e.f || (e.f = () => queueJob(e.update)),
    $nextTick: (e) => e.n || (e.n = nextTick.bind(e.proxy)),
    $watch: (e) => instanceWatch.bind(e)
  })
), isReservedPrefix = (e) => e === "_" || e === "$", hasSetupBinding = (e, n) => e !== EMPTY_OBJ && !e.__isScriptSetup && hasOwn$1(e, n), PublicInstanceProxyHandlers = {
  get({ _: e }, n) {
    const { ctx: o, setupState: u, data: c, props: d, accessCache: m, type: v, appContext: S } = e;
    if (browser$1$1.env.NODE_ENV !== "production" && n === "__isVue")
      return !0;
    let $;
    if (n[0] !== "$") {
      const y = m[n];
      if (y !== void 0)
        switch (y) {
          case 1:
            return u[n];
          case 2:
            return c[n];
          case 4:
            return o[n];
          case 3:
            return d[n];
        }
      else {
        if (hasSetupBinding(u, n))
          return m[n] = 1, u[n];
        if (c !== EMPTY_OBJ && hasOwn$1(c, n))
          return m[n] = 2, c[n];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          ($ = e.propsOptions[0]) && hasOwn$1($, n)
        )
          return m[n] = 3, d[n];
        if (o !== EMPTY_OBJ && hasOwn$1(o, n))
          return m[n] = 4, o[n];
        shouldCacheAccess && (m[n] = 0);
      }
    }
    const E = publicPropertiesMap[n];
    let O, T;
    if (E)
      return n === "$attrs" ? (track(e, "get", n), browser$1$1.env.NODE_ENV !== "production" && markAttrsAccessed()) : browser$1$1.env.NODE_ENV !== "production" && n === "$slots" && track(e, "get", n), E(e);
    if (
      // css module (injected by vue-loader)
      (O = v.__cssModules) && (O = O[n])
    )
      return O;
    if (o !== EMPTY_OBJ && hasOwn$1(o, n))
      return m[n] = 4, o[n];
    if (
      // global properties
      T = S.config.globalProperties, hasOwn$1(T, n)
    )
      return T[n];
    browser$1$1.env.NODE_ENV !== "production" && currentRenderingInstance && (!isString$5(n) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    n.indexOf("__v") !== 0) && (c !== EMPTY_OBJ && isReservedPrefix(n[0]) && hasOwn$1(c, n) ? warn(
      `Property ${JSON.stringify(
        n
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === currentRenderingInstance && warn(
      `Property ${JSON.stringify(n)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, n, o) {
    const { data: u, setupState: c, ctx: d } = e;
    return hasSetupBinding(c, n) ? (c[n] = o, !0) : browser$1$1.env.NODE_ENV !== "production" && c.__isScriptSetup && hasOwn$1(c, n) ? (warn(`Cannot mutate <script setup> binding "${n}" from Options API.`), !1) : u !== EMPTY_OBJ && hasOwn$1(u, n) ? (u[n] = o, !0) : hasOwn$1(e.props, n) ? (browser$1$1.env.NODE_ENV !== "production" && warn(`Attempting to mutate prop "${n}". Props are readonly.`), !1) : n[0] === "$" && n.slice(1) in e ? (browser$1$1.env.NODE_ENV !== "production" && warn(
      `Attempting to mutate public property "${n}". Properties starting with $ are reserved and readonly.`
    ), !1) : (browser$1$1.env.NODE_ENV !== "production" && n in e.appContext.config.globalProperties ? Object.defineProperty(d, n, {
      enumerable: !0,
      configurable: !0,
      value: o
    }) : d[n] = o, !0);
  },
  has({
    _: { data: e, setupState: n, accessCache: o, ctx: u, appContext: c, propsOptions: d }
  }, m) {
    let v;
    return !!o[m] || e !== EMPTY_OBJ && hasOwn$1(e, m) || hasSetupBinding(n, m) || (v = d[0]) && hasOwn$1(v, m) || hasOwn$1(u, m) || hasOwn$1(publicPropertiesMap, m) || hasOwn$1(c.config.globalProperties, m);
  },
  defineProperty(e, n, o) {
    return o.get != null ? e._.accessCache[n] = 0 : hasOwn$1(o, "value") && this.set(e, n, o.value, null), Reflect.defineProperty(e, n, o);
  }
};
browser$1$1.env.NODE_ENV !== "production" && (PublicInstanceProxyHandlers.ownKeys = (e) => (warn(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
const RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ extend$5(
  {},
  PublicInstanceProxyHandlers,
  {
    get(e, n) {
      if (n !== Symbol.unscopables)
        return PublicInstanceProxyHandlers.get(e, n, e);
    },
    has(e, n) {
      const o = n[0] !== "_" && !isGloballyWhitelisted(n);
      return browser$1$1.env.NODE_ENV !== "production" && !o && PublicInstanceProxyHandlers.has(e, n) && warn(
        `Property ${JSON.stringify(
          n
        )} should not start with _ which is a reserved prefix for Vue internals.`
      ), o;
    }
  }
);
function createDevRenderContext(e) {
  const n = {};
  return Object.defineProperty(n, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(publicPropertiesMap).forEach((o) => {
    Object.defineProperty(n, o, {
      configurable: !0,
      enumerable: !1,
      get: () => publicPropertiesMap[o](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: NOOP
    });
  }), n;
}
function exposePropsOnRenderContext(e) {
  const {
    ctx: n,
    propsOptions: [o]
  } = e;
  o && Object.keys(o).forEach((u) => {
    Object.defineProperty(n, u, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[u],
      set: NOOP
    });
  });
}
function exposeSetupStateOnRenderContext(e) {
  const { ctx: n, setupState: o } = e;
  Object.keys(toRaw(o)).forEach((u) => {
    if (!o.__isScriptSetup) {
      if (isReservedPrefix(u[0])) {
        warn(
          `setup() return property ${JSON.stringify(
            u
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(n, u, {
        enumerable: !0,
        configurable: !0,
        get: () => o[u],
        set: NOOP
      });
    }
  });
}
const warnRuntimeUsage = (e) => warn(
  `${e}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`
);
function defineProps() {
  return browser$1$1.env.NODE_ENV !== "production" && warnRuntimeUsage("defineProps"), null;
}
function defineEmits() {
  return browser$1$1.env.NODE_ENV !== "production" && warnRuntimeUsage("defineEmits"), null;
}
function defineExpose(e) {
  browser$1$1.env.NODE_ENV !== "production" && warnRuntimeUsage("defineExpose");
}
function defineOptions(e) {
  browser$1$1.env.NODE_ENV !== "production" && warnRuntimeUsage("defineOptions");
}
function defineSlots() {
  return browser$1$1.env.NODE_ENV !== "production" && warnRuntimeUsage("defineSlots"), null;
}
function defineModel() {
  browser$1$1.env.NODE_ENV !== "production" && warnRuntimeUsage("defineModel");
}
function withDefaults(e, n) {
  return browser$1$1.env.NODE_ENV !== "production" && warnRuntimeUsage("withDefaults"), null;
}
function useSlots() {
  return getContext().slots;
}
function useAttrs() {
  return getContext().attrs;
}
function useModel(e, n, o) {
  const u = getCurrentInstance();
  if (browser$1$1.env.NODE_ENV !== "production" && !u)
    return warn("useModel() called without active instance."), ref();
  if (browser$1$1.env.NODE_ENV !== "production" && !u.propsOptions[0][n])
    return warn(`useModel() called with prop "${n}" which is not declared.`), ref();
  if (o && o.local) {
    const c = ref(e[n]);
    return watch(
      () => e[n],
      (d) => c.value = d
    ), watch(c, (d) => {
      d !== e[n] && u.emit(`update:${n}`, d);
    }), c;
  } else
    return {
      __v_isRef: !0,
      get value() {
        return e[n];
      },
      set value(c) {
        u.emit(`update:${n}`, c);
      }
    };
}
function getContext() {
  const e = getCurrentInstance();
  return browser$1$1.env.NODE_ENV !== "production" && !e && warn("useContext() called without active instance."), e.setupContext || (e.setupContext = createSetupContext(e));
}
function normalizePropsOrEmits(e) {
  return isArray$7(e) ? e.reduce(
    (n, o) => (n[o] = null, n),
    {}
  ) : e;
}
function mergeDefaults(e, n) {
  const o = normalizePropsOrEmits(e);
  for (const u in n) {
    if (u.startsWith("__skip"))
      continue;
    let c = o[u];
    c ? isArray$7(c) || isFunction$7(c) ? c = o[u] = { type: c, default: n[u] } : c.default = n[u] : c === null ? c = o[u] = { default: n[u] } : browser$1$1.env.NODE_ENV !== "production" && warn(`props default key "${u}" has no corresponding declaration.`), c && n[`__skip_${u}`] && (c.skipFactory = !0);
  }
  return o;
}
function mergeModels(e, n) {
  return !e || !n ? e || n : isArray$7(e) && isArray$7(n) ? e.concat(n) : extend$5({}, normalizePropsOrEmits(e), normalizePropsOrEmits(n));
}
function createPropsRestProxy(e, n) {
  const o = {};
  for (const u in e)
    n.includes(u) || Object.defineProperty(o, u, {
      enumerable: !0,
      get: () => e[u]
    });
  return o;
}
function withAsyncContext(e) {
  const n = getCurrentInstance();
  browser$1$1.env.NODE_ENV !== "production" && !n && warn(
    "withAsyncContext called without active current instance. This is likely a bug."
  );
  let o = e();
  return unsetCurrentInstance(), isPromise$1(o) && (o = o.catch((u) => {
    throw setCurrentInstance(n), u;
  })), [o, () => setCurrentInstance(n)];
}
function createDuplicateChecker() {
  const e = /* @__PURE__ */ Object.create(null);
  return (n, o) => {
    e[o] ? warn(`${n} property "${o}" is already defined in ${e[o]}.`) : e[o] = n;
  };
}
let shouldCacheAccess = !0;
function applyOptions(e) {
  const n = resolveMergedOptions(e), o = e.proxy, u = e.ctx;
  shouldCacheAccess = !1, n.beforeCreate && callHook$1(n.beforeCreate, e, "bc");
  const {
    // state
    data: c,
    computed: d,
    methods: m,
    watch: v,
    provide: S,
    inject: $,
    // lifecycle
    created: E,
    beforeMount: O,
    mounted: T,
    beforeUpdate: y,
    updated: V,
    activated: M,
    deactivated: G,
    beforeDestroy: k,
    beforeUnmount: F,
    destroyed: X,
    unmounted: ee,
    render: ue,
    renderTracked: Q,
    renderTriggered: Y,
    errorCaptured: pe,
    serverPrefetch: oe,
    // public API
    expose: ne,
    inheritAttrs: H,
    // assets
    components: C,
    directives: w,
    filters: P
  } = n, J = browser$1$1.env.NODE_ENV !== "production" ? createDuplicateChecker() : null;
  if (browser$1$1.env.NODE_ENV !== "production") {
    const [fe] = e.propsOptions;
    if (fe)
      for (const N in fe)
        J("Props", N);
  }
  if ($ && resolveInjections($, u, J), m)
    for (const fe in m) {
      const N = m[fe];
      isFunction$7(N) ? (browser$1$1.env.NODE_ENV !== "production" ? Object.defineProperty(u, fe, {
        value: N.bind(o),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : u[fe] = N.bind(o), browser$1$1.env.NODE_ENV !== "production" && J("Methods", fe)) : browser$1$1.env.NODE_ENV !== "production" && warn(
        `Method "${fe}" has type "${typeof N}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (c) {
    browser$1$1.env.NODE_ENV !== "production" && !isFunction$7(c) && warn(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const fe = c.call(o, o);
    if (browser$1$1.env.NODE_ENV !== "production" && isPromise$1(fe) && warn(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !isObject$8(fe))
      browser$1$1.env.NODE_ENV !== "production" && warn("data() should return an object.");
    else if (e.data = reactive(fe), browser$1$1.env.NODE_ENV !== "production")
      for (const N in fe)
        J("Data", N), isReservedPrefix(N[0]) || Object.defineProperty(u, N, {
          configurable: !0,
          enumerable: !0,
          get: () => fe[N],
          set: NOOP
        });
  }
  if (shouldCacheAccess = !0, d)
    for (const fe in d) {
      const N = d[fe], W = isFunction$7(N) ? N.bind(o, o) : isFunction$7(N.get) ? N.get.bind(o, o) : NOOP;
      browser$1$1.env.NODE_ENV !== "production" && W === NOOP && warn(`Computed property "${fe}" has no getter.`);
      const I = !isFunction$7(N) && isFunction$7(N.set) ? N.set.bind(o) : browser$1$1.env.NODE_ENV !== "production" ? () => {
        warn(
          `Write operation failed: computed property "${fe}" is readonly.`
        );
      } : NOOP, te = computed({
        get: W,
        set: I
      });
      Object.defineProperty(u, fe, {
        enumerable: !0,
        configurable: !0,
        get: () => te.value,
        set: (ge) => te.value = ge
      }), browser$1$1.env.NODE_ENV !== "production" && J("Computed", fe);
    }
  if (v)
    for (const fe in v)
      createWatcher(v[fe], u, o, fe);
  if (S) {
    const fe = isFunction$7(S) ? S.call(o) : S;
    Reflect.ownKeys(fe).forEach((N) => {
      provide(N, fe[N]);
    });
  }
  E && callHook$1(E, e, "c");
  function se(fe, N) {
    isArray$7(N) ? N.forEach((W) => fe(W.bind(o))) : N && fe(N.bind(o));
  }
  if (se(onBeforeMount, O), se(onMounted, T), se(onBeforeUpdate, y), se(onUpdated, V), se(onActivated, M), se(onDeactivated, G), se(onErrorCaptured, pe), se(onRenderTracked, Q), se(onRenderTriggered, Y), se(onBeforeUnmount, F), se(onUnmounted, ee), se(onServerPrefetch, oe), isArray$7(ne))
    if (ne.length) {
      const fe = e.exposed || (e.exposed = {});
      ne.forEach((N) => {
        Object.defineProperty(fe, N, {
          get: () => o[N],
          set: (W) => o[N] = W
        });
      });
    } else
      e.exposed || (e.exposed = {});
  ue && e.render === NOOP && (e.render = ue), H != null && (e.inheritAttrs = H), C && (e.components = C), w && (e.directives = w);
}
function resolveInjections(e, n, o = NOOP) {
  isArray$7(e) && (e = normalizeInject(e));
  for (const u in e) {
    const c = e[u];
    let d;
    isObject$8(c) ? "default" in c ? d = inject(
      c.from || u,
      c.default,
      !0
      /* treat default function as factory */
    ) : d = inject(c.from || u) : d = inject(c), isRef(d) ? Object.defineProperty(n, u, {
      enumerable: !0,
      configurable: !0,
      get: () => d.value,
      set: (m) => d.value = m
    }) : n[u] = d, browser$1$1.env.NODE_ENV !== "production" && o("Inject", u);
  }
}
function callHook$1(e, n, o) {
  callWithAsyncErrorHandling(
    isArray$7(e) ? e.map((u) => u.bind(n.proxy)) : e.bind(n.proxy),
    n,
    o
  );
}
function createWatcher(e, n, o, u) {
  const c = u.includes(".") ? createPathGetter(o, u) : () => o[u];
  if (isString$5(e)) {
    const d = n[e];
    isFunction$7(d) ? watch(c, d) : browser$1$1.env.NODE_ENV !== "production" && warn(`Invalid watch handler specified by key "${e}"`, d);
  } else if (isFunction$7(e))
    watch(c, e.bind(o));
  else if (isObject$8(e))
    if (isArray$7(e))
      e.forEach((d) => createWatcher(d, n, o, u));
    else {
      const d = isFunction$7(e.handler) ? e.handler.bind(o) : n[e.handler];
      isFunction$7(d) ? watch(c, d, e) : browser$1$1.env.NODE_ENV !== "production" && warn(`Invalid watch handler specified by key "${e.handler}"`, d);
    }
  else
    browser$1$1.env.NODE_ENV !== "production" && warn(`Invalid watch option: "${u}"`, e);
}
function resolveMergedOptions(e) {
  const n = e.type, { mixins: o, extends: u } = n, {
    mixins: c,
    optionsCache: d,
    config: { optionMergeStrategies: m }
  } = e.appContext, v = d.get(n);
  let S;
  return v ? S = v : !c.length && !o && !u ? S = n : (S = {}, c.length && c.forEach(
    ($) => mergeOptions(S, $, m, !0)
  ), mergeOptions(S, n, m)), isObject$8(n) && d.set(n, S), S;
}
function mergeOptions(e, n, o, u = !1) {
  const { mixins: c, extends: d } = n;
  d && mergeOptions(e, d, o, !0), c && c.forEach(
    (m) => mergeOptions(e, m, o, !0)
  );
  for (const m in n)
    if (u && m === "expose")
      browser$1$1.env.NODE_ENV !== "production" && warn(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const v = internalOptionMergeStrats[m] || o && o[m];
      e[m] = v ? v(e[m], n[m]) : n[m];
    }
  return e;
}
const internalOptionMergeStrats = {
  data: mergeDataFn,
  props: mergeEmitsOrPropsOptions,
  emits: mergeEmitsOrPropsOptions,
  // objects
  methods: mergeObjectOptions,
  computed: mergeObjectOptions,
  // lifecycle
  beforeCreate: mergeAsArray,
  created: mergeAsArray,
  beforeMount: mergeAsArray,
  mounted: mergeAsArray,
  beforeUpdate: mergeAsArray,
  updated: mergeAsArray,
  beforeDestroy: mergeAsArray,
  beforeUnmount: mergeAsArray,
  destroyed: mergeAsArray,
  unmounted: mergeAsArray,
  activated: mergeAsArray,
  deactivated: mergeAsArray,
  errorCaptured: mergeAsArray,
  serverPrefetch: mergeAsArray,
  // assets
  components: mergeObjectOptions,
  directives: mergeObjectOptions,
  // watch
  watch: mergeWatchOptions,
  // provide / inject
  provide: mergeDataFn,
  inject: mergeInject
};
function mergeDataFn(e, n) {
  return n ? e ? function() {
    return extend$5(
      isFunction$7(e) ? e.call(this, this) : e,
      isFunction$7(n) ? n.call(this, this) : n
    );
  } : n : e;
}
function mergeInject(e, n) {
  return mergeObjectOptions(normalizeInject(e), normalizeInject(n));
}
function normalizeInject(e) {
  if (isArray$7(e)) {
    const n = {};
    for (let o = 0; o < e.length; o++)
      n[e[o]] = e[o];
    return n;
  }
  return e;
}
function mergeAsArray(e, n) {
  return e ? [...new Set([].concat(e, n))] : n;
}
function mergeObjectOptions(e, n) {
  return e ? extend$5(/* @__PURE__ */ Object.create(null), e, n) : n;
}
function mergeEmitsOrPropsOptions(e, n) {
  return e ? isArray$7(e) && isArray$7(n) ? [.../* @__PURE__ */ new Set([...e, ...n])] : extend$5(
    /* @__PURE__ */ Object.create(null),
    normalizePropsOrEmits(e),
    normalizePropsOrEmits(n ?? {})
  ) : n;
}
function mergeWatchOptions(e, n) {
  if (!e)
    return n;
  if (!n)
    return e;
  const o = extend$5(/* @__PURE__ */ Object.create(null), e);
  for (const u in n)
    o[u] = mergeAsArray(e[u], n[u]);
  return o;
}
function createAppContext() {
  return {
    app: null,
    config: {
      isNativeTag: NO$1,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let uid$1 = 0;
function createAppAPI(e, n) {
  return function(u, c = null) {
    isFunction$7(u) || (u = extend$5({}, u)), c != null && !isObject$8(c) && (browser$1$1.env.NODE_ENV !== "production" && warn("root props passed to app.mount() must be an object."), c = null);
    const d = createAppContext();
    browser$1$1.env.NODE_ENV !== "production" && Object.defineProperty(d.config, "unwrapInjectedRef", {
      get() {
        return !0;
      },
      set() {
        warn(
          "app.config.unwrapInjectedRef has been deprecated. 3.3 now alawys unwraps injected refs in Options API."
        );
      }
    });
    const m = /* @__PURE__ */ new Set();
    let v = !1;
    const S = d.app = {
      _uid: uid$1++,
      _component: u,
      _props: c,
      _container: null,
      _context: d,
      _instance: null,
      version: version$6,
      get config() {
        return d.config;
      },
      set config($) {
        browser$1$1.env.NODE_ENV !== "production" && warn(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use($, ...E) {
        return m.has($) ? browser$1$1.env.NODE_ENV !== "production" && warn("Plugin has already been applied to target app.") : $ && isFunction$7($.install) ? (m.add($), $.install(S, ...E)) : isFunction$7($) ? (m.add($), $(S, ...E)) : browser$1$1.env.NODE_ENV !== "production" && warn(
          'A plugin must either be a function or an object with an "install" function.'
        ), S;
      },
      mixin($) {
        return d.mixins.includes($) ? browser$1$1.env.NODE_ENV !== "production" && warn(
          "Mixin has already been applied to target app" + ($.name ? `: ${$.name}` : "")
        ) : d.mixins.push($), S;
      },
      component($, E) {
        return browser$1$1.env.NODE_ENV !== "production" && validateComponentName($, d.config), E ? (browser$1$1.env.NODE_ENV !== "production" && d.components[$] && warn(`Component "${$}" has already been registered in target app.`), d.components[$] = E, S) : d.components[$];
      },
      directive($, E) {
        return browser$1$1.env.NODE_ENV !== "production" && validateDirectiveName($), E ? (browser$1$1.env.NODE_ENV !== "production" && d.directives[$] && warn(`Directive "${$}" has already been registered in target app.`), d.directives[$] = E, S) : d.directives[$];
      },
      mount($, E, O) {
        if (v)
          browser$1$1.env.NODE_ENV !== "production" && warn(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          browser$1$1.env.NODE_ENV !== "production" && $.__vue_app__ && warn(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const T = createVNode(
            u,
            c
          );
          return T.appContext = d, browser$1$1.env.NODE_ENV !== "production" && (d.reload = () => {
            e(cloneVNode(T), $, O);
          }), E && n ? n(T, $) : e(T, $, O), v = !0, S._container = $, $.__vue_app__ = S, browser$1$1.env.NODE_ENV !== "production" && (S._instance = T.component, devtoolsInitApp(S, version$6)), getExposeProxy(T.component) || T.component.proxy;
        }
      },
      unmount() {
        v ? (e(null, S._container), browser$1$1.env.NODE_ENV !== "production" && (S._instance = null, devtoolsUnmountApp(S)), delete S._container.__vue_app__) : browser$1$1.env.NODE_ENV !== "production" && warn("Cannot unmount an app that is not mounted.");
      },
      provide($, E) {
        return browser$1$1.env.NODE_ENV !== "production" && $ in d.provides && warn(
          `App already provides property with key "${String($)}". It will be overwritten with the new value.`
        ), d.provides[$] = E, S;
      },
      runWithContext($) {
        currentApp = S;
        try {
          return $();
        } finally {
          currentApp = null;
        }
      }
    };
    return S;
  };
}
let currentApp = null;
function provide(e, n) {
  if (!currentInstance)
    browser$1$1.env.NODE_ENV !== "production" && warn("provide() can only be used inside setup().");
  else {
    let o = currentInstance.provides;
    const u = currentInstance.parent && currentInstance.parent.provides;
    u === o && (o = currentInstance.provides = Object.create(u)), o[e] = n;
  }
}
function inject(e, n, o = !1) {
  const u = currentInstance || currentRenderingInstance;
  if (u || currentApp) {
    const c = u ? u.parent == null ? u.vnode.appContext && u.vnode.appContext.provides : u.parent.provides : currentApp._context.provides;
    if (c && e in c)
      return c[e];
    if (arguments.length > 1)
      return o && isFunction$7(n) ? n.call(u && u.proxy) : n;
    browser$1$1.env.NODE_ENV !== "production" && warn(`injection "${String(e)}" not found.`);
  } else
    browser$1$1.env.NODE_ENV !== "production" && warn("inject() can only be used inside setup() or functional components.");
}
function hasInjectionContext() {
  return !!(currentInstance || currentRenderingInstance || currentApp);
}
function initProps(e, n, o, u = !1) {
  const c = {}, d = {};
  def(d, InternalObjectKey, 1), e.propsDefaults = /* @__PURE__ */ Object.create(null), setFullProps(e, n, c, d);
  for (const m in e.propsOptions[0])
    m in c || (c[m] = void 0);
  browser$1$1.env.NODE_ENV !== "production" && validateProps(n || {}, c, e), o ? e.props = u ? c : shallowReactive(c) : e.type.props ? e.props = c : e.props = d, e.attrs = d;
}
function isInHmrContext(e) {
  for (; e; ) {
    if (e.type.__hmrId)
      return !0;
    e = e.parent;
  }
}
function updateProps(e, n, o, u) {
  const {
    props: c,
    attrs: d,
    vnode: { patchFlag: m }
  } = e, v = toRaw(c), [S] = e.propsOptions;
  let $ = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(browser$1$1.env.NODE_ENV !== "production" && isInHmrContext(e)) && (u || m > 0) && !(m & 16)
  ) {
    if (m & 8) {
      const E = e.vnode.dynamicProps;
      for (let O = 0; O < E.length; O++) {
        let T = E[O];
        if (isEmitListener(e.emitsOptions, T))
          continue;
        const y = n[T];
        if (S)
          if (hasOwn$1(d, T))
            y !== d[T] && (d[T] = y, $ = !0);
          else {
            const V = camelize(T);
            c[V] = resolvePropValue(
              S,
              v,
              V,
              y,
              e,
              !1
              /* isAbsent */
            );
          }
        else
          y !== d[T] && (d[T] = y, $ = !0);
      }
    }
  } else {
    setFullProps(e, n, c, d) && ($ = !0);
    let E;
    for (const O in v)
      (!n || // for camelCase
      !hasOwn$1(n, O) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((E = hyphenate(O)) === O || !hasOwn$1(n, E))) && (S ? o && // for camelCase
      (o[O] !== void 0 || // for kebab-case
      o[E] !== void 0) && (c[O] = resolvePropValue(
        S,
        v,
        O,
        void 0,
        e,
        !0
        /* isAbsent */
      )) : delete c[O]);
    if (d !== v)
      for (const O in d)
        (!n || !hasOwn$1(n, O)) && (delete d[O], $ = !0);
  }
  $ && trigger(e, "set", "$attrs"), browser$1$1.env.NODE_ENV !== "production" && validateProps(n || {}, c, e);
}
function setFullProps(e, n, o, u) {
  const [c, d] = e.propsOptions;
  let m = !1, v;
  if (n)
    for (let S in n) {
      if (isReservedProp(S))
        continue;
      const $ = n[S];
      let E;
      c && hasOwn$1(c, E = camelize(S)) ? !d || !d.includes(E) ? o[E] = $ : (v || (v = {}))[E] = $ : isEmitListener(e.emitsOptions, S) || (!(S in u) || $ !== u[S]) && (u[S] = $, m = !0);
    }
  if (d) {
    const S = toRaw(o), $ = v || EMPTY_OBJ;
    for (let E = 0; E < d.length; E++) {
      const O = d[E];
      o[O] = resolvePropValue(
        c,
        S,
        O,
        $[O],
        e,
        !hasOwn$1($, O)
      );
    }
  }
  return m;
}
function resolvePropValue(e, n, o, u, c, d) {
  const m = e[o];
  if (m != null) {
    const v = hasOwn$1(m, "default");
    if (v && u === void 0) {
      const S = m.default;
      if (m.type !== Function && !m.skipFactory && isFunction$7(S)) {
        const { propsDefaults: $ } = c;
        o in $ ? u = $[o] : (setCurrentInstance(c), u = $[o] = S.call(
          null,
          n
        ), unsetCurrentInstance());
      } else
        u = S;
    }
    m[
      0
      /* shouldCast */
    ] && (d && !v ? u = !1 : m[
      1
      /* shouldCastTrue */
    ] && (u === "" || u === hyphenate(o)) && (u = !0));
  }
  return u;
}
function normalizePropsOptions(e, n, o = !1) {
  const u = n.propsCache, c = u.get(e);
  if (c)
    return c;
  const d = e.props, m = {}, v = [];
  let S = !1;
  if (!isFunction$7(e)) {
    const E = (O) => {
      S = !0;
      const [T, y] = normalizePropsOptions(O, n, !0);
      extend$5(m, T), y && v.push(...y);
    };
    !o && n.mixins.length && n.mixins.forEach(E), e.extends && E(e.extends), e.mixins && e.mixins.forEach(E);
  }
  if (!d && !S)
    return isObject$8(e) && u.set(e, EMPTY_ARR), EMPTY_ARR;
  if (isArray$7(d))
    for (let E = 0; E < d.length; E++) {
      browser$1$1.env.NODE_ENV !== "production" && !isString$5(d[E]) && warn("props must be strings when using array syntax.", d[E]);
      const O = camelize(d[E]);
      validatePropName(O) && (m[O] = EMPTY_OBJ);
    }
  else if (d) {
    browser$1$1.env.NODE_ENV !== "production" && !isObject$8(d) && warn("invalid props options", d);
    for (const E in d) {
      const O = camelize(E);
      if (validatePropName(O)) {
        const T = d[E], y = m[O] = isArray$7(T) || isFunction$7(T) ? { type: T } : extend$5({}, T);
        if (y) {
          const V = getTypeIndex(Boolean, y.type), M = getTypeIndex(String, y.type);
          y[
            0
            /* shouldCast */
          ] = V > -1, y[
            1
            /* shouldCastTrue */
          ] = M < 0 || V < M, (V > -1 || hasOwn$1(y, "default")) && v.push(O);
        }
      }
    }
  }
  const $ = [m, v];
  return isObject$8(e) && u.set(e, $), $;
}
function validatePropName(e) {
  return e[0] !== "$" ? !0 : (browser$1$1.env.NODE_ENV !== "production" && warn(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function getType(e) {
  const n = e && e.toString().match(/^\s*(function|class) (\w+)/);
  return n ? n[2] : e === null ? "null" : "";
}
function isSameType(e, n) {
  return getType(e) === getType(n);
}
function getTypeIndex(e, n) {
  return isArray$7(n) ? n.findIndex((o) => isSameType(o, e)) : isFunction$7(n) && isSameType(n, e) ? 0 : -1;
}
function validateProps(e, n, o) {
  const u = toRaw(n), c = o.propsOptions[0];
  for (const d in c) {
    let m = c[d];
    m != null && validateProp(
      d,
      u[d],
      m,
      !hasOwn$1(e, d) && !hasOwn$1(e, hyphenate(d))
    );
  }
}
function validateProp(e, n, o, u) {
  const { type: c, required: d, validator: m, skipCheck: v } = o;
  if (d && u) {
    warn('Missing required prop: "' + e + '"');
    return;
  }
  if (!(n == null && !d)) {
    if (c != null && c !== !0 && !v) {
      let S = !1;
      const $ = isArray$7(c) ? c : [c], E = [];
      for (let O = 0; O < $.length && !S; O++) {
        const { valid: T, expectedType: y } = assertType(n, $[O]);
        E.push(y || ""), S = T;
      }
      if (!S) {
        warn(getInvalidTypeMessage(e, n, E));
        return;
      }
    }
    m && !m(n) && warn('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const isSimpleType = /* @__PURE__ */ makeMap(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function assertType(e, n) {
  let o;
  const u = getType(n);
  if (isSimpleType(u)) {
    const c = typeof e;
    o = c === u.toLowerCase(), !o && c === "object" && (o = e instanceof n);
  } else
    u === "Object" ? o = isObject$8(e) : u === "Array" ? o = isArray$7(e) : u === "null" ? o = e === null : o = e instanceof n;
  return {
    valid: o,
    expectedType: u
  };
}
function getInvalidTypeMessage(e, n, o) {
  let u = `Invalid prop: type check failed for prop "${e}". Expected ${o.map(capitalize).join(" | ")}`;
  const c = o[0], d = toRawType(n), m = styleValue(n, c), v = styleValue(n, d);
  return o.length === 1 && isExplicable(c) && !isBoolean$3(c, d) && (u += ` with value ${m}`), u += `, got ${d} `, isExplicable(d) && (u += `with value ${v}.`), u;
}
function styleValue(e, n) {
  return n === "String" ? `"${e}"` : n === "Number" ? `${Number(e)}` : `${e}`;
}
function isExplicable(e) {
  return ["string", "number", "boolean"].some((o) => e.toLowerCase() === o);
}
function isBoolean$3(...e) {
  return e.some((n) => n.toLowerCase() === "boolean");
}
const isInternalKey = (e) => e[0] === "_" || e === "$stable", normalizeSlotValue = (e) => isArray$7(e) ? e.map(normalizeVNode) : [normalizeVNode(e)], normalizeSlot = (e, n, o) => {
  if (n._n)
    return n;
  const u = withCtx((...c) => (browser$1$1.env.NODE_ENV !== "production" && currentInstance && warn(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), normalizeSlotValue(n(...c))), o);
  return u._c = !1, u;
}, normalizeObjectSlots = (e, n, o) => {
  const u = e._ctx;
  for (const c in e) {
    if (isInternalKey(c))
      continue;
    const d = e[c];
    if (isFunction$7(d))
      n[c] = normalizeSlot(c, d, u);
    else if (d != null) {
      browser$1$1.env.NODE_ENV !== "production" && warn(
        `Non-function value encountered for slot "${c}". Prefer function slots for better performance.`
      );
      const m = normalizeSlotValue(d);
      n[c] = () => m;
    }
  }
}, normalizeVNodeSlots = (e, n) => {
  browser$1$1.env.NODE_ENV !== "production" && !isKeepAlive(e.vnode) && warn(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const o = normalizeSlotValue(n);
  e.slots.default = () => o;
}, initSlots = (e, n) => {
  if (e.vnode.shapeFlag & 32) {
    const o = n._;
    o ? (e.slots = toRaw(n), def(n, "_", o)) : normalizeObjectSlots(
      n,
      e.slots = {}
    );
  } else
    e.slots = {}, n && normalizeVNodeSlots(e, n);
  def(e.slots, InternalObjectKey, 1);
}, updateSlots = (e, n, o) => {
  const { vnode: u, slots: c } = e;
  let d = !0, m = EMPTY_OBJ;
  if (u.shapeFlag & 32) {
    const v = n._;
    v ? browser$1$1.env.NODE_ENV !== "production" && isHmrUpdating ? (extend$5(c, n), trigger(e, "set", "$slots")) : o && v === 1 ? d = !1 : (extend$5(c, n), !o && v === 1 && delete c._) : (d = !n.$stable, normalizeObjectSlots(n, c)), m = n;
  } else
    n && (normalizeVNodeSlots(e, n), m = { default: 1 });
  if (d)
    for (const v in c)
      !isInternalKey(v) && !(v in m) && delete c[v];
};
function setRef(e, n, o, u, c = !1) {
  if (isArray$7(e)) {
    e.forEach(
      (T, y) => setRef(
        T,
        n && (isArray$7(n) ? n[y] : n),
        o,
        u,
        c
      )
    );
    return;
  }
  if (isAsyncWrapper(u) && !c)
    return;
  const d = u.shapeFlag & 4 ? getExposeProxy(u.component) || u.component.proxy : u.el, m = c ? null : d, { i: v, r: S } = e;
  if (browser$1$1.env.NODE_ENV !== "production" && !v) {
    warn(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const $ = n && n.r, E = v.refs === EMPTY_OBJ ? v.refs = {} : v.refs, O = v.setupState;
  if ($ != null && $ !== S && (isString$5($) ? (E[$] = null, hasOwn$1(O, $) && (O[$] = null)) : isRef($) && ($.value = null)), isFunction$7(S))
    callWithErrorHandling(S, v, 12, [m, E]);
  else {
    const T = isString$5(S), y = isRef(S);
    if (T || y) {
      const V = () => {
        if (e.f) {
          const M = T ? hasOwn$1(O, S) ? O[S] : E[S] : S.value;
          c ? isArray$7(M) && remove(M, d) : isArray$7(M) ? M.includes(d) || M.push(d) : T ? (E[S] = [d], hasOwn$1(O, S) && (O[S] = E[S])) : (S.value = [d], e.k && (E[e.k] = S.value));
        } else
          T ? (E[S] = m, hasOwn$1(O, S) && (O[S] = m)) : y ? (S.value = m, e.k && (E[e.k] = m)) : browser$1$1.env.NODE_ENV !== "production" && warn("Invalid template ref type:", S, `(${typeof S})`);
      };
      m ? (V.id = -1, queuePostRenderEffect(V, o)) : V();
    } else
      browser$1$1.env.NODE_ENV !== "production" && warn("Invalid template ref type:", S, `(${typeof S})`);
  }
}
let hasMismatch = !1;
const isSVGContainer = (e) => /svg/.test(e.namespaceURI) && e.tagName !== "foreignObject", isComment = (e) => e.nodeType === 8;
function createHydrationFunctions(e) {
  const {
    mt: n,
    p: o,
    o: {
      patchProp: u,
      createText: c,
      nextSibling: d,
      parentNode: m,
      remove: v,
      insert: S,
      createComment: $
    }
  } = e, E = (k, F) => {
    if (!F.hasChildNodes()) {
      browser$1$1.env.NODE_ENV !== "production" && warn(
        "Attempting to hydrate existing markup but container is empty. Performing full mount instead."
      ), o(null, k, F), flushPostFlushCbs(), F._vnode = k;
      return;
    }
    hasMismatch = !1, O(F.firstChild, k, null, null, null), flushPostFlushCbs(), F._vnode = k, hasMismatch && console.error("Hydration completed but contains mismatches.");
  }, O = (k, F, X, ee, ue, Q = !1) => {
    const Y = isComment(k) && k.data === "[", pe = () => M(
      k,
      F,
      X,
      ee,
      ue,
      Y
    ), { type: oe, ref: ne, shapeFlag: H, patchFlag: C } = F;
    let w = k.nodeType;
    F.el = k, C === -2 && (Q = !1, F.dynamicChildren = null);
    let P = null;
    switch (oe) {
      case Text$1:
        w !== 3 ? F.children === "" ? (S(F.el = c(""), m(k), k), P = k) : P = pe() : (k.data !== F.children && (hasMismatch = !0, browser$1$1.env.NODE_ENV !== "production" && warn(
          `Hydration text mismatch:
- Client: ${JSON.stringify(k.data)}
- Server: ${JSON.stringify(F.children)}`
        ), k.data = F.children), P = d(k));
        break;
      case Comment:
        w !== 8 || Y ? P = pe() : P = d(k);
        break;
      case Static:
        if (Y && (k = d(k), w = k.nodeType), w === 1 || w === 3) {
          P = k;
          const J = !F.children.length;
          for (let se = 0; se < F.staticCount; se++)
            J && (F.children += P.nodeType === 1 ? P.outerHTML : P.data), se === F.staticCount - 1 && (F.anchor = P), P = d(P);
          return Y ? d(P) : P;
        } else
          pe();
        break;
      case Fragment:
        Y ? P = V(
          k,
          F,
          X,
          ee,
          ue,
          Q
        ) : P = pe();
        break;
      default:
        if (H & 1)
          w !== 1 || F.type.toLowerCase() !== k.tagName.toLowerCase() ? P = pe() : P = T(
            k,
            F,
            X,
            ee,
            ue,
            Q
          );
        else if (H & 6) {
          F.slotScopeIds = ue;
          const J = m(k);
          if (n(
            F,
            J,
            null,
            X,
            ee,
            isSVGContainer(J),
            Q
          ), P = Y ? G(k) : d(k), P && isComment(P) && P.data === "teleport end" && (P = d(P)), isAsyncWrapper(F)) {
            let se;
            Y ? (se = createVNode(Fragment), se.anchor = P ? P.previousSibling : J.lastChild) : se = k.nodeType === 3 ? createTextVNode("") : createVNode("div"), se.el = k, F.component.subTree = se;
          }
        } else
          H & 64 ? w !== 8 ? P = pe() : P = F.type.hydrate(
            k,
            F,
            X,
            ee,
            ue,
            Q,
            e,
            y
          ) : H & 128 ? P = F.type.hydrate(
            k,
            F,
            X,
            ee,
            isSVGContainer(m(k)),
            ue,
            Q,
            e,
            O
          ) : browser$1$1.env.NODE_ENV !== "production" && warn("Invalid HostVNode type:", oe, `(${typeof oe})`);
    }
    return ne != null && setRef(ne, null, ee, F), P;
  }, T = (k, F, X, ee, ue, Q) => {
    Q = Q || !!F.dynamicChildren;
    const { type: Y, props: pe, patchFlag: oe, shapeFlag: ne, dirs: H } = F, C = Y === "input" && H || Y === "option";
    if (browser$1$1.env.NODE_ENV !== "production" || C || oe !== -1) {
      if (H && invokeDirectiveHook(F, null, X, "created"), pe)
        if (C || !Q || oe & 48)
          for (const P in pe)
            (C && P.endsWith("value") || isOn(P) && !isReservedProp(P)) && u(
              k,
              P,
              null,
              pe[P],
              !1,
              void 0,
              X
            );
        else
          pe.onClick && u(
            k,
            "onClick",
            null,
            pe.onClick,
            !1,
            void 0,
            X
          );
      let w;
      if ((w = pe && pe.onVnodeBeforeMount) && invokeVNodeHook(w, X, F), H && invokeDirectiveHook(F, null, X, "beforeMount"), ((w = pe && pe.onVnodeMounted) || H) && queueEffectWithSuspense(() => {
        w && invokeVNodeHook(w, X, F), H && invokeDirectiveHook(F, null, X, "mounted");
      }, ee), ne & 16 && // skip if element has innerHTML / textContent
      !(pe && (pe.innerHTML || pe.textContent))) {
        let P = y(
          k.firstChild,
          F,
          k,
          X,
          ee,
          ue,
          Q
        ), J = !1;
        for (; P; ) {
          hasMismatch = !0, browser$1$1.env.NODE_ENV !== "production" && !J && (warn(
            `Hydration children mismatch in <${F.type}>: server rendered element contains more child nodes than client vdom.`
          ), J = !0);
          const se = P;
          P = P.nextSibling, v(se);
        }
      } else
        ne & 8 && k.textContent !== F.children && (hasMismatch = !0, browser$1$1.env.NODE_ENV !== "production" && warn(
          `Hydration text content mismatch in <${F.type}>:
- Client: ${k.textContent}
- Server: ${F.children}`
        ), k.textContent = F.children);
    }
    return k.nextSibling;
  }, y = (k, F, X, ee, ue, Q, Y) => {
    Y = Y || !!F.dynamicChildren;
    const pe = F.children, oe = pe.length;
    let ne = !1;
    for (let H = 0; H < oe; H++) {
      const C = Y ? pe[H] : pe[H] = normalizeVNode(pe[H]);
      if (k)
        k = O(
          k,
          C,
          ee,
          ue,
          Q,
          Y
        );
      else {
        if (C.type === Text$1 && !C.children)
          continue;
        hasMismatch = !0, browser$1$1.env.NODE_ENV !== "production" && !ne && (warn(
          `Hydration children mismatch in <${X.tagName.toLowerCase()}>: server rendered element contains fewer child nodes than client vdom.`
        ), ne = !0), o(
          null,
          C,
          X,
          null,
          ee,
          ue,
          isSVGContainer(X),
          Q
        );
      }
    }
    return k;
  }, V = (k, F, X, ee, ue, Q) => {
    const { slotScopeIds: Y } = F;
    Y && (ue = ue ? ue.concat(Y) : Y);
    const pe = m(k), oe = y(
      d(k),
      F,
      pe,
      X,
      ee,
      ue,
      Q
    );
    return oe && isComment(oe) && oe.data === "]" ? d(F.anchor = oe) : (hasMismatch = !0, S(F.anchor = $("]"), pe, oe), oe);
  }, M = (k, F, X, ee, ue, Q) => {
    if (hasMismatch = !0, browser$1$1.env.NODE_ENV !== "production" && warn(
      `Hydration node mismatch:
- Client vnode:`,
      F.type,
      `
- Server rendered DOM:`,
      k,
      k.nodeType === 3 ? "(text)" : isComment(k) && k.data === "[" ? "(start of fragment)" : ""
    ), F.el = null, Q) {
      const oe = G(k);
      for (; ; ) {
        const ne = d(k);
        if (ne && ne !== oe)
          v(ne);
        else
          break;
      }
    }
    const Y = d(k), pe = m(k);
    return v(k), o(
      null,
      F,
      pe,
      Y,
      X,
      ee,
      isSVGContainer(pe),
      ue
    ), Y;
  }, G = (k) => {
    let F = 0;
    for (; k; )
      if (k = d(k), k && isComment(k) && (k.data === "[" && F++, k.data === "]")) {
        if (F === 0)
          return d(k);
        F--;
      }
    return k;
  };
  return [E, O];
}
let supported, perf;
function startMeasure(e, n) {
  e.appContext.config.performance && isSupported$1() && perf.mark(`vue-${n}-${e.uid}`), browser$1$1.env.NODE_ENV !== "production" && devtoolsPerfStart(e, n, isSupported$1() ? perf.now() : Date.now());
}
function endMeasure(e, n) {
  if (e.appContext.config.performance && isSupported$1()) {
    const o = `vue-${n}-${e.uid}`, u = o + ":end";
    perf.mark(u), perf.measure(
      `<${formatComponentName(e, e.type)}> ${n}`,
      o,
      u
    ), perf.clearMarks(o), perf.clearMarks(u);
  }
  browser$1$1.env.NODE_ENV !== "production" && devtoolsPerfEnd(e, n, isSupported$1() ? perf.now() : Date.now());
}
function isSupported$1() {
  return supported !== void 0 || (typeof window < "u" && window.performance ? (supported = !0, perf = window.performance) : supported = !1), supported;
}
function initFeatureFlags() {
  const e = [];
  if (browser$1$1.env.NODE_ENV !== "production" && e.length) {
    const n = e.length > 1;
    console.warn(
      `Feature flag${n ? "s" : ""} ${e.join(", ")} ${n ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(e) {
  return baseCreateRenderer(e);
}
function createHydrationRenderer(e) {
  return baseCreateRenderer(e, createHydrationFunctions);
}
function baseCreateRenderer(e, n) {
  initFeatureFlags();
  const o = getGlobalThis();
  o.__VUE__ = !0, browser$1$1.env.NODE_ENV !== "production" && setDevtoolsHook(o.__VUE_DEVTOOLS_GLOBAL_HOOK__, o);
  const {
    insert: u,
    remove: c,
    patchProp: d,
    createElement: m,
    createText: v,
    createComment: S,
    setText: $,
    setElementText: E,
    parentNode: O,
    nextSibling: T,
    setScopeId: y = NOOP,
    insertStaticContent: V
  } = e, M = (at, kt, Ut, dn = null, En = null, Ht = null, Xt = !1, On = null, sn = browser$1$1.env.NODE_ENV !== "production" && isHmrUpdating ? !1 : !!kt.dynamicChildren) => {
    if (at === kt)
      return;
    at && !isSameVNodeType(at, kt) && (dn = Qt(at), Pe(at, En, Ht, !0), at = null), kt.patchFlag === -2 && (sn = !1, kt.dynamicChildren = null);
    const { type: At, ref: hn, shapeFlag: $t } = kt;
    switch (At) {
      case Text$1:
        G(at, kt, Ut, dn);
        break;
      case Comment:
        k(at, kt, Ut, dn);
        break;
      case Static:
        at == null ? F(kt, Ut, dn, Xt) : browser$1$1.env.NODE_ENV !== "production" && X(at, kt, Ut, Xt);
        break;
      case Fragment:
        w(
          at,
          kt,
          Ut,
          dn,
          En,
          Ht,
          Xt,
          On,
          sn
        );
        break;
      default:
        $t & 1 ? Q(
          at,
          kt,
          Ut,
          dn,
          En,
          Ht,
          Xt,
          On,
          sn
        ) : $t & 6 ? P(
          at,
          kt,
          Ut,
          dn,
          En,
          Ht,
          Xt,
          On,
          sn
        ) : $t & 64 || $t & 128 ? At.process(
          at,
          kt,
          Ut,
          dn,
          En,
          Ht,
          Xt,
          On,
          sn,
          zt
        ) : browser$1$1.env.NODE_ENV !== "production" && warn("Invalid VNode type:", At, `(${typeof At})`);
    }
    hn != null && En && setRef(hn, at && at.ref, Ht, kt || at, !kt);
  }, G = (at, kt, Ut, dn) => {
    if (at == null)
      u(
        kt.el = v(kt.children),
        Ut,
        dn
      );
    else {
      const En = kt.el = at.el;
      kt.children !== at.children && $(En, kt.children);
    }
  }, k = (at, kt, Ut, dn) => {
    at == null ? u(
      kt.el = S(kt.children || ""),
      Ut,
      dn
    ) : kt.el = at.el;
  }, F = (at, kt, Ut, dn) => {
    [at.el, at.anchor] = V(
      at.children,
      kt,
      Ut,
      dn,
      at.el,
      at.anchor
    );
  }, X = (at, kt, Ut, dn) => {
    if (kt.children !== at.children) {
      const En = T(at.anchor);
      ue(at), [kt.el, kt.anchor] = V(
        kt.children,
        Ut,
        En,
        dn
      );
    } else
      kt.el = at.el, kt.anchor = at.anchor;
  }, ee = ({ el: at, anchor: kt }, Ut, dn) => {
    let En;
    for (; at && at !== kt; )
      En = T(at), u(at, Ut, dn), at = En;
    u(kt, Ut, dn);
  }, ue = ({ el: at, anchor: kt }) => {
    let Ut;
    for (; at && at !== kt; )
      Ut = T(at), c(at), at = Ut;
    c(kt);
  }, Q = (at, kt, Ut, dn, En, Ht, Xt, On, sn) => {
    Xt = Xt || kt.type === "svg", at == null ? Y(
      kt,
      Ut,
      dn,
      En,
      Ht,
      Xt,
      On,
      sn
    ) : ne(
      at,
      kt,
      En,
      Ht,
      Xt,
      On,
      sn
    );
  }, Y = (at, kt, Ut, dn, En, Ht, Xt, On) => {
    let sn, At;
    const { type: hn, props: $t, shapeFlag: Lt, transition: Qn, dirs: ce } = at;
    if (sn = at.el = m(
      at.type,
      Ht,
      $t && $t.is,
      $t
    ), Lt & 8 ? E(sn, at.children) : Lt & 16 && oe(
      at.children,
      sn,
      null,
      dn,
      En,
      Ht && hn !== "foreignObject",
      Xt,
      On
    ), ce && invokeDirectiveHook(at, null, dn, "created"), pe(sn, at, at.scopeId, Xt, dn), $t) {
      for (const ft in $t)
        ft !== "value" && !isReservedProp(ft) && d(
          sn,
          ft,
          null,
          $t[ft],
          Ht,
          at.children,
          dn,
          En,
          nt
        );
      "value" in $t && d(sn, "value", null, $t.value), (At = $t.onVnodeBeforeMount) && invokeVNodeHook(At, dn, at);
    }
    browser$1$1.env.NODE_ENV !== "production" && (Object.defineProperty(sn, "__vnode", {
      value: at,
      enumerable: !1
    }), Object.defineProperty(sn, "__vueParentComponent", {
      value: dn,
      enumerable: !1
    })), ce && invokeDirectiveHook(at, null, dn, "beforeMount");
    const Ze = (!En || En && !En.pendingBranch) && Qn && !Qn.persisted;
    Ze && Qn.beforeEnter(sn), u(sn, kt, Ut), ((At = $t && $t.onVnodeMounted) || Ze || ce) && queuePostRenderEffect(() => {
      At && invokeVNodeHook(At, dn, at), Ze && Qn.enter(sn), ce && invokeDirectiveHook(at, null, dn, "mounted");
    }, En);
  }, pe = (at, kt, Ut, dn, En) => {
    if (Ut && y(at, Ut), dn)
      for (let Ht = 0; Ht < dn.length; Ht++)
        y(at, dn[Ht]);
    if (En) {
      let Ht = En.subTree;
      if (browser$1$1.env.NODE_ENV !== "production" && Ht.patchFlag > 0 && Ht.patchFlag & 2048 && (Ht = filterSingleRoot(Ht.children) || Ht), kt === Ht) {
        const Xt = En.vnode;
        pe(
          at,
          Xt,
          Xt.scopeId,
          Xt.slotScopeIds,
          En.parent
        );
      }
    }
  }, oe = (at, kt, Ut, dn, En, Ht, Xt, On, sn = 0) => {
    for (let At = sn; At < at.length; At++) {
      const hn = at[At] = On ? cloneIfMounted(at[At]) : normalizeVNode(at[At]);
      M(
        null,
        hn,
        kt,
        Ut,
        dn,
        En,
        Ht,
        Xt,
        On
      );
    }
  }, ne = (at, kt, Ut, dn, En, Ht, Xt) => {
    const On = kt.el = at.el;
    let { patchFlag: sn, dynamicChildren: At, dirs: hn } = kt;
    sn |= at.patchFlag & 16;
    const $t = at.props || EMPTY_OBJ, Lt = kt.props || EMPTY_OBJ;
    let Qn;
    Ut && toggleRecurse(Ut, !1), (Qn = Lt.onVnodeBeforeUpdate) && invokeVNodeHook(Qn, Ut, kt, at), hn && invokeDirectiveHook(kt, at, Ut, "beforeUpdate"), Ut && toggleRecurse(Ut, !0), browser$1$1.env.NODE_ENV !== "production" && isHmrUpdating && (sn = 0, Xt = !1, At = null);
    const ce = En && kt.type !== "foreignObject";
    if (At ? (H(
      at.dynamicChildren,
      At,
      On,
      Ut,
      dn,
      ce,
      Ht
    ), browser$1$1.env.NODE_ENV !== "production" && traverseStaticChildren(at, kt)) : Xt || W(
      at,
      kt,
      On,
      null,
      Ut,
      dn,
      ce,
      Ht,
      !1
    ), sn > 0) {
      if (sn & 16)
        C(
          On,
          kt,
          $t,
          Lt,
          Ut,
          dn,
          En
        );
      else if (sn & 2 && $t.class !== Lt.class && d(On, "class", null, Lt.class, En), sn & 4 && d(On, "style", $t.style, Lt.style, En), sn & 8) {
        const Ze = kt.dynamicProps;
        for (let ft = 0; ft < Ze.length; ft++) {
          const It = Ze[ft], rn = $t[It], Ln = Lt[It];
          (Ln !== rn || It === "value") && d(
            On,
            It,
            rn,
            Ln,
            En,
            at.children,
            Ut,
            dn,
            nt
          );
        }
      }
      sn & 1 && at.children !== kt.children && E(On, kt.children);
    } else
      !Xt && At == null && C(
        On,
        kt,
        $t,
        Lt,
        Ut,
        dn,
        En
      );
    ((Qn = Lt.onVnodeUpdated) || hn) && queuePostRenderEffect(() => {
      Qn && invokeVNodeHook(Qn, Ut, kt, at), hn && invokeDirectiveHook(kt, at, Ut, "updated");
    }, dn);
  }, H = (at, kt, Ut, dn, En, Ht, Xt) => {
    for (let On = 0; On < kt.length; On++) {
      const sn = at[On], At = kt[On], hn = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        sn.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (sn.type === Fragment || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !isSameVNodeType(sn, At) || // - In the case of a component, it could contain anything.
        sn.shapeFlag & 70) ? O(sn.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          Ut
        )
      );
      M(
        sn,
        At,
        hn,
        null,
        dn,
        En,
        Ht,
        Xt,
        !0
      );
    }
  }, C = (at, kt, Ut, dn, En, Ht, Xt) => {
    if (Ut !== dn) {
      if (Ut !== EMPTY_OBJ)
        for (const On in Ut)
          !isReservedProp(On) && !(On in dn) && d(
            at,
            On,
            Ut[On],
            null,
            Xt,
            kt.children,
            En,
            Ht,
            nt
          );
      for (const On in dn) {
        if (isReservedProp(On))
          continue;
        const sn = dn[On], At = Ut[On];
        sn !== At && On !== "value" && d(
          at,
          On,
          At,
          sn,
          Xt,
          kt.children,
          En,
          Ht,
          nt
        );
      }
      "value" in dn && d(at, "value", Ut.value, dn.value);
    }
  }, w = (at, kt, Ut, dn, En, Ht, Xt, On, sn) => {
    const At = kt.el = at ? at.el : v(""), hn = kt.anchor = at ? at.anchor : v("");
    let { patchFlag: $t, dynamicChildren: Lt, slotScopeIds: Qn } = kt;
    browser$1$1.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (isHmrUpdating || $t & 2048) && ($t = 0, sn = !1, Lt = null), Qn && (On = On ? On.concat(Qn) : Qn), at == null ? (u(At, Ut, dn), u(hn, Ut, dn), oe(
      kt.children,
      Ut,
      hn,
      En,
      Ht,
      Xt,
      On,
      sn
    )) : $t > 0 && $t & 64 && Lt && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    at.dynamicChildren ? (H(
      at.dynamicChildren,
      Lt,
      Ut,
      En,
      Ht,
      Xt,
      On
    ), browser$1$1.env.NODE_ENV !== "production" ? traverseStaticChildren(at, kt) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (kt.key != null || En && kt === En.subTree) && traverseStaticChildren(
        at,
        kt,
        !0
        /* shallow */
      )
    )) : W(
      at,
      kt,
      Ut,
      hn,
      En,
      Ht,
      Xt,
      On,
      sn
    );
  }, P = (at, kt, Ut, dn, En, Ht, Xt, On, sn) => {
    kt.slotScopeIds = On, at == null ? kt.shapeFlag & 512 ? En.ctx.activate(
      kt,
      Ut,
      dn,
      Xt,
      sn
    ) : J(
      kt,
      Ut,
      dn,
      En,
      Ht,
      Xt,
      sn
    ) : se(at, kt, sn);
  }, J = (at, kt, Ut, dn, En, Ht, Xt) => {
    const On = at.component = createComponentInstance(
      at,
      dn,
      En
    );
    if (browser$1$1.env.NODE_ENV !== "production" && On.type.__hmrId && registerHMR(On), browser$1$1.env.NODE_ENV !== "production" && (pushWarningContext(at), startMeasure(On, "mount")), isKeepAlive(at) && (On.ctx.renderer = zt), browser$1$1.env.NODE_ENV !== "production" && startMeasure(On, "init"), setupComponent(On), browser$1$1.env.NODE_ENV !== "production" && endMeasure(On, "init"), On.asyncDep) {
      if (En && En.registerDep(On, fe), !at.el) {
        const sn = On.subTree = createVNode(Comment);
        k(null, sn, kt, Ut);
      }
      return;
    }
    fe(
      On,
      at,
      kt,
      Ut,
      En,
      Ht,
      Xt
    ), browser$1$1.env.NODE_ENV !== "production" && (popWarningContext(), endMeasure(On, "mount"));
  }, se = (at, kt, Ut) => {
    const dn = kt.component = at.component;
    if (shouldUpdateComponent(at, kt, Ut))
      if (dn.asyncDep && !dn.asyncResolved) {
        browser$1$1.env.NODE_ENV !== "production" && pushWarningContext(kt), N(dn, kt, Ut), browser$1$1.env.NODE_ENV !== "production" && popWarningContext();
        return;
      } else
        dn.next = kt, invalidateJob(dn.update), dn.update();
    else
      kt.el = at.el, dn.vnode = kt;
  }, fe = (at, kt, Ut, dn, En, Ht, Xt) => {
    const On = () => {
      if (at.isMounted) {
        let { next: hn, bu: $t, u: Lt, parent: Qn, vnode: ce } = at, Ze = hn, ft;
        browser$1$1.env.NODE_ENV !== "production" && pushWarningContext(hn || at.vnode), toggleRecurse(at, !1), hn ? (hn.el = ce.el, N(at, hn, Xt)) : hn = ce, $t && invokeArrayFns($t), (ft = hn.props && hn.props.onVnodeBeforeUpdate) && invokeVNodeHook(ft, Qn, hn, ce), toggleRecurse(at, !0), browser$1$1.env.NODE_ENV !== "production" && startMeasure(at, "render");
        const It = renderComponentRoot(at);
        browser$1$1.env.NODE_ENV !== "production" && endMeasure(at, "render");
        const rn = at.subTree;
        at.subTree = It, browser$1$1.env.NODE_ENV !== "production" && startMeasure(at, "patch"), M(
          rn,
          It,
          // parent may have changed if it's in a teleport
          O(rn.el),
          // anchor may have changed if it's in a fragment
          Qt(rn),
          at,
          En,
          Ht
        ), browser$1$1.env.NODE_ENV !== "production" && endMeasure(at, "patch"), hn.el = It.el, Ze === null && updateHOCHostEl(at, It.el), Lt && queuePostRenderEffect(Lt, En), (ft = hn.props && hn.props.onVnodeUpdated) && queuePostRenderEffect(
          () => invokeVNodeHook(ft, Qn, hn, ce),
          En
        ), browser$1$1.env.NODE_ENV !== "production" && devtoolsComponentUpdated(at), browser$1$1.env.NODE_ENV !== "production" && popWarningContext();
      } else {
        let hn;
        const { el: $t, props: Lt } = kt, { bm: Qn, m: ce, parent: Ze } = at, ft = isAsyncWrapper(kt);
        if (toggleRecurse(at, !1), Qn && invokeArrayFns(Qn), !ft && (hn = Lt && Lt.onVnodeBeforeMount) && invokeVNodeHook(hn, Ze, kt), toggleRecurse(at, !0), $t && pt) {
          const It = () => {
            browser$1$1.env.NODE_ENV !== "production" && startMeasure(at, "render"), at.subTree = renderComponentRoot(at), browser$1$1.env.NODE_ENV !== "production" && endMeasure(at, "render"), browser$1$1.env.NODE_ENV !== "production" && startMeasure(at, "hydrate"), pt(
              $t,
              at.subTree,
              at,
              En,
              null
            ), browser$1$1.env.NODE_ENV !== "production" && endMeasure(at, "hydrate");
          };
          ft ? kt.type.__asyncLoader().then(
            // note: we are moving the render call into an async callback,
            // which means it won't track dependencies - but it's ok because
            // a server-rendered async wrapper is already in resolved state
            // and it will never need to change.
            () => !at.isUnmounted && It()
          ) : It();
        } else {
          browser$1$1.env.NODE_ENV !== "production" && startMeasure(at, "render");
          const It = at.subTree = renderComponentRoot(at);
          browser$1$1.env.NODE_ENV !== "production" && endMeasure(at, "render"), browser$1$1.env.NODE_ENV !== "production" && startMeasure(at, "patch"), M(
            null,
            It,
            Ut,
            dn,
            at,
            En,
            Ht
          ), browser$1$1.env.NODE_ENV !== "production" && endMeasure(at, "patch"), kt.el = It.el;
        }
        if (ce && queuePostRenderEffect(ce, En), !ft && (hn = Lt && Lt.onVnodeMounted)) {
          const It = kt;
          queuePostRenderEffect(
            () => invokeVNodeHook(hn, Ze, It),
            En
          );
        }
        (kt.shapeFlag & 256 || Ze && isAsyncWrapper(Ze.vnode) && Ze.vnode.shapeFlag & 256) && at.a && queuePostRenderEffect(at.a, En), at.isMounted = !0, browser$1$1.env.NODE_ENV !== "production" && devtoolsComponentAdded(at), kt = Ut = dn = null;
      }
    }, sn = at.effect = new ReactiveEffect(
      On,
      () => queueJob(At),
      at.scope
      // track it in component's effect scope
    ), At = at.update = () => sn.run();
    At.id = at.uid, toggleRecurse(at, !0), browser$1$1.env.NODE_ENV !== "production" && (sn.onTrack = at.rtc ? (hn) => invokeArrayFns(at.rtc, hn) : void 0, sn.onTrigger = at.rtg ? (hn) => invokeArrayFns(at.rtg, hn) : void 0, At.ownerInstance = at), At();
  }, N = (at, kt, Ut) => {
    kt.component = at;
    const dn = at.vnode.props;
    at.vnode = kt, at.next = null, updateProps(at, kt.props, dn, Ut), updateSlots(at, kt.children, Ut), pauseTracking(), flushPreFlushCbs(), resetTracking();
  }, W = (at, kt, Ut, dn, En, Ht, Xt, On, sn = !1) => {
    const At = at && at.children, hn = at ? at.shapeFlag : 0, $t = kt.children, { patchFlag: Lt, shapeFlag: Qn } = kt;
    if (Lt > 0) {
      if (Lt & 128) {
        te(
          At,
          $t,
          Ut,
          dn,
          En,
          Ht,
          Xt,
          On,
          sn
        );
        return;
      } else if (Lt & 256) {
        I(
          At,
          $t,
          Ut,
          dn,
          En,
          Ht,
          Xt,
          On,
          sn
        );
        return;
      }
    }
    Qn & 8 ? (hn & 16 && nt(At, En, Ht), $t !== At && E(Ut, $t)) : hn & 16 ? Qn & 16 ? te(
      At,
      $t,
      Ut,
      dn,
      En,
      Ht,
      Xt,
      On,
      sn
    ) : nt(At, En, Ht, !0) : (hn & 8 && E(Ut, ""), Qn & 16 && oe(
      $t,
      Ut,
      dn,
      En,
      Ht,
      Xt,
      On,
      sn
    ));
  }, I = (at, kt, Ut, dn, En, Ht, Xt, On, sn) => {
    at = at || EMPTY_ARR, kt = kt || EMPTY_ARR;
    const At = at.length, hn = kt.length, $t = Math.min(At, hn);
    let Lt;
    for (Lt = 0; Lt < $t; Lt++) {
      const Qn = kt[Lt] = sn ? cloneIfMounted(kt[Lt]) : normalizeVNode(kt[Lt]);
      M(
        at[Lt],
        Qn,
        Ut,
        null,
        En,
        Ht,
        Xt,
        On,
        sn
      );
    }
    At > hn ? nt(
      at,
      En,
      Ht,
      !0,
      !1,
      $t
    ) : oe(
      kt,
      Ut,
      dn,
      En,
      Ht,
      Xt,
      On,
      sn,
      $t
    );
  }, te = (at, kt, Ut, dn, En, Ht, Xt, On, sn) => {
    let At = 0;
    const hn = kt.length;
    let $t = at.length - 1, Lt = hn - 1;
    for (; At <= $t && At <= Lt; ) {
      const Qn = at[At], ce = kt[At] = sn ? cloneIfMounted(kt[At]) : normalizeVNode(kt[At]);
      if (isSameVNodeType(Qn, ce))
        M(
          Qn,
          ce,
          Ut,
          null,
          En,
          Ht,
          Xt,
          On,
          sn
        );
      else
        break;
      At++;
    }
    for (; At <= $t && At <= Lt; ) {
      const Qn = at[$t], ce = kt[Lt] = sn ? cloneIfMounted(kt[Lt]) : normalizeVNode(kt[Lt]);
      if (isSameVNodeType(Qn, ce))
        M(
          Qn,
          ce,
          Ut,
          null,
          En,
          Ht,
          Xt,
          On,
          sn
        );
      else
        break;
      $t--, Lt--;
    }
    if (At > $t) {
      if (At <= Lt) {
        const Qn = Lt + 1, ce = Qn < hn ? kt[Qn].el : dn;
        for (; At <= Lt; )
          M(
            null,
            kt[At] = sn ? cloneIfMounted(kt[At]) : normalizeVNode(kt[At]),
            Ut,
            ce,
            En,
            Ht,
            Xt,
            On,
            sn
          ), At++;
      }
    } else if (At > Lt)
      for (; At <= $t; )
        Pe(at[At], En, Ht, !0), At++;
    else {
      const Qn = At, ce = At, Ze = /* @__PURE__ */ new Map();
      for (At = ce; At <= Lt; At++) {
        const He = kt[At] = sn ? cloneIfMounted(kt[At]) : normalizeVNode(kt[At]);
        He.key != null && (browser$1$1.env.NODE_ENV !== "production" && Ze.has(He.key) && warn(
          "Duplicate keys found during update:",
          JSON.stringify(He.key),
          "Make sure keys are unique."
        ), Ze.set(He.key, At));
      }
      let ft, It = 0;
      const rn = Lt - ce + 1;
      let Ln = !1, Pn = 0;
      const Ae = new Array(rn);
      for (At = 0; At < rn; At++)
        Ae[At] = 0;
      for (At = Qn; At <= $t; At++) {
        const He = at[At];
        if (It >= rn) {
          Pe(He, En, Ht, !0);
          continue;
        }
        let cn;
        if (He.key != null)
          cn = Ze.get(He.key);
        else
          for (ft = ce; ft <= Lt; ft++)
            if (Ae[ft - ce] === 0 && isSameVNodeType(He, kt[ft])) {
              cn = ft;
              break;
            }
        cn === void 0 ? Pe(He, En, Ht, !0) : (Ae[cn - ce] = At + 1, cn >= Pn ? Pn = cn : Ln = !0, M(
          He,
          kt[cn],
          Ut,
          null,
          En,
          Ht,
          Xt,
          On,
          sn
        ), It++);
      }
      const Me = Ln ? getSequence(Ae) : EMPTY_ARR;
      for (ft = Me.length - 1, At = rn - 1; At >= 0; At--) {
        const He = ce + At, cn = kt[He], Wt = He + 1 < hn ? kt[He + 1].el : dn;
        Ae[At] === 0 ? M(
          null,
          cn,
          Ut,
          Wt,
          En,
          Ht,
          Xt,
          On,
          sn
        ) : Ln && (ft < 0 || At !== Me[ft] ? ge(cn, Ut, Wt, 2) : ft--);
      }
    }
  }, ge = (at, kt, Ut, dn, En = null) => {
    const { el: Ht, type: Xt, transition: On, children: sn, shapeFlag: At } = at;
    if (At & 6) {
      ge(at.component.subTree, kt, Ut, dn);
      return;
    }
    if (At & 128) {
      at.suspense.move(kt, Ut, dn);
      return;
    }
    if (At & 64) {
      Xt.move(at, kt, Ut, zt);
      return;
    }
    if (Xt === Fragment) {
      u(Ht, kt, Ut);
      for (let $t = 0; $t < sn.length; $t++)
        ge(sn[$t], kt, Ut, dn);
      u(at.anchor, kt, Ut);
      return;
    }
    if (Xt === Static) {
      ee(at, kt, Ut);
      return;
    }
    if (dn !== 2 && At & 1 && On)
      if (dn === 0)
        On.beforeEnter(Ht), u(Ht, kt, Ut), queuePostRenderEffect(() => On.enter(Ht), En);
      else {
        const { leave: $t, delayLeave: Lt, afterLeave: Qn } = On, ce = () => u(Ht, kt, Ut), Ze = () => {
          $t(Ht, () => {
            ce(), Qn && Qn();
          });
        };
        Lt ? Lt(Ht, ce, Ze) : Ze();
      }
    else
      u(Ht, kt, Ut);
  }, Pe = (at, kt, Ut, dn = !1, En = !1) => {
    const {
      type: Ht,
      props: Xt,
      ref: On,
      children: sn,
      dynamicChildren: At,
      shapeFlag: hn,
      patchFlag: $t,
      dirs: Lt
    } = at;
    if (On != null && setRef(On, null, Ut, at, !0), hn & 256) {
      kt.ctx.deactivate(at);
      return;
    }
    const Qn = hn & 1 && Lt, ce = !isAsyncWrapper(at);
    let Ze;
    if (ce && (Ze = Xt && Xt.onVnodeBeforeUnmount) && invokeVNodeHook(Ze, kt, at), hn & 6)
      ze(at.component, Ut, dn);
    else {
      if (hn & 128) {
        at.suspense.unmount(Ut, dn);
        return;
      }
      Qn && invokeDirectiveHook(at, null, kt, "beforeUnmount"), hn & 64 ? at.type.remove(
        at,
        kt,
        Ut,
        En,
        zt,
        dn
      ) : At && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (Ht !== Fragment || $t > 0 && $t & 64) ? nt(
        At,
        kt,
        Ut,
        !1,
        !0
      ) : (Ht === Fragment && $t & 384 || !En && hn & 16) && nt(sn, kt, Ut), dn && Ke(at);
    }
    (ce && (Ze = Xt && Xt.onVnodeUnmounted) || Qn) && queuePostRenderEffect(() => {
      Ze && invokeVNodeHook(Ze, kt, at), Qn && invokeDirectiveHook(at, null, kt, "unmounted");
    }, Ut);
  }, Ke = (at) => {
    const { type: kt, el: Ut, anchor: dn, transition: En } = at;
    if (kt === Fragment) {
      browser$1$1.env.NODE_ENV !== "production" && at.patchFlag > 0 && at.patchFlag & 2048 && En && !En.persisted ? at.children.forEach((Xt) => {
        Xt.type === Comment ? c(Xt.el) : Ke(Xt);
      }) : xe(Ut, dn);
      return;
    }
    if (kt === Static) {
      ue(at);
      return;
    }
    const Ht = () => {
      c(Ut), En && !En.persisted && En.afterLeave && En.afterLeave();
    };
    if (at.shapeFlag & 1 && En && !En.persisted) {
      const { leave: Xt, delayLeave: On } = En, sn = () => Xt(Ut, Ht);
      On ? On(at.el, Ht, sn) : sn();
    } else
      Ht();
  }, xe = (at, kt) => {
    let Ut;
    for (; at !== kt; )
      Ut = T(at), c(at), at = Ut;
    c(kt);
  }, ze = (at, kt, Ut) => {
    browser$1$1.env.NODE_ENV !== "production" && at.type.__hmrId && unregisterHMR(at);
    const { bum: dn, scope: En, update: Ht, subTree: Xt, um: On } = at;
    dn && invokeArrayFns(dn), En.stop(), Ht && (Ht.active = !1, Pe(Xt, at, kt, Ut)), On && queuePostRenderEffect(On, kt), queuePostRenderEffect(() => {
      at.isUnmounted = !0;
    }, kt), kt && kt.pendingBranch && !kt.isUnmounted && at.asyncDep && !at.asyncResolved && at.suspenseId === kt.pendingId && (kt.deps--, kt.deps === 0 && kt.resolve()), browser$1$1.env.NODE_ENV !== "production" && devtoolsComponentRemoved(at);
  }, nt = (at, kt, Ut, dn = !1, En = !1, Ht = 0) => {
    for (let Xt = Ht; Xt < at.length; Xt++)
      Pe(at[Xt], kt, Ut, dn, En);
  }, Qt = (at) => at.shapeFlag & 6 ? Qt(at.component.subTree) : at.shapeFlag & 128 ? at.suspense.next() : T(at.anchor || at.el), Et = (at, kt, Ut) => {
    at == null ? kt._vnode && Pe(kt._vnode, null, null, !0) : M(kt._vnode || null, at, kt, null, null, null, Ut), flushPreFlushCbs(), flushPostFlushCbs(), kt._vnode = at;
  }, zt = {
    p: M,
    um: Pe,
    m: ge,
    r: Ke,
    mt: J,
    mc: oe,
    pc: W,
    pbc: H,
    n: Qt,
    o: e
  };
  let Nt, pt;
  return n && ([Nt, pt] = n(
    zt
  )), {
    render: Et,
    hydrate: Nt,
    createApp: createAppAPI(Et, Nt)
  };
}
function toggleRecurse({ effect: e, update: n }, o) {
  e.allowRecurse = n.allowRecurse = o;
}
function traverseStaticChildren(e, n, o = !1) {
  const u = e.children, c = n.children;
  if (isArray$7(u) && isArray$7(c))
    for (let d = 0; d < u.length; d++) {
      const m = u[d];
      let v = c[d];
      v.shapeFlag & 1 && !v.dynamicChildren && ((v.patchFlag <= 0 || v.patchFlag === 32) && (v = c[d] = cloneIfMounted(c[d]), v.el = m.el), o || traverseStaticChildren(m, v)), v.type === Text$1 && (v.el = m.el), browser$1$1.env.NODE_ENV !== "production" && v.type === Comment && !v.el && (v.el = m.el);
    }
}
function getSequence(e) {
  const n = e.slice(), o = [0];
  let u, c, d, m, v;
  const S = e.length;
  for (u = 0; u < S; u++) {
    const $ = e[u];
    if ($ !== 0) {
      if (c = o[o.length - 1], e[c] < $) {
        n[u] = c, o.push(u);
        continue;
      }
      for (d = 0, m = o.length - 1; d < m; )
        v = d + m >> 1, e[o[v]] < $ ? d = v + 1 : m = v;
      $ < e[o[d]] && (d > 0 && (n[u] = o[d - 1]), o[d] = u);
    }
  }
  for (d = o.length, m = o[d - 1]; d-- > 0; )
    o[d] = m, m = n[m];
  return o;
}
const isTeleport = (e) => e.__isTeleport, isTeleportDisabled = (e) => e && (e.disabled || e.disabled === ""), isTargetSVG = (e) => typeof SVGElement < "u" && e instanceof SVGElement, resolveTarget = (e, n) => {
  const o = e && e.to;
  if (isString$5(o))
    if (n) {
      const u = n(o);
      return u || browser$1$1.env.NODE_ENV !== "production" && warn(
        `Failed to locate Teleport target with selector "${o}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
      ), u;
    } else
      return browser$1$1.env.NODE_ENV !== "production" && warn(
        "Current renderer does not support string target for Teleports. (missing querySelector renderer option)"
      ), null;
  else
    return browser$1$1.env.NODE_ENV !== "production" && !o && !isTeleportDisabled(e) && warn(`Invalid Teleport target: ${o}`), o;
}, TeleportImpl = {
  __isTeleport: !0,
  process(e, n, o, u, c, d, m, v, S, $) {
    const {
      mc: E,
      pc: O,
      pbc: T,
      o: { insert: y, querySelector: V, createText: M, createComment: G }
    } = $, k = isTeleportDisabled(n.props);
    let { shapeFlag: F, children: X, dynamicChildren: ee } = n;
    if (browser$1$1.env.NODE_ENV !== "production" && isHmrUpdating && (S = !1, ee = null), e == null) {
      const ue = n.el = browser$1$1.env.NODE_ENV !== "production" ? G("teleport start") : M(""), Q = n.anchor = browser$1$1.env.NODE_ENV !== "production" ? G("teleport end") : M("");
      y(ue, o, u), y(Q, o, u);
      const Y = n.target = resolveTarget(n.props, V), pe = n.targetAnchor = M("");
      Y ? (y(pe, Y), m = m || isTargetSVG(Y)) : browser$1$1.env.NODE_ENV !== "production" && !k && warn("Invalid Teleport target on mount:", Y, `(${typeof Y})`);
      const oe = (ne, H) => {
        F & 16 && E(
          X,
          ne,
          H,
          c,
          d,
          m,
          v,
          S
        );
      };
      k ? oe(o, Q) : Y && oe(Y, pe);
    } else {
      n.el = e.el;
      const ue = n.anchor = e.anchor, Q = n.target = e.target, Y = n.targetAnchor = e.targetAnchor, pe = isTeleportDisabled(e.props), oe = pe ? o : Q, ne = pe ? ue : Y;
      if (m = m || isTargetSVG(Q), ee ? (T(
        e.dynamicChildren,
        ee,
        oe,
        c,
        d,
        m,
        v
      ), traverseStaticChildren(e, n, !0)) : S || O(
        e,
        n,
        oe,
        ne,
        c,
        d,
        m,
        v,
        !1
      ), k)
        pe || moveTeleport(
          n,
          o,
          ue,
          $,
          1
        );
      else if ((n.props && n.props.to) !== (e.props && e.props.to)) {
        const H = n.target = resolveTarget(
          n.props,
          V
        );
        H ? moveTeleport(
          n,
          H,
          null,
          $,
          0
        ) : browser$1$1.env.NODE_ENV !== "production" && warn(
          "Invalid Teleport target on update:",
          Q,
          `(${typeof Q})`
        );
      } else
        pe && moveTeleport(
          n,
          Q,
          Y,
          $,
          1
        );
    }
    updateCssVars(n);
  },
  remove(e, n, o, u, { um: c, o: { remove: d } }, m) {
    const { shapeFlag: v, children: S, anchor: $, targetAnchor: E, target: O, props: T } = e;
    if (O && d(E), (m || !isTeleportDisabled(T)) && (d($), v & 16))
      for (let y = 0; y < S.length; y++) {
        const V = S[y];
        c(
          V,
          n,
          o,
          !0,
          !!V.dynamicChildren
        );
      }
  },
  move: moveTeleport,
  hydrate: hydrateTeleport
};
function moveTeleport(e, n, o, { o: { insert: u }, m: c }, d = 2) {
  d === 0 && u(e.targetAnchor, n, o);
  const { el: m, anchor: v, shapeFlag: S, children: $, props: E } = e, O = d === 2;
  if (O && u(m, n, o), (!O || isTeleportDisabled(E)) && S & 16)
    for (let T = 0; T < $.length; T++)
      c(
        $[T],
        n,
        o,
        2
      );
  O && u(v, n, o);
}
function hydrateTeleport(e, n, o, u, c, d, {
  o: { nextSibling: m, parentNode: v, querySelector: S }
}, $) {
  const E = n.target = resolveTarget(
    n.props,
    S
  );
  if (E) {
    const O = E._lpa || E.firstChild;
    if (n.shapeFlag & 16)
      if (isTeleportDisabled(n.props))
        n.anchor = $(
          m(e),
          n,
          v(e),
          o,
          u,
          c,
          d
        ), n.targetAnchor = O;
      else {
        n.anchor = m(e);
        let T = O;
        for (; T; )
          if (T = m(T), T && T.nodeType === 8 && T.data === "teleport anchor") {
            n.targetAnchor = T, E._lpa = n.targetAnchor && m(n.targetAnchor);
            break;
          }
        $(
          O,
          n,
          E,
          o,
          u,
          c,
          d
        );
      }
    updateCssVars(n);
  }
  return n.anchor && m(n.anchor);
}
const Teleport = TeleportImpl;
function updateCssVars(e) {
  const n = e.ctx;
  if (n && n.ut) {
    let o = e.children[0].el;
    for (; o !== e.targetAnchor; )
      o.nodeType === 1 && o.setAttribute("data-v-owner", n.uid), o = o.nextSibling;
    n.ut();
  }
}
const Fragment = Symbol.for("v-fgt"), Text$1 = Symbol.for("v-txt"), Comment = Symbol.for("v-cmt"), Static = Symbol.for("v-stc"), blockStack = [];
let currentBlock = null;
function openBlock(e = !1) {
  blockStack.push(currentBlock = e ? null : []);
}
function closeBlock() {
  blockStack.pop(), currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(e) {
  isBlockTreeEnabled += e;
}
function setupBlock(e) {
  return e.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null, closeBlock(), isBlockTreeEnabled > 0 && currentBlock && currentBlock.push(e), e;
}
function createElementBlock(e, n, o, u, c, d) {
  return setupBlock(
    createBaseVNode(
      e,
      n,
      o,
      u,
      c,
      d,
      !0
      /* isBlock */
    )
  );
}
function createBlock(e, n, o, u, c) {
  return setupBlock(
    createVNode(
      e,
      n,
      o,
      u,
      c,
      !0
      /* isBlock: prevent a block from tracking itself */
    )
  );
}
function isVNode(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function isSameVNodeType(e, n) {
  return browser$1$1.env.NODE_ENV !== "production" && n.shapeFlag & 6 && hmrDirtyComponents.has(n.type) ? (e.shapeFlag &= -257, n.shapeFlag &= -513, !1) : e.type === n.type && e.key === n.key;
}
let vnodeArgsTransformer;
function transformVNodeArgs(e) {
  vnodeArgsTransformer = e;
}
const createVNodeWithArgsTransform = (...e) => _createVNode(
  ...vnodeArgsTransformer ? vnodeArgsTransformer(e, currentRenderingInstance) : e
), InternalObjectKey = "__vInternal", normalizeKey = ({ key: e }) => e ?? null, normalizeRef = ({
  ref: e,
  ref_key: n,
  ref_for: o
}) => (typeof e == "number" && (e = "" + e), e != null ? isString$5(e) || isRef(e) || isFunction$7(e) ? { i: currentRenderingInstance, r: e, k: n, f: !!o } : e : null);
function createBaseVNode(e, n = null, o = null, u = 0, c = null, d = e === Fragment ? 0 : 1, m = !1, v = !1) {
  const S = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: n,
    key: n && normalizeKey(n),
    ref: n && normalizeRef(n),
    scopeId: currentScopeId,
    slotScopeIds: null,
    children: o,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: d,
    patchFlag: u,
    dynamicProps: c,
    dynamicChildren: null,
    appContext: null,
    ctx: currentRenderingInstance
  };
  return v ? (normalizeChildren(S, o), d & 128 && e.normalize(S)) : o && (S.shapeFlag |= isString$5(o) ? 8 : 16), browser$1$1.env.NODE_ENV !== "production" && S.key !== S.key && warn("VNode created with invalid key (NaN). VNode type:", S.type), isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
  !m && // has current parent block
  currentBlock && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (S.patchFlag > 0 || d & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  S.patchFlag !== 32 && currentBlock.push(S), S;
}
const createVNode = browser$1$1.env.NODE_ENV !== "production" ? createVNodeWithArgsTransform : _createVNode;
function _createVNode(e, n = null, o = null, u = 0, c = null, d = !1) {
  if ((!e || e === NULL_DYNAMIC_COMPONENT) && (browser$1$1.env.NODE_ENV !== "production" && !e && warn(`Invalid vnode type when creating vnode: ${e}.`), e = Comment), isVNode(e)) {
    const v = cloneVNode(
      e,
      n,
      !0
      /* mergeRef: true */
    );
    return o && normalizeChildren(v, o), isBlockTreeEnabled > 0 && !d && currentBlock && (v.shapeFlag & 6 ? currentBlock[currentBlock.indexOf(e)] = v : currentBlock.push(v)), v.patchFlag |= -2, v;
  }
  if (isClassComponent(e) && (e = e.__vccOpts), n) {
    n = guardReactiveProps(n);
    let { class: v, style: S } = n;
    v && !isString$5(v) && (n.class = normalizeClass(v)), isObject$8(S) && (isProxy(S) && !isArray$7(S) && (S = extend$5({}, S)), n.style = normalizeStyle(S));
  }
  const m = isString$5(e) ? 1 : isSuspense(e) ? 128 : isTeleport(e) ? 64 : isObject$8(e) ? 4 : isFunction$7(e) ? 2 : 0;
  return browser$1$1.env.NODE_ENV !== "production" && m & 4 && isProxy(e) && (e = toRaw(e), warn(
    "Vue received a Component which was made a reactive object. This can lead to unnecessary performance overhead, and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), createBaseVNode(
    e,
    n,
    o,
    u,
    c,
    m,
    d,
    !0
  );
}
function guardReactiveProps(e) {
  return e ? isProxy(e) || InternalObjectKey in e ? extend$5({}, e) : e : null;
}
function cloneVNode(e, n, o = !1) {
  const { props: u, ref: c, patchFlag: d, children: m } = e, v = n ? mergeProps(u || {}, n) : u;
  return {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: v,
    key: v && normalizeKey(v),
    ref: n && n.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      o && c ? isArray$7(c) ? c.concat(normalizeRef(n)) : [c, normalizeRef(n)] : normalizeRef(n)
    ) : c,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: browser$1$1.env.NODE_ENV !== "production" && d === -1 && isArray$7(m) ? m.map(deepCloneVNode) : m,
    target: e.target,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: n && e.type !== Fragment ? d === -1 ? 16 : d | 16 : d,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: e.transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && cloneVNode(e.ssContent),
    ssFallback: e.ssFallback && cloneVNode(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
}
function deepCloneVNode(e) {
  const n = cloneVNode(e);
  return isArray$7(e.children) && (n.children = e.children.map(deepCloneVNode)), n;
}
function createTextVNode(e = " ", n = 0) {
  return createVNode(Text$1, null, e, n);
}
function createStaticVNode(e, n) {
  const o = createVNode(Static, null, e);
  return o.staticCount = n, o;
}
function createCommentVNode(e = "", n = !1) {
  return n ? (openBlock(), createBlock(Comment, null, e)) : createVNode(Comment, null, e);
}
function normalizeVNode(e) {
  return e == null || typeof e == "boolean" ? createVNode(Comment) : isArray$7(e) ? createVNode(
    Fragment,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : typeof e == "object" ? cloneIfMounted(e) : createVNode(Text$1, null, String(e));
}
function cloneIfMounted(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : cloneVNode(e);
}
function normalizeChildren(e, n) {
  let o = 0;
  const { shapeFlag: u } = e;
  if (n == null)
    n = null;
  else if (isArray$7(n))
    o = 16;
  else if (typeof n == "object")
    if (u & 65) {
      const c = n.default;
      c && (c._c && (c._d = !1), normalizeChildren(e, c()), c._c && (c._d = !0));
      return;
    } else {
      o = 32;
      const c = n._;
      !c && !(InternalObjectKey in n) ? n._ctx = currentRenderingInstance : c === 3 && currentRenderingInstance && (currentRenderingInstance.slots._ === 1 ? n._ = 1 : (n._ = 2, e.patchFlag |= 1024));
    }
  else
    isFunction$7(n) ? (n = { default: n, _ctx: currentRenderingInstance }, o = 32) : (n = String(n), u & 64 ? (o = 16, n = [createTextVNode(n)]) : o = 8);
  e.children = n, e.shapeFlag |= o;
}
function mergeProps(...e) {
  const n = {};
  for (let o = 0; o < e.length; o++) {
    const u = e[o];
    for (const c in u)
      if (c === "class")
        n.class !== u.class && (n.class = normalizeClass([n.class, u.class]));
      else if (c === "style")
        n.style = normalizeStyle([n.style, u.style]);
      else if (isOn(c)) {
        const d = n[c], m = u[c];
        m && d !== m && !(isArray$7(d) && d.includes(m)) && (n[c] = d ? [].concat(d, m) : m);
      } else
        c !== "" && (n[c] = u[c]);
  }
  return n;
}
function invokeVNodeHook(e, n, o, u = null) {
  callWithAsyncErrorHandling(e, n, 7, [
    o,
    u
  ]);
}
const emptyAppContext = createAppContext();
let uid = 0;
function createComponentInstance(e, n, o) {
  const u = e.type, c = (n ? n.appContext : e.appContext) || emptyAppContext, d = {
    uid: uid++,
    vnode: e,
    type: u,
    parent: n,
    appContext: c,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    scope: new EffectScope(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: n ? n.provides : Object.create(c.provides),
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: normalizePropsOptions(u, c),
    emitsOptions: normalizeEmitsOptions(u, c),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: EMPTY_OBJ,
    // inheritAttrs
    inheritAttrs: u.inheritAttrs,
    // state
    ctx: EMPTY_OBJ,
    data: EMPTY_OBJ,
    props: EMPTY_OBJ,
    attrs: EMPTY_OBJ,
    slots: EMPTY_OBJ,
    refs: EMPTY_OBJ,
    setupState: EMPTY_OBJ,
    setupContext: null,
    attrsProxy: null,
    slotsProxy: null,
    // suspense related
    suspense: o,
    suspenseId: o ? o.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return browser$1$1.env.NODE_ENV !== "production" ? d.ctx = createDevRenderContext(d) : d.ctx = { _: d }, d.root = n ? n.root : d, d.emit = emit.bind(null, d), e.ce && e.ce(d), d;
}
let currentInstance = null;
const getCurrentInstance = () => currentInstance || currentRenderingInstance;
let internalSetCurrentInstance, globalCurrentInstanceSetters, settersKey = "__VUE_INSTANCE_SETTERS__";
(globalCurrentInstanceSetters = getGlobalThis()[settersKey]) || (globalCurrentInstanceSetters = getGlobalThis()[settersKey] = []), globalCurrentInstanceSetters.push((e) => currentInstance = e), internalSetCurrentInstance = (e) => {
  globalCurrentInstanceSetters.length > 1 ? globalCurrentInstanceSetters.forEach((n) => n(e)) : globalCurrentInstanceSetters[0](e);
};
const setCurrentInstance = (e) => {
  internalSetCurrentInstance(e), e.scope.on();
}, unsetCurrentInstance = () => {
  currentInstance && currentInstance.scope.off(), internalSetCurrentInstance(null);
}, isBuiltInTag = /* @__PURE__ */ makeMap("slot,component");
function validateComponentName(e, n) {
  const o = n.isNativeTag || NO$1;
  (isBuiltInTag(e) || o(e)) && warn(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function isStatefulComponent(e) {
  return e.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = !1;
function setupComponent(e, n = !1) {
  isInSSRComponentSetup = n;
  const { props: o, children: u } = e.vnode, c = isStatefulComponent(e);
  initProps(e, o, c, n), initSlots(e, u);
  const d = c ? setupStatefulComponent(e, n) : void 0;
  return isInSSRComponentSetup = !1, d;
}
function setupStatefulComponent(e, n) {
  var o;
  const u = e.type;
  if (browser$1$1.env.NODE_ENV !== "production") {
    if (u.name && validateComponentName(u.name, e.appContext.config), u.components) {
      const d = Object.keys(u.components);
      for (let m = 0; m < d.length; m++)
        validateComponentName(d[m], e.appContext.config);
    }
    if (u.directives) {
      const d = Object.keys(u.directives);
      for (let m = 0; m < d.length; m++)
        validateDirectiveName(d[m]);
    }
    u.compilerOptions && isRuntimeOnly() && warn(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = markRaw(new Proxy(e.ctx, PublicInstanceProxyHandlers)), browser$1$1.env.NODE_ENV !== "production" && exposePropsOnRenderContext(e);
  const { setup: c } = u;
  if (c) {
    const d = e.setupContext = c.length > 1 ? createSetupContext(e) : null;
    setCurrentInstance(e), pauseTracking();
    const m = callWithErrorHandling(
      c,
      e,
      0,
      [browser$1$1.env.NODE_ENV !== "production" ? shallowReadonly(e.props) : e.props, d]
    );
    if (resetTracking(), unsetCurrentInstance(), isPromise$1(m)) {
      if (m.then(unsetCurrentInstance, unsetCurrentInstance), n)
        return m.then((v) => {
          handleSetupResult(e, v, n);
        }).catch((v) => {
          handleError(v, e, 0);
        });
      if (e.asyncDep = m, browser$1$1.env.NODE_ENV !== "production" && !e.suspense) {
        const v = (o = u.name) != null ? o : "Anonymous";
        warn(
          `Component <${v}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      handleSetupResult(e, m, n);
  } else
    finishComponentSetup(e, n);
}
function handleSetupResult(e, n, o) {
  isFunction$7(n) ? e.type.__ssrInlineRender ? e.ssrRender = n : e.render = n : isObject$8(n) ? (browser$1$1.env.NODE_ENV !== "production" && isVNode(n) && warn(
    "setup() should not return VNodes directly - return a render function instead."
  ), browser$1$1.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = n), e.setupState = proxyRefs(n), browser$1$1.env.NODE_ENV !== "production" && exposeSetupStateOnRenderContext(e)) : browser$1$1.env.NODE_ENV !== "production" && n !== void 0 && warn(
    `setup() should return an object. Received: ${n === null ? "null" : typeof n}`
  ), finishComponentSetup(e, o);
}
let compile$1, installWithProxy;
function registerRuntimeCompiler(e) {
  compile$1 = e, installWithProxy = (n) => {
    n.render._rc && (n.withProxy = new Proxy(n.ctx, RuntimeCompiledPublicInstanceProxyHandlers));
  };
}
const isRuntimeOnly = () => !compile$1;
function finishComponentSetup(e, n, o) {
  const u = e.type;
  if (!e.render) {
    if (!n && compile$1 && !u.render) {
      const c = u.template || resolveMergedOptions(e).template;
      if (c) {
        browser$1$1.env.NODE_ENV !== "production" && startMeasure(e, "compile");
        const { isCustomElement: d, compilerOptions: m } = e.appContext.config, { delimiters: v, compilerOptions: S } = u, $ = extend$5(
          extend$5(
            {
              isCustomElement: d,
              delimiters: v
            },
            m
          ),
          S
        );
        u.render = compile$1(c, $), browser$1$1.env.NODE_ENV !== "production" && endMeasure(e, "compile");
      }
    }
    e.render = u.render || NOOP, installWithProxy && installWithProxy(e);
  }
  setCurrentInstance(e), pauseTracking(), applyOptions(e), resetTracking(), unsetCurrentInstance(), browser$1$1.env.NODE_ENV !== "production" && !u.render && e.render === NOOP && !n && (!compile$1 && u.template ? warn(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
    /* should not happen */
  ) : warn("Component is missing template or render function."));
}
function getAttrsProxy(e) {
  return e.attrsProxy || (e.attrsProxy = new Proxy(
    e.attrs,
    browser$1$1.env.NODE_ENV !== "production" ? {
      get(n, o) {
        return markAttrsAccessed(), track(e, "get", "$attrs"), n[o];
      },
      set() {
        return warn("setupContext.attrs is readonly."), !1;
      },
      deleteProperty() {
        return warn("setupContext.attrs is readonly."), !1;
      }
    } : {
      get(n, o) {
        return track(e, "get", "$attrs"), n[o];
      }
    }
  ));
}
function getSlotsProxy(e) {
  return e.slotsProxy || (e.slotsProxy = new Proxy(e.slots, {
    get(n, o) {
      return track(e, "get", "$slots"), n[o];
    }
  }));
}
function createSetupContext(e) {
  const n = (o) => {
    if (browser$1$1.env.NODE_ENV !== "production" && (e.exposed && warn("expose() should be called only once per setup()."), o != null)) {
      let u = typeof o;
      u === "object" && (isArray$7(o) ? u = "array" : isRef(o) && (u = "ref")), u !== "object" && warn(
        `expose() should be passed a plain object, received ${u}.`
      );
    }
    e.exposed = o || {};
  };
  return browser$1$1.env.NODE_ENV !== "production" ? Object.freeze({
    get attrs() {
      return getAttrsProxy(e);
    },
    get slots() {
      return getSlotsProxy(e);
    },
    get emit() {
      return (o, ...u) => e.emit(o, ...u);
    },
    expose: n
  }) : {
    get attrs() {
      return getAttrsProxy(e);
    },
    slots: e.slots,
    emit: e.emit,
    expose: n
  };
}
function getExposeProxy(e) {
  if (e.exposed)
    return e.exposeProxy || (e.exposeProxy = new Proxy(proxyRefs(markRaw(e.exposed)), {
      get(n, o) {
        if (o in n)
          return n[o];
        if (o in publicPropertiesMap)
          return publicPropertiesMap[o](e);
      },
      has(n, o) {
        return o in n || o in publicPropertiesMap;
      }
    }));
}
const classifyRE = /(?:^|[-_])(\w)/g, classify = (e) => e.replace(classifyRE, (n) => n.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(e, n = !0) {
  return isFunction$7(e) ? e.displayName || e.name : e.name || n && e.__name;
}
function formatComponentName(e, n, o = !1) {
  let u = getComponentName(n);
  if (!u && n.__file) {
    const c = n.__file.match(/([^/\\]+)\.\w+$/);
    c && (u = c[1]);
  }
  if (!u && e && e.parent) {
    const c = (d) => {
      for (const m in d)
        if (d[m] === n)
          return m;
    };
    u = c(
      e.components || e.parent.type.components
    ) || c(e.appContext.components);
  }
  return u ? classify(u) : o ? "App" : "Anonymous";
}
function isClassComponent(e) {
  return isFunction$7(e) && "__vccOpts" in e;
}
const computed = (e, n) => computed$1(e, n, isInSSRComponentSetup);
function h(e, n, o) {
  const u = arguments.length;
  return u === 2 ? isObject$8(n) && !isArray$7(n) ? isVNode(n) ? createVNode(e, null, [n]) : createVNode(e, n) : createVNode(e, null, n) : (u > 3 ? o = Array.prototype.slice.call(arguments, 2) : u === 3 && isVNode(o) && (o = [o]), createVNode(e, n, o));
}
const ssrContextKey = Symbol.for("v-scx"), useSSRContext = () => {
  {
    const e = inject(ssrContextKey);
    return e || browser$1$1.env.NODE_ENV !== "production" && warn(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function isShallow(e) {
  return !!(e && e.__v_isShallow);
}
function initCustomFormatter() {
  if (browser$1$1.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, n = { style: "color:#0b1bc9" }, o = { style: "color:#b62e24" }, u = { style: "color:#9d288c" }, c = {
    header(O) {
      return isObject$8(O) ? O.__isVue ? ["div", e, "VueInstance"] : isRef(O) ? [
        "div",
        {},
        ["span", e, E(O)],
        "<",
        v(O.value),
        ">"
      ] : isReactive(O) ? [
        "div",
        {},
        ["span", e, isShallow(O) ? "ShallowReactive" : "Reactive"],
        "<",
        v(O),
        `>${isReadonly(O) ? " (readonly)" : ""}`
      ] : isReadonly(O) ? [
        "div",
        {},
        ["span", e, isShallow(O) ? "ShallowReadonly" : "Readonly"],
        "<",
        v(O),
        ">"
      ] : null : null;
    },
    hasBody(O) {
      return O && O.__isVue;
    },
    body(O) {
      if (O && O.__isVue)
        return [
          "div",
          {},
          ...d(O.$)
        ];
    }
  };
  function d(O) {
    const T = [];
    O.type.props && O.props && T.push(m("props", toRaw(O.props))), O.setupState !== EMPTY_OBJ && T.push(m("setup", O.setupState)), O.data !== EMPTY_OBJ && T.push(m("data", toRaw(O.data)));
    const y = S(O, "computed");
    y && T.push(m("computed", y));
    const V = S(O, "inject");
    return V && T.push(m("injected", V)), T.push([
      "div",
      {},
      [
        "span",
        {
          style: u.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: O }]
    ]), T;
  }
  function m(O, T) {
    return T = extend$5({}, T), Object.keys(T).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        O
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(T).map((y) => [
          "div",
          {},
          ["span", u, y + ": "],
          v(T[y], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function v(O, T = !0) {
    return typeof O == "number" ? ["span", n, O] : typeof O == "string" ? ["span", o, JSON.stringify(O)] : typeof O == "boolean" ? ["span", u, O] : isObject$8(O) ? ["object", { object: T ? toRaw(O) : O }] : ["span", o, String(O)];
  }
  function S(O, T) {
    const y = O.type;
    if (isFunction$7(y))
      return;
    const V = {};
    for (const M in O.ctx)
      $(y, M, T) && (V[M] = O.ctx[M]);
    return V;
  }
  function $(O, T, y) {
    const V = O[y];
    if (isArray$7(V) && V.includes(T) || isObject$8(V) && T in V || O.extends && $(O.extends, T, y) || O.mixins && O.mixins.some((M) => $(M, T, y)))
      return !0;
  }
  function E(O) {
    return isShallow(O) ? "ShallowRef" : O.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(c) : window.devtoolsFormatters = [c];
}
function withMemo(e, n, o, u) {
  const c = o[u];
  if (c && isMemoSame(c, e))
    return c;
  const d = n();
  return d.memo = e.slice(), o[u] = d;
}
function isMemoSame(e, n) {
  const o = e.memo;
  if (o.length != n.length)
    return !1;
  for (let u = 0; u < o.length; u++)
    if (hasChanged(o[u], n[u]))
      return !1;
  return isBlockTreeEnabled > 0 && currentBlock && currentBlock.push(e), !0;
}
const version$6 = "3.3.4", _ssrUtils = {
  createComponentInstance,
  setupComponent,
  renderComponentRoot,
  setCurrentRenderingInstance,
  isVNode,
  normalizeVNode
}, ssrUtils = _ssrUtils, resolveFilter = null, compatUtils = null, svgNS = "http://www.w3.org/2000/svg", doc = typeof document < "u" ? document : null, templateContainer = doc && /* @__PURE__ */ doc.createElement("template"), nodeOps = {
  insert: (e, n, o) => {
    n.insertBefore(e, o || null);
  },
  remove: (e) => {
    const n = e.parentNode;
    n && n.removeChild(e);
  },
  createElement: (e, n, o, u) => {
    const c = n ? doc.createElementNS(svgNS, e) : doc.createElement(e, o ? { is: o } : void 0);
    return e === "select" && u && u.multiple != null && c.setAttribute("multiple", u.multiple), c;
  },
  createText: (e) => doc.createTextNode(e),
  createComment: (e) => doc.createComment(e),
  setText: (e, n) => {
    e.nodeValue = n;
  },
  setElementText: (e, n) => {
    e.textContent = n;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => doc.querySelector(e),
  setScopeId(e, n) {
    e.setAttribute(n, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, n, o, u, c, d) {
    const m = o ? o.previousSibling : n.lastChild;
    if (c && (c === d || c.nextSibling))
      for (; n.insertBefore(c.cloneNode(!0), o), !(c === d || !(c = c.nextSibling)); )
        ;
    else {
      templateContainer.innerHTML = u ? `<svg>${e}</svg>` : e;
      const v = templateContainer.content;
      if (u) {
        const S = v.firstChild;
        for (; S.firstChild; )
          v.appendChild(S.firstChild);
        v.removeChild(S);
      }
      n.insertBefore(v, o);
    }
    return [
      // first
      m ? m.nextSibling : n.firstChild,
      // last
      o ? o.previousSibling : n.lastChild
    ];
  }
};
function patchClass(e, n, o) {
  const u = e._vtc;
  u && (n = (n ? [n, ...u] : [...u]).join(" ")), n == null ? e.removeAttribute("class") : o ? e.setAttribute("class", n) : e.className = n;
}
function patchStyle(e, n, o) {
  const u = e.style, c = isString$5(o);
  if (o && !c) {
    if (n && !isString$5(n))
      for (const d in n)
        o[d] == null && setStyle(u, d, "");
    for (const d in o)
      setStyle(u, d, o[d]);
  } else {
    const d = u.display;
    c ? n !== o && (u.cssText = o) : n && e.removeAttribute("style"), "_vod" in e && (u.display = d);
  }
}
const semicolonRE = /[^\\];\s*$/, importantRE = /\s*!important$/;
function setStyle(e, n, o) {
  if (isArray$7(o))
    o.forEach((u) => setStyle(e, n, u));
  else if (o == null && (o = ""), browser$1$1.env.NODE_ENV !== "production" && semicolonRE.test(o) && warn(
    `Unexpected semicolon at the end of '${n}' style value: '${o}'`
  ), n.startsWith("--"))
    e.setProperty(n, o);
  else {
    const u = autoPrefix(e, n);
    importantRE.test(o) ? e.setProperty(
      hyphenate(u),
      o.replace(importantRE, ""),
      "important"
    ) : e[u] = o;
  }
}
const prefixes = ["Webkit", "Moz", "ms"], prefixCache = {};
function autoPrefix(e, n) {
  const o = prefixCache[n];
  if (o)
    return o;
  let u = camelize(n);
  if (u !== "filter" && u in e)
    return prefixCache[n] = u;
  u = capitalize(u);
  for (let c = 0; c < prefixes.length; c++) {
    const d = prefixes[c] + u;
    if (d in e)
      return prefixCache[n] = d;
  }
  return n;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(e, n, o, u, c) {
  if (u && n.startsWith("xlink:"))
    o == null ? e.removeAttributeNS(xlinkNS, n.slice(6, n.length)) : e.setAttributeNS(xlinkNS, n, o);
  else {
    const d = isSpecialBooleanAttr(n);
    o == null || d && !includeBooleanAttr(o) ? e.removeAttribute(n) : e.setAttribute(n, d ? "" : o);
  }
}
function patchDOMProp(e, n, o, u, c, d, m) {
  if (n === "innerHTML" || n === "textContent") {
    u && m(u, c, d), e[n] = o ?? "";
    return;
  }
  const v = e.tagName;
  if (n === "value" && v !== "PROGRESS" && // custom elements may use _value internally
  !v.includes("-")) {
    e._value = o;
    const $ = v === "OPTION" ? e.getAttribute("value") : e.value, E = o ?? "";
    $ !== E && (e.value = E), o == null && e.removeAttribute(n);
    return;
  }
  let S = !1;
  if (o === "" || o == null) {
    const $ = typeof e[n];
    $ === "boolean" ? o = includeBooleanAttr(o) : o == null && $ === "string" ? (o = "", S = !0) : $ === "number" && (o = 0, S = !0);
  }
  try {
    e[n] = o;
  } catch ($) {
    browser$1$1.env.NODE_ENV !== "production" && !S && warn(
      `Failed setting prop "${n}" on <${v.toLowerCase()}>: value ${o} is invalid.`,
      $
    );
  }
  S && e.removeAttribute(n);
}
function addEventListener(e, n, o, u) {
  e.addEventListener(n, o, u);
}
function removeEventListener(e, n, o, u) {
  e.removeEventListener(n, o, u);
}
function patchEvent(e, n, o, u, c = null) {
  const d = e._vei || (e._vei = {}), m = d[n];
  if (u && m)
    m.value = u;
  else {
    const [v, S] = parseName(n);
    if (u) {
      const $ = d[n] = createInvoker(u, c);
      addEventListener(e, v, $, S);
    } else
      m && (removeEventListener(e, v, m, S), d[n] = void 0);
  }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(e) {
  let n;
  if (optionsModifierRE.test(e)) {
    n = {};
    let u;
    for (; u = e.match(optionsModifierRE); )
      e = e.slice(0, e.length - u[0].length), n[u[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : hyphenate(e.slice(2)), n];
}
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve(), getNow = () => cachedNow || (p.then(() => cachedNow = 0), cachedNow = Date.now());
function createInvoker(e, n) {
  const o = (u) => {
    if (!u._vts)
      u._vts = Date.now();
    else if (u._vts <= o.attached)
      return;
    callWithAsyncErrorHandling(
      patchStopImmediatePropagation(u, o.value),
      n,
      5,
      [u]
    );
  };
  return o.value = e, o.attached = getNow(), o;
}
function patchStopImmediatePropagation(e, n) {
  if (isArray$7(n)) {
    const o = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      o.call(e), e._stopped = !0;
    }, n.map((u) => (c) => !c._stopped && u && u(c));
  } else
    return n;
}
const nativeOnRE = /^on[a-z]/, patchProp = (e, n, o, u, c = !1, d, m, v, S) => {
  n === "class" ? patchClass(e, u, c) : n === "style" ? patchStyle(e, o, u) : isOn(n) ? isModelListener(n) || patchEvent(e, n, o, u, m) : (n[0] === "." ? (n = n.slice(1), !0) : n[0] === "^" ? (n = n.slice(1), !1) : shouldSetAsProp(e, n, u, c)) ? patchDOMProp(
    e,
    n,
    u,
    d,
    m,
    v,
    S
  ) : (n === "true-value" ? e._trueValue = u : n === "false-value" && (e._falseValue = u), patchAttr(e, n, u, c));
};
function shouldSetAsProp(e, n, o, u) {
  return u ? !!(n === "innerHTML" || n === "textContent" || n in e && nativeOnRE.test(n) && isFunction$7(o)) : n === "spellcheck" || n === "draggable" || n === "translate" || n === "form" || n === "list" && e.tagName === "INPUT" || n === "type" && e.tagName === "TEXTAREA" || nativeOnRE.test(n) && isString$5(o) ? !1 : n in e;
}
function defineCustomElement(e, n) {
  const o = defineComponent(e);
  class u extends VueElement {
    constructor(d) {
      super(o, d, n);
    }
  }
  return u.def = o, u;
}
const defineSSRCustomElement = (e) => defineCustomElement(e, hydrate), BaseClass = typeof HTMLElement < "u" ? HTMLElement : class {
};
class VueElement extends BaseClass {
  constructor(n, o = {}, u) {
    super(), this._def = n, this._props = o, this._instance = null, this._connected = !1, this._resolved = !1, this._numberProps = null, this.shadowRoot && u ? u(this._createVNode(), this.shadowRoot) : (browser$1$1.env.NODE_ENV !== "production" && this.shadowRoot && warn(
      "Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`."
    ), this.attachShadow({ mode: "open" }), this._def.__asyncLoader || this._resolveProps(this._def));
  }
  connectedCallback() {
    this._connected = !0, this._instance || (this._resolved ? this._update() : this._resolveDef());
  }
  disconnectedCallback() {
    this._connected = !1, nextTick(() => {
      this._connected || (render$1(null, this.shadowRoot), this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    this._resolved = !0;
    for (let u = 0; u < this.attributes.length; u++)
      this._setAttr(this.attributes[u].name);
    new MutationObserver((u) => {
      for (const c of u)
        this._setAttr(c.attributeName);
    }).observe(this, { attributes: !0 });
    const n = (u, c = !1) => {
      const { props: d, styles: m } = u;
      let v;
      if (d && !isArray$7(d))
        for (const S in d) {
          const $ = d[S];
          ($ === Number || $ && $.type === Number) && (S in this._props && (this._props[S] = toNumber(this._props[S])), (v || (v = /* @__PURE__ */ Object.create(null)))[camelize(S)] = !0);
        }
      this._numberProps = v, c && this._resolveProps(u), this._applyStyles(m), this._update();
    }, o = this._def.__asyncLoader;
    o ? o().then((u) => n(u, !0)) : n(this._def);
  }
  _resolveProps(n) {
    const { props: o } = n, u = isArray$7(o) ? o : Object.keys(o || {});
    for (const c of Object.keys(this))
      c[0] !== "_" && u.includes(c) && this._setProp(c, this[c], !0, !1);
    for (const c of u.map(camelize))
      Object.defineProperty(this, c, {
        get() {
          return this._getProp(c);
        },
        set(d) {
          this._setProp(c, d);
        }
      });
  }
  _setAttr(n) {
    let o = this.getAttribute(n);
    const u = camelize(n);
    this._numberProps && this._numberProps[u] && (o = toNumber(o)), this._setProp(u, o, !1);
  }
  /**
   * @internal
   */
  _getProp(n) {
    return this._props[n];
  }
  /**
   * @internal
   */
  _setProp(n, o, u = !0, c = !0) {
    o !== this._props[n] && (this._props[n] = o, c && this._instance && this._update(), u && (o === !0 ? this.setAttribute(hyphenate(n), "") : typeof o == "string" || typeof o == "number" ? this.setAttribute(hyphenate(n), o + "") : o || this.removeAttribute(hyphenate(n))));
  }
  _update() {
    render$1(this._createVNode(), this.shadowRoot);
  }
  _createVNode() {
    const n = createVNode(this._def, extend$5({}, this._props));
    return this._instance || (n.ce = (o) => {
      this._instance = o, o.isCE = !0, browser$1$1.env.NODE_ENV !== "production" && (o.ceReload = (d) => {
        this._styles && (this._styles.forEach((m) => this.shadowRoot.removeChild(m)), this._styles.length = 0), this._applyStyles(d), this._instance = null, this._update();
      });
      const u = (d, m) => {
        this.dispatchEvent(
          new CustomEvent(d, {
            detail: m
          })
        );
      };
      o.emit = (d, ...m) => {
        u(d, m), hyphenate(d) !== d && u(hyphenate(d), m);
      };
      let c = this;
      for (; c = c && (c.parentNode || c.host); )
        if (c instanceof VueElement) {
          o.parent = c._instance, o.provides = c._instance.provides;
          break;
        }
    }), n;
  }
  _applyStyles(n) {
    n && n.forEach((o) => {
      const u = document.createElement("style");
      u.textContent = o, this.shadowRoot.appendChild(u), browser$1$1.env.NODE_ENV !== "production" && (this._styles || (this._styles = [])).push(u);
    });
  }
}
function useCssModule(e = "$style") {
  {
    const n = getCurrentInstance();
    if (!n)
      return browser$1$1.env.NODE_ENV !== "production" && warn("useCssModule must be called inside setup()"), EMPTY_OBJ;
    const o = n.type.__cssModules;
    if (!o)
      return browser$1$1.env.NODE_ENV !== "production" && warn("Current instance does not have CSS modules injected."), EMPTY_OBJ;
    const u = o[e];
    return u || (browser$1$1.env.NODE_ENV !== "production" && warn(`Current instance does not have CSS module named "${e}".`), EMPTY_OBJ);
  }
}
function useCssVars(e) {
  const n = getCurrentInstance();
  if (!n) {
    browser$1$1.env.NODE_ENV !== "production" && warn("useCssVars is called without current active component instance.");
    return;
  }
  const o = n.ut = (c = e(n.proxy)) => {
    Array.from(
      document.querySelectorAll(`[data-v-owner="${n.uid}"]`)
    ).forEach((d) => setVarsOnNode(d, c));
  }, u = () => {
    const c = e(n.proxy);
    setVarsOnVNode(n.subTree, c), o(c);
  };
  watchPostEffect(u), onMounted(() => {
    const c = new MutationObserver(u);
    c.observe(n.subTree.el.parentNode, { childList: !0 }), onUnmounted(() => c.disconnect());
  });
}
function setVarsOnVNode(e, n) {
  if (e.shapeFlag & 128) {
    const o = e.suspense;
    e = o.activeBranch, o.pendingBranch && !o.isHydrating && o.effects.push(() => {
      setVarsOnVNode(o.activeBranch, n);
    });
  }
  for (; e.component; )
    e = e.component.subTree;
  if (e.shapeFlag & 1 && e.el)
    setVarsOnNode(e.el, n);
  else if (e.type === Fragment)
    e.children.forEach((o) => setVarsOnVNode(o, n));
  else if (e.type === Static) {
    let { el: o, anchor: u } = e;
    for (; o && (setVarsOnNode(o, n), o !== u); )
      o = o.nextSibling;
  }
}
function setVarsOnNode(e, n) {
  if (e.nodeType === 1) {
    const o = e.style;
    for (const u in n)
      o.setProperty(`--${u}`, n[u]);
  }
}
const TRANSITION = "transition", ANIMATION = "animation", Transition = (e, { slots: n }) => h(BaseTransition, resolveTransitionProps(e), n);
Transition.displayName = "Transition";
const DOMTransitionPropsValidators = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, TransitionPropsValidators = Transition.props = /* @__PURE__ */ extend$5(
  {},
  BaseTransitionPropsValidators,
  DOMTransitionPropsValidators
), callHook = (e, n = []) => {
  isArray$7(e) ? e.forEach((o) => o(...n)) : e && e(...n);
}, hasExplicitCallback = (e) => e ? isArray$7(e) ? e.some((n) => n.length > 1) : e.length > 1 : !1;
function resolveTransitionProps(e) {
  const n = {};
  for (const C in e)
    C in DOMTransitionPropsValidators || (n[C] = e[C]);
  if (e.css === !1)
    return n;
  const {
    name: o = "v",
    type: u,
    duration: c,
    enterFromClass: d = `${o}-enter-from`,
    enterActiveClass: m = `${o}-enter-active`,
    enterToClass: v = `${o}-enter-to`,
    appearFromClass: S = d,
    appearActiveClass: $ = m,
    appearToClass: E = v,
    leaveFromClass: O = `${o}-leave-from`,
    leaveActiveClass: T = `${o}-leave-active`,
    leaveToClass: y = `${o}-leave-to`
  } = e, V = normalizeDuration(c), M = V && V[0], G = V && V[1], {
    onBeforeEnter: k,
    onEnter: F,
    onEnterCancelled: X,
    onLeave: ee,
    onLeaveCancelled: ue,
    onBeforeAppear: Q = k,
    onAppear: Y = F,
    onAppearCancelled: pe = X
  } = n, oe = (C, w, P) => {
    removeTransitionClass(C, w ? E : v), removeTransitionClass(C, w ? $ : m), P && P();
  }, ne = (C, w) => {
    C._isLeaving = !1, removeTransitionClass(C, O), removeTransitionClass(C, y), removeTransitionClass(C, T), w && w();
  }, H = (C) => (w, P) => {
    const J = C ? Y : F, se = () => oe(w, C, P);
    callHook(J, [w, se]), nextFrame(() => {
      removeTransitionClass(w, C ? S : d), addTransitionClass(w, C ? E : v), hasExplicitCallback(J) || whenTransitionEnds(w, u, M, se);
    });
  };
  return extend$5(n, {
    onBeforeEnter(C) {
      callHook(k, [C]), addTransitionClass(C, d), addTransitionClass(C, m);
    },
    onBeforeAppear(C) {
      callHook(Q, [C]), addTransitionClass(C, S), addTransitionClass(C, $);
    },
    onEnter: H(!1),
    onAppear: H(!0),
    onLeave(C, w) {
      C._isLeaving = !0;
      const P = () => ne(C, w);
      addTransitionClass(C, O), forceReflow(), addTransitionClass(C, T), nextFrame(() => {
        C._isLeaving && (removeTransitionClass(C, O), addTransitionClass(C, y), hasExplicitCallback(ee) || whenTransitionEnds(C, u, G, P));
      }), callHook(ee, [C, P]);
    },
    onEnterCancelled(C) {
      oe(C, !1), callHook(X, [C]);
    },
    onAppearCancelled(C) {
      oe(C, !0), callHook(pe, [C]);
    },
    onLeaveCancelled(C) {
      ne(C), callHook(ue, [C]);
    }
  });
}
function normalizeDuration(e) {
  if (e == null)
    return null;
  if (isObject$8(e))
    return [NumberOf(e.enter), NumberOf(e.leave)];
  {
    const n = NumberOf(e);
    return [n, n];
  }
}
function NumberOf(e) {
  const n = toNumber(e);
  return browser$1$1.env.NODE_ENV !== "production" && assertNumber$a(n, "<transition> explicit duration"), n;
}
function addTransitionClass(e, n) {
  n.split(/\s+/).forEach((o) => o && e.classList.add(o)), (e._vtc || (e._vtc = /* @__PURE__ */ new Set())).add(n);
}
function removeTransitionClass(e, n) {
  n.split(/\s+/).forEach((u) => u && e.classList.remove(u));
  const { _vtc: o } = e;
  o && (o.delete(n), o.size || (e._vtc = void 0));
}
function nextFrame(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let endId = 0;
function whenTransitionEnds(e, n, o, u) {
  const c = e._endId = ++endId, d = () => {
    c === e._endId && u();
  };
  if (o)
    return setTimeout(d, o);
  const { type: m, timeout: v, propCount: S } = getTransitionInfo(e, n);
  if (!m)
    return u();
  const $ = m + "end";
  let E = 0;
  const O = () => {
    e.removeEventListener($, T), d();
  }, T = (y) => {
    y.target === e && ++E >= S && O();
  };
  setTimeout(() => {
    E < S && O();
  }, v + 1), e.addEventListener($, T);
}
function getTransitionInfo(e, n) {
  const o = window.getComputedStyle(e), u = (V) => (o[V] || "").split(", "), c = u(`${TRANSITION}Delay`), d = u(`${TRANSITION}Duration`), m = getTimeout(c, d), v = u(`${ANIMATION}Delay`), S = u(`${ANIMATION}Duration`), $ = getTimeout(v, S);
  let E = null, O = 0, T = 0;
  n === TRANSITION ? m > 0 && (E = TRANSITION, O = m, T = d.length) : n === ANIMATION ? $ > 0 && (E = ANIMATION, O = $, T = S.length) : (O = Math.max(m, $), E = O > 0 ? m > $ ? TRANSITION : ANIMATION : null, T = E ? E === TRANSITION ? d.length : S.length : 0);
  const y = E === TRANSITION && /\b(transform|all)(,|$)/.test(
    u(`${TRANSITION}Property`).toString()
  );
  return {
    type: E,
    timeout: O,
    propCount: T,
    hasTransform: y
  };
}
function getTimeout(e, n) {
  for (; e.length < n.length; )
    e = e.concat(e);
  return Math.max(...n.map((o, u) => toMs(o) + toMs(e[u])));
}
function toMs(e) {
  return Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow() {
  return document.body.offsetHeight;
}
const positionMap = /* @__PURE__ */ new WeakMap(), newPositionMap = /* @__PURE__ */ new WeakMap(), TransitionGroupImpl = {
  name: "TransitionGroup",
  props: /* @__PURE__ */ extend$5({}, TransitionPropsValidators, {
    tag: String,
    moveClass: String
  }),
  setup(e, { slots: n }) {
    const o = getCurrentInstance(), u = useTransitionState();
    let c, d;
    return onUpdated(() => {
      if (!c.length)
        return;
      const m = e.moveClass || `${e.name || "v"}-move`;
      if (!hasCSSTransform(
        c[0].el,
        o.vnode.el,
        m
      ))
        return;
      c.forEach(callPendingCbs), c.forEach(recordPosition);
      const v = c.filter(applyTranslation);
      forceReflow(), v.forEach((S) => {
        const $ = S.el, E = $.style;
        addTransitionClass($, m), E.transform = E.webkitTransform = E.transitionDuration = "";
        const O = $._moveCb = (T) => {
          T && T.target !== $ || (!T || /transform$/.test(T.propertyName)) && ($.removeEventListener("transitionend", O), $._moveCb = null, removeTransitionClass($, m));
        };
        $.addEventListener("transitionend", O);
      });
    }), () => {
      const m = toRaw(e), v = resolveTransitionProps(m);
      let S = m.tag || Fragment;
      c = d, d = n.default ? getTransitionRawChildren(n.default()) : [];
      for (let $ = 0; $ < d.length; $++) {
        const E = d[$];
        E.key != null ? setTransitionHooks(
          E,
          resolveTransitionHooks(E, v, u, o)
        ) : browser$1$1.env.NODE_ENV !== "production" && warn("<TransitionGroup> children must be keyed.");
      }
      if (c)
        for (let $ = 0; $ < c.length; $++) {
          const E = c[$];
          setTransitionHooks(
            E,
            resolveTransitionHooks(E, v, u, o)
          ), positionMap.set(E, E.el.getBoundingClientRect());
        }
      return createVNode(S, null, d);
    };
  }
}, removeMode = (e) => delete e.mode;
TransitionGroupImpl.props;
const TransitionGroup = TransitionGroupImpl;
function callPendingCbs(e) {
  const n = e.el;
  n._moveCb && n._moveCb(), n._enterCb && n._enterCb();
}
function recordPosition(e) {
  newPositionMap.set(e, e.el.getBoundingClientRect());
}
function applyTranslation(e) {
  const n = positionMap.get(e), o = newPositionMap.get(e), u = n.left - o.left, c = n.top - o.top;
  if (u || c) {
    const d = e.el.style;
    return d.transform = d.webkitTransform = `translate(${u}px,${c}px)`, d.transitionDuration = "0s", e;
  }
}
function hasCSSTransform(e, n, o) {
  const u = e.cloneNode();
  e._vtc && e._vtc.forEach((m) => {
    m.split(/\s+/).forEach((v) => v && u.classList.remove(v));
  }), o.split(/\s+/).forEach((m) => m && u.classList.add(m)), u.style.display = "none";
  const c = n.nodeType === 1 ? n : n.parentNode;
  c.appendChild(u);
  const { hasTransform: d } = getTransitionInfo(u);
  return c.removeChild(u), d;
}
const getModelAssigner = (e) => {
  const n = e.props["onUpdate:modelValue"] || !1;
  return isArray$7(n) ? (o) => invokeArrayFns(n, o) : n;
};
function onCompositionStart(e) {
  e.target.composing = !0;
}
function onCompositionEnd(e) {
  const n = e.target;
  n.composing && (n.composing = !1, n.dispatchEvent(new Event("input")));
}
const vModelText = {
  created(e, { modifiers: { lazy: n, trim: o, number: u } }, c) {
    e._assign = getModelAssigner(c);
    const d = u || c.props && c.props.type === "number";
    addEventListener(e, n ? "change" : "input", (m) => {
      if (m.target.composing)
        return;
      let v = e.value;
      o && (v = v.trim()), d && (v = looseToNumber(v)), e._assign(v);
    }), o && addEventListener(e, "change", () => {
      e.value = e.value.trim();
    }), n || (addEventListener(e, "compositionstart", onCompositionStart), addEventListener(e, "compositionend", onCompositionEnd), addEventListener(e, "change", onCompositionEnd));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: n }) {
    e.value = n ?? "";
  },
  beforeUpdate(e, { value: n, modifiers: { lazy: o, trim: u, number: c } }, d) {
    if (e._assign = getModelAssigner(d), e.composing || document.activeElement === e && e.type !== "range" && (o || u && e.value.trim() === n || (c || e.type === "number") && looseToNumber(e.value) === n))
      return;
    const m = n ?? "";
    e.value !== m && (e.value = m);
  }
}, vModelCheckbox = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(e, n, o) {
    e._assign = getModelAssigner(o), addEventListener(e, "change", () => {
      const u = e._modelValue, c = getValue(e), d = e.checked, m = e._assign;
      if (isArray$7(u)) {
        const v = looseIndexOf(u, c), S = v !== -1;
        if (d && !S)
          m(u.concat(c));
        else if (!d && S) {
          const $ = [...u];
          $.splice(v, 1), m($);
        }
      } else if (isSet$2(u)) {
        const v = new Set(u);
        d ? v.add(c) : v.delete(c), m(v);
      } else
        m(getCheckboxValue(e, d));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: setChecked,
  beforeUpdate(e, n, o) {
    e._assign = getModelAssigner(o), setChecked(e, n, o);
  }
};
function setChecked(e, { value: n, oldValue: o }, u) {
  e._modelValue = n, isArray$7(n) ? e.checked = looseIndexOf(n, u.props.value) > -1 : isSet$2(n) ? e.checked = n.has(u.props.value) : n !== o && (e.checked = looseEqual(n, getCheckboxValue(e, !0)));
}
const vModelRadio = {
  created(e, { value: n }, o) {
    e.checked = looseEqual(n, o.props.value), e._assign = getModelAssigner(o), addEventListener(e, "change", () => {
      e._assign(getValue(e));
    });
  },
  beforeUpdate(e, { value: n, oldValue: o }, u) {
    e._assign = getModelAssigner(u), n !== o && (e.checked = looseEqual(n, u.props.value));
  }
}, vModelSelect = {
  // <select multiple> value need to be deep traversed
  deep: !0,
  created(e, { value: n, modifiers: { number: o } }, u) {
    const c = isSet$2(n);
    addEventListener(e, "change", () => {
      const d = Array.prototype.filter.call(e.options, (m) => m.selected).map(
        (m) => o ? looseToNumber(getValue(m)) : getValue(m)
      );
      e._assign(
        e.multiple ? c ? new Set(d) : d : d[0]
      );
    }), e._assign = getModelAssigner(u);
  },
  // set value in mounted & updated because <select> relies on its children
  // <option>s.
  mounted(e, { value: n }) {
    setSelected(e, n);
  },
  beforeUpdate(e, n, o) {
    e._assign = getModelAssigner(o);
  },
  updated(e, { value: n }) {
    setSelected(e, n);
  }
};
function setSelected(e, n) {
  const o = e.multiple;
  if (o && !isArray$7(n) && !isSet$2(n)) {
    browser$1$1.env.NODE_ENV !== "production" && warn(
      `<select multiple v-model> expects an Array or Set value for its binding, but got ${Object.prototype.toString.call(n).slice(8, -1)}.`
    );
    return;
  }
  for (let u = 0, c = e.options.length; u < c; u++) {
    const d = e.options[u], m = getValue(d);
    if (o)
      isArray$7(n) ? d.selected = looseIndexOf(n, m) > -1 : d.selected = n.has(m);
    else if (looseEqual(getValue(d), n)) {
      e.selectedIndex !== u && (e.selectedIndex = u);
      return;
    }
  }
  !o && e.selectedIndex !== -1 && (e.selectedIndex = -1);
}
function getValue(e) {
  return "_value" in e ? e._value : e.value;
}
function getCheckboxValue(e, n) {
  const o = n ? "_trueValue" : "_falseValue";
  return o in e ? e[o] : n;
}
const vModelDynamic = {
  created(e, n, o) {
    callModelHook(e, n, o, null, "created");
  },
  mounted(e, n, o) {
    callModelHook(e, n, o, null, "mounted");
  },
  beforeUpdate(e, n, o, u) {
    callModelHook(e, n, o, u, "beforeUpdate");
  },
  updated(e, n, o, u) {
    callModelHook(e, n, o, u, "updated");
  }
};
function resolveDynamicModel(e, n) {
  switch (e) {
    case "SELECT":
      return vModelSelect;
    case "TEXTAREA":
      return vModelText;
    default:
      switch (n) {
        case "checkbox":
          return vModelCheckbox;
        case "radio":
          return vModelRadio;
        default:
          return vModelText;
      }
  }
}
function callModelHook(e, n, o, u, c) {
  const m = resolveDynamicModel(
    e.tagName,
    o.props && o.props.type
  )[c];
  m && m(e, n, o, u);
}
function initVModelForSSR() {
  vModelText.getSSRProps = ({ value: e }) => ({ value: e }), vModelRadio.getSSRProps = ({ value: e }, n) => {
    if (n.props && looseEqual(n.props.value, e))
      return { checked: !0 };
  }, vModelCheckbox.getSSRProps = ({ value: e }, n) => {
    if (isArray$7(e)) {
      if (n.props && looseIndexOf(e, n.props.value) > -1)
        return { checked: !0 };
    } else if (isSet$2(e)) {
      if (n.props && e.has(n.props.value))
        return { checked: !0 };
    } else if (e)
      return { checked: !0 };
  }, vModelDynamic.getSSRProps = (e, n) => {
    if (typeof n.type != "string")
      return;
    const o = resolveDynamicModel(
      // resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
      n.type.toUpperCase(),
      n.props && n.props.type
    );
    if (o.getSSRProps)
      return o.getSSRProps(e, n);
  };
}
const systemModifiers = ["ctrl", "shift", "alt", "meta"], modifierGuards = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, n) => systemModifiers.some((o) => e[`${o}Key`] && !n.includes(o))
}, withModifiers = (e, n) => (o, ...u) => {
  for (let c = 0; c < n.length; c++) {
    const d = modifierGuards[n[c]];
    if (d && d(o, n))
      return;
  }
  return e(o, ...u);
}, keyNames = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, withKeys = (e, n) => (o) => {
  if (!("key" in o))
    return;
  const u = hyphenate(o.key);
  if (n.some((c) => c === u || keyNames[c] === u))
    return e(o);
}, vShow = {
  beforeMount(e, { value: n }, { transition: o }) {
    e._vod = e.style.display === "none" ? "" : e.style.display, o && n ? o.beforeEnter(e) : setDisplay(e, n);
  },
  mounted(e, { value: n }, { transition: o }) {
    o && n && o.enter(e);
  },
  updated(e, { value: n, oldValue: o }, { transition: u }) {
    !n != !o && (u ? n ? (u.beforeEnter(e), setDisplay(e, !0), u.enter(e)) : u.leave(e, () => {
      setDisplay(e, !1);
    }) : setDisplay(e, n));
  },
  beforeUnmount(e, { value: n }) {
    setDisplay(e, n);
  }
};
function setDisplay(e, n) {
  e.style.display = n ? e._vod : "none";
}
function initVShowForSSR() {
  vShow.getSSRProps = ({ value: e }) => {
    if (!e)
      return { style: { display: "none" } };
  };
}
const rendererOptions = /* @__PURE__ */ extend$5({ patchProp }, nodeOps);
let renderer, enabledHydration = !1;
function ensureRenderer() {
  return renderer || (renderer = createRenderer(rendererOptions));
}
function ensureHydrationRenderer() {
  return renderer = enabledHydration ? renderer : createHydrationRenderer(rendererOptions), enabledHydration = !0, renderer;
}
const render$1 = (...e) => {
  ensureRenderer().render(...e);
}, hydrate = (...e) => {
  ensureHydrationRenderer().hydrate(...e);
}, createApp = (...e) => {
  const n = ensureRenderer().createApp(...e);
  browser$1$1.env.NODE_ENV !== "production" && (injectNativeTagCheck(n), injectCompilerOptionsCheck(n));
  const { mount: o } = n;
  return n.mount = (u) => {
    const c = normalizeContainer(u);
    if (!c)
      return;
    const d = n._component;
    !isFunction$7(d) && !d.render && !d.template && (d.template = c.innerHTML), c.innerHTML = "";
    const m = o(c, !1, c instanceof SVGElement);
    return c instanceof Element && (c.removeAttribute("v-cloak"), c.setAttribute("data-v-app", "")), m;
  }, n;
}, createSSRApp = (...e) => {
  const n = ensureHydrationRenderer().createApp(...e);
  browser$1$1.env.NODE_ENV !== "production" && (injectNativeTagCheck(n), injectCompilerOptionsCheck(n));
  const { mount: o } = n;
  return n.mount = (u) => {
    const c = normalizeContainer(u);
    if (c)
      return o(c, !0, c instanceof SVGElement);
  }, n;
};
function injectNativeTagCheck(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (n) => isHTMLTag(n) || isSVGTag(n),
    writable: !1
  });
}
function injectCompilerOptionsCheck(e) {
  if (isRuntimeOnly()) {
    const n = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return n;
      },
      set() {
        warn(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const o = e.config.compilerOptions, u = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return warn(u), o;
      },
      set() {
        warn(u);
      }
    });
  }
}
function normalizeContainer(e) {
  if (isString$5(e)) {
    const n = document.querySelector(e);
    return browser$1$1.env.NODE_ENV !== "production" && !n && warn(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), n;
  }
  return browser$1$1.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && warn(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
let ssrDirectiveInitialized = !1;
const initDirectivesForSSR = () => {
  ssrDirectiveInitialized || (ssrDirectiveInitialized = !0, initVModelForSSR(), initVShowForSSR());
};
function initDev() {
  initCustomFormatter();
}
browser$1$1.env.NODE_ENV !== "production" && initDev();
const compile = () => {
  browser$1$1.env.NODE_ENV !== "production" && warn(
    'Runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
    /* should not happen */
  );
}, vue_runtime_esmBundler = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseTransition,
  BaseTransitionPropsValidators,
  Comment,
  EffectScope,
  Fragment,
  KeepAlive,
  ReactiveEffect,
  Static,
  Suspense,
  Teleport,
  Text: Text$1,
  Transition,
  TransitionGroup,
  VueElement,
  assertNumber: assertNumber$a,
  callWithAsyncErrorHandling,
  callWithErrorHandling,
  camelize,
  capitalize,
  cloneVNode,
  compatUtils,
  compile,
  computed,
  createApp,
  createBlock,
  createCommentVNode,
  createElementBlock,
  createElementVNode: createBaseVNode,
  createHydrationRenderer,
  createPropsRestProxy,
  createRenderer,
  createSSRApp,
  createSlots,
  createStaticVNode,
  createTextVNode,
  createVNode,
  customRef,
  defineAsyncComponent,
  defineComponent,
  defineCustomElement,
  defineEmits,
  defineExpose,
  defineModel,
  defineOptions,
  defineProps,
  defineSSRCustomElement,
  defineSlots,
  get devtools() {
    return devtools;
  },
  effect,
  effectScope,
  getCurrentInstance,
  getCurrentScope,
  getTransitionRawChildren,
  guardReactiveProps,
  h,
  handleError,
  hasInjectionContext,
  hydrate,
  initCustomFormatter,
  initDirectivesForSSR,
  inject,
  isMemoSame,
  isProxy,
  isReactive,
  isReadonly,
  isRef,
  isRuntimeOnly,
  isShallow: isShallow$1,
  isVNode,
  markRaw,
  mergeDefaults,
  mergeModels,
  mergeProps,
  nextTick,
  normalizeClass,
  normalizeProps,
  normalizeStyle,
  onActivated,
  onBeforeMount,
  onBeforeUnmount,
  onBeforeUpdate,
  onDeactivated,
  onErrorCaptured,
  onMounted,
  onRenderTracked,
  onRenderTriggered,
  onScopeDispose,
  onServerPrefetch,
  onUnmounted,
  onUpdated,
  openBlock,
  popScopeId,
  provide,
  proxyRefs,
  pushScopeId,
  queuePostFlushCb,
  reactive,
  readonly,
  ref,
  registerRuntimeCompiler,
  render: render$1,
  renderList,
  renderSlot,
  resolveComponent,
  resolveDirective,
  resolveDynamicComponent,
  resolveFilter,
  resolveTransitionHooks,
  setBlockTracking,
  setDevtoolsHook,
  setTransitionHooks,
  shallowReactive,
  shallowReadonly,
  shallowRef,
  ssrContextKey,
  ssrUtils,
  stop,
  toDisplayString,
  toHandlerKey,
  toHandlers,
  toRaw,
  toRef,
  toRefs,
  toValue,
  transformVNodeArgs,
  triggerRef,
  unref,
  useAttrs,
  useCssModule,
  useCssVars,
  useModel,
  useSSRContext,
  useSlots,
  useTransitionState,
  vModelCheckbox,
  vModelDynamic,
  vModelRadio,
  vModelSelect,
  vModelText,
  vShow,
  version: version$6,
  warn,
  watch,
  watchEffect,
  watchPostEffect,
  watchSyncEffect,
  withAsyncContext,
  withCtx,
  withDefaults,
  withDirectives,
  withKeys,
  withMemo,
  withModifiers,
  withScopeId
}, Symbol.toStringTag, { value: "Module" }));
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function getAugmentedNamespace(e) {
  if (e.__esModule)
    return e;
  var n = e.default;
  if (typeof n == "function") {
    var o = function u() {
      if (this instanceof u) {
        var c = [null];
        c.push.apply(c, arguments);
        var d = Function.bind.apply(n, c);
        return new d();
      }
      return n.apply(this, arguments);
    };
    o.prototype = n.prototype;
  } else
    o = {};
  return Object.defineProperty(o, "__esModule", { value: !0 }), Object.keys(e).forEach(function(u) {
    var c = Object.getOwnPropertyDescriptor(e, u);
    Object.defineProperty(o, u, c.get ? c : {
      enumerable: !0,
      get: function() {
        return e[u];
      }
    });
  }), o;
}
var dist$6 = { exports: {} };
(function(e, n) {
  (function(o, u) {
    e.exports = u();
  })(typeof self < "u" ? self : commonjsGlobal, function() {
    return (() => {
      var o = { d: (ne, H) => {
        for (var C in H)
          o.o(H, C) && !o.o(ne, C) && Object.defineProperty(ne, C, { enumerable: !0, get: H[C] });
      } };
      o.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), o.o = (ne, H) => Object.prototype.hasOwnProperty.call(ne, H);
      var u = {};
      o.d(u, { default: () => oe });
      const c = (ne) => {
        const H = /* @__PURE__ */ Object.create(null);
        return (C) => H[C] || (H[C] = ne(C));
      }, d = c((ne) => ne.charAt(0).toUpperCase() + ne.slice(1)), m = c((ne) => ne ? `on${d(ne)}` : "");
      var v = /-(\w)/g, S = function(ne) {
        return ne.replace(v, function(H, C) {
          return C ? C.toUpperCase() : "";
        });
      }, $ = /\B([A-Z])/g, E = function(ne) {
        return ne.replace($, "-$1").toLowerCase();
      };
      function O(ne, H) {
        return new CustomEvent(ne, { bubbles: !1, cancelable: !1, detail: H.length === 1 ? H[0] : H });
      }
      var T = function(ne) {
        return /function Boolean/.test(String(ne));
      }, y = function(ne) {
        return /function Number/.test(String(ne));
      };
      function V(ne, H) {
        if (ne.nodeType === 3)
          return ne.data.trim() ? ne.data : null;
        if (ne.nodeType === 1) {
          var C = { attrs: M(ne), domProps: { innerHTML: ne.innerHTML } };
          return C.attrs.slot && (C.slot = C.attrs.slot, delete C.attrs.slot), H(ne.tagName, C);
        }
        return null;
      }
      function M(ne) {
        for (var H = {}, C = 0, w = ne.attributes.length; C < w; C++) {
          var P = ne.attributes[C];
          H[P.nodeName] = P.nodeValue;
        }
        return H;
      }
      function G(ne) {
        return G = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
          return typeof H;
        } : function(H) {
          return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
        }, G(ne);
      }
      function k(ne, H) {
        for (var C = 0; C < H.length; C++) {
          var w = H[C];
          w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(ne, w.key, w);
        }
      }
      function F(ne, H) {
        return !H || G(H) !== "object" && typeof H != "function" ? X(ne) : H;
      }
      function X(ne) {
        if (ne === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return ne;
      }
      function ee(ne) {
        var H = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
        return ee = function(C) {
          if (C === null || (w = C, Function.toString.call(w).indexOf("[native code]") === -1))
            return C;
          var w;
          if (typeof C != "function")
            throw new TypeError("Super expression must either be null or a function");
          if (H !== void 0) {
            if (H.has(C))
              return H.get(C);
            H.set(C, P);
          }
          function P() {
            return ue(C, arguments, pe(this).constructor);
          }
          return P.prototype = Object.create(C.prototype, { constructor: { value: P, enumerable: !1, writable: !0, configurable: !0 } }), Y(P, C);
        }, ee(ne);
      }
      function ue(ne, H, C) {
        return ue = Q() ? Reflect.construct : function(w, P, J) {
          var se = [null];
          se.push.apply(se, P);
          var fe = new (Function.bind.apply(w, se))();
          return J && Y(fe, J.prototype), fe;
        }, ue.apply(null, arguments);
      }
      function Q() {
        if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
          return !1;
        if (typeof Proxy == "function")
          return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
          })), !0;
        } catch {
          return !1;
        }
      }
      function Y(ne, H) {
        return Y = Object.setPrototypeOf || function(C, w) {
          return C.__proto__ = w, C;
        }, Y(ne, H);
      }
      function pe(ne) {
        return pe = Object.setPrototypeOf ? Object.getPrototypeOf : function(H) {
          return H.__proto__ || Object.getPrototypeOf(H);
        }, pe(ne);
      }
      function oe(ne, H, C, w) {
        var P, J, se, fe = ne, N = !1, W = function(I) {
          (function(nt, Qt) {
            if (typeof Qt != "function" && Qt !== null)
              throw new TypeError("Super expression must either be null or a function");
            nt.prototype = Object.create(Qt && Qt.prototype, { constructor: { value: nt, writable: !0, configurable: !0 } }), Qt && Y(nt, Qt);
          })(ze, I);
          var te, ge, Pe, Ke, xe = (te = ze, ge = Q(), function() {
            var nt, Qt = pe(te);
            if (ge) {
              var Et = pe(this).constructor;
              nt = Reflect.construct(Qt, arguments, Et);
            } else
              nt = Qt.apply(this, arguments);
            return F(this, nt);
          });
          function ze() {
            var nt;
            return function(Qt, Et) {
              if (!(Qt instanceof Et))
                throw new TypeError("Cannot call a class as a function");
            }(this, ze), (nt = xe.call(this))._wrapper = void 0, nt._component = void 0, nt._props = void 0, nt._slotChildren = void 0, nt._mounted = !1, nt._props = {}, nt._slotChildren = [], new MutationObserver(function(Qt) {
              for (var Et = 0; Et < Qt.length; Et++) {
                var zt = Qt[Et];
                !N || zt.type !== "attributes" || zt.target !== X(nt) || zt.attributeName && nt.syncAttribute(zt.attributeName);
              }
            }).observe(X(nt), { childList: !0, subtree: !0, characterData: !0, attributes: !0 }), nt;
          }
          return Pe = ze, Ke = [{ key: "createEventProxies", value: function(nt) {
            var Qt = this, Et = {};
            return nt && nt.forEach(function(zt) {
              var Nt = m(S(zt));
              Et[Nt] = function() {
                for (var pt = arguments.length, at = new Array(pt), kt = 0; kt < pt; kt++)
                  at[kt] = arguments[kt];
                Qt.dispatchEvent(O(zt, at));
              };
            }), Et;
          } }, { key: "syncAttribute", value: function(nt) {
            var Qt, Et = S(nt), zt = void 0;
            this.hasOwnProperty(nt) ? zt = this[nt] : this.hasAttribute(nt) && (zt = this.getAttribute(nt)), this._props[Et] = function(Nt, pt) {
              var at = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).type;
              if (T(at))
                return Nt === "true" || Nt === "false" ? Nt === "true" : Nt === "" || Nt === pt || Nt != null;
              if (y(at)) {
                var kt = parseFloat(Nt);
                return isNaN(kt) ? Nt : kt;
              }
              return Nt;
            }(zt, nt, se[Et]), (Qt = this._component) === null || Qt === void 0 || Qt.$forceUpdate();
          } }, { key: "syncSlots", value: function() {
            var nt;
            this._slotChildren = function(Qt, Et) {
              for (var zt = [], Nt = 0, pt = Qt.length; Nt < pt; Nt++)
                zt.push(V(Qt[Nt], Et));
              return zt;
            }(this.childNodes, C), (nt = this._component) === null || nt === void 0 || nt.$forceUpdate();
          } }, { key: "syncInitialAttributes", value: function() {
            var nt, Qt = this;
            this._props = (nt = {}, J.forEach(function(Et) {
              nt[Et] = void 0;
            }), nt), P.forEach(function(Et) {
              Qt.syncAttribute(Et);
            });
          } }, { key: "connectedCallback", value: function() {
            N && this.syncInitialAttributes();
            var nt = this.createEventProxies(fe.emits), Qt = this;
            this._wrapper = H({ render: function() {
              var Et = Object.assign({}, Qt._props, nt);
              return delete Et.dataVApp, C(fe, Et, function() {
                return Qt._slotChildren;
              });
            }, mounted: function() {
              Qt._mounted = !0;
            }, unmounted: function() {
              Qt._mounted = !1;
            } }), this.syncSlots(), this._component = this._wrapper.mount(this), w != null && w.connectedCallback && w.connectedCallback.bind(this)();
          } }, { key: "disconnectedCallback", value: function() {
            var nt;
            (nt = this._wrapper) === null || nt === void 0 || nt.unmount();
          } }], Ke && k(Pe.prototype, Ke), ze;
        }(ee(HTMLElement));
        return function() {
          if (!N) {
            var I = Array.isArray(fe.props) ? fe.props : Object.keys(fe.props || {});
            P = I.map(E), J = I.map(S);
            var te = Array.isArray(fe.props) ? {} : fe.props || {};
            se = J.reduce(function(ge, Pe, Ke) {
              return ge[Pe] = te[I[Ke]], ge;
            }, {}), N = !0;
          }
        }(), W;
      }
      return u.default;
    })();
  });
})(dist$6);
var distExports = dist$6.exports;
const wrapper = /* @__PURE__ */ getDefaultExportFromCjs(distExports);
var build$W = {}, bip39$7 = {}, build$V = {}, ascii$7 = {};
Object.defineProperty(ascii$7, "__esModule", { value: !0 });
ascii$7.fromAscii = ascii$7.toAscii = void 0;
function toAscii$7(e) {
  const n = (o) => o.split("").map((u) => {
    const c = u.charCodeAt(0);
    if (c < 32 || c > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + c);
    return c;
  });
  return Uint8Array.from(n(e));
}
ascii$7.toAscii = toAscii$7;
function fromAscii$7(e) {
  return ((o) => o.map((u) => {
    if (u < 32 || u > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + u);
    return String.fromCharCode(u);
  }))(Array.from(e)).join("");
}
ascii$7.fromAscii = fromAscii$7;
var base64$9 = {}, base64Js = {};
base64Js.byteLength = byteLength$1;
base64Js.toByteArray = toByteArray$1;
base64Js.fromByteArray = fromByteArray$1;
var lookup$1 = [], revLookup$1 = [], Arr$1 = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$1 = 0, len = code.length; i$1 < len; ++i$1)
  lookup$1[i$1] = code[i$1], revLookup$1[code.charCodeAt(i$1)] = i$1;
revLookup$1["-".charCodeAt(0)] = 62;
revLookup$1["_".charCodeAt(0)] = 63;
function getLens(e) {
  var n = e.length;
  if (n % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var o = e.indexOf("=");
  o === -1 && (o = n);
  var u = o === n ? 0 : 4 - o % 4;
  return [o, u];
}
function byteLength$1(e) {
  var n = getLens(e), o = n[0], u = n[1];
  return (o + u) * 3 / 4 - u;
}
function _byteLength(e, n, o) {
  return (n + o) * 3 / 4 - o;
}
function toByteArray$1(e) {
  var n, o = getLens(e), u = o[0], c = o[1], d = new Arr$1(_byteLength(e, u, c)), m = 0, v = c > 0 ? u - 4 : u, S;
  for (S = 0; S < v; S += 4)
    n = revLookup$1[e.charCodeAt(S)] << 18 | revLookup$1[e.charCodeAt(S + 1)] << 12 | revLookup$1[e.charCodeAt(S + 2)] << 6 | revLookup$1[e.charCodeAt(S + 3)], d[m++] = n >> 16 & 255, d[m++] = n >> 8 & 255, d[m++] = n & 255;
  return c === 2 && (n = revLookup$1[e.charCodeAt(S)] << 2 | revLookup$1[e.charCodeAt(S + 1)] >> 4, d[m++] = n & 255), c === 1 && (n = revLookup$1[e.charCodeAt(S)] << 10 | revLookup$1[e.charCodeAt(S + 1)] << 4 | revLookup$1[e.charCodeAt(S + 2)] >> 2, d[m++] = n >> 8 & 255, d[m++] = n & 255), d;
}
function tripletToBase64$1(e) {
  return lookup$1[e >> 18 & 63] + lookup$1[e >> 12 & 63] + lookup$1[e >> 6 & 63] + lookup$1[e & 63];
}
function encodeChunk$1(e, n, o) {
  for (var u, c = [], d = n; d < o; d += 3)
    u = (e[d] << 16 & 16711680) + (e[d + 1] << 8 & 65280) + (e[d + 2] & 255), c.push(tripletToBase64$1(u));
  return c.join("");
}
function fromByteArray$1(e) {
  for (var n, o = e.length, u = o % 3, c = [], d = 16383, m = 0, v = o - u; m < v; m += d)
    c.push(encodeChunk$1(e, m, m + d > v ? v : m + d));
  return u === 1 ? (n = e[o - 1], c.push(
    lookup$1[n >> 2] + lookup$1[n << 4 & 63] + "=="
  )) : u === 2 && (n = (e[o - 2] << 8) + e[o - 1], c.push(
    lookup$1[n >> 10] + lookup$1[n >> 4 & 63] + lookup$1[n << 2 & 63] + "="
  )), c.join("");
}
var __createBinding$W = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$W = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$W = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$W(n, e, o);
  return __setModuleDefault$W(n, e), n;
};
Object.defineProperty(base64$9, "__esModule", { value: !0 });
base64$9.fromBase64 = base64$9.toBase64 = void 0;
const base64js$7 = __importStar$W(base64Js);
function toBase64$7(e) {
  return base64js$7.fromByteArray(e);
}
base64$9.toBase64 = toBase64$7;
function fromBase64$7(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$7.toByteArray(e);
}
base64$9.fromBase64 = fromBase64$7;
var bech32$g = {}, ALPHABET$3 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP = {};
for (var z = 0; z < ALPHABET$3.length; z++) {
  var x$1 = ALPHABET$3.charAt(z);
  if (ALPHABET_MAP[x$1] !== void 0)
    throw new TypeError(x$1 + " is ambiguous");
  ALPHABET_MAP[x$1] = z;
}
function polymodStep(e) {
  var n = e >> 25;
  return (e & 33554431) << 5 ^ -(n >> 0 & 1) & 996825010 ^ -(n >> 1 & 1) & 642813549 ^ -(n >> 2 & 1) & 513874426 ^ -(n >> 3 & 1) & 1027748829 ^ -(n >> 4 & 1) & 705979059;
}
function prefixChk(e) {
  for (var n = 1, o = 0; o < e.length; ++o) {
    var u = e.charCodeAt(o);
    if (u < 33 || u > 126)
      return "Invalid prefix (" + e + ")";
    n = polymodStep(n) ^ u >> 5;
  }
  for (n = polymodStep(n), o = 0; o < e.length; ++o) {
    var c = e.charCodeAt(o);
    n = polymodStep(n) ^ c & 31;
  }
  return n;
}
function encode$5(e, n, o) {
  if (o = o || 90, e.length + 7 + n.length > o)
    throw new TypeError("Exceeds length limit");
  e = e.toLowerCase();
  var u = prefixChk(e);
  if (typeof u == "string")
    throw new Error(u);
  for (var c = e + "1", d = 0; d < n.length; ++d) {
    var m = n[d];
    if (m >> 5)
      throw new Error("Non 5-bit word");
    u = polymodStep(u) ^ m, c += ALPHABET$3.charAt(m);
  }
  for (d = 0; d < 6; ++d)
    u = polymodStep(u);
  for (u ^= 1, d = 0; d < 6; ++d) {
    var v = u >> (5 - d) * 5 & 31;
    c += ALPHABET$3.charAt(v);
  }
  return c;
}
function __decode(e, n) {
  if (n = n || 90, e.length < 8)
    return e + " too short";
  if (e.length > n)
    return "Exceeds length limit";
  var o = e.toLowerCase(), u = e.toUpperCase();
  if (e !== o && e !== u)
    return "Mixed-case string " + e;
  e = o;
  var c = e.lastIndexOf("1");
  if (c === -1)
    return "No separator character for " + e;
  if (c === 0)
    return "Missing prefix for " + e;
  var d = e.slice(0, c), m = e.slice(c + 1);
  if (m.length < 6)
    return "Data too short";
  var v = prefixChk(d);
  if (typeof v == "string")
    return v;
  for (var S = [], $ = 0; $ < m.length; ++$) {
    var E = m.charAt($), O = ALPHABET_MAP[E];
    if (O === void 0)
      return "Unknown character " + E;
    v = polymodStep(v) ^ O, !($ + 6 >= m.length) && S.push(O);
  }
  return v !== 1 ? "Invalid checksum for " + e : { prefix: d, words: S };
}
function decodeUnsafe() {
  var e = __decode.apply(null, arguments);
  if (typeof e == "object")
    return e;
}
function decode$2(e) {
  var n = __decode.apply(null, arguments);
  if (typeof n == "object")
    return n;
  throw new Error(n);
}
function convert(e, n, o, u) {
  for (var c = 0, d = 0, m = (1 << o) - 1, v = [], S = 0; S < e.length; ++S)
    for (c = c << n | e[S], d += n; d >= o; )
      d -= o, v.push(c >> d & m);
  if (u)
    d > 0 && v.push(c << o - d & m);
  else {
    if (d >= n)
      return "Excess padding";
    if (c << o - d & m)
      return "Non-zero padding";
  }
  return v;
}
function toWordsUnsafe(e) {
  var n = convert(e, 8, 5, !0);
  if (Array.isArray(n))
    return n;
}
function toWords(e) {
  var n = convert(e, 8, 5, !0);
  if (Array.isArray(n))
    return n;
  throw new Error(n);
}
function fromWordsUnsafe(e) {
  var n = convert(e, 5, 8, !1);
  if (Array.isArray(n))
    return n;
}
function fromWords(e) {
  var n = convert(e, 5, 8, !1);
  if (Array.isArray(n))
    return n;
  throw new Error(n);
}
var bech32$f = {
  decodeUnsafe,
  decode: decode$2,
  encode: encode$5,
  toWordsUnsafe,
  toWords,
  fromWordsUnsafe,
  fromWords
}, __createBinding$V = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$V = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$V = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$V(n, e, o);
  return __setModuleDefault$V(n, e), n;
};
Object.defineProperty(bech32$g, "__esModule", { value: !0 });
bech32$g.normalizeBech32 = bech32$g.fromBech32 = bech32$g.toBech32 = void 0;
const bech32$e = __importStar$V(bech32$f);
function toBech32$7(e, n, o) {
  return bech32$e.encode(e, bech32$e.toWords(n), o);
}
bech32$g.toBech32 = toBech32$7;
function fromBech32$7(e, n = 1 / 0) {
  const o = bech32$e.decode(e, n);
  return {
    prefix: o.prefix,
    data: new Uint8Array(bech32$e.fromWords(o.words))
  };
}
bech32$g.fromBech32 = fromBech32$7;
function normalizeBech32$7(e) {
  const { prefix: n, data: o } = fromBech32$7(e);
  return toBech32$7(n, o);
}
bech32$g.normalizeBech32 = normalizeBech32$7;
var hex$7 = {};
Object.defineProperty(hex$7, "__esModule", { value: !0 });
hex$7.fromHex = hex$7.toHex = void 0;
function toHex$9(e) {
  let n = "";
  for (const o of e)
    n += ("0" + o.toString(16)).slice(-2);
  return n;
}
hex$7.toHex = toHex$9;
function fromHex$7(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let o = 0; o < n.length; o++) {
    const u = 2 * o, c = e.slice(u, u + 2);
    if (!c.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[o] = parseInt(c, 16);
  }
  return n;
}
hex$7.fromHex = fromHex$7;
var rfc3339$7 = {};
Object.defineProperty(rfc3339$7, "__esModule", { value: !0 });
rfc3339$7.toRfc3339 = rfc3339$7.fromRfc3339 = void 0;
const rfc3339Matcher$7 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$7(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function fromRfc3339$7(e) {
  const n = rfc3339Matcher$7.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const o = +n[1], u = +n[2], c = +n[3], d = +n[4], m = +n[5], v = +n[6], S = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let $, E, O;
  n[8] === "Z" ? ($ = 1, E = 0, O = 0) : ($ = n[8].substring(0, 1) === "-" ? -1 : 1, E = +n[8].substring(1, 3), O = +n[8].substring(4, 6));
  const T = $ * (E * 60 + O) * 60, y = Date.UTC(o, u - 1, c, d, m, v, S) - T * 1e3;
  return new Date(y);
}
rfc3339$7.fromRfc3339 = fromRfc3339$7;
function toRfc3339$7(e) {
  const n = e.getUTCFullYear(), o = padded$7(e.getUTCMonth() + 1), u = padded$7(e.getUTCDate()), c = padded$7(e.getUTCHours()), d = padded$7(e.getUTCMinutes()), m = padded$7(e.getUTCSeconds()), v = padded$7(e.getUTCMilliseconds(), 3);
  return `${n}-${o}-${u}T${c}:${d}:${m}.${v}Z`;
}
rfc3339$7.toRfc3339 = toRfc3339$7;
var utf8$b = {};
Object.defineProperty(utf8$b, "__esModule", { value: !0 });
utf8$b.fromUtf8 = utf8$b.toUtf8 = void 0;
function toUtf8$7(e) {
  return new TextEncoder().encode(e);
}
utf8$b.toUtf8 = toUtf8$7;
function fromUtf8$7(e, n = !1) {
  const o = !n;
  return new TextDecoder("utf-8", { fatal: o }).decode(e);
}
utf8$b.fromUtf8 = fromUtf8$7;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = ascii$7;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var o = base64$9;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return o.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return o.toBase64;
  } });
  var u = bech32$g;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return u.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return u.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return u.toBech32;
  } });
  var c = hex$7;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return c.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return c.toHex;
  } });
  var d = rfc3339$7;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return d.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return d.toRfc3339;
  } });
  var m = utf8$b;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return m.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return m.toUtf8;
  } });
})(build$V);
var pbkdf2$9 = {}, build$U = {}, arrays$7 = {};
Object.defineProperty(arrays$7, "__esModule", { value: !0 });
arrays$7.arrayContentStartsWith = arrays$7.arrayContentEquals = void 0;
function arrayContentEquals$7(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$7.arrayContentEquals = arrayContentEquals$7;
function arrayContentStartsWith$7(e, n) {
  if (e.length < n.length)
    return !1;
  for (let o = 0; o < n.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$7.arrayContentStartsWith = arrayContentStartsWith$7;
var assert$z = {};
Object.defineProperty(assert$z, "__esModule", { value: !0 });
assert$z.assertDefinedAndNotNull = assert$z.assertDefined = assert$z.assert = void 0;
function assert$y(e, n) {
  if (!e)
    throw new Error(n || "condition is not truthy");
}
assert$z.assert = assert$y;
function assertDefined$7(e, n) {
  if (e === void 0)
    throw new Error(n ?? "value is undefined");
}
assert$z.assertDefined = assertDefined$7;
function assertDefinedAndNotNull$7(e, n) {
  if (e == null)
    throw new Error(n ?? "value is undefined or null");
}
assert$z.assertDefinedAndNotNull = assertDefinedAndNotNull$7;
var sleep$f = {};
Object.defineProperty(sleep$f, "__esModule", { value: !0 });
sleep$f.sleep = void 0;
async function sleep$e(e) {
  return new Promise((n) => setTimeout(n, e));
}
sleep$f.sleep = sleep$e;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, inited = !1;
function init() {
  inited = !0;
  for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, o = e.length; n < o; ++n)
    lookup[n] = e[n], revLookup[e.charCodeAt(n)] = n;
  revLookup["-".charCodeAt(0)] = 62, revLookup["_".charCodeAt(0)] = 63;
}
function toByteArray(e) {
  inited || init();
  var n, o, u, c, d, m, v = e.length;
  if (v % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  d = e[v - 2] === "=" ? 2 : e[v - 1] === "=" ? 1 : 0, m = new Arr(v * 3 / 4 - d), u = d > 0 ? v - 4 : v;
  var S = 0;
  for (n = 0, o = 0; n < u; n += 4, o += 3)
    c = revLookup[e.charCodeAt(n)] << 18 | revLookup[e.charCodeAt(n + 1)] << 12 | revLookup[e.charCodeAt(n + 2)] << 6 | revLookup[e.charCodeAt(n + 3)], m[S++] = c >> 16 & 255, m[S++] = c >> 8 & 255, m[S++] = c & 255;
  return d === 2 ? (c = revLookup[e.charCodeAt(n)] << 2 | revLookup[e.charCodeAt(n + 1)] >> 4, m[S++] = c & 255) : d === 1 && (c = revLookup[e.charCodeAt(n)] << 10 | revLookup[e.charCodeAt(n + 1)] << 4 | revLookup[e.charCodeAt(n + 2)] >> 2, m[S++] = c >> 8 & 255, m[S++] = c & 255), m;
}
function tripletToBase64(e) {
  return lookup[e >> 18 & 63] + lookup[e >> 12 & 63] + lookup[e >> 6 & 63] + lookup[e & 63];
}
function encodeChunk(e, n, o) {
  for (var u, c = [], d = n; d < o; d += 3)
    u = (e[d] << 16) + (e[d + 1] << 8) + e[d + 2], c.push(tripletToBase64(u));
  return c.join("");
}
function fromByteArray(e) {
  inited || init();
  for (var n, o = e.length, u = o % 3, c = "", d = [], m = 16383, v = 0, S = o - u; v < S; v += m)
    d.push(encodeChunk(e, v, v + m > S ? S : v + m));
  return u === 1 ? (n = e[o - 1], c += lookup[n >> 2], c += lookup[n << 4 & 63], c += "==") : u === 2 && (n = (e[o - 2] << 8) + e[o - 1], c += lookup[n >> 10], c += lookup[n >> 4 & 63], c += lookup[n << 2 & 63], c += "="), d.push(c), d.join("");
}
function read(e, n, o, u, c) {
  var d, m, v = c * 8 - u - 1, S = (1 << v) - 1, $ = S >> 1, E = -7, O = o ? c - 1 : 0, T = o ? -1 : 1, y = e[n + O];
  for (O += T, d = y & (1 << -E) - 1, y >>= -E, E += v; E > 0; d = d * 256 + e[n + O], O += T, E -= 8)
    ;
  for (m = d & (1 << -E) - 1, d >>= -E, E += u; E > 0; m = m * 256 + e[n + O], O += T, E -= 8)
    ;
  if (d === 0)
    d = 1 - $;
  else {
    if (d === S)
      return m ? NaN : (y ? -1 : 1) * (1 / 0);
    m = m + Math.pow(2, u), d = d - $;
  }
  return (y ? -1 : 1) * m * Math.pow(2, d - u);
}
function write(e, n, o, u, c, d) {
  var m, v, S, $ = d * 8 - c - 1, E = (1 << $) - 1, O = E >> 1, T = c === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = u ? 0 : d - 1, V = u ? 1 : -1, M = n < 0 || n === 0 && 1 / n < 0 ? 1 : 0;
  for (n = Math.abs(n), isNaN(n) || n === 1 / 0 ? (v = isNaN(n) ? 1 : 0, m = E) : (m = Math.floor(Math.log(n) / Math.LN2), n * (S = Math.pow(2, -m)) < 1 && (m--, S *= 2), m + O >= 1 ? n += T / S : n += T * Math.pow(2, 1 - O), n * S >= 2 && (m++, S /= 2), m + O >= E ? (v = 0, m = E) : m + O >= 1 ? (v = (n * S - 1) * Math.pow(2, c), m = m + O) : (v = n * Math.pow(2, O - 1) * Math.pow(2, c), m = 0)); c >= 8; e[o + y] = v & 255, y += V, v /= 256, c -= 8)
    ;
  for (m = m << c | v, $ += c; $ > 0; e[o + y] = m & 255, y += V, m /= 256, $ -= 8)
    ;
  e[o + y - V] |= M * 128;
}
var toString$7 = {}.toString, isArray$6 = Array.isArray || function(e) {
  return toString$7.call(e) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var INSPECT_MAX_BYTES = 50;
Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== void 0 ? global$1.TYPED_ARRAY_SUPPORT : !0;
kMaxLength();
function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function createBuffer(e, n) {
  if (kMaxLength() < n)
    throw new RangeError("Invalid typed array length");
  return Buffer.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(n), e.__proto__ = Buffer.prototype) : (e === null && (e = new Buffer(n)), e.length = n), e;
}
function Buffer(e, n, o) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer))
    return new Buffer(e, n, o);
  if (typeof e == "number") {
    if (typeof n == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return allocUnsafe(this, e);
  }
  return from$1(this, e, n, o);
}
Buffer.poolSize = 8192;
Buffer._augment = function(e) {
  return e.__proto__ = Buffer.prototype, e;
};
function from$1(e, n, o, u) {
  if (typeof n == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && n instanceof ArrayBuffer ? fromArrayBuffer(e, n, o, u) : typeof n == "string" ? fromString$3(e, n, o) : fromObject(e, n);
}
Buffer.from = function(e, n, o) {
  return from$1(null, e, n, o);
};
Buffer.TYPED_ARRAY_SUPPORT && (Buffer.prototype.__proto__ = Uint8Array.prototype, Buffer.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Buffer[Symbol.species]);
function assertSize(e) {
  if (typeof e != "number")
    throw new TypeError('"size" argument must be a number');
  if (e < 0)
    throw new RangeError('"size" argument must not be negative');
}
function alloc(e, n, o, u) {
  return assertSize(n), n <= 0 ? createBuffer(e, n) : o !== void 0 ? typeof u == "string" ? createBuffer(e, n).fill(o, u) : createBuffer(e, n).fill(o) : createBuffer(e, n);
}
Buffer.alloc = function(e, n, o) {
  return alloc(null, e, n, o);
};
function allocUnsafe(e, n) {
  if (assertSize(n), e = createBuffer(e, n < 0 ? 0 : checked(n) | 0), !Buffer.TYPED_ARRAY_SUPPORT)
    for (var o = 0; o < n; ++o)
      e[o] = 0;
  return e;
}
Buffer.allocUnsafe = function(e) {
  return allocUnsafe(null, e);
};
Buffer.allocUnsafeSlow = function(e) {
  return allocUnsafe(null, e);
};
function fromString$3(e, n, o) {
  if ((typeof o != "string" || o === "") && (o = "utf8"), !Buffer.isEncoding(o))
    throw new TypeError('"encoding" must be a valid string encoding');
  var u = byteLength(n, o) | 0;
  e = createBuffer(e, u);
  var c = e.write(n, o);
  return c !== u && (e = e.slice(0, c)), e;
}
function fromArrayLike(e, n) {
  var o = n.length < 0 ? 0 : checked(n.length) | 0;
  e = createBuffer(e, o);
  for (var u = 0; u < o; u += 1)
    e[u] = n[u] & 255;
  return e;
}
function fromArrayBuffer(e, n, o, u) {
  if (n.byteLength, o < 0 || n.byteLength < o)
    throw new RangeError("'offset' is out of bounds");
  if (n.byteLength < o + (u || 0))
    throw new RangeError("'length' is out of bounds");
  return o === void 0 && u === void 0 ? n = new Uint8Array(n) : u === void 0 ? n = new Uint8Array(n, o) : n = new Uint8Array(n, o, u), Buffer.TYPED_ARRAY_SUPPORT ? (e = n, e.__proto__ = Buffer.prototype) : e = fromArrayLike(e, n), e;
}
function fromObject(e, n) {
  if (internalIsBuffer(n)) {
    var o = checked(n.length) | 0;
    return e = createBuffer(e, o), e.length === 0 || n.copy(e, 0, 0, o), e;
  }
  if (n) {
    if (typeof ArrayBuffer < "u" && n.buffer instanceof ArrayBuffer || "length" in n)
      return typeof n.length != "number" || isnan(n.length) ? createBuffer(e, 0) : fromArrayLike(e, n);
    if (n.type === "Buffer" && isArray$6(n.data))
      return fromArrayLike(e, n.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(e) {
  if (e >= kMaxLength())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
  return e | 0;
}
Buffer.isBuffer = isBuffer$5;
function internalIsBuffer(e) {
  return !!(e != null && e._isBuffer);
}
Buffer.compare = function(n, o) {
  if (!internalIsBuffer(n) || !internalIsBuffer(o))
    throw new TypeError("Arguments must be Buffers");
  if (n === o)
    return 0;
  for (var u = n.length, c = o.length, d = 0, m = Math.min(u, c); d < m; ++d)
    if (n[d] !== o[d]) {
      u = n[d], c = o[d];
      break;
    }
  return u < c ? -1 : c < u ? 1 : 0;
};
Buffer.isEncoding = function(n) {
  switch (String(n).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
Buffer.concat = function(n, o) {
  if (!isArray$6(n))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (n.length === 0)
    return Buffer.alloc(0);
  var u;
  if (o === void 0)
    for (o = 0, u = 0; u < n.length; ++u)
      o += n[u].length;
  var c = Buffer.allocUnsafe(o), d = 0;
  for (u = 0; u < n.length; ++u) {
    var m = n[u];
    if (!internalIsBuffer(m))
      throw new TypeError('"list" argument must be an Array of Buffers');
    m.copy(c, d), d += m.length;
  }
  return c;
};
function byteLength(e, n) {
  if (internalIsBuffer(e))
    return e.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer))
    return e.byteLength;
  typeof e != "string" && (e = "" + e);
  var o = e.length;
  if (o === 0)
    return 0;
  for (var u = !1; ; )
    switch (n) {
      case "ascii":
      case "latin1":
      case "binary":
        return o;
      case "utf8":
      case "utf-8":
      case void 0:
        return utf8ToBytes(e).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return o * 2;
      case "hex":
        return o >>> 1;
      case "base64":
        return base64ToBytes(e).length;
      default:
        if (u)
          return utf8ToBytes(e).length;
        n = ("" + n).toLowerCase(), u = !0;
    }
}
Buffer.byteLength = byteLength;
function slowToString(e, n, o) {
  var u = !1;
  if ((n === void 0 || n < 0) && (n = 0), n > this.length || ((o === void 0 || o > this.length) && (o = this.length), o <= 0) || (o >>>= 0, n >>>= 0, o <= n))
    return "";
  for (e || (e = "utf8"); ; )
    switch (e) {
      case "hex":
        return hexSlice(this, n, o);
      case "utf8":
      case "utf-8":
        return utf8Slice(this, n, o);
      case "ascii":
        return asciiSlice(this, n, o);
      case "latin1":
      case "binary":
        return latin1Slice(this, n, o);
      case "base64":
        return base64Slice(this, n, o);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return utf16leSlice(this, n, o);
      default:
        if (u)
          throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), u = !0;
    }
}
Buffer.prototype._isBuffer = !0;
function swap(e, n, o) {
  var u = e[n];
  e[n] = e[o], e[o] = u;
}
Buffer.prototype.swap16 = function() {
  var n = this.length;
  if (n % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var o = 0; o < n; o += 2)
    swap(this, o, o + 1);
  return this;
};
Buffer.prototype.swap32 = function() {
  var n = this.length;
  if (n % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var o = 0; o < n; o += 4)
    swap(this, o, o + 3), swap(this, o + 1, o + 2);
  return this;
};
Buffer.prototype.swap64 = function() {
  var n = this.length;
  if (n % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var o = 0; o < n; o += 8)
    swap(this, o, o + 7), swap(this, o + 1, o + 6), swap(this, o + 2, o + 5), swap(this, o + 3, o + 4);
  return this;
};
Buffer.prototype.toString = function() {
  var n = this.length | 0;
  return n === 0 ? "" : arguments.length === 0 ? utf8Slice(this, 0, n) : slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function(n) {
  if (!internalIsBuffer(n))
    throw new TypeError("Argument must be a Buffer");
  return this === n ? !0 : Buffer.compare(this, n) === 0;
};
Buffer.prototype.inspect = function() {
  var n = "", o = INSPECT_MAX_BYTES;
  return this.length > 0 && (n = this.toString("hex", 0, o).match(/.{2}/g).join(" "), this.length > o && (n += " ... ")), "<Buffer " + n + ">";
};
Buffer.prototype.compare = function(n, o, u, c, d) {
  if (!internalIsBuffer(n))
    throw new TypeError("Argument must be a Buffer");
  if (o === void 0 && (o = 0), u === void 0 && (u = n ? n.length : 0), c === void 0 && (c = 0), d === void 0 && (d = this.length), o < 0 || u > n.length || c < 0 || d > this.length)
    throw new RangeError("out of range index");
  if (c >= d && o >= u)
    return 0;
  if (c >= d)
    return -1;
  if (o >= u)
    return 1;
  if (o >>>= 0, u >>>= 0, c >>>= 0, d >>>= 0, this === n)
    return 0;
  for (var m = d - c, v = u - o, S = Math.min(m, v), $ = this.slice(c, d), E = n.slice(o, u), O = 0; O < S; ++O)
    if ($[O] !== E[O]) {
      m = $[O], v = E[O];
      break;
    }
  return m < v ? -1 : v < m ? 1 : 0;
};
function bidirectionalIndexOf(e, n, o, u, c) {
  if (e.length === 0)
    return -1;
  if (typeof o == "string" ? (u = o, o = 0) : o > 2147483647 ? o = 2147483647 : o < -2147483648 && (o = -2147483648), o = +o, isNaN(o) && (o = c ? 0 : e.length - 1), o < 0 && (o = e.length + o), o >= e.length) {
    if (c)
      return -1;
    o = e.length - 1;
  } else if (o < 0)
    if (c)
      o = 0;
    else
      return -1;
  if (typeof n == "string" && (n = Buffer.from(n, u)), internalIsBuffer(n))
    return n.length === 0 ? -1 : arrayIndexOf(e, n, o, u, c);
  if (typeof n == "number")
    return n = n & 255, Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? c ? Uint8Array.prototype.indexOf.call(e, n, o) : Uint8Array.prototype.lastIndexOf.call(e, n, o) : arrayIndexOf(e, [n], o, u, c);
  throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(e, n, o, u, c) {
  var d = 1, m = e.length, v = n.length;
  if (u !== void 0 && (u = String(u).toLowerCase(), u === "ucs2" || u === "ucs-2" || u === "utf16le" || u === "utf-16le")) {
    if (e.length < 2 || n.length < 2)
      return -1;
    d = 2, m /= 2, v /= 2, o /= 2;
  }
  function S(y, V) {
    return d === 1 ? y[V] : y.readUInt16BE(V * d);
  }
  var $;
  if (c) {
    var E = -1;
    for ($ = o; $ < m; $++)
      if (S(e, $) === S(n, E === -1 ? 0 : $ - E)) {
        if (E === -1 && (E = $), $ - E + 1 === v)
          return E * d;
      } else
        E !== -1 && ($ -= $ - E), E = -1;
  } else
    for (o + v > m && (o = m - v), $ = o; $ >= 0; $--) {
      for (var O = !0, T = 0; T < v; T++)
        if (S(e, $ + T) !== S(n, T)) {
          O = !1;
          break;
        }
      if (O)
        return $;
    }
  return -1;
}
Buffer.prototype.includes = function(n, o, u) {
  return this.indexOf(n, o, u) !== -1;
};
Buffer.prototype.indexOf = function(n, o, u) {
  return bidirectionalIndexOf(this, n, o, u, !0);
};
Buffer.prototype.lastIndexOf = function(n, o, u) {
  return bidirectionalIndexOf(this, n, o, u, !1);
};
function hexWrite(e, n, o, u) {
  o = Number(o) || 0;
  var c = e.length - o;
  u ? (u = Number(u), u > c && (u = c)) : u = c;
  var d = n.length;
  if (d % 2 !== 0)
    throw new TypeError("Invalid hex string");
  u > d / 2 && (u = d / 2);
  for (var m = 0; m < u; ++m) {
    var v = parseInt(n.substr(m * 2, 2), 16);
    if (isNaN(v))
      return m;
    e[o + m] = v;
  }
  return m;
}
function utf8Write$1(e, n, o, u) {
  return blitBuffer(utf8ToBytes(n, e.length - o), e, o, u);
}
function asciiWrite(e, n, o, u) {
  return blitBuffer(asciiToBytes(n), e, o, u);
}
function latin1Write(e, n, o, u) {
  return asciiWrite(e, n, o, u);
}
function base64Write(e, n, o, u) {
  return blitBuffer(base64ToBytes(n), e, o, u);
}
function ucs2Write(e, n, o, u) {
  return blitBuffer(utf16leToBytes(n, e.length - o), e, o, u);
}
Buffer.prototype.write = function(n, o, u, c) {
  if (o === void 0)
    c = "utf8", u = this.length, o = 0;
  else if (u === void 0 && typeof o == "string")
    c = o, u = this.length, o = 0;
  else if (isFinite(o))
    o = o | 0, isFinite(u) ? (u = u | 0, c === void 0 && (c = "utf8")) : (c = u, u = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var d = this.length - o;
  if ((u === void 0 || u > d) && (u = d), n.length > 0 && (u < 0 || o < 0) || o > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  c || (c = "utf8");
  for (var m = !1; ; )
    switch (c) {
      case "hex":
        return hexWrite(this, n, o, u);
      case "utf8":
      case "utf-8":
        return utf8Write$1(this, n, o, u);
      case "ascii":
        return asciiWrite(this, n, o, u);
      case "latin1":
      case "binary":
        return latin1Write(this, n, o, u);
      case "base64":
        return base64Write(this, n, o, u);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return ucs2Write(this, n, o, u);
      default:
        if (m)
          throw new TypeError("Unknown encoding: " + c);
        c = ("" + c).toLowerCase(), m = !0;
    }
};
Buffer.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(e, n, o) {
  return n === 0 && o === e.length ? fromByteArray(e) : fromByteArray(e.slice(n, o));
}
function utf8Slice(e, n, o) {
  o = Math.min(e.length, o);
  for (var u = [], c = n; c < o; ) {
    var d = e[c], m = null, v = d > 239 ? 4 : d > 223 ? 3 : d > 191 ? 2 : 1;
    if (c + v <= o) {
      var S, $, E, O;
      switch (v) {
        case 1:
          d < 128 && (m = d);
          break;
        case 2:
          S = e[c + 1], (S & 192) === 128 && (O = (d & 31) << 6 | S & 63, O > 127 && (m = O));
          break;
        case 3:
          S = e[c + 1], $ = e[c + 2], (S & 192) === 128 && ($ & 192) === 128 && (O = (d & 15) << 12 | (S & 63) << 6 | $ & 63, O > 2047 && (O < 55296 || O > 57343) && (m = O));
          break;
        case 4:
          S = e[c + 1], $ = e[c + 2], E = e[c + 3], (S & 192) === 128 && ($ & 192) === 128 && (E & 192) === 128 && (O = (d & 15) << 18 | (S & 63) << 12 | ($ & 63) << 6 | E & 63, O > 65535 && O < 1114112 && (m = O));
      }
    }
    m === null ? (m = 65533, v = 1) : m > 65535 && (m -= 65536, u.push(m >>> 10 & 1023 | 55296), m = 56320 | m & 1023), u.push(m), c += v;
  }
  return decodeCodePointsArray(u);
}
var MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(e) {
  var n = e.length;
  if (n <= MAX_ARGUMENTS_LENGTH)
    return String.fromCharCode.apply(String, e);
  for (var o = "", u = 0; u < n; )
    o += String.fromCharCode.apply(
      String,
      e.slice(u, u += MAX_ARGUMENTS_LENGTH)
    );
  return o;
}
function asciiSlice(e, n, o) {
  var u = "";
  o = Math.min(e.length, o);
  for (var c = n; c < o; ++c)
    u += String.fromCharCode(e[c] & 127);
  return u;
}
function latin1Slice(e, n, o) {
  var u = "";
  o = Math.min(e.length, o);
  for (var c = n; c < o; ++c)
    u += String.fromCharCode(e[c]);
  return u;
}
function hexSlice(e, n, o) {
  var u = e.length;
  (!n || n < 0) && (n = 0), (!o || o < 0 || o > u) && (o = u);
  for (var c = "", d = n; d < o; ++d)
    c += toHex$8(e[d]);
  return c;
}
function utf16leSlice(e, n, o) {
  for (var u = e.slice(n, o), c = "", d = 0; d < u.length; d += 2)
    c += String.fromCharCode(u[d] + u[d + 1] * 256);
  return c;
}
Buffer.prototype.slice = function(n, o) {
  var u = this.length;
  n = ~~n, o = o === void 0 ? u : ~~o, n < 0 ? (n += u, n < 0 && (n = 0)) : n > u && (n = u), o < 0 ? (o += u, o < 0 && (o = 0)) : o > u && (o = u), o < n && (o = n);
  var c;
  if (Buffer.TYPED_ARRAY_SUPPORT)
    c = this.subarray(n, o), c.__proto__ = Buffer.prototype;
  else {
    var d = o - n;
    c = new Buffer(d, void 0);
    for (var m = 0; m < d; ++m)
      c[m] = this[m + n];
  }
  return c;
};
function checkOffset(e, n, o) {
  if (e % 1 !== 0 || e < 0)
    throw new RangeError("offset is not uint");
  if (e + n > o)
    throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function(n, o, u) {
  n = n | 0, o = o | 0, u || checkOffset(n, o, this.length);
  for (var c = this[n], d = 1, m = 0; ++m < o && (d *= 256); )
    c += this[n + m] * d;
  return c;
};
Buffer.prototype.readUIntBE = function(n, o, u) {
  n = n | 0, o = o | 0, u || checkOffset(n, o, this.length);
  for (var c = this[n + --o], d = 1; o > 0 && (d *= 256); )
    c += this[n + --o] * d;
  return c;
};
Buffer.prototype.readUInt8 = function(n, o) {
  return o || checkOffset(n, 1, this.length), this[n];
};
Buffer.prototype.readUInt16LE = function(n, o) {
  return o || checkOffset(n, 2, this.length), this[n] | this[n + 1] << 8;
};
Buffer.prototype.readUInt16BE = function(n, o) {
  return o || checkOffset(n, 2, this.length), this[n] << 8 | this[n + 1];
};
Buffer.prototype.readUInt32LE = function(n, o) {
  return o || checkOffset(n, 4, this.length), (this[n] | this[n + 1] << 8 | this[n + 2] << 16) + this[n + 3] * 16777216;
};
Buffer.prototype.readUInt32BE = function(n, o) {
  return o || checkOffset(n, 4, this.length), this[n] * 16777216 + (this[n + 1] << 16 | this[n + 2] << 8 | this[n + 3]);
};
Buffer.prototype.readIntLE = function(n, o, u) {
  n = n | 0, o = o | 0, u || checkOffset(n, o, this.length);
  for (var c = this[n], d = 1, m = 0; ++m < o && (d *= 256); )
    c += this[n + m] * d;
  return d *= 128, c >= d && (c -= Math.pow(2, 8 * o)), c;
};
Buffer.prototype.readIntBE = function(n, o, u) {
  n = n | 0, o = o | 0, u || checkOffset(n, o, this.length);
  for (var c = o, d = 1, m = this[n + --c]; c > 0 && (d *= 256); )
    m += this[n + --c] * d;
  return d *= 128, m >= d && (m -= Math.pow(2, 8 * o)), m;
};
Buffer.prototype.readInt8 = function(n, o) {
  return o || checkOffset(n, 1, this.length), this[n] & 128 ? (255 - this[n] + 1) * -1 : this[n];
};
Buffer.prototype.readInt16LE = function(n, o) {
  o || checkOffset(n, 2, this.length);
  var u = this[n] | this[n + 1] << 8;
  return u & 32768 ? u | 4294901760 : u;
};
Buffer.prototype.readInt16BE = function(n, o) {
  o || checkOffset(n, 2, this.length);
  var u = this[n + 1] | this[n] << 8;
  return u & 32768 ? u | 4294901760 : u;
};
Buffer.prototype.readInt32LE = function(n, o) {
  return o || checkOffset(n, 4, this.length), this[n] | this[n + 1] << 8 | this[n + 2] << 16 | this[n + 3] << 24;
};
Buffer.prototype.readInt32BE = function(n, o) {
  return o || checkOffset(n, 4, this.length), this[n] << 24 | this[n + 1] << 16 | this[n + 2] << 8 | this[n + 3];
};
Buffer.prototype.readFloatLE = function(n, o) {
  return o || checkOffset(n, 4, this.length), read(this, n, !0, 23, 4);
};
Buffer.prototype.readFloatBE = function(n, o) {
  return o || checkOffset(n, 4, this.length), read(this, n, !1, 23, 4);
};
Buffer.prototype.readDoubleLE = function(n, o) {
  return o || checkOffset(n, 8, this.length), read(this, n, !0, 52, 8);
};
Buffer.prototype.readDoubleBE = function(n, o) {
  return o || checkOffset(n, 8, this.length), read(this, n, !1, 52, 8);
};
function checkInt(e, n, o, u, c, d) {
  if (!internalIsBuffer(e))
    throw new TypeError('"buffer" argument must be a Buffer instance');
  if (n > c || n < d)
    throw new RangeError('"value" argument is out of bounds');
  if (o + u > e.length)
    throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function(n, o, u, c) {
  if (n = +n, o = o | 0, u = u | 0, !c) {
    var d = Math.pow(2, 8 * u) - 1;
    checkInt(this, n, o, u, d, 0);
  }
  var m = 1, v = 0;
  for (this[o] = n & 255; ++v < u && (m *= 256); )
    this[o + v] = n / m & 255;
  return o + u;
};
Buffer.prototype.writeUIntBE = function(n, o, u, c) {
  if (n = +n, o = o | 0, u = u | 0, !c) {
    var d = Math.pow(2, 8 * u) - 1;
    checkInt(this, n, o, u, d, 0);
  }
  var m = u - 1, v = 1;
  for (this[o + m] = n & 255; --m >= 0 && (v *= 256); )
    this[o + m] = n / v & 255;
  return o + u;
};
Buffer.prototype.writeUInt8 = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 1, 255, 0), Buffer.TYPED_ARRAY_SUPPORT || (n = Math.floor(n)), this[o] = n & 255, o + 1;
};
function objectWriteUInt16(e, n, o, u) {
  n < 0 && (n = 65535 + n + 1);
  for (var c = 0, d = Math.min(e.length - o, 2); c < d; ++c)
    e[o + c] = (n & 255 << 8 * (u ? c : 1 - c)) >>> (u ? c : 1 - c) * 8;
}
Buffer.prototype.writeUInt16LE = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[o] = n & 255, this[o + 1] = n >>> 8) : objectWriteUInt16(this, n, o, !0), o + 2;
};
Buffer.prototype.writeUInt16BE = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[o] = n >>> 8, this[o + 1] = n & 255) : objectWriteUInt16(this, n, o, !1), o + 2;
};
function objectWriteUInt32(e, n, o, u) {
  n < 0 && (n = 4294967295 + n + 1);
  for (var c = 0, d = Math.min(e.length - o, 4); c < d; ++c)
    e[o + c] = n >>> (u ? c : 3 - c) * 8 & 255;
}
Buffer.prototype.writeUInt32LE = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[o + 3] = n >>> 24, this[o + 2] = n >>> 16, this[o + 1] = n >>> 8, this[o] = n & 255) : objectWriteUInt32(this, n, o, !0), o + 4;
};
Buffer.prototype.writeUInt32BE = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[o] = n >>> 24, this[o + 1] = n >>> 16, this[o + 2] = n >>> 8, this[o + 3] = n & 255) : objectWriteUInt32(this, n, o, !1), o + 4;
};
Buffer.prototype.writeIntLE = function(n, o, u, c) {
  if (n = +n, o = o | 0, !c) {
    var d = Math.pow(2, 8 * u - 1);
    checkInt(this, n, o, u, d - 1, -d);
  }
  var m = 0, v = 1, S = 0;
  for (this[o] = n & 255; ++m < u && (v *= 256); )
    n < 0 && S === 0 && this[o + m - 1] !== 0 && (S = 1), this[o + m] = (n / v >> 0) - S & 255;
  return o + u;
};
Buffer.prototype.writeIntBE = function(n, o, u, c) {
  if (n = +n, o = o | 0, !c) {
    var d = Math.pow(2, 8 * u - 1);
    checkInt(this, n, o, u, d - 1, -d);
  }
  var m = u - 1, v = 1, S = 0;
  for (this[o + m] = n & 255; --m >= 0 && (v *= 256); )
    n < 0 && S === 0 && this[o + m + 1] !== 0 && (S = 1), this[o + m] = (n / v >> 0) - S & 255;
  return o + u;
};
Buffer.prototype.writeInt8 = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 1, 127, -128), Buffer.TYPED_ARRAY_SUPPORT || (n = Math.floor(n)), n < 0 && (n = 255 + n + 1), this[o] = n & 255, o + 1;
};
Buffer.prototype.writeInt16LE = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[o] = n & 255, this[o + 1] = n >>> 8) : objectWriteUInt16(this, n, o, !0), o + 2;
};
Buffer.prototype.writeInt16BE = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[o] = n >>> 8, this[o + 1] = n & 255) : objectWriteUInt16(this, n, o, !1), o + 2;
};
Buffer.prototype.writeInt32LE = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 4, 2147483647, -2147483648), Buffer.TYPED_ARRAY_SUPPORT ? (this[o] = n & 255, this[o + 1] = n >>> 8, this[o + 2] = n >>> 16, this[o + 3] = n >>> 24) : objectWriteUInt32(this, n, o, !0), o + 4;
};
Buffer.prototype.writeInt32BE = function(n, o, u) {
  return n = +n, o = o | 0, u || checkInt(this, n, o, 4, 2147483647, -2147483648), n < 0 && (n = 4294967295 + n + 1), Buffer.TYPED_ARRAY_SUPPORT ? (this[o] = n >>> 24, this[o + 1] = n >>> 16, this[o + 2] = n >>> 8, this[o + 3] = n & 255) : objectWriteUInt32(this, n, o, !1), o + 4;
};
function checkIEEE754(e, n, o, u, c, d) {
  if (o + u > e.length)
    throw new RangeError("Index out of range");
  if (o < 0)
    throw new RangeError("Index out of range");
}
function writeFloat(e, n, o, u, c) {
  return c || checkIEEE754(e, n, o, 4), write(e, n, o, u, 23, 4), o + 4;
}
Buffer.prototype.writeFloatLE = function(n, o, u) {
  return writeFloat(this, n, o, !0, u);
};
Buffer.prototype.writeFloatBE = function(n, o, u) {
  return writeFloat(this, n, o, !1, u);
};
function writeDouble(e, n, o, u, c) {
  return c || checkIEEE754(e, n, o, 8), write(e, n, o, u, 52, 8), o + 8;
}
Buffer.prototype.writeDoubleLE = function(n, o, u) {
  return writeDouble(this, n, o, !0, u);
};
Buffer.prototype.writeDoubleBE = function(n, o, u) {
  return writeDouble(this, n, o, !1, u);
};
Buffer.prototype.copy = function(n, o, u, c) {
  if (u || (u = 0), !c && c !== 0 && (c = this.length), o >= n.length && (o = n.length), o || (o = 0), c > 0 && c < u && (c = u), c === u || n.length === 0 || this.length === 0)
    return 0;
  if (o < 0)
    throw new RangeError("targetStart out of bounds");
  if (u < 0 || u >= this.length)
    throw new RangeError("sourceStart out of bounds");
  if (c < 0)
    throw new RangeError("sourceEnd out of bounds");
  c > this.length && (c = this.length), n.length - o < c - u && (c = n.length - o + u);
  var d = c - u, m;
  if (this === n && u < o && o < c)
    for (m = d - 1; m >= 0; --m)
      n[m + o] = this[m + u];
  else if (d < 1e3 || !Buffer.TYPED_ARRAY_SUPPORT)
    for (m = 0; m < d; ++m)
      n[m + o] = this[m + u];
  else
    Uint8Array.prototype.set.call(
      n,
      this.subarray(u, u + d),
      o
    );
  return d;
};
Buffer.prototype.fill = function(n, o, u, c) {
  if (typeof n == "string") {
    if (typeof o == "string" ? (c = o, o = 0, u = this.length) : typeof u == "string" && (c = u, u = this.length), n.length === 1) {
      var d = n.charCodeAt(0);
      d < 256 && (n = d);
    }
    if (c !== void 0 && typeof c != "string")
      throw new TypeError("encoding must be a string");
    if (typeof c == "string" && !Buffer.isEncoding(c))
      throw new TypeError("Unknown encoding: " + c);
  } else
    typeof n == "number" && (n = n & 255);
  if (o < 0 || this.length < o || this.length < u)
    throw new RangeError("Out of range index");
  if (u <= o)
    return this;
  o = o >>> 0, u = u === void 0 ? this.length : u >>> 0, n || (n = 0);
  var m;
  if (typeof n == "number")
    for (m = o; m < u; ++m)
      this[m] = n;
  else {
    var v = internalIsBuffer(n) ? n : utf8ToBytes(new Buffer(n, c).toString()), S = v.length;
    for (m = 0; m < u - o; ++m)
      this[m + o] = v[m % S];
  }
  return this;
};
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(e) {
  if (e = stringtrim(e).replace(INVALID_BASE64_RE, ""), e.length < 2)
    return "";
  for (; e.length % 4 !== 0; )
    e = e + "=";
  return e;
}
function stringtrim(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function toHex$8(e) {
  return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function utf8ToBytes(e, n) {
  n = n || 1 / 0;
  for (var o, u = e.length, c = null, d = [], m = 0; m < u; ++m) {
    if (o = e.charCodeAt(m), o > 55295 && o < 57344) {
      if (!c) {
        if (o > 56319) {
          (n -= 3) > -1 && d.push(239, 191, 189);
          continue;
        } else if (m + 1 === u) {
          (n -= 3) > -1 && d.push(239, 191, 189);
          continue;
        }
        c = o;
        continue;
      }
      if (o < 56320) {
        (n -= 3) > -1 && d.push(239, 191, 189), c = o;
        continue;
      }
      o = (c - 55296 << 10 | o - 56320) + 65536;
    } else
      c && (n -= 3) > -1 && d.push(239, 191, 189);
    if (c = null, o < 128) {
      if ((n -= 1) < 0)
        break;
      d.push(o);
    } else if (o < 2048) {
      if ((n -= 2) < 0)
        break;
      d.push(
        o >> 6 | 192,
        o & 63 | 128
      );
    } else if (o < 65536) {
      if ((n -= 3) < 0)
        break;
      d.push(
        o >> 12 | 224,
        o >> 6 & 63 | 128,
        o & 63 | 128
      );
    } else if (o < 1114112) {
      if ((n -= 4) < 0)
        break;
      d.push(
        o >> 18 | 240,
        o >> 12 & 63 | 128,
        o >> 6 & 63 | 128,
        o & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return d;
}
function asciiToBytes(e) {
  for (var n = [], o = 0; o < e.length; ++o)
    n.push(e.charCodeAt(o) & 255);
  return n;
}
function utf16leToBytes(e, n) {
  for (var o, u, c, d = [], m = 0; m < e.length && !((n -= 2) < 0); ++m)
    o = e.charCodeAt(m), u = o >> 8, c = o % 256, d.push(c), d.push(u);
  return d;
}
function base64ToBytes(e) {
  return toByteArray(base64clean(e));
}
function blitBuffer(e, n, o, u) {
  for (var c = 0; c < u && !(c + o >= n.length || c >= e.length); ++c)
    n[c + o] = e[c];
  return c;
}
function isnan(e) {
  return e !== e;
}
function isBuffer$5(e) {
  return e != null && (!!e._isBuffer || isFastBuffer(e) || isSlowBuffer(e));
}
function isFastBuffer(e) {
  return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function isSlowBuffer(e) {
  return typeof e.readFloatLE == "function" && typeof e.slice == "function" && isFastBuffer(e.slice(0, 0));
}
var typechecks$7 = {};
Object.defineProperty(typechecks$7, "__esModule", { value: !0 });
typechecks$7.isDefined = typechecks$7.isUint8Array = typechecks$7.isNonNullObject = void 0;
function isNonNullObject$7(e) {
  return typeof e == "object" && e !== null;
}
typechecks$7.isNonNullObject = isNonNullObject$7;
function isUint8Array$7(e) {
  return !(!isNonNullObject$7(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(e));
}
typechecks$7.isUint8Array = isUint8Array$7;
function isDefined$7(e) {
  return e !== void 0;
}
typechecks$7.isDefined = isDefined$7;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var n = arrays$7;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return n.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return n.arrayContentStartsWith;
  } });
  var o = assert$z;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return o.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return o.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return o.assertDefinedAndNotNull;
  } });
  var u = sleep$f;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return u.sleep;
  } });
  var c = typechecks$7;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return c.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return c.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return c.isUint8Array;
  } });
})(build$U);
var pbkdf2$8 = {}, _assert = {};
Object.defineProperty(_assert, "__esModule", { value: !0 });
_assert.output = _assert.exists = _assert.hash = _assert.bytes = _assert.bool = _assert.number = void 0;
function number(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
_assert.number = number;
function bool(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
_assert.bool = bool;
function bytes(e, ...n) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (n.length > 0 && !n.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${n}, not of length=${e.length}`);
}
_assert.bytes = bytes;
function hash$6(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number(e.outputLen), number(e.blockLen);
}
_assert.hash = hash$6;
function exists(e, n = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (n && e.finished)
    throw new Error("Hash#digest() has already been called");
}
_assert.exists = exists;
function output(e, n) {
  bytes(e);
  const o = n.outputLen;
  if (e.length < o)
    throw new Error(`digestInto() expects output buffer of length at least ${o}`);
}
_assert.output = output;
const assert$x = {
  number,
  bool,
  bytes,
  hash: hash$6,
  exists,
  output
};
_assert.default = assert$x;
var hmac$9 = {}, utils$Z = {}, crypto$1 = {};
Object.defineProperty(crypto$1, "__esModule", { value: !0 });
crypto$1.crypto = void 0;
crypto$1.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
(function(e) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.randomBytes = e.wrapConstructorWithOpts = e.wrapConstructor = e.checkOpts = e.Hash = e.concatBytes = e.toBytes = e.utf8ToBytes = e.asyncLoop = e.nextTick = e.hexToBytes = e.bytesToHex = e.isLE = e.rotr = e.createView = e.u32 = e.u8 = void 0;
  const n = crypto$1, o = (ee) => new Uint8Array(ee.buffer, ee.byteOffset, ee.byteLength);
  e.u8 = o;
  const u = (ee) => new Uint32Array(ee.buffer, ee.byteOffset, Math.floor(ee.byteLength / 4));
  e.u32 = u;
  const c = (ee) => new DataView(ee.buffer, ee.byteOffset, ee.byteLength);
  e.createView = c;
  const d = (ee, ue) => ee << 32 - ue | ee >>> ue;
  if (e.rotr = d, e.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, !e.isLE)
    throw new Error("Non little-endian hardware is not supported");
  const m = Array.from({ length: 256 }, (ee, ue) => ue.toString(16).padStart(2, "0"));
  function v(ee) {
    if (!(ee instanceof Uint8Array))
      throw new Error("Uint8Array expected");
    let ue = "";
    for (let Q = 0; Q < ee.length; Q++)
      ue += m[ee[Q]];
    return ue;
  }
  e.bytesToHex = v;
  function S(ee) {
    if (typeof ee != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof ee);
    if (ee.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex");
    const ue = new Uint8Array(ee.length / 2);
    for (let Q = 0; Q < ue.length; Q++) {
      const Y = Q * 2, pe = ee.slice(Y, Y + 2), oe = Number.parseInt(pe, 16);
      if (Number.isNaN(oe) || oe < 0)
        throw new Error("Invalid byte sequence");
      ue[Q] = oe;
    }
    return ue;
  }
  e.hexToBytes = S;
  const $ = async () => {
  };
  e.nextTick = $;
  async function E(ee, ue, Q) {
    let Y = Date.now();
    for (let pe = 0; pe < ee; pe++) {
      Q(pe);
      const oe = Date.now() - Y;
      oe >= 0 && oe < ue || (await (0, e.nextTick)(), Y += oe);
    }
  }
  e.asyncLoop = E;
  function O(ee) {
    if (typeof ee != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof ee}`);
    return new TextEncoder().encode(ee);
  }
  e.utf8ToBytes = O;
  function T(ee) {
    if (typeof ee == "string" && (ee = O(ee)), !(ee instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof ee})`);
    return ee;
  }
  e.toBytes = T;
  function y(...ee) {
    if (!ee.every((Y) => Y instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (ee.length === 1)
      return ee[0];
    const ue = ee.reduce((Y, pe) => Y + pe.length, 0), Q = new Uint8Array(ue);
    for (let Y = 0, pe = 0; Y < ee.length; Y++) {
      const oe = ee[Y];
      Q.set(oe, pe), pe += oe.length;
    }
    return Q;
  }
  e.concatBytes = y;
  class V {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  e.Hash = V;
  const M = (ee) => Object.prototype.toString.call(ee) === "[object Object]" && ee.constructor === Object;
  function G(ee, ue) {
    if (ue !== void 0 && (typeof ue != "object" || !M(ue)))
      throw new TypeError("Options should be object or undefined");
    return Object.assign(ee, ue);
  }
  e.checkOpts = G;
  function k(ee) {
    const ue = (Y) => ee().update(T(Y)).digest(), Q = ee();
    return ue.outputLen = Q.outputLen, ue.blockLen = Q.blockLen, ue.create = () => ee(), ue;
  }
  e.wrapConstructor = k;
  function F(ee) {
    const ue = (Y, pe) => ee(pe).update(T(Y)).digest(), Q = ee({});
    return ue.outputLen = Q.outputLen, ue.blockLen = Q.blockLen, ue.create = (Y) => ee(Y), ue;
  }
  e.wrapConstructorWithOpts = F;
  function X(ee = 32) {
    if (n.crypto && typeof n.crypto.getRandomValues == "function")
      return n.crypto.getRandomValues(new Uint8Array(ee));
    throw new Error("crypto.getRandomValues must be defined");
  }
  e.randomBytes = X;
})(utils$Z);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hmac = void 0;
  const n = _assert, o = utils$Z;
  class u extends o.Hash {
    constructor(m, v) {
      super(), this.finished = !1, this.destroyed = !1, n.default.hash(m);
      const S = (0, o.toBytes)(v);
      if (this.iHash = m.create(), typeof this.iHash.update != "function")
        throw new TypeError("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const $ = this.blockLen, E = new Uint8Array($);
      E.set(S.length > $ ? m.create().update(S).digest() : S);
      for (let O = 0; O < E.length; O++)
        E[O] ^= 54;
      this.iHash.update(E), this.oHash = m.create();
      for (let O = 0; O < E.length; O++)
        E[O] ^= 106;
      this.oHash.update(E), E.fill(0);
    }
    update(m) {
      return n.default.exists(this), this.iHash.update(m), this;
    }
    digestInto(m) {
      n.default.exists(this), n.default.bytes(m, this.outputLen), this.finished = !0, this.iHash.digestInto(m), this.oHash.update(m), this.oHash.digestInto(m), this.destroy();
    }
    digest() {
      const m = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(m), m;
    }
    _cloneInto(m) {
      m || (m = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: v, iHash: S, finished: $, destroyed: E, blockLen: O, outputLen: T } = this;
      return m = m, m.finished = $, m.destroyed = E, m.blockLen = O, m.outputLen = T, m.oHash = v._cloneInto(m.oHash), m.iHash = S._cloneInto(m.iHash), m;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  const c = (d, m, v) => new u(d, m).update(v).digest();
  e.hmac = c, e.hmac.create = (d, m) => new u(d, m);
})(hmac$9);
Object.defineProperty(pbkdf2$8, "__esModule", { value: !0 });
pbkdf2$8.pbkdf2Async = pbkdf2$8.pbkdf2 = void 0;
const _assert_js_1$2 = _assert, hmac_js_1 = hmac$9, utils_js_1$5 = utils$Z;
function pbkdf2Init(e, n, o, u) {
  _assert_js_1$2.default.hash(e);
  const c = (0, utils_js_1$5.checkOpts)({ dkLen: 32, asyncTick: 10 }, u), { c: d, dkLen: m, asyncTick: v } = c;
  if (_assert_js_1$2.default.number(d), _assert_js_1$2.default.number(m), _assert_js_1$2.default.number(v), d < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const S = (0, utils_js_1$5.toBytes)(n), $ = (0, utils_js_1$5.toBytes)(o), E = new Uint8Array(m), O = hmac_js_1.hmac.create(e, S), T = O._cloneInto().update($);
  return { c: d, dkLen: m, asyncTick: v, DK: E, PRF: O, PRFSalt: T };
}
function pbkdf2Output(e, n, o, u, c) {
  return e.destroy(), n.destroy(), u && u.destroy(), c.fill(0), o;
}
function pbkdf2$7(e, n, o, u) {
  const { c, dkLen: d, DK: m, PRF: v, PRFSalt: S } = pbkdf2Init(e, n, o, u);
  let $;
  const E = new Uint8Array(4), O = (0, utils_js_1$5.createView)(E), T = new Uint8Array(v.outputLen);
  for (let y = 1, V = 0; V < d; y++, V += v.outputLen) {
    const M = m.subarray(V, V + v.outputLen);
    O.setInt32(0, y, !1), ($ = S._cloneInto($)).update(E).digestInto(T), M.set(T.subarray(0, M.length));
    for (let G = 1; G < c; G++) {
      v._cloneInto($).update(T).digestInto(T);
      for (let k = 0; k < M.length; k++)
        M[k] ^= T[k];
    }
  }
  return pbkdf2Output(v, S, m, $, T);
}
pbkdf2$8.pbkdf2 = pbkdf2$7;
async function pbkdf2Async(e, n, o, u) {
  const { c, dkLen: d, asyncTick: m, DK: v, PRF: S, PRFSalt: $ } = pbkdf2Init(e, n, o, u);
  let E;
  const O = new Uint8Array(4), T = (0, utils_js_1$5.createView)(O), y = new Uint8Array(S.outputLen);
  for (let V = 1, M = 0; M < d; V++, M += S.outputLen) {
    const G = v.subarray(M, M + S.outputLen);
    T.setInt32(0, V, !1), (E = $._cloneInto(E)).update(O).digestInto(y), G.set(y.subarray(0, G.length)), await (0, utils_js_1$5.asyncLoop)(c - 1, m, (k) => {
      S._cloneInto(E).update(y).digestInto(y);
      for (let F = 0; F < G.length; F++)
        G[F] ^= y[F];
    });
  }
  return pbkdf2Output(S, $, v, E, y);
}
pbkdf2$8.pbkdf2Async = pbkdf2Async;
var sha512$a = {}, _sha2 = {};
Object.defineProperty(_sha2, "__esModule", { value: !0 });
_sha2.SHA2 = void 0;
const _assert_js_1$1 = _assert, utils_js_1$4 = utils$Z;
function setBigUint64(e, n, o, u) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(n, o, u);
  const c = BigInt(32), d = BigInt(4294967295), m = Number(o >> c & d), v = Number(o & d), S = u ? 4 : 0, $ = u ? 0 : 4;
  e.setUint32(n + S, m, u), e.setUint32(n + $, v, u);
}
class SHA2 extends utils_js_1$4.Hash {
  constructor(n, o, u, c) {
    super(), this.blockLen = n, this.outputLen = o, this.padOffset = u, this.isLE = c, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(n), this.view = (0, utils_js_1$4.createView)(this.buffer);
  }
  update(n) {
    _assert_js_1$1.default.exists(this);
    const { view: o, buffer: u, blockLen: c } = this;
    n = (0, utils_js_1$4.toBytes)(n);
    const d = n.length;
    for (let m = 0; m < d; ) {
      const v = Math.min(c - this.pos, d - m);
      if (v === c) {
        const S = (0, utils_js_1$4.createView)(n);
        for (; c <= d - m; m += c)
          this.process(S, m);
        continue;
      }
      u.set(n.subarray(m, m + v), this.pos), this.pos += v, m += v, this.pos === c && (this.process(o, 0), this.pos = 0);
    }
    return this.length += n.length, this.roundClean(), this;
  }
  digestInto(n) {
    _assert_js_1$1.default.exists(this), _assert_js_1$1.default.output(n, this), this.finished = !0;
    const { buffer: o, view: u, blockLen: c, isLE: d } = this;
    let { pos: m } = this;
    o[m++] = 128, this.buffer.subarray(m).fill(0), this.padOffset > c - m && (this.process(u, 0), m = 0);
    for (let O = m; O < c; O++)
      o[O] = 0;
    setBigUint64(u, c - 8, BigInt(this.length * 8), d), this.process(u, 0);
    const v = (0, utils_js_1$4.createView)(n), S = this.outputLen;
    if (S % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const $ = S / 4, E = this.get();
    if ($ > E.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let O = 0; O < $; O++)
      v.setUint32(4 * O, E[O], d);
  }
  digest() {
    const { buffer: n, outputLen: o } = this;
    this.digestInto(n);
    const u = n.slice(0, o);
    return this.destroy(), u;
  }
  _cloneInto(n) {
    n || (n = new this.constructor()), n.set(...this.get());
    const { blockLen: o, buffer: u, length: c, finished: d, destroyed: m, pos: v } = this;
    return n.length = c, n.pos = v, n.finished = d, n.destroyed = m, c % o && n.buffer.set(u), n;
  }
}
_sha2.SHA2 = SHA2;
var _u64 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.add = e.toBig = e.split = e.fromBig = void 0;
  const n = BigInt(2 ** 32 - 1), o = BigInt(32);
  function u(ne, H = !1) {
    return H ? { h: Number(ne & n), l: Number(ne >> o & n) } : { h: Number(ne >> o & n) | 0, l: Number(ne & n) | 0 };
  }
  e.fromBig = u;
  function c(ne, H = !1) {
    let C = new Uint32Array(ne.length), w = new Uint32Array(ne.length);
    for (let P = 0; P < ne.length; P++) {
      const { h: J, l: se } = u(ne[P], H);
      [C[P], w[P]] = [J, se];
    }
    return [C, w];
  }
  e.split = c;
  const d = (ne, H) => BigInt(ne >>> 0) << o | BigInt(H >>> 0);
  e.toBig = d;
  const m = (ne, H, C) => ne >>> C, v = (ne, H, C) => ne << 32 - C | H >>> C, S = (ne, H, C) => ne >>> C | H << 32 - C, $ = (ne, H, C) => ne << 32 - C | H >>> C, E = (ne, H, C) => ne << 64 - C | H >>> C - 32, O = (ne, H, C) => ne >>> C - 32 | H << 64 - C, T = (ne, H) => H, y = (ne, H) => ne, V = (ne, H, C) => ne << C | H >>> 32 - C, M = (ne, H, C) => H << C | ne >>> 32 - C, G = (ne, H, C) => H << C - 32 | ne >>> 64 - C, k = (ne, H, C) => ne << C - 32 | H >>> 64 - C;
  function F(ne, H, C, w) {
    const P = (H >>> 0) + (w >>> 0);
    return { h: ne + C + (P / 2 ** 32 | 0) | 0, l: P | 0 };
  }
  e.add = F;
  const X = (ne, H, C) => (ne >>> 0) + (H >>> 0) + (C >>> 0), ee = (ne, H, C, w) => H + C + w + (ne / 2 ** 32 | 0) | 0, ue = (ne, H, C, w) => (ne >>> 0) + (H >>> 0) + (C >>> 0) + (w >>> 0), Q = (ne, H, C, w, P) => H + C + w + P + (ne / 2 ** 32 | 0) | 0, Y = (ne, H, C, w, P) => (ne >>> 0) + (H >>> 0) + (C >>> 0) + (w >>> 0) + (P >>> 0), pe = (ne, H, C, w, P, J) => H + C + w + P + J + (ne / 2 ** 32 | 0) | 0, oe = {
    fromBig: u,
    split: c,
    toBig: e.toBig,
    shrSH: m,
    shrSL: v,
    rotrSH: S,
    rotrSL: $,
    rotrBH: E,
    rotrBL: O,
    rotr32H: T,
    rotr32L: y,
    rotlSH: V,
    rotlSL: M,
    rotlBH: G,
    rotlBL: k,
    add: F,
    add3L: X,
    add3H: ee,
    add4L: ue,
    add4H: Q,
    add5H: pe,
    add5L: Y
  };
  e.default = oe;
})(_u64);
Object.defineProperty(sha512$a, "__esModule", { value: !0 });
sha512$a.sha384 = sha512$a.sha512_256 = sha512$a.sha512_224 = sha512$a.sha512 = sha512$a.SHA512 = void 0;
const _sha2_js_1$2 = _sha2, _u64_js_1$1 = _u64, utils_js_1$3 = utils$Z, [SHA512_Kh, SHA512_Kl] = _u64_js_1$1.default.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), SHA512_W_H = new Uint32Array(80), SHA512_W_L = new Uint32Array(80);
let SHA512$2 = class extends _sha2_js_1$2.SHA2 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: n, Al: o, Bh: u, Bl: c, Ch: d, Cl: m, Dh: v, Dl: S, Eh: $, El: E, Fh: O, Fl: T, Gh: y, Gl: V, Hh: M, Hl: G } = this;
    return [n, o, u, c, d, m, v, S, $, E, O, T, y, V, M, G];
  }
  // prettier-ignore
  set(n, o, u, c, d, m, v, S, $, E, O, T, y, V, M, G) {
    this.Ah = n | 0, this.Al = o | 0, this.Bh = u | 0, this.Bl = c | 0, this.Ch = d | 0, this.Cl = m | 0, this.Dh = v | 0, this.Dl = S | 0, this.Eh = $ | 0, this.El = E | 0, this.Fh = O | 0, this.Fl = T | 0, this.Gh = y | 0, this.Gl = V | 0, this.Hh = M | 0, this.Hl = G | 0;
  }
  process(n, o) {
    for (let X = 0; X < 16; X++, o += 4)
      SHA512_W_H[X] = n.getUint32(o), SHA512_W_L[X] = n.getUint32(o += 4);
    for (let X = 16; X < 80; X++) {
      const ee = SHA512_W_H[X - 15] | 0, ue = SHA512_W_L[X - 15] | 0, Q = _u64_js_1$1.default.rotrSH(ee, ue, 1) ^ _u64_js_1$1.default.rotrSH(ee, ue, 8) ^ _u64_js_1$1.default.shrSH(ee, ue, 7), Y = _u64_js_1$1.default.rotrSL(ee, ue, 1) ^ _u64_js_1$1.default.rotrSL(ee, ue, 8) ^ _u64_js_1$1.default.shrSL(ee, ue, 7), pe = SHA512_W_H[X - 2] | 0, oe = SHA512_W_L[X - 2] | 0, ne = _u64_js_1$1.default.rotrSH(pe, oe, 19) ^ _u64_js_1$1.default.rotrBH(pe, oe, 61) ^ _u64_js_1$1.default.shrSH(pe, oe, 6), H = _u64_js_1$1.default.rotrSL(pe, oe, 19) ^ _u64_js_1$1.default.rotrBL(pe, oe, 61) ^ _u64_js_1$1.default.shrSL(pe, oe, 6), C = _u64_js_1$1.default.add4L(Y, H, SHA512_W_L[X - 7], SHA512_W_L[X - 16]), w = _u64_js_1$1.default.add4H(C, Q, ne, SHA512_W_H[X - 7], SHA512_W_H[X - 16]);
      SHA512_W_H[X] = w | 0, SHA512_W_L[X] = C | 0;
    }
    let { Ah: u, Al: c, Bh: d, Bl: m, Ch: v, Cl: S, Dh: $, Dl: E, Eh: O, El: T, Fh: y, Fl: V, Gh: M, Gl: G, Hh: k, Hl: F } = this;
    for (let X = 0; X < 80; X++) {
      const ee = _u64_js_1$1.default.rotrSH(O, T, 14) ^ _u64_js_1$1.default.rotrSH(O, T, 18) ^ _u64_js_1$1.default.rotrBH(O, T, 41), ue = _u64_js_1$1.default.rotrSL(O, T, 14) ^ _u64_js_1$1.default.rotrSL(O, T, 18) ^ _u64_js_1$1.default.rotrBL(O, T, 41), Q = O & y ^ ~O & M, Y = T & V ^ ~T & G, pe = _u64_js_1$1.default.add5L(F, ue, Y, SHA512_Kl[X], SHA512_W_L[X]), oe = _u64_js_1$1.default.add5H(pe, k, ee, Q, SHA512_Kh[X], SHA512_W_H[X]), ne = pe | 0, H = _u64_js_1$1.default.rotrSH(u, c, 28) ^ _u64_js_1$1.default.rotrBH(u, c, 34) ^ _u64_js_1$1.default.rotrBH(u, c, 39), C = _u64_js_1$1.default.rotrSL(u, c, 28) ^ _u64_js_1$1.default.rotrBL(u, c, 34) ^ _u64_js_1$1.default.rotrBL(u, c, 39), w = u & d ^ u & v ^ d & v, P = c & m ^ c & S ^ m & S;
      k = M | 0, F = G | 0, M = y | 0, G = V | 0, y = O | 0, V = T | 0, { h: O, l: T } = _u64_js_1$1.default.add($ | 0, E | 0, oe | 0, ne | 0), $ = v | 0, E = S | 0, v = d | 0, S = m | 0, d = u | 0, m = c | 0;
      const J = _u64_js_1$1.default.add3L(ne, C, P);
      u = _u64_js_1$1.default.add3H(J, oe, H, w), c = J | 0;
    }
    ({ h: u, l: c } = _u64_js_1$1.default.add(this.Ah | 0, this.Al | 0, u | 0, c | 0)), { h: d, l: m } = _u64_js_1$1.default.add(this.Bh | 0, this.Bl | 0, d | 0, m | 0), { h: v, l: S } = _u64_js_1$1.default.add(this.Ch | 0, this.Cl | 0, v | 0, S | 0), { h: $, l: E } = _u64_js_1$1.default.add(this.Dh | 0, this.Dl | 0, $ | 0, E | 0), { h: O, l: T } = _u64_js_1$1.default.add(this.Eh | 0, this.El | 0, O | 0, T | 0), { h: y, l: V } = _u64_js_1$1.default.add(this.Fh | 0, this.Fl | 0, y | 0, V | 0), { h: M, l: G } = _u64_js_1$1.default.add(this.Gh | 0, this.Gl | 0, M | 0, G | 0), { h: k, l: F } = _u64_js_1$1.default.add(this.Hh | 0, this.Hl | 0, k | 0, F | 0), this.set(u, c, d, m, v, S, $, E, O, T, y, V, M, G, k, F);
  }
  roundClean() {
    SHA512_W_H.fill(0), SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
sha512$a.SHA512 = SHA512$2;
class SHA512_224 extends SHA512$2 {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
class SHA512_256 extends SHA512$2 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
let SHA384$1 = class extends SHA512$2 {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
};
sha512$a.sha512 = (0, utils_js_1$3.wrapConstructor)(() => new SHA512$2());
sha512$a.sha512_224 = (0, utils_js_1$3.wrapConstructor)(() => new SHA512_224());
sha512$a.sha512_256 = (0, utils_js_1$3.wrapConstructor)(() => new SHA512_256());
sha512$a.sha384 = (0, utils_js_1$3.wrapConstructor)(() => new SHA384$1());
var cryptoBrowserify = {}, browser$d = { exports: {} }, safeBuffer = { exports: {} }, buffer$1 = {}, ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(e, n, o, u, c) {
  var d, m, v = c * 8 - u - 1, S = (1 << v) - 1, $ = S >> 1, E = -7, O = o ? c - 1 : 0, T = o ? -1 : 1, y = e[n + O];
  for (O += T, d = y & (1 << -E) - 1, y >>= -E, E += v; E > 0; d = d * 256 + e[n + O], O += T, E -= 8)
    ;
  for (m = d & (1 << -E) - 1, d >>= -E, E += u; E > 0; m = m * 256 + e[n + O], O += T, E -= 8)
    ;
  if (d === 0)
    d = 1 - $;
  else {
    if (d === S)
      return m ? NaN : (y ? -1 : 1) * (1 / 0);
    m = m + Math.pow(2, u), d = d - $;
  }
  return (y ? -1 : 1) * m * Math.pow(2, d - u);
};
ieee754.write = function(e, n, o, u, c, d) {
  var m, v, S, $ = d * 8 - c - 1, E = (1 << $) - 1, O = E >> 1, T = c === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = u ? 0 : d - 1, V = u ? 1 : -1, M = n < 0 || n === 0 && 1 / n < 0 ? 1 : 0;
  for (n = Math.abs(n), isNaN(n) || n === 1 / 0 ? (v = isNaN(n) ? 1 : 0, m = E) : (m = Math.floor(Math.log(n) / Math.LN2), n * (S = Math.pow(2, -m)) < 1 && (m--, S *= 2), m + O >= 1 ? n += T / S : n += T * Math.pow(2, 1 - O), n * S >= 2 && (m++, S /= 2), m + O >= E ? (v = 0, m = E) : m + O >= 1 ? (v = (n * S - 1) * Math.pow(2, c), m = m + O) : (v = n * Math.pow(2, O - 1) * Math.pow(2, c), m = 0)); c >= 8; e[o + y] = v & 255, y += V, v /= 256, c -= 8)
    ;
  for (m = m << c | v, $ += c; $ > 0; e[o + y] = m & 255, y += V, m /= 256, $ -= 8)
    ;
  e[o + y - V] |= M * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const n = base64Js, o = ieee754, u = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = v, e.SlowBuffer = F, e.INSPECT_MAX_BYTES = 50;
  const c = 2147483647;
  e.kMaxLength = c, v.TYPED_ARRAY_SUPPORT = d(), !v.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function d() {
    try {
      const ce = new Uint8Array(1), Ze = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Ze, Uint8Array.prototype), Object.setPrototypeOf(ce, Ze), ce.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(v.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (v.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(v.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (v.isBuffer(this))
        return this.byteOffset;
    }
  });
  function m(ce) {
    if (ce > c)
      throw new RangeError('The value "' + ce + '" is invalid for option "size"');
    const Ze = new Uint8Array(ce);
    return Object.setPrototypeOf(Ze, v.prototype), Ze;
  }
  function v(ce, Ze, ft) {
    if (typeof ce == "number") {
      if (typeof Ze == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return O(ce);
    }
    return S(ce, Ze, ft);
  }
  v.poolSize = 8192;
  function S(ce, Ze, ft) {
    if (typeof ce == "string")
      return T(ce, Ze);
    if (ArrayBuffer.isView(ce))
      return V(ce);
    if (ce == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ce
      );
    if (At(ce, ArrayBuffer) || ce && At(ce.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (At(ce, SharedArrayBuffer) || ce && At(ce.buffer, SharedArrayBuffer)))
      return M(ce, Ze, ft);
    if (typeof ce == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const It = ce.valueOf && ce.valueOf();
    if (It != null && It !== ce)
      return v.from(It, Ze, ft);
    const rn = G(ce);
    if (rn)
      return rn;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof ce[Symbol.toPrimitive] == "function")
      return v.from(ce[Symbol.toPrimitive]("string"), Ze, ft);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ce
    );
  }
  v.from = function(ce, Ze, ft) {
    return S(ce, Ze, ft);
  }, Object.setPrototypeOf(v.prototype, Uint8Array.prototype), Object.setPrototypeOf(v, Uint8Array);
  function $(ce) {
    if (typeof ce != "number")
      throw new TypeError('"size" argument must be of type number');
    if (ce < 0)
      throw new RangeError('The value "' + ce + '" is invalid for option "size"');
  }
  function E(ce, Ze, ft) {
    return $(ce), ce <= 0 ? m(ce) : Ze !== void 0 ? typeof ft == "string" ? m(ce).fill(Ze, ft) : m(ce).fill(Ze) : m(ce);
  }
  v.alloc = function(ce, Ze, ft) {
    return E(ce, Ze, ft);
  };
  function O(ce) {
    return $(ce), m(ce < 0 ? 0 : k(ce) | 0);
  }
  v.allocUnsafe = function(ce) {
    return O(ce);
  }, v.allocUnsafeSlow = function(ce) {
    return O(ce);
  };
  function T(ce, Ze) {
    if ((typeof Ze != "string" || Ze === "") && (Ze = "utf8"), !v.isEncoding(Ze))
      throw new TypeError("Unknown encoding: " + Ze);
    const ft = X(ce, Ze) | 0;
    let It = m(ft);
    const rn = It.write(ce, Ze);
    return rn !== ft && (It = It.slice(0, rn)), It;
  }
  function y(ce) {
    const Ze = ce.length < 0 ? 0 : k(ce.length) | 0, ft = m(Ze);
    for (let It = 0; It < Ze; It += 1)
      ft[It] = ce[It] & 255;
    return ft;
  }
  function V(ce) {
    if (At(ce, Uint8Array)) {
      const Ze = new Uint8Array(ce);
      return M(Ze.buffer, Ze.byteOffset, Ze.byteLength);
    }
    return y(ce);
  }
  function M(ce, Ze, ft) {
    if (Ze < 0 || ce.byteLength < Ze)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (ce.byteLength < Ze + (ft || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let It;
    return Ze === void 0 && ft === void 0 ? It = new Uint8Array(ce) : ft === void 0 ? It = new Uint8Array(ce, Ze) : It = new Uint8Array(ce, Ze, ft), Object.setPrototypeOf(It, v.prototype), It;
  }
  function G(ce) {
    if (v.isBuffer(ce)) {
      const Ze = k(ce.length) | 0, ft = m(Ze);
      return ft.length === 0 || ce.copy(ft, 0, 0, Ze), ft;
    }
    if (ce.length !== void 0)
      return typeof ce.length != "number" || hn(ce.length) ? m(0) : y(ce);
    if (ce.type === "Buffer" && Array.isArray(ce.data))
      return y(ce.data);
  }
  function k(ce) {
    if (ce >= c)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + c.toString(16) + " bytes");
    return ce | 0;
  }
  function F(ce) {
    return +ce != ce && (ce = 0), v.alloc(+ce);
  }
  v.isBuffer = function(Ze) {
    return Ze != null && Ze._isBuffer === !0 && Ze !== v.prototype;
  }, v.compare = function(Ze, ft) {
    if (At(Ze, Uint8Array) && (Ze = v.from(Ze, Ze.offset, Ze.byteLength)), At(ft, Uint8Array) && (ft = v.from(ft, ft.offset, ft.byteLength)), !v.isBuffer(Ze) || !v.isBuffer(ft))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Ze === ft)
      return 0;
    let It = Ze.length, rn = ft.length;
    for (let Ln = 0, Pn = Math.min(It, rn); Ln < Pn; ++Ln)
      if (Ze[Ln] !== ft[Ln]) {
        It = Ze[Ln], rn = ft[Ln];
        break;
      }
    return It < rn ? -1 : rn < It ? 1 : 0;
  }, v.isEncoding = function(Ze) {
    switch (String(Ze).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, v.concat = function(Ze, ft) {
    if (!Array.isArray(Ze))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Ze.length === 0)
      return v.alloc(0);
    let It;
    if (ft === void 0)
      for (ft = 0, It = 0; It < Ze.length; ++It)
        ft += Ze[It].length;
    const rn = v.allocUnsafe(ft);
    let Ln = 0;
    for (It = 0; It < Ze.length; ++It) {
      let Pn = Ze[It];
      if (At(Pn, Uint8Array))
        Ln + Pn.length > rn.length ? (v.isBuffer(Pn) || (Pn = v.from(Pn)), Pn.copy(rn, Ln)) : Uint8Array.prototype.set.call(
          rn,
          Pn,
          Ln
        );
      else if (v.isBuffer(Pn))
        Pn.copy(rn, Ln);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      Ln += Pn.length;
    }
    return rn;
  };
  function X(ce, Ze) {
    if (v.isBuffer(ce))
      return ce.length;
    if (ArrayBuffer.isView(ce) || At(ce, ArrayBuffer))
      return ce.byteLength;
    if (typeof ce != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof ce
      );
    const ft = ce.length, It = arguments.length > 2 && arguments[2] === !0;
    if (!It && ft === 0)
      return 0;
    let rn = !1;
    for (; ; )
      switch (Ze) {
        case "ascii":
        case "latin1":
        case "binary":
          return ft;
        case "utf8":
        case "utf-8":
          return En(ce).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ft * 2;
        case "hex":
          return ft >>> 1;
        case "base64":
          return On(ce).length;
        default:
          if (rn)
            return It ? -1 : En(ce).length;
          Ze = ("" + Ze).toLowerCase(), rn = !0;
      }
  }
  v.byteLength = X;
  function ee(ce, Ze, ft) {
    let It = !1;
    if ((Ze === void 0 || Ze < 0) && (Ze = 0), Ze > this.length || ((ft === void 0 || ft > this.length) && (ft = this.length), ft <= 0) || (ft >>>= 0, Ze >>>= 0, ft <= Ze))
      return "";
    for (ce || (ce = "utf8"); ; )
      switch (ce) {
        case "hex":
          return W(this, Ze, ft);
        case "utf8":
        case "utf-8":
          return P(this, Ze, ft);
        case "ascii":
          return fe(this, Ze, ft);
        case "latin1":
        case "binary":
          return N(this, Ze, ft);
        case "base64":
          return w(this, Ze, ft);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return I(this, Ze, ft);
        default:
          if (It)
            throw new TypeError("Unknown encoding: " + ce);
          ce = (ce + "").toLowerCase(), It = !0;
      }
  }
  v.prototype._isBuffer = !0;
  function ue(ce, Ze, ft) {
    const It = ce[Ze];
    ce[Ze] = ce[ft], ce[ft] = It;
  }
  v.prototype.swap16 = function() {
    const Ze = this.length;
    if (Ze % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let ft = 0; ft < Ze; ft += 2)
      ue(this, ft, ft + 1);
    return this;
  }, v.prototype.swap32 = function() {
    const Ze = this.length;
    if (Ze % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let ft = 0; ft < Ze; ft += 4)
      ue(this, ft, ft + 3), ue(this, ft + 1, ft + 2);
    return this;
  }, v.prototype.swap64 = function() {
    const Ze = this.length;
    if (Ze % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let ft = 0; ft < Ze; ft += 8)
      ue(this, ft, ft + 7), ue(this, ft + 1, ft + 6), ue(this, ft + 2, ft + 5), ue(this, ft + 3, ft + 4);
    return this;
  }, v.prototype.toString = function() {
    const Ze = this.length;
    return Ze === 0 ? "" : arguments.length === 0 ? P(this, 0, Ze) : ee.apply(this, arguments);
  }, v.prototype.toLocaleString = v.prototype.toString, v.prototype.equals = function(Ze) {
    if (!v.isBuffer(Ze))
      throw new TypeError("Argument must be a Buffer");
    return this === Ze ? !0 : v.compare(this, Ze) === 0;
  }, v.prototype.inspect = function() {
    let Ze = "";
    const ft = e.INSPECT_MAX_BYTES;
    return Ze = this.toString("hex", 0, ft).replace(/(.{2})/g, "$1 ").trim(), this.length > ft && (Ze += " ... "), "<Buffer " + Ze + ">";
  }, u && (v.prototype[u] = v.prototype.inspect), v.prototype.compare = function(Ze, ft, It, rn, Ln) {
    if (At(Ze, Uint8Array) && (Ze = v.from(Ze, Ze.offset, Ze.byteLength)), !v.isBuffer(Ze))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Ze
      );
    if (ft === void 0 && (ft = 0), It === void 0 && (It = Ze ? Ze.length : 0), rn === void 0 && (rn = 0), Ln === void 0 && (Ln = this.length), ft < 0 || It > Ze.length || rn < 0 || Ln > this.length)
      throw new RangeError("out of range index");
    if (rn >= Ln && ft >= It)
      return 0;
    if (rn >= Ln)
      return -1;
    if (ft >= It)
      return 1;
    if (ft >>>= 0, It >>>= 0, rn >>>= 0, Ln >>>= 0, this === Ze)
      return 0;
    let Pn = Ln - rn, Ae = It - ft;
    const Me = Math.min(Pn, Ae), He = this.slice(rn, Ln), cn = Ze.slice(ft, It);
    for (let Wt = 0; Wt < Me; ++Wt)
      if (He[Wt] !== cn[Wt]) {
        Pn = He[Wt], Ae = cn[Wt];
        break;
      }
    return Pn < Ae ? -1 : Ae < Pn ? 1 : 0;
  };
  function Q(ce, Ze, ft, It, rn) {
    if (ce.length === 0)
      return -1;
    if (typeof ft == "string" ? (It = ft, ft = 0) : ft > 2147483647 ? ft = 2147483647 : ft < -2147483648 && (ft = -2147483648), ft = +ft, hn(ft) && (ft = rn ? 0 : ce.length - 1), ft < 0 && (ft = ce.length + ft), ft >= ce.length) {
      if (rn)
        return -1;
      ft = ce.length - 1;
    } else if (ft < 0)
      if (rn)
        ft = 0;
      else
        return -1;
    if (typeof Ze == "string" && (Ze = v.from(Ze, It)), v.isBuffer(Ze))
      return Ze.length === 0 ? -1 : Y(ce, Ze, ft, It, rn);
    if (typeof Ze == "number")
      return Ze = Ze & 255, typeof Uint8Array.prototype.indexOf == "function" ? rn ? Uint8Array.prototype.indexOf.call(ce, Ze, ft) : Uint8Array.prototype.lastIndexOf.call(ce, Ze, ft) : Y(ce, [Ze], ft, It, rn);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Y(ce, Ze, ft, It, rn) {
    let Ln = 1, Pn = ce.length, Ae = Ze.length;
    if (It !== void 0 && (It = String(It).toLowerCase(), It === "ucs2" || It === "ucs-2" || It === "utf16le" || It === "utf-16le")) {
      if (ce.length < 2 || Ze.length < 2)
        return -1;
      Ln = 2, Pn /= 2, Ae /= 2, ft /= 2;
    }
    function Me(cn, Wt) {
      return Ln === 1 ? cn[Wt] : cn.readUInt16BE(Wt * Ln);
    }
    let He;
    if (rn) {
      let cn = -1;
      for (He = ft; He < Pn; He++)
        if (Me(ce, He) === Me(Ze, cn === -1 ? 0 : He - cn)) {
          if (cn === -1 && (cn = He), He - cn + 1 === Ae)
            return cn * Ln;
        } else
          cn !== -1 && (He -= He - cn), cn = -1;
    } else
      for (ft + Ae > Pn && (ft = Pn - Ae), He = ft; He >= 0; He--) {
        let cn = !0;
        for (let Wt = 0; Wt < Ae; Wt++)
          if (Me(ce, He + Wt) !== Me(Ze, Wt)) {
            cn = !1;
            break;
          }
        if (cn)
          return He;
      }
    return -1;
  }
  v.prototype.includes = function(Ze, ft, It) {
    return this.indexOf(Ze, ft, It) !== -1;
  }, v.prototype.indexOf = function(Ze, ft, It) {
    return Q(this, Ze, ft, It, !0);
  }, v.prototype.lastIndexOf = function(Ze, ft, It) {
    return Q(this, Ze, ft, It, !1);
  };
  function pe(ce, Ze, ft, It) {
    ft = Number(ft) || 0;
    const rn = ce.length - ft;
    It ? (It = Number(It), It > rn && (It = rn)) : It = rn;
    const Ln = Ze.length;
    It > Ln / 2 && (It = Ln / 2);
    let Pn;
    for (Pn = 0; Pn < It; ++Pn) {
      const Ae = parseInt(Ze.substr(Pn * 2, 2), 16);
      if (hn(Ae))
        return Pn;
      ce[ft + Pn] = Ae;
    }
    return Pn;
  }
  function oe(ce, Ze, ft, It) {
    return sn(En(Ze, ce.length - ft), ce, ft, It);
  }
  function ne(ce, Ze, ft, It) {
    return sn(Ht(Ze), ce, ft, It);
  }
  function H(ce, Ze, ft, It) {
    return sn(On(Ze), ce, ft, It);
  }
  function C(ce, Ze, ft, It) {
    return sn(Xt(Ze, ce.length - ft), ce, ft, It);
  }
  v.prototype.write = function(Ze, ft, It, rn) {
    if (ft === void 0)
      rn = "utf8", It = this.length, ft = 0;
    else if (It === void 0 && typeof ft == "string")
      rn = ft, It = this.length, ft = 0;
    else if (isFinite(ft))
      ft = ft >>> 0, isFinite(It) ? (It = It >>> 0, rn === void 0 && (rn = "utf8")) : (rn = It, It = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const Ln = this.length - ft;
    if ((It === void 0 || It > Ln) && (It = Ln), Ze.length > 0 && (It < 0 || ft < 0) || ft > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    rn || (rn = "utf8");
    let Pn = !1;
    for (; ; )
      switch (rn) {
        case "hex":
          return pe(this, Ze, ft, It);
        case "utf8":
        case "utf-8":
          return oe(this, Ze, ft, It);
        case "ascii":
        case "latin1":
        case "binary":
          return ne(this, Ze, ft, It);
        case "base64":
          return H(this, Ze, ft, It);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return C(this, Ze, ft, It);
        default:
          if (Pn)
            throw new TypeError("Unknown encoding: " + rn);
          rn = ("" + rn).toLowerCase(), Pn = !0;
      }
  }, v.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function w(ce, Ze, ft) {
    return Ze === 0 && ft === ce.length ? n.fromByteArray(ce) : n.fromByteArray(ce.slice(Ze, ft));
  }
  function P(ce, Ze, ft) {
    ft = Math.min(ce.length, ft);
    const It = [];
    let rn = Ze;
    for (; rn < ft; ) {
      const Ln = ce[rn];
      let Pn = null, Ae = Ln > 239 ? 4 : Ln > 223 ? 3 : Ln > 191 ? 2 : 1;
      if (rn + Ae <= ft) {
        let Me, He, cn, Wt;
        switch (Ae) {
          case 1:
            Ln < 128 && (Pn = Ln);
            break;
          case 2:
            Me = ce[rn + 1], (Me & 192) === 128 && (Wt = (Ln & 31) << 6 | Me & 63, Wt > 127 && (Pn = Wt));
            break;
          case 3:
            Me = ce[rn + 1], He = ce[rn + 2], (Me & 192) === 128 && (He & 192) === 128 && (Wt = (Ln & 15) << 12 | (Me & 63) << 6 | He & 63, Wt > 2047 && (Wt < 55296 || Wt > 57343) && (Pn = Wt));
            break;
          case 4:
            Me = ce[rn + 1], He = ce[rn + 2], cn = ce[rn + 3], (Me & 192) === 128 && (He & 192) === 128 && (cn & 192) === 128 && (Wt = (Ln & 15) << 18 | (Me & 63) << 12 | (He & 63) << 6 | cn & 63, Wt > 65535 && Wt < 1114112 && (Pn = Wt));
        }
      }
      Pn === null ? (Pn = 65533, Ae = 1) : Pn > 65535 && (Pn -= 65536, It.push(Pn >>> 10 & 1023 | 55296), Pn = 56320 | Pn & 1023), It.push(Pn), rn += Ae;
    }
    return se(It);
  }
  const J = 4096;
  function se(ce) {
    const Ze = ce.length;
    if (Ze <= J)
      return String.fromCharCode.apply(String, ce);
    let ft = "", It = 0;
    for (; It < Ze; )
      ft += String.fromCharCode.apply(
        String,
        ce.slice(It, It += J)
      );
    return ft;
  }
  function fe(ce, Ze, ft) {
    let It = "";
    ft = Math.min(ce.length, ft);
    for (let rn = Ze; rn < ft; ++rn)
      It += String.fromCharCode(ce[rn] & 127);
    return It;
  }
  function N(ce, Ze, ft) {
    let It = "";
    ft = Math.min(ce.length, ft);
    for (let rn = Ze; rn < ft; ++rn)
      It += String.fromCharCode(ce[rn]);
    return It;
  }
  function W(ce, Ze, ft) {
    const It = ce.length;
    (!Ze || Ze < 0) && (Ze = 0), (!ft || ft < 0 || ft > It) && (ft = It);
    let rn = "";
    for (let Ln = Ze; Ln < ft; ++Ln)
      rn += $t[ce[Ln]];
    return rn;
  }
  function I(ce, Ze, ft) {
    const It = ce.slice(Ze, ft);
    let rn = "";
    for (let Ln = 0; Ln < It.length - 1; Ln += 2)
      rn += String.fromCharCode(It[Ln] + It[Ln + 1] * 256);
    return rn;
  }
  v.prototype.slice = function(Ze, ft) {
    const It = this.length;
    Ze = ~~Ze, ft = ft === void 0 ? It : ~~ft, Ze < 0 ? (Ze += It, Ze < 0 && (Ze = 0)) : Ze > It && (Ze = It), ft < 0 ? (ft += It, ft < 0 && (ft = 0)) : ft > It && (ft = It), ft < Ze && (ft = Ze);
    const rn = this.subarray(Ze, ft);
    return Object.setPrototypeOf(rn, v.prototype), rn;
  };
  function te(ce, Ze, ft) {
    if (ce % 1 !== 0 || ce < 0)
      throw new RangeError("offset is not uint");
    if (ce + Ze > ft)
      throw new RangeError("Trying to access beyond buffer length");
  }
  v.prototype.readUintLE = v.prototype.readUIntLE = function(Ze, ft, It) {
    Ze = Ze >>> 0, ft = ft >>> 0, It || te(Ze, ft, this.length);
    let rn = this[Ze], Ln = 1, Pn = 0;
    for (; ++Pn < ft && (Ln *= 256); )
      rn += this[Ze + Pn] * Ln;
    return rn;
  }, v.prototype.readUintBE = v.prototype.readUIntBE = function(Ze, ft, It) {
    Ze = Ze >>> 0, ft = ft >>> 0, It || te(Ze, ft, this.length);
    let rn = this[Ze + --ft], Ln = 1;
    for (; ft > 0 && (Ln *= 256); )
      rn += this[Ze + --ft] * Ln;
    return rn;
  }, v.prototype.readUint8 = v.prototype.readUInt8 = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 1, this.length), this[Ze];
  }, v.prototype.readUint16LE = v.prototype.readUInt16LE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 2, this.length), this[Ze] | this[Ze + 1] << 8;
  }, v.prototype.readUint16BE = v.prototype.readUInt16BE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 2, this.length), this[Ze] << 8 | this[Ze + 1];
  }, v.prototype.readUint32LE = v.prototype.readUInt32LE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 4, this.length), (this[Ze] | this[Ze + 1] << 8 | this[Ze + 2] << 16) + this[Ze + 3] * 16777216;
  }, v.prototype.readUint32BE = v.prototype.readUInt32BE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 4, this.length), this[Ze] * 16777216 + (this[Ze + 1] << 16 | this[Ze + 2] << 8 | this[Ze + 3]);
  }, v.prototype.readBigUInt64LE = Lt(function(Ze) {
    Ze = Ze >>> 0, at(Ze, "offset");
    const ft = this[Ze], It = this[Ze + 7];
    (ft === void 0 || It === void 0) && kt(Ze, this.length - 8);
    const rn = ft + this[++Ze] * 2 ** 8 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 24, Ln = this[++Ze] + this[++Ze] * 2 ** 8 + this[++Ze] * 2 ** 16 + It * 2 ** 24;
    return BigInt(rn) + (BigInt(Ln) << BigInt(32));
  }), v.prototype.readBigUInt64BE = Lt(function(Ze) {
    Ze = Ze >>> 0, at(Ze, "offset");
    const ft = this[Ze], It = this[Ze + 7];
    (ft === void 0 || It === void 0) && kt(Ze, this.length - 8);
    const rn = ft * 2 ** 24 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 8 + this[++Ze], Ln = this[++Ze] * 2 ** 24 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 8 + It;
    return (BigInt(rn) << BigInt(32)) + BigInt(Ln);
  }), v.prototype.readIntLE = function(Ze, ft, It) {
    Ze = Ze >>> 0, ft = ft >>> 0, It || te(Ze, ft, this.length);
    let rn = this[Ze], Ln = 1, Pn = 0;
    for (; ++Pn < ft && (Ln *= 256); )
      rn += this[Ze + Pn] * Ln;
    return Ln *= 128, rn >= Ln && (rn -= Math.pow(2, 8 * ft)), rn;
  }, v.prototype.readIntBE = function(Ze, ft, It) {
    Ze = Ze >>> 0, ft = ft >>> 0, It || te(Ze, ft, this.length);
    let rn = ft, Ln = 1, Pn = this[Ze + --rn];
    for (; rn > 0 && (Ln *= 256); )
      Pn += this[Ze + --rn] * Ln;
    return Ln *= 128, Pn >= Ln && (Pn -= Math.pow(2, 8 * ft)), Pn;
  }, v.prototype.readInt8 = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 1, this.length), this[Ze] & 128 ? (255 - this[Ze] + 1) * -1 : this[Ze];
  }, v.prototype.readInt16LE = function(Ze, ft) {
    Ze = Ze >>> 0, ft || te(Ze, 2, this.length);
    const It = this[Ze] | this[Ze + 1] << 8;
    return It & 32768 ? It | 4294901760 : It;
  }, v.prototype.readInt16BE = function(Ze, ft) {
    Ze = Ze >>> 0, ft || te(Ze, 2, this.length);
    const It = this[Ze + 1] | this[Ze] << 8;
    return It & 32768 ? It | 4294901760 : It;
  }, v.prototype.readInt32LE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 4, this.length), this[Ze] | this[Ze + 1] << 8 | this[Ze + 2] << 16 | this[Ze + 3] << 24;
  }, v.prototype.readInt32BE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 4, this.length), this[Ze] << 24 | this[Ze + 1] << 16 | this[Ze + 2] << 8 | this[Ze + 3];
  }, v.prototype.readBigInt64LE = Lt(function(Ze) {
    Ze = Ze >>> 0, at(Ze, "offset");
    const ft = this[Ze], It = this[Ze + 7];
    (ft === void 0 || It === void 0) && kt(Ze, this.length - 8);
    const rn = this[Ze + 4] + this[Ze + 5] * 2 ** 8 + this[Ze + 6] * 2 ** 16 + (It << 24);
    return (BigInt(rn) << BigInt(32)) + BigInt(ft + this[++Ze] * 2 ** 8 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 24);
  }), v.prototype.readBigInt64BE = Lt(function(Ze) {
    Ze = Ze >>> 0, at(Ze, "offset");
    const ft = this[Ze], It = this[Ze + 7];
    (ft === void 0 || It === void 0) && kt(Ze, this.length - 8);
    const rn = (ft << 24) + // Overflow
    this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 8 + this[++Ze];
    return (BigInt(rn) << BigInt(32)) + BigInt(this[++Ze] * 2 ** 24 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 8 + It);
  }), v.prototype.readFloatLE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 4, this.length), o.read(this, Ze, !0, 23, 4);
  }, v.prototype.readFloatBE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 4, this.length), o.read(this, Ze, !1, 23, 4);
  }, v.prototype.readDoubleLE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 8, this.length), o.read(this, Ze, !0, 52, 8);
  }, v.prototype.readDoubleBE = function(Ze, ft) {
    return Ze = Ze >>> 0, ft || te(Ze, 8, this.length), o.read(this, Ze, !1, 52, 8);
  };
  function ge(ce, Ze, ft, It, rn, Ln) {
    if (!v.isBuffer(ce))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Ze > rn || Ze < Ln)
      throw new RangeError('"value" argument is out of bounds');
    if (ft + It > ce.length)
      throw new RangeError("Index out of range");
  }
  v.prototype.writeUintLE = v.prototype.writeUIntLE = function(Ze, ft, It, rn) {
    if (Ze = +Ze, ft = ft >>> 0, It = It >>> 0, !rn) {
      const Ae = Math.pow(2, 8 * It) - 1;
      ge(this, Ze, ft, It, Ae, 0);
    }
    let Ln = 1, Pn = 0;
    for (this[ft] = Ze & 255; ++Pn < It && (Ln *= 256); )
      this[ft + Pn] = Ze / Ln & 255;
    return ft + It;
  }, v.prototype.writeUintBE = v.prototype.writeUIntBE = function(Ze, ft, It, rn) {
    if (Ze = +Ze, ft = ft >>> 0, It = It >>> 0, !rn) {
      const Ae = Math.pow(2, 8 * It) - 1;
      ge(this, Ze, ft, It, Ae, 0);
    }
    let Ln = It - 1, Pn = 1;
    for (this[ft + Ln] = Ze & 255; --Ln >= 0 && (Pn *= 256); )
      this[ft + Ln] = Ze / Pn & 255;
    return ft + It;
  }, v.prototype.writeUint8 = v.prototype.writeUInt8 = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 1, 255, 0), this[ft] = Ze & 255, ft + 1;
  }, v.prototype.writeUint16LE = v.prototype.writeUInt16LE = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 2, 65535, 0), this[ft] = Ze & 255, this[ft + 1] = Ze >>> 8, ft + 2;
  }, v.prototype.writeUint16BE = v.prototype.writeUInt16BE = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 2, 65535, 0), this[ft] = Ze >>> 8, this[ft + 1] = Ze & 255, ft + 2;
  }, v.prototype.writeUint32LE = v.prototype.writeUInt32LE = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 4, 4294967295, 0), this[ft + 3] = Ze >>> 24, this[ft + 2] = Ze >>> 16, this[ft + 1] = Ze >>> 8, this[ft] = Ze & 255, ft + 4;
  }, v.prototype.writeUint32BE = v.prototype.writeUInt32BE = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 4, 4294967295, 0), this[ft] = Ze >>> 24, this[ft + 1] = Ze >>> 16, this[ft + 2] = Ze >>> 8, this[ft + 3] = Ze & 255, ft + 4;
  };
  function Pe(ce, Ze, ft, It, rn) {
    pt(Ze, It, rn, ce, ft, 7);
    let Ln = Number(Ze & BigInt(4294967295));
    ce[ft++] = Ln, Ln = Ln >> 8, ce[ft++] = Ln, Ln = Ln >> 8, ce[ft++] = Ln, Ln = Ln >> 8, ce[ft++] = Ln;
    let Pn = Number(Ze >> BigInt(32) & BigInt(4294967295));
    return ce[ft++] = Pn, Pn = Pn >> 8, ce[ft++] = Pn, Pn = Pn >> 8, ce[ft++] = Pn, Pn = Pn >> 8, ce[ft++] = Pn, ft;
  }
  function Ke(ce, Ze, ft, It, rn) {
    pt(Ze, It, rn, ce, ft, 7);
    let Ln = Number(Ze & BigInt(4294967295));
    ce[ft + 7] = Ln, Ln = Ln >> 8, ce[ft + 6] = Ln, Ln = Ln >> 8, ce[ft + 5] = Ln, Ln = Ln >> 8, ce[ft + 4] = Ln;
    let Pn = Number(Ze >> BigInt(32) & BigInt(4294967295));
    return ce[ft + 3] = Pn, Pn = Pn >> 8, ce[ft + 2] = Pn, Pn = Pn >> 8, ce[ft + 1] = Pn, Pn = Pn >> 8, ce[ft] = Pn, ft + 8;
  }
  v.prototype.writeBigUInt64LE = Lt(function(Ze, ft = 0) {
    return Pe(this, Ze, ft, BigInt(0), BigInt("0xffffffffffffffff"));
  }), v.prototype.writeBigUInt64BE = Lt(function(Ze, ft = 0) {
    return Ke(this, Ze, ft, BigInt(0), BigInt("0xffffffffffffffff"));
  }), v.prototype.writeIntLE = function(Ze, ft, It, rn) {
    if (Ze = +Ze, ft = ft >>> 0, !rn) {
      const Me = Math.pow(2, 8 * It - 1);
      ge(this, Ze, ft, It, Me - 1, -Me);
    }
    let Ln = 0, Pn = 1, Ae = 0;
    for (this[ft] = Ze & 255; ++Ln < It && (Pn *= 256); )
      Ze < 0 && Ae === 0 && this[ft + Ln - 1] !== 0 && (Ae = 1), this[ft + Ln] = (Ze / Pn >> 0) - Ae & 255;
    return ft + It;
  }, v.prototype.writeIntBE = function(Ze, ft, It, rn) {
    if (Ze = +Ze, ft = ft >>> 0, !rn) {
      const Me = Math.pow(2, 8 * It - 1);
      ge(this, Ze, ft, It, Me - 1, -Me);
    }
    let Ln = It - 1, Pn = 1, Ae = 0;
    for (this[ft + Ln] = Ze & 255; --Ln >= 0 && (Pn *= 256); )
      Ze < 0 && Ae === 0 && this[ft + Ln + 1] !== 0 && (Ae = 1), this[ft + Ln] = (Ze / Pn >> 0) - Ae & 255;
    return ft + It;
  }, v.prototype.writeInt8 = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 1, 127, -128), Ze < 0 && (Ze = 255 + Ze + 1), this[ft] = Ze & 255, ft + 1;
  }, v.prototype.writeInt16LE = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 2, 32767, -32768), this[ft] = Ze & 255, this[ft + 1] = Ze >>> 8, ft + 2;
  }, v.prototype.writeInt16BE = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 2, 32767, -32768), this[ft] = Ze >>> 8, this[ft + 1] = Ze & 255, ft + 2;
  }, v.prototype.writeInt32LE = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 4, 2147483647, -2147483648), this[ft] = Ze & 255, this[ft + 1] = Ze >>> 8, this[ft + 2] = Ze >>> 16, this[ft + 3] = Ze >>> 24, ft + 4;
  }, v.prototype.writeInt32BE = function(Ze, ft, It) {
    return Ze = +Ze, ft = ft >>> 0, It || ge(this, Ze, ft, 4, 2147483647, -2147483648), Ze < 0 && (Ze = 4294967295 + Ze + 1), this[ft] = Ze >>> 24, this[ft + 1] = Ze >>> 16, this[ft + 2] = Ze >>> 8, this[ft + 3] = Ze & 255, ft + 4;
  }, v.prototype.writeBigInt64LE = Lt(function(Ze, ft = 0) {
    return Pe(this, Ze, ft, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), v.prototype.writeBigInt64BE = Lt(function(Ze, ft = 0) {
    return Ke(this, Ze, ft, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function xe(ce, Ze, ft, It, rn, Ln) {
    if (ft + It > ce.length)
      throw new RangeError("Index out of range");
    if (ft < 0)
      throw new RangeError("Index out of range");
  }
  function ze(ce, Ze, ft, It, rn) {
    return Ze = +Ze, ft = ft >>> 0, rn || xe(ce, Ze, ft, 4), o.write(ce, Ze, ft, It, 23, 4), ft + 4;
  }
  v.prototype.writeFloatLE = function(Ze, ft, It) {
    return ze(this, Ze, ft, !0, It);
  }, v.prototype.writeFloatBE = function(Ze, ft, It) {
    return ze(this, Ze, ft, !1, It);
  };
  function nt(ce, Ze, ft, It, rn) {
    return Ze = +Ze, ft = ft >>> 0, rn || xe(ce, Ze, ft, 8), o.write(ce, Ze, ft, It, 52, 8), ft + 8;
  }
  v.prototype.writeDoubleLE = function(Ze, ft, It) {
    return nt(this, Ze, ft, !0, It);
  }, v.prototype.writeDoubleBE = function(Ze, ft, It) {
    return nt(this, Ze, ft, !1, It);
  }, v.prototype.copy = function(Ze, ft, It, rn) {
    if (!v.isBuffer(Ze))
      throw new TypeError("argument should be a Buffer");
    if (It || (It = 0), !rn && rn !== 0 && (rn = this.length), ft >= Ze.length && (ft = Ze.length), ft || (ft = 0), rn > 0 && rn < It && (rn = It), rn === It || Ze.length === 0 || this.length === 0)
      return 0;
    if (ft < 0)
      throw new RangeError("targetStart out of bounds");
    if (It < 0 || It >= this.length)
      throw new RangeError("Index out of range");
    if (rn < 0)
      throw new RangeError("sourceEnd out of bounds");
    rn > this.length && (rn = this.length), Ze.length - ft < rn - It && (rn = Ze.length - ft + It);
    const Ln = rn - It;
    return this === Ze && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(ft, It, rn) : Uint8Array.prototype.set.call(
      Ze,
      this.subarray(It, rn),
      ft
    ), Ln;
  }, v.prototype.fill = function(Ze, ft, It, rn) {
    if (typeof Ze == "string") {
      if (typeof ft == "string" ? (rn = ft, ft = 0, It = this.length) : typeof It == "string" && (rn = It, It = this.length), rn !== void 0 && typeof rn != "string")
        throw new TypeError("encoding must be a string");
      if (typeof rn == "string" && !v.isEncoding(rn))
        throw new TypeError("Unknown encoding: " + rn);
      if (Ze.length === 1) {
        const Pn = Ze.charCodeAt(0);
        (rn === "utf8" && Pn < 128 || rn === "latin1") && (Ze = Pn);
      }
    } else
      typeof Ze == "number" ? Ze = Ze & 255 : typeof Ze == "boolean" && (Ze = Number(Ze));
    if (ft < 0 || this.length < ft || this.length < It)
      throw new RangeError("Out of range index");
    if (It <= ft)
      return this;
    ft = ft >>> 0, It = It === void 0 ? this.length : It >>> 0, Ze || (Ze = 0);
    let Ln;
    if (typeof Ze == "number")
      for (Ln = ft; Ln < It; ++Ln)
        this[Ln] = Ze;
    else {
      const Pn = v.isBuffer(Ze) ? Ze : v.from(Ze, rn), Ae = Pn.length;
      if (Ae === 0)
        throw new TypeError('The value "' + Ze + '" is invalid for argument "value"');
      for (Ln = 0; Ln < It - ft; ++Ln)
        this[Ln + ft] = Pn[Ln % Ae];
    }
    return this;
  };
  const Qt = {};
  function Et(ce, Ze, ft) {
    Qt[ce] = class extends ft {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Ze.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${ce}]`, this.stack, delete this.name;
      }
      get code() {
        return ce;
      }
      set code(rn) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: rn,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${ce}]: ${this.message}`;
      }
    };
  }
  Et(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(ce) {
      return ce ? `${ce} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Et(
    "ERR_INVALID_ARG_TYPE",
    function(ce, Ze) {
      return `The "${ce}" argument must be of type number. Received type ${typeof Ze}`;
    },
    TypeError
  ), Et(
    "ERR_OUT_OF_RANGE",
    function(ce, Ze, ft) {
      let It = `The value of "${ce}" is out of range.`, rn = ft;
      return Number.isInteger(ft) && Math.abs(ft) > 2 ** 32 ? rn = zt(String(ft)) : typeof ft == "bigint" && (rn = String(ft), (ft > BigInt(2) ** BigInt(32) || ft < -(BigInt(2) ** BigInt(32))) && (rn = zt(rn)), rn += "n"), It += ` It must be ${Ze}. Received ${rn}`, It;
    },
    RangeError
  );
  function zt(ce) {
    let Ze = "", ft = ce.length;
    const It = ce[0] === "-" ? 1 : 0;
    for (; ft >= It + 4; ft -= 3)
      Ze = `_${ce.slice(ft - 3, ft)}${Ze}`;
    return `${ce.slice(0, ft)}${Ze}`;
  }
  function Nt(ce, Ze, ft) {
    at(Ze, "offset"), (ce[Ze] === void 0 || ce[Ze + ft] === void 0) && kt(Ze, ce.length - (ft + 1));
  }
  function pt(ce, Ze, ft, It, rn, Ln) {
    if (ce > ft || ce < Ze) {
      const Pn = typeof Ze == "bigint" ? "n" : "";
      let Ae;
      throw Ln > 3 ? Ze === 0 || Ze === BigInt(0) ? Ae = `>= 0${Pn} and < 2${Pn} ** ${(Ln + 1) * 8}${Pn}` : Ae = `>= -(2${Pn} ** ${(Ln + 1) * 8 - 1}${Pn}) and < 2 ** ${(Ln + 1) * 8 - 1}${Pn}` : Ae = `>= ${Ze}${Pn} and <= ${ft}${Pn}`, new Qt.ERR_OUT_OF_RANGE("value", Ae, ce);
    }
    Nt(It, rn, Ln);
  }
  function at(ce, Ze) {
    if (typeof ce != "number")
      throw new Qt.ERR_INVALID_ARG_TYPE(Ze, "number", ce);
  }
  function kt(ce, Ze, ft) {
    throw Math.floor(ce) !== ce ? (at(ce, ft), new Qt.ERR_OUT_OF_RANGE(ft || "offset", "an integer", ce)) : Ze < 0 ? new Qt.ERR_BUFFER_OUT_OF_BOUNDS() : new Qt.ERR_OUT_OF_RANGE(
      ft || "offset",
      `>= ${ft ? 1 : 0} and <= ${Ze}`,
      ce
    );
  }
  const Ut = /[^+/0-9A-Za-z-_]/g;
  function dn(ce) {
    if (ce = ce.split("=")[0], ce = ce.trim().replace(Ut, ""), ce.length < 2)
      return "";
    for (; ce.length % 4 !== 0; )
      ce = ce + "=";
    return ce;
  }
  function En(ce, Ze) {
    Ze = Ze || 1 / 0;
    let ft;
    const It = ce.length;
    let rn = null;
    const Ln = [];
    for (let Pn = 0; Pn < It; ++Pn) {
      if (ft = ce.charCodeAt(Pn), ft > 55295 && ft < 57344) {
        if (!rn) {
          if (ft > 56319) {
            (Ze -= 3) > -1 && Ln.push(239, 191, 189);
            continue;
          } else if (Pn + 1 === It) {
            (Ze -= 3) > -1 && Ln.push(239, 191, 189);
            continue;
          }
          rn = ft;
          continue;
        }
        if (ft < 56320) {
          (Ze -= 3) > -1 && Ln.push(239, 191, 189), rn = ft;
          continue;
        }
        ft = (rn - 55296 << 10 | ft - 56320) + 65536;
      } else
        rn && (Ze -= 3) > -1 && Ln.push(239, 191, 189);
      if (rn = null, ft < 128) {
        if ((Ze -= 1) < 0)
          break;
        Ln.push(ft);
      } else if (ft < 2048) {
        if ((Ze -= 2) < 0)
          break;
        Ln.push(
          ft >> 6 | 192,
          ft & 63 | 128
        );
      } else if (ft < 65536) {
        if ((Ze -= 3) < 0)
          break;
        Ln.push(
          ft >> 12 | 224,
          ft >> 6 & 63 | 128,
          ft & 63 | 128
        );
      } else if (ft < 1114112) {
        if ((Ze -= 4) < 0)
          break;
        Ln.push(
          ft >> 18 | 240,
          ft >> 12 & 63 | 128,
          ft >> 6 & 63 | 128,
          ft & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return Ln;
  }
  function Ht(ce) {
    const Ze = [];
    for (let ft = 0; ft < ce.length; ++ft)
      Ze.push(ce.charCodeAt(ft) & 255);
    return Ze;
  }
  function Xt(ce, Ze) {
    let ft, It, rn;
    const Ln = [];
    for (let Pn = 0; Pn < ce.length && !((Ze -= 2) < 0); ++Pn)
      ft = ce.charCodeAt(Pn), It = ft >> 8, rn = ft % 256, Ln.push(rn), Ln.push(It);
    return Ln;
  }
  function On(ce) {
    return n.toByteArray(dn(ce));
  }
  function sn(ce, Ze, ft, It) {
    let rn;
    for (rn = 0; rn < It && !(rn + ft >= Ze.length || rn >= ce.length); ++rn)
      Ze[rn + ft] = ce[rn];
    return rn;
  }
  function At(ce, Ze) {
    return ce instanceof Ze || ce != null && ce.constructor != null && ce.constructor.name != null && ce.constructor.name === Ze.name;
  }
  function hn(ce) {
    return ce !== ce;
  }
  const $t = function() {
    const ce = "0123456789abcdef", Ze = new Array(256);
    for (let ft = 0; ft < 16; ++ft) {
      const It = ft * 16;
      for (let rn = 0; rn < 16; ++rn)
        Ze[It + rn] = ce[ft] + ce[rn];
    }
    return Ze;
  }();
  function Lt(ce) {
    return typeof BigInt > "u" ? Qn : ce;
  }
  function Qn() {
    throw new Error("BigInt not supported");
  }
})(buffer$1);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(e, n) {
    var o = buffer$1, u = o.Buffer;
    function c(m, v) {
      for (var S in m)
        v[S] = m[S];
    }
    u.from && u.alloc && u.allocUnsafe && u.allocUnsafeSlow ? e.exports = o : (c(o, n), n.Buffer = d);
    function d(m, v, S) {
      return u(m, v, S);
    }
    d.prototype = Object.create(u.prototype), c(u, d), d.from = function(m, v, S) {
      if (typeof m == "number")
        throw new TypeError("Argument must not be a number");
      return u(m, v, S);
    }, d.alloc = function(m, v, S) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      var $ = u(m);
      return v !== void 0 ? typeof S == "string" ? $.fill(v, S) : $.fill(v) : $.fill(0), $;
    }, d.allocUnsafe = function(m) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      return u(m);
    }, d.allocUnsafeSlow = function(m) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      return o.SlowBuffer(m);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var hasRequiredBrowser$b;
function requireBrowser$b() {
  if (hasRequiredBrowser$b)
    return browser$d.exports;
  hasRequiredBrowser$b = 1;
  var e = 65536, n = 4294967295;
  function o() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var u = requireSafeBuffer().Buffer, c = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
  c && c.getRandomValues ? browser$d.exports = d : browser$d.exports = o;
  function d(m, v) {
    if (m > n)
      throw new RangeError("requested too many random bytes");
    var S = u.allocUnsafe(m);
    if (m > 0)
      if (m > e)
        for (var $ = 0; $ < m; $ += e)
          c.getRandomValues(S.slice($, $ + e));
      else
        c.getRandomValues(S);
    return typeof v == "function" ? browser$1$1.nextTick(function() {
      v(null, S);
    }) : S;
  }
  return browser$d.exports;
}
var inherits_browser$1 = { exports: {} }, hasRequiredInherits_browser;
function requireInherits_browser() {
  return hasRequiredInherits_browser || (hasRequiredInherits_browser = 1, typeof Object.create == "function" ? inherits_browser$1.exports = function(n, o) {
    o && (n.super_ = o, n.prototype = Object.create(o.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : inherits_browser$1.exports = function(n, o) {
    if (o) {
      n.super_ = o;
      var u = function() {
      };
      u.prototype = o.prototype, n.prototype = new u(), n.prototype.constructor = n;
    }
  }), inherits_browser$1.exports;
}
var readableBrowser = { exports: {} }, events$2 = { exports: {} }, R = typeof Reflect == "object" ? Reflect : null, ReflectApply = R && typeof R.apply == "function" ? R.apply : function(n, o, u) {
  return Function.prototype.apply.call(n, o, u);
}, ReflectOwnKeys;
R && typeof R.ownKeys == "function" ? ReflectOwnKeys = R.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(n) {
  return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : ReflectOwnKeys = function(n) {
  return Object.getOwnPropertyNames(n);
};
function ProcessEmitWarning(e) {
  console && console.warn && console.warn(e);
}
var NumberIsNaN = Number.isNaN || function(n) {
  return n !== n;
};
function EventEmitter$1() {
  EventEmitter$1.init.call(this);
}
events$2.exports = EventEmitter$1;
events$2.exports.once = once;
EventEmitter$1.EventEmitter = EventEmitter$1;
EventEmitter$1.prototype._events = void 0;
EventEmitter$1.prototype._eventsCount = 0;
EventEmitter$1.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(EventEmitter$1, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || NumberIsNaN(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    defaultMaxListeners = e;
  }
});
EventEmitter$1.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$1.prototype.setMaxListeners = function(n) {
  if (typeof n != "number" || n < 0 || NumberIsNaN(n))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
  return this._maxListeners = n, this;
};
function _getMaxListeners(e) {
  return e._maxListeners === void 0 ? EventEmitter$1.defaultMaxListeners : e._maxListeners;
}
EventEmitter$1.prototype.getMaxListeners = function() {
  return _getMaxListeners(this);
};
EventEmitter$1.prototype.emit = function(n) {
  for (var o = [], u = 1; u < arguments.length; u++)
    o.push(arguments[u]);
  var c = n === "error", d = this._events;
  if (d !== void 0)
    c = c && d.error === void 0;
  else if (!c)
    return !1;
  if (c) {
    var m;
    if (o.length > 0 && (m = o[0]), m instanceof Error)
      throw m;
    var v = new Error("Unhandled error." + (m ? " (" + m.message + ")" : ""));
    throw v.context = m, v;
  }
  var S = d[n];
  if (S === void 0)
    return !1;
  if (typeof S == "function")
    ReflectApply(S, this, o);
  else
    for (var $ = S.length, E = arrayClone(S, $), u = 0; u < $; ++u)
      ReflectApply(E[u], this, o);
  return !0;
};
function _addListener(e, n, o, u) {
  var c, d, m;
  if (checkListener(o), d = e._events, d === void 0 ? (d = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (d.newListener !== void 0 && (e.emit(
    "newListener",
    n,
    o.listener ? o.listener : o
  ), d = e._events), m = d[n]), m === void 0)
    m = d[n] = o, ++e._eventsCount;
  else if (typeof m == "function" ? m = d[n] = u ? [o, m] : [m, o] : u ? m.unshift(o) : m.push(o), c = _getMaxListeners(e), c > 0 && m.length > c && !m.warned) {
    m.warned = !0;
    var v = new Error("Possible EventEmitter memory leak detected. " + m.length + " " + String(n) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    v.name = "MaxListenersExceededWarning", v.emitter = e, v.type = n, v.count = m.length, ProcessEmitWarning(v);
  }
  return e;
}
EventEmitter$1.prototype.addListener = function(n, o) {
  return _addListener(this, n, o, !1);
};
EventEmitter$1.prototype.on = EventEmitter$1.prototype.addListener;
EventEmitter$1.prototype.prependListener = function(n, o) {
  return _addListener(this, n, o, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(e, n, o) {
  var u = { fired: !1, wrapFn: void 0, target: e, type: n, listener: o }, c = onceWrapper.bind(u);
  return c.listener = o, u.wrapFn = c, c;
}
EventEmitter$1.prototype.once = function(n, o) {
  return checkListener(o), this.on(n, _onceWrap(this, n, o)), this;
};
EventEmitter$1.prototype.prependOnceListener = function(n, o) {
  return checkListener(o), this.prependListener(n, _onceWrap(this, n, o)), this;
};
EventEmitter$1.prototype.removeListener = function(n, o) {
  var u, c, d, m, v;
  if (checkListener(o), c = this._events, c === void 0)
    return this;
  if (u = c[n], u === void 0)
    return this;
  if (u === o || u.listener === o)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete c[n], c.removeListener && this.emit("removeListener", n, u.listener || o));
  else if (typeof u != "function") {
    for (d = -1, m = u.length - 1; m >= 0; m--)
      if (u[m] === o || u[m].listener === o) {
        v = u[m].listener, d = m;
        break;
      }
    if (d < 0)
      return this;
    d === 0 ? u.shift() : spliceOne(u, d), u.length === 1 && (c[n] = u[0]), c.removeListener !== void 0 && this.emit("removeListener", n, v || o);
  }
  return this;
};
EventEmitter$1.prototype.off = EventEmitter$1.prototype.removeListener;
EventEmitter$1.prototype.removeAllListeners = function(n) {
  var o, u, c;
  if (u = this._events, u === void 0)
    return this;
  if (u.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : u[n] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete u[n]), this;
  if (arguments.length === 0) {
    var d = Object.keys(u), m;
    for (c = 0; c < d.length; ++c)
      m = d[c], m !== "removeListener" && this.removeAllListeners(m);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (o = u[n], typeof o == "function")
    this.removeListener(n, o);
  else if (o !== void 0)
    for (c = o.length - 1; c >= 0; c--)
      this.removeListener(n, o[c]);
  return this;
};
function _listeners(e, n, o) {
  var u = e._events;
  if (u === void 0)
    return [];
  var c = u[n];
  return c === void 0 ? [] : typeof c == "function" ? o ? [c.listener || c] : [c] : o ? unwrapListeners(c) : arrayClone(c, c.length);
}
EventEmitter$1.prototype.listeners = function(n) {
  return _listeners(this, n, !0);
};
EventEmitter$1.prototype.rawListeners = function(n) {
  return _listeners(this, n, !1);
};
EventEmitter$1.listenerCount = function(e, n) {
  return typeof e.listenerCount == "function" ? e.listenerCount(n) : listenerCount.call(e, n);
};
EventEmitter$1.prototype.listenerCount = listenerCount;
function listenerCount(e) {
  var n = this._events;
  if (n !== void 0) {
    var o = n[e];
    if (typeof o == "function")
      return 1;
    if (o !== void 0)
      return o.length;
  }
  return 0;
}
EventEmitter$1.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(e, n) {
  for (var o = new Array(n), u = 0; u < n; ++u)
    o[u] = e[u];
  return o;
}
function spliceOne(e, n) {
  for (; n + 1 < e.length; n++)
    e[n] = e[n + 1];
  e.pop();
}
function unwrapListeners(e) {
  for (var n = new Array(e.length), o = 0; o < n.length; ++o)
    n[o] = e[o].listener || e[o];
  return n;
}
function once(e, n) {
  return new Promise(function(o, u) {
    function c(m) {
      e.removeListener(n, d), u(m);
    }
    function d() {
      typeof e.removeListener == "function" && e.removeListener("error", c), o([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(e, n, d, { once: !0 }), n !== "error" && addErrorHandlerIfEventEmitter(e, c, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(e, n, o) {
  typeof e.on == "function" && eventTargetAgnosticAddListener(e, "error", n, o);
}
function eventTargetAgnosticAddListener(e, n, o, u) {
  if (typeof e.on == "function")
    u.once ? e.once(n, o) : e.on(n, o);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(n, function c(d) {
      u.once && e.removeEventListener(n, c), o(d);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var eventsExports = events$2.exports;
const EventEmitter$2 = /* @__PURE__ */ getDefaultExportFromCjs(eventsExports);
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = eventsExports.EventEmitter), streamBrowser;
}
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list)
    return buffer_list;
  hasRequiredBuffer_list = 1;
  function e(V, M) {
    var G = Object.keys(V);
    if (Object.getOwnPropertySymbols) {
      var k = Object.getOwnPropertySymbols(V);
      M && (k = k.filter(function(F) {
        return Object.getOwnPropertyDescriptor(V, F).enumerable;
      })), G.push.apply(G, k);
    }
    return G;
  }
  function n(V) {
    for (var M = 1; M < arguments.length; M++) {
      var G = arguments[M] != null ? arguments[M] : {};
      M % 2 ? e(Object(G), !0).forEach(function(k) {
        o(V, k, G[k]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(V, Object.getOwnPropertyDescriptors(G)) : e(Object(G)).forEach(function(k) {
        Object.defineProperty(V, k, Object.getOwnPropertyDescriptor(G, k));
      });
    }
    return V;
  }
  function o(V, M, G) {
    return M = m(M), M in V ? Object.defineProperty(V, M, { value: G, enumerable: !0, configurable: !0, writable: !0 }) : V[M] = G, V;
  }
  function u(V, M) {
    if (!(V instanceof M))
      throw new TypeError("Cannot call a class as a function");
  }
  function c(V, M) {
    for (var G = 0; G < M.length; G++) {
      var k = M[G];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(V, m(k.key), k);
    }
  }
  function d(V, M, G) {
    return M && c(V.prototype, M), G && c(V, G), Object.defineProperty(V, "prototype", { writable: !1 }), V;
  }
  function m(V) {
    var M = v(V, "string");
    return typeof M == "symbol" ? M : String(M);
  }
  function v(V, M) {
    if (typeof V != "object" || V === null)
      return V;
    var G = V[Symbol.toPrimitive];
    if (G !== void 0) {
      var k = G.call(V, M || "default");
      if (typeof k != "object")
        return k;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (M === "string" ? String : Number)(V);
  }
  var S = buffer$1, $ = S.Buffer, E = require$$0$3, O = E.inspect, T = O && O.custom || "inspect";
  function y(V, M, G) {
    $.prototype.copy.call(V, M, G);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function V() {
      u(this, V), this.head = null, this.tail = null, this.length = 0;
    }
    return d(V, [{
      key: "push",
      value: function(G) {
        var k = {
          data: G,
          next: null
        };
        this.length > 0 ? this.tail.next = k : this.head = k, this.tail = k, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(G) {
        var k = {
          data: G,
          next: this.head
        };
        this.length === 0 && (this.tail = k), this.head = k, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var G = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, G;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(G) {
        if (this.length === 0)
          return "";
        for (var k = this.head, F = "" + k.data; k = k.next; )
          F += G + k.data;
        return F;
      }
    }, {
      key: "concat",
      value: function(G) {
        if (this.length === 0)
          return $.alloc(0);
        for (var k = $.allocUnsafe(G >>> 0), F = this.head, X = 0; F; )
          y(F.data, k, X), X += F.data.length, F = F.next;
        return k;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(G, k) {
        var F;
        return G < this.head.data.length ? (F = this.head.data.slice(0, G), this.head.data = this.head.data.slice(G)) : G === this.head.data.length ? F = this.shift() : F = k ? this._getString(G) : this._getBuffer(G), F;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(G) {
        var k = this.head, F = 1, X = k.data;
        for (G -= X.length; k = k.next; ) {
          var ee = k.data, ue = G > ee.length ? ee.length : G;
          if (ue === ee.length ? X += ee : X += ee.slice(0, G), G -= ue, G === 0) {
            ue === ee.length ? (++F, k.next ? this.head = k.next : this.head = this.tail = null) : (this.head = k, k.data = ee.slice(ue));
            break;
          }
          ++F;
        }
        return this.length -= F, X;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(G) {
        var k = $.allocUnsafe(G), F = this.head, X = 1;
        for (F.data.copy(k), G -= F.data.length; F = F.next; ) {
          var ee = F.data, ue = G > ee.length ? ee.length : G;
          if (ee.copy(k, k.length - G, 0, ue), G -= ue, G === 0) {
            ue === ee.length ? (++X, F.next ? this.head = F.next : this.head = this.tail = null) : (this.head = F, F.data = ee.slice(ue));
            break;
          }
          ++X;
        }
        return this.length -= X, k;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: T,
      value: function(G, k) {
        return O(this, n(n({}, k), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), V;
  }(), buffer_list;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy)
    return destroy_1;
  hasRequiredDestroy = 1;
  function e(m, v) {
    var S = this, $ = this._readableState && this._readableState.destroyed, E = this._writableState && this._writableState.destroyed;
    return $ || E ? (v ? v(m) : m && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, browser$1$1.nextTick(c, this, m)) : browser$1$1.nextTick(c, this, m)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(m || null, function(O) {
      !v && O ? S._writableState ? S._writableState.errorEmitted ? browser$1$1.nextTick(o, S) : (S._writableState.errorEmitted = !0, browser$1$1.nextTick(n, S, O)) : browser$1$1.nextTick(n, S, O) : v ? (browser$1$1.nextTick(o, S), v(O)) : browser$1$1.nextTick(o, S);
    }), this);
  }
  function n(m, v) {
    c(m, v), o(m);
  }
  function o(m) {
    m._writableState && !m._writableState.emitClose || m._readableState && !m._readableState.emitClose || m.emit("close");
  }
  function u() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function c(m, v) {
    m.emit("error", v);
  }
  function d(m, v) {
    var S = m._readableState, $ = m._writableState;
    S && S.autoDestroy || $ && $.autoDestroy ? m.destroy(v) : m.emit("error", v);
  }
  return destroy_1 = {
    destroy: e,
    undestroy: u,
    errorOrDestroy: d
  }, destroy_1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser)
    return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function e(v, S) {
    v.prototype = Object.create(S.prototype), v.prototype.constructor = v, v.__proto__ = S;
  }
  var n = {};
  function o(v, S, $) {
    $ || ($ = Error);
    function E(T, y, V) {
      return typeof S == "string" ? S : S(T, y, V);
    }
    var O = /* @__PURE__ */ function(T) {
      e(y, T);
      function y(V, M, G) {
        return T.call(this, E(V, M, G)) || this;
      }
      return y;
    }($);
    O.prototype.name = $.name, O.prototype.code = v, n[v] = O;
  }
  function u(v, S) {
    if (Array.isArray(v)) {
      var $ = v.length;
      return v = v.map(function(E) {
        return String(E);
      }), $ > 2 ? "one of ".concat(S, " ").concat(v.slice(0, $ - 1).join(", "), ", or ") + v[$ - 1] : $ === 2 ? "one of ".concat(S, " ").concat(v[0], " or ").concat(v[1]) : "of ".concat(S, " ").concat(v[0]);
    } else
      return "of ".concat(S, " ").concat(String(v));
  }
  function c(v, S, $) {
    return v.substr(!$ || $ < 0 ? 0 : +$, S.length) === S;
  }
  function d(v, S, $) {
    return ($ === void 0 || $ > v.length) && ($ = v.length), v.substring($ - S.length, $) === S;
  }
  function m(v, S, $) {
    return typeof $ != "number" && ($ = 0), $ + S.length > v.length ? !1 : v.indexOf(S, $) !== -1;
  }
  return o("ERR_INVALID_OPT_VALUE", function(v, S) {
    return 'The value "' + S + '" is invalid for option "' + v + '"';
  }, TypeError), o("ERR_INVALID_ARG_TYPE", function(v, S, $) {
    var E;
    typeof S == "string" && c(S, "not ") ? (E = "must not be", S = S.replace(/^not /, "")) : E = "must be";
    var O;
    if (d(v, " argument"))
      O = "The ".concat(v, " ").concat(E, " ").concat(u(S, "type"));
    else {
      var T = m(v, ".") ? "property" : "argument";
      O = 'The "'.concat(v, '" ').concat(T, " ").concat(E, " ").concat(u(S, "type"));
    }
    return O += ". Received type ".concat(typeof $), O;
  }, TypeError), o("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), o("ERR_METHOD_NOT_IMPLEMENTED", function(v) {
    return "The " + v + " method is not implemented";
  }), o("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), o("ERR_STREAM_DESTROYED", function(v) {
    return "Cannot call " + v + " after a stream was destroyed";
  }), o("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), o("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), o("ERR_STREAM_WRITE_AFTER_END", "write after end"), o("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), o("ERR_UNKNOWN_ENCODING", function(v) {
    return "Unknown encoding: " + v;
  }, TypeError), o("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = n, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState)
    return state;
  hasRequiredState = 1;
  var e = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function n(u, c, d) {
    return u.highWaterMark != null ? u.highWaterMark : c ? u[d] : null;
  }
  function o(u, c, d, m) {
    var v = n(c, m, d);
    if (v != null) {
      if (!(isFinite(v) && Math.floor(v) === v) || v < 0) {
        var S = m ? d : "highWaterMark";
        throw new e(S, v);
      }
      return Math.floor(v);
    }
    return u.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: o
  }, state;
}
var browser$c, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a)
    return browser$c;
  hasRequiredBrowser$a = 1, browser$c = e;
  function e(o, u) {
    if (n("noDeprecation"))
      return o;
    var c = !1;
    function d() {
      if (!c) {
        if (n("throwDeprecation"))
          throw new Error(u);
        n("traceDeprecation") ? console.trace(u) : console.warn(u), c = !0;
      }
      return o.apply(this, arguments);
    }
    return d;
  }
  function n(o) {
    try {
      if (!commonjsGlobal.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var u = commonjsGlobal.localStorage[o];
    return u == null ? !1 : String(u).toLowerCase() === "true";
  }
  return browser$c;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable)
    return _stream_writable;
  hasRequired_stream_writable = 1, _stream_writable = pe;
  function e(ze) {
    var nt = this;
    this.next = null, this.entry = null, this.finish = function() {
      xe(nt, ze);
    };
  }
  var n;
  pe.WritableState = Q;
  var o = {
    deprecate: requireBrowser$a()
  }, u = requireStreamBrowser(), c = buffer$1.Buffer, d = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function m(ze) {
    return c.from(ze);
  }
  function v(ze) {
    return c.isBuffer(ze) || ze instanceof d;
  }
  var S = requireDestroy(), $ = requireState(), E = $.getHighWaterMark, O = requireErrorsBrowser().codes, T = O.ERR_INVALID_ARG_TYPE, y = O.ERR_METHOD_NOT_IMPLEMENTED, V = O.ERR_MULTIPLE_CALLBACK, M = O.ERR_STREAM_CANNOT_PIPE, G = O.ERR_STREAM_DESTROYED, k = O.ERR_STREAM_NULL_VALUES, F = O.ERR_STREAM_WRITE_AFTER_END, X = O.ERR_UNKNOWN_ENCODING, ee = S.errorOrDestroy;
  requireInherits_browser()(pe, u);
  function ue() {
  }
  function Q(ze, nt, Qt) {
    n = n || require_stream_duplex(), ze = ze || {}, typeof Qt != "boolean" && (Qt = nt instanceof n), this.objectMode = !!ze.objectMode, Qt && (this.objectMode = this.objectMode || !!ze.writableObjectMode), this.highWaterMark = E(this, ze, "writableHighWaterMark", Qt), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Et = ze.decodeStrings === !1;
    this.decodeStrings = !Et, this.defaultEncoding = ze.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(zt) {
      se(nt, zt);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = ze.emitClose !== !1, this.autoDestroy = !!ze.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  Q.prototype.getBuffer = function() {
    for (var nt = this.bufferedRequest, Qt = []; nt; )
      Qt.push(nt), nt = nt.next;
    return Qt;
  }, function() {
    try {
      Object.defineProperty(Q.prototype, "buffer", {
        get: o.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Y;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Y = Function.prototype[Symbol.hasInstance], Object.defineProperty(pe, Symbol.hasInstance, {
    value: function(nt) {
      return Y.call(this, nt) ? !0 : this !== pe ? !1 : nt && nt._writableState instanceof Q;
    }
  })) : Y = function(nt) {
    return nt instanceof this;
  };
  function pe(ze) {
    n = n || require_stream_duplex();
    var nt = this instanceof n;
    if (!nt && !Y.call(pe, this))
      return new pe(ze);
    this._writableState = new Q(ze, this, nt), this.writable = !0, ze && (typeof ze.write == "function" && (this._write = ze.write), typeof ze.writev == "function" && (this._writev = ze.writev), typeof ze.destroy == "function" && (this._destroy = ze.destroy), typeof ze.final == "function" && (this._final = ze.final)), u.call(this);
  }
  pe.prototype.pipe = function() {
    ee(this, new M());
  };
  function oe(ze, nt) {
    var Qt = new F();
    ee(ze, Qt), browser$1$1.nextTick(nt, Qt);
  }
  function ne(ze, nt, Qt, Et) {
    var zt;
    return Qt === null ? zt = new k() : typeof Qt != "string" && !nt.objectMode && (zt = new T("chunk", ["string", "Buffer"], Qt)), zt ? (ee(ze, zt), browser$1$1.nextTick(Et, zt), !1) : !0;
  }
  pe.prototype.write = function(ze, nt, Qt) {
    var Et = this._writableState, zt = !1, Nt = !Et.objectMode && v(ze);
    return Nt && !c.isBuffer(ze) && (ze = m(ze)), typeof nt == "function" && (Qt = nt, nt = null), Nt ? nt = "buffer" : nt || (nt = Et.defaultEncoding), typeof Qt != "function" && (Qt = ue), Et.ending ? oe(this, Qt) : (Nt || ne(this, Et, ze, Qt)) && (Et.pendingcb++, zt = C(this, Et, Nt, ze, nt, Qt)), zt;
  }, pe.prototype.cork = function() {
    this._writableState.corked++;
  }, pe.prototype.uncork = function() {
    var ze = this._writableState;
    ze.corked && (ze.corked--, !ze.writing && !ze.corked && !ze.bufferProcessing && ze.bufferedRequest && W(this, ze));
  }, pe.prototype.setDefaultEncoding = function(nt) {
    if (typeof nt == "string" && (nt = nt.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((nt + "").toLowerCase()) > -1))
      throw new X(nt);
    return this._writableState.defaultEncoding = nt, this;
  }, Object.defineProperty(pe.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function H(ze, nt, Qt) {
    return !ze.objectMode && ze.decodeStrings !== !1 && typeof nt == "string" && (nt = c.from(nt, Qt)), nt;
  }
  Object.defineProperty(pe.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function C(ze, nt, Qt, Et, zt, Nt) {
    if (!Qt) {
      var pt = H(nt, Et, zt);
      Et !== pt && (Qt = !0, zt = "buffer", Et = pt);
    }
    var at = nt.objectMode ? 1 : Et.length;
    nt.length += at;
    var kt = nt.length < nt.highWaterMark;
    if (kt || (nt.needDrain = !0), nt.writing || nt.corked) {
      var Ut = nt.lastBufferedRequest;
      nt.lastBufferedRequest = {
        chunk: Et,
        encoding: zt,
        isBuf: Qt,
        callback: Nt,
        next: null
      }, Ut ? Ut.next = nt.lastBufferedRequest : nt.bufferedRequest = nt.lastBufferedRequest, nt.bufferedRequestCount += 1;
    } else
      w(ze, nt, !1, at, Et, zt, Nt);
    return kt;
  }
  function w(ze, nt, Qt, Et, zt, Nt, pt) {
    nt.writelen = Et, nt.writecb = pt, nt.writing = !0, nt.sync = !0, nt.destroyed ? nt.onwrite(new G("write")) : Qt ? ze._writev(zt, nt.onwrite) : ze._write(zt, Nt, nt.onwrite), nt.sync = !1;
  }
  function P(ze, nt, Qt, Et, zt) {
    --nt.pendingcb, Qt ? (browser$1$1.nextTick(zt, Et), browser$1$1.nextTick(Pe, ze, nt), ze._writableState.errorEmitted = !0, ee(ze, Et)) : (zt(Et), ze._writableState.errorEmitted = !0, ee(ze, Et), Pe(ze, nt));
  }
  function J(ze) {
    ze.writing = !1, ze.writecb = null, ze.length -= ze.writelen, ze.writelen = 0;
  }
  function se(ze, nt) {
    var Qt = ze._writableState, Et = Qt.sync, zt = Qt.writecb;
    if (typeof zt != "function")
      throw new V();
    if (J(Qt), nt)
      P(ze, Qt, Et, nt, zt);
    else {
      var Nt = I(Qt) || ze.destroyed;
      !Nt && !Qt.corked && !Qt.bufferProcessing && Qt.bufferedRequest && W(ze, Qt), Et ? browser$1$1.nextTick(fe, ze, Qt, Nt, zt) : fe(ze, Qt, Nt, zt);
    }
  }
  function fe(ze, nt, Qt, Et) {
    Qt || N(ze, nt), nt.pendingcb--, Et(), Pe(ze, nt);
  }
  function N(ze, nt) {
    nt.length === 0 && nt.needDrain && (nt.needDrain = !1, ze.emit("drain"));
  }
  function W(ze, nt) {
    nt.bufferProcessing = !0;
    var Qt = nt.bufferedRequest;
    if (ze._writev && Qt && Qt.next) {
      var Et = nt.bufferedRequestCount, zt = new Array(Et), Nt = nt.corkedRequestsFree;
      Nt.entry = Qt;
      for (var pt = 0, at = !0; Qt; )
        zt[pt] = Qt, Qt.isBuf || (at = !1), Qt = Qt.next, pt += 1;
      zt.allBuffers = at, w(ze, nt, !0, nt.length, zt, "", Nt.finish), nt.pendingcb++, nt.lastBufferedRequest = null, Nt.next ? (nt.corkedRequestsFree = Nt.next, Nt.next = null) : nt.corkedRequestsFree = new e(nt), nt.bufferedRequestCount = 0;
    } else {
      for (; Qt; ) {
        var kt = Qt.chunk, Ut = Qt.encoding, dn = Qt.callback, En = nt.objectMode ? 1 : kt.length;
        if (w(ze, nt, !1, En, kt, Ut, dn), Qt = Qt.next, nt.bufferedRequestCount--, nt.writing)
          break;
      }
      Qt === null && (nt.lastBufferedRequest = null);
    }
    nt.bufferedRequest = Qt, nt.bufferProcessing = !1;
  }
  pe.prototype._write = function(ze, nt, Qt) {
    Qt(new y("_write()"));
  }, pe.prototype._writev = null, pe.prototype.end = function(ze, nt, Qt) {
    var Et = this._writableState;
    return typeof ze == "function" ? (Qt = ze, ze = null, nt = null) : typeof nt == "function" && (Qt = nt, nt = null), ze != null && this.write(ze, nt), Et.corked && (Et.corked = 1, this.uncork()), Et.ending || Ke(this, Et, Qt), this;
  }, Object.defineProperty(pe.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function I(ze) {
    return ze.ending && ze.length === 0 && ze.bufferedRequest === null && !ze.finished && !ze.writing;
  }
  function te(ze, nt) {
    ze._final(function(Qt) {
      nt.pendingcb--, Qt && ee(ze, Qt), nt.prefinished = !0, ze.emit("prefinish"), Pe(ze, nt);
    });
  }
  function ge(ze, nt) {
    !nt.prefinished && !nt.finalCalled && (typeof ze._final == "function" && !nt.destroyed ? (nt.pendingcb++, nt.finalCalled = !0, browser$1$1.nextTick(te, ze, nt)) : (nt.prefinished = !0, ze.emit("prefinish")));
  }
  function Pe(ze, nt) {
    var Qt = I(nt);
    if (Qt && (ge(ze, nt), nt.pendingcb === 0 && (nt.finished = !0, ze.emit("finish"), nt.autoDestroy))) {
      var Et = ze._readableState;
      (!Et || Et.autoDestroy && Et.endEmitted) && ze.destroy();
    }
    return Qt;
  }
  function Ke(ze, nt, Qt) {
    nt.ending = !0, Pe(ze, nt), Qt && (nt.finished ? browser$1$1.nextTick(Qt) : ze.once("finish", Qt)), nt.ended = !0, ze.writable = !1;
  }
  function xe(ze, nt, Qt) {
    var Et = ze.entry;
    for (ze.entry = null; Et; ) {
      var zt = Et.callback;
      nt.pendingcb--, zt(Qt), Et = Et.next;
    }
    nt.corkedRequestsFree.next = ze;
  }
  return Object.defineProperty(pe.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(nt) {
      this._writableState && (this._writableState.destroyed = nt);
    }
  }), pe.prototype.destroy = S.destroy, pe.prototype._undestroy = S.undestroy, pe.prototype._destroy = function(ze, nt) {
    nt(ze);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex)
    return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var e = Object.keys || function($) {
    var E = [];
    for (var O in $)
      E.push(O);
    return E;
  };
  _stream_duplex = m;
  var n = require_stream_readable(), o = require_stream_writable();
  requireInherits_browser()(m, n);
  for (var u = e(o.prototype), c = 0; c < u.length; c++) {
    var d = u[c];
    m.prototype[d] || (m.prototype[d] = o.prototype[d]);
  }
  function m($) {
    if (!(this instanceof m))
      return new m($);
    n.call(this, $), o.call(this, $), this.allowHalfOpen = !0, $ && ($.readable === !1 && (this.readable = !1), $.writable === !1 && (this.writable = !1), $.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", v)));
  }
  Object.defineProperty(m.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(m.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(m.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function v() {
    this._writableState.ended || browser$1$1.nextTick(S, this);
  }
  function S($) {
    $.end();
  }
  return Object.defineProperty(m.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(E) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = E, this._writableState.destroyed = E);
    }
  }), _stream_duplex;
}
var string_decoder = {}, hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder)
    return string_decoder;
  hasRequiredString_decoder = 1;
  var e = requireSafeBuffer().Buffer, n = e.isEncoding || function(k) {
    switch (k = "" + k, k && k.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function o(k) {
    if (!k)
      return "utf8";
    for (var F; ; )
      switch (k) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return k;
        default:
          if (F)
            return;
          k = ("" + k).toLowerCase(), F = !0;
      }
  }
  function u(k) {
    var F = o(k);
    if (typeof F != "string" && (e.isEncoding === n || !n(k)))
      throw new Error("Unknown encoding: " + k);
    return F || k;
  }
  string_decoder.StringDecoder = c;
  function c(k) {
    this.encoding = u(k);
    var F;
    switch (this.encoding) {
      case "utf16le":
        this.text = O, this.end = T, F = 4;
        break;
      case "utf8":
        this.fillLast = S, F = 4;
        break;
      case "base64":
        this.text = y, this.end = V, F = 3;
        break;
      default:
        this.write = M, this.end = G;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(F);
  }
  c.prototype.write = function(k) {
    if (k.length === 0)
      return "";
    var F, X;
    if (this.lastNeed) {
      if (F = this.fillLast(k), F === void 0)
        return "";
      X = this.lastNeed, this.lastNeed = 0;
    } else
      X = 0;
    return X < k.length ? F ? F + this.text(k, X) : this.text(k, X) : F || "";
  }, c.prototype.end = E, c.prototype.text = $, c.prototype.fillLast = function(k) {
    if (this.lastNeed <= k.length)
      return k.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    k.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, k.length), this.lastNeed -= k.length;
  };
  function d(k) {
    return k <= 127 ? 0 : k >> 5 === 6 ? 2 : k >> 4 === 14 ? 3 : k >> 3 === 30 ? 4 : k >> 6 === 2 ? -1 : -2;
  }
  function m(k, F, X) {
    var ee = F.length - 1;
    if (ee < X)
      return 0;
    var ue = d(F[ee]);
    return ue >= 0 ? (ue > 0 && (k.lastNeed = ue - 1), ue) : --ee < X || ue === -2 ? 0 : (ue = d(F[ee]), ue >= 0 ? (ue > 0 && (k.lastNeed = ue - 2), ue) : --ee < X || ue === -2 ? 0 : (ue = d(F[ee]), ue >= 0 ? (ue > 0 && (ue === 2 ? ue = 0 : k.lastNeed = ue - 3), ue) : 0));
  }
  function v(k, F, X) {
    if ((F[0] & 192) !== 128)
      return k.lastNeed = 0, "�";
    if (k.lastNeed > 1 && F.length > 1) {
      if ((F[1] & 192) !== 128)
        return k.lastNeed = 1, "�";
      if (k.lastNeed > 2 && F.length > 2 && (F[2] & 192) !== 128)
        return k.lastNeed = 2, "�";
    }
  }
  function S(k) {
    var F = this.lastTotal - this.lastNeed, X = v(this, k);
    if (X !== void 0)
      return X;
    if (this.lastNeed <= k.length)
      return k.copy(this.lastChar, F, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    k.copy(this.lastChar, F, 0, k.length), this.lastNeed -= k.length;
  }
  function $(k, F) {
    var X = m(this, k, F);
    if (!this.lastNeed)
      return k.toString("utf8", F);
    this.lastTotal = X;
    var ee = k.length - (X - this.lastNeed);
    return k.copy(this.lastChar, 0, ee), k.toString("utf8", F, ee);
  }
  function E(k) {
    var F = k && k.length ? this.write(k) : "";
    return this.lastNeed ? F + "�" : F;
  }
  function O(k, F) {
    if ((k.length - F) % 2 === 0) {
      var X = k.toString("utf16le", F);
      if (X) {
        var ee = X.charCodeAt(X.length - 1);
        if (ee >= 55296 && ee <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = k[k.length - 2], this.lastChar[1] = k[k.length - 1], X.slice(0, -1);
      }
      return X;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = k[k.length - 1], k.toString("utf16le", F, k.length - 1);
  }
  function T(k) {
    var F = k && k.length ? this.write(k) : "";
    if (this.lastNeed) {
      var X = this.lastTotal - this.lastNeed;
      return F + this.lastChar.toString("utf16le", 0, X);
    }
    return F;
  }
  function y(k, F) {
    var X = (k.length - F) % 3;
    return X === 0 ? k.toString("base64", F) : (this.lastNeed = 3 - X, this.lastTotal = 3, X === 1 ? this.lastChar[0] = k[k.length - 1] : (this.lastChar[0] = k[k.length - 2], this.lastChar[1] = k[k.length - 1]), k.toString("base64", F, k.length - X));
  }
  function V(k) {
    var F = k && k.length ? this.write(k) : "";
    return this.lastNeed ? F + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : F;
  }
  function M(k) {
    return k.toString(this.encoding);
  }
  function G(k) {
    return k && k.length ? this.write(k) : "";
  }
  return string_decoder;
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream)
    return endOfStream;
  hasRequiredEndOfStream = 1;
  var e = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function n(d) {
    var m = !1;
    return function() {
      if (!m) {
        m = !0;
        for (var v = arguments.length, S = new Array(v), $ = 0; $ < v; $++)
          S[$] = arguments[$];
        d.apply(this, S);
      }
    };
  }
  function o() {
  }
  function u(d) {
    return d.setHeader && typeof d.abort == "function";
  }
  function c(d, m, v) {
    if (typeof m == "function")
      return c(d, null, m);
    m || (m = {}), v = n(v || o);
    var S = m.readable || m.readable !== !1 && d.readable, $ = m.writable || m.writable !== !1 && d.writable, E = function() {
      d.writable || T();
    }, O = d._writableState && d._writableState.finished, T = function() {
      $ = !1, O = !0, S || v.call(d);
    }, y = d._readableState && d._readableState.endEmitted, V = function() {
      S = !1, y = !0, $ || v.call(d);
    }, M = function(X) {
      v.call(d, X);
    }, G = function() {
      var X;
      if (S && !y)
        return (!d._readableState || !d._readableState.ended) && (X = new e()), v.call(d, X);
      if ($ && !O)
        return (!d._writableState || !d._writableState.ended) && (X = new e()), v.call(d, X);
    }, k = function() {
      d.req.on("finish", T);
    };
    return u(d) ? (d.on("complete", T), d.on("abort", G), d.req ? k() : d.on("request", k)) : $ && !d._writableState && (d.on("end", E), d.on("close", E)), d.on("end", V), d.on("finish", T), m.error !== !1 && d.on("error", M), d.on("close", G), function() {
      d.removeListener("complete", T), d.removeListener("abort", G), d.removeListener("request", k), d.req && d.req.removeListener("finish", T), d.removeListener("end", E), d.removeListener("close", E), d.removeListener("finish", T), d.removeListener("end", V), d.removeListener("error", M), d.removeListener("close", G);
    };
  }
  return endOfStream = c, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator)
    return async_iterator;
  hasRequiredAsync_iterator = 1;
  var e;
  function n(X, ee, ue) {
    return ee = o(ee), ee in X ? Object.defineProperty(X, ee, { value: ue, enumerable: !0, configurable: !0, writable: !0 }) : X[ee] = ue, X;
  }
  function o(X) {
    var ee = u(X, "string");
    return typeof ee == "symbol" ? ee : String(ee);
  }
  function u(X, ee) {
    if (typeof X != "object" || X === null)
      return X;
    var ue = X[Symbol.toPrimitive];
    if (ue !== void 0) {
      var Q = ue.call(X, ee || "default");
      if (typeof Q != "object")
        return Q;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (ee === "string" ? String : Number)(X);
  }
  var c = requireEndOfStream(), d = Symbol("lastResolve"), m = Symbol("lastReject"), v = Symbol("error"), S = Symbol("ended"), $ = Symbol("lastPromise"), E = Symbol("handlePromise"), O = Symbol("stream");
  function T(X, ee) {
    return {
      value: X,
      done: ee
    };
  }
  function y(X) {
    var ee = X[d];
    if (ee !== null) {
      var ue = X[O].read();
      ue !== null && (X[$] = null, X[d] = null, X[m] = null, ee(T(ue, !1)));
    }
  }
  function V(X) {
    browser$1$1.nextTick(y, X);
  }
  function M(X, ee) {
    return function(ue, Q) {
      X.then(function() {
        if (ee[S]) {
          ue(T(void 0, !0));
          return;
        }
        ee[E](ue, Q);
      }, Q);
    };
  }
  var G = Object.getPrototypeOf(function() {
  }), k = Object.setPrototypeOf((e = {
    get stream() {
      return this[O];
    },
    next: function() {
      var ee = this, ue = this[v];
      if (ue !== null)
        return Promise.reject(ue);
      if (this[S])
        return Promise.resolve(T(void 0, !0));
      if (this[O].destroyed)
        return new Promise(function(oe, ne) {
          browser$1$1.nextTick(function() {
            ee[v] ? ne(ee[v]) : oe(T(void 0, !0));
          });
        });
      var Q = this[$], Y;
      if (Q)
        Y = new Promise(M(Q, this));
      else {
        var pe = this[O].read();
        if (pe !== null)
          return Promise.resolve(T(pe, !1));
        Y = new Promise(this[E]);
      }
      return this[$] = Y, Y;
    }
  }, n(e, Symbol.asyncIterator, function() {
    return this;
  }), n(e, "return", function() {
    var ee = this;
    return new Promise(function(ue, Q) {
      ee[O].destroy(null, function(Y) {
        if (Y) {
          Q(Y);
          return;
        }
        ue(T(void 0, !0));
      });
    });
  }), e), G), F = function(ee) {
    var ue, Q = Object.create(k, (ue = {}, n(ue, O, {
      value: ee,
      writable: !0
    }), n(ue, d, {
      value: null,
      writable: !0
    }), n(ue, m, {
      value: null,
      writable: !0
    }), n(ue, v, {
      value: null,
      writable: !0
    }), n(ue, S, {
      value: ee._readableState.endEmitted,
      writable: !0
    }), n(ue, E, {
      value: function(pe, oe) {
        var ne = Q[O].read();
        ne ? (Q[$] = null, Q[d] = null, Q[m] = null, pe(T(ne, !1))) : (Q[d] = pe, Q[m] = oe);
      },
      writable: !0
    }), ue));
    return Q[$] = null, c(ee, function(Y) {
      if (Y && Y.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var pe = Q[m];
        pe !== null && (Q[$] = null, Q[d] = null, Q[m] = null, pe(Y)), Q[v] = Y;
        return;
      }
      var oe = Q[d];
      oe !== null && (Q[$] = null, Q[d] = null, Q[m] = null, oe(T(void 0, !0))), Q[S] = !0;
    }), ee.on("readable", V.bind(null, Q)), Q;
  };
  return async_iterator = F, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable)
    return _stream_readable;
  hasRequired_stream_readable = 1, _stream_readable = oe;
  var e;
  oe.ReadableState = pe, eventsExports.EventEmitter;
  var n = function(pt, at) {
    return pt.listeners(at).length;
  }, o = requireStreamBrowser(), u = buffer$1.Buffer, c = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function d(Nt) {
    return u.from(Nt);
  }
  function m(Nt) {
    return u.isBuffer(Nt) || Nt instanceof c;
  }
  var v = require$$0$3, S;
  v && v.debuglog ? S = v.debuglog("stream") : S = function() {
  };
  var $ = requireBuffer_list(), E = requireDestroy(), O = requireState(), T = O.getHighWaterMark, y = requireErrorsBrowser().codes, V = y.ERR_INVALID_ARG_TYPE, M = y.ERR_STREAM_PUSH_AFTER_EOF, G = y.ERR_METHOD_NOT_IMPLEMENTED, k = y.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, F, X, ee;
  requireInherits_browser()(oe, o);
  var ue = E.errorOrDestroy, Q = ["error", "close", "destroy", "pause", "resume"];
  function Y(Nt, pt, at) {
    if (typeof Nt.prependListener == "function")
      return Nt.prependListener(pt, at);
    !Nt._events || !Nt._events[pt] ? Nt.on(pt, at) : Array.isArray(Nt._events[pt]) ? Nt._events[pt].unshift(at) : Nt._events[pt] = [at, Nt._events[pt]];
  }
  function pe(Nt, pt, at) {
    e = e || require_stream_duplex(), Nt = Nt || {}, typeof at != "boolean" && (at = pt instanceof e), this.objectMode = !!Nt.objectMode, at && (this.objectMode = this.objectMode || !!Nt.readableObjectMode), this.highWaterMark = T(this, Nt, "readableHighWaterMark", at), this.buffer = new $(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Nt.emitClose !== !1, this.autoDestroy = !!Nt.autoDestroy, this.destroyed = !1, this.defaultEncoding = Nt.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Nt.encoding && (F || (F = requireString_decoder().StringDecoder), this.decoder = new F(Nt.encoding), this.encoding = Nt.encoding);
  }
  function oe(Nt) {
    if (e = e || require_stream_duplex(), !(this instanceof oe))
      return new oe(Nt);
    var pt = this instanceof e;
    this._readableState = new pe(Nt, this, pt), this.readable = !0, Nt && (typeof Nt.read == "function" && (this._read = Nt.read), typeof Nt.destroy == "function" && (this._destroy = Nt.destroy)), o.call(this);
  }
  Object.defineProperty(oe.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(pt) {
      this._readableState && (this._readableState.destroyed = pt);
    }
  }), oe.prototype.destroy = E.destroy, oe.prototype._undestroy = E.undestroy, oe.prototype._destroy = function(Nt, pt) {
    pt(Nt);
  }, oe.prototype.push = function(Nt, pt) {
    var at = this._readableState, kt;
    return at.objectMode ? kt = !0 : typeof Nt == "string" && (pt = pt || at.defaultEncoding, pt !== at.encoding && (Nt = u.from(Nt, pt), pt = ""), kt = !0), ne(this, Nt, pt, !1, kt);
  }, oe.prototype.unshift = function(Nt) {
    return ne(this, Nt, null, !0, !1);
  };
  function ne(Nt, pt, at, kt, Ut) {
    S("readableAddChunk", pt);
    var dn = Nt._readableState;
    if (pt === null)
      dn.reading = !1, se(Nt, dn);
    else {
      var En;
      if (Ut || (En = C(dn, pt)), En)
        ue(Nt, En);
      else if (dn.objectMode || pt && pt.length > 0)
        if (typeof pt != "string" && !dn.objectMode && Object.getPrototypeOf(pt) !== u.prototype && (pt = d(pt)), kt)
          dn.endEmitted ? ue(Nt, new k()) : H(Nt, dn, pt, !0);
        else if (dn.ended)
          ue(Nt, new M());
        else {
          if (dn.destroyed)
            return !1;
          dn.reading = !1, dn.decoder && !at ? (pt = dn.decoder.write(pt), dn.objectMode || pt.length !== 0 ? H(Nt, dn, pt, !1) : W(Nt, dn)) : H(Nt, dn, pt, !1);
        }
      else
        kt || (dn.reading = !1, W(Nt, dn));
    }
    return !dn.ended && (dn.length < dn.highWaterMark || dn.length === 0);
  }
  function H(Nt, pt, at, kt) {
    pt.flowing && pt.length === 0 && !pt.sync ? (pt.awaitDrain = 0, Nt.emit("data", at)) : (pt.length += pt.objectMode ? 1 : at.length, kt ? pt.buffer.unshift(at) : pt.buffer.push(at), pt.needReadable && fe(Nt)), W(Nt, pt);
  }
  function C(Nt, pt) {
    var at;
    return !m(pt) && typeof pt != "string" && pt !== void 0 && !Nt.objectMode && (at = new V("chunk", ["string", "Buffer", "Uint8Array"], pt)), at;
  }
  oe.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, oe.prototype.setEncoding = function(Nt) {
    F || (F = requireString_decoder().StringDecoder);
    var pt = new F(Nt);
    this._readableState.decoder = pt, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var at = this._readableState.buffer.head, kt = ""; at !== null; )
      kt += pt.write(at.data), at = at.next;
    return this._readableState.buffer.clear(), kt !== "" && this._readableState.buffer.push(kt), this._readableState.length = kt.length, this;
  };
  var w = 1073741824;
  function P(Nt) {
    return Nt >= w ? Nt = w : (Nt--, Nt |= Nt >>> 1, Nt |= Nt >>> 2, Nt |= Nt >>> 4, Nt |= Nt >>> 8, Nt |= Nt >>> 16, Nt++), Nt;
  }
  function J(Nt, pt) {
    return Nt <= 0 || pt.length === 0 && pt.ended ? 0 : pt.objectMode ? 1 : Nt !== Nt ? pt.flowing && pt.length ? pt.buffer.head.data.length : pt.length : (Nt > pt.highWaterMark && (pt.highWaterMark = P(Nt)), Nt <= pt.length ? Nt : pt.ended ? pt.length : (pt.needReadable = !0, 0));
  }
  oe.prototype.read = function(Nt) {
    S("read", Nt), Nt = parseInt(Nt, 10);
    var pt = this._readableState, at = Nt;
    if (Nt !== 0 && (pt.emittedReadable = !1), Nt === 0 && pt.needReadable && ((pt.highWaterMark !== 0 ? pt.length >= pt.highWaterMark : pt.length > 0) || pt.ended))
      return S("read: emitReadable", pt.length, pt.ended), pt.length === 0 && pt.ended ? Qt(this) : fe(this), null;
    if (Nt = J(Nt, pt), Nt === 0 && pt.ended)
      return pt.length === 0 && Qt(this), null;
    var kt = pt.needReadable;
    S("need readable", kt), (pt.length === 0 || pt.length - Nt < pt.highWaterMark) && (kt = !0, S("length less than watermark", kt)), pt.ended || pt.reading ? (kt = !1, S("reading or ended", kt)) : kt && (S("do read"), pt.reading = !0, pt.sync = !0, pt.length === 0 && (pt.needReadable = !0), this._read(pt.highWaterMark), pt.sync = !1, pt.reading || (Nt = J(at, pt)));
    var Ut;
    return Nt > 0 ? Ut = nt(Nt, pt) : Ut = null, Ut === null ? (pt.needReadable = pt.length <= pt.highWaterMark, Nt = 0) : (pt.length -= Nt, pt.awaitDrain = 0), pt.length === 0 && (pt.ended || (pt.needReadable = !0), at !== Nt && pt.ended && Qt(this)), Ut !== null && this.emit("data", Ut), Ut;
  };
  function se(Nt, pt) {
    if (S("onEofChunk"), !pt.ended) {
      if (pt.decoder) {
        var at = pt.decoder.end();
        at && at.length && (pt.buffer.push(at), pt.length += pt.objectMode ? 1 : at.length);
      }
      pt.ended = !0, pt.sync ? fe(Nt) : (pt.needReadable = !1, pt.emittedReadable || (pt.emittedReadable = !0, N(Nt)));
    }
  }
  function fe(Nt) {
    var pt = Nt._readableState;
    S("emitReadable", pt.needReadable, pt.emittedReadable), pt.needReadable = !1, pt.emittedReadable || (S("emitReadable", pt.flowing), pt.emittedReadable = !0, browser$1$1.nextTick(N, Nt));
  }
  function N(Nt) {
    var pt = Nt._readableState;
    S("emitReadable_", pt.destroyed, pt.length, pt.ended), !pt.destroyed && (pt.length || pt.ended) && (Nt.emit("readable"), pt.emittedReadable = !1), pt.needReadable = !pt.flowing && !pt.ended && pt.length <= pt.highWaterMark, ze(Nt);
  }
  function W(Nt, pt) {
    pt.readingMore || (pt.readingMore = !0, browser$1$1.nextTick(I, Nt, pt));
  }
  function I(Nt, pt) {
    for (; !pt.reading && !pt.ended && (pt.length < pt.highWaterMark || pt.flowing && pt.length === 0); ) {
      var at = pt.length;
      if (S("maybeReadMore read 0"), Nt.read(0), at === pt.length)
        break;
    }
    pt.readingMore = !1;
  }
  oe.prototype._read = function(Nt) {
    ue(this, new G("_read()"));
  }, oe.prototype.pipe = function(Nt, pt) {
    var at = this, kt = this._readableState;
    switch (kt.pipesCount) {
      case 0:
        kt.pipes = Nt;
        break;
      case 1:
        kt.pipes = [kt.pipes, Nt];
        break;
      default:
        kt.pipes.push(Nt);
        break;
    }
    kt.pipesCount += 1, S("pipe count=%d opts=%j", kt.pipesCount, pt);
    var Ut = (!pt || pt.end !== !1) && Nt !== browser$1$1.stdout && Nt !== browser$1$1.stderr, dn = Ut ? Ht : Qn;
    kt.endEmitted ? browser$1$1.nextTick(dn) : at.once("end", dn), Nt.on("unpipe", En);
    function En(ce, Ze) {
      S("onunpipe"), ce === at && Ze && Ze.hasUnpiped === !1 && (Ze.hasUnpiped = !0, sn());
    }
    function Ht() {
      S("onend"), Nt.end();
    }
    var Xt = te(at);
    Nt.on("drain", Xt);
    var On = !1;
    function sn() {
      S("cleanup"), Nt.removeListener("close", $t), Nt.removeListener("finish", Lt), Nt.removeListener("drain", Xt), Nt.removeListener("error", hn), Nt.removeListener("unpipe", En), at.removeListener("end", Ht), at.removeListener("end", Qn), at.removeListener("data", At), On = !0, kt.awaitDrain && (!Nt._writableState || Nt._writableState.needDrain) && Xt();
    }
    at.on("data", At);
    function At(ce) {
      S("ondata");
      var Ze = Nt.write(ce);
      S("dest.write", Ze), Ze === !1 && ((kt.pipesCount === 1 && kt.pipes === Nt || kt.pipesCount > 1 && zt(kt.pipes, Nt) !== -1) && !On && (S("false write response, pause", kt.awaitDrain), kt.awaitDrain++), at.pause());
    }
    function hn(ce) {
      S("onerror", ce), Qn(), Nt.removeListener("error", hn), n(Nt, "error") === 0 && ue(Nt, ce);
    }
    Y(Nt, "error", hn);
    function $t() {
      Nt.removeListener("finish", Lt), Qn();
    }
    Nt.once("close", $t);
    function Lt() {
      S("onfinish"), Nt.removeListener("close", $t), Qn();
    }
    Nt.once("finish", Lt);
    function Qn() {
      S("unpipe"), at.unpipe(Nt);
    }
    return Nt.emit("pipe", at), kt.flowing || (S("pipe resume"), at.resume()), Nt;
  };
  function te(Nt) {
    return function() {
      var at = Nt._readableState;
      S("pipeOnDrain", at.awaitDrain), at.awaitDrain && at.awaitDrain--, at.awaitDrain === 0 && n(Nt, "data") && (at.flowing = !0, ze(Nt));
    };
  }
  oe.prototype.unpipe = function(Nt) {
    var pt = this._readableState, at = {
      hasUnpiped: !1
    };
    if (pt.pipesCount === 0)
      return this;
    if (pt.pipesCount === 1)
      return Nt && Nt !== pt.pipes ? this : (Nt || (Nt = pt.pipes), pt.pipes = null, pt.pipesCount = 0, pt.flowing = !1, Nt && Nt.emit("unpipe", this, at), this);
    if (!Nt) {
      var kt = pt.pipes, Ut = pt.pipesCount;
      pt.pipes = null, pt.pipesCount = 0, pt.flowing = !1;
      for (var dn = 0; dn < Ut; dn++)
        kt[dn].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var En = zt(pt.pipes, Nt);
    return En === -1 ? this : (pt.pipes.splice(En, 1), pt.pipesCount -= 1, pt.pipesCount === 1 && (pt.pipes = pt.pipes[0]), Nt.emit("unpipe", this, at), this);
  }, oe.prototype.on = function(Nt, pt) {
    var at = o.prototype.on.call(this, Nt, pt), kt = this._readableState;
    return Nt === "data" ? (kt.readableListening = this.listenerCount("readable") > 0, kt.flowing !== !1 && this.resume()) : Nt === "readable" && !kt.endEmitted && !kt.readableListening && (kt.readableListening = kt.needReadable = !0, kt.flowing = !1, kt.emittedReadable = !1, S("on readable", kt.length, kt.reading), kt.length ? fe(this) : kt.reading || browser$1$1.nextTick(Pe, this)), at;
  }, oe.prototype.addListener = oe.prototype.on, oe.prototype.removeListener = function(Nt, pt) {
    var at = o.prototype.removeListener.call(this, Nt, pt);
    return Nt === "readable" && browser$1$1.nextTick(ge, this), at;
  }, oe.prototype.removeAllListeners = function(Nt) {
    var pt = o.prototype.removeAllListeners.apply(this, arguments);
    return (Nt === "readable" || Nt === void 0) && browser$1$1.nextTick(ge, this), pt;
  };
  function ge(Nt) {
    var pt = Nt._readableState;
    pt.readableListening = Nt.listenerCount("readable") > 0, pt.resumeScheduled && !pt.paused ? pt.flowing = !0 : Nt.listenerCount("data") > 0 && Nt.resume();
  }
  function Pe(Nt) {
    S("readable nexttick read 0"), Nt.read(0);
  }
  oe.prototype.resume = function() {
    var Nt = this._readableState;
    return Nt.flowing || (S("resume"), Nt.flowing = !Nt.readableListening, Ke(this, Nt)), Nt.paused = !1, this;
  };
  function Ke(Nt, pt) {
    pt.resumeScheduled || (pt.resumeScheduled = !0, browser$1$1.nextTick(xe, Nt, pt));
  }
  function xe(Nt, pt) {
    S("resume", pt.reading), pt.reading || Nt.read(0), pt.resumeScheduled = !1, Nt.emit("resume"), ze(Nt), pt.flowing && !pt.reading && Nt.read(0);
  }
  oe.prototype.pause = function() {
    return S("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (S("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function ze(Nt) {
    var pt = Nt._readableState;
    for (S("flow", pt.flowing); pt.flowing && Nt.read() !== null; )
      ;
  }
  oe.prototype.wrap = function(Nt) {
    var pt = this, at = this._readableState, kt = !1;
    Nt.on("end", function() {
      if (S("wrapped end"), at.decoder && !at.ended) {
        var En = at.decoder.end();
        En && En.length && pt.push(En);
      }
      pt.push(null);
    }), Nt.on("data", function(En) {
      if (S("wrapped data"), at.decoder && (En = at.decoder.write(En)), !(at.objectMode && En == null) && !(!at.objectMode && (!En || !En.length))) {
        var Ht = pt.push(En);
        Ht || (kt = !0, Nt.pause());
      }
    });
    for (var Ut in Nt)
      this[Ut] === void 0 && typeof Nt[Ut] == "function" && (this[Ut] = function(Ht) {
        return function() {
          return Nt[Ht].apply(Nt, arguments);
        };
      }(Ut));
    for (var dn = 0; dn < Q.length; dn++)
      Nt.on(Q[dn], this.emit.bind(this, Q[dn]));
    return this._read = function(En) {
      S("wrapped _read", En), kt && (kt = !1, Nt.resume());
    }, this;
  }, typeof Symbol == "function" && (oe.prototype[Symbol.asyncIterator] = function() {
    return X === void 0 && (X = requireAsync_iterator()), X(this);
  }), Object.defineProperty(oe.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(oe.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(oe.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(pt) {
      this._readableState && (this._readableState.flowing = pt);
    }
  }), oe._fromList = nt, Object.defineProperty(oe.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function nt(Nt, pt) {
    if (pt.length === 0)
      return null;
    var at;
    return pt.objectMode ? at = pt.buffer.shift() : !Nt || Nt >= pt.length ? (pt.decoder ? at = pt.buffer.join("") : pt.buffer.length === 1 ? at = pt.buffer.first() : at = pt.buffer.concat(pt.length), pt.buffer.clear()) : at = pt.buffer.consume(Nt, pt.decoder), at;
  }
  function Qt(Nt) {
    var pt = Nt._readableState;
    S("endReadable", pt.endEmitted), pt.endEmitted || (pt.ended = !0, browser$1$1.nextTick(Et, pt, Nt));
  }
  function Et(Nt, pt) {
    if (S("endReadableNT", Nt.endEmitted, Nt.length), !Nt.endEmitted && Nt.length === 0 && (Nt.endEmitted = !0, pt.readable = !1, pt.emit("end"), Nt.autoDestroy)) {
      var at = pt._writableState;
      (!at || at.autoDestroy && at.finished) && pt.destroy();
    }
  }
  typeof Symbol == "function" && (oe.from = function(Nt, pt) {
    return ee === void 0 && (ee = requireFromBrowser()), ee(oe, Nt, pt);
  });
  function zt(Nt, pt) {
    for (var at = 0, kt = Nt.length; at < kt; at++)
      if (Nt[at] === pt)
        return at;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform)
    return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = v;
  var e = requireErrorsBrowser().codes, n = e.ERR_METHOD_NOT_IMPLEMENTED, o = e.ERR_MULTIPLE_CALLBACK, u = e.ERR_TRANSFORM_ALREADY_TRANSFORMING, c = e.ERR_TRANSFORM_WITH_LENGTH_0, d = require_stream_duplex();
  requireInherits_browser()(v, d);
  function m(E, O) {
    var T = this._transformState;
    T.transforming = !1;
    var y = T.writecb;
    if (y === null)
      return this.emit("error", new o());
    T.writechunk = null, T.writecb = null, O != null && this.push(O), y(E);
    var V = this._readableState;
    V.reading = !1, (V.needReadable || V.length < V.highWaterMark) && this._read(V.highWaterMark);
  }
  function v(E) {
    if (!(this instanceof v))
      return new v(E);
    d.call(this, E), this._transformState = {
      afterTransform: m.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, E && (typeof E.transform == "function" && (this._transform = E.transform), typeof E.flush == "function" && (this._flush = E.flush)), this.on("prefinish", S);
  }
  function S() {
    var E = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(O, T) {
      $(E, O, T);
    }) : $(this, null, null);
  }
  v.prototype.push = function(E, O) {
    return this._transformState.needTransform = !1, d.prototype.push.call(this, E, O);
  }, v.prototype._transform = function(E, O, T) {
    T(new n("_transform()"));
  }, v.prototype._write = function(E, O, T) {
    var y = this._transformState;
    if (y.writecb = T, y.writechunk = E, y.writeencoding = O, !y.transforming) {
      var V = this._readableState;
      (y.needTransform || V.needReadable || V.length < V.highWaterMark) && this._read(V.highWaterMark);
    }
  }, v.prototype._read = function(E) {
    var O = this._transformState;
    O.writechunk !== null && !O.transforming ? (O.transforming = !0, this._transform(O.writechunk, O.writeencoding, O.afterTransform)) : O.needTransform = !0;
  }, v.prototype._destroy = function(E, O) {
    d.prototype._destroy.call(this, E, function(T) {
      O(T);
    });
  };
  function $(E, O, T) {
    if (O)
      return E.emit("error", O);
    if (T != null && E.push(T), E._writableState.length)
      throw new c();
    if (E._transformState.transforming)
      throw new u();
    return E.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough)
    return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = n;
  var e = require_stream_transform();
  requireInherits_browser()(n, e);
  function n(o) {
    if (!(this instanceof n))
      return new n(o);
    e.call(this, o);
  }
  return n.prototype._transform = function(o, u, c) {
    c(null, o);
  }, _stream_passthrough;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline)
    return pipeline_1;
  hasRequiredPipeline = 1;
  var e;
  function n(T) {
    var y = !1;
    return function() {
      y || (y = !0, T.apply(void 0, arguments));
    };
  }
  var o = requireErrorsBrowser().codes, u = o.ERR_MISSING_ARGS, c = o.ERR_STREAM_DESTROYED;
  function d(T) {
    if (T)
      throw T;
  }
  function m(T) {
    return T.setHeader && typeof T.abort == "function";
  }
  function v(T, y, V, M) {
    M = n(M);
    var G = !1;
    T.on("close", function() {
      G = !0;
    }), e === void 0 && (e = requireEndOfStream()), e(T, {
      readable: y,
      writable: V
    }, function(F) {
      if (F)
        return M(F);
      G = !0, M();
    });
    var k = !1;
    return function(F) {
      if (!G && !k) {
        if (k = !0, m(T))
          return T.abort();
        if (typeof T.destroy == "function")
          return T.destroy();
        M(F || new c("pipe"));
      }
    };
  }
  function S(T) {
    T();
  }
  function $(T, y) {
    return T.pipe(y);
  }
  function E(T) {
    return !T.length || typeof T[T.length - 1] != "function" ? d : T.pop();
  }
  function O() {
    for (var T = arguments.length, y = new Array(T), V = 0; V < T; V++)
      y[V] = arguments[V];
    var M = E(y);
    if (Array.isArray(y[0]) && (y = y[0]), y.length < 2)
      throw new u("streams");
    var G, k = y.map(function(F, X) {
      var ee = X < y.length - 1, ue = X > 0;
      return v(F, ee, ue, function(Q) {
        G || (G = Q), Q && k.forEach(S), !ee && (k.forEach(S), M(G));
      });
    });
    return y.reduce($);
  }
  return pipeline_1 = O, pipeline_1;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(e, n) {
    n = e.exports = require_stream_readable(), n.Stream = n, n.Readable = n, n.Writable = require_stream_writable(), n.Duplex = require_stream_duplex(), n.Transform = require_stream_transform(), n.PassThrough = require_stream_passthrough(), n.finished = requireEndOfStream(), n.pipeline = requirePipeline();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase)
    return hashBase;
  hasRequiredHashBase = 1;
  var e = requireSafeBuffer().Buffer, n = requireReadableBrowser().Transform, o = requireInherits_browser();
  function u(d, m) {
    if (!e.isBuffer(d) && typeof d != "string")
      throw new TypeError(m + " must be a string or a buffer");
  }
  function c(d) {
    n.call(this), this._block = e.allocUnsafe(d), this._blockSize = d, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return o(c, n), c.prototype._transform = function(d, m, v) {
    var S = null;
    try {
      this.update(d, m);
    } catch ($) {
      S = $;
    }
    v(S);
  }, c.prototype._flush = function(d) {
    var m = null;
    try {
      this.push(this.digest());
    } catch (v) {
      m = v;
    }
    d(m);
  }, c.prototype.update = function(d, m) {
    if (u(d, "Data"), this._finalized)
      throw new Error("Digest already called");
    e.isBuffer(d) || (d = e.from(d, m));
    for (var v = this._block, S = 0; this._blockOffset + d.length - S >= this._blockSize; ) {
      for (var $ = this._blockOffset; $ < this._blockSize; )
        v[$++] = d[S++];
      this._update(), this._blockOffset = 0;
    }
    for (; S < d.length; )
      v[this._blockOffset++] = d[S++];
    for (var E = 0, O = d.length * 8; O > 0; ++E)
      this._length[E] += O, O = this._length[E] / 4294967296 | 0, O > 0 && (this._length[E] -= 4294967296 * O);
    return this;
  }, c.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, c.prototype.digest = function(d) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var m = this._digest();
    d !== void 0 && (m = m.toString(d)), this._block.fill(0), this._blockOffset = 0;
    for (var v = 0; v < 4; ++v)
      this._length[v] = 0;
    return m;
  }, c.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = c, hashBase;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js)
    return md5_js;
  hasRequiredMd5_js = 1;
  var e = requireInherits_browser(), n = requireHashBase(), o = requireSafeBuffer().Buffer, u = new Array(16);
  function c() {
    n.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  e(c, n), c.prototype._update = function() {
    for (var E = u, O = 0; O < 16; ++O)
      E[O] = this._block.readInt32LE(O * 4);
    var T = this._a, y = this._b, V = this._c, M = this._d;
    T = m(T, y, V, M, E[0], 3614090360, 7), M = m(M, T, y, V, E[1], 3905402710, 12), V = m(V, M, T, y, E[2], 606105819, 17), y = m(y, V, M, T, E[3], 3250441966, 22), T = m(T, y, V, M, E[4], 4118548399, 7), M = m(M, T, y, V, E[5], 1200080426, 12), V = m(V, M, T, y, E[6], 2821735955, 17), y = m(y, V, M, T, E[7], 4249261313, 22), T = m(T, y, V, M, E[8], 1770035416, 7), M = m(M, T, y, V, E[9], 2336552879, 12), V = m(V, M, T, y, E[10], 4294925233, 17), y = m(y, V, M, T, E[11], 2304563134, 22), T = m(T, y, V, M, E[12], 1804603682, 7), M = m(M, T, y, V, E[13], 4254626195, 12), V = m(V, M, T, y, E[14], 2792965006, 17), y = m(y, V, M, T, E[15], 1236535329, 22), T = v(T, y, V, M, E[1], 4129170786, 5), M = v(M, T, y, V, E[6], 3225465664, 9), V = v(V, M, T, y, E[11], 643717713, 14), y = v(y, V, M, T, E[0], 3921069994, 20), T = v(T, y, V, M, E[5], 3593408605, 5), M = v(M, T, y, V, E[10], 38016083, 9), V = v(V, M, T, y, E[15], 3634488961, 14), y = v(y, V, M, T, E[4], 3889429448, 20), T = v(T, y, V, M, E[9], 568446438, 5), M = v(M, T, y, V, E[14], 3275163606, 9), V = v(V, M, T, y, E[3], 4107603335, 14), y = v(y, V, M, T, E[8], 1163531501, 20), T = v(T, y, V, M, E[13], 2850285829, 5), M = v(M, T, y, V, E[2], 4243563512, 9), V = v(V, M, T, y, E[7], 1735328473, 14), y = v(y, V, M, T, E[12], 2368359562, 20), T = S(T, y, V, M, E[5], 4294588738, 4), M = S(M, T, y, V, E[8], 2272392833, 11), V = S(V, M, T, y, E[11], 1839030562, 16), y = S(y, V, M, T, E[14], 4259657740, 23), T = S(T, y, V, M, E[1], 2763975236, 4), M = S(M, T, y, V, E[4], 1272893353, 11), V = S(V, M, T, y, E[7], 4139469664, 16), y = S(y, V, M, T, E[10], 3200236656, 23), T = S(T, y, V, M, E[13], 681279174, 4), M = S(M, T, y, V, E[0], 3936430074, 11), V = S(V, M, T, y, E[3], 3572445317, 16), y = S(y, V, M, T, E[6], 76029189, 23), T = S(T, y, V, M, E[9], 3654602809, 4), M = S(M, T, y, V, E[12], 3873151461, 11), V = S(V, M, T, y, E[15], 530742520, 16), y = S(y, V, M, T, E[2], 3299628645, 23), T = $(T, y, V, M, E[0], 4096336452, 6), M = $(M, T, y, V, E[7], 1126891415, 10), V = $(V, M, T, y, E[14], 2878612391, 15), y = $(y, V, M, T, E[5], 4237533241, 21), T = $(T, y, V, M, E[12], 1700485571, 6), M = $(M, T, y, V, E[3], 2399980690, 10), V = $(V, M, T, y, E[10], 4293915773, 15), y = $(y, V, M, T, E[1], 2240044497, 21), T = $(T, y, V, M, E[8], 1873313359, 6), M = $(M, T, y, V, E[15], 4264355552, 10), V = $(V, M, T, y, E[6], 2734768916, 15), y = $(y, V, M, T, E[13], 1309151649, 21), T = $(T, y, V, M, E[4], 4149444226, 6), M = $(M, T, y, V, E[11], 3174756917, 10), V = $(V, M, T, y, E[2], 718787259, 15), y = $(y, V, M, T, E[9], 3951481745, 21), this._a = this._a + T | 0, this._b = this._b + y | 0, this._c = this._c + V | 0, this._d = this._d + M | 0;
  }, c.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var E = o.allocUnsafe(16);
    return E.writeInt32LE(this._a, 0), E.writeInt32LE(this._b, 4), E.writeInt32LE(this._c, 8), E.writeInt32LE(this._d, 12), E;
  };
  function d(E, O) {
    return E << O | E >>> 32 - O;
  }
  function m(E, O, T, y, V, M, G) {
    return d(E + (O & T | ~O & y) + V + M | 0, G) + O | 0;
  }
  function v(E, O, T, y, V, M, G) {
    return d(E + (O & y | T & ~y) + V + M | 0, G) + O | 0;
  }
  function S(E, O, T, y, V, M, G) {
    return d(E + (O ^ T ^ y) + V + M | 0, G) + O | 0;
  }
  function $(E, O, T, y, V, M, G) {
    return d(E + (T ^ (O | ~y)) + V + M | 0, G) + O | 0;
  }
  return md5_js = c, md5_js;
}
var ripemd160$9, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160)
    return ripemd160$9;
  hasRequiredRipemd160 = 1;
  var e = buffer$1.Buffer, n = requireInherits_browser(), o = requireHashBase(), u = new Array(16), c = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], d = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], m = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], v = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], S = [0, 1518500249, 1859775393, 2400959708, 2840853838], $ = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function E() {
    o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  n(E, o), E.prototype._update = function() {
    for (var k = u, F = 0; F < 16; ++F)
      k[F] = this._block.readInt32LE(F * 4);
    for (var X = this._a | 0, ee = this._b | 0, ue = this._c | 0, Q = this._d | 0, Y = this._e | 0, pe = this._a | 0, oe = this._b | 0, ne = this._c | 0, H = this._d | 0, C = this._e | 0, w = 0; w < 80; w += 1) {
      var P, J;
      w < 16 ? (P = T(X, ee, ue, Q, Y, k[c[w]], S[0], m[w]), J = G(pe, oe, ne, H, C, k[d[w]], $[0], v[w])) : w < 32 ? (P = y(X, ee, ue, Q, Y, k[c[w]], S[1], m[w]), J = M(pe, oe, ne, H, C, k[d[w]], $[1], v[w])) : w < 48 ? (P = V(X, ee, ue, Q, Y, k[c[w]], S[2], m[w]), J = V(pe, oe, ne, H, C, k[d[w]], $[2], v[w])) : w < 64 ? (P = M(X, ee, ue, Q, Y, k[c[w]], S[3], m[w]), J = y(pe, oe, ne, H, C, k[d[w]], $[3], v[w])) : (P = G(X, ee, ue, Q, Y, k[c[w]], S[4], m[w]), J = T(pe, oe, ne, H, C, k[d[w]], $[4], v[w])), X = Y, Y = Q, Q = O(ue, 10), ue = ee, ee = P, pe = C, C = H, H = O(ne, 10), ne = oe, oe = J;
    }
    var se = this._b + ue + H | 0;
    this._b = this._c + Q + C | 0, this._c = this._d + Y + pe | 0, this._d = this._e + X + oe | 0, this._e = this._a + ee + ne | 0, this._a = se;
  }, E.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var k = e.alloc ? e.alloc(20) : new e(20);
    return k.writeInt32LE(this._a, 0), k.writeInt32LE(this._b, 4), k.writeInt32LE(this._c, 8), k.writeInt32LE(this._d, 12), k.writeInt32LE(this._e, 16), k;
  };
  function O(k, F) {
    return k << F | k >>> 32 - F;
  }
  function T(k, F, X, ee, ue, Q, Y, pe) {
    return O(k + (F ^ X ^ ee) + Q + Y | 0, pe) + ue | 0;
  }
  function y(k, F, X, ee, ue, Q, Y, pe) {
    return O(k + (F & X | ~F & ee) + Q + Y | 0, pe) + ue | 0;
  }
  function V(k, F, X, ee, ue, Q, Y, pe) {
    return O(k + ((F | ~X) ^ ee) + Q + Y | 0, pe) + ue | 0;
  }
  function M(k, F, X, ee, ue, Q, Y, pe) {
    return O(k + (F & ee | X & ~ee) + Q + Y | 0, pe) + ue | 0;
  }
  function G(k, F, X, ee, ue, Q, Y, pe) {
    return O(k + (F ^ (X | ~ee)) + Q + Y | 0, pe) + ue | 0;
  }
  return ripemd160$9 = E, ripemd160$9;
}
var sha_js = { exports: {} }, hash$5, hasRequiredHash;
function requireHash() {
  if (hasRequiredHash)
    return hash$5;
  hasRequiredHash = 1;
  var e = requireSafeBuffer().Buffer;
  function n(o, u) {
    this._block = e.alloc(o), this._finalSize = u, this._blockSize = o, this._len = 0;
  }
  return n.prototype.update = function(o, u) {
    typeof o == "string" && (u = u || "utf8", o = e.from(o, u));
    for (var c = this._block, d = this._blockSize, m = o.length, v = this._len, S = 0; S < m; ) {
      for (var $ = v % d, E = Math.min(m - S, d - $), O = 0; O < E; O++)
        c[$ + O] = o[S + O];
      v += E, S += E, v % d === 0 && this._update(c);
    }
    return this._len += m, this;
  }, n.prototype.digest = function(o) {
    var u = this._len % this._blockSize;
    this._block[u] = 128, this._block.fill(0, u + 1), u >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var c = this._len * 8;
    if (c <= 4294967295)
      this._block.writeUInt32BE(c, this._blockSize - 4);
    else {
      var d = (c & 4294967295) >>> 0, m = (c - d) / 4294967296;
      this._block.writeUInt32BE(m, this._blockSize - 8), this._block.writeUInt32BE(d, this._blockSize - 4);
    }
    this._update(this._block);
    var v = this._hash();
    return o ? v.toString(o) : v;
  }, n.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, hash$5 = n, hash$5;
}
var sha$9, hasRequiredSha;
function requireSha() {
  if (hasRequiredSha)
    return sha$9;
  hasRequiredSha = 1;
  var e = requireInherits_browser(), n = requireHash(), o = requireSafeBuffer().Buffer, u = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], c = new Array(80);
  function d() {
    this.init(), this._w = c, n.call(this, 64, 56);
  }
  e(d, n), d.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function m($) {
    return $ << 5 | $ >>> 27;
  }
  function v($) {
    return $ << 30 | $ >>> 2;
  }
  function S($, E, O, T) {
    return $ === 0 ? E & O | ~E & T : $ === 2 ? E & O | E & T | O & T : E ^ O ^ T;
  }
  return d.prototype._update = function($) {
    for (var E = this._w, O = this._a | 0, T = this._b | 0, y = this._c | 0, V = this._d | 0, M = this._e | 0, G = 0; G < 16; ++G)
      E[G] = $.readInt32BE(G * 4);
    for (; G < 80; ++G)
      E[G] = E[G - 3] ^ E[G - 8] ^ E[G - 14] ^ E[G - 16];
    for (var k = 0; k < 80; ++k) {
      var F = ~~(k / 20), X = m(O) + S(F, T, y, V) + M + E[k] + u[F] | 0;
      M = V, V = y, y = v(T), T = O, O = X;
    }
    this._a = O + this._a | 0, this._b = T + this._b | 0, this._c = y + this._c | 0, this._d = V + this._d | 0, this._e = M + this._e | 0;
  }, d.prototype._hash = function() {
    var $ = o.allocUnsafe(20);
    return $.writeInt32BE(this._a | 0, 0), $.writeInt32BE(this._b | 0, 4), $.writeInt32BE(this._c | 0, 8), $.writeInt32BE(this._d | 0, 12), $.writeInt32BE(this._e | 0, 16), $;
  }, sha$9 = d, sha$9;
}
var sha1, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1)
    return sha1;
  hasRequiredSha1 = 1;
  var e = requireInherits_browser(), n = requireHash(), o = requireSafeBuffer().Buffer, u = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], c = new Array(80);
  function d() {
    this.init(), this._w = c, n.call(this, 64, 56);
  }
  e(d, n), d.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function m(E) {
    return E << 1 | E >>> 31;
  }
  function v(E) {
    return E << 5 | E >>> 27;
  }
  function S(E) {
    return E << 30 | E >>> 2;
  }
  function $(E, O, T, y) {
    return E === 0 ? O & T | ~O & y : E === 2 ? O & T | O & y | T & y : O ^ T ^ y;
  }
  return d.prototype._update = function(E) {
    for (var O = this._w, T = this._a | 0, y = this._b | 0, V = this._c | 0, M = this._d | 0, G = this._e | 0, k = 0; k < 16; ++k)
      O[k] = E.readInt32BE(k * 4);
    for (; k < 80; ++k)
      O[k] = m(O[k - 3] ^ O[k - 8] ^ O[k - 14] ^ O[k - 16]);
    for (var F = 0; F < 80; ++F) {
      var X = ~~(F / 20), ee = v(T) + $(X, y, V, M) + G + O[F] + u[X] | 0;
      G = M, M = V, V = S(y), y = T, T = ee;
    }
    this._a = T + this._a | 0, this._b = y + this._b | 0, this._c = V + this._c | 0, this._d = M + this._d | 0, this._e = G + this._e | 0;
  }, d.prototype._hash = function() {
    var E = o.allocUnsafe(20);
    return E.writeInt32BE(this._a | 0, 0), E.writeInt32BE(this._b | 0, 4), E.writeInt32BE(this._c | 0, 8), E.writeInt32BE(this._d | 0, 12), E.writeInt32BE(this._e | 0, 16), E;
  }, sha1 = d, sha1;
}
var sha256$a, hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256)
    return sha256$a;
  hasRequiredSha256 = 1;
  var e = requireInherits_browser(), n = requireHash(), o = requireSafeBuffer().Buffer, u = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], c = new Array(64);
  function d() {
    this.init(), this._w = c, n.call(this, 64, 56);
  }
  e(d, n), d.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function m(T, y, V) {
    return V ^ T & (y ^ V);
  }
  function v(T, y, V) {
    return T & y | V & (T | y);
  }
  function S(T) {
    return (T >>> 2 | T << 30) ^ (T >>> 13 | T << 19) ^ (T >>> 22 | T << 10);
  }
  function $(T) {
    return (T >>> 6 | T << 26) ^ (T >>> 11 | T << 21) ^ (T >>> 25 | T << 7);
  }
  function E(T) {
    return (T >>> 7 | T << 25) ^ (T >>> 18 | T << 14) ^ T >>> 3;
  }
  function O(T) {
    return (T >>> 17 | T << 15) ^ (T >>> 19 | T << 13) ^ T >>> 10;
  }
  return d.prototype._update = function(T) {
    for (var y = this._w, V = this._a | 0, M = this._b | 0, G = this._c | 0, k = this._d | 0, F = this._e | 0, X = this._f | 0, ee = this._g | 0, ue = this._h | 0, Q = 0; Q < 16; ++Q)
      y[Q] = T.readInt32BE(Q * 4);
    for (; Q < 64; ++Q)
      y[Q] = O(y[Q - 2]) + y[Q - 7] + E(y[Q - 15]) + y[Q - 16] | 0;
    for (var Y = 0; Y < 64; ++Y) {
      var pe = ue + $(F) + m(F, X, ee) + u[Y] + y[Y] | 0, oe = S(V) + v(V, M, G) | 0;
      ue = ee, ee = X, X = F, F = k + pe | 0, k = G, G = M, M = V, V = pe + oe | 0;
    }
    this._a = V + this._a | 0, this._b = M + this._b | 0, this._c = G + this._c | 0, this._d = k + this._d | 0, this._e = F + this._e | 0, this._f = X + this._f | 0, this._g = ee + this._g | 0, this._h = ue + this._h | 0;
  }, d.prototype._hash = function() {
    var T = o.allocUnsafe(32);
    return T.writeInt32BE(this._a, 0), T.writeInt32BE(this._b, 4), T.writeInt32BE(this._c, 8), T.writeInt32BE(this._d, 12), T.writeInt32BE(this._e, 16), T.writeInt32BE(this._f, 20), T.writeInt32BE(this._g, 24), T.writeInt32BE(this._h, 28), T;
  }, sha256$a = d, sha256$a;
}
var sha224$1, hasRequiredSha224;
function requireSha224() {
  if (hasRequiredSha224)
    return sha224$1;
  hasRequiredSha224 = 1;
  var e = requireInherits_browser(), n = requireSha256(), o = requireHash(), u = requireSafeBuffer().Buffer, c = new Array(64);
  function d() {
    this.init(), this._w = c, o.call(this, 64, 56);
  }
  return e(d, n), d.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, d.prototype._hash = function() {
    var m = u.allocUnsafe(28);
    return m.writeInt32BE(this._a, 0), m.writeInt32BE(this._b, 4), m.writeInt32BE(this._c, 8), m.writeInt32BE(this._d, 12), m.writeInt32BE(this._e, 16), m.writeInt32BE(this._f, 20), m.writeInt32BE(this._g, 24), m;
  }, sha224$1 = d, sha224$1;
}
var sha512$9, hasRequiredSha512;
function requireSha512() {
  if (hasRequiredSha512)
    return sha512$9;
  hasRequiredSha512 = 1;
  var e = requireInherits_browser(), n = requireHash(), o = requireSafeBuffer().Buffer, u = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], c = new Array(160);
  function d() {
    this.init(), this._w = c, n.call(this, 128, 112);
  }
  e(d, n), d.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function m(M, G, k) {
    return k ^ M & (G ^ k);
  }
  function v(M, G, k) {
    return M & G | k & (M | G);
  }
  function S(M, G) {
    return (M >>> 28 | G << 4) ^ (G >>> 2 | M << 30) ^ (G >>> 7 | M << 25);
  }
  function $(M, G) {
    return (M >>> 14 | G << 18) ^ (M >>> 18 | G << 14) ^ (G >>> 9 | M << 23);
  }
  function E(M, G) {
    return (M >>> 1 | G << 31) ^ (M >>> 8 | G << 24) ^ M >>> 7;
  }
  function O(M, G) {
    return (M >>> 1 | G << 31) ^ (M >>> 8 | G << 24) ^ (M >>> 7 | G << 25);
  }
  function T(M, G) {
    return (M >>> 19 | G << 13) ^ (G >>> 29 | M << 3) ^ M >>> 6;
  }
  function y(M, G) {
    return (M >>> 19 | G << 13) ^ (G >>> 29 | M << 3) ^ (M >>> 6 | G << 26);
  }
  function V(M, G) {
    return M >>> 0 < G >>> 0 ? 1 : 0;
  }
  return d.prototype._update = function(M) {
    for (var G = this._w, k = this._ah | 0, F = this._bh | 0, X = this._ch | 0, ee = this._dh | 0, ue = this._eh | 0, Q = this._fh | 0, Y = this._gh | 0, pe = this._hh | 0, oe = this._al | 0, ne = this._bl | 0, H = this._cl | 0, C = this._dl | 0, w = this._el | 0, P = this._fl | 0, J = this._gl | 0, se = this._hl | 0, fe = 0; fe < 32; fe += 2)
      G[fe] = M.readInt32BE(fe * 4), G[fe + 1] = M.readInt32BE(fe * 4 + 4);
    for (; fe < 160; fe += 2) {
      var N = G[fe - 30], W = G[fe - 15 * 2 + 1], I = E(N, W), te = O(W, N);
      N = G[fe - 2 * 2], W = G[fe - 2 * 2 + 1];
      var ge = T(N, W), Pe = y(W, N), Ke = G[fe - 7 * 2], xe = G[fe - 7 * 2 + 1], ze = G[fe - 16 * 2], nt = G[fe - 16 * 2 + 1], Qt = te + xe | 0, Et = I + Ke + V(Qt, te) | 0;
      Qt = Qt + Pe | 0, Et = Et + ge + V(Qt, Pe) | 0, Qt = Qt + nt | 0, Et = Et + ze + V(Qt, nt) | 0, G[fe] = Et, G[fe + 1] = Qt;
    }
    for (var zt = 0; zt < 160; zt += 2) {
      Et = G[zt], Qt = G[zt + 1];
      var Nt = v(k, F, X), pt = v(oe, ne, H), at = S(k, oe), kt = S(oe, k), Ut = $(ue, w), dn = $(w, ue), En = u[zt], Ht = u[zt + 1], Xt = m(ue, Q, Y), On = m(w, P, J), sn = se + dn | 0, At = pe + Ut + V(sn, se) | 0;
      sn = sn + On | 0, At = At + Xt + V(sn, On) | 0, sn = sn + Ht | 0, At = At + En + V(sn, Ht) | 0, sn = sn + Qt | 0, At = At + Et + V(sn, Qt) | 0;
      var hn = kt + pt | 0, $t = at + Nt + V(hn, kt) | 0;
      pe = Y, se = J, Y = Q, J = P, Q = ue, P = w, w = C + sn | 0, ue = ee + At + V(w, C) | 0, ee = X, C = H, X = F, H = ne, F = k, ne = oe, oe = sn + hn | 0, k = At + $t + V(oe, sn) | 0;
    }
    this._al = this._al + oe | 0, this._bl = this._bl + ne | 0, this._cl = this._cl + H | 0, this._dl = this._dl + C | 0, this._el = this._el + w | 0, this._fl = this._fl + P | 0, this._gl = this._gl + J | 0, this._hl = this._hl + se | 0, this._ah = this._ah + k + V(this._al, oe) | 0, this._bh = this._bh + F + V(this._bl, ne) | 0, this._ch = this._ch + X + V(this._cl, H) | 0, this._dh = this._dh + ee + V(this._dl, C) | 0, this._eh = this._eh + ue + V(this._el, w) | 0, this._fh = this._fh + Q + V(this._fl, P) | 0, this._gh = this._gh + Y + V(this._gl, J) | 0, this._hh = this._hh + pe + V(this._hl, se) | 0;
  }, d.prototype._hash = function() {
    var M = o.allocUnsafe(64);
    function G(k, F, X) {
      M.writeInt32BE(k, X), M.writeInt32BE(F, X + 4);
    }
    return G(this._ah, this._al, 0), G(this._bh, this._bl, 8), G(this._ch, this._cl, 16), G(this._dh, this._dl, 24), G(this._eh, this._el, 32), G(this._fh, this._fl, 40), G(this._gh, this._gl, 48), G(this._hh, this._hl, 56), M;
  }, sha512$9 = d, sha512$9;
}
var sha384$1, hasRequiredSha384;
function requireSha384() {
  if (hasRequiredSha384)
    return sha384$1;
  hasRequiredSha384 = 1;
  var e = requireInherits_browser(), n = requireSha512(), o = requireHash(), u = requireSafeBuffer().Buffer, c = new Array(160);
  function d() {
    this.init(), this._w = c, o.call(this, 128, 112);
  }
  return e(d, n), d.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, d.prototype._hash = function() {
    var m = u.allocUnsafe(48);
    function v(S, $, E) {
      m.writeInt32BE(S, E), m.writeInt32BE($, E + 4);
    }
    return v(this._ah, this._al, 0), v(this._bh, this._bl, 8), v(this._ch, this._cl, 16), v(this._dh, this._dl, 24), v(this._eh, this._el, 32), v(this._fh, this._fl, 40), m;
  }, sha384$1 = d, sha384$1;
}
var hasRequiredSha_js;
function requireSha_js() {
  if (hasRequiredSha_js)
    return sha_js.exports;
  hasRequiredSha_js = 1;
  var e = sha_js.exports = function(o) {
    o = o.toLowerCase();
    var u = e[o];
    if (!u)
      throw new Error(o + " is not supported (we accept pull requests)");
    return new u();
  };
  return e.sha = requireSha(), e.sha1 = requireSha1(), e.sha224 = requireSha224(), e.sha256 = requireSha256(), e.sha384 = requireSha384(), e.sha512 = requireSha512(), sha_js.exports;
}
var streamBrowserify, hasRequiredStreamBrowserify;
function requireStreamBrowserify() {
  if (hasRequiredStreamBrowserify)
    return streamBrowserify;
  hasRequiredStreamBrowserify = 1, streamBrowserify = o;
  var e = eventsExports.EventEmitter, n = requireInherits_browser();
  n(o, e), o.Readable = require_stream_readable(), o.Writable = require_stream_writable(), o.Duplex = require_stream_duplex(), o.Transform = require_stream_transform(), o.PassThrough = require_stream_passthrough(), o.finished = requireEndOfStream(), o.pipeline = requirePipeline(), o.Stream = o;
  function o() {
    e.call(this);
  }
  return o.prototype.pipe = function(u, c) {
    var d = this;
    function m(y) {
      u.writable && u.write(y) === !1 && d.pause && d.pause();
    }
    d.on("data", m);
    function v() {
      d.readable && d.resume && d.resume();
    }
    u.on("drain", v), !u._isStdio && (!c || c.end !== !1) && (d.on("end", $), d.on("close", E));
    var S = !1;
    function $() {
      S || (S = !0, u.end());
    }
    function E() {
      S || (S = !0, typeof u.destroy == "function" && u.destroy());
    }
    function O(y) {
      if (T(), e.listenerCount(this, "error") === 0)
        throw y;
    }
    d.on("error", O), u.on("error", O);
    function T() {
      d.removeListener("data", m), u.removeListener("drain", v), d.removeListener("end", $), d.removeListener("close", E), d.removeListener("error", O), u.removeListener("error", O), d.removeListener("end", T), d.removeListener("close", T), u.removeListener("close", T);
    }
    return d.on("end", T), d.on("close", T), u.on("close", T), u.emit("pipe", d), u;
  }, streamBrowserify;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase)
    return cipherBase;
  hasRequiredCipherBase = 1;
  var e = requireSafeBuffer().Buffer, n = requireStreamBrowserify().Transform, o = requireString_decoder().StringDecoder, u = requireInherits_browser();
  function c(d) {
    n.call(this), this.hashMode = typeof d == "string", this.hashMode ? this[d] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  return u(c, n), c.prototype.update = function(d, m, v) {
    typeof d == "string" && (d = e.from(d, m));
    var S = this._update(d);
    return this.hashMode ? this : (v && (S = this._toString(S, v)), S);
  }, c.prototype.setAutoPadding = function() {
  }, c.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, c.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, c.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, c.prototype._transform = function(d, m, v) {
    var S;
    try {
      this.hashMode ? this._update(d) : this.push(this._update(d));
    } catch ($) {
      S = $;
    } finally {
      v(S);
    }
  }, c.prototype._flush = function(d) {
    var m;
    try {
      this.push(this.__final());
    } catch (v) {
      m = v;
    }
    d(m);
  }, c.prototype._finalOrDigest = function(d) {
    var m = this.__final() || e.alloc(0);
    return d && (m = this._toString(m, d, !0)), m;
  }, c.prototype._toString = function(d, m, v) {
    if (this._decoder || (this._decoder = new o(m), this._encoding = m), this._encoding !== m)
      throw new Error("can't switch encodings");
    var S = this._decoder.write(d);
    return v && (S += this._decoder.end()), S;
  }, cipherBase = c, cipherBase;
}
var browser$b, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9)
    return browser$b;
  hasRequiredBrowser$9 = 1;
  var e = requireInherits_browser(), n = requireMd5_js(), o = requireRipemd160(), u = requireSha_js(), c = requireCipherBase();
  function d(m) {
    c.call(this, "digest"), this._hash = m;
  }
  return e(d, c), d.prototype._update = function(m) {
    this._hash.update(m);
  }, d.prototype._final = function() {
    return this._hash.digest();
  }, browser$b = function(v) {
    return v = v.toLowerCase(), v === "md5" ? new n() : v === "rmd160" || v === "ripemd160" ? new o() : new d(u(v));
  }, browser$b;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy)
    return legacy;
  hasRequiredLegacy = 1;
  var e = requireInherits_browser(), n = requireSafeBuffer().Buffer, o = requireCipherBase(), u = n.alloc(128), c = 64;
  function d(m, v) {
    o.call(this, "digest"), typeof v == "string" && (v = n.from(v)), this._alg = m, this._key = v, v.length > c ? v = m(v) : v.length < c && (v = n.concat([v, u], c));
    for (var S = this._ipad = n.allocUnsafe(c), $ = this._opad = n.allocUnsafe(c), E = 0; E < c; E++)
      S[E] = v[E] ^ 54, $[E] = v[E] ^ 92;
    this._hash = [S];
  }
  return e(d, o), d.prototype._update = function(m) {
    this._hash.push(m);
  }, d.prototype._final = function() {
    var m = this._alg(n.concat(this._hash));
    return this._alg(n.concat([this._opad, m]));
  }, legacy = d, legacy;
}
var md5, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5)
    return md5;
  hasRequiredMd5 = 1;
  var e = requireMd5_js();
  return md5 = function(n) {
    return new e().update(n).digest();
  }, md5;
}
var browser$a, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8)
    return browser$a;
  hasRequiredBrowser$8 = 1;
  var e = requireInherits_browser(), n = requireLegacy(), o = requireCipherBase(), u = requireSafeBuffer().Buffer, c = requireMd5(), d = requireRipemd160(), m = requireSha_js(), v = u.alloc(128);
  function S($, E) {
    o.call(this, "digest"), typeof E == "string" && (E = u.from(E));
    var O = $ === "sha512" || $ === "sha384" ? 128 : 64;
    if (this._alg = $, this._key = E, E.length > O) {
      var T = $ === "rmd160" ? new d() : m($);
      E = T.update(E).digest();
    } else
      E.length < O && (E = u.concat([E, v], O));
    for (var y = this._ipad = u.allocUnsafe(O), V = this._opad = u.allocUnsafe(O), M = 0; M < O; M++)
      y[M] = E[M] ^ 54, V[M] = E[M] ^ 92;
    this._hash = $ === "rmd160" ? new d() : m($), this._hash.update(y);
  }
  return e(S, o), S.prototype._update = function($) {
    this._hash.update($);
  }, S.prototype._final = function() {
    var $ = this._hash.digest(), E = this._alg === "rmd160" ? new d() : m(this._alg);
    return E.update(this._opad).update($).digest();
  }, browser$a = function(E, O) {
    return E = E.toLowerCase(), E === "rmd160" || E === "ripemd160" ? new S("rmd160", O) : E === "md5" ? new n(c, O) : new S(E, O);
  }, browser$a;
}
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256$9 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512$8 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: sha256$9,
  sha224,
  sha384,
  sha512: sha512$8,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6), algos;
}
var browser$9 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition)
    return precondition;
  hasRequiredPrecondition = 1;
  var e = Math.pow(2, 30) - 1;
  return precondition = function(n, o) {
    if (typeof n != "number")
      throw new TypeError("Iterations not a number");
    if (n < 0)
      throw new TypeError("Bad iterations");
    if (typeof o != "number")
      throw new TypeError("Key length not a number");
    if (o < 0 || o > e || o !== o)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding)
    return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var e;
  if (commonjsGlobal.process && commonjsGlobal.process.browser)
    e = "utf-8";
  else if (commonjsGlobal.process && commonjsGlobal.process.version) {
    var n = parseInt(browser$1$1.version.split(".")[0].slice(1), 10);
    e = n >= 6 ? "utf-8" : "binary";
  } else
    e = "utf-8";
  return defaultEncoding_1 = e, defaultEncoding_1;
}
var toBuffer, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer)
    return toBuffer;
  hasRequiredToBuffer = 1;
  var e = requireSafeBuffer().Buffer;
  return toBuffer = function(n, o, u) {
    if (e.isBuffer(n))
      return n;
    if (typeof n == "string")
      return e.from(n, o);
    if (ArrayBuffer.isView(n))
      return e.from(n.buffer);
    throw new TypeError(u + " must be a string, a Buffer, a typed array or a DataView");
  }, toBuffer;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser)
    return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var e = requireMd5(), n = requireRipemd160(), o = requireSha_js(), u = requireSafeBuffer().Buffer, c = requirePrecondition(), d = requireDefaultEncoding(), m = requireToBuffer(), v = u.alloc(128), S = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function $(T, y, V) {
    var M = E(T), G = T === "sha512" || T === "sha384" ? 128 : 64;
    y.length > G ? y = M(y) : y.length < G && (y = u.concat([y, v], G));
    for (var k = u.allocUnsafe(G + S[T]), F = u.allocUnsafe(G + S[T]), X = 0; X < G; X++)
      k[X] = y[X] ^ 54, F[X] = y[X] ^ 92;
    var ee = u.allocUnsafe(G + V + 4);
    k.copy(ee, 0, 0, G), this.ipad1 = ee, this.ipad2 = k, this.opad = F, this.alg = T, this.blocksize = G, this.hash = M, this.size = S[T];
  }
  $.prototype.run = function(T, y) {
    T.copy(y, this.blocksize);
    var V = this.hash(y);
    return V.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function E(T) {
    function y(M) {
      return o(T).update(M).digest();
    }
    function V(M) {
      return new n().update(M).digest();
    }
    return T === "rmd160" || T === "ripemd160" ? V : T === "md5" ? e : y;
  }
  function O(T, y, V, M, G) {
    c(V, M), T = m(T, d, "Password"), y = m(y, d, "Salt"), G = G || "sha1";
    var k = new $(G, T, y.length), F = u.allocUnsafe(M), X = u.allocUnsafe(y.length + 4);
    y.copy(X, 0, 0, y.length);
    for (var ee = 0, ue = S[G], Q = Math.ceil(M / ue), Y = 1; Y <= Q; Y++) {
      X.writeUInt32BE(Y, y.length);
      for (var pe = k.run(X, k.ipad1), oe = pe, ne = 1; ne < V; ne++) {
        oe = k.run(oe, k.ipad2);
        for (var H = 0; H < ue; H++)
          pe[H] ^= oe[H];
      }
      pe.copy(F, ee), ee += ue;
    }
    return F;
  }
  return syncBrowser = O, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync)
    return async;
  hasRequiredAsync = 1;
  var e = requireSafeBuffer().Buffer, n = requirePrecondition(), o = requireDefaultEncoding(), u = requireSyncBrowser(), c = requireToBuffer(), d, m = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, v = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, S = [];
  function $(V) {
    if (commonjsGlobal.process && !commonjsGlobal.process.browser || !m || !m.importKey || !m.deriveBits)
      return Promise.resolve(!1);
    if (S[V] !== void 0)
      return S[V];
    d = d || e.alloc(8);
    var M = T(d, d, 10, 128, V).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return S[V] = M, M;
  }
  var E;
  function O() {
    return E || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? E = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? E = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? E = commonjsGlobal.setImmediate : E = commonjsGlobal.setTimeout, E);
  }
  function T(V, M, G, k, F) {
    return m.importKey(
      "raw",
      V,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(X) {
      return m.deriveBits({
        name: "PBKDF2",
        salt: M,
        iterations: G,
        hash: {
          name: F
        }
      }, X, k << 3);
    }).then(function(X) {
      return e.from(X);
    });
  }
  function y(V, M) {
    V.then(function(G) {
      O()(function() {
        M(null, G);
      });
    }, function(G) {
      O()(function() {
        M(G);
      });
    });
  }
  return async = function(V, M, G, k, F, X) {
    typeof F == "function" && (X = F, F = void 0), F = F || "sha1";
    var ee = v[F.toLowerCase()];
    if (!ee || typeof commonjsGlobal.Promise != "function") {
      O()(function() {
        var ue;
        try {
          ue = u(V, M, G, k, F);
        } catch (Q) {
          return X(Q);
        }
        X(null, ue);
      });
      return;
    }
    if (n(G, k), V = c(V, o, "Password"), M = c(M, o, "Salt"), typeof X != "function")
      throw new Error("No callback provided to pbkdf2");
    y($(ee).then(function(ue) {
      return ue ? T(V, M, G, k, ee) : u(V, M, G, k, F);
    }), X);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$9.pbkdf2 = requireAsync(), browser$9.pbkdf2Sync = requireSyncBrowser()), browser$9;
}
var browser$8 = {}, des$1 = {}, utils$Y = {}, hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils)
    return utils$Y;
  hasRequiredUtils = 1, utils$Y.readUInt32BE = function(c, d) {
    var m = c[0 + d] << 24 | c[1 + d] << 16 | c[2 + d] << 8 | c[3 + d];
    return m >>> 0;
  }, utils$Y.writeUInt32BE = function(c, d, m) {
    c[0 + m] = d >>> 24, c[1 + m] = d >>> 16 & 255, c[2 + m] = d >>> 8 & 255, c[3 + m] = d & 255;
  }, utils$Y.ip = function(c, d, m, v) {
    for (var S = 0, $ = 0, E = 6; E >= 0; E -= 2) {
      for (var O = 0; O <= 24; O += 8)
        S <<= 1, S |= d >>> O + E & 1;
      for (var O = 0; O <= 24; O += 8)
        S <<= 1, S |= c >>> O + E & 1;
    }
    for (var E = 6; E >= 0; E -= 2) {
      for (var O = 1; O <= 25; O += 8)
        $ <<= 1, $ |= d >>> O + E & 1;
      for (var O = 1; O <= 25; O += 8)
        $ <<= 1, $ |= c >>> O + E & 1;
    }
    m[v + 0] = S >>> 0, m[v + 1] = $ >>> 0;
  }, utils$Y.rip = function(c, d, m, v) {
    for (var S = 0, $ = 0, E = 0; E < 4; E++)
      for (var O = 24; O >= 0; O -= 8)
        S <<= 1, S |= d >>> O + E & 1, S <<= 1, S |= c >>> O + E & 1;
    for (var E = 4; E < 8; E++)
      for (var O = 24; O >= 0; O -= 8)
        $ <<= 1, $ |= d >>> O + E & 1, $ <<= 1, $ |= c >>> O + E & 1;
    m[v + 0] = S >>> 0, m[v + 1] = $ >>> 0;
  }, utils$Y.pc1 = function(c, d, m, v) {
    for (var S = 0, $ = 0, E = 7; E >= 5; E--) {
      for (var O = 0; O <= 24; O += 8)
        S <<= 1, S |= d >> O + E & 1;
      for (var O = 0; O <= 24; O += 8)
        S <<= 1, S |= c >> O + E & 1;
    }
    for (var O = 0; O <= 24; O += 8)
      S <<= 1, S |= d >> O + E & 1;
    for (var E = 1; E <= 3; E++) {
      for (var O = 0; O <= 24; O += 8)
        $ <<= 1, $ |= d >> O + E & 1;
      for (var O = 0; O <= 24; O += 8)
        $ <<= 1, $ |= c >> O + E & 1;
    }
    for (var O = 0; O <= 24; O += 8)
      $ <<= 1, $ |= c >> O + E & 1;
    m[v + 0] = S >>> 0, m[v + 1] = $ >>> 0;
  }, utils$Y.r28shl = function(c, d) {
    return c << d & 268435455 | c >>> 28 - d;
  };
  var e = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$Y.pc2 = function(c, d, m, v) {
    for (var S = 0, $ = 0, E = e.length >>> 1, O = 0; O < E; O++)
      S <<= 1, S |= c >>> e[O] & 1;
    for (var O = E; O < e.length; O++)
      $ <<= 1, $ |= d >>> e[O] & 1;
    m[v + 0] = S >>> 0, m[v + 1] = $ >>> 0;
  }, utils$Y.expand = function(c, d, m) {
    var v = 0, S = 0;
    v = (c & 1) << 5 | c >>> 27;
    for (var $ = 23; $ >= 15; $ -= 4)
      v <<= 6, v |= c >>> $ & 63;
    for (var $ = 11; $ >= 3; $ -= 4)
      S |= c >>> $ & 63, S <<= 6;
    S |= (c & 31) << 1 | c >>> 31, d[m + 0] = v >>> 0, d[m + 1] = S >>> 0;
  };
  var n = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$Y.substitute = function(c, d) {
    for (var m = 0, v = 0; v < 4; v++) {
      var S = c >>> 18 - v * 6 & 63, $ = n[v * 64 + S];
      m <<= 4, m |= $;
    }
    for (var v = 0; v < 4; v++) {
      var S = d >>> 18 - v * 6 & 63, $ = n[4 * 64 + v * 64 + S];
      m <<= 4, m |= $;
    }
    return m >>> 0;
  };
  var o = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$Y.permute = function(c) {
    for (var d = 0, m = 0; m < o.length; m++)
      d <<= 1, d |= c >>> o[m] & 1;
    return d >>> 0;
  }, utils$Y.padSplit = function(c, d, m) {
    for (var v = c.toString(2); v.length < d; )
      v = "0" + v;
    for (var S = [], $ = 0; $ < d; $ += m)
      S.push(v.slice($, $ + m));
    return S.join(" ");
  }, utils$Y;
}
var minimalisticAssert$1 = assert$w;
function assert$w(e, n) {
  if (!e)
    throw new Error(n || "Assertion failed");
}
assert$w.equal = function(n, o, u) {
  if (n != o)
    throw new Error(u || "Assertion failed: " + n + " != " + o);
};
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher)
    return cipher;
  hasRequiredCipher = 1;
  var e = minimalisticAssert$1;
  function n(o) {
    this.options = o, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = o.padding !== !1;
  }
  return cipher = n, n.prototype._init = function() {
  }, n.prototype.update = function(u) {
    return u.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(u) : this._updateEncrypt(u);
  }, n.prototype._buffer = function(u, c) {
    for (var d = Math.min(this.buffer.length - this.bufferOff, u.length - c), m = 0; m < d; m++)
      this.buffer[this.bufferOff + m] = u[c + m];
    return this.bufferOff += d, d;
  }, n.prototype._flushBuffer = function(u, c) {
    return this._update(this.buffer, 0, u, c), this.bufferOff = 0, this.blockSize;
  }, n.prototype._updateEncrypt = function(u) {
    var c = 0, d = 0, m = (this.bufferOff + u.length) / this.blockSize | 0, v = new Array(m * this.blockSize);
    this.bufferOff !== 0 && (c += this._buffer(u, c), this.bufferOff === this.buffer.length && (d += this._flushBuffer(v, d)));
    for (var S = u.length - (u.length - c) % this.blockSize; c < S; c += this.blockSize)
      this._update(u, c, v, d), d += this.blockSize;
    for (; c < u.length; c++, this.bufferOff++)
      this.buffer[this.bufferOff] = u[c];
    return v;
  }, n.prototype._updateDecrypt = function(u) {
    for (var c = 0, d = 0, m = Math.ceil((this.bufferOff + u.length) / this.blockSize) - 1, v = new Array(m * this.blockSize); m > 0; m--)
      c += this._buffer(u, c), d += this._flushBuffer(v, d);
    return c += this._buffer(u, c), v;
  }, n.prototype.final = function(u) {
    var c;
    u && (c = this.update(u));
    var d;
    return this.type === "encrypt" ? d = this._finalEncrypt() : d = this._finalDecrypt(), c ? c.concat(d) : d;
  }, n.prototype._pad = function(u, c) {
    if (c === 0)
      return !1;
    for (; c < u.length; )
      u[c++] = 0;
    return !0;
  }, n.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var u = new Array(this.blockSize);
    return this._update(this.buffer, 0, u, 0), u;
  }, n.prototype._unpad = function(u) {
    return u;
  }, n.prototype._finalDecrypt = function() {
    e.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var u = new Array(this.blockSize);
    return this._flushBuffer(u, 0), this._unpad(u);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1)
    return des;
  hasRequiredDes$1 = 1;
  var e = minimalisticAssert$1, n = requireInherits_browser(), o = requireUtils(), u = requireCipher();
  function c() {
    this.tmp = new Array(2), this.keys = null;
  }
  function d(v) {
    u.call(this, v);
    var S = new c();
    this._desState = S, this.deriveKeys(S, v.key);
  }
  n(d, u), des = d, d.create = function(S) {
    return new d(S);
  };
  var m = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return d.prototype.deriveKeys = function(S, $) {
    S.keys = new Array(16 * 2), e.equal($.length, this.blockSize, "Invalid key length");
    var E = o.readUInt32BE($, 0), O = o.readUInt32BE($, 4);
    o.pc1(E, O, S.tmp, 0), E = S.tmp[0], O = S.tmp[1];
    for (var T = 0; T < S.keys.length; T += 2) {
      var y = m[T >>> 1];
      E = o.r28shl(E, y), O = o.r28shl(O, y), o.pc2(E, O, S.keys, T);
    }
  }, d.prototype._update = function(S, $, E, O) {
    var T = this._desState, y = o.readUInt32BE(S, $), V = o.readUInt32BE(S, $ + 4);
    o.ip(y, V, T.tmp, 0), y = T.tmp[0], V = T.tmp[1], this.type === "encrypt" ? this._encrypt(T, y, V, T.tmp, 0) : this._decrypt(T, y, V, T.tmp, 0), y = T.tmp[0], V = T.tmp[1], o.writeUInt32BE(E, y, O), o.writeUInt32BE(E, V, O + 4);
  }, d.prototype._pad = function(S, $) {
    if (this.padding === !1)
      return !1;
    for (var E = S.length - $, O = $; O < S.length; O++)
      S[O] = E;
    return !0;
  }, d.prototype._unpad = function(S) {
    if (this.padding === !1)
      return S;
    for (var $ = S[S.length - 1], E = S.length - $; E < S.length; E++)
      e.equal(S[E], $);
    return S.slice(0, S.length - $);
  }, d.prototype._encrypt = function(S, $, E, O, T) {
    for (var y = $, V = E, M = 0; M < S.keys.length; M += 2) {
      var G = S.keys[M], k = S.keys[M + 1];
      o.expand(V, S.tmp, 0), G ^= S.tmp[0], k ^= S.tmp[1];
      var F = o.substitute(G, k), X = o.permute(F), ee = V;
      V = (y ^ X) >>> 0, y = ee;
    }
    o.rip(V, y, O, T);
  }, d.prototype._decrypt = function(S, $, E, O, T) {
    for (var y = E, V = $, M = S.keys.length - 2; M >= 0; M -= 2) {
      var G = S.keys[M], k = S.keys[M + 1];
      o.expand(y, S.tmp, 0), G ^= S.tmp[0], k ^= S.tmp[1];
      var F = o.substitute(G, k), X = o.permute(F), ee = y;
      y = (V ^ X) >>> 0, V = ee;
    }
    o.rip(y, V, O, T);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1)
    return cbc$1;
  hasRequiredCbc$1 = 1;
  var e = minimalisticAssert$1, n = requireInherits_browser(), o = {};
  function u(d) {
    e.equal(d.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var m = 0; m < this.iv.length; m++)
      this.iv[m] = d[m];
  }
  function c(d) {
    function m(E) {
      d.call(this, E), this._cbcInit();
    }
    n(m, d);
    for (var v = Object.keys(o), S = 0; S < v.length; S++) {
      var $ = v[S];
      m.prototype[$] = o[$];
    }
    return m.create = function(O) {
      return new m(O);
    }, m;
  }
  return cbc$1.instantiate = c, o._cbcInit = function() {
    var m = new u(this.options.iv);
    this._cbcState = m;
  }, o._update = function(m, v, S, $) {
    var E = this._cbcState, O = this.constructor.super_.prototype, T = E.iv;
    if (this.type === "encrypt") {
      for (var y = 0; y < this.blockSize; y++)
        T[y] ^= m[v + y];
      O._update.call(this, T, 0, S, $);
      for (var y = 0; y < this.blockSize; y++)
        T[y] = S[$ + y];
    } else {
      O._update.call(this, m, v, S, $);
      for (var y = 0; y < this.blockSize; y++)
        S[$ + y] ^= T[y];
      for (var y = 0; y < this.blockSize; y++)
        T[y] = m[v + y];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde)
    return ede;
  hasRequiredEde = 1;
  var e = minimalisticAssert$1, n = requireInherits_browser(), o = requireCipher(), u = requireDes$1();
  function c(m, v) {
    e.equal(v.length, 24, "Invalid key length");
    var S = v.slice(0, 8), $ = v.slice(8, 16), E = v.slice(16, 24);
    m === "encrypt" ? this.ciphers = [
      u.create({ type: "encrypt", key: S }),
      u.create({ type: "decrypt", key: $ }),
      u.create({ type: "encrypt", key: E })
    ] : this.ciphers = [
      u.create({ type: "decrypt", key: E }),
      u.create({ type: "encrypt", key: $ }),
      u.create({ type: "decrypt", key: S })
    ];
  }
  function d(m) {
    o.call(this, m);
    var v = new c(this.type, this.options.key);
    this._edeState = v;
  }
  return n(d, o), ede = d, d.create = function(v) {
    return new d(v);
  }, d.prototype._update = function(v, S, $, E) {
    var O = this._edeState;
    O.ciphers[0]._update(v, S, $, E), O.ciphers[1]._update($, E, $, E), O.ciphers[2]._update($, E, $, E);
  }, d.prototype._pad = u.prototype._pad, d.prototype._unpad = u.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes)
    return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var e = requireCipherBase(), n = requireDes(), o = requireInherits_browser(), u = requireSafeBuffer().Buffer, c = {
    "des-ede3-cbc": n.CBC.instantiate(n.EDE),
    "des-ede3": n.EDE,
    "des-ede-cbc": n.CBC.instantiate(n.EDE),
    "des-ede": n.EDE,
    "des-cbc": n.CBC.instantiate(n.DES),
    "des-ecb": n.DES
  };
  c.des = c["des-cbc"], c.des3 = c["des-ede3-cbc"], browserifyDes = d, o(d, e);
  function d(m) {
    e.call(this);
    var v = m.mode.toLowerCase(), S = c[v], $;
    m.decrypt ? $ = "decrypt" : $ = "encrypt";
    var E = m.key;
    u.isBuffer(E) || (E = u.from(E)), (v === "des-ede" || v === "des-ede-cbc") && (E = u.concat([E, E.slice(0, 8)]));
    var O = m.iv;
    u.isBuffer(O) || (O = u.from(O)), this._des = S.create({
      key: E,
      iv: O,
      type: $
    });
  }
  return d.prototype._update = function(m) {
    return u.from(this._des.update(m));
  }, d.prototype._final = function() {
    return u.from(this._des.final());
  }, browserifyDes;
}
var browser$7 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(e, n) {
    return e._cipher.encryptBlock(n);
  }, ecb.decrypt = function(e, n) {
    return e._cipher.decryptBlock(n);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(n, o) {
    for (var u = Math.min(n.length, o.length), c = new Buffer(u), d = 0; d < u; ++d)
      c[d] = n[d] ^ o[d];
    return c;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc)
    return cbc;
  hasRequiredCbc = 1;
  var e = requireBufferXor();
  return cbc.encrypt = function(n, o) {
    var u = e(o, n._prev);
    return n._prev = n._cipher.encryptBlock(u), n._prev;
  }, cbc.decrypt = function(n, o) {
    var u = n._prev;
    n._prev = o;
    var c = n._cipher.decryptBlock(o);
    return e(c, u);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb)
    return cfb;
  hasRequiredCfb = 1;
  var e = requireSafeBuffer().Buffer, n = requireBufferXor();
  function o(u, c, d) {
    var m = c.length, v = n(c, u._cache);
    return u._cache = u._cache.slice(m), u._prev = e.concat([u._prev, d ? c : v]), v;
  }
  return cfb.encrypt = function(u, c, d) {
    for (var m = e.allocUnsafe(0), v; c.length; )
      if (u._cache.length === 0 && (u._cache = u._cipher.encryptBlock(u._prev), u._prev = e.allocUnsafe(0)), u._cache.length <= c.length)
        v = u._cache.length, m = e.concat([m, o(u, c.slice(0, v), d)]), c = c.slice(v);
      else {
        m = e.concat([m, o(u, c, d)]);
        break;
      }
    return m;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8)
    return cfb8;
  hasRequiredCfb8 = 1;
  var e = requireSafeBuffer().Buffer;
  function n(o, u, c) {
    var d = o._cipher.encryptBlock(o._prev), m = d[0] ^ u;
    return o._prev = e.concat([
      o._prev.slice(1),
      e.from([c ? u : m])
    ]), m;
  }
  return cfb8.encrypt = function(o, u, c) {
    for (var d = u.length, m = e.allocUnsafe(d), v = -1; ++v < d; )
      m[v] = n(o, u[v], c);
    return m;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1)
    return cfb1;
  hasRequiredCfb1 = 1;
  var e = requireSafeBuffer().Buffer;
  function n(u, c, d) {
    for (var m, v = -1, S = 8, $ = 0, E, O; ++v < S; )
      m = u._cipher.encryptBlock(u._prev), E = c & 1 << 7 - v ? 128 : 0, O = m[0] ^ E, $ += (O & 128) >> v % 8, u._prev = o(u._prev, d ? E : O);
    return $;
  }
  function o(u, c) {
    var d = u.length, m = -1, v = e.allocUnsafe(u.length);
    for (u = e.concat([u, e.from([c])]); ++m < d; )
      v[m] = u[m] << 1 | u[m + 1] >> 7;
    return v;
  }
  return cfb1.encrypt = function(u, c, d) {
    for (var m = c.length, v = e.allocUnsafe(m), S = -1; ++S < m; )
      v[S] = n(u, c[S], d);
    return v;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb)
    return ofb;
  hasRequiredOfb = 1;
  var e = requireBufferXor();
  function n(o) {
    return o._prev = o._cipher.encryptBlock(o._prev), o._prev;
  }
  return ofb.encrypt = function(o, u) {
    for (; o._cache.length < u.length; )
      o._cache = Buffer.concat([o._cache, n(o)]);
    var c = o._cache.slice(0, u.length);
    return o._cache = o._cache.slice(u.length), e(u, c);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32)
    return incr32_1;
  hasRequiredIncr32 = 1;
  function e(n) {
    for (var o = n.length, u; o--; )
      if (u = n.readUInt8(o), u === 255)
        n.writeUInt8(0, o);
      else {
        u++, n.writeUInt8(u, o);
        break;
      }
  }
  return incr32_1 = e, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr)
    return ctr;
  hasRequiredCtr = 1;
  var e = requireBufferXor(), n = requireSafeBuffer().Buffer, o = requireIncr32();
  function u(d) {
    var m = d._cipher.encryptBlockRaw(d._prev);
    return o(d._prev), m;
  }
  var c = 16;
  return ctr.encrypt = function(d, m) {
    var v = Math.ceil(m.length / c), S = d._cache.length;
    d._cache = n.concat([
      d._cache,
      n.allocUnsafe(v * c)
    ]);
    for (var $ = 0; $ < v; $++) {
      var E = u(d), O = S + $ * c;
      d._cache.writeUInt32BE(E[0], O + 0), d._cache.writeUInt32BE(E[1], O + 4), d._cache.writeUInt32BE(E[2], O + 8), d._cache.writeUInt32BE(E[3], O + 12);
    }
    var T = d._cache.slice(0, m.length);
    return d._cache = d._cache.slice(m.length), e(m, T);
  }, ctr;
}
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1)
    return modes_1;
  hasRequiredModes$1 = 1;
  var e = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, n = require$$2;
  for (var o in n)
    n[o].module = e[n[o].mode];
  return modes_1 = n, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes)
    return aes;
  hasRequiredAes = 1;
  var e = requireSafeBuffer().Buffer;
  function n(v) {
    e.isBuffer(v) || (v = e.from(v));
    for (var S = v.length / 4 | 0, $ = new Array(S), E = 0; E < S; E++)
      $[E] = v.readUInt32BE(E * 4);
    return $;
  }
  function o(v) {
    for (var S = 0; S < v.length; v++)
      v[S] = 0;
  }
  function u(v, S, $, E, O) {
    for (var T = $[0], y = $[1], V = $[2], M = $[3], G = v[0] ^ S[0], k = v[1] ^ S[1], F = v[2] ^ S[2], X = v[3] ^ S[3], ee, ue, Q, Y, pe = 4, oe = 1; oe < O; oe++)
      ee = T[G >>> 24] ^ y[k >>> 16 & 255] ^ V[F >>> 8 & 255] ^ M[X & 255] ^ S[pe++], ue = T[k >>> 24] ^ y[F >>> 16 & 255] ^ V[X >>> 8 & 255] ^ M[G & 255] ^ S[pe++], Q = T[F >>> 24] ^ y[X >>> 16 & 255] ^ V[G >>> 8 & 255] ^ M[k & 255] ^ S[pe++], Y = T[X >>> 24] ^ y[G >>> 16 & 255] ^ V[k >>> 8 & 255] ^ M[F & 255] ^ S[pe++], G = ee, k = ue, F = Q, X = Y;
    return ee = (E[G >>> 24] << 24 | E[k >>> 16 & 255] << 16 | E[F >>> 8 & 255] << 8 | E[X & 255]) ^ S[pe++], ue = (E[k >>> 24] << 24 | E[F >>> 16 & 255] << 16 | E[X >>> 8 & 255] << 8 | E[G & 255]) ^ S[pe++], Q = (E[F >>> 24] << 24 | E[X >>> 16 & 255] << 16 | E[G >>> 8 & 255] << 8 | E[k & 255]) ^ S[pe++], Y = (E[X >>> 24] << 24 | E[G >>> 16 & 255] << 16 | E[k >>> 8 & 255] << 8 | E[F & 255]) ^ S[pe++], ee = ee >>> 0, ue = ue >>> 0, Q = Q >>> 0, Y = Y >>> 0, [ee, ue, Q, Y];
  }
  var c = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], d = function() {
    for (var v = new Array(256), S = 0; S < 256; S++)
      S < 128 ? v[S] = S << 1 : v[S] = S << 1 ^ 283;
    for (var $ = [], E = [], O = [[], [], [], []], T = [[], [], [], []], y = 0, V = 0, M = 0; M < 256; ++M) {
      var G = V ^ V << 1 ^ V << 2 ^ V << 3 ^ V << 4;
      G = G >>> 8 ^ G & 255 ^ 99, $[y] = G, E[G] = y;
      var k = v[y], F = v[k], X = v[F], ee = v[G] * 257 ^ G * 16843008;
      O[0][y] = ee << 24 | ee >>> 8, O[1][y] = ee << 16 | ee >>> 16, O[2][y] = ee << 8 | ee >>> 24, O[3][y] = ee, ee = X * 16843009 ^ F * 65537 ^ k * 257 ^ y * 16843008, T[0][G] = ee << 24 | ee >>> 8, T[1][G] = ee << 16 | ee >>> 16, T[2][G] = ee << 8 | ee >>> 24, T[3][G] = ee, y === 0 ? y = V = 1 : (y = k ^ v[v[v[X ^ k]]], V ^= v[v[V]]);
    }
    return {
      SBOX: $,
      INV_SBOX: E,
      SUB_MIX: O,
      INV_SUB_MIX: T
    };
  }();
  function m(v) {
    this._key = n(v), this._reset();
  }
  return m.blockSize = 4 * 4, m.keySize = 256 / 8, m.prototype.blockSize = m.blockSize, m.prototype.keySize = m.keySize, m.prototype._reset = function() {
    for (var v = this._key, S = v.length, $ = S + 6, E = ($ + 1) * 4, O = [], T = 0; T < S; T++)
      O[T] = v[T];
    for (T = S; T < E; T++) {
      var y = O[T - 1];
      T % S === 0 ? (y = y << 8 | y >>> 24, y = d.SBOX[y >>> 24] << 24 | d.SBOX[y >>> 16 & 255] << 16 | d.SBOX[y >>> 8 & 255] << 8 | d.SBOX[y & 255], y ^= c[T / S | 0] << 24) : S > 6 && T % S === 4 && (y = d.SBOX[y >>> 24] << 24 | d.SBOX[y >>> 16 & 255] << 16 | d.SBOX[y >>> 8 & 255] << 8 | d.SBOX[y & 255]), O[T] = O[T - S] ^ y;
    }
    for (var V = [], M = 0; M < E; M++) {
      var G = E - M, k = O[G - (M % 4 ? 0 : 4)];
      M < 4 || G <= 4 ? V[M] = k : V[M] = d.INV_SUB_MIX[0][d.SBOX[k >>> 24]] ^ d.INV_SUB_MIX[1][d.SBOX[k >>> 16 & 255]] ^ d.INV_SUB_MIX[2][d.SBOX[k >>> 8 & 255]] ^ d.INV_SUB_MIX[3][d.SBOX[k & 255]];
    }
    this._nRounds = $, this._keySchedule = O, this._invKeySchedule = V;
  }, m.prototype.encryptBlockRaw = function(v) {
    return v = n(v), u(v, this._keySchedule, d.SUB_MIX, d.SBOX, this._nRounds);
  }, m.prototype.encryptBlock = function(v) {
    var S = this.encryptBlockRaw(v), $ = e.allocUnsafe(16);
    return $.writeUInt32BE(S[0], 0), $.writeUInt32BE(S[1], 4), $.writeUInt32BE(S[2], 8), $.writeUInt32BE(S[3], 12), $;
  }, m.prototype.decryptBlock = function(v) {
    v = n(v);
    var S = v[1];
    v[1] = v[3], v[3] = S;
    var $ = u(v, this._invKeySchedule, d.INV_SUB_MIX, d.INV_SBOX, this._nRounds), E = e.allocUnsafe(16);
    return E.writeUInt32BE($[0], 0), E.writeUInt32BE($[3], 4), E.writeUInt32BE($[2], 8), E.writeUInt32BE($[1], 12), E;
  }, m.prototype.scrub = function() {
    o(this._keySchedule), o(this._invKeySchedule), o(this._key);
  }, aes.AES = m, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash)
    return ghash;
  hasRequiredGhash = 1;
  var e = requireSafeBuffer().Buffer, n = e.alloc(16, 0);
  function o(d) {
    return [
      d.readUInt32BE(0),
      d.readUInt32BE(4),
      d.readUInt32BE(8),
      d.readUInt32BE(12)
    ];
  }
  function u(d) {
    var m = e.allocUnsafe(16);
    return m.writeUInt32BE(d[0] >>> 0, 0), m.writeUInt32BE(d[1] >>> 0, 4), m.writeUInt32BE(d[2] >>> 0, 8), m.writeUInt32BE(d[3] >>> 0, 12), m;
  }
  function c(d) {
    this.h = d, this.state = e.alloc(16, 0), this.cache = e.allocUnsafe(0);
  }
  return c.prototype.ghash = function(d) {
    for (var m = -1; ++m < d.length; )
      this.state[m] ^= d[m];
    this._multiply();
  }, c.prototype._multiply = function() {
    for (var d = o(this.h), m = [0, 0, 0, 0], v, S, $, E = -1; ++E < 128; ) {
      for (S = (this.state[~~(E / 8)] & 1 << 7 - E % 8) !== 0, S && (m[0] ^= d[0], m[1] ^= d[1], m[2] ^= d[2], m[3] ^= d[3]), $ = (d[3] & 1) !== 0, v = 3; v > 0; v--)
        d[v] = d[v] >>> 1 | (d[v - 1] & 1) << 31;
      d[0] = d[0] >>> 1, $ && (d[0] = d[0] ^ 225 << 24);
    }
    this.state = u(m);
  }, c.prototype.update = function(d) {
    this.cache = e.concat([this.cache, d]);
    for (var m; this.cache.length >= 16; )
      m = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(m);
  }, c.prototype.final = function(d, m) {
    return this.cache.length && this.ghash(e.concat([this.cache, n], 16)), this.ghash(u([0, d, 0, m])), this.state;
  }, ghash = c, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher)
    return authCipher;
  hasRequiredAuthCipher = 1;
  var e = requireAes(), n = requireSafeBuffer().Buffer, o = requireCipherBase(), u = requireInherits_browser(), c = requireGhash(), d = requireBufferXor(), m = requireIncr32();
  function v(E, O) {
    var T = 0;
    E.length !== O.length && T++;
    for (var y = Math.min(E.length, O.length), V = 0; V < y; ++V)
      T += E[V] ^ O[V];
    return T;
  }
  function S(E, O, T) {
    if (O.length === 12)
      return E._finID = n.concat([O, n.from([0, 0, 0, 1])]), n.concat([O, n.from([0, 0, 0, 2])]);
    var y = new c(T), V = O.length, M = V % 16;
    y.update(O), M && (M = 16 - M, y.update(n.alloc(M, 0))), y.update(n.alloc(8, 0));
    var G = V * 8, k = n.alloc(8);
    k.writeUIntBE(G, 0, 8), y.update(k), E._finID = y.state;
    var F = n.from(E._finID);
    return m(F), F;
  }
  function $(E, O, T, y) {
    o.call(this);
    var V = n.alloc(4, 0);
    this._cipher = new e.AES(O);
    var M = this._cipher.encryptBlock(V);
    this._ghash = new c(M), T = S(this, T, M), this._prev = n.from(T), this._cache = n.allocUnsafe(0), this._secCache = n.allocUnsafe(0), this._decrypt = y, this._alen = 0, this._len = 0, this._mode = E, this._authTag = null, this._called = !1;
  }
  return u($, o), $.prototype._update = function(E) {
    if (!this._called && this._alen) {
      var O = 16 - this._alen % 16;
      O < 16 && (O = n.alloc(O, 0), this._ghash.update(O));
    }
    this._called = !0;
    var T = this._mode.encrypt(this, E);
    return this._decrypt ? this._ghash.update(E) : this._ghash.update(T), this._len += E.length, T;
  }, $.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var E = d(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && v(E, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = E, this._cipher.scrub();
  }, $.prototype.getAuthTag = function() {
    if (this._decrypt || !n.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, $.prototype.setAuthTag = function(O) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = O;
  }, $.prototype.setAAD = function(O) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(O), this._alen += O.length;
  }, authCipher = $, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher)
    return streamCipher;
  hasRequiredStreamCipher = 1;
  var e = requireAes(), n = requireSafeBuffer().Buffer, o = requireCipherBase(), u = requireInherits_browser();
  function c(d, m, v, S) {
    o.call(this), this._cipher = new e.AES(m), this._prev = n.from(v), this._cache = n.allocUnsafe(0), this._secCache = n.allocUnsafe(0), this._decrypt = S, this._mode = d;
  }
  return u(c, o), c.prototype._update = function(d) {
    return this._mode.encrypt(this, d, this._decrypt);
  }, c.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = c, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey)
    return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var e = requireSafeBuffer().Buffer, n = requireMd5_js();
  function o(u, c, d, m) {
    if (e.isBuffer(u) || (u = e.from(u, "binary")), c && (e.isBuffer(c) || (c = e.from(c, "binary")), c.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var v = d / 8, S = e.alloc(v), $ = e.alloc(m || 0), E = e.alloc(0); v > 0 || m > 0; ) {
      var O = new n();
      O.update(E), O.update(u), c && O.update(c), E = O.digest();
      var T = 0;
      if (v > 0) {
        var y = S.length - v;
        T = Math.min(v, E.length), E.copy(S, y, 0, T), v -= T;
      }
      if (T < E.length && m > 0) {
        var V = $.length - m, M = Math.min(m, E.length - T);
        E.copy($, V, T, T + M), m -= M;
      }
    }
    return E.fill(0), { key: S, iv: $ };
  }
  return evp_bytestokey = o, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter)
    return encrypter;
  hasRequiredEncrypter = 1;
  var e = requireModes$1(), n = requireAuthCipher(), o = requireSafeBuffer().Buffer, u = requireStreamCipher(), c = requireCipherBase(), d = requireAes(), m = requireEvp_bytestokey(), v = requireInherits_browser();
  function S(y, V, M) {
    c.call(this), this._cache = new E(), this._cipher = new d.AES(V), this._prev = o.from(M), this._mode = y, this._autopadding = !0;
  }
  v(S, c), S.prototype._update = function(y) {
    this._cache.add(y);
    for (var V, M, G = []; V = this._cache.get(); )
      M = this._mode.encrypt(this, V), G.push(M);
    return o.concat(G);
  };
  var $ = o.alloc(16, 16);
  S.prototype._final = function() {
    var y = this._cache.flush();
    if (this._autopadding)
      return y = this._mode.encrypt(this, y), this._cipher.scrub(), y;
    if (!y.equals($))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, S.prototype.setAutoPadding = function(y) {
    return this._autopadding = !!y, this;
  };
  function E() {
    this.cache = o.allocUnsafe(0);
  }
  E.prototype.add = function(y) {
    this.cache = o.concat([this.cache, y]);
  }, E.prototype.get = function() {
    if (this.cache.length > 15) {
      var y = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), y;
    }
    return null;
  }, E.prototype.flush = function() {
    for (var y = 16 - this.cache.length, V = o.allocUnsafe(y), M = -1; ++M < y; )
      V.writeUInt8(y, M);
    return o.concat([this.cache, V]);
  };
  function O(y, V, M) {
    var G = e[y.toLowerCase()];
    if (!G)
      throw new TypeError("invalid suite type");
    if (typeof V == "string" && (V = o.from(V)), V.length !== G.key / 8)
      throw new TypeError("invalid key length " + V.length);
    if (typeof M == "string" && (M = o.from(M)), G.mode !== "GCM" && M.length !== G.iv)
      throw new TypeError("invalid iv length " + M.length);
    return G.type === "stream" ? new u(G.module, V, M) : G.type === "auth" ? new n(G.module, V, M) : new S(G.module, V, M);
  }
  function T(y, V) {
    var M = e[y.toLowerCase()];
    if (!M)
      throw new TypeError("invalid suite type");
    var G = m(V, !1, M.key, M.iv);
    return O(y, G.key, G.iv);
  }
  return encrypter.createCipheriv = O, encrypter.createCipher = T, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter)
    return decrypter;
  hasRequiredDecrypter = 1;
  var e = requireAuthCipher(), n = requireSafeBuffer().Buffer, o = requireModes$1(), u = requireStreamCipher(), c = requireCipherBase(), d = requireAes(), m = requireEvp_bytestokey(), v = requireInherits_browser();
  function S(y, V, M) {
    c.call(this), this._cache = new $(), this._last = void 0, this._cipher = new d.AES(V), this._prev = n.from(M), this._mode = y, this._autopadding = !0;
  }
  v(S, c), S.prototype._update = function(y) {
    this._cache.add(y);
    for (var V, M, G = []; V = this._cache.get(this._autopadding); )
      M = this._mode.decrypt(this, V), G.push(M);
    return n.concat(G);
  }, S.prototype._final = function() {
    var y = this._cache.flush();
    if (this._autopadding)
      return E(this._mode.decrypt(this, y));
    if (y)
      throw new Error("data not multiple of block length");
  }, S.prototype.setAutoPadding = function(y) {
    return this._autopadding = !!y, this;
  };
  function $() {
    this.cache = n.allocUnsafe(0);
  }
  $.prototype.add = function(y) {
    this.cache = n.concat([this.cache, y]);
  }, $.prototype.get = function(y) {
    var V;
    if (y) {
      if (this.cache.length > 16)
        return V = this.cache.slice(0, 16), this.cache = this.cache.slice(16), V;
    } else if (this.cache.length >= 16)
      return V = this.cache.slice(0, 16), this.cache = this.cache.slice(16), V;
    return null;
  }, $.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function E(y) {
    var V = y[15];
    if (V < 1 || V > 16)
      throw new Error("unable to decrypt data");
    for (var M = -1; ++M < V; )
      if (y[M + (16 - V)] !== V)
        throw new Error("unable to decrypt data");
    if (V !== 16)
      return y.slice(0, 16 - V);
  }
  function O(y, V, M) {
    var G = o[y.toLowerCase()];
    if (!G)
      throw new TypeError("invalid suite type");
    if (typeof M == "string" && (M = n.from(M)), G.mode !== "GCM" && M.length !== G.iv)
      throw new TypeError("invalid iv length " + M.length);
    if (typeof V == "string" && (V = n.from(V)), V.length !== G.key / 8)
      throw new TypeError("invalid key length " + V.length);
    return G.type === "stream" ? new u(G.module, V, M, !0) : G.type === "auth" ? new e(G.module, V, M, !0) : new S(G.module, V, M);
  }
  function T(y, V) {
    var M = o[y.toLowerCase()];
    if (!M)
      throw new TypeError("invalid suite type");
    var G = m(V, !1, M.key, M.iv);
    return O(y, G.key, G.iv);
  }
  return decrypter.createDecipher = T, decrypter.createDecipheriv = O, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6)
    return browser$7;
  hasRequiredBrowser$6 = 1;
  var e = requireEncrypter(), n = requireDecrypter(), o = require$$2;
  function u() {
    return Object.keys(o);
  }
  return browser$7.createCipher = browser$7.Cipher = e.createCipher, browser$7.createCipheriv = browser$7.Cipheriv = e.createCipheriv, browser$7.createDecipher = browser$7.Decipher = n.createDecipher, browser$7.createDecipheriv = browser$7.Decipheriv = n.createDecipheriv, browser$7.listCiphers = browser$7.getCiphers = u, browser$7;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(e) {
    e["des-ecb"] = {
      key: 8,
      iv: 0
    }, e["des-cbc"] = e.des = {
      key: 8,
      iv: 8
    }, e["des-ede3-cbc"] = e.des3 = {
      key: 24,
      iv: 8
    }, e["des-ede3"] = {
      key: 24,
      iv: 0
    }, e["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, e["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5)
    return browser$8;
  hasRequiredBrowser$5 = 1;
  var e = requireBrowserifyDes(), n = requireBrowser$6(), o = requireModes$1(), u = requireModes(), c = requireEvp_bytestokey();
  function d(E, O) {
    E = E.toLowerCase();
    var T, y;
    if (o[E])
      T = o[E].key, y = o[E].iv;
    else if (u[E])
      T = u[E].key * 8, y = u[E].iv;
    else
      throw new TypeError("invalid suite type");
    var V = c(O, !1, T, y);
    return v(E, V.key, V.iv);
  }
  function m(E, O) {
    E = E.toLowerCase();
    var T, y;
    if (o[E])
      T = o[E].key, y = o[E].iv;
    else if (u[E])
      T = u[E].key * 8, y = u[E].iv;
    else
      throw new TypeError("invalid suite type");
    var V = c(O, !1, T, y);
    return S(E, V.key, V.iv);
  }
  function v(E, O, T) {
    if (E = E.toLowerCase(), o[E])
      return n.createCipheriv(E, O, T);
    if (u[E])
      return new e({ key: O, iv: T, mode: E });
    throw new TypeError("invalid suite type");
  }
  function S(E, O, T) {
    if (E = E.toLowerCase(), o[E])
      return n.createDecipheriv(E, O, T);
    if (u[E])
      return new e({ key: O, iv: T, mode: E, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function $() {
    return Object.keys(u).concat(n.getCiphers());
  }
  return browser$8.createCipher = browser$8.Cipher = d, browser$8.createCipheriv = browser$8.Cipheriv = v, browser$8.createDecipher = browser$8.Decipher = m, browser$8.createDecipheriv = browser$8.Decipheriv = S, browser$8.listCiphers = browser$8.getCiphers = $, browser$8;
}
var browser$6 = {}, bn$6 = { exports: {} };
bn$6.exports;
var hasRequiredBn$4;
function requireBn$4() {
  return hasRequiredBn$4 || (hasRequiredBn$4 = 1, function(e) {
    (function(n, o) {
      function u(H, C) {
        if (!H)
          throw new Error(C || "Assertion failed");
      }
      function c(H, C) {
        H.super_ = C;
        var w = function() {
        };
        w.prototype = C.prototype, H.prototype = new w(), H.prototype.constructor = H;
      }
      function d(H, C, w) {
        if (d.isBN(H))
          return H;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, H !== null && ((C === "le" || C === "be") && (w = C, C = 10), this._init(H || 0, C || 10, w || "be"));
      }
      typeof n == "object" ? n.exports = d : o.BN = d, d.BN = d, d.wordSize = 26;
      var m;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = require$$0$3.Buffer;
      } catch {
      }
      d.isBN = function(C) {
        return C instanceof d ? !0 : C !== null && typeof C == "object" && C.constructor.wordSize === d.wordSize && Array.isArray(C.words);
      }, d.max = function(C, w) {
        return C.cmp(w) > 0 ? C : w;
      }, d.min = function(C, w) {
        return C.cmp(w) < 0 ? C : w;
      }, d.prototype._init = function(C, w, P) {
        if (typeof C == "number")
          return this._initNumber(C, w, P);
        if (typeof C == "object")
          return this._initArray(C, w, P);
        w === "hex" && (w = 16), u(w === (w | 0) && w >= 2 && w <= 36), C = C.toString().replace(/\s+/g, "");
        var J = 0;
        C[0] === "-" && (J++, this.negative = 1), J < C.length && (w === 16 ? this._parseHex(C, J, P) : (this._parseBase(C, w, J), P === "le" && this._initArray(this.toArray(), w, P)));
      }, d.prototype._initNumber = function(C, w, P) {
        C < 0 && (this.negative = 1, C = -C), C < 67108864 ? (this.words = [C & 67108863], this.length = 1) : C < 4503599627370496 ? (this.words = [
          C & 67108863,
          C / 67108864 & 67108863
        ], this.length = 2) : (u(C < 9007199254740992), this.words = [
          C & 67108863,
          C / 67108864 & 67108863,
          1
        ], this.length = 3), P === "le" && this._initArray(this.toArray(), w, P);
      }, d.prototype._initArray = function(C, w, P) {
        if (u(typeof C.length == "number"), C.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(C.length / 3), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se, fe, N = 0;
        if (P === "be")
          for (J = C.length - 1, se = 0; J >= 0; J -= 3)
            fe = C[J] | C[J - 1] << 8 | C[J - 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        else if (P === "le")
          for (J = 0, se = 0; J < C.length; J += 3)
            fe = C[J] | C[J + 1] << 8 | C[J + 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        return this.strip();
      };
      function v(H, C) {
        var w = H.charCodeAt(C);
        return w >= 65 && w <= 70 ? w - 55 : w >= 97 && w <= 102 ? w - 87 : w - 48 & 15;
      }
      function S(H, C, w) {
        var P = v(H, w);
        return w - 1 >= C && (P |= v(H, w - 1) << 4), P;
      }
      d.prototype._parseHex = function(C, w, P) {
        this.length = Math.ceil((C.length - w) / 6), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se = 0, fe = 0, N;
        if (P === "be")
          for (J = C.length - 1; J >= w; J -= 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        else {
          var W = C.length - w;
          for (J = W % 2 === 0 ? w + 1 : w; J < C.length; J += 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        }
        this.strip();
      };
      function $(H, C, w, P) {
        for (var J = 0, se = Math.min(H.length, w), fe = C; fe < se; fe++) {
          var N = H.charCodeAt(fe) - 48;
          J *= P, N >= 49 ? J += N - 49 + 10 : N >= 17 ? J += N - 17 + 10 : J += N;
        }
        return J;
      }
      d.prototype._parseBase = function(C, w, P) {
        this.words = [0], this.length = 1;
        for (var J = 0, se = 1; se <= 67108863; se *= w)
          J++;
        J--, se = se / w | 0;
        for (var fe = C.length - P, N = fe % J, W = Math.min(fe, fe - N) + P, I = 0, te = P; te < W; te += J)
          I = $(C, te, te + J, w), this.imuln(se), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        if (N !== 0) {
          var ge = 1;
          for (I = $(C, te, C.length, w), te = 0; te < N; te++)
            ge *= w;
          this.imuln(ge), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        }
        this.strip();
      }, d.prototype.copy = function(C) {
        C.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          C.words[w] = this.words[w];
        C.length = this.length, C.negative = this.negative, C.red = this.red;
      }, d.prototype.clone = function() {
        var C = new d(null);
        return this.copy(C), C;
      }, d.prototype._expand = function(C) {
        for (; this.length < C; )
          this.words[this.length++] = 0;
        return this;
      }, d.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, d.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, d.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var E = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], O = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], T = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      d.prototype.toString = function(C, w) {
        C = C || 10, w = w | 0 || 1;
        var P;
        if (C === 16 || C === "hex") {
          P = "";
          for (var J = 0, se = 0, fe = 0; fe < this.length; fe++) {
            var N = this.words[fe], W = ((N << J | se) & 16777215).toString(16);
            se = N >>> 24 - J & 16777215, se !== 0 || fe !== this.length - 1 ? P = E[6 - W.length] + W + P : P = W + P, J += 2, J >= 26 && (J -= 26, fe--);
          }
          for (se !== 0 && (P = se.toString(16) + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        if (C === (C | 0) && C >= 2 && C <= 36) {
          var I = O[C], te = T[C];
          P = "";
          var ge = this.clone();
          for (ge.negative = 0; !ge.isZero(); ) {
            var Pe = ge.modn(te).toString(C);
            ge = ge.idivn(te), ge.isZero() ? P = Pe + P : P = E[I - Pe.length] + Pe + P;
          }
          for (this.isZero() && (P = "0" + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        u(!1, "Base should be between 2 and 36");
      }, d.prototype.toNumber = function() {
        var C = this.words[0];
        return this.length === 2 ? C += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? C += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && u(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -C : C;
      }, d.prototype.toJSON = function() {
        return this.toString(16);
      }, d.prototype.toBuffer = function(C, w) {
        return u(typeof m < "u"), this.toArrayLike(m, C, w);
      }, d.prototype.toArray = function(C, w) {
        return this.toArrayLike(Array, C, w);
      }, d.prototype.toArrayLike = function(C, w, P) {
        var J = this.byteLength(), se = P || Math.max(1, J);
        u(J <= se, "byte array longer than desired length"), u(se > 0, "Requested array length <= 0"), this.strip();
        var fe = w === "le", N = new C(se), W, I, te = this.clone();
        if (fe) {
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[I] = W;
          for (; I < se; I++)
            N[I] = 0;
        } else {
          for (I = 0; I < se - J; I++)
            N[I] = 0;
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[se - I - 1] = W;
        }
        return N;
      }, Math.clz32 ? d.prototype._countBits = function(C) {
        return 32 - Math.clz32(C);
      } : d.prototype._countBits = function(C) {
        var w = C, P = 0;
        return w >= 4096 && (P += 13, w >>>= 13), w >= 64 && (P += 7, w >>>= 7), w >= 8 && (P += 4, w >>>= 4), w >= 2 && (P += 2, w >>>= 2), P + w;
      }, d.prototype._zeroBits = function(C) {
        if (C === 0)
          return 26;
        var w = C, P = 0;
        return w & 8191 || (P += 13, w >>>= 13), w & 127 || (P += 7, w >>>= 7), w & 15 || (P += 4, w >>>= 4), w & 3 || (P += 2, w >>>= 2), w & 1 || P++, P;
      }, d.prototype.bitLength = function() {
        var C = this.words[this.length - 1], w = this._countBits(C);
        return (this.length - 1) * 26 + w;
      };
      function y(H) {
        for (var C = new Array(H.bitLength()), w = 0; w < C.length; w++) {
          var P = w / 26 | 0, J = w % 26;
          C[w] = (H.words[P] & 1 << J) >>> J;
        }
        return C;
      }
      d.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var C = 0, w = 0; w < this.length; w++) {
          var P = this._zeroBits(this.words[w]);
          if (C += P, P !== 26)
            break;
        }
        return C;
      }, d.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, d.prototype.toTwos = function(C) {
        return this.negative !== 0 ? this.abs().inotn(C).iaddn(1) : this.clone();
      }, d.prototype.fromTwos = function(C) {
        return this.testn(C - 1) ? this.notn(C).iaddn(1).ineg() : this.clone();
      }, d.prototype.isNeg = function() {
        return this.negative !== 0;
      }, d.prototype.neg = function() {
        return this.clone().ineg();
      }, d.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, d.prototype.iuor = function(C) {
        for (; this.length < C.length; )
          this.words[this.length++] = 0;
        for (var w = 0; w < C.length; w++)
          this.words[w] = this.words[w] | C.words[w];
        return this.strip();
      }, d.prototype.ior = function(C) {
        return u((this.negative | C.negative) === 0), this.iuor(C);
      }, d.prototype.or = function(C) {
        return this.length > C.length ? this.clone().ior(C) : C.clone().ior(this);
      }, d.prototype.uor = function(C) {
        return this.length > C.length ? this.clone().iuor(C) : C.clone().iuor(this);
      }, d.prototype.iuand = function(C) {
        var w;
        this.length > C.length ? w = C : w = this;
        for (var P = 0; P < w.length; P++)
          this.words[P] = this.words[P] & C.words[P];
        return this.length = w.length, this.strip();
      }, d.prototype.iand = function(C) {
        return u((this.negative | C.negative) === 0), this.iuand(C);
      }, d.prototype.and = function(C) {
        return this.length > C.length ? this.clone().iand(C) : C.clone().iand(this);
      }, d.prototype.uand = function(C) {
        return this.length > C.length ? this.clone().iuand(C) : C.clone().iuand(this);
      }, d.prototype.iuxor = function(C) {
        var w, P;
        this.length > C.length ? (w = this, P = C) : (w = C, P = this);
        for (var J = 0; J < P.length; J++)
          this.words[J] = w.words[J] ^ P.words[J];
        if (this !== w)
          for (; J < w.length; J++)
            this.words[J] = w.words[J];
        return this.length = w.length, this.strip();
      }, d.prototype.ixor = function(C) {
        return u((this.negative | C.negative) === 0), this.iuxor(C);
      }, d.prototype.xor = function(C) {
        return this.length > C.length ? this.clone().ixor(C) : C.clone().ixor(this);
      }, d.prototype.uxor = function(C) {
        return this.length > C.length ? this.clone().iuxor(C) : C.clone().iuxor(this);
      }, d.prototype.inotn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = Math.ceil(C / 26) | 0, P = C % 26;
        this._expand(w), P > 0 && w--;
        for (var J = 0; J < w; J++)
          this.words[J] = ~this.words[J] & 67108863;
        return P > 0 && (this.words[J] = ~this.words[J] & 67108863 >> 26 - P), this.strip();
      }, d.prototype.notn = function(C) {
        return this.clone().inotn(C);
      }, d.prototype.setn = function(C, w) {
        u(typeof C == "number" && C >= 0);
        var P = C / 26 | 0, J = C % 26;
        return this._expand(P + 1), w ? this.words[P] = this.words[P] | 1 << J : this.words[P] = this.words[P] & ~(1 << J), this.strip();
      }, d.prototype.iadd = function(C) {
        var w;
        if (this.negative !== 0 && C.negative === 0)
          return this.negative = 0, w = this.isub(C), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && C.negative !== 0)
          return C.negative = 0, w = this.isub(C), C.negative = 1, w._normSign();
        var P, J;
        this.length > C.length ? (P = this, J = C) : (P = C, J = this);
        for (var se = 0, fe = 0; fe < J.length; fe++)
          w = (P.words[fe] | 0) + (J.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        for (; se !== 0 && fe < P.length; fe++)
          w = (P.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        if (this.length = P.length, se !== 0)
          this.words[this.length] = se, this.length++;
        else if (P !== this)
          for (; fe < P.length; fe++)
            this.words[fe] = P.words[fe];
        return this;
      }, d.prototype.add = function(C) {
        var w;
        return C.negative !== 0 && this.negative === 0 ? (C.negative = 0, w = this.sub(C), C.negative ^= 1, w) : C.negative === 0 && this.negative !== 0 ? (this.negative = 0, w = C.sub(this), this.negative = 1, w) : this.length > C.length ? this.clone().iadd(C) : C.clone().iadd(this);
      }, d.prototype.isub = function(C) {
        if (C.negative !== 0) {
          C.negative = 0;
          var w = this.iadd(C);
          return C.negative = 1, w._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(C), this.negative = 1, this._normSign();
        var P = this.cmp(C);
        if (P === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var J, se;
        P > 0 ? (J = this, se = C) : (J = C, se = this);
        for (var fe = 0, N = 0; N < se.length; N++)
          w = (J.words[N] | 0) - (se.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        for (; fe !== 0 && N < J.length; N++)
          w = (J.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        if (fe === 0 && N < J.length && J !== this)
          for (; N < J.length; N++)
            this.words[N] = J.words[N];
        return this.length = Math.max(this.length, N), J !== this && (this.negative = 1), this.strip();
      }, d.prototype.sub = function(C) {
        return this.clone().isub(C);
      };
      function V(H, C, w) {
        w.negative = C.negative ^ H.negative;
        var P = H.length + C.length | 0;
        w.length = P, P = P - 1 | 0;
        var J = H.words[0] | 0, se = C.words[0] | 0, fe = J * se, N = fe & 67108863, W = fe / 67108864 | 0;
        w.words[0] = N;
        for (var I = 1; I < P; I++) {
          for (var te = W >>> 26, ge = W & 67108863, Pe = Math.min(I, C.length - 1), Ke = Math.max(0, I - H.length + 1); Ke <= Pe; Ke++) {
            var xe = I - Ke | 0;
            J = H.words[xe] | 0, se = C.words[Ke] | 0, fe = J * se + ge, te += fe / 67108864 | 0, ge = fe & 67108863;
          }
          w.words[I] = ge | 0, W = te | 0;
        }
        return W !== 0 ? w.words[I] = W | 0 : w.length--, w.strip();
      }
      var M = function(C, w, P) {
        var J = C.words, se = w.words, fe = P.words, N = 0, W, I, te, ge = J[0] | 0, Pe = ge & 8191, Ke = ge >>> 13, xe = J[1] | 0, ze = xe & 8191, nt = xe >>> 13, Qt = J[2] | 0, Et = Qt & 8191, zt = Qt >>> 13, Nt = J[3] | 0, pt = Nt & 8191, at = Nt >>> 13, kt = J[4] | 0, Ut = kt & 8191, dn = kt >>> 13, En = J[5] | 0, Ht = En & 8191, Xt = En >>> 13, On = J[6] | 0, sn = On & 8191, At = On >>> 13, hn = J[7] | 0, $t = hn & 8191, Lt = hn >>> 13, Qn = J[8] | 0, ce = Qn & 8191, Ze = Qn >>> 13, ft = J[9] | 0, It = ft & 8191, rn = ft >>> 13, Ln = se[0] | 0, Pn = Ln & 8191, Ae = Ln >>> 13, Me = se[1] | 0, He = Me & 8191, cn = Me >>> 13, Wt = se[2] | 0, yn = Wt & 8191, pr = Wt >>> 13, Uo = se[3] | 0, ar = Uo & 8191, Sr = Uo >>> 13, Jo = se[4] | 0, fr = Jo & 8191, Er = Jo >>> 13, vo = se[5] | 0, lr = vo & 8191, $r = vo >>> 13, Wo = se[6] | 0, yr = Wo & 8191, Dr = Wo >>> 13, Zo = se[7] | 0, dr = Zo & 8191, Br = Zo >>> 13, Qo = se[8] | 0, tr = Qo & 8191, Mr = Qo >>> 13, qo = se[9] | 0, hr = qo & 8191, Or = qo >>> 13;
        P.negative = C.negative ^ w.negative, P.length = 19, W = Math.imul(Pe, Pn), I = Math.imul(Pe, Ae), I = I + Math.imul(Ke, Pn) | 0, te = Math.imul(Ke, Ae);
        var Fo = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fo >>> 26) | 0, Fo &= 67108863, W = Math.imul(ze, Pn), I = Math.imul(ze, Ae), I = I + Math.imul(nt, Pn) | 0, te = Math.imul(nt, Ae), W = W + Math.imul(Pe, He) | 0, I = I + Math.imul(Pe, cn) | 0, I = I + Math.imul(Ke, He) | 0, te = te + Math.imul(Ke, cn) | 0;
        var No = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, W = Math.imul(Et, Pn), I = Math.imul(Et, Ae), I = I + Math.imul(zt, Pn) | 0, te = Math.imul(zt, Ae), W = W + Math.imul(ze, He) | 0, I = I + Math.imul(ze, cn) | 0, I = I + Math.imul(nt, He) | 0, te = te + Math.imul(nt, cn) | 0, W = W + Math.imul(Pe, yn) | 0, I = I + Math.imul(Pe, pr) | 0, I = I + Math.imul(Ke, yn) | 0, te = te + Math.imul(Ke, pr) | 0;
        var di = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, W = Math.imul(pt, Pn), I = Math.imul(pt, Ae), I = I + Math.imul(at, Pn) | 0, te = Math.imul(at, Ae), W = W + Math.imul(Et, He) | 0, I = I + Math.imul(Et, cn) | 0, I = I + Math.imul(zt, He) | 0, te = te + Math.imul(zt, cn) | 0, W = W + Math.imul(ze, yn) | 0, I = I + Math.imul(ze, pr) | 0, I = I + Math.imul(nt, yn) | 0, te = te + Math.imul(nt, pr) | 0, W = W + Math.imul(Pe, ar) | 0, I = I + Math.imul(Pe, Sr) | 0, I = I + Math.imul(Ke, ar) | 0, te = te + Math.imul(Ke, Sr) | 0;
        var gi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, W = Math.imul(Ut, Pn), I = Math.imul(Ut, Ae), I = I + Math.imul(dn, Pn) | 0, te = Math.imul(dn, Ae), W = W + Math.imul(pt, He) | 0, I = I + Math.imul(pt, cn) | 0, I = I + Math.imul(at, He) | 0, te = te + Math.imul(at, cn) | 0, W = W + Math.imul(Et, yn) | 0, I = I + Math.imul(Et, pr) | 0, I = I + Math.imul(zt, yn) | 0, te = te + Math.imul(zt, pr) | 0, W = W + Math.imul(ze, ar) | 0, I = I + Math.imul(ze, Sr) | 0, I = I + Math.imul(nt, ar) | 0, te = te + Math.imul(nt, Sr) | 0, W = W + Math.imul(Pe, fr) | 0, I = I + Math.imul(Pe, Er) | 0, I = I + Math.imul(Ke, fr) | 0, te = te + Math.imul(Ke, Er) | 0;
        var ai = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, W = Math.imul(Ht, Pn), I = Math.imul(Ht, Ae), I = I + Math.imul(Xt, Pn) | 0, te = Math.imul(Xt, Ae), W = W + Math.imul(Ut, He) | 0, I = I + Math.imul(Ut, cn) | 0, I = I + Math.imul(dn, He) | 0, te = te + Math.imul(dn, cn) | 0, W = W + Math.imul(pt, yn) | 0, I = I + Math.imul(pt, pr) | 0, I = I + Math.imul(at, yn) | 0, te = te + Math.imul(at, pr) | 0, W = W + Math.imul(Et, ar) | 0, I = I + Math.imul(Et, Sr) | 0, I = I + Math.imul(zt, ar) | 0, te = te + Math.imul(zt, Sr) | 0, W = W + Math.imul(ze, fr) | 0, I = I + Math.imul(ze, Er) | 0, I = I + Math.imul(nt, fr) | 0, te = te + Math.imul(nt, Er) | 0, W = W + Math.imul(Pe, lr) | 0, I = I + Math.imul(Pe, $r) | 0, I = I + Math.imul(Ke, lr) | 0, te = te + Math.imul(Ke, $r) | 0;
        var ui = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, W = Math.imul(sn, Pn), I = Math.imul(sn, Ae), I = I + Math.imul(At, Pn) | 0, te = Math.imul(At, Ae), W = W + Math.imul(Ht, He) | 0, I = I + Math.imul(Ht, cn) | 0, I = I + Math.imul(Xt, He) | 0, te = te + Math.imul(Xt, cn) | 0, W = W + Math.imul(Ut, yn) | 0, I = I + Math.imul(Ut, pr) | 0, I = I + Math.imul(dn, yn) | 0, te = te + Math.imul(dn, pr) | 0, W = W + Math.imul(pt, ar) | 0, I = I + Math.imul(pt, Sr) | 0, I = I + Math.imul(at, ar) | 0, te = te + Math.imul(at, Sr) | 0, W = W + Math.imul(Et, fr) | 0, I = I + Math.imul(Et, Er) | 0, I = I + Math.imul(zt, fr) | 0, te = te + Math.imul(zt, Er) | 0, W = W + Math.imul(ze, lr) | 0, I = I + Math.imul(ze, $r) | 0, I = I + Math.imul(nt, lr) | 0, te = te + Math.imul(nt, $r) | 0, W = W + Math.imul(Pe, yr) | 0, I = I + Math.imul(Pe, Dr) | 0, I = I + Math.imul(Ke, yr) | 0, te = te + Math.imul(Ke, Dr) | 0;
        var hi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (hi >>> 26) | 0, hi &= 67108863, W = Math.imul($t, Pn), I = Math.imul($t, Ae), I = I + Math.imul(Lt, Pn) | 0, te = Math.imul(Lt, Ae), W = W + Math.imul(sn, He) | 0, I = I + Math.imul(sn, cn) | 0, I = I + Math.imul(At, He) | 0, te = te + Math.imul(At, cn) | 0, W = W + Math.imul(Ht, yn) | 0, I = I + Math.imul(Ht, pr) | 0, I = I + Math.imul(Xt, yn) | 0, te = te + Math.imul(Xt, pr) | 0, W = W + Math.imul(Ut, ar) | 0, I = I + Math.imul(Ut, Sr) | 0, I = I + Math.imul(dn, ar) | 0, te = te + Math.imul(dn, Sr) | 0, W = W + Math.imul(pt, fr) | 0, I = I + Math.imul(pt, Er) | 0, I = I + Math.imul(at, fr) | 0, te = te + Math.imul(at, Er) | 0, W = W + Math.imul(Et, lr) | 0, I = I + Math.imul(Et, $r) | 0, I = I + Math.imul(zt, lr) | 0, te = te + Math.imul(zt, $r) | 0, W = W + Math.imul(ze, yr) | 0, I = I + Math.imul(ze, Dr) | 0, I = I + Math.imul(nt, yr) | 0, te = te + Math.imul(nt, Dr) | 0, W = W + Math.imul(Pe, dr) | 0, I = I + Math.imul(Pe, Br) | 0, I = I + Math.imul(Ke, dr) | 0, te = te + Math.imul(Ke, Br) | 0;
        var bi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, W = Math.imul(ce, Pn), I = Math.imul(ce, Ae), I = I + Math.imul(Ze, Pn) | 0, te = Math.imul(Ze, Ae), W = W + Math.imul($t, He) | 0, I = I + Math.imul($t, cn) | 0, I = I + Math.imul(Lt, He) | 0, te = te + Math.imul(Lt, cn) | 0, W = W + Math.imul(sn, yn) | 0, I = I + Math.imul(sn, pr) | 0, I = I + Math.imul(At, yn) | 0, te = te + Math.imul(At, pr) | 0, W = W + Math.imul(Ht, ar) | 0, I = I + Math.imul(Ht, Sr) | 0, I = I + Math.imul(Xt, ar) | 0, te = te + Math.imul(Xt, Sr) | 0, W = W + Math.imul(Ut, fr) | 0, I = I + Math.imul(Ut, Er) | 0, I = I + Math.imul(dn, fr) | 0, te = te + Math.imul(dn, Er) | 0, W = W + Math.imul(pt, lr) | 0, I = I + Math.imul(pt, $r) | 0, I = I + Math.imul(at, lr) | 0, te = te + Math.imul(at, $r) | 0, W = W + Math.imul(Et, yr) | 0, I = I + Math.imul(Et, Dr) | 0, I = I + Math.imul(zt, yr) | 0, te = te + Math.imul(zt, Dr) | 0, W = W + Math.imul(ze, dr) | 0, I = I + Math.imul(ze, Br) | 0, I = I + Math.imul(nt, dr) | 0, te = te + Math.imul(nt, Br) | 0, W = W + Math.imul(Pe, tr) | 0, I = I + Math.imul(Pe, Mr) | 0, I = I + Math.imul(Ke, tr) | 0, te = te + Math.imul(Ke, Mr) | 0;
        var ii = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, W = Math.imul(It, Pn), I = Math.imul(It, Ae), I = I + Math.imul(rn, Pn) | 0, te = Math.imul(rn, Ae), W = W + Math.imul(ce, He) | 0, I = I + Math.imul(ce, cn) | 0, I = I + Math.imul(Ze, He) | 0, te = te + Math.imul(Ze, cn) | 0, W = W + Math.imul($t, yn) | 0, I = I + Math.imul($t, pr) | 0, I = I + Math.imul(Lt, yn) | 0, te = te + Math.imul(Lt, pr) | 0, W = W + Math.imul(sn, ar) | 0, I = I + Math.imul(sn, Sr) | 0, I = I + Math.imul(At, ar) | 0, te = te + Math.imul(At, Sr) | 0, W = W + Math.imul(Ht, fr) | 0, I = I + Math.imul(Ht, Er) | 0, I = I + Math.imul(Xt, fr) | 0, te = te + Math.imul(Xt, Er) | 0, W = W + Math.imul(Ut, lr) | 0, I = I + Math.imul(Ut, $r) | 0, I = I + Math.imul(dn, lr) | 0, te = te + Math.imul(dn, $r) | 0, W = W + Math.imul(pt, yr) | 0, I = I + Math.imul(pt, Dr) | 0, I = I + Math.imul(at, yr) | 0, te = te + Math.imul(at, Dr) | 0, W = W + Math.imul(Et, dr) | 0, I = I + Math.imul(Et, Br) | 0, I = I + Math.imul(zt, dr) | 0, te = te + Math.imul(zt, Br) | 0, W = W + Math.imul(ze, tr) | 0, I = I + Math.imul(ze, Mr) | 0, I = I + Math.imul(nt, tr) | 0, te = te + Math.imul(nt, Mr) | 0, W = W + Math.imul(Pe, hr) | 0, I = I + Math.imul(Pe, Or) | 0, I = I + Math.imul(Ke, hr) | 0, te = te + Math.imul(Ke, Or) | 0;
        var pi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (pi >>> 26) | 0, pi &= 67108863, W = Math.imul(It, He), I = Math.imul(It, cn), I = I + Math.imul(rn, He) | 0, te = Math.imul(rn, cn), W = W + Math.imul(ce, yn) | 0, I = I + Math.imul(ce, pr) | 0, I = I + Math.imul(Ze, yn) | 0, te = te + Math.imul(Ze, pr) | 0, W = W + Math.imul($t, ar) | 0, I = I + Math.imul($t, Sr) | 0, I = I + Math.imul(Lt, ar) | 0, te = te + Math.imul(Lt, Sr) | 0, W = W + Math.imul(sn, fr) | 0, I = I + Math.imul(sn, Er) | 0, I = I + Math.imul(At, fr) | 0, te = te + Math.imul(At, Er) | 0, W = W + Math.imul(Ht, lr) | 0, I = I + Math.imul(Ht, $r) | 0, I = I + Math.imul(Xt, lr) | 0, te = te + Math.imul(Xt, $r) | 0, W = W + Math.imul(Ut, yr) | 0, I = I + Math.imul(Ut, Dr) | 0, I = I + Math.imul(dn, yr) | 0, te = te + Math.imul(dn, Dr) | 0, W = W + Math.imul(pt, dr) | 0, I = I + Math.imul(pt, Br) | 0, I = I + Math.imul(at, dr) | 0, te = te + Math.imul(at, Br) | 0, W = W + Math.imul(Et, tr) | 0, I = I + Math.imul(Et, Mr) | 0, I = I + Math.imul(zt, tr) | 0, te = te + Math.imul(zt, Mr) | 0, W = W + Math.imul(ze, hr) | 0, I = I + Math.imul(ze, Or) | 0, I = I + Math.imul(nt, hr) | 0, te = te + Math.imul(nt, Or) | 0;
        var Ci = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, W = Math.imul(It, yn), I = Math.imul(It, pr), I = I + Math.imul(rn, yn) | 0, te = Math.imul(rn, pr), W = W + Math.imul(ce, ar) | 0, I = I + Math.imul(ce, Sr) | 0, I = I + Math.imul(Ze, ar) | 0, te = te + Math.imul(Ze, Sr) | 0, W = W + Math.imul($t, fr) | 0, I = I + Math.imul($t, Er) | 0, I = I + Math.imul(Lt, fr) | 0, te = te + Math.imul(Lt, Er) | 0, W = W + Math.imul(sn, lr) | 0, I = I + Math.imul(sn, $r) | 0, I = I + Math.imul(At, lr) | 0, te = te + Math.imul(At, $r) | 0, W = W + Math.imul(Ht, yr) | 0, I = I + Math.imul(Ht, Dr) | 0, I = I + Math.imul(Xt, yr) | 0, te = te + Math.imul(Xt, Dr) | 0, W = W + Math.imul(Ut, dr) | 0, I = I + Math.imul(Ut, Br) | 0, I = I + Math.imul(dn, dr) | 0, te = te + Math.imul(dn, Br) | 0, W = W + Math.imul(pt, tr) | 0, I = I + Math.imul(pt, Mr) | 0, I = I + Math.imul(at, tr) | 0, te = te + Math.imul(at, Mr) | 0, W = W + Math.imul(Et, hr) | 0, I = I + Math.imul(Et, Or) | 0, I = I + Math.imul(zt, hr) | 0, te = te + Math.imul(zt, Or) | 0;
        var _i = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (_i >>> 26) | 0, _i &= 67108863, W = Math.imul(It, ar), I = Math.imul(It, Sr), I = I + Math.imul(rn, ar) | 0, te = Math.imul(rn, Sr), W = W + Math.imul(ce, fr) | 0, I = I + Math.imul(ce, Er) | 0, I = I + Math.imul(Ze, fr) | 0, te = te + Math.imul(Ze, Er) | 0, W = W + Math.imul($t, lr) | 0, I = I + Math.imul($t, $r) | 0, I = I + Math.imul(Lt, lr) | 0, te = te + Math.imul(Lt, $r) | 0, W = W + Math.imul(sn, yr) | 0, I = I + Math.imul(sn, Dr) | 0, I = I + Math.imul(At, yr) | 0, te = te + Math.imul(At, Dr) | 0, W = W + Math.imul(Ht, dr) | 0, I = I + Math.imul(Ht, Br) | 0, I = I + Math.imul(Xt, dr) | 0, te = te + Math.imul(Xt, Br) | 0, W = W + Math.imul(Ut, tr) | 0, I = I + Math.imul(Ut, Mr) | 0, I = I + Math.imul(dn, tr) | 0, te = te + Math.imul(dn, Mr) | 0, W = W + Math.imul(pt, hr) | 0, I = I + Math.imul(pt, Or) | 0, I = I + Math.imul(at, hr) | 0, te = te + Math.imul(at, Or) | 0;
        var xn = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, W = Math.imul(It, fr), I = Math.imul(It, Er), I = I + Math.imul(rn, fr) | 0, te = Math.imul(rn, Er), W = W + Math.imul(ce, lr) | 0, I = I + Math.imul(ce, $r) | 0, I = I + Math.imul(Ze, lr) | 0, te = te + Math.imul(Ze, $r) | 0, W = W + Math.imul($t, yr) | 0, I = I + Math.imul($t, Dr) | 0, I = I + Math.imul(Lt, yr) | 0, te = te + Math.imul(Lt, Dr) | 0, W = W + Math.imul(sn, dr) | 0, I = I + Math.imul(sn, Br) | 0, I = I + Math.imul(At, dr) | 0, te = te + Math.imul(At, Br) | 0, W = W + Math.imul(Ht, tr) | 0, I = I + Math.imul(Ht, Mr) | 0, I = I + Math.imul(Xt, tr) | 0, te = te + Math.imul(Xt, Mr) | 0, W = W + Math.imul(Ut, hr) | 0, I = I + Math.imul(Ut, Or) | 0, I = I + Math.imul(dn, hr) | 0, te = te + Math.imul(dn, Or) | 0;
        var sr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (sr >>> 26) | 0, sr &= 67108863, W = Math.imul(It, lr), I = Math.imul(It, $r), I = I + Math.imul(rn, lr) | 0, te = Math.imul(rn, $r), W = W + Math.imul(ce, yr) | 0, I = I + Math.imul(ce, Dr) | 0, I = I + Math.imul(Ze, yr) | 0, te = te + Math.imul(Ze, Dr) | 0, W = W + Math.imul($t, dr) | 0, I = I + Math.imul($t, Br) | 0, I = I + Math.imul(Lt, dr) | 0, te = te + Math.imul(Lt, Br) | 0, W = W + Math.imul(sn, tr) | 0, I = I + Math.imul(sn, Mr) | 0, I = I + Math.imul(At, tr) | 0, te = te + Math.imul(At, Mr) | 0, W = W + Math.imul(Ht, hr) | 0, I = I + Math.imul(Ht, Or) | 0, I = I + Math.imul(Xt, hr) | 0, te = te + Math.imul(Xt, Or) | 0;
        var Nr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Nr >>> 26) | 0, Nr &= 67108863, W = Math.imul(It, yr), I = Math.imul(It, Dr), I = I + Math.imul(rn, yr) | 0, te = Math.imul(rn, Dr), W = W + Math.imul(ce, dr) | 0, I = I + Math.imul(ce, Br) | 0, I = I + Math.imul(Ze, dr) | 0, te = te + Math.imul(Ze, Br) | 0, W = W + Math.imul($t, tr) | 0, I = I + Math.imul($t, Mr) | 0, I = I + Math.imul(Lt, tr) | 0, te = te + Math.imul(Lt, Mr) | 0, W = W + Math.imul(sn, hr) | 0, I = I + Math.imul(sn, Or) | 0, I = I + Math.imul(At, hr) | 0, te = te + Math.imul(At, Or) | 0;
        var vr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, W = Math.imul(It, dr), I = Math.imul(It, Br), I = I + Math.imul(rn, dr) | 0, te = Math.imul(rn, Br), W = W + Math.imul(ce, tr) | 0, I = I + Math.imul(ce, Mr) | 0, I = I + Math.imul(Ze, tr) | 0, te = te + Math.imul(Ze, Mr) | 0, W = W + Math.imul($t, hr) | 0, I = I + Math.imul($t, Or) | 0, I = I + Math.imul(Lt, hr) | 0, te = te + Math.imul(Lt, Or) | 0;
        var Yr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, W = Math.imul(It, tr), I = Math.imul(It, Mr), I = I + Math.imul(rn, tr) | 0, te = Math.imul(rn, Mr), W = W + Math.imul(ce, hr) | 0, I = I + Math.imul(ce, Or) | 0, I = I + Math.imul(Ze, hr) | 0, te = te + Math.imul(Ze, Or) | 0;
        var Fr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, W = Math.imul(It, hr), I = Math.imul(It, Or), I = I + Math.imul(rn, hr) | 0, te = Math.imul(rn, Or);
        var eo = (N + W | 0) + ((I & 8191) << 13) | 0;
        return N = (te + (I >>> 13) | 0) + (eo >>> 26) | 0, eo &= 67108863, fe[0] = Fo, fe[1] = No, fe[2] = di, fe[3] = gi, fe[4] = ai, fe[5] = ui, fe[6] = hi, fe[7] = bi, fe[8] = ii, fe[9] = pi, fe[10] = Ci, fe[11] = _i, fe[12] = xn, fe[13] = sr, fe[14] = Nr, fe[15] = vr, fe[16] = Yr, fe[17] = Fr, fe[18] = eo, N !== 0 && (fe[19] = N, P.length++), P;
      };
      Math.imul || (M = V);
      function G(H, C, w) {
        w.negative = C.negative ^ H.negative, w.length = H.length + C.length;
        for (var P = 0, J = 0, se = 0; se < w.length - 1; se++) {
          var fe = J;
          J = 0;
          for (var N = P & 67108863, W = Math.min(se, C.length - 1), I = Math.max(0, se - H.length + 1); I <= W; I++) {
            var te = se - I, ge = H.words[te] | 0, Pe = C.words[I] | 0, Ke = ge * Pe, xe = Ke & 67108863;
            fe = fe + (Ke / 67108864 | 0) | 0, xe = xe + N | 0, N = xe & 67108863, fe = fe + (xe >>> 26) | 0, J += fe >>> 26, fe &= 67108863;
          }
          w.words[se] = N, P = fe, fe = J;
        }
        return P !== 0 ? w.words[se] = P : w.length--, w.strip();
      }
      function k(H, C, w) {
        var P = new F();
        return P.mulp(H, C, w);
      }
      d.prototype.mulTo = function(C, w) {
        var P, J = this.length + C.length;
        return this.length === 10 && C.length === 10 ? P = M(this, C, w) : J < 63 ? P = V(this, C, w) : J < 1024 ? P = G(this, C, w) : P = k(this, C, w), P;
      };
      function F(H, C) {
        this.x = H, this.y = C;
      }
      F.prototype.makeRBT = function(C) {
        for (var w = new Array(C), P = d.prototype._countBits(C) - 1, J = 0; J < C; J++)
          w[J] = this.revBin(J, P, C);
        return w;
      }, F.prototype.revBin = function(C, w, P) {
        if (C === 0 || C === P - 1)
          return C;
        for (var J = 0, se = 0; se < w; se++)
          J |= (C & 1) << w - se - 1, C >>= 1;
        return J;
      }, F.prototype.permute = function(C, w, P, J, se, fe) {
        for (var N = 0; N < fe; N++)
          J[N] = w[C[N]], se[N] = P[C[N]];
      }, F.prototype.transform = function(C, w, P, J, se, fe) {
        this.permute(fe, C, w, P, J, se);
        for (var N = 1; N < se; N <<= 1)
          for (var W = N << 1, I = Math.cos(2 * Math.PI / W), te = Math.sin(2 * Math.PI / W), ge = 0; ge < se; ge += W)
            for (var Pe = I, Ke = te, xe = 0; xe < N; xe++) {
              var ze = P[ge + xe], nt = J[ge + xe], Qt = P[ge + xe + N], Et = J[ge + xe + N], zt = Pe * Qt - Ke * Et;
              Et = Pe * Et + Ke * Qt, Qt = zt, P[ge + xe] = ze + Qt, J[ge + xe] = nt + Et, P[ge + xe + N] = ze - Qt, J[ge + xe + N] = nt - Et, xe !== W && (zt = I * Pe - te * Ke, Ke = I * Ke + te * Pe, Pe = zt);
            }
      }, F.prototype.guessLen13b = function(C, w) {
        var P = Math.max(w, C) | 1, J = P & 1, se = 0;
        for (P = P / 2 | 0; P; P = P >>> 1)
          se++;
        return 1 << se + 1 + J;
      }, F.prototype.conjugate = function(C, w, P) {
        if (!(P <= 1))
          for (var J = 0; J < P / 2; J++) {
            var se = C[J];
            C[J] = C[P - J - 1], C[P - J - 1] = se, se = w[J], w[J] = -w[P - J - 1], w[P - J - 1] = -se;
          }
      }, F.prototype.normalize13b = function(C, w) {
        for (var P = 0, J = 0; J < w / 2; J++) {
          var se = Math.round(C[2 * J + 1] / w) * 8192 + Math.round(C[2 * J] / w) + P;
          C[J] = se & 67108863, se < 67108864 ? P = 0 : P = se / 67108864 | 0;
        }
        return C;
      }, F.prototype.convert13b = function(C, w, P, J) {
        for (var se = 0, fe = 0; fe < w; fe++)
          se = se + (C[fe] | 0), P[2 * fe] = se & 8191, se = se >>> 13, P[2 * fe + 1] = se & 8191, se = se >>> 13;
        for (fe = 2 * w; fe < J; ++fe)
          P[fe] = 0;
        u(se === 0), u((se & -8192) === 0);
      }, F.prototype.stub = function(C) {
        for (var w = new Array(C), P = 0; P < C; P++)
          w[P] = 0;
        return w;
      }, F.prototype.mulp = function(C, w, P) {
        var J = 2 * this.guessLen13b(C.length, w.length), se = this.makeRBT(J), fe = this.stub(J), N = new Array(J), W = new Array(J), I = new Array(J), te = new Array(J), ge = new Array(J), Pe = new Array(J), Ke = P.words;
        Ke.length = J, this.convert13b(C.words, C.length, N, J), this.convert13b(w.words, w.length, te, J), this.transform(N, fe, W, I, J, se), this.transform(te, fe, ge, Pe, J, se);
        for (var xe = 0; xe < J; xe++) {
          var ze = W[xe] * ge[xe] - I[xe] * Pe[xe];
          I[xe] = W[xe] * Pe[xe] + I[xe] * ge[xe], W[xe] = ze;
        }
        return this.conjugate(W, I, J), this.transform(W, I, Ke, fe, J, se), this.conjugate(Ke, fe, J), this.normalize13b(Ke, J), P.negative = C.negative ^ w.negative, P.length = C.length + w.length, P.strip();
      }, d.prototype.mul = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), this.mulTo(C, w);
      }, d.prototype.mulf = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), k(this, C, w);
      }, d.prototype.imul = function(C) {
        return this.clone().mulTo(C, this);
      }, d.prototype.imuln = function(C) {
        u(typeof C == "number"), u(C < 67108864);
        for (var w = 0, P = 0; P < this.length; P++) {
          var J = (this.words[P] | 0) * C, se = (J & 67108863) + (w & 67108863);
          w >>= 26, w += J / 67108864 | 0, w += se >>> 26, this.words[P] = se & 67108863;
        }
        return w !== 0 && (this.words[P] = w, this.length++), this;
      }, d.prototype.muln = function(C) {
        return this.clone().imuln(C);
      }, d.prototype.sqr = function() {
        return this.mul(this);
      }, d.prototype.isqr = function() {
        return this.imul(this.clone());
      }, d.prototype.pow = function(C) {
        var w = y(C);
        if (w.length === 0)
          return new d(1);
        for (var P = this, J = 0; J < w.length && w[J] === 0; J++, P = P.sqr())
          ;
        if (++J < w.length)
          for (var se = P.sqr(); J < w.length; J++, se = se.sqr())
            w[J] !== 0 && (P = P.mul(se));
        return P;
      }, d.prototype.iushln = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 67108863 >>> 26 - w << 26 - w, se;
        if (w !== 0) {
          var fe = 0;
          for (se = 0; se < this.length; se++) {
            var N = this.words[se] & J, W = (this.words[se] | 0) - N << w;
            this.words[se] = W | fe, fe = N >>> 26 - w;
          }
          fe && (this.words[se] = fe, this.length++);
        }
        if (P !== 0) {
          for (se = this.length - 1; se >= 0; se--)
            this.words[se + P] = this.words[se];
          for (se = 0; se < P; se++)
            this.words[se] = 0;
          this.length += P;
        }
        return this.strip();
      }, d.prototype.ishln = function(C) {
        return u(this.negative === 0), this.iushln(C);
      }, d.prototype.iushrn = function(C, w, P) {
        u(typeof C == "number" && C >= 0);
        var J;
        w ? J = (w - w % 26) / 26 : J = 0;
        var se = C % 26, fe = Math.min((C - se) / 26, this.length), N = 67108863 ^ 67108863 >>> se << se, W = P;
        if (J -= fe, J = Math.max(0, J), W) {
          for (var I = 0; I < fe; I++)
            W.words[I] = this.words[I];
          W.length = fe;
        }
        if (fe !== 0)
          if (this.length > fe)
            for (this.length -= fe, I = 0; I < this.length; I++)
              this.words[I] = this.words[I + fe];
          else
            this.words[0] = 0, this.length = 1;
        var te = 0;
        for (I = this.length - 1; I >= 0 && (te !== 0 || I >= J); I--) {
          var ge = this.words[I] | 0;
          this.words[I] = te << 26 - se | ge >>> se, te = ge & N;
        }
        return W && te !== 0 && (W.words[W.length++] = te), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, d.prototype.ishrn = function(C, w, P) {
        return u(this.negative === 0), this.iushrn(C, w, P);
      }, d.prototype.shln = function(C) {
        return this.clone().ishln(C);
      }, d.prototype.ushln = function(C) {
        return this.clone().iushln(C);
      }, d.prototype.shrn = function(C) {
        return this.clone().ishrn(C);
      }, d.prototype.ushrn = function(C) {
        return this.clone().iushrn(C);
      }, d.prototype.testn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return !1;
        var se = this.words[P];
        return !!(se & J);
      }, d.prototype.imaskn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26;
        if (u(this.negative === 0, "imaskn works only with positive numbers"), this.length <= P)
          return this;
        if (w !== 0 && P++, this.length = Math.min(P, this.length), w !== 0) {
          var J = 67108863 ^ 67108863 >>> w << w;
          this.words[this.length - 1] &= J;
        }
        return this.strip();
      }, d.prototype.maskn = function(C) {
        return this.clone().imaskn(C);
      }, d.prototype.iaddn = function(C) {
        return u(typeof C == "number"), u(C < 67108864), C < 0 ? this.isubn(-C) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < C ? (this.words[0] = C - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(C), this.negative = 1, this) : this._iaddn(C);
      }, d.prototype._iaddn = function(C) {
        this.words[0] += C;
        for (var w = 0; w < this.length && this.words[w] >= 67108864; w++)
          this.words[w] -= 67108864, w === this.length - 1 ? this.words[w + 1] = 1 : this.words[w + 1]++;
        return this.length = Math.max(this.length, w + 1), this;
      }, d.prototype.isubn = function(C) {
        if (u(typeof C == "number"), u(C < 67108864), C < 0)
          return this.iaddn(-C);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(C), this.negative = 1, this;
        if (this.words[0] -= C, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var w = 0; w < this.length && this.words[w] < 0; w++)
            this.words[w] += 67108864, this.words[w + 1] -= 1;
        return this.strip();
      }, d.prototype.addn = function(C) {
        return this.clone().iaddn(C);
      }, d.prototype.subn = function(C) {
        return this.clone().isubn(C);
      }, d.prototype.iabs = function() {
        return this.negative = 0, this;
      }, d.prototype.abs = function() {
        return this.clone().iabs();
      }, d.prototype._ishlnsubmul = function(C, w, P) {
        var J = C.length + P, se;
        this._expand(J);
        var fe, N = 0;
        for (se = 0; se < C.length; se++) {
          fe = (this.words[se + P] | 0) + N;
          var W = (C.words[se] | 0) * w;
          fe -= W & 67108863, N = (fe >> 26) - (W / 67108864 | 0), this.words[se + P] = fe & 67108863;
        }
        for (; se < this.length - P; se++)
          fe = (this.words[se + P] | 0) + N, N = fe >> 26, this.words[se + P] = fe & 67108863;
        if (N === 0)
          return this.strip();
        for (u(N === -1), N = 0, se = 0; se < this.length; se++)
          fe = -(this.words[se] | 0) + N, N = fe >> 26, this.words[se] = fe & 67108863;
        return this.negative = 1, this.strip();
      }, d.prototype._wordDiv = function(C, w) {
        var P = this.length - C.length, J = this.clone(), se = C, fe = se.words[se.length - 1] | 0, N = this._countBits(fe);
        P = 26 - N, P !== 0 && (se = se.ushln(P), J.iushln(P), fe = se.words[se.length - 1] | 0);
        var W = J.length - se.length, I;
        if (w !== "mod") {
          I = new d(null), I.length = W + 1, I.words = new Array(I.length);
          for (var te = 0; te < I.length; te++)
            I.words[te] = 0;
        }
        var ge = J.clone()._ishlnsubmul(se, 1, W);
        ge.negative === 0 && (J = ge, I && (I.words[W] = 1));
        for (var Pe = W - 1; Pe >= 0; Pe--) {
          var Ke = (J.words[se.length + Pe] | 0) * 67108864 + (J.words[se.length + Pe - 1] | 0);
          for (Ke = Math.min(Ke / fe | 0, 67108863), J._ishlnsubmul(se, Ke, Pe); J.negative !== 0; )
            Ke--, J.negative = 0, J._ishlnsubmul(se, 1, Pe), J.isZero() || (J.negative ^= 1);
          I && (I.words[Pe] = Ke);
        }
        return I && I.strip(), J.strip(), w !== "div" && P !== 0 && J.iushrn(P), {
          div: I || null,
          mod: J
        };
      }, d.prototype.divmod = function(C, w, P) {
        if (u(!C.isZero()), this.isZero())
          return {
            div: new d(0),
            mod: new d(0)
          };
        var J, se, fe;
        return this.negative !== 0 && C.negative === 0 ? (fe = this.neg().divmod(C, w), w !== "mod" && (J = fe.div.neg()), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.iadd(C)), {
          div: J,
          mod: se
        }) : this.negative === 0 && C.negative !== 0 ? (fe = this.divmod(C.neg(), w), w !== "mod" && (J = fe.div.neg()), {
          div: J,
          mod: fe.mod
        }) : this.negative & C.negative ? (fe = this.neg().divmod(C.neg(), w), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.isub(C)), {
          div: fe.div,
          mod: se
        }) : C.length > this.length || this.cmp(C) < 0 ? {
          div: new d(0),
          mod: this
        } : C.length === 1 ? w === "div" ? {
          div: this.divn(C.words[0]),
          mod: null
        } : w === "mod" ? {
          div: null,
          mod: new d(this.modn(C.words[0]))
        } : {
          div: this.divn(C.words[0]),
          mod: new d(this.modn(C.words[0]))
        } : this._wordDiv(C, w);
      }, d.prototype.div = function(C) {
        return this.divmod(C, "div", !1).div;
      }, d.prototype.mod = function(C) {
        return this.divmod(C, "mod", !1).mod;
      }, d.prototype.umod = function(C) {
        return this.divmod(C, "mod", !0).mod;
      }, d.prototype.divRound = function(C) {
        var w = this.divmod(C);
        if (w.mod.isZero())
          return w.div;
        var P = w.div.negative !== 0 ? w.mod.isub(C) : w.mod, J = C.ushrn(1), se = C.andln(1), fe = P.cmp(J);
        return fe < 0 || se === 1 && fe === 0 ? w.div : w.div.negative !== 0 ? w.div.isubn(1) : w.div.iaddn(1);
      }, d.prototype.modn = function(C) {
        u(C <= 67108863);
        for (var w = (1 << 26) % C, P = 0, J = this.length - 1; J >= 0; J--)
          P = (w * P + (this.words[J] | 0)) % C;
        return P;
      }, d.prototype.idivn = function(C) {
        u(C <= 67108863);
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = (this.words[P] | 0) + w * 67108864;
          this.words[P] = J / C | 0, w = J % C;
        }
        return this.strip();
      }, d.prototype.divn = function(C) {
        return this.clone().idivn(C);
      }, d.prototype.egcd = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = new d(0), N = new d(1), W = 0; w.isEven() && P.isEven(); )
          w.iushrn(1), P.iushrn(1), ++W;
        for (var I = P.clone(), te = w.clone(); !w.isZero(); ) {
          for (var ge = 0, Pe = 1; !(w.words[0] & Pe) && ge < 26; ++ge, Pe <<= 1)
            ;
          if (ge > 0)
            for (w.iushrn(ge); ge-- > 0; )
              (J.isOdd() || se.isOdd()) && (J.iadd(I), se.isub(te)), J.iushrn(1), se.iushrn(1);
          for (var Ke = 0, xe = 1; !(P.words[0] & xe) && Ke < 26; ++Ke, xe <<= 1)
            ;
          if (Ke > 0)
            for (P.iushrn(Ke); Ke-- > 0; )
              (fe.isOdd() || N.isOdd()) && (fe.iadd(I), N.isub(te)), fe.iushrn(1), N.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(fe), se.isub(N)) : (P.isub(w), fe.isub(J), N.isub(se));
        }
        return {
          a: fe,
          b: N,
          gcd: P.iushln(W)
        };
      }, d.prototype._invmp = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = P.clone(); w.cmpn(1) > 0 && P.cmpn(1) > 0; ) {
          for (var N = 0, W = 1; !(w.words[0] & W) && N < 26; ++N, W <<= 1)
            ;
          if (N > 0)
            for (w.iushrn(N); N-- > 0; )
              J.isOdd() && J.iadd(fe), J.iushrn(1);
          for (var I = 0, te = 1; !(P.words[0] & te) && I < 26; ++I, te <<= 1)
            ;
          if (I > 0)
            for (P.iushrn(I); I-- > 0; )
              se.isOdd() && se.iadd(fe), se.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(se)) : (P.isub(w), se.isub(J));
        }
        var ge;
        return w.cmpn(1) === 0 ? ge = J : ge = se, ge.cmpn(0) < 0 && ge.iadd(C), ge;
      }, d.prototype.gcd = function(C) {
        if (this.isZero())
          return C.abs();
        if (C.isZero())
          return this.abs();
        var w = this.clone(), P = C.clone();
        w.negative = 0, P.negative = 0;
        for (var J = 0; w.isEven() && P.isEven(); J++)
          w.iushrn(1), P.iushrn(1);
        do {
          for (; w.isEven(); )
            w.iushrn(1);
          for (; P.isEven(); )
            P.iushrn(1);
          var se = w.cmp(P);
          if (se < 0) {
            var fe = w;
            w = P, P = fe;
          } else if (se === 0 || P.cmpn(1) === 0)
            break;
          w.isub(P);
        } while (!0);
        return P.iushln(J);
      }, d.prototype.invm = function(C) {
        return this.egcd(C).a.umod(C);
      }, d.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, d.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, d.prototype.andln = function(C) {
        return this.words[0] & C;
      }, d.prototype.bincn = function(C) {
        u(typeof C == "number");
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return this._expand(P + 1), this.words[P] |= J, this;
        for (var se = J, fe = P; se !== 0 && fe < this.length; fe++) {
          var N = this.words[fe] | 0;
          N += se, se = N >>> 26, N &= 67108863, this.words[fe] = N;
        }
        return se !== 0 && (this.words[fe] = se, this.length++), this;
      }, d.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, d.prototype.cmpn = function(C) {
        var w = C < 0;
        if (this.negative !== 0 && !w)
          return -1;
        if (this.negative === 0 && w)
          return 1;
        this.strip();
        var P;
        if (this.length > 1)
          P = 1;
        else {
          w && (C = -C), u(C <= 67108863, "Number is too big");
          var J = this.words[0] | 0;
          P = J === C ? 0 : J < C ? -1 : 1;
        }
        return this.negative !== 0 ? -P | 0 : P;
      }, d.prototype.cmp = function(C) {
        if (this.negative !== 0 && C.negative === 0)
          return -1;
        if (this.negative === 0 && C.negative !== 0)
          return 1;
        var w = this.ucmp(C);
        return this.negative !== 0 ? -w | 0 : w;
      }, d.prototype.ucmp = function(C) {
        if (this.length > C.length)
          return 1;
        if (this.length < C.length)
          return -1;
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = this.words[P] | 0, se = C.words[P] | 0;
          if (J !== se) {
            J < se ? w = -1 : J > se && (w = 1);
            break;
          }
        }
        return w;
      }, d.prototype.gtn = function(C) {
        return this.cmpn(C) === 1;
      }, d.prototype.gt = function(C) {
        return this.cmp(C) === 1;
      }, d.prototype.gten = function(C) {
        return this.cmpn(C) >= 0;
      }, d.prototype.gte = function(C) {
        return this.cmp(C) >= 0;
      }, d.prototype.ltn = function(C) {
        return this.cmpn(C) === -1;
      }, d.prototype.lt = function(C) {
        return this.cmp(C) === -1;
      }, d.prototype.lten = function(C) {
        return this.cmpn(C) <= 0;
      }, d.prototype.lte = function(C) {
        return this.cmp(C) <= 0;
      }, d.prototype.eqn = function(C) {
        return this.cmpn(C) === 0;
      }, d.prototype.eq = function(C) {
        return this.cmp(C) === 0;
      }, d.red = function(C) {
        return new oe(C);
      }, d.prototype.toRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), u(this.negative === 0, "red works only with positives"), C.convertTo(this)._forceRed(C);
      }, d.prototype.fromRed = function() {
        return u(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, d.prototype._forceRed = function(C) {
        return this.red = C, this;
      }, d.prototype.forceRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), this._forceRed(C);
      }, d.prototype.redAdd = function(C) {
        return u(this.red, "redAdd works only with red numbers"), this.red.add(this, C);
      }, d.prototype.redIAdd = function(C) {
        return u(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, C);
      }, d.prototype.redSub = function(C) {
        return u(this.red, "redSub works only with red numbers"), this.red.sub(this, C);
      }, d.prototype.redISub = function(C) {
        return u(this.red, "redISub works only with red numbers"), this.red.isub(this, C);
      }, d.prototype.redShl = function(C) {
        return u(this.red, "redShl works only with red numbers"), this.red.shl(this, C);
      }, d.prototype.redMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.mul(this, C);
      }, d.prototype.redIMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.imul(this, C);
      }, d.prototype.redSqr = function() {
        return u(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, d.prototype.redISqr = function() {
        return u(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, d.prototype.redSqrt = function() {
        return u(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, d.prototype.redInvm = function() {
        return u(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, d.prototype.redNeg = function() {
        return u(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, d.prototype.redPow = function(C) {
        return u(this.red && !C.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, C);
      };
      var X = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function ee(H, C) {
        this.name = H, this.p = new d(C, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      ee.prototype._tmp = function() {
        var C = new d(null);
        return C.words = new Array(Math.ceil(this.n / 13)), C;
      }, ee.prototype.ireduce = function(C) {
        var w = C, P;
        do
          this.split(w, this.tmp), w = this.imulK(w), w = w.iadd(this.tmp), P = w.bitLength();
        while (P > this.n);
        var J = P < this.n ? -1 : w.ucmp(this.p);
        return J === 0 ? (w.words[0] = 0, w.length = 1) : J > 0 ? w.isub(this.p) : w.strip !== void 0 ? w.strip() : w._strip(), w;
      }, ee.prototype.split = function(C, w) {
        C.iushrn(this.n, 0, w);
      }, ee.prototype.imulK = function(C) {
        return C.imul(this.k);
      };
      function ue() {
        ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(ue, ee), ue.prototype.split = function(C, w) {
        for (var P = 4194303, J = Math.min(C.length, 9), se = 0; se < J; se++)
          w.words[se] = C.words[se];
        if (w.length = J, C.length <= 9) {
          C.words[0] = 0, C.length = 1;
          return;
        }
        var fe = C.words[9];
        for (w.words[w.length++] = fe & P, se = 10; se < C.length; se++) {
          var N = C.words[se] | 0;
          C.words[se - 10] = (N & P) << 4 | fe >>> 22, fe = N;
        }
        fe >>>= 22, C.words[se - 10] = fe, fe === 0 && C.length > 10 ? C.length -= 10 : C.length -= 9;
      }, ue.prototype.imulK = function(C) {
        C.words[C.length] = 0, C.words[C.length + 1] = 0, C.length += 2;
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = C.words[P] | 0;
          w += J * 977, C.words[P] = w & 67108863, w = J * 64 + (w / 67108864 | 0);
        }
        return C.words[C.length - 1] === 0 && (C.length--, C.words[C.length - 1] === 0 && C.length--), C;
      };
      function Q() {
        ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(Q, ee);
      function Y() {
        ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(Y, ee);
      function pe() {
        ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(pe, ee), pe.prototype.imulK = function(C) {
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = (C.words[P] | 0) * 19 + w, se = J & 67108863;
          J >>>= 26, C.words[P] = se, w = J;
        }
        return w !== 0 && (C.words[C.length++] = w), C;
      }, d._prime = function(C) {
        if (X[C])
          return X[C];
        var w;
        if (C === "k256")
          w = new ue();
        else if (C === "p224")
          w = new Q();
        else if (C === "p192")
          w = new Y();
        else if (C === "p25519")
          w = new pe();
        else
          throw new Error("Unknown prime " + C);
        return X[C] = w, w;
      };
      function oe(H) {
        if (typeof H == "string") {
          var C = d._prime(H);
          this.m = C.p, this.prime = C;
        } else
          u(H.gtn(1), "modulus must be greater than 1"), this.m = H, this.prime = null;
      }
      oe.prototype._verify1 = function(C) {
        u(C.negative === 0, "red works only with positives"), u(C.red, "red works only with red numbers");
      }, oe.prototype._verify2 = function(C, w) {
        u((C.negative | w.negative) === 0, "red works only with positives"), u(
          C.red && C.red === w.red,
          "red works only with red numbers"
        );
      }, oe.prototype.imod = function(C) {
        return this.prime ? this.prime.ireduce(C)._forceRed(this) : C.umod(this.m)._forceRed(this);
      }, oe.prototype.neg = function(C) {
        return C.isZero() ? C.clone() : this.m.sub(C)._forceRed(this);
      }, oe.prototype.add = function(C, w) {
        this._verify2(C, w);
        var P = C.add(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P._forceRed(this);
      }, oe.prototype.iadd = function(C, w) {
        this._verify2(C, w);
        var P = C.iadd(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P;
      }, oe.prototype.sub = function(C, w) {
        this._verify2(C, w);
        var P = C.sub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P._forceRed(this);
      }, oe.prototype.isub = function(C, w) {
        this._verify2(C, w);
        var P = C.isub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P;
      }, oe.prototype.shl = function(C, w) {
        return this._verify1(C), this.imod(C.ushln(w));
      }, oe.prototype.imul = function(C, w) {
        return this._verify2(C, w), this.imod(C.imul(w));
      }, oe.prototype.mul = function(C, w) {
        return this._verify2(C, w), this.imod(C.mul(w));
      }, oe.prototype.isqr = function(C) {
        return this.imul(C, C.clone());
      }, oe.prototype.sqr = function(C) {
        return this.mul(C, C);
      }, oe.prototype.sqrt = function(C) {
        if (C.isZero())
          return C.clone();
        var w = this.m.andln(3);
        if (u(w % 2 === 1), w === 3) {
          var P = this.m.add(new d(1)).iushrn(2);
          return this.pow(C, P);
        }
        for (var J = this.m.subn(1), se = 0; !J.isZero() && J.andln(1) === 0; )
          se++, J.iushrn(1);
        u(!J.isZero());
        var fe = new d(1).toRed(this), N = fe.redNeg(), W = this.m.subn(1).iushrn(1), I = this.m.bitLength();
        for (I = new d(2 * I * I).toRed(this); this.pow(I, W).cmp(N) !== 0; )
          I.redIAdd(N);
        for (var te = this.pow(I, J), ge = this.pow(C, J.addn(1).iushrn(1)), Pe = this.pow(C, J), Ke = se; Pe.cmp(fe) !== 0; ) {
          for (var xe = Pe, ze = 0; xe.cmp(fe) !== 0; ze++)
            xe = xe.redSqr();
          u(ze < Ke);
          var nt = this.pow(te, new d(1).iushln(Ke - ze - 1));
          ge = ge.redMul(nt), te = nt.redSqr(), Pe = Pe.redMul(te), Ke = ze;
        }
        return ge;
      }, oe.prototype.invm = function(C) {
        var w = C._invmp(this.m);
        return w.negative !== 0 ? (w.negative = 0, this.imod(w).redNeg()) : this.imod(w);
      }, oe.prototype.pow = function(C, w) {
        if (w.isZero())
          return new d(1).toRed(this);
        if (w.cmpn(1) === 0)
          return C.clone();
        var P = 4, J = new Array(1 << P);
        J[0] = new d(1).toRed(this), J[1] = C;
        for (var se = 2; se < J.length; se++)
          J[se] = this.mul(J[se - 1], C);
        var fe = J[0], N = 0, W = 0, I = w.bitLength() % 26;
        for (I === 0 && (I = 26), se = w.length - 1; se >= 0; se--) {
          for (var te = w.words[se], ge = I - 1; ge >= 0; ge--) {
            var Pe = te >> ge & 1;
            if (fe !== J[0] && (fe = this.sqr(fe)), Pe === 0 && N === 0) {
              W = 0;
              continue;
            }
            N <<= 1, N |= Pe, W++, !(W !== P && (se !== 0 || ge !== 0)) && (fe = this.mul(fe, J[N]), W = 0, N = 0);
          }
          I = 26;
        }
        return fe;
      }, oe.prototype.convertTo = function(C) {
        var w = C.umod(this.m);
        return w === C ? w.clone() : w;
      }, oe.prototype.convertFrom = function(C) {
        var w = C.clone();
        return w.red = null, w;
      }, d.mont = function(C) {
        return new ne(C);
      };
      function ne(H) {
        oe.call(this, H), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(ne, oe), ne.prototype.convertTo = function(C) {
        return this.imod(C.ushln(this.shift));
      }, ne.prototype.convertFrom = function(C) {
        var w = this.imod(C.mul(this.rinv));
        return w.red = null, w;
      }, ne.prototype.imul = function(C, w) {
        if (C.isZero() || w.isZero())
          return C.words[0] = 0, C.length = 1, C;
        var P = C.imul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.mul = function(C, w) {
        if (C.isZero() || w.isZero())
          return new d(0)._forceRed(this);
        var P = C.mul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.invm = function(C) {
        var w = this.imod(C._invmp(this.m).mul(this.r2));
        return w._forceRed(this);
      };
    })(e, commonjsGlobal);
  }(bn$6)), bn$6.exports;
}
var bn$5 = { exports: {} };
bn$5.exports;
var hasRequiredBn$3;
function requireBn$3() {
  return hasRequiredBn$3 || (hasRequiredBn$3 = 1, function(e) {
    (function(n, o) {
      function u(H, C) {
        if (!H)
          throw new Error(C || "Assertion failed");
      }
      function c(H, C) {
        H.super_ = C;
        var w = function() {
        };
        w.prototype = C.prototype, H.prototype = new w(), H.prototype.constructor = H;
      }
      function d(H, C, w) {
        if (d.isBN(H))
          return H;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, H !== null && ((C === "le" || C === "be") && (w = C, C = 10), this._init(H || 0, C || 10, w || "be"));
      }
      typeof n == "object" ? n.exports = d : o.BN = d, d.BN = d, d.wordSize = 26;
      var m;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = require$$0$3.Buffer;
      } catch {
      }
      d.isBN = function(C) {
        return C instanceof d ? !0 : C !== null && typeof C == "object" && C.constructor.wordSize === d.wordSize && Array.isArray(C.words);
      }, d.max = function(C, w) {
        return C.cmp(w) > 0 ? C : w;
      }, d.min = function(C, w) {
        return C.cmp(w) < 0 ? C : w;
      }, d.prototype._init = function(C, w, P) {
        if (typeof C == "number")
          return this._initNumber(C, w, P);
        if (typeof C == "object")
          return this._initArray(C, w, P);
        w === "hex" && (w = 16), u(w === (w | 0) && w >= 2 && w <= 36), C = C.toString().replace(/\s+/g, "");
        var J = 0;
        C[0] === "-" && (J++, this.negative = 1), J < C.length && (w === 16 ? this._parseHex(C, J, P) : (this._parseBase(C, w, J), P === "le" && this._initArray(this.toArray(), w, P)));
      }, d.prototype._initNumber = function(C, w, P) {
        C < 0 && (this.negative = 1, C = -C), C < 67108864 ? (this.words = [C & 67108863], this.length = 1) : C < 4503599627370496 ? (this.words = [
          C & 67108863,
          C / 67108864 & 67108863
        ], this.length = 2) : (u(C < 9007199254740992), this.words = [
          C & 67108863,
          C / 67108864 & 67108863,
          1
        ], this.length = 3), P === "le" && this._initArray(this.toArray(), w, P);
      }, d.prototype._initArray = function(C, w, P) {
        if (u(typeof C.length == "number"), C.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(C.length / 3), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se, fe, N = 0;
        if (P === "be")
          for (J = C.length - 1, se = 0; J >= 0; J -= 3)
            fe = C[J] | C[J - 1] << 8 | C[J - 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        else if (P === "le")
          for (J = 0, se = 0; J < C.length; J += 3)
            fe = C[J] | C[J + 1] << 8 | C[J + 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        return this.strip();
      };
      function v(H, C) {
        var w = H.charCodeAt(C);
        return w >= 65 && w <= 70 ? w - 55 : w >= 97 && w <= 102 ? w - 87 : w - 48 & 15;
      }
      function S(H, C, w) {
        var P = v(H, w);
        return w - 1 >= C && (P |= v(H, w - 1) << 4), P;
      }
      d.prototype._parseHex = function(C, w, P) {
        this.length = Math.ceil((C.length - w) / 6), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se = 0, fe = 0, N;
        if (P === "be")
          for (J = C.length - 1; J >= w; J -= 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        else {
          var W = C.length - w;
          for (J = W % 2 === 0 ? w + 1 : w; J < C.length; J += 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        }
        this.strip();
      };
      function $(H, C, w, P) {
        for (var J = 0, se = Math.min(H.length, w), fe = C; fe < se; fe++) {
          var N = H.charCodeAt(fe) - 48;
          J *= P, N >= 49 ? J += N - 49 + 10 : N >= 17 ? J += N - 17 + 10 : J += N;
        }
        return J;
      }
      d.prototype._parseBase = function(C, w, P) {
        this.words = [0], this.length = 1;
        for (var J = 0, se = 1; se <= 67108863; se *= w)
          J++;
        J--, se = se / w | 0;
        for (var fe = C.length - P, N = fe % J, W = Math.min(fe, fe - N) + P, I = 0, te = P; te < W; te += J)
          I = $(C, te, te + J, w), this.imuln(se), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        if (N !== 0) {
          var ge = 1;
          for (I = $(C, te, C.length, w), te = 0; te < N; te++)
            ge *= w;
          this.imuln(ge), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        }
        this.strip();
      }, d.prototype.copy = function(C) {
        C.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          C.words[w] = this.words[w];
        C.length = this.length, C.negative = this.negative, C.red = this.red;
      }, d.prototype.clone = function() {
        var C = new d(null);
        return this.copy(C), C;
      }, d.prototype._expand = function(C) {
        for (; this.length < C; )
          this.words[this.length++] = 0;
        return this;
      }, d.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, d.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, d.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var E = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], O = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], T = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      d.prototype.toString = function(C, w) {
        C = C || 10, w = w | 0 || 1;
        var P;
        if (C === 16 || C === "hex") {
          P = "";
          for (var J = 0, se = 0, fe = 0; fe < this.length; fe++) {
            var N = this.words[fe], W = ((N << J | se) & 16777215).toString(16);
            se = N >>> 24 - J & 16777215, se !== 0 || fe !== this.length - 1 ? P = E[6 - W.length] + W + P : P = W + P, J += 2, J >= 26 && (J -= 26, fe--);
          }
          for (se !== 0 && (P = se.toString(16) + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        if (C === (C | 0) && C >= 2 && C <= 36) {
          var I = O[C], te = T[C];
          P = "";
          var ge = this.clone();
          for (ge.negative = 0; !ge.isZero(); ) {
            var Pe = ge.modn(te).toString(C);
            ge = ge.idivn(te), ge.isZero() ? P = Pe + P : P = E[I - Pe.length] + Pe + P;
          }
          for (this.isZero() && (P = "0" + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        u(!1, "Base should be between 2 and 36");
      }, d.prototype.toNumber = function() {
        var C = this.words[0];
        return this.length === 2 ? C += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? C += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && u(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -C : C;
      }, d.prototype.toJSON = function() {
        return this.toString(16);
      }, d.prototype.toBuffer = function(C, w) {
        return u(typeof m < "u"), this.toArrayLike(m, C, w);
      }, d.prototype.toArray = function(C, w) {
        return this.toArrayLike(Array, C, w);
      }, d.prototype.toArrayLike = function(C, w, P) {
        var J = this.byteLength(), se = P || Math.max(1, J);
        u(J <= se, "byte array longer than desired length"), u(se > 0, "Requested array length <= 0"), this.strip();
        var fe = w === "le", N = new C(se), W, I, te = this.clone();
        if (fe) {
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[I] = W;
          for (; I < se; I++)
            N[I] = 0;
        } else {
          for (I = 0; I < se - J; I++)
            N[I] = 0;
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[se - I - 1] = W;
        }
        return N;
      }, Math.clz32 ? d.prototype._countBits = function(C) {
        return 32 - Math.clz32(C);
      } : d.prototype._countBits = function(C) {
        var w = C, P = 0;
        return w >= 4096 && (P += 13, w >>>= 13), w >= 64 && (P += 7, w >>>= 7), w >= 8 && (P += 4, w >>>= 4), w >= 2 && (P += 2, w >>>= 2), P + w;
      }, d.prototype._zeroBits = function(C) {
        if (C === 0)
          return 26;
        var w = C, P = 0;
        return w & 8191 || (P += 13, w >>>= 13), w & 127 || (P += 7, w >>>= 7), w & 15 || (P += 4, w >>>= 4), w & 3 || (P += 2, w >>>= 2), w & 1 || P++, P;
      }, d.prototype.bitLength = function() {
        var C = this.words[this.length - 1], w = this._countBits(C);
        return (this.length - 1) * 26 + w;
      };
      function y(H) {
        for (var C = new Array(H.bitLength()), w = 0; w < C.length; w++) {
          var P = w / 26 | 0, J = w % 26;
          C[w] = (H.words[P] & 1 << J) >>> J;
        }
        return C;
      }
      d.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var C = 0, w = 0; w < this.length; w++) {
          var P = this._zeroBits(this.words[w]);
          if (C += P, P !== 26)
            break;
        }
        return C;
      }, d.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, d.prototype.toTwos = function(C) {
        return this.negative !== 0 ? this.abs().inotn(C).iaddn(1) : this.clone();
      }, d.prototype.fromTwos = function(C) {
        return this.testn(C - 1) ? this.notn(C).iaddn(1).ineg() : this.clone();
      }, d.prototype.isNeg = function() {
        return this.negative !== 0;
      }, d.prototype.neg = function() {
        return this.clone().ineg();
      }, d.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, d.prototype.iuor = function(C) {
        for (; this.length < C.length; )
          this.words[this.length++] = 0;
        for (var w = 0; w < C.length; w++)
          this.words[w] = this.words[w] | C.words[w];
        return this.strip();
      }, d.prototype.ior = function(C) {
        return u((this.negative | C.negative) === 0), this.iuor(C);
      }, d.prototype.or = function(C) {
        return this.length > C.length ? this.clone().ior(C) : C.clone().ior(this);
      }, d.prototype.uor = function(C) {
        return this.length > C.length ? this.clone().iuor(C) : C.clone().iuor(this);
      }, d.prototype.iuand = function(C) {
        var w;
        this.length > C.length ? w = C : w = this;
        for (var P = 0; P < w.length; P++)
          this.words[P] = this.words[P] & C.words[P];
        return this.length = w.length, this.strip();
      }, d.prototype.iand = function(C) {
        return u((this.negative | C.negative) === 0), this.iuand(C);
      }, d.prototype.and = function(C) {
        return this.length > C.length ? this.clone().iand(C) : C.clone().iand(this);
      }, d.prototype.uand = function(C) {
        return this.length > C.length ? this.clone().iuand(C) : C.clone().iuand(this);
      }, d.prototype.iuxor = function(C) {
        var w, P;
        this.length > C.length ? (w = this, P = C) : (w = C, P = this);
        for (var J = 0; J < P.length; J++)
          this.words[J] = w.words[J] ^ P.words[J];
        if (this !== w)
          for (; J < w.length; J++)
            this.words[J] = w.words[J];
        return this.length = w.length, this.strip();
      }, d.prototype.ixor = function(C) {
        return u((this.negative | C.negative) === 0), this.iuxor(C);
      }, d.prototype.xor = function(C) {
        return this.length > C.length ? this.clone().ixor(C) : C.clone().ixor(this);
      }, d.prototype.uxor = function(C) {
        return this.length > C.length ? this.clone().iuxor(C) : C.clone().iuxor(this);
      }, d.prototype.inotn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = Math.ceil(C / 26) | 0, P = C % 26;
        this._expand(w), P > 0 && w--;
        for (var J = 0; J < w; J++)
          this.words[J] = ~this.words[J] & 67108863;
        return P > 0 && (this.words[J] = ~this.words[J] & 67108863 >> 26 - P), this.strip();
      }, d.prototype.notn = function(C) {
        return this.clone().inotn(C);
      }, d.prototype.setn = function(C, w) {
        u(typeof C == "number" && C >= 0);
        var P = C / 26 | 0, J = C % 26;
        return this._expand(P + 1), w ? this.words[P] = this.words[P] | 1 << J : this.words[P] = this.words[P] & ~(1 << J), this.strip();
      }, d.prototype.iadd = function(C) {
        var w;
        if (this.negative !== 0 && C.negative === 0)
          return this.negative = 0, w = this.isub(C), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && C.negative !== 0)
          return C.negative = 0, w = this.isub(C), C.negative = 1, w._normSign();
        var P, J;
        this.length > C.length ? (P = this, J = C) : (P = C, J = this);
        for (var se = 0, fe = 0; fe < J.length; fe++)
          w = (P.words[fe] | 0) + (J.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        for (; se !== 0 && fe < P.length; fe++)
          w = (P.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        if (this.length = P.length, se !== 0)
          this.words[this.length] = se, this.length++;
        else if (P !== this)
          for (; fe < P.length; fe++)
            this.words[fe] = P.words[fe];
        return this;
      }, d.prototype.add = function(C) {
        var w;
        return C.negative !== 0 && this.negative === 0 ? (C.negative = 0, w = this.sub(C), C.negative ^= 1, w) : C.negative === 0 && this.negative !== 0 ? (this.negative = 0, w = C.sub(this), this.negative = 1, w) : this.length > C.length ? this.clone().iadd(C) : C.clone().iadd(this);
      }, d.prototype.isub = function(C) {
        if (C.negative !== 0) {
          C.negative = 0;
          var w = this.iadd(C);
          return C.negative = 1, w._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(C), this.negative = 1, this._normSign();
        var P = this.cmp(C);
        if (P === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var J, se;
        P > 0 ? (J = this, se = C) : (J = C, se = this);
        for (var fe = 0, N = 0; N < se.length; N++)
          w = (J.words[N] | 0) - (se.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        for (; fe !== 0 && N < J.length; N++)
          w = (J.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        if (fe === 0 && N < J.length && J !== this)
          for (; N < J.length; N++)
            this.words[N] = J.words[N];
        return this.length = Math.max(this.length, N), J !== this && (this.negative = 1), this.strip();
      }, d.prototype.sub = function(C) {
        return this.clone().isub(C);
      };
      function V(H, C, w) {
        w.negative = C.negative ^ H.negative;
        var P = H.length + C.length | 0;
        w.length = P, P = P - 1 | 0;
        var J = H.words[0] | 0, se = C.words[0] | 0, fe = J * se, N = fe & 67108863, W = fe / 67108864 | 0;
        w.words[0] = N;
        for (var I = 1; I < P; I++) {
          for (var te = W >>> 26, ge = W & 67108863, Pe = Math.min(I, C.length - 1), Ke = Math.max(0, I - H.length + 1); Ke <= Pe; Ke++) {
            var xe = I - Ke | 0;
            J = H.words[xe] | 0, se = C.words[Ke] | 0, fe = J * se + ge, te += fe / 67108864 | 0, ge = fe & 67108863;
          }
          w.words[I] = ge | 0, W = te | 0;
        }
        return W !== 0 ? w.words[I] = W | 0 : w.length--, w.strip();
      }
      var M = function(C, w, P) {
        var J = C.words, se = w.words, fe = P.words, N = 0, W, I, te, ge = J[0] | 0, Pe = ge & 8191, Ke = ge >>> 13, xe = J[1] | 0, ze = xe & 8191, nt = xe >>> 13, Qt = J[2] | 0, Et = Qt & 8191, zt = Qt >>> 13, Nt = J[3] | 0, pt = Nt & 8191, at = Nt >>> 13, kt = J[4] | 0, Ut = kt & 8191, dn = kt >>> 13, En = J[5] | 0, Ht = En & 8191, Xt = En >>> 13, On = J[6] | 0, sn = On & 8191, At = On >>> 13, hn = J[7] | 0, $t = hn & 8191, Lt = hn >>> 13, Qn = J[8] | 0, ce = Qn & 8191, Ze = Qn >>> 13, ft = J[9] | 0, It = ft & 8191, rn = ft >>> 13, Ln = se[0] | 0, Pn = Ln & 8191, Ae = Ln >>> 13, Me = se[1] | 0, He = Me & 8191, cn = Me >>> 13, Wt = se[2] | 0, yn = Wt & 8191, pr = Wt >>> 13, Uo = se[3] | 0, ar = Uo & 8191, Sr = Uo >>> 13, Jo = se[4] | 0, fr = Jo & 8191, Er = Jo >>> 13, vo = se[5] | 0, lr = vo & 8191, $r = vo >>> 13, Wo = se[6] | 0, yr = Wo & 8191, Dr = Wo >>> 13, Zo = se[7] | 0, dr = Zo & 8191, Br = Zo >>> 13, Qo = se[8] | 0, tr = Qo & 8191, Mr = Qo >>> 13, qo = se[9] | 0, hr = qo & 8191, Or = qo >>> 13;
        P.negative = C.negative ^ w.negative, P.length = 19, W = Math.imul(Pe, Pn), I = Math.imul(Pe, Ae), I = I + Math.imul(Ke, Pn) | 0, te = Math.imul(Ke, Ae);
        var Fo = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fo >>> 26) | 0, Fo &= 67108863, W = Math.imul(ze, Pn), I = Math.imul(ze, Ae), I = I + Math.imul(nt, Pn) | 0, te = Math.imul(nt, Ae), W = W + Math.imul(Pe, He) | 0, I = I + Math.imul(Pe, cn) | 0, I = I + Math.imul(Ke, He) | 0, te = te + Math.imul(Ke, cn) | 0;
        var No = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, W = Math.imul(Et, Pn), I = Math.imul(Et, Ae), I = I + Math.imul(zt, Pn) | 0, te = Math.imul(zt, Ae), W = W + Math.imul(ze, He) | 0, I = I + Math.imul(ze, cn) | 0, I = I + Math.imul(nt, He) | 0, te = te + Math.imul(nt, cn) | 0, W = W + Math.imul(Pe, yn) | 0, I = I + Math.imul(Pe, pr) | 0, I = I + Math.imul(Ke, yn) | 0, te = te + Math.imul(Ke, pr) | 0;
        var di = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, W = Math.imul(pt, Pn), I = Math.imul(pt, Ae), I = I + Math.imul(at, Pn) | 0, te = Math.imul(at, Ae), W = W + Math.imul(Et, He) | 0, I = I + Math.imul(Et, cn) | 0, I = I + Math.imul(zt, He) | 0, te = te + Math.imul(zt, cn) | 0, W = W + Math.imul(ze, yn) | 0, I = I + Math.imul(ze, pr) | 0, I = I + Math.imul(nt, yn) | 0, te = te + Math.imul(nt, pr) | 0, W = W + Math.imul(Pe, ar) | 0, I = I + Math.imul(Pe, Sr) | 0, I = I + Math.imul(Ke, ar) | 0, te = te + Math.imul(Ke, Sr) | 0;
        var gi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, W = Math.imul(Ut, Pn), I = Math.imul(Ut, Ae), I = I + Math.imul(dn, Pn) | 0, te = Math.imul(dn, Ae), W = W + Math.imul(pt, He) | 0, I = I + Math.imul(pt, cn) | 0, I = I + Math.imul(at, He) | 0, te = te + Math.imul(at, cn) | 0, W = W + Math.imul(Et, yn) | 0, I = I + Math.imul(Et, pr) | 0, I = I + Math.imul(zt, yn) | 0, te = te + Math.imul(zt, pr) | 0, W = W + Math.imul(ze, ar) | 0, I = I + Math.imul(ze, Sr) | 0, I = I + Math.imul(nt, ar) | 0, te = te + Math.imul(nt, Sr) | 0, W = W + Math.imul(Pe, fr) | 0, I = I + Math.imul(Pe, Er) | 0, I = I + Math.imul(Ke, fr) | 0, te = te + Math.imul(Ke, Er) | 0;
        var ai = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, W = Math.imul(Ht, Pn), I = Math.imul(Ht, Ae), I = I + Math.imul(Xt, Pn) | 0, te = Math.imul(Xt, Ae), W = W + Math.imul(Ut, He) | 0, I = I + Math.imul(Ut, cn) | 0, I = I + Math.imul(dn, He) | 0, te = te + Math.imul(dn, cn) | 0, W = W + Math.imul(pt, yn) | 0, I = I + Math.imul(pt, pr) | 0, I = I + Math.imul(at, yn) | 0, te = te + Math.imul(at, pr) | 0, W = W + Math.imul(Et, ar) | 0, I = I + Math.imul(Et, Sr) | 0, I = I + Math.imul(zt, ar) | 0, te = te + Math.imul(zt, Sr) | 0, W = W + Math.imul(ze, fr) | 0, I = I + Math.imul(ze, Er) | 0, I = I + Math.imul(nt, fr) | 0, te = te + Math.imul(nt, Er) | 0, W = W + Math.imul(Pe, lr) | 0, I = I + Math.imul(Pe, $r) | 0, I = I + Math.imul(Ke, lr) | 0, te = te + Math.imul(Ke, $r) | 0;
        var ui = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, W = Math.imul(sn, Pn), I = Math.imul(sn, Ae), I = I + Math.imul(At, Pn) | 0, te = Math.imul(At, Ae), W = W + Math.imul(Ht, He) | 0, I = I + Math.imul(Ht, cn) | 0, I = I + Math.imul(Xt, He) | 0, te = te + Math.imul(Xt, cn) | 0, W = W + Math.imul(Ut, yn) | 0, I = I + Math.imul(Ut, pr) | 0, I = I + Math.imul(dn, yn) | 0, te = te + Math.imul(dn, pr) | 0, W = W + Math.imul(pt, ar) | 0, I = I + Math.imul(pt, Sr) | 0, I = I + Math.imul(at, ar) | 0, te = te + Math.imul(at, Sr) | 0, W = W + Math.imul(Et, fr) | 0, I = I + Math.imul(Et, Er) | 0, I = I + Math.imul(zt, fr) | 0, te = te + Math.imul(zt, Er) | 0, W = W + Math.imul(ze, lr) | 0, I = I + Math.imul(ze, $r) | 0, I = I + Math.imul(nt, lr) | 0, te = te + Math.imul(nt, $r) | 0, W = W + Math.imul(Pe, yr) | 0, I = I + Math.imul(Pe, Dr) | 0, I = I + Math.imul(Ke, yr) | 0, te = te + Math.imul(Ke, Dr) | 0;
        var hi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (hi >>> 26) | 0, hi &= 67108863, W = Math.imul($t, Pn), I = Math.imul($t, Ae), I = I + Math.imul(Lt, Pn) | 0, te = Math.imul(Lt, Ae), W = W + Math.imul(sn, He) | 0, I = I + Math.imul(sn, cn) | 0, I = I + Math.imul(At, He) | 0, te = te + Math.imul(At, cn) | 0, W = W + Math.imul(Ht, yn) | 0, I = I + Math.imul(Ht, pr) | 0, I = I + Math.imul(Xt, yn) | 0, te = te + Math.imul(Xt, pr) | 0, W = W + Math.imul(Ut, ar) | 0, I = I + Math.imul(Ut, Sr) | 0, I = I + Math.imul(dn, ar) | 0, te = te + Math.imul(dn, Sr) | 0, W = W + Math.imul(pt, fr) | 0, I = I + Math.imul(pt, Er) | 0, I = I + Math.imul(at, fr) | 0, te = te + Math.imul(at, Er) | 0, W = W + Math.imul(Et, lr) | 0, I = I + Math.imul(Et, $r) | 0, I = I + Math.imul(zt, lr) | 0, te = te + Math.imul(zt, $r) | 0, W = W + Math.imul(ze, yr) | 0, I = I + Math.imul(ze, Dr) | 0, I = I + Math.imul(nt, yr) | 0, te = te + Math.imul(nt, Dr) | 0, W = W + Math.imul(Pe, dr) | 0, I = I + Math.imul(Pe, Br) | 0, I = I + Math.imul(Ke, dr) | 0, te = te + Math.imul(Ke, Br) | 0;
        var bi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, W = Math.imul(ce, Pn), I = Math.imul(ce, Ae), I = I + Math.imul(Ze, Pn) | 0, te = Math.imul(Ze, Ae), W = W + Math.imul($t, He) | 0, I = I + Math.imul($t, cn) | 0, I = I + Math.imul(Lt, He) | 0, te = te + Math.imul(Lt, cn) | 0, W = W + Math.imul(sn, yn) | 0, I = I + Math.imul(sn, pr) | 0, I = I + Math.imul(At, yn) | 0, te = te + Math.imul(At, pr) | 0, W = W + Math.imul(Ht, ar) | 0, I = I + Math.imul(Ht, Sr) | 0, I = I + Math.imul(Xt, ar) | 0, te = te + Math.imul(Xt, Sr) | 0, W = W + Math.imul(Ut, fr) | 0, I = I + Math.imul(Ut, Er) | 0, I = I + Math.imul(dn, fr) | 0, te = te + Math.imul(dn, Er) | 0, W = W + Math.imul(pt, lr) | 0, I = I + Math.imul(pt, $r) | 0, I = I + Math.imul(at, lr) | 0, te = te + Math.imul(at, $r) | 0, W = W + Math.imul(Et, yr) | 0, I = I + Math.imul(Et, Dr) | 0, I = I + Math.imul(zt, yr) | 0, te = te + Math.imul(zt, Dr) | 0, W = W + Math.imul(ze, dr) | 0, I = I + Math.imul(ze, Br) | 0, I = I + Math.imul(nt, dr) | 0, te = te + Math.imul(nt, Br) | 0, W = W + Math.imul(Pe, tr) | 0, I = I + Math.imul(Pe, Mr) | 0, I = I + Math.imul(Ke, tr) | 0, te = te + Math.imul(Ke, Mr) | 0;
        var ii = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, W = Math.imul(It, Pn), I = Math.imul(It, Ae), I = I + Math.imul(rn, Pn) | 0, te = Math.imul(rn, Ae), W = W + Math.imul(ce, He) | 0, I = I + Math.imul(ce, cn) | 0, I = I + Math.imul(Ze, He) | 0, te = te + Math.imul(Ze, cn) | 0, W = W + Math.imul($t, yn) | 0, I = I + Math.imul($t, pr) | 0, I = I + Math.imul(Lt, yn) | 0, te = te + Math.imul(Lt, pr) | 0, W = W + Math.imul(sn, ar) | 0, I = I + Math.imul(sn, Sr) | 0, I = I + Math.imul(At, ar) | 0, te = te + Math.imul(At, Sr) | 0, W = W + Math.imul(Ht, fr) | 0, I = I + Math.imul(Ht, Er) | 0, I = I + Math.imul(Xt, fr) | 0, te = te + Math.imul(Xt, Er) | 0, W = W + Math.imul(Ut, lr) | 0, I = I + Math.imul(Ut, $r) | 0, I = I + Math.imul(dn, lr) | 0, te = te + Math.imul(dn, $r) | 0, W = W + Math.imul(pt, yr) | 0, I = I + Math.imul(pt, Dr) | 0, I = I + Math.imul(at, yr) | 0, te = te + Math.imul(at, Dr) | 0, W = W + Math.imul(Et, dr) | 0, I = I + Math.imul(Et, Br) | 0, I = I + Math.imul(zt, dr) | 0, te = te + Math.imul(zt, Br) | 0, W = W + Math.imul(ze, tr) | 0, I = I + Math.imul(ze, Mr) | 0, I = I + Math.imul(nt, tr) | 0, te = te + Math.imul(nt, Mr) | 0, W = W + Math.imul(Pe, hr) | 0, I = I + Math.imul(Pe, Or) | 0, I = I + Math.imul(Ke, hr) | 0, te = te + Math.imul(Ke, Or) | 0;
        var pi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (pi >>> 26) | 0, pi &= 67108863, W = Math.imul(It, He), I = Math.imul(It, cn), I = I + Math.imul(rn, He) | 0, te = Math.imul(rn, cn), W = W + Math.imul(ce, yn) | 0, I = I + Math.imul(ce, pr) | 0, I = I + Math.imul(Ze, yn) | 0, te = te + Math.imul(Ze, pr) | 0, W = W + Math.imul($t, ar) | 0, I = I + Math.imul($t, Sr) | 0, I = I + Math.imul(Lt, ar) | 0, te = te + Math.imul(Lt, Sr) | 0, W = W + Math.imul(sn, fr) | 0, I = I + Math.imul(sn, Er) | 0, I = I + Math.imul(At, fr) | 0, te = te + Math.imul(At, Er) | 0, W = W + Math.imul(Ht, lr) | 0, I = I + Math.imul(Ht, $r) | 0, I = I + Math.imul(Xt, lr) | 0, te = te + Math.imul(Xt, $r) | 0, W = W + Math.imul(Ut, yr) | 0, I = I + Math.imul(Ut, Dr) | 0, I = I + Math.imul(dn, yr) | 0, te = te + Math.imul(dn, Dr) | 0, W = W + Math.imul(pt, dr) | 0, I = I + Math.imul(pt, Br) | 0, I = I + Math.imul(at, dr) | 0, te = te + Math.imul(at, Br) | 0, W = W + Math.imul(Et, tr) | 0, I = I + Math.imul(Et, Mr) | 0, I = I + Math.imul(zt, tr) | 0, te = te + Math.imul(zt, Mr) | 0, W = W + Math.imul(ze, hr) | 0, I = I + Math.imul(ze, Or) | 0, I = I + Math.imul(nt, hr) | 0, te = te + Math.imul(nt, Or) | 0;
        var Ci = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, W = Math.imul(It, yn), I = Math.imul(It, pr), I = I + Math.imul(rn, yn) | 0, te = Math.imul(rn, pr), W = W + Math.imul(ce, ar) | 0, I = I + Math.imul(ce, Sr) | 0, I = I + Math.imul(Ze, ar) | 0, te = te + Math.imul(Ze, Sr) | 0, W = W + Math.imul($t, fr) | 0, I = I + Math.imul($t, Er) | 0, I = I + Math.imul(Lt, fr) | 0, te = te + Math.imul(Lt, Er) | 0, W = W + Math.imul(sn, lr) | 0, I = I + Math.imul(sn, $r) | 0, I = I + Math.imul(At, lr) | 0, te = te + Math.imul(At, $r) | 0, W = W + Math.imul(Ht, yr) | 0, I = I + Math.imul(Ht, Dr) | 0, I = I + Math.imul(Xt, yr) | 0, te = te + Math.imul(Xt, Dr) | 0, W = W + Math.imul(Ut, dr) | 0, I = I + Math.imul(Ut, Br) | 0, I = I + Math.imul(dn, dr) | 0, te = te + Math.imul(dn, Br) | 0, W = W + Math.imul(pt, tr) | 0, I = I + Math.imul(pt, Mr) | 0, I = I + Math.imul(at, tr) | 0, te = te + Math.imul(at, Mr) | 0, W = W + Math.imul(Et, hr) | 0, I = I + Math.imul(Et, Or) | 0, I = I + Math.imul(zt, hr) | 0, te = te + Math.imul(zt, Or) | 0;
        var _i = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (_i >>> 26) | 0, _i &= 67108863, W = Math.imul(It, ar), I = Math.imul(It, Sr), I = I + Math.imul(rn, ar) | 0, te = Math.imul(rn, Sr), W = W + Math.imul(ce, fr) | 0, I = I + Math.imul(ce, Er) | 0, I = I + Math.imul(Ze, fr) | 0, te = te + Math.imul(Ze, Er) | 0, W = W + Math.imul($t, lr) | 0, I = I + Math.imul($t, $r) | 0, I = I + Math.imul(Lt, lr) | 0, te = te + Math.imul(Lt, $r) | 0, W = W + Math.imul(sn, yr) | 0, I = I + Math.imul(sn, Dr) | 0, I = I + Math.imul(At, yr) | 0, te = te + Math.imul(At, Dr) | 0, W = W + Math.imul(Ht, dr) | 0, I = I + Math.imul(Ht, Br) | 0, I = I + Math.imul(Xt, dr) | 0, te = te + Math.imul(Xt, Br) | 0, W = W + Math.imul(Ut, tr) | 0, I = I + Math.imul(Ut, Mr) | 0, I = I + Math.imul(dn, tr) | 0, te = te + Math.imul(dn, Mr) | 0, W = W + Math.imul(pt, hr) | 0, I = I + Math.imul(pt, Or) | 0, I = I + Math.imul(at, hr) | 0, te = te + Math.imul(at, Or) | 0;
        var xn = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, W = Math.imul(It, fr), I = Math.imul(It, Er), I = I + Math.imul(rn, fr) | 0, te = Math.imul(rn, Er), W = W + Math.imul(ce, lr) | 0, I = I + Math.imul(ce, $r) | 0, I = I + Math.imul(Ze, lr) | 0, te = te + Math.imul(Ze, $r) | 0, W = W + Math.imul($t, yr) | 0, I = I + Math.imul($t, Dr) | 0, I = I + Math.imul(Lt, yr) | 0, te = te + Math.imul(Lt, Dr) | 0, W = W + Math.imul(sn, dr) | 0, I = I + Math.imul(sn, Br) | 0, I = I + Math.imul(At, dr) | 0, te = te + Math.imul(At, Br) | 0, W = W + Math.imul(Ht, tr) | 0, I = I + Math.imul(Ht, Mr) | 0, I = I + Math.imul(Xt, tr) | 0, te = te + Math.imul(Xt, Mr) | 0, W = W + Math.imul(Ut, hr) | 0, I = I + Math.imul(Ut, Or) | 0, I = I + Math.imul(dn, hr) | 0, te = te + Math.imul(dn, Or) | 0;
        var sr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (sr >>> 26) | 0, sr &= 67108863, W = Math.imul(It, lr), I = Math.imul(It, $r), I = I + Math.imul(rn, lr) | 0, te = Math.imul(rn, $r), W = W + Math.imul(ce, yr) | 0, I = I + Math.imul(ce, Dr) | 0, I = I + Math.imul(Ze, yr) | 0, te = te + Math.imul(Ze, Dr) | 0, W = W + Math.imul($t, dr) | 0, I = I + Math.imul($t, Br) | 0, I = I + Math.imul(Lt, dr) | 0, te = te + Math.imul(Lt, Br) | 0, W = W + Math.imul(sn, tr) | 0, I = I + Math.imul(sn, Mr) | 0, I = I + Math.imul(At, tr) | 0, te = te + Math.imul(At, Mr) | 0, W = W + Math.imul(Ht, hr) | 0, I = I + Math.imul(Ht, Or) | 0, I = I + Math.imul(Xt, hr) | 0, te = te + Math.imul(Xt, Or) | 0;
        var Nr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Nr >>> 26) | 0, Nr &= 67108863, W = Math.imul(It, yr), I = Math.imul(It, Dr), I = I + Math.imul(rn, yr) | 0, te = Math.imul(rn, Dr), W = W + Math.imul(ce, dr) | 0, I = I + Math.imul(ce, Br) | 0, I = I + Math.imul(Ze, dr) | 0, te = te + Math.imul(Ze, Br) | 0, W = W + Math.imul($t, tr) | 0, I = I + Math.imul($t, Mr) | 0, I = I + Math.imul(Lt, tr) | 0, te = te + Math.imul(Lt, Mr) | 0, W = W + Math.imul(sn, hr) | 0, I = I + Math.imul(sn, Or) | 0, I = I + Math.imul(At, hr) | 0, te = te + Math.imul(At, Or) | 0;
        var vr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, W = Math.imul(It, dr), I = Math.imul(It, Br), I = I + Math.imul(rn, dr) | 0, te = Math.imul(rn, Br), W = W + Math.imul(ce, tr) | 0, I = I + Math.imul(ce, Mr) | 0, I = I + Math.imul(Ze, tr) | 0, te = te + Math.imul(Ze, Mr) | 0, W = W + Math.imul($t, hr) | 0, I = I + Math.imul($t, Or) | 0, I = I + Math.imul(Lt, hr) | 0, te = te + Math.imul(Lt, Or) | 0;
        var Yr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, W = Math.imul(It, tr), I = Math.imul(It, Mr), I = I + Math.imul(rn, tr) | 0, te = Math.imul(rn, Mr), W = W + Math.imul(ce, hr) | 0, I = I + Math.imul(ce, Or) | 0, I = I + Math.imul(Ze, hr) | 0, te = te + Math.imul(Ze, Or) | 0;
        var Fr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, W = Math.imul(It, hr), I = Math.imul(It, Or), I = I + Math.imul(rn, hr) | 0, te = Math.imul(rn, Or);
        var eo = (N + W | 0) + ((I & 8191) << 13) | 0;
        return N = (te + (I >>> 13) | 0) + (eo >>> 26) | 0, eo &= 67108863, fe[0] = Fo, fe[1] = No, fe[2] = di, fe[3] = gi, fe[4] = ai, fe[5] = ui, fe[6] = hi, fe[7] = bi, fe[8] = ii, fe[9] = pi, fe[10] = Ci, fe[11] = _i, fe[12] = xn, fe[13] = sr, fe[14] = Nr, fe[15] = vr, fe[16] = Yr, fe[17] = Fr, fe[18] = eo, N !== 0 && (fe[19] = N, P.length++), P;
      };
      Math.imul || (M = V);
      function G(H, C, w) {
        w.negative = C.negative ^ H.negative, w.length = H.length + C.length;
        for (var P = 0, J = 0, se = 0; se < w.length - 1; se++) {
          var fe = J;
          J = 0;
          for (var N = P & 67108863, W = Math.min(se, C.length - 1), I = Math.max(0, se - H.length + 1); I <= W; I++) {
            var te = se - I, ge = H.words[te] | 0, Pe = C.words[I] | 0, Ke = ge * Pe, xe = Ke & 67108863;
            fe = fe + (Ke / 67108864 | 0) | 0, xe = xe + N | 0, N = xe & 67108863, fe = fe + (xe >>> 26) | 0, J += fe >>> 26, fe &= 67108863;
          }
          w.words[se] = N, P = fe, fe = J;
        }
        return P !== 0 ? w.words[se] = P : w.length--, w.strip();
      }
      function k(H, C, w) {
        var P = new F();
        return P.mulp(H, C, w);
      }
      d.prototype.mulTo = function(C, w) {
        var P, J = this.length + C.length;
        return this.length === 10 && C.length === 10 ? P = M(this, C, w) : J < 63 ? P = V(this, C, w) : J < 1024 ? P = G(this, C, w) : P = k(this, C, w), P;
      };
      function F(H, C) {
        this.x = H, this.y = C;
      }
      F.prototype.makeRBT = function(C) {
        for (var w = new Array(C), P = d.prototype._countBits(C) - 1, J = 0; J < C; J++)
          w[J] = this.revBin(J, P, C);
        return w;
      }, F.prototype.revBin = function(C, w, P) {
        if (C === 0 || C === P - 1)
          return C;
        for (var J = 0, se = 0; se < w; se++)
          J |= (C & 1) << w - se - 1, C >>= 1;
        return J;
      }, F.prototype.permute = function(C, w, P, J, se, fe) {
        for (var N = 0; N < fe; N++)
          J[N] = w[C[N]], se[N] = P[C[N]];
      }, F.prototype.transform = function(C, w, P, J, se, fe) {
        this.permute(fe, C, w, P, J, se);
        for (var N = 1; N < se; N <<= 1)
          for (var W = N << 1, I = Math.cos(2 * Math.PI / W), te = Math.sin(2 * Math.PI / W), ge = 0; ge < se; ge += W)
            for (var Pe = I, Ke = te, xe = 0; xe < N; xe++) {
              var ze = P[ge + xe], nt = J[ge + xe], Qt = P[ge + xe + N], Et = J[ge + xe + N], zt = Pe * Qt - Ke * Et;
              Et = Pe * Et + Ke * Qt, Qt = zt, P[ge + xe] = ze + Qt, J[ge + xe] = nt + Et, P[ge + xe + N] = ze - Qt, J[ge + xe + N] = nt - Et, xe !== W && (zt = I * Pe - te * Ke, Ke = I * Ke + te * Pe, Pe = zt);
            }
      }, F.prototype.guessLen13b = function(C, w) {
        var P = Math.max(w, C) | 1, J = P & 1, se = 0;
        for (P = P / 2 | 0; P; P = P >>> 1)
          se++;
        return 1 << se + 1 + J;
      }, F.prototype.conjugate = function(C, w, P) {
        if (!(P <= 1))
          for (var J = 0; J < P / 2; J++) {
            var se = C[J];
            C[J] = C[P - J - 1], C[P - J - 1] = se, se = w[J], w[J] = -w[P - J - 1], w[P - J - 1] = -se;
          }
      }, F.prototype.normalize13b = function(C, w) {
        for (var P = 0, J = 0; J < w / 2; J++) {
          var se = Math.round(C[2 * J + 1] / w) * 8192 + Math.round(C[2 * J] / w) + P;
          C[J] = se & 67108863, se < 67108864 ? P = 0 : P = se / 67108864 | 0;
        }
        return C;
      }, F.prototype.convert13b = function(C, w, P, J) {
        for (var se = 0, fe = 0; fe < w; fe++)
          se = se + (C[fe] | 0), P[2 * fe] = se & 8191, se = se >>> 13, P[2 * fe + 1] = se & 8191, se = se >>> 13;
        for (fe = 2 * w; fe < J; ++fe)
          P[fe] = 0;
        u(se === 0), u((se & -8192) === 0);
      }, F.prototype.stub = function(C) {
        for (var w = new Array(C), P = 0; P < C; P++)
          w[P] = 0;
        return w;
      }, F.prototype.mulp = function(C, w, P) {
        var J = 2 * this.guessLen13b(C.length, w.length), se = this.makeRBT(J), fe = this.stub(J), N = new Array(J), W = new Array(J), I = new Array(J), te = new Array(J), ge = new Array(J), Pe = new Array(J), Ke = P.words;
        Ke.length = J, this.convert13b(C.words, C.length, N, J), this.convert13b(w.words, w.length, te, J), this.transform(N, fe, W, I, J, se), this.transform(te, fe, ge, Pe, J, se);
        for (var xe = 0; xe < J; xe++) {
          var ze = W[xe] * ge[xe] - I[xe] * Pe[xe];
          I[xe] = W[xe] * Pe[xe] + I[xe] * ge[xe], W[xe] = ze;
        }
        return this.conjugate(W, I, J), this.transform(W, I, Ke, fe, J, se), this.conjugate(Ke, fe, J), this.normalize13b(Ke, J), P.negative = C.negative ^ w.negative, P.length = C.length + w.length, P.strip();
      }, d.prototype.mul = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), this.mulTo(C, w);
      }, d.prototype.mulf = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), k(this, C, w);
      }, d.prototype.imul = function(C) {
        return this.clone().mulTo(C, this);
      }, d.prototype.imuln = function(C) {
        u(typeof C == "number"), u(C < 67108864);
        for (var w = 0, P = 0; P < this.length; P++) {
          var J = (this.words[P] | 0) * C, se = (J & 67108863) + (w & 67108863);
          w >>= 26, w += J / 67108864 | 0, w += se >>> 26, this.words[P] = se & 67108863;
        }
        return w !== 0 && (this.words[P] = w, this.length++), this;
      }, d.prototype.muln = function(C) {
        return this.clone().imuln(C);
      }, d.prototype.sqr = function() {
        return this.mul(this);
      }, d.prototype.isqr = function() {
        return this.imul(this.clone());
      }, d.prototype.pow = function(C) {
        var w = y(C);
        if (w.length === 0)
          return new d(1);
        for (var P = this, J = 0; J < w.length && w[J] === 0; J++, P = P.sqr())
          ;
        if (++J < w.length)
          for (var se = P.sqr(); J < w.length; J++, se = se.sqr())
            w[J] !== 0 && (P = P.mul(se));
        return P;
      }, d.prototype.iushln = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 67108863 >>> 26 - w << 26 - w, se;
        if (w !== 0) {
          var fe = 0;
          for (se = 0; se < this.length; se++) {
            var N = this.words[se] & J, W = (this.words[se] | 0) - N << w;
            this.words[se] = W | fe, fe = N >>> 26 - w;
          }
          fe && (this.words[se] = fe, this.length++);
        }
        if (P !== 0) {
          for (se = this.length - 1; se >= 0; se--)
            this.words[se + P] = this.words[se];
          for (se = 0; se < P; se++)
            this.words[se] = 0;
          this.length += P;
        }
        return this.strip();
      }, d.prototype.ishln = function(C) {
        return u(this.negative === 0), this.iushln(C);
      }, d.prototype.iushrn = function(C, w, P) {
        u(typeof C == "number" && C >= 0);
        var J;
        w ? J = (w - w % 26) / 26 : J = 0;
        var se = C % 26, fe = Math.min((C - se) / 26, this.length), N = 67108863 ^ 67108863 >>> se << se, W = P;
        if (J -= fe, J = Math.max(0, J), W) {
          for (var I = 0; I < fe; I++)
            W.words[I] = this.words[I];
          W.length = fe;
        }
        if (fe !== 0)
          if (this.length > fe)
            for (this.length -= fe, I = 0; I < this.length; I++)
              this.words[I] = this.words[I + fe];
          else
            this.words[0] = 0, this.length = 1;
        var te = 0;
        for (I = this.length - 1; I >= 0 && (te !== 0 || I >= J); I--) {
          var ge = this.words[I] | 0;
          this.words[I] = te << 26 - se | ge >>> se, te = ge & N;
        }
        return W && te !== 0 && (W.words[W.length++] = te), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, d.prototype.ishrn = function(C, w, P) {
        return u(this.negative === 0), this.iushrn(C, w, P);
      }, d.prototype.shln = function(C) {
        return this.clone().ishln(C);
      }, d.prototype.ushln = function(C) {
        return this.clone().iushln(C);
      }, d.prototype.shrn = function(C) {
        return this.clone().ishrn(C);
      }, d.prototype.ushrn = function(C) {
        return this.clone().iushrn(C);
      }, d.prototype.testn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return !1;
        var se = this.words[P];
        return !!(se & J);
      }, d.prototype.imaskn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26;
        if (u(this.negative === 0, "imaskn works only with positive numbers"), this.length <= P)
          return this;
        if (w !== 0 && P++, this.length = Math.min(P, this.length), w !== 0) {
          var J = 67108863 ^ 67108863 >>> w << w;
          this.words[this.length - 1] &= J;
        }
        return this.strip();
      }, d.prototype.maskn = function(C) {
        return this.clone().imaskn(C);
      }, d.prototype.iaddn = function(C) {
        return u(typeof C == "number"), u(C < 67108864), C < 0 ? this.isubn(-C) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < C ? (this.words[0] = C - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(C), this.negative = 1, this) : this._iaddn(C);
      }, d.prototype._iaddn = function(C) {
        this.words[0] += C;
        for (var w = 0; w < this.length && this.words[w] >= 67108864; w++)
          this.words[w] -= 67108864, w === this.length - 1 ? this.words[w + 1] = 1 : this.words[w + 1]++;
        return this.length = Math.max(this.length, w + 1), this;
      }, d.prototype.isubn = function(C) {
        if (u(typeof C == "number"), u(C < 67108864), C < 0)
          return this.iaddn(-C);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(C), this.negative = 1, this;
        if (this.words[0] -= C, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var w = 0; w < this.length && this.words[w] < 0; w++)
            this.words[w] += 67108864, this.words[w + 1] -= 1;
        return this.strip();
      }, d.prototype.addn = function(C) {
        return this.clone().iaddn(C);
      }, d.prototype.subn = function(C) {
        return this.clone().isubn(C);
      }, d.prototype.iabs = function() {
        return this.negative = 0, this;
      }, d.prototype.abs = function() {
        return this.clone().iabs();
      }, d.prototype._ishlnsubmul = function(C, w, P) {
        var J = C.length + P, se;
        this._expand(J);
        var fe, N = 0;
        for (se = 0; se < C.length; se++) {
          fe = (this.words[se + P] | 0) + N;
          var W = (C.words[se] | 0) * w;
          fe -= W & 67108863, N = (fe >> 26) - (W / 67108864 | 0), this.words[se + P] = fe & 67108863;
        }
        for (; se < this.length - P; se++)
          fe = (this.words[se + P] | 0) + N, N = fe >> 26, this.words[se + P] = fe & 67108863;
        if (N === 0)
          return this.strip();
        for (u(N === -1), N = 0, se = 0; se < this.length; se++)
          fe = -(this.words[se] | 0) + N, N = fe >> 26, this.words[se] = fe & 67108863;
        return this.negative = 1, this.strip();
      }, d.prototype._wordDiv = function(C, w) {
        var P = this.length - C.length, J = this.clone(), se = C, fe = se.words[se.length - 1] | 0, N = this._countBits(fe);
        P = 26 - N, P !== 0 && (se = se.ushln(P), J.iushln(P), fe = se.words[se.length - 1] | 0);
        var W = J.length - se.length, I;
        if (w !== "mod") {
          I = new d(null), I.length = W + 1, I.words = new Array(I.length);
          for (var te = 0; te < I.length; te++)
            I.words[te] = 0;
        }
        var ge = J.clone()._ishlnsubmul(se, 1, W);
        ge.negative === 0 && (J = ge, I && (I.words[W] = 1));
        for (var Pe = W - 1; Pe >= 0; Pe--) {
          var Ke = (J.words[se.length + Pe] | 0) * 67108864 + (J.words[se.length + Pe - 1] | 0);
          for (Ke = Math.min(Ke / fe | 0, 67108863), J._ishlnsubmul(se, Ke, Pe); J.negative !== 0; )
            Ke--, J.negative = 0, J._ishlnsubmul(se, 1, Pe), J.isZero() || (J.negative ^= 1);
          I && (I.words[Pe] = Ke);
        }
        return I && I.strip(), J.strip(), w !== "div" && P !== 0 && J.iushrn(P), {
          div: I || null,
          mod: J
        };
      }, d.prototype.divmod = function(C, w, P) {
        if (u(!C.isZero()), this.isZero())
          return {
            div: new d(0),
            mod: new d(0)
          };
        var J, se, fe;
        return this.negative !== 0 && C.negative === 0 ? (fe = this.neg().divmod(C, w), w !== "mod" && (J = fe.div.neg()), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.iadd(C)), {
          div: J,
          mod: se
        }) : this.negative === 0 && C.negative !== 0 ? (fe = this.divmod(C.neg(), w), w !== "mod" && (J = fe.div.neg()), {
          div: J,
          mod: fe.mod
        }) : this.negative & C.negative ? (fe = this.neg().divmod(C.neg(), w), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.isub(C)), {
          div: fe.div,
          mod: se
        }) : C.length > this.length || this.cmp(C) < 0 ? {
          div: new d(0),
          mod: this
        } : C.length === 1 ? w === "div" ? {
          div: this.divn(C.words[0]),
          mod: null
        } : w === "mod" ? {
          div: null,
          mod: new d(this.modn(C.words[0]))
        } : {
          div: this.divn(C.words[0]),
          mod: new d(this.modn(C.words[0]))
        } : this._wordDiv(C, w);
      }, d.prototype.div = function(C) {
        return this.divmod(C, "div", !1).div;
      }, d.prototype.mod = function(C) {
        return this.divmod(C, "mod", !1).mod;
      }, d.prototype.umod = function(C) {
        return this.divmod(C, "mod", !0).mod;
      }, d.prototype.divRound = function(C) {
        var w = this.divmod(C);
        if (w.mod.isZero())
          return w.div;
        var P = w.div.negative !== 0 ? w.mod.isub(C) : w.mod, J = C.ushrn(1), se = C.andln(1), fe = P.cmp(J);
        return fe < 0 || se === 1 && fe === 0 ? w.div : w.div.negative !== 0 ? w.div.isubn(1) : w.div.iaddn(1);
      }, d.prototype.modn = function(C) {
        u(C <= 67108863);
        for (var w = (1 << 26) % C, P = 0, J = this.length - 1; J >= 0; J--)
          P = (w * P + (this.words[J] | 0)) % C;
        return P;
      }, d.prototype.idivn = function(C) {
        u(C <= 67108863);
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = (this.words[P] | 0) + w * 67108864;
          this.words[P] = J / C | 0, w = J % C;
        }
        return this.strip();
      }, d.prototype.divn = function(C) {
        return this.clone().idivn(C);
      }, d.prototype.egcd = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = new d(0), N = new d(1), W = 0; w.isEven() && P.isEven(); )
          w.iushrn(1), P.iushrn(1), ++W;
        for (var I = P.clone(), te = w.clone(); !w.isZero(); ) {
          for (var ge = 0, Pe = 1; !(w.words[0] & Pe) && ge < 26; ++ge, Pe <<= 1)
            ;
          if (ge > 0)
            for (w.iushrn(ge); ge-- > 0; )
              (J.isOdd() || se.isOdd()) && (J.iadd(I), se.isub(te)), J.iushrn(1), se.iushrn(1);
          for (var Ke = 0, xe = 1; !(P.words[0] & xe) && Ke < 26; ++Ke, xe <<= 1)
            ;
          if (Ke > 0)
            for (P.iushrn(Ke); Ke-- > 0; )
              (fe.isOdd() || N.isOdd()) && (fe.iadd(I), N.isub(te)), fe.iushrn(1), N.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(fe), se.isub(N)) : (P.isub(w), fe.isub(J), N.isub(se));
        }
        return {
          a: fe,
          b: N,
          gcd: P.iushln(W)
        };
      }, d.prototype._invmp = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = P.clone(); w.cmpn(1) > 0 && P.cmpn(1) > 0; ) {
          for (var N = 0, W = 1; !(w.words[0] & W) && N < 26; ++N, W <<= 1)
            ;
          if (N > 0)
            for (w.iushrn(N); N-- > 0; )
              J.isOdd() && J.iadd(fe), J.iushrn(1);
          for (var I = 0, te = 1; !(P.words[0] & te) && I < 26; ++I, te <<= 1)
            ;
          if (I > 0)
            for (P.iushrn(I); I-- > 0; )
              se.isOdd() && se.iadd(fe), se.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(se)) : (P.isub(w), se.isub(J));
        }
        var ge;
        return w.cmpn(1) === 0 ? ge = J : ge = se, ge.cmpn(0) < 0 && ge.iadd(C), ge;
      }, d.prototype.gcd = function(C) {
        if (this.isZero())
          return C.abs();
        if (C.isZero())
          return this.abs();
        var w = this.clone(), P = C.clone();
        w.negative = 0, P.negative = 0;
        for (var J = 0; w.isEven() && P.isEven(); J++)
          w.iushrn(1), P.iushrn(1);
        do {
          for (; w.isEven(); )
            w.iushrn(1);
          for (; P.isEven(); )
            P.iushrn(1);
          var se = w.cmp(P);
          if (se < 0) {
            var fe = w;
            w = P, P = fe;
          } else if (se === 0 || P.cmpn(1) === 0)
            break;
          w.isub(P);
        } while (!0);
        return P.iushln(J);
      }, d.prototype.invm = function(C) {
        return this.egcd(C).a.umod(C);
      }, d.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, d.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, d.prototype.andln = function(C) {
        return this.words[0] & C;
      }, d.prototype.bincn = function(C) {
        u(typeof C == "number");
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return this._expand(P + 1), this.words[P] |= J, this;
        for (var se = J, fe = P; se !== 0 && fe < this.length; fe++) {
          var N = this.words[fe] | 0;
          N += se, se = N >>> 26, N &= 67108863, this.words[fe] = N;
        }
        return se !== 0 && (this.words[fe] = se, this.length++), this;
      }, d.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, d.prototype.cmpn = function(C) {
        var w = C < 0;
        if (this.negative !== 0 && !w)
          return -1;
        if (this.negative === 0 && w)
          return 1;
        this.strip();
        var P;
        if (this.length > 1)
          P = 1;
        else {
          w && (C = -C), u(C <= 67108863, "Number is too big");
          var J = this.words[0] | 0;
          P = J === C ? 0 : J < C ? -1 : 1;
        }
        return this.negative !== 0 ? -P | 0 : P;
      }, d.prototype.cmp = function(C) {
        if (this.negative !== 0 && C.negative === 0)
          return -1;
        if (this.negative === 0 && C.negative !== 0)
          return 1;
        var w = this.ucmp(C);
        return this.negative !== 0 ? -w | 0 : w;
      }, d.prototype.ucmp = function(C) {
        if (this.length > C.length)
          return 1;
        if (this.length < C.length)
          return -1;
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = this.words[P] | 0, se = C.words[P] | 0;
          if (J !== se) {
            J < se ? w = -1 : J > se && (w = 1);
            break;
          }
        }
        return w;
      }, d.prototype.gtn = function(C) {
        return this.cmpn(C) === 1;
      }, d.prototype.gt = function(C) {
        return this.cmp(C) === 1;
      }, d.prototype.gten = function(C) {
        return this.cmpn(C) >= 0;
      }, d.prototype.gte = function(C) {
        return this.cmp(C) >= 0;
      }, d.prototype.ltn = function(C) {
        return this.cmpn(C) === -1;
      }, d.prototype.lt = function(C) {
        return this.cmp(C) === -1;
      }, d.prototype.lten = function(C) {
        return this.cmpn(C) <= 0;
      }, d.prototype.lte = function(C) {
        return this.cmp(C) <= 0;
      }, d.prototype.eqn = function(C) {
        return this.cmpn(C) === 0;
      }, d.prototype.eq = function(C) {
        return this.cmp(C) === 0;
      }, d.red = function(C) {
        return new oe(C);
      }, d.prototype.toRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), u(this.negative === 0, "red works only with positives"), C.convertTo(this)._forceRed(C);
      }, d.prototype.fromRed = function() {
        return u(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, d.prototype._forceRed = function(C) {
        return this.red = C, this;
      }, d.prototype.forceRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), this._forceRed(C);
      }, d.prototype.redAdd = function(C) {
        return u(this.red, "redAdd works only with red numbers"), this.red.add(this, C);
      }, d.prototype.redIAdd = function(C) {
        return u(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, C);
      }, d.prototype.redSub = function(C) {
        return u(this.red, "redSub works only with red numbers"), this.red.sub(this, C);
      }, d.prototype.redISub = function(C) {
        return u(this.red, "redISub works only with red numbers"), this.red.isub(this, C);
      }, d.prototype.redShl = function(C) {
        return u(this.red, "redShl works only with red numbers"), this.red.shl(this, C);
      }, d.prototype.redMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.mul(this, C);
      }, d.prototype.redIMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.imul(this, C);
      }, d.prototype.redSqr = function() {
        return u(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, d.prototype.redISqr = function() {
        return u(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, d.prototype.redSqrt = function() {
        return u(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, d.prototype.redInvm = function() {
        return u(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, d.prototype.redNeg = function() {
        return u(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, d.prototype.redPow = function(C) {
        return u(this.red && !C.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, C);
      };
      var X = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function ee(H, C) {
        this.name = H, this.p = new d(C, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      ee.prototype._tmp = function() {
        var C = new d(null);
        return C.words = new Array(Math.ceil(this.n / 13)), C;
      }, ee.prototype.ireduce = function(C) {
        var w = C, P;
        do
          this.split(w, this.tmp), w = this.imulK(w), w = w.iadd(this.tmp), P = w.bitLength();
        while (P > this.n);
        var J = P < this.n ? -1 : w.ucmp(this.p);
        return J === 0 ? (w.words[0] = 0, w.length = 1) : J > 0 ? w.isub(this.p) : w.strip !== void 0 ? w.strip() : w._strip(), w;
      }, ee.prototype.split = function(C, w) {
        C.iushrn(this.n, 0, w);
      }, ee.prototype.imulK = function(C) {
        return C.imul(this.k);
      };
      function ue() {
        ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(ue, ee), ue.prototype.split = function(C, w) {
        for (var P = 4194303, J = Math.min(C.length, 9), se = 0; se < J; se++)
          w.words[se] = C.words[se];
        if (w.length = J, C.length <= 9) {
          C.words[0] = 0, C.length = 1;
          return;
        }
        var fe = C.words[9];
        for (w.words[w.length++] = fe & P, se = 10; se < C.length; se++) {
          var N = C.words[se] | 0;
          C.words[se - 10] = (N & P) << 4 | fe >>> 22, fe = N;
        }
        fe >>>= 22, C.words[se - 10] = fe, fe === 0 && C.length > 10 ? C.length -= 10 : C.length -= 9;
      }, ue.prototype.imulK = function(C) {
        C.words[C.length] = 0, C.words[C.length + 1] = 0, C.length += 2;
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = C.words[P] | 0;
          w += J * 977, C.words[P] = w & 67108863, w = J * 64 + (w / 67108864 | 0);
        }
        return C.words[C.length - 1] === 0 && (C.length--, C.words[C.length - 1] === 0 && C.length--), C;
      };
      function Q() {
        ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(Q, ee);
      function Y() {
        ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(Y, ee);
      function pe() {
        ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(pe, ee), pe.prototype.imulK = function(C) {
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = (C.words[P] | 0) * 19 + w, se = J & 67108863;
          J >>>= 26, C.words[P] = se, w = J;
        }
        return w !== 0 && (C.words[C.length++] = w), C;
      }, d._prime = function(C) {
        if (X[C])
          return X[C];
        var w;
        if (C === "k256")
          w = new ue();
        else if (C === "p224")
          w = new Q();
        else if (C === "p192")
          w = new Y();
        else if (C === "p25519")
          w = new pe();
        else
          throw new Error("Unknown prime " + C);
        return X[C] = w, w;
      };
      function oe(H) {
        if (typeof H == "string") {
          var C = d._prime(H);
          this.m = C.p, this.prime = C;
        } else
          u(H.gtn(1), "modulus must be greater than 1"), this.m = H, this.prime = null;
      }
      oe.prototype._verify1 = function(C) {
        u(C.negative === 0, "red works only with positives"), u(C.red, "red works only with red numbers");
      }, oe.prototype._verify2 = function(C, w) {
        u((C.negative | w.negative) === 0, "red works only with positives"), u(
          C.red && C.red === w.red,
          "red works only with red numbers"
        );
      }, oe.prototype.imod = function(C) {
        return this.prime ? this.prime.ireduce(C)._forceRed(this) : C.umod(this.m)._forceRed(this);
      }, oe.prototype.neg = function(C) {
        return C.isZero() ? C.clone() : this.m.sub(C)._forceRed(this);
      }, oe.prototype.add = function(C, w) {
        this._verify2(C, w);
        var P = C.add(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P._forceRed(this);
      }, oe.prototype.iadd = function(C, w) {
        this._verify2(C, w);
        var P = C.iadd(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P;
      }, oe.prototype.sub = function(C, w) {
        this._verify2(C, w);
        var P = C.sub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P._forceRed(this);
      }, oe.prototype.isub = function(C, w) {
        this._verify2(C, w);
        var P = C.isub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P;
      }, oe.prototype.shl = function(C, w) {
        return this._verify1(C), this.imod(C.ushln(w));
      }, oe.prototype.imul = function(C, w) {
        return this._verify2(C, w), this.imod(C.imul(w));
      }, oe.prototype.mul = function(C, w) {
        return this._verify2(C, w), this.imod(C.mul(w));
      }, oe.prototype.isqr = function(C) {
        return this.imul(C, C.clone());
      }, oe.prototype.sqr = function(C) {
        return this.mul(C, C);
      }, oe.prototype.sqrt = function(C) {
        if (C.isZero())
          return C.clone();
        var w = this.m.andln(3);
        if (u(w % 2 === 1), w === 3) {
          var P = this.m.add(new d(1)).iushrn(2);
          return this.pow(C, P);
        }
        for (var J = this.m.subn(1), se = 0; !J.isZero() && J.andln(1) === 0; )
          se++, J.iushrn(1);
        u(!J.isZero());
        var fe = new d(1).toRed(this), N = fe.redNeg(), W = this.m.subn(1).iushrn(1), I = this.m.bitLength();
        for (I = new d(2 * I * I).toRed(this); this.pow(I, W).cmp(N) !== 0; )
          I.redIAdd(N);
        for (var te = this.pow(I, J), ge = this.pow(C, J.addn(1).iushrn(1)), Pe = this.pow(C, J), Ke = se; Pe.cmp(fe) !== 0; ) {
          for (var xe = Pe, ze = 0; xe.cmp(fe) !== 0; ze++)
            xe = xe.redSqr();
          u(ze < Ke);
          var nt = this.pow(te, new d(1).iushln(Ke - ze - 1));
          ge = ge.redMul(nt), te = nt.redSqr(), Pe = Pe.redMul(te), Ke = ze;
        }
        return ge;
      }, oe.prototype.invm = function(C) {
        var w = C._invmp(this.m);
        return w.negative !== 0 ? (w.negative = 0, this.imod(w).redNeg()) : this.imod(w);
      }, oe.prototype.pow = function(C, w) {
        if (w.isZero())
          return new d(1).toRed(this);
        if (w.cmpn(1) === 0)
          return C.clone();
        var P = 4, J = new Array(1 << P);
        J[0] = new d(1).toRed(this), J[1] = C;
        for (var se = 2; se < J.length; se++)
          J[se] = this.mul(J[se - 1], C);
        var fe = J[0], N = 0, W = 0, I = w.bitLength() % 26;
        for (I === 0 && (I = 26), se = w.length - 1; se >= 0; se--) {
          for (var te = w.words[se], ge = I - 1; ge >= 0; ge--) {
            var Pe = te >> ge & 1;
            if (fe !== J[0] && (fe = this.sqr(fe)), Pe === 0 && N === 0) {
              W = 0;
              continue;
            }
            N <<= 1, N |= Pe, W++, !(W !== P && (se !== 0 || ge !== 0)) && (fe = this.mul(fe, J[N]), W = 0, N = 0);
          }
          I = 26;
        }
        return fe;
      }, oe.prototype.convertTo = function(C) {
        var w = C.umod(this.m);
        return w === C ? w.clone() : w;
      }, oe.prototype.convertFrom = function(C) {
        var w = C.clone();
        return w.red = null, w;
      }, d.mont = function(C) {
        return new ne(C);
      };
      function ne(H) {
        oe.call(this, H), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(ne, oe), ne.prototype.convertTo = function(C) {
        return this.imod(C.ushln(this.shift));
      }, ne.prototype.convertFrom = function(C) {
        var w = this.imod(C.mul(this.rinv));
        return w.red = null, w;
      }, ne.prototype.imul = function(C, w) {
        if (C.isZero() || w.isZero())
          return C.words[0] = 0, C.length = 1, C;
        var P = C.imul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.mul = function(C, w) {
        if (C.isZero() || w.isZero())
          return new d(0)._forceRed(this);
        var P = C.mul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.invm = function(C) {
        var w = this.imod(C._invmp(this.m).mul(this.r2));
        return w._forceRed(this);
      };
    })(e, commonjsGlobal);
  }(bn$5)), bn$5.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand)
    return brorand.exports;
  hasRequiredBrorand = 1;
  var e;
  brorand.exports = function(c) {
    return e || (e = new n(null)), e.generate(c);
  };
  function n(u) {
    this.rand = u;
  }
  if (brorand.exports.Rand = n, n.prototype.generate = function(c) {
    return this._rand(c);
  }, n.prototype._rand = function(c) {
    if (this.rand.getBytes)
      return this.rand.getBytes(c);
    for (var d = new Uint8Array(c), m = 0; m < d.length; m++)
      d[m] = this.rand.getByte();
    return d;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? n.prototype._rand = function(c) {
      var d = new Uint8Array(c);
      return self.crypto.getRandomValues(d), d;
    } : self.msCrypto && self.msCrypto.getRandomValues ? n.prototype._rand = function(c) {
      var d = new Uint8Array(c);
      return self.msCrypto.getRandomValues(d), d;
    } : typeof window == "object" && (n.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var o = requireCryptoBrowserify();
      if (typeof o.randomBytes != "function")
        throw new Error("Not supported");
      n.prototype._rand = function(c) {
        return o.randomBytes(c);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr)
    return mr;
  hasRequiredMr = 1;
  var e = requireBn$3(), n = requireBrorand();
  function o(u) {
    this.rand = u || new n.Rand();
  }
  return mr = o, o.create = function(c) {
    return new o(c);
  }, o.prototype._randbelow = function(c) {
    var d = c.bitLength(), m = Math.ceil(d / 8);
    do
      var v = new e(this.rand.generate(m));
    while (v.cmp(c) >= 0);
    return v;
  }, o.prototype._randrange = function(c, d) {
    var m = d.sub(c);
    return c.add(this._randbelow(m));
  }, o.prototype.test = function(c, d, m) {
    var v = c.bitLength(), S = e.mont(c), $ = new e(1).toRed(S);
    d || (d = Math.max(1, v / 48 | 0));
    for (var E = c.subn(1), O = 0; !E.testn(O); O++)
      ;
    for (var T = c.shrn(O), y = E.toRed(S), V = !0; d > 0; d--) {
      var M = this._randrange(new e(2), E);
      m && m(M);
      var G = M.toRed(S).redPow(T);
      if (!(G.cmp($) === 0 || G.cmp(y) === 0)) {
        for (var k = 1; k < O; k++) {
          if (G = G.redSqr(), G.cmp($) === 0)
            return !1;
          if (G.cmp(y) === 0)
            break;
        }
        if (k === O)
          return !1;
      }
    }
    return V;
  }, o.prototype.getDivisor = function(c, d) {
    var m = c.bitLength(), v = e.mont(c), S = new e(1).toRed(v);
    d || (d = Math.max(1, m / 48 | 0));
    for (var $ = c.subn(1), E = 0; !$.testn(E); E++)
      ;
    for (var O = c.shrn(E), T = $.toRed(v); d > 0; d--) {
      var y = this._randrange(new e(2), $), V = c.gcd(y);
      if (V.cmpn(1) !== 0)
        return V;
      var M = y.toRed(v).redPow(O);
      if (!(M.cmp(S) === 0 || M.cmp(T) === 0)) {
        for (var G = 1; G < E; G++) {
          if (M = M.redSqr(), M.cmp(S) === 0)
            return M.fromRed().subn(1).gcd(c);
          if (M.cmp(T) === 0)
            break;
        }
        if (G === E)
          return M = M.redSqr(), M.fromRed().subn(1).gcd(c);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime)
    return generatePrime;
  hasRequiredGeneratePrime = 1;
  var e = requireBrowser$b();
  generatePrime = G, G.simpleSieve = V, G.fermatTest = M;
  var n = requireBn$4(), o = new n(24), u = requireMr(), c = new u(), d = new n(1), m = new n(2), v = new n(5);
  new n(16), new n(8);
  var S = new n(10), $ = new n(3);
  new n(7);
  var E = new n(11), O = new n(4);
  new n(12);
  var T = null;
  function y() {
    if (T !== null)
      return T;
    var k = 1048576, F = [];
    F[0] = 2;
    for (var X = 1, ee = 3; ee < k; ee += 2) {
      for (var ue = Math.ceil(Math.sqrt(ee)), Q = 0; Q < X && F[Q] <= ue && ee % F[Q] !== 0; Q++)
        ;
      X !== Q && F[Q] <= ue || (F[X++] = ee);
    }
    return T = F, F;
  }
  function V(k) {
    for (var F = y(), X = 0; X < F.length; X++)
      if (k.modn(F[X]) === 0)
        return k.cmpn(F[X]) === 0;
    return !0;
  }
  function M(k) {
    var F = n.mont(k);
    return m.toRed(F).redPow(k.subn(1)).fromRed().cmpn(1) === 0;
  }
  function G(k, F) {
    if (k < 16)
      return F === 2 || F === 5 ? new n([140, 123]) : new n([140, 39]);
    F = new n(F);
    for (var X, ee; ; ) {
      for (X = new n(e(Math.ceil(k / 8))); X.bitLength() > k; )
        X.ishrn(1);
      if (X.isEven() && X.iadd(d), X.testn(1) || X.iadd(m), F.cmp(m)) {
        if (!F.cmp(v))
          for (; X.mod(S).cmp($); )
            X.iadd(O);
      } else
        for (; X.mod(o).cmp(E); )
          X.iadd(O);
      if (ee = X.shrn(1), V(ee) && V(X) && M(ee) && M(X) && c.test(ee) && c.test(X))
        return X;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "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"
}, require$$1$3 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh)
    return dh;
  hasRequiredDh = 1;
  var e = requireBn$4(), n = requireMr(), o = new n(), u = new e(24), c = new e(11), d = new e(10), m = new e(3), v = new e(7), S = requireGeneratePrime(), $ = requireBrowser$b();
  dh = V;
  function E(G, k) {
    return k = k || "utf8", Buffer.isBuffer(G) || (G = new Buffer(G, k)), this._pub = new e(G), this;
  }
  function O(G, k) {
    return k = k || "utf8", Buffer.isBuffer(G) || (G = new Buffer(G, k)), this._priv = new e(G), this;
  }
  var T = {};
  function y(G, k) {
    var F = k.toString("hex"), X = [F, G.toString(16)].join("_");
    if (X in T)
      return T[X];
    var ee = 0;
    if (G.isEven() || !S.simpleSieve || !S.fermatTest(G) || !o.test(G))
      return ee += 1, F === "02" || F === "05" ? ee += 8 : ee += 4, T[X] = ee, ee;
    o.test(G.shrn(1)) || (ee += 2);
    var ue;
    switch (F) {
      case "02":
        G.mod(u).cmp(c) && (ee += 8);
        break;
      case "05":
        ue = G.mod(d), ue.cmp(m) && ue.cmp(v) && (ee += 8);
        break;
      default:
        ee += 4;
    }
    return T[X] = ee, ee;
  }
  function V(G, k, F) {
    this.setGenerator(k), this.__prime = new e(G), this._prime = e.mont(this.__prime), this._primeLen = G.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, F ? (this.setPublicKey = E, this.setPrivateKey = O) : this._primeCode = 8;
  }
  Object.defineProperty(V.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = y(this.__prime, this.__gen)), this._primeCode;
    }
  }), V.prototype.generateKeys = function() {
    return this._priv || (this._priv = new e($(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, V.prototype.computeSecret = function(G) {
    G = new e(G), G = G.toRed(this._prime);
    var k = G.redPow(this._priv).fromRed(), F = new Buffer(k.toArray()), X = this.getPrime();
    if (F.length < X.length) {
      var ee = new Buffer(X.length - F.length);
      ee.fill(0), F = Buffer.concat([ee, F]);
    }
    return F;
  }, V.prototype.getPublicKey = function(k) {
    return M(this._pub, k);
  }, V.prototype.getPrivateKey = function(k) {
    return M(this._priv, k);
  }, V.prototype.getPrime = function(G) {
    return M(this.__prime, G);
  }, V.prototype.getGenerator = function(G) {
    return M(this._gen, G);
  }, V.prototype.setGenerator = function(G, k) {
    return k = k || "utf8", Buffer.isBuffer(G) || (G = new Buffer(G, k)), this.__gen = G, this._gen = new e(G), this;
  };
  function M(G, k) {
    var F = new Buffer(G.toArray());
    return k ? F.toString(k) : F;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4)
    return browser$6;
  hasRequiredBrowser$4 = 1;
  var e = requireGeneratePrime(), n = require$$1$3, o = requireDh();
  function u(m) {
    var v = new Buffer(n[m].prime, "hex"), S = new Buffer(n[m].gen, "hex");
    return new o(v, S);
  }
  var c = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function d(m, v, S, $) {
    return Buffer.isBuffer(v) || c[v] === void 0 ? d(m, "binary", v, S) : (v = v || "binary", $ = $ || "binary", S = S || new Buffer([2]), Buffer.isBuffer(S) || (S = new Buffer(S, $)), typeof m == "number" ? new o(e(m, S), S, !0) : (Buffer.isBuffer(m) || (m = new Buffer(m, v)), new o(m, S, !0)));
  }
  return browser$6.DiffieHellmanGroup = browser$6.createDiffieHellmanGroup = browser$6.getDiffieHellman = u, browser$6.createDiffieHellman = browser$6.DiffieHellman = d, browser$6;
}
var sign = { exports: {} }, bn$4 = { exports: {} };
bn$4.exports;
(function(e) {
  (function(n, o) {
    function u(w, P) {
      if (!w)
        throw new Error(P || "Assertion failed");
    }
    function c(w, P) {
      w.super_ = P;
      var J = function() {
      };
      J.prototype = P.prototype, w.prototype = new J(), w.prototype.constructor = w;
    }
    function d(w, P, J) {
      if (d.isBN(w))
        return w;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, w !== null && ((P === "le" || P === "be") && (J = P, P = 10), this._init(w || 0, P || 10, J || "be"));
    }
    typeof n == "object" ? n.exports = d : o.BN = d, d.BN = d, d.wordSize = 26;
    var m;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = require$$0$3.Buffer;
    } catch {
    }
    d.isBN = function(P) {
      return P instanceof d ? !0 : P !== null && typeof P == "object" && P.constructor.wordSize === d.wordSize && Array.isArray(P.words);
    }, d.max = function(P, J) {
      return P.cmp(J) > 0 ? P : J;
    }, d.min = function(P, J) {
      return P.cmp(J) < 0 ? P : J;
    }, d.prototype._init = function(P, J, se) {
      if (typeof P == "number")
        return this._initNumber(P, J, se);
      if (typeof P == "object")
        return this._initArray(P, J, se);
      J === "hex" && (J = 16), u(J === (J | 0) && J >= 2 && J <= 36), P = P.toString().replace(/\s+/g, "");
      var fe = 0;
      P[0] === "-" && (fe++, this.negative = 1), fe < P.length && (J === 16 ? this._parseHex(P, fe, se) : (this._parseBase(P, J, fe), se === "le" && this._initArray(this.toArray(), J, se)));
    }, d.prototype._initNumber = function(P, J, se) {
      P < 0 && (this.negative = 1, P = -P), P < 67108864 ? (this.words = [P & 67108863], this.length = 1) : P < 4503599627370496 ? (this.words = [
        P & 67108863,
        P / 67108864 & 67108863
      ], this.length = 2) : (u(P < 9007199254740992), this.words = [
        P & 67108863,
        P / 67108864 & 67108863,
        1
      ], this.length = 3), se === "le" && this._initArray(this.toArray(), J, se);
    }, d.prototype._initArray = function(P, J, se) {
      if (u(typeof P.length == "number"), P.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(P.length / 3), this.words = new Array(this.length);
      for (var fe = 0; fe < this.length; fe++)
        this.words[fe] = 0;
      var N, W, I = 0;
      if (se === "be")
        for (fe = P.length - 1, N = 0; fe >= 0; fe -= 3)
          W = P[fe] | P[fe - 1] << 8 | P[fe - 2] << 16, this.words[N] |= W << I & 67108863, this.words[N + 1] = W >>> 26 - I & 67108863, I += 24, I >= 26 && (I -= 26, N++);
      else if (se === "le")
        for (fe = 0, N = 0; fe < P.length; fe += 3)
          W = P[fe] | P[fe + 1] << 8 | P[fe + 2] << 16, this.words[N] |= W << I & 67108863, this.words[N + 1] = W >>> 26 - I & 67108863, I += 24, I >= 26 && (I -= 26, N++);
      return this._strip();
    };
    function v(w, P) {
      var J = w.charCodeAt(P);
      if (J >= 48 && J <= 57)
        return J - 48;
      if (J >= 65 && J <= 70)
        return J - 55;
      if (J >= 97 && J <= 102)
        return J - 87;
      u(!1, "Invalid character in " + w);
    }
    function S(w, P, J) {
      var se = v(w, J);
      return J - 1 >= P && (se |= v(w, J - 1) << 4), se;
    }
    d.prototype._parseHex = function(P, J, se) {
      this.length = Math.ceil((P.length - J) / 6), this.words = new Array(this.length);
      for (var fe = 0; fe < this.length; fe++)
        this.words[fe] = 0;
      var N = 0, W = 0, I;
      if (se === "be")
        for (fe = P.length - 1; fe >= J; fe -= 2)
          I = S(P, J, fe) << N, this.words[W] |= I & 67108863, N >= 18 ? (N -= 18, W += 1, this.words[W] |= I >>> 26) : N += 8;
      else {
        var te = P.length - J;
        for (fe = te % 2 === 0 ? J + 1 : J; fe < P.length; fe += 2)
          I = S(P, J, fe) << N, this.words[W] |= I & 67108863, N >= 18 ? (N -= 18, W += 1, this.words[W] |= I >>> 26) : N += 8;
      }
      this._strip();
    };
    function $(w, P, J, se) {
      for (var fe = 0, N = 0, W = Math.min(w.length, J), I = P; I < W; I++) {
        var te = w.charCodeAt(I) - 48;
        fe *= se, te >= 49 ? N = te - 49 + 10 : te >= 17 ? N = te - 17 + 10 : N = te, u(te >= 0 && N < se, "Invalid character"), fe += N;
      }
      return fe;
    }
    d.prototype._parseBase = function(P, J, se) {
      this.words = [0], this.length = 1;
      for (var fe = 0, N = 1; N <= 67108863; N *= J)
        fe++;
      fe--, N = N / J | 0;
      for (var W = P.length - se, I = W % fe, te = Math.min(W, W - I) + se, ge = 0, Pe = se; Pe < te; Pe += fe)
        ge = $(P, Pe, Pe + fe, J), this.imuln(N), this.words[0] + ge < 67108864 ? this.words[0] += ge : this._iaddn(ge);
      if (I !== 0) {
        var Ke = 1;
        for (ge = $(P, Pe, P.length, J), Pe = 0; Pe < I; Pe++)
          Ke *= J;
        this.imuln(Ke), this.words[0] + ge < 67108864 ? this.words[0] += ge : this._iaddn(ge);
      }
      this._strip();
    }, d.prototype.copy = function(P) {
      P.words = new Array(this.length);
      for (var J = 0; J < this.length; J++)
        P.words[J] = this.words[J];
      P.length = this.length, P.negative = this.negative, P.red = this.red;
    };
    function E(w, P) {
      w.words = P.words, w.length = P.length, w.negative = P.negative, w.red = P.red;
    }
    if (d.prototype._move = function(P) {
      E(P, this);
    }, d.prototype.clone = function() {
      var P = new d(null);
      return this.copy(P), P;
    }, d.prototype._expand = function(P) {
      for (; this.length < P; )
        this.words[this.length++] = 0;
      return this;
    }, d.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, d.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        d.prototype[Symbol.for("nodejs.util.inspect.custom")] = O;
      } catch {
        d.prototype.inspect = O;
      }
    else
      d.prototype.inspect = O;
    function O() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var T = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], y = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], V = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    d.prototype.toString = function(P, J) {
      P = P || 10, J = J | 0 || 1;
      var se;
      if (P === 16 || P === "hex") {
        se = "";
        for (var fe = 0, N = 0, W = 0; W < this.length; W++) {
          var I = this.words[W], te = ((I << fe | N) & 16777215).toString(16);
          N = I >>> 24 - fe & 16777215, fe += 2, fe >= 26 && (fe -= 26, W--), N !== 0 || W !== this.length - 1 ? se = T[6 - te.length] + te + se : se = te + se;
        }
        for (N !== 0 && (se = N.toString(16) + se); se.length % J !== 0; )
          se = "0" + se;
        return this.negative !== 0 && (se = "-" + se), se;
      }
      if (P === (P | 0) && P >= 2 && P <= 36) {
        var ge = y[P], Pe = V[P];
        se = "";
        var Ke = this.clone();
        for (Ke.negative = 0; !Ke.isZero(); ) {
          var xe = Ke.modrn(Pe).toString(P);
          Ke = Ke.idivn(Pe), Ke.isZero() ? se = xe + se : se = T[ge - xe.length] + xe + se;
        }
        for (this.isZero() && (se = "0" + se); se.length % J !== 0; )
          se = "0" + se;
        return this.negative !== 0 && (se = "-" + se), se;
      }
      u(!1, "Base should be between 2 and 36");
    }, d.prototype.toNumber = function() {
      var P = this.words[0];
      return this.length === 2 ? P += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? P += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && u(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -P : P;
    }, d.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, m && (d.prototype.toBuffer = function(P, J) {
      return this.toArrayLike(m, P, J);
    }), d.prototype.toArray = function(P, J) {
      return this.toArrayLike(Array, P, J);
    };
    var M = function(P, J) {
      return P.allocUnsafe ? P.allocUnsafe(J) : new P(J);
    };
    d.prototype.toArrayLike = function(P, J, se) {
      this._strip();
      var fe = this.byteLength(), N = se || Math.max(1, fe);
      u(fe <= N, "byte array longer than desired length"), u(N > 0, "Requested array length <= 0");
      var W = M(P, N), I = J === "le" ? "LE" : "BE";
      return this["_toArrayLike" + I](W, fe), W;
    }, d.prototype._toArrayLikeLE = function(P, J) {
      for (var se = 0, fe = 0, N = 0, W = 0; N < this.length; N++) {
        var I = this.words[N] << W | fe;
        P[se++] = I & 255, se < P.length && (P[se++] = I >> 8 & 255), se < P.length && (P[se++] = I >> 16 & 255), W === 6 ? (se < P.length && (P[se++] = I >> 24 & 255), fe = 0, W = 0) : (fe = I >>> 24, W += 2);
      }
      if (se < P.length)
        for (P[se++] = fe; se < P.length; )
          P[se++] = 0;
    }, d.prototype._toArrayLikeBE = function(P, J) {
      for (var se = P.length - 1, fe = 0, N = 0, W = 0; N < this.length; N++) {
        var I = this.words[N] << W | fe;
        P[se--] = I & 255, se >= 0 && (P[se--] = I >> 8 & 255), se >= 0 && (P[se--] = I >> 16 & 255), W === 6 ? (se >= 0 && (P[se--] = I >> 24 & 255), fe = 0, W = 0) : (fe = I >>> 24, W += 2);
      }
      if (se >= 0)
        for (P[se--] = fe; se >= 0; )
          P[se--] = 0;
    }, Math.clz32 ? d.prototype._countBits = function(P) {
      return 32 - Math.clz32(P);
    } : d.prototype._countBits = function(P) {
      var J = P, se = 0;
      return J >= 4096 && (se += 13, J >>>= 13), J >= 64 && (se += 7, J >>>= 7), J >= 8 && (se += 4, J >>>= 4), J >= 2 && (se += 2, J >>>= 2), se + J;
    }, d.prototype._zeroBits = function(P) {
      if (P === 0)
        return 26;
      var J = P, se = 0;
      return J & 8191 || (se += 13, J >>>= 13), J & 127 || (se += 7, J >>>= 7), J & 15 || (se += 4, J >>>= 4), J & 3 || (se += 2, J >>>= 2), J & 1 || se++, se;
    }, d.prototype.bitLength = function() {
      var P = this.words[this.length - 1], J = this._countBits(P);
      return (this.length - 1) * 26 + J;
    };
    function G(w) {
      for (var P = new Array(w.bitLength()), J = 0; J < P.length; J++) {
        var se = J / 26 | 0, fe = J % 26;
        P[J] = w.words[se] >>> fe & 1;
      }
      return P;
    }
    d.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var P = 0, J = 0; J < this.length; J++) {
        var se = this._zeroBits(this.words[J]);
        if (P += se, se !== 26)
          break;
      }
      return P;
    }, d.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, d.prototype.toTwos = function(P) {
      return this.negative !== 0 ? this.abs().inotn(P).iaddn(1) : this.clone();
    }, d.prototype.fromTwos = function(P) {
      return this.testn(P - 1) ? this.notn(P).iaddn(1).ineg() : this.clone();
    }, d.prototype.isNeg = function() {
      return this.negative !== 0;
    }, d.prototype.neg = function() {
      return this.clone().ineg();
    }, d.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, d.prototype.iuor = function(P) {
      for (; this.length < P.length; )
        this.words[this.length++] = 0;
      for (var J = 0; J < P.length; J++)
        this.words[J] = this.words[J] | P.words[J];
      return this._strip();
    }, d.prototype.ior = function(P) {
      return u((this.negative | P.negative) === 0), this.iuor(P);
    }, d.prototype.or = function(P) {
      return this.length > P.length ? this.clone().ior(P) : P.clone().ior(this);
    }, d.prototype.uor = function(P) {
      return this.length > P.length ? this.clone().iuor(P) : P.clone().iuor(this);
    }, d.prototype.iuand = function(P) {
      var J;
      this.length > P.length ? J = P : J = this;
      for (var se = 0; se < J.length; se++)
        this.words[se] = this.words[se] & P.words[se];
      return this.length = J.length, this._strip();
    }, d.prototype.iand = function(P) {
      return u((this.negative | P.negative) === 0), this.iuand(P);
    }, d.prototype.and = function(P) {
      return this.length > P.length ? this.clone().iand(P) : P.clone().iand(this);
    }, d.prototype.uand = function(P) {
      return this.length > P.length ? this.clone().iuand(P) : P.clone().iuand(this);
    }, d.prototype.iuxor = function(P) {
      var J, se;
      this.length > P.length ? (J = this, se = P) : (J = P, se = this);
      for (var fe = 0; fe < se.length; fe++)
        this.words[fe] = J.words[fe] ^ se.words[fe];
      if (this !== J)
        for (; fe < J.length; fe++)
          this.words[fe] = J.words[fe];
      return this.length = J.length, this._strip();
    }, d.prototype.ixor = function(P) {
      return u((this.negative | P.negative) === 0), this.iuxor(P);
    }, d.prototype.xor = function(P) {
      return this.length > P.length ? this.clone().ixor(P) : P.clone().ixor(this);
    }, d.prototype.uxor = function(P) {
      return this.length > P.length ? this.clone().iuxor(P) : P.clone().iuxor(this);
    }, d.prototype.inotn = function(P) {
      u(typeof P == "number" && P >= 0);
      var J = Math.ceil(P / 26) | 0, se = P % 26;
      this._expand(J), se > 0 && J--;
      for (var fe = 0; fe < J; fe++)
        this.words[fe] = ~this.words[fe] & 67108863;
      return se > 0 && (this.words[fe] = ~this.words[fe] & 67108863 >> 26 - se), this._strip();
    }, d.prototype.notn = function(P) {
      return this.clone().inotn(P);
    }, d.prototype.setn = function(P, J) {
      u(typeof P == "number" && P >= 0);
      var se = P / 26 | 0, fe = P % 26;
      return this._expand(se + 1), J ? this.words[se] = this.words[se] | 1 << fe : this.words[se] = this.words[se] & ~(1 << fe), this._strip();
    }, d.prototype.iadd = function(P) {
      var J;
      if (this.negative !== 0 && P.negative === 0)
        return this.negative = 0, J = this.isub(P), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && P.negative !== 0)
        return P.negative = 0, J = this.isub(P), P.negative = 1, J._normSign();
      var se, fe;
      this.length > P.length ? (se = this, fe = P) : (se = P, fe = this);
      for (var N = 0, W = 0; W < fe.length; W++)
        J = (se.words[W] | 0) + (fe.words[W] | 0) + N, this.words[W] = J & 67108863, N = J >>> 26;
      for (; N !== 0 && W < se.length; W++)
        J = (se.words[W] | 0) + N, this.words[W] = J & 67108863, N = J >>> 26;
      if (this.length = se.length, N !== 0)
        this.words[this.length] = N, this.length++;
      else if (se !== this)
        for (; W < se.length; W++)
          this.words[W] = se.words[W];
      return this;
    }, d.prototype.add = function(P) {
      var J;
      return P.negative !== 0 && this.negative === 0 ? (P.negative = 0, J = this.sub(P), P.negative ^= 1, J) : P.negative === 0 && this.negative !== 0 ? (this.negative = 0, J = P.sub(this), this.negative = 1, J) : this.length > P.length ? this.clone().iadd(P) : P.clone().iadd(this);
    }, d.prototype.isub = function(P) {
      if (P.negative !== 0) {
        P.negative = 0;
        var J = this.iadd(P);
        return P.negative = 1, J._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(P), this.negative = 1, this._normSign();
      var se = this.cmp(P);
      if (se === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var fe, N;
      se > 0 ? (fe = this, N = P) : (fe = P, N = this);
      for (var W = 0, I = 0; I < N.length; I++)
        J = (fe.words[I] | 0) - (N.words[I] | 0) + W, W = J >> 26, this.words[I] = J & 67108863;
      for (; W !== 0 && I < fe.length; I++)
        J = (fe.words[I] | 0) + W, W = J >> 26, this.words[I] = J & 67108863;
      if (W === 0 && I < fe.length && fe !== this)
        for (; I < fe.length; I++)
          this.words[I] = fe.words[I];
      return this.length = Math.max(this.length, I), fe !== this && (this.negative = 1), this._strip();
    }, d.prototype.sub = function(P) {
      return this.clone().isub(P);
    };
    function k(w, P, J) {
      J.negative = P.negative ^ w.negative;
      var se = w.length + P.length | 0;
      J.length = se, se = se - 1 | 0;
      var fe = w.words[0] | 0, N = P.words[0] | 0, W = fe * N, I = W & 67108863, te = W / 67108864 | 0;
      J.words[0] = I;
      for (var ge = 1; ge < se; ge++) {
        for (var Pe = te >>> 26, Ke = te & 67108863, xe = Math.min(ge, P.length - 1), ze = Math.max(0, ge - w.length + 1); ze <= xe; ze++) {
          var nt = ge - ze | 0;
          fe = w.words[nt] | 0, N = P.words[ze] | 0, W = fe * N + Ke, Pe += W / 67108864 | 0, Ke = W & 67108863;
        }
        J.words[ge] = Ke | 0, te = Pe | 0;
      }
      return te !== 0 ? J.words[ge] = te | 0 : J.length--, J._strip();
    }
    var F = function(P, J, se) {
      var fe = P.words, N = J.words, W = se.words, I = 0, te, ge, Pe, Ke = fe[0] | 0, xe = Ke & 8191, ze = Ke >>> 13, nt = fe[1] | 0, Qt = nt & 8191, Et = nt >>> 13, zt = fe[2] | 0, Nt = zt & 8191, pt = zt >>> 13, at = fe[3] | 0, kt = at & 8191, Ut = at >>> 13, dn = fe[4] | 0, En = dn & 8191, Ht = dn >>> 13, Xt = fe[5] | 0, On = Xt & 8191, sn = Xt >>> 13, At = fe[6] | 0, hn = At & 8191, $t = At >>> 13, Lt = fe[7] | 0, Qn = Lt & 8191, ce = Lt >>> 13, Ze = fe[8] | 0, ft = Ze & 8191, It = Ze >>> 13, rn = fe[9] | 0, Ln = rn & 8191, Pn = rn >>> 13, Ae = N[0] | 0, Me = Ae & 8191, He = Ae >>> 13, cn = N[1] | 0, Wt = cn & 8191, yn = cn >>> 13, pr = N[2] | 0, Uo = pr & 8191, ar = pr >>> 13, Sr = N[3] | 0, Jo = Sr & 8191, fr = Sr >>> 13, Er = N[4] | 0, vo = Er & 8191, lr = Er >>> 13, $r = N[5] | 0, Wo = $r & 8191, yr = $r >>> 13, Dr = N[6] | 0, Zo = Dr & 8191, dr = Dr >>> 13, Br = N[7] | 0, Qo = Br & 8191, tr = Br >>> 13, Mr = N[8] | 0, qo = Mr & 8191, hr = Mr >>> 13, Or = N[9] | 0, Fo = Or & 8191, No = Or >>> 13;
      se.negative = P.negative ^ J.negative, se.length = 19, te = Math.imul(xe, Me), ge = Math.imul(xe, He), ge = ge + Math.imul(ze, Me) | 0, Pe = Math.imul(ze, He);
      var di = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, te = Math.imul(Qt, Me), ge = Math.imul(Qt, He), ge = ge + Math.imul(Et, Me) | 0, Pe = Math.imul(Et, He), te = te + Math.imul(xe, Wt) | 0, ge = ge + Math.imul(xe, yn) | 0, ge = ge + Math.imul(ze, Wt) | 0, Pe = Pe + Math.imul(ze, yn) | 0;
      var gi = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, te = Math.imul(Nt, Me), ge = Math.imul(Nt, He), ge = ge + Math.imul(pt, Me) | 0, Pe = Math.imul(pt, He), te = te + Math.imul(Qt, Wt) | 0, ge = ge + Math.imul(Qt, yn) | 0, ge = ge + Math.imul(Et, Wt) | 0, Pe = Pe + Math.imul(Et, yn) | 0, te = te + Math.imul(xe, Uo) | 0, ge = ge + Math.imul(xe, ar) | 0, ge = ge + Math.imul(ze, Uo) | 0, Pe = Pe + Math.imul(ze, ar) | 0;
      var ai = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, te = Math.imul(kt, Me), ge = Math.imul(kt, He), ge = ge + Math.imul(Ut, Me) | 0, Pe = Math.imul(Ut, He), te = te + Math.imul(Nt, Wt) | 0, ge = ge + Math.imul(Nt, yn) | 0, ge = ge + Math.imul(pt, Wt) | 0, Pe = Pe + Math.imul(pt, yn) | 0, te = te + Math.imul(Qt, Uo) | 0, ge = ge + Math.imul(Qt, ar) | 0, ge = ge + Math.imul(Et, Uo) | 0, Pe = Pe + Math.imul(Et, ar) | 0, te = te + Math.imul(xe, Jo) | 0, ge = ge + Math.imul(xe, fr) | 0, ge = ge + Math.imul(ze, Jo) | 0, Pe = Pe + Math.imul(ze, fr) | 0;
      var ui = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, te = Math.imul(En, Me), ge = Math.imul(En, He), ge = ge + Math.imul(Ht, Me) | 0, Pe = Math.imul(Ht, He), te = te + Math.imul(kt, Wt) | 0, ge = ge + Math.imul(kt, yn) | 0, ge = ge + Math.imul(Ut, Wt) | 0, Pe = Pe + Math.imul(Ut, yn) | 0, te = te + Math.imul(Nt, Uo) | 0, ge = ge + Math.imul(Nt, ar) | 0, ge = ge + Math.imul(pt, Uo) | 0, Pe = Pe + Math.imul(pt, ar) | 0, te = te + Math.imul(Qt, Jo) | 0, ge = ge + Math.imul(Qt, fr) | 0, ge = ge + Math.imul(Et, Jo) | 0, Pe = Pe + Math.imul(Et, fr) | 0, te = te + Math.imul(xe, vo) | 0, ge = ge + Math.imul(xe, lr) | 0, ge = ge + Math.imul(ze, vo) | 0, Pe = Pe + Math.imul(ze, lr) | 0;
      var hi = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (hi >>> 26) | 0, hi &= 67108863, te = Math.imul(On, Me), ge = Math.imul(On, He), ge = ge + Math.imul(sn, Me) | 0, Pe = Math.imul(sn, He), te = te + Math.imul(En, Wt) | 0, ge = ge + Math.imul(En, yn) | 0, ge = ge + Math.imul(Ht, Wt) | 0, Pe = Pe + Math.imul(Ht, yn) | 0, te = te + Math.imul(kt, Uo) | 0, ge = ge + Math.imul(kt, ar) | 0, ge = ge + Math.imul(Ut, Uo) | 0, Pe = Pe + Math.imul(Ut, ar) | 0, te = te + Math.imul(Nt, Jo) | 0, ge = ge + Math.imul(Nt, fr) | 0, ge = ge + Math.imul(pt, Jo) | 0, Pe = Pe + Math.imul(pt, fr) | 0, te = te + Math.imul(Qt, vo) | 0, ge = ge + Math.imul(Qt, lr) | 0, ge = ge + Math.imul(Et, vo) | 0, Pe = Pe + Math.imul(Et, lr) | 0, te = te + Math.imul(xe, Wo) | 0, ge = ge + Math.imul(xe, yr) | 0, ge = ge + Math.imul(ze, Wo) | 0, Pe = Pe + Math.imul(ze, yr) | 0;
      var bi = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, te = Math.imul(hn, Me), ge = Math.imul(hn, He), ge = ge + Math.imul($t, Me) | 0, Pe = Math.imul($t, He), te = te + Math.imul(On, Wt) | 0, ge = ge + Math.imul(On, yn) | 0, ge = ge + Math.imul(sn, Wt) | 0, Pe = Pe + Math.imul(sn, yn) | 0, te = te + Math.imul(En, Uo) | 0, ge = ge + Math.imul(En, ar) | 0, ge = ge + Math.imul(Ht, Uo) | 0, Pe = Pe + Math.imul(Ht, ar) | 0, te = te + Math.imul(kt, Jo) | 0, ge = ge + Math.imul(kt, fr) | 0, ge = ge + Math.imul(Ut, Jo) | 0, Pe = Pe + Math.imul(Ut, fr) | 0, te = te + Math.imul(Nt, vo) | 0, ge = ge + Math.imul(Nt, lr) | 0, ge = ge + Math.imul(pt, vo) | 0, Pe = Pe + Math.imul(pt, lr) | 0, te = te + Math.imul(Qt, Wo) | 0, ge = ge + Math.imul(Qt, yr) | 0, ge = ge + Math.imul(Et, Wo) | 0, Pe = Pe + Math.imul(Et, yr) | 0, te = te + Math.imul(xe, Zo) | 0, ge = ge + Math.imul(xe, dr) | 0, ge = ge + Math.imul(ze, Zo) | 0, Pe = Pe + Math.imul(ze, dr) | 0;
      var ii = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, te = Math.imul(Qn, Me), ge = Math.imul(Qn, He), ge = ge + Math.imul(ce, Me) | 0, Pe = Math.imul(ce, He), te = te + Math.imul(hn, Wt) | 0, ge = ge + Math.imul(hn, yn) | 0, ge = ge + Math.imul($t, Wt) | 0, Pe = Pe + Math.imul($t, yn) | 0, te = te + Math.imul(On, Uo) | 0, ge = ge + Math.imul(On, ar) | 0, ge = ge + Math.imul(sn, Uo) | 0, Pe = Pe + Math.imul(sn, ar) | 0, te = te + Math.imul(En, Jo) | 0, ge = ge + Math.imul(En, fr) | 0, ge = ge + Math.imul(Ht, Jo) | 0, Pe = Pe + Math.imul(Ht, fr) | 0, te = te + Math.imul(kt, vo) | 0, ge = ge + Math.imul(kt, lr) | 0, ge = ge + Math.imul(Ut, vo) | 0, Pe = Pe + Math.imul(Ut, lr) | 0, te = te + Math.imul(Nt, Wo) | 0, ge = ge + Math.imul(Nt, yr) | 0, ge = ge + Math.imul(pt, Wo) | 0, Pe = Pe + Math.imul(pt, yr) | 0, te = te + Math.imul(Qt, Zo) | 0, ge = ge + Math.imul(Qt, dr) | 0, ge = ge + Math.imul(Et, Zo) | 0, Pe = Pe + Math.imul(Et, dr) | 0, te = te + Math.imul(xe, Qo) | 0, ge = ge + Math.imul(xe, tr) | 0, ge = ge + Math.imul(ze, Qo) | 0, Pe = Pe + Math.imul(ze, tr) | 0;
      var pi = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (pi >>> 26) | 0, pi &= 67108863, te = Math.imul(ft, Me), ge = Math.imul(ft, He), ge = ge + Math.imul(It, Me) | 0, Pe = Math.imul(It, He), te = te + Math.imul(Qn, Wt) | 0, ge = ge + Math.imul(Qn, yn) | 0, ge = ge + Math.imul(ce, Wt) | 0, Pe = Pe + Math.imul(ce, yn) | 0, te = te + Math.imul(hn, Uo) | 0, ge = ge + Math.imul(hn, ar) | 0, ge = ge + Math.imul($t, Uo) | 0, Pe = Pe + Math.imul($t, ar) | 0, te = te + Math.imul(On, Jo) | 0, ge = ge + Math.imul(On, fr) | 0, ge = ge + Math.imul(sn, Jo) | 0, Pe = Pe + Math.imul(sn, fr) | 0, te = te + Math.imul(En, vo) | 0, ge = ge + Math.imul(En, lr) | 0, ge = ge + Math.imul(Ht, vo) | 0, Pe = Pe + Math.imul(Ht, lr) | 0, te = te + Math.imul(kt, Wo) | 0, ge = ge + Math.imul(kt, yr) | 0, ge = ge + Math.imul(Ut, Wo) | 0, Pe = Pe + Math.imul(Ut, yr) | 0, te = te + Math.imul(Nt, Zo) | 0, ge = ge + Math.imul(Nt, dr) | 0, ge = ge + Math.imul(pt, Zo) | 0, Pe = Pe + Math.imul(pt, dr) | 0, te = te + Math.imul(Qt, Qo) | 0, ge = ge + Math.imul(Qt, tr) | 0, ge = ge + Math.imul(Et, Qo) | 0, Pe = Pe + Math.imul(Et, tr) | 0, te = te + Math.imul(xe, qo) | 0, ge = ge + Math.imul(xe, hr) | 0, ge = ge + Math.imul(ze, qo) | 0, Pe = Pe + Math.imul(ze, hr) | 0;
      var Ci = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, te = Math.imul(Ln, Me), ge = Math.imul(Ln, He), ge = ge + Math.imul(Pn, Me) | 0, Pe = Math.imul(Pn, He), te = te + Math.imul(ft, Wt) | 0, ge = ge + Math.imul(ft, yn) | 0, ge = ge + Math.imul(It, Wt) | 0, Pe = Pe + Math.imul(It, yn) | 0, te = te + Math.imul(Qn, Uo) | 0, ge = ge + Math.imul(Qn, ar) | 0, ge = ge + Math.imul(ce, Uo) | 0, Pe = Pe + Math.imul(ce, ar) | 0, te = te + Math.imul(hn, Jo) | 0, ge = ge + Math.imul(hn, fr) | 0, ge = ge + Math.imul($t, Jo) | 0, Pe = Pe + Math.imul($t, fr) | 0, te = te + Math.imul(On, vo) | 0, ge = ge + Math.imul(On, lr) | 0, ge = ge + Math.imul(sn, vo) | 0, Pe = Pe + Math.imul(sn, lr) | 0, te = te + Math.imul(En, Wo) | 0, ge = ge + Math.imul(En, yr) | 0, ge = ge + Math.imul(Ht, Wo) | 0, Pe = Pe + Math.imul(Ht, yr) | 0, te = te + Math.imul(kt, Zo) | 0, ge = ge + Math.imul(kt, dr) | 0, ge = ge + Math.imul(Ut, Zo) | 0, Pe = Pe + Math.imul(Ut, dr) | 0, te = te + Math.imul(Nt, Qo) | 0, ge = ge + Math.imul(Nt, tr) | 0, ge = ge + Math.imul(pt, Qo) | 0, Pe = Pe + Math.imul(pt, tr) | 0, te = te + Math.imul(Qt, qo) | 0, ge = ge + Math.imul(Qt, hr) | 0, ge = ge + Math.imul(Et, qo) | 0, Pe = Pe + Math.imul(Et, hr) | 0, te = te + Math.imul(xe, Fo) | 0, ge = ge + Math.imul(xe, No) | 0, ge = ge + Math.imul(ze, Fo) | 0, Pe = Pe + Math.imul(ze, No) | 0;
      var _i = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (_i >>> 26) | 0, _i &= 67108863, te = Math.imul(Ln, Wt), ge = Math.imul(Ln, yn), ge = ge + Math.imul(Pn, Wt) | 0, Pe = Math.imul(Pn, yn), te = te + Math.imul(ft, Uo) | 0, ge = ge + Math.imul(ft, ar) | 0, ge = ge + Math.imul(It, Uo) | 0, Pe = Pe + Math.imul(It, ar) | 0, te = te + Math.imul(Qn, Jo) | 0, ge = ge + Math.imul(Qn, fr) | 0, ge = ge + Math.imul(ce, Jo) | 0, Pe = Pe + Math.imul(ce, fr) | 0, te = te + Math.imul(hn, vo) | 0, ge = ge + Math.imul(hn, lr) | 0, ge = ge + Math.imul($t, vo) | 0, Pe = Pe + Math.imul($t, lr) | 0, te = te + Math.imul(On, Wo) | 0, ge = ge + Math.imul(On, yr) | 0, ge = ge + Math.imul(sn, Wo) | 0, Pe = Pe + Math.imul(sn, yr) | 0, te = te + Math.imul(En, Zo) | 0, ge = ge + Math.imul(En, dr) | 0, ge = ge + Math.imul(Ht, Zo) | 0, Pe = Pe + Math.imul(Ht, dr) | 0, te = te + Math.imul(kt, Qo) | 0, ge = ge + Math.imul(kt, tr) | 0, ge = ge + Math.imul(Ut, Qo) | 0, Pe = Pe + Math.imul(Ut, tr) | 0, te = te + Math.imul(Nt, qo) | 0, ge = ge + Math.imul(Nt, hr) | 0, ge = ge + Math.imul(pt, qo) | 0, Pe = Pe + Math.imul(pt, hr) | 0, te = te + Math.imul(Qt, Fo) | 0, ge = ge + Math.imul(Qt, No) | 0, ge = ge + Math.imul(Et, Fo) | 0, Pe = Pe + Math.imul(Et, No) | 0;
      var xn = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, te = Math.imul(Ln, Uo), ge = Math.imul(Ln, ar), ge = ge + Math.imul(Pn, Uo) | 0, Pe = Math.imul(Pn, ar), te = te + Math.imul(ft, Jo) | 0, ge = ge + Math.imul(ft, fr) | 0, ge = ge + Math.imul(It, Jo) | 0, Pe = Pe + Math.imul(It, fr) | 0, te = te + Math.imul(Qn, vo) | 0, ge = ge + Math.imul(Qn, lr) | 0, ge = ge + Math.imul(ce, vo) | 0, Pe = Pe + Math.imul(ce, lr) | 0, te = te + Math.imul(hn, Wo) | 0, ge = ge + Math.imul(hn, yr) | 0, ge = ge + Math.imul($t, Wo) | 0, Pe = Pe + Math.imul($t, yr) | 0, te = te + Math.imul(On, Zo) | 0, ge = ge + Math.imul(On, dr) | 0, ge = ge + Math.imul(sn, Zo) | 0, Pe = Pe + Math.imul(sn, dr) | 0, te = te + Math.imul(En, Qo) | 0, ge = ge + Math.imul(En, tr) | 0, ge = ge + Math.imul(Ht, Qo) | 0, Pe = Pe + Math.imul(Ht, tr) | 0, te = te + Math.imul(kt, qo) | 0, ge = ge + Math.imul(kt, hr) | 0, ge = ge + Math.imul(Ut, qo) | 0, Pe = Pe + Math.imul(Ut, hr) | 0, te = te + Math.imul(Nt, Fo) | 0, ge = ge + Math.imul(Nt, No) | 0, ge = ge + Math.imul(pt, Fo) | 0, Pe = Pe + Math.imul(pt, No) | 0;
      var sr = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (sr >>> 26) | 0, sr &= 67108863, te = Math.imul(Ln, Jo), ge = Math.imul(Ln, fr), ge = ge + Math.imul(Pn, Jo) | 0, Pe = Math.imul(Pn, fr), te = te + Math.imul(ft, vo) | 0, ge = ge + Math.imul(ft, lr) | 0, ge = ge + Math.imul(It, vo) | 0, Pe = Pe + Math.imul(It, lr) | 0, te = te + Math.imul(Qn, Wo) | 0, ge = ge + Math.imul(Qn, yr) | 0, ge = ge + Math.imul(ce, Wo) | 0, Pe = Pe + Math.imul(ce, yr) | 0, te = te + Math.imul(hn, Zo) | 0, ge = ge + Math.imul(hn, dr) | 0, ge = ge + Math.imul($t, Zo) | 0, Pe = Pe + Math.imul($t, dr) | 0, te = te + Math.imul(On, Qo) | 0, ge = ge + Math.imul(On, tr) | 0, ge = ge + Math.imul(sn, Qo) | 0, Pe = Pe + Math.imul(sn, tr) | 0, te = te + Math.imul(En, qo) | 0, ge = ge + Math.imul(En, hr) | 0, ge = ge + Math.imul(Ht, qo) | 0, Pe = Pe + Math.imul(Ht, hr) | 0, te = te + Math.imul(kt, Fo) | 0, ge = ge + Math.imul(kt, No) | 0, ge = ge + Math.imul(Ut, Fo) | 0, Pe = Pe + Math.imul(Ut, No) | 0;
      var Nr = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (Nr >>> 26) | 0, Nr &= 67108863, te = Math.imul(Ln, vo), ge = Math.imul(Ln, lr), ge = ge + Math.imul(Pn, vo) | 0, Pe = Math.imul(Pn, lr), te = te + Math.imul(ft, Wo) | 0, ge = ge + Math.imul(ft, yr) | 0, ge = ge + Math.imul(It, Wo) | 0, Pe = Pe + Math.imul(It, yr) | 0, te = te + Math.imul(Qn, Zo) | 0, ge = ge + Math.imul(Qn, dr) | 0, ge = ge + Math.imul(ce, Zo) | 0, Pe = Pe + Math.imul(ce, dr) | 0, te = te + Math.imul(hn, Qo) | 0, ge = ge + Math.imul(hn, tr) | 0, ge = ge + Math.imul($t, Qo) | 0, Pe = Pe + Math.imul($t, tr) | 0, te = te + Math.imul(On, qo) | 0, ge = ge + Math.imul(On, hr) | 0, ge = ge + Math.imul(sn, qo) | 0, Pe = Pe + Math.imul(sn, hr) | 0, te = te + Math.imul(En, Fo) | 0, ge = ge + Math.imul(En, No) | 0, ge = ge + Math.imul(Ht, Fo) | 0, Pe = Pe + Math.imul(Ht, No) | 0;
      var vr = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, te = Math.imul(Ln, Wo), ge = Math.imul(Ln, yr), ge = ge + Math.imul(Pn, Wo) | 0, Pe = Math.imul(Pn, yr), te = te + Math.imul(ft, Zo) | 0, ge = ge + Math.imul(ft, dr) | 0, ge = ge + Math.imul(It, Zo) | 0, Pe = Pe + Math.imul(It, dr) | 0, te = te + Math.imul(Qn, Qo) | 0, ge = ge + Math.imul(Qn, tr) | 0, ge = ge + Math.imul(ce, Qo) | 0, Pe = Pe + Math.imul(ce, tr) | 0, te = te + Math.imul(hn, qo) | 0, ge = ge + Math.imul(hn, hr) | 0, ge = ge + Math.imul($t, qo) | 0, Pe = Pe + Math.imul($t, hr) | 0, te = te + Math.imul(On, Fo) | 0, ge = ge + Math.imul(On, No) | 0, ge = ge + Math.imul(sn, Fo) | 0, Pe = Pe + Math.imul(sn, No) | 0;
      var Yr = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, te = Math.imul(Ln, Zo), ge = Math.imul(Ln, dr), ge = ge + Math.imul(Pn, Zo) | 0, Pe = Math.imul(Pn, dr), te = te + Math.imul(ft, Qo) | 0, ge = ge + Math.imul(ft, tr) | 0, ge = ge + Math.imul(It, Qo) | 0, Pe = Pe + Math.imul(It, tr) | 0, te = te + Math.imul(Qn, qo) | 0, ge = ge + Math.imul(Qn, hr) | 0, ge = ge + Math.imul(ce, qo) | 0, Pe = Pe + Math.imul(ce, hr) | 0, te = te + Math.imul(hn, Fo) | 0, ge = ge + Math.imul(hn, No) | 0, ge = ge + Math.imul($t, Fo) | 0, Pe = Pe + Math.imul($t, No) | 0;
      var Fr = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, te = Math.imul(Ln, Qo), ge = Math.imul(Ln, tr), ge = ge + Math.imul(Pn, Qo) | 0, Pe = Math.imul(Pn, tr), te = te + Math.imul(ft, qo) | 0, ge = ge + Math.imul(ft, hr) | 0, ge = ge + Math.imul(It, qo) | 0, Pe = Pe + Math.imul(It, hr) | 0, te = te + Math.imul(Qn, Fo) | 0, ge = ge + Math.imul(Qn, No) | 0, ge = ge + Math.imul(ce, Fo) | 0, Pe = Pe + Math.imul(ce, No) | 0;
      var eo = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (eo >>> 26) | 0, eo &= 67108863, te = Math.imul(Ln, qo), ge = Math.imul(Ln, hr), ge = ge + Math.imul(Pn, qo) | 0, Pe = Math.imul(Pn, hr), te = te + Math.imul(ft, Fo) | 0, ge = ge + Math.imul(ft, No) | 0, ge = ge + Math.imul(It, Fo) | 0, Pe = Pe + Math.imul(It, No) | 0;
      var Xr = (I + te | 0) + ((ge & 8191) << 13) | 0;
      I = (Pe + (ge >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, te = Math.imul(Ln, Fo), ge = Math.imul(Ln, No), ge = ge + Math.imul(Pn, Fo) | 0, Pe = Math.imul(Pn, No);
      var Mo = (I + te | 0) + ((ge & 8191) << 13) | 0;
      return I = (Pe + (ge >>> 13) | 0) + (Mo >>> 26) | 0, Mo &= 67108863, W[0] = di, W[1] = gi, W[2] = ai, W[3] = ui, W[4] = hi, W[5] = bi, W[6] = ii, W[7] = pi, W[8] = Ci, W[9] = _i, W[10] = xn, W[11] = sr, W[12] = Nr, W[13] = vr, W[14] = Yr, W[15] = Fr, W[16] = eo, W[17] = Xr, W[18] = Mo, I !== 0 && (W[19] = I, se.length++), se;
    };
    Math.imul || (F = k);
    function X(w, P, J) {
      J.negative = P.negative ^ w.negative, J.length = w.length + P.length;
      for (var se = 0, fe = 0, N = 0; N < J.length - 1; N++) {
        var W = fe;
        fe = 0;
        for (var I = se & 67108863, te = Math.min(N, P.length - 1), ge = Math.max(0, N - w.length + 1); ge <= te; ge++) {
          var Pe = N - ge, Ke = w.words[Pe] | 0, xe = P.words[ge] | 0, ze = Ke * xe, nt = ze & 67108863;
          W = W + (ze / 67108864 | 0) | 0, nt = nt + I | 0, I = nt & 67108863, W = W + (nt >>> 26) | 0, fe += W >>> 26, W &= 67108863;
        }
        J.words[N] = I, se = W, W = fe;
      }
      return se !== 0 ? J.words[N] = se : J.length--, J._strip();
    }
    function ee(w, P, J) {
      return X(w, P, J);
    }
    d.prototype.mulTo = function(P, J) {
      var se, fe = this.length + P.length;
      return this.length === 10 && P.length === 10 ? se = F(this, P, J) : fe < 63 ? se = k(this, P, J) : fe < 1024 ? se = X(this, P, J) : se = ee(this, P, J), se;
    }, d.prototype.mul = function(P) {
      var J = new d(null);
      return J.words = new Array(this.length + P.length), this.mulTo(P, J);
    }, d.prototype.mulf = function(P) {
      var J = new d(null);
      return J.words = new Array(this.length + P.length), ee(this, P, J);
    }, d.prototype.imul = function(P) {
      return this.clone().mulTo(P, this);
    }, d.prototype.imuln = function(P) {
      var J = P < 0;
      J && (P = -P), u(typeof P == "number"), u(P < 67108864);
      for (var se = 0, fe = 0; fe < this.length; fe++) {
        var N = (this.words[fe] | 0) * P, W = (N & 67108863) + (se & 67108863);
        se >>= 26, se += N / 67108864 | 0, se += W >>> 26, this.words[fe] = W & 67108863;
      }
      return se !== 0 && (this.words[fe] = se, this.length++), J ? this.ineg() : this;
    }, d.prototype.muln = function(P) {
      return this.clone().imuln(P);
    }, d.prototype.sqr = function() {
      return this.mul(this);
    }, d.prototype.isqr = function() {
      return this.imul(this.clone());
    }, d.prototype.pow = function(P) {
      var J = G(P);
      if (J.length === 0)
        return new d(1);
      for (var se = this, fe = 0; fe < J.length && J[fe] === 0; fe++, se = se.sqr())
        ;
      if (++fe < J.length)
        for (var N = se.sqr(); fe < J.length; fe++, N = N.sqr())
          J[fe] !== 0 && (se = se.mul(N));
      return se;
    }, d.prototype.iushln = function(P) {
      u(typeof P == "number" && P >= 0);
      var J = P % 26, se = (P - J) / 26, fe = 67108863 >>> 26 - J << 26 - J, N;
      if (J !== 0) {
        var W = 0;
        for (N = 0; N < this.length; N++) {
          var I = this.words[N] & fe, te = (this.words[N] | 0) - I << J;
          this.words[N] = te | W, W = I >>> 26 - J;
        }
        W && (this.words[N] = W, this.length++);
      }
      if (se !== 0) {
        for (N = this.length - 1; N >= 0; N--)
          this.words[N + se] = this.words[N];
        for (N = 0; N < se; N++)
          this.words[N] = 0;
        this.length += se;
      }
      return this._strip();
    }, d.prototype.ishln = function(P) {
      return u(this.negative === 0), this.iushln(P);
    }, d.prototype.iushrn = function(P, J, se) {
      u(typeof P == "number" && P >= 0);
      var fe;
      J ? fe = (J - J % 26) / 26 : fe = 0;
      var N = P % 26, W = Math.min((P - N) / 26, this.length), I = 67108863 ^ 67108863 >>> N << N, te = se;
      if (fe -= W, fe = Math.max(0, fe), te) {
        for (var ge = 0; ge < W; ge++)
          te.words[ge] = this.words[ge];
        te.length = W;
      }
      if (W !== 0)
        if (this.length > W)
          for (this.length -= W, ge = 0; ge < this.length; ge++)
            this.words[ge] = this.words[ge + W];
        else
          this.words[0] = 0, this.length = 1;
      var Pe = 0;
      for (ge = this.length - 1; ge >= 0 && (Pe !== 0 || ge >= fe); ge--) {
        var Ke = this.words[ge] | 0;
        this.words[ge] = Pe << 26 - N | Ke >>> N, Pe = Ke & I;
      }
      return te && Pe !== 0 && (te.words[te.length++] = Pe), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, d.prototype.ishrn = function(P, J, se) {
      return u(this.negative === 0), this.iushrn(P, J, se);
    }, d.prototype.shln = function(P) {
      return this.clone().ishln(P);
    }, d.prototype.ushln = function(P) {
      return this.clone().iushln(P);
    }, d.prototype.shrn = function(P) {
      return this.clone().ishrn(P);
    }, d.prototype.ushrn = function(P) {
      return this.clone().iushrn(P);
    }, d.prototype.testn = function(P) {
      u(typeof P == "number" && P >= 0);
      var J = P % 26, se = (P - J) / 26, fe = 1 << J;
      if (this.length <= se)
        return !1;
      var N = this.words[se];
      return !!(N & fe);
    }, d.prototype.imaskn = function(P) {
      u(typeof P == "number" && P >= 0);
      var J = P % 26, se = (P - J) / 26;
      if (u(this.negative === 0, "imaskn works only with positive numbers"), this.length <= se)
        return this;
      if (J !== 0 && se++, this.length = Math.min(se, this.length), J !== 0) {
        var fe = 67108863 ^ 67108863 >>> J << J;
        this.words[this.length - 1] &= fe;
      }
      return this._strip();
    }, d.prototype.maskn = function(P) {
      return this.clone().imaskn(P);
    }, d.prototype.iaddn = function(P) {
      return u(typeof P == "number"), u(P < 67108864), P < 0 ? this.isubn(-P) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= P ? (this.words[0] = P - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(P), this.negative = 1, this) : this._iaddn(P);
    }, d.prototype._iaddn = function(P) {
      this.words[0] += P;
      for (var J = 0; J < this.length && this.words[J] >= 67108864; J++)
        this.words[J] -= 67108864, J === this.length - 1 ? this.words[J + 1] = 1 : this.words[J + 1]++;
      return this.length = Math.max(this.length, J + 1), this;
    }, d.prototype.isubn = function(P) {
      if (u(typeof P == "number"), u(P < 67108864), P < 0)
        return this.iaddn(-P);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(P), this.negative = 1, this;
      if (this.words[0] -= P, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var J = 0; J < this.length && this.words[J] < 0; J++)
          this.words[J] += 67108864, this.words[J + 1] -= 1;
      return this._strip();
    }, d.prototype.addn = function(P) {
      return this.clone().iaddn(P);
    }, d.prototype.subn = function(P) {
      return this.clone().isubn(P);
    }, d.prototype.iabs = function() {
      return this.negative = 0, this;
    }, d.prototype.abs = function() {
      return this.clone().iabs();
    }, d.prototype._ishlnsubmul = function(P, J, se) {
      var fe = P.length + se, N;
      this._expand(fe);
      var W, I = 0;
      for (N = 0; N < P.length; N++) {
        W = (this.words[N + se] | 0) + I;
        var te = (P.words[N] | 0) * J;
        W -= te & 67108863, I = (W >> 26) - (te / 67108864 | 0), this.words[N + se] = W & 67108863;
      }
      for (; N < this.length - se; N++)
        W = (this.words[N + se] | 0) + I, I = W >> 26, this.words[N + se] = W & 67108863;
      if (I === 0)
        return this._strip();
      for (u(I === -1), I = 0, N = 0; N < this.length; N++)
        W = -(this.words[N] | 0) + I, I = W >> 26, this.words[N] = W & 67108863;
      return this.negative = 1, this._strip();
    }, d.prototype._wordDiv = function(P, J) {
      var se = this.length - P.length, fe = this.clone(), N = P, W = N.words[N.length - 1] | 0, I = this._countBits(W);
      se = 26 - I, se !== 0 && (N = N.ushln(se), fe.iushln(se), W = N.words[N.length - 1] | 0);
      var te = fe.length - N.length, ge;
      if (J !== "mod") {
        ge = new d(null), ge.length = te + 1, ge.words = new Array(ge.length);
        for (var Pe = 0; Pe < ge.length; Pe++)
          ge.words[Pe] = 0;
      }
      var Ke = fe.clone()._ishlnsubmul(N, 1, te);
      Ke.negative === 0 && (fe = Ke, ge && (ge.words[te] = 1));
      for (var xe = te - 1; xe >= 0; xe--) {
        var ze = (fe.words[N.length + xe] | 0) * 67108864 + (fe.words[N.length + xe - 1] | 0);
        for (ze = Math.min(ze / W | 0, 67108863), fe._ishlnsubmul(N, ze, xe); fe.negative !== 0; )
          ze--, fe.negative = 0, fe._ishlnsubmul(N, 1, xe), fe.isZero() || (fe.negative ^= 1);
        ge && (ge.words[xe] = ze);
      }
      return ge && ge._strip(), fe._strip(), J !== "div" && se !== 0 && fe.iushrn(se), {
        div: ge || null,
        mod: fe
      };
    }, d.prototype.divmod = function(P, J, se) {
      if (u(!P.isZero()), this.isZero())
        return {
          div: new d(0),
          mod: new d(0)
        };
      var fe, N, W;
      return this.negative !== 0 && P.negative === 0 ? (W = this.neg().divmod(P, J), J !== "mod" && (fe = W.div.neg()), J !== "div" && (N = W.mod.neg(), se && N.negative !== 0 && N.iadd(P)), {
        div: fe,
        mod: N
      }) : this.negative === 0 && P.negative !== 0 ? (W = this.divmod(P.neg(), J), J !== "mod" && (fe = W.div.neg()), {
        div: fe,
        mod: W.mod
      }) : this.negative & P.negative ? (W = this.neg().divmod(P.neg(), J), J !== "div" && (N = W.mod.neg(), se && N.negative !== 0 && N.isub(P)), {
        div: W.div,
        mod: N
      }) : P.length > this.length || this.cmp(P) < 0 ? {
        div: new d(0),
        mod: this
      } : P.length === 1 ? J === "div" ? {
        div: this.divn(P.words[0]),
        mod: null
      } : J === "mod" ? {
        div: null,
        mod: new d(this.modrn(P.words[0]))
      } : {
        div: this.divn(P.words[0]),
        mod: new d(this.modrn(P.words[0]))
      } : this._wordDiv(P, J);
    }, d.prototype.div = function(P) {
      return this.divmod(P, "div", !1).div;
    }, d.prototype.mod = function(P) {
      return this.divmod(P, "mod", !1).mod;
    }, d.prototype.umod = function(P) {
      return this.divmod(P, "mod", !0).mod;
    }, d.prototype.divRound = function(P) {
      var J = this.divmod(P);
      if (J.mod.isZero())
        return J.div;
      var se = J.div.negative !== 0 ? J.mod.isub(P) : J.mod, fe = P.ushrn(1), N = P.andln(1), W = se.cmp(fe);
      return W < 0 || N === 1 && W === 0 ? J.div : J.div.negative !== 0 ? J.div.isubn(1) : J.div.iaddn(1);
    }, d.prototype.modrn = function(P) {
      var J = P < 0;
      J && (P = -P), u(P <= 67108863);
      for (var se = (1 << 26) % P, fe = 0, N = this.length - 1; N >= 0; N--)
        fe = (se * fe + (this.words[N] | 0)) % P;
      return J ? -fe : fe;
    }, d.prototype.modn = function(P) {
      return this.modrn(P);
    }, d.prototype.idivn = function(P) {
      var J = P < 0;
      J && (P = -P), u(P <= 67108863);
      for (var se = 0, fe = this.length - 1; fe >= 0; fe--) {
        var N = (this.words[fe] | 0) + se * 67108864;
        this.words[fe] = N / P | 0, se = N % P;
      }
      return this._strip(), J ? this.ineg() : this;
    }, d.prototype.divn = function(P) {
      return this.clone().idivn(P);
    }, d.prototype.egcd = function(P) {
      u(P.negative === 0), u(!P.isZero());
      var J = this, se = P.clone();
      J.negative !== 0 ? J = J.umod(P) : J = J.clone();
      for (var fe = new d(1), N = new d(0), W = new d(0), I = new d(1), te = 0; J.isEven() && se.isEven(); )
        J.iushrn(1), se.iushrn(1), ++te;
      for (var ge = se.clone(), Pe = J.clone(); !J.isZero(); ) {
        for (var Ke = 0, xe = 1; !(J.words[0] & xe) && Ke < 26; ++Ke, xe <<= 1)
          ;
        if (Ke > 0)
          for (J.iushrn(Ke); Ke-- > 0; )
            (fe.isOdd() || N.isOdd()) && (fe.iadd(ge), N.isub(Pe)), fe.iushrn(1), N.iushrn(1);
        for (var ze = 0, nt = 1; !(se.words[0] & nt) && ze < 26; ++ze, nt <<= 1)
          ;
        if (ze > 0)
          for (se.iushrn(ze); ze-- > 0; )
            (W.isOdd() || I.isOdd()) && (W.iadd(ge), I.isub(Pe)), W.iushrn(1), I.iushrn(1);
        J.cmp(se) >= 0 ? (J.isub(se), fe.isub(W), N.isub(I)) : (se.isub(J), W.isub(fe), I.isub(N));
      }
      return {
        a: W,
        b: I,
        gcd: se.iushln(te)
      };
    }, d.prototype._invmp = function(P) {
      u(P.negative === 0), u(!P.isZero());
      var J = this, se = P.clone();
      J.negative !== 0 ? J = J.umod(P) : J = J.clone();
      for (var fe = new d(1), N = new d(0), W = se.clone(); J.cmpn(1) > 0 && se.cmpn(1) > 0; ) {
        for (var I = 0, te = 1; !(J.words[0] & te) && I < 26; ++I, te <<= 1)
          ;
        if (I > 0)
          for (J.iushrn(I); I-- > 0; )
            fe.isOdd() && fe.iadd(W), fe.iushrn(1);
        for (var ge = 0, Pe = 1; !(se.words[0] & Pe) && ge < 26; ++ge, Pe <<= 1)
          ;
        if (ge > 0)
          for (se.iushrn(ge); ge-- > 0; )
            N.isOdd() && N.iadd(W), N.iushrn(1);
        J.cmp(se) >= 0 ? (J.isub(se), fe.isub(N)) : (se.isub(J), N.isub(fe));
      }
      var Ke;
      return J.cmpn(1) === 0 ? Ke = fe : Ke = N, Ke.cmpn(0) < 0 && Ke.iadd(P), Ke;
    }, d.prototype.gcd = function(P) {
      if (this.isZero())
        return P.abs();
      if (P.isZero())
        return this.abs();
      var J = this.clone(), se = P.clone();
      J.negative = 0, se.negative = 0;
      for (var fe = 0; J.isEven() && se.isEven(); fe++)
        J.iushrn(1), se.iushrn(1);
      do {
        for (; J.isEven(); )
          J.iushrn(1);
        for (; se.isEven(); )
          se.iushrn(1);
        var N = J.cmp(se);
        if (N < 0) {
          var W = J;
          J = se, se = W;
        } else if (N === 0 || se.cmpn(1) === 0)
          break;
        J.isub(se);
      } while (!0);
      return se.iushln(fe);
    }, d.prototype.invm = function(P) {
      return this.egcd(P).a.umod(P);
    }, d.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, d.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, d.prototype.andln = function(P) {
      return this.words[0] & P;
    }, d.prototype.bincn = function(P) {
      u(typeof P == "number");
      var J = P % 26, se = (P - J) / 26, fe = 1 << J;
      if (this.length <= se)
        return this._expand(se + 1), this.words[se] |= fe, this;
      for (var N = fe, W = se; N !== 0 && W < this.length; W++) {
        var I = this.words[W] | 0;
        I += N, N = I >>> 26, I &= 67108863, this.words[W] = I;
      }
      return N !== 0 && (this.words[W] = N, this.length++), this;
    }, d.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, d.prototype.cmpn = function(P) {
      var J = P < 0;
      if (this.negative !== 0 && !J)
        return -1;
      if (this.negative === 0 && J)
        return 1;
      this._strip();
      var se;
      if (this.length > 1)
        se = 1;
      else {
        J && (P = -P), u(P <= 67108863, "Number is too big");
        var fe = this.words[0] | 0;
        se = fe === P ? 0 : fe < P ? -1 : 1;
      }
      return this.negative !== 0 ? -se | 0 : se;
    }, d.prototype.cmp = function(P) {
      if (this.negative !== 0 && P.negative === 0)
        return -1;
      if (this.negative === 0 && P.negative !== 0)
        return 1;
      var J = this.ucmp(P);
      return this.negative !== 0 ? -J | 0 : J;
    }, d.prototype.ucmp = function(P) {
      if (this.length > P.length)
        return 1;
      if (this.length < P.length)
        return -1;
      for (var J = 0, se = this.length - 1; se >= 0; se--) {
        var fe = this.words[se] | 0, N = P.words[se] | 0;
        if (fe !== N) {
          fe < N ? J = -1 : fe > N && (J = 1);
          break;
        }
      }
      return J;
    }, d.prototype.gtn = function(P) {
      return this.cmpn(P) === 1;
    }, d.prototype.gt = function(P) {
      return this.cmp(P) === 1;
    }, d.prototype.gten = function(P) {
      return this.cmpn(P) >= 0;
    }, d.prototype.gte = function(P) {
      return this.cmp(P) >= 0;
    }, d.prototype.ltn = function(P) {
      return this.cmpn(P) === -1;
    }, d.prototype.lt = function(P) {
      return this.cmp(P) === -1;
    }, d.prototype.lten = function(P) {
      return this.cmpn(P) <= 0;
    }, d.prototype.lte = function(P) {
      return this.cmp(P) <= 0;
    }, d.prototype.eqn = function(P) {
      return this.cmpn(P) === 0;
    }, d.prototype.eq = function(P) {
      return this.cmp(P) === 0;
    }, d.red = function(P) {
      return new H(P);
    }, d.prototype.toRed = function(P) {
      return u(!this.red, "Already a number in reduction context"), u(this.negative === 0, "red works only with positives"), P.convertTo(this)._forceRed(P);
    }, d.prototype.fromRed = function() {
      return u(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, d.prototype._forceRed = function(P) {
      return this.red = P, this;
    }, d.prototype.forceRed = function(P) {
      return u(!this.red, "Already a number in reduction context"), this._forceRed(P);
    }, d.prototype.redAdd = function(P) {
      return u(this.red, "redAdd works only with red numbers"), this.red.add(this, P);
    }, d.prototype.redIAdd = function(P) {
      return u(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, P);
    }, d.prototype.redSub = function(P) {
      return u(this.red, "redSub works only with red numbers"), this.red.sub(this, P);
    }, d.prototype.redISub = function(P) {
      return u(this.red, "redISub works only with red numbers"), this.red.isub(this, P);
    }, d.prototype.redShl = function(P) {
      return u(this.red, "redShl works only with red numbers"), this.red.shl(this, P);
    }, d.prototype.redMul = function(P) {
      return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, P), this.red.mul(this, P);
    }, d.prototype.redIMul = function(P) {
      return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, P), this.red.imul(this, P);
    }, d.prototype.redSqr = function() {
      return u(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, d.prototype.redISqr = function() {
      return u(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, d.prototype.redSqrt = function() {
      return u(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, d.prototype.redInvm = function() {
      return u(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, d.prototype.redNeg = function() {
      return u(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, d.prototype.redPow = function(P) {
      return u(this.red && !P.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, P);
    };
    var ue = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Q(w, P) {
      this.name = w, this.p = new d(P, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Q.prototype._tmp = function() {
      var P = new d(null);
      return P.words = new Array(Math.ceil(this.n / 13)), P;
    }, Q.prototype.ireduce = function(P) {
      var J = P, se;
      do
        this.split(J, this.tmp), J = this.imulK(J), J = J.iadd(this.tmp), se = J.bitLength();
      while (se > this.n);
      var fe = se < this.n ? -1 : J.ucmp(this.p);
      return fe === 0 ? (J.words[0] = 0, J.length = 1) : fe > 0 ? J.isub(this.p) : J.strip !== void 0 ? J.strip() : J._strip(), J;
    }, Q.prototype.split = function(P, J) {
      P.iushrn(this.n, 0, J);
    }, Q.prototype.imulK = function(P) {
      return P.imul(this.k);
    };
    function Y() {
      Q.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    c(Y, Q), Y.prototype.split = function(P, J) {
      for (var se = 4194303, fe = Math.min(P.length, 9), N = 0; N < fe; N++)
        J.words[N] = P.words[N];
      if (J.length = fe, P.length <= 9) {
        P.words[0] = 0, P.length = 1;
        return;
      }
      var W = P.words[9];
      for (J.words[J.length++] = W & se, N = 10; N < P.length; N++) {
        var I = P.words[N] | 0;
        P.words[N - 10] = (I & se) << 4 | W >>> 22, W = I;
      }
      W >>>= 22, P.words[N - 10] = W, W === 0 && P.length > 10 ? P.length -= 10 : P.length -= 9;
    }, Y.prototype.imulK = function(P) {
      P.words[P.length] = 0, P.words[P.length + 1] = 0, P.length += 2;
      for (var J = 0, se = 0; se < P.length; se++) {
        var fe = P.words[se] | 0;
        J += fe * 977, P.words[se] = J & 67108863, J = fe * 64 + (J / 67108864 | 0);
      }
      return P.words[P.length - 1] === 0 && (P.length--, P.words[P.length - 1] === 0 && P.length--), P;
    };
    function pe() {
      Q.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    c(pe, Q);
    function oe() {
      Q.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    c(oe, Q);
    function ne() {
      Q.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    c(ne, Q), ne.prototype.imulK = function(P) {
      for (var J = 0, se = 0; se < P.length; se++) {
        var fe = (P.words[se] | 0) * 19 + J, N = fe & 67108863;
        fe >>>= 26, P.words[se] = N, J = fe;
      }
      return J !== 0 && (P.words[P.length++] = J), P;
    }, d._prime = function(P) {
      if (ue[P])
        return ue[P];
      var J;
      if (P === "k256")
        J = new Y();
      else if (P === "p224")
        J = new pe();
      else if (P === "p192")
        J = new oe();
      else if (P === "p25519")
        J = new ne();
      else
        throw new Error("Unknown prime " + P);
      return ue[P] = J, J;
    };
    function H(w) {
      if (typeof w == "string") {
        var P = d._prime(w);
        this.m = P.p, this.prime = P;
      } else
        u(w.gtn(1), "modulus must be greater than 1"), this.m = w, this.prime = null;
    }
    H.prototype._verify1 = function(P) {
      u(P.negative === 0, "red works only with positives"), u(P.red, "red works only with red numbers");
    }, H.prototype._verify2 = function(P, J) {
      u((P.negative | J.negative) === 0, "red works only with positives"), u(
        P.red && P.red === J.red,
        "red works only with red numbers"
      );
    }, H.prototype.imod = function(P) {
      return this.prime ? this.prime.ireduce(P)._forceRed(this) : (E(P, P.umod(this.m)._forceRed(this)), P);
    }, H.prototype.neg = function(P) {
      return P.isZero() ? P.clone() : this.m.sub(P)._forceRed(this);
    }, H.prototype.add = function(P, J) {
      this._verify2(P, J);
      var se = P.add(J);
      return se.cmp(this.m) >= 0 && se.isub(this.m), se._forceRed(this);
    }, H.prototype.iadd = function(P, J) {
      this._verify2(P, J);
      var se = P.iadd(J);
      return se.cmp(this.m) >= 0 && se.isub(this.m), se;
    }, H.prototype.sub = function(P, J) {
      this._verify2(P, J);
      var se = P.sub(J);
      return se.cmpn(0) < 0 && se.iadd(this.m), se._forceRed(this);
    }, H.prototype.isub = function(P, J) {
      this._verify2(P, J);
      var se = P.isub(J);
      return se.cmpn(0) < 0 && se.iadd(this.m), se;
    }, H.prototype.shl = function(P, J) {
      return this._verify1(P), this.imod(P.ushln(J));
    }, H.prototype.imul = function(P, J) {
      return this._verify2(P, J), this.imod(P.imul(J));
    }, H.prototype.mul = function(P, J) {
      return this._verify2(P, J), this.imod(P.mul(J));
    }, H.prototype.isqr = function(P) {
      return this.imul(P, P.clone());
    }, H.prototype.sqr = function(P) {
      return this.mul(P, P);
    }, H.prototype.sqrt = function(P) {
      if (P.isZero())
        return P.clone();
      var J = this.m.andln(3);
      if (u(J % 2 === 1), J === 3) {
        var se = this.m.add(new d(1)).iushrn(2);
        return this.pow(P, se);
      }
      for (var fe = this.m.subn(1), N = 0; !fe.isZero() && fe.andln(1) === 0; )
        N++, fe.iushrn(1);
      u(!fe.isZero());
      var W = new d(1).toRed(this), I = W.redNeg(), te = this.m.subn(1).iushrn(1), ge = this.m.bitLength();
      for (ge = new d(2 * ge * ge).toRed(this); this.pow(ge, te).cmp(I) !== 0; )
        ge.redIAdd(I);
      for (var Pe = this.pow(ge, fe), Ke = this.pow(P, fe.addn(1).iushrn(1)), xe = this.pow(P, fe), ze = N; xe.cmp(W) !== 0; ) {
        for (var nt = xe, Qt = 0; nt.cmp(W) !== 0; Qt++)
          nt = nt.redSqr();
        u(Qt < ze);
        var Et = this.pow(Pe, new d(1).iushln(ze - Qt - 1));
        Ke = Ke.redMul(Et), Pe = Et.redSqr(), xe = xe.redMul(Pe), ze = Qt;
      }
      return Ke;
    }, H.prototype.invm = function(P) {
      var J = P._invmp(this.m);
      return J.negative !== 0 ? (J.negative = 0, this.imod(J).redNeg()) : this.imod(J);
    }, H.prototype.pow = function(P, J) {
      if (J.isZero())
        return new d(1).toRed(this);
      if (J.cmpn(1) === 0)
        return P.clone();
      var se = 4, fe = new Array(1 << se);
      fe[0] = new d(1).toRed(this), fe[1] = P;
      for (var N = 2; N < fe.length; N++)
        fe[N] = this.mul(fe[N - 1], P);
      var W = fe[0], I = 0, te = 0, ge = J.bitLength() % 26;
      for (ge === 0 && (ge = 26), N = J.length - 1; N >= 0; N--) {
        for (var Pe = J.words[N], Ke = ge - 1; Ke >= 0; Ke--) {
          var xe = Pe >> Ke & 1;
          if (W !== fe[0] && (W = this.sqr(W)), xe === 0 && I === 0) {
            te = 0;
            continue;
          }
          I <<= 1, I |= xe, te++, !(te !== se && (N !== 0 || Ke !== 0)) && (W = this.mul(W, fe[I]), te = 0, I = 0);
        }
        ge = 26;
      }
      return W;
    }, H.prototype.convertTo = function(P) {
      var J = P.umod(this.m);
      return J === P ? J.clone() : J;
    }, H.prototype.convertFrom = function(P) {
      var J = P.clone();
      return J.red = null, J;
    }, d.mont = function(P) {
      return new C(P);
    };
    function C(w) {
      H.call(this, w), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    c(C, H), C.prototype.convertTo = function(P) {
      return this.imod(P.ushln(this.shift));
    }, C.prototype.convertFrom = function(P) {
      var J = this.imod(P.mul(this.rinv));
      return J.red = null, J;
    }, C.prototype.imul = function(P, J) {
      if (P.isZero() || J.isZero())
        return P.words[0] = 0, P.length = 1, P;
      var se = P.imul(J), fe = se.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), N = se.isub(fe).iushrn(this.shift), W = N;
      return N.cmp(this.m) >= 0 ? W = N.isub(this.m) : N.cmpn(0) < 0 && (W = N.iadd(this.m)), W._forceRed(this);
    }, C.prototype.mul = function(P, J) {
      if (P.isZero() || J.isZero())
        return new d(0)._forceRed(this);
      var se = P.mul(J), fe = se.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), N = se.isub(fe).iushrn(this.shift), W = N;
      return N.cmp(this.m) >= 0 ? W = N.isub(this.m) : N.cmpn(0) < 0 && (W = N.iadd(this.m)), W._forceRed(this);
    }, C.prototype.invm = function(P) {
      var J = this.imod(P._invmp(this.m).mul(this.r2));
      return J._forceRed(this);
    };
  })(e, commonjsGlobal);
})(bn$4);
var bnExports$1 = bn$4.exports;
const BN$7 = /* @__PURE__ */ getDefaultExportFromCjs(bnExports$1);
var browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa)
    return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var e = bnExports$1, n = requireBrowser$b();
  function o(d) {
    var m = u(d), v = m.toRed(e.mont(d.modulus)).redPow(new e(d.publicExponent)).fromRed();
    return { blinder: v, unblinder: m.invm(d.modulus) };
  }
  function u(d) {
    var m = d.modulus.byteLength(), v;
    do
      v = new e(n(m));
    while (v.cmp(d.modulus) >= 0 || !v.umod(d.prime1) || !v.umod(d.prime2));
    return v;
  }
  function c(d, m) {
    var v = o(m), S = m.modulus.byteLength(), $ = new e(d).mul(v.blinder).umod(m.modulus), E = $.toRed(e.mont(m.prime1)), O = $.toRed(e.mont(m.prime2)), T = m.coefficient, y = m.prime1, V = m.prime2, M = E.redPow(m.exponent1).fromRed(), G = O.redPow(m.exponent2).fromRed(), k = M.isub(G).imul(T).umod(y).imul(V);
    return G.iadd(k).imul(v.unblinder).umod(m.modulus).toArrayLike(Buffer, "be", S);
  }
  return c.getr = u, browserifyRsa = c, browserifyRsa;
}
var elliptic = {};
const name$1 = "elliptic", version$5 = "6.5.4", description$1 = "EC cryptography", main$3 = "lib/elliptic.js", files = [
  "lib"
], scripts$1 = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository$1 = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords$1 = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author$1 = "Fedor Indutny <fedor@indutny.com>", license$1 = "MIT", bugs$1 = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage$1 = "https://github.com/indutny/elliptic", devDependencies$1 = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies$1 = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$2 = {
  name: name$1,
  version: version$5,
  description: description$1,
  main: main$3,
  files,
  scripts: scripts$1,
  repository: repository$1,
  keywords: keywords$1,
  author: author$1,
  license: license$1,
  bugs: bugs$1,
  homepage: homepage$1,
  devDependencies: devDependencies$1,
  dependencies: dependencies$1
};
var utils$X = {}, bn$3 = { exports: {} };
bn$3.exports;
(function(e) {
  (function(n, o) {
    function u(H, C) {
      if (!H)
        throw new Error(C || "Assertion failed");
    }
    function c(H, C) {
      H.super_ = C;
      var w = function() {
      };
      w.prototype = C.prototype, H.prototype = new w(), H.prototype.constructor = H;
    }
    function d(H, C, w) {
      if (d.isBN(H))
        return H;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, H !== null && ((C === "le" || C === "be") && (w = C, C = 10), this._init(H || 0, C || 10, w || "be"));
    }
    typeof n == "object" ? n.exports = d : o.BN = d, d.BN = d, d.wordSize = 26;
    var m;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = require$$0$3.Buffer;
    } catch {
    }
    d.isBN = function(C) {
      return C instanceof d ? !0 : C !== null && typeof C == "object" && C.constructor.wordSize === d.wordSize && Array.isArray(C.words);
    }, d.max = function(C, w) {
      return C.cmp(w) > 0 ? C : w;
    }, d.min = function(C, w) {
      return C.cmp(w) < 0 ? C : w;
    }, d.prototype._init = function(C, w, P) {
      if (typeof C == "number")
        return this._initNumber(C, w, P);
      if (typeof C == "object")
        return this._initArray(C, w, P);
      w === "hex" && (w = 16), u(w === (w | 0) && w >= 2 && w <= 36), C = C.toString().replace(/\s+/g, "");
      var J = 0;
      C[0] === "-" && (J++, this.negative = 1), J < C.length && (w === 16 ? this._parseHex(C, J, P) : (this._parseBase(C, w, J), P === "le" && this._initArray(this.toArray(), w, P)));
    }, d.prototype._initNumber = function(C, w, P) {
      C < 0 && (this.negative = 1, C = -C), C < 67108864 ? (this.words = [C & 67108863], this.length = 1) : C < 4503599627370496 ? (this.words = [
        C & 67108863,
        C / 67108864 & 67108863
      ], this.length = 2) : (u(C < 9007199254740992), this.words = [
        C & 67108863,
        C / 67108864 & 67108863,
        1
      ], this.length = 3), P === "le" && this._initArray(this.toArray(), w, P);
    }, d.prototype._initArray = function(C, w, P) {
      if (u(typeof C.length == "number"), C.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(C.length / 3), this.words = new Array(this.length);
      for (var J = 0; J < this.length; J++)
        this.words[J] = 0;
      var se, fe, N = 0;
      if (P === "be")
        for (J = C.length - 1, se = 0; J >= 0; J -= 3)
          fe = C[J] | C[J - 1] << 8 | C[J - 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
      else if (P === "le")
        for (J = 0, se = 0; J < C.length; J += 3)
          fe = C[J] | C[J + 1] << 8 | C[J + 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
      return this.strip();
    };
    function v(H, C) {
      var w = H.charCodeAt(C);
      return w >= 65 && w <= 70 ? w - 55 : w >= 97 && w <= 102 ? w - 87 : w - 48 & 15;
    }
    function S(H, C, w) {
      var P = v(H, w);
      return w - 1 >= C && (P |= v(H, w - 1) << 4), P;
    }
    d.prototype._parseHex = function(C, w, P) {
      this.length = Math.ceil((C.length - w) / 6), this.words = new Array(this.length);
      for (var J = 0; J < this.length; J++)
        this.words[J] = 0;
      var se = 0, fe = 0, N;
      if (P === "be")
        for (J = C.length - 1; J >= w; J -= 2)
          N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
      else {
        var W = C.length - w;
        for (J = W % 2 === 0 ? w + 1 : w; J < C.length; J += 2)
          N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
      }
      this.strip();
    };
    function $(H, C, w, P) {
      for (var J = 0, se = Math.min(H.length, w), fe = C; fe < se; fe++) {
        var N = H.charCodeAt(fe) - 48;
        J *= P, N >= 49 ? J += N - 49 + 10 : N >= 17 ? J += N - 17 + 10 : J += N;
      }
      return J;
    }
    d.prototype._parseBase = function(C, w, P) {
      this.words = [0], this.length = 1;
      for (var J = 0, se = 1; se <= 67108863; se *= w)
        J++;
      J--, se = se / w | 0;
      for (var fe = C.length - P, N = fe % J, W = Math.min(fe, fe - N) + P, I = 0, te = P; te < W; te += J)
        I = $(C, te, te + J, w), this.imuln(se), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
      if (N !== 0) {
        var ge = 1;
        for (I = $(C, te, C.length, w), te = 0; te < N; te++)
          ge *= w;
        this.imuln(ge), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
      }
      this.strip();
    }, d.prototype.copy = function(C) {
      C.words = new Array(this.length);
      for (var w = 0; w < this.length; w++)
        C.words[w] = this.words[w];
      C.length = this.length, C.negative = this.negative, C.red = this.red;
    }, d.prototype.clone = function() {
      var C = new d(null);
      return this.copy(C), C;
    }, d.prototype._expand = function(C) {
      for (; this.length < C; )
        this.words[this.length++] = 0;
      return this;
    }, d.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, d.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, d.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var E = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], O = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], T = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    d.prototype.toString = function(C, w) {
      C = C || 10, w = w | 0 || 1;
      var P;
      if (C === 16 || C === "hex") {
        P = "";
        for (var J = 0, se = 0, fe = 0; fe < this.length; fe++) {
          var N = this.words[fe], W = ((N << J | se) & 16777215).toString(16);
          se = N >>> 24 - J & 16777215, se !== 0 || fe !== this.length - 1 ? P = E[6 - W.length] + W + P : P = W + P, J += 2, J >= 26 && (J -= 26, fe--);
        }
        for (se !== 0 && (P = se.toString(16) + P); P.length % w !== 0; )
          P = "0" + P;
        return this.negative !== 0 && (P = "-" + P), P;
      }
      if (C === (C | 0) && C >= 2 && C <= 36) {
        var I = O[C], te = T[C];
        P = "";
        var ge = this.clone();
        for (ge.negative = 0; !ge.isZero(); ) {
          var Pe = ge.modn(te).toString(C);
          ge = ge.idivn(te), ge.isZero() ? P = Pe + P : P = E[I - Pe.length] + Pe + P;
        }
        for (this.isZero() && (P = "0" + P); P.length % w !== 0; )
          P = "0" + P;
        return this.negative !== 0 && (P = "-" + P), P;
      }
      u(!1, "Base should be between 2 and 36");
    }, d.prototype.toNumber = function() {
      var C = this.words[0];
      return this.length === 2 ? C += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? C += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && u(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -C : C;
    }, d.prototype.toJSON = function() {
      return this.toString(16);
    }, d.prototype.toBuffer = function(C, w) {
      return u(typeof m < "u"), this.toArrayLike(m, C, w);
    }, d.prototype.toArray = function(C, w) {
      return this.toArrayLike(Array, C, w);
    }, d.prototype.toArrayLike = function(C, w, P) {
      var J = this.byteLength(), se = P || Math.max(1, J);
      u(J <= se, "byte array longer than desired length"), u(se > 0, "Requested array length <= 0"), this.strip();
      var fe = w === "le", N = new C(se), W, I, te = this.clone();
      if (fe) {
        for (I = 0; !te.isZero(); I++)
          W = te.andln(255), te.iushrn(8), N[I] = W;
        for (; I < se; I++)
          N[I] = 0;
      } else {
        for (I = 0; I < se - J; I++)
          N[I] = 0;
        for (I = 0; !te.isZero(); I++)
          W = te.andln(255), te.iushrn(8), N[se - I - 1] = W;
      }
      return N;
    }, Math.clz32 ? d.prototype._countBits = function(C) {
      return 32 - Math.clz32(C);
    } : d.prototype._countBits = function(C) {
      var w = C, P = 0;
      return w >= 4096 && (P += 13, w >>>= 13), w >= 64 && (P += 7, w >>>= 7), w >= 8 && (P += 4, w >>>= 4), w >= 2 && (P += 2, w >>>= 2), P + w;
    }, d.prototype._zeroBits = function(C) {
      if (C === 0)
        return 26;
      var w = C, P = 0;
      return w & 8191 || (P += 13, w >>>= 13), w & 127 || (P += 7, w >>>= 7), w & 15 || (P += 4, w >>>= 4), w & 3 || (P += 2, w >>>= 2), w & 1 || P++, P;
    }, d.prototype.bitLength = function() {
      var C = this.words[this.length - 1], w = this._countBits(C);
      return (this.length - 1) * 26 + w;
    };
    function y(H) {
      for (var C = new Array(H.bitLength()), w = 0; w < C.length; w++) {
        var P = w / 26 | 0, J = w % 26;
        C[w] = (H.words[P] & 1 << J) >>> J;
      }
      return C;
    }
    d.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var C = 0, w = 0; w < this.length; w++) {
        var P = this._zeroBits(this.words[w]);
        if (C += P, P !== 26)
          break;
      }
      return C;
    }, d.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, d.prototype.toTwos = function(C) {
      return this.negative !== 0 ? this.abs().inotn(C).iaddn(1) : this.clone();
    }, d.prototype.fromTwos = function(C) {
      return this.testn(C - 1) ? this.notn(C).iaddn(1).ineg() : this.clone();
    }, d.prototype.isNeg = function() {
      return this.negative !== 0;
    }, d.prototype.neg = function() {
      return this.clone().ineg();
    }, d.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, d.prototype.iuor = function(C) {
      for (; this.length < C.length; )
        this.words[this.length++] = 0;
      for (var w = 0; w < C.length; w++)
        this.words[w] = this.words[w] | C.words[w];
      return this.strip();
    }, d.prototype.ior = function(C) {
      return u((this.negative | C.negative) === 0), this.iuor(C);
    }, d.prototype.or = function(C) {
      return this.length > C.length ? this.clone().ior(C) : C.clone().ior(this);
    }, d.prototype.uor = function(C) {
      return this.length > C.length ? this.clone().iuor(C) : C.clone().iuor(this);
    }, d.prototype.iuand = function(C) {
      var w;
      this.length > C.length ? w = C : w = this;
      for (var P = 0; P < w.length; P++)
        this.words[P] = this.words[P] & C.words[P];
      return this.length = w.length, this.strip();
    }, d.prototype.iand = function(C) {
      return u((this.negative | C.negative) === 0), this.iuand(C);
    }, d.prototype.and = function(C) {
      return this.length > C.length ? this.clone().iand(C) : C.clone().iand(this);
    }, d.prototype.uand = function(C) {
      return this.length > C.length ? this.clone().iuand(C) : C.clone().iuand(this);
    }, d.prototype.iuxor = function(C) {
      var w, P;
      this.length > C.length ? (w = this, P = C) : (w = C, P = this);
      for (var J = 0; J < P.length; J++)
        this.words[J] = w.words[J] ^ P.words[J];
      if (this !== w)
        for (; J < w.length; J++)
          this.words[J] = w.words[J];
      return this.length = w.length, this.strip();
    }, d.prototype.ixor = function(C) {
      return u((this.negative | C.negative) === 0), this.iuxor(C);
    }, d.prototype.xor = function(C) {
      return this.length > C.length ? this.clone().ixor(C) : C.clone().ixor(this);
    }, d.prototype.uxor = function(C) {
      return this.length > C.length ? this.clone().iuxor(C) : C.clone().iuxor(this);
    }, d.prototype.inotn = function(C) {
      u(typeof C == "number" && C >= 0);
      var w = Math.ceil(C / 26) | 0, P = C % 26;
      this._expand(w), P > 0 && w--;
      for (var J = 0; J < w; J++)
        this.words[J] = ~this.words[J] & 67108863;
      return P > 0 && (this.words[J] = ~this.words[J] & 67108863 >> 26 - P), this.strip();
    }, d.prototype.notn = function(C) {
      return this.clone().inotn(C);
    }, d.prototype.setn = function(C, w) {
      u(typeof C == "number" && C >= 0);
      var P = C / 26 | 0, J = C % 26;
      return this._expand(P + 1), w ? this.words[P] = this.words[P] | 1 << J : this.words[P] = this.words[P] & ~(1 << J), this.strip();
    }, d.prototype.iadd = function(C) {
      var w;
      if (this.negative !== 0 && C.negative === 0)
        return this.negative = 0, w = this.isub(C), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && C.negative !== 0)
        return C.negative = 0, w = this.isub(C), C.negative = 1, w._normSign();
      var P, J;
      this.length > C.length ? (P = this, J = C) : (P = C, J = this);
      for (var se = 0, fe = 0; fe < J.length; fe++)
        w = (P.words[fe] | 0) + (J.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
      for (; se !== 0 && fe < P.length; fe++)
        w = (P.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
      if (this.length = P.length, se !== 0)
        this.words[this.length] = se, this.length++;
      else if (P !== this)
        for (; fe < P.length; fe++)
          this.words[fe] = P.words[fe];
      return this;
    }, d.prototype.add = function(C) {
      var w;
      return C.negative !== 0 && this.negative === 0 ? (C.negative = 0, w = this.sub(C), C.negative ^= 1, w) : C.negative === 0 && this.negative !== 0 ? (this.negative = 0, w = C.sub(this), this.negative = 1, w) : this.length > C.length ? this.clone().iadd(C) : C.clone().iadd(this);
    }, d.prototype.isub = function(C) {
      if (C.negative !== 0) {
        C.negative = 0;
        var w = this.iadd(C);
        return C.negative = 1, w._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(C), this.negative = 1, this._normSign();
      var P = this.cmp(C);
      if (P === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var J, se;
      P > 0 ? (J = this, se = C) : (J = C, se = this);
      for (var fe = 0, N = 0; N < se.length; N++)
        w = (J.words[N] | 0) - (se.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
      for (; fe !== 0 && N < J.length; N++)
        w = (J.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
      if (fe === 0 && N < J.length && J !== this)
        for (; N < J.length; N++)
          this.words[N] = J.words[N];
      return this.length = Math.max(this.length, N), J !== this && (this.negative = 1), this.strip();
    }, d.prototype.sub = function(C) {
      return this.clone().isub(C);
    };
    function V(H, C, w) {
      w.negative = C.negative ^ H.negative;
      var P = H.length + C.length | 0;
      w.length = P, P = P - 1 | 0;
      var J = H.words[0] | 0, se = C.words[0] | 0, fe = J * se, N = fe & 67108863, W = fe / 67108864 | 0;
      w.words[0] = N;
      for (var I = 1; I < P; I++) {
        for (var te = W >>> 26, ge = W & 67108863, Pe = Math.min(I, C.length - 1), Ke = Math.max(0, I - H.length + 1); Ke <= Pe; Ke++) {
          var xe = I - Ke | 0;
          J = H.words[xe] | 0, se = C.words[Ke] | 0, fe = J * se + ge, te += fe / 67108864 | 0, ge = fe & 67108863;
        }
        w.words[I] = ge | 0, W = te | 0;
      }
      return W !== 0 ? w.words[I] = W | 0 : w.length--, w.strip();
    }
    var M = function(C, w, P) {
      var J = C.words, se = w.words, fe = P.words, N = 0, W, I, te, ge = J[0] | 0, Pe = ge & 8191, Ke = ge >>> 13, xe = J[1] | 0, ze = xe & 8191, nt = xe >>> 13, Qt = J[2] | 0, Et = Qt & 8191, zt = Qt >>> 13, Nt = J[3] | 0, pt = Nt & 8191, at = Nt >>> 13, kt = J[4] | 0, Ut = kt & 8191, dn = kt >>> 13, En = J[5] | 0, Ht = En & 8191, Xt = En >>> 13, On = J[6] | 0, sn = On & 8191, At = On >>> 13, hn = J[7] | 0, $t = hn & 8191, Lt = hn >>> 13, Qn = J[8] | 0, ce = Qn & 8191, Ze = Qn >>> 13, ft = J[9] | 0, It = ft & 8191, rn = ft >>> 13, Ln = se[0] | 0, Pn = Ln & 8191, Ae = Ln >>> 13, Me = se[1] | 0, He = Me & 8191, cn = Me >>> 13, Wt = se[2] | 0, yn = Wt & 8191, pr = Wt >>> 13, Uo = se[3] | 0, ar = Uo & 8191, Sr = Uo >>> 13, Jo = se[4] | 0, fr = Jo & 8191, Er = Jo >>> 13, vo = se[5] | 0, lr = vo & 8191, $r = vo >>> 13, Wo = se[6] | 0, yr = Wo & 8191, Dr = Wo >>> 13, Zo = se[7] | 0, dr = Zo & 8191, Br = Zo >>> 13, Qo = se[8] | 0, tr = Qo & 8191, Mr = Qo >>> 13, qo = se[9] | 0, hr = qo & 8191, Or = qo >>> 13;
      P.negative = C.negative ^ w.negative, P.length = 19, W = Math.imul(Pe, Pn), I = Math.imul(Pe, Ae), I = I + Math.imul(Ke, Pn) | 0, te = Math.imul(Ke, Ae);
      var Fo = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (Fo >>> 26) | 0, Fo &= 67108863, W = Math.imul(ze, Pn), I = Math.imul(ze, Ae), I = I + Math.imul(nt, Pn) | 0, te = Math.imul(nt, Ae), W = W + Math.imul(Pe, He) | 0, I = I + Math.imul(Pe, cn) | 0, I = I + Math.imul(Ke, He) | 0, te = te + Math.imul(Ke, cn) | 0;
      var No = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, W = Math.imul(Et, Pn), I = Math.imul(Et, Ae), I = I + Math.imul(zt, Pn) | 0, te = Math.imul(zt, Ae), W = W + Math.imul(ze, He) | 0, I = I + Math.imul(ze, cn) | 0, I = I + Math.imul(nt, He) | 0, te = te + Math.imul(nt, cn) | 0, W = W + Math.imul(Pe, yn) | 0, I = I + Math.imul(Pe, pr) | 0, I = I + Math.imul(Ke, yn) | 0, te = te + Math.imul(Ke, pr) | 0;
      var di = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, W = Math.imul(pt, Pn), I = Math.imul(pt, Ae), I = I + Math.imul(at, Pn) | 0, te = Math.imul(at, Ae), W = W + Math.imul(Et, He) | 0, I = I + Math.imul(Et, cn) | 0, I = I + Math.imul(zt, He) | 0, te = te + Math.imul(zt, cn) | 0, W = W + Math.imul(ze, yn) | 0, I = I + Math.imul(ze, pr) | 0, I = I + Math.imul(nt, yn) | 0, te = te + Math.imul(nt, pr) | 0, W = W + Math.imul(Pe, ar) | 0, I = I + Math.imul(Pe, Sr) | 0, I = I + Math.imul(Ke, ar) | 0, te = te + Math.imul(Ke, Sr) | 0;
      var gi = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, W = Math.imul(Ut, Pn), I = Math.imul(Ut, Ae), I = I + Math.imul(dn, Pn) | 0, te = Math.imul(dn, Ae), W = W + Math.imul(pt, He) | 0, I = I + Math.imul(pt, cn) | 0, I = I + Math.imul(at, He) | 0, te = te + Math.imul(at, cn) | 0, W = W + Math.imul(Et, yn) | 0, I = I + Math.imul(Et, pr) | 0, I = I + Math.imul(zt, yn) | 0, te = te + Math.imul(zt, pr) | 0, W = W + Math.imul(ze, ar) | 0, I = I + Math.imul(ze, Sr) | 0, I = I + Math.imul(nt, ar) | 0, te = te + Math.imul(nt, Sr) | 0, W = W + Math.imul(Pe, fr) | 0, I = I + Math.imul(Pe, Er) | 0, I = I + Math.imul(Ke, fr) | 0, te = te + Math.imul(Ke, Er) | 0;
      var ai = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, W = Math.imul(Ht, Pn), I = Math.imul(Ht, Ae), I = I + Math.imul(Xt, Pn) | 0, te = Math.imul(Xt, Ae), W = W + Math.imul(Ut, He) | 0, I = I + Math.imul(Ut, cn) | 0, I = I + Math.imul(dn, He) | 0, te = te + Math.imul(dn, cn) | 0, W = W + Math.imul(pt, yn) | 0, I = I + Math.imul(pt, pr) | 0, I = I + Math.imul(at, yn) | 0, te = te + Math.imul(at, pr) | 0, W = W + Math.imul(Et, ar) | 0, I = I + Math.imul(Et, Sr) | 0, I = I + Math.imul(zt, ar) | 0, te = te + Math.imul(zt, Sr) | 0, W = W + Math.imul(ze, fr) | 0, I = I + Math.imul(ze, Er) | 0, I = I + Math.imul(nt, fr) | 0, te = te + Math.imul(nt, Er) | 0, W = W + Math.imul(Pe, lr) | 0, I = I + Math.imul(Pe, $r) | 0, I = I + Math.imul(Ke, lr) | 0, te = te + Math.imul(Ke, $r) | 0;
      var ui = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, W = Math.imul(sn, Pn), I = Math.imul(sn, Ae), I = I + Math.imul(At, Pn) | 0, te = Math.imul(At, Ae), W = W + Math.imul(Ht, He) | 0, I = I + Math.imul(Ht, cn) | 0, I = I + Math.imul(Xt, He) | 0, te = te + Math.imul(Xt, cn) | 0, W = W + Math.imul(Ut, yn) | 0, I = I + Math.imul(Ut, pr) | 0, I = I + Math.imul(dn, yn) | 0, te = te + Math.imul(dn, pr) | 0, W = W + Math.imul(pt, ar) | 0, I = I + Math.imul(pt, Sr) | 0, I = I + Math.imul(at, ar) | 0, te = te + Math.imul(at, Sr) | 0, W = W + Math.imul(Et, fr) | 0, I = I + Math.imul(Et, Er) | 0, I = I + Math.imul(zt, fr) | 0, te = te + Math.imul(zt, Er) | 0, W = W + Math.imul(ze, lr) | 0, I = I + Math.imul(ze, $r) | 0, I = I + Math.imul(nt, lr) | 0, te = te + Math.imul(nt, $r) | 0, W = W + Math.imul(Pe, yr) | 0, I = I + Math.imul(Pe, Dr) | 0, I = I + Math.imul(Ke, yr) | 0, te = te + Math.imul(Ke, Dr) | 0;
      var hi = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (hi >>> 26) | 0, hi &= 67108863, W = Math.imul($t, Pn), I = Math.imul($t, Ae), I = I + Math.imul(Lt, Pn) | 0, te = Math.imul(Lt, Ae), W = W + Math.imul(sn, He) | 0, I = I + Math.imul(sn, cn) | 0, I = I + Math.imul(At, He) | 0, te = te + Math.imul(At, cn) | 0, W = W + Math.imul(Ht, yn) | 0, I = I + Math.imul(Ht, pr) | 0, I = I + Math.imul(Xt, yn) | 0, te = te + Math.imul(Xt, pr) | 0, W = W + Math.imul(Ut, ar) | 0, I = I + Math.imul(Ut, Sr) | 0, I = I + Math.imul(dn, ar) | 0, te = te + Math.imul(dn, Sr) | 0, W = W + Math.imul(pt, fr) | 0, I = I + Math.imul(pt, Er) | 0, I = I + Math.imul(at, fr) | 0, te = te + Math.imul(at, Er) | 0, W = W + Math.imul(Et, lr) | 0, I = I + Math.imul(Et, $r) | 0, I = I + Math.imul(zt, lr) | 0, te = te + Math.imul(zt, $r) | 0, W = W + Math.imul(ze, yr) | 0, I = I + Math.imul(ze, Dr) | 0, I = I + Math.imul(nt, yr) | 0, te = te + Math.imul(nt, Dr) | 0, W = W + Math.imul(Pe, dr) | 0, I = I + Math.imul(Pe, Br) | 0, I = I + Math.imul(Ke, dr) | 0, te = te + Math.imul(Ke, Br) | 0;
      var bi = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, W = Math.imul(ce, Pn), I = Math.imul(ce, Ae), I = I + Math.imul(Ze, Pn) | 0, te = Math.imul(Ze, Ae), W = W + Math.imul($t, He) | 0, I = I + Math.imul($t, cn) | 0, I = I + Math.imul(Lt, He) | 0, te = te + Math.imul(Lt, cn) | 0, W = W + Math.imul(sn, yn) | 0, I = I + Math.imul(sn, pr) | 0, I = I + Math.imul(At, yn) | 0, te = te + Math.imul(At, pr) | 0, W = W + Math.imul(Ht, ar) | 0, I = I + Math.imul(Ht, Sr) | 0, I = I + Math.imul(Xt, ar) | 0, te = te + Math.imul(Xt, Sr) | 0, W = W + Math.imul(Ut, fr) | 0, I = I + Math.imul(Ut, Er) | 0, I = I + Math.imul(dn, fr) | 0, te = te + Math.imul(dn, Er) | 0, W = W + Math.imul(pt, lr) | 0, I = I + Math.imul(pt, $r) | 0, I = I + Math.imul(at, lr) | 0, te = te + Math.imul(at, $r) | 0, W = W + Math.imul(Et, yr) | 0, I = I + Math.imul(Et, Dr) | 0, I = I + Math.imul(zt, yr) | 0, te = te + Math.imul(zt, Dr) | 0, W = W + Math.imul(ze, dr) | 0, I = I + Math.imul(ze, Br) | 0, I = I + Math.imul(nt, dr) | 0, te = te + Math.imul(nt, Br) | 0, W = W + Math.imul(Pe, tr) | 0, I = I + Math.imul(Pe, Mr) | 0, I = I + Math.imul(Ke, tr) | 0, te = te + Math.imul(Ke, Mr) | 0;
      var ii = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, W = Math.imul(It, Pn), I = Math.imul(It, Ae), I = I + Math.imul(rn, Pn) | 0, te = Math.imul(rn, Ae), W = W + Math.imul(ce, He) | 0, I = I + Math.imul(ce, cn) | 0, I = I + Math.imul(Ze, He) | 0, te = te + Math.imul(Ze, cn) | 0, W = W + Math.imul($t, yn) | 0, I = I + Math.imul($t, pr) | 0, I = I + Math.imul(Lt, yn) | 0, te = te + Math.imul(Lt, pr) | 0, W = W + Math.imul(sn, ar) | 0, I = I + Math.imul(sn, Sr) | 0, I = I + Math.imul(At, ar) | 0, te = te + Math.imul(At, Sr) | 0, W = W + Math.imul(Ht, fr) | 0, I = I + Math.imul(Ht, Er) | 0, I = I + Math.imul(Xt, fr) | 0, te = te + Math.imul(Xt, Er) | 0, W = W + Math.imul(Ut, lr) | 0, I = I + Math.imul(Ut, $r) | 0, I = I + Math.imul(dn, lr) | 0, te = te + Math.imul(dn, $r) | 0, W = W + Math.imul(pt, yr) | 0, I = I + Math.imul(pt, Dr) | 0, I = I + Math.imul(at, yr) | 0, te = te + Math.imul(at, Dr) | 0, W = W + Math.imul(Et, dr) | 0, I = I + Math.imul(Et, Br) | 0, I = I + Math.imul(zt, dr) | 0, te = te + Math.imul(zt, Br) | 0, W = W + Math.imul(ze, tr) | 0, I = I + Math.imul(ze, Mr) | 0, I = I + Math.imul(nt, tr) | 0, te = te + Math.imul(nt, Mr) | 0, W = W + Math.imul(Pe, hr) | 0, I = I + Math.imul(Pe, Or) | 0, I = I + Math.imul(Ke, hr) | 0, te = te + Math.imul(Ke, Or) | 0;
      var pi = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (pi >>> 26) | 0, pi &= 67108863, W = Math.imul(It, He), I = Math.imul(It, cn), I = I + Math.imul(rn, He) | 0, te = Math.imul(rn, cn), W = W + Math.imul(ce, yn) | 0, I = I + Math.imul(ce, pr) | 0, I = I + Math.imul(Ze, yn) | 0, te = te + Math.imul(Ze, pr) | 0, W = W + Math.imul($t, ar) | 0, I = I + Math.imul($t, Sr) | 0, I = I + Math.imul(Lt, ar) | 0, te = te + Math.imul(Lt, Sr) | 0, W = W + Math.imul(sn, fr) | 0, I = I + Math.imul(sn, Er) | 0, I = I + Math.imul(At, fr) | 0, te = te + Math.imul(At, Er) | 0, W = W + Math.imul(Ht, lr) | 0, I = I + Math.imul(Ht, $r) | 0, I = I + Math.imul(Xt, lr) | 0, te = te + Math.imul(Xt, $r) | 0, W = W + Math.imul(Ut, yr) | 0, I = I + Math.imul(Ut, Dr) | 0, I = I + Math.imul(dn, yr) | 0, te = te + Math.imul(dn, Dr) | 0, W = W + Math.imul(pt, dr) | 0, I = I + Math.imul(pt, Br) | 0, I = I + Math.imul(at, dr) | 0, te = te + Math.imul(at, Br) | 0, W = W + Math.imul(Et, tr) | 0, I = I + Math.imul(Et, Mr) | 0, I = I + Math.imul(zt, tr) | 0, te = te + Math.imul(zt, Mr) | 0, W = W + Math.imul(ze, hr) | 0, I = I + Math.imul(ze, Or) | 0, I = I + Math.imul(nt, hr) | 0, te = te + Math.imul(nt, Or) | 0;
      var Ci = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, W = Math.imul(It, yn), I = Math.imul(It, pr), I = I + Math.imul(rn, yn) | 0, te = Math.imul(rn, pr), W = W + Math.imul(ce, ar) | 0, I = I + Math.imul(ce, Sr) | 0, I = I + Math.imul(Ze, ar) | 0, te = te + Math.imul(Ze, Sr) | 0, W = W + Math.imul($t, fr) | 0, I = I + Math.imul($t, Er) | 0, I = I + Math.imul(Lt, fr) | 0, te = te + Math.imul(Lt, Er) | 0, W = W + Math.imul(sn, lr) | 0, I = I + Math.imul(sn, $r) | 0, I = I + Math.imul(At, lr) | 0, te = te + Math.imul(At, $r) | 0, W = W + Math.imul(Ht, yr) | 0, I = I + Math.imul(Ht, Dr) | 0, I = I + Math.imul(Xt, yr) | 0, te = te + Math.imul(Xt, Dr) | 0, W = W + Math.imul(Ut, dr) | 0, I = I + Math.imul(Ut, Br) | 0, I = I + Math.imul(dn, dr) | 0, te = te + Math.imul(dn, Br) | 0, W = W + Math.imul(pt, tr) | 0, I = I + Math.imul(pt, Mr) | 0, I = I + Math.imul(at, tr) | 0, te = te + Math.imul(at, Mr) | 0, W = W + Math.imul(Et, hr) | 0, I = I + Math.imul(Et, Or) | 0, I = I + Math.imul(zt, hr) | 0, te = te + Math.imul(zt, Or) | 0;
      var _i = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (_i >>> 26) | 0, _i &= 67108863, W = Math.imul(It, ar), I = Math.imul(It, Sr), I = I + Math.imul(rn, ar) | 0, te = Math.imul(rn, Sr), W = W + Math.imul(ce, fr) | 0, I = I + Math.imul(ce, Er) | 0, I = I + Math.imul(Ze, fr) | 0, te = te + Math.imul(Ze, Er) | 0, W = W + Math.imul($t, lr) | 0, I = I + Math.imul($t, $r) | 0, I = I + Math.imul(Lt, lr) | 0, te = te + Math.imul(Lt, $r) | 0, W = W + Math.imul(sn, yr) | 0, I = I + Math.imul(sn, Dr) | 0, I = I + Math.imul(At, yr) | 0, te = te + Math.imul(At, Dr) | 0, W = W + Math.imul(Ht, dr) | 0, I = I + Math.imul(Ht, Br) | 0, I = I + Math.imul(Xt, dr) | 0, te = te + Math.imul(Xt, Br) | 0, W = W + Math.imul(Ut, tr) | 0, I = I + Math.imul(Ut, Mr) | 0, I = I + Math.imul(dn, tr) | 0, te = te + Math.imul(dn, Mr) | 0, W = W + Math.imul(pt, hr) | 0, I = I + Math.imul(pt, Or) | 0, I = I + Math.imul(at, hr) | 0, te = te + Math.imul(at, Or) | 0;
      var xn = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, W = Math.imul(It, fr), I = Math.imul(It, Er), I = I + Math.imul(rn, fr) | 0, te = Math.imul(rn, Er), W = W + Math.imul(ce, lr) | 0, I = I + Math.imul(ce, $r) | 0, I = I + Math.imul(Ze, lr) | 0, te = te + Math.imul(Ze, $r) | 0, W = W + Math.imul($t, yr) | 0, I = I + Math.imul($t, Dr) | 0, I = I + Math.imul(Lt, yr) | 0, te = te + Math.imul(Lt, Dr) | 0, W = W + Math.imul(sn, dr) | 0, I = I + Math.imul(sn, Br) | 0, I = I + Math.imul(At, dr) | 0, te = te + Math.imul(At, Br) | 0, W = W + Math.imul(Ht, tr) | 0, I = I + Math.imul(Ht, Mr) | 0, I = I + Math.imul(Xt, tr) | 0, te = te + Math.imul(Xt, Mr) | 0, W = W + Math.imul(Ut, hr) | 0, I = I + Math.imul(Ut, Or) | 0, I = I + Math.imul(dn, hr) | 0, te = te + Math.imul(dn, Or) | 0;
      var sr = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (sr >>> 26) | 0, sr &= 67108863, W = Math.imul(It, lr), I = Math.imul(It, $r), I = I + Math.imul(rn, lr) | 0, te = Math.imul(rn, $r), W = W + Math.imul(ce, yr) | 0, I = I + Math.imul(ce, Dr) | 0, I = I + Math.imul(Ze, yr) | 0, te = te + Math.imul(Ze, Dr) | 0, W = W + Math.imul($t, dr) | 0, I = I + Math.imul($t, Br) | 0, I = I + Math.imul(Lt, dr) | 0, te = te + Math.imul(Lt, Br) | 0, W = W + Math.imul(sn, tr) | 0, I = I + Math.imul(sn, Mr) | 0, I = I + Math.imul(At, tr) | 0, te = te + Math.imul(At, Mr) | 0, W = W + Math.imul(Ht, hr) | 0, I = I + Math.imul(Ht, Or) | 0, I = I + Math.imul(Xt, hr) | 0, te = te + Math.imul(Xt, Or) | 0;
      var Nr = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (Nr >>> 26) | 0, Nr &= 67108863, W = Math.imul(It, yr), I = Math.imul(It, Dr), I = I + Math.imul(rn, yr) | 0, te = Math.imul(rn, Dr), W = W + Math.imul(ce, dr) | 0, I = I + Math.imul(ce, Br) | 0, I = I + Math.imul(Ze, dr) | 0, te = te + Math.imul(Ze, Br) | 0, W = W + Math.imul($t, tr) | 0, I = I + Math.imul($t, Mr) | 0, I = I + Math.imul(Lt, tr) | 0, te = te + Math.imul(Lt, Mr) | 0, W = W + Math.imul(sn, hr) | 0, I = I + Math.imul(sn, Or) | 0, I = I + Math.imul(At, hr) | 0, te = te + Math.imul(At, Or) | 0;
      var vr = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, W = Math.imul(It, dr), I = Math.imul(It, Br), I = I + Math.imul(rn, dr) | 0, te = Math.imul(rn, Br), W = W + Math.imul(ce, tr) | 0, I = I + Math.imul(ce, Mr) | 0, I = I + Math.imul(Ze, tr) | 0, te = te + Math.imul(Ze, Mr) | 0, W = W + Math.imul($t, hr) | 0, I = I + Math.imul($t, Or) | 0, I = I + Math.imul(Lt, hr) | 0, te = te + Math.imul(Lt, Or) | 0;
      var Yr = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, W = Math.imul(It, tr), I = Math.imul(It, Mr), I = I + Math.imul(rn, tr) | 0, te = Math.imul(rn, Mr), W = W + Math.imul(ce, hr) | 0, I = I + Math.imul(ce, Or) | 0, I = I + Math.imul(Ze, hr) | 0, te = te + Math.imul(Ze, Or) | 0;
      var Fr = (N + W | 0) + ((I & 8191) << 13) | 0;
      N = (te + (I >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, W = Math.imul(It, hr), I = Math.imul(It, Or), I = I + Math.imul(rn, hr) | 0, te = Math.imul(rn, Or);
      var eo = (N + W | 0) + ((I & 8191) << 13) | 0;
      return N = (te + (I >>> 13) | 0) + (eo >>> 26) | 0, eo &= 67108863, fe[0] = Fo, fe[1] = No, fe[2] = di, fe[3] = gi, fe[4] = ai, fe[5] = ui, fe[6] = hi, fe[7] = bi, fe[8] = ii, fe[9] = pi, fe[10] = Ci, fe[11] = _i, fe[12] = xn, fe[13] = sr, fe[14] = Nr, fe[15] = vr, fe[16] = Yr, fe[17] = Fr, fe[18] = eo, N !== 0 && (fe[19] = N, P.length++), P;
    };
    Math.imul || (M = V);
    function G(H, C, w) {
      w.negative = C.negative ^ H.negative, w.length = H.length + C.length;
      for (var P = 0, J = 0, se = 0; se < w.length - 1; se++) {
        var fe = J;
        J = 0;
        for (var N = P & 67108863, W = Math.min(se, C.length - 1), I = Math.max(0, se - H.length + 1); I <= W; I++) {
          var te = se - I, ge = H.words[te] | 0, Pe = C.words[I] | 0, Ke = ge * Pe, xe = Ke & 67108863;
          fe = fe + (Ke / 67108864 | 0) | 0, xe = xe + N | 0, N = xe & 67108863, fe = fe + (xe >>> 26) | 0, J += fe >>> 26, fe &= 67108863;
        }
        w.words[se] = N, P = fe, fe = J;
      }
      return P !== 0 ? w.words[se] = P : w.length--, w.strip();
    }
    function k(H, C, w) {
      var P = new F();
      return P.mulp(H, C, w);
    }
    d.prototype.mulTo = function(C, w) {
      var P, J = this.length + C.length;
      return this.length === 10 && C.length === 10 ? P = M(this, C, w) : J < 63 ? P = V(this, C, w) : J < 1024 ? P = G(this, C, w) : P = k(this, C, w), P;
    };
    function F(H, C) {
      this.x = H, this.y = C;
    }
    F.prototype.makeRBT = function(C) {
      for (var w = new Array(C), P = d.prototype._countBits(C) - 1, J = 0; J < C; J++)
        w[J] = this.revBin(J, P, C);
      return w;
    }, F.prototype.revBin = function(C, w, P) {
      if (C === 0 || C === P - 1)
        return C;
      for (var J = 0, se = 0; se < w; se++)
        J |= (C & 1) << w - se - 1, C >>= 1;
      return J;
    }, F.prototype.permute = function(C, w, P, J, se, fe) {
      for (var N = 0; N < fe; N++)
        J[N] = w[C[N]], se[N] = P[C[N]];
    }, F.prototype.transform = function(C, w, P, J, se, fe) {
      this.permute(fe, C, w, P, J, se);
      for (var N = 1; N < se; N <<= 1)
        for (var W = N << 1, I = Math.cos(2 * Math.PI / W), te = Math.sin(2 * Math.PI / W), ge = 0; ge < se; ge += W)
          for (var Pe = I, Ke = te, xe = 0; xe < N; xe++) {
            var ze = P[ge + xe], nt = J[ge + xe], Qt = P[ge + xe + N], Et = J[ge + xe + N], zt = Pe * Qt - Ke * Et;
            Et = Pe * Et + Ke * Qt, Qt = zt, P[ge + xe] = ze + Qt, J[ge + xe] = nt + Et, P[ge + xe + N] = ze - Qt, J[ge + xe + N] = nt - Et, xe !== W && (zt = I * Pe - te * Ke, Ke = I * Ke + te * Pe, Pe = zt);
          }
    }, F.prototype.guessLen13b = function(C, w) {
      var P = Math.max(w, C) | 1, J = P & 1, se = 0;
      for (P = P / 2 | 0; P; P = P >>> 1)
        se++;
      return 1 << se + 1 + J;
    }, F.prototype.conjugate = function(C, w, P) {
      if (!(P <= 1))
        for (var J = 0; J < P / 2; J++) {
          var se = C[J];
          C[J] = C[P - J - 1], C[P - J - 1] = se, se = w[J], w[J] = -w[P - J - 1], w[P - J - 1] = -se;
        }
    }, F.prototype.normalize13b = function(C, w) {
      for (var P = 0, J = 0; J < w / 2; J++) {
        var se = Math.round(C[2 * J + 1] / w) * 8192 + Math.round(C[2 * J] / w) + P;
        C[J] = se & 67108863, se < 67108864 ? P = 0 : P = se / 67108864 | 0;
      }
      return C;
    }, F.prototype.convert13b = function(C, w, P, J) {
      for (var se = 0, fe = 0; fe < w; fe++)
        se = se + (C[fe] | 0), P[2 * fe] = se & 8191, se = se >>> 13, P[2 * fe + 1] = se & 8191, se = se >>> 13;
      for (fe = 2 * w; fe < J; ++fe)
        P[fe] = 0;
      u(se === 0), u((se & -8192) === 0);
    }, F.prototype.stub = function(C) {
      for (var w = new Array(C), P = 0; P < C; P++)
        w[P] = 0;
      return w;
    }, F.prototype.mulp = function(C, w, P) {
      var J = 2 * this.guessLen13b(C.length, w.length), se = this.makeRBT(J), fe = this.stub(J), N = new Array(J), W = new Array(J), I = new Array(J), te = new Array(J), ge = new Array(J), Pe = new Array(J), Ke = P.words;
      Ke.length = J, this.convert13b(C.words, C.length, N, J), this.convert13b(w.words, w.length, te, J), this.transform(N, fe, W, I, J, se), this.transform(te, fe, ge, Pe, J, se);
      for (var xe = 0; xe < J; xe++) {
        var ze = W[xe] * ge[xe] - I[xe] * Pe[xe];
        I[xe] = W[xe] * Pe[xe] + I[xe] * ge[xe], W[xe] = ze;
      }
      return this.conjugate(W, I, J), this.transform(W, I, Ke, fe, J, se), this.conjugate(Ke, fe, J), this.normalize13b(Ke, J), P.negative = C.negative ^ w.negative, P.length = C.length + w.length, P.strip();
    }, d.prototype.mul = function(C) {
      var w = new d(null);
      return w.words = new Array(this.length + C.length), this.mulTo(C, w);
    }, d.prototype.mulf = function(C) {
      var w = new d(null);
      return w.words = new Array(this.length + C.length), k(this, C, w);
    }, d.prototype.imul = function(C) {
      return this.clone().mulTo(C, this);
    }, d.prototype.imuln = function(C) {
      u(typeof C == "number"), u(C < 67108864);
      for (var w = 0, P = 0; P < this.length; P++) {
        var J = (this.words[P] | 0) * C, se = (J & 67108863) + (w & 67108863);
        w >>= 26, w += J / 67108864 | 0, w += se >>> 26, this.words[P] = se & 67108863;
      }
      return w !== 0 && (this.words[P] = w, this.length++), this;
    }, d.prototype.muln = function(C) {
      return this.clone().imuln(C);
    }, d.prototype.sqr = function() {
      return this.mul(this);
    }, d.prototype.isqr = function() {
      return this.imul(this.clone());
    }, d.prototype.pow = function(C) {
      var w = y(C);
      if (w.length === 0)
        return new d(1);
      for (var P = this, J = 0; J < w.length && w[J] === 0; J++, P = P.sqr())
        ;
      if (++J < w.length)
        for (var se = P.sqr(); J < w.length; J++, se = se.sqr())
          w[J] !== 0 && (P = P.mul(se));
      return P;
    }, d.prototype.iushln = function(C) {
      u(typeof C == "number" && C >= 0);
      var w = C % 26, P = (C - w) / 26, J = 67108863 >>> 26 - w << 26 - w, se;
      if (w !== 0) {
        var fe = 0;
        for (se = 0; se < this.length; se++) {
          var N = this.words[se] & J, W = (this.words[se] | 0) - N << w;
          this.words[se] = W | fe, fe = N >>> 26 - w;
        }
        fe && (this.words[se] = fe, this.length++);
      }
      if (P !== 0) {
        for (se = this.length - 1; se >= 0; se--)
          this.words[se + P] = this.words[se];
        for (se = 0; se < P; se++)
          this.words[se] = 0;
        this.length += P;
      }
      return this.strip();
    }, d.prototype.ishln = function(C) {
      return u(this.negative === 0), this.iushln(C);
    }, d.prototype.iushrn = function(C, w, P) {
      u(typeof C == "number" && C >= 0);
      var J;
      w ? J = (w - w % 26) / 26 : J = 0;
      var se = C % 26, fe = Math.min((C - se) / 26, this.length), N = 67108863 ^ 67108863 >>> se << se, W = P;
      if (J -= fe, J = Math.max(0, J), W) {
        for (var I = 0; I < fe; I++)
          W.words[I] = this.words[I];
        W.length = fe;
      }
      if (fe !== 0)
        if (this.length > fe)
          for (this.length -= fe, I = 0; I < this.length; I++)
            this.words[I] = this.words[I + fe];
        else
          this.words[0] = 0, this.length = 1;
      var te = 0;
      for (I = this.length - 1; I >= 0 && (te !== 0 || I >= J); I--) {
        var ge = this.words[I] | 0;
        this.words[I] = te << 26 - se | ge >>> se, te = ge & N;
      }
      return W && te !== 0 && (W.words[W.length++] = te), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, d.prototype.ishrn = function(C, w, P) {
      return u(this.negative === 0), this.iushrn(C, w, P);
    }, d.prototype.shln = function(C) {
      return this.clone().ishln(C);
    }, d.prototype.ushln = function(C) {
      return this.clone().iushln(C);
    }, d.prototype.shrn = function(C) {
      return this.clone().ishrn(C);
    }, d.prototype.ushrn = function(C) {
      return this.clone().iushrn(C);
    }, d.prototype.testn = function(C) {
      u(typeof C == "number" && C >= 0);
      var w = C % 26, P = (C - w) / 26, J = 1 << w;
      if (this.length <= P)
        return !1;
      var se = this.words[P];
      return !!(se & J);
    }, d.prototype.imaskn = function(C) {
      u(typeof C == "number" && C >= 0);
      var w = C % 26, P = (C - w) / 26;
      if (u(this.negative === 0, "imaskn works only with positive numbers"), this.length <= P)
        return this;
      if (w !== 0 && P++, this.length = Math.min(P, this.length), w !== 0) {
        var J = 67108863 ^ 67108863 >>> w << w;
        this.words[this.length - 1] &= J;
      }
      return this.strip();
    }, d.prototype.maskn = function(C) {
      return this.clone().imaskn(C);
    }, d.prototype.iaddn = function(C) {
      return u(typeof C == "number"), u(C < 67108864), C < 0 ? this.isubn(-C) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < C ? (this.words[0] = C - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(C), this.negative = 1, this) : this._iaddn(C);
    }, d.prototype._iaddn = function(C) {
      this.words[0] += C;
      for (var w = 0; w < this.length && this.words[w] >= 67108864; w++)
        this.words[w] -= 67108864, w === this.length - 1 ? this.words[w + 1] = 1 : this.words[w + 1]++;
      return this.length = Math.max(this.length, w + 1), this;
    }, d.prototype.isubn = function(C) {
      if (u(typeof C == "number"), u(C < 67108864), C < 0)
        return this.iaddn(-C);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(C), this.negative = 1, this;
      if (this.words[0] -= C, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var w = 0; w < this.length && this.words[w] < 0; w++)
          this.words[w] += 67108864, this.words[w + 1] -= 1;
      return this.strip();
    }, d.prototype.addn = function(C) {
      return this.clone().iaddn(C);
    }, d.prototype.subn = function(C) {
      return this.clone().isubn(C);
    }, d.prototype.iabs = function() {
      return this.negative = 0, this;
    }, d.prototype.abs = function() {
      return this.clone().iabs();
    }, d.prototype._ishlnsubmul = function(C, w, P) {
      var J = C.length + P, se;
      this._expand(J);
      var fe, N = 0;
      for (se = 0; se < C.length; se++) {
        fe = (this.words[se + P] | 0) + N;
        var W = (C.words[se] | 0) * w;
        fe -= W & 67108863, N = (fe >> 26) - (W / 67108864 | 0), this.words[se + P] = fe & 67108863;
      }
      for (; se < this.length - P; se++)
        fe = (this.words[se + P] | 0) + N, N = fe >> 26, this.words[se + P] = fe & 67108863;
      if (N === 0)
        return this.strip();
      for (u(N === -1), N = 0, se = 0; se < this.length; se++)
        fe = -(this.words[se] | 0) + N, N = fe >> 26, this.words[se] = fe & 67108863;
      return this.negative = 1, this.strip();
    }, d.prototype._wordDiv = function(C, w) {
      var P = this.length - C.length, J = this.clone(), se = C, fe = se.words[se.length - 1] | 0, N = this._countBits(fe);
      P = 26 - N, P !== 0 && (se = se.ushln(P), J.iushln(P), fe = se.words[se.length - 1] | 0);
      var W = J.length - se.length, I;
      if (w !== "mod") {
        I = new d(null), I.length = W + 1, I.words = new Array(I.length);
        for (var te = 0; te < I.length; te++)
          I.words[te] = 0;
      }
      var ge = J.clone()._ishlnsubmul(se, 1, W);
      ge.negative === 0 && (J = ge, I && (I.words[W] = 1));
      for (var Pe = W - 1; Pe >= 0; Pe--) {
        var Ke = (J.words[se.length + Pe] | 0) * 67108864 + (J.words[se.length + Pe - 1] | 0);
        for (Ke = Math.min(Ke / fe | 0, 67108863), J._ishlnsubmul(se, Ke, Pe); J.negative !== 0; )
          Ke--, J.negative = 0, J._ishlnsubmul(se, 1, Pe), J.isZero() || (J.negative ^= 1);
        I && (I.words[Pe] = Ke);
      }
      return I && I.strip(), J.strip(), w !== "div" && P !== 0 && J.iushrn(P), {
        div: I || null,
        mod: J
      };
    }, d.prototype.divmod = function(C, w, P) {
      if (u(!C.isZero()), this.isZero())
        return {
          div: new d(0),
          mod: new d(0)
        };
      var J, se, fe;
      return this.negative !== 0 && C.negative === 0 ? (fe = this.neg().divmod(C, w), w !== "mod" && (J = fe.div.neg()), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.iadd(C)), {
        div: J,
        mod: se
      }) : this.negative === 0 && C.negative !== 0 ? (fe = this.divmod(C.neg(), w), w !== "mod" && (J = fe.div.neg()), {
        div: J,
        mod: fe.mod
      }) : this.negative & C.negative ? (fe = this.neg().divmod(C.neg(), w), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.isub(C)), {
        div: fe.div,
        mod: se
      }) : C.length > this.length || this.cmp(C) < 0 ? {
        div: new d(0),
        mod: this
      } : C.length === 1 ? w === "div" ? {
        div: this.divn(C.words[0]),
        mod: null
      } : w === "mod" ? {
        div: null,
        mod: new d(this.modn(C.words[0]))
      } : {
        div: this.divn(C.words[0]),
        mod: new d(this.modn(C.words[0]))
      } : this._wordDiv(C, w);
    }, d.prototype.div = function(C) {
      return this.divmod(C, "div", !1).div;
    }, d.prototype.mod = function(C) {
      return this.divmod(C, "mod", !1).mod;
    }, d.prototype.umod = function(C) {
      return this.divmod(C, "mod", !0).mod;
    }, d.prototype.divRound = function(C) {
      var w = this.divmod(C);
      if (w.mod.isZero())
        return w.div;
      var P = w.div.negative !== 0 ? w.mod.isub(C) : w.mod, J = C.ushrn(1), se = C.andln(1), fe = P.cmp(J);
      return fe < 0 || se === 1 && fe === 0 ? w.div : w.div.negative !== 0 ? w.div.isubn(1) : w.div.iaddn(1);
    }, d.prototype.modn = function(C) {
      u(C <= 67108863);
      for (var w = (1 << 26) % C, P = 0, J = this.length - 1; J >= 0; J--)
        P = (w * P + (this.words[J] | 0)) % C;
      return P;
    }, d.prototype.idivn = function(C) {
      u(C <= 67108863);
      for (var w = 0, P = this.length - 1; P >= 0; P--) {
        var J = (this.words[P] | 0) + w * 67108864;
        this.words[P] = J / C | 0, w = J % C;
      }
      return this.strip();
    }, d.prototype.divn = function(C) {
      return this.clone().idivn(C);
    }, d.prototype.egcd = function(C) {
      u(C.negative === 0), u(!C.isZero());
      var w = this, P = C.clone();
      w.negative !== 0 ? w = w.umod(C) : w = w.clone();
      for (var J = new d(1), se = new d(0), fe = new d(0), N = new d(1), W = 0; w.isEven() && P.isEven(); )
        w.iushrn(1), P.iushrn(1), ++W;
      for (var I = P.clone(), te = w.clone(); !w.isZero(); ) {
        for (var ge = 0, Pe = 1; !(w.words[0] & Pe) && ge < 26; ++ge, Pe <<= 1)
          ;
        if (ge > 0)
          for (w.iushrn(ge); ge-- > 0; )
            (J.isOdd() || se.isOdd()) && (J.iadd(I), se.isub(te)), J.iushrn(1), se.iushrn(1);
        for (var Ke = 0, xe = 1; !(P.words[0] & xe) && Ke < 26; ++Ke, xe <<= 1)
          ;
        if (Ke > 0)
          for (P.iushrn(Ke); Ke-- > 0; )
            (fe.isOdd() || N.isOdd()) && (fe.iadd(I), N.isub(te)), fe.iushrn(1), N.iushrn(1);
        w.cmp(P) >= 0 ? (w.isub(P), J.isub(fe), se.isub(N)) : (P.isub(w), fe.isub(J), N.isub(se));
      }
      return {
        a: fe,
        b: N,
        gcd: P.iushln(W)
      };
    }, d.prototype._invmp = function(C) {
      u(C.negative === 0), u(!C.isZero());
      var w = this, P = C.clone();
      w.negative !== 0 ? w = w.umod(C) : w = w.clone();
      for (var J = new d(1), se = new d(0), fe = P.clone(); w.cmpn(1) > 0 && P.cmpn(1) > 0; ) {
        for (var N = 0, W = 1; !(w.words[0] & W) && N < 26; ++N, W <<= 1)
          ;
        if (N > 0)
          for (w.iushrn(N); N-- > 0; )
            J.isOdd() && J.iadd(fe), J.iushrn(1);
        for (var I = 0, te = 1; !(P.words[0] & te) && I < 26; ++I, te <<= 1)
          ;
        if (I > 0)
          for (P.iushrn(I); I-- > 0; )
            se.isOdd() && se.iadd(fe), se.iushrn(1);
        w.cmp(P) >= 0 ? (w.isub(P), J.isub(se)) : (P.isub(w), se.isub(J));
      }
      var ge;
      return w.cmpn(1) === 0 ? ge = J : ge = se, ge.cmpn(0) < 0 && ge.iadd(C), ge;
    }, d.prototype.gcd = function(C) {
      if (this.isZero())
        return C.abs();
      if (C.isZero())
        return this.abs();
      var w = this.clone(), P = C.clone();
      w.negative = 0, P.negative = 0;
      for (var J = 0; w.isEven() && P.isEven(); J++)
        w.iushrn(1), P.iushrn(1);
      do {
        for (; w.isEven(); )
          w.iushrn(1);
        for (; P.isEven(); )
          P.iushrn(1);
        var se = w.cmp(P);
        if (se < 0) {
          var fe = w;
          w = P, P = fe;
        } else if (se === 0 || P.cmpn(1) === 0)
          break;
        w.isub(P);
      } while (!0);
      return P.iushln(J);
    }, d.prototype.invm = function(C) {
      return this.egcd(C).a.umod(C);
    }, d.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, d.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, d.prototype.andln = function(C) {
      return this.words[0] & C;
    }, d.prototype.bincn = function(C) {
      u(typeof C == "number");
      var w = C % 26, P = (C - w) / 26, J = 1 << w;
      if (this.length <= P)
        return this._expand(P + 1), this.words[P] |= J, this;
      for (var se = J, fe = P; se !== 0 && fe < this.length; fe++) {
        var N = this.words[fe] | 0;
        N += se, se = N >>> 26, N &= 67108863, this.words[fe] = N;
      }
      return se !== 0 && (this.words[fe] = se, this.length++), this;
    }, d.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, d.prototype.cmpn = function(C) {
      var w = C < 0;
      if (this.negative !== 0 && !w)
        return -1;
      if (this.negative === 0 && w)
        return 1;
      this.strip();
      var P;
      if (this.length > 1)
        P = 1;
      else {
        w && (C = -C), u(C <= 67108863, "Number is too big");
        var J = this.words[0] | 0;
        P = J === C ? 0 : J < C ? -1 : 1;
      }
      return this.negative !== 0 ? -P | 0 : P;
    }, d.prototype.cmp = function(C) {
      if (this.negative !== 0 && C.negative === 0)
        return -1;
      if (this.negative === 0 && C.negative !== 0)
        return 1;
      var w = this.ucmp(C);
      return this.negative !== 0 ? -w | 0 : w;
    }, d.prototype.ucmp = function(C) {
      if (this.length > C.length)
        return 1;
      if (this.length < C.length)
        return -1;
      for (var w = 0, P = this.length - 1; P >= 0; P--) {
        var J = this.words[P] | 0, se = C.words[P] | 0;
        if (J !== se) {
          J < se ? w = -1 : J > se && (w = 1);
          break;
        }
      }
      return w;
    }, d.prototype.gtn = function(C) {
      return this.cmpn(C) === 1;
    }, d.prototype.gt = function(C) {
      return this.cmp(C) === 1;
    }, d.prototype.gten = function(C) {
      return this.cmpn(C) >= 0;
    }, d.prototype.gte = function(C) {
      return this.cmp(C) >= 0;
    }, d.prototype.ltn = function(C) {
      return this.cmpn(C) === -1;
    }, d.prototype.lt = function(C) {
      return this.cmp(C) === -1;
    }, d.prototype.lten = function(C) {
      return this.cmpn(C) <= 0;
    }, d.prototype.lte = function(C) {
      return this.cmp(C) <= 0;
    }, d.prototype.eqn = function(C) {
      return this.cmpn(C) === 0;
    }, d.prototype.eq = function(C) {
      return this.cmp(C) === 0;
    }, d.red = function(C) {
      return new oe(C);
    }, d.prototype.toRed = function(C) {
      return u(!this.red, "Already a number in reduction context"), u(this.negative === 0, "red works only with positives"), C.convertTo(this)._forceRed(C);
    }, d.prototype.fromRed = function() {
      return u(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, d.prototype._forceRed = function(C) {
      return this.red = C, this;
    }, d.prototype.forceRed = function(C) {
      return u(!this.red, "Already a number in reduction context"), this._forceRed(C);
    }, d.prototype.redAdd = function(C) {
      return u(this.red, "redAdd works only with red numbers"), this.red.add(this, C);
    }, d.prototype.redIAdd = function(C) {
      return u(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, C);
    }, d.prototype.redSub = function(C) {
      return u(this.red, "redSub works only with red numbers"), this.red.sub(this, C);
    }, d.prototype.redISub = function(C) {
      return u(this.red, "redISub works only with red numbers"), this.red.isub(this, C);
    }, d.prototype.redShl = function(C) {
      return u(this.red, "redShl works only with red numbers"), this.red.shl(this, C);
    }, d.prototype.redMul = function(C) {
      return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.mul(this, C);
    }, d.prototype.redIMul = function(C) {
      return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.imul(this, C);
    }, d.prototype.redSqr = function() {
      return u(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, d.prototype.redISqr = function() {
      return u(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, d.prototype.redSqrt = function() {
      return u(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, d.prototype.redInvm = function() {
      return u(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, d.prototype.redNeg = function() {
      return u(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, d.prototype.redPow = function(C) {
      return u(this.red && !C.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, C);
    };
    var X = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function ee(H, C) {
      this.name = H, this.p = new d(C, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    ee.prototype._tmp = function() {
      var C = new d(null);
      return C.words = new Array(Math.ceil(this.n / 13)), C;
    }, ee.prototype.ireduce = function(C) {
      var w = C, P;
      do
        this.split(w, this.tmp), w = this.imulK(w), w = w.iadd(this.tmp), P = w.bitLength();
      while (P > this.n);
      var J = P < this.n ? -1 : w.ucmp(this.p);
      return J === 0 ? (w.words[0] = 0, w.length = 1) : J > 0 ? w.isub(this.p) : w.strip !== void 0 ? w.strip() : w._strip(), w;
    }, ee.prototype.split = function(C, w) {
      C.iushrn(this.n, 0, w);
    }, ee.prototype.imulK = function(C) {
      return C.imul(this.k);
    };
    function ue() {
      ee.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    c(ue, ee), ue.prototype.split = function(C, w) {
      for (var P = 4194303, J = Math.min(C.length, 9), se = 0; se < J; se++)
        w.words[se] = C.words[se];
      if (w.length = J, C.length <= 9) {
        C.words[0] = 0, C.length = 1;
        return;
      }
      var fe = C.words[9];
      for (w.words[w.length++] = fe & P, se = 10; se < C.length; se++) {
        var N = C.words[se] | 0;
        C.words[se - 10] = (N & P) << 4 | fe >>> 22, fe = N;
      }
      fe >>>= 22, C.words[se - 10] = fe, fe === 0 && C.length > 10 ? C.length -= 10 : C.length -= 9;
    }, ue.prototype.imulK = function(C) {
      C.words[C.length] = 0, C.words[C.length + 1] = 0, C.length += 2;
      for (var w = 0, P = 0; P < C.length; P++) {
        var J = C.words[P] | 0;
        w += J * 977, C.words[P] = w & 67108863, w = J * 64 + (w / 67108864 | 0);
      }
      return C.words[C.length - 1] === 0 && (C.length--, C.words[C.length - 1] === 0 && C.length--), C;
    };
    function Q() {
      ee.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    c(Q, ee);
    function Y() {
      ee.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    c(Y, ee);
    function pe() {
      ee.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    c(pe, ee), pe.prototype.imulK = function(C) {
      for (var w = 0, P = 0; P < C.length; P++) {
        var J = (C.words[P] | 0) * 19 + w, se = J & 67108863;
        J >>>= 26, C.words[P] = se, w = J;
      }
      return w !== 0 && (C.words[C.length++] = w), C;
    }, d._prime = function(C) {
      if (X[C])
        return X[C];
      var w;
      if (C === "k256")
        w = new ue();
      else if (C === "p224")
        w = new Q();
      else if (C === "p192")
        w = new Y();
      else if (C === "p25519")
        w = new pe();
      else
        throw new Error("Unknown prime " + C);
      return X[C] = w, w;
    };
    function oe(H) {
      if (typeof H == "string") {
        var C = d._prime(H);
        this.m = C.p, this.prime = C;
      } else
        u(H.gtn(1), "modulus must be greater than 1"), this.m = H, this.prime = null;
    }
    oe.prototype._verify1 = function(C) {
      u(C.negative === 0, "red works only with positives"), u(C.red, "red works only with red numbers");
    }, oe.prototype._verify2 = function(C, w) {
      u((C.negative | w.negative) === 0, "red works only with positives"), u(
        C.red && C.red === w.red,
        "red works only with red numbers"
      );
    }, oe.prototype.imod = function(C) {
      return this.prime ? this.prime.ireduce(C)._forceRed(this) : C.umod(this.m)._forceRed(this);
    }, oe.prototype.neg = function(C) {
      return C.isZero() ? C.clone() : this.m.sub(C)._forceRed(this);
    }, oe.prototype.add = function(C, w) {
      this._verify2(C, w);
      var P = C.add(w);
      return P.cmp(this.m) >= 0 && P.isub(this.m), P._forceRed(this);
    }, oe.prototype.iadd = function(C, w) {
      this._verify2(C, w);
      var P = C.iadd(w);
      return P.cmp(this.m) >= 0 && P.isub(this.m), P;
    }, oe.prototype.sub = function(C, w) {
      this._verify2(C, w);
      var P = C.sub(w);
      return P.cmpn(0) < 0 && P.iadd(this.m), P._forceRed(this);
    }, oe.prototype.isub = function(C, w) {
      this._verify2(C, w);
      var P = C.isub(w);
      return P.cmpn(0) < 0 && P.iadd(this.m), P;
    }, oe.prototype.shl = function(C, w) {
      return this._verify1(C), this.imod(C.ushln(w));
    }, oe.prototype.imul = function(C, w) {
      return this._verify2(C, w), this.imod(C.imul(w));
    }, oe.prototype.mul = function(C, w) {
      return this._verify2(C, w), this.imod(C.mul(w));
    }, oe.prototype.isqr = function(C) {
      return this.imul(C, C.clone());
    }, oe.prototype.sqr = function(C) {
      return this.mul(C, C);
    }, oe.prototype.sqrt = function(C) {
      if (C.isZero())
        return C.clone();
      var w = this.m.andln(3);
      if (u(w % 2 === 1), w === 3) {
        var P = this.m.add(new d(1)).iushrn(2);
        return this.pow(C, P);
      }
      for (var J = this.m.subn(1), se = 0; !J.isZero() && J.andln(1) === 0; )
        se++, J.iushrn(1);
      u(!J.isZero());
      var fe = new d(1).toRed(this), N = fe.redNeg(), W = this.m.subn(1).iushrn(1), I = this.m.bitLength();
      for (I = new d(2 * I * I).toRed(this); this.pow(I, W).cmp(N) !== 0; )
        I.redIAdd(N);
      for (var te = this.pow(I, J), ge = this.pow(C, J.addn(1).iushrn(1)), Pe = this.pow(C, J), Ke = se; Pe.cmp(fe) !== 0; ) {
        for (var xe = Pe, ze = 0; xe.cmp(fe) !== 0; ze++)
          xe = xe.redSqr();
        u(ze < Ke);
        var nt = this.pow(te, new d(1).iushln(Ke - ze - 1));
        ge = ge.redMul(nt), te = nt.redSqr(), Pe = Pe.redMul(te), Ke = ze;
      }
      return ge;
    }, oe.prototype.invm = function(C) {
      var w = C._invmp(this.m);
      return w.negative !== 0 ? (w.negative = 0, this.imod(w).redNeg()) : this.imod(w);
    }, oe.prototype.pow = function(C, w) {
      if (w.isZero())
        return new d(1).toRed(this);
      if (w.cmpn(1) === 0)
        return C.clone();
      var P = 4, J = new Array(1 << P);
      J[0] = new d(1).toRed(this), J[1] = C;
      for (var se = 2; se < J.length; se++)
        J[se] = this.mul(J[se - 1], C);
      var fe = J[0], N = 0, W = 0, I = w.bitLength() % 26;
      for (I === 0 && (I = 26), se = w.length - 1; se >= 0; se--) {
        for (var te = w.words[se], ge = I - 1; ge >= 0; ge--) {
          var Pe = te >> ge & 1;
          if (fe !== J[0] && (fe = this.sqr(fe)), Pe === 0 && N === 0) {
            W = 0;
            continue;
          }
          N <<= 1, N |= Pe, W++, !(W !== P && (se !== 0 || ge !== 0)) && (fe = this.mul(fe, J[N]), W = 0, N = 0);
        }
        I = 26;
      }
      return fe;
    }, oe.prototype.convertTo = function(C) {
      var w = C.umod(this.m);
      return w === C ? w.clone() : w;
    }, oe.prototype.convertFrom = function(C) {
      var w = C.clone();
      return w.red = null, w;
    }, d.mont = function(C) {
      return new ne(C);
    };
    function ne(H) {
      oe.call(this, H), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    c(ne, oe), ne.prototype.convertTo = function(C) {
      return this.imod(C.ushln(this.shift));
    }, ne.prototype.convertFrom = function(C) {
      var w = this.imod(C.mul(this.rinv));
      return w.red = null, w;
    }, ne.prototype.imul = function(C, w) {
      if (C.isZero() || w.isZero())
        return C.words[0] = 0, C.length = 1, C;
      var P = C.imul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
      return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
    }, ne.prototype.mul = function(C, w) {
      if (C.isZero() || w.isZero())
        return new d(0)._forceRed(this);
      var P = C.mul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
      return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
    }, ne.prototype.invm = function(C) {
      var w = this.imod(C._invmp(this.m).mul(this.r2));
      return w._forceRed(this);
    };
  })(e, commonjsGlobal);
})(bn$3);
var bnExports = bn$3.exports, utils$W = {};
(function(e) {
  var n = e;
  function o(d, m) {
    if (Array.isArray(d))
      return d.slice();
    if (!d)
      return [];
    var v = [];
    if (typeof d != "string") {
      for (var S = 0; S < d.length; S++)
        v[S] = d[S] | 0;
      return v;
    }
    if (m === "hex") {
      d = d.replace(/[^a-z0-9]+/ig, ""), d.length % 2 !== 0 && (d = "0" + d);
      for (var S = 0; S < d.length; S += 2)
        v.push(parseInt(d[S] + d[S + 1], 16));
    } else
      for (var S = 0; S < d.length; S++) {
        var $ = d.charCodeAt(S), E = $ >> 8, O = $ & 255;
        E ? v.push(E, O) : v.push(O);
      }
    return v;
  }
  n.toArray = o;
  function u(d) {
    return d.length === 1 ? "0" + d : d;
  }
  n.zero2 = u;
  function c(d) {
    for (var m = "", v = 0; v < d.length; v++)
      m += u(d[v].toString(16));
    return m;
  }
  n.toHex = c, n.encode = function(m, v) {
    return v === "hex" ? c(m) : m;
  };
})(utils$W);
(function(e) {
  var n = e, o = bnExports, u = minimalisticAssert$1, c = utils$W;
  n.assert = u, n.toArray = c.toArray, n.zero2 = c.zero2, n.toHex = c.toHex, n.encode = c.encode;
  function d(E, O, T) {
    var y = new Array(Math.max(E.bitLength(), T) + 1);
    y.fill(0);
    for (var V = 1 << O + 1, M = E.clone(), G = 0; G < y.length; G++) {
      var k, F = M.andln(V - 1);
      M.isOdd() ? (F > (V >> 1) - 1 ? k = (V >> 1) - F : k = F, M.isubn(k)) : k = 0, y[G] = k, M.iushrn(1);
    }
    return y;
  }
  n.getNAF = d;
  function m(E, O) {
    var T = [
      [],
      []
    ];
    E = E.clone(), O = O.clone();
    for (var y = 0, V = 0, M; E.cmpn(-y) > 0 || O.cmpn(-V) > 0; ) {
      var G = E.andln(3) + y & 3, k = O.andln(3) + V & 3;
      G === 3 && (G = -1), k === 3 && (k = -1);
      var F;
      G & 1 ? (M = E.andln(7) + y & 7, (M === 3 || M === 5) && k === 2 ? F = -G : F = G) : F = 0, T[0].push(F);
      var X;
      k & 1 ? (M = O.andln(7) + V & 7, (M === 3 || M === 5) && G === 2 ? X = -k : X = k) : X = 0, T[1].push(X), 2 * y === F + 1 && (y = 1 - y), 2 * V === X + 1 && (V = 1 - V), E.iushrn(1), O.iushrn(1);
    }
    return T;
  }
  n.getJSF = m;
  function v(E, O, T) {
    var y = "_" + O;
    E.prototype[O] = function() {
      return this[y] !== void 0 ? this[y] : this[y] = T.call(this);
    };
  }
  n.cachedProperty = v;
  function S(E) {
    return typeof E == "string" ? n.toArray(E, "hex") : E;
  }
  n.parseBytes = S;
  function $(E) {
    return new o(E, "hex", "le");
  }
  n.intFromLE = $;
})(utils$X);
var curve = {}, BN$6 = bnExports, utils$V = utils$X, getNAF$1 = utils$V.getNAF, getJSF$1 = utils$V.getJSF, assert$v = utils$V.assert;
function BaseCurve$1(e, n) {
  this.type = e, this.p = new BN$6(n.p, 16), this.red = n.prime ? BN$6.red(n.prime) : BN$6.mont(this.p), this.zero = new BN$6(0).toRed(this.red), this.one = new BN$6(1).toRed(this.red), this.two = new BN$6(2).toRed(this.red), this.n = n.n && new BN$6(n.n, 16), this.g = n.g && this.pointFromJSON(n.g, n.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var o = this.n && this.p.div(this.n);
  !o || o.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base$3 = BaseCurve$1;
BaseCurve$1.prototype.point = function() {
  throw new Error("Not implemented");
};
BaseCurve$1.prototype.validate = function() {
  throw new Error("Not implemented");
};
BaseCurve$1.prototype._fixedNafMul = function(n, o) {
  assert$v(n.precomputed);
  var u = n._getDoubles(), c = getNAF$1(o, 1, this._bitLength), d = (1 << u.step + 1) - (u.step % 2 === 0 ? 2 : 1);
  d /= 3;
  var m = [], v, S;
  for (v = 0; v < c.length; v += u.step) {
    S = 0;
    for (var $ = v + u.step - 1; $ >= v; $--)
      S = (S << 1) + c[$];
    m.push(S);
  }
  for (var E = this.jpoint(null, null, null), O = this.jpoint(null, null, null), T = d; T > 0; T--) {
    for (v = 0; v < m.length; v++)
      S = m[v], S === T ? O = O.mixedAdd(u.points[v]) : S === -T && (O = O.mixedAdd(u.points[v].neg()));
    E = E.add(O);
  }
  return E.toP();
};
BaseCurve$1.prototype._wnafMul = function(n, o) {
  var u = 4, c = n._getNAFPoints(u);
  u = c.wnd;
  for (var d = c.points, m = getNAF$1(o, u, this._bitLength), v = this.jpoint(null, null, null), S = m.length - 1; S >= 0; S--) {
    for (var $ = 0; S >= 0 && m[S] === 0; S--)
      $++;
    if (S >= 0 && $++, v = v.dblp($), S < 0)
      break;
    var E = m[S];
    assert$v(E !== 0), n.type === "affine" ? E > 0 ? v = v.mixedAdd(d[E - 1 >> 1]) : v = v.mixedAdd(d[-E - 1 >> 1].neg()) : E > 0 ? v = v.add(d[E - 1 >> 1]) : v = v.add(d[-E - 1 >> 1].neg());
  }
  return n.type === "affine" ? v.toP() : v;
};
BaseCurve$1.prototype._wnafMulAdd = function(n, o, u, c, d) {
  var m = this._wnafT1, v = this._wnafT2, S = this._wnafT3, $ = 0, E, O, T;
  for (E = 0; E < c; E++) {
    T = o[E];
    var y = T._getNAFPoints(n);
    m[E] = y.wnd, v[E] = y.points;
  }
  for (E = c - 1; E >= 1; E -= 2) {
    var V = E - 1, M = E;
    if (m[V] !== 1 || m[M] !== 1) {
      S[V] = getNAF$1(u[V], m[V], this._bitLength), S[M] = getNAF$1(u[M], m[M], this._bitLength), $ = Math.max(S[V].length, $), $ = Math.max(S[M].length, $);
      continue;
    }
    var G = [
      o[V],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      o[M]
      /* 7 */
    ];
    o[V].y.cmp(o[M].y) === 0 ? (G[1] = o[V].add(o[M]), G[2] = o[V].toJ().mixedAdd(o[M].neg())) : o[V].y.cmp(o[M].y.redNeg()) === 0 ? (G[1] = o[V].toJ().mixedAdd(o[M]), G[2] = o[V].add(o[M].neg())) : (G[1] = o[V].toJ().mixedAdd(o[M]), G[2] = o[V].toJ().mixedAdd(o[M].neg()));
    var k = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], F = getJSF$1(u[V], u[M]);
    for ($ = Math.max(F[0].length, $), S[V] = new Array($), S[M] = new Array($), O = 0; O < $; O++) {
      var X = F[0][O] | 0, ee = F[1][O] | 0;
      S[V][O] = k[(X + 1) * 3 + (ee + 1)], S[M][O] = 0, v[V] = G;
    }
  }
  var ue = this.jpoint(null, null, null), Q = this._wnafT4;
  for (E = $; E >= 0; E--) {
    for (var Y = 0; E >= 0; ) {
      var pe = !0;
      for (O = 0; O < c; O++)
        Q[O] = S[O][E] | 0, Q[O] !== 0 && (pe = !1);
      if (!pe)
        break;
      Y++, E--;
    }
    if (E >= 0 && Y++, ue = ue.dblp(Y), E < 0)
      break;
    for (O = 0; O < c; O++) {
      var oe = Q[O];
      oe !== 0 && (oe > 0 ? T = v[O][oe - 1 >> 1] : oe < 0 && (T = v[O][-oe - 1 >> 1].neg()), T.type === "affine" ? ue = ue.mixedAdd(T) : ue = ue.add(T));
    }
  }
  for (E = 0; E < c; E++)
    v[E] = null;
  return d ? ue : ue.toP();
};
function BasePoint$1(e, n) {
  this.curve = e, this.type = n, this.precomputed = null;
}
BaseCurve$1.BasePoint = BasePoint$1;
BasePoint$1.prototype.eq = function() {
  throw new Error("Not implemented");
};
BasePoint$1.prototype.validate = function() {
  return this.curve.validate(this);
};
BaseCurve$1.prototype.decodePoint = function(n, o) {
  n = utils$V.toArray(n, o);
  var u = this.p.byteLength();
  if ((n[0] === 4 || n[0] === 6 || n[0] === 7) && n.length - 1 === 2 * u) {
    n[0] === 6 ? assert$v(n[n.length - 1] % 2 === 0) : n[0] === 7 && assert$v(n[n.length - 1] % 2 === 1);
    var c = this.point(
      n.slice(1, 1 + u),
      n.slice(1 + u, 1 + 2 * u)
    );
    return c;
  } else if ((n[0] === 2 || n[0] === 3) && n.length - 1 === u)
    return this.pointFromX(n.slice(1, 1 + u), n[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint$1.prototype.encodeCompressed = function(n) {
  return this.encode(n, !0);
};
BasePoint$1.prototype._encode = function(n) {
  var o = this.curve.p.byteLength(), u = this.getX().toArray("be", o);
  return n ? [this.getY().isEven() ? 2 : 3].concat(u) : [4].concat(u, this.getY().toArray("be", o));
};
BasePoint$1.prototype.encode = function(n, o) {
  return utils$V.encode(this._encode(o), n);
};
BasePoint$1.prototype.precompute = function(n) {
  if (this.precomputed)
    return this;
  var o = {
    doubles: null,
    naf: null,
    beta: null
  };
  return o.naf = this._getNAFPoints(8), o.doubles = this._getDoubles(4, n), o.beta = this._getBeta(), this.precomputed = o, this;
};
BasePoint$1.prototype._hasDoubles = function(n) {
  if (!this.precomputed)
    return !1;
  var o = this.precomputed.doubles;
  return o ? o.points.length >= Math.ceil((n.bitLength() + 1) / o.step) : !1;
};
BasePoint$1.prototype._getDoubles = function(n, o) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var u = [this], c = this, d = 0; d < o; d += n) {
    for (var m = 0; m < n; m++)
      c = c.dbl();
    u.push(c);
  }
  return {
    step: n,
    points: u
  };
};
BasePoint$1.prototype._getNAFPoints = function(n) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var o = [this], u = (1 << n) - 1, c = u === 1 ? null : this.dbl(), d = 1; d < u; d++)
    o[d] = o[d - 1].add(c);
  return {
    wnd: n,
    points: o
  };
};
BasePoint$1.prototype._getBeta = function() {
  return null;
};
BasePoint$1.prototype.dblp = function(n) {
  for (var o = this, u = 0; u < n; u++)
    o = o.dbl();
  return o;
};
var utils$U = utils$X, BN$5 = bnExports, inherits$7 = requireInherits_browser(), Base$2 = base$3, assert$u = utils$U.assert;
function ShortCurve$1(e) {
  Base$2.call(this, "short", e), this.a = new BN$5(e.a, 16).toRed(this.red), this.b = new BN$5(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$7(ShortCurve$1, Base$2);
var short = ShortCurve$1;
ShortCurve$1.prototype._getEndomorphism = function(n) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var o, u;
    if (n.beta)
      o = new BN$5(n.beta, 16).toRed(this.red);
    else {
      var c = this._getEndoRoots(this.p);
      o = c[0].cmp(c[1]) < 0 ? c[0] : c[1], o = o.toRed(this.red);
    }
    if (n.lambda)
      u = new BN$5(n.lambda, 16);
    else {
      var d = this._getEndoRoots(this.n);
      this.g.mul(d[0]).x.cmp(this.g.x.redMul(o)) === 0 ? u = d[0] : (u = d[1], assert$u(this.g.mul(u).x.cmp(this.g.x.redMul(o)) === 0));
    }
    var m;
    return n.basis ? m = n.basis.map(function(v) {
      return {
        a: new BN$5(v.a, 16),
        b: new BN$5(v.b, 16)
      };
    }) : m = this._getEndoBasis(u), {
      beta: o,
      lambda: u,
      basis: m
    };
  }
};
ShortCurve$1.prototype._getEndoRoots = function(n) {
  var o = n === this.p ? this.red : BN$5.mont(n), u = new BN$5(2).toRed(o).redInvm(), c = u.redNeg(), d = new BN$5(3).toRed(o).redNeg().redSqrt().redMul(u), m = c.redAdd(d).fromRed(), v = c.redSub(d).fromRed();
  return [m, v];
};
ShortCurve$1.prototype._getEndoBasis = function(n) {
  for (var o = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), u = n, c = this.n.clone(), d = new BN$5(1), m = new BN$5(0), v = new BN$5(0), S = new BN$5(1), $, E, O, T, y, V, M, G = 0, k, F; u.cmpn(0) !== 0; ) {
    var X = c.div(u);
    k = c.sub(X.mul(u)), F = v.sub(X.mul(d));
    var ee = S.sub(X.mul(m));
    if (!O && k.cmp(o) < 0)
      $ = M.neg(), E = d, O = k.neg(), T = F;
    else if (O && ++G === 2)
      break;
    M = k, c = u, u = k, v = d, d = F, S = m, m = ee;
  }
  y = k.neg(), V = F;
  var ue = O.sqr().add(T.sqr()), Q = y.sqr().add(V.sqr());
  return Q.cmp(ue) >= 0 && (y = $, V = E), O.negative && (O = O.neg(), T = T.neg()), y.negative && (y = y.neg(), V = V.neg()), [
    { a: O, b: T },
    { a: y, b: V }
  ];
};
ShortCurve$1.prototype._endoSplit = function(n) {
  var o = this.endo.basis, u = o[0], c = o[1], d = c.b.mul(n).divRound(this.n), m = u.b.neg().mul(n).divRound(this.n), v = d.mul(u.a), S = m.mul(c.a), $ = d.mul(u.b), E = m.mul(c.b), O = n.sub(v).sub(S), T = $.add(E).neg();
  return { k1: O, k2: T };
};
ShortCurve$1.prototype.pointFromX = function(n, o) {
  n = new BN$5(n, 16), n.red || (n = n.toRed(this.red));
  var u = n.redSqr().redMul(n).redIAdd(n.redMul(this.a)).redIAdd(this.b), c = u.redSqrt();
  if (c.redSqr().redSub(u).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var d = c.fromRed().isOdd();
  return (o && !d || !o && d) && (c = c.redNeg()), this.point(n, c);
};
ShortCurve$1.prototype.validate = function(n) {
  if (n.inf)
    return !0;
  var o = n.x, u = n.y, c = this.a.redMul(o), d = o.redSqr().redMul(o).redIAdd(c).redIAdd(this.b);
  return u.redSqr().redISub(d).cmpn(0) === 0;
};
ShortCurve$1.prototype._endoWnafMulAdd = function(n, o, u) {
  for (var c = this._endoWnafT1, d = this._endoWnafT2, m = 0; m < n.length; m++) {
    var v = this._endoSplit(o[m]), S = n[m], $ = S._getBeta();
    v.k1.negative && (v.k1.ineg(), S = S.neg(!0)), v.k2.negative && (v.k2.ineg(), $ = $.neg(!0)), c[m * 2] = S, c[m * 2 + 1] = $, d[m * 2] = v.k1, d[m * 2 + 1] = v.k2;
  }
  for (var E = this._wnafMulAdd(1, c, d, m * 2, u), O = 0; O < m * 2; O++)
    c[O] = null, d[O] = null;
  return E;
};
function Point$3(e, n, o, u) {
  Base$2.BasePoint.call(this, e, "affine"), n === null && o === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$5(n, 16), this.y = new BN$5(o, 16), u && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$7(Point$3, Base$2.BasePoint);
ShortCurve$1.prototype.point = function(n, o, u) {
  return new Point$3(this, n, o, u);
};
ShortCurve$1.prototype.pointFromJSON = function(n, o) {
  return Point$3.fromJSON(this, n, o);
};
Point$3.prototype._getBeta = function() {
  if (this.curve.endo) {
    var n = this.precomputed;
    if (n && n.beta)
      return n.beta;
    var o = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (n) {
      var u = this.curve, c = function(d) {
        return u.point(d.x.redMul(u.endo.beta), d.y);
      };
      n.beta = o, o.precomputed = {
        beta: null,
        naf: n.naf && {
          wnd: n.naf.wnd,
          points: n.naf.points.map(c)
        },
        doubles: n.doubles && {
          step: n.doubles.step,
          points: n.doubles.points.map(c)
        }
      };
    }
    return o;
  }
};
Point$3.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$3.fromJSON = function(n, o, u) {
  typeof o == "string" && (o = JSON.parse(o));
  var c = n.point(o[0], o[1], u);
  if (!o[2])
    return c;
  function d(v) {
    return n.point(v[0], v[1], u);
  }
  var m = o[2];
  return c.precomputed = {
    beta: null,
    doubles: m.doubles && {
      step: m.doubles.step,
      points: [c].concat(m.doubles.points.map(d))
    },
    naf: m.naf && {
      wnd: m.naf.wnd,
      points: [c].concat(m.naf.points.map(d))
    }
  }, c;
};
Point$3.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$3.prototype.isInfinity = function() {
  return this.inf;
};
Point$3.prototype.add = function(n) {
  if (this.inf)
    return n;
  if (n.inf)
    return this;
  if (this.eq(n))
    return this.dbl();
  if (this.neg().eq(n))
    return this.curve.point(null, null);
  if (this.x.cmp(n.x) === 0)
    return this.curve.point(null, null);
  var o = this.y.redSub(n.y);
  o.cmpn(0) !== 0 && (o = o.redMul(this.x.redSub(n.x).redInvm()));
  var u = o.redSqr().redISub(this.x).redISub(n.x), c = o.redMul(this.x.redSub(u)).redISub(this.y);
  return this.curve.point(u, c);
};
Point$3.prototype.dbl = function() {
  if (this.inf)
    return this;
  var n = this.y.redAdd(this.y);
  if (n.cmpn(0) === 0)
    return this.curve.point(null, null);
  var o = this.curve.a, u = this.x.redSqr(), c = n.redInvm(), d = u.redAdd(u).redIAdd(u).redIAdd(o).redMul(c), m = d.redSqr().redISub(this.x.redAdd(this.x)), v = d.redMul(this.x.redSub(m)).redISub(this.y);
  return this.curve.point(m, v);
};
Point$3.prototype.getX = function() {
  return this.x.fromRed();
};
Point$3.prototype.getY = function() {
  return this.y.fromRed();
};
Point$3.prototype.mul = function(n) {
  return n = new BN$5(n, 16), this.isInfinity() ? this : this._hasDoubles(n) ? this.curve._fixedNafMul(this, n) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [n]) : this.curve._wnafMul(this, n);
};
Point$3.prototype.mulAdd = function(n, o, u) {
  var c = [this, o], d = [n, u];
  return this.curve.endo ? this.curve._endoWnafMulAdd(c, d) : this.curve._wnafMulAdd(1, c, d, 2);
};
Point$3.prototype.jmulAdd = function(n, o, u) {
  var c = [this, o], d = [n, u];
  return this.curve.endo ? this.curve._endoWnafMulAdd(c, d, !0) : this.curve._wnafMulAdd(1, c, d, 2, !0);
};
Point$3.prototype.eq = function(n) {
  return this === n || this.inf === n.inf && (this.inf || this.x.cmp(n.x) === 0 && this.y.cmp(n.y) === 0);
};
Point$3.prototype.neg = function(n) {
  if (this.inf)
    return this;
  var o = this.curve.point(this.x, this.y.redNeg());
  if (n && this.precomputed) {
    var u = this.precomputed, c = function(d) {
      return d.neg();
    };
    o.precomputed = {
      naf: u.naf && {
        wnd: u.naf.wnd,
        points: u.naf.points.map(c)
      },
      doubles: u.doubles && {
        step: u.doubles.step,
        points: u.doubles.points.map(c)
      }
    };
  }
  return o;
};
Point$3.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var n = this.curve.jpoint(this.x, this.y, this.curve.one);
  return n;
};
function JPoint$1(e, n, o, u) {
  Base$2.BasePoint.call(this, e, "jacobian"), n === null && o === null && u === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$5(0)) : (this.x = new BN$5(n, 16), this.y = new BN$5(o, 16), this.z = new BN$5(u, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$7(JPoint$1, Base$2.BasePoint);
ShortCurve$1.prototype.jpoint = function(n, o, u) {
  return new JPoint$1(this, n, o, u);
};
JPoint$1.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var n = this.z.redInvm(), o = n.redSqr(), u = this.x.redMul(o), c = this.y.redMul(o).redMul(n);
  return this.curve.point(u, c);
};
JPoint$1.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint$1.prototype.add = function(n) {
  if (this.isInfinity())
    return n;
  if (n.isInfinity())
    return this;
  var o = n.z.redSqr(), u = this.z.redSqr(), c = this.x.redMul(o), d = n.x.redMul(u), m = this.y.redMul(o.redMul(n.z)), v = n.y.redMul(u.redMul(this.z)), S = c.redSub(d), $ = m.redSub(v);
  if (S.cmpn(0) === 0)
    return $.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var E = S.redSqr(), O = E.redMul(S), T = c.redMul(E), y = $.redSqr().redIAdd(O).redISub(T).redISub(T), V = $.redMul(T.redISub(y)).redISub(m.redMul(O)), M = this.z.redMul(n.z).redMul(S);
  return this.curve.jpoint(y, V, M);
};
JPoint$1.prototype.mixedAdd = function(n) {
  if (this.isInfinity())
    return n.toJ();
  if (n.isInfinity())
    return this;
  var o = this.z.redSqr(), u = this.x, c = n.x.redMul(o), d = this.y, m = n.y.redMul(o).redMul(this.z), v = u.redSub(c), S = d.redSub(m);
  if (v.cmpn(0) === 0)
    return S.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var $ = v.redSqr(), E = $.redMul(v), O = u.redMul($), T = S.redSqr().redIAdd(E).redISub(O).redISub(O), y = S.redMul(O.redISub(T)).redISub(d.redMul(E)), V = this.z.redMul(v);
  return this.curve.jpoint(T, y, V);
};
JPoint$1.prototype.dblp = function(n) {
  if (n === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!n)
    return this.dbl();
  var o;
  if (this.curve.zeroA || this.curve.threeA) {
    var u = this;
    for (o = 0; o < n; o++)
      u = u.dbl();
    return u;
  }
  var c = this.curve.a, d = this.curve.tinv, m = this.x, v = this.y, S = this.z, $ = S.redSqr().redSqr(), E = v.redAdd(v);
  for (o = 0; o < n; o++) {
    var O = m.redSqr(), T = E.redSqr(), y = T.redSqr(), V = O.redAdd(O).redIAdd(O).redIAdd(c.redMul($)), M = m.redMul(T), G = V.redSqr().redISub(M.redAdd(M)), k = M.redISub(G), F = V.redMul(k);
    F = F.redIAdd(F).redISub(y);
    var X = E.redMul(S);
    o + 1 < n && ($ = $.redMul(y)), m = G, S = X, E = F;
  }
  return this.curve.jpoint(m, E.redMul(d), S);
};
JPoint$1.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint$1.prototype._zeroDbl = function() {
  var n, o, u;
  if (this.zOne) {
    var c = this.x.redSqr(), d = this.y.redSqr(), m = d.redSqr(), v = this.x.redAdd(d).redSqr().redISub(c).redISub(m);
    v = v.redIAdd(v);
    var S = c.redAdd(c).redIAdd(c), $ = S.redSqr().redISub(v).redISub(v), E = m.redIAdd(m);
    E = E.redIAdd(E), E = E.redIAdd(E), n = $, o = S.redMul(v.redISub($)).redISub(E), u = this.y.redAdd(this.y);
  } else {
    var O = this.x.redSqr(), T = this.y.redSqr(), y = T.redSqr(), V = this.x.redAdd(T).redSqr().redISub(O).redISub(y);
    V = V.redIAdd(V);
    var M = O.redAdd(O).redIAdd(O), G = M.redSqr(), k = y.redIAdd(y);
    k = k.redIAdd(k), k = k.redIAdd(k), n = G.redISub(V).redISub(V), o = M.redMul(V.redISub(n)).redISub(k), u = this.y.redMul(this.z), u = u.redIAdd(u);
  }
  return this.curve.jpoint(n, o, u);
};
JPoint$1.prototype._threeDbl = function() {
  var n, o, u;
  if (this.zOne) {
    var c = this.x.redSqr(), d = this.y.redSqr(), m = d.redSqr(), v = this.x.redAdd(d).redSqr().redISub(c).redISub(m);
    v = v.redIAdd(v);
    var S = c.redAdd(c).redIAdd(c).redIAdd(this.curve.a), $ = S.redSqr().redISub(v).redISub(v);
    n = $;
    var E = m.redIAdd(m);
    E = E.redIAdd(E), E = E.redIAdd(E), o = S.redMul(v.redISub($)).redISub(E), u = this.y.redAdd(this.y);
  } else {
    var O = this.z.redSqr(), T = this.y.redSqr(), y = this.x.redMul(T), V = this.x.redSub(O).redMul(this.x.redAdd(O));
    V = V.redAdd(V).redIAdd(V);
    var M = y.redIAdd(y);
    M = M.redIAdd(M);
    var G = M.redAdd(M);
    n = V.redSqr().redISub(G), u = this.y.redAdd(this.z).redSqr().redISub(T).redISub(O);
    var k = T.redSqr();
    k = k.redIAdd(k), k = k.redIAdd(k), k = k.redIAdd(k), o = V.redMul(M.redISub(n)).redISub(k);
  }
  return this.curve.jpoint(n, o, u);
};
JPoint$1.prototype._dbl = function() {
  var n = this.curve.a, o = this.x, u = this.y, c = this.z, d = c.redSqr().redSqr(), m = o.redSqr(), v = u.redSqr(), S = m.redAdd(m).redIAdd(m).redIAdd(n.redMul(d)), $ = o.redAdd(o);
  $ = $.redIAdd($);
  var E = $.redMul(v), O = S.redSqr().redISub(E.redAdd(E)), T = E.redISub(O), y = v.redSqr();
  y = y.redIAdd(y), y = y.redIAdd(y), y = y.redIAdd(y);
  var V = S.redMul(T).redISub(y), M = u.redAdd(u).redMul(c);
  return this.curve.jpoint(O, V, M);
};
JPoint$1.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var n = this.x.redSqr(), o = this.y.redSqr(), u = this.z.redSqr(), c = o.redSqr(), d = n.redAdd(n).redIAdd(n), m = d.redSqr(), v = this.x.redAdd(o).redSqr().redISub(n).redISub(c);
  v = v.redIAdd(v), v = v.redAdd(v).redIAdd(v), v = v.redISub(m);
  var S = v.redSqr(), $ = c.redIAdd(c);
  $ = $.redIAdd($), $ = $.redIAdd($), $ = $.redIAdd($);
  var E = d.redIAdd(v).redSqr().redISub(m).redISub(S).redISub($), O = o.redMul(E);
  O = O.redIAdd(O), O = O.redIAdd(O);
  var T = this.x.redMul(S).redISub(O);
  T = T.redIAdd(T), T = T.redIAdd(T);
  var y = this.y.redMul(E.redMul($.redISub(E)).redISub(v.redMul(S)));
  y = y.redIAdd(y), y = y.redIAdd(y), y = y.redIAdd(y);
  var V = this.z.redAdd(v).redSqr().redISub(u).redISub(S);
  return this.curve.jpoint(T, y, V);
};
JPoint$1.prototype.mul = function(n, o) {
  return n = new BN$5(n, o), this.curve._wnafMul(this, n);
};
JPoint$1.prototype.eq = function(n) {
  if (n.type === "affine")
    return this.eq(n.toJ());
  if (this === n)
    return !0;
  var o = this.z.redSqr(), u = n.z.redSqr();
  if (this.x.redMul(u).redISub(n.x.redMul(o)).cmpn(0) !== 0)
    return !1;
  var c = o.redMul(this.z), d = u.redMul(n.z);
  return this.y.redMul(d).redISub(n.y.redMul(c)).cmpn(0) === 0;
};
JPoint$1.prototype.eqXToP = function(n) {
  var o = this.z.redSqr(), u = n.toRed(this.curve.red).redMul(o);
  if (this.x.cmp(u) === 0)
    return !0;
  for (var c = n.clone(), d = this.curve.redN.redMul(o); ; ) {
    if (c.iadd(this.curve.n), c.cmp(this.curve.p) >= 0)
      return !1;
    if (u.redIAdd(d), this.x.cmp(u) === 0)
      return !0;
  }
};
JPoint$1.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint$1.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var BN$4 = bnExports, inherits$6 = requireInherits_browser(), Base$1 = base$3, utils$T = utils$X;
function MontCurve(e) {
  Base$1.call(this, "mont", e), this.a = new BN$4(e.a, 16).toRed(this.red), this.b = new BN$4(e.b, 16).toRed(this.red), this.i4 = new BN$4(4).toRed(this.red).redInvm(), this.two = new BN$4(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$6(MontCurve, Base$1);
var mont = MontCurve;
MontCurve.prototype.validate = function(n) {
  var o = n.normalize().x, u = o.redSqr(), c = u.redMul(o).redAdd(u.redMul(this.a)).redAdd(o), d = c.redSqrt();
  return d.redSqr().cmp(c) === 0;
};
function Point$2(e, n, o) {
  Base$1.BasePoint.call(this, e, "projective"), n === null && o === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$4(n, 16), this.z = new BN$4(o, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$6(Point$2, Base$1.BasePoint);
MontCurve.prototype.decodePoint = function(n, o) {
  return this.point(utils$T.toArray(n, o), 1);
};
MontCurve.prototype.point = function(n, o) {
  return new Point$2(this, n, o);
};
MontCurve.prototype.pointFromJSON = function(n) {
  return Point$2.fromJSON(this, n);
};
Point$2.prototype.precompute = function() {
};
Point$2.prototype._encode = function() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$2.fromJSON = function(n, o) {
  return new Point$2(n, o[0], o[1] || n.one);
};
Point$2.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
Point$2.prototype.dbl = function() {
  var n = this.x.redAdd(this.z), o = n.redSqr(), u = this.x.redSub(this.z), c = u.redSqr(), d = o.redSub(c), m = o.redMul(c), v = d.redMul(c.redAdd(this.curve.a24.redMul(d)));
  return this.curve.point(m, v);
};
Point$2.prototype.add = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$2.prototype.diffAdd = function(n, o) {
  var u = this.x.redAdd(this.z), c = this.x.redSub(this.z), d = n.x.redAdd(n.z), m = n.x.redSub(n.z), v = m.redMul(u), S = d.redMul(c), $ = o.z.redMul(v.redAdd(S).redSqr()), E = o.x.redMul(v.redISub(S).redSqr());
  return this.curve.point($, E);
};
Point$2.prototype.mul = function(n) {
  for (var o = n.clone(), u = this, c = this.curve.point(null, null), d = this, m = []; o.cmpn(0) !== 0; o.iushrn(1))
    m.push(o.andln(1));
  for (var v = m.length - 1; v >= 0; v--)
    m[v] === 0 ? (u = u.diffAdd(c, d), c = c.dbl()) : (c = u.diffAdd(c, d), u = u.dbl());
  return c;
};
Point$2.prototype.mulAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$2.prototype.jumlAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$2.prototype.eq = function(n) {
  return this.getX().cmp(n.getX()) === 0;
};
Point$2.prototype.normalize = function() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$2.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
var utils$S = utils$X, BN$3 = bnExports, inherits$5 = requireInherits_browser(), Base = base$3, assert$t = utils$S.assert;
function EdwardsCurve(e) {
  this.twisted = (e.a | 0) !== 1, this.mOneA = this.twisted && (e.a | 0) === -1, this.extended = this.mOneA, Base.call(this, "edwards", e), this.a = new BN$3(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$3(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$3(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$t(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (e.c | 0) === 1;
}
inherits$5(EdwardsCurve, Base);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function(n) {
  return this.mOneA ? n.redNeg() : this.a.redMul(n);
};
EdwardsCurve.prototype._mulC = function(n) {
  return this.oneC ? n : this.c.redMul(n);
};
EdwardsCurve.prototype.jpoint = function(n, o, u, c) {
  return this.point(n, o, u, c);
};
EdwardsCurve.prototype.pointFromX = function(n, o) {
  n = new BN$3(n, 16), n.red || (n = n.toRed(this.red));
  var u = n.redSqr(), c = this.c2.redSub(this.a.redMul(u)), d = this.one.redSub(this.c2.redMul(this.d).redMul(u)), m = c.redMul(d.redInvm()), v = m.redSqrt();
  if (v.redSqr().redSub(m).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var S = v.fromRed().isOdd();
  return (o && !S || !o && S) && (v = v.redNeg()), this.point(n, v);
};
EdwardsCurve.prototype.pointFromY = function(n, o) {
  n = new BN$3(n, 16), n.red || (n = n.toRed(this.red));
  var u = n.redSqr(), c = u.redSub(this.c2), d = u.redMul(this.d).redMul(this.c2).redSub(this.a), m = c.redMul(d.redInvm());
  if (m.cmp(this.zero) === 0) {
    if (o)
      throw new Error("invalid point");
    return this.point(this.zero, n);
  }
  var v = m.redSqrt();
  if (v.redSqr().redSub(m).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return v.fromRed().isOdd() !== o && (v = v.redNeg()), this.point(v, n);
};
EdwardsCurve.prototype.validate = function(n) {
  if (n.isInfinity())
    return !0;
  n.normalize();
  var o = n.x.redSqr(), u = n.y.redSqr(), c = o.redMul(this.a).redAdd(u), d = this.c2.redMul(this.one.redAdd(this.d.redMul(o).redMul(u)));
  return c.cmp(d) === 0;
};
function Point$1(e, n, o, u, c) {
  Base.BasePoint.call(this, e, "projective"), n === null && o === null && u === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$3(n, 16), this.y = new BN$3(o, 16), this.z = u ? new BN$3(u, 16) : this.curve.one, this.t = c && new BN$3(c, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits$5(Point$1, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function(n) {
  return Point$1.fromJSON(this, n);
};
EdwardsCurve.prototype.point = function(n, o, u, c) {
  return new Point$1(this, n, o, u, c);
};
Point$1.fromJSON = function(n, o) {
  return new Point$1(n, o[0], o[1], o[2]);
};
Point$1.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point$1.prototype._extDbl = function() {
  var n = this.x.redSqr(), o = this.y.redSqr(), u = this.z.redSqr();
  u = u.redIAdd(u);
  var c = this.curve._mulA(n), d = this.x.redAdd(this.y).redSqr().redISub(n).redISub(o), m = c.redAdd(o), v = m.redSub(u), S = c.redSub(o), $ = d.redMul(v), E = m.redMul(S), O = d.redMul(S), T = v.redMul(m);
  return this.curve.point($, E, T, O);
};
Point$1.prototype._projDbl = function() {
  var n = this.x.redAdd(this.y).redSqr(), o = this.x.redSqr(), u = this.y.redSqr(), c, d, m, v, S, $;
  if (this.curve.twisted) {
    v = this.curve._mulA(o);
    var E = v.redAdd(u);
    this.zOne ? (c = n.redSub(o).redSub(u).redMul(E.redSub(this.curve.two)), d = E.redMul(v.redSub(u)), m = E.redSqr().redSub(E).redSub(E)) : (S = this.z.redSqr(), $ = E.redSub(S).redISub(S), c = n.redSub(o).redISub(u).redMul($), d = E.redMul(v.redSub(u)), m = E.redMul($));
  } else
    v = o.redAdd(u), S = this.curve._mulC(this.z).redSqr(), $ = v.redSub(S).redSub(S), c = this.curve._mulC(n.redISub(v)).redMul($), d = this.curve._mulC(v).redMul(o.redISub(u)), m = v.redMul($);
  return this.curve.point(c, d, m);
};
Point$1.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point$1.prototype._extAdd = function(n) {
  var o = this.y.redSub(this.x).redMul(n.y.redSub(n.x)), u = this.y.redAdd(this.x).redMul(n.y.redAdd(n.x)), c = this.t.redMul(this.curve.dd).redMul(n.t), d = this.z.redMul(n.z.redAdd(n.z)), m = u.redSub(o), v = d.redSub(c), S = d.redAdd(c), $ = u.redAdd(o), E = m.redMul(v), O = S.redMul($), T = m.redMul($), y = v.redMul(S);
  return this.curve.point(E, O, y, T);
};
Point$1.prototype._projAdd = function(n) {
  var o = this.z.redMul(n.z), u = o.redSqr(), c = this.x.redMul(n.x), d = this.y.redMul(n.y), m = this.curve.d.redMul(c).redMul(d), v = u.redSub(m), S = u.redAdd(m), $ = this.x.redAdd(this.y).redMul(n.x.redAdd(n.y)).redISub(c).redISub(d), E = o.redMul(v).redMul($), O, T;
  return this.curve.twisted ? (O = o.redMul(S).redMul(d.redSub(this.curve._mulA(c))), T = v.redMul(S)) : (O = o.redMul(S).redMul(d.redSub(c)), T = this.curve._mulC(v).redMul(S)), this.curve.point(E, O, T);
};
Point$1.prototype.add = function(n) {
  return this.isInfinity() ? n : n.isInfinity() ? this : this.curve.extended ? this._extAdd(n) : this._projAdd(n);
};
Point$1.prototype.mul = function(n) {
  return this._hasDoubles(n) ? this.curve._fixedNafMul(this, n) : this.curve._wnafMul(this, n);
};
Point$1.prototype.mulAdd = function(n, o, u) {
  return this.curve._wnafMulAdd(1, [this, o], [n, u], 2, !1);
};
Point$1.prototype.jmulAdd = function(n, o, u) {
  return this.curve._wnafMulAdd(1, [this, o], [n, u], 2, !0);
};
Point$1.prototype.normalize = function() {
  if (this.zOne)
    return this;
  var n = this.z.redInvm();
  return this.x = this.x.redMul(n), this.y = this.y.redMul(n), this.t && (this.t = this.t.redMul(n)), this.z = this.curve.one, this.zOne = !0, this;
};
Point$1.prototype.neg = function() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point$1.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
Point$1.prototype.getY = function() {
  return this.normalize(), this.y.fromRed();
};
Point$1.prototype.eq = function(n) {
  return this === n || this.getX().cmp(n.getX()) === 0 && this.getY().cmp(n.getY()) === 0;
};
Point$1.prototype.eqXToP = function(n) {
  var o = n.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(o) === 0)
    return !0;
  for (var u = n.clone(), c = this.curve.redN.redMul(this.z); ; ) {
    if (u.iadd(this.curve.n), u.cmp(this.curve.p) >= 0)
      return !1;
    if (o.redIAdd(c), this.x.cmp(o) === 0)
      return !0;
  }
};
Point$1.prototype.toP = Point$1.prototype.normalize;
Point$1.prototype.mixedAdd = Point$1.prototype.add;
(function(e) {
  var n = e;
  n.base = base$3, n.short = short, n.mont = mont, n.edwards = edwards;
})(curve);
var curves$1 = {}, hash$4 = {}, utils$R = {}, assert$s = minimalisticAssert$1, inherits$4 = requireInherits_browser();
utils$R.inherits = inherits$4;
function isSurrogatePair(e, n) {
  return (e.charCodeAt(n) & 64512) !== 55296 || n < 0 || n + 1 >= e.length ? !1 : (e.charCodeAt(n + 1) & 64512) === 56320;
}
function toArray$4(e, n) {
  if (Array.isArray(e))
    return e.slice();
  if (!e)
    return [];
  var o = [];
  if (typeof e == "string")
    if (n) {
      if (n === "hex")
        for (e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), c = 0; c < e.length; c += 2)
          o.push(parseInt(e[c] + e[c + 1], 16));
    } else
      for (var u = 0, c = 0; c < e.length; c++) {
        var d = e.charCodeAt(c);
        d < 128 ? o[u++] = d : d < 2048 ? (o[u++] = d >> 6 | 192, o[u++] = d & 63 | 128) : isSurrogatePair(e, c) ? (d = 65536 + ((d & 1023) << 10) + (e.charCodeAt(++c) & 1023), o[u++] = d >> 18 | 240, o[u++] = d >> 12 & 63 | 128, o[u++] = d >> 6 & 63 | 128, o[u++] = d & 63 | 128) : (o[u++] = d >> 12 | 224, o[u++] = d >> 6 & 63 | 128, o[u++] = d & 63 | 128);
      }
  else
    for (c = 0; c < e.length; c++)
      o[c] = e[c] | 0;
  return o;
}
utils$R.toArray = toArray$4;
function toHex$7(e) {
  for (var n = "", o = 0; o < e.length; o++)
    n += zero2(e[o].toString(16));
  return n;
}
utils$R.toHex = toHex$7;
function htonl(e) {
  var n = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
  return n >>> 0;
}
utils$R.htonl = htonl;
function toHex32(e, n) {
  for (var o = "", u = 0; u < e.length; u++) {
    var c = e[u];
    n === "little" && (c = htonl(c)), o += zero8(c.toString(16));
  }
  return o;
}
utils$R.toHex32 = toHex32;
function zero2(e) {
  return e.length === 1 ? "0" + e : e;
}
utils$R.zero2 = zero2;
function zero8(e) {
  return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
utils$R.zero8 = zero8;
function join32(e, n, o, u) {
  var c = o - n;
  assert$s(c % 4 === 0);
  for (var d = new Array(c / 4), m = 0, v = n; m < d.length; m++, v += 4) {
    var S;
    u === "big" ? S = e[v] << 24 | e[v + 1] << 16 | e[v + 2] << 8 | e[v + 3] : S = e[v + 3] << 24 | e[v + 2] << 16 | e[v + 1] << 8 | e[v], d[m] = S >>> 0;
  }
  return d;
}
utils$R.join32 = join32;
function split32(e, n) {
  for (var o = new Array(e.length * 4), u = 0, c = 0; u < e.length; u++, c += 4) {
    var d = e[u];
    n === "big" ? (o[c] = d >>> 24, o[c + 1] = d >>> 16 & 255, o[c + 2] = d >>> 8 & 255, o[c + 3] = d & 255) : (o[c + 3] = d >>> 24, o[c + 2] = d >>> 16 & 255, o[c + 1] = d >>> 8 & 255, o[c] = d & 255);
  }
  return o;
}
utils$R.split32 = split32;
function rotr32$1(e, n) {
  return e >>> n | e << 32 - n;
}
utils$R.rotr32 = rotr32$1;
function rotl32$2(e, n) {
  return e << n | e >>> 32 - n;
}
utils$R.rotl32 = rotl32$2;
function sum32$3(e, n) {
  return e + n >>> 0;
}
utils$R.sum32 = sum32$3;
function sum32_3$1(e, n, o) {
  return e + n + o >>> 0;
}
utils$R.sum32_3 = sum32_3$1;
function sum32_4$2(e, n, o, u) {
  return e + n + o + u >>> 0;
}
utils$R.sum32_4 = sum32_4$2;
function sum32_5$2(e, n, o, u, c) {
  return e + n + o + u + c >>> 0;
}
utils$R.sum32_5 = sum32_5$2;
function sum64$1(e, n, o, u) {
  var c = e[n], d = e[n + 1], m = u + d >>> 0, v = (m < u ? 1 : 0) + o + c;
  e[n] = v >>> 0, e[n + 1] = m;
}
utils$R.sum64 = sum64$1;
function sum64_hi$1(e, n, o, u) {
  var c = n + u >>> 0, d = (c < n ? 1 : 0) + e + o;
  return d >>> 0;
}
utils$R.sum64_hi = sum64_hi$1;
function sum64_lo$1(e, n, o, u) {
  var c = n + u;
  return c >>> 0;
}
utils$R.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(e, n, o, u, c, d, m, v) {
  var S = 0, $ = n;
  $ = $ + u >>> 0, S += $ < n ? 1 : 0, $ = $ + d >>> 0, S += $ < d ? 1 : 0, $ = $ + v >>> 0, S += $ < v ? 1 : 0;
  var E = e + o + c + m + S;
  return E >>> 0;
}
utils$R.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(e, n, o, u, c, d, m, v) {
  var S = n + u + d + v;
  return S >>> 0;
}
utils$R.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(e, n, o, u, c, d, m, v, S, $) {
  var E = 0, O = n;
  O = O + u >>> 0, E += O < n ? 1 : 0, O = O + d >>> 0, E += O < d ? 1 : 0, O = O + v >>> 0, E += O < v ? 1 : 0, O = O + $ >>> 0, E += O < $ ? 1 : 0;
  var T = e + o + c + m + S + E;
  return T >>> 0;
}
utils$R.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(e, n, o, u, c, d, m, v, S, $) {
  var E = n + u + d + v + $;
  return E >>> 0;
}
utils$R.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(e, n, o) {
  var u = n << 32 - o | e >>> o;
  return u >>> 0;
}
utils$R.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(e, n, o) {
  var u = e << 32 - o | n >>> o;
  return u >>> 0;
}
utils$R.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(e, n, o) {
  return e >>> o;
}
utils$R.shr64_hi = shr64_hi$1;
function shr64_lo$1(e, n, o) {
  var u = e << 32 - o | n >>> o;
  return u >>> 0;
}
utils$R.shr64_lo = shr64_lo$1;
var common$8 = {}, utils$Q = utils$R, assert$r = minimalisticAssert$1;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$8.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function(n, o) {
  if (n = utils$Q.toArray(n, o), this.pending ? this.pending = this.pending.concat(n) : this.pending = n, this.pendingTotal += n.length, this.pending.length >= this._delta8) {
    n = this.pending;
    var u = n.length % this._delta8;
    this.pending = n.slice(n.length - u, n.length), this.pending.length === 0 && (this.pending = null), n = utils$Q.join32(n, 0, n.length - u, this.endian);
    for (var c = 0; c < n.length; c += this._delta32)
      this._update(n, c, c + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function(n) {
  return this.update(this._pad()), assert$r(this.pending === null), this._digest(n);
};
BlockHash$4.prototype._pad = function() {
  var n = this.pendingTotal, o = this._delta8, u = o - (n + this.padLength) % o, c = new Array(u + this.padLength);
  c[0] = 128;
  for (var d = 1; d < u; d++)
    c[d] = 0;
  if (n <<= 3, this.endian === "big") {
    for (var m = 8; m < this.padLength; m++)
      c[d++] = 0;
    c[d++] = 0, c[d++] = 0, c[d++] = 0, c[d++] = 0, c[d++] = n >>> 24 & 255, c[d++] = n >>> 16 & 255, c[d++] = n >>> 8 & 255, c[d++] = n & 255;
  } else
    for (c[d++] = n & 255, c[d++] = n >>> 8 & 255, c[d++] = n >>> 16 & 255, c[d++] = n >>> 24 & 255, c[d++] = 0, c[d++] = 0, c[d++] = 0, c[d++] = 0, m = 8; m < this.padLength; m++)
      c[d++] = 0;
  return c;
};
var sha$8 = {}, common$7 = {}, utils$P = utils$R, rotr32 = utils$P.rotr32;
function ft_1$1(e, n, o, u) {
  if (e === 0)
    return ch32$1(n, o, u);
  if (e === 1 || e === 3)
    return p32(n, o, u);
  if (e === 2)
    return maj32$1(n, o, u);
}
common$7.ft_1 = ft_1$1;
function ch32$1(e, n, o) {
  return e & n ^ ~e & o;
}
common$7.ch32 = ch32$1;
function maj32$1(e, n, o) {
  return e & n ^ e & o ^ n & o;
}
common$7.maj32 = maj32$1;
function p32(e, n, o) {
  return e ^ n ^ o;
}
common$7.p32 = p32;
function s0_256$1(e) {
  return rotr32(e, 2) ^ rotr32(e, 13) ^ rotr32(e, 22);
}
common$7.s0_256 = s0_256$1;
function s1_256$1(e) {
  return rotr32(e, 6) ^ rotr32(e, 11) ^ rotr32(e, 25);
}
common$7.s1_256 = s1_256$1;
function g0_256$1(e) {
  return rotr32(e, 7) ^ rotr32(e, 18) ^ e >>> 3;
}
common$7.g0_256 = g0_256$1;
function g1_256$1(e) {
  return rotr32(e, 17) ^ rotr32(e, 19) ^ e >>> 10;
}
common$7.g1_256 = g1_256$1;
var utils$O = utils$R, common$6 = common$8, shaCommon$1 = common$7, rotl32$1 = utils$O.rotl32, sum32$2 = utils$O.sum32, sum32_5$1 = utils$O.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$6.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$O.inherits(SHA1, BlockHash$3);
var _1$1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function(n, o) {
  for (var u = this.W, c = 0; c < 16; c++)
    u[c] = n[o + c];
  for (; c < u.length; c++)
    u[c] = rotl32$1(u[c - 3] ^ u[c - 8] ^ u[c - 14] ^ u[c - 16], 1);
  var d = this.h[0], m = this.h[1], v = this.h[2], S = this.h[3], $ = this.h[4];
  for (c = 0; c < u.length; c++) {
    var E = ~~(c / 20), O = sum32_5$1(rotl32$1(d, 5), ft_1(E, m, v, S), $, u[c], sha1_K[E]);
    $ = S, S = v, v = rotl32$1(m, 30), m = d, d = O;
  }
  this.h[0] = sum32$2(this.h[0], d), this.h[1] = sum32$2(this.h[1], m), this.h[2] = sum32$2(this.h[2], v), this.h[3] = sum32$2(this.h[3], S), this.h[4] = sum32$2(this.h[4], $);
};
SHA1.prototype._digest = function(n) {
  return n === "hex" ? utils$O.toHex32(this.h, "big") : utils$O.split32(this.h, "big");
};
var utils$N = utils$R, common$5 = common$8, shaCommon = common$7, assert$q = minimalisticAssert$1, sum32$1 = utils$N.sum32, sum32_4$1 = utils$N.sum32_4, sum32_5 = utils$N.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$5.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$2() {
  if (!(this instanceof SHA256$2))
    return new SHA256$2();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$N.inherits(SHA256$2, BlockHash$2);
var _256$1 = SHA256$2;
SHA256$2.blockSize = 512;
SHA256$2.outSize = 256;
SHA256$2.hmacStrength = 192;
SHA256$2.padLength = 64;
SHA256$2.prototype._update = function(n, o) {
  for (var u = this.W, c = 0; c < 16; c++)
    u[c] = n[o + c];
  for (; c < u.length; c++)
    u[c] = sum32_4$1(g1_256(u[c - 2]), u[c - 7], g0_256(u[c - 15]), u[c - 16]);
  var d = this.h[0], m = this.h[1], v = this.h[2], S = this.h[3], $ = this.h[4], E = this.h[5], O = this.h[6], T = this.h[7];
  for (assert$q(this.k.length === u.length), c = 0; c < u.length; c++) {
    var y = sum32_5(T, s1_256($), ch32($, E, O), this.k[c], u[c]), V = sum32$1(s0_256(d), maj32(d, m, v));
    T = O, O = E, E = $, $ = sum32$1(S, y), S = v, v = m, m = d, d = sum32$1(y, V);
  }
  this.h[0] = sum32$1(this.h[0], d), this.h[1] = sum32$1(this.h[1], m), this.h[2] = sum32$1(this.h[2], v), this.h[3] = sum32$1(this.h[3], S), this.h[4] = sum32$1(this.h[4], $), this.h[5] = sum32$1(this.h[5], E), this.h[6] = sum32$1(this.h[6], O), this.h[7] = sum32$1(this.h[7], T);
};
SHA256$2.prototype._digest = function(n) {
  return n === "hex" ? utils$N.toHex32(this.h, "big") : utils$N.split32(this.h, "big");
};
var utils$M = utils$R, SHA256$1 = _256$1;
function SHA224$1() {
  if (!(this instanceof SHA224$1))
    return new SHA224$1();
  SHA256$1.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$M.inherits(SHA224$1, SHA256$1);
var _224$1 = SHA224$1;
SHA224$1.blockSize = 512;
SHA224$1.outSize = 224;
SHA224$1.hmacStrength = 192;
SHA224$1.padLength = 64;
SHA224$1.prototype._digest = function(n) {
  return n === "hex" ? utils$M.toHex32(this.h.slice(0, 7), "big") : utils$M.split32(this.h.slice(0, 7), "big");
};
var utils$L = utils$R, common$4 = common$8, assert$p = minimalisticAssert$1, rotr64_hi = utils$L.rotr64_hi, rotr64_lo = utils$L.rotr64_lo, shr64_hi = utils$L.shr64_hi, shr64_lo = utils$L.shr64_lo, sum64 = utils$L.sum64, sum64_hi = utils$L.sum64_hi, sum64_lo = utils$L.sum64_lo, sum64_4_hi = utils$L.sum64_4_hi, sum64_4_lo = utils$L.sum64_4_lo, sum64_5_hi = utils$L.sum64_5_hi, sum64_5_lo = utils$L.sum64_5_lo, BlockHash$1 = common$4.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$1() {
  if (!(this instanceof SHA512$1))
    return new SHA512$1();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$L.inherits(SHA512$1, BlockHash$1);
var _512 = SHA512$1;
SHA512$1.blockSize = 1024;
SHA512$1.outSize = 512;
SHA512$1.hmacStrength = 192;
SHA512$1.padLength = 128;
SHA512$1.prototype._prepareBlock = function(n, o) {
  for (var u = this.W, c = 0; c < 32; c++)
    u[c] = n[o + c];
  for (; c < u.length; c += 2) {
    var d = g1_512_hi(u[c - 4], u[c - 3]), m = g1_512_lo(u[c - 4], u[c - 3]), v = u[c - 14], S = u[c - 13], $ = g0_512_hi(u[c - 30], u[c - 29]), E = g0_512_lo(u[c - 30], u[c - 29]), O = u[c - 32], T = u[c - 31];
    u[c] = sum64_4_hi(
      d,
      m,
      v,
      S,
      $,
      E,
      O,
      T
    ), u[c + 1] = sum64_4_lo(
      d,
      m,
      v,
      S,
      $,
      E,
      O,
      T
    );
  }
};
SHA512$1.prototype._update = function(n, o) {
  this._prepareBlock(n, o);
  var u = this.W, c = this.h[0], d = this.h[1], m = this.h[2], v = this.h[3], S = this.h[4], $ = this.h[5], E = this.h[6], O = this.h[7], T = this.h[8], y = this.h[9], V = this.h[10], M = this.h[11], G = this.h[12], k = this.h[13], F = this.h[14], X = this.h[15];
  assert$p(this.k.length === u.length);
  for (var ee = 0; ee < u.length; ee += 2) {
    var ue = F, Q = X, Y = s1_512_hi(T, y), pe = s1_512_lo(T, y), oe = ch64_hi(T, y, V, M, G), ne = ch64_lo(T, y, V, M, G, k), H = this.k[ee], C = this.k[ee + 1], w = u[ee], P = u[ee + 1], J = sum64_5_hi(
      ue,
      Q,
      Y,
      pe,
      oe,
      ne,
      H,
      C,
      w,
      P
    ), se = sum64_5_lo(
      ue,
      Q,
      Y,
      pe,
      oe,
      ne,
      H,
      C,
      w,
      P
    );
    ue = s0_512_hi(c, d), Q = s0_512_lo(c, d), Y = maj64_hi(c, d, m, v, S), pe = maj64_lo(c, d, m, v, S, $);
    var fe = sum64_hi(ue, Q, Y, pe), N = sum64_lo(ue, Q, Y, pe);
    F = G, X = k, G = V, k = M, V = T, M = y, T = sum64_hi(E, O, J, se), y = sum64_lo(O, O, J, se), E = S, O = $, S = m, $ = v, m = c, v = d, c = sum64_hi(J, se, fe, N), d = sum64_lo(J, se, fe, N);
  }
  sum64(this.h, 0, c, d), sum64(this.h, 2, m, v), sum64(this.h, 4, S, $), sum64(this.h, 6, E, O), sum64(this.h, 8, T, y), sum64(this.h, 10, V, M), sum64(this.h, 12, G, k), sum64(this.h, 14, F, X);
};
SHA512$1.prototype._digest = function(n) {
  return n === "hex" ? utils$L.toHex32(this.h, "big") : utils$L.split32(this.h, "big");
};
function ch64_hi(e, n, o, u, c) {
  var d = e & o ^ ~e & c;
  return d < 0 && (d += 4294967296), d;
}
function ch64_lo(e, n, o, u, c, d) {
  var m = n & u ^ ~n & d;
  return m < 0 && (m += 4294967296), m;
}
function maj64_hi(e, n, o, u, c) {
  var d = e & o ^ e & c ^ o & c;
  return d < 0 && (d += 4294967296), d;
}
function maj64_lo(e, n, o, u, c, d) {
  var m = n & u ^ n & d ^ u & d;
  return m < 0 && (m += 4294967296), m;
}
function s0_512_hi(e, n) {
  var o = rotr64_hi(e, n, 28), u = rotr64_hi(n, e, 2), c = rotr64_hi(n, e, 7), d = o ^ u ^ c;
  return d < 0 && (d += 4294967296), d;
}
function s0_512_lo(e, n) {
  var o = rotr64_lo(e, n, 28), u = rotr64_lo(n, e, 2), c = rotr64_lo(n, e, 7), d = o ^ u ^ c;
  return d < 0 && (d += 4294967296), d;
}
function s1_512_hi(e, n) {
  var o = rotr64_hi(e, n, 14), u = rotr64_hi(e, n, 18), c = rotr64_hi(n, e, 9), d = o ^ u ^ c;
  return d < 0 && (d += 4294967296), d;
}
function s1_512_lo(e, n) {
  var o = rotr64_lo(e, n, 14), u = rotr64_lo(e, n, 18), c = rotr64_lo(n, e, 9), d = o ^ u ^ c;
  return d < 0 && (d += 4294967296), d;
}
function g0_512_hi(e, n) {
  var o = rotr64_hi(e, n, 1), u = rotr64_hi(e, n, 8), c = shr64_hi(e, n, 7), d = o ^ u ^ c;
  return d < 0 && (d += 4294967296), d;
}
function g0_512_lo(e, n) {
  var o = rotr64_lo(e, n, 1), u = rotr64_lo(e, n, 8), c = shr64_lo(e, n, 7), d = o ^ u ^ c;
  return d < 0 && (d += 4294967296), d;
}
function g1_512_hi(e, n) {
  var o = rotr64_hi(e, n, 19), u = rotr64_hi(n, e, 29), c = shr64_hi(e, n, 6), d = o ^ u ^ c;
  return d < 0 && (d += 4294967296), d;
}
function g1_512_lo(e, n) {
  var o = rotr64_lo(e, n, 19), u = rotr64_lo(n, e, 29), c = shr64_lo(e, n, 6), d = o ^ u ^ c;
  return d < 0 && (d += 4294967296), d;
}
var utils$K = utils$R, SHA512 = _512;
function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();
  SHA512.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$K.inherits(SHA384, SHA512);
var _384 = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function(n) {
  return n === "hex" ? utils$K.toHex32(this.h.slice(0, 12), "big") : utils$K.split32(this.h.slice(0, 12), "big");
};
sha$8.sha1 = _1$1;
sha$8.sha224 = _224$1;
sha$8.sha256 = _256$1;
sha$8.sha384 = _384;
sha$8.sha512 = _512;
var ripemd$8 = {}, utils$J = utils$R, common$3 = common$8, rotl32 = utils$J.rotl32, sum32 = utils$J.sum32, sum32_3 = utils$J.sum32_3, sum32_4 = utils$J.sum32_4, BlockHash = common$3.BlockHash;
function RIPEMD160$1() {
  if (!(this instanceof RIPEMD160$1))
    return new RIPEMD160$1();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$J.inherits(RIPEMD160$1, BlockHash);
ripemd$8.ripemd160 = RIPEMD160$1;
RIPEMD160$1.blockSize = 512;
RIPEMD160$1.outSize = 160;
RIPEMD160$1.hmacStrength = 192;
RIPEMD160$1.padLength = 64;
RIPEMD160$1.prototype._update = function(n, o) {
  for (var u = this.h[0], c = this.h[1], d = this.h[2], m = this.h[3], v = this.h[4], S = u, $ = c, E = d, O = m, T = v, y = 0; y < 80; y++) {
    var V = sum32(
      rotl32(
        sum32_4(u, f$1(y, c, d, m), n[r[y] + o], K(y)),
        s[y]
      ),
      v
    );
    u = v, v = m, m = rotl32(d, 10), d = c, c = V, V = sum32(
      rotl32(
        sum32_4(S, f$1(79 - y, $, E, O), n[rh[y] + o], Kh(y)),
        sh[y]
      ),
      T
    ), S = T, T = O, O = rotl32(E, 10), E = $, $ = V;
  }
  V = sum32_3(this.h[1], d, O), this.h[1] = sum32_3(this.h[2], m, T), this.h[2] = sum32_3(this.h[3], v, S), this.h[3] = sum32_3(this.h[4], u, $), this.h[4] = sum32_3(this.h[0], c, E), this.h[0] = V;
};
RIPEMD160$1.prototype._digest = function(n) {
  return n === "hex" ? utils$J.toHex32(this.h, "little") : utils$J.split32(this.h, "little");
};
function f$1(e, n, o, u) {
  return e <= 15 ? n ^ o ^ u : e <= 31 ? n & o | ~n & u : e <= 47 ? (n | ~o) ^ u : e <= 63 ? n & u | o & ~u : n ^ (o | ~u);
}
function K(e) {
  return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function Kh(e) {
  return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var r = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$I = utils$R, assert$o = minimalisticAssert$1;
function Hmac$8(e, n, o) {
  if (!(this instanceof Hmac$8))
    return new Hmac$8(e, n, o);
  this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(utils$I.toArray(n, o));
}
var hmac$8 = Hmac$8;
Hmac$8.prototype._init = function(n) {
  n.length > this.blockSize && (n = new this.Hash().update(n).digest()), assert$o(n.length <= this.blockSize);
  for (var o = n.length; o < this.blockSize; o++)
    n.push(0);
  for (o = 0; o < n.length; o++)
    n[o] ^= 54;
  for (this.inner = new this.Hash().update(n), o = 0; o < n.length; o++)
    n[o] ^= 106;
  this.outer = new this.Hash().update(n);
};
Hmac$8.prototype.update = function(n, o) {
  return this.inner.update(n, o), this;
};
Hmac$8.prototype.digest = function(n) {
  return this.outer.update(this.inner.digest()), this.outer.digest(n);
};
(function(e) {
  var n = e;
  n.utils = utils$R, n.common = common$8, n.sha = sha$8, n.ripemd = ripemd$8, n.hmac = hmac$8, n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
})(hash$4);
const hash$3 = /* @__PURE__ */ getDefaultExportFromCjs(hash$4);
var secp256k1$g, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1$g = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$g;
}
(function(e) {
  var n = e, o = hash$4, u = curve, c = utils$X, d = c.assert;
  function m($) {
    $.type === "short" ? this.curve = new u.short($) : $.type === "edwards" ? this.curve = new u.edwards($) : this.curve = new u.mont($), this.g = this.curve.g, this.n = this.curve.n, this.hash = $.hash, d(this.g.validate(), "Invalid curve"), d(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  n.PresetCurve = m;
  function v($, E) {
    Object.defineProperty(n, $, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var O = new m(E);
        return Object.defineProperty(n, $, {
          configurable: !0,
          enumerable: !0,
          value: O
        }), O;
      }
    });
  }
  v("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: o.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), v("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: o.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), v("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: o.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), v("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: o.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), v("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: o.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), v("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: o.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), v("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: o.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var S;
  try {
    S = requireSecp256k1();
  } catch {
    S = void 0;
  }
  v("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: o.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      S
    ]
  });
})(curves$1);
var hash$2 = hash$4, utils$H = utils$W, assert$n = minimalisticAssert$1;
function HmacDRBG$1(e) {
  if (!(this instanceof HmacDRBG$1))
    return new HmacDRBG$1(e);
  this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var n = utils$H.toArray(e.entropy, e.entropyEnc || "hex"), o = utils$H.toArray(e.nonce, e.nonceEnc || "hex"), u = utils$H.toArray(e.pers, e.persEnc || "hex");
  assert$n(
    n.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(n, o, u);
}
var hmacDrbg$1 = HmacDRBG$1;
HmacDRBG$1.prototype._init = function(n, o, u) {
  var c = n.concat(o).concat(u);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var d = 0; d < this.V.length; d++)
    this.K[d] = 0, this.V[d] = 1;
  this._update(c), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG$1.prototype._hmac = function() {
  return new hash$2.hmac(this.hash, this.K);
};
HmacDRBG$1.prototype._update = function(n) {
  var o = this._hmac().update(this.V).update([0]);
  n && (o = o.update(n)), this.K = o.digest(), this.V = this._hmac().update(this.V).digest(), n && (this.K = this._hmac().update(this.V).update([1]).update(n).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG$1.prototype.reseed = function(n, o, u, c) {
  typeof o != "string" && (c = u, u = o, o = null), n = utils$H.toArray(n, o), u = utils$H.toArray(u, c), assert$n(
    n.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(n.concat(u || [])), this._reseed = 1;
};
HmacDRBG$1.prototype.generate = function(n, o, u, c) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof o != "string" && (c = u, u = o, o = null), u && (u = utils$H.toArray(u, c || "hex"), this._update(u));
  for (var d = []; d.length < n; )
    this.V = this._hmac().update(this.V).digest(), d = d.concat(this.V);
  var m = d.slice(0, n);
  return this._update(u), this._reseed++, utils$H.encode(m, o);
};
var BN$2 = bnExports, utils$G = utils$X, assert$m = utils$G.assert;
function KeyPair$3(e, n) {
  this.ec = e, this.priv = null, this.pub = null, n.priv && this._importPrivate(n.priv, n.privEnc), n.pub && this._importPublic(n.pub, n.pubEnc);
}
var key$2 = KeyPair$3;
KeyPair$3.fromPublic = function(n, o, u) {
  return o instanceof KeyPair$3 ? o : new KeyPair$3(n, {
    pub: o,
    pubEnc: u
  });
};
KeyPair$3.fromPrivate = function(n, o, u) {
  return o instanceof KeyPair$3 ? o : new KeyPair$3(n, {
    priv: o,
    privEnc: u
  });
};
KeyPair$3.prototype.validate = function() {
  var n = this.getPublic();
  return n.isInfinity() ? { result: !1, reason: "Invalid public key" } : n.validate() ? n.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$3.prototype.getPublic = function(n, o) {
  return typeof n == "string" && (o = n, n = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), o ? this.pub.encode(o, n) : this.pub;
};
KeyPair$3.prototype.getPrivate = function(n) {
  return n === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$3.prototype._importPrivate = function(n, o) {
  this.priv = new BN$2(n, o || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$3.prototype._importPublic = function(n, o) {
  if (n.x || n.y) {
    this.ec.curve.type === "mont" ? assert$m(n.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$m(n.x && n.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(n.x, n.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(n, o);
};
KeyPair$3.prototype.derive = function(n) {
  return n.validate() || assert$m(n.validate(), "public point not validated"), n.mul(this.priv).getX();
};
KeyPair$3.prototype.sign = function(n, o, u) {
  return this.ec.sign(n, this, o, u);
};
KeyPair$3.prototype.verify = function(n, o) {
  return this.ec.verify(n, o, this);
};
KeyPair$3.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$1 = bnExports, utils$F = utils$X, assert$l = utils$F.assert;
function Signature$3(e, n) {
  if (e instanceof Signature$3)
    return e;
  this._importDER(e, n) || (assert$l(e.r && e.s, "Signature without r or s"), this.r = new BN$1(e.r, 16), this.s = new BN$1(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var signature$4 = Signature$3;
function Position$1() {
  this.place = 0;
}
function getLength$1(e, n) {
  var o = e[n.place++];
  if (!(o & 128))
    return o;
  var u = o & 15;
  if (u === 0 || u > 4)
    return !1;
  for (var c = 0, d = 0, m = n.place; d < u; d++, m++)
    c <<= 8, c |= e[m], c >>>= 0;
  return c <= 127 ? !1 : (n.place = m, c);
}
function rmPadding$1(e) {
  for (var n = 0, o = e.length - 1; !e[n] && !(e[n + 1] & 128) && n < o; )
    n++;
  return n === 0 ? e : e.slice(n);
}
Signature$3.prototype._importDER = function(n, o) {
  n = utils$F.toArray(n, o);
  var u = new Position$1();
  if (n[u.place++] !== 48)
    return !1;
  var c = getLength$1(n, u);
  if (c === !1 || c + u.place !== n.length || n[u.place++] !== 2)
    return !1;
  var d = getLength$1(n, u);
  if (d === !1)
    return !1;
  var m = n.slice(u.place, d + u.place);
  if (u.place += d, n[u.place++] !== 2)
    return !1;
  var v = getLength$1(n, u);
  if (v === !1 || n.length !== v + u.place)
    return !1;
  var S = n.slice(u.place, v + u.place);
  if (m[0] === 0)
    if (m[1] & 128)
      m = m.slice(1);
    else
      return !1;
  if (S[0] === 0)
    if (S[1] & 128)
      S = S.slice(1);
    else
      return !1;
  return this.r = new BN$1(m), this.s = new BN$1(S), this.recoveryParam = null, !0;
};
function constructLength$1(e, n) {
  if (n < 128) {
    e.push(n);
    return;
  }
  var o = 1 + (Math.log(n) / Math.LN2 >>> 3);
  for (e.push(o | 128); --o; )
    e.push(n >>> (o << 3) & 255);
  e.push(n);
}
Signature$3.prototype.toDER = function(n) {
  var o = this.r.toArray(), u = this.s.toArray();
  for (o[0] & 128 && (o = [0].concat(o)), u[0] & 128 && (u = [0].concat(u)), o = rmPadding$1(o), u = rmPadding$1(u); !u[0] && !(u[1] & 128); )
    u = u.slice(1);
  var c = [2];
  constructLength$1(c, o.length), c = c.concat(o), c.push(2), constructLength$1(c, u.length);
  var d = c.concat(u), m = [48];
  return constructLength$1(m, d.length), m = m.concat(d), utils$F.encode(m, n);
};
var ec$1, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc)
    return ec$1;
  hasRequiredEc = 1;
  var e = bnExports, n = hmacDrbg$1, o = utils$X, u = curves$1, c = requireBrorand(), d = o.assert, m = key$2, v = signature$4;
  function S($) {
    if (!(this instanceof S))
      return new S($);
    typeof $ == "string" && (d(
      Object.prototype.hasOwnProperty.call(u, $),
      "Unknown curve " + $
    ), $ = u[$]), $ instanceof u.PresetCurve && ($ = { curve: $ }), this.curve = $.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = $.curve.g, this.g.precompute($.curve.n.bitLength() + 1), this.hash = $.hash || $.curve.hash;
  }
  return ec$1 = S, S.prototype.keyPair = function(E) {
    return new m(this, E);
  }, S.prototype.keyFromPrivate = function(E, O) {
    return m.fromPrivate(this, E, O);
  }, S.prototype.keyFromPublic = function(E, O) {
    return m.fromPublic(this, E, O);
  }, S.prototype.genKeyPair = function(E) {
    E || (E = {});
    for (var O = new n({
      hash: this.hash,
      pers: E.pers,
      persEnc: E.persEnc || "utf8",
      entropy: E.entropy || c(this.hash.hmacStrength),
      entropyEnc: E.entropy && E.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), T = this.n.byteLength(), y = this.n.sub(new e(2)); ; ) {
      var V = new e(O.generate(T));
      if (!(V.cmp(y) > 0))
        return V.iaddn(1), this.keyFromPrivate(V);
    }
  }, S.prototype._truncateToN = function(E, O) {
    var T = E.byteLength() * 8 - this.n.bitLength();
    return T > 0 && (E = E.ushrn(T)), !O && E.cmp(this.n) >= 0 ? E.sub(this.n) : E;
  }, S.prototype.sign = function(E, O, T, y) {
    typeof T == "object" && (y = T, T = null), y || (y = {}), O = this.keyFromPrivate(O, T), E = this._truncateToN(new e(E, 16));
    for (var V = this.n.byteLength(), M = O.getPrivate().toArray("be", V), G = E.toArray("be", V), k = new n({
      hash: this.hash,
      entropy: M,
      nonce: G,
      pers: y.pers,
      persEnc: y.persEnc || "utf8"
    }), F = this.n.sub(new e(1)), X = 0; ; X++) {
      var ee = y.k ? y.k(X) : new e(k.generate(this.n.byteLength()));
      if (ee = this._truncateToN(ee, !0), !(ee.cmpn(1) <= 0 || ee.cmp(F) >= 0)) {
        var ue = this.g.mul(ee);
        if (!ue.isInfinity()) {
          var Q = ue.getX(), Y = Q.umod(this.n);
          if (Y.cmpn(0) !== 0) {
            var pe = ee.invm(this.n).mul(Y.mul(O.getPrivate()).iadd(E));
            if (pe = pe.umod(this.n), pe.cmpn(0) !== 0) {
              var oe = (ue.getY().isOdd() ? 1 : 0) | (Q.cmp(Y) !== 0 ? 2 : 0);
              return y.canonical && pe.cmp(this.nh) > 0 && (pe = this.n.sub(pe), oe ^= 1), new v({ r: Y, s: pe, recoveryParam: oe });
            }
          }
        }
      }
    }
  }, S.prototype.verify = function(E, O, T, y) {
    E = this._truncateToN(new e(E, 16)), T = this.keyFromPublic(T, y), O = new v(O, "hex");
    var V = O.r, M = O.s;
    if (V.cmpn(1) < 0 || V.cmp(this.n) >= 0 || M.cmpn(1) < 0 || M.cmp(this.n) >= 0)
      return !1;
    var G = M.invm(this.n), k = G.mul(E).umod(this.n), F = G.mul(V).umod(this.n), X;
    return this.curve._maxwellTrick ? (X = this.g.jmulAdd(k, T.getPublic(), F), X.isInfinity() ? !1 : X.eqXToP(V)) : (X = this.g.mulAdd(k, T.getPublic(), F), X.isInfinity() ? !1 : X.getX().umod(this.n).cmp(V) === 0);
  }, S.prototype.recoverPubKey = function($, E, O, T) {
    d((3 & O) === O, "The recovery param is more than two bits"), E = new v(E, T);
    var y = this.n, V = new e($), M = E.r, G = E.s, k = O & 1, F = O >> 1;
    if (M.cmp(this.curve.p.umod(this.curve.n)) >= 0 && F)
      throw new Error("Unable to find sencond key candinate");
    F ? M = this.curve.pointFromX(M.add(this.curve.n), k) : M = this.curve.pointFromX(M, k);
    var X = E.r.invm(y), ee = y.sub(V).mul(X).umod(y), ue = G.mul(X).umod(y);
    return this.g.mulAdd(ee, M, ue);
  }, S.prototype.getKeyRecoveryParam = function($, E, O, T) {
    if (E = new v(E, T), E.recoveryParam !== null)
      return E.recoveryParam;
    for (var y = 0; y < 4; y++) {
      var V;
      try {
        V = this.recoverPubKey($, E, y);
      } catch {
        continue;
      }
      if (V.eq(O))
        return y;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec$1;
}
var utils$E = utils$X, assert$k = utils$E.assert, parseBytes$2 = utils$E.parseBytes, cachedProperty$1 = utils$E.cachedProperty;
function KeyPair$2(e, n) {
  this.eddsa = e, this._secret = parseBytes$2(n.secret), e.isPoint(n.pub) ? this._pub = n.pub : this._pubBytes = parseBytes$2(n.pub);
}
KeyPair$2.fromPublic = function(n, o) {
  return o instanceof KeyPair$2 ? o : new KeyPair$2(n, { pub: o });
};
KeyPair$2.fromSecret = function(n, o) {
  return o instanceof KeyPair$2 ? o : new KeyPair$2(n, { secret: o });
};
KeyPair$2.prototype.secret = function() {
  return this._secret;
};
cachedProperty$1(KeyPair$2, "pubBytes", function() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$2, "pub", function() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$2, "privBytes", function() {
  var n = this.eddsa, o = this.hash(), u = n.encodingLength - 1, c = o.slice(0, n.encodingLength);
  return c[0] &= 248, c[u] &= 127, c[u] |= 64, c;
});
cachedProperty$1(KeyPair$2, "priv", function() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$2, "hash", function() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$2, "messagePrefix", function() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$2.prototype.sign = function(n) {
  return assert$k(this._secret, "KeyPair can only verify"), this.eddsa.sign(n, this);
};
KeyPair$2.prototype.verify = function(n, o) {
  return this.eddsa.verify(n, o, this);
};
KeyPair$2.prototype.getSecret = function(n) {
  return assert$k(this._secret, "KeyPair is public only"), utils$E.encode(this.secret(), n);
};
KeyPair$2.prototype.getPublic = function(n) {
  return utils$E.encode(this.pubBytes(), n);
};
var key$1 = KeyPair$2, BN = bnExports, utils$D = utils$X, assert$j = utils$D.assert, cachedProperty = utils$D.cachedProperty, parseBytes$1 = utils$D.parseBytes;
function Signature$2(e, n) {
  this.eddsa = e, typeof n != "object" && (n = parseBytes$1(n)), Array.isArray(n) && (n = {
    R: n.slice(0, e.encodingLength),
    S: n.slice(e.encodingLength)
  }), assert$j(n.R && n.S, "Signature without R or S"), e.isPoint(n.R) && (this._R = n.R), n.S instanceof BN && (this._S = n.S), this._Rencoded = Array.isArray(n.R) ? n.R : n.Rencoded, this._Sencoded = Array.isArray(n.S) ? n.S : n.Sencoded;
}
cachedProperty(Signature$2, "S", function() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$2, "R", function() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$2, "Rencoded", function() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$2, "Sencoded", function() {
  return this.eddsa.encodeInt(this.S());
});
Signature$2.prototype.toBytes = function() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$2.prototype.toHex = function() {
  return utils$D.encode(this.toBytes(), "hex").toUpperCase();
};
var signature$3 = Signature$2, hash$1 = hash$4, curves = curves$1, utils$C = utils$X, assert$i = utils$C.assert, parseBytes = utils$C.parseBytes, KeyPair$1 = key$1, Signature$1 = signature$3;
function EDDSA(e) {
  if (assert$i(e === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(e);
  e = curves[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = hash$1.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function(n, o) {
  n = parseBytes(n);
  var u = this.keyFromSecret(o), c = this.hashInt(u.messagePrefix(), n), d = this.g.mul(c), m = this.encodePoint(d), v = this.hashInt(m, u.pubBytes(), n).mul(u.priv()), S = c.add(v).umod(this.curve.n);
  return this.makeSignature({ R: d, S, Rencoded: m });
};
EDDSA.prototype.verify = function(n, o, u) {
  n = parseBytes(n), o = this.makeSignature(o);
  var c = this.keyFromPublic(u), d = this.hashInt(o.Rencoded(), c.pubBytes(), n), m = this.g.mul(o.S()), v = o.R().add(c.pub().mul(d));
  return v.eq(m);
};
EDDSA.prototype.hashInt = function() {
  for (var n = this.hash(), o = 0; o < arguments.length; o++)
    n.update(arguments[o]);
  return utils$C.intFromLE(n.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function(n) {
  return KeyPair$1.fromPublic(this, n);
};
EDDSA.prototype.keyFromSecret = function(n) {
  return KeyPair$1.fromSecret(this, n);
};
EDDSA.prototype.makeSignature = function(n) {
  return n instanceof Signature$1 ? n : new Signature$1(this, n);
};
EDDSA.prototype.encodePoint = function(n) {
  var o = n.getY().toArray("le", this.encodingLength);
  return o[this.encodingLength - 1] |= n.getX().isOdd() ? 128 : 0, o;
};
EDDSA.prototype.decodePoint = function(n) {
  n = utils$C.parseBytes(n);
  var o = n.length - 1, u = n.slice(0, o).concat(n[o] & -129), c = (n[o] & 128) !== 0, d = utils$C.intFromLE(u);
  return this.curve.pointFromY(d, c);
};
EDDSA.prototype.encodeInt = function(n) {
  return n.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function(n) {
  return utils$C.intFromLE(n);
};
EDDSA.prototype.isPoint = function(n) {
  return n instanceof this.pointClass;
};
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(e) {
    var n = e;
    n.version = require$$0$2.version, n.utils = utils$X, n.rand = requireBrorand(), n.curve = curve, n.curves = curves$1, n.ec = requireEc(), n.eddsa = eddsa;
  }(elliptic)), elliptic;
}
var asn1$1 = {}, asn1 = {}, bn$2 = { exports: {} };
bn$2.exports;
var hasRequiredBn$2;
function requireBn$2() {
  return hasRequiredBn$2 || (hasRequiredBn$2 = 1, function(e) {
    (function(n, o) {
      function u(H, C) {
        if (!H)
          throw new Error(C || "Assertion failed");
      }
      function c(H, C) {
        H.super_ = C;
        var w = function() {
        };
        w.prototype = C.prototype, H.prototype = new w(), H.prototype.constructor = H;
      }
      function d(H, C, w) {
        if (d.isBN(H))
          return H;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, H !== null && ((C === "le" || C === "be") && (w = C, C = 10), this._init(H || 0, C || 10, w || "be"));
      }
      typeof n == "object" ? n.exports = d : o.BN = d, d.BN = d, d.wordSize = 26;
      var m;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = require$$0$3.Buffer;
      } catch {
      }
      d.isBN = function(C) {
        return C instanceof d ? !0 : C !== null && typeof C == "object" && C.constructor.wordSize === d.wordSize && Array.isArray(C.words);
      }, d.max = function(C, w) {
        return C.cmp(w) > 0 ? C : w;
      }, d.min = function(C, w) {
        return C.cmp(w) < 0 ? C : w;
      }, d.prototype._init = function(C, w, P) {
        if (typeof C == "number")
          return this._initNumber(C, w, P);
        if (typeof C == "object")
          return this._initArray(C, w, P);
        w === "hex" && (w = 16), u(w === (w | 0) && w >= 2 && w <= 36), C = C.toString().replace(/\s+/g, "");
        var J = 0;
        C[0] === "-" && (J++, this.negative = 1), J < C.length && (w === 16 ? this._parseHex(C, J, P) : (this._parseBase(C, w, J), P === "le" && this._initArray(this.toArray(), w, P)));
      }, d.prototype._initNumber = function(C, w, P) {
        C < 0 && (this.negative = 1, C = -C), C < 67108864 ? (this.words = [C & 67108863], this.length = 1) : C < 4503599627370496 ? (this.words = [
          C & 67108863,
          C / 67108864 & 67108863
        ], this.length = 2) : (u(C < 9007199254740992), this.words = [
          C & 67108863,
          C / 67108864 & 67108863,
          1
        ], this.length = 3), P === "le" && this._initArray(this.toArray(), w, P);
      }, d.prototype._initArray = function(C, w, P) {
        if (u(typeof C.length == "number"), C.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(C.length / 3), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se, fe, N = 0;
        if (P === "be")
          for (J = C.length - 1, se = 0; J >= 0; J -= 3)
            fe = C[J] | C[J - 1] << 8 | C[J - 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        else if (P === "le")
          for (J = 0, se = 0; J < C.length; J += 3)
            fe = C[J] | C[J + 1] << 8 | C[J + 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        return this.strip();
      };
      function v(H, C) {
        var w = H.charCodeAt(C);
        return w >= 65 && w <= 70 ? w - 55 : w >= 97 && w <= 102 ? w - 87 : w - 48 & 15;
      }
      function S(H, C, w) {
        var P = v(H, w);
        return w - 1 >= C && (P |= v(H, w - 1) << 4), P;
      }
      d.prototype._parseHex = function(C, w, P) {
        this.length = Math.ceil((C.length - w) / 6), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se = 0, fe = 0, N;
        if (P === "be")
          for (J = C.length - 1; J >= w; J -= 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        else {
          var W = C.length - w;
          for (J = W % 2 === 0 ? w + 1 : w; J < C.length; J += 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        }
        this.strip();
      };
      function $(H, C, w, P) {
        for (var J = 0, se = Math.min(H.length, w), fe = C; fe < se; fe++) {
          var N = H.charCodeAt(fe) - 48;
          J *= P, N >= 49 ? J += N - 49 + 10 : N >= 17 ? J += N - 17 + 10 : J += N;
        }
        return J;
      }
      d.prototype._parseBase = function(C, w, P) {
        this.words = [0], this.length = 1;
        for (var J = 0, se = 1; se <= 67108863; se *= w)
          J++;
        J--, se = se / w | 0;
        for (var fe = C.length - P, N = fe % J, W = Math.min(fe, fe - N) + P, I = 0, te = P; te < W; te += J)
          I = $(C, te, te + J, w), this.imuln(se), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        if (N !== 0) {
          var ge = 1;
          for (I = $(C, te, C.length, w), te = 0; te < N; te++)
            ge *= w;
          this.imuln(ge), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        }
        this.strip();
      }, d.prototype.copy = function(C) {
        C.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          C.words[w] = this.words[w];
        C.length = this.length, C.negative = this.negative, C.red = this.red;
      }, d.prototype.clone = function() {
        var C = new d(null);
        return this.copy(C), C;
      }, d.prototype._expand = function(C) {
        for (; this.length < C; )
          this.words[this.length++] = 0;
        return this;
      }, d.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, d.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, d.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var E = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], O = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], T = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      d.prototype.toString = function(C, w) {
        C = C || 10, w = w | 0 || 1;
        var P;
        if (C === 16 || C === "hex") {
          P = "";
          for (var J = 0, se = 0, fe = 0; fe < this.length; fe++) {
            var N = this.words[fe], W = ((N << J | se) & 16777215).toString(16);
            se = N >>> 24 - J & 16777215, se !== 0 || fe !== this.length - 1 ? P = E[6 - W.length] + W + P : P = W + P, J += 2, J >= 26 && (J -= 26, fe--);
          }
          for (se !== 0 && (P = se.toString(16) + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        if (C === (C | 0) && C >= 2 && C <= 36) {
          var I = O[C], te = T[C];
          P = "";
          var ge = this.clone();
          for (ge.negative = 0; !ge.isZero(); ) {
            var Pe = ge.modn(te).toString(C);
            ge = ge.idivn(te), ge.isZero() ? P = Pe + P : P = E[I - Pe.length] + Pe + P;
          }
          for (this.isZero() && (P = "0" + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        u(!1, "Base should be between 2 and 36");
      }, d.prototype.toNumber = function() {
        var C = this.words[0];
        return this.length === 2 ? C += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? C += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && u(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -C : C;
      }, d.prototype.toJSON = function() {
        return this.toString(16);
      }, d.prototype.toBuffer = function(C, w) {
        return u(typeof m < "u"), this.toArrayLike(m, C, w);
      }, d.prototype.toArray = function(C, w) {
        return this.toArrayLike(Array, C, w);
      }, d.prototype.toArrayLike = function(C, w, P) {
        var J = this.byteLength(), se = P || Math.max(1, J);
        u(J <= se, "byte array longer than desired length"), u(se > 0, "Requested array length <= 0"), this.strip();
        var fe = w === "le", N = new C(se), W, I, te = this.clone();
        if (fe) {
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[I] = W;
          for (; I < se; I++)
            N[I] = 0;
        } else {
          for (I = 0; I < se - J; I++)
            N[I] = 0;
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[se - I - 1] = W;
        }
        return N;
      }, Math.clz32 ? d.prototype._countBits = function(C) {
        return 32 - Math.clz32(C);
      } : d.prototype._countBits = function(C) {
        var w = C, P = 0;
        return w >= 4096 && (P += 13, w >>>= 13), w >= 64 && (P += 7, w >>>= 7), w >= 8 && (P += 4, w >>>= 4), w >= 2 && (P += 2, w >>>= 2), P + w;
      }, d.prototype._zeroBits = function(C) {
        if (C === 0)
          return 26;
        var w = C, P = 0;
        return w & 8191 || (P += 13, w >>>= 13), w & 127 || (P += 7, w >>>= 7), w & 15 || (P += 4, w >>>= 4), w & 3 || (P += 2, w >>>= 2), w & 1 || P++, P;
      }, d.prototype.bitLength = function() {
        var C = this.words[this.length - 1], w = this._countBits(C);
        return (this.length - 1) * 26 + w;
      };
      function y(H) {
        for (var C = new Array(H.bitLength()), w = 0; w < C.length; w++) {
          var P = w / 26 | 0, J = w % 26;
          C[w] = (H.words[P] & 1 << J) >>> J;
        }
        return C;
      }
      d.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var C = 0, w = 0; w < this.length; w++) {
          var P = this._zeroBits(this.words[w]);
          if (C += P, P !== 26)
            break;
        }
        return C;
      }, d.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, d.prototype.toTwos = function(C) {
        return this.negative !== 0 ? this.abs().inotn(C).iaddn(1) : this.clone();
      }, d.prototype.fromTwos = function(C) {
        return this.testn(C - 1) ? this.notn(C).iaddn(1).ineg() : this.clone();
      }, d.prototype.isNeg = function() {
        return this.negative !== 0;
      }, d.prototype.neg = function() {
        return this.clone().ineg();
      }, d.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, d.prototype.iuor = function(C) {
        for (; this.length < C.length; )
          this.words[this.length++] = 0;
        for (var w = 0; w < C.length; w++)
          this.words[w] = this.words[w] | C.words[w];
        return this.strip();
      }, d.prototype.ior = function(C) {
        return u((this.negative | C.negative) === 0), this.iuor(C);
      }, d.prototype.or = function(C) {
        return this.length > C.length ? this.clone().ior(C) : C.clone().ior(this);
      }, d.prototype.uor = function(C) {
        return this.length > C.length ? this.clone().iuor(C) : C.clone().iuor(this);
      }, d.prototype.iuand = function(C) {
        var w;
        this.length > C.length ? w = C : w = this;
        for (var P = 0; P < w.length; P++)
          this.words[P] = this.words[P] & C.words[P];
        return this.length = w.length, this.strip();
      }, d.prototype.iand = function(C) {
        return u((this.negative | C.negative) === 0), this.iuand(C);
      }, d.prototype.and = function(C) {
        return this.length > C.length ? this.clone().iand(C) : C.clone().iand(this);
      }, d.prototype.uand = function(C) {
        return this.length > C.length ? this.clone().iuand(C) : C.clone().iuand(this);
      }, d.prototype.iuxor = function(C) {
        var w, P;
        this.length > C.length ? (w = this, P = C) : (w = C, P = this);
        for (var J = 0; J < P.length; J++)
          this.words[J] = w.words[J] ^ P.words[J];
        if (this !== w)
          for (; J < w.length; J++)
            this.words[J] = w.words[J];
        return this.length = w.length, this.strip();
      }, d.prototype.ixor = function(C) {
        return u((this.negative | C.negative) === 0), this.iuxor(C);
      }, d.prototype.xor = function(C) {
        return this.length > C.length ? this.clone().ixor(C) : C.clone().ixor(this);
      }, d.prototype.uxor = function(C) {
        return this.length > C.length ? this.clone().iuxor(C) : C.clone().iuxor(this);
      }, d.prototype.inotn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = Math.ceil(C / 26) | 0, P = C % 26;
        this._expand(w), P > 0 && w--;
        for (var J = 0; J < w; J++)
          this.words[J] = ~this.words[J] & 67108863;
        return P > 0 && (this.words[J] = ~this.words[J] & 67108863 >> 26 - P), this.strip();
      }, d.prototype.notn = function(C) {
        return this.clone().inotn(C);
      }, d.prototype.setn = function(C, w) {
        u(typeof C == "number" && C >= 0);
        var P = C / 26 | 0, J = C % 26;
        return this._expand(P + 1), w ? this.words[P] = this.words[P] | 1 << J : this.words[P] = this.words[P] & ~(1 << J), this.strip();
      }, d.prototype.iadd = function(C) {
        var w;
        if (this.negative !== 0 && C.negative === 0)
          return this.negative = 0, w = this.isub(C), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && C.negative !== 0)
          return C.negative = 0, w = this.isub(C), C.negative = 1, w._normSign();
        var P, J;
        this.length > C.length ? (P = this, J = C) : (P = C, J = this);
        for (var se = 0, fe = 0; fe < J.length; fe++)
          w = (P.words[fe] | 0) + (J.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        for (; se !== 0 && fe < P.length; fe++)
          w = (P.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        if (this.length = P.length, se !== 0)
          this.words[this.length] = se, this.length++;
        else if (P !== this)
          for (; fe < P.length; fe++)
            this.words[fe] = P.words[fe];
        return this;
      }, d.prototype.add = function(C) {
        var w;
        return C.negative !== 0 && this.negative === 0 ? (C.negative = 0, w = this.sub(C), C.negative ^= 1, w) : C.negative === 0 && this.negative !== 0 ? (this.negative = 0, w = C.sub(this), this.negative = 1, w) : this.length > C.length ? this.clone().iadd(C) : C.clone().iadd(this);
      }, d.prototype.isub = function(C) {
        if (C.negative !== 0) {
          C.negative = 0;
          var w = this.iadd(C);
          return C.negative = 1, w._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(C), this.negative = 1, this._normSign();
        var P = this.cmp(C);
        if (P === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var J, se;
        P > 0 ? (J = this, se = C) : (J = C, se = this);
        for (var fe = 0, N = 0; N < se.length; N++)
          w = (J.words[N] | 0) - (se.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        for (; fe !== 0 && N < J.length; N++)
          w = (J.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        if (fe === 0 && N < J.length && J !== this)
          for (; N < J.length; N++)
            this.words[N] = J.words[N];
        return this.length = Math.max(this.length, N), J !== this && (this.negative = 1), this.strip();
      }, d.prototype.sub = function(C) {
        return this.clone().isub(C);
      };
      function V(H, C, w) {
        w.negative = C.negative ^ H.negative;
        var P = H.length + C.length | 0;
        w.length = P, P = P - 1 | 0;
        var J = H.words[0] | 0, se = C.words[0] | 0, fe = J * se, N = fe & 67108863, W = fe / 67108864 | 0;
        w.words[0] = N;
        for (var I = 1; I < P; I++) {
          for (var te = W >>> 26, ge = W & 67108863, Pe = Math.min(I, C.length - 1), Ke = Math.max(0, I - H.length + 1); Ke <= Pe; Ke++) {
            var xe = I - Ke | 0;
            J = H.words[xe] | 0, se = C.words[Ke] | 0, fe = J * se + ge, te += fe / 67108864 | 0, ge = fe & 67108863;
          }
          w.words[I] = ge | 0, W = te | 0;
        }
        return W !== 0 ? w.words[I] = W | 0 : w.length--, w.strip();
      }
      var M = function(C, w, P) {
        var J = C.words, se = w.words, fe = P.words, N = 0, W, I, te, ge = J[0] | 0, Pe = ge & 8191, Ke = ge >>> 13, xe = J[1] | 0, ze = xe & 8191, nt = xe >>> 13, Qt = J[2] | 0, Et = Qt & 8191, zt = Qt >>> 13, Nt = J[3] | 0, pt = Nt & 8191, at = Nt >>> 13, kt = J[4] | 0, Ut = kt & 8191, dn = kt >>> 13, En = J[5] | 0, Ht = En & 8191, Xt = En >>> 13, On = J[6] | 0, sn = On & 8191, At = On >>> 13, hn = J[7] | 0, $t = hn & 8191, Lt = hn >>> 13, Qn = J[8] | 0, ce = Qn & 8191, Ze = Qn >>> 13, ft = J[9] | 0, It = ft & 8191, rn = ft >>> 13, Ln = se[0] | 0, Pn = Ln & 8191, Ae = Ln >>> 13, Me = se[1] | 0, He = Me & 8191, cn = Me >>> 13, Wt = se[2] | 0, yn = Wt & 8191, pr = Wt >>> 13, Uo = se[3] | 0, ar = Uo & 8191, Sr = Uo >>> 13, Jo = se[4] | 0, fr = Jo & 8191, Er = Jo >>> 13, vo = se[5] | 0, lr = vo & 8191, $r = vo >>> 13, Wo = se[6] | 0, yr = Wo & 8191, Dr = Wo >>> 13, Zo = se[7] | 0, dr = Zo & 8191, Br = Zo >>> 13, Qo = se[8] | 0, tr = Qo & 8191, Mr = Qo >>> 13, qo = se[9] | 0, hr = qo & 8191, Or = qo >>> 13;
        P.negative = C.negative ^ w.negative, P.length = 19, W = Math.imul(Pe, Pn), I = Math.imul(Pe, Ae), I = I + Math.imul(Ke, Pn) | 0, te = Math.imul(Ke, Ae);
        var Fo = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fo >>> 26) | 0, Fo &= 67108863, W = Math.imul(ze, Pn), I = Math.imul(ze, Ae), I = I + Math.imul(nt, Pn) | 0, te = Math.imul(nt, Ae), W = W + Math.imul(Pe, He) | 0, I = I + Math.imul(Pe, cn) | 0, I = I + Math.imul(Ke, He) | 0, te = te + Math.imul(Ke, cn) | 0;
        var No = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, W = Math.imul(Et, Pn), I = Math.imul(Et, Ae), I = I + Math.imul(zt, Pn) | 0, te = Math.imul(zt, Ae), W = W + Math.imul(ze, He) | 0, I = I + Math.imul(ze, cn) | 0, I = I + Math.imul(nt, He) | 0, te = te + Math.imul(nt, cn) | 0, W = W + Math.imul(Pe, yn) | 0, I = I + Math.imul(Pe, pr) | 0, I = I + Math.imul(Ke, yn) | 0, te = te + Math.imul(Ke, pr) | 0;
        var di = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, W = Math.imul(pt, Pn), I = Math.imul(pt, Ae), I = I + Math.imul(at, Pn) | 0, te = Math.imul(at, Ae), W = W + Math.imul(Et, He) | 0, I = I + Math.imul(Et, cn) | 0, I = I + Math.imul(zt, He) | 0, te = te + Math.imul(zt, cn) | 0, W = W + Math.imul(ze, yn) | 0, I = I + Math.imul(ze, pr) | 0, I = I + Math.imul(nt, yn) | 0, te = te + Math.imul(nt, pr) | 0, W = W + Math.imul(Pe, ar) | 0, I = I + Math.imul(Pe, Sr) | 0, I = I + Math.imul(Ke, ar) | 0, te = te + Math.imul(Ke, Sr) | 0;
        var gi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, W = Math.imul(Ut, Pn), I = Math.imul(Ut, Ae), I = I + Math.imul(dn, Pn) | 0, te = Math.imul(dn, Ae), W = W + Math.imul(pt, He) | 0, I = I + Math.imul(pt, cn) | 0, I = I + Math.imul(at, He) | 0, te = te + Math.imul(at, cn) | 0, W = W + Math.imul(Et, yn) | 0, I = I + Math.imul(Et, pr) | 0, I = I + Math.imul(zt, yn) | 0, te = te + Math.imul(zt, pr) | 0, W = W + Math.imul(ze, ar) | 0, I = I + Math.imul(ze, Sr) | 0, I = I + Math.imul(nt, ar) | 0, te = te + Math.imul(nt, Sr) | 0, W = W + Math.imul(Pe, fr) | 0, I = I + Math.imul(Pe, Er) | 0, I = I + Math.imul(Ke, fr) | 0, te = te + Math.imul(Ke, Er) | 0;
        var ai = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, W = Math.imul(Ht, Pn), I = Math.imul(Ht, Ae), I = I + Math.imul(Xt, Pn) | 0, te = Math.imul(Xt, Ae), W = W + Math.imul(Ut, He) | 0, I = I + Math.imul(Ut, cn) | 0, I = I + Math.imul(dn, He) | 0, te = te + Math.imul(dn, cn) | 0, W = W + Math.imul(pt, yn) | 0, I = I + Math.imul(pt, pr) | 0, I = I + Math.imul(at, yn) | 0, te = te + Math.imul(at, pr) | 0, W = W + Math.imul(Et, ar) | 0, I = I + Math.imul(Et, Sr) | 0, I = I + Math.imul(zt, ar) | 0, te = te + Math.imul(zt, Sr) | 0, W = W + Math.imul(ze, fr) | 0, I = I + Math.imul(ze, Er) | 0, I = I + Math.imul(nt, fr) | 0, te = te + Math.imul(nt, Er) | 0, W = W + Math.imul(Pe, lr) | 0, I = I + Math.imul(Pe, $r) | 0, I = I + Math.imul(Ke, lr) | 0, te = te + Math.imul(Ke, $r) | 0;
        var ui = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, W = Math.imul(sn, Pn), I = Math.imul(sn, Ae), I = I + Math.imul(At, Pn) | 0, te = Math.imul(At, Ae), W = W + Math.imul(Ht, He) | 0, I = I + Math.imul(Ht, cn) | 0, I = I + Math.imul(Xt, He) | 0, te = te + Math.imul(Xt, cn) | 0, W = W + Math.imul(Ut, yn) | 0, I = I + Math.imul(Ut, pr) | 0, I = I + Math.imul(dn, yn) | 0, te = te + Math.imul(dn, pr) | 0, W = W + Math.imul(pt, ar) | 0, I = I + Math.imul(pt, Sr) | 0, I = I + Math.imul(at, ar) | 0, te = te + Math.imul(at, Sr) | 0, W = W + Math.imul(Et, fr) | 0, I = I + Math.imul(Et, Er) | 0, I = I + Math.imul(zt, fr) | 0, te = te + Math.imul(zt, Er) | 0, W = W + Math.imul(ze, lr) | 0, I = I + Math.imul(ze, $r) | 0, I = I + Math.imul(nt, lr) | 0, te = te + Math.imul(nt, $r) | 0, W = W + Math.imul(Pe, yr) | 0, I = I + Math.imul(Pe, Dr) | 0, I = I + Math.imul(Ke, yr) | 0, te = te + Math.imul(Ke, Dr) | 0;
        var hi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (hi >>> 26) | 0, hi &= 67108863, W = Math.imul($t, Pn), I = Math.imul($t, Ae), I = I + Math.imul(Lt, Pn) | 0, te = Math.imul(Lt, Ae), W = W + Math.imul(sn, He) | 0, I = I + Math.imul(sn, cn) | 0, I = I + Math.imul(At, He) | 0, te = te + Math.imul(At, cn) | 0, W = W + Math.imul(Ht, yn) | 0, I = I + Math.imul(Ht, pr) | 0, I = I + Math.imul(Xt, yn) | 0, te = te + Math.imul(Xt, pr) | 0, W = W + Math.imul(Ut, ar) | 0, I = I + Math.imul(Ut, Sr) | 0, I = I + Math.imul(dn, ar) | 0, te = te + Math.imul(dn, Sr) | 0, W = W + Math.imul(pt, fr) | 0, I = I + Math.imul(pt, Er) | 0, I = I + Math.imul(at, fr) | 0, te = te + Math.imul(at, Er) | 0, W = W + Math.imul(Et, lr) | 0, I = I + Math.imul(Et, $r) | 0, I = I + Math.imul(zt, lr) | 0, te = te + Math.imul(zt, $r) | 0, W = W + Math.imul(ze, yr) | 0, I = I + Math.imul(ze, Dr) | 0, I = I + Math.imul(nt, yr) | 0, te = te + Math.imul(nt, Dr) | 0, W = W + Math.imul(Pe, dr) | 0, I = I + Math.imul(Pe, Br) | 0, I = I + Math.imul(Ke, dr) | 0, te = te + Math.imul(Ke, Br) | 0;
        var bi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, W = Math.imul(ce, Pn), I = Math.imul(ce, Ae), I = I + Math.imul(Ze, Pn) | 0, te = Math.imul(Ze, Ae), W = W + Math.imul($t, He) | 0, I = I + Math.imul($t, cn) | 0, I = I + Math.imul(Lt, He) | 0, te = te + Math.imul(Lt, cn) | 0, W = W + Math.imul(sn, yn) | 0, I = I + Math.imul(sn, pr) | 0, I = I + Math.imul(At, yn) | 0, te = te + Math.imul(At, pr) | 0, W = W + Math.imul(Ht, ar) | 0, I = I + Math.imul(Ht, Sr) | 0, I = I + Math.imul(Xt, ar) | 0, te = te + Math.imul(Xt, Sr) | 0, W = W + Math.imul(Ut, fr) | 0, I = I + Math.imul(Ut, Er) | 0, I = I + Math.imul(dn, fr) | 0, te = te + Math.imul(dn, Er) | 0, W = W + Math.imul(pt, lr) | 0, I = I + Math.imul(pt, $r) | 0, I = I + Math.imul(at, lr) | 0, te = te + Math.imul(at, $r) | 0, W = W + Math.imul(Et, yr) | 0, I = I + Math.imul(Et, Dr) | 0, I = I + Math.imul(zt, yr) | 0, te = te + Math.imul(zt, Dr) | 0, W = W + Math.imul(ze, dr) | 0, I = I + Math.imul(ze, Br) | 0, I = I + Math.imul(nt, dr) | 0, te = te + Math.imul(nt, Br) | 0, W = W + Math.imul(Pe, tr) | 0, I = I + Math.imul(Pe, Mr) | 0, I = I + Math.imul(Ke, tr) | 0, te = te + Math.imul(Ke, Mr) | 0;
        var ii = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, W = Math.imul(It, Pn), I = Math.imul(It, Ae), I = I + Math.imul(rn, Pn) | 0, te = Math.imul(rn, Ae), W = W + Math.imul(ce, He) | 0, I = I + Math.imul(ce, cn) | 0, I = I + Math.imul(Ze, He) | 0, te = te + Math.imul(Ze, cn) | 0, W = W + Math.imul($t, yn) | 0, I = I + Math.imul($t, pr) | 0, I = I + Math.imul(Lt, yn) | 0, te = te + Math.imul(Lt, pr) | 0, W = W + Math.imul(sn, ar) | 0, I = I + Math.imul(sn, Sr) | 0, I = I + Math.imul(At, ar) | 0, te = te + Math.imul(At, Sr) | 0, W = W + Math.imul(Ht, fr) | 0, I = I + Math.imul(Ht, Er) | 0, I = I + Math.imul(Xt, fr) | 0, te = te + Math.imul(Xt, Er) | 0, W = W + Math.imul(Ut, lr) | 0, I = I + Math.imul(Ut, $r) | 0, I = I + Math.imul(dn, lr) | 0, te = te + Math.imul(dn, $r) | 0, W = W + Math.imul(pt, yr) | 0, I = I + Math.imul(pt, Dr) | 0, I = I + Math.imul(at, yr) | 0, te = te + Math.imul(at, Dr) | 0, W = W + Math.imul(Et, dr) | 0, I = I + Math.imul(Et, Br) | 0, I = I + Math.imul(zt, dr) | 0, te = te + Math.imul(zt, Br) | 0, W = W + Math.imul(ze, tr) | 0, I = I + Math.imul(ze, Mr) | 0, I = I + Math.imul(nt, tr) | 0, te = te + Math.imul(nt, Mr) | 0, W = W + Math.imul(Pe, hr) | 0, I = I + Math.imul(Pe, Or) | 0, I = I + Math.imul(Ke, hr) | 0, te = te + Math.imul(Ke, Or) | 0;
        var pi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (pi >>> 26) | 0, pi &= 67108863, W = Math.imul(It, He), I = Math.imul(It, cn), I = I + Math.imul(rn, He) | 0, te = Math.imul(rn, cn), W = W + Math.imul(ce, yn) | 0, I = I + Math.imul(ce, pr) | 0, I = I + Math.imul(Ze, yn) | 0, te = te + Math.imul(Ze, pr) | 0, W = W + Math.imul($t, ar) | 0, I = I + Math.imul($t, Sr) | 0, I = I + Math.imul(Lt, ar) | 0, te = te + Math.imul(Lt, Sr) | 0, W = W + Math.imul(sn, fr) | 0, I = I + Math.imul(sn, Er) | 0, I = I + Math.imul(At, fr) | 0, te = te + Math.imul(At, Er) | 0, W = W + Math.imul(Ht, lr) | 0, I = I + Math.imul(Ht, $r) | 0, I = I + Math.imul(Xt, lr) | 0, te = te + Math.imul(Xt, $r) | 0, W = W + Math.imul(Ut, yr) | 0, I = I + Math.imul(Ut, Dr) | 0, I = I + Math.imul(dn, yr) | 0, te = te + Math.imul(dn, Dr) | 0, W = W + Math.imul(pt, dr) | 0, I = I + Math.imul(pt, Br) | 0, I = I + Math.imul(at, dr) | 0, te = te + Math.imul(at, Br) | 0, W = W + Math.imul(Et, tr) | 0, I = I + Math.imul(Et, Mr) | 0, I = I + Math.imul(zt, tr) | 0, te = te + Math.imul(zt, Mr) | 0, W = W + Math.imul(ze, hr) | 0, I = I + Math.imul(ze, Or) | 0, I = I + Math.imul(nt, hr) | 0, te = te + Math.imul(nt, Or) | 0;
        var Ci = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, W = Math.imul(It, yn), I = Math.imul(It, pr), I = I + Math.imul(rn, yn) | 0, te = Math.imul(rn, pr), W = W + Math.imul(ce, ar) | 0, I = I + Math.imul(ce, Sr) | 0, I = I + Math.imul(Ze, ar) | 0, te = te + Math.imul(Ze, Sr) | 0, W = W + Math.imul($t, fr) | 0, I = I + Math.imul($t, Er) | 0, I = I + Math.imul(Lt, fr) | 0, te = te + Math.imul(Lt, Er) | 0, W = W + Math.imul(sn, lr) | 0, I = I + Math.imul(sn, $r) | 0, I = I + Math.imul(At, lr) | 0, te = te + Math.imul(At, $r) | 0, W = W + Math.imul(Ht, yr) | 0, I = I + Math.imul(Ht, Dr) | 0, I = I + Math.imul(Xt, yr) | 0, te = te + Math.imul(Xt, Dr) | 0, W = W + Math.imul(Ut, dr) | 0, I = I + Math.imul(Ut, Br) | 0, I = I + Math.imul(dn, dr) | 0, te = te + Math.imul(dn, Br) | 0, W = W + Math.imul(pt, tr) | 0, I = I + Math.imul(pt, Mr) | 0, I = I + Math.imul(at, tr) | 0, te = te + Math.imul(at, Mr) | 0, W = W + Math.imul(Et, hr) | 0, I = I + Math.imul(Et, Or) | 0, I = I + Math.imul(zt, hr) | 0, te = te + Math.imul(zt, Or) | 0;
        var _i = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (_i >>> 26) | 0, _i &= 67108863, W = Math.imul(It, ar), I = Math.imul(It, Sr), I = I + Math.imul(rn, ar) | 0, te = Math.imul(rn, Sr), W = W + Math.imul(ce, fr) | 0, I = I + Math.imul(ce, Er) | 0, I = I + Math.imul(Ze, fr) | 0, te = te + Math.imul(Ze, Er) | 0, W = W + Math.imul($t, lr) | 0, I = I + Math.imul($t, $r) | 0, I = I + Math.imul(Lt, lr) | 0, te = te + Math.imul(Lt, $r) | 0, W = W + Math.imul(sn, yr) | 0, I = I + Math.imul(sn, Dr) | 0, I = I + Math.imul(At, yr) | 0, te = te + Math.imul(At, Dr) | 0, W = W + Math.imul(Ht, dr) | 0, I = I + Math.imul(Ht, Br) | 0, I = I + Math.imul(Xt, dr) | 0, te = te + Math.imul(Xt, Br) | 0, W = W + Math.imul(Ut, tr) | 0, I = I + Math.imul(Ut, Mr) | 0, I = I + Math.imul(dn, tr) | 0, te = te + Math.imul(dn, Mr) | 0, W = W + Math.imul(pt, hr) | 0, I = I + Math.imul(pt, Or) | 0, I = I + Math.imul(at, hr) | 0, te = te + Math.imul(at, Or) | 0;
        var xn = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, W = Math.imul(It, fr), I = Math.imul(It, Er), I = I + Math.imul(rn, fr) | 0, te = Math.imul(rn, Er), W = W + Math.imul(ce, lr) | 0, I = I + Math.imul(ce, $r) | 0, I = I + Math.imul(Ze, lr) | 0, te = te + Math.imul(Ze, $r) | 0, W = W + Math.imul($t, yr) | 0, I = I + Math.imul($t, Dr) | 0, I = I + Math.imul(Lt, yr) | 0, te = te + Math.imul(Lt, Dr) | 0, W = W + Math.imul(sn, dr) | 0, I = I + Math.imul(sn, Br) | 0, I = I + Math.imul(At, dr) | 0, te = te + Math.imul(At, Br) | 0, W = W + Math.imul(Ht, tr) | 0, I = I + Math.imul(Ht, Mr) | 0, I = I + Math.imul(Xt, tr) | 0, te = te + Math.imul(Xt, Mr) | 0, W = W + Math.imul(Ut, hr) | 0, I = I + Math.imul(Ut, Or) | 0, I = I + Math.imul(dn, hr) | 0, te = te + Math.imul(dn, Or) | 0;
        var sr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (sr >>> 26) | 0, sr &= 67108863, W = Math.imul(It, lr), I = Math.imul(It, $r), I = I + Math.imul(rn, lr) | 0, te = Math.imul(rn, $r), W = W + Math.imul(ce, yr) | 0, I = I + Math.imul(ce, Dr) | 0, I = I + Math.imul(Ze, yr) | 0, te = te + Math.imul(Ze, Dr) | 0, W = W + Math.imul($t, dr) | 0, I = I + Math.imul($t, Br) | 0, I = I + Math.imul(Lt, dr) | 0, te = te + Math.imul(Lt, Br) | 0, W = W + Math.imul(sn, tr) | 0, I = I + Math.imul(sn, Mr) | 0, I = I + Math.imul(At, tr) | 0, te = te + Math.imul(At, Mr) | 0, W = W + Math.imul(Ht, hr) | 0, I = I + Math.imul(Ht, Or) | 0, I = I + Math.imul(Xt, hr) | 0, te = te + Math.imul(Xt, Or) | 0;
        var Nr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Nr >>> 26) | 0, Nr &= 67108863, W = Math.imul(It, yr), I = Math.imul(It, Dr), I = I + Math.imul(rn, yr) | 0, te = Math.imul(rn, Dr), W = W + Math.imul(ce, dr) | 0, I = I + Math.imul(ce, Br) | 0, I = I + Math.imul(Ze, dr) | 0, te = te + Math.imul(Ze, Br) | 0, W = W + Math.imul($t, tr) | 0, I = I + Math.imul($t, Mr) | 0, I = I + Math.imul(Lt, tr) | 0, te = te + Math.imul(Lt, Mr) | 0, W = W + Math.imul(sn, hr) | 0, I = I + Math.imul(sn, Or) | 0, I = I + Math.imul(At, hr) | 0, te = te + Math.imul(At, Or) | 0;
        var vr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, W = Math.imul(It, dr), I = Math.imul(It, Br), I = I + Math.imul(rn, dr) | 0, te = Math.imul(rn, Br), W = W + Math.imul(ce, tr) | 0, I = I + Math.imul(ce, Mr) | 0, I = I + Math.imul(Ze, tr) | 0, te = te + Math.imul(Ze, Mr) | 0, W = W + Math.imul($t, hr) | 0, I = I + Math.imul($t, Or) | 0, I = I + Math.imul(Lt, hr) | 0, te = te + Math.imul(Lt, Or) | 0;
        var Yr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, W = Math.imul(It, tr), I = Math.imul(It, Mr), I = I + Math.imul(rn, tr) | 0, te = Math.imul(rn, Mr), W = W + Math.imul(ce, hr) | 0, I = I + Math.imul(ce, Or) | 0, I = I + Math.imul(Ze, hr) | 0, te = te + Math.imul(Ze, Or) | 0;
        var Fr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, W = Math.imul(It, hr), I = Math.imul(It, Or), I = I + Math.imul(rn, hr) | 0, te = Math.imul(rn, Or);
        var eo = (N + W | 0) + ((I & 8191) << 13) | 0;
        return N = (te + (I >>> 13) | 0) + (eo >>> 26) | 0, eo &= 67108863, fe[0] = Fo, fe[1] = No, fe[2] = di, fe[3] = gi, fe[4] = ai, fe[5] = ui, fe[6] = hi, fe[7] = bi, fe[8] = ii, fe[9] = pi, fe[10] = Ci, fe[11] = _i, fe[12] = xn, fe[13] = sr, fe[14] = Nr, fe[15] = vr, fe[16] = Yr, fe[17] = Fr, fe[18] = eo, N !== 0 && (fe[19] = N, P.length++), P;
      };
      Math.imul || (M = V);
      function G(H, C, w) {
        w.negative = C.negative ^ H.negative, w.length = H.length + C.length;
        for (var P = 0, J = 0, se = 0; se < w.length - 1; se++) {
          var fe = J;
          J = 0;
          for (var N = P & 67108863, W = Math.min(se, C.length - 1), I = Math.max(0, se - H.length + 1); I <= W; I++) {
            var te = se - I, ge = H.words[te] | 0, Pe = C.words[I] | 0, Ke = ge * Pe, xe = Ke & 67108863;
            fe = fe + (Ke / 67108864 | 0) | 0, xe = xe + N | 0, N = xe & 67108863, fe = fe + (xe >>> 26) | 0, J += fe >>> 26, fe &= 67108863;
          }
          w.words[se] = N, P = fe, fe = J;
        }
        return P !== 0 ? w.words[se] = P : w.length--, w.strip();
      }
      function k(H, C, w) {
        var P = new F();
        return P.mulp(H, C, w);
      }
      d.prototype.mulTo = function(C, w) {
        var P, J = this.length + C.length;
        return this.length === 10 && C.length === 10 ? P = M(this, C, w) : J < 63 ? P = V(this, C, w) : J < 1024 ? P = G(this, C, w) : P = k(this, C, w), P;
      };
      function F(H, C) {
        this.x = H, this.y = C;
      }
      F.prototype.makeRBT = function(C) {
        for (var w = new Array(C), P = d.prototype._countBits(C) - 1, J = 0; J < C; J++)
          w[J] = this.revBin(J, P, C);
        return w;
      }, F.prototype.revBin = function(C, w, P) {
        if (C === 0 || C === P - 1)
          return C;
        for (var J = 0, se = 0; se < w; se++)
          J |= (C & 1) << w - se - 1, C >>= 1;
        return J;
      }, F.prototype.permute = function(C, w, P, J, se, fe) {
        for (var N = 0; N < fe; N++)
          J[N] = w[C[N]], se[N] = P[C[N]];
      }, F.prototype.transform = function(C, w, P, J, se, fe) {
        this.permute(fe, C, w, P, J, se);
        for (var N = 1; N < se; N <<= 1)
          for (var W = N << 1, I = Math.cos(2 * Math.PI / W), te = Math.sin(2 * Math.PI / W), ge = 0; ge < se; ge += W)
            for (var Pe = I, Ke = te, xe = 0; xe < N; xe++) {
              var ze = P[ge + xe], nt = J[ge + xe], Qt = P[ge + xe + N], Et = J[ge + xe + N], zt = Pe * Qt - Ke * Et;
              Et = Pe * Et + Ke * Qt, Qt = zt, P[ge + xe] = ze + Qt, J[ge + xe] = nt + Et, P[ge + xe + N] = ze - Qt, J[ge + xe + N] = nt - Et, xe !== W && (zt = I * Pe - te * Ke, Ke = I * Ke + te * Pe, Pe = zt);
            }
      }, F.prototype.guessLen13b = function(C, w) {
        var P = Math.max(w, C) | 1, J = P & 1, se = 0;
        for (P = P / 2 | 0; P; P = P >>> 1)
          se++;
        return 1 << se + 1 + J;
      }, F.prototype.conjugate = function(C, w, P) {
        if (!(P <= 1))
          for (var J = 0; J < P / 2; J++) {
            var se = C[J];
            C[J] = C[P - J - 1], C[P - J - 1] = se, se = w[J], w[J] = -w[P - J - 1], w[P - J - 1] = -se;
          }
      }, F.prototype.normalize13b = function(C, w) {
        for (var P = 0, J = 0; J < w / 2; J++) {
          var se = Math.round(C[2 * J + 1] / w) * 8192 + Math.round(C[2 * J] / w) + P;
          C[J] = se & 67108863, se < 67108864 ? P = 0 : P = se / 67108864 | 0;
        }
        return C;
      }, F.prototype.convert13b = function(C, w, P, J) {
        for (var se = 0, fe = 0; fe < w; fe++)
          se = se + (C[fe] | 0), P[2 * fe] = se & 8191, se = se >>> 13, P[2 * fe + 1] = se & 8191, se = se >>> 13;
        for (fe = 2 * w; fe < J; ++fe)
          P[fe] = 0;
        u(se === 0), u((se & -8192) === 0);
      }, F.prototype.stub = function(C) {
        for (var w = new Array(C), P = 0; P < C; P++)
          w[P] = 0;
        return w;
      }, F.prototype.mulp = function(C, w, P) {
        var J = 2 * this.guessLen13b(C.length, w.length), se = this.makeRBT(J), fe = this.stub(J), N = new Array(J), W = new Array(J), I = new Array(J), te = new Array(J), ge = new Array(J), Pe = new Array(J), Ke = P.words;
        Ke.length = J, this.convert13b(C.words, C.length, N, J), this.convert13b(w.words, w.length, te, J), this.transform(N, fe, W, I, J, se), this.transform(te, fe, ge, Pe, J, se);
        for (var xe = 0; xe < J; xe++) {
          var ze = W[xe] * ge[xe] - I[xe] * Pe[xe];
          I[xe] = W[xe] * Pe[xe] + I[xe] * ge[xe], W[xe] = ze;
        }
        return this.conjugate(W, I, J), this.transform(W, I, Ke, fe, J, se), this.conjugate(Ke, fe, J), this.normalize13b(Ke, J), P.negative = C.negative ^ w.negative, P.length = C.length + w.length, P.strip();
      }, d.prototype.mul = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), this.mulTo(C, w);
      }, d.prototype.mulf = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), k(this, C, w);
      }, d.prototype.imul = function(C) {
        return this.clone().mulTo(C, this);
      }, d.prototype.imuln = function(C) {
        u(typeof C == "number"), u(C < 67108864);
        for (var w = 0, P = 0; P < this.length; P++) {
          var J = (this.words[P] | 0) * C, se = (J & 67108863) + (w & 67108863);
          w >>= 26, w += J / 67108864 | 0, w += se >>> 26, this.words[P] = se & 67108863;
        }
        return w !== 0 && (this.words[P] = w, this.length++), this;
      }, d.prototype.muln = function(C) {
        return this.clone().imuln(C);
      }, d.prototype.sqr = function() {
        return this.mul(this);
      }, d.prototype.isqr = function() {
        return this.imul(this.clone());
      }, d.prototype.pow = function(C) {
        var w = y(C);
        if (w.length === 0)
          return new d(1);
        for (var P = this, J = 0; J < w.length && w[J] === 0; J++, P = P.sqr())
          ;
        if (++J < w.length)
          for (var se = P.sqr(); J < w.length; J++, se = se.sqr())
            w[J] !== 0 && (P = P.mul(se));
        return P;
      }, d.prototype.iushln = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 67108863 >>> 26 - w << 26 - w, se;
        if (w !== 0) {
          var fe = 0;
          for (se = 0; se < this.length; se++) {
            var N = this.words[se] & J, W = (this.words[se] | 0) - N << w;
            this.words[se] = W | fe, fe = N >>> 26 - w;
          }
          fe && (this.words[se] = fe, this.length++);
        }
        if (P !== 0) {
          for (se = this.length - 1; se >= 0; se--)
            this.words[se + P] = this.words[se];
          for (se = 0; se < P; se++)
            this.words[se] = 0;
          this.length += P;
        }
        return this.strip();
      }, d.prototype.ishln = function(C) {
        return u(this.negative === 0), this.iushln(C);
      }, d.prototype.iushrn = function(C, w, P) {
        u(typeof C == "number" && C >= 0);
        var J;
        w ? J = (w - w % 26) / 26 : J = 0;
        var se = C % 26, fe = Math.min((C - se) / 26, this.length), N = 67108863 ^ 67108863 >>> se << se, W = P;
        if (J -= fe, J = Math.max(0, J), W) {
          for (var I = 0; I < fe; I++)
            W.words[I] = this.words[I];
          W.length = fe;
        }
        if (fe !== 0)
          if (this.length > fe)
            for (this.length -= fe, I = 0; I < this.length; I++)
              this.words[I] = this.words[I + fe];
          else
            this.words[0] = 0, this.length = 1;
        var te = 0;
        for (I = this.length - 1; I >= 0 && (te !== 0 || I >= J); I--) {
          var ge = this.words[I] | 0;
          this.words[I] = te << 26 - se | ge >>> se, te = ge & N;
        }
        return W && te !== 0 && (W.words[W.length++] = te), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, d.prototype.ishrn = function(C, w, P) {
        return u(this.negative === 0), this.iushrn(C, w, P);
      }, d.prototype.shln = function(C) {
        return this.clone().ishln(C);
      }, d.prototype.ushln = function(C) {
        return this.clone().iushln(C);
      }, d.prototype.shrn = function(C) {
        return this.clone().ishrn(C);
      }, d.prototype.ushrn = function(C) {
        return this.clone().iushrn(C);
      }, d.prototype.testn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return !1;
        var se = this.words[P];
        return !!(se & J);
      }, d.prototype.imaskn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26;
        if (u(this.negative === 0, "imaskn works only with positive numbers"), this.length <= P)
          return this;
        if (w !== 0 && P++, this.length = Math.min(P, this.length), w !== 0) {
          var J = 67108863 ^ 67108863 >>> w << w;
          this.words[this.length - 1] &= J;
        }
        return this.strip();
      }, d.prototype.maskn = function(C) {
        return this.clone().imaskn(C);
      }, d.prototype.iaddn = function(C) {
        return u(typeof C == "number"), u(C < 67108864), C < 0 ? this.isubn(-C) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < C ? (this.words[0] = C - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(C), this.negative = 1, this) : this._iaddn(C);
      }, d.prototype._iaddn = function(C) {
        this.words[0] += C;
        for (var w = 0; w < this.length && this.words[w] >= 67108864; w++)
          this.words[w] -= 67108864, w === this.length - 1 ? this.words[w + 1] = 1 : this.words[w + 1]++;
        return this.length = Math.max(this.length, w + 1), this;
      }, d.prototype.isubn = function(C) {
        if (u(typeof C == "number"), u(C < 67108864), C < 0)
          return this.iaddn(-C);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(C), this.negative = 1, this;
        if (this.words[0] -= C, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var w = 0; w < this.length && this.words[w] < 0; w++)
            this.words[w] += 67108864, this.words[w + 1] -= 1;
        return this.strip();
      }, d.prototype.addn = function(C) {
        return this.clone().iaddn(C);
      }, d.prototype.subn = function(C) {
        return this.clone().isubn(C);
      }, d.prototype.iabs = function() {
        return this.negative = 0, this;
      }, d.prototype.abs = function() {
        return this.clone().iabs();
      }, d.prototype._ishlnsubmul = function(C, w, P) {
        var J = C.length + P, se;
        this._expand(J);
        var fe, N = 0;
        for (se = 0; se < C.length; se++) {
          fe = (this.words[se + P] | 0) + N;
          var W = (C.words[se] | 0) * w;
          fe -= W & 67108863, N = (fe >> 26) - (W / 67108864 | 0), this.words[se + P] = fe & 67108863;
        }
        for (; se < this.length - P; se++)
          fe = (this.words[se + P] | 0) + N, N = fe >> 26, this.words[se + P] = fe & 67108863;
        if (N === 0)
          return this.strip();
        for (u(N === -1), N = 0, se = 0; se < this.length; se++)
          fe = -(this.words[se] | 0) + N, N = fe >> 26, this.words[se] = fe & 67108863;
        return this.negative = 1, this.strip();
      }, d.prototype._wordDiv = function(C, w) {
        var P = this.length - C.length, J = this.clone(), se = C, fe = se.words[se.length - 1] | 0, N = this._countBits(fe);
        P = 26 - N, P !== 0 && (se = se.ushln(P), J.iushln(P), fe = se.words[se.length - 1] | 0);
        var W = J.length - se.length, I;
        if (w !== "mod") {
          I = new d(null), I.length = W + 1, I.words = new Array(I.length);
          for (var te = 0; te < I.length; te++)
            I.words[te] = 0;
        }
        var ge = J.clone()._ishlnsubmul(se, 1, W);
        ge.negative === 0 && (J = ge, I && (I.words[W] = 1));
        for (var Pe = W - 1; Pe >= 0; Pe--) {
          var Ke = (J.words[se.length + Pe] | 0) * 67108864 + (J.words[se.length + Pe - 1] | 0);
          for (Ke = Math.min(Ke / fe | 0, 67108863), J._ishlnsubmul(se, Ke, Pe); J.negative !== 0; )
            Ke--, J.negative = 0, J._ishlnsubmul(se, 1, Pe), J.isZero() || (J.negative ^= 1);
          I && (I.words[Pe] = Ke);
        }
        return I && I.strip(), J.strip(), w !== "div" && P !== 0 && J.iushrn(P), {
          div: I || null,
          mod: J
        };
      }, d.prototype.divmod = function(C, w, P) {
        if (u(!C.isZero()), this.isZero())
          return {
            div: new d(0),
            mod: new d(0)
          };
        var J, se, fe;
        return this.negative !== 0 && C.negative === 0 ? (fe = this.neg().divmod(C, w), w !== "mod" && (J = fe.div.neg()), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.iadd(C)), {
          div: J,
          mod: se
        }) : this.negative === 0 && C.negative !== 0 ? (fe = this.divmod(C.neg(), w), w !== "mod" && (J = fe.div.neg()), {
          div: J,
          mod: fe.mod
        }) : this.negative & C.negative ? (fe = this.neg().divmod(C.neg(), w), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.isub(C)), {
          div: fe.div,
          mod: se
        }) : C.length > this.length || this.cmp(C) < 0 ? {
          div: new d(0),
          mod: this
        } : C.length === 1 ? w === "div" ? {
          div: this.divn(C.words[0]),
          mod: null
        } : w === "mod" ? {
          div: null,
          mod: new d(this.modn(C.words[0]))
        } : {
          div: this.divn(C.words[0]),
          mod: new d(this.modn(C.words[0]))
        } : this._wordDiv(C, w);
      }, d.prototype.div = function(C) {
        return this.divmod(C, "div", !1).div;
      }, d.prototype.mod = function(C) {
        return this.divmod(C, "mod", !1).mod;
      }, d.prototype.umod = function(C) {
        return this.divmod(C, "mod", !0).mod;
      }, d.prototype.divRound = function(C) {
        var w = this.divmod(C);
        if (w.mod.isZero())
          return w.div;
        var P = w.div.negative !== 0 ? w.mod.isub(C) : w.mod, J = C.ushrn(1), se = C.andln(1), fe = P.cmp(J);
        return fe < 0 || se === 1 && fe === 0 ? w.div : w.div.negative !== 0 ? w.div.isubn(1) : w.div.iaddn(1);
      }, d.prototype.modn = function(C) {
        u(C <= 67108863);
        for (var w = (1 << 26) % C, P = 0, J = this.length - 1; J >= 0; J--)
          P = (w * P + (this.words[J] | 0)) % C;
        return P;
      }, d.prototype.idivn = function(C) {
        u(C <= 67108863);
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = (this.words[P] | 0) + w * 67108864;
          this.words[P] = J / C | 0, w = J % C;
        }
        return this.strip();
      }, d.prototype.divn = function(C) {
        return this.clone().idivn(C);
      }, d.prototype.egcd = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = new d(0), N = new d(1), W = 0; w.isEven() && P.isEven(); )
          w.iushrn(1), P.iushrn(1), ++W;
        for (var I = P.clone(), te = w.clone(); !w.isZero(); ) {
          for (var ge = 0, Pe = 1; !(w.words[0] & Pe) && ge < 26; ++ge, Pe <<= 1)
            ;
          if (ge > 0)
            for (w.iushrn(ge); ge-- > 0; )
              (J.isOdd() || se.isOdd()) && (J.iadd(I), se.isub(te)), J.iushrn(1), se.iushrn(1);
          for (var Ke = 0, xe = 1; !(P.words[0] & xe) && Ke < 26; ++Ke, xe <<= 1)
            ;
          if (Ke > 0)
            for (P.iushrn(Ke); Ke-- > 0; )
              (fe.isOdd() || N.isOdd()) && (fe.iadd(I), N.isub(te)), fe.iushrn(1), N.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(fe), se.isub(N)) : (P.isub(w), fe.isub(J), N.isub(se));
        }
        return {
          a: fe,
          b: N,
          gcd: P.iushln(W)
        };
      }, d.prototype._invmp = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = P.clone(); w.cmpn(1) > 0 && P.cmpn(1) > 0; ) {
          for (var N = 0, W = 1; !(w.words[0] & W) && N < 26; ++N, W <<= 1)
            ;
          if (N > 0)
            for (w.iushrn(N); N-- > 0; )
              J.isOdd() && J.iadd(fe), J.iushrn(1);
          for (var I = 0, te = 1; !(P.words[0] & te) && I < 26; ++I, te <<= 1)
            ;
          if (I > 0)
            for (P.iushrn(I); I-- > 0; )
              se.isOdd() && se.iadd(fe), se.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(se)) : (P.isub(w), se.isub(J));
        }
        var ge;
        return w.cmpn(1) === 0 ? ge = J : ge = se, ge.cmpn(0) < 0 && ge.iadd(C), ge;
      }, d.prototype.gcd = function(C) {
        if (this.isZero())
          return C.abs();
        if (C.isZero())
          return this.abs();
        var w = this.clone(), P = C.clone();
        w.negative = 0, P.negative = 0;
        for (var J = 0; w.isEven() && P.isEven(); J++)
          w.iushrn(1), P.iushrn(1);
        do {
          for (; w.isEven(); )
            w.iushrn(1);
          for (; P.isEven(); )
            P.iushrn(1);
          var se = w.cmp(P);
          if (se < 0) {
            var fe = w;
            w = P, P = fe;
          } else if (se === 0 || P.cmpn(1) === 0)
            break;
          w.isub(P);
        } while (!0);
        return P.iushln(J);
      }, d.prototype.invm = function(C) {
        return this.egcd(C).a.umod(C);
      }, d.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, d.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, d.prototype.andln = function(C) {
        return this.words[0] & C;
      }, d.prototype.bincn = function(C) {
        u(typeof C == "number");
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return this._expand(P + 1), this.words[P] |= J, this;
        for (var se = J, fe = P; se !== 0 && fe < this.length; fe++) {
          var N = this.words[fe] | 0;
          N += se, se = N >>> 26, N &= 67108863, this.words[fe] = N;
        }
        return se !== 0 && (this.words[fe] = se, this.length++), this;
      }, d.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, d.prototype.cmpn = function(C) {
        var w = C < 0;
        if (this.negative !== 0 && !w)
          return -1;
        if (this.negative === 0 && w)
          return 1;
        this.strip();
        var P;
        if (this.length > 1)
          P = 1;
        else {
          w && (C = -C), u(C <= 67108863, "Number is too big");
          var J = this.words[0] | 0;
          P = J === C ? 0 : J < C ? -1 : 1;
        }
        return this.negative !== 0 ? -P | 0 : P;
      }, d.prototype.cmp = function(C) {
        if (this.negative !== 0 && C.negative === 0)
          return -1;
        if (this.negative === 0 && C.negative !== 0)
          return 1;
        var w = this.ucmp(C);
        return this.negative !== 0 ? -w | 0 : w;
      }, d.prototype.ucmp = function(C) {
        if (this.length > C.length)
          return 1;
        if (this.length < C.length)
          return -1;
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = this.words[P] | 0, se = C.words[P] | 0;
          if (J !== se) {
            J < se ? w = -1 : J > se && (w = 1);
            break;
          }
        }
        return w;
      }, d.prototype.gtn = function(C) {
        return this.cmpn(C) === 1;
      }, d.prototype.gt = function(C) {
        return this.cmp(C) === 1;
      }, d.prototype.gten = function(C) {
        return this.cmpn(C) >= 0;
      }, d.prototype.gte = function(C) {
        return this.cmp(C) >= 0;
      }, d.prototype.ltn = function(C) {
        return this.cmpn(C) === -1;
      }, d.prototype.lt = function(C) {
        return this.cmp(C) === -1;
      }, d.prototype.lten = function(C) {
        return this.cmpn(C) <= 0;
      }, d.prototype.lte = function(C) {
        return this.cmp(C) <= 0;
      }, d.prototype.eqn = function(C) {
        return this.cmpn(C) === 0;
      }, d.prototype.eq = function(C) {
        return this.cmp(C) === 0;
      }, d.red = function(C) {
        return new oe(C);
      }, d.prototype.toRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), u(this.negative === 0, "red works only with positives"), C.convertTo(this)._forceRed(C);
      }, d.prototype.fromRed = function() {
        return u(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, d.prototype._forceRed = function(C) {
        return this.red = C, this;
      }, d.prototype.forceRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), this._forceRed(C);
      }, d.prototype.redAdd = function(C) {
        return u(this.red, "redAdd works only with red numbers"), this.red.add(this, C);
      }, d.prototype.redIAdd = function(C) {
        return u(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, C);
      }, d.prototype.redSub = function(C) {
        return u(this.red, "redSub works only with red numbers"), this.red.sub(this, C);
      }, d.prototype.redISub = function(C) {
        return u(this.red, "redISub works only with red numbers"), this.red.isub(this, C);
      }, d.prototype.redShl = function(C) {
        return u(this.red, "redShl works only with red numbers"), this.red.shl(this, C);
      }, d.prototype.redMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.mul(this, C);
      }, d.prototype.redIMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.imul(this, C);
      }, d.prototype.redSqr = function() {
        return u(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, d.prototype.redISqr = function() {
        return u(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, d.prototype.redSqrt = function() {
        return u(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, d.prototype.redInvm = function() {
        return u(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, d.prototype.redNeg = function() {
        return u(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, d.prototype.redPow = function(C) {
        return u(this.red && !C.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, C);
      };
      var X = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function ee(H, C) {
        this.name = H, this.p = new d(C, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      ee.prototype._tmp = function() {
        var C = new d(null);
        return C.words = new Array(Math.ceil(this.n / 13)), C;
      }, ee.prototype.ireduce = function(C) {
        var w = C, P;
        do
          this.split(w, this.tmp), w = this.imulK(w), w = w.iadd(this.tmp), P = w.bitLength();
        while (P > this.n);
        var J = P < this.n ? -1 : w.ucmp(this.p);
        return J === 0 ? (w.words[0] = 0, w.length = 1) : J > 0 ? w.isub(this.p) : w.strip !== void 0 ? w.strip() : w._strip(), w;
      }, ee.prototype.split = function(C, w) {
        C.iushrn(this.n, 0, w);
      }, ee.prototype.imulK = function(C) {
        return C.imul(this.k);
      };
      function ue() {
        ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(ue, ee), ue.prototype.split = function(C, w) {
        for (var P = 4194303, J = Math.min(C.length, 9), se = 0; se < J; se++)
          w.words[se] = C.words[se];
        if (w.length = J, C.length <= 9) {
          C.words[0] = 0, C.length = 1;
          return;
        }
        var fe = C.words[9];
        for (w.words[w.length++] = fe & P, se = 10; se < C.length; se++) {
          var N = C.words[se] | 0;
          C.words[se - 10] = (N & P) << 4 | fe >>> 22, fe = N;
        }
        fe >>>= 22, C.words[se - 10] = fe, fe === 0 && C.length > 10 ? C.length -= 10 : C.length -= 9;
      }, ue.prototype.imulK = function(C) {
        C.words[C.length] = 0, C.words[C.length + 1] = 0, C.length += 2;
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = C.words[P] | 0;
          w += J * 977, C.words[P] = w & 67108863, w = J * 64 + (w / 67108864 | 0);
        }
        return C.words[C.length - 1] === 0 && (C.length--, C.words[C.length - 1] === 0 && C.length--), C;
      };
      function Q() {
        ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(Q, ee);
      function Y() {
        ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(Y, ee);
      function pe() {
        ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(pe, ee), pe.prototype.imulK = function(C) {
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = (C.words[P] | 0) * 19 + w, se = J & 67108863;
          J >>>= 26, C.words[P] = se, w = J;
        }
        return w !== 0 && (C.words[C.length++] = w), C;
      }, d._prime = function(C) {
        if (X[C])
          return X[C];
        var w;
        if (C === "k256")
          w = new ue();
        else if (C === "p224")
          w = new Q();
        else if (C === "p192")
          w = new Y();
        else if (C === "p25519")
          w = new pe();
        else
          throw new Error("Unknown prime " + C);
        return X[C] = w, w;
      };
      function oe(H) {
        if (typeof H == "string") {
          var C = d._prime(H);
          this.m = C.p, this.prime = C;
        } else
          u(H.gtn(1), "modulus must be greater than 1"), this.m = H, this.prime = null;
      }
      oe.prototype._verify1 = function(C) {
        u(C.negative === 0, "red works only with positives"), u(C.red, "red works only with red numbers");
      }, oe.prototype._verify2 = function(C, w) {
        u((C.negative | w.negative) === 0, "red works only with positives"), u(
          C.red && C.red === w.red,
          "red works only with red numbers"
        );
      }, oe.prototype.imod = function(C) {
        return this.prime ? this.prime.ireduce(C)._forceRed(this) : C.umod(this.m)._forceRed(this);
      }, oe.prototype.neg = function(C) {
        return C.isZero() ? C.clone() : this.m.sub(C)._forceRed(this);
      }, oe.prototype.add = function(C, w) {
        this._verify2(C, w);
        var P = C.add(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P._forceRed(this);
      }, oe.prototype.iadd = function(C, w) {
        this._verify2(C, w);
        var P = C.iadd(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P;
      }, oe.prototype.sub = function(C, w) {
        this._verify2(C, w);
        var P = C.sub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P._forceRed(this);
      }, oe.prototype.isub = function(C, w) {
        this._verify2(C, w);
        var P = C.isub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P;
      }, oe.prototype.shl = function(C, w) {
        return this._verify1(C), this.imod(C.ushln(w));
      }, oe.prototype.imul = function(C, w) {
        return this._verify2(C, w), this.imod(C.imul(w));
      }, oe.prototype.mul = function(C, w) {
        return this._verify2(C, w), this.imod(C.mul(w));
      }, oe.prototype.isqr = function(C) {
        return this.imul(C, C.clone());
      }, oe.prototype.sqr = function(C) {
        return this.mul(C, C);
      }, oe.prototype.sqrt = function(C) {
        if (C.isZero())
          return C.clone();
        var w = this.m.andln(3);
        if (u(w % 2 === 1), w === 3) {
          var P = this.m.add(new d(1)).iushrn(2);
          return this.pow(C, P);
        }
        for (var J = this.m.subn(1), se = 0; !J.isZero() && J.andln(1) === 0; )
          se++, J.iushrn(1);
        u(!J.isZero());
        var fe = new d(1).toRed(this), N = fe.redNeg(), W = this.m.subn(1).iushrn(1), I = this.m.bitLength();
        for (I = new d(2 * I * I).toRed(this); this.pow(I, W).cmp(N) !== 0; )
          I.redIAdd(N);
        for (var te = this.pow(I, J), ge = this.pow(C, J.addn(1).iushrn(1)), Pe = this.pow(C, J), Ke = se; Pe.cmp(fe) !== 0; ) {
          for (var xe = Pe, ze = 0; xe.cmp(fe) !== 0; ze++)
            xe = xe.redSqr();
          u(ze < Ke);
          var nt = this.pow(te, new d(1).iushln(Ke - ze - 1));
          ge = ge.redMul(nt), te = nt.redSqr(), Pe = Pe.redMul(te), Ke = ze;
        }
        return ge;
      }, oe.prototype.invm = function(C) {
        var w = C._invmp(this.m);
        return w.negative !== 0 ? (w.negative = 0, this.imod(w).redNeg()) : this.imod(w);
      }, oe.prototype.pow = function(C, w) {
        if (w.isZero())
          return new d(1).toRed(this);
        if (w.cmpn(1) === 0)
          return C.clone();
        var P = 4, J = new Array(1 << P);
        J[0] = new d(1).toRed(this), J[1] = C;
        for (var se = 2; se < J.length; se++)
          J[se] = this.mul(J[se - 1], C);
        var fe = J[0], N = 0, W = 0, I = w.bitLength() % 26;
        for (I === 0 && (I = 26), se = w.length - 1; se >= 0; se--) {
          for (var te = w.words[se], ge = I - 1; ge >= 0; ge--) {
            var Pe = te >> ge & 1;
            if (fe !== J[0] && (fe = this.sqr(fe)), Pe === 0 && N === 0) {
              W = 0;
              continue;
            }
            N <<= 1, N |= Pe, W++, !(W !== P && (se !== 0 || ge !== 0)) && (fe = this.mul(fe, J[N]), W = 0, N = 0);
          }
          I = 26;
        }
        return fe;
      }, oe.prototype.convertTo = function(C) {
        var w = C.umod(this.m);
        return w === C ? w.clone() : w;
      }, oe.prototype.convertFrom = function(C) {
        var w = C.clone();
        return w.red = null, w;
      }, d.mont = function(C) {
        return new ne(C);
      };
      function ne(H) {
        oe.call(this, H), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(ne, oe), ne.prototype.convertTo = function(C) {
        return this.imod(C.ushln(this.shift));
      }, ne.prototype.convertFrom = function(C) {
        var w = this.imod(C.mul(this.rinv));
        return w.red = null, w;
      }, ne.prototype.imul = function(C, w) {
        if (C.isZero() || w.isZero())
          return C.words[0] = 0, C.length = 1, C;
        var P = C.imul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.mul = function(C, w) {
        if (C.isZero() || w.isZero())
          return new d(0)._forceRed(this);
        var P = C.mul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.invm = function(C) {
        var w = this.imod(C._invmp(this.m).mul(this.r2));
        return w._forceRed(this);
      };
    })(e, commonjsGlobal);
  }(bn$2)), bn$2.exports;
}
var api = {}, encoders = {}, safer_1, hasRequiredSafer;
function requireSafer() {
  if (hasRequiredSafer)
    return safer_1;
  hasRequiredSafer = 1;
  var e = buffer$1, n = e.Buffer, o = {}, u;
  for (u in e)
    e.hasOwnProperty(u) && (u === "SlowBuffer" || u === "Buffer" || (o[u] = e[u]));
  var c = o.Buffer = {};
  for (u in n)
    n.hasOwnProperty(u) && (u === "allocUnsafe" || u === "allocUnsafeSlow" || (c[u] = n[u]));
  if (o.Buffer.prototype = n.prototype, (!c.from || c.from === Uint8Array.from) && (c.from = function(d, m, v) {
    if (typeof d == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof d);
    if (d && typeof d.length > "u")
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof d);
    return n(d, m, v);
  }), c.alloc || (c.alloc = function(d, m, v) {
    if (typeof d != "number")
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof d);
    if (d < 0 || d >= 2 * (1 << 30))
      throw new RangeError('The value "' + d + '" is invalid for option "size"');
    var S = n(d);
    return !m || m.length === 0 ? S.fill(0) : typeof v == "string" ? S.fill(m, v) : S.fill(m), S;
  }), !o.kStringMaxLength)
    try {
      o.kStringMaxLength = browser$1$1.binding("buffer").kStringMaxLength;
    } catch {
    }
  return o.constants || (o.constants = {
    MAX_LENGTH: o.kMaxLength
  }, o.kStringMaxLength && (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)), safer_1 = o, safer_1;
}
var reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter)
    return reporter;
  hasRequiredReporter = 1;
  const e = requireInherits_browser();
  function n(u) {
    this._reporterState = {
      obj: null,
      path: [],
      options: u || {},
      errors: []
    };
  }
  reporter.Reporter = n, n.prototype.isError = function(c) {
    return c instanceof o;
  }, n.prototype.save = function() {
    const c = this._reporterState;
    return { obj: c.obj, pathLen: c.path.length };
  }, n.prototype.restore = function(c) {
    const d = this._reporterState;
    d.obj = c.obj, d.path = d.path.slice(0, c.pathLen);
  }, n.prototype.enterKey = function(c) {
    return this._reporterState.path.push(c);
  }, n.prototype.exitKey = function(c) {
    const d = this._reporterState;
    d.path = d.path.slice(0, c - 1);
  }, n.prototype.leaveKey = function(c, d, m) {
    const v = this._reporterState;
    this.exitKey(c), v.obj !== null && (v.obj[d] = m);
  }, n.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, n.prototype.enterObject = function() {
    const c = this._reporterState, d = c.obj;
    return c.obj = {}, d;
  }, n.prototype.leaveObject = function(c) {
    const d = this._reporterState, m = d.obj;
    return d.obj = c, m;
  }, n.prototype.error = function(c) {
    let d;
    const m = this._reporterState, v = c instanceof o;
    if (v ? d = c : d = new o(m.path.map(function(S) {
      return "[" + JSON.stringify(S) + "]";
    }).join(""), c.message || c, c.stack), !m.options.partial)
      throw d;
    return v || m.errors.push(d), d;
  }, n.prototype.wrapResult = function(c) {
    const d = this._reporterState;
    return d.options.partial ? {
      result: this.isError(c) ? null : c,
      errors: d.errors
    } : c;
  };
  function o(u, c) {
    this.path = u, this.rethrow(c);
  }
  return e(o, Error), o.prototype.rethrow = function(c) {
    if (this.message = c + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, o), !this.stack)
      try {
        throw new Error(this.message);
      } catch (d) {
        this.stack = d.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer)
    return buffer;
  hasRequiredBuffer = 1;
  const e = requireInherits_browser(), n = requireReporter().Reporter, o = requireSafer().Buffer;
  function u(d, m) {
    if (n.call(this, m), !o.isBuffer(d)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = d, this.offset = 0, this.length = d.length;
  }
  e(u, n), buffer.DecoderBuffer = u, u.isDecoderBuffer = function(m) {
    return m instanceof u ? !0 : typeof m == "object" && o.isBuffer(m.base) && m.constructor.name === "DecoderBuffer" && typeof m.offset == "number" && typeof m.length == "number" && typeof m.save == "function" && typeof m.restore == "function" && typeof m.isEmpty == "function" && typeof m.readUInt8 == "function" && typeof m.skip == "function" && typeof m.raw == "function";
  }, u.prototype.save = function() {
    return { offset: this.offset, reporter: n.prototype.save.call(this) };
  }, u.prototype.restore = function(m) {
    const v = new u(this.base);
    return v.offset = m.offset, v.length = this.offset, this.offset = m.offset, n.prototype.restore.call(this, m.reporter), v;
  }, u.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, u.prototype.readUInt8 = function(m) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(m || "DecoderBuffer overrun");
  }, u.prototype.skip = function(m, v) {
    if (!(this.offset + m <= this.length))
      return this.error(v || "DecoderBuffer overrun");
    const S = new u(this.base);
    return S._reporterState = this._reporterState, S.offset = this.offset, S.length = this.offset + m, this.offset += m, S;
  }, u.prototype.raw = function(m) {
    return this.base.slice(m ? m.offset : this.offset, this.length);
  };
  function c(d, m) {
    if (Array.isArray(d))
      this.length = 0, this.value = d.map(function(v) {
        return c.isEncoderBuffer(v) || (v = new c(v, m)), this.length += v.length, v;
      }, this);
    else if (typeof d == "number") {
      if (!(0 <= d && d <= 255))
        return m.error("non-byte EncoderBuffer value");
      this.value = d, this.length = 1;
    } else if (typeof d == "string")
      this.value = d, this.length = o.byteLength(d);
    else if (o.isBuffer(d))
      this.value = d, this.length = d.length;
    else
      return m.error("Unsupported type: " + typeof d);
  }
  return buffer.EncoderBuffer = c, c.isEncoderBuffer = function(m) {
    return m instanceof c ? !0 : typeof m == "object" && m.constructor.name === "EncoderBuffer" && typeof m.length == "number" && typeof m.join == "function";
  }, c.prototype.join = function(m, v) {
    return m || (m = o.alloc(this.length)), v || (v = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(S) {
      S.join(m, v), v += S.length;
    }) : (typeof this.value == "number" ? m[v] = this.value : typeof this.value == "string" ? m.write(this.value, v) : o.isBuffer(this.value) && this.value.copy(m, v), v += this.length)), m;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode)
    return node;
  hasRequiredNode = 1;
  const e = requireReporter().Reporter, n = requireBuffer().EncoderBuffer, o = requireBuffer().DecoderBuffer, u = minimalisticAssert$1, c = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], d = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(c), m = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function v($, E, O) {
    const T = {};
    this._baseState = T, T.name = O, T.enc = $, T.parent = E || null, T.children = null, T.tag = null, T.args = null, T.reverseArgs = null, T.choice = null, T.optional = !1, T.any = !1, T.obj = !1, T.use = null, T.useDecoder = null, T.key = null, T.default = null, T.explicit = null, T.implicit = null, T.contains = null, T.parent || (T.children = [], this._wrap());
  }
  node = v;
  const S = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return v.prototype.clone = function() {
    const E = this._baseState, O = {};
    S.forEach(function(y) {
      O[y] = E[y];
    });
    const T = new this.constructor(O.parent);
    return T._baseState = O, T;
  }, v.prototype._wrap = function() {
    const E = this._baseState;
    d.forEach(function(O) {
      this[O] = function() {
        const y = new this.constructor(this);
        return E.children.push(y), y[O].apply(y, arguments);
      };
    }, this);
  }, v.prototype._init = function(E) {
    const O = this._baseState;
    u(O.parent === null), E.call(this), O.children = O.children.filter(function(T) {
      return T._baseState.parent === this;
    }, this), u.equal(O.children.length, 1, "Root node can have only one child");
  }, v.prototype._useArgs = function(E) {
    const O = this._baseState, T = E.filter(function(y) {
      return y instanceof this.constructor;
    }, this);
    E = E.filter(function(y) {
      return !(y instanceof this.constructor);
    }, this), T.length !== 0 && (u(O.children === null), O.children = T, T.forEach(function(y) {
      y._baseState.parent = this;
    }, this)), E.length !== 0 && (u(O.args === null), O.args = E, O.reverseArgs = E.map(function(y) {
      if (typeof y != "object" || y.constructor !== Object)
        return y;
      const V = {};
      return Object.keys(y).forEach(function(M) {
        M == (M | 0) && (M |= 0);
        const G = y[M];
        V[G] = M;
      }), V;
    }));
  }, m.forEach(function($) {
    v.prototype[$] = function() {
      const O = this._baseState;
      throw new Error($ + " not implemented for encoding: " + O.enc);
    };
  }), c.forEach(function($) {
    v.prototype[$] = function() {
      const O = this._baseState, T = Array.prototype.slice.call(arguments);
      return u(O.tag === null), O.tag = $, this._useArgs(T), this;
    };
  }), v.prototype.use = function(E) {
    u(E);
    const O = this._baseState;
    return u(O.use === null), O.use = E, this;
  }, v.prototype.optional = function() {
    const E = this._baseState;
    return E.optional = !0, this;
  }, v.prototype.def = function(E) {
    const O = this._baseState;
    return u(O.default === null), O.default = E, O.optional = !0, this;
  }, v.prototype.explicit = function(E) {
    const O = this._baseState;
    return u(O.explicit === null && O.implicit === null), O.explicit = E, this;
  }, v.prototype.implicit = function(E) {
    const O = this._baseState;
    return u(O.explicit === null && O.implicit === null), O.implicit = E, this;
  }, v.prototype.obj = function() {
    const E = this._baseState, O = Array.prototype.slice.call(arguments);
    return E.obj = !0, O.length !== 0 && this._useArgs(O), this;
  }, v.prototype.key = function(E) {
    const O = this._baseState;
    return u(O.key === null), O.key = E, this;
  }, v.prototype.any = function() {
    const E = this._baseState;
    return E.any = !0, this;
  }, v.prototype.choice = function(E) {
    const O = this._baseState;
    return u(O.choice === null), O.choice = E, this._useArgs(Object.keys(E).map(function(T) {
      return E[T];
    })), this;
  }, v.prototype.contains = function(E) {
    const O = this._baseState;
    return u(O.use === null), O.contains = E, this;
  }, v.prototype._decode = function(E, O) {
    const T = this._baseState;
    if (T.parent === null)
      return E.wrapResult(T.children[0]._decode(E, O));
    let y = T.default, V = !0, M = null;
    if (T.key !== null && (M = E.enterKey(T.key)), T.optional) {
      let k = null;
      if (T.explicit !== null ? k = T.explicit : T.implicit !== null ? k = T.implicit : T.tag !== null && (k = T.tag), k === null && !T.any) {
        const F = E.save();
        try {
          T.choice === null ? this._decodeGeneric(T.tag, E, O) : this._decodeChoice(E, O), V = !0;
        } catch {
          V = !1;
        }
        E.restore(F);
      } else if (V = this._peekTag(E, k, T.any), E.isError(V))
        return V;
    }
    let G;
    if (T.obj && V && (G = E.enterObject()), V) {
      if (T.explicit !== null) {
        const F = this._decodeTag(E, T.explicit);
        if (E.isError(F))
          return F;
        E = F;
      }
      const k = E.offset;
      if (T.use === null && T.choice === null) {
        let F;
        T.any && (F = E.save());
        const X = this._decodeTag(
          E,
          T.implicit !== null ? T.implicit : T.tag,
          T.any
        );
        if (E.isError(X))
          return X;
        T.any ? y = E.raw(F) : E = X;
      }
      if (O && O.track && T.tag !== null && O.track(E.path(), k, E.length, "tagged"), O && O.track && T.tag !== null && O.track(E.path(), E.offset, E.length, "content"), T.any || (T.choice === null ? y = this._decodeGeneric(T.tag, E, O) : y = this._decodeChoice(E, O)), E.isError(y))
        return y;
      if (!T.any && T.choice === null && T.children !== null && T.children.forEach(function(X) {
        X._decode(E, O);
      }), T.contains && (T.tag === "octstr" || T.tag === "bitstr")) {
        const F = new o(y);
        y = this._getUse(T.contains, E._reporterState.obj)._decode(F, O);
      }
    }
    return T.obj && V && (y = E.leaveObject(G)), T.key !== null && (y !== null || V === !0) ? E.leaveKey(M, T.key, y) : M !== null && E.exitKey(M), y;
  }, v.prototype._decodeGeneric = function(E, O, T) {
    const y = this._baseState;
    return E === "seq" || E === "set" ? null : E === "seqof" || E === "setof" ? this._decodeList(O, E, y.args[0], T) : /str$/.test(E) ? this._decodeStr(O, E, T) : E === "objid" && y.args ? this._decodeObjid(O, y.args[0], y.args[1], T) : E === "objid" ? this._decodeObjid(O, null, null, T) : E === "gentime" || E === "utctime" ? this._decodeTime(O, E, T) : E === "null_" ? this._decodeNull(O, T) : E === "bool" ? this._decodeBool(O, T) : E === "objDesc" ? this._decodeStr(O, E, T) : E === "int" || E === "enum" ? this._decodeInt(O, y.args && y.args[0], T) : y.use !== null ? this._getUse(y.use, O._reporterState.obj)._decode(O, T) : O.error("unknown tag: " + E);
  }, v.prototype._getUse = function(E, O) {
    const T = this._baseState;
    return T.useDecoder = this._use(E, O), u(T.useDecoder._baseState.parent === null), T.useDecoder = T.useDecoder._baseState.children[0], T.implicit !== T.useDecoder._baseState.implicit && (T.useDecoder = T.useDecoder.clone(), T.useDecoder._baseState.implicit = T.implicit), T.useDecoder;
  }, v.prototype._decodeChoice = function(E, O) {
    const T = this._baseState;
    let y = null, V = !1;
    return Object.keys(T.choice).some(function(M) {
      const G = E.save(), k = T.choice[M];
      try {
        const F = k._decode(E, O);
        if (E.isError(F))
          return !1;
        y = { type: M, value: F }, V = !0;
      } catch {
        return E.restore(G), !1;
      }
      return !0;
    }, this), V ? y : E.error("Choice not matched");
  }, v.prototype._createEncoderBuffer = function(E) {
    return new n(E, this.reporter);
  }, v.prototype._encode = function(E, O, T) {
    const y = this._baseState;
    if (y.default !== null && y.default === E)
      return;
    const V = this._encodeValue(E, O, T);
    if (V !== void 0 && !this._skipDefault(V, O, T))
      return V;
  }, v.prototype._encodeValue = function(E, O, T) {
    const y = this._baseState;
    if (y.parent === null)
      return y.children[0]._encode(E, O || new e());
    let V = null;
    if (this.reporter = O, y.optional && E === void 0)
      if (y.default !== null)
        E = y.default;
      else
        return;
    let M = null, G = !1;
    if (y.any)
      V = this._createEncoderBuffer(E);
    else if (y.choice)
      V = this._encodeChoice(E, O);
    else if (y.contains)
      M = this._getUse(y.contains, T)._encode(E, O), G = !0;
    else if (y.children)
      M = y.children.map(function(k) {
        if (k._baseState.tag === "null_")
          return k._encode(null, O, E);
        if (k._baseState.key === null)
          return O.error("Child should have a key");
        const F = O.enterKey(k._baseState.key);
        if (typeof E != "object")
          return O.error("Child expected, but input is not object");
        const X = k._encode(E[k._baseState.key], O, E);
        return O.leaveKey(F), X;
      }, this).filter(function(k) {
        return k;
      }), M = this._createEncoderBuffer(M);
    else if (y.tag === "seqof" || y.tag === "setof") {
      if (!(y.args && y.args.length === 1))
        return O.error("Too many args for : " + y.tag);
      if (!Array.isArray(E))
        return O.error("seqof/setof, but data is not Array");
      const k = this.clone();
      k._baseState.implicit = null, M = this._createEncoderBuffer(E.map(function(F) {
        const X = this._baseState;
        return this._getUse(X.args[0], E)._encode(F, O);
      }, k));
    } else
      y.use !== null ? V = this._getUse(y.use, T)._encode(E, O) : (M = this._encodePrimitive(y.tag, E), G = !0);
    if (!y.any && y.choice === null) {
      const k = y.implicit !== null ? y.implicit : y.tag, F = y.implicit === null ? "universal" : "context";
      k === null ? y.use === null && O.error("Tag could be omitted only for .use()") : y.use === null && (V = this._encodeComposite(k, G, F, M));
    }
    return y.explicit !== null && (V = this._encodeComposite(y.explicit, !1, "context", V)), V;
  }, v.prototype._encodeChoice = function(E, O) {
    const T = this._baseState, y = T.choice[E.type];
    return y || u(
      !1,
      E.type + " not found in " + JSON.stringify(Object.keys(T.choice))
    ), y._encode(E.value, O);
  }, v.prototype._encodePrimitive = function(E, O) {
    const T = this._baseState;
    if (/str$/.test(E))
      return this._encodeStr(O, E);
    if (E === "objid" && T.args)
      return this._encodeObjid(O, T.reverseArgs[0], T.args[1]);
    if (E === "objid")
      return this._encodeObjid(O, null, null);
    if (E === "gentime" || E === "utctime")
      return this._encodeTime(O, E);
    if (E === "null_")
      return this._encodeNull();
    if (E === "int" || E === "enum")
      return this._encodeInt(O, T.args && T.reverseArgs[0]);
    if (E === "bool")
      return this._encodeBool(O);
    if (E === "objDesc")
      return this._encodeStr(O, E);
    throw new Error("Unsupported tag: " + E);
  }, v.prototype._isNumstr = function(E) {
    return /^[0-9 ]*$/.test(E);
  }, v.prototype._isPrintstr = function(E) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(E);
  }, node;
}
var der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(e) {
    function n(o) {
      const u = {};
      return Object.keys(o).forEach(function(c) {
        (c | 0) == c && (c = c | 0);
        const d = o[c];
        u[d] = c;
      }), u;
    }
    e.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, e.tagClassByName = n(e.tagClass), e.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, e.tagByName = n(e.tag);
  }(der)), der;
}
var der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1)
    return der_1$1;
  hasRequiredDer$1 = 1;
  const e = requireInherits_browser(), n = requireSafer().Buffer, o = requireNode(), u = requireDer$2();
  function c(S) {
    this.enc = "der", this.name = S.name, this.entity = S, this.tree = new d(), this.tree._init(S.body);
  }
  der_1$1 = c, c.prototype.encode = function($, E) {
    return this.tree._encode($, E).join();
  };
  function d(S) {
    o.call(this, "der", S);
  }
  e(d, o), d.prototype._encodeComposite = function($, E, O, T) {
    const y = v($, E, O, this.reporter);
    if (T.length < 128) {
      const G = n.alloc(2);
      return G[0] = y, G[1] = T.length, this._createEncoderBuffer([G, T]);
    }
    let V = 1;
    for (let G = T.length; G >= 256; G >>= 8)
      V++;
    const M = n.alloc(1 + 1 + V);
    M[0] = y, M[1] = 128 | V;
    for (let G = 1 + V, k = T.length; k > 0; G--, k >>= 8)
      M[G] = k & 255;
    return this._createEncoderBuffer([M, T]);
  }, d.prototype._encodeStr = function($, E) {
    if (E === "bitstr")
      return this._createEncoderBuffer([$.unused | 0, $.data]);
    if (E === "bmpstr") {
      const O = n.alloc($.length * 2);
      for (let T = 0; T < $.length; T++)
        O.writeUInt16BE($.charCodeAt(T), T * 2);
      return this._createEncoderBuffer(O);
    } else
      return E === "numstr" ? this._isNumstr($) ? this._createEncoderBuffer($) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : E === "printstr" ? this._isPrintstr($) ? this._createEncoderBuffer($) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(E) ? this._createEncoderBuffer($) : E === "objDesc" ? this._createEncoderBuffer($) : this.reporter.error("Encoding of string type: " + E + " unsupported");
  }, d.prototype._encodeObjid = function($, E, O) {
    if (typeof $ == "string") {
      if (!E)
        return this.reporter.error("string objid given, but no values map found");
      if (!E.hasOwnProperty($))
        return this.reporter.error("objid not found in values map");
      $ = E[$].split(/[\s.]+/g);
      for (let M = 0; M < $.length; M++)
        $[M] |= 0;
    } else if (Array.isArray($)) {
      $ = $.slice();
      for (let M = 0; M < $.length; M++)
        $[M] |= 0;
    }
    if (!Array.isArray($))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify($));
    if (!O) {
      if ($[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      $.splice(0, 2, $[0] * 40 + $[1]);
    }
    let T = 0;
    for (let M = 0; M < $.length; M++) {
      let G = $[M];
      for (T++; G >= 128; G >>= 7)
        T++;
    }
    const y = n.alloc(T);
    let V = y.length - 1;
    for (let M = $.length - 1; M >= 0; M--) {
      let G = $[M];
      for (y[V--] = G & 127; (G >>= 7) > 0; )
        y[V--] = 128 | G & 127;
    }
    return this._createEncoderBuffer(y);
  };
  function m(S) {
    return S < 10 ? "0" + S : S;
  }
  d.prototype._encodeTime = function($, E) {
    let O;
    const T = new Date($);
    return E === "gentime" ? O = [
      m(T.getUTCFullYear()),
      m(T.getUTCMonth() + 1),
      m(T.getUTCDate()),
      m(T.getUTCHours()),
      m(T.getUTCMinutes()),
      m(T.getUTCSeconds()),
      "Z"
    ].join("") : E === "utctime" ? O = [
      m(T.getUTCFullYear() % 100),
      m(T.getUTCMonth() + 1),
      m(T.getUTCDate()),
      m(T.getUTCHours()),
      m(T.getUTCMinutes()),
      m(T.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + E + " time is not supported yet"), this._encodeStr(O, "octstr");
  }, d.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, d.prototype._encodeInt = function($, E) {
    if (typeof $ == "string") {
      if (!E)
        return this.reporter.error("String int or enum given, but no values map");
      if (!E.hasOwnProperty($))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify($));
      $ = E[$];
    }
    if (typeof $ != "number" && !n.isBuffer($)) {
      const y = $.toArray();
      !$.sign && y[0] & 128 && y.unshift(0), $ = n.from(y);
    }
    if (n.isBuffer($)) {
      let y = $.length;
      $.length === 0 && y++;
      const V = n.alloc(y);
      return $.copy(V), $.length === 0 && (V[0] = 0), this._createEncoderBuffer(V);
    }
    if ($ < 128)
      return this._createEncoderBuffer($);
    if ($ < 256)
      return this._createEncoderBuffer([0, $]);
    let O = 1;
    for (let y = $; y >= 256; y >>= 8)
      O++;
    const T = new Array(O);
    for (let y = T.length - 1; y >= 0; y--)
      T[y] = $ & 255, $ >>= 8;
    return T[0] & 128 && T.unshift(0), this._createEncoderBuffer(n.from(T));
  }, d.prototype._encodeBool = function($) {
    return this._createEncoderBuffer($ ? 255 : 0);
  }, d.prototype._use = function($, E) {
    return typeof $ == "function" && ($ = $(E)), $._getEncoder("der").tree;
  }, d.prototype._skipDefault = function($, E, O) {
    const T = this._baseState;
    let y;
    if (T.default === null)
      return !1;
    const V = $.join();
    if (T.defaultBuffer === void 0 && (T.defaultBuffer = this._encodeValue(T.default, E, O).join()), V.length !== T.defaultBuffer.length)
      return !1;
    for (y = 0; y < V.length; y++)
      if (V[y] !== T.defaultBuffer[y])
        return !1;
    return !0;
  };
  function v(S, $, E, O) {
    let T;
    if (S === "seqof" ? S = "seq" : S === "setof" && (S = "set"), u.tagByName.hasOwnProperty(S))
      T = u.tagByName[S];
    else if (typeof S == "number" && (S | 0) === S)
      T = S;
    else
      return O.error("Unknown tag: " + S);
    return T >= 31 ? O.error("Multi-octet tag encoding unsupported") : ($ || (T |= 32), T |= u.tagClassByName[E || "universal"] << 6, T);
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1)
    return pem$1;
  hasRequiredPem$1 = 1;
  const e = requireInherits_browser(), n = requireDer$1();
  function o(u) {
    n.call(this, u), this.enc = "pem";
  }
  return e(o, n), pem$1 = o, o.prototype.encode = function(c, d) {
    const v = n.prototype.encode.call(this, c).toString("base64"), S = ["-----BEGIN " + d.label + "-----"];
    for (let $ = 0; $ < v.length; $ += 64)
      S.push(v.slice($, $ + 64));
    return S.push("-----END " + d.label + "-----"), S.join(`
`);
  }, pem$1;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(e) {
    const n = e;
    n.der = requireDer$1(), n.pem = requirePem$1();
  }(encoders)), encoders;
}
var decoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer)
    return der_1;
  hasRequiredDer = 1;
  const e = requireInherits_browser(), n = requireBn$2(), o = requireBuffer().DecoderBuffer, u = requireNode(), c = requireDer$2();
  function d($) {
    this.enc = "der", this.name = $.name, this.entity = $, this.tree = new m(), this.tree._init($.body);
  }
  der_1 = d, d.prototype.decode = function(E, O) {
    return o.isDecoderBuffer(E) || (E = new o(E, O)), this.tree._decode(E, O);
  };
  function m($) {
    u.call(this, "der", $);
  }
  e(m, u), m.prototype._peekTag = function(E, O, T) {
    if (E.isEmpty())
      return !1;
    const y = E.save(), V = v(E, 'Failed to peek tag: "' + O + '"');
    return E.isError(V) ? V : (E.restore(y), V.tag === O || V.tagStr === O || V.tagStr + "of" === O || T);
  }, m.prototype._decodeTag = function(E, O, T) {
    const y = v(
      E,
      'Failed to decode tag of "' + O + '"'
    );
    if (E.isError(y))
      return y;
    let V = S(
      E,
      y.primitive,
      'Failed to get length of "' + O + '"'
    );
    if (E.isError(V))
      return V;
    if (!T && y.tag !== O && y.tagStr !== O && y.tagStr + "of" !== O)
      return E.error('Failed to match tag: "' + O + '"');
    if (y.primitive || V !== null)
      return E.skip(V, 'Failed to match body of: "' + O + '"');
    const M = E.save(), G = this._skipUntilEnd(
      E,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return E.isError(G) ? G : (V = E.offset - M.offset, E.restore(M), E.skip(V, 'Failed to match body of: "' + O + '"'));
  }, m.prototype._skipUntilEnd = function(E, O) {
    for (; ; ) {
      const T = v(E, O);
      if (E.isError(T))
        return T;
      const y = S(E, T.primitive, O);
      if (E.isError(y))
        return y;
      let V;
      if (T.primitive || y !== null ? V = E.skip(y) : V = this._skipUntilEnd(E, O), E.isError(V))
        return V;
      if (T.tagStr === "end")
        break;
    }
  }, m.prototype._decodeList = function(E, O, T, y) {
    const V = [];
    for (; !E.isEmpty(); ) {
      const M = this._peekTag(E, "end");
      if (E.isError(M))
        return M;
      const G = T.decode(E, "der", y);
      if (E.isError(G) && M)
        break;
      V.push(G);
    }
    return V;
  }, m.prototype._decodeStr = function(E, O) {
    if (O === "bitstr") {
      const T = E.readUInt8();
      return E.isError(T) ? T : { unused: T, data: E.raw() };
    } else if (O === "bmpstr") {
      const T = E.raw();
      if (T.length % 2 === 1)
        return E.error("Decoding of string type: bmpstr length mismatch");
      let y = "";
      for (let V = 0; V < T.length / 2; V++)
        y += String.fromCharCode(T.readUInt16BE(V * 2));
      return y;
    } else if (O === "numstr") {
      const T = E.raw().toString("ascii");
      return this._isNumstr(T) ? T : E.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (O === "octstr")
        return E.raw();
      if (O === "objDesc")
        return E.raw();
      if (O === "printstr") {
        const T = E.raw().toString("ascii");
        return this._isPrintstr(T) ? T : E.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(O) ? E.raw().toString() : E.error("Decoding of string type: " + O + " unsupported");
    }
  }, m.prototype._decodeObjid = function(E, O, T) {
    let y;
    const V = [];
    let M = 0, G = 0;
    for (; !E.isEmpty(); )
      G = E.readUInt8(), M <<= 7, M |= G & 127, G & 128 || (V.push(M), M = 0);
    G & 128 && V.push(M);
    const k = V[0] / 40 | 0, F = V[0] % 40;
    if (T ? y = V : y = [k, F].concat(V.slice(1)), O) {
      let X = O[y.join(" ")];
      X === void 0 && (X = O[y.join(".")]), X !== void 0 && (y = X);
    }
    return y;
  }, m.prototype._decodeTime = function(E, O) {
    const T = E.raw().toString();
    let y, V, M, G, k, F;
    if (O === "gentime")
      y = T.slice(0, 4) | 0, V = T.slice(4, 6) | 0, M = T.slice(6, 8) | 0, G = T.slice(8, 10) | 0, k = T.slice(10, 12) | 0, F = T.slice(12, 14) | 0;
    else if (O === "utctime")
      y = T.slice(0, 2) | 0, V = T.slice(2, 4) | 0, M = T.slice(4, 6) | 0, G = T.slice(6, 8) | 0, k = T.slice(8, 10) | 0, F = T.slice(10, 12) | 0, y < 70 ? y = 2e3 + y : y = 1900 + y;
    else
      return E.error("Decoding " + O + " time is not supported yet");
    return Date.UTC(y, V - 1, M, G, k, F, 0);
  }, m.prototype._decodeNull = function() {
    return null;
  }, m.prototype._decodeBool = function(E) {
    const O = E.readUInt8();
    return E.isError(O) ? O : O !== 0;
  }, m.prototype._decodeInt = function(E, O) {
    const T = E.raw();
    let y = new n(T);
    return O && (y = O[y.toString(10)] || y), y;
  }, m.prototype._use = function(E, O) {
    return typeof E == "function" && (E = E(O)), E._getDecoder("der").tree;
  };
  function v($, E) {
    let O = $.readUInt8(E);
    if ($.isError(O))
      return O;
    const T = c.tagClass[O >> 6], y = (O & 32) === 0;
    if ((O & 31) === 31) {
      let M = O;
      for (O = 0; (M & 128) === 128; ) {
        if (M = $.readUInt8(E), $.isError(M))
          return M;
        O <<= 7, O |= M & 127;
      }
    } else
      O &= 31;
    const V = c.tag[O];
    return {
      cls: T,
      primitive: y,
      tag: O,
      tagStr: V
    };
  }
  function S($, E, O) {
    let T = $.readUInt8(O);
    if ($.isError(T))
      return T;
    if (!E && T === 128)
      return null;
    if (!(T & 128))
      return T;
    const y = T & 127;
    if (y > 4)
      return $.error("length octect is too long");
    T = 0;
    for (let V = 0; V < y; V++) {
      T <<= 8;
      const M = $.readUInt8(O);
      if ($.isError(M))
        return M;
      T |= M;
    }
    return T;
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem)
    return pem;
  hasRequiredPem = 1;
  const e = requireInherits_browser(), n = requireSafer().Buffer, o = requireDer();
  function u(c) {
    o.call(this, c), this.enc = "pem";
  }
  return e(u, o), pem = u, u.prototype.decode = function(d, m) {
    const v = d.toString().split(/[\r\n]+/g), S = m.label.toUpperCase(), $ = /^-----(BEGIN|END) ([^-]+)-----$/;
    let E = -1, O = -1;
    for (let V = 0; V < v.length; V++) {
      const M = v[V].match($);
      if (M !== null && M[2] === S)
        if (E === -1) {
          if (M[1] !== "BEGIN")
            break;
          E = V;
        } else {
          if (M[1] !== "END")
            break;
          O = V;
          break;
        }
    }
    if (E === -1 || O === -1)
      throw new Error("PEM section not found for: " + S);
    const T = v.slice(E + 1, O).join("");
    T.replace(/[^a-z0-9+/=]+/gi, "");
    const y = n.from(T, "base64");
    return o.prototype.decode.call(this, y, m);
  }, pem;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(e) {
    const n = e;
    n.der = requireDer(), n.pem = requirePem();
  }(decoders)), decoders;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(e) {
    const n = requireEncoders(), o = requireDecoders(), u = requireInherits_browser(), c = e;
    c.define = function(v, S) {
      return new d(v, S);
    };
    function d(m, v) {
      this.name = m, this.body = v, this.decoders = {}, this.encoders = {};
    }
    d.prototype._createNamed = function(v) {
      const S = this.name;
      function $(E) {
        this._initNamed(E, S);
      }
      return u($, v), $.prototype._initNamed = function(O, T) {
        v.call(this, O, T);
      }, new $(this);
    }, d.prototype._getDecoder = function(v) {
      return v = v || "der", this.decoders.hasOwnProperty(v) || (this.decoders[v] = this._createNamed(o[v])), this.decoders[v];
    }, d.prototype.decode = function(v, S, $) {
      return this._getDecoder(S).decode(v, $);
    }, d.prototype._getEncoder = function(v) {
      return v = v || "der", this.encoders.hasOwnProperty(v) || (this.encoders[v] = this._createNamed(n[v])), this.encoders[v];
    }, d.prototype.encode = function(v, S, $) {
      return this._getEncoder(S).encode(v, $);
    };
  }(api)), api;
}
var base$2 = {}, hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(e) {
    const n = e;
    n.Reporter = requireReporter().Reporter, n.DecoderBuffer = requireBuffer().DecoderBuffer, n.EncoderBuffer = requireBuffer().EncoderBuffer, n.Node = requireNode();
  }(base$2)), base$2;
}
var constants$6 = {}, hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(e) {
    const n = e;
    n._reverse = function(u) {
      const c = {};
      return Object.keys(u).forEach(function(d) {
        (d | 0) == d && (d = d | 0);
        const m = u[d];
        c[m] = d;
      }), c;
    }, n.der = requireDer$2();
  }(constants$6)), constants$6;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(e) {
    const n = e;
    n.bignum = requireBn$2(), n.define = requireApi().define, n.base = requireBase(), n.constants = requireConstants(), n.decoders = requireDecoders(), n.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate)
    return certificate;
  hasRequiredCertificate = 1;
  var e = requireAsn1$1(), n = e.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), o = e.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), u = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), c = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(u),
      this.key("subjectPublicKey").bitstr()
    );
  }), d = e.define("RelativeDistinguishedName", function() {
    this.setof(o);
  }), m = e.define("RDNSequence", function() {
    this.seqof(d);
  }), v = e.define("Name", function() {
    this.choice({
      rdnSequence: this.use(m)
    });
  }), S = e.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(n),
      this.key("notAfter").use(n)
    );
  }), $ = e.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), E = e.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(u),
      this.key("issuer").use(v),
      this.key("validity").use(S),
      this.key("subject").use(v),
      this.key("subjectPublicKeyInfo").use(c),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof($).optional()
    );
  }), O = e.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(E),
      this.key("signatureAlgorithm").use(u),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = O, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1)
    return asn1$1;
  hasRequiredAsn1 = 1;
  var e = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var n = e.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = n;
  var o = e.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = o;
  var u = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(c),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = u;
  var c = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), d = e.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(c),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = d;
  var m = e.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = m;
  var v = e.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = v, asn1$1.DSAparam = e.define("DSAparam", function() {
    this.int();
  });
  var S = e.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use($),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  asn1$1.ECPrivateKey = S;
  var $ = e.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  });
  return asn1$1.signature = e.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1$2 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc)
    return fixProc;
  hasRequiredFixProc = 1;
  var e = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, n = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, o = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, u = requireEvp_bytestokey(), c = requireBrowser$6(), d = requireSafeBuffer().Buffer;
  return fixProc = function(m, v) {
    var S = m.toString(), $ = S.match(e), E;
    if ($) {
      var T = "aes" + $[1], y = d.from($[2], "hex"), V = d.from($[3].replace(/[\r\n]/g, ""), "base64"), M = u(v, y.slice(0, 8), parseInt($[1], 10)).key, G = [], k = c.createDecipheriv(T, M, y);
      G.push(k.update(V)), G.push(k.final()), E = d.concat(G);
    } else {
      var O = S.match(o);
      E = d.from(O[2].replace(/[\r\n]/g, ""), "base64");
    }
    var F = S.match(n)[1];
    return {
      tag: F,
      data: E
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1)
    return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var e = requireAsn1(), n = require$$1$2, o = requireFixProc(), u = requireBrowser$6(), c = requireBrowser$7(), d = requireSafeBuffer().Buffer;
  parseAsn1 = m;
  function m(S) {
    var $;
    typeof S == "object" && !d.isBuffer(S) && ($ = S.passphrase, S = S.key), typeof S == "string" && (S = d.from(S));
    var E = o(S, $), O = E.tag, T = E.data, y, V;
    switch (O) {
      case "CERTIFICATE":
        V = e.certificate.decode(T, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (V || (V = e.PublicKey.decode(T, "der")), y = V.algorithm.algorithm.join("."), y) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPublicKey.decode(V.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return V.subjectPrivateKey = V.subjectPublicKey, {
              type: "ec",
              data: V
            };
          case "1.2.840.10040.4.1":
            return V.algorithm.params.pub_key = e.DSAparam.decode(V.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: V.algorithm.params
            };
          default:
            throw new Error("unknown key id " + y);
        }
      case "ENCRYPTED PRIVATE KEY":
        T = e.EncryptedPrivateKey.decode(T, "der"), T = v(T, $);
      case "PRIVATE KEY":
        switch (V = e.PrivateKey.decode(T, "der"), y = V.algorithm.algorithm.join("."), y) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPrivateKey.decode(V.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: V.algorithm.curve,
              privateKey: e.ECPrivateKey.decode(V.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return V.algorithm.params.priv_key = e.DSAparam.decode(V.subjectPrivateKey, "der"), {
              type: "dsa",
              params: V.algorithm.params
            };
          default:
            throw new Error("unknown key id " + y);
        }
      case "RSA PUBLIC KEY":
        return e.RSAPublicKey.decode(T, "der");
      case "RSA PRIVATE KEY":
        return e.RSAPrivateKey.decode(T, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: e.DSAPrivateKey.decode(T, "der")
        };
      case "EC PRIVATE KEY":
        return T = e.ECPrivateKey.decode(T, "der"), {
          curve: T.parameters.value,
          privateKey: T.privateKey
        };
      default:
        throw new Error("unknown key type " + O);
    }
  }
  m.signature = e.signature;
  function v(S, $) {
    var E = S.algorithm.decrypt.kde.kdeparams.salt, O = parseInt(S.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), T = n[S.algorithm.decrypt.cipher.algo.join(".")], y = S.algorithm.decrypt.cipher.iv, V = S.subjectPrivateKey, M = parseInt(T.split("-")[1], 10) / 8, G = c.pbkdf2Sync($, E, O, M, "sha1"), k = u.createDecipheriv(T, G, y), F = [];
    return F.push(k.update(V)), F.push(k.final()), d.concat(F);
  }
  return parseAsn1;
}
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign)
    return sign.exports;
  hasRequiredSign = 1;
  var e = requireSafeBuffer().Buffer, n = requireBrowser$8(), o = requireBrowserifyRsa(), u = requireElliptic().ec, c = bnExports$1, d = requireParseAsn1(), m = require$$4;
  function v(G, k, F, X, ee) {
    var ue = d(k);
    if (ue.curve) {
      if (X !== "ecdsa" && X !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return S(G, ue);
    } else if (ue.type === "dsa") {
      if (X !== "dsa")
        throw new Error("wrong private key type");
      return $(G, ue, F);
    } else if (X !== "rsa" && X !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    G = e.concat([ee, G]);
    for (var Q = ue.modulus.byteLength(), Y = [0, 1]; G.length + Y.length + 1 < Q; )
      Y.push(255);
    Y.push(0);
    for (var pe = -1; ++pe < G.length; )
      Y.push(G[pe]);
    var oe = o(Y, ue);
    return oe;
  }
  function S(G, k) {
    var F = m[k.curve.join(".")];
    if (!F)
      throw new Error("unknown curve " + k.curve.join("."));
    var X = new u(F), ee = X.keyFromPrivate(k.privateKey), ue = ee.sign(G);
    return e.from(ue.toDER());
  }
  function $(G, k, F) {
    for (var X = k.params.priv_key, ee = k.params.p, ue = k.params.q, Q = k.params.g, Y = new c(0), pe, oe = T(G, ue).mod(ue), ne = !1, H = O(X, ue, G, F); ne === !1; )
      pe = V(ue, H, F), Y = M(Q, pe, ee, ue), ne = pe.invm(ue).imul(oe.add(X.mul(Y))).mod(ue), ne.cmpn(0) === 0 && (ne = !1, Y = new c(0));
    return E(Y, ne);
  }
  function E(G, k) {
    G = G.toArray(), k = k.toArray(), G[0] & 128 && (G = [0].concat(G)), k[0] & 128 && (k = [0].concat(k));
    var F = G.length + k.length + 4, X = [48, F, 2, G.length];
    return X = X.concat(G, [2, k.length], k), e.from(X);
  }
  function O(G, k, F, X) {
    if (G = e.from(G.toArray()), G.length < k.byteLength()) {
      var ee = e.alloc(k.byteLength() - G.length);
      G = e.concat([ee, G]);
    }
    var ue = F.length, Q = y(F, k), Y = e.alloc(ue);
    Y.fill(1);
    var pe = e.alloc(ue);
    return pe = n(X, pe).update(Y).update(e.from([0])).update(G).update(Q).digest(), Y = n(X, pe).update(Y).digest(), pe = n(X, pe).update(Y).update(e.from([1])).update(G).update(Q).digest(), Y = n(X, pe).update(Y).digest(), { k: pe, v: Y };
  }
  function T(G, k) {
    var F = new c(G), X = (G.length << 3) - k.bitLength();
    return X > 0 && F.ishrn(X), F;
  }
  function y(G, k) {
    G = T(G, k), G = G.mod(k);
    var F = e.from(G.toArray());
    if (F.length < k.byteLength()) {
      var X = e.alloc(k.byteLength() - F.length);
      F = e.concat([X, F]);
    }
    return F;
  }
  function V(G, k, F) {
    var X, ee;
    do {
      for (X = e.alloc(0); X.length * 8 < G.bitLength(); )
        k.v = n(F, k.k).update(k.v).digest(), X = e.concat([X, k.v]);
      ee = T(X, G), k.k = n(F, k.k).update(k.v).update(e.from([0])).digest(), k.v = n(F, k.k).update(k.v).digest();
    } while (ee.cmp(G) !== -1);
    return ee;
  }
  function M(G, k, F, X) {
    return G.toRed(c.mont(F)).redPow(k).fromRed().mod(X);
  }
  return sign.exports = v, sign.exports.getKey = O, sign.exports.makeKey = V, sign.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify)
    return verify_1;
  hasRequiredVerify = 1;
  var e = requireSafeBuffer().Buffer, n = bnExports$1, o = requireElliptic().ec, u = requireParseAsn1(), c = require$$4;
  function d($, E, O, T, y) {
    var V = u(O);
    if (V.type === "ec") {
      if (T !== "ecdsa" && T !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return m($, E, V);
    } else if (V.type === "dsa") {
      if (T !== "dsa")
        throw new Error("wrong public key type");
      return v($, E, V);
    } else if (T !== "rsa" && T !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    E = e.concat([y, E]);
    for (var M = V.modulus.byteLength(), G = [1], k = 0; E.length + G.length + 2 < M; )
      G.push(255), k++;
    G.push(0);
    for (var F = -1; ++F < E.length; )
      G.push(E[F]);
    G = e.from(G);
    var X = n.mont(V.modulus);
    $ = new n($).toRed(X), $ = $.redPow(new n(V.publicExponent)), $ = e.from($.fromRed().toArray());
    var ee = k < 8 ? 1 : 0;
    for (M = Math.min($.length, G.length), $.length !== G.length && (ee = 1), F = -1; ++F < M; )
      ee |= $[F] ^ G[F];
    return ee === 0;
  }
  function m($, E, O) {
    var T = c[O.data.algorithm.curve.join(".")];
    if (!T)
      throw new Error("unknown curve " + O.data.algorithm.curve.join("."));
    var y = new o(T), V = O.data.subjectPrivateKey.data;
    return y.verify(E, $, V);
  }
  function v($, E, O) {
    var T = O.data.p, y = O.data.q, V = O.data.g, M = O.data.pub_key, G = u.signature.decode($, "der"), k = G.s, F = G.r;
    S(k, y), S(F, y);
    var X = n.mont(T), ee = k.invm(y), ue = V.toRed(X).redPow(new n(E).mul(ee).mod(y)).fromRed().mul(M.toRed(X).redPow(F.mul(ee).mod(y)).fromRed()).mod(T).mod(y);
    return ue.cmp(F) === 0;
  }
  function S($, E) {
    if ($.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if ($.cmp(E) >= E)
      throw new Error("invalid sig");
  }
  return verify_1 = d, verify_1;
}
var browser$5, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3)
    return browser$5;
  hasRequiredBrowser$3 = 1;
  var e = requireSafeBuffer().Buffer, n = requireBrowser$9(), o = requireReadableBrowser(), u = requireInherits_browser(), c = requireSign(), d = requireVerify(), m = require$$6;
  Object.keys(m).forEach(function(O) {
    m[O].id = e.from(m[O].id, "hex"), m[O.toLowerCase()] = m[O];
  });
  function v(O) {
    o.Writable.call(this);
    var T = m[O];
    if (!T)
      throw new Error("Unknown message digest");
    this._hashType = T.hash, this._hash = n(T.hash), this._tag = T.id, this._signType = T.sign;
  }
  u(v, o.Writable), v.prototype._write = function(T, y, V) {
    this._hash.update(T), V();
  }, v.prototype.update = function(T, y) {
    return typeof T == "string" && (T = e.from(T, y)), this._hash.update(T), this;
  }, v.prototype.sign = function(T, y) {
    this.end();
    var V = this._hash.digest(), M = c(V, T, this._hashType, this._signType, this._tag);
    return y ? M.toString(y) : M;
  };
  function S(O) {
    o.Writable.call(this);
    var T = m[O];
    if (!T)
      throw new Error("Unknown message digest");
    this._hash = n(T.hash), this._tag = T.id, this._signType = T.sign;
  }
  u(S, o.Writable), S.prototype._write = function(T, y, V) {
    this._hash.update(T), V();
  }, S.prototype.update = function(T, y) {
    return typeof T == "string" && (T = e.from(T, y)), this._hash.update(T), this;
  }, S.prototype.verify = function(T, y, V) {
    typeof y == "string" && (y = e.from(y, V)), this.end();
    var M = this._hash.digest();
    return d(y, M, T, this._signType, this._tag);
  };
  function $(O) {
    return new v(O);
  }
  function E(O) {
    return new S(O);
  }
  return browser$5 = {
    Sign: $,
    Verify: E,
    createSign: $,
    createVerify: E
  }, browser$5;
}
var bn$1 = { exports: {} };
bn$1.exports;
var hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(e) {
    (function(n, o) {
      function u(H, C) {
        if (!H)
          throw new Error(C || "Assertion failed");
      }
      function c(H, C) {
        H.super_ = C;
        var w = function() {
        };
        w.prototype = C.prototype, H.prototype = new w(), H.prototype.constructor = H;
      }
      function d(H, C, w) {
        if (d.isBN(H))
          return H;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, H !== null && ((C === "le" || C === "be") && (w = C, C = 10), this._init(H || 0, C || 10, w || "be"));
      }
      typeof n == "object" ? n.exports = d : o.BN = d, d.BN = d, d.wordSize = 26;
      var m;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = require$$0$3.Buffer;
      } catch {
      }
      d.isBN = function(C) {
        return C instanceof d ? !0 : C !== null && typeof C == "object" && C.constructor.wordSize === d.wordSize && Array.isArray(C.words);
      }, d.max = function(C, w) {
        return C.cmp(w) > 0 ? C : w;
      }, d.min = function(C, w) {
        return C.cmp(w) < 0 ? C : w;
      }, d.prototype._init = function(C, w, P) {
        if (typeof C == "number")
          return this._initNumber(C, w, P);
        if (typeof C == "object")
          return this._initArray(C, w, P);
        w === "hex" && (w = 16), u(w === (w | 0) && w >= 2 && w <= 36), C = C.toString().replace(/\s+/g, "");
        var J = 0;
        C[0] === "-" && (J++, this.negative = 1), J < C.length && (w === 16 ? this._parseHex(C, J, P) : (this._parseBase(C, w, J), P === "le" && this._initArray(this.toArray(), w, P)));
      }, d.prototype._initNumber = function(C, w, P) {
        C < 0 && (this.negative = 1, C = -C), C < 67108864 ? (this.words = [C & 67108863], this.length = 1) : C < 4503599627370496 ? (this.words = [
          C & 67108863,
          C / 67108864 & 67108863
        ], this.length = 2) : (u(C < 9007199254740992), this.words = [
          C & 67108863,
          C / 67108864 & 67108863,
          1
        ], this.length = 3), P === "le" && this._initArray(this.toArray(), w, P);
      }, d.prototype._initArray = function(C, w, P) {
        if (u(typeof C.length == "number"), C.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(C.length / 3), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se, fe, N = 0;
        if (P === "be")
          for (J = C.length - 1, se = 0; J >= 0; J -= 3)
            fe = C[J] | C[J - 1] << 8 | C[J - 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        else if (P === "le")
          for (J = 0, se = 0; J < C.length; J += 3)
            fe = C[J] | C[J + 1] << 8 | C[J + 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        return this.strip();
      };
      function v(H, C) {
        var w = H.charCodeAt(C);
        return w >= 65 && w <= 70 ? w - 55 : w >= 97 && w <= 102 ? w - 87 : w - 48 & 15;
      }
      function S(H, C, w) {
        var P = v(H, w);
        return w - 1 >= C && (P |= v(H, w - 1) << 4), P;
      }
      d.prototype._parseHex = function(C, w, P) {
        this.length = Math.ceil((C.length - w) / 6), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se = 0, fe = 0, N;
        if (P === "be")
          for (J = C.length - 1; J >= w; J -= 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        else {
          var W = C.length - w;
          for (J = W % 2 === 0 ? w + 1 : w; J < C.length; J += 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        }
        this.strip();
      };
      function $(H, C, w, P) {
        for (var J = 0, se = Math.min(H.length, w), fe = C; fe < se; fe++) {
          var N = H.charCodeAt(fe) - 48;
          J *= P, N >= 49 ? J += N - 49 + 10 : N >= 17 ? J += N - 17 + 10 : J += N;
        }
        return J;
      }
      d.prototype._parseBase = function(C, w, P) {
        this.words = [0], this.length = 1;
        for (var J = 0, se = 1; se <= 67108863; se *= w)
          J++;
        J--, se = se / w | 0;
        for (var fe = C.length - P, N = fe % J, W = Math.min(fe, fe - N) + P, I = 0, te = P; te < W; te += J)
          I = $(C, te, te + J, w), this.imuln(se), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        if (N !== 0) {
          var ge = 1;
          for (I = $(C, te, C.length, w), te = 0; te < N; te++)
            ge *= w;
          this.imuln(ge), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        }
        this.strip();
      }, d.prototype.copy = function(C) {
        C.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          C.words[w] = this.words[w];
        C.length = this.length, C.negative = this.negative, C.red = this.red;
      }, d.prototype.clone = function() {
        var C = new d(null);
        return this.copy(C), C;
      }, d.prototype._expand = function(C) {
        for (; this.length < C; )
          this.words[this.length++] = 0;
        return this;
      }, d.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, d.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, d.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var E = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], O = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], T = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      d.prototype.toString = function(C, w) {
        C = C || 10, w = w | 0 || 1;
        var P;
        if (C === 16 || C === "hex") {
          P = "";
          for (var J = 0, se = 0, fe = 0; fe < this.length; fe++) {
            var N = this.words[fe], W = ((N << J | se) & 16777215).toString(16);
            se = N >>> 24 - J & 16777215, se !== 0 || fe !== this.length - 1 ? P = E[6 - W.length] + W + P : P = W + P, J += 2, J >= 26 && (J -= 26, fe--);
          }
          for (se !== 0 && (P = se.toString(16) + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        if (C === (C | 0) && C >= 2 && C <= 36) {
          var I = O[C], te = T[C];
          P = "";
          var ge = this.clone();
          for (ge.negative = 0; !ge.isZero(); ) {
            var Pe = ge.modn(te).toString(C);
            ge = ge.idivn(te), ge.isZero() ? P = Pe + P : P = E[I - Pe.length] + Pe + P;
          }
          for (this.isZero() && (P = "0" + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        u(!1, "Base should be between 2 and 36");
      }, d.prototype.toNumber = function() {
        var C = this.words[0];
        return this.length === 2 ? C += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? C += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && u(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -C : C;
      }, d.prototype.toJSON = function() {
        return this.toString(16);
      }, d.prototype.toBuffer = function(C, w) {
        return u(typeof m < "u"), this.toArrayLike(m, C, w);
      }, d.prototype.toArray = function(C, w) {
        return this.toArrayLike(Array, C, w);
      }, d.prototype.toArrayLike = function(C, w, P) {
        var J = this.byteLength(), se = P || Math.max(1, J);
        u(J <= se, "byte array longer than desired length"), u(se > 0, "Requested array length <= 0"), this.strip();
        var fe = w === "le", N = new C(se), W, I, te = this.clone();
        if (fe) {
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[I] = W;
          for (; I < se; I++)
            N[I] = 0;
        } else {
          for (I = 0; I < se - J; I++)
            N[I] = 0;
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[se - I - 1] = W;
        }
        return N;
      }, Math.clz32 ? d.prototype._countBits = function(C) {
        return 32 - Math.clz32(C);
      } : d.prototype._countBits = function(C) {
        var w = C, P = 0;
        return w >= 4096 && (P += 13, w >>>= 13), w >= 64 && (P += 7, w >>>= 7), w >= 8 && (P += 4, w >>>= 4), w >= 2 && (P += 2, w >>>= 2), P + w;
      }, d.prototype._zeroBits = function(C) {
        if (C === 0)
          return 26;
        var w = C, P = 0;
        return w & 8191 || (P += 13, w >>>= 13), w & 127 || (P += 7, w >>>= 7), w & 15 || (P += 4, w >>>= 4), w & 3 || (P += 2, w >>>= 2), w & 1 || P++, P;
      }, d.prototype.bitLength = function() {
        var C = this.words[this.length - 1], w = this._countBits(C);
        return (this.length - 1) * 26 + w;
      };
      function y(H) {
        for (var C = new Array(H.bitLength()), w = 0; w < C.length; w++) {
          var P = w / 26 | 0, J = w % 26;
          C[w] = (H.words[P] & 1 << J) >>> J;
        }
        return C;
      }
      d.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var C = 0, w = 0; w < this.length; w++) {
          var P = this._zeroBits(this.words[w]);
          if (C += P, P !== 26)
            break;
        }
        return C;
      }, d.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, d.prototype.toTwos = function(C) {
        return this.negative !== 0 ? this.abs().inotn(C).iaddn(1) : this.clone();
      }, d.prototype.fromTwos = function(C) {
        return this.testn(C - 1) ? this.notn(C).iaddn(1).ineg() : this.clone();
      }, d.prototype.isNeg = function() {
        return this.negative !== 0;
      }, d.prototype.neg = function() {
        return this.clone().ineg();
      }, d.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, d.prototype.iuor = function(C) {
        for (; this.length < C.length; )
          this.words[this.length++] = 0;
        for (var w = 0; w < C.length; w++)
          this.words[w] = this.words[w] | C.words[w];
        return this.strip();
      }, d.prototype.ior = function(C) {
        return u((this.negative | C.negative) === 0), this.iuor(C);
      }, d.prototype.or = function(C) {
        return this.length > C.length ? this.clone().ior(C) : C.clone().ior(this);
      }, d.prototype.uor = function(C) {
        return this.length > C.length ? this.clone().iuor(C) : C.clone().iuor(this);
      }, d.prototype.iuand = function(C) {
        var w;
        this.length > C.length ? w = C : w = this;
        for (var P = 0; P < w.length; P++)
          this.words[P] = this.words[P] & C.words[P];
        return this.length = w.length, this.strip();
      }, d.prototype.iand = function(C) {
        return u((this.negative | C.negative) === 0), this.iuand(C);
      }, d.prototype.and = function(C) {
        return this.length > C.length ? this.clone().iand(C) : C.clone().iand(this);
      }, d.prototype.uand = function(C) {
        return this.length > C.length ? this.clone().iuand(C) : C.clone().iuand(this);
      }, d.prototype.iuxor = function(C) {
        var w, P;
        this.length > C.length ? (w = this, P = C) : (w = C, P = this);
        for (var J = 0; J < P.length; J++)
          this.words[J] = w.words[J] ^ P.words[J];
        if (this !== w)
          for (; J < w.length; J++)
            this.words[J] = w.words[J];
        return this.length = w.length, this.strip();
      }, d.prototype.ixor = function(C) {
        return u((this.negative | C.negative) === 0), this.iuxor(C);
      }, d.prototype.xor = function(C) {
        return this.length > C.length ? this.clone().ixor(C) : C.clone().ixor(this);
      }, d.prototype.uxor = function(C) {
        return this.length > C.length ? this.clone().iuxor(C) : C.clone().iuxor(this);
      }, d.prototype.inotn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = Math.ceil(C / 26) | 0, P = C % 26;
        this._expand(w), P > 0 && w--;
        for (var J = 0; J < w; J++)
          this.words[J] = ~this.words[J] & 67108863;
        return P > 0 && (this.words[J] = ~this.words[J] & 67108863 >> 26 - P), this.strip();
      }, d.prototype.notn = function(C) {
        return this.clone().inotn(C);
      }, d.prototype.setn = function(C, w) {
        u(typeof C == "number" && C >= 0);
        var P = C / 26 | 0, J = C % 26;
        return this._expand(P + 1), w ? this.words[P] = this.words[P] | 1 << J : this.words[P] = this.words[P] & ~(1 << J), this.strip();
      }, d.prototype.iadd = function(C) {
        var w;
        if (this.negative !== 0 && C.negative === 0)
          return this.negative = 0, w = this.isub(C), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && C.negative !== 0)
          return C.negative = 0, w = this.isub(C), C.negative = 1, w._normSign();
        var P, J;
        this.length > C.length ? (P = this, J = C) : (P = C, J = this);
        for (var se = 0, fe = 0; fe < J.length; fe++)
          w = (P.words[fe] | 0) + (J.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        for (; se !== 0 && fe < P.length; fe++)
          w = (P.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        if (this.length = P.length, se !== 0)
          this.words[this.length] = se, this.length++;
        else if (P !== this)
          for (; fe < P.length; fe++)
            this.words[fe] = P.words[fe];
        return this;
      }, d.prototype.add = function(C) {
        var w;
        return C.negative !== 0 && this.negative === 0 ? (C.negative = 0, w = this.sub(C), C.negative ^= 1, w) : C.negative === 0 && this.negative !== 0 ? (this.negative = 0, w = C.sub(this), this.negative = 1, w) : this.length > C.length ? this.clone().iadd(C) : C.clone().iadd(this);
      }, d.prototype.isub = function(C) {
        if (C.negative !== 0) {
          C.negative = 0;
          var w = this.iadd(C);
          return C.negative = 1, w._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(C), this.negative = 1, this._normSign();
        var P = this.cmp(C);
        if (P === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var J, se;
        P > 0 ? (J = this, se = C) : (J = C, se = this);
        for (var fe = 0, N = 0; N < se.length; N++)
          w = (J.words[N] | 0) - (se.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        for (; fe !== 0 && N < J.length; N++)
          w = (J.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        if (fe === 0 && N < J.length && J !== this)
          for (; N < J.length; N++)
            this.words[N] = J.words[N];
        return this.length = Math.max(this.length, N), J !== this && (this.negative = 1), this.strip();
      }, d.prototype.sub = function(C) {
        return this.clone().isub(C);
      };
      function V(H, C, w) {
        w.negative = C.negative ^ H.negative;
        var P = H.length + C.length | 0;
        w.length = P, P = P - 1 | 0;
        var J = H.words[0] | 0, se = C.words[0] | 0, fe = J * se, N = fe & 67108863, W = fe / 67108864 | 0;
        w.words[0] = N;
        for (var I = 1; I < P; I++) {
          for (var te = W >>> 26, ge = W & 67108863, Pe = Math.min(I, C.length - 1), Ke = Math.max(0, I - H.length + 1); Ke <= Pe; Ke++) {
            var xe = I - Ke | 0;
            J = H.words[xe] | 0, se = C.words[Ke] | 0, fe = J * se + ge, te += fe / 67108864 | 0, ge = fe & 67108863;
          }
          w.words[I] = ge | 0, W = te | 0;
        }
        return W !== 0 ? w.words[I] = W | 0 : w.length--, w.strip();
      }
      var M = function(C, w, P) {
        var J = C.words, se = w.words, fe = P.words, N = 0, W, I, te, ge = J[0] | 0, Pe = ge & 8191, Ke = ge >>> 13, xe = J[1] | 0, ze = xe & 8191, nt = xe >>> 13, Qt = J[2] | 0, Et = Qt & 8191, zt = Qt >>> 13, Nt = J[3] | 0, pt = Nt & 8191, at = Nt >>> 13, kt = J[4] | 0, Ut = kt & 8191, dn = kt >>> 13, En = J[5] | 0, Ht = En & 8191, Xt = En >>> 13, On = J[6] | 0, sn = On & 8191, At = On >>> 13, hn = J[7] | 0, $t = hn & 8191, Lt = hn >>> 13, Qn = J[8] | 0, ce = Qn & 8191, Ze = Qn >>> 13, ft = J[9] | 0, It = ft & 8191, rn = ft >>> 13, Ln = se[0] | 0, Pn = Ln & 8191, Ae = Ln >>> 13, Me = se[1] | 0, He = Me & 8191, cn = Me >>> 13, Wt = se[2] | 0, yn = Wt & 8191, pr = Wt >>> 13, Uo = se[3] | 0, ar = Uo & 8191, Sr = Uo >>> 13, Jo = se[4] | 0, fr = Jo & 8191, Er = Jo >>> 13, vo = se[5] | 0, lr = vo & 8191, $r = vo >>> 13, Wo = se[6] | 0, yr = Wo & 8191, Dr = Wo >>> 13, Zo = se[7] | 0, dr = Zo & 8191, Br = Zo >>> 13, Qo = se[8] | 0, tr = Qo & 8191, Mr = Qo >>> 13, qo = se[9] | 0, hr = qo & 8191, Or = qo >>> 13;
        P.negative = C.negative ^ w.negative, P.length = 19, W = Math.imul(Pe, Pn), I = Math.imul(Pe, Ae), I = I + Math.imul(Ke, Pn) | 0, te = Math.imul(Ke, Ae);
        var Fo = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fo >>> 26) | 0, Fo &= 67108863, W = Math.imul(ze, Pn), I = Math.imul(ze, Ae), I = I + Math.imul(nt, Pn) | 0, te = Math.imul(nt, Ae), W = W + Math.imul(Pe, He) | 0, I = I + Math.imul(Pe, cn) | 0, I = I + Math.imul(Ke, He) | 0, te = te + Math.imul(Ke, cn) | 0;
        var No = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, W = Math.imul(Et, Pn), I = Math.imul(Et, Ae), I = I + Math.imul(zt, Pn) | 0, te = Math.imul(zt, Ae), W = W + Math.imul(ze, He) | 0, I = I + Math.imul(ze, cn) | 0, I = I + Math.imul(nt, He) | 0, te = te + Math.imul(nt, cn) | 0, W = W + Math.imul(Pe, yn) | 0, I = I + Math.imul(Pe, pr) | 0, I = I + Math.imul(Ke, yn) | 0, te = te + Math.imul(Ke, pr) | 0;
        var di = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, W = Math.imul(pt, Pn), I = Math.imul(pt, Ae), I = I + Math.imul(at, Pn) | 0, te = Math.imul(at, Ae), W = W + Math.imul(Et, He) | 0, I = I + Math.imul(Et, cn) | 0, I = I + Math.imul(zt, He) | 0, te = te + Math.imul(zt, cn) | 0, W = W + Math.imul(ze, yn) | 0, I = I + Math.imul(ze, pr) | 0, I = I + Math.imul(nt, yn) | 0, te = te + Math.imul(nt, pr) | 0, W = W + Math.imul(Pe, ar) | 0, I = I + Math.imul(Pe, Sr) | 0, I = I + Math.imul(Ke, ar) | 0, te = te + Math.imul(Ke, Sr) | 0;
        var gi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, W = Math.imul(Ut, Pn), I = Math.imul(Ut, Ae), I = I + Math.imul(dn, Pn) | 0, te = Math.imul(dn, Ae), W = W + Math.imul(pt, He) | 0, I = I + Math.imul(pt, cn) | 0, I = I + Math.imul(at, He) | 0, te = te + Math.imul(at, cn) | 0, W = W + Math.imul(Et, yn) | 0, I = I + Math.imul(Et, pr) | 0, I = I + Math.imul(zt, yn) | 0, te = te + Math.imul(zt, pr) | 0, W = W + Math.imul(ze, ar) | 0, I = I + Math.imul(ze, Sr) | 0, I = I + Math.imul(nt, ar) | 0, te = te + Math.imul(nt, Sr) | 0, W = W + Math.imul(Pe, fr) | 0, I = I + Math.imul(Pe, Er) | 0, I = I + Math.imul(Ke, fr) | 0, te = te + Math.imul(Ke, Er) | 0;
        var ai = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, W = Math.imul(Ht, Pn), I = Math.imul(Ht, Ae), I = I + Math.imul(Xt, Pn) | 0, te = Math.imul(Xt, Ae), W = W + Math.imul(Ut, He) | 0, I = I + Math.imul(Ut, cn) | 0, I = I + Math.imul(dn, He) | 0, te = te + Math.imul(dn, cn) | 0, W = W + Math.imul(pt, yn) | 0, I = I + Math.imul(pt, pr) | 0, I = I + Math.imul(at, yn) | 0, te = te + Math.imul(at, pr) | 0, W = W + Math.imul(Et, ar) | 0, I = I + Math.imul(Et, Sr) | 0, I = I + Math.imul(zt, ar) | 0, te = te + Math.imul(zt, Sr) | 0, W = W + Math.imul(ze, fr) | 0, I = I + Math.imul(ze, Er) | 0, I = I + Math.imul(nt, fr) | 0, te = te + Math.imul(nt, Er) | 0, W = W + Math.imul(Pe, lr) | 0, I = I + Math.imul(Pe, $r) | 0, I = I + Math.imul(Ke, lr) | 0, te = te + Math.imul(Ke, $r) | 0;
        var ui = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, W = Math.imul(sn, Pn), I = Math.imul(sn, Ae), I = I + Math.imul(At, Pn) | 0, te = Math.imul(At, Ae), W = W + Math.imul(Ht, He) | 0, I = I + Math.imul(Ht, cn) | 0, I = I + Math.imul(Xt, He) | 0, te = te + Math.imul(Xt, cn) | 0, W = W + Math.imul(Ut, yn) | 0, I = I + Math.imul(Ut, pr) | 0, I = I + Math.imul(dn, yn) | 0, te = te + Math.imul(dn, pr) | 0, W = W + Math.imul(pt, ar) | 0, I = I + Math.imul(pt, Sr) | 0, I = I + Math.imul(at, ar) | 0, te = te + Math.imul(at, Sr) | 0, W = W + Math.imul(Et, fr) | 0, I = I + Math.imul(Et, Er) | 0, I = I + Math.imul(zt, fr) | 0, te = te + Math.imul(zt, Er) | 0, W = W + Math.imul(ze, lr) | 0, I = I + Math.imul(ze, $r) | 0, I = I + Math.imul(nt, lr) | 0, te = te + Math.imul(nt, $r) | 0, W = W + Math.imul(Pe, yr) | 0, I = I + Math.imul(Pe, Dr) | 0, I = I + Math.imul(Ke, yr) | 0, te = te + Math.imul(Ke, Dr) | 0;
        var hi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (hi >>> 26) | 0, hi &= 67108863, W = Math.imul($t, Pn), I = Math.imul($t, Ae), I = I + Math.imul(Lt, Pn) | 0, te = Math.imul(Lt, Ae), W = W + Math.imul(sn, He) | 0, I = I + Math.imul(sn, cn) | 0, I = I + Math.imul(At, He) | 0, te = te + Math.imul(At, cn) | 0, W = W + Math.imul(Ht, yn) | 0, I = I + Math.imul(Ht, pr) | 0, I = I + Math.imul(Xt, yn) | 0, te = te + Math.imul(Xt, pr) | 0, W = W + Math.imul(Ut, ar) | 0, I = I + Math.imul(Ut, Sr) | 0, I = I + Math.imul(dn, ar) | 0, te = te + Math.imul(dn, Sr) | 0, W = W + Math.imul(pt, fr) | 0, I = I + Math.imul(pt, Er) | 0, I = I + Math.imul(at, fr) | 0, te = te + Math.imul(at, Er) | 0, W = W + Math.imul(Et, lr) | 0, I = I + Math.imul(Et, $r) | 0, I = I + Math.imul(zt, lr) | 0, te = te + Math.imul(zt, $r) | 0, W = W + Math.imul(ze, yr) | 0, I = I + Math.imul(ze, Dr) | 0, I = I + Math.imul(nt, yr) | 0, te = te + Math.imul(nt, Dr) | 0, W = W + Math.imul(Pe, dr) | 0, I = I + Math.imul(Pe, Br) | 0, I = I + Math.imul(Ke, dr) | 0, te = te + Math.imul(Ke, Br) | 0;
        var bi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, W = Math.imul(ce, Pn), I = Math.imul(ce, Ae), I = I + Math.imul(Ze, Pn) | 0, te = Math.imul(Ze, Ae), W = W + Math.imul($t, He) | 0, I = I + Math.imul($t, cn) | 0, I = I + Math.imul(Lt, He) | 0, te = te + Math.imul(Lt, cn) | 0, W = W + Math.imul(sn, yn) | 0, I = I + Math.imul(sn, pr) | 0, I = I + Math.imul(At, yn) | 0, te = te + Math.imul(At, pr) | 0, W = W + Math.imul(Ht, ar) | 0, I = I + Math.imul(Ht, Sr) | 0, I = I + Math.imul(Xt, ar) | 0, te = te + Math.imul(Xt, Sr) | 0, W = W + Math.imul(Ut, fr) | 0, I = I + Math.imul(Ut, Er) | 0, I = I + Math.imul(dn, fr) | 0, te = te + Math.imul(dn, Er) | 0, W = W + Math.imul(pt, lr) | 0, I = I + Math.imul(pt, $r) | 0, I = I + Math.imul(at, lr) | 0, te = te + Math.imul(at, $r) | 0, W = W + Math.imul(Et, yr) | 0, I = I + Math.imul(Et, Dr) | 0, I = I + Math.imul(zt, yr) | 0, te = te + Math.imul(zt, Dr) | 0, W = W + Math.imul(ze, dr) | 0, I = I + Math.imul(ze, Br) | 0, I = I + Math.imul(nt, dr) | 0, te = te + Math.imul(nt, Br) | 0, W = W + Math.imul(Pe, tr) | 0, I = I + Math.imul(Pe, Mr) | 0, I = I + Math.imul(Ke, tr) | 0, te = te + Math.imul(Ke, Mr) | 0;
        var ii = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, W = Math.imul(It, Pn), I = Math.imul(It, Ae), I = I + Math.imul(rn, Pn) | 0, te = Math.imul(rn, Ae), W = W + Math.imul(ce, He) | 0, I = I + Math.imul(ce, cn) | 0, I = I + Math.imul(Ze, He) | 0, te = te + Math.imul(Ze, cn) | 0, W = W + Math.imul($t, yn) | 0, I = I + Math.imul($t, pr) | 0, I = I + Math.imul(Lt, yn) | 0, te = te + Math.imul(Lt, pr) | 0, W = W + Math.imul(sn, ar) | 0, I = I + Math.imul(sn, Sr) | 0, I = I + Math.imul(At, ar) | 0, te = te + Math.imul(At, Sr) | 0, W = W + Math.imul(Ht, fr) | 0, I = I + Math.imul(Ht, Er) | 0, I = I + Math.imul(Xt, fr) | 0, te = te + Math.imul(Xt, Er) | 0, W = W + Math.imul(Ut, lr) | 0, I = I + Math.imul(Ut, $r) | 0, I = I + Math.imul(dn, lr) | 0, te = te + Math.imul(dn, $r) | 0, W = W + Math.imul(pt, yr) | 0, I = I + Math.imul(pt, Dr) | 0, I = I + Math.imul(at, yr) | 0, te = te + Math.imul(at, Dr) | 0, W = W + Math.imul(Et, dr) | 0, I = I + Math.imul(Et, Br) | 0, I = I + Math.imul(zt, dr) | 0, te = te + Math.imul(zt, Br) | 0, W = W + Math.imul(ze, tr) | 0, I = I + Math.imul(ze, Mr) | 0, I = I + Math.imul(nt, tr) | 0, te = te + Math.imul(nt, Mr) | 0, W = W + Math.imul(Pe, hr) | 0, I = I + Math.imul(Pe, Or) | 0, I = I + Math.imul(Ke, hr) | 0, te = te + Math.imul(Ke, Or) | 0;
        var pi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (pi >>> 26) | 0, pi &= 67108863, W = Math.imul(It, He), I = Math.imul(It, cn), I = I + Math.imul(rn, He) | 0, te = Math.imul(rn, cn), W = W + Math.imul(ce, yn) | 0, I = I + Math.imul(ce, pr) | 0, I = I + Math.imul(Ze, yn) | 0, te = te + Math.imul(Ze, pr) | 0, W = W + Math.imul($t, ar) | 0, I = I + Math.imul($t, Sr) | 0, I = I + Math.imul(Lt, ar) | 0, te = te + Math.imul(Lt, Sr) | 0, W = W + Math.imul(sn, fr) | 0, I = I + Math.imul(sn, Er) | 0, I = I + Math.imul(At, fr) | 0, te = te + Math.imul(At, Er) | 0, W = W + Math.imul(Ht, lr) | 0, I = I + Math.imul(Ht, $r) | 0, I = I + Math.imul(Xt, lr) | 0, te = te + Math.imul(Xt, $r) | 0, W = W + Math.imul(Ut, yr) | 0, I = I + Math.imul(Ut, Dr) | 0, I = I + Math.imul(dn, yr) | 0, te = te + Math.imul(dn, Dr) | 0, W = W + Math.imul(pt, dr) | 0, I = I + Math.imul(pt, Br) | 0, I = I + Math.imul(at, dr) | 0, te = te + Math.imul(at, Br) | 0, W = W + Math.imul(Et, tr) | 0, I = I + Math.imul(Et, Mr) | 0, I = I + Math.imul(zt, tr) | 0, te = te + Math.imul(zt, Mr) | 0, W = W + Math.imul(ze, hr) | 0, I = I + Math.imul(ze, Or) | 0, I = I + Math.imul(nt, hr) | 0, te = te + Math.imul(nt, Or) | 0;
        var Ci = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, W = Math.imul(It, yn), I = Math.imul(It, pr), I = I + Math.imul(rn, yn) | 0, te = Math.imul(rn, pr), W = W + Math.imul(ce, ar) | 0, I = I + Math.imul(ce, Sr) | 0, I = I + Math.imul(Ze, ar) | 0, te = te + Math.imul(Ze, Sr) | 0, W = W + Math.imul($t, fr) | 0, I = I + Math.imul($t, Er) | 0, I = I + Math.imul(Lt, fr) | 0, te = te + Math.imul(Lt, Er) | 0, W = W + Math.imul(sn, lr) | 0, I = I + Math.imul(sn, $r) | 0, I = I + Math.imul(At, lr) | 0, te = te + Math.imul(At, $r) | 0, W = W + Math.imul(Ht, yr) | 0, I = I + Math.imul(Ht, Dr) | 0, I = I + Math.imul(Xt, yr) | 0, te = te + Math.imul(Xt, Dr) | 0, W = W + Math.imul(Ut, dr) | 0, I = I + Math.imul(Ut, Br) | 0, I = I + Math.imul(dn, dr) | 0, te = te + Math.imul(dn, Br) | 0, W = W + Math.imul(pt, tr) | 0, I = I + Math.imul(pt, Mr) | 0, I = I + Math.imul(at, tr) | 0, te = te + Math.imul(at, Mr) | 0, W = W + Math.imul(Et, hr) | 0, I = I + Math.imul(Et, Or) | 0, I = I + Math.imul(zt, hr) | 0, te = te + Math.imul(zt, Or) | 0;
        var _i = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (_i >>> 26) | 0, _i &= 67108863, W = Math.imul(It, ar), I = Math.imul(It, Sr), I = I + Math.imul(rn, ar) | 0, te = Math.imul(rn, Sr), W = W + Math.imul(ce, fr) | 0, I = I + Math.imul(ce, Er) | 0, I = I + Math.imul(Ze, fr) | 0, te = te + Math.imul(Ze, Er) | 0, W = W + Math.imul($t, lr) | 0, I = I + Math.imul($t, $r) | 0, I = I + Math.imul(Lt, lr) | 0, te = te + Math.imul(Lt, $r) | 0, W = W + Math.imul(sn, yr) | 0, I = I + Math.imul(sn, Dr) | 0, I = I + Math.imul(At, yr) | 0, te = te + Math.imul(At, Dr) | 0, W = W + Math.imul(Ht, dr) | 0, I = I + Math.imul(Ht, Br) | 0, I = I + Math.imul(Xt, dr) | 0, te = te + Math.imul(Xt, Br) | 0, W = W + Math.imul(Ut, tr) | 0, I = I + Math.imul(Ut, Mr) | 0, I = I + Math.imul(dn, tr) | 0, te = te + Math.imul(dn, Mr) | 0, W = W + Math.imul(pt, hr) | 0, I = I + Math.imul(pt, Or) | 0, I = I + Math.imul(at, hr) | 0, te = te + Math.imul(at, Or) | 0;
        var xn = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, W = Math.imul(It, fr), I = Math.imul(It, Er), I = I + Math.imul(rn, fr) | 0, te = Math.imul(rn, Er), W = W + Math.imul(ce, lr) | 0, I = I + Math.imul(ce, $r) | 0, I = I + Math.imul(Ze, lr) | 0, te = te + Math.imul(Ze, $r) | 0, W = W + Math.imul($t, yr) | 0, I = I + Math.imul($t, Dr) | 0, I = I + Math.imul(Lt, yr) | 0, te = te + Math.imul(Lt, Dr) | 0, W = W + Math.imul(sn, dr) | 0, I = I + Math.imul(sn, Br) | 0, I = I + Math.imul(At, dr) | 0, te = te + Math.imul(At, Br) | 0, W = W + Math.imul(Ht, tr) | 0, I = I + Math.imul(Ht, Mr) | 0, I = I + Math.imul(Xt, tr) | 0, te = te + Math.imul(Xt, Mr) | 0, W = W + Math.imul(Ut, hr) | 0, I = I + Math.imul(Ut, Or) | 0, I = I + Math.imul(dn, hr) | 0, te = te + Math.imul(dn, Or) | 0;
        var sr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (sr >>> 26) | 0, sr &= 67108863, W = Math.imul(It, lr), I = Math.imul(It, $r), I = I + Math.imul(rn, lr) | 0, te = Math.imul(rn, $r), W = W + Math.imul(ce, yr) | 0, I = I + Math.imul(ce, Dr) | 0, I = I + Math.imul(Ze, yr) | 0, te = te + Math.imul(Ze, Dr) | 0, W = W + Math.imul($t, dr) | 0, I = I + Math.imul($t, Br) | 0, I = I + Math.imul(Lt, dr) | 0, te = te + Math.imul(Lt, Br) | 0, W = W + Math.imul(sn, tr) | 0, I = I + Math.imul(sn, Mr) | 0, I = I + Math.imul(At, tr) | 0, te = te + Math.imul(At, Mr) | 0, W = W + Math.imul(Ht, hr) | 0, I = I + Math.imul(Ht, Or) | 0, I = I + Math.imul(Xt, hr) | 0, te = te + Math.imul(Xt, Or) | 0;
        var Nr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Nr >>> 26) | 0, Nr &= 67108863, W = Math.imul(It, yr), I = Math.imul(It, Dr), I = I + Math.imul(rn, yr) | 0, te = Math.imul(rn, Dr), W = W + Math.imul(ce, dr) | 0, I = I + Math.imul(ce, Br) | 0, I = I + Math.imul(Ze, dr) | 0, te = te + Math.imul(Ze, Br) | 0, W = W + Math.imul($t, tr) | 0, I = I + Math.imul($t, Mr) | 0, I = I + Math.imul(Lt, tr) | 0, te = te + Math.imul(Lt, Mr) | 0, W = W + Math.imul(sn, hr) | 0, I = I + Math.imul(sn, Or) | 0, I = I + Math.imul(At, hr) | 0, te = te + Math.imul(At, Or) | 0;
        var vr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, W = Math.imul(It, dr), I = Math.imul(It, Br), I = I + Math.imul(rn, dr) | 0, te = Math.imul(rn, Br), W = W + Math.imul(ce, tr) | 0, I = I + Math.imul(ce, Mr) | 0, I = I + Math.imul(Ze, tr) | 0, te = te + Math.imul(Ze, Mr) | 0, W = W + Math.imul($t, hr) | 0, I = I + Math.imul($t, Or) | 0, I = I + Math.imul(Lt, hr) | 0, te = te + Math.imul(Lt, Or) | 0;
        var Yr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, W = Math.imul(It, tr), I = Math.imul(It, Mr), I = I + Math.imul(rn, tr) | 0, te = Math.imul(rn, Mr), W = W + Math.imul(ce, hr) | 0, I = I + Math.imul(ce, Or) | 0, I = I + Math.imul(Ze, hr) | 0, te = te + Math.imul(Ze, Or) | 0;
        var Fr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, W = Math.imul(It, hr), I = Math.imul(It, Or), I = I + Math.imul(rn, hr) | 0, te = Math.imul(rn, Or);
        var eo = (N + W | 0) + ((I & 8191) << 13) | 0;
        return N = (te + (I >>> 13) | 0) + (eo >>> 26) | 0, eo &= 67108863, fe[0] = Fo, fe[1] = No, fe[2] = di, fe[3] = gi, fe[4] = ai, fe[5] = ui, fe[6] = hi, fe[7] = bi, fe[8] = ii, fe[9] = pi, fe[10] = Ci, fe[11] = _i, fe[12] = xn, fe[13] = sr, fe[14] = Nr, fe[15] = vr, fe[16] = Yr, fe[17] = Fr, fe[18] = eo, N !== 0 && (fe[19] = N, P.length++), P;
      };
      Math.imul || (M = V);
      function G(H, C, w) {
        w.negative = C.negative ^ H.negative, w.length = H.length + C.length;
        for (var P = 0, J = 0, se = 0; se < w.length - 1; se++) {
          var fe = J;
          J = 0;
          for (var N = P & 67108863, W = Math.min(se, C.length - 1), I = Math.max(0, se - H.length + 1); I <= W; I++) {
            var te = se - I, ge = H.words[te] | 0, Pe = C.words[I] | 0, Ke = ge * Pe, xe = Ke & 67108863;
            fe = fe + (Ke / 67108864 | 0) | 0, xe = xe + N | 0, N = xe & 67108863, fe = fe + (xe >>> 26) | 0, J += fe >>> 26, fe &= 67108863;
          }
          w.words[se] = N, P = fe, fe = J;
        }
        return P !== 0 ? w.words[se] = P : w.length--, w.strip();
      }
      function k(H, C, w) {
        var P = new F();
        return P.mulp(H, C, w);
      }
      d.prototype.mulTo = function(C, w) {
        var P, J = this.length + C.length;
        return this.length === 10 && C.length === 10 ? P = M(this, C, w) : J < 63 ? P = V(this, C, w) : J < 1024 ? P = G(this, C, w) : P = k(this, C, w), P;
      };
      function F(H, C) {
        this.x = H, this.y = C;
      }
      F.prototype.makeRBT = function(C) {
        for (var w = new Array(C), P = d.prototype._countBits(C) - 1, J = 0; J < C; J++)
          w[J] = this.revBin(J, P, C);
        return w;
      }, F.prototype.revBin = function(C, w, P) {
        if (C === 0 || C === P - 1)
          return C;
        for (var J = 0, se = 0; se < w; se++)
          J |= (C & 1) << w - se - 1, C >>= 1;
        return J;
      }, F.prototype.permute = function(C, w, P, J, se, fe) {
        for (var N = 0; N < fe; N++)
          J[N] = w[C[N]], se[N] = P[C[N]];
      }, F.prototype.transform = function(C, w, P, J, se, fe) {
        this.permute(fe, C, w, P, J, se);
        for (var N = 1; N < se; N <<= 1)
          for (var W = N << 1, I = Math.cos(2 * Math.PI / W), te = Math.sin(2 * Math.PI / W), ge = 0; ge < se; ge += W)
            for (var Pe = I, Ke = te, xe = 0; xe < N; xe++) {
              var ze = P[ge + xe], nt = J[ge + xe], Qt = P[ge + xe + N], Et = J[ge + xe + N], zt = Pe * Qt - Ke * Et;
              Et = Pe * Et + Ke * Qt, Qt = zt, P[ge + xe] = ze + Qt, J[ge + xe] = nt + Et, P[ge + xe + N] = ze - Qt, J[ge + xe + N] = nt - Et, xe !== W && (zt = I * Pe - te * Ke, Ke = I * Ke + te * Pe, Pe = zt);
            }
      }, F.prototype.guessLen13b = function(C, w) {
        var P = Math.max(w, C) | 1, J = P & 1, se = 0;
        for (P = P / 2 | 0; P; P = P >>> 1)
          se++;
        return 1 << se + 1 + J;
      }, F.prototype.conjugate = function(C, w, P) {
        if (!(P <= 1))
          for (var J = 0; J < P / 2; J++) {
            var se = C[J];
            C[J] = C[P - J - 1], C[P - J - 1] = se, se = w[J], w[J] = -w[P - J - 1], w[P - J - 1] = -se;
          }
      }, F.prototype.normalize13b = function(C, w) {
        for (var P = 0, J = 0; J < w / 2; J++) {
          var se = Math.round(C[2 * J + 1] / w) * 8192 + Math.round(C[2 * J] / w) + P;
          C[J] = se & 67108863, se < 67108864 ? P = 0 : P = se / 67108864 | 0;
        }
        return C;
      }, F.prototype.convert13b = function(C, w, P, J) {
        for (var se = 0, fe = 0; fe < w; fe++)
          se = se + (C[fe] | 0), P[2 * fe] = se & 8191, se = se >>> 13, P[2 * fe + 1] = se & 8191, se = se >>> 13;
        for (fe = 2 * w; fe < J; ++fe)
          P[fe] = 0;
        u(se === 0), u((se & -8192) === 0);
      }, F.prototype.stub = function(C) {
        for (var w = new Array(C), P = 0; P < C; P++)
          w[P] = 0;
        return w;
      }, F.prototype.mulp = function(C, w, P) {
        var J = 2 * this.guessLen13b(C.length, w.length), se = this.makeRBT(J), fe = this.stub(J), N = new Array(J), W = new Array(J), I = new Array(J), te = new Array(J), ge = new Array(J), Pe = new Array(J), Ke = P.words;
        Ke.length = J, this.convert13b(C.words, C.length, N, J), this.convert13b(w.words, w.length, te, J), this.transform(N, fe, W, I, J, se), this.transform(te, fe, ge, Pe, J, se);
        for (var xe = 0; xe < J; xe++) {
          var ze = W[xe] * ge[xe] - I[xe] * Pe[xe];
          I[xe] = W[xe] * Pe[xe] + I[xe] * ge[xe], W[xe] = ze;
        }
        return this.conjugate(W, I, J), this.transform(W, I, Ke, fe, J, se), this.conjugate(Ke, fe, J), this.normalize13b(Ke, J), P.negative = C.negative ^ w.negative, P.length = C.length + w.length, P.strip();
      }, d.prototype.mul = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), this.mulTo(C, w);
      }, d.prototype.mulf = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), k(this, C, w);
      }, d.prototype.imul = function(C) {
        return this.clone().mulTo(C, this);
      }, d.prototype.imuln = function(C) {
        u(typeof C == "number"), u(C < 67108864);
        for (var w = 0, P = 0; P < this.length; P++) {
          var J = (this.words[P] | 0) * C, se = (J & 67108863) + (w & 67108863);
          w >>= 26, w += J / 67108864 | 0, w += se >>> 26, this.words[P] = se & 67108863;
        }
        return w !== 0 && (this.words[P] = w, this.length++), this;
      }, d.prototype.muln = function(C) {
        return this.clone().imuln(C);
      }, d.prototype.sqr = function() {
        return this.mul(this);
      }, d.prototype.isqr = function() {
        return this.imul(this.clone());
      }, d.prototype.pow = function(C) {
        var w = y(C);
        if (w.length === 0)
          return new d(1);
        for (var P = this, J = 0; J < w.length && w[J] === 0; J++, P = P.sqr())
          ;
        if (++J < w.length)
          for (var se = P.sqr(); J < w.length; J++, se = se.sqr())
            w[J] !== 0 && (P = P.mul(se));
        return P;
      }, d.prototype.iushln = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 67108863 >>> 26 - w << 26 - w, se;
        if (w !== 0) {
          var fe = 0;
          for (se = 0; se < this.length; se++) {
            var N = this.words[se] & J, W = (this.words[se] | 0) - N << w;
            this.words[se] = W | fe, fe = N >>> 26 - w;
          }
          fe && (this.words[se] = fe, this.length++);
        }
        if (P !== 0) {
          for (se = this.length - 1; se >= 0; se--)
            this.words[se + P] = this.words[se];
          for (se = 0; se < P; se++)
            this.words[se] = 0;
          this.length += P;
        }
        return this.strip();
      }, d.prototype.ishln = function(C) {
        return u(this.negative === 0), this.iushln(C);
      }, d.prototype.iushrn = function(C, w, P) {
        u(typeof C == "number" && C >= 0);
        var J;
        w ? J = (w - w % 26) / 26 : J = 0;
        var se = C % 26, fe = Math.min((C - se) / 26, this.length), N = 67108863 ^ 67108863 >>> se << se, W = P;
        if (J -= fe, J = Math.max(0, J), W) {
          for (var I = 0; I < fe; I++)
            W.words[I] = this.words[I];
          W.length = fe;
        }
        if (fe !== 0)
          if (this.length > fe)
            for (this.length -= fe, I = 0; I < this.length; I++)
              this.words[I] = this.words[I + fe];
          else
            this.words[0] = 0, this.length = 1;
        var te = 0;
        for (I = this.length - 1; I >= 0 && (te !== 0 || I >= J); I--) {
          var ge = this.words[I] | 0;
          this.words[I] = te << 26 - se | ge >>> se, te = ge & N;
        }
        return W && te !== 0 && (W.words[W.length++] = te), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, d.prototype.ishrn = function(C, w, P) {
        return u(this.negative === 0), this.iushrn(C, w, P);
      }, d.prototype.shln = function(C) {
        return this.clone().ishln(C);
      }, d.prototype.ushln = function(C) {
        return this.clone().iushln(C);
      }, d.prototype.shrn = function(C) {
        return this.clone().ishrn(C);
      }, d.prototype.ushrn = function(C) {
        return this.clone().iushrn(C);
      }, d.prototype.testn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return !1;
        var se = this.words[P];
        return !!(se & J);
      }, d.prototype.imaskn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26;
        if (u(this.negative === 0, "imaskn works only with positive numbers"), this.length <= P)
          return this;
        if (w !== 0 && P++, this.length = Math.min(P, this.length), w !== 0) {
          var J = 67108863 ^ 67108863 >>> w << w;
          this.words[this.length - 1] &= J;
        }
        return this.strip();
      }, d.prototype.maskn = function(C) {
        return this.clone().imaskn(C);
      }, d.prototype.iaddn = function(C) {
        return u(typeof C == "number"), u(C < 67108864), C < 0 ? this.isubn(-C) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < C ? (this.words[0] = C - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(C), this.negative = 1, this) : this._iaddn(C);
      }, d.prototype._iaddn = function(C) {
        this.words[0] += C;
        for (var w = 0; w < this.length && this.words[w] >= 67108864; w++)
          this.words[w] -= 67108864, w === this.length - 1 ? this.words[w + 1] = 1 : this.words[w + 1]++;
        return this.length = Math.max(this.length, w + 1), this;
      }, d.prototype.isubn = function(C) {
        if (u(typeof C == "number"), u(C < 67108864), C < 0)
          return this.iaddn(-C);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(C), this.negative = 1, this;
        if (this.words[0] -= C, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var w = 0; w < this.length && this.words[w] < 0; w++)
            this.words[w] += 67108864, this.words[w + 1] -= 1;
        return this.strip();
      }, d.prototype.addn = function(C) {
        return this.clone().iaddn(C);
      }, d.prototype.subn = function(C) {
        return this.clone().isubn(C);
      }, d.prototype.iabs = function() {
        return this.negative = 0, this;
      }, d.prototype.abs = function() {
        return this.clone().iabs();
      }, d.prototype._ishlnsubmul = function(C, w, P) {
        var J = C.length + P, se;
        this._expand(J);
        var fe, N = 0;
        for (se = 0; se < C.length; se++) {
          fe = (this.words[se + P] | 0) + N;
          var W = (C.words[se] | 0) * w;
          fe -= W & 67108863, N = (fe >> 26) - (W / 67108864 | 0), this.words[se + P] = fe & 67108863;
        }
        for (; se < this.length - P; se++)
          fe = (this.words[se + P] | 0) + N, N = fe >> 26, this.words[se + P] = fe & 67108863;
        if (N === 0)
          return this.strip();
        for (u(N === -1), N = 0, se = 0; se < this.length; se++)
          fe = -(this.words[se] | 0) + N, N = fe >> 26, this.words[se] = fe & 67108863;
        return this.negative = 1, this.strip();
      }, d.prototype._wordDiv = function(C, w) {
        var P = this.length - C.length, J = this.clone(), se = C, fe = se.words[se.length - 1] | 0, N = this._countBits(fe);
        P = 26 - N, P !== 0 && (se = se.ushln(P), J.iushln(P), fe = se.words[se.length - 1] | 0);
        var W = J.length - se.length, I;
        if (w !== "mod") {
          I = new d(null), I.length = W + 1, I.words = new Array(I.length);
          for (var te = 0; te < I.length; te++)
            I.words[te] = 0;
        }
        var ge = J.clone()._ishlnsubmul(se, 1, W);
        ge.negative === 0 && (J = ge, I && (I.words[W] = 1));
        for (var Pe = W - 1; Pe >= 0; Pe--) {
          var Ke = (J.words[se.length + Pe] | 0) * 67108864 + (J.words[se.length + Pe - 1] | 0);
          for (Ke = Math.min(Ke / fe | 0, 67108863), J._ishlnsubmul(se, Ke, Pe); J.negative !== 0; )
            Ke--, J.negative = 0, J._ishlnsubmul(se, 1, Pe), J.isZero() || (J.negative ^= 1);
          I && (I.words[Pe] = Ke);
        }
        return I && I.strip(), J.strip(), w !== "div" && P !== 0 && J.iushrn(P), {
          div: I || null,
          mod: J
        };
      }, d.prototype.divmod = function(C, w, P) {
        if (u(!C.isZero()), this.isZero())
          return {
            div: new d(0),
            mod: new d(0)
          };
        var J, se, fe;
        return this.negative !== 0 && C.negative === 0 ? (fe = this.neg().divmod(C, w), w !== "mod" && (J = fe.div.neg()), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.iadd(C)), {
          div: J,
          mod: se
        }) : this.negative === 0 && C.negative !== 0 ? (fe = this.divmod(C.neg(), w), w !== "mod" && (J = fe.div.neg()), {
          div: J,
          mod: fe.mod
        }) : this.negative & C.negative ? (fe = this.neg().divmod(C.neg(), w), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.isub(C)), {
          div: fe.div,
          mod: se
        }) : C.length > this.length || this.cmp(C) < 0 ? {
          div: new d(0),
          mod: this
        } : C.length === 1 ? w === "div" ? {
          div: this.divn(C.words[0]),
          mod: null
        } : w === "mod" ? {
          div: null,
          mod: new d(this.modn(C.words[0]))
        } : {
          div: this.divn(C.words[0]),
          mod: new d(this.modn(C.words[0]))
        } : this._wordDiv(C, w);
      }, d.prototype.div = function(C) {
        return this.divmod(C, "div", !1).div;
      }, d.prototype.mod = function(C) {
        return this.divmod(C, "mod", !1).mod;
      }, d.prototype.umod = function(C) {
        return this.divmod(C, "mod", !0).mod;
      }, d.prototype.divRound = function(C) {
        var w = this.divmod(C);
        if (w.mod.isZero())
          return w.div;
        var P = w.div.negative !== 0 ? w.mod.isub(C) : w.mod, J = C.ushrn(1), se = C.andln(1), fe = P.cmp(J);
        return fe < 0 || se === 1 && fe === 0 ? w.div : w.div.negative !== 0 ? w.div.isubn(1) : w.div.iaddn(1);
      }, d.prototype.modn = function(C) {
        u(C <= 67108863);
        for (var w = (1 << 26) % C, P = 0, J = this.length - 1; J >= 0; J--)
          P = (w * P + (this.words[J] | 0)) % C;
        return P;
      }, d.prototype.idivn = function(C) {
        u(C <= 67108863);
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = (this.words[P] | 0) + w * 67108864;
          this.words[P] = J / C | 0, w = J % C;
        }
        return this.strip();
      }, d.prototype.divn = function(C) {
        return this.clone().idivn(C);
      }, d.prototype.egcd = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = new d(0), N = new d(1), W = 0; w.isEven() && P.isEven(); )
          w.iushrn(1), P.iushrn(1), ++W;
        for (var I = P.clone(), te = w.clone(); !w.isZero(); ) {
          for (var ge = 0, Pe = 1; !(w.words[0] & Pe) && ge < 26; ++ge, Pe <<= 1)
            ;
          if (ge > 0)
            for (w.iushrn(ge); ge-- > 0; )
              (J.isOdd() || se.isOdd()) && (J.iadd(I), se.isub(te)), J.iushrn(1), se.iushrn(1);
          for (var Ke = 0, xe = 1; !(P.words[0] & xe) && Ke < 26; ++Ke, xe <<= 1)
            ;
          if (Ke > 0)
            for (P.iushrn(Ke); Ke-- > 0; )
              (fe.isOdd() || N.isOdd()) && (fe.iadd(I), N.isub(te)), fe.iushrn(1), N.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(fe), se.isub(N)) : (P.isub(w), fe.isub(J), N.isub(se));
        }
        return {
          a: fe,
          b: N,
          gcd: P.iushln(W)
        };
      }, d.prototype._invmp = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = P.clone(); w.cmpn(1) > 0 && P.cmpn(1) > 0; ) {
          for (var N = 0, W = 1; !(w.words[0] & W) && N < 26; ++N, W <<= 1)
            ;
          if (N > 0)
            for (w.iushrn(N); N-- > 0; )
              J.isOdd() && J.iadd(fe), J.iushrn(1);
          for (var I = 0, te = 1; !(P.words[0] & te) && I < 26; ++I, te <<= 1)
            ;
          if (I > 0)
            for (P.iushrn(I); I-- > 0; )
              se.isOdd() && se.iadd(fe), se.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(se)) : (P.isub(w), se.isub(J));
        }
        var ge;
        return w.cmpn(1) === 0 ? ge = J : ge = se, ge.cmpn(0) < 0 && ge.iadd(C), ge;
      }, d.prototype.gcd = function(C) {
        if (this.isZero())
          return C.abs();
        if (C.isZero())
          return this.abs();
        var w = this.clone(), P = C.clone();
        w.negative = 0, P.negative = 0;
        for (var J = 0; w.isEven() && P.isEven(); J++)
          w.iushrn(1), P.iushrn(1);
        do {
          for (; w.isEven(); )
            w.iushrn(1);
          for (; P.isEven(); )
            P.iushrn(1);
          var se = w.cmp(P);
          if (se < 0) {
            var fe = w;
            w = P, P = fe;
          } else if (se === 0 || P.cmpn(1) === 0)
            break;
          w.isub(P);
        } while (!0);
        return P.iushln(J);
      }, d.prototype.invm = function(C) {
        return this.egcd(C).a.umod(C);
      }, d.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, d.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, d.prototype.andln = function(C) {
        return this.words[0] & C;
      }, d.prototype.bincn = function(C) {
        u(typeof C == "number");
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return this._expand(P + 1), this.words[P] |= J, this;
        for (var se = J, fe = P; se !== 0 && fe < this.length; fe++) {
          var N = this.words[fe] | 0;
          N += se, se = N >>> 26, N &= 67108863, this.words[fe] = N;
        }
        return se !== 0 && (this.words[fe] = se, this.length++), this;
      }, d.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, d.prototype.cmpn = function(C) {
        var w = C < 0;
        if (this.negative !== 0 && !w)
          return -1;
        if (this.negative === 0 && w)
          return 1;
        this.strip();
        var P;
        if (this.length > 1)
          P = 1;
        else {
          w && (C = -C), u(C <= 67108863, "Number is too big");
          var J = this.words[0] | 0;
          P = J === C ? 0 : J < C ? -1 : 1;
        }
        return this.negative !== 0 ? -P | 0 : P;
      }, d.prototype.cmp = function(C) {
        if (this.negative !== 0 && C.negative === 0)
          return -1;
        if (this.negative === 0 && C.negative !== 0)
          return 1;
        var w = this.ucmp(C);
        return this.negative !== 0 ? -w | 0 : w;
      }, d.prototype.ucmp = function(C) {
        if (this.length > C.length)
          return 1;
        if (this.length < C.length)
          return -1;
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = this.words[P] | 0, se = C.words[P] | 0;
          if (J !== se) {
            J < se ? w = -1 : J > se && (w = 1);
            break;
          }
        }
        return w;
      }, d.prototype.gtn = function(C) {
        return this.cmpn(C) === 1;
      }, d.prototype.gt = function(C) {
        return this.cmp(C) === 1;
      }, d.prototype.gten = function(C) {
        return this.cmpn(C) >= 0;
      }, d.prototype.gte = function(C) {
        return this.cmp(C) >= 0;
      }, d.prototype.ltn = function(C) {
        return this.cmpn(C) === -1;
      }, d.prototype.lt = function(C) {
        return this.cmp(C) === -1;
      }, d.prototype.lten = function(C) {
        return this.cmpn(C) <= 0;
      }, d.prototype.lte = function(C) {
        return this.cmp(C) <= 0;
      }, d.prototype.eqn = function(C) {
        return this.cmpn(C) === 0;
      }, d.prototype.eq = function(C) {
        return this.cmp(C) === 0;
      }, d.red = function(C) {
        return new oe(C);
      }, d.prototype.toRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), u(this.negative === 0, "red works only with positives"), C.convertTo(this)._forceRed(C);
      }, d.prototype.fromRed = function() {
        return u(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, d.prototype._forceRed = function(C) {
        return this.red = C, this;
      }, d.prototype.forceRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), this._forceRed(C);
      }, d.prototype.redAdd = function(C) {
        return u(this.red, "redAdd works only with red numbers"), this.red.add(this, C);
      }, d.prototype.redIAdd = function(C) {
        return u(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, C);
      }, d.prototype.redSub = function(C) {
        return u(this.red, "redSub works only with red numbers"), this.red.sub(this, C);
      }, d.prototype.redISub = function(C) {
        return u(this.red, "redISub works only with red numbers"), this.red.isub(this, C);
      }, d.prototype.redShl = function(C) {
        return u(this.red, "redShl works only with red numbers"), this.red.shl(this, C);
      }, d.prototype.redMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.mul(this, C);
      }, d.prototype.redIMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.imul(this, C);
      }, d.prototype.redSqr = function() {
        return u(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, d.prototype.redISqr = function() {
        return u(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, d.prototype.redSqrt = function() {
        return u(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, d.prototype.redInvm = function() {
        return u(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, d.prototype.redNeg = function() {
        return u(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, d.prototype.redPow = function(C) {
        return u(this.red && !C.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, C);
      };
      var X = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function ee(H, C) {
        this.name = H, this.p = new d(C, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      ee.prototype._tmp = function() {
        var C = new d(null);
        return C.words = new Array(Math.ceil(this.n / 13)), C;
      }, ee.prototype.ireduce = function(C) {
        var w = C, P;
        do
          this.split(w, this.tmp), w = this.imulK(w), w = w.iadd(this.tmp), P = w.bitLength();
        while (P > this.n);
        var J = P < this.n ? -1 : w.ucmp(this.p);
        return J === 0 ? (w.words[0] = 0, w.length = 1) : J > 0 ? w.isub(this.p) : w.strip !== void 0 ? w.strip() : w._strip(), w;
      }, ee.prototype.split = function(C, w) {
        C.iushrn(this.n, 0, w);
      }, ee.prototype.imulK = function(C) {
        return C.imul(this.k);
      };
      function ue() {
        ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(ue, ee), ue.prototype.split = function(C, w) {
        for (var P = 4194303, J = Math.min(C.length, 9), se = 0; se < J; se++)
          w.words[se] = C.words[se];
        if (w.length = J, C.length <= 9) {
          C.words[0] = 0, C.length = 1;
          return;
        }
        var fe = C.words[9];
        for (w.words[w.length++] = fe & P, se = 10; se < C.length; se++) {
          var N = C.words[se] | 0;
          C.words[se - 10] = (N & P) << 4 | fe >>> 22, fe = N;
        }
        fe >>>= 22, C.words[se - 10] = fe, fe === 0 && C.length > 10 ? C.length -= 10 : C.length -= 9;
      }, ue.prototype.imulK = function(C) {
        C.words[C.length] = 0, C.words[C.length + 1] = 0, C.length += 2;
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = C.words[P] | 0;
          w += J * 977, C.words[P] = w & 67108863, w = J * 64 + (w / 67108864 | 0);
        }
        return C.words[C.length - 1] === 0 && (C.length--, C.words[C.length - 1] === 0 && C.length--), C;
      };
      function Q() {
        ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(Q, ee);
      function Y() {
        ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(Y, ee);
      function pe() {
        ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(pe, ee), pe.prototype.imulK = function(C) {
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = (C.words[P] | 0) * 19 + w, se = J & 67108863;
          J >>>= 26, C.words[P] = se, w = J;
        }
        return w !== 0 && (C.words[C.length++] = w), C;
      }, d._prime = function(C) {
        if (X[C])
          return X[C];
        var w;
        if (C === "k256")
          w = new ue();
        else if (C === "p224")
          w = new Q();
        else if (C === "p192")
          w = new Y();
        else if (C === "p25519")
          w = new pe();
        else
          throw new Error("Unknown prime " + C);
        return X[C] = w, w;
      };
      function oe(H) {
        if (typeof H == "string") {
          var C = d._prime(H);
          this.m = C.p, this.prime = C;
        } else
          u(H.gtn(1), "modulus must be greater than 1"), this.m = H, this.prime = null;
      }
      oe.prototype._verify1 = function(C) {
        u(C.negative === 0, "red works only with positives"), u(C.red, "red works only with red numbers");
      }, oe.prototype._verify2 = function(C, w) {
        u((C.negative | w.negative) === 0, "red works only with positives"), u(
          C.red && C.red === w.red,
          "red works only with red numbers"
        );
      }, oe.prototype.imod = function(C) {
        return this.prime ? this.prime.ireduce(C)._forceRed(this) : C.umod(this.m)._forceRed(this);
      }, oe.prototype.neg = function(C) {
        return C.isZero() ? C.clone() : this.m.sub(C)._forceRed(this);
      }, oe.prototype.add = function(C, w) {
        this._verify2(C, w);
        var P = C.add(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P._forceRed(this);
      }, oe.prototype.iadd = function(C, w) {
        this._verify2(C, w);
        var P = C.iadd(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P;
      }, oe.prototype.sub = function(C, w) {
        this._verify2(C, w);
        var P = C.sub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P._forceRed(this);
      }, oe.prototype.isub = function(C, w) {
        this._verify2(C, w);
        var P = C.isub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P;
      }, oe.prototype.shl = function(C, w) {
        return this._verify1(C), this.imod(C.ushln(w));
      }, oe.prototype.imul = function(C, w) {
        return this._verify2(C, w), this.imod(C.imul(w));
      }, oe.prototype.mul = function(C, w) {
        return this._verify2(C, w), this.imod(C.mul(w));
      }, oe.prototype.isqr = function(C) {
        return this.imul(C, C.clone());
      }, oe.prototype.sqr = function(C) {
        return this.mul(C, C);
      }, oe.prototype.sqrt = function(C) {
        if (C.isZero())
          return C.clone();
        var w = this.m.andln(3);
        if (u(w % 2 === 1), w === 3) {
          var P = this.m.add(new d(1)).iushrn(2);
          return this.pow(C, P);
        }
        for (var J = this.m.subn(1), se = 0; !J.isZero() && J.andln(1) === 0; )
          se++, J.iushrn(1);
        u(!J.isZero());
        var fe = new d(1).toRed(this), N = fe.redNeg(), W = this.m.subn(1).iushrn(1), I = this.m.bitLength();
        for (I = new d(2 * I * I).toRed(this); this.pow(I, W).cmp(N) !== 0; )
          I.redIAdd(N);
        for (var te = this.pow(I, J), ge = this.pow(C, J.addn(1).iushrn(1)), Pe = this.pow(C, J), Ke = se; Pe.cmp(fe) !== 0; ) {
          for (var xe = Pe, ze = 0; xe.cmp(fe) !== 0; ze++)
            xe = xe.redSqr();
          u(ze < Ke);
          var nt = this.pow(te, new d(1).iushln(Ke - ze - 1));
          ge = ge.redMul(nt), te = nt.redSqr(), Pe = Pe.redMul(te), Ke = ze;
        }
        return ge;
      }, oe.prototype.invm = function(C) {
        var w = C._invmp(this.m);
        return w.negative !== 0 ? (w.negative = 0, this.imod(w).redNeg()) : this.imod(w);
      }, oe.prototype.pow = function(C, w) {
        if (w.isZero())
          return new d(1).toRed(this);
        if (w.cmpn(1) === 0)
          return C.clone();
        var P = 4, J = new Array(1 << P);
        J[0] = new d(1).toRed(this), J[1] = C;
        for (var se = 2; se < J.length; se++)
          J[se] = this.mul(J[se - 1], C);
        var fe = J[0], N = 0, W = 0, I = w.bitLength() % 26;
        for (I === 0 && (I = 26), se = w.length - 1; se >= 0; se--) {
          for (var te = w.words[se], ge = I - 1; ge >= 0; ge--) {
            var Pe = te >> ge & 1;
            if (fe !== J[0] && (fe = this.sqr(fe)), Pe === 0 && N === 0) {
              W = 0;
              continue;
            }
            N <<= 1, N |= Pe, W++, !(W !== P && (se !== 0 || ge !== 0)) && (fe = this.mul(fe, J[N]), W = 0, N = 0);
          }
          I = 26;
        }
        return fe;
      }, oe.prototype.convertTo = function(C) {
        var w = C.umod(this.m);
        return w === C ? w.clone() : w;
      }, oe.prototype.convertFrom = function(C) {
        var w = C.clone();
        return w.red = null, w;
      }, d.mont = function(C) {
        return new ne(C);
      };
      function ne(H) {
        oe.call(this, H), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(ne, oe), ne.prototype.convertTo = function(C) {
        return this.imod(C.ushln(this.shift));
      }, ne.prototype.convertFrom = function(C) {
        var w = this.imod(C.mul(this.rinv));
        return w.red = null, w;
      }, ne.prototype.imul = function(C, w) {
        if (C.isZero() || w.isZero())
          return C.words[0] = 0, C.length = 1, C;
        var P = C.imul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.mul = function(C, w) {
        if (C.isZero() || w.isZero())
          return new d(0)._forceRed(this);
        var P = C.mul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.invm = function(C) {
        var w = this.imod(C._invmp(this.m).mul(this.r2));
        return w._forceRed(this);
      };
    })(e, commonjsGlobal);
  }(bn$1)), bn$1.exports;
}
var browser$4, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2)
    return browser$4;
  hasRequiredBrowser$2 = 1;
  var e = requireElliptic(), n = requireBn$1();
  browser$4 = function(m) {
    return new u(m);
  };
  var o = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  o.p224 = o.secp224r1, o.p256 = o.secp256r1 = o.prime256v1, o.p192 = o.secp192r1 = o.prime192v1, o.p384 = o.secp384r1, o.p521 = o.secp521r1;
  function u(d) {
    this.curveType = o[d], this.curveType || (this.curveType = {
      name: d
    }), this.curve = new e.ec(this.curveType.name), this.keys = void 0;
  }
  u.prototype.generateKeys = function(d, m) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(d, m);
  }, u.prototype.computeSecret = function(d, m, v) {
    m = m || "utf8", Buffer.isBuffer(d) || (d = new Buffer(d, m));
    var S = this.curve.keyFromPublic(d).getPublic(), $ = S.mul(this.keys.getPrivate()).getX();
    return c($, v, this.curveType.byteLength);
  }, u.prototype.getPublicKey = function(d, m) {
    var v = this.keys.getPublic(m === "compressed", !0);
    return m === "hybrid" && (v[v.length - 1] % 2 ? v[0] = 7 : v[0] = 6), c(v, d);
  }, u.prototype.getPrivateKey = function(d) {
    return c(this.keys.getPrivate(), d);
  }, u.prototype.setPublicKey = function(d, m) {
    return m = m || "utf8", Buffer.isBuffer(d) || (d = new Buffer(d, m)), this.keys._importPublic(d), this;
  }, u.prototype.setPrivateKey = function(d, m) {
    m = m || "utf8", Buffer.isBuffer(d) || (d = new Buffer(d, m));
    var v = new n(d);
    return v = v.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(v), this;
  };
  function c(d, m, v) {
    Array.isArray(d) || (d = d.toArray());
    var S = new Buffer(d);
    if (v && S.length < v) {
      var $ = new Buffer(v - S.length);
      $.fill(0), S = Buffer.concat([$, S]);
    }
    return m ? S.toString(m) : S;
  }
  return browser$4;
}
var browser$3 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf)
    return mgf;
  hasRequiredMgf = 1;
  var e = requireBrowser$9(), n = requireSafeBuffer().Buffer;
  mgf = function(u, c) {
    for (var d = n.alloc(0), m = 0, v; d.length < c; )
      v = o(m++), d = n.concat([d, e("sha1").update(u).update(v).digest()]);
    return d.slice(0, c);
  };
  function o(u) {
    var c = n.allocUnsafe(4);
    return c.writeUInt32BE(u, 0), c;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(n, o) {
    for (var u = n.length, c = -1; ++c < u; )
      n[c] ^= o[c];
    return n;
  }), xor;
}
var bn = { exports: {} };
bn.exports;
var hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(e) {
    (function(n, o) {
      function u(H, C) {
        if (!H)
          throw new Error(C || "Assertion failed");
      }
      function c(H, C) {
        H.super_ = C;
        var w = function() {
        };
        w.prototype = C.prototype, H.prototype = new w(), H.prototype.constructor = H;
      }
      function d(H, C, w) {
        if (d.isBN(H))
          return H;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, H !== null && ((C === "le" || C === "be") && (w = C, C = 10), this._init(H || 0, C || 10, w || "be"));
      }
      typeof n == "object" ? n.exports = d : o.BN = d, d.BN = d, d.wordSize = 26;
      var m;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = require$$0$3.Buffer;
      } catch {
      }
      d.isBN = function(C) {
        return C instanceof d ? !0 : C !== null && typeof C == "object" && C.constructor.wordSize === d.wordSize && Array.isArray(C.words);
      }, d.max = function(C, w) {
        return C.cmp(w) > 0 ? C : w;
      }, d.min = function(C, w) {
        return C.cmp(w) < 0 ? C : w;
      }, d.prototype._init = function(C, w, P) {
        if (typeof C == "number")
          return this._initNumber(C, w, P);
        if (typeof C == "object")
          return this._initArray(C, w, P);
        w === "hex" && (w = 16), u(w === (w | 0) && w >= 2 && w <= 36), C = C.toString().replace(/\s+/g, "");
        var J = 0;
        C[0] === "-" && (J++, this.negative = 1), J < C.length && (w === 16 ? this._parseHex(C, J, P) : (this._parseBase(C, w, J), P === "le" && this._initArray(this.toArray(), w, P)));
      }, d.prototype._initNumber = function(C, w, P) {
        C < 0 && (this.negative = 1, C = -C), C < 67108864 ? (this.words = [C & 67108863], this.length = 1) : C < 4503599627370496 ? (this.words = [
          C & 67108863,
          C / 67108864 & 67108863
        ], this.length = 2) : (u(C < 9007199254740992), this.words = [
          C & 67108863,
          C / 67108864 & 67108863,
          1
        ], this.length = 3), P === "le" && this._initArray(this.toArray(), w, P);
      }, d.prototype._initArray = function(C, w, P) {
        if (u(typeof C.length == "number"), C.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(C.length / 3), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se, fe, N = 0;
        if (P === "be")
          for (J = C.length - 1, se = 0; J >= 0; J -= 3)
            fe = C[J] | C[J - 1] << 8 | C[J - 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        else if (P === "le")
          for (J = 0, se = 0; J < C.length; J += 3)
            fe = C[J] | C[J + 1] << 8 | C[J + 2] << 16, this.words[se] |= fe << N & 67108863, this.words[se + 1] = fe >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, se++);
        return this.strip();
      };
      function v(H, C) {
        var w = H.charCodeAt(C);
        return w >= 65 && w <= 70 ? w - 55 : w >= 97 && w <= 102 ? w - 87 : w - 48 & 15;
      }
      function S(H, C, w) {
        var P = v(H, w);
        return w - 1 >= C && (P |= v(H, w - 1) << 4), P;
      }
      d.prototype._parseHex = function(C, w, P) {
        this.length = Math.ceil((C.length - w) / 6), this.words = new Array(this.length);
        for (var J = 0; J < this.length; J++)
          this.words[J] = 0;
        var se = 0, fe = 0, N;
        if (P === "be")
          for (J = C.length - 1; J >= w; J -= 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        else {
          var W = C.length - w;
          for (J = W % 2 === 0 ? w + 1 : w; J < C.length; J += 2)
            N = S(C, w, J) << se, this.words[fe] |= N & 67108863, se >= 18 ? (se -= 18, fe += 1, this.words[fe] |= N >>> 26) : se += 8;
        }
        this.strip();
      };
      function $(H, C, w, P) {
        for (var J = 0, se = Math.min(H.length, w), fe = C; fe < se; fe++) {
          var N = H.charCodeAt(fe) - 48;
          J *= P, N >= 49 ? J += N - 49 + 10 : N >= 17 ? J += N - 17 + 10 : J += N;
        }
        return J;
      }
      d.prototype._parseBase = function(C, w, P) {
        this.words = [0], this.length = 1;
        for (var J = 0, se = 1; se <= 67108863; se *= w)
          J++;
        J--, se = se / w | 0;
        for (var fe = C.length - P, N = fe % J, W = Math.min(fe, fe - N) + P, I = 0, te = P; te < W; te += J)
          I = $(C, te, te + J, w), this.imuln(se), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        if (N !== 0) {
          var ge = 1;
          for (I = $(C, te, C.length, w), te = 0; te < N; te++)
            ge *= w;
          this.imuln(ge), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        }
        this.strip();
      }, d.prototype.copy = function(C) {
        C.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          C.words[w] = this.words[w];
        C.length = this.length, C.negative = this.negative, C.red = this.red;
      }, d.prototype.clone = function() {
        var C = new d(null);
        return this.copy(C), C;
      }, d.prototype._expand = function(C) {
        for (; this.length < C; )
          this.words[this.length++] = 0;
        return this;
      }, d.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, d.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, d.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var E = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], O = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], T = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      d.prototype.toString = function(C, w) {
        C = C || 10, w = w | 0 || 1;
        var P;
        if (C === 16 || C === "hex") {
          P = "";
          for (var J = 0, se = 0, fe = 0; fe < this.length; fe++) {
            var N = this.words[fe], W = ((N << J | se) & 16777215).toString(16);
            se = N >>> 24 - J & 16777215, se !== 0 || fe !== this.length - 1 ? P = E[6 - W.length] + W + P : P = W + P, J += 2, J >= 26 && (J -= 26, fe--);
          }
          for (se !== 0 && (P = se.toString(16) + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        if (C === (C | 0) && C >= 2 && C <= 36) {
          var I = O[C], te = T[C];
          P = "";
          var ge = this.clone();
          for (ge.negative = 0; !ge.isZero(); ) {
            var Pe = ge.modn(te).toString(C);
            ge = ge.idivn(te), ge.isZero() ? P = Pe + P : P = E[I - Pe.length] + Pe + P;
          }
          for (this.isZero() && (P = "0" + P); P.length % w !== 0; )
            P = "0" + P;
          return this.negative !== 0 && (P = "-" + P), P;
        }
        u(!1, "Base should be between 2 and 36");
      }, d.prototype.toNumber = function() {
        var C = this.words[0];
        return this.length === 2 ? C += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? C += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && u(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -C : C;
      }, d.prototype.toJSON = function() {
        return this.toString(16);
      }, d.prototype.toBuffer = function(C, w) {
        return u(typeof m < "u"), this.toArrayLike(m, C, w);
      }, d.prototype.toArray = function(C, w) {
        return this.toArrayLike(Array, C, w);
      }, d.prototype.toArrayLike = function(C, w, P) {
        var J = this.byteLength(), se = P || Math.max(1, J);
        u(J <= se, "byte array longer than desired length"), u(se > 0, "Requested array length <= 0"), this.strip();
        var fe = w === "le", N = new C(se), W, I, te = this.clone();
        if (fe) {
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[I] = W;
          for (; I < se; I++)
            N[I] = 0;
        } else {
          for (I = 0; I < se - J; I++)
            N[I] = 0;
          for (I = 0; !te.isZero(); I++)
            W = te.andln(255), te.iushrn(8), N[se - I - 1] = W;
        }
        return N;
      }, Math.clz32 ? d.prototype._countBits = function(C) {
        return 32 - Math.clz32(C);
      } : d.prototype._countBits = function(C) {
        var w = C, P = 0;
        return w >= 4096 && (P += 13, w >>>= 13), w >= 64 && (P += 7, w >>>= 7), w >= 8 && (P += 4, w >>>= 4), w >= 2 && (P += 2, w >>>= 2), P + w;
      }, d.prototype._zeroBits = function(C) {
        if (C === 0)
          return 26;
        var w = C, P = 0;
        return w & 8191 || (P += 13, w >>>= 13), w & 127 || (P += 7, w >>>= 7), w & 15 || (P += 4, w >>>= 4), w & 3 || (P += 2, w >>>= 2), w & 1 || P++, P;
      }, d.prototype.bitLength = function() {
        var C = this.words[this.length - 1], w = this._countBits(C);
        return (this.length - 1) * 26 + w;
      };
      function y(H) {
        for (var C = new Array(H.bitLength()), w = 0; w < C.length; w++) {
          var P = w / 26 | 0, J = w % 26;
          C[w] = (H.words[P] & 1 << J) >>> J;
        }
        return C;
      }
      d.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var C = 0, w = 0; w < this.length; w++) {
          var P = this._zeroBits(this.words[w]);
          if (C += P, P !== 26)
            break;
        }
        return C;
      }, d.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, d.prototype.toTwos = function(C) {
        return this.negative !== 0 ? this.abs().inotn(C).iaddn(1) : this.clone();
      }, d.prototype.fromTwos = function(C) {
        return this.testn(C - 1) ? this.notn(C).iaddn(1).ineg() : this.clone();
      }, d.prototype.isNeg = function() {
        return this.negative !== 0;
      }, d.prototype.neg = function() {
        return this.clone().ineg();
      }, d.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, d.prototype.iuor = function(C) {
        for (; this.length < C.length; )
          this.words[this.length++] = 0;
        for (var w = 0; w < C.length; w++)
          this.words[w] = this.words[w] | C.words[w];
        return this.strip();
      }, d.prototype.ior = function(C) {
        return u((this.negative | C.negative) === 0), this.iuor(C);
      }, d.prototype.or = function(C) {
        return this.length > C.length ? this.clone().ior(C) : C.clone().ior(this);
      }, d.prototype.uor = function(C) {
        return this.length > C.length ? this.clone().iuor(C) : C.clone().iuor(this);
      }, d.prototype.iuand = function(C) {
        var w;
        this.length > C.length ? w = C : w = this;
        for (var P = 0; P < w.length; P++)
          this.words[P] = this.words[P] & C.words[P];
        return this.length = w.length, this.strip();
      }, d.prototype.iand = function(C) {
        return u((this.negative | C.negative) === 0), this.iuand(C);
      }, d.prototype.and = function(C) {
        return this.length > C.length ? this.clone().iand(C) : C.clone().iand(this);
      }, d.prototype.uand = function(C) {
        return this.length > C.length ? this.clone().iuand(C) : C.clone().iuand(this);
      }, d.prototype.iuxor = function(C) {
        var w, P;
        this.length > C.length ? (w = this, P = C) : (w = C, P = this);
        for (var J = 0; J < P.length; J++)
          this.words[J] = w.words[J] ^ P.words[J];
        if (this !== w)
          for (; J < w.length; J++)
            this.words[J] = w.words[J];
        return this.length = w.length, this.strip();
      }, d.prototype.ixor = function(C) {
        return u((this.negative | C.negative) === 0), this.iuxor(C);
      }, d.prototype.xor = function(C) {
        return this.length > C.length ? this.clone().ixor(C) : C.clone().ixor(this);
      }, d.prototype.uxor = function(C) {
        return this.length > C.length ? this.clone().iuxor(C) : C.clone().iuxor(this);
      }, d.prototype.inotn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = Math.ceil(C / 26) | 0, P = C % 26;
        this._expand(w), P > 0 && w--;
        for (var J = 0; J < w; J++)
          this.words[J] = ~this.words[J] & 67108863;
        return P > 0 && (this.words[J] = ~this.words[J] & 67108863 >> 26 - P), this.strip();
      }, d.prototype.notn = function(C) {
        return this.clone().inotn(C);
      }, d.prototype.setn = function(C, w) {
        u(typeof C == "number" && C >= 0);
        var P = C / 26 | 0, J = C % 26;
        return this._expand(P + 1), w ? this.words[P] = this.words[P] | 1 << J : this.words[P] = this.words[P] & ~(1 << J), this.strip();
      }, d.prototype.iadd = function(C) {
        var w;
        if (this.negative !== 0 && C.negative === 0)
          return this.negative = 0, w = this.isub(C), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && C.negative !== 0)
          return C.negative = 0, w = this.isub(C), C.negative = 1, w._normSign();
        var P, J;
        this.length > C.length ? (P = this, J = C) : (P = C, J = this);
        for (var se = 0, fe = 0; fe < J.length; fe++)
          w = (P.words[fe] | 0) + (J.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        for (; se !== 0 && fe < P.length; fe++)
          w = (P.words[fe] | 0) + se, this.words[fe] = w & 67108863, se = w >>> 26;
        if (this.length = P.length, se !== 0)
          this.words[this.length] = se, this.length++;
        else if (P !== this)
          for (; fe < P.length; fe++)
            this.words[fe] = P.words[fe];
        return this;
      }, d.prototype.add = function(C) {
        var w;
        return C.negative !== 0 && this.negative === 0 ? (C.negative = 0, w = this.sub(C), C.negative ^= 1, w) : C.negative === 0 && this.negative !== 0 ? (this.negative = 0, w = C.sub(this), this.negative = 1, w) : this.length > C.length ? this.clone().iadd(C) : C.clone().iadd(this);
      }, d.prototype.isub = function(C) {
        if (C.negative !== 0) {
          C.negative = 0;
          var w = this.iadd(C);
          return C.negative = 1, w._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(C), this.negative = 1, this._normSign();
        var P = this.cmp(C);
        if (P === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var J, se;
        P > 0 ? (J = this, se = C) : (J = C, se = this);
        for (var fe = 0, N = 0; N < se.length; N++)
          w = (J.words[N] | 0) - (se.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        for (; fe !== 0 && N < J.length; N++)
          w = (J.words[N] | 0) + fe, fe = w >> 26, this.words[N] = w & 67108863;
        if (fe === 0 && N < J.length && J !== this)
          for (; N < J.length; N++)
            this.words[N] = J.words[N];
        return this.length = Math.max(this.length, N), J !== this && (this.negative = 1), this.strip();
      }, d.prototype.sub = function(C) {
        return this.clone().isub(C);
      };
      function V(H, C, w) {
        w.negative = C.negative ^ H.negative;
        var P = H.length + C.length | 0;
        w.length = P, P = P - 1 | 0;
        var J = H.words[0] | 0, se = C.words[0] | 0, fe = J * se, N = fe & 67108863, W = fe / 67108864 | 0;
        w.words[0] = N;
        for (var I = 1; I < P; I++) {
          for (var te = W >>> 26, ge = W & 67108863, Pe = Math.min(I, C.length - 1), Ke = Math.max(0, I - H.length + 1); Ke <= Pe; Ke++) {
            var xe = I - Ke | 0;
            J = H.words[xe] | 0, se = C.words[Ke] | 0, fe = J * se + ge, te += fe / 67108864 | 0, ge = fe & 67108863;
          }
          w.words[I] = ge | 0, W = te | 0;
        }
        return W !== 0 ? w.words[I] = W | 0 : w.length--, w.strip();
      }
      var M = function(C, w, P) {
        var J = C.words, se = w.words, fe = P.words, N = 0, W, I, te, ge = J[0] | 0, Pe = ge & 8191, Ke = ge >>> 13, xe = J[1] | 0, ze = xe & 8191, nt = xe >>> 13, Qt = J[2] | 0, Et = Qt & 8191, zt = Qt >>> 13, Nt = J[3] | 0, pt = Nt & 8191, at = Nt >>> 13, kt = J[4] | 0, Ut = kt & 8191, dn = kt >>> 13, En = J[5] | 0, Ht = En & 8191, Xt = En >>> 13, On = J[6] | 0, sn = On & 8191, At = On >>> 13, hn = J[7] | 0, $t = hn & 8191, Lt = hn >>> 13, Qn = J[8] | 0, ce = Qn & 8191, Ze = Qn >>> 13, ft = J[9] | 0, It = ft & 8191, rn = ft >>> 13, Ln = se[0] | 0, Pn = Ln & 8191, Ae = Ln >>> 13, Me = se[1] | 0, He = Me & 8191, cn = Me >>> 13, Wt = se[2] | 0, yn = Wt & 8191, pr = Wt >>> 13, Uo = se[3] | 0, ar = Uo & 8191, Sr = Uo >>> 13, Jo = se[4] | 0, fr = Jo & 8191, Er = Jo >>> 13, vo = se[5] | 0, lr = vo & 8191, $r = vo >>> 13, Wo = se[6] | 0, yr = Wo & 8191, Dr = Wo >>> 13, Zo = se[7] | 0, dr = Zo & 8191, Br = Zo >>> 13, Qo = se[8] | 0, tr = Qo & 8191, Mr = Qo >>> 13, qo = se[9] | 0, hr = qo & 8191, Or = qo >>> 13;
        P.negative = C.negative ^ w.negative, P.length = 19, W = Math.imul(Pe, Pn), I = Math.imul(Pe, Ae), I = I + Math.imul(Ke, Pn) | 0, te = Math.imul(Ke, Ae);
        var Fo = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fo >>> 26) | 0, Fo &= 67108863, W = Math.imul(ze, Pn), I = Math.imul(ze, Ae), I = I + Math.imul(nt, Pn) | 0, te = Math.imul(nt, Ae), W = W + Math.imul(Pe, He) | 0, I = I + Math.imul(Pe, cn) | 0, I = I + Math.imul(Ke, He) | 0, te = te + Math.imul(Ke, cn) | 0;
        var No = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, W = Math.imul(Et, Pn), I = Math.imul(Et, Ae), I = I + Math.imul(zt, Pn) | 0, te = Math.imul(zt, Ae), W = W + Math.imul(ze, He) | 0, I = I + Math.imul(ze, cn) | 0, I = I + Math.imul(nt, He) | 0, te = te + Math.imul(nt, cn) | 0, W = W + Math.imul(Pe, yn) | 0, I = I + Math.imul(Pe, pr) | 0, I = I + Math.imul(Ke, yn) | 0, te = te + Math.imul(Ke, pr) | 0;
        var di = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (di >>> 26) | 0, di &= 67108863, W = Math.imul(pt, Pn), I = Math.imul(pt, Ae), I = I + Math.imul(at, Pn) | 0, te = Math.imul(at, Ae), W = W + Math.imul(Et, He) | 0, I = I + Math.imul(Et, cn) | 0, I = I + Math.imul(zt, He) | 0, te = te + Math.imul(zt, cn) | 0, W = W + Math.imul(ze, yn) | 0, I = I + Math.imul(ze, pr) | 0, I = I + Math.imul(nt, yn) | 0, te = te + Math.imul(nt, pr) | 0, W = W + Math.imul(Pe, ar) | 0, I = I + Math.imul(Pe, Sr) | 0, I = I + Math.imul(Ke, ar) | 0, te = te + Math.imul(Ke, Sr) | 0;
        var gi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, W = Math.imul(Ut, Pn), I = Math.imul(Ut, Ae), I = I + Math.imul(dn, Pn) | 0, te = Math.imul(dn, Ae), W = W + Math.imul(pt, He) | 0, I = I + Math.imul(pt, cn) | 0, I = I + Math.imul(at, He) | 0, te = te + Math.imul(at, cn) | 0, W = W + Math.imul(Et, yn) | 0, I = I + Math.imul(Et, pr) | 0, I = I + Math.imul(zt, yn) | 0, te = te + Math.imul(zt, pr) | 0, W = W + Math.imul(ze, ar) | 0, I = I + Math.imul(ze, Sr) | 0, I = I + Math.imul(nt, ar) | 0, te = te + Math.imul(nt, Sr) | 0, W = W + Math.imul(Pe, fr) | 0, I = I + Math.imul(Pe, Er) | 0, I = I + Math.imul(Ke, fr) | 0, te = te + Math.imul(Ke, Er) | 0;
        var ai = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, W = Math.imul(Ht, Pn), I = Math.imul(Ht, Ae), I = I + Math.imul(Xt, Pn) | 0, te = Math.imul(Xt, Ae), W = W + Math.imul(Ut, He) | 0, I = I + Math.imul(Ut, cn) | 0, I = I + Math.imul(dn, He) | 0, te = te + Math.imul(dn, cn) | 0, W = W + Math.imul(pt, yn) | 0, I = I + Math.imul(pt, pr) | 0, I = I + Math.imul(at, yn) | 0, te = te + Math.imul(at, pr) | 0, W = W + Math.imul(Et, ar) | 0, I = I + Math.imul(Et, Sr) | 0, I = I + Math.imul(zt, ar) | 0, te = te + Math.imul(zt, Sr) | 0, W = W + Math.imul(ze, fr) | 0, I = I + Math.imul(ze, Er) | 0, I = I + Math.imul(nt, fr) | 0, te = te + Math.imul(nt, Er) | 0, W = W + Math.imul(Pe, lr) | 0, I = I + Math.imul(Pe, $r) | 0, I = I + Math.imul(Ke, lr) | 0, te = te + Math.imul(Ke, $r) | 0;
        var ui = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, W = Math.imul(sn, Pn), I = Math.imul(sn, Ae), I = I + Math.imul(At, Pn) | 0, te = Math.imul(At, Ae), W = W + Math.imul(Ht, He) | 0, I = I + Math.imul(Ht, cn) | 0, I = I + Math.imul(Xt, He) | 0, te = te + Math.imul(Xt, cn) | 0, W = W + Math.imul(Ut, yn) | 0, I = I + Math.imul(Ut, pr) | 0, I = I + Math.imul(dn, yn) | 0, te = te + Math.imul(dn, pr) | 0, W = W + Math.imul(pt, ar) | 0, I = I + Math.imul(pt, Sr) | 0, I = I + Math.imul(at, ar) | 0, te = te + Math.imul(at, Sr) | 0, W = W + Math.imul(Et, fr) | 0, I = I + Math.imul(Et, Er) | 0, I = I + Math.imul(zt, fr) | 0, te = te + Math.imul(zt, Er) | 0, W = W + Math.imul(ze, lr) | 0, I = I + Math.imul(ze, $r) | 0, I = I + Math.imul(nt, lr) | 0, te = te + Math.imul(nt, $r) | 0, W = W + Math.imul(Pe, yr) | 0, I = I + Math.imul(Pe, Dr) | 0, I = I + Math.imul(Ke, yr) | 0, te = te + Math.imul(Ke, Dr) | 0;
        var hi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (hi >>> 26) | 0, hi &= 67108863, W = Math.imul($t, Pn), I = Math.imul($t, Ae), I = I + Math.imul(Lt, Pn) | 0, te = Math.imul(Lt, Ae), W = W + Math.imul(sn, He) | 0, I = I + Math.imul(sn, cn) | 0, I = I + Math.imul(At, He) | 0, te = te + Math.imul(At, cn) | 0, W = W + Math.imul(Ht, yn) | 0, I = I + Math.imul(Ht, pr) | 0, I = I + Math.imul(Xt, yn) | 0, te = te + Math.imul(Xt, pr) | 0, W = W + Math.imul(Ut, ar) | 0, I = I + Math.imul(Ut, Sr) | 0, I = I + Math.imul(dn, ar) | 0, te = te + Math.imul(dn, Sr) | 0, W = W + Math.imul(pt, fr) | 0, I = I + Math.imul(pt, Er) | 0, I = I + Math.imul(at, fr) | 0, te = te + Math.imul(at, Er) | 0, W = W + Math.imul(Et, lr) | 0, I = I + Math.imul(Et, $r) | 0, I = I + Math.imul(zt, lr) | 0, te = te + Math.imul(zt, $r) | 0, W = W + Math.imul(ze, yr) | 0, I = I + Math.imul(ze, Dr) | 0, I = I + Math.imul(nt, yr) | 0, te = te + Math.imul(nt, Dr) | 0, W = W + Math.imul(Pe, dr) | 0, I = I + Math.imul(Pe, Br) | 0, I = I + Math.imul(Ke, dr) | 0, te = te + Math.imul(Ke, Br) | 0;
        var bi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, W = Math.imul(ce, Pn), I = Math.imul(ce, Ae), I = I + Math.imul(Ze, Pn) | 0, te = Math.imul(Ze, Ae), W = W + Math.imul($t, He) | 0, I = I + Math.imul($t, cn) | 0, I = I + Math.imul(Lt, He) | 0, te = te + Math.imul(Lt, cn) | 0, W = W + Math.imul(sn, yn) | 0, I = I + Math.imul(sn, pr) | 0, I = I + Math.imul(At, yn) | 0, te = te + Math.imul(At, pr) | 0, W = W + Math.imul(Ht, ar) | 0, I = I + Math.imul(Ht, Sr) | 0, I = I + Math.imul(Xt, ar) | 0, te = te + Math.imul(Xt, Sr) | 0, W = W + Math.imul(Ut, fr) | 0, I = I + Math.imul(Ut, Er) | 0, I = I + Math.imul(dn, fr) | 0, te = te + Math.imul(dn, Er) | 0, W = W + Math.imul(pt, lr) | 0, I = I + Math.imul(pt, $r) | 0, I = I + Math.imul(at, lr) | 0, te = te + Math.imul(at, $r) | 0, W = W + Math.imul(Et, yr) | 0, I = I + Math.imul(Et, Dr) | 0, I = I + Math.imul(zt, yr) | 0, te = te + Math.imul(zt, Dr) | 0, W = W + Math.imul(ze, dr) | 0, I = I + Math.imul(ze, Br) | 0, I = I + Math.imul(nt, dr) | 0, te = te + Math.imul(nt, Br) | 0, W = W + Math.imul(Pe, tr) | 0, I = I + Math.imul(Pe, Mr) | 0, I = I + Math.imul(Ke, tr) | 0, te = te + Math.imul(Ke, Mr) | 0;
        var ii = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, W = Math.imul(It, Pn), I = Math.imul(It, Ae), I = I + Math.imul(rn, Pn) | 0, te = Math.imul(rn, Ae), W = W + Math.imul(ce, He) | 0, I = I + Math.imul(ce, cn) | 0, I = I + Math.imul(Ze, He) | 0, te = te + Math.imul(Ze, cn) | 0, W = W + Math.imul($t, yn) | 0, I = I + Math.imul($t, pr) | 0, I = I + Math.imul(Lt, yn) | 0, te = te + Math.imul(Lt, pr) | 0, W = W + Math.imul(sn, ar) | 0, I = I + Math.imul(sn, Sr) | 0, I = I + Math.imul(At, ar) | 0, te = te + Math.imul(At, Sr) | 0, W = W + Math.imul(Ht, fr) | 0, I = I + Math.imul(Ht, Er) | 0, I = I + Math.imul(Xt, fr) | 0, te = te + Math.imul(Xt, Er) | 0, W = W + Math.imul(Ut, lr) | 0, I = I + Math.imul(Ut, $r) | 0, I = I + Math.imul(dn, lr) | 0, te = te + Math.imul(dn, $r) | 0, W = W + Math.imul(pt, yr) | 0, I = I + Math.imul(pt, Dr) | 0, I = I + Math.imul(at, yr) | 0, te = te + Math.imul(at, Dr) | 0, W = W + Math.imul(Et, dr) | 0, I = I + Math.imul(Et, Br) | 0, I = I + Math.imul(zt, dr) | 0, te = te + Math.imul(zt, Br) | 0, W = W + Math.imul(ze, tr) | 0, I = I + Math.imul(ze, Mr) | 0, I = I + Math.imul(nt, tr) | 0, te = te + Math.imul(nt, Mr) | 0, W = W + Math.imul(Pe, hr) | 0, I = I + Math.imul(Pe, Or) | 0, I = I + Math.imul(Ke, hr) | 0, te = te + Math.imul(Ke, Or) | 0;
        var pi = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (pi >>> 26) | 0, pi &= 67108863, W = Math.imul(It, He), I = Math.imul(It, cn), I = I + Math.imul(rn, He) | 0, te = Math.imul(rn, cn), W = W + Math.imul(ce, yn) | 0, I = I + Math.imul(ce, pr) | 0, I = I + Math.imul(Ze, yn) | 0, te = te + Math.imul(Ze, pr) | 0, W = W + Math.imul($t, ar) | 0, I = I + Math.imul($t, Sr) | 0, I = I + Math.imul(Lt, ar) | 0, te = te + Math.imul(Lt, Sr) | 0, W = W + Math.imul(sn, fr) | 0, I = I + Math.imul(sn, Er) | 0, I = I + Math.imul(At, fr) | 0, te = te + Math.imul(At, Er) | 0, W = W + Math.imul(Ht, lr) | 0, I = I + Math.imul(Ht, $r) | 0, I = I + Math.imul(Xt, lr) | 0, te = te + Math.imul(Xt, $r) | 0, W = W + Math.imul(Ut, yr) | 0, I = I + Math.imul(Ut, Dr) | 0, I = I + Math.imul(dn, yr) | 0, te = te + Math.imul(dn, Dr) | 0, W = W + Math.imul(pt, dr) | 0, I = I + Math.imul(pt, Br) | 0, I = I + Math.imul(at, dr) | 0, te = te + Math.imul(at, Br) | 0, W = W + Math.imul(Et, tr) | 0, I = I + Math.imul(Et, Mr) | 0, I = I + Math.imul(zt, tr) | 0, te = te + Math.imul(zt, Mr) | 0, W = W + Math.imul(ze, hr) | 0, I = I + Math.imul(ze, Or) | 0, I = I + Math.imul(nt, hr) | 0, te = te + Math.imul(nt, Or) | 0;
        var Ci = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, W = Math.imul(It, yn), I = Math.imul(It, pr), I = I + Math.imul(rn, yn) | 0, te = Math.imul(rn, pr), W = W + Math.imul(ce, ar) | 0, I = I + Math.imul(ce, Sr) | 0, I = I + Math.imul(Ze, ar) | 0, te = te + Math.imul(Ze, Sr) | 0, W = W + Math.imul($t, fr) | 0, I = I + Math.imul($t, Er) | 0, I = I + Math.imul(Lt, fr) | 0, te = te + Math.imul(Lt, Er) | 0, W = W + Math.imul(sn, lr) | 0, I = I + Math.imul(sn, $r) | 0, I = I + Math.imul(At, lr) | 0, te = te + Math.imul(At, $r) | 0, W = W + Math.imul(Ht, yr) | 0, I = I + Math.imul(Ht, Dr) | 0, I = I + Math.imul(Xt, yr) | 0, te = te + Math.imul(Xt, Dr) | 0, W = W + Math.imul(Ut, dr) | 0, I = I + Math.imul(Ut, Br) | 0, I = I + Math.imul(dn, dr) | 0, te = te + Math.imul(dn, Br) | 0, W = W + Math.imul(pt, tr) | 0, I = I + Math.imul(pt, Mr) | 0, I = I + Math.imul(at, tr) | 0, te = te + Math.imul(at, Mr) | 0, W = W + Math.imul(Et, hr) | 0, I = I + Math.imul(Et, Or) | 0, I = I + Math.imul(zt, hr) | 0, te = te + Math.imul(zt, Or) | 0;
        var _i = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (_i >>> 26) | 0, _i &= 67108863, W = Math.imul(It, ar), I = Math.imul(It, Sr), I = I + Math.imul(rn, ar) | 0, te = Math.imul(rn, Sr), W = W + Math.imul(ce, fr) | 0, I = I + Math.imul(ce, Er) | 0, I = I + Math.imul(Ze, fr) | 0, te = te + Math.imul(Ze, Er) | 0, W = W + Math.imul($t, lr) | 0, I = I + Math.imul($t, $r) | 0, I = I + Math.imul(Lt, lr) | 0, te = te + Math.imul(Lt, $r) | 0, W = W + Math.imul(sn, yr) | 0, I = I + Math.imul(sn, Dr) | 0, I = I + Math.imul(At, yr) | 0, te = te + Math.imul(At, Dr) | 0, W = W + Math.imul(Ht, dr) | 0, I = I + Math.imul(Ht, Br) | 0, I = I + Math.imul(Xt, dr) | 0, te = te + Math.imul(Xt, Br) | 0, W = W + Math.imul(Ut, tr) | 0, I = I + Math.imul(Ut, Mr) | 0, I = I + Math.imul(dn, tr) | 0, te = te + Math.imul(dn, Mr) | 0, W = W + Math.imul(pt, hr) | 0, I = I + Math.imul(pt, Or) | 0, I = I + Math.imul(at, hr) | 0, te = te + Math.imul(at, Or) | 0;
        var xn = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (xn >>> 26) | 0, xn &= 67108863, W = Math.imul(It, fr), I = Math.imul(It, Er), I = I + Math.imul(rn, fr) | 0, te = Math.imul(rn, Er), W = W + Math.imul(ce, lr) | 0, I = I + Math.imul(ce, $r) | 0, I = I + Math.imul(Ze, lr) | 0, te = te + Math.imul(Ze, $r) | 0, W = W + Math.imul($t, yr) | 0, I = I + Math.imul($t, Dr) | 0, I = I + Math.imul(Lt, yr) | 0, te = te + Math.imul(Lt, Dr) | 0, W = W + Math.imul(sn, dr) | 0, I = I + Math.imul(sn, Br) | 0, I = I + Math.imul(At, dr) | 0, te = te + Math.imul(At, Br) | 0, W = W + Math.imul(Ht, tr) | 0, I = I + Math.imul(Ht, Mr) | 0, I = I + Math.imul(Xt, tr) | 0, te = te + Math.imul(Xt, Mr) | 0, W = W + Math.imul(Ut, hr) | 0, I = I + Math.imul(Ut, Or) | 0, I = I + Math.imul(dn, hr) | 0, te = te + Math.imul(dn, Or) | 0;
        var sr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (sr >>> 26) | 0, sr &= 67108863, W = Math.imul(It, lr), I = Math.imul(It, $r), I = I + Math.imul(rn, lr) | 0, te = Math.imul(rn, $r), W = W + Math.imul(ce, yr) | 0, I = I + Math.imul(ce, Dr) | 0, I = I + Math.imul(Ze, yr) | 0, te = te + Math.imul(Ze, Dr) | 0, W = W + Math.imul($t, dr) | 0, I = I + Math.imul($t, Br) | 0, I = I + Math.imul(Lt, dr) | 0, te = te + Math.imul(Lt, Br) | 0, W = W + Math.imul(sn, tr) | 0, I = I + Math.imul(sn, Mr) | 0, I = I + Math.imul(At, tr) | 0, te = te + Math.imul(At, Mr) | 0, W = W + Math.imul(Ht, hr) | 0, I = I + Math.imul(Ht, Or) | 0, I = I + Math.imul(Xt, hr) | 0, te = te + Math.imul(Xt, Or) | 0;
        var Nr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Nr >>> 26) | 0, Nr &= 67108863, W = Math.imul(It, yr), I = Math.imul(It, Dr), I = I + Math.imul(rn, yr) | 0, te = Math.imul(rn, Dr), W = W + Math.imul(ce, dr) | 0, I = I + Math.imul(ce, Br) | 0, I = I + Math.imul(Ze, dr) | 0, te = te + Math.imul(Ze, Br) | 0, W = W + Math.imul($t, tr) | 0, I = I + Math.imul($t, Mr) | 0, I = I + Math.imul(Lt, tr) | 0, te = te + Math.imul(Lt, Mr) | 0, W = W + Math.imul(sn, hr) | 0, I = I + Math.imul(sn, Or) | 0, I = I + Math.imul(At, hr) | 0, te = te + Math.imul(At, Or) | 0;
        var vr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, W = Math.imul(It, dr), I = Math.imul(It, Br), I = I + Math.imul(rn, dr) | 0, te = Math.imul(rn, Br), W = W + Math.imul(ce, tr) | 0, I = I + Math.imul(ce, Mr) | 0, I = I + Math.imul(Ze, tr) | 0, te = te + Math.imul(Ze, Mr) | 0, W = W + Math.imul($t, hr) | 0, I = I + Math.imul($t, Or) | 0, I = I + Math.imul(Lt, hr) | 0, te = te + Math.imul(Lt, Or) | 0;
        var Yr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, W = Math.imul(It, tr), I = Math.imul(It, Mr), I = I + Math.imul(rn, tr) | 0, te = Math.imul(rn, Mr), W = W + Math.imul(ce, hr) | 0, I = I + Math.imul(ce, Or) | 0, I = I + Math.imul(Ze, hr) | 0, te = te + Math.imul(Ze, Or) | 0;
        var Fr = (N + W | 0) + ((I & 8191) << 13) | 0;
        N = (te + (I >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, W = Math.imul(It, hr), I = Math.imul(It, Or), I = I + Math.imul(rn, hr) | 0, te = Math.imul(rn, Or);
        var eo = (N + W | 0) + ((I & 8191) << 13) | 0;
        return N = (te + (I >>> 13) | 0) + (eo >>> 26) | 0, eo &= 67108863, fe[0] = Fo, fe[1] = No, fe[2] = di, fe[3] = gi, fe[4] = ai, fe[5] = ui, fe[6] = hi, fe[7] = bi, fe[8] = ii, fe[9] = pi, fe[10] = Ci, fe[11] = _i, fe[12] = xn, fe[13] = sr, fe[14] = Nr, fe[15] = vr, fe[16] = Yr, fe[17] = Fr, fe[18] = eo, N !== 0 && (fe[19] = N, P.length++), P;
      };
      Math.imul || (M = V);
      function G(H, C, w) {
        w.negative = C.negative ^ H.negative, w.length = H.length + C.length;
        for (var P = 0, J = 0, se = 0; se < w.length - 1; se++) {
          var fe = J;
          J = 0;
          for (var N = P & 67108863, W = Math.min(se, C.length - 1), I = Math.max(0, se - H.length + 1); I <= W; I++) {
            var te = se - I, ge = H.words[te] | 0, Pe = C.words[I] | 0, Ke = ge * Pe, xe = Ke & 67108863;
            fe = fe + (Ke / 67108864 | 0) | 0, xe = xe + N | 0, N = xe & 67108863, fe = fe + (xe >>> 26) | 0, J += fe >>> 26, fe &= 67108863;
          }
          w.words[se] = N, P = fe, fe = J;
        }
        return P !== 0 ? w.words[se] = P : w.length--, w.strip();
      }
      function k(H, C, w) {
        var P = new F();
        return P.mulp(H, C, w);
      }
      d.prototype.mulTo = function(C, w) {
        var P, J = this.length + C.length;
        return this.length === 10 && C.length === 10 ? P = M(this, C, w) : J < 63 ? P = V(this, C, w) : J < 1024 ? P = G(this, C, w) : P = k(this, C, w), P;
      };
      function F(H, C) {
        this.x = H, this.y = C;
      }
      F.prototype.makeRBT = function(C) {
        for (var w = new Array(C), P = d.prototype._countBits(C) - 1, J = 0; J < C; J++)
          w[J] = this.revBin(J, P, C);
        return w;
      }, F.prototype.revBin = function(C, w, P) {
        if (C === 0 || C === P - 1)
          return C;
        for (var J = 0, se = 0; se < w; se++)
          J |= (C & 1) << w - se - 1, C >>= 1;
        return J;
      }, F.prototype.permute = function(C, w, P, J, se, fe) {
        for (var N = 0; N < fe; N++)
          J[N] = w[C[N]], se[N] = P[C[N]];
      }, F.prototype.transform = function(C, w, P, J, se, fe) {
        this.permute(fe, C, w, P, J, se);
        for (var N = 1; N < se; N <<= 1)
          for (var W = N << 1, I = Math.cos(2 * Math.PI / W), te = Math.sin(2 * Math.PI / W), ge = 0; ge < se; ge += W)
            for (var Pe = I, Ke = te, xe = 0; xe < N; xe++) {
              var ze = P[ge + xe], nt = J[ge + xe], Qt = P[ge + xe + N], Et = J[ge + xe + N], zt = Pe * Qt - Ke * Et;
              Et = Pe * Et + Ke * Qt, Qt = zt, P[ge + xe] = ze + Qt, J[ge + xe] = nt + Et, P[ge + xe + N] = ze - Qt, J[ge + xe + N] = nt - Et, xe !== W && (zt = I * Pe - te * Ke, Ke = I * Ke + te * Pe, Pe = zt);
            }
      }, F.prototype.guessLen13b = function(C, w) {
        var P = Math.max(w, C) | 1, J = P & 1, se = 0;
        for (P = P / 2 | 0; P; P = P >>> 1)
          se++;
        return 1 << se + 1 + J;
      }, F.prototype.conjugate = function(C, w, P) {
        if (!(P <= 1))
          for (var J = 0; J < P / 2; J++) {
            var se = C[J];
            C[J] = C[P - J - 1], C[P - J - 1] = se, se = w[J], w[J] = -w[P - J - 1], w[P - J - 1] = -se;
          }
      }, F.prototype.normalize13b = function(C, w) {
        for (var P = 0, J = 0; J < w / 2; J++) {
          var se = Math.round(C[2 * J + 1] / w) * 8192 + Math.round(C[2 * J] / w) + P;
          C[J] = se & 67108863, se < 67108864 ? P = 0 : P = se / 67108864 | 0;
        }
        return C;
      }, F.prototype.convert13b = function(C, w, P, J) {
        for (var se = 0, fe = 0; fe < w; fe++)
          se = se + (C[fe] | 0), P[2 * fe] = se & 8191, se = se >>> 13, P[2 * fe + 1] = se & 8191, se = se >>> 13;
        for (fe = 2 * w; fe < J; ++fe)
          P[fe] = 0;
        u(se === 0), u((se & -8192) === 0);
      }, F.prototype.stub = function(C) {
        for (var w = new Array(C), P = 0; P < C; P++)
          w[P] = 0;
        return w;
      }, F.prototype.mulp = function(C, w, P) {
        var J = 2 * this.guessLen13b(C.length, w.length), se = this.makeRBT(J), fe = this.stub(J), N = new Array(J), W = new Array(J), I = new Array(J), te = new Array(J), ge = new Array(J), Pe = new Array(J), Ke = P.words;
        Ke.length = J, this.convert13b(C.words, C.length, N, J), this.convert13b(w.words, w.length, te, J), this.transform(N, fe, W, I, J, se), this.transform(te, fe, ge, Pe, J, se);
        for (var xe = 0; xe < J; xe++) {
          var ze = W[xe] * ge[xe] - I[xe] * Pe[xe];
          I[xe] = W[xe] * Pe[xe] + I[xe] * ge[xe], W[xe] = ze;
        }
        return this.conjugate(W, I, J), this.transform(W, I, Ke, fe, J, se), this.conjugate(Ke, fe, J), this.normalize13b(Ke, J), P.negative = C.negative ^ w.negative, P.length = C.length + w.length, P.strip();
      }, d.prototype.mul = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), this.mulTo(C, w);
      }, d.prototype.mulf = function(C) {
        var w = new d(null);
        return w.words = new Array(this.length + C.length), k(this, C, w);
      }, d.prototype.imul = function(C) {
        return this.clone().mulTo(C, this);
      }, d.prototype.imuln = function(C) {
        u(typeof C == "number"), u(C < 67108864);
        for (var w = 0, P = 0; P < this.length; P++) {
          var J = (this.words[P] | 0) * C, se = (J & 67108863) + (w & 67108863);
          w >>= 26, w += J / 67108864 | 0, w += se >>> 26, this.words[P] = se & 67108863;
        }
        return w !== 0 && (this.words[P] = w, this.length++), this;
      }, d.prototype.muln = function(C) {
        return this.clone().imuln(C);
      }, d.prototype.sqr = function() {
        return this.mul(this);
      }, d.prototype.isqr = function() {
        return this.imul(this.clone());
      }, d.prototype.pow = function(C) {
        var w = y(C);
        if (w.length === 0)
          return new d(1);
        for (var P = this, J = 0; J < w.length && w[J] === 0; J++, P = P.sqr())
          ;
        if (++J < w.length)
          for (var se = P.sqr(); J < w.length; J++, se = se.sqr())
            w[J] !== 0 && (P = P.mul(se));
        return P;
      }, d.prototype.iushln = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 67108863 >>> 26 - w << 26 - w, se;
        if (w !== 0) {
          var fe = 0;
          for (se = 0; se < this.length; se++) {
            var N = this.words[se] & J, W = (this.words[se] | 0) - N << w;
            this.words[se] = W | fe, fe = N >>> 26 - w;
          }
          fe && (this.words[se] = fe, this.length++);
        }
        if (P !== 0) {
          for (se = this.length - 1; se >= 0; se--)
            this.words[se + P] = this.words[se];
          for (se = 0; se < P; se++)
            this.words[se] = 0;
          this.length += P;
        }
        return this.strip();
      }, d.prototype.ishln = function(C) {
        return u(this.negative === 0), this.iushln(C);
      }, d.prototype.iushrn = function(C, w, P) {
        u(typeof C == "number" && C >= 0);
        var J;
        w ? J = (w - w % 26) / 26 : J = 0;
        var se = C % 26, fe = Math.min((C - se) / 26, this.length), N = 67108863 ^ 67108863 >>> se << se, W = P;
        if (J -= fe, J = Math.max(0, J), W) {
          for (var I = 0; I < fe; I++)
            W.words[I] = this.words[I];
          W.length = fe;
        }
        if (fe !== 0)
          if (this.length > fe)
            for (this.length -= fe, I = 0; I < this.length; I++)
              this.words[I] = this.words[I + fe];
          else
            this.words[0] = 0, this.length = 1;
        var te = 0;
        for (I = this.length - 1; I >= 0 && (te !== 0 || I >= J); I--) {
          var ge = this.words[I] | 0;
          this.words[I] = te << 26 - se | ge >>> se, te = ge & N;
        }
        return W && te !== 0 && (W.words[W.length++] = te), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, d.prototype.ishrn = function(C, w, P) {
        return u(this.negative === 0), this.iushrn(C, w, P);
      }, d.prototype.shln = function(C) {
        return this.clone().ishln(C);
      }, d.prototype.ushln = function(C) {
        return this.clone().iushln(C);
      }, d.prototype.shrn = function(C) {
        return this.clone().ishrn(C);
      }, d.prototype.ushrn = function(C) {
        return this.clone().iushrn(C);
      }, d.prototype.testn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return !1;
        var se = this.words[P];
        return !!(se & J);
      }, d.prototype.imaskn = function(C) {
        u(typeof C == "number" && C >= 0);
        var w = C % 26, P = (C - w) / 26;
        if (u(this.negative === 0, "imaskn works only with positive numbers"), this.length <= P)
          return this;
        if (w !== 0 && P++, this.length = Math.min(P, this.length), w !== 0) {
          var J = 67108863 ^ 67108863 >>> w << w;
          this.words[this.length - 1] &= J;
        }
        return this.strip();
      }, d.prototype.maskn = function(C) {
        return this.clone().imaskn(C);
      }, d.prototype.iaddn = function(C) {
        return u(typeof C == "number"), u(C < 67108864), C < 0 ? this.isubn(-C) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < C ? (this.words[0] = C - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(C), this.negative = 1, this) : this._iaddn(C);
      }, d.prototype._iaddn = function(C) {
        this.words[0] += C;
        for (var w = 0; w < this.length && this.words[w] >= 67108864; w++)
          this.words[w] -= 67108864, w === this.length - 1 ? this.words[w + 1] = 1 : this.words[w + 1]++;
        return this.length = Math.max(this.length, w + 1), this;
      }, d.prototype.isubn = function(C) {
        if (u(typeof C == "number"), u(C < 67108864), C < 0)
          return this.iaddn(-C);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(C), this.negative = 1, this;
        if (this.words[0] -= C, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var w = 0; w < this.length && this.words[w] < 0; w++)
            this.words[w] += 67108864, this.words[w + 1] -= 1;
        return this.strip();
      }, d.prototype.addn = function(C) {
        return this.clone().iaddn(C);
      }, d.prototype.subn = function(C) {
        return this.clone().isubn(C);
      }, d.prototype.iabs = function() {
        return this.negative = 0, this;
      }, d.prototype.abs = function() {
        return this.clone().iabs();
      }, d.prototype._ishlnsubmul = function(C, w, P) {
        var J = C.length + P, se;
        this._expand(J);
        var fe, N = 0;
        for (se = 0; se < C.length; se++) {
          fe = (this.words[se + P] | 0) + N;
          var W = (C.words[se] | 0) * w;
          fe -= W & 67108863, N = (fe >> 26) - (W / 67108864 | 0), this.words[se + P] = fe & 67108863;
        }
        for (; se < this.length - P; se++)
          fe = (this.words[se + P] | 0) + N, N = fe >> 26, this.words[se + P] = fe & 67108863;
        if (N === 0)
          return this.strip();
        for (u(N === -1), N = 0, se = 0; se < this.length; se++)
          fe = -(this.words[se] | 0) + N, N = fe >> 26, this.words[se] = fe & 67108863;
        return this.negative = 1, this.strip();
      }, d.prototype._wordDiv = function(C, w) {
        var P = this.length - C.length, J = this.clone(), se = C, fe = se.words[se.length - 1] | 0, N = this._countBits(fe);
        P = 26 - N, P !== 0 && (se = se.ushln(P), J.iushln(P), fe = se.words[se.length - 1] | 0);
        var W = J.length - se.length, I;
        if (w !== "mod") {
          I = new d(null), I.length = W + 1, I.words = new Array(I.length);
          for (var te = 0; te < I.length; te++)
            I.words[te] = 0;
        }
        var ge = J.clone()._ishlnsubmul(se, 1, W);
        ge.negative === 0 && (J = ge, I && (I.words[W] = 1));
        for (var Pe = W - 1; Pe >= 0; Pe--) {
          var Ke = (J.words[se.length + Pe] | 0) * 67108864 + (J.words[se.length + Pe - 1] | 0);
          for (Ke = Math.min(Ke / fe | 0, 67108863), J._ishlnsubmul(se, Ke, Pe); J.negative !== 0; )
            Ke--, J.negative = 0, J._ishlnsubmul(se, 1, Pe), J.isZero() || (J.negative ^= 1);
          I && (I.words[Pe] = Ke);
        }
        return I && I.strip(), J.strip(), w !== "div" && P !== 0 && J.iushrn(P), {
          div: I || null,
          mod: J
        };
      }, d.prototype.divmod = function(C, w, P) {
        if (u(!C.isZero()), this.isZero())
          return {
            div: new d(0),
            mod: new d(0)
          };
        var J, se, fe;
        return this.negative !== 0 && C.negative === 0 ? (fe = this.neg().divmod(C, w), w !== "mod" && (J = fe.div.neg()), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.iadd(C)), {
          div: J,
          mod: se
        }) : this.negative === 0 && C.negative !== 0 ? (fe = this.divmod(C.neg(), w), w !== "mod" && (J = fe.div.neg()), {
          div: J,
          mod: fe.mod
        }) : this.negative & C.negative ? (fe = this.neg().divmod(C.neg(), w), w !== "div" && (se = fe.mod.neg(), P && se.negative !== 0 && se.isub(C)), {
          div: fe.div,
          mod: se
        }) : C.length > this.length || this.cmp(C) < 0 ? {
          div: new d(0),
          mod: this
        } : C.length === 1 ? w === "div" ? {
          div: this.divn(C.words[0]),
          mod: null
        } : w === "mod" ? {
          div: null,
          mod: new d(this.modn(C.words[0]))
        } : {
          div: this.divn(C.words[0]),
          mod: new d(this.modn(C.words[0]))
        } : this._wordDiv(C, w);
      }, d.prototype.div = function(C) {
        return this.divmod(C, "div", !1).div;
      }, d.prototype.mod = function(C) {
        return this.divmod(C, "mod", !1).mod;
      }, d.prototype.umod = function(C) {
        return this.divmod(C, "mod", !0).mod;
      }, d.prototype.divRound = function(C) {
        var w = this.divmod(C);
        if (w.mod.isZero())
          return w.div;
        var P = w.div.negative !== 0 ? w.mod.isub(C) : w.mod, J = C.ushrn(1), se = C.andln(1), fe = P.cmp(J);
        return fe < 0 || se === 1 && fe === 0 ? w.div : w.div.negative !== 0 ? w.div.isubn(1) : w.div.iaddn(1);
      }, d.prototype.modn = function(C) {
        u(C <= 67108863);
        for (var w = (1 << 26) % C, P = 0, J = this.length - 1; J >= 0; J--)
          P = (w * P + (this.words[J] | 0)) % C;
        return P;
      }, d.prototype.idivn = function(C) {
        u(C <= 67108863);
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = (this.words[P] | 0) + w * 67108864;
          this.words[P] = J / C | 0, w = J % C;
        }
        return this.strip();
      }, d.prototype.divn = function(C) {
        return this.clone().idivn(C);
      }, d.prototype.egcd = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = new d(0), N = new d(1), W = 0; w.isEven() && P.isEven(); )
          w.iushrn(1), P.iushrn(1), ++W;
        for (var I = P.clone(), te = w.clone(); !w.isZero(); ) {
          for (var ge = 0, Pe = 1; !(w.words[0] & Pe) && ge < 26; ++ge, Pe <<= 1)
            ;
          if (ge > 0)
            for (w.iushrn(ge); ge-- > 0; )
              (J.isOdd() || se.isOdd()) && (J.iadd(I), se.isub(te)), J.iushrn(1), se.iushrn(1);
          for (var Ke = 0, xe = 1; !(P.words[0] & xe) && Ke < 26; ++Ke, xe <<= 1)
            ;
          if (Ke > 0)
            for (P.iushrn(Ke); Ke-- > 0; )
              (fe.isOdd() || N.isOdd()) && (fe.iadd(I), N.isub(te)), fe.iushrn(1), N.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(fe), se.isub(N)) : (P.isub(w), fe.isub(J), N.isub(se));
        }
        return {
          a: fe,
          b: N,
          gcd: P.iushln(W)
        };
      }, d.prototype._invmp = function(C) {
        u(C.negative === 0), u(!C.isZero());
        var w = this, P = C.clone();
        w.negative !== 0 ? w = w.umod(C) : w = w.clone();
        for (var J = new d(1), se = new d(0), fe = P.clone(); w.cmpn(1) > 0 && P.cmpn(1) > 0; ) {
          for (var N = 0, W = 1; !(w.words[0] & W) && N < 26; ++N, W <<= 1)
            ;
          if (N > 0)
            for (w.iushrn(N); N-- > 0; )
              J.isOdd() && J.iadd(fe), J.iushrn(1);
          for (var I = 0, te = 1; !(P.words[0] & te) && I < 26; ++I, te <<= 1)
            ;
          if (I > 0)
            for (P.iushrn(I); I-- > 0; )
              se.isOdd() && se.iadd(fe), se.iushrn(1);
          w.cmp(P) >= 0 ? (w.isub(P), J.isub(se)) : (P.isub(w), se.isub(J));
        }
        var ge;
        return w.cmpn(1) === 0 ? ge = J : ge = se, ge.cmpn(0) < 0 && ge.iadd(C), ge;
      }, d.prototype.gcd = function(C) {
        if (this.isZero())
          return C.abs();
        if (C.isZero())
          return this.abs();
        var w = this.clone(), P = C.clone();
        w.negative = 0, P.negative = 0;
        for (var J = 0; w.isEven() && P.isEven(); J++)
          w.iushrn(1), P.iushrn(1);
        do {
          for (; w.isEven(); )
            w.iushrn(1);
          for (; P.isEven(); )
            P.iushrn(1);
          var se = w.cmp(P);
          if (se < 0) {
            var fe = w;
            w = P, P = fe;
          } else if (se === 0 || P.cmpn(1) === 0)
            break;
          w.isub(P);
        } while (!0);
        return P.iushln(J);
      }, d.prototype.invm = function(C) {
        return this.egcd(C).a.umod(C);
      }, d.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, d.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, d.prototype.andln = function(C) {
        return this.words[0] & C;
      }, d.prototype.bincn = function(C) {
        u(typeof C == "number");
        var w = C % 26, P = (C - w) / 26, J = 1 << w;
        if (this.length <= P)
          return this._expand(P + 1), this.words[P] |= J, this;
        for (var se = J, fe = P; se !== 0 && fe < this.length; fe++) {
          var N = this.words[fe] | 0;
          N += se, se = N >>> 26, N &= 67108863, this.words[fe] = N;
        }
        return se !== 0 && (this.words[fe] = se, this.length++), this;
      }, d.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, d.prototype.cmpn = function(C) {
        var w = C < 0;
        if (this.negative !== 0 && !w)
          return -1;
        if (this.negative === 0 && w)
          return 1;
        this.strip();
        var P;
        if (this.length > 1)
          P = 1;
        else {
          w && (C = -C), u(C <= 67108863, "Number is too big");
          var J = this.words[0] | 0;
          P = J === C ? 0 : J < C ? -1 : 1;
        }
        return this.negative !== 0 ? -P | 0 : P;
      }, d.prototype.cmp = function(C) {
        if (this.negative !== 0 && C.negative === 0)
          return -1;
        if (this.negative === 0 && C.negative !== 0)
          return 1;
        var w = this.ucmp(C);
        return this.negative !== 0 ? -w | 0 : w;
      }, d.prototype.ucmp = function(C) {
        if (this.length > C.length)
          return 1;
        if (this.length < C.length)
          return -1;
        for (var w = 0, P = this.length - 1; P >= 0; P--) {
          var J = this.words[P] | 0, se = C.words[P] | 0;
          if (J !== se) {
            J < se ? w = -1 : J > se && (w = 1);
            break;
          }
        }
        return w;
      }, d.prototype.gtn = function(C) {
        return this.cmpn(C) === 1;
      }, d.prototype.gt = function(C) {
        return this.cmp(C) === 1;
      }, d.prototype.gten = function(C) {
        return this.cmpn(C) >= 0;
      }, d.prototype.gte = function(C) {
        return this.cmp(C) >= 0;
      }, d.prototype.ltn = function(C) {
        return this.cmpn(C) === -1;
      }, d.prototype.lt = function(C) {
        return this.cmp(C) === -1;
      }, d.prototype.lten = function(C) {
        return this.cmpn(C) <= 0;
      }, d.prototype.lte = function(C) {
        return this.cmp(C) <= 0;
      }, d.prototype.eqn = function(C) {
        return this.cmpn(C) === 0;
      }, d.prototype.eq = function(C) {
        return this.cmp(C) === 0;
      }, d.red = function(C) {
        return new oe(C);
      }, d.prototype.toRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), u(this.negative === 0, "red works only with positives"), C.convertTo(this)._forceRed(C);
      }, d.prototype.fromRed = function() {
        return u(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, d.prototype._forceRed = function(C) {
        return this.red = C, this;
      }, d.prototype.forceRed = function(C) {
        return u(!this.red, "Already a number in reduction context"), this._forceRed(C);
      }, d.prototype.redAdd = function(C) {
        return u(this.red, "redAdd works only with red numbers"), this.red.add(this, C);
      }, d.prototype.redIAdd = function(C) {
        return u(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, C);
      }, d.prototype.redSub = function(C) {
        return u(this.red, "redSub works only with red numbers"), this.red.sub(this, C);
      }, d.prototype.redISub = function(C) {
        return u(this.red, "redISub works only with red numbers"), this.red.isub(this, C);
      }, d.prototype.redShl = function(C) {
        return u(this.red, "redShl works only with red numbers"), this.red.shl(this, C);
      }, d.prototype.redMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.mul(this, C);
      }, d.prototype.redIMul = function(C) {
        return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.imul(this, C);
      }, d.prototype.redSqr = function() {
        return u(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, d.prototype.redISqr = function() {
        return u(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, d.prototype.redSqrt = function() {
        return u(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, d.prototype.redInvm = function() {
        return u(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, d.prototype.redNeg = function() {
        return u(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, d.prototype.redPow = function(C) {
        return u(this.red && !C.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, C);
      };
      var X = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function ee(H, C) {
        this.name = H, this.p = new d(C, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      ee.prototype._tmp = function() {
        var C = new d(null);
        return C.words = new Array(Math.ceil(this.n / 13)), C;
      }, ee.prototype.ireduce = function(C) {
        var w = C, P;
        do
          this.split(w, this.tmp), w = this.imulK(w), w = w.iadd(this.tmp), P = w.bitLength();
        while (P > this.n);
        var J = P < this.n ? -1 : w.ucmp(this.p);
        return J === 0 ? (w.words[0] = 0, w.length = 1) : J > 0 ? w.isub(this.p) : w.strip !== void 0 ? w.strip() : w._strip(), w;
      }, ee.prototype.split = function(C, w) {
        C.iushrn(this.n, 0, w);
      }, ee.prototype.imulK = function(C) {
        return C.imul(this.k);
      };
      function ue() {
        ee.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(ue, ee), ue.prototype.split = function(C, w) {
        for (var P = 4194303, J = Math.min(C.length, 9), se = 0; se < J; se++)
          w.words[se] = C.words[se];
        if (w.length = J, C.length <= 9) {
          C.words[0] = 0, C.length = 1;
          return;
        }
        var fe = C.words[9];
        for (w.words[w.length++] = fe & P, se = 10; se < C.length; se++) {
          var N = C.words[se] | 0;
          C.words[se - 10] = (N & P) << 4 | fe >>> 22, fe = N;
        }
        fe >>>= 22, C.words[se - 10] = fe, fe === 0 && C.length > 10 ? C.length -= 10 : C.length -= 9;
      }, ue.prototype.imulK = function(C) {
        C.words[C.length] = 0, C.words[C.length + 1] = 0, C.length += 2;
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = C.words[P] | 0;
          w += J * 977, C.words[P] = w & 67108863, w = J * 64 + (w / 67108864 | 0);
        }
        return C.words[C.length - 1] === 0 && (C.length--, C.words[C.length - 1] === 0 && C.length--), C;
      };
      function Q() {
        ee.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(Q, ee);
      function Y() {
        ee.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(Y, ee);
      function pe() {
        ee.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(pe, ee), pe.prototype.imulK = function(C) {
        for (var w = 0, P = 0; P < C.length; P++) {
          var J = (C.words[P] | 0) * 19 + w, se = J & 67108863;
          J >>>= 26, C.words[P] = se, w = J;
        }
        return w !== 0 && (C.words[C.length++] = w), C;
      }, d._prime = function(C) {
        if (X[C])
          return X[C];
        var w;
        if (C === "k256")
          w = new ue();
        else if (C === "p224")
          w = new Q();
        else if (C === "p192")
          w = new Y();
        else if (C === "p25519")
          w = new pe();
        else
          throw new Error("Unknown prime " + C);
        return X[C] = w, w;
      };
      function oe(H) {
        if (typeof H == "string") {
          var C = d._prime(H);
          this.m = C.p, this.prime = C;
        } else
          u(H.gtn(1), "modulus must be greater than 1"), this.m = H, this.prime = null;
      }
      oe.prototype._verify1 = function(C) {
        u(C.negative === 0, "red works only with positives"), u(C.red, "red works only with red numbers");
      }, oe.prototype._verify2 = function(C, w) {
        u((C.negative | w.negative) === 0, "red works only with positives"), u(
          C.red && C.red === w.red,
          "red works only with red numbers"
        );
      }, oe.prototype.imod = function(C) {
        return this.prime ? this.prime.ireduce(C)._forceRed(this) : C.umod(this.m)._forceRed(this);
      }, oe.prototype.neg = function(C) {
        return C.isZero() ? C.clone() : this.m.sub(C)._forceRed(this);
      }, oe.prototype.add = function(C, w) {
        this._verify2(C, w);
        var P = C.add(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P._forceRed(this);
      }, oe.prototype.iadd = function(C, w) {
        this._verify2(C, w);
        var P = C.iadd(w);
        return P.cmp(this.m) >= 0 && P.isub(this.m), P;
      }, oe.prototype.sub = function(C, w) {
        this._verify2(C, w);
        var P = C.sub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P._forceRed(this);
      }, oe.prototype.isub = function(C, w) {
        this._verify2(C, w);
        var P = C.isub(w);
        return P.cmpn(0) < 0 && P.iadd(this.m), P;
      }, oe.prototype.shl = function(C, w) {
        return this._verify1(C), this.imod(C.ushln(w));
      }, oe.prototype.imul = function(C, w) {
        return this._verify2(C, w), this.imod(C.imul(w));
      }, oe.prototype.mul = function(C, w) {
        return this._verify2(C, w), this.imod(C.mul(w));
      }, oe.prototype.isqr = function(C) {
        return this.imul(C, C.clone());
      }, oe.prototype.sqr = function(C) {
        return this.mul(C, C);
      }, oe.prototype.sqrt = function(C) {
        if (C.isZero())
          return C.clone();
        var w = this.m.andln(3);
        if (u(w % 2 === 1), w === 3) {
          var P = this.m.add(new d(1)).iushrn(2);
          return this.pow(C, P);
        }
        for (var J = this.m.subn(1), se = 0; !J.isZero() && J.andln(1) === 0; )
          se++, J.iushrn(1);
        u(!J.isZero());
        var fe = new d(1).toRed(this), N = fe.redNeg(), W = this.m.subn(1).iushrn(1), I = this.m.bitLength();
        for (I = new d(2 * I * I).toRed(this); this.pow(I, W).cmp(N) !== 0; )
          I.redIAdd(N);
        for (var te = this.pow(I, J), ge = this.pow(C, J.addn(1).iushrn(1)), Pe = this.pow(C, J), Ke = se; Pe.cmp(fe) !== 0; ) {
          for (var xe = Pe, ze = 0; xe.cmp(fe) !== 0; ze++)
            xe = xe.redSqr();
          u(ze < Ke);
          var nt = this.pow(te, new d(1).iushln(Ke - ze - 1));
          ge = ge.redMul(nt), te = nt.redSqr(), Pe = Pe.redMul(te), Ke = ze;
        }
        return ge;
      }, oe.prototype.invm = function(C) {
        var w = C._invmp(this.m);
        return w.negative !== 0 ? (w.negative = 0, this.imod(w).redNeg()) : this.imod(w);
      }, oe.prototype.pow = function(C, w) {
        if (w.isZero())
          return new d(1).toRed(this);
        if (w.cmpn(1) === 0)
          return C.clone();
        var P = 4, J = new Array(1 << P);
        J[0] = new d(1).toRed(this), J[1] = C;
        for (var se = 2; se < J.length; se++)
          J[se] = this.mul(J[se - 1], C);
        var fe = J[0], N = 0, W = 0, I = w.bitLength() % 26;
        for (I === 0 && (I = 26), se = w.length - 1; se >= 0; se--) {
          for (var te = w.words[se], ge = I - 1; ge >= 0; ge--) {
            var Pe = te >> ge & 1;
            if (fe !== J[0] && (fe = this.sqr(fe)), Pe === 0 && N === 0) {
              W = 0;
              continue;
            }
            N <<= 1, N |= Pe, W++, !(W !== P && (se !== 0 || ge !== 0)) && (fe = this.mul(fe, J[N]), W = 0, N = 0);
          }
          I = 26;
        }
        return fe;
      }, oe.prototype.convertTo = function(C) {
        var w = C.umod(this.m);
        return w === C ? w.clone() : w;
      }, oe.prototype.convertFrom = function(C) {
        var w = C.clone();
        return w.red = null, w;
      }, d.mont = function(C) {
        return new ne(C);
      };
      function ne(H) {
        oe.call(this, H), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(ne, oe), ne.prototype.convertTo = function(C) {
        return this.imod(C.ushln(this.shift));
      }, ne.prototype.convertFrom = function(C) {
        var w = this.imod(C.mul(this.rinv));
        return w.red = null, w;
      }, ne.prototype.imul = function(C, w) {
        if (C.isZero() || w.isZero())
          return C.words[0] = 0, C.length = 1, C;
        var P = C.imul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.mul = function(C, w) {
        if (C.isZero() || w.isZero())
          return new d(0)._forceRed(this);
        var P = C.mul(w), J = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), se = P.isub(J).iushrn(this.shift), fe = se;
        return se.cmp(this.m) >= 0 ? fe = se.isub(this.m) : se.cmpn(0) < 0 && (fe = se.iadd(this.m)), fe._forceRed(this);
      }, ne.prototype.invm = function(C) {
        var w = this.imod(C._invmp(this.m).mul(this.r2));
        return w._forceRed(this);
      };
    })(e, commonjsGlobal);
  }(bn)), bn.exports;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic)
    return withPublic_1;
  hasRequiredWithPublic = 1;
  var e = requireBn(), n = requireSafeBuffer().Buffer;
  function o(u, c) {
    return n.from(u.toRed(e.mont(c.modulus)).redPow(new e(c.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = o, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt)
    return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var e = requireParseAsn1(), n = requireBrowser$b(), o = requireBrowser$9(), u = requireMgf(), c = requireXor(), d = requireBn(), m = requireWithPublic(), v = requireBrowserifyRsa(), S = requireSafeBuffer().Buffer;
  publicEncrypt = function(y, V, M) {
    var G;
    y.padding ? G = y.padding : M ? G = 1 : G = 4;
    var k = e(y), F;
    if (G === 4)
      F = $(k, V);
    else if (G === 1)
      F = E(k, V, M);
    else if (G === 3) {
      if (F = new d(V), F.cmp(k.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return M ? v(F, k) : m(F, k);
  };
  function $(T, y) {
    var V = T.modulus.byteLength(), M = y.length, G = o("sha1").update(S.alloc(0)).digest(), k = G.length, F = 2 * k;
    if (M > V - F - 2)
      throw new Error("message too long");
    var X = S.alloc(V - M - F - 2), ee = V - k - 1, ue = n(k), Q = c(S.concat([G, X, S.alloc(1, 1), y], ee), u(ue, ee)), Y = c(ue, u(Q, k));
    return new d(S.concat([S.alloc(1), Y, Q], V));
  }
  function E(T, y, V) {
    var M = y.length, G = T.modulus.byteLength();
    if (M > G - 11)
      throw new Error("message too long");
    var k;
    return V ? k = S.alloc(G - M - 3, 255) : k = O(G - M - 3), new d(S.concat([S.from([0, V ? 1 : 2]), k, S.alloc(1), y], G));
  }
  function O(T) {
    for (var y = S.allocUnsafe(T), V = 0, M = n(T * 2), G = 0, k; V < T; )
      G === M.length && (M = n(T * 2), G = 0), k = M[G++], k && (y[V++] = k);
    return y;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt)
    return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var e = requireParseAsn1(), n = requireMgf(), o = requireXor(), u = requireBn(), c = requireBrowserifyRsa(), d = requireBrowser$9(), m = requireWithPublic(), v = requireSafeBuffer().Buffer;
  privateDecrypt = function(T, y, V) {
    var M;
    T.padding ? M = T.padding : V ? M = 1 : M = 4;
    var G = e(T), k = G.modulus.byteLength();
    if (y.length > k || new u(y).cmp(G.modulus) >= 0)
      throw new Error("decryption error");
    var F;
    V ? F = m(new u(y), G) : F = c(y, G);
    var X = v.alloc(k - F.length);
    if (F = v.concat([X, F], k), M === 4)
      return S(G, F);
    if (M === 1)
      return $(G, F, V);
    if (M === 3)
      return F;
    throw new Error("unknown padding");
  };
  function S(O, T) {
    var y = O.modulus.byteLength(), V = d("sha1").update(v.alloc(0)).digest(), M = V.length;
    if (T[0] !== 0)
      throw new Error("decryption error");
    var G = T.slice(1, M + 1), k = T.slice(M + 1), F = o(G, n(k, M)), X = o(k, n(F, y - M - 1));
    if (E(V, X.slice(0, M)))
      throw new Error("decryption error");
    for (var ee = M; X[ee] === 0; )
      ee++;
    if (X[ee++] !== 1)
      throw new Error("decryption error");
    return X.slice(ee);
  }
  function $(O, T, y) {
    for (var V = T.slice(0, 2), M = 2, G = 0; T[M++] !== 0; )
      if (M >= T.length) {
        G++;
        break;
      }
    var k = T.slice(2, M - 1);
    if ((V.toString("hex") !== "0002" && !y || V.toString("hex") !== "0001" && y) && G++, k.length < 8 && G++, G)
      throw new Error("decryption error");
    return T.slice(M);
  }
  function E(O, T) {
    O = v.from(O), T = v.from(T);
    var y = 0, V = O.length;
    O.length !== T.length && (y++, V = Math.min(O.length, T.length));
    for (var M = -1; ++M < V; )
      y += O[M] ^ T[M];
    return y;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(e) {
    e.publicEncrypt = requirePublicEncrypt(), e.privateDecrypt = requirePrivateDecrypt(), e.privateEncrypt = function(o, u) {
      return e.publicEncrypt(o, u, !0);
    }, e.publicDecrypt = function(o, u) {
      return e.privateDecrypt(o, u, !0);
    };
  }(browser$3)), browser$3;
}
var browser$2 = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser)
    return browser$2;
  hasRequiredBrowser = 1;
  function e() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var n = requireSafeBuffer(), o = requireBrowser$b(), u = n.Buffer, c = n.kMaxLength, d = commonjsGlobal.crypto || commonjsGlobal.msCrypto, m = Math.pow(2, 32) - 1;
  function v(T, y) {
    if (typeof T != "number" || T !== T)
      throw new TypeError("offset must be a number");
    if (T > m || T < 0)
      throw new TypeError("offset must be a uint32");
    if (T > c || T > y)
      throw new RangeError("offset out of range");
  }
  function S(T, y, V) {
    if (typeof T != "number" || T !== T)
      throw new TypeError("size must be a number");
    if (T > m || T < 0)
      throw new TypeError("size must be a uint32");
    if (T + y > V || T > c)
      throw new RangeError("buffer too small");
  }
  d && d.getRandomValues || !browser$1$1.browser ? (browser$2.randomFill = $, browser$2.randomFillSync = O) : (browser$2.randomFill = e, browser$2.randomFillSync = e);
  function $(T, y, V, M) {
    if (!u.isBuffer(T) && !(T instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof y == "function")
      M = y, y = 0, V = T.length;
    else if (typeof V == "function")
      M = V, V = T.length - y;
    else if (typeof M != "function")
      throw new TypeError('"cb" argument must be a function');
    return v(y, T.length), S(V, y, T.length), E(T, y, V, M);
  }
  function E(T, y, V, M) {
    if (browser$1$1.browser) {
      var G = T.buffer, k = new Uint8Array(G, y, V);
      if (d.getRandomValues(k), M) {
        browser$1$1.nextTick(function() {
          M(null, T);
        });
        return;
      }
      return T;
    }
    if (M) {
      o(V, function(X, ee) {
        if (X)
          return M(X);
        ee.copy(T, y), M(null, T);
      });
      return;
    }
    var F = o(V);
    return F.copy(T, y), T;
  }
  function O(T, y, V) {
    if (typeof y > "u" && (y = 0), !u.isBuffer(T) && !(T instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return v(y, T.length), V === void 0 && (V = T.length - y), S(V, y, T.length), E(T, y, V);
  }
  return browser$2;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify)
    return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$b(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$9(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var e = requireAlgos(), n = Object.keys(e), o = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(n);
  cryptoBrowserify.getHashes = function() {
    return o;
  };
  var u = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = u.pbkdf2, cryptoBrowserify.pbkdf2Sync = u.pbkdf2Sync;
  var c = requireBrowser$5();
  cryptoBrowserify.Cipher = c.Cipher, cryptoBrowserify.createCipher = c.createCipher, cryptoBrowserify.Cipheriv = c.Cipheriv, cryptoBrowserify.createCipheriv = c.createCipheriv, cryptoBrowserify.Decipher = c.Decipher, cryptoBrowserify.createDecipher = c.createDecipher, cryptoBrowserify.Decipheriv = c.Decipheriv, cryptoBrowserify.createDecipheriv = c.createDecipheriv, cryptoBrowserify.getCiphers = c.getCiphers, cryptoBrowserify.listCiphers = c.listCiphers;
  var d = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = d.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = d.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = d.getDiffieHellman, cryptoBrowserify.createDiffieHellman = d.createDiffieHellman, cryptoBrowserify.DiffieHellman = d.DiffieHellman;
  var m = requireBrowser$3();
  cryptoBrowserify.createSign = m.createSign, cryptoBrowserify.Sign = m.Sign, cryptoBrowserify.createVerify = m.createVerify, cryptoBrowserify.Verify = m.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var v = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = v.publicEncrypt, cryptoBrowserify.privateEncrypt = v.privateEncrypt, cryptoBrowserify.publicDecrypt = v.publicDecrypt, cryptoBrowserify.privateDecrypt = v.privateDecrypt;
  var S = requireBrowser();
  return cryptoBrowserify.randomFill = S.randomFill, cryptoBrowserify.randomFillSync = S.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error([
      "sorry, createCredentials is not implemented yet",
      "we accept pull requests",
      "https://github.com/crypto-browserify/crypto-browserify"
    ].join(`
`));
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var __createBinding$U = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$U = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$U = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$U(n, e, o);
  return __setModuleDefault$U(n, e), n;
};
Object.defineProperty(pbkdf2$9, "__esModule", { value: !0 });
pbkdf2$9.pbkdf2Sha512 = pbkdf2$9.pbkdf2Sha512Noble = pbkdf2$9.pbkdf2Sha512NodeCrypto = pbkdf2$9.pbkdf2Sha512Subtle = pbkdf2$9.getSubtle = pbkdf2$9.getNodeCrypto = void 0;
const utils_1$1e = build$U, pbkdf2_1$f = pbkdf2$8, sha512_1$g = sha512$a;
async function getNodeCrypto$6() {
  try {
    const e = await Promise.resolve().then(() => __importStar$U(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2$9.getNodeCrypto = getNodeCrypto$6;
async function getSubtle$7() {
  var n, o, u;
  let e = (n = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : n.subtle;
  return e || (e = (u = (o = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : o.webcrypto) == null ? void 0 : u.subtle), e;
}
pbkdf2$9.getSubtle = getSubtle$7;
async function pbkdf2Sha512Subtle$7(e, n, o, u, c) {
  return (0, utils_1$1e.assert)(e, "Argument subtle is falsy"), (0, utils_1$1e.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$1e.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$1e.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", n, { name: "PBKDF2" }, !1, ["deriveBits"]).then((d) => e.deriveBits({
    name: "PBKDF2",
    salt: o,
    iterations: u,
    hash: { name: "SHA-512" }
  }, d, c * 8).then((m) => new Uint8Array(m)));
}
pbkdf2$9.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle$7;
async function pbkdf2Sha512NodeCrypto$6(e, n, o, u, c) {
  return (0, utils_1$1e.assert)(e, "Argument nodeCrypto is falsy"), (0, utils_1$1e.assert)(typeof e == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$1e.assert)(typeof e.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((d, m) => {
    e.pbkdf2(n, o, u, c, "sha512", (v, S) => {
      v ? m(v) : d(Uint8Array.from(S));
    });
  });
}
pbkdf2$9.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto$6;
async function pbkdf2Sha512Noble$7(e, n, o, u) {
  return (0, pbkdf2_1$f.pbkdf2Async)(sha512_1$g.sha512, e, n, { c: o, dkLen: u });
}
pbkdf2$9.pbkdf2Sha512Noble = pbkdf2Sha512Noble$7;
async function pbkdf2Sha512$7(e, n, o, u) {
  const c = await getSubtle$7();
  if (c)
    return pbkdf2Sha512Subtle$7(c, e, n, o, u);
  {
    const d = await getNodeCrypto$6();
    return d ? pbkdf2Sha512NodeCrypto$6(d, e, n, o, u) : pbkdf2Sha512Noble$7(e, n, o, u);
  }
}
pbkdf2$9.pbkdf2Sha512 = pbkdf2Sha512$7;
var sha$7 = {}, sha256$8 = {};
Object.defineProperty(sha256$8, "__esModule", { value: !0 });
sha256$8.sha224 = sha256$8.sha256 = void 0;
const _sha2_js_1$1 = _sha2, utils_js_1$2 = utils$Z, Chi = (e, n, o) => e & n ^ ~e & o, Maj = (e, n, o) => e & n ^ e & o ^ n & o, SHA256_K = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), IV = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W = new Uint32Array(64);
class SHA256 extends _sha2_js_1$1.SHA2 {
  constructor() {
    super(64, 32, 8, !1), this.A = IV[0] | 0, this.B = IV[1] | 0, this.C = IV[2] | 0, this.D = IV[3] | 0, this.E = IV[4] | 0, this.F = IV[5] | 0, this.G = IV[6] | 0, this.H = IV[7] | 0;
  }
  get() {
    const { A: n, B: o, C: u, D: c, E: d, F: m, G: v, H: S } = this;
    return [n, o, u, c, d, m, v, S];
  }
  // prettier-ignore
  set(n, o, u, c, d, m, v, S) {
    this.A = n | 0, this.B = o | 0, this.C = u | 0, this.D = c | 0, this.E = d | 0, this.F = m | 0, this.G = v | 0, this.H = S | 0;
  }
  process(n, o) {
    for (let O = 0; O < 16; O++, o += 4)
      SHA256_W[O] = n.getUint32(o, !1);
    for (let O = 16; O < 64; O++) {
      const T = SHA256_W[O - 15], y = SHA256_W[O - 2], V = (0, utils_js_1$2.rotr)(T, 7) ^ (0, utils_js_1$2.rotr)(T, 18) ^ T >>> 3, M = (0, utils_js_1$2.rotr)(y, 17) ^ (0, utils_js_1$2.rotr)(y, 19) ^ y >>> 10;
      SHA256_W[O] = M + SHA256_W[O - 7] + V + SHA256_W[O - 16] | 0;
    }
    let { A: u, B: c, C: d, D: m, E: v, F: S, G: $, H: E } = this;
    for (let O = 0; O < 64; O++) {
      const T = (0, utils_js_1$2.rotr)(v, 6) ^ (0, utils_js_1$2.rotr)(v, 11) ^ (0, utils_js_1$2.rotr)(v, 25), y = E + T + Chi(v, S, $) + SHA256_K[O] + SHA256_W[O] | 0, M = ((0, utils_js_1$2.rotr)(u, 2) ^ (0, utils_js_1$2.rotr)(u, 13) ^ (0, utils_js_1$2.rotr)(u, 22)) + Maj(u, c, d) | 0;
      E = $, $ = S, S = v, v = m + y | 0, m = d, d = c, c = u, u = y + M | 0;
    }
    u = u + this.A | 0, c = c + this.B | 0, d = d + this.C | 0, m = m + this.D | 0, v = v + this.E | 0, S = S + this.F | 0, $ = $ + this.G | 0, E = E + this.H | 0, this.set(u, c, d, m, v, S, $, E);
  }
  roundClean() {
    SHA256_W.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
class SHA224 extends SHA256 {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
sha256$8.sha256 = (0, utils_js_1$2.wrapConstructor)(() => new SHA256());
sha256$8.sha224 = (0, utils_js_1$2.wrapConstructor)(() => new SHA224());
var utils$B = {};
Object.defineProperty(utils$B, "__esModule", { value: !0 });
utils$B.toRealUint8Array = void 0;
function toRealUint8Array$7(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$B.toRealUint8Array = toRealUint8Array$7;
Object.defineProperty(sha$7, "__esModule", { value: !0 });
sha$7.sha512 = sha$7.Sha512 = sha$7.sha256 = sha$7.Sha256 = void 0;
const sha256_1$8 = sha256$8, sha512_1$f = sha512$a, utils_1$1d = utils$B;
let Sha256$7 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha256_1$8.sha256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$1d.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$7.Sha256 = Sha256$7;
function sha256$7(e) {
  return new Sha256$7(e).digest();
}
sha$7.sha256 = sha256$7;
let Sha512$7 = class {
  constructor(n) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$f.sha512.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$1d.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$7.Sha512 = Sha512$7;
function sha512$7(e) {
  return new Sha512$7(e).digest();
}
sha$7.sha512 = sha512$7;
Object.defineProperty(bip39$7, "__esModule", { value: !0 });
bip39$7.Bip39 = bip39$7.EnglishMnemonic = bip39$7.mnemonicToEntropy = bip39$7.entropyToMnemonic = void 0;
const encoding_1$1s = build$V, pbkdf2_1$e = pbkdf2$9, sha_1$7 = sha$7, wordlist$7 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring$7(e) {
  return Array.from(e).map((n) => n.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits$7(e) {
  const o = e.length * 8 / 32, u = (0, sha_1$7.sha256)(e);
  return bytesToBitstring$7(u).slice(0, o);
}
function bitstringToByte$7(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths$7 = [16, 20, 24, 28, 32], allowedWordLengths$7 = [12, 15, 18, 21, 24];
function entropyToMnemonic$7(e) {
  if (allowedEntropyLengths$7.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const n = bytesToBitstring$7(e), o = deriveChecksumBits$7(e);
  return (n + o).match(/(.{11})/g).map((m) => {
    const v = bitstringToByte$7(m);
    return wordlist$7[v];
  }).join(" ");
}
bip39$7.entropyToMnemonic = entropyToMnemonic$7;
const invalidNumberOfWorks$7 = "Invalid number of words", wordNotInWordlist$7 = "Found word that is not in the wordlist", invalidEntropy$7 = "Invalid entropy", invalidChecksum$7 = "Invalid mnemonic checksum";
function normalize$7(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy$7(e) {
  const n = normalize$7(e).split(" ");
  if (!allowedWordLengths$7.includes(n.length))
    throw new Error(invalidNumberOfWorks$7);
  const o = n.map(($) => {
    const E = wordlist$7.indexOf($);
    if (E === -1)
      throw new Error(wordNotInWordlist$7);
    return E.toString(2).padStart(11, "0");
  }).join(""), u = Math.floor(o.length / 33) * 32, c = o.slice(0, u), d = o.slice(u), m = c.match(/(.{1,8})/g).map(bitstringToByte$7);
  if (m.length < 16 || m.length > 32 || m.length % 4 !== 0)
    throw new Error(invalidEntropy$7);
  const v = Uint8Array.from(m);
  if (deriveChecksumBits$7(v) !== d)
    throw new Error(invalidChecksum$7);
  return v;
}
bip39$7.mnemonicToEntropy = mnemonicToEntropy$7;
let EnglishMnemonic$7 = class Ou {
  constructor(n) {
    if (!Ou.mnemonicMatcher.test(n))
      throw new Error("Invalid mnemonic format");
    const o = n.split(" "), u = [12, 15, 18, 21, 24];
    if (u.indexOf(o.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${u} got: ${o.length})`);
    for (const c of o)
      if (Ou.wordlist.indexOf(c) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy$7(n), this.data = n;
  }
  toString() {
    return this.data;
  }
};
bip39$7.EnglishMnemonic = EnglishMnemonic$7;
EnglishMnemonic$7.wordlist = wordlist$7;
EnglishMnemonic$7.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
let Bip39$7 = class {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(n) {
    return new EnglishMnemonic$7(entropyToMnemonic$7(n));
  }
  static decode(n) {
    return mnemonicToEntropy$7(n.toString());
  }
  static async mnemonicToSeed(n, o) {
    const u = (0, encoding_1$1s.toUtf8)(normalize$7(n.toString())), c = "mnemonic" + (o ? normalize$7(o) : ""), d = (0, encoding_1$1s.toUtf8)(c);
    return (0, pbkdf2_1$e.pbkdf2Sha512)(u, d, 2048, 64);
  }
};
bip39$7.Bip39 = Bip39$7;
var hmac$7 = {};
Object.defineProperty(hmac$7, "__esModule", { value: !0 });
hmac$7.Hmac = void 0;
let Hmac$7 = class {
  constructor(n, o) {
    const u = new n().blockSize;
    this.hash = (d) => new n().update(d).digest();
    let c = o;
    if (c.length > u && (c = this.hash(c)), c.length < u) {
      const d = new Uint8Array(u - c.length);
      c = new Uint8Array([...c, ...d]);
    }
    this.oKeyPad = c.map((d) => d ^ 92), this.iKeyPad = c.map((d) => d ^ 54), this.messageHasher = new n(), this.blockSize = u, this.update(this.iKeyPad);
  }
  update(n) {
    return this.messageHasher.update(n), this;
  }
  digest() {
    const n = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...n]));
  }
};
hmac$7.Hmac = Hmac$7;
var keccak$7 = {}, sha3$3 = {};
Object.defineProperty(sha3$3, "__esModule", { value: !0 });
sha3$3.shake256 = sha3$3.shake128 = sha3$3.keccak_512 = sha3$3.keccak_384 = sha3$3.keccak_256 = sha3$3.keccak_224 = sha3$3.sha3_512 = sha3$3.sha3_384 = sha3$3.sha3_256 = sha3$3.sha3_224 = sha3$3.Keccak = sha3$3.keccakP = void 0;
const _assert_js_1 = _assert, _u64_js_1 = _u64, utils_js_1$1 = utils$Z, [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [[], [], []], _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _7n = BigInt(7), _256n = BigInt(256), _0x71n = BigInt(113);
for (let e = 0, n = _1n, o = 1, u = 0; e < 24; e++) {
  [o, u] = [u, (2 * o + 3 * u) % 5], SHA3_PI.push(2 * (5 * u + o)), SHA3_ROTL.push((e + 1) * (e + 2) / 2 % 64);
  let c = _0n;
  for (let d = 0; d < 7; d++)
    n = (n << _1n ^ (n >> _7n) * _0x71n) % _256n, n & _2n && (c ^= _1n << (_1n << BigInt(d)) - _1n);
  _SHA3_IOTA.push(c);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = _u64_js_1.default.split(_SHA3_IOTA, !0), rotlH = (e, n, o) => o > 32 ? _u64_js_1.default.rotlBH(e, n, o) : _u64_js_1.default.rotlSH(e, n, o), rotlL = (e, n, o) => o > 32 ? _u64_js_1.default.rotlBL(e, n, o) : _u64_js_1.default.rotlSL(e, n, o);
function keccakP(e, n = 24) {
  const o = new Uint32Array(10);
  for (let u = 24 - n; u < 24; u++) {
    for (let m = 0; m < 10; m++)
      o[m] = e[m] ^ e[m + 10] ^ e[m + 20] ^ e[m + 30] ^ e[m + 40];
    for (let m = 0; m < 10; m += 2) {
      const v = (m + 8) % 10, S = (m + 2) % 10, $ = o[S], E = o[S + 1], O = rotlH($, E, 1) ^ o[v], T = rotlL($, E, 1) ^ o[v + 1];
      for (let y = 0; y < 50; y += 10)
        e[m + y] ^= O, e[m + y + 1] ^= T;
    }
    let c = e[2], d = e[3];
    for (let m = 0; m < 24; m++) {
      const v = SHA3_ROTL[m], S = rotlH(c, d, v), $ = rotlL(c, d, v), E = SHA3_PI[m];
      c = e[E], d = e[E + 1], e[E] = S, e[E + 1] = $;
    }
    for (let m = 0; m < 50; m += 10) {
      for (let v = 0; v < 10; v++)
        o[v] = e[m + v];
      for (let v = 0; v < 10; v++)
        e[m + v] ^= ~o[(v + 2) % 10] & o[(v + 4) % 10];
    }
    e[0] ^= SHA3_IOTA_H[u], e[1] ^= SHA3_IOTA_L[u];
  }
  o.fill(0);
}
sha3$3.keccakP = keccakP;
class Keccak extends utils_js_1$1.Hash {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(n, o, u, c = !1, d = 24) {
    if (super(), this.blockLen = n, this.suffix = o, this.outputLen = u, this.enableXOF = c, this.rounds = d, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, _assert_js_1.default.number(u), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = (0, utils_js_1$1.u32)(this.state);
  }
  keccak() {
    keccakP(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(n) {
    _assert_js_1.default.exists(this);
    const { blockLen: o, state: u } = this;
    n = (0, utils_js_1$1.toBytes)(n);
    const c = n.length;
    for (let d = 0; d < c; ) {
      const m = Math.min(o - this.pos, c - d);
      for (let v = 0; v < m; v++)
        u[this.pos++] ^= n[d++];
      this.pos === o && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: n, suffix: o, pos: u, blockLen: c } = this;
    n[u] ^= o, o & 128 && u === c - 1 && this.keccak(), n[c - 1] ^= 128, this.keccak();
  }
  writeInto(n) {
    _assert_js_1.default.exists(this, !1), _assert_js_1.default.bytes(n), this.finish();
    const o = this.state, { blockLen: u } = this;
    for (let c = 0, d = n.length; c < d; ) {
      this.posOut >= u && this.keccak();
      const m = Math.min(u - this.posOut, d - c);
      n.set(o.subarray(this.posOut, this.posOut + m), c), this.posOut += m, c += m;
    }
    return n;
  }
  xofInto(n) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(n);
  }
  xof(n) {
    return _assert_js_1.default.number(n), this.xofInto(new Uint8Array(n));
  }
  digestInto(n) {
    if (_assert_js_1.default.output(n, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(n), this.destroy(), n;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(n) {
    const { blockLen: o, suffix: u, outputLen: c, rounds: d, enableXOF: m } = this;
    return n || (n = new Keccak(o, u, c, m, d)), n.state32.set(this.state32), n.pos = this.pos, n.posOut = this.posOut, n.finished = this.finished, n.rounds = d, n.suffix = u, n.outputLen = c, n.enableXOF = m, n.destroyed = this.destroyed, n;
  }
}
sha3$3.Keccak = Keccak;
const gen = (e, n, o) => (0, utils_js_1$1.wrapConstructor)(() => new Keccak(n, e, o));
sha3$3.sha3_224 = gen(6, 144, 224 / 8);
sha3$3.sha3_256 = gen(6, 136, 256 / 8);
sha3$3.sha3_384 = gen(6, 104, 384 / 8);
sha3$3.sha3_512 = gen(6, 72, 512 / 8);
sha3$3.keccak_224 = gen(1, 144, 224 / 8);
sha3$3.keccak_256 = gen(1, 136, 256 / 8);
sha3$3.keccak_384 = gen(1, 104, 384 / 8);
sha3$3.keccak_512 = gen(1, 72, 512 / 8);
const genShake = (e, n, o) => (0, utils_js_1$1.wrapConstructorWithOpts)((u = {}) => new Keccak(n, e, u.dkLen === void 0 ? o : u.dkLen, !0));
sha3$3.shake128 = genShake(31, 168, 128 / 8);
sha3$3.shake256 = genShake(31, 136, 256 / 8);
Object.defineProperty(keccak$7, "__esModule", { value: !0 });
keccak$7.keccak256 = keccak$7.Keccak256 = void 0;
const sha3_1$7 = sha3$3, utils_1$1c = utils$B;
let Keccak256$7 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha3_1$7.keccak_256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$1c.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
keccak$7.Keccak256 = Keccak256$7;
function keccak256$8(e) {
  return new Keccak256$7(e).digest();
}
keccak$7.keccak256 = keccak256$8;
var libsodium$8 = {}, libsodiumWrappers$1 = {};
const __dirname$1 = "/home/runner/work/oraiscan-widget/oraiscan-widget/node_modules/libsodium/dist/modules";
var libsodium$7 = { exports: {} }, pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify)
    return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function e(c) {
    if (typeof c != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(c));
  }
  function n(c, d) {
    for (var m = "", v = 0, S = -1, $ = 0, E, O = 0; O <= c.length; ++O) {
      if (O < c.length)
        E = c.charCodeAt(O);
      else {
        if (E === 47)
          break;
        E = 47;
      }
      if (E === 47) {
        if (!(S === O - 1 || $ === 1))
          if (S !== O - 1 && $ === 2) {
            if (m.length < 2 || v !== 2 || m.charCodeAt(m.length - 1) !== 46 || m.charCodeAt(m.length - 2) !== 46) {
              if (m.length > 2) {
                var T = m.lastIndexOf("/");
                if (T !== m.length - 1) {
                  T === -1 ? (m = "", v = 0) : (m = m.slice(0, T), v = m.length - 1 - m.lastIndexOf("/")), S = O, $ = 0;
                  continue;
                }
              } else if (m.length === 2 || m.length === 1) {
                m = "", v = 0, S = O, $ = 0;
                continue;
              }
            }
            d && (m.length > 0 ? m += "/.." : m = "..", v = 2);
          } else
            m.length > 0 ? m += "/" + c.slice(S + 1, O) : m = c.slice(S + 1, O), v = O - S - 1;
        S = O, $ = 0;
      } else
        E === 46 && $ !== -1 ? ++$ : $ = -1;
    }
    return m;
  }
  function o(c, d) {
    var m = d.dir || d.root, v = d.base || (d.name || "") + (d.ext || "");
    return m ? m === d.root ? m + v : m + c + v : v;
  }
  var u = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var d = "", m = !1, v, S = arguments.length - 1; S >= -1 && !m; S--) {
        var $;
        S >= 0 ? $ = arguments[S] : (v === void 0 && (v = browser$1$1.cwd()), $ = v), e($), $.length !== 0 && (d = $ + "/" + d, m = $.charCodeAt(0) === 47);
      }
      return d = n(d, !m), m ? d.length > 0 ? "/" + d : "/" : d.length > 0 ? d : ".";
    },
    normalize: function(d) {
      if (e(d), d.length === 0)
        return ".";
      var m = d.charCodeAt(0) === 47, v = d.charCodeAt(d.length - 1) === 47;
      return d = n(d, !m), d.length === 0 && !m && (d = "."), d.length > 0 && v && (d += "/"), m ? "/" + d : d;
    },
    isAbsolute: function(d) {
      return e(d), d.length > 0 && d.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var d, m = 0; m < arguments.length; ++m) {
        var v = arguments[m];
        e(v), v.length > 0 && (d === void 0 ? d = v : d += "/" + v);
      }
      return d === void 0 ? "." : u.normalize(d);
    },
    relative: function(d, m) {
      if (e(d), e(m), d === m || (d = u.resolve(d), m = u.resolve(m), d === m))
        return "";
      for (var v = 1; v < d.length && d.charCodeAt(v) === 47; ++v)
        ;
      for (var S = d.length, $ = S - v, E = 1; E < m.length && m.charCodeAt(E) === 47; ++E)
        ;
      for (var O = m.length, T = O - E, y = $ < T ? $ : T, V = -1, M = 0; M <= y; ++M) {
        if (M === y) {
          if (T > y) {
            if (m.charCodeAt(E + M) === 47)
              return m.slice(E + M + 1);
            if (M === 0)
              return m.slice(E + M);
          } else
            $ > y && (d.charCodeAt(v + M) === 47 ? V = M : M === 0 && (V = 0));
          break;
        }
        var G = d.charCodeAt(v + M), k = m.charCodeAt(E + M);
        if (G !== k)
          break;
        G === 47 && (V = M);
      }
      var F = "";
      for (M = v + V + 1; M <= S; ++M)
        (M === S || d.charCodeAt(M) === 47) && (F.length === 0 ? F += ".." : F += "/..");
      return F.length > 0 ? F + m.slice(E + V) : (E += V, m.charCodeAt(E) === 47 && ++E, m.slice(E));
    },
    _makeLong: function(d) {
      return d;
    },
    dirname: function(d) {
      if (e(d), d.length === 0)
        return ".";
      for (var m = d.charCodeAt(0), v = m === 47, S = -1, $ = !0, E = d.length - 1; E >= 1; --E)
        if (m = d.charCodeAt(E), m === 47) {
          if (!$) {
            S = E;
            break;
          }
        } else
          $ = !1;
      return S === -1 ? v ? "/" : "." : v && S === 1 ? "//" : d.slice(0, S);
    },
    basename: function(d, m) {
      if (m !== void 0 && typeof m != "string")
        throw new TypeError('"ext" argument must be a string');
      e(d);
      var v = 0, S = -1, $ = !0, E;
      if (m !== void 0 && m.length > 0 && m.length <= d.length) {
        if (m.length === d.length && m === d)
          return "";
        var O = m.length - 1, T = -1;
        for (E = d.length - 1; E >= 0; --E) {
          var y = d.charCodeAt(E);
          if (y === 47) {
            if (!$) {
              v = E + 1;
              break;
            }
          } else
            T === -1 && ($ = !1, T = E + 1), O >= 0 && (y === m.charCodeAt(O) ? --O === -1 && (S = E) : (O = -1, S = T));
        }
        return v === S ? S = T : S === -1 && (S = d.length), d.slice(v, S);
      } else {
        for (E = d.length - 1; E >= 0; --E)
          if (d.charCodeAt(E) === 47) {
            if (!$) {
              v = E + 1;
              break;
            }
          } else
            S === -1 && ($ = !1, S = E + 1);
        return S === -1 ? "" : d.slice(v, S);
      }
    },
    extname: function(d) {
      e(d);
      for (var m = -1, v = 0, S = -1, $ = !0, E = 0, O = d.length - 1; O >= 0; --O) {
        var T = d.charCodeAt(O);
        if (T === 47) {
          if (!$) {
            v = O + 1;
            break;
          }
          continue;
        }
        S === -1 && ($ = !1, S = O + 1), T === 46 ? m === -1 ? m = O : E !== 1 && (E = 1) : m !== -1 && (E = -1);
      }
      return m === -1 || S === -1 || // We saw a non-dot character immediately before the dot
      E === 0 || // The (right-most) trimmed path component is exactly '..'
      E === 1 && m === S - 1 && m === v + 1 ? "" : d.slice(m, S);
    },
    format: function(d) {
      if (d === null || typeof d != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof d);
      return o("/", d);
    },
    parse: function(d) {
      e(d);
      var m = { root: "", dir: "", base: "", ext: "", name: "" };
      if (d.length === 0)
        return m;
      var v = d.charCodeAt(0), S = v === 47, $;
      S ? (m.root = "/", $ = 1) : $ = 0;
      for (var E = -1, O = 0, T = -1, y = !0, V = d.length - 1, M = 0; V >= $; --V) {
        if (v = d.charCodeAt(V), v === 47) {
          if (!y) {
            O = V + 1;
            break;
          }
          continue;
        }
        T === -1 && (y = !1, T = V + 1), v === 46 ? E === -1 ? E = V : M !== 1 && (M = 1) : E !== -1 && (M = -1);
      }
      return E === -1 || T === -1 || // We saw a non-dot character immediately before the dot
      M === 0 || // The (right-most) trimmed path component is exactly '..'
      M === 1 && E === T - 1 && E === O + 1 ? T !== -1 && (O === 0 && S ? m.base = m.name = d.slice(1, T) : m.base = m.name = d.slice(O, T)) : (O === 0 && S ? (m.name = d.slice(1, E), m.base = d.slice(1, T)) : (m.name = d.slice(O, E), m.base = d.slice(O, T)), m.ext = d.slice(E, T)), O > 0 ? m.dir = d.slice(0, O - 1) : S && (m.dir = "/"), m;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return u.posix = u, pathBrowserify = u, pathBrowserify;
}
var hasRequiredLibsodium;
function requireLibsodium() {
  return hasRequiredLibsodium || (hasRequiredLibsodium = 1, function(e, n) {
    (function(o) {
      function u(c) {
        var d;
        (d = c) === void 0 && (d = {});
        var m = d;
        typeof m.sodium != "object" && (typeof commonjsGlobal == "object" ? m = commonjsGlobal : typeof window == "object" && (m = window));
        var v = d;
        return d.ready = new Promise(function(S, $) {
          (y = v).onAbort = $, y.print = function(At) {
          }, y.printErr = function(At) {
          }, y.onRuntimeInitialized = function() {
            try {
              y._crypto_secretbox_keybytes(), S();
            } catch (At) {
              $(At);
            }
          }, y.useBackupModule = function() {
            return new Promise(function(At, hn) {
              (ce = {}).onAbort = hn, ce.onRuntimeInitialized = function() {
                Object.keys(v).forEach(function(xn) {
                  xn !== "getRandomValue" && delete v[xn];
                }), Object.keys(ce).forEach(function(xn) {
                  v[xn] = ce[xn];
                }), At();
              };
              var $t, Lt, Qn, ce = ce !== void 0 ? ce : {}, Ze = Object.assign({}, ce), ft = typeof window == "object", It = typeof importScripts == "function", rn = typeof browser$1$1 == "object" && typeof browser$1$1.versions == "object" && typeof browser$1$1.versions.node == "string", Ln = "";
              if (rn) {
                var Pn = require$$0$3, Ae = requirePathBrowserify();
                Ln = It ? Ae.dirname(Ln) + "/" : __dirname$1 + "/", $t = (xn, sr) => {
                  var Nr = ii(xn);
                  return Nr ? sr ? Nr : Nr.toString() : (xn = No(xn) ? new URL(xn) : Ae.normalize(xn), Pn.readFileSync(xn, sr ? void 0 : "utf8"));
                }, Qn = (xn) => {
                  var sr = $t(xn, !0);
                  return sr.buffer || (sr = new Uint8Array(sr)), sr;
                }, Lt = (xn, sr, Nr) => {
                  var vr = ii(xn);
                  vr && sr(vr), xn = No(xn) ? new URL(xn) : Ae.normalize(xn), Pn.readFile(xn, function(Yr, Fr) {
                    Yr ? Nr(Yr) : sr(Fr.buffer);
                  });
                }, browser$1$1.argv.length > 1 && browser$1$1.argv[1].replace(/\\/g, "/"), browser$1$1.argv.slice(2), e.exports = ce, ce.inspect = function() {
                  return "[Emscripten Module object]";
                };
              } else
                (ft || It) && (It ? Ln = self.location.href : typeof document < "u" && document.currentScript && (Ln = document.currentScript.src), Ln = Ln.indexOf("blob:") !== 0 ? Ln.substr(0, Ln.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", $t = (xn) => {
                  try {
                    var sr = new XMLHttpRequest();
                    return sr.open("GET", xn, !1), sr.send(null), sr.responseText;
                  } catch (vr) {
                    var Nr = ii(xn);
                    if (Nr)
                      return function(Yr) {
                        for (var Fr = [], eo = 0; eo < Yr.length; eo++) {
                          var Xr = Yr[eo];
                          Xr > 255 && (Xr &= 255), Fr.push(String.fromCharCode(Xr));
                        }
                        return Fr.join("");
                      }(Nr);
                    throw vr;
                  }
                }, It && (Qn = (xn) => {
                  try {
                    var sr = new XMLHttpRequest();
                    return sr.open("GET", xn, !1), sr.responseType = "arraybuffer", sr.send(null), new Uint8Array(sr.response);
                  } catch (vr) {
                    var Nr = ii(xn);
                    if (Nr)
                      return Nr;
                    throw vr;
                  }
                }), Lt = (xn, sr, Nr) => {
                  var vr = new XMLHttpRequest();
                  vr.open("GET", xn, !0), vr.responseType = "arraybuffer", vr.onload = () => {
                    if (vr.status == 200 || vr.status == 0 && vr.response)
                      sr(vr.response);
                    else {
                      var Yr = ii(xn);
                      Yr ? sr(Yr.buffer) : Nr();
                    }
                  }, vr.onerror = Nr, vr.send(null);
                });
              ce.print;
              var Me, He = ce.printErr || void 0;
              Object.assign(ce, Ze), Ze = null, ce.arguments && ce.arguments, ce.thisProgram && ce.thisProgram, ce.quit && ce.quit, ce.wasmBinary && (Me = ce.wasmBinary), ce.noExitRuntime;
              var cn, Wt = { Memory: function(xn) {
                this.buffer = new ArrayBuffer(65536 * xn.initial);
              }, Module: function(xn) {
              }, Instance: function(xn, sr) {
                this.exports = function(Nr) {
                  for (var vr, Yr = new Uint8Array(123), Fr = 25; Fr >= 0; --Fr)
                    Yr[48 + Fr] = 52 + Fr, Yr[65 + Fr] = Fr, Yr[97 + Fr] = 26 + Fr;
                  function eo(Mo, jo, Ii) {
                    for (var ki, j, l = 0, B = jo, Ri = Ii.length, wr = jo + (3 * Ri >> 2) - (Ii[Ri - 2] == "=") - (Ii[Ri - 1] == "="); l < Ri; l += 4)
                      ki = Yr[Ii.charCodeAt(l + 1)], j = Yr[Ii.charCodeAt(l + 2)], Mo[B++] = Yr[Ii.charCodeAt(l)] << 2 | ki >> 4, B < wr && (Mo[B++] = ki << 4 | j >> 2), B < wr && (Mo[B++] = j << 6 | Yr[Ii.charCodeAt(l + 3)]);
                  }
                  function Xr() {
                    throw new Error("abort");
                  }
                  return Yr[43] = 62, Yr[47] = 63, function(Mo) {
                    var jo = Mo.a, Ii = jo.a, ki = Ii.buffer;
                    Ii.grow = function(L) {
                      L |= 0;
                      var Z = 0 | Xa(), le = Z + L | 0;
                      if (Z < le && le < 65536) {
                        var ae = new ArrayBuffer(wr(le, 65536));
                        new Int8Array(ae).set(j), j = new Int8Array(ae), l = new Int32Array(ae), B = new Uint8Array(ae), Ri = new Uint32Array(ae), ki = ae, Ii.buffer = ki, vr = B;
                      }
                      return Z;
                    };
                    var j = new Int8Array(ki), l = new Int32Array(ki), B = new Uint8Array(ki), Ri = new Uint32Array(ki), wr = Math.imul, zi = Math.clz32, ks = jo.b, Hs = jo.c, Oa = jo.d, qa = jo.e, st = 101744, Oe = 0;
                    function Bs(L, Z) {
                      var le, ae, de, Ie, Qe, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0, kr = 0, Qr = 0, Ur = 0, Lr = 0, Jr = 0, jr = 0, oo = 0, uo = 0, _o = 0, So = 0, Ao = 0, bo = 0, xr = 0, Oo = 0, Yn = 0, ir = 0, Bt = 0, Jt = 0, mn = 0, Hr = 0, Vr = 0, ro = 0, io = 0, fo = 0, po = 0, mo = 0, ho = 0, tn = 0, Eo = 0, To = 0, Do = 0, Lo = 0, Ho = 0, Vo = 0, ri = 0, ci = 0, li = 0, mi = 0, yi = 0, Mi = 0;
                      fo = B[Z + 40 | 0] | B[Z + 41 | 0] << 8 | B[Z + 42 | 0] << 16 | B[Z + 43 | 0] << 24, mo = q = B[Z + 44 | 0] | B[Z + 45 | 0] << 8 | B[Z + 46 | 0] << 16 | B[Z + 47 | 0] << 24, xr = B[Z + 104 | 0] | B[Z + 105 | 0] << 8 | B[Z + 106 | 0] << 16 | B[Z + 107 | 0] << 24, ho = q = B[Z + 108 | 0] | B[Z + 109 | 0] << 8 | B[Z + 110 | 0] << 16 | B[Z + 111 | 0] << 24, q = B[Z + 68 | 0] | B[Z + 69 | 0] << 8 | B[Z + 70 | 0] << 16 | B[Z + 71 | 0] << 24, Ur = B[Z + 64 | 0] | B[Z + 65 | 0] << 8 | B[Z + 66 | 0] << 16 | B[Z + 67 | 0] << 24, Yn = q, li = q = B[Z + 36 | 0] | B[Z + 37 | 0] << 8 | B[Z + 38 | 0] << 16 | B[Z + 39 | 0] << 24, gn = q, mn = B[Z + 120 | 0] | B[Z + 121 | 0] << 8 | B[Z + 122 | 0] << 16 | B[Z + 123 | 0] << 24, Do = q = B[Z + 124 | 0] | B[Z + 125 | 0] << 8 | B[Z + 126 | 0] << 16 | B[Z + 127 | 0] << 24, de = q = B[Z + 92 | 0] | B[Z + 93 | 0] << 8 | B[Z + 94 | 0] << 16 | B[Z + 95 | 0] << 24, le = B[Z + 88 | 0] | B[Z + 89 | 0] << 8 | B[Z + 90 | 0] << 16 | B[Z + 91 | 0] << 24, Qr = q, Jt = B[Z + 80 | 0] | B[Z + 81 | 0] << 8 | B[Z + 82 | 0] << 16 | B[Z + 83 | 0] << 24, Eo = q = B[Z + 84 | 0] | B[Z + 85 | 0] << 8 | B[Z + 86 | 0] << 16 | B[Z + 87 | 0] << 24, Lr = q, ir = B[L + 16 | 0] | B[L + 17 | 0] << 8 | B[L + 18 | 0] << 16 | B[L + 19 | 0] << 24, q = (Vr = B[L + 52 | 0] | B[L + 53 | 0] << 8 | B[L + 54 | 0] << 16 | B[L + 55 | 0] << 24) + gn | 0, br = (Hr = B[L + 48 | 0] | B[L + 49 | 0] << 8 | B[L + 50 | 0] << 16 | B[L + 51 | 0] << 24) + (ro = B[Z + 32 | 0] | B[Z + 33 | 0] << 8 | B[Z + 34 | 0] << 16 | B[Z + 35 | 0] << 24) | 0, q = (B[L + 20 | 0] | B[L + 21 | 0] << 8 | B[L + 22 | 0] << 16 | B[L + 23 | 0] << 24) + (Hr >>> 0 > br >>> 0 ? q + 1 | 0 : q) | 0, q = (ir = (be = br) >>> 0 > (br = br + ir | 0) >>> 0 ? q + 1 | 0 : q) + mo | 0, Bt = po = br + fo | 0, po = q = po >>> 0 < br >>> 0 ? q + 1 | 0 : q, br = vt(br ^ (B[L + 80 | 0] | B[L + 81 | 0] << 8 | B[L + 82 | 0] << 16 | B[L + 83 | 0] << 24) ^ -79577749, ir ^ (B[L + 84 | 0] | B[L + 85 | 0] << 8 | B[L + 86 | 0] << 16 | B[L + 87 | 0] << 24) ^ 528734635, 32), Vo = q = Oe, q = q + 1013904242 | 0, ir = br, oo = q = (br = br - 23791573 | 0) >>> 0 < 4271175723 ? q + 1 | 0 : q, Vr = vt(br ^ Hr, q ^ Vr, 40), q = (q = po) + (po = Oe) | 0, Hr = vt(ir ^ (ot = Hr = Vr + Bt | 0), Vo ^ (_t = ot >>> 0 < Vr >>> 0 ? q + 1 | 0 : q), 48), q = oo + (jn = Oe) | 0, Mt = q = (Hr = br + (qt = Hr) | 0) >>> 0 < br >>> 0 ? q + 1 | 0 : q, Hr = q = vt(Vr ^ (xt = Hr), po ^ q, 1), oo = br = Oe, po = B[Z + 24 | 0] | B[Z + 25 | 0] << 8 | B[Z + 26 | 0] << 16 | B[Z + 27 | 0] << 24, Vo = q = B[Z + 28 | 0] | B[Z + 29 | 0] << 8 | B[Z + 30 | 0] << 16 | B[Z + 31 | 0] << 24, io = B[L + 8 | 0] | B[L + 9 | 0] << 8 | B[L + 10 | 0] << 16 | B[L + 11 | 0] << 24, br = (Vr = B[Z + 16 | 0] | B[Z + 17 | 0] << 8 | B[Z + 18 | 0] << 16 | B[Z + 19 | 0] << 24) + (ir = B[L + 40 | 0] | B[L + 41 | 0] << 8 | B[L + 42 | 0] << 16 | B[L + 43 | 0] << 24) | 0, q = (mi = B[Z + 20 | 0] | B[Z + 21 | 0] << 8 | B[Z + 22 | 0] << 16 | B[Z + 23 | 0] << 24) + (Mi = B[L + 44 | 0] | B[L + 45 | 0] << 8 | B[L + 46 | 0] << 16 | B[L + 47 | 0] << 24) | 0, q = (B[L + 12 | 0] | B[L + 13 | 0] << 8 | B[L + 14 | 0] << 16 | B[L + 15 | 0] << 24) + (br >>> 0 < ir >>> 0 ? q + 1 | 0 : q) | 0, q = Vo + (Bt = (be = br) >>> 0 > (br = br + io | 0) >>> 0 ? q + 1 | 0 : q) | 0, q = (io = br + po | 0) >>> 0 < br >>> 0 ? q + 1 | 0 : q, be = vt(br ^ (B[L + 72 | 0] | B[L + 73 | 0] << 8 | B[L + 74 | 0] << 16 | B[L + 75 | 0] << 24) ^ 725511199, Bt ^ (B[L + 76 | 0] | B[L + 77 | 0] << 8 | B[L + 78 | 0] << 16 | B[L + 79 | 0] << 24) ^ -1694144372, 32), Ne = vt(ir ^ (Ue = be - 2067093701 | 0), Mi ^ (vn = (De = br = Oe) - ((be >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), q = (_r = Oe) + q | 0, q = (Dn = (Vt = br = Ne + io | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q) + oo | 0, q = (Vt >>> 0 > (br = Vt + Hr | 0) >>> 0 ? q + 1 | 0 : q) + Lr | 0, q = (ir = (Ye = br) >>> 0 > (br = br + Jt | 0) >>> 0 ? q + 1 | 0 : q) + Qr | 0, nr = Qr = br + le | 0, rt = q = Qr >>> 0 < br >>> 0 ? q + 1 | 0 : q, tt = Hr, Lo = oo, oo = br, Bt = ir, Hr = B[Z + 8 | 0] | B[Z + 9 | 0] << 8 | B[Z + 10 | 0] << 16 | B[Z + 11 | 0] << 24, br = q = B[Z + 12 | 0] | B[Z + 13 | 0] << 8 | B[Z + 14 | 0] << 16 | B[Z + 15 | 0] << 24, Mi = q = B[0 | L] | B[L + 1 | 0] << 8 | B[L + 2 | 0] << 16 | B[L + 3 | 0] << 24, Ie = ir = B[L + 4 | 0] | B[L + 5 | 0] << 8 | B[L + 6 | 0] << 16 | B[L + 7 | 0] << 24, Lr = q, q = (ri = B[Z + 4 | 0] | B[Z + 5 | 0] << 8 | B[Z + 6 | 0] << 16 | B[Z + 7 | 0] << 24) + (Te = B[L + 36 | 0] | B[L + 37 | 0] << 8 | B[L + 38 | 0] << 16 | B[L + 39 | 0] << 24) | 0, q = Ie + ((Qr = B[L + 32 | 0] | B[L + 33 | 0] << 8 | B[L + 34 | 0] << 16 | B[L + 35 | 0] << 24) >>> 0 > (Ye = Qr + (ir = B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24) | 0) >>> 0 ? q + 1 | 0 : q) | 0, q = (io = (Lr = Ye + Lr | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) + br | 0, To = Ye = Lr + Hr | 0, Ye = q = Ye >>> 0 < Lr >>> 0 ? q + 1 | 0 : q, We = Qr, Qr = vt(Lr ^ (B[0 | (q = L - -64 | 0)] | B[q + 1 | 0] << 8 | B[q + 2 | 0] << 16 | B[q + 3 | 0] << 24) ^ -1377402159, io ^ (B[q + 4 | 0] | B[q + 5 | 0] << 8 | B[q + 6 | 0] << 16 | B[q + 7 | 0] << 24) ^ 1359893119, 32), io = q = Oe, q = q + 1779033703 | 0, Lr = Qr, Dt = q = (Qr = Qr - 205731576 | 0) >>> 0 < 4089235720 ? q + 1 | 0 : q, Te = vt(We ^ (un = Qr), q ^ Te, 40), q = (Xn = Oe) + Ye | 0, We = vt(Lr ^ (Ye = Qr = Te + To | 0), io ^ (Bn = Te >>> 0 > Ye >>> 0 ? q + 1 | 0 : q), 48), q = vt(We ^ oo, (_o = Oe) ^ Bt, 32), jr = Qr = Oe, nn = q, ae = q = B[Z + 60 | 0] | B[Z + 61 | 0] << 8 | B[Z + 62 | 0] << 16 | B[Z + 63 | 0] << 24, io = To = B[Z + 56 | 0] | B[Z + 57 | 0] << 8 | B[Z + 58 | 0] << 16 | B[Z + 59 | 0] << 24, Pt = B[L + 24 | 0] | B[L + 25 | 0] << 8 | B[L + 26 | 0] << 16 | B[L + 27 | 0] << 24, Qr = (Bt = B[Z + 48 | 0] | B[Z + 49 | 0] << 8 | B[Z + 50 | 0] << 16 | B[Z + 51 | 0] << 24) + (Lr = B[L + 56 | 0] | B[L + 57 | 0] << 8 | B[L + 58 | 0] << 16 | B[L + 59 | 0] << 24) | 0, q = (ci = B[Z + 52 | 0] | B[Z + 53 | 0] << 8 | B[Z + 54 | 0] << 16 | B[Z + 55 | 0] << 24) + (Vn = B[L + 60 | 0] | B[L + 61 | 0] << 8 | B[L + 62 | 0] << 16 | B[L + 63 | 0] << 24) | 0, q = (B[L + 28 | 0] | B[L + 29 | 0] << 8 | B[L + 30 | 0] << 16 | B[L + 31 | 0] << 24) + (Qr >>> 0 < Lr >>> 0 ? q + 1 | 0 : q) | 0, q = ae + (oo = (Tn = Qr) >>> 0 > (Qr = Pt + Qr | 0) >>> 0 ? q + 1 | 0 : q) | 0, q = (Pt = Qr + io | 0) >>> 0 < Qr >>> 0 ? q + 1 | 0 : q, oo = vt(Qr ^ (B[L + 88 | 0] | B[L + 89 | 0] << 8 | B[L + 90 | 0] << 16 | B[L + 91 | 0] << 24) ^ 327033209, oo ^ (B[L + 92 | 0] | B[L + 93 | 0] << 8 | B[L + 94 | 0] << 16 | B[L + 95 | 0] << 24) ^ 1541459225, 32), Lr = vt(Lr ^ (io = oo + 1595750129 | 0), (Tn = Vn) ^ (Vn = (An = Qr = Oe) - ((oo >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), q = (bo = Oe) + q | 0, Qr = vt((Pt = Qr = Lr + Pt | 0) ^ oo, An ^ (Tn = Pt >>> 0 < Lr >>> 0 ? q + 1 | 0 : q), 48), q = Vn + (So = Oe) | 0, kn = q = (Qr = io + (Vn = Qr) | 0) >>> 0 < io >>> 0 ? q + 1 | 0 : q, q = jr + q | 0, Jr = tt ^ (oo = nn + (An = Qr) | 0), tt = q = oo >>> 0 < An >>> 0 ? q + 1 | 0 : q, io = vt(Jr, q ^ Lo, 40), q = (Lo = Oe) + rt | 0, Qr = vt(nr = nn ^ (rt = Qr = io + nr | 0), jr ^ (nn = rt >>> 0 < io >>> 0 ? q + 1 | 0 : q), 48), q = tt + (Oo = Oe) | 0, jr = q = (tt = oo + (nr = Qr) | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q, Qr = (zn = vt(tt ^ io, Lo ^ q, 1)) + (oo = B[Z + 72 | 0] | B[Z + 73 | 0] << 8 | B[Z + 74 | 0] << 16 | B[Z + 75 | 0] << 24) | 0, q = (tn = Oe) + (Lo = B[Z + 76 | 0] | B[Z + 77 | 0] << 8 | B[Z + 78 | 0] << 16 | B[Z + 79 | 0] << 24) | 0, Ho = Qr, kr = Qr >>> 0 < oo >>> 0 ? q + 1 | 0 : q, uo = ho, Qr = B[Z + 96 | 0] | B[Z + 97 | 0] << 8 | B[Z + 98 | 0] << 16 | B[Z + 99 | 0] << 24, io = q = B[Z + 100 | 0] | B[Z + 101 | 0] << 8 | B[Z + 102 | 0] << 16 | B[Z + 103 | 0] << 24, Lr = (q = ot) + (ot = vt(An ^ Lr, kn ^ bo, 1)) | 0, q = (An = Oe) + _t | 0, q = (ot >>> 0 > Lr >>> 0 ? q + 1 | 0 : q) + io | 0, q = (_t = (_t = Lr) >>> 0 > (Lr = Qr + Lr | 0) >>> 0 ? q + 1 | 0 : q) + uo | 0, Jr = kn = Lr + xr | 0, kn = q = kn >>> 0 < Lr >>> 0 ? q + 1 | 0 : q, Vt = vt(be ^ Vt, Dn ^ De, 48), Dn = q = vt(Vt ^ Lr, (De = Oe) ^ _t, 32), q = Dt + _o | 0, q = (bo = Lr = Oe) + (un = (Lr = We + un | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, Dt = q = (_t = Lr) >>> 0 > (We = _t + Dn | 0) >>> 0 ? q + 1 | 0 : q, ot = vt(We ^ ot, An ^ q, 40), q = (_o = Oe) + kn | 0, q = (An = ot >>> 0 > (kn = Lr = ot + Jr | 0) >>> 0 ? q + 1 | 0 : q) + kr | 0, q = (be = kn >>> 0 > (Lr = kn + Ho | 0) >>> 0 ? q + 1 | 0 : q) + Do | 0, Ho = kr = Lr + mn | 0, kr = q = kr >>> 0 < Lr >>> 0 ? q + 1 | 0 : q, Jr = Lr, uo = be, Lr = B[Z + 116 | 0] | B[Z + 117 | 0] << 8 | B[Z + 118 | 0] << 16 | B[Z + 119 | 0] << 24, Z = B[Z + 112 | 0] | B[Z + 113 | 0] << 8 | B[Z + 114 | 0] << 16 | B[Z + 115 | 0] << 24, Te = vt(Te ^ _t, un ^ Xn, 1), q = (Xn = Oe) + Tn | 0, q = ((be = Te + Pt | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q) + Lr | 0, q = (_t = (un = be) >>> 0 > (be = Z + be | 0) >>> 0 ? q + 1 | 0 : q) + Do | 0, yi = un = be + mn | 0, un = q = un >>> 0 < be >>> 0 ? q + 1 | 0 : q, q = vt(be ^ qt, _t ^ jn, 32), Ao = be = Oe, qt = q, _t = be, q = De + vn | 0, Vt = be = Ue + Vt | 0, Pt = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, q = q + _t | 0, Tn = be = be + qt | 0, jn = q = Vt >>> 0 > be >>> 0 ? q + 1 | 0 : q, _t = vt(be ^ Te, Xn ^ q, 40), q = (Xn = Oe) + un | 0, qt = vt((be = _t + yi | 0) ^ qt, Ao ^ (Ue = be >>> 0 < _t >>> 0 ? q + 1 | 0 : q), 48), q = vt(qt ^ Jr, (yi = Oe) ^ uo, 32), Ao = Te = Oe, un = q, Jr = Te, Ne = vt(Ne ^ Vt, Pt ^ _r, 1), q = Bn + (Vt = Oe) | 0, q = ((Te = Ye) >>> 0 > (Ye = Ye + Ne | 0) >>> 0 ? q + 1 | 0 : q) + Yn | 0, q = (Ye = (Te = Ye + Ur | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) + Lo | 0, uo = Bn = Te + oo | 0, Bn = q = Bn >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Pt = Ne, Te = vt(Te ^ Vn, Ye ^ So, 32), q = (Vn = Oe) + Mt | 0, xt = vt(Pt ^ (Ye = Ne = Te + xt | 0), (Mt = Te >>> 0 > Ye >>> 0 ? q + 1 | 0 : q) ^ Vt, 40), q = (So = Oe) + Bn | 0, Vt = Ne = xt + uo | 0, Ne = vt(Te ^ Ne, Vn ^ (Bn = Ne >>> 0 < xt >>> 0 ? q + 1 | 0 : q), 48), q = Mt + (Qe = Oe) | 0, Mt = Ne, Vn = q = (Ne = Ye + Ne | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, q = q + Jr | 0, q = (Pt = Ne) >>> 0 > (Ne = Ne + un | 0) >>> 0 ? q + 1 | 0 : q, Jr = Ne, Ne ^= zn, zn = q, Te = vt(Ne, tn ^ q, 40), q = (tn = Oe) + kr | 0, kr = Ne = Te + Ho | 0, q = de + (uo = Te >>> 0 > Ne >>> 0 ? q + 1 | 0 : q) | 0, Ho = Ne = Ne + le | 0, De = q = Ne >>> 0 < le >>> 0 ? q + 1 | 0 : q, Ne = be, vn = xr, _r = ho, be = vt(Dn ^ kn, An ^ bo, 48), q = Dt + (bo = Oe) | 0, Dn = be, Dt = q = (Ye = We + be | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q, be = vt(Ye ^ ot, _o ^ q, 1), q = (We = Oe) + _r | 0, q = ((ot = be + vn | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) + Ue | 0, q = ci + (Ne = (Ue = Ne + ot | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q) | 0, kn = ot = Ue + Bt | 0, ot = q = ot >>> 0 < Bt >>> 0 ? q + 1 | 0 : q, Ue = vt(Ue ^ Mt, Ne ^ Qe, 32), q = jr + (An = Oe) | 0, Mt = Ue, tt = q = (Ue = tt + Ue | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q, Ne = vt(be ^ Ue, q ^ We, 40), q = (q = ot) + (ot = Oe) | 0, We = be = Ne + kn | 0, be = vt(be ^ Mt, An ^ (kn = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q), 48), q = tt + (_o = Oe) | 0, An = be, jr = q = (tt = Ue + be | 0) >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, be = vt(Ne ^ tt, ot ^ q, 1), q = (ot = Oe) + De | 0, q = ae + (Ne = (Ue = be + Ho | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, Ho = Mt = Ue + To | 0, Mt = q = Mt >>> 0 < To >>> 0 ? q + 1 | 0 : q, De = be, vn = ot, q = jn + yi | 0, q = (be = qt + Tn | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, qt = be, Tn = q, q = vt(be ^ _t, Xn ^ q, 1), _t = ot = Oe, be = q, q = Bn + Lr | 0, q = ((Vt = Z + Vt | 0) >>> 0 < Z >>> 0 ? q + 1 | 0 : q) + ot | 0, q = Eo + (Vt = (ot = be + Vt | 0) >>> 0 < Vt >>> 0 ? q + 1 | 0 : q) | 0, jn = Bn = ot + Jt | 0, Bn = q = Bn >>> 0 < Jt >>> 0 ? q + 1 | 0 : q, ot = vt(ot ^ nr, Vt ^ Oo, 32), q = Dt + (nr = Oe) | 0, Vt = ot, Dt = q = (Dt = Ye) >>> 0 > (Ye = Ye + ot | 0) >>> 0 ? q + 1 | 0 : q, ot = vt(be ^ Ye, q ^ _t, 40), q = (Xn = Oe) + Bn | 0, _t = be = ot + jn | 0, be = vt(Bn = be ^ Vt, nr ^ (Vt = be >>> 0 < ot >>> 0 ? q + 1 | 0 : q), 48), q = Dt + (Oo = Oe) | 0, Dt = be, Bn = be = Ye + be | 0, nr = q = be >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, jn = Ue, _r = Ne, be = vt(xt ^ Pt, Vn ^ So, 1), q = (Ye = Oe) + gn | 0, q = nn + ((Ue = be + ro | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, q = Yn + (Ne = (Ue = Ue + rt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q) | 0, nn = rt = Ue + Ur | 0, rt = q = rt >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, xt = be, be = (Ue = vt(Ue ^ Dn, Ne ^ bo, 32)) + qt | 0, q = (qt = Oe) + Tn | 0, Ne = be, Ye = vt(be ^ xt, (Dn = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q) ^ Ye, 40), q = (bo = Oe) + rt | 0, rt = be = Ye + nn | 0, Pt = vt(be ^ Ue, qt ^ (nn = be >>> 0 < Ye >>> 0 ? q + 1 | 0 : q), 48), Ue = vt(Pt ^ jn, (q = _r) ^ (_r = Oe), 32), q = (jn = Oe) + nr | 0, qt = be = Ue + Bn | 0, xt = vt(be ^ De, (Tn = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q) ^ vn, 40), q = (De = Oe) + Mt | 0, Mt = be = xt + Ho | 0, be = vt(be ^ Ue, jn ^ (Vn = be >>> 0 < xt >>> 0 ? q + 1 | 0 : q), 48), q = Tn + (So = Oe) | 0, Tn = be, jn = q = (Ue = qt) >>> 0 > (qt = qt + be | 0) >>> 0 ? q + 1 | 0 : q, be = vt(qt ^ xt, De ^ q, 1), q = Do + (Ho = Oe) | 0, De = be, yi = be = mn + be | 0, xt = q = be >>> 0 < mn >>> 0 ? q + 1 | 0 : q, Ue = fo, be = vt(ot ^ Bn, Xn ^ nr, 1), q = kn + (ot = Oe) | 0, q = ((Bn = We) >>> 0 > (We = be + We | 0) >>> 0 ? q + 1 | 0 : q) + mo | 0, q = (Bn = (Ue = Ue + We | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) + Vo | 0, vn = We = Ue + po | 0, kn = q = We >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, nr = be, We = vt(un ^ kr, uo ^ Ao, 48), q = vt(We ^ Ue, (Xn = Oe) ^ Bn, 32), Ao = be = Oe, un = q, Ue = be, q = Dn + _r | 0, q = (be = Ne + Pt | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = be, Dn = q, q = q + Ue | 0, Bn = be = be + un | 0, Pt = q = Ne >>> 0 > be >>> 0 ? q + 1 | 0 : q, Ue = vt(be ^ nr, q ^ ot, 40), q = (q = kn) + (kn = Oe) | 0, nr = be = Ue + vn | 0, kr = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, q = q + xt | 0, uo = q = (ot = be + yi | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, xt = q, be = vt(Ye ^ Ne, Dn ^ bo, 1), q = br + (Ye = Oe) | 0, q = Vt + ((Ne = be + Hr | 0) >>> 0 < Hr >>> 0 ? q + 1 | 0 : q) | 0, q = io + (_t = (Ne = Ne + _t | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q) | 0, vn = Vt = Ne + Qr | 0, Vt = q = Vt >>> 0 < Qr >>> 0 ? q + 1 | 0 : q, Dn = be, q = vt(Ne ^ An, _t ^ _o, 32), _r = be = Oe, Ne = q, _t = be, q = Xn + zn | 0, An = be = We + Jr | 0, zn = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, q = q + _t | 0, q = (We = be + Ne | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = We ^ Dn, Dn = q, _t = vt(be, q ^ Ye, 40), q = (_o = Oe) + Vt | 0, Ye = be = _t + vn | 0, Jr = vt(be ^ Ne, _r ^ (Vt = be >>> 0 < _t >>> 0 ? q + 1 | 0 : q), 48), q = vt(Jr ^ ot, (bo = Oe) ^ xt, 32), yi = be = Oe, vn = q, xt = be, be = vt(Te ^ An, zn ^ tn, 1), q = nn + (Te = Oe) | 0, q = ri + ((Ne = be + rt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q) | 0, q = (rt = (Ne = Ne + ir | 0) >>> 0 < ir >>> 0 ? q + 1 | 0 : q) + mi | 0, An = nn = Ne + Vr | 0, nn = q = nn >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = vt(Ne ^ Dt, rt ^ Oo, 32), q = jr + (zn = Oe) | 0, Dt = Ne, rt = Te, Te = q = (Ne = tt + Ne | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q, rt = vt(be ^ Ne, rt ^ q, 40), q = (Oo = Oe) + nn | 0, tt = be = rt + An | 0, be = vt(An = be ^ Dt, zn ^ (Dt = be >>> 0 < rt >>> 0 ? q + 1 | 0 : q), 48), q = Te + (Xn = Oe) | 0, Te = be, nn = be = Ne + be | 0, An = q = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, q = q + xt | 0, jr = q = (xt = be + vn | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, Ne = vt(xt ^ De, Ho ^ q, 40), q = uo + (zn = Oe) | 0, q = ((be = Ne + ot | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q) + ho | 0, ot = be, uo = be = be + xr | 0, De = q = ot >>> 0 > be >>> 0 ? q + 1 | 0 : q, _r = Yn, ot = vt(un ^ nr, kr ^ Ao, 48), q = (tn = Oe) + Pt | 0, un = be = ot + Bn | 0, q = vt(be ^ Ue, (Bn = be >>> 0 < ot >>> 0 ? q + 1 | 0 : q) ^ kn, 1), kn = Ue = Oe, be = q, q = Vt + de | 0, q = ((Ye = Ye + le | 0) >>> 0 < le >>> 0 ? q + 1 | 0 : q) + Ue | 0, q = (Ye = (Ue = be + Ye | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) + _r | 0, Pt = Vt = Ue + Ur | 0, Vt = q = Vt >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, Ue = vt(Ue ^ Te, Ye ^ Xn, 32), q = jn + (nr = Oe) | 0, qt = q = (Te = Ue + qt | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Te, q ^ kn, 40), q = (kr = Oe) + Vt | 0, Vt = be = Ye + Pt | 0, Ue = vt(be ^ Ue, nr ^ (kn = be >>> 0 < Ye >>> 0 ? q + 1 | 0 : q), 48), q = qt + (Pt = Oe) | 0, nr = q = (qt = Ue + Te | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q, be = vt(Ye ^ qt, kr ^ q, 1), q = (kr = Oe) + De | 0, q = Lo + ((Te = be + uo | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, q = (Ye = (Te = Te + oo | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q) + gn | 0, Ho = gn = Te + ro | 0, gn = q = gn >>> 0 < Te >>> 0 ? q + 1 | 0 : q, jn = be, _r = Te, Xn = Ye, Te = fo, be = vt(rt ^ nn, An ^ Oo, 1), q = Vn + (rt = Oe) | 0, q = ((Ye = Mt) >>> 0 > (Mt = be + Mt | 0) >>> 0 ? q + 1 | 0 : q) + mo | 0, q = mi + (Ye = (Te = Te + Mt | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q) | 0, Vn = Mt = Te + Vr | 0, nn = q = Mt >>> 0 < Vr >>> 0 ? q + 1 | 0 : q, Mt = be, Ye = q = vt(Te ^ ot, Ye ^ tn, 32), q = Dn + bo | 0, q = (An = be = Oe) + (We = (be = We + Jr | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, Dn = q = (ot = be + Ye | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, Mt = vt(ot ^ Mt, q ^ rt, 40), q = (bo = Oe) + nn | 0, nn = vt(Vn = (Te = Mt + Vn | 0) ^ Ye, An ^ (Ye = Te >>> 0 < Mt >>> 0 ? q + 1 | 0 : q), 48), q = vt(nn ^ _r, (Oo = Oe) ^ Xn, 32), tn = rt = Oe, Vn = q, An = rt, be = vt(be ^ _t, We ^ _o, 1), q = io + (rt = Oe) | 0, q = Dt + ((We = be + Qr | 0) >>> 0 < Qr >>> 0 ? q + 1 | 0 : q) | 0, q = ri + (tt = (We = We + tt | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q) | 0, _r = _t = We + ir | 0, _t = q = _t >>> 0 < ir >>> 0 ? q + 1 | 0 : q, Dt = be, Jr = rt, We = vt(We ^ Tn, tt ^ So, 32), q = (Tn = Oe) + Bn | 0, rt = be = We + un | 0, tt = vt(be ^ Dt, (un = be >>> 0 < We >>> 0 ? q + 1 | 0 : q) ^ Jr, 40), q = (_o = Oe) + _t | 0, Dt = be = tt + _r | 0, be = vt(be ^ We, Tn ^ (Bn = be >>> 0 < tt >>> 0 ? q + 1 | 0 : q), 48), q = un + (_r = Oe) | 0, _t = be, un = be = rt + be | 0, Tn = q = be >>> 0 < rt >>> 0 ? q + 1 | 0 : q, q = q + An | 0, An = be = be + Vn | 0, We = kr, kr = q = un >>> 0 > be >>> 0 ? q + 1 | 0 : q, We = vt(be ^ jn, We ^ q, 40), q = (q = gn) + (gn = Oe) | 0, Jr = be = We + Ho | 0, jn = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, rt = Ye, be = vt(vn ^ uo, De ^ yi, 48), q = jr + (So = Oe) | 0, jr = be, Ye = (be = xt + be | 0) ^ Ne, Ne = q = be >>> 0 < xt >>> 0 ? q + 1 | 0 : q, Ye = vt(Ye, q ^ zn, 1), q = (zn = Oe) + rt | 0, q = ae + ((Te = Ye + Te | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) | 0, q = (rt = (Te = Te + To | 0) >>> 0 < To >>> 0 ? q + 1 | 0 : q) + br | 0, uo = xt = Te + Hr | 0, xt = q = xt >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = vt(Te ^ _t, rt ^ _r, 32), q = nr + (De = Oe) | 0, nr = Te, qt = q = (rt = qt + Te | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, Ye = vt(Ye ^ rt, zn ^ q, 40), q = (q = xt) + (xt = Oe) | 0, _t = Te = Ye + uo | 0, Te = vt(vn = Te ^ nr, De ^ (nr = Te >>> 0 < Ye >>> 0 ? q + 1 | 0 : q), 48), q = qt + (Ho = Oe) | 0, zn = Te, uo = q = (qt = rt + Te | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, Te = vt(Ye ^ qt, xt ^ q, 1), q = (xt = Oe) + jn | 0, q = de + ((Ye = Te + Jr | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q) | 0, q = Lr + (rt = (Ye = Ye + le | 0) >>> 0 < le >>> 0 ? q + 1 | 0 : q) | 0, yi = De = Z + Ye | 0, De = q = De >>> 0 < Z >>> 0 ? q + 1 | 0 : q, vn = Te, _r = xt, xt = Ye, Xn = rt, Te = vt(tt ^ un, Tn ^ _o, 1), q = (rt = Oe) + kn | 0, q = Eo + ((Ye = Te + Vt | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q) | 0, q = (tt = (Ye = Ye + Jt | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q) + Lr | 0, kn = Vt = Z + Ye | 0, Vt = q = Vt >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, un = Te, Ye = q = vt(Ye ^ jr, tt ^ So, 32), tt = Te = Oe, q = Dn + Oo | 0, Dn = q = (Te = ot + nn | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, q = q + tt | 0, q = (ot = Te) >>> 0 > (Te = Te + Ye | 0) >>> 0 ? q + 1 | 0 : q, nn = Te, Te ^= un, un = q, rt = vt(Te, q ^ rt, 40), q = (_o = Oe) + Vt | 0, tt = vt(Vt = (Te = rt + kn | 0) ^ Ye, tt ^ (Ye = Te >>> 0 < rt >>> 0 ? q + 1 | 0 : q), 48), q = vt(tt ^ xt, (q = Xn) ^ (Xn = Oe), 32), So = xt = Oe, Vt = q, kn = Ne, Ne = Ue, q = vt(ot ^ Mt, Dn ^ bo, 1), Tn = Ue = Oe, ot = q, q = Bn + Vo | 0, q = ((Mt = Dt + po | 0) >>> 0 < po >>> 0 ? q + 1 | 0 : q) + Ue | 0, Mt = q = (Ue = ot + Mt | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Ne = vt(Ue ^ Ne, q ^ Pt, 32), q = (q = kn) + (kn = Oe) | 0, ot = vt((be = Ne + be | 0) ^ ot, Tn ^ (Dn = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q), 40), q = Mt + (bo = Oe) | 0, Dt = ot, q = ci + ((Bn = Ue) >>> 0 > (Ue = Ue + ot | 0) >>> 0 ? q + 1 | 0 : q) | 0, Bn = q = (ot = Ue + Bt | 0) >>> 0 < Bt >>> 0 ? q + 1 | 0 : q, Ue = vt(Ne ^ ot, kn ^ q, 48), q = Dn + (Oo = Oe) | 0, Pt = be, Ne = Ue, Dn = be = be + Ue | 0, kn = q = Pt >>> 0 > be >>> 0 ? q + 1 | 0 : q, q = q + xt | 0, Pt = q = (xt = be + Vt | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = (Mt = vt(xt ^ vn, q ^ _r, 40)) + yi | 0, q = (yi = Oe) + De | 0, Tn = be, jr = be >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, be = vt(Vn ^ Jr, jn ^ tn, 48), q = (Vn = Oe) + kr | 0, An = Ue = be + An | 0, vn = gn, gn = q = Ue >>> 0 < be >>> 0 ? q + 1 | 0 : q, q = vt(Ue ^ We, vn ^ q, 1), Jr = Ue = Oe, We = q, q = Ye + ae | 0, q = ((Te = Te + To | 0) >>> 0 < To >>> 0 ? q + 1 | 0 : q) + Ue | 0, q = Lo + (Te = (Ue = Te + We | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q) | 0, jn = Ye = Ue + oo | 0, Ye = q = Ye >>> 0 < oo >>> 0 ? q + 1 | 0 : q, Ue = vt(Ue ^ Ne, Te ^ Oo, 32), q = uo + (De = Oe) | 0, kr = Ue, Ue = (Ne = qt + Ue | 0) ^ We, We = q = Ne >>> 0 < qt >>> 0 ? q + 1 | 0 : q, Te = vt(Ue, Jr ^ q, 40), q = (q = Ye) + (Ye = Oe) | 0, Jr = Ue = Te + jn | 0, Ue = vt(qt = Ue ^ kr, De ^ (kr = Ue >>> 0 < Te >>> 0 ? q + 1 | 0 : q), 48), q = We + (Oo = Oe) | 0, uo = Ue, Ne = q = (Ue = Ne + Ue | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Te = vt(Ue ^ Te, Ye ^ q, 1), q = (qt = Oe) + jr | 0, q = Do + ((Ye = Te + Tn | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q) | 0, q = (We = (Ye = Ye + mn | 0) >>> 0 < mn >>> 0 ? q + 1 | 0 : q) + Yn | 0, Ao = jn = Ye + Ur | 0, jn = q = jn >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, De = Te, vn = Ye, _r = We, Te = vt(Dt ^ Dn, kn ^ bo, 1), q = (kn = Oe) + ho | 0, q = nr + (Te >>> 0 > (Ye = Te + xr | 0) >>> 0 ? q + 1 | 0 : q) | 0, We = q = (Ye = Ye + _t | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, q = vt(be ^ Ye, q ^ Vn, 32), Vn = be = Oe, _t = q, q = un + Xn | 0, q = (be = tt + nn | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q, tt = be, Dn = q, q = Vn + q | 0, un = be = be + _t | 0, Dt = q = tt >>> 0 > be >>> 0 ? q + 1 | 0 : q, be = vt(be ^ Te, kn ^ q, 40), q = We + (Xn = Oe) | 0, nn = be, q = io + ((be = Ye + be | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) | 0, q = (be = be + Qr | 0) >>> 0 < Qr >>> 0 ? q + 1 | 0 : q, kn = be, be ^= _t, _t = q, We = vt(be, Vn ^ q, 48), q = vt(We ^ vn, (q = _r) ^ (_r = Oe), 32), bo = be = Oe, Vn = q, nr = be, be = vt(rt ^ tt, Dn ^ _o, 1), q = Vo + (Ye = Oe) | 0, q = Bn + ((Te = be + po | 0) >>> 0 < po >>> 0 ? q + 1 | 0 : q) | 0, q = (rt = (Te = Te + ot | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q) + br | 0, Bn = tt = Te + Hr | 0, tt = q = tt >>> 0 < Te >>> 0 ? q + 1 | 0 : q, ot = be, Dn = Ye, be = (Te = vt(Te ^ zn, rt ^ Ho, 32)) + An | 0, q = (An = Oe) + gn | 0, Ye = be, rt = vt(rt = be ^ ot, (ot = be >>> 0 < Te >>> 0 ? q + 1 | 0 : q) ^ Dn, 40), q = (_o = Oe) + tt | 0, tt = be = rt + Bn | 0, Te = vt(be ^ Te, An ^ (gn = be >>> 0 < rt >>> 0 ? q + 1 | 0 : q), 48), q = ot + (Dn = Oe) | 0, Bn = be = Te + Ye | 0, An = q = be >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, q = q + nr | 0, nr = q = (ot = be + Vn | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, Ye = vt(ot ^ De, q ^ qt, 40), q = (zn = Oe) + jn | 0, jn = be = Ye + Ao | 0, De = q = be >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, be = Ue, qt = Ne, Ne = Te, Ue = vt(Vt ^ Tn, jr ^ So, 48), q = Pt + (Ao = Oe) | 0, Vt = Ue, xt = q = (Te = xt + Ue | 0) >>> 0 < xt >>> 0 ? q + 1 | 0 : q, q = vt(Te ^ Mt, yi ^ q, 1), Pt = Ue = Oe, Mt = q, q = _t + li | 0, q = ((_t = kn + ro | 0) >>> 0 < ro >>> 0 ? q + 1 | 0 : q) + Ue | 0, _t = q = (Ue = _t + Mt | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, Ne = vt(Ue ^ Ne, q ^ Dn, 32), q = (kn = Oe) + qt | 0, Mt = vt((be = Ne + be | 0) ^ Mt, Pt ^ (qt = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q), 40), q = _t + (Tn = Oe) | 0, q = ri + ((_t = Ue) >>> 0 > (Ue = Ue + Mt | 0) >>> 0 ? q + 1 | 0 : q) | 0, Dn = q = (_t = Ue + ir | 0) >>> 0 < ir >>> 0 ? q + 1 | 0 : q, Ue = vt(Ne ^ _t, kn ^ q, 48), q = qt + (So = Oe) | 0, kn = Ue, Pt = q = (qt = be + Ue | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = vt(qt ^ Mt, Tn ^ q, 1), q = (Mt = Oe) + De | 0, q = Eo + ((Ue = be + jn | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, q = Do + (Ne = (Ue = Ue + Jt | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q) | 0, tn = Tn = Ue + mn | 0, Tn = q = Tn >>> 0 < mn >>> 0 ? q + 1 | 0 : q, jr = be, vn = Ue, be = vt(rt ^ Bn, An ^ _o, 1), q = (rt = Oe) + kr | 0, q = mi + ((Ue = be + Jr | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, q = ci + (Bn = (Ue = Ue + Vr | 0) >>> 0 < Vr >>> 0 ? q + 1 | 0 : q) | 0, Jr = An = Ue + Bt | 0, An = q = An >>> 0 < Bt >>> 0 ? q + 1 | 0 : q, kr = be, q = vt(Ue ^ Vt, Bn ^ Ao, 32), Ao = be = Oe, Ue = q, q = Dt + _r | 0, un = be = We + un | 0, Vt = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, q = Ao + q | 0, Dt = q = (We = be + Ue | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, rt = vt(We ^ kr, q ^ rt, 40), q = (_r = Oe) + An | 0, Bn = be = rt + Jr | 0, kr = vt(be ^ Ue, Ao ^ (An = be >>> 0 < rt >>> 0 ? q + 1 | 0 : q), 48), q = vt(kr ^ vn, (Ao = Oe) ^ Ne, 32), _o = be = Oe, Jr = q, Ne = be, Ue = fo, be = vt(un ^ nn, Vt ^ Xn, 1), q = gn + (Vt = Oe) | 0, q = ((un = tt) >>> 0 > (tt = be + tt | 0) >>> 0 ? q + 1 | 0 : q) + mo | 0, q = Eo + (tt = (Ue = Ue + tt | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q) | 0, un = gn = Ue + Jt | 0, gn = q = gn >>> 0 < Jt >>> 0 ? q + 1 | 0 : q, Ue = vt(Ue ^ uo, tt ^ Oo, 32), q = xt + (nn = Oe) | 0, xt = Ue, q = (Ue = Te + Ue | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = Vt, Vt = q, Te = vt(be ^ Ue, Te ^ q, 40), q = (Xn = Oe) + gn | 0, tt = be = Te + un | 0, be = vt(be ^ xt, nn ^ (gn = be >>> 0 < Te >>> 0 ? q + 1 | 0 : q), 48), q = Vt + (vn = Oe) | 0, Vt = be, un = be = Ue + be | 0, nn = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, q = q + Ne | 0, q = (xt = be + Jr | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = xt ^ jr, jr = q, Mt = vt(be, q ^ Mt, 40), q = (Oo = Oe) + Tn | 0, Tn = be = Mt + tn | 0, uo = be >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, be = vt(Vn ^ jn, De ^ bo, 48), q = nr + (bo = Oe) | 0, Vn = be, q = (be = ot + be | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, ot = be, nr = q, q = vt(be ^ Ye, q ^ zn, 1), zn = be = Oe, Ne = q, q = An + Lo | 0, q = ((Ue = Bn + oo | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q) + be | 0, q = ri + (Ue = (be = Ue + Ne | 0) >>> 0 < Ue >>> 0 ? q + 1 | 0 : q) | 0, Bn = Ye = be + ir | 0, Ye = q = Ye >>> 0 < ir >>> 0 ? q + 1 | 0 : q, be = vt(be ^ Vt, Ue ^ vn, 32), q = Pt + (An = Oe) | 0, Vt = be, qt = q = (Ue = qt + be | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, Ne = vt(Ue ^ Ne, zn ^ q, 40), q = (zn = Oe) + Ye | 0, Bn = be = Ne + Bn | 0, be = vt(Ye = be ^ Vt, An ^ (Vt = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q), 48), q = qt + (tn = Oe) | 0, qt = be, Pt = q = (Ye = Ue + be | 0) >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, be = vt(Ye ^ Ne, zn ^ q, 1), q = (An = Oe) + uo | 0, q = Vo + ((Ue = be + Tn | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, q = (Ne = (Ue = Ue + po | 0) >>> 0 < po >>> 0 ? q + 1 | 0 : q) + ho | 0, Ho = zn = Ue + xr | 0, zn = q = zn >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, jn = be, De = Ue, vn = Ne, be = vt(Te ^ un, Xn ^ nn, 1), q = mi + (Ne = Oe) | 0, q = Dn + ((Ue = be + Vr | 0) >>> 0 < Vr >>> 0 ? q + 1 | 0 : q) | 0, q = li + (Te = (Ue = Ue + _t | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q) | 0, nn = _t = Ue + ro | 0, _t = q = _t >>> 0 < ro >>> 0 ? q + 1 | 0 : q, Dn = be, un = Ne, q = vt(Ue ^ Vn, Te ^ bo, 32), Vn = be = Oe, Te = q, Ue = be, q = Dt + Ao | 0, q = (be = We + kr | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q, We = be, Dt = q, q = q + Ue | 0, q = (Ne = be + Te | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = Ne ^ Dn, Dn = q, be = vt(be, q ^ un, 40), q = (q = _t) + (_t = Oe) | 0, un = Ue = be + nn | 0, nn = q = Ue >>> 0 < be >>> 0 ? q + 1 | 0 : q, Vn = vt(Ue ^ Te, Vn ^ q, 48), q = vt(Vn ^ De, (q = vn) ^ (vn = Oe), 32), Xn = Ue = Oe, kr = q, Ue = vt(We ^ rt, Dt ^ _r, 1), q = (We = Oe) + mo | 0, q = gn + ((Te = Ue + fo | 0) >>> 0 < Ue >>> 0 ? q + 1 | 0 : q) | 0, q = ae + (rt = (Te = Te + tt | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q) | 0, _r = tt = Te + To | 0, tt = q = tt >>> 0 < To >>> 0 ? q + 1 | 0 : q, gn = Ue, Dt = We, Te = vt(Te ^ kn, rt ^ So, 32), q = (kn = Oe) + nr | 0, We = Ue = Te + ot | 0, Ue = (rt = vt(Ue ^ gn, (ot = Ue >>> 0 < Te >>> 0 ? q + 1 | 0 : q) ^ Dt, 40)) + _r | 0, q = (_r = Oe) + tt | 0, gn = Ue, Ue = vt(Ue ^ Te, kn ^ (Dt = Ue >>> 0 < rt >>> 0 ? q + 1 | 0 : q), 48), q = ot + (Ao = Oe) | 0, kn = Ue, nr = Ue = We + Ue | 0, De = q = Ue >>> 0 < We >>> 0 ? q + 1 | 0 : q, q = Xn + q | 0, q = (Te = Ue + kr | 0) >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, Ue = An, An = q, We = vt(Te ^ jn, Ue ^ q, 40), q = (bo = Oe) + zn | 0, tt = Ue = We + Ho | 0, q = vt(Ue ^ kr, Xn ^ (zn = Ue >>> 0 < We >>> 0 ? q + 1 | 0 : q), 48), Xn = Ue = Oe, kr = q, Ue = be, q = Dn + vn | 0, Dn = be = Ne + Vn | 0, Vn = q = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, q = vt(be ^ Ue, q ^ _t, 1), Ne = Ue = Oe, be = q, q = Dt + de | 0, q = ((ot = gn + le | 0) >>> 0 < le >>> 0 ? q + 1 | 0 : q) + Ue | 0, q = io + (ot = (Ue = be + ot | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q) | 0, vn = _t = Ue + Qr | 0, _t = q = _t >>> 0 < Qr >>> 0 ? q + 1 | 0 : q, gn = be, Dt = Ne, be = vt(Tn ^ Jr, uo ^ _o, 48), q = jr + (_o = Oe) | 0, Tn = be, q = (be = xt + be | 0) >>> 0 < xt >>> 0 ? q + 1 | 0 : q, xt = be, Ue = vt(Ue ^ qt, ot ^ tn, 32), jr = q, q = q + (Jr = Oe) | 0, Ne = be = Ue + be | 0, ot = vt(be ^ gn, (qt = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q) ^ Dt, 40), q = (uo = Oe) + _t | 0, _t = be = ot + vn | 0, be = vt(be ^ Ue, Jr ^ (gn = be >>> 0 < ot >>> 0 ? q + 1 | 0 : q), 48), q = qt + (So = Oe) | 0, Dt = be, Jr = q = (qt = Ne + be | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, be = vt(ot ^ qt, uo ^ q, 1), q = ri + (vn = Oe) | 0, uo = be, tn = be = ir + be | 0, Ne = q = be >>> 0 < ir >>> 0 ? q + 1 | 0 : q, be = vt(Mt ^ xt, jr ^ Oo, 1), q = (ot = Oe) + nn | 0, q = ci + ((Ue = be + un | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, q = Yn + (xt = (Ue = Ue + Bt | 0) >>> 0 < Bt >>> 0 ? q + 1 | 0 : q) | 0, jr = Mt = Ue + Ur | 0, Mt = q = Mt >>> 0 < Ur >>> 0 ? q + 1 | 0 : q, un = ot, Ue = vt(Ue ^ kn, xt ^ Ao, 32), q = Pt + (Ao = Oe) | 0, nn = Ue, q = (ot = Ye + Ue | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, Ye = un, un = q, xt = vt(be ^ ot, Ye ^ q, 40), q = (Oo = Oe) + Mt | 0, kn = be = xt + jr | 0, q = (Pt = be >>> 0 < xt >>> 0 ? q + 1 | 0 : q) + Ne | 0, Mt = q = (Ne = be + tn | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, jr = q = vt(Ne ^ kr, q ^ Xn, 32), jn = be = Oe, be = vt(rt ^ nr, De ^ _r, 1), q = (Ye = Oe) + Vt | 0, q = Lr + ((Ue = be + Bn | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, q = (rt = (Ue = Z + Ue | 0) >>> 0 < Z >>> 0 ? q + 1 | 0 : q) + br | 0, De = Vt = Ue + Hr | 0, Vt = q = Vt >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, Bn = be, nr = Ye, Ue = vt(Ue ^ Tn, rt ^ _o, 32), q = (Tn = Oe) + Vn | 0, Ye = be = Ue + Dn | 0, be = (rt = vt(be ^ Bn, (Dn = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q) ^ nr, 40)) + De | 0, q = (De = Oe) + Vt | 0, Vt = be, be = vt(be ^ Ue, Tn ^ (Bn = be >>> 0 < rt >>> 0 ? q + 1 | 0 : q), 48), q = Dn + (_o = Oe) | 0, Dn = be, Tn = q = (be = Ye + be | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, q = q + jn | 0, Vn = q = (Ye = be) >>> 0 > (be = be + jr | 0) >>> 0 ? q + 1 | 0 : q, Ue = vt(be ^ uo, vn ^ q, 40), q = Mt + (vn = Oe) | 0, nr = Ue, q = de + ((Ue = Ne + Ue | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q) | 0, uo = Ue = Ue + le | 0, Ne = Ue ^ jr, jr = q = Ue >>> 0 < le >>> 0 ? q + 1 | 0 : q, Ue = vt(Ne, jn ^ q, 48), q = Vn + (jn = Oe) | 0, Vn = q = (Mt = be + Ue | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = q = vt(Mt ^ nr, vn ^ q, 1), nr = Ne = Oe, Ne = vt(Ye ^ rt, Tn ^ De, 1), q = gn + (rt = Oe) | 0, q = ci + ((Ye = Ne + _t | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q) | 0, q = Eo + (_t = (Ye = Ye + Bt | 0) >>> 0 < Bt >>> 0 ? q + 1 | 0 : q) | 0, vn = gn = Ye + Jt | 0, gn = q = gn >>> 0 < Jt >>> 0 ? q + 1 | 0 : q, Tn = Ne, De = rt, q = An + Xn | 0, q = (Ne = Te + kr | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q, An = Ne, nn = vt(kn ^ nn, Pt ^ Ao, 48), rt = vt(Ye ^ nn, _t ^ (Ao = Oe), 32), kn = q, q = q + (tn = Oe) | 0, _t = Ne = rt + Ne | 0, Ne = vt(Ne ^ Tn, (Pt = Ne >>> 0 < rt >>> 0 ? q + 1 | 0 : q) ^ De, 40), q = (Tn = Oe) + gn | 0, De = q = (Te = Ne + vn | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, q = q + nr | 0, q = ae + ((kr = Te) >>> 0 > (Te = be + Te | 0) >>> 0 ? q + 1 | 0 : q) | 0, q = (Ye = (Te = Te + To | 0) >>> 0 < To >>> 0 ? q + 1 | 0 : q) + mo | 0, Ho = gn = Te + fo | 0, vn = q = gn >>> 0 < Te >>> 0 ? q + 1 | 0 : q, _r = be, Xn = Te, q = vt(We ^ An, kn ^ bo, 1), We = Te = Oe, be = q, q = Bn + mi | 0, q = ((gn = Vt + Vr | 0) >>> 0 < Vr >>> 0 ? q + 1 | 0 : q) + Te | 0, q = io + (gn = (Te = be + gn | 0) >>> 0 < gn >>> 0 ? q + 1 | 0 : q) | 0, kn = Vt = Te + Qr | 0, Vt = q = Vt >>> 0 < Qr >>> 0 ? q + 1 | 0 : q, Bn = be, q = vt(Te ^ Dt, gn ^ So, 32), An = be = Oe, Te = q, gn = be, q = un + Ao | 0, un = be = ot + nn | 0, Dt = q = be >>> 0 < ot >>> 0 ? q + 1 | 0 : q, q = q + gn | 0, q = (ot = be + Te | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = ot ^ Bn, Bn = q, gn = vt(be, q ^ We, 40), q = (Ao = Oe) + Vt | 0, nn = vt(Vt = (be = gn + kn | 0) ^ Te, An ^ (Te = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q), 48), q = vt(q = nn ^ Xn, (Xn = Oe) ^ Ye, 32), bo = Ye = Oe, kn = q, Vt = Ye, Ye = vt(xt ^ un, Dt ^ Oo, 1), q = Yn + (xt = Oe) | 0, q = zn + ((We = Ye + Ur | 0) >>> 0 < Ur >>> 0 ? q + 1 | 0 : q) | 0, q = Vo + (tt = (We = We + tt | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q) | 0, Dt = un = We + po | 0, un = q = un >>> 0 < po >>> 0 ? q + 1 | 0 : q, We = vt(We ^ Dn, tt ^ _o, 32), q = Jr + (An = Oe) | 0, Dn = We, qt = q = (We = qt + We | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, tt = vt(Ye ^ We, q ^ xt, 40), q = (_o = Oe) + un | 0, xt = Ye = tt + Dt | 0, Ye = vt(un = Ye ^ Dn, An ^ (Dn = Ye >>> 0 < tt >>> 0 ? q + 1 | 0 : q), 48), q = qt + (So = Oe) | 0, un = Ye, Dt = Ye = We + Ye | 0, An = q = Ye >>> 0 < We >>> 0 ? q + 1 | 0 : q, q = q + Vt | 0, q = (We = Ye + kn | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q, Ye = nr, nr = q, qt = vt(We ^ _r, Ye ^ q, 40), q = (zn = Oe) + vn | 0, Vt = Ye = qt + Ho | 0, Ye = vt(vn = Ye ^ kn, bo ^ (kn = Ye >>> 0 < qt >>> 0 ? q + 1 | 0 : q), 48), q = nr + (bo = Oe) | 0, nr = Ye, We = q = (Ye = We + Ye | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q, zn = q = vt(Ye ^ qt, zn ^ q, 1), Oo = q, Jr = qt = Oe, qt = Te, Te = Ne, Ne = vt(rt ^ kr, De ^ tn, 48), q = Pt + (tn = Oe) | 0, Pt = Ne, q = (Ne = _t + Ne | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, _t = be, be = Te ^ Ne, Te = q, be = vt(be, q ^ Tn, 1), q = (Tn = Oe) + qt | 0, q = li + (be >>> 0 > (rt = _t + be | 0) >>> 0 ? q + 1 | 0 : q) | 0, q = ho + (_t = (rt = rt + ro | 0) >>> 0 < ro >>> 0 ? q + 1 | 0 : q) | 0, kr = qt = rt + xr | 0, qt = q = qt >>> 0 < xr >>> 0 ? q + 1 | 0 : q, rt = vt(rt ^ un, _t ^ So, 32), q = Vn + (De = Oe) | 0, un = q = (_t = rt + Mt | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Mt = vt(be ^ _t, Tn ^ q, 40), q = (So = Oe) + qt | 0, Tn = be = Mt + kr | 0, rt = vt(be ^ rt, De ^ (Vn = be >>> 0 < Mt >>> 0 ? q + 1 | 0 : q), 48), q = un + (kr = Oe) | 0, De = be = rt + _t | 0, un = be, vn = q = be >>> 0 < _t >>> 0 ? q + 1 | 0 : q, _t = Ne, qt = Te, q = Bn + Xn | 0, q = (be = ot + nn | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, ot = be, be ^= gn, gn = q, q = vt(be, Ao ^ q, 1), _r = be = Oe, Bn = q, Te = q, q = Dn + br | 0, q = ((Ne = xt + Hr | 0) >>> 0 < Hr >>> 0 ? q + 1 | 0 : q) + be | 0, xt = q = (be = Ne) >>> 0 > (Ne = Te + Ne | 0) >>> 0 ? q + 1 | 0 : q, Te = vt(Ue ^ Ne, q ^ jn, 32), q = (q = qt) + (qt = Oe) | 0, nn = be = Te + _t | 0, Ue = vt(Ue = be ^ Bn, _r ^ (Bn = be >>> 0 < Te >>> 0 ? q + 1 | 0 : q), 40), q = xt + (jn = Oe) | 0, q = Lo + ((be = Ue + Ne | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q) | 0, _r = q = (_t = be + oo | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q, qt = vt(Te ^ _t, qt ^ q, 48), Ho = q = Oe, be = vt(tt ^ Dt, An ^ _o, 1), q = (Te = Oe) + jr | 0, q = Do + ((Ne = be + uo | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q) | 0, q = Lr + (tt = (Ne = Ne + mn | 0) >>> 0 < mn >>> 0 ? q + 1 | 0 : q) | 0, jr = xt = Z + Ne | 0, Dt = q = xt >>> 0 < Z >>> 0 ? q + 1 | 0 : q, An = be, xt = vt(Ne ^ Pt, tt ^ tn, 32), q = (_o = Oe) + gn | 0, gn = be = xt + ot | 0, Ne = vt(be ^ An, (Pt = be >>> 0 < xt >>> 0 ? q + 1 | 0 : q) ^ Te, 40), q = (q = Dt) + (Dt = Oe) | 0, An = be = Ne + jr | 0, jr = q = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Te = q, q = Lr + Jr | 0, q = ((tt = Z + zn | 0) >>> 0 < Z >>> 0 ? q + 1 | 0 : q) + Te | 0, Dn = q = (Te = be + tt | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q, be = vt(Te ^ qt, Ho ^ q, 32), q = (zn = Oe) + vn | 0, ot = vt((tt = be + un | 0) ^ Oo, (q = tt >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ Jr, 40), Jr = q, q = ho + (un = Oe) | 0, q = Dn + ((uo = ot + xr | 0) >>> 0 < xr >>> 0 ? q + 1 | 0 : q) | 0, q = (Dn = Te + uo | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = zn, zn = q, Te = vt(be ^ Dn, Te ^ q, 48), q = (q = Jr) + (Jr = Oe) | 0, be = ot ^ (tt = Te + tt | 0), ot = q = tt >>> 0 < Te >>> 0 ? q + 1 | 0 : q, uo = q = vt(be, q ^ un, 1), Oo = q, Xn = be = Oe, un = Ye, Ao = We, Ye = Ne, Ne = vt(xt ^ An, jr ^ _o, 48), q = Pt + (An = Oe) | 0, xt = be = Ne + gn | 0, gn = q = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ Dt, 1), q = (jr = Oe) + li | 0, q = _r + ((be = Ye + ro | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) | 0, _t = q = (We = be + _t | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, be = vt(We ^ rt, q ^ kr, 32), q = (Dt = Oe) + Ao | 0, un = rt = be + un | 0, Pt = q = rt >>> 0 < be >>> 0 ? q + 1 | 0 : q, Ye = vt(Ye ^ rt, q ^ jr, 40), q = Eo + (tn = Oe) | 0, jr = Ye, q = _t + ((Ye = Jt + Ye | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q) | 0, We = q = (Ye = Ye + We | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q, rt = vt(be ^ Ye, q ^ Dt, 48), q = (q = Pt) + (Pt = Oe) | 0, kr = be = rt + un | 0, Dt = be, _r = q = be >>> 0 < rt >>> 0 ? q + 1 | 0 : q, q = Bn + Ho | 0, un = (be = qt + nn | 0) ^ Ue, Ue = q = be >>> 0 < qt >>> 0 ? q + 1 | 0 : q, q = vt(un, q ^ jn, 1), jn = _t = Oe, un = q, q = Vn + io | 0, q = ((qt = Tn + Qr | 0) >>> 0 < Qr >>> 0 ? q + 1 | 0 : q) + _t | 0, Bn = q = (Bn = qt) >>> 0 > (qt = qt + un | 0) >>> 0 ? q + 1 | 0 : q, nn = _t = vt(qt ^ nr, bo ^ q, 32), Tn = q = Oe, q = q + gn | 0, Vn = _t = _t + xt | 0, nr = q = nn >>> 0 > _t >>> 0 ? q + 1 | 0 : q, _t = vt(_t ^ un, jn ^ q, 40), q = mo + (jn = Oe) | 0, q = Bn + ((xt = _t + fo | 0) >>> 0 < fo >>> 0 ? q + 1 | 0 : q) | 0, xt = q = (un = qt) >>> 0 > (qt = qt + xt | 0) >>> 0 ? q + 1 | 0 : q, un = vt(qt ^ nn, q ^ Tn, 48), bo = q = Oe, gn = q, Mt = vt(Mt ^ De, vn ^ So, 1), Bn = q = Oe, nn = Ne, q = q + br | 0, q = kn + ((Ne = Mt + Hr | 0) >>> 0 < Hr >>> 0 ? q + 1 | 0 : q) | 0, q = (Ne = Ne + Vt | 0) >>> 0 < Vt >>> 0 ? q + 1 | 0 : q, Vt = Ne ^ nn, nn = q, Vt = vt(Vt, q ^ An, 32), q = (So = Oe) + Ue | 0, kn = be = Vt + be | 0, Ue = vt(be ^ Mt, (Ue = Bn) ^ (Bn = be >>> 0 < Vt >>> 0 ? q + 1 | 0 : q), 40), q = Do + (Tn = Oe) | 0, q = nn + ((be = Ue + mn | 0) >>> 0 < mn >>> 0 ? q + 1 | 0 : q) | 0, nn = be = be + Ne | 0, An = q = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = q, q = Xn + ci | 0, q = ((Mt = uo + Bt | 0) >>> 0 < Bt >>> 0 ? q + 1 | 0 : q) + Ne | 0, uo = q = (Ne = be + Mt | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, be = vt(Ne ^ un, q ^ gn, 32), q = (De = Oe) + _r | 0, gn = vt((Mt = be + Dt | 0) ^ Oo, (q = Mt >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ Xn, 40), vn = Dt = Oe, Xn = q, q = Dt + Vo | 0, q = uo + ((Dt = gn + po | 0) >>> 0 < po >>> 0 ? q + 1 | 0 : q) | 0, uo = q = (Dt = Ne + Dt | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = vt(be ^ Dt, q ^ De, 48), q = (De = Oe) + Xn | 0, be = (Mt = Ne + Mt | 0) ^ gn, gn = q = Mt >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, vn = q = vt(be, q ^ vn, 1), Xn = be = Oe, Ao = tt, _o = rt, rt = Ue, Ue = vt(Vt ^ nn, An ^ So, 48), q = (Vt = Oe) + Bn | 0, Bn = be = Ue + kn | 0, nn = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, rt = vt(be ^ rt, q ^ Tn, 1), q = (Tn = Oe) + ri | 0, q = ((be = rt + ir | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q) + xt | 0, qt = q = (tt = be + qt | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = vt(tt ^ _o, q ^ Pt, 32), q = (xt = Oe) + ot | 0, kn = ot = be + Ao | 0, Pt = q = ot >>> 0 < be >>> 0 ? q + 1 | 0 : q, rt = vt(rt ^ ot, q ^ Tn, 40), q = ae + (_o = Oe) | 0, Tn = rt, q = qt + ((rt = To + rt | 0) >>> 0 < To >>> 0 ? q + 1 | 0 : q) | 0, An = q = (ot = rt + tt | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q, rt = vt(be ^ ot, q ^ xt, 48), q = (q = Pt) + (Pt = Oe) | 0, kn = be = rt + kn | 0, Ao = q = be >>> 0 < rt >>> 0 ? q + 1 | 0 : q, qt = Te, tt = Ye, q = nr + bo | 0, Te = q = (be = un + Vn | 0) >>> 0 < un >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ _t, q ^ jn, 1), q = (_t = Oe) + Yn | 0, q = ((xt = Ye + Ur | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) + We | 0, We = vt(qt ^ (tt = tt + xt | 0), (q = tt >>> 0 < xt >>> 0 ? q + 1 | 0 : q) ^ Jr, 32), xt = q, un = Ye, q = (qt = Oe) + nn | 0, q = (Ye = We + Bn | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q, Bn = Ye, Ye ^= un, un = q, Ye = vt(Ye, q ^ _t, 40), q = de + (nn = Oe) | 0, q = ((_t = Ye + le | 0) >>> 0 < le >>> 0 ? q + 1 | 0 : q) + xt | 0, Vn = q = (xt = _t) >>> 0 > (_t = _t + tt | 0) >>> 0 ? q + 1 | 0 : q, qt = vt(We ^ _t, q ^ qt, 48), bo = q = Oe, tt = q, We = vt(kr ^ jr, _r ^ tn, 1), nr = q = Oe, jr = Te, q = q + Lo | 0, q = zn + ((Te = We + oo | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q) | 0, xt = Vt, Vt = q = (Te = Te + Dn | 0) >>> 0 < Dn >>> 0 ? q + 1 | 0 : q, xt = vt(Ue ^ Te, xt ^ q, 32), q = (So = Oe) + jr | 0, Dn = be = xt + be | 0, Ue = vt(be ^ We, (Ue = nr) ^ (nr = be >>> 0 < xt >>> 0 ? q + 1 | 0 : q), 40), q = mi + (jr = Oe) | 0, q = Vt + ((be = Ue + Vr | 0) >>> 0 < Vr >>> 0 ? q + 1 | 0 : q) | 0, zn = be = be + Te | 0, kr = q = be >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = q, q = Xn + io | 0, q = ((We = Qr + vn | 0) >>> 0 < Qr >>> 0 ? q + 1 | 0 : q) + Te | 0, Vt = q = (Te = be + We | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q, be = vt(Te ^ qt, q ^ tt, 32), q = (Jr = Oe) + Ao | 0, tt = vt((We = be + kn | 0) ^ vn, (q = We >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ Xn, 40), vn = q, q = br + (jn = Oe) | 0, q = Vt + ((_r = tt + Hr | 0) >>> 0 < Hr >>> 0 ? q + 1 | 0 : q) | 0, q = (Vt = Te + _r | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = Jr, Jr = q, Te = vt(be ^ Vt, Te ^ q, 48), q = (q = vn) + (vn = Oe) | 0, be = (We = Te + We | 0) ^ tt, tt = q = We >>> 0 < Te >>> 0 ? q + 1 | 0 : q, jn = q = vt(be, q ^ jn, 1), _r = be = Oe, Xn = rt, rt = Ue, Ue = vt(xt ^ zn, kr ^ So, 48), q = (q = nr) + (nr = Oe) | 0, Dn = be = Ue + Dn | 0, xt = jr, jr = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, rt = vt(be ^ rt, xt ^ q, 1), q = (zn = Oe) + Vo | 0, q = Vn + ((be = rt + po | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q) | 0, xt = _t, _t = be + _t | 0, be = Pt, Pt = q = xt >>> 0 > _t >>> 0 ? q + 1 | 0 : q, be = vt(_t ^ Xn, be ^ q, 32), q = (q = gn) + (gn = Oe) | 0, Vn = q = (xt = be + Mt | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, Mt = xt, rt = vt(rt ^ xt, q ^ zn, 40), q = Lo + (So = Oe) | 0, zn = rt, q = Pt + ((rt = oo + rt | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q) | 0, Pt = q = (xt = rt + _t | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, rt = vt(be ^ xt, q ^ gn, 48), q = (q = Vn) + (Vn = Oe) | 0, kr = be = rt + Mt | 0, Xn = q = be >>> 0 < rt >>> 0 ? q + 1 | 0 : q, Mt = Ne, q = un + bo | 0, Ne = q = (be = qt + Bn | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ nn, 1), q = ho + (qt = Oe) | 0, q = An + ((_t = Ye + xr | 0) >>> 0 < xr >>> 0 ? q + 1 | 0 : q) | 0, un = (_t = ot + _t | 0) ^ Mt, Mt = q = _t >>> 0 < ot >>> 0 ? q + 1 | 0 : q, ot = vt(un, q ^ De, 32), gn = q = Oe, un = Ye, q = q + jr | 0, q = (Ye = ot + Dn | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, Bn = Ye, Ye ^= un, un = q, Ye = vt(Ye, q ^ qt, 40), q = de + (nn = Oe) | 0, q = Mt + ((qt = Ye + le | 0) >>> 0 < le >>> 0 ? q + 1 | 0 : q) | 0, An = q = (qt = _t + qt | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, Mt = vt(ot ^ qt, q ^ gn, 48), bo = q = Oe, _t = q, ot = vt(Tn ^ kn, _o ^ Ao, 1), Dn = q = Oe, kn = Ne, q = q + ae | 0, q = uo + ((Ne = ot + To | 0) >>> 0 < To >>> 0 ? q + 1 | 0 : q) | 0, Dt = q = (Ne = Ne + Dt | 0) >>> 0 < Dt >>> 0 ? q + 1 | 0 : q, gn = vt(Ue ^ Ne, q ^ nr, 32), q = (Oo = Oe) + kn | 0, kn = be = gn + be | 0, Ue = vt(be ^ ot, (Tn = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q) ^ Dn, 40), q = Lr + (nr = Oe) | 0, q = Dt + ((be = Z + Ue | 0) >>> 0 < Z >>> 0 ? q + 1 | 0 : q) | 0, Dt = be = be + Ne | 0, jr = q = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = q, q = _r + Do | 0, q = ((ot = jn + mn | 0) >>> 0 < mn >>> 0 ? q + 1 | 0 : q) + Ne | 0, Dn = q = (Ne = be + ot | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, be = vt(Ne ^ Mt, q ^ _t, 32), q = (uo = Oe) + Xn | 0, _t = vt((ot = be + kr | 0) ^ jn, (q = ot >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ _r, 40), De = q, q = li + (jn = Oe) | 0, q = Dn + ((_r = _t + ro | 0) >>> 0 < ro >>> 0 ? q + 1 | 0 : q) | 0, q = (Dn = Ne + _r | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = uo, uo = q, Ne = vt(be ^ Dn, Ne ^ q, 48), q = (q = De) + (De = Oe) | 0, be = (ot = Ne + ot | 0) ^ _t, _t = q = ot >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, jn = q = vt(be, q ^ jn, 1), tn = q, _r = be = Oe, Ao = We, _o = rt, We = Ue, Ue = vt(gn ^ Dt, jr ^ Oo, 48), q = (gn = Oe) + Tn | 0, Dt = be = Ue + kn | 0, kn = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, We = vt(be ^ We, q ^ nr, 1), q = (nr = Oe) + mo | 0, q = An + ((be = We + fo | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, qt = q = (rt = be + qt | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, be = vt(rt ^ _o, q ^ Vn, 32), q = (Tn = Oe) + tt | 0, Vn = q = (tt = be + Ao | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, We = vt(We ^ tt, q ^ nr, 40), q = ri + (Oo = Oe) | 0, An = We, q = qt + ((We = ir + We | 0) >>> 0 < ir >>> 0 ? q + 1 | 0 : q) | 0, qt = We + rt | 0, We = Tn, Tn = q = qt >>> 0 < rt >>> 0 ? q + 1 | 0 : q, We = vt(be ^ qt, We ^ q, 48), q = (q = Vn) + (Vn = Oe) | 0, nr = be = We + tt | 0, jr = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, rt = Te, q = un + bo | 0, Te = q = (be = Mt + Bn | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ nn, 1), q = (Mt = Oe) + mi | 0, q = Pt + ((tt = Ye + Vr | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) | 0, rt = vt(rt ^ (tt = tt + xt | 0), (q = tt >>> 0 < xt >>> 0 ? q + 1 | 0 : q) ^ vn, 32), un = xt = Oe, xt = q, Bn = Ye, q = un + kn | 0, q = (Ye = rt + Dt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, Dt = Ye, Ye ^= Bn, Bn = q, Ye = vt(Ye, q ^ Mt, 40), q = Eo + (nn = Oe) | 0, q = ((Mt = Ye + Jt | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q) + xt | 0, Pt = un, un = q = (xt = tt + Mt | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Mt = vt(rt ^ xt, Pt ^ q, 48), bo = q = Oe, tt = q, rt = vt(kr ^ zn, Xn ^ So, 1), kn = q = Oe, Pt = Te, q = q + Yn | 0, q = Jr + ((Te = rt + Ur | 0) >>> 0 < Ur >>> 0 ? q + 1 | 0 : q) | 0, Vt = q = (Te = Te + Vt | 0) >>> 0 < Vt >>> 0 ? q + 1 | 0 : q, gn = vt(Ue ^ Te, q ^ gn, 32), q = (So = Oe) + Pt | 0, Pt = be = gn + be | 0, Ue = vt(be ^ rt, (Ue = kn) ^ (kn = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q), 40), q = ci + (zn = Oe) | 0, q = Vt + ((be = Ue + Bt | 0) >>> 0 < Bt >>> 0 ? q + 1 | 0 : q) | 0, kr = be = be + Te | 0, Jr = q = be >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = q, q = _r + de | 0, q = ((rt = jn + le | 0) >>> 0 < le >>> 0 ? q + 1 | 0 : q) + Te | 0, Vt = q = (Te = be + rt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, be = vt(Te ^ Mt, q ^ tt, 32), q = (jn = Oe) + jr | 0, tt = vt((rt = be + nr | 0) ^ tn, (q = rt >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ _r, 40), _r = q, q = Vo + (vn = Oe) | 0, q = Vt + ((Xn = tt + po | 0) >>> 0 < po >>> 0 ? q + 1 | 0 : q) | 0, q = (Vt = Te + Xn | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = jn, jn = q, Te = vt(be ^ Vt, Te ^ q, 48), q = (q = _r) + (_r = Oe) | 0, be = (rt = Te + rt | 0) ^ tt, tt = q = rt >>> 0 < Te >>> 0 ? q + 1 | 0 : q, vn = q = vt(be, q ^ vn, 1), Xn = be = Oe, Ao = ot, _o = We, We = Ue, Ue = vt(gn ^ kr, Jr ^ So, 48), q = (gn = Oe) + kn | 0, kn = be = Ue + Pt | 0, Pt = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, We = vt(be ^ We, q ^ zn, 1), q = (zn = Oe) + ri | 0, q = un + ((be = We + ir | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, xt = q = (ot = be + xt | 0) >>> 0 < xt >>> 0 ? q + 1 | 0 : q, be = vt(ot ^ _o, q ^ Vn, 32), q = (un = Oe) + _t | 0, Vn = q = (_t = be + Ao | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, We = vt(We ^ _t, q ^ zn, 40), q = Yn + (So = Oe) | 0, zn = We, q = xt + ((We = Ur + We | 0) >>> 0 < Ur >>> 0 ? q + 1 | 0 : q) | 0, xt = We + ot | 0, We = un, un = q = xt >>> 0 < ot >>> 0 ? q + 1 | 0 : q, We = vt(be ^ xt, We ^ q, 48), q = (q = Vn) + (Vn = Oe) | 0, kr = be = We + _t | 0, Jr = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, ot = Ne, q = Bn + bo | 0, Ne = q = (be = Mt + Dt | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ nn, 1), q = ci + (Mt = Oe) | 0, q = Tn + ((_t = Ye + Bt | 0) >>> 0 < Bt >>> 0 ? q + 1 | 0 : q) | 0, qt = q = (_t = _t + qt | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, ot = vt(ot ^ _t, q ^ De, 32), Dt = q = Oe, Bn = Ye, q = q + Pt | 0, q = (Ye = ot + kn | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, nn = Ye, Ye ^= Bn, Bn = q, Ye = vt(Ye, q ^ Mt, 40), q = Do + (kn = Oe) | 0, q = qt + ((Mt = Ye + mn | 0) >>> 0 < mn >>> 0 ? q + 1 | 0 : q) | 0, q = (qt = _t + Mt | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, _t = Dt, Dt = q, Mt = vt(ot ^ qt, _t ^ q, 48), bo = q = Oe, _t = q, ot = vt(An ^ nr, jr ^ Oo, 1), Pt = q = Oe, Tn = Ne, q = q + Lr | 0, q = uo + ((Ne = Z + ot | 0) >>> 0 < Z >>> 0 ? q + 1 | 0 : q) | 0, Dn = q = (Ne = Ne + Dn | 0) >>> 0 < Dn >>> 0 ? q + 1 | 0 : q, gn = vt(Ue ^ Ne, q ^ gn, 32), q = (Oo = Oe) + Tn | 0, Tn = be = gn + be | 0, Ue = vt(be ^ ot, (Ue = Pt) ^ (Pt = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q), 40), q = Lo + (An = Oe) | 0, q = Dn + ((be = Ue + oo | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q) | 0, nr = be = be + Ne | 0, jr = q = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = q, q = Xn + ho | 0, q = ((ot = vn + xr | 0) >>> 0 < xr >>> 0 ? q + 1 | 0 : q) + Ne | 0, Dn = q = (Ne = be + ot | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, be = vt(Ne ^ Mt, q ^ _t, 32), q = (uo = Oe) + Jr | 0, _t = vt((ot = be + kr | 0) ^ vn, (q = ot >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ Xn, 40), vn = q, q = ae + (De = Oe) | 0, q = Dn + ((Xn = _t + To | 0) >>> 0 < To >>> 0 ? q + 1 | 0 : q) | 0, q = (Dn = Ne + Xn | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = uo, uo = q, Ne = vt(be ^ Dn, Ne ^ q, 48), q = (q = vn) + (vn = Oe) | 0, be = (ot = Ne + ot | 0) ^ _t, _t = q = ot >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, De = q = vt(be, q ^ De, 1), Xn = be = Oe, Ao = rt, _o = We, We = Ue, Ue = vt(gn ^ nr, jr ^ Oo, 48), q = (gn = Oe) + Pt | 0, Pt = be = Ue + Tn | 0, Tn = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, We = vt(be ^ We, q ^ An, 1), q = (An = Oe) + io | 0, q = Dt + ((be = We + Qr | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, qt = q = (rt = be + qt | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, be = vt(rt ^ _o, q ^ Vn, 32), q = (Dt = Oe) + tt | 0, Vn = q = (tt = be + Ao | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, We = vt(We ^ tt, q ^ An, 40), q = mi + (Oo = Oe) | 0, An = We, q = qt + ((We = Vr + We | 0) >>> 0 < Vr >>> 0 ? q + 1 | 0 : q) | 0, qt = We + rt | 0, We = Dt, Dt = q = qt >>> 0 < rt >>> 0 ? q + 1 | 0 : q, We = vt(be ^ qt, We ^ q, 48), q = (q = Vn) + (Vn = Oe) | 0, nr = be = We + tt | 0, jr = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, rt = Te, q = Bn + bo | 0, Te = q = (be = Mt + nn | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ kn, 1), q = (Mt = Oe) + Eo | 0, q = un + ((tt = Ye + Jt | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) | 0, xt = q = (tt = tt + xt | 0) >>> 0 < xt >>> 0 ? q + 1 | 0 : q, rt = vt(rt ^ tt, q ^ _r, 32), un = q = Oe, Bn = Ye, q = q + Tn | 0, q = (Ye = rt + Pt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, nn = Ye, Ye ^= Bn, Bn = q, Ye = vt(Ye, q ^ Mt, 40), q = mo + (kn = Oe) | 0, q = xt + ((Mt = Ye + fo | 0) >>> 0 < fo >>> 0 ? q + 1 | 0 : q) | 0, Pt = un, un = q = (xt = tt + Mt | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q, Mt = vt(rt ^ xt, Pt ^ q, 48), bo = q = Oe, tt = q, rt = vt(kr ^ zn, Jr ^ So, 1), Pt = q = Oe, Tn = Te, q = q + br | 0, q = jn + ((Te = rt + Hr | 0) >>> 0 < Hr >>> 0 ? q + 1 | 0 : q) | 0, Vt = q = (Te = Te + Vt | 0) >>> 0 < Vt >>> 0 ? q + 1 | 0 : q, gn = vt(Ue ^ Te, q ^ gn, 32), q = (So = Oe) + Tn | 0, Tn = be = gn + be | 0, Ue = vt(be ^ rt, (Ue = Pt) ^ (Pt = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q), 40), q = li + (zn = Oe) | 0, q = Vt + ((be = Ue + ro | 0) >>> 0 < ro >>> 0 ? q + 1 | 0 : q) | 0, kr = be = be + Te | 0, Jr = q = be >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = q, q = Xn + ae | 0, q = ((rt = De + To | 0) >>> 0 < To >>> 0 ? q + 1 | 0 : q) + Te | 0, Vt = q = (Te = be + rt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, be = vt(Te ^ Mt, q ^ tt, 32), q = (jn = Oe) + jr | 0, tt = vt((rt = be + nr | 0) ^ De, (q = rt >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ Xn, 40), _r = q, q = ci + (De = Oe) | 0, q = Vt + ((Xn = tt + Bt | 0) >>> 0 < Bt >>> 0 ? q + 1 | 0 : q) | 0, q = (Vt = Te + Xn | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = jn, jn = q, Te = vt(be ^ Vt, Te ^ q, 48), q = (q = _r) + (_r = Oe) | 0, be = (rt = Te + rt | 0) ^ tt, tt = q = rt >>> 0 < Te >>> 0 ? q + 1 | 0 : q, De = q = vt(be, q ^ De, 1), Xn = be = Oe, Ao = ot, _o = We, We = Ue, Ue = vt(gn ^ kr, Jr ^ So, 48), q = (gn = Oe) + Pt | 0, Pt = be = Ue + Tn | 0, Tn = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, We = vt(be ^ We, q ^ zn, 1), q = (zn = Oe) + br | 0, q = un + ((be = We + Hr | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, xt = q = (ot = be + xt | 0) >>> 0 < xt >>> 0 ? q + 1 | 0 : q, be = vt(ot ^ _o, q ^ Vn, 32), q = (un = Oe) + _t | 0, Vn = q = (_t = be + Ao | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, We = vt(We ^ _t, q ^ zn, 40), q = mo + (So = Oe) | 0, zn = We, q = xt + ((We = fo + We | 0) >>> 0 < fo >>> 0 ? q + 1 | 0 : q) | 0, xt = We + ot | 0, We = un, un = q = xt >>> 0 < ot >>> 0 ? q + 1 | 0 : q, We = vt(be ^ xt, We ^ q, 48), q = (q = Vn) + (Vn = Oe) | 0, kr = be = We + _t | 0, Jr = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, ot = Ne, q = Bn + bo | 0, Ne = q = (be = Mt + nn | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ kn, 1), q = Eo + (Mt = Oe) | 0, q = Dt + ((_t = Ye + Jt | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q) | 0, qt = q = (_t = _t + qt | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, ot = vt(ot ^ _t, q ^ vn, 32), Dt = q = Oe, Bn = Ye, q = q + Tn | 0, q = (Ye = ot + Pt | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, nn = Ye, Ye ^= Bn, Bn = q, Ye = vt(Ye, q ^ Mt, 40), q = mi + (kn = Oe) | 0, q = qt + ((Mt = Ye + Vr | 0) >>> 0 < Vr >>> 0 ? q + 1 | 0 : q) | 0, q = (qt = _t + Mt | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, _t = Dt, Dt = q, Mt = vt(ot ^ qt, _t ^ q, 48), bo = q = Oe, _t = q, ot = vt(An ^ nr, jr ^ Oo, 1), Pt = q = Oe, Tn = Ne, q = q + Yn | 0, q = uo + ((Ne = ot + Ur | 0) >>> 0 < Ur >>> 0 ? q + 1 | 0 : q) | 0, Dn = q = (Ne = Ne + Dn | 0) >>> 0 < Dn >>> 0 ? q + 1 | 0 : q, gn = vt(Ue ^ Ne, q ^ gn, 32), q = (Oo = Oe) + Tn | 0, Tn = be = gn + be | 0, Ue = vt(be ^ ot, (Ue = Pt) ^ (Pt = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q), 40), q = li + (An = Oe) | 0, q = Dn + ((be = Ue + ro | 0) >>> 0 < ro >>> 0 ? q + 1 | 0 : q) | 0, nr = be = be + Ne | 0, jr = q = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = q, q = Xn + Lo | 0, q = ((ot = De + oo | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q) + Ne | 0, Dn = q = (Ne = be + ot | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, be = vt(Ne ^ Mt, q ^ _t, 32), q = (uo = Oe) + Jr | 0, _t = vt((ot = be + kr | 0) ^ De, (q = ot >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ Xn, 40), vn = q, q = Lr + (De = Oe) | 0, q = Dn + ((Xn = Z + _t | 0) >>> 0 < Z >>> 0 ? q + 1 | 0 : q) | 0, q = (Dn = Ne + Xn | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = uo, uo = q, Ne = vt(be ^ Dn, Ne ^ q, 48), q = (q = vn) + (vn = Oe) | 0, be = (ot = Ne + ot | 0) ^ _t, _t = q = ot >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, De = q = vt(be, q ^ De, 1), Xn = be = Oe, Ao = rt, _o = We, We = Ue, Ue = vt(gn ^ nr, jr ^ Oo, 48), q = (gn = Oe) + Pt | 0, Pt = be = Ue + Tn | 0, Tn = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, We = vt(be ^ We, q ^ An, 1), q = (An = Oe) + Do | 0, q = Dt + ((be = We + mn | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, qt = q = (rt = be + qt | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, be = vt(rt ^ _o, q ^ Vn, 32), q = (Dt = Oe) + tt | 0, Vn = q = (tt = be + Ao | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, We = vt(We ^ tt, q ^ An, 40), q = de + (Oo = Oe) | 0, An = We, q = qt + ((We = le + We | 0) >>> 0 < le >>> 0 ? q + 1 | 0 : q) | 0, qt = We + rt | 0, We = Dt, Dt = q = qt >>> 0 < rt >>> 0 ? q + 1 | 0 : q, We = vt(be ^ qt, We ^ q, 48), q = (q = Vn) + (Vn = Oe) | 0, nr = be = We + tt | 0, jr = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, rt = Te, q = Bn + bo | 0, Te = q = (be = Mt + nn | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ kn, 1), q = (Mt = Oe) + ho | 0, q = un + ((tt = Ye + xr | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) | 0, xt = q = (tt = tt + xt | 0) >>> 0 < xt >>> 0 ? q + 1 | 0 : q, rt = vt(rt ^ tt, q ^ _r, 32), un = q = Oe, Bn = Ye, q = q + Tn | 0, q = (Ye = rt + Pt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, nn = Ye, Ye ^= Bn, Bn = q, Ye = vt(Ye, q ^ Mt, 40), q = ri + (kn = Oe) | 0, q = xt + ((Mt = Ye + ir | 0) >>> 0 < ir >>> 0 ? q + 1 | 0 : q) | 0, Pt = un, un = q = (xt = tt + Mt | 0) >>> 0 < tt >>> 0 ? q + 1 | 0 : q, Mt = vt(rt ^ xt, Pt ^ q, 48), bo = q = Oe, tt = q, rt = vt(kr ^ zn, Jr ^ So, 1), Pt = q = Oe, Tn = Te, q = q + Vo | 0, q = jn + ((Te = rt + po | 0) >>> 0 < po >>> 0 ? q + 1 | 0 : q) | 0, Vt = q = (Te = Te + Vt | 0) >>> 0 < Vt >>> 0 ? q + 1 | 0 : q, gn = vt(Ue ^ Te, q ^ gn, 32), q = (So = Oe) + Tn | 0, Tn = be = gn + be | 0, Ue = vt(be ^ rt, (Ue = Pt) ^ (Pt = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q), 40), q = io + (zn = Oe) | 0, q = Vt + ((be = Ue + Qr | 0) >>> 0 < Qr >>> 0 ? q + 1 | 0 : q) | 0, kr = be = be + Te | 0, Jr = q = be >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = q, q = Xn + li | 0, q = ((rt = De + ro | 0) >>> 0 < ro >>> 0 ? q + 1 | 0 : q) + Te | 0, Vt = q = (Te = be + rt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, be = vt(Te ^ Mt, q ^ tt, 32), q = (jn = Oe) + jr | 0, tt = vt((rt = be + nr | 0) ^ De, (q = rt >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ Xn, 40), _r = q, q = mo + (De = Oe) | 0, q = Vt + ((Xn = tt + fo | 0) >>> 0 < fo >>> 0 ? q + 1 | 0 : q) | 0, q = (Vt = Te + Xn | 0) >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = jn, jn = q, Te = vt(be ^ Vt, Te ^ q, 48), q = (q = _r) + (_r = Oe) | 0, be = (rt = Te + rt | 0) ^ tt, tt = q = rt >>> 0 < Te >>> 0 ? q + 1 | 0 : q, De = q = vt(be, q ^ De, 1), Xn = be = Oe, Ao = ot, _o = We, We = Ue, Ue = vt(gn ^ kr, Jr ^ So, 48), q = (gn = Oe) + Pt | 0, Pt = be = Ue + Tn | 0, Tn = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, We = vt(be ^ We, q ^ zn, 1), q = (zn = Oe) + ci | 0, q = un + ((be = We + Bt | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, xt = q = (ot = be + xt | 0) >>> 0 < xt >>> 0 ? q + 1 | 0 : q, be = vt(ot ^ _o, q ^ Vn, 32), q = (un = Oe) + _t | 0, Vn = q = (_t = be + Ao | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, We = vt(We ^ _t, q ^ zn, 40), q = ae + (So = Oe) | 0, zn = We, q = xt + ((We = To + We | 0) >>> 0 < To >>> 0 ? q + 1 | 0 : q) | 0, xt = We + ot | 0, We = un, un = q = xt >>> 0 < ot >>> 0 ? q + 1 | 0 : q, We = vt(be ^ xt, We ^ q, 48), q = (q = Vn) + (Vn = Oe) | 0, kr = be = We + _t | 0, Jr = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, ot = Ne, q = Bn + bo | 0, Ne = q = (be = Mt + nn | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ kn, 1), q = ri + (Mt = Oe) | 0, q = Dt + ((_t = Ye + ir | 0) >>> 0 < ir >>> 0 ? q + 1 | 0 : q) | 0, qt = q = (_t = _t + qt | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, ot = vt(ot ^ _t, q ^ vn, 32), Dt = q = Oe, Bn = Ye, q = q + Tn | 0, q = (Ye = ot + Pt | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, nn = Ye, Ye ^= Bn, Bn = q, Ye = vt(Ye, q ^ Mt, 40), q = br + (kn = Oe) | 0, q = qt + ((Mt = Ye + Hr | 0) >>> 0 < Hr >>> 0 ? q + 1 | 0 : q) | 0, q = (qt = _t + Mt | 0) >>> 0 < _t >>> 0 ? q + 1 | 0 : q, _t = Dt, Dt = q, Mt = vt(ot ^ qt, _t ^ q, 48), bo = q = Oe, _t = q, ot = vt(An ^ nr, jr ^ Oo, 1), Pt = q = Oe, Tn = Ne, q = q + mi | 0, q = uo + ((Ne = ot + Vr | 0) >>> 0 < Vr >>> 0 ? q + 1 | 0 : q) | 0, Dn = q = (Ne = Ne + Dn | 0) >>> 0 < Dn >>> 0 ? q + 1 | 0 : q, gn = vt(Ue ^ Ne, q ^ gn, 32), q = (Oo = Oe) + Tn | 0, Tn = be = gn + be | 0, Ue = vt(be ^ ot, (Ue = Pt) ^ (Pt = be >>> 0 < gn >>> 0 ? q + 1 | 0 : q), 40), q = Vo + (An = Oe) | 0, q = Dn + ((be = Ue + po | 0) >>> 0 < po >>> 0 ? q + 1 | 0 : q) | 0, nr = be = be + Ne | 0, jr = q = be >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = q, q = Xn + Eo | 0, q = ((ot = De + Jt | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q) + Ne | 0, Dn = q = (Ne = be + ot | 0) >>> 0 < ot >>> 0 ? q + 1 | 0 : q, be = vt(Ne ^ Mt, q ^ _t, 32), q = (uo = Oe) + Jr | 0, _t = vt((ot = be + kr | 0) ^ De, (q = ot >>> 0 < be >>> 0 ? q + 1 | 0 : q) ^ Xn, 40), vn = q, q = de + (De = Oe) | 0, q = Dn + ((Xn = _t + le | 0) >>> 0 < le >>> 0 ? q + 1 | 0 : q) | 0, q = (Dn = Ne + Xn | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Ne = uo, uo = q, Ne = vt(be ^ Dn, Ne ^ q, 48), q = (q = vn) + (vn = Oe) | 0, be = (ot = Ne + ot | 0) ^ _t, _t = q = ot >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, De = q = vt(be, q ^ De, 1), Xn = be = Oe, Ao = rt, _o = We, We = Ue, Ue = vt(gn ^ nr, jr ^ Oo, 48), q = (gn = Oe) + Pt | 0, Pt = be = Ue + Tn | 0, Tn = q = be >>> 0 < Ue >>> 0 ? q + 1 | 0 : q, We = vt(be ^ We, q ^ An, 1), q = (nr = Oe) + Yn | 0, q = Dt + ((be = We + Ur | 0) >>> 0 < We >>> 0 ? q + 1 | 0 : q) | 0, qt = q = (rt = be + qt | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, be = vt(rt ^ _o, q ^ Vn, 32), q = (Dt = Oe) + tt | 0, Vn = tt = be + Ao | 0, An = q = tt >>> 0 < be >>> 0 ? q + 1 | 0 : q, We = vt(We ^ tt, q ^ nr, 40), q = Lo + (Ao = Oe) | 0, nr = We, q = qt + ((We = oo + We | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q) | 0, tt = We + rt | 0, We = Dt, Dt = q = tt >>> 0 < rt >>> 0 ? q + 1 | 0 : q, We = vt(be ^ tt, We ^ q, 48), q = (q = An) + (An = Oe) | 0, Vn = be = We + Vn | 0, jr = q = be >>> 0 < We >>> 0 ? q + 1 | 0 : q, rt = Te, q = Bn + bo | 0, Te = q = (be = Mt + nn | 0) >>> 0 < Mt >>> 0 ? q + 1 | 0 : q, Ye = vt(be ^ Ye, q ^ kn, 1), q = (Mt = Oe) + Lr | 0, q = un + ((qt = Z + Ye | 0) >>> 0 < Ye >>> 0 ? q + 1 | 0 : q) | 0, xt = q = (qt = qt + xt | 0) >>> 0 < xt >>> 0 ? q + 1 | 0 : q, un = rt = vt(rt ^ qt, q ^ _r, 32), Bn = q = Oe, nn = Ye, q = q + Tn | 0, q = (Ye = rt + Pt | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, kn = Ye, Ye ^= nn, nn = q, Ye = vt(Ye, q ^ Mt, 40), q = Do + (Pt = Oe) | 0, q = xt + ((rt = Ye + mn | 0) >>> 0 < mn >>> 0 ? q + 1 | 0 : q) | 0, Tn = (rt = rt + qt | 0) ^ un, un = q = rt >>> 0 < qt >>> 0 ? q + 1 | 0 : q, qt = vt(Tn, q ^ Bn, 48), _r = q = Oe, Mt = q, Bn = xt = vt(kr ^ zn, Jr ^ So, 1), Tn = q = Oe, zn = Te, q = q + io | 0, q = jn + ((Te = xt + Qr | 0) >>> 0 < Qr >>> 0 ? q + 1 | 0 : q) | 0, q = (Te = Te + Vt | 0) >>> 0 < Vt >>> 0 ? q + 1 | 0 : q, Vt = gn, gn = q, xt = vt(Ue ^ Te, Vt ^ q, 32), q = (_o = Oe) + zn | 0, Vt = be = xt + be | 0, Ue = vt(Ue = be ^ Bn, (Bn = be >>> 0 < xt >>> 0 ? q + 1 | 0 : q) ^ Tn, 40), q = ho + (Tn = Oe) | 0, q = gn + ((be = Ue + xr | 0) >>> 0 < xr >>> 0 ? q + 1 | 0 : q) | 0, gn = be = be + Te | 0, zn = q = be >>> 0 < Te >>> 0 ? q + 1 | 0 : q, Te = q, q = Xn + Lo | 0, q = ((jn = oo) >>> 0 > (oo = De + oo | 0) >>> 0 ? q + 1 | 0 : q) + Te | 0, Lo = q = (be = be + oo | 0) >>> 0 < oo >>> 0 ? q + 1 | 0 : q, oo = vt(be ^ qt, q ^ Mt, 32), q = (kr = Oe) + jr | 0, Mt = vt((Te = Vn + oo | 0) ^ De, (q = Te >>> 0 < oo >>> 0 ? q + 1 | 0 : q) ^ Xn, 40), jn = q, q = Do + (Jr = Oe) | 0, q = Lo + ((De = mn) >>> 0 > (mn = Mt + mn | 0) >>> 0 ? q + 1 | 0 : q) | 0, q = (mn = be + mn | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, be = oo ^ mn, oo = q, Do = vt(be, q ^ kr, 48), q = (Lo = Oe) + jn | 0, Te = q = (be = Te + Do | 0) >>> 0 < Do >>> 0 ? q + 1 | 0 : q, q = vt(be ^ Mt, q ^ Jr, 1), Mt = Oe, kr = q, Jr = ot, ot = xr, jn = ho, ho = vt(xt ^ gn, zn ^ _o, 48), q = (xt = Oe) + Bn | 0, Bn = ot, Vt = q = (xr = Vt + ho | 0) >>> 0 < ho >>> 0 ? q + 1 | 0 : q, ot = vt(Ue ^ (gn = xr), q ^ Tn, 1), q = (Tn = Oe) + jn | 0, q = un + (ot >>> 0 > (xr = Bn + ot | 0) >>> 0 ? q + 1 | 0 : q) | 0, Ue = q = (xr = rt + xr | 0) >>> 0 < rt >>> 0 ? q + 1 | 0 : q, We = vt(We ^ xr, q ^ An, 32), q = (q = _t) + (_t = Oe) | 0, un = rt = We + Jr | 0, Bn = q = rt >>> 0 < We >>> 0 ? q + 1 | 0 : q, rt = vt(rt ^ ot, q ^ Tn, 40), q = (Tn = Oe) + ci | 0, q = (rt >>> 0 > (Bt = rt + Bt | 0) >>> 0 ? q + 1 | 0 : q) + Ue | 0, Ue = q = (Ue = Bt) >>> 0 > (Bt = xr + Bt | 0) >>> 0 ? q + 1 | 0 : q, We = vt(We ^ Bt, q ^ _t, 48), q = (ot = Oe) + Bn | 0, _t = xr = We + un | 0, ci = q = xr >>> 0 < We >>> 0 ? q + 1 | 0 : q, un = Z, Bn = Lr, q = nn + _r | 0, xr = q = (Z = qt + kn | 0) >>> 0 < qt >>> 0 ? q + 1 | 0 : q, Lr = vt(Z ^ Ye, q ^ Pt, 1), q = (qt = Oe) + Bn | 0, q = Dt + ((Ye = un + Lr | 0) >>> 0 < Lr >>> 0 ? q + 1 | 0 : q) | 0, Ne = vt((Ye = Ye + tt | 0) ^ Ne, (q = Ye >>> 0 < tt >>> 0 ? q + 1 | 0 : q) ^ vn, 32), un = q, Dt = Jt, Jt = Lr, q = (tt = Oe) + Vt | 0, Vt = qt, qt = q = (Lr = Ne + gn | 0) >>> 0 < Ne >>> 0 ? q + 1 | 0 : q, Jt = vt(Lr ^ Jt, Vt ^ q, 40), q = (gn = Oe) + Eo | 0, q = ((Eo = Dt + Jt | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q) + un | 0, un = Eo, Ye = Ne ^ (Eo = Ye + Eo | 0), Ne = q = un >>> 0 > Eo >>> 0 ? q + 1 | 0 : q, q = vt(Ye, q ^ tt, 48), nn = Ye = Oe, tt = q, Vt = Ur, un = Yn, Ur = vt(Vn ^ nr, jr ^ Ao, 1), Bn = q = Oe, q = q + li | 0, q = uo + ((Ur = (Dt = Ur) + ro | 0) >>> 0 < ro >>> 0 ? q + 1 | 0 : q) | 0, ro = q = (Ur = Dn + Ur | 0) >>> 0 < Dn >>> 0 ? q + 1 | 0 : q, Yn = vt(Ur ^ ho, q ^ xt, 32), q = (Dn = Oe) + xr | 0, xr = Z = Yn + Z | 0, ho = vt(Z ^ Dt, (xt = Z >>> 0 < Yn >>> 0 ? q + 1 | 0 : q) ^ Bn, 40), q = (q = un) + (un = Oe) | 0, q = ro + ((Z = ho + Vt | 0) >>> 0 < ho >>> 0 ? q + 1 | 0 : q) | 0, ro = Z = Z + Ur | 0, li = q = Z >>> 0 < Ur >>> 0 ? q + 1 | 0 : q, Ur = q, q = Mt + ri | 0, q = ((Dt = ir) >>> 0 > (ir = kr + ir | 0) >>> 0 ? q + 1 | 0 : q) + Ur | 0, ri = q = (Ur = Z + ir | 0) >>> 0 < ir >>> 0 ? q + 1 | 0 : q, ir = vt(tt ^ Ur, q ^ Ye, 32), q = (Dt = Oe) + ci | 0, Ye = Z = ir + _t | 0, Z = vt(Z ^ kr, (Vt = Mt) ^ (Mt = Z >>> 0 < ir >>> 0 ? q + 1 | 0 : q), 40), q = mi + (Bn = Oe) | 0, mi = Z, q = ri + ((Z = Vr + Z | 0) >>> 0 < Vr >>> 0 ? q + 1 | 0 : q) | 0, q = (Z = Z + Ur | 0) >>> 0 < Ur >>> 0 ? q + 1 | 0 : q, ri = Z, kn = (B[L + 8 | 0] | B[L + 9 | 0] << 8 | B[L + 10 | 0] << 16 | B[L + 11 | 0] << 24) ^ Z, Vt = q, Pt = q ^ (B[L + 12 | 0] | B[L + 13 | 0] << 8 | B[L + 14 | 0] << 16 | B[L + 15 | 0] << 24), Ur = vt(Yn ^ ro, Dn ^ li, 48), q = (ro = Oe) + xt | 0, xt = Z = Ur + xr | 0, li = q = Z >>> 0 < Ur >>> 0 ? q + 1 | 0 : q, Yn = fo, q = qt + nn | 0, fo = q = (Z = tt + Lr | 0) >>> 0 < Lr >>> 0 ? q + 1 | 0 : q, Jt = vt(Z ^ Jt, q ^ gn, 1), q = (tt = Oe) + mo | 0, q = ((Yn = Jt + Yn | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q) + Ue | 0, Yn = q = (mo = Yn + Bt | 0) >>> 0 < Yn >>> 0 ? q + 1 | 0 : q, xr = vt(mo ^ Do, q ^ Lo, 32), q = (Lr = Oe) + li | 0, Bt = q = (Vr = xr + xt | 0) >>> 0 < xr >>> 0 ? q + 1 | 0 : q, Do = xr, xr = vt(Jt ^ Vr, q ^ tt, 40), q = (Ue = Oe) + Vo | 0, q = (xr >>> 0 > (Jt = xr + po | 0) >>> 0 ? q + 1 | 0 : q) + Yn | 0, qt = Lr, Lr = q = (mo = Jt + mo | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q, Jt = vt(Do ^ (po = mo), qt ^ q, 48), q = (tt = Oe) + Bt | 0, q = (Yn = Jt + Vr | 0) >>> 0 < Jt >>> 0 ? q + 1 | 0 : q, Vr = Yn, Yn ^= kn, j[L + 8 | 0] = Yn, j[L + 9 | 0] = Yn >>> 8, j[L + 10 | 0] = Yn >>> 16, j[L + 11 | 0] = Yn >>> 24, Bt = q, q ^= Pt, j[L + 12 | 0] = q, j[L + 13 | 0] = q >>> 8, j[L + 14 | 0] = q >>> 16, j[L + 15 | 0] = q >>> 24, mo = Z, Yn = fo, Z = Ur, Ur = vt(rt ^ _t, Tn ^ ci, 1), q = (Vo = Oe) + de | 0, q = (Ur >>> 0 > (fo = Ur + le | 0) >>> 0 ? q + 1 | 0 : q) + oo | 0, mn = q = (_t = fo) >>> 0 > (fo = mn + fo | 0) >>> 0 ? q + 1 | 0 : q, Z = vt(Z ^ fo, q ^ ro, 32), q = (q = Yn) + (Yn = Oe) | 0, ro = q = (mo = Z + mo | 0) >>> 0 < Z >>> 0 ? q + 1 | 0 : q, Do = Z, mo = vt(Ur ^ (oo = mo), q ^ Vo, 40), q = (rt = Oe) + ae | 0, q = mn + ((Z = mo + To | 0) >>> 0 < mo >>> 0 ? q + 1 | 0 : q) | 0, q = (Z = Z + fo | 0) >>> 0 < fo >>> 0 ? q + 1 | 0 : q, mn = Z, Z ^= Do, Do = q, fo = vt(Z, q ^ Yn, 48), q = (_t = Oe) + ro | 0, oo = Z = fo + oo | 0, ro = Z >>> 0 < fo >>> 0 ? q + 1 | 0 : q, ho = Z = vt(xt ^ ho, un ^ li, 1), Vo = q = Oe, q = q + br | 0, q = Ne + ((Z = Z + Hr | 0) >>> 0 < Hr >>> 0 ? q + 1 | 0 : q) | 0, br = q = (Ur = Z + Eo | 0) >>> 0 < Eo >>> 0 ? q + 1 | 0 : q, Z = (Yn = vt(We ^ Ur, q ^ ot, 32)) + be | 0, q = (be = Oe) + Te | 0, Eo = Z, Z = (Hr = vt(Ne = Z ^ ho, (ho = Z >>> 0 < Yn >>> 0 ? q + 1 | 0 : q) ^ Vo, 40)) + Qr | 0, q = (Qr = Oe) + io | 0, q = br + (Z >>> 0 < Hr >>> 0 ? q + 1 | 0 : q) | 0, q = (br = Z + Ur | 0) >>> 0 < Ur >>> 0 ? q + 1 | 0 : q, Ur = br ^ Mi ^ oo, j[0 | (Z = L)] = Ur, j[Z + 1 | 0] = Ur >>> 8, j[Z + 2 | 0] = Ur >>> 16, j[Z + 3 | 0] = Ur >>> 24, Ur = q ^ Ie ^ ro, j[Z + 4 | 0] = Ur, j[Z + 5 | 0] = Ur >>> 8, j[Z + 6 | 0] = Ur >>> 16, j[Z + 7 | 0] = Ur >>> 24, Ur = (Yn = vt(br ^ Yn, q ^ be, 48)) + Eo | 0, q = (Eo = Oe) + ho | 0, q = (ho = Ur >>> 0 < Yn >>> 0 ? q + 1 | 0 : q) ^ (B[Z + 20 | 0] | B[Z + 21 | 0] << 8 | B[Z + 22 | 0] << 16 | B[Z + 23 | 0] << 24) ^ Do, br = (B[Z + 16 | 0] | B[Z + 17 | 0] << 8 | B[Z + 18 | 0] << 16 | B[Z + 19 | 0] << 24) ^ mn ^ Ur, j[Z + 16 | 0] = br, j[Z + 17 | 0] = br >>> 8, j[Z + 18 | 0] = br >>> 16, j[Z + 19 | 0] = br >>> 24, j[Z + 20 | 0] = q, j[Z + 21 | 0] = q >>> 8, j[Z + 22 | 0] = q >>> 16, j[Z + 23 | 0] = q >>> 24, Z = vt(ir ^ ri, Vt ^ Dt, 48), br = Oe, mn = B[L + 36 | 0] | B[L + 37 | 0] << 8 | B[L + 38 | 0] << 16 | B[L + 39 | 0] << 24, q = (B[L + 32 | 0] | B[L + 33 | 0] << 8 | B[L + 34 | 0] << 16 | B[L + 35 | 0] << 24) ^ vt(xr ^ Vr, Ue ^ Bt, 1) ^ Z, j[L + 32 | 0] = q, j[L + 33 | 0] = q >>> 8, j[L + 34 | 0] = q >>> 16, j[L + 35 | 0] = q >>> 24, q = Oe ^ mn ^ br, j[L + 36 | 0] = q, j[L + 37 | 0] = q >>> 8, j[L + 38 | 0] = q >>> 16, j[L + 39 | 0] = q >>> 24, q = Mt + br | 0, q = (mn = Z + Ye | 0) >>> 0 < Z >>> 0 ? q + 1 | 0 : q, xr = (B[(Z = L) + 28 | 0] | B[Z + 29 | 0] << 8 | B[Z + 30 | 0] << 16 | B[Z + 31 | 0] << 24) ^ Lr ^ q, br = (B[Z + 24 | 0] | B[Z + 25 | 0] << 8 | B[Z + 26 | 0] << 16 | B[Z + 27 | 0] << 24) ^ po ^ mn, j[Z + 24 | 0] = br, j[Z + 25 | 0] = br >>> 8, j[Z + 26 | 0] = br >>> 16, j[Z + 27 | 0] = br >>> 24, j[Z + 28 | 0] = xr, j[Z + 29 | 0] = xr >>> 8, j[Z + 30 | 0] = xr >>> 16, j[Z + 31 | 0] = xr >>> 24, xr = B[Z + 44 | 0] | B[Z + 45 | 0] << 8 | B[Z + 46 | 0] << 16 | B[Z + 47 | 0] << 24, Z = fo ^ (B[Z + 40 | 0] | B[Z + 41 | 0] << 8 | B[Z + 42 | 0] << 16 | B[Z + 43 | 0] << 24) ^ vt(Ur ^ Hr, Qr ^ ho, 1), j[L + 40 | 0] = Z, j[L + 41 | 0] = Z >>> 8, j[L + 42 | 0] = Z >>> 16, j[L + 43 | 0] = Z >>> 24, Z = _t ^ Oe ^ xr, j[L + 44 | 0] = Z, j[L + 45 | 0] = Z >>> 8, j[L + 46 | 0] = Z >>> 16, j[L + 47 | 0] = Z >>> 24, Ur = B[L + 60 | 0] | B[L + 61 | 0] << 8 | B[L + 62 | 0] << 16 | B[L + 63 | 0] << 24, Z = Yn ^ (B[L + 56 | 0] | B[L + 57 | 0] << 8 | B[L + 58 | 0] << 16 | B[L + 59 | 0] << 24) ^ vt(oo ^ mo, rt ^ ro, 1), j[L + 56 | 0] = Z, j[L + 57 | 0] = Z >>> 8, j[L + 58 | 0] = Z >>> 16, j[L + 59 | 0] = Z >>> 24, Z = Eo ^ Oe ^ Ur, j[L + 60 | 0] = Z, j[L + 61 | 0] = Z >>> 8, j[L + 62 | 0] = Z >>> 16, j[L + 63 | 0] = Z >>> 24, Ur = B[L + 52 | 0] | B[L + 53 | 0] << 8 | B[L + 54 | 0] << 16 | B[L + 55 | 0] << 24, Z = Jt ^ (B[L + 48 | 0] | B[L + 49 | 0] << 8 | B[L + 50 | 0] << 16 | B[L + 51 | 0] << 24) ^ vt(mn ^ mi, q ^ Bn, 1), j[L + 48 | 0] = Z, j[L + 49 | 0] = Z >>> 8, j[L + 50 | 0] = Z >>> 16, j[L + 51 | 0] = Z >>> 24, Z = tt ^ Oe ^ Ur, j[L + 52 | 0] = Z, j[L + 53 | 0] = Z >>> 8, j[L + 54 | 0] = Z >>> 16, j[L + 55 | 0] = Z >>> 24;
                    }
                    function ve(L, Z, le, ae, de, Ie, Qe) {
                      var q, be, Ue, Ye, Te, Ne, We, rt, ot, _t, qt, tt, xt, Mt, Vt, un, gn, Bn, Tn, Pt, Dt, An, kn, Dn, De, Vn, Xn, nr, nn, vn, zn, jn, _r, br, kr, Qr, Ur, Lr, Jr, jr, oo, uo, _o, So, Ao, bo, xr, Oo, Yn = 0, ir = 0, Bt = 0, Jt = 0, mn = 0, Hr = 0, Vr = 0, ro = 0, io = 0, fo = 0, po = 0, mo = 0, ho = 0, tn = 0, Eo = 0, To = 0, Do = 0, Lo = 0, Ho = 0, Vo = 0, ri = 0, ci = 0, li = 0, mi = 0, yi = 0, Mi = 0, Fi = 0, Yi = 0, us = 0, As = 0, Vs = 0, Qs = 0, oa = 0, Ns = 0, fs = 0, Us = 0, Js = 0, Rs = 0, ia = 0, Ss = 0, Ai = 0, $a = 0, Ma = 0, Ga = 0, Ua = 0, ys = 0;
                      return st = Ue = st - 560 | 0, Ds(Ue + 352 | 0), Qe && Ni(Ue + 352 | 0, 34768, 34, 0), Si(Ue + 288 | 0, Ie, 32, 0), Ni(Hr = Ue + 352 | 0, Ue + 320 | 0, 32, 0), Ni(Hr, le, ae, de), Qi(Hr, ro = Ue + 224 | 0), io = B[(ir = Ie) + 32 | 0] | B[ir + 33 | 0] << 8 | B[ir + 34 | 0] << 16 | B[ir + 35 | 0] << 24, po = B[ir + 36 | 0] | B[ir + 37 | 0] << 8 | B[ir + 38 | 0] << 16 | B[ir + 39 | 0] << 24, Jt = B[ir + 40 | 0] | B[ir + 41 | 0] << 8 | B[ir + 42 | 0] << 16 | B[ir + 43 | 0] << 24, Yn = B[ir + 44 | 0] | B[ir + 45 | 0] << 8 | B[ir + 46 | 0] << 16 | B[ir + 47 | 0] << 24, Bt = B[ir + 48 | 0] | B[ir + 49 | 0] << 8 | B[ir + 50 | 0] << 16 | B[ir + 51 | 0] << 24, Ie = B[ir + 52 | 0] | B[ir + 53 | 0] << 8 | B[ir + 54 | 0] << 16 | B[ir + 55 | 0] << 24, mn = B[ir + 60 | 0] | B[ir + 61 | 0] << 8 | B[ir + 62 | 0] << 16 | B[ir + 63 | 0] << 24, ir = B[ir + 56 | 0] | B[ir + 57 | 0] << 8 | B[ir + 58 | 0] << 16 | B[ir + 59 | 0] << 24, j[L + 56 | 0] = ir, j[L + 57 | 0] = ir >>> 8, j[L + 58 | 0] = ir >>> 16, j[L + 59 | 0] = ir >>> 24, j[L + 60 | 0] = mn, j[L + 61 | 0] = mn >>> 8, j[L + 62 | 0] = mn >>> 16, j[L + 63 | 0] = mn >>> 24, j[L + 48 | 0] = Bt, j[L + 49 | 0] = Bt >>> 8, j[L + 50 | 0] = Bt >>> 16, j[L + 51 | 0] = Bt >>> 24, j[L + 52 | 0] = Ie, j[L + 53 | 0] = Ie >>> 8, j[L + 54 | 0] = Ie >>> 16, j[L + 55 | 0] = Ie >>> 24, j[L + 40 | 0] = Jt, j[L + 41 | 0] = Jt >>> 8, j[L + 42 | 0] = Jt >>> 16, j[L + 43 | 0] = Jt >>> 24, j[L + 44 | 0] = Yn, j[L + 45 | 0] = Yn >>> 8, j[L + 46 | 0] = Yn >>> 16, j[L + 47 | 0] = Yn >>> 24, j[0 | (Ie = L + 32 | 0)] = io, j[Ie + 1 | 0] = io >>> 8, j[Ie + 2 | 0] = io >>> 16, j[Ie + 3 | 0] = io >>> 24, j[Ie + 4 | 0] = po, j[Ie + 5 | 0] = po >>> 8, j[Ie + 6 | 0] = po >>> 16, j[Ie + 7 | 0] = po >>> 24, aa(ro), Ui(Ue, ro), Ce(L, Ue), Ds(Hr), Qe && Ni(Ue + 352 | 0, 34768, 34, 0), Ni(Qe = Ue + 352 | 0, L, 64, 0), Ni(Qe, le, ae, de), Qi(Qe, Vr = Ue + 160 | 0), aa(Vr), j[Ue + 288 | 0] = 248 & B[Ue + 288 | 0], j[Ue + 319 | 0] = 63 & B[Ue + 319 | 0] | 64, le = B[23 + (L = be = Ue + 288 | 0) | 0], Jt = dt(Ye = B[L + 21 | 0] | B[L + 22 | 0] << 8 | le << 16 & 2031616, 0, Te = (B[Vr + 28 | 0] | B[Vr + 29 | 0] << 8 | B[Vr + 30 | 0] << 16 | B[Vr + 31 | 0] << 24) >>> 7 | 0, 0), Bt = Oe, le = (L = B[Vr + 27 | 0]) >>> 24 | 0, de = L << 8 | (Yn = B[Vr + 23 | 0] | B[Vr + 24 | 0] << 8 | B[Vr + 25 | 0] << 16 | B[Vr + 26 | 0] << 24) >>> 24, L = dt(Ne = 2097151 & ((3 & (po = (L = (ae = B[Vr + 28 | 0]) >>> 16 | 0) | le)) << 30 | (le = (ae <<= 16) | de) >>> 2), 0, We = (Qe = B[be + 23 | 0] | B[be + 24 | 0] << 8 | B[be + 25 | 0] << 16 | B[be + 26 | 0] << 24) >>> 5 & 2097151, 0), le = Oe + Bt | 0, ae = L >>> 0 > (de = L + Jt | 0) >>> 0 ? le + 1 | 0 : le, L = dt(rt = (le = B[Vr + 23 | 0]) << 16 & 2031616 | B[Vr + 21 | 0] | B[Vr + 22 | 0] << 8, 0, ot = (B[be + 28 | 0] | B[be + 29 | 0] << 8 | B[be + 30 | 0] << 16 | B[be + 31 | 0] << 24) >>> 7 | 0, 0), ae = Oe + ae | 0, Bt = le = L + de | 0, de = L >>> 0 > le >>> 0 ? ae + 1 | 0 : ae, ae = (L = B[be + 27 | 0]) >>> 24 | 0, Qe = L << 8 | Qe >>> 24, L = dt(_t = 2097151 & ((3 & (ae |= le = (L = B[be + 28 | 0]) >>> 16 | 0)) << 30 | (le = (L <<= 16) | Qe) >>> 2), 0, qt = Yn >>> 5 & 2097151, 0), le = Oe + de | 0, ir = ae = L + Bt | 0, de = L >>> 0 > ae >>> 0 ? le + 1 | 0 : le, Yn = dt(We, 0, qt, 0), Bt = Oe, le = (L = B[be + 19 | 0]) >>> 24 | 0, Qe = L << 8 | (Do = B[be + 15 | 0] | B[be + 16 | 0] << 8 | B[be + 17 | 0] << 16 | B[be + 18 | 0] << 24) >>> 24, ae = le, le = dt(tt = (7 & (ae |= le = (L = B[be + 20 | 0]) >>> 16 | 0)) << 29 | (le = (L <<= 16) | Qe) >>> 3, po = ae >>> 3 | 0, Te, 0), L = Oe + Bt | 0, L = le >>> 0 > (ae = le + Yn | 0) >>> 0 ? L + 1 | 0 : L, Qe = (le = dt(Ye, 0, Ne, 0)) + ae | 0, ae = Oe + L | 0, le = le >>> 0 > (Yn = Qe) >>> 0 ? ae + 1 | 0 : ae, ae = (L = B[Vr + 19 | 0]) >>> 24 | 0, Bt = L << 8 | (To = B[Vr + 15 | 0] | B[Vr + 16 | 0] << 8 | B[Vr + 17 | 0] << 16 | B[Vr + 18 | 0] << 24) >>> 24, L = dt(xt = (7 & (Jt = (L = (Qe = B[Vr + 20 | 0]) >>> 16 | 0) | ae)) << 29 | (ae = (Qe <<= 16) | Bt) >>> 3, Mt = Jt >>> 3 | 0, ot, 0), le = Oe + le | 0, le = L >>> 0 > (ae = L + Yn | 0) >>> 0 ? le + 1 | 0 : le, L = dt(rt, 0, _t, 0), le = Oe + le | 0, io = le = L >>> 0 > (ro = L + ae | 0) >>> 0 ? le + 1 | 0 : le, mo = L = le - ((ro >>> 0 < 4293918720) - 1 | 0) | 0, ae = (le = L >>> 21 | 0) + de | 0, Yn = ae = (L = (2097151 & L) << 11 | (Jt = ro - -1048576 | 0) >>> 21) >>> 0 > (ir = L + ir | 0) >>> 0 ? ae + 1 | 0 : ae, tn = L = ae - ((ir >>> 0 < 4293918720) - 1 | 0) | 0, Hr = (2097151 & L) << 11 | (Bt = ir - -1048576 | 0) >>> 21, Qe = L >>> 21 | 0, L = dt(ot, 0, qt, 0), le = Oe, ae = L, L = dt(Te, 0, We, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, ho = (L = ae) + (ae = dt(Ne, 0, _t, 0)) | 0, L = Oe + le | 0, L = ae >>> 0 > ho >>> 0 ? L + 1 | 0 : L, mn = ho - (le = -2097152 & (ae = ho - -1048576 | 0)) | 0, le = (L - ((131071 & (de = L - ((ho >>> 0 < 4293918720) - 1 | 0) | 0)) + (le >>> 0 > ho >>> 0) | 0) | 0) + Qe | 0, nn = le = (L = mn + Hr | 0) >>> 0 < mn >>> 0 ? le + 1 | 0 : le, vn = L, mn = dt(L, le, 470296, 0), Hr = Oe, le = dt(Te, 0, _t, 0), L = Oe, Qe = le, le = dt(Ne, 0, ot, 0), L = Oe + L | 0, le = le >>> 0 > (Qe = Qe + le | 0) >>> 0 ? L + 1 | 0 : L, L = de >>> 21 | 0, de = (2097151 & de) << 11 | ae >>> 21, ae = L + le | 0, ci = de = (ae = de >>> 0 > (Qe = de + Qe | 0) >>> 0 ? ae + 1 | 0 : ae) - ((Qe >>> 0 < 4293918720) - 1 | 0) | 0, L = Qe - (le = -2097152 & (ri = Qe - -1048576 | 0)) | 0, zn = Qe = ae - ((131071 & de) + (le >>> 0 > Qe >>> 0) | 0) | 0, jn = le = ir - (ae = -2097152 & Bt) | 0, _r = de = Yn - ((ae >>> 0 > ir >>> 0) + tn | 0) | 0, br = L, ae = dt(L, Qe, 666643, 0), L = Oe + Hr | 0, L = ae >>> 0 > (Qe = ae + mn | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(le, de, 654183, 0), le = Oe + L | 0, fo = de = ae + Qe | 0, Bt = ae >>> 0 > de >>> 0 ? le + 1 | 0 : le, ho = ro - (L = -2097152 & Jt) | 0, mo = io - ((L >>> 0 > ro >>> 0) + mo | 0) | 0, le = dt(Ne, 0, tt, po), ae = Oe, de = (L = le) + (le = dt(Vt = Do >>> 6 & 2097151, 0, Te, 0)) | 0, L = Oe + ae | 0, L = le >>> 0 > de >>> 0 ? L + 1 | 0 : L, le = dt(We, 0, rt, 0), ae = Oe + L | 0, ae = le >>> 0 > (de = le + de | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(Ye, 0, qt, 0), le = Oe + ae | 0, le = L >>> 0 > (de = L + de | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(ot, 0, un = To >>> 6 & 2097151, 0), L = Oe + le | 0, L = ae >>> 0 > (de = ae + de | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(_t, 0, xt, Mt), le = Oe + L | 0, ro = de = ae + de | 0, Qe = ae >>> 0 > de >>> 0 ? le + 1 | 0 : le, le = (L = B[be + 14 | 0]) >>> 24 | 0, de = L << 8 | (io = B[be + 10 | 0] | B[be + 11 | 0] << 8 | B[be + 12 | 0] << 16 | B[be + 13 | 0] << 24) >>> 24, le = dt(gn = 2097151 & ((1 & (le |= L = (ae = B[be + 15 | 0]) >>> 16 | 0)) << 31 | (L = (ae <<= 16) | de) >>> 1), 0, Te, 0), L = Oe, ae = le, le = dt(Ne, 0, Vt, 0), L = Oe + L | 0, L = le >>> 0 > (ae = ae + le | 0) >>> 0 ? L + 1 | 0 : L, de = (le = dt(qt, 0, tt, po)) + ae | 0, ae = Oe + L | 0, ae = le >>> 0 > de >>> 0 ? ae + 1 | 0 : ae, L = dt(We, 0, xt, Mt), le = Oe + ae | 0, le = L >>> 0 > (de = L + de | 0) >>> 0 ? le + 1 | 0 : le, L = dt(Ye, 0, rt, 0), le = Oe + le | 0, Jt = ae = L + de | 0, de = L >>> 0 > ae >>> 0 ? le + 1 | 0 : le, le = (L = B[Vr + 14 | 0]) >>> 24 | 0, Yn = L << 8 | (ir = B[Vr + 10 | 0] | B[Vr + 11 | 0] << 8 | B[Vr + 12 | 0] << 16 | B[Vr + 13 | 0] << 24) >>> 24, ae = le, le = (L = B[Vr + 15 | 0]) >>> 16 | 0, le = dt(Bn = 2097151 & ((1 & (le |= ae)) << 31 | (L = L << 16 | Yn) >>> 1), 0, ot, 0), L = Oe + de | 0, L = le >>> 0 > (ae = le + Jt | 0) >>> 0 ? L + 1 | 0 : L, le = dt(_t, 0, un, 0), L = Oe + L | 0, Yn = L = le >>> 0 > (Jt = le + ae | 0) >>> 0 ? L + 1 | 0 : L, li = le = L - ((Jt >>> 0 < 4293918720) - 1 | 0) | 0, ae = (L = le >>> 21 | 0) + Qe | 0, Hr = ae = (le = (2097151 & le) << 11 | (mn = Jt - -1048576 | 0) >>> 21) >>> 0 > (tn = le + ro | 0) >>> 0 ? ae + 1 | 0 : ae, Ho = le = ae - ((tn >>> 0 < 4293918720) - 1 | 0) | 0, L = (L = le >>> 21 | 0) + mo | 0, kr = L = (le = (ae = (2097151 & le) << 11 | (ro = tn - -1048576 | 0) >>> 21) + ho | 0) >>> 0 < ae >>> 0 ? L + 1 | 0 : L, Qr = le, L = dt(le, L, -997805, -1), le = Oe + Bt | 0, fo = ae = L + fo | 0, Bt = L >>> 0 > ae >>> 0 ? le + 1 | 0 : le, ho = (Mi = B[23 + (q = Ue + 224 | 0) | 0] | B[q + 24 | 0] << 8 | B[q + 25 | 0] << 16 | B[q + 26 | 0] << 24) >>> 5 & 2097151, ae = dt(Tn = (L = B[be + 2 | 0]) << 16 & 2031616 | B[0 | be] | B[be + 1 | 0] << 8, 0, qt, 0), le = Oe, de = (L = dt(rt, 0, Pt = (Qe = B[be + 2 | 0] | B[be + 3 | 0] << 8 | B[be + 4 | 0] << 16 | B[be + 5 | 0] << 24) >>> 5 & 2097151, 0)) + ae | 0, ae = Oe + le | 0, ae = L >>> 0 > de >>> 0 ? ae + 1 | 0 : ae, L = dt(Dt = (B[be + 7 | 0] | B[be + 8 | 0] << 8 | B[be + 9 | 0] << 16 | B[be + 10 | 0] << 24) >>> 7 & 2097151, 0, un, 0), le = Oe + ae | 0, le = L >>> 0 > (de = L + de | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(Bn, 0, An = io >>> 4 & 2097151, 0), L = Oe + le | 0, io = de = ae + de | 0, de = ae >>> 0 > de >>> 0 ? L + 1 | 0 : L, Qe = (le = B[be + 6 | 0]) << 8 | Qe >>> 24, ae = L = le >>> 24 | 0, le = (L = B[be + 7 | 0]) >>> 16 | 0, le = dt(kn = 2097151 & ((3 & (le |= ae)) << 30 | (L = L << 16 | Qe) >>> 2), 0, xt, Mt), L = Oe + de | 0, L = le >>> 0 > (ae = le + io | 0) >>> 0 ? L + 1 | 0 : L, de = (le = dt(Vt, 0, Dn = (B[Vr + 7 | 0] | B[Vr + 8 | 0] << 8 | B[Vr + 9 | 0] << 16 | B[Vr + 10 | 0] << 24) >>> 7 & 2097151, 0)) + ae | 0, ae = Oe + L | 0, ae = le >>> 0 > de >>> 0 ? ae + 1 | 0 : ae, le = dt(gn, 0, Vo = ir >>> 4 & 2097151, 0), L = Oe + ae | 0, Qe = le >>> 0 > (de = le + de | 0) >>> 0 ? L + 1 | 0 : L, L = (le = B[Vr + 6 | 0]) >>> 24 | 0, io = le << 8 | (ir = B[Vr + 2 | 0] | B[Vr + 3 | 0] << 8 | B[Vr + 4 | 0] << 16 | B[Vr + 5 | 0] << 24) >>> 24, le = L, L = dt(tt, po, De = 2097151 & ((3 & (le |= ae = (L = B[Vr + 7 | 0]) >>> 16 | 0)) << 30 | (L = L << 16 | io) >>> 2), 0), le = Oe + Qe | 0, le = L >>> 0 > (ae = L + de | 0) >>> 0 ? le + 1 | 0 : le, de = ae, ae = dt(Vn = (L = B[Vr + 2 | 0]) << 16 & 2031616 | B[0 | Vr] | B[Vr + 1 | 0] << 8, 0, We, 0), L = Oe + le | 0, L = ae >>> 0 > (de = de + ae | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Ye, 0, Xn = ir >>> 5 & 2097151, 0), L = Oe + L | 0, le = le >>> 0 > (ae = le + de | 0) >>> 0 ? L + 1 | 0 : L, io = L = ae + ho | 0, Qe = le = L >>> 0 < ae >>> 0 ? le + 1 | 0 : le, de = B[q + 21 | 0] | B[q + 22 | 0] << 8, L = dt(rt, 0, Tn, 0), le = Oe, ir = (ae = L) + (L = dt(xt, Mt, Pt, 0)) | 0, ae = Oe + le | 0, ae = L >>> 0 > ir >>> 0 ? ae + 1 | 0 : ae, L = dt(Bn, 0, Dt, 0), le = Oe + ae | 0, le = L >>> 0 > (ir = L + ir | 0) >>> 0 ? le + 1 | 0 : le, L = dt(An, 0, Vo, 0), le = Oe + le | 0, le = L >>> 0 > (ae = L + ir | 0) >>> 0 ? le + 1 | 0 : le, ir = (L = ae) + (ae = dt(un, 0, kn, 0)) | 0, L = Oe + le | 0, L = ae >>> 0 > ir >>> 0 ? L + 1 | 0 : L, le = dt(Vt, 0, De, 0), L = Oe + L | 0, L = le >>> 0 > (ae = le + ir | 0) >>> 0 ? L + 1 | 0 : L, ir = (le = dt(gn, 0, Dn, 0)) + ae | 0, ae = Oe + L | 0, ae = le >>> 0 > ir >>> 0 ? ae + 1 | 0 : ae, L = dt(tt, po, Xn, 0), le = Oe + ae | 0, le = L >>> 0 > (ir = L + ir | 0) >>> 0 ? le + 1 | 0 : le, L = dt(Ye, 0, Vn, 0), le = Oe + le | 0, L = L >>> 0 > (ae = L + ir | 0) >>> 0 ? le + 1 | 0 : le, le = (le = ae) >>> 0 > (ae = ae + de | 0) >>> 0 ? L + 1 | 0 : L, de = ae, ae = (L = B[q + 23 | 0]) << 16 & 2031616, L = le, ae = L = ae >>> 0 > (de = de + ae | 0) >>> 0 ? L + 1 | 0 : L, Vr = L = L - ((de >>> 0 < 4293918720) - 1 | 0) | 0, le = (le = L >>> 21 | 0) + Qe | 0, L = (le = (Qe = io = (L = (2097151 & L) << 11 | (ir = de - -1048576 | 0) >>> 21) + io | 0) >>> 0 < L >>> 0 ? le + 1 | 0 : le) + Bt | 0, L = (Bt = Qe + fo | 0) >>> 0 < Qe >>> 0 ? L + 1 | 0 : L, Do = Qe - -1048576 | 0, Eo = Qe = le - ((Qe >>> 0 < 4293918720) - 1 | 0) | 0, Lo = Bt - (le = -2097152 & Do) | 0, mi = L - ((le >>> 0 > Bt >>> 0) + Qe | 0) | 0, io = de, Bt = ae, L = dt(jn, _r, 470296, 0), le = Oe, ae = L, L = dt(vn, nn, 666643, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, de = (L = ae) + (ae = dt(Qr, kr, 654183, 0)) | 0, L = Oe + le | 0, To = de, Qe = ae >>> 0 > de >>> 0 ? L + 1 | 0 : L, le = dt(xt, Mt, Tn, 0), L = Oe, ae = le, le = dt(un, 0, Pt, 0), L = Oe + L | 0, L = le >>> 0 > (ae = ae + le | 0) >>> 0 ? L + 1 | 0 : L, de = (le = ae) + (ae = dt(Dt, 0, Vo, 0)) | 0, le = Oe + L | 0, le = ae >>> 0 > de >>> 0 ? le + 1 | 0 : le, L = dt(An, 0, Dn, 0), ae = Oe + le | 0, ae = L >>> 0 > (de = L + de | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(Bn, 0, kn, 0), le = Oe + ae | 0, le = L >>> 0 > (de = L + de | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(Vt, 0, Xn, 0), L = Oe + le | 0, L = ae >>> 0 > (de = ae + de | 0) >>> 0 ? L + 1 | 0 : L, le = dt(gn, 0, De, 0), L = Oe + L | 0, L = le >>> 0 > (ae = le + de | 0) >>> 0 ? L + 1 | 0 : L, de = (le = ae) + (ae = dt(tt, po, Vn, 0)) | 0, le = Oe + L | 0, ho = de, ae = ae >>> 0 > de >>> 0 ? le + 1 | 0 : le, le = (L = B[q + 19 | 0]) >>> 24 | 0, mo = L << 8 | (fo = B[q + 15 | 0] | B[q + 16 | 0] << 8 | B[q + 17 | 0] << 16 | B[q + 18 | 0] << 24) >>> 24, ae = ((yi = (L = (de = B[q + 20 | 0]) >>> 16 | 0) | le) >>> 3 | 0) + ae | 0, ho = de = (le = (7 & yi) << 29 | (le = (de <<= 16) | mo) >>> 3) + ho | 0, de = le >>> 0 > de >>> 0 ? ae + 1 | 0 : ae, mo = fo >>> 6 & 2097151, L = dt(un, 0, Tn, 0), le = Oe, ae = L, L = dt(Bn, 0, Pt, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, fo = (L = ae) + (ae = dt(Dt, 0, Dn, 0)) | 0, L = Oe + le | 0, L = ae >>> 0 > fo >>> 0 ? L + 1 | 0 : L, ae = dt(An, 0, De, 0), le = Oe + L | 0, le = ae >>> 0 > (fo = ae + fo | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(kn, 0, Vo, 0), L = Oe + le | 0, L = ae >>> 0 > (fo = ae + fo | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Vt, 0, Vn, 0), ae = Oe + L | 0, ae = le >>> 0 > (fo = le + fo | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(gn, 0, Xn, 0), le = Oe + ae | 0, L = L >>> 0 > (fo = L + fo | 0) >>> 0 ? le + 1 | 0 : le, fs = L = (Yi = fo + mo | 0) >>> 0 < fo >>> 0 ? L + 1 | 0 : L, $a = L = L - ((Yi >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & L) << 11 | (oa = Yi - -1048576 | 0) >>> 21, L = (L >>> 21 | 0) + de | 0, Js = L = ae >>> 0 > (Us = ae + ho | 0) >>> 0 ? L + 1 | 0 : L, Ma = L = L - ((Us >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & L) << 11 | (As = Us - -1048576 | 0) >>> 21, L = (L >>> 21 | 0) + Qe | 0, le = (ae >>> 0 > (de = ae + To | 0) >>> 0 ? L + 1 | 0 : L) + Bt | 0, Bt = (ae = de + io | 0) - (L = -2097152 & ir) | 0, Vr = L = (le = ae >>> 0 < de >>> 0 ? le + 1 | 0 : le) - ((L >>> 0 > ae >>> 0) + Vr | 0) | 0, Ga = L = L - ((Bt >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & L) << 11 | (Vs = Bt - -1048576 | 0) >>> 21, L = (L >> 21) + mi | 0, de = L = ae >>> 0 > (Qe = ae + Lo | 0) >>> 0 ? L + 1 | 0 : L, Ai = L = L - ((Qe >>> 0 < 4293918720) - 1 | 0) | 0, Qs = (2097151 & L) << 11 | (To = Qe - -1048576 | 0) >>> 21, io = L >> 21, yi = tn - (L = -2097152 & ro) | 0, Ho = Hr - ((L >>> 0 > tn >>> 0) + Ho | 0) | 0, L = dt(Te, 0, ot, 0), Ns = le = Oe, Lo = L, fo = L - -1048576 | 0, us = le = le - ((L >>> 0 < 4293918720) - 1 | 0) | 0, Ur = L = le >>> 21 | 0, L = dt(nr = (2097151 & le) << 11 | fo >>> 21, L, -683901, -1), le = Oe + Yn | 0, le = L >>> 0 > (ae = L + Jt | 0) >>> 0 ? le + 1 | 0 : le, ro = ae - (L = -2097152 & mn) | 0, ir = le - ((L >>> 0 > ae >>> 0) + li | 0) | 0, le = dt(qt, 0, Vt, 0), L = Oe, ae = le, le = dt(Te, 0, An, 0), L = Oe + L | 0, L = le >>> 0 > (ae = ae + le | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Ne, 0, gn, 0), L = Oe + L | 0, L = le >>> 0 > (ae = le + ae | 0) >>> 0 ? L + 1 | 0 : L, Yn = (le = ae) + (ae = dt(rt, 0, tt, po)) | 0, le = Oe + L | 0, le = ae >>> 0 > Yn >>> 0 ? le + 1 | 0 : le, L = dt(We, 0, un, 0), ae = Oe + le | 0, ae = L >>> 0 > (Yn = L + Yn | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(Ye, 0, xt, Mt), le = Oe + ae | 0, le = L >>> 0 > (Yn = L + Yn | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(ot, 0, Vo, 0), L = Oe + le | 0, L = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? L + 1 | 0 : L, le = dt(_t, 0, Bn, 0), L = Oe + L | 0, Jt = ae = le + Yn | 0, Yn = le >>> 0 > ae >>> 0 ? L + 1 | 0 : L, L = dt(Ne, 0, An, 0), le = Oe, ae = L, L = dt(Te, 0, Dt, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, Hr = (L = dt(rt, 0, Vt, 0)) + ae | 0, ae = Oe + le | 0, ae = L >>> 0 > Hr >>> 0 ? ae + 1 | 0 : ae, L = dt(qt, 0, gn, 0), le = Oe + ae | 0, le = L >>> 0 > (Hr = L + Hr | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(tt, po, xt, Mt), L = Oe + le | 0, L = ae >>> 0 > (Hr = ae + Hr | 0) >>> 0 ? L + 1 | 0 : L, le = dt(We, 0, Bn, 0), L = Oe + L | 0, L = le >>> 0 > (ae = le + Hr | 0) >>> 0 ? L + 1 | 0 : L, Hr = (le = ae) + (ae = dt(Ye, 0, un, 0)) | 0, le = Oe + L | 0, le = ae >>> 0 > Hr >>> 0 ? le + 1 | 0 : le, L = dt(ot, 0, Dn, 0), ae = Oe + le | 0, ae = L >>> 0 > (Hr = L + Hr | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(_t, 0, Vo, 0), le = Oe + ae | 0, mo = le = L >>> 0 > (ho = L + Hr | 0) >>> 0 ? le + 1 | 0 : le, ia = L = le - ((ho >>> 0 < 4293918720) - 1 | 0) | 0, le = (2097151 & L) << 11 | (tn = ho - -1048576 | 0) >>> 21, L = (L >>> 21 | 0) + Yn | 0, mn = L = le >>> 0 > (li = le + Jt | 0) >>> 0 ? L + 1 | 0 : L, Fi = L = L - ((li >>> 0 < 4293918720) - 1 | 0) | 0, le = (ae = L >>> 21 | 0) + ir | 0, ro = le = (L = (2097151 & L) << 11 | (Hr = li - -1048576 | 0) >>> 21) >>> 0 > (mi = L + ro | 0) >>> 0 ? le + 1 | 0 : le, Rs = L = le - ((mi >>> 0 < 4293918720) - 1 | 0) | 0, Yn = (2097151 & L) << 11 | (ir = mi - -1048576 | 0) >>> 21, L = (L >> 21) + Ho | 0, Lr = L = (le = Yn + yi | 0) >>> 0 < Yn >>> 0 ? L + 1 | 0 : L, Jr = le, L = dt(le, L, -683901, -1), le = Oe + io | 0, Qs = ae = L + Qs | 0, io = L >>> 0 > ae >>> 0 ? le + 1 | 0 : le, L = dt(Ne, 0, Tn, 0), le = Oe, ae = L, L = dt(qt, 0, Pt, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, Yn = (L = ae) + (ae = dt(xt, Mt, Dt, 0)) | 0, L = Oe + le | 0, L = ae >>> 0 > Yn >>> 0 ? L + 1 | 0 : L, le = dt(un, 0, An, 0), ae = Oe + L | 0, ae = le >>> 0 > (Yn = le + Yn | 0) >>> 0 ? ae + 1 | 0 : ae, le = dt(rt, 0, kn, 0), L = Oe + ae | 0, L = le >>> 0 > (Yn = le + Yn | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(Vt, 0, Vo, 0), le = Oe + L | 0, le = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? le + 1 | 0 : le, L = dt(gn, 0, Bn, 0), le = Oe + le | 0, le = L >>> 0 > (ae = L + Yn | 0) >>> 0 ? le + 1 | 0 : le, Yn = (L = ae) + (ae = dt(tt, po, Dn, 0)) | 0, L = Oe + le | 0, L = ae >>> 0 > Yn >>> 0 ? L + 1 | 0 : L, le = dt(We, 0, Xn, 0), ae = Oe + L | 0, ae = le >>> 0 > (Yn = le + Yn | 0) >>> 0 ? ae + 1 | 0 : ae, le = dt(Ye, 0, De, 0), L = Oe + ae | 0, L = le >>> 0 > (Yn = le + Yn | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(_t, 0, Vn, 0), le = Oe + L | 0, Ho = Yn = ae + Yn | 0, ae = ae >>> 0 > Yn >>> 0 ? le + 1 | 0 : le, le = (L = B[q + 27 | 0]) >>> 24 | 0, Jt = L << 8 | Mi >>> 24, Yn = 2097151 & ((3 & (le |= L = (Yn = B[q + 28 | 0]) >>> 16 | 0)) << 30 | (L = (Yn <<= 16) | Jt) >>> 2), le = ae, Jt = L = Yn + Ho | 0, Yn = L >>> 0 < Yn >>> 0 ? le + 1 | 0 : le, yi = dt(br, zn, 470296, 0), Ho = Oe, L = (ae = (2097151 & ci) << 11 | ri >>> 21) + (Lo - (le = -2097152 & fo) | 0) | 0, le = Ns - ((524287 & us) + (le >>> 0 > Lo >>> 0) | 0) + (ci >>> 21) | 0, jr = le = L >>> 0 < ae >>> 0 ? le + 1 | 0 : le, oo = L, le = dt(L, le, 666643, 0), L = Oe + Ho | 0, L = le >>> 0 > (ae = le + yi | 0) >>> 0 ? L + 1 | 0 : L, fo = (le = dt(vn, nn, 654183, 0)) + ae | 0, ae = Oe + L | 0, ae = le >>> 0 > fo >>> 0 ? ae + 1 | 0 : ae, le = dt(jn, _r, -997805, -1), L = Oe + ae | 0, L = le >>> 0 > (fo = le + fo | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(Qr, kr, 136657, 0), le = Oe + L | 0, Do = (L = (2097151 & Eo) << 11 | Do >>> 21) + (fo = ae + fo | 0) | 0, le = (Eo >>> 21 | 0) + (ae >>> 0 > fo >>> 0 ? le + 1 | 0 : le) | 0, us = fo = Yn - ((Jt >>> 0 < 4293918720) - 1 | 0) | 0, L = (L >>> 0 > Do >>> 0 ? le + 1 | 0 : le) + Yn | 0, le = (Yn = Jt + Do | 0) - (ae = -2097152 & (Ns = Jt - -1048576 | 0)) | 0, ae = (L = (L = Yn >>> 0 < Do >>> 0 ? L + 1 | 0 : L) - ((ae >>> 0 > Yn >>> 0) + fo | 0) | 0) + io | 0, yi = Yn = L - ((le >>> 0 < 4293918720) - 1 | 0) | 0, Lo = (ae = (Jt = le + Qs | 0) >>> 0 < le >>> 0 ? ae + 1 | 0 : ae) - (((le = -2097152 & (Ho = le - -1048576 | 0)) >>> 0 > Jt >>> 0) + Yn | 0) | 0, Mi = L = Jt - le | 0, Yn = Qe, Qe = de, Ss = mi - (L = -2097152 & ir) | 0, fo = ro - ((L >>> 0 > mi >>> 0) + Rs | 0) | 0, L = dt(oo, jr, -683901, -1), le = Oe, de = (ae = L) + (L = dt(nr, Ur, 136657, 0)) | 0, ae = Oe + le | 0, le = mn + (L >>> 0 > de >>> 0 ? ae + 1 | 0 : ae) | 0, Hr = (ae = de + li | 0) - (L = -2097152 & Hr) | 0, ro = (le = ae >>> 0 < li >>> 0 ? le + 1 | 0 : le) - ((L >>> 0 > ae >>> 0) + Fi | 0) | 0, le = dt(nr, Ur, -997805, -1), L = Oe + mo | 0, L = le >>> 0 > (ae = le + ho | 0) >>> 0 ? L + 1 | 0 : L, de = (le = dt(oo, jr, 136657, 0)) + ae | 0, ae = Oe + L | 0, ae = le >>> 0 > de >>> 0 ? ae + 1 | 0 : ae, L = dt(br, zn, -683901, -1), le = Oe + ae | 0, le = L >>> 0 > (de = L + de | 0) >>> 0 ? le + 1 | 0 : le, ir = de - (L = -2097152 & tn) | 0, io = le - ((L >>> 0 > de >>> 0) + ia | 0) | 0, le = dt(qt, 0, An, 0), L = Oe, ae = le, le = dt(Ne, 0, Dt, 0), L = Oe + L | 0, L = le >>> 0 > (ae = ae + le | 0) >>> 0 ? L + 1 | 0 : L, de = (le = dt(Te, 0, kn, 0)) + ae | 0, ae = Oe + L | 0, ae = le >>> 0 > de >>> 0 ? ae + 1 | 0 : ae, L = dt(xt, Mt, Vt, 0), le = Oe + ae | 0, le = L >>> 0 > (de = L + de | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(rt, 0, gn, 0), L = Oe + le | 0, L = ae >>> 0 > (de = ae + de | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(tt, po, un, 0), le = Oe + L | 0, le = ae >>> 0 > (de = ae + de | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(We, 0, Vo, 0), L = Oe + le | 0, L = ae >>> 0 > (de = ae + de | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Ye, 0, Bn, 0), ae = Oe + L | 0, ae = le >>> 0 > (de = le + de | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(ot, 0, De, 0), le = Oe + ae | 0, le = L >>> 0 > (de = L + de | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(_t, 0, Dn, 0), L = Oe + le | 0, Jt = de = ae + de | 0, de = ae >>> 0 > de >>> 0 ? L + 1 | 0 : L, L = dt(qt, 0, Dt, 0), le = Oe, ae = L, L = dt(Te, 0, Pt, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, mn = (L = ae) + (ae = dt(rt, 0, An, 0)) | 0, L = Oe + le | 0, L = ae >>> 0 > mn >>> 0 ? L + 1 | 0 : L, le = dt(Ne, 0, kn, 0), ae = Oe + L | 0, ae = le >>> 0 > (mn = le + mn | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(Vt, 0, un, 0), le = Oe + ae | 0, le = L >>> 0 > (mn = L + mn | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(xt, Mt, gn, 0), L = Oe + le | 0, L = ae >>> 0 > (mn = ae + mn | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(tt, po, Bn, 0), le = Oe + L | 0, le = ae >>> 0 > (mn = ae + mn | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(We, 0, Dn, 0), L = Oe + le | 0, L = ae >>> 0 > (mn = ae + mn | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Ye, 0, Vo, 0), ae = Oe + L | 0, ae = le >>> 0 > (mn = le + mn | 0) >>> 0 ? ae + 1 | 0 : ae, mn = (L = dt(ot, 0, Xn, 0)) + mn | 0, le = Oe + ae | 0, ae = dt(_t, 0, De, 0), L = Oe + (L >>> 0 > mn >>> 0 ? le + 1 | 0 : le) | 0, mi = L = ae >>> 0 > (Rs = ae + mn | 0) >>> 0 ? L + 1 | 0 : L, _o = L = L - ((Rs >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & L) << 11 | (ci = Rs - -1048576 | 0) >>> 21, L = (L >>> 21 | 0) + de | 0, ri = L = ae >>> 0 > (Qs = ae + Jt | 0) >>> 0 ? L + 1 | 0 : L, So = L = L - ((Qs >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & L) << 11 | (Eo = Qs - -1048576 | 0) >>> 21, L = (L >>> 21 | 0) + io | 0, Do = L = ae >>> 0 > (li = ae + ir | 0) >>> 0 ? L + 1 | 0 : L, Ao = L = L - ((li >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & L) << 11 | (mo = li - -1048576 | 0) >>> 21, L = (L >> 21) + ro | 0, de = L = ae >>> 0 > (ir = ae + Hr | 0) >>> 0 ? L + 1 | 0 : L, ro = L = L - ((ir >>> 0 < 4293918720) - 1 | 0) | 0, io = (2097151 & L) << 11 | (ae = ir - -1048576 | 0) >>> 21, L = (L >> 21) + fo | 0, ia = L = (Jt = io + Ss | 0) >>> 0 < io >>> 0 ? L + 1 | 0 : L, Fi = Jt, L = dt(Jt, L, -683901, -1), le = Oe, Jt = L, L = dt(Jr, Lr, 136657, 0), le = Oe + le | 0, L = (L >>> 0 > (Jt = Jt + L | 0) >>> 0 ? le + 1 | 0 : le) + Qe | 0, Ua = (Qe = Yn + Jt | 0) - (le = -2097152 & To) | 0, ys = (L = Qe >>> 0 < Jt >>> 0 ? L + 1 | 0 : L) - ((le >>> 0 > Qe >>> 0) + Ai | 0) | 0, io = Bt, Jt = Vr, Bt = dt(Fi, ia, 136657, 0), Qe = Oe, Ss = L = ir - (le = -2097152 & ae) | 0, uo = de = de - ((le >>> 0 > ir >>> 0) + ro | 0) | 0, ae = dt(Jr, Lr, -997805, -1), le = Oe + Qe | 0, le = ae >>> 0 > (Bt = ae + Bt | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(L, de, -683901, -1), L = Oe + le | 0, Ai = de = ae + Bt | 0, Yn = ae >>> 0 > de >>> 0 ? L + 1 | 0 : L, L = dt(Qr, kr, 470296, 0), le = Oe, de = (ae = L) + (L = dt(jn, _r, 666643, 0)) | 0, ae = Oe + le | 0, le = Js + (L >>> 0 > de >>> 0 ? ae + 1 | 0 : ae) | 0, fo = L = de + Us | 0, Qe = le = L >>> 0 < Us >>> 0 ? le + 1 | 0 : le, le = dt(Qr, kr, 666643, 0), L = Oe + fs | 0, L = le >>> 0 > (ae = le + Yi | 0) >>> 0 ? L + 1 | 0 : L, Hr = ae - (le = -2097152 & oa) | 0, ho = L - ((le >>> 0 > ae >>> 0) + $a | 0) | 0, le = dt(Bn, 0, Tn, 0), L = Oe, ae = le, le = dt(Pt, 0, Vo, 0), L = Oe + L | 0, L = le >>> 0 > (ae = ae + le | 0) >>> 0 ? L + 1 | 0 : L, de = (le = ae) + (ae = dt(Dt, 0, De, 0)) | 0, le = Oe + L | 0, le = ae >>> 0 > de >>> 0 ? le + 1 | 0 : le, ae = dt(An, 0, Xn, 0), L = Oe + le | 0, L = ae >>> 0 > (de = ae + de | 0) >>> 0 ? L + 1 | 0 : L, le = dt(kn, 0, Dn, 0), ae = Oe + L | 0, ae = le >>> 0 > (de = le + de | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(gn, 0, Vn, 0), le = Oe + ae | 0, ir = de = L + de | 0, de = L >>> 0 > de >>> 0 ? le + 1 | 0 : le, le = (L = B[q + 14 | 0]) >>> 24 | 0, Bt = L << 8 | (ro = B[q + 10 | 0] | B[q + 11 | 0] << 8 | B[q + 12 | 0] << 16 | B[q + 13 | 0] << 24) >>> 24, le = 2097151 & ((1 & (le |= ae = (L = B[q + 15 | 0]) >>> 16 | 0)) << 31 | (L = Bt | L << 16) >>> 1), L = de, ir = ae = le + ir | 0, de = le >>> 0 > ae >>> 0 ? L + 1 | 0 : L, Bt = ro >>> 4 & 2097151, L = dt(Tn, 0, Vo, 0), le = Oe, ae = L, L = dt(Pt, 0, Dn, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, L = dt(Dt, 0, Xn, 0), le = Oe + le | 0, le = L >>> 0 > (ae = L + ae | 0) >>> 0 ? le + 1 | 0 : le, ro = (L = ae) + (ae = dt(An, 0, Vn, 0)) | 0, L = Oe + le | 0, L = ae >>> 0 > ro >>> 0 ? L + 1 | 0 : L, le = dt(kn, 0, De, 0), ae = Oe + L | 0, L = le >>> 0 > (ro = le + ro | 0) >>> 0 ? ae + 1 | 0 : ae, Vr = L = (oa = Bt + ro | 0) >>> 0 < ro >>> 0 ? L + 1 | 0 : L, bo = L = L - ((oa >>> 0 < 4293918720) - 1 | 0) | 0, le = (ae = L >>> 21 | 0) + de | 0, tn = le = (L = (2097151 & L) << 11 | (To = oa - -1048576 | 0) >>> 21) >>> 0 > (Js = L + ir | 0) >>> 0 ? le + 1 | 0 : le, xr = L = le - ((Js >>> 0 < 4293918720) - 1 | 0) | 0, le = (2097151 & L) << 11 | (mn = Js - -1048576 | 0) >>> 21, L = (L >>> 21 | 0) + ho | 0, ro = L = le >>> 0 > (Hr = le + Hr | 0) >>> 0 ? L + 1 | 0 : L, Oo = L = L - ((Hr >>> 0 < 4293918720) - 1 | 0) | 0, le = (ae = L >> 21) + Qe | 0, $a = le = (le = (L = (2097151 & L) << 11 | (ir = Hr - -1048576 | 0) >>> 21) >>> 0 > (de = L + fo | 0) >>> 0 ? le + 1 | 0 : le) - (((ae = -2097152 & As) >>> 0 > de >>> 0) + Ma | 0) | 0, As = L = de - ae | 0, Bt = L - -1048576 | 0, Ma = L = le - ((L >>> 0 < 4293918720) - 1 | 0) | 0, ae = (le = L >> 21) + Yn | 0, le = ((L = (2097151 & L) << 11 | Bt >>> 21) >>> 0 > (de = L + Ai | 0) >>> 0 ? ae + 1 | 0 : ae) + Jt | 0, Yi = le = (le = (L = de) >>> 0 > (de = de + io | 0) >>> 0 ? le + 1 | 0 : le) - (((ae = -2097152 & Vs) >>> 0 > de >>> 0) + Ga | 0) | 0, Jt = L = de - ae | 0, Qe = L - -1048576 | 0, fs = L = le - ((L >>> 0 < 4293918720) - 1 | 0) | 0, ae = (le = L >> 21) + ys | 0, Vs = L = (ae = (L = (2097151 & L) << 11 | Qe >>> 21) >>> 0 > (Yn = L + Ua | 0) >>> 0 ? ae + 1 | 0 : ae) - ((Yn >>> 0 < 4293918720) - 1 | 0) | 0, fo = Mi - -1048576 | 0, ho = Lo - ((Mi >>> 0 < 4293918720) - 1 | 0) | 0, io = (2097151 & L) << 11 | (de = Yn - -1048576 | 0) >>> 21, L = (L >> 21) + Lo | 0, Ga = (Mi = io + Mi | 0) - (le = -2097152 & fo) | 0, Ua = (io >>> 0 > Mi >>> 0 ? L + 1 | 0 : L) - ((le >>> 0 > Mi >>> 0) + ho | 0) | 0, ys = Yn - (L = -2097152 & de) | 0, Ai = ae - ((L >>> 0 > Yn >>> 0) + Vs | 0) | 0, Us = Jt - (L = -2097152 & Qe) | 0, Mi = Yi - ((L >>> 0 > Jt >>> 0) + fs | 0) | 0, L = dt(Fi, ia, -997805, -1), le = Oe, ae = L, L = dt(Jr, Lr, 654183, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, de = (L = ae) + (ae = dt(Ss, uo, 136657, 0)) | 0, L = Oe + le | 0, le = $a + (ae >>> 0 > de >>> 0 ? L + 1 | 0 : L) | 0, Yi = (ae = de + As | 0) - (L = -2097152 & Bt) | 0, fs = (le = ae >>> 0 < As >>> 0 ? le + 1 | 0 : le) - ((L >>> 0 > ae >>> 0) + Ma | 0) | 0, As = li - (L = -2097152 & mo) | 0, Lo = Do - ((L >>> 0 > li >>> 0) + Ao | 0) | 0, le = dt(oo, jr, -997805, -1), L = Oe, ae = le, le = dt(nr, Ur, 654183, 0), L = Oe + L | 0, L = le >>> 0 > (ae = ae + le | 0) >>> 0 ? L + 1 | 0 : L, de = (le = ae) + (ae = dt(br, zn, 136657, 0)) | 0, le = Oe + L | 0, le = ae >>> 0 > de >>> 0 ? le + 1 | 0 : le, L = dt(vn, nn, -683901, -1), ae = Oe + le | 0, le = ri + (L >>> 0 > (de = L + de | 0) >>> 0 ? ae + 1 | 0 : ae) | 0, mo = (ae = de + Qs | 0) - (L = -2097152 & Eo) | 0, Do = (le = ae >>> 0 < Qs >>> 0 ? le + 1 | 0 : le) - ((L >>> 0 > ae >>> 0) + So | 0) | 0, le = dt(oo, jr, 654183, 0), L = Oe, ae = le, le = dt(nr, Ur, 470296, 0), L = Oe + L | 0, L = le >>> 0 > (ae = ae + le | 0) >>> 0 ? L + 1 | 0 : L, de = (le = dt(br, zn, -997805, -1)) + ae | 0, ae = Oe + L | 0, le = mi + (le >>> 0 > de >>> 0 ? ae + 1 | 0 : ae) | 0, le = (L = de + Rs | 0) >>> 0 < Rs >>> 0 ? le + 1 | 0 : le, ae = L, L = dt(vn, nn, 136657, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, de = (L = ae) + (ae = dt(jn, _r, -683901, -1)) | 0, L = Oe + le | 0, Bt = de - (le = -2097152 & ci) | 0, Qe = (ae >>> 0 > de >>> 0 ? L + 1 | 0 : L) - ((le >>> 0 > de >>> 0) + _o | 0) | 0, de = (B[q + 28 | 0] | B[q + 29 | 0] << 8 | B[q + 30 | 0] << 16 | B[q + 31 | 0] << 24) >>> 7 | 0, L = dt(Te, 0, Tn, 0), le = Oe, Yn = (ae = L) + (L = dt(Ne, 0, Pt, 0)) | 0, ae = Oe + le | 0, ae = L >>> 0 > Yn >>> 0 ? ae + 1 | 0 : ae, L = dt(rt, 0, Dt, 0), le = Oe + ae | 0, le = L >>> 0 > (Yn = L + Yn | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(xt, Mt, An, 0), L = Oe + le | 0, L = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(qt, 0, kn, 0), le = Oe + L | 0, le = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(Vt, 0, Bn, 0), L = Oe + le | 0, L = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? L + 1 | 0 : L, le = dt(un, 0, gn, 0), ae = Oe + L | 0, ae = le >>> 0 > (Yn = le + Yn | 0) >>> 0 ? ae + 1 | 0 : ae, L = dt(tt, po, Vo, 0), le = Oe + ae | 0, le = L >>> 0 > (Yn = L + Yn | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(We, 0, De, 0), L = Oe + le | 0, L = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(Ye, 0, Dn, 0), le = Oe + L | 0, le = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(ot, 0, Vn, 0), L = Oe + le | 0, L = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? L + 1 | 0 : L, le = dt(_t, 0, Xn, 0), ae = Oe + L | 0, le = le >>> 0 > (Yn = le + Yn | 0) >>> 0 ? ae + 1 | 0 : ae, ri = (ae = (2097151 & us) << 11 | Ns >>> 21) + (L = de + Yn | 0) | 0, L = (us >>> 21 | 0) + (le = L >>> 0 < Yn >>> 0 ? le + 1 | 0 : le) | 0, io = L = ae >>> 0 > ri >>> 0 ? L + 1 | 0 : L, Vs = le = L - ((ri >>> 0 < 4293918720) - 1 | 0) | 0, ae = (L = le >>> 21 | 0) + Qe | 0, Jt = ae = (le = (2097151 & le) << 11 | (po = ri - -1048576 | 0) >>> 21) >>> 0 > (Eo = le + Bt | 0) >>> 0 ? ae + 1 | 0 : ae, Ns = le = ae - ((Eo >>> 0 < 4293918720) - 1 | 0) | 0, L = (L = le >> 21) + Do | 0, Bt = L = (le = (2097151 & le) << 11 | (Yn = Eo - -1048576 | 0) >>> 21) >>> 0 > (mo = le + mo | 0) >>> 0 ? L + 1 | 0 : L, ci = le = L - ((mo >>> 0 < 4293918720) - 1 | 0) | 0, ae = (L = le >> 21) + Lo | 0, us = ae = (le = (de = (2097151 & le) << 11 | (Qe = mo - -1048576 | 0) >>> 21) + As | 0) >>> 0 < de >>> 0 ? ae + 1 | 0 : ae, Lo = le, L = dt(le, ae, -683901, -1), le = Oe + fs | 0, Do = ae = L + Yi | 0, de = L >>> 0 > ae >>> 0 ? le + 1 | 0 : le, le = dt(Jr, Lr, 470296, 0), L = Oe + ro | 0, L = le >>> 0 > (Hr = le + Hr | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Fi, ia, 654183, 0), L = Oe + (L - (((ae = -2097152 & ir) >>> 0 > Hr >>> 0) + Oo | 0) | 0) | 0, L = le >>> 0 > (ir = le + (Hr - ae | 0) | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(Ss, uo, -997805, -1), le = Oe + L | 0, le = ae >>> 0 > (ir = ae + ir | 0) >>> 0 ? le + 1 | 0 : le, mi = ae = mo - (L = -2097152 & Qe) | 0, Vo = Bt = Bt - ((L >>> 0 > mo >>> 0) + ci | 0) | 0, ir = (Qe = dt(Lo, us, 136657, 0)) + ir | 0, L = Oe + le | 0, ae = dt(ae, Bt, -683901, -1), le = Oe + (Qe >>> 0 > ir >>> 0 ? L + 1 | 0 : L) | 0, Bt = le = ae >>> 0 > (ro = ae + ir | 0) >>> 0 ? le + 1 | 0 : le, ci = L = le - ((ro >>> 0 < 4293918720) - 1 | 0) | 0, le = (2097151 & L) << 11 | (Qe = ro - -1048576 | 0) >>> 21, L = (L >> 21) + de | 0, mo = le = (L = le >>> 0 > (ir = le + Do | 0) >>> 0 ? L + 1 | 0 : L) - ((ir >>> 0 < 4293918720) - 1 | 0) | 0, Hr = (2097151 & le) << 11 | (de = ir - -1048576 | 0) >>> 21, le = (le >> 21) + Mi | 0, Us = Do = Hr + Us | 0, Do = Hr >>> 0 > Do >>> 0 ? le + 1 | 0 : le, Mi = ir - (le = -2097152 & de) | 0, Rs = L - ((le >>> 0 > ir >>> 0) + mo | 0) | 0, Yi = ro - (L = -2097152 & Qe) | 0, fs = Bt - ((L >>> 0 > ro >>> 0) + ci | 0) | 0, L = dt(Jr, Lr, 666643, 0), ae = tn + Oe | 0, ae = (Qe = L + Js | 0) >>> 0 < Js >>> 0 ? ae + 1 | 0 : ae, de = (L = dt(Fi, ia, 470296, 0)) + (Qe - (le = -2097152 & mn) | 0) | 0, le = Oe + (ae - ((le >>> 0 > Qe >>> 0) + xr | 0) | 0) | 0, le = L >>> 0 > de >>> 0 ? le + 1 | 0 : le, ae = dt(Ss, uo, 654183, 0), L = Oe + le | 0, ir = de = ae + de | 0, de = ae >>> 0 > de >>> 0 ? L + 1 | 0 : L, Qe = Eo - (L = -2097152 & Yn) | 0, Bt = Jt - ((L >>> 0 > Eo >>> 0) + Ns | 0) | 0, L = dt(oo, jr, 470296, 0), le = Oe, ae = L, L = dt(nr, Ur, 666643, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, L = dt(br, zn, 654183, 0), le = Oe + le | 0, le = L >>> 0 > (ae = L + ae | 0) >>> 0 ? le + 1 | 0 : le, Yn = (L = ae) + (ae = dt(vn, nn, -997805, -1)) | 0, L = Oe + le | 0, L = ae >>> 0 > Yn >>> 0 ? L + 1 | 0 : L, le = dt(jn, _r, 136657, 0), L = Oe + L | 0, L = le >>> 0 > (ae = le + Yn | 0) >>> 0 ? L + 1 | 0 : L, Yn = (le = dt(Qr, kr, -683901, -1)) + ae | 0, ae = Oe + L | 0, le = io + (le >>> 0 > Yn >>> 0 ? ae + 1 | 0 : ae) | 0, Eo = (ae = (2097151 & yi) << 11 | Ho >>> 21) + ((Yn = Yn + ri | 0) - (L = -2097152 & po) | 0) | 0, L = ((le = Yn >>> 0 < ri >>> 0 ? le + 1 | 0 : le) - ((L >>> 0 > Yn >>> 0) + Vs | 0) | 0) + (yi >> 21) | 0, mo = L = ae >>> 0 > Eo >>> 0 ? L + 1 | 0 : L, As = L = L - ((Eo >>> 0 < 4293918720) - 1 | 0) | 0, le = Qe, Qe = (2097151 & L) << 11 | (mn = Eo - -1048576 | 0) >>> 21, L = (L >> 21) + Bt | 0, ci = L = (ae = le + Qe | 0) >>> 0 < Qe >>> 0 ? L + 1 | 0 : L, ri = ae, L = dt(ae, L, -683901, -1), le = Oe + de | 0, le = L >>> 0 > (ae = L + ir | 0) >>> 0 ? le + 1 | 0 : le, de = (L = ae) + (ae = dt(Lo, us, -997805, -1)) | 0, L = Oe + le | 0, L = ae >>> 0 > de >>> 0 ? L + 1 | 0 : L, le = dt(mi, Vo, 136657, 0), ae = Oe + L | 0, Ho = de = le + de | 0, Jt = le >>> 0 > de >>> 0 ? ae + 1 | 0 : ae, ir = oa - (L = -2097152 & To) | 0, io = Vr - ((L >>> 0 > oa >>> 0) + bo | 0) | 0, le = dt(Tn, 0, Dn, 0), L = Oe, ae = le, le = dt(Pt, 0, De, 0), L = Oe + L | 0, L = le >>> 0 > (ae = ae + le | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Dt, 0, Vn, 0), L = Oe + L | 0, L = le >>> 0 > (ae = le + ae | 0) >>> 0 ? L + 1 | 0 : L, de = (le = dt(kn, 0, Xn, 0)) + ae | 0, ae = Oe + L | 0, le = le >>> 0 > de >>> 0 ? ae + 1 | 0 : ae, po = ae = (L = (B[q + 7 | 0] | B[q + 8 | 0] << 8 | B[q + 9 | 0] << 16 | B[q + 10 | 0] << 24) >>> 7 & 2097151) + de | 0, Yn = L >>> 0 > ae >>> 0 ? le + 1 | 0 : le, L = dt(Tn, 0, De, 0), le = Oe, ae = L, L = dt(Pt, 0, Xn, 0), le = Oe + le | 0, le = L >>> 0 > (ae = ae + L | 0) >>> 0 ? le + 1 | 0 : le, de = (L = ae) + (ae = dt(kn, 0, Vn, 0)) | 0, L = Oe + le | 0, Bt = de, de = ae >>> 0 > de >>> 0 ? L + 1 | 0 : L, L = (le = B[q + 6 | 0]) >>> 24 | 0, Qe = le << 8 | (Vs = B[q + 2 | 0] | B[q + 3 | 0] << 8 | B[q + 4 | 0] << 16 | B[q + 5 | 0] << 24) >>> 24, ae = L, le = (L = B[q + 7 | 0]) >>> 16 | 0, le |= ae, ae = de, Qe = ae = (L = 2097151 & ((3 & le) << 30 | (L = L << 16 | Qe) >>> 2)) >>> 0 > (Bt = L + Bt | 0) >>> 0 ? ae + 1 | 0 : ae, Qs = L = ae - ((Bt >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & L) << 11 | (tn = Bt - -1048576 | 0) >>> 21, L = (L >>> 21 | 0) + Yn | 0, Hr = L = ae >>> 0 > (Vr = ae + po | 0) >>> 0 ? L + 1 | 0 : L, Ns = L = L - ((Vr >>> 0 < 4293918720) - 1 | 0) | 0, ae = (le = L >>> 21 | 0) + io | 0, ae = (L = (2097151 & L) << 11 | (ro = Vr - -1048576 | 0) >>> 21) >>> 0 > (de = L + ir | 0) >>> 0 ? ae + 1 | 0 : ae, le = dt(Fi, ia, 666643, 0), L = Oe + ae | 0, L = le >>> 0 > (de = le + de | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Ss, uo, 470296, 0), L = Oe + L | 0, L = le >>> 0 > (ae = le + de | 0) >>> 0 ? L + 1 | 0 : L, de = (le = ae) + (ae = dt(ri, ci, 136657, 0)) | 0, le = Oe + L | 0, le = ae >>> 0 > de >>> 0 ? le + 1 | 0 : le, L = dt(Lo, us, 654183, 0), le = Oe + le | 0, le = L >>> 0 > (ae = L + de | 0) >>> 0 ? le + 1 | 0 : le, ir = (L = dt(mi, Vo, -997805, -1)) + ae | 0, ae = Oe + le | 0, io = ae = L >>> 0 > ir >>> 0 ? ae + 1 | 0 : ae, yi = L = ae - ((ir >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & L) << 11 | (po = ir - -1048576 | 0) >>> 21, L = (L >> 21) + Jt | 0, Ho = ae = (L = ae >>> 0 > (de = ae + Ho | 0) >>> 0 ? L + 1 | 0 : L) - ((de >>> 0 < 4293918720) - 1 | 0) | 0, Yn = (2097151 & ae) << 11 | (Jt = de - -1048576 | 0) >>> 21, ae = (ae >> 21) + fs | 0, li = To = Yn + Yi | 0, To = Yn >>> 0 > To >>> 0 ? ae + 1 | 0 : ae, Yn = de, le = L, de = (Eo - (L = -2097152 & mn) | 0) + (mn = (2097151 & ho) << 11 | fo >>> 21) | 0, L = (mo - ((L >>> 0 > Eo >>> 0) + As | 0) | 0) + (ho >> 21) | 0, fo = L = de >>> 0 < mn >>> 0 ? L + 1 | 0 : L, Yi = L = L - ((de >>> 0 < 4293918720) - 1 | 0) | 0, Eo = ae = L >> 21, L = dt(Fi = (2097151 & L) << 11 | (ho = de - -1048576 | 0) >>> 21, ae, -683901, -1), le = Oe + le | 0, le = L >>> 0 > (ae = L + Yn | 0) >>> 0 ? le + 1 | 0 : le, fs = ae - (L = -2097152 & Jt) | 0, oa = le - ((L >>> 0 > ae >>> 0) + Ho | 0) | 0, le = dt(Fi, Eo, 136657, 0), L = Oe + io | 0, L = le >>> 0 > (ae = le + ir | 0) >>> 0 ? L + 1 | 0 : L, Js = ae - (le = -2097152 & po) | 0, yi = L - ((le >>> 0 > ae >>> 0) + yi | 0) | 0, le = dt(Ss, uo, 666643, 0), L = Oe + (Hr - (((ae = -2097152 & ro) >>> 0 > Vr >>> 0) + Ns | 0) | 0) | 0, L = le >>> 0 > (Yn = le + (Vr - ae | 0) | 0) >>> 0 ? L + 1 | 0 : L, ae = dt(ri, ci, -997805, -1), le = Oe + L | 0, le = ae >>> 0 > (Yn = ae + Yn | 0) >>> 0 ? le + 1 | 0 : le, L = dt(Lo, us, 470296, 0), ae = Oe + le | 0, ae = L >>> 0 > (Yn = L + Yn | 0) >>> 0 ? ae + 1 | 0 : ae, le = dt(mi, Vo, 654183, 0), L = Oe + ae | 0, Ho = Yn = le + Yn | 0, io = le >>> 0 > Yn >>> 0 ? L + 1 | 0 : L, ae = Vs >>> 5 & 2097151, L = dt(Tn, 0, Xn, 0), le = Oe, Jt = L, L = dt(Pt, 0, Vn, 0), le = Oe + le | 0, L = L >>> 0 > (Yn = Jt + L | 0) >>> 0 ? le + 1 | 0 : le, Jt = le = ae + Yn | 0, ae = L = le >>> 0 < Yn >>> 0 ? L + 1 | 0 : L, Vr = (le = dt(Tn, 0, Vn, 0)) + (L = (L = B[q + 2 | 0]) << 16 & 2031616 | B[0 | q] | B[q + 1 | 0] << 8) | 0, le = Oe, mn = le = L >>> 0 > Vr >>> 0 ? le + 1 | 0 : le, As = le = le - ((Vr >>> 0 < 4293918720) - 1 | 0) | 0, L = (L = le >>> 21 | 0) + ae | 0, ro = L = (le = (2097151 & le) << 11 | (Hr = Vr - -1048576 | 0) >>> 21) >>> 0 > (mo = le + Jt | 0) >>> 0 ? L + 1 | 0 : L, Vs = le = L - ((mo >>> 0 < 4293918720) - 1 | 0) | 0, ae = (2097151 & le) << 11 | (ir = mo - -1048576 | 0) >>> 21, le = (le >>> 21 | 0) + Qe | 0, le = ae >>> 0 > (Yn = ae + Bt | 0) >>> 0 ? le + 1 | 0 : le, ae = dt(ri, ci, 654183, 0), L = Oe + (le - (((Qe = -2097152 & tn) >>> 0 > Yn >>> 0) + Qs | 0) | 0) | 0, L = ae >>> 0 > (Bt = ae + (Yn - Qe | 0) | 0) >>> 0 ? L + 1 | 0 : L, le = dt(Lo, us, 666643, 0), L = Oe + L | 0, L = le >>> 0 > (ae = le + Bt | 0) >>> 0 ? L + 1 | 0 : L, po = (le = ae) + (ae = dt(mi, Vo, 470296, 0)) | 0, le = Oe + L | 0, Jt = le = ae >>> 0 > po >>> 0 ? le + 1 | 0 : le, Ns = le = le - ((po >>> 0 < 4293918720) - 1 | 0) | 0, ae = (L = le >> 21) + io | 0, tn = le = (ae = (le = (2097151 & le) << 11 | (Yn = po - -1048576 | 0) >>> 21) >>> 0 > (Bt = le + Ho | 0) >>> 0 ? ae + 1 | 0 : ae) - ((Bt >>> 0 < 4293918720) - 1 | 0) | 0, io = (2097151 & le) << 11 | (Qe = Bt - -1048576 | 0) >>> 21, le = (le >> 21) + yi | 0, us = Lo = io + Js | 0, io = io >>> 0 > Lo >>> 0 ? le + 1 | 0 : le, L = dt(Fi, Eo, -997805, -1), le = Oe + ae | 0, le = L >>> 0 > (Bt = L + Bt | 0) >>> 0 ? le + 1 | 0 : le, yi = Bt - (L = -2097152 & Qe) | 0, Ho = le - ((L >>> 0 > Bt >>> 0) + tn | 0) | 0, le = dt(Fi, Eo, 654183, 0), L = Oe + Jt | 0, L = le >>> 0 > (ae = le + po | 0) >>> 0 ? L + 1 | 0 : L, Lo = ae - (le = -2097152 & Yn) | 0, tn = L - ((le >>> 0 > ae >>> 0) + Ns | 0) | 0, L = dt(ri, ci, 470296, 0), ae = Oe + (ro - (((le = -2097152 & ir) >>> 0 > mo >>> 0) + Vs | 0) | 0) | 0, ae = L >>> 0 > (Qe = L + (mo - le | 0) | 0) >>> 0 ? ae + 1 | 0 : ae, le = dt(mi, Vo, 666643, 0), L = Oe + ae | 0, Bt = Qe = le + Qe | 0, ae = le >>> 0 > Qe >>> 0 ? L + 1 | 0 : L, le = dt(ri, ci, 666643, 0), L = Oe + (mn - ((4095 & As) + ((Qe = -2097152 & Hr) >>> 0 > Vr >>> 0) | 0) | 0) | 0, po = L = le >>> 0 > (ir = le + (Vr - Qe | 0) | 0) >>> 0 ? L + 1 | 0 : L, mn = L = L - ((ir >>> 0 < 4293918720) - 1 | 0) | 0, Qe = (2097151 & L) << 11 | (Jt = ir - -1048576 | 0) >>> 21, L = (L >> 21) + ae | 0, ae = L = Qe >>> 0 > (Yn = Qe + Bt | 0) >>> 0 ? L + 1 | 0 : L, Hr = L = L - ((Yn >>> 0 < 4293918720) - 1 | 0) | 0, Qe = (2097151 & L) << 11 | (Bt = Yn - -1048576 | 0) >>> 21, L = (L >> 21) + tn | 0, Qe = Qe >>> 0 > (ro = Qe + Lo | 0) >>> 0 ? L + 1 | 0 : L, L = dt(Fi, Eo, 470296, 0), ae = Oe + ae | 0, ae = L >>> 0 > (le = L + Yn | 0) >>> 0 ? ae + 1 | 0 : ae, Yn = le - (L = -2097152 & Bt) | 0, Bt = ae - ((L >>> 0 > le >>> 0) + Hr | 0) | 0, le = dt(Fi, Eo, 666643, 0), L = Oe + (po - (((ae = -2097152 & Jt) >>> 0 > ir >>> 0) + mn | 0) | 0) | 0, le = (ae = (L = le >>> 0 > (mo = le + (ir - ae | 0) | 0) >>> 0 ? L + 1 | 0 : L) >> 21) + Bt | 0, L = (L = (le = (L = (2097151 & L) << 11 | mo >>> 21) >>> 0 > (tn = L + Yn | 0) >>> 0 ? le + 1 | 0 : le) >> 21) + Qe | 0, le = (le = (L = (le = (2097151 & le) << 11 | tn >>> 21) >>> 0 > (mn = le + ro | 0) >>> 0 ? L + 1 | 0 : L) >> 21) + Ho | 0, ae = (L = (le = (L = (2097151 & L) << 11 | mn >>> 21) >>> 0 > (Qe = L + yi | 0) >>> 0 ? le + 1 | 0 : le) >> 21) + io | 0, L = (le = (ae = (le = (2097151 & le) << 11 | Qe >>> 21) >>> 0 > (Hr = le + us | 0) >>> 0 ? ae + 1 | 0 : ae) >> 21) + oa | 0, le = (ae = (L = (ae = (2097151 & ae) << 11 | Hr >>> 21) >>> 0 > (ro = ae + fs | 0) >>> 0 ? L + 1 | 0 : L) >> 21) + To | 0, L = (L = (le = (L = (2097151 & L) << 11 | ro >>> 21) >>> 0 > (ir = L + li | 0) >>> 0 ? le + 1 | 0 : le) >> 21) + Rs | 0, le = (le = (L = (le = (2097151 & le) << 11 | ir >>> 21) >>> 0 > (io = le + Mi | 0) >>> 0 ? L + 1 | 0 : L) >> 21) + Do | 0, ae = (L = (le = (L = (2097151 & L) << 11 | io >>> 21) >>> 0 > (po = L + Us | 0) >>> 0 ? le + 1 | 0 : le) >> 21) + Ai | 0, L = (le = (ae = (le = (2097151 & le) << 11 | po >>> 21) >>> 0 > (Jt = le + ys | 0) >>> 0 ? ae + 1 | 0 : ae) >> 21) + Ua | 0, Bt = (ho = de - (le = -2097152 & ho) | 0) + ((2097151 & (L = (ae = (2097151 & ae) << 11 | Jt >>> 21) >>> 0 > (Yn = ae + Ga | 0) >>> 0 ? L + 1 | 0 : L)) << 11 | Yn >>> 21) | 0, L = (fo - ((le >>> 0 > de >>> 0) + Yi | 0) | 0) + (L >> 21) | 0, ho = le = (L = Bt >>> 0 < ho >>> 0 ? L + 1 | 0 : L) >> 21, mo = (L = dt(To = (2097151 & L) << 11 | Bt >>> 21, le, 666643, 0)) + (le = 2097151 & mo) | 0, L = Oe, de = L = le >>> 0 > mo >>> 0 ? L + 1 | 0 : L, j[0 | Ie] = mo, j[Ie + 1 | 0] = (255 & L) << 24 | mo >>> 8, L = 2097151 & tn, le = dt(To, ho, 470296, 0) + L | 0, ae = Oe, L = (de >> 21) + (L >>> 0 > le >>> 0 ? ae + 1 | 0 : ae) | 0, L = (fo = (2097151 & de) << 11 | mo >>> 21) >>> 0 > (tn = fo + le | 0) >>> 0 ? L + 1 | 0 : L, j[Ie + 4 | 0] = (2047 & L) << 21 | tn >>> 11, le = L, ae = tn, j[Ie + 3 | 0] = (7 & L) << 29 | ae >>> 3, j[Ie + 2 | 0] = 31 & ((65535 & de) << 16 | mo >>> 16) | ae << 5, de = 2097151 & mn, mn = dt(To, ho, 654183, 0) + de | 0, L = Oe, tn = (2097151 & le) << 11 | ae >>> 21, le = (le >> 21) + (de = de >>> 0 > mn >>> 0 ? L + 1 | 0 : L) | 0, L = le = (mn = tn + mn | 0) >>> 0 < tn >>> 0 ? le + 1 | 0 : le, j[Ie + 6 | 0] = (63 & L) << 26 | mn >>> 6, de = mn, mn = 0, j[Ie + 5 | 0] = mn << 13 | (1572864 & ae) >>> 19 | de << 2, ae = 2097151 & Qe, Qe = dt(To, ho, -997805, -1) + ae | 0, le = Oe, le = ae >>> 0 > Qe >>> 0 ? le + 1 | 0 : le, mn = (2097151 & (ae = L)) << 11 | de >>> 21, ae = (L >>= 21) + le | 0, ae = (Qe = mn + Qe | 0) >>> 0 < mn >>> 0 ? ae + 1 | 0 : ae, j[Ie + 9 | 0] = (511 & ae) << 23 | Qe >>> 9, j[Ie + 8 | 0] = (1 & ae) << 31 | Qe >>> 1, le = 0, j[Ie + 7 | 0] = le << 18 | (2080768 & de) >>> 14 | Qe << 7, le = 2097151 & Hr, de = dt(To, ho, 136657, 0) + le | 0, L = Oe, L = le >>> 0 > de >>> 0 ? L + 1 | 0 : L, Hr = (2097151 & (le = ae)) << 11 | Qe >>> 21, le = L + (ae = le >> 21) | 0, le = (de = Hr + de | 0) >>> 0 < Hr >>> 0 ? le + 1 | 0 : le, j[Ie + 12 | 0] = (4095 & le) << 20 | de >>> 12, ae = de, j[Ie + 11 | 0] = (15 & le) << 28 | ae >>> 4, de = 0, j[Ie + 10 | 0] = de << 15 | (1966080 & Qe) >>> 17 | ae << 4, de = 2097151 & ro, Qe = dt(To, ho, -683901, -1) + de | 0, L = Oe, L = de >>> 0 > Qe >>> 0 ? L + 1 | 0 : L, de = le, le = L + (le >>= 21) | 0, le = (de = (ro = Qe) + (Qe = (2097151 & de) << 11 | ae >>> 21) | 0) >>> 0 < Qe >>> 0 ? le + 1 | 0 : le, j[Ie + 14 | 0] = (127 & le) << 25 | de >>> 7, Qe = 0, j[Ie + 13 | 0] = Qe << 12 | (1048576 & ae) >>> 20 | de << 1, L = le >> 21, ae = (le = (2097151 & le) << 11 | de >>> 21) >>> 0 > (Qe = le + (2097151 & ir) | 0) >>> 0 ? L + 1 | 0 : L, j[Ie + 17 | 0] = (1023 & ae) << 22 | Qe >>> 10, j[Ie + 16 | 0] = (3 & ae) << 30 | Qe >>> 2, le = 0, j[Ie + 15 | 0] = le << 17 | (2064384 & de) >>> 15 | Qe << 6, L = ae >> 21, L = (le = (2097151 & ae) << 11 | Qe >>> 21) >>> 0 > (ae = le + (2097151 & io) | 0) >>> 0 ? L + 1 | 0 : L, j[Ie + 20 | 0] = (8191 & L) << 19 | ae >>> 13, j[Ie + 19 | 0] = (31 & L) << 27 | ae >>> 5, de = (le = 2097151 & po) + (po = (2097151 & L) << 11 | ae >>> 21) | 0, le = L >> 21, le = de >>> 0 < po >>> 0 ? le + 1 | 0 : le, po = de, j[Ie + 21 | 0] = de, io = 0, j[Ie + 18 | 0] = io << 14 | (1835008 & Qe) >>> 18 | ae << 3, j[Ie + 22 | 0] = (255 & le) << 24 | de >>> 8, ae = le >> 21, ae = (de = (Qe = (2097151 & le) << 11 | de >>> 21) + (2097151 & Jt) | 0) >>> 0 < Qe >>> 0 ? ae + 1 | 0 : ae, j[Ie + 25 | 0] = (2047 & ae) << 21 | de >>> 11, j[Ie + 24 | 0] = (7 & ae) << 29 | de >>> 3, j[Ie + 23 | 0] = 31 & ((65535 & le) << 16 | po >>> 16) | de << 5, L = ae >> 21, L = (le = (2097151 & ae) << 11 | de >>> 21) >>> 0 > (ae = le + (2097151 & Yn) | 0) >>> 0 ? L + 1 | 0 : L, j[Ie + 27 | 0] = (63 & L) << 26 | ae >>> 6, Qe = 0, j[Ie + 26 | 0] = Qe << 13 | (1572864 & de) >>> 19 | ae << 2, le = L >> 21, le = (L = (de = (2097151 & L) << 11 | ae >>> 21) + (2097151 & Bt) | 0) >>> 0 < de >>> 0 ? le + 1 | 0 : le, j[Ie + 31 | 0] = (131071 & le) << 15 | L >>> 17, j[Ie + 30 | 0] = (511 & le) << 23 | L >>> 9, j[Ie + 29 | 0] = (1 & le) << 31 | L >>> 1, de = 0, j[Ie + 28 | 0] = de << 18 | (2080768 & ae) >>> 14 | L << 7, Ro(be, 64), Ro(q, 64), Z && (l[Z >> 2] = 64, l[Z + 4 >> 2] = 0), st = Ue + 560 | 0, 0;
                    }
                    function $s(L, Z, le, ae) {
                      for (var de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0; Qe = (de = Ye << 3) + le | 0, Ie = B[0 | (de = Z + de | 0)] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, Bn = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, be = Ie << 24 | (65280 & Ie) << 8, Ne = (Ue = 16711680 & Ie) << 24, Ue = Ue >>> 8 | 0, de = (Te = -16777216 & Ie) >>> 24 | 0, l[Qe >> 2] = Ne | Te << 8 | -16777216 & ((255 & Bn) << 24 | Ie >>> 8) | 16711680 & ((16777215 & Bn) << 8 | Ie >>> 24) | Bn >>> 8 & 65280 | Bn >>> 24, Ie = de | Ue | be, de = 0, l[Qe + 4 >> 2] = Ie | de | de, (0 | (Ye = Ye + 1 | 0)) != 16; )
                        ;
                      for (Z = l[L + 4 >> 2], l[ae >> 2] = l[L >> 2], l[ae + 4 >> 2] = Z, Z = l[L + 60 >> 2], l[ae + 56 >> 2] = l[L + 56 >> 2], l[ae + 60 >> 2] = Z, Z = l[L + 52 >> 2], l[ae + 48 >> 2] = l[L + 48 >> 2], l[ae + 52 >> 2] = Z, Z = l[L + 44 >> 2], l[ae + 40 >> 2] = l[L + 40 >> 2], l[ae + 44 >> 2] = Z, Z = l[L + 36 >> 2], l[ae + 32 >> 2] = l[L + 32 >> 2], l[ae + 36 >> 2] = Z, Z = l[L + 28 >> 2], l[ae + 24 >> 2] = l[L + 24 >> 2], l[ae + 28 >> 2] = Z, Z = l[L + 20 >> 2], l[ae + 16 >> 2] = l[L + 16 >> 2], l[ae + 20 >> 2] = Z, Z = l[L + 12 >> 2], l[ae + 8 >> 2] = l[L + 8 >> 2], l[ae + 12 >> 2] = Z; Te = l[ae + 56 >> 2], be = l[ae + 60 >> 2], de = l[(Z = Bn = (Tn = br << 3) + le | 0) >> 2], Z = l[Z + 4 >> 2], Mt = Ie = l[ae + 36 >> 2], Ie = vt(Ye = l[ae + 32 >> 2], Ie, 50), Qe = Oe, Ie = vt(Ye, Mt, 46) ^ Ie, Qe ^= Oe, Ie = vt(Ye, Mt, 23) ^ Ie, Z = (Oe ^ Qe) + Z | 0, Z = (de = Ie + de | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, de = (Qe = l[(Ie = Tn + 34e3 | 0) >> 2]) + de | 0, Z = l[Ie + 4 >> 2] + Z | 0, Z = de >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z, Ie = (Ne = ((Qe = l[ae + 48 >> 2]) ^ (Ue = l[ae + 40 >> 2])) & Ye ^ Qe) + de | 0, de = (((xt = l[ae + 52 >> 2]) ^ (We = l[ae + 44 >> 2])) & Mt ^ xt) + Z | 0, Z = (Ie >>> 0 < Ne >>> 0 ? de + 1 | 0 : de) + be | 0, Z = (de = Ie) >>> 0 > (Ie = Ie + Te | 0) >>> 0 ? Z + 1 | 0 : Z, Te = (be = l[ae + 24 >> 2]) + Ie | 0, de = l[ae + 28 >> 2] + Z | 0, rt = de = be >>> 0 > Te >>> 0 ? de + 1 | 0 : de, l[ae + 24 >> 2] = Te, l[ae + 28 >> 2] = de, un = de = l[ae + 4 >> 2], de = vt(_t = l[ae >> 2], de, 36), be = Oe, de = vt(_t, un, 30) ^ de, Ne = Oe ^ be, be = Ie + (vt(_t, un, 25) ^ de) | 0, de = Z + (Oe ^ Ne) | 0, de = Ie >>> 0 > be >>> 0 ? de + 1 | 0 : de, Ne = (Z = be) + (be = _t & ((Ie = l[ae + 16 >> 2]) | (qt = l[ae + 8 >> 2])) | Ie & qt) | 0, Z = (Z = de) + (un & ((de = l[ae + 20 >> 2]) | (Vt = l[ae + 12 >> 2])) | de & Vt) | 0, be = Z = be >>> 0 > Ne >>> 0 ? Z + 1 | 0 : Z, l[ae + 56 >> 2] = Ne, l[ae + 60 >> 2] = Z, q = Ie, ot = de, gn = l[(Z = nr = (tt = 8 | Tn) + le | 0) >> 2], Xn = l[Z + 4 >> 2], de = ((We ^ Mt) & rt ^ We) + xt | 0, de = (Z = (Ie = (Ue ^ Ye) & Te ^ Ue) + Qe | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = vt(Te, rt, 50), Qe = Oe, Ie = vt(Te, rt, 46) ^ Ie, Qe ^= Oe, Ie = (xt = vt(Te, rt, 23) ^ Ie) + Z | 0, Z = (Oe ^ Qe) + de | 0, Z = (Ie >>> 0 < xt >>> 0 ? Z + 1 | 0 : Z) + Xn | 0, Z = (de = Ie + gn | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Ie = (Ie = de) + (Qe = l[(de = tt + 34e3 | 0) >> 2]) | 0, de = l[de + 4 >> 2] + Z | 0, de = (Z = Ie >>> 0 < Qe >>> 0 ? de + 1 | 0 : de) + ot | 0, tt = de = (q = Ie + q | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, l[ae + 16 >> 2] = q, l[ae + 20 >> 2] = de, Z = Z + ((Vt | un) & be | Vt & un) | 0, Z = (de = Ie + ((_t | qt) & Ne | _t & qt) | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Ie = vt(Ne, be, 36), Qe = Oe, Ie = vt(Ne, be, 30) ^ Ie, ot = Oe ^ Qe, Qe = de, de = vt(Ne, be, 25) ^ Ie, Z = (Oe ^ ot) + Z | 0, ot = Z = de >>> 0 > (Qe = Qe + de | 0) >>> 0 ? Z + 1 | 0 : Z, l[ae + 48 >> 2] = Qe, l[ae + 52 >> 2] = Z, Z = (Z = Ue) + (Ue = l[(de = Xn = (Ie = 16 | Tn) + le | 0) >> 2]) | 0, de = l[de + 4 >> 2] + We | 0, de = Z >>> 0 < Ue >>> 0 ? de + 1 | 0 : de, Ie = (We = Z) + (Ue = l[(Z = Ie + 34e3 | 0) >> 2]) | 0, Z = l[Z + 4 >> 2] + de | 0, Z = ((rt ^ Mt) & tt ^ Mt) + (Z = Ie >>> 0 < Ue >>> 0 ? Z + 1 | 0 : Z) | 0, Z = (de = (de = Ie) + (Ie = (Te ^ Ye) & q ^ Ye) | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Ie = vt(q, tt, 50), Ue = Oe, Ie = vt(q, tt, 46) ^ Ie, Ue ^= Oe, Ie = (We = vt(q, tt, 23) ^ Ie) + de | 0, de = (Oe ^ Ue) + Z | 0, xt = de = Ie >>> 0 < We >>> 0 ? de + 1 | 0 : de, Z = de, de = vt(Qe, ot, 36), Ue = Oe, de = vt(Qe, ot, 30) ^ de, We = Oe ^ Ue, gn = vt(Qe, ot, 25) ^ de, de = ((be | un) & ot | be & un) + (Oe ^ We) | 0, Z = ((Ue = gn + ((Ne | _t) & Qe | Ne & _t) | 0) >>> 0 < gn >>> 0 ? de + 1 | 0 : de) + Z | 0, We = Z = (de = Ue) >>> 0 > (Ue = Ie + Ue | 0) >>> 0 ? Z + 1 | 0 : Z, l[ae + 40 >> 2] = Ue, l[ae + 44 >> 2] = Z, de = xt + Vt | 0, Vt = de = (qt = Ie + qt | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, l[ae + 8 >> 2] = qt, l[ae + 12 >> 2] = de, de = (de = Ye) + (Ye = l[(Z = kn = (Ie = 24 | Tn) + le | 0) >> 2]) | 0, Z = l[Z + 4 >> 2] + Mt | 0, Z = de >>> 0 < Ye >>> 0 ? Z + 1 | 0 : Z, Ie = (Mt = de) + (Ye = l[(de = Ie + 34e3 | 0) >> 2]) | 0, de = l[de + 4 >> 2] + Z | 0, de = (rt ^ (rt ^ tt) & Vt) + (de = Ie >>> 0 < Ye >>> 0 ? de + 1 | 0 : de) | 0, de = (Z = (Z = Ie) + (Ie = Te ^ (Te ^ q) & qt) | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = vt(qt, Vt, 50), Ye = Oe, Ie = vt(qt, Vt, 46) ^ Ie, Ye ^= Oe, Ie = (xt = vt(qt, Vt, 23) ^ Ie) + Z | 0, Z = (Oe ^ Ye) + de | 0, Z = Ie >>> 0 < xt >>> 0 ? Z + 1 | 0 : Z, de = vt(Ue, We, 36), Ye = Oe, de = vt(Ue, We, 30) ^ de, xt = Oe ^ Ye, Mt = vt(Ue, We, 25) ^ de, de = ((be | ot) & We | be & ot) + (Oe ^ xt) | 0, de = ((Ye = Mt + ((Qe | Ne) & Ue | Qe & Ne) | 0) >>> 0 < Mt >>> 0 ? de + 1 | 0 : de) + Z | 0, xt = de = (Mt = Ye) >>> 0 > (Ye = Ie + Ye | 0) >>> 0 ? de + 1 | 0 : de, l[ae + 32 >> 2] = Ye, l[ae + 36 >> 2] = de, Z = Z + un | 0, un = Z = (_t = Ie + _t | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, l[ae >> 2] = _t, l[ae + 4 >> 2] = Z, Ie = l[(de = nn = (Z = 32 | Tn) + le | 0) >> 2], de = rt + l[de + 4 >> 2] | 0, de = (Ie = Ie + Te | 0) >>> 0 < Te >>> 0 ? de + 1 | 0 : de, Ie = (Te = l[(Z = Z + 34e3 | 0) >> 2]) + Ie | 0, Z = l[Z + 4 >> 2] + de | 0, Z = (tt ^ (tt ^ Vt) & un) + (Z = Ie >>> 0 < Te >>> 0 ? Z + 1 | 0 : Z) | 0, Z = (de = (de = Ie) + (Ie = q ^ (q ^ qt) & _t) | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Ie = vt(_t, un, 50), Te = Oe, Ie = vt(_t, un, 46) ^ Ie, Te ^= Oe, Ie = (rt = vt(_t, un, 23) ^ Ie) + de | 0, de = (Oe ^ Te) + Z | 0, Mt = de = Ie >>> 0 < rt >>> 0 ? de + 1 | 0 : de, Z = de, de = vt(Ye, xt, 36), Te = Oe, de = vt(Ye, xt, 30) ^ de, rt = Oe ^ Te, gn = vt(Ye, xt, 25) ^ de, de = ((We | ot) & xt | We & ot) + (Oe ^ rt) | 0, Z = ((Te = gn + ((Qe | Ue) & Ye | Qe & Ue) | 0) >>> 0 < gn >>> 0 ? de + 1 | 0 : de) + Z | 0, Te = Z = (rt = Ie + Te | 0) >>> 0 < Te >>> 0 ? Z + 1 | 0 : Z, l[ae + 24 >> 2] = rt, l[ae + 28 >> 2] = Z, de = be + Mt | 0, Mt = de = (be = Ie + Ne | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, l[ae + 56 >> 2] = be, l[ae + 60 >> 2] = de, Ie = l[(Z = De = (de = 40 | Tn) + le | 0) >> 2], Z = tt + l[Z + 4 >> 2] | 0, Z = (Ie = Ie + q | 0) >>> 0 < q >>> 0 ? Z + 1 | 0 : Z, Ie = (Ne = l[(de = de + 34e3 | 0) >> 2]) + Ie | 0, de = l[de + 4 >> 2] + Z | 0, de = (Vt ^ (Vt ^ un) & Mt) + (de = Ie >>> 0 < Ne >>> 0 ? de + 1 | 0 : de) | 0, de = (Z = (Z = Ie) + (Ie = qt ^ (_t ^ qt) & be) | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = vt(be, Mt, 50), Ne = Oe, Ie = vt(be, Mt, 46) ^ Ie, Ne ^= Oe, Ie = (q = vt(be, Mt, 23) ^ Ie) + Z | 0, Z = (Oe ^ Ne) + de | 0, Z = Ie >>> 0 < q >>> 0 ? Z + 1 | 0 : Z, de = vt(rt, Te, 36), Ne = Oe, de = vt(rt, Te, 30) ^ de, q = Oe ^ Ne, tt = vt(rt, Te, 25) ^ de, de = ((We | xt) & Te | We & xt) + (Oe ^ q) | 0, de = ((Ne = tt + ((Ue | Ye) & rt | Ue & Ye) | 0) >>> 0 < tt >>> 0 ? de + 1 | 0 : de) + Z | 0, Ne = de = (q = Ie + Ne | 0) >>> 0 < Ne >>> 0 ? de + 1 | 0 : de, l[ae + 16 >> 2] = q, l[ae + 20 >> 2] = de, Z = Z + ot | 0, tt = Z = (ot = Ie + Qe | 0) >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z, l[ae + 48 >> 2] = ot, l[ae + 52 >> 2] = Z, Ie = l[(de = Vn = (Z = 48 | Tn) + le | 0) >> 2], de = Vt + l[de + 4 >> 2] | 0, de = (Ie = Ie + qt | 0) >>> 0 < qt >>> 0 ? de + 1 | 0 : de, Ie = (Qe = l[(Z = Z + 34e3 | 0) >> 2]) + Ie | 0, Z = l[Z + 4 >> 2] + de | 0, Z = (un ^ (Mt ^ un) & tt) + (Z = Ie >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z) | 0, Z = (de = (de = Ie) + (Ie = _t ^ (be ^ _t) & ot) | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Ie = vt(ot, tt, 50), Qe = Oe, Ie = vt(ot, tt, 46) ^ Ie, Qe ^= Oe, Ie = (qt = vt(ot, tt, 23) ^ Ie) + de | 0, de = (Oe ^ Qe) + Z | 0, Vt = de = Ie >>> 0 < qt >>> 0 ? de + 1 | 0 : de, Z = de, de = vt(q, Ne, 36), Qe = Oe, de = vt(q, Ne, 30) ^ de, qt = Oe ^ Qe, gn = vt(q, Ne, 25) ^ de, de = ((Te | xt) & Ne | Te & xt) + (Oe ^ qt) | 0, Z = ((Qe = gn + ((Ye | rt) & q | Ye & rt) | 0) >>> 0 < gn >>> 0 ? de + 1 | 0 : de) + Z | 0, qt = Z = (de = Qe) >>> 0 > (Qe = Ie + Qe | 0) >>> 0 ? Z + 1 | 0 : Z, l[ae + 8 >> 2] = Qe, l[ae + 12 >> 2] = Z, de = We + Vt | 0, Vt = de = (gn = Ie + Ue | 0) >>> 0 < Ue >>> 0 ? de + 1 | 0 : de, l[ae + 40 >> 2] = gn, l[ae + 44 >> 2] = de, Ie = l[(Z = Dn = (de = 56 | Tn) + le | 0) >> 2], Z = un + l[Z + 4 >> 2] | 0, Z = (Ie = Ie + _t | 0) >>> 0 < _t >>> 0 ? Z + 1 | 0 : Z, Ie = (Ue = l[(de = de + 34e3 | 0) >> 2]) + Ie | 0, de = l[de + 4 >> 2] + Z | 0, de = (Mt ^ (tt ^ Mt) & Vt) + (de = Ie >>> 0 < Ue >>> 0 ? de + 1 | 0 : de) | 0, de = (Z = (Z = Ie) + (Ie = be ^ (be ^ ot) & gn) | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = vt(gn, Vt, 50), Ue = Oe, Ie = vt(gn, Vt, 46) ^ Ie, Ue ^= Oe, Ie = (We = vt(gn, Vt, 23) ^ Ie) + Z | 0, Z = (Oe ^ Ue) + de | 0, Z = Ie >>> 0 < We >>> 0 ? Z + 1 | 0 : Z, de = vt(Qe, qt, 36), Ue = Oe, de = vt(Qe, qt, 30) ^ de, We = Oe ^ Ue, _t = vt(Qe, qt, 25) ^ de, de = ((Te | Ne) & qt | Te & Ne) + (Oe ^ We) | 0, de = ((Ue = _t + ((q | rt) & Qe | q & rt) | 0) >>> 0 < _t >>> 0 ? de + 1 | 0 : de) + Z | 0, We = de = (We = Ue) >>> 0 > (Ue = Ie + Ue | 0) >>> 0 ? de + 1 | 0 : de, l[ae >> 2] = Ue, l[ae + 4 >> 2] = de, Z = Z + xt | 0, un = Z = (de = Ye) >>> 0 > (Ye = Ie + Ye | 0) >>> 0 ? Z + 1 | 0 : Z, l[ae + 32 >> 2] = Ye, l[ae + 36 >> 2] = Z, Ie = l[(de = vn = (Z = 64 | Tn) + le | 0) >> 2], de = Mt + l[de + 4 >> 2] | 0, de = (Ie = Ie + be | 0) >>> 0 < be >>> 0 ? de + 1 | 0 : de, Ie = (be = l[(Z = Z + 34e3 | 0) >> 2]) + Ie | 0, Z = l[Z + 4 >> 2] + de | 0, Z = (tt ^ (tt ^ Vt) & un) + (Z = Ie >>> 0 < be >>> 0 ? Z + 1 | 0 : Z) | 0, Z = (de = (de = Ie) + (Ie = ot ^ (ot ^ gn) & Ye) | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Ie = vt(Ye, un, 50), be = Oe, Ie = vt(Ye, un, 46) ^ Ie, be ^= Oe, Ie = (xt = vt(Ye, un, 23) ^ Ie) + de | 0, de = (Oe ^ be) + Z | 0, _t = de = Ie >>> 0 < xt >>> 0 ? de + 1 | 0 : de, Z = de, de = vt(Ue, We, 36), be = Oe, de = vt(Ue, We, 30) ^ de, xt = Oe ^ be, Mt = vt(Ue, We, 25) ^ de, de = ((Ne | qt) & We | Ne & qt) + (Oe ^ xt) | 0, Z = ((be = Mt + ((Qe | q) & Ue | Qe & q) | 0) >>> 0 < Mt >>> 0 ? de + 1 | 0 : de) + Z | 0, be = Z = (xt = Ie + be | 0) >>> 0 < be >>> 0 ? Z + 1 | 0 : Z, l[ae + 56 >> 2] = xt, l[ae + 60 >> 2] = Z, de = Te + _t | 0, Mt = de = (Te = Ie + rt | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, l[ae + 24 >> 2] = Te, l[ae + 28 >> 2] = de, Ie = l[(Z = Pt = (de = 72 | Tn) + le | 0) >> 2], Z = tt + l[Z + 4 >> 2] | 0, Z = (Ie = Ie + ot | 0) >>> 0 < ot >>> 0 ? Z + 1 | 0 : Z, Ie = (ot = l[(de = de + 34e3 | 0) >> 2]) + Ie | 0, de = l[de + 4 >> 2] + Z | 0, de = (Vt ^ (Vt ^ un) & Mt) + (de = Ie >>> 0 < ot >>> 0 ? de + 1 | 0 : de) | 0, de = (Z = (Z = Ie) + (Ie = gn ^ (Ye ^ gn) & Te) | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = vt(Te, Mt, 50), ot = Oe, Ie = vt(Te, Mt, 46) ^ Ie, ot ^= Oe, Ie = (_t = vt(Te, Mt, 23) ^ Ie) + Z | 0, Z = (Oe ^ ot) + de | 0, Z = Ie >>> 0 < _t >>> 0 ? Z + 1 | 0 : Z, de = vt(xt, be, 36), ot = Oe, de = vt(xt, be, 30) ^ de, _t = Oe ^ ot, rt = vt(xt, be, 25) ^ de, de = ((We | qt) & be | We & qt) + (Oe ^ _t) | 0, de = ((ot = rt + ((Qe | Ue) & xt | Qe & Ue) | 0) >>> 0 < rt >>> 0 ? de + 1 | 0 : de) + Z | 0, ot = de = (_t = Ie + ot | 0) >>> 0 < ot >>> 0 ? de + 1 | 0 : de, l[ae + 48 >> 2] = _t, l[ae + 52 >> 2] = de, Z = Z + Ne | 0, tt = Z = (Ne = Ie + q | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, l[ae + 16 >> 2] = Ne, l[ae + 20 >> 2] = Z, Z = (q = l[(de = An = (Ie = 80 | Tn) + le | 0) >> 2]) + gn | 0, de = l[de + 4 >> 2] + Vt | 0, de = Z >>> 0 < q >>> 0 ? de + 1 | 0 : de, Ie = (rt = Z) + (q = l[(Z = Ie + 34e3 | 0) >> 2]) | 0, Z = l[Z + 4 >> 2] + de | 0, Z = (un ^ (Mt ^ un) & tt) + (Z = Ie >>> 0 < q >>> 0 ? Z + 1 | 0 : Z) | 0, Z = (de = (de = Ie) + (Ie = Ye ^ (Te ^ Ye) & Ne) | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Ie = vt(Ne, tt, 50), q = Oe, Ie = vt(Ne, tt, 46) ^ Ie, q ^= Oe, Ie = (rt = vt(Ne, tt, 23) ^ Ie) + de | 0, de = (Oe ^ q) + Z | 0, Vt = de = Ie >>> 0 < rt >>> 0 ? de + 1 | 0 : de, Z = de, de = vt(_t, ot, 36), q = Oe, de = vt(_t, ot, 30) ^ de, rt = Oe ^ q, gn = vt(_t, ot, 25) ^ de, de = ((be | We) & ot | be & We) + (Oe ^ rt) | 0, Z = ((q = gn + ((Ue | xt) & _t | Ue & xt) | 0) >>> 0 < gn >>> 0 ? de + 1 | 0 : de) + Z | 0, q = Z = (rt = Ie + q | 0) >>> 0 < q >>> 0 ? Z + 1 | 0 : Z, l[ae + 40 >> 2] = rt, l[ae + 44 >> 2] = Z, de = qt + Vt | 0, Vt = de = (qt = Ie + Qe | 0) >>> 0 < Qe >>> 0 ? de + 1 | 0 : de, l[ae + 8 >> 2] = qt, l[ae + 12 >> 2] = de, de = 34e3 + (Z = 88 | Tn) | 0, Qe = l[(Z = Dt = Z + le | 0) >> 2], Ie = l[de >> 2] + Qe | 0, Z = l[de + 4 >> 2] + l[Z + 4 >> 2] | 0, de = un + (Ie >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z) | 0, de = (Mt ^ (tt ^ Mt) & Vt) + (de = (Z = Ie + Ye | 0) >>> 0 < Ye >>> 0 ? de + 1 | 0 : de) | 0, de = (Z = (Ie = Te ^ (Te ^ Ne) & qt) + Z | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = vt(qt, Vt, 50), Qe = Oe, Ie = vt(qt, Vt, 46) ^ Ie, Qe ^= Oe, Ie = (Ye = vt(qt, Vt, 23) ^ Ie) + Z | 0, Z = (Oe ^ Qe) + de | 0, Z = Ie >>> 0 < Ye >>> 0 ? Z + 1 | 0 : Z, de = vt(rt, q, 36), Qe = Oe, de = vt(rt, q, 30) ^ de, Ye = Oe ^ Qe, un = vt(rt, q, 25) ^ de, de = ((be | ot) & q | be & ot) + (Oe ^ Ye) | 0, de = ((Qe = un + ((_t | xt) & rt | _t & xt) | 0) >>> 0 < un >>> 0 ? de + 1 | 0 : de) + Z | 0, Ye = de = (Ye = Qe) >>> 0 > (Qe = Ie + Qe | 0) >>> 0 ? de + 1 | 0 : de, l[ae + 32 >> 2] = Qe, l[ae + 36 >> 2] = de, Z = Z + We | 0, We = Z = (de = Ue) >>> 0 > (Ue = Ie + Ue | 0) >>> 0 ? Z + 1 | 0 : Z, l[ae >> 2] = Ue, l[ae + 4 >> 2] = Z, de = 34e3 + (Z = 96 | Tn) | 0, un = l[(Z = zn = Z + le | 0) >> 2], Ie = l[de >> 2] + un | 0, de = l[de + 4 >> 2] + l[Z + 4 >> 2] | 0, Z = Mt + (Ie >>> 0 < un >>> 0 ? de + 1 | 0 : de) | 0, Z = (de = Ie + Te | 0) >>> 0 < Te >>> 0 ? Z + 1 | 0 : Z, Ie = (Te = Ne ^ (Ne ^ qt) & Ue) + de | 0, de = (tt ^ (tt ^ Vt) & We) + Z | 0, de = Ie >>> 0 < Te >>> 0 ? de + 1 | 0 : de, Z = vt(Ue, We, 50), Te = Oe, Z = vt(Ue, We, 46) ^ Z, Te ^= Oe, Mt = Ie, Ie = vt(Ue, We, 23) ^ Z, de = (Oe ^ Te) + de | 0, Mt = de = (Z = Mt + Ie | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = Z, Z = vt(Qe, Ye, 36), Te = Oe, Z = vt(Qe, Ye, 30) ^ Z, un = Oe ^ Te, gn = vt(Qe, Ye, 25) ^ Z, Z = ((q | ot) & Ye | q & ot) + (Oe ^ un) | 0, de = ((Te = gn + ((_t | rt) & Qe | _t & rt) | 0) >>> 0 < gn >>> 0 ? Z + 1 | 0 : Z) + de | 0, Te = de = (un = Ie + Te | 0) >>> 0 < Te >>> 0 ? de + 1 | 0 : de, l[ae + 24 >> 2] = un, l[ae + 28 >> 2] = de, de = be + Mt | 0, be = de = (xt = Ie + xt | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, l[ae + 56 >> 2] = xt, l[ae + 60 >> 2] = de, de = 34e3 + (Z = 104 | Tn) | 0, Mt = l[(Z = _r = Z + le | 0) >> 2], Ie = l[de >> 2] + Mt | 0, Z = l[de + 4 >> 2] + l[Z + 4 >> 2] | 0, de = tt + (Ie >>> 0 < Mt >>> 0 ? Z + 1 | 0 : Z) | 0, de = (Z = Ie + Ne | 0) >>> 0 < Ne >>> 0 ? de + 1 | 0 : de, Ie = (Ne = qt ^ (Ue ^ qt) & xt) + Z | 0, Z = (Vt ^ (We ^ Vt) & be) + de | 0, Z = Ie >>> 0 < Ne >>> 0 ? Z + 1 | 0 : Z, de = vt(xt, be, 50), Ne = Oe, de = vt(xt, be, 46) ^ de, Ne ^= Oe, tt = vt(xt, be, 23) ^ de, de = (Oe ^ Ne) + Z | 0, Mt = de = (Ie = tt + Ie | 0) >>> 0 < tt >>> 0 ? de + 1 | 0 : de, Z = de, de = vt(un, Te, 36), Ne = Oe, de = vt(un, Te, 30) ^ de, tt = Oe ^ Ne, gn = vt(un, Te, 25) ^ de, de = ((q | Ye) & Te | q & Ye) + (Oe ^ tt) | 0, Z = ((Ne = gn + ((Qe | rt) & un | Qe & rt) | 0) >>> 0 < gn >>> 0 ? de + 1 | 0 : de) + Z | 0, Ne = Z = (tt = Ie + Ne | 0) >>> 0 < Ne >>> 0 ? Z + 1 | 0 : Z, l[ae + 16 >> 2] = tt, l[ae + 20 >> 2] = Z, Z = ot + Mt | 0, ot = Z = (_t = Ie + _t | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, l[ae + 48 >> 2] = _t, l[ae + 52 >> 2] = Z, de = 34e3 + (Z = 112 | Tn) | 0, Mt = l[(Ie = gn = Z + le | 0) >> 2], Z = l[de >> 2] + Mt | 0, de = l[de + 4 >> 2] + l[Ie + 4 >> 2] | 0, de = Vt + (Z >>> 0 < Mt >>> 0 ? de + 1 | 0 : de) | 0, de = (We ^ (be ^ We) & ot) + (de = (Z = Z + qt | 0) >>> 0 < qt >>> 0 ? de + 1 | 0 : de) | 0, de = (Z = (Ie = Ue ^ (Ue ^ xt) & _t) + Z | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = vt(_t, ot, 50), qt = Oe, Ie = vt(_t, ot, 46) ^ Ie, qt ^= Oe, Ie = (Vt = vt(_t, ot, 23) ^ Ie) + Z | 0, Z = (Oe ^ qt) + de | 0, Mt = Z = Ie >>> 0 < Vt >>> 0 ? Z + 1 | 0 : Z, de = Z, Z = vt(tt, Ne, 36), qt = Oe, Z = vt(tt, Ne, 30) ^ Z, Vt = Oe ^ qt, jn = vt(tt, Ne, 25) ^ Z, Z = ((Te | Ye) & Ne | Te & Ye) + (Oe ^ Vt) | 0, de = ((qt = jn + ((Qe | un) & tt | Qe & un) | 0) >>> 0 < jn >>> 0 ? Z + 1 | 0 : Z) + de | 0, qt = de = (Vt = Ie + qt | 0) >>> 0 < qt >>> 0 ? de + 1 | 0 : de, l[ae + 8 >> 2] = Vt, l[ae + 12 >> 2] = de, de = q + Mt | 0, Ie = de = (q = Ie + rt | 0) >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, l[ae + 40 >> 2] = q, l[ae + 44 >> 2] = de, de = 34e3 + (Z = 120 | Tn) | 0, Tn = l[(Z = rt = Z + le | 0) >> 2], Mt = l[de >> 2] + Tn | 0, de = l[de + 4 >> 2] + l[Z + 4 >> 2] | 0, Z = We + (Mt >>> 0 < Tn >>> 0 ? de + 1 | 0 : de) | 0, Z = (be ^ (be ^ ot) & Ie) + (Z = (de = Ue + Mt | 0) >>> 0 < Ue >>> 0 ? Z + 1 | 0 : Z) | 0, Z = (de = (Ue = xt ^ (_t ^ xt) & q) + de | 0) >>> 0 < Ue >>> 0 ? Z + 1 | 0 : Z, Ue = vt(q, Ie, 50), be = Oe, Ue = vt(q, Ie, 46) ^ Ue, be ^= Oe, Ie = (Ue = vt(q, Ie, 23) ^ Ue) + de | 0, de = (Oe ^ be) + Z | 0, de = Ie >>> 0 < Ue >>> 0 ? de + 1 | 0 : de, Ue = Ie, be = de, Z = de, de = vt(Vt, qt, 36), q = Oe, de = vt(Vt, qt, 30) ^ de, ot = Oe ^ q, We = vt(Vt, qt, 25) ^ de, de = ((Te | Ne) & qt | Te & Ne) + (Oe ^ ot) | 0, Z = ((q = We + ((tt | un) & Vt | tt & un) | 0) >>> 0 < We >>> 0 ? de + 1 | 0 : de) + Z | 0, Z = (Ie = Ie + q | 0) >>> 0 < q >>> 0 ? Z + 1 | 0 : Z, l[ae >> 2] = Ie, l[ae + 4 >> 2] = Z, de = be + Ye | 0, de = (Ye = Qe) >>> 0 > (Qe = Qe + Ue | 0) >>> 0 ? de + 1 | 0 : de, l[ae + 32 >> 2] = Qe, l[ae + 36 >> 2] = de, (0 | br) != 64; )
                        be = ((br = br + 16 | 0) << 3) + le | 0, Ue = l[Bn >> 2], Ye = l[Bn + 4 >> 2], jn = l[Pt >> 2], Te = Z = l[Pt + 4 >> 2], de = Z, Ie = Z = l[gn + 4 >> 2], Z = vt(Vt = l[gn >> 2], Z, 45), Qe = Oe, q = ((63 & Ie) << 26 | Vt >>> 6) ^ (Z = vt(Vt, Ie, 3) ^ Z), Z = (Ie >>> 6 ^ (Ne = Oe ^ Qe)) + de | 0, de = ((Qe = q + jn | 0) >>> 0 < q >>> 0 ? Z + 1 | 0 : Z) + Ye | 0, de = (Z = Qe + Ue | 0) >>> 0 < Qe >>> 0 ? de + 1 | 0 : de, Ue = Qe = l[nr + 4 >> 2], Qe = vt(Ye = l[nr >> 2], Qe, 63), Ne = Oe, Qe = ((127 & Ue) << 25 | Ye >>> 7) ^ vt(Ye, Ue, 56) ^ Qe, de = (Oe ^ Ne ^ Ue >>> 7) + de | 0, Qe = de = Qe >>> 0 > (un = Qe + Z | 0) >>> 0 ? de + 1 | 0 : de, l[be >> 2] = un, l[be + 4 >> 2] = de, Ye = (gn = l[An >> 2]) + Ye | 0, Z = (be = l[An + 4 >> 2]) + Ue | 0, de = Ye >>> 0 < gn >>> 0 ? Z + 1 | 0 : Z, Ue = Z = l[rt + 4 >> 2], Z = vt(Mt = l[rt >> 2], Z, 45), Ne = Oe, q = Ye, Ye = ((63 & Ue) << 26 | Mt >>> 6) ^ vt(Mt, Ue, 3) ^ Z, de = (Oe ^ Ne ^ Ue >>> 6) + de | 0, Ye = (q = q + Ye | 0) >>> 0 < Ye >>> 0 ? de + 1 | 0 : de, de = vt(Ne = l[Xn >> 2], Z = l[Xn + 4 >> 2], 63), ot = Oe, rt = q, q = ((127 & Z) << 25 | Ne >>> 7) ^ vt(Ne, Z, 56) ^ de, de = (Oe ^ ot ^ Z >>> 7) + Ye | 0, Ye = de = q >>> 0 > (tt = rt + q | 0) >>> 0 ? de + 1 | 0 : de, l[Bn + 136 >> 2] = tt, l[Bn + 140 >> 2] = de, de = (Tn = l[Dt >> 2]) + Ne | 0, Z = (Ne = l[Dt + 4 >> 2]) + Z | 0, q = vt(un, Qe, 45), ot = Oe, q = (We = ((63 & Qe) << 26 | un >>> 6) ^ vt(un, Qe, 3) ^ q) + de | 0, de = (Oe ^ ot ^ Qe >>> 6) + (de >>> 0 < Tn >>> 0 ? Z + 1 | 0 : Z) | 0, de = q >>> 0 < We >>> 0 ? de + 1 | 0 : de, ot = Z = l[kn + 4 >> 2], Z = vt(We = l[kn >> 2], Z, 63), qt = Oe, rt = q, q = ((127 & ot) << 25 | We >>> 7) ^ vt(We, ot, 56) ^ Z, de = (Oe ^ qt ^ ot >>> 7) + de | 0, q = de = q >>> 0 > (nr = rt + q | 0) >>> 0 ? de + 1 | 0 : de, l[Bn + 144 >> 2] = nr, l[Bn + 148 >> 2] = de, We = (Xn = l[zn >> 2]) + We | 0, Z = (Z = ot) + (ot = l[zn + 4 >> 2]) | 0, de = We >>> 0 < Xn >>> 0 ? Z + 1 | 0 : Z, Z = vt(tt, Ye, 45), qt = Oe, xt = ((63 & Ye) << 26 | tt >>> 6) ^ vt(tt, Ye, 3) ^ Z, de = (Oe ^ qt ^ Ye >>> 6) + de | 0, de = (We = xt + We | 0) >>> 0 < xt >>> 0 ? de + 1 | 0 : de, qt = Z = l[nn + 4 >> 2], Z = vt(xt = l[nn >> 2], Z, 63), _t = Oe, rt = We, We = ((127 & qt) << 25 | xt >>> 7) ^ vt(xt, qt, 56) ^ Z, de = (Oe ^ _t ^ qt >>> 7) + de | 0, We = de = We >>> 0 > (kn = rt + We | 0) >>> 0 ? de + 1 | 0 : de, l[Bn + 152 >> 2] = kn, l[Bn + 156 >> 2] = de, Z = (nn = l[_r >> 2]) + xt | 0, de = (de = qt) + (qt = l[_r + 4 >> 2]) | 0, xt = vt(nr, q, 45), _t = Oe, xt = ((63 & q) << 26 | nr >>> 6) ^ vt(nr, q, 3) ^ xt, de = (Oe ^ _t ^ q >>> 6) + (Z >>> 0 < nn >>> 0 ? de + 1 | 0 : de) | 0, xt = (rt = xt + Z | 0) >>> 0 < xt >>> 0 ? de + 1 | 0 : de, de = vt(_t = l[De >> 2], Z = l[De + 4 >> 2], 63), De = Oe, Dt = rt, rt = ((127 & Z) << 25 | _t >>> 7) ^ (de = vt(_t, Z, 56) ^ de), de = (Z >>> 7 ^ (Pt = Oe ^ De)) + xt | 0, xt = de = rt >>> 0 > (De = Dt + rt | 0) >>> 0 ? de + 1 | 0 : de, l[Bn + 160 >> 2] = De, l[Bn + 164 >> 2] = de, Z = Z + Ie | 0, Z = (de = _t + Vt | 0) >>> 0 < _t >>> 0 ? Z + 1 | 0 : Z, _t = vt(kn, We, 45), rt = Oe, _t = (Pt = ((63 & We) << 26 | kn >>> 6) ^ vt(kn, We, 3) ^ _t) + de | 0, de = (Oe ^ rt ^ We >>> 6) + Z | 0, de = _t >>> 0 < Pt >>> 0 ? de + 1 | 0 : de, Pt = Z = l[Vn + 4 >> 2], Z = vt(rt = l[Vn >> 2], Z, 63), Vn = Oe, Z = vt(rt, Pt, 56) ^ Z, Dt = _t, de = (Pt >>> 7 ^ (An = Oe ^ Vn)) + de | 0, _t = de = (_t = ((127 & Pt) << 25 | rt >>> 7) ^ Z) >>> 0 > (Vn = Dt + _t | 0) >>> 0 ? de + 1 | 0 : de, l[Bn + 168 >> 2] = Vn, l[Bn + 172 >> 2] = de, Z = Ue + Pt | 0, Z = (de = rt + Mt | 0) >>> 0 < rt >>> 0 ? Z + 1 | 0 : Z, Dt = rt = l[Dn + 4 >> 2], rt = vt(An = l[Dn >> 2], rt, 63), Pt = Oe, rt = (Dn = ((127 & Dt) << 25 | An >>> 7) ^ vt(An, Dt, 56) ^ rt) + de | 0, de = (Oe ^ Pt ^ Dt >>> 7) + Z | 0, Z = rt >>> 0 < Dn >>> 0 ? de + 1 | 0 : de, de = vt(De, xt, 45), Pt = Oe, de = vt(De, xt, 3) ^ de, Dn = Oe ^ Pt, Pt = rt, Z = (xt >>> 6 ^ Dn) + Z | 0, rt = Z = (rt = ((63 & xt) << 26 | De >>> 6) ^ de) >>> 0 > (Pt = Pt + rt | 0) >>> 0 ? Z + 1 | 0 : Z, l[Bn + 176 >> 2] = Pt, l[Bn + 180 >> 2] = Z, zn = l[vn >> 2], vn = Z = l[vn + 4 >> 2], Dn = Z, Z = vt(jn, Te, 63), de = Oe, _r = ((127 & Te) << 25 | jn >>> 7) ^ vt(jn, Te, 56) ^ Z, Z = (Oe ^ de ^ Te >>> 7) + Ye | 0, de = ((tt = _r + tt | 0) >>> 0 < _r >>> 0 ? Z + 1 | 0 : Z) + Dn | 0, de = (Z = tt + zn | 0) >>> 0 < tt >>> 0 ? de + 1 | 0 : de, Ye = vt(Pt, rt, 45), tt = Oe, Dn = (Ye = ((63 & rt) << 26 | Pt >>> 6) ^ vt(Pt, rt, 3) ^ Ye) + Z | 0, Z = (Oe ^ tt ^ rt >>> 6) + de | 0, Ye = Z = Ye >>> 0 > Dn >>> 0 ? Z + 1 | 0 : Z, l[Bn + 192 >> 2] = Dn, l[Bn + 196 >> 2] = Z, de = Qe + Dt | 0, de = (Z = un + An | 0) >>> 0 < An >>> 0 ? de + 1 | 0 : de, tt = vt(zn, vn, 63), An = Oe, Dt = ((127 & vn) << 25 | zn >>> 7) ^ vt(zn, vn, 56) ^ tt, de = (Oe ^ An ^ vn >>> 7) + de | 0, Z = (tt = Dt + Z | 0) >>> 0 < Dt >>> 0 ? de + 1 | 0 : de, de = vt(Vn, _t, 45), An = Oe, de = vt(Vn, _t, 3) ^ de, vn = tt, Z = (_t >>> 6 ^ (Dt = Oe ^ An)) + Z | 0, tt = Z = (tt = ((63 & _t) << 26 | Vn >>> 6) ^ de) >>> 0 > (An = vn + tt | 0) >>> 0 ? Z + 1 | 0 : Z, l[Bn + 184 >> 2] = An, l[Bn + 188 >> 2] = Z, Z = vt(Tn, Ne, 63), de = Oe, Z = ((127 & Ne) << 25 | Tn >>> 7) ^ vt(Tn, Ne, 56) ^ Z, de = (Oe ^ de ^ Ne >>> 7) + be | 0, Z = We + (Z >>> 0 > (Dt = Z + gn | 0) >>> 0 ? de + 1 | 0 : de) | 0, Z = (de = kn + Dt | 0) >>> 0 < kn >>> 0 ? Z + 1 | 0 : Z, We = vt(Dn, Ye, 45), kn = Oe, We = vt(Dn, Ye, 3) ^ We, Dt = Oe ^ kn, kn = (We ^= (63 & Ye) << 26 | Dn >>> 6) + de | 0, de = (Ye >>> 6 ^ Dt) + Z | 0, We = de = We >>> 0 > kn >>> 0 ? de + 1 | 0 : de, l[Bn + 208 >> 2] = kn, l[Bn + 212 >> 2] = de, Z = vt(gn, be, 63), de = Oe, Dt = vt(gn, be, 56) ^ Z, de = ((Z = be >>> 7 | 0) ^ Oe ^ de) + Te | 0, Z = q + ((be = (gn = Dt ^ ((127 & be) << 25 | gn >>> 7)) + jn | 0) >>> 0 < gn >>> 0 ? de + 1 | 0 : de) | 0, Z = (de = be + nr | 0) >>> 0 < nr >>> 0 ? Z + 1 | 0 : Z, Te = vt(An, tt, 45), be = Oe, q = (Te = ((63 & tt) << 26 | An >>> 6) ^ vt(An, tt, 3) ^ Te) + de | 0, de = (Oe ^ be ^ tt >>> 6) + Z | 0, Te = de = Te >>> 0 > q >>> 0 ? de + 1 | 0 : de, l[Bn + 200 >> 2] = q, l[Bn + 204 >> 2] = de, Z = vt(nn, qt, 63), de = Oe, gn = ((127 & qt) << 25 | nn >>> 7) ^ vt(nn, qt, 56) ^ Z, Z = (Oe ^ de ^ qt >>> 7) + ot | 0, de = _t + ((be = gn + Xn | 0) >>> 0 < gn >>> 0 ? Z + 1 | 0 : Z) | 0, de = (Z = be + Vn | 0) >>> 0 < Vn >>> 0 ? de + 1 | 0 : de, be = vt(kn, We, 45), _t = Oe, Dt = Z, Z = We >>> 6 | 0, be = ((63 & We) << 26 | kn >>> 6) ^ vt(kn, We, 3) ^ be, de = (Z ^ Oe ^ _t) + de | 0, be = de = be >>> 0 > (We = Dt + be | 0) >>> 0 ? de + 1 | 0 : de, l[Bn + 224 >> 2] = We, l[Bn + 228 >> 2] = de, Z = vt(Xn, ot, 63), de = Oe, Z = vt(Xn, ot, 56) ^ Z, _t = Oe ^ de, gn = ((127 & ot) << 25 | Xn >>> 7) ^ Z, Z = ((de = ot >>> 7 | 0) ^ _t) + Ne | 0, de = xt + ((ot = gn + Tn | 0) >>> 0 < gn >>> 0 ? Z + 1 | 0 : Z) | 0, de = (Z = ot + De | 0) >>> 0 < De >>> 0 ? de + 1 | 0 : de, Ne = vt(q, Te, 45), ot = Oe, _t = Z, Z = Te >>> 6 | 0, Te = ((63 & Te) << 26 | q >>> 6) ^ vt(q, Te, 3) ^ Ne, Z = (Z ^ Oe ^ ot) + de | 0, Te = Z = Te >>> 0 > (Ne = _t + Te | 0) >>> 0 ? Z + 1 | 0 : Z, l[Bn + 216 >> 2] = Ne, l[Bn + 220 >> 2] = Z, Z = vt(Mt, Ue, 63), de = Oe, ot = ((127 & Ue) << 25 | Mt >>> 7) ^ vt(Mt, Ue, 56) ^ Z, de = (Oe ^ de ^ Ue >>> 7) + Ie | 0, de = tt + ((Z = ot + Vt | 0) >>> 0 < ot >>> 0 ? de + 1 | 0 : de) | 0, Z = (q = Z + An | 0) >>> 0 < An >>> 0 ? de + 1 | 0 : de, de = vt(We, be, 45), ot = Oe, tt = q, q = vt(We, be, 3) ^ de, de = be >>> 6 | 0, be = tt + (q ^= (63 & be) << 26 | We >>> 6) | 0, Z = (de ^ Oe ^ ot) + Z | 0, l[Bn + 240 >> 2] = be, l[Bn + 244 >> 2] = be >>> 0 < q >>> 0 ? Z + 1 | 0 : Z, Z = vt(Vt, Ie, 63), de = Oe, Z = vt(Vt, Ie, 56) ^ Z, be = Oe ^ de, de = ((de = Ie >>> 7 | 0) ^ be) + qt | 0, Z = rt + ((Z ^= (127 & Ie) << 25 | Vt >>> 7) >>> 0 > (Ie = Z + nn | 0) >>> 0 ? de + 1 | 0 : de) | 0, Z = (de = Ie + Pt | 0) >>> 0 < Pt >>> 0 ? Z + 1 | 0 : Z, Ie = vt(Ne, Te, 45), be = Oe, q = de, de = Te >>> 6 | 0, Ie = ((63 & Te) << 26 | Ne >>> 6) ^ vt(Ne, Te, 3) ^ Ie, de = (de ^ Oe ^ be) + Z | 0, Ie = de = Ie >>> 0 > (Te = q + Ie | 0) >>> 0 ? de + 1 | 0 : de, l[Bn + 232 >> 2] = Te, l[Bn + 236 >> 2] = de, Z = vt(un, Qe, 63), de = Oe, q = vt(un, Qe, 56) ^ Z, de = ((Z = Qe >>> 7 | 0) ^ Oe ^ de) + Ue | 0, Z = Ye + ((Qe = (be = q ^ ((127 & Qe) << 25 | un >>> 7)) + Mt | 0) >>> 0 < be >>> 0 ? de + 1 | 0 : de) | 0, Z = (de = Qe + Dn | 0) >>> 0 < Dn >>> 0 ? Z + 1 | 0 : Z, Qe = vt(Te, Ie, 45), Ue = Oe, Ye = de, de = Ie >>> 6 | 0, Ie = Ye + (Qe = ((63 & Ie) << 26 | Te >>> 6) ^ vt(Te, Ie, 3) ^ Qe) | 0, de = (de ^ Oe ^ Ue) + Z | 0, l[Bn + 248 >> 2] = Ie, l[Bn + 252 >> 2] = Ie >>> 0 < Qe >>> 0 ? de + 1 | 0 : de;
                      Z = Z + l[L + 4 >> 2] | 0, Z = (le = Ie + l[L >> 2] | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, l[L >> 2] = le, l[L + 4 >> 2] = Z, de = l[L + 12 >> 2] + l[ae + 12 >> 2] | 0, Z = (le = l[ae + 8 >> 2]) + l[L + 8 >> 2] | 0, l[L + 8 >> 2] = Z, l[L + 12 >> 2] = Z >>> 0 < le >>> 0 ? de + 1 | 0 : de, de = l[L + 20 >> 2] + l[ae + 20 >> 2] | 0, Z = (le = l[ae + 16 >> 2]) + l[L + 16 >> 2] | 0, l[L + 16 >> 2] = Z, l[L + 20 >> 2] = Z >>> 0 < le >>> 0 ? de + 1 | 0 : de, Z = l[L + 28 >> 2] + l[ae + 28 >> 2] | 0, le = (de = l[ae + 24 >> 2]) + l[L + 24 >> 2] | 0, l[L + 24 >> 2] = le, l[L + 28 >> 2] = le >>> 0 < de >>> 0 ? Z + 1 | 0 : Z, de = l[L + 36 >> 2] + l[ae + 36 >> 2] | 0, Z = (le = l[ae + 32 >> 2]) + l[L + 32 >> 2] | 0, l[L + 32 >> 2] = Z, l[L + 36 >> 2] = Z >>> 0 < le >>> 0 ? de + 1 | 0 : de, Z = l[L + 44 >> 2] + l[ae + 44 >> 2] | 0, le = (de = l[ae + 40 >> 2]) + l[L + 40 >> 2] | 0, l[L + 40 >> 2] = le, l[L + 44 >> 2] = le >>> 0 < de >>> 0 ? Z + 1 | 0 : Z, de = l[L + 52 >> 2] + l[ae + 52 >> 2] | 0, Z = (le = l[ae + 48 >> 2]) + l[L + 48 >> 2] | 0, l[L + 48 >> 2] = Z, l[L + 52 >> 2] = Z >>> 0 < le >>> 0 ? de + 1 | 0 : de, de = l[L + 60 >> 2] + l[ae + 60 >> 2] | 0, Z = (le = l[ae + 56 >> 2]) + l[L + 56 >> 2] | 0, l[L + 56 >> 2] = Z, l[L + 60 >> 2] = Z >>> 0 < le >>> 0 ? de + 1 | 0 : de;
                    }
                    function aa(L) {
                      var Z, le, ae, de, Ie, Qe, q, be, Ue, Ye, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0, kr = 0, Qr = 0, Ur = 0, Lr = 0, Jr = 0, jr = 0, oo = 0, uo = 0;
                      rt = (un = B[L + 44 | 0] | B[L + 45 | 0] << 8 | B[L + 46 | 0] << 16 | B[L + 47 | 0] << 24) >>> 5 & 2097151, We = dt(Vn = (B[L + 60 | 0] | B[L + 61 | 0] << 8 | B[L + 62 | 0] << 16 | B[L + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), Ne = (Te = B[L + 44 | 0]) << 16 & 2031616 | B[L + 42 | 0] | B[L + 43 | 0] << 8, Te = Oe, tt = Te = Ne >>> 0 > (xt = We + Ne | 0) >>> 0 ? Te + 1 | 0 : Te, Pt = Te = Te - ((xt >>> 0 < 4293918720) - 1 | 0) | 0, We = Te >> 21, Te = (Ne = rt) + (rt = (2097151 & Te) << 11 | (_t = xt - -1048576 | 0) >>> 21) | 0, Ne = We, br = Ne = Te >>> 0 < rt >>> 0 ? Ne + 1 | 0 : Ne, kr = Te, kn = dt(Te, Ne, -683901, -1), Mt = Oe, qt = dt(Z = (B[L + 49 | 0] | B[L + 50 | 0] << 8 | B[L + 51 | 0] << 16 | B[L + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), We = (Te = B[L + 27 | 0]) >>> 24 | 0, rt = Te << 8 | (gn = B[L + 23 | 0] | B[L + 24 | 0] << 8 | B[L + 25 | 0] << 16 | B[L + 26 | 0] << 24) >>> 24, Ne = (Te = B[L + 28 | 0]) >>> 16 | 0, Ne = 2097151 & ((3 & (Ne |= We)) << 30 | (Te = rt | Te << 16) >>> 2), Te = Oe, Te = Ne >>> 0 > (We = Ne + qt | 0) >>> 0 ? Te + 1 | 0 : Te, Ne = dt(zn = (Bn = B[L + 52 | 0] | B[L + 53 | 0] << 8 | B[L + 54 | 0] << 16 | B[L + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), Te = Oe + Te | 0, qt = We = Ne + We | 0, We = Ne >>> 0 > We >>> 0 ? Te + 1 | 0 : Te, ot = (Ne = B[L + 48 | 0]) << 8 | un >>> 24, Ne = Te = Ne >>> 24 | 0, Te = dt(le = 2097151 & ((3 & (un = (Te = (rt = B[L + 49 | 0]) >>> 16 | 0) | Ne)) << 30 | (Ne = (rt <<= 16) | ot) >>> 2), 0, 136657, 0), We = Oe + We | 0, We = Te >>> 0 > (Ne = Te + qt | 0) >>> 0 ? We + 1 | 0 : We, rt = (Te = dt(ae = (B[L + 57 | 0] | B[L + 58 | 0] << 8 | B[L + 59 | 0] << 16 | B[L + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + Ne | 0, Ne = Oe + We | 0, qt = rt, We = Te >>> 0 > rt >>> 0 ? Ne + 1 | 0 : Ne, Ne = (Te = B[L + 56 | 0]) >>> 24 | 0, ot = Te << 8 | Bn >>> 24, Ne = dt(de = 2097151 & ((1 & (Bn = (Te = (rt = B[L + 57 | 0]) >>> 16 | 0) | Ne)) << 31 | (Ne = (rt <<= 16) | ot) >>> 1), 0, 470296, 0), Te = Oe + We | 0, Ne = (Te = (We = rt = Ne + qt | 0) >>> 0 < Ne >>> 0 ? Te + 1 | 0 : Te) + Mt | 0, Ne = We >>> 0 > (rt = We + kn | 0) >>> 0 ? Ne + 1 | 0 : Ne, Dt = We - -1048576 | 0, An = We = Te - ((We >>> 0 < 4293918720) - 1 | 0) | 0, Mt = rt - (Te = -2097152 & Dt) | 0, kn = Ne - ((Te >>> 0 > rt >>> 0) + We | 0) | 0, Ne = dt(Z, 0, 654183, 0), Te = Oe, Te = Ne >>> 0 > (We = Ne + (gn >>> 5 & 2097151) | 0) >>> 0 ? Te + 1 | 0 : Te, rt = (Ne = We) + (We = dt(zn, 0, 470296, 0)) | 0, Ne = Oe + Te | 0, Ne = We >>> 0 > rt >>> 0 ? Ne + 1 | 0 : Ne, Te = dt(le, Ur, -997805, -1), Ne = Oe + Ne | 0, Ne = Te >>> 0 > (We = Te + rt | 0) >>> 0 ? Ne + 1 | 0 : Ne, rt = (Te = We) + (We = dt(de, Lr, 666643, 0)) | 0, Te = Oe + Ne | 0, ot = rt, rt = We >>> 0 > rt >>> 0 ? Te + 1 | 0 : Te, qt = (We = dt(Z, 0, 470296, 0)) + (Te = (Te = B[L + 23 | 0]) << 16 & 2031616 | B[L + 21 | 0] | B[L + 22 | 0] << 8) | 0, We = Oe, We = Te >>> 0 > qt >>> 0 ? We + 1 | 0 : We, qt = (Ne = dt(zn, 0, 666643, 0)) + qt | 0, Te = Oe + We | 0, We = dt(le, Ur, 654183, 0), Ne = Oe + (Ne >>> 0 > qt >>> 0 ? Te + 1 | 0 : Te) | 0, Bn = Ne = We >>> 0 > (gn = We + qt | 0) >>> 0 ? Ne + 1 | 0 : Ne, vn = Ne = Ne - ((gn >>> 0 < 4293918720) - 1 | 0) | 0, Te = (Te = Ne >>> 21 | 0) + rt | 0, We = Te = (Ne = (2097151 & Ne) << 11 | (qt = gn - -1048576 | 0) >>> 21) >>> 0 > (ot = Ne + ot | 0) >>> 0 ? Te + 1 | 0 : Te, Vt = Ne = Te - ((ot >>> 0 < 4293918720) - 1 | 0) | 0, Te = Mt, Mt = (2097151 & Ne) << 11 | (rt = ot - -1048576 | 0) >>> 21, Ne = (Ne >> 21) + kn | 0, un = Mt = (Ne = Mt >>> 0 > (Tn = Te + Mt | 0) >>> 0 ? Ne + 1 | 0 : Ne) - ((Tn >>> 0 < 4293918720) - 1 | 0) | 0, jn = Tn - (Te = -2097152 & (kn = Tn - -1048576 | 0)) | 0, Jr = Ne - ((Te >>> 0 > Tn >>> 0) + Mt | 0) | 0, Te = dt(kr, br, 136657, 0), We = Oe + We | 0, We = Te >>> 0 > (Ne = Te + ot | 0) >>> 0 ? We + 1 | 0 : We, De = Ne - (Te = -2097152 & rt) | 0, _r = We - ((Te >>> 0 > Ne >>> 0) + Vt | 0) | 0, Tn = xt - (Te = -2097152 & _t) | 0, Pt = tt - ((Te >>> 0 > xt >>> 0) + Pt | 0) | 0, tt = dt(Vn, 0, 136657, 0), Ne = (Te = B[L + 40 | 0]) >>> 24 | 0, rt = Te << 8 | (_t = B[L + 36 | 0] | B[L + 37 | 0] << 8 | B[L + 38 | 0] << 16 | B[L + 39 | 0] << 24) >>> 24, We = (Te = B[L + 41 | 0]) >>> 16 | 0, Ne = (We |= Ne) >>> 3 | 0, We = (7 & We) << 29 | (Te = rt | Te << 16) >>> 3, Te = Ne + Oe | 0, Te = We >>> 0 > (rt = We + tt | 0) >>> 0 ? Te + 1 | 0 : Te, Ne = dt(ae, 0, -683901, -1), Te = Oe + Te | 0, Te = Ne >>> 0 > (We = Ne + rt | 0) >>> 0 ? Te + 1 | 0 : Te, ot = We, Ne = dt(Vn, 0, -997805, -1), We = Oe, We = Ne >>> 0 > (rt = Ne + (_t >>> 6 & 2097151) | 0) >>> 0 ? We + 1 | 0 : We, _t = (Ne = rt) + (rt = dt(ae, 0, 136657, 0)) | 0, Ne = Oe + We | 0, We = dt(de, Lr, -683901, -1), Ne = Oe + (rt >>> 0 > _t >>> 0 ? Ne + 1 | 0 : Ne) | 0, Mt = Ne = We >>> 0 > (Xn = We + _t | 0) >>> 0 ? Ne + 1 | 0 : Ne, jr = We = Ne - ((Xn >>> 0 < 4293918720) - 1 | 0) | 0, Te = Te + (Ne = We >> 21) | 0, _t = Te = (We = (2097151 & We) << 11 | (xt = Xn - -1048576 | 0) >>> 21) >>> 0 > (Vt = We + ot | 0) >>> 0 ? Te + 1 | 0 : Te, nr = Te = Te - ((Vt >>> 0 < 4293918720) - 1 | 0) | 0, Ne = (Ne = Te >> 21) + Pt | 0, Qr = Ne = (Te = (We = (2097151 & Te) << 11 | (ot = Vt - -1048576 | 0) >>> 21) + Tn | 0) >>> 0 < We >>> 0 ? Ne + 1 | 0 : Ne, nn = Te, Ne = dt(Te, Ne, -683901, -1), Te = Oe + _r | 0, Dn = We = Ne + De | 0, rt = Ne >>> 0 > We >>> 0 ? Te + 1 | 0 : Te, _r = gn - (Te = -2097152 & qt) | 0, Pt = Bn - ((4095 & vn) + (Te >>> 0 > gn >>> 0) | 0) | 0, gn = dt(Z, 0, 666643, 0), Te = (Ne = B[L + 19 | 0]) >>> 24 | 0, qt = Ne << 8 | (Bn = B[L + 15 | 0] | B[L + 16 | 0] << 8 | B[L + 17 | 0] << 16 | B[L + 18 | 0] << 24) >>> 24, We = Te, Ne = (7 & (We |= Ne = (Te = B[L + 20 | 0]) >>> 16 | 0)) << 29 | (Ne = (Te <<= 16) | qt) >>> 3, We = Oe + (We >>> 3 | 0) | 0, We = Ne >>> 0 > (qt = Ne + gn | 0) >>> 0 ? We + 1 | 0 : We, Te = dt(le, Ur, 470296, 0), Ne = Oe + We | 0, Te = Te >>> 0 > (qt = Te + qt | 0) >>> 0 ? Ne + 1 | 0 : Ne, We = dt(le, Ur, 666643, 0), Ne = Oe, gn = Ne = We >>> 0 > (De = We + (Bn >>> 6 & 2097151) | 0) >>> 0 ? Ne + 1 | 0 : Ne, oo = We = Ne - ((De >>> 0 < 4293918720) - 1 | 0) | 0, Te = Te + (Ne = We >>> 21 | 0) | 0, Bn = Te = (We = (2097151 & We) << 11 | (tt = De - -1048576 | 0) >>> 21) >>> 0 > (Tn = We + qt | 0) >>> 0 ? Te + 1 | 0 : Te, uo = Te = Te - ((Tn >>> 0 < 4293918720) - 1 | 0) | 0, Ne = (Ne = Te >>> 21 | 0) + Pt | 0, Ne = (Te = (2097151 & Te) << 11 | (qt = Tn - -1048576 | 0) >>> 21) >>> 0 > (We = Te + _r | 0) >>> 0 ? Ne + 1 | 0 : Ne, Pt = (Te = We) + (We = dt(kr, br, -997805, -1)) | 0, Te = Oe + Ne | 0, Te = We >>> 0 > Pt >>> 0 ? Te + 1 | 0 : Te, vn = Ne = Vt - (We = -2097152 & ot) | 0, Ie = ot = _t - ((We >>> 0 > Vt >>> 0) + nr | 0) | 0, We = dt(nn, Qr, 136657, 0), Te = Oe + Te | 0, Te = We >>> 0 > (_t = We + Pt | 0) >>> 0 ? Te + 1 | 0 : Te, We = dt(Ne, ot, -683901, -1), Ne = Oe + Te | 0, _t = Ne = We >>> 0 > (Pt = We + _t | 0) >>> 0 ? Ne + 1 | 0 : Ne, nr = Te = Ne - ((Pt >>> 0 < 4293918720) - 1 | 0) | 0, Ne = (2097151 & Te) << 11 | (ot = Pt - -1048576 | 0) >>> 21, Te = (Te >> 21) + rt | 0, Dn = Ne = (Te = Ne >>> 0 > (Vt = Ne + Dn | 0) >>> 0 ? Te + 1 | 0 : Te) - ((Vt >>> 0 < 4293918720) - 1 | 0) | 0, _r = (2097151 & Ne) << 11 | (rt = Vt - -1048576 | 0) >>> 21, Ne = (Ne >> 21) + Jr | 0, q = jn = _r + jn | 0, _r = jn >>> 0 < _r >>> 0 ? Ne + 1 | 0 : Ne, be = Vt - (Ne = -2097152 & rt) | 0, Ue = Te - ((Ne >>> 0 > Vt >>> 0) + Dn | 0) | 0, jn = Pt - (Te = -2097152 & ot) | 0, Jr = _t - ((Te >>> 0 > Pt >>> 0) + nr | 0) | 0, We = (Te = dt(kr, br, 654183, 0)) + (Tn - (Ne = -2097152 & qt) | 0) | 0, Ne = Oe + (Bn - ((Ne >>> 0 > Tn >>> 0) + uo | 0) | 0) | 0, Ne = Te >>> 0 > We >>> 0 ? Ne + 1 | 0 : Ne, Te = dt(nn, Qr, -997805, -1), Ne = Oe + Ne | 0, Ne = Te >>> 0 > (We = Te + We | 0) >>> 0 ? Ne + 1 | 0 : Ne, rt = (Te = We) + (We = dt(vn, Ie, 136657, 0)) | 0, Te = Oe + Ne | 0, Dn = rt, _t = We >>> 0 > rt >>> 0 ? Te + 1 | 0 : Te, Tn = Xn - (Te = -2097152 & xt) | 0, Vt = Mt - ((Te >>> 0 > Xn >>> 0) + jr | 0) | 0, Bn = dt(zn, 0, -683901, -1), Te = (Ne = B[L + 35 | 0]) >>> 24 | 0, rt = Ne << 8 | (qt = B[L + 31 | 0] | B[L + 32 | 0] << 8 | B[L + 33 | 0] << 16 | B[L + 34 | 0] << 24) >>> 24, We = Te, Ne = (Te = B[L + 36 | 0]) >>> 16 | 0, Ne |= We, We = Oe, We = (Te = 2097151 & ((1 & Ne) << 31 | (Te = Te << 16 | rt) >>> 1)) >>> 0 > (Ne = Te + Bn | 0) >>> 0 ? We + 1 | 0 : We, rt = (Te = dt(Vn, 0, 654183, 0)) + Ne | 0, Ne = Oe + We | 0, Ne = Te >>> 0 > rt >>> 0 ? Ne + 1 | 0 : Ne, We = dt(ae, 0, -997805, -1), Te = Oe + Ne | 0, Te = We >>> 0 > (rt = We + rt | 0) >>> 0 ? Te + 1 | 0 : Te, Ne = dt(de, Lr, 136657, 0), Te = Oe + Te | 0, ot = We = Ne + rt | 0, rt = Ne >>> 0 > We >>> 0 ? Te + 1 | 0 : Te, Te = dt(Z, 0, -683901, -1), Ne = Oe, Ne = Te >>> 0 > (We = Te + (qt >>> 4 & 2097151) | 0) >>> 0 ? Ne + 1 | 0 : Ne, qt = (Te = dt(zn, 0, 136657, 0)) + We | 0, We = Oe + Ne | 0, We = Te >>> 0 > qt >>> 0 ? We + 1 | 0 : We, Te = dt(Vn, 0, 470296, 0), Ne = Oe + We | 0, Ne = Te >>> 0 > (qt = Te + qt | 0) >>> 0 ? Ne + 1 | 0 : Ne, qt = (We = dt(ae, 0, 654183, 0)) + qt | 0, Te = Oe + Ne | 0, Ne = dt(de, Lr, -997805, -1), Te = Oe + (We >>> 0 > qt >>> 0 ? Te + 1 | 0 : Te) | 0, Bn = Te = Ne >>> 0 > (Mt = Ne + qt | 0) >>> 0 ? Te + 1 | 0 : Te, Ye = Ne = Te - ((Mt >>> 0 < 4293918720) - 1 | 0) | 0, We = (Te = Ne >> 21) + rt | 0, Pt = Ne = (We = (Ne = (2097151 & Ne) << 11 | (qt = Mt - -1048576 | 0) >>> 21) >>> 0 > (xt = Ne + ot | 0) >>> 0 ? We + 1 | 0 : We) - ((xt >>> 0 < 4293918720) - 1 | 0) | 0, Te = (Te = Ne >> 21) + Vt | 0, nr = Te = (Ne = (rt = (2097151 & Ne) << 11 | (ot = xt - -1048576 | 0) >>> 21) + Tn | 0) >>> 0 < rt >>> 0 ? Te + 1 | 0 : Te, rt = Dn, Dn = Ne, Te = dt(Ne, Te, -683901, -1), Ne = Oe + _t | 0, Vt = rt = rt + Te | 0, rt = Te >>> 0 > rt >>> 0 ? Ne + 1 | 0 : Ne, _t = (Te = dt(kr, br, 470296, 0)) + (De - (Ne = -2097152 & tt) | 0) | 0, Ne = Oe + (gn - ((2047 & oo) + (Ne >>> 0 > De >>> 0) | 0) | 0) | 0, Ne = Te >>> 0 > _t >>> 0 ? Ne + 1 | 0 : Ne, tt = (Te = _t) + (_t = dt(nn, Qr, 654183, 0)) | 0, Te = Oe + Ne | 0, Te = _t >>> 0 > tt >>> 0 ? Te + 1 | 0 : Te, _t = dt(vn, Ie, -997805, -1), Ne = Oe + Te | 0, Ne = _t >>> 0 > (tt = _t + tt | 0) >>> 0 ? Ne + 1 | 0 : Ne, Xn = ot = xt - (Te = -2097152 & ot) | 0, Qe = _t = We - ((Te >>> 0 > xt >>> 0) + Pt | 0) | 0, We = dt(Dn, nr, 136657, 0), Te = Oe + Ne | 0, Te = We >>> 0 > (tt = We + tt | 0) >>> 0 ? Te + 1 | 0 : Te, We = dt(ot, _t, -683901, -1), Ne = Oe + Te | 0, _t = Ne = We >>> 0 > (gn = We + tt | 0) >>> 0 ? Ne + 1 | 0 : Ne, Pt = Te = Ne - ((gn >>> 0 < 4293918720) - 1 | 0) | 0, Ne = (2097151 & Te) << 11 | (ot = gn - -1048576 | 0) >>> 21, Te = (Te >> 21) + rt | 0, Vt = Ne = (Te = Ne >>> 0 > (tt = Ne + Vt | 0) >>> 0 ? Te + 1 | 0 : Te) - ((tt >>> 0 < 4293918720) - 1 | 0) | 0, xt = (2097151 & Ne) << 11 | (rt = tt - -1048576 | 0) >>> 21, Ne = (Ne >> 21) + Jr | 0, jr = Tn = xt + jn | 0, Tn = xt >>> 0 > Tn >>> 0 ? Ne + 1 | 0 : Ne, oo = tt - (Ne = -2097152 & rt) | 0, uo = Te - ((Ne >>> 0 > tt >>> 0) + Vt | 0) | 0, jn = gn - (Te = -2097152 & ot) | 0, Jr = _t - ((Te >>> 0 > gn >>> 0) + Pt | 0) | 0, _t = dt(kr, br, 666643, 0), Te = (Ne = B[L + 14 | 0]) >>> 24 | 0, rt = Ne << 8 | (Pt = B[L + 10 | 0] | B[L + 11 | 0] << 8 | B[L + 12 | 0] << 16 | B[L + 13 | 0] << 24) >>> 24, We = Te, Ne = (Te = B[L + 15 | 0]) >>> 16 | 0, Ne |= We, We = Oe, We = (Te = 2097151 & ((1 & Ne) << 31 | (Te = Te << 16 | rt) >>> 1)) >>> 0 > (Ne = Te + _t | 0) >>> 0 ? We + 1 | 0 : We, rt = (Te = Ne) + (Ne = dt(nn, Qr, 470296, 0)) | 0, Te = Oe + We | 0, Te = Ne >>> 0 > rt >>> 0 ? Te + 1 | 0 : Te, Ne = dt(vn, Ie, 654183, 0), Te = Oe + Te | 0, Te = Ne >>> 0 > (We = Ne + rt | 0) >>> 0 ? Te + 1 | 0 : Te, rt = (Ne = We) + (We = dt(Dn, nr, -997805, -1)) | 0, Ne = Oe + Te | 0, Ne = We >>> 0 > rt >>> 0 ? Ne + 1 | 0 : Ne, Te = dt(Xn, Qe, 136657, 0), Ne = Oe + Ne | 0, gn = We = Te + rt | 0, rt = Te >>> 0 > We >>> 0 ? Ne + 1 | 0 : Ne, qt = Mt - (Te = -2097152 & qt) | 0, _t = Bn - ((Te >>> 0 > Mt >>> 0) + Ye | 0) | 0, We = dt(Z, 0, 136657, 0), Te = Oe, Te = (Ne = (B[L + 28 | 0] | B[L + 29 | 0] << 8 | B[L + 30 | 0] << 16 | B[L + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (We = Ne + We | 0) >>> 0 ? Te + 1 | 0 : Te, ot = (Ne = We) + (We = dt(zn, 0, -997805, -1)) | 0, Ne = Oe + Te | 0, Ne = We >>> 0 > ot >>> 0 ? Ne + 1 | 0 : Ne, Te = dt(le, Ur, -683901, -1), Ne = Oe + Ne | 0, Ne = Te >>> 0 > (We = Te + ot | 0) >>> 0 ? Ne + 1 | 0 : Ne, ot = (Te = dt(Vn, 0, 666643, 0)) + We | 0, We = Oe + Ne | 0, We = Te >>> 0 > ot >>> 0 ? We + 1 | 0 : We, Ne = dt(ae, 0, 470296, 0), Te = Oe + We | 0, Te = Ne >>> 0 > (ot = Ne + ot | 0) >>> 0 ? Te + 1 | 0 : Te, Ne = dt(de, Lr, 654183, 0), Te = Oe + Te | 0, Ne = (An >> 21) + (Ne >>> 0 > (We = Ne + ot | 0) >>> 0 ? Te + 1 | 0 : Te) | 0, xt = Ne = (ot = (2097151 & An) << 11 | Dt >>> 21) >>> 0 > (Dt = ot + We | 0) >>> 0 ? Ne + 1 | 0 : Ne, Vt = Te = Ne - ((Dt >>> 0 < 4293918720) - 1 | 0) | 0, ot = (2097151 & Te) << 11 | (tt = Dt - -1048576 | 0) >>> 21, Te = (Te >> 21) + _t | 0, De = Te = (Ne = ot + qt | 0) >>> 0 < ot >>> 0 ? Te + 1 | 0 : Te, An = Ne, Ne = dt(Ne, Te, -683901, -1), Te = Oe + rt | 0, ot = We = Ne + gn | 0, rt = Ne >>> 0 > We >>> 0 ? Te + 1 | 0 : Te, Te = dt(nn, Qr, 666643, 0), Ne = Oe, Ne = Te >>> 0 > (We = Te + (Pt >>> 4 & 2097151) | 0) >>> 0 ? Ne + 1 | 0 : Ne, Te = dt(vn, Ie, 470296, 0), Ne = Oe + Ne | 0, Ne = Te >>> 0 > (We = Te + We | 0) >>> 0 ? Ne + 1 | 0 : Ne, _t = (Te = dt(Dn, nr, 654183, 0)) + We | 0, We = Oe + Ne | 0, We = Te >>> 0 > _t >>> 0 ? We + 1 | 0 : We, Ne = dt(Xn, Qe, -997805, -1), Te = Oe + We | 0, Te = Ne >>> 0 > (_t = Ne + _t | 0) >>> 0 ? Te + 1 | 0 : Te, Ne = dt(An, De, 136657, 0), Te = Oe + Te | 0, Bn = Te = Ne >>> 0 > (Mt = Ne + _t | 0) >>> 0 ? Te + 1 | 0 : Te, br = Ne = Te - ((Mt >>> 0 < 4293918720) - 1 | 0) | 0, Te = ot, ot = (2097151 & Ne) << 11 | (qt = Mt - -1048576 | 0) >>> 21, Ne = (Ne >> 21) + rt | 0, nn = rt = (Ne = (We = Te + ot | 0) >>> 0 < ot >>> 0 ? Ne + 1 | 0 : Ne) - ((We >>> 0 < 4293918720) - 1 | 0) | 0, Te = (Te = rt >> 21) + Jr | 0, kr = ot = (rt = (2097151 & rt) << 11 | (_t = We - -1048576 | 0) >>> 21) + jn | 0, gn = rt >>> 0 > ot >>> 0 ? Te + 1 | 0 : Te, ot = We, We = Ne, rt = (Dt - (Ne = -2097152 & tt) | 0) + (tt = (2097151 & un) << 11 | kn >>> 21) | 0, Ne = (xt - ((Ne >>> 0 > Dt >>> 0) + Vt | 0) | 0) + (un >> 21) | 0, Pt = Ne = rt >>> 0 < tt >>> 0 ? Ne + 1 | 0 : Ne, zn = Ne = Ne - ((rt >>> 0 < 4293918720) - 1 | 0) | 0, kn = Te = Ne >> 21, Te = dt(Vn = (2097151 & Ne) << 11 | (Vt = rt - -1048576 | 0) >>> 21, Te, -683901, -1), We = Oe + We | 0, We = Te >>> 0 > (Ne = Te + ot | 0) >>> 0 ? We + 1 | 0 : We, Ur = Ne - (Te = -2097152 & _t) | 0, Lr = We - ((Te >>> 0 > Ne >>> 0) + nn | 0) | 0, Te = dt(Vn, kn, 136657, 0), Ne = Bn + Oe | 0, Qr = (We = Te + Mt | 0) - (Te = -2097152 & qt) | 0, nn = (Ne = We >>> 0 < Mt >>> 0 ? Ne + 1 | 0 : Ne) - ((Te >>> 0 > We >>> 0) + br | 0) | 0, Ne = dt(vn, Ie, 666643, 0), We = Oe, We = (Te = (B[L + 7 | 0] | B[L + 8 | 0] << 8 | B[L + 9 | 0] << 16 | B[L + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (Ne = Te + Ne | 0) >>> 0 ? We + 1 | 0 : We, ot = (Te = dt(Dn, nr, 470296, 0)) + Ne | 0, Ne = Oe + We | 0, Ne = Te >>> 0 > ot >>> 0 ? Ne + 1 | 0 : Ne, Te = dt(Xn, Qe, 654183, 0), Ne = Oe + Ne | 0, Ne = Te >>> 0 > (We = Te + ot | 0) >>> 0 ? Ne + 1 | 0 : Ne, ot = (Te = We) + (We = dt(An, De, -997805, -1)) | 0, Te = Oe + Ne | 0, tt = ot, ot = We >>> 0 > ot >>> 0 ? Te + 1 | 0 : Te, Bn = dt(Dn, nr, 666643, 0), Te = (Ne = B[L + 6 | 0]) >>> 24 | 0, _t = Ne << 8 | (Dt = B[L + 2 | 0] | B[L + 3 | 0] << 8 | B[L + 4 | 0] << 16 | B[L + 5 | 0] << 24) >>> 24, We = Te, Ne = (Te = B[L + 7 | 0]) >>> 16 | 0, Ne = 2097151 & ((3 & (Ne |= We)) << 30 | (Te = Te << 16 | _t) >>> 2), Te = Oe, Te = Ne >>> 0 > (We = Ne + Bn | 0) >>> 0 ? Te + 1 | 0 : Te, _t = (Ne = dt(Xn, Qe, 470296, 0)) + We | 0, We = Oe + Te | 0, We = Ne >>> 0 > _t >>> 0 ? We + 1 | 0 : We, Ne = dt(An, De, 654183, 0), Te = Oe + We | 0, Bn = Te = Ne >>> 0 > (xt = Ne + _t | 0) >>> 0 ? Te + 1 | 0 : Te, un = Te = Te - ((xt >>> 0 < 4293918720) - 1 | 0) | 0, Ne = (We = Te >> 21) + ot | 0, Mt = Te = (Ne = (Te = (2097151 & Te) << 11 | (qt = xt - -1048576 | 0) >>> 21) >>> 0 > (_t = Te + tt | 0) >>> 0 ? Ne + 1 | 0 : Ne) - ((_t >>> 0 < 4293918720) - 1 | 0) | 0, tt = (2097151 & Te) << 11 | (ot = _t - -1048576 | 0) >>> 21, Te = (Te >> 21) + nn | 0, nn = Dn = tt + Qr | 0, tt = tt >>> 0 > Dn >>> 0 ? Te + 1 | 0 : Te, Te = dt(Vn, kn, -997805, -1), Ne = Oe + Ne | 0, Ne = Te >>> 0 > (We = Te + _t | 0) >>> 0 ? Ne + 1 | 0 : Ne, vn = We - (Te = -2097152 & ot) | 0, nr = Ne - ((Te >>> 0 > We >>> 0) + Mt | 0) | 0, Ne = dt(Vn, kn, 654183, 0), Te = Bn + Oe | 0, Dn = (We = Ne + xt | 0) - (Ne = -2097152 & qt) | 0, un = (Te = We >>> 0 < xt >>> 0 ? Te + 1 | 0 : Te) - ((Ne >>> 0 > We >>> 0) + un | 0) | 0, Te = dt(Xn, Qe, 666643, 0), Ne = Oe, Ne = Te >>> 0 > (We = Te + (Dt >>> 5 & 2097151) | 0) >>> 0 ? Ne + 1 | 0 : Ne, Te = dt(An, De, 470296, 0), Ne = Oe + Ne | 0, _t = We = Te + We | 0, We = Te >>> 0 > We >>> 0 ? Ne + 1 | 0 : Ne, ot = dt(An, De, 666643, 0), Ne = (Te = B[L + 2 | 0]) << 16 & 2031616 | B[0 | L] | B[L + 1 | 0] << 8, Te = Oe, Bn = Te = Ne >>> 0 > (Mt = ot + Ne | 0) >>> 0 ? Te + 1 | 0 : Te, De = Te = Te - ((Mt >>> 0 < 4293918720) - 1 | 0) | 0, ot = (2097151 & Te) << 11 | (qt = Mt - -1048576 | 0) >>> 21, Te = (Te >> 21) + We | 0, We = Te = ot >>> 0 > (xt = ot + _t | 0) >>> 0 ? Te + 1 | 0 : Te, Dt = Te = Te - ((xt >>> 0 < 4293918720) - 1 | 0) | 0, ot = (2097151 & Te) << 11 | (_t = xt - -1048576 | 0) >>> 21, Te = (Te >> 21) + un | 0, ot = ot >>> 0 > (un = An = ot + Dn | 0) >>> 0 ? Te + 1 | 0 : Te, Te = dt(Vn, kn, 470296, 0), We = We + Oe | 0, We = (Ne = Te + xt | 0) >>> 0 < xt >>> 0 ? We + 1 | 0 : We, xt = Ne - (Te = -2097152 & _t) | 0, _t = We - ((Te >>> 0 > Ne >>> 0) + Dt | 0) | 0, Ne = dt(Vn, kn, 666643, 0), Te = Oe + (Bn - (((We = -2097152 & qt) >>> 0 > Mt >>> 0) + De | 0) | 0) | 0, Ne = (We = (Te = Ne >>> 0 > (An = Ne + (Mt - We | 0) | 0) >>> 0 ? Te + 1 | 0 : Te) >> 21) + _t | 0, Te = (Te = (Ne = (Te = (2097151 & Te) << 11 | An >>> 21) >>> 0 > (Dt = Te + xt | 0) >>> 0 ? Ne + 1 | 0 : Ne) >> 21) + ot | 0, Ne = (Ne = (Te = (Ne = (2097151 & Ne) << 11 | Dt >>> 21) >>> 0 > (un = Ne + un | 0) >>> 0 ? Te + 1 | 0 : Te) >> 21) + nr | 0, We = (Te = (Ne = (Te = (2097151 & Te) << 11 | un >>> 21) >>> 0 > (ot = Te + vn | 0) >>> 0 ? Ne + 1 | 0 : Ne) >> 21) + tt | 0, Te = (Ne = (We = (Ne = (2097151 & Ne) << 11 | ot >>> 21) >>> 0 > (kn = Ne + nn | 0) >>> 0 ? We + 1 | 0 : We) >> 21) + Lr | 0, Ne = (We = (Te = (We = (2097151 & We) << 11 | kn >>> 21) >>> 0 > (Mt = We + Ur | 0) >>> 0 ? Te + 1 | 0 : Te) >> 21) + gn | 0, Te = (Te = (Ne = (Te = (2097151 & Te) << 11 | Mt >>> 21) >>> 0 > (xt = Te + kr | 0) >>> 0 ? Ne + 1 | 0 : Ne) >> 21) + uo | 0, Ne = (Ne = (Te = (Ne = (2097151 & Ne) << 11 | xt >>> 21) >>> 0 > (gn = Ne + oo | 0) >>> 0 ? Te + 1 | 0 : Te) >> 21) + Tn | 0, We = (Te = (Ne = (Te = (2097151 & Te) << 11 | gn >>> 21) >>> 0 > (tt = Te + jr | 0) >>> 0 ? Ne + 1 | 0 : Ne) >> 21) + Ue | 0, Te = (Ne = (We = (Ne = (2097151 & Ne) << 11 | tt >>> 21) >>> 0 > (Bn = Ne + be | 0) >>> 0 ? We + 1 | 0 : We) >> 21) + _r | 0, _t = (Vt = rt - (Ne = -2097152 & Vt) | 0) + ((2097151 & (Te = (We = (2097151 & We) << 11 | Bn >>> 21) >>> 0 > (qt = We + q | 0) >>> 0 ? Te + 1 | 0 : Te)) << 11 | qt >>> 21) | 0, Te = (Pt - ((Ne >>> 0 > rt >>> 0) + zn | 0) | 0) + (Te >> 21) | 0, Vt = Ne = (Te = _t >>> 0 < Vt >>> 0 ? Te + 1 | 0 : Te) >> 21, An = (Te = dt(Tn = (2097151 & Te) << 11 | _t >>> 21, Ne, 666643, 0)) + (Ne = 2097151 & An) | 0, Te = Oe, rt = Te = Ne >>> 0 > An >>> 0 ? Te + 1 | 0 : Te, j[0 | L] = An, j[L + 1 | 0] = (255 & Te) << 24 | An >>> 8, Te = 2097151 & Dt, Ne = dt(Tn, Vt, 470296, 0) + Te | 0, We = Oe, Te = (rt >> 21) + (Te >>> 0 > Ne >>> 0 ? We + 1 | 0 : We) | 0, Te = (Pt = (2097151 & rt) << 11 | An >>> 21) >>> 0 > (Dt = Pt + Ne | 0) >>> 0 ? Te + 1 | 0 : Te, j[L + 4 | 0] = (2047 & Te) << 21 | Dt >>> 11, Ne = Te, We = Dt, j[L + 3 | 0] = (7 & Te) << 29 | We >>> 3, j[L + 2 | 0] = 31 & ((65535 & rt) << 16 | An >>> 16) | We << 5, rt = 2097151 & un, un = dt(Tn, Vt, 654183, 0) + rt | 0, Te = Oe, Dt = (2097151 & Ne) << 11 | We >>> 21, Ne = (Ne >> 21) + (rt = rt >>> 0 > un >>> 0 ? Te + 1 | 0 : Te) | 0, Te = Ne = (un = Dt + un | 0) >>> 0 < Dt >>> 0 ? Ne + 1 | 0 : Ne, j[L + 6 | 0] = (63 & Te) << 26 | un >>> 6, rt = un, un = 0, j[L + 5 | 0] = un << 13 | (1572864 & We) >>> 19 | rt << 2, We = 2097151 & ot, ot = dt(Tn, Vt, -997805, -1) + We | 0, Ne = Oe, Ne = We >>> 0 > ot >>> 0 ? Ne + 1 | 0 : Ne, un = (2097151 & (We = Te)) << 11 | rt >>> 21, We = (Te >>= 21) + Ne | 0, We = (ot = un + ot | 0) >>> 0 < un >>> 0 ? We + 1 | 0 : We, j[L + 9 | 0] = (511 & We) << 23 | ot >>> 9, j[L + 8 | 0] = (1 & We) << 31 | ot >>> 1, Ne = 0, j[L + 7 | 0] = Ne << 18 | (2080768 & rt) >>> 14 | ot << 7, Ne = 2097151 & kn, rt = dt(Tn, Vt, 136657, 0) + Ne | 0, Te = Oe, Te = Ne >>> 0 > rt >>> 0 ? Te + 1 | 0 : Te, kn = (2097151 & (Ne = We)) << 11 | ot >>> 21, Ne = Te + (We = Ne >> 21) | 0, Ne = (rt = kn + rt | 0) >>> 0 < kn >>> 0 ? Ne + 1 | 0 : Ne, j[L + 12 | 0] = (4095 & Ne) << 20 | rt >>> 12, We = rt, j[L + 11 | 0] = (15 & Ne) << 28 | We >>> 4, rt = 0, j[L + 10 | 0] = rt << 15 | (1966080 & ot) >>> 17 | We << 4, rt = 2097151 & Mt, ot = dt(Tn, Vt, -683901, -1) + rt | 0, Te = Oe, Te = rt >>> 0 > ot >>> 0 ? Te + 1 | 0 : Te, rt = Ne, Ne = Te + (Ne >>= 21) | 0, Ne = (rt = (Dn = ot) + (ot = (2097151 & rt) << 11 | We >>> 21) | 0) >>> 0 < ot >>> 0 ? Ne + 1 | 0 : Ne, j[L + 14 | 0] = (127 & Ne) << 25 | rt >>> 7, ot = 0, j[L + 13 | 0] = ot << 12 | (1048576 & We) >>> 20 | rt << 1, Te = Ne >> 21, We = (Ne = (2097151 & Ne) << 11 | rt >>> 21) >>> 0 > (ot = Ne + (2097151 & xt) | 0) >>> 0 ? Te + 1 | 0 : Te, j[L + 17 | 0] = (1023 & We) << 22 | ot >>> 10, j[L + 16 | 0] = (3 & We) << 30 | ot >>> 2, Ne = 0, j[L + 15 | 0] = Ne << 17 | (2064384 & rt) >>> 15 | ot << 6, Te = We >> 21, Te = (Ne = (2097151 & We) << 11 | ot >>> 21) >>> 0 > (We = Ne + (2097151 & gn) | 0) >>> 0 ? Te + 1 | 0 : Te, j[L + 20 | 0] = (8191 & Te) << 19 | We >>> 13, j[L + 19 | 0] = (31 & Te) << 27 | We >>> 5, rt = (Ne = 2097151 & tt) + (tt = (2097151 & Te) << 11 | We >>> 21) | 0, Ne = Te >> 21, Ne = rt >>> 0 < tt >>> 0 ? Ne + 1 | 0 : Ne, tt = rt, j[L + 21 | 0] = rt, gn = 0, j[L + 18 | 0] = gn << 14 | (1835008 & ot) >>> 18 | We << 3, j[L + 22 | 0] = (255 & Ne) << 24 | rt >>> 8, We = Ne >> 21, We = (rt = (ot = (2097151 & Ne) << 11 | rt >>> 21) + (2097151 & Bn) | 0) >>> 0 < ot >>> 0 ? We + 1 | 0 : We, j[L + 25 | 0] = (2047 & We) << 21 | rt >>> 11, j[L + 24 | 0] = (7 & We) << 29 | rt >>> 3, j[L + 23 | 0] = 31 & ((65535 & Ne) << 16 | tt >>> 16) | rt << 5, Te = We >> 21, Te = (Ne = (2097151 & We) << 11 | rt >>> 21) >>> 0 > (We = Ne + (2097151 & qt) | 0) >>> 0 ? Te + 1 | 0 : Te, j[L + 27 | 0] = (63 & Te) << 26 | We >>> 6, ot = 0, j[L + 26 | 0] = ot << 13 | (1572864 & rt) >>> 19 | We << 2, Ne = Te >> 21, Ne = (Te = (rt = (2097151 & Te) << 11 | We >>> 21) + (2097151 & _t) | 0) >>> 0 < rt >>> 0 ? Ne + 1 | 0 : Ne, j[L + 31 | 0] = (131071 & Ne) << 15 | Te >>> 17, j[L + 30 | 0] = (511 & Ne) << 23 | Te >>> 9, j[L + 29 | 0] = (1 & Ne) << 31 | Te >>> 1, rt = 0, j[L + 28 | 0] = rt << 18 | (2080768 & We) >>> 14 | Te << 7;
                    }
                    function gr(L, Z, le, ae, de, Ie) {
                      var Qe, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0, kr = 0, Qr = 0, Ur = 0, Lr = 0;
                      for (st = Qe = st - 592 | 0, tt = -1, xt = L + 32 | 0, qt = 32, Mt = 1; _t = B[2672 + (be = qt - 1 | 0) | 0], Ue = (be = ((Ye = B[be + xt | 0]) ^ _t) - 1 >> 8 & Mt) & (Ne = B[xt + (qt = qt - 2 | 0) | 0]) - (Te = B[qt + 2672 | 0]) >> 8 | 255 & (Ye - _t >>> 8 & Mt | Ue), Mt = be & (Te ^ Ne) - 1 >> 8, qt; )
                        ;
                      if (255 & Ue && !(Os(L) | !(((127 & (-1 ^ B[de + 31 | 0]) | B[de + 1 | 0] & B[de + 2 | 0] & B[de + 3 | 0] & B[de + 4 | 0] & B[de + 5 | 0] & B[de + 6 | 0] & B[de + 7 | 0] & B[de + 8 | 0] & B[de + 9 | 0] & B[de + 10 | 0] & B[de + 11 | 0] & B[de + 12 | 0] & B[de + 13 | 0] & B[de + 14 | 0] & B[de + 15 | 0] & B[de + 16 | 0] & B[de + 17 | 0] & B[de + 18 | 0] & B[de + 19 | 0] & B[de + 20 | 0] & B[de + 21 | 0] & B[de + 22 | 0] & B[de + 23 | 0] & B[de + 24 | 0] & B[de + 25 | 0] & B[de + 26 | 0] & B[de + 27 | 0] & B[de + 28 | 0] & B[de + 30 | 0] & B[de + 29 | 0] ^ 255) - 1 & 236 - B[0 | de] ^ -1) >>> 8 & 1) || Os(de) || wa(Qe + 128 | 0, de))) {
                        for (Ds(be = Qe + 384 | 0), Ie && Ni(be, 34768, 34, 0), Ni(be, L, 32, 0), Ni(be, de, 32, 0), Ni(be, Z, le, ae), Qi(be, le = Qe + 320 | 0), aa(le), Ie = Qe + 8 | 0, ae = Qe + 128 | 0, de = 0, Z = 0, st = q = st - 2272 | 0; Ye = le + (de >>> 3 | 0) | 0, j[(be = q + 2016 | 0) + de | 0] = B[0 | Ye] >>> (6 & de) & 1, j[(Ue = be) + (be = 1 | de) | 0] = B[0 | Ye] >>> (7 & be) & 1, (0 | (de = de + 2 | 0)) != 256; )
                          ;
                        for (; ; ) {
                          Z = (le = Z) + 1 | 0;
                          e:
                            if (!(!B[0 | (Ue = le + (q + 2016 | 0) | 0)] | le >>> 0 > 254)) {
                              t:
                                if (de = j[0 | (Te = (q + 2016 | 0) + Z | 0)])
                                  if ((0 | (de = (Ye = de << 1) + (be = j[0 | Ue]) | 0)) <= 15)
                                    j[0 | Ue] = de, j[0 | Te] = 0;
                                  else {
                                    if ((0 | (de = be - Ye | 0)) < -15)
                                      break e;
                                    for (j[0 | Ue] = de, de = Z; ; ) {
                                      if (!B[0 | (be = (q + 2016 | 0) + de | 0)]) {
                                        j[0 | be] = 1;
                                        break t;
                                      }
                                      if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, !be)
                                        break;
                                    }
                                  }
                              if (!(le >>> 0 > 253)) {
                                t:
                                  if (be = j[0 | (Ne = (de = le + 2 | 0) + (q + 2016 | 0) | 0)])
                                    if ((0 | (be = (Te = be << 2) + (Ye = j[0 | Ue]) | 0)) >= 16) {
                                      if ((0 | (be = Ye - Te | 0)) < -15)
                                        break e;
                                      for (j[0 | Ue] = be; ; ) {
                                        if (B[0 | (be = (q + 2016 | 0) + de | 0)]) {
                                          if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, be)
                                            continue;
                                          break t;
                                        }
                                        break;
                                      }
                                      j[0 | be] = 1;
                                    } else
                                      j[0 | Ue] = be, j[0 | Ne] = 0;
                                if (!(le >>> 0 > 252)) {
                                  t:
                                    if (be = j[0 | (Ne = (de = le + 3 | 0) + (q + 2016 | 0) | 0)])
                                      if ((0 | (be = (Te = be << 3) + (Ye = j[0 | Ue]) | 0)) >= 16) {
                                        if ((0 | (be = Ye - Te | 0)) < -15)
                                          break e;
                                        for (j[0 | Ue] = be; ; ) {
                                          if (B[0 | (be = (q + 2016 | 0) + de | 0)]) {
                                            if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, be)
                                              continue;
                                            break t;
                                          }
                                          break;
                                        }
                                        j[0 | be] = 1;
                                      } else
                                        j[0 | Ue] = be, j[0 | Ne] = 0;
                                  if (!(le >>> 0 > 251)) {
                                    t:
                                      if (be = j[0 | (Ne = (de = le + 4 | 0) + (q + 2016 | 0) | 0)])
                                        if ((0 | (be = (Te = be << 4) + (Ye = j[0 | Ue]) | 0)) >= 16) {
                                          if ((0 | (be = Ye - Te | 0)) < -15)
                                            break e;
                                          for (j[0 | Ue] = be; ; ) {
                                            if (B[0 | (be = (q + 2016 | 0) + de | 0)]) {
                                              if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, be)
                                                continue;
                                              break t;
                                            }
                                            break;
                                          }
                                          j[0 | be] = 1;
                                        } else
                                          j[0 | Ue] = be, j[0 | Ne] = 0;
                                    if (!(le >>> 0 > 250)) {
                                      t:
                                        if (be = j[0 | (Ne = (de = le + 5 | 0) + (q + 2016 | 0) | 0)])
                                          if ((0 | (be = (Te = be << 5) + (Ye = j[0 | Ue]) | 0)) >= 16) {
                                            if ((0 | (be = Ye - Te | 0)) < -15)
                                              break e;
                                            for (j[0 | Ue] = be; ; ) {
                                              if (B[0 | (be = (q + 2016 | 0) + de | 0)]) {
                                                if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, be)
                                                  continue;
                                                break t;
                                              }
                                              break;
                                            }
                                            j[0 | be] = 1;
                                          } else
                                            j[0 | Ue] = be, j[0 | Ne] = 0;
                                      if (!(le >>> 0 > 249) && (le = j[0 | (Te = (de = le + 6 | 0) + (q + 2016 | 0) | 0)]))
                                        if ((0 | (le = (Ye = le << 6) + (be = j[0 | Ue]) | 0)) >= 16) {
                                          if ((0 | (le = be - Ye | 0)) < -15)
                                            break e;
                                          for (j[0 | Ue] = le; ; ) {
                                            if (B[0 | (le = (q + 2016 | 0) + de | 0)]) {
                                              if (j[0 | le] = 0, le = de >>> 0 < 255, de = de + 1 | 0, le)
                                                continue;
                                              break e;
                                            }
                                            break;
                                          }
                                          j[0 | le] = 1;
                                        } else
                                          j[0 | Ue] = le, j[0 | Te] = 0;
                                    }
                                  }
                                }
                              }
                            }
                          if ((0 | Z) == 256)
                            break;
                        }
                        for (de = 0; le = xt + (de >>> 3 | 0) | 0, j[(Z = q + 1760 | 0) + de | 0] = B[0 | le] >>> (6 & de) & 1, j[(be = Z) + (Z = 1 | de) | 0] = B[0 | le] >>> (7 & Z) & 1, (0 | (de = de + 2 | 0)) != 256; )
                          ;
                        for (Z = 0; ; ) {
                          Z = (le = Z) + 1 | 0;
                          e:
                            if (!(!B[0 | (Ue = le + (q + 1760 | 0) | 0)] | le >>> 0 > 254)) {
                              t:
                                if (de = j[0 | (Te = (q + 1760 | 0) + Z | 0)])
                                  if ((0 | (de = (Ye = de << 1) + (be = j[0 | Ue]) | 0)) <= 15)
                                    j[0 | Ue] = de, j[0 | Te] = 0;
                                  else {
                                    if ((0 | (de = be - Ye | 0)) < -15)
                                      break e;
                                    for (j[0 | Ue] = de, de = Z; ; ) {
                                      if (!B[0 | (be = (q + 1760 | 0) + de | 0)]) {
                                        j[0 | be] = 1;
                                        break t;
                                      }
                                      if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, !be)
                                        break;
                                    }
                                  }
                              if (!(le >>> 0 > 253)) {
                                t:
                                  if (be = j[0 | (Ne = (de = le + 2 | 0) + (q + 1760 | 0) | 0)])
                                    if ((0 | (be = (Te = be << 2) + (Ye = j[0 | Ue]) | 0)) >= 16) {
                                      if ((0 | (be = Ye - Te | 0)) < -15)
                                        break e;
                                      for (j[0 | Ue] = be; ; ) {
                                        if (B[0 | (be = (q + 1760 | 0) + de | 0)]) {
                                          if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, be)
                                            continue;
                                          break t;
                                        }
                                        break;
                                      }
                                      j[0 | be] = 1;
                                    } else
                                      j[0 | Ue] = be, j[0 | Ne] = 0;
                                if (!(le >>> 0 > 252)) {
                                  t:
                                    if (be = j[0 | (Ne = (de = le + 3 | 0) + (q + 1760 | 0) | 0)])
                                      if ((0 | (be = (Te = be << 3) + (Ye = j[0 | Ue]) | 0)) >= 16) {
                                        if ((0 | (be = Ye - Te | 0)) < -15)
                                          break e;
                                        for (j[0 | Ue] = be; ; ) {
                                          if (B[0 | (be = (q + 1760 | 0) + de | 0)]) {
                                            if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, be)
                                              continue;
                                            break t;
                                          }
                                          break;
                                        }
                                        j[0 | be] = 1;
                                      } else
                                        j[0 | Ue] = be, j[0 | Ne] = 0;
                                  if (!(le >>> 0 > 251)) {
                                    t:
                                      if (be = j[0 | (Ne = (de = le + 4 | 0) + (q + 1760 | 0) | 0)])
                                        if ((0 | (be = (Te = be << 4) + (Ye = j[0 | Ue]) | 0)) >= 16) {
                                          if ((0 | (be = Ye - Te | 0)) < -15)
                                            break e;
                                          for (j[0 | Ue] = be; ; ) {
                                            if (B[0 | (be = (q + 1760 | 0) + de | 0)]) {
                                              if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, be)
                                                continue;
                                              break t;
                                            }
                                            break;
                                          }
                                          j[0 | be] = 1;
                                        } else
                                          j[0 | Ue] = be, j[0 | Ne] = 0;
                                    if (!(le >>> 0 > 250)) {
                                      t:
                                        if (be = j[0 | (Ne = (de = le + 5 | 0) + (q + 1760 | 0) | 0)])
                                          if ((0 | (be = (Te = be << 5) + (Ye = j[0 | Ue]) | 0)) >= 16) {
                                            if ((0 | (be = Ye - Te | 0)) < -15)
                                              break e;
                                            for (j[0 | Ue] = be; ; ) {
                                              if (B[0 | (be = (q + 1760 | 0) + de | 0)]) {
                                                if (j[0 | be] = 0, be = de >>> 0 < 255, de = de + 1 | 0, be)
                                                  continue;
                                                break t;
                                              }
                                              break;
                                            }
                                            j[0 | be] = 1;
                                          } else
                                            j[0 | Ue] = be, j[0 | Ne] = 0;
                                      if (!(le >>> 0 > 249) && (le = j[0 | (Te = (de = le + 6 | 0) + (q + 1760 | 0) | 0)]))
                                        if ((0 | (le = (Ye = le << 6) + (be = j[0 | Ue]) | 0)) >= 16) {
                                          if ((0 | (le = be - Ye | 0)) < -15)
                                            break e;
                                          for (j[0 | Ue] = le; ; ) {
                                            if (B[0 | (le = (q + 1760 | 0) + de | 0)]) {
                                              if (j[0 | le] = 0, le = de >>> 0 < 255, de = de + 1 | 0, le)
                                                continue;
                                              break e;
                                            }
                                            break;
                                          }
                                          j[0 | le] = 1;
                                        } else
                                          j[0 | Ue] = le, j[0 | Te] = 0;
                                    }
                                  }
                                }
                              }
                            }
                          if ((0 | Z) == 256)
                            break;
                        }
                        for (qi(tt = q + 480 | 0, ae), _t = l[ae + 8 >> 2], Ue = l[ae + 12 >> 2], Ne = l[ae + 16 >> 2], Te = l[ae + 20 >> 2], Ye = l[ae + 24 >> 2], be = l[ae + 28 >> 2], de = l[ae >> 2], le = l[ae + 4 >> 2], Z = l[ae + 36 >> 2], l[q + 192 >> 2] = l[ae + 32 >> 2], l[q + 196 >> 2] = Z, l[q + 184 >> 2] = Ye, l[q + 188 >> 2] = be, l[q + 176 >> 2] = Ne, l[q + 180 >> 2] = Te, l[q + 168 >> 2] = _t, l[q + 172 >> 2] = Ue, l[q + 160 >> 2] = de, l[q + 164 >> 2] = le, _t = l[ae + 40 >> 2], Ue = l[ae + 44 >> 2], Ne = l[ae + 48 >> 2], Te = l[ae + 52 >> 2], Ye = l[ae + 56 >> 2], be = l[ae + 60 >> 2], de = l[(Z = ae - -64 | 0) >> 2], le = l[Z + 4 >> 2], Z = l[ae + 76 >> 2], l[q + 232 >> 2] = l[ae + 72 >> 2], l[q + 236 >> 2] = Z, l[q + 224 >> 2] = de, l[q + 228 >> 2] = le, l[q + 216 >> 2] = Ye, l[q + 220 >> 2] = be, l[q + 208 >> 2] = Ne, l[q + 212 >> 2] = Te, l[q + 200 >> 2] = _t, l[q + 204 >> 2] = Ue, _t = l[ae + 80 >> 2], Ue = l[ae + 84 >> 2], Ne = l[ae + 88 >> 2], Te = l[ae + 92 >> 2], Ye = l[ae + 96 >> 2], be = l[ae + 100 >> 2], de = l[ae + 104 >> 2], le = l[ae + 108 >> 2], Z = l[ae + 116 >> 2], l[q + 272 >> 2] = l[ae + 112 >> 2], l[q + 276 >> 2] = Z, l[q + 264 >> 2] = de, l[q + 268 >> 2] = le, l[q + 256 >> 2] = Ye, l[q + 260 >> 2] = be, l[q + 248 >> 2] = Ne, l[q + 252 >> 2] = Te, l[q + 240 >> 2] = _t, l[q + 244 >> 2] = Ue, Vi(ae = q + 320 | 0, le = q + 160 | 0), rr(q, ae, We = q + 440 | 0), rr(q + 40 | 0, rt = q + 360 | 0, ot = q + 400 | 0), rr(q + 80 | 0, ot, We), rr(q + 120 | 0, ae, rt), Ot(ae, q, tt), rr(le, ae, We), rr(un = q + 200 | 0, rt, ot), rr(gn = q + 240 | 0, ot, We), rr(Vt = q + 280 | 0, ae, rt), qi(Z = q + 640 | 0, le), Ot(ae, q, Z), rr(le, ae, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), qi(Z = q + 800 | 0, le), Ot(ae, q, Z), rr(le, ae, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), qi(Z = q + 960 | 0, le), Ot(ae, q, Z), rr(le, ae, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), qi(Z = q + 1120 | 0, le), Ot(ae, q, Z), rr(le, ae, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), qi(Z = q + 1280 | 0, le), Ot(ae, q, Z), rr(le, ae, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), qi(Z = q + 1440 | 0, le), Ot(ae, q, Z), rr(le, ae, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), qi(q + 1600 | 0, le), l[Ie + 32 >> 2] = 0, l[Ie + 36 >> 2] = 0, l[Ie + 24 >> 2] = 0, l[Ie + 28 >> 2] = 0, l[Ie + 16 >> 2] = 0, l[Ie + 20 >> 2] = 0, l[Ie + 8 >> 2] = 0, l[Ie + 12 >> 2] = 0, l[Ie >> 2] = 0, l[Ie + 4 >> 2] = 0, l[Ie + 44 >> 2] = 0, l[Ie + 48 >> 2] = 0, l[(Xn = Ie + 40 | 0) >> 2] = 1, l[Ie + 52 >> 2] = 0, l[Ie + 56 >> 2] = 0, l[Ie + 60 >> 2] = 0, l[Ie + 64 >> 2] = 0, l[Ie + 68 >> 2] = 0, l[Ie + 72 >> 2] = 0, l[Ie + 84 >> 2] = 0, l[Ie + 88 >> 2] = 0, l[Ie + 76 >> 2] = 0, l[Ie + 80 >> 2] = 1, l[Ie + 92 >> 2] = 0, l[Ie + 96 >> 2] = 0, l[Ie + 100 >> 2] = 0, l[Ie + 104 >> 2] = 0, l[Ie + 108 >> 2] = 0, l[Ie + 112 >> 2] = 0, l[Ie + 116 >> 2] = 0, br = Ie + 80 | 0, Z = 255; ; ) {
                          e: {
                            t: {
                              if (!(B[(q + 2016 | 0) + Z | 0] | B[(q + 1760 | 0) + Z | 0])) {
                                if (!(B[(le = Z - 1 | 0) + (q + 2016 | 0) | 0] | B[le + (q + 1760 | 0) | 0]))
                                  break t;
                                Z = le;
                              }
                              if ((0 | Z) < 0)
                                break e;
                              for (; Vi(q + 320 | 0, Ie), (0 | (de = j[(le = Z) + (q + 2016 | 0) | 0])) > 0 ? (rr(Z = q + 160 | 0, ae = q + 320 | 0, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), Ot(ae, Z, (q + 480 | 0) + wr((254 & de) >>> 1 | 0, 160) | 0)) : (0 | de) >= 0 || (rr(Z = q + 160 | 0, ae = q + 320 | 0, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), Ia(ae, Z, (q + 480 | 0) + wr((0 - de & 254) >>> 1 | 0, 160) | 0)), (0 | (De = j[le + (q + 1760 | 0) | 0])) > 0 ? (rr(Z = q + 160 | 0, ae = q + 320 | 0, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, ae, rt), js(ae, Z, wr((254 & De) >>> 1 | 0, 120) + 1488 | 0)) : (0 | De) >= 0 || (rr(q + 160 | 0, Vn = q + 320 | 0, We), rr(un, rt, ot), rr(gn, ot, We), rr(Vt, Vn, rt), Bn = l[q + 160 >> 2], Tn = l[q + 200 >> 2], Pt = l[q + 164 >> 2], Dt = l[q + 204 >> 2], An = l[q + 168 >> 2], kn = l[q + 208 >> 2], Dn = l[q + 172 >> 2], qt = l[q + 212 >> 2], xt = l[q + 176 >> 2], Mt = l[q + 216 >> 2], tt = l[q + 180 >> 2], _t = l[q + 220 >> 2], Ue = l[q + 184 >> 2], Ne = l[q + 224 >> 2], Te = l[q + 188 >> 2], Ye = l[q + 228 >> 2], be = l[q + 192 >> 2], de = l[q + 232 >> 2], ae = l[q + 236 >> 2], Z = l[q + 196 >> 2], l[q + 396 >> 2] = ae - Z, l[q + 392 >> 2] = de - be, l[q + 388 >> 2] = Ye - Te, l[q + 384 >> 2] = Ne - Ue, l[q + 380 >> 2] = _t - tt, l[q + 376 >> 2] = Mt - xt, l[q + 372 >> 2] = qt - Dn, l[q + 368 >> 2] = kn - An, l[q + 364 >> 2] = Dt - Pt, l[q + 360 >> 2] = Tn - Bn, l[q + 356 >> 2] = Z + ae, l[q + 352 >> 2] = de + be, l[q + 348 >> 2] = Ye + Te, l[q + 344 >> 2] = Ue + Ne, l[q + 340 >> 2] = _t + tt, l[q + 336 >> 2] = xt + Mt, l[q + 332 >> 2] = qt + Dn, l[q + 328 >> 2] = An + kn, l[q + 324 >> 2] = Pt + Dt, l[q + 320 >> 2] = Bn + Tn, rr(ot, Vn, 40 + (Z = wr((0 - De & 254) >>> 1 | 0, 120) + 1488 | 0) | 0), rr(rt, rt, Z), rr(We, Z + 80 | 0, Vt), kr = l[q + 276 >> 2], Qr = l[q + 272 >> 2], De = l[q + 268 >> 2], Vn = l[q + 264 >> 2], Ue = l[q + 260 >> 2], Ne = l[q + 256 >> 2], Te = l[q + 252 >> 2], Ye = l[q + 248 >> 2], be = l[q + 244 >> 2], de = l[q + 240 >> 2], nr = l[q + 360 >> 2], nn = l[q + 400 >> 2], vn = l[q + 364 >> 2], zn = l[q + 404 >> 2], jn = l[q + 368 >> 2], _r = l[q + 408 >> 2], Bn = l[q + 372 >> 2], Tn = l[q + 412 >> 2], Pt = l[q + 376 >> 2], Dt = l[q + 416 >> 2], An = l[q + 380 >> 2], kn = l[q + 420 >> 2], Dn = l[q + 384 >> 2], qt = l[q + 424 >> 2], xt = l[q + 388 >> 2], Mt = l[q + 428 >> 2], tt = l[q + 392 >> 2], _t = l[q + 432 >> 2], ae = l[q + 396 >> 2], Z = l[q + 436 >> 2], l[q + 396 >> 2] = ae + Z, l[q + 392 >> 2] = _t + tt, l[q + 388 >> 2] = xt + Mt, l[q + 384 >> 2] = qt + Dn, l[q + 380 >> 2] = An + kn, l[q + 376 >> 2] = Pt + Dt, l[q + 372 >> 2] = Bn + Tn, l[q + 368 >> 2] = jn + _r, l[q + 364 >> 2] = vn + zn, l[q + 360 >> 2] = nr + nn, l[q + 356 >> 2] = Z - ae, l[q + 352 >> 2] = _t - tt, l[q + 348 >> 2] = Mt - xt, l[q + 344 >> 2] = qt - Dn, l[q + 340 >> 2] = kn - An, l[q + 336 >> 2] = Dt - Pt, l[q + 332 >> 2] = Tn - Bn, l[q + 328 >> 2] = _r - jn, l[q + 324 >> 2] = zn - vn, l[q + 320 >> 2] = nn - nr, Bn = de << 1, Tn = l[q + 440 >> 2], l[q + 400 >> 2] = Bn - Tn, Pt = be << 1, Dt = l[q + 444 >> 2], l[q + 404 >> 2] = Pt - Dt, An = Ye << 1, kn = l[q + 448 >> 2], l[q + 408 >> 2] = An - kn, Dn = Te << 1, qt = l[q + 452 >> 2], l[q + 412 >> 2] = Dn - qt, xt = Ne << 1, Mt = l[q + 456 >> 2], l[q + 416 >> 2] = xt - Mt, tt = Ue << 1, _t = l[q + 460 >> 2], l[q + 420 >> 2] = tt - _t, Ue = Vn << 1, Ne = l[q + 464 >> 2], l[q + 424 >> 2] = Ue - Ne, Te = De << 1, Ye = l[q + 468 >> 2], l[q + 428 >> 2] = Te - Ye, be = Qr << 1, de = l[q + 472 >> 2], l[q + 432 >> 2] = be - de, ae = kr << 1, Z = l[q + 476 >> 2], l[q + 436 >> 2] = ae - Z, l[q + 440 >> 2] = Bn + Tn, l[q + 444 >> 2] = Pt + Dt, l[q + 448 >> 2] = An + kn, l[q + 452 >> 2] = qt + Dn, l[q + 456 >> 2] = xt + Mt, l[q + 460 >> 2] = _t + tt, l[q + 464 >> 2] = Ue + Ne, l[q + 468 >> 2] = Ye + Te, l[q + 472 >> 2] = de + be, l[q + 476 >> 2] = Z + ae), rr(Ie, q + 320 | 0, We), rr(Xn, rt, ot), rr(br, ot, We), Z = le - 1 | 0, (0 | le) > 0; )
                                ;
                              break e;
                            }
                            if (Z = Z - 2 | 0, le)
                              continue;
                          }
                          break;
                        }
                        st = q + 2272 | 0, Ce(Z = Qe + 288 | 0, Ie), Ur = -1, Lr = Cs(Z, L), tt = ((0 | L) == (0 | Z) ? Ur : Lr) | gs(L, Z, 32);
                      }
                      return st = Qe + 592 | 0, tt;
                    }
                    function rr(L, Z, le) {
                      var ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt, ot, _t, qt, tt, xt, Mt, Vt, un, gn, Bn, Tn, Pt, Dt, An, kn, Dn, De, Vn, Xn, nr, nn, vn, zn, jn, _r, br, kr, Qr, Ur, Lr, Jr, jr, oo, uo, _o, So, Ao, bo, xr, Oo, Yn, ir, Bt = 0, Jt = 0, mn = 0, Hr = 0, Vr = 0, ro = 0, io = 0, fo = 0, po = 0, mo = 0, ho = 0, tn = 0, Eo = 0, To = 0, Do = 0, Lo = 0, Ho = 0, Vo = 0, ri = 0, ci = 0, li = 0, mi = 0, yi = 0, Mi = 0;
                      Bt = dt(ae = l[le + 4 >> 2], Ne = ae >> 31, Ho = (tt = l[Z + 20 >> 2]) << 1, Xn = Ho >> 31), mn = Oe, Jt = (Eo = dt(Do = l[le >> 2], Ie = Do >> 31, de = l[Z + 24 >> 2], Qe = de >> 31)) + Bt | 0, Bt = Oe + mn | 0, Bt = Jt >>> 0 < Eo >>> 0 ? Bt + 1 | 0 : Bt, po = dt(q = l[le + 8 >> 2], ot = q >> 31, Eo = l[Z + 16 >> 2], be = Eo >> 31), mn = Oe + Bt | 0, mn = (Jt = po + Jt | 0) >>> 0 < po >>> 0 ? mn + 1 | 0 : mn, Bt = (po = dt(We = l[le + 12 >> 2], xt = We >> 31, Pt = (Mt = l[Z + 12 >> 2]) << 1, nr = Pt >> 31)) + Jt | 0, Jt = Oe + mn | 0, Jt = Bt >>> 0 < po >>> 0 ? Jt + 1 | 0 : Jt, mn = (To = dt(_t = l[le + 16 >> 2], Dt = _t >> 31, po = l[Z + 8 >> 2], Ue = po >> 31)) + Bt | 0, Bt = Oe + Jt | 0, Bt = mn >>> 0 < To >>> 0 ? Bt + 1 | 0 : Bt, Jt = mn, mn = dt(Vt = l[le + 20 >> 2], nn = Vt >> 31, An = (un = l[Z + 4 >> 2]) << 1, vn = An >> 31), Bt = Oe + Bt | 0, Bt = (Jt = Jt + mn | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, uo = fo = l[le + 24 >> 2], mn = (mo = dt(fo, jr = fo >> 31, To = l[Z >> 2], Ye = To >> 31)) + Jt | 0, Jt = Oe + Bt | 0, Jt = mn >>> 0 < mo >>> 0 ? Jt + 1 | 0 : Jt, zn = l[le + 28 >> 2], Bt = (mo = dt(tn = wr(zn, 19), gn = tn >> 31, kn = (Bn = l[Z + 36 >> 2]) << 1, jn = kn >> 31)) + mn | 0, mn = Oe + Jt | 0, mn = Bt >>> 0 < mo >>> 0 ? mn + 1 | 0 : mn, So = l[le + 32 >> 2], Jt = (io = dt(Hr = wr(So, 19), qt = Hr >> 31, mo = l[Z + 32 >> 2], Te = mo >> 31)) + Bt | 0, Bt = Oe + mn | 0, Bt = Jt >>> 0 < io >>> 0 ? Bt + 1 | 0 : Bt, _o = l[le + 36 >> 2], le = dt(io = wr(_o, 19), rt = io >> 31, Dn = (Tn = l[Z + 28 >> 2]) << 1, _r = Dn >> 31), Bt = Oe + Bt | 0, Vr = Z = le + Jt | 0, le = Z >>> 0 < le >>> 0 ? Bt + 1 | 0 : Bt, Z = dt(Eo, be, ae, Ne), Bt = Oe, Jt = dt(Do, Ie, tt, br = tt >> 31), mn = Oe + Bt | 0, mn = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? mn + 1 | 0 : mn, Bt = dt(q, ot, Mt, kr = Mt >> 31), Jt = Oe + mn | 0, Jt = (Z = Bt + Z | 0) >>> 0 < Bt >>> 0 ? Jt + 1 | 0 : Jt, mn = dt(po, Ue, We, xt), Bt = Oe + Jt | 0, Bt = (Z = mn + Z | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(_t, Dt, un, Qr = un >> 31), Bt = Oe + Bt | 0, Bt = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(To, Ye, Vt, nn), Bt = Oe + Bt | 0, Bt = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(fo = wr(fo, 19), De = fo >> 31, Bn, Ur = Bn >> 31), mn = Oe + Bt | 0, mn = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? mn + 1 | 0 : mn, Bt = dt(mo, Te, tn, gn), Jt = Oe + mn | 0, Jt = (Z = Bt + Z | 0) >>> 0 < Bt >>> 0 ? Jt + 1 | 0 : Jt, mn = dt(Hr, qt, Tn, Lr = Tn >> 31), Bt = Oe + Jt | 0, Bt = (Z = mn + Z | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(io, rt, de, Qe), Bt = Oe + Bt | 0, mi = Z = Jt + Z | 0, ri = Z >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Z = dt(ae, Ne, Pt, nr), Bt = Oe, Jt = dt(Do, Ie, Eo, be), Bt = Oe + Bt | 0, Bt = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(po, Ue, q, ot), mn = Oe + Bt | 0, mn = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? mn + 1 | 0 : mn, Bt = dt(We, xt, An, vn), Jt = Oe + mn | 0, Jt = (Z = Bt + Z | 0) >>> 0 < Bt >>> 0 ? Jt + 1 | 0 : Jt, mn = dt(To, Ye, _t, Dt), Bt = Oe + Jt | 0, Bt = (Z = mn + Z | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(Vn = wr(Vt, 19), Jr = Vn >> 31, kn, jn), Bt = Oe + Bt | 0, Bt = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(mo, Te, fo, De), Bt = Oe + Bt | 0, Bt = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(tn, gn, Dn, _r), mn = Oe + Bt | 0, mn = (Z = Jt + Z | 0) >>> 0 < Jt >>> 0 ? mn + 1 | 0 : mn, Bt = dt(Hr, qt, de, Qe), Jt = Oe + mn | 0, Jt = (Z = Bt + Z | 0) >>> 0 < Bt >>> 0 ? Jt + 1 | 0 : Jt, mn = dt(io, rt, Ho, Xn), Bt = Oe + Jt | 0, Ao = Z = mn + Z | 0, bo = Bt = Z >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, xr = Z = Z + 33554432 | 0, Oo = Bt = Z >>> 0 < 33554432 ? Bt + 1 | 0 : Bt, mn = (67108863 & Bt) << 6 | Z >>> 26, Bt = (Bt >> 26) + ri | 0, mi = Z = mn + mi | 0, Bt = Z >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Yn = Z = Z + 16777216 | 0, Bt = le + (Jt = (mn = Z >>> 0 < 16777216 ? Bt + 1 | 0 : Bt) >> 25) | 0, Bt = (Z = (mn = (33554431 & mn) << 7 | Z >>> 25) + Vr | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Vo = le = (Jt = Z) + 33554432 | 0, Z = Bt = le >>> 0 < 33554432 ? Bt + 1 | 0 : Bt, l[L + 24 >> 2] = Jt - (-67108864 & le), le = dt(ae, Ne, An, vn), Bt = Oe, Jt = dt(Do, Ie, po, Ue), mn = Oe + Bt | 0, mn = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? mn + 1 | 0 : mn, Jt = (Bt = le) + (le = dt(To, Ye, q, ot)) | 0, Bt = Oe + mn | 0, Bt = le >>> 0 > Jt >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(le = wr(We, 19), ci = le >> 31, kn, jn), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, mn = (Vr = dt(mo, Te, ri = wr(_t, 19), oo = ri >> 31)) + Jt | 0, Jt = Oe + Bt | 0, Jt = mn >>> 0 < Vr >>> 0 ? Jt + 1 | 0 : Jt, Vr = dt(Dn, _r, Vn, Jr), Bt = Oe + Jt | 0, Bt = (mn = Vr + mn | 0) >>> 0 < Vr >>> 0 ? Bt + 1 | 0 : Bt, Jt = (Vr = dt(de, Qe, fo, De)) + mn | 0, mn = Oe + Bt | 0, mn = Jt >>> 0 < Vr >>> 0 ? mn + 1 | 0 : mn, Vr = dt(tn, gn, Ho, Xn), Bt = Oe + mn | 0, Bt = (Jt = Vr + Jt | 0) >>> 0 < Vr >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(Hr, qt, Eo, be), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, mn = (Vr = dt(io, rt, Pt, nr)) + Jt | 0, Jt = Oe + Bt | 0, ho = mn, yi = mn >>> 0 < Vr >>> 0 ? Jt + 1 | 0 : Jt, Bt = dt(To, Ye, ae, Ne), Jt = Oe, mn = (Vr = dt(Do, Ie, un, Qr)) + Bt | 0, Bt = Oe + Jt | 0, Bt = mn >>> 0 < Vr >>> 0 ? Bt + 1 | 0 : Bt, Vr = Jt = wr(q, 19), Jt = (ro = dt(Jt, li = Jt >> 31, Bn, Ur)) + mn | 0, mn = Oe + Bt | 0, mn = Jt >>> 0 < ro >>> 0 ? mn + 1 | 0 : mn, ro = dt(mo, Te, le, ci), Bt = Oe + mn | 0, Bt = (Jt = ro + Jt | 0) >>> 0 < ro >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(ri, oo, Tn, Lr), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, mn = (ro = dt(de, Qe, Vn, Jr)) + Jt | 0, Jt = Oe + Bt | 0, Jt = mn >>> 0 < ro >>> 0 ? Jt + 1 | 0 : Jt, ro = dt(fo, De, tt, br), Bt = Oe + Jt | 0, Bt = (mn = ro + mn | 0) >>> 0 < ro >>> 0 ? Bt + 1 | 0 : Bt, Jt = (ro = dt(Eo, be, tn, gn)) + mn | 0, mn = Oe + Bt | 0, mn = Jt >>> 0 < ro >>> 0 ? mn + 1 | 0 : mn, ro = dt(Hr, qt, Mt, kr), Bt = Oe + mn | 0, Bt = (Jt = ro + Jt | 0) >>> 0 < ro >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(io, rt, po, Ue), Bt = Oe + Bt | 0, Mi = Jt = mn + Jt | 0, ro = Jt >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Bt = dt(Bt = wr(ae, 19), Bt >> 31, kn, jn), Jt = Oe, mn = dt(Do, Ie, To, Ye), Jt = Oe + Jt | 0, Jt = (Bt = mn + Bt | 0) >>> 0 < mn >>> 0 ? Jt + 1 | 0 : Jt, mn = (Vr = dt(mo, Te, Vr, li)) + Bt | 0, Bt = Oe + Jt | 0, le = (Jt = dt(le, ci, Dn, _r)) + mn | 0, mn = Oe + (mn >>> 0 < Vr >>> 0 ? Bt + 1 | 0 : Bt) | 0, mn = le >>> 0 < Jt >>> 0 ? mn + 1 | 0 : mn, Jt = dt(de, Qe, ri, oo), Bt = Oe + mn | 0, Bt = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(Ho, Xn, Vn, Jr), Bt = Oe + Bt | 0, Bt = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(Eo, be, fo, De), Jt = Oe + Bt | 0, Jt = (le = mn + le | 0) >>> 0 < mn >>> 0 ? Jt + 1 | 0 : Jt, mn = dt(tn, gn, Pt, nr), Bt = Oe + Jt | 0, Bt = (le = mn + le | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(Hr, qt, po, Ue), mn = Oe + Bt | 0, mn = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? mn + 1 | 0 : mn, Jt = dt(io, rt, An, vn), Bt = Oe + mn | 0, Vr = le = Jt + le | 0, ci = Bt = le >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, li = le = le + 33554432 | 0, ir = Bt = le >>> 0 < 33554432 ? Bt + 1 | 0 : Bt, Jt = (mn = Bt >> 26) + ro | 0, ro = le = (Bt = (67108863 & Bt) << 6 | le >>> 26) + Mi | 0, Bt = Jt = le >>> 0 < Bt >>> 0 ? Jt + 1 | 0 : Jt, Mi = le = le + 16777216 | 0, Jt = (33554431 & (Bt = le >>> 0 < 16777216 ? Bt + 1 | 0 : Bt)) << 7 | le >>> 25, Bt = (Bt >> 25) + yi | 0, Bt = (le = Jt + ho | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, yi = Jt = (mn = le) + 33554432 | 0, le = Bt = Jt >>> 0 < 33554432 ? Bt + 1 | 0 : Bt, l[L + 8 >> 2] = mn - (-67108864 & Jt), Bt = dt(de, Qe, ae, Ne), mn = Oe, Jt = (ho = dt(Do, Ie, Tn, Lr)) + Bt | 0, Bt = Oe + mn | 0, Bt = Jt >>> 0 < ho >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(q, ot, tt, br), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(Eo, be, We, xt), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, ho = dt(_t, Dt, Mt, kr), mn = Oe + Bt | 0, mn = (Jt = ho + Jt | 0) >>> 0 < ho >>> 0 ? mn + 1 | 0 : mn, Bt = (ho = dt(po, Ue, Vt, nn)) + Jt | 0, Jt = Oe + mn | 0, Jt = Bt >>> 0 < ho >>> 0 ? Jt + 1 | 0 : Jt, mn = (ho = dt(un, Qr, uo, jr)) + Bt | 0, Bt = Oe + Jt | 0, Bt = mn >>> 0 < ho >>> 0 ? Bt + 1 | 0 : Bt, Jt = mn, mn = dt(To, Ye, zn, ho = zn >> 31), Bt = Oe + Bt | 0, Bt = (Jt = Jt + mn | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(Hr, qt, Bn, Ur), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Lo = dt(io, rt, mo, Te), mn = Oe + Bt | 0, Bt = Z >> 26, Z = (Vo = (67108863 & Z) << 6 | Vo >>> 26) + (Jt = Lo + Jt | 0) | 0, Jt = Bt + (Jt >>> 0 < Lo >>> 0 ? mn + 1 | 0 : mn) | 0, Bt = (mn = Z) >>> 0 < Vo >>> 0 ? Jt + 1 | 0 : Jt, Vo = Jt = mn + 16777216 | 0, Z = Bt = Jt >>> 0 < 16777216 ? Bt + 1 | 0 : Bt, l[L + 28 >> 2] = mn - (-33554432 & Jt), Bt = dt(po, Ue, ae, Ne), Jt = Oe, Lo = dt(Do, Ie, Mt, kr), mn = Oe + Jt | 0, mn = (Bt = Lo + Bt | 0) >>> 0 < Lo >>> 0 ? mn + 1 | 0 : mn, Lo = dt(q, ot, un, Qr), Jt = Oe + mn | 0, Jt = (Bt = Lo + Bt | 0) >>> 0 < Lo >>> 0 ? Jt + 1 | 0 : Jt, mn = (Lo = dt(To, Ye, We, xt)) + Bt | 0, Bt = Oe + Jt | 0, Bt = mn >>> 0 < Lo >>> 0 ? Bt + 1 | 0 : Bt, Jt = mn, mn = dt(ri, oo, Bn, Ur), Bt = Oe + Bt | 0, Bt = (Jt = Jt + mn | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(mo, Te, Vn, Jr), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Jt = (fo = dt(fo, De, Tn, Lr)) + Jt | 0, mn = Oe + Bt | 0, Bt = (tn = dt(de, Qe, tn, gn)) + Jt | 0, Jt = Oe + (Jt >>> 0 < fo >>> 0 ? mn + 1 | 0 : mn) | 0, mn = (Hr = dt(Hr, qt, tt, br)) + Bt | 0, Bt = Oe + (Bt >>> 0 < tn >>> 0 ? Jt + 1 | 0 : Jt) | 0, Bt = mn >>> 0 < Hr >>> 0 ? Bt + 1 | 0 : Bt, Jt = mn, mn = dt(io, rt, Eo, be), Bt = Oe + Bt | 0, Hr = Jt = Jt + mn | 0, Bt = (Bt = Jt >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt) + (Jt = le >> 26) | 0, mn = (Jt = le = Hr + (mn = (67108863 & le) << 6 | yi >>> 26) | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, tn = Bt = Jt + 16777216 | 0, le = mn = Bt >>> 0 < 16777216 ? mn + 1 | 0 : mn, l[L + 12 >> 2] = Jt - (-33554432 & Bt), Bt = dt(ae, Ne, Dn, _r), mn = Oe, Jt = (Hr = dt(Do, Ie, mo, Te)) + Bt | 0, Bt = Oe + mn | 0, Bt = Jt >>> 0 < Hr >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(de, Qe, q, ot), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Hr = dt(We, xt, Ho, Xn), mn = Oe + Bt | 0, mn = (Jt = Hr + Jt | 0) >>> 0 < Hr >>> 0 ? mn + 1 | 0 : mn, Bt = (Hr = dt(Eo, be, _t, Dt)) + Jt | 0, Jt = Oe + mn | 0, Jt = Bt >>> 0 < Hr >>> 0 ? Jt + 1 | 0 : Jt, mn = (Hr = dt(Pt, nr, Vt, nn)) + Bt | 0, Bt = Oe + Jt | 0, Bt = mn >>> 0 < Hr >>> 0 ? Bt + 1 | 0 : Bt, Jt = mn, mn = dt(po, Ue, uo, jr), Bt = Oe + Bt | 0, Bt = (Jt = Jt + mn | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(zn, ho, An, vn), Bt = Oe + Bt | 0, Bt = (Jt = mn + Jt | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, Jt = (Ho = dt(To, Ye, Hr = So, fo = Hr >> 31)) + Jt | 0, mn = Oe + Bt | 0, Bt = (io = dt(io, rt, kn, jn)) + Jt | 0, Jt = Oe + (Jt >>> 0 < Ho >>> 0 ? mn + 1 | 0 : mn) | 0, Jt = Bt >>> 0 < io >>> 0 ? Jt + 1 | 0 : Jt, io = Bt, Bt = (Bt = Z >> 25) + Jt | 0, Bt = (Z = io + (mn = (33554431 & Z) << 7 | Vo >>> 25) | 0) >>> 0 < mn >>> 0 ? Bt + 1 | 0 : Bt, io = Jt = (mn = Z) + 33554432 | 0, Z = Bt = Jt >>> 0 < 33554432 ? Bt + 1 | 0 : Bt, l[L + 32 >> 2] = mn - (-67108864 & Jt), Jt = le >> 25, le = (tn = (33554431 & le) << 7 | tn >>> 25) + (Ao - (Bt = -67108864 & xr) | 0) | 0, Bt = Jt + (bo - ((Bt >>> 0 > Ao >>> 0) + Oo | 0) | 0) | 0, Bt = le >>> 0 < tn >>> 0 ? Bt + 1 | 0 : Bt, Vo = Bt = (67108863 & (Bt = (le = (Jt = le) + 33554432 | 0) >>> 0 < 33554432 ? Bt + 1 | 0 : Bt)) << 6 | le >>> 26, Bt = Bt + (mn = mi - (-33554432 & Yn) | 0) | 0, l[L + 20 >> 2] = Bt, l[L + 16 >> 2] = Jt - (-67108864 & le), le = dt(mo, Te, ae, Ne), Bt = Oe, Jt = dt(Do, Ie, Bn, Ur), Bt = Oe + Bt | 0, Bt = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(q, ot, Tn, Lr), Jt = Oe + Bt | 0, Jt = (le = mn + le | 0) >>> 0 < mn >>> 0 ? Jt + 1 | 0 : Jt, Bt = dt(de, Qe, We, xt), mn = Oe + Jt | 0, mn = (le = Bt + le | 0) >>> 0 < Bt >>> 0 ? mn + 1 | 0 : mn, Jt = dt(_t, Dt, tt, br), Bt = Oe + mn | 0, Bt = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(Eo, be, Vt, nn), Bt = Oe + Bt | 0, Bt = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, Jt = dt(Mt, kr, uo, jr), Bt = Oe + Bt | 0, Bt = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt, mn = dt(po, Ue, zn, ho), Jt = Oe + Bt | 0, Jt = (le = mn + le | 0) >>> 0 < mn >>> 0 ? Jt + 1 | 0 : Jt, Bt = dt(Hr, fo, un, Qr), mn = Oe + Jt | 0, mn = (le = Bt + le | 0) >>> 0 < Bt >>> 0 ? mn + 1 | 0 : mn, Jt = dt(To, Ye, _o, _o >> 31), Bt = Oe + mn | 0, Bt = (Bt = (le = Jt + le | 0) >>> 0 < Jt >>> 0 ? Bt + 1 | 0 : Bt) + (Jt = Z >> 26) | 0, Bt = (Z = (mn = le) + (le = (67108863 & Z) << 6 | io >>> 26) | 0) >>> 0 < le >>> 0 ? Bt + 1 | 0 : Bt, Bt = (Z = (le = Z) + 16777216 | 0) >>> 0 < 16777216 ? Bt + 1 | 0 : Bt, l[L + 36 >> 2] = le - (-33554432 & Z), mn = ro - (-33554432 & Mi) | 0, Jt = Vr - (le = -67108864 & li) | 0, Do = ci - ((le >>> 0 > Vr >>> 0) + ir | 0) | 0, Z = (le = dt((33554431 & (le = Bt)) << 7 | Z >>> 25, Bt >>= 25, 19, 0)) + Jt | 0, Jt = Oe + Do | 0, Bt = Z >>> 0 < le >>> 0 ? Jt + 1 | 0 : Jt, Jt = Bt = (67108863 & (Bt = (Z = (le = Z) + 33554432 | 0) >>> 0 < 33554432 ? Bt + 1 | 0 : Bt)) << 6 | Z >>> 26, Bt = Bt + mn | 0, l[L + 4 >> 2] = Bt, l[L >> 2] = le - (-67108864 & Z);
                    }
                    function Vi(L, Z) {
                      var le, ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt, ot, _t, qt, tt, xt, Mt, Vt, un, gn, Bn, Tn, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0, kr = 0, Qr = 0, Ur = 0, Lr = 0, Jr = 0, jr = 0, oo = 0, uo = 0, _o = 0, So = 0, Ao = 0, bo = 0, xr = 0, Oo = 0, Yn = 0, ir = 0, Bt = 0, Jt = 0, mn = 0, Hr = 0;
                      st = le = st - 48 | 0, Cn(L, Z), Cn(L + 80 | 0, Z + 40 | 0), Pt = dt(jn = (jr = l[Z + 92 >> 2]) << 1, Qe = jn >> 31, zn = (kn = l[Z + 84 >> 2]) << 1, ae = zn >> 31), An = Oe, xr = _r = l[Z + 88 >> 2], Dt = (vn = dt(_r, kr = _r >> 31, _r, kr)) + Pt | 0, Pt = Oe + An | 0, Pt = Dt >>> 0 < vn >>> 0 ? Pt + 1 | 0 : Pt, An = (nr = dt(Vn = l[Z + 96 >> 2], q = Vn >> 31, vn = (Dn = l[Z + 80 >> 2]) << 1, de = vn >> 31)) + Dt | 0, Dt = Oe + Pt | 0, Dt = An >>> 0 < nr >>> 0 ? Dt + 1 | 0 : Dt, So = l[Z + 108 >> 2], nr = dt(nn = wr(So, 38), Ne = nn >> 31, So, ot = So >> 31), Pt = Oe + Dt | 0, Pt = (An = nr + An | 0) >>> 0 < nr >>> 0 ? Pt + 1 | 0 : Pt, Xn = An, oo = l[Z + 112 >> 2], An = dt(De = wr(oo, 19), be = De >> 31, Dt = (Qr = l[Z + 104 >> 2]) << 1, Dt >> 31), Pt = Oe + Pt | 0, Pt = (Dt = Xn + An | 0) >>> 0 < An >>> 0 ? Pt + 1 | 0 : Pt, Yn = l[Z + 116 >> 2], An = (uo = dt(nr = wr(Yn, 38), Ie = nr >> 31, br = (Ur = l[Z + 100 >> 2]) << 1, Ye = br >> 31)) + Dt | 0, Dt = Oe + Pt | 0, ir = Pt = (An >>> 0 < uo >>> 0 ? Dt + 1 | 0 : Dt) << 1 | An >>> 31, Bt = An = 33554432 + (_t = An << 1) | 0, Jt = Pt = An >>> 0 < 33554432 ? Pt + 1 | 0 : Pt, Ao = (67108863 & Pt) << 6 | An >>> 26, Lr = Pt >> 26, Pt = dt(zn, ae, Vn, q), Dt = Oe, An = dt(_r <<= 1, Te = _r >> 31, jr, qt = jr >> 31), Dt = Oe + Dt | 0, Dt = (Pt = An + Pt | 0) >>> 0 < An >>> 0 ? Dt + 1 | 0 : Dt, An = (uo = dt(Ur, We = Ur >> 31, vn, de)) + Pt | 0, Pt = Oe + Dt | 0, Pt = An >>> 0 < uo >>> 0 ? Pt + 1 | 0 : Pt, Dt = An, An = dt(De, be, uo = So << 1, tt = uo >> 31), Pt = Oe + Pt | 0, Pt = (Dt = Dt + An | 0) >>> 0 < An >>> 0 ? Pt + 1 | 0 : Pt, An = dt(nr, Ie, Qr, Ue = Qr >> 31), Pt = Oe + Pt | 0, Pt = (Dt = An + Dt | 0) >>> 0 < An >>> 0 ? Pt + 1 | 0 : Pt, An = Ao, Ao = Dt << 1, Dt = (Pt << 1 | Dt >>> 31) + Lr | 0, Dt = (An = An + Ao | 0) >>> 0 < Ao >>> 0 ? Dt + 1 | 0 : Dt, Ao = An, mn = An = An + 16777216 | 0, Xn = (33554431 & (Dt = An >>> 0 < 16777216 ? Dt + 1 | 0 : Dt)) << 7 | An >>> 25, Lr = Dt >> 25, Pt = dt(jn, Qe, jr, qt), An = Oe, Dt = (Jr = dt(Vn, q, _r, Te)) + Pt | 0, Pt = Oe + An | 0, Pt = Dt >>> 0 < Jr >>> 0 ? Pt + 1 | 0 : Pt, An = dt(zn, ae, br, Ye), Pt = Oe + Pt | 0, Pt = (Dt = An + Dt | 0) >>> 0 < An >>> 0 ? Pt + 1 | 0 : Pt, An = (Jr = dt(vn, de, Qr, Ue)) + Dt | 0, Dt = Oe + Pt | 0, Dt = An >>> 0 < Jr >>> 0 ? Dt + 1 | 0 : Dt, Pt = An, An = dt(De, be, oo, rt = oo >> 31), Dt = Oe + Dt | 0, Dt = (Pt = Pt + An | 0) >>> 0 < An >>> 0 ? Dt + 1 | 0 : Dt, An = (Jr = dt(nr, Ie, uo, tt)) + Pt | 0, Pt = Oe + Dt | 0, Dt = (An >>> 0 < Jr >>> 0 ? Pt + 1 | 0 : Pt) << 1 | An >>> 31, An = (Pt = Xn) + (Xn = An << 1) | 0, Pt = Dt + Lr | 0, Pt = An >>> 0 < Xn >>> 0 ? Pt + 1 | 0 : Pt, Lr = An, Jr = Dt = An + 33554432 | 0, An = Pt = Dt >>> 0 < 33554432 ? Pt + 1 | 0 : Pt, l[L + 144 >> 2] = Lr - (-67108864 & Dt), Lr = dt(Pt = wr(Ur, 38), Pt >> 31, Ur, We), Xn = Oe, Dn = dt(Pt = Dn, Dt = Pt >> 31, Pt, Dt), Pt = Oe + Xn | 0, Pt = (Dt = Dn + Lr | 0) >>> 0 < Dn >>> 0 ? Pt + 1 | 0 : Pt, Xn = dt(Dn = wr(Qr, 19), xt = Dn >> 31, Lr = Vn << 1, Mt = Lr >> 31), Pt = Oe + Pt | 0, Pt = (Dt = Xn + Dt | 0) >>> 0 < Xn >>> 0 ? Pt + 1 | 0 : Pt, Xn = dt(jn, Qe, nn, Ne), Pt = Oe + Pt | 0, Pt = (Dt = Xn + Dt | 0) >>> 0 < Xn >>> 0 ? Pt + 1 | 0 : Pt, Xn = (Hr = dt(De, be, _r, Te)) + Dt | 0, Dt = Oe + Pt | 0, Dt = Xn >>> 0 < Hr >>> 0 ? Dt + 1 | 0 : Dt, Pt = Xn, Xn = dt(zn, ae, nr, Ie), Dt = Oe + Dt | 0, Dt = ((Pt = Pt + Xn | 0) >>> 0 < Xn >>> 0 ? Dt + 1 | 0 : Dt) << 1, Xn = Pt, Hr = Pt = Dt | Pt >>> 31, gn = Xn = 33554432 + (Vt = Xn << 1) | 0, Bn = Pt = Xn >>> 0 < 33554432 ? Pt + 1 | 0 : Pt, _o = (67108863 & Pt) << 6 | Xn >>> 26, Xn = Pt >> 26, Pt = dt(Dn, xt, br, Ye), bo = Oe, Oo = kn, Dt = (kn = dt(vn, de, kn, un = kn >> 31)) + Pt | 0, Pt = Oe + bo | 0, Pt = Dt >>> 0 < kn >>> 0 ? Pt + 1 | 0 : Pt, kn = (bo = dt(Vn, q, nn, Ne)) + Dt | 0, Dt = Oe + Pt | 0, Dt = kn >>> 0 < bo >>> 0 ? Dt + 1 | 0 : Dt, bo = dt(De, be, jn, Qe), Pt = Oe + Dt | 0, Pt = (kn = bo + kn | 0) >>> 0 < bo >>> 0 ? Pt + 1 | 0 : Pt, Dt = kn, kn = dt(nr, Ie, xr, kr), Pt = Oe + Pt | 0, Pt = ((Dt = Dt + kn | 0) >>> 0 < kn >>> 0 ? Pt + 1 | 0 : Pt) << 1, kn = Dt, Dt = (Dt = Pt | Dt >>> 31) + Xn | 0, Xn = kn = (Pt = kn << 1) + _o | 0, Pt = Dt = Pt >>> 0 > kn >>> 0 ? Dt + 1 | 0 : Dt, bo = kn = kn + 16777216 | 0, Tn = (33554431 & (Pt = kn >>> 0 < 16777216 ? Pt + 1 | 0 : Pt)) << 7 | kn >>> 25, _o = Pt >> 25, Pt = dt(vn, de, xr, kr), kn = Oe, Dt = (Oo = dt(zn, ae, Oo, un)) + Pt | 0, Pt = Oe + kn | 0, Pt = Dt >>> 0 < Oo >>> 0 ? Pt + 1 | 0 : Pt, kn = dt(Dn, xt, Qr, Ue), Pt = Oe + Pt | 0, Pt = (Dt = kn + Dt | 0) >>> 0 < kn >>> 0 ? Pt + 1 | 0 : Pt, kn = (Dn = dt(br, Ye, nn, Ne)) + Dt | 0, Dt = Oe + Pt | 0, Dt = kn >>> 0 < Dn >>> 0 ? Dt + 1 | 0 : Dt, Dn = dt(De, be, Lr, Mt), Pt = Oe + Dt | 0, Pt = (kn = Dn + kn | 0) >>> 0 < Dn >>> 0 ? Pt + 1 | 0 : Pt, Dn = dt(nr, Ie, jn, Qe), Dt = Oe + Pt | 0, Pt = (Dt = ((kn = Dn + kn | 0) >>> 0 < Dn >>> 0 ? Dt + 1 | 0 : Dt) << 1 | kn >>> 31) + _o | 0, Pt = (kn = (Dn = kn << 1) + Tn | 0) >>> 0 < Dn >>> 0 ? Pt + 1 | 0 : Pt, Dn = kn, Oo = Dt = kn + 33554432 | 0, kn = Pt = Dt >>> 0 < 33554432 ? Pt + 1 | 0 : Pt, l[L + 128 >> 2] = Dn - (-67108864 & Dt), Pt = dt(_r, Te, Ur, We), Dt = Oe, Dn = dt(Vn, q, jn, Qe), Dt = Oe + Dt | 0, Dt = (Pt = Dn + Pt | 0) >>> 0 < Dn >>> 0 ? Dt + 1 | 0 : Dt, Dn = (_o = dt(zn, ae, Qr, Ue)) + Pt | 0, Pt = Oe + Dt | 0, Pt = Dn >>> 0 < _o >>> 0 ? Pt + 1 | 0 : Pt, Dt = Dn, Dn = dt(vn, de, So, ot), Pt = Oe + Pt | 0, Pt = (Dt = Dt + Dn | 0) >>> 0 < Dn >>> 0 ? Pt + 1 | 0 : Pt, Dn = (_o = dt(nr, Ie, oo, rt)) + Dt | 0, Dt = Oe + Pt | 0, Dt = Pt = (Dn >>> 0 < _o >>> 0 ? Dt + 1 | 0 : Dt) << 1 | Dn >>> 31, Pt = (Pt = An >> 26) + Dt | 0, Pt = (An = (_o = Dn <<= 1) + (Dn = (67108863 & An) << 6 | Jr >>> 26) | 0) >>> 0 < Dn >>> 0 ? Pt + 1 | 0 : Pt, Dn = An, Dt = Pt, Jr = Pt = An + 16777216 | 0, An = Dt = Pt >>> 0 < 16777216 ? Dt + 1 | 0 : Dt, l[L + 148 >> 2] = Dn - (-33554432 & Pt), Pt = dt(vn, de, jr, qt), jr = Oe, Dt = (kr = dt(zn, ae, xr, kr)) + Pt | 0, Pt = Oe + jr | 0, Pt = Dt >>> 0 < kr >>> 0 ? Pt + 1 | 0 : Pt, nn = dt(Qr, Ue, nn, Ne), Pt = Oe + Pt | 0, Pt = (Dt = nn + Dt | 0) >>> 0 < nn >>> 0 ? Pt + 1 | 0 : Pt, De = (nn = dt(De, be, br, Ye)) + Dt | 0, Dt = Oe + Pt | 0, Dt = De >>> 0 < nn >>> 0 ? Dt + 1 | 0 : Dt, nn = dt(nr, Ie, Vn, q), Pt = Oe + Dt | 0, Dt = (Pt = ((De = nn + De | 0) >>> 0 < nn >>> 0 ? Pt + 1 | 0 : Pt) << 1 | De >>> 31) + (Dt = kn >> 26) | 0, Dt = (kn = (Dn = De << 1) + (De = (67108863 & kn) << 6 | Oo >>> 26) | 0) >>> 0 < De >>> 0 ? Dt + 1 | 0 : Dt, De = kn, Pt = Dt, nn = Dt = kn + 16777216 | 0, kn = Pt = Dt >>> 0 < 16777216 ? Pt + 1 | 0 : Pt, l[L + 132 >> 2] = De - (-33554432 & Dt), Pt = dt(Qr, Ue, _r, Te), De = Oe, Dt = (Vn = dt(Vn, q, Vn, q)) + Pt | 0, Pt = Oe + De | 0, Pt = Dt >>> 0 < Vn >>> 0 ? Pt + 1 | 0 : Pt, Vn = (De = dt(jn, Qe, br, Ye)) + Dt | 0, Dt = Oe + Pt | 0, Dt = Vn >>> 0 < De >>> 0 ? Dt + 1 | 0 : Dt, De = dt(zn, ae, uo, tt), Pt = Oe + Dt | 0, Pt = (Vn = De + Vn | 0) >>> 0 < De >>> 0 ? Pt + 1 | 0 : Pt, De = dt(vn, de, oo, rt), Dt = Oe + Pt | 0, Dt = (Vn = De + Vn | 0) >>> 0 < De >>> 0 ? Dt + 1 | 0 : Dt, De = dt(Pt = nr, Ie, nr = Yn, br = nr >> 31), Pt = Oe + Dt | 0, Pt = (Pt = ((Vn = De + Vn | 0) >>> 0 < De >>> 0 ? Pt + 1 | 0 : Pt) << 1 | Vn >>> 31) + (Dt = An >> 25) | 0, Pt = (An = (Dn = Vn << 1) + (Vn = (33554431 & An) << 7 | Jr >>> 25) | 0) >>> 0 < Vn >>> 0 ? Pt + 1 | 0 : Pt, Vn = An, Dt = Pt, De = Pt = An + 33554432 | 0, An = Dt = Pt >>> 0 < 33554432 ? Dt + 1 | 0 : Dt, l[L + 152 >> 2] = Vn - (-67108864 & Pt), Dt = _t - (Pt = -67108864 & Bt) | 0, kr = ir - ((Pt >>> 0 > _t >>> 0) + Jt | 0) | 0, Pt = kn >> 25, kn = (nn = (33554431 & kn) << 7 | nn >>> 25) + Dt | 0, Dt = Pt + kr | 0, Dt = kn >>> 0 < nn >>> 0 ? Dt + 1 | 0 : Dt, Dn = Dt = (67108863 & (Dt = (Pt = kn + 33554432 | 0) >>> 0 < 33554432 ? Dt + 1 | 0 : Dt)) << 6 | Pt >>> 26, Dt = Dt + (Vn = Ao - (-33554432 & mn) | 0) | 0, l[L + 140 >> 2] = Dt, l[L + 136 >> 2] = kn - (-67108864 & Pt), Pt = dt(jn, Qe, Qr, Ue), Dt = Oe, kn = dt(Ur, We, Lr, Mt), Dt = Oe + Dt | 0, Dt = (Pt = kn + Pt | 0) >>> 0 < kn >>> 0 ? Dt + 1 | 0 : Dt, kn = (jn = dt(_r, Te, So, ot)) + Pt | 0, Pt = Oe + Dt | 0, Pt = kn >>> 0 < jn >>> 0 ? Pt + 1 | 0 : Pt, Dt = kn, kn = dt(zn, ae, oo, rt), Pt = Oe + Pt | 0, Pt = (Dt = Dt + kn | 0) >>> 0 < kn >>> 0 ? Pt + 1 | 0 : Pt, kn = (zn = dt(vn, de, nr, br)) + Dt | 0, Dt = Oe + Pt | 0, Dt = Pt = (kn >>> 0 < zn >>> 0 ? Dt + 1 | 0 : Dt) << 1 | kn >>> 31, Pt = (Pt = An >> 26) + Dt | 0, Dt = (An = (Dn = kn <<= 1) + (kn = (67108863 & An) << 6 | De >>> 26) | 0) >>> 0 < kn >>> 0 ? Pt + 1 | 0 : Pt, Dt = (Pt = An + 16777216 | 0) >>> 0 < 16777216 ? Dt + 1 | 0 : Dt, l[L + 156 >> 2] = An - (-33554432 & Pt), kn = Xn - (-33554432 & bo) | 0, zn = Vt - (An = -67108864 & gn) | 0, vn = Hr - ((An >>> 0 > Vt >>> 0) + Bn | 0) | 0, Dt = dt((33554431 & Dt) << 7 | Pt >>> 25, Dt >> 25, 19, 0), Pt = Oe + vn | 0, Dt = Dt >>> 0 > (An = Dt + zn | 0) >>> 0 ? Pt + 1 | 0 : Pt, Dn = Dt = (67108863 & (Dt = (Pt = An + 33554432 | 0) >>> 0 < 33554432 ? Dt + 1 | 0 : Dt)) << 6 | Pt >>> 26, Dt = Dt + kn | 0, l[L + 124 >> 2] = Dt, l[L + 120 >> 2] = An - (-67108864 & Pt), Pt = l[Z + 40 >> 2], Dt = l[Z + 44 >> 2], An = l[Z + 4 >> 2], kn = l[Z + 48 >> 2], zn = l[Z + 8 >> 2], vn = l[Z + 52 >> 2], nr = l[Z + 12 >> 2], jn = l[Z + 56 >> 2], Vn = l[Z + 16 >> 2], De = l[Z + 60 >> 2], Qr = l[Z + 20 >> 2], br = l[Z - -64 >> 2], _r = l[Z + 24 >> 2], nn = l[Z + 68 >> 2], kr = l[Z + 28 >> 2], Ur = l[Z + 72 >> 2], oo = l[Z + 32 >> 2], xr = l[Z >> 2], l[L + 76 >> 2] = l[Z + 76 >> 2] + l[Z + 36 >> 2], l[L + 72 >> 2] = Ur + oo, l[L + 68 >> 2] = nn + kr, l[(So = L - -64 | 0) >> 2] = _r + br, l[L + 60 >> 2] = De + Qr, l[L + 56 >> 2] = Vn + jn, l[L + 52 >> 2] = nr + vn, l[L + 48 >> 2] = kn + zn, l[L + 44 >> 2] = Dt + An, l[(Z = L + 40 | 0) >> 2] = Pt + xr, Cn(le, Z), Pt = l[L + 80 >> 2], Dt = l[L + 4 >> 2], An = l[L + 84 >> 2], kn = l[L + 8 >> 2], zn = l[L + 88 >> 2], vn = l[L + 12 >> 2], nr = l[L + 92 >> 2], jn = l[L + 16 >> 2], Vn = l[L + 96 >> 2], De = l[L + 20 >> 2], Qr = l[L + 100 >> 2], br = l[L + 24 >> 2], _r = l[L + 104 >> 2], nn = l[L + 28 >> 2], kr = l[L + 108 >> 2], Ur = l[L + 32 >> 2], oo = l[L + 112 >> 2], xr = l[L >> 2], Dn = (jr = l[L + 116 >> 2]) - (uo = l[L + 36 >> 2]) | 0, l[L + 116 >> 2] = Dn, Lr = oo - Ur | 0, l[L + 112 >> 2] = Lr, Ao = kr - nn | 0, l[L + 108 >> 2] = Ao, Xn = _r - br | 0, l[L + 104 >> 2] = Xn, Yn = Qr - De | 0, l[L + 100 >> 2] = Yn, ir = Vn - jn | 0, l[L + 96 >> 2] = ir, Bt = nr - vn | 0, l[L + 92 >> 2] = Bt, Jt = zn - kn | 0, l[L + 88 >> 2] = Jt, Jr = An - Dt | 0, l[L + 84 >> 2] = Jr, mn = Pt - xr | 0, l[L + 80 >> 2] = mn, jr = jr + uo | 0, l[L + 76 >> 2] = jr, Ur = Ur + oo | 0, l[L + 72 >> 2] = Ur, nn = nn + kr | 0, l[L + 68 >> 2] = nn, br = _r + br | 0, l[So >> 2] = br, De = De + Qr | 0, l[L + 60 >> 2] = De, jn = Vn + jn | 0, l[L + 56 >> 2] = jn, vn = nr + vn | 0, l[L + 52 >> 2] = vn, kn = kn + zn | 0, l[L + 48 >> 2] = kn, Dt = Dt + An | 0, l[L + 44 >> 2] = Dt, An = Z, Z = Pt + xr | 0, l[An >> 2] = Z, Pt = l[le >> 2], An = l[le + 4 >> 2], zn = l[le + 8 >> 2], nr = l[le + 12 >> 2], Vn = l[le + 16 >> 2], Qr = l[le + 20 >> 2], _r = l[le + 24 >> 2], kr = l[le + 28 >> 2], oo = l[le + 32 >> 2], l[L + 36 >> 2] = l[le + 36 >> 2] - jr, l[L + 32 >> 2] = oo - Ur, l[L + 28 >> 2] = kr - nn, l[L + 24 >> 2] = _r - br, l[L + 20 >> 2] = Qr - De, l[L + 16 >> 2] = Vn - jn, l[L + 12 >> 2] = nr - vn, l[L + 8 >> 2] = zn - kn, l[L + 4 >> 2] = An - Dt, l[L >> 2] = Pt - Z, Z = l[L + 120 >> 2], Pt = l[L + 124 >> 2], Dt = l[L + 128 >> 2], An = l[L + 132 >> 2], kn = l[L + 136 >> 2], zn = l[L + 140 >> 2], vn = l[L + 144 >> 2], nr = l[L + 148 >> 2], jn = l[L + 152 >> 2], l[L + 156 >> 2] = l[L + 156 >> 2] - Dn, l[L + 152 >> 2] = jn - Lr, l[L + 148 >> 2] = nr - Ao, l[L + 144 >> 2] = vn - Xn, l[L + 140 >> 2] = zn - Yn, l[L + 136 >> 2] = kn - ir, l[L + 132 >> 2] = An - Bt, l[L + 128 >> 2] = Dt - Jt, l[L + 124 >> 2] = Pt - Jr, l[L + 120 >> 2] = Z - mn, st = le + 48 | 0;
                    }
                    function Cn(L, Z) {
                      var le, ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt, ot, _t, qt, tt, xt, Mt, Vt, un, gn, Bn, Tn, Pt, Dt, An, kn, Dn, De, Vn, Xn, nr, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0, kr = 0, Qr = 0, Ur = 0, Lr = 0, Jr = 0, jr = 0, oo = 0, uo = 0, _o = 0, So = 0, Ao = 0, bo = 0, xr = 0, Oo = 0, Yn = 0, ir = 0;
                      nn = dt(ae = (qt = l[Z + 12 >> 2]) << 1, q = ae >> 31, qt, un = qt >> 31), zn = Oe, vn = (Ur = dt(_r = l[Z + 16 >> 2], be = _r >> 31, Ue = (jn = l[Z + 8 >> 2]) << 1, We = Ue >> 31)) + nn | 0, nn = Oe + zn | 0, nn = vn >>> 0 < Ur >>> 0 ? nn + 1 | 0 : nn, zn = (Lr = dt(oo = (Ye = l[Z + 20 >> 2]) << 1, rt = oo >> 31, Ur = (br = l[Z + 4 >> 2]) << 1, de = Ur >> 31)) + vn | 0, vn = Oe + nn | 0, vn = zn >>> 0 < Lr >>> 0 ? vn + 1 | 0 : vn, kr = dt(le = l[Z + 24 >> 2], Te = le >> 31, Lr = (So = l[Z >> 2]) << 1, Ie = Lr >> 31), nn = Oe + vn | 0, nn = (zn = kr + zn | 0) >>> 0 < kr >>> 0 ? nn + 1 | 0 : nn, vn = zn, ot = l[Z + 32 >> 2], zn = dt(Jr = wr(ot, 19), Ne = Jr >> 31, ot, xt = ot >> 31), nn = Oe + nn | 0, nn = (vn = vn + zn | 0) >>> 0 < zn >>> 0 ? nn + 1 | 0 : nn, Dt = l[Z + 36 >> 2], zn = dt(kr = wr(Dt, 38), Qe = kr >> 31, Mt = (_t = l[Z + 28 >> 2]) << 1, gn = Mt >> 31), Z = Oe + nn | 0, _o = vn = zn + vn | 0, zn = vn >>> 0 < zn >>> 0 ? Z + 1 | 0 : Z, Z = dt(Ur, de, _r, be), nn = Oe, vn = dt(Ue, We, qt, un), nn = Oe + nn | 0, nn = (Z = vn + Z | 0) >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, Qr = dt(Ye, Vt = Ye >> 31, Lr, Ie), vn = Oe + nn | 0, vn = (Z = Qr + Z | 0) >>> 0 < Qr >>> 0 ? vn + 1 | 0 : vn, Qr = dt(Jr, Ne, Mt, gn), nn = Oe + vn | 0, nn = (Z = Qr + Z | 0) >>> 0 < Qr >>> 0 ? nn + 1 | 0 : nn, vn = dt(kr, Qe, le, Te), nn = Oe + nn | 0, Yn = Z = vn + Z | 0, jr = Z >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, nn = dt(Ur, de, ae, q), vn = Oe, Bn = Z = jn, jn = dt(Z, uo = Z >> 31, Z, uo), Z = Oe + vn | 0, Z = (nn = jn + nn | 0) >>> 0 < jn >>> 0 ? Z + 1 | 0 : Z, vn = (jn = dt(Lr, Ie, _r, be)) + nn | 0, nn = Oe + Z | 0, nn = vn >>> 0 < jn >>> 0 ? nn + 1 | 0 : nn, Z = (jn = dt(Qr = wr(_t, 38), tt = Qr >> 31, _t, Tn = _t >> 31)) + vn | 0, vn = Oe + nn | 0, vn = Z >>> 0 < jn >>> 0 ? vn + 1 | 0 : vn, Z = (nn = Z) + (jn = dt(Jr, Ne, Z = le << 1, Z >> 31)) | 0, nn = Oe + vn | 0, nn = Z >>> 0 < jn >>> 0 ? nn + 1 | 0 : nn, vn = Z, Z = dt(kr, Qe, oo, rt), nn = Oe + nn | 0, An = vn = vn + Z | 0, kn = nn = Z >>> 0 > vn >>> 0 ? nn + 1 | 0 : nn, Z = nn, Dn = vn = vn + 33554432 | 0, De = Z = vn >>> 0 < 33554432 ? Z + 1 | 0 : Z, nn = (nn = Z >> 26) + jr | 0, Yn = Z = (vn = (67108863 & Z) << 6 | vn >>> 26) + Yn | 0, nn = Z >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, Vn = Z = Z + 16777216 | 0, nn = (nn = (vn = Z >>> 0 < 16777216 ? nn + 1 | 0 : nn) >> 25) + zn | 0, Z = (Z = (33554431 & vn) << 7 | Z >>> 25) >>> 0 > (vn = Z + _o | 0) >>> 0 ? nn + 1 | 0 : nn, _o = nn = vn + 33554432 | 0, jn = Z = nn >>> 0 < 33554432 ? Z + 1 | 0 : Z, l[L + 24 >> 2] = vn - (-67108864 & nn), Z = dt(Lr, Ie, Bn, uo), nn = Oe, zn = dt(Ur, de, br, Oo = br >> 31), vn = Oe + nn | 0, vn = (Z = zn + Z | 0) >>> 0 < zn >>> 0 ? vn + 1 | 0 : vn, jr = dt(zn = wr(le, 19), xr = zn >> 31, le, Te), nn = Oe + vn | 0, nn = (Z = jr + Z | 0) >>> 0 < jr >>> 0 ? nn + 1 | 0 : nn, vn = (jr = dt(oo, rt, Qr, tt)) + Z | 0, Z = Oe + nn | 0, Z = vn >>> 0 < jr >>> 0 ? Z + 1 | 0 : Z, Ao = dt(Jr, Ne, jr = _r << 1, Pt = jr >> 31), nn = Oe + Z | 0, nn = (vn = Ao + vn | 0) >>> 0 < Ao >>> 0 ? nn + 1 | 0 : nn, Z = vn, vn = dt(kr, Qe, ae, q), nn = Oe + nn | 0, bo = Z = Z + vn | 0, Ao = Z >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, Z = dt(oo, rt, zn, xr), nn = Oe, br = dt(Lr, Ie, br, Oo), vn = Oe + nn | 0, vn = (Z = br + Z | 0) >>> 0 < br >>> 0 ? vn + 1 | 0 : vn, br = dt(_r, be, Qr, tt), nn = Oe + vn | 0, nn = (Z = br + Z | 0) >>> 0 < br >>> 0 ? nn + 1 | 0 : nn, vn = (br = dt(Jr, Ne, ae, q)) + Z | 0, Z = Oe + nn | 0, Z = vn >>> 0 < br >>> 0 ? Z + 1 | 0 : Z, br = dt(kr, Qe, Bn, uo), nn = Oe + Z | 0, ir = vn = br + vn | 0, Oo = vn >>> 0 < br >>> 0 ? nn + 1 | 0 : nn, vn = dt(Z = wr(Ye, 38), Z >> 31, Ye, Vt), br = Oe, Z = So, So = vn, vn = dt(Z, nn = Z >> 31, Z, nn), nn = Oe + br | 0, nn = (Z = So + vn | 0) >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, zn = dt(zn, xr, jr, Pt), vn = Oe + nn | 0, vn = (Z = zn + Z | 0) >>> 0 < zn >>> 0 ? vn + 1 | 0 : vn, zn = dt(ae, q, Qr, tt), nn = Oe + vn | 0, nn = (Z = zn + Z | 0) >>> 0 < zn >>> 0 ? nn + 1 | 0 : nn, vn = (zn = dt(Jr, Ne, Ue, We)) + Z | 0, Z = Oe + nn | 0, Z = vn >>> 0 < zn >>> 0 ? Z + 1 | 0 : Z, zn = dt(Ur, de, kr, Qe), nn = Oe + Z | 0, br = vn = zn + vn | 0, xr = nn = vn >>> 0 < zn >>> 0 ? nn + 1 | 0 : nn, Xn = vn = vn + 33554432 | 0, nr = nn = vn >>> 0 < 33554432 ? nn + 1 | 0 : nn, Z = nn >> 26, nn = (67108863 & nn) << 6 | vn >>> 26, vn = Z + Oo | 0, So = zn = nn + ir | 0, nn = vn = nn >>> 0 > zn >>> 0 ? vn + 1 | 0 : vn, ir = vn = zn + 16777216 | 0, zn = (33554431 & (nn = vn >>> 0 < 16777216 ? nn + 1 | 0 : nn)) << 7 | vn >>> 25, nn = (nn >> 25) + Ao | 0, nn = (vn = zn + bo | 0) >>> 0 < zn >>> 0 ? nn + 1 | 0 : nn, Ao = Z = vn + 33554432 | 0, zn = nn = Z >>> 0 < 33554432 ? nn + 1 | 0 : nn, l[L + 8 >> 2] = vn - (-67108864 & Z), Z = dt(Ue, We, Ye, Vt), nn = Oe, vn = dt(_r, be, ae, q), nn = Oe + nn | 0, nn = (Z = vn + Z | 0) >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, vn = dt(Ur, de, le, Te), nn = Oe + nn | 0, nn = (Z = vn + Z | 0) >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, vn = dt(Lr, Ie, _t, Tn), nn = Oe + nn | 0, nn = (Z = vn + Z | 0) >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, bo = (vn = dt(kr, Qe, ot, xt)) + Z | 0, Z = Oe + nn | 0, vn = (nn = jn >> 26) + (vn = vn >>> 0 > bo >>> 0 ? Z + 1 | 0 : Z) | 0, _o = Z = (jn = (67108863 & jn) << 6 | _o >>> 26) + bo | 0, nn = Z >>> 0 < jn >>> 0 ? vn + 1 | 0 : vn, bo = Z = Z + 16777216 | 0, jn = nn = Z >>> 0 < 16777216 ? nn + 1 | 0 : nn, l[L + 28 >> 2] = _o - (-33554432 & Z), Z = dt(Lr, Ie, qt, un), vn = Oe, nn = (uo = dt(Ur, de, Bn, uo)) + Z | 0, Z = Oe + vn | 0, Z = nn >>> 0 < uo >>> 0 ? Z + 1 | 0 : Z, nn = (Qr = dt(le, Te, Qr, tt)) + nn | 0, vn = Oe + Z | 0, Z = (Jr = dt(Jr, Ne, oo, rt)) + nn | 0, nn = Oe + (nn >>> 0 < Qr >>> 0 ? vn + 1 | 0 : vn) | 0, nn = Z >>> 0 < Jr >>> 0 ? nn + 1 | 0 : nn, vn = dt(kr, Qe, _r, be), nn = Oe + nn | 0, nn = (nn = (Z = vn + Z | 0) >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn) + (vn = zn >> 26) | 0, Z = (vn = zn = (_o = Z) + (Z = (67108863 & zn) << 6 | Ao >>> 26) | 0) >>> 0 < Z >>> 0 ? nn + 1 | 0 : nn, Jr = nn = vn + 16777216 | 0, zn = Z = nn >>> 0 < 16777216 ? Z + 1 | 0 : Z, l[L + 12 >> 2] = vn - (-33554432 & nn), Z = dt(le, Te, Ue, We), nn = Oe, vn = dt(_r, be, _r, be), nn = Oe + nn | 0, nn = (Z = vn + Z | 0) >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, vn = dt(ae, q, oo, rt), nn = Oe + nn | 0, nn = (Z = vn + Z | 0) >>> 0 < vn >>> 0 ? nn + 1 | 0 : nn, vn = (_r = dt(Ur, de, Mt, gn)) + Z | 0, Z = Oe + nn | 0, Z = vn >>> 0 < _r >>> 0 ? Z + 1 | 0 : Z, nn = (_r = dt(Lr, Ie, ot, xt)) + vn | 0, vn = Oe + Z | 0, vn = nn >>> 0 < _r >>> 0 ? vn + 1 | 0 : vn, Z = (_r = dt(Z = kr, Qe, kr = Dt, oo = kr >> 31)) + nn | 0, nn = Oe + vn | 0, nn = Z >>> 0 < _r >>> 0 ? nn + 1 | 0 : nn, vn = Z, nn = (Z = jn >> 25) + nn | 0, nn = (vn = vn + (jn = (33554431 & jn) << 7 | bo >>> 25) | 0) >>> 0 < jn >>> 0 ? nn + 1 | 0 : nn, _r = Z = vn + 33554432 | 0, jn = nn = Z >>> 0 < 33554432 ? nn + 1 | 0 : nn, l[L + 32 >> 2] = vn - (-67108864 & Z), nn = zn >> 25, vn = (zn = (33554431 & zn) << 7 | Jr >>> 25) + (An - (Z = -67108864 & Dn) | 0) | 0, Z = nn + (kn - ((Z >>> 0 > An >>> 0) + De | 0) | 0) | 0, nn = vn >>> 0 < zn >>> 0 ? Z + 1 | 0 : Z, zn = nn = (67108863 & (nn = (Z = vn + 33554432 | 0) >>> 0 < 33554432 ? nn + 1 | 0 : nn)) << 6 | Z >>> 26, nn = nn + (Qr = Yn - (-33554432 & Vn) | 0) | 0, l[L + 20 >> 2] = nn, l[L + 16 >> 2] = vn - (-67108864 & Z), Z = dt(ae, q, le, Te), vn = Oe, nn = (zn = dt(Ye, Vt, jr, Pt)) + Z | 0, Z = Oe + vn | 0, Z = nn >>> 0 < zn >>> 0 ? Z + 1 | 0 : Z, vn = (zn = dt(Ue, We, _t, Tn)) + nn | 0, nn = Oe + Z | 0, nn = vn >>> 0 < zn >>> 0 ? nn + 1 | 0 : nn, Z = (zn = dt(Ur, de, ot, xt)) + vn | 0, vn = Oe + nn | 0, vn = Z >>> 0 < zn >>> 0 ? vn + 1 | 0 : vn, zn = (nn = Z) + (Z = dt(Lr, Ie, kr, oo)) | 0, nn = Oe + vn | 0, nn = (Z = Z >>> 0 > zn >>> 0 ? nn + 1 | 0 : nn) + (nn = jn >> 26) | 0, Z = (vn = (jn = (67108863 & jn) << 6 | _r >>> 26) + zn | 0) >>> 0 < jn >>> 0 ? nn + 1 | 0 : nn, Z = (nn = vn + 16777216 | 0) >>> 0 < 16777216 ? Z + 1 | 0 : Z, l[L + 36 >> 2] = vn - (-33554432 & nn), jn = So - (-33554432 & ir) | 0, zn = br - (vn = -67108864 & Xn) | 0, Ur = xr - ((vn >>> 0 > br >>> 0) + nr | 0) | 0, Z = dt((33554431 & Z) << 7 | nn >>> 25, Z >> 25, 19, 0), nn = Oe + Ur | 0, Z = Z >>> 0 > (vn = Z + zn | 0) >>> 0 ? nn + 1 | 0 : nn, zn = Z = (67108863 & (Z = (nn = vn + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z)) << 6 | nn >>> 26, Z = Z + jn | 0, l[L + 4 >> 2] = Z, l[L >> 2] = vn - (-67108864 & nn);
                    }
                    function Ks(L, Z, le, ae, de) {
                      var Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt, ot, _t, qt, tt, xt, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0, kr = 0, Qr = 0, Ur = 0, Lr = 0, Jr = 0, jr = 0, oo = 0, uo = 0, _o = 0, So = 0, Ao = 0, bo = 0, xr = 0;
                      for (Ie = st + -64 | 0, Qe = l[L + 60 >> 2], q = l[L + 56 >> 2], _r = l[L + 52 >> 2], jn = l[L + 48 >> 2], be = l[L + 44 >> 2], Ue = l[L + 40 >> 2], Ye = l[L + 36 >> 2], Te = l[L + 32 >> 2], Ne = l[L + 28 >> 2], We = l[L + 24 >> 2], rt = l[L + 20 >> 2], ot = l[L + 16 >> 2], _t = l[L + 12 >> 2], qt = l[L + 8 >> 2], tt = l[L + 4 >> 2], xt = l[L >> 2]; ; ) {
                        if (!de & ae >>> 0 > 63 | de)
                          Mt = le;
                        else {
                          if (l[Ie + 56 >> 2] = 0, l[Ie + 60 >> 2] = 0, l[Ie + 48 >> 2] = 0, l[Ie + 52 >> 2] = 0, l[Ie + 40 >> 2] = 0, l[Ie + 44 >> 2] = 0, l[Ie + 32 >> 2] = 0, l[Ie + 36 >> 2] = 0, l[Ie + 24 >> 2] = 0, l[Ie + 28 >> 2] = 0, l[Ie + 16 >> 2] = 0, l[Ie + 20 >> 2] = 0, l[Ie + 8 >> 2] = 0, l[Ie + 12 >> 2] = 0, l[Ie >> 2] = 0, l[Ie + 4 >> 2] = 0, un = 0, ae | de)
                            for (; j[un + Ie | 0] = B[Z + un | 0], !de & (un = un + 1 | 0) >>> 0 < ae >>> 0 | de; )
                              ;
                          Z = Mt = Ie, Lr = le;
                        }
                        for (br = 20, Vt = xt, kn = tt, Dn = qt, Xn = _t, un = ot, le = rt, Bn = We, Tn = Ne, Pt = Te, nn = Ye, De = Ue, gn = Qe, vn = q, nr = _r, Vn = jn, Dt = be; An = un, Vt = Rn((un = Vt + un | 0) ^ Vn, 16), An = Vn = Rn(An ^ (Pt = Vt + Pt | 0), 12), Vn = Rn((zn = un + Vn | 0) ^ Vt, 8), un = Rn(An ^ (Pt = Vn + Pt | 0), 7), gn = Rn((Vt = Tn + Xn | 0) ^ gn, 16), Tn = Rn((Dt = gn + Dt | 0) ^ Tn, 12), Xn = Rn((Dn = Bn + Dn | 0) ^ vn, 16), Bn = Rn((De = Xn + De | 0) ^ Bn, 12), vn = (kr = Vt + Tn | 0) + un | 0, Qr = Rn((Dn = Bn + Dn | 0) ^ Xn, 8), Vt = Rn(vn ^ Qr, 16), Xn = Rn((kn = le + kn | 0) ^ nr, 16), le = Rn((nn = Xn + nn | 0) ^ le, 12), An = un, nr = Rn((kn = le + kn | 0) ^ Xn, 8), An = Rn(An ^ (un = (Ur = nr + nn | 0) + Vt | 0), 12), vn = Rn(Vt ^ (Xn = An + vn | 0), 8), un = Rn((nn = vn + un | 0) ^ An, 7), An = Pt, Pt = Dn, Vt = Rn(gn ^ kr, 8), Dn = Rn((gn = Vt + Dt | 0) ^ Tn, 7), nr = Rn((Pt = Pt + Dn | 0) ^ nr, 16), Dt = Rn((Tn = An + nr | 0) ^ Dn, 12), nr = Rn(nr ^ (Dn = Dt + Pt | 0), 8), Tn = Rn((Pt = Tn + nr | 0) ^ Dt, 7), Dt = gn, gn = kn, kn = Rn((De = De + Qr | 0) ^ Bn, 7), Bn = Dt + (Vn = Rn((gn = gn + kn | 0) ^ Vn, 16)) | 0, Dt = gn, gn = Rn(Bn ^ kn, 12), Vn = Rn(Vn ^ (kn = Dt + gn | 0), 8), Bn = Rn((Dt = Bn + Vn | 0) ^ gn, 7), An = De, gn = Vt, Vt = Rn(le ^ Ur, 7), gn = Rn(gn ^ (De = Vt + zn | 0), 16), zn = Rn((le = An + gn | 0) ^ Vt, 12), gn = Rn(gn ^ (Vt = zn + De | 0), 8), le = Rn((De = le + gn | 0) ^ zn, 7), br = br - 2 | 0; )
                          ;
                        if (br = B[Z + 4 | 0] | B[Z + 5 | 0] << 8 | B[Z + 6 | 0] << 16 | B[Z + 7 | 0] << 24, zn = B[Z + 8 | 0] | B[Z + 9 | 0] << 8 | B[Z + 10 | 0] << 16 | B[Z + 11 | 0] << 24, kr = B[Z + 12 | 0] | B[Z + 13 | 0] << 8 | B[Z + 14 | 0] << 16 | B[Z + 15 | 0] << 24, Qr = B[Z + 16 | 0] | B[Z + 17 | 0] << 8 | B[Z + 18 | 0] << 16 | B[Z + 19 | 0] << 24, Ur = B[Z + 20 | 0] | B[Z + 21 | 0] << 8 | B[Z + 22 | 0] << 16 | B[Z + 23 | 0] << 24, An = B[Z + 24 | 0] | B[Z + 25 | 0] << 8 | B[Z + 26 | 0] << 16 | B[Z + 27 | 0] << 24, Jr = B[Z + 28 | 0] | B[Z + 29 | 0] << 8 | B[Z + 30 | 0] << 16 | B[Z + 31 | 0] << 24, jr = B[Z + 32 | 0] | B[Z + 33 | 0] << 8 | B[Z + 34 | 0] << 16 | B[Z + 35 | 0] << 24, oo = B[Z + 36 | 0] | B[Z + 37 | 0] << 8 | B[Z + 38 | 0] << 16 | B[Z + 39 | 0] << 24, uo = B[Z + 40 | 0] | B[Z + 41 | 0] << 8 | B[Z + 42 | 0] << 16 | B[Z + 43 | 0] << 24, _o = B[Z + 44 | 0] | B[Z + 45 | 0] << 8 | B[Z + 46 | 0] << 16 | B[Z + 47 | 0] << 24, So = B[Z + 48 | 0] | B[Z + 49 | 0] << 8 | B[Z + 50 | 0] << 16 | B[Z + 51 | 0] << 24, Ao = B[Z + 52 | 0] | B[Z + 53 | 0] << 8 | B[Z + 54 | 0] << 16 | B[Z + 55 | 0] << 24, bo = B[Z + 56 | 0] | B[Z + 57 | 0] << 8 | B[Z + 58 | 0] << 16 | B[Z + 59 | 0] << 24, xr = B[Z + 60 | 0] | B[Z + 61 | 0] << 8 | B[Z + 62 | 0] << 16 | B[Z + 63 | 0] << 24, Vt = Vt + xt ^ (B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24), j[0 | Mt] = Vt, j[Mt + 1 | 0] = Vt >>> 8, j[Mt + 2 | 0] = Vt >>> 16, j[Mt + 3 | 0] = Vt >>> 24, Vt = gn + Qe ^ xr, j[Mt + 60 | 0] = Vt, j[Mt + 61 | 0] = Vt >>> 8, j[Mt + 62 | 0] = Vt >>> 16, j[Mt + 63 | 0] = Vt >>> 24, Vt = vn + q ^ bo, j[Mt + 56 | 0] = Vt, j[Mt + 57 | 0] = Vt >>> 8, j[Mt + 58 | 0] = Vt >>> 16, j[Mt + 59 | 0] = Vt >>> 24, Vt = nr + _r ^ Ao, j[Mt + 52 | 0] = Vt, j[Mt + 53 | 0] = Vt >>> 8, j[Mt + 54 | 0] = Vt >>> 16, j[Mt + 55 | 0] = Vt >>> 24, Vt = Vn + jn ^ So, j[Mt + 48 | 0] = Vt, j[Mt + 49 | 0] = Vt >>> 8, j[Mt + 50 | 0] = Vt >>> 16, j[Mt + 51 | 0] = Vt >>> 24, Vt = Dt + be ^ _o, j[Mt + 44 | 0] = Vt, j[Mt + 45 | 0] = Vt >>> 8, j[Mt + 46 | 0] = Vt >>> 16, j[Mt + 47 | 0] = Vt >>> 24, Vt = De + Ue ^ uo, j[Mt + 40 | 0] = Vt, j[Mt + 41 | 0] = Vt >>> 8, j[Mt + 42 | 0] = Vt >>> 16, j[Mt + 43 | 0] = Vt >>> 24, Vt = nn + Ye ^ oo, j[Mt + 36 | 0] = Vt, j[Mt + 37 | 0] = Vt >>> 8, j[Mt + 38 | 0] = Vt >>> 16, j[Mt + 39 | 0] = Vt >>> 24, Vt = Pt + Te ^ jr, j[Mt + 32 | 0] = Vt, j[Mt + 33 | 0] = Vt >>> 8, j[Mt + 34 | 0] = Vt >>> 16, j[Mt + 35 | 0] = Vt >>> 24, Tn = Tn + Ne ^ Jr, j[Mt + 28 | 0] = Tn, j[Mt + 29 | 0] = Tn >>> 8, j[Mt + 30 | 0] = Tn >>> 16, j[Mt + 31 | 0] = Tn >>> 24, Bn = An ^ Bn + We, j[Mt + 24 | 0] = Bn, j[Mt + 25 | 0] = Bn >>> 8, j[Mt + 26 | 0] = Bn >>> 16, j[Mt + 27 | 0] = Bn >>> 24, le = Ur ^ le + rt, j[Mt + 20 | 0] = le, j[Mt + 21 | 0] = le >>> 8, j[Mt + 22 | 0] = le >>> 16, j[Mt + 23 | 0] = le >>> 24, le = Qr ^ un + ot, j[Mt + 16 | 0] = le, j[Mt + 17 | 0] = le >>> 8, j[Mt + 18 | 0] = le >>> 16, j[Mt + 19 | 0] = le >>> 24, le = kr ^ Xn + _t, j[Mt + 12 | 0] = le, j[Mt + 13 | 0] = le >>> 8, j[Mt + 14 | 0] = le >>> 16, j[Mt + 15 | 0] = le >>> 24, le = zn ^ Dn + qt, j[Mt + 8 | 0] = le, j[Mt + 9 | 0] = le >>> 8, j[Mt + 10 | 0] = le >>> 16, j[Mt + 11 | 0] = le >>> 24, le = br ^ kn + tt, j[Mt + 4 | 0] = le, j[Mt + 5 | 0] = le >>> 8, j[Mt + 6 | 0] = le >>> 16, j[Mt + 7 | 0] = le >>> 24, _r = !(jn = jn + 1 | 0) + _r | 0, !de & ae >>> 0 <= 64) {
                          if (!(!ae | !de & ae >>> 0 > 63 | (0 | de) != 0))
                            for (un = 0; j[un + Lr | 0] = B[Mt + un | 0], ae >>> 0 > (un = un + 1 | 0) >>> 0; )
                              ;
                          l[L + 52 >> 2] = _r, l[L + 48 >> 2] = jn;
                          break;
                        }
                        Z = Z - -64 | 0, le = Mt - -64 | 0, de = de - 1 | 0, de = (ae = ae + -64 | 0) >>> 0 < 4294967232 ? de + 1 | 0 : de;
                      }
                    }
                    function Qi(L, Z) {
                      var le, ae = 0, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0;
                      st = le = st - 704 | 0, ae = 80 + ((de = l[L + 72 >> 2] >>> 3 & 127) + L | 0) | 0, de >>> 0 <= 111 ? yt(ae, 34640, 112 - de | 0) : (yt(ae, 34640, 128 - de | 0), $s(L, de = L + 80 | 0, le, le + 640 | 0), Rt(de, 0, 112)), be = (Ie = l[L + 64 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 68 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[L + 192 | 0] = ae, j[L + 193 | 0] = ae >>> 8, j[L + 194 | 0] = ae >>> 16, j[L + 195 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[L + 196 | 0] = de, j[L + 197 | 0] = de >>> 8, j[L + 198 | 0] = de >>> 16, j[L + 199 | 0] = de >>> 24, be = (Ie = l[L + 72 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 76 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[L + 200 | 0] = ae, j[L + 201 | 0] = ae >>> 8, j[L + 202 | 0] = ae >>> 16, j[L + 203 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[L + 204 | 0] = de, j[L + 205 | 0] = de >>> 8, j[L + 206 | 0] = de >>> 16, j[L + 207 | 0] = de >>> 24, $s(L, L + 80 | 0, le, le + 640 | 0), be = (Ie = l[L >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 4 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[0 | Z] = ae, j[Z + 1 | 0] = ae >>> 8, j[Z + 2 | 0] = ae >>> 16, j[Z + 3 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[Z + 4 | 0] = de, j[Z + 5 | 0] = de >>> 8, j[Z + 6 | 0] = de >>> 16, j[Z + 7 | 0] = de >>> 24, be = (Ie = l[L + 8 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 12 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[Z + 8 | 0] = ae, j[Z + 9 | 0] = ae >>> 8, j[Z + 10 | 0] = ae >>> 16, j[Z + 11 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[Z + 12 | 0] = de, j[Z + 13 | 0] = de >>> 8, j[Z + 14 | 0] = de >>> 16, j[Z + 15 | 0] = de >>> 24, be = (Ie = l[L + 16 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 20 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[Z + 16 | 0] = ae, j[Z + 17 | 0] = ae >>> 8, j[Z + 18 | 0] = ae >>> 16, j[Z + 19 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[Z + 20 | 0] = de, j[Z + 21 | 0] = de >>> 8, j[Z + 22 | 0] = de >>> 16, j[Z + 23 | 0] = de >>> 24, be = (Ie = l[L + 24 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 28 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[Z + 24 | 0] = ae, j[Z + 25 | 0] = ae >>> 8, j[Z + 26 | 0] = ae >>> 16, j[Z + 27 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[Z + 28 | 0] = de, j[Z + 29 | 0] = de >>> 8, j[Z + 30 | 0] = de >>> 16, j[Z + 31 | 0] = de >>> 24, be = (Ie = l[L + 32 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 36 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[Z + 32 | 0] = ae, j[Z + 33 | 0] = ae >>> 8, j[Z + 34 | 0] = ae >>> 16, j[Z + 35 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[Z + 36 | 0] = de, j[Z + 37 | 0] = de >>> 8, j[Z + 38 | 0] = de >>> 16, j[Z + 39 | 0] = de >>> 24, be = (Ie = l[L + 40 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 44 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[Z + 40 | 0] = ae, j[Z + 41 | 0] = ae >>> 8, j[Z + 42 | 0] = ae >>> 16, j[Z + 43 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[Z + 44 | 0] = de, j[Z + 45 | 0] = de >>> 8, j[Z + 46 | 0] = de >>> 16, j[Z + 47 | 0] = de >>> 24, be = (Ie = l[L + 48 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, ae = Ue | q << 8 | -16777216 & ((255 & (ae = l[L + 52 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & ae) << 8 | Ie >>> 24) | ae >>> 8 & 65280 | ae >>> 24, j[Z + 48 | 0] = ae, j[Z + 49 | 0] = ae >>> 8, j[Z + 50 | 0] = ae >>> 16, j[Z + 51 | 0] = ae >>> 24, de = (ae = de | Qe | be) | (de = 0) | de | 0, j[Z + 52 | 0] = de, j[Z + 53 | 0] = de >>> 8, j[Z + 54 | 0] = de >>> 16, j[Z + 55 | 0] = de >>> 24, be = (Ie = l[L + 56 >> 2]) << 24 | (65280 & Ie) << 8, de = (Qe = 16711680 & Ie) >>> 8 | 0, ae = Z, Ue = Qe << 24, Qe = (q = -16777216 & Ie) >>> 24 | 0, Z = Ue | q << 8 | -16777216 & ((255 & (Z = l[L + 60 >> 2])) << 24 | Ie >>> 8) | 16711680 & ((16777215 & Z) << 8 | Ie >>> 24) | Z >>> 8 & 65280 | Z >>> 24, j[ae + 56 | 0] = Z, j[ae + 57 | 0] = Z >>> 8, j[ae + 58 | 0] = Z >>> 16, j[ae + 59 | 0] = Z >>> 24, Z = (Z = de | Qe | be) | (de = 0) | de | 0, j[ae + 60 | 0] = Z, j[ae + 61 | 0] = Z >>> 8, j[ae + 62 | 0] = Z >>> 16, j[ae + 63 | 0] = Z >>> 24, Ro(le, 704), Ro(L, 208), st = le + 704 | 0;
                    }
                    function ua(L, Z, le) {
                      var ae, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0;
                      st = ae = st + -64 | 0;
                      e: {
                        if ((le - 65 & 255) >>> 0 > 191) {
                          if (de = -1, !(B[L + 80 | 0] | B[L + 81 | 0] << 8 | B[L + 82 | 0] << 16 | B[L + 83 | 0] << 24 | B[L + 84 | 0] | B[L + 85 | 0] << 8 | B[L + 86 | 0] << 16 | B[L + 87 | 0] << 24)) {
                            if ((q = B[L + 352 | 0] | B[L + 353 | 0] << 8 | B[L + 354 | 0] << 16 | B[L + 355 | 0] << 24) >>> 0 >= 129) {
                              if (Qe = B[0 | (de = L - -64 | 0)] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, be = Ie = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, Ie = (q = Qe + 128 | 0) >>> 0 < 128 ? Ie + 1 | 0 : Ie, j[0 | de] = q, j[de + 1 | 0] = q >>> 8, j[de + 2 | 0] = q >>> 16, j[de + 3 | 0] = q >>> 24, j[de + 4 | 0] = Ie, j[de + 5 | 0] = Ie >>> 8, j[de + 6 | 0] = Ie >>> 16, j[de + 7 | 0] = Ie >>> 24, Ie = B[L + 76 | 0] | B[L + 77 | 0] << 8 | B[L + 78 | 0] << 16 | B[L + 79 | 0] << 24, Ie = (de = (0 | be) == -1 & Qe >>> 0 > 4294967167) >>> 0 > (Qe = de + (B[L + 72 | 0] | B[L + 73 | 0] << 8 | B[L + 74 | 0] << 16 | B[L + 75 | 0] << 24) | 0) >>> 0 ? Ie + 1 | 0 : Ie, j[L + 72 | 0] = Qe, j[L + 73 | 0] = Qe >>> 8, j[L + 74 | 0] = Qe >>> 16, j[L + 75 | 0] = Qe >>> 24, j[L + 76 | 0] = Ie, j[L + 77 | 0] = Ie >>> 8, j[L + 78 | 0] = Ie >>> 16, j[L + 79 | 0] = Ie >>> 24, Bs(L, Ie = L + 96 | 0), de = (B[L + 352 | 0] | B[L + 353 | 0] << 8 | B[L + 354 | 0] << 16 | B[L + 355 | 0] << 24) - 128 | 0, j[L + 352 | 0] = de, j[L + 353 | 0] = de >>> 8, j[L + 354 | 0] = de >>> 16, j[L + 355 | 0] = de >>> 24, de >>> 0 >= 129)
                                break e;
                              yt(Ie, L + 224 | 0, de), q = B[L + 352 | 0] | B[L + 353 | 0] << 8 | B[L + 354 | 0] << 16 | B[L + 355 | 0] << 24;
                            }
                            Ie = B[0 | (de = L - -64 | 0)] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, Qe = Ue = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, Qe = (be = Ie + q | 0) >>> 0 < q >>> 0 ? Qe + 1 | 0 : Qe, j[0 | de] = be, j[de + 1 | 0] = be >>> 8, j[de + 2 | 0] = be >>> 16, j[de + 3 | 0] = be >>> 24, j[de + 4 | 0] = Qe, j[de + 5 | 0] = Qe >>> 8, j[de + 6 | 0] = Qe >>> 16, j[de + 7 | 0] = Qe >>> 24, de = (0 | Qe) == (0 | Ue) & Ie >>> 0 > be >>> 0 | Qe >>> 0 < Ue >>> 0, Ie = B[L + 76 | 0] | B[L + 77 | 0] << 8 | B[L + 78 | 0] << 16 | B[L + 79 | 0] << 24, Ie = (Qe = de + (B[L + 72 | 0] | B[L + 73 | 0] << 8 | B[L + 74 | 0] << 16 | B[L + 75 | 0] << 24) | 0) >>> 0 < de >>> 0 ? Ie + 1 | 0 : Ie, j[L + 72 | 0] = Qe, j[L + 73 | 0] = Qe >>> 8, j[L + 74 | 0] = Qe >>> 16, j[L + 75 | 0] = Qe >>> 24, j[L + 76 | 0] = Ie, j[L + 77 | 0] = Ie >>> 8, j[L + 78 | 0] = Ie >>> 16, j[L + 79 | 0] = Ie >>> 24, B[L + 356 | 0] && (j[L + 88 | 0] = 255, j[L + 89 | 0] = 255, j[L + 90 | 0] = 255, j[L + 91 | 0] = 255, j[L + 92 | 0] = 255, j[L + 93 | 0] = 255, j[L + 94 | 0] = 255, j[L + 95 | 0] = 255), j[L + 80 | 0] = 255, j[L + 81 | 0] = 255, j[L + 82 | 0] = 255, j[L + 83 | 0] = 255, j[L + 84 | 0] = 255, j[L + 85 | 0] = 255, j[L + 86 | 0] = 255, j[L + 87 | 0] = 255, Rt((de = L + 96 | 0) + q | 0, 0, 256 - q | 0), Bs(L, de), Ie = B[L + 4 | 0] | B[L + 5 | 0] << 8 | B[L + 6 | 0] << 16 | B[L + 7 | 0] << 24, l[ae >> 2] = B[0 | L] | B[L + 1 | 0] << 8 | B[L + 2 | 0] << 16 | B[L + 3 | 0] << 24, l[ae + 4 >> 2] = Ie, Ie = B[L + 12 | 0] | B[L + 13 | 0] << 8 | B[L + 14 | 0] << 16 | B[L + 15 | 0] << 24, l[ae + 8 >> 2] = B[L + 8 | 0] | B[L + 9 | 0] << 8 | B[L + 10 | 0] << 16 | B[L + 11 | 0] << 24, l[ae + 12 >> 2] = Ie, Ie = B[L + 20 | 0] | B[L + 21 | 0] << 8 | B[L + 22 | 0] << 16 | B[L + 23 | 0] << 24, l[ae + 16 >> 2] = B[L + 16 | 0] | B[L + 17 | 0] << 8 | B[L + 18 | 0] << 16 | B[L + 19 | 0] << 24, l[ae + 20 >> 2] = Ie, Ie = B[L + 28 | 0] | B[L + 29 | 0] << 8 | B[L + 30 | 0] << 16 | B[L + 31 | 0] << 24, l[ae + 24 >> 2] = B[L + 24 | 0] | B[L + 25 | 0] << 8 | B[L + 26 | 0] << 16 | B[L + 27 | 0] << 24, l[ae + 28 >> 2] = Ie, Ie = B[L + 36 | 0] | B[L + 37 | 0] << 8 | B[L + 38 | 0] << 16 | B[L + 39 | 0] << 24, l[ae + 32 >> 2] = B[L + 32 | 0] | B[L + 33 | 0] << 8 | B[L + 34 | 0] << 16 | B[L + 35 | 0] << 24, l[ae + 36 >> 2] = Ie, Ie = B[L + 44 | 0] | B[L + 45 | 0] << 8 | B[L + 46 | 0] << 16 | B[L + 47 | 0] << 24, l[ae + 40 >> 2] = B[L + 40 | 0] | B[L + 41 | 0] << 8 | B[L + 42 | 0] << 16 | B[L + 43 | 0] << 24, l[ae + 44 >> 2] = Ie, Ie = B[L + 52 | 0] | B[L + 53 | 0] << 8 | B[L + 54 | 0] << 16 | B[L + 55 | 0] << 24, l[ae + 48 >> 2] = B[L + 48 | 0] | B[L + 49 | 0] << 8 | B[L + 50 | 0] << 16 | B[L + 51 | 0] << 24, l[ae + 52 >> 2] = Ie, Ie = B[L + 60 | 0] | B[L + 61 | 0] << 8 | B[L + 62 | 0] << 16 | B[L + 63 | 0] << 24, l[ae + 56 >> 2] = B[L + 56 | 0] | B[L + 57 | 0] << 8 | B[L + 58 | 0] << 16 | B[L + 59 | 0] << 24, l[ae + 60 >> 2] = Ie, yt(Z, ae, le), Ro(L, 64), Ro(de, 256), de = 0;
                          }
                          return st = ae - -64 | 0, de;
                        }
                        Ko(), Xr();
                      }
                      Hs(1280, 1142, 306, 1086), Xr();
                    }
                    function wa(L, Z) {
                      var le, ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt, ot, _t, qt, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0;
                      for (st = le = st - 320 | 0, ca(ae = L + 40 | 0, Z), l[L + 84 >> 2] = 0, l[L + 88 >> 2] = 0, l[L + 80 >> 2] = 1, l[L + 92 >> 2] = 0, l[L + 96 >> 2] = 0, l[L + 100 >> 2] = 0, l[L + 104 >> 2] = 0, l[L + 108 >> 2] = 0, l[L + 112 >> 2] = 0, l[L + 116 >> 2] = 0, Cn(gn = le + 240 | 0, ae), rr(Vt = le + 192 | 0, gn, 1344), Bn = -1, de = l[le + 240 >> 2] - 1 | 0, l[le + 240 >> 2] = de, l[le + 192 >> 2] = l[le + 192 >> 2] + 1, Ie = l[le + 244 >> 2], Qe = l[le + 248 >> 2], q = l[le + 252 >> 2], be = l[le + 256 >> 2], Ue = l[le + 260 >> 2], Ye = l[le + 264 >> 2], Te = l[le + 268 >> 2], Ne = l[le + 272 >> 2], We = l[le + 276 >> 2], Cn(un = le + 144 | 0, Vt), rr(un, un, Vt), Cn(L, un), rr(L, L, Vt), rr(L, L, gn), st = xt = st - 144 | 0, Cn(Mt = xt + 96 | 0, L), Cn(tt = xt + 48 | 0, Mt), Cn(tt, tt), rr(tt, L, tt), rr(Mt, Mt, tt), Cn(Mt, Mt), rr(Mt, tt, Mt), Cn(tt, Mt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), rr(Mt, tt, Mt), Cn(tt, Mt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), rr(tt, tt, Mt), Cn(xt, tt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), Cn(xt, xt), rr(tt, xt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), rr(Mt, tt, Mt), Cn(tt, Mt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), rr(tt, tt, Mt), Cn(xt, tt), tt = 1; Cn(xt, xt), (0 | (tt = tt + 1 | 0)) != 100; )
                        ;
                      rr(tt = xt + 48 | 0, xt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), Cn(tt, tt), rr(Mt = xt + 96 | 0, tt, Mt), Cn(Mt, Mt), Cn(Mt, Mt), rr(L, Mt, L), st = xt + 144 | 0, rr(L, L, un), rr(L, L, gn), Cn(tt = le + 96 | 0, L), rr(tt, tt, Vt), tt = l[le + 132 >> 2], l[le + 84 >> 2] = tt - We, xt = l[le + 128 >> 2], l[le + 80 >> 2] = xt - Ne, Mt = l[le + 124 >> 2], l[le + 76 >> 2] = Mt - Te, Vt = l[le + 120 >> 2], l[le + 72 >> 2] = Vt - Ye, un = l[le + 116 >> 2], l[le + 68 >> 2] = un - Ue, gn = l[le + 112 >> 2], l[le + 64 >> 2] = gn - be, rt = l[le + 108 >> 2], l[le + 60 >> 2] = rt - q, ot = l[le + 104 >> 2], l[le + 56 >> 2] = ot - Qe, _t = l[le + 100 >> 2], l[le + 52 >> 2] = _t - Ie, qt = l[le + 96 >> 2], l[le + 48 >> 2] = qt - de, ms(le, le + 48 | 0);
                      e: {
                        if (!Ts(le, 32)) {
                          if (l[le + 36 >> 2] = tt + We, l[le + 32 >> 2] = xt + Ne, l[le + 28 >> 2] = Mt + Te, l[le + 24 >> 2] = Vt + Ye, l[le + 20 >> 2] = un + Ue, l[le + 16 >> 2] = gn + be, l[le + 12 >> 2] = q + rt, l[le + 8 >> 2] = Qe + ot, l[le + 4 >> 2] = Ie + _t, l[le >> 2] = de + qt, ms(tt = le + 288 | 0, le), !Ts(tt, 32))
                            break e;
                          rr(L, L, 1392);
                        }
                        ms(le + 288 | 0, L), (1 & j[le + 288 | 0]) == (B[Z + 31 | 0] >>> 7 | 0) && (l[L >> 2] = 0 - l[L >> 2], l[L + 36 >> 2] = 0 - l[L + 36 >> 2], l[L + 32 >> 2] = 0 - l[L + 32 >> 2], l[L + 28 >> 2] = 0 - l[L + 28 >> 2], l[L + 24 >> 2] = 0 - l[L + 24 >> 2], l[L + 20 >> 2] = 0 - l[L + 20 >> 2], l[L + 16 >> 2] = 0 - l[L + 16 >> 2], l[L + 12 >> 2] = 0 - l[L + 12 >> 2], l[L + 8 >> 2] = 0 - l[L + 8 >> 2], l[L + 4 >> 2] = 0 - l[L + 4 >> 2]), rr(L + 120 | 0, L, ae), Bn = 0;
                      }
                      return st = le + 320 | 0, Bn;
                    }
                    function In(L, Z, le) {
                      var ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0;
                      for (xt = 1634760805, _t = ae = B[0 | le] | B[le + 1 | 0] << 8 | B[le + 2 | 0] << 16 | B[le + 3 | 0] << 24, Mt = de = B[le + 4 | 0] | B[le + 5 | 0] << 8 | B[le + 6 | 0] << 16 | B[le + 7 | 0] << 24, Vt = Ie = B[le + 8 | 0] | B[le + 9 | 0] << 8 | B[le + 10 | 0] << 16 | B[le + 11 | 0] << 24, un = Qe = B[le + 12 | 0] | B[le + 13 | 0] << 8 | B[le + 14 | 0] << 16 | B[le + 15 | 0] << 24, Pt = 857760878, gn = q = B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24, qt = be = B[Z + 4 | 0] | B[Z + 5 | 0] << 8 | B[Z + 6 | 0] << 16 | B[Z + 7 | 0] << 24, Tn = Ue = B[Z + 8 | 0] | B[Z + 9 | 0] << 8 | B[Z + 10 | 0] << 16 | B[Z + 11 | 0] << 24, An = Ye = B[Z + 12 | 0] | B[Z + 13 | 0] << 8 | B[Z + 14 | 0] << 16 | B[Z + 15 | 0] << 24, Z = 2036477234, tt = Te = B[le + 16 | 0] | B[le + 17 | 0] << 8 | B[le + 18 | 0] << 16 | B[le + 19 | 0] << 24, ot = 1797285236, kn = Ne = B[le + 28 | 0] | B[le + 29 | 0] << 8 | B[le + 30 | 0] << 16 | B[le + 31 | 0] << 24, Dt = We = B[le + 24 | 0] | B[le + 25 | 0] << 8 | B[le + 26 | 0] << 16 | B[le + 27 | 0] << 24, le = rt = B[le + 20 | 0] | B[le + 21 | 0] << 8 | B[le + 22 | 0] << 16 | B[le + 23 | 0] << 24; Bn = Rn(_t + Pt | 0, 7) ^ An, Dn = Rn(Bn + Pt | 0, 9) ^ Dt, un = Rn(le + xt | 0, 7) ^ un, De = Rn(un + xt | 0, 9) ^ Tn, Xn = Rn(De + un | 0, 13) ^ le, Vt = Rn(ot + tt | 0, 7) ^ Vt, Vn = Rn(Vt + ot | 0, 9) ^ qt, Tn = Rn(Vt + Vn | 0, 13) ^ tt, tt = Rn(Vn + Tn | 0, 18) ^ ot, qt = Rn(Z + gn | 0, 7) ^ kn, le = Xn ^ Rn(tt + qt | 0, 7), Dt = Dn ^ Rn(le + tt | 0, 9), kn = Rn(le + Dt | 0, 13) ^ qt, ot = Rn(Dt + kn | 0, 18) ^ tt, Mt = Rn(Z + qt | 0, 9) ^ Mt, gn = Rn(Mt + qt | 0, 13) ^ gn, Z = Rn(gn + Mt | 0, 18) ^ Z, tt = Rn(Z + Bn | 0, 7) ^ Tn, Tn = Rn(tt + Z | 0, 9) ^ De, An = Rn(tt + Tn | 0, 13) ^ Bn, Z = Rn(Tn + An | 0, 18) ^ Z, Bn = Rn(Bn + Dn | 0, 13) ^ _t, _t = Rn(Bn + Dn | 0, 18) ^ Pt, gn = Rn(_t + un | 0, 7) ^ gn, qt = Rn(gn + _t | 0, 9) ^ Vn, un = Rn(qt + gn | 0, 13) ^ un, Pt = Rn(qt + un | 0, 18) ^ _t, xt = Rn(De + Xn | 0, 18) ^ xt, _t = Rn(xt + Vt | 0, 7) ^ Bn, Mt = Rn(_t + xt | 0, 9) ^ Mt, Vt = Rn(_t + Mt | 0, 13) ^ Vt, xt = Rn(Mt + Vt | 0, 18) ^ xt, Bn = nr >>> 0 < 18, nr = nr + 2 | 0, Bn; )
                        ;
                      ot = ot + 1797285236 | 0, j[L + 60 | 0] = ot, j[L + 61 | 0] = ot >>> 8, j[L + 62 | 0] = ot >>> 16, j[L + 63 | 0] = ot >>> 24, ot = kn + Ne | 0, j[L + 56 | 0] = ot, j[L + 57 | 0] = ot >>> 8, j[L + 58 | 0] = ot >>> 16, j[L + 59 | 0] = ot >>> 24, ot = Dt + We | 0, j[L + 52 | 0] = ot, j[L + 53 | 0] = ot >>> 8, j[L + 54 | 0] = ot >>> 16, j[L + 55 | 0] = ot >>> 24, le = le + rt | 0, j[L + 48 | 0] = le, j[L + 49 | 0] = le >>> 8, j[L + 50 | 0] = le >>> 16, j[L + 51 | 0] = le >>> 24, le = tt + Te | 0, j[L + 44 | 0] = le, j[L + 45 | 0] = le >>> 8, j[L + 46 | 0] = le >>> 16, j[L + 47 | 0] = le >>> 24, Z = Z + 2036477234 | 0, j[L + 40 | 0] = Z, j[L + 41 | 0] = Z >>> 8, j[L + 42 | 0] = Z >>> 16, j[L + 43 | 0] = Z >>> 24, Z = An + Ye | 0, j[L + 36 | 0] = Z, j[L + 37 | 0] = Z >>> 8, j[L + 38 | 0] = Z >>> 16, j[L + 39 | 0] = Z >>> 24, Z = Tn + Ue | 0, j[L + 32 | 0] = Z, j[L + 33 | 0] = Z >>> 8, j[L + 34 | 0] = Z >>> 16, j[L + 35 | 0] = Z >>> 24, Z = qt + be | 0, j[L + 28 | 0] = Z, j[L + 29 | 0] = Z >>> 8, j[L + 30 | 0] = Z >>> 16, j[L + 31 | 0] = Z >>> 24, Z = gn + q | 0, j[L + 24 | 0] = Z, j[L + 25 | 0] = Z >>> 8, j[L + 26 | 0] = Z >>> 16, j[L + 27 | 0] = Z >>> 24, Z = Pt + 857760878 | 0, j[L + 20 | 0] = Z, j[L + 21 | 0] = Z >>> 8, j[L + 22 | 0] = Z >>> 16, j[L + 23 | 0] = Z >>> 24, Z = un + Qe | 0, j[L + 16 | 0] = Z, j[L + 17 | 0] = Z >>> 8, j[L + 18 | 0] = Z >>> 16, j[L + 19 | 0] = Z >>> 24, Z = Vt + Ie | 0, j[L + 12 | 0] = Z, j[L + 13 | 0] = Z >>> 8, j[L + 14 | 0] = Z >>> 16, j[L + 15 | 0] = Z >>> 24, Z = Mt + de | 0, j[L + 8 | 0] = Z, j[L + 9 | 0] = Z >>> 8, j[L + 10 | 0] = Z >>> 16, j[L + 11 | 0] = Z >>> 24, Z = _t + ae | 0, j[L + 4 | 0] = Z, j[L + 5 | 0] = Z >>> 8, j[L + 6 | 0] = Z >>> 16, j[L + 7 | 0] = Z >>> 24, Z = xt + 1634760805 | 0, j[0 | L] = Z, j[L + 1 | 0] = Z >>> 8, j[L + 2 | 0] = Z >>> 16, j[L + 3 | 0] = Z >>> 24;
                    }
                    function Ys(L, Z, le, ae) {
                      var de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0;
                      if (rt = l[L + 36 >> 2], Ne = l[L + 32 >> 2], We = l[L + 28 >> 2], Ye = l[L + 24 >> 2], Te = l[L + 20 >> 2], !ae & le >>> 0 >= 16 | ae)
                        for (Bn = !B[L + 80 | 0] << 24, _t = l[L + 4 >> 2], Tn = wr(_t, 5), tt = l[L + 8 >> 2], un = wr(tt, 5), Mt = l[L + 12 >> 2], Vt = wr(Mt, 5), gn = l[L + 16 >> 2], xt = wr(gn, 5), qt = l[L >> 2]; de = dt(Qe = ((B[Z + 3 | 0] | B[Z + 4 | 0] << 8 | B[Z + 5 | 0] << 16 | B[Z + 6 | 0] << 24) >>> 2 & 67108863) + Ye | 0, 0, Mt, 0), be = Oe, Te = (q = dt(Ye = (67108863 & (B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24)) + Te | 0, 0, gn, 0)) + de | 0, de = Oe + be | 0, de = q >>> 0 > Te >>> 0 ? de + 1 | 0 : de, be = dt(We = ((B[Z + 6 | 0] | B[Z + 7 | 0] << 8 | B[Z + 8 | 0] << 16 | B[Z + 9 | 0] << 24) >>> 4 & 67108863) + We | 0, 0, tt, 0), de = Oe + de | 0, de = be >>> 0 > (Te = be + Te | 0) >>> 0 ? de + 1 | 0 : de, be = dt(Ne = ((B[Z + 9 | 0] | B[Z + 10 | 0] << 8 | B[Z + 11 | 0] << 16 | B[Z + 12 | 0] << 24) >>> 6 | 0) + Ne | 0, 0, _t, 0), de = Oe + de | 0, de = be >>> 0 > (Te = be + Te | 0) >>> 0 ? de + 1 | 0 : de, be = dt(rt = rt + Bn + ((B[Z + 12 | 0] | B[Z + 13 | 0] << 8 | B[Z + 14 | 0] << 16 | B[Z + 15 | 0] << 24) >>> 8) | 0, 0, qt, 0), de = Oe + de | 0, Pt = Te = be + Te | 0, Te = be >>> 0 > Te >>> 0 ? de + 1 | 0 : de, de = dt(Qe, 0, tt, 0), be = Oe, q = dt(Ye, 0, Mt, 0), Ie = Oe + be | 0, Ie = (de = q + de | 0) >>> 0 < q >>> 0 ? Ie + 1 | 0 : Ie, be = (q = dt(We, 0, _t, 0)) + de | 0, de = Oe + Ie | 0, de = q >>> 0 > be >>> 0 ? de + 1 | 0 : de, q = dt(Ne, 0, qt, 0), de = Oe + de | 0, de = q >>> 0 > (be = q + be | 0) >>> 0 ? de + 1 | 0 : de, q = dt(rt, 0, xt, 0), de = Oe + de | 0, Dt = be = q + be | 0, be = q >>> 0 > be >>> 0 ? de + 1 | 0 : de, de = dt(Qe, 0, _t, 0), Ue = Oe, q = (Ie = dt(Ye, 0, tt, 0)) + de | 0, de = Oe + Ue | 0, de = Ie >>> 0 > q >>> 0 ? de + 1 | 0 : de, Ue = dt(We, 0, qt, 0), Ie = Oe + de | 0, Ie = (q = Ue + q | 0) >>> 0 < Ue >>> 0 ? Ie + 1 | 0 : Ie, Ue = dt(Ne, 0, xt, 0), de = Oe + Ie | 0, de = (q = Ue + q | 0) >>> 0 < Ue >>> 0 ? de + 1 | 0 : de, Ue = dt(rt, 0, Vt, 0), de = Oe + de | 0, An = q = Ue + q | 0, q = q >>> 0 < Ue >>> 0 ? de + 1 | 0 : de, de = dt(Qe, 0, qt, 0), Ie = Oe, Ue = (ot = dt(Ye, 0, _t, 0)) + de | 0, de = Oe + Ie | 0, de = Ue >>> 0 < ot >>> 0 ? de + 1 | 0 : de, Ie = dt(We, 0, xt, 0), de = Oe + de | 0, de = Ie >>> 0 > (Ue = Ie + Ue | 0) >>> 0 ? de + 1 | 0 : de, ot = dt(Ne, 0, Vt, 0), Ie = Oe + de | 0, Ie = (Ue = ot + Ue | 0) >>> 0 < ot >>> 0 ? Ie + 1 | 0 : Ie, ot = dt(rt, 0, un, 0), de = Oe + Ie | 0, de = (Ue = ot + Ue | 0) >>> 0 < ot >>> 0 ? de + 1 | 0 : de, ot = Ue, Ue = de, de = dt(Qe, 0, xt, 0), Ie = Oe, Qe = (Ye = dt(Ye, 0, qt, 0)) + de | 0, de = Oe + Ie | 0, de = Qe >>> 0 < Ye >>> 0 ? de + 1 | 0 : de, Ye = dt(We, 0, Vt, 0), de = Oe + de | 0, de = (Qe = Ye + Qe | 0) >>> 0 < Ye >>> 0 ? de + 1 | 0 : de, Ye = dt(Ne, 0, un, 0), de = Oe + de | 0, de = (Qe = Ye + Qe | 0) >>> 0 < Ye >>> 0 ? de + 1 | 0 : de, Ye = dt(rt, 0, Tn, 0), Ie = Oe + de | 0, Ie = (Qe = Ye + Qe | 0) >>> 0 < Ye >>> 0 ? Ie + 1 | 0 : Ie, Ye = Qe, de = Ue, de = (Qe = (We = (67108863 & Ie) << 6 | Qe >>> 26) + ot | 0) >>> 0 < We >>> 0 ? de + 1 | 0 : de, We = Qe, Ne = (67108863 & de) << 6 | Qe >>> 26, de = q, de = (Qe = Ne + An | 0) >>> 0 < Ne >>> 0 ? de + 1 | 0 : de, Ne = Qe, Ie = be, rt = de = (Qe = (67108863 & de) << 6 | Qe >>> 26) + Dt | 0, be = (67108863 & (Ie = de >>> 0 < Qe >>> 0 ? Ie + 1 | 0 : Ie)) << 6 | de >>> 26, de = Te, Ye = (67108863 & We) + ((de = wr((67108863 & ((Qe = be + Pt | 0) >>> 0 < be >>> 0 ? de + 1 | 0 : de)) << 6 | Qe >>> 26, 5) + (67108863 & Ye) | 0) >>> 26 | 0) | 0, We = 67108863 & Ne, Ne = 67108863 & rt, rt = 67108863 & Qe, Te = 67108863 & de, Z = Z + 16 | 0, !(ae = ae - (le >>> 0 < 16) | 0) & (le = le - 16 | 0) >>> 0 > 15 | ae; )
                          ;
                      l[L + 20 >> 2] = Te, l[L + 36 >> 2] = rt, l[L + 32 >> 2] = Ne, l[L + 28 >> 2] = We, l[L + 24 >> 2] = Ye;
                    }
                    function Zs(L, Z, le, ae) {
                      L |= 0, Z |= 0;
                      var de = 0;
                      return de = -1, (ae |= 0) - 65 >>> 0 < 4294967232 | (le |= 0) >>> 0 > 64 || (le && Z ? (st = de = st - 128 | 0, !Z | ((ae &= 255) - 65 & 255) >>> 0 <= 191 | ((le &= 255) - 65 & 255) >>> 0 <= 191 ? (Ko(), Xr()) : (Rt(L - -64 | 0, 0, 293), j[L + 56 | 0] = 121, j[L + 57 | 0] = 33, j[L + 58 | 0] = 126, j[L + 59 | 0] = 19, j[L + 60 | 0] = 25, j[L + 61 | 0] = 205, j[L + 62 | 0] = 224, j[L + 63 | 0] = 91, j[L + 48 | 0] = 107, j[L + 49 | 0] = 189, j[L + 50 | 0] = 65, j[L + 51 | 0] = 251, j[L + 52 | 0] = 171, j[L + 53 | 0] = 217, j[L + 54 | 0] = 131, j[L + 55 | 0] = 31, j[L + 40 | 0] = 31, j[L + 41 | 0] = 108, j[L + 42 | 0] = 62, j[L + 43 | 0] = 43, j[L + 44 | 0] = 140, j[L + 45 | 0] = 104, j[L + 46 | 0] = 5, j[L + 47 | 0] = 155, j[L + 32 | 0] = 209, j[L + 33 | 0] = 130, j[L + 34 | 0] = 230, j[L + 35 | 0] = 173, j[L + 36 | 0] = 127, j[L + 37 | 0] = 82, j[L + 38 | 0] = 14, j[L + 39 | 0] = 81, j[L + 24 | 0] = 241, j[L + 25 | 0] = 54, j[L + 26 | 0] = 29, j[L + 27 | 0] = 95, j[L + 28 | 0] = 58, j[L + 29 | 0] = 245, j[L + 30 | 0] = 79, j[L + 31 | 0] = 165, j[L + 16 | 0] = 43, j[L + 17 | 0] = 248, j[L + 18 | 0] = 148, j[L + 19 | 0] = 254, j[L + 20 | 0] = 114, j[L + 21 | 0] = 243, j[L + 22 | 0] = 110, j[L + 23 | 0] = 60, j[L + 8 | 0] = 59, j[L + 9 | 0] = 167, j[L + 10 | 0] = 202, j[L + 11 | 0] = 132, j[L + 12 | 0] = 133, j[L + 13 | 0] = 174, j[L + 14 | 0] = 103, j[L + 15 | 0] = 187, ae = -222443256 ^ (le << 8 | ae), j[0 | L] = ae, j[L + 1 | 0] = ae >>> 8, j[L + 2 | 0] = ae >>> 16, j[L + 3 | 0] = ae >>> 24, ae = le >>> 24 ^ 1779033703, j[L + 4 | 0] = ae, j[L + 5 | 0] = ae >>> 8, j[L + 6 | 0] = ae >>> 16, j[L + 7 | 0] = ae >>> 24, Rt(le + de | 0, 0, le << 24 >> 24 >= 0 ? 128 - le | 0 : 0), le = yt(de, Z, le), yt(L + 96 | 0, le, 128), Z = 128 + (B[L + 352 | 0] | B[L + 353 | 0] << 8 | B[L + 354 | 0] << 16 | B[L + 355 | 0] << 24) | 0, j[L + 352 | 0] = Z, j[L + 353 | 0] = Z >>> 8, j[L + 354 | 0] = Z >>> 16, j[L + 355 | 0] = Z >>> 24, Ro(le, 128), st = le + 128 | 0)) : (((Z = 255 & ae) - 65 & 255) >>> 0 <= 191 && (Ko(), Xr()), Rt(L - -64 | 0, 0, 293), j[L + 56 | 0] = 121, j[L + 57 | 0] = 33, j[L + 58 | 0] = 126, j[L + 59 | 0] = 19, j[L + 60 | 0] = 25, j[L + 61 | 0] = 205, j[L + 62 | 0] = 224, j[L + 63 | 0] = 91, j[L + 48 | 0] = 107, j[L + 49 | 0] = 189, j[L + 50 | 0] = 65, j[L + 51 | 0] = 251, j[L + 52 | 0] = 171, j[L + 53 | 0] = 217, j[L + 54 | 0] = 131, j[L + 55 | 0] = 31, j[L + 40 | 0] = 31, j[L + 41 | 0] = 108, j[L + 42 | 0] = 62, j[L + 43 | 0] = 43, j[L + 44 | 0] = 140, j[L + 45 | 0] = 104, j[L + 46 | 0] = 5, j[L + 47 | 0] = 155, j[L + 32 | 0] = 209, j[L + 33 | 0] = 130, j[L + 34 | 0] = 230, j[L + 35 | 0] = 173, j[L + 36 | 0] = 127, j[L + 37 | 0] = 82, j[L + 38 | 0] = 14, j[L + 39 | 0] = 81, j[L + 24 | 0] = 241, j[L + 25 | 0] = 54, j[L + 26 | 0] = 29, j[L + 27 | 0] = 95, j[L + 28 | 0] = 58, j[L + 29 | 0] = 245, j[L + 30 | 0] = 79, j[L + 31 | 0] = 165, j[L + 16 | 0] = 43, j[L + 17 | 0] = 248, j[L + 18 | 0] = 148, j[L + 19 | 0] = 254, j[L + 20 | 0] = 114, j[L + 21 | 0] = 243, j[L + 22 | 0] = 110, j[L + 23 | 0] = 60, j[L + 8 | 0] = 59, j[L + 9 | 0] = 167, j[L + 10 | 0] = 202, j[L + 11 | 0] = 132, j[L + 12 | 0] = 133, j[L + 13 | 0] = 174, j[L + 14 | 0] = 103, j[L + 15 | 0] = 187, Z ^= -222443256, j[0 | L] = Z, j[L + 1 | 0] = Z >>> 8, j[L + 2 | 0] = Z >>> 16, j[L + 3 | 0] = Z >>> 24, j[L + 4 | 0] = 103, j[L + 5 | 0] = 230, j[L + 6 | 0] = 9, j[L + 7 | 0] = 106), de = 0), 0 | de;
                    }
                    function Ia(L, Z, le) {
                      var ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0;
                      rt = l[Z + 40 >> 2], ot = l[Z + 4 >> 2], qt = l[Z + 44 >> 2], tt = l[Z + 8 >> 2], xt = l[Z + 48 >> 2], Mt = l[Z + 12 >> 2], Vt = l[Z + 52 >> 2], un = l[Z + 16 >> 2], gn = l[Z + 56 >> 2], Bn = l[Z + 20 >> 2], Tn = l[Z + 60 >> 2], Pt = l[Z + 24 >> 2], Dt = l[(_t = Z - -64 | 0) >> 2], An = l[Z + 28 >> 2], kn = l[Z + 68 >> 2], Dn = l[Z + 32 >> 2], De = l[Z + 72 >> 2], Vn = l[Z >> 2], l[L + 36 >> 2] = l[Z + 36 >> 2] + l[Z + 76 >> 2], l[L + 32 >> 2] = Dn + De, l[L + 28 >> 2] = An + kn, l[L + 24 >> 2] = Pt + Dt, l[L + 20 >> 2] = Bn + Tn, l[L + 16 >> 2] = un + gn, l[L + 12 >> 2] = Mt + Vt, l[L + 8 >> 2] = tt + xt, l[L + 4 >> 2] = ot + qt, l[L >> 2] = rt + Vn, qt = l[Z + 40 >> 2], rt = l[Z + 4 >> 2], tt = l[Z + 44 >> 2], xt = l[Z + 8 >> 2], Mt = l[Z + 48 >> 2], Vt = l[Z + 12 >> 2], un = l[Z + 52 >> 2], gn = l[Z + 16 >> 2], Bn = l[Z + 56 >> 2], Tn = l[Z + 20 >> 2], Pt = l[Z + 60 >> 2], Dt = l[Z + 24 >> 2], _t = l[_t >> 2], ot = l[Z + 28 >> 2], An = l[Z + 68 >> 2], kn = l[Z + 32 >> 2], Dn = l[Z + 72 >> 2], De = l[Z >> 2], l[L + 76 >> 2] = l[Z + 76 >> 2] - l[Z + 36 >> 2], l[L + 72 >> 2] = Dn - kn, l[L + 68 >> 2] = An - ot, l[(ot = L - -64 | 0) >> 2] = _t - Dt, l[L + 60 >> 2] = Pt - Tn, l[L + 56 >> 2] = Bn - gn, l[L + 52 >> 2] = un - Vt, l[L + 48 >> 2] = Mt - xt, l[L + 44 >> 2] = tt - rt, l[(rt = L + 40 | 0) >> 2] = qt - De, rr(L + 80 | 0, L, le + 40 | 0), rr(rt, rt, le), rr(L + 120 | 0, le + 120 | 0, Z + 120 | 0), rr(L, Z + 80 | 0, le + 80 | 0), Vn = l[L + 4 >> 2], Ie = l[L + 8 >> 2], Qe = l[L + 12 >> 2], q = l[L + 16 >> 2], be = l[L + 20 >> 2], Ue = l[L + 24 >> 2], Ye = l[L + 28 >> 2], Te = l[L + 32 >> 2], Ne = l[L + 36 >> 2], Z = l[rt >> 2], le = l[L + 80 >> 2], qt = l[L + 44 >> 2], tt = l[L + 84 >> 2], xt = l[L + 48 >> 2], Mt = l[L + 88 >> 2], Vt = l[L + 52 >> 2], un = l[L + 92 >> 2], gn = l[L + 56 >> 2], Bn = l[L + 96 >> 2], Tn = l[L + 60 >> 2], Pt = l[L + 100 >> 2], _t = l[ot >> 2], Dt = l[L + 104 >> 2], An = l[L + 68 >> 2], kn = l[L + 108 >> 2], Dn = l[L + 72 >> 2], De = l[L + 112 >> 2], We = l[L >> 2], ae = l[L + 76 >> 2], de = l[L + 116 >> 2], l[L + 76 >> 2] = ae + de, l[L + 72 >> 2] = Dn + De, l[L + 68 >> 2] = An + kn, l[ot >> 2] = _t + Dt, l[L + 60 >> 2] = Tn + Pt, l[L + 56 >> 2] = gn + Bn, l[L + 52 >> 2] = Vt + un, l[L + 48 >> 2] = xt + Mt, l[L + 44 >> 2] = qt + tt, l[rt >> 2] = Z + le, l[L + 36 >> 2] = de - ae, l[L + 32 >> 2] = De - Dn, l[L + 28 >> 2] = kn - An, l[L + 24 >> 2] = Dt - _t, l[L + 20 >> 2] = Pt - Tn, l[L + 16 >> 2] = Bn - gn, l[L + 12 >> 2] = un - Vt, l[L + 8 >> 2] = Mt - xt, l[L + 4 >> 2] = tt - qt, l[L >> 2] = le - Z, Z = l[L + 156 >> 2], le = Ne << 1, l[L + 156 >> 2] = Z + le, rt = l[L + 152 >> 2], ot = Te << 1, l[L + 152 >> 2] = rt + ot, qt = l[L + 148 >> 2], tt = Ye << 1, l[L + 148 >> 2] = qt + tt, xt = l[L + 144 >> 2], Mt = Ue << 1, l[L + 144 >> 2] = xt + Mt, Vt = l[L + 140 >> 2], un = be << 1, l[L + 140 >> 2] = Vt + un, gn = l[L + 136 >> 2], Bn = q << 1, l[L + 136 >> 2] = gn + Bn, Tn = l[L + 132 >> 2], Pt = Qe << 1, l[L + 132 >> 2] = Tn + Pt, _t = l[L + 128 >> 2], Dt = Ie << 1, l[L + 128 >> 2] = _t + Dt, An = l[L + 124 >> 2], kn = Vn << 1, l[L + 124 >> 2] = An + kn, Dn = l[L + 120 >> 2], De = We << 1, l[L + 120 >> 2] = Dn + De, l[L + 112 >> 2] = ot - rt, l[L + 108 >> 2] = tt - qt, l[L + 104 >> 2] = Mt - xt, l[L + 100 >> 2] = un - Vt, l[L + 96 >> 2] = Bn - gn, l[L + 92 >> 2] = Pt - Tn, l[L + 88 >> 2] = Dt - _t, l[L + 84 >> 2] = kn - An, l[L + 80 >> 2] = De - Dn, l[L + 116 >> 2] = le - Z;
                    }
                    function Ot(L, Z, le) {
                      var ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0;
                      rt = l[Z + 40 >> 2], ot = l[Z + 4 >> 2], qt = l[Z + 44 >> 2], tt = l[Z + 8 >> 2], xt = l[Z + 48 >> 2], Mt = l[Z + 12 >> 2], Vt = l[Z + 52 >> 2], un = l[Z + 16 >> 2], gn = l[Z + 56 >> 2], Bn = l[Z + 20 >> 2], Tn = l[Z + 60 >> 2], Pt = l[Z + 24 >> 2], Dt = l[(_t = Z - -64 | 0) >> 2], An = l[Z + 28 >> 2], kn = l[Z + 68 >> 2], Dn = l[Z + 32 >> 2], De = l[Z + 72 >> 2], Vn = l[Z >> 2], l[L + 36 >> 2] = l[Z + 36 >> 2] + l[Z + 76 >> 2], l[L + 32 >> 2] = Dn + De, l[L + 28 >> 2] = An + kn, l[L + 24 >> 2] = Pt + Dt, l[L + 20 >> 2] = Bn + Tn, l[L + 16 >> 2] = un + gn, l[L + 12 >> 2] = Mt + Vt, l[L + 8 >> 2] = tt + xt, l[L + 4 >> 2] = ot + qt, l[L >> 2] = rt + Vn, qt = l[Z + 40 >> 2], rt = l[Z + 4 >> 2], tt = l[Z + 44 >> 2], xt = l[Z + 8 >> 2], Mt = l[Z + 48 >> 2], Vt = l[Z + 12 >> 2], un = l[Z + 52 >> 2], gn = l[Z + 16 >> 2], Bn = l[Z + 56 >> 2], Tn = l[Z + 20 >> 2], Pt = l[Z + 60 >> 2], Dt = l[Z + 24 >> 2], _t = l[_t >> 2], ot = l[Z + 28 >> 2], An = l[Z + 68 >> 2], kn = l[Z + 32 >> 2], Dn = l[Z + 72 >> 2], De = l[Z >> 2], l[L + 76 >> 2] = l[Z + 76 >> 2] - l[Z + 36 >> 2], l[L + 72 >> 2] = Dn - kn, l[L + 68 >> 2] = An - ot, l[(ot = L - -64 | 0) >> 2] = _t - Dt, l[L + 60 >> 2] = Pt - Tn, l[L + 56 >> 2] = Bn - gn, l[L + 52 >> 2] = un - Vt, l[L + 48 >> 2] = Mt - xt, l[L + 44 >> 2] = tt - rt, l[(rt = L + 40 | 0) >> 2] = qt - De, rr(L + 80 | 0, L, le), rr(rt, rt, le + 40 | 0), rr(L + 120 | 0, le + 120 | 0, Z + 120 | 0), rr(L, Z + 80 | 0, le + 80 | 0), Vn = l[L + 4 >> 2], Ie = l[L + 8 >> 2], Qe = l[L + 12 >> 2], q = l[L + 16 >> 2], be = l[L + 20 >> 2], Ue = l[L + 24 >> 2], Ye = l[L + 28 >> 2], Te = l[L + 32 >> 2], Ne = l[L + 36 >> 2], Z = l[rt >> 2], le = l[L + 80 >> 2], qt = l[L + 44 >> 2], tt = l[L + 84 >> 2], xt = l[L + 48 >> 2], Mt = l[L + 88 >> 2], Vt = l[L + 52 >> 2], un = l[L + 92 >> 2], gn = l[L + 56 >> 2], Bn = l[L + 96 >> 2], Tn = l[L + 60 >> 2], Pt = l[L + 100 >> 2], _t = l[ot >> 2], Dt = l[L + 104 >> 2], An = l[L + 68 >> 2], kn = l[L + 108 >> 2], Dn = l[L + 72 >> 2], De = l[L + 112 >> 2], We = l[L >> 2], ae = l[L + 76 >> 2], de = l[L + 116 >> 2], l[L + 76 >> 2] = ae + de, l[L + 72 >> 2] = Dn + De, l[L + 68 >> 2] = An + kn, l[ot >> 2] = _t + Dt, l[L + 60 >> 2] = Tn + Pt, l[L + 56 >> 2] = gn + Bn, l[L + 52 >> 2] = Vt + un, l[L + 48 >> 2] = xt + Mt, l[L + 44 >> 2] = qt + tt, l[rt >> 2] = Z + le, l[L + 36 >> 2] = de - ae, l[L + 32 >> 2] = De - Dn, l[L + 28 >> 2] = kn - An, l[L + 24 >> 2] = Dt - _t, l[L + 20 >> 2] = Pt - Tn, l[L + 16 >> 2] = Bn - gn, l[L + 12 >> 2] = un - Vt, l[L + 8 >> 2] = Mt - xt, l[L + 4 >> 2] = tt - qt, l[L >> 2] = le - Z, Z = Ne << 1, le = l[L + 156 >> 2], l[L + 156 >> 2] = Z - le, rt = Te << 1, ot = l[L + 152 >> 2], l[L + 152 >> 2] = rt - ot, qt = Ye << 1, tt = l[L + 148 >> 2], l[L + 148 >> 2] = qt - tt, xt = Ue << 1, Mt = l[L + 144 >> 2], l[L + 144 >> 2] = xt - Mt, Vt = be << 1, un = l[L + 140 >> 2], l[L + 140 >> 2] = Vt - un, gn = q << 1, Bn = l[L + 136 >> 2], l[L + 136 >> 2] = gn - Bn, Tn = Qe << 1, Pt = l[L + 132 >> 2], l[L + 132 >> 2] = Tn - Pt, _t = Ie << 1, Dt = l[L + 128 >> 2], l[L + 128 >> 2] = _t - Dt, An = Vn << 1, kn = l[L + 124 >> 2], l[L + 124 >> 2] = An - kn, Dn = We << 1, De = l[L + 120 >> 2], l[L + 120 >> 2] = Dn - De, l[L + 112 >> 2] = rt + ot, l[L + 108 >> 2] = qt + tt, l[L + 104 >> 2] = xt + Mt, l[L + 100 >> 2] = Vt + un, l[L + 96 >> 2] = gn + Bn, l[L + 92 >> 2] = Tn + Pt, l[L + 88 >> 2] = _t + Dt, l[L + 84 >> 2] = An + kn, l[L + 80 >> 2] = Dn + De, l[L + 116 >> 2] = Z + le;
                    }
                    function js(L, Z, le) {
                      var ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0;
                      rt = l[Z + 40 >> 2], ot = l[Z + 4 >> 2], qt = l[Z + 44 >> 2], tt = l[Z + 8 >> 2], xt = l[Z + 48 >> 2], Mt = l[Z + 12 >> 2], Vt = l[Z + 52 >> 2], un = l[Z + 16 >> 2], gn = l[Z + 56 >> 2], Bn = l[Z + 20 >> 2], Tn = l[Z + 60 >> 2], Pt = l[Z + 24 >> 2], Dt = l[(_t = Z - -64 | 0) >> 2], An = l[Z + 28 >> 2], kn = l[Z + 68 >> 2], Dn = l[Z + 32 >> 2], De = l[Z + 72 >> 2], Vn = l[Z >> 2], l[L + 36 >> 2] = l[Z + 36 >> 2] + l[Z + 76 >> 2], l[L + 32 >> 2] = Dn + De, l[L + 28 >> 2] = An + kn, l[L + 24 >> 2] = Pt + Dt, l[L + 20 >> 2] = Bn + Tn, l[L + 16 >> 2] = un + gn, l[L + 12 >> 2] = Mt + Vt, l[L + 8 >> 2] = tt + xt, l[L + 4 >> 2] = ot + qt, l[L >> 2] = rt + Vn, qt = l[Z + 40 >> 2], rt = l[Z + 4 >> 2], tt = l[Z + 44 >> 2], xt = l[Z + 8 >> 2], Mt = l[Z + 48 >> 2], Vt = l[Z + 12 >> 2], un = l[Z + 52 >> 2], gn = l[Z + 16 >> 2], Bn = l[Z + 56 >> 2], Tn = l[Z + 20 >> 2], Pt = l[Z + 60 >> 2], Dt = l[Z + 24 >> 2], _t = l[_t >> 2], ot = l[Z + 28 >> 2], An = l[Z + 68 >> 2], kn = l[Z + 32 >> 2], Dn = l[Z + 72 >> 2], De = l[Z >> 2], l[L + 76 >> 2] = l[Z + 76 >> 2] - l[Z + 36 >> 2], l[L + 72 >> 2] = Dn - kn, l[L + 68 >> 2] = An - ot, l[(ot = L - -64 | 0) >> 2] = _t - Dt, l[L + 60 >> 2] = Pt - Tn, l[L + 56 >> 2] = Bn - gn, l[L + 52 >> 2] = un - Vt, l[L + 48 >> 2] = Mt - xt, l[L + 44 >> 2] = tt - rt, l[(rt = L + 40 | 0) >> 2] = qt - De, rr(L + 80 | 0, L, le), rr(rt, rt, le + 40 | 0), rr(L + 120 | 0, le + 80 | 0, Z + 120 | 0), Vn = l[Z + 80 >> 2], Ie = l[Z + 84 >> 2], Qe = l[Z + 88 >> 2], q = l[Z + 92 >> 2], be = l[Z + 96 >> 2], Ue = l[Z + 100 >> 2], Ye = l[Z + 104 >> 2], Te = l[Z + 108 >> 2], Ne = l[Z + 112 >> 2], We = l[Z + 116 >> 2], Z = l[rt >> 2], le = l[L + 80 >> 2], qt = l[L + 44 >> 2], tt = l[L + 84 >> 2], xt = l[L + 48 >> 2], Mt = l[L + 88 >> 2], Vt = l[L + 52 >> 2], un = l[L + 92 >> 2], gn = l[L + 56 >> 2], Bn = l[L + 96 >> 2], Tn = l[L + 60 >> 2], Pt = l[L + 100 >> 2], _t = l[ot >> 2], Dt = l[L + 104 >> 2], An = l[L + 68 >> 2], kn = l[L + 108 >> 2], Dn = l[L + 72 >> 2], De = l[L + 112 >> 2], ae = l[L + 76 >> 2], de = l[L + 116 >> 2], l[L + 76 >> 2] = ae + de, l[L + 72 >> 2] = Dn + De, l[L + 68 >> 2] = An + kn, l[ot >> 2] = _t + Dt, l[L + 60 >> 2] = Tn + Pt, l[L + 56 >> 2] = gn + Bn, l[L + 52 >> 2] = Vt + un, l[L + 48 >> 2] = xt + Mt, l[L + 44 >> 2] = qt + tt, l[rt >> 2] = Z + le, l[L + 36 >> 2] = de - ae, l[L + 32 >> 2] = De - Dn, l[L + 28 >> 2] = kn - An, l[L + 24 >> 2] = Dt - _t, l[L + 20 >> 2] = Pt - Tn, l[L + 16 >> 2] = Bn - gn, l[L + 12 >> 2] = un - Vt, l[L + 8 >> 2] = Mt - xt, l[L + 4 >> 2] = tt - qt, l[L >> 2] = le - Z, Z = We << 1, le = l[L + 156 >> 2], l[L + 156 >> 2] = Z - le, rt = Ne << 1, ot = l[L + 152 >> 2], l[L + 152 >> 2] = rt - ot, qt = Te << 1, tt = l[L + 148 >> 2], l[L + 148 >> 2] = qt - tt, xt = Ye << 1, Mt = l[L + 144 >> 2], l[L + 144 >> 2] = xt - Mt, Vt = Ue << 1, un = l[L + 140 >> 2], l[L + 140 >> 2] = Vt - un, gn = be << 1, Bn = l[L + 136 >> 2], l[L + 136 >> 2] = gn - Bn, Tn = q << 1, Pt = l[L + 132 >> 2], l[L + 132 >> 2] = Tn - Pt, _t = Qe << 1, Dt = l[L + 128 >> 2], l[L + 128 >> 2] = _t - Dt, An = Ie << 1, kn = l[L + 124 >> 2], l[L + 124 >> 2] = An - kn, Dn = Vn << 1, De = l[L + 120 >> 2], l[L + 120 >> 2] = Dn - De, l[L + 112 >> 2] = rt + ot, l[L + 108 >> 2] = qt + tt, l[L + 104 >> 2] = xt + Mt, l[L + 100 >> 2] = Vt + un, l[L + 96 >> 2] = gn + Bn, l[L + 92 >> 2] = Tn + Pt, l[L + 88 >> 2] = _t + Dt, l[L + 84 >> 2] = An + kn, l[L + 80 >> 2] = Dn + De, l[L + 116 >> 2] = Z + le;
                    }
                    function ca(L, Z) {
                      var le, ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0;
                      We = B[Z + 31 | 0], le = B[Z + 30 | 0], ae = B[Z + 29 | 0], de = B[Z + 6 | 0], Ie = B[Z + 5 | 0], Qe = B[Z + 4 | 0], q = B[Z + 9 | 0], be = B[Z + 8 | 0], Ue = B[Z + 7 | 0], Bn = B[Z + 12 | 0], Tn = B[Z + 11 | 0], Ye = B[Z + 10 | 0], Te = B[Z + 15 | 0], Pt = B[Z + 14 | 0], Ne = B[Z + 13 | 0], Vt = B[Z + 28 | 0], gn = B[Z + 27 | 0], un = B[Z + 26 | 0], Mt = B[Z + 25 | 0], tt = B[Z + 24 | 0], qt = B[Z + 23 | 0], rt = B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24, xt = (ot = B[Z + 21 | 0]) << 15, ot = _t = ot >>> 17 | 0, An = xt, _t = (xt = B[Z + 20 | 0]) >>> 25 | 0, xt = An | xt << 7, Dt = ot | _t, ot = (_t = B[Z + 22 | 0]) >>> 9 | 0, xt |= _t << 23, ot |= Dt, _t = B[Z + 16 | 0] | B[Z + 17 | 0] << 8 | B[Z + 18 | 0] << 16 | B[Z + 19 | 0] << 24, Z = 0, An = _t, _t = (33554431 & (Z = (Dt = _t + 16777216 | 0) >>> 0 < 16777216 ? 1 : Z)) << 7 | Dt >>> 25, Z = (Z >>> 25 | 0) + ot | 0, _t = (ot = xt = _t + xt | 0) >>> 0 < _t >>> 0 ? Z + 1 | 0 : Z, Z = (xt = ot + 33554432 | 0) >>> 0 < 33554432 ? _t + 1 | 0 : _t, l[L + 24 >> 2] = ot - (-67108864 & xt), _t = (ot = qt >>> 27 | 0) | tt >>> 19 | Mt >>> 11, ot = qt = (tt = Mt << 21 | (qt = tt << 13 | qt << 5)) + (ot = (67108863 & (ot = Z)) << 6 | xt >>> 26) | 0, Z = _t, _t = (qt = tt + 16777216 | 0) >>> 0 < 16777216 ? Z + 1 | 0 : Z, l[L + 28 >> 2] = ot - (1040187392 & qt), ot = (ot = gn >>> 20 | un >>> 28 | Vt >>> 12) + (_t = (Z = _t) >>> 25 | 0) | 0, Z = (_t = qt = (Z = (33554431 & Z) << 7 | qt >>> 25) + (gn << 12 | un << 4 | Vt << 20) | 0) >>> 0 < Z >>> 0 ? ot + 1 | 0 : ot, qt = (Vt = _t + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z, l[L + 32 >> 2] = _t - (-67108864 & Vt), ot = (Z = Bn >>> 13 | 0) | (_t = Tn >>> 21 | Ye >>> 29), Z = (ot = (gn = 16777216 + (Bn = Tn << 11 | Ye << 3 | Bn << 19) | 0) >>> 0 < 16777216 ? ot + 1 | 0 : ot) >>> 25 | 0, ot = (_t = tt = Pt << 10 | Ne << 2 | Te << 18) + (tt = (33554431 & ot) << 7 | gn >>> 25) | 0, _t = Z + (Mt = Pt >>> 22 | Ne >>> 30 | Te >>> 14) | 0, Z = ot >>> 0 < tt >>> 0 ? _t + 1 | 0 : _t, tt = Z = (67108863 & (Z = (_t = ot + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z)) << 6 | _t >>> 26, Z = Z + (un = An - (-33554432 & Dt) | 0) | 0, l[L + 20 >> 2] = Z, l[L + 16 >> 2] = ot - (-67108864 & _t), _t = Ie >>> 18 | Qe >>> 26 | de >>> 10, ot = (_t = (un = 16777216 + (Tn = Ie << 14 | Qe << 6 | de << 22) | 0) >>> 0 < 16777216 ? _t + 1 | 0 : _t) >>> 25 | 0, _t = (Z = tt = be << 13 | Ue << 5 | q << 21) + (tt = (33554431 & _t) << 7 | un >>> 25) | 0, Z = ot + (Mt = be >>> 19 | Ue >>> 27 | q >>> 11) | 0, Z = _t >>> 0 < tt >>> 0 ? Z + 1 | 0 : Z, ot = (Mt = _t + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z, l[L + 8 >> 2] = _t - (-67108864 & Mt), Vt = (qt = (67108863 & qt) << 6 | Vt >>> 26) + (Pt = We << 18 & 33292288 | le << 10 | ae << 2) | 0, Z = _t = le >>> 22 | ae >>> 30, _t = (qt = Pt + 16777216 | 0) >>> 0 < 16777216 ? Z + 1 | 0 : Z, l[L + 36 >> 2] = Vt - (33554432 & qt), ot = Bn + ((67108863 & ot) << 6 | Mt >>> 26) | 0, l[L + 12 >> 2] = ot - (234881024 & gn), tt = Tn - (2113929216 & un) | 0, ot = dt((33554431 & (Z = _t)) << 7 | qt >>> 25, _t = Z >>> 25 | 0, 19, 0), Z = Oe, ot = ot >>> 0 > (_t = ot + rt | 0) >>> 0 ? Z + 1 | 0 : Z, qt = ot = (67108863 & (ot = (Z = _t + 33554432 | 0) >>> 0 < 33554432 ? ot + 1 | 0 : ot)) << 6 | Z >>> 26, ot = ot + tt | 0, l[L + 4 >> 2] = ot, l[L >> 2] = _t - (-67108864 & Z);
                    }
                    function Ui(L, Z) {
                      var le, ae, de, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0;
                      for (st = le = st - 480 | 0; Qe = (q = le + 288 | 0) + (Ie << 1) | 0, Ne = B[Z + Ie | 0], j[Qe + 1 | 0] = Ne >>> 4, j[0 | Qe] = 15 & Ne, q = q + ((Qe = 1 | Ie) << 1) | 0, Qe = B[Z + Qe | 0], j[q + 1 | 0] = Qe >>> 4, j[0 | q] = 15 & Qe, (0 | (Ie = Ie + 2 | 0)) != 32; )
                        ;
                      for (Z = 0; Ie = 8 + (q = (Ie = Z) + B[0 | (Z = (le + 288 | 0) + be | 0)] | 0) | 0, j[0 | Z] = q - (240 & Ie), Ie = 8 + (q = B[Z + 1 | 0] + (Ie << 24 >> 24 >> 4) | 0) | 0, j[Z + 1 | 0] = q - (240 & Ie), Ie = 8 + (q = B[Z + 2 | 0] + (Ie << 24 >> 24 >> 4) | 0) | 0, j[Z + 2 | 0] = q - (240 & Ie), Z = Ie << 24 >> 24 >> 4, (0 | (be = be + 3 | 0)) != 63; )
                        ;
                      for (j[le + 351 | 0] = B[le + 351 | 0] + Z, l[L + 32 >> 2] = 0, l[L + 36 >> 2] = 0, l[L + 24 >> 2] = 0, l[L + 28 >> 2] = 0, l[L + 16 >> 2] = 0, l[L + 20 >> 2] = 0, l[L + 8 >> 2] = 0, l[L + 12 >> 2] = 0, l[L >> 2] = 0, l[L + 4 >> 2] = 0, l[L + 44 >> 2] = 0, l[L + 48 >> 2] = 0, l[(Ne = L + 40 | 0) >> 2] = 1, l[L + 52 >> 2] = 0, l[L + 56 >> 2] = 0, l[L + 60 >> 2] = 0, l[L + 64 >> 2] = 0, l[L + 68 >> 2] = 0, l[L + 72 >> 2] = 0, l[L + 76 >> 2] = 0, l[L + 80 >> 2] = 1, Rt(L + 84 | 0, 0, 76), ae = L + 120 | 0, de = L + 80 | 0, Z = le + 208 | 0, q = le + 168 | 0, be = le + 248 | 0, Ie = 1; ha(Ue = le + 8 | 0, Ie >>> 1 | 0, j[(le + 288 | 0) + Ie | 0]), js(Qe = le + 128 | 0, L, Ue), rr(L, Qe, be), rr(Ne, q, Z), rr(de, Z, be), rr(ae, Qe, q), Qe = Ie >>> 0 < 62, Ie = Ie + 2 | 0, Qe; )
                        ;
                      for (Ie = l[L + 8 >> 2], Qe = l[L + 12 >> 2], Ue = l[L + 16 >> 2], Ye = l[L + 20 >> 2], We = l[L + 24 >> 2], rt = l[L + 28 >> 2], Te = l[L >> 2], ot = l[L + 4 >> 2], _t = l[L + 36 >> 2], l[le + 392 >> 2] = l[L + 32 >> 2], l[le + 396 >> 2] = _t, l[le + 384 >> 2] = We, l[le + 388 >> 2] = rt, l[le + 376 >> 2] = Ue, l[le + 380 >> 2] = Ye, l[le + 368 >> 2] = Ie, l[le + 372 >> 2] = Qe, l[le + 360 >> 2] = Te, l[le + 364 >> 2] = ot, Ie = l[L + 40 >> 2], Qe = l[L + 44 >> 2], Ue = l[L + 48 >> 2], Ye = l[L + 52 >> 2], We = l[L + 56 >> 2], rt = l[L + 60 >> 2], ot = l[(Te = L - -64 | 0) >> 2], Te = l[Te + 4 >> 2], _t = l[L + 76 >> 2], l[le + 432 >> 2] = l[L + 72 >> 2], l[le + 436 >> 2] = _t, l[le + 424 >> 2] = ot, l[le + 428 >> 2] = Te, l[le + 416 >> 2] = We, l[le + 420 >> 2] = rt, l[le + 408 >> 2] = Ue, l[le + 412 >> 2] = Ye, l[le + 400 >> 2] = Ie, l[le + 404 >> 2] = Qe, Ie = l[L + 80 >> 2], Qe = l[L + 84 >> 2], Ue = l[L + 88 >> 2], Ye = l[L + 92 >> 2], We = l[L + 96 >> 2], rt = l[L + 100 >> 2], Te = l[L + 104 >> 2], ot = l[L + 108 >> 2], _t = l[L + 116 >> 2], l[le + 472 >> 2] = l[L + 112 >> 2], l[le + 476 >> 2] = _t, l[le + 464 >> 2] = Te, l[le + 468 >> 2] = ot, l[le + 456 >> 2] = We, l[le + 460 >> 2] = rt, l[le + 448 >> 2] = Ue, l[le + 452 >> 2] = Ye, l[le + 440 >> 2] = Ie, l[le + 444 >> 2] = Qe, Vi(Ie = le + 128 | 0, Qe = le + 360 | 0), rr(Qe, Ie, be), rr(Ue = le + 400 | 0, q, Z), rr(Ye = le + 440 | 0, Z, be), Vi(Ie, Qe), rr(Qe, Ie, be), rr(Ue, q, Z), rr(Ye, Z, be), Vi(Ie, Qe), rr(Qe, Ie, be), rr(Ue, q, Z), rr(Ye, Z, be), Vi(Ie, Qe), rr(L, Ie, be), rr(Ne, q, Z), rr(de, Z, be), rr(ae, Ie, q), Ie = 0; ha(Ue = le + 8 | 0, Ie >>> 1 | 0, j[(le + 288 | 0) + Ie | 0]), js(Qe = le + 128 | 0, L, Ue), rr(L, Qe, be), rr(Ne, q, Z), rr(de, Z, be), rr(ae, Qe, q), Qe = Ie >>> 0 < 62, Ie = Ie + 2 | 0, Qe; )
                        ;
                      st = le + 480 | 0;
                    }
                    function Ni(L, Z, le, ae) {
                      var de, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0;
                      if (st = de = st - 704 | 0, le | ae)
                        if (Ie = (ae << 3 | le >>> 29) + (Qe = q = l[L + 76 >> 2]) | 0, Ue = (Ye = l[L + 72 >> 2]) + (be = le << 3) | 0, l[L + 72 >> 2] = Ue, Ie = be >>> 0 > Ue >>> 0 ? Ie + 1 | 0 : Ie, l[L + 76 >> 2] = Ie, q = l[4 + (be = L - -64 | 0) >> 2], q = (Te = Ie = (0 | Ie) == (0 | Qe) & Ue >>> 0 < Ye >>> 0 | Ie >>> 0 < Qe >>> 0) >>> 0 > (Ie = Ie + l[be >> 2] | 0) >>> 0 ? q + 1 | 0 : q, Ue = (Te = ae >>> 29 | 0) + Ie | 0, Ie = q, l[be >> 2] = Ue, l[be + 4 >> 2] = Ue >>> 0 < Te >>> 0 ? Ie + 1 | 0 : Ie, (0 | (q = Te = 0 - ((Ie = 0) + ((be = 127 & ((7 & Qe) << 29 | Ye >>> 3)) >>> 0 > 128) | 0) | 0)) == (0 | ae) & le >>> 0 >= (Ue = 128 - be | 0) >>> 0 | ae >>> 0 > q >>> 0) {
                          if (Qe = 0, q = 0, !Ie & (127 ^ be) >>> 0 >= 3 | Ie)
                            for (_t = 252 & Ue, Ye = L + 80 | 0; j[(Ie = Qe + be | 0) + Ye | 0] = B[Z + Qe | 0], j[Ye + (be + (Ie = 1 | Qe) | 0) | 0] = B[Z + Ie | 0], j[Ye + (be + (Ie = 2 | Qe) | 0) | 0] = B[Z + Ie | 0], j[Ye + (be + (Ie = 3 | Qe) | 0) | 0] = B[Z + Ie | 0], Ie = q, q = (Qe = Qe + 4 | 0) >>> 0 < 4 ? Ie + 1 | 0 : Ie, Ie = We, We = Ie = (rt = rt + 4 | 0) >>> 0 < 4 ? Ie + 1 | 0 : Ie, (0 | rt) != (0 | _t) | (0 | ot) != (0 | Ie); )
                              ;
                          if (Ye = Ie = 0, Ie | (We = 3 & Ue))
                            for (; j[80 + (L + (Ie = Qe + be | 0) | 0) | 0] = B[Z + Qe | 0], Ie = q, q = (Qe = Qe + 1 | 0) ? Ie : Ie + 1 | 0, Ie = ot, ot = Ie = (Ne = Ne + 1 | 0) ? Ie : Ie + 1 | 0, (0 | We) != (0 | Ne) | (0 | Ye) != (0 | Ie); )
                              ;
                          if ($s(L, L + 80 | 0, de, Qe = de + 640 | 0), Z = Z + Ue | 0, !(ae = ae - ((le >>> 0 < Ue >>> 0) + Te | 0) | 0) & (le = le - Ue | 0) >>> 0 > 127 | ae)
                            for (; $s(L, Z, de, Qe), Z = Z + 128 | 0, !(ae = ae - (le >>> 0 < 128) | 0) & (le = le - 128 | 0) >>> 0 > 127 | ae; )
                              ;
                          if (le | ae) {
                            if (rt = 3 & le, Ue = 0, Ne = 0, ot = 0, Qe = 0, q = 0, !ae & le >>> 0 >= 4 | ae)
                              for (be = -4 & le, Ye = ae, We = L + 80 | 0, le = 0, ae = 0; j[Qe + We | 0] = B[Z + Qe | 0], j[(Ie = 1 | Qe) + We | 0] = B[Z + Ie | 0], j[(Ie = 2 | Qe) + We | 0] = B[Z + Ie | 0], j[(Ie = 3 | Qe) + We | 0] = B[Z + Ie | 0], Ie = q, q = (Qe = Qe + 4 | 0) >>> 0 < 4 ? Ie + 1 | 0 : Ie, Ie = ae, ae = Ie = (le = le + 4 | 0) >>> 0 < 4 ? Ie + 1 | 0 : Ie, (0 | le) != (0 | be) | (0 | Ye) != (0 | Ie); )
                                ;
                            if (Ue | rt)
                              for (; j[80 + (L + Qe | 0) | 0] = B[Z + Qe | 0], q = (Qe = Qe + 1 | 0) ? q : q + 1 | 0, Ie = ot, ot = Ie = (Ne = Ne + 1 | 0) ? Ie : Ie + 1 | 0, (0 | Ne) != (0 | rt) | (0 | Ue) != (0 | Ie); )
                                ;
                          }
                          Ro(de, 704);
                        } else {
                          if (Qe = 0, q = 0, !ae & le >>> 0 >= 4 | ae)
                            for (Ue = -4 & le, Ye = ae, ae = L + 80 | 0; j[ae + (Ie = Qe + be | 0) | 0] = B[Z + Qe | 0], j[ae + (Te = be + (Ie = 1 | Qe) | 0) | 0] = B[Z + Ie | 0], j[ae + (Te = be + (Ie = 2 | Qe) | 0) | 0] = B[Z + Ie | 0], j[ae + (Te = be + (Ie = 3 | Qe) | 0) | 0] = B[Z + Ie | 0], Ie = q, q = (Qe = Qe + 4 | 0) >>> 0 < 4 ? Ie + 1 | 0 : Ie, Ie = We, We = Ie = (rt = rt + 4 | 0) >>> 0 < 4 ? Ie + 1 | 0 : Ie, (0 | Ue) != (0 | rt) | (0 | Ye) != (0 | Ie); )
                              ;
                          if ((le &= 3) | (ae = 0))
                            for (; j[80 + (L + (Ie = Qe + be | 0) | 0) | 0] = B[Z + Qe | 0], q = (Qe = Qe + 1 | 0) ? q : q + 1 | 0, Ie = ot, ot = Ie = (Ne = Ne + 1 | 0) ? Ie : Ie + 1 | 0, (0 | le) != (0 | Ne) | (0 | ae) != (0 | Ie); )
                              ;
                        }
                      return st = de + 704 | 0, 0;
                    }
                    function da(L, Z, le) {
                      var ae = 0, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0;
                      for (de = 2036477234, Qe = 857760878, ae = 1634760805, be = 1797285236, Ie = B[Z + 12 | 0] | B[Z + 13 | 0] << 8 | B[Z + 14 | 0] << 16 | B[Z + 15 | 0] << 24, Te = B[Z + 8 | 0] | B[Z + 9 | 0] << 8 | B[Z + 10 | 0] << 16 | B[Z + 11 | 0] << 24, q = B[Z + 4 | 0] | B[Z + 5 | 0] << 8 | B[Z + 6 | 0] << 16 | B[Z + 7 | 0] << 24, Ne = B[le + 28 | 0] | B[le + 29 | 0] << 8 | B[le + 30 | 0] << 16 | B[le + 31 | 0] << 24, Ue = B[le + 24 | 0] | B[le + 25 | 0] << 8 | B[le + 26 | 0] << 16 | B[le + 27 | 0] << 24, xt = B[le + 20 | 0] | B[le + 21 | 0] << 8 | B[le + 22 | 0] << 16 | B[le + 23 | 0] << 24, We = B[le + 16 | 0] | B[le + 17 | 0] << 8 | B[le + 18 | 0] << 16 | B[le + 19 | 0] << 24, rt = B[le + 12 | 0] | B[le + 13 | 0] << 8 | B[le + 14 | 0] << 16 | B[le + 15 | 0] << 24, ot = B[le + 8 | 0] | B[le + 9 | 0] << 8 | B[le + 10 | 0] << 16 | B[le + 11 | 0] << 24, _t = B[le + 4 | 0] | B[le + 5 | 0] << 8 | B[le + 6 | 0] << 16 | B[le + 7 | 0] << 24, Z = B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24, le = B[0 | le] | B[le + 1 | 0] << 8 | B[le + 2 | 0] << 16 | B[le + 3 | 0] << 24; Ye = le, le = Rn((qt = Z) ^ (Z = le + ae | 0), 16), Ye = We = Rn(Ye ^ (ae = le + We | 0), 12), Mt = Rn((qt = Z + We | 0) ^ le, 8), Z = Rn(Ye ^ (We = Mt + ae | 0), 7), ae = rt, rt = Rn((le = be + rt | 0) ^ Ie, 16), ae = Rn(ae ^ (Ne = rt + Ne | 0), 12), Ie = ot, be = Rn((de = de + ot | 0) ^ Te, 16), Ie = Rn(Ie ^ (ot = be + Ue | 0), 12), Ue = Rn((de = Ie + de | 0) ^ be, 8), le = Rn(Ue ^ (be = Z + (tt = le + ae | 0) | 0), 16), Te = Rn((Qe = Qe + _t | 0) ^ q, 16), _t = Rn((q = Te + xt | 0) ^ _t, 12), Ye = Z, Z = Rn((Qe = Qe + _t | 0) ^ Te, 8), Ye = Rn(Ye ^ (q = le + (Vt = Z + q | 0) | 0), 12), Te = Rn(le ^ (be = Ye + be | 0), 8), le = Rn((xt = Te + q | 0) ^ Ye, 7), Ye = de, de = ae, tt = Rn(rt ^ tt, 8), de = Rn(de ^ (ae = tt + Ne | 0), 7), rt = Rn((q = Ye + de | 0) ^ Z, 16), Ne = Rn((Z = rt + We | 0) ^ de, 12), q = Rn(rt ^ (de = Ne + q | 0), 8), rt = Rn((We = Z + q | 0) ^ Ne, 7), Z = Rn((Z = Ie) ^ (Ie = Ue + ot | 0), 7), ot = Rn((Qe = Z + Qe | 0) ^ Mt, 16), Ue = Rn(Z ^ (ae = ot + ae | 0), 12), Z = Rn(ot ^ (Qe = Ue + Qe | 0), 8), ot = Rn((Ne = ae + Z | 0) ^ Ue, 7), Ye = Ie, ae = Rn(_t ^ Vt, 7), Ue = Rn((Ie = ae + qt | 0) ^ tt, 16), qt = Rn(ae ^ (_t = Ye + Ue | 0), 12), Ie = Rn(Ue ^ (ae = qt + Ie | 0), 8), _t = Rn((Ue = _t + Ie | 0) ^ qt, 7), (0 | (un = un + 1 | 0)) != 10; )
                        ;
                      j[0 | L] = ae, j[L + 1 | 0] = ae >>> 8, j[L + 2 | 0] = ae >>> 16, j[L + 3 | 0] = ae >>> 24, j[L + 28 | 0] = Ie, j[L + 29 | 0] = Ie >>> 8, j[L + 30 | 0] = Ie >>> 16, j[L + 31 | 0] = Ie >>> 24, j[L + 24 | 0] = Te, j[L + 25 | 0] = Te >>> 8, j[L + 26 | 0] = Te >>> 16, j[L + 27 | 0] = Te >>> 24, j[L + 20 | 0] = q, j[L + 21 | 0] = q >>> 8, j[L + 22 | 0] = q >>> 16, j[L + 23 | 0] = q >>> 24, j[L + 16 | 0] = Z, j[L + 17 | 0] = Z >>> 8, j[L + 18 | 0] = Z >>> 16, j[L + 19 | 0] = Z >>> 24, j[L + 12 | 0] = be, j[L + 13 | 0] = be >>> 8, j[L + 14 | 0] = be >>> 16, j[L + 15 | 0] = be >>> 24, j[L + 8 | 0] = de, j[L + 9 | 0] = de >>> 8, j[L + 10 | 0] = de >>> 16, j[L + 11 | 0] = de >>> 24, j[L + 4 | 0] = Qe, j[L + 5 | 0] = Qe >>> 8, j[L + 6 | 0] = Qe >>> 16, j[L + 7 | 0] = Qe >>> 24;
                    }
                    function ma(L, Z, le) {
                      var ae = 0, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0;
                      for (ae = 1797285236, Ue = 2036477234, Ye = 857760878, de = 1634760805, Ie = B[Z + 12 | 0] | B[Z + 13 | 0] << 8 | B[Z + 14 | 0] << 16 | B[Z + 15 | 0] << 24, q = B[Z + 8 | 0] | B[Z + 9 | 0] << 8 | B[Z + 10 | 0] << 16 | B[Z + 11 | 0] << 24, Qe = B[Z + 4 | 0] | B[Z + 5 | 0] << 8 | B[Z + 6 | 0] << 16 | B[Z + 7 | 0] << 24, qt = B[le + 28 | 0] | B[le + 29 | 0] << 8 | B[le + 30 | 0] << 16 | B[le + 31 | 0] << 24, _t = B[le + 24 | 0] | B[le + 25 | 0] << 8 | B[le + 26 | 0] << 16 | B[le + 27 | 0] << 24, tt = 20, rt = B[le + 20 | 0] | B[le + 21 | 0] << 8 | B[le + 22 | 0] << 16 | B[le + 23 | 0] << 24, ot = B[le + 16 | 0] | B[le + 17 | 0] << 8 | B[le + 18 | 0] << 16 | B[le + 19 | 0] << 24, Te = B[le + 12 | 0] | B[le + 13 | 0] << 8 | B[le + 14 | 0] << 16 | B[le + 15 | 0] << 24, Ne = B[le + 8 | 0] | B[le + 9 | 0] << 8 | B[le + 10 | 0] << 16 | B[le + 11 | 0] << 24, We = B[le + 4 | 0] | B[le + 5 | 0] << 8 | B[le + 6 | 0] << 16 | B[le + 7 | 0] << 24, Z = B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24, le = B[0 | le] | B[le + 1 | 0] << 8 | B[le + 2 | 0] << 16 | B[le + 3 | 0] << 24; be = Rn(le + Ye | 0, 7) ^ Ie, xt = Rn(be + Ye | 0, 9) ^ _t, Te = Rn(de + rt | 0, 7) ^ Te, Mt = Rn(Te + de | 0, 9) ^ q, Vt = Rn(Mt + Te | 0, 13) ^ rt, Ne = Rn(ae + ot | 0, 7) ^ Ne, Qe = Rn(Ne + ae | 0, 9) ^ Qe, q = Rn(Qe + Ne | 0, 13) ^ ot, ae = Rn(Qe + q | 0, 18) ^ ae, Ie = Rn(Z + Ue | 0, 7) ^ qt, rt = Vt ^ Rn(ae + Ie | 0, 7), _t = xt ^ Rn(rt + ae | 0, 9), qt = Rn(rt + _t | 0, 13) ^ Ie, ae = Rn(_t + qt | 0, 18) ^ ae, We = Rn(Ie + Ue | 0, 9) ^ We, un = Rn(We + Ie | 0, 13) ^ Z, Z = Rn(un + We | 0, 18) ^ Ue, ot = Rn(Z + be | 0, 7) ^ q, q = Rn(ot + Z | 0, 9) ^ Mt, Ie = Rn(q + ot | 0, 13) ^ be, Ue = Rn(Ie + q | 0, 18) ^ Z, be = Rn(be + xt | 0, 13) ^ le, le = Rn(be + xt | 0, 18) ^ Ye, Z = Rn(le + Te | 0, 7) ^ un, Qe = Rn(Z + le | 0, 9) ^ Qe, Te = Rn(Z + Qe | 0, 13) ^ Te, Ye = Rn(Qe + Te | 0, 18) ^ le, de = Rn(Mt + Vt | 0, 18) ^ de, le = Rn(de + Ne | 0, 7) ^ be, We = Rn(le + de | 0, 9) ^ We, Ne = Rn(le + We | 0, 13) ^ Ne, de = Rn(We + Ne | 0, 18) ^ de, be = tt >>> 0 > 2, tt = tt - 2 | 0, be; )
                        ;
                      return j[0 | L] = de, j[L + 1 | 0] = de >>> 8, j[L + 2 | 0] = de >>> 16, j[L + 3 | 0] = de >>> 24, j[L + 28 | 0] = Ie, j[L + 29 | 0] = Ie >>> 8, j[L + 30 | 0] = Ie >>> 16, j[L + 31 | 0] = Ie >>> 24, j[L + 24 | 0] = q, j[L + 25 | 0] = q >>> 8, j[L + 26 | 0] = q >>> 16, j[L + 27 | 0] = q >>> 24, j[L + 20 | 0] = Qe, j[L + 21 | 0] = Qe >>> 8, j[L + 22 | 0] = Qe >>> 16, j[L + 23 | 0] = Qe >>> 24, j[L + 16 | 0] = Z, j[L + 17 | 0] = Z >>> 8, j[L + 18 | 0] = Z >>> 16, j[L + 19 | 0] = Z >>> 24, j[L + 12 | 0] = ae, j[L + 13 | 0] = ae >>> 8, j[L + 14 | 0] = ae >>> 16, j[L + 15 | 0] = ae >>> 24, j[L + 8 | 0] = Ue, j[L + 9 | 0] = Ue >>> 8, j[L + 10 | 0] = Ue >>> 16, j[L + 11 | 0] = Ue >>> 24, j[L + 4 | 0] = Ye, j[L + 5 | 0] = Ye >>> 8, j[L + 6 | 0] = Ye >>> 16, j[L + 7 | 0] = Ye >>> 24, 0;
                    }
                    function ga(L, Z, le, ae, de, Ie, Qe) {
                      var q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0;
                      if (Z - 65 >>> 0 < 4294967232 | Qe >>> 0 > 64)
                        L = -1;
                      else {
                        Ne = q = st, st = q = q - 512 & -64;
                        e: {
                          t:
                            if (!(!(!(ae | de) | le) | !L | ((be = 255 & Z) - 65 & 255) >>> 0 <= 191 | !(!(Z = 255 & Qe) || Ie) | Z >>> 0 >= 65)) {
                              if (Z) {
                                if (!Ie)
                                  break t;
                                Rt(q - -64 | 0, 0, 293), l[q + 56 >> 2] = 327033209, l[q + 60 >> 2] = 1541459225, l[q + 48 >> 2] = -79577749, l[q + 52 >> 2] = 528734635, l[q + 40 >> 2] = 725511199, l[q + 44 >> 2] = -1694144372, l[q + 32 >> 2] = -1377402159, l[q + 36 >> 2] = 1359893119, l[q + 24 >> 2] = 1595750129, l[q + 28 >> 2] = -1521486534, l[q + 16 >> 2] = -23791573, l[q + 20 >> 2] = 1013904242, l[q + 8 >> 2] = -2067093701, l[q + 12 >> 2] = -1150833019, l[q >> 2] = -222443256 ^ (Z << 8 | be), l[q + 4 >> 2] = Z >>> 24 ^ 1779033703, Rt((Qe = q + 384 | 0) + Z | 0, 0, 128 - Z | 0), yt(Qe, Ie, Z), yt(q + 96 | 0, Qe, 128), l[q + 352 >> 2] = 128, Ro(Qe, 128), Z = 128;
                              } else
                                Rt(q - -64 | 0, 0, 293), l[q + 56 >> 2] = 327033209, l[q + 60 >> 2] = 1541459225, l[q + 48 >> 2] = -79577749, l[q + 52 >> 2] = 528734635, l[q + 40 >> 2] = 725511199, l[q + 44 >> 2] = -1694144372, l[q + 32 >> 2] = -1377402159, l[q + 36 >> 2] = 1359893119, l[q + 24 >> 2] = 1595750129, l[q + 28 >> 2] = -1521486534, l[q + 16 >> 2] = -23791573, l[q + 20 >> 2] = 1013904242, l[q + 8 >> 2] = -2067093701, l[q + 12 >> 2] = -1150833019, l[q >> 2] = -222443256 ^ be, l[q + 4 >> 2] = 1779033703, Z = 0;
                              n:
                                if (ae | de)
                                  for (We = q + 224 | 0, Ue = q + 96 | 0; ; ) {
                                    if (Qe = Z + Ue | 0, !de & ae >>> 0 <= (Ie = 256 - Z | 0) >>> 0) {
                                      yt(Qe, le, ae), l[q + 352 >> 2] = ae + l[q + 352 >> 2];
                                      break n;
                                    }
                                    if (yt(Qe, le, Ie), l[q + 352 >> 2] = Ie + l[q + 352 >> 2], Ye = Z = l[q + 68 >> 2], Z = (Te = (Qe = l[q + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? Z + 1 | 0 : Z, l[q + 64 >> 2] = Te, l[q + 68 >> 2] = Z, Z = l[q + 76 >> 2], Z = (Ye = Qe = (0 | Ye) == -1 & Qe >>> 0 > 4294967167) >>> 0 > (Qe = Qe + l[q + 72 >> 2] | 0) >>> 0 ? Z + 1 | 0 : Z, l[q + 72 >> 2] = Qe, l[q + 76 >> 2] = Z, Bs(q, Ue), yt(Ue, We, 128), Z = l[q + 352 >> 2] - 128 | 0, l[q + 352 >> 2] = Z, le = le + Ie | 0, !((de = de - (ae >>> 0 < Ie >>> 0) | 0) | (ae = ae - Ie | 0)))
                                      break;
                                  }
                              ua(q, L, be), st = Ne;
                              break e;
                            }
                          Ko(), Xr();
                        }
                        L = 0;
                      }
                      return L;
                    }
                    function la(L, Z, le, ae) {
                      var de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0;
                      e: {
                        if ((Qe = l[L + 56 >> 2]) | (de = l[L + 60 >> 2])) {
                          if (Ne = Ie = 16 - Qe | 0, be = (Ie = (0 | (q = 0 - ((Qe >>> 0 > 16) + de | 0) | 0)) == (0 | ae) & le >>> 0 > Ie >>> 0 | ae >>> 0 > q >>> 0) ? Ne : le, Ne = Ie = Ie ? q : ae, Ie | be) {
                            if (Ie = 0, Qe = 0, !Ne & be >>> 0 >= 4 | Ne)
                              for (Ue = -4 & be, q = L - -64 | 0; de = Ie + l[L + 56 >> 2] | 0, j[de + q | 0] = B[Z + Ie | 0], de = (We = 1 | Ie) + l[L + 56 >> 2] | 0, j[de + q | 0] = B[Z + We | 0], de = (We = 2 | Ie) + l[L + 56 >> 2] | 0, j[de + q | 0] = B[Z + We | 0], de = (We = 3 | Ie) + l[L + 56 >> 2] | 0, j[de + q | 0] = B[Z + We | 0], de = Qe, Qe = (Ie = Ie + 4 | 0) >>> 0 < 4 ? de + 1 | 0 : de, de = Ye, Ye = de = (Te = Te + 4 | 0) >>> 0 < 4 ? de + 1 | 0 : de, (0 | Te) != (0 | Ue) | (0 | Ne) != (0 | de); )
                                ;
                            if (q = de = 0, de | (Ye = 3 & be))
                              for (; Te = Ie + l[L + 56 >> 2] | 0, j[(L + Te | 0) - -64 | 0] = B[Z + Ie | 0], Qe = (Ie = Ie + 1 | 0) ? Qe : Qe + 1 | 0, de = ot, ot = de = (rt = rt + 1 | 0) ? de : de + 1 | 0, (0 | Ye) != (0 | rt) | (0 | q) != (0 | de); )
                                ;
                            Qe = l[L + 56 >> 2], de = l[L + 60 >> 2];
                          }
                          if (de = de + Ne | 0, de = (Qe = Qe + be | 0) >>> 0 < be >>> 0 ? de + 1 | 0 : de, l[L + 56 >> 2] = Qe, l[L + 60 >> 2] = de, !de & Qe >>> 0 < 16)
                            break e;
                          Ys(L, L - -64 | 0, 16, 0), l[L + 56 >> 2] = 0, l[L + 60 >> 2] = 0, le = (Qe = le) - be | 0, ae = ae - ((Qe >>> 0 < be >>> 0) + Ne | 0) | 0, Z = Z + be | 0;
                        }
                        if (!ae & le >>> 0 >= 16 | ae && (Ys(L, Z, Qe = -16 & le, ae), le &= 15, ae = 0, Z = Z + Qe | 0), le | ae) {
                          if (rt = 0, ot = 0, Ie = 0, Qe = 0, !ae & le >>> 0 >= 4 | ae)
                            for (be = 12 & le, Ne = 0, q = L - -64 | 0, Te = 0, Ye = 0; de = Ie + l[L + 56 >> 2] | 0, j[de + q | 0] = B[Z + Ie | 0], de = (Ue = 1 | Ie) + l[L + 56 >> 2] | 0, j[de + q | 0] = B[Z + Ue | 0], de = (Ue = 2 | Ie) + l[L + 56 >> 2] | 0, j[de + q | 0] = B[Z + Ue | 0], de = (Ue = 3 | Ie) + l[L + 56 >> 2] | 0, j[de + q | 0] = B[Z + Ue | 0], Qe = (Ie = Ie + 4 | 0) >>> 0 < 4 ? Qe + 1 | 0 : Qe, de = Ye, Ye = de = (Te = Te + 4 | 0) >>> 0 < 4 ? de + 1 | 0 : de, (0 | be) != (0 | Te) | (0 | Ne) != (0 | de); )
                              ;
                          if (q = de = 0, de | (Ye = 3 & le))
                            for (; de = Ie + l[L + 56 >> 2] | 0, j[(L + de | 0) - -64 | 0] = B[Z + Ie | 0], Qe = (Ie = Ie + 1 | 0) ? Qe : Qe + 1 | 0, de = ot, ot = de = (rt = rt + 1 | 0) ? de : de + 1 | 0, (0 | Ye) != (0 | rt) | (0 | q) != (0 | de); )
                              ;
                          Qe = ae + l[L + 60 >> 2] | 0, Qe = (Z = le + l[L + 56 >> 2] | 0) >>> 0 < le >>> 0 ? Qe + 1 | 0 : Qe, l[L + 56 >> 2] = Z, l[L + 60 >> 2] = Qe;
                        }
                      }
                    }
                    function _s(L, Z, le) {
                      var ae, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0;
                      ot = l[Z + 4 >> 2], de = l[L + 4 >> 2], _t = l[Z + 8 >> 2], Ie = l[L + 8 >> 2], qt = l[Z + 12 >> 2], Qe = l[L + 12 >> 2], tt = l[Z + 16 >> 2], q = l[L + 16 >> 2], xt = l[Z + 20 >> 2], be = l[L + 20 >> 2], Mt = l[Z + 24 >> 2], Ue = l[L + 24 >> 2], We = l[Z + 28 >> 2], Ye = l[L + 28 >> 2], Vt = l[Z + 32 >> 2], Te = l[L + 32 >> 2], un = l[Z + 36 >> 2], Ne = l[L + 36 >> 2], le = 0 - le | 0, rt = l[L >> 2], l[L >> 2] = le & (rt ^ l[Z >> 2]) ^ rt, l[L + 36 >> 2] = Ne ^ le & (Ne ^ un), l[L + 32 >> 2] = Te ^ le & (Te ^ Vt), l[L + 28 >> 2] = Ye ^ le & (Ye ^ We), l[L + 24 >> 2] = Ue ^ le & (Ue ^ Mt), l[L + 20 >> 2] = be ^ le & (be ^ xt), l[L + 16 >> 2] = q ^ le & (q ^ tt), l[L + 12 >> 2] = Qe ^ le & (Qe ^ qt), l[L + 8 >> 2] = Ie ^ le & (Ie ^ _t), l[L + 4 >> 2] = de ^ le & (de ^ ot), de = l[L + 40 >> 2], ot = l[Z + 40 >> 2], Ie = l[L + 44 >> 2], _t = l[Z + 44 >> 2], Qe = l[L + 48 >> 2], qt = l[Z + 48 >> 2], q = l[L + 52 >> 2], tt = l[Z + 52 >> 2], be = l[L + 56 >> 2], xt = l[Z + 56 >> 2], Ue = l[L + 60 >> 2], Mt = l[Z + 60 >> 2], Ye = l[(We = L - -64 | 0) >> 2], Vt = l[Z - -64 >> 2], Te = l[L + 68 >> 2], un = l[Z + 68 >> 2], Ne = l[L + 72 >> 2], rt = l[Z + 72 >> 2], ae = l[L + 76 >> 2], l[L + 76 >> 2] = ae ^ le & (l[Z + 76 >> 2] ^ ae), l[L + 72 >> 2] = Ne ^ le & (Ne ^ rt), l[L + 68 >> 2] = Te ^ le & (Te ^ un), l[We >> 2] = Ye ^ le & (Ye ^ Vt), l[L + 60 >> 2] = Ue ^ le & (Ue ^ Mt), l[L + 56 >> 2] = be ^ le & (be ^ xt), l[L + 52 >> 2] = q ^ le & (q ^ tt), l[L + 48 >> 2] = Qe ^ le & (Qe ^ qt), l[L + 44 >> 2] = Ie ^ le & (Ie ^ _t), l[L + 40 >> 2] = de ^ le & (de ^ ot), de = l[L + 80 >> 2], ot = l[Z + 80 >> 2], Ie = l[L + 84 >> 2], _t = l[Z + 84 >> 2], Qe = l[L + 88 >> 2], qt = l[Z + 88 >> 2], q = l[L + 92 >> 2], tt = l[Z + 92 >> 2], be = l[L + 96 >> 2], xt = l[Z + 96 >> 2], Ue = l[L + 100 >> 2], Mt = l[Z + 100 >> 2], Ye = l[L + 104 >> 2], We = l[Z + 104 >> 2], Te = l[L + 108 >> 2], Vt = l[Z + 108 >> 2], Ne = l[L + 112 >> 2], un = l[Z + 112 >> 2], rt = l[Z + 116 >> 2], Z = l[L + 116 >> 2], l[L + 116 >> 2] = le & (rt ^ Z) ^ Z, l[L + 112 >> 2] = Ne ^ le & (Ne ^ un), l[L + 108 >> 2] = Te ^ le & (Te ^ Vt), l[L + 104 >> 2] = Ye ^ le & (Ye ^ We), l[L + 100 >> 2] = Ue ^ le & (Ue ^ Mt), l[L + 96 >> 2] = be ^ le & (be ^ xt), l[L + 92 >> 2] = q ^ le & (q ^ tt), l[L + 88 >> 2] = Qe ^ le & (Qe ^ qt), l[L + 84 >> 2] = Ie ^ le & (Ie ^ _t), l[L + 80 >> 2] = de ^ le & (de ^ ot);
                    }
                    function wi(L, Z) {
                      var le, ae, de = 0;
                      for (st = le = st - 192 | 0, Cn(ae = le + 144 | 0, Z), Cn(de = le + 96 | 0, ae), Cn(de, de), rr(de, Z, de), rr(ae, ae, de), Cn(Z = le + 48 | 0, ae), rr(de, de, Z), Cn(Z, de), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), rr(de, Z, de), Cn(Z, de), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), rr(Z, Z, de), Cn(le, Z), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), Cn(le, le), rr(Z, le, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), rr(de, Z, de), Cn(Z, de), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), rr(Z, Z, de), Cn(le, Z), Z = 1; Cn(le, le), (0 | (Z = Z + 1 | 0)) != 100; )
                        ;
                      rr(Z = le + 48 | 0, le, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), Cn(Z, Z), rr(de = le + 96 | 0, Z, de), Cn(de, de), Cn(de, de), Cn(de, de), Cn(de, de), Cn(de, de), rr(L, de, le + 144 | 0), st = le + 192 | 0;
                    }
                    function ha(L, Z, le) {
                      var ae, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0;
                      st = ae = st - 128 | 0, l[L >> 2] = 1, l[L + 4 >> 2] = 0, l[L + 8 >> 2] = 0, l[L + 12 >> 2] = 0, l[L + 16 >> 2] = 0, l[L + 20 >> 2] = 0, l[L + 24 >> 2] = 0, l[L + 28 >> 2] = 0, l[L + 32 >> 2] = 0, l[L + 36 >> 2] = 0, l[L + 40 >> 2] = 1, Rt(L + 44 | 0, 0, 76), _s(L, de = wr(Z, 960) + 2704 | 0, (255 & (1 ^ (Z = le - ((le >> 31 & le) << 1) | 0))) - 1 >>> 31 | 0), _s(L, de + 120 | 0, (255 & (2 ^ Z)) - 1 >>> 31 | 0), _s(L, de + 240 | 0, (255 & (3 ^ Z)) - 1 >>> 31 | 0), _s(L, de + 360 | 0, (255 & (4 ^ Z)) - 1 >>> 31 | 0), _s(L, de + 480 | 0, (255 & (5 ^ Z)) - 1 >>> 31 | 0), _s(L, de + 600 | 0, (255 & (6 ^ Z)) - 1 >>> 31 | 0), _s(L, de + 720 | 0, (255 & (7 ^ Z)) - 1 >>> 31 | 0), _s(L, de + 840 | 0, (255 & (8 ^ Z)) - 1 >>> 31 | 0), Ie = l[L + 40 >> 2], Qe = l[L + 44 >> 2], q = l[L + 48 >> 2], be = l[L + 52 >> 2], Ue = l[L + 56 >> 2], Ye = l[L + 60 >> 2], Te = l[(Z = L - -64 | 0) >> 2], de = l[Z + 4 >> 2], Z = l[L + 76 >> 2], l[ae + 40 >> 2] = l[L + 72 >> 2], l[ae + 44 >> 2] = Z, l[ae + 32 >> 2] = Te, l[ae + 36 >> 2] = de, l[ae + 24 >> 2] = Ue, l[ae + 28 >> 2] = Ye, l[ae + 16 >> 2] = q, l[ae + 20 >> 2] = be, l[ae + 8 >> 2] = Ie, l[ae + 12 >> 2] = Qe, Ie = l[L + 8 >> 2], Qe = l[L + 12 >> 2], q = l[L + 16 >> 2], be = l[L + 20 >> 2], Ue = l[L + 24 >> 2], Ye = l[L + 28 >> 2], Te = l[L >> 2], de = l[L + 4 >> 2], Z = l[L + 36 >> 2], l[ae + 80 >> 2] = l[L + 32 >> 2], l[ae + 84 >> 2] = Z, l[ae + 72 >> 2] = Ue, l[ae + 76 >> 2] = Ye, l[(Z = ae - -64 | 0) >> 2] = q, l[Z + 4 >> 2] = be, l[ae + 56 >> 2] = Ie, l[ae + 60 >> 2] = Qe, l[ae + 48 >> 2] = Te, l[ae + 52 >> 2] = de, Ie = l[L + 80 >> 2], Qe = l[L + 84 >> 2], q = l[L + 88 >> 2], be = l[L + 92 >> 2], Ue = l[L + 96 >> 2], Ye = l[L + 100 >> 2], Te = l[L + 104 >> 2], de = l[L + 108 >> 2], Z = l[L + 112 >> 2], l[ae + 124 >> 2] = 0 - l[L + 116 >> 2], l[ae + 120 >> 2] = 0 - Z, l[ae + 116 >> 2] = 0 - de, l[ae + 112 >> 2] = 0 - Te, l[ae + 108 >> 2] = 0 - Ye, l[ae + 104 >> 2] = 0 - Ue, l[ae + 100 >> 2] = 0 - be, l[ae + 96 >> 2] = 0 - q, l[ae + 92 >> 2] = 0 - Qe, l[ae + 88 >> 2] = 0 - Ie, _s(L, ae + 8 | 0, (128 & le) >>> 7 | 0), st = ae + 128 | 0;
                    }
                    function as(L, Z, le, ae) {
                      var de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0;
                      if (le | ae)
                        e:
                          for (Ye = L + 224 | 0, be = L + 96 | 0, Ie = B[L + 352 | 0] | B[L + 353 | 0] << 8 | B[L + 354 | 0] << 16 | B[L + 355 | 0] << 24; ; ) {
                            if (de = Ie + be | 0, !ae & le >>> 0 <= (Qe = 256 - Ie | 0) >>> 0) {
                              yt(de, Z, le), Z = (B[L + 352 | 0] | B[L + 353 | 0] << 8 | B[L + 354 | 0] << 16 | B[L + 355 | 0] << 24) + le | 0, j[L + 352 | 0] = Z, j[L + 353 | 0] = Z >>> 8, j[L + 354 | 0] = Z >>> 16, j[L + 355 | 0] = Z >>> 24;
                              break e;
                            }
                            if (yt(de, Z, Qe), de = (B[L + 352 | 0] | B[L + 353 | 0] << 8 | B[L + 354 | 0] << 16 | B[L + 355 | 0] << 24) + Qe | 0, j[L + 352 | 0] = de, j[L + 353 | 0] = de >>> 8, j[L + 354 | 0] = de >>> 16, j[L + 355 | 0] = de >>> 24, Ue = Ie = B[L + 68 | 0] | B[L + 69 | 0] << 8 | B[L + 70 | 0] << 16 | B[L + 71 | 0] << 24, Ie = (q = 128 + (de = B[L + 64 | 0] | B[L + 65 | 0] << 8 | B[L + 66 | 0] << 16 | B[L + 67 | 0] << 24) | 0) >>> 0 < 128 ? Ie + 1 | 0 : Ie, j[L + 64 | 0] = q, j[L + 65 | 0] = q >>> 8, j[L + 66 | 0] = q >>> 16, j[L + 67 | 0] = q >>> 24, j[L + 68 | 0] = Ie, j[L + 69 | 0] = Ie >>> 8, j[L + 70 | 0] = Ie >>> 16, j[L + 71 | 0] = Ie >>> 24, Ie = B[L + 76 | 0] | B[L + 77 | 0] << 8 | B[L + 78 | 0] << 16 | B[L + 79 | 0] << 24, Ie = (Ue = de = (0 | Ue) == -1 & de >>> 0 > 4294967167) >>> 0 > (de = de + (B[L + 72 | 0] | B[L + 73 | 0] << 8 | B[L + 74 | 0] << 16 | B[L + 75 | 0] << 24) | 0) >>> 0 ? Ie + 1 | 0 : Ie, j[L + 72 | 0] = de, j[L + 73 | 0] = de >>> 8, j[L + 74 | 0] = de >>> 16, j[L + 75 | 0] = de >>> 24, j[L + 76 | 0] = Ie, j[L + 77 | 0] = Ie >>> 8, j[L + 78 | 0] = Ie >>> 16, j[L + 79 | 0] = Ie >>> 24, Bs(L, be), yt(be, Ye, 128), de = Ie = (B[L + 352 | 0] | B[L + 353 | 0] << 8 | B[L + 354 | 0] << 16 | B[L + 355 | 0] << 24) - 128 | 0, j[L + 352 | 0] = de, j[L + 353 | 0] = de >>> 8, j[L + 354 | 0] = de >>> 16, j[L + 355 | 0] = de >>> 24, Z = Z + Qe | 0, !((ae = ae - (le >>> 0 < Qe >>> 0) | 0) | (le = le - Qe | 0)))
                              break;
                          }
                      return 0;
                    }
                    function qi(L, Z) {
                      var le, ae = 0, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0;
                      ae = l[Z + 40 >> 2], de = l[Z + 4 >> 2], Ie = l[Z + 44 >> 2], Qe = l[Z + 8 >> 2], q = l[Z + 48 >> 2], be = l[Z + 12 >> 2], Ue = l[Z + 52 >> 2], Ye = l[Z + 16 >> 2], Te = l[Z + 56 >> 2], We = l[Z + 20 >> 2], rt = l[Z + 60 >> 2], ot = l[Z + 24 >> 2], _t = l[(Ne = Z - -64 | 0) >> 2], qt = l[Z + 28 >> 2], tt = l[Z + 68 >> 2], xt = l[Z + 32 >> 2], Mt = l[Z + 72 >> 2], le = l[Z >> 2], l[L + 36 >> 2] = l[Z + 36 >> 2] + l[Z + 76 >> 2], l[L + 32 >> 2] = xt + Mt, l[L + 28 >> 2] = qt + tt, l[L + 24 >> 2] = ot + _t, l[L + 20 >> 2] = We + rt, l[L + 16 >> 2] = Ye + Te, l[L + 12 >> 2] = be + Ue, l[L + 8 >> 2] = Qe + q, l[L + 4 >> 2] = de + Ie, l[L >> 2] = ae + le, ae = l[Z + 40 >> 2], de = l[Z + 4 >> 2], Ie = l[Z + 44 >> 2], Qe = l[Z + 8 >> 2], q = l[Z + 48 >> 2], be = l[Z + 12 >> 2], Ue = l[Z + 52 >> 2], Ye = l[Z + 16 >> 2], Te = l[Z + 56 >> 2], We = l[Z + 20 >> 2], rt = l[Z + 60 >> 2], ot = l[Z + 24 >> 2], Ne = l[Ne >> 2], _t = l[Z + 28 >> 2], qt = l[Z + 68 >> 2], tt = l[Z + 32 >> 2], xt = l[Z + 72 >> 2], Mt = l[Z >> 2], l[L + 76 >> 2] = l[Z + 76 >> 2] - l[Z + 36 >> 2], l[L + 72 >> 2] = xt - tt, l[L + 68 >> 2] = qt - _t, l[L - -64 >> 2] = Ne - ot, l[L + 60 >> 2] = rt - We, l[L + 56 >> 2] = Te - Ye, l[L + 52 >> 2] = Ue - be, l[L + 48 >> 2] = q - Qe, l[L + 44 >> 2] = Ie - de, l[L + 40 >> 2] = ae - Mt, ae = l[Z + 80 >> 2], de = l[Z + 84 >> 2], Ie = l[Z + 88 >> 2], Qe = l[Z + 92 >> 2], q = l[Z + 96 >> 2], be = l[Z + 100 >> 2], Ue = l[Z + 104 >> 2], Ye = l[Z + 108 >> 2], Te = l[Z + 116 >> 2], l[L + 112 >> 2] = l[Z + 112 >> 2], l[L + 116 >> 2] = Te, l[L + 104 >> 2] = Ue, l[L + 108 >> 2] = Ye, l[L + 96 >> 2] = q, l[L + 100 >> 2] = be, l[L + 88 >> 2] = Ie, l[L + 92 >> 2] = Qe, l[L + 80 >> 2] = ae, l[L + 84 >> 2] = de, rr(L + 120 | 0, Z + 120 | 0, 1440);
                    }
                    function Aa(L, Z) {
                      var le, ae, de, Ie, Qe, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0;
                      (Ue = l[L + 56 >> 2]) | (q = l[L + 60 >> 2]) && (j[Ue + (be = L - -64 | 0) | 0] = 1, !((_t = Ue + 1 | 0) ? q : q + 1 | 0) & _t >>> 0 <= 15 && Rt(65 + (L + Ue | 0) | 0, 0, 15 - Ue | 0), j[L + 80 | 0] = 1, Ys(L, be, 16, 0)), _t = l[L + 52 >> 2], rt = l[L + 48 >> 2], be = l[L + 44 >> 2], Ue = l[L + 24 >> 2], Te = l[L + 28 >> 2] + (Ue >>> 26 | 0) | 0, Ye = l[L + 32 >> 2] + (Te >>> 26 | 0) | 0, le = l[L + 36 >> 2] + (Ye >>> 26 | 0) | 0, q = (We = (Ue = (Ue = (67108863 & Ue) + ((Ne = l[L + 20 >> 2] + wr(le >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (Te = (Ye = (Qe = (67108863 & le) + ((Ie = (ae = 67108863 & Ye) + ((de = (ot = 67108863 & Te) + ((Ne = Ue + ((q = 5 + (We = 67108863 & Ne) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | Ne & (Ye = 67108863 & (Ne = (Ye >>> 31 | 0) - 1 | 0))) << 26 | q & Ye | Te & We) + l[L + 40 >> 2] | 0, j[0 | Z] = q, j[Z + 1 | 0] = q >>> 8, j[Z + 2 | 0] = q >>> 16, j[Z + 3 | 0] = q >>> 24, We = q >>> 0 < We >>> 0, q = (ot = Te & ot | Ye & de) << 20 | Ue >>> 6, Ue = 0, q = (be = q + be | 0) >>> 0 < q >>> 0 ? 1 : Ue, q = (Ue = be + We | 0) >>> 0 < be >>> 0 ? q + 1 | 0 : q, j[(be = Z) + 4 | 0] = Ue, j[be + 5 | 0] = Ue >>> 8, j[be + 6 | 0] = Ue >>> 16, j[be + 7 | 0] = Ue >>> 24, Ue = 0, be = (be = (Ye = Te & ae | Ye & Ie) << 14 | ot >>> 12) >>> 0 > (rt = be + rt | 0) >>> 0 ? 1 : Ue, Ue = rt, rt = q, Ue = (q = Ue + q | 0) >>> 0 < rt >>> 0 ? be + 1 | 0 : be, j[(be = Z) + 8 | 0] = q, j[be + 9 | 0] = q >>> 8, j[be + 10 | 0] = q >>> 16, j[be + 11 | 0] = q >>> 24, q = be = (Ne & Qe | Te & le) << 8 | Ye >>> 18, q = (q = Ue) + (be = be + _t | 0) | 0, j[Z + 12 | 0] = q, j[Z + 13 | 0] = q >>> 8, j[Z + 14 | 0] = q >>> 16, j[Z + 15 | 0] = q >>> 24, Ro(L, 88);
                    }
                    function ka(L, Z, le) {
                      var ae, de = 0;
                      return st = ae = st - 16 | 0, j[ae + 15 | 0] = 0, de = -1, 0 | Ki[l[8722]](L, Z, le) || (j[ae + 15 | 0] = B[0 | L] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 1 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 2 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 3 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 4 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 5 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 6 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 7 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 8 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 9 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 10 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 11 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 12 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 13 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 14 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 15 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 16 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 17 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 18 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 19 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 20 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 21 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 22 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 23 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 24 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 25 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 26 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 27 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 28 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 29 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 30 | 0] | B[ae + 15 | 0], j[ae + 15 | 0] = B[L + 31 | 0] | B[ae + 15 | 0], de = (B[ae + 15 | 0] << 23) - 8388608 >> 31), st = ae + 16 | 0, de;
                    }
                    function ms(L, Z) {
                      var le, ae, de, Ie, Qe, q, be, Ue = 0, Ye = 0;
                      ae = l[Z + 32 >> 2], de = l[Z + 28 >> 2], Ie = l[Z + 24 >> 2], Qe = l[Z + 20 >> 2], q = l[Z + 16 >> 2], be = l[Z + 12 >> 2], Ue = l[Z + 4 >> 2], Ye = l[Z >> 2], le = l[Z + 36 >> 2], Z = l[Z + 8 >> 2], Ye = wr((ae + (de + (Ie + (Qe + (q + (be + ((Ue + (Ye + (wr(le, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + Z >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + le >> 25, 19) + Ye | 0, j[0 | L] = Ye, j[L + 2 | 0] = Ye >>> 16, j[L + 1 | 0] = Ye >>> 8, Ue = Ue + (Ye >> 26) | 0, j[L + 5 | 0] = Ue >>> 14, j[L + 4 | 0] = Ue >>> 6, j[L + 3 | 0] = Ye >>> 24 & 3 | Ue << 2, Z = Z + (Ue >> 25) | 0, j[L + 8 | 0] = Z >>> 13, j[L + 7 | 0] = Z >>> 5, j[L + 6 | 0] = Z << 3 | (29360128 & Ue) >>> 22, Ye = (Z >> 26) + be | 0, j[L + 11 | 0] = Ye >>> 11, j[L + 10 | 0] = Ye >>> 3, j[L + 9 | 0] = Ye << 5 | (65011712 & Z) >>> 21, Ue = (Ye >> 25) + q | 0, j[L + 15 | 0] = Ue >>> 18, j[L + 14 | 0] = Ue >>> 10, j[L + 13 | 0] = Ue >>> 2, Z = (Ue >> 26) + Qe | 0, j[L + 16 | 0] = Z, j[L + 12 | 0] = Ue << 6 | (33030144 & Ye) >>> 19, j[L + 18 | 0] = Z >>> 16, j[L + 17 | 0] = Z >>> 8, Ue = (Z >> 25) + Ie | 0, j[L + 21 | 0] = Ue >>> 15, j[L + 20 | 0] = Ue >>> 7, j[L + 19 | 0] = Z >>> 24 & 1 | Ue << 1, Z = (Ue >> 26) + de | 0, j[L + 24 | 0] = Z >>> 13, j[L + 23 | 0] = Z >>> 5, j[L + 22 | 0] = Z << 3 | (58720256 & Ue) >>> 23, Ue = (Z >> 25) + ae | 0, j[L + 27 | 0] = Ue >>> 12, j[L + 26 | 0] = Ue >>> 4, j[L + 25 | 0] = Ue << 4 | (31457280 & Z) >>> 21, Z = le + (Ue >> 26) | 0, j[L + 30 | 0] = Z >>> 10, j[L + 29 | 0] = Z >>> 2, j[L + 31 | 0] = (33292288 & Z) >>> 18, j[L + 28 | 0] = Z << 6 | (66060288 & Ue) >>> 20;
                    }
                    function Ps(L, Z) {
                      var le;
                      return l[12 + (le = st - 16 | 0) >> 2] = L, l[le + 8 >> 2] = Z, l[le + 4 >> 2] = 0, l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2]] ^ B[l[le + 8 >> 2]], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 1 | 0] ^ B[l[le + 8 >> 2] + 1 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 2 | 0] ^ B[l[le + 8 >> 2] + 2 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 3 | 0] ^ B[l[le + 8 >> 2] + 3 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 4 | 0] ^ B[l[le + 8 >> 2] + 4 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 5 | 0] ^ B[l[le + 8 >> 2] + 5 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 6 | 0] ^ B[l[le + 8 >> 2] + 6 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 7 | 0] ^ B[l[le + 8 >> 2] + 7 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 8 | 0] ^ B[l[le + 8 >> 2] + 8 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 9 | 0] ^ B[l[le + 8 >> 2] + 9 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 10 | 0] ^ B[l[le + 8 >> 2] + 10 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 11 | 0] ^ B[l[le + 8 >> 2] + 11 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 12 | 0] ^ B[l[le + 8 >> 2] + 12 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 13 | 0] ^ B[l[le + 8 >> 2] + 13 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 14 | 0] ^ B[l[le + 8 >> 2] + 14 | 0], l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + 15 | 0] ^ B[l[le + 8 >> 2] + 15 | 0], (l[le + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Gs(L, Z) {
                      var le, ae = 0, de = 0;
                      le = Z;
                      e:
                        if (ae = 255 & Z) {
                          if (3 & L)
                            for (; ; ) {
                              if (!(Z = B[0 | L]) | (0 | Z) == (255 & le))
                                break e;
                              if (!(3 & (L = L + 1 | 0)))
                                break;
                            }
                          t:
                            if (!((-1 ^ (Z = l[L >> 2])) & Z - 16843009 & -2139062144))
                              for (ae = wr(ae, 16843009); ; ) {
                                if ((-1 ^ (Z ^= ae)) & Z - 16843009 & -2139062144)
                                  break t;
                                if (Z = l[L + 4 >> 2], L = L + 4 | 0, Z - 16843009 & (-1 ^ Z) & -2139062144)
                                  break;
                              }
                          for (; Z = L, (ae = B[0 | L]) && (L = Z + 1 | 0, (0 | ae) != (255 & le)); )
                            ;
                          L = Z;
                        } else {
                          ae = L;
                          t: {
                            if (3 & L)
                              for (; ; ) {
                                if (!B[0 | L])
                                  break t;
                                if (!(3 & (L = L + 1 | 0)))
                                  break;
                              }
                            for (; Z = L, L = L + 4 | 0, !((-1 ^ (de = l[Z >> 2])) & de - 16843009 & -2139062144); )
                              ;
                            for (; Z = (L = Z) + 1 | 0, B[0 | L]; )
                              ;
                          }
                          L = ae + (L - ae | 0) | 0;
                        }
                      return B[0 | L] == (255 & le) ? L : 0;
                    }
                    function Ba(L, Z) {
                      var le, ae = 0, de = 0, Ie = 0, Qe = 0, q = 0;
                      for (st = le = st - 192 | 0, Ds(L), Rt(le - -64 | 0, 54, 128); j[0 | (ae = (Qe = le - -64 | 0) + de | 0)] = B[0 | ae] ^ B[Z + de | 0], j[0 | (Ie = (ae = 1 | de) + Qe | 0)] = B[0 | Ie] ^ B[Z + ae | 0], j[0 | (Ie = (ae = 2 | de) + Qe | 0)] = B[0 | Ie] ^ B[Z + ae | 0], j[0 | (ae = (ae = Qe) + (Qe = 3 | de) | 0)] = B[0 | ae] ^ B[Z + Qe | 0], de = de + 4 | 0, (0 | (q = q + 4 | 0)) != 32; )
                        ;
                      for (Ni(L, de = le - -64 | 0, 128, 0), Ds(Qe = L + 208 | 0), Rt(de, 92, 128), de = 0, q = 0; j[0 | (ae = (L = le - -64 | 0) + de | 0)] = B[0 | ae] ^ B[Z + de | 0], j[0 | (Ie = (ae = 1 | de) + L | 0)] = B[0 | Ie] ^ B[Z + ae | 0], j[0 | (Ie = (ae = 2 | de) + L | 0)] = B[0 | Ie] ^ B[Z + ae | 0], j[0 | (ae = (ae = L) + (L = 3 | de) | 0)] = B[0 | ae] ^ B[L + Z | 0], de = de + 4 | 0, (0 | (q = q + 4 | 0)) != 32; )
                        ;
                      Ni(Qe, L = le - -64 | 0, 128, 0), Ro(L, 128), Ro(le, 64), st = le + 192 | 0;
                    }
                    function Ms(L, Z, le, ae, de, Ie, Qe) {
                      var q, be, Ue, Ye, Te, Ne = 0;
                      return st = q = st - 352 | 0, ma(q, Ie, Qe), !((!de & ae >>> 0 > L - le >>> 0 | (0 | de) != 0) & L >>> 0 > le >>> 0) & (!de & ae >>> 0 <= le - L >>> 0 | L >>> 0 >= le >>> 0) || (le = Re(L, le, ae)), l[q + 56 >> 2] = 0, l[q + 60 >> 2] = 0, l[q + 48 >> 2] = 0, l[q + 52 >> 2] = 0, l[q + 40 >> 2] = 0, l[q + 44 >> 2] = 0, l[q + 32 >> 2] = 0, l[q + 36 >> 2] = 0, Qe = (Ne = !de & ae >>> 0 >= 32 | (0 | de) != 0) ? 32 : ae, Te = Ne = Ne ? 0 : de, (Ue = !(Qe | Ne)) || yt(q - -64 | 0, le, Qe), Bi(be = q + 32 | 0, be, Ye = Qe + 32 | 0, Ne = Ye >>> 0 < 32 ? Ne + 1 | 0 : Ne, Ie = Ie + 16 | 0, q), Es(q + 96 | 0, be), Ue || yt(L, q - -64 | 0, Qe), Ro(q + 32 | 0, 64), !de & ae >>> 0 >= 33 | de && zo(L + Qe | 0, le + Qe | 0, ae - Qe | 0, de - (Te + (ae >>> 0 < Qe >>> 0) | 0) | 0, Ie, q), Ro(q, 32), Yo(le = q + 96 | 0, L, ae, de), ta(le, Z), Ro(le, 256), st = q + 352 | 0, 0;
                    }
                    function Xs(L, Z, le, ae, de, Ie, Qe) {
                      var q, be, Ue = 0, Ye = 0;
                      st = q = st - 96 | 0, ma(q, Ie, Qe), Qe = q + 32 | 0, be = Ie + 16 | 0, Ki[l[8724]](Qe, 32, 0, be, q), Ie = -1;
                      e: {
                        if (!(0 | Ki[l[8718]](le, Z, ae, de, Qe))) {
                          if (Ie = 0, !L)
                            break e;
                          !((!de & ae >>> 0 > Z - L >>> 0 | (0 | de) != 0) & L >>> 0 < Z >>> 0) & (!de & ae >>> 0 <= L - Z >>> 0 | L >>> 0 <= Z >>> 0) || (Z = Re(L, Z, ae)), (Qe = (le = !de & ae >>> 0 >= 32 | (0 | de) != 0) ? 32 : ae) | (le = le ? 0 : de) ? (Ye = yt(q - -64 | 0, Z, Qe), Bi(Ie = q + 32 | 0, Ie, Ue = Qe + 32 | 0, Ue >>> 0 < 32 ? le + 1 | 0 : le, be, q), yt(L, Ye, Qe)) : Bi(Ie = q + 32 | 0, Ie, Ue = Qe + 32 | 0, Ue >>> 0 < 32 ? le + 1 | 0 : le, be, q), Ro(q + 32 | 0, 64), Ie = 0, !de & ae >>> 0 < 33 || zo(L + Qe | 0, Z + Qe | 0, ae - Qe | 0, de - (le + (ae >>> 0 < Qe >>> 0) | 0) | 0, be, q);
                        }
                        Ro(q, 32);
                      }
                      return st = q + 96 | 0, Ie;
                    }
                    function ea(L, Z, le, ae, de, Ie, Qe, q, be, Ue) {
                      var Ye, Te;
                      return st = Ye = st - 400 | 0, l[Ye + 4 >> 2] = 0, da(Te = Ye + 16 | 0, be, Ue), Ue = B[be + 20 | 0] | B[be + 21 | 0] << 8 | B[be + 22 | 0] << 16 | B[be + 23 | 0] << 24, l[Ye + 8 >> 2] = B[be + 16 | 0] | B[be + 17 | 0] << 8 | B[be + 18 | 0] << 16 | B[be + 19 | 0] << 24, l[Ye + 12 >> 2] = Ue, ls(Ue = Ye + 80 | 0, 64, Ye + 4 | 0, Te), Es(be = Ye + 144 | 0, Ue), Ro(Ue, 64), Yo(be, Ie, Qe, q), Yo(be, 34816, 0 - Qe & 15, 0), Yo(be, Z, le, ae), Yo(be, 34816, 0 - le & 15, 0), l[Ye + 72 >> 2] = Qe, l[Ye + 76 >> 2] = q, Yo(be, Ie = Ye + 72 | 0, 8, 0), l[Ye + 72 >> 2] = le, l[Ye + 76 >> 2] = ae, Yo(be, Ie, 8, 0), ta(be, Ie = Ye + 48 | 0), Ro(be, 256), be = Ps(Ie, de), Ro(Ie, 16), L && (be ? (Rt(L, 0, le), be = -1) : (go(L, Z, le, ae, Ye + 4 | 0, Ye + 16 | 0), be = 0)), Ro(Ye + 16 | 0, 32), st = Ye + 400 | 0, be;
                    }
                    function Ji(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      var Te, Ne, We;
                      return st = Te = st - 384 | 0, l[Te + 4 >> 2] = 0, da(Ne = Te + 16 | 0, Ue, Ye), Ye = B[Ue + 20 | 0] | B[Ue + 21 | 0] << 8 | B[Ue + 22 | 0] << 16 | B[Ue + 23 | 0] << 24, l[Te + 8 >> 2] = B[Ue + 16 | 0] | B[Ue + 17 | 0] << 8 | B[Ue + 18 | 0] << 16 | B[Ue + 19 | 0] << 24, l[Te + 12 >> 2] = Ye, ls(Ye = Te - -64 | 0, 64, We = Te + 4 | 0, Ne), Es(Ue = Te + 128 | 0, Ye), Ro(Ye, 64), Yo(Ue, Qe, q, be), Yo(Ue, 34816, 0 - q & 15, 0), go(L, ae, de, Ie, We, Ne), Yo(Ue, L, de, Ie), Yo(Ue, 34816, 0 - de & 15, 0), l[Te + 56 >> 2] = q, l[Te + 60 >> 2] = be, Yo(Ue, L = Te + 56 | 0, 8, 0), l[Te + 56 >> 2] = de, l[Te + 60 >> 2] = Ie, Yo(Ue, L, 8, 0), ta(Ue, Z), Ro(Ue, 256), le && (l[le >> 2] = 16, l[le + 4 >> 2] = 0), Ro(Te + 16 | 0, 32), st = Te + 384 | 0, 0;
                    }
                    function Si(L, Z, le, ae) {
                      var de, Ie = 0;
                      return st = de = st - 208 | 0, l[de + 72 >> 2] = 0, l[de + 76 >> 2] = 0, Ie = l[8487], l[de + 8 >> 2] = l[8486], l[de + 12 >> 2] = Ie, Ie = l[8489], l[de + 16 >> 2] = l[8488], l[de + 20 >> 2] = Ie, Ie = l[8491], l[de + 24 >> 2] = l[8490], l[de + 28 >> 2] = Ie, Ie = l[8493], l[de + 32 >> 2] = l[8492], l[de + 36 >> 2] = Ie, Ie = l[8495], l[de + 40 >> 2] = l[8494], l[de + 44 >> 2] = Ie, Ie = l[8497], l[de + 48 >> 2] = l[8496], l[de + 52 >> 2] = Ie, Ie = l[8499], l[de + 56 >> 2] = l[8498], l[de + 60 >> 2] = Ie, l[de + 64 >> 2] = 0, l[de + 68 >> 2] = 0, Ie = l[8485], l[de >> 2] = l[8484], l[de + 4 >> 2] = Ie, Ni(de, Z, le, ae), Qi(de, L), st = de + 208 | 0, 0;
                    }
                    function Ts(L, Z) {
                      var le, ae = 0, de = 0, Ie = 0;
                      if (j[15 + (le = st - 16 | 0) | 0] = 0, Z) {
                        if (de = 3 & Z, Z >>> 0 >= 4)
                          for (Ie = -4 & Z, Z = 0; j[le + 15 | 0] = B[L + ae | 0] | B[le + 15 | 0], j[le + 15 | 0] = B[(1 | ae) + L | 0] | B[le + 15 | 0], j[le + 15 | 0] = B[(2 | ae) + L | 0] | B[le + 15 | 0], j[le + 15 | 0] = B[(3 | ae) + L | 0] | B[le + 15 | 0], ae = ae + 4 | 0, (0 | Ie) != (0 | (Z = Z + 4 | 0)); )
                            ;
                        if (de)
                          for (Z = 0; j[le + 15 | 0] = B[L + ae | 0] | B[le + 15 | 0], ae = ae + 1 | 0, (0 | de) != (0 | (Z = Z + 1 | 0)); )
                            ;
                      }
                      return B[le + 15 | 0] - 1 >>> 8 & 1;
                    }
                    function Ds(L) {
                      var Z = 0;
                      l[L + 64 >> 2] = 0, l[L + 68 >> 2] = 0, l[L + 72 >> 2] = 0, l[L + 76 >> 2] = 0, Z = l[8485], l[L >> 2] = l[8484], l[L + 4 >> 2] = Z, Z = l[8487], l[L + 8 >> 2] = l[8486], l[L + 12 >> 2] = Z, Z = l[8489], l[L + 16 >> 2] = l[8488], l[L + 20 >> 2] = Z, Z = l[8491], l[L + 24 >> 2] = l[8490], l[L + 28 >> 2] = Z, Z = l[8493], l[L + 32 >> 2] = l[8492], l[L + 36 >> 2] = Z, Z = l[8495], l[L + 40 >> 2] = l[8494], l[L + 44 >> 2] = Z, Z = l[8497], l[L + 48 >> 2] = l[8496], l[L + 52 >> 2] = Z, Z = l[8499], l[L + 56 >> 2] = l[8498], l[L + 60 >> 2] = Z;
                    }
                    function gs(L, Z, le) {
                      var ae, de = 0, Ie = 0;
                      if (l[12 + (ae = st - 16 | 0) >> 2] = L, l[ae + 8 >> 2] = Z, L = 0, j[ae + 7 | 0] = 0, le) {
                        if (Z = 1 & le, (0 | le) != 1)
                          for (Ie = -2 & le, le = 0; j[ae + 7 | 0] = B[ae + 7 | 0] | B[l[ae + 12 >> 2] + L | 0] ^ B[l[ae + 8 >> 2] + L | 0], de = 1 | L, j[ae + 7 | 0] = B[ae + 7 | 0] | B[de + l[ae + 12 >> 2] | 0] ^ B[l[ae + 8 >> 2] + de | 0], L = L + 2 | 0, (0 | Ie) != (0 | (le = le + 2 | 0)); )
                            ;
                        Z && (j[ae + 7 | 0] = B[ae + 7 | 0] | B[l[ae + 12 >> 2] + L | 0] ^ B[l[ae + 8 >> 2] + L | 0]);
                      }
                      return (B[ae + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Os(L) {
                      for (var Z = 0, le = 0, ae = 0, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0; de = (le = B[L + ae | 0]) ^ B[0 | (Z = ae + 2448 | 0)] | de, Ie = le ^ B[Z + 192 | 0] | Ie, Qe = le ^ B[Z + 160 | 0] | Qe, q = le ^ B[Z + 128 | 0] | q, be = le ^ B[Z + 96 | 0] | be, Ue = le ^ B[Z - -64 | 0] | Ue, Ye = le ^ B[Z + 32 | 0] | Ye, (0 | (ae = ae + 1 | 0)) != 31; )
                        ;
                      return ((255 & ((Z = 127 ^ (L = 127 & B[L + 31 | 0])) | Ie)) - 1 | (255 & (Z | Qe)) - 1 | (255 & (Z | q)) - 1 | (255 & (122 ^ L | be)) - 1 | (255 & (5 ^ L | Ue)) - 1 | (255 & (L | Ye)) - 1 | (255 & (L | de)) - 1) >>> 8 & 1;
                    }
                    function vt(L, Z, le) {
                      var ae = 0, de = 0, Ie = 0, Qe = 0;
                      return de = 31 & (Ie = Qe = 63 & le), Ie = Ie >>> 0 >= 32 ? -1 >>> de | 0 : (ae = -1 >>> de | 0) | (1 << de) - 1 << 32 - de, Ie &= L, ae &= Z, de = 31 & Qe, Qe >>> 0 >= 32 ? (ae = Ie << de, Qe = 0) : (ae = (1 << de) - 1 & Ie >>> 32 - de | ae << de, Qe = Ie << de), Ie = ae, ae = 31 & (de = 0 - le & 63), de >>> 0 >= 32 ? (ae = -1 << ae, le = 0) : ae = (le = -1 << ae) | (1 << ae) - 1 & -1 >>> 32 - ae, L &= le, Z &= ae, ae = 31 & de, de >>> 0 >= 32 ? (le = 0, L = Z >>> ae | 0) : (le = Z >>> ae | 0, L = ((1 << ae) - 1 & Z) << 32 - ae | L >>> ae), Oe = le | Ie, L | Qe;
                    }
                    function bs(L, Z, le, ae, de, Ie, Qe, q, be, Ue) {
                      var Ye, Te, Ne;
                      return st = Ye = st - 352 | 0, ls(Ne = Ye + 32 | 0, 64, be, Ue), Es(Te = Ye + 96 | 0, Ne), Ro(Ne, 64), Yo(Te, Ie, Qe, q), Yo(Te, 33920, 0 - Qe & 15, 0), Yo(Te, Z, le, ae), Yo(Te, 33920, 0 - le & 15, 0), l[Ye + 24 >> 2] = Qe, l[Ye + 28 >> 2] = q, Yo(Te, Ie = Ye + 24 | 0, 8, 0), l[Ye + 24 >> 2] = le, l[Ye + 28 >> 2] = ae, Yo(Te, Ie, 8, 0), ta(Te, Ye), Ro(Te, 256), Ie = Ps(Ye, de), Ro(Ye, 16), L && (Ie ? (Rt(L, 0, le), Ie = -1) : (ds(L, Z, le, ae, be, 1, Ue), Ie = 0)), st = Ye + 352 | 0, Ie;
                    }
                    function Di(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      var Te, Ne, We;
                      return st = Te = st - 336 | 0, ls(We = Te + 16 | 0, 64, Ue, Ye), Es(Ne = Te + 80 | 0, We), Ro(We, 64), Yo(Ne, Qe, q, be), Yo(Ne, 33920, 0 - q & 15, 0), ds(L, ae, de, Ie, Ue, 1, Ye), Yo(Ne, L, de, Ie), Yo(Ne, 33920, 0 - de & 15, 0), l[Te + 8 >> 2] = q, l[Te + 12 >> 2] = be, Yo(Ne, L = Te + 8 | 0, 8, 0), l[Te + 8 >> 2] = de, l[Te + 12 >> 2] = Ie, Yo(Ne, L, 8, 0), ta(Ne, Z), Ro(Ne, 256), le && (l[le >> 2] = 16, l[le + 4 >> 2] = 0), st = Te + 336 | 0, 0;
                    }
                    function Pa(L, Z, le, ae, de, Ie, Qe, q, be, Ue) {
                      var Ye, Te, Ne;
                      return st = Ye = st - 352 | 0, Ei(Ne = Ye + 32 | 0, be, Ue), Es(Te = Ye + 96 | 0, Ne), Ro(Ne, 64), Yo(Te, Ie, Qe, q), l[Ye + 24 >> 2] = Qe, l[Ye + 28 >> 2] = q, Yo(Te, Ie = Ye + 24 | 0, 8, 0), Yo(Te, Z, le, ae), l[Ye + 24 >> 2] = le, l[Ye + 28 >> 2] = ae, Yo(Te, Ie, 8, 0), ta(Te, Ye), Ro(Te, 256), Ie = Ps(Ye, de), Ro(Ye, 16), L && (Ie ? (Rt(L, 0, le), Ie = -1) : (Zr(L, Z, le, ae, be, Ue), Ie = 0)), st = Ye + 352 | 0, Ie;
                    }
                    function Ea(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      var Te, Ne, We;
                      return st = Te = st - 336 | 0, Ei(We = Te + 16 | 0, Ue, Ye), Es(Ne = Te + 80 | 0, We), Ro(We, 64), Yo(Ne, Qe, q, be), l[Te + 8 >> 2] = q, l[Te + 12 >> 2] = be, Yo(Ne, Qe = Te + 8 | 0, 8, 0), Zr(L, ae, de, Ie, Ue, Ye), Yo(Ne, L, de, Ie), l[Te + 8 >> 2] = de, l[Te + 12 >> 2] = Ie, Yo(Ne, Qe, 8, 0), ta(Ne, Z), Ro(Ne, 256), le && (l[le >> 2] = 16, l[le + 4 >> 2] = 0), st = Te + 336 | 0, 0;
                    }
                    function Cs(L, Z) {
                      var le;
                      for (l[12 + (le = st - 16 | 0) >> 2] = L, l[le + 8 >> 2] = Z, L = 0, l[le + 4 >> 2] = 0; l[le + 4 >> 2] = l[le + 4 >> 2] | B[l[le + 12 >> 2] + L | 0] ^ B[l[le + 8 >> 2] + L | 0], Z = 1 | L, l[le + 4 >> 2] = l[le + 4 >> 2] | B[Z + l[le + 12 >> 2] | 0] ^ B[Z + l[le + 8 >> 2] | 0], (0 | (L = L + 2 | 0)) != 32; )
                        ;
                      return (l[le + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function ya(L) {
                      var Z = 0, le = 0, ae = 0, de = 0;
                      for (Z = 1; Z = B[0 | (le = L + ae | 0)] + Z | 0, j[0 | le] = Z, Z = B[0 | (le = (1 | ae) + L | 0)] + (Z >>> 8 | 0) | 0, j[0 | le] = Z, Z = B[0 | (le = (2 | ae) + L | 0)] + (Z >>> 8 | 0) | 0, j[0 | le] = Z, Z = B[0 | (le = (3 | ae) + L | 0)] + (Z >>> 8 | 0) | 0, j[0 | le] = Z, Z = Z >>> 8 | 0, ae = ae + 4 | 0, (0 | (de = de + 4 | 0)) != 4; )
                        ;
                    }
                    function dt(L, Z, le, ae) {
                      var de, Ie, Qe, q, be = 0, Ue = 0;
                      return q = wr(be = le >>> 16 | 0, Ue = L >>> 16 | 0), be = (65535 & (Ue = ((Qe = wr(de = 65535 & le, Ie = 65535 & L)) >>> 16 | 0) + wr(Ue, de) | 0)) + wr(be, Ie) | 0, Oe = (wr(Z, le) + q | 0) + wr(L, ae) + (Ue >>> 16) + (be >>> 16) | 0, 65535 & Qe | be << 16;
                    }
                    function ds(L, Z, le, ae, de, Ie, Qe) {
                      var q = 0, be = 0;
                      q = ae, (((q = (be = le + 63 | 0) >>> 0 < 63 ? q + 1 | 0 : q) >>> 6 | 0) + ((0 | (q = (63 & q) << 26 | be >>> 6)) != 0) | 0) == 1 & Ie >>> 0 > (be = 0 - q | 0) >>> 0 | (0 | ae) == 1 | ae >>> 0 > 1 ? (Ko(), Xr()) : Ki[l[8716]](L, Z, le, ae, de, Ie, Qe);
                    }
                    function Se(L, Z) {
                      L |= 0;
                      var le, ae = 0, de = 0, Ie = 0;
                      if (st = le = st - 16 | 0, Z |= 0)
                        for (; j[le + 15 | 0] = 0, de = L + ae | 0, Ie = 0 | ks(34904, le + 15 | 0, 0), j[0 | de] = Ie, (0 | (ae = ae + 1 | 0)) != (0 | Z); )
                          ;
                      st = le + 16 | 0;
                    }
                    function Ee(L, Z, le, ae, de, Ie, Qe) {
                      var q, be = 0;
                      return st = q = st - 32 | 0, be = -1, !ae & le >>> 0 < 16 || Xe(q, Ie, Qe) || (be = Xs(L, Z + 16 | 0, Z, le - 16 | 0, ae - (le >>> 0 < 16) | 0, de, q), Ro(q, 32)), st = q + 32 | 0, be;
                    }
                    function ke(L) {
                      var Z, le;
                      return (L = (Z = l[8712]) + (le = L + 7 & -8) | 0) >>> 0 <= Z >>> 0 && le || L >>> 0 > Xa() << 16 >>> 0 && !(0 | qa(0 | L)) ? (l[8916] = 48, -1) : (l[8712] = L, Z);
                    }
                    function Ce(L, Z) {
                      var le, ae, de;
                      st = le = st - 176 | 0, wi(ae = le + 96 | 0, Z + 80 | 0), rr(de = le + 48 | 0, Z, ae), rr(le, Z + 40 | 0, ae), ms(L, le), ms(le + 144 | 0, de), j[L + 31 | 0] = B[L + 31 | 0] ^ B[le + 144 | 0] << 7, st = le + 176 | 0;
                    }
                    function Re(L, Z, le) {
                      var ae = 0;
                      if (L >>> 0 < Z >>> 0)
                        return yt(L, Z, le);
                      if (le)
                        for (ae = L + le | 0, Z = Z + le | 0; Z = Z - 1 | 0, j[0 | (ae = ae - 1 | 0)] = B[0 | Z], le = le - 1 | 0; )
                          ;
                      return L;
                    }
                    function Fe(L, Z, le, ae, de, Ie, Qe) {
                      var q, be = 0;
                      if (st = q = st - 32 | 0, !ae & le >>> 0 < 4294967280)
                        return be = -1, Xe(q, Ie, Qe) || (be = Ms(L + 16 | 0, L, Z, le, ae, de, q), Ro(q, 32)), st = q + 32 | 0, be;
                      Ko(), Xr();
                    }
                    function qe(L, Z, le, ae, de, Ie) {
                      return Z |= 0, 0 | (!(ae |= 0) & (le |= 0) >>> 0 >= 16 | ae ? Xs(L |= 0, Z + 16 | 0, Z, le - 16 | 0, ae - (le >>> 0 < 16) | 0, de |= 0, Ie |= 0) : -1);
                    }
                    function Xe(L, Z, le) {
                      L |= 0;
                      var ae, de = 0;
                      return st = ae = st - 32 | 0, de = -1, ka(ae, le |= 0, Z |= 0) || (de = ma(L, 34832, ae)), st = ae + 32 | 0, 0 | de;
                    }
                    function yt(L, Z, le) {
                      var ae = 0;
                      if (le)
                        for (ae = L; j[0 | ae] = B[0 | Z], ae = ae + 1 | 0, Z = Z + 1 | 0, le = le - 1 | 0; )
                          ;
                      return L;
                    }
                    function Rt(L, Z, le) {
                      var ae = 0;
                      if (le)
                        for (ae = L; j[0 | ae] = Z, ae = ae + 1 | 0, le = le - 1 | 0; )
                          ;
                      return L;
                    }
                    function Yt(L, Z, le) {
                      return L |= 0, Z |= 0, (le |= 0) >>> 0 >= 256 && (Hs(1260, 1187, 107, 1067), Xr()), 0 | ua(L, Z, 255 & le);
                    }
                    function Mn(L, Z) {
                      var le;
                      st = le = st + -64 | 0, Qi(L, le), Ni(L = L + 208 | 0, le, 64, 0), Qi(L, Z), Ro(le, 64), st = le - -64 | 0;
                    }
                    function Un(L, Z, le, ae, de, Ie, Qe) {
                      return 0 | Ms(L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, Ie |= 0, Qe |= 0);
                    }
                    function Jn(L, Z, le, ae, de, Ie, Qe) {
                      return 0 | Xs(L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, Ie |= 0, Qe |= 0);
                    }
                    function Rn(L, Z) {
                      var le = 0;
                      return (-1 >>> (le = 31 & Z) & L) << le | ((le = L) & -1 << (L = 0 - Z & 31)) >>> L;
                    }
                    function Zr(L, Z, le, ae, de, Ie) {
                      (0 | ae) == 1 | ae >>> 0 > 1 && (Ko(), Xr()), Ki[l[8715]](L, Z, le, ae, de, 1, 0, Ie);
                    }
                    function go(L, Z, le, ae, de, Ie) {
                      (0 | ae) == 1 | ae >>> 0 > 1 && (Ko(), Xr()), Ki[l[8716]](L, Z, le, ae, de, 1, Ie);
                    }
                    function to() {
                      var L;
                      st = L = st - 16 | 0, j[L + 15 | 0] = 0, ks(34940, L + 15 | 0, 0), st = L + 16 | 0;
                    }
                    function Bo(L, Z, le) {
                      return 0 | ka(L |= 0, Z |= 0, le |= 0);
                    }
                    function zo(L, Z, le, ae, de, Ie) {
                      Ki[l[8725]](L, Z, le, ae, de, 1, 0, Ie);
                    }
                    function Ko() {
                      var L;
                      (L = l[9050]) && Ki[0 | L](), Oa(), Xr();
                    }
                    function hs(L, Z) {
                      return L |= 0, Se(Z |= 0, 32), 0 | Wa(L, Z);
                    }
                    function Bi(L, Z, le, ae, de, Ie) {
                      Ki[l[8725]](L, Z, le, ae, de, 0, 0, Ie);
                    }
                    function Va(L) {
                      return L ? 31 - zi(L - 1 ^ L) | 0 : 32;
                    }
                    function Fa(L, Z, le, ae) {
                      Ki[l[8716]](L, Z, 40, 0, le, 0, ae);
                    }
                    function Ja(L, Z) {
                      return 0 | Wa(L |= 0, Z |= 0);
                    }
                    function ls(L, Z, le, ae) {
                      Ki[l[8714]](L, Z, 0, le, ae);
                    }
                    function Ei(L, Z, le) {
                      Ki[l[8713]](L, 64, 0, Z, le);
                    }
                    function Yo(L, Z, le, ae) {
                      Ki[l[8720]](L, Z, le, ae);
                    }
                    function Wa(L, Z) {
                      return 0 | Ki[l[8723]](L, Z);
                    }
                    function Es(L, Z) {
                      Ki[l[8719]](L, Z);
                    }
                    function ta(L, Z) {
                      Ki[l[8721]](L, Z);
                    }
                    function ja(L, Z, le, ae) {
                      Ni(L, Z, le, ae);
                    }
                    function na(L) {
                      Se(L |= 0, 32);
                    }
                    function Ro(L, Z) {
                      Rt(L, 0, Z);
                    }
                    function ra() {
                      return 16;
                    }
                    function $i() {
                      return 32;
                    }
                    function va() {
                      return 24;
                    }
                    function Qa() {
                      return -17;
                    }
                    function Ra() {
                      return 64;
                    }
                    function La() {
                      return 1;
                    }
                    function Ha() {
                      return 3;
                    }
                    function za() {
                      return 8;
                    }
                    function Na() {
                      return 0;
                    }
                    eo(vr = B, 1024, "TGlic29kaXVtRFJHcmFuZG9tYnl0ZXMAYjY0X3BvcyA8PSBiNjRfbGVuAGNyeXB0b19nZW5lcmljaGFzaF9ibGFrZTJiX2ZpbmFsAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAYnVmX2xlbiA8PSBTSVpFX01BWABvdXRsZW4gPD0gVUlOVDhfTUFYAFMtPmJ1ZmxlbiA8PSBCTEFLRTJCX0JMT0NLQllURVMAMS4wLjE4AHNvZGl1bV9iaW4yYmFzZTY0AAAAAAAAAAC2eFn/hXLTAL1uFf8PCmoAKcABAJjoef+8PKD/mXHO/wC34v60DUj/AAAAAAAAAACwoA7+08mG/54YjwB/aTUAYAy9AKfX+/+fTID+amXh/x78BACSDK4="), eo(vr, 1440, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), eo(vr, 1488, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), eo(vr, 2480, "AQ=="), eo(vr, 2512, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), eo(vr, 2703, "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"), eo(vr, 33676, "AQ=="), eo(vr, 33712, "AQ=="), eo(vr, 33744, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////fw=="), eo(vr, 33936, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), eo(vr, 34768, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), eo(vr, 34848, "cI0BAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0=");
                    var xa, Ki = (xa = [null, function(L, Z, le, ae, de) {
                      var Ie;
                      return L |= 0, ae |= 0, de |= 0, st = Ie = st + -64 | 0, (Z |= 0) | (le |= 0) && (l[Ie + 8 >> 2] = 2036477234, l[Ie + 12 >> 2] = 1797285236, l[Ie >> 2] = 1634760805, l[Ie + 4 >> 2] = 857760878, l[Ie + 16 >> 2] = B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, l[Ie + 20 >> 2] = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, l[Ie + 24 >> 2] = B[de + 8 | 0] | B[de + 9 | 0] << 8 | B[de + 10 | 0] << 16 | B[de + 11 | 0] << 24, l[Ie + 28 >> 2] = B[de + 12 | 0] | B[de + 13 | 0] << 8 | B[de + 14 | 0] << 16 | B[de + 15 | 0] << 24, l[Ie + 32 >> 2] = B[de + 16 | 0] | B[de + 17 | 0] << 8 | B[de + 18 | 0] << 16 | B[de + 19 | 0] << 24, l[Ie + 36 >> 2] = B[de + 20 | 0] | B[de + 21 | 0] << 8 | B[de + 22 | 0] << 16 | B[de + 23 | 0] << 24, l[Ie + 40 >> 2] = B[de + 24 | 0] | B[de + 25 | 0] << 8 | B[de + 26 | 0] << 16 | B[de + 27 | 0] << 24, de = B[de + 28 | 0] | B[de + 29 | 0] << 8 | B[de + 30 | 0] << 16 | B[de + 31 | 0] << 24, l[Ie + 48 >> 2] = 0, l[Ie + 52 >> 2] = 0, l[Ie + 44 >> 2] = de, l[Ie + 56 >> 2] = B[0 | ae] | B[ae + 1 | 0] << 8 | B[ae + 2 | 0] << 16 | B[ae + 3 | 0] << 24, l[Ie + 60 >> 2] = B[ae + 4 | 0] | B[ae + 5 | 0] << 8 | B[ae + 6 | 0] << 16 | B[ae + 7 | 0] << 24, Ks(Ie, L = Rt(L, 0, Z), L, Z, le), Ro(Ie, 64)), st = Ie - -64 | 0, 0;
                    }, function(L, Z, le, ae, de) {
                      var Ie;
                      return L |= 0, ae |= 0, de |= 0, st = Ie = st + -64 | 0, (Z |= 0) | (le |= 0) && (l[Ie + 8 >> 2] = 2036477234, l[Ie + 12 >> 2] = 1797285236, l[Ie >> 2] = 1634760805, l[Ie + 4 >> 2] = 857760878, l[Ie + 16 >> 2] = B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, l[Ie + 20 >> 2] = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, l[Ie + 24 >> 2] = B[de + 8 | 0] | B[de + 9 | 0] << 8 | B[de + 10 | 0] << 16 | B[de + 11 | 0] << 24, l[Ie + 28 >> 2] = B[de + 12 | 0] | B[de + 13 | 0] << 8 | B[de + 14 | 0] << 16 | B[de + 15 | 0] << 24, l[Ie + 32 >> 2] = B[de + 16 | 0] | B[de + 17 | 0] << 8 | B[de + 18 | 0] << 16 | B[de + 19 | 0] << 24, l[Ie + 36 >> 2] = B[de + 20 | 0] | B[de + 21 | 0] << 8 | B[de + 22 | 0] << 16 | B[de + 23 | 0] << 24, l[Ie + 40 >> 2] = B[de + 24 | 0] | B[de + 25 | 0] << 8 | B[de + 26 | 0] << 16 | B[de + 27 | 0] << 24, de = B[de + 28 | 0] | B[de + 29 | 0] << 8 | B[de + 30 | 0] << 16 | B[de + 31 | 0] << 24, l[Ie + 48 >> 2] = 0, l[Ie + 44 >> 2] = de, l[Ie + 52 >> 2] = B[0 | ae] | B[ae + 1 | 0] << 8 | B[ae + 2 | 0] << 16 | B[ae + 3 | 0] << 24, l[Ie + 56 >> 2] = B[ae + 4 | 0] | B[ae + 5 | 0] << 8 | B[ae + 6 | 0] << 16 | B[ae + 7 | 0] << 24, l[Ie + 60 >> 2] = B[ae + 8 | 0] | B[ae + 9 | 0] << 8 | B[ae + 10 | 0] << 16 | B[ae + 11 | 0] << 24, Ks(Ie, L = Rt(L, 0, Z), L, Z, le), Ro(Ie, 64)), st = Ie - -64 | 0, 0;
                    }, function(L, Z, le, ae, de, Ie, Qe, q) {
                      var be;
                      return L |= 0, Z |= 0, de |= 0, Ie |= 0, Qe |= 0, q |= 0, st = be = st + -64 | 0, (le |= 0) | (ae |= 0) && (l[be + 8 >> 2] = 2036477234, l[be + 12 >> 2] = 1797285236, l[be >> 2] = 1634760805, l[be + 4 >> 2] = 857760878, l[be + 16 >> 2] = B[0 | q] | B[q + 1 | 0] << 8 | B[q + 2 | 0] << 16 | B[q + 3 | 0] << 24, l[be + 20 >> 2] = B[q + 4 | 0] | B[q + 5 | 0] << 8 | B[q + 6 | 0] << 16 | B[q + 7 | 0] << 24, l[be + 24 >> 2] = B[q + 8 | 0] | B[q + 9 | 0] << 8 | B[q + 10 | 0] << 16 | B[q + 11 | 0] << 24, l[be + 28 >> 2] = B[q + 12 | 0] | B[q + 13 | 0] << 8 | B[q + 14 | 0] << 16 | B[q + 15 | 0] << 24, l[be + 32 >> 2] = B[q + 16 | 0] | B[q + 17 | 0] << 8 | B[q + 18 | 0] << 16 | B[q + 19 | 0] << 24, l[be + 36 >> 2] = B[q + 20 | 0] | B[q + 21 | 0] << 8 | B[q + 22 | 0] << 16 | B[q + 23 | 0] << 24, l[be + 40 >> 2] = B[q + 24 | 0] | B[q + 25 | 0] << 8 | B[q + 26 | 0] << 16 | B[q + 27 | 0] << 24, l[be + 44 >> 2] = B[q + 28 | 0] | B[q + 29 | 0] << 8 | B[q + 30 | 0] << 16 | B[q + 31 | 0] << 24, l[be + 48 >> 2] = Ie, l[be + 52 >> 2] = Qe, l[be + 56 >> 2] = B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, l[be + 60 >> 2] = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, Ks(be, Z, L, le, ae), Ro(be, 64)), st = be - -64 | 0, 0;
                    }, function(L, Z, le, ae, de, Ie, Qe) {
                      var q;
                      return L |= 0, Z |= 0, de |= 0, Ie |= 0, Qe |= 0, st = q = st + -64 | 0, (le |= 0) | (ae |= 0) && (l[q + 8 >> 2] = 2036477234, l[q + 12 >> 2] = 1797285236, l[q >> 2] = 1634760805, l[q + 4 >> 2] = 857760878, l[q + 16 >> 2] = B[0 | Qe] | B[Qe + 1 | 0] << 8 | B[Qe + 2 | 0] << 16 | B[Qe + 3 | 0] << 24, l[q + 20 >> 2] = B[Qe + 4 | 0] | B[Qe + 5 | 0] << 8 | B[Qe + 6 | 0] << 16 | B[Qe + 7 | 0] << 24, l[q + 24 >> 2] = B[Qe + 8 | 0] | B[Qe + 9 | 0] << 8 | B[Qe + 10 | 0] << 16 | B[Qe + 11 | 0] << 24, l[q + 28 >> 2] = B[Qe + 12 | 0] | B[Qe + 13 | 0] << 8 | B[Qe + 14 | 0] << 16 | B[Qe + 15 | 0] << 24, l[q + 32 >> 2] = B[Qe + 16 | 0] | B[Qe + 17 | 0] << 8 | B[Qe + 18 | 0] << 16 | B[Qe + 19 | 0] << 24, l[q + 36 >> 2] = B[Qe + 20 | 0] | B[Qe + 21 | 0] << 8 | B[Qe + 22 | 0] << 16 | B[Qe + 23 | 0] << 24, l[q + 40 >> 2] = B[Qe + 24 | 0] | B[Qe + 25 | 0] << 8 | B[Qe + 26 | 0] << 16 | B[Qe + 27 | 0] << 24, Qe = B[Qe + 28 | 0] | B[Qe + 29 | 0] << 8 | B[Qe + 30 | 0] << 16 | B[Qe + 31 | 0] << 24, l[q + 48 >> 2] = Ie, l[q + 44 >> 2] = Qe, l[q + 52 >> 2] = B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, l[q + 56 >> 2] = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, l[q + 60 >> 2] = B[de + 8 | 0] | B[de + 9 | 0] << 8 | B[de + 10 | 0] << 16 | B[de + 11 | 0] << 24, Ks(q, Z, L, le, ae), Ro(q, 64)), st = q - -64 | 0, 0;
                    }, function(L, Z, le, ae, de) {
                      var Ie, Qe, q;
                      return L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, st = Ie = (Qe = st) - 128 & -64, l[Ie >> 2] = 67108863 & (B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24), l[Ie + 4 >> 2] = (B[de + 3 | 0] | B[de + 4 | 0] << 8 | B[de + 5 | 0] << 16 | B[de + 6 | 0] << 24) >>> 2 & 67108611, l[Ie + 8 >> 2] = (B[de + 6 | 0] | B[de + 7 | 0] << 8 | B[de + 8 | 0] << 16 | B[de + 9 | 0] << 24) >>> 4 & 67092735, l[Ie + 12 >> 2] = (B[de + 9 | 0] | B[de + 10 | 0] << 8 | B[de + 11 | 0] << 16 | B[de + 12 | 0] << 24) >>> 6 & 66076671, q = B[de + 12 | 0] | B[de + 13 | 0] << 8 | B[de + 14 | 0] << 16 | B[de + 15 | 0] << 24, l[Ie + 20 >> 2] = 0, l[Ie + 24 >> 2] = 0, l[Ie + 28 >> 2] = 0, l[Ie + 32 >> 2] = 0, l[Ie + 36 >> 2] = 0, l[Ie + 16 >> 2] = q >>> 8 & 1048575, l[Ie + 40 >> 2] = B[de + 16 | 0] | B[de + 17 | 0] << 8 | B[de + 18 | 0] << 16 | B[de + 19 | 0] << 24, l[Ie + 44 >> 2] = B[de + 20 | 0] | B[de + 21 | 0] << 8 | B[de + 22 | 0] << 16 | B[de + 23 | 0] << 24, l[Ie + 48 >> 2] = B[de + 24 | 0] | B[de + 25 | 0] << 8 | B[de + 26 | 0] << 16 | B[de + 27 | 0] << 24, de = B[de + 28 | 0] | B[de + 29 | 0] << 8 | B[de + 30 | 0] << 16 | B[de + 31 | 0] << 24, j[Ie + 80 | 0] = 0, l[Ie + 56 >> 2] = 0, l[Ie + 60 >> 2] = 0, l[Ie + 52 >> 2] = de, la(Ie, Z, le, ae), Aa(Ie, L), st = Qe, 0;
                    }, function(L, Z, le, ae, de) {
                      var Ie, Qe, q;
                      return L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, st = Ie = (Qe = st) - 192 & -64, l[Ie + 64 >> 2] = 67108863 & (B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24), l[Ie + 68 >> 2] = (B[de + 3 | 0] | B[de + 4 | 0] << 8 | B[de + 5 | 0] << 16 | B[de + 6 | 0] << 24) >>> 2 & 67108611, l[Ie + 72 >> 2] = (B[de + 6 | 0] | B[de + 7 | 0] << 8 | B[de + 8 | 0] << 16 | B[de + 9 | 0] << 24) >>> 4 & 67092735, l[Ie + 76 >> 2] = (B[de + 9 | 0] | B[de + 10 | 0] << 8 | B[de + 11 | 0] << 16 | B[de + 12 | 0] << 24) >>> 6 & 66076671, q = B[de + 12 | 0] | B[de + 13 | 0] << 8 | B[de + 14 | 0] << 16 | B[de + 15 | 0] << 24, l[Ie + 84 >> 2] = 0, l[Ie + 88 >> 2] = 0, l[Ie + 92 >> 2] = 0, l[Ie + 96 >> 2] = 0, l[Ie + 100 >> 2] = 0, l[Ie + 80 >> 2] = q >>> 8 & 1048575, l[Ie + 104 >> 2] = B[de + 16 | 0] | B[de + 17 | 0] << 8 | B[de + 18 | 0] << 16 | B[de + 19 | 0] << 24, l[Ie + 108 >> 2] = B[de + 20 | 0] | B[de + 21 | 0] << 8 | B[de + 22 | 0] << 16 | B[de + 23 | 0] << 24, l[Ie + 112 >> 2] = B[de + 24 | 0] | B[de + 25 | 0] << 8 | B[de + 26 | 0] << 16 | B[de + 27 | 0] << 24, de = B[de + 28 | 0] | B[de + 29 | 0] << 8 | B[de + 30 | 0] << 16 | B[de + 31 | 0] << 24, j[Ie + 144 | 0] = 0, l[Ie + 120 >> 2] = 0, l[Ie + 124 >> 2] = 0, l[Ie + 116 >> 2] = de, la(de = Ie - -64 | 0, Z, le, ae), Aa(de, Z = Ie + 48 | 0), L = Ps(L, Z), st = Qe, 0 | L;
                    }, function(L, Z) {
                      var le;
                      return Z |= 0, l[(L |= 0) >> 2] = 67108863 & (B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24), l[L + 4 >> 2] = (B[Z + 3 | 0] | B[Z + 4 | 0] << 8 | B[Z + 5 | 0] << 16 | B[Z + 6 | 0] << 24) >>> 2 & 67108611, l[L + 8 >> 2] = (B[Z + 6 | 0] | B[Z + 7 | 0] << 8 | B[Z + 8 | 0] << 16 | B[Z + 9 | 0] << 24) >>> 4 & 67092735, l[L + 12 >> 2] = (B[Z + 9 | 0] | B[Z + 10 | 0] << 8 | B[Z + 11 | 0] << 16 | B[Z + 12 | 0] << 24) >>> 6 & 66076671, le = B[Z + 12 | 0] | B[Z + 13 | 0] << 8 | B[Z + 14 | 0] << 16 | B[Z + 15 | 0] << 24, l[L + 20 >> 2] = 0, l[L + 24 >> 2] = 0, l[L + 28 >> 2] = 0, l[L + 32 >> 2] = 0, l[L + 36 >> 2] = 0, l[L + 16 >> 2] = le >>> 8 & 1048575, l[L + 40 >> 2] = B[Z + 16 | 0] | B[Z + 17 | 0] << 8 | B[Z + 18 | 0] << 16 | B[Z + 19 | 0] << 24, l[L + 44 >> 2] = B[Z + 20 | 0] | B[Z + 21 | 0] << 8 | B[Z + 22 | 0] << 16 | B[Z + 23 | 0] << 24, l[L + 48 >> 2] = B[Z + 24 | 0] | B[Z + 25 | 0] << 8 | B[Z + 26 | 0] << 16 | B[Z + 27 | 0] << 24, Z = B[Z + 28 | 0] | B[Z + 29 | 0] << 8 | B[Z + 30 | 0] << 16 | B[Z + 31 | 0] << 24, j[L + 80 | 0] = 0, l[L + 56 >> 2] = 0, l[L + 60 >> 2] = 0, l[L + 52 >> 2] = Z, 0;
                    }, function(L, Z, le, ae) {
                      return la(L |= 0, Z |= 0, le |= 0, ae |= 0), 0;
                    }, function(L, Z) {
                      return Aa(L |= 0, Z |= 0), 0;
                    }, function(L, Z, le) {
                      L |= 0, Z |= 0, le |= 0;
                      var ae, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0, kr = 0, Qr = 0, Ur = 0, Lr = 0, Jr = 0, jr = 0, oo = 0, uo = 0, _o = 0, So = 0, Ao = 0, bo = 0, xr = 0, Oo = 0, Yn = 0, ir = 0, Bt = 0, Jt = 0, mn = 0, Hr = 0, Vr = 0, ro = 0, io = 0, fo = 0, po = 0, mo = 0, ho = 0, tn = 0;
                      for (st = ae = st - 368 | 0; rt = (Qe = B[le + de | 0]) ^ B[0 | (be = de + 33680 | 0)] | rt, Ne = Qe ^ B[be + 192 | 0] | Ne, We = Qe ^ B[be + 160 | 0] | We, Te = Qe ^ B[be + 128 | 0] | Te, q = Qe ^ B[be + 96 | 0] | q, Ue = Qe ^ B[be - -64 | 0] | Ue, Ie = Qe ^ B[be + 32 | 0] | Ie, (0 | (de = de + 1 | 0)) != 31; )
                        ;
                      if (de = -1, !(256 & ((255 & ((Qe = 127 ^ (be = 127 & B[le + 31 | 0])) | Ne)) - 1 | (255 & (Qe | We)) - 1 | (255 & (Qe | Te)) - 1 | (255 & (87 ^ be | q)) - 1 | (255 & (Ue | be)) - 1 | (255 & (Ie | be)) - 1 | (255 & (be | rt)) - 1))) {
                        for (de = Z, Z = B[Z + 28 | 0] | B[Z + 29 | 0] << 8 | B[Z + 30 | 0] << 16 | B[Z + 31 | 0] << 24, l[ae + 360 >> 2] = B[de + 24 | 0] | B[de + 25 | 0] << 8 | B[de + 26 | 0] << 16 | B[de + 27 | 0] << 24, l[ae + 364 >> 2] = Z, Z = B[de + 20 | 0] | B[de + 21 | 0] << 8 | B[de + 22 | 0] << 16 | B[de + 23 | 0] << 24, l[ae + 352 >> 2] = B[de + 16 | 0] | B[de + 17 | 0] << 8 | B[de + 18 | 0] << 16 | B[de + 19 | 0] << 24, l[ae + 356 >> 2] = Z, Ie = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, Z = B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, l[ae + 336 >> 2] = Z, l[ae + 340 >> 2] = Ie, Ie = B[de + 12 | 0] | B[de + 13 | 0] << 8 | B[de + 14 | 0] << 16 | B[de + 15 | 0] << 24, l[ae + 344 >> 2] = B[de + 8 | 0] | B[de + 9 | 0] << 8 | B[de + 10 | 0] << 16 | B[de + 11 | 0] << 24, l[ae + 348 >> 2] = Ie, j[ae + 336 | 0] = 248 & Z, j[ae + 367 | 0] = 63 & B[ae + 367 | 0] | 64, ca(ae + 288 | 0, le), l[ae + 260 >> 2] = 0, l[ae + 264 >> 2] = 0, l[ae + 268 >> 2] = 0, l[ae + 272 >> 2] = 0, l[ae + 276 >> 2] = 0, l[ae + 208 >> 2] = 0, l[ae + 212 >> 2] = 0, l[ae + 216 >> 2] = 0, l[ae + 220 >> 2] = 0, l[ae + 224 >> 2] = 0, l[ae + 228 >> 2] = 0, l[ae + 244 >> 2] = 0, l[ae + 248 >> 2] = 0, l[ae + 240 >> 2] = 1, l[ae + 252 >> 2] = 0, l[ae + 256 >> 2] = 0, l[ae + 192 >> 2] = 0, l[ae + 196 >> 2] = 0, l[ae + 200 >> 2] = 0, l[ae + 204 >> 2] = 0, Z = l[ae + 316 >> 2], l[ae + 168 >> 2] = l[ae + 312 >> 2], l[ae + 172 >> 2] = Z, Z = l[ae + 308 >> 2], l[ae + 160 >> 2] = l[ae + 304 >> 2], l[ae + 164 >> 2] = Z, Z = l[ae + 300 >> 2], l[ae + 152 >> 2] = l[ae + 296 >> 2], l[ae + 156 >> 2] = Z, Z = l[ae + 292 >> 2], l[ae + 144 >> 2] = l[ae + 288 >> 2], l[ae + 148 >> 2] = Z, Z = l[ae + 324 >> 2], l[ae + 176 >> 2] = l[ae + 320 >> 2], l[ae + 180 >> 2] = Z, l[ae + 116 >> 2] = 0, l[ae + 120 >> 2] = 0, l[ae + 124 >> 2] = 0, l[ae + 128 >> 2] = 0, l[ae + 132 >> 2] = 0, l[ae + 100 >> 2] = 0, l[ae + 104 >> 2] = 0, l[ae + 96 >> 2] = 1, l[ae + 108 >> 2] = 0, l[ae + 112 >> 2] = 0, le = 254; Qr = l[ae + 276 >> 2], Qe = l[ae + 180 >> 2], Ur = l[ae + 96 >> 2], Lr = l[ae + 192 >> 2], Jr = l[ae + 144 >> 2], jr = l[ae + 240 >> 2], oo = l[ae + 100 >> 2], uo = l[ae + 196 >> 2], _o = l[ae + 148 >> 2], So = l[ae + 244 >> 2], Bn = l[ae + 104 >> 2], Ao = l[ae + 200 >> 2], Tn = l[ae + 152 >> 2], bo = l[ae + 248 >> 2], kn = l[ae + 108 >> 2], xr = l[ae + 204 >> 2], Pt = l[ae + 156 >> 2], Oo = l[ae + 252 >> 2], Dt = l[ae + 112 >> 2], Yn = l[ae + 208 >> 2], un = l[ae + 160 >> 2], ir = l[ae + 256 >> 2], rt = l[ae + 116 >> 2], Bt = l[ae + 212 >> 2], Ye = l[ae + 164 >> 2], Jt = l[ae + 260 >> 2], Ne = l[ae + 120 >> 2], mn = l[ae + 216 >> 2], We = l[ae + 168 >> 2], Hr = l[ae + 264 >> 2], Te = l[ae + 124 >> 2], Vr = l[ae + 220 >> 2], q = l[ae + 172 >> 2], ro = l[ae + 268 >> 2], Ue = l[ae + 128 >> 2], io = l[ae + 224 >> 2], Ie = l[ae + 176 >> 2], fo = l[ae + 272 >> 2], po = le, gn = (Mt = (Z = 0 - ((Z = kr) ^ (kr = B[ae + 336 + (le >>> 3) | 0] >>> (7 & le) & 1)) | 0) & ((de = l[ae + 132 >> 2]) ^ (zn = l[ae + 228 >> 2]))) ^ de, l[ae + 132 >> 2] = gn, jn = Qe ^ (_t = Z & (Qe ^ Qr)), l[ae + 84 >> 2] = jn - gn, An = Ue ^ (qt = Z & (Ue ^ io)), l[ae + 128 >> 2] = An, _r = (Vt = Z & (Ie ^ fo)) ^ Ie, l[ae + 80 >> 2] = _r - An, De = Te ^ (tt = Z & (Te ^ Vr)), l[ae + 124 >> 2] = De, mo = q ^ (xt = Z & (q ^ ro)), l[ae + 76 >> 2] = mo - De, Vn = Ne ^ (ot = Z & (Ne ^ mn)), l[ae + 120 >> 2] = Vn, ho = We ^ (be = Z & (We ^ Hr)), l[ae + 72 >> 2] = ho - Vn, Xn = rt ^ (Qe = Z & (rt ^ Bt)), l[ae + 116 >> 2] = Xn, tn = Ye ^ (rt = Z & (Ye ^ Jt)), l[ae + 68 >> 2] = tn - Xn, nr = Dt ^ (Ne = Z & (Dt ^ Yn)), l[ae + 112 >> 2] = nr, Dn = un ^ (We = Z & (un ^ ir)), l[ae + 64 >> 2] = Dn - nr, nn = kn ^ (Te = Z & (kn ^ xr)), l[ae + 108 >> 2] = nn, br = Pt ^ (q = Z & (Pt ^ Oo)), l[ae + 60 >> 2] = br - nn, vn = Bn ^ (Ue = Z & (Bn ^ Ao)), l[ae + 104 >> 2] = vn, kn = Tn ^ (Ie = Z & (Tn ^ bo)), l[ae + 56 >> 2] = kn - vn, Bn = oo ^ (de = Z & (oo ^ uo)), l[ae + 100 >> 2] = Bn, Pt = _o ^ (le = Z & (_o ^ So)), l[ae + 52 >> 2] = Pt - Bn, Tn = Ur ^ (Dt = Z & (Ur ^ Lr)), l[ae + 96 >> 2] = Tn, un = (Z &= Jr ^ jr) ^ Jr, l[ae + 48 >> 2] = un - Tn, Ye = _t ^ Qr, Mt ^= zn, l[ae + 36 >> 2] = Ye - Mt, _t = Vt ^ fo, qt ^= io, l[ae + 32 >> 2] = _t - qt, Vt = xt ^ ro, tt ^= Vr, l[ae + 28 >> 2] = Vt - tt, xt = be ^ Hr, ot ^= mn, l[ae + 24 >> 2] = xt - ot, be = rt ^ Jt, Qe ^= Bt, l[ae + 20 >> 2] = be - Qe, rt = We ^ ir, Ne ^= Yn, l[ae + 16 >> 2] = rt - Ne, We = q ^ Oo, Te ^= xr, l[ae + 12 >> 2] = We - Te, q = Ie ^ bo, Ue ^= Ao, l[ae + 8 >> 2] = q - Ue, Ie = le ^ So, de ^= uo, l[ae + 4 >> 2] = Ie - de, le = Z ^ jr, Z = Dt ^ Lr, l[ae >> 2] = le - Z, l[ae + 276 >> 2] = Ye + Mt, l[ae + 272 >> 2] = _t + qt, l[ae + 268 >> 2] = tt + Vt, l[ae + 264 >> 2] = ot + xt, l[ae + 260 >> 2] = Qe + be, l[ae + 256 >> 2] = Ne + rt, l[ae + 248 >> 2] = q + Ue, l[ae + 244 >> 2] = de + Ie, l[ae + 240 >> 2] = Z + le, l[ae + 252 >> 2] = Te + We, l[ae + 228 >> 2] = gn + jn, l[ae + 224 >> 2] = An + _r, l[ae + 220 >> 2] = De + mo, l[ae + 216 >> 2] = Vn + ho, l[ae + 212 >> 2] = Xn + tn, l[ae + 208 >> 2] = Dn + nr, l[ae + 204 >> 2] = nn + br, l[ae + 200 >> 2] = kn + vn, l[ae + 196 >> 2] = Bn + Pt, l[ae + 192 >> 2] = un + Tn, rr(jn = ae + 96 | 0, An = ae + 48 | 0, un = ae + 240 | 0), rr(gn = ae + 192 | 0, gn, ae), Cn(An, ae), Cn(ae, un), Ye = l[ae + 192 >> 2], Mt = l[ae + 96 >> 2], _t = l[ae + 196 >> 2], qt = l[ae + 100 >> 2], Vt = l[ae + 200 >> 2], tt = l[ae + 104 >> 2], xt = l[ae + 204 >> 2], ot = l[ae + 108 >> 2], be = l[ae + 208 >> 2], Qe = l[ae + 112 >> 2], rt = l[ae + 212 >> 2], Ne = l[ae + 116 >> 2], We = l[ae + 216 >> 2], Te = l[ae + 120 >> 2], q = l[ae + 220 >> 2], Ue = l[ae + 124 >> 2], Ie = l[ae + 224 >> 2], de = l[ae + 128 >> 2], le = l[ae + 228 >> 2], Z = l[ae + 132 >> 2], l[ae + 180 >> 2] = le + Z, l[ae + 176 >> 2] = de + Ie, l[ae + 172 >> 2] = q + Ue, l[ae + 168 >> 2] = Te + We, l[ae + 164 >> 2] = Ne + rt, l[ae + 160 >> 2] = Qe + be, l[ae + 156 >> 2] = ot + xt, l[ae + 152 >> 2] = tt + Vt, l[ae + 148 >> 2] = _t + qt, l[ae + 144 >> 2] = Ye + Mt, l[ae + 228 >> 2] = Z - le, l[ae + 224 >> 2] = de - Ie, l[ae + 220 >> 2] = Ue - q, l[ae + 216 >> 2] = Te - We, l[ae + 212 >> 2] = Ne - rt, l[ae + 208 >> 2] = Qe - be, l[ae + 204 >> 2] = ot - xt, l[ae + 200 >> 2] = tt - Vt, l[ae + 196 >> 2] = qt - _t, l[ae + 192 >> 2] = Mt - Ye, rr(un, ae, An), De = l[ae + 52 >> 2], ot = l[ae + 4 >> 2], Vn = l[ae + 56 >> 2], be = l[ae + 8 >> 2], Xn = l[ae + 64 >> 2], Qe = l[ae + 16 >> 2], nr = l[ae + 60 >> 2], Te = l[ae + 12 >> 2], nn = l[ae + 72 >> 2], q = l[ae + 24 >> 2], vn = l[ae + 68 >> 2], Ue = l[ae + 20 >> 2], Bn = l[ae + 80 >> 2], de = l[ae + 32 >> 2], Tn = l[ae + 76 >> 2], le = l[ae + 28 >> 2], zn = l[ae + 84 >> 2], Z = l[ae + 36 >> 2], _r = l[ae + 48 >> 2], Ie = l[ae >> 2] - _r | 0, l[ae >> 2] = Ie, Z = Z - zn | 0, l[ae + 36 >> 2] = Z, Dt = le - Tn | 0, l[ae + 28 >> 2] = Dt, un = de - Bn | 0, l[ae + 32 >> 2] = un, rt = Ue - vn | 0, l[ae + 20 >> 2] = rt, Ne = q - nn | 0, l[ae + 24 >> 2] = Ne, We = Te - nr | 0, l[ae + 12 >> 2] = We, Te = Qe - Xn | 0, l[ae + 16 >> 2] = Te, q = be - Vn | 0, l[ae + 8 >> 2] = q, de = ot - De | 0, l[ae + 4 >> 2] = de, Cn(gn, gn), Z = dt(Z, Z >> 31, 121666, 0), le = Oe, br = Z, Z = dt((33554431 & (le = (Ye = Z + 16777216 | 0) >>> 0 < 16777216 ? le + 1 | 0 : le)) << 7 | Ye >>> 25, le >> 25, 19, 0), Ue = Oe, le = Z, Z = dt(Ie, Ie >> 31, 121666, 0), Dn = Oe + Ue | 0, Z = Z >>> 0 > (le = le + Z | 0) >>> 0 ? Dn + 1 | 0 : Dn, Z = (Ue = le + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z, Mt = le - (-67108864 & Ue) | 0, l[ae + 96 >> 2] = Mt, Ie = dt(de, de >> 31, 121666, 0), le = Oe, le = (de = Ie + 16777216 | 0) >>> 0 < 16777216 ? le + 1 | 0 : le, _t = (Z = (67108863 & Z) << 6 | Ue >>> 26) + (Ie - (-33554432 & de) | 0) | 0, l[ae + 100 >> 2] = _t, Dn = le >> 25, de = (33554431 & le) << 7 | de >>> 25, le = dt(q, q >> 31, 121666, 0) + de | 0, Z = Dn + Oe | 0, Z = le >>> 0 < de >>> 0 ? Z + 1 | 0 : Z, Ue = (qt = le + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z, Vt = le - (-67108864 & qt) | 0, l[ae + 104 >> 2] = Vt, de = dt(Te, Te >> 31, 121666, 0), Ie = Oe, le = dt(We, We >> 31, 121666, 0), Z = Oe, Pt = de, kn = le, de = (33554431 & (Z = (tt = le + 16777216 | 0) >>> 0 < 16777216 ? Z + 1 | 0 : Z)) << 7 | tt >>> 25, Z = (Z >> 25) + Ie | 0, Z = (le = Pt + de | 0) >>> 0 < de >>> 0 ? Z + 1 | 0 : Z, Ie = (xt = le + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z, ot = le - (-67108864 & xt) | 0, l[ae + 112 >> 2] = ot, de = dt(Ne, Ne >> 31, 121666, 0), q = Oe, le = dt(rt, rt >> 31, 121666, 0), Z = Oe, Pt = le, le = (33554431 & (Z = (be = le + 16777216 | 0) >>> 0 < 16777216 ? Z + 1 | 0 : Z)) << 7 | be >>> 25, Z = (Z >> 25) + q | 0, Z = le >>> 0 > (de = le + de | 0) >>> 0 ? Z + 1 | 0 : Z, le = (Qe = de + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z, rt = de - (-67108864 & Qe) | 0, l[ae + 120 >> 2] = rt, q = dt(un, un >> 31, 121666, 0), Te = Oe, de = dt(Dt, Dt >> 31, 121666, 0), Z = Oe, un = de, de = (33554431 & (Z = (Ne = de + 16777216 | 0) >>> 0 < 16777216 ? Z + 1 | 0 : Z)) << 7 | Ne >>> 25, Z = (Z >> 25) + Te | 0, Z = de >>> 0 > (q = de + q | 0) >>> 0 ? Z + 1 | 0 : Z, de = (We = q + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z, Te = q - (-67108864 & We) | 0, l[ae + 128 >> 2] = Te, q = (Ue = kn + ((67108863 & Ue) << 6 | qt >>> 26) | 0) - (-33554432 & tt) | 0, l[ae + 108 >> 2] = q, Ue = (Ie = Pt + ((67108863 & Ie) << 6 | xt >>> 26) | 0) - (-33554432 & be) | 0, l[ae + 116 >> 2] = Ue, Ie = (Z = un + ((67108863 & le) << 6 | Qe >>> 26) | 0) - (-33554432 & Ne) | 0, l[ae + 124 >> 2] = Ie, le = (de = br + ((67108863 & de) << 6 | We >>> 26) | 0) - (-33554432 & Ye) | 0, l[ae + 132 >> 2] = le, Cn(Z = ae + 144 | 0, Z), l[ae + 84 >> 2] = le + zn, l[ae + 80 >> 2] = Te + Bn, l[ae + 76 >> 2] = Ie + Tn, l[ae + 72 >> 2] = rt + nn, l[ae + 68 >> 2] = Ue + vn, l[ae + 64 >> 2] = ot + Xn, l[ae + 60 >> 2] = q + nr, l[ae + 56 >> 2] = Vt + Vn, l[ae + 52 >> 2] = _t + De, l[ae + 48 >> 2] = Mt + _r, le = po - 1 | 0, rr(jn, ae + 288 | 0, gn), rr(gn, ae, An), po; )
                          ;
                        rt = l[ae + 144 >> 2], Mt = l[ae + 240 >> 2], Ne = l[ae + 148 >> 2], _t = l[ae + 244 >> 2], We = l[ae + 152 >> 2], qt = l[ae + 248 >> 2], Te = l[ae + 156 >> 2], Vt = l[ae + 252 >> 2], q = l[ae + 160 >> 2], tt = l[ae + 256 >> 2], Ue = l[ae + 164 >> 2], xt = l[ae + 260 >> 2], Ie = l[ae + 168 >> 2], ot = l[ae + 264 >> 2], de = l[ae + 172 >> 2], be = l[ae + 268 >> 2], le = l[ae + 176 >> 2], Qe = l[ae + 272 >> 2], Ye = 0 - kr | 0, Z = l[ae + 276 >> 2], l[ae + 276 >> 2] = Ye & (Z ^ l[ae + 180 >> 2]) ^ Z, l[ae + 272 >> 2] = Qe ^ Ye & (le ^ Qe), l[ae + 268 >> 2] = be ^ Ye & (de ^ be), l[ae + 264 >> 2] = ot ^ Ye & (Ie ^ ot), l[ae + 260 >> 2] = xt ^ Ye & (Ue ^ xt), l[ae + 256 >> 2] = tt ^ Ye & (q ^ tt), l[ae + 252 >> 2] = Vt ^ Ye & (Te ^ Vt), l[ae + 248 >> 2] = qt ^ Ye & (We ^ qt), l[ae + 244 >> 2] = _t ^ Ye & (Ne ^ _t), l[ae + 240 >> 2] = Mt ^ Ye & (rt ^ Mt), Mt = l[ae + 192 >> 2], rt = l[ae + 96 >> 2], _t = l[ae + 196 >> 2], Ne = l[ae + 100 >> 2], qt = l[ae + 200 >> 2], We = l[ae + 104 >> 2], Vt = l[ae + 204 >> 2], Te = l[ae + 108 >> 2], tt = l[ae + 208 >> 2], q = l[ae + 112 >> 2], xt = l[ae + 212 >> 2], Ue = l[ae + 116 >> 2], ot = l[ae + 216 >> 2], Ie = l[ae + 120 >> 2], be = l[ae + 220 >> 2], de = l[ae + 124 >> 2], Qe = l[ae + 224 >> 2], le = l[ae + 128 >> 2], Z = l[ae + 228 >> 2], l[ae + 228 >> 2] = Ye & (Z ^ l[ae + 132 >> 2]) ^ Z, l[ae + 224 >> 2] = Qe ^ Ye & (le ^ Qe), l[ae + 220 >> 2] = be ^ Ye & (de ^ be), l[ae + 216 >> 2] = ot ^ Ye & (Ie ^ ot), l[ae + 212 >> 2] = xt ^ Ye & (Ue ^ xt), l[ae + 208 >> 2] = tt ^ Ye & (q ^ tt), l[ae + 204 >> 2] = Vt ^ Ye & (Te ^ Vt), l[ae + 200 >> 2] = qt ^ Ye & (We ^ qt), l[ae + 196 >> 2] = _t ^ Ye & (Ne ^ _t), l[ae + 192 >> 2] = Mt ^ Ye & (rt ^ Mt), wi(le = ae + 192 | 0, le), rr(Z = ae + 240 | 0, Z, le), ms(L, Z), Ro(ae + 336 | 0, 32), de = 0;
                      }
                      return st = ae + 368 | 0, 0 | de;
                    }, function(L, Z) {
                      var le, ae, de, Ie, Qe, q, be, Ue, Ye, Te, Ne, We, rt, ot, _t, qt, tt, xt, Mt, Vt;
                      return Z |= 0, st = le = st - 304 | 0, j[0 | (L |= 0)] = B[0 | Z], j[L + 1 | 0] = B[Z + 1 | 0], j[L + 2 | 0] = B[Z + 2 | 0], j[L + 3 | 0] = B[Z + 3 | 0], j[L + 4 | 0] = B[Z + 4 | 0], j[L + 5 | 0] = B[Z + 5 | 0], j[L + 6 | 0] = B[Z + 6 | 0], j[L + 7 | 0] = B[Z + 7 | 0], j[L + 8 | 0] = B[Z + 8 | 0], j[L + 9 | 0] = B[Z + 9 | 0], j[L + 10 | 0] = B[Z + 10 | 0], j[L + 11 | 0] = B[Z + 11 | 0], j[L + 12 | 0] = B[Z + 12 | 0], j[L + 13 | 0] = B[Z + 13 | 0], j[L + 14 | 0] = B[Z + 14 | 0], j[L + 15 | 0] = B[Z + 15 | 0], j[L + 16 | 0] = B[Z + 16 | 0], j[L + 17 | 0] = B[Z + 17 | 0], j[L + 18 | 0] = B[Z + 18 | 0], j[L + 19 | 0] = B[Z + 19 | 0], j[L + 20 | 0] = B[Z + 20 | 0], j[L + 21 | 0] = B[Z + 21 | 0], j[L + 22 | 0] = B[Z + 22 | 0], j[L + 23 | 0] = B[Z + 23 | 0], j[L + 24 | 0] = B[Z + 24 | 0], j[L + 25 | 0] = B[Z + 25 | 0], j[L + 26 | 0] = B[Z + 26 | 0], j[L + 27 | 0] = B[Z + 27 | 0], j[L + 28 | 0] = B[Z + 28 | 0], j[L + 29 | 0] = B[Z + 29 | 0], j[L + 30 | 0] = B[Z + 30 | 0], Z = B[Z + 31 | 0], j[0 | L] = 248 & B[0 | L], j[L + 31 | 0] = 63 & Z | 64, Ui(le + 48 | 0, L), Z = l[le + 132 >> 2], ae = l[le + 92 >> 2], de = l[le + 136 >> 2], Ie = l[le + 96 >> 2], Qe = l[le + 140 >> 2], q = l[le + 100 >> 2], be = l[le + 144 >> 2], Ue = l[le + 104 >> 2], Ye = l[le + 148 >> 2], Te = l[le + 108 >> 2], Ne = l[le + 152 >> 2], We = l[le + 112 >> 2], rt = l[le + 156 >> 2], ot = l[le + 116 >> 2], _t = l[le + 160 >> 2], qt = l[le + 120 >> 2], tt = l[le + 128 >> 2], xt = l[le + 88 >> 2], Mt = l[le + 124 >> 2], Vt = l[le + 164 >> 2], l[le + 292 >> 2] = Mt + Vt, l[le + 288 >> 2] = _t + qt, l[le + 284 >> 2] = rt + ot, l[le + 280 >> 2] = Ne + We, l[le + 276 >> 2] = Ye + Te, l[le + 272 >> 2] = be + Ue, l[le + 268 >> 2] = Qe + q, l[le + 264 >> 2] = de + Ie, l[le + 260 >> 2] = Z + ae, l[le + 256 >> 2] = tt + xt, l[le + 244 >> 2] = Vt - Mt, l[le + 240 >> 2] = _t - qt, l[le + 236 >> 2] = rt - ot, l[le + 232 >> 2] = Ne - We, l[le + 228 >> 2] = Ye - Te, l[le + 224 >> 2] = be - Ue, l[le + 220 >> 2] = Qe - q, l[le + 216 >> 2] = de - Ie, l[le + 212 >> 2] = Z - ae, l[le + 208 >> 2] = tt - xt, wi(Z = le + 208 | 0, Z), rr(le, le + 256 | 0, Z), ms(L, le), st = le + 304 | 0, 0;
                    }, function(L, Z, le, ae, de) {
                      L |= 0, ae |= 0, de |= 0;
                      var Ie, Qe = 0, q = 0, be = 0, Ue = 0;
                      if (st = Ie = st - 112 | 0, (Z |= 0) | (le |= 0)) {
                        Qe = B[de + 28 | 0] | B[de + 29 | 0] << 8 | B[de + 30 | 0] << 16 | B[de + 31 | 0] << 24, l[Ie + 24 >> 2] = B[de + 24 | 0] | B[de + 25 | 0] << 8 | B[de + 26 | 0] << 16 | B[de + 27 | 0] << 24, l[Ie + 28 >> 2] = Qe, Qe = B[de + 20 | 0] | B[de + 21 | 0] << 8 | B[de + 22 | 0] << 16 | B[de + 23 | 0] << 24, l[Ie + 16 >> 2] = B[de + 16 | 0] | B[de + 17 | 0] << 8 | B[de + 18 | 0] << 16 | B[de + 19 | 0] << 24, l[Ie + 20 >> 2] = Qe, Qe = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, l[Ie >> 2] = B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, l[Ie + 4 >> 2] = Qe, Qe = B[de + 12 | 0] | B[de + 13 | 0] << 8 | B[de + 14 | 0] << 16 | B[de + 15 | 0] << 24, l[Ie + 8 >> 2] = B[de + 8 | 0] | B[de + 9 | 0] << 8 | B[de + 10 | 0] << 16 | B[de + 11 | 0] << 24, l[Ie + 12 >> 2] = Qe, de = B[0 | ae] | B[ae + 1 | 0] << 8 | B[ae + 2 | 0] << 16 | B[ae + 3 | 0] << 24, ae = B[ae + 4 | 0] | B[ae + 5 | 0] << 8 | B[ae + 6 | 0] << 16 | B[ae + 7 | 0] << 24, l[Ie + 104 >> 2] = 0, l[Ie + 108 >> 2] = 0, l[Ie + 96 >> 2] = de, l[Ie + 100 >> 2] = ae;
                        e: {
                          if (!le & Z >>> 0 >= 64 | le) {
                            for (; In(L, Ie + 96 | 0, Ie), ae = B[Ie + 104 | 0] + 1 | 0, j[Ie + 104 | 0] = ae, ae = B[Ie + 105 | 0] + (ae >>> 8 | 0) | 0, j[Ie + 105 | 0] = ae, ae = B[Ie + 106 | 0] + (ae >>> 8 | 0) | 0, j[Ie + 106 | 0] = ae, ae = B[Ie + 107 | 0] + (ae >>> 8 | 0) | 0, j[Ie + 107 | 0] = ae, ae = B[Ie + 108 | 0] + (ae >>> 8 | 0) | 0, j[Ie + 108 | 0] = ae, ae = B[Ie + 109 | 0] + (ae >>> 8 | 0) | 0, j[Ie + 109 | 0] = ae, ae = B[Ie + 110 | 0] + (ae >>> 8 | 0) | 0, j[Ie + 110 | 0] = ae, j[Ie + 111 | 0] = B[Ie + 111 | 0] + (ae >>> 8 | 0), L = L - -64 | 0, le = le - 1 | 0, !(le = (Z = Z + -64 | 0) >>> 0 < 4294967232 ? le + 1 | 0 : le) & Z >>> 0 > 63 | le; )
                              ;
                            if (!(Z | le))
                              break e;
                          }
                          if (ae = 0, In(Ie + 32 | 0, Ie + 96 | 0, Ie), le = 3 & Z, de = 0, Z - 1 >>> 0 >= 3)
                            for (Qe = -4 & Z, Z = 0; q = be = Ie + 32 | 0, j[L + de | 0] = B[q + de | 0], j[(Ue = 1 | de) + L | 0] = B[q + Ue | 0], j[(q = 2 | de) + L | 0] = B[q + be | 0], j[(q = 3 | de) + L | 0] = B[q + (Ie + 32 | 0) | 0], de = de + 4 | 0, (0 | Qe) != (0 | (Z = Z + 4 | 0)); )
                              ;
                          if (le)
                            for (; j[L + de | 0] = B[(Ie + 32 | 0) + de | 0], de = de + 1 | 0, (0 | le) != (0 | (ae = ae + 1 | 0)); )
                              ;
                        }
                        Ro(Ie + 32 | 0, 64), Ro(Ie, 32);
                      }
                      return st = Ie + 112 | 0, 0;
                    }, function(L, Z, le, ae, de, Ie, Qe, q) {
                      L |= 0, Z |= 0, de |= 0, Ie |= 0, Qe |= 0, q |= 0;
                      var be, Ue = 0;
                      if (st = be = st - 112 | 0, (le |= 0) | (ae |= 0)) {
                        Ue = B[q + 28 | 0] | B[q + 29 | 0] << 8 | B[q + 30 | 0] << 16 | B[q + 31 | 0] << 24, l[be + 24 >> 2] = B[q + 24 | 0] | B[q + 25 | 0] << 8 | B[q + 26 | 0] << 16 | B[q + 27 | 0] << 24, l[be + 28 >> 2] = Ue, Ue = B[q + 20 | 0] | B[q + 21 | 0] << 8 | B[q + 22 | 0] << 16 | B[q + 23 | 0] << 24, l[be + 16 >> 2] = B[q + 16 | 0] | B[q + 17 | 0] << 8 | B[q + 18 | 0] << 16 | B[q + 19 | 0] << 24, l[be + 20 >> 2] = Ue, Ue = B[q + 4 | 0] | B[q + 5 | 0] << 8 | B[q + 6 | 0] << 16 | B[q + 7 | 0] << 24, l[be >> 2] = B[0 | q] | B[q + 1 | 0] << 8 | B[q + 2 | 0] << 16 | B[q + 3 | 0] << 24, l[be + 4 >> 2] = Ue, Ue = B[q + 12 | 0] | B[q + 13 | 0] << 8 | B[q + 14 | 0] << 16 | B[q + 15 | 0] << 24, l[be + 8 >> 2] = B[q + 8 | 0] | B[q + 9 | 0] << 8 | B[q + 10 | 0] << 16 | B[q + 11 | 0] << 24, l[be + 12 >> 2] = Ue, q = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, l[be + 96 >> 2] = B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, l[be + 100 >> 2] = q, j[be + 104 | 0] = Ie, j[be + 111 | 0] = Qe >>> 24, j[be + 110 | 0] = Qe >>> 16, j[be + 109 | 0] = Qe >>> 8, j[be + 108 | 0] = Qe, j[be + 107 | 0] = (16777215 & Qe) << 8 | Ie >>> 24, j[be + 106 | 0] = (65535 & Qe) << 16 | Ie >>> 16, j[be + 105 | 0] = (255 & Qe) << 24 | Ie >>> 8;
                        e: {
                          if (!ae & le >>> 0 >= 64 | ae) {
                            for (; ; ) {
                              for (q = 0, In(be + 32 | 0, be + 96 | 0, be); Ie = be + 32 | 0, j[L + q | 0] = B[Ie + q | 0] ^ B[Z + q | 0], j[(de = 1 | q) + L | 0] = B[de + Ie | 0] ^ B[Z + de | 0], (0 | (q = q + 2 | 0)) != 64; )
                                ;
                              if (de = B[be + 104 | 0] + 1 | 0, j[be + 104 | 0] = de, de = B[be + 105 | 0] + (de >>> 8 | 0) | 0, j[be + 105 | 0] = de, de = B[be + 106 | 0] + (de >>> 8 | 0) | 0, j[be + 106 | 0] = de, de = B[be + 107 | 0] + (de >>> 8 | 0) | 0, j[be + 107 | 0] = de, de = B[be + 108 | 0] + (de >>> 8 | 0) | 0, j[be + 108 | 0] = de, de = B[be + 109 | 0] + (de >>> 8 | 0) | 0, j[be + 109 | 0] = de, de = B[be + 110 | 0] + (de >>> 8 | 0) | 0, j[be + 110 | 0] = de, j[be + 111 | 0] = B[be + 111 | 0] + (de >>> 8 | 0), Z = Z - -64 | 0, L = L - -64 | 0, ae = ae - 1 | 0, !(!(ae = (le = le + -64 | 0) >>> 0 < 4294967232 ? ae + 1 | 0 : ae) & le >>> 0 > 63 | ae))
                                break;
                            }
                            if (!(le | ae))
                              break e;
                          }
                          if (q = 0, In(be + 32 | 0, be + 96 | 0, be), ae = 1 & le, (0 | le) != 1)
                            for (Ie = -2 & le, de = 0; Qe = be + 32 | 0, j[L + q | 0] = B[Qe + q | 0] ^ B[Z + q | 0], j[(le = 1 | q) + L | 0] = B[le + Qe | 0] ^ B[Z + le | 0], q = q + 2 | 0, (0 | Ie) != (0 | (de = de + 2 | 0)); )
                              ;
                          ae && (j[L + q | 0] = B[(be + 32 | 0) + q | 0] ^ B[Z + q | 0]);
                        }
                        Ro(be + 32 | 0, 64), Ro(be, 32);
                      }
                      return st = be + 112 | 0, 0;
                    }], xa.grow = function(L) {
                      var Z = this.length;
                      return this.length = this.length + L, Z;
                    }, xa.set = function(L, Z) {
                      this[L] = Z;
                    }, xa.get = function(L) {
                      return this[L];
                    }, xa);
                    function Xa() {
                      return ki.byteLength / 65536 | 0;
                    }
                    return { f: function() {
                    }, g: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye, Te) {
                      return 0 | Ea(L |= 0, Z |= 0, le |= 0, ae |= 0, (L = 0) | (de |= 0), Ie |= 0, Qe |= 0, L | (q |= 0), be |= 0, Ye |= 0, Te |= 0);
                    }, h: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return L |= 0, Z |= 0, be |= 0, be = ae |= 0, !(ae = de |= 0) & (de = 0 | be) >>> 0 < 4294967280 ? (Ea(L, L + de | 0, 0, le |= 0, de, ae, Ie |= 0, Qe |= 0, q |= 0, Ue |= 0, Ye |= 0), Z && (ae = (L = de + 16 | 0) >>> 0 < 16 ? ae + 1 | 0 : ae, l[Z >> 2] = L, l[Z + 4 >> 2] = ae)) : (Ko(), Xr()), 0;
                    }, i: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye, Te) {
                      return 0 | Di(L |= 0, Z |= 0, le |= 0, ae |= 0, (L = 0) | (de |= 0), Ie |= 0, Qe |= 0, L | (q |= 0), be |= 0, Ye |= 0, Te |= 0);
                    }, j: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return L |= 0, Z |= 0, be |= 0, be = ae |= 0, !(ae = de |= 0) & (de = 0 | be) >>> 0 < 4294967280 ? (Di(L, L + de | 0, 0, le |= 0, de, ae, Ie |= 0, Qe |= 0, q |= 0, Ue |= 0, Ye |= 0), Z && (ae = (L = de + 16 | 0) >>> 0 < 16 ? ae + 1 | 0 : ae, l[Z >> 2] = L, l[Z + 4 >> 2] = ae)) : (Ko(), Xr()), 0;
                    }, k: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return 0 | Pa(L |= 0, le |= 0, (L = 0) | (ae |= 0), de |= 0, Ie |= 0, Qe |= 0, L | (q |= 0), be |= 0, Ue |= 0, Ye |= 0);
                    }, l: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return Z |= 0, le |= 0, ae |= 0, de |= 0, q |= 0, q |= 0, le = -1, !(Ie |= 0) & (de |= 0) >>> 0 >= 16 | Ie && (le = Pa(L |= 0, ae, de - 16 | 0, Ie - (de >>> 0 < 16) | 0, (ae + de | 0) - 16 | 0, Qe |= 0, q, be |= 0, Ue |= 0, Ye |= 0)), Z && (l[Z >> 2] = le ? 0 : de - 16 | 0, l[Z + 4 >> 2] = le ? 0 : Ie - (de >>> 0 < 16) | 0), 0 | le;
                    }, m: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return 0 | bs(L |= 0, le |= 0, (L = 0) | (ae |= 0), de |= 0, Ie |= 0, Qe |= 0, L | (q |= 0), be |= 0, Ue |= 0, Ye |= 0);
                    }, n: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return Z |= 0, le |= 0, ae |= 0, de |= 0, q |= 0, q |= 0, le = -1, !(Ie |= 0) & (de |= 0) >>> 0 >= 16 | Ie && (le = bs(L |= 0, ae, de - 16 | 0, Ie - (de >>> 0 < 16) | 0, (ae + de | 0) - 16 | 0, Qe |= 0, q, be |= 0, Ue |= 0, Ye |= 0)), Z && (l[Z >> 2] = le ? 0 : de - 16 | 0, l[Z + 4 >> 2] = le ? 0 : Ie - (de >>> 0 < 16) | 0), 0 | le;
                    }, o: $i, p: function() {
                      return 12;
                    }, q: Na, r: ra, s: Qa, t: na, u: $i, v: za, w: Na, x: ra, y: Qa, z: na, A: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye, Te) {
                      return 0 | Ji(L |= 0, Z |= 0, le |= 0, ae |= 0, (L = 0) | (de |= 0), Ie |= 0, Qe |= 0, L | (q |= 0), be |= 0, Ye |= 0, Te |= 0);
                    }, B: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return L |= 0, Z |= 0, be |= 0, be = ae |= 0, !(ae = de |= 0) & (de = 0 | be) >>> 0 < 4294967280 ? (Ji(L, L + de | 0, 0, le |= 0, de, ae, Ie |= 0, Qe |= 0, q |= 0, Ue |= 0, Ye |= 0), Z && (ae = (L = de + 16 | 0) >>> 0 < 16 ? ae + 1 | 0 : ae, l[Z >> 2] = L, l[Z + 4 >> 2] = ae)) : (Ko(), Xr()), 0;
                    }, C: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return 0 | ea(L |= 0, le |= 0, (L = 0) | (ae |= 0), de |= 0, Ie |= 0, Qe |= 0, L | (q |= 0), be |= 0, Ue |= 0, Ye |= 0);
                    }, D: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue, Ye) {
                      return Z |= 0, le |= 0, ae |= 0, de |= 0, q |= 0, q |= 0, le = -1, !(Ie |= 0) & (de |= 0) >>> 0 >= 16 | Ie && (le = ea(L |= 0, ae, de - 16 | 0, Ie - (de >>> 0 < 16) | 0, (ae + de | 0) - 16 | 0, Qe |= 0, q, be |= 0, Ue |= 0, Ye |= 0)), Z && (l[Z >> 2] = le ? 0 : de - 16 | 0, l[Z + 4 >> 2] = le ? 0 : Ie - (de >>> 0 < 16) | 0), 0 | le;
                    }, E: $i, F: va, G: Na, H: ra, I: Qa, J: na, K: $i, L: $i, M: function(L, Z, le, ae, de) {
                      var Ie;
                      return L |= 0, Z |= 0, le |= 0, ae |= 0, st = Ie = st - 480 | 0, Ba(Ie, de |= 0), ja(Ie, Z, le, ae), Mn(Ie, Ie + 416 | 0), Z = l[Ie + 444 >> 2], le = l[Ie + 440 >> 2], j[L + 24 | 0] = le, j[L + 25 | 0] = le >>> 8, j[L + 26 | 0] = le >>> 16, j[L + 27 | 0] = le >>> 24, j[L + 28 | 0] = Z, j[L + 29 | 0] = Z >>> 8, j[L + 30 | 0] = Z >>> 16, j[L + 31 | 0] = Z >>> 24, Z = l[Ie + 436 >> 2], le = l[Ie + 432 >> 2], j[L + 16 | 0] = le, j[L + 17 | 0] = le >>> 8, j[L + 18 | 0] = le >>> 16, j[L + 19 | 0] = le >>> 24, j[L + 20 | 0] = Z, j[L + 21 | 0] = Z >>> 8, j[L + 22 | 0] = Z >>> 16, j[L + 23 | 0] = Z >>> 24, Z = l[Ie + 428 >> 2], le = l[Ie + 424 >> 2], j[L + 8 | 0] = le, j[L + 9 | 0] = le >>> 8, j[L + 10 | 0] = le >>> 16, j[L + 11 | 0] = le >>> 24, j[L + 12 | 0] = Z, j[L + 13 | 0] = Z >>> 8, j[L + 14 | 0] = Z >>> 16, j[L + 15 | 0] = Z >>> 24, Z = l[Ie + 420 >> 2], le = l[Ie + 416 >> 2], j[0 | L] = le, j[L + 1 | 0] = le >>> 8, j[L + 2 | 0] = le >>> 16, j[L + 3 | 0] = le >>> 24, j[L + 4 | 0] = Z, j[L + 5 | 0] = Z >>> 8, j[L + 6 | 0] = Z >>> 16, j[L + 7 | 0] = Z >>> 24, st = Ie + 480 | 0, 0;
                    }, N: function(L, Z, le, ae, de) {
                      var Ie, Qe;
                      return L |= 0, Z |= 0, le |= 0, ae |= 0, st = Ie = st - 512 | 0, Ba(Qe = Ie + 32 | 0, de |= 0), ja(Qe, Z, le, ae), Mn(Qe, Ie + 448 | 0), Z = l[Ie + 476 >> 2], l[Ie + 24 >> 2] = l[Ie + 472 >> 2], l[Ie + 28 >> 2] = Z, Z = l[Ie + 468 >> 2], l[Ie + 16 >> 2] = l[Ie + 464 >> 2], l[Ie + 20 >> 2] = Z, Z = l[Ie + 460 >> 2], l[Ie + 8 >> 2] = l[Ie + 456 >> 2], l[Ie + 12 >> 2] = Z, Z = l[Ie + 452 >> 2], l[Ie >> 2] = l[Ie + 448 >> 2], l[Ie + 4 >> 2] = Z, Z = Cs(L, Ie), le = gs(Ie, L, 32), st = Ie + 512 | 0, le | ((0 | L) == (0 | Ie) ? -1 : Z);
                    }, O: na, P: $i, Q: $i, R: $i, S: $i, T: va, U: ra, V: Qa, W: function(L, Z, le) {
                      L |= 0, Z |= 0;
                      var ae, de = 0;
                      return st = ae = st + -64 | 0, Si(ae, le |= 0, 32, 0), le = l[ae + 28 >> 2], de = l[ae + 24 >> 2], j[Z + 24 | 0] = de, j[Z + 25 | 0] = de >>> 8, j[Z + 26 | 0] = de >>> 16, j[Z + 27 | 0] = de >>> 24, j[Z + 28 | 0] = le, j[Z + 29 | 0] = le >>> 8, j[Z + 30 | 0] = le >>> 16, j[Z + 31 | 0] = le >>> 24, le = l[ae + 20 >> 2], de = l[ae + 16 >> 2], j[Z + 16 | 0] = de, j[Z + 17 | 0] = de >>> 8, j[Z + 18 | 0] = de >>> 16, j[Z + 19 | 0] = de >>> 24, j[Z + 20 | 0] = le, j[Z + 21 | 0] = le >>> 8, j[Z + 22 | 0] = le >>> 16, j[Z + 23 | 0] = le >>> 24, le = l[ae + 12 >> 2], de = l[ae + 8 >> 2], j[Z + 8 | 0] = de, j[Z + 9 | 0] = de >>> 8, j[Z + 10 | 0] = de >>> 16, j[Z + 11 | 0] = de >>> 24, j[Z + 12 | 0] = le, j[Z + 13 | 0] = le >>> 8, j[Z + 14 | 0] = le >>> 16, j[Z + 15 | 0] = le >>> 24, le = l[ae + 4 >> 2], de = l[ae >> 2], j[0 | Z] = de, j[Z + 1 | 0] = de >>> 8, j[Z + 2 | 0] = de >>> 16, j[Z + 3 | 0] = de >>> 24, j[Z + 4 | 0] = le, j[Z + 5 | 0] = le >>> 8, j[Z + 6 | 0] = le >>> 16, j[Z + 7 | 0] = le >>> 24, Ro(ae, 64), L = Wa(L, Z), st = ae - -64 | 0, 0 | L;
                    }, X: hs, Y: Xe, Z: Un, _: function(L, Z, le, ae, de, Ie, Qe, q) {
                      var be, Ue;
                      return L |= 0, Z |= 0, le |= 0, Ie |= 0, Ue = ae |= 0, ae = de |= 0, st = be = st - 32 | 0, de = -1, Xe(be, Qe |= 0, q |= 0) || (de = Ms(L, Z, le, Ue, ae, Ie, be), Ro(be, 32)), st = be + 32 | 0, 0 | de;
                    }, $: function(L, Z, le, ae, de, Ie) {
                      return L |= 0, Z |= 0, de |= 0, Ie |= 0, !(ae |= 0) & (le |= 0) >>> 0 >= 4294967280 | ae && (Ko(), Xr()), 0 | Ms(L + 16 | 0, L, Z, le, ae, de, Ie);
                    }, aa: function(L, Z, le, ae, de, Ie, Qe) {
                      return 0 | Fe(L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, Ie |= 0, Qe |= 0);
                    }, ba: Jn, ca: function(L, Z, le, ae, de, Ie, Qe, q) {
                      var be, Ue;
                      return L |= 0, Z |= 0, le |= 0, Ie |= 0, Ue = ae |= 0, ae = de |= 0, st = be = st - 32 | 0, de = -1, Xe(be, Qe |= 0, q |= 0) || (de = Xs(L, Z, le, Ue, ae, Ie, be), Ro(be, 32)), st = be + 32 | 0, 0 | de;
                    }, da: qe, ea: function(L, Z, le, ae, de, Ie, Qe) {
                      return 0 | Ee(L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, Ie |= 0, Qe |= 0);
                    }, fa: function(L, Z, le, ae, de) {
                      L |= 0, Z |= 0, de |= 0;
                      var Ie, Qe, q, be = 0, Ue = 0;
                      return Qe = le |= 0, le = ae |= 0, q = ae = st, st = Ie = ae - 512 & -64, ae = -1, hs(Ie - -64 | 0, Ie + 32 | 0) || (Zs(ae = Ie + 128 | 0, 0, 0, 24), as(ae, Ue = Ie - -64 | 0, 32, 0), as(ae, de, 32, 0), Yt(ae, be = Ie + 96 | 0, 24), ae = Fe(L + 32 | 0, Z, Qe, le, be, ae = de, de = Ie + 32 | 0), Z = l[Ie + 92 >> 2], le = l[Ie + 88 >> 2], j[L + 24 | 0] = le, j[L + 25 | 0] = le >>> 8, j[L + 26 | 0] = le >>> 16, j[L + 27 | 0] = le >>> 24, j[L + 28 | 0] = Z, j[L + 29 | 0] = Z >>> 8, j[L + 30 | 0] = Z >>> 16, j[L + 31 | 0] = Z >>> 24, Z = l[Ie + 84 >> 2], le = l[Ie + 80 >> 2], j[L + 16 | 0] = le, j[L + 17 | 0] = le >>> 8, j[L + 18 | 0] = le >>> 16, j[L + 19 | 0] = le >>> 24, j[L + 20 | 0] = Z, j[L + 21 | 0] = Z >>> 8, j[L + 22 | 0] = Z >>> 16, j[L + 23 | 0] = Z >>> 24, Z = l[Ie + 76 >> 2], le = l[Ie + 72 >> 2], j[L + 8 | 0] = le, j[L + 9 | 0] = le >>> 8, j[L + 10 | 0] = le >>> 16, j[L + 11 | 0] = le >>> 24, j[L + 12 | 0] = Z, j[L + 13 | 0] = Z >>> 8, j[L + 14 | 0] = Z >>> 16, j[L + 15 | 0] = Z >>> 24, Z = l[Ie + 68 >> 2], le = l[Ie + 64 >> 2], j[0 | L] = le, j[L + 1 | 0] = le >>> 8, j[L + 2 | 0] = le >>> 16, j[L + 3 | 0] = le >>> 24, j[L + 4 | 0] = Z, j[L + 5 | 0] = Z >>> 8, j[L + 6 | 0] = Z >>> 16, j[L + 7 | 0] = Z >>> 24, Ro(de, 32), Ro(Ue, 32), Ro(be, 24)), st = q, 0 | ae;
                    }, ga: function(L, Z, le, ae, de, Ie) {
                      L |= 0, Z |= 0, de |= 0, Ie |= 0;
                      var Qe, q, be = 0, Ue = 0;
                      return Qe = be = st, st = be = be - 448 & -64, Ue = -1, q = ae |= 0, !ae & (le |= 0) >>> 0 >= 48 | ae && (Zs(ae = be - -64 | 0, 0, 0, 24), as(ae, Z, 32, 0), as(ae, de, 32, 0), Yt(de = ae, ae = be + 32 | 0, 24), Ue = Ee(L, Z + 32 | 0, le - 32 | 0, q - (le >>> 0 < 32) | 0, ae, Z, Ie)), st = Qe, 0 | Ue;
                    }, ha: function() {
                      return 48;
                    }, ia: ra, ja: Ra, ka: $i, la: ra, ma: Ra, na: $i, oa: function() {
                      return 384;
                    }, pa: function(L, Z, le, ae, de, Ie, Qe) {
                      return 0 | ga(L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, Ie |= 0, Qe |= 0);
                    }, qa: Zs, ra: function(L, Z, le, ae) {
                      return 0 | as(L |= 0, Z |= 0, le |= 0, ae |= 0);
                    }, sa: Yt, ta: na, ua: Ra, va: function(L, Z, le, ae) {
                      return 0 | Si(L |= 0, Z |= 0, le |= 0, ae |= 0);
                    }, wa: ra, xa: Ra, ya: za, za: $i, Aa: function(L, Z, le, ae, de, Ie) {
                      L |= 0, Z |= 0, le |= 0, ae |= 0, Ie |= 0;
                      var Qe, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0;
                      return st = Qe = st - 32 | 0, q = B[0 | (de |= 0)] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, de = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, l[Qe + 24 >> 2] = 0, l[Qe + 28 >> 2] = 0, l[Qe + 16 >> 2] = q, l[Qe + 20 >> 2] = de, l[Qe + 8 >> 2] = 0, l[Qe + 12 >> 2] = 0, l[(de = Qe) >> 2] = le, l[de + 4 >> 2] = ae, Z - 65 >>> 0 <= 4294967246 ? (l[8916] = 28, L = -1) : Z - 65 >>> 0 < 4294967232 ? L = -1 : (st = de = (Ue = st) - 512 & -64, !Ie | !L | ((be = 255 & Z) - 65 & 255) >>> 0 <= 191 ? (Ko(), Xr()) : (ae = Qe + 16 | 0, Qe ? (Ye = 725511199 ^ (B[Qe + 8 | 0] | B[Qe + 9 | 0] << 8 | B[Qe + 10 | 0] << 16 | B[Qe + 11 | 0] << 24), Te = -1694144372 ^ (B[Qe + 12 | 0] | B[Qe + 13 | 0] << 8 | B[Qe + 14 | 0] << 16 | B[Qe + 15 | 0] << 24), le = -1377402159 ^ (B[0 | Qe] | B[Qe + 1 | 0] << 8 | B[Qe + 2 | 0] << 16 | B[Qe + 3 | 0] << 24), Z = 1359893119 ^ (B[Qe + 4 | 0] | B[Qe + 5 | 0] << 8 | B[Qe + 6 | 0] << 16 | B[Qe + 7 | 0] << 24)) : (Ye = 725511199, Te = -1694144372, le = -1377402159, Z = 1359893119), ae ? (Ne = 327033209 ^ (B[ae + 8 | 0] | B[ae + 9 | 0] << 8 | B[ae + 10 | 0] << 16 | B[ae + 11 | 0] << 24), We = 1541459225 ^ (B[ae + 12 | 0] | B[ae + 13 | 0] << 8 | B[ae + 14 | 0] << 16 | B[ae + 15 | 0] << 24), q = -79577749 ^ (B[0 | ae] | B[ae + 1 | 0] << 8 | B[ae + 2 | 0] << 16 | B[ae + 3 | 0] << 24), ae = 528734635 ^ (B[ae + 4 | 0] | B[ae + 5 | 0] << 8 | B[ae + 6 | 0] << 16 | B[ae + 7 | 0] << 24)) : (Ne = 327033209, We = 1541459225, q = -79577749, ae = 528734635), Rt(de - -64 | 0, 0, 293), l[de + 56 >> 2] = Ne, l[de + 60 >> 2] = We, l[de + 48 >> 2] = q, l[de + 52 >> 2] = ae, l[de + 40 >> 2] = Ye, l[de + 44 >> 2] = Te, l[de + 32 >> 2] = le, l[de + 36 >> 2] = Z, l[de + 24 >> 2] = 1595750129, l[de + 28 >> 2] = -1521486534, l[de + 16 >> 2] = -23791573, l[de + 20 >> 2] = 1013904242, l[de + 8 >> 2] = -2067093701, l[de + 12 >> 2] = -1150833019, l[de >> 2] = -222443256 ^ (8192 | be), l[de + 4 >> 2] = 1779033703, Rt(32 + (Z = de + 384 | 0) | 0, 0, 96), yt(Z, Ie, 32), yt(de + 96 | 0, Z, 128), l[de + 352 >> 2] = 128, Ro(Z, 128), ua(de, L, be), st = Ue), L = 0), st = Qe + 32 | 0, 0 | L;
                    }, Ba: na, Ca: function(L, Z, le) {
                      return L |= 0, ga(Z |= 0, 32, le |= 0, 32, 0, 0, 0), 0 | Ja(L, Z);
                    }, Da: function(L, Z) {
                      return L |= 0, Se(Z |= 0, 32), 0 | Ja(L, Z);
                    }, Ea: function(L, Z, le, ae, de) {
                      Z |= 0, le |= 0, ae |= 0, de |= 0;
                      var Ie, Qe, q = 0, be = 0;
                      if (Qe = q = st, st = q = q - 512 & -64, Ie = (L |= 0) || Z) {
                        if (be = -1, !Bo(q + 96 | 0, ae, de)) {
                          for (ae = Z || L, L = 0, Zs(Z = q + 128 | 0, 0, 0, 64), as(Z, be = q + 96 | 0, 32, 0), Ro(be, 32), as(Z, le, 32, 0), as(Z, de, 32, 0), Yt(Z, q + 32 | 0, 64), Ro(Z, 384); Z = (de = q + 32 | 0) + L | 0, j[L + Ie | 0] = B[0 | Z], j[L + ae | 0] = B[Z + 32 | 0], j[(le = 1 | L) + Ie | 0] = B[le + de | 0], j[le + ae | 0] = B[Z + 33 | 0], (0 | (L = L + 2 | 0)) != 32; )
                            ;
                          Ro(q + 32 | 0, 64), be = 0;
                        }
                        return st = Qe, 0 | be;
                      }
                      Ko(), Xr();
                    }, Fa: function(L, Z, le, ae, de) {
                      Z |= 0, le |= 0, ae |= 0, de |= 0;
                      var Ie, Qe, q = 0, be = 0;
                      if (Qe = q = st, st = q = q - 512 & -64, Ie = (L |= 0) || Z) {
                        if (be = -1, !Bo(q + 96 | 0, ae, de)) {
                          for (ae = Z || L, L = 0, Zs(Z = q + 128 | 0, 0, 0, 64), as(Z, be = q + 96 | 0, 32, 0), Ro(be, 32), as(Z, de, 32, 0), as(Z, le, 32, 0), Yt(Z, q + 32 | 0, 64), Ro(Z, 384); Z = (de = q + 32 | 0) + L | 0, j[L + ae | 0] = B[0 | Z], j[L + Ie | 0] = B[Z + 32 | 0], j[(le = 1 | L) + ae | 0] = B[le + de | 0], j[le + Ie | 0] = B[Z + 33 | 0], (0 | (L = L + 2 | 0)) != 32; )
                            ;
                          Ro(q + 32 | 0, 64), be = 0;
                        }
                        return st = Qe, 0 | be;
                      }
                      Ko(), Xr();
                    }, Ga: $i, Ha: $i, Ia: $i, Ja: $i, Ka: Ja, La: Bo, Ma: $i, Na: $i, Oa: $i, Pa: va, Qa: ra, Ra: Qa, Sa: na, Ta: Un, Ua: function(L, Z, le, ae, de, Ie) {
                      return L |= 0, Z |= 0, de |= 0, Ie |= 0, !(ae |= 0) & (le |= 0) >>> 0 >= 4294967280 | ae && (Ko(), Xr()), Ms(L + 16 | 0, L, Z, le, ae, de, Ie), 0;
                    }, Va: Jn, Wa: qe, Xa: na, Ya: function(L, Z, le) {
                      return L |= 0, le |= 0, Se(Z |= 0, 24), da(L, Z, le), j[L + 32 | 0] = 1, j[L + 33 | 0] = 0, j[L + 34 | 0] = 0, j[L + 35 | 0] = 0, le = B[Z + 16 | 0] | B[Z + 17 | 0] << 8 | B[Z + 18 | 0] << 16 | B[Z + 19 | 0] << 24, Z = B[Z + 20 | 0] | B[Z + 21 | 0] << 8 | B[Z + 22 | 0] << 16 | B[Z + 23 | 0] << 24, j[L + 44 | 0] = 0, j[L + 45 | 0] = 0, j[L + 46 | 0] = 0, j[L + 47 | 0] = 0, j[L + 48 | 0] = 0, j[L + 49 | 0] = 0, j[L + 50 | 0] = 0, j[L + 51 | 0] = 0, j[L + 36 | 0] = le, j[L + 37 | 0] = le >>> 8, j[L + 38 | 0] = le >>> 16, j[L + 39 | 0] = le >>> 24, j[L + 40 | 0] = Z, j[L + 41 | 0] = Z >>> 8, j[L + 42 | 0] = Z >>> 16, j[L + 43 | 0] = Z >>> 24, 0;
                    }, Za: function(L, Z, le) {
                      return da(L |= 0, Z |= 0, le |= 0), j[L + 32 | 0] = 1, j[L + 33 | 0] = 0, j[L + 34 | 0] = 0, j[L + 35 | 0] = 0, le = B[Z + 16 | 0] | B[Z + 17 | 0] << 8 | B[Z + 18 | 0] << 16 | B[Z + 19 | 0] << 24, Z = B[Z + 20 | 0] | B[Z + 21 | 0] << 8 | B[Z + 22 | 0] << 16 | B[Z + 23 | 0] << 24, j[L + 44 | 0] = 0, j[L + 45 | 0] = 0, j[L + 46 | 0] = 0, j[L + 47 | 0] = 0, j[L + 48 | 0] = 0, j[L + 49 | 0] = 0, j[L + 50 | 0] = 0, j[L + 51 | 0] = 0, j[L + 36 | 0] = le, j[L + 37 | 0] = le >>> 8, j[L + 38 | 0] = le >>> 16, j[L + 39 | 0] = le >>> 24, j[L + 40 | 0] = Z, j[L + 41 | 0] = Z >>> 8, j[L + 42 | 0] = Z >>> 16, j[L + 43 | 0] = Z >>> 24, 0;
                    }, _a: function(L) {
                      var Z, le = 0, ae = 0;
                      st = Z = st - 48 | 0, le = B[28 + (L |= 0) | 0] | B[L + 29 | 0] << 8 | B[L + 30 | 0] << 16 | B[L + 31 | 0] << 24, l[Z + 24 >> 2] = B[L + 24 | 0] | B[L + 25 | 0] << 8 | B[L + 26 | 0] << 16 | B[L + 27 | 0] << 24, l[Z + 28 >> 2] = le, le = B[L + 20 | 0] | B[L + 21 | 0] << 8 | B[L + 22 | 0] << 16 | B[L + 23 | 0] << 24, l[Z + 16 >> 2] = B[L + 16 | 0] | B[L + 17 | 0] << 8 | B[L + 18 | 0] << 16 | B[L + 19 | 0] << 24, l[Z + 20 >> 2] = le, le = B[L + 4 | 0] | B[L + 5 | 0] << 8 | B[L + 6 | 0] << 16 | B[L + 7 | 0] << 24, l[Z >> 2] = B[0 | L] | B[L + 1 | 0] << 8 | B[L + 2 | 0] << 16 | B[L + 3 | 0] << 24, l[Z + 4 >> 2] = le, le = B[L + 12 | 0] | B[L + 13 | 0] << 8 | B[L + 14 | 0] << 16 | B[L + 15 | 0] << 24, l[Z + 8 >> 2] = B[L + 8 | 0] | B[L + 9 | 0] << 8 | B[L + 10 | 0] << 16 | B[L + 11 | 0] << 24, l[Z + 12 >> 2] = le, le = B[L + 40 | 0] | B[L + 41 | 0] << 8 | B[L + 42 | 0] << 16 | B[L + 43 | 0] << 24, l[Z + 32 >> 2] = B[L + 36 | 0] | B[L + 37 | 0] << 8 | B[L + 38 | 0] << 16 | B[L + 39 | 0] << 24, l[Z + 36 >> 2] = le, Fa(Z, Z, L + 32 | 0, L), le = l[Z + 28 >> 2], ae = l[Z + 24 >> 2], j[L + 24 | 0] = ae, j[L + 25 | 0] = ae >>> 8, j[L + 26 | 0] = ae >>> 16, j[L + 27 | 0] = ae >>> 24, j[L + 28 | 0] = le, j[L + 29 | 0] = le >>> 8, j[L + 30 | 0] = le >>> 16, j[L + 31 | 0] = le >>> 24, le = l[Z + 20 >> 2], ae = l[Z + 16 >> 2], j[L + 16 | 0] = ae, j[L + 17 | 0] = ae >>> 8, j[L + 18 | 0] = ae >>> 16, j[L + 19 | 0] = ae >>> 24, j[L + 20 | 0] = le, j[L + 21 | 0] = le >>> 8, j[L + 22 | 0] = le >>> 16, j[L + 23 | 0] = le >>> 24, le = l[Z + 12 >> 2], ae = l[Z + 8 >> 2], j[L + 8 | 0] = ae, j[L + 9 | 0] = ae >>> 8, j[L + 10 | 0] = ae >>> 16, j[L + 11 | 0] = ae >>> 24, j[L + 12 | 0] = le, j[L + 13 | 0] = le >>> 8, j[L + 14 | 0] = le >>> 16, j[L + 15 | 0] = le >>> 24, le = l[Z + 4 >> 2], ae = l[Z >> 2], j[0 | L] = ae, j[L + 1 | 0] = ae >>> 8, j[L + 2 | 0] = ae >>> 16, j[L + 3 | 0] = ae >>> 24, j[L + 4 | 0] = le, j[L + 5 | 0] = le >>> 8, j[L + 6 | 0] = le >>> 16, j[L + 7 | 0] = le >>> 24, ae = l[Z + 36 >> 2], le = l[Z + 32 >> 2], j[L + 32 | 0] = 1, j[L + 33 | 0] = 0, j[L + 34 | 0] = 0, j[L + 35 | 0] = 0, j[L + 36 | 0] = le, j[L + 37 | 0] = le >>> 8, j[L + 38 | 0] = le >>> 16, j[L + 39 | 0] = le >>> 24, j[L + 40 | 0] = ae, j[L + 41 | 0] = ae >>> 8, j[L + 42 | 0] = ae >>> 16, j[L + 43 | 0] = ae >>> 24, st = Z + 48 | 0;
                    }, $a: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue) {
                      L |= 0, Z |= 0, ae |= 0, Qe |= 0, be |= 0, Ue |= 0;
                      var Ye, Te = 0, Ne = 0, We = 0;
                      return Te = de |= 0, de = Ie |= 0, Te |= Ie = 0, Ye = Ie | (q |= 0), st = Ie = st - 384 | 0, (le |= 0) && (l[le >> 2] = 0, l[le + 4 >> 2] = 0), !de & Te >>> 0 < 4294967279 ? (ls(Ne = Ie + 16 | 0, 64, We = L + 32 | 0, L), Es(q = Ie + 80 | 0, Ne), Ro(Ne, 64), Yo(q, Qe, Ye, be), Yo(q, 33904, 0 - Ye & 15, 0), l[Ie + 72 >> 2] = 0, l[Ie + 76 >> 2] = 0, l[(Qe = Ie - -64 | 0) >> 2] = 0, l[Qe + 4 >> 2] = 0, l[Ie + 56 >> 2] = 0, l[Ie + 60 >> 2] = 0, l[Ie + 48 >> 2] = 0, l[Ie + 52 >> 2] = 0, l[Ie + 40 >> 2] = 0, l[Ie + 44 >> 2] = 0, l[Ie + 32 >> 2] = 0, l[Ie + 36 >> 2] = 0, l[Ie + 16 >> 2] = 0, l[Ie + 20 >> 2] = 0, l[Ie + 24 >> 2] = 0, l[Ie + 28 >> 2] = 0, j[Ie + 16 | 0] = Ue, ds(Ne, Ne, 64, 0, We, 1, L), Yo(q, Ne, 64, 0), j[0 | Z] = B[Ie + 16 | 0], ds(Z = Z + 1 | 0, ae, Te, de, We, 2, L), Yo(q, Z, Te, de), Yo(q, 33904, 15 & Te, 0), l[Ie + 8 >> 2] = Ye, l[Ie + 12 >> 2] = be, Yo(q, ae = Ie + 8 | 0, 8, 0), l[Ie + 8 >> 2] = Te - -64, l[Ie + 12 >> 2] = de - ((Te >>> 0 < 4294967232) - 1 | 0), Yo(q, ae, 8, 0), ta(q, Z = Z + Te | 0), Ro(q, 256), j[L + 36 | 0] = B[L + 36 | 0] ^ B[0 | Z], j[L + 37 | 0] = B[L + 37 | 0] ^ B[Z + 1 | 0], j[L + 38 | 0] = B[L + 38 | 0] ^ B[Z + 2 | 0], j[L + 39 | 0] = B[L + 39 | 0] ^ B[Z + 3 | 0], j[L + 40 | 0] = B[L + 40 | 0] ^ B[Z + 4 | 0], j[L + 41 | 0] = B[L + 41 | 0] ^ B[Z + 5 | 0], j[L + 42 | 0] = B[L + 42 | 0] ^ B[Z + 6 | 0], j[L + 43 | 0] = B[L + 43 | 0] ^ B[Z + 7 | 0], ya(We), (2 & Ue || Ts(We, 4)) && (Z = B[L + 28 | 0] | B[L + 29 | 0] << 8 | B[L + 30 | 0] << 16 | B[L + 31 | 0] << 24, l[Ie + 360 >> 2] = B[L + 24 | 0] | B[L + 25 | 0] << 8 | B[L + 26 | 0] << 16 | B[L + 27 | 0] << 24, l[Ie + 364 >> 2] = Z, Z = B[L + 20 | 0] | B[L + 21 | 0] << 8 | B[L + 22 | 0] << 16 | B[L + 23 | 0] << 24, l[Ie + 352 >> 2] = B[L + 16 | 0] | B[L + 17 | 0] << 8 | B[L + 18 | 0] << 16 | B[L + 19 | 0] << 24, l[Ie + 356 >> 2] = Z, Z = B[L + 4 | 0] | B[L + 5 | 0] << 8 | B[L + 6 | 0] << 16 | B[L + 7 | 0] << 24, l[Ie + 336 >> 2] = B[0 | L] | B[L + 1 | 0] << 8 | B[L + 2 | 0] << 16 | B[L + 3 | 0] << 24, l[Ie + 340 >> 2] = Z, Z = B[L + 12 | 0] | B[L + 13 | 0] << 8 | B[L + 14 | 0] << 16 | B[L + 15 | 0] << 24, l[Ie + 344 >> 2] = B[L + 8 | 0] | B[L + 9 | 0] << 8 | B[L + 10 | 0] << 16 | B[L + 11 | 0] << 24, l[Ie + 348 >> 2] = Z, Z = B[L + 40 | 0] | B[L + 41 | 0] << 8 | B[L + 42 | 0] << 16 | B[L + 43 | 0] << 24, l[Ie + 368 >> 2] = B[L + 36 | 0] | B[L + 37 | 0] << 8 | B[L + 38 | 0] << 16 | B[L + 39 | 0] << 24, l[Ie + 372 >> 2] = Z, Fa(Z = Ie + 336 | 0, Z, We, L), Z = l[Ie + 364 >> 2], ae = l[Ie + 360 >> 2], j[L + 24 | 0] = ae, j[L + 25 | 0] = ae >>> 8, j[L + 26 | 0] = ae >>> 16, j[L + 27 | 0] = ae >>> 24, j[L + 28 | 0] = Z, j[L + 29 | 0] = Z >>> 8, j[L + 30 | 0] = Z >>> 16, j[L + 31 | 0] = Z >>> 24, Z = l[Ie + 356 >> 2], ae = l[Ie + 352 >> 2], j[L + 16 | 0] = ae, j[L + 17 | 0] = ae >>> 8, j[L + 18 | 0] = ae >>> 16, j[L + 19 | 0] = ae >>> 24, j[L + 20 | 0] = Z, j[L + 21 | 0] = Z >>> 8, j[L + 22 | 0] = Z >>> 16, j[L + 23 | 0] = Z >>> 24, Z = l[Ie + 348 >> 2], ae = l[Ie + 344 >> 2], j[L + 8 | 0] = ae, j[L + 9 | 0] = ae >>> 8, j[L + 10 | 0] = ae >>> 16, j[L + 11 | 0] = ae >>> 24, j[L + 12 | 0] = Z, j[L + 13 | 0] = Z >>> 8, j[L + 14 | 0] = Z >>> 16, j[L + 15 | 0] = Z >>> 24, Z = l[Ie + 340 >> 2], ae = l[Ie + 336 >> 2], j[0 | L] = ae, j[L + 1 | 0] = ae >>> 8, j[L + 2 | 0] = ae >>> 16, j[L + 3 | 0] = ae >>> 24, j[L + 4 | 0] = Z, j[L + 5 | 0] = Z >>> 8, j[L + 6 | 0] = Z >>> 16, j[L + 7 | 0] = Z >>> 24, Z = l[Ie + 368 >> 2], ae = l[Ie + 372 >> 2], j[L + 32 | 0] = 1, j[L + 33 | 0] = 0, j[L + 34 | 0] = 0, j[L + 35 | 0] = 0, j[L + 36 | 0] = Z, j[L + 37 | 0] = Z >>> 8, j[L + 38 | 0] = Z >>> 16, j[L + 39 | 0] = Z >>> 24, j[L + 40 | 0] = ae, j[L + 41 | 0] = ae >>> 8, j[L + 42 | 0] = ae >>> 16, j[L + 43 | 0] = ae >>> 24), le && (de = (L = Te + 17 | 0) >>> 0 < 17 ? de + 1 | 0 : de, l[le >> 2] = L, l[le + 4 >> 2] = de), st = Ie + 384 | 0) : (Ko(), Xr()), 0;
                    }, ab: function(L, Z, le, ae, de, Ie, Qe, q, be, Ue) {
                      L |= 0, Z |= 0, ae |= 0, de |= 0, q |= 0, Ue |= 0;
                      var Ye, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0;
                      Te = Ie |= 0, Ie = Qe |= 0, Ne = 0 | Te, Ye = be |= 0, st = Qe = st - 400 | 0, (le |= 0) && (l[le >> 2] = 0, l[le + 4 >> 2] = 0), ae && (j[0 | ae] = 255), _t = -1;
                      e: {
                        t: {
                          if (!(!Ie & Ne >>> 0 < 17)) {
                            if (ot = Te = Ie - (Ne >>> 0 < 17) | 0, !Te & (be = Ne - 17 | 0) >>> 0 >= 4294967279 | Te)
                              break t;
                            ls(We = Qe + 32 | 0, 64, rt = L + 32 | 0, L), Es(Te = Qe + 96 | 0, We), Ro(We, 64), Yo(Te, q, Ye, Ue), Yo(Te, 33904, 0 - Ye & 15, 0), l[Qe + 88 >> 2] = 0, l[Qe + 92 >> 2] = 0, l[Qe + 80 >> 2] = 0, l[Qe + 84 >> 2] = 0, l[Qe + 72 >> 2] = 0, l[Qe + 76 >> 2] = 0, l[(q = Qe - -64 | 0) >> 2] = 0, l[q + 4 >> 2] = 0, l[Qe + 56 >> 2] = 0, l[Qe + 60 >> 2] = 0, l[Qe + 48 >> 2] = 0, l[Qe + 52 >> 2] = 0, l[Qe + 40 >> 2] = 0, l[Qe + 44 >> 2] = 0, l[Qe + 32 >> 2] = 0, l[Qe + 36 >> 2] = 0, j[Qe + 32 | 0] = B[0 | de], ds(We, We, 64, 0, rt, 1, L), q = B[Qe + 32 | 0], j[Qe + 32 | 0] = B[0 | de], Yo(Te, We, 64, 0), Yo(Te, de = de + 1 | 0, be, ot), Yo(Te, 33904, Ne - 1 & 15, 0), l[Qe + 24 >> 2] = Ye, l[Qe + 28 >> 2] = Ue, Yo(Te, Ue = Qe + 24 | 0, 8, 0), Ie = (Ne = Ne + 47 | 0) >>> 0 < 47 ? Ie + 1 | 0 : Ie, l[Qe + 24 >> 2] = Ne, l[Qe + 28 >> 2] = Ie, Yo(Te, Ue, 8, 0), ta(Te, Qe), Ro(Te, 256), gs(Qe, de + be | 0, 16) ? Ro(Qe, 16) : (ds(Z, de, be, ot, rt, 2, L), j[L + 36 | 0] = B[L + 36 | 0] ^ B[0 | Qe], j[L + 37 | 0] = B[L + 37 | 0] ^ B[Qe + 1 | 0], j[L + 38 | 0] = B[L + 38 | 0] ^ B[Qe + 2 | 0], j[L + 39 | 0] = B[L + 39 | 0] ^ B[Qe + 3 | 0], j[L + 40 | 0] = B[L + 40 | 0] ^ B[Qe + 4 | 0], j[L + 41 | 0] = B[L + 41 | 0] ^ B[Qe + 5 | 0], j[L + 42 | 0] = B[L + 42 | 0] ^ B[Qe + 6 | 0], j[L + 43 | 0] = B[L + 43 | 0] ^ B[Qe + 7 | 0], ya(rt), (2 & q || Ts(rt, 4)) && (Z = B[L + 28 | 0] | B[L + 29 | 0] << 8 | B[L + 30 | 0] << 16 | B[L + 31 | 0] << 24, l[Qe + 376 >> 2] = B[L + 24 | 0] | B[L + 25 | 0] << 8 | B[L + 26 | 0] << 16 | B[L + 27 | 0] << 24, l[Qe + 380 >> 2] = Z, Z = B[L + 20 | 0] | B[L + 21 | 0] << 8 | B[L + 22 | 0] << 16 | B[L + 23 | 0] << 24, l[Qe + 368 >> 2] = B[L + 16 | 0] | B[L + 17 | 0] << 8 | B[L + 18 | 0] << 16 | B[L + 19 | 0] << 24, l[Qe + 372 >> 2] = Z, Z = B[L + 4 | 0] | B[L + 5 | 0] << 8 | B[L + 6 | 0] << 16 | B[L + 7 | 0] << 24, l[Qe + 352 >> 2] = B[0 | L] | B[L + 1 | 0] << 8 | B[L + 2 | 0] << 16 | B[L + 3 | 0] << 24, l[Qe + 356 >> 2] = Z, Z = B[L + 12 | 0] | B[L + 13 | 0] << 8 | B[L + 14 | 0] << 16 | B[L + 15 | 0] << 24, l[Qe + 360 >> 2] = B[L + 8 | 0] | B[L + 9 | 0] << 8 | B[L + 10 | 0] << 16 | B[L + 11 | 0] << 24, l[Qe + 364 >> 2] = Z, Z = B[L + 40 | 0] | B[L + 41 | 0] << 8 | B[L + 42 | 0] << 16 | B[L + 43 | 0] << 24, l[Qe + 384 >> 2] = B[L + 36 | 0] | B[L + 37 | 0] << 8 | B[L + 38 | 0] << 16 | B[L + 39 | 0] << 24, l[Qe + 388 >> 2] = Z, Fa(Z = Qe + 352 | 0, Z, rt, L), Z = l[Qe + 380 >> 2], de = l[Qe + 376 >> 2], j[L + 24 | 0] = de, j[L + 25 | 0] = de >>> 8, j[L + 26 | 0] = de >>> 16, j[L + 27 | 0] = de >>> 24, j[L + 28 | 0] = Z, j[L + 29 | 0] = Z >>> 8, j[L + 30 | 0] = Z >>> 16, j[L + 31 | 0] = Z >>> 24, Z = l[Qe + 372 >> 2], de = l[Qe + 368 >> 2], j[L + 16 | 0] = de, j[L + 17 | 0] = de >>> 8, j[L + 18 | 0] = de >>> 16, j[L + 19 | 0] = de >>> 24, j[L + 20 | 0] = Z, j[L + 21 | 0] = Z >>> 8, j[L + 22 | 0] = Z >>> 16, j[L + 23 | 0] = Z >>> 24, Z = l[Qe + 364 >> 2], de = l[Qe + 360 >> 2], j[L + 8 | 0] = de, j[L + 9 | 0] = de >>> 8, j[L + 10 | 0] = de >>> 16, j[L + 11 | 0] = de >>> 24, j[L + 12 | 0] = Z, j[L + 13 | 0] = Z >>> 8, j[L + 14 | 0] = Z >>> 16, j[L + 15 | 0] = Z >>> 24, Z = l[Qe + 356 >> 2], de = l[Qe + 352 >> 2], j[0 | L] = de, j[L + 1 | 0] = de >>> 8, j[L + 2 | 0] = de >>> 16, j[L + 3 | 0] = de >>> 24, j[L + 4 | 0] = Z, j[L + 5 | 0] = Z >>> 8, j[L + 6 | 0] = Z >>> 16, j[L + 7 | 0] = Z >>> 24, Z = l[Qe + 384 >> 2], de = l[Qe + 388 >> 2], j[L + 32 | 0] = 1, j[L + 33 | 0] = 0, j[L + 34 | 0] = 0, j[L + 35 | 0] = 0, j[L + 36 | 0] = Z, j[L + 37 | 0] = Z >>> 8, j[L + 38 | 0] = Z >>> 16, j[L + 39 | 0] = Z >>> 24, j[L + 40 | 0] = de, j[L + 41 | 0] = de >>> 8, j[L + 42 | 0] = de >>> 16, j[L + 43 | 0] = de >>> 24), le && (l[le >> 2] = be, l[le + 4 >> 2] = ot), _t = 0, ae && (j[0 | ae] = q));
                          }
                          st = Qe + 400 | 0;
                          break e;
                        }
                        Ko(), Xr();
                      }
                      return 0 | _t;
                    }, bb: function() {
                      return 52;
                    }, cb: function() {
                      return 17;
                    }, db: va, eb: $i, fb: function() {
                      return -18;
                    }, gb: Na, hb: La, ib: function() {
                      return 2;
                    }, jb: Ha, kb: za, lb: ra, mb: function(L, Z, le, ae, de) {
                      L |= 0, Z |= 0, le |= 0, ae |= 0;
                      var Ie, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0;
                      if (tt = 1886610805 ^ (de = B[0 | (Qe = de |= 0)] | B[Qe + 1 | 0] << 8 | B[Qe + 2 | 0] << 16 | B[Qe + 3 | 0] << 24), xt = 1936682341 ^ (q = B[Qe + 4 | 0] | B[Qe + 5 | 0] << 8 | B[Qe + 6 | 0] << 16 | B[Qe + 7 | 0] << 24), de ^= 1852142177, be = 1819895653 ^ q, Mt = 1852075885 ^ (q = B[Qe + 8 | 0] | B[Qe + 9 | 0] << 8 | B[Qe + 10 | 0] << 16 | B[Qe + 11 | 0] << 24), Vt = 1685025377 ^ (Qe = B[Qe + 12 | 0] | B[Qe + 13 | 0] << 8 | B[Qe + 14 | 0] << 16 | B[Qe + 15 | 0] << 24), Ue = 2037671283 ^ q, q = 1952801890 ^ Qe, ot = le, (0 | (We = (Z + le | 0) - (Ie = 7 & le) | 0)) != (0 | Z)) {
                        for (; le = (_t = q ^ (qt = B[Z + 4 | 0] | B[Z + 5 | 0] << 8 | B[Z + 6 | 0] << 16 | B[Z + 7 | 0] << 24)) + be | 0, Ue = de = (Qe = ae = Ue ^ (rt = B[0 | Z] | B[Z + 1 | 0] << 8 | B[Z + 2 | 0] << 16 | B[Z + 3 | 0] << 24)) + de | 0, Ne = le = de >>> 0 < Qe >>> 0 ? le + 1 | 0 : le, le = xt + Vt | 0, le = (be = tt + Mt | 0) >>> 0 < Mt >>> 0 ? le + 1 | 0 : le, Qe = vt(Mt, Vt, 13) ^ be, q = le, le = Ne + (de = le ^ Oe) | 0, le = Qe >>> 0 > (Ye = Ue + Qe | 0) >>> 0 ? le + 1 | 0 : le, Qe = vt(Qe, de, 17) ^ Ye, Te = le, tt = vt(Qe, de = le ^ Oe, 13), xt = Oe, le = vt(ae, _t, 16), ae = Ne ^ Oe, _t = le ^ Ue, q = vt(be, q, 32), le = Oe + ae | 0, le = (q = (be = _t + q | 0) >>> 0 < q >>> 0 ? le + 1 | 0 : le) + de | 0, Ne = le = (Ue = Qe + be | 0) >>> 0 < be >>> 0 ? le + 1 | 0 : le, tt = vt(Qe = Ue ^ tt, de = le ^ xt, 17), xt = Oe, le = vt(_t, ae, 21), ae = q ^ Oe, _t = le ^ be, q = vt(Ye, Te, 32), le = Oe + ae | 0, le = (q = (be = _t + q | 0) >>> 0 < q >>> 0 ? le + 1 | 0 : le) + de | 0, Mt = (Qe = Qe + be | 0) ^ tt, de = le = Qe >>> 0 < be >>> 0 ? le + 1 | 0 : le, Vt = le ^ xt, le = vt(_t, ae, 16), Ye = q ^= Oe, Te = vt(le ^= be, q, 21), be = Oe, Ne = (q = vt(Ue, Ne, 32)) + le | 0, le = Oe + Ye | 0, Ue = Te ^ Ne, q = (le = q >>> 0 > Ne >>> 0 ? le + 1 | 0 : le) ^ be, de = vt(Qe, de, 32), be = Oe, tt = Ne ^ rt, xt = le ^ qt, (0 | We) != (0 | (Z = Z + 8 | 0)); )
                          ;
                        Z = We;
                      }
                      switch (qt = 0, Te = ot << 24, Ie - 1 | 0) {
                        case 6:
                          Te |= B[Z + 6 | 0] << 16;
                        case 5:
                          Te |= B[Z + 5 | 0] << 8;
                        case 4:
                          Te |= B[Z + 4 | 0];
                        case 3:
                          qt |= (ae = B[Z + 3 | 0]) << 24, Te |= le = ae >>> 8 | 0;
                        case 2:
                          qt |= (ae = B[Z + 2 | 0]) << 16, Te |= le = ae >>> 16 | 0;
                        case 1:
                          qt |= (ae = B[Z + 1 | 0]) << 8, Te |= le = ae >>> 24 | 0;
                        case 0:
                          qt = B[0 | Z] | qt;
                      }
                      return Z = L, ae = vt(Qe = Ue ^ qt, L = q ^ Te, 16), L = L + be | 0, Ne = L = (Ue = de + Qe | 0) >>> 0 < de >>> 0 ? L + 1 | 0 : L, Ye = vt(de = ae ^ Ue, L ^= le = Oe, 21), q = Oe, le = xt + Vt | 0, ae = le = (Qe = tt + Mt | 0) >>> 0 < Mt >>> 0 ? le + 1 | 0 : le, We = de, de = vt(Qe, le, 32), le = Oe + L | 0, L = q, q = le = de >>> 0 > (be = We + de | 0) >>> 0 ? le + 1 | 0 : le, ot = vt(de = be ^ Ye, L ^= le, 16), rt = Oe, Qe = (le = Ue) + (Ue = We = vt(Mt, Vt, 13) ^ Qe) | 0, le = (Ye = Oe ^ ae) + Ne | 0, ae = Qe, Ne = de, de = vt(Qe, le = Qe >>> 0 < Ue >>> 0 ? le + 1 | 0 : le, 32), L = Oe + L | 0, _t = vt(Qe = (Ue = Ne + de | 0) ^ ot, de = (Ne = de >>> 0 > Ue >>> 0 ? L + 1 | 0 : L) ^ rt, 21), rt = Oe, We = vt(We, Ye, 17) ^ ae, le = (Ye = Oe ^ le) + q | 0, L = le = (L = We) >>> 0 > (ae = L + be | 0) >>> 0 ? le + 1 | 0 : le, q = Qe, Qe = vt(ae, le, 32), le = Oe + de | 0, ot = le = (q = Qe >>> 0 > (be = q + Qe | 0) >>> 0 ? le + 1 | 0 : le) ^ rt, rt = vt(_t ^= be, le, 16), Qe = Oe, We = vt(We, Ye, 13) ^ ae, L = (Ye = L ^ Oe) + Ne | 0, ae = L = (le = We) >>> 0 > (de = le + Ue | 0) >>> 0 ? L + 1 | 0 : L, L = vt(de, L, 32), le = ot + Oe | 0, ot = le = (Ue = Qe) ^ (Qe = (L = _t + (255 ^ L) | 0) >>> 0 < _t >>> 0 ? le + 1 | 0 : le), Ue = L, rt = vt(_t = rt ^ L, le, 21), Ne = Oe, We = vt(We, Ye, 17) ^ de, le = (Ye = ae ^ Oe) + (q ^ Te) | 0, ae = le = (L = be ^ qt) >>> 0 > (de = We + L | 0) >>> 0 ? le + 1 | 0 : le, L = vt(de, le, 32), le = ot + Oe | 0, le = (q = (L = L + _t | 0) >>> 0 < _t >>> 0 ? le + 1 | 0 : le) ^ Ne, Ne = L, rt = vt(ot = rt ^ L, le, 16), be = Oe, Ye = vt(We, Ye, 13) ^ de, L = Qe + (Te = Oe ^ ae) | 0, ae = L = (de = Ue + Ye | 0) >>> 0 < Ue >>> 0 ? L + 1 | 0 : L, L = vt(de, L, 32), le = le + Oe | 0, We = le = (Qe = (L = L + ot | 0) >>> 0 < ot >>> 0 ? le + 1 | 0 : le) ^ be, be = L, rt = vt(ot = rt ^ L, le, 21), Ue = Oe, L = vt(Ye, Te, 17), le = q + (Ye = ae ^ Oe) | 0, ae = le = (de = Ne + (Te = L ^ de) | 0) >>> 0 < Ne >>> 0 ? le + 1 | 0 : le, L = vt(de, le, 32), le = We + Oe | 0, Ue = le = (q = (L = L + ot | 0) >>> 0 < ot >>> 0 ? le + 1 | 0 : le) ^ Ue, Ne = L, We = vt(ot = rt ^ L, le, 16), rt = Oe, L = vt(Te, Ye, 13), le = Qe + (Ye = ae ^ Oe) | 0, ae = le = (Qe = be + (Te = L ^ de) | 0) >>> 0 < be >>> 0 ? le + 1 | 0 : le, L = vt(Qe, le, 32), le = Ue + Oe | 0, Ue = L = L + ot | 0, be = le = L >>> 0 < ot >>> 0 ? le + 1 | 0 : le, ot = vt(de = We ^ L, L = le ^ rt, 21), We = Oe, Te = vt(Te, Ye, 17), le = q + (rt = ae ^ Oe) | 0, Ye = Qe ^ Te, Qe = de, de = vt(ae = Ne + Ye | 0, le = ae >>> 0 < Ne >>> 0 ? le + 1 | 0 : le, 32), L = Oe + L | 0, We = vt(Qe = (Ne = Qe + de | 0) ^ ot, de = (q = de >>> 0 > Ne >>> 0 ? L + 1 | 0 : L) ^ We, 16), Te = Oe, L = vt(Ye, rt, 13), le = be + (rt = le ^ Oe) | 0, L = le = (ae = Ue + (Ye = L ^ ae) | 0) >>> 0 < Ue >>> 0 ? le + 1 | 0 : le, be = vt(ae, le, 32), le = Oe + de | 0, de = Qe = be + Qe | 0, Te = vt(Qe ^ We, (le = Qe >>> 0 < be >>> 0 ? le + 1 | 0 : le) ^ Te, 21), Ue = Oe, ae = vt(Ye, rt, 17) ^ ae, be = vt(ae, L ^= Oe, 13), L = L + q | 0, q = L = Oe ^ ((ae = ae + Ne | 0) >>> 0 < Ne >>> 0 ? L + 1 | 0 : L), ae = vt(Qe = ae ^ be, L, 17) ^ Te, L = Oe ^ Ue, le = le + q | 0, Ue = de, ae = vt(de = de + Qe | 0, le = Ue >>> 0 > de >>> 0 ? le + 1 | 0 : le, 32) ^ ae ^ de, j[0 | Z] = ae, j[Z + 1 | 0] = ae >>> 8, j[Z + 2 | 0] = ae >>> 16, j[Z + 3 | 0] = ae >>> 24, L ^= le ^ Oe, j[Z + 4 | 0] = L, j[Z + 5 | 0] = L >>> 8, j[Z + 6 | 0] = L >>> 16, j[Z + 7 | 0] = L >>> 24, 0;
                    }, nb: function(L) {
                      Se(L |= 0, 16);
                    }, ob: function() {
                      return 208;
                    }, pb: Ra, qb: $i, rb: $i, sb: Ra, tb: function() {
                      return -65;
                    }, ub: function(L, Z, le) {
                      L |= 0;
                      var ae, de, Ie, Qe, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0;
                      return st = Ie = st - 160 | 0, Si(Z |= 0, le |= 0, 32, 0), j[0 | Z] = 248 & B[0 | Z], j[Z + 31 | 0] = 63 & B[Z + 31 | 0] | 64, Ui(Ie, Z), Ce(L, Ie), be = B[(de = le) + 8 | 0] | B[de + 9 | 0] << 8 | B[de + 10 | 0] << 16 | B[de + 11 | 0] << 24, q = B[de + 12 | 0] | B[de + 13 | 0] << 8 | B[de + 14 | 0] << 16 | B[de + 15 | 0] << 24, Ue = B[de + 16 | 0] | B[de + 17 | 0] << 8 | B[de + 18 | 0] << 16 | B[de + 19 | 0] << 24, Ye = B[de + 20 | 0] | B[de + 21 | 0] << 8 | B[de + 22 | 0] << 16 | B[de + 23 | 0] << 24, Te = B[0 | de] | B[de + 1 | 0] << 8 | B[de + 2 | 0] << 16 | B[de + 3 | 0] << 24, le = B[de + 4 | 0] | B[de + 5 | 0] << 8 | B[de + 6 | 0] << 16 | B[de + 7 | 0] << 24, Qe = B[de + 28 | 0] | B[de + 29 | 0] << 8 | B[de + 30 | 0] << 16 | B[de + 31 | 0] << 24, ae = Z, Z = B[de + 24 | 0] | B[de + 25 | 0] << 8 | B[de + 26 | 0] << 16 | B[de + 27 | 0] << 24, j[ae + 24 | 0] = Z, j[ae + 25 | 0] = Z >>> 8, j[ae + 26 | 0] = Z >>> 16, j[ae + 27 | 0] = Z >>> 24, j[ae + 28 | 0] = Qe, j[ae + 29 | 0] = Qe >>> 8, j[ae + 30 | 0] = Qe >>> 16, j[ae + 31 | 0] = Qe >>> 24, j[ae + 16 | 0] = Ue, j[ae + 17 | 0] = Ue >>> 8, j[ae + 18 | 0] = Ue >>> 16, j[ae + 19 | 0] = Ue >>> 24, j[ae + 20 | 0] = Ye, j[ae + 21 | 0] = Ye >>> 8, j[ae + 22 | 0] = Ye >>> 16, j[ae + 23 | 0] = Ye >>> 24, j[ae + 8 | 0] = be, j[ae + 9 | 0] = be >>> 8, j[ae + 10 | 0] = be >>> 16, j[ae + 11 | 0] = be >>> 24, j[ae + 12 | 0] = q, j[ae + 13 | 0] = q >>> 8, j[ae + 14 | 0] = q >>> 16, j[ae + 15 | 0] = q >>> 24, j[0 | ae] = Te, j[ae + 1 | 0] = Te >>> 8, j[ae + 2 | 0] = Te >>> 16, j[ae + 3 | 0] = Te >>> 24, j[ae + 4 | 0] = le, j[ae + 5 | 0] = le >>> 8, j[ae + 6 | 0] = le >>> 16, j[ae + 7 | 0] = le >>> 24, Ue = B[(q = L) + 8 | 0] | B[q + 9 | 0] << 8 | B[q + 10 | 0] << 16 | B[q + 11 | 0] << 24, Ye = B[q + 12 | 0] | B[q + 13 | 0] << 8 | B[q + 14 | 0] << 16 | B[q + 15 | 0] << 24, Te = B[q + 16 | 0] | B[q + 17 | 0] << 8 | B[q + 18 | 0] << 16 | B[q + 19 | 0] << 24, le = B[q + 20 | 0] | B[q + 21 | 0] << 8 | B[q + 22 | 0] << 16 | B[q + 23 | 0] << 24, Z = B[0 | q] | B[q + 1 | 0] << 8 | B[q + 2 | 0] << 16 | B[q + 3 | 0] << 24, L = B[q + 4 | 0] | B[q + 5 | 0] << 8 | B[q + 6 | 0] << 16 | B[q + 7 | 0] << 24, be = B[q + 28 | 0] | B[q + 29 | 0] << 8 | B[q + 30 | 0] << 16 | B[q + 31 | 0] << 24, q = B[q + 24 | 0] | B[q + 25 | 0] << 8 | B[q + 26 | 0] << 16 | B[q + 27 | 0] << 24, j[ae + 56 | 0] = q, j[ae + 57 | 0] = q >>> 8, j[ae + 58 | 0] = q >>> 16, j[ae + 59 | 0] = q >>> 24, j[ae + 60 | 0] = be, j[ae + 61 | 0] = be >>> 8, j[ae + 62 | 0] = be >>> 16, j[ae + 63 | 0] = be >>> 24, j[ae + 48 | 0] = Te, j[ae + 49 | 0] = Te >>> 8, j[ae + 50 | 0] = Te >>> 16, j[ae + 51 | 0] = Te >>> 24, j[ae + 52 | 0] = le, j[ae + 53 | 0] = le >>> 8, j[ae + 54 | 0] = le >>> 16, j[ae + 55 | 0] = le >>> 24, j[ae + 40 | 0] = Ue, j[ae + 41 | 0] = Ue >>> 8, j[ae + 42 | 0] = Ue >>> 16, j[ae + 43 | 0] = Ue >>> 24, j[ae + 44 | 0] = Ye, j[ae + 45 | 0] = Ye >>> 8, j[ae + 46 | 0] = Ye >>> 16, j[ae + 47 | 0] = Ye >>> 24, j[ae + 32 | 0] = Z, j[ae + 33 | 0] = Z >>> 8, j[ae + 34 | 0] = Z >>> 16, j[ae + 35 | 0] = Z >>> 24, j[ae + 36 | 0] = L, j[ae + 37 | 0] = L >>> 8, j[ae + 38 | 0] = L >>> 16, j[ae + 39 | 0] = L >>> 24, st = Ie + 160 | 0, 0;
                    }, vb: function(L, Z) {
                      L |= 0, Z |= 0;
                      var le, ae, de, Ie, Qe, q = 0, be = 0, Ue = 0;
                      return st = be = st - 192 | 0, Se(be, 32), Si(Z, be, 32, 0), j[0 | Z] = 248 & B[0 | Z], j[Z + 31 | 0] = 63 & B[Z + 31 | 0] | 64, Ui(Ue = be + 32 | 0, Z), Ce(L, Ue), le = be, Ue = l[be + 28 >> 2], be = l[be + 24 >> 2], j[Z + 24 | 0] = be, j[Z + 25 | 0] = be >>> 8, j[Z + 26 | 0] = be >>> 16, j[Z + 27 | 0] = be >>> 24, j[Z + 28 | 0] = Ue, j[Z + 29 | 0] = Ue >>> 8, j[Z + 30 | 0] = Ue >>> 16, j[Z + 31 | 0] = Ue >>> 24, Ue = l[le + 20 >> 2], be = l[le + 16 >> 2], j[Z + 16 | 0] = be, j[Z + 17 | 0] = be >>> 8, j[Z + 18 | 0] = be >>> 16, j[Z + 19 | 0] = be >>> 24, j[Z + 20 | 0] = Ue, j[Z + 21 | 0] = Ue >>> 8, j[Z + 22 | 0] = Ue >>> 16, j[Z + 23 | 0] = Ue >>> 24, Ue = l[le + 12 >> 2], be = l[le + 8 >> 2], j[Z + 8 | 0] = be, j[Z + 9 | 0] = be >>> 8, j[Z + 10 | 0] = be >>> 16, j[Z + 11 | 0] = be >>> 24, j[Z + 12 | 0] = Ue, j[Z + 13 | 0] = Ue >>> 8, j[Z + 14 | 0] = Ue >>> 16, j[Z + 15 | 0] = Ue >>> 24, Ue = l[le + 4 >> 2], be = l[le >> 2], j[0 | Z] = be, j[Z + 1 | 0] = be >>> 8, j[Z + 2 | 0] = be >>> 16, j[Z + 3 | 0] = be >>> 24, j[Z + 4 | 0] = Ue, j[Z + 5 | 0] = Ue >>> 8, j[Z + 6 | 0] = Ue >>> 16, j[Z + 7 | 0] = Ue >>> 24, ae = B[(q = L) + 8 | 0] | B[q + 9 | 0] << 8 | B[q + 10 | 0] << 16 | B[q + 11 | 0] << 24, de = B[q + 12 | 0] | B[q + 13 | 0] << 8 | B[q + 14 | 0] << 16 | B[q + 15 | 0] << 24, Ie = B[q + 16 | 0] | B[q + 17 | 0] << 8 | B[q + 18 | 0] << 16 | B[q + 19 | 0] << 24, Ue = B[q + 20 | 0] | B[q + 21 | 0] << 8 | B[q + 22 | 0] << 16 | B[q + 23 | 0] << 24, be = B[0 | q] | B[q + 1 | 0] << 8 | B[q + 2 | 0] << 16 | B[q + 3 | 0] << 24, L = B[q + 4 | 0] | B[q + 5 | 0] << 8 | B[q + 6 | 0] << 16 | B[q + 7 | 0] << 24, Qe = B[q + 28 | 0] | B[q + 29 | 0] << 8 | B[q + 30 | 0] << 16 | B[q + 31 | 0] << 24, q = B[q + 24 | 0] | B[q + 25 | 0] << 8 | B[q + 26 | 0] << 16 | B[q + 27 | 0] << 24, j[Z + 56 | 0] = q, j[Z + 57 | 0] = q >>> 8, j[Z + 58 | 0] = q >>> 16, j[Z + 59 | 0] = q >>> 24, j[Z + 60 | 0] = Qe, j[Z + 61 | 0] = Qe >>> 8, j[Z + 62 | 0] = Qe >>> 16, j[Z + 63 | 0] = Qe >>> 24, j[Z + 48 | 0] = Ie, j[Z + 49 | 0] = Ie >>> 8, j[Z + 50 | 0] = Ie >>> 16, j[Z + 51 | 0] = Ie >>> 24, j[Z + 52 | 0] = Ue, j[Z + 53 | 0] = Ue >>> 8, j[Z + 54 | 0] = Ue >>> 16, j[Z + 55 | 0] = Ue >>> 24, j[Z + 40 | 0] = ae, j[Z + 41 | 0] = ae >>> 8, j[Z + 42 | 0] = ae >>> 16, j[Z + 43 | 0] = ae >>> 24, j[Z + 44 | 0] = de, j[Z + 45 | 0] = de >>> 8, j[Z + 46 | 0] = de >>> 16, j[Z + 47 | 0] = de >>> 24, j[Z + 32 | 0] = be, j[Z + 33 | 0] = be >>> 8, j[Z + 34 | 0] = be >>> 16, j[Z + 35 | 0] = be >>> 24, j[Z + 36 | 0] = L, j[Z + 37 | 0] = L >>> 8, j[Z + 38 | 0] = L >>> 16, j[Z + 39 | 0] = L >>> 24, Ro(le, 32), st = le + 192 | 0, 0;
                    }, wb: function(L, Z, le, ae, de, Ie) {
                      Z |= 0, de |= 0, Ie |= 0;
                      var Qe, q = 0;
                      return st = Qe = st - 16 | 0, ve(L |= 0, Qe + 8 | 0, Re(L - -64 | 0, le |= 0, ae |= 0), ae, de, Ie, 0), l[Qe + 8 >> 2] != 64 | l[Qe + 12 >> 2] ? (Z && (l[Z >> 2] = 0, l[Z + 4 >> 2] = 0), Rt(L, 0, ae - -64 | 0), q = -1) : Z && (l[Z >> 2] = ae - -64, l[Z + 4 >> 2] = de - ((ae >>> 0 < 4294967232) - 1 | 0)), st = Qe + 16 | 0, 0 | q;
                    }, xb: function(L, Z, le, ae, de, Ie) {
                      L |= 0, Z |= 0, le |= 0;
                      var Qe = 0;
                      e: {
                        t: {
                          if (!(!(de |= 0) & (ae |= 0) >>> 0 < 64 || (de = de - 1 | 0, !(de = (ae = ae + -64 | 0) >>> 0 < 4294967232 ? de + 1 | 0 : de) & ae >>> 0 > 4294967231 | de))) {
                            if (!gr(le, Qe = le - -64 | 0, ae, de, Ie |= 0, 0))
                              break t;
                            L && Rt(L, 0, ae);
                          }
                          if (le = -1, !Z)
                            break e;
                          l[Z >> 2] = 0, l[Z + 4 >> 2] = 0;
                          break e;
                        }
                        Z && (l[Z >> 2] = ae, l[Z + 4 >> 2] = de), le = 0, L && Re(L, Qe, ae);
                      }
                      return 0 | le;
                    }, yb: function(L, Z, le, ae, de, Ie) {
                      return ve(L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, Ie |= 0, 0), 0;
                    }, zb: function(L, Z, le, ae, de) {
                      return 0 | gr(L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, 0);
                    }, Ab: function(L) {
                      return Ds(L |= 0), 0;
                    }, Bb: function(L, Z, le, ae) {
                      return 0 | Ni(L |= 0, Z |= 0, le |= 0, ae |= 0);
                    }, Cb: function(L, Z, le, ae) {
                      var de;
                      return Z |= 0, le |= 0, ae |= 0, st = de = st + -64 | 0, Qi(L |= 0, de), L = ve(Z, le, de, 64, 0, ae, 1), st = de - -64 | 0, 0 | L;
                    }, Db: function(L, Z, le) {
                      var ae;
                      return Z |= 0, le |= 0, st = ae = st + -64 | 0, Qi(L |= 0, ae), L = gr(Z, ae, 64, 0, le, 1), st = ae - -64 | 0, 0 | L;
                    }, Eb: function(L, Z) {
                      L |= 0;
                      var le, ae = 0, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0, qt = 0, tt = 0, xt = 0, Mt = 0, Vt = 0, un = 0, gn = 0, Bn = 0, Tn = 0, Pt = 0, Dt = 0, An = 0, kn = 0, Dn = 0, De = 0, Vn = 0, Xn = 0, nr = 0, nn = 0, vn = 0, zn = 0, jn = 0, _r = 0, br = 0, kr = 0, Qr = 0, Ur = 0, Lr = 0, Jr = 0, jr = 0, oo = 0, uo = 0, _o = 0, So = 0, Ao = 0, bo = 0, xr = 0, Oo = 0, Yn = 0, ir = 0, Bt = 0, Jt = 0, mn = 0, Hr = 0, Vr = 0, ro = 0, io = 0, fo = 0, po = 0, mo = 0, ho = 0, tn = 0, Eo = 0, To = 0, Do = 0, Lo = 0, Ho = 0, Vo = 0, ri = 0, ci = 0, li = 0, mi = 0, yi = 0, Mi = 0, Fi = 0, Yi = 0;
                      if (st = le = st - 256 | 0, Vo = -1, !Os(Z |= 0) && !wa(le + 96 | 0, Z)) {
                        for (st = ae = st - 2048 | 0, qi(ot = ae + 640 | 0, Z = le + 96 | 0), de = l[Z + 8 >> 2], Qe = l[Z + 12 >> 2], Ie = l[Z + 16 >> 2], q = l[Z + 20 >> 2], Te = l[Z + 24 >> 2], Ne = l[Z + 28 >> 2], be = l[Z >> 2], Ue = l[Z + 4 >> 2], _t = l[Z + 36 >> 2], l[ae + 352 >> 2] = l[Z + 32 >> 2], l[ae + 356 >> 2] = _t, l[ae + 344 >> 2] = Te, l[ae + 348 >> 2] = Ne, l[ae + 336 >> 2] = Ie, l[ae + 340 >> 2] = q, l[ae + 328 >> 2] = de, l[ae + 332 >> 2] = Qe, l[ae + 320 >> 2] = be, l[ae + 324 >> 2] = Ue, de = l[Z + 40 >> 2], Qe = l[Z + 44 >> 2], Ie = l[Z + 48 >> 2], q = l[Z + 52 >> 2], Te = l[Z + 56 >> 2], Ne = l[Z + 60 >> 2], Ue = l[(be = Z - -64 | 0) >> 2], be = l[be + 4 >> 2], _t = l[Z + 76 >> 2], l[ae + 392 >> 2] = l[Z + 72 >> 2], l[ae + 396 >> 2] = _t, l[ae + 384 >> 2] = Ue, l[ae + 388 >> 2] = be, l[ae + 376 >> 2] = Te, l[ae + 380 >> 2] = Ne, l[ae + 368 >> 2] = Ie, l[ae + 372 >> 2] = q, l[ae + 360 >> 2] = de, l[ae + 364 >> 2] = Qe, de = l[Z + 80 >> 2], Qe = l[Z + 84 >> 2], Ie = l[Z + 88 >> 2], q = l[Z + 92 >> 2], Te = l[Z + 96 >> 2], Ne = l[Z + 100 >> 2], be = l[Z + 104 >> 2], Ue = l[Z + 108 >> 2], _t = l[Z + 116 >> 2], l[ae + 432 >> 2] = l[Z + 112 >> 2], l[ae + 436 >> 2] = _t, l[ae + 424 >> 2] = be, l[ae + 428 >> 2] = Ue, l[ae + 416 >> 2] = Te, l[ae + 420 >> 2] = Ne, l[ae + 408 >> 2] = Ie, l[ae + 412 >> 2] = q, l[ae + 400 >> 2] = de, l[ae + 404 >> 2] = Qe, Vi(Z = ae + 480 | 0, de = ae + 320 | 0), rr(be = ae + 160 | 0, Z, Qe = ae + 600 | 0), rr(ae + 200 | 0, Ie = ae + 520 | 0, q = ae + 560 | 0), rr(ae + 240 | 0, q, Qe), rr(ae + 280 | 0, Z, Ie), Ot(Z, be, ot), rr(de, Z, Qe), rr(ot = ae + 360 | 0, Ie, q), rr(Te = ae + 400 | 0, q, Qe), rr(Ne = ae + 440 | 0, Z, Ie), qi(Ue = ae + 800 | 0, de), Ot(Z, be, Ue), rr(de, Z, Qe), rr(ot, Ie, q), rr(Te, q, Qe), rr(Ne, Z, Ie), qi(Ue = ae + 960 | 0, de), Ot(Z, be, Ue), rr(de, Z, Qe), rr(ot, Ie, q), rr(Te, q, Qe), rr(Ne, Z, Ie), qi(Ue = ae + 1120 | 0, de), Ot(Z, be, Ue), rr(de, Z, Qe), rr(ot, Ie, q), rr(Te, q, Qe), rr(Ne, Z, Ie), qi(Ue = ae + 1280 | 0, de), Ot(Z, be, Ue), rr(de, Z, Qe), rr(ot, Ie, q), rr(Te, q, Qe), rr(Ne, Z, Ie), qi(Ue = ae + 1440 | 0, de), Ot(Z, be, Ue), rr(de, Z, Qe), rr(ot, Ie, q), rr(Te, q, Qe), rr(Ne, Z, Ie), qi(Ue = ae + 1600 | 0, de), Ot(Z, be, Ue), rr(de, Z, Qe), rr(ot, Ie, q), rr(Te, q, Qe), rr(Ne, Z, Ie), qi(ae + 1760 | 0, de), l[ae + 32 >> 2] = 0, l[ae + 36 >> 2] = 0, l[ae + 24 >> 2] = 0, l[ae + 28 >> 2] = 0, l[ae + 16 >> 2] = 0, l[ae + 20 >> 2] = 0, l[ae + 8 >> 2] = 0, l[ae + 12 >> 2] = 0, l[ae + 44 >> 2] = 0, l[ae + 48 >> 2] = 0, l[ae + 52 >> 2] = 0, l[ae + 56 >> 2] = 0, l[ae + 60 >> 2] = 0, l[ae + 64 >> 2] = 0, l[ae + 68 >> 2] = 0, l[ae + 72 >> 2] = 0, l[ae + 76 >> 2] = 0, l[ae + 80 >> 2] = 1, l[ae >> 2] = 0, l[ae + 4 >> 2] = 0, l[ae + 40 >> 2] = 1, Rt(ae + 84 | 0, 0, 76), Ue = ae + 120 | 0, _t = ae + 80 | 0, Vt = ae + 40 | 0, Z = 252; de = l[ae + 36 >> 2], l[ae + 1960 >> 2] = l[ae + 32 >> 2], l[ae + 1964 >> 2] = de, de = l[ae + 28 >> 2], l[ae + 1952 >> 2] = l[ae + 24 >> 2], l[ae + 1956 >> 2] = de, de = l[ae + 20 >> 2], l[ae + 1944 >> 2] = l[ae + 16 >> 2], l[ae + 1948 >> 2] = de, de = l[ae + 12 >> 2], l[ae + 1936 >> 2] = l[ae + 8 >> 2], l[ae + 1940 >> 2] = de, de = l[ae + 4 >> 2], l[ae + 1928 >> 2] = l[ae >> 2], l[ae + 1932 >> 2] = de, de = l[ae + 76 >> 2], l[ae + 2e3 >> 2] = l[ae + 72 >> 2], l[ae + 2004 >> 2] = de, de = l[ae + 68 >> 2], l[ae + 1992 >> 2] = l[ae + 64 >> 2], l[ae + 1996 >> 2] = de, de = l[ae + 60 >> 2], l[ae + 1984 >> 2] = l[ae + 56 >> 2], l[ae + 1988 >> 2] = de, de = l[ae + 52 >> 2], l[ae + 1976 >> 2] = l[ae + 48 >> 2], l[ae + 1980 >> 2] = de, de = l[ae + 44 >> 2], l[ae + 1968 >> 2] = l[ae + 40 >> 2], l[ae + 1972 >> 2] = de, de = l[ae + 84 >> 2], l[ae + 2008 >> 2] = l[ae + 80 >> 2], l[ae + 2012 >> 2] = de, de = l[ae + 92 >> 2], l[ae + 2016 >> 2] = l[ae + 88 >> 2], l[ae + 2020 >> 2] = de, de = l[ae + 100 >> 2], l[ae + 2024 >> 2] = l[ae + 96 >> 2], l[ae + 2028 >> 2] = de, de = l[ae + 108 >> 2], l[ae + 2032 >> 2] = l[ae + 104 >> 2], l[ae + 2036 >> 2] = de, de = l[ae + 116 >> 2], l[ae + 2040 >> 2] = l[ae + 112 >> 2], l[ae + 2044 >> 2] = de, de = Z, Z = j[Z + 33424 | 0], Vi(ae + 480 | 0, ae + 1928 | 0), (0 | Z) > 0 ? (rr(tt = ae + 320 | 0, be = ae + 480 | 0, Qe), rr(ot, Ie, q), rr(Te, q, Qe), rr(Ne, be, Ie), Ot(be, tt, (ae + 640 | 0) + wr((254 & Z) >>> 1 | 0, 160) | 0)) : (0 | Z) >= 0 || (rr(tt = ae + 320 | 0, be = ae + 480 | 0, Qe), rr(ot, Ie, q), rr(Te, q, Qe), rr(Ne, be, Ie), Ia(be, tt, (ae + 640 | 0) + wr((0 - Z & 254) >>> 1 | 0, 160) | 0)), rr(ae, Z = ae + 480 | 0, Qe), rr(Vt, Ie, q), rr(_t, q, Qe), rr(Ue, Z, Ie), Z = de - 1 | 0, de; )
                          ;
                        ms(Z = ae + 640 | 0, ae), Z = Ts(Z, 32), st = ae + 2048 | 0, Z && (Ie = l[le + 136 >> 2], l[le >> 2] = 1 - Ie, Vo = 0, nr = l[le + 172 >> 2], l[le + 36 >> 2] = 0 - nr, Ue = l[le + 168 >> 2], l[le + 32 >> 2] = 0 - Ue, nn = l[le + 164 >> 2], l[le + 28 >> 2] = 0 - nn, ot = l[le + 160 >> 2], l[le + 24 >> 2] = 0 - ot, vn = l[le + 156 >> 2], l[le + 20 >> 2] = 0 - vn, Te = l[le + 152 >> 2], l[le + 16 >> 2] = 0 - Te, zn = l[le + 148 >> 2], l[le + 12 >> 2] = 0 - zn, Ne = l[le + 144 >> 2], l[le + 8 >> 2] = 0 - Ne, jn = l[le + 140 >> 2], l[le + 4 >> 2] = 0 - jn, wi(le, le), Z = dt(Vt = l[le + 4 >> 2], De = Vt >> 31, un = vn << 1, Ao = un >> 31), de = Oe, ae = dt(q = l[le >> 2], Bn = q >> 31, ot, Tn = ot >> 31), de = Oe + de | 0, de = (Z = ae + Z | 0) >>> 0 < ae >>> 0 ? de + 1 | 0 : de, ae = (Qe = dt(Pt = l[le + 8 >> 2], _r = Pt >> 31, Te, Dt = Te >> 31)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z, de = ae, ae = dt(Vn = l[le + 12 >> 2], Qr = Vn >> 31, Jr = zn << 1, bo = Jr >> 31), Z = Oe + Z | 0, Z = ae >>> 0 > (de = de + ae | 0) >>> 0 ? Z + 1 | 0 : Z, ae = dt(br = l[le + 16 >> 2], jr = br >> 31, Ne, An = Ne >> 31), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, tn = Qe = l[le + 20 >> 2], be = dt(Qe, xr = Qe >> 31, oo = jn << 1, Oo = oo >> 31), ae = Oe + Z | 0, ae = (de = be + de | 0) >>> 0 < be >>> 0 ? ae + 1 | 0 : ae, Eo = xt = l[le + 24 >> 2], Z = (Ie = dt(xt, po = xt >> 31, be = Ie + 1 | 0, kn = be >> 31)) + de | 0, de = Oe + ae | 0, de = Z >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Yn = l[le + 28 >> 2], ae = (Ie = dt(We = wr(Yn, 19), Ur = We >> 31, uo = nr << 1, ir = uo >> 31)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, de = ae, ri = l[le + 32 >> 2], ae = dt(tt = wr(ri, 19), kr = tt >> 31, Ue, Dn = Ue >> 31), Z = Oe + Z | 0, Z = ae >>> 0 > (de = de + ae | 0) >>> 0 ? Z + 1 | 0 : Z, ci = l[le + 36 >> 2], ae = dt(_t = wr(ci, 19), Xn = _t >> 31, _o = nn << 1, Bt = _o >> 31), Z = Oe + Z | 0, rt = de = ae + de | 0, Ie = ae >>> 0 > de >>> 0 ? Z + 1 | 0 : Z, Z = dt(Te, Dt, Vt, De), de = Oe, Ye = dt(q, Bn, vn, Jt = vn >> 31), ae = Oe + de | 0, ae = (Z = Ye + Z | 0) >>> 0 < Ye >>> 0 ? ae + 1 | 0 : ae, Ye = dt(Pt, _r, zn, mn = zn >> 31), de = Oe + ae | 0, de = (Z = Ye + Z | 0) >>> 0 < Ye >>> 0 ? de + 1 | 0 : de, ae = (Ye = dt(Ne, An, Vn, Qr)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < Ye >>> 0 ? Z + 1 | 0 : Z, de = ae, ae = dt(br, jr, jn, Hr = jn >> 31), Z = Oe + Z | 0, Z = ae >>> 0 > (de = de + ae | 0) >>> 0 ? Z + 1 | 0 : Z, ae = dt(be, kn, Qe, xr), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, Ye = dt(xt = wr(xt, 19), So = xt >> 31, nr, Vr = nr >> 31), ae = Oe + Z | 0, ae = (de = Ye + de | 0) >>> 0 < Ye >>> 0 ? ae + 1 | 0 : ae, Z = (Ye = dt(Ue, Dn, We, Ur)) + de | 0, de = Oe + ae | 0, de = Z >>> 0 < Ye >>> 0 ? de + 1 | 0 : de, ae = (Ye = dt(tt, kr, nn, ro = nn >> 31)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < Ye >>> 0 ? Z + 1 | 0 : Z, de = ae, ae = dt(ot, Tn, _t, Xn), Z = Oe + Z | 0, To = de = de + ae | 0, Lr = ae >>> 0 > de >>> 0 ? Z + 1 | 0 : Z, Z = dt(Vt, De, Jr, bo), ae = Oe, de = (Ye = dt(q, Bn, Te, Dt)) + Z | 0, Z = Oe + ae | 0, Z = de >>> 0 < Ye >>> 0 ? Z + 1 | 0 : Z, Ye = dt(Ne, An, Pt, _r), ae = Oe + Z | 0, ae = (de = Ye + de | 0) >>> 0 < Ye >>> 0 ? ae + 1 | 0 : ae, Z = (Ye = dt(Vn, Qr, oo, Oo)) + de | 0, de = Oe + ae | 0, de = Z >>> 0 < Ye >>> 0 ? de + 1 | 0 : de, ae = (Ye = dt(be, kn, br, jr)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < Ye >>> 0 ? Z + 1 | 0 : Z, de = ae, ae = dt(Ye = wr(Qe, 19), io = Ye >> 31, uo, ir), Z = Oe + Z | 0, Z = ae >>> 0 > (de = de + ae | 0) >>> 0 ? Z + 1 | 0 : Z, ae = dt(Ue, Dn, xt, So), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, Qe = dt(We, Ur, _o, Bt), ae = Oe + Z | 0, ae = (de = Qe + de | 0) >>> 0 < Qe >>> 0 ? ae + 1 | 0 : ae, Z = (Qe = dt(ot, Tn, tt, kr)) + de | 0, de = Oe + ae | 0, de = Z >>> 0 < Qe >>> 0 ? de + 1 | 0 : de, ae = (Qe = dt(_t, Xn, un, Ao)) + Z | 0, Z = Oe + de | 0, li = ae, mi = Z = ae >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z, yi = ae = ae + 33554432 | 0, Mi = Z = ae >>> 0 < 33554432 ? Z + 1 | 0 : Z, ae = (67108863 & Z) << 6 | ae >>> 26, Z = (Z >> 26) + Lr | 0, To = Qe = ae + To | 0, ae = Z = ae >>> 0 > Qe >>> 0 ? Z + 1 | 0 : Z, Fi = Z = Qe + 16777216 | 0, Qe = (33554431 & (ae = Z >>> 0 < 16777216 ? ae + 1 | 0 : ae)) << 7 | Z >>> 25, Z = (de = ae >> 25) + Ie | 0, Z = (ae = Qe + rt | 0) >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z, Do = de = ae + 33554432 | 0, Qe = Z = de >>> 0 < 33554432 ? Z + 1 | 0 : Z, l[le + 72 >> 2] = ae - (-67108864 & de), Z = dt(Vt, De, oo, Oo), de = Oe, Ie = dt(q, Bn, Ne, An), ae = Oe + de | 0, ae = (Z = Ie + Z | 0) >>> 0 < Ie >>> 0 ? ae + 1 | 0 : ae, de = (Ie = dt(be, kn, Pt, _r)) + Z | 0, Z = Oe + ae | 0, Z = de >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, ae = dt(Ie = wr(Vn, 19), fo = Ie >> 31, uo, ir), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, ae = (rt = dt(Lr = wr(br, 19), mo = Lr >> 31, Ue, Dn)) + de | 0, de = Oe + Z | 0, de = ae >>> 0 < rt >>> 0 ? de + 1 | 0 : de, rt = dt(_o, Bt, Ye, io), Z = Oe + de | 0, Z = (ae = rt + ae | 0) >>> 0 < rt >>> 0 ? Z + 1 | 0 : Z, de = (rt = dt(ot, Tn, xt, So)) + ae | 0, ae = Oe + Z | 0, ae = de >>> 0 < rt >>> 0 ? ae + 1 | 0 : ae, rt = dt(We, Ur, un, Ao), Z = Oe + ae | 0, Z = (de = rt + de | 0) >>> 0 < rt >>> 0 ? Z + 1 | 0 : Z, ae = dt(Te, Dt, tt, kr), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, ae = (rt = dt(_t, Xn, Jr, bo)) + de | 0, de = Oe + Z | 0, Mt = ae, Lo = ae >>> 0 < rt >>> 0 ? de + 1 | 0 : de, Z = dt(be, kn, Vt, De), de = Oe, ae = (rt = dt(q, Bn, jn, Hr)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < rt >>> 0 ? Z + 1 | 0 : Z, rt = de = wr(Pt, 19), de = (qt = dt(de, ho = de >> 31, nr, Vr)) + ae | 0, ae = Oe + Z | 0, ae = de >>> 0 < qt >>> 0 ? ae + 1 | 0 : ae, qt = dt(Ue, Dn, Ie, fo), Z = Oe + ae | 0, Z = (de = qt + de | 0) >>> 0 < qt >>> 0 ? Z + 1 | 0 : Z, ae = dt(Lr, mo, nn, ro), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, ae = (qt = dt(ot, Tn, Ye, io)) + de | 0, de = Oe + Z | 0, de = ae >>> 0 < qt >>> 0 ? de + 1 | 0 : de, qt = dt(xt, So, vn, Jt), Z = Oe + de | 0, Z = (ae = qt + ae | 0) >>> 0 < qt >>> 0 ? Z + 1 | 0 : Z, de = (qt = dt(Te, Dt, We, Ur)) + ae | 0, ae = Oe + Z | 0, ae = de >>> 0 < qt >>> 0 ? ae + 1 | 0 : ae, qt = dt(tt, kr, zn, mn), Z = Oe + ae | 0, Z = (de = qt + de | 0) >>> 0 < qt >>> 0 ? Z + 1 | 0 : Z, ae = dt(Ne, An, _t, Xn), Z = Oe + Z | 0, Ho = de = ae + de | 0, qt = ae >>> 0 > de >>> 0 ? Z + 1 | 0 : Z, Z = dt(Z = wr(Vt, 19), Z >> 31, uo, ir), de = Oe, ae = dt(q, Bn, be, kn), de = Oe + de | 0, de = (Z = ae + Z | 0) >>> 0 < ae >>> 0 ? de + 1 | 0 : de, ae = (rt = dt(Ue, Dn, rt, ho)) + Z | 0, Z = Oe + de | 0, de = (Ie = dt(Ie, fo, _o, Bt)) + ae | 0, ae = Oe + (ae >>> 0 < rt >>> 0 ? Z + 1 | 0 : Z) | 0, ae = de >>> 0 < Ie >>> 0 ? ae + 1 | 0 : ae, Ie = dt(ot, Tn, Lr, mo), Z = Oe + ae | 0, Z = (de = Ie + de | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, ae = dt(un, Ao, Ye, io), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, ae = (Ie = dt(Te, Dt, xt, So)) + de | 0, de = Oe + Z | 0, de = ae >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = dt(We, Ur, Jr, bo), Z = Oe + de | 0, Z = (ae = Ie + ae | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, de = (Ie = dt(Ne, An, tt, kr)) + ae | 0, ae = Oe + Z | 0, ae = de >>> 0 < Ie >>> 0 ? ae + 1 | 0 : ae, Ie = dt(_t, Xn, oo, Oo), Z = Oe + ae | 0, rt = de = Ie + de | 0, fo = Z = de >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, ho = de = de + 33554432 | 0, Yi = Z = de >>> 0 < 33554432 ? Z + 1 | 0 : Z, ae = Z >> 26, Z = (67108863 & Z) << 6 | de >>> 26, de = ae + qt | 0, qt = Ie = Z + Ho | 0, Z = de = Z >>> 0 > Ie >>> 0 ? de + 1 | 0 : de, Ho = de = Ie + 16777216 | 0, Ie = (33554431 & (Z = de >>> 0 < 16777216 ? Z + 1 | 0 : Z)) << 7 | de >>> 25, Z = (Z >> 25) + Lo | 0, Z = (de = Ie + Mt | 0) >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Lo = de = (ae = de) + 33554432 | 0, Ie = Z = de >>> 0 < 33554432 ? Z + 1 | 0 : Z, l[le + 56 >> 2] = ae - (-67108864 & de), Z = dt(ot, Tn, Vt, De), ae = Oe, de = (Mt = dt(q, Bn, nn, ro)) + Z | 0, Z = Oe + ae | 0, Z = de >>> 0 < Mt >>> 0 ? Z + 1 | 0 : Z, ae = dt(Pt, _r, vn, Jt), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, ae = dt(Te, Dt, Vn, Qr), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, Mt = dt(br, jr, zn, mn), ae = Oe + Z | 0, ae = (de = Mt + de | 0) >>> 0 < Mt >>> 0 ? ae + 1 | 0 : ae, Z = (Mt = dt(Ne, An, tn, xr)) + de | 0, de = Oe + ae | 0, de = Z >>> 0 < Mt >>> 0 ? de + 1 | 0 : de, ae = (Mt = dt(jn, Hr, Eo, po)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < Mt >>> 0 ? Z + 1 | 0 : Z, de = ae, ae = dt(Yn, Mt = Yn >> 31, be, kn), Z = Oe + Z | 0, Z = ae >>> 0 > (de = de + ae | 0) >>> 0 ? Z + 1 | 0 : Z, ae = dt(tt, kr, nr, Vr), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, gn = (ae = de) + (de = dt(_t, Xn, Ue, Dn)) | 0, ae = Oe + Z | 0, de = (Z = Qe >> 26) + (de = de >>> 0 > gn >>> 0 ? ae + 1 | 0 : ae) | 0, Z = (ae = (Qe = (67108863 & Qe) << 6 | Do >>> 26) + gn | 0) >>> 0 < Qe >>> 0 ? de + 1 | 0 : de, Do = de = ae + 16777216 | 0, Qe = Z = de >>> 0 < 16777216 ? Z + 1 | 0 : Z, l[le + 76 >> 2] = ae - (-33554432 & de), Z = dt(Ne, An, Vt, De), de = Oe, gn = dt(q, Bn, zn, mn), ae = Oe + de | 0, ae = (Z = gn + Z | 0) >>> 0 < gn >>> 0 ? ae + 1 | 0 : ae, gn = dt(Pt, _r, jn, Hr), de = Oe + ae | 0, de = (Z = gn + Z | 0) >>> 0 < gn >>> 0 ? de + 1 | 0 : de, ae = (gn = dt(be, kn, Vn, Qr)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < gn >>> 0 ? Z + 1 | 0 : Z, de = ae, ae = dt(Lr, mo, nr, Vr), Z = Oe + Z | 0, Z = ae >>> 0 > (de = de + ae | 0) >>> 0 ? Z + 1 | 0 : Z, ae = dt(Ue, Dn, Ye, io), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, de = (xt = dt(xt, So, nn, ro)) + de | 0, ae = Oe + Z | 0, Z = (We = dt(ot, Tn, We, Ur)) + de | 0, de = Oe + (de >>> 0 < xt >>> 0 ? ae + 1 | 0 : ae) | 0, ae = (tt = dt(tt, kr, vn, Jt)) + Z | 0, Z = Oe + (Z >>> 0 < We >>> 0 ? de + 1 | 0 : de) | 0, Z = ae >>> 0 < tt >>> 0 ? Z + 1 | 0 : Z, de = ae, ae = dt(Te, Dt, _t, Xn), Z = Oe + Z | 0, We = de = de + ae | 0, Z = (Z = ae >>> 0 > de >>> 0 ? Z + 1 | 0 : Z) + (de = Ie >> 26) | 0, ae = (de = Ie = We + (ae = (67108863 & Ie) << 6 | Lo >>> 26) | 0) >>> 0 < ae >>> 0 ? Z + 1 | 0 : Z, tt = Z = de + 16777216 | 0, Ie = ae = Z >>> 0 < 16777216 ? ae + 1 | 0 : ae, l[le + 60 >> 2] = de - (-33554432 & Z), Z = dt(Vt, De, _o, Bt), ae = Oe, de = (We = dt(q, Bn, Ue, Dn)) + Z | 0, Z = Oe + ae | 0, Z = de >>> 0 < We >>> 0 ? Z + 1 | 0 : Z, ae = dt(ot, Tn, Pt, _r), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, We = dt(Vn, Qr, un, Ao), ae = Oe + Z | 0, ae = (de = We + de | 0) >>> 0 < We >>> 0 ? ae + 1 | 0 : ae, Z = (We = dt(Te, Dt, br, jr)) + de | 0, de = Oe + ae | 0, de = Z >>> 0 < We >>> 0 ? de + 1 | 0 : de, ae = (We = dt(Jr, bo, tn, xr)) + Z | 0, Z = Oe + de | 0, Z = ae >>> 0 < We >>> 0 ? Z + 1 | 0 : Z, de = ae, ae = dt(Ne, An, Eo, po), Z = Oe + Z | 0, Z = ae >>> 0 > (de = de + ae | 0) >>> 0 ? Z + 1 | 0 : Z, ae = de, de = dt(Yn, Mt, oo, Oo), Z = Oe + Z | 0, Z = (ae = ae + de | 0) >>> 0 < de >>> 0 ? Z + 1 | 0 : Z, We = de = ri, de = (un = dt(de, xt = de >> 31, be, kn)) + ae | 0, ae = Oe + Z | 0, Z = (_t = dt(_t, Xn, uo, ir)) + de | 0, de = Oe + (de >>> 0 < un >>> 0 ? ae + 1 | 0 : ae) | 0, ae = Z >>> 0 < _t >>> 0 ? de + 1 | 0 : de, de = Z, Z = (Z = Qe >> 25) + ae | 0, Z = (de = de + (Qe = (33554431 & Qe) << 7 | Do >>> 25) | 0) >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z, _t = de = (ae = de) + 33554432 | 0, Qe = Z = de >>> 0 < 33554432 ? Z + 1 | 0 : Z, l[le + 80 >> 2] = ae - (-67108864 & de), de = Ie >> 25, ae = (Ie = (33554431 & Ie) << 7 | tt >>> 25) + (li - (Z = -67108864 & yi) | 0) | 0, Z = de + (mi - ((Z >>> 0 > li >>> 0) + Mi | 0) | 0) | 0, Z = ae >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, Ie = Z = (67108863 & (Z = (de = ae + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z)) << 6 | de >>> 26, Z = Z + (un = To - (-33554432 & Fi) | 0) | 0, l[le + 68 >> 2] = Z, l[le + 64 >> 2] = ae - (-67108864 & de), Z = dt(Ue, Dn, Vt, De), ae = Oe, de = (Ie = dt(q, Bn, nr, Vr)) + Z | 0, Z = Oe + ae | 0, Z = de >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, ae = (Ie = dt(Pt, _r, nn, ro)) + de | 0, de = Oe + Z | 0, de = ae >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Z = (Ie = dt(ot, Tn, Vn, Qr)) + ae | 0, ae = Oe + de | 0, ae = Z >>> 0 < Ie >>> 0 ? ae + 1 | 0 : ae, de = (Ie = dt(br, jr, vn, Jt)) + Z | 0, Z = Oe + ae | 0, Z = de >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z, ae = dt(Te, Dt, tn, xr), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, ae = dt(zn, mn, Eo, po), Z = Oe + Z | 0, Z = ae >>> 0 > (de = ae + de | 0) >>> 0 ? Z + 1 | 0 : Z, ae = (Ie = dt(Ne, An, Yn, Mt)) + de | 0, de = Oe + Z | 0, de = ae >>> 0 < Ie >>> 0 ? de + 1 | 0 : de, Ie = (Z = dt(We, xt, jn, Hr)) + ae | 0, ae = Oe + de | 0, ae = Z >>> 0 > Ie >>> 0 ? ae + 1 | 0 : ae, de = Ie, Ie = dt(Z = ci, Z >> 31, be, kn), Z = Oe + ae | 0, ae = de = de + Ie | 0, Z = (Z = de >>> 0 < Ie >>> 0 ? Z + 1 | 0 : Z) + (de = Qe >> 26) | 0, Z = (ae = ae + (Qe = (67108863 & Qe) << 6 | _t >>> 26) | 0) >>> 0 < Qe >>> 0 ? Z + 1 | 0 : Z, Z = (de = ae + 16777216 | 0) >>> 0 < 16777216 ? Z + 1 | 0 : Z, l[le + 84 >> 2] = ae - (-33554432 & de), Qe = qt - (-33554432 & Ho) | 0, Ie = rt - (ae = -67108864 & ho) | 0, q = fo - ((ae >>> 0 > rt >>> 0) + Yi | 0) | 0, Z = dt((33554431 & (ae = Z)) << 7 | de >>> 25, Z = ae >> 25, 19, 0), de = Oe + q | 0, Z = Z >>> 0 > (ae = Z + Ie | 0) >>> 0 ? de + 1 | 0 : de, Ie = Z = (67108863 & (Z = (de = ae + 33554432 | 0) >>> 0 < 33554432 ? Z + 1 | 0 : Z)) << 6 | de >>> 26, Z = Z + Qe | 0, l[le + 52 >> 2] = Z, l[le + 48 >> 2] = ae - (-67108864 & de), ms(L, le + 48 | 0));
                      }
                      return st = le + 256 | 0, 0 | Vo;
                    }, Fb: function(L, Z) {
                      L |= 0;
                      var le, ae = 0;
                      return st = le = st + -64 | 0, Si(le, Z |= 0, 32, 0), j[0 | le] = 248 & B[0 | le], j[le + 31 | 0] = 63 & B[le + 31 | 0] | 64, Z = l[le + 20 >> 2], ae = l[le + 16 >> 2], j[L + 16 | 0] = ae, j[L + 17 | 0] = ae >>> 8, j[L + 18 | 0] = ae >>> 16, j[L + 19 | 0] = ae >>> 24, j[L + 20 | 0] = Z, j[L + 21 | 0] = Z >>> 8, j[L + 22 | 0] = Z >>> 16, j[L + 23 | 0] = Z >>> 24, Z = l[le + 12 >> 2], ae = l[le + 8 >> 2], j[L + 8 | 0] = ae, j[L + 9 | 0] = ae >>> 8, j[L + 10 | 0] = ae >>> 16, j[L + 11 | 0] = ae >>> 24, j[L + 12 | 0] = Z, j[L + 13 | 0] = Z >>> 8, j[L + 14 | 0] = Z >>> 16, j[L + 15 | 0] = Z >>> 24, Z = l[le + 4 >> 2], ae = l[le >> 2], j[0 | L] = ae, j[L + 1 | 0] = ae >>> 8, j[L + 2 | 0] = ae >>> 16, j[L + 3 | 0] = ae >>> 24, j[L + 4 | 0] = Z, j[L + 5 | 0] = Z >>> 8, j[L + 6 | 0] = Z >>> 16, j[L + 7 | 0] = Z >>> 24, Z = l[le + 28 >> 2], ae = l[le + 24 >> 2], j[L + 24 | 0] = ae, j[L + 25 | 0] = ae >>> 8, j[L + 26 | 0] = ae >>> 16, j[L + 27 | 0] = ae >>> 24, j[L + 28 | 0] = Z, j[L + 29 | 0] = Z >>> 8, j[L + 30 | 0] = Z >>> 16, j[L + 31 | 0] = Z >>> 24, Ro(le, 64), st = le - -64 | 0, 0;
                    }, Gb: function() {
                      var L, Z;
                      return st = L = st - 16 | 0, j[L + 15 | 0] = 0, Z = 0 | ks(34904, L + 15 | 0, 0), st = L + 16 | 0, 0 | Z;
                    }, Hb: to, Ib: function(L) {
                      var Z, le = 0, ae = 0;
                      if (st = Z = st - 16 | 0, (L |= 0) >>> 0 >= 2) {
                        for (le = (0 - L >>> 0) % (L >>> 0) | 0; j[Z + 15 | 0] = 0, le >>> 0 > (ae = 0 | ks(34904, Z + 15 | 0, 0)) >>> 0; )
                          ;
                        le = (ae >>> 0) % (L >>> 0) | 0;
                      }
                      return st = Z + 16 | 0, 0 | le;
                    }, Jb: Se, Kb: function(L, Z, le) {
                      ls(L |= 0, Z |= 0, 1024, le |= 0);
                    }, Lb: $i, Mb: function() {
                      var L = 0, Z = 0;
                      return (L = l[9048]) && (L = l[L + 20 >> 2]) && (Z = 0 | Ki[0 | L]()), 0 | Z;
                    }, Nb: function(L, Z, le) {
                      L |= 0, Z |= 0;
                      var ae, de = 0, Ie = 0, Qe = 0;
                      if (st = ae = st - 16 | 0, le |= 0)
                        Hs(1240, 1100, 197, 1036), Xr();
                      else {
                        if (Z)
                          for (; j[ae + 15 | 0] = 0, Ie = L + de | 0, Qe = 0 | ks(34904, ae + 15 | 0, 0), j[0 | Ie] = Qe, (0 | Z) != (0 | (de = de + 1 | 0)); )
                            ;
                        st = ae + 16 | 0;
                      }
                    }, Ob: function(L, Z, le, ae) {
                      L |= 0, le |= 0;
                      var de = 0, Ie = 0, Qe = 0;
                      if (!((ae |= 0) >>> 0 > 2147483646 | ae << 1 >>> 0 >= (Z |= 0) >>> 0)) {
                        if (Z = 0, ae) {
                          for (; de = (Z << 1) + L | 0, Ie = 15 & (Qe = B[Z + le | 0]), j[de + 1 | 0] = 22272 + ((Ie << 8) + (Ie + 65526 & 55552) | 0) >>> 8, Ie = de, de = Qe >>> 4 | 0, j[0 | Ie] = 87 + ((de + 65526 >>> 8 & 217) + de | 0), (0 | ae) != (0 | (Z = Z + 1 | 0)); )
                            ;
                          Z = ae << 1;
                        } else
                          Z = 0;
                        return j[Z + L | 0] = 0, 0 | L;
                      }
                      Ko(), Xr();
                    }, Pb: function(L, Z, le, ae, de, Ie, Qe) {
                      L |= 0, Z |= 0, le |= 0, de |= 0, Ie |= 0, Qe |= 0;
                      var q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0, _t = 0;
                      e:
                        if (ae |= 0) {
                          t: {
                            n: {
                              r: {
                                s: {
                                  if (!de) {
                                    for (be = 1, de = 0; ; ) {
                                      if (!(255 & ((We = (65526 + (Ue = (223 & (Te = B[le + q | 0])) - 55 & 255) ^ Ue + 65520) >>> 8 | 0) | (rt = 65526 + (Te ^= 48) >>> 8 | 0))))
                                        break r;
                                      if (Z >>> 0 <= Ne >>> 0)
                                        break s;
                                      if (Ue = Ue & We | Te & rt, 255 & Ye ? (j[L + Ne | 0] = de | Ue, Ne = Ne + 1 | 0) : de = Ue << 4, Ye ^= -1, (0 | (q = q + 1 | 0)) == (0 | ae))
                                        break;
                                    }
                                    q = ae;
                                    break r;
                                  }
                                  for (; ; ) {
                                    u: {
                                      a: {
                                        d: {
                                          o: {
                                            i: {
                                              if (!(255 & ((Te = (65526 + (Ue = (223 & (be = B[le + q | 0])) - 55 & 255) ^ Ue + 65520) >>> 8 | 0) | (rt = 65526 + (We = 48 ^ be) >>> 8 | 0)))) {
                                                if (255 & Ye)
                                                  break n;
                                                if (!Gs(de, be))
                                                  break e;
                                                if ((q = Ye = q + 1 | 0) >>> 0 < ae >>> 0)
                                                  break i;
                                                break e;
                                              }
                                              if (Z >>> 0 <= Ne >>> 0)
                                                break s;
                                              if (be = Ue & Te | We & rt, !(255 & Ye))
                                                break o;
                                              j[L + Ne | 0] = be | _t, Ne = Ne + 1 | 0;
                                              break u;
                                            }
                                            for (; ; ) {
                                              if (!(255 & ((Te = (65526 + (Ue = (223 & (be = B[le + q | 0])) - 55 & 255) ^ Ue + 65520) >>> 8 | 0) | (rt = 65526 + (We = 48 ^ be) >>> 8 | 0)))) {
                                                if (!Gs(de, be))
                                                  break e;
                                                if ((q = q + 1 | 0) >>> 0 < ae >>> 0)
                                                  continue;
                                                break d;
                                              }
                                              break;
                                            }
                                            if (Z >>> 0 <= Ne >>> 0)
                                              break a;
                                            be = Ue & Te | We & rt;
                                          }
                                          _t = be << 4, Ye = 0;
                                          break u;
                                        }
                                        q = ae >>> 0 > Ye >>> 0 ? ae : Ye;
                                        break e;
                                      }
                                      Ye = 0;
                                      break s;
                                    }
                                    if (Ye ^= -1, be = 1, !((q = q + 1 | 0) >>> 0 < ae >>> 0))
                                      break;
                                  }
                                  break r;
                                }
                                l[8916] = 68, be = 0;
                              }
                              if (!(255 & Ye))
                                break t;
                            }
                            l[8916] = 28, ot = -1, q = q - 1 | 0, Ne = 0;
                            break e;
                          }
                          be || (Ne = 0, ot = -1);
                        }
                      return Qe ? l[Qe >> 2] = le + q : (0 | ae) != (0 | q) && (l[8916] = 28, ot = -1), Ie && (l[Ie >> 2] = Ne), 0 | ot;
                    }, Qb: function(L, Z) {
                      L |= 0;
                      var le = 0;
                      return (-7 & (Z |= 0)) != 1 && (Ko(), Xr()), 1 + ((3 & (le = (le = L) + wr(L = (L >>> 0) / 3 | 0, -3) | 0) ? 2 & Z ? le + 1 | 0 : 4 : 0) + (L << 2) | 0) | 0;
                    }, Rb: function(L, Z, le, ae, de) {
                      L |= 0, Z |= 0, le |= 0, ae |= 0;
                      var Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0;
                      e: {
                        t: {
                          n: {
                            if ((-7 & (de |= 0)) == 1 && (be = (Ie = (ae >>> 0) / 3 | 0) << 2, (Ie = wr(Ie, -3) + ae | 0) && (be = 2 & de ? (2 | be) + (Ie >>> 1 | 0) | 0 : be + 4 | 0), !(Z >>> 0 <= be >>> 0))) {
                              if (!(4 & de)) {
                                if (Ie = 0, !ae)
                                  break e;
                                break n;
                              }
                              if (Ie = 0, !ae)
                                break e;
                              for (; ; ) {
                                for (Ye = (Ne = B[le + Te | 0]) | Ye << 8, Ue = Ie, Ie = 1 + ((((q |= 8) - 6 >>> 0) / 6 | 0) + Ie | 0) | 0; We = 65510 + (Qe = Ye >>> (q = (de = q) - 6 | 0) & 63) >>> 8 | 0, rt = Qe + 65484 >>> 8 | 0, j[L + Ue | 0] = (1 + (16321 ^ Qe) ^ -1) >>> 8 & 45 | Qe + 252 & Qe + 65474 >>> 8 & (-1 ^ rt) | (Qe + 32705 ^ -1) >>> 8 & 95 | We & Qe + 65 | rt & Qe + 71 & (-1 ^ We), (0 | (Ue = Ue + 1 | 0)) != (0 | Ie); )
                                  ;
                                if ((0 | (Te = Te + 1 | 0)) == (0 | ae))
                                  break;
                              }
                              if (!q)
                                break e;
                              Ue = (ae = 65510 + (le = Ne << 12 - de & 63) >>> 8 | 0) & le + 65, Ye = le + 252 & le + 65474 >>> 8 & (-1 ^ (de = le + 65484 >>> 8 | 0)), q = de & le + 71 & (-1 ^ ae), ae = le + 32705 | 0, de = (1 + (16321 ^ le) ^ -1) >>> 8 & 45, le = 95;
                              break t;
                            }
                            Ko(), Xr();
                          }
                          for (; ; ) {
                            for (Ye = (Ne = B[le + Te | 0]) | Ye << 8, Ue = Ie, Ie = 1 + ((((q |= 8) - 6 >>> 0) / 6 | 0) + Ie | 0) | 0; We = 65510 + (Qe = Ye >>> (q = (de = q) - 6 | 0) & 63) >>> 8 | 0, rt = Qe + 65484 >>> 8 | 0, j[L + Ue | 0] = (1 + (16321 ^ Qe) ^ -1) >>> 8 & 43 | Qe + 252 & Qe + 65474 >>> 8 & (-1 ^ rt) | (Qe + 16321 ^ -1) >>> 8 & 47 | We & Qe + 65 | rt & Qe + 71 & (-1 ^ We), (0 | (Ue = Ue + 1 | 0)) != (0 | Ie); )
                              ;
                            if ((0 | (Te = Te + 1 | 0)) == (0 | ae))
                              break;
                          }
                          if (!q)
                            break e;
                          Ue = (ae = 65510 + (le = Ne << 12 - de & 63) >>> 8 | 0) & le + 65, Ye = le + 252 & le + 65474 >>> 8 & (-1 ^ (de = le + 65484 >>> 8 | 0)), q = de & le + 71 & (-1 ^ ae), ae = le + 16321 | 0, de = (1 + (16321 ^ le) ^ -1) >>> 8 & 43, le = 47;
                        }
                        j[L + Ie | 0] = le & (-1 ^ ae) >>> 8 | Ue | Ye | de | q, Ie = Ie + 1 | 0;
                      }
                      e: {
                        t: {
                          if (Ie >>> 0 <= be >>> 0) {
                            if (Ie >>> 0 < be >>> 0)
                              break t;
                            be = Ie;
                            break e;
                          }
                          Hs(1048, 1126, 230, 1319), Xr();
                        }
                        Rt(L + Ie | 0, 61, be - Ie | 0);
                      }
                      return Rt(L + be | 0, 0, (Z >>> 0 > (le = be + 1 | 0) >>> 0 ? Z : le) - be | 0), 0 | L;
                    }, Sb: function(L, Z, le, ae, de, Ie, Qe, q) {
                      L |= 0, Z |= 0, le |= 0, ae |= 0, de |= 0, Ie |= 0, Qe |= 0;
                      var be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0, rt = 0, ot = 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              s: {
                                u: {
                                  a: {
                                    d: {
                                      o: {
                                        i: {
                                          c: {
                                            if ((-7 & (q |= 0)) == 1) {
                                              if (Ye = 0, !ae)
                                                break d;
                                              if (4 & q)
                                                break c;
                                              for (; ; ) {
                                                Ye = Ue;
                                                l: {
                                                  f: {
                                                    p: {
                                                      m: {
                                                        for (; ; ) {
                                                          if (be = (be = (Te = j[le + Ye | 0]) - 65 | 0) & ((90 - Te ^ -1) & (-1 ^ be)) >>> 8 & 255 | Te + 4 & ((Te + 65488 ^ -1) & (57 - Te ^ -1)) >>> 8 & 255 | Te + 185 & ((Te + 65439 ^ -1) & (122 - Te ^ -1)) >>> 8 & 255 | (1 + (16336 ^ Te) ^ -1) >>> 8 & 63 | (1 + (16340 ^ Te) ^ -1) >>> 8 & 62, (0 | (be |= (be - 1 & 1 + (65470 ^ Te)) >>> 8 & 255)) != 255)
                                                            break m;
                                                          if (be = 0, !de)
                                                            break o;
                                                          if (!Gs(de, Te))
                                                            break;
                                                          if ((Ye = Ye + 1 | 0) >>> 0 >= ae >>> 0)
                                                            break p;
                                                        }
                                                        Ue = Ye;
                                                        break o;
                                                      }
                                                      if (rt = be + (rt << 6) | 0, Ne >>> 0 > 1)
                                                        break f;
                                                      Ne = Ne + 6 | 0;
                                                      break l;
                                                    }
                                                    Ue = (L = Ue + 1 | 0) >>> 0 < ae >>> 0 ? ae : L;
                                                    break o;
                                                  }
                                                  if (Ne = Ne - 2 | 0, Z >>> 0 <= We >>> 0)
                                                    break i;
                                                  j[L + We | 0] = rt >>> Ne, We = We + 1 | 0;
                                                }
                                                if (be = 0, !((Ue = Ye + 1 | 0) >>> 0 < ae >>> 0))
                                                  break;
                                              }
                                              break o;
                                            }
                                            Ko(), Xr();
                                          }
                                          c:
                                            for (; ; ) {
                                              for (Ye = Ue; ; ) {
                                                l: {
                                                  if (be = (be = (Te = j[le + Ye | 0]) - 65 | 0) & ((90 - Te ^ -1) & (-1 ^ be)) >>> 8 & 255 | Te + 4 & ((Te + 65488 ^ -1) & (57 - Te ^ -1)) >>> 8 & 255 | Te + 185 & ((Te + 65439 ^ -1) & (122 - Te ^ -1)) >>> 8 & 255 | (1 + (16288 ^ Te) ^ -1) >>> 8 & 63 | (1 + (16338 ^ Te) ^ -1) >>> 8 & 62, (0 | (be |= (be - 1 & 1 + (65470 ^ Te)) >>> 8 & 255)) == 255) {
                                                    if (be = 0, !de)
                                                      break o;
                                                    if (Gs(de, Te))
                                                      break l;
                                                    Ue = Ye;
                                                    break o;
                                                  }
                                                  if (rt = be + (rt << 6) | 0, Ne >>> 0 < 2)
                                                    Ne = Ne + 6 | 0;
                                                  else {
                                                    if (Ne = Ne - 2 | 0, Z >>> 0 <= We >>> 0)
                                                      break i;
                                                    j[L + We | 0] = rt >>> Ne, We = We + 1 | 0;
                                                  }
                                                  if (be = 0, (Ue = Ye + 1 | 0) >>> 0 < ae >>> 0)
                                                    continue c;
                                                  break o;
                                                }
                                                if (!((Ye = Ye + 1 | 0) >>> 0 < ae >>> 0))
                                                  break;
                                              }
                                              break;
                                            }
                                          Ue = (L = Ue + 1 | 0) >>> 0 < ae >>> 0 ? ae : L;
                                          break o;
                                        }
                                        Ue = Ye, l[8916] = 68, be = 1;
                                      }
                                      if (Ne >>> 0 > 4)
                                        break a;
                                      Ye = Ue;
                                    }
                                    if (L = Ye, Z = -1, be) {
                                      Ue = L;
                                      break e;
                                    }
                                    if ((-1 << Ne ^ -1) & rt) {
                                      Ue = L;
                                      break e;
                                    }
                                    if (2 & q) {
                                      q = L;
                                      break s;
                                    }
                                    if (Ne >>> 0 < 2) {
                                      q = L;
                                      break s;
                                    }
                                    if (Ue = L >>> 0 > ae >>> 0 ? L : ae, Ye = Ne >>> 1 | 0, !de)
                                      break u;
                                    for (q = L; ; ) {
                                      if ((0 | q) == (0 | Ue)) {
                                        be = 68;
                                        break r;
                                      }
                                      if ((0 | (L = j[le + q | 0])) != 61) {
                                        if (!Gs(de, L)) {
                                          be = 28, Ue = q;
                                          break r;
                                        }
                                      } else
                                        Ye = Ye - 1 | 0;
                                      if (q = q + 1 | 0, !Ye)
                                        break;
                                    }
                                    break s;
                                  }
                                  Z = -1;
                                  break e;
                                }
                                if (be = 68, L >>> 0 >= ae >>> 0)
                                  break r;
                                if (B[L + le | 0] != 61) {
                                  Ue = L, be = 28;
                                  break r;
                                }
                                if (q = L + Ye | 0, (0 | Ye) != 1) {
                                  if ((0 | (Ne = L + 1 | 0)) == (0 | Ue))
                                    break r;
                                  if (B[le + Ne | 0] != 61) {
                                    Ue = Ne, be = 28;
                                    break r;
                                  }
                                  if ((0 | Ye) != 2 && ((0 | (L = L + 2 | 0)) == (0 | Ue) || (be = 28, Ue = L, B[L + le | 0] != 61)))
                                    break r;
                                }
                              }
                              if (Z = 0, de)
                                break n;
                              break t;
                            }
                            l[8916] = be;
                            break e;
                          }
                          if (!(ae >>> 0 <= q >>> 0)) {
                            for (; ; ) {
                              if (!Gs(de, j[le + q | 0]))
                                break t;
                              if ((0 | (q = q + 1 | 0)) == (0 | ae))
                                break;
                            }
                            q = ae;
                          }
                        }
                        Ue = q, ot = We;
                      }
                      return Qe ? l[Qe >> 2] = le + Ue : (0 | ae) != (0 | Ue) && (l[8916] = 28, Z = -1), Ie && (l[Ie >> 2] = ot), 0 | Z;
                    }, Tb: function() {
                      var L = 0;
                      return l[9049] ? L = 1 : (to(), Se(36176, 16), l[9049] = 1, L = 0), 0 | L;
                    }, Ub: function(L, Z, le, ae, de) {
                      L |= 0, Z |= 0, le |= 0, de |= 0;
                      var Ie, Qe = 0, q = 0, be = 0;
                      st = Ie = st - 16 | 0;
                      e: {
                        if (ae |= 0) {
                          if (be = -1, (Qe = (Qe = ae - 1 | 0) - (q = Qe & ae ? (le >>> 0) % (ae >>> 0) | 0 : le & Qe) | 0) >>> 0 >= (-1 ^ le) >>> 0)
                            break e;
                          if (!((le = le + Qe | 0) >>> 0 >= de >>> 0))
                            for (L && (l[L >> 2] = le + 1), L = Z + le | 0, be = 0, j[Ie + 15 | 0] = 0, le = 0; de = Z = L - le | 0, q = B[0 | Z] & B[Ie + 15 | 0], Z = (le ^ Qe) - 1 >>> 24 | 0, j[0 | de] = q | 128 & Z, j[Ie + 15 | 0] = Z | B[Ie + 15 | 0], (0 | ae) != (0 | (le = le + 1 | 0)); )
                              ;
                        } else
                          be = -1;
                        return st = Ie + 16 | 0, 0 | be;
                      }
                      Ko(), Xr();
                    }, Vb: function(L, Z, le, ae) {
                      L |= 0, Z |= 0, le |= 0, ae |= 0;
                      var de, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0;
                      if (l[12 + (de = st - 16 | 0) >> 2] = 0, ae - 1 >>> 0 < le >>> 0) {
                        for (Ue = (Qe = le - 1 | 0) + Z | 0, le = 0, Z = 0; Z &= 255, be = (128 ^ (q = B[Ue - Ie | 0])) - 1 & l[de + 12 >> 2] - 1 & Z - 1, l[de + 12 >> 2] = l[de + 12 >> 2] | be << 23 >> 31 & Ie, Z |= q, le |= be >>> 8 & 1, (0 | (Ie = Ie + 1 | 0)) != (0 | ae); )
                          ;
                        l[L >> 2] = Qe - l[de + 12 >> 2], L = (255 & le) - 1 | 0;
                      } else
                        L = -1;
                      return 0 | L;
                    }, Wb: function() {
                      return 1312;
                    }, Xb: function() {
                      return 10;
                    }, Yb: Ha, Zb: La, _b: function(L) {
                      var Z, le = 0, ae = 0, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0, Ye = 0, Te = 0, Ne = 0, We = 0;
                      st = Z = st - 16 | 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              s: {
                                u: {
                                  a: {
                                    d: {
                                      o: {
                                        if ((L |= 0) >>> 0 <= 244) {
                                          if (3 & (le = (q = l[8917]) >>> (ae = (be = L >>> 0 < 11 ? 16 : L + 11 & -8) >>> 3 | 0) | 0)) {
                                            le = 35708 + (L = (ae = ae + (1 & (-1 ^ le)) | 0) << 3) | 0, de = l[L + 35716 >> 2], (0 | le) != (0 | (L = l[de + 8 >> 2])) ? (l[L + 12 >> 2] = le, l[le + 8 >> 2] = L) : (Ne = 35668, We = Rn(-2, ae) & q, l[Ne >> 2] = We), L = de + 8 | 0, le = ae << 3, l[de + 4 >> 2] = 3 | le, l[4 + (le = le + de | 0) >> 2] = 1 | l[le + 4 >> 2];
                                            break e;
                                          }
                                          if ((Te = l[8919]) >>> 0 >= be >>> 0)
                                            break o;
                                          if (le) {
                                            le = 35708 + (L = (de = Va(0 - (L = (0 - (L = 2 << ae) | L) & le << ae) & L)) << 3) | 0, Ie = l[L + 35716 >> 2], (0 | le) != (0 | (L = l[Ie + 8 >> 2])) ? (l[L + 12 >> 2] = le, l[le + 8 >> 2] = L) : (q = Rn(-2, de) & q, l[8917] = q), l[Ie + 4 >> 2] = 3 | be, de = (L = de << 3) - be | 0, l[4 + (ae = Ie + be | 0) >> 2] = 1 | de, l[L + Ie >> 2] = de, Te && (le = 35708 + (-8 & Te) | 0, Qe = l[8922], (L = 1 << (Te >>> 3)) & q ? L = l[le + 8 >> 2] : (l[8917] = L | q, L = le), l[le + 8 >> 2] = Qe, l[L + 12 >> 2] = Qe, l[Qe + 12 >> 2] = le, l[Qe + 8 >> 2] = L), L = Ie + 8 | 0, l[8922] = ae, l[8919] = de;
                                            break e;
                                          }
                                          if (!(Ye = l[8918]))
                                            break o;
                                          for (ae = l[35972 + (Va(0 - Ye & Ye) << 2) >> 2], Qe = (-8 & l[ae + 4 >> 2]) - be | 0, le = ae; (L = l[le + 16 >> 2]) || (L = l[le + 20 >> 2]); )
                                            Qe = (de = (le = (-8 & l[L + 4 >> 2]) - be | 0) >>> 0 < Qe >>> 0) ? le : Qe, ae = de ? L : ae, le = L;
                                          if (Ue = l[ae + 24 >> 2], (0 | (de = l[ae + 12 >> 2])) != (0 | ae)) {
                                            L = l[ae + 8 >> 2], l[L + 12 >> 2] = de, l[de + 8 >> 2] = L;
                                            break t;
                                          }
                                          if (!(L = l[(le = ae + 20 | 0) >> 2])) {
                                            if (!(L = l[ae + 16 >> 2]))
                                              break d;
                                            le = ae + 16 | 0;
                                          }
                                          for (; Ie = le, de = L, (L = l[(le = L + 20 | 0) >> 2]) || (le = de + 16 | 0, L = l[de + 16 >> 2]); )
                                            ;
                                          l[Ie >> 2] = 0;
                                          break t;
                                        }
                                        if (be = -1, !(L >>> 0 > 4294967231) && (be = -8 & (L = L + 11 | 0), Ye = l[8918])) {
                                          Qe = 0 - be | 0, q = 0, be >>> 0 < 256 || (q = 31, be >>> 0 > 16777215 || (q = 62 + ((be >>> 38 - (L = zi(L >>> 8 | 0)) & 1) - (L << 1) | 0) | 0));
                                          i: {
                                            c: {
                                              if (le = l[35972 + (q << 2) >> 2])
                                                for (L = 0, ae = be << ((0 | q) != 31 ? 25 - (q >>> 1 | 0) | 0 : 0); ; ) {
                                                  if (!((Ie = (-8 & l[le + 4 >> 2]) - be | 0) >>> 0 >= Qe >>> 0 || (de = le, Qe = Ie, Ie))) {
                                                    Qe = 0, L = le;
                                                    break c;
                                                  }
                                                  if (Ie = l[le + 20 >> 2], le = l[16 + ((ae >>> 29 & 4) + le | 0) >> 2], L = Ie ? (0 | Ie) == (0 | le) ? L : Ie : L, ae <<= 1, !le)
                                                    break;
                                                }
                                              else
                                                L = 0;
                                              if (!(L | de)) {
                                                if (de = 0, !(L = (0 - (L = 2 << q) | L) & Ye))
                                                  break o;
                                                L = l[35972 + (Va(L & 0 - L) << 2) >> 2];
                                              }
                                              if (!L)
                                                break i;
                                            }
                                            for (; Qe = (ae = (le = (-8 & l[L + 4 >> 2]) - be | 0) >>> 0 < Qe >>> 0) ? le : Qe, de = ae ? L : de, L = (le = l[L + 16 >> 2]) || l[L + 20 >> 2]; )
                                              ;
                                          }
                                          if (!(!de | l[8919] - be >>> 0 <= Qe >>> 0)) {
                                            if (q = l[de + 24 >> 2], (0 | de) != (0 | (ae = l[de + 12 >> 2]))) {
                                              L = l[de + 8 >> 2], l[L + 12 >> 2] = ae, l[ae + 8 >> 2] = L;
                                              break n;
                                            }
                                            if (!(L = l[(le = de + 20 | 0) >> 2])) {
                                              if (!(L = l[de + 16 >> 2]))
                                                break a;
                                              le = de + 16 | 0;
                                            }
                                            for (; Ie = le, ae = L, (L = l[(le = L + 20 | 0) >> 2]) || (le = ae + 16 | 0, L = l[ae + 16 >> 2]); )
                                              ;
                                            l[Ie >> 2] = 0;
                                            break n;
                                          }
                                        }
                                      }
                                      if ((L = l[8919]) >>> 0 >= be >>> 0) {
                                        de = l[8922], (le = L - be | 0) >>> 0 >= 16 ? (l[4 + (ae = de + be | 0) >> 2] = 1 | le, l[L + de >> 2] = le, l[de + 4 >> 2] = 3 | be) : (l[de + 4 >> 2] = 3 | L, l[4 + (L = L + de | 0) >> 2] = 1 | l[L + 4 >> 2], ae = 0, le = 0), l[8919] = le, l[8922] = ae, L = de + 8 | 0;
                                        break e;
                                      }
                                      if ((Ue = l[8920]) >>> 0 > be >>> 0) {
                                        le = Ue - be | 0, l[8920] = le, L = (ae = l[8923]) + be | 0, l[8923] = L, l[L + 4 >> 2] = 1 | le, l[ae + 4 >> 2] = 3 | be, L = ae + 8 | 0;
                                        break e;
                                      }
                                      if (L = 0, Ye = be + 47 | 0, l[9035] ? ae = l[9037] : (l[9038] = -1, l[9039] = -1, l[9036] = 4096, l[9037] = 4096, l[9035] = Z + 12 & -16 ^ 1431655768, l[9040] = 0, l[9028] = 0, ae = 4096), (le = (Ie = Ye + ae | 0) & (Qe = 0 - ae | 0)) >>> 0 <= be >>> 0 || (de = l[9027]) && de >>> 0 < (q = (ae = l[9025]) + le | 0) >>> 0 | ae >>> 0 >= q >>> 0)
                                        break e;
                                      o: {
                                        if (!(4 & B[36112])) {
                                          i: {
                                            c: {
                                              l: {
                                                f: {
                                                  if (de = l[8923])
                                                    for (L = 36116; ; ) {
                                                      if ((ae = l[L >> 2]) >>> 0 <= de >>> 0 & de >>> 0 < ae + l[L + 4 >> 2] >>> 0)
                                                        break f;
                                                      if (!(L = l[L + 8 >> 2]))
                                                        break;
                                                    }
                                                  if ((0 | (ae = ke(0))) == -1 || (q = le, (L = (de = l[9036]) - 1 | 0) & ae && (q = (le - ae | 0) + (L + ae & 0 - de) | 0), q >>> 0 <= be >>> 0) || (de = l[9027]) && de >>> 0 < (Qe = (L = l[9025]) + q | 0) >>> 0 | L >>> 0 >= Qe >>> 0)
                                                    break i;
                                                  if ((0 | ae) != (0 | (L = ke(q))))
                                                    break l;
                                                  break o;
                                                }
                                                if ((0 | (ae = ke(q = Qe & Ie - Ue))) == (l[L >> 2] + l[L + 4 >> 2] | 0))
                                                  break c;
                                                L = ae;
                                              }
                                              if ((0 | L) == -1)
                                                break i;
                                              if (be + 48 >>> 0 <= q >>> 0) {
                                                ae = L;
                                                break o;
                                              }
                                              if ((0 | ke(ae = (ae = l[9037]) + (Ye - q | 0) & 0 - ae)) == -1)
                                                break i;
                                              q = ae + q | 0, ae = L;
                                              break o;
                                            }
                                            if ((0 | ae) != -1)
                                              break o;
                                          }
                                          l[9028] = 4 | l[9028];
                                        }
                                        if ((0 | (ae = ke(le))) == -1 | (0 | (L = ke(0))) == -1 | L >>> 0 <= ae >>> 0 || (q = L - ae | 0) >>> 0 <= be + 40 >>> 0)
                                          break r;
                                      }
                                      L = l[9025] + q | 0, l[9025] = L, L >>> 0 > Ri[9026] && (l[9026] = L);
                                      o: {
                                        if (Ie = l[8923]) {
                                          for (L = 36116; ; ) {
                                            if (((de = l[L >> 2]) + (le = l[L + 4 >> 2]) | 0) == (0 | ae))
                                              break o;
                                            if (!(L = l[L + 8 >> 2]))
                                              break;
                                          }
                                          break u;
                                        }
                                        for ((L = l[8921]) >>> 0 <= ae >>> 0 && L || (l[8921] = ae), L = 0, l[9030] = q, l[9029] = ae, l[8925] = -1, l[8926] = l[9035], l[9032] = 0; le = 35708 + (de = L << 3) | 0, l[de + 35716 >> 2] = le, l[de + 35720 >> 2] = le, (0 | (L = L + 1 | 0)) != 32; )
                                          ;
                                        le = (de = q - 40 | 0) - (L = ae + 8 & 7 ? -8 - ae & 7 : 0) | 0, l[8920] = le, L = L + ae | 0, l[8923] = L, l[L + 4 >> 2] = 1 | le, l[4 + (ae + de | 0) >> 2] = 40, l[8924] = l[9039];
                                        break s;
                                      }
                                      if (8 & B[L + 12 | 0] | de >>> 0 > Ie >>> 0 | ae >>> 0 <= Ie >>> 0)
                                        break u;
                                      l[L + 4 >> 2] = le + q, ae = (L = Ie + 8 & 7 ? -8 - Ie & 7 : 0) + Ie | 0, l[8923] = ae, L = (le = l[8920] + q | 0) - L | 0, l[8920] = L, l[ae + 4 >> 2] = 1 | L, l[4 + (le + Ie | 0) >> 2] = 40, l[8924] = l[9039];
                                      break s;
                                    }
                                    de = 0;
                                    break t;
                                  }
                                  ae = 0;
                                  break n;
                                }
                                Ri[8921] > ae >>> 0 && (l[8921] = ae), le = ae + q | 0, L = 36116;
                                u: {
                                  a: {
                                    d: {
                                      o: {
                                        i: {
                                          c: {
                                            for (; ; ) {
                                              if ((0 | le) != l[L >> 2]) {
                                                if (L = l[L + 8 >> 2])
                                                  continue;
                                                break c;
                                              }
                                              break;
                                            }
                                            if (!(8 & B[L + 12 | 0]))
                                              break i;
                                          }
                                          for (L = 36116; ; ) {
                                            if ((le = l[L >> 2]) >>> 0 <= Ie >>> 0 && (Qe = le + l[L + 4 >> 2] | 0) >>> 0 > Ie >>> 0)
                                              break o;
                                            L = l[L + 8 >> 2];
                                          }
                                        }
                                        if (l[L >> 2] = ae, l[L + 4 >> 2] = l[L + 4 >> 2] + q, l[4 + (Ye = (ae + 8 & 7 ? -8 - ae & 7 : 0) + ae | 0) >> 2] = 3 | be, L = (q = le + (le + 8 & 7 ? -8 - le & 7 : 0) | 0) - (Ue = be + Ye | 0) | 0, (0 | Ie) == (0 | q)) {
                                          l[8923] = Ue, L = l[8920] + L | 0, l[8920] = L, l[Ue + 4 >> 2] = 1 | L;
                                          break a;
                                        }
                                        if (l[8922] == (0 | q)) {
                                          l[8922] = Ue, L = l[8919] + L | 0, l[8919] = L, l[Ue + 4 >> 2] = 1 | L, l[L + Ue >> 2] = L;
                                          break a;
                                        }
                                        if ((3 & (Qe = l[q + 4 >> 2])) == 1) {
                                          Ie = -8 & Qe;
                                          i:
                                            if (Qe >>> 0 <= 255) {
                                              if (de = l[q + 8 >> 2], le = Qe >>> 3 | 0, (0 | (ae = l[q + 12 >> 2])) == (0 | de)) {
                                                Ne = 35668, We = l[8917] & Rn(-2, le), l[Ne >> 2] = We;
                                                break i;
                                              }
                                              l[de + 12 >> 2] = ae, l[ae + 8 >> 2] = de;
                                            } else {
                                              if (be = l[q + 24 >> 2], (0 | q) == (0 | (ae = l[q + 12 >> 2])))
                                                if ((le = l[(Qe = q + 20 | 0) >> 2]) || (le = l[(Qe = q + 16 | 0) >> 2])) {
                                                  for (; de = Qe, (le = l[(Qe = (ae = le) + 20 | 0) >> 2]) || (Qe = ae + 16 | 0, le = l[ae + 16 >> 2]); )
                                                    ;
                                                  l[de >> 2] = 0;
                                                } else
                                                  ae = 0;
                                              else
                                                le = l[q + 8 >> 2], l[le + 12 >> 2] = ae, l[ae + 8 >> 2] = le;
                                              if (be) {
                                                de = l[q + 28 >> 2];
                                                c: {
                                                  if (l[(le = 35972 + (de << 2) | 0) >> 2] == (0 | q)) {
                                                    if (l[le >> 2] = ae, ae)
                                                      break c;
                                                    Ne = 35672, We = l[8918] & Rn(-2, de), l[Ne >> 2] = We;
                                                    break i;
                                                  }
                                                  if (l[be + (l[be + 16 >> 2] == (0 | q) ? 16 : 20) >> 2] = ae, !ae)
                                                    break i;
                                                }
                                                l[ae + 24 >> 2] = be, (le = l[q + 16 >> 2]) && (l[ae + 16 >> 2] = le, l[le + 24 >> 2] = ae), (le = l[q + 20 >> 2]) && (l[ae + 20 >> 2] = le, l[le + 24 >> 2] = ae);
                                              }
                                            }
                                          Qe = l[4 + (q = Ie + q | 0) >> 2], L = L + Ie | 0;
                                        }
                                        if (l[q + 4 >> 2] = -2 & Qe, l[Ue + 4 >> 2] = 1 | L, l[L + Ue >> 2] = L, L >>> 0 <= 255) {
                                          le = 35708 + (-8 & L) | 0, (ae = l[8917]) & (L = 1 << (L >>> 3)) ? L = l[le + 8 >> 2] : (l[8917] = L | ae, L = le), l[le + 8 >> 2] = Ue, l[L + 12 >> 2] = Ue, l[Ue + 12 >> 2] = le, l[Ue + 8 >> 2] = L;
                                          break a;
                                        }
                                        if (Qe = 31, L >>> 0 <= 16777215 && (Qe = 62 + ((L >>> 38 - (le = zi(L >>> 8 | 0)) & 1) - (le << 1) | 0) | 0), l[Ue + 28 >> 2] = Qe, l[Ue + 16 >> 2] = 0, l[Ue + 20 >> 2] = 0, le = 35972 + (Qe << 2) | 0, (de = l[8918]) & (ae = 1 << Qe)) {
                                          for (Qe = L << ((0 | Qe) != 31 ? 25 - (Qe >>> 1 | 0) | 0 : 0), ae = l[le >> 2]; ; ) {
                                            if (le = ae, (-8 & l[ae + 4 >> 2]) == (0 | L))
                                              break d;
                                            if (ae = Qe >>> 29 | 0, Qe <<= 1, !(ae = l[16 + (de = (4 & ae) + le | 0) >> 2]))
                                              break;
                                          }
                                          l[de + 16 >> 2] = Ue;
                                        } else
                                          l[8918] = ae | de, l[le >> 2] = Ue;
                                        l[Ue + 24 >> 2] = le, l[Ue + 12 >> 2] = Ue, l[Ue + 8 >> 2] = Ue;
                                        break a;
                                      }
                                      for (le = (de = q - 40 | 0) - (L = ae + 8 & 7 ? -8 - ae & 7 : 0) | 0, l[8920] = le, L = L + ae | 0, l[8923] = L, l[L + 4 >> 2] = 1 | le, l[4 + (ae + de | 0) >> 2] = 40, l[8924] = l[9039], l[(de = (L = (Qe + (Qe - 39 & 7 ? 39 - Qe & 7 : 0) | 0) - 47 | 0) >>> 0 < Ie + 16 >>> 0 ? Ie : L) + 4 >> 2] = 27, L = l[9032], l[de + 16 >> 2] = l[9031], l[de + 20 >> 2] = L, L = l[9030], l[de + 8 >> 2] = l[9029], l[de + 12 >> 2] = L, l[9031] = de + 8, l[9030] = q, l[9029] = ae, l[9032] = 0, L = de + 24 | 0; l[L + 4 >> 2] = 7, le = L + 8 | 0, L = L + 4 | 0, le >>> 0 < Qe >>> 0; )
                                        ;
                                      if ((0 | de) == (0 | Ie))
                                        break s;
                                      if (l[de + 4 >> 2] = -2 & l[de + 4 >> 2], Qe = de - Ie | 0, l[Ie + 4 >> 2] = 1 | Qe, l[de >> 2] = Qe, Qe >>> 0 <= 255) {
                                        le = 35708 + (-8 & Qe) | 0, (ae = l[8917]) & (L = 1 << (Qe >>> 3)) ? L = l[le + 8 >> 2] : (l[8917] = L | ae, L = le), l[le + 8 >> 2] = Ie, l[L + 12 >> 2] = Ie, l[Ie + 12 >> 2] = le, l[Ie + 8 >> 2] = L;
                                        break s;
                                      }
                                      if (L = 31, Qe >>> 0 <= 16777215 && (L = 62 + ((Qe >>> 38 - (L = zi(Qe >>> 8 | 0)) & 1) - (L << 1) | 0) | 0), l[Ie + 28 >> 2] = L, l[Ie + 16 >> 2] = 0, l[Ie + 20 >> 2] = 0, le = 35972 + (L << 2) | 0, (de = l[8918]) & (ae = 1 << L)) {
                                        for (L = Qe << ((0 | L) != 31 ? 25 - (L >>> 1 | 0) | 0 : 0), de = l[le >> 2]; ; ) {
                                          if ((0 | Qe) == (-8 & l[(le = de) + 4 >> 2]))
                                            break u;
                                          if (ae = L >>> 29 | 0, L <<= 1, !(de = l[16 + (ae = (4 & ae) + le | 0) >> 2]))
                                            break;
                                        }
                                        l[ae + 16 >> 2] = Ie;
                                      } else
                                        l[8918] = ae | de, l[le >> 2] = Ie;
                                      l[Ie + 24 >> 2] = le, l[Ie + 12 >> 2] = Ie, l[Ie + 8 >> 2] = Ie;
                                      break s;
                                    }
                                    L = l[le + 8 >> 2], l[L + 12 >> 2] = Ue, l[le + 8 >> 2] = Ue, l[Ue + 24 >> 2] = 0, l[Ue + 12 >> 2] = le, l[Ue + 8 >> 2] = L;
                                  }
                                  L = Ye + 8 | 0;
                                  break e;
                                }
                                L = l[le + 8 >> 2], l[L + 12 >> 2] = Ie, l[le + 8 >> 2] = Ie, l[Ie + 24 >> 2] = 0, l[Ie + 12 >> 2] = le, l[Ie + 8 >> 2] = L;
                              }
                              if (!((L = l[8920]) >>> 0 <= be >>> 0)) {
                                le = L - be | 0, l[8920] = le, L = (ae = l[8923]) + be | 0, l[8923] = L, l[L + 4 >> 2] = 1 | le, l[ae + 4 >> 2] = 3 | be, L = ae + 8 | 0;
                                break e;
                              }
                            }
                            l[8916] = 48, L = 0;
                            break e;
                          }
                          n:
                            if (q) {
                              le = l[de + 28 >> 2];
                              r: {
                                if (l[(L = 35972 + (le << 2) | 0) >> 2] == (0 | de)) {
                                  if (l[L >> 2] = ae, ae)
                                    break r;
                                  Ye = Rn(-2, le) & Ye, l[8918] = Ye;
                                  break n;
                                }
                                if (l[q + (l[q + 16 >> 2] == (0 | de) ? 16 : 20) >> 2] = ae, !ae)
                                  break n;
                              }
                              l[ae + 24 >> 2] = q, (L = l[de + 16 >> 2]) && (l[ae + 16 >> 2] = L, l[L + 24 >> 2] = ae), (L = l[de + 20 >> 2]) && (l[ae + 20 >> 2] = L, l[L + 24 >> 2] = ae);
                            }
                          n:
                            if (Qe >>> 0 <= 15)
                              L = Qe + be | 0, l[de + 4 >> 2] = 3 | L, l[4 + (L = L + de | 0) >> 2] = 1 | l[L + 4 >> 2];
                            else if (l[de + 4 >> 2] = 3 | be, l[4 + (Ie = de + be | 0) >> 2] = 1 | Qe, l[Ie + Qe >> 2] = Qe, Qe >>> 0 <= 255)
                              le = 35708 + (-8 & Qe) | 0, (ae = l[8917]) & (L = 1 << (Qe >>> 3)) ? L = l[le + 8 >> 2] : (l[8917] = L | ae, L = le), l[le + 8 >> 2] = Ie, l[L + 12 >> 2] = Ie, l[Ie + 12 >> 2] = le, l[Ie + 8 >> 2] = L;
                            else {
                              L = 31, Qe >>> 0 <= 16777215 && (L = 62 + ((Qe >>> 38 - (L = zi(Qe >>> 8 | 0)) & 1) - (L << 1) | 0) | 0), l[Ie + 28 >> 2] = L, l[Ie + 16 >> 2] = 0, l[Ie + 20 >> 2] = 0, le = 35972 + (L << 2) | 0;
                              r: {
                                if ((ae = 1 << L) & Ye) {
                                  for (L = Qe << ((0 | L) != 31 ? 25 - (L >>> 1 | 0) | 0 : 0), be = l[le >> 2]; ; ) {
                                    if ((-8 & l[(le = be) + 4 >> 2]) == (0 | Qe))
                                      break r;
                                    if (ae = L >>> 29 | 0, L <<= 1, !(be = l[16 + (ae = (4 & ae) + le | 0) >> 2]))
                                      break;
                                  }
                                  l[ae + 16 >> 2] = Ie;
                                } else
                                  l[8918] = ae | Ye, l[le >> 2] = Ie;
                                l[Ie + 24 >> 2] = le, l[Ie + 12 >> 2] = Ie, l[Ie + 8 >> 2] = Ie;
                                break n;
                              }
                              L = l[le + 8 >> 2], l[L + 12 >> 2] = Ie, l[le + 8 >> 2] = Ie, l[Ie + 24 >> 2] = 0, l[Ie + 12 >> 2] = le, l[Ie + 8 >> 2] = L;
                            }
                          L = de + 8 | 0;
                          break e;
                        }
                        t:
                          if (Ue) {
                            le = l[ae + 28 >> 2];
                            n: {
                              if (l[(L = 35972 + (le << 2) | 0) >> 2] == (0 | ae)) {
                                if (l[L >> 2] = de, de)
                                  break n;
                                Ne = 35672, We = Rn(-2, le) & Ye, l[Ne >> 2] = We;
                                break t;
                              }
                              if (l[Ue + (l[Ue + 16 >> 2] == (0 | ae) ? 16 : 20) >> 2] = de, !de)
                                break t;
                            }
                            l[de + 24 >> 2] = Ue, (L = l[ae + 16 >> 2]) && (l[de + 16 >> 2] = L, l[L + 24 >> 2] = de), (L = l[ae + 20 >> 2]) && (l[de + 20 >> 2] = L, l[L + 24 >> 2] = de);
                          }
                        Qe >>> 0 <= 15 ? (L = Qe + be | 0, l[ae + 4 >> 2] = 3 | L, l[4 + (L = L + ae | 0) >> 2] = 1 | l[L + 4 >> 2]) : (l[ae + 4 >> 2] = 3 | be, l[4 + (de = ae + be | 0) >> 2] = 1 | Qe, l[de + Qe >> 2] = Qe, Te && (le = 35708 + (-8 & Te) | 0, Ie = l[8922], (L = 1 << (Te >>> 3)) & q ? L = l[le + 8 >> 2] : (l[8917] = L | q, L = le), l[le + 8 >> 2] = Ie, l[L + 12 >> 2] = Ie, l[Ie + 12 >> 2] = le, l[Ie + 8 >> 2] = L), l[8922] = de, l[8919] = Qe), L = ae + 8 | 0;
                      }
                      return st = Z + 16 | 0, 0 | L;
                    }, $b: function(L) {
                      var Z = 0, le = 0, ae = 0, de = 0, Ie = 0, Qe = 0, q = 0, be = 0, Ue = 0;
                      e:
                        if (L |= 0) {
                          Ie = (ae = L - 8 | 0) + (L = -8 & (Z = l[L - 4 >> 2])) | 0;
                          t:
                            if (!(1 & Z)) {
                              if (!(3 & Z) || (ae = ae - (Z = l[ae >> 2]) | 0) >>> 0 < Ri[8921])
                                break e;
                              if (L = L + Z | 0, l[8922] == (0 | ae)) {
                                if ((3 & (Z = l[Ie + 4 >> 2])) == 3)
                                  return l[8919] = L, l[Ie + 4 >> 2] = -2 & Z, l[ae + 4 >> 2] = 1 | L, void (l[L + ae >> 2] = L);
                              } else {
                                if (Z >>> 0 <= 255) {
                                  if (de = l[ae + 8 >> 2], Z = Z >>> 3 | 0, (0 | (le = l[ae + 12 >> 2])) == (0 | de)) {
                                    be = 35668, Ue = l[8917] & Rn(-2, Z), l[be >> 2] = Ue;
                                    break t;
                                  }
                                  l[de + 12 >> 2] = le, l[le + 8 >> 2] = de;
                                  break t;
                                }
                                if (q = l[ae + 24 >> 2], (0 | ae) == (0 | (Z = l[ae + 12 >> 2])))
                                  if ((le = l[(de = ae + 20 | 0) >> 2]) || (le = l[(de = ae + 16 | 0) >> 2])) {
                                    for (; Qe = de, (le = l[(de = (Z = le) + 20 | 0) >> 2]) || (de = Z + 16 | 0, le = l[Z + 16 >> 2]); )
                                      ;
                                    l[Qe >> 2] = 0;
                                  } else
                                    Z = 0;
                                else
                                  le = l[ae + 8 >> 2], l[le + 12 >> 2] = Z, l[Z + 8 >> 2] = le;
                                if (!q)
                                  break t;
                                de = l[ae + 28 >> 2];
                                n: {
                                  if (l[(le = 35972 + (de << 2) | 0) >> 2] == (0 | ae)) {
                                    if (l[le >> 2] = Z, Z)
                                      break n;
                                    be = 35672, Ue = l[8918] & Rn(-2, de), l[be >> 2] = Ue;
                                    break t;
                                  }
                                  if (l[q + (l[q + 16 >> 2] == (0 | ae) ? 16 : 20) >> 2] = Z, !Z)
                                    break t;
                                }
                                if (l[Z + 24 >> 2] = q, (le = l[ae + 16 >> 2]) && (l[Z + 16 >> 2] = le, l[le + 24 >> 2] = Z), !(le = l[ae + 20 >> 2]))
                                  break t;
                                l[Z + 20 >> 2] = le, l[le + 24 >> 2] = Z;
                              }
                            }
                          if (!(ae >>> 0 >= Ie >>> 0) && 1 & (Z = l[Ie + 4 >> 2])) {
                            t: {
                              if (!(2 & Z)) {
                                if (l[8923] == (0 | Ie)) {
                                  if (l[8923] = ae, L = l[8920] + L | 0, l[8920] = L, l[ae + 4 >> 2] = 1 | L, l[8922] != (0 | ae))
                                    break e;
                                  return l[8919] = 0, void (l[8922] = 0);
                                }
                                if (l[8922] == (0 | Ie))
                                  return l[8922] = ae, L = l[8919] + L | 0, l[8919] = L, l[ae + 4 >> 2] = 1 | L, void (l[L + ae >> 2] = L);
                                L = (-8 & Z) + L | 0;
                                n:
                                  if (Z >>> 0 <= 255) {
                                    if (de = l[Ie + 8 >> 2], Z = Z >>> 3 | 0, (0 | (le = l[Ie + 12 >> 2])) == (0 | de)) {
                                      be = 35668, Ue = l[8917] & Rn(-2, Z), l[be >> 2] = Ue;
                                      break n;
                                    }
                                    l[de + 12 >> 2] = le, l[le + 8 >> 2] = de;
                                  } else {
                                    if (q = l[Ie + 24 >> 2], (0 | Ie) == (0 | (Z = l[Ie + 12 >> 2])))
                                      if ((le = l[(de = Ie + 20 | 0) >> 2]) || (le = l[(de = Ie + 16 | 0) >> 2])) {
                                        for (; Qe = de, (le = l[(de = (Z = le) + 20 | 0) >> 2]) || (de = Z + 16 | 0, le = l[Z + 16 >> 2]); )
                                          ;
                                        l[Qe >> 2] = 0;
                                      } else
                                        Z = 0;
                                    else
                                      le = l[Ie + 8 >> 2], l[le + 12 >> 2] = Z, l[Z + 8 >> 2] = le;
                                    if (q) {
                                      de = l[Ie + 28 >> 2];
                                      r: {
                                        if (l[(le = 35972 + (de << 2) | 0) >> 2] == (0 | Ie)) {
                                          if (l[le >> 2] = Z, Z)
                                            break r;
                                          be = 35672, Ue = l[8918] & Rn(-2, de), l[be >> 2] = Ue;
                                          break n;
                                        }
                                        if (l[q + (l[q + 16 >> 2] == (0 | Ie) ? 16 : 20) >> 2] = Z, !Z)
                                          break n;
                                      }
                                      l[Z + 24 >> 2] = q, (le = l[Ie + 16 >> 2]) && (l[Z + 16 >> 2] = le, l[le + 24 >> 2] = Z), (le = l[Ie + 20 >> 2]) && (l[Z + 20 >> 2] = le, l[le + 24 >> 2] = Z);
                                    }
                                  }
                                if (l[ae + 4 >> 2] = 1 | L, l[L + ae >> 2] = L, l[8922] != (0 | ae))
                                  break t;
                                return void (l[8919] = L);
                              }
                              l[Ie + 4 >> 2] = -2 & Z, l[ae + 4 >> 2] = 1 | L, l[L + ae >> 2] = L;
                            }
                            if (L >>> 0 <= 255)
                              return Z = 35708 + (-8 & L) | 0, (le = l[8917]) & (L = 1 << (L >>> 3)) ? L = l[Z + 8 >> 2] : (l[8917] = L | le, L = Z), l[Z + 8 >> 2] = ae, l[L + 12 >> 2] = ae, l[ae + 12 >> 2] = Z, void (l[ae + 8 >> 2] = L);
                            de = 31, L >>> 0 <= 16777215 && (de = 62 + ((L >>> 38 - (Z = zi(L >>> 8 | 0)) & 1) - (Z << 1) | 0) | 0), l[ae + 28 >> 2] = de, l[ae + 16 >> 2] = 0, l[ae + 20 >> 2] = 0, Qe = 35972 + (de << 2) | 0;
                            t: {
                              n: {
                                if ((le = l[8918]) & (Z = 1 << de)) {
                                  for (de = L << ((0 | de) != 31 ? 25 - (de >>> 1 | 0) | 0 : 0), Z = l[Qe >> 2]; ; ) {
                                    if (le = Z, (-8 & l[Z + 4 >> 2]) == (0 | L))
                                      break n;
                                    if (Z = de >>> 29 | 0, de <<= 1, !(Z = l[16 + (Qe = le + (4 & Z) | 0) >> 2]))
                                      break;
                                  }
                                  l[Qe + 16 >> 2] = ae, l[ae + 24 >> 2] = le;
                                } else
                                  l[8918] = Z | le, l[Qe >> 2] = ae, l[ae + 24 >> 2] = Qe;
                                l[ae + 12 >> 2] = ae, l[ae + 8 >> 2] = ae;
                                break t;
                              }
                              L = l[le + 8 >> 2], l[L + 12 >> 2] = ae, l[le + 8 >> 2] = ae, l[ae + 24 >> 2] = 0, l[ae + 12 >> 2] = le, l[ae + 8 >> 2] = L;
                            }
                            L = l[8925] - 1 | 0, l[8925] = L || -1;
                          }
                        }
                    }, ac: Ki };
                  }(Nr);
                }(sr);
              }, instantiate: function(xn, sr) {
                return { then: function(Nr) {
                  var vr = new Wt.Module(xn);
                  Nr({ instance: new Wt.Instance(vr, sr) });
                } };
              }, RuntimeError: Error };
              Me = [], typeof Wt != "object" && Qo("no native wasm support detected");
              var yn, pr, Uo, ar, Sr, Jo, fr, Er = !1, vo = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
              function lr(xn, sr) {
                return xn ? function(Nr, vr, Yr) {
                  for (var Fr = vr + Yr, eo = vr; Nr[eo] && !(eo >= Fr); )
                    ++eo;
                  if (eo - vr > 16 && Nr.buffer && vo)
                    return vo.decode(Nr.subarray(vr, eo));
                  for (var Xr = ""; vr < eo; ) {
                    var Mo = Nr[vr++];
                    if (128 & Mo) {
                      var jo = 63 & Nr[vr++];
                      if ((224 & Mo) != 192) {
                        var Ii = 63 & Nr[vr++];
                        if ((Mo = (240 & Mo) == 224 ? (15 & Mo) << 12 | jo << 6 | Ii : (7 & Mo) << 18 | jo << 12 | Ii << 6 | 63 & Nr[vr++]) < 65536)
                          Xr += String.fromCharCode(Mo);
                        else {
                          var ki = Mo - 65536;
                          Xr += String.fromCharCode(55296 | ki >> 10, 56320 | 1023 & ki);
                        }
                      } else
                        Xr += String.fromCharCode((31 & Mo) << 6 | jo);
                    } else
                      Xr += String.fromCharCode(Mo);
                  }
                  return Xr;
                }(pr, xn, sr) : "";
              }
              function $r() {
                var xn = cn.buffer;
                ce.HEAP8 = yn = new Int8Array(xn), ce.HEAP16 = Uo = new Int16Array(xn), ce.HEAP32 = ar = new Int32Array(xn), ce.HEAPU8 = pr = new Uint8Array(xn), ce.HEAPU16 = new Uint16Array(xn), ce.HEAPU32 = Sr = new Uint32Array(xn), ce.HEAPF32 = Jo = new Float32Array(xn), ce.HEAPF64 = fr = new Float64Array(xn);
              }
              var Wo = ce.INITIAL_MEMORY || 16777216;
              Wo >= 65536 || Qo("INITIAL_MEMORY should be larger than STACK_SIZE, was " + Wo + "! (STACK_SIZE=65536)"), cn = ce.wasmMemory ? ce.wasmMemory : new Wt.Memory({ initial: Wo / 65536, maximum: 32768 }), $r(), Wo = cn.buffer.byteLength;
              var yr = [], Dr = [], Zo = [], dr = 0, Br = null;
              function Qo(xn) {
                throw ce.onAbort && ce.onAbort(xn), He(xn = "Aborted(" + xn + ")"), Er = !0, xn += ". Build with -sASSERTIONS for more info.", new Wt.RuntimeError(xn);
              }
              var tr, Mr, qo, hr, Or = "data:application/octet-stream;base64,";
              function Fo(xn) {
                return xn.startsWith(Or);
              }
              function No(xn) {
                return xn.startsWith("file://");
              }
              function di(xn) {
                try {
                  if (xn == tr && Me)
                    return new Uint8Array(Me);
                  var sr = ii(xn);
                  if (sr)
                    return sr;
                  if (Qn)
                    return Qn(xn);
                  throw "both async and sync fetching of the wasm failed";
                } catch (Nr) {
                  Qo(Nr);
                }
              }
              Fo(tr = "<<< WASM_BINARY_FILE >>>") || (Mr = tr, tr = ce.locateFile ? ce.locateFile(Mr, Ln) : Ln + Mr);
              var gi = { 34904: () => ce.getRandomValue(), 34940: () => {
                if (ce.getRandomValue === void 0)
                  try {
                    var xn = typeof window == "object" ? window : self, sr = xn.crypto !== void 0 ? xn.crypto : xn.msCrypto, Nr = function() {
                      var Fr = new Uint32Array(1);
                      return sr.getRandomValues(Fr), Fr[0] >>> 0;
                    };
                    Nr(), ce.getRandomValue = Nr;
                  } catch {
                    try {
                      var vr = requireCryptoBrowserify(), Yr = function() {
                        var eo = vr.randomBytes(4);
                        return (eo[0] << 24 | eo[1] << 16 | eo[2] << 8 | eo[3]) >>> 0;
                      };
                      Yr(), ce.getRandomValue = Yr;
                    } catch {
                      throw "No secure random number generator found";
                    }
                  }
              } };
              function ai(xn) {
                for (; xn.length > 0; )
                  xn.shift()(ce);
              }
              var ui = [];
              function hi(xn) {
                var sr = cn.buffer;
                try {
                  return cn.grow(xn - sr.byteLength + 65535 >>> 16), $r(), 1;
                } catch {
                }
              }
              var bi = typeof atob == "function" ? atob : function(xn) {
                var sr, Nr, vr, Yr, Fr, eo, Xr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Mo = "", jo = 0;
                xn = xn.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                do
                  sr = Xr.indexOf(xn.charAt(jo++)) << 2 | (Yr = Xr.indexOf(xn.charAt(jo++))) >> 4, Nr = (15 & Yr) << 4 | (Fr = Xr.indexOf(xn.charAt(jo++))) >> 2, vr = (3 & Fr) << 6 | (eo = Xr.indexOf(xn.charAt(jo++))), Mo += String.fromCharCode(sr), Fr !== 64 && (Mo += String.fromCharCode(Nr)), eo !== 64 && (Mo += String.fromCharCode(vr));
                while (jo < xn.length);
                return Mo;
              };
              function ii(xn) {
                if (Fo(xn))
                  return function(sr) {
                    if (typeof rn == "boolean" && rn) {
                      var Nr = Buffer.from(sr, "base64");
                      return new Uint8Array(Nr.buffer, Nr.byteOffset, Nr.byteLength);
                    }
                    try {
                      for (var vr = bi(sr), Yr = new Uint8Array(vr.length), Fr = 0; Fr < vr.length; ++Fr)
                        Yr[Fr] = vr.charCodeAt(Fr);
                      return Yr;
                    } catch {
                      throw new Error("Converting base64 string to bytes failed.");
                    }
                  }(xn.slice(Or.length));
              }
              var pi, Ci = { c: function(xn, sr, Nr, vr) {
                Qo("Assertion failed: " + lr(xn) + ", at: " + [sr ? lr(sr) : "unknown filename", Nr, vr ? lr(vr) : "unknown function"]);
              }, d: function() {
                Qo("");
              }, b: function(xn, sr, Nr) {
                return function(vr, Yr, Fr) {
                  var eo = function(Xr, Mo) {
                    var jo;
                    for (ui.length = 0, Mo >>= 2; jo = pr[Xr++]; )
                      Mo += jo != 105 & Mo, ui.push(jo == 105 ? ar[Mo] : fr[Mo++ >> 1]), ++Mo;
                    return ui;
                  }(Yr, Fr);
                  return gi[vr].apply(null, eo);
                }(xn, sr, Nr);
              }, e: function(xn) {
                var sr, Nr = pr.length, vr = 2147483648;
                if ((xn >>>= 0) > vr)
                  return !1;
                for (var Yr = 1; Yr <= 4; Yr *= 2) {
                  var Fr = Nr * (1 + 0.2 / Yr);
                  if (Fr = Math.min(Fr, xn + 100663296), hi(Math.min(vr, (sr = Math.max(xn, Fr)) + (65536 - sr % 65536) % 65536)))
                    return !0;
                }
                return !1;
              }, a: cn };
              function _i() {
                function xn() {
                  pi || (pi = !0, ce.calledRun = !0, Er || (ai(Dr), ce.onRuntimeInitialized && ce.onRuntimeInitialized(), function() {
                    if (ce.postRun)
                      for (typeof ce.postRun == "function" && (ce.postRun = [ce.postRun]); ce.postRun.length; )
                        sr = ce.postRun.shift(), Zo.unshift(sr);
                    var sr;
                    ai(Zo);
                  }()));
                }
                dr > 0 || (function() {
                  if (ce.preRun)
                    for (typeof ce.preRun == "function" && (ce.preRun = [ce.preRun]); ce.preRun.length; )
                      sr = ce.preRun.shift(), yr.unshift(sr);
                  var sr;
                  ai(yr);
                }(), dr > 0 || (ce.setStatus ? (ce.setStatus("Running..."), setTimeout(function() {
                  setTimeout(function() {
                    ce.setStatus("");
                  }, 1), xn();
                }, 1)) : xn()));
              }
              if (function() {
                var xn = { a: Ci };
                function sr(Yr, Fr) {
                  var eo, Xr = Yr.exports;
                  ce.asm = Xr, ce.asm.ac, eo = ce.asm.f, Dr.unshift(eo), function(Mo) {
                    if (dr--, ce.monitorRunDependencies && ce.monitorRunDependencies(dr), dr == 0 && Br) {
                      var jo = Br;
                      Br = null, jo();
                    }
                  }();
                }
                function Nr(Yr) {
                  sr(Yr.instance);
                }
                function vr(Yr) {
                  return function() {
                    if (!Me && (ft || It)) {
                      if (typeof fetch == "function" && !No(tr))
                        return fetch(tr, { credentials: "same-origin" }).then(function(Fr) {
                          if (!Fr.ok)
                            throw "failed to load wasm binary file at '" + tr + "'";
                          return Fr.arrayBuffer();
                        }).catch(function() {
                          return di(tr);
                        });
                      if (Lt)
                        return new Promise(function(Fr, eo) {
                          Lt(tr, function(Xr) {
                            Fr(new Uint8Array(Xr));
                          }, eo);
                        });
                    }
                    return Promise.resolve().then(function() {
                      return di(tr);
                    });
                  }().then(function(Fr) {
                    return Wt.instantiate(Fr, xn);
                  }).then(function(Fr) {
                    return Fr;
                  }).then(Yr, function(Fr) {
                    He("failed to asynchronously prepare wasm: " + Fr), Qo(Fr);
                  });
                }
                if (dr++, ce.monitorRunDependencies && ce.monitorRunDependencies(dr), ce.instantiateWasm)
                  try {
                    return ce.instantiateWasm(xn, sr);
                  } catch (Yr) {
                    return He("Module.instantiateWasm callback failed with error: " + Yr), !1;
                  }
                Me || typeof Wt.instantiateStreaming != "function" || Fo(tr) || No(tr) || rn || typeof fetch != "function" ? vr(Nr) : fetch(tr, { credentials: "same-origin" }).then(function(Yr) {
                  return Wt.instantiateStreaming(Yr, xn).then(Nr, function(Fr) {
                    return He("wasm streaming compile failed: " + Fr), He("falling back to ArrayBuffer instantiation"), vr(Nr);
                  });
                });
              }(), ce._crypto_aead_chacha20poly1305_encrypt_detached = function() {
                return (ce._crypto_aead_chacha20poly1305_encrypt_detached = ce.asm.g).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_encrypt = function() {
                return (ce._crypto_aead_chacha20poly1305_encrypt = ce.asm.h).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_encrypt_detached = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_encrypt_detached = ce.asm.i).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_encrypt = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_encrypt = ce.asm.j).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_decrypt_detached = function() {
                return (ce._crypto_aead_chacha20poly1305_decrypt_detached = ce.asm.k).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_decrypt = function() {
                return (ce._crypto_aead_chacha20poly1305_decrypt = ce.asm.l).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_decrypt_detached = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_decrypt_detached = ce.asm.m).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_decrypt = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_decrypt = ce.asm.n).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_keybytes = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_keybytes = ce.asm.o).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_npubbytes = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_npubbytes = ce.asm.p).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_nsecbytes = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_nsecbytes = ce.asm.q).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_abytes = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_abytes = ce.asm.r).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_messagebytes_max = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ce.asm.s).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_keygen = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_keygen = ce.asm.t).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_keybytes = function() {
                return (ce._crypto_aead_chacha20poly1305_keybytes = ce.asm.u).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_npubbytes = function() {
                return (ce._crypto_aead_chacha20poly1305_npubbytes = ce.asm.v).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_nsecbytes = function() {
                return (ce._crypto_aead_chacha20poly1305_nsecbytes = ce.asm.w).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_abytes = function() {
                return (ce._crypto_aead_chacha20poly1305_abytes = ce.asm.x).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_messagebytes_max = function() {
                return (ce._crypto_aead_chacha20poly1305_messagebytes_max = ce.asm.y).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_keygen = function() {
                return (ce._crypto_aead_chacha20poly1305_keygen = ce.asm.z).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = ce.asm.A).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_encrypt = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_encrypt = ce.asm.B).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = ce.asm.C).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_decrypt = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_decrypt = ce.asm.D).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_keybytes = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_keybytes = ce.asm.E).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_npubbytes = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_npubbytes = ce.asm.F).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_nsecbytes = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ce.asm.G).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_abytes = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_abytes = ce.asm.H).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ce.asm.I).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_keygen = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_keygen = ce.asm.J).apply(null, arguments);
              }, ce._crypto_auth_bytes = function() {
                return (ce._crypto_auth_bytes = ce.asm.K).apply(null, arguments);
              }, ce._crypto_auth_keybytes = function() {
                return (ce._crypto_auth_keybytes = ce.asm.L).apply(null, arguments);
              }, ce._crypto_auth = function() {
                return (ce._crypto_auth = ce.asm.M).apply(null, arguments);
              }, ce._crypto_auth_verify = function() {
                return (ce._crypto_auth_verify = ce.asm.N).apply(null, arguments);
              }, ce._crypto_auth_keygen = function() {
                return (ce._crypto_auth_keygen = ce.asm.O).apply(null, arguments);
              }, ce._crypto_box_seedbytes = function() {
                return (ce._crypto_box_seedbytes = ce.asm.P).apply(null, arguments);
              }, ce._crypto_box_publickeybytes = function() {
                return (ce._crypto_box_publickeybytes = ce.asm.Q).apply(null, arguments);
              }, ce._crypto_box_secretkeybytes = function() {
                return (ce._crypto_box_secretkeybytes = ce.asm.R).apply(null, arguments);
              }, ce._crypto_box_beforenmbytes = function() {
                return (ce._crypto_box_beforenmbytes = ce.asm.S).apply(null, arguments);
              }, ce._crypto_box_noncebytes = function() {
                return (ce._crypto_box_noncebytes = ce.asm.T).apply(null, arguments);
              }, ce._crypto_box_macbytes = function() {
                return (ce._crypto_box_macbytes = ce.asm.U).apply(null, arguments);
              }, ce._crypto_box_messagebytes_max = function() {
                return (ce._crypto_box_messagebytes_max = ce.asm.V).apply(null, arguments);
              }, ce._crypto_box_seed_keypair = function() {
                return (ce._crypto_box_seed_keypair = ce.asm.W).apply(null, arguments);
              }, ce._crypto_box_keypair = function() {
                return (ce._crypto_box_keypair = ce.asm.X).apply(null, arguments);
              }, ce._crypto_box_beforenm = function() {
                return (ce._crypto_box_beforenm = ce.asm.Y).apply(null, arguments);
              }, ce._crypto_box_detached_afternm = function() {
                return (ce._crypto_box_detached_afternm = ce.asm.Z).apply(null, arguments);
              }, ce._crypto_box_detached = function() {
                return (ce._crypto_box_detached = ce.asm._).apply(null, arguments);
              }, ce._crypto_box_easy_afternm = function() {
                return (ce._crypto_box_easy_afternm = ce.asm.$).apply(null, arguments);
              }, ce._crypto_box_easy = function() {
                return (ce._crypto_box_easy = ce.asm.aa).apply(null, arguments);
              }, ce._crypto_box_open_detached_afternm = function() {
                return (ce._crypto_box_open_detached_afternm = ce.asm.ba).apply(null, arguments);
              }, ce._crypto_box_open_detached = function() {
                return (ce._crypto_box_open_detached = ce.asm.ca).apply(null, arguments);
              }, ce._crypto_box_open_easy_afternm = function() {
                return (ce._crypto_box_open_easy_afternm = ce.asm.da).apply(null, arguments);
              }, ce._crypto_box_open_easy = function() {
                return (ce._crypto_box_open_easy = ce.asm.ea).apply(null, arguments);
              }, ce._crypto_box_seal = function() {
                return (ce._crypto_box_seal = ce.asm.fa).apply(null, arguments);
              }, ce._crypto_box_seal_open = function() {
                return (ce._crypto_box_seal_open = ce.asm.ga).apply(null, arguments);
              }, ce._crypto_box_sealbytes = function() {
                return (ce._crypto_box_sealbytes = ce.asm.ha).apply(null, arguments);
              }, ce._crypto_generichash_bytes_min = function() {
                return (ce._crypto_generichash_bytes_min = ce.asm.ia).apply(null, arguments);
              }, ce._crypto_generichash_bytes_max = function() {
                return (ce._crypto_generichash_bytes_max = ce.asm.ja).apply(null, arguments);
              }, ce._crypto_generichash_bytes = function() {
                return (ce._crypto_generichash_bytes = ce.asm.ka).apply(null, arguments);
              }, ce._crypto_generichash_keybytes_min = function() {
                return (ce._crypto_generichash_keybytes_min = ce.asm.la).apply(null, arguments);
              }, ce._crypto_generichash_keybytes_max = function() {
                return (ce._crypto_generichash_keybytes_max = ce.asm.ma).apply(null, arguments);
              }, ce._crypto_generichash_keybytes = function() {
                return (ce._crypto_generichash_keybytes = ce.asm.na).apply(null, arguments);
              }, ce._crypto_generichash_statebytes = function() {
                return (ce._crypto_generichash_statebytes = ce.asm.oa).apply(null, arguments);
              }, ce._crypto_generichash = function() {
                return (ce._crypto_generichash = ce.asm.pa).apply(null, arguments);
              }, ce._crypto_generichash_init = function() {
                return (ce._crypto_generichash_init = ce.asm.qa).apply(null, arguments);
              }, ce._crypto_generichash_update = function() {
                return (ce._crypto_generichash_update = ce.asm.ra).apply(null, arguments);
              }, ce._crypto_generichash_final = function() {
                return (ce._crypto_generichash_final = ce.asm.sa).apply(null, arguments);
              }, ce._crypto_generichash_keygen = function() {
                return (ce._crypto_generichash_keygen = ce.asm.ta).apply(null, arguments);
              }, ce._crypto_hash_bytes = function() {
                return (ce._crypto_hash_bytes = ce.asm.ua).apply(null, arguments);
              }, ce._crypto_hash = function() {
                return (ce._crypto_hash = ce.asm.va).apply(null, arguments);
              }, ce._crypto_kdf_bytes_min = function() {
                return (ce._crypto_kdf_bytes_min = ce.asm.wa).apply(null, arguments);
              }, ce._crypto_kdf_bytes_max = function() {
                return (ce._crypto_kdf_bytes_max = ce.asm.xa).apply(null, arguments);
              }, ce._crypto_kdf_contextbytes = function() {
                return (ce._crypto_kdf_contextbytes = ce.asm.ya).apply(null, arguments);
              }, ce._crypto_kdf_keybytes = function() {
                return (ce._crypto_kdf_keybytes = ce.asm.za).apply(null, arguments);
              }, ce._crypto_kdf_derive_from_key = function() {
                return (ce._crypto_kdf_derive_from_key = ce.asm.Aa).apply(null, arguments);
              }, ce._crypto_kdf_keygen = function() {
                return (ce._crypto_kdf_keygen = ce.asm.Ba).apply(null, arguments);
              }, ce._crypto_kx_seed_keypair = function() {
                return (ce._crypto_kx_seed_keypair = ce.asm.Ca).apply(null, arguments);
              }, ce._crypto_kx_keypair = function() {
                return (ce._crypto_kx_keypair = ce.asm.Da).apply(null, arguments);
              }, ce._crypto_kx_client_session_keys = function() {
                return (ce._crypto_kx_client_session_keys = ce.asm.Ea).apply(null, arguments);
              }, ce._crypto_kx_server_session_keys = function() {
                return (ce._crypto_kx_server_session_keys = ce.asm.Fa).apply(null, arguments);
              }, ce._crypto_kx_publickeybytes = function() {
                return (ce._crypto_kx_publickeybytes = ce.asm.Ga).apply(null, arguments);
              }, ce._crypto_kx_secretkeybytes = function() {
                return (ce._crypto_kx_secretkeybytes = ce.asm.Ha).apply(null, arguments);
              }, ce._crypto_kx_seedbytes = function() {
                return (ce._crypto_kx_seedbytes = ce.asm.Ia).apply(null, arguments);
              }, ce._crypto_kx_sessionkeybytes = function() {
                return (ce._crypto_kx_sessionkeybytes = ce.asm.Ja).apply(null, arguments);
              }, ce._crypto_scalarmult_base = function() {
                return (ce._crypto_scalarmult_base = ce.asm.Ka).apply(null, arguments);
              }, ce._crypto_scalarmult = function() {
                return (ce._crypto_scalarmult = ce.asm.La).apply(null, arguments);
              }, ce._crypto_scalarmult_bytes = function() {
                return (ce._crypto_scalarmult_bytes = ce.asm.Ma).apply(null, arguments);
              }, ce._crypto_scalarmult_scalarbytes = function() {
                return (ce._crypto_scalarmult_scalarbytes = ce.asm.Na).apply(null, arguments);
              }, ce._crypto_secretbox_keybytes = function() {
                return (ce._crypto_secretbox_keybytes = ce.asm.Oa).apply(null, arguments);
              }, ce._crypto_secretbox_noncebytes = function() {
                return (ce._crypto_secretbox_noncebytes = ce.asm.Pa).apply(null, arguments);
              }, ce._crypto_secretbox_macbytes = function() {
                return (ce._crypto_secretbox_macbytes = ce.asm.Qa).apply(null, arguments);
              }, ce._crypto_secretbox_messagebytes_max = function() {
                return (ce._crypto_secretbox_messagebytes_max = ce.asm.Ra).apply(null, arguments);
              }, ce._crypto_secretbox_keygen = function() {
                return (ce._crypto_secretbox_keygen = ce.asm.Sa).apply(null, arguments);
              }, ce._crypto_secretbox_detached = function() {
                return (ce._crypto_secretbox_detached = ce.asm.Ta).apply(null, arguments);
              }, ce._crypto_secretbox_easy = function() {
                return (ce._crypto_secretbox_easy = ce.asm.Ua).apply(null, arguments);
              }, ce._crypto_secretbox_open_detached = function() {
                return (ce._crypto_secretbox_open_detached = ce.asm.Va).apply(null, arguments);
              }, ce._crypto_secretbox_open_easy = function() {
                return (ce._crypto_secretbox_open_easy = ce.asm.Wa).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_keygen = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_keygen = ce.asm.Xa).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_init_push = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_init_push = ce.asm.Ya).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_init_pull = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_init_pull = ce.asm.Za).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_rekey = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_rekey = ce.asm._a).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_push = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_push = ce.asm.$a).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_pull = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_pull = ce.asm.ab).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_statebytes = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_statebytes = ce.asm.bb).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_abytes = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_abytes = ce.asm.cb).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_headerbytes = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_headerbytes = ce.asm.db).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_keybytes = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_keybytes = ce.asm.eb).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_messagebytes_max = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_messagebytes_max = ce.asm.fb).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_tag_message = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_tag_message = ce.asm.gb).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_tag_push = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_tag_push = ce.asm.hb).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_tag_rekey = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_tag_rekey = ce.asm.ib).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_tag_final = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_tag_final = ce.asm.jb).apply(null, arguments);
              }, ce._crypto_shorthash_bytes = function() {
                return (ce._crypto_shorthash_bytes = ce.asm.kb).apply(null, arguments);
              }, ce._crypto_shorthash_keybytes = function() {
                return (ce._crypto_shorthash_keybytes = ce.asm.lb).apply(null, arguments);
              }, ce._crypto_shorthash = function() {
                return (ce._crypto_shorthash = ce.asm.mb).apply(null, arguments);
              }, ce._crypto_shorthash_keygen = function() {
                return (ce._crypto_shorthash_keygen = ce.asm.nb).apply(null, arguments);
              }, ce._crypto_sign_statebytes = function() {
                return (ce._crypto_sign_statebytes = ce.asm.ob).apply(null, arguments);
              }, ce._crypto_sign_bytes = function() {
                return (ce._crypto_sign_bytes = ce.asm.pb).apply(null, arguments);
              }, ce._crypto_sign_seedbytes = function() {
                return (ce._crypto_sign_seedbytes = ce.asm.qb).apply(null, arguments);
              }, ce._crypto_sign_publickeybytes = function() {
                return (ce._crypto_sign_publickeybytes = ce.asm.rb).apply(null, arguments);
              }, ce._crypto_sign_secretkeybytes = function() {
                return (ce._crypto_sign_secretkeybytes = ce.asm.sb).apply(null, arguments);
              }, ce._crypto_sign_messagebytes_max = function() {
                return (ce._crypto_sign_messagebytes_max = ce.asm.tb).apply(null, arguments);
              }, ce._crypto_sign_seed_keypair = function() {
                return (ce._crypto_sign_seed_keypair = ce.asm.ub).apply(null, arguments);
              }, ce._crypto_sign_keypair = function() {
                return (ce._crypto_sign_keypair = ce.asm.vb).apply(null, arguments);
              }, ce._crypto_sign = function() {
                return (ce._crypto_sign = ce.asm.wb).apply(null, arguments);
              }, ce._crypto_sign_open = function() {
                return (ce._crypto_sign_open = ce.asm.xb).apply(null, arguments);
              }, ce._crypto_sign_detached = function() {
                return (ce._crypto_sign_detached = ce.asm.yb).apply(null, arguments);
              }, ce._crypto_sign_verify_detached = function() {
                return (ce._crypto_sign_verify_detached = ce.asm.zb).apply(null, arguments);
              }, ce._crypto_sign_init = function() {
                return (ce._crypto_sign_init = ce.asm.Ab).apply(null, arguments);
              }, ce._crypto_sign_update = function() {
                return (ce._crypto_sign_update = ce.asm.Bb).apply(null, arguments);
              }, ce._crypto_sign_final_create = function() {
                return (ce._crypto_sign_final_create = ce.asm.Cb).apply(null, arguments);
              }, ce._crypto_sign_final_verify = function() {
                return (ce._crypto_sign_final_verify = ce.asm.Db).apply(null, arguments);
              }, ce._crypto_sign_ed25519_pk_to_curve25519 = function() {
                return (ce._crypto_sign_ed25519_pk_to_curve25519 = ce.asm.Eb).apply(null, arguments);
              }, ce._crypto_sign_ed25519_sk_to_curve25519 = function() {
                return (ce._crypto_sign_ed25519_sk_to_curve25519 = ce.asm.Fb).apply(null, arguments);
              }, ce._randombytes_random = function() {
                return (ce._randombytes_random = ce.asm.Gb).apply(null, arguments);
              }, ce._randombytes_stir = function() {
                return (ce._randombytes_stir = ce.asm.Hb).apply(null, arguments);
              }, ce._randombytes_uniform = function() {
                return (ce._randombytes_uniform = ce.asm.Ib).apply(null, arguments);
              }, ce._randombytes_buf = function() {
                return (ce._randombytes_buf = ce.asm.Jb).apply(null, arguments);
              }, ce._randombytes_buf_deterministic = function() {
                return (ce._randombytes_buf_deterministic = ce.asm.Kb).apply(null, arguments);
              }, ce._randombytes_seedbytes = function() {
                return (ce._randombytes_seedbytes = ce.asm.Lb).apply(null, arguments);
              }, ce._randombytes_close = function() {
                return (ce._randombytes_close = ce.asm.Mb).apply(null, arguments);
              }, ce._randombytes = function() {
                return (ce._randombytes = ce.asm.Nb).apply(null, arguments);
              }, ce._sodium_bin2hex = function() {
                return (ce._sodium_bin2hex = ce.asm.Ob).apply(null, arguments);
              }, ce._sodium_hex2bin = function() {
                return (ce._sodium_hex2bin = ce.asm.Pb).apply(null, arguments);
              }, ce._sodium_base64_encoded_len = function() {
                return (ce._sodium_base64_encoded_len = ce.asm.Qb).apply(null, arguments);
              }, ce._sodium_bin2base64 = function() {
                return (ce._sodium_bin2base64 = ce.asm.Rb).apply(null, arguments);
              }, ce._sodium_base642bin = function() {
                return (ce._sodium_base642bin = ce.asm.Sb).apply(null, arguments);
              }, ce._sodium_init = function() {
                return (ce._sodium_init = ce.asm.Tb).apply(null, arguments);
              }, ce._sodium_pad = function() {
                return (ce._sodium_pad = ce.asm.Ub).apply(null, arguments);
              }, ce._sodium_unpad = function() {
                return (ce._sodium_unpad = ce.asm.Vb).apply(null, arguments);
              }, ce._sodium_version_string = function() {
                return (ce._sodium_version_string = ce.asm.Wb).apply(null, arguments);
              }, ce._sodium_library_version_major = function() {
                return (ce._sodium_library_version_major = ce.asm.Xb).apply(null, arguments);
              }, ce._sodium_library_version_minor = function() {
                return (ce._sodium_library_version_minor = ce.asm.Yb).apply(null, arguments);
              }, ce._sodium_library_minimal = function() {
                return (ce._sodium_library_minimal = ce.asm.Zb).apply(null, arguments);
              }, ce._malloc = function() {
                return (ce._malloc = ce.asm._b).apply(null, arguments);
              }, ce._free = function() {
                return (ce._free = ce.asm.$b).apply(null, arguments);
              }, ce.UTF8ToString = lr, ce.setValue = function(xn, sr, Nr = "i8") {
                switch (Nr.endsWith("*") && (Nr = "*"), Nr) {
                  case "i1":
                  case "i8":
                    yn[xn >> 0] = sr;
                    break;
                  case "i16":
                    Uo[xn >> 1] = sr;
                    break;
                  case "i32":
                    ar[xn >> 2] = sr;
                    break;
                  case "i64":
                    hr = [sr >>> 0, (qo = sr, +Math.abs(qo) >= 1 ? qo > 0 ? (0 | Math.min(+Math.floor(qo / 4294967296), 4294967295)) >>> 0 : ~~+Math.ceil((qo - +(~~qo >>> 0)) / 4294967296) >>> 0 : 0)], ar[xn >> 2] = hr[0], ar[xn + 4 >> 2] = hr[1];
                    break;
                  case "float":
                    Jo[xn >> 2] = sr;
                    break;
                  case "double":
                    fr[xn >> 3] = sr;
                    break;
                  case "*":
                    Sr[xn >> 2] = sr;
                    break;
                  default:
                    Qo("invalid type for setValue: " + Nr);
                }
              }, ce.getValue = function(xn, sr = "i8") {
                switch (sr.endsWith("*") && (sr = "*"), sr) {
                  case "i1":
                  case "i8":
                    return yn[xn >> 0];
                  case "i16":
                    return Uo[xn >> 1];
                  case "i32":
                  case "i64":
                    return ar[xn >> 2];
                  case "float":
                    return Jo[xn >> 2];
                  case "double":
                    return fr[xn >> 3];
                  case "*":
                    return Sr[xn >> 2];
                  default:
                    Qo("invalid type for getValue: " + sr);
                }
                return null;
              }, Br = function xn() {
                pi || _i(), pi || (Br = xn);
              }, ce.preInit)
                for (typeof ce.preInit == "function" && (ce.preInit = [ce.preInit]); ce.preInit.length > 0; )
                  ce.preInit.pop()();
              _i();
            });
          };
          var E, O, T, y = y !== void 0 ? y : {}, V = Object.assign({}, y), M = typeof window == "object", G = typeof importScripts == "function", k = typeof browser$1$1 == "object" && typeof browser$1$1.versions == "object" && typeof browser$1$1.versions.node == "string", F = "";
          if (k) {
            var X = require$$0$3, ee = requirePathBrowserify();
            F = G ? ee.dirname(F) + "/" : __dirname$1 + "/", E = (At, hn) => {
              var $t = Ht(At);
              return $t ? hn ? $t : $t.toString() : (At = Nt(At) ? new URL(At) : ee.normalize(At), X.readFileSync(At, hn ? void 0 : "utf8"));
            }, T = (At) => {
              var hn = E(At, !0);
              return hn.buffer || (hn = new Uint8Array(hn)), hn;
            }, O = (At, hn, $t) => {
              var Lt = Ht(At);
              Lt && hn(Lt), At = Nt(At) ? new URL(At) : ee.normalize(At), X.readFile(At, function(Qn, ce) {
                Qn ? $t(Qn) : hn(ce.buffer);
              });
            }, browser$1$1.argv.length > 1 && browser$1$1.argv[1].replace(/\\/g, "/"), browser$1$1.argv.slice(2), e.exports = y, y.inspect = function() {
              return "[Emscripten Module object]";
            };
          } else
            (M || G) && (G ? F = self.location.href : typeof document < "u" && document.currentScript && (F = document.currentScript.src), F = F.indexOf("blob:") !== 0 ? F.substr(0, F.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", E = (At) => {
              try {
                var hn = new XMLHttpRequest();
                return hn.open("GET", At, !1), hn.send(null), hn.responseText;
              } catch (Lt) {
                var $t = Ht(At);
                if ($t)
                  return function(Qn) {
                    for (var ce = [], Ze = 0; Ze < Qn.length; Ze++) {
                      var ft = Qn[Ze];
                      ft > 255 && (ft &= 255), ce.push(String.fromCharCode(ft));
                    }
                    return ce.join("");
                  }($t);
                throw Lt;
              }
            }, G && (T = (At) => {
              try {
                var hn = new XMLHttpRequest();
                return hn.open("GET", At, !1), hn.responseType = "arraybuffer", hn.send(null), new Uint8Array(hn.response);
              } catch (Lt) {
                var $t = Ht(At);
                if ($t)
                  return $t;
                throw Lt;
              }
            }), O = (At, hn, $t) => {
              var Lt = new XMLHttpRequest();
              Lt.open("GET", At, !0), Lt.responseType = "arraybuffer", Lt.onload = () => {
                if (Lt.status == 200 || Lt.status == 0 && Lt.response)
                  hn(Lt.response);
                else {
                  var Qn = Ht(At);
                  Qn ? hn(Qn.buffer) : $t();
                }
              }, Lt.onerror = $t, Lt.send(null);
            });
          y.print;
          var ue, Q, Y = y.printErr || void 0;
          Object.assign(y, V), V = null, y.arguments && y.arguments, y.thisProgram && y.thisProgram, y.quit && y.quit, y.wasmBinary && (ue = y.wasmBinary), y.noExitRuntime, typeof WebAssembly != "object" && Ke("no native wasm support detected");
          var pe, oe, ne, H, C, w, P, J = !1, se = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
          function fe(At, hn) {
            return At ? function($t, Lt, Qn) {
              for (var ce = Lt + Qn, Ze = Lt; $t[Ze] && !(Ze >= ce); )
                ++Ze;
              if (Ze - Lt > 16 && $t.buffer && se)
                return se.decode($t.subarray(Lt, Ze));
              for (var ft = ""; Lt < Ze; ) {
                var It = $t[Lt++];
                if (128 & It) {
                  var rn = 63 & $t[Lt++];
                  if ((224 & It) != 192) {
                    var Ln = 63 & $t[Lt++];
                    if ((It = (240 & It) == 224 ? (15 & It) << 12 | rn << 6 | Ln : (7 & It) << 18 | rn << 12 | Ln << 6 | 63 & $t[Lt++]) < 65536)
                      ft += String.fromCharCode(It);
                    else {
                      var Pn = It - 65536;
                      ft += String.fromCharCode(55296 | Pn >> 10, 56320 | 1023 & Pn);
                    }
                  } else
                    ft += String.fromCharCode((31 & It) << 6 | rn);
                } else
                  ft += String.fromCharCode(It);
              }
              return ft;
            }(oe, At, hn) : "";
          }
          function N() {
            var At = Q.buffer;
            y.HEAP8 = pe = new Int8Array(At), y.HEAP16 = ne = new Int16Array(At), y.HEAP32 = H = new Int32Array(At), y.HEAPU8 = oe = new Uint8Array(At), y.HEAPU16 = new Uint16Array(At), y.HEAPU32 = C = new Uint32Array(At), y.HEAPF32 = w = new Float32Array(At), y.HEAPF64 = P = new Float64Array(At);
          }
          var W = [], I = [], te = [], ge = 0, Pe = null;
          function Ke(At) {
            throw y.onAbort && y.onAbort(At), Y(At = "Aborted(" + At + ")"), J = !0, At += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(At);
          }
          var xe, ze, nt, Qt, Et = "data:application/octet-stream;base64,";
          function zt(At) {
            return At.startsWith(Et);
          }
          function Nt(At) {
            return At.startsWith("file://");
          }
          function pt(At) {
            try {
              if (At == xe && ue)
                return new Uint8Array(ue);
              var hn = Ht(At);
              if (hn)
                return hn;
              if (T)
                return T(At);
              throw "both async and sync fetching of the wasm failed";
            } catch ($t) {
              Ke($t);
            }
          }
          zt(xe = "data:application/octet-stream;base64,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") || (ze = xe, xe = y.locateFile ? y.locateFile(ze, F) : F + ze);
          var at = { 34904: () => y.getRandomValue(), 34940: () => {
            if (y.getRandomValue === void 0)
              try {
                var At = typeof window == "object" ? window : self, hn = At.crypto !== void 0 ? At.crypto : At.msCrypto, $t = function() {
                  var ce = new Uint32Array(1);
                  return hn.getRandomValues(ce), ce[0] >>> 0;
                };
                $t(), y.getRandomValue = $t;
              } catch {
                try {
                  var Lt = requireCryptoBrowserify(), Qn = function() {
                    var Ze = Lt.randomBytes(4);
                    return (Ze[0] << 24 | Ze[1] << 16 | Ze[2] << 8 | Ze[3]) >>> 0;
                  };
                  Qn(), y.getRandomValue = Qn;
                } catch {
                  throw "No secure random number generator found";
                }
              }
          } };
          function kt(At) {
            for (; At.length > 0; )
              At.shift()(y);
          }
          var Ut = [];
          function dn(At) {
            var hn = Q.buffer;
            try {
              return Q.grow(At - hn.byteLength + 65535 >>> 16), N(), 1;
            } catch {
            }
          }
          var En = typeof atob == "function" ? atob : function(At) {
            var hn, $t, Lt, Qn, ce, Ze, ft = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", It = "", rn = 0;
            At = At.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            do
              hn = ft.indexOf(At.charAt(rn++)) << 2 | (Qn = ft.indexOf(At.charAt(rn++))) >> 4, $t = (15 & Qn) << 4 | (ce = ft.indexOf(At.charAt(rn++))) >> 2, Lt = (3 & ce) << 6 | (Ze = ft.indexOf(At.charAt(rn++))), It += String.fromCharCode(hn), ce !== 64 && (It += String.fromCharCode($t)), Ze !== 64 && (It += String.fromCharCode(Lt));
            while (rn < At.length);
            return It;
          };
          function Ht(At) {
            if (zt(At))
              return function(hn) {
                if (typeof k == "boolean" && k) {
                  var $t = Buffer.from(hn, "base64");
                  return new Uint8Array($t.buffer, $t.byteOffset, $t.byteLength);
                }
                try {
                  for (var Lt = En(hn), Qn = new Uint8Array(Lt.length), ce = 0; ce < Lt.length; ++ce)
                    Qn[ce] = Lt.charCodeAt(ce);
                  return Qn;
                } catch {
                  throw new Error("Converting base64 string to bytes failed.");
                }
              }(At.slice(Et.length));
          }
          var Xt, On = { b: function(At, hn, $t, Lt) {
            Ke("Assertion failed: " + fe(At) + ", at: " + [hn ? fe(hn) : "unknown filename", $t, Lt ? fe(Lt) : "unknown function"]);
          }, c: function() {
            Ke("");
          }, a: function(At, hn, $t) {
            return function(Lt, Qn, ce) {
              var Ze = function(ft, It) {
                var rn;
                for (Ut.length = 0, It >>= 2; rn = oe[ft++]; )
                  It += rn != 105 & It, Ut.push(rn == 105 ? H[It] : P[It++ >> 1]), ++It;
                return Ut;
              }(Qn, ce);
              return at[Lt].apply(null, Ze);
            }(At, hn, $t);
          }, d: function(At, hn, $t) {
            oe.copyWithin(At, hn, hn + $t);
          }, e: function(At) {
            var hn, $t = oe.length, Lt = 2147483648;
            if ((At >>>= 0) > Lt)
              return !1;
            for (var Qn = 1; Qn <= 4; Qn *= 2) {
              var ce = $t * (1 + 0.2 / Qn);
              if (ce = Math.min(ce, At + 100663296), dn(Math.min(Lt, (hn = Math.max(At, ce)) + (65536 - hn % 65536) % 65536)))
                return !0;
            }
            return !1;
          } };
          function sn() {
            function At() {
              Xt || (Xt = !0, y.calledRun = !0, J || (kt(I), y.onRuntimeInitialized && y.onRuntimeInitialized(), function() {
                if (y.postRun)
                  for (typeof y.postRun == "function" && (y.postRun = [y.postRun]); y.postRun.length; )
                    hn = y.postRun.shift(), te.unshift(hn);
                var hn;
                kt(te);
              }()));
            }
            ge > 0 || (function() {
              if (y.preRun)
                for (typeof y.preRun == "function" && (y.preRun = [y.preRun]); y.preRun.length; )
                  hn = y.preRun.shift(), W.unshift(hn);
              var hn;
              kt(W);
            }(), ge > 0 || (y.setStatus ? (y.setStatus("Running..."), setTimeout(function() {
              setTimeout(function() {
                y.setStatus("");
              }, 1), At();
            }, 1)) : At()));
          }
          if (function() {
            var At = { a: On };
            function hn(Qn, ce) {
              var Ze = Qn.exports;
              y.asm = Ze, Q = y.asm.f, N(), y.asm.ac, function(ft) {
                if (ge--, y.monitorRunDependencies && y.monitorRunDependencies(ge), ge == 0 && Pe) {
                  var It = Pe;
                  Pe = null, It();
                }
              }();
            }
            function $t(Qn) {
              hn(Qn.instance);
            }
            function Lt(Qn) {
              return function() {
                if (!ue && (M || G)) {
                  if (typeof fetch == "function" && !Nt(xe))
                    return fetch(xe, { credentials: "same-origin" }).then(function(ce) {
                      if (!ce.ok)
                        throw "failed to load wasm binary file at '" + xe + "'";
                      return ce.arrayBuffer();
                    }).catch(function() {
                      return pt(xe);
                    });
                  if (O)
                    return new Promise(function(ce, Ze) {
                      O(xe, function(ft) {
                        ce(new Uint8Array(ft));
                      }, Ze);
                    });
                }
                return Promise.resolve().then(function() {
                  return pt(xe);
                });
              }().then(function(ce) {
                return WebAssembly.instantiate(ce, At);
              }).then(function(ce) {
                return ce;
              }).then(Qn, function(ce) {
                Y("failed to asynchronously prepare wasm: " + ce), Ke(ce);
              });
            }
            if (ge++, y.monitorRunDependencies && y.monitorRunDependencies(ge), y.instantiateWasm)
              try {
                return y.instantiateWasm(At, hn);
              } catch (Qn) {
                return Y("Module.instantiateWasm callback failed with error: " + Qn), !1;
              }
            ue || typeof WebAssembly.instantiateStreaming != "function" || zt(xe) || Nt(xe) || k || typeof fetch != "function" ? Lt($t) : fetch(xe, { credentials: "same-origin" }).then(function(Qn) {
              return WebAssembly.instantiateStreaming(Qn, At).then($t, function(ce) {
                return Y("wasm streaming compile failed: " + ce), Y("falling back to ArrayBuffer instantiation"), Lt($t);
              });
            });
          }(), y._crypto_aead_chacha20poly1305_encrypt_detached = function() {
            return (y._crypto_aead_chacha20poly1305_encrypt_detached = y.asm.g).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_encrypt = function() {
            return (y._crypto_aead_chacha20poly1305_encrypt = y.asm.h).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_encrypt_detached = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_encrypt_detached = y.asm.i).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_encrypt = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_encrypt = y.asm.j).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_decrypt_detached = function() {
            return (y._crypto_aead_chacha20poly1305_decrypt_detached = y.asm.k).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_decrypt = function() {
            return (y._crypto_aead_chacha20poly1305_decrypt = y.asm.l).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_decrypt_detached = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_decrypt_detached = y.asm.m).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_decrypt = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_decrypt = y.asm.n).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_keybytes = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_keybytes = y.asm.o).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_npubbytes = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_npubbytes = y.asm.p).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_nsecbytes = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_nsecbytes = y.asm.q).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_abytes = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_abytes = y.asm.r).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_messagebytes_max = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_messagebytes_max = y.asm.s).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_keygen = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_keygen = y.asm.t).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_keybytes = function() {
            return (y._crypto_aead_chacha20poly1305_keybytes = y.asm.u).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_npubbytes = function() {
            return (y._crypto_aead_chacha20poly1305_npubbytes = y.asm.v).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_nsecbytes = function() {
            return (y._crypto_aead_chacha20poly1305_nsecbytes = y.asm.w).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_abytes = function() {
            return (y._crypto_aead_chacha20poly1305_abytes = y.asm.x).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_messagebytes_max = function() {
            return (y._crypto_aead_chacha20poly1305_messagebytes_max = y.asm.y).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_keygen = function() {
            return (y._crypto_aead_chacha20poly1305_keygen = y.asm.z).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = y.asm.A).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_encrypt = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_encrypt = y.asm.B).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = y.asm.C).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_decrypt = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_decrypt = y.asm.D).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_keybytes = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_keybytes = y.asm.E).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_npubbytes = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_npubbytes = y.asm.F).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_nsecbytes = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_nsecbytes = y.asm.G).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_abytes = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_abytes = y.asm.H).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = y.asm.I).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_keygen = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_keygen = y.asm.J).apply(null, arguments);
          }, y._crypto_auth_bytes = function() {
            return (y._crypto_auth_bytes = y.asm.K).apply(null, arguments);
          }, y._crypto_auth_keybytes = function() {
            return (y._crypto_auth_keybytes = y.asm.L).apply(null, arguments);
          }, y._crypto_auth = function() {
            return (y._crypto_auth = y.asm.M).apply(null, arguments);
          }, y._crypto_auth_verify = function() {
            return (y._crypto_auth_verify = y.asm.N).apply(null, arguments);
          }, y._crypto_auth_keygen = function() {
            return (y._crypto_auth_keygen = y.asm.O).apply(null, arguments);
          }, y._crypto_box_seedbytes = function() {
            return (y._crypto_box_seedbytes = y.asm.P).apply(null, arguments);
          }, y._crypto_box_publickeybytes = function() {
            return (y._crypto_box_publickeybytes = y.asm.Q).apply(null, arguments);
          }, y._crypto_box_secretkeybytes = function() {
            return (y._crypto_box_secretkeybytes = y.asm.R).apply(null, arguments);
          }, y._crypto_box_beforenmbytes = function() {
            return (y._crypto_box_beforenmbytes = y.asm.S).apply(null, arguments);
          }, y._crypto_box_noncebytes = function() {
            return (y._crypto_box_noncebytes = y.asm.T).apply(null, arguments);
          }, y._crypto_box_macbytes = function() {
            return (y._crypto_box_macbytes = y.asm.U).apply(null, arguments);
          }, y._crypto_box_messagebytes_max = function() {
            return (y._crypto_box_messagebytes_max = y.asm.V).apply(null, arguments);
          }, y._crypto_box_seed_keypair = function() {
            return (y._crypto_box_seed_keypair = y.asm.W).apply(null, arguments);
          }, y._crypto_box_keypair = function() {
            return (y._crypto_box_keypair = y.asm.X).apply(null, arguments);
          }, y._crypto_box_beforenm = function() {
            return (y._crypto_box_beforenm = y.asm.Y).apply(null, arguments);
          }, y._crypto_box_detached_afternm = function() {
            return (y._crypto_box_detached_afternm = y.asm.Z).apply(null, arguments);
          }, y._crypto_box_detached = function() {
            return (y._crypto_box_detached = y.asm._).apply(null, arguments);
          }, y._crypto_box_easy_afternm = function() {
            return (y._crypto_box_easy_afternm = y.asm.$).apply(null, arguments);
          }, y._crypto_box_easy = function() {
            return (y._crypto_box_easy = y.asm.aa).apply(null, arguments);
          }, y._crypto_box_open_detached_afternm = function() {
            return (y._crypto_box_open_detached_afternm = y.asm.ba).apply(null, arguments);
          }, y._crypto_box_open_detached = function() {
            return (y._crypto_box_open_detached = y.asm.ca).apply(null, arguments);
          }, y._crypto_box_open_easy_afternm = function() {
            return (y._crypto_box_open_easy_afternm = y.asm.da).apply(null, arguments);
          }, y._crypto_box_open_easy = function() {
            return (y._crypto_box_open_easy = y.asm.ea).apply(null, arguments);
          }, y._crypto_box_seal = function() {
            return (y._crypto_box_seal = y.asm.fa).apply(null, arguments);
          }, y._crypto_box_seal_open = function() {
            return (y._crypto_box_seal_open = y.asm.ga).apply(null, arguments);
          }, y._crypto_box_sealbytes = function() {
            return (y._crypto_box_sealbytes = y.asm.ha).apply(null, arguments);
          }, y._crypto_generichash_bytes_min = function() {
            return (y._crypto_generichash_bytes_min = y.asm.ia).apply(null, arguments);
          }, y._crypto_generichash_bytes_max = function() {
            return (y._crypto_generichash_bytes_max = y.asm.ja).apply(null, arguments);
          }, y._crypto_generichash_bytes = function() {
            return (y._crypto_generichash_bytes = y.asm.ka).apply(null, arguments);
          }, y._crypto_generichash_keybytes_min = function() {
            return (y._crypto_generichash_keybytes_min = y.asm.la).apply(null, arguments);
          }, y._crypto_generichash_keybytes_max = function() {
            return (y._crypto_generichash_keybytes_max = y.asm.ma).apply(null, arguments);
          }, y._crypto_generichash_keybytes = function() {
            return (y._crypto_generichash_keybytes = y.asm.na).apply(null, arguments);
          }, y._crypto_generichash_statebytes = function() {
            return (y._crypto_generichash_statebytes = y.asm.oa).apply(null, arguments);
          }, y._crypto_generichash = function() {
            return (y._crypto_generichash = y.asm.pa).apply(null, arguments);
          }, y._crypto_generichash_init = function() {
            return (y._crypto_generichash_init = y.asm.qa).apply(null, arguments);
          }, y._crypto_generichash_update = function() {
            return (y._crypto_generichash_update = y.asm.ra).apply(null, arguments);
          }, y._crypto_generichash_final = function() {
            return (y._crypto_generichash_final = y.asm.sa).apply(null, arguments);
          }, y._crypto_generichash_keygen = function() {
            return (y._crypto_generichash_keygen = y.asm.ta).apply(null, arguments);
          }, y._crypto_hash_bytes = function() {
            return (y._crypto_hash_bytes = y.asm.ua).apply(null, arguments);
          }, y._crypto_hash = function() {
            return (y._crypto_hash = y.asm.va).apply(null, arguments);
          }, y._crypto_kdf_bytes_min = function() {
            return (y._crypto_kdf_bytes_min = y.asm.wa).apply(null, arguments);
          }, y._crypto_kdf_bytes_max = function() {
            return (y._crypto_kdf_bytes_max = y.asm.xa).apply(null, arguments);
          }, y._crypto_kdf_contextbytes = function() {
            return (y._crypto_kdf_contextbytes = y.asm.ya).apply(null, arguments);
          }, y._crypto_kdf_keybytes = function() {
            return (y._crypto_kdf_keybytes = y.asm.za).apply(null, arguments);
          }, y._crypto_kdf_derive_from_key = function() {
            return (y._crypto_kdf_derive_from_key = y.asm.Aa).apply(null, arguments);
          }, y._crypto_kdf_keygen = function() {
            return (y._crypto_kdf_keygen = y.asm.Ba).apply(null, arguments);
          }, y._crypto_kx_seed_keypair = function() {
            return (y._crypto_kx_seed_keypair = y.asm.Ca).apply(null, arguments);
          }, y._crypto_kx_keypair = function() {
            return (y._crypto_kx_keypair = y.asm.Da).apply(null, arguments);
          }, y._crypto_kx_client_session_keys = function() {
            return (y._crypto_kx_client_session_keys = y.asm.Ea).apply(null, arguments);
          }, y._crypto_kx_server_session_keys = function() {
            return (y._crypto_kx_server_session_keys = y.asm.Fa).apply(null, arguments);
          }, y._crypto_kx_publickeybytes = function() {
            return (y._crypto_kx_publickeybytes = y.asm.Ga).apply(null, arguments);
          }, y._crypto_kx_secretkeybytes = function() {
            return (y._crypto_kx_secretkeybytes = y.asm.Ha).apply(null, arguments);
          }, y._crypto_kx_seedbytes = function() {
            return (y._crypto_kx_seedbytes = y.asm.Ia).apply(null, arguments);
          }, y._crypto_kx_sessionkeybytes = function() {
            return (y._crypto_kx_sessionkeybytes = y.asm.Ja).apply(null, arguments);
          }, y._crypto_scalarmult_base = function() {
            return (y._crypto_scalarmult_base = y.asm.Ka).apply(null, arguments);
          }, y._crypto_scalarmult = function() {
            return (y._crypto_scalarmult = y.asm.La).apply(null, arguments);
          }, y._crypto_scalarmult_bytes = function() {
            return (y._crypto_scalarmult_bytes = y.asm.Ma).apply(null, arguments);
          }, y._crypto_scalarmult_scalarbytes = function() {
            return (y._crypto_scalarmult_scalarbytes = y.asm.Na).apply(null, arguments);
          }, y._crypto_secretbox_keybytes = function() {
            return (y._crypto_secretbox_keybytes = y.asm.Oa).apply(null, arguments);
          }, y._crypto_secretbox_noncebytes = function() {
            return (y._crypto_secretbox_noncebytes = y.asm.Pa).apply(null, arguments);
          }, y._crypto_secretbox_macbytes = function() {
            return (y._crypto_secretbox_macbytes = y.asm.Qa).apply(null, arguments);
          }, y._crypto_secretbox_messagebytes_max = function() {
            return (y._crypto_secretbox_messagebytes_max = y.asm.Ra).apply(null, arguments);
          }, y._crypto_secretbox_keygen = function() {
            return (y._crypto_secretbox_keygen = y.asm.Sa).apply(null, arguments);
          }, y._crypto_secretbox_detached = function() {
            return (y._crypto_secretbox_detached = y.asm.Ta).apply(null, arguments);
          }, y._crypto_secretbox_easy = function() {
            return (y._crypto_secretbox_easy = y.asm.Ua).apply(null, arguments);
          }, y._crypto_secretbox_open_detached = function() {
            return (y._crypto_secretbox_open_detached = y.asm.Va).apply(null, arguments);
          }, y._crypto_secretbox_open_easy = function() {
            return (y._crypto_secretbox_open_easy = y.asm.Wa).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_keygen = function() {
            return (y._crypto_secretstream_xchacha20poly1305_keygen = y.asm.Xa).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_init_push = function() {
            return (y._crypto_secretstream_xchacha20poly1305_init_push = y.asm.Ya).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_init_pull = function() {
            return (y._crypto_secretstream_xchacha20poly1305_init_pull = y.asm.Za).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_rekey = function() {
            return (y._crypto_secretstream_xchacha20poly1305_rekey = y.asm._a).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_push = function() {
            return (y._crypto_secretstream_xchacha20poly1305_push = y.asm.$a).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_pull = function() {
            return (y._crypto_secretstream_xchacha20poly1305_pull = y.asm.ab).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_statebytes = function() {
            return (y._crypto_secretstream_xchacha20poly1305_statebytes = y.asm.bb).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_abytes = function() {
            return (y._crypto_secretstream_xchacha20poly1305_abytes = y.asm.cb).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_headerbytes = function() {
            return (y._crypto_secretstream_xchacha20poly1305_headerbytes = y.asm.db).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_keybytes = function() {
            return (y._crypto_secretstream_xchacha20poly1305_keybytes = y.asm.eb).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_messagebytes_max = function() {
            return (y._crypto_secretstream_xchacha20poly1305_messagebytes_max = y.asm.fb).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_tag_message = function() {
            return (y._crypto_secretstream_xchacha20poly1305_tag_message = y.asm.gb).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_tag_push = function() {
            return (y._crypto_secretstream_xchacha20poly1305_tag_push = y.asm.hb).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_tag_rekey = function() {
            return (y._crypto_secretstream_xchacha20poly1305_tag_rekey = y.asm.ib).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_tag_final = function() {
            return (y._crypto_secretstream_xchacha20poly1305_tag_final = y.asm.jb).apply(null, arguments);
          }, y._crypto_shorthash_bytes = function() {
            return (y._crypto_shorthash_bytes = y.asm.kb).apply(null, arguments);
          }, y._crypto_shorthash_keybytes = function() {
            return (y._crypto_shorthash_keybytes = y.asm.lb).apply(null, arguments);
          }, y._crypto_shorthash = function() {
            return (y._crypto_shorthash = y.asm.mb).apply(null, arguments);
          }, y._crypto_shorthash_keygen = function() {
            return (y._crypto_shorthash_keygen = y.asm.nb).apply(null, arguments);
          }, y._crypto_sign_statebytes = function() {
            return (y._crypto_sign_statebytes = y.asm.ob).apply(null, arguments);
          }, y._crypto_sign_bytes = function() {
            return (y._crypto_sign_bytes = y.asm.pb).apply(null, arguments);
          }, y._crypto_sign_seedbytes = function() {
            return (y._crypto_sign_seedbytes = y.asm.qb).apply(null, arguments);
          }, y._crypto_sign_publickeybytes = function() {
            return (y._crypto_sign_publickeybytes = y.asm.rb).apply(null, arguments);
          }, y._crypto_sign_secretkeybytes = function() {
            return (y._crypto_sign_secretkeybytes = y.asm.sb).apply(null, arguments);
          }, y._crypto_sign_messagebytes_max = function() {
            return (y._crypto_sign_messagebytes_max = y.asm.tb).apply(null, arguments);
          }, y._crypto_sign_seed_keypair = function() {
            return (y._crypto_sign_seed_keypair = y.asm.ub).apply(null, arguments);
          }, y._crypto_sign_keypair = function() {
            return (y._crypto_sign_keypair = y.asm.vb).apply(null, arguments);
          }, y._crypto_sign = function() {
            return (y._crypto_sign = y.asm.wb).apply(null, arguments);
          }, y._crypto_sign_open = function() {
            return (y._crypto_sign_open = y.asm.xb).apply(null, arguments);
          }, y._crypto_sign_detached = function() {
            return (y._crypto_sign_detached = y.asm.yb).apply(null, arguments);
          }, y._crypto_sign_verify_detached = function() {
            return (y._crypto_sign_verify_detached = y.asm.zb).apply(null, arguments);
          }, y._crypto_sign_init = function() {
            return (y._crypto_sign_init = y.asm.Ab).apply(null, arguments);
          }, y._crypto_sign_update = function() {
            return (y._crypto_sign_update = y.asm.Bb).apply(null, arguments);
          }, y._crypto_sign_final_create = function() {
            return (y._crypto_sign_final_create = y.asm.Cb).apply(null, arguments);
          }, y._crypto_sign_final_verify = function() {
            return (y._crypto_sign_final_verify = y.asm.Db).apply(null, arguments);
          }, y._crypto_sign_ed25519_pk_to_curve25519 = function() {
            return (y._crypto_sign_ed25519_pk_to_curve25519 = y.asm.Eb).apply(null, arguments);
          }, y._crypto_sign_ed25519_sk_to_curve25519 = function() {
            return (y._crypto_sign_ed25519_sk_to_curve25519 = y.asm.Fb).apply(null, arguments);
          }, y._randombytes_random = function() {
            return (y._randombytes_random = y.asm.Gb).apply(null, arguments);
          }, y._randombytes_stir = function() {
            return (y._randombytes_stir = y.asm.Hb).apply(null, arguments);
          }, y._randombytes_uniform = function() {
            return (y._randombytes_uniform = y.asm.Ib).apply(null, arguments);
          }, y._randombytes_buf = function() {
            return (y._randombytes_buf = y.asm.Jb).apply(null, arguments);
          }, y._randombytes_buf_deterministic = function() {
            return (y._randombytes_buf_deterministic = y.asm.Kb).apply(null, arguments);
          }, y._randombytes_seedbytes = function() {
            return (y._randombytes_seedbytes = y.asm.Lb).apply(null, arguments);
          }, y._randombytes_close = function() {
            return (y._randombytes_close = y.asm.Mb).apply(null, arguments);
          }, y._randombytes = function() {
            return (y._randombytes = y.asm.Nb).apply(null, arguments);
          }, y._sodium_bin2hex = function() {
            return (y._sodium_bin2hex = y.asm.Ob).apply(null, arguments);
          }, y._sodium_hex2bin = function() {
            return (y._sodium_hex2bin = y.asm.Pb).apply(null, arguments);
          }, y._sodium_base64_encoded_len = function() {
            return (y._sodium_base64_encoded_len = y.asm.Qb).apply(null, arguments);
          }, y._sodium_bin2base64 = function() {
            return (y._sodium_bin2base64 = y.asm.Rb).apply(null, arguments);
          }, y._sodium_base642bin = function() {
            return (y._sodium_base642bin = y.asm.Sb).apply(null, arguments);
          }, y._sodium_init = function() {
            return (y._sodium_init = y.asm.Tb).apply(null, arguments);
          }, y._sodium_pad = function() {
            return (y._sodium_pad = y.asm.Ub).apply(null, arguments);
          }, y._sodium_unpad = function() {
            return (y._sodium_unpad = y.asm.Vb).apply(null, arguments);
          }, y._sodium_version_string = function() {
            return (y._sodium_version_string = y.asm.Wb).apply(null, arguments);
          }, y._sodium_library_version_major = function() {
            return (y._sodium_library_version_major = y.asm.Xb).apply(null, arguments);
          }, y._sodium_library_version_minor = function() {
            return (y._sodium_library_version_minor = y.asm.Yb).apply(null, arguments);
          }, y._sodium_library_minimal = function() {
            return (y._sodium_library_minimal = y.asm.Zb).apply(null, arguments);
          }, y._malloc = function() {
            return (y._malloc = y.asm._b).apply(null, arguments);
          }, y._free = function() {
            return (y._free = y.asm.$b).apply(null, arguments);
          }, y.UTF8ToString = fe, y.setValue = function(At, hn, $t = "i8") {
            switch ($t.endsWith("*") && ($t = "*"), $t) {
              case "i1":
              case "i8":
                pe[At >> 0] = hn;
                break;
              case "i16":
                ne[At >> 1] = hn;
                break;
              case "i32":
                H[At >> 2] = hn;
                break;
              case "i64":
                Qt = [hn >>> 0, (nt = hn, +Math.abs(nt) >= 1 ? nt > 0 ? (0 | Math.min(+Math.floor(nt / 4294967296), 4294967295)) >>> 0 : ~~+Math.ceil((nt - +(~~nt >>> 0)) / 4294967296) >>> 0 : 0)], H[At >> 2] = Qt[0], H[At + 4 >> 2] = Qt[1];
                break;
              case "float":
                w[At >> 2] = hn;
                break;
              case "double":
                P[At >> 3] = hn;
                break;
              case "*":
                C[At >> 2] = hn;
                break;
              default:
                Ke("invalid type for setValue: " + $t);
            }
          }, y.getValue = function(At, hn = "i8") {
            switch (hn.endsWith("*") && (hn = "*"), hn) {
              case "i1":
              case "i8":
                return pe[At >> 0];
              case "i16":
                return ne[At >> 1];
              case "i32":
              case "i64":
                return H[At >> 2];
              case "float":
                return w[At >> 2];
              case "double":
                return P[At >> 3];
              case "*":
                return C[At >> 2];
              default:
                Ke("invalid type for getValue: " + hn);
            }
            return null;
          }, Pe = function At() {
            Xt || sn(), Xt || (Pe = At);
          }, y.preInit)
            for (typeof y.preInit == "function" && (y.preInit = [y.preInit]); y.preInit.length > 0; )
              y.preInit.pop()();
          sn();
        }).catch(function() {
          return v.useBackupModule();
        }), d;
      }
      typeof n.nodeName != "string" ? u(n) : o.libsodium = u(o.libsodium_mod || (o.commonJsStrict = {}));
    })(commonjsGlobal);
  }(libsodium$7, libsodium$7.exports)), libsodium$7.exports;
}
(function(e) {
  (function(n) {
    function o(c, d) {
      var m, v = "uint8array", S = d.ready.then(function() {
        function Se() {
          if (m._sodium_init() !== 0)
            throw new Error("libsodium was not correctly initialized.");
          for (var qe = ["crypto_aead_chacha20poly1305_decrypt", "crypto_aead_chacha20poly1305_decrypt_detached", "crypto_aead_chacha20poly1305_encrypt", "crypto_aead_chacha20poly1305_encrypt_detached", "crypto_aead_chacha20poly1305_ietf_decrypt", "crypto_aead_chacha20poly1305_ietf_decrypt_detached", "crypto_aead_chacha20poly1305_ietf_encrypt", "crypto_aead_chacha20poly1305_ietf_encrypt_detached", "crypto_aead_chacha20poly1305_ietf_keygen", "crypto_aead_chacha20poly1305_keygen", "crypto_aead_xchacha20poly1305_ietf_decrypt", "crypto_aead_xchacha20poly1305_ietf_decrypt_detached", "crypto_aead_xchacha20poly1305_ietf_encrypt", "crypto_aead_xchacha20poly1305_ietf_encrypt_detached", "crypto_aead_xchacha20poly1305_ietf_keygen", "crypto_auth", "crypto_auth_hmacsha256", "crypto_auth_hmacsha256_final", "crypto_auth_hmacsha256_init", "crypto_auth_hmacsha256_keygen", "crypto_auth_hmacsha256_update", "crypto_auth_hmacsha256_verify", "crypto_auth_hmacsha512", "crypto_auth_hmacsha512_final", "crypto_auth_hmacsha512_init", "crypto_auth_hmacsha512_keygen", "crypto_auth_hmacsha512_update", "crypto_auth_hmacsha512_verify", "crypto_auth_keygen", "crypto_auth_verify", "crypto_box_beforenm", "crypto_box_curve25519xchacha20poly1305_keypair", "crypto_box_curve25519xchacha20poly1305_seal", "crypto_box_curve25519xchacha20poly1305_seal_open", "crypto_box_detached", "crypto_box_easy", "crypto_box_easy_afternm", "crypto_box_keypair", "crypto_box_open_detached", "crypto_box_open_easy", "crypto_box_open_easy_afternm", "crypto_box_seal", "crypto_box_seal_open", "crypto_box_seed_keypair", "crypto_core_ed25519_add", "crypto_core_ed25519_from_hash", "crypto_core_ed25519_from_uniform", "crypto_core_ed25519_is_valid_point", "crypto_core_ed25519_random", "crypto_core_ed25519_scalar_add", "crypto_core_ed25519_scalar_complement", "crypto_core_ed25519_scalar_invert", "crypto_core_ed25519_scalar_mul", "crypto_core_ed25519_scalar_negate", "crypto_core_ed25519_scalar_random", "crypto_core_ed25519_scalar_reduce", "crypto_core_ed25519_scalar_sub", "crypto_core_ed25519_sub", "crypto_core_hchacha20", "crypto_core_hsalsa20", "crypto_core_ristretto255_add", "crypto_core_ristretto255_from_hash", "crypto_core_ristretto255_is_valid_point", "crypto_core_ristretto255_random", "crypto_core_ristretto255_scalar_add", "crypto_core_ristretto255_scalar_complement", "crypto_core_ristretto255_scalar_invert", "crypto_core_ristretto255_scalar_mul", "crypto_core_ristretto255_scalar_negate", "crypto_core_ristretto255_scalar_random", "crypto_core_ristretto255_scalar_reduce", "crypto_core_ristretto255_scalar_sub", "crypto_core_ristretto255_sub", "crypto_generichash", "crypto_generichash_blake2b_salt_personal", "crypto_generichash_final", "crypto_generichash_init", "crypto_generichash_keygen", "crypto_generichash_update", "crypto_hash", "crypto_hash_sha256", "crypto_hash_sha256_final", "crypto_hash_sha256_init", "crypto_hash_sha256_update", "crypto_hash_sha512", "crypto_hash_sha512_final", "crypto_hash_sha512_init", "crypto_hash_sha512_update", "crypto_kdf_derive_from_key", "crypto_kdf_keygen", "crypto_kx_client_session_keys", "crypto_kx_keypair", "crypto_kx_seed_keypair", "crypto_kx_server_session_keys", "crypto_onetimeauth", "crypto_onetimeauth_final", "crypto_onetimeauth_init", "crypto_onetimeauth_keygen", "crypto_onetimeauth_update", "crypto_onetimeauth_verify", "crypto_pwhash", "crypto_pwhash_scryptsalsa208sha256", "crypto_pwhash_scryptsalsa208sha256_ll", "crypto_pwhash_scryptsalsa208sha256_str", "crypto_pwhash_scryptsalsa208sha256_str_verify", "crypto_pwhash_str", "crypto_pwhash_str_needs_rehash", "crypto_pwhash_str_verify", "crypto_scalarmult", "crypto_scalarmult_base", "crypto_scalarmult_ed25519", "crypto_scalarmult_ed25519_base", "crypto_scalarmult_ed25519_base_noclamp", "crypto_scalarmult_ed25519_noclamp", "crypto_scalarmult_ristretto255", "crypto_scalarmult_ristretto255_base", "crypto_secretbox_detached", "crypto_secretbox_easy", "crypto_secretbox_keygen", "crypto_secretbox_open_detached", "crypto_secretbox_open_easy", "crypto_secretstream_xchacha20poly1305_init_pull", "crypto_secretstream_xchacha20poly1305_init_push", "crypto_secretstream_xchacha20poly1305_keygen", "crypto_secretstream_xchacha20poly1305_pull", "crypto_secretstream_xchacha20poly1305_push", "crypto_secretstream_xchacha20poly1305_rekey", "crypto_shorthash", "crypto_shorthash_keygen", "crypto_shorthash_siphashx24", "crypto_sign", "crypto_sign_detached", "crypto_sign_ed25519_pk_to_curve25519", "crypto_sign_ed25519_sk_to_curve25519", "crypto_sign_ed25519_sk_to_pk", "crypto_sign_ed25519_sk_to_seed", "crypto_sign_final_create", "crypto_sign_final_verify", "crypto_sign_init", "crypto_sign_keypair", "crypto_sign_open", "crypto_sign_seed_keypair", "crypto_sign_update", "crypto_sign_verify_detached", "crypto_stream_chacha20", "crypto_stream_chacha20_ietf_xor", "crypto_stream_chacha20_ietf_xor_ic", "crypto_stream_chacha20_keygen", "crypto_stream_chacha20_xor", "crypto_stream_chacha20_xor_ic", "crypto_stream_keygen", "crypto_stream_xchacha20_keygen", "crypto_stream_xchacha20_xor", "crypto_stream_xchacha20_xor_ic", "randombytes_buf", "randombytes_buf_deterministic", "randombytes_close", "randombytes_random", "randombytes_set_implementation", "randombytes_stir", "randombytes_uniform", "sodium_version_string"], Xe = [ne, H, C, w, P, J, se, fe, N, W, I, te, ge, Pe, Ke, xe, ze, nt, Qt, Et, zt, Nt, pt, at, kt, Ut, dn, En, Ht, Xt, On, sn, At, hn, $t, Lt, Qn, ce, Ze, ft, It, rn, Ln, Pn, Ae, Me, He, cn, Wt, yn, pr, Uo, ar, Sr, Jo, fr, Er, vo, lr, $r, Wo, yr, Dr, Zo, dr, Br, Qo, tr, Mr, qo, hr, Or, Fo, No, di, gi, ai, ui, hi, bi, ii, pi, Ci, _i, xn, sr, Nr, vr, Yr, Fr, eo, Xr, Mo, jo, Ii, ki, j, l, B, Ri, wr, zi, ks, Hs, Oa, qa, st, Oe, Bs, ve, $s, aa, gr, rr, Vi, Cn, Ks, Qi, ua, wa, In, Ys, Zs, Ia, Ot, js, ca, Ui, Ni, da, ma, ga, la, _s, wi, ha, as, qi, Aa, ka, ms, Ps, Gs, Ba, Ms, Xs, ea, Ji, Si, Ts, Ds, gs, Os, vt, bs, Di, Pa, Ea, Cs, ya, dt, ds], yt = 0; yt < Xe.length; yt++)
            typeof m["_" + qe[yt]] == "function" && (c[qe[yt]] = Xe[yt]);
          var Rt = ["SODIUM_LIBRARY_VERSION_MAJOR", "SODIUM_LIBRARY_VERSION_MINOR", "crypto_aead_chacha20poly1305_ABYTES", "crypto_aead_chacha20poly1305_IETF_ABYTES", "crypto_aead_chacha20poly1305_IETF_KEYBYTES", "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_IETF_NPUBBYTES", "crypto_aead_chacha20poly1305_IETF_NSECBYTES", "crypto_aead_chacha20poly1305_KEYBYTES", "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_NPUBBYTES", "crypto_aead_chacha20poly1305_NSECBYTES", "crypto_aead_chacha20poly1305_ietf_ABYTES", "crypto_aead_chacha20poly1305_ietf_KEYBYTES", "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_ietf_NPUBBYTES", "crypto_aead_chacha20poly1305_ietf_NSECBYTES", "crypto_aead_xchacha20poly1305_IETF_ABYTES", "crypto_aead_xchacha20poly1305_IETF_KEYBYTES", "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX", "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES", "crypto_aead_xchacha20poly1305_IETF_NSECBYTES", "crypto_aead_xchacha20poly1305_ietf_ABYTES", "crypto_aead_xchacha20poly1305_ietf_KEYBYTES", "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX", "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES", "crypto_aead_xchacha20poly1305_ietf_NSECBYTES", "crypto_auth_BYTES", "crypto_auth_KEYBYTES", "crypto_auth_hmacsha256_BYTES", "crypto_auth_hmacsha256_KEYBYTES", "crypto_auth_hmacsha512256_BYTES", "crypto_auth_hmacsha512256_KEYBYTES", "crypto_auth_hmacsha512_BYTES", "crypto_auth_hmacsha512_KEYBYTES", "crypto_box_BEFORENMBYTES", "crypto_box_MACBYTES", "crypto_box_MESSAGEBYTES_MAX", "crypto_box_NONCEBYTES", "crypto_box_PUBLICKEYBYTES", "crypto_box_SEALBYTES", "crypto_box_SECRETKEYBYTES", "crypto_box_SEEDBYTES", "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES", "crypto_box_curve25519xchacha20poly1305_MACBYTES", "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_box_curve25519xchacha20poly1305_NONCEBYTES", "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES", "crypto_box_curve25519xchacha20poly1305_SEALBYTES", "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES", "crypto_box_curve25519xchacha20poly1305_SEEDBYTES", "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES", "crypto_box_curve25519xsalsa20poly1305_MACBYTES", "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX", "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES", "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES", "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES", "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES", "crypto_core_ed25519_BYTES", "crypto_core_ed25519_HASHBYTES", "crypto_core_ed25519_NONREDUCEDSCALARBYTES", "crypto_core_ed25519_SCALARBYTES", "crypto_core_ed25519_UNIFORMBYTES", "crypto_core_hchacha20_CONSTBYTES", "crypto_core_hchacha20_INPUTBYTES", "crypto_core_hchacha20_KEYBYTES", "crypto_core_hchacha20_OUTPUTBYTES", "crypto_core_hsalsa20_CONSTBYTES", "crypto_core_hsalsa20_INPUTBYTES", "crypto_core_hsalsa20_KEYBYTES", "crypto_core_hsalsa20_OUTPUTBYTES", "crypto_core_ristretto255_BYTES", "crypto_core_ristretto255_HASHBYTES", "crypto_core_ristretto255_NONREDUCEDSCALARBYTES", "crypto_core_ristretto255_SCALARBYTES", "crypto_core_salsa2012_CONSTBYTES", "crypto_core_salsa2012_INPUTBYTES", "crypto_core_salsa2012_KEYBYTES", "crypto_core_salsa2012_OUTPUTBYTES", "crypto_core_salsa20_CONSTBYTES", "crypto_core_salsa20_INPUTBYTES", "crypto_core_salsa20_KEYBYTES", "crypto_core_salsa20_OUTPUTBYTES", "crypto_generichash_BYTES", "crypto_generichash_BYTES_MAX", "crypto_generichash_BYTES_MIN", "crypto_generichash_KEYBYTES", "crypto_generichash_KEYBYTES_MAX", "crypto_generichash_KEYBYTES_MIN", "crypto_generichash_blake2b_BYTES", "crypto_generichash_blake2b_BYTES_MAX", "crypto_generichash_blake2b_BYTES_MIN", "crypto_generichash_blake2b_KEYBYTES", "crypto_generichash_blake2b_KEYBYTES_MAX", "crypto_generichash_blake2b_KEYBYTES_MIN", "crypto_generichash_blake2b_PERSONALBYTES", "crypto_generichash_blake2b_SALTBYTES", "crypto_hash_BYTES", "crypto_hash_sha256_BYTES", "crypto_hash_sha512_BYTES", "crypto_kdf_BYTES_MAX", "crypto_kdf_BYTES_MIN", "crypto_kdf_CONTEXTBYTES", "crypto_kdf_KEYBYTES", "crypto_kdf_blake2b_BYTES_MAX", "crypto_kdf_blake2b_BYTES_MIN", "crypto_kdf_blake2b_CONTEXTBYTES", "crypto_kdf_blake2b_KEYBYTES", "crypto_kx_PUBLICKEYBYTES", "crypto_kx_SECRETKEYBYTES", "crypto_kx_SEEDBYTES", "crypto_kx_SESSIONKEYBYTES", "crypto_onetimeauth_BYTES", "crypto_onetimeauth_KEYBYTES", "crypto_onetimeauth_poly1305_BYTES", "crypto_onetimeauth_poly1305_KEYBYTES", "crypto_pwhash_ALG_ARGON2I13", "crypto_pwhash_ALG_ARGON2ID13", "crypto_pwhash_ALG_DEFAULT", "crypto_pwhash_BYTES_MAX", "crypto_pwhash_BYTES_MIN", "crypto_pwhash_MEMLIMIT_INTERACTIVE", "crypto_pwhash_MEMLIMIT_MAX", "crypto_pwhash_MEMLIMIT_MIN", "crypto_pwhash_MEMLIMIT_MODERATE", "crypto_pwhash_MEMLIMIT_SENSITIVE", "crypto_pwhash_OPSLIMIT_INTERACTIVE", "crypto_pwhash_OPSLIMIT_MAX", "crypto_pwhash_OPSLIMIT_MIN", "crypto_pwhash_OPSLIMIT_MODERATE", "crypto_pwhash_OPSLIMIT_SENSITIVE", "crypto_pwhash_PASSWD_MAX", "crypto_pwhash_PASSWD_MIN", "crypto_pwhash_SALTBYTES", "crypto_pwhash_STRBYTES", "crypto_pwhash_argon2i_BYTES_MAX", "crypto_pwhash_argon2i_BYTES_MIN", "crypto_pwhash_argon2i_SALTBYTES", "crypto_pwhash_argon2i_STRBYTES", "crypto_pwhash_argon2id_BYTES_MAX", "crypto_pwhash_argon2id_BYTES_MIN", "crypto_pwhash_argon2id_SALTBYTES", "crypto_pwhash_argon2id_STRBYTES", "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX", "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE", "crypto_pwhash_scryptsalsa208sha256_SALTBYTES", "crypto_pwhash_scryptsalsa208sha256_STRBYTES", "crypto_scalarmult_BYTES", "crypto_scalarmult_SCALARBYTES", "crypto_scalarmult_curve25519_BYTES", "crypto_scalarmult_curve25519_SCALARBYTES", "crypto_scalarmult_ed25519_BYTES", "crypto_scalarmult_ed25519_SCALARBYTES", "crypto_scalarmult_ristretto255_BYTES", "crypto_scalarmult_ristretto255_SCALARBYTES", "crypto_secretbox_KEYBYTES", "crypto_secretbox_MACBYTES", "crypto_secretbox_MESSAGEBYTES_MAX", "crypto_secretbox_NONCEBYTES", "crypto_secretbox_xchacha20poly1305_KEYBYTES", "crypto_secretbox_xchacha20poly1305_MACBYTES", "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_secretbox_xchacha20poly1305_NONCEBYTES", "crypto_secretbox_xsalsa20poly1305_KEYBYTES", "crypto_secretbox_xsalsa20poly1305_MACBYTES", "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX", "crypto_secretbox_xsalsa20poly1305_NONCEBYTES", "crypto_secretstream_xchacha20poly1305_ABYTES", "crypto_secretstream_xchacha20poly1305_HEADERBYTES", "crypto_secretstream_xchacha20poly1305_KEYBYTES", "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_secretstream_xchacha20poly1305_TAG_FINAL", "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE", "crypto_secretstream_xchacha20poly1305_TAG_PUSH", "crypto_secretstream_xchacha20poly1305_TAG_REKEY", "crypto_shorthash_BYTES", "crypto_shorthash_KEYBYTES", "crypto_shorthash_siphash24_BYTES", "crypto_shorthash_siphash24_KEYBYTES", "crypto_shorthash_siphashx24_BYTES", "crypto_shorthash_siphashx24_KEYBYTES", "crypto_sign_BYTES", "crypto_sign_MESSAGEBYTES_MAX", "crypto_sign_PUBLICKEYBYTES", "crypto_sign_SECRETKEYBYTES", "crypto_sign_SEEDBYTES", "crypto_sign_ed25519_BYTES", "crypto_sign_ed25519_MESSAGEBYTES_MAX", "crypto_sign_ed25519_PUBLICKEYBYTES", "crypto_sign_ed25519_SECRETKEYBYTES", "crypto_sign_ed25519_SEEDBYTES", "crypto_stream_KEYBYTES", "crypto_stream_MESSAGEBYTES_MAX", "crypto_stream_NONCEBYTES", "crypto_stream_chacha20_IETF_KEYBYTES", "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX", "crypto_stream_chacha20_IETF_NONCEBYTES", "crypto_stream_chacha20_KEYBYTES", "crypto_stream_chacha20_MESSAGEBYTES_MAX", "crypto_stream_chacha20_NONCEBYTES", "crypto_stream_chacha20_ietf_KEYBYTES", "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX", "crypto_stream_chacha20_ietf_NONCEBYTES", "crypto_stream_salsa2012_KEYBYTES", "crypto_stream_salsa2012_MESSAGEBYTES_MAX", "crypto_stream_salsa2012_NONCEBYTES", "crypto_stream_salsa208_KEYBYTES", "crypto_stream_salsa208_MESSAGEBYTES_MAX", "crypto_stream_salsa208_NONCEBYTES", "crypto_stream_salsa20_KEYBYTES", "crypto_stream_salsa20_MESSAGEBYTES_MAX", "crypto_stream_salsa20_NONCEBYTES", "crypto_stream_xchacha20_KEYBYTES", "crypto_stream_xchacha20_MESSAGEBYTES_MAX", "crypto_stream_xchacha20_NONCEBYTES", "crypto_stream_xsalsa20_KEYBYTES", "crypto_stream_xsalsa20_MESSAGEBYTES_MAX", "crypto_stream_xsalsa20_NONCEBYTES", "crypto_verify_16_BYTES", "crypto_verify_32_BYTES", "crypto_verify_64_BYTES"];
          for (yt = 0; yt < Rt.length; yt++)
            typeof (Mn = m["_" + Rt[yt].toLowerCase()]) == "function" && (c[Rt[yt]] = Mn());
          var Yt = ["SODIUM_VERSION_STRING", "crypto_pwhash_STRPREFIX", "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"];
          for (yt = 0; yt < Yt.length; yt++) {
            var Mn;
            typeof (Mn = m["_" + Yt[yt].toLowerCase()]) == "function" && (c[Yt[yt]] = m.UTF8ToString(Mn()));
          }
        }
        m = d;
        try {
          Se();
          var Ee = new Uint8Array([98, 97, 108, 108, 115]), ke = c.randombytes_buf(c.crypto_secretbox_NONCEBYTES), Ce = c.randombytes_buf(c.crypto_secretbox_KEYBYTES), Re = c.crypto_secretbox_easy(Ee, ke, Ce), Fe = c.crypto_secretbox_open_easy(Re, ke, Ce);
          if (c.memcmp(Ee, Fe))
            return;
        } catch (qe) {
          if (m.useBackupModule == null)
            throw new Error("Both wasm and asm failed to load" + qe);
        }
        m.useBackupModule(), Se();
      });
      function $(Se) {
        if (typeof TextEncoder == "function")
          return new TextEncoder().encode(Se);
        Se = unescape(encodeURIComponent(Se));
        for (var Ee = new Uint8Array(Se.length), ke = 0, Ce = Se.length; ke < Ce; ke++)
          Ee[ke] = Se.charCodeAt(ke);
        return Ee;
      }
      function E(Se) {
        if (typeof TextDecoder == "function")
          return new TextDecoder("utf-8", { fatal: !0 }).decode(Se);
        var Ee = 8192, ke = Math.ceil(Se.length / Ee);
        if (ke <= 1)
          try {
            return decodeURIComponent(escape(String.fromCharCode.apply(null, Se)));
          } catch {
            throw new TypeError("The encoded data was not valid.");
          }
        for (var Ce = "", Re = 0, Fe = 0; Fe < ke; Fe++) {
          var qe = Array.prototype.slice.call(Se, Fe * Ee + Re, (Fe + 1) * Ee + Re);
          if (qe.length != 0) {
            var Xe, yt = qe.length, Rt = 0;
            do {
              var Yt = qe[--yt];
              Yt >= 240 ? (Rt = 4, Xe = !0) : Yt >= 224 ? (Rt = 3, Xe = !0) : Yt >= 192 ? (Rt = 2, Xe = !0) : Yt < 128 && (Rt = 1, Xe = !0);
            } while (!Xe);
            for (var Mn = Rt - (qe.length - yt), Un = 0; Un < Mn; Un++)
              Re--, qe.pop();
            Ce += E(qe);
          }
        }
        return Ce;
      }
      function O(Se) {
        Se = oe(null, Se, "input");
        for (var Ee, ke, Ce, Re = "", Fe = 0; Fe < Se.length; Fe++)
          Ce = 87 + (ke = 15 & Se[Fe]) + (ke - 10 >> 8 & -39) << 8 | 87 + (Ee = Se[Fe] >>> 4) + (Ee - 10 >> 8 & -39), Re += String.fromCharCode(255 & Ce) + String.fromCharCode(Ce >>> 8);
        return Re;
      }
      var T = { ORIGINAL: 1, ORIGINAL_NO_PADDING: 3, URLSAFE: 5, URLSAFE_NO_PADDING: 7 };
      function y(Se) {
        if (Se == null)
          return T.URLSAFE_NO_PADDING;
        if (Se !== T.ORIGINAL && Se !== T.ORIGINAL_NO_PADDING && Se !== T.URLSAFE && Se != T.URLSAFE_NO_PADDING)
          throw new Error("unsupported base64 variant");
        return Se;
      }
      function V(Se, Ee) {
        Ee = y(Ee), Se = oe(Ce, Se, "input");
        var ke, Ce = [], Re = 0 | Math.floor(Se.length / 3), Fe = Se.length - 3 * Re, qe = 4 * Re + (Fe !== 0 ? 2 & Ee ? 2 + (Fe >>> 1) : 4 : 0), Xe = new F(qe + 1), yt = X(Se);
        return Ce.push(yt), Ce.push(Xe.address), m._sodium_bin2base64(Xe.address, Xe.length, yt, Se.length, Ee) === 0 && Q(Ce, "conversion failed"), Xe.length = qe, ke = E(Xe.to_Uint8Array()), ue(Ce), ke;
      }
      function M(Se, Ee) {
        var ke = Ee || v;
        if (!G(ke))
          throw new Error(ke + " output format is not available");
        if (Se instanceof F) {
          if (ke === "uint8array")
            return Se.to_Uint8Array();
          if (ke === "text")
            return E(Se.to_Uint8Array());
          if (ke === "hex")
            return O(Se.to_Uint8Array());
          if (ke === "base64")
            return V(Se.to_Uint8Array(), T.URLSAFE_NO_PADDING);
          throw new Error('What is output format "' + ke + '"?');
        }
        if (typeof Se == "object") {
          for (var Ce = Object.keys(Se), Re = {}, Fe = 0; Fe < Ce.length; Fe++)
            Re[Ce[Fe]] = M(Se[Ce[Fe]], ke);
          return Re;
        }
        if (typeof Se == "string")
          return Se;
        throw new TypeError("Cannot format output");
      }
      function G(Se) {
        for (var Ee = ["uint8array", "text", "hex", "base64"], ke = 0; ke < Ee.length; ke++)
          if (Ee[ke] === Se)
            return !0;
        return !1;
      }
      function k(Se) {
        if (Se) {
          if (typeof Se != "string")
            throw new TypeError("When defined, the output format must be a string");
          if (!G(Se))
            throw new Error(Se + " is not a supported output format");
        }
      }
      function F(Se) {
        this.length = Se, this.address = ee(Se);
      }
      function X(Se) {
        var Ee = ee(Se.length);
        return m.HEAPU8.set(Se, Ee), Ee;
      }
      function ee(Se) {
        var Ee = m._malloc(Se);
        if (Ee === 0)
          throw { message: "_malloc() failed", length: Se };
        return Ee;
      }
      function ue(Se) {
        if (Se)
          for (var Ee = 0; Ee < Se.length; Ee++)
            ke = Se[Ee], m._free(ke);
        var ke;
      }
      function Q(Se, Ee) {
        throw ue(Se), new Error(Ee);
      }
      function Y(Se, Ee) {
        throw ue(Se), new TypeError(Ee);
      }
      function pe(Se, Ee, ke) {
        Ee == null && Y(Se, ke + " cannot be null or undefined");
      }
      function oe(Se, Ee, ke) {
        return pe(Se, Ee, ke), Ee instanceof Uint8Array ? Ee : typeof Ee == "string" ? $(Ee) : void Y(Se, "unsupported input type for " + ke);
      }
      function ne(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = null;
        Se != null && (Xe = X(Se = oe(qe, Se, "secret_nonce")), Se.length, qe.push(Xe)), Ee = oe(qe, Ee, "ciphertext");
        var yt, Rt = m._crypto_aead_chacha20poly1305_abytes(), Yt = Ee.length;
        Yt < Rt && Y(qe, "ciphertext is too short"), yt = X(Ee), qe.push(yt);
        var Mn = null, Un = 0;
        ke != null && (Mn = X(ke = oe(qe, ke, "additional_data")), Un = ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Jn, Rn = 0 | m._crypto_aead_chacha20poly1305_npubbytes();
        Ce.length !== Rn && Y(qe, "invalid public_nonce length"), Jn = X(Ce), qe.push(Jn), Re = oe(qe, Re, "key");
        var Zr, go = 0 | m._crypto_aead_chacha20poly1305_keybytes();
        Re.length !== go && Y(qe, "invalid key length"), Zr = X(Re), qe.push(Zr);
        var to = new F(Yt - m._crypto_aead_chacha20poly1305_abytes() | 0), Bo = to.address;
        if (qe.push(Bo), m._crypto_aead_chacha20poly1305_decrypt(Bo, null, Xe, yt, Yt, 0, Mn, Un, 0, Jn, Zr) === 0) {
          var zo = M(to, Fe);
          return ue(qe), zo;
        }
        Q(qe, "ciphertext cannot be decrypted using that key");
      }
      function H(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe);
        var yt = null;
        Se != null && (yt = X(Se = oe(Xe, Se, "secret_nonce")), Se.length, Xe.push(yt));
        var Rt = X(Ee = oe(Xe, Ee, "ciphertext")), Yt = Ee.length;
        Xe.push(Rt), ke = oe(Xe, ke, "mac");
        var Mn, Un = 0 | m._crypto_box_macbytes();
        ke.length !== Un && Y(Xe, "invalid mac length"), Mn = X(ke), Xe.push(Mn);
        var Jn = null, Rn = 0;
        Ce != null && (Jn = X(Ce = oe(Xe, Ce, "additional_data")), Rn = Ce.length, Xe.push(Jn)), Re = oe(Xe, Re, "public_nonce");
        var Zr, go = 0 | m._crypto_aead_chacha20poly1305_npubbytes();
        Re.length !== go && Y(Xe, "invalid public_nonce length"), Zr = X(Re), Xe.push(Zr), Fe = oe(Xe, Fe, "key");
        var to, Bo = 0 | m._crypto_aead_chacha20poly1305_keybytes();
        Fe.length !== Bo && Y(Xe, "invalid key length"), to = X(Fe), Xe.push(to);
        var zo = new F(0 | Yt), Ko = zo.address;
        if (Xe.push(Ko), m._crypto_aead_chacha20poly1305_decrypt_detached(Ko, yt, Rt, Yt, 0, Mn, Jn, Rn, 0, Zr, to) === 0) {
          var hs = M(zo, qe);
          return ue(Xe), hs;
        }
        Q(Xe, "ciphertext cannot be decrypted using that key");
      }
      function C(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_chacha20poly1305_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_chacha20poly1305_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(yt + m._crypto_aead_chacha20poly1305_abytes() | 0), to = go.address;
        if (qe.push(to), m._crypto_aead_chacha20poly1305_encrypt(to, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Bo = M(go, Fe);
          return ue(qe), Bo;
        }
        Q(qe, "invalid usage");
      }
      function w(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_chacha20poly1305_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_chacha20poly1305_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(0 | yt), to = go.address;
        qe.push(to);
        var Bo = new F(0 | m._crypto_aead_chacha20poly1305_abytes()), zo = Bo.address;
        if (qe.push(zo), m._crypto_aead_chacha20poly1305_encrypt_detached(to, zo, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Ko = M({ ciphertext: go, mac: Bo }, Fe);
          return ue(qe), Ko;
        }
        Q(qe, "invalid usage");
      }
      function P(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = null;
        Se != null && (Xe = X(Se = oe(qe, Se, "secret_nonce")), Se.length, qe.push(Xe)), Ee = oe(qe, Ee, "ciphertext");
        var yt, Rt = m._crypto_aead_chacha20poly1305_ietf_abytes(), Yt = Ee.length;
        Yt < Rt && Y(qe, "ciphertext is too short"), yt = X(Ee), qe.push(yt);
        var Mn = null, Un = 0;
        ke != null && (Mn = X(ke = oe(qe, ke, "additional_data")), Un = ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Jn, Rn = 0 | m._crypto_aead_chacha20poly1305_ietf_npubbytes();
        Ce.length !== Rn && Y(qe, "invalid public_nonce length"), Jn = X(Ce), qe.push(Jn), Re = oe(qe, Re, "key");
        var Zr, go = 0 | m._crypto_aead_chacha20poly1305_ietf_keybytes();
        Re.length !== go && Y(qe, "invalid key length"), Zr = X(Re), qe.push(Zr);
        var to = new F(Yt - m._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Bo = to.address;
        if (qe.push(Bo), m._crypto_aead_chacha20poly1305_ietf_decrypt(Bo, null, Xe, yt, Yt, 0, Mn, Un, 0, Jn, Zr) === 0) {
          var zo = M(to, Fe);
          return ue(qe), zo;
        }
        Q(qe, "ciphertext cannot be decrypted using that key");
      }
      function J(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe);
        var yt = null;
        Se != null && (yt = X(Se = oe(Xe, Se, "secret_nonce")), Se.length, Xe.push(yt));
        var Rt = X(Ee = oe(Xe, Ee, "ciphertext")), Yt = Ee.length;
        Xe.push(Rt), ke = oe(Xe, ke, "mac");
        var Mn, Un = 0 | m._crypto_box_macbytes();
        ke.length !== Un && Y(Xe, "invalid mac length"), Mn = X(ke), Xe.push(Mn);
        var Jn = null, Rn = 0;
        Ce != null && (Jn = X(Ce = oe(Xe, Ce, "additional_data")), Rn = Ce.length, Xe.push(Jn)), Re = oe(Xe, Re, "public_nonce");
        var Zr, go = 0 | m._crypto_aead_chacha20poly1305_ietf_npubbytes();
        Re.length !== go && Y(Xe, "invalid public_nonce length"), Zr = X(Re), Xe.push(Zr), Fe = oe(Xe, Fe, "key");
        var to, Bo = 0 | m._crypto_aead_chacha20poly1305_ietf_keybytes();
        Fe.length !== Bo && Y(Xe, "invalid key length"), to = X(Fe), Xe.push(to);
        var zo = new F(0 | Yt), Ko = zo.address;
        if (Xe.push(Ko), m._crypto_aead_chacha20poly1305_ietf_decrypt_detached(Ko, yt, Rt, Yt, 0, Mn, Jn, Rn, 0, Zr, to) === 0) {
          var hs = M(zo, qe);
          return ue(Xe), hs;
        }
        Q(Xe, "ciphertext cannot be decrypted using that key");
      }
      function se(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_chacha20poly1305_ietf_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_chacha20poly1305_ietf_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(yt + m._crypto_aead_chacha20poly1305_ietf_abytes() | 0), to = go.address;
        if (qe.push(to), m._crypto_aead_chacha20poly1305_ietf_encrypt(to, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Bo = M(go, Fe);
          return ue(qe), Bo;
        }
        Q(qe, "invalid usage");
      }
      function fe(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_chacha20poly1305_ietf_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_chacha20poly1305_ietf_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(0 | yt), to = go.address;
        qe.push(to);
        var Bo = new F(0 | m._crypto_aead_chacha20poly1305_ietf_abytes()), zo = Bo.address;
        if (qe.push(zo), m._crypto_aead_chacha20poly1305_ietf_encrypt_detached(to, zo, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Ko = M({ ciphertext: go, mac: Bo }, Fe);
          return ue(qe), Ko;
        }
        Q(qe, "invalid usage");
      }
      function N(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_aead_chacha20poly1305_ietf_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_aead_chacha20poly1305_ietf_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function W(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_aead_chacha20poly1305_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_aead_chacha20poly1305_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function I(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = null;
        Se != null && (Xe = X(Se = oe(qe, Se, "secret_nonce")), Se.length, qe.push(Xe)), Ee = oe(qe, Ee, "ciphertext");
        var yt, Rt = m._crypto_aead_xchacha20poly1305_ietf_abytes(), Yt = Ee.length;
        Yt < Rt && Y(qe, "ciphertext is too short"), yt = X(Ee), qe.push(yt);
        var Mn = null, Un = 0;
        ke != null && (Mn = X(ke = oe(qe, ke, "additional_data")), Un = ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Jn, Rn = 0 | m._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        Ce.length !== Rn && Y(qe, "invalid public_nonce length"), Jn = X(Ce), qe.push(Jn), Re = oe(qe, Re, "key");
        var Zr, go = 0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Re.length !== go && Y(qe, "invalid key length"), Zr = X(Re), qe.push(Zr);
        var to = new F(Yt - m._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Bo = to.address;
        if (qe.push(Bo), m._crypto_aead_xchacha20poly1305_ietf_decrypt(Bo, null, Xe, yt, Yt, 0, Mn, Un, 0, Jn, Zr) === 0) {
          var zo = M(to, Fe);
          return ue(qe), zo;
        }
        Q(qe, "ciphertext cannot be decrypted using that key");
      }
      function te(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe);
        var yt = null;
        Se != null && (yt = X(Se = oe(Xe, Se, "secret_nonce")), Se.length, Xe.push(yt));
        var Rt = X(Ee = oe(Xe, Ee, "ciphertext")), Yt = Ee.length;
        Xe.push(Rt), ke = oe(Xe, ke, "mac");
        var Mn, Un = 0 | m._crypto_box_macbytes();
        ke.length !== Un && Y(Xe, "invalid mac length"), Mn = X(ke), Xe.push(Mn);
        var Jn = null, Rn = 0;
        Ce != null && (Jn = X(Ce = oe(Xe, Ce, "additional_data")), Rn = Ce.length, Xe.push(Jn)), Re = oe(Xe, Re, "public_nonce");
        var Zr, go = 0 | m._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        Re.length !== go && Y(Xe, "invalid public_nonce length"), Zr = X(Re), Xe.push(Zr), Fe = oe(Xe, Fe, "key");
        var to, Bo = 0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Fe.length !== Bo && Y(Xe, "invalid key length"), to = X(Fe), Xe.push(to);
        var zo = new F(0 | Yt), Ko = zo.address;
        if (Xe.push(Ko), m._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(Ko, yt, Rt, Yt, 0, Mn, Jn, Rn, 0, Zr, to) === 0) {
          var hs = M(zo, qe);
          return ue(Xe), hs;
        }
        Q(Xe, "ciphertext cannot be decrypted using that key");
      }
      function ge(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(yt + m._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), to = go.address;
        if (qe.push(to), m._crypto_aead_xchacha20poly1305_ietf_encrypt(to, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Bo = M(go, Fe);
          return ue(qe), Bo;
        }
        Q(qe, "invalid usage");
      }
      function Pe(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(0 | yt), to = go.address;
        qe.push(to);
        var Bo = new F(0 | m._crypto_aead_xchacha20poly1305_ietf_abytes()), zo = Bo.address;
        if (qe.push(zo), m._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(to, zo, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Ko = M({ ciphertext: go, mac: Bo }, Fe);
          return ue(qe), Ko;
        }
        Q(qe, "invalid usage");
      }
      function Ke(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_aead_xchacha20poly1305_ietf_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function xe(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_auth_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_auth_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_auth(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function ze(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_auth_hmacsha256_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_auth_hmacsha256_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_auth_hmacsha256(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function nt(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_auth_hmacsha256_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_auth_hmacsha256_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function Qt(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = null, Re = 0;
        Se != null && (Ce = X(Se = oe(ke, Se, "key")), Re = Se.length, ke.push(Ce));
        var Fe = new F(208).address;
        if (!(0 | m._crypto_auth_hmacsha256_init(Fe, Ce, Re))) {
          var qe = Fe;
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function Et(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_auth_hmacsha256_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_auth_hmacsha256_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function zt(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_auth_hmacsha256_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function Nt(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "tag");
        var Re, Fe = 0 | m._crypto_auth_hmacsha256_bytes();
        Se.length !== Fe && Y(Ce, "invalid tag length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "key");
        var yt, Rt = 0 | m._crypto_auth_hmacsha256_keybytes();
        ke.length !== Rt && Y(Ce, "invalid key length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_auth_hmacsha256_verify(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function pt(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_auth_hmacsha512_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_auth_hmacsha512_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_auth_hmacsha512(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function at(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_auth_hmacsha512_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_auth_hmacsha512_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function kt(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = null, Re = 0;
        Se != null && (Ce = X(Se = oe(ke, Se, "key")), Re = Se.length, ke.push(Ce));
        var Fe = new F(416).address;
        if (!(0 | m._crypto_auth_hmacsha512_init(Fe, Ce, Re))) {
          var qe = Fe;
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function Ut(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_auth_hmacsha512_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_auth_hmacsha512_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function dn(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_auth_hmacsha512_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function En(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "tag");
        var Re, Fe = 0 | m._crypto_auth_hmacsha512_bytes();
        Se.length !== Fe && Y(Ce, "invalid tag length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "key");
        var yt, Rt = 0 | m._crypto_auth_hmacsha512_keybytes();
        ke.length !== Rt && Y(Ce, "invalid key length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_auth_hmacsha512_verify(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function Ht(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_auth_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_auth_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function Xt(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "tag");
        var Re, Fe = 0 | m._crypto_auth_bytes();
        Se.length !== Fe && Y(Ce, "invalid tag length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "key");
        var yt, Rt = 0 | m._crypto_auth_keybytes();
        ke.length !== Rt && Y(Ce, "invalid key length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_auth_verify(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function On(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "publicKey");
        var Re, Fe = 0 | m._crypto_box_publickeybytes();
        Se.length !== Fe && Y(Ce, "invalid publicKey length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "privateKey");
        var qe, Xe = 0 | m._crypto_box_secretkeybytes();
        Ee.length !== Xe && Y(Ce, "invalid privateKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_box_beforenmbytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_box_beforenm(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function sn(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_box_curve25519xchacha20poly1305_publickeybytes()), Ce = ke.address;
        Ee.push(Ce);
        var Re = new F(0 | m._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), Fe = Re.address;
        Ee.push(Fe), m._crypto_box_curve25519xchacha20poly1305_keypair(Ce, Fe);
        var qe = M({ publicKey: ke, privateKey: Re, keyType: "curve25519" }, Se);
        return ue(Ee), qe;
      }
      function At(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "publicKey");
        var qe, Xe = 0 | m._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        Ee.length !== Xe && Y(Ce, "invalid publicKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(Fe + m._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), Rt = yt.address;
        Ce.push(Rt), m._crypto_box_curve25519xchacha20poly1305_seal(Rt, Re, Fe, 0, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function hn(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "ciphertext");
        var Fe, qe = m._crypto_box_curve25519xchacha20poly1305_sealbytes(), Xe = Se.length;
        Xe < qe && Y(Re, "ciphertext is too short"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "publicKey");
        var yt, Rt = 0 | m._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        Ee.length !== Rt && Y(Re, "invalid publicKey length"), yt = X(Ee), Re.push(yt), ke = oe(Re, ke, "secretKey");
        var Yt, Mn = 0 | m._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ke.length !== Mn && Y(Re, "invalid secretKey length"), Yt = X(ke), Re.push(Yt);
        var Un = new F(Xe - m._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), Jn = Un.address;
        Re.push(Jn), m._crypto_box_curve25519xchacha20poly1305_seal_open(Jn, Fe, Xe, 0, yt, Yt);
        var Rn = M(Un, Ce);
        return ue(Re), Rn;
      }
      function $t(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_box_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), ke = oe(Fe, ke, "publicKey");
        var Yt, Mn = 0 | m._crypto_box_publickeybytes();
        ke.length !== Mn && Y(Fe, "invalid publicKey length"), Yt = X(ke), Fe.push(Yt), Ce = oe(Fe, Ce, "privateKey");
        var Un, Jn = 0 | m._crypto_box_secretkeybytes();
        Ce.length !== Jn && Y(Fe, "invalid privateKey length"), Un = X(Ce), Fe.push(Un);
        var Rn = new F(0 | Xe), Zr = Rn.address;
        Fe.push(Zr);
        var go = new F(0 | m._crypto_box_macbytes()), to = go.address;
        if (Fe.push(to), (0 | m._crypto_box_detached(Zr, to, qe, Xe, 0, yt, Yt, Un)) == 0) {
          var Bo = M({ ciphertext: Rn, mac: go }, Re);
          return ue(Fe), Bo;
        }
        Q(Fe, "invalid usage");
      }
      function Lt(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_box_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), ke = oe(Fe, ke, "publicKey");
        var Yt, Mn = 0 | m._crypto_box_publickeybytes();
        ke.length !== Mn && Y(Fe, "invalid publicKey length"), Yt = X(ke), Fe.push(Yt), Ce = oe(Fe, Ce, "privateKey");
        var Un, Jn = 0 | m._crypto_box_secretkeybytes();
        Ce.length !== Jn && Y(Fe, "invalid privateKey length"), Un = X(Ce), Fe.push(Un);
        var Rn = new F(Xe + m._crypto_box_macbytes() | 0), Zr = Rn.address;
        if (Fe.push(Zr), (0 | m._crypto_box_easy(Zr, qe, Xe, 0, yt, Yt, Un)) == 0) {
          var go = M(Rn, Re);
          return ue(Fe), go;
        }
        Q(Fe, "invalid usage");
      }
      function Qn(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_box_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "sharedKey");
        var Rt, Yt = 0 | m._crypto_box_beforenmbytes();
        ke.length !== Yt && Y(Re, "invalid sharedKey length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(qe + m._crypto_box_macbytes() | 0), Un = Mn.address;
        if (Re.push(Un), (0 | m._crypto_box_easy_afternm(Un, Fe, qe, 0, Xe, Rt)) == 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function ce(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_box_publickeybytes()), Ce = ke.address;
        Ee.push(Ce);
        var Re = new F(0 | m._crypto_box_secretkeybytes()), Fe = Re.address;
        if (Ee.push(Fe), (0 | m._crypto_box_keypair(Ce, Fe)) == 0) {
          var qe = { publicKey: M(ke, Se), privateKey: M(Re, Se), keyType: "x25519" };
          return ue(Ee), qe;
        }
        Q(Ee, "internal error");
      }
      function Ze(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "ciphertext")), yt = Se.length;
        qe.push(Xe), Ee = oe(qe, Ee, "mac");
        var Rt, Yt = 0 | m._crypto_box_macbytes();
        Ee.length !== Yt && Y(qe, "invalid mac length"), Rt = X(Ee), qe.push(Rt), ke = oe(qe, ke, "nonce");
        var Mn, Un = 0 | m._crypto_box_noncebytes();
        ke.length !== Un && Y(qe, "invalid nonce length"), Mn = X(ke), qe.push(Mn), Ce = oe(qe, Ce, "publicKey");
        var Jn, Rn = 0 | m._crypto_box_publickeybytes();
        Ce.length !== Rn && Y(qe, "invalid publicKey length"), Jn = X(Ce), qe.push(Jn), Re = oe(qe, Re, "privateKey");
        var Zr, go = 0 | m._crypto_box_secretkeybytes();
        Re.length !== go && Y(qe, "invalid privateKey length"), Zr = X(Re), qe.push(Zr);
        var to = new F(0 | yt), Bo = to.address;
        if (qe.push(Bo), (0 | m._crypto_box_open_detached(Bo, Xe, Rt, yt, 0, Mn, Jn, Zr)) == 0) {
          var zo = M(to, Fe);
          return ue(qe), zo;
        }
        Q(qe, "incorrect key pair for the given ciphertext");
      }
      function ft(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re), Se = oe(Fe, Se, "ciphertext");
        var qe, Xe = m._crypto_box_macbytes(), yt = Se.length;
        yt < Xe && Y(Fe, "ciphertext is too short"), qe = X(Se), Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var Rt, Yt = 0 | m._crypto_box_noncebytes();
        Ee.length !== Yt && Y(Fe, "invalid nonce length"), Rt = X(Ee), Fe.push(Rt), ke = oe(Fe, ke, "publicKey");
        var Mn, Un = 0 | m._crypto_box_publickeybytes();
        ke.length !== Un && Y(Fe, "invalid publicKey length"), Mn = X(ke), Fe.push(Mn), Ce = oe(Fe, Ce, "privateKey");
        var Jn, Rn = 0 | m._crypto_box_secretkeybytes();
        Ce.length !== Rn && Y(Fe, "invalid privateKey length"), Jn = X(Ce), Fe.push(Jn);
        var Zr = new F(yt - m._crypto_box_macbytes() | 0), go = Zr.address;
        if (Fe.push(go), (0 | m._crypto_box_open_easy(go, qe, yt, 0, Rt, Mn, Jn)) == 0) {
          var to = M(Zr, Re);
          return ue(Fe), to;
        }
        Q(Fe, "incorrect key pair for the given ciphertext");
      }
      function It(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "ciphertext")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_box_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "sharedKey");
        var Rt, Yt = 0 | m._crypto_box_beforenmbytes();
        ke.length !== Yt && Y(Re, "invalid sharedKey length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(qe - m._crypto_box_macbytes() | 0), Un = Mn.address;
        if (Re.push(Un), (0 | m._crypto_box_open_easy_afternm(Un, Fe, qe, 0, Xe, Rt)) == 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "incorrect secret key for the given ciphertext");
      }
      function rn(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "publicKey");
        var qe, Xe = 0 | m._crypto_box_publickeybytes();
        Ee.length !== Xe && Y(Ce, "invalid publicKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(Fe + m._crypto_box_sealbytes() | 0), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_box_seal(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function Ln(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "ciphertext");
        var Fe, qe = m._crypto_box_sealbytes(), Xe = Se.length;
        Xe < qe && Y(Re, "ciphertext is too short"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "publicKey");
        var yt, Rt = 0 | m._crypto_box_publickeybytes();
        Ee.length !== Rt && Y(Re, "invalid publicKey length"), yt = X(Ee), Re.push(yt), ke = oe(Re, ke, "privateKey");
        var Yt, Mn = 0 | m._crypto_box_secretkeybytes();
        ke.length !== Mn && Y(Re, "invalid privateKey length"), Yt = X(ke), Re.push(Yt);
        var Un = new F(Xe - m._crypto_box_sealbytes() | 0), Jn = Un.address;
        if (Re.push(Jn), (0 | m._crypto_box_seal_open(Jn, Fe, Xe, 0, yt, Yt)) == 0) {
          var Rn = M(Un, Ce);
          return ue(Re), Rn;
        }
        Q(Re, "incorrect key pair for the given ciphertext");
      }
      function Pn(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "seed");
        var Ce, Re = 0 | m._crypto_box_seedbytes();
        Se.length !== Re && Y(ke, "invalid seed length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_box_publickeybytes()), qe = Fe.address;
        ke.push(qe);
        var Xe = new F(0 | m._crypto_box_secretkeybytes()), yt = Xe.address;
        if (ke.push(yt), (0 | m._crypto_box_seed_keypair(qe, yt, Ce)) == 0) {
          var Rt = { publicKey: M(Fe, Ee), privateKey: M(Xe, Ee), keyType: "x25519" };
          return ue(ke), Rt;
        }
        Q(ke, "invalid usage");
      }
      function Ae(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "p");
        var Re, Fe = 0 | m._crypto_core_ed25519_bytes();
        Se.length !== Fe && Y(Ce, "invalid p length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "q");
        var qe, Xe = 0 | m._crypto_core_ed25519_bytes();
        Ee.length !== Xe && Y(Ce, "invalid q length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_core_ed25519_add(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "input is an invalid element");
      }
      function Me(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "r"));
        Se.length, ke.push(Ce);
        var Re = new F(0 | m._crypto_core_ed25519_bytes()), Fe = Re.address;
        if (ke.push(Fe), (0 | m._crypto_core_ed25519_from_hash(Fe, Ce)) == 0) {
          var qe = M(Re, Ee);
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function He(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "r"));
        Se.length, ke.push(Ce);
        var Re = new F(0 | m._crypto_core_ed25519_bytes()), Fe = Re.address;
        if (ke.push(Fe), (0 | m._crypto_core_ed25519_from_uniform(Fe, Ce)) == 0) {
          var qe = M(Re, Ee);
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function cn(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "repr");
        var Ce, Re = 0 | m._crypto_core_ed25519_bytes();
        Se.length !== Re && Y(ke, "invalid repr length"), Ce = X(Se), ke.push(Ce);
        var Fe = (0 | m._crypto_core_ed25519_is_valid_point(Ce)) == 1;
        return ue(ke), Fe;
      }
      function Wt(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_core_ed25519_bytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_core_ed25519_random(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function yn(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ed25519_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ed25519_scalar_add(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function pr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ed25519_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ed25519_scalar_complement(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Uo(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ed25519_scalarbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_core_ed25519_scalar_invert(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid reciprocate");
      }
      function ar(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ed25519_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ed25519_scalar_mul(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function Sr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ed25519_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ed25519_scalar_negate(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Jo(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_core_ed25519_scalarbytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_core_ed25519_scalar_random(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function fr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "sample");
        var Ce, Re = 0 | m._crypto_core_ed25519_nonreducedscalarbytes();
        Se.length !== Re && Y(ke, "invalid sample length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ed25519_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ed25519_scalar_reduce(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Er(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ed25519_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ed25519_scalar_sub(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function vo(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "p");
        var Re, Fe = 0 | m._crypto_core_ed25519_bytes();
        Se.length !== Fe && Y(Ce, "invalid p length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "q");
        var qe, Xe = 0 | m._crypto_core_ed25519_bytes();
        Ee.length !== Xe && Y(Ce, "invalid q length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_core_ed25519_sub(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "input is an invalid element");
      }
      function lr(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "input");
        var Fe, qe = 0 | m._crypto_core_hchacha20_inputbytes();
        Se.length !== qe && Y(Re, "invalid input length"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "privateKey");
        var Xe, yt = 0 | m._crypto_core_hchacha20_keybytes();
        Ee.length !== yt && Y(Re, "invalid privateKey length"), Xe = X(Ee), Re.push(Xe);
        var Rt = null;
        ke != null && (Rt = X(ke = oe(Re, ke, "constant")), ke.length, Re.push(Rt));
        var Yt = new F(0 | m._crypto_core_hchacha20_outputbytes()), Mn = Yt.address;
        if (Re.push(Mn), (0 | m._crypto_core_hchacha20(Mn, Fe, Xe, Rt)) == 0) {
          var Un = M(Yt, Ce);
          return ue(Re), Un;
        }
        Q(Re, "invalid usage");
      }
      function $r(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "input");
        var Fe, qe = 0 | m._crypto_core_hsalsa20_inputbytes();
        Se.length !== qe && Y(Re, "invalid input length"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "privateKey");
        var Xe, yt = 0 | m._crypto_core_hsalsa20_keybytes();
        Ee.length !== yt && Y(Re, "invalid privateKey length"), Xe = X(Ee), Re.push(Xe);
        var Rt = null;
        ke != null && (Rt = X(ke = oe(Re, ke, "constant")), ke.length, Re.push(Rt));
        var Yt = new F(0 | m._crypto_core_hsalsa20_outputbytes()), Mn = Yt.address;
        if (Re.push(Mn), (0 | m._crypto_core_hsalsa20(Mn, Fe, Xe, Rt)) == 0) {
          var Un = M(Yt, Ce);
          return ue(Re), Un;
        }
        Q(Re, "invalid usage");
      }
      function Wo(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "p");
        var Re, Fe = 0 | m._crypto_core_ristretto255_bytes();
        Se.length !== Fe && Y(Ce, "invalid p length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "q");
        var qe, Xe = 0 | m._crypto_core_ristretto255_bytes();
        Ee.length !== Xe && Y(Ce, "invalid q length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_core_ristretto255_add(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "input is an invalid element");
      }
      function yr(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "r"));
        Se.length, ke.push(Ce);
        var Re = new F(0 | m._crypto_core_ristretto255_bytes()), Fe = Re.address;
        if (ke.push(Fe), (0 | m._crypto_core_ristretto255_from_hash(Fe, Ce)) == 0) {
          var qe = M(Re, Ee);
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function Dr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "repr");
        var Ce, Re = 0 | m._crypto_core_ristretto255_bytes();
        Se.length !== Re && Y(ke, "invalid repr length"), Ce = X(Se), ke.push(Ce);
        var Fe = (0 | m._crypto_core_ristretto255_is_valid_point(Ce)) == 1;
        return ue(ke), Fe;
      }
      function Zo(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_core_ristretto255_bytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_core_ristretto255_random(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function dr(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ristretto255_scalar_add(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function Br(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ristretto255_scalar_complement(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Qo(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_scalarbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_core_ristretto255_scalar_invert(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid reciprocate");
      }
      function tr(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ristretto255_scalar_mul(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function Mr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ristretto255_scalar_negate(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function qo(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_core_ristretto255_scalarbytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_core_ristretto255_scalar_random(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function hr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "sample");
        var Ce, Re = 0 | m._crypto_core_ristretto255_nonreducedscalarbytes();
        Se.length !== Re && Y(ke, "invalid sample length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ristretto255_scalar_reduce(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Or(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ristretto255_scalar_sub(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function Fo(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "p");
        var Re, Fe = 0 | m._crypto_core_ristretto255_bytes();
        Se.length !== Fe && Y(Ce, "invalid p length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "q");
        var qe, Xe = 0 | m._crypto_core_ristretto255_bytes();
        Ee.length !== Xe && Y(Ce, "invalid q length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_core_ristretto255_sub(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "input is an invalid element");
      }
      function No(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), pe(Re, Se, "hash_length"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Re, "hash_length must be an unsigned integer");
        var Fe = X(Ee = oe(Re, Ee, "message")), qe = Ee.length;
        Re.push(Fe);
        var Xe = null, yt = 0;
        ke != null && (Xe = X(ke = oe(Re, ke, "key")), yt = ke.length, Re.push(Xe));
        var Rt = new F(Se |= 0), Yt = Rt.address;
        if (Re.push(Yt), (0 | m._crypto_generichash(Yt, Se, Fe, qe, 0, Xe, yt)) == 0) {
          var Mn = M(Rt, Ce);
          return ue(Re), Mn;
        }
        Q(Re, "invalid usage");
      }
      function di(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re), pe(Fe, Se, "subkey_len"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Fe, "subkey_len must be an unsigned integer");
        var qe = null, Xe = 0;
        Ee != null && (qe = X(Ee = oe(Fe, Ee, "key")), Xe = Ee.length, Fe.push(qe));
        var yt = null, Rt = 0;
        ke != null && (ke = oe(Fe, ke, "id"), Rt = 0 | m._crypto_generichash_blake2b_saltbytes(), ke.length !== Rt && Y(Fe, "invalid id length"), yt = X(ke), Fe.push(yt));
        var Yt = null, Mn = 0;
        Ce != null && (Ce = oe(Fe, Ce, "ctx"), Mn = 0 | m._crypto_generichash_blake2b_personalbytes(), Ce.length !== Mn && Y(Fe, "invalid ctx length"), Yt = X(Ce), Fe.push(Yt));
        var Un = new F(0 | Se), Jn = Un.address;
        if (Fe.push(Jn), (0 | m._crypto_generichash_blake2b_salt_personal(Jn, Se, null, 0, 0, qe, Xe, yt, Yt)) == 0) {
          var Rn = M(Un, Re);
          return ue(Fe), Rn;
        }
        Q(Fe, "invalid usage");
      }
      function gi(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address"), pe(Ce, Ee, "hash_length"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Ce, "hash_length must be an unsigned integer");
        var Re = new F(Ee |= 0), Fe = Re.address;
        if (Ce.push(Fe), (0 | m._crypto_generichash_final(Se, Fe, Ee)) == 0) {
          var qe = (m._free(Se), M(Re, ke));
          return ue(Ce), qe;
        }
        Q(Ce, "invalid usage");
      }
      function ai(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = null, Fe = 0;
        Se != null && (Re = X(Se = oe(Ce, Se, "key")), Fe = Se.length, Ce.push(Re)), pe(Ce, Ee, "hash_length"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Ce, "hash_length must be an unsigned integer");
        var qe = new F(357).address;
        if (!(0 | m._crypto_generichash_init(qe, Re, Fe, Ee))) {
          var Xe = qe;
          return ue(Ce), Xe;
        }
        Q(Ce, "invalid usage");
      }
      function ui(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_generichash_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_generichash_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function hi(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_generichash_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function bi(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "message")), Re = Se.length;
        ke.push(Ce);
        var Fe = new F(0 | m._crypto_hash_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_hash(qe, Ce, Re, 0)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid usage");
      }
      function ii(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "message")), Re = Se.length;
        ke.push(Ce);
        var Fe = new F(0 | m._crypto_hash_sha256_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_hash_sha256(qe, Ce, Re, 0)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid usage");
      }
      function pi(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_hash_sha256_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_hash_sha256_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function Ci(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(104).address;
        if (!(0 | m._crypto_hash_sha256_init(ke))) {
          var Ce = ke;
          return ue(Ee), Ce;
        }
        Q(Ee, "invalid usage");
      }
      function _i(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_hash_sha256_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function xn(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "message")), Re = Se.length;
        ke.push(Ce);
        var Fe = new F(0 | m._crypto_hash_sha512_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_hash_sha512(qe, Ce, Re, 0)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid usage");
      }
      function sr(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_hash_sha512_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_hash_sha512_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function Nr(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(208).address;
        if (!(0 | m._crypto_hash_sha512_init(ke))) {
          var Ce = ke;
          return ue(Ee), Ce;
        }
        Q(Ee, "invalid usage");
      }
      function vr(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_hash_sha512_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function Yr(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re), pe(Fe, Se, "subkey_len"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Fe, "subkey_len must be an unsigned integer"), pe(Fe, Ee, "subkey_id"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Fe, "subkey_id must be an unsigned integer"), typeof ke != "string" && Y(Fe, "ctx must be a string"), ke = $(ke + "\0"), Xe != null && ke.length - 1 !== Xe && Y(Fe, "invalid ctx length");
        var qe = X(ke), Xe = ke.length - 1;
        Fe.push(qe), Ce = oe(Fe, Ce, "key");
        var yt, Rt = 0 | m._crypto_kdf_keybytes();
        Ce.length !== Rt && Y(Fe, "invalid key length"), yt = X(Ce), Fe.push(yt);
        var Yt = new F(0 | Se), Mn = Yt.address;
        Fe.push(Mn), m._crypto_kdf_derive_from_key(Mn, Se, Ee, Ee >>> 24 >>> 8, qe, yt);
        var Un = M(Yt, Re);
        return ue(Fe), Un;
      }
      function Fr(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_kdf_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_kdf_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function eo(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "clientPublicKey");
        var Fe, qe = 0 | m._crypto_kx_publickeybytes();
        Se.length !== qe && Y(Re, "invalid clientPublicKey length"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "clientSecretKey");
        var Xe, yt = 0 | m._crypto_kx_secretkeybytes();
        Ee.length !== yt && Y(Re, "invalid clientSecretKey length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "serverPublicKey");
        var Rt, Yt = 0 | m._crypto_kx_publickeybytes();
        ke.length !== Yt && Y(Re, "invalid serverPublicKey length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | m._crypto_kx_sessionkeybytes()), Un = Mn.address;
        Re.push(Un);
        var Jn = new F(0 | m._crypto_kx_sessionkeybytes()), Rn = Jn.address;
        if (Re.push(Rn), (0 | m._crypto_kx_client_session_keys(Un, Rn, Fe, Xe, Rt)) == 0) {
          var Zr = M({ sharedRx: Mn, sharedTx: Jn }, Ce);
          return ue(Re), Zr;
        }
        Q(Re, "invalid usage");
      }
      function Xr(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_kx_publickeybytes()), Ce = ke.address;
        Ee.push(Ce);
        var Re = new F(0 | m._crypto_kx_secretkeybytes()), Fe = Re.address;
        if (Ee.push(Fe), (0 | m._crypto_kx_keypair(Ce, Fe)) == 0) {
          var qe = { publicKey: M(ke, Se), privateKey: M(Re, Se), keyType: "x25519" };
          return ue(Ee), qe;
        }
        Q(Ee, "internal error");
      }
      function Mo(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "seed");
        var Ce, Re = 0 | m._crypto_kx_seedbytes();
        Se.length !== Re && Y(ke, "invalid seed length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_kx_publickeybytes()), qe = Fe.address;
        ke.push(qe);
        var Xe = new F(0 | m._crypto_kx_secretkeybytes()), yt = Xe.address;
        if (ke.push(yt), (0 | m._crypto_kx_seed_keypair(qe, yt, Ce)) == 0) {
          var Rt = { publicKey: M(Fe, Ee), privateKey: M(Xe, Ee), keyType: "x25519" };
          return ue(ke), Rt;
        }
        Q(ke, "internal error");
      }
      function jo(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "serverPublicKey");
        var Fe, qe = 0 | m._crypto_kx_publickeybytes();
        Se.length !== qe && Y(Re, "invalid serverPublicKey length"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "serverSecretKey");
        var Xe, yt = 0 | m._crypto_kx_secretkeybytes();
        Ee.length !== yt && Y(Re, "invalid serverSecretKey length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "clientPublicKey");
        var Rt, Yt = 0 | m._crypto_kx_publickeybytes();
        ke.length !== Yt && Y(Re, "invalid clientPublicKey length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | m._crypto_kx_sessionkeybytes()), Un = Mn.address;
        Re.push(Un);
        var Jn = new F(0 | m._crypto_kx_sessionkeybytes()), Rn = Jn.address;
        if (Re.push(Rn), (0 | m._crypto_kx_server_session_keys(Un, Rn, Fe, Xe, Rt)) == 0) {
          var Zr = M({ sharedRx: Mn, sharedTx: Jn }, Ce);
          return ue(Re), Zr;
        }
        Q(Re, "invalid usage");
      }
      function Ii(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_onetimeauth_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_onetimeauth_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_onetimeauth(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function ki(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_onetimeauth_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_onetimeauth_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function j(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = null;
        Se != null && (Ce = X(Se = oe(ke, Se, "key")), Se.length, ke.push(Ce));
        var Re = new F(144).address;
        if (!(0 | m._crypto_onetimeauth_init(Re, Ce))) {
          var Fe = Re;
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function l(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_onetimeauth_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_onetimeauth_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function B(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_onetimeauth_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function Ri(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "hash");
        var Re, Fe = 0 | m._crypto_onetimeauth_bytes();
        Se.length !== Fe && Y(Ce, "invalid hash length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "key");
        var yt, Rt = 0 | m._crypto_onetimeauth_keybytes();
        ke.length !== Rt && Y(Ce, "invalid key length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_onetimeauth_verify(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function wr(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe), pe(Xe, Se, "keyLength"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Xe, "keyLength must be an unsigned integer");
        var yt = X(Ee = oe(Xe, Ee, "password")), Rt = Ee.length;
        Xe.push(yt), ke = oe(Xe, ke, "salt");
        var Yt, Mn = 0 | m._crypto_pwhash_saltbytes();
        ke.length !== Mn && Y(Xe, "invalid salt length"), Yt = X(ke), Xe.push(Yt), pe(Xe, Ce, "opsLimit"), (typeof Ce != "number" || (0 | Ce) !== Ce || Ce < 0) && Y(Xe, "opsLimit must be an unsigned integer"), pe(Xe, Re, "memLimit"), (typeof Re != "number" || (0 | Re) !== Re || Re < 0) && Y(Xe, "memLimit must be an unsigned integer"), pe(Xe, Fe, "algorithm"), (typeof Fe != "number" || (0 | Fe) !== Fe || Fe < 0) && Y(Xe, "algorithm must be an unsigned integer");
        var Un = new F(0 | Se), Jn = Un.address;
        if (Xe.push(Jn), (0 | m._crypto_pwhash(Jn, Se, 0, yt, Rt, 0, Yt, Ce, 0, Re, Fe)) == 0) {
          var Rn = M(Un, qe);
          return ue(Xe), Rn;
        }
        Q(Xe, "invalid usage");
      }
      function zi(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe), pe(qe, Se, "keyLength"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(qe, "keyLength must be an unsigned integer");
        var Xe = X(Ee = oe(qe, Ee, "password")), yt = Ee.length;
        qe.push(Xe), ke = oe(qe, ke, "salt");
        var Rt, Yt = 0 | m._crypto_pwhash_scryptsalsa208sha256_saltbytes();
        ke.length !== Yt && Y(qe, "invalid salt length"), Rt = X(ke), qe.push(Rt), pe(qe, Ce, "opsLimit"), (typeof Ce != "number" || (0 | Ce) !== Ce || Ce < 0) && Y(qe, "opsLimit must be an unsigned integer"), pe(qe, Re, "memLimit"), (typeof Re != "number" || (0 | Re) !== Re || Re < 0) && Y(qe, "memLimit must be an unsigned integer");
        var Mn = new F(0 | Se), Un = Mn.address;
        if (qe.push(Un), (0 | m._crypto_pwhash_scryptsalsa208sha256(Un, Se, 0, Xe, yt, 0, Rt, Ce, 0, Re)) == 0) {
          var Jn = M(Mn, Fe);
          return ue(qe), Jn;
        }
        Q(qe, "invalid usage");
      }
      function ks(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe);
        var yt = X(Se = oe(Xe, Se, "password")), Rt = Se.length;
        Xe.push(yt);
        var Yt = X(Ee = oe(Xe, Ee, "salt")), Mn = Ee.length;
        Xe.push(Yt), pe(Xe, ke, "opsLimit"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Xe, "opsLimit must be an unsigned integer"), pe(Xe, Ce, "r"), (typeof Ce != "number" || (0 | Ce) !== Ce || Ce < 0) && Y(Xe, "r must be an unsigned integer"), pe(Xe, Re, "p"), (typeof Re != "number" || (0 | Re) !== Re || Re < 0) && Y(Xe, "p must be an unsigned integer"), pe(Xe, Fe, "keyLength"), (typeof Fe != "number" || (0 | Fe) !== Fe || Fe < 0) && Y(Xe, "keyLength must be an unsigned integer");
        var Un = new F(0 | Fe), Jn = Un.address;
        if (Xe.push(Jn), (0 | m._crypto_pwhash_scryptsalsa208sha256_ll(yt, Rt, Yt, Mn, ke, 0, Ce, Re, Jn, Fe)) == 0) {
          var Rn = M(Un, qe);
          return ue(Xe), Rn;
        }
        Q(Xe, "invalid usage");
      }
      function Hs(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "password")), qe = Se.length;
        Re.push(Fe), pe(Re, Ee, "opsLimit"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Re, "opsLimit must be an unsigned integer"), pe(Re, ke, "memLimit"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Re, "memLimit must be an unsigned integer");
        var Xe = new F(0 | m._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
        if (Re.push(Xe), (0 | m._crypto_pwhash_scryptsalsa208sha256_str(Xe, Fe, qe, 0, Ee, 0, ke)) == 0) {
          var yt = m.UTF8ToString(Xe);
          return ue(Re), yt;
        }
        Q(Re, "invalid usage");
      }
      function Oa(Se, Ee, ke) {
        var Ce = [];
        k(ke), typeof Se != "string" && Y(Ce, "hashed_password must be a string"), Se = $(Se + "\0"), Fe != null && Se.length - 1 !== Fe && Y(Ce, "invalid hashed_password length");
        var Re = X(Se), Fe = Se.length - 1;
        Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "password")), Xe = Ee.length;
        Ce.push(qe);
        var yt = (0 | m._crypto_pwhash_scryptsalsa208sha256_str_verify(Re, qe, Xe, 0)) == 0;
        return ue(Ce), yt;
      }
      function qa(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "password")), qe = Se.length;
        Re.push(Fe), pe(Re, Ee, "opsLimit"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Re, "opsLimit must be an unsigned integer"), pe(Re, ke, "memLimit"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Re, "memLimit must be an unsigned integer");
        var Xe = new F(0 | m._crypto_pwhash_strbytes()).address;
        if (Re.push(Xe), (0 | m._crypto_pwhash_str(Xe, Fe, qe, 0, Ee, 0, ke)) == 0) {
          var yt = m.UTF8ToString(Xe);
          return ue(Re), yt;
        }
        Q(Re, "invalid usage");
      }
      function st(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), typeof Se != "string" && Y(Re, "hashed_password must be a string"), Se = $(Se + "\0"), qe != null && Se.length - 1 !== qe && Y(Re, "invalid hashed_password length");
        var Fe = X(Se), qe = Se.length - 1;
        Re.push(Fe), pe(Re, Ee, "opsLimit"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Re, "opsLimit must be an unsigned integer"), pe(Re, ke, "memLimit"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Re, "memLimit must be an unsigned integer");
        var Xe = (0 | m._crypto_pwhash_str_needs_rehash(Fe, Ee, 0, ke)) != 0;
        return ue(Re), Xe;
      }
      function Oe(Se, Ee, ke) {
        var Ce = [];
        k(ke), typeof Se != "string" && Y(Ce, "hashed_password must be a string"), Se = $(Se + "\0"), Fe != null && Se.length - 1 !== Fe && Y(Ce, "invalid hashed_password length");
        var Re = X(Se), Fe = Se.length - 1;
        Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "password")), Xe = Ee.length;
        Ce.push(qe);
        var yt = (0 | m._crypto_pwhash_str_verify(Re, qe, Xe, 0)) == 0;
        return ue(Ce), yt;
      }
      function Bs(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "privateKey");
        var Re, Fe = 0 | m._crypto_scalarmult_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid privateKey length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "publicKey");
        var qe, Xe = 0 | m._crypto_scalarmult_bytes();
        Ee.length !== Xe && Y(Ce, "invalid publicKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_scalarmult_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_scalarmult(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "weak public key");
      }
      function ve(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "privateKey");
        var Ce, Re = 0 | m._crypto_scalarmult_scalarbytes();
        Se.length !== Re && Y(ke, "invalid privateKey length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_scalarmult_base(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "unknown error");
      }
      function $s(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "n");
        var Re, Fe = 0 | m._crypto_scalarmult_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid n length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "p");
        var qe, Xe = 0 | m._crypto_scalarmult_ed25519_bytes();
        Ee.length !== Xe && Y(Ce, "invalid p length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_scalarmult_ed25519_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_scalarmult_ed25519(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid point or scalar is 0");
      }
      function aa(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "scalar");
        var Ce, Re = 0 | m._crypto_scalarmult_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid scalar length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_ed25519_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_scalarmult_ed25519_base(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "scalar is 0");
      }
      function gr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "scalar");
        var Ce, Re = 0 | m._crypto_scalarmult_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid scalar length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_ed25519_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_scalarmult_ed25519_base_noclamp(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "scalar is 0");
      }
      function rr(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "n");
        var Re, Fe = 0 | m._crypto_scalarmult_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid n length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "p");
        var qe, Xe = 0 | m._crypto_scalarmult_ed25519_bytes();
        Ee.length !== Xe && Y(Ce, "invalid p length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_scalarmult_ed25519_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_scalarmult_ed25519_noclamp(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid point or scalar is 0");
      }
      function Vi(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "scalar");
        var Re, Fe = 0 | m._crypto_scalarmult_ristretto255_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid scalar length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "element");
        var qe, Xe = 0 | m._crypto_scalarmult_ristretto255_bytes();
        Ee.length !== Xe && Y(Ce, "invalid element length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_scalarmult_ristretto255_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_scalarmult_ristretto255(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "result is identity element");
      }
      function Cn(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "scalar");
        var Ce, Re = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Re && Y(ke, "invalid scalar length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_scalarmult_ristretto255_base(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "scalar is 0");
      }
      function Ks(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_secretbox_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_secretbox_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | qe), Un = Mn.address;
        Re.push(Un);
        var Jn = new F(0 | m._crypto_secretbox_macbytes()), Rn = Jn.address;
        if (Re.push(Rn), (0 | m._crypto_secretbox_detached(Un, Rn, Fe, qe, 0, Xe, Rt)) == 0) {
          var Zr = M({ mac: Jn, cipher: Mn }, Ce);
          return ue(Re), Zr;
        }
        Q(Re, "invalid usage");
      }
      function Qi(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_secretbox_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_secretbox_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(qe + m._crypto_secretbox_macbytes() | 0), Un = Mn.address;
        if (Re.push(Un), (0 | m._crypto_secretbox_easy(Un, Fe, qe, 0, Xe, Rt)) == 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function ua(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_secretbox_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_secretbox_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function wa(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "ciphertext")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "mac");
        var yt, Rt = 0 | m._crypto_secretbox_macbytes();
        Ee.length !== Rt && Y(Fe, "invalid mac length"), yt = X(Ee), Fe.push(yt), ke = oe(Fe, ke, "nonce");
        var Yt, Mn = 0 | m._crypto_secretbox_noncebytes();
        ke.length !== Mn && Y(Fe, "invalid nonce length"), Yt = X(ke), Fe.push(Yt), Ce = oe(Fe, Ce, "key");
        var Un, Jn = 0 | m._crypto_secretbox_keybytes();
        Ce.length !== Jn && Y(Fe, "invalid key length"), Un = X(Ce), Fe.push(Un);
        var Rn = new F(0 | Xe), Zr = Rn.address;
        if (Fe.push(Zr), (0 | m._crypto_secretbox_open_detached(Zr, qe, yt, Xe, 0, Yt, Un)) == 0) {
          var go = M(Rn, Re);
          return ue(Fe), go;
        }
        Q(Fe, "wrong secret key for the given ciphertext");
      }
      function In(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "ciphertext");
        var Fe, qe = m._crypto_secretbox_macbytes(), Xe = Se.length;
        Xe < qe && Y(Re, "ciphertext is too short"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_secretbox_noncebytes();
        Ee.length !== Rt && Y(Re, "invalid nonce length"), yt = X(Ee), Re.push(yt), ke = oe(Re, ke, "key");
        var Yt, Mn = 0 | m._crypto_secretbox_keybytes();
        ke.length !== Mn && Y(Re, "invalid key length"), Yt = X(ke), Re.push(Yt);
        var Un = new F(Xe - m._crypto_secretbox_macbytes() | 0), Jn = Un.address;
        if (Re.push(Jn), (0 | m._crypto_secretbox_open_easy(Jn, Fe, Xe, 0, yt, Yt)) == 0) {
          var Rn = M(Un, Ce);
          return ue(Re), Rn;
        }
        Q(Re, "wrong secret key for the given ciphertext");
      }
      function Ys(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "header");
        var Re, Fe = 0 | m._crypto_secretstream_xchacha20poly1305_headerbytes();
        Se.length !== Fe && Y(Ce, "invalid header length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_secretstream_xchacha20poly1305_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(52).address;
        if (!(0 | m._crypto_secretstream_xchacha20poly1305_init_pull(yt, Re, qe))) {
          var Rt = yt;
          return ue(Ce), Rt;
        }
        Q(Ce, "invalid usage");
      }
      function Zs(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "key");
        var Ce, Re = 0 | m._crypto_secretstream_xchacha20poly1305_keybytes();
        Se.length !== Re && Y(ke, "invalid key length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(52).address, qe = new F(0 | m._crypto_secretstream_xchacha20poly1305_headerbytes()), Xe = qe.address;
        if (ke.push(Xe), (0 | m._crypto_secretstream_xchacha20poly1305_init_push(Fe, Xe, Ce)) == 0) {
          var yt = { state: Fe, header: M(qe, Ee) };
          return ue(ke), yt;
        }
        Q(ke, "invalid usage");
      }
      function Ia(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_secretstream_xchacha20poly1305_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_secretstream_xchacha20poly1305_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function Ot(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), pe(Re, Se, "state_address"), Ee = oe(Re, Ee, "cipher");
        var Fe, qe = m._crypto_secretstream_xchacha20poly1305_abytes(), Xe = Ee.length;
        Xe < qe && Y(Re, "cipher is too short"), Fe = X(Ee), Re.push(Fe);
        var yt = null, Rt = 0;
        ke != null && (yt = X(ke = oe(Re, ke, "ad")), Rt = ke.length, Re.push(yt));
        var Yt = new F(Xe - m._crypto_secretstream_xchacha20poly1305_abytes() | 0), Mn = Yt.address;
        Re.push(Mn);
        var Un, Jn = (Un = ee(1), Re.push(Un), (Jn = m._crypto_secretstream_xchacha20poly1305_pull(Se, Mn, 0, Un, Fe, Xe, 0, yt, Rt) === 0 && { tag: m.HEAPU8[Un], message: Yt }) && { message: M(Jn.message, Ce), tag: Jn.tag });
        return ue(Re), Jn;
      }
      function js(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re), pe(Fe, Se, "state_address");
        var qe = X(Ee = oe(Fe, Ee, "message_chunk")), Xe = Ee.length;
        Fe.push(qe);
        var yt = null, Rt = 0;
        ke != null && (yt = X(ke = oe(Fe, ke, "ad")), Rt = ke.length, Fe.push(yt)), pe(Fe, Ce, "tag"), (typeof Ce != "number" || (0 | Ce) !== Ce || Ce < 0) && Y(Fe, "tag must be an unsigned integer");
        var Yt = new F(Xe + m._crypto_secretstream_xchacha20poly1305_abytes() | 0), Mn = Yt.address;
        if (Fe.push(Mn), (0 | m._crypto_secretstream_xchacha20poly1305_push(Se, Mn, 0, qe, Xe, 0, yt, Rt, 0, Ce)) == 0) {
          var Un = M(Yt, Re);
          return ue(Fe), Un;
        }
        Q(Fe, "invalid usage");
      }
      function ca(Se, Ee) {
        var ke = [];
        return k(Ee), pe(ke, Se, "state_address"), m._crypto_secretstream_xchacha20poly1305_rekey(Se), ue(ke), !0;
      }
      function Ui(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_shorthash_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_shorthash_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_shorthash(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function Ni(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_shorthash_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_shorthash_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function da(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_shorthash_siphashx24_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_shorthash_siphashx24_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_shorthash_siphashx24(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function ma(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "privateKey");
        var qe, Xe = 0 | m._crypto_sign_secretkeybytes();
        Ee.length !== Xe && Y(Ce, "invalid privateKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(Se.length + m._crypto_sign_bytes() | 0), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_sign(Rt, null, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function ga(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "privateKey");
        var qe, Xe = 0 | m._crypto_sign_secretkeybytes();
        Ee.length !== Xe && Y(Ce, "invalid privateKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_sign_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_sign_detached(Rt, null, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function la(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "edPk");
        var Ce, Re = 0 | m._crypto_sign_publickeybytes();
        Se.length !== Re && Y(ke, "invalid edPk length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_scalarbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_sign_ed25519_pk_to_curve25519(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid key");
      }
      function _s(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "edSk");
        var Ce, Re = 0 | m._crypto_sign_secretkeybytes();
        Se.length !== Re && Y(ke, "invalid edSk length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_scalarbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_sign_ed25519_sk_to_curve25519(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid key");
      }
      function wi(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "privateKey");
        var Ce, Re = 0 | m._crypto_sign_secretkeybytes();
        Se.length !== Re && Y(ke, "invalid privateKey length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_sign_publickeybytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_sign_ed25519_sk_to_pk(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid key");
      }
      function ha(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "privateKey");
        var Ce, Re = 0 | m._crypto_sign_secretkeybytes();
        Se.length !== Re && Y(ke, "invalid privateKey length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_sign_seedbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_sign_ed25519_sk_to_seed(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid key");
      }
      function as(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address"), Ee = oe(Ce, Ee, "privateKey");
        var Re, Fe = 0 | m._crypto_sign_secretkeybytes();
        Ee.length !== Fe && Y(Ce, "invalid privateKey length"), Re = X(Ee), Ce.push(Re);
        var qe = new F(0 | m._crypto_sign_bytes()), Xe = qe.address;
        if (Ce.push(Xe), (0 | m._crypto_sign_final_create(Se, Xe, null, Re)) == 0) {
          var yt = (m._free(Se), M(qe, ke));
          return ue(Ce), yt;
        }
        Q(Ce, "invalid usage");
      }
      function qi(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), pe(Re, Se, "state_address"), Ee = oe(Re, Ee, "signature");
        var Fe, qe = 0 | m._crypto_sign_bytes();
        Ee.length !== qe && Y(Re, "invalid signature length"), Fe = X(Ee), Re.push(Fe), ke = oe(Re, ke, "publicKey");
        var Xe, yt = 0 | m._crypto_sign_publickeybytes();
        ke.length !== yt && Y(Re, "invalid publicKey length"), Xe = X(ke), Re.push(Xe);
        var Rt = (0 | m._crypto_sign_final_verify(Se, Fe, Xe)) == 0;
        return ue(Re), Rt;
      }
      function Aa(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(208).address;
        if (!(0 | m._crypto_sign_init(ke))) {
          var Ce = ke;
          return ue(Ee), Ce;
        }
        Q(Ee, "internal error");
      }
      function ka(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_sign_publickeybytes()), Ce = ke.address;
        Ee.push(Ce);
        var Re = new F(0 | m._crypto_sign_secretkeybytes()), Fe = Re.address;
        if (Ee.push(Fe), (0 | m._crypto_sign_keypair(Ce, Fe)) == 0) {
          var qe = { publicKey: M(ke, Se), privateKey: M(Re, Se), keyType: "ed25519" };
          return ue(Ee), qe;
        }
        Q(Ee, "internal error");
      }
      function ms(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "signedMessage");
        var Re, Fe = m._crypto_sign_bytes(), qe = Se.length;
        qe < Fe && Y(Ce, "signedMessage is too short"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "publicKey");
        var Xe, yt = 0 | m._crypto_sign_publickeybytes();
        Ee.length !== yt && Y(Ce, "invalid publicKey length"), Xe = X(Ee), Ce.push(Xe);
        var Rt = new F(qe - m._crypto_sign_bytes() | 0), Yt = Rt.address;
        if (Ce.push(Yt), (0 | m._crypto_sign_open(Yt, null, Re, qe, 0, Xe)) == 0) {
          var Mn = M(Rt, ke);
          return ue(Ce), Mn;
        }
        Q(Ce, "incorrect signature for the given public key");
      }
      function Ps(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "seed");
        var Ce, Re = 0 | m._crypto_sign_seedbytes();
        Se.length !== Re && Y(ke, "invalid seed length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_sign_publickeybytes()), qe = Fe.address;
        ke.push(qe);
        var Xe = new F(0 | m._crypto_sign_secretkeybytes()), yt = Xe.address;
        if (ke.push(yt), (0 | m._crypto_sign_seed_keypair(qe, yt, Ce)) == 0) {
          var Rt = { publicKey: M(Fe, Ee), privateKey: M(Xe, Ee), keyType: "ed25519" };
          return ue(ke), Rt;
        }
        Q(ke, "invalid usage");
      }
      function Gs(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_sign_update(Se, Re, Fe, 0) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function Ba(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "signature");
        var Re, Fe = 0 | m._crypto_sign_bytes();
        Se.length !== Fe && Y(Ce, "invalid signature length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "publicKey");
        var yt, Rt = 0 | m._crypto_sign_publickeybytes();
        ke.length !== Rt && Y(Ce, "invalid publicKey length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_sign_verify_detached(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function Ms(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), pe(Re, Se, "outLength"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Re, "outLength must be an unsigned integer"), Ee = oe(Re, Ee, "key");
        var Fe, qe = 0 | m._crypto_stream_chacha20_keybytes();
        Ee.length !== qe && Y(Re, "invalid key length"), Fe = X(Ee), Re.push(Fe), ke = oe(Re, ke, "nonce");
        var Xe, yt = 0 | m._crypto_stream_chacha20_noncebytes();
        ke.length !== yt && Y(Re, "invalid nonce length"), Xe = X(ke), Re.push(Xe);
        var Rt = new F(0 | Se), Yt = Rt.address;
        Re.push(Yt), m._crypto_stream_chacha20(Yt, Se, 0, Xe, Fe);
        var Mn = M(Rt, Ce);
        return ue(Re), Mn;
      }
      function Xs(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "input_message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_stream_chacha20_ietf_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_stream_chacha20_ietf_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | qe), Un = Mn.address;
        if (Re.push(Un), m._crypto_stream_chacha20_ietf_xor(Un, Fe, qe, 0, Xe, Rt) === 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function ea(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "input_message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_stream_chacha20_ietf_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), pe(Fe, ke, "nonce_increment"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Fe, "nonce_increment must be an unsigned integer"), Ce = oe(Fe, Ce, "key");
        var Yt, Mn = 0 | m._crypto_stream_chacha20_ietf_keybytes();
        Ce.length !== Mn && Y(Fe, "invalid key length"), Yt = X(Ce), Fe.push(Yt);
        var Un = new F(0 | Xe), Jn = Un.address;
        if (Fe.push(Jn), m._crypto_stream_chacha20_ietf_xor_ic(Jn, qe, Xe, 0, yt, ke, Yt) === 0) {
          var Rn = M(Un, Re);
          return ue(Fe), Rn;
        }
        Q(Fe, "invalid usage");
      }
      function Ji(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_stream_chacha20_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_stream_chacha20_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function Si(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "input_message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_stream_chacha20_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_stream_chacha20_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | qe), Un = Mn.address;
        if (Re.push(Un), m._crypto_stream_chacha20_xor(Un, Fe, qe, 0, Xe, Rt) === 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function Ts(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "input_message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_stream_chacha20_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), pe(Fe, ke, "nonce_increment"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Fe, "nonce_increment must be an unsigned integer"), Ce = oe(Fe, Ce, "key");
        var Yt, Mn = 0 | m._crypto_stream_chacha20_keybytes();
        Ce.length !== Mn && Y(Fe, "invalid key length"), Yt = X(Ce), Fe.push(Yt);
        var Un = new F(0 | Xe), Jn = Un.address;
        if (Fe.push(Jn), m._crypto_stream_chacha20_xor_ic(Jn, qe, Xe, 0, yt, ke, 0, Yt) === 0) {
          var Rn = M(Un, Re);
          return ue(Fe), Rn;
        }
        Q(Fe, "invalid usage");
      }
      function Ds(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_stream_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_stream_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function gs(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_stream_xchacha20_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_stream_xchacha20_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function Os(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "input_message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_stream_xchacha20_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_stream_xchacha20_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | qe), Un = Mn.address;
        if (Re.push(Un), m._crypto_stream_xchacha20_xor(Un, Fe, qe, 0, Xe, Rt) === 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function vt(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "input_message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_stream_xchacha20_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), pe(Fe, ke, "nonce_increment"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Fe, "nonce_increment must be an unsigned integer"), Ce = oe(Fe, Ce, "key");
        var Yt, Mn = 0 | m._crypto_stream_xchacha20_keybytes();
        Ce.length !== Mn && Y(Fe, "invalid key length"), Yt = X(Ce), Fe.push(Yt);
        var Un = new F(0 | Xe), Jn = Un.address;
        if (Fe.push(Jn), m._crypto_stream_xchacha20_xor_ic(Jn, qe, Xe, 0, yt, ke, 0, Yt) === 0) {
          var Rn = M(Un, Re);
          return ue(Fe), Rn;
        }
        Q(Fe, "invalid usage");
      }
      function bs(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "length"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(ke, "length must be an unsigned integer");
        var Ce = new F(0 | Se), Re = Ce.address;
        ke.push(Re), m._randombytes_buf(Re, Se);
        var Fe = M(Ce, Ee);
        return ue(ke), Fe;
      }
      function Di(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "length"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Ce, "length must be an unsigned integer"), Ee = oe(Ce, Ee, "seed");
        var Re, Fe = 0 | m._randombytes_seedbytes();
        Ee.length !== Fe && Y(Ce, "invalid seed length"), Re = X(Ee), Ce.push(Re);
        var qe = new F(0 | Se), Xe = qe.address;
        Ce.push(Xe), m._randombytes_buf_deterministic(Xe, Se, Re);
        var yt = M(qe, ke);
        return ue(Ce), yt;
      }
      function Pa(Se) {
        k(Se), m._randombytes_close();
      }
      function Ea(Se) {
        k(Se);
        var Ee = m._randombytes_random() >>> 0;
        return ue([]), Ee;
      }
      function Cs(Se, Ee) {
        var ke = [];
        k(Ee);
        for (var Ce = m._malloc(24), Re = 0; Re < 6; Re++)
          m.setValue(Ce + 4 * Re, m.Runtime.addFunction(Se[["implementation_name", "random", "stir", "uniform", "buf", "close"][Re]]), "i32");
        0 | m._randombytes_set_implementation(Ce) && Q(ke, "unsupported implementation"), ue(ke);
      }
      function ya(Se) {
        k(Se), m._randombytes_stir();
      }
      function dt(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "upper_bound"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(ke, "upper_bound must be an unsigned integer");
        var Ce = m._randombytes_uniform(Se) >>> 0;
        return ue(ke), Ce;
      }
      function ds() {
        var Se = m._sodium_version_string(), Ee = m.UTF8ToString(Se);
        return ue([]), Ee;
      }
      return F.prototype.to_Uint8Array = function() {
        var Se = new Uint8Array(this.length);
        return Se.set(m.HEAPU8.subarray(this.address, this.address + this.length)), Se;
      }, c.add = function(Se, Ee) {
        if (!(Se instanceof Uint8Array && Ee instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can added");
        var ke = Se.length, Ce = 0, Re = 0;
        if (Ee.length != Se.length)
          throw new TypeError("Arguments must have the same length");
        for (Re = 0; Re < ke; Re++)
          Ce >>= 8, Ce += Se[Re] + Ee[Re], Se[Re] = 255 & Ce;
      }, c.base64_variants = T, c.compare = function(Se, Ee) {
        if (!(Se instanceof Uint8Array && Ee instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be compared");
        if (Se.length !== Ee.length)
          throw new TypeError("Only instances of identical length can be compared");
        for (var ke = 0, Ce = 1, Re = Se.length; Re-- > 0; )
          ke |= Ee[Re] - Se[Re] >> 8 & Ce, Ce &= (Ee[Re] ^ Se[Re]) - 1 >> 8;
        return ke + ke + Ce - 1;
      }, c.from_base64 = function(Se, Ee) {
        Ee = y(Ee);
        var ke, Ce = [], Re = new F(3 * (Se = oe(Ce, Se, "input")).length / 4), Fe = X(Se), qe = ee(4), Xe = ee(4);
        return Ce.push(Fe), Ce.push(Re.address), Ce.push(Re.result_bin_len_p), Ce.push(Re.b64_end_p), m._sodium_base642bin(Re.address, Re.length, Fe, Se.length, 0, qe, Xe, Ee) !== 0 && Q(Ce, "invalid input"), m.getValue(Xe, "i32") - Fe !== Se.length && Q(Ce, "incomplete input"), Re.length = m.getValue(qe, "i32"), ke = Re.to_Uint8Array(), ue(Ce), ke;
      }, c.from_hex = function(Se) {
        var Ee, ke = [], Ce = new F((Se = oe(ke, Se, "input")).length / 2), Re = X(Se), Fe = ee(4);
        return ke.push(Re), ke.push(Ce.address), ke.push(Ce.hex_end_p), m._sodium_hex2bin(Ce.address, Ce.length, Re, Se.length, 0, 0, Fe) !== 0 && Q(ke, "invalid input"), m.getValue(Fe, "i32") - Re !== Se.length && Q(ke, "incomplete input"), Ee = Ce.to_Uint8Array(), ue(ke), Ee;
      }, c.from_string = $, c.increment = function(Se) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be incremented");
        for (var Ee = 256, ke = 0, Ce = Se.length; ke < Ce; ke++)
          Ee >>= 8, Ee += Se[ke], Se[ke] = 255 & Ee;
      }, c.is_zero = function(Se) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be checked");
        for (var Ee = 0, ke = 0, Ce = Se.length; ke < Ce; ke++)
          Ee |= Se[ke];
        return Ee === 0;
      }, c.libsodium = d, c.memcmp = function(Se, Ee) {
        if (!(Se instanceof Uint8Array && Ee instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be compared");
        if (Se.length !== Ee.length)
          throw new TypeError("Only instances of identical length can be compared");
        for (var ke = 0, Ce = 0, Re = Se.length; Ce < Re; Ce++)
          ke |= Se[Ce] ^ Ee[Ce];
        return ke === 0;
      }, c.memzero = function(Se) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be wiped");
        for (var Ee = 0, ke = Se.length; Ee < ke; Ee++)
          Se[Ee] = 0;
      }, c.output_formats = function() {
        return ["uint8array", "text", "hex", "base64"];
      }, c.pad = function(Se, Ee) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("buffer must be a Uint8Array");
        if ((Ee |= 0) <= 0)
          throw new Error("block size must be > 0");
        var ke, Ce = [], Re = ee(4), Fe = 1, qe = 0, Xe = 0 | Se.length, yt = new F(Xe + Ee);
        Ce.push(Re), Ce.push(yt.address);
        for (var Rt = yt.address, Yt = yt.address + Xe + Ee; Rt < Yt; Rt++)
          m.HEAPU8[Rt] = Se[qe], qe += Fe = 1 & ~((65535 & ((Xe -= Fe) >>> 48 | Xe >>> 32 | Xe >>> 16 | Xe)) - 1 >> 16);
        return m._sodium_pad(Re, yt.address, Se.length, Ee, yt.length) !== 0 && Q(Ce, "internal error"), yt.length = m.getValue(Re, "i32"), ke = yt.to_Uint8Array(), ue(Ce), ke;
      }, c.unpad = function(Se, Ee) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("buffer must be a Uint8Array");
        if ((Ee |= 0) <= 0)
          throw new Error("block size must be > 0");
        var ke = [], Ce = X(Se), Re = ee(4);
        return ke.push(Ce), ke.push(Re), m._sodium_unpad(Re, Ce, Se.length, Ee) !== 0 && Q(ke, "unsupported/invalid padding"), Se = (Se = new Uint8Array(Se)).subarray(0, m.getValue(Re, "i32")), ue(ke), Se;
      }, c.ready = S, c.symbols = function() {
        return Object.keys(c).sort();
      }, c.to_base64 = V, c.to_hex = O, c.to_string = E, c;
    }
    var u = typeof n.sodium == "object" && typeof n.sodium.onload == "function" ? n.sodium.onload : null;
    typeof e.nodeName != "string" ? o(e, requireLibsodium()) : n.sodium = o(n.commonJsStrict = {}, n.libsodium), u && n.sodium.ready.then(function() {
      u(n.sodium);
    });
  })(commonjsGlobal);
})(libsodiumWrappers$1);
var __importDefault$Q = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium$8, "__esModule", { value: !0 });
libsodium$8.Xchacha20poly1305Ietf = libsodium$8.xchacha20NonceLength = libsodium$8.Ed25519 = libsodium$8.Ed25519Keypair = libsodium$8.Argon2id = libsodium$8.isArgon2idOptions = void 0;
const utils_1$1b = build$U, libsodium_wrappers_1$1 = __importDefault$Q(libsodiumWrappers$1);
function isArgon2idOptions$7(e) {
  return !(!(0, utils_1$1b.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium$8.isArgon2idOptions = isArgon2idOptions$7;
let Argon2id$7 = class {
  static async execute(n, o, u) {
    return await libsodium_wrappers_1$1.default.ready, libsodium_wrappers_1$1.default.crypto_pwhash(
      u.outputLength,
      n,
      o,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      u.opsLimit,
      u.memLimitKib * 1024,
      libsodium_wrappers_1$1.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
};
libsodium$8.Argon2id = Argon2id$7;
let Ed25519Keypair$7 = class kc {
  constructor(n, o) {
    this.privkey = n, this.pubkey = o;
  }
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(n) {
    if (n.length !== 64)
      throw new Error(`Unexpected key length ${n.length}. Must be 64.`);
    return new kc(n.slice(0, 32), n.slice(32, 64));
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
};
libsodium$8.Ed25519Keypair = Ed25519Keypair$7;
let Ed25519$7 = class {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(n) {
    await libsodium_wrappers_1$1.default.ready;
    const o = libsodium_wrappers_1$1.default.crypto_sign_seed_keypair(n);
    return Ed25519Keypair$7.fromLibsodiumPrivkey(o.privateKey);
  }
  static async createSignature(n, o) {
    return await libsodium_wrappers_1$1.default.ready, libsodium_wrappers_1$1.default.crypto_sign_detached(n, o.toLibsodiumPrivkey());
  }
  static async verifySignature(n, o, u) {
    return await libsodium_wrappers_1$1.default.ready, libsodium_wrappers_1$1.default.crypto_sign_verify_detached(n, o, u);
  }
};
libsodium$8.Ed25519 = Ed25519$7;
libsodium$8.xchacha20NonceLength = 24;
let Xchacha20poly1305Ietf$7 = class {
  static async encrypt(n, o, u) {
    await libsodium_wrappers_1$1.default.ready;
    const c = null;
    return libsodium_wrappers_1$1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      n,
      c,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      u,
      o
    );
  }
  static async decrypt(n, o, u) {
    await libsodium_wrappers_1$1.default.ready;
    const c = null;
    return libsodium_wrappers_1$1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      n,
      c,
      u,
      o
    );
  }
};
libsodium$8.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf$7;
var random$7 = {};
Object.defineProperty(random$7, "__esModule", { value: !0 });
random$7.Random = void 0;
let Random$7 = class {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(n) {
    try {
      const o = typeof window == "object" ? window : self, u = typeof o.crypto < "u" ? o.crypto : o.msCrypto, c = new Uint8Array(n);
      return u.getRandomValues(c), c;
    } catch {
      try {
        const o = requireCryptoBrowserify();
        return new Uint8Array([...o.randomBytes(n)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
};
random$7.Random = Random$7;
var ripemd$7 = {}, ripemd160$8 = {};
Object.defineProperty(ripemd160$8, "__esModule", { value: !0 });
ripemd160$8.ripemd160 = ripemd160$8.RIPEMD160 = void 0;
const _sha2_js_1 = _sha2, utils_js_1 = utils$Z, Rho = new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Id = Uint8Array.from({ length: 16 }, (e, n) => n), Pi = Id.map((e) => (9 * e + 5) % 16);
let idxL = [Id], idxR = [Pi];
for (let e = 0; e < 4; e++)
  for (let n of [idxL, idxR])
    n.push(n[e].map((o) => Rho[o]));
const shifts = [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((e) => new Uint8Array(e)), shiftsL = idxL.map((e, n) => e.map((o) => shifts[n][o])), shiftsR = idxR.map((e, n) => e.map((o) => shifts[n][o])), Kl = new Uint32Array([0, 1518500249, 1859775393, 2400959708, 2840853838]), Kr = new Uint32Array([1352829926, 1548603684, 1836072691, 2053994217, 0]), rotl = (e, n) => e << n | e >>> 32 - n;
function f(e, n, o, u) {
  return e === 0 ? n ^ o ^ u : e === 1 ? n & o | ~n & u : e === 2 ? (n | ~o) ^ u : e === 3 ? n & u | o & ~u : n ^ (o | ~u);
}
const BUF = new Uint32Array(16);
class RIPEMD160 extends _sha2_js_1.SHA2 {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: n, h1: o, h2: u, h3: c, h4: d } = this;
    return [n, o, u, c, d];
  }
  set(n, o, u, c, d) {
    this.h0 = n | 0, this.h1 = o | 0, this.h2 = u | 0, this.h3 = c | 0, this.h4 = d | 0;
  }
  process(n, o) {
    for (let y = 0; y < 16; y++, o += 4)
      BUF[y] = n.getUint32(o, !0);
    let u = this.h0 | 0, c = u, d = this.h1 | 0, m = d, v = this.h2 | 0, S = v, $ = this.h3 | 0, E = $, O = this.h4 | 0, T = O;
    for (let y = 0; y < 5; y++) {
      const V = 4 - y, M = Kl[y], G = Kr[y], k = idxL[y], F = idxR[y], X = shiftsL[y], ee = shiftsR[y];
      for (let ue = 0; ue < 16; ue++) {
        const Q = rotl(u + f(y, d, v, $) + BUF[k[ue]] + M, X[ue]) + O | 0;
        u = O, O = $, $ = rotl(v, 10) | 0, v = d, d = Q;
      }
      for (let ue = 0; ue < 16; ue++) {
        const Q = rotl(c + f(V, m, S, E) + BUF[F[ue]] + G, ee[ue]) + T | 0;
        c = T, T = E, E = rotl(S, 10) | 0, S = m, m = Q;
      }
    }
    this.set(this.h1 + v + E | 0, this.h2 + $ + T | 0, this.h3 + O + c | 0, this.h4 + u + m | 0, this.h0 + d + S | 0);
  }
  roundClean() {
    BUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
}
ripemd160$8.RIPEMD160 = RIPEMD160;
ripemd160$8.ripemd160 = (0, utils_js_1.wrapConstructor)(() => new RIPEMD160());
Object.defineProperty(ripemd$7, "__esModule", { value: !0 });
ripemd$7.ripemd160 = ripemd$7.Ripemd160 = void 0;
const ripemd160_1$8 = ripemd160$8, utils_1$1a = utils$B;
let Ripemd160$7 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$8.ripemd160.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$1a.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
ripemd$7.Ripemd160 = Ripemd160$7;
function ripemd160$7(e) {
  return new Ripemd160$7(e).digest();
}
ripemd$7.ripemd160 = ripemd160$7;
var secp256k1$f = {}, secp256k1signature$7 = {};
Object.defineProperty(secp256k1signature$7, "__esModule", { value: !0 });
secp256k1signature$7.ExtendedSecp256k1Signature = secp256k1signature$7.Secp256k1Signature = void 0;
function trimLeadingNullBytes$7(e) {
  let n = 0;
  for (const o of e)
    if (o === 0)
      n++;
    else
      break;
  return e.slice(n);
}
const derTagInteger$7 = 2;
let Secp256k1Signature$7 = class Qu {
  constructor(n, o) {
    if (n.length > 32 || n.length === 0 || n[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (o.length > 32 || o.length === 0 || o[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: n,
      s: o
    };
  }
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(n) {
    if (n.length !== 64)
      throw new Error(`Got invalid data length: ${n.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new Qu(trimLeadingNullBytes$7(n.slice(0, 32)), trimLeadingNullBytes$7(n.slice(32, 64)));
  }
  static fromDer(n) {
    let o = 0;
    if (n[o++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const u = n[o++];
    if (n.length - o !== u)
      throw new Error("Data length mismatch detected");
    if (n[o++] !== derTagInteger$7)
      throw new Error("INTEGER tag expected");
    const d = n[o++];
    if (d >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const m = n.slice(o, o + d);
    if (o += d, n[o++] !== derTagInteger$7)
      throw new Error("INTEGER tag expected");
    const S = n[o++];
    if (S >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const $ = n.slice(o, o + S);
    return o += S, new Qu(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes$7(m),
      trimLeadingNullBytes$7($)
    );
  }
  r(n) {
    if (n === void 0)
      return this.data.r;
    {
      const o = n - this.data.r.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter r");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.r]);
    }
  }
  s(n) {
    if (n === void 0)
      return this.data.s;
    {
      const o = n - this.data.s.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter s");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const n = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, o = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, u = n.length, c = o.length, d = new Uint8Array([derTagInteger$7, u, ...n, derTagInteger$7, c, ...o]);
    return new Uint8Array([48, d.length, ...d]);
  }
};
secp256k1signature$7.Secp256k1Signature = Secp256k1Signature$7;
let ExtendedSecp256k1Signature$7 = class Bc extends Secp256k1Signature$7 {
  constructor(n, o, u) {
    if (super(n, o), !Number.isInteger(u))
      throw new Error("The recovery parameter must be an integer.");
    if (u < 0 || u > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = u;
  }
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(n) {
    if (n.length !== 65)
      throw new Error(`Got invalid data length ${n.length}. Expected 32 + 32 + 1`);
    return new Bc(trimLeadingNullBytes$7(n.slice(0, 32)), trimLeadingNullBytes$7(n.slice(32, 64)), n[64]);
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
};
secp256k1signature$7.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature$7;
var __importDefault$P = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$f, "__esModule", { value: !0 });
secp256k1$f.Secp256k1 = void 0;
const encoding_1$1r = build$V, bn_js_1$n = __importDefault$P(bnExports$1), elliptic_1$8 = __importDefault$P(requireElliptic()), secp256k1signature_1$7 = secp256k1signature$7, secp256k1$e = new elliptic_1$8.default.ec("secp256k1"), secp256k1N$7 = new bn_js_1$n.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
let Secp256k1$7 = class {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(n) {
    if (n.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const o = secp256k1$e.keyFromPrivate(n);
    if (o.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$n.default(n).gte(secp256k1N$7))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$1r.fromHex)(o.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(o.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(n, o) {
    if (n.length === 0)
      throw new Error("Message hash must not be empty");
    if (n.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const u = secp256k1$e.keyFromPrivate(o), { r: c, s: d, recoveryParam: m } = u.sign(n, { canonical: !0 });
    if (typeof m != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1$7.ExtendedSecp256k1Signature(Uint8Array.from(c.toArray()), Uint8Array.from(d.toArray()), m);
  }
  static async verifySignature(n, o, u) {
    if (o.length === 0)
      throw new Error("Message hash must not be empty");
    if (o.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const c = secp256k1$e.keyFromPublic(u);
    try {
      return c.verify(o, n.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(n, o) {
    const u = { r: (0, encoding_1$1r.toHex)(n.r()), s: (0, encoding_1$1r.toHex)(n.s()) }, c = secp256k1$e.recoverPubKey(o, u, n.recovery), d = secp256k1$e.keyFromPublic(c);
    return (0, encoding_1$1r.fromHex)(d.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(n) {
    switch (n.length) {
      case 33:
        return n;
      case 65:
        return Uint8Array.from(secp256k1$e.keyFromPublic(n).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(n) {
    switch (n.length) {
      case 33:
        return Uint8Array.from(secp256k1$e.keyFromPublic(n).getPublic(!1, "array"));
      case 65:
        return n;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(n) {
    switch (n.length) {
      case 64:
        return n;
      case 65:
        return n.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
};
secp256k1$f.Secp256k1 = Secp256k1$7;
var slip10$7 = {}, build$T = {}, decimal$7 = {}, __importDefault$O = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal$7, "__esModule", { value: !0 });
decimal$7.Decimal = void 0;
const bn_js_1$m = __importDefault$O(bnExports$1), maxFractionalDigits$7 = 100;
let Decimal$7 = class es {
  constructor(n, o) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$m.default(n),
      fractionalDigits: o
    };
  }
  static fromUserInput(n, o) {
    es.verifyFractionalDigits(o);
    const u = n.match(/[^0-9.]/);
    if (u)
      throw new Error(`Invalid character at position ${u.index + 1}`);
    let c, d;
    if (n === "")
      c = "0", d = "";
    else if (n.search(/\./) === -1)
      c = n, d = "";
    else {
      const v = n.split(".");
      switch (v.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!v[1])
            throw new Error("Fractional part missing");
          c = v[0], d = v[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (d.length > o)
      throw new Error("Got more fractional digits than supported");
    const m = `${c}${d.padEnd(o, "0")}`;
    return new es(m, o);
  }
  static fromAtomics(n, o) {
    return es.verifyFractionalDigits(o), new es(n, o);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(n) {
    return es.verifyFractionalDigits(n), new es("0", n);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(n) {
    return es.verifyFractionalDigits(n), new es("1" + "0".repeat(n), n);
  }
  static verifyFractionalDigits(n) {
    if (!Number.isInteger(n))
      throw new Error("Fractional digits is not an integer");
    if (n < 0)
      throw new Error("Fractional digits must not be negative");
    if (n > maxFractionalDigits$7)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits$7}`);
  }
  static compare(n, o) {
    if (n.fractionalDigits !== o.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return n.data.atomics.cmp(new bn_js_1$m.default(o.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  /** Creates a new instance with the same value */
  clone() {
    return new es(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const n = new bn_js_1$m.default(10).pow(new bn_js_1$m.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : es.fromAtomics(o.mul(n).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const n = new bn_js_1$m.default(10).pow(new bn_js_1$m.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : es.fromAtomics(o.addn(1).mul(n).toString(), this.fractionalDigits);
  }
  toString() {
    const n = new bn_js_1$m.default(10).pow(new bn_js_1$m.default(this.data.fractionalDigits)), o = this.data.atomics.div(n), u = this.data.atomics.mod(n);
    if (u.isZero())
      return o.toString();
    {
      const d = u.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${o.toString()}.${d}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const n = Number(this.toString());
    if (Number.isNaN(n))
      throw new Error("Conversion to number failed");
    return n;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.add(new bn_js_1$m.default(n.atomics));
    return new es(o.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.sub(new bn_js_1$m.default(n.atomics));
    if (o.ltn(0))
      throw new Error("Difference must not be negative");
    return new es(o.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(n) {
    const o = this.data.atomics.mul(new bn_js_1$m.default(n.toString()));
    return new es(o.toString(), this.fractionalDigits);
  }
  equals(n) {
    return es.compare(this, n) === 0;
  }
  isLessThan(n) {
    return es.compare(this, n) < 0;
  }
  isLessThanOrEqual(n) {
    return es.compare(this, n) <= 0;
  }
  isGreaterThan(n) {
    return es.compare(this, n) > 0;
  }
  isGreaterThanOrEqual(n) {
    return es.compare(this, n) >= 0;
  }
};
decimal$7.Decimal = Decimal$7;
var integers$7 = {}, __importDefault$N = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers$7, "__esModule", { value: !0 });
integers$7.Uint64 = integers$7.Uint53 = integers$7.Int53 = integers$7.Uint32 = void 0;
const bn_js_1$l = __importDefault$N(bnExports$1), uint64MaxValue$7 = new bn_js_1$l.default("18446744073709551615", 10, "be");
let Uint32$7 = class vu {
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < 0 || n > 4294967295)
      throw new Error("Input not in uint32 range: " + n.toString());
    this.data = n;
  }
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(n) {
    return vu.fromBytes(n);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? n : Array.from(n).reverse();
    return new vu(u[0] * 2 ** 24 + u[1] * 2 ** 16 + u[2] * 2 ** 8 + u[3]);
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new vu(Number.parseInt(n, 10));
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$7.Uint32 = Uint32$7;
let Int53$7 = class Pc {
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + n.toString());
    this.data = n;
  }
  static fromString(n) {
    if (!n.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Pc(Number.parseInt(n, 10));
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$7.Int53 = Int53$7;
let Uint53$7 = class Ec {
  constructor(n) {
    const o = new Int53$7(n);
    if (o.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = o;
  }
  static fromString(n) {
    const o = Int53$7.fromString(n);
    return new Ec(o.toNumber());
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$7.Uint53 = Uint53$7;
let Uint64$7 = class ru {
  constructor(n) {
    if (n.isNeg())
      throw new Error("Input is negative");
    if (n.gt(uint64MaxValue$7))
      throw new Error("Input exceeds uint64 range");
    this.data = n;
  }
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(n) {
    return ru.fromBytes(n);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? Array.from(n) : Array.from(n).reverse();
    return new ru(new bn_js_1$l.default(u));
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new ru(new bn_js_1$l.default(n, 10, "be"));
  }
  static fromNumber(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    let o;
    try {
      o = new bn_js_1$l.default(n);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new ru(o);
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
};
integers$7.Uint64 = Uint64$7;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var n = decimal$7;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return n.Decimal;
  } });
  var o = integers$7;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return o.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return o.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return o.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return o.Uint64;
  } });
})(build$T);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const o = build$V, u = build$T, c = n(bnExports$1), d = n(requireElliptic()), m = hmac$7, v = sha$7;
  var S;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(S = e.Slip10Curve || (e.Slip10Curve = {}));
  function $(M) {
    switch (M) {
      case S.Ed25519:
        return S.Ed25519;
      case S.Secp256k1:
        return S.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  e.slip10CurveFromString = $;
  class E extends u.Uint32 {
    static hardened(G) {
      return new E(G + 2 ** 31);
    }
    static normal(G) {
      return new E(G);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = E;
  const O = new d.default.ec("secp256k1");
  class T {
    static derivePath(G, k, F) {
      let X = this.master(G, k);
      for (const ee of F)
        X = this.child(G, X.privkey, X.chainCode, ee);
      return X;
    }
    static master(G, k) {
      const F = new m.Hmac(v.Sha512, (0, o.toAscii)(G)).update(k).digest(), X = F.slice(0, 32), ee = F.slice(32, 64);
      return G !== S.Ed25519 && (this.isZero(X) || this.isGteN(G, X)) ? this.master(G, F) : {
        chainCode: ee,
        privkey: X
      };
    }
    static child(G, k, F, X) {
      let ee;
      if (X.isHardened()) {
        const ue = new Uint8Array([0, ...k, ...X.toBytesBigEndian()]);
        ee = new m.Hmac(v.Sha512, F).update(ue).digest();
      } else {
        if (G === S.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ue = new Uint8Array([
            ...T.serializedPoint(G, new c.default(k)),
            ...X.toBytesBigEndian()
          ]);
          ee = new m.Hmac(v.Sha512, F).update(ue).digest();
        }
      }
      return this.childImpl(G, k, F, X, ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(G, k) {
      switch (G) {
        case S.Secp256k1:
          return (0, o.fromHex)(O.g.mul(k).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(G, k, F, X, ee) {
      const ue = ee.slice(0, 32), Q = ee.slice(32, 64), Y = Q;
      if (G === S.Ed25519)
        return {
          chainCode: Y,
          privkey: ue
        };
      const pe = this.n(G), oe = new c.default(ue).add(new c.default(k)).mod(pe), ne = Uint8Array.from(oe.toArray("be", 32));
      if (this.isGteN(G, ue) || this.isZero(ne)) {
        const H = new m.Hmac(v.Sha512, F).update(new Uint8Array([1, ...Q, ...X.toBytesBigEndian()])).digest();
        return this.childImpl(G, k, F, X, H);
      }
      return {
        chainCode: Y,
        privkey: ne
      };
    }
    static isZero(G) {
      return G.every((k) => k === 0);
    }
    static isGteN(G, k) {
      return new c.default(k).gte(this.n(G));
    }
    static n(G) {
      switch (G) {
        case S.Secp256k1:
          return new c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = T;
  function y(M) {
    return M.reduce((G, k) => {
      const F = k.isHardened() ? `${k.toNumber() - 2147483648}'` : k.toString();
      return G + "/" + F;
    }, "m");
  }
  e.pathToString = y;
  function V(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let G = M.slice(1);
    const k = new Array();
    for (; G; ) {
      const F = G.match(/^\/([0-9]+)('?)/);
      if (!F)
        throw new Error("Syntax error while reading path component");
      const [X, ee, ue] = F, Q = u.Uint53.fromString(ee).toNumber();
      if (Q >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ue ? k.push(E.hardened(Q)) : k.push(E.normal(Q)), G = G.slice(X.length);
    }
    return k;
  }
  e.stringToPath = V;
})(slip10$7);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var n = bip39$7;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return n.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return n.EnglishMnemonic;
  } });
  var o = hmac$7;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return o.Hmac;
  } });
  var u = keccak$7;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return u.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return u.keccak256;
  } });
  var c = libsodium$8;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return c.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return c.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return c.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return c.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return c.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return c.Xchacha20poly1305Ietf;
  } });
  var d = random$7;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return d.Random;
  } });
  var m = ripemd$7;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return m.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return m.ripemd160;
  } });
  var v = secp256k1$f;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return v.Secp256k1;
  } });
  var S = secp256k1signature$7;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return S.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return S.Secp256k1Signature;
  } });
  var $ = sha$7;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return $.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return $.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return $.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return $.sha512;
  } });
  var E = slip10$7;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return E.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return E.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return E.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return E.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return E.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return E.stringToPath;
  } });
})(build$W);
var build$S = {}, accounts$1 = {}, build$R = {}, decimal$6 = {}, __importDefault$M = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal$6, "__esModule", { value: !0 });
decimal$6.Decimal = void 0;
const bn_js_1$k = __importDefault$M(bnExports$1), maxFractionalDigits$6 = 100;
let Decimal$6 = class ts {
  static fromUserInput(n, o) {
    ts.verifyFractionalDigits(o);
    const u = n.match(/[^0-9.]/);
    if (u)
      throw new Error(`Invalid character at position ${u.index + 1}`);
    let c, d;
    if (n === "")
      c = "0", d = "";
    else if (n.search(/\./) === -1)
      c = n, d = "";
    else {
      const v = n.split(".");
      switch (v.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!v[1])
            throw new Error("Fractional part missing");
          c = v[0], d = v[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (d.length > o)
      throw new Error("Got more fractional digits than supported");
    const m = `${c}${d.padEnd(o, "0")}`;
    return new ts(m, o);
  }
  static fromAtomics(n, o) {
    return ts.verifyFractionalDigits(o), new ts(n, o);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(n) {
    return ts.verifyFractionalDigits(n), new ts("0", n);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(n) {
    return ts.verifyFractionalDigits(n), new ts("1" + "0".repeat(n), n);
  }
  static verifyFractionalDigits(n) {
    if (!Number.isInteger(n))
      throw new Error("Fractional digits is not an integer");
    if (n < 0)
      throw new Error("Fractional digits must not be negative");
    if (n > maxFractionalDigits$6)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits$6}`);
  }
  static compare(n, o) {
    if (n.fractionalDigits !== o.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return n.data.atomics.cmp(new bn_js_1$k.default(o.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(n, o) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$k.default(n),
      fractionalDigits: o
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new ts(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const n = new bn_js_1$k.default(10).pow(new bn_js_1$k.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : ts.fromAtomics(o.mul(n).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const n = new bn_js_1$k.default(10).pow(new bn_js_1$k.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : ts.fromAtomics(o.addn(1).mul(n).toString(), this.fractionalDigits);
  }
  toString() {
    const n = new bn_js_1$k.default(10).pow(new bn_js_1$k.default(this.data.fractionalDigits)), o = this.data.atomics.div(n), u = this.data.atomics.mod(n);
    if (u.isZero())
      return o.toString();
    {
      const d = u.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${o.toString()}.${d}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const n = Number(this.toString());
    if (Number.isNaN(n))
      throw new Error("Conversion to number failed");
    return n;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.add(new bn_js_1$k.default(n.atomics));
    return new ts(o.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.sub(new bn_js_1$k.default(n.atomics));
    if (o.ltn(0))
      throw new Error("Difference must not be negative");
    return new ts(o.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(n) {
    const o = this.data.atomics.mul(new bn_js_1$k.default(n.toString()));
    return new ts(o.toString(), this.fractionalDigits);
  }
  equals(n) {
    return ts.compare(this, n) === 0;
  }
  isLessThan(n) {
    return ts.compare(this, n) < 0;
  }
  isLessThanOrEqual(n) {
    return ts.compare(this, n) <= 0;
  }
  isGreaterThan(n) {
    return ts.compare(this, n) > 0;
  }
  isGreaterThanOrEqual(n) {
    return ts.compare(this, n) >= 0;
  }
};
decimal$6.Decimal = Decimal$6;
var integers$6 = {}, __importDefault$L = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers$6, "__esModule", { value: !0 });
integers$6.Uint64 = integers$6.Uint53 = integers$6.Int53 = integers$6.Uint32 = void 0;
const bn_js_1$j = __importDefault$L(bnExports$1), uint64MaxValue$6 = new bn_js_1$j.default("18446744073709551615", 10, "be");
let Uint32$6 = class _u {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(n) {
    return _u.fromBytes(n);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? n : Array.from(n).reverse();
    return new _u(u[0] * 2 ** 24 + u[1] * 2 ** 16 + u[2] * 2 ** 8 + u[3]);
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new _u(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < 0 || n > 4294967295)
      throw new Error("Input not in uint32 range: " + n.toString());
    this.data = n;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$6.Uint32 = Uint32$6;
let Int53$6 = class Rc {
  static fromString(n) {
    if (!n.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Rc(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + n.toString());
    this.data = n;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$6.Int53 = Int53$6;
let Uint53$6 = class $c {
  static fromString(n) {
    const o = Int53$6.fromString(n);
    return new $c(o.toNumber());
  }
  constructor(n) {
    const o = new Int53$6(n);
    if (o.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = o;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$6.Uint53 = Uint53$6;
let Uint64$6 = class ou {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(n) {
    return ou.fromBytes(n);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? Array.from(n) : Array.from(n).reverse();
    return new ou(new bn_js_1$j.default(u));
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new ou(new bn_js_1$j.default(n, 10, "be"));
  }
  static fromNumber(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    let o;
    try {
      o = new bn_js_1$j.default(n);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new ou(o);
  }
  constructor(n) {
    if (n.isNeg())
      throw new Error("Input is negative");
    if (n.gt(uint64MaxValue$6))
      throw new Error("Input exceeds uint64 range");
    this.data = n;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
};
integers$6.Uint64 = Uint64$6;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var n = decimal$6;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return n.Decimal;
  } });
  var o = integers$6;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return o.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return o.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return o.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return o.Uint64;
  } });
})(build$R);
var build$Q = {}, coins$5 = {};
Object.defineProperty(coins$5, "__esModule", { value: !0 });
coins$5.parseCoins = void 0;
function parseCoins$3(e) {
  return e.replace(/\s/g, "").split(",").filter(Boolean).map((n) => {
    const o = n.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
    if (!o)
      throw new Error("Got an invalid coin string");
    return {
      amount: o[1].replace(/^0+/, "") || "0",
      denom: o[2]
    };
  });
}
coins$5.parseCoins = parseCoins$3;
var decode$1 = {}, tx$p = {}, any$1 = {}, binary = {}, utf8$a = {};
Object.defineProperty(utf8$a, "__esModule", { value: !0 });
utf8$a.utf8Write = utf8$a.utf8Read = utf8$a.utf8Length = void 0;
function utf8Length(e) {
  let n = 0, o = 0;
  for (let u = 0; u < e.length; ++u)
    o = e.charCodeAt(u), o < 128 ? n += 1 : o < 2048 ? n += 2 : (o & 64512) === 55296 && (e.charCodeAt(u + 1) & 64512) === 56320 ? (++u, n += 4) : n += 3;
  return n;
}
utf8$a.utf8Length = utf8Length;
function utf8Read(e, n, o) {
  if (o - n < 1)
    return "";
  const c = [];
  let d = [], m = 0, v;
  for (; n < o; )
    v = e[n++], v < 128 ? c[m++] = v : v > 191 && v < 224 ? c[m++] = (v & 31) << 6 | e[n++] & 63 : v > 239 && v < 365 ? (v = ((v & 7) << 18 | (e[n++] & 63) << 12 | (e[n++] & 63) << 6 | e[n++] & 63) - 65536, c[m++] = 55296 + (v >> 10), c[m++] = 56320 + (v & 1023)) : c[m++] = (v & 15) << 12 | (e[n++] & 63) << 6 | e[n++] & 63, m > 8191 && ((d || (d = [])).push(String.fromCharCode(...c)), m = 0);
  return d ? (m && d.push(String.fromCharCode(...c.slice(0, m))), d.join("")) : String.fromCharCode(...c.slice(0, m));
}
utf8$a.utf8Read = utf8Read;
function utf8Write(e, n, o) {
  const u = o;
  let c, d;
  for (let m = 0; m < e.length; ++m)
    c = e.charCodeAt(m), c < 128 ? n[o++] = c : c < 2048 ? (n[o++] = c >> 6 | 192, n[o++] = c & 63 | 128) : (c & 64512) === 55296 && ((d = e.charCodeAt(m + 1)) & 64512) === 56320 ? (c = 65536 + ((c & 1023) << 10) + (d & 1023), ++m, n[o++] = c >> 18 | 240, n[o++] = c >> 12 & 63 | 128, n[o++] = c >> 6 & 63 | 128, n[o++] = c & 63 | 128) : (n[o++] = c >> 12 | 224, n[o++] = c >> 6 & 63 | 128, n[o++] = c & 63 | 128);
  return o - u;
}
utf8$a.utf8Write = utf8Write;
var varint = {};
Object.defineProperty(varint, "__esModule", { value: !0 });
varint.writeByte = varint.writeFixed32 = varint.int64Length = varint.writeVarint64 = varint.writeVarint32 = varint.readInt32 = varint.readUInt32 = varint.zzDecode = varint.zzEncode = varint.varint32read = varint.varint32write = varint.uInt64ToString = varint.int64ToString = varint.int64FromString = varint.varint64write = varint.varint64read = void 0;
function varint64read() {
  let e = 0, n = 0;
  for (let u = 0; u < 28; u += 7) {
    let c = this.buf[this.pos++];
    if (e |= (c & 127) << u, !(c & 128))
      return this.assertBounds(), [e, n];
  }
  let o = this.buf[this.pos++];
  if (e |= (o & 15) << 28, n = (o & 112) >> 4, !(o & 128))
    return this.assertBounds(), [e, n];
  for (let u = 3; u <= 31; u += 7) {
    let c = this.buf[this.pos++];
    if (n |= (c & 127) << u, !(c & 128))
      return this.assertBounds(), [e, n];
  }
  throw new Error("invalid varint");
}
varint.varint64read = varint64read;
function varint64write(e, n, o) {
  for (let d = 0; d < 28; d = d + 7) {
    const m = e >>> d, v = !(!(m >>> 7) && n == 0), S = (v ? m | 128 : m) & 255;
    if (o.push(S), !v)
      return;
  }
  const u = e >>> 28 & 15 | (n & 7) << 4, c = !!(n >> 3);
  if (o.push((c ? u | 128 : u) & 255), !!c) {
    for (let d = 3; d < 31; d = d + 7) {
      const m = n >>> d, v = !!(m >>> 7), S = (v ? m | 128 : m) & 255;
      if (o.push(S), !v)
        return;
    }
    o.push(n >>> 31 & 1);
  }
}
varint.varint64write = varint64write;
const TWO_PWR_32_DBL$3 = 4294967296;
function int64FromString(e) {
  const n = e[0] === "-";
  n && (e = e.slice(1));
  const o = 1e6;
  let u = 0, c = 0;
  function d(m, v) {
    const S = Number(e.slice(m, v));
    c *= o, u = u * o + S, u >= TWO_PWR_32_DBL$3 && (c = c + (u / TWO_PWR_32_DBL$3 | 0), u = u % TWO_PWR_32_DBL$3);
  }
  return d(-24, -18), d(-18, -12), d(-12, -6), d(-6), n ? negate(u, c) : newBits(u, c);
}
varint.int64FromString = int64FromString;
function int64ToString(e, n) {
  let o = newBits(e, n);
  const u = o.hi & 2147483648;
  u && (o = negate(o.lo, o.hi));
  const c = uInt64ToString(o.lo, o.hi);
  return u ? "-" + c : c;
}
varint.int64ToString = int64ToString;
function uInt64ToString(e, n) {
  if ({ lo: e, hi: n } = toUnsigned(e, n), n <= 2097151)
    return String(TWO_PWR_32_DBL$3 * n + e);
  const o = e & 16777215, u = (e >>> 24 | n << 8) & 16777215, c = n >> 16 & 65535;
  let d = o + u * 6777216 + c * 6710656, m = u + c * 8147497, v = c * 2;
  const S = 1e7;
  return d >= S && (m += Math.floor(d / S), d %= S), m >= S && (v += Math.floor(m / S), m %= S), v.toString() + decimalFrom1e7WithLeadingZeros(m) + decimalFrom1e7WithLeadingZeros(d);
}
varint.uInt64ToString = uInt64ToString;
function toUnsigned(e, n) {
  return { lo: e >>> 0, hi: n >>> 0 };
}
function newBits(e, n) {
  return { lo: e | 0, hi: n | 0 };
}
function negate(e, n) {
  return n = ~n, e ? e = ~e + 1 : n += 1, newBits(e, n);
}
const decimalFrom1e7WithLeadingZeros = (e) => {
  const n = String(e);
  return "0000000".slice(n.length) + n;
};
function varint32write(e, n) {
  if (e >= 0) {
    for (; e > 127; )
      n.push(e & 127 | 128), e = e >>> 7;
    n.push(e);
  } else {
    for (let o = 0; o < 9; o++)
      n.push(e & 127 | 128), e = e >> 7;
    n.push(1);
  }
}
varint.varint32write = varint32write;
function varint32read() {
  let e = this.buf[this.pos++], n = e & 127;
  if (!(e & 128))
    return this.assertBounds(), n;
  if (e = this.buf[this.pos++], n |= (e & 127) << 7, !(e & 128))
    return this.assertBounds(), n;
  if (e = this.buf[this.pos++], n |= (e & 127) << 14, !(e & 128))
    return this.assertBounds(), n;
  if (e = this.buf[this.pos++], n |= (e & 127) << 21, !(e & 128))
    return this.assertBounds(), n;
  e = this.buf[this.pos++], n |= (e & 15) << 28;
  for (let o = 5; e & 128 && o < 10; o++)
    e = this.buf[this.pos++];
  if (e & 128)
    throw new Error("invalid varint");
  return this.assertBounds(), n >>> 0;
}
varint.varint32read = varint32read;
function zzEncode(e, n) {
  let o = n >> 31;
  return n = ((n << 1 | e >>> 31) ^ o) >>> 0, e = (e << 1 ^ o) >>> 0, [e, n];
}
varint.zzEncode = zzEncode;
function zzDecode(e, n) {
  let o = -(e & 1);
  return e = ((e >>> 1 | n << 31) ^ o) >>> 0, n = (n >>> 1 ^ o) >>> 0, [e, n];
}
varint.zzDecode = zzDecode;
function readUInt32(e, n) {
  return (e[n] | e[n + 1] << 8 | e[n + 2] << 16) + e[n + 3] * 16777216;
}
varint.readUInt32 = readUInt32;
function readInt32(e, n) {
  return (e[n] | e[n + 1] << 8 | e[n + 2] << 16) + (e[n + 3] << 24);
}
varint.readInt32 = readInt32;
function writeVarint32$1(e, n, o) {
  for (; e > 127; )
    n[o++] = e & 127 | 128, e >>>= 7;
  n[o] = e;
}
varint.writeVarint32 = writeVarint32$1;
function writeVarint64$1(e, n, o) {
  for (; e.hi; )
    n[o++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    n[o++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  n[o++] = e.lo;
}
varint.writeVarint64 = writeVarint64$1;
function int64Length(e, n) {
  let o = e, u = (e >>> 28 | n << 4) >>> 0, c = n >>> 24;
  return c === 0 ? u === 0 ? o < 16384 ? o < 128 ? 1 : 2 : o < 2097152 ? 3 : 4 : u < 16384 ? u < 128 ? 5 : 6 : u < 2097152 ? 7 : 8 : c < 128 ? 9 : 10;
}
varint.int64Length = int64Length;
function writeFixed32$1(e, n, o) {
  n[o] = e & 255, n[o + 1] = e >>> 8 & 255, n[o + 2] = e >>> 16 & 255, n[o + 3] = e >>> 24;
}
varint.writeFixed32 = writeFixed32$1;
function writeByte$1(e, n, o) {
  n[o] = e & 255;
}
varint.writeByte = writeByte$1;
Object.defineProperty(binary, "__esModule", { value: !0 });
binary.BinaryWriter = binary.BinaryReader = binary.WireType = void 0;
const utf8_1 = utf8$a, varint_1 = varint;
var WireType;
(function(e) {
  e[e.Varint = 0] = "Varint", e[e.Fixed64 = 1] = "Fixed64", e[e.Bytes = 2] = "Bytes", e[e.Fixed32 = 5] = "Fixed32";
})(WireType || (binary.WireType = WireType = {}));
class BinaryReader {
  assertBounds() {
    if (this.pos > this.len)
      throw new RangeError("premature EOF");
  }
  constructor(n) {
    this.buf = n ? new Uint8Array(n) : new Uint8Array(0), this.pos = 0, this.type = 0, this.len = this.buf.length;
  }
  tag() {
    const n = this.uint32(), o = n >>> 3, u = n & 7;
    if (o <= 0 || u < 0 || u > 5)
      throw new Error("illegal tag: field no " + o + " wire type " + u);
    return [o, u, n];
  }
  skip(n) {
    if (typeof n == "number") {
      if (this.pos + n > this.len)
        throw indexOutOfRange$1(this, n);
      this.pos += n;
    } else
      do
        if (this.pos >= this.len)
          throw indexOutOfRange$1(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }
  skipType(n) {
    switch (n) {
      case WireType.Varint:
        this.skip();
        break;
      case WireType.Fixed64:
        this.skip(8);
        break;
      case WireType.Bytes:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (n = this.uint32() & 7) !== 4; )
          this.skipType(n);
        break;
      case WireType.Fixed32:
        this.skip(4);
        break;
      default:
        throw Error("invalid wire type " + n + " at offset " + this.pos);
    }
    return this;
  }
  uint32() {
    return varint_1.varint32read.bind(this)();
  }
  int32() {
    return this.uint32() | 0;
  }
  sint32() {
    const n = this.uint32();
    return n % 2 === 1 ? (n + 1) / -2 : n / 2;
  }
  fixed32() {
    const n = (0, varint_1.readUInt32)(this.buf, this.pos);
    return this.pos += 4, n;
  }
  sfixed32() {
    const n = (0, varint_1.readInt32)(this.buf, this.pos);
    return this.pos += 4, n;
  }
  int64() {
    const [n, o] = varint_1.varint64read.bind(this)();
    return BigInt((0, varint_1.int64ToString)(n, o));
  }
  uint64() {
    const [n, o] = varint_1.varint64read.bind(this)();
    return BigInt((0, varint_1.uInt64ToString)(n, o));
  }
  sint64() {
    let [n, o] = varint_1.varint64read.bind(this)();
    return [n, o] = (0, varint_1.zzDecode)(n, o), BigInt((0, varint_1.int64ToString)(n, o));
  }
  fixed64() {
    const n = this.sfixed32(), o = this.sfixed32();
    return BigInt((0, varint_1.uInt64ToString)(n, o));
  }
  sfixed64() {
    const n = this.sfixed32(), o = this.sfixed32();
    return BigInt((0, varint_1.int64ToString)(n, o));
  }
  float() {
    throw new Error("float not supported");
  }
  double() {
    throw new Error("double not supported");
  }
  bool() {
    const [n, o] = varint_1.varint64read.bind(this)();
    return n !== 0 || o !== 0;
  }
  bytes() {
    const n = this.uint32(), o = this.pos;
    return this.pos += n, this.assertBounds(), this.buf.subarray(o, o + n);
  }
  string() {
    const n = this.bytes();
    return (0, utf8_1.utf8Read)(n, 0, n.length);
  }
}
binary.BinaryReader = BinaryReader;
let Op$1 = class {
  constructor(n, o, u) {
    this.fn = n, this.len = o, this.val = u;
  }
  proceed(n, o) {
    this.fn && this.fn(this.val, n, o);
  }
}, State$3 = class {
  constructor(n) {
    this.head = n.head, this.tail = n.tail, this.len = n.len, this.next = n.states;
  }
};
class BinaryWriter {
  constructor() {
    this.len = 0, this.uint64 = BinaryWriter.prototype.int64, this.sfixed64 = BinaryWriter.prototype.fixed64, this.sfixed32 = BinaryWriter.prototype.fixed32, this.head = new Op$1(null, 0, 0), this.tail = this.head, this.states = null;
  }
  static create() {
    return new BinaryWriter();
  }
  static alloc(n) {
    return typeof Uint8Array < "u" ? pool$1((o) => new Uint8Array(o), Uint8Array.prototype.subarray)(n) : new Array(n);
  }
  _push(n, o, u) {
    return this.tail = this.tail.next = new Op$1(n, o, u), this.len += o, this;
  }
  finish() {
    let n = this.head.next, o = 0;
    const u = BinaryWriter.alloc(this.len);
    for (; n; )
      n.proceed(u, o), o += n.len, n = n.next;
    return u;
  }
  fork() {
    return this.states = new State$3(this), this.head = this.tail = new Op$1(null, 0, 0), this.len = 0, this;
  }
  reset() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op$1(null, 0, 0), this.len = 0), this;
  }
  ldelim() {
    const n = this.head, o = this.tail, u = this.len;
    return this.reset().uint32(u), u && (this.tail.next = n.next, this.tail = o, this.len += u), this;
  }
  tag(n, o) {
    return this.uint32((n << 3 | o) >>> 0);
  }
  uint32(n) {
    return this.len += (this.tail = this.tail.next = new Op$1(varint_1.writeVarint32, (n = n >>> 0) < 128 ? 1 : n < 16384 ? 2 : n < 2097152 ? 3 : n < 268435456 ? 4 : 5, n)).len, this;
  }
  int32(n) {
    return n < 0 ? this._push(varint_1.writeVarint64, 10, (0, varint_1.int64FromString)(n.toString())) : this.uint32(n);
  }
  sint32(n) {
    return this.uint32((n << 1 ^ n >> 31) >>> 0);
  }
  int64(n) {
    const { lo: o, hi: u } = (0, varint_1.int64FromString)(n.toString());
    return this._push(varint_1.writeVarint64, (0, varint_1.int64Length)(o, u), { lo: o, hi: u });
  }
  sint64(n) {
    let { lo: o, hi: u } = (0, varint_1.int64FromString)(n.toString());
    return [o, u] = (0, varint_1.zzEncode)(o, u), this._push(varint_1.writeVarint64, (0, varint_1.int64Length)(o, u), { lo: o, hi: u });
  }
  fixed64(n) {
    const { lo: o, hi: u } = (0, varint_1.int64FromString)(n.toString());
    return this._push(varint_1.writeFixed32, 4, o)._push(varint_1.writeFixed32, 4, u);
  }
  bool(n) {
    return this._push(varint_1.writeByte, 1, n ? 1 : 0);
  }
  fixed32(n) {
    return this._push(varint_1.writeFixed32, 4, n >>> 0);
  }
  float(n) {
    throw new Error("float not supported" + n);
  }
  double(n) {
    throw new Error("double not supported" + n);
  }
  bytes(n) {
    const o = n.length >>> 0;
    return o ? this.uint32(o)._push(writeBytes$1, o, n) : this._push(varint_1.writeByte, 1, 0);
  }
  string(n) {
    const o = (0, utf8_1.utf8Length)(n);
    return o ? this.uint32(o)._push(utf8_1.utf8Write, o, n) : this._push(varint_1.writeByte, 1, 0);
  }
}
binary.BinaryWriter = BinaryWriter;
function writeBytes$1(e, n, o) {
  if (typeof Uint8Array < "u")
    n.set(e, o);
  else
    for (let u = 0; u < e.length; ++u)
      n[o + u] = e[u];
}
function pool$1(e, n, o) {
  const u = o || 8192, c = u >>> 1;
  let d = null, m = u;
  return function(S) {
    if (S < 1 || S > c)
      return e(S);
    m + S > u && (d = e(u), m = 0);
    const $ = n.call(d, m, m += S);
    return m & 7 && (m = (m | 7) + 1), $;
  };
}
function indexOutOfRange$1(e, n) {
  return RangeError("index out of range: " + e.pos + " + " + (n || 1) + " > " + e.len);
}
var helpers = {};
Object.defineProperty(helpers, "__esModule", { value: !0 });
helpers.fromJsonTimestamp = fromTimestamp_1 = helpers.fromTimestamp = helpers.toTimestamp = helpers.setPaginationParams = helpers.isObject = helpers.isSet = helpers.fromDuration = helpers.toDuration = helpers.omitDefault = helpers.base64FromBytes = helpers.bytesFromBase64 = void 0;
var globalThis$2 = (() => {
  if (typeof globalThis$2 < "u")
    return globalThis$2;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal < "u")
    return commonjsGlobal;
  throw "Unable to locate global object";
})();
const atob$1 = globalThis$2.atob || ((e) => globalThis$2.Buffer.from(e, "base64").toString("binary"));
function bytesFromBase64(e) {
  const n = atob$1(e), o = new Uint8Array(n.length);
  for (let u = 0; u < n.length; ++u)
    o[u] = n.charCodeAt(u);
  return o;
}
helpers.bytesFromBase64 = bytesFromBase64;
const btoa$1 = globalThis$2.btoa || ((e) => globalThis$2.Buffer.from(e, "binary").toString("base64"));
function base64FromBytes(e) {
  const n = [];
  return e.forEach((o) => {
    n.push(String.fromCharCode(o));
  }), btoa$1(n.join(""));
}
helpers.base64FromBytes = base64FromBytes;
function omitDefault$2(e) {
  if (typeof e == "string")
    return e === "" ? void 0 : e;
  if (typeof e == "number")
    return e === 0 ? void 0 : e;
  if (typeof e == "bigint")
    return e === BigInt(0) ? void 0 : e;
  throw new Error(`Got unsupported type ${typeof e}`);
}
helpers.omitDefault = omitDefault$2;
function toDuration(e) {
  return {
    seconds: BigInt(Math.floor(parseInt(e) / 1e9)),
    nanos: parseInt(e) % 1e9
  };
}
helpers.toDuration = toDuration;
function fromDuration(e) {
  return (parseInt(e.seconds.toString()) * 1e9 + e.nanos).toString();
}
helpers.fromDuration = fromDuration;
function isSet$1(e) {
  return e != null;
}
helpers.isSet = isSet$1;
function isObject$7(e) {
  return typeof e == "object" && e !== null;
}
helpers.isObject = isObject$7;
const setPaginationParams$1 = (e, n) => (n && (typeof (n == null ? void 0 : n.countTotal) < "u" && (e.params["pagination.count_total"] = n.countTotal), typeof (n == null ? void 0 : n.key) < "u" && (e.params["pagination.key"] = Buffer.from(n.key).toString("base64")), typeof (n == null ? void 0 : n.limit) < "u" && (e.params["pagination.limit"] = n.limit.toString()), typeof (n == null ? void 0 : n.offset) < "u" && (e.params["pagination.offset"] = n.offset.toString()), typeof (n == null ? void 0 : n.reverse) < "u" && (e.params["pagination.reverse"] = n.reverse)), e);
helpers.setPaginationParams = setPaginationParams$1;
function toTimestamp$1(e) {
  const n = numberToLong$1(e.getTime() / 1e3), o = e.getTime() % 1e3 * 1e6;
  return {
    seconds: n,
    nanos: o
  };
}
helpers.toTimestamp = toTimestamp$1;
function fromTimestamp$1(e) {
  let n = Number(e.seconds) * 1e3;
  return n += e.nanos / 1e6, new Date(n);
}
var fromTimestamp_1 = helpers.fromTimestamp = fromTimestamp$1;
const timestampFromJSON = (e) => ({
  seconds: isSet$1(e.seconds) ? BigInt(e.seconds.toString()) : BigInt(0),
  nanos: isSet$1(e.nanos) ? Number(e.nanos) : 0
});
function fromJsonTimestamp(e) {
  return e instanceof Date ? toTimestamp$1(e) : typeof e == "string" ? toTimestamp$1(new Date(e)) : timestampFromJSON(e);
}
helpers.fromJsonTimestamp = fromJsonTimestamp;
function numberToLong$1(e) {
  return BigInt(Math.trunc(e));
}
Object.defineProperty(any$1, "__esModule", { value: !0 });
var Any$1 = any$1.Any = any$1.protobufPackage = void 0;
const binary_1$g = binary, helpers_1$g = helpers;
any$1.protobufPackage = "google.protobuf";
function createBaseAny$1() {
  return {
    typeUrl: "",
    value: new Uint8Array()
  };
}
Any$1 = any$1.Any = {
  typeUrl: "/google.protobuf.Any",
  encode(e, n = binary_1$g.BinaryWriter.create()) {
    return e.typeUrl !== "" && n.uint32(10).string(e.typeUrl), e.value.length !== 0 && n.uint32(18).bytes(e.value), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$g.BinaryReader ? e : new binary_1$g.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAny$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.typeUrl = o.string();
          break;
        case 2:
          c.value = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseAny$1();
    return (0, helpers_1$g.isSet)(e.typeUrl) && (n.typeUrl = String(e.typeUrl)), (0, helpers_1$g.isSet)(e.value) && (n.value = (0, helpers_1$g.bytesFromBase64)(e.value)), n;
  },
  toJSON(e) {
    const n = {};
    return e.typeUrl !== void 0 && (n.typeUrl = e.typeUrl), e.value !== void 0 && (n.value = (0, helpers_1$g.base64FromBytes)(e.value !== void 0 ? e.value : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBaseAny$1();
    return n.typeUrl = e.typeUrl ?? "", n.value = e.value ?? new Uint8Array(), n;
  }
};
var signing$3 = {}, multisig$3 = {};
Object.defineProperty(multisig$3, "__esModule", { value: !0 });
multisig$3.CompactBitArray = multisig$3.MultiSignature = multisig$3.protobufPackage = void 0;
const binary_1$f = binary, helpers_1$f = helpers;
multisig$3.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function createBaseMultiSignature() {
  return {
    signatures: []
  };
}
multisig$3.MultiSignature = {
  typeUrl: "/cosmos.crypto.multisig.v1beta1.MultiSignature",
  encode(e, n = binary_1$f.BinaryWriter.create()) {
    for (const o of e.signatures)
      n.uint32(10).bytes(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$f.BinaryReader ? e : new binary_1$f.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMultiSignature();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signatures.push(o.bytes());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseMultiSignature();
    return Array.isArray(e == null ? void 0 : e.signatures) && (n.signatures = e.signatures.map((o) => (0, helpers_1$f.bytesFromBase64)(o))), n;
  },
  toJSON(e) {
    const n = {};
    return e.signatures ? n.signatures = e.signatures.map((o) => (0, helpers_1$f.base64FromBytes)(o !== void 0 ? o : new Uint8Array())) : n.signatures = [], n;
  },
  fromPartial(e) {
    var o;
    const n = createBaseMultiSignature();
    return n.signatures = ((o = e.signatures) == null ? void 0 : o.map((u) => u)) || [], n;
  }
};
function createBaseCompactBitArray$1() {
  return {
    extraBitsStored: 0,
    elems: new Uint8Array()
  };
}
multisig$3.CompactBitArray = {
  typeUrl: "/cosmos.crypto.multisig.v1beta1.CompactBitArray",
  encode(e, n = binary_1$f.BinaryWriter.create()) {
    return e.extraBitsStored !== 0 && n.uint32(8).uint32(e.extraBitsStored), e.elems.length !== 0 && n.uint32(18).bytes(e.elems), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$f.BinaryReader ? e : new binary_1$f.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompactBitArray$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.extraBitsStored = o.uint32();
          break;
        case 2:
          c.elems = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseCompactBitArray$1();
    return (0, helpers_1$f.isSet)(e.extraBitsStored) && (n.extraBitsStored = Number(e.extraBitsStored)), (0, helpers_1$f.isSet)(e.elems) && (n.elems = (0, helpers_1$f.bytesFromBase64)(e.elems)), n;
  },
  toJSON(e) {
    const n = {};
    return e.extraBitsStored !== void 0 && (n.extraBitsStored = Math.round(e.extraBitsStored)), e.elems !== void 0 && (n.elems = (0, helpers_1$f.base64FromBytes)(e.elems !== void 0 ? e.elems : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBaseCompactBitArray$1();
    return n.extraBitsStored = e.extraBitsStored ?? 0, n.elems = e.elems ?? new Uint8Array(), n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SignatureDescriptor_Data_Multi = e.SignatureDescriptor_Data_Single = e.SignatureDescriptor_Data = e.SignatureDescriptor = e.SignatureDescriptors = e.signModeToJSON = e.signModeFromJSON = e.SignMode = e.protobufPackage = void 0;
  const n = multisig$3, o = any$1, u = binary, c = helpers;
  e.protobufPackage = "cosmos.tx.signing.v1beta1";
  var d;
  (function(y) {
    y[y.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", y[y.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", y[y.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", y[y.SIGN_MODE_DIRECT_AUX = 3] = "SIGN_MODE_DIRECT_AUX", y[y.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", y[y.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", y[y.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(d || (e.SignMode = d = {}));
  function m(y) {
    switch (y) {
      case 0:
      case "SIGN_MODE_UNSPECIFIED":
        return d.SIGN_MODE_UNSPECIFIED;
      case 1:
      case "SIGN_MODE_DIRECT":
        return d.SIGN_MODE_DIRECT;
      case 2:
      case "SIGN_MODE_TEXTUAL":
        return d.SIGN_MODE_TEXTUAL;
      case 3:
      case "SIGN_MODE_DIRECT_AUX":
        return d.SIGN_MODE_DIRECT_AUX;
      case 127:
      case "SIGN_MODE_LEGACY_AMINO_JSON":
        return d.SIGN_MODE_LEGACY_AMINO_JSON;
      case 191:
      case "SIGN_MODE_EIP_191":
        return d.SIGN_MODE_EIP_191;
      case -1:
      case "UNRECOGNIZED":
      default:
        return d.UNRECOGNIZED;
    }
  }
  e.signModeFromJSON = m;
  function v(y) {
    switch (y) {
      case d.SIGN_MODE_UNSPECIFIED:
        return "SIGN_MODE_UNSPECIFIED";
      case d.SIGN_MODE_DIRECT:
        return "SIGN_MODE_DIRECT";
      case d.SIGN_MODE_TEXTUAL:
        return "SIGN_MODE_TEXTUAL";
      case d.SIGN_MODE_DIRECT_AUX:
        return "SIGN_MODE_DIRECT_AUX";
      case d.SIGN_MODE_LEGACY_AMINO_JSON:
        return "SIGN_MODE_LEGACY_AMINO_JSON";
      case d.SIGN_MODE_EIP_191:
        return "SIGN_MODE_EIP_191";
      case d.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.signModeToJSON = v;
  function S() {
    return {
      signatures: []
    };
  }
  e.SignatureDescriptors = {
    typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptors",
    encode(y, V = u.BinaryWriter.create()) {
      for (const M of y.signatures)
        e.SignatureDescriptor.encode(M, V.uint32(10).fork()).ldelim();
      return V;
    },
    decode(y, V) {
      const M = y instanceof u.BinaryReader ? y : new u.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = S();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.signatures.push(e.SignatureDescriptor.decode(M, M.uint32()));
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = S();
      return Array.isArray(y == null ? void 0 : y.signatures) && (V.signatures = y.signatures.map((M) => e.SignatureDescriptor.fromJSON(M))), V;
    },
    toJSON(y) {
      const V = {};
      return y.signatures ? V.signatures = y.signatures.map((M) => M ? e.SignatureDescriptor.toJSON(M) : void 0) : V.signatures = [], V;
    },
    fromPartial(y) {
      var M;
      const V = S();
      return V.signatures = ((M = y.signatures) == null ? void 0 : M.map((G) => e.SignatureDescriptor.fromPartial(G))) || [], V;
    }
  };
  function $() {
    return {
      publicKey: void 0,
      data: void 0,
      sequence: BigInt(0)
    };
  }
  e.SignatureDescriptor = {
    typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptor",
    encode(y, V = u.BinaryWriter.create()) {
      return y.publicKey !== void 0 && o.Any.encode(y.publicKey, V.uint32(10).fork()).ldelim(), y.data !== void 0 && e.SignatureDescriptor_Data.encode(y.data, V.uint32(18).fork()).ldelim(), y.sequence !== BigInt(0) && V.uint32(24).uint64(y.sequence), V;
    },
    decode(y, V) {
      const M = y instanceof u.BinaryReader ? y : new u.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = $();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.publicKey = o.Any.decode(M, M.uint32());
            break;
          case 2:
            k.data = e.SignatureDescriptor_Data.decode(M, M.uint32());
            break;
          case 3:
            k.sequence = M.uint64();
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = $();
      return (0, c.isSet)(y.publicKey) && (V.publicKey = o.Any.fromJSON(y.publicKey)), (0, c.isSet)(y.data) && (V.data = e.SignatureDescriptor_Data.fromJSON(y.data)), (0, c.isSet)(y.sequence) && (V.sequence = BigInt(y.sequence.toString())), V;
    },
    toJSON(y) {
      const V = {};
      return y.publicKey !== void 0 && (V.publicKey = y.publicKey ? o.Any.toJSON(y.publicKey) : void 0), y.data !== void 0 && (V.data = y.data ? e.SignatureDescriptor_Data.toJSON(y.data) : void 0), y.sequence !== void 0 && (V.sequence = (y.sequence || BigInt(0)).toString()), V;
    },
    fromPartial(y) {
      const V = $();
      return y.publicKey !== void 0 && y.publicKey !== null && (V.publicKey = o.Any.fromPartial(y.publicKey)), y.data !== void 0 && y.data !== null && (V.data = e.SignatureDescriptor_Data.fromPartial(y.data)), y.sequence !== void 0 && y.sequence !== null && (V.sequence = BigInt(y.sequence.toString())), V;
    }
  };
  function E() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  e.SignatureDescriptor_Data = {
    typeUrl: "/cosmos.tx.signing.v1beta1.Data",
    encode(y, V = u.BinaryWriter.create()) {
      return y.single !== void 0 && e.SignatureDescriptor_Data_Single.encode(y.single, V.uint32(10).fork()).ldelim(), y.multi !== void 0 && e.SignatureDescriptor_Data_Multi.encode(y.multi, V.uint32(18).fork()).ldelim(), V;
    },
    decode(y, V) {
      const M = y instanceof u.BinaryReader ? y : new u.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = E();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.single = e.SignatureDescriptor_Data_Single.decode(M, M.uint32());
            break;
          case 2:
            k.multi = e.SignatureDescriptor_Data_Multi.decode(M, M.uint32());
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = E();
      return (0, c.isSet)(y.single) && (V.single = e.SignatureDescriptor_Data_Single.fromJSON(y.single)), (0, c.isSet)(y.multi) && (V.multi = e.SignatureDescriptor_Data_Multi.fromJSON(y.multi)), V;
    },
    toJSON(y) {
      const V = {};
      return y.single !== void 0 && (V.single = y.single ? e.SignatureDescriptor_Data_Single.toJSON(y.single) : void 0), y.multi !== void 0 && (V.multi = y.multi ? e.SignatureDescriptor_Data_Multi.toJSON(y.multi) : void 0), V;
    },
    fromPartial(y) {
      const V = E();
      return y.single !== void 0 && y.single !== null && (V.single = e.SignatureDescriptor_Data_Single.fromPartial(y.single)), y.multi !== void 0 && y.multi !== null && (V.multi = e.SignatureDescriptor_Data_Multi.fromPartial(y.multi)), V;
    }
  };
  function O() {
    return {
      mode: 0,
      signature: new Uint8Array()
    };
  }
  e.SignatureDescriptor_Data_Single = {
    typeUrl: "/cosmos.tx.signing.v1beta1.Single",
    encode(y, V = u.BinaryWriter.create()) {
      return y.mode !== 0 && V.uint32(8).int32(y.mode), y.signature.length !== 0 && V.uint32(18).bytes(y.signature), V;
    },
    decode(y, V) {
      const M = y instanceof u.BinaryReader ? y : new u.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = O();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.mode = M.int32();
            break;
          case 2:
            k.signature = M.bytes();
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = O();
      return (0, c.isSet)(y.mode) && (V.mode = m(y.mode)), (0, c.isSet)(y.signature) && (V.signature = (0, c.bytesFromBase64)(y.signature)), V;
    },
    toJSON(y) {
      const V = {};
      return y.mode !== void 0 && (V.mode = v(y.mode)), y.signature !== void 0 && (V.signature = (0, c.base64FromBytes)(y.signature !== void 0 ? y.signature : new Uint8Array())), V;
    },
    fromPartial(y) {
      const V = O();
      return V.mode = y.mode ?? 0, V.signature = y.signature ?? new Uint8Array(), V;
    }
  };
  function T() {
    return {
      bitarray: void 0,
      signatures: []
    };
  }
  e.SignatureDescriptor_Data_Multi = {
    typeUrl: "/cosmos.tx.signing.v1beta1.Multi",
    encode(y, V = u.BinaryWriter.create()) {
      y.bitarray !== void 0 && n.CompactBitArray.encode(y.bitarray, V.uint32(10).fork()).ldelim();
      for (const M of y.signatures)
        e.SignatureDescriptor_Data.encode(M, V.uint32(18).fork()).ldelim();
      return V;
    },
    decode(y, V) {
      const M = y instanceof u.BinaryReader ? y : new u.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = T();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.bitarray = n.CompactBitArray.decode(M, M.uint32());
            break;
          case 2:
            k.signatures.push(e.SignatureDescriptor_Data.decode(M, M.uint32()));
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = T();
      return (0, c.isSet)(y.bitarray) && (V.bitarray = n.CompactBitArray.fromJSON(y.bitarray)), Array.isArray(y == null ? void 0 : y.signatures) && (V.signatures = y.signatures.map((M) => e.SignatureDescriptor_Data.fromJSON(M))), V;
    },
    toJSON(y) {
      const V = {};
      return y.bitarray !== void 0 && (V.bitarray = y.bitarray ? n.CompactBitArray.toJSON(y.bitarray) : void 0), y.signatures ? V.signatures = y.signatures.map((M) => M ? e.SignatureDescriptor_Data.toJSON(M) : void 0) : V.signatures = [], V;
    },
    fromPartial(y) {
      var M;
      const V = T();
      return y.bitarray !== void 0 && y.bitarray !== null && (V.bitarray = n.CompactBitArray.fromPartial(y.bitarray)), V.signatures = ((M = y.signatures) == null ? void 0 : M.map((G) => e.SignatureDescriptor_Data.fromPartial(G))) || [], V;
    }
  };
})(signing$3);
var coin$8 = {};
Object.defineProperty(coin$8, "__esModule", { value: !0 });
coin$8.DecProto = coin$8.IntProto = coin$8.DecCoin = coin$8.Coin = coin$8.protobufPackage = void 0;
const binary_1$e = binary, helpers_1$e = helpers;
coin$8.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin$1() {
  return {
    denom: "",
    amount: ""
  };
}
coin$8.Coin = {
  typeUrl: "/cosmos.base.v1beta1.Coin",
  encode(e, n = binary_1$e.BinaryWriter.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.amount !== "" && n.uint32(18).string(e.amount), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$e.BinaryReader ? e : new binary_1$e.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCoin$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.amount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseCoin$1();
    return (0, helpers_1$e.isSet)(e.denom) && (n.denom = String(e.denom)), (0, helpers_1$e.isSet)(e.amount) && (n.amount = String(e.amount)), n;
  },
  toJSON(e) {
    const n = {};
    return e.denom !== void 0 && (n.denom = e.denom), e.amount !== void 0 && (n.amount = e.amount), n;
  },
  fromPartial(e) {
    const n = createBaseCoin$1();
    return n.denom = e.denom ?? "", n.amount = e.amount ?? "", n;
  }
};
function createBaseDecCoin$1() {
  return {
    denom: "",
    amount: ""
  };
}
coin$8.DecCoin = {
  typeUrl: "/cosmos.base.v1beta1.DecCoin",
  encode(e, n = binary_1$e.BinaryWriter.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.amount !== "" && n.uint32(18).string(e.amount), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$e.BinaryReader ? e : new binary_1$e.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDecCoin$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.amount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseDecCoin$1();
    return (0, helpers_1$e.isSet)(e.denom) && (n.denom = String(e.denom)), (0, helpers_1$e.isSet)(e.amount) && (n.amount = String(e.amount)), n;
  },
  toJSON(e) {
    const n = {};
    return e.denom !== void 0 && (n.denom = e.denom), e.amount !== void 0 && (n.amount = e.amount), n;
  },
  fromPartial(e) {
    const n = createBaseDecCoin$1();
    return n.denom = e.denom ?? "", n.amount = e.amount ?? "", n;
  }
};
function createBaseIntProto$1() {
  return {
    int: ""
  };
}
coin$8.IntProto = {
  typeUrl: "/cosmos.base.v1beta1.IntProto",
  encode(e, n = binary_1$e.BinaryWriter.create()) {
    return e.int !== "" && n.uint32(10).string(e.int), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$e.BinaryReader ? e : new binary_1$e.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIntProto$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.int = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseIntProto$1();
    return (0, helpers_1$e.isSet)(e.int) && (n.int = String(e.int)), n;
  },
  toJSON(e) {
    const n = {};
    return e.int !== void 0 && (n.int = e.int), n;
  },
  fromPartial(e) {
    const n = createBaseIntProto$1();
    return n.int = e.int ?? "", n;
  }
};
function createBaseDecProto$1() {
  return {
    dec: ""
  };
}
coin$8.DecProto = {
  typeUrl: "/cosmos.base.v1beta1.DecProto",
  encode(e, n = binary_1$e.BinaryWriter.create()) {
    return e.dec !== "" && n.uint32(10).string(e.dec), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$e.BinaryReader ? e : new binary_1$e.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDecProto$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.dec = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseDecProto$1();
    return (0, helpers_1$e.isSet)(e.dec) && (n.dec = String(e.dec)), n;
  },
  toJSON(e) {
    const n = {};
    return e.dec !== void 0 && (n.dec = e.dec), n;
  },
  fromPartial(e) {
    const n = createBaseDecProto$1();
    return n.dec = e.dec ?? "", n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AuxSignerData = e.Tip = e.Fee = e.ModeInfo_Multi = e.ModeInfo_Single = e.ModeInfo = e.SignerInfo = e.AuthInfo = e.TxBody = e.SignDocDirectAux = e.SignDoc = e.TxRaw = e.Tx = e.protobufPackage = void 0;
  const n = any$1, o = signing$3, u = multisig$3, c = coin$8, d = binary, m = helpers;
  e.protobufPackage = "cosmos.tx.v1beta1";
  function v() {
    return {
      body: void 0,
      authInfo: void 0,
      signatures: []
    };
  }
  e.Tx = {
    typeUrl: "/cosmos.tx.v1beta1.Tx",
    encode(ee, ue = d.BinaryWriter.create()) {
      ee.body !== void 0 && e.TxBody.encode(ee.body, ue.uint32(10).fork()).ldelim(), ee.authInfo !== void 0 && e.AuthInfo.encode(ee.authInfo, ue.uint32(18).fork()).ldelim();
      for (const Q of ee.signatures)
        ue.uint32(26).bytes(Q);
      return ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = v();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.body = e.TxBody.decode(Q, Q.uint32());
            break;
          case 2:
            pe.authInfo = e.AuthInfo.decode(Q, Q.uint32());
            break;
          case 3:
            pe.signatures.push(Q.bytes());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = v();
      return (0, m.isSet)(ee.body) && (ue.body = e.TxBody.fromJSON(ee.body)), (0, m.isSet)(ee.authInfo) && (ue.authInfo = e.AuthInfo.fromJSON(ee.authInfo)), Array.isArray(ee == null ? void 0 : ee.signatures) && (ue.signatures = ee.signatures.map((Q) => (0, m.bytesFromBase64)(Q))), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.body !== void 0 && (ue.body = ee.body ? e.TxBody.toJSON(ee.body) : void 0), ee.authInfo !== void 0 && (ue.authInfo = ee.authInfo ? e.AuthInfo.toJSON(ee.authInfo) : void 0), ee.signatures ? ue.signatures = ee.signatures.map((Q) => (0, m.base64FromBytes)(Q !== void 0 ? Q : new Uint8Array())) : ue.signatures = [], ue;
    },
    fromPartial(ee) {
      var Q;
      const ue = v();
      return ee.body !== void 0 && ee.body !== null && (ue.body = e.TxBody.fromPartial(ee.body)), ee.authInfo !== void 0 && ee.authInfo !== null && (ue.authInfo = e.AuthInfo.fromPartial(ee.authInfo)), ue.signatures = ((Q = ee.signatures) == null ? void 0 : Q.map((Y) => Y)) || [], ue;
    }
  };
  function S() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      signatures: []
    };
  }
  e.TxRaw = {
    typeUrl: "/cosmos.tx.v1beta1.TxRaw",
    encode(ee, ue = d.BinaryWriter.create()) {
      ee.bodyBytes.length !== 0 && ue.uint32(10).bytes(ee.bodyBytes), ee.authInfoBytes.length !== 0 && ue.uint32(18).bytes(ee.authInfoBytes);
      for (const Q of ee.signatures)
        ue.uint32(26).bytes(Q);
      return ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = S();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.bodyBytes = Q.bytes();
            break;
          case 2:
            pe.authInfoBytes = Q.bytes();
            break;
          case 3:
            pe.signatures.push(Q.bytes());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = S();
      return (0, m.isSet)(ee.bodyBytes) && (ue.bodyBytes = (0, m.bytesFromBase64)(ee.bodyBytes)), (0, m.isSet)(ee.authInfoBytes) && (ue.authInfoBytes = (0, m.bytesFromBase64)(ee.authInfoBytes)), Array.isArray(ee == null ? void 0 : ee.signatures) && (ue.signatures = ee.signatures.map((Q) => (0, m.bytesFromBase64)(Q))), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.bodyBytes !== void 0 && (ue.bodyBytes = (0, m.base64FromBytes)(ee.bodyBytes !== void 0 ? ee.bodyBytes : new Uint8Array())), ee.authInfoBytes !== void 0 && (ue.authInfoBytes = (0, m.base64FromBytes)(ee.authInfoBytes !== void 0 ? ee.authInfoBytes : new Uint8Array())), ee.signatures ? ue.signatures = ee.signatures.map((Q) => (0, m.base64FromBytes)(Q !== void 0 ? Q : new Uint8Array())) : ue.signatures = [], ue;
    },
    fromPartial(ee) {
      var Q;
      const ue = S();
      return ue.bodyBytes = ee.bodyBytes ?? new Uint8Array(), ue.authInfoBytes = ee.authInfoBytes ?? new Uint8Array(), ue.signatures = ((Q = ee.signatures) == null ? void 0 : Q.map((Y) => Y)) || [], ue;
    }
  };
  function $() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      chainId: "",
      accountNumber: BigInt(0)
    };
  }
  e.SignDoc = {
    typeUrl: "/cosmos.tx.v1beta1.SignDoc",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.bodyBytes.length !== 0 && ue.uint32(10).bytes(ee.bodyBytes), ee.authInfoBytes.length !== 0 && ue.uint32(18).bytes(ee.authInfoBytes), ee.chainId !== "" && ue.uint32(26).string(ee.chainId), ee.accountNumber !== BigInt(0) && ue.uint32(32).uint64(ee.accountNumber), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = $();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.bodyBytes = Q.bytes();
            break;
          case 2:
            pe.authInfoBytes = Q.bytes();
            break;
          case 3:
            pe.chainId = Q.string();
            break;
          case 4:
            pe.accountNumber = Q.uint64();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = $();
      return (0, m.isSet)(ee.bodyBytes) && (ue.bodyBytes = (0, m.bytesFromBase64)(ee.bodyBytes)), (0, m.isSet)(ee.authInfoBytes) && (ue.authInfoBytes = (0, m.bytesFromBase64)(ee.authInfoBytes)), (0, m.isSet)(ee.chainId) && (ue.chainId = String(ee.chainId)), (0, m.isSet)(ee.accountNumber) && (ue.accountNumber = BigInt(ee.accountNumber.toString())), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.bodyBytes !== void 0 && (ue.bodyBytes = (0, m.base64FromBytes)(ee.bodyBytes !== void 0 ? ee.bodyBytes : new Uint8Array())), ee.authInfoBytes !== void 0 && (ue.authInfoBytes = (0, m.base64FromBytes)(ee.authInfoBytes !== void 0 ? ee.authInfoBytes : new Uint8Array())), ee.chainId !== void 0 && (ue.chainId = ee.chainId), ee.accountNumber !== void 0 && (ue.accountNumber = (ee.accountNumber || BigInt(0)).toString()), ue;
    },
    fromPartial(ee) {
      const ue = $();
      return ue.bodyBytes = ee.bodyBytes ?? new Uint8Array(), ue.authInfoBytes = ee.authInfoBytes ?? new Uint8Array(), ue.chainId = ee.chainId ?? "", ee.accountNumber !== void 0 && ee.accountNumber !== null && (ue.accountNumber = BigInt(ee.accountNumber.toString())), ue;
    }
  };
  function E() {
    return {
      bodyBytes: new Uint8Array(),
      publicKey: void 0,
      chainId: "",
      accountNumber: BigInt(0),
      sequence: BigInt(0),
      tip: void 0
    };
  }
  e.SignDocDirectAux = {
    typeUrl: "/cosmos.tx.v1beta1.SignDocDirectAux",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.bodyBytes.length !== 0 && ue.uint32(10).bytes(ee.bodyBytes), ee.publicKey !== void 0 && n.Any.encode(ee.publicKey, ue.uint32(18).fork()).ldelim(), ee.chainId !== "" && ue.uint32(26).string(ee.chainId), ee.accountNumber !== BigInt(0) && ue.uint32(32).uint64(ee.accountNumber), ee.sequence !== BigInt(0) && ue.uint32(40).uint64(ee.sequence), ee.tip !== void 0 && e.Tip.encode(ee.tip, ue.uint32(50).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = E();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.bodyBytes = Q.bytes();
            break;
          case 2:
            pe.publicKey = n.Any.decode(Q, Q.uint32());
            break;
          case 3:
            pe.chainId = Q.string();
            break;
          case 4:
            pe.accountNumber = Q.uint64();
            break;
          case 5:
            pe.sequence = Q.uint64();
            break;
          case 6:
            pe.tip = e.Tip.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = E();
      return (0, m.isSet)(ee.bodyBytes) && (ue.bodyBytes = (0, m.bytesFromBase64)(ee.bodyBytes)), (0, m.isSet)(ee.publicKey) && (ue.publicKey = n.Any.fromJSON(ee.publicKey)), (0, m.isSet)(ee.chainId) && (ue.chainId = String(ee.chainId)), (0, m.isSet)(ee.accountNumber) && (ue.accountNumber = BigInt(ee.accountNumber.toString())), (0, m.isSet)(ee.sequence) && (ue.sequence = BigInt(ee.sequence.toString())), (0, m.isSet)(ee.tip) && (ue.tip = e.Tip.fromJSON(ee.tip)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.bodyBytes !== void 0 && (ue.bodyBytes = (0, m.base64FromBytes)(ee.bodyBytes !== void 0 ? ee.bodyBytes : new Uint8Array())), ee.publicKey !== void 0 && (ue.publicKey = ee.publicKey ? n.Any.toJSON(ee.publicKey) : void 0), ee.chainId !== void 0 && (ue.chainId = ee.chainId), ee.accountNumber !== void 0 && (ue.accountNumber = (ee.accountNumber || BigInt(0)).toString()), ee.sequence !== void 0 && (ue.sequence = (ee.sequence || BigInt(0)).toString()), ee.tip !== void 0 && (ue.tip = ee.tip ? e.Tip.toJSON(ee.tip) : void 0), ue;
    },
    fromPartial(ee) {
      const ue = E();
      return ue.bodyBytes = ee.bodyBytes ?? new Uint8Array(), ee.publicKey !== void 0 && ee.publicKey !== null && (ue.publicKey = n.Any.fromPartial(ee.publicKey)), ue.chainId = ee.chainId ?? "", ee.accountNumber !== void 0 && ee.accountNumber !== null && (ue.accountNumber = BigInt(ee.accountNumber.toString())), ee.sequence !== void 0 && ee.sequence !== null && (ue.sequence = BigInt(ee.sequence.toString())), ee.tip !== void 0 && ee.tip !== null && (ue.tip = e.Tip.fromPartial(ee.tip)), ue;
    }
  };
  function O() {
    return {
      messages: [],
      memo: "",
      timeoutHeight: BigInt(0),
      extensionOptions: [],
      nonCriticalExtensionOptions: []
    };
  }
  e.TxBody = {
    typeUrl: "/cosmos.tx.v1beta1.TxBody",
    encode(ee, ue = d.BinaryWriter.create()) {
      for (const Q of ee.messages)
        n.Any.encode(Q, ue.uint32(10).fork()).ldelim();
      ee.memo !== "" && ue.uint32(18).string(ee.memo), ee.timeoutHeight !== BigInt(0) && ue.uint32(24).uint64(ee.timeoutHeight);
      for (const Q of ee.extensionOptions)
        n.Any.encode(Q, ue.uint32(8186).fork()).ldelim();
      for (const Q of ee.nonCriticalExtensionOptions)
        n.Any.encode(Q, ue.uint32(16378).fork()).ldelim();
      return ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = O();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.messages.push(n.Any.decode(Q, Q.uint32()));
            break;
          case 2:
            pe.memo = Q.string();
            break;
          case 3:
            pe.timeoutHeight = Q.uint64();
            break;
          case 1023:
            pe.extensionOptions.push(n.Any.decode(Q, Q.uint32()));
            break;
          case 2047:
            pe.nonCriticalExtensionOptions.push(n.Any.decode(Q, Q.uint32()));
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = O();
      return Array.isArray(ee == null ? void 0 : ee.messages) && (ue.messages = ee.messages.map((Q) => n.Any.fromJSON(Q))), (0, m.isSet)(ee.memo) && (ue.memo = String(ee.memo)), (0, m.isSet)(ee.timeoutHeight) && (ue.timeoutHeight = BigInt(ee.timeoutHeight.toString())), Array.isArray(ee == null ? void 0 : ee.extensionOptions) && (ue.extensionOptions = ee.extensionOptions.map((Q) => n.Any.fromJSON(Q))), Array.isArray(ee == null ? void 0 : ee.nonCriticalExtensionOptions) && (ue.nonCriticalExtensionOptions = ee.nonCriticalExtensionOptions.map((Q) => n.Any.fromJSON(Q))), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.messages ? ue.messages = ee.messages.map((Q) => Q ? n.Any.toJSON(Q) : void 0) : ue.messages = [], ee.memo !== void 0 && (ue.memo = ee.memo), ee.timeoutHeight !== void 0 && (ue.timeoutHeight = (ee.timeoutHeight || BigInt(0)).toString()), ee.extensionOptions ? ue.extensionOptions = ee.extensionOptions.map((Q) => Q ? n.Any.toJSON(Q) : void 0) : ue.extensionOptions = [], ee.nonCriticalExtensionOptions ? ue.nonCriticalExtensionOptions = ee.nonCriticalExtensionOptions.map((Q) => Q ? n.Any.toJSON(Q) : void 0) : ue.nonCriticalExtensionOptions = [], ue;
    },
    fromPartial(ee) {
      var Q, Y, pe;
      const ue = O();
      return ue.messages = ((Q = ee.messages) == null ? void 0 : Q.map((oe) => n.Any.fromPartial(oe))) || [], ue.memo = ee.memo ?? "", ee.timeoutHeight !== void 0 && ee.timeoutHeight !== null && (ue.timeoutHeight = BigInt(ee.timeoutHeight.toString())), ue.extensionOptions = ((Y = ee.extensionOptions) == null ? void 0 : Y.map((oe) => n.Any.fromPartial(oe))) || [], ue.nonCriticalExtensionOptions = ((pe = ee.nonCriticalExtensionOptions) == null ? void 0 : pe.map((oe) => n.Any.fromPartial(oe))) || [], ue;
    }
  };
  function T() {
    return {
      signerInfos: [],
      fee: void 0,
      tip: void 0
    };
  }
  e.AuthInfo = {
    typeUrl: "/cosmos.tx.v1beta1.AuthInfo",
    encode(ee, ue = d.BinaryWriter.create()) {
      for (const Q of ee.signerInfos)
        e.SignerInfo.encode(Q, ue.uint32(10).fork()).ldelim();
      return ee.fee !== void 0 && e.Fee.encode(ee.fee, ue.uint32(18).fork()).ldelim(), ee.tip !== void 0 && e.Tip.encode(ee.tip, ue.uint32(26).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = T();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.signerInfos.push(e.SignerInfo.decode(Q, Q.uint32()));
            break;
          case 2:
            pe.fee = e.Fee.decode(Q, Q.uint32());
            break;
          case 3:
            pe.tip = e.Tip.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = T();
      return Array.isArray(ee == null ? void 0 : ee.signerInfos) && (ue.signerInfos = ee.signerInfos.map((Q) => e.SignerInfo.fromJSON(Q))), (0, m.isSet)(ee.fee) && (ue.fee = e.Fee.fromJSON(ee.fee)), (0, m.isSet)(ee.tip) && (ue.tip = e.Tip.fromJSON(ee.tip)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.signerInfos ? ue.signerInfos = ee.signerInfos.map((Q) => Q ? e.SignerInfo.toJSON(Q) : void 0) : ue.signerInfos = [], ee.fee !== void 0 && (ue.fee = ee.fee ? e.Fee.toJSON(ee.fee) : void 0), ee.tip !== void 0 && (ue.tip = ee.tip ? e.Tip.toJSON(ee.tip) : void 0), ue;
    },
    fromPartial(ee) {
      var Q;
      const ue = T();
      return ue.signerInfos = ((Q = ee.signerInfos) == null ? void 0 : Q.map((Y) => e.SignerInfo.fromPartial(Y))) || [], ee.fee !== void 0 && ee.fee !== null && (ue.fee = e.Fee.fromPartial(ee.fee)), ee.tip !== void 0 && ee.tip !== null && (ue.tip = e.Tip.fromPartial(ee.tip)), ue;
    }
  };
  function y() {
    return {
      publicKey: void 0,
      modeInfo: void 0,
      sequence: BigInt(0)
    };
  }
  e.SignerInfo = {
    typeUrl: "/cosmos.tx.v1beta1.SignerInfo",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.publicKey !== void 0 && n.Any.encode(ee.publicKey, ue.uint32(10).fork()).ldelim(), ee.modeInfo !== void 0 && e.ModeInfo.encode(ee.modeInfo, ue.uint32(18).fork()).ldelim(), ee.sequence !== BigInt(0) && ue.uint32(24).uint64(ee.sequence), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = y();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.publicKey = n.Any.decode(Q, Q.uint32());
            break;
          case 2:
            pe.modeInfo = e.ModeInfo.decode(Q, Q.uint32());
            break;
          case 3:
            pe.sequence = Q.uint64();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = y();
      return (0, m.isSet)(ee.publicKey) && (ue.publicKey = n.Any.fromJSON(ee.publicKey)), (0, m.isSet)(ee.modeInfo) && (ue.modeInfo = e.ModeInfo.fromJSON(ee.modeInfo)), (0, m.isSet)(ee.sequence) && (ue.sequence = BigInt(ee.sequence.toString())), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.publicKey !== void 0 && (ue.publicKey = ee.publicKey ? n.Any.toJSON(ee.publicKey) : void 0), ee.modeInfo !== void 0 && (ue.modeInfo = ee.modeInfo ? e.ModeInfo.toJSON(ee.modeInfo) : void 0), ee.sequence !== void 0 && (ue.sequence = (ee.sequence || BigInt(0)).toString()), ue;
    },
    fromPartial(ee) {
      const ue = y();
      return ee.publicKey !== void 0 && ee.publicKey !== null && (ue.publicKey = n.Any.fromPartial(ee.publicKey)), ee.modeInfo !== void 0 && ee.modeInfo !== null && (ue.modeInfo = e.ModeInfo.fromPartial(ee.modeInfo)), ee.sequence !== void 0 && ee.sequence !== null && (ue.sequence = BigInt(ee.sequence.toString())), ue;
    }
  };
  function V() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  e.ModeInfo = {
    typeUrl: "/cosmos.tx.v1beta1.ModeInfo",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.single !== void 0 && e.ModeInfo_Single.encode(ee.single, ue.uint32(10).fork()).ldelim(), ee.multi !== void 0 && e.ModeInfo_Multi.encode(ee.multi, ue.uint32(18).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = V();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.single = e.ModeInfo_Single.decode(Q, Q.uint32());
            break;
          case 2:
            pe.multi = e.ModeInfo_Multi.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = V();
      return (0, m.isSet)(ee.single) && (ue.single = e.ModeInfo_Single.fromJSON(ee.single)), (0, m.isSet)(ee.multi) && (ue.multi = e.ModeInfo_Multi.fromJSON(ee.multi)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.single !== void 0 && (ue.single = ee.single ? e.ModeInfo_Single.toJSON(ee.single) : void 0), ee.multi !== void 0 && (ue.multi = ee.multi ? e.ModeInfo_Multi.toJSON(ee.multi) : void 0), ue;
    },
    fromPartial(ee) {
      const ue = V();
      return ee.single !== void 0 && ee.single !== null && (ue.single = e.ModeInfo_Single.fromPartial(ee.single)), ee.multi !== void 0 && ee.multi !== null && (ue.multi = e.ModeInfo_Multi.fromPartial(ee.multi)), ue;
    }
  };
  function M() {
    return {
      mode: 0
    };
  }
  e.ModeInfo_Single = {
    typeUrl: "/cosmos.tx.v1beta1.Single",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.mode !== 0 && ue.uint32(8).int32(ee.mode), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = M();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.mode = Q.int32();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = M();
      return (0, m.isSet)(ee.mode) && (ue.mode = (0, o.signModeFromJSON)(ee.mode)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.mode !== void 0 && (ue.mode = (0, o.signModeToJSON)(ee.mode)), ue;
    },
    fromPartial(ee) {
      const ue = M();
      return ue.mode = ee.mode ?? 0, ue;
    }
  };
  function G() {
    return {
      bitarray: void 0,
      modeInfos: []
    };
  }
  e.ModeInfo_Multi = {
    typeUrl: "/cosmos.tx.v1beta1.Multi",
    encode(ee, ue = d.BinaryWriter.create()) {
      ee.bitarray !== void 0 && u.CompactBitArray.encode(ee.bitarray, ue.uint32(10).fork()).ldelim();
      for (const Q of ee.modeInfos)
        e.ModeInfo.encode(Q, ue.uint32(18).fork()).ldelim();
      return ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = G();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.bitarray = u.CompactBitArray.decode(Q, Q.uint32());
            break;
          case 2:
            pe.modeInfos.push(e.ModeInfo.decode(Q, Q.uint32()));
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = G();
      return (0, m.isSet)(ee.bitarray) && (ue.bitarray = u.CompactBitArray.fromJSON(ee.bitarray)), Array.isArray(ee == null ? void 0 : ee.modeInfos) && (ue.modeInfos = ee.modeInfos.map((Q) => e.ModeInfo.fromJSON(Q))), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.bitarray !== void 0 && (ue.bitarray = ee.bitarray ? u.CompactBitArray.toJSON(ee.bitarray) : void 0), ee.modeInfos ? ue.modeInfos = ee.modeInfos.map((Q) => Q ? e.ModeInfo.toJSON(Q) : void 0) : ue.modeInfos = [], ue;
    },
    fromPartial(ee) {
      var Q;
      const ue = G();
      return ee.bitarray !== void 0 && ee.bitarray !== null && (ue.bitarray = u.CompactBitArray.fromPartial(ee.bitarray)), ue.modeInfos = ((Q = ee.modeInfos) == null ? void 0 : Q.map((Y) => e.ModeInfo.fromPartial(Y))) || [], ue;
    }
  };
  function k() {
    return {
      amount: [],
      gasLimit: BigInt(0),
      payer: "",
      granter: ""
    };
  }
  e.Fee = {
    typeUrl: "/cosmos.tx.v1beta1.Fee",
    encode(ee, ue = d.BinaryWriter.create()) {
      for (const Q of ee.amount)
        c.Coin.encode(Q, ue.uint32(10).fork()).ldelim();
      return ee.gasLimit !== BigInt(0) && ue.uint32(16).uint64(ee.gasLimit), ee.payer !== "" && ue.uint32(26).string(ee.payer), ee.granter !== "" && ue.uint32(34).string(ee.granter), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = k();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.amount.push(c.Coin.decode(Q, Q.uint32()));
            break;
          case 2:
            pe.gasLimit = Q.uint64();
            break;
          case 3:
            pe.payer = Q.string();
            break;
          case 4:
            pe.granter = Q.string();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = k();
      return Array.isArray(ee == null ? void 0 : ee.amount) && (ue.amount = ee.amount.map((Q) => c.Coin.fromJSON(Q))), (0, m.isSet)(ee.gasLimit) && (ue.gasLimit = BigInt(ee.gasLimit.toString())), (0, m.isSet)(ee.payer) && (ue.payer = String(ee.payer)), (0, m.isSet)(ee.granter) && (ue.granter = String(ee.granter)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.amount ? ue.amount = ee.amount.map((Q) => Q ? c.Coin.toJSON(Q) : void 0) : ue.amount = [], ee.gasLimit !== void 0 && (ue.gasLimit = (ee.gasLimit || BigInt(0)).toString()), ee.payer !== void 0 && (ue.payer = ee.payer), ee.granter !== void 0 && (ue.granter = ee.granter), ue;
    },
    fromPartial(ee) {
      var Q;
      const ue = k();
      return ue.amount = ((Q = ee.amount) == null ? void 0 : Q.map((Y) => c.Coin.fromPartial(Y))) || [], ee.gasLimit !== void 0 && ee.gasLimit !== null && (ue.gasLimit = BigInt(ee.gasLimit.toString())), ue.payer = ee.payer ?? "", ue.granter = ee.granter ?? "", ue;
    }
  };
  function F() {
    return {
      amount: [],
      tipper: ""
    };
  }
  e.Tip = {
    typeUrl: "/cosmos.tx.v1beta1.Tip",
    encode(ee, ue = d.BinaryWriter.create()) {
      for (const Q of ee.amount)
        c.Coin.encode(Q, ue.uint32(10).fork()).ldelim();
      return ee.tipper !== "" && ue.uint32(18).string(ee.tipper), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = F();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.amount.push(c.Coin.decode(Q, Q.uint32()));
            break;
          case 2:
            pe.tipper = Q.string();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = F();
      return Array.isArray(ee == null ? void 0 : ee.amount) && (ue.amount = ee.amount.map((Q) => c.Coin.fromJSON(Q))), (0, m.isSet)(ee.tipper) && (ue.tipper = String(ee.tipper)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.amount ? ue.amount = ee.amount.map((Q) => Q ? c.Coin.toJSON(Q) : void 0) : ue.amount = [], ee.tipper !== void 0 && (ue.tipper = ee.tipper), ue;
    },
    fromPartial(ee) {
      var Q;
      const ue = F();
      return ue.amount = ((Q = ee.amount) == null ? void 0 : Q.map((Y) => c.Coin.fromPartial(Y))) || [], ue.tipper = ee.tipper ?? "", ue;
    }
  };
  function X() {
    return {
      address: "",
      signDoc: void 0,
      mode: 0,
      sig: new Uint8Array()
    };
  }
  e.AuxSignerData = {
    typeUrl: "/cosmos.tx.v1beta1.AuxSignerData",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.address !== "" && ue.uint32(10).string(ee.address), ee.signDoc !== void 0 && e.SignDocDirectAux.encode(ee.signDoc, ue.uint32(18).fork()).ldelim(), ee.mode !== 0 && ue.uint32(24).int32(ee.mode), ee.sig.length !== 0 && ue.uint32(34).bytes(ee.sig), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = X();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.address = Q.string();
            break;
          case 2:
            pe.signDoc = e.SignDocDirectAux.decode(Q, Q.uint32());
            break;
          case 3:
            pe.mode = Q.int32();
            break;
          case 4:
            pe.sig = Q.bytes();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = X();
      return (0, m.isSet)(ee.address) && (ue.address = String(ee.address)), (0, m.isSet)(ee.signDoc) && (ue.signDoc = e.SignDocDirectAux.fromJSON(ee.signDoc)), (0, m.isSet)(ee.mode) && (ue.mode = (0, o.signModeFromJSON)(ee.mode)), (0, m.isSet)(ee.sig) && (ue.sig = (0, m.bytesFromBase64)(ee.sig)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.address !== void 0 && (ue.address = ee.address), ee.signDoc !== void 0 && (ue.signDoc = ee.signDoc ? e.SignDocDirectAux.toJSON(ee.signDoc) : void 0), ee.mode !== void 0 && (ue.mode = (0, o.signModeToJSON)(ee.mode)), ee.sig !== void 0 && (ue.sig = (0, m.base64FromBytes)(ee.sig !== void 0 ? ee.sig : new Uint8Array())), ue;
    },
    fromPartial(ee) {
      const ue = X();
      return ue.address = ee.address ?? "", ee.signDoc !== void 0 && ee.signDoc !== null && (ue.signDoc = e.SignDocDirectAux.fromPartial(ee.signDoc)), ue.mode = ee.mode ?? 0, ue.sig = ee.sig ?? new Uint8Array(), ue;
    }
  };
})(tx$p);
Object.defineProperty(decode$1, "__esModule", { value: !0 });
decode$1.decodeTxRaw = void 0;
const tx_1$t = tx$p;
function decodeTxRaw$1(e) {
  const n = tx_1$t.TxRaw.decode(e);
  return {
    authInfo: tx_1$t.AuthInfo.decode(n.authInfoBytes),
    body: tx_1$t.TxBody.decode(n.bodyBytes),
    signatures: n.signatures
  };
}
decode$1.decodeTxRaw = decodeTxRaw$1;
var directsecp256k1hdwallet$1 = {}, build$P = {}, addresses$5 = {}, build$O = {}, bip39$6 = {}, build$N = {}, ascii$6 = {};
Object.defineProperty(ascii$6, "__esModule", { value: !0 });
ascii$6.fromAscii = ascii$6.toAscii = void 0;
function toAscii$6(e) {
  const n = (o) => o.split("").map((u) => {
    const c = u.charCodeAt(0);
    if (c < 32 || c > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + c);
    return c;
  });
  return Uint8Array.from(n(e));
}
ascii$6.toAscii = toAscii$6;
function fromAscii$6(e) {
  return ((o) => o.map((u) => {
    if (u < 32 || u > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + u);
    return String.fromCharCode(u);
  }))(Array.from(e)).join("");
}
ascii$6.fromAscii = fromAscii$6;
var base64$8 = {}, __createBinding$T = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$T = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$T = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$T(n, e, o);
  return __setModuleDefault$T(n, e), n;
};
Object.defineProperty(base64$8, "__esModule", { value: !0 });
base64$8.fromBase64 = base64$8.toBase64 = void 0;
const base64js$6 = __importStar$T(base64Js);
function toBase64$6(e) {
  return base64js$6.fromByteArray(e);
}
base64$8.toBase64 = toBase64$6;
function fromBase64$6(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$6.toByteArray(e);
}
base64$8.fromBase64 = fromBase64$6;
var bech32$d = {}, __createBinding$S = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$S = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$S = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$S(n, e, o);
  return __setModuleDefault$S(n, e), n;
};
Object.defineProperty(bech32$d, "__esModule", { value: !0 });
bech32$d.normalizeBech32 = bech32$d.fromBech32 = bech32$d.toBech32 = void 0;
const bech32$c = __importStar$S(bech32$f);
function toBech32$6(e, n, o) {
  return bech32$c.encode(e, bech32$c.toWords(n), o);
}
bech32$d.toBech32 = toBech32$6;
function fromBech32$6(e, n = 1 / 0) {
  const o = bech32$c.decode(e, n);
  return {
    prefix: o.prefix,
    data: new Uint8Array(bech32$c.fromWords(o.words))
  };
}
bech32$d.fromBech32 = fromBech32$6;
function normalizeBech32$6(e) {
  const { prefix: n, data: o } = fromBech32$6(e);
  return toBech32$6(n, o);
}
bech32$d.normalizeBech32 = normalizeBech32$6;
var hex$6 = {};
Object.defineProperty(hex$6, "__esModule", { value: !0 });
hex$6.fromHex = hex$6.toHex = void 0;
function toHex$6(e) {
  let n = "";
  for (const o of e)
    n += ("0" + o.toString(16)).slice(-2);
  return n;
}
hex$6.toHex = toHex$6;
function fromHex$6(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let o = 0; o < n.length; o++) {
    const u = 2 * o, c = e.slice(u, u + 2);
    if (!c.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[o] = parseInt(c, 16);
  }
  return n;
}
hex$6.fromHex = fromHex$6;
var rfc3339$6 = {};
Object.defineProperty(rfc3339$6, "__esModule", { value: !0 });
rfc3339$6.toRfc3339 = rfc3339$6.fromRfc3339 = void 0;
const rfc3339Matcher$6 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$6(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function fromRfc3339$6(e) {
  const n = rfc3339Matcher$6.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const o = +n[1], u = +n[2], c = +n[3], d = +n[4], m = +n[5], v = +n[6], S = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let $, E, O;
  n[8] === "Z" ? ($ = 1, E = 0, O = 0) : ($ = n[8].substring(0, 1) === "-" ? -1 : 1, E = +n[8].substring(1, 3), O = +n[8].substring(4, 6));
  const T = $ * (E * 60 + O) * 60, y = Date.UTC(o, u - 1, c, d, m, v, S) - T * 1e3;
  return new Date(y);
}
rfc3339$6.fromRfc3339 = fromRfc3339$6;
function toRfc3339$6(e) {
  const n = e.getUTCFullYear(), o = padded$6(e.getUTCMonth() + 1), u = padded$6(e.getUTCDate()), c = padded$6(e.getUTCHours()), d = padded$6(e.getUTCMinutes()), m = padded$6(e.getUTCSeconds()), v = padded$6(e.getUTCMilliseconds(), 3);
  return `${n}-${o}-${u}T${c}:${d}:${m}.${v}Z`;
}
rfc3339$6.toRfc3339 = toRfc3339$6;
var utf8$9 = {};
Object.defineProperty(utf8$9, "__esModule", { value: !0 });
utf8$9.fromUtf8 = utf8$9.toUtf8 = void 0;
function toUtf8$6(e) {
  return new TextEncoder().encode(e);
}
utf8$9.toUtf8 = toUtf8$6;
function fromUtf8$6(e, n = !1) {
  const o = !n;
  return new TextDecoder("utf-8", { fatal: o }).decode(e);
}
utf8$9.fromUtf8 = fromUtf8$6;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = ascii$6;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var o = base64$8;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return o.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return o.toBase64;
  } });
  var u = bech32$d;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return u.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return u.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return u.toBech32;
  } });
  var c = hex$6;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return c.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return c.toHex;
  } });
  var d = rfc3339$6;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return d.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return d.toRfc3339;
  } });
  var m = utf8$9;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return m.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return m.toUtf8;
  } });
})(build$N);
var pbkdf2$6 = {}, build$M = {}, arrays$6 = {};
Object.defineProperty(arrays$6, "__esModule", { value: !0 });
arrays$6.arrayContentStartsWith = arrays$6.arrayContentEquals = void 0;
function arrayContentEquals$6(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$6.arrayContentEquals = arrayContentEquals$6;
function arrayContentStartsWith$6(e, n) {
  if (e.length < n.length)
    return !1;
  for (let o = 0; o < n.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$6.arrayContentStartsWith = arrayContentStartsWith$6;
var assert$h = {};
Object.defineProperty(assert$h, "__esModule", { value: !0 });
assert$h.assertDefinedAndNotNull = assert$h.assertDefined = assert$h.assert = void 0;
function assert$g(e, n) {
  if (!e)
    throw new Error(n || "condition is not truthy");
}
assert$h.assert = assert$g;
function assertDefined$6(e, n) {
  if (e === void 0)
    throw new Error(n ?? "value is undefined");
}
assert$h.assertDefined = assertDefined$6;
function assertDefinedAndNotNull$6(e, n) {
  if (e == null)
    throw new Error(n ?? "value is undefined or null");
}
assert$h.assertDefinedAndNotNull = assertDefinedAndNotNull$6;
var sleep$d = {};
Object.defineProperty(sleep$d, "__esModule", { value: !0 });
sleep$d.sleep = void 0;
async function sleep$c(e) {
  return new Promise((n) => setTimeout(n, e));
}
sleep$d.sleep = sleep$c;
var typechecks$6 = {};
Object.defineProperty(typechecks$6, "__esModule", { value: !0 });
typechecks$6.isDefined = typechecks$6.isUint8Array = typechecks$6.isNonNullObject = void 0;
function isNonNullObject$6(e) {
  return typeof e == "object" && e !== null;
}
typechecks$6.isNonNullObject = isNonNullObject$6;
function isUint8Array$6(e) {
  return !(!isNonNullObject$6(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(e));
}
typechecks$6.isUint8Array = isUint8Array$6;
function isDefined$6(e) {
  return e !== void 0;
}
typechecks$6.isDefined = isDefined$6;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var n = arrays$6;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return n.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return n.arrayContentStartsWith;
  } });
  var o = assert$h;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return o.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return o.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return o.assertDefinedAndNotNull;
  } });
  var u = sleep$d;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return u.sleep;
  } });
  var c = typechecks$6;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return c.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return c.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return c.isUint8Array;
  } });
})(build$M);
var __createBinding$R = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$R = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$R = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$R(n, e, o);
  return __setModuleDefault$R(n, e), n;
};
Object.defineProperty(pbkdf2$6, "__esModule", { value: !0 });
pbkdf2$6.pbkdf2Sha512 = pbkdf2$6.pbkdf2Sha512Noble = pbkdf2$6.pbkdf2Sha512NodeCrypto = pbkdf2$6.pbkdf2Sha512Subtle = pbkdf2$6.getSubtle = pbkdf2$6.getNodeCrypto = void 0;
const utils_1$19 = build$M, pbkdf2_1$d = pbkdf2$8, sha512_1$e = sha512$a;
async function getNodeCrypto$5() {
  try {
    const e = await Promise.resolve().then(() => __importStar$R(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2$6.getNodeCrypto = getNodeCrypto$5;
async function getSubtle$6() {
  var n, o, u;
  let e = (n = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : n.subtle;
  return e || (e = (u = (o = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : o.webcrypto) == null ? void 0 : u.subtle), e;
}
pbkdf2$6.getSubtle = getSubtle$6;
async function pbkdf2Sha512Subtle$6(e, n, o, u, c) {
  return (0, utils_1$19.assert)(e, "Argument subtle is falsy"), (0, utils_1$19.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$19.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$19.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", n, { name: "PBKDF2" }, !1, ["deriveBits"]).then((d) => e.deriveBits({
    name: "PBKDF2",
    salt: o,
    iterations: u,
    hash: { name: "SHA-512" }
  }, d, c * 8).then((m) => new Uint8Array(m)));
}
pbkdf2$6.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle$6;
async function pbkdf2Sha512NodeCrypto$5(e, n, o, u, c) {
  return (0, utils_1$19.assert)(e, "Argument nodeCrypto is falsy"), (0, utils_1$19.assert)(typeof e == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$19.assert)(typeof e.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((d, m) => {
    e.pbkdf2(n, o, u, c, "sha512", (v, S) => {
      v ? m(v) : d(Uint8Array.from(S));
    });
  });
}
pbkdf2$6.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto$5;
async function pbkdf2Sha512Noble$6(e, n, o, u) {
  return (0, pbkdf2_1$d.pbkdf2Async)(sha512_1$e.sha512, e, n, { c: o, dkLen: u });
}
pbkdf2$6.pbkdf2Sha512Noble = pbkdf2Sha512Noble$6;
async function pbkdf2Sha512$6(e, n, o, u) {
  const c = await getSubtle$6();
  if (c)
    return pbkdf2Sha512Subtle$6(c, e, n, o, u);
  {
    const d = await getNodeCrypto$5();
    return d ? pbkdf2Sha512NodeCrypto$5(d, e, n, o, u) : pbkdf2Sha512Noble$6(e, n, o, u);
  }
}
pbkdf2$6.pbkdf2Sha512 = pbkdf2Sha512$6;
var sha$6 = {}, utils$A = {};
Object.defineProperty(utils$A, "__esModule", { value: !0 });
utils$A.toRealUint8Array = void 0;
function toRealUint8Array$6(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$A.toRealUint8Array = toRealUint8Array$6;
Object.defineProperty(sha$6, "__esModule", { value: !0 });
sha$6.sha512 = sha$6.Sha512 = sha$6.sha256 = sha$6.Sha256 = void 0;
const sha256_1$7 = sha256$8, sha512_1$d = sha512$a, utils_1$18 = utils$A;
let Sha256$6 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha256_1$7.sha256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$18.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$6.Sha256 = Sha256$6;
function sha256$6(e) {
  return new Sha256$6(e).digest();
}
sha$6.sha256 = sha256$6;
let Sha512$6 = class {
  constructor(n) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$d.sha512.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$18.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$6.Sha512 = Sha512$6;
function sha512$6(e) {
  return new Sha512$6(e).digest();
}
sha$6.sha512 = sha512$6;
Object.defineProperty(bip39$6, "__esModule", { value: !0 });
bip39$6.Bip39 = bip39$6.EnglishMnemonic = bip39$6.mnemonicToEntropy = bip39$6.entropyToMnemonic = void 0;
const encoding_1$1q = build$N, pbkdf2_1$c = pbkdf2$6, sha_1$6 = sha$6, wordlist$6 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring$6(e) {
  return Array.from(e).map((n) => n.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits$6(e) {
  const o = e.length * 8 / 32, u = (0, sha_1$6.sha256)(e);
  return bytesToBitstring$6(u).slice(0, o);
}
function bitstringToByte$6(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths$6 = [16, 20, 24, 28, 32], allowedWordLengths$6 = [12, 15, 18, 21, 24];
function entropyToMnemonic$6(e) {
  if (allowedEntropyLengths$6.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const n = bytesToBitstring$6(e), o = deriveChecksumBits$6(e);
  return (n + o).match(/(.{11})/g).map((m) => {
    const v = bitstringToByte$6(m);
    return wordlist$6[v];
  }).join(" ");
}
bip39$6.entropyToMnemonic = entropyToMnemonic$6;
const invalidNumberOfWorks$6 = "Invalid number of words", wordNotInWordlist$6 = "Found word that is not in the wordlist", invalidEntropy$6 = "Invalid entropy", invalidChecksum$6 = "Invalid mnemonic checksum";
function normalize$6(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy$6(e) {
  const n = normalize$6(e).split(" ");
  if (!allowedWordLengths$6.includes(n.length))
    throw new Error(invalidNumberOfWorks$6);
  const o = n.map(($) => {
    const E = wordlist$6.indexOf($);
    if (E === -1)
      throw new Error(wordNotInWordlist$6);
    return E.toString(2).padStart(11, "0");
  }).join(""), u = Math.floor(o.length / 33) * 32, c = o.slice(0, u), d = o.slice(u), m = c.match(/(.{1,8})/g).map(bitstringToByte$6);
  if (m.length < 16 || m.length > 32 || m.length % 4 !== 0)
    throw new Error(invalidEntropy$6);
  const v = Uint8Array.from(m);
  if (deriveChecksumBits$6(v) !== d)
    throw new Error(invalidChecksum$6);
  return v;
}
bip39$6.mnemonicToEntropy = mnemonicToEntropy$6;
let EnglishMnemonic$6 = class Nu {
  constructor(n) {
    if (!Nu.mnemonicMatcher.test(n))
      throw new Error("Invalid mnemonic format");
    const o = n.split(" "), u = [12, 15, 18, 21, 24];
    if (u.indexOf(o.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${u} got: ${o.length})`);
    for (const c of o)
      if (Nu.wordlist.indexOf(c) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy$6(n), this.data = n;
  }
  toString() {
    return this.data;
  }
};
bip39$6.EnglishMnemonic = EnglishMnemonic$6;
EnglishMnemonic$6.wordlist = wordlist$6;
EnglishMnemonic$6.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
let Bip39$6 = class {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(n) {
    return new EnglishMnemonic$6(entropyToMnemonic$6(n));
  }
  static decode(n) {
    return mnemonicToEntropy$6(n.toString());
  }
  static async mnemonicToSeed(n, o) {
    const u = (0, encoding_1$1q.toUtf8)(normalize$6(n.toString())), c = "mnemonic" + (o ? normalize$6(o) : ""), d = (0, encoding_1$1q.toUtf8)(c);
    return (0, pbkdf2_1$c.pbkdf2Sha512)(u, d, 2048, 64);
  }
};
bip39$6.Bip39 = Bip39$6;
var hmac$6 = {};
Object.defineProperty(hmac$6, "__esModule", { value: !0 });
hmac$6.Hmac = void 0;
let Hmac$6 = class {
  constructor(n, o) {
    const u = new n().blockSize;
    this.hash = (d) => new n().update(d).digest();
    let c = o;
    if (c.length > u && (c = this.hash(c)), c.length < u) {
      const d = new Uint8Array(u - c.length);
      c = new Uint8Array([...c, ...d]);
    }
    this.oKeyPad = c.map((d) => d ^ 92), this.iKeyPad = c.map((d) => d ^ 54), this.messageHasher = new n(), this.blockSize = u, this.update(this.iKeyPad);
  }
  update(n) {
    return this.messageHasher.update(n), this;
  }
  digest() {
    const n = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...n]));
  }
};
hmac$6.Hmac = Hmac$6;
var keccak$6 = {};
Object.defineProperty(keccak$6, "__esModule", { value: !0 });
keccak$6.keccak256 = keccak$6.Keccak256 = void 0;
const sha3_1$6 = sha3$3, utils_1$17 = utils$A;
let Keccak256$6 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha3_1$6.keccak_256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$17.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
keccak$6.Keccak256 = Keccak256$6;
function keccak256$7(e) {
  return new Keccak256$6(e).digest();
}
keccak$6.keccak256 = keccak256$7;
var libsodium$6 = {}, libsodiumWrappers = {};
const __dirname = "/home/runner/work/oraiscan-widget/oraiscan-widget/node_modules/libsodium-sumo/dist/modules-sumo";
var libsodiumSumo = { exports: {} }, hasRequiredLibsodiumSumo;
function requireLibsodiumSumo() {
  return hasRequiredLibsodiumSumo || (hasRequiredLibsodiumSumo = 1, function(e, n) {
    (function(o) {
      function u(c) {
        var d;
        (d = c) === void 0 && (d = {});
        var m = d;
        typeof m.sodium != "object" && (typeof commonjsGlobal == "object" ? m = commonjsGlobal : typeof window == "object" && (m = window));
        var v = d;
        return d.ready = new Promise(function(S, $) {
          (y = v).onAbort = $, y.print = function(At) {
          }, y.printErr = function(At) {
          }, y.onRuntimeInitialized = function() {
            try {
              y._crypto_secretbox_keybytes(), S();
            } catch (At) {
              $(At);
            }
          }, y.useBackupModule = function() {
            return new Promise(function(At, hn) {
              (ce = {}).onAbort = hn, ce.onRuntimeInitialized = function() {
                Object.keys(v).forEach(function(xn) {
                  xn !== "getRandomValue" && delete v[xn];
                }), Object.keys(ce).forEach(function(xn) {
                  v[xn] = ce[xn];
                }), At();
              };
              var $t, Lt, Qn, ce = ce !== void 0 ? ce : {}, Ze = Object.assign({}, ce), ft = typeof window == "object", It = typeof importScripts == "function", rn = typeof browser$1$1 == "object" && typeof browser$1$1.versions == "object" && typeof browser$1$1.versions.node == "string", Ln = "";
              if (rn) {
                var Pn = require$$0$3, Ae = requirePathBrowserify();
                Ln = It ? Ae.dirname(Ln) + "/" : __dirname + "/", $t = (xn, sr) => {
                  var Nr = ii(xn);
                  return Nr ? sr ? Nr : Nr.toString() : (xn = No(xn) ? new URL(xn) : Ae.normalize(xn), Pn.readFileSync(xn, sr ? void 0 : "utf8"));
                }, Qn = (xn) => {
                  var sr = $t(xn, !0);
                  return sr.buffer || (sr = new Uint8Array(sr)), sr;
                }, Lt = (xn, sr, Nr) => {
                  var vr = ii(xn);
                  vr && sr(vr), xn = No(xn) ? new URL(xn) : Ae.normalize(xn), Pn.readFile(xn, function(Yr, Fr) {
                    Yr ? Nr(Yr) : sr(Fr.buffer);
                  });
                }, browser$1$1.argv.length > 1 && browser$1$1.argv[1].replace(/\\/g, "/"), browser$1$1.argv.slice(2), e.exports = ce, ce.inspect = function() {
                  return "[Emscripten Module object]";
                };
              } else
                (ft || It) && (It ? Ln = self.location.href : typeof document < "u" && document.currentScript && (Ln = document.currentScript.src), Ln = Ln.indexOf("blob:") !== 0 ? Ln.substr(0, Ln.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", $t = (xn) => {
                  try {
                    var sr = new XMLHttpRequest();
                    return sr.open("GET", xn, !1), sr.send(null), sr.responseText;
                  } catch (vr) {
                    var Nr = ii(xn);
                    if (Nr)
                      return function(Yr) {
                        for (var Fr = [], eo = 0; eo < Yr.length; eo++) {
                          var Xr = Yr[eo];
                          Xr > 255 && (Xr &= 255), Fr.push(String.fromCharCode(Xr));
                        }
                        return Fr.join("");
                      }(Nr);
                    throw vr;
                  }
                }, It && (Qn = (xn) => {
                  try {
                    var sr = new XMLHttpRequest();
                    return sr.open("GET", xn, !1), sr.responseType = "arraybuffer", sr.send(null), new Uint8Array(sr.response);
                  } catch (vr) {
                    var Nr = ii(xn);
                    if (Nr)
                      return Nr;
                    throw vr;
                  }
                }), Lt = (xn, sr, Nr) => {
                  var vr = new XMLHttpRequest();
                  vr.open("GET", xn, !0), vr.responseType = "arraybuffer", vr.onload = () => {
                    if (vr.status == 200 || vr.status == 0 && vr.response)
                      sr(vr.response);
                    else {
                      var Yr = ii(xn);
                      Yr ? sr(Yr.buffer) : Nr();
                    }
                  }, vr.onerror = Nr, vr.send(null);
                });
              ce.print;
              var Me, He = ce.printErr || void 0;
              Object.assign(ce, Ze), Ze = null, ce.arguments && ce.arguments, ce.thisProgram && ce.thisProgram, ce.quit && ce.quit, ce.wasmBinary && (Me = ce.wasmBinary), ce.noExitRuntime;
              var cn, Wt = { Memory: function(xn) {
                this.buffer = new ArrayBuffer(65536 * xn.initial);
              }, Module: function(xn) {
              }, Instance: function(xn, sr) {
                this.exports = function(Nr) {
                  for (var vr, Yr = new Uint8Array(123), Fr = 25; Fr >= 0; --Fr)
                    Yr[48 + Fr] = 52 + Fr, Yr[65 + Fr] = Fr, Yr[97 + Fr] = 26 + Fr;
                  function eo(Mo, jo, Ii) {
                    for (var ki, j, l = 0, B = jo, Ri = Ii.length, wr = jo + (3 * Ri >> 2) - (Ii[Ri - 2] == "=") - (Ii[Ri - 1] == "="); l < Ri; l += 4)
                      ki = Yr[Ii.charCodeAt(l + 1)], j = Yr[Ii.charCodeAt(l + 2)], Mo[B++] = Yr[Ii.charCodeAt(l)] << 2 | ki >> 4, B < wr && (Mo[B++] = ki << 4 | j >> 2), B < wr && (Mo[B++] = j << 6 | Yr[Ii.charCodeAt(l + 3)]);
                  }
                  function Xr() {
                    throw new Error("abort");
                  }
                  return Yr[43] = 62, Yr[47] = 63, function(Mo) {
                    var jo = Mo.a, Ii = jo.a, ki = Ii.buffer;
                    Ii.grow = function(A) {
                      A |= 0;
                      var g = 0 | Ic(), _ = g + A | 0;
                      if (g < _ && _ < 65536) {
                        var b = new ArrayBuffer(wr(_, 65536));
                        new Int8Array(b).set(j), j = new Int8Array(b), l = new Int32Array(b), B = new Uint8Array(b), Ri = new Uint32Array(b), ki = b, Ii.buffer = ki, vr = B;
                      }
                      return g;
                    };
                    var j = new Int8Array(ki), l = new Int32Array(ki), B = new Uint8Array(ki), Ri = new Uint32Array(ki), wr = Math.imul, zi = Math.clz32, ks = jo.b, Hs = jo.c, Oa = jo.d, qa = jo.e, st = 102592, Oe = 0, Bs = 0, ve = 0;
                    function $s(A, g) {
                      var _, b, U, ie, he, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0, Nn = 0, cr = 0, Rr = 0, Ir = 0, Pr = 0, qr = 0, ao = 0, Fn = 0, Wn = 0, wt = 0, jt = 0, an = 0, Ar = 0, Tr = 0, zr = 0, Gr = 0, no = 0, so = 0, co = 0, lo = 0, yo = 0, Co = 0, Io = 0, ko = 0, Po = 0, $o = 0, xo = 0, Go = 0, Xo = 0, ei = 0, ti = 0, oi = 0, vi = 0;
                      no = B[g + 40 | 0] | B[g + 41 | 0] << 8 | B[g + 42 | 0] << 16 | B[g + 43 | 0] << 24, co = D = B[g + 44 | 0] | B[g + 45 | 0] << 8 | B[g + 46 | 0] << 16 | B[g + 47 | 0] << 24, qr = B[g + 104 | 0] | B[g + 105 | 0] << 8 | B[g + 106 | 0] << 16 | B[g + 107 | 0] << 24, lo = D = B[g + 108 | 0] | B[g + 109 | 0] << 8 | B[g + 110 | 0] << 16 | B[g + 111 | 0] << 24, D = B[g + 68 | 0] | B[g + 69 | 0] << 8 | B[g + 70 | 0] << 16 | B[g + 71 | 0] << 24, ur = B[g + 64 | 0] | B[g + 65 | 0] << 8 | B[g + 66 | 0] << 16 | B[g + 67 | 0] << 24, Fn = D, ei = D = B[g + 36 | 0] | B[g + 37 | 0] << 8 | B[g + 38 | 0] << 16 | B[g + 39 | 0] << 24, Gt = D, an = B[g + 120 | 0] | B[g + 121 | 0] << 8 | B[g + 122 | 0] << 16 | B[g + 123 | 0] << 24, ko = D = B[g + 124 | 0] | B[g + 125 | 0] << 8 | B[g + 126 | 0] << 16 | B[g + 127 | 0] << 24, U = D = B[g + 92 | 0] | B[g + 93 | 0] << 8 | B[g + 94 | 0] << 16 | B[g + 95 | 0] << 24, _ = B[g + 88 | 0] | B[g + 89 | 0] << 8 | B[g + 90 | 0] << 16 | B[g + 91 | 0] << 24, or = D, jt = B[g + 80 | 0] | B[g + 81 | 0] << 8 | B[g + 82 | 0] << 16 | B[g + 83 | 0] << 24, Co = D = B[g + 84 | 0] | B[g + 85 | 0] << 8 | B[g + 86 | 0] << 16 | B[g + 87 | 0] << 24, Cr = D, Wn = B[A + 16 | 0] | B[A + 17 | 0] << 8 | B[A + 18 | 0] << 16 | B[A + 19 | 0] << 24, D = (Tr = B[A + 52 | 0] | B[A + 53 | 0] << 8 | B[A + 54 | 0] << 16 | B[A + 55 | 0] << 24) + Gt | 0, Zt = (Ar = B[A + 48 | 0] | B[A + 49 | 0] << 8 | B[A + 50 | 0] << 16 | B[A + 51 | 0] << 24) + (zr = B[g + 32 | 0] | B[g + 33 | 0] << 8 | B[g + 34 | 0] << 16 | B[g + 35 | 0] << 24) | 0, D = (B[A + 20 | 0] | B[A + 21 | 0] << 8 | B[A + 22 | 0] << 16 | B[A + 23 | 0] << 24) + (Ar >>> 0 > Zt >>> 0 ? D + 1 | 0 : D) | 0, D = (Wn = (me = Zt) >>> 0 > (Zt = Zt + Wn | 0) >>> 0 ? D + 1 | 0 : D) + co | 0, wt = so = Zt + no | 0, so = D = so >>> 0 < Zt >>> 0 ? D + 1 | 0 : D, Zt = q(Zt ^ (B[A + 80 | 0] | B[A + 81 | 0] << 8 | B[A + 82 | 0] << 16 | B[A + 83 | 0] << 24) ^ -79577749, Wn ^ (B[A + 84 | 0] | B[A + 85 | 0] << 8 | B[A + 86 | 0] << 16 | B[A + 87 | 0] << 24) ^ 528734635, 32), xo = D = ve, D = D + 1013904242 | 0, Wn = Zt, ut = D = (Zt = Zt - 23791573 | 0) >>> 0 < 4271175723 ? D + 1 | 0 : D, Tr = q(Zt ^ Ar, D ^ Tr, 40), D = (D = so) + (so = ve) | 0, Ar = q(Wn ^ (Ge = Ar = Tr + wt | 0), xo ^ (je = Ge >>> 0 < Tr >>> 0 ? D + 1 | 0 : D), 48), D = ut + (Zn = ve) | 0, ht = D = (Ar = Zt + (ct = Ar) | 0) >>> 0 < Zt >>> 0 ? D + 1 | 0 : D, Ar = D = q(Tr ^ (bt = Ar), so ^ D, 1), ut = Zt = ve, so = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, xo = D = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, Gr = B[A + 8 | 0] | B[A + 9 | 0] << 8 | B[A + 10 | 0] << 16 | B[A + 11 | 0] << 24, Zt = (Tr = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24) + (Wn = B[A + 40 | 0] | B[A + 41 | 0] << 8 | B[A + 42 | 0] << 16 | B[A + 43 | 0] << 24) | 0, D = (ti = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24) + (vi = B[A + 44 | 0] | B[A + 45 | 0] << 8 | B[A + 46 | 0] << 16 | B[A + 47 | 0] << 24) | 0, D = (B[A + 12 | 0] | B[A + 13 | 0] << 8 | B[A + 14 | 0] << 16 | B[A + 15 | 0] << 24) + (Zt >>> 0 < Wn >>> 0 ? D + 1 | 0 : D) | 0, D = xo + (wt = (me = Zt) >>> 0 > (Zt = Zt + Gr | 0) >>> 0 ? D + 1 | 0 : D) | 0, D = (Gr = Zt + so | 0) >>> 0 < Zt >>> 0 ? D + 1 | 0 : D, me = q(Zt ^ (B[A + 72 | 0] | B[A + 73 | 0] << 8 | B[A + 74 | 0] << 16 | B[A + 75 | 0] << 24) ^ 725511199, wt ^ (B[A + 76 | 0] | B[A + 77 | 0] << 8 | B[A + 78 | 0] << 16 | B[A + 79 | 0] << 24) ^ -1694144372, 32), we = q(Wn ^ (_e = me - 2067093701 | 0), vi ^ (pn = ($n = Zt = ve) - ((me >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), D = (er = ve) + D | 0, D = (wn = (Ct = Zt = we + Gr | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D) + ut | 0, D = (Ct >>> 0 > (Zt = Ct + Ar | 0) >>> 0 ? D + 1 | 0 : D) + Cr | 0, D = (Wn = (Be = Zt) >>> 0 > (Zt = Zt + jt | 0) >>> 0 ? D + 1 | 0 : D) + or | 0, Kn = or = Zt + _ | 0, Le = D = or >>> 0 < Zt >>> 0 ? D + 1 | 0 : D, mt = Ar, Po = ut, ut = Zt, wt = Wn, Ar = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, Zt = D = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, vi = D = B[0 | A] | B[A + 1 | 0] << 8 | B[A + 2 | 0] << 16 | B[A + 3 | 0] << 24, ie = Wn = B[A + 4 | 0] | B[A + 5 | 0] << 8 | B[A + 6 | 0] << 16 | B[A + 7 | 0] << 24, Cr = D, D = (Go = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24) + (ye = B[A + 36 | 0] | B[A + 37 | 0] << 8 | B[A + 38 | 0] << 16 | B[A + 39 | 0] << 24) | 0, D = ie + ((or = B[A + 32 | 0] | B[A + 33 | 0] << 8 | B[A + 34 | 0] << 16 | B[A + 35 | 0] << 24) >>> 0 > (Be = or + (Wn = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24) | 0) >>> 0 ? D + 1 | 0 : D) | 0, D = (Gr = (Cr = Be + Cr | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) + Zt | 0, Io = Be = Cr + Ar | 0, Be = D = Be >>> 0 < Cr >>> 0 ? D + 1 | 0 : D, $e = or, or = q(Cr ^ (B[0 | (D = A - -64 | 0)] | B[D + 1 | 0] << 8 | B[D + 2 | 0] << 16 | B[D + 3 | 0] << 24) ^ -1377402159, Gr ^ (B[D + 4 | 0] | B[D + 5 | 0] << 8 | B[D + 6 | 0] << 16 | B[D + 7 | 0] << 24) ^ 1359893119, 32), Gr = D = ve, D = D + 1779033703 | 0, Cr = or, Ft = D = (or = or - 205731576 | 0) >>> 0 < 4089235720 ? D + 1 | 0 : D, ye = q($e ^ (Tt = or), D ^ ye, 40), D = (Gn = ve) + Be | 0, $e = q(Cr ^ (Be = or = ye + Io | 0), Gr ^ (en = ye >>> 0 > Be >>> 0 ? D + 1 | 0 : D), 48), D = q($e ^ ut, (cr = ve) ^ wt, 32), Ve = or = ve, Kt = D, b = D = B[g + 60 | 0] | B[g + 61 | 0] << 8 | B[g + 62 | 0] << 16 | B[g + 63 | 0] << 24, Gr = Io = B[g + 56 | 0] | B[g + 57 | 0] << 8 | B[g + 58 | 0] << 16 | B[g + 59 | 0] << 24, St = B[A + 24 | 0] | B[A + 25 | 0] << 8 | B[A + 26 | 0] << 16 | B[A + 27 | 0] << 24, or = (wt = B[g + 48 | 0] | B[g + 49 | 0] << 8 | B[g + 50 | 0] << 16 | B[g + 51 | 0] << 24) + (Cr = B[A + 56 | 0] | B[A + 57 | 0] << 8 | B[A + 58 | 0] << 16 | B[A + 59 | 0] << 24) | 0, D = (Xo = B[g + 52 | 0] | B[g + 53 | 0] << 8 | B[g + 54 | 0] << 16 | B[g + 55 | 0] << 24) + (qn = B[A + 60 | 0] | B[A + 61 | 0] << 8 | B[A + 62 | 0] << 16 | B[A + 63 | 0] << 24) | 0, D = (B[A + 28 | 0] | B[A + 29 | 0] << 8 | B[A + 30 | 0] << 16 | B[A + 31 | 0] << 24) + (or >>> 0 < Cr >>> 0 ? D + 1 | 0 : D) | 0, D = b + (ut = (it = or) >>> 0 > (or = St + or | 0) >>> 0 ? D + 1 | 0 : D) | 0, D = (St = or + Gr | 0) >>> 0 < or >>> 0 ? D + 1 | 0 : D, ut = q(or ^ (B[A + 88 | 0] | B[A + 89 | 0] << 8 | B[A + 90 | 0] << 16 | B[A + 91 | 0] << 24) ^ 327033209, ut ^ (B[A + 92 | 0] | B[A + 93 | 0] << 8 | B[A + 94 | 0] << 16 | B[A + 95 | 0] << 24) ^ 1541459225, 32), Cr = q(Cr ^ (Gr = ut + 1595750129 | 0), (it = qn) ^ (qn = (fn = or = ve) - ((ut >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), D = (Pr = ve) + D | 0, or = q((St = or = Cr + St | 0) ^ ut, fn ^ (it = St >>> 0 < Cr >>> 0 ? D + 1 | 0 : D), 48), D = qn + (Rr = ve) | 0, _n = D = (or = Gr + (qn = or) | 0) >>> 0 < Gr >>> 0 ? D + 1 | 0 : D, D = Ve + D | 0, Je = mt ^ (ut = Kt + (fn = or) | 0), mt = D = ut >>> 0 < fn >>> 0 ? D + 1 | 0 : D, Gr = q(Je, D ^ Po, 40), D = (Po = ve) + Le | 0, or = q(Kn = Kt ^ (Le = or = Gr + Kn | 0), Ve ^ (Kt = Le >>> 0 < Gr >>> 0 ? D + 1 | 0 : D), 48), D = mt + (ao = ve) | 0, Ve = D = (mt = ut + (Kn = or) | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D, or = (Hn = q(mt ^ Gr, Po ^ D, 1)) + (ut = B[g + 72 | 0] | B[g + 73 | 0] << 8 | B[g + 74 | 0] << 16 | B[g + 75 | 0] << 24) | 0, D = (yo = ve) + (Po = B[g + 76 | 0] | B[g + 77 | 0] << 8 | B[g + 78 | 0] << 16 | B[g + 79 | 0] << 24) | 0, $o = or, Sn = or >>> 0 < ut >>> 0 ? D + 1 | 0 : D, Nn = lo, or = B[g + 96 | 0] | B[g + 97 | 0] << 8 | B[g + 98 | 0] << 16 | B[g + 99 | 0] << 24, Gr = D = B[g + 100 | 0] | B[g + 101 | 0] << 8 | B[g + 102 | 0] << 16 | B[g + 103 | 0] << 24, Cr = (D = Ge) + (Ge = q(fn ^ Cr, _n ^ Pr, 1)) | 0, D = (fn = ve) + je | 0, D = (Ge >>> 0 > Cr >>> 0 ? D + 1 | 0 : D) + Gr | 0, D = (je = (je = Cr) >>> 0 > (Cr = or + Cr | 0) >>> 0 ? D + 1 | 0 : D) + Nn | 0, Je = _n = Cr + qr | 0, _n = D = _n >>> 0 < Cr >>> 0 ? D + 1 | 0 : D, Ct = q(me ^ Ct, wn ^ $n, 48), wn = D = q(Ct ^ Cr, ($n = ve) ^ je, 32), D = Ft + cr | 0, D = (Pr = Cr = ve) + (Tt = (Cr = $e + Tt | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, Ft = D = (je = Cr) >>> 0 > ($e = je + wn | 0) >>> 0 ? D + 1 | 0 : D, Ge = q($e ^ Ge, fn ^ D, 40), D = (cr = ve) + _n | 0, D = (fn = Ge >>> 0 > (_n = Cr = Ge + Je | 0) >>> 0 ? D + 1 | 0 : D) + Sn | 0, D = (me = _n >>> 0 > (Cr = _n + $o | 0) >>> 0 ? D + 1 | 0 : D) + ko | 0, $o = Sn = Cr + an | 0, Sn = D = Sn >>> 0 < Cr >>> 0 ? D + 1 | 0 : D, Je = Cr, Nn = me, Cr = B[g + 116 | 0] | B[g + 117 | 0] << 8 | B[g + 118 | 0] << 16 | B[g + 119 | 0] << 24, g = B[g + 112 | 0] | B[g + 113 | 0] << 8 | B[g + 114 | 0] << 16 | B[g + 115 | 0] << 24, ye = q(ye ^ je, Tt ^ Gn, 1), D = (Gn = ve) + it | 0, D = ((me = ye + St | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D) + Cr | 0, D = (je = (Tt = me) >>> 0 > (me = g + me | 0) >>> 0 ? D + 1 | 0 : D) + ko | 0, oi = Tt = me + an | 0, Tt = D = Tt >>> 0 < me >>> 0 ? D + 1 | 0 : D, D = q(me ^ ct, je ^ Zn, 32), Ir = me = ve, ct = D, je = me, D = $n + pn | 0, Ct = me = _e + Ct | 0, St = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, D = D + je | 0, it = me = me + ct | 0, Zn = D = Ct >>> 0 > me >>> 0 ? D + 1 | 0 : D, je = q(me ^ ye, Gn ^ D, 40), D = (Gn = ve) + Tt | 0, ct = q((me = je + oi | 0) ^ ct, Ir ^ (_e = me >>> 0 < je >>> 0 ? D + 1 | 0 : D), 48), D = q(ct ^ Je, (oi = ve) ^ Nn, 32), Ir = ye = ve, Tt = D, Je = ye, we = q(we ^ Ct, St ^ er, 1), D = en + (Ct = ve) | 0, D = ((ye = Be) >>> 0 > (Be = Be + we | 0) >>> 0 ? D + 1 | 0 : D) + Fn | 0, D = (Be = (ye = Be + ur | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) + Po | 0, Nn = en = ye + ut | 0, en = D = en >>> 0 < ye >>> 0 ? D + 1 | 0 : D, St = we, ye = q(ye ^ qn, Be ^ Rr, 32), D = (qn = ve) + ht | 0, bt = q(St ^ (Be = we = ye + bt | 0), (ht = ye >>> 0 > Be >>> 0 ? D + 1 | 0 : D) ^ Ct, 40), D = (Rr = ve) + en | 0, Ct = we = bt + Nn | 0, we = q(ye ^ we, qn ^ (en = we >>> 0 < bt >>> 0 ? D + 1 | 0 : D), 48), D = ht + (he = ve) | 0, ht = we, qn = D = (we = Be + we | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D, D = D + Je | 0, D = (St = we) >>> 0 > (we = we + Tt | 0) >>> 0 ? D + 1 | 0 : D, Je = we, we ^= Hn, Hn = D, ye = q(we, yo ^ D, 40), D = (yo = ve) + Sn | 0, Sn = we = ye + $o | 0, D = U + (Nn = ye >>> 0 > we >>> 0 ? D + 1 | 0 : D) | 0, $o = we = we + _ | 0, $n = D = we >>> 0 < _ >>> 0 ? D + 1 | 0 : D, we = me, pn = qr, er = lo, me = q(wn ^ _n, fn ^ Pr, 48), D = Ft + (Pr = ve) | 0, wn = me, Ft = D = (Be = $e + me | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D, me = q(Be ^ Ge, cr ^ D, 1), D = ($e = ve) + er | 0, D = ((Ge = me + pn | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) + _e | 0, D = Xo + (we = (_e = we + Ge | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D) | 0, _n = Ge = _e + wt | 0, Ge = D = Ge >>> 0 < wt >>> 0 ? D + 1 | 0 : D, _e = q(_e ^ ht, we ^ he, 32), D = Ve + (fn = ve) | 0, ht = _e, mt = D = (_e = mt + _e | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D, we = q(me ^ _e, D ^ $e, 40), D = (D = Ge) + (Ge = ve) | 0, $e = me = we + _n | 0, me = q(me ^ ht, fn ^ (_n = me >>> 0 < we >>> 0 ? D + 1 | 0 : D), 48), D = mt + (cr = ve) | 0, fn = me, Ve = D = (mt = _e + me | 0) >>> 0 < _e >>> 0 ? D + 1 | 0 : D, me = q(we ^ mt, Ge ^ D, 1), D = (Ge = ve) + $n | 0, D = b + (we = (_e = me + $o | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, $o = ht = _e + Io | 0, ht = D = ht >>> 0 < Io >>> 0 ? D + 1 | 0 : D, $n = me, pn = Ge, D = Zn + oi | 0, D = (me = ct + it | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, ct = me, it = D, D = q(me ^ je, Gn ^ D, 1), je = Ge = ve, me = D, D = en + Cr | 0, D = ((Ct = g + Ct | 0) >>> 0 < g >>> 0 ? D + 1 | 0 : D) + Ge | 0, D = Co + (Ct = (Ge = me + Ct | 0) >>> 0 < Ct >>> 0 ? D + 1 | 0 : D) | 0, Zn = en = Ge + jt | 0, en = D = en >>> 0 < jt >>> 0 ? D + 1 | 0 : D, Ge = q(Ge ^ Kn, Ct ^ ao, 32), D = Ft + (Kn = ve) | 0, Ct = Ge, Ft = D = (Ft = Be) >>> 0 > (Be = Be + Ge | 0) >>> 0 ? D + 1 | 0 : D, Ge = q(me ^ Be, D ^ je, 40), D = (Gn = ve) + en | 0, je = me = Ge + Zn | 0, me = q(en = me ^ Ct, Kn ^ (Ct = me >>> 0 < Ge >>> 0 ? D + 1 | 0 : D), 48), D = Ft + (ao = ve) | 0, Ft = me, en = me = Be + me | 0, Kn = D = me >>> 0 < Be >>> 0 ? D + 1 | 0 : D, Zn = _e, er = we, me = q(bt ^ St, qn ^ Rr, 1), D = (Be = ve) + Gt | 0, D = Kt + ((_e = me + zr | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, D = Fn + (we = (_e = _e + Le | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D) | 0, Kt = Le = _e + ur | 0, Le = D = Le >>> 0 < _e >>> 0 ? D + 1 | 0 : D, bt = me, me = (_e = q(_e ^ wn, we ^ Pr, 32)) + ct | 0, D = (ct = ve) + it | 0, we = me, Be = q(me ^ bt, (wn = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D) ^ Be, 40), D = (Pr = ve) + Le | 0, Le = me = Be + Kt | 0, St = q(me ^ _e, ct ^ (Kt = me >>> 0 < Be >>> 0 ? D + 1 | 0 : D), 48), _e = q(St ^ Zn, (D = er) ^ (er = ve), 32), D = (Zn = ve) + Kn | 0, ct = me = _e + en | 0, bt = q(me ^ $n, (it = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D) ^ pn, 40), D = ($n = ve) + ht | 0, ht = me = bt + $o | 0, me = q(me ^ _e, Zn ^ (qn = me >>> 0 < bt >>> 0 ? D + 1 | 0 : D), 48), D = it + (Rr = ve) | 0, it = me, Zn = D = (_e = ct) >>> 0 > (ct = ct + me | 0) >>> 0 ? D + 1 | 0 : D, me = q(ct ^ bt, $n ^ D, 1), D = ko + ($o = ve) | 0, $n = me, oi = me = an + me | 0, bt = D = me >>> 0 < an >>> 0 ? D + 1 | 0 : D, _e = no, me = q(Ge ^ en, Gn ^ Kn, 1), D = _n + (Ge = ve) | 0, D = ((en = $e) >>> 0 > ($e = me + $e | 0) >>> 0 ? D + 1 | 0 : D) + co | 0, D = (en = (_e = _e + $e | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) + xo | 0, pn = $e = _e + so | 0, _n = D = $e >>> 0 < _e >>> 0 ? D + 1 | 0 : D, Kn = me, $e = q(Tt ^ Sn, Nn ^ Ir, 48), D = q($e ^ _e, (Gn = ve) ^ en, 32), Ir = me = ve, Tt = D, _e = me, D = wn + er | 0, D = (me = we + St | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = me, wn = D, D = D + _e | 0, en = me = me + Tt | 0, St = D = we >>> 0 > me >>> 0 ? D + 1 | 0 : D, _e = q(me ^ Kn, D ^ Ge, 40), D = (D = _n) + (_n = ve) | 0, Kn = me = _e + pn | 0, Sn = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, D = D + bt | 0, Nn = D = (Ge = me + oi | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, bt = D, me = q(Be ^ we, wn ^ Pr, 1), D = Zt + (Be = ve) | 0, D = Ct + ((we = me + Ar | 0) >>> 0 < Ar >>> 0 ? D + 1 | 0 : D) | 0, D = Gr + (je = (we = we + je | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D) | 0, pn = Ct = we + or | 0, Ct = D = Ct >>> 0 < or >>> 0 ? D + 1 | 0 : D, wn = me, D = q(we ^ fn, je ^ cr, 32), er = me = ve, we = D, je = me, D = Gn + Hn | 0, fn = me = $e + Je | 0, Hn = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, D = D + je | 0, D = ($e = me + we | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = $e ^ wn, wn = D, je = q(me, D ^ Be, 40), D = (cr = ve) + Ct | 0, Be = me = je + pn | 0, Je = q(me ^ we, er ^ (Ct = me >>> 0 < je >>> 0 ? D + 1 | 0 : D), 48), D = q(Je ^ Ge, (Pr = ve) ^ bt, 32), oi = me = ve, pn = D, bt = me, me = q(ye ^ fn, Hn ^ yo, 1), D = Kt + (ye = ve) | 0, D = Go + ((we = me + Le | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D) | 0, D = (Le = (we = we + Wn | 0) >>> 0 < Wn >>> 0 ? D + 1 | 0 : D) + ti | 0, fn = Kt = we + Tr | 0, Kt = D = Kt >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = q(we ^ Ft, Le ^ ao, 32), D = Ve + (Hn = ve) | 0, Ft = we, Le = ye, ye = D = (we = mt + we | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D, Le = q(me ^ we, Le ^ D, 40), D = (ao = ve) + Kt | 0, mt = me = Le + fn | 0, me = q(fn = me ^ Ft, Hn ^ (Ft = me >>> 0 < Le >>> 0 ? D + 1 | 0 : D), 48), D = ye + (Gn = ve) | 0, ye = me, Kt = me = we + me | 0, fn = D = me >>> 0 < we >>> 0 ? D + 1 | 0 : D, D = D + bt | 0, Ve = D = (bt = me + pn | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, we = q(bt ^ $n, $o ^ D, 40), D = Nn + (Hn = ve) | 0, D = ((me = we + Ge | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D) + lo | 0, Ge = me, Nn = me = me + qr | 0, $n = D = Ge >>> 0 > me >>> 0 ? D + 1 | 0 : D, er = Fn, Ge = q(Tt ^ Kn, Sn ^ Ir, 48), D = (yo = ve) + St | 0, Tt = me = Ge + en | 0, D = q(me ^ _e, (en = me >>> 0 < Ge >>> 0 ? D + 1 | 0 : D) ^ _n, 1), _n = _e = ve, me = D, D = Ct + U | 0, D = ((Be = Be + _ | 0) >>> 0 < _ >>> 0 ? D + 1 | 0 : D) + _e | 0, D = (Be = (_e = me + Be | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) + er | 0, St = Ct = _e + ur | 0, Ct = D = Ct >>> 0 < _e >>> 0 ? D + 1 | 0 : D, _e = q(_e ^ ye, Be ^ Gn, 32), D = Zn + (Kn = ve) | 0, ct = D = (ye = _e + ct | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, Be = q(me ^ ye, D ^ _n, 40), D = (Sn = ve) + Ct | 0, Ct = me = Be + St | 0, _e = q(me ^ _e, Kn ^ (_n = me >>> 0 < Be >>> 0 ? D + 1 | 0 : D), 48), D = ct + (St = ve) | 0, Kn = D = (ct = _e + ye | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D, me = q(Be ^ ct, Sn ^ D, 1), D = (Sn = ve) + $n | 0, D = Po + ((ye = me + Nn | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, D = (Be = (ye = ye + ut | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D) + Gt | 0, $o = Gt = ye + zr | 0, Gt = D = Gt >>> 0 < ye >>> 0 ? D + 1 | 0 : D, Zn = me, er = ye, Gn = Be, ye = no, me = q(Le ^ Kt, fn ^ ao, 1), D = qn + (Le = ve) | 0, D = ((Be = ht) >>> 0 > (ht = me + ht | 0) >>> 0 ? D + 1 | 0 : D) + co | 0, D = ti + (Be = (ye = ye + ht | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D) | 0, qn = ht = ye + Tr | 0, Kt = D = ht >>> 0 < Tr >>> 0 ? D + 1 | 0 : D, ht = me, Be = D = q(ye ^ Ge, Be ^ yo, 32), D = wn + Pr | 0, D = (fn = me = ve) + ($e = (me = $e + Je | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, wn = D = (Ge = me + Be | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, ht = q(Ge ^ ht, D ^ Le, 40), D = (Pr = ve) + Kt | 0, Kt = q(qn = (ye = ht + qn | 0) ^ Be, fn ^ (Be = ye >>> 0 < ht >>> 0 ? D + 1 | 0 : D), 48), D = q(Kt ^ er, (ao = ve) ^ Gn, 32), yo = Le = ve, qn = D, fn = Le, me = q(me ^ je, $e ^ cr, 1), D = Gr + (Le = ve) | 0, D = Ft + (($e = me + or | 0) >>> 0 < or >>> 0 ? D + 1 | 0 : D) | 0, D = Go + (mt = ($e = $e + mt | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D) | 0, er = je = $e + Wn | 0, je = D = je >>> 0 < Wn >>> 0 ? D + 1 | 0 : D, Ft = me, Je = Le, $e = q($e ^ it, mt ^ Rr, 32), D = (it = ve) + en | 0, Le = me = $e + Tt | 0, mt = q(me ^ Ft, (Tt = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D) ^ Je, 40), D = (cr = ve) + je | 0, Ft = me = mt + er | 0, me = q(me ^ $e, it ^ (en = me >>> 0 < mt >>> 0 ? D + 1 | 0 : D), 48), D = Tt + (er = ve) | 0, je = me, Tt = me = Le + me | 0, it = D = me >>> 0 < Le >>> 0 ? D + 1 | 0 : D, D = D + fn | 0, fn = me = me + qn | 0, $e = Sn, Sn = D = Tt >>> 0 > me >>> 0 ? D + 1 | 0 : D, $e = q(me ^ Zn, $e ^ D, 40), D = (D = Gt) + (Gt = ve) | 0, Je = me = $e + $o | 0, Zn = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Le = Be, me = q(pn ^ Nn, $n ^ oi, 48), D = Ve + (Rr = ve) | 0, Ve = me, Be = (me = bt + me | 0) ^ we, we = D = me >>> 0 < bt >>> 0 ? D + 1 | 0 : D, Be = q(Be, D ^ Hn, 1), D = (Hn = ve) + Le | 0, D = b + ((ye = Be + ye | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) | 0, D = (Le = (ye = ye + Io | 0) >>> 0 < Io >>> 0 ? D + 1 | 0 : D) + Zt | 0, Nn = bt = ye + Ar | 0, bt = D = bt >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = q(ye ^ je, Le ^ er, 32), D = Kn + ($n = ve) | 0, Kn = ye, ct = D = (Le = ct + ye | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, Be = q(Be ^ Le, Hn ^ D, 40), D = (D = bt) + (bt = ve) | 0, je = ye = Be + Nn | 0, ye = q(pn = ye ^ Kn, $n ^ (Kn = ye >>> 0 < Be >>> 0 ? D + 1 | 0 : D), 48), D = ct + ($o = ve) | 0, Hn = ye, Nn = D = (ct = Le + ye | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, ye = q(Be ^ ct, bt ^ D, 1), D = (bt = ve) + Zn | 0, D = U + ((Be = ye + Je | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D) | 0, D = Cr + (Le = (Be = Be + _ | 0) >>> 0 < _ >>> 0 ? D + 1 | 0 : D) | 0, oi = $n = g + Be | 0, $n = D = $n >>> 0 < g >>> 0 ? D + 1 | 0 : D, pn = ye, er = bt, bt = Be, Gn = Le, ye = q(mt ^ Tt, it ^ cr, 1), D = (Le = ve) + _n | 0, D = Co + ((Be = ye + Ct | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D) | 0, D = (mt = (Be = Be + jt | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D) + Cr | 0, _n = Ct = g + Be | 0, Ct = D = Ct >>> 0 < Be >>> 0 ? D + 1 | 0 : D, Tt = ye, Be = D = q(Be ^ Ve, mt ^ Rr, 32), mt = ye = ve, D = wn + ao | 0, wn = D = (ye = Ge + Kt | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, D = D + mt | 0, D = (Ge = ye) >>> 0 > (ye = ye + Be | 0) >>> 0 ? D + 1 | 0 : D, Kt = ye, ye ^= Tt, Tt = D, Le = q(ye, D ^ Le, 40), D = (cr = ve) + Ct | 0, mt = q(Ct = (ye = Le + _n | 0) ^ Be, mt ^ (Be = ye >>> 0 < Le >>> 0 ? D + 1 | 0 : D), 48), D = q(mt ^ bt, (D = Gn) ^ (Gn = ve), 32), Rr = bt = ve, Ct = D, _n = we, we = _e, D = q(Ge ^ ht, wn ^ Pr, 1), it = _e = ve, Ge = D, D = en + xo | 0, D = ((ht = Ft + so | 0) >>> 0 < so >>> 0 ? D + 1 | 0 : D) + _e | 0, ht = D = (_e = Ge + ht | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, we = q(_e ^ we, D ^ St, 32), D = (D = _n) + (_n = ve) | 0, Ge = q((me = we + me | 0) ^ Ge, it ^ (wn = me >>> 0 < we >>> 0 ? D + 1 | 0 : D), 40), D = ht + (Pr = ve) | 0, Ft = Ge, D = Xo + ((en = _e) >>> 0 > (_e = _e + Ge | 0) >>> 0 ? D + 1 | 0 : D) | 0, en = D = (Ge = _e + wt | 0) >>> 0 < wt >>> 0 ? D + 1 | 0 : D, _e = q(we ^ Ge, _n ^ D, 48), D = wn + (ao = ve) | 0, St = me, we = _e, wn = me = me + _e | 0, _n = D = St >>> 0 > me >>> 0 ? D + 1 | 0 : D, D = D + bt | 0, St = D = (bt = me + Ct | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = (ht = q(bt ^ pn, D ^ er, 40)) + oi | 0, D = (oi = ve) + $n | 0, it = me, Ve = me >>> 0 < ht >>> 0 ? D + 1 | 0 : D, me = q(qn ^ Je, Zn ^ yo, 48), D = (qn = ve) + Sn | 0, fn = _e = me + fn | 0, pn = Gt, Gt = D = _e >>> 0 < me >>> 0 ? D + 1 | 0 : D, D = q(_e ^ $e, pn ^ D, 1), Je = _e = ve, $e = D, D = Be + b | 0, D = ((ye = ye + Io | 0) >>> 0 < Io >>> 0 ? D + 1 | 0 : D) + _e | 0, D = Po + (ye = (_e = ye + $e | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D) | 0, Zn = Be = _e + ut | 0, Be = D = Be >>> 0 < ut >>> 0 ? D + 1 | 0 : D, _e = q(_e ^ we, ye ^ ao, 32), D = Nn + ($n = ve) | 0, Sn = _e, _e = (we = ct + _e | 0) ^ $e, $e = D = we >>> 0 < ct >>> 0 ? D + 1 | 0 : D, ye = q(_e, Je ^ D, 40), D = (D = Be) + (Be = ve) | 0, Je = _e = ye + Zn | 0, _e = q(ct = _e ^ Sn, $n ^ (Sn = _e >>> 0 < ye >>> 0 ? D + 1 | 0 : D), 48), D = $e + (ao = ve) | 0, Nn = _e, we = D = (_e = we + _e | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, ye = q(_e ^ ye, Be ^ D, 1), D = (ct = ve) + Ve | 0, D = ko + ((Be = ye + it | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D) | 0, D = ($e = (Be = Be + an | 0) >>> 0 < an >>> 0 ? D + 1 | 0 : D) + Fn | 0, Ir = Zn = Be + ur | 0, Zn = D = Zn >>> 0 < Be >>> 0 ? D + 1 | 0 : D, $n = ye, pn = Be, er = $e, ye = q(Ft ^ wn, _n ^ Pr, 1), D = (_n = ve) + lo | 0, D = Kn + (ye >>> 0 > (Be = ye + qr | 0) >>> 0 ? D + 1 | 0 : D) | 0, $e = D = (Be = Be + je | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, D = q(me ^ Be, D ^ qn, 32), qn = me = ve, je = D, D = Tt + Gn | 0, D = (me = mt + Kt | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D, mt = me, wn = D, D = qn + D | 0, Tt = me = me + je | 0, Ft = D = mt >>> 0 > me >>> 0 ? D + 1 | 0 : D, me = q(me ^ ye, _n ^ D, 40), D = $e + (Gn = ve) | 0, Kt = me, D = Gr + ((me = Be + me | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) | 0, D = (me = me + or | 0) >>> 0 < or >>> 0 ? D + 1 | 0 : D, _n = me, me ^= je, je = D, $e = q(me, qn ^ D, 48), D = q($e ^ pn, (D = er) ^ (er = ve), 32), Pr = me = ve, qn = D, Kn = me, me = q(Le ^ mt, wn ^ cr, 1), D = xo + (Be = ve) | 0, D = en + ((ye = me + so | 0) >>> 0 < so >>> 0 ? D + 1 | 0 : D) | 0, D = (Le = (ye = ye + Ge | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D) + Zt | 0, en = mt = ye + Ar | 0, mt = D = mt >>> 0 < ye >>> 0 ? D + 1 | 0 : D, Ge = me, wn = Be, me = (ye = q(ye ^ Hn, Le ^ $o, 32)) + fn | 0, D = (fn = ve) + Gt | 0, Be = me, Le = q(Le = me ^ Ge, (Ge = me >>> 0 < ye >>> 0 ? D + 1 | 0 : D) ^ wn, 40), D = (cr = ve) + mt | 0, mt = me = Le + en | 0, ye = q(me ^ ye, fn ^ (Gt = me >>> 0 < Le >>> 0 ? D + 1 | 0 : D), 48), D = Ge + (wn = ve) | 0, en = me = ye + Be | 0, fn = D = me >>> 0 < Be >>> 0 ? D + 1 | 0 : D, D = D + Kn | 0, Kn = D = (Ge = me + qn | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, Be = q(Ge ^ $n, D ^ ct, 40), D = (Hn = ve) + Zn | 0, Zn = me = Be + Ir | 0, $n = D = me >>> 0 < Be >>> 0 ? D + 1 | 0 : D, me = _e, ct = we, we = ye, _e = q(Ct ^ it, Ve ^ Rr, 48), D = St + (Ir = ve) | 0, Ct = _e, bt = D = (ye = bt + _e | 0) >>> 0 < bt >>> 0 ? D + 1 | 0 : D, D = q(ye ^ ht, oi ^ D, 1), St = _e = ve, ht = D, D = je + ei | 0, D = ((je = _n + zr | 0) >>> 0 < zr >>> 0 ? D + 1 | 0 : D) + _e | 0, je = D = (_e = je + ht | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, we = q(_e ^ we, D ^ wn, 32), D = (_n = ve) + ct | 0, ht = q((me = we + me | 0) ^ ht, St ^ (ct = me >>> 0 < we >>> 0 ? D + 1 | 0 : D), 40), D = je + (it = ve) | 0, D = Go + ((je = _e) >>> 0 > (_e = _e + ht | 0) >>> 0 ? D + 1 | 0 : D) | 0, wn = D = (je = _e + Wn | 0) >>> 0 < Wn >>> 0 ? D + 1 | 0 : D, _e = q(we ^ je, _n ^ D, 48), D = ct + (Rr = ve) | 0, _n = _e, St = D = (ct = me + _e | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = q(ct ^ ht, it ^ D, 1), D = (ht = ve) + $n | 0, D = Co + ((_e = me + Zn | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, D = ko + (we = (_e = _e + jt | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D) | 0, yo = it = _e + an | 0, it = D = it >>> 0 < an >>> 0 ? D + 1 | 0 : D, Ve = me, pn = _e, me = q(Le ^ en, fn ^ cr, 1), D = (Le = ve) + Sn | 0, D = ti + ((_e = me + Je | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, D = Xo + (en = (_e = _e + Tr | 0) >>> 0 < Tr >>> 0 ? D + 1 | 0 : D) | 0, Je = fn = _e + wt | 0, fn = D = fn >>> 0 < wt >>> 0 ? D + 1 | 0 : D, Sn = me, D = q(_e ^ Ct, en ^ Ir, 32), Ir = me = ve, _e = D, D = Ft + er | 0, Tt = me = $e + Tt | 0, Ct = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, D = Ir + D | 0, Ft = D = ($e = me + _e | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, Le = q($e ^ Sn, D ^ Le, 40), D = (er = ve) + fn | 0, en = me = Le + Je | 0, Sn = q(me ^ _e, Ir ^ (fn = me >>> 0 < Le >>> 0 ? D + 1 | 0 : D), 48), D = q(Sn ^ pn, (Ir = ve) ^ we, 32), cr = me = ve, Je = D, we = me, _e = no, me = q(Tt ^ Kt, Ct ^ Gn, 1), D = Gt + (Ct = ve) | 0, D = ((Tt = mt) >>> 0 > (mt = me + mt | 0) >>> 0 ? D + 1 | 0 : D) + co | 0, D = Co + (mt = (_e = _e + mt | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D) | 0, Tt = Gt = _e + jt | 0, Gt = D = Gt >>> 0 < jt >>> 0 ? D + 1 | 0 : D, _e = q(_e ^ Nn, mt ^ ao, 32), D = bt + (Kt = ve) | 0, bt = _e, D = (_e = ye + _e | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = Ct, Ct = D, ye = q(me ^ _e, ye ^ D, 40), D = (Gn = ve) + Gt | 0, mt = me = ye + Tt | 0, me = q(me ^ bt, Kt ^ (Gt = me >>> 0 < ye >>> 0 ? D + 1 | 0 : D), 48), D = Ct + (pn = ve) | 0, Ct = me, Tt = me = _e + me | 0, Kt = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, D = D + we | 0, D = (bt = me + Je | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = bt ^ Ve, Ve = D, ht = q(me, D ^ ht, 40), D = (ao = ve) + it | 0, it = me = ht + yo | 0, Nn = me >>> 0 < ht >>> 0 ? D + 1 | 0 : D, me = q(qn ^ Zn, $n ^ Pr, 48), D = Kn + (Pr = ve) | 0, qn = me, D = (me = Ge + me | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, Ge = me, Kn = D, D = q(me ^ Be, D ^ Hn, 1), Hn = me = ve, we = D, D = fn + Po | 0, D = ((_e = en + ut | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D) + me | 0, D = Go + (_e = (me = _e + we | 0) >>> 0 < _e >>> 0 ? D + 1 | 0 : D) | 0, en = Be = me + Wn | 0, Be = D = Be >>> 0 < Wn >>> 0 ? D + 1 | 0 : D, me = q(me ^ Ct, _e ^ pn, 32), D = St + (fn = ve) | 0, Ct = me, ct = D = (_e = ct + me | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, we = q(_e ^ we, Hn ^ D, 40), D = (Hn = ve) + Be | 0, en = me = we + en | 0, me = q(Be = me ^ Ct, fn ^ (Ct = me >>> 0 < we >>> 0 ? D + 1 | 0 : D), 48), D = ct + (yo = ve) | 0, ct = me, St = D = (Be = _e + me | 0) >>> 0 < _e >>> 0 ? D + 1 | 0 : D, me = q(Be ^ we, Hn ^ D, 1), D = (fn = ve) + Nn | 0, D = xo + ((_e = me + it | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, D = (we = (_e = _e + so | 0) >>> 0 < so >>> 0 ? D + 1 | 0 : D) + lo | 0, $o = Hn = _e + qr | 0, Hn = D = Hn >>> 0 < _e >>> 0 ? D + 1 | 0 : D, Zn = me, $n = _e, pn = we, me = q(ye ^ Tt, Gn ^ Kt, 1), D = ti + (we = ve) | 0, D = wn + ((_e = me + Tr | 0) >>> 0 < Tr >>> 0 ? D + 1 | 0 : D) | 0, D = ei + (ye = (_e = _e + je | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D) | 0, Kt = je = _e + zr | 0, je = D = je >>> 0 < zr >>> 0 ? D + 1 | 0 : D, wn = me, Tt = we, D = q(_e ^ qn, ye ^ Pr, 32), qn = me = ve, ye = D, _e = me, D = Ft + Ir | 0, D = (me = $e + Sn | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D, $e = me, Ft = D, D = D + _e | 0, D = (we = me + ye | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = we ^ wn, wn = D, me = q(me, D ^ Tt, 40), D = (D = je) + (je = ve) | 0, Tt = _e = me + Kt | 0, Kt = D = _e >>> 0 < me >>> 0 ? D + 1 | 0 : D, qn = q(_e ^ ye, qn ^ D, 48), D = q(qn ^ $n, (D = pn) ^ (pn = ve), 32), Gn = _e = ve, Sn = D, _e = q($e ^ Le, Ft ^ er, 1), D = ($e = ve) + co | 0, D = Gt + ((ye = _e + no | 0) >>> 0 < _e >>> 0 ? D + 1 | 0 : D) | 0, D = b + (Le = (ye = ye + mt | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D) | 0, er = mt = ye + Io | 0, mt = D = mt >>> 0 < Io >>> 0 ? D + 1 | 0 : D, Gt = _e, Ft = $e, ye = q(ye ^ _n, Le ^ Rr, 32), D = (_n = ve) + Kn | 0, $e = _e = ye + Ge | 0, _e = (Le = q(_e ^ Gt, (Ge = _e >>> 0 < ye >>> 0 ? D + 1 | 0 : D) ^ Ft, 40)) + er | 0, D = (er = ve) + mt | 0, Gt = _e, _e = q(_e ^ ye, _n ^ (Ft = _e >>> 0 < Le >>> 0 ? D + 1 | 0 : D), 48), D = Ge + (Ir = ve) | 0, _n = _e, Kn = _e = $e + _e | 0, $n = D = _e >>> 0 < $e >>> 0 ? D + 1 | 0 : D, D = Gn + D | 0, D = (ye = _e + Sn | 0) >>> 0 < _e >>> 0 ? D + 1 | 0 : D, _e = fn, fn = D, $e = q(ye ^ Zn, _e ^ D, 40), D = (Pr = ve) + Hn | 0, mt = _e = $e + $o | 0, D = q(_e ^ Sn, Gn ^ (Hn = _e >>> 0 < $e >>> 0 ? D + 1 | 0 : D), 48), Gn = _e = ve, Sn = D, _e = me, D = wn + pn | 0, wn = me = we + qn | 0, qn = D = me >>> 0 < we >>> 0 ? D + 1 | 0 : D, D = q(me ^ _e, D ^ je, 1), we = _e = ve, me = D, D = Ft + U | 0, D = ((Ge = Gt + _ | 0) >>> 0 < _ >>> 0 ? D + 1 | 0 : D) + _e | 0, D = Gr + (Ge = (_e = me + Ge | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D) | 0, pn = je = _e + or | 0, je = D = je >>> 0 < or >>> 0 ? D + 1 | 0 : D, Gt = me, Ft = we, me = q(it ^ Je, Nn ^ cr, 48), D = Ve + (cr = ve) | 0, it = me, D = (me = bt + me | 0) >>> 0 < bt >>> 0 ? D + 1 | 0 : D, bt = me, _e = q(_e ^ ct, Ge ^ yo, 32), Ve = D, D = D + (Je = ve) | 0, we = me = _e + me | 0, Ge = q(me ^ Gt, (ct = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D) ^ Ft, 40), D = (Nn = ve) + je | 0, je = me = Ge + pn | 0, me = q(me ^ _e, Je ^ (Gt = me >>> 0 < Ge >>> 0 ? D + 1 | 0 : D), 48), D = ct + (Rr = ve) | 0, Ft = me, Je = D = (ct = we + me | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, me = q(Ge ^ ct, Nn ^ D, 1), D = Go + (pn = ve) | 0, Nn = me, yo = me = Wn + me | 0, we = D = me >>> 0 < Wn >>> 0 ? D + 1 | 0 : D, me = q(ht ^ bt, Ve ^ ao, 1), D = (Ge = ve) + Kt | 0, D = Xo + ((_e = me + Tt | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, D = Fn + (bt = (_e = _e + wt | 0) >>> 0 < wt >>> 0 ? D + 1 | 0 : D) | 0, Ve = ht = _e + ur | 0, ht = D = ht >>> 0 < ur >>> 0 ? D + 1 | 0 : D, Tt = Ge, _e = q(_e ^ _n, bt ^ Ir, 32), D = St + (Ir = ve) | 0, Kt = _e, D = (Ge = Be + _e | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D, Be = Tt, Tt = D, bt = q(me ^ Ge, Be ^ D, 40), D = (ao = ve) + ht | 0, _n = me = bt + Ve | 0, D = (St = me >>> 0 < bt >>> 0 ? D + 1 | 0 : D) + we | 0, ht = D = (we = me + yo | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, Ve = D = q(we ^ Sn, D ^ Gn, 32), Zn = me = ve, me = q(Le ^ Kn, $n ^ er, 1), D = (Be = ve) + Ct | 0, D = Cr + ((_e = me + en | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, D = (Le = (_e = g + _e | 0) >>> 0 < g >>> 0 ? D + 1 | 0 : D) + Zt | 0, $n = Ct = _e + Ar | 0, Ct = D = Ct >>> 0 < _e >>> 0 ? D + 1 | 0 : D, en = me, Kn = Be, _e = q(_e ^ it, Le ^ cr, 32), D = (it = ve) + qn | 0, Be = me = _e + wn | 0, me = (Le = q(me ^ en, (wn = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D) ^ Kn, 40)) + $n | 0, D = ($n = ve) + Ct | 0, Ct = me, me = q(me ^ _e, it ^ (en = me >>> 0 < Le >>> 0 ? D + 1 | 0 : D), 48), D = wn + (cr = ve) | 0, wn = me, it = D = (me = Be + me | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D, D = D + Zn | 0, qn = D = (Be = me) >>> 0 > (me = me + Ve | 0) >>> 0 ? D + 1 | 0 : D, _e = q(me ^ Nn, pn ^ D, 40), D = ht + (pn = ve) | 0, Kn = _e, D = U + ((_e = we + _e | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D) | 0, Nn = _e = _e + _ | 0, we = _e ^ Ve, Ve = D = _e >>> 0 < _ >>> 0 ? D + 1 | 0 : D, _e = q(we, Zn ^ D, 48), D = qn + (Zn = ve) | 0, qn = D = (ht = me + _e | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = D = q(ht ^ Kn, pn ^ D, 1), Kn = we = ve, we = q(Be ^ Le, it ^ $n, 1), D = Gt + (Le = ve) | 0, D = Xo + ((Be = we + je | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D) | 0, D = Co + (je = (Be = Be + wt | 0) >>> 0 < wt >>> 0 ? D + 1 | 0 : D) | 0, pn = Gt = Be + jt | 0, Gt = D = Gt >>> 0 < jt >>> 0 ? D + 1 | 0 : D, it = we, $n = Le, D = fn + Gn | 0, D = (we = ye + Sn | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D, fn = we, Kt = q(_n ^ Kt, St ^ Ir, 48), Le = q(Be ^ Kt, je ^ (Ir = ve), 32), _n = D, D = D + (yo = ve) | 0, je = we = Le + we | 0, we = q(we ^ it, (St = we >>> 0 < Le >>> 0 ? D + 1 | 0 : D) ^ $n, 40), D = (it = ve) + Gt | 0, $n = D = (ye = we + pn | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, D = D + Kn | 0, D = b + ((Sn = ye) >>> 0 > (ye = me + ye | 0) >>> 0 ? D + 1 | 0 : D) | 0, D = (Be = (ye = ye + Io | 0) >>> 0 < Io >>> 0 ? D + 1 | 0 : D) + co | 0, $o = Gt = ye + no | 0, pn = D = Gt >>> 0 < ye >>> 0 ? D + 1 | 0 : D, er = me, Gn = ye, D = q($e ^ fn, _n ^ Pr, 1), $e = ye = ve, me = D, D = en + ti | 0, D = ((Gt = Ct + Tr | 0) >>> 0 < Tr >>> 0 ? D + 1 | 0 : D) + ye | 0, D = Gr + (Gt = (ye = me + Gt | 0) >>> 0 < Gt >>> 0 ? D + 1 | 0 : D) | 0, _n = Ct = ye + or | 0, Ct = D = Ct >>> 0 < or >>> 0 ? D + 1 | 0 : D, en = me, D = q(ye ^ Ft, Gt ^ Rr, 32), fn = me = ve, ye = D, Gt = me, D = Tt + Ir | 0, Tt = me = Ge + Kt | 0, Ft = D = me >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, D = D + Gt | 0, D = (Ge = me + ye | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = Ge ^ en, en = D, Gt = q(me, D ^ $e, 40), D = (Ir = ve) + Ct | 0, Kt = q(Ct = (me = Gt + _n | 0) ^ ye, fn ^ (ye = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D), 48), D = q(D = Kt ^ Gn, (Gn = ve) ^ Be, 32), Pr = Be = ve, _n = D, Ct = Be, Be = q(bt ^ Tt, Ft ^ ao, 1), D = Fn + (bt = ve) | 0, D = Hn + (($e = Be + ur | 0) >>> 0 < ur >>> 0 ? D + 1 | 0 : D) | 0, D = xo + (mt = ($e = $e + mt | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D) | 0, Ft = Tt = $e + so | 0, Tt = D = Tt >>> 0 < so >>> 0 ? D + 1 | 0 : D, $e = q($e ^ wn, mt ^ cr, 32), D = Je + (fn = ve) | 0, wn = $e, ct = D = ($e = ct + $e | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, mt = q(Be ^ $e, D ^ bt, 40), D = (cr = ve) + Tt | 0, bt = Be = mt + Ft | 0, Be = q(Tt = Be ^ wn, fn ^ (wn = Be >>> 0 < mt >>> 0 ? D + 1 | 0 : D), 48), D = ct + (Rr = ve) | 0, Tt = Be, Ft = Be = $e + Be | 0, fn = D = Be >>> 0 < $e >>> 0 ? D + 1 | 0 : D, D = D + Ct | 0, D = ($e = Be + _n | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D, Be = Kn, Kn = D, ct = q($e ^ er, Be ^ D, 40), D = (Hn = ve) + pn | 0, Ct = Be = ct + $o | 0, Be = q(pn = Be ^ _n, Pr ^ (_n = Be >>> 0 < ct >>> 0 ? D + 1 | 0 : D), 48), D = Kn + (Pr = ve) | 0, Kn = Be, $e = D = (Be = $e + Be | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Hn = D = q(Be ^ ct, Hn ^ D, 1), ao = D, Je = ct = ve, ct = ye, ye = we, we = q(Le ^ Sn, $n ^ yo, 48), D = St + (yo = ve) | 0, St = we, D = (we = je + we | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, je = me, me = ye ^ we, ye = D, me = q(me, D ^ it, 1), D = (it = ve) + ct | 0, D = ei + (me >>> 0 > (Le = je + me | 0) >>> 0 ? D + 1 | 0 : D) | 0, D = lo + (je = (Le = Le + zr | 0) >>> 0 < zr >>> 0 ? D + 1 | 0 : D) | 0, Sn = ct = Le + qr | 0, ct = D = ct >>> 0 < qr >>> 0 ? D + 1 | 0 : D, Le = q(Le ^ Tt, je ^ Rr, 32), D = qn + ($n = ve) | 0, Tt = D = (je = Le + ht | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, ht = q(me ^ je, it ^ D, 40), D = (Rr = ve) + ct | 0, it = me = ht + Sn | 0, Le = q(me ^ Le, $n ^ (qn = me >>> 0 < ht >>> 0 ? D + 1 | 0 : D), 48), D = Tt + (Sn = ve) | 0, $n = me = Le + je | 0, Tt = me, pn = D = me >>> 0 < je >>> 0 ? D + 1 | 0 : D, je = we, ct = ye, D = en + Gn | 0, D = (me = Ge + Kt | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, Ge = me, me ^= Gt, Gt = D, D = q(me, Ir ^ D, 1), er = me = ve, en = D, ye = D, D = wn + Zt | 0, D = ((we = bt + Ar | 0) >>> 0 < Ar >>> 0 ? D + 1 | 0 : D) + me | 0, bt = D = (me = we) >>> 0 > (we = ye + we | 0) >>> 0 ? D + 1 | 0 : D, ye = q(_e ^ we, D ^ Zn, 32), D = (D = ct) + (ct = ve) | 0, Kt = me = ye + je | 0, _e = q(_e = me ^ en, er ^ (en = me >>> 0 < ye >>> 0 ? D + 1 | 0 : D), 40), D = bt + (Zn = ve) | 0, D = Po + ((me = _e + we | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D) | 0, er = D = (je = me + ut | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D, ct = q(ye ^ je, ct ^ D, 48), $o = D = ve, me = q(mt ^ Ft, fn ^ cr, 1), D = (ye = ve) + Ve | 0, D = ko + ((we = me + Nn | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D) | 0, D = Cr + (mt = (we = we + an | 0) >>> 0 < an >>> 0 ? D + 1 | 0 : D) | 0, Ve = bt = g + we | 0, Ft = D = bt >>> 0 < g >>> 0 ? D + 1 | 0 : D, fn = me, bt = q(we ^ St, mt ^ yo, 32), D = (cr = ve) + Gt | 0, Gt = me = bt + Ge | 0, we = q(me ^ fn, (St = me >>> 0 < bt >>> 0 ? D + 1 | 0 : D) ^ ye, 40), D = (D = Ft) + (Ft = ve) | 0, fn = me = we + Ve | 0, Ve = D = me >>> 0 < we >>> 0 ? D + 1 | 0 : D, ye = D, D = Cr + Je | 0, D = ((mt = g + Hn | 0) >>> 0 < g >>> 0 ? D + 1 | 0 : D) + ye | 0, wn = D = (ye = me + mt | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D, me = q(ye ^ ct, $o ^ D, 32), D = (Hn = ve) + pn | 0, Ge = q((mt = me + Tt | 0) ^ ao, (D = mt >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ Je, 40), Je = D, D = lo + (Tt = ve) | 0, D = wn + ((Nn = Ge + qr | 0) >>> 0 < qr >>> 0 ? D + 1 | 0 : D) | 0, D = (wn = ye + Nn | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = Hn, Hn = D, ye = q(me ^ wn, ye ^ D, 48), D = (D = Je) + (Je = ve) | 0, me = Ge ^ (mt = ye + mt | 0), Ge = D = mt >>> 0 < ye >>> 0 ? D + 1 | 0 : D, Nn = D = q(me, D ^ Tt, 1), ao = D, Gn = me = ve, Tt = Be, Ir = $e, Be = we, we = q(bt ^ fn, Ve ^ cr, 48), D = St + (fn = ve) | 0, bt = me = we + Gt | 0, Gt = D = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ Ft, 1), D = (Ve = ve) + ei | 0, D = er + ((me = Be + zr | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) | 0, je = D = ($e = me + je | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, me = q($e ^ Le, D ^ Sn, 32), D = (Ft = ve) + Ir | 0, Tt = Le = me + Tt | 0, St = D = Le >>> 0 < me >>> 0 ? D + 1 | 0 : D, Be = q(Be ^ Le, D ^ Ve, 40), D = Co + (yo = ve) | 0, Ve = Be, D = je + ((Be = jt + Be | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D) | 0, $e = D = (Be = Be + $e | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Le = q(me ^ Be, D ^ Ft, 48), D = (D = St) + (St = ve) | 0, Sn = me = Le + Tt | 0, Ft = me, er = D = me >>> 0 < Le >>> 0 ? D + 1 | 0 : D, D = en + $o | 0, Tt = (me = ct + Kt | 0) ^ _e, _e = D = me >>> 0 < ct >>> 0 ? D + 1 | 0 : D, D = q(Tt, D ^ Zn, 1), Zn = je = ve, Tt = D, D = qn + Gr | 0, D = ((ct = it + or | 0) >>> 0 < or >>> 0 ? D + 1 | 0 : D) + je | 0, en = D = (en = ct) >>> 0 > (ct = ct + Tt | 0) >>> 0 ? D + 1 | 0 : D, Kt = je = q(ct ^ Kn, Pr ^ D, 32), it = D = ve, D = D + Gt | 0, qn = je = je + bt | 0, Kn = D = Kt >>> 0 > je >>> 0 ? D + 1 | 0 : D, je = q(je ^ Tt, Zn ^ D, 40), D = co + (Zn = ve) | 0, D = en + ((bt = je + no | 0) >>> 0 < no >>> 0 ? D + 1 | 0 : D) | 0, bt = D = (Tt = ct) >>> 0 > (ct = ct + bt | 0) >>> 0 ? D + 1 | 0 : D, Tt = q(ct ^ Kt, D ^ it, 48), Pr = D = ve, Gt = D, ht = q(ht ^ $n, pn ^ Rr, 1), en = D = ve, Kt = we, D = D + Zt | 0, D = _n + ((we = ht + Ar | 0) >>> 0 < Ar >>> 0 ? D + 1 | 0 : D) | 0, D = (we = we + Ct | 0) >>> 0 < Ct >>> 0 ? D + 1 | 0 : D, Ct = we ^ Kt, Kt = D, Ct = q(Ct, D ^ fn, 32), D = (Rr = ve) + _e | 0, _n = me = Ct + me | 0, _e = q(me ^ ht, (_e = en) ^ (en = me >>> 0 < Ct >>> 0 ? D + 1 | 0 : D), 40), D = ko + (it = ve) | 0, D = Kt + ((me = _e + an | 0) >>> 0 < an >>> 0 ? D + 1 | 0 : D) | 0, Kt = me = me + we | 0, fn = D = me >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = D, D = Gn + Xo | 0, D = ((ht = Nn + wt | 0) >>> 0 < wt >>> 0 ? D + 1 | 0 : D) + we | 0, Nn = D = (we = me + ht | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, me = q(we ^ Tt, D ^ Gt, 32), D = ($n = ve) + er | 0, Gt = q((ht = me + Ft | 0) ^ ao, (D = ht >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ Gn, 40), pn = Ft = ve, Gn = D, D = Ft + xo | 0, D = Nn + ((Ft = Gt + so | 0) >>> 0 < so >>> 0 ? D + 1 | 0 : D) | 0, Nn = D = (Ft = we + Ft | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = q(me ^ Ft, D ^ $n, 48), D = ($n = ve) + Gn | 0, me = (ht = we + ht | 0) ^ Gt, Gt = D = ht >>> 0 < we >>> 0 ? D + 1 | 0 : D, pn = D = q(me, D ^ pn, 1), Gn = me = ve, Ir = mt, cr = Le, Le = _e, _e = q(Ct ^ Kt, fn ^ Rr, 48), D = (Ct = ve) + en | 0, en = me = _e + _n | 0, Kt = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, Le = q(me ^ Le, D ^ it, 1), D = (it = ve) + Go | 0, D = ((me = Le + Wn | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D) + bt | 0, ct = D = (mt = me + ct | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = q(mt ^ cr, D ^ St, 32), D = (bt = ve) + Ge | 0, _n = Ge = me + Ir | 0, St = D = Ge >>> 0 < me >>> 0 ? D + 1 | 0 : D, Le = q(Le ^ Ge, D ^ it, 40), D = b + (cr = ve) | 0, it = Le, D = ct + ((Le = Io + Le | 0) >>> 0 < Io >>> 0 ? D + 1 | 0 : D) | 0, fn = D = (Ge = Le + mt | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D, Le = q(me ^ Ge, D ^ bt, 48), D = (D = St) + (St = ve) | 0, _n = me = Le + _n | 0, Ir = D = me >>> 0 < Le >>> 0 ? D + 1 | 0 : D, ct = ye, mt = Be, D = Kn + Pr | 0, ye = D = (me = Tt + qn | 0) >>> 0 < Tt >>> 0 ? D + 1 | 0 : D, Be = q(me ^ je, D ^ Zn, 1), D = (je = ve) + Fn | 0, D = ((bt = Be + ur | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) + $e | 0, $e = q(ct ^ (mt = mt + bt | 0), (D = mt >>> 0 < bt >>> 0 ? D + 1 | 0 : D) ^ Je, 32), bt = D, Tt = Be, D = (ct = ve) + Kt | 0, D = (Be = $e + en | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D, en = Be, Be ^= Tt, Tt = D, Be = q(Be, D ^ je, 40), D = U + (Kt = ve) | 0, D = ((je = Be + _ | 0) >>> 0 < _ >>> 0 ? D + 1 | 0 : D) + bt | 0, qn = D = (bt = je) >>> 0 > (je = je + mt | 0) >>> 0 ? D + 1 | 0 : D, ct = q($e ^ je, D ^ ct, 48), Pr = D = ve, mt = D, $e = q(Sn ^ Ve, er ^ yo, 1), Kn = D = ve, Ve = ye, D = D + Po | 0, D = Hn + ((ye = $e + ut | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D) | 0, bt = Ct, Ct = D = (ye = ye + wn | 0) >>> 0 < wn >>> 0 ? D + 1 | 0 : D, bt = q(_e ^ ye, bt ^ D, 32), D = (Rr = ve) + Ve | 0, wn = me = bt + me | 0, _e = q(me ^ $e, (_e = Kn) ^ (Kn = me >>> 0 < bt >>> 0 ? D + 1 | 0 : D), 40), D = ti + (Ve = ve) | 0, D = Ct + ((me = _e + Tr | 0) >>> 0 < Tr >>> 0 ? D + 1 | 0 : D) | 0, Hn = me = me + ye | 0, Sn = D = me >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = D, D = Gn + Gr | 0, D = (($e = or + pn | 0) >>> 0 < or >>> 0 ? D + 1 | 0 : D) + ye | 0, Ct = D = (ye = me + $e | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D, me = q(ye ^ ct, D ^ mt, 32), D = (Je = ve) + Ir | 0, mt = q(($e = me + _n | 0) ^ pn, (D = $e >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ Gn, 40), pn = D, D = Zt + (Zn = ve) | 0, D = Ct + ((er = mt + Ar | 0) >>> 0 < Ar >>> 0 ? D + 1 | 0 : D) | 0, D = (Ct = ye + er | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = Je, Je = D, ye = q(me ^ Ct, ye ^ D, 48), D = (D = pn) + (pn = ve) | 0, me = ($e = ye + $e | 0) ^ mt, mt = D = $e >>> 0 < ye >>> 0 ? D + 1 | 0 : D, Zn = D = q(me, D ^ Zn, 1), er = me = ve, Gn = Le, Le = _e, _e = q(bt ^ Hn, Sn ^ Rr, 48), D = (D = Kn) + (Kn = ve) | 0, wn = me = _e + wn | 0, bt = Ve, Ve = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, Le = q(me ^ Le, bt ^ D, 1), D = (Hn = ve) + xo | 0, D = qn + ((me = Le + so | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D) | 0, bt = je, je = me + je | 0, me = St, St = D = bt >>> 0 > je >>> 0 ? D + 1 | 0 : D, me = q(je ^ Gn, me ^ D, 32), D = (D = Gt) + (Gt = ve) | 0, qn = D = (bt = me + ht | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, ht = bt, Le = q(Le ^ bt, D ^ Hn, 40), D = Po + (Rr = ve) | 0, Hn = Le, D = St + ((Le = ut + Le | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D) | 0, St = D = (bt = Le + je | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, Le = q(me ^ bt, D ^ Gt, 48), D = (D = qn) + (qn = ve) | 0, Sn = me = Le + ht | 0, Gn = D = me >>> 0 < Le >>> 0 ? D + 1 | 0 : D, ht = we, D = Tt + Pr | 0, we = D = (me = ct + en | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ Kt, 1), D = lo + (ct = ve) | 0, D = fn + ((je = Be + qr | 0) >>> 0 < qr >>> 0 ? D + 1 | 0 : D) | 0, Tt = (je = Ge + je | 0) ^ ht, ht = D = je >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, Ge = q(Tt, D ^ $n, 32), Gt = D = ve, Tt = Be, D = D + Ve | 0, D = (Be = Ge + wn | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, en = Be, Be ^= Tt, Tt = D, Be = q(Be, D ^ ct, 40), D = U + (Kt = ve) | 0, D = ht + ((ct = Be + _ | 0) >>> 0 < _ >>> 0 ? D + 1 | 0 : D) | 0, fn = D = (ct = je + ct | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, ht = q(Ge ^ ct, D ^ Gt, 48), Pr = D = ve, je = D, Ge = q(it ^ _n, cr ^ Ir, 1), wn = D = ve, _n = we, D = D + b | 0, D = Nn + ((we = Ge + Io | 0) >>> 0 < Io >>> 0 ? D + 1 | 0 : D) | 0, Ft = D = (we = we + Ft | 0) >>> 0 < Ft >>> 0 ? D + 1 | 0 : D, Gt = q(_e ^ we, D ^ Kn, 32), D = (ao = ve) + _n | 0, _n = me = Gt + me | 0, _e = q(me ^ Ge, (it = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D) ^ wn, 40), D = Cr + (Kn = ve) | 0, D = Ft + ((me = g + _e | 0) >>> 0 < g >>> 0 ? D + 1 | 0 : D) | 0, Ft = me = me + we | 0, Ve = D = me >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = D, D = er + ko | 0, D = ((Ge = Zn + an | 0) >>> 0 < an >>> 0 ? D + 1 | 0 : D) + we | 0, wn = D = (we = me + Ge | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, me = q(we ^ ht, D ^ je, 32), D = (Nn = ve) + Gn | 0, je = q((Ge = me + Sn | 0) ^ Zn, (D = Ge >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ er, 40), $n = D, D = ei + (Zn = ve) | 0, D = wn + ((er = je + zr | 0) >>> 0 < zr >>> 0 ? D + 1 | 0 : D) | 0, D = (wn = we + er | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = Nn, Nn = D, we = q(me ^ wn, we ^ D, 48), D = (D = $n) + ($n = ve) | 0, me = (Ge = we + Ge | 0) ^ je, je = D = Ge >>> 0 < we >>> 0 ? D + 1 | 0 : D, Zn = D = q(me, D ^ Zn, 1), yo = D, er = me = ve, Ir = $e, cr = Le, $e = _e, _e = q(Gt ^ Ft, Ve ^ ao, 48), D = (Gt = ve) + it | 0, Ft = me = _e + _n | 0, _n = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, $e = q(me ^ $e, D ^ Kn, 1), D = (Kn = ve) + co | 0, D = fn + ((me = $e + no | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, ct = D = (Le = me + ct | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, me = q(Le ^ cr, D ^ qn, 32), D = (it = ve) + mt | 0, qn = D = (mt = me + Ir | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, $e = q($e ^ mt, D ^ Kn, 40), D = Go + (ao = ve) | 0, fn = $e, D = ct + (($e = Wn + $e | 0) >>> 0 < Wn >>> 0 ? D + 1 | 0 : D) | 0, ct = $e + Le | 0, $e = it, it = D = ct >>> 0 < Le >>> 0 ? D + 1 | 0 : D, $e = q(me ^ ct, $e ^ D, 48), D = (D = qn) + (qn = ve) | 0, Kn = me = $e + mt | 0, Ve = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Le = ye, D = Tt + Pr | 0, ye = D = (me = ht + en | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ Kt, 1), D = (ht = ve) + ti | 0, D = St + ((mt = Be + Tr | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) | 0, Le = q(Le ^ (mt = mt + bt | 0), (D = mt >>> 0 < bt >>> 0 ? D + 1 | 0 : D) ^ pn, 32), Tt = bt = ve, bt = D, en = Be, D = Tt + _n | 0, D = (Be = Le + Ft | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, Ft = Be, Be ^= en, en = D, Be = q(Be, D ^ ht, 40), D = Co + (Kt = ve) | 0, D = ((ht = Be + jt | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D) + bt | 0, St = Tt, Tt = D = (bt = mt + ht | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, ht = q(Le ^ bt, St ^ D, 48), Pr = D = ve, mt = D, Le = q(Sn ^ Hn, Gn ^ Rr, 1), _n = D = ve, St = ye, D = D + Fn | 0, D = Je + ((ye = Le + ur | 0) >>> 0 < ur >>> 0 ? D + 1 | 0 : D) | 0, Ct = D = (ye = ye + Ct | 0) >>> 0 < Ct >>> 0 ? D + 1 | 0 : D, Gt = q(_e ^ ye, D ^ Gt, 32), D = (Rr = ve) + St | 0, St = me = Gt + me | 0, _e = q(me ^ Le, (_e = _n) ^ (_n = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D), 40), D = Xo + (Hn = ve) | 0, D = Ct + ((me = _e + wt | 0) >>> 0 < wt >>> 0 ? D + 1 | 0 : D) | 0, Sn = me = me + ye | 0, Je = D = me >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = D, D = er + U | 0, D = ((Le = Zn + _ | 0) >>> 0 < _ >>> 0 ? D + 1 | 0 : D) + ye | 0, Ct = D = (ye = me + Le | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, me = q(ye ^ ht, D ^ mt, 32), D = (Zn = ve) + Ve | 0, mt = q((Le = me + Kn | 0) ^ yo, (D = Le >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ er, 40), er = D, D = xo + (pn = ve) | 0, D = Ct + ((Gn = mt + so | 0) >>> 0 < so >>> 0 ? D + 1 | 0 : D) | 0, D = (Ct = ye + Gn | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = Zn, Zn = D, ye = q(me ^ Ct, ye ^ D, 48), D = (D = er) + (er = ve) | 0, me = (Le = ye + Le | 0) ^ mt, mt = D = Le >>> 0 < ye >>> 0 ? D + 1 | 0 : D, pn = D = q(me, D ^ pn, 1), Gn = me = ve, Ir = Ge, cr = $e, $e = _e, _e = q(Gt ^ Sn, Je ^ Rr, 48), D = (Gt = ve) + _n | 0, _n = me = _e + St | 0, St = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, $e = q(me ^ $e, D ^ Hn, 1), D = (Hn = ve) + Go | 0, D = Tt + ((me = $e + Wn | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, bt = D = (Ge = me + bt | 0) >>> 0 < bt >>> 0 ? D + 1 | 0 : D, me = q(Ge ^ cr, D ^ qn, 32), D = (Tt = ve) + je | 0, qn = D = (je = me + Ir | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, $e = q($e ^ je, D ^ Hn, 40), D = Fn + (Rr = ve) | 0, Hn = $e, D = bt + (($e = ur + $e | 0) >>> 0 < ur >>> 0 ? D + 1 | 0 : D) | 0, bt = $e + Ge | 0, $e = Tt, Tt = D = bt >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, $e = q(me ^ bt, $e ^ D, 48), D = (D = qn) + (qn = ve) | 0, Sn = me = $e + je | 0, Je = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Ge = we, D = en + Pr | 0, we = D = (me = ht + Ft | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ Kt, 1), D = Xo + (ht = ve) | 0, D = it + ((je = Be + wt | 0) >>> 0 < wt >>> 0 ? D + 1 | 0 : D) | 0, ct = D = (je = je + ct | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, Ge = q(Ge ^ je, D ^ $n, 32), Ft = D = ve, en = Be, D = D + St | 0, D = (Be = Ge + _n | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, Kt = Be, Be ^= en, en = D, Be = q(Be, D ^ ht, 40), D = ko + (_n = ve) | 0, D = ct + ((ht = Be + an | 0) >>> 0 < an >>> 0 ? D + 1 | 0 : D) | 0, D = (ct = je + ht | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, je = Ft, Ft = D, ht = q(Ge ^ ct, je ^ D, 48), Pr = D = ve, je = D, Ge = q(fn ^ Kn, Ve ^ ao, 1), St = D = ve, it = we, D = D + Cr | 0, D = Nn + ((we = g + Ge | 0) >>> 0 < g >>> 0 ? D + 1 | 0 : D) | 0, wn = D = (we = we + wn | 0) >>> 0 < wn >>> 0 ? D + 1 | 0 : D, Gt = q(_e ^ we, D ^ Gt, 32), D = (ao = ve) + it | 0, it = me = Gt + me | 0, _e = q(me ^ Ge, (_e = St) ^ (St = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D), 40), D = Po + (fn = ve) | 0, D = wn + ((me = _e + ut | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D) | 0, Kn = me = me + we | 0, Ve = D = me >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = D, D = Gn + lo | 0, D = ((Ge = pn + qr | 0) >>> 0 < qr >>> 0 ? D + 1 | 0 : D) + we | 0, wn = D = (we = me + Ge | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, me = q(we ^ ht, D ^ je, 32), D = (Nn = ve) + Je | 0, je = q((Ge = me + Sn | 0) ^ pn, (D = Ge >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ Gn, 40), pn = D, D = b + ($n = ve) | 0, D = wn + ((Gn = je + Io | 0) >>> 0 < Io >>> 0 ? D + 1 | 0 : D) | 0, D = (wn = we + Gn | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = Nn, Nn = D, we = q(me ^ wn, we ^ D, 48), D = (D = pn) + (pn = ve) | 0, me = (Ge = we + Ge | 0) ^ je, je = D = Ge >>> 0 < we >>> 0 ? D + 1 | 0 : D, $n = D = q(me, D ^ $n, 1), Gn = me = ve, Ir = Le, cr = $e, $e = _e, _e = q(Gt ^ Kn, Ve ^ ao, 48), D = (Gt = ve) + St | 0, St = me = _e + it | 0, it = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, $e = q(me ^ $e, D ^ fn, 1), D = (fn = ve) + Gr | 0, D = Ft + ((me = $e + or | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, ct = D = (Le = me + ct | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, me = q(Le ^ cr, D ^ qn, 32), D = (Ft = ve) + mt | 0, qn = D = (mt = me + Ir | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, $e = q($e ^ mt, D ^ fn, 40), D = ti + (ao = ve) | 0, fn = $e, D = ct + (($e = Tr + $e | 0) >>> 0 < Tr >>> 0 ? D + 1 | 0 : D) | 0, ct = $e + Le | 0, $e = Ft, Ft = D = ct >>> 0 < Le >>> 0 ? D + 1 | 0 : D, $e = q(me ^ ct, $e ^ D, 48), D = (D = qn) + (qn = ve) | 0, Kn = me = $e + mt | 0, Ve = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Le = ye, D = en + Pr | 0, ye = D = (me = ht + Kt | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ _n, 1), D = (ht = ve) + Co | 0, D = Tt + ((mt = Be + jt | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) | 0, bt = D = (mt = mt + bt | 0) >>> 0 < bt >>> 0 ? D + 1 | 0 : D, Le = q(Le ^ mt, D ^ er, 32), Tt = D = ve, en = Be, D = D + it | 0, D = (Be = Le + St | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, Kt = Be, Be ^= en, en = D, Be = q(Be, D ^ ht, 40), D = co + (_n = ve) | 0, D = bt + ((ht = Be + no | 0) >>> 0 < no >>> 0 ? D + 1 | 0 : D) | 0, St = Tt, Tt = D = (bt = mt + ht | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D, ht = q(Le ^ bt, St ^ D, 48), Pr = D = ve, mt = D, Le = q(Sn ^ Hn, Je ^ Rr, 1), St = D = ve, it = ye, D = D + Zt | 0, D = Zn + ((ye = Le + Ar | 0) >>> 0 < Ar >>> 0 ? D + 1 | 0 : D) | 0, Ct = D = (ye = ye + Ct | 0) >>> 0 < Ct >>> 0 ? D + 1 | 0 : D, Gt = q(_e ^ ye, D ^ Gt, 32), D = (Rr = ve) + it | 0, it = me = Gt + me | 0, _e = q(me ^ Le, (_e = St) ^ (St = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D), 40), D = ei + (Hn = ve) | 0, D = Ct + ((me = _e + zr | 0) >>> 0 < zr >>> 0 ? D + 1 | 0 : D) | 0, Sn = me = me + ye | 0, Je = D = me >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = D, D = Gn + b | 0, D = ((Le = $n + Io | 0) >>> 0 < Io >>> 0 ? D + 1 | 0 : D) + ye | 0, Ct = D = (ye = me + Le | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, me = q(ye ^ ht, D ^ mt, 32), D = (Zn = ve) + Ve | 0, mt = q((Le = me + Kn | 0) ^ $n, (D = Le >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ Gn, 40), er = D, D = Xo + ($n = ve) | 0, D = Ct + ((Gn = mt + wt | 0) >>> 0 < wt >>> 0 ? D + 1 | 0 : D) | 0, D = (Ct = ye + Gn | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = Zn, Zn = D, ye = q(me ^ Ct, ye ^ D, 48), D = (D = er) + (er = ve) | 0, me = (Le = ye + Le | 0) ^ mt, mt = D = Le >>> 0 < ye >>> 0 ? D + 1 | 0 : D, $n = D = q(me, D ^ $n, 1), Gn = me = ve, Ir = Ge, cr = $e, $e = _e, _e = q(Gt ^ Sn, Je ^ Rr, 48), D = (Gt = ve) + St | 0, St = me = _e + it | 0, it = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, $e = q(me ^ $e, D ^ Hn, 1), D = (Hn = ve) + Zt | 0, D = Tt + ((me = $e + Ar | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, bt = D = (Ge = me + bt | 0) >>> 0 < bt >>> 0 ? D + 1 | 0 : D, me = q(Ge ^ cr, D ^ qn, 32), D = (Tt = ve) + je | 0, qn = D = (je = me + Ir | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, $e = q($e ^ je, D ^ Hn, 40), D = co + (Rr = ve) | 0, Hn = $e, D = bt + (($e = no + $e | 0) >>> 0 < no >>> 0 ? D + 1 | 0 : D) | 0, bt = $e + Ge | 0, $e = Tt, Tt = D = bt >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, $e = q(me ^ bt, $e ^ D, 48), D = (D = qn) + (qn = ve) | 0, Sn = me = $e + je | 0, Je = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Ge = we, D = en + Pr | 0, we = D = (me = ht + Kt | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ _n, 1), D = Co + (ht = ve) | 0, D = Ft + ((je = Be + jt | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D) | 0, ct = D = (je = je + ct | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, Ge = q(Ge ^ je, D ^ pn, 32), Ft = D = ve, en = Be, D = D + it | 0, D = (Be = Ge + St | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, Kt = Be, Be ^= en, en = D, Be = q(Be, D ^ ht, 40), D = ti + (_n = ve) | 0, D = ct + ((ht = Be + Tr | 0) >>> 0 < Tr >>> 0 ? D + 1 | 0 : D) | 0, D = (ct = je + ht | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, je = Ft, Ft = D, ht = q(Ge ^ ct, je ^ D, 48), Pr = D = ve, je = D, Ge = q(fn ^ Kn, Ve ^ ao, 1), St = D = ve, it = we, D = D + Fn | 0, D = Nn + ((we = Ge + ur | 0) >>> 0 < ur >>> 0 ? D + 1 | 0 : D) | 0, wn = D = (we = we + wn | 0) >>> 0 < wn >>> 0 ? D + 1 | 0 : D, Gt = q(_e ^ we, D ^ Gt, 32), D = (ao = ve) + it | 0, it = me = Gt + me | 0, _e = q(me ^ Ge, (_e = St) ^ (St = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D), 40), D = ei + (fn = ve) | 0, D = wn + ((me = _e + zr | 0) >>> 0 < zr >>> 0 ? D + 1 | 0 : D) | 0, Kn = me = me + we | 0, Ve = D = me >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = D, D = Gn + Po | 0, D = ((Ge = $n + ut | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D) + we | 0, wn = D = (we = me + Ge | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, me = q(we ^ ht, D ^ je, 32), D = (Nn = ve) + Je | 0, je = q((Ge = me + Sn | 0) ^ $n, (D = Ge >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ Gn, 40), pn = D, D = Cr + ($n = ve) | 0, D = wn + ((Gn = g + je | 0) >>> 0 < g >>> 0 ? D + 1 | 0 : D) | 0, D = (wn = we + Gn | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = Nn, Nn = D, we = q(me ^ wn, we ^ D, 48), D = (D = pn) + (pn = ve) | 0, me = (Ge = we + Ge | 0) ^ je, je = D = Ge >>> 0 < we >>> 0 ? D + 1 | 0 : D, $n = D = q(me, D ^ $n, 1), Gn = me = ve, Ir = Le, cr = $e, $e = _e, _e = q(Gt ^ Kn, Ve ^ ao, 48), D = (Gt = ve) + St | 0, St = me = _e + it | 0, it = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, $e = q(me ^ $e, D ^ fn, 1), D = (fn = ve) + ko | 0, D = Ft + ((me = $e + an | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, ct = D = (Le = me + ct | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, me = q(Le ^ cr, D ^ qn, 32), D = (Ft = ve) + mt | 0, qn = D = (mt = me + Ir | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, $e = q($e ^ mt, D ^ fn, 40), D = U + (ao = ve) | 0, fn = $e, D = ct + (($e = _ + $e | 0) >>> 0 < _ >>> 0 ? D + 1 | 0 : D) | 0, ct = $e + Le | 0, $e = Ft, Ft = D = ct >>> 0 < Le >>> 0 ? D + 1 | 0 : D, $e = q(me ^ ct, $e ^ D, 48), D = (D = qn) + (qn = ve) | 0, Kn = me = $e + mt | 0, Ve = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Le = ye, D = en + Pr | 0, ye = D = (me = ht + Kt | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ _n, 1), D = (ht = ve) + lo | 0, D = Tt + ((mt = Be + qr | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) | 0, bt = D = (mt = mt + bt | 0) >>> 0 < bt >>> 0 ? D + 1 | 0 : D, Le = q(Le ^ mt, D ^ er, 32), Tt = D = ve, en = Be, D = D + it | 0, D = (Be = Le + St | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, Kt = Be, Be ^= en, en = D, Be = q(Be, D ^ ht, 40), D = Go + (_n = ve) | 0, D = bt + ((ht = Be + Wn | 0) >>> 0 < Wn >>> 0 ? D + 1 | 0 : D) | 0, St = Tt, Tt = D = (bt = mt + ht | 0) >>> 0 < mt >>> 0 ? D + 1 | 0 : D, ht = q(Le ^ bt, St ^ D, 48), Pr = D = ve, mt = D, Le = q(Sn ^ Hn, Je ^ Rr, 1), St = D = ve, it = ye, D = D + xo | 0, D = Zn + ((ye = Le + so | 0) >>> 0 < so >>> 0 ? D + 1 | 0 : D) | 0, Ct = D = (ye = ye + Ct | 0) >>> 0 < Ct >>> 0 ? D + 1 | 0 : D, Gt = q(_e ^ ye, D ^ Gt, 32), D = (Rr = ve) + it | 0, it = me = Gt + me | 0, _e = q(me ^ Le, (_e = St) ^ (St = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D), 40), D = Gr + (Hn = ve) | 0, D = Ct + ((me = _e + or | 0) >>> 0 < or >>> 0 ? D + 1 | 0 : D) | 0, Sn = me = me + ye | 0, Je = D = me >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = D, D = Gn + ei | 0, D = ((Le = $n + zr | 0) >>> 0 < zr >>> 0 ? D + 1 | 0 : D) + ye | 0, Ct = D = (ye = me + Le | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, me = q(ye ^ ht, D ^ mt, 32), D = (Zn = ve) + Ve | 0, mt = q((Le = me + Kn | 0) ^ $n, (D = Le >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ Gn, 40), er = D, D = co + ($n = ve) | 0, D = Ct + ((Gn = mt + no | 0) >>> 0 < no >>> 0 ? D + 1 | 0 : D) | 0, D = (Ct = ye + Gn | 0) >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = Zn, Zn = D, ye = q(me ^ Ct, ye ^ D, 48), D = (D = er) + (er = ve) | 0, me = (Le = ye + Le | 0) ^ mt, mt = D = Le >>> 0 < ye >>> 0 ? D + 1 | 0 : D, $n = D = q(me, D ^ $n, 1), Gn = me = ve, Ir = Ge, cr = $e, $e = _e, _e = q(Gt ^ Sn, Je ^ Rr, 48), D = (Gt = ve) + St | 0, St = me = _e + it | 0, it = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, $e = q(me ^ $e, D ^ Hn, 1), D = (Hn = ve) + Xo | 0, D = Tt + ((me = $e + wt | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, bt = D = (Ge = me + bt | 0) >>> 0 < bt >>> 0 ? D + 1 | 0 : D, me = q(Ge ^ cr, D ^ qn, 32), D = (Tt = ve) + je | 0, qn = D = (je = me + Ir | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, $e = q($e ^ je, D ^ Hn, 40), D = b + (Rr = ve) | 0, Hn = $e, D = bt + (($e = Io + $e | 0) >>> 0 < Io >>> 0 ? D + 1 | 0 : D) | 0, bt = $e + Ge | 0, $e = Tt, Tt = D = bt >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, $e = q(me ^ bt, $e ^ D, 48), D = (D = qn) + (qn = ve) | 0, Sn = me = $e + je | 0, Je = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Ge = we, D = en + Pr | 0, we = D = (me = ht + Kt | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ _n, 1), D = Go + (ht = ve) | 0, D = Ft + ((je = Be + Wn | 0) >>> 0 < Wn >>> 0 ? D + 1 | 0 : D) | 0, ct = D = (je = je + ct | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, Ge = q(Ge ^ je, D ^ pn, 32), Ft = D = ve, en = Be, D = D + it | 0, D = (Be = Ge + St | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, Kt = Be, Be ^= en, en = D, Be = q(Be, D ^ ht, 40), D = Zt + (_n = ve) | 0, D = ct + ((ht = Be + Ar | 0) >>> 0 < Ar >>> 0 ? D + 1 | 0 : D) | 0, D = (ct = je + ht | 0) >>> 0 < je >>> 0 ? D + 1 | 0 : D, je = Ft, Ft = D, ht = q(Ge ^ ct, je ^ D, 48), Pr = D = ve, je = D, Ge = q(fn ^ Kn, Ve ^ ao, 1), St = D = ve, it = we, D = D + ti | 0, D = Nn + ((we = Ge + Tr | 0) >>> 0 < Tr >>> 0 ? D + 1 | 0 : D) | 0, wn = D = (we = we + wn | 0) >>> 0 < wn >>> 0 ? D + 1 | 0 : D, Gt = q(_e ^ we, D ^ Gt, 32), D = (ao = ve) + it | 0, it = me = Gt + me | 0, _e = q(me ^ Ge, (_e = St) ^ (St = me >>> 0 < Gt >>> 0 ? D + 1 | 0 : D), 40), D = xo + (fn = ve) | 0, D = wn + ((me = _e + so | 0) >>> 0 < so >>> 0 ? D + 1 | 0 : D) | 0, Kn = me = me + we | 0, Ve = D = me >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = D, D = Gn + Co | 0, D = ((Ge = $n + jt | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D) + we | 0, wn = D = (we = me + Ge | 0) >>> 0 < Ge >>> 0 ? D + 1 | 0 : D, me = q(we ^ ht, D ^ je, 32), D = (Nn = ve) + Je | 0, je = q((Ge = me + Sn | 0) ^ $n, (D = Ge >>> 0 < me >>> 0 ? D + 1 | 0 : D) ^ Gn, 40), pn = D, D = U + ($n = ve) | 0, D = wn + ((Gn = je + _ | 0) >>> 0 < _ >>> 0 ? D + 1 | 0 : D) | 0, D = (wn = we + Gn | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, we = Nn, Nn = D, we = q(me ^ wn, we ^ D, 48), D = (D = pn) + (pn = ve) | 0, me = (Ge = we + Ge | 0) ^ je, je = D = Ge >>> 0 < we >>> 0 ? D + 1 | 0 : D, $n = D = q(me, D ^ $n, 1), Gn = me = ve, Ir = Le, cr = $e, $e = _e, _e = q(Gt ^ Kn, Ve ^ ao, 48), D = (Gt = ve) + St | 0, St = me = _e + it | 0, it = D = me >>> 0 < _e >>> 0 ? D + 1 | 0 : D, $e = q(me ^ $e, D ^ fn, 1), D = (Kn = ve) + Fn | 0, D = Ft + ((me = $e + ur | 0) >>> 0 < $e >>> 0 ? D + 1 | 0 : D) | 0, ct = D = (Le = me + ct | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, me = q(Le ^ cr, D ^ qn, 32), D = (Ft = ve) + mt | 0, qn = mt = me + Ir | 0, fn = D = mt >>> 0 < me >>> 0 ? D + 1 | 0 : D, $e = q($e ^ mt, D ^ Kn, 40), D = Po + (Ir = ve) | 0, Kn = $e, D = ct + (($e = ut + $e | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D) | 0, mt = $e + Le | 0, $e = Ft, Ft = D = mt >>> 0 < Le >>> 0 ? D + 1 | 0 : D, $e = q(me ^ mt, $e ^ D, 48), D = (D = fn) + (fn = ve) | 0, qn = me = $e + qn | 0, Ve = D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Le = ye, D = en + Pr | 0, ye = D = (me = ht + Kt | 0) >>> 0 < ht >>> 0 ? D + 1 | 0 : D, Be = q(me ^ Be, D ^ _n, 1), D = (ht = ve) + Cr | 0, D = Tt + ((ct = g + Be | 0) >>> 0 < Be >>> 0 ? D + 1 | 0 : D) | 0, bt = D = (ct = ct + bt | 0) >>> 0 < bt >>> 0 ? D + 1 | 0 : D, Tt = Le = q(Le ^ ct, D ^ er, 32), en = D = ve, Kt = Be, D = D + it | 0, D = (Be = Le + St | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, _n = Be, Be ^= Kt, Kt = D, Be = q(Be, D ^ ht, 40), D = ko + (St = ve) | 0, D = bt + ((Le = Be + an | 0) >>> 0 < an >>> 0 ? D + 1 | 0 : D) | 0, it = (Le = Le + ct | 0) ^ Tt, Tt = D = Le >>> 0 < ct >>> 0 ? D + 1 | 0 : D, ct = q(it, D ^ en, 48), er = D = ve, ht = D, en = bt = q(Sn ^ Hn, Je ^ Rr, 1), it = D = ve, Hn = ye, D = D + Gr | 0, D = Zn + ((ye = bt + or | 0) >>> 0 < or >>> 0 ? D + 1 | 0 : D) | 0, D = (ye = ye + Ct | 0) >>> 0 < Ct >>> 0 ? D + 1 | 0 : D, Ct = Gt, Gt = D, bt = q(_e ^ ye, Ct ^ D, 32), D = (cr = ve) + Hn | 0, Ct = me = bt + me | 0, _e = q(_e = me ^ en, (en = me >>> 0 < bt >>> 0 ? D + 1 | 0 : D) ^ it, 40), D = lo + (it = ve) | 0, D = Gt + ((me = _e + qr | 0) >>> 0 < qr >>> 0 ? D + 1 | 0 : D) | 0, Gt = me = me + ye | 0, Hn = D = me >>> 0 < ye >>> 0 ? D + 1 | 0 : D, ye = D, D = Gn + Po | 0, D = ((Zn = ut) >>> 0 > (ut = $n + ut | 0) >>> 0 ? D + 1 | 0 : D) + ye | 0, Po = D = (me = me + ut | 0) >>> 0 < ut >>> 0 ? D + 1 | 0 : D, ut = q(me ^ ct, D ^ ht, 32), D = (Sn = ve) + Ve | 0, ht = q((ye = qn + ut | 0) ^ $n, (D = ye >>> 0 < ut >>> 0 ? D + 1 | 0 : D) ^ Gn, 40), Zn = D, D = ko + (Je = ve) | 0, D = Po + (($n = an) >>> 0 > (an = ht + an | 0) >>> 0 ? D + 1 | 0 : D) | 0, D = (an = me + an | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, me = ut ^ an, ut = D, ko = q(me, D ^ Sn, 48), D = (Po = ve) + Zn | 0, ye = D = (me = ye + ko | 0) >>> 0 < ko >>> 0 ? D + 1 | 0 : D, D = q(me ^ ht, D ^ Je, 1), ht = ve, Sn = D, Je = Ge, Ge = qr, Zn = lo, lo = q(bt ^ Gt, Hn ^ cr, 48), D = (bt = ve) + en | 0, en = Ge, Ct = D = (qr = Ct + lo | 0) >>> 0 < lo >>> 0 ? D + 1 | 0 : D, Ge = q(_e ^ (Gt = qr), D ^ it, 1), D = (it = ve) + Zn | 0, D = Tt + (Ge >>> 0 > (qr = en + Ge | 0) >>> 0 ? D + 1 | 0 : D) | 0, _e = D = (qr = Le + qr | 0) >>> 0 < Le >>> 0 ? D + 1 | 0 : D, $e = q($e ^ qr, D ^ fn, 32), D = (D = je) + (je = ve) | 0, Tt = Le = $e + Je | 0, en = D = Le >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Le = q(Le ^ Ge, D ^ it, 40), D = (it = ve) + Xo | 0, D = (Le >>> 0 > (wt = Le + wt | 0) >>> 0 ? D + 1 | 0 : D) + _e | 0, _e = D = (_e = wt) >>> 0 > (wt = qr + wt | 0) >>> 0 ? D + 1 | 0 : D, $e = q($e ^ wt, D ^ je, 48), D = (Ge = ve) + en | 0, je = qr = $e + Tt | 0, Xo = D = qr >>> 0 < $e >>> 0 ? D + 1 | 0 : D, Tt = g, en = Cr, D = Kt + er | 0, qr = D = (g = ct + _n | 0) >>> 0 < ct >>> 0 ? D + 1 | 0 : D, Cr = q(g ^ Be, D ^ St, 1), D = (ct = ve) + en | 0, D = Ft + ((Be = Tt + Cr | 0) >>> 0 < Cr >>> 0 ? D + 1 | 0 : D) | 0, we = q((Be = Be + mt | 0) ^ we, (D = Be >>> 0 < mt >>> 0 ? D + 1 | 0 : D) ^ pn, 32), Tt = D, Ft = jt, jt = Cr, D = (mt = ve) + Ct | 0, Ct = ct, ct = D = (Cr = we + Gt | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D, jt = q(Cr ^ jt, Ct ^ D, 40), D = (Gt = ve) + Co | 0, D = ((Co = Ft + jt | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D) + Tt | 0, Tt = Co, Be = we ^ (Co = Be + Co | 0), we = D = Tt >>> 0 > Co >>> 0 ? D + 1 | 0 : D, D = q(Be, D ^ mt, 48), Kt = Be = ve, mt = D, Ct = ur, Tt = Fn, ur = q(qn ^ Kn, Ve ^ Ir, 1), en = D = ve, D = D + ei | 0, D = Nn + ((ur = (Ft = ur) + zr | 0) >>> 0 < zr >>> 0 ? D + 1 | 0 : D) | 0, zr = D = (ur = wn + ur | 0) >>> 0 < wn >>> 0 ? D + 1 | 0 : D, Fn = q(ur ^ lo, D ^ bt, 32), D = (wn = ve) + qr | 0, qr = g = Fn + g | 0, lo = q(g ^ Ft, (bt = g >>> 0 < Fn >>> 0 ? D + 1 | 0 : D) ^ en, 40), D = (D = Tt) + (Tt = ve) | 0, D = zr + ((g = lo + Ct | 0) >>> 0 < lo >>> 0 ? D + 1 | 0 : D) | 0, zr = g = g + ur | 0, ei = D = g >>> 0 < ur >>> 0 ? D + 1 | 0 : D, ur = D, D = ht + Go | 0, D = ((Ft = Wn) >>> 0 > (Wn = Sn + Wn | 0) >>> 0 ? D + 1 | 0 : D) + ur | 0, Go = D = (ur = g + Wn | 0) >>> 0 < Wn >>> 0 ? D + 1 | 0 : D, Wn = q(mt ^ ur, D ^ Be, 32), D = (Ft = ve) + Xo | 0, Be = g = Wn + je | 0, g = q(g ^ Sn, (Ct = ht) ^ (ht = g >>> 0 < Wn >>> 0 ? D + 1 | 0 : D), 40), D = ti + (en = ve) | 0, ti = g, D = Go + ((g = Tr + g | 0) >>> 0 < Tr >>> 0 ? D + 1 | 0 : D) | 0, D = (g = g + ur | 0) >>> 0 < ur >>> 0 ? D + 1 | 0 : D, Go = g, _n = (B[A + 8 | 0] | B[A + 9 | 0] << 8 | B[A + 10 | 0] << 16 | B[A + 11 | 0] << 24) ^ g, Ct = D, St = D ^ (B[A + 12 | 0] | B[A + 13 | 0] << 8 | B[A + 14 | 0] << 16 | B[A + 15 | 0] << 24), ur = q(Fn ^ zr, wn ^ ei, 48), D = (zr = ve) + bt | 0, bt = g = ur + qr | 0, ei = D = g >>> 0 < ur >>> 0 ? D + 1 | 0 : D, Fn = no, D = ct + Kt | 0, no = D = (g = mt + Cr | 0) >>> 0 < Cr >>> 0 ? D + 1 | 0 : D, jt = q(g ^ jt, D ^ Gt, 1), D = (mt = ve) + co | 0, D = ((Fn = jt + Fn | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D) + _e | 0, Fn = D = (co = Fn + wt | 0) >>> 0 < Fn >>> 0 ? D + 1 | 0 : D, qr = q(co ^ ko, D ^ Po, 32), D = (Cr = ve) + ei | 0, wt = D = (Tr = qr + bt | 0) >>> 0 < qr >>> 0 ? D + 1 | 0 : D, ko = qr, qr = q(jt ^ Tr, D ^ mt, 40), D = (_e = ve) + xo | 0, D = (qr >>> 0 > (jt = qr + so | 0) >>> 0 ? D + 1 | 0 : D) + Fn | 0, ct = Cr, Cr = D = (co = jt + co | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D, jt = q(ko ^ (so = co), ct ^ D, 48), D = (mt = ve) + wt | 0, D = (Fn = jt + Tr | 0) >>> 0 < jt >>> 0 ? D + 1 | 0 : D, Tr = Fn, Fn ^= _n, j[A + 8 | 0] = Fn, j[A + 9 | 0] = Fn >>> 8, j[A + 10 | 0] = Fn >>> 16, j[A + 11 | 0] = Fn >>> 24, wt = D, D ^= St, j[A + 12 | 0] = D, j[A + 13 | 0] = D >>> 8, j[A + 14 | 0] = D >>> 16, j[A + 15 | 0] = D >>> 24, co = g, Fn = no, g = ur, ur = q(Le ^ je, it ^ Xo, 1), D = (xo = ve) + U | 0, D = (ur >>> 0 > (no = ur + _ | 0) >>> 0 ? D + 1 | 0 : D) + ut | 0, an = D = (je = no) >>> 0 > (no = an + no | 0) >>> 0 ? D + 1 | 0 : D, g = q(g ^ no, D ^ zr, 32), D = (D = Fn) + (Fn = ve) | 0, zr = D = (co = g + co | 0) >>> 0 < g >>> 0 ? D + 1 | 0 : D, ko = g, co = q(ur ^ (ut = co), D ^ xo, 40), D = (Le = ve) + b | 0, D = an + ((g = co + Io | 0) >>> 0 < co >>> 0 ? D + 1 | 0 : D) | 0, D = (g = g + no | 0) >>> 0 < no >>> 0 ? D + 1 | 0 : D, an = g, g ^= ko, ko = D, no = q(g, D ^ Fn, 48), D = (je = ve) + zr | 0, ut = g = no + ut | 0, zr = g >>> 0 < no >>> 0 ? D + 1 | 0 : D, lo = g = q(bt ^ lo, Tt ^ ei, 1), xo = D = ve, D = D + Zt | 0, D = we + ((g = g + Ar | 0) >>> 0 < Ar >>> 0 ? D + 1 | 0 : D) | 0, Zt = D = (ur = g + Co | 0) >>> 0 < Co >>> 0 ? D + 1 | 0 : D, g = (Fn = q($e ^ ur, D ^ Ge, 32)) + me | 0, D = (me = ve) + ye | 0, Co = g, g = (Ar = q(we = g ^ lo, (lo = g >>> 0 < Fn >>> 0 ? D + 1 | 0 : D) ^ xo, 40)) + or | 0, D = (or = ve) + Gr | 0, D = Zt + (g >>> 0 < Ar >>> 0 ? D + 1 | 0 : D) | 0, D = (Zt = g + ur | 0) >>> 0 < ur >>> 0 ? D + 1 | 0 : D, ur = Zt ^ vi ^ ut, j[0 | (g = A)] = ur, j[g + 1 | 0] = ur >>> 8, j[g + 2 | 0] = ur >>> 16, j[g + 3 | 0] = ur >>> 24, ur = D ^ ie ^ zr, j[g + 4 | 0] = ur, j[g + 5 | 0] = ur >>> 8, j[g + 6 | 0] = ur >>> 16, j[g + 7 | 0] = ur >>> 24, ur = (Fn = q(Zt ^ Fn, D ^ me, 48)) + Co | 0, D = (Co = ve) + lo | 0, D = (lo = ur >>> 0 < Fn >>> 0 ? D + 1 | 0 : D) ^ (B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24) ^ ko, Zt = (B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24) ^ an ^ ur, j[g + 16 | 0] = Zt, j[g + 17 | 0] = Zt >>> 8, j[g + 18 | 0] = Zt >>> 16, j[g + 19 | 0] = Zt >>> 24, j[g + 20 | 0] = D, j[g + 21 | 0] = D >>> 8, j[g + 22 | 0] = D >>> 16, j[g + 23 | 0] = D >>> 24, g = q(Wn ^ Go, Ct ^ Ft, 48), Zt = ve, an = B[A + 36 | 0] | B[A + 37 | 0] << 8 | B[A + 38 | 0] << 16 | B[A + 39 | 0] << 24, D = (B[A + 32 | 0] | B[A + 33 | 0] << 8 | B[A + 34 | 0] << 16 | B[A + 35 | 0] << 24) ^ q(qr ^ Tr, _e ^ wt, 1) ^ g, j[A + 32 | 0] = D, j[A + 33 | 0] = D >>> 8, j[A + 34 | 0] = D >>> 16, j[A + 35 | 0] = D >>> 24, D = ve ^ an ^ Zt, j[A + 36 | 0] = D, j[A + 37 | 0] = D >>> 8, j[A + 38 | 0] = D >>> 16, j[A + 39 | 0] = D >>> 24, D = ht + Zt | 0, D = (an = g + Be | 0) >>> 0 < g >>> 0 ? D + 1 | 0 : D, qr = (B[(g = A) + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24) ^ Cr ^ D, Zt = (B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24) ^ so ^ an, j[g + 24 | 0] = Zt, j[g + 25 | 0] = Zt >>> 8, j[g + 26 | 0] = Zt >>> 16, j[g + 27 | 0] = Zt >>> 24, j[g + 28 | 0] = qr, j[g + 29 | 0] = qr >>> 8, j[g + 30 | 0] = qr >>> 16, j[g + 31 | 0] = qr >>> 24, qr = B[g + 44 | 0] | B[g + 45 | 0] << 8 | B[g + 46 | 0] << 16 | B[g + 47 | 0] << 24, g = no ^ (B[g + 40 | 0] | B[g + 41 | 0] << 8 | B[g + 42 | 0] << 16 | B[g + 43 | 0] << 24) ^ q(ur ^ Ar, or ^ lo, 1), j[A + 40 | 0] = g, j[A + 41 | 0] = g >>> 8, j[A + 42 | 0] = g >>> 16, j[A + 43 | 0] = g >>> 24, g = je ^ ve ^ qr, j[A + 44 | 0] = g, j[A + 45 | 0] = g >>> 8, j[A + 46 | 0] = g >>> 16, j[A + 47 | 0] = g >>> 24, ur = B[A + 60 | 0] | B[A + 61 | 0] << 8 | B[A + 62 | 0] << 16 | B[A + 63 | 0] << 24, g = Fn ^ (B[A + 56 | 0] | B[A + 57 | 0] << 8 | B[A + 58 | 0] << 16 | B[A + 59 | 0] << 24) ^ q(ut ^ co, Le ^ zr, 1), j[A + 56 | 0] = g, j[A + 57 | 0] = g >>> 8, j[A + 58 | 0] = g >>> 16, j[A + 59 | 0] = g >>> 24, g = Co ^ ve ^ ur, j[A + 60 | 0] = g, j[A + 61 | 0] = g >>> 8, j[A + 62 | 0] = g >>> 16, j[A + 63 | 0] = g >>> 24, ur = B[A + 52 | 0] | B[A + 53 | 0] << 8 | B[A + 54 | 0] << 16 | B[A + 55 | 0] << 24, g = jt ^ (B[A + 48 | 0] | B[A + 49 | 0] << 8 | B[A + 50 | 0] << 16 | B[A + 51 | 0] << 24) ^ q(an ^ ti, D ^ en, 1), j[A + 48 | 0] = g, j[A + 49 | 0] = g >>> 8, j[A + 50 | 0] = g >>> 16, j[A + 51 | 0] = g >>> 24, g = mt ^ ve ^ ur, j[A + 52 | 0] = g, j[A + 53 | 0] = g >>> 8, j[A + 54 | 0] = g >>> 16, j[A + 55 | 0] = g >>> 24;
                    }
                    function aa(A, g, _, b, U, ie, he) {
                      var D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht, Ct, Tt, Gt, en, it, St, Ft, fn, _n, wn, $n, qn, Gn, Kn, Kt, pn, Hn, Zn, er, Zt, Sn, or, ur, Cr, Je, Ve, ut, Nn, cr, Rr, Ir, Pr, qr, ao, Fn = 0, Wn = 0, wt = 0, jt = 0, an = 0, Ar = 0, Tr = 0, zr = 0, Gr = 0, no = 0, so = 0, co = 0, lo = 0, yo = 0, Co = 0, Io = 0, ko = 0, Po = 0, $o = 0, xo = 0, Go = 0, Xo = 0, ei = 0, ti = 0, oi = 0, vi = 0, Ti = 0, Oi = 0, xi = 0, Hi = 0, Wi = 0, Gi = 0, ps = 0, cs = 0, vs = 0, qs = 0, Fs = 0, Ls = 0, Ws = 0, zs = 0, pa = 0, mu = 0, gu = 0, hu = 0, Au = 0, yu = 0;
                      return st = _e = st - 560 | 0, ae(_e + 352 | 0), he && Di(_e + 352 | 0, 35248, 34, 0), L(_e + 288 | 0, ie, 32, 0), Di(Ar = _e + 352 | 0, _e + 320 | 0, 32, 0), Di(Ar, _, b, U), Ui(Ar, zr = _e + 224 | 0), Gr = B[(Wn = ie) + 32 | 0] | B[Wn + 33 | 0] << 8 | B[Wn + 34 | 0] << 16 | B[Wn + 35 | 0] << 24, so = B[Wn + 36 | 0] | B[Wn + 37 | 0] << 8 | B[Wn + 38 | 0] << 16 | B[Wn + 39 | 0] << 24, jt = B[Wn + 40 | 0] | B[Wn + 41 | 0] << 8 | B[Wn + 42 | 0] << 16 | B[Wn + 43 | 0] << 24, Fn = B[Wn + 44 | 0] | B[Wn + 45 | 0] << 8 | B[Wn + 46 | 0] << 16 | B[Wn + 47 | 0] << 24, wt = B[Wn + 48 | 0] | B[Wn + 49 | 0] << 8 | B[Wn + 50 | 0] << 16 | B[Wn + 51 | 0] << 24, ie = B[Wn + 52 | 0] | B[Wn + 53 | 0] << 8 | B[Wn + 54 | 0] << 16 | B[Wn + 55 | 0] << 24, an = B[Wn + 60 | 0] | B[Wn + 61 | 0] << 8 | B[Wn + 62 | 0] << 16 | B[Wn + 63 | 0] << 24, Wn = B[Wn + 56 | 0] | B[Wn + 57 | 0] << 8 | B[Wn + 58 | 0] << 16 | B[Wn + 59 | 0] << 24, j[A + 56 | 0] = Wn, j[A + 57 | 0] = Wn >>> 8, j[A + 58 | 0] = Wn >>> 16, j[A + 59 | 0] = Wn >>> 24, j[A + 60 | 0] = an, j[A + 61 | 0] = an >>> 8, j[A + 62 | 0] = an >>> 16, j[A + 63 | 0] = an >>> 24, j[A + 48 | 0] = wt, j[A + 49 | 0] = wt >>> 8, j[A + 50 | 0] = wt >>> 16, j[A + 51 | 0] = wt >>> 24, j[A + 52 | 0] = ie, j[A + 53 | 0] = ie >>> 8, j[A + 54 | 0] = ie >>> 16, j[A + 55 | 0] = ie >>> 24, j[A + 40 | 0] = jt, j[A + 41 | 0] = jt >>> 8, j[A + 42 | 0] = jt >>> 16, j[A + 43 | 0] = jt >>> 24, j[A + 44 | 0] = Fn, j[A + 45 | 0] = Fn >>> 8, j[A + 46 | 0] = Fn >>> 16, j[A + 47 | 0] = Fn >>> 24, j[0 | (ie = A + 32 | 0)] = Gr, j[ie + 1 | 0] = Gr >>> 8, j[ie + 2 | 0] = Gr >>> 16, j[ie + 3 | 0] = Gr >>> 24, j[ie + 4 | 0] = so, j[ie + 5 | 0] = so >>> 8, j[ie + 6 | 0] = so >>> 16, j[ie + 7 | 0] = so >>> 24, Vi(zr), Os(_e, zr), kr(A, _e), ae(Ar), he && Di(_e + 352 | 0, 35248, 34, 0), Di(he = _e + 352 | 0, A, 64, 0), Di(he, _, b, U), Ui(he, Tr = _e + 160 | 0), Vi(Tr), j[_e + 288 | 0] = 248 & B[_e + 288 | 0], j[_e + 319 | 0] = 63 & B[_e + 319 | 0] | 64, _ = B[23 + (A = me = _e + 288 | 0) | 0], jt = De(Be = B[A + 21 | 0] | B[A + 22 | 0] << 8 | _ << 16 & 2031616, 0, ye = (B[Tr + 28 | 0] | B[Tr + 29 | 0] << 8 | B[Tr + 30 | 0] << 16 | B[Tr + 31 | 0] << 24) >>> 7 | 0, 0), wt = ve, _ = (A = B[Tr + 27 | 0]) >>> 24 | 0, U = A << 8 | (Fn = B[Tr + 23 | 0] | B[Tr + 24 | 0] << 8 | B[Tr + 25 | 0] << 16 | B[Tr + 26 | 0] << 24) >>> 24, A = De(we = 2097151 & ((3 & (so = (A = (b = B[Tr + 28 | 0]) >>> 16 | 0) | _)) << 30 | (_ = (b <<= 16) | U) >>> 2), 0, $e = (he = B[me + 23 | 0] | B[me + 24 | 0] << 8 | B[me + 25 | 0] << 16 | B[me + 26 | 0] << 24) >>> 5 & 2097151, 0), _ = ve + wt | 0, b = A >>> 0 > (U = A + jt | 0) >>> 0 ? _ + 1 | 0 : _, A = De(Le = (_ = B[Tr + 23 | 0]) << 16 & 2031616 | B[Tr + 21 | 0] | B[Tr + 22 | 0] << 8, 0, Ge = (B[me + 28 | 0] | B[me + 29 | 0] << 8 | B[me + 30 | 0] << 16 | B[me + 31 | 0] << 24) >>> 7 | 0, 0), b = ve + b | 0, wt = _ = A + U | 0, U = A >>> 0 > _ >>> 0 ? b + 1 | 0 : b, b = (A = B[me + 27 | 0]) >>> 24 | 0, he = A << 8 | he >>> 24, A = De(je = 2097151 & ((3 & (b |= _ = (A = B[me + 28 | 0]) >>> 16 | 0)) << 30 | (_ = (A <<= 16) | he) >>> 2), 0, ct = Fn >>> 5 & 2097151, 0), _ = ve + U | 0, Wn = b = A + wt | 0, U = A >>> 0 > b >>> 0 ? _ + 1 | 0 : _, Fn = De($e, 0, ct, 0), wt = ve, _ = (A = B[me + 19 | 0]) >>> 24 | 0, he = A << 8 | (ko = B[me + 15 | 0] | B[me + 16 | 0] << 8 | B[me + 17 | 0] << 16 | B[me + 18 | 0] << 24) >>> 24, b = _, _ = De(mt = (7 & (b |= _ = (A = B[me + 20 | 0]) >>> 16 | 0)) << 29 | (_ = (A <<= 16) | he) >>> 3, so = b >>> 3 | 0, ye, 0), A = ve + wt | 0, A = _ >>> 0 > (b = _ + Fn | 0) >>> 0 ? A + 1 | 0 : A, he = (_ = De(Be, 0, we, 0)) + b | 0, b = ve + A | 0, _ = _ >>> 0 > (Fn = he) >>> 0 ? b + 1 | 0 : b, b = (A = B[Tr + 19 | 0]) >>> 24 | 0, wt = A << 8 | (Io = B[Tr + 15 | 0] | B[Tr + 16 | 0] << 8 | B[Tr + 17 | 0] << 16 | B[Tr + 18 | 0] << 24) >>> 24, A = De(bt = (7 & (jt = (A = (he = B[Tr + 20 | 0]) >>> 16 | 0) | b)) << 29 | (b = (he <<= 16) | wt) >>> 3, ht = jt >>> 3 | 0, Ge, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = A + Fn | 0) >>> 0 ? _ + 1 | 0 : _, A = De(Le, 0, je, 0), _ = ve + _ | 0, Gr = _ = A >>> 0 > (zr = A + b | 0) >>> 0 ? _ + 1 | 0 : _, co = A = _ - ((zr >>> 0 < 4293918720) - 1 | 0) | 0, b = (_ = A >>> 21 | 0) + U | 0, Fn = b = (A = (2097151 & A) << 11 | (jt = zr - -1048576 | 0) >>> 21) >>> 0 > (Wn = A + Wn | 0) >>> 0 ? b + 1 | 0 : b, yo = A = b - ((Wn >>> 0 < 4293918720) - 1 | 0) | 0, Ar = (2097151 & A) << 11 | (wt = Wn - -1048576 | 0) >>> 21, he = A >>> 21 | 0, A = De(Ge, 0, ct, 0), _ = ve, b = A, A = De(ye, 0, $e, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, lo = (A = b) + (b = De(we, 0, je, 0)) | 0, A = ve + _ | 0, A = b >>> 0 > lo >>> 0 ? A + 1 | 0 : A, an = lo - (_ = -2097152 & (b = lo - -1048576 | 0)) | 0, _ = (A - ((131071 & (U = A - ((lo >>> 0 < 4293918720) - 1 | 0) | 0)) + (_ >>> 0 > lo >>> 0) | 0) | 0) + he | 0, Kt = _ = (A = an + Ar | 0) >>> 0 < an >>> 0 ? _ + 1 | 0 : _, pn = A, an = De(A, _, 470296, 0), Ar = ve, _ = De(ye, 0, je, 0), A = ve, he = _, _ = De(we, 0, Ge, 0), A = ve + A | 0, _ = _ >>> 0 > (he = he + _ | 0) >>> 0 ? A + 1 | 0 : A, A = U >>> 21 | 0, U = (2097151 & U) << 11 | b >>> 21, b = A + _ | 0, Xo = U = (b = U >>> 0 > (he = U + he | 0) >>> 0 ? b + 1 | 0 : b) - ((he >>> 0 < 4293918720) - 1 | 0) | 0, A = he - (_ = -2097152 & (Go = he - -1048576 | 0)) | 0, Hn = he = b - ((131071 & U) + (_ >>> 0 > he >>> 0) | 0) | 0, Zn = _ = Wn - (b = -2097152 & wt) | 0, er = U = Fn - ((b >>> 0 > Wn >>> 0) + yo | 0) | 0, Zt = A, b = De(A, he, 666643, 0), A = ve + Ar | 0, A = b >>> 0 > (he = b + an | 0) >>> 0 ? A + 1 | 0 : A, b = De(_, U, 654183, 0), _ = ve + A | 0, no = U = b + he | 0, wt = b >>> 0 > U >>> 0 ? _ + 1 | 0 : _, lo = zr - (A = -2097152 & jt) | 0, co = Gr - ((A >>> 0 > zr >>> 0) + co | 0) | 0, _ = De(we, 0, mt, so), b = ve, U = (A = _) + (_ = De(Ct = ko >>> 6 & 2097151, 0, ye, 0)) | 0, A = ve + b | 0, A = _ >>> 0 > U >>> 0 ? A + 1 | 0 : A, _ = De($e, 0, Le, 0), b = ve + A | 0, b = _ >>> 0 > (U = _ + U | 0) >>> 0 ? b + 1 | 0 : b, A = De(Be, 0, ct, 0), _ = ve + b | 0, _ = A >>> 0 > (U = A + U | 0) >>> 0 ? _ + 1 | 0 : _, b = De(Ge, 0, Tt = Io >>> 6 & 2097151, 0), A = ve + _ | 0, A = b >>> 0 > (U = b + U | 0) >>> 0 ? A + 1 | 0 : A, b = De(je, 0, bt, ht), _ = ve + A | 0, zr = U = b + U | 0, he = b >>> 0 > U >>> 0 ? _ + 1 | 0 : _, _ = (A = B[me + 14 | 0]) >>> 24 | 0, U = A << 8 | (Gr = B[me + 10 | 0] | B[me + 11 | 0] << 8 | B[me + 12 | 0] << 16 | B[me + 13 | 0] << 24) >>> 24, _ = De(Gt = 2097151 & ((1 & (_ |= A = (b = B[me + 15 | 0]) >>> 16 | 0)) << 31 | (A = (b <<= 16) | U) >>> 1), 0, ye, 0), A = ve, b = _, _ = De(we, 0, Ct, 0), A = ve + A | 0, A = _ >>> 0 > (b = b + _ | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = De(ct, 0, mt, so)) + b | 0, b = ve + A | 0, b = _ >>> 0 > U >>> 0 ? b + 1 | 0 : b, A = De($e, 0, bt, ht), _ = ve + b | 0, _ = A >>> 0 > (U = A + U | 0) >>> 0 ? _ + 1 | 0 : _, A = De(Be, 0, Le, 0), _ = ve + _ | 0, jt = b = A + U | 0, U = A >>> 0 > b >>> 0 ? _ + 1 | 0 : _, _ = (A = B[Tr + 14 | 0]) >>> 24 | 0, Fn = A << 8 | (Wn = B[Tr + 10 | 0] | B[Tr + 11 | 0] << 8 | B[Tr + 12 | 0] << 16 | B[Tr + 13 | 0] << 24) >>> 24, b = _, _ = (A = B[Tr + 15 | 0]) >>> 16 | 0, _ = De(en = 2097151 & ((1 & (_ |= b)) << 31 | (A = A << 16 | Fn) >>> 1), 0, Ge, 0), A = ve + U | 0, A = _ >>> 0 > (b = _ + jt | 0) >>> 0 ? A + 1 | 0 : A, _ = De(je, 0, Tt, 0), A = ve + A | 0, Fn = A = _ >>> 0 > (jt = _ + b | 0) >>> 0 ? A + 1 | 0 : A, ei = _ = A - ((jt >>> 0 < 4293918720) - 1 | 0) | 0, b = (A = _ >>> 21 | 0) + he | 0, Ar = b = (_ = (2097151 & _) << 11 | (an = jt - -1048576 | 0) >>> 21) >>> 0 > (yo = _ + zr | 0) >>> 0 ? b + 1 | 0 : b, $o = _ = b - ((yo >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = _ >>> 21 | 0) + co | 0, Sn = A = (_ = (b = (2097151 & _) << 11 | (zr = yo - -1048576 | 0) >>> 21) + lo | 0) >>> 0 < b >>> 0 ? A + 1 | 0 : A, or = _, A = De(_, A, -997805, -1), _ = ve + wt | 0, no = b = A + no | 0, wt = A >>> 0 > b >>> 0 ? _ + 1 | 0 : _, lo = (vi = B[23 + (D = _e + 224 | 0) | 0] | B[D + 24 | 0] << 8 | B[D + 25 | 0] << 16 | B[D + 26 | 0] << 24) >>> 5 & 2097151, b = De(it = (A = B[me + 2 | 0]) << 16 & 2031616 | B[0 | me] | B[me + 1 | 0] << 8, 0, ct, 0), _ = ve, U = (A = De(Le, 0, St = (he = B[me + 2 | 0] | B[me + 3 | 0] << 8 | B[me + 4 | 0] << 16 | B[me + 5 | 0] << 24) >>> 5 & 2097151, 0)) + b | 0, b = ve + _ | 0, b = A >>> 0 > U >>> 0 ? b + 1 | 0 : b, A = De(Ft = (B[me + 7 | 0] | B[me + 8 | 0] << 8 | B[me + 9 | 0] << 16 | B[me + 10 | 0] << 24) >>> 7 & 2097151, 0, Tt, 0), _ = ve + b | 0, _ = A >>> 0 > (U = A + U | 0) >>> 0 ? _ + 1 | 0 : _, b = De(en, 0, fn = Gr >>> 4 & 2097151, 0), A = ve + _ | 0, Gr = U = b + U | 0, U = b >>> 0 > U >>> 0 ? A + 1 | 0 : A, he = (_ = B[me + 6 | 0]) << 8 | he >>> 24, b = A = _ >>> 24 | 0, _ = (A = B[me + 7 | 0]) >>> 16 | 0, _ = De(_n = 2097151 & ((3 & (_ |= b)) << 30 | (A = A << 16 | he) >>> 2), 0, bt, ht), A = ve + U | 0, A = _ >>> 0 > (b = _ + Gr | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = De(Ct, 0, wn = (B[Tr + 7 | 0] | B[Tr + 8 | 0] << 8 | B[Tr + 9 | 0] << 16 | B[Tr + 10 | 0] << 24) >>> 7 & 2097151, 0)) + b | 0, b = ve + A | 0, b = _ >>> 0 > U >>> 0 ? b + 1 | 0 : b, _ = De(Gt, 0, xo = Wn >>> 4 & 2097151, 0), A = ve + b | 0, he = _ >>> 0 > (U = _ + U | 0) >>> 0 ? A + 1 | 0 : A, A = (_ = B[Tr + 6 | 0]) >>> 24 | 0, Gr = _ << 8 | (Wn = B[Tr + 2 | 0] | B[Tr + 3 | 0] << 8 | B[Tr + 4 | 0] << 16 | B[Tr + 5 | 0] << 24) >>> 24, _ = A, A = De(mt, so, $n = 2097151 & ((3 & (_ |= b = (A = B[Tr + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | Gr) >>> 2), 0), _ = ve + he | 0, _ = A >>> 0 > (b = A + U | 0) >>> 0 ? _ + 1 | 0 : _, U = b, b = De(qn = (A = B[Tr + 2 | 0]) << 16 & 2031616 | B[0 | Tr] | B[Tr + 1 | 0] << 8, 0, $e, 0), A = ve + _ | 0, A = b >>> 0 > (U = U + b | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Be, 0, Gn = Wn >>> 5 & 2097151, 0), A = ve + A | 0, _ = _ >>> 0 > (b = _ + U | 0) >>> 0 ? A + 1 | 0 : A, Gr = A = b + lo | 0, he = _ = A >>> 0 < b >>> 0 ? _ + 1 | 0 : _, U = B[D + 21 | 0] | B[D + 22 | 0] << 8, A = De(Le, 0, it, 0), _ = ve, Wn = (b = A) + (A = De(bt, ht, St, 0)) | 0, b = ve + _ | 0, b = A >>> 0 > Wn >>> 0 ? b + 1 | 0 : b, A = De(en, 0, Ft, 0), _ = ve + b | 0, _ = A >>> 0 > (Wn = A + Wn | 0) >>> 0 ? _ + 1 | 0 : _, A = De(fn, 0, xo, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = A + Wn | 0) >>> 0 ? _ + 1 | 0 : _, Wn = (A = b) + (b = De(Tt, 0, _n, 0)) | 0, A = ve + _ | 0, A = b >>> 0 > Wn >>> 0 ? A + 1 | 0 : A, _ = De(Ct, 0, $n, 0), A = ve + A | 0, A = _ >>> 0 > (b = _ + Wn | 0) >>> 0 ? A + 1 | 0 : A, Wn = (_ = De(Gt, 0, wn, 0)) + b | 0, b = ve + A | 0, b = _ >>> 0 > Wn >>> 0 ? b + 1 | 0 : b, A = De(mt, so, Gn, 0), _ = ve + b | 0, _ = A >>> 0 > (Wn = A + Wn | 0) >>> 0 ? _ + 1 | 0 : _, A = De(Be, 0, qn, 0), _ = ve + _ | 0, A = A >>> 0 > (b = A + Wn | 0) >>> 0 ? _ + 1 | 0 : _, _ = (_ = b) >>> 0 > (b = b + U | 0) >>> 0 ? A + 1 | 0 : A, U = b, b = (A = B[D + 23 | 0]) << 16 & 2031616, A = _, b = A = b >>> 0 > (U = U + b | 0) >>> 0 ? A + 1 | 0 : A, Tr = A = A - ((U >>> 0 < 4293918720) - 1 | 0) | 0, _ = (_ = A >>> 21 | 0) + he | 0, A = (_ = (he = Gr = (A = (2097151 & A) << 11 | (Wn = U - -1048576 | 0) >>> 21) + Gr | 0) >>> 0 < A >>> 0 ? _ + 1 | 0 : _) + wt | 0, A = (wt = he + no | 0) >>> 0 < he >>> 0 ? A + 1 | 0 : A, ko = he - -1048576 | 0, Co = he = _ - ((he >>> 0 < 4293918720) - 1 | 0) | 0, Po = wt - (_ = -2097152 & ko) | 0, ti = A - ((_ >>> 0 > wt >>> 0) + he | 0) | 0, Gr = U, wt = b, A = De(Zn, er, 470296, 0), _ = ve, b = A, A = De(pn, Kt, 666643, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, U = (A = b) + (b = De(or, Sn, 654183, 0)) | 0, A = ve + _ | 0, Io = U, he = b >>> 0 > U >>> 0 ? A + 1 | 0 : A, _ = De(bt, ht, it, 0), A = ve, b = _, _ = De(Tt, 0, St, 0), A = ve + A | 0, A = _ >>> 0 > (b = b + _ | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = b) + (b = De(Ft, 0, xo, 0)) | 0, _ = ve + A | 0, _ = b >>> 0 > U >>> 0 ? _ + 1 | 0 : _, A = De(fn, 0, wn, 0), b = ve + _ | 0, b = A >>> 0 > (U = A + U | 0) >>> 0 ? b + 1 | 0 : b, A = De(en, 0, _n, 0), _ = ve + b | 0, _ = A >>> 0 > (U = A + U | 0) >>> 0 ? _ + 1 | 0 : _, b = De(Ct, 0, Gn, 0), A = ve + _ | 0, A = b >>> 0 > (U = b + U | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Gt, 0, $n, 0), A = ve + A | 0, A = _ >>> 0 > (b = _ + U | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = b) + (b = De(mt, so, qn, 0)) | 0, _ = ve + A | 0, lo = U, b = b >>> 0 > U >>> 0 ? _ + 1 | 0 : _, _ = (A = B[D + 19 | 0]) >>> 24 | 0, co = A << 8 | (no = B[D + 15 | 0] | B[D + 16 | 0] << 8 | B[D + 17 | 0] << 16 | B[D + 18 | 0] << 24) >>> 24, b = ((oi = (A = (U = B[D + 20 | 0]) >>> 16 | 0) | _) >>> 3 | 0) + b | 0, lo = U = (_ = (7 & oi) << 29 | (_ = (U <<= 16) | co) >>> 3) + lo | 0, U = _ >>> 0 > U >>> 0 ? b + 1 | 0 : b, co = no >>> 6 & 2097151, A = De(Tt, 0, it, 0), _ = ve, b = A, A = De(en, 0, St, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, no = (A = b) + (b = De(Ft, 0, wn, 0)) | 0, A = ve + _ | 0, A = b >>> 0 > no >>> 0 ? A + 1 | 0 : A, b = De(fn, 0, $n, 0), _ = ve + A | 0, _ = b >>> 0 > (no = b + no | 0) >>> 0 ? _ + 1 | 0 : _, b = De(_n, 0, xo, 0), A = ve + _ | 0, A = b >>> 0 > (no = b + no | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Ct, 0, qn, 0), b = ve + A | 0, b = _ >>> 0 > (no = _ + no | 0) >>> 0 ? b + 1 | 0 : b, A = De(Gt, 0, Gn, 0), _ = ve + b | 0, A = A >>> 0 > (no = A + no | 0) >>> 0 ? _ + 1 | 0 : _, vs = A = (Oi = no + co | 0) >>> 0 < no >>> 0 ? A + 1 | 0 : A, mu = A = A - ((Oi >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & A) << 11 | (ps = Oi - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + U | 0, Fs = A = b >>> 0 > (qs = b + lo | 0) >>> 0 ? A + 1 | 0 : A, gu = A = A - ((qs >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & A) << 11 | (Hi = qs - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + he | 0, _ = (b >>> 0 > (U = b + Io | 0) >>> 0 ? A + 1 | 0 : A) + wt | 0, wt = (b = U + Gr | 0) - (A = -2097152 & Wn) | 0, Tr = A = (_ = b >>> 0 < U >>> 0 ? _ + 1 | 0 : _) - ((A >>> 0 > b >>> 0) + Tr | 0) | 0, hu = A = A - ((wt >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & A) << 11 | (Wi = wt - -1048576 | 0) >>> 21, A = (A >> 21) + ti | 0, U = A = b >>> 0 > (he = b + Po | 0) >>> 0 ? A + 1 | 0 : A, pa = A = A - ((he >>> 0 < 4293918720) - 1 | 0) | 0, Gi = (2097151 & A) << 11 | (Io = he - -1048576 | 0) >>> 21, Gr = A >> 21, oi = yo - (A = -2097152 & zr) | 0, $o = Ar - ((A >>> 0 > yo >>> 0) + $o | 0) | 0, A = De(ye, 0, Ge, 0), cs = _ = ve, Po = A, no = A - -1048576 | 0, xi = _ = _ - ((A >>> 0 < 4293918720) - 1 | 0) | 0, ur = A = _ >>> 21 | 0, A = De(Kn = (2097151 & _) << 11 | no >>> 21, A, -683901, -1), _ = ve + Fn | 0, _ = A >>> 0 > (b = A + jt | 0) >>> 0 ? _ + 1 | 0 : _, zr = b - (A = -2097152 & an) | 0, Wn = _ - ((A >>> 0 > b >>> 0) + ei | 0) | 0, _ = De(ct, 0, Ct, 0), A = ve, b = _, _ = De(ye, 0, fn, 0), A = ve + A | 0, A = _ >>> 0 > (b = b + _ | 0) >>> 0 ? A + 1 | 0 : A, _ = De(we, 0, Gt, 0), A = ve + A | 0, A = _ >>> 0 > (b = _ + b | 0) >>> 0 ? A + 1 | 0 : A, Fn = (_ = b) + (b = De(Le, 0, mt, so)) | 0, _ = ve + A | 0, _ = b >>> 0 > Fn >>> 0 ? _ + 1 | 0 : _, A = De($e, 0, Tt, 0), b = ve + _ | 0, b = A >>> 0 > (Fn = A + Fn | 0) >>> 0 ? b + 1 | 0 : b, A = De(Be, 0, bt, ht), _ = ve + b | 0, _ = A >>> 0 > (Fn = A + Fn | 0) >>> 0 ? _ + 1 | 0 : _, b = De(Ge, 0, xo, 0), A = ve + _ | 0, A = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? A + 1 | 0 : A, _ = De(je, 0, en, 0), A = ve + A | 0, jt = b = _ + Fn | 0, Fn = _ >>> 0 > b >>> 0 ? A + 1 | 0 : A, A = De(we, 0, fn, 0), _ = ve, b = A, A = De(ye, 0, Ft, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, Ar = (A = De(Le, 0, Ct, 0)) + b | 0, b = ve + _ | 0, b = A >>> 0 > Ar >>> 0 ? b + 1 | 0 : b, A = De(ct, 0, Gt, 0), _ = ve + b | 0, _ = A >>> 0 > (Ar = A + Ar | 0) >>> 0 ? _ + 1 | 0 : _, b = De(mt, so, bt, ht), A = ve + _ | 0, A = b >>> 0 > (Ar = b + Ar | 0) >>> 0 ? A + 1 | 0 : A, _ = De($e, 0, en, 0), A = ve + A | 0, A = _ >>> 0 > (b = _ + Ar | 0) >>> 0 ? A + 1 | 0 : A, Ar = (_ = b) + (b = De(Be, 0, Tt, 0)) | 0, _ = ve + A | 0, _ = b >>> 0 > Ar >>> 0 ? _ + 1 | 0 : _, A = De(Ge, 0, wn, 0), b = ve + _ | 0, b = A >>> 0 > (Ar = A + Ar | 0) >>> 0 ? b + 1 | 0 : b, A = De(je, 0, xo, 0), _ = ve + b | 0, co = _ = A >>> 0 > (lo = A + Ar | 0) >>> 0 ? _ + 1 | 0 : _, Ws = A = _ - ((lo >>> 0 < 4293918720) - 1 | 0) | 0, _ = (2097151 & A) << 11 | (yo = lo - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + Fn | 0, an = A = _ >>> 0 > (ei = _ + jt | 0) >>> 0 ? A + 1 | 0 : A, Ti = A = A - ((ei >>> 0 < 4293918720) - 1 | 0) | 0, _ = (b = A >>> 21 | 0) + Wn | 0, zr = _ = (A = (2097151 & A) << 11 | (Ar = ei - -1048576 | 0) >>> 21) >>> 0 > (ti = A + zr | 0) >>> 0 ? _ + 1 | 0 : _, Ls = A = _ - ((ti >>> 0 < 4293918720) - 1 | 0) | 0, Fn = (2097151 & A) << 11 | (Wn = ti - -1048576 | 0) >>> 21, A = (A >> 21) + $o | 0, Cr = A = (_ = Fn + oi | 0) >>> 0 < Fn >>> 0 ? A + 1 | 0 : A, Je = _, A = De(_, A, -683901, -1), _ = ve + Gr | 0, Gi = b = A + Gi | 0, Gr = A >>> 0 > b >>> 0 ? _ + 1 | 0 : _, A = De(we, 0, it, 0), _ = ve, b = A, A = De(ct, 0, St, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, Fn = (A = b) + (b = De(bt, ht, Ft, 0)) | 0, A = ve + _ | 0, A = b >>> 0 > Fn >>> 0 ? A + 1 | 0 : A, _ = De(Tt, 0, fn, 0), b = ve + A | 0, b = _ >>> 0 > (Fn = _ + Fn | 0) >>> 0 ? b + 1 | 0 : b, _ = De(Le, 0, _n, 0), A = ve + b | 0, A = _ >>> 0 > (Fn = _ + Fn | 0) >>> 0 ? A + 1 | 0 : A, b = De(Ct, 0, xo, 0), _ = ve + A | 0, _ = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? _ + 1 | 0 : _, A = De(Gt, 0, en, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = A + Fn | 0) >>> 0 ? _ + 1 | 0 : _, Fn = (A = b) + (b = De(mt, so, wn, 0)) | 0, A = ve + _ | 0, A = b >>> 0 > Fn >>> 0 ? A + 1 | 0 : A, _ = De($e, 0, Gn, 0), b = ve + A | 0, b = _ >>> 0 > (Fn = _ + Fn | 0) >>> 0 ? b + 1 | 0 : b, _ = De(Be, 0, $n, 0), A = ve + b | 0, A = _ >>> 0 > (Fn = _ + Fn | 0) >>> 0 ? A + 1 | 0 : A, b = De(je, 0, qn, 0), _ = ve + A | 0, $o = Fn = b + Fn | 0, b = b >>> 0 > Fn >>> 0 ? _ + 1 | 0 : _, _ = (A = B[D + 27 | 0]) >>> 24 | 0, jt = A << 8 | vi >>> 24, Fn = 2097151 & ((3 & (_ |= A = (Fn = B[D + 28 | 0]) >>> 16 | 0)) << 30 | (A = (Fn <<= 16) | jt) >>> 2), _ = b, jt = A = Fn + $o | 0, Fn = A >>> 0 < Fn >>> 0 ? _ + 1 | 0 : _, oi = De(Zt, Hn, 470296, 0), $o = ve, A = (b = (2097151 & Xo) << 11 | Go >>> 21) + (Po - (_ = -2097152 & no) | 0) | 0, _ = cs - ((524287 & xi) + (_ >>> 0 > Po >>> 0) | 0) + (Xo >>> 21) | 0, Ve = _ = A >>> 0 < b >>> 0 ? _ + 1 | 0 : _, ut = A, _ = De(A, _, 666643, 0), A = ve + $o | 0, A = _ >>> 0 > (b = _ + oi | 0) >>> 0 ? A + 1 | 0 : A, no = (_ = De(pn, Kt, 654183, 0)) + b | 0, b = ve + A | 0, b = _ >>> 0 > no >>> 0 ? b + 1 | 0 : b, _ = De(Zn, er, -997805, -1), A = ve + b | 0, A = _ >>> 0 > (no = _ + no | 0) >>> 0 ? A + 1 | 0 : A, b = De(or, Sn, 136657, 0), _ = ve + A | 0, ko = (A = (2097151 & Co) << 11 | ko >>> 21) + (no = b + no | 0) | 0, _ = (Co >>> 21 | 0) + (b >>> 0 > no >>> 0 ? _ + 1 | 0 : _) | 0, xi = no = Fn - ((jt >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > ko >>> 0 ? _ + 1 | 0 : _) + Fn | 0, _ = (Fn = jt + ko | 0) - (b = -2097152 & (cs = jt - -1048576 | 0)) | 0, b = (A = (A = Fn >>> 0 < ko >>> 0 ? A + 1 | 0 : A) - ((b >>> 0 > Fn >>> 0) + no | 0) | 0) + Gr | 0, oi = Fn = A - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, Po = (b = (jt = _ + Gi | 0) >>> 0 < _ >>> 0 ? b + 1 | 0 : b) - (((_ = -2097152 & ($o = _ - -1048576 | 0)) >>> 0 > jt >>> 0) + Fn | 0) | 0, vi = A = jt - _ | 0, Fn = he, he = U, zs = ti - (A = -2097152 & Wn) | 0, no = zr - ((A >>> 0 > ti >>> 0) + Ls | 0) | 0, A = De(ut, Ve, -683901, -1), _ = ve, U = (b = A) + (A = De(Kn, ur, 136657, 0)) | 0, b = ve + _ | 0, _ = an + (A >>> 0 > U >>> 0 ? b + 1 | 0 : b) | 0, Ar = (b = U + ei | 0) - (A = -2097152 & Ar) | 0, zr = (_ = b >>> 0 < ei >>> 0 ? _ + 1 | 0 : _) - ((A >>> 0 > b >>> 0) + Ti | 0) | 0, _ = De(Kn, ur, -997805, -1), A = ve + co | 0, A = _ >>> 0 > (b = _ + lo | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = De(ut, Ve, 136657, 0)) + b | 0, b = ve + A | 0, b = _ >>> 0 > U >>> 0 ? b + 1 | 0 : b, A = De(Zt, Hn, -683901, -1), _ = ve + b | 0, _ = A >>> 0 > (U = A + U | 0) >>> 0 ? _ + 1 | 0 : _, Wn = U - (A = -2097152 & yo) | 0, Gr = _ - ((A >>> 0 > U >>> 0) + Ws | 0) | 0, _ = De(ct, 0, fn, 0), A = ve, b = _, _ = De(we, 0, Ft, 0), A = ve + A | 0, A = _ >>> 0 > (b = b + _ | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = De(ye, 0, _n, 0)) + b | 0, b = ve + A | 0, b = _ >>> 0 > U >>> 0 ? b + 1 | 0 : b, A = De(bt, ht, Ct, 0), _ = ve + b | 0, _ = A >>> 0 > (U = A + U | 0) >>> 0 ? _ + 1 | 0 : _, b = De(Le, 0, Gt, 0), A = ve + _ | 0, A = b >>> 0 > (U = b + U | 0) >>> 0 ? A + 1 | 0 : A, b = De(mt, so, Tt, 0), _ = ve + A | 0, _ = b >>> 0 > (U = b + U | 0) >>> 0 ? _ + 1 | 0 : _, b = De($e, 0, xo, 0), A = ve + _ | 0, A = b >>> 0 > (U = b + U | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Be, 0, en, 0), b = ve + A | 0, b = _ >>> 0 > (U = _ + U | 0) >>> 0 ? b + 1 | 0 : b, A = De(Ge, 0, $n, 0), _ = ve + b | 0, _ = A >>> 0 > (U = A + U | 0) >>> 0 ? _ + 1 | 0 : _, b = De(je, 0, wn, 0), A = ve + _ | 0, jt = U = b + U | 0, U = b >>> 0 > U >>> 0 ? A + 1 | 0 : A, A = De(ct, 0, Ft, 0), _ = ve, b = A, A = De(ye, 0, St, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, an = (A = b) + (b = De(Le, 0, fn, 0)) | 0, A = ve + _ | 0, A = b >>> 0 > an >>> 0 ? A + 1 | 0 : A, _ = De(we, 0, _n, 0), b = ve + A | 0, b = _ >>> 0 > (an = _ + an | 0) >>> 0 ? b + 1 | 0 : b, A = De(Ct, 0, Tt, 0), _ = ve + b | 0, _ = A >>> 0 > (an = A + an | 0) >>> 0 ? _ + 1 | 0 : _, b = De(bt, ht, Gt, 0), A = ve + _ | 0, A = b >>> 0 > (an = b + an | 0) >>> 0 ? A + 1 | 0 : A, b = De(mt, so, en, 0), _ = ve + A | 0, _ = b >>> 0 > (an = b + an | 0) >>> 0 ? _ + 1 | 0 : _, b = De($e, 0, wn, 0), A = ve + _ | 0, A = b >>> 0 > (an = b + an | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Be, 0, xo, 0), b = ve + A | 0, b = _ >>> 0 > (an = _ + an | 0) >>> 0 ? b + 1 | 0 : b, an = (A = De(Ge, 0, Gn, 0)) + an | 0, _ = ve + b | 0, b = De(je, 0, $n, 0), A = ve + (A >>> 0 > an >>> 0 ? _ + 1 | 0 : _) | 0, ti = A = b >>> 0 > (Ls = b + an | 0) >>> 0 ? A + 1 | 0 : A, cr = A = A - ((Ls >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & A) << 11 | (Xo = Ls - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + U | 0, Go = A = b >>> 0 > (Gi = b + jt | 0) >>> 0 ? A + 1 | 0 : A, Rr = A = A - ((Gi >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & A) << 11 | (Co = Gi - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + Gr | 0, ko = A = b >>> 0 > (ei = b + Wn | 0) >>> 0 ? A + 1 | 0 : A, Ir = A = A - ((ei >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & A) << 11 | (co = ei - -1048576 | 0) >>> 21, A = (A >> 21) + zr | 0, U = A = b >>> 0 > (Wn = b + Ar | 0) >>> 0 ? A + 1 | 0 : A, zr = A = A - ((Wn >>> 0 < 4293918720) - 1 | 0) | 0, Gr = (2097151 & A) << 11 | (b = Wn - -1048576 | 0) >>> 21, A = (A >> 21) + no | 0, Ws = A = (jt = Gr + zs | 0) >>> 0 < Gr >>> 0 ? A + 1 | 0 : A, Ti = jt, A = De(jt, A, -683901, -1), _ = ve, jt = A, A = De(Je, Cr, 136657, 0), _ = ve + _ | 0, A = (A >>> 0 > (jt = jt + A | 0) >>> 0 ? _ + 1 | 0 : _) + he | 0, Au = (he = Fn + jt | 0) - (_ = -2097152 & Io) | 0, yu = (A = he >>> 0 < jt >>> 0 ? A + 1 | 0 : A) - ((_ >>> 0 > he >>> 0) + pa | 0) | 0, Gr = wt, jt = Tr, wt = De(Ti, Ws, 136657, 0), he = ve, zs = A = Wn - (_ = -2097152 & b) | 0, Nn = U = U - ((_ >>> 0 > Wn >>> 0) + zr | 0) | 0, b = De(Je, Cr, -997805, -1), _ = ve + he | 0, _ = b >>> 0 > (wt = b + wt | 0) >>> 0 ? _ + 1 | 0 : _, b = De(A, U, -683901, -1), A = ve + _ | 0, pa = U = b + wt | 0, Fn = b >>> 0 > U >>> 0 ? A + 1 | 0 : A, A = De(or, Sn, 470296, 0), _ = ve, U = (b = A) + (A = De(Zn, er, 666643, 0)) | 0, b = ve + _ | 0, _ = Fs + (A >>> 0 > U >>> 0 ? b + 1 | 0 : b) | 0, no = A = U + qs | 0, he = _ = A >>> 0 < qs >>> 0 ? _ + 1 | 0 : _, _ = De(or, Sn, 666643, 0), A = ve + vs | 0, A = _ >>> 0 > (b = _ + Oi | 0) >>> 0 ? A + 1 | 0 : A, Ar = b - (_ = -2097152 & ps) | 0, lo = A - ((_ >>> 0 > b >>> 0) + mu | 0) | 0, _ = De(en, 0, it, 0), A = ve, b = _, _ = De(St, 0, xo, 0), A = ve + A | 0, A = _ >>> 0 > (b = b + _ | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = b) + (b = De(Ft, 0, $n, 0)) | 0, _ = ve + A | 0, _ = b >>> 0 > U >>> 0 ? _ + 1 | 0 : _, b = De(fn, 0, Gn, 0), A = ve + _ | 0, A = b >>> 0 > (U = b + U | 0) >>> 0 ? A + 1 | 0 : A, _ = De(_n, 0, wn, 0), b = ve + A | 0, b = _ >>> 0 > (U = _ + U | 0) >>> 0 ? b + 1 | 0 : b, A = De(Gt, 0, qn, 0), _ = ve + b | 0, Wn = U = A + U | 0, U = A >>> 0 > U >>> 0 ? _ + 1 | 0 : _, _ = (A = B[D + 14 | 0]) >>> 24 | 0, wt = A << 8 | (zr = B[D + 10 | 0] | B[D + 11 | 0] << 8 | B[D + 12 | 0] << 16 | B[D + 13 | 0] << 24) >>> 24, _ = 2097151 & ((1 & (_ |= b = (A = B[D + 15 | 0]) >>> 16 | 0)) << 31 | (A = wt | A << 16) >>> 1), A = U, Wn = b = _ + Wn | 0, U = _ >>> 0 > b >>> 0 ? A + 1 | 0 : A, wt = zr >>> 4 & 2097151, A = De(it, 0, xo, 0), _ = ve, b = A, A = De(St, 0, wn, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, A = De(Ft, 0, Gn, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = A + b | 0) >>> 0 ? _ + 1 | 0 : _, zr = (A = b) + (b = De(fn, 0, qn, 0)) | 0, A = ve + _ | 0, A = b >>> 0 > zr >>> 0 ? A + 1 | 0 : A, _ = De(_n, 0, $n, 0), b = ve + A | 0, A = _ >>> 0 > (zr = _ + zr | 0) >>> 0 ? b + 1 | 0 : b, Tr = A = (ps = wt + zr | 0) >>> 0 < zr >>> 0 ? A + 1 | 0 : A, Pr = A = A - ((ps >>> 0 < 4293918720) - 1 | 0) | 0, _ = (b = A >>> 21 | 0) + U | 0, yo = _ = (A = (2097151 & A) << 11 | (Io = ps - -1048576 | 0) >>> 21) >>> 0 > (Fs = A + Wn | 0) >>> 0 ? _ + 1 | 0 : _, qr = A = _ - ((Fs >>> 0 < 4293918720) - 1 | 0) | 0, _ = (2097151 & A) << 11 | (an = Fs - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + lo | 0, zr = A = _ >>> 0 > (Ar = _ + Ar | 0) >>> 0 ? A + 1 | 0 : A, ao = A = A - ((Ar >>> 0 < 4293918720) - 1 | 0) | 0, _ = (b = A >> 21) + he | 0, mu = _ = (_ = (A = (2097151 & A) << 11 | (Wn = Ar - -1048576 | 0) >>> 21) >>> 0 > (U = A + no | 0) >>> 0 ? _ + 1 | 0 : _) - (((b = -2097152 & Hi) >>> 0 > U >>> 0) + gu | 0) | 0, Hi = A = U - b | 0, wt = A - -1048576 | 0, gu = A = _ - ((A >>> 0 < 4293918720) - 1 | 0) | 0, b = (_ = A >> 21) + Fn | 0, _ = ((A = (2097151 & A) << 11 | wt >>> 21) >>> 0 > (U = A + pa | 0) >>> 0 ? b + 1 | 0 : b) + jt | 0, Oi = _ = (_ = (A = U) >>> 0 > (U = U + Gr | 0) >>> 0 ? _ + 1 | 0 : _) - (((b = -2097152 & Wi) >>> 0 > U >>> 0) + hu | 0) | 0, jt = A = U - b | 0, he = A - -1048576 | 0, vs = A = _ - ((A >>> 0 < 4293918720) - 1 | 0) | 0, b = (_ = A >> 21) + yu | 0, Wi = A = (b = (A = (2097151 & A) << 11 | he >>> 21) >>> 0 > (Fn = A + Au | 0) >>> 0 ? b + 1 | 0 : b) - ((Fn >>> 0 < 4293918720) - 1 | 0) | 0, no = vi - -1048576 | 0, lo = Po - ((vi >>> 0 < 4293918720) - 1 | 0) | 0, Gr = (2097151 & A) << 11 | (U = Fn - -1048576 | 0) >>> 21, A = (A >> 21) + Po | 0, hu = (vi = Gr + vi | 0) - (_ = -2097152 & no) | 0, Au = (Gr >>> 0 > vi >>> 0 ? A + 1 | 0 : A) - ((_ >>> 0 > vi >>> 0) + lo | 0) | 0, yu = Fn - (A = -2097152 & U) | 0, pa = b - ((A >>> 0 > Fn >>> 0) + Wi | 0) | 0, qs = jt - (A = -2097152 & he) | 0, vi = Oi - ((A >>> 0 > jt >>> 0) + vs | 0) | 0, A = De(Ti, Ws, -997805, -1), _ = ve, b = A, A = De(Je, Cr, 654183, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, U = (A = b) + (b = De(zs, Nn, 136657, 0)) | 0, A = ve + _ | 0, _ = mu + (b >>> 0 > U >>> 0 ? A + 1 | 0 : A) | 0, Oi = (b = U + Hi | 0) - (A = -2097152 & wt) | 0, vs = (_ = b >>> 0 < Hi >>> 0 ? _ + 1 | 0 : _) - ((A >>> 0 > b >>> 0) + gu | 0) | 0, Hi = ei - (A = -2097152 & co) | 0, Po = ko - ((A >>> 0 > ei >>> 0) + Ir | 0) | 0, _ = De(ut, Ve, -997805, -1), A = ve, b = _, _ = De(Kn, ur, 654183, 0), A = ve + A | 0, A = _ >>> 0 > (b = b + _ | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = b) + (b = De(Zt, Hn, 136657, 0)) | 0, _ = ve + A | 0, _ = b >>> 0 > U >>> 0 ? _ + 1 | 0 : _, A = De(pn, Kt, -683901, -1), b = ve + _ | 0, _ = Go + (A >>> 0 > (U = A + U | 0) >>> 0 ? b + 1 | 0 : b) | 0, co = (b = U + Gi | 0) - (A = -2097152 & Co) | 0, ko = (_ = b >>> 0 < Gi >>> 0 ? _ + 1 | 0 : _) - ((A >>> 0 > b >>> 0) + Rr | 0) | 0, _ = De(ut, Ve, 654183, 0), A = ve, b = _, _ = De(Kn, ur, 470296, 0), A = ve + A | 0, A = _ >>> 0 > (b = b + _ | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = De(Zt, Hn, -997805, -1)) + b | 0, b = ve + A | 0, _ = ti + (_ >>> 0 > U >>> 0 ? b + 1 | 0 : b) | 0, _ = (A = U + Ls | 0) >>> 0 < Ls >>> 0 ? _ + 1 | 0 : _, b = A, A = De(pn, Kt, 136657, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, U = (A = b) + (b = De(Zn, er, -683901, -1)) | 0, A = ve + _ | 0, wt = U - (_ = -2097152 & Xo) | 0, he = (b >>> 0 > U >>> 0 ? A + 1 | 0 : A) - ((_ >>> 0 > U >>> 0) + cr | 0) | 0, U = (B[D + 28 | 0] | B[D + 29 | 0] << 8 | B[D + 30 | 0] << 16 | B[D + 31 | 0] << 24) >>> 7 | 0, A = De(ye, 0, it, 0), _ = ve, Fn = (b = A) + (A = De(we, 0, St, 0)) | 0, b = ve + _ | 0, b = A >>> 0 > Fn >>> 0 ? b + 1 | 0 : b, A = De(Le, 0, Ft, 0), _ = ve + b | 0, _ = A >>> 0 > (Fn = A + Fn | 0) >>> 0 ? _ + 1 | 0 : _, b = De(bt, ht, fn, 0), A = ve + _ | 0, A = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? A + 1 | 0 : A, b = De(ct, 0, _n, 0), _ = ve + A | 0, _ = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? _ + 1 | 0 : _, b = De(Ct, 0, en, 0), A = ve + _ | 0, A = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Tt, 0, Gt, 0), b = ve + A | 0, b = _ >>> 0 > (Fn = _ + Fn | 0) >>> 0 ? b + 1 | 0 : b, A = De(mt, so, xo, 0), _ = ve + b | 0, _ = A >>> 0 > (Fn = A + Fn | 0) >>> 0 ? _ + 1 | 0 : _, b = De($e, 0, $n, 0), A = ve + _ | 0, A = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? A + 1 | 0 : A, b = De(Be, 0, wn, 0), _ = ve + A | 0, _ = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? _ + 1 | 0 : _, b = De(Ge, 0, qn, 0), A = ve + _ | 0, A = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? A + 1 | 0 : A, _ = De(je, 0, Gn, 0), b = ve + A | 0, _ = _ >>> 0 > (Fn = _ + Fn | 0) >>> 0 ? b + 1 | 0 : b, Go = (b = (2097151 & xi) << 11 | cs >>> 21) + (A = U + Fn | 0) | 0, A = (xi >>> 21 | 0) + (_ = A >>> 0 < Fn >>> 0 ? _ + 1 | 0 : _) | 0, Gr = A = b >>> 0 > Go >>> 0 ? A + 1 | 0 : A, Wi = _ = A - ((Go >>> 0 < 4293918720) - 1 | 0) | 0, b = (A = _ >>> 21 | 0) + he | 0, jt = b = (_ = (2097151 & _) << 11 | (so = Go - -1048576 | 0) >>> 21) >>> 0 > (Co = _ + wt | 0) >>> 0 ? b + 1 | 0 : b, cs = _ = b - ((Co >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = _ >> 21) + ko | 0, wt = A = (_ = (2097151 & _) << 11 | (Fn = Co - -1048576 | 0) >>> 21) >>> 0 > (co = _ + co | 0) >>> 0 ? A + 1 | 0 : A, Xo = _ = A - ((co >>> 0 < 4293918720) - 1 | 0) | 0, b = (A = _ >> 21) + Po | 0, xi = b = (_ = (U = (2097151 & _) << 11 | (he = co - -1048576 | 0) >>> 21) + Hi | 0) >>> 0 < U >>> 0 ? b + 1 | 0 : b, Po = _, A = De(_, b, -683901, -1), _ = ve + vs | 0, ko = b = A + Oi | 0, U = A >>> 0 > b >>> 0 ? _ + 1 | 0 : _, _ = De(Je, Cr, 470296, 0), A = ve + zr | 0, A = _ >>> 0 > (Ar = _ + Ar | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Ti, Ws, 654183, 0), A = ve + (A - (((b = -2097152 & Wn) >>> 0 > Ar >>> 0) + ao | 0) | 0) | 0, A = _ >>> 0 > (Wn = _ + (Ar - b | 0) | 0) >>> 0 ? A + 1 | 0 : A, b = De(zs, Nn, -997805, -1), _ = ve + A | 0, _ = b >>> 0 > (Wn = b + Wn | 0) >>> 0 ? _ + 1 | 0 : _, ti = b = co - (A = -2097152 & he) | 0, xo = wt = wt - ((A >>> 0 > co >>> 0) + Xo | 0) | 0, Wn = (he = De(Po, xi, 136657, 0)) + Wn | 0, A = ve + _ | 0, b = De(b, wt, -683901, -1), _ = ve + (he >>> 0 > Wn >>> 0 ? A + 1 | 0 : A) | 0, wt = _ = b >>> 0 > (zr = b + Wn | 0) >>> 0 ? _ + 1 | 0 : _, Xo = A = _ - ((zr >>> 0 < 4293918720) - 1 | 0) | 0, _ = (2097151 & A) << 11 | (he = zr - -1048576 | 0) >>> 21, A = (A >> 21) + U | 0, co = _ = (A = _ >>> 0 > (Wn = _ + ko | 0) >>> 0 ? A + 1 | 0 : A) - ((Wn >>> 0 < 4293918720) - 1 | 0) | 0, Ar = (2097151 & _) << 11 | (U = Wn - -1048576 | 0) >>> 21, _ = (_ >> 21) + vi | 0, qs = ko = Ar + qs | 0, ko = Ar >>> 0 > ko >>> 0 ? _ + 1 | 0 : _, vi = Wn - (_ = -2097152 & U) | 0, Ls = A - ((_ >>> 0 > Wn >>> 0) + co | 0) | 0, Oi = zr - (A = -2097152 & he) | 0, vs = wt - ((A >>> 0 > zr >>> 0) + Xo | 0) | 0, A = De(Je, Cr, 666643, 0), b = yo + ve | 0, b = (he = A + Fs | 0) >>> 0 < Fs >>> 0 ? b + 1 | 0 : b, U = (A = De(Ti, Ws, 470296, 0)) + (he - (_ = -2097152 & an) | 0) | 0, _ = ve + (b - ((_ >>> 0 > he >>> 0) + qr | 0) | 0) | 0, _ = A >>> 0 > U >>> 0 ? _ + 1 | 0 : _, b = De(zs, Nn, 654183, 0), A = ve + _ | 0, Wn = U = b + U | 0, U = b >>> 0 > U >>> 0 ? A + 1 | 0 : A, he = Co - (A = -2097152 & Fn) | 0, wt = jt - ((A >>> 0 > Co >>> 0) + cs | 0) | 0, A = De(ut, Ve, 470296, 0), _ = ve, b = A, A = De(Kn, ur, 666643, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, A = De(Zt, Hn, 654183, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = A + b | 0) >>> 0 ? _ + 1 | 0 : _, Fn = (A = b) + (b = De(pn, Kt, -997805, -1)) | 0, A = ve + _ | 0, A = b >>> 0 > Fn >>> 0 ? A + 1 | 0 : A, _ = De(Zn, er, 136657, 0), A = ve + A | 0, A = _ >>> 0 > (b = _ + Fn | 0) >>> 0 ? A + 1 | 0 : A, Fn = (_ = De(or, Sn, -683901, -1)) + b | 0, b = ve + A | 0, _ = Gr + (_ >>> 0 > Fn >>> 0 ? b + 1 | 0 : b) | 0, Co = (b = (2097151 & oi) << 11 | $o >>> 21) + ((Fn = Fn + Go | 0) - (A = -2097152 & so) | 0) | 0, A = ((_ = Fn >>> 0 < Go >>> 0 ? _ + 1 | 0 : _) - ((A >>> 0 > Fn >>> 0) + Wi | 0) | 0) + (oi >> 21) | 0, co = A = b >>> 0 > Co >>> 0 ? A + 1 | 0 : A, Hi = A = A - ((Co >>> 0 < 4293918720) - 1 | 0) | 0, _ = he, he = (2097151 & A) << 11 | (an = Co - -1048576 | 0) >>> 21, A = (A >> 21) + wt | 0, Xo = A = (b = _ + he | 0) >>> 0 < he >>> 0 ? A + 1 | 0 : A, Go = b, A = De(b, A, -683901, -1), _ = ve + U | 0, _ = A >>> 0 > (b = A + Wn | 0) >>> 0 ? _ + 1 | 0 : _, U = (A = b) + (b = De(Po, xi, -997805, -1)) | 0, A = ve + _ | 0, A = b >>> 0 > U >>> 0 ? A + 1 | 0 : A, _ = De(ti, xo, 136657, 0), b = ve + A | 0, $o = U = _ + U | 0, jt = _ >>> 0 > U >>> 0 ? b + 1 | 0 : b, Wn = ps - (A = -2097152 & Io) | 0, Gr = Tr - ((A >>> 0 > ps >>> 0) + Pr | 0) | 0, _ = De(it, 0, wn, 0), A = ve, b = _, _ = De(St, 0, $n, 0), A = ve + A | 0, A = _ >>> 0 > (b = b + _ | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Ft, 0, qn, 0), A = ve + A | 0, A = _ >>> 0 > (b = _ + b | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = De(_n, 0, Gn, 0)) + b | 0, b = ve + A | 0, _ = _ >>> 0 > U >>> 0 ? b + 1 | 0 : b, so = b = (A = (B[D + 7 | 0] | B[D + 8 | 0] << 8 | B[D + 9 | 0] << 16 | B[D + 10 | 0] << 24) >>> 7 & 2097151) + U | 0, Fn = A >>> 0 > b >>> 0 ? _ + 1 | 0 : _, A = De(it, 0, $n, 0), _ = ve, b = A, A = De(St, 0, Gn, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = b + A | 0) >>> 0 ? _ + 1 | 0 : _, U = (A = b) + (b = De(_n, 0, qn, 0)) | 0, A = ve + _ | 0, wt = U, U = b >>> 0 > U >>> 0 ? A + 1 | 0 : A, A = (_ = B[D + 6 | 0]) >>> 24 | 0, he = _ << 8 | (Wi = B[D + 2 | 0] | B[D + 3 | 0] << 8 | B[D + 4 | 0] << 16 | B[D + 5 | 0] << 24) >>> 24, b = A, _ = (A = B[D + 7 | 0]) >>> 16 | 0, _ |= b, b = U, he = b = (A = 2097151 & ((3 & _) << 30 | (A = A << 16 | he) >>> 2)) >>> 0 > (wt = A + wt | 0) >>> 0 ? b + 1 | 0 : b, Gi = A = b - ((wt >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & A) << 11 | (yo = wt - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + Fn | 0, Ar = A = b >>> 0 > (Tr = b + so | 0) >>> 0 ? A + 1 | 0 : A, cs = A = A - ((Tr >>> 0 < 4293918720) - 1 | 0) | 0, b = (_ = A >>> 21 | 0) + Gr | 0, b = (A = (2097151 & A) << 11 | (zr = Tr - -1048576 | 0) >>> 21) >>> 0 > (U = A + Wn | 0) >>> 0 ? b + 1 | 0 : b, _ = De(Ti, Ws, 666643, 0), A = ve + b | 0, A = _ >>> 0 > (U = _ + U | 0) >>> 0 ? A + 1 | 0 : A, _ = De(zs, Nn, 470296, 0), A = ve + A | 0, A = _ >>> 0 > (b = _ + U | 0) >>> 0 ? A + 1 | 0 : A, U = (_ = b) + (b = De(Go, Xo, 136657, 0)) | 0, _ = ve + A | 0, _ = b >>> 0 > U >>> 0 ? _ + 1 | 0 : _, A = De(Po, xi, 654183, 0), _ = ve + _ | 0, _ = A >>> 0 > (b = A + U | 0) >>> 0 ? _ + 1 | 0 : _, Wn = (A = De(ti, xo, -997805, -1)) + b | 0, b = ve + _ | 0, Gr = b = A >>> 0 > Wn >>> 0 ? b + 1 | 0 : b, oi = A = b - ((Wn >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & A) << 11 | (so = Wn - -1048576 | 0) >>> 21, A = (A >> 21) + jt | 0, $o = b = (A = b >>> 0 > (U = b + $o | 0) >>> 0 ? A + 1 | 0 : A) - ((U >>> 0 < 4293918720) - 1 | 0) | 0, Fn = (2097151 & b) << 11 | (jt = U - -1048576 | 0) >>> 21, b = (b >> 21) + vs | 0, ei = Io = Fn + Oi | 0, Io = Fn >>> 0 > Io >>> 0 ? b + 1 | 0 : b, Fn = U, _ = A, U = (Co - (A = -2097152 & an) | 0) + (an = (2097151 & lo) << 11 | no >>> 21) | 0, A = (co - ((A >>> 0 > Co >>> 0) + Hi | 0) | 0) + (lo >> 21) | 0, no = A = U >>> 0 < an >>> 0 ? A + 1 | 0 : A, Oi = A = A - ((U >>> 0 < 4293918720) - 1 | 0) | 0, Co = b = A >> 21, A = De(Ti = (2097151 & A) << 11 | (lo = U - -1048576 | 0) >>> 21, b, -683901, -1), _ = ve + _ | 0, _ = A >>> 0 > (b = A + Fn | 0) >>> 0 ? _ + 1 | 0 : _, vs = b - (A = -2097152 & jt) | 0, ps = _ - ((A >>> 0 > b >>> 0) + $o | 0) | 0, _ = De(Ti, Co, 136657, 0), A = ve + Gr | 0, A = _ >>> 0 > (b = _ + Wn | 0) >>> 0 ? A + 1 | 0 : A, Fs = b - (_ = -2097152 & so) | 0, oi = A - ((_ >>> 0 > b >>> 0) + oi | 0) | 0, _ = De(zs, Nn, 666643, 0), A = ve + (Ar - (((b = -2097152 & zr) >>> 0 > Tr >>> 0) + cs | 0) | 0) | 0, A = _ >>> 0 > (Fn = _ + (Tr - b | 0) | 0) >>> 0 ? A + 1 | 0 : A, b = De(Go, Xo, -997805, -1), _ = ve + A | 0, _ = b >>> 0 > (Fn = b + Fn | 0) >>> 0 ? _ + 1 | 0 : _, A = De(Po, xi, 470296, 0), b = ve + _ | 0, b = A >>> 0 > (Fn = A + Fn | 0) >>> 0 ? b + 1 | 0 : b, _ = De(ti, xo, 654183, 0), A = ve + b | 0, $o = Fn = _ + Fn | 0, Gr = _ >>> 0 > Fn >>> 0 ? A + 1 | 0 : A, b = Wi >>> 5 & 2097151, A = De(it, 0, Gn, 0), _ = ve, jt = A, A = De(St, 0, qn, 0), _ = ve + _ | 0, A = A >>> 0 > (Fn = jt + A | 0) >>> 0 ? _ + 1 | 0 : _, jt = _ = b + Fn | 0, b = A = _ >>> 0 < Fn >>> 0 ? A + 1 | 0 : A, Tr = (_ = De(it, 0, qn, 0)) + (A = (A = B[D + 2 | 0]) << 16 & 2031616 | B[0 | D] | B[D + 1 | 0] << 8) | 0, _ = ve, an = _ = A >>> 0 > Tr >>> 0 ? _ + 1 | 0 : _, Hi = _ = _ - ((Tr >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = _ >>> 21 | 0) + b | 0, zr = A = (_ = (2097151 & _) << 11 | (Ar = Tr - -1048576 | 0) >>> 21) >>> 0 > (co = _ + jt | 0) >>> 0 ? A + 1 | 0 : A, Wi = _ = A - ((co >>> 0 < 4293918720) - 1 | 0) | 0, b = (2097151 & _) << 11 | (Wn = co - -1048576 | 0) >>> 21, _ = (_ >>> 21 | 0) + he | 0, _ = b >>> 0 > (Fn = b + wt | 0) >>> 0 ? _ + 1 | 0 : _, b = De(Go, Xo, 654183, 0), A = ve + (_ - (((he = -2097152 & yo) >>> 0 > Fn >>> 0) + Gi | 0) | 0) | 0, A = b >>> 0 > (wt = b + (Fn - he | 0) | 0) >>> 0 ? A + 1 | 0 : A, _ = De(Po, xi, 666643, 0), A = ve + A | 0, A = _ >>> 0 > (b = _ + wt | 0) >>> 0 ? A + 1 | 0 : A, so = (_ = b) + (b = De(ti, xo, 470296, 0)) | 0, _ = ve + A | 0, jt = _ = b >>> 0 > so >>> 0 ? _ + 1 | 0 : _, cs = _ = _ - ((so >>> 0 < 4293918720) - 1 | 0) | 0, b = (A = _ >> 21) + Gr | 0, yo = _ = (b = (_ = (2097151 & _) << 11 | (Fn = so - -1048576 | 0) >>> 21) >>> 0 > (wt = _ + $o | 0) >>> 0 ? b + 1 | 0 : b) - ((wt >>> 0 < 4293918720) - 1 | 0) | 0, Gr = (2097151 & _) << 11 | (he = wt - -1048576 | 0) >>> 21, _ = (_ >> 21) + oi | 0, xi = Po = Gr + Fs | 0, Gr = Gr >>> 0 > Po >>> 0 ? _ + 1 | 0 : _, A = De(Ti, Co, -997805, -1), _ = ve + b | 0, _ = A >>> 0 > (wt = A + wt | 0) >>> 0 ? _ + 1 | 0 : _, oi = wt - (A = -2097152 & he) | 0, $o = _ - ((A >>> 0 > wt >>> 0) + yo | 0) | 0, _ = De(Ti, Co, 654183, 0), A = ve + jt | 0, A = _ >>> 0 > (b = _ + so | 0) >>> 0 ? A + 1 | 0 : A, Po = b - (_ = -2097152 & Fn) | 0, yo = A - ((_ >>> 0 > b >>> 0) + cs | 0) | 0, A = De(Go, Xo, 470296, 0), b = ve + (zr - (((_ = -2097152 & Wn) >>> 0 > co >>> 0) + Wi | 0) | 0) | 0, b = A >>> 0 > (he = A + (co - _ | 0) | 0) >>> 0 ? b + 1 | 0 : b, _ = De(ti, xo, 666643, 0), A = ve + b | 0, wt = he = _ + he | 0, b = _ >>> 0 > he >>> 0 ? A + 1 | 0 : A, _ = De(Go, Xo, 666643, 0), A = ve + (an - ((4095 & Hi) + ((he = -2097152 & Ar) >>> 0 > Tr >>> 0) | 0) | 0) | 0, so = A = _ >>> 0 > (Wn = _ + (Tr - he | 0) | 0) >>> 0 ? A + 1 | 0 : A, an = A = A - ((Wn >>> 0 < 4293918720) - 1 | 0) | 0, he = (2097151 & A) << 11 | (jt = Wn - -1048576 | 0) >>> 21, A = (A >> 21) + b | 0, b = A = he >>> 0 > (Fn = he + wt | 0) >>> 0 ? A + 1 | 0 : A, Ar = A = A - ((Fn >>> 0 < 4293918720) - 1 | 0) | 0, he = (2097151 & A) << 11 | (wt = Fn - -1048576 | 0) >>> 21, A = (A >> 21) + yo | 0, he = he >>> 0 > (zr = he + Po | 0) >>> 0 ? A + 1 | 0 : A, A = De(Ti, Co, 470296, 0), b = ve + b | 0, b = A >>> 0 > (_ = A + Fn | 0) >>> 0 ? b + 1 | 0 : b, Fn = _ - (A = -2097152 & wt) | 0, wt = b - ((A >>> 0 > _ >>> 0) + Ar | 0) | 0, _ = De(Ti, Co, 666643, 0), A = ve + (so - (((b = -2097152 & jt) >>> 0 > Wn >>> 0) + an | 0) | 0) | 0, _ = (b = (A = _ >>> 0 > (co = _ + (Wn - b | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + wt | 0, A = (A = (_ = (A = (2097151 & A) << 11 | co >>> 21) >>> 0 > (yo = A + Fn | 0) >>> 0 ? _ + 1 | 0 : _) >> 21) + he | 0, _ = (_ = (A = (_ = (2097151 & _) << 11 | yo >>> 21) >>> 0 > (an = _ + zr | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + $o | 0, b = (A = (_ = (A = (2097151 & A) << 11 | an >>> 21) >>> 0 > (he = A + oi | 0) >>> 0 ? _ + 1 | 0 : _) >> 21) + Gr | 0, A = (_ = (b = (_ = (2097151 & _) << 11 | he >>> 21) >>> 0 > (Ar = _ + xi | 0) >>> 0 ? b + 1 | 0 : b) >> 21) + ps | 0, _ = (b = (A = (b = (2097151 & b) << 11 | Ar >>> 21) >>> 0 > (zr = b + vs | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + Io | 0, A = (A = (_ = (A = (2097151 & A) << 11 | zr >>> 21) >>> 0 > (Wn = A + ei | 0) >>> 0 ? _ + 1 | 0 : _) >> 21) + Ls | 0, _ = (_ = (A = (_ = (2097151 & _) << 11 | Wn >>> 21) >>> 0 > (Gr = _ + vi | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + ko | 0, b = (A = (_ = (A = (2097151 & A) << 11 | Gr >>> 21) >>> 0 > (so = A + qs | 0) >>> 0 ? _ + 1 | 0 : _) >> 21) + pa | 0, A = (_ = (b = (_ = (2097151 & _) << 11 | so >>> 21) >>> 0 > (jt = _ + yu | 0) >>> 0 ? b + 1 | 0 : b) >> 21) + Au | 0, wt = (lo = U - (_ = -2097152 & lo) | 0) + ((2097151 & (A = (b = (2097151 & b) << 11 | jt >>> 21) >>> 0 > (Fn = b + hu | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | Fn >>> 21) | 0, A = (no - ((_ >>> 0 > U >>> 0) + Oi | 0) | 0) + (A >> 21) | 0, lo = _ = (A = wt >>> 0 < lo >>> 0 ? A + 1 | 0 : A) >> 21, co = (A = De(Io = (2097151 & A) << 11 | wt >>> 21, _, 666643, 0)) + (_ = 2097151 & co) | 0, A = ve, U = A = _ >>> 0 > co >>> 0 ? A + 1 | 0 : A, j[0 | ie] = co, j[ie + 1 | 0] = (255 & A) << 24 | co >>> 8, A = 2097151 & yo, _ = De(Io, lo, 470296, 0) + A | 0, b = ve, A = (U >> 21) + (A >>> 0 > _ >>> 0 ? b + 1 | 0 : b) | 0, A = (no = (2097151 & U) << 11 | co >>> 21) >>> 0 > (yo = no + _ | 0) >>> 0 ? A + 1 | 0 : A, j[ie + 4 | 0] = (2047 & A) << 21 | yo >>> 11, _ = A, b = yo, j[ie + 3 | 0] = (7 & A) << 29 | b >>> 3, j[ie + 2 | 0] = 31 & ((65535 & U) << 16 | co >>> 16) | b << 5, U = 2097151 & an, an = De(Io, lo, 654183, 0) + U | 0, A = ve, yo = (2097151 & _) << 11 | b >>> 21, _ = (_ >> 21) + (U = U >>> 0 > an >>> 0 ? A + 1 | 0 : A) | 0, A = _ = (an = yo + an | 0) >>> 0 < yo >>> 0 ? _ + 1 | 0 : _, j[ie + 6 | 0] = (63 & A) << 26 | an >>> 6, U = an, an = 0, j[ie + 5 | 0] = an << 13 | (1572864 & b) >>> 19 | U << 2, b = 2097151 & he, he = De(Io, lo, -997805, -1) + b | 0, _ = ve, _ = b >>> 0 > he >>> 0 ? _ + 1 | 0 : _, an = (2097151 & (b = A)) << 11 | U >>> 21, b = (A >>= 21) + _ | 0, b = (he = an + he | 0) >>> 0 < an >>> 0 ? b + 1 | 0 : b, j[ie + 9 | 0] = (511 & b) << 23 | he >>> 9, j[ie + 8 | 0] = (1 & b) << 31 | he >>> 1, _ = 0, j[ie + 7 | 0] = _ << 18 | (2080768 & U) >>> 14 | he << 7, _ = 2097151 & Ar, U = De(Io, lo, 136657, 0) + _ | 0, A = ve, A = _ >>> 0 > U >>> 0 ? A + 1 | 0 : A, Ar = (2097151 & (_ = b)) << 11 | he >>> 21, _ = A + (b = _ >> 21) | 0, _ = (U = Ar + U | 0) >>> 0 < Ar >>> 0 ? _ + 1 | 0 : _, j[ie + 12 | 0] = (4095 & _) << 20 | U >>> 12, b = U, j[ie + 11 | 0] = (15 & _) << 28 | b >>> 4, U = 0, j[ie + 10 | 0] = U << 15 | (1966080 & he) >>> 17 | b << 4, U = 2097151 & zr, he = De(Io, lo, -683901, -1) + U | 0, A = ve, A = U >>> 0 > he >>> 0 ? A + 1 | 0 : A, U = _, _ = A + (_ >>= 21) | 0, _ = (U = (zr = he) + (he = (2097151 & U) << 11 | b >>> 21) | 0) >>> 0 < he >>> 0 ? _ + 1 | 0 : _, j[ie + 14 | 0] = (127 & _) << 25 | U >>> 7, he = 0, j[ie + 13 | 0] = he << 12 | (1048576 & b) >>> 20 | U << 1, A = _ >> 21, b = (_ = (2097151 & _) << 11 | U >>> 21) >>> 0 > (he = _ + (2097151 & Wn) | 0) >>> 0 ? A + 1 | 0 : A, j[ie + 17 | 0] = (1023 & b) << 22 | he >>> 10, j[ie + 16 | 0] = (3 & b) << 30 | he >>> 2, _ = 0, j[ie + 15 | 0] = _ << 17 | (2064384 & U) >>> 15 | he << 6, A = b >> 21, A = (_ = (2097151 & b) << 11 | he >>> 21) >>> 0 > (b = _ + (2097151 & Gr) | 0) >>> 0 ? A + 1 | 0 : A, j[ie + 20 | 0] = (8191 & A) << 19 | b >>> 13, j[ie + 19 | 0] = (31 & A) << 27 | b >>> 5, U = (_ = 2097151 & so) + (so = (2097151 & A) << 11 | b >>> 21) | 0, _ = A >> 21, _ = U >>> 0 < so >>> 0 ? _ + 1 | 0 : _, so = U, j[ie + 21 | 0] = U, Gr = 0, j[ie + 18 | 0] = Gr << 14 | (1835008 & he) >>> 18 | b << 3, j[ie + 22 | 0] = (255 & _) << 24 | U >>> 8, b = _ >> 21, b = (U = (he = (2097151 & _) << 11 | U >>> 21) + (2097151 & jt) | 0) >>> 0 < he >>> 0 ? b + 1 | 0 : b, j[ie + 25 | 0] = (2047 & b) << 21 | U >>> 11, j[ie + 24 | 0] = (7 & b) << 29 | U >>> 3, j[ie + 23 | 0] = 31 & ((65535 & _) << 16 | so >>> 16) | U << 5, A = b >> 21, A = (_ = (2097151 & b) << 11 | U >>> 21) >>> 0 > (b = _ + (2097151 & Fn) | 0) >>> 0 ? A + 1 | 0 : A, j[ie + 27 | 0] = (63 & A) << 26 | b >>> 6, he = 0, j[ie + 26 | 0] = he << 13 | (1572864 & U) >>> 19 | b << 2, _ = A >> 21, _ = (A = (U = (2097151 & A) << 11 | b >>> 21) + (2097151 & wt) | 0) >>> 0 < U >>> 0 ? _ + 1 | 0 : _, j[ie + 31 | 0] = (131071 & _) << 15 | A >>> 17, j[ie + 30 | 0] = (511 & _) << 23 | A >>> 9, j[ie + 29 | 0] = (1 & _) << 31 | A >>> 1, U = 0, j[ie + 28 | 0] = U << 18 | (2080768 & b) >>> 14 | A << 7, Wr(me, 64), Wr(D, 64), g && (l[g >> 2] = 64, l[g + 4 >> 2] = 0), st = _e + 560 | 0, 0;
                    }
                    function gr(A, g, _) {
                      var b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht, Ct, Tt, Gt, en, it, St, Ft, fn, _n, wn, $n, qn, Gn, Kn, Kt, pn, Hn, Zn, er, Zt, Sn, or, ur, Cr, Je = 0, Ve = 0, ut = 0, Nn = 0, cr = 0, Rr = 0, Ir = 0, Pr = 0, qr = 0, ao = 0, Fn = 0, Wn = 0, wt = 0, jt = 0, an = 0, Ar = 0, Tr = 0, zr = 0, Gr = 0, no = 0, so = 0, co = 0, lo = 0, yo = 0, Co = 0, Io = 0, ko = 0, Po = 0, $o = 0, xo = 0, Go = 0, Xo = 0, ei = 0, ti = 0, oi = 0, vi = 0, Ti = 0, Oi = 0, xi = 0, Hi = 0, Wi = 0, Gi = 0, ps = 0, cs = 0, vs = 0, qs = 0, Fs = 0, Ls = 0, Ws = 0, zs = 0, pa = 0;
                      Nn = De(b = (Ve = B[_ + 2 | 0]) << 16 & 2031616 | B[0 | _] | B[_ + 1 | 0] << 8, 0, U = (Wn = B[g + 23 | 0] | B[g + 24 | 0] << 8 | B[g + 25 | 0] << 16 | B[g + 26 | 0] << 24) >>> 5 & 2097151, 0), ut = ve, Je = De(ie = (Ve = B[g + 23 | 0]) << 16 & 2031616 | B[g + 21 | 0] | B[g + 22 | 0] << 8, 0, he = (cr = B[_ + 2 | 0] | B[_ + 3 | 0] << 8 | B[_ + 4 | 0] << 16 | B[_ + 5 | 0] << 24) >>> 5 & 2097151, 0), Ve = ve + ut | 0, Ve = Je >>> 0 > (Nn = Je + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(D = (B[_ + 7 | 0] | B[_ + 8 | 0] << 8 | B[_ + 9 | 0] << 16 | B[_ + 10 | 0] << 24) >>> 7 & 2097151, 0, me = (jt = B[g + 15 | 0] | B[g + 16 | 0] << 8 | B[g + 17 | 0] << 16 | B[g + 18 | 0] << 24) >>> 6 & 2097151, 0), Je = ve + Ve | 0, Pr = Nn = ut + Nn | 0, ut = ut >>> 0 > Nn >>> 0 ? Je + 1 | 0 : Je, Je = (Ve = B[g + 14 | 0]) >>> 24 | 0, Rr = Ve << 8 | (qr = B[g + 10 | 0] | B[g + 11 | 0] << 8 | B[g + 12 | 0] << 16 | B[g + 13 | 0] << 24) >>> 24, Je = De(_e = 2097151 & ((1 & (ao = (Ve = Je) | (Je = (Nn = B[g + 15 | 0]) >>> 16 | 0))) << 31 | (Ve = (Nn <<= 16) | Rr) >>> 1), 0, Be = (Ir = B[_ + 10 | 0] | B[_ + 11 | 0] << 8 | B[_ + 12 | 0] << 16 | B[_ + 13 | 0] << 24) >>> 4 & 2097151, 0), ut = ve + ut | 0, ao = Ve = Je + Pr | 0, Nn = Ve >>> 0 < Je >>> 0 ? ut + 1 | 0 : ut, ut = (Je = B[_ + 6 | 0]) >>> 24 | 0, Pr = Je << 8 | cr >>> 24, cr = ye = 2097151 & ((3 & (ut |= Je = (Ve = B[_ + 7 | 0]) >>> 16 | 0)) << 30 | (Ve = Pr | Ve << 16) >>> 2), Pr = 0, Rr = (Ve = B[g + 19 | 0]) << 8 | jt >>> 24, ut = Je = Ve >>> 24 | 0, Ve = (Je = B[g + 20 | 0]) >>> 16 | 0, en = ut = (Ve |= ut) >>> 3 | 0, Je = De(cr, Pr, we = (7 & Ve) << 29 | (Je = Je << 16 | Rr) >>> 3, ut), Ve = ve + Nn | 0, Ve = Je >>> 0 > (Rr = Je + ao | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De($e = (cr = B[_ + 15 | 0] | B[_ + 16 | 0] << 8 | B[_ + 17 | 0] << 16 | B[_ + 18 | 0] << 24) >>> 6 & 2097151, 0, Le = (B[g + 7 | 0] | B[g + 8 | 0] << 8 | B[g + 9 | 0] << 16 | B[g + 10 | 0] << 24) >>> 7 & 2097151, 0), Je = ve + Ve | 0, Pr = Nn = ut + Rr | 0, Nn = ut >>> 0 > Nn >>> 0 ? Je + 1 | 0 : Je, Rr = (Ve = B[_ + 14 | 0]) << 8 | Ir >>> 24, Ve = Je = Ve >>> 24 | 0, ut = (Je = B[_ + 15 | 0]) >>> 16 | 0, Je = De(Ge = 2097151 & ((1 & (ut |= Ve)) << 31 | (Ve = (Je <<= 16) | Rr) >>> 1), 0, je = qr >>> 4 & 2097151, 0), Ve = ve + Nn | 0, Ir = ut = Je + Pr | 0, Pr = Je >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, Ve = (Je = B[_ + 19 | 0]) >>> 24 | 0, Nn = Je << 8 | cr >>> 24, ut = (Je = B[_ + 20 | 0]) >>> 16 | 0, ct = (7 & (ut |= Ve)) << 29 | (Je = Nn | Je << 16) >>> 3, so = Ve = ut >>> 3 | 0, Nn = Ve, Ve = (Je = B[g + 6 | 0]) >>> 24 | 0, cr = Je << 8 | (ao = B[g + 2 | 0] | B[g + 3 | 0] << 8 | B[g + 4 | 0] << 16 | B[g + 5 | 0] << 24) >>> 24, ut = Ve, Ve = (Je = B[g + 7 | 0]) >>> 16 | 0, Ve = De(ct, Nn, mt = 2097151 & ((3 & (Ve |= ut)) << 30 | (Je = Je << 16 | cr) >>> 2), 0), Je = ve + Pr | 0, ut = Ve >>> 0 > (Nn = Ve + Ir | 0) >>> 0 ? Je + 1 | 0 : Je, Ve = De(bt = (Ve = B[_ + 23 | 0]) << 16 & 2031616 | B[_ + 21 | 0] | B[_ + 22 | 0] << 8, 0, ht = ao >>> 5 & 2097151, 0), Je = ve + ut | 0, ut = Ve >>> 0 > (Nn = Ve + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, Je = De(Ct = (Ve = B[g + 2 | 0]) << 16 & 2031616 | B[0 | g] | B[g + 1 | 0] << 8, 0, Co = (ao = B[_ + 23 | 0] | B[_ + 24 | 0] << 8 | B[_ + 25 | 0] << 16 | B[_ + 26 | 0] << 24) >>> 5 & 2097151, 0), Ve = ve + ut | 0, cr = Nn = Je + Nn | 0, Pr = Je >>> 0 > Nn >>> 0 ? Ve + 1 | 0 : Ve, Je = De(ie, 0, b, 0), Ve = ve, Nn = (ut = Je) + (Je = De(we, en, he, 0)) | 0, ut = ve + Ve | 0, ut = Je >>> 0 > Nn >>> 0 ? ut + 1 | 0 : ut, Je = De(D, 0, _e, 0), Ve = ve + ut | 0, Ve = Je >>> 0 > (Nn = Je + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(Be, 0, je, 0), Je = ve + Ve | 0, Je = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, Ve = De(me, 0, ye, 0), Je = ve + Je | 0, Je = Ve >>> 0 > (ut = Ve + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, Nn = (Ve = ut) + (ut = De($e, 0, mt, 0)) | 0, Ve = ve + Je | 0, Ve = ut >>> 0 > Nn >>> 0 ? Ve + 1 | 0 : Ve, Je = De(Ge, 0, Le, 0), ut = ve + Ve | 0, ut = Je >>> 0 > (Nn = Je + Nn | 0) >>> 0 ? ut + 1 | 0 : ut, Nn = (Je = De(ct, so, ht, 0)) + Nn | 0, Ve = ve + ut | 0, ut = De(bt, 0, Ct, 0), Je = ve + (Je >>> 0 > Nn >>> 0 ? Ve + 1 | 0 : Ve) | 0, Nn = Je = ut >>> 0 > (Rr = ut + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, an = Je = Je - ((Rr >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (Ve = Je >>> 21 | 0) + Pr | 0, Ar = ut = (Ve = (Je = (2097151 & Je) << 11 | (zr = Rr - -1048576 | 0) >>> 21) >>> 0 > (cr = Je + cr | 0) >>> 0 ? Ve + 1 | 0 : Ve) - ((cr >>> 0 < 4293918720) - 1 | 0) | 0, wt = cr - (Je = -2097152 & (Gr = cr - -1048576 | 0)) | 0, Fn = Ve - ((Je >>> 0 > cr >>> 0) + ut | 0) | 0, Pr = (Ve = B[_ + 27 | 0]) << 8 | ao >>> 24, ut = Je = Ve >>> 24 | 0, cr = De(Tt = 2097151 & ((3 & (ut |= Ve = (Je = B[_ + 28 | 0]) >>> 16 | 0)) << 30 | (Ve = (Je <<= 16) | Pr) >>> 2), 0, ko = (B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24) >>> 7 | 0, 0), Pr = ve, Ve = (Je = B[g + 27 | 0]) >>> 24 | 0, g = De(Gt = 2097151 & ((3 & (Ve |= ut = (g = B[g + 28 | 0]) >>> 16 | 0)) << 30 | (Je = Je << 8 | Wn >>> 24 | g << 16) >>> 2), 0, Po = (B[_ + 28 | 0] | B[_ + 29 | 0] << 8 | B[_ + 30 | 0] << 16 | B[_ + 31 | 0] << 24) >>> 7 | 0, 0), Je = ve + Pr | 0, Je = g >>> 0 > (_ = g + cr | 0) >>> 0 ? Je + 1 | 0 : Je, ut = _, g = De(U, 0, Po, 0), _ = ve, Pr = (Ve = g) + (g = De(Co, 0, ko, 0)) | 0, Ve = ve + _ | 0, Ve = g >>> 0 > Pr >>> 0 ? Ve + 1 | 0 : Ve, g = De(Tt, 0, Gt, 0), Ve = ve + Ve | 0, Pr = Ve = g >>> 0 > (ao = g + Pr | 0) >>> 0 ? Ve + 1 | 0 : Ve, Ir = g = Ve - ((ao >>> 0 < 4293918720) - 1 | 0) | 0, Ve = g >>> 21 | 0, cr = (g = (2097151 & g) << 11 | (_ = ao - -1048576 | 0) >>> 21) + ut | 0, ut = Ve + Je | 0, jt = Ve = (ut = g >>> 0 > cr >>> 0 ? ut + 1 | 0 : ut) - ((cr >>> 0 < 4293918720) - 1 | 0) | 0, g = cr - (Je = -2097152 & (qr = cr - -1048576 | 0)) | 0, St = Je = ut - ((131071 & Ve) + (Je >>> 0 > cr >>> 0) | 0) | 0, Ft = g, g = De(g, Je, 666643, 0), Je = ve + Fn | 0, xo = Ve = g + wt | 0, cr = g >>> 0 > Ve >>> 0 ? Je + 1 | 0 : Je, wt = ao - (g = -2097152 & _) | 0, lo = Pr - ((131071 & Ir) + (g >>> 0 > ao >>> 0) | 0) | 0, g = De(bt, 0, ko, 0), _ = ve, Ve = (Je = g) + (g = De(Co, 0, Gt, 0)) | 0, Je = ve + _ | 0, Je = g >>> 0 > Ve >>> 0 ? Je + 1 | 0 : Je, _ = (g = De(ie, 0, Po, 0)) + Ve | 0, Ve = ve + Je | 0, Ve = g >>> 0 > _ >>> 0 ? Ve + 1 | 0 : Ve, g = De(U, 0, Tt, 0), Je = ve + Ve | 0, Ir = _ = g + _ | 0, g = g >>> 0 > _ >>> 0 ? Je + 1 | 0 : Je, _ = De(U, 0, Co, 0), Je = ve, ut = (Ve = _) + (_ = De(ct, so, ko, 0)) | 0, Ve = ve + Je | 0, Ve = _ >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, Je = (_ = De(bt, 0, Gt, 0)) + ut | 0, ut = ve + Ve | 0, ut = _ >>> 0 > Je >>> 0 ? ut + 1 | 0 : ut, Ve = (_ = De(we, en, Po, 0)) + Je | 0, Je = ve + ut | 0, Je = _ >>> 0 > Ve >>> 0 ? Je + 1 | 0 : Je, Fn = (_ = De(ie, 0, Tt, 0)) + Ve | 0, Ve = ve + Je | 0, ao = Ve = _ >>> 0 > Fn >>> 0 ? Ve + 1 | 0 : Ve, Tr = _ = Ve - ((Fn >>> 0 < 4293918720) - 1 | 0) | 0, Ve = g + (Je = _ >>> 21 | 0) | 0, _ = Ve = (_ = (2097151 & _) << 11 | (Pr = Fn - -1048576 | 0) >>> 21) >>> 0 > (Ir = _ + Ir | 0) >>> 0 ? Ve + 1 | 0 : Ve, Wn = Ve = Ve - ((Ir >>> 0 < 4293918720) - 1 | 0) | 0, Je = wt, wt = (2097151 & Ve) << 11 | (g = Ir - -1048576 | 0) >>> 21, Ve = (Ve >>> 21 | 0) + lo | 0, fn = Ve = (ut = Je + wt | 0) >>> 0 < wt >>> 0 ? Ve + 1 | 0 : Ve, _n = g = Ir - (Je = -2097152 & g) | 0, wn = Ir = _ - ((Je >>> 0 > Ir >>> 0) + Wn | 0) | 0, $n = ut, _ = De(ut, Ve, 470296, 0), Je = ve + cr | 0, Je = _ >>> 0 > (Ve = _ + xo | 0) >>> 0 ? Je + 1 | 0 : Je, g = De(g, Ir, 654183, 0), ut = ve + Je | 0, lo = _ = g + Ve | 0, cr = g >>> 0 > _ >>> 0 ? ut + 1 | 0 : ut, Wn = Fn - (g = -2097152 & Pr) | 0, Fn = ao - ((g >>> 0 > Fn >>> 0) + Tr | 0) | 0, g = De(ct, so, Gt, 0), _ = ve, Ve = (Je = g) + (g = De($e, 0, ko, 0)) | 0, Je = ve + _ | 0, Je = g >>> 0 > Ve >>> 0 ? Je + 1 | 0 : Je, _ = (g = De(ie, 0, Co, 0)) + Ve | 0, Ve = ve + Je | 0, Ve = g >>> 0 > _ >>> 0 ? Ve + 1 | 0 : Ve, g = De(U, 0, bt, 0), ut = ve + Ve | 0, ut = g >>> 0 > (_ = g + _ | 0) >>> 0 ? ut + 1 | 0 : ut, g = De(me, 0, Po, 0), Je = ve + ut | 0, Je = g >>> 0 > (_ = g + _ | 0) >>> 0 ? Je + 1 | 0 : Je, g = De(we, en, Tt, 0), Ve = ve + Je | 0, ao = _ = g + _ | 0, Pr = g >>> 0 > _ >>> 0 ? Ve + 1 | 0 : Ve, g = De(Ge, 0, ko, 0), _ = ve, Ve = (Je = g) + (g = De($e, 0, Gt, 0)) | 0, Je = ve + _ | 0, Je = g >>> 0 > Ve >>> 0 ? Je + 1 | 0 : Je, _ = (g = De(U, 0, ct, so)) + Ve | 0, Ve = ve + Je | 0, Ve = g >>> 0 > _ >>> 0 ? Ve + 1 | 0 : Ve, g = De(we, en, Co, 0), ut = ve + Ve | 0, ut = g >>> 0 > (_ = g + _ | 0) >>> 0 ? ut + 1 | 0 : ut, g = De(ie, 0, bt, 0), Je = ve + ut | 0, Je = g >>> 0 > (_ = g + _ | 0) >>> 0 ? Je + 1 | 0 : Je, g = De(_e, 0, Po, 0), Ve = ve + Je | 0, Ve = g >>> 0 > (_ = g + _ | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(me, 0, Tt, 0), Je = ve + Ve | 0, g = Je = g >>> 0 > (_ = g + _ | 0) >>> 0 ? Je + 1 | 0 : Je, co = Je = Je - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, ut = (Ve = Je >>> 21 | 0) + Pr | 0, wt = ut = (Je = (2097151 & Je) << 11 | (Tr = _ - -1048576 | 0) >>> 21) >>> 0 > (yo = Je + ao | 0) >>> 0 ? ut + 1 | 0 : ut, Hi = Je = ut - ((yo >>> 0 < 4293918720) - 1 | 0) | 0, Pr = (2097151 & Je) << 11 | (Ir = yo - -1048576 | 0) >>> 21, Je = (Je >>> 21 | 0) + Fn | 0, qn = Je = (ut = Pr + Wn | 0) >>> 0 < Pr >>> 0 ? Je + 1 | 0 : Je, Gn = ut, Je = De(ut, Je, -997805, -1), Ve = ve + cr | 0, Fn = ut = Je + lo | 0, cr = Je >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, Pr = Rr, Rr = Nn, Je = De(b, 0, we, en), Ve = ve, Nn = (ut = Je) + (Je = De(me, 0, he, 0)) | 0, ut = ve + Ve | 0, ut = Je >>> 0 > Nn >>> 0 ? ut + 1 | 0 : ut, Ve = De(D, 0, je, 0), Je = ve + ut | 0, Je = Ve >>> 0 > (Nn = Ve + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(Be, 0, Le, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(_e, 0, ye, 0), Je = ve + Ve | 0, Je = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De($e, 0, ht, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, Je = De(Ge, 0, mt, 0), ut = ve + Ve | 0, ut = Je >>> 0 > (Nn = Je + Nn | 0) >>> 0 ? ut + 1 | 0 : ut, Ve = De(ct, so, Ct, 0), Je = ve + ut | 0, ao = Nn = Ve + Nn | 0, Nn = Ve >>> 0 > Nn >>> 0 ? Je + 1 | 0 : Je, Je = De(b, 0, me, 0), Ve = ve, ut = Je, Je = De(_e, 0, he, 0), Ve = ve + Ve | 0, Ve = Je >>> 0 > (ut = ut + Je | 0) >>> 0 ? Ve + 1 | 0 : Ve, Wn = (Je = ut) + (ut = De(D, 0, Le, 0)) | 0, Je = ve + Ve | 0, Je = ut >>> 0 > Wn >>> 0 ? Je + 1 | 0 : Je, ut = De(Be, 0, mt, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (Wn = ut + Wn | 0) >>> 0 ? Ve + 1 | 0 : Ve, Je = De(ye, 0, je, 0), ut = ve + Ve | 0, ut = Je >>> 0 > (Wn = Je + Wn | 0) >>> 0 ? ut + 1 | 0 : ut, Wn = (Ve = De($e, 0, Ct, 0)) + Wn | 0, Je = ve + ut | 0, ut = De(Ge, 0, ht, 0), Ve = ve + (Ve >>> 0 > Wn >>> 0 ? Je + 1 | 0 : Je) | 0, ti = Ve = ut >>> 0 > (ei = ut + Wn | 0) >>> 0 ? Ve + 1 | 0 : Ve, qs = Ve = Ve - ((ei >>> 0 < 4293918720) - 1 | 0) | 0, ut = (2097151 & Ve) << 11 | (Xo = ei - -1048576 | 0) >>> 21, Ve = (Ve >>> 21 | 0) + Nn | 0, no = Ve = ut >>> 0 > (oi = ut + ao | 0) >>> 0 ? Ve + 1 | 0 : Ve, Fs = Ve = Ve - ((oi >>> 0 < 4293918720) - 1 | 0) | 0, ut = (2097151 & Ve) << 11 | (xo = oi - -1048576 | 0) >>> 21, Ve = (Ve >>> 21 | 0) + Rr | 0, Ve = ut >>> 0 > (Pr = ut + Pr | 0) >>> 0 ? Ve + 1 | 0 : Ve, Je = De($n, fn, 666643, 0), Ve = ve + (Ve - (((ut = -2097152 & zr) >>> 0 > Pr >>> 0) + an | 0) | 0) | 0, Ve = Je >>> 0 > (Nn = Je + (Pr - ut | 0) | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(_n, wn, 470296, 0), Je = ve + Ve | 0, Je = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(Gn, qn, 654183, 0), Ve = ve + Je | 0, lo = Ve = ut >>> 0 > (Io = ut + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, ps = Ve = Ve - ((Io >>> 0 < 4293918720) - 1 | 0) | 0, Je = (Je = Ve >> 21) + cr | 0, Fn = Je = (Ve = (2097151 & Ve) << 11 | (Wn = Io - -1048576 | 0) >>> 21) >>> 0 > (an = Ve + Fn | 0) >>> 0 ? Je + 1 | 0 : Je, vi = Ve = Je - ((an >>> 0 < 4293918720) - 1 | 0) | 0, Wi = (2097151 & Ve) << 11 | (zr = an - -1048576 | 0) >>> 21, ao = Ve >> 21, Je = De(b, 0, Gt, 0), Ve = ve, ut = Je, Je = De(U, 0, he, 0), Ve = ve + Ve | 0, Ve = Je >>> 0 > (ut = ut + Je | 0) >>> 0 ? Ve + 1 | 0 : Ve, Nn = (Je = De(D, 0, we, en)) + ut | 0, ut = ve + Ve | 0, ut = Je >>> 0 > Nn >>> 0 ? ut + 1 | 0 : ut, Ve = De(me, 0, Be, 0), Je = ve + ut | 0, Je = Ve >>> 0 > (Nn = Ve + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(ie, 0, ye, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De($e, 0, je, 0), Je = ve + Ve | 0, Je = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(_e, 0, Ge, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, Je = De(Le, 0, ct, so), ut = ve + Ve | 0, ut = Je >>> 0 > (Nn = Je + Nn | 0) >>> 0 ? ut + 1 | 0 : ut, Ve = De(ht, 0, Co, 0), Je = ve + ut | 0, Je = Ve >>> 0 > (Nn = Ve + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(mt, 0, bt, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = (Je = Nn) + (Nn = De(Tt, 0, Ct, 0)) | 0, Je = ve + Ve | 0, cr = ut, Pr = ut >>> 0 < Nn >>> 0 ? Je + 1 | 0 : Je, Go = De(ko, 0, Po, 0), Rr = ut = (Ti = ve) - ((Go >>> 0 < 4293918720) - 1 | 0) | 0, Ve = Go - (Je = -2097152 & (Nn = Go - -1048576 | 0)) | 0, Je = (jt >>> 21 | 0) + (Je = Ti - ((524287 & ut) + (Je >>> 0 > Go >>> 0) | 0) | 0) | 0, Kn = Je = (ut = (qr = (2097151 & jt) << 11 | qr >>> 21) + Ve | 0) >>> 0 < qr >>> 0 ? Je + 1 | 0 : Je, Kt = ut, Ve = (2097151 & Ar) << 11 | Gr >>> 21, qr = De(ut, Je, 666643, 0) + Ve | 0, Je = ve + (Ar >>> 21 | 0) | 0, Je = Ve >>> 0 > qr >>> 0 ? Je + 1 | 0 : Je, ut = De(Ft, St, 470296, 0), Ve = ve + Je | 0, Ve = (ut >>> 0 > (qr = ut + qr | 0) >>> 0 ? Ve + 1 | 0 : Ve) + Pr | 0, Ve = (Je = cr + qr | 0) >>> 0 < qr >>> 0 ? Ve + 1 | 0 : Ve, qr = (ut = De($n, fn, 654183, 0)) + Je | 0, Je = ve + Ve | 0, Gi = cr - -1048576 | 0, Go = Pr = Pr - ((cr >>> 0 < 4293918720) - 1 | 0) | 0, Ve = De(_n, wn, -997805, -1), ut = ve + (ut >>> 0 > qr >>> 0 ? Je + 1 | 0 : Je) | 0, ut = Ve >>> 0 > (cr = Ve + qr | 0) >>> 0 ? ut + 1 | 0 : ut, Gr = (Je = De(Gn, qn, 136657, 0)) + (cr - (Ve = -2097152 & Gi) | 0) | 0, Ve = ve + (ut - ((Ve >>> 0 > cr >>> 0) + Pr | 0) | 0) | 0, ut = (jt = Je >>> 0 > Gr >>> 0 ? Ve + 1 | 0 : Ve) + ao | 0, Oi = Je = Gr + Wi | 0, qr = ut = Je >>> 0 < Gr >>> 0 ? ut + 1 | 0 : ut, Ti = yo - (Je = -2097152 & Ir) | 0, yo = wt - ((Je >>> 0 > yo >>> 0) + Hi | 0) | 0, pn = ut = Rr >>> 21 | 0, Ve = (Je = _) + (_ = De(it = (2097151 & Rr) << 11 | Nn >>> 21, ut, -683901, -1)) | 0, Je = ve + g | 0, wt = Ve - (g = -2097152 & Tr) | 0, Ar = (_ >>> 0 > Ve >>> 0 ? Je + 1 | 0 : Je) - ((g >>> 0 > Ve >>> 0) + co | 0) | 0, g = De(U, 0, $e, 0), _ = ve, Je = g, g = De(Be, 0, ko, 0), Ve = ve + _ | 0, Ve = g >>> 0 > (Je = Je + g | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(Ge, 0, Gt, 0), ut = ve + Ve | 0, ut = g >>> 0 > (_ = g + Je | 0) >>> 0 ? ut + 1 | 0 : ut, g = De(ie, 0, ct, so), Je = ve + ut | 0, Je = g >>> 0 > (_ = g + _ | 0) >>> 0 ? Je + 1 | 0 : Je, g = De(me, 0, Co, 0), Je = ve + Je | 0, Je = g >>> 0 > (_ = g + _ | 0) >>> 0 ? Je + 1 | 0 : Je, g = De(we, en, bt, 0), Ve = ve + Je | 0, Ve = g >>> 0 > (_ = g + _ | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(je, 0, Po, 0), Ve = ve + Ve | 0, Ve = g >>> 0 > (_ = g + _ | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(_e, 0, Tt, 0), ut = ve + Ve | 0, Nn = _ = g + _ | 0, g = g >>> 0 > _ >>> 0 ? ut + 1 | 0 : ut, _ = De(Be, 0, Gt, 0), Je = ve, Ve = _, _ = De(D, 0, ko, 0), Je = ve + Je | 0, Je = _ >>> 0 > (Ve = Ve + _ | 0) >>> 0 ? Je + 1 | 0 : Je, _ = De(ie, 0, $e, 0), Je = ve + Je | 0, Je = _ >>> 0 > (Ve = _ + Ve | 0) >>> 0 ? Je + 1 | 0 : Je, ut = (_ = De(U, 0, Ge, 0)) + Ve | 0, Ve = ve + Je | 0, Ve = _ >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, _ = De(we, en, ct, so), Ve = ve + Ve | 0, Ve = _ >>> 0 > (Je = _ + ut | 0) >>> 0 ? Ve + 1 | 0 : Ve, _ = De(_e, 0, Co, 0), ut = ve + Ve | 0, ut = _ >>> 0 > (Je = _ + Je | 0) >>> 0 ? ut + 1 | 0 : ut, Ve = (_ = De(me, 0, bt, 0)) + Je | 0, Je = ve + ut | 0, Je = _ >>> 0 > Ve >>> 0 ? Je + 1 | 0 : Je, _ = De(Le, 0, Po, 0), Je = ve + Je | 0, Je = _ >>> 0 > (Ve = _ + Ve | 0) >>> 0 ? Je + 1 | 0 : Je, Ir = (_ = De(je, 0, Tt, 0)) + Ve | 0, Ve = ve + Je | 0, ao = Ve = _ >>> 0 > Ir >>> 0 ? Ve + 1 | 0 : Ve, xi = _ = Ve - ((Ir >>> 0 < 4293918720) - 1 | 0) | 0, ut = g + (Je = _ >>> 21 | 0) | 0, Pr = ut = (_ = (2097151 & _) << 11 | (cr = Ir - -1048576 | 0) >>> 21) >>> 0 > (Tr = _ + Nn | 0) >>> 0 ? ut + 1 | 0 : ut, co = g = ut - ((Tr >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (Je = g >>> 21 | 0) + Ar | 0, Nn = Ve = (g = (2097151 & g) << 11 | (Rr = Tr - -1048576 | 0) >>> 21) >>> 0 > (wt = g + wt | 0) >>> 0 ? Ve + 1 | 0 : Ve, Ar = _ = Ve - ((wt >>> 0 < 4293918720) - 1 | 0) | 0, ut = (Je = _ >> 21) + yo | 0, Hn = ut = (_ = (Ve = (2097151 & _) << 11 | (g = wt - -1048576 | 0) >>> 21) + Ti | 0) >>> 0 < Ve >>> 0 ? ut + 1 | 0 : ut, Hi = Gr - -1048576 | 0, Wi = Ve = jt - ((Gr >>> 0 < 4293918720) - 1 | 0) | 0, cs = _, _ = De(_, ut, -683901, -1), Je = ve + qr | 0, Ti = Je = (Ve = (Je = _ >>> 0 > (ut = _ + Oi | 0) >>> 0 ? Je + 1 | 0 : Je) - (((_ = -2097152 & Hi) >>> 0 > ut >>> 0) + Ve | 0) | 0) - (((qr = ut - _ | 0) >>> 0 < 4293918720) - 1 | 0) | 0, Zt = qr - (_ = -2097152 & (yo = qr - -1048576 | 0)) | 0, Ls = Ve - ((_ >>> 0 > qr >>> 0) + Je | 0) | 0, _ = De(cs, Hn, 136657, 0), Ve = ve + (Fn - (((Je = -2097152 & zr) >>> 0 > an >>> 0) + vi | 0) | 0) | 0, vs = ut = _ + (an - Je | 0) | 0, _ = _ >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, $o = wt - (g &= -2097152) | 0, zr = Nn - ((g >>> 0 > wt >>> 0) + Ar | 0) | 0, g = De(Kt, Kn, -683901, -1), Je = ve, Ve = g, g = De(it, pn, 136657, 0), Je = ve + Je | 0, Ve = Pr + (g >>> 0 > (ut = Ve + g | 0) >>> 0 ? Je + 1 | 0 : Je) | 0, jt = (Je = ut + Tr | 0) - (g = -2097152 & Rr) | 0, qr = (Ve = Je >>> 0 < Tr >>> 0 ? Ve + 1 | 0 : Ve) - ((g >>> 0 > Je >>> 0) + co | 0) | 0, g = De(it, pn, -997805, -1), Je = ve + ao | 0, Je = g >>> 0 > (Ve = g + Ir | 0) >>> 0 ? Je + 1 | 0 : Je, g = De(Kt, Kn, 136657, 0), Je = ve + Je | 0, Je = g >>> 0 > (Ve = g + Ve | 0) >>> 0 ? Je + 1 | 0 : Je, ut = (g = De(Ft, St, -683901, -1)) + Ve | 0, Ve = ve + Je | 0, Ve = g >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, Pr = ut - (g = -2097152 & cr) | 0, Rr = Ve - ((g >>> 0 > ut >>> 0) + xi | 0) | 0, g = De(U, 0, Be, 0), Je = ve, ut = (Ve = g) + (g = De(D, 0, Gt, 0)) | 0, Ve = ve + Je | 0, Ve = g >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, g = De(ye, 0, ko, 0), Je = ve + Ve | 0, Je = g >>> 0 > (ut = g + ut | 0) >>> 0 ? Je + 1 | 0 : Je, g = De($e, 0, we, en), Ve = ve + Je | 0, Ve = g >>> 0 > (ut = g + ut | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(ie, 0, Ge, 0), Je = ve + Ve | 0, Je = g >>> 0 > (ut = g + ut | 0) >>> 0 ? Je + 1 | 0 : Je, Ve = (g = De(me, 0, ct, so)) + ut | 0, ut = ve + Je | 0, ut = g >>> 0 > Ve >>> 0 ? ut + 1 | 0 : ut, Je = (g = De(je, 0, Co, 0)) + Ve | 0, Ve = ve + ut | 0, Ve = g >>> 0 > Je >>> 0 ? Ve + 1 | 0 : Ve, ut = (g = De(_e, 0, bt, 0)) + Je | 0, Je = ve + Ve | 0, Je = g >>> 0 > ut >>> 0 ? Je + 1 | 0 : Je, g = De(mt, 0, Po, 0), Ve = ve + Je | 0, Ve = g >>> 0 > (ut = g + ut | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(Le, 0, Tt, 0), Je = ve + Ve | 0, Nn = ut = g + ut | 0, g = g >>> 0 > ut >>> 0 ? Je + 1 | 0 : Je, Je = De(U, 0, D, 0), Ve = ve, cr = (ut = Je) + (Je = De(he, 0, ko, 0)) | 0, ut = ve + Ve | 0, ut = Je >>> 0 > cr >>> 0 ? ut + 1 | 0 : ut, Je = De(ie, 0, Be, 0), Ve = ve + ut | 0, Ve = Je >>> 0 > (cr = Je + cr | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(ye, 0, Gt, 0), Je = ve + Ve | 0, Je = ut >>> 0 > (cr = ut + cr | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(me, 0, $e, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (cr = ut + cr | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(we, en, Ge, 0), Je = ve + Ve | 0, Je = ut >>> 0 > (cr = ut + cr | 0) >>> 0 ? Je + 1 | 0 : Je, Ve = De(_e, 0, ct, so), ut = ve + Je | 0, ut = Ve >>> 0 > (cr = Ve + cr | 0) >>> 0 ? ut + 1 | 0 : ut, Je = De(Le, 0, Co, 0), Ve = ve + ut | 0, Ve = Je >>> 0 > (cr = Je + cr | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(je, 0, bt, 0), Je = ve + Ve | 0, Je = ut >>> 0 > (cr = ut + cr | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(ht, 0, Po, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (cr = ut + cr | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(mt, 0, Tt, 0), Je = ve + Ve | 0, an = Je = ut >>> 0 > (vi = ut + cr | 0) >>> 0 ? Je + 1 | 0 : Je, Sn = Je = Je - ((vi >>> 0 < 4293918720) - 1 | 0) | 0, Ve = g + (Ve = Je >>> 21 | 0) | 0, Gr = Ve = (Je = (2097151 & Je) << 11 | (Ar = vi - -1048576 | 0) >>> 21) >>> 0 > (Oi = Je + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, or = g = Ve - ((Oi >>> 0 < 4293918720) - 1 | 0) | 0, Je = (Ve = g >>> 21 | 0) + Rr | 0, wt = Je = (g = (2097151 & g) << 11 | (Tr = Oi - -1048576 | 0) >>> 21) >>> 0 > (xi = g + Pr | 0) >>> 0 ? Je + 1 | 0 : Je, ur = g = Je - ((xi >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (Ve = g >> 21) + qr | 0, ao = Ve = (g = (2097151 & g) << 11 | (Fn = xi - -1048576 | 0) >>> 21) >>> 0 > (co = g + jt | 0) >>> 0 ? Ve + 1 | 0 : Ve, Ws = g = Ve - ((co >>> 0 < 4293918720) - 1 | 0) | 0, Je = (Ve = g >> 21) + zr | 0, Zn = Je = (g = (ut = (2097151 & g) << 11 | (Nn = co - -1048576 | 0) >>> 21) + $o | 0) >>> 0 < ut >>> 0 ? Je + 1 | 0 : Je, $o = g, g = De(g, Je, -683901, -1), ut = ve + _ | 0, zs = Je = g + vs | 0, cr = g >>> 0 > Je >>> 0 ? ut + 1 | 0 : ut, pa = Io - (g = -2097152 & Wn) | 0, ps = lo - ((g >>> 0 > Io >>> 0) + ps | 0) | 0, g = De(_n, wn, 666643, 0), Je = ve + (no - (((_ = -2097152 & xo) >>> 0 > oi >>> 0) + Fs | 0) | 0) | 0, Je = g >>> 0 > (Ve = g + (oi - _ | 0) | 0) >>> 0 ? Je + 1 | 0 : Je, _ = (g = De(Gn, qn, 470296, 0)) + Ve | 0, Ve = ve + Je | 0, xo = _, _ = g >>> 0 > _ >>> 0 ? Ve + 1 | 0 : Ve, Ir = ei - (g = -2097152 & Xo) | 0, Pr = ti - ((g >>> 0 > ei >>> 0) + qs | 0) | 0, g = De(b, 0, _e, 0), Je = ve, Ve = g, g = De(he, 0, je, 0), ut = ve + Je | 0, ut = g >>> 0 > (Ve = Ve + g | 0) >>> 0 ? ut + 1 | 0 : ut, g = De(D, 0, mt, 0), Je = ve + ut | 0, Je = g >>> 0 > (Ve = g + Ve | 0) >>> 0 ? Je + 1 | 0 : Je, ut = (g = De(Be, 0, ht, 0)) + Ve | 0, Ve = ve + Je | 0, Ve = g >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, g = De(ye, 0, Le, 0), Je = ve + Ve | 0, Je = g >>> 0 > (ut = g + ut | 0) >>> 0 ? Je + 1 | 0 : Je, g = De(Ge, 0, Ct, 0), Ve = ve + Je | 0, Rr = ut = g + ut | 0, g = g >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, Je = De(b, 0, je, 0), Ve = ve, qr = (ut = Je) + (Je = De(he, 0, Le, 0)) | 0, ut = ve + Ve | 0, ut = Je >>> 0 > qr >>> 0 ? ut + 1 | 0 : ut, Ve = De(D, 0, ht, 0), Je = ve + ut | 0, Je = Ve >>> 0 > (qr = Ve + qr | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(Be, 0, Ct, 0), Ve = ve + Je | 0, Ve = ut >>> 0 > (qr = ut + qr | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(ye, 0, mt, 0), Je = ve + Ve | 0, lo = Je = ut >>> 0 > (Io = ut + qr | 0) >>> 0 ? Je + 1 | 0 : Je, Cr = Je = Je - ((Io >>> 0 < 4293918720) - 1 | 0) | 0, ut = g + (Ve = Je >>> 21 | 0) | 0, zr = ut = (Je = (2097151 & Je) << 11 | (Wn = Io - -1048576 | 0) >>> 21) >>> 0 > (ti = Je + Rr | 0) >>> 0 ? ut + 1 | 0 : ut, qs = g = ut - ((ti >>> 0 < 4293918720) - 1 | 0) | 0, Je = (Ve = g >>> 21 | 0) + Pr | 0, Je = (g = (2097151 & g) << 11 | (jt = ti - -1048576 | 0) >>> 21) >>> 0 > (ut = g + Ir | 0) >>> 0 ? Je + 1 | 0 : Je, g = De(Gn, qn, 666643, 0), Ve = ve + Je | 0, qr = Ve = g >>> 0 > (Xo = g + ut | 0) >>> 0 ? Ve + 1 | 0 : Ve, Fs = g = Ve - ((Xo >>> 0 < 4293918720) - 1 | 0) | 0, Je = _ + (Je = g >> 21) | 0, Pr = Je = (g = (2097151 & g) << 11 | (Ir = Xo - -1048576 | 0) >>> 21) >>> 0 > (no = g + xo | 0) >>> 0 ? Je + 1 | 0 : Je, vs = g = Je - ((no >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (Je = g >> 21) + ps | 0, Ve = (g = (2097151 & g) << 11 | (Rr = no - -1048576 | 0) >>> 21) >>> 0 > (_ = g + pa | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(cs, Hn, -997805, -1), ut = ve + Ve | 0, ut = g >>> 0 > (Je = g + _ | 0) >>> 0 ? ut + 1 | 0 : ut, oi = g = co - (_ = -2097152 & Nn) | 0, er = Ve = ao - ((_ >>> 0 > co >>> 0) + Ws | 0) | 0, Nn = (_ = De($o, Zn, 136657, 0)) + Je | 0, Je = ve + ut | 0, g = De(g, Ve, -683901, -1), Je = ve + (_ >>> 0 > Nn >>> 0 ? Je + 1 | 0 : Je) | 0, Nn = Je = g >>> 0 > (ao = g + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, ei = g = Je - ((ao >>> 0 < 4293918720) - 1 | 0) | 0, Je = (Ve = g >> 21) + cr | 0, _ = Je = (cr = xo = (g = (2097151 & g) << 11 | (ut = ao - -1048576 | 0) >>> 21) + zs | 0) >>> 0 < g >>> 0 ? Je + 1 | 0 : Je, co = Je = Je - ((cr >>> 0 < 4293918720) - 1 | 0) | 0, xo = (2097151 & Je) << 11 | (g = cr - -1048576 | 0) >>> 21, Je = (Je >> 21) + Ls | 0, Ls = ps = xo + Zt | 0, xo = xo >>> 0 > ps >>> 0 ? Je + 1 | 0 : Je, Ws = cr - (g &= -2097152) | 0, zs = _ - ((g >>> 0 > cr >>> 0) + co | 0) | 0, pa = ao - (g = -2097152 & ut) | 0, ps = Nn - ((g >>> 0 > ao >>> 0) + ei | 0) | 0, g = De(cs, Hn, 654183, 0), Ve = ve + (Pr - (((_ = -2097152 & Rr) >>> 0 > no >>> 0) + vs | 0) | 0) | 0, Ve = g >>> 0 > (Je = g + (no - _ | 0) | 0) >>> 0 ? Ve + 1 | 0 : Ve, _ = (g = De($o, Zn, -997805, -1)) + Je | 0, Je = ve + Ve | 0, Je = g >>> 0 > _ >>> 0 ? Je + 1 | 0 : Je, g = De(oi, er, 136657, 0), Je = ve + Je | 0, vs = _ = g + _ | 0, g = g >>> 0 > _ >>> 0 ? Je + 1 | 0 : Je, ei = xi - (_ = -2097152 & Fn) | 0, no = wt - ((_ >>> 0 > xi >>> 0) + ur | 0) | 0, _ = De(Kt, Kn, -997805, -1), Je = ve, ut = (Ve = _) + (_ = De(it, pn, 654183, 0)) | 0, Ve = ve + Je | 0, Ve = _ >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, _ = De(Ft, St, 136657, 0), Je = ve + Ve | 0, Je = _ >>> 0 > (ut = _ + ut | 0) >>> 0 ? Je + 1 | 0 : Je, _ = De($n, fn, -683901, -1), Je = ve + Je | 0, Ve = Gr + (_ >>> 0 > (ut = _ + ut | 0) >>> 0 ? Je + 1 | 0 : Je) | 0, Fn = (Je = ut + Oi | 0) - (_ = -2097152 & Tr) | 0, Gr = (Ve = Je >>> 0 < Oi >>> 0 ? Ve + 1 | 0 : Ve) - ((_ >>> 0 > Je >>> 0) + or | 0) | 0, _ = De(Kt, Kn, 654183, 0), Je = ve, ut = (Ve = _) + (_ = De(it, pn, 470296, 0)) | 0, Ve = ve + Je | 0, Ve = _ >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, _ = De(Ft, St, -997805, -1), Je = ve + Ve | 0, Ve = an + (_ >>> 0 > (ut = _ + ut | 0) >>> 0 ? Je + 1 | 0 : Je) | 0, Ve = (_ = ut + vi | 0) >>> 0 < vi >>> 0 ? Ve + 1 | 0 : Ve, ut = (Je = _) + (_ = De($n, fn, 136657, 0)) | 0, Je = ve + Ve | 0, Je = _ >>> 0 > ut >>> 0 ? Je + 1 | 0 : Je, Ve = (_ = De(_n, wn, -683901, -1)) + ut | 0, ut = ve + Je | 0, ut = _ >>> 0 > Ve >>> 0 ? ut + 1 | 0 : ut, Rr = Ve - (_ = -2097152 & Ar) | 0, Nn = ut - ((_ >>> 0 > Ve >>> 0) + Sn | 0) | 0, _ = De(b, 0, ko, 0), Je = ve, Ve = _, _ = De(he, 0, Gt, 0), Je = ve + Je | 0, Je = _ >>> 0 > (Ve = Ve + _ | 0) >>> 0 ? Je + 1 | 0 : Je, _ = De(ie, 0, D, 0), Je = ve + Je | 0, Je = _ >>> 0 > (Ve = _ + Ve | 0) >>> 0 ? Je + 1 | 0 : Je, _ = De(we, en, Be, 0), ut = ve + Je | 0, ut = _ >>> 0 > (Ve = _ + Ve | 0) >>> 0 ? ut + 1 | 0 : ut, Je = (_ = De(U, 0, ye, 0)) + Ve | 0, Ve = ve + ut | 0, Ve = _ >>> 0 > Je >>> 0 ? Ve + 1 | 0 : Ve, _ = De($e, 0, _e, 0), Ve = ve + Ve | 0, Ve = _ >>> 0 > (Je = _ + Je | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = (_ = De(me, 0, Ge, 0)) + Je | 0, Je = ve + Ve | 0, Je = _ >>> 0 > ut >>> 0 ? Je + 1 | 0 : Je, _ = De(je, 0, ct, so), Je = ve + Je | 0, Je = _ >>> 0 > (Ve = _ + ut | 0) >>> 0 ? Je + 1 | 0 : Je, _ = De(mt, 0, Co, 0), ut = ve + Je | 0, ut = _ >>> 0 > (Ve = _ + Ve | 0) >>> 0 ? ut + 1 | 0 : ut, Je = (_ = De(Le, 0, bt, 0)) + Ve | 0, Ve = ve + ut | 0, Ve = _ >>> 0 > Je >>> 0 ? Ve + 1 | 0 : Ve, _ = De(Ct, 0, Po, 0), Ve = ve + Ve | 0, Ve = _ >>> 0 > (Je = _ + Je | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = (_ = De(Tt, 0, ht, 0)) + Je | 0, Je = ve + Ve | 0, Je = (Go >>> 21 | 0) + (Je = _ >>> 0 > ut >>> 0 ? Je + 1 | 0 : Je) | 0, ao = Je = (_ = (2097151 & Go) << 11 | Gi >>> 21) >>> 0 > (Tr = _ + ut | 0) >>> 0 ? Je + 1 | 0 : Je, vi = _ = Je - ((Tr >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (Ve = _ >>> 21 | 0) + Nn | 0, Pr = Ve = (_ = (2097151 & _) << 11 | (cr = Tr - -1048576 | 0) >>> 21) >>> 0 > (wt = _ + Rr | 0) >>> 0 ? Ve + 1 | 0 : Ve, co = _ = Ve - ((wt >>> 0 < 4293918720) - 1 | 0) | 0, Je = (Ve = _ >> 21) + Gr | 0, Nn = Je = (_ = (2097151 & _) << 11 | (Rr = wt - -1048576 | 0) >>> 21) >>> 0 > (Fn = _ + Fn | 0) >>> 0 ? Je + 1 | 0 : Je, Ar = Je = Je - ((Fn >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (Ve = Je >> 21) + no | 0, no = Ve = (Je = (ut = (2097151 & Je) << 11 | (_ = Fn - -1048576 | 0) >>> 21) + ei | 0) >>> 0 < ut >>> 0 ? Ve + 1 | 0 : Ve, Gi = Je, Ve = De(Je, Ve, -683901, -1), Je = ve + g | 0, Gr = ut = Ve + vs | 0, g = Ve >>> 0 > ut >>> 0 ? Je + 1 | 0 : Je, Je = De(cs, Hn, 470296, 0), ut = ve + (qr - (((Ve = -2097152 & Ir) >>> 0 > Xo >>> 0) + Fs | 0) | 0) | 0, ut = Je >>> 0 > (Ir = Je + (Xo - Ve | 0) | 0) >>> 0 ? ut + 1 | 0 : ut, Je = De($o, Zn, 654183, 0), Ve = ve + ut | 0, Ve = Je >>> 0 > (Ir = Je + Ir | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = De(oi, er, -997805, -1), Je = ve + Ve | 0, Je = ut >>> 0 > (Ir = ut + Ir | 0) >>> 0 ? Je + 1 | 0 : Je, Go = _ = Fn - (Ve = -2097152 & _) | 0, so = Nn = Nn - ((Ve >>> 0 > Fn >>> 0) + Ar | 0) | 0, Ir = (ut = De(Gi, no, 136657, 0)) + Ir | 0, Ve = ve + Je | 0, _ = De(_, Nn, -683901, -1), ut = ve + (ut >>> 0 > Ir >>> 0 ? Ve + 1 | 0 : Ve) | 0, Nn = ut = _ >>> 0 > (qr = _ + Ir | 0) >>> 0 ? ut + 1 | 0 : ut, an = Ve = ut - ((qr >>> 0 < 4293918720) - 1 | 0) | 0, ut = (2097151 & Ve) << 11 | (_ = qr - -1048576 | 0) >>> 21, Ve = (Ve >> 21) + g | 0, Ar = ut = (Ve = ut >>> 0 > (Ir = ut + Gr | 0) >>> 0 ? Ve + 1 | 0 : Ve) - ((Ir >>> 0 < 4293918720) - 1 | 0) | 0, Fn = (2097151 & ut) << 11 | (g = Ir - -1048576 | 0) >>> 21, ut = (ut >> 21) + ps | 0, Gr = Fn >>> 0 > (Co = Gr = Fn + pa | 0) >>> 0 ? ut + 1 | 0 : ut, ko = Ir - (g &= -2097152) | 0, Po = Ve - ((g >>> 0 > Ir >>> 0) + Ar | 0) | 0, Oi = qr - (g = -2097152 & _) | 0, xi = Nn - ((g >>> 0 > qr >>> 0) + an | 0) | 0, g = De(cs, Hn, 666643, 0), Ve = ve + (zr - (((_ = -2097152 & jt) >>> 0 > ti >>> 0) + qs | 0) | 0) | 0, Ve = g >>> 0 > (Je = g + (ti - _ | 0) | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De($o, Zn, 470296, 0), ut = ve + Ve | 0, ut = g >>> 0 > (_ = g + Je | 0) >>> 0 ? ut + 1 | 0 : ut, g = De(oi, er, 654183, 0), Ve = ve + ut | 0, Ir = _ = g + _ | 0, g = g >>> 0 > _ >>> 0 ? Ve + 1 | 0 : Ve, Rr = wt - (_ = -2097152 & Rr) | 0, Nn = Pr - ((_ >>> 0 > wt >>> 0) + co | 0) | 0, _ = De(Kt, Kn, 470296, 0), Je = ve, Ve = _, _ = De(it, pn, 666643, 0), Je = ve + Je | 0, Je = _ >>> 0 > (Ve = Ve + _ | 0) >>> 0 ? Je + 1 | 0 : Je, _ = De(Ft, St, 654183, 0), ut = ve + Je | 0, ut = _ >>> 0 > (Ve = _ + Ve | 0) >>> 0 ? ut + 1 | 0 : ut, Je = (_ = De($n, fn, -997805, -1)) + Ve | 0, Ve = ve + ut | 0, Ve = _ >>> 0 > Je >>> 0 ? Ve + 1 | 0 : Ve, _ = De(_n, wn, 136657, 0), Ve = ve + Ve | 0, Je = ao + (_ >>> 0 > (ut = _ + Je | 0) >>> 0 ? Ve + 1 | 0 : Ve) | 0, Je = (_ = ut + Tr | 0) >>> 0 < Tr >>> 0 ? Je + 1 | 0 : Je, Ve = _, _ = De(Gn, qn, -683901, -1), Je = ve + Je | 0, Je = _ >>> 0 > (ut = Ve + _ | 0) >>> 0 ? Je + 1 | 0 : Je, an = (_ = (2097151 & Wi) << 11 | Hi >>> 21) + (ut - (Ve = -2097152 & cr) | 0) | 0, Ve = (Je - ((Ve >>> 0 > ut >>> 0) + vi | 0) | 0) + (Wi >> 21) | 0, wt = Ve = _ >>> 0 > an >>> 0 ? Ve + 1 | 0 : Ve, co = _ = Ve - ((an >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (Je = _ >> 21) + Nn | 0, Hi = Ve = (_ = (ut = (2097151 & _) << 11 | (Fn = an - -1048576 | 0) >>> 21) + Rr | 0) >>> 0 < ut >>> 0 ? Ve + 1 | 0 : Ve, Wi = _, _ = De(_, Ve, -683901, -1), ut = ve + g | 0, ut = _ >>> 0 > (Je = _ + Ir | 0) >>> 0 ? ut + 1 | 0 : ut, g = De(Gi, no, -997805, -1), Ve = ve + ut | 0, Ve = g >>> 0 > (_ = g + Je | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(Go, so, 136657, 0), Je = ve + Ve | 0, Tr = _ = g + _ | 0, Rr = g >>> 0 > _ >>> 0 ? Je + 1 | 0 : Je, cr = Io - (g = -2097152 & Wn) | 0, Pr = lo - ((g >>> 0 > Io >>> 0) + Cr | 0) | 0, g = De(b, 0, Le, 0), _ = ve, Je = g, g = De(he, 0, mt, 0), Ve = ve + _ | 0, Ve = g >>> 0 > (Je = Je + g | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(D, 0, Ct, 0), Ve = ve + Ve | 0, Ve = g >>> 0 > (_ = g + Je | 0) >>> 0 ? Ve + 1 | 0 : Ve, g = De(ye, 0, ht, 0), Je = ve + Ve | 0, g = g >>> 0 > (Ve = _ = g + _ | 0) >>> 0 ? Je + 1 | 0 : Je, _ = De(b, 0, mt, 0), Je = ve, Nn = (ut = _) + (_ = De(he, 0, ht, 0)) | 0, ut = ve + Je | 0, ut = _ >>> 0 > Nn >>> 0 ? ut + 1 | 0 : ut, _ = De(ye, 0, Ct, 0), Je = ve + ut | 0, _ = Je = _ >>> 0 > (Nn = _ + Nn | 0) >>> 0 ? Je + 1 | 0 : Je, cs = Je = Je - ((Nn >>> 0 < 4293918720) - 1 | 0) | 0, ut = Je >>> 21 | 0, Ar = (Je = (2097151 & Je) << 11 | (zr = Nn - -1048576 | 0) >>> 21) + Ve | 0, Ve = g + ut | 0, jt = Ve = Je >>> 0 > Ar >>> 0 ? Ve + 1 | 0 : Ve, Io = g = Ve - ((Ar >>> 0 < 4293918720) - 1 | 0) | 0, Je = (ut = g >>> 21 | 0) + Pr | 0, Je = (g = (2097151 & g) << 11 | (qr = Ar - -1048576 | 0) >>> 21) >>> 0 > (Ve = g + cr | 0) >>> 0 ? Je + 1 | 0 : Je, ut = (g = De($o, Zn, 666643, 0)) + Ve | 0, Ve = ve + Je | 0, Ve = g >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, g = De(oi, er, 470296, 0), Ve = ve + Ve | 0, Ve = g >>> 0 > (Je = g + ut | 0) >>> 0 ? Ve + 1 | 0 : Ve, ut = (g = De(Wi, Hi, 136657, 0)) + Je | 0, Je = ve + Ve | 0, Je = g >>> 0 > ut >>> 0 ? Je + 1 | 0 : Je, Ve = (g = De(Gi, no, 654183, 0)) + ut | 0, ut = ve + Je | 0, ut = g >>> 0 > Ve >>> 0 ? ut + 1 | 0 : ut, g = De(Go, so, -997805, -1), Je = ve + ut | 0, ao = Je = g >>> 0 > (Ir = g + Ve | 0) >>> 0 ? Je + 1 | 0 : Je, ti = g = Je - ((Ir >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (ut = g >> 21) + Rr | 0, Xo = Je = (Ve = (g = (Je = (2097151 & g) << 11 | (cr = Ir - -1048576 | 0) >>> 21) + Tr | 0) >>> 0 < Je >>> 0 ? Ve + 1 | 0 : Ve) - ((g >>> 0 < 4293918720) - 1 | 0) | 0, Rr = (2097151 & Je) << 11 | (Pr = g - -1048576 | 0) >>> 21, Je = (Je >> 21) + xi | 0, ei = Wn = Rr + Oi | 0, Tr = Rr >>> 0 > Wn >>> 0 ? Je + 1 | 0 : Je, Rr = g, ut = Ve, Ve = (wt - (((Je = -2097152 & Fn) >>> 0 > an >>> 0) + co | 0) | 0) + (Ti >> 21) | 0, lo = Ve = (g = (an - Je | 0) + (Fn = (2097151 & Ti) << 11 | yo >>> 21) | 0) >>> 0 < Fn >>> 0 ? Ve + 1 | 0 : Ve, vi = Ve = Ve - ((g >>> 0 < 4293918720) - 1 | 0) | 0, an = Je = Ve >> 21, Ve = De($o = (2097151 & Ve) << 11 | (Wn = g - -1048576 | 0) >>> 21, Je, -683901, -1), Je = ve + ut | 0, Je = Ve >>> 0 > (Rr = Ve + Rr | 0) >>> 0 ? Je + 1 | 0 : Je, Oi = Rr - (Ve = -2097152 & Pr) | 0, xi = Je - ((Ve >>> 0 > Rr >>> 0) + Xo | 0) | 0, Je = De($o, an, 136657, 0), Ve = ve + ao | 0, Ve = Je >>> 0 > (ut = Je + Ir | 0) >>> 0 ? Ve + 1 | 0 : Ve, co = ut - (Je = -2097152 & cr) | 0, Ti = Ve - ((Je >>> 0 > ut >>> 0) + ti | 0) | 0, ut = (Je = De(oi, er, 666643, 0)) + (Ar - (Ve = -2097152 & qr) | 0) | 0, Ve = ve + (jt - ((Ve >>> 0 > Ar >>> 0) + Io | 0) | 0) | 0, Ve = Je >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, Rr = (Je = De(Wi, Hi, -997805, -1)) + ut | 0, ut = ve + Ve | 0, ut = Je >>> 0 > Rr >>> 0 ? ut + 1 | 0 : ut, Ve = De(Gi, no, 470296, 0), Je = ve + ut | 0, Je = Ve >>> 0 > (Rr = Ve + Rr | 0) >>> 0 ? Je + 1 | 0 : Je, ut = De(Go, so, 654183, 0), Ve = ve + Je | 0, yo = Rr = ut + Rr | 0, ao = ut >>> 0 > Rr >>> 0 ? Ve + 1 | 0 : Ve, Rr = Nn, Nn = _, _ = De(he, 0, Ct, 0), Je = ve, Ve = _, _ = De(b, 0, ht, 0), Je = ve + Je | 0, Je = _ >>> 0 > (ut = Ve + _ | 0) >>> 0 ? Je + 1 | 0 : Je, _ = De(b, 0, Ct, 0), Io = Ve = ve, wt = _, jt = _ - -1048576 | 0, ti = _ = Ve - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, Ve = _ >>> 21 | 0, Fn = (_ = (2097151 & _) << 11 | jt >>> 21) + ut | 0, ut = Ve + Je | 0, qr = ut = _ >>> 0 > Fn >>> 0 ? ut + 1 | 0 : ut, Xo = _ = ut - ((Fn >>> 0 < 4293918720) - 1 | 0) | 0, Je = (Ve = _ >>> 21 | 0) + Nn | 0, Je = (_ = (2097151 & _) << 11 | (Ir = Fn - -1048576 | 0) >>> 21) >>> 0 > (ut = _ + Rr | 0) >>> 0 ? Je + 1 | 0 : Je, Nn = (_ = De(Wi, Hi, 654183, 0)) + (ut - (Ve = -2097152 & zr) | 0) | 0, ut = ve + (Je - ((8191 & cs) + (Ve >>> 0 > ut >>> 0) | 0) | 0) | 0, ut = _ >>> 0 > Nn >>> 0 ? ut + 1 | 0 : ut, _ = De(Gi, no, 666643, 0), Ve = ve + ut | 0, Ve = _ >>> 0 > (Je = _ + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve, cr = (_ = De(Go, so, 470296, 0)) + Je | 0, Je = ve + Ve | 0, Pr = Je = _ >>> 0 > cr >>> 0 ? Je + 1 | 0 : Je, Ar = _ = Je - ((cr >>> 0 < 4293918720) - 1 | 0) | 0, Ve = (Ve = _ >> 21) + ao | 0, ut = Ve = (_ = (2097151 & _) << 11 | (Rr = cr - -1048576 | 0) >>> 21) >>> 0 > (Nn = _ + yo | 0) >>> 0 ? Ve + 1 | 0 : Ve, zr = Je = Ve - ((Nn >>> 0 < 4293918720) - 1 | 0) | 0, ao = (2097151 & Je) << 11 | (_ = Nn - -1048576 | 0) >>> 21, Je = (Je >> 21) + Ti | 0, ao = ao >>> 0 > (no = yo = ao + co | 0) >>> 0 ? Je + 1 | 0 : Je, Ve = De($o, an, -997805, -1), Je = ve + ut | 0, Gi = (Nn = Ve + Nn | 0) - (_ &= -2097152) | 0, Ti = (Ve >>> 0 > Nn >>> 0 ? Je + 1 | 0 : Je) - ((_ >>> 0 > Nn >>> 0) + zr | 0) | 0, _ = De($o, an, 654183, 0), ut = ve + Pr | 0, ut = _ >>> 0 > (Je = _ + cr | 0) >>> 0 ? ut + 1 | 0 : ut, yo = Je - (_ = -2097152 & Rr) | 0, Ar = ut - ((_ >>> 0 > Je >>> 0) + Ar | 0) | 0, _ = De(Wi, Hi, 470296, 0), Ve = ve + (qr - ((8191 & Xo) + ((Je = -2097152 & Ir) >>> 0 > Fn >>> 0) | 0) | 0) | 0, Ve = _ >>> 0 > (ut = _ + (Fn - Je | 0) | 0) >>> 0 ? Ve + 1 | 0 : Ve, _ = De(Go, so, 666643, 0), Ve = ve + Ve | 0, Ve = _ >>> 0 > (Je = _ + ut | 0) >>> 0 ? Ve + 1 | 0 : Ve, Nn = Je, _ = De(Wi, Hi, 666643, 0), ut = ve + (Io - ((2047 & ti) + ((Je = -2097152 & jt) >>> 0 > wt >>> 0) | 0) | 0) | 0, cr = ut = _ >>> 0 > (Ir = _ + (wt - Je | 0) | 0) >>> 0 ? ut + 1 | 0 : ut, zr = _ = ut - ((Ir >>> 0 < 4293918720) - 1 | 0) | 0, Ve = Ve + (Je = _ >> 21) | 0, jt = _ = (Ve = (_ = (2097151 & _) << 11 | (Pr = Ir - -1048576 | 0) >>> 21) >>> 0 > (Rr = _ + Nn | 0) >>> 0 ? Ve + 1 | 0 : Ve) - ((Rr >>> 0 < 4293918720) - 1 | 0) | 0, ut = (Je = _ >> 21) + Ar | 0, _ = (_ = (2097151 & _) << 11 | (Nn = Rr - -1048576 | 0) >>> 21) >>> 0 > (qr = _ + yo | 0) >>> 0 ? ut + 1 | 0 : ut, Je = De($o, an, 470296, 0), Ve = ve + Ve | 0, Ve = Je >>> 0 > (ut = Je + Rr | 0) >>> 0 ? Ve + 1 | 0 : Ve, Nn = ut - (Je = -2097152 & Nn) | 0, Rr = Ve - ((Je >>> 0 > ut >>> 0) + jt | 0) | 0, Je = De($o, an, 666643, 0), ut = ve + (cr - (((Ve = -2097152 & Pr) >>> 0 > Ir >>> 0) + zr | 0) | 0) | 0, Je = (Ve = (ut = Je >>> 0 > (wt = Je + (Ir - Ve | 0) | 0) >>> 0 ? ut + 1 | 0 : ut) >> 21) + Rr | 0, Ve = _ + (ut = (Je = (ut = (2097151 & ut) << 11 | wt >>> 21) >>> 0 > (Nn = ut + Nn | 0) >>> 0 ? Je + 1 | 0 : Je) >> 21) | 0, Je = (Je = (Ve = (_ = Rr = (Je = (2097151 & Je) << 11 | Nn >>> 21) + qr | 0) >>> 0 < Je >>> 0 ? Ve + 1 | 0 : Ve) >> 21) + Ti | 0, Ve = (Ve = (Je = (Ve = (2097151 & Ve) << 11 | _ >>> 21) >>> 0 > (Fn = Ve + Gi | 0) >>> 0 ? Je + 1 | 0 : Je) >> 21) + ao | 0, ut = (Je = (Ve = (Je = (2097151 & Je) << 11 | Fn >>> 21) >>> 0 > (zr = Je + no | 0) >>> 0 ? Ve + 1 | 0 : Ve) >> 21) + xi | 0, Je = (Ve = (ut = (Ve = (2097151 & Ve) << 11 | zr >>> 21) >>> 0 > (jt = Ve + Oi | 0) >>> 0 ? ut + 1 | 0 : ut) >> 21) + Tr | 0, Ve = (ut = (Je = (ut = (2097151 & ut) << 11 | jt >>> 21) >>> 0 > (qr = ut + ei | 0) >>> 0 ? Je + 1 | 0 : Je) >> 21) + Po | 0, Je = (Je = (Ve = (Je = (2097151 & Je) << 11 | qr >>> 21) >>> 0 > (Ir = Je + ko | 0) >>> 0 ? Ve + 1 | 0 : Ve) >> 21) + Gr | 0, Ve = (Ve = (Je = (Ve = (2097151 & Ve) << 11 | Ir >>> 21) >>> 0 > (ao = Ve + Co | 0) >>> 0 ? Je + 1 | 0 : Je) >> 21) + zs | 0, ut = (Je = (Ve = (Je = (2097151 & Je) << 11 | ao >>> 21) >>> 0 > (cr = Je + Ws | 0) >>> 0 ? Ve + 1 | 0 : Ve) >> 21) + xo | 0, Ve = (lo - ((g >>> 0 < (Je = -2097152 & Wn) >>> 0) + vi | 0) | 0) + ((ut = (Ve = (2097151 & Ve) << 11 | cr >>> 21) >>> 0 > (Pr = Ve + Ls | 0) >>> 0 ? ut + 1 | 0 : ut) >> 21) | 0, Wn = Je = (Ve = (Rr = (Wn = g - Je | 0) + ((2097151 & ut) << 11 | Pr >>> 21) | 0) >>> 0 < Wn >>> 0 ? Ve + 1 | 0 : Ve) >> 21, g = (g = De(lo = (2097151 & Ve) << 11 | Rr >>> 21, Je, 666643, 0)) + (Je = 2097151 & wt) | 0, ut = ve, j[0 | A] = g, ut = g >>> 0 < Je >>> 0 ? ut + 1 | 0 : ut, j[A + 1 | 0] = (255 & ut) << 24 | g >>> 8, Je = 2097151 & Nn, Nn = De(lo, Wn, 470296, 0) + Je | 0, Ve = ve, Ve = (ut >> 21) + (Ve = Je >>> 0 > Nn >>> 0 ? Ve + 1 | 0 : Ve) | 0, Ve = (Nn = (wt = (2097151 & ut) << 11 | g >>> 21) + Nn | 0) >>> 0 < wt >>> 0 ? Ve + 1 | 0 : Ve, j[A + 4 | 0] = (2047 & Ve) << 21 | Nn >>> 11, j[A + 3 | 0] = (7 & Ve) << 29 | Nn >>> 3, j[A + 2 | 0] = 31 & ((65535 & ut) << 16 | g >>> 16) | Nn << 5, g = 2097151 & _, _ = De(lo, Wn, 654183, 0) + g | 0, ut = ve, ut = g >>> 0 > _ >>> 0 ? ut + 1 | 0 : ut, g = Ve, Je = (Ve >>= 21) + ut | 0, g = Je = (g = (2097151 & g) << 11 | Nn >>> 21) >>> 0 > (_ = g + _ | 0) >>> 0 ? Je + 1 | 0 : Je, j[A + 6 | 0] = (63 & Je) << 26 | _ >>> 6, Ve = 0, j[A + 5 | 0] = Ve << 13 | (1572864 & Nn) >>> 19 | _ << 2, Ve = 2097151 & Fn, ut = De(lo, Wn, -997805, -1) + Ve | 0, Je = ve, Je = Ve >>> 0 > ut >>> 0 ? Je + 1 | 0 : Je, Ve = (Ve = g >> 21) + Je | 0, Ve = (g = (Nn = ut) + (ut = (2097151 & g) << 11 | _ >>> 21) | 0) >>> 0 < ut >>> 0 ? Ve + 1 | 0 : Ve, j[A + 9 | 0] = (511 & Ve) << 23 | g >>> 9, j[A + 8 | 0] = (1 & Ve) << 31 | g >>> 1, Je = 0, j[A + 7 | 0] = Je << 18 | (2080768 & _) >>> 14 | g << 7, _ = 2097151 & zr, Je = De(lo, Wn, 136657, 0) + _ | 0, ut = ve, ut = _ >>> 0 > Je >>> 0 ? ut + 1 | 0 : ut, _ = (Nn = (2097151 & (_ = Ve)) << 11 | g >>> 21) + Je | 0, Je = (Ve >>= 21) + ut | 0, Je = _ >>> 0 < Nn >>> 0 ? Je + 1 | 0 : Je, j[A + 12 | 0] = (4095 & Je) << 20 | _ >>> 12, j[A + 11 | 0] = (15 & Je) << 28 | _ >>> 4, Ve = 0, j[A + 10 | 0] = Ve << 15 | (1966080 & g) >>> 17 | _ << 4, g = 2097151 & jt, ut = De(lo, Wn, -683901, -1) + g | 0, Ve = ve, Ve = g >>> 0 > ut >>> 0 ? Ve + 1 | 0 : Ve, g = Je, Je = Ve + (Je >>= 21) | 0, Je = (g = (Nn = ut) + (ut = (2097151 & g) << 11 | _ >>> 21) | 0) >>> 0 < ut >>> 0 ? Je + 1 | 0 : Je, j[A + 14 | 0] = (127 & Je) << 25 | g >>> 7, Ve = 0, j[A + 13 | 0] = Ve << 12 | (1048576 & _) >>> 20 | g << 1, Ve = Je >> 21, Ve = (_ = (Je = (2097151 & Je) << 11 | g >>> 21) + (2097151 & qr) | 0) >>> 0 < Je >>> 0 ? Ve + 1 | 0 : Ve, j[A + 17 | 0] = (1023 & Ve) << 22 | _ >>> 10, j[A + 16 | 0] = (3 & Ve) << 30 | _ >>> 2, Je = 0, j[A + 15 | 0] = Je << 17 | (2064384 & g) >>> 15 | _ << 6, g = Ve, Ve >>= 21, ut = (g = (Je = (2097151 & g) << 11 | _ >>> 21) + (2097151 & Ir) | 0) >>> 0 < Je >>> 0 ? Ve + 1 | 0 : Ve, j[A + 20 | 0] = (8191 & ut) << 19 | g >>> 13, j[A + 19 | 0] = (31 & ut) << 27 | g >>> 5, Je = ut >> 21, Je = (Ve = (Nn = (2097151 & ut) << 11 | g >>> 21) + (2097151 & ao) | 0) >>> 0 < Nn >>> 0 ? Je + 1 | 0 : Je, Nn = Ve, j[A + 21 | 0] = Ve, Ve = 0, j[A + 18 | 0] = Ve << 14 | (1835008 & _) >>> 18 | g << 3, j[A + 22 | 0] = (255 & Je) << 24 | Nn >>> 8, Ve = Je >> 21, Ve = (g = (_ = (2097151 & Je) << 11 | Nn >>> 21) + (2097151 & cr) | 0) >>> 0 < _ >>> 0 ? Ve + 1 | 0 : Ve, j[A + 25 | 0] = (2047 & Ve) << 21 | g >>> 11, j[A + 24 | 0] = (7 & Ve) << 29 | g >>> 3, j[A + 23 | 0] = 31 & ((65535 & Je) << 16 | Nn >>> 16) | g << 5, Je = (2097151 & Ve) << 11 | g >>> 21, Ve >>= 21, Ve = (_ = Je + (2097151 & Pr) | 0) >>> 0 < Je >>> 0 ? Ve + 1 | 0 : Ve, j[A + 27 | 0] = (63 & Ve) << 26 | _ >>> 6, Je = 0, j[A + 26 | 0] = Je << 13 | (1572864 & g) >>> 19 | _ << 2, Je = Ve >> 21, Je = (g = (Ve = (2097151 & Ve) << 11 | _ >>> 21) + (2097151 & Rr) | 0) >>> 0 < Ve >>> 0 ? Je + 1 | 0 : Je, j[A + 31 | 0] = (131071 & Je) << 15 | g >>> 17, j[A + 30 | 0] = (511 & Je) << 23 | g >>> 9, j[A + 29 | 0] = (1 & Je) << 31 | g >>> 1, Ve = 0, j[A + 28 | 0] = Ve << 18 | (2080768 & _) >>> 14 | g << 7;
                    }
                    function rr(A, g, _, b) {
                      for (var U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0; he = (U = Be << 3) + _ | 0, ie = B[0 | (U = g + U | 0)] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, en = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, me = ie << 24 | (65280 & ie) << 8, we = (_e = 16711680 & ie) << 24, _e = _e >>> 8 | 0, U = (ye = -16777216 & ie) >>> 24 | 0, l[he >> 2] = we | ye << 8 | -16777216 & ((255 & en) << 24 | ie >>> 8) | 16711680 & ((16777215 & en) << 8 | ie >>> 24) | en >>> 8 & 65280 | en >>> 24, ie = U | _e | me, U = 0, l[he + 4 >> 2] = ie | U | U, (0 | (Be = Be + 1 | 0)) != 16; )
                        ;
                      for (g = l[A + 4 >> 2], l[b >> 2] = l[A >> 2], l[b + 4 >> 2] = g, g = l[A + 60 >> 2], l[b + 56 >> 2] = l[A + 56 >> 2], l[b + 60 >> 2] = g, g = l[A + 52 >> 2], l[b + 48 >> 2] = l[A + 48 >> 2], l[b + 52 >> 2] = g, g = l[A + 44 >> 2], l[b + 40 >> 2] = l[A + 40 >> 2], l[b + 44 >> 2] = g, g = l[A + 36 >> 2], l[b + 32 >> 2] = l[A + 32 >> 2], l[b + 36 >> 2] = g, g = l[A + 28 >> 2], l[b + 24 >> 2] = l[A + 24 >> 2], l[b + 28 >> 2] = g, g = l[A + 20 >> 2], l[b + 16 >> 2] = l[A + 16 >> 2], l[b + 20 >> 2] = g, g = l[A + 12 >> 2], l[b + 8 >> 2] = l[A + 8 >> 2], l[b + 12 >> 2] = g; ye = l[b + 56 >> 2], me = l[b + 60 >> 2], U = l[(g = en = (it = Zt << 3) + _ | 0) >> 2], g = l[g + 4 >> 2], ht = ie = l[b + 36 >> 2], ie = q(Be = l[b + 32 >> 2], ie, 50), he = ve, ie = q(Be, ht, 46) ^ ie, he ^= ve, ie = q(Be, ht, 23) ^ ie, g = (ve ^ he) + g | 0, g = (U = ie + U | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, U = (he = l[(ie = it + 34464 | 0) >> 2]) + U | 0, g = l[ie + 4 >> 2] + g | 0, g = U >>> 0 < he >>> 0 ? g + 1 | 0 : g, ie = (we = ((he = l[b + 48 >> 2]) ^ (_e = l[b + 40 >> 2])) & Be ^ he) + U | 0, U = (((bt = l[b + 52 >> 2]) ^ ($e = l[b + 44 >> 2])) & ht ^ bt) + g | 0, g = (ie >>> 0 < we >>> 0 ? U + 1 | 0 : U) + me | 0, g = (U = ie) >>> 0 > (ie = ie + ye | 0) >>> 0 ? g + 1 | 0 : g, ye = (me = l[b + 24 >> 2]) + ie | 0, U = l[b + 28 >> 2] + g | 0, Le = U = me >>> 0 > ye >>> 0 ? U + 1 | 0 : U, l[b + 24 >> 2] = ye, l[b + 28 >> 2] = U, Tt = U = l[b + 4 >> 2], U = q(je = l[b >> 2], U, 36), me = ve, U = q(je, Tt, 30) ^ U, we = ve ^ me, me = ie + (q(je, Tt, 25) ^ U) | 0, U = g + (ve ^ we) | 0, U = ie >>> 0 > me >>> 0 ? U + 1 | 0 : U, we = (g = me) + (me = je & ((ie = l[b + 16 >> 2]) | (ct = l[b + 8 >> 2])) | ie & ct) | 0, g = (g = U) + (Tt & ((U = l[b + 20 >> 2]) | (Ct = l[b + 12 >> 2])) | U & Ct) | 0, me = g = me >>> 0 > we >>> 0 ? g + 1 | 0 : g, l[b + 56 >> 2] = we, l[b + 60 >> 2] = g, D = ie, Ge = U, Gt = l[(g = Kn = (mt = 8 | it) + _ | 0) >> 2], Gn = l[g + 4 >> 2], U = (($e ^ ht) & Le ^ $e) + bt | 0, U = (g = (ie = (_e ^ Be) & ye ^ _e) + he | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = q(ye, Le, 50), he = ve, ie = q(ye, Le, 46) ^ ie, he ^= ve, ie = (bt = q(ye, Le, 23) ^ ie) + g | 0, g = (ve ^ he) + U | 0, g = (ie >>> 0 < bt >>> 0 ? g + 1 | 0 : g) + Gn | 0, g = (U = ie + Gt | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = (ie = U) + (he = l[(U = mt + 34464 | 0) >> 2]) | 0, U = l[U + 4 >> 2] + g | 0, U = (g = ie >>> 0 < he >>> 0 ? U + 1 | 0 : U) + Ge | 0, mt = U = (D = ie + D | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, l[b + 16 >> 2] = D, l[b + 20 >> 2] = U, g = g + ((Ct | Tt) & me | Ct & Tt) | 0, g = (U = ie + ((je | ct) & we | je & ct) | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = q(we, me, 36), he = ve, ie = q(we, me, 30) ^ ie, Ge = ve ^ he, he = U, U = q(we, me, 25) ^ ie, g = (ve ^ Ge) + g | 0, Ge = g = U >>> 0 > (he = he + U | 0) >>> 0 ? g + 1 | 0 : g, l[b + 48 >> 2] = he, l[b + 52 >> 2] = g, g = (g = _e) + (_e = l[(U = Gn = (ie = 16 | it) + _ | 0) >> 2]) | 0, U = l[U + 4 >> 2] + $e | 0, U = g >>> 0 < _e >>> 0 ? U + 1 | 0 : U, ie = ($e = g) + (_e = l[(g = ie + 34464 | 0) >> 2]) | 0, g = l[g + 4 >> 2] + U | 0, g = ((Le ^ ht) & mt ^ ht) + (g = ie >>> 0 < _e >>> 0 ? g + 1 | 0 : g) | 0, g = (U = (U = ie) + (ie = (ye ^ Be) & D ^ Be) | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = q(D, mt, 50), _e = ve, ie = q(D, mt, 46) ^ ie, _e ^= ve, ie = ($e = q(D, mt, 23) ^ ie) + U | 0, U = (ve ^ _e) + g | 0, bt = U = ie >>> 0 < $e >>> 0 ? U + 1 | 0 : U, g = U, U = q(he, Ge, 36), _e = ve, U = q(he, Ge, 30) ^ U, $e = ve ^ _e, Gt = q(he, Ge, 25) ^ U, U = ((me | Tt) & Ge | me & Tt) + (ve ^ $e) | 0, g = ((_e = Gt + ((we | je) & he | we & je) | 0) >>> 0 < Gt >>> 0 ? U + 1 | 0 : U) + g | 0, $e = g = (U = _e) >>> 0 > (_e = ie + _e | 0) >>> 0 ? g + 1 | 0 : g, l[b + 40 >> 2] = _e, l[b + 44 >> 2] = g, U = bt + Ct | 0, Ct = U = (ct = ie + ct | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, l[b + 8 >> 2] = ct, l[b + 12 >> 2] = U, U = (U = Be) + (Be = l[(g = _n = (ie = 24 | it) + _ | 0) >> 2]) | 0, g = l[g + 4 >> 2] + ht | 0, g = U >>> 0 < Be >>> 0 ? g + 1 | 0 : g, ie = (ht = U) + (Be = l[(U = ie + 34464 | 0) >> 2]) | 0, U = l[U + 4 >> 2] + g | 0, U = (Le ^ (Le ^ mt) & Ct) + (U = ie >>> 0 < Be >>> 0 ? U + 1 | 0 : U) | 0, U = (g = (g = ie) + (ie = ye ^ (ye ^ D) & ct) | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = q(ct, Ct, 50), Be = ve, ie = q(ct, Ct, 46) ^ ie, Be ^= ve, ie = (bt = q(ct, Ct, 23) ^ ie) + g | 0, g = (ve ^ Be) + U | 0, g = ie >>> 0 < bt >>> 0 ? g + 1 | 0 : g, U = q(_e, $e, 36), Be = ve, U = q(_e, $e, 30) ^ U, bt = ve ^ Be, ht = q(_e, $e, 25) ^ U, U = ((me | Ge) & $e | me & Ge) + (ve ^ bt) | 0, U = ((Be = ht + ((he | we) & _e | he & we) | 0) >>> 0 < ht >>> 0 ? U + 1 | 0 : U) + g | 0, bt = U = (ht = Be) >>> 0 > (Be = ie + Be | 0) >>> 0 ? U + 1 | 0 : U, l[b + 32 >> 2] = Be, l[b + 36 >> 2] = U, g = g + Tt | 0, Tt = g = (je = ie + je | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, l[b >> 2] = je, l[b + 4 >> 2] = g, ie = l[(U = Kt = (g = 32 | it) + _ | 0) >> 2], U = Le + l[U + 4 >> 2] | 0, U = (ie = ie + ye | 0) >>> 0 < ye >>> 0 ? U + 1 | 0 : U, ie = (ye = l[(g = g + 34464 | 0) >> 2]) + ie | 0, g = l[g + 4 >> 2] + U | 0, g = (mt ^ (mt ^ Ct) & Tt) + (g = ie >>> 0 < ye >>> 0 ? g + 1 | 0 : g) | 0, g = (U = (U = ie) + (ie = D ^ (D ^ ct) & je) | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = q(je, Tt, 50), ye = ve, ie = q(je, Tt, 46) ^ ie, ye ^= ve, ie = (Le = q(je, Tt, 23) ^ ie) + U | 0, U = (ve ^ ye) + g | 0, ht = U = ie >>> 0 < Le >>> 0 ? U + 1 | 0 : U, g = U, U = q(Be, bt, 36), ye = ve, U = q(Be, bt, 30) ^ U, Le = ve ^ ye, Gt = q(Be, bt, 25) ^ U, U = (($e | Ge) & bt | $e & Ge) + (ve ^ Le) | 0, g = ((ye = Gt + ((he | _e) & Be | he & _e) | 0) >>> 0 < Gt >>> 0 ? U + 1 | 0 : U) + g | 0, ye = g = (Le = ie + ye | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, l[b + 24 >> 2] = Le, l[b + 28 >> 2] = g, U = me + ht | 0, ht = U = (me = ie + we | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, l[b + 56 >> 2] = me, l[b + 60 >> 2] = U, ie = l[(g = $n = (U = 40 | it) + _ | 0) >> 2], g = mt + l[g + 4 >> 2] | 0, g = (ie = ie + D | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, ie = (we = l[(U = U + 34464 | 0) >> 2]) + ie | 0, U = l[U + 4 >> 2] + g | 0, U = (Ct ^ (Ct ^ Tt) & ht) + (U = ie >>> 0 < we >>> 0 ? U + 1 | 0 : U) | 0, U = (g = (g = ie) + (ie = ct ^ (je ^ ct) & me) | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = q(me, ht, 50), we = ve, ie = q(me, ht, 46) ^ ie, we ^= ve, ie = (D = q(me, ht, 23) ^ ie) + g | 0, g = (ve ^ we) + U | 0, g = ie >>> 0 < D >>> 0 ? g + 1 | 0 : g, U = q(Le, ye, 36), we = ve, U = q(Le, ye, 30) ^ U, D = ve ^ we, mt = q(Le, ye, 25) ^ U, U = (($e | bt) & ye | $e & bt) + (ve ^ D) | 0, U = ((we = mt + ((_e | Be) & Le | _e & Be) | 0) >>> 0 < mt >>> 0 ? U + 1 | 0 : U) + g | 0, we = U = (D = ie + we | 0) >>> 0 < we >>> 0 ? U + 1 | 0 : U, l[b + 16 >> 2] = D, l[b + 20 >> 2] = U, g = g + Ge | 0, mt = g = (Ge = ie + he | 0) >>> 0 < he >>> 0 ? g + 1 | 0 : g, l[b + 48 >> 2] = Ge, l[b + 52 >> 2] = g, ie = l[(U = qn = (g = 48 | it) + _ | 0) >> 2], U = Ct + l[U + 4 >> 2] | 0, U = (ie = ie + ct | 0) >>> 0 < ct >>> 0 ? U + 1 | 0 : U, ie = (he = l[(g = g + 34464 | 0) >> 2]) + ie | 0, g = l[g + 4 >> 2] + U | 0, g = (Tt ^ (ht ^ Tt) & mt) + (g = ie >>> 0 < he >>> 0 ? g + 1 | 0 : g) | 0, g = (U = (U = ie) + (ie = je ^ (me ^ je) & Ge) | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = q(Ge, mt, 50), he = ve, ie = q(Ge, mt, 46) ^ ie, he ^= ve, ie = (ct = q(Ge, mt, 23) ^ ie) + U | 0, U = (ve ^ he) + g | 0, Ct = U = ie >>> 0 < ct >>> 0 ? U + 1 | 0 : U, g = U, U = q(D, we, 36), he = ve, U = q(D, we, 30) ^ U, ct = ve ^ he, Gt = q(D, we, 25) ^ U, U = ((ye | bt) & we | ye & bt) + (ve ^ ct) | 0, g = ((he = Gt + ((Be | Le) & D | Be & Le) | 0) >>> 0 < Gt >>> 0 ? U + 1 | 0 : U) + g | 0, ct = g = (U = he) >>> 0 > (he = ie + he | 0) >>> 0 ? g + 1 | 0 : g, l[b + 8 >> 2] = he, l[b + 12 >> 2] = g, U = $e + Ct | 0, Ct = U = (Gt = ie + _e | 0) >>> 0 < _e >>> 0 ? U + 1 | 0 : U, l[b + 40 >> 2] = Gt, l[b + 44 >> 2] = U, ie = l[(g = wn = (U = 56 | it) + _ | 0) >> 2], g = Tt + l[g + 4 >> 2] | 0, g = (ie = ie + je | 0) >>> 0 < je >>> 0 ? g + 1 | 0 : g, ie = (_e = l[(U = U + 34464 | 0) >> 2]) + ie | 0, U = l[U + 4 >> 2] + g | 0, U = (ht ^ (mt ^ ht) & Ct) + (U = ie >>> 0 < _e >>> 0 ? U + 1 | 0 : U) | 0, U = (g = (g = ie) + (ie = me ^ (me ^ Ge) & Gt) | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = q(Gt, Ct, 50), _e = ve, ie = q(Gt, Ct, 46) ^ ie, _e ^= ve, ie = ($e = q(Gt, Ct, 23) ^ ie) + g | 0, g = (ve ^ _e) + U | 0, g = ie >>> 0 < $e >>> 0 ? g + 1 | 0 : g, U = q(he, ct, 36), _e = ve, U = q(he, ct, 30) ^ U, $e = ve ^ _e, je = q(he, ct, 25) ^ U, U = ((ye | we) & ct | ye & we) + (ve ^ $e) | 0, U = ((_e = je + ((D | Le) & he | D & Le) | 0) >>> 0 < je >>> 0 ? U + 1 | 0 : U) + g | 0, $e = U = ($e = _e) >>> 0 > (_e = ie + _e | 0) >>> 0 ? U + 1 | 0 : U, l[b >> 2] = _e, l[b + 4 >> 2] = U, g = g + bt | 0, Tt = g = (U = Be) >>> 0 > (Be = ie + Be | 0) >>> 0 ? g + 1 | 0 : g, l[b + 32 >> 2] = Be, l[b + 36 >> 2] = g, ie = l[(U = pn = (g = 64 | it) + _ | 0) >> 2], U = ht + l[U + 4 >> 2] | 0, U = (ie = ie + me | 0) >>> 0 < me >>> 0 ? U + 1 | 0 : U, ie = (me = l[(g = g + 34464 | 0) >> 2]) + ie | 0, g = l[g + 4 >> 2] + U | 0, g = (mt ^ (mt ^ Ct) & Tt) + (g = ie >>> 0 < me >>> 0 ? g + 1 | 0 : g) | 0, g = (U = (U = ie) + (ie = Ge ^ (Ge ^ Gt) & Be) | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = q(Be, Tt, 50), me = ve, ie = q(Be, Tt, 46) ^ ie, me ^= ve, ie = (bt = q(Be, Tt, 23) ^ ie) + U | 0, U = (ve ^ me) + g | 0, je = U = ie >>> 0 < bt >>> 0 ? U + 1 | 0 : U, g = U, U = q(_e, $e, 36), me = ve, U = q(_e, $e, 30) ^ U, bt = ve ^ me, ht = q(_e, $e, 25) ^ U, U = ((we | ct) & $e | we & ct) + (ve ^ bt) | 0, g = ((me = ht + ((he | D) & _e | he & D) | 0) >>> 0 < ht >>> 0 ? U + 1 | 0 : U) + g | 0, me = g = (bt = ie + me | 0) >>> 0 < me >>> 0 ? g + 1 | 0 : g, l[b + 56 >> 2] = bt, l[b + 60 >> 2] = g, U = ye + je | 0, ht = U = (ye = ie + Le | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, l[b + 24 >> 2] = ye, l[b + 28 >> 2] = U, ie = l[(g = St = (U = 72 | it) + _ | 0) >> 2], g = mt + l[g + 4 >> 2] | 0, g = (ie = ie + Ge | 0) >>> 0 < Ge >>> 0 ? g + 1 | 0 : g, ie = (Ge = l[(U = U + 34464 | 0) >> 2]) + ie | 0, U = l[U + 4 >> 2] + g | 0, U = (Ct ^ (Ct ^ Tt) & ht) + (U = ie >>> 0 < Ge >>> 0 ? U + 1 | 0 : U) | 0, U = (g = (g = ie) + (ie = Gt ^ (Be ^ Gt) & ye) | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = q(ye, ht, 50), Ge = ve, ie = q(ye, ht, 46) ^ ie, Ge ^= ve, ie = (je = q(ye, ht, 23) ^ ie) + g | 0, g = (ve ^ Ge) + U | 0, g = ie >>> 0 < je >>> 0 ? g + 1 | 0 : g, U = q(bt, me, 36), Ge = ve, U = q(bt, me, 30) ^ U, je = ve ^ Ge, Le = q(bt, me, 25) ^ U, U = (($e | ct) & me | $e & ct) + (ve ^ je) | 0, U = ((Ge = Le + ((he | _e) & bt | he & _e) | 0) >>> 0 < Le >>> 0 ? U + 1 | 0 : U) + g | 0, Ge = U = (je = ie + Ge | 0) >>> 0 < Ge >>> 0 ? U + 1 | 0 : U, l[b + 48 >> 2] = je, l[b + 52 >> 2] = U, g = g + we | 0, mt = g = (we = ie + D | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, l[b + 16 >> 2] = we, l[b + 20 >> 2] = g, g = (D = l[(U = fn = (ie = 80 | it) + _ | 0) >> 2]) + Gt | 0, U = l[U + 4 >> 2] + Ct | 0, U = g >>> 0 < D >>> 0 ? U + 1 | 0 : U, ie = (Le = g) + (D = l[(g = ie + 34464 | 0) >> 2]) | 0, g = l[g + 4 >> 2] + U | 0, g = (Tt ^ (ht ^ Tt) & mt) + (g = ie >>> 0 < D >>> 0 ? g + 1 | 0 : g) | 0, g = (U = (U = ie) + (ie = Be ^ (ye ^ Be) & we) | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = q(we, mt, 50), D = ve, ie = q(we, mt, 46) ^ ie, D ^= ve, ie = (Le = q(we, mt, 23) ^ ie) + U | 0, U = (ve ^ D) + g | 0, Ct = U = ie >>> 0 < Le >>> 0 ? U + 1 | 0 : U, g = U, U = q(je, Ge, 36), D = ve, U = q(je, Ge, 30) ^ U, Le = ve ^ D, Gt = q(je, Ge, 25) ^ U, U = ((me | $e) & Ge | me & $e) + (ve ^ Le) | 0, g = ((D = Gt + ((_e | bt) & je | _e & bt) | 0) >>> 0 < Gt >>> 0 ? U + 1 | 0 : U) + g | 0, D = g = (Le = ie + D | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, l[b + 40 >> 2] = Le, l[b + 44 >> 2] = g, U = ct + Ct | 0, Ct = U = (ct = ie + he | 0) >>> 0 < he >>> 0 ? U + 1 | 0 : U, l[b + 8 >> 2] = ct, l[b + 12 >> 2] = U, U = 34464 + (g = 88 | it) | 0, he = l[(g = Ft = g + _ | 0) >> 2], ie = l[U >> 2] + he | 0, g = l[U + 4 >> 2] + l[g + 4 >> 2] | 0, U = Tt + (ie >>> 0 < he >>> 0 ? g + 1 | 0 : g) | 0, U = (ht ^ (mt ^ ht) & Ct) + (U = (g = ie + Be | 0) >>> 0 < Be >>> 0 ? U + 1 | 0 : U) | 0, U = (g = (ie = ye ^ (ye ^ we) & ct) + g | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = q(ct, Ct, 50), he = ve, ie = q(ct, Ct, 46) ^ ie, he ^= ve, ie = (Be = q(ct, Ct, 23) ^ ie) + g | 0, g = (ve ^ he) + U | 0, g = ie >>> 0 < Be >>> 0 ? g + 1 | 0 : g, U = q(Le, D, 36), he = ve, U = q(Le, D, 30) ^ U, Be = ve ^ he, Tt = q(Le, D, 25) ^ U, U = ((me | Ge) & D | me & Ge) + (ve ^ Be) | 0, U = ((he = Tt + ((je | bt) & Le | je & bt) | 0) >>> 0 < Tt >>> 0 ? U + 1 | 0 : U) + g | 0, Be = U = (Be = he) >>> 0 > (he = ie + he | 0) >>> 0 ? U + 1 | 0 : U, l[b + 32 >> 2] = he, l[b + 36 >> 2] = U, g = g + $e | 0, $e = g = (U = _e) >>> 0 > (_e = ie + _e | 0) >>> 0 ? g + 1 | 0 : g, l[b >> 2] = _e, l[b + 4 >> 2] = g, U = 34464 + (g = 96 | it) | 0, Tt = l[(g = Hn = g + _ | 0) >> 2], ie = l[U >> 2] + Tt | 0, U = l[U + 4 >> 2] + l[g + 4 >> 2] | 0, g = ht + (ie >>> 0 < Tt >>> 0 ? U + 1 | 0 : U) | 0, g = (U = ie + ye | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, ie = (ye = we ^ (we ^ ct) & _e) + U | 0, U = (mt ^ (mt ^ Ct) & $e) + g | 0, U = ie >>> 0 < ye >>> 0 ? U + 1 | 0 : U, g = q(_e, $e, 50), ye = ve, g = q(_e, $e, 46) ^ g, ye ^= ve, ht = ie, ie = q(_e, $e, 23) ^ g, U = (ve ^ ye) + U | 0, ht = U = (g = ht + ie | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = g, g = q(he, Be, 36), ye = ve, g = q(he, Be, 30) ^ g, Tt = ve ^ ye, Gt = q(he, Be, 25) ^ g, g = ((D | Ge) & Be | D & Ge) + (ve ^ Tt) | 0, U = ((ye = Gt + ((je | Le) & he | je & Le) | 0) >>> 0 < Gt >>> 0 ? g + 1 | 0 : g) + U | 0, ye = U = (Tt = ie + ye | 0) >>> 0 < ye >>> 0 ? U + 1 | 0 : U, l[b + 24 >> 2] = Tt, l[b + 28 >> 2] = U, U = me + ht | 0, me = U = (bt = ie + bt | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, l[b + 56 >> 2] = bt, l[b + 60 >> 2] = U, U = 34464 + (g = 104 | it) | 0, ht = l[(g = er = g + _ | 0) >> 2], ie = l[U >> 2] + ht | 0, g = l[U + 4 >> 2] + l[g + 4 >> 2] | 0, U = mt + (ie >>> 0 < ht >>> 0 ? g + 1 | 0 : g) | 0, U = (g = ie + we | 0) >>> 0 < we >>> 0 ? U + 1 | 0 : U, ie = (we = ct ^ (_e ^ ct) & bt) + g | 0, g = (Ct ^ ($e ^ Ct) & me) + U | 0, g = ie >>> 0 < we >>> 0 ? g + 1 | 0 : g, U = q(bt, me, 50), we = ve, U = q(bt, me, 46) ^ U, we ^= ve, mt = q(bt, me, 23) ^ U, U = (ve ^ we) + g | 0, ht = U = (ie = mt + ie | 0) >>> 0 < mt >>> 0 ? U + 1 | 0 : U, g = U, U = q(Tt, ye, 36), we = ve, U = q(Tt, ye, 30) ^ U, mt = ve ^ we, Gt = q(Tt, ye, 25) ^ U, U = ((D | Be) & ye | D & Be) + (ve ^ mt) | 0, g = ((we = Gt + ((he | Le) & Tt | he & Le) | 0) >>> 0 < Gt >>> 0 ? U + 1 | 0 : U) + g | 0, we = g = (mt = ie + we | 0) >>> 0 < we >>> 0 ? g + 1 | 0 : g, l[b + 16 >> 2] = mt, l[b + 20 >> 2] = g, g = Ge + ht | 0, Ge = g = (je = ie + je | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, l[b + 48 >> 2] = je, l[b + 52 >> 2] = g, U = 34464 + (g = 112 | it) | 0, ht = l[(ie = Gt = g + _ | 0) >> 2], g = l[U >> 2] + ht | 0, U = l[U + 4 >> 2] + l[ie + 4 >> 2] | 0, U = Ct + (g >>> 0 < ht >>> 0 ? U + 1 | 0 : U) | 0, U = ($e ^ (me ^ $e) & Ge) + (U = (g = g + ct | 0) >>> 0 < ct >>> 0 ? U + 1 | 0 : U) | 0, U = (g = (ie = _e ^ (_e ^ bt) & je) + g | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = q(je, Ge, 50), ct = ve, ie = q(je, Ge, 46) ^ ie, ct ^= ve, ie = (Ct = q(je, Ge, 23) ^ ie) + g | 0, g = (ve ^ ct) + U | 0, ht = g = ie >>> 0 < Ct >>> 0 ? g + 1 | 0 : g, U = g, g = q(mt, we, 36), ct = ve, g = q(mt, we, 30) ^ g, Ct = ve ^ ct, Zn = q(mt, we, 25) ^ g, g = ((ye | Be) & we | ye & Be) + (ve ^ Ct) | 0, U = ((ct = Zn + ((he | Tt) & mt | he & Tt) | 0) >>> 0 < Zn >>> 0 ? g + 1 | 0 : g) + U | 0, ct = U = (Ct = ie + ct | 0) >>> 0 < ct >>> 0 ? U + 1 | 0 : U, l[b + 8 >> 2] = Ct, l[b + 12 >> 2] = U, U = D + ht | 0, ie = U = (D = ie + Le | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, l[b + 40 >> 2] = D, l[b + 44 >> 2] = U, U = 34464 + (g = 120 | it) | 0, it = l[(g = Le = g + _ | 0) >> 2], ht = l[U >> 2] + it | 0, U = l[U + 4 >> 2] + l[g + 4 >> 2] | 0, g = $e + (ht >>> 0 < it >>> 0 ? U + 1 | 0 : U) | 0, g = (me ^ (me ^ Ge) & ie) + (g = (U = _e + ht | 0) >>> 0 < _e >>> 0 ? g + 1 | 0 : g) | 0, g = (U = (_e = bt ^ (je ^ bt) & D) + U | 0) >>> 0 < _e >>> 0 ? g + 1 | 0 : g, _e = q(D, ie, 50), me = ve, _e = q(D, ie, 46) ^ _e, me ^= ve, ie = (_e = q(D, ie, 23) ^ _e) + U | 0, U = (ve ^ me) + g | 0, U = ie >>> 0 < _e >>> 0 ? U + 1 | 0 : U, _e = ie, me = U, g = U, U = q(Ct, ct, 36), D = ve, U = q(Ct, ct, 30) ^ U, Ge = ve ^ D, $e = q(Ct, ct, 25) ^ U, U = ((ye | we) & ct | ye & we) + (ve ^ Ge) | 0, g = ((D = $e + ((mt | Tt) & Ct | mt & Tt) | 0) >>> 0 < $e >>> 0 ? U + 1 | 0 : U) + g | 0, g = (ie = ie + D | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, l[b >> 2] = ie, l[b + 4 >> 2] = g, U = me + Be | 0, U = (Be = he) >>> 0 > (he = he + _e | 0) >>> 0 ? U + 1 | 0 : U, l[b + 32 >> 2] = he, l[b + 36 >> 2] = U, (0 | Zt) != 64; )
                        me = ((Zt = Zt + 16 | 0) << 3) + _ | 0, _e = l[en >> 2], Be = l[en + 4 >> 2], Zn = l[St >> 2], ye = g = l[St + 4 >> 2], U = g, ie = g = l[Gt + 4 >> 2], g = q(Ct = l[Gt >> 2], g, 45), he = ve, D = ((63 & ie) << 26 | Ct >>> 6) ^ (g = q(Ct, ie, 3) ^ g), g = (ie >>> 6 ^ (we = ve ^ he)) + U | 0, U = ((he = D + Zn | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g) + Be | 0, U = (g = he + _e | 0) >>> 0 < he >>> 0 ? U + 1 | 0 : U, _e = he = l[Kn + 4 >> 2], he = q(Be = l[Kn >> 2], he, 63), we = ve, he = ((127 & _e) << 25 | Be >>> 7) ^ q(Be, _e, 56) ^ he, U = (ve ^ we ^ _e >>> 7) + U | 0, he = U = he >>> 0 > (Tt = he + g | 0) >>> 0 ? U + 1 | 0 : U, l[me >> 2] = Tt, l[me + 4 >> 2] = U, Be = (Gt = l[fn >> 2]) + Be | 0, g = (me = l[fn + 4 >> 2]) + _e | 0, U = Be >>> 0 < Gt >>> 0 ? g + 1 | 0 : g, _e = g = l[Le + 4 >> 2], g = q(ht = l[Le >> 2], g, 45), we = ve, D = Be, Be = ((63 & _e) << 26 | ht >>> 6) ^ q(ht, _e, 3) ^ g, U = (ve ^ we ^ _e >>> 6) + U | 0, Be = (D = D + Be | 0) >>> 0 < Be >>> 0 ? U + 1 | 0 : U, U = q(we = l[Gn >> 2], g = l[Gn + 4 >> 2], 63), Ge = ve, Le = D, D = ((127 & g) << 25 | we >>> 7) ^ q(we, g, 56) ^ U, U = (ve ^ Ge ^ g >>> 7) + Be | 0, Be = U = D >>> 0 > (mt = Le + D | 0) >>> 0 ? U + 1 | 0 : U, l[en + 136 >> 2] = mt, l[en + 140 >> 2] = U, U = (it = l[Ft >> 2]) + we | 0, g = (we = l[Ft + 4 >> 2]) + g | 0, D = q(Tt, he, 45), Ge = ve, D = ($e = ((63 & he) << 26 | Tt >>> 6) ^ q(Tt, he, 3) ^ D) + U | 0, U = (ve ^ Ge ^ he >>> 6) + (U >>> 0 < it >>> 0 ? g + 1 | 0 : g) | 0, U = D >>> 0 < $e >>> 0 ? U + 1 | 0 : U, Ge = g = l[_n + 4 >> 2], g = q($e = l[_n >> 2], g, 63), ct = ve, Le = D, D = ((127 & Ge) << 25 | $e >>> 7) ^ q($e, Ge, 56) ^ g, U = (ve ^ ct ^ Ge >>> 7) + U | 0, D = U = D >>> 0 > (Kn = Le + D | 0) >>> 0 ? U + 1 | 0 : U, l[en + 144 >> 2] = Kn, l[en + 148 >> 2] = U, $e = (Gn = l[Hn >> 2]) + $e | 0, g = (g = Ge) + (Ge = l[Hn + 4 >> 2]) | 0, U = $e >>> 0 < Gn >>> 0 ? g + 1 | 0 : g, g = q(mt, Be, 45), ct = ve, bt = ((63 & Be) << 26 | mt >>> 6) ^ q(mt, Be, 3) ^ g, U = (ve ^ ct ^ Be >>> 6) + U | 0, U = ($e = bt + $e | 0) >>> 0 < bt >>> 0 ? U + 1 | 0 : U, ct = g = l[Kt + 4 >> 2], g = q(bt = l[Kt >> 2], g, 63), je = ve, Le = $e, $e = ((127 & ct) << 25 | bt >>> 7) ^ q(bt, ct, 56) ^ g, U = (ve ^ je ^ ct >>> 7) + U | 0, $e = U = $e >>> 0 > (_n = Le + $e | 0) >>> 0 ? U + 1 | 0 : U, l[en + 152 >> 2] = _n, l[en + 156 >> 2] = U, g = (Kt = l[er >> 2]) + bt | 0, U = (U = ct) + (ct = l[er + 4 >> 2]) | 0, bt = q(Kn, D, 45), je = ve, bt = ((63 & D) << 26 | Kn >>> 6) ^ q(Kn, D, 3) ^ bt, U = (ve ^ je ^ D >>> 6) + (g >>> 0 < Kt >>> 0 ? U + 1 | 0 : U) | 0, bt = (Le = bt + g | 0) >>> 0 < bt >>> 0 ? U + 1 | 0 : U, U = q(je = l[$n >> 2], g = l[$n + 4 >> 2], 63), $n = ve, Ft = Le, Le = ((127 & g) << 25 | je >>> 7) ^ (U = q(je, g, 56) ^ U), U = (g >>> 7 ^ (St = ve ^ $n)) + bt | 0, bt = U = Le >>> 0 > ($n = Ft + Le | 0) >>> 0 ? U + 1 | 0 : U, l[en + 160 >> 2] = $n, l[en + 164 >> 2] = U, g = g + ie | 0, g = (U = je + Ct | 0) >>> 0 < je >>> 0 ? g + 1 | 0 : g, je = q(_n, $e, 45), Le = ve, je = (St = ((63 & $e) << 26 | _n >>> 6) ^ q(_n, $e, 3) ^ je) + U | 0, U = (ve ^ Le ^ $e >>> 6) + g | 0, U = je >>> 0 < St >>> 0 ? U + 1 | 0 : U, St = g = l[qn + 4 >> 2], g = q(Le = l[qn >> 2], g, 63), qn = ve, g = q(Le, St, 56) ^ g, Ft = je, U = (St >>> 7 ^ (fn = ve ^ qn)) + U | 0, je = U = (je = ((127 & St) << 25 | Le >>> 7) ^ g) >>> 0 > (qn = Ft + je | 0) >>> 0 ? U + 1 | 0 : U, l[en + 168 >> 2] = qn, l[en + 172 >> 2] = U, g = _e + St | 0, g = (U = Le + ht | 0) >>> 0 < Le >>> 0 ? g + 1 | 0 : g, Ft = Le = l[wn + 4 >> 2], Le = q(fn = l[wn >> 2], Le, 63), St = ve, Le = (wn = ((127 & Ft) << 25 | fn >>> 7) ^ q(fn, Ft, 56) ^ Le) + U | 0, U = (ve ^ St ^ Ft >>> 7) + g | 0, g = Le >>> 0 < wn >>> 0 ? U + 1 | 0 : U, U = q($n, bt, 45), St = ve, U = q($n, bt, 3) ^ U, wn = ve ^ St, St = Le, g = (bt >>> 6 ^ wn) + g | 0, Le = g = (Le = ((63 & bt) << 26 | $n >>> 6) ^ U) >>> 0 > (St = St + Le | 0) >>> 0 ? g + 1 | 0 : g, l[en + 176 >> 2] = St, l[en + 180 >> 2] = g, Hn = l[pn >> 2], pn = g = l[pn + 4 >> 2], wn = g, g = q(Zn, ye, 63), U = ve, er = ((127 & ye) << 25 | Zn >>> 7) ^ q(Zn, ye, 56) ^ g, g = (ve ^ U ^ ye >>> 7) + Be | 0, U = ((mt = er + mt | 0) >>> 0 < er >>> 0 ? g + 1 | 0 : g) + wn | 0, U = (g = mt + Hn | 0) >>> 0 < mt >>> 0 ? U + 1 | 0 : U, Be = q(St, Le, 45), mt = ve, wn = (Be = ((63 & Le) << 26 | St >>> 6) ^ q(St, Le, 3) ^ Be) + g | 0, g = (ve ^ mt ^ Le >>> 6) + U | 0, Be = g = Be >>> 0 > wn >>> 0 ? g + 1 | 0 : g, l[en + 192 >> 2] = wn, l[en + 196 >> 2] = g, U = he + Ft | 0, U = (g = Tt + fn | 0) >>> 0 < fn >>> 0 ? U + 1 | 0 : U, mt = q(Hn, pn, 63), fn = ve, Ft = ((127 & pn) << 25 | Hn >>> 7) ^ q(Hn, pn, 56) ^ mt, U = (ve ^ fn ^ pn >>> 7) + U | 0, g = (mt = Ft + g | 0) >>> 0 < Ft >>> 0 ? U + 1 | 0 : U, U = q(qn, je, 45), fn = ve, U = q(qn, je, 3) ^ U, pn = mt, g = (je >>> 6 ^ (Ft = ve ^ fn)) + g | 0, mt = g = (mt = ((63 & je) << 26 | qn >>> 6) ^ U) >>> 0 > (fn = pn + mt | 0) >>> 0 ? g + 1 | 0 : g, l[en + 184 >> 2] = fn, l[en + 188 >> 2] = g, g = q(it, we, 63), U = ve, g = ((127 & we) << 25 | it >>> 7) ^ q(it, we, 56) ^ g, U = (ve ^ U ^ we >>> 7) + me | 0, g = $e + (g >>> 0 > (Ft = g + Gt | 0) >>> 0 ? U + 1 | 0 : U) | 0, g = (U = _n + Ft | 0) >>> 0 < _n >>> 0 ? g + 1 | 0 : g, $e = q(wn, Be, 45), _n = ve, $e = q(wn, Be, 3) ^ $e, Ft = ve ^ _n, _n = ($e ^= (63 & Be) << 26 | wn >>> 6) + U | 0, U = (Be >>> 6 ^ Ft) + g | 0, $e = U = $e >>> 0 > _n >>> 0 ? U + 1 | 0 : U, l[en + 208 >> 2] = _n, l[en + 212 >> 2] = U, g = q(Gt, me, 63), U = ve, Ft = q(Gt, me, 56) ^ g, U = ((g = me >>> 7 | 0) ^ ve ^ U) + ye | 0, g = D + ((me = (Gt = Ft ^ ((127 & me) << 25 | Gt >>> 7)) + Zn | 0) >>> 0 < Gt >>> 0 ? U + 1 | 0 : U) | 0, g = (U = me + Kn | 0) >>> 0 < Kn >>> 0 ? g + 1 | 0 : g, ye = q(fn, mt, 45), me = ve, D = (ye = ((63 & mt) << 26 | fn >>> 6) ^ q(fn, mt, 3) ^ ye) + U | 0, U = (ve ^ me ^ mt >>> 6) + g | 0, ye = U = ye >>> 0 > D >>> 0 ? U + 1 | 0 : U, l[en + 200 >> 2] = D, l[en + 204 >> 2] = U, g = q(Kt, ct, 63), U = ve, Gt = ((127 & ct) << 25 | Kt >>> 7) ^ q(Kt, ct, 56) ^ g, g = (ve ^ U ^ ct >>> 7) + Ge | 0, U = je + ((me = Gt + Gn | 0) >>> 0 < Gt >>> 0 ? g + 1 | 0 : g) | 0, U = (g = me + qn | 0) >>> 0 < qn >>> 0 ? U + 1 | 0 : U, me = q(_n, $e, 45), je = ve, Ft = g, g = $e >>> 6 | 0, me = ((63 & $e) << 26 | _n >>> 6) ^ q(_n, $e, 3) ^ me, U = (g ^ ve ^ je) + U | 0, me = U = me >>> 0 > ($e = Ft + me | 0) >>> 0 ? U + 1 | 0 : U, l[en + 224 >> 2] = $e, l[en + 228 >> 2] = U, g = q(Gn, Ge, 63), U = ve, g = q(Gn, Ge, 56) ^ g, je = ve ^ U, Gt = ((127 & Ge) << 25 | Gn >>> 7) ^ g, g = ((U = Ge >>> 7 | 0) ^ je) + we | 0, U = bt + ((Ge = Gt + it | 0) >>> 0 < Gt >>> 0 ? g + 1 | 0 : g) | 0, U = (g = Ge + $n | 0) >>> 0 < $n >>> 0 ? U + 1 | 0 : U, we = q(D, ye, 45), Ge = ve, je = g, g = ye >>> 6 | 0, ye = ((63 & ye) << 26 | D >>> 6) ^ q(D, ye, 3) ^ we, g = (g ^ ve ^ Ge) + U | 0, ye = g = ye >>> 0 > (we = je + ye | 0) >>> 0 ? g + 1 | 0 : g, l[en + 216 >> 2] = we, l[en + 220 >> 2] = g, g = q(ht, _e, 63), U = ve, Ge = ((127 & _e) << 25 | ht >>> 7) ^ q(ht, _e, 56) ^ g, U = (ve ^ U ^ _e >>> 7) + ie | 0, U = mt + ((g = Ge + Ct | 0) >>> 0 < Ge >>> 0 ? U + 1 | 0 : U) | 0, g = (D = g + fn | 0) >>> 0 < fn >>> 0 ? U + 1 | 0 : U, U = q($e, me, 45), Ge = ve, mt = D, D = q($e, me, 3) ^ U, U = me >>> 6 | 0, me = mt + (D ^= (63 & me) << 26 | $e >>> 6) | 0, g = (U ^ ve ^ Ge) + g | 0, l[en + 240 >> 2] = me, l[en + 244 >> 2] = me >>> 0 < D >>> 0 ? g + 1 | 0 : g, g = q(Ct, ie, 63), U = ve, g = q(Ct, ie, 56) ^ g, me = ve ^ U, U = ((U = ie >>> 7 | 0) ^ me) + ct | 0, g = Le + ((g ^= (127 & ie) << 25 | Ct >>> 7) >>> 0 > (ie = g + Kt | 0) >>> 0 ? U + 1 | 0 : U) | 0, g = (U = ie + St | 0) >>> 0 < St >>> 0 ? g + 1 | 0 : g, ie = q(we, ye, 45), me = ve, D = U, U = ye >>> 6 | 0, ie = ((63 & ye) << 26 | we >>> 6) ^ q(we, ye, 3) ^ ie, U = (U ^ ve ^ me) + g | 0, ie = U = ie >>> 0 > (ye = D + ie | 0) >>> 0 ? U + 1 | 0 : U, l[en + 232 >> 2] = ye, l[en + 236 >> 2] = U, g = q(Tt, he, 63), U = ve, D = q(Tt, he, 56) ^ g, U = ((g = he >>> 7 | 0) ^ ve ^ U) + _e | 0, g = Be + ((he = (me = D ^ ((127 & he) << 25 | Tt >>> 7)) + ht | 0) >>> 0 < me >>> 0 ? U + 1 | 0 : U) | 0, g = (U = he + wn | 0) >>> 0 < wn >>> 0 ? g + 1 | 0 : g, he = q(ye, ie, 45), _e = ve, Be = U, U = ie >>> 6 | 0, ie = Be + (he = ((63 & ie) << 26 | ye >>> 6) ^ q(ye, ie, 3) ^ he) | 0, U = (U ^ ve ^ _e) + g | 0, l[en + 248 >> 2] = ie, l[en + 252 >> 2] = ie >>> 0 < he >>> 0 ? U + 1 | 0 : U;
                      g = g + l[A + 4 >> 2] | 0, g = (_ = ie + l[A >> 2] | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, l[A >> 2] = _, l[A + 4 >> 2] = g, U = l[A + 12 >> 2] + l[b + 12 >> 2] | 0, g = (_ = l[b + 8 >> 2]) + l[A + 8 >> 2] | 0, l[A + 8 >> 2] = g, l[A + 12 >> 2] = g >>> 0 < _ >>> 0 ? U + 1 | 0 : U, U = l[A + 20 >> 2] + l[b + 20 >> 2] | 0, g = (_ = l[b + 16 >> 2]) + l[A + 16 >> 2] | 0, l[A + 16 >> 2] = g, l[A + 20 >> 2] = g >>> 0 < _ >>> 0 ? U + 1 | 0 : U, g = l[A + 28 >> 2] + l[b + 28 >> 2] | 0, _ = (U = l[b + 24 >> 2]) + l[A + 24 >> 2] | 0, l[A + 24 >> 2] = _, l[A + 28 >> 2] = _ >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = l[A + 36 >> 2] + l[b + 36 >> 2] | 0, g = (_ = l[b + 32 >> 2]) + l[A + 32 >> 2] | 0, l[A + 32 >> 2] = g, l[A + 36 >> 2] = g >>> 0 < _ >>> 0 ? U + 1 | 0 : U, g = l[A + 44 >> 2] + l[b + 44 >> 2] | 0, _ = (U = l[b + 40 >> 2]) + l[A + 40 >> 2] | 0, l[A + 40 >> 2] = _, l[A + 44 >> 2] = _ >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = l[A + 52 >> 2] + l[b + 52 >> 2] | 0, g = (_ = l[b + 48 >> 2]) + l[A + 48 >> 2] | 0, l[A + 48 >> 2] = g, l[A + 52 >> 2] = g >>> 0 < _ >>> 0 ? U + 1 | 0 : U, U = l[A + 60 >> 2] + l[b + 60 >> 2] | 0, g = (_ = l[b + 56 >> 2]) + l[A + 56 >> 2] | 0, l[A + 56 >> 2] = g, l[A + 60 >> 2] = g >>> 0 < _ >>> 0 ? U + 1 | 0 : U;
                    }
                    function Vi(A) {
                      var g, _, b, U, ie, he, D, me, _e, Be, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0, Nn = 0;
                      Le = (Tt = B[A + 44 | 0] | B[A + 45 | 0] << 8 | B[A + 46 | 0] << 16 | B[A + 47 | 0] << 24) >>> 5 & 2097151, $e = De(qn = (B[A + 60 | 0] | B[A + 61 | 0] << 8 | B[A + 62 | 0] << 16 | B[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), we = (ye = B[A + 44 | 0]) << 16 & 2031616 | B[A + 42 | 0] | B[A + 43 | 0] << 8, ye = ve, mt = ye = we >>> 0 > (bt = $e + we | 0) >>> 0 ? ye + 1 | 0 : ye, St = ye = ye - ((bt >>> 0 < 4293918720) - 1 | 0) | 0, $e = ye >> 21, ye = (we = Le) + (Le = (2097151 & ye) << 11 | (je = bt - -1048576 | 0) >>> 21) | 0, we = $e, Zt = we = ye >>> 0 < Le >>> 0 ? we + 1 | 0 : we, Sn = ye, _n = De(ye, we, -683901, -1), ht = ve, ct = De(g = (B[A + 49 | 0] | B[A + 50 | 0] << 8 | B[A + 51 | 0] << 16 | B[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), $e = (ye = B[A + 27 | 0]) >>> 24 | 0, Le = ye << 8 | (Gt = B[A + 23 | 0] | B[A + 24 | 0] << 8 | B[A + 25 | 0] << 16 | B[A + 26 | 0] << 24) >>> 24, we = (ye = B[A + 28 | 0]) >>> 16 | 0, we = 2097151 & ((3 & (we |= $e)) << 30 | (ye = Le | ye << 16) >>> 2), ye = ve, ye = we >>> 0 > ($e = we + ct | 0) >>> 0 ? ye + 1 | 0 : ye, we = De(Hn = (en = B[A + 52 | 0] | B[A + 53 | 0] << 8 | B[A + 54 | 0] << 16 | B[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), ye = ve + ye | 0, ct = $e = we + $e | 0, $e = we >>> 0 > $e >>> 0 ? ye + 1 | 0 : ye, Ge = (we = B[A + 48 | 0]) << 8 | Tt >>> 24, we = ye = we >>> 24 | 0, ye = De(_ = 2097151 & ((3 & (Tt = (ye = (Le = B[A + 49 | 0]) >>> 16 | 0) | we)) << 30 | (we = (Le <<= 16) | Ge) >>> 2), 0, 136657, 0), $e = ve + $e | 0, $e = ye >>> 0 > (we = ye + ct | 0) >>> 0 ? $e + 1 | 0 : $e, Le = (ye = De(b = (B[A + 57 | 0] | B[A + 58 | 0] << 8 | B[A + 59 | 0] << 16 | B[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + we | 0, we = ve + $e | 0, ct = Le, $e = ye >>> 0 > Le >>> 0 ? we + 1 | 0 : we, we = (ye = B[A + 56 | 0]) >>> 24 | 0, Ge = ye << 8 | en >>> 24, we = De(U = 2097151 & ((1 & (en = (ye = (Le = B[A + 57 | 0]) >>> 16 | 0) | we)) << 31 | (we = (Le <<= 16) | Ge) >>> 1), 0, 470296, 0), ye = ve + $e | 0, we = (ye = ($e = Le = we + ct | 0) >>> 0 < we >>> 0 ? ye + 1 | 0 : ye) + ht | 0, we = $e >>> 0 > (Le = $e + _n | 0) >>> 0 ? we + 1 | 0 : we, Ft = $e - -1048576 | 0, fn = $e = ye - (($e >>> 0 < 4293918720) - 1 | 0) | 0, ht = Le - (ye = -2097152 & Ft) | 0, _n = we - ((ye >>> 0 > Le >>> 0) + $e | 0) | 0, we = De(g, 0, 654183, 0), ye = ve, ye = we >>> 0 > ($e = we + (Gt >>> 5 & 2097151) | 0) >>> 0 ? ye + 1 | 0 : ye, Le = (we = $e) + ($e = De(Hn, 0, 470296, 0)) | 0, we = ve + ye | 0, we = $e >>> 0 > Le >>> 0 ? we + 1 | 0 : we, ye = De(_, ur, -997805, -1), we = ve + we | 0, we = ye >>> 0 > ($e = ye + Le | 0) >>> 0 ? we + 1 | 0 : we, Le = (ye = $e) + ($e = De(U, Cr, 666643, 0)) | 0, ye = ve + we | 0, Ge = Le, Le = $e >>> 0 > Le >>> 0 ? ye + 1 | 0 : ye, ct = ($e = De(g, 0, 470296, 0)) + (ye = (ye = B[A + 23 | 0]) << 16 & 2031616 | B[A + 21 | 0] | B[A + 22 | 0] << 8) | 0, $e = ve, $e = ye >>> 0 > ct >>> 0 ? $e + 1 | 0 : $e, ct = (we = De(Hn, 0, 666643, 0)) + ct | 0, ye = ve + $e | 0, $e = De(_, ur, 654183, 0), we = ve + (we >>> 0 > ct >>> 0 ? ye + 1 | 0 : ye) | 0, en = we = $e >>> 0 > (Gt = $e + ct | 0) >>> 0 ? we + 1 | 0 : we, pn = we = we - ((Gt >>> 0 < 4293918720) - 1 | 0) | 0, ye = (ye = we >>> 21 | 0) + Le | 0, $e = ye = (we = (2097151 & we) << 11 | (ct = Gt - -1048576 | 0) >>> 21) >>> 0 > (Ge = we + Ge | 0) >>> 0 ? ye + 1 | 0 : ye, Ct = we = ye - ((Ge >>> 0 < 4293918720) - 1 | 0) | 0, ye = ht, ht = (2097151 & we) << 11 | (Le = Ge - -1048576 | 0) >>> 21, we = (we >> 21) + _n | 0, Tt = ht = (we = ht >>> 0 > (it = ye + ht | 0) >>> 0 ? we + 1 | 0 : we) - ((it >>> 0 < 4293918720) - 1 | 0) | 0, Zn = it - (ye = -2097152 & (_n = it - -1048576 | 0)) | 0, Je = we - ((ye >>> 0 > it >>> 0) + ht | 0) | 0, ye = De(Sn, Zt, 136657, 0), $e = ve + $e | 0, $e = ye >>> 0 > (we = ye + Ge | 0) >>> 0 ? $e + 1 | 0 : $e, $n = we - (ye = -2097152 & Le) | 0, er = $e - ((ye >>> 0 > we >>> 0) + Ct | 0) | 0, it = bt - (ye = -2097152 & je) | 0, St = mt - ((ye >>> 0 > bt >>> 0) + St | 0) | 0, mt = De(qn, 0, 136657, 0), we = (ye = B[A + 40 | 0]) >>> 24 | 0, Le = ye << 8 | (je = B[A + 36 | 0] | B[A + 37 | 0] << 8 | B[A + 38 | 0] << 16 | B[A + 39 | 0] << 24) >>> 24, $e = (ye = B[A + 41 | 0]) >>> 16 | 0, we = ($e |= we) >>> 3 | 0, $e = (7 & $e) << 29 | (ye = Le | ye << 16) >>> 3, ye = we + ve | 0, ye = $e >>> 0 > (Le = $e + mt | 0) >>> 0 ? ye + 1 | 0 : ye, we = De(b, 0, -683901, -1), ye = ve + ye | 0, ye = we >>> 0 > ($e = we + Le | 0) >>> 0 ? ye + 1 | 0 : ye, Ge = $e, we = De(qn, 0, -997805, -1), $e = ve, $e = we >>> 0 > (Le = we + (je >>> 6 & 2097151) | 0) >>> 0 ? $e + 1 | 0 : $e, je = (we = Le) + (Le = De(b, 0, 136657, 0)) | 0, we = ve + $e | 0, $e = De(U, Cr, -683901, -1), we = ve + (Le >>> 0 > je >>> 0 ? we + 1 | 0 : we) | 0, ht = we = $e >>> 0 > (Gn = $e + je | 0) >>> 0 ? we + 1 | 0 : we, Ve = $e = we - ((Gn >>> 0 < 4293918720) - 1 | 0) | 0, ye = ye + (we = $e >> 21) | 0, je = ye = ($e = (2097151 & $e) << 11 | (bt = Gn - -1048576 | 0) >>> 21) >>> 0 > (Ct = $e + Ge | 0) >>> 0 ? ye + 1 | 0 : ye, Kn = ye = ye - ((Ct >>> 0 < 4293918720) - 1 | 0) | 0, we = (we = ye >> 21) + St | 0, or = we = (ye = ($e = (2097151 & ye) << 11 | (Ge = Ct - -1048576 | 0) >>> 21) + it | 0) >>> 0 < $e >>> 0 ? we + 1 | 0 : we, Kt = ye, we = De(ye, we, -683901, -1), ye = ve + er | 0, wn = $e = we + $n | 0, Le = we >>> 0 > $e >>> 0 ? ye + 1 | 0 : ye, er = Gt - (ye = -2097152 & ct) | 0, St = en - ((4095 & pn) + (ye >>> 0 > Gt >>> 0) | 0) | 0, Gt = De(g, 0, 666643, 0), ye = (we = B[A + 19 | 0]) >>> 24 | 0, ct = we << 8 | (en = B[A + 15 | 0] | B[A + 16 | 0] << 8 | B[A + 17 | 0] << 16 | B[A + 18 | 0] << 24) >>> 24, $e = ye, we = (7 & ($e |= we = (ye = B[A + 20 | 0]) >>> 16 | 0)) << 29 | (we = (ye <<= 16) | ct) >>> 3, $e = ve + ($e >>> 3 | 0) | 0, $e = we >>> 0 > (ct = we + Gt | 0) >>> 0 ? $e + 1 | 0 : $e, ye = De(_, ur, 470296, 0), we = ve + $e | 0, ye = ye >>> 0 > (ct = ye + ct | 0) >>> 0 ? we + 1 | 0 : we, $e = De(_, ur, 666643, 0), we = ve, Gt = we = $e >>> 0 > ($n = $e + (en >>> 6 & 2097151) | 0) >>> 0 ? we + 1 | 0 : we, ut = $e = we - (($n >>> 0 < 4293918720) - 1 | 0) | 0, ye = ye + (we = $e >>> 21 | 0) | 0, en = ye = ($e = (2097151 & $e) << 11 | (mt = $n - -1048576 | 0) >>> 21) >>> 0 > (it = $e + ct | 0) >>> 0 ? ye + 1 | 0 : ye, Nn = ye = ye - ((it >>> 0 < 4293918720) - 1 | 0) | 0, we = (we = ye >>> 21 | 0) + St | 0, we = (ye = (2097151 & ye) << 11 | (ct = it - -1048576 | 0) >>> 21) >>> 0 > ($e = ye + er | 0) >>> 0 ? we + 1 | 0 : we, St = (ye = $e) + ($e = De(Sn, Zt, -997805, -1)) | 0, ye = ve + we | 0, ye = $e >>> 0 > St >>> 0 ? ye + 1 | 0 : ye, pn = we = Ct - ($e = -2097152 & Ge) | 0, ie = Ge = je - (($e >>> 0 > Ct >>> 0) + Kn | 0) | 0, $e = De(Kt, or, 136657, 0), ye = ve + ye | 0, ye = $e >>> 0 > (je = $e + St | 0) >>> 0 ? ye + 1 | 0 : ye, $e = De(we, Ge, -683901, -1), we = ve + ye | 0, je = we = $e >>> 0 > (St = $e + je | 0) >>> 0 ? we + 1 | 0 : we, Kn = ye = we - ((St >>> 0 < 4293918720) - 1 | 0) | 0, we = (2097151 & ye) << 11 | (Ge = St - -1048576 | 0) >>> 21, ye = (ye >> 21) + Le | 0, wn = we = (ye = we >>> 0 > (Ct = we + wn | 0) >>> 0 ? ye + 1 | 0 : ye) - ((Ct >>> 0 < 4293918720) - 1 | 0) | 0, er = (2097151 & we) << 11 | (Le = Ct - -1048576 | 0) >>> 21, we = (we >> 21) + Je | 0, D = Zn = er + Zn | 0, er = Zn >>> 0 < er >>> 0 ? we + 1 | 0 : we, me = Ct - (we = -2097152 & Le) | 0, _e = ye - ((we >>> 0 > Ct >>> 0) + wn | 0) | 0, Zn = St - (ye = -2097152 & Ge) | 0, Je = je - ((ye >>> 0 > St >>> 0) + Kn | 0) | 0, $e = (ye = De(Sn, Zt, 654183, 0)) + (it - (we = -2097152 & ct) | 0) | 0, we = ve + (en - ((we >>> 0 > it >>> 0) + Nn | 0) | 0) | 0, we = ye >>> 0 > $e >>> 0 ? we + 1 | 0 : we, ye = De(Kt, or, -997805, -1), we = ve + we | 0, we = ye >>> 0 > ($e = ye + $e | 0) >>> 0 ? we + 1 | 0 : we, Le = (ye = $e) + ($e = De(pn, ie, 136657, 0)) | 0, ye = ve + we | 0, wn = Le, je = $e >>> 0 > Le >>> 0 ? ye + 1 | 0 : ye, it = Gn - (ye = -2097152 & bt) | 0, Ct = ht - ((ye >>> 0 > Gn >>> 0) + Ve | 0) | 0, en = De(Hn, 0, -683901, -1), ye = (we = B[A + 35 | 0]) >>> 24 | 0, Le = we << 8 | (ct = B[A + 31 | 0] | B[A + 32 | 0] << 8 | B[A + 33 | 0] << 16 | B[A + 34 | 0] << 24) >>> 24, $e = ye, we = (ye = B[A + 36 | 0]) >>> 16 | 0, we |= $e, $e = ve, $e = (ye = 2097151 & ((1 & we) << 31 | (ye = ye << 16 | Le) >>> 1)) >>> 0 > (we = ye + en | 0) >>> 0 ? $e + 1 | 0 : $e, Le = (ye = De(qn, 0, 654183, 0)) + we | 0, we = ve + $e | 0, we = ye >>> 0 > Le >>> 0 ? we + 1 | 0 : we, $e = De(b, 0, -997805, -1), ye = ve + we | 0, ye = $e >>> 0 > (Le = $e + Le | 0) >>> 0 ? ye + 1 | 0 : ye, we = De(U, Cr, 136657, 0), ye = ve + ye | 0, Ge = $e = we + Le | 0, Le = we >>> 0 > $e >>> 0 ? ye + 1 | 0 : ye, ye = De(g, 0, -683901, -1), we = ve, we = ye >>> 0 > ($e = ye + (ct >>> 4 & 2097151) | 0) >>> 0 ? we + 1 | 0 : we, ct = (ye = De(Hn, 0, 136657, 0)) + $e | 0, $e = ve + we | 0, $e = ye >>> 0 > ct >>> 0 ? $e + 1 | 0 : $e, ye = De(qn, 0, 470296, 0), we = ve + $e | 0, we = ye >>> 0 > (ct = ye + ct | 0) >>> 0 ? we + 1 | 0 : we, ct = ($e = De(b, 0, 654183, 0)) + ct | 0, ye = ve + we | 0, we = De(U, Cr, -997805, -1), ye = ve + ($e >>> 0 > ct >>> 0 ? ye + 1 | 0 : ye) | 0, en = ye = we >>> 0 > (ht = we + ct | 0) >>> 0 ? ye + 1 | 0 : ye, Be = we = ye - ((ht >>> 0 < 4293918720) - 1 | 0) | 0, $e = (ye = we >> 21) + Le | 0, St = we = ($e = (we = (2097151 & we) << 11 | (ct = ht - -1048576 | 0) >>> 21) >>> 0 > (bt = we + Ge | 0) >>> 0 ? $e + 1 | 0 : $e) - ((bt >>> 0 < 4293918720) - 1 | 0) | 0, ye = (ye = we >> 21) + Ct | 0, Kn = ye = (we = (Le = (2097151 & we) << 11 | (Ge = bt - -1048576 | 0) >>> 21) + it | 0) >>> 0 < Le >>> 0 ? ye + 1 | 0 : ye, Le = wn, wn = we, ye = De(we, ye, -683901, -1), we = ve + je | 0, Ct = Le = Le + ye | 0, Le = ye >>> 0 > Le >>> 0 ? we + 1 | 0 : we, je = (ye = De(Sn, Zt, 470296, 0)) + ($n - (we = -2097152 & mt) | 0) | 0, we = ve + (Gt - ((2047 & ut) + (we >>> 0 > $n >>> 0) | 0) | 0) | 0, we = ye >>> 0 > je >>> 0 ? we + 1 | 0 : we, mt = (ye = je) + (je = De(Kt, or, 654183, 0)) | 0, ye = ve + we | 0, ye = je >>> 0 > mt >>> 0 ? ye + 1 | 0 : ye, je = De(pn, ie, -997805, -1), we = ve + ye | 0, we = je >>> 0 > (mt = je + mt | 0) >>> 0 ? we + 1 | 0 : we, Gn = Ge = bt - (ye = -2097152 & Ge) | 0, he = je = $e - ((ye >>> 0 > bt >>> 0) + St | 0) | 0, $e = De(wn, Kn, 136657, 0), ye = ve + we | 0, ye = $e >>> 0 > (mt = $e + mt | 0) >>> 0 ? ye + 1 | 0 : ye, $e = De(Ge, je, -683901, -1), we = ve + ye | 0, je = we = $e >>> 0 > (Gt = $e + mt | 0) >>> 0 ? we + 1 | 0 : we, St = ye = we - ((Gt >>> 0 < 4293918720) - 1 | 0) | 0, we = (2097151 & ye) << 11 | (Ge = Gt - -1048576 | 0) >>> 21, ye = (ye >> 21) + Le | 0, Ct = we = (ye = we >>> 0 > (mt = we + Ct | 0) >>> 0 ? ye + 1 | 0 : ye) - ((mt >>> 0 < 4293918720) - 1 | 0) | 0, bt = (2097151 & we) << 11 | (Le = mt - -1048576 | 0) >>> 21, we = (we >> 21) + Je | 0, Ve = it = bt + Zn | 0, it = bt >>> 0 > it >>> 0 ? we + 1 | 0 : we, ut = mt - (we = -2097152 & Le) | 0, Nn = ye - ((we >>> 0 > mt >>> 0) + Ct | 0) | 0, Zn = Gt - (ye = -2097152 & Ge) | 0, Je = je - ((ye >>> 0 > Gt >>> 0) + St | 0) | 0, je = De(Sn, Zt, 666643, 0), ye = (we = B[A + 14 | 0]) >>> 24 | 0, Le = we << 8 | (St = B[A + 10 | 0] | B[A + 11 | 0] << 8 | B[A + 12 | 0] << 16 | B[A + 13 | 0] << 24) >>> 24, $e = ye, we = (ye = B[A + 15 | 0]) >>> 16 | 0, we |= $e, $e = ve, $e = (ye = 2097151 & ((1 & we) << 31 | (ye = ye << 16 | Le) >>> 1)) >>> 0 > (we = ye + je | 0) >>> 0 ? $e + 1 | 0 : $e, Le = (ye = we) + (we = De(Kt, or, 470296, 0)) | 0, ye = ve + $e | 0, ye = we >>> 0 > Le >>> 0 ? ye + 1 | 0 : ye, we = De(pn, ie, 654183, 0), ye = ve + ye | 0, ye = we >>> 0 > ($e = we + Le | 0) >>> 0 ? ye + 1 | 0 : ye, Le = (we = $e) + ($e = De(wn, Kn, -997805, -1)) | 0, we = ve + ye | 0, we = $e >>> 0 > Le >>> 0 ? we + 1 | 0 : we, ye = De(Gn, he, 136657, 0), we = ve + we | 0, Gt = $e = ye + Le | 0, Le = ye >>> 0 > $e >>> 0 ? we + 1 | 0 : we, ct = ht - (ye = -2097152 & ct) | 0, je = en - ((ye >>> 0 > ht >>> 0) + Be | 0) | 0, $e = De(g, 0, 136657, 0), ye = ve, ye = (we = (B[A + 28 | 0] | B[A + 29 | 0] << 8 | B[A + 30 | 0] << 16 | B[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > ($e = we + $e | 0) >>> 0 ? ye + 1 | 0 : ye, Ge = (we = $e) + ($e = De(Hn, 0, -997805, -1)) | 0, we = ve + ye | 0, we = $e >>> 0 > Ge >>> 0 ? we + 1 | 0 : we, ye = De(_, ur, -683901, -1), we = ve + we | 0, we = ye >>> 0 > ($e = ye + Ge | 0) >>> 0 ? we + 1 | 0 : we, Ge = (ye = De(qn, 0, 666643, 0)) + $e | 0, $e = ve + we | 0, $e = ye >>> 0 > Ge >>> 0 ? $e + 1 | 0 : $e, we = De(b, 0, 470296, 0), ye = ve + $e | 0, ye = we >>> 0 > (Ge = we + Ge | 0) >>> 0 ? ye + 1 | 0 : ye, we = De(U, Cr, 654183, 0), ye = ve + ye | 0, we = (fn >> 21) + (we >>> 0 > ($e = we + Ge | 0) >>> 0 ? ye + 1 | 0 : ye) | 0, bt = we = (Ge = (2097151 & fn) << 11 | Ft >>> 21) >>> 0 > (Ft = Ge + $e | 0) >>> 0 ? we + 1 | 0 : we, Ct = ye = we - ((Ft >>> 0 < 4293918720) - 1 | 0) | 0, Ge = (2097151 & ye) << 11 | (mt = Ft - -1048576 | 0) >>> 21, ye = (ye >> 21) + je | 0, $n = ye = (we = Ge + ct | 0) >>> 0 < Ge >>> 0 ? ye + 1 | 0 : ye, fn = we, we = De(we, ye, -683901, -1), ye = ve + Le | 0, Ge = $e = we + Gt | 0, Le = we >>> 0 > $e >>> 0 ? ye + 1 | 0 : ye, ye = De(Kt, or, 666643, 0), we = ve, we = ye >>> 0 > ($e = ye + (St >>> 4 & 2097151) | 0) >>> 0 ? we + 1 | 0 : we, ye = De(pn, ie, 470296, 0), we = ve + we | 0, we = ye >>> 0 > ($e = ye + $e | 0) >>> 0 ? we + 1 | 0 : we, je = (ye = De(wn, Kn, 654183, 0)) + $e | 0, $e = ve + we | 0, $e = ye >>> 0 > je >>> 0 ? $e + 1 | 0 : $e, we = De(Gn, he, -997805, -1), ye = ve + $e | 0, ye = we >>> 0 > (je = we + je | 0) >>> 0 ? ye + 1 | 0 : ye, we = De(fn, $n, 136657, 0), ye = ve + ye | 0, en = ye = we >>> 0 > (ht = we + je | 0) >>> 0 ? ye + 1 | 0 : ye, Zt = we = ye - ((ht >>> 0 < 4293918720) - 1 | 0) | 0, ye = Ge, Ge = (2097151 & we) << 11 | (ct = ht - -1048576 | 0) >>> 21, we = (we >> 21) + Le | 0, Kt = Le = (we = ($e = ye + Ge | 0) >>> 0 < Ge >>> 0 ? we + 1 | 0 : we) - (($e >>> 0 < 4293918720) - 1 | 0) | 0, ye = (ye = Le >> 21) + Je | 0, Sn = Ge = (Le = (2097151 & Le) << 11 | (je = $e - -1048576 | 0) >>> 21) + Zn | 0, Gt = Le >>> 0 > Ge >>> 0 ? ye + 1 | 0 : ye, Ge = $e, $e = we, Le = (Ft - (we = -2097152 & mt) | 0) + (mt = (2097151 & Tt) << 11 | _n >>> 21) | 0, we = (bt - ((we >>> 0 > Ft >>> 0) + Ct | 0) | 0) + (Tt >> 21) | 0, St = we = Le >>> 0 < mt >>> 0 ? we + 1 | 0 : we, Hn = we = we - ((Le >>> 0 < 4293918720) - 1 | 0) | 0, _n = ye = we >> 21, ye = De(qn = (2097151 & we) << 11 | (Ct = Le - -1048576 | 0) >>> 21, ye, -683901, -1), $e = ve + $e | 0, $e = ye >>> 0 > (we = ye + Ge | 0) >>> 0 ? $e + 1 | 0 : $e, ur = we - (ye = -2097152 & je) | 0, Cr = $e - ((ye >>> 0 > we >>> 0) + Kt | 0) | 0, ye = De(qn, _n, 136657, 0), we = en + ve | 0, or = ($e = ye + ht | 0) - (ye = -2097152 & ct) | 0, Kt = (we = $e >>> 0 < ht >>> 0 ? we + 1 | 0 : we) - ((ye >>> 0 > $e >>> 0) + Zt | 0) | 0, we = De(pn, ie, 666643, 0), $e = ve, $e = (ye = (B[A + 7 | 0] | B[A + 8 | 0] << 8 | B[A + 9 | 0] << 16 | B[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (we = ye + we | 0) >>> 0 ? $e + 1 | 0 : $e, Ge = (ye = De(wn, Kn, 470296, 0)) + we | 0, we = ve + $e | 0, we = ye >>> 0 > Ge >>> 0 ? we + 1 | 0 : we, ye = De(Gn, he, 654183, 0), we = ve + we | 0, we = ye >>> 0 > ($e = ye + Ge | 0) >>> 0 ? we + 1 | 0 : we, Ge = (ye = $e) + ($e = De(fn, $n, -997805, -1)) | 0, ye = ve + we | 0, mt = Ge, Ge = $e >>> 0 > Ge >>> 0 ? ye + 1 | 0 : ye, en = De(wn, Kn, 666643, 0), ye = (we = B[A + 6 | 0]) >>> 24 | 0, je = we << 8 | (Ft = B[A + 2 | 0] | B[A + 3 | 0] << 8 | B[A + 4 | 0] << 16 | B[A + 5 | 0] << 24) >>> 24, $e = ye, we = (ye = B[A + 7 | 0]) >>> 16 | 0, we = 2097151 & ((3 & (we |= $e)) << 30 | (ye = ye << 16 | je) >>> 2), ye = ve, ye = we >>> 0 > ($e = we + en | 0) >>> 0 ? ye + 1 | 0 : ye, je = (we = De(Gn, he, 470296, 0)) + $e | 0, $e = ve + ye | 0, $e = we >>> 0 > je >>> 0 ? $e + 1 | 0 : $e, we = De(fn, $n, 654183, 0), ye = ve + $e | 0, en = ye = we >>> 0 > (bt = we + je | 0) >>> 0 ? ye + 1 | 0 : ye, Tt = ye = ye - ((bt >>> 0 < 4293918720) - 1 | 0) | 0, we = ($e = ye >> 21) + Ge | 0, ht = ye = (we = (ye = (2097151 & ye) << 11 | (ct = bt - -1048576 | 0) >>> 21) >>> 0 > (je = ye + mt | 0) >>> 0 ? we + 1 | 0 : we) - ((je >>> 0 < 4293918720) - 1 | 0) | 0, mt = (2097151 & ye) << 11 | (Ge = je - -1048576 | 0) >>> 21, ye = (ye >> 21) + Kt | 0, Kt = wn = mt + or | 0, mt = mt >>> 0 > wn >>> 0 ? ye + 1 | 0 : ye, ye = De(qn, _n, -997805, -1), we = ve + we | 0, we = ye >>> 0 > ($e = ye + je | 0) >>> 0 ? we + 1 | 0 : we, pn = $e - (ye = -2097152 & Ge) | 0, Kn = we - ((ye >>> 0 > $e >>> 0) + ht | 0) | 0, we = De(qn, _n, 654183, 0), ye = en + ve | 0, wn = ($e = we + bt | 0) - (we = -2097152 & ct) | 0, Tt = (ye = $e >>> 0 < bt >>> 0 ? ye + 1 | 0 : ye) - ((we >>> 0 > $e >>> 0) + Tt | 0) | 0, ye = De(Gn, he, 666643, 0), we = ve, we = ye >>> 0 > ($e = ye + (Ft >>> 5 & 2097151) | 0) >>> 0 ? we + 1 | 0 : we, ye = De(fn, $n, 470296, 0), we = ve + we | 0, je = $e = ye + $e | 0, $e = ye >>> 0 > $e >>> 0 ? we + 1 | 0 : we, Ge = De(fn, $n, 666643, 0), we = (ye = B[A + 2 | 0]) << 16 & 2031616 | B[0 | A] | B[A + 1 | 0] << 8, ye = ve, en = ye = we >>> 0 > (ht = Ge + we | 0) >>> 0 ? ye + 1 | 0 : ye, $n = ye = ye - ((ht >>> 0 < 4293918720) - 1 | 0) | 0, Ge = (2097151 & ye) << 11 | (ct = ht - -1048576 | 0) >>> 21, ye = (ye >> 21) + $e | 0, $e = ye = Ge >>> 0 > (bt = Ge + je | 0) >>> 0 ? ye + 1 | 0 : ye, Ft = ye = ye - ((bt >>> 0 < 4293918720) - 1 | 0) | 0, Ge = (2097151 & ye) << 11 | (je = bt - -1048576 | 0) >>> 21, ye = (ye >> 21) + Tt | 0, Ge = Ge >>> 0 > (Tt = fn = Ge + wn | 0) >>> 0 ? ye + 1 | 0 : ye, ye = De(qn, _n, 470296, 0), $e = $e + ve | 0, $e = (we = ye + bt | 0) >>> 0 < bt >>> 0 ? $e + 1 | 0 : $e, bt = we - (ye = -2097152 & je) | 0, je = $e - ((ye >>> 0 > we >>> 0) + Ft | 0) | 0, we = De(qn, _n, 666643, 0), ye = ve + (en - ((($e = -2097152 & ct) >>> 0 > ht >>> 0) + $n | 0) | 0) | 0, we = ($e = (ye = we >>> 0 > (fn = we + (ht - $e | 0) | 0) >>> 0 ? ye + 1 | 0 : ye) >> 21) + je | 0, ye = (ye = (we = (ye = (2097151 & ye) << 11 | fn >>> 21) >>> 0 > (Ft = ye + bt | 0) >>> 0 ? we + 1 | 0 : we) >> 21) + Ge | 0, we = (we = (ye = (we = (2097151 & we) << 11 | Ft >>> 21) >>> 0 > (Tt = we + Tt | 0) >>> 0 ? ye + 1 | 0 : ye) >> 21) + Kn | 0, $e = (ye = (we = (ye = (2097151 & ye) << 11 | Tt >>> 21) >>> 0 > (Ge = ye + pn | 0) >>> 0 ? we + 1 | 0 : we) >> 21) + mt | 0, ye = (we = ($e = (we = (2097151 & we) << 11 | Ge >>> 21) >>> 0 > (_n = we + Kt | 0) >>> 0 ? $e + 1 | 0 : $e) >> 21) + Cr | 0, we = ($e = (ye = ($e = (2097151 & $e) << 11 | _n >>> 21) >>> 0 > (ht = $e + ur | 0) >>> 0 ? ye + 1 | 0 : ye) >> 21) + Gt | 0, ye = (ye = (we = (ye = (2097151 & ye) << 11 | ht >>> 21) >>> 0 > (bt = ye + Sn | 0) >>> 0 ? we + 1 | 0 : we) >> 21) + Nn | 0, we = (we = (ye = (we = (2097151 & we) << 11 | bt >>> 21) >>> 0 > (Gt = we + ut | 0) >>> 0 ? ye + 1 | 0 : ye) >> 21) + it | 0, $e = (ye = (we = (ye = (2097151 & ye) << 11 | Gt >>> 21) >>> 0 > (mt = ye + Ve | 0) >>> 0 ? we + 1 | 0 : we) >> 21) + _e | 0, ye = (we = ($e = (we = (2097151 & we) << 11 | mt >>> 21) >>> 0 > (en = we + me | 0) >>> 0 ? $e + 1 | 0 : $e) >> 21) + er | 0, je = (Ct = Le - (we = -2097152 & Ct) | 0) + ((2097151 & (ye = ($e = (2097151 & $e) << 11 | en >>> 21) >>> 0 > (ct = $e + D | 0) >>> 0 ? ye + 1 | 0 : ye)) << 11 | ct >>> 21) | 0, ye = (St - ((we >>> 0 > Le >>> 0) + Hn | 0) | 0) + (ye >> 21) | 0, Ct = we = (ye = je >>> 0 < Ct >>> 0 ? ye + 1 | 0 : ye) >> 21, fn = (ye = De(it = (2097151 & ye) << 11 | je >>> 21, we, 666643, 0)) + (we = 2097151 & fn) | 0, ye = ve, Le = ye = we >>> 0 > fn >>> 0 ? ye + 1 | 0 : ye, j[0 | A] = fn, j[A + 1 | 0] = (255 & ye) << 24 | fn >>> 8, ye = 2097151 & Ft, we = De(it, Ct, 470296, 0) + ye | 0, $e = ve, ye = (Le >> 21) + (ye >>> 0 > we >>> 0 ? $e + 1 | 0 : $e) | 0, ye = (St = (2097151 & Le) << 11 | fn >>> 21) >>> 0 > (Ft = St + we | 0) >>> 0 ? ye + 1 | 0 : ye, j[A + 4 | 0] = (2047 & ye) << 21 | Ft >>> 11, we = ye, $e = Ft, j[A + 3 | 0] = (7 & ye) << 29 | $e >>> 3, j[A + 2 | 0] = 31 & ((65535 & Le) << 16 | fn >>> 16) | $e << 5, Le = 2097151 & Tt, Tt = De(it, Ct, 654183, 0) + Le | 0, ye = ve, Ft = (2097151 & we) << 11 | $e >>> 21, we = (we >> 21) + (Le = Le >>> 0 > Tt >>> 0 ? ye + 1 | 0 : ye) | 0, ye = we = (Tt = Ft + Tt | 0) >>> 0 < Ft >>> 0 ? we + 1 | 0 : we, j[A + 6 | 0] = (63 & ye) << 26 | Tt >>> 6, Le = Tt, Tt = 0, j[A + 5 | 0] = Tt << 13 | (1572864 & $e) >>> 19 | Le << 2, $e = 2097151 & Ge, Ge = De(it, Ct, -997805, -1) + $e | 0, we = ve, we = $e >>> 0 > Ge >>> 0 ? we + 1 | 0 : we, Tt = (2097151 & ($e = ye)) << 11 | Le >>> 21, $e = (ye >>= 21) + we | 0, $e = (Ge = Tt + Ge | 0) >>> 0 < Tt >>> 0 ? $e + 1 | 0 : $e, j[A + 9 | 0] = (511 & $e) << 23 | Ge >>> 9, j[A + 8 | 0] = (1 & $e) << 31 | Ge >>> 1, we = 0, j[A + 7 | 0] = we << 18 | (2080768 & Le) >>> 14 | Ge << 7, we = 2097151 & _n, Le = De(it, Ct, 136657, 0) + we | 0, ye = ve, ye = we >>> 0 > Le >>> 0 ? ye + 1 | 0 : ye, _n = (2097151 & (we = $e)) << 11 | Ge >>> 21, we = ye + ($e = we >> 21) | 0, we = (Le = _n + Le | 0) >>> 0 < _n >>> 0 ? we + 1 | 0 : we, j[A + 12 | 0] = (4095 & we) << 20 | Le >>> 12, $e = Le, j[A + 11 | 0] = (15 & we) << 28 | $e >>> 4, Le = 0, j[A + 10 | 0] = Le << 15 | (1966080 & Ge) >>> 17 | $e << 4, Le = 2097151 & ht, Ge = De(it, Ct, -683901, -1) + Le | 0, ye = ve, ye = Le >>> 0 > Ge >>> 0 ? ye + 1 | 0 : ye, Le = we, we = ye + (we >>= 21) | 0, we = (Le = (wn = Ge) + (Ge = (2097151 & Le) << 11 | $e >>> 21) | 0) >>> 0 < Ge >>> 0 ? we + 1 | 0 : we, j[A + 14 | 0] = (127 & we) << 25 | Le >>> 7, Ge = 0, j[A + 13 | 0] = Ge << 12 | (1048576 & $e) >>> 20 | Le << 1, ye = we >> 21, $e = (we = (2097151 & we) << 11 | Le >>> 21) >>> 0 > (Ge = we + (2097151 & bt) | 0) >>> 0 ? ye + 1 | 0 : ye, j[A + 17 | 0] = (1023 & $e) << 22 | Ge >>> 10, j[A + 16 | 0] = (3 & $e) << 30 | Ge >>> 2, we = 0, j[A + 15 | 0] = we << 17 | (2064384 & Le) >>> 15 | Ge << 6, ye = $e >> 21, ye = (we = (2097151 & $e) << 11 | Ge >>> 21) >>> 0 > ($e = we + (2097151 & Gt) | 0) >>> 0 ? ye + 1 | 0 : ye, j[A + 20 | 0] = (8191 & ye) << 19 | $e >>> 13, j[A + 19 | 0] = (31 & ye) << 27 | $e >>> 5, Le = (we = 2097151 & mt) + (mt = (2097151 & ye) << 11 | $e >>> 21) | 0, we = ye >> 21, we = Le >>> 0 < mt >>> 0 ? we + 1 | 0 : we, mt = Le, j[A + 21 | 0] = Le, Gt = 0, j[A + 18 | 0] = Gt << 14 | (1835008 & Ge) >>> 18 | $e << 3, j[A + 22 | 0] = (255 & we) << 24 | Le >>> 8, $e = we >> 21, $e = (Le = (Ge = (2097151 & we) << 11 | Le >>> 21) + (2097151 & en) | 0) >>> 0 < Ge >>> 0 ? $e + 1 | 0 : $e, j[A + 25 | 0] = (2047 & $e) << 21 | Le >>> 11, j[A + 24 | 0] = (7 & $e) << 29 | Le >>> 3, j[A + 23 | 0] = 31 & ((65535 & we) << 16 | mt >>> 16) | Le << 5, ye = $e >> 21, ye = (we = (2097151 & $e) << 11 | Le >>> 21) >>> 0 > ($e = we + (2097151 & ct) | 0) >>> 0 ? ye + 1 | 0 : ye, j[A + 27 | 0] = (63 & ye) << 26 | $e >>> 6, Ge = 0, j[A + 26 | 0] = Ge << 13 | (1572864 & Le) >>> 19 | $e << 2, we = ye >> 21, we = (ye = (Le = (2097151 & ye) << 11 | $e >>> 21) + (2097151 & je) | 0) >>> 0 < Le >>> 0 ? we + 1 | 0 : we, j[A + 31 | 0] = (131071 & we) << 15 | ye >>> 17, j[A + 30 | 0] = (511 & we) << 23 | ye >>> 9, j[A + 29 | 0] = (1 & we) << 31 | ye >>> 1, Le = 0, j[A + 28 | 0] = Le << 18 | (2080768 & $e) >>> 14 | ye << 7;
                    }
                    function Cn(A, g) {
                      var _, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0, Nn = 0, cr = 0, Rr = 0, Ir = 0, Pr = 0, qr = 0, ao = 0, Fn = 0, Wn = 0, wt = 0, jt = 0, an = 0, Ar = 0;
                      if (st = _ = st - 4096 | 0, A) {
                        e: {
                          t: {
                            if ((0 | (me = l[A + 36 >> 2])) == 2) {
                              if (Pr = l[A + 4 >> 2], (Cr = l[g >> 2]) | (er = B[g + 8 | 0]) >>> 0 >= 2)
                                break t;
                              Cr = 0;
                            } else
                              er = B[g + 8 | 0], Pr = l[A + 4 >> 2], Cr = l[g >> 2];
                            if (Jt(_ + 3072 | 0, 0, 1024), Jt(_ + 2104 | 0, 0, 968), l[_ + 2048 >> 2] = Cr, l[_ + 2052 >> 2] = 0, wn = l[g + 4 >> 2], l[_ + 2064 >> 2] = er, l[_ + 2068 >> 2] = 0, l[_ + 2056 >> 2] = wn, l[_ + 2060 >> 2] = 0, l[_ + 2072 >> 2] = l[A + 16 >> 2], l[_ + 2076 >> 2] = 0, wn = l[A + 8 >> 2], l[_ + 2088 >> 2] = me, l[_ + 2092 >> 2] = 0, l[_ + 2080 >> 2] = wn, l[_ + 2084 >> 2] = 0, !l[A + 20 >> 2])
                              break e;
                            for (wn = 0; (ct = 127 & _e) || (wn = (Kt = Kt + 1 | 0) ? wn : wn + 1 | 0, l[_ + 2096 >> 2] = Kt, l[_ + 2100 >> 2] = wn, me = Jt(_, 0, 1024), Jt(me + 1024 | 0, 0, 1024), Ks(b = me + 3072 | 0, me + 2048 | 0, me), Ks(b, me, me + 1024 | 0)), ct = l[4 + (me = (_ + 1024 | 0) + (ct << 3) | 0) >> 2], l[(b = (_e << 3) + Pr | 0) >> 2] = l[me >> 2], l[b + 4 >> 2] = ct, (ct = l[A + 20 >> 2]) >>> 0 > (_e = _e + 1 | 0) >>> 0; )
                              ;
                            break e;
                          }
                          ct = l[A + 20 >> 2], Wn = 1;
                        }
                        if (!((wn = (ao = !(er | Cr)) << 1) >>> 0 >= ct >>> 0))
                          for (me = l[A + 24 >> 2], Ir = l[g + 4 >> 2], _e = (Kt = (wr(me, Ir) + wn | 0) + wr(ct, er) | 0) + ((Kt >>> 0) % (me >>> 0) | 0 ? -1 : me - 1 | 0) | 0, wt = er + 1 | 0; ; ) {
                            b = l[A + 28 >> 2], qr = ((Kt >>> 0) % ((me = l[A + 24 >> 2]) >>> 0) | 0) == 1 ? Kt - 1 | 0 : _e, _e = Wn ? l[l[A >> 2] + 4 >> 2] + (qr << 10) | 0 : (wn << 3) + Pr | 0, U = l[_e >> 2], _e = l[_e + 4 >> 2], l[g + 12 >> 2] = wn, b = ao ? Ir : (_e >>> 0) % (b >>> 0) | 0;
                            e:
                              if (Cr)
                                _e = me + ((0 | b) == (0 | Ir) ? (-1 ^ ct) + wn | 0 : (wn ? 0 : -1) - ct | 0) | 0, ie = 0, (0 | er) != 3 && (ie = wr(ct, wt));
                              else {
                                if (!er) {
                                  _e = wn - 1 | 0, ie = 0;
                                  break e;
                                }
                                if (_e = wr(ct, er), (0 | b) == (0 | Ir)) {
                                  _e = (_e + wn | 0) - 1 | 0, ie = 0;
                                  break e;
                                }
                                _e = _e - !wn | 0, ie = 0;
                              }
                            if (Be = (ct = l[l[A >> 2] + 4 >> 2]) + (wr(b, me) << 10) | 0, ie = (he = b = _e - 1 | 0) >>> 0 > (b = b + ie | 0) >>> 0, De(U, 0, U, 0), De(_e, 0, ve, 0), ta(b - (_e = ve) | 0, ie - (b >>> 0 < _e >>> 0) | 0, me), ve = Bs, _e = (Oe << 10) + Be | 0, me = ct + (qr << 10) | 0, Fn = ct + (Kt << 10) | 0, Cr)
                              Ks(me, _e, Fn);
                            else {
                              for (xr(_ + 3072 | 0, _e, 1024), _e = 0; ie = l[(U = (ct = _e << 3) + (b = _ + 3072 | 0) | 0) >> 2], we = l[(Be = me + ct | 0) >> 2], Be = l[U + 4 >> 2] ^ l[Be + 4 >> 2], l[U >> 2] = ie ^ we, l[U + 4 >> 2] = Be, Be = l[(U = (ie = 8 | ct) + b | 0) >> 2], we = l[(ie = me + ie | 0) >> 2], ie = l[U + 4 >> 2] ^ l[ie + 4 >> 2], l[U >> 2] = Be ^ we, l[U + 4 >> 2] = ie, Be = l[(U = (ie = 16 | ct) + b | 0) >> 2], we = l[(ie = me + ie | 0) >> 2], ie = l[U + 4 >> 2] ^ l[ie + 4 >> 2], l[U >> 2] = Be ^ we, l[U + 4 >> 2] = ie, b = l[(ct = b + (U = 24 | ct) | 0) >> 2], ie = l[(U = U + me | 0) >> 2], U = l[ct + 4 >> 2] ^ l[U + 4 >> 2], l[ct >> 2] = b ^ ie, l[ct + 4 >> 2] = U, (0 | (_e = _e + 4 | 0)) != 128; )
                                ;
                              for (xr(_ + 2048 | 0, _ + 3072 | 0, 1024), ct = 0, _e = 0; Be = (ie = l[56 + (me = (_ + 3072 | 0) + (_e << 7) | 0) >> 2]) + (U = l[me + 24 >> 2]) | 0, we = (he = l[me + 60 >> 2]) + (b = l[me + 28 >> 2]) | 0, ye = De(U << 1 & -2, 1 & (b << 1 | U >>> 31), ie, 0), U = ve + (U >>> 0 > Be >>> 0 ? we + 1 | 0 : we) | 0, Be = (b = ye + Be | 0) >>> 0 < ye >>> 0 ? U + 1 | 0 : U, ye = (we = q(b ^ l[me + 120 >> 2], Be ^ l[me + 124 >> 2], 32)) + (U = l[me + 88 >> 2]) | 0, D = (Ge = ve) + (St = l[me + 92 >> 2]) | 0, $e = ie, St = De(we, 0, U << 1 & -2, 1 & (St << 1 | U >>> 31)), U = ve + (U >>> 0 > ye >>> 0 ? D + 1 | 0 : D) | 0, fn = q($e ^ (ie = St + ye | 0), he ^ (qn = ie >>> 0 < St >>> 0 ? U + 1 | 0 : U), 40), ye = 1 + (U = Be + (Nn = ve) | 0) | 0, he = U, ye = (U = b + fn | 0) >>> 0 < b >>> 0 ? ye : he, St = (b = De(fn, 0, b << 1 & -2, 1 & (Be << 1 | b >>> 31))) + U | 0, U = ve + ye | 0, ht = q(St ^ we, Ge ^ (Hn = b >>> 0 > St >>> 0 ? U + 1 | 0 : U), 48), Gt = $e = ve, Be = (Le = l[me + 44 >> 2]) + (b = l[me + 12 >> 2]) | 0, ye = (we = l[me + 40 >> 2]) + (U = l[me + 8 >> 2]) | 0, D = De(U << 1 & -2, 1 & (b << 1 | U >>> 31), we, 0), U = ve + (U >>> 0 > ye >>> 0 ? Be + 1 | 0 : Be) | 0, ye = (b = ye + D | 0) >>> 0 < D >>> 0 ? U + 1 | 0 : U, he = (D = q(b ^ l[me + 104 >> 2], ye ^ l[me + 108 >> 2], 32)) + (Be = l[me + 72 >> 2]) | 0, Ge = (mt = ve) + (U = l[me + 76 >> 2]) | 0, je = we, we = De(D, 0, Be << 1 & -2, 1 & (U << 1 | Be >>> 31)), Be = ve + (he >>> 0 < Be >>> 0 ? Ge + 1 | 0 : Ge) | 0, we = q(je ^ (U = we + he | 0), Le ^ (he = U >>> 0 < we >>> 0 ? Be + 1 | 0 : Be), 40), je = 1 + (Be = ye + (Ge = ve) | 0) | 0, Le = Be, Le = (Be = b + we | 0) >>> 0 < b >>> 0 ? je : Le, b = De(we, 0, b << 1 & -2, 1 & (ye << 1 | b >>> 31)), ye = ve + Le | 0, Le = q((Be = b + Be | 0) ^ D, mt ^ (Zn = b >>> 0 > Be >>> 0 ? ye + 1 | 0 : ye), 48), D = 1 + (b = he + (cr = ve) | 0) | 0, ye = b, ye = (b = U + Le | 0) >>> 0 < U >>> 0 ? D : ye, D = we, we = b, b = De(Le, 0, U << 1 & -2, 1 & (he << 1 | U >>> 31)), U = ve + ye | 0, mt = q(D ^ (we = we + b | 0), Ge ^ (Zt = b >>> 0 > we >>> 0 ? U + 1 | 0 : U), 1), Je = bt = ve, ye = (it = l[me + 36 >> 2]) + (b = l[me + 4 >> 2]) | 0, he = (D = l[me + 32 >> 2]) + (U = l[me >> 2]) | 0, Ge = De(U << 1 & -2, 1 & (b << 1 | U >>> 31), D, 0), U = ve + (U >>> 0 > he >>> 0 ? ye + 1 | 0 : ye) | 0, he = (b = he + Ge | 0) >>> 0 < Ge >>> 0 ? U + 1 | 0 : U, Ge = (Sn = q(b ^ l[me + 96 >> 2], he ^ l[me + 100 >> 2], 32)) + (U = l[(ye = pn = me - -64 | 0) >> 2]) | 0, je = (Rr = ve) + (ye = l[ye + 4 >> 2]) | 0, Ct = D, D = De(Sn, 0, U << 1 & -2, 1 & (ye << 1 | U >>> 31)), U = ve + (U >>> 0 > Ge >>> 0 ? je + 1 | 0 : je) | 0, je = q(Ct ^ (ye = D + Ge | 0), it ^ (Kn = D >>> 0 > ye >>> 0 ? U + 1 | 0 : U), 40), Ge = 1 + (U = he + (or = ve) | 0) | 0, D = U, D = (U = b + je | 0) >>> 0 < b >>> 0 ? Ge : D, Ge = U, U = De(je, 0, b << 1 & -2, 1 & (he << 1 | b >>> 31)), D = ve + D | 0, D = 1 + (U = bt + ($n = (b = Ge + U | 0) >>> 0 < U >>> 0 ? D + 1 | 0 : D) | 0) | 0, he = U, he = (U = b + mt | 0) >>> 0 < b >>> 0 ? D : he, D = U, U = De(mt, 0, b << 1 & -2, 1 & ($n << 1 | b >>> 31)), he = ve + he | 0, $e = q((D = D + U | 0) ^ ht, $e ^ (_n = U >>> 0 > D >>> 0 ? he + 1 | 0 : he), 32), ur = ve, Ge = (en = l[me + 52 >> 2]) + (U = l[me + 20 >> 2]) | 0, it = (bt = l[me + 48 >> 2]) + (he = l[me + 16 >> 2]) | 0, Ft = De(he << 1 & -2, 1 & (U << 1 | he >>> 31), bt, 0), he = ve + (he >>> 0 > it >>> 0 ? Ge + 1 | 0 : Ge) | 0, it = (U = it + Ft | 0) >>> 0 < Ft >>> 0 ? he + 1 | 0 : he, Gn = (Ft = q(U ^ l[me + 112 >> 2], it ^ l[me + 116 >> 2], 32)) + (Ge = l[me + 80 >> 2]) | 0, Ct = (Ve = ve) + (he = l[me + 84 >> 2]) | 0, Tt = bt, bt = De(Ft, 0, Ge << 1 & -2, 1 & (he << 1 | Ge >>> 31)), Ge = ve + (Ge >>> 0 > Gn >>> 0 ? Ct + 1 | 0 : Ct) | 0, bt = q(Tt ^ (he = bt + Gn | 0), en ^ (Gn = he >>> 0 < bt >>> 0 ? Ge + 1 | 0 : Ge), 40), Tt = 1 + (Ge = it + (en = ve) | 0) | 0, Ct = Ge, Ct = (Ge = U + bt | 0) >>> 0 < U >>> 0 ? Tt : Ct, U = De(bt, 0, U << 1 & -2, 1 & (it << 1 | U >>> 31)), it = ve + Ct | 0, it = q(Tt = (Ge = U + Ge | 0) ^ Ft, Ve ^ (Ft = U >>> 0 > Ge >>> 0 ? it + 1 | 0 : it), 48), Tt = 1 + (U = Gn + (Ve = ve) | 0) | 0, Ct = U, Ct = (U = he + it | 0) >>> 0 < he >>> 0 ? Tt : Ct, he = De(it, 0, he << 1 & -2, 1 & (Gn << 1 | he >>> 31)), Gn = ve + Ct | 0, Tt = 1 + (he = (Gn = (U = he + U | 0) >>> 0 < he >>> 0 ? Gn + 1 | 0 : Gn) + ur | 0) | 0, Ct = he, Ct = (he = U + $e | 0) >>> 0 < U >>> 0 ? Tt : Ct, Tt = mt, mt = De($e, 0, U << 1 & -2, 1 & (Gn << 1 | U >>> 31)), Ct = ve + Ct | 0, mt = q(Tt ^ (he = mt + he | 0), Je ^ (Ct = he >>> 0 < mt >>> 0 ? Ct + 1 | 0 : Ct), 40), jt = 1 + (Tt = _n + (Je = ve) | 0) | 0, ut = Tt, ut = (Tt = D + mt | 0) >>> 0 < D >>> 0 ? jt : ut, D = (_n = De(mt, 0, D << 1 & -2, 1 & (_n << 1 | D >>> 31))) + Tt | 0, l[me >> 2] = D, Tt = ve + ut | 0, _n = D >>> 0 < _n >>> 0 ? Tt + 1 | 0 : Tt, l[me + 4 >> 2] = _n, D = q(D ^ $e, _n ^ ur, 48), l[me + 120 >> 2] = D, $e = ve, l[me + 124 >> 2] = $e, ut = 1 + ($e = $e + Ct | 0) | 0, Tt = $e, _n = ($e = D + he | 0) >>> 0 < he >>> 0 ? ut : Tt, D = (he = De(D, 0, he << 1 & -2, 1 & (Ct << 1 | he >>> 31))) + $e | 0, l[me + 80 >> 2] = D, $e = ve + _n | 0, he = D >>> 0 < he >>> 0 ? $e + 1 | 0 : $e, l[me + 84 >> 2] = he, an = me, Ar = q(D ^ mt, he ^ Je, 1), l[an + 40 >> 2] = Ar, l[me + 44 >> 2] = ve, D = q(U ^ bt, Gn ^ en, 1), $e = 1 + (U = Zn + (bt = ve) | 0) | 0, he = U, he = (U = D + Be | 0) >>> 0 < Be >>> 0 ? $e : he, U = U + (mt = De(D, 0, Be << 1 & -2, 1 & (Zn << 1 | Be >>> 31))) | 0, Be = ve + he | 0, he = q(b ^ Sn, $n ^ Rr, 48), Be = q(he ^ U, (mt = U >>> 0 < mt >>> 0 ? Be + 1 | 0 : Be) ^ (Zn = ve), 32), Sn = $e = ve, Ct = 1 + (b = qn + Gt | 0) | 0, Gt = b, $n = (b = ie + ht | 0) >>> 0 < ie >>> 0 ? Ct : Gt, ie = De(ht, 0, ie << 1 & -2, 1 & (qn << 1 | ie >>> 31)), ht = ve + $n | 0, Gt = 1 + (ie = (ht = (b = ie + b | 0) >>> 0 < ie >>> 0 ? ht + 1 | 0 : ht) + $e | 0) | 0, $e = ie, $e = (ie = b + Be | 0) >>> 0 < b >>> 0 ? Gt : $e, Gt = D, D = De(Be, 0, b << 1 & -2, 1 & (ht << 1 | b >>> 31)), $e = ve + $e | 0, D = q(Gt ^ (ie = D + ie | 0), bt ^ ($e = ie >>> 0 < D >>> 0 ? $e + 1 | 0 : $e), 40), Ct = 1 + (qn = mt + (bt = ve) | 0) | 0, Gt = qn, $n = (qn = U + D | 0) >>> 0 < U >>> 0 ? Ct : Gt, Gt = Be, Be = De(D, 0, U << 1 & -2, 1 & (mt << 1 | U >>> 31)), mt = ve + $n | 0, Be = q(Gt ^ (U = Be + qn | 0), Sn ^ (mt = U >>> 0 < Be >>> 0 ? mt + 1 | 0 : mt), 48), l[me + 96 >> 2] = Be, qn = ve, l[me + 100 >> 2] = qn, l[me + 8 >> 2] = U, l[me + 12 >> 2] = mt, mt = 1 + (U = $e + qn | 0) | 0, Gt = U, mt = (U = ie + Be | 0) >>> 0 < ie >>> 0 ? mt : Gt, ie = De(Be, 0, ie << 1 & -2, 1 & ($e << 1 | ie >>> 31)), Be = ve + mt | 0, an = me, Ar = q((U = ie + U | 0) ^ D, bt ^ (ie = U >>> 0 < ie >>> 0 ? Be + 1 | 0 : Be), 1), l[an + 48 >> 2] = Ar, l[me + 52 >> 2] = ve, l[me + 88 >> 2] = U, l[me + 92 >> 2] = ie, ie = q(b ^ fn, ht ^ Nn, 1), Be = 1 + (b = Ft + (fn = ve) | 0) | 0, U = b, Be = (b = ie + Ge | 0) >>> 0 < Ge >>> 0 ? Be : U, U = b, b = De(ie, 0, Ge << 1 & -2, 1 & (Ft << 1 | Ge >>> 31)), Be = ve + Be | 0, Be = q((U = U + b | 0) ^ Le, cr ^ (D = b >>> 0 > U >>> 0 ? Be + 1 | 0 : Be), 32), ht = Ge = ve, Le = 1 + (b = Kn + Zn | 0) | 0, $e = b, Le = (b = he + ye | 0) >>> 0 < ye >>> 0 ? Le : $e, ye = De(he, 0, ye << 1 & -2, 1 & (Kn << 1 | ye >>> 31)), he = ve + Le | 0, Le = 1 + (ye = (he = (b = b + ye | 0) >>> 0 < ye >>> 0 ? he + 1 | 0 : he) + Ge | 0) | 0, $e = ye, Ge = (ye = b + Be | 0) >>> 0 < b >>> 0 ? Le : $e, $e = ie, ie = ye, ye = De(Be, 0, b << 1 & -2, 1 & (he << 1 | b >>> 31)), Ge = ve + Ge | 0, ye = q($e ^ (ie = ie + ye | 0), fn ^ (Ge = ie >>> 0 < ye >>> 0 ? Ge + 1 | 0 : Ge), 40), bt = 1 + (Le = D + (fn = ve) | 0) | 0, $e = Le, mt = (Le = U + ye | 0) >>> 0 < U >>> 0 ? bt : $e, U = (D = De(ye, 0, U << 1 & -2, 1 & (D << 1 | U >>> 31))) + Le | 0, l[me + 16 >> 2] = U, Le = ve + mt | 0, D = U >>> 0 < D >>> 0 ? Le + 1 | 0 : Le, l[me + 20 >> 2] = D, U = q(U ^ Be, D ^ ht, 48), l[me + 104 >> 2] = U, Be = ve, l[me + 108 >> 2] = Be, Le = 1 + (Be = Be + Ge | 0) | 0, $e = Be, D = (Be = U + ie | 0) >>> 0 < ie >>> 0 ? Le : $e, ie = (U = De(U, 0, ie << 1 & -2, 1 & (Ge << 1 | ie >>> 31))) + Be | 0, Be = ve + D | 0, Ge = U = U >>> 0 > ie >>> 0 ? Be + 1 | 0 : Be, l[pn >> 2] = ie, l[pn + 4 >> 2] = U, Be = (U = q(b ^ je, he ^ or, 1)) + St | 0, D = (ht = ve) + Hn | 0, b = (he = De(St << 1 & -2, 1 & (Hn << 1 | St >>> 31), U, 0)) + Be | 0, Be = ve + (U >>> 0 > Be >>> 0 ? D + 1 | 0 : D) | 0, Be = q(b ^ it, Ve ^ (D = b >>> 0 < he >>> 0 ? Be + 1 | 0 : Be), 32), Le = 1 + (he = Zt + (St = ve) | 0) | 0, $e = he, Le = (he = Be + we | 0) >>> 0 < we >>> 0 ? Le : $e, $e = U, U = (we = De(Be, 0, we << 1 & -2, 1 & (Zt << 1 | we >>> 31))) + he | 0, he = ve + Le | 0, we = q($e ^ U, ht ^ (he = U >>> 0 < we >>> 0 ? he + 1 | 0 : he), 40), je = 1 + (Le = D + (ht = ve) | 0) | 0, $e = Le, mt = (Le = b + we | 0) >>> 0 < b >>> 0 ? je : $e, $e = Be, b = De(we, 0, b << 1 & -2, 1 & (D << 1 | b >>> 31)), D = ve + mt | 0, b = q($e ^ (Be = b + Le | 0), St ^ (D = b >>> 0 > Be >>> 0 ? D + 1 | 0 : D), 48), je = 1 + (Le = he + (St = ve) | 0) | 0, $e = Le, mt = (Le = b + U | 0) >>> 0 < U >>> 0 ? je : $e, U = (he = De(b, 0, U << 1 & -2, 1 & (he << 1 | U >>> 31))) + Le | 0, l[me + 72 >> 2] = U, Le = ve + mt | 0, he = U >>> 0 < he >>> 0 ? Le + 1 | 0 : Le, l[me + 76 >> 2] = he, l[me + 112 >> 2] = b, l[me + 116 >> 2] = St, l[me + 24 >> 2] = Be, l[me + 28 >> 2] = D, an = me, Ar = q(ie ^ ye, Ge ^ fn, 1), l[an + 56 >> 2] = Ar, l[me + 60 >> 2] = ve, an = me, Ar = q(U ^ we, he ^ ht, 1), l[an + 32 >> 2] = Ar, l[me + 36 >> 2] = ve, (0 | (_e = _e + 1 | 0)) != 8; )
                                ;
                              for (; ie = (U = l[392 + (me = (_ + 3072 | 0) + (ct << 4) | 0) >> 2]) + (b = l[me + 136 >> 2]) | 0, Be = (D = l[me + 396 >> 2]) + (_e = l[me + 140 >> 2]) | 0, we = De(b << 1 & -2, 1 & (_e << 1 | b >>> 31), U, 0), b = ve + (b >>> 0 > ie >>> 0 ? Be + 1 | 0 : Be) | 0, ie = (_e = we + ie | 0) >>> 0 < we >>> 0 ? b + 1 | 0 : b, we = (Be = q(_e ^ l[me + 904 >> 2], ie ^ l[me + 908 >> 2], 32)) + (b = l[me + 648 >> 2]) | 0, ye = (he = ve) + (Ge = l[me + 652 >> 2]) | 0, $e = U, Ge = De(Be, 0, b << 1 & -2, 1 & (Ge << 1 | b >>> 31)), b = ve + (b >>> 0 > we >>> 0 ? ye + 1 | 0 : ye) | 0, St = q($e ^ (U = Ge + we | 0), D ^ (it = U >>> 0 < Ge >>> 0 ? b + 1 | 0 : b), 40), $e = 1 + (b = ie + (Gn = ve) | 0) | 0, ye = b, we = (b = _e + St | 0) >>> 0 < _e >>> 0 ? $e : ye, Ge = (_e = De(St, 0, _e << 1 & -2, 1 & (ie << 1 | _e >>> 31))) + b | 0, b = ve + we | 0, fn = q(Ge ^ Be, he ^ (qn = _e >>> 0 > Ge >>> 0 ? b + 1 | 0 : b), 48), Ct = je = ve, ie = (ht = l[me + 268 >> 2]) + (_e = l[me + 12 >> 2]) | 0, we = (Be = l[me + 264 >> 2]) + (b = l[me + 8 >> 2]) | 0, ye = De(b << 1 & -2, 1 & (_e << 1 | b >>> 31), Be, 0), b = ve + (b >>> 0 > we >>> 0 ? ie + 1 | 0 : ie) | 0, we = (_e = we + ye | 0) >>> 0 < ye >>> 0 ? b + 1 | 0 : b, D = (ye = q(_e ^ l[me + 776 >> 2], we ^ l[me + 780 >> 2], 32)) + (ie = l[me + 520 >> 2]) | 0, he = (Le = ve) + (b = l[me + 524 >> 2]) | 0, $e = Be, Be = De(ye, 0, ie << 1 & -2, 1 & (b << 1 | ie >>> 31)), ie = ve + (ie >>> 0 > D >>> 0 ? he + 1 | 0 : he) | 0, Be = q($e ^ (b = Be + D | 0), ht ^ (D = b >>> 0 < Be >>> 0 ? ie + 1 | 0 : ie), 40), bt = 1 + (ie = we + (he = ve) | 0) | 0, $e = ie, ht = (ie = _e + Be | 0) >>> 0 < _e >>> 0 ? bt : $e, _e = De(Be, 0, _e << 1 & -2, 1 & (we << 1 | _e >>> 31)), we = ve + ht | 0, ht = q((ie = _e + ie | 0) ^ ye, Le ^ (Hn = ie >>> 0 < _e >>> 0 ? we + 1 | 0 : we), 48), $e = 1 + (_e = D + (Nn = ve) | 0) | 0, ye = _e, we = (_e = b + ht | 0) >>> 0 < b >>> 0 ? $e : ye, ye = Be, Be = _e, _e = De(ht, 0, b << 1 & -2, 1 & (D << 1 | b >>> 31)), b = ve + we | 0, Le = q(ye ^ (Be = Be + _e | 0), he ^ (Zn = _e >>> 0 > Be >>> 0 ? b + 1 | 0 : b), 1), Gt = $e = ve, we = (bt = l[me + 260 >> 2]) + (_e = l[me + 4 >> 2]) | 0, D = (ye = l[me + 256 >> 2]) + (b = l[me >> 2]) | 0, he = De(b << 1 & -2, 1 & (_e << 1 | b >>> 31), ye, 0), b = ve + (b >>> 0 > D >>> 0 ? we + 1 | 0 : we) | 0, D = (_e = D + he | 0) >>> 0 < he >>> 0 ? b + 1 | 0 : b, he = (Zt = q(_e ^ l[me + 768 >> 2], D ^ l[me + 772 >> 2], 32)) + (b = l[me + 512 >> 2]) | 0, mt = (cr = ve) + (we = l[me + 516 >> 2]) | 0, en = ye, ye = De(Zt, 0, b << 1 & -2, 1 & (we << 1 | b >>> 31)), b = ve + (b >>> 0 > he >>> 0 ? mt + 1 | 0 : mt) | 0, mt = q(en ^ (we = ye + he | 0), bt ^ (Sn = ye >>> 0 > we >>> 0 ? b + 1 | 0 : b), 40), ye = 1 + (b = D + (Je = ve) | 0) | 0, he = b, ye = (b = _e + mt | 0) >>> 0 < _e >>> 0 ? ye : he, he = b, b = De(mt, 0, _e << 1 & -2, 1 & (D << 1 | _e >>> 31)), ye = ve + ye | 0, ye = 1 + (b = $e + (pn = b >>> 0 > (_e = he + b | 0) >>> 0 ? ye + 1 | 0 : ye) | 0) | 0, he = b, D = (b = _e + Le | 0) >>> 0 < _e >>> 0 ? ye : he, he = b, b = De(Le, 0, _e << 1 & -2, 1 & (pn << 1 | _e >>> 31)), D = ve + D | 0, je = q((ye = he + b | 0) ^ fn, je ^ (Kn = b >>> 0 > ye >>> 0 ? D + 1 | 0 : D), 32), Rr = ve, he = (or = l[me + 388 >> 2]) + (b = l[me + 132 >> 2]) | 0, bt = ($e = l[me + 384 >> 2]) + (D = l[me + 128 >> 2]) | 0, $n = De(D << 1 & -2, 1 & (b << 1 | D >>> 31), $e, 0), D = ve + (D >>> 0 > bt >>> 0 ? he + 1 | 0 : he) | 0, bt = (b = bt + $n | 0) >>> 0 < $n >>> 0 ? D + 1 | 0 : D, _n = ($n = q(b ^ l[me + 896 >> 2], bt ^ l[me + 900 >> 2], 32)) + (he = l[me + 640 >> 2]) | 0, Ft = (ur = ve) + (D = l[me + 644 >> 2]) | 0, en = $e, $e = De($n, 0, he << 1 & -2, 1 & (D << 1 | he >>> 31)), he = ve + (he >>> 0 > _n >>> 0 ? Ft + 1 | 0 : Ft) | 0, $e = q(en ^ (D = $e + _n | 0), or ^ (_n = D >>> 0 < $e >>> 0 ? he + 1 | 0 : he), 40), Tt = 1 + (he = bt + (or = ve) | 0) | 0, en = he, Ft = (he = b + $e | 0) >>> 0 < b >>> 0 ? Tt : en, b = De($e, 0, b << 1 & -2, 1 & (bt << 1 | b >>> 31)), bt = ve + Ft | 0, bt = q(en = (he = b + he | 0) ^ $n, ur ^ ($n = b >>> 0 > he >>> 0 ? bt + 1 | 0 : bt), 48), Tt = 1 + (b = _n + (ur = ve) | 0) | 0, en = b, Ft = (b = D + bt | 0) >>> 0 < D >>> 0 ? Tt : en, D = De(bt, 0, D << 1 & -2, 1 & (_n << 1 | D >>> 31)), _n = ve + Ft | 0, Tt = 1 + (D = (_n = (b = D + b | 0) >>> 0 < D >>> 0 ? _n + 1 | 0 : _n) + Rr | 0) | 0, en = D, Ft = (D = b + je | 0) >>> 0 < b >>> 0 ? Tt : en, en = Le, Le = De(je, 0, b << 1 & -2, 1 & (_n << 1 | b >>> 31)), Ft = ve + Ft | 0, Le = q(en ^ (D = Le + D | 0), Gt ^ (Ft = D >>> 0 < Le >>> 0 ? Ft + 1 | 0 : Ft), 40), ut = 1 + (en = Kn + (Gt = ve) | 0) | 0, Tt = en, Ve = (en = ye + Le | 0) >>> 0 < ye >>> 0 ? ut : Tt, ye = (Kn = De(Le, 0, ye << 1 & -2, 1 & (Kn << 1 | ye >>> 31))) + en | 0, l[me >> 2] = ye, en = ve + Ve | 0, Kn = ye >>> 0 < Kn >>> 0 ? en + 1 | 0 : en, l[me + 4 >> 2] = Kn, ye = q(ye ^ je, Kn ^ Rr, 48), l[me + 904 >> 2] = ye, je = ve, l[me + 908 >> 2] = je, Tt = 1 + (je = je + Ft | 0) | 0, en = je, Kn = (je = D + ye | 0) >>> 0 < D >>> 0 ? Tt : en, ye = (D = De(ye, 0, D << 1 & -2, 1 & (Ft << 1 | D >>> 31))) + je | 0, l[me + 640 >> 2] = ye, je = ve + Kn | 0, D = D >>> 0 > ye >>> 0 ? je + 1 | 0 : je, l[me + 644 >> 2] = D, an = me, Ar = q(ye ^ Le, D ^ Gt, 1), l[an + 264 >> 2] = Ar, l[me + 268 >> 2] = ve, ye = q(b ^ $e, _n ^ or, 1), D = 1 + (b = Hn + ($e = ve) | 0) | 0, Le = b, D = (b = ie + ye | 0) >>> 0 < ie >>> 0 ? D : Le, b = b + (Le = De(ye, 0, ie << 1 & -2, 1 & (Hn << 1 | ie >>> 31))) | 0, ie = ve + D | 0, D = q(_e ^ Zt, pn ^ cr, 48), ie = q(D ^ b, (Le = b >>> 0 < Le >>> 0 ? ie + 1 | 0 : ie) ^ (Hn = ve), 32), Zt = je = ve, Ct = 1 + (_e = it + Ct | 0) | 0, Gt = _e, pn = (_e = U + fn | 0) >>> 0 < U >>> 0 ? Ct : Gt, U = De(fn, 0, U << 1 & -2, 1 & (it << 1 | U >>> 31)), fn = ve + pn | 0, Gt = 1 + (U = (fn = U >>> 0 > (_e = U + _e | 0) >>> 0 ? fn + 1 | 0 : fn) + je | 0) | 0, je = U, je = (U = ie + _e | 0) >>> 0 < _e >>> 0 ? Gt : je, Gt = ye, ye = De(ie, 0, _e << 1 & -2, 1 & (fn << 1 | _e >>> 31)), je = ve + je | 0, ye = q(Gt ^ (U = ye + U | 0), $e ^ (je = U >>> 0 < ye >>> 0 ? je + 1 | 0 : je), 40), Ct = 1 + (it = Le + ($e = ve) | 0) | 0, Gt = it, pn = (it = b + ye | 0) >>> 0 < b >>> 0 ? Ct : Gt, Gt = ie, ie = De(ye, 0, b << 1 & -2, 1 & (Le << 1 | b >>> 31)), Le = ve + pn | 0, ie = q(Gt ^ (b = ie + it | 0), Zt ^ (Le = b >>> 0 < ie >>> 0 ? Le + 1 | 0 : Le), 48), l[me + 768 >> 2] = ie, it = ve, l[me + 772 >> 2] = it, l[me + 8 >> 2] = b, l[me + 12 >> 2] = Le, Gt = 1 + (b = je + it | 0) | 0, Le = b, Le = (b = U + ie | 0) >>> 0 < U >>> 0 ? Gt : Le, b = (U = De(ie, 0, U << 1 & -2, 1 & (je << 1 | U >>> 31))) + b | 0, l[me + 648 >> 2] = b, ie = ve + Le | 0, U = b >>> 0 < U >>> 0 ? ie + 1 | 0 : ie, l[me + 652 >> 2] = U, an = me, Ar = q(b ^ ye, U ^ $e, 1), l[an + 384 >> 2] = Ar, l[me + 388 >> 2] = ve, U = q(_e ^ St, fn ^ Gn, 1), ie = 1 + (_e = $n + (St = ve) | 0) | 0, b = _e, ie = (_e = U + he | 0) >>> 0 < he >>> 0 ? ie : b, b = _e, _e = De(U, 0, he << 1 & -2, 1 & ($n << 1 | he >>> 31)), ie = ve + ie | 0, ie = q((b = b + _e | 0) ^ ht, Nn ^ (ye = b >>> 0 < _e >>> 0 ? ie + 1 | 0 : ie), 32), fn = he = ve, Le = 1 + (_e = Hn + Sn | 0) | 0, $e = _e, ht = (_e = D + we | 0) >>> 0 < we >>> 0 ? Le : $e, we = De(D, 0, we << 1 & -2, 1 & (Sn << 1 | we >>> 31)), D = ve + ht | 0, $e = 1 + (we = (D = (_e = _e + we | 0) >>> 0 < we >>> 0 ? D + 1 | 0 : D) + he | 0) | 0, he = we, he = (we = ie + _e | 0) >>> 0 < _e >>> 0 ? $e : he, $e = U, U = we, we = De(ie, 0, _e << 1 & -2, 1 & (D << 1 | _e >>> 31)), he = ve + he | 0, we = q($e ^ (U = U + we | 0), St ^ (he = U >>> 0 < we >>> 0 ? he + 1 | 0 : he), 40), Le = 1 + (ht = ye + (St = ve) | 0) | 0, $e = ht, Le = (ht = b + we | 0) >>> 0 < b >>> 0 ? Le : $e, $e = ie, ie = De(we, 0, b << 1 & -2, 1 & (ye << 1 | b >>> 31)), ye = ve + Le | 0, ie = q($e ^ (b = ie + ht | 0), fn ^ (ye = b >>> 0 < ie >>> 0 ? ye + 1 | 0 : ye), 48), l[me + 776 >> 2] = ie, fn = ve, l[me + 780 >> 2] = fn, l[me + 128 >> 2] = b, l[me + 132 >> 2] = ye, $e = 1 + (b = he + fn | 0) | 0, ye = b, ye = (b = U + ie | 0) >>> 0 < U >>> 0 ? $e : ye, b = (U = De(ie, 0, U << 1 & -2, 1 & (he << 1 | U >>> 31))) + b | 0, l[me + 512 >> 2] = b, ie = ve + ye | 0, U = b >>> 0 < U >>> 0 ? ie + 1 | 0 : ie, l[me + 516 >> 2] = U, an = me, Ar = q(b ^ we, U ^ St, 1), l[an + 392 >> 2] = Ar, l[me + 396 >> 2] = ve, U = (b = q(_e ^ mt, D ^ Je, 1)) + Ge | 0, ie = (ye = ve) + qn | 0, _e = (we = De(Ge << 1 & -2, 1 & (qn << 1 | Ge >>> 31), b, 0)) + U | 0, U = ve + (b >>> 0 > U >>> 0 ? ie + 1 | 0 : ie) | 0, U = q(_e ^ bt, ur ^ (we = _e >>> 0 < we >>> 0 ? U + 1 | 0 : U), 32), $e = 1 + (ie = Zn + (D = ve) | 0) | 0, he = ie, he = (ie = U + Be | 0) >>> 0 < Be >>> 0 ? $e : he, $e = b, b = ie, ie = De(U, 0, Be << 1 & -2, 1 & (Zn << 1 | Be >>> 31)), Be = ve + he | 0, ie = q($e ^ (b = b + ie | 0), ye ^ (Be = b >>> 0 < ie >>> 0 ? Be + 1 | 0 : Be), 40), Le = 1 + (he = we + (ye = ve) | 0) | 0, $e = he, Ge = (he = ie + _e | 0) >>> 0 < _e >>> 0 ? Le : $e, $e = U, U = De(ie, 0, _e << 1 & -2, 1 & (we << 1 | _e >>> 31)), we = ve + Ge | 0, U = q($e ^ (_e = U + he | 0), D ^ (we = U >>> 0 > _e >>> 0 ? we + 1 | 0 : we), 48), l[me + 896 >> 2] = U, D = ve, l[me + 900 >> 2] = D, l[me + 136 >> 2] = _e, l[me + 140 >> 2] = we, $e = 1 + (_e = D + Be | 0) | 0, he = _e, we = (_e = b + U | 0) >>> 0 < b >>> 0 ? $e : he, _e = (b = De(U, 0, b << 1 & -2, 1 & (Be << 1 | b >>> 31))) + _e | 0, l[me + 520 >> 2] = _e, U = ve + we | 0, b = b >>> 0 > _e >>> 0 ? U + 1 | 0 : U, l[me + 524 >> 2] = b, an = me, Ar = q(ie ^ _e, b ^ ye, 1), l[an + 256 >> 2] = Ar, l[me + 260 >> 2] = ve, (0 | (ct = ct + 1 | 0)) != 8; )
                                ;
                              for (me = xr(Fn, _ + 2048 | 0, 1024), _e = 0; ie = l[(b = (ct = _e << 3) + me | 0) >> 2], we = l[(Be = (U = _ + 3072 | 0) + ct | 0) >> 2], Be = l[b + 4 >> 2] ^ l[Be + 4 >> 2], l[b >> 2] = ie ^ we, l[b + 4 >> 2] = Be, Be = l[(b = (ie = 8 | ct) + me | 0) >> 2], we = l[(ie = U + ie | 0) >> 2], ie = l[b + 4 >> 2] ^ l[ie + 4 >> 2], l[b >> 2] = Be ^ we, l[b + 4 >> 2] = ie, Be = l[(b = (ie = 16 | ct) + me | 0) >> 2], we = l[(ie = U + ie | 0) >> 2], ie = l[b + 4 >> 2] ^ l[ie + 4 >> 2], l[b >> 2] = Be ^ we, l[b + 4 >> 2] = ie, ie = l[(ct = (b = 24 | ct) + me | 0) >> 2], U = l[(b = b + U | 0) >> 2], b = l[ct + 4 >> 2] ^ l[b + 4 >> 2], l[ct >> 2] = U ^ ie, l[ct + 4 >> 2] = b, (0 | (_e = _e + 4 | 0)) != 128; )
                                ;
                            }
                            if (_e = qr + 1 | 0, Kt = Kt + 1 | 0, !((ct = l[A + 20 >> 2]) >>> 0 > (wn = wn + 1 | 0) >>> 0))
                              break;
                          }
                      }
                      st = _ + 4096 | 0;
                    }
                    function Ks(A, g, _) {
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0;
                      for (st = he = st - 2048 | 0, xr(he + 1024 | 0, g, 1024), g = 0; ie = l[(Be = (D = he + 1024 | 0) + (U = g << 3) | 0) >> 2], _e = l[(ye = A + U | 0) >> 2], ye = l[Be + 4 >> 2] ^ l[ye + 4 >> 2], l[Be >> 2] = ie ^ _e, l[Be + 4 >> 2] = ye, ye = l[(Be = (ie = 8 | U) + D | 0) >> 2], _e = l[(ie = A + ie | 0) >> 2], ie = l[Be + 4 >> 2] ^ l[ie + 4 >> 2], l[Be >> 2] = _e ^ ye, l[Be + 4 >> 2] = ie, ye = l[(Be = (ie = 16 | U) + D | 0) >> 2], _e = l[(ie = A + ie | 0) >> 2], ie = l[Be + 4 >> 2] ^ l[ie + 4 >> 2], l[Be >> 2] = _e ^ ye, l[Be + 4 >> 2] = ie, Be = l[(U = (ie = D) + (D = 24 | U) | 0) >> 2], ie = l[(D = A + D | 0) >> 2], D = l[U + 4 >> 2] ^ l[D + 4 >> 2], l[U >> 2] = ie ^ Be, l[U + 4 >> 2] = D, (0 | (g = g + 4 | 0)) != 128; )
                        ;
                      for (b = xr(he, he + 1024 | 0, 1024), A = 0, g = 0; D = l[(U = (he = g << 3) + b | 0) >> 2], ie = l[(Be = _ + he | 0) >> 2], Be = l[U + 4 >> 2] ^ l[Be + 4 >> 2], l[U >> 2] = ie ^ D, l[U + 4 >> 2] = Be, Be = l[(U = (D = 8 | he) + b | 0) >> 2], ie = l[(D = _ + D | 0) >> 2], D = l[U + 4 >> 2] ^ l[D + 4 >> 2], l[U >> 2] = ie ^ Be, l[U + 4 >> 2] = D, Be = l[(U = (D = 16 | he) + b | 0) >> 2], ie = l[(D = _ + D | 0) >> 2], D = l[U + 4 >> 2] ^ l[D + 4 >> 2], l[U >> 2] = ie ^ Be, l[U + 4 >> 2] = D, D = l[(he = (U = 24 | he) + b | 0) >> 2], Be = l[(U = _ + U | 0) >> 2], U = l[he + 4 >> 2] ^ l[U + 4 >> 2], l[he >> 2] = D ^ Be, l[he + 4 >> 2] = U, (0 | (g = g + 4 | 0)) != 128; )
                        ;
                      for (; ye = (ie = l[56 + (he = (b + 1024 | 0) + (A << 7) | 0) >> 2]) + (U = l[he + 24 >> 2]) | 0, g = (bt = l[he + 60 >> 2]) + (D = l[he + 28 >> 2]) | 0, Be = U >>> 0 > ye >>> 0 ? g + 1 | 0 : g, D = De(U << 1 & -2, 1 & (D << 1 | U >>> 31), ie, 0), g = ve + Be | 0, Be = (U = D + ye | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, je = (ye = q(l[he + 120 >> 2] ^ U, Be ^ l[he + 124 >> 2], 32)) + (D = l[he + 88 >> 2]) | 0, g = (we = ve) + (_e = l[he + 92 >> 2]) | 0, me = D >>> 0 > je >>> 0 ? g + 1 | 0 : g, _e = De(D << 1 & -2, 1 & (_e << 1 | D >>> 31), ye, 0), g = ve + me | 0, Zn = q(ie ^ (D = _e + je | 0), bt ^ (je = D >>> 0 < _e >>> 0 ? g + 1 | 0 : g), 40), g = Be + (Sn = ve) | 0, ie = (_e = U + Zn | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(Zn, 0, U << 1 & -2, 1 & (Be << 1 | U >>> 31)), g = ve + ie | 0, wn = q(ye ^ (bt = U + _e | 0), we ^ (fn = U >>> 0 > bt >>> 0 ? g + 1 | 0 : g), 48), or = g = ve, $e = wn, _e = (ye = l[he + 40 >> 2]) + (U = l[he + 8 >> 2]) | 0, g = (Ge = l[he + 44 >> 2]) + (Be = l[he + 12 >> 2]) | 0, ie = U >>> 0 > _e >>> 0 ? g + 1 | 0 : g, Be = De(U << 1 & -2, 1 & (Be << 1 | U >>> 31), ye, 0), g = ve + ie | 0, ie = (U = Be + _e | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, Tt = (_e = q(l[he + 104 >> 2] ^ U, ie ^ l[he + 108 >> 2], 32)) + (Be = l[he + 72 >> 2]) | 0, g = (Le = ve) + (me = l[he + 76 >> 2]) | 0, we = Be >>> 0 > Tt >>> 0 ? g + 1 | 0 : g, me = De(Be << 1 & -2, 1 & (me << 1 | Be >>> 31), _e, 0), g = ve + we | 0, me = q(mt = (Be = me + Tt | 0) ^ ye, Ge ^ (ye = me >>> 0 > Be >>> 0 ? g + 1 | 0 : g), 40), g = ie + (Ge = ve) | 0, we = (Tt = U + me | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, ie = De(me, 0, U << 1 & -2, 1 & (ie << 1 | U >>> 31)), g = ve + we | 0, er = q((U = ie + Tt | 0) ^ _e, Le ^ (we = U >>> 0 < ie >>> 0 ? g + 1 | 0 : g), 48), g = ye + (Kt = ve) | 0, ie = (_e = Be + er | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, ye = De(er, 0, Be << 1 & -2, 1 & (ye << 1 | Be >>> 31)), g = ve + ie | 0, Gt = q(me ^ (Be = ye + _e | 0), Ge ^ (Tt = Be >>> 0 < ye >>> 0 ? g + 1 | 0 : g), 1), pn = g = ve, ct = Gt, Ge = (me = l[he + 32 >> 2]) + (ie = l[he >> 2]) | 0, g = ($n = l[he + 36 >> 2]) + (ye = l[he + 4 >> 2]) | 0, _e = ie >>> 0 > Ge >>> 0 ? g + 1 | 0 : g, ye = De(ie << 1 & -2, 1 & (ye << 1 | ie >>> 31), me, 0), g = ve + _e | 0, _e = (ie = ye + Ge | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, ht = (qn = q(l[he + 96 >> 2] ^ ie, _e ^ l[he + 100 >> 2], 32)) + (ye = l[(g = St = he - -64 | 0) >> 2]) | 0, g = (ur = ve) + (Ge = l[g + 4 >> 2]) | 0, Le = ye >>> 0 > ht >>> 0 ? g + 1 | 0 : g, Ge = De(ye << 1 & -2, 1 & (Ge << 1 | ye >>> 31), qn, 0), g = ve + Le | 0, $n = q(me ^ (ye = Ge + ht | 0), $n ^ (Ge = ye >>> 0 < Ge >>> 0 ? g + 1 | 0 : g), 40), g = _e + (Cr = ve) | 0, me = (Le = ie + $n | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = De($n, 0, ie << 1 & -2, 1 & (_e << 1 | ie >>> 31)), g = ve + me | 0, g = pn + (Ct = ie >>> 0 > (Le = ie + Le | 0) >>> 0 ? g + 1 | 0 : g) | 0, _e = (ie = Le + ct | 0) >>> 0 < Le >>> 0 ? g + 1 | 0 : g, me = De(ct, 0, Le << 1 & -2, 1 & (Ct << 1 | Le >>> 31)), g = ve + _e | 0, Gn = q((ie = me + ie | 0) ^ $e, or ^ (mt = ie >>> 0 < me >>> 0 ? g + 1 | 0 : g), 32), Zt = g = ve, en = g, ct = ($e = l[he + 48 >> 2]) + (_e = l[he + 16 >> 2]) | 0, g = (Kn = l[he + 52 >> 2]) + (me = l[he + 20 >> 2]) | 0, ht = _e >>> 0 > ct >>> 0 ? g + 1 | 0 : g, me = De(_e << 1 & -2, 1 & (me << 1 | _e >>> 31), $e, 0), g = ve + ht | 0, ht = me >>> 0 > (_e = me + ct | 0) >>> 0 ? g + 1 | 0 : g, Ft = (ct = q(l[he + 112 >> 2] ^ _e, ht ^ l[he + 116 >> 2], 32)) + (me = l[he + 80 >> 2]) | 0, g = (Hn = ve) + (it = l[he + 84 >> 2]) | 0, _n = me >>> 0 > Ft >>> 0 ? g + 1 | 0 : g, it = De(me << 1 & -2, 1 & (it << 1 | me >>> 31), ct, 0), g = ve + _n | 0, it = q(Ft = (me = it + Ft | 0) ^ $e, Kn ^ ($e = me >>> 0 < it >>> 0 ? g + 1 | 0 : g), 40), g = ht + (Kn = ve) | 0, _n = (Ft = _e + it | 0) >>> 0 < _e >>> 0 ? g + 1 | 0 : g, ht = De(it, 0, _e << 1 & -2, 1 & (ht << 1 | _e >>> 31)), g = ve + _n | 0, _n = q((_e = ht + Ft | 0) ^ ct, Hn ^ (ht = _e >>> 0 < ht >>> 0 ? g + 1 | 0 : g), 48), g = $e + (Hn = ve) | 0, ct = (Ft = me + _n | 0) >>> 0 < me >>> 0 ? g + 1 | 0 : g, me = De(_n, 0, me << 1 & -2, 1 & ($e << 1 | me >>> 31)), g = ve + ct | 0, g = (ct = me >>> 0 > ($e = me + Ft | 0) >>> 0 ? g + 1 | 0 : g) + en | 0, en = (me = $e + Gn | 0) >>> 0 < $e >>> 0 ? g + 1 | 0 : g, Ft = De(Gn, 0, $e << 1 & -2, 1 & (ct << 1 | $e >>> 31)), g = ve + en | 0, en = q(en = (me = Ft + me | 0) ^ Gt, pn ^ (Gt = me >>> 0 < Ft >>> 0 ? g + 1 | 0 : g), 40), g = mt + (pn = ve) | 0, Ft = (Je = ie + en | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = (mt = De(en, 0, ie << 1 & -2, 1 & (mt << 1 | ie >>> 31))) + Je | 0, g = ve + Ft | 0, l[he >> 2] = ie, g = ie >>> 0 < mt >>> 0 ? g + 1 | 0 : g, l[he + 4 >> 2] = g, ie = q(ie ^ Gn, g ^ Zt, 48), l[he + 120 >> 2] = ie, g = ve, l[he + 124 >> 2] = g, g = g + Gt | 0, mt = (Gn = ie + me | 0) >>> 0 < me >>> 0 ? g + 1 | 0 : g, ie = (me = De(ie, 0, me << 1 & -2, 1 & (Gt << 1 | me >>> 31))) + Gn | 0, g = ve + mt | 0, l[he + 80 >> 2] = ie, g = ie >>> 0 < me >>> 0 ? g + 1 | 0 : g, l[he + 84 >> 2] = g, Ve = he, ut = q(ie ^ en, g ^ pn, 1), l[Ve + 40 >> 2] = ut, l[he + 44 >> 2] = ve, g = je + or | 0, ie = (me = D + wn | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, D = De(wn, 0, D << 1 & -2, 1 & (je << 1 | D >>> 31)), g = ve + ie | 0, ie = g = D >>> 0 > (me = D + me | 0) >>> 0 ? g + 1 | 0 : g, mt = q($e ^ it, ct ^ Kn, 1), g = we + (ct = ve) | 0, je = ($e = U + mt | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (we = De(mt, 0, U << 1 & -2, 1 & (we << 1 | U >>> 31))) + $e | 0, g = ve + je | 0, $e = q(Le ^ qn, Ct ^ ur, 48), Ct = q($e ^ U, (je = U >>> 0 < we >>> 0 ? g + 1 | 0 : g) ^ (Gt = ve), 32), g = (wn = ve) + ie | 0, we = (Le = Ct + me | 0) >>> 0 < Ct >>> 0 ? g + 1 | 0 : g, D = (g = Le) + (Le = De(me << 1 & -2, 1 & (ie << 1 | me >>> 31), Ct, 0)) | 0, g = ve + we | 0, Le = q(D ^ mt, ct ^ (we = D >>> 0 < Le >>> 0 ? g + 1 | 0 : g), 40), g = je + (mt = ve) | 0, ct = (qn = U + Le | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(Le, 0, U << 1 & -2, 1 & (je << 1 | U >>> 31)), g = ve + ct | 0, U = q((je = U + qn | 0) ^ Ct, wn ^ (g = U >>> 0 > je >>> 0 ? g + 1 | 0 : g), 48), l[he + 96 >> 2] = U, Ct = ve, l[he + 100 >> 2] = Ct, l[he + 8 >> 2] = je, l[he + 12 >> 2] = g, g = we + Ct | 0, je = (Ct = U + D | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, D = De(U, 0, D << 1 & -2, 1 & (we << 1 | D >>> 31)), g = ve + je | 0, Ve = he, ut = q((U = D + Ct | 0) ^ Le, (g = U >>> 0 < D >>> 0 ? g + 1 | 0 : g) ^ mt, 1), l[Ve + 48 >> 2] = ut, l[he + 52 >> 2] = ve, l[he + 88 >> 2] = U, l[he + 92 >> 2] = g, me = q(me ^ Zn, ie ^ Sn, 1), g = ht + (Le = ve) | 0, D = (U = me + _e | 0) >>> 0 < _e >>> 0 ? g + 1 | 0 : g, ie = De(me, 0, _e << 1 & -2, 1 & (ht << 1 | _e >>> 31)), g = ve + D | 0, je = q((U = ie + U | 0) ^ er, Kt ^ (ie = U >>> 0 < ie >>> 0 ? g + 1 | 0 : g), 32), Ct = g = ve, D = g, g = Ge + Gt | 0, _e = (we = ye + $e | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, ye = (g = we) + (we = De($e, 0, ye << 1 & -2, 1 & (Ge << 1 | ye >>> 31))) | 0, g = ve + _e | 0, g = (_e = ye >>> 0 < we >>> 0 ? g + 1 | 0 : g) + D | 0, we = (D = ye + je | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, Ge = De(je, 0, ye << 1 & -2, 1 & (_e << 1 | ye >>> 31)), g = ve + we | 0, we = q($e = (D = Ge + D | 0) ^ me, Le ^ (me = D >>> 0 < Ge >>> 0 ? g + 1 | 0 : g), 40), g = ie + (Le = ve) | 0, Ge = (mt = U + we | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (ie = De(we, 0, U << 1 & -2, 1 & (ie << 1 | U >>> 31))) + mt | 0, g = ve + Ge | 0, l[he + 16 >> 2] = U, g = U >>> 0 < ie >>> 0 ? g + 1 | 0 : g, l[he + 20 >> 2] = g, U = q(U ^ je, g ^ Ct, 48), l[he + 104 >> 2] = U, g = ve, l[he + 108 >> 2] = g, ie = St, g = g + me | 0, je = (Ge = U + D | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, D = De(U, 0, D << 1 & -2, 1 & (me << 1 | D >>> 31)), g = ve + je | 0, me = U = D + Ge | 0, je = g = U >>> 0 < D >>> 0 ? g + 1 | 0 : g, l[ie >> 2] = U, l[ie + 4 >> 2] = g, ye = q(ye ^ $n, _e ^ Cr, 1), g = (Ge = ve) + fn | 0, D = (U = ye + bt | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, ie = De(bt << 1 & -2, 1 & (fn << 1 | bt >>> 31), ye, 0), g = ve + D | 0, _e = q((U = ie + U | 0) ^ _n, Hn ^ (ie = U >>> 0 < ie >>> 0 ? g + 1 | 0 : g), 32), g = Tt + (fn = ve) | 0, bt = (D = _e + Be | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, Be = De(_e, 0, Be << 1 & -2, 1 & (Tt << 1 | Be >>> 31)), g = ve + bt | 0, ye = q((D = Be + D | 0) ^ ye, Ge ^ (Be = D >>> 0 < Be >>> 0 ? g + 1 | 0 : g), 40), g = ie + (Tt = ve) | 0, bt = (Ge = U + ye | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, ie = De(ye, 0, U << 1 & -2, 1 & (ie << 1 | U >>> 31)), g = ve + bt | 0, g = (U = ie + Ge | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = U, $e = U ^ _e, _e = g, U = q($e, fn ^ g, 48), g = Be + (fn = ve) | 0, bt = (Ge = U + D | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, D = (Be = De(U, 0, D << 1 & -2, 1 & (Be << 1 | D >>> 31))) + Ge | 0, g = ve + bt | 0, l[he + 72 >> 2] = D, g = D >>> 0 < Be >>> 0 ? g + 1 | 0 : g, l[he + 76 >> 2] = g, l[he + 112 >> 2] = U, l[he + 116 >> 2] = fn, l[he + 24 >> 2] = ie, l[he + 28 >> 2] = _e, Ve = he, ut = q(me ^ we, je ^ Le, 1), l[Ve + 56 >> 2] = ut, l[he + 60 >> 2] = ve, Ve = he, ut = q(D ^ ye, g ^ Tt, 1), l[Ve + 32 >> 2] = ut, l[he + 36 >> 2] = ve, (0 | (A = A + 1 | 0)) != 8; )
                        ;
                      for (A = 0; ye = (ie = l[392 + (he = (b + 1024 | 0) + (A << 4) | 0) >> 2]) + (U = l[he + 136 >> 2]) | 0, g = (bt = l[he + 396 >> 2]) + (D = l[he + 140 >> 2]) | 0, Be = U >>> 0 > ye >>> 0 ? g + 1 | 0 : g, D = De(U << 1 & -2, 1 & (D << 1 | U >>> 31), ie, 0), g = ve + Be | 0, Be = (U = D + ye | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, je = (ye = q(l[he + 904 >> 2] ^ U, Be ^ l[he + 908 >> 2], 32)) + (D = l[he + 648 >> 2]) | 0, g = (we = ve) + (_e = l[he + 652 >> 2]) | 0, me = D >>> 0 > je >>> 0 ? g + 1 | 0 : g, _e = De(D << 1 & -2, 1 & (_e << 1 | D >>> 31), ye, 0), g = ve + me | 0, Zn = q(ie ^ (D = _e + je | 0), bt ^ (je = D >>> 0 < _e >>> 0 ? g + 1 | 0 : g), 40), g = Be + (Ft = ve) | 0, ie = (_e = U + Zn | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(Zn, 0, U << 1 & -2, 1 & (Be << 1 | U >>> 31)), g = ve + ie | 0, wn = q(ye ^ (bt = U + _e | 0), we ^ (fn = U >>> 0 > bt >>> 0 ? g + 1 | 0 : g), 48), Sn = g = ve, $e = wn, _e = (ye = l[he + 264 >> 2]) + (U = l[he + 8 >> 2]) | 0, g = (Ge = l[he + 268 >> 2]) + (Be = l[he + 12 >> 2]) | 0, ie = U >>> 0 > _e >>> 0 ? g + 1 | 0 : g, Be = De(U << 1 & -2, 1 & (Be << 1 | U >>> 31), ye, 0), g = ve + ie | 0, ie = (U = Be + _e | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, Tt = (_e = q(l[he + 776 >> 2] ^ U, ie ^ l[he + 780 >> 2], 32)) + (Be = l[he + 520 >> 2]) | 0, g = (Le = ve) + (me = l[he + 524 >> 2]) | 0, we = Be >>> 0 > Tt >>> 0 ? g + 1 | 0 : g, me = De(Be << 1 & -2, 1 & (me << 1 | Be >>> 31), _e, 0), g = ve + we | 0, me = q(mt = (Be = me + Tt | 0) ^ ye, Ge ^ (ye = me >>> 0 > Be >>> 0 ? g + 1 | 0 : g), 40), g = ie + (Ge = ve) | 0, we = (Tt = U + me | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, ie = De(me, 0, U << 1 & -2, 1 & (ie << 1 | U >>> 31)), g = ve + we | 0, er = q((U = ie + Tt | 0) ^ _e, Le ^ (we = U >>> 0 < ie >>> 0 ? g + 1 | 0 : g), 48), g = ye + (or = ve) | 0, ie = (_e = Be + er | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, ye = De(er, 0, Be << 1 & -2, 1 & (ye << 1 | Be >>> 31)), g = ve + ie | 0, Gt = q(me ^ (Be = ye + _e | 0), Ge ^ (Tt = Be >>> 0 < ye >>> 0 ? g + 1 | 0 : g), 1), Kt = g = ve, ct = Gt, Ge = (me = l[he + 256 >> 2]) + (ie = l[he >> 2]) | 0, g = ($n = l[he + 260 >> 2]) + (ye = l[he + 4 >> 2]) | 0, _e = ie >>> 0 > Ge >>> 0 ? g + 1 | 0 : g, ye = De(ie << 1 & -2, 1 & (ye << 1 | ie >>> 31), me, 0), g = ve + _e | 0, _e = (ie = ye + Ge | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, ht = (qn = q(l[he + 768 >> 2] ^ ie, _e ^ l[he + 772 >> 2], 32)) + (ye = l[he + 512 >> 2]) | 0, g = (pn = ve) + (Ge = l[he + 516 >> 2]) | 0, Le = ye >>> 0 > ht >>> 0 ? g + 1 | 0 : g, Ge = De(ye << 1 & -2, 1 & (Ge << 1 | ye >>> 31), qn, 0), g = ve + Le | 0, $n = q(me ^ (ye = Ge + ht | 0), $n ^ (Ge = ye >>> 0 < Ge >>> 0 ? g + 1 | 0 : g), 40), g = _e + (ur = ve) | 0, me = (Le = ie + $n | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = De($n, 0, ie << 1 & -2, 1 & (_e << 1 | ie >>> 31)), g = ve + me | 0, g = Kt + (Ct = ie >>> 0 > (Le = ie + Le | 0) >>> 0 ? g + 1 | 0 : g) | 0, _e = (ie = Le + ct | 0) >>> 0 < Le >>> 0 ? g + 1 | 0 : g, me = De(ct, 0, Le << 1 & -2, 1 & (Ct << 1 | Le >>> 31)), g = ve + _e | 0, Gn = q((ie = me + ie | 0) ^ $e, Sn ^ (mt = ie >>> 0 < me >>> 0 ? g + 1 | 0 : g), 32), Cr = g = ve, en = g, ct = ($e = l[he + 384 >> 2]) + (_e = l[he + 128 >> 2]) | 0, g = (Zt = l[he + 388 >> 2]) + (me = l[he + 132 >> 2]) | 0, ht = _e >>> 0 > ct >>> 0 ? g + 1 | 0 : g, me = De(_e << 1 & -2, 1 & (me << 1 | _e >>> 31), $e, 0), g = ve + ht | 0, ht = me >>> 0 > (_e = me + ct | 0) >>> 0 ? g + 1 | 0 : g, St = (ct = q(l[he + 896 >> 2] ^ _e, ht ^ l[he + 900 >> 2], 32)) + (me = l[he + 640 >> 2]) | 0, g = (Kn = ve) + (it = l[he + 644 >> 2]) | 0, _n = me >>> 0 > St >>> 0 ? g + 1 | 0 : g, it = De(me << 1 & -2, 1 & (it << 1 | me >>> 31), ct, 0), g = ve + _n | 0, it = q(St = (me = it + St | 0) ^ $e, Zt ^ ($e = me >>> 0 < it >>> 0 ? g + 1 | 0 : g), 40), g = ht + (Zt = ve) | 0, _n = (St = _e + it | 0) >>> 0 < _e >>> 0 ? g + 1 | 0 : g, ht = De(it, 0, _e << 1 & -2, 1 & (ht << 1 | _e >>> 31)), g = ve + _n | 0, _n = q((_e = ht + St | 0) ^ ct, Kn ^ (ht = _e >>> 0 < ht >>> 0 ? g + 1 | 0 : g), 48), g = $e + (Kn = ve) | 0, ct = (St = me + _n | 0) >>> 0 < me >>> 0 ? g + 1 | 0 : g, me = De(_n, 0, me << 1 & -2, 1 & ($e << 1 | me >>> 31)), g = ve + ct | 0, g = (ct = me >>> 0 > ($e = me + St | 0) >>> 0 ? g + 1 | 0 : g) + en | 0, en = (me = $e + Gn | 0) >>> 0 < $e >>> 0 ? g + 1 | 0 : g, St = De(Gn, 0, $e << 1 & -2, 1 & (ct << 1 | $e >>> 31)), g = ve + en | 0, en = q(en = (me = St + me | 0) ^ Gt, Kt ^ (Gt = me >>> 0 < St >>> 0 ? g + 1 | 0 : g), 40), g = mt + (Kt = ve) | 0, St = (Hn = ie + en | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = (mt = De(en, 0, ie << 1 & -2, 1 & (mt << 1 | ie >>> 31))) + Hn | 0, g = ve + St | 0, l[he >> 2] = ie, g = ie >>> 0 < mt >>> 0 ? g + 1 | 0 : g, l[he + 4 >> 2] = g, ie = q(ie ^ Gn, g ^ Cr, 48), l[he + 904 >> 2] = ie, g = ve, l[he + 908 >> 2] = g, g = g + Gt | 0, mt = (Gn = ie + me | 0) >>> 0 < me >>> 0 ? g + 1 | 0 : g, ie = (me = De(ie, 0, me << 1 & -2, 1 & (Gt << 1 | me >>> 31))) + Gn | 0, g = ve + mt | 0, l[he + 640 >> 2] = ie, g = ie >>> 0 < me >>> 0 ? g + 1 | 0 : g, l[he + 644 >> 2] = g, Ve = he, ut = q(ie ^ en, g ^ Kt, 1), l[Ve + 264 >> 2] = ut, l[he + 268 >> 2] = ve, g = je + Sn | 0, ie = (me = D + wn | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, D = De(wn, 0, D << 1 & -2, 1 & (je << 1 | D >>> 31)), g = ve + ie | 0, ie = g = D >>> 0 > (me = D + me | 0) >>> 0 ? g + 1 | 0 : g, mt = q($e ^ it, ct ^ Zt, 1), g = we + (ct = ve) | 0, je = ($e = U + mt | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (we = De(mt, 0, U << 1 & -2, 1 & (we << 1 | U >>> 31))) + $e | 0, g = ve + je | 0, Ct = q(Le ^ qn, Ct ^ pn, 48), Le = q(Ct ^ U, (je = U >>> 0 < we >>> 0 ? g + 1 | 0 : g) ^ (Gt = ve), 32), g = (wn = ve) + ie | 0, we = Le >>> 0 > ($e = Le + me | 0) >>> 0 ? g + 1 | 0 : g, D = (g = $e) + ($e = De(me << 1 & -2, 1 & (ie << 1 | me >>> 31), Le, 0)) | 0, g = ve + we | 0, mt = q(D ^ mt, ct ^ (we = D >>> 0 < $e >>> 0 ? g + 1 | 0 : g), 40), g = je + (ct = ve) | 0, $e = (qn = U + mt | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(mt, 0, U << 1 & -2, 1 & (je << 1 | U >>> 31)), g = ve + $e | 0, U = q((je = U + qn | 0) ^ Le, wn ^ (g = U >>> 0 > je >>> 0 ? g + 1 | 0 : g), 48), l[he + 768 >> 2] = U, Le = ve, l[he + 772 >> 2] = Le, l[he + 8 >> 2] = je, l[he + 12 >> 2] = g, g = we + Le | 0, je = (Le = U + D | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, U = (D = De(U, 0, D << 1 & -2, 1 & (we << 1 | D >>> 31))) + Le | 0, g = ve + je | 0, l[he + 648 >> 2] = U, g = U >>> 0 < D >>> 0 ? g + 1 | 0 : g, l[he + 652 >> 2] = g, Ve = he, ut = q(U ^ mt, g ^ ct, 1), l[Ve + 384 >> 2] = ut, l[he + 388 >> 2] = ve, me = q(me ^ Zn, ie ^ Ft, 1), g = ht + (Le = ve) | 0, D = (U = me + _e | 0) >>> 0 < _e >>> 0 ? g + 1 | 0 : g, ie = De(me, 0, _e << 1 & -2, 1 & (ht << 1 | _e >>> 31)), g = ve + D | 0, je = q((U = ie + U | 0) ^ er, or ^ (ie = U >>> 0 < ie >>> 0 ? g + 1 | 0 : g), 32), mt = g = ve, D = g, g = Ge + Gt | 0, _e = (we = ye + Ct | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, ye = (g = we) + (we = De(Ct, 0, ye << 1 & -2, 1 & (Ge << 1 | ye >>> 31))) | 0, g = ve + _e | 0, g = (_e = ye >>> 0 < we >>> 0 ? g + 1 | 0 : g) + D | 0, we = (D = ye + je | 0) >>> 0 < ye >>> 0 ? g + 1 | 0 : g, Ge = De(je, 0, ye << 1 & -2, 1 & (_e << 1 | ye >>> 31)), g = ve + we | 0, we = q($e = (D = Ge + D | 0) ^ me, Le ^ (me = D >>> 0 < Ge >>> 0 ? g + 1 | 0 : g), 40), g = ie + (Le = ve) | 0, Ge = (Ct = U + we | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(we, 0, U << 1 & -2, 1 & (ie << 1 | U >>> 31)), g = ve + Ge | 0, U = q((ie = U + Ct | 0) ^ je, mt ^ (g = U >>> 0 > ie >>> 0 ? g + 1 | 0 : g), 48), l[he + 776 >> 2] = U, je = ve, l[he + 780 >> 2] = je, l[he + 128 >> 2] = ie, l[he + 132 >> 2] = g, g = me + je | 0, ie = (je = U + D | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, U = (D = De(U, 0, D << 1 & -2, 1 & (me << 1 | D >>> 31))) + je | 0, g = ve + ie | 0, l[he + 512 >> 2] = U, g = U >>> 0 < D >>> 0 ? g + 1 | 0 : g, l[he + 516 >> 2] = g, Ve = he, ut = q(U ^ we, g ^ Le, 1), l[Ve + 392 >> 2] = ut, l[he + 396 >> 2] = ve, ie = q(ye ^ $n, _e ^ ur, 1), g = (me = ve) + fn | 0, D = (U = ie + bt | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ye = De(bt << 1 & -2, 1 & (fn << 1 | bt >>> 31), ie, 0), g = ve + D | 0, ye = q((U = ye + U | 0) ^ _n, Kn ^ (D = U >>> 0 < ye >>> 0 ? g + 1 | 0 : g), 32), g = Tt + (je = ve) | 0, _e = (bt = Be + ye | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, Be = (g = bt) + (bt = De(ye, 0, Be << 1 & -2, 1 & (Tt << 1 | Be >>> 31))) | 0, g = ve + _e | 0, _e = q($e = ie ^ Be, me ^ (ie = Be >>> 0 < bt >>> 0 ? g + 1 | 0 : g), 40), g = D + (bt = ve) | 0, me = (fn = U + _e | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(_e, 0, U << 1 & -2, 1 & (D << 1 | U >>> 31)), g = ve + me | 0, U = q((D = U + fn | 0) ^ ye, je ^ (g = U >>> 0 > D >>> 0 ? g + 1 | 0 : g), 48), l[he + 896 >> 2] = U, ye = ve, l[he + 900 >> 2] = ye, l[he + 136 >> 2] = D, l[he + 140 >> 2] = g, g = ie + ye | 0, D = (ye = U + Be | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (Be = De(U, 0, Be << 1 & -2, 1 & (ie << 1 | Be >>> 31))) + ye | 0, g = ve + D | 0, l[he + 520 >> 2] = U, g = U >>> 0 < Be >>> 0 ? g + 1 | 0 : g, l[he + 524 >> 2] = g, Ve = he, ut = q(U ^ _e, g ^ bt, 1), l[Ve + 256 >> 2] = ut, l[he + 260 >> 2] = ve, (0 | (A = A + 1 | 0)) != 8; )
                        ;
                      for (g = xr(_, b, 1024), A = 0; U = l[(he = (_ = A << 3) + g | 0) >> 2], ie = l[(Be = (D = $e = b + 1024 | 0) + _ | 0) >> 2], Be = l[he + 4 >> 2] ^ l[Be + 4 >> 2], l[he >> 2] = U ^ ie, l[he + 4 >> 2] = Be, Be = l[(he = (U = 8 | _) + g | 0) >> 2], D = l[(U = U + D | 0) >> 2], U = l[he + 4 >> 2] ^ l[U + 4 >> 2], l[he >> 2] = D ^ Be, l[he + 4 >> 2] = U, D = l[(he = (U = 16 | _) + g | 0) >> 2], Be = l[(U = U + $e | 0) >> 2], U = l[he + 4 >> 2] ^ l[U + 4 >> 2], l[he >> 2] = D ^ Be, l[he + 4 >> 2] = U, U = l[(_ = (he = 24 | _) + g | 0) >> 2], D = l[(he = he + $e | 0) >> 2], he = l[_ + 4 >> 2] ^ l[he + 4 >> 2], l[_ >> 2] = U ^ D, l[_ + 4 >> 2] = he, (0 | (A = A + 4 | 0)) != 128; )
                        ;
                      st = b + 2048 | 0;
                    }
                    function Qi(A) {
                      var g, _ = 0, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0;
                      st = g = st - 16 | 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              s: {
                                u: {
                                  a: {
                                    d: {
                                      o: {
                                        if ((A |= 0) >>> 0 <= 244) {
                                          if (3 & (_ = (D = l[9130]) >>> (b = (me = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                            _ = 36560 + (A = (b = b + (1 & (-1 ^ _)) | 0) << 3) | 0, U = l[A + 36568 >> 2], (0 | _) != (0 | (A = l[U + 8 >> 2])) ? (l[A + 12 >> 2] = _, l[_ + 8 >> 2] = A) : (we = 36520, $e = tn(-2, b) & D, l[we >> 2] = $e), A = U + 8 | 0, _ = b << 3, l[U + 4 >> 2] = 3 | _, l[4 + (_ = _ + U | 0) >> 2] = 1 | l[_ + 4 >> 2];
                                            break e;
                                          }
                                          if ((ye = l[9132]) >>> 0 >= me >>> 0)
                                            break o;
                                          if (_) {
                                            _ = 36560 + (A = (U = lu(0 - (A = (0 - (A = 2 << b) | A) & _ << b) & A)) << 3) | 0, ie = l[A + 36568 >> 2], (0 | _) != (0 | (A = l[ie + 8 >> 2])) ? (l[A + 12 >> 2] = _, l[_ + 8 >> 2] = A) : (D = tn(-2, U) & D, l[9130] = D), l[ie + 4 >> 2] = 3 | me, U = (A = U << 3) - me | 0, l[4 + (b = ie + me | 0) >> 2] = 1 | U, l[A + ie >> 2] = U, ye && (_ = 36560 + (-8 & ye) | 0, he = l[9135], (A = 1 << (ye >>> 3)) & D ? A = l[_ + 8 >> 2] : (l[9130] = A | D, A = _), l[_ + 8 >> 2] = he, l[A + 12 >> 2] = he, l[he + 12 >> 2] = _, l[he + 8 >> 2] = A), A = ie + 8 | 0, l[9135] = b, l[9132] = U;
                                            break e;
                                          }
                                          if (!(Be = l[9131]))
                                            break o;
                                          for (b = l[36824 + (lu(0 - Be & Be) << 2) >> 2], he = (-8 & l[b + 4 >> 2]) - me | 0, _ = b; (A = l[_ + 16 >> 2]) || (A = l[_ + 20 >> 2]); )
                                            he = (U = (_ = (-8 & l[A + 4 >> 2]) - me | 0) >>> 0 < he >>> 0) ? _ : he, b = U ? A : b, _ = A;
                                          if (_e = l[b + 24 >> 2], (0 | (U = l[b + 12 >> 2])) != (0 | b)) {
                                            A = l[b + 8 >> 2], l[A + 12 >> 2] = U, l[U + 8 >> 2] = A;
                                            break t;
                                          }
                                          if (!(A = l[(_ = b + 20 | 0) >> 2])) {
                                            if (!(A = l[b + 16 >> 2]))
                                              break d;
                                            _ = b + 16 | 0;
                                          }
                                          for (; ie = _, U = A, (A = l[(_ = A + 20 | 0) >> 2]) || (_ = U + 16 | 0, A = l[U + 16 >> 2]); )
                                            ;
                                          l[ie >> 2] = 0;
                                          break t;
                                        }
                                        if (me = -1, !(A >>> 0 > 4294967231) && (me = -8 & (A = A + 11 | 0), Be = l[9131])) {
                                          he = 0 - me | 0, D = 0, me >>> 0 < 256 || (D = 31, me >>> 0 > 16777215 || (D = 62 + ((me >>> 38 - (A = zi(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                          i: {
                                            c: {
                                              if (_ = l[36824 + (D << 2) >> 2])
                                                for (A = 0, b = me << ((0 | D) != 31 ? 25 - (D >>> 1 | 0) | 0 : 0); ; ) {
                                                  if (!((ie = (-8 & l[_ + 4 >> 2]) - me | 0) >>> 0 >= he >>> 0 || (U = _, he = ie, ie))) {
                                                    he = 0, A = _;
                                                    break c;
                                                  }
                                                  if (ie = l[_ + 20 >> 2], _ = l[16 + ((b >>> 29 & 4) + _ | 0) >> 2], A = ie ? (0 | ie) == (0 | _) ? A : ie : A, b <<= 1, !_)
                                                    break;
                                                }
                                              else
                                                A = 0;
                                              if (!(A | U)) {
                                                if (U = 0, !(A = (0 - (A = 2 << D) | A) & Be))
                                                  break o;
                                                A = l[36824 + (lu(A & 0 - A) << 2) >> 2];
                                              }
                                              if (!A)
                                                break i;
                                            }
                                            for (; he = (b = (_ = (-8 & l[A + 4 >> 2]) - me | 0) >>> 0 < he >>> 0) ? _ : he, U = b ? A : U, A = (_ = l[A + 16 >> 2]) || l[A + 20 >> 2]; )
                                              ;
                                          }
                                          if (!(!U | l[9132] - me >>> 0 <= he >>> 0)) {
                                            if (D = l[U + 24 >> 2], (0 | U) != (0 | (b = l[U + 12 >> 2]))) {
                                              A = l[U + 8 >> 2], l[A + 12 >> 2] = b, l[b + 8 >> 2] = A;
                                              break n;
                                            }
                                            if (!(A = l[(_ = U + 20 | 0) >> 2])) {
                                              if (!(A = l[U + 16 >> 2]))
                                                break a;
                                              _ = U + 16 | 0;
                                            }
                                            for (; ie = _, b = A, (A = l[(_ = A + 20 | 0) >> 2]) || (_ = b + 16 | 0, A = l[b + 16 >> 2]); )
                                              ;
                                            l[ie >> 2] = 0;
                                            break n;
                                          }
                                        }
                                      }
                                      if ((A = l[9132]) >>> 0 >= me >>> 0) {
                                        U = l[9135], (_ = A - me | 0) >>> 0 >= 16 ? (l[4 + (b = U + me | 0) >> 2] = 1 | _, l[A + U >> 2] = _, l[U + 4 >> 2] = 3 | me) : (l[U + 4 >> 2] = 3 | A, l[4 + (A = A + U | 0) >> 2] = 1 | l[A + 4 >> 2], b = 0, _ = 0), l[9132] = _, l[9135] = b, A = U + 8 | 0;
                                        break e;
                                      }
                                      if ((_e = l[9133]) >>> 0 > me >>> 0) {
                                        _ = _e - me | 0, l[9133] = _, A = (b = l[9136]) + me | 0, l[9136] = A, l[A + 4 >> 2] = 1 | _, l[b + 4 >> 2] = 3 | me, A = b + 8 | 0;
                                        break e;
                                      }
                                      if (A = 0, Be = me + 47 | 0, l[9248] ? b = l[9250] : (l[9251] = -1, l[9252] = -1, l[9249] = 4096, l[9250] = 4096, l[9248] = g + 12 & -16 ^ 1431655768, l[9253] = 0, l[9241] = 0, b = 4096), (_ = (ie = Be + b | 0) & (he = 0 - b | 0)) >>> 0 <= me >>> 0 || (U = l[9240]) && U >>> 0 < (D = (b = l[9238]) + _ | 0) >>> 0 | b >>> 0 >= D >>> 0)
                                        break e;
                                      o: {
                                        if (!(4 & B[36964])) {
                                          i: {
                                            c: {
                                              l: {
                                                f: {
                                                  if (U = l[9136])
                                                    for (A = 36968; ; ) {
                                                      if ((b = l[A >> 2]) >>> 0 <= U >>> 0 & U >>> 0 < b + l[A + 4 >> 2] >>> 0)
                                                        break f;
                                                      if (!(A = l[A + 8 >> 2]))
                                                        break;
                                                    }
                                                  if ((0 | (b = br(0))) == -1 || (D = _, (A = (U = l[9249]) - 1 | 0) & b && (D = (_ - b | 0) + (A + b & 0 - U) | 0), D >>> 0 <= me >>> 0) || (U = l[9240]) && U >>> 0 < (he = (A = l[9238]) + D | 0) >>> 0 | A >>> 0 >= he >>> 0)
                                                    break i;
                                                  if ((0 | b) != (0 | (A = br(D))))
                                                    break l;
                                                  break o;
                                                }
                                                if ((0 | (b = br(D = he & ie - _e))) == (l[A >> 2] + l[A + 4 >> 2] | 0))
                                                  break c;
                                                A = b;
                                              }
                                              if ((0 | A) == -1)
                                                break i;
                                              if (me + 48 >>> 0 <= D >>> 0) {
                                                b = A;
                                                break o;
                                              }
                                              if ((0 | br(b = (b = l[9250]) + (Be - D | 0) & 0 - b)) == -1)
                                                break i;
                                              D = b + D | 0, b = A;
                                              break o;
                                            }
                                            if ((0 | b) != -1)
                                              break o;
                                          }
                                          l[9241] = 4 | l[9241];
                                        }
                                        if ((0 | (b = br(_))) == -1 | (0 | (A = br(0))) == -1 | A >>> 0 <= b >>> 0 || (D = A - b | 0) >>> 0 <= me + 40 >>> 0)
                                          break r;
                                      }
                                      A = l[9238] + D | 0, l[9238] = A, A >>> 0 > Ri[9239] && (l[9239] = A);
                                      o: {
                                        if (ie = l[9136]) {
                                          for (A = 36968; ; ) {
                                            if (((U = l[A >> 2]) + (_ = l[A + 4 >> 2]) | 0) == (0 | b))
                                              break o;
                                            if (!(A = l[A + 8 >> 2]))
                                              break;
                                          }
                                          break u;
                                        }
                                        for ((A = l[9134]) >>> 0 <= b >>> 0 && A || (l[9134] = b), A = 0, l[9243] = D, l[9242] = b, l[9138] = -1, l[9139] = l[9248], l[9245] = 0; _ = 36560 + (U = A << 3) | 0, l[U + 36568 >> 2] = _, l[U + 36572 >> 2] = _, (0 | (A = A + 1 | 0)) != 32; )
                                          ;
                                        _ = (U = D - 40 | 0) - (A = b + 8 & 7 ? -8 - b & 7 : 0) | 0, l[9133] = _, A = A + b | 0, l[9136] = A, l[A + 4 >> 2] = 1 | _, l[4 + (b + U | 0) >> 2] = 40, l[9137] = l[9252];
                                        break s;
                                      }
                                      if (8 & B[A + 12 | 0] | U >>> 0 > ie >>> 0 | b >>> 0 <= ie >>> 0)
                                        break u;
                                      l[A + 4 >> 2] = _ + D, b = (A = ie + 8 & 7 ? -8 - ie & 7 : 0) + ie | 0, l[9136] = b, A = (_ = l[9133] + D | 0) - A | 0, l[9133] = A, l[b + 4 >> 2] = 1 | A, l[4 + (_ + ie | 0) >> 2] = 40, l[9137] = l[9252];
                                      break s;
                                    }
                                    U = 0;
                                    break t;
                                  }
                                  b = 0;
                                  break n;
                                }
                                Ri[9134] > b >>> 0 && (l[9134] = b), _ = b + D | 0, A = 36968;
                                u: {
                                  a: {
                                    d: {
                                      o: {
                                        i: {
                                          c: {
                                            for (; ; ) {
                                              if ((0 | _) != l[A >> 2]) {
                                                if (A = l[A + 8 >> 2])
                                                  continue;
                                                break c;
                                              }
                                              break;
                                            }
                                            if (!(8 & B[A + 12 | 0]))
                                              break i;
                                          }
                                          for (A = 36968; ; ) {
                                            if ((_ = l[A >> 2]) >>> 0 <= ie >>> 0 && (he = _ + l[A + 4 >> 2] | 0) >>> 0 > ie >>> 0)
                                              break o;
                                            A = l[A + 8 >> 2];
                                          }
                                        }
                                        if (l[A >> 2] = b, l[A + 4 >> 2] = l[A + 4 >> 2] + D, l[4 + (Be = (b + 8 & 7 ? -8 - b & 7 : 0) + b | 0) >> 2] = 3 | me, A = (D = _ + (_ + 8 & 7 ? -8 - _ & 7 : 0) | 0) - (_e = me + Be | 0) | 0, (0 | ie) == (0 | D)) {
                                          l[9136] = _e, A = l[9133] + A | 0, l[9133] = A, l[_e + 4 >> 2] = 1 | A;
                                          break a;
                                        }
                                        if (l[9135] == (0 | D)) {
                                          l[9135] = _e, A = l[9132] + A | 0, l[9132] = A, l[_e + 4 >> 2] = 1 | A, l[A + _e >> 2] = A;
                                          break a;
                                        }
                                        if ((3 & (he = l[D + 4 >> 2])) == 1) {
                                          ie = -8 & he;
                                          i:
                                            if (he >>> 0 <= 255) {
                                              if (U = l[D + 8 >> 2], _ = he >>> 3 | 0, (0 | (b = l[D + 12 >> 2])) == (0 | U)) {
                                                we = 36520, $e = l[9130] & tn(-2, _), l[we >> 2] = $e;
                                                break i;
                                              }
                                              l[U + 12 >> 2] = b, l[b + 8 >> 2] = U;
                                            } else {
                                              if (me = l[D + 24 >> 2], (0 | D) == (0 | (b = l[D + 12 >> 2])))
                                                if ((_ = l[(he = D + 20 | 0) >> 2]) || (_ = l[(he = D + 16 | 0) >> 2])) {
                                                  for (; U = he, (_ = l[(he = (b = _) + 20 | 0) >> 2]) || (he = b + 16 | 0, _ = l[b + 16 >> 2]); )
                                                    ;
                                                  l[U >> 2] = 0;
                                                } else
                                                  b = 0;
                                              else
                                                _ = l[D + 8 >> 2], l[_ + 12 >> 2] = b, l[b + 8 >> 2] = _;
                                              if (me) {
                                                U = l[D + 28 >> 2];
                                                c: {
                                                  if (l[(_ = 36824 + (U << 2) | 0) >> 2] == (0 | D)) {
                                                    if (l[_ >> 2] = b, b)
                                                      break c;
                                                    we = 36524, $e = l[9131] & tn(-2, U), l[we >> 2] = $e;
                                                    break i;
                                                  }
                                                  if (l[me + (l[me + 16 >> 2] == (0 | D) ? 16 : 20) >> 2] = b, !b)
                                                    break i;
                                                }
                                                l[b + 24 >> 2] = me, (_ = l[D + 16 >> 2]) && (l[b + 16 >> 2] = _, l[_ + 24 >> 2] = b), (_ = l[D + 20 >> 2]) && (l[b + 20 >> 2] = _, l[_ + 24 >> 2] = b);
                                              }
                                            }
                                          he = l[4 + (D = ie + D | 0) >> 2], A = A + ie | 0;
                                        }
                                        if (l[D + 4 >> 2] = -2 & he, l[_e + 4 >> 2] = 1 | A, l[A + _e >> 2] = A, A >>> 0 <= 255) {
                                          _ = 36560 + (-8 & A) | 0, (b = l[9130]) & (A = 1 << (A >>> 3)) ? A = l[_ + 8 >> 2] : (l[9130] = A | b, A = _), l[_ + 8 >> 2] = _e, l[A + 12 >> 2] = _e, l[_e + 12 >> 2] = _, l[_e + 8 >> 2] = A;
                                          break a;
                                        }
                                        if (he = 31, A >>> 0 <= 16777215 && (he = 62 + ((A >>> 38 - (_ = zi(A >>> 8 | 0)) & 1) - (_ << 1) | 0) | 0), l[_e + 28 >> 2] = he, l[_e + 16 >> 2] = 0, l[_e + 20 >> 2] = 0, _ = 36824 + (he << 2) | 0, (U = l[9131]) & (b = 1 << he)) {
                                          for (he = A << ((0 | he) != 31 ? 25 - (he >>> 1 | 0) | 0 : 0), b = l[_ >> 2]; ; ) {
                                            if (_ = b, (-8 & l[b + 4 >> 2]) == (0 | A))
                                              break d;
                                            if (b = he >>> 29 | 0, he <<= 1, !(b = l[16 + (U = (4 & b) + _ | 0) >> 2]))
                                              break;
                                          }
                                          l[U + 16 >> 2] = _e;
                                        } else
                                          l[9131] = b | U, l[_ >> 2] = _e;
                                        l[_e + 24 >> 2] = _, l[_e + 12 >> 2] = _e, l[_e + 8 >> 2] = _e;
                                        break a;
                                      }
                                      for (_ = (U = D - 40 | 0) - (A = b + 8 & 7 ? -8 - b & 7 : 0) | 0, l[9133] = _, A = A + b | 0, l[9136] = A, l[A + 4 >> 2] = 1 | _, l[4 + (b + U | 0) >> 2] = 40, l[9137] = l[9252], l[(U = (A = (he + (he - 39 & 7 ? 39 - he & 7 : 0) | 0) - 47 | 0) >>> 0 < ie + 16 >>> 0 ? ie : A) + 4 >> 2] = 27, A = l[9245], l[U + 16 >> 2] = l[9244], l[U + 20 >> 2] = A, A = l[9243], l[U + 8 >> 2] = l[9242], l[U + 12 >> 2] = A, l[9244] = U + 8, l[9243] = D, l[9242] = b, l[9245] = 0, A = U + 24 | 0; l[A + 4 >> 2] = 7, _ = A + 8 | 0, A = A + 4 | 0, _ >>> 0 < he >>> 0; )
                                        ;
                                      if ((0 | U) == (0 | ie))
                                        break s;
                                      if (l[U + 4 >> 2] = -2 & l[U + 4 >> 2], he = U - ie | 0, l[ie + 4 >> 2] = 1 | he, l[U >> 2] = he, he >>> 0 <= 255) {
                                        _ = 36560 + (-8 & he) | 0, (b = l[9130]) & (A = 1 << (he >>> 3)) ? A = l[_ + 8 >> 2] : (l[9130] = A | b, A = _), l[_ + 8 >> 2] = ie, l[A + 12 >> 2] = ie, l[ie + 12 >> 2] = _, l[ie + 8 >> 2] = A;
                                        break s;
                                      }
                                      if (A = 31, he >>> 0 <= 16777215 && (A = 62 + ((he >>> 38 - (A = zi(he >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), l[ie + 28 >> 2] = A, l[ie + 16 >> 2] = 0, l[ie + 20 >> 2] = 0, _ = 36824 + (A << 2) | 0, (U = l[9131]) & (b = 1 << A)) {
                                        for (A = he << ((0 | A) != 31 ? 25 - (A >>> 1 | 0) | 0 : 0), U = l[_ >> 2]; ; ) {
                                          if ((0 | he) == (-8 & l[(_ = U) + 4 >> 2]))
                                            break u;
                                          if (b = A >>> 29 | 0, A <<= 1, !(U = l[16 + (b = (4 & b) + _ | 0) >> 2]))
                                            break;
                                        }
                                        l[b + 16 >> 2] = ie;
                                      } else
                                        l[9131] = b | U, l[_ >> 2] = ie;
                                      l[ie + 24 >> 2] = _, l[ie + 12 >> 2] = ie, l[ie + 8 >> 2] = ie;
                                      break s;
                                    }
                                    A = l[_ + 8 >> 2], l[A + 12 >> 2] = _e, l[_ + 8 >> 2] = _e, l[_e + 24 >> 2] = 0, l[_e + 12 >> 2] = _, l[_e + 8 >> 2] = A;
                                  }
                                  A = Be + 8 | 0;
                                  break e;
                                }
                                A = l[_ + 8 >> 2], l[A + 12 >> 2] = ie, l[_ + 8 >> 2] = ie, l[ie + 24 >> 2] = 0, l[ie + 12 >> 2] = _, l[ie + 8 >> 2] = A;
                              }
                              if (!((A = l[9133]) >>> 0 <= me >>> 0)) {
                                _ = A - me | 0, l[9133] = _, A = (b = l[9136]) + me | 0, l[9136] = A, l[A + 4 >> 2] = 1 | _, l[b + 4 >> 2] = 3 | me, A = b + 8 | 0;
                                break e;
                              }
                            }
                            l[9129] = 48, A = 0;
                            break e;
                          }
                          n:
                            if (D) {
                              _ = l[U + 28 >> 2];
                              r: {
                                if (l[(A = 36824 + (_ << 2) | 0) >> 2] == (0 | U)) {
                                  if (l[A >> 2] = b, b)
                                    break r;
                                  Be = tn(-2, _) & Be, l[9131] = Be;
                                  break n;
                                }
                                if (l[D + (l[D + 16 >> 2] == (0 | U) ? 16 : 20) >> 2] = b, !b)
                                  break n;
                              }
                              l[b + 24 >> 2] = D, (A = l[U + 16 >> 2]) && (l[b + 16 >> 2] = A, l[A + 24 >> 2] = b), (A = l[U + 20 >> 2]) && (l[b + 20 >> 2] = A, l[A + 24 >> 2] = b);
                            }
                          n:
                            if (he >>> 0 <= 15)
                              A = he + me | 0, l[U + 4 >> 2] = 3 | A, l[4 + (A = A + U | 0) >> 2] = 1 | l[A + 4 >> 2];
                            else if (l[U + 4 >> 2] = 3 | me, l[4 + (ie = U + me | 0) >> 2] = 1 | he, l[ie + he >> 2] = he, he >>> 0 <= 255)
                              _ = 36560 + (-8 & he) | 0, (b = l[9130]) & (A = 1 << (he >>> 3)) ? A = l[_ + 8 >> 2] : (l[9130] = A | b, A = _), l[_ + 8 >> 2] = ie, l[A + 12 >> 2] = ie, l[ie + 12 >> 2] = _, l[ie + 8 >> 2] = A;
                            else {
                              A = 31, he >>> 0 <= 16777215 && (A = 62 + ((he >>> 38 - (A = zi(he >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), l[ie + 28 >> 2] = A, l[ie + 16 >> 2] = 0, l[ie + 20 >> 2] = 0, _ = 36824 + (A << 2) | 0;
                              r: {
                                if ((b = 1 << A) & Be) {
                                  for (A = he << ((0 | A) != 31 ? 25 - (A >>> 1 | 0) | 0 : 0), me = l[_ >> 2]; ; ) {
                                    if ((-8 & l[(_ = me) + 4 >> 2]) == (0 | he))
                                      break r;
                                    if (b = A >>> 29 | 0, A <<= 1, !(me = l[16 + (b = (4 & b) + _ | 0) >> 2]))
                                      break;
                                  }
                                  l[b + 16 >> 2] = ie;
                                } else
                                  l[9131] = b | Be, l[_ >> 2] = ie;
                                l[ie + 24 >> 2] = _, l[ie + 12 >> 2] = ie, l[ie + 8 >> 2] = ie;
                                break n;
                              }
                              A = l[_ + 8 >> 2], l[A + 12 >> 2] = ie, l[_ + 8 >> 2] = ie, l[ie + 24 >> 2] = 0, l[ie + 12 >> 2] = _, l[ie + 8 >> 2] = A;
                            }
                          A = U + 8 | 0;
                          break e;
                        }
                        t:
                          if (_e) {
                            _ = l[b + 28 >> 2];
                            n: {
                              if (l[(A = 36824 + (_ << 2) | 0) >> 2] == (0 | b)) {
                                if (l[A >> 2] = U, U)
                                  break n;
                                we = 36524, $e = tn(-2, _) & Be, l[we >> 2] = $e;
                                break t;
                              }
                              if (l[_e + (l[_e + 16 >> 2] == (0 | b) ? 16 : 20) >> 2] = U, !U)
                                break t;
                            }
                            l[U + 24 >> 2] = _e, (A = l[b + 16 >> 2]) && (l[U + 16 >> 2] = A, l[A + 24 >> 2] = U), (A = l[b + 20 >> 2]) && (l[U + 20 >> 2] = A, l[A + 24 >> 2] = U);
                          }
                        he >>> 0 <= 15 ? (A = he + me | 0, l[b + 4 >> 2] = 3 | A, l[4 + (A = A + b | 0) >> 2] = 1 | l[A + 4 >> 2]) : (l[b + 4 >> 2] = 3 | me, l[4 + (U = b + me | 0) >> 2] = 1 | he, l[U + he >> 2] = he, ye && (_ = 36560 + (-8 & ye) | 0, ie = l[9135], (A = 1 << (ye >>> 3)) & D ? A = l[_ + 8 >> 2] : (l[9130] = A | D, A = _), l[_ + 8 >> 2] = ie, l[A + 12 >> 2] = ie, l[ie + 12 >> 2] = _, l[ie + 8 >> 2] = A), l[9135] = U, l[9132] = he), A = b + 8 | 0;
                      }
                      return st = g + 16 | 0, 0 | A;
                    }
                    function ua(A, g, _, b, U, ie) {
                      var he, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0;
                      if (st = he = st - 592 | 0, me = -1, Pt(we = A + 32 | 0) && !Qe(A) && de(U) && !Qe(U) && !Rn(he + 128 | 0, U)) {
                        for (ae(me = he + 384 | 0), ie && Di(me, 35248, 34, 0), Di(me, A, 32, 0), Di(me, U, 32, 0), Di(me, g, _, b), Ui(me, _ = he + 320 | 0), Vi(_), ie = he + 8 | 0, b = he + 128 | 0, U = 0, g = 0, st = D = st - 2272 | 0; _e = _ + (U >>> 3 | 0) | 0, j[(me = D + 2016 | 0) + U | 0] = B[0 | _e] >>> (6 & U) & 1, j[(Be = me) + (me = 1 | U) | 0] = B[0 | _e] >>> (7 & me) & 1, (0 | (U = U + 2 | 0)) != 256; )
                          ;
                        for (; ; ) {
                          g = (_ = g) + 1 | 0;
                          e:
                            if (!(!B[0 | ($e = _ + (D + 2016 | 0) | 0)] | _ >>> 0 > 254)) {
                              t:
                                if (U = j[0 | (Be = (D + 2016 | 0) + g | 0)])
                                  if ((0 | (U = (_e = U << 1) + (me = j[0 | $e]) | 0)) <= 15)
                                    j[0 | $e] = U, j[0 | Be] = 0;
                                  else {
                                    if ((0 | (U = me - _e | 0)) < -15)
                                      break e;
                                    for (j[0 | $e] = U, U = g; ; ) {
                                      if (!B[0 | (me = (D + 2016 | 0) + U | 0)]) {
                                        j[0 | me] = 1;
                                        break t;
                                      }
                                      if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, !me)
                                        break;
                                    }
                                  }
                              if (!(_ >>> 0 > 253)) {
                                t:
                                  if (me = j[0 | (ye = (U = _ + 2 | 0) + (D + 2016 | 0) | 0)])
                                    if ((0 | (me = (Be = me << 2) + (_e = j[0 | $e]) | 0)) >= 16) {
                                      if ((0 | (me = _e - Be | 0)) < -15)
                                        break e;
                                      for (j[0 | $e] = me; ; ) {
                                        if (B[0 | (me = (D + 2016 | 0) + U | 0)]) {
                                          if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, me)
                                            continue;
                                          break t;
                                        }
                                        break;
                                      }
                                      j[0 | me] = 1;
                                    } else
                                      j[0 | $e] = me, j[0 | ye] = 0;
                                if (!(_ >>> 0 > 252)) {
                                  t:
                                    if (me = j[0 | (ye = (U = _ + 3 | 0) + (D + 2016 | 0) | 0)])
                                      if ((0 | (me = (Be = me << 3) + (_e = j[0 | $e]) | 0)) >= 16) {
                                        if ((0 | (me = _e - Be | 0)) < -15)
                                          break e;
                                        for (j[0 | $e] = me; ; ) {
                                          if (B[0 | (me = (D + 2016 | 0) + U | 0)]) {
                                            if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, me)
                                              continue;
                                            break t;
                                          }
                                          break;
                                        }
                                        j[0 | me] = 1;
                                      } else
                                        j[0 | $e] = me, j[0 | ye] = 0;
                                  if (!(_ >>> 0 > 251)) {
                                    t:
                                      if (me = j[0 | (ye = (U = _ + 4 | 0) + (D + 2016 | 0) | 0)])
                                        if ((0 | (me = (Be = me << 4) + (_e = j[0 | $e]) | 0)) >= 16) {
                                          if ((0 | (me = _e - Be | 0)) < -15)
                                            break e;
                                          for (j[0 | $e] = me; ; ) {
                                            if (B[0 | (me = (D + 2016 | 0) + U | 0)]) {
                                              if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, me)
                                                continue;
                                              break t;
                                            }
                                            break;
                                          }
                                          j[0 | me] = 1;
                                        } else
                                          j[0 | $e] = me, j[0 | ye] = 0;
                                    if (!(_ >>> 0 > 250)) {
                                      t:
                                        if (me = j[0 | (ye = (U = _ + 5 | 0) + (D + 2016 | 0) | 0)])
                                          if ((0 | (me = (Be = me << 5) + (_e = j[0 | $e]) | 0)) >= 16) {
                                            if ((0 | (me = _e - Be | 0)) < -15)
                                              break e;
                                            for (j[0 | $e] = me; ; ) {
                                              if (B[0 | (me = (D + 2016 | 0) + U | 0)]) {
                                                if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, me)
                                                  continue;
                                                break t;
                                              }
                                              break;
                                            }
                                            j[0 | me] = 1;
                                          } else
                                            j[0 | $e] = me, j[0 | ye] = 0;
                                      if (!(_ >>> 0 > 249) && (_ = j[0 | (Be = (U = _ + 6 | 0) + (D + 2016 | 0) | 0)]))
                                        if ((0 | (_ = (_e = _ << 6) + (me = j[0 | $e]) | 0)) >= 16) {
                                          if ((0 | (_ = me - _e | 0)) < -15)
                                            break e;
                                          for (j[0 | $e] = _; ; ) {
                                            if (B[0 | (_ = (D + 2016 | 0) + U | 0)]) {
                                              if (j[0 | _] = 0, _ = U >>> 0 < 255, U = U + 1 | 0, _)
                                                continue;
                                              break e;
                                            }
                                            break;
                                          }
                                          j[0 | _] = 1;
                                        } else
                                          j[0 | $e] = _, j[0 | Be] = 0;
                                    }
                                  }
                                }
                              }
                            }
                          if ((0 | g) == 256)
                            break;
                        }
                        for (U = 0; _ = we + (U >>> 3 | 0) | 0, j[(g = D + 1760 | 0) + U | 0] = B[0 | _] >>> (6 & U) & 1, j[(me = g) + (g = 1 | U) | 0] = B[0 | _] >>> (7 & g) & 1, (0 | (U = U + 2 | 0)) != 256; )
                          ;
                        for (g = 0; ; ) {
                          g = (_ = g) + 1 | 0;
                          e:
                            if (!(!B[0 | (we = _ + (D + 1760 | 0) | 0)] | _ >>> 0 > 254)) {
                              t:
                                if (U = j[0 | (Be = (D + 1760 | 0) + g | 0)])
                                  if ((0 | (U = (_e = U << 1) + (me = j[0 | we]) | 0)) <= 15)
                                    j[0 | we] = U, j[0 | Be] = 0;
                                  else {
                                    if ((0 | (U = me - _e | 0)) < -15)
                                      break e;
                                    for (j[0 | we] = U, U = g; ; ) {
                                      if (!B[0 | (me = (D + 1760 | 0) + U | 0)]) {
                                        j[0 | me] = 1;
                                        break t;
                                      }
                                      if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, !me)
                                        break;
                                    }
                                  }
                              if (!(_ >>> 0 > 253)) {
                                t:
                                  if (me = j[0 | (ye = (U = _ + 2 | 0) + (D + 1760 | 0) | 0)])
                                    if ((0 | (me = (Be = me << 2) + (_e = j[0 | we]) | 0)) >= 16) {
                                      if ((0 | (me = _e - Be | 0)) < -15)
                                        break e;
                                      for (j[0 | we] = me; ; ) {
                                        if (B[0 | (me = (D + 1760 | 0) + U | 0)]) {
                                          if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, me)
                                            continue;
                                          break t;
                                        }
                                        break;
                                      }
                                      j[0 | me] = 1;
                                    } else
                                      j[0 | we] = me, j[0 | ye] = 0;
                                if (!(_ >>> 0 > 252)) {
                                  t:
                                    if (me = j[0 | (ye = (U = _ + 3 | 0) + (D + 1760 | 0) | 0)])
                                      if ((0 | (me = (Be = me << 3) + (_e = j[0 | we]) | 0)) >= 16) {
                                        if ((0 | (me = _e - Be | 0)) < -15)
                                          break e;
                                        for (j[0 | we] = me; ; ) {
                                          if (B[0 | (me = (D + 1760 | 0) + U | 0)]) {
                                            if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, me)
                                              continue;
                                            break t;
                                          }
                                          break;
                                        }
                                        j[0 | me] = 1;
                                      } else
                                        j[0 | we] = me, j[0 | ye] = 0;
                                  if (!(_ >>> 0 > 251)) {
                                    t:
                                      if (me = j[0 | (ye = (U = _ + 4 | 0) + (D + 1760 | 0) | 0)])
                                        if ((0 | (me = (Be = me << 4) + (_e = j[0 | we]) | 0)) >= 16) {
                                          if ((0 | (me = _e - Be | 0)) < -15)
                                            break e;
                                          for (j[0 | we] = me; ; ) {
                                            if (B[0 | (me = (D + 1760 | 0) + U | 0)]) {
                                              if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, me)
                                                continue;
                                              break t;
                                            }
                                            break;
                                          }
                                          j[0 | me] = 1;
                                        } else
                                          j[0 | we] = me, j[0 | ye] = 0;
                                    if (!(_ >>> 0 > 250)) {
                                      t:
                                        if (me = j[0 | (ye = (U = _ + 5 | 0) + (D + 1760 | 0) | 0)])
                                          if ((0 | (me = (Be = me << 5) + (_e = j[0 | we]) | 0)) >= 16) {
                                            if ((0 | (me = _e - Be | 0)) < -15)
                                              break e;
                                            for (j[0 | we] = me; ; ) {
                                              if (B[0 | (me = (D + 1760 | 0) + U | 0)]) {
                                                if (j[0 | me] = 0, me = U >>> 0 < 255, U = U + 1 | 0, me)
                                                  continue;
                                                break t;
                                              }
                                              break;
                                            }
                                            j[0 | me] = 1;
                                          } else
                                            j[0 | we] = me, j[0 | ye] = 0;
                                      if (!(_ >>> 0 > 249) && (_ = j[0 | (Be = (U = _ + 6 | 0) + (D + 1760 | 0) | 0)]))
                                        if ((0 | (_ = (_e = _ << 6) + (me = j[0 | we]) | 0)) >= 16) {
                                          if ((0 | (_ = me - _e | 0)) < -15)
                                            break e;
                                          for (j[0 | we] = _; ; ) {
                                            if (B[0 | (_ = (D + 1760 | 0) + U | 0)]) {
                                              if (j[0 | _] = 0, _ = U >>> 0 < 255, U = U + 1 | 0, _)
                                                continue;
                                              break e;
                                            }
                                            break;
                                          }
                                          j[0 | _] = 1;
                                        } else
                                          j[0 | we] = _, j[0 | Be] = 0;
                                    }
                                  }
                                }
                              }
                            }
                          if ((0 | g) == 256)
                            break;
                        }
                        for (Bi(mt = D + 480 | 0, b), $e = l[b + 8 >> 2], we = l[b + 12 >> 2], ye = l[b + 16 >> 2], Be = l[b + 20 >> 2], _e = l[b + 24 >> 2], me = l[b + 28 >> 2], U = l[b >> 2], _ = l[b + 4 >> 2], g = l[b + 36 >> 2], l[D + 192 >> 2] = l[b + 32 >> 2], l[D + 196 >> 2] = g, l[D + 184 >> 2] = _e, l[D + 188 >> 2] = me, l[D + 176 >> 2] = ye, l[D + 180 >> 2] = Be, l[D + 168 >> 2] = $e, l[D + 172 >> 2] = we, l[D + 160 >> 2] = U, l[D + 164 >> 2] = _, $e = l[b + 40 >> 2], we = l[b + 44 >> 2], ye = l[b + 48 >> 2], Be = l[b + 52 >> 2], _e = l[b + 56 >> 2], me = l[b + 60 >> 2], U = l[(g = b - -64 | 0) >> 2], _ = l[g + 4 >> 2], g = l[b + 76 >> 2], l[D + 232 >> 2] = l[b + 72 >> 2], l[D + 236 >> 2] = g, l[D + 224 >> 2] = U, l[D + 228 >> 2] = _, l[D + 216 >> 2] = _e, l[D + 220 >> 2] = me, l[D + 208 >> 2] = ye, l[D + 212 >> 2] = Be, l[D + 200 >> 2] = $e, l[D + 204 >> 2] = we, $e = l[b + 80 >> 2], we = l[b + 84 >> 2], ye = l[b + 88 >> 2], Be = l[b + 92 >> 2], _e = l[b + 96 >> 2], me = l[b + 100 >> 2], U = l[b + 104 >> 2], _ = l[b + 108 >> 2], g = l[b + 116 >> 2], l[D + 272 >> 2] = l[b + 112 >> 2], l[D + 276 >> 2] = g, l[D + 264 >> 2] = U, l[D + 268 >> 2] = _, l[D + 256 >> 2] = _e, l[D + 260 >> 2] = me, l[D + 248 >> 2] = ye, l[D + 252 >> 2] = Be, l[D + 240 >> 2] = $e, l[D + 244 >> 2] = we, Se(b = D + 320 | 0, _ = D + 160 | 0), In(D, b, Le = D + 440 | 0), In(D + 40 | 0, Ge = D + 360 | 0, je = D + 400 | 0), In(D + 80 | 0, je, Le), In(D + 120 | 0, b, Ge), Si(b, D, mt), In(_, b, Le), In(bt = D + 200 | 0, Ge, je), In(ht = D + 240 | 0, je, Le), In(ct = D + 280 | 0, b, Ge), Bi(g = D + 640 | 0, _), Si(b, D, g), In(_, b, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Bi(g = D + 800 | 0, _), Si(b, D, g), In(_, b, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Bi(g = D + 960 | 0, _), Si(b, D, g), In(_, b, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Bi(g = D + 1120 | 0, _), Si(b, D, g), In(_, b, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Bi(g = D + 1280 | 0, _), Si(b, D, g), In(_, b, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Bi(g = D + 1440 | 0, _), Si(b, D, g), In(_, b, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Bi(D + 1600 | 0, _), l[ie + 32 >> 2] = 0, l[ie + 36 >> 2] = 0, l[ie + 24 >> 2] = 0, l[ie + 28 >> 2] = 0, l[ie + 16 >> 2] = 0, l[ie + 20 >> 2] = 0, l[ie + 8 >> 2] = 0, l[ie + 12 >> 2] = 0, l[ie >> 2] = 0, l[ie + 4 >> 2] = 0, l[ie + 44 >> 2] = 0, l[ie + 48 >> 2] = 0, l[(Gn = ie + 40 | 0) >> 2] = 1, l[ie + 52 >> 2] = 0, l[ie + 56 >> 2] = 0, l[ie + 60 >> 2] = 0, l[ie + 64 >> 2] = 0, l[ie + 68 >> 2] = 0, l[ie + 72 >> 2] = 0, l[ie + 84 >> 2] = 0, l[ie + 88 >> 2] = 0, l[ie + 76 >> 2] = 0, l[ie + 80 >> 2] = 1, l[ie + 92 >> 2] = 0, l[ie + 96 >> 2] = 0, l[ie + 100 >> 2] = 0, l[ie + 104 >> 2] = 0, l[ie + 108 >> 2] = 0, l[ie + 112 >> 2] = 0, l[ie + 116 >> 2] = 0, Zt = ie + 80 | 0, g = 255; ; ) {
                          e: {
                            t: {
                              if (!(B[(D + 2016 | 0) + g | 0] | B[(D + 1760 | 0) + g | 0])) {
                                if (!(B[(_ = g - 1 | 0) + (D + 2016 | 0) | 0] | B[_ + (D + 1760 | 0) | 0]))
                                  break t;
                                g = _;
                              }
                              if ((0 | g) < 0)
                                break e;
                              for (; Se(D + 320 | 0, ie), (0 | (U = j[(_ = g) + (D + 2016 | 0) | 0])) > 0 ? (In(g = D + 160 | 0, b = D + 320 | 0, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Si(b, g, (D + 480 | 0) + wr((254 & U) >>> 1 | 0, 160) | 0)) : (0 | U) >= 0 || (In(g = D + 160 | 0, b = D + 320 | 0, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Ts(b, g, (D + 480 | 0) + wr((0 - U & 254) >>> 1 | 0, 160) | 0)), (0 | ($n = j[_ + (D + 1760 | 0) | 0])) > 0 ? (In(g = D + 160 | 0, b = D + 320 | 0, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, b, Ge), Ds(b, g, wr((254 & $n) >>> 1 | 0, 120) + 1744 | 0)) : (0 | $n) >= 0 || (In(D + 160 | 0, qn = D + 320 | 0, Le), In(bt, Ge, je), In(ht, je, Le), In(ct, qn, Ge), Ct = l[D + 160 >> 2], Tt = l[D + 200 >> 2], Gt = l[D + 164 >> 2], en = l[D + 204 >> 2], it = l[D + 168 >> 2], St = l[D + 208 >> 2], Ft = l[D + 172 >> 2], fn = l[D + 212 >> 2], _n = l[D + 176 >> 2], wn = l[D + 216 >> 2], mt = l[D + 180 >> 2], $e = l[D + 220 >> 2], we = l[D + 184 >> 2], ye = l[D + 224 >> 2], Be = l[D + 188 >> 2], _e = l[D + 228 >> 2], me = l[D + 192 >> 2], U = l[D + 232 >> 2], b = l[D + 236 >> 2], g = l[D + 196 >> 2], l[D + 396 >> 2] = b - g, l[D + 392 >> 2] = U - me, l[D + 388 >> 2] = _e - Be, l[D + 384 >> 2] = ye - we, l[D + 380 >> 2] = $e - mt, l[D + 376 >> 2] = wn - _n, l[D + 372 >> 2] = fn - Ft, l[D + 368 >> 2] = St - it, l[D + 364 >> 2] = en - Gt, l[D + 360 >> 2] = Tt - Ct, l[D + 356 >> 2] = g + b, l[D + 352 >> 2] = U + me, l[D + 348 >> 2] = _e + Be, l[D + 344 >> 2] = we + ye, l[D + 340 >> 2] = $e + mt, l[D + 336 >> 2] = _n + wn, l[D + 332 >> 2] = Ft + fn, l[D + 328 >> 2] = it + St, l[D + 324 >> 2] = Gt + en, l[D + 320 >> 2] = Ct + Tt, In(je, qn, 40 + (g = wr((0 - $n & 254) >>> 1 | 0, 120) + 1744 | 0) | 0), In(Ge, Ge, g), In(Le, g + 80 | 0, ct), Sn = l[D + 276 >> 2], or = l[D + 272 >> 2], $n = l[D + 268 >> 2], qn = l[D + 264 >> 2], we = l[D + 260 >> 2], ye = l[D + 256 >> 2], Be = l[D + 252 >> 2], _e = l[D + 248 >> 2], me = l[D + 244 >> 2], U = l[D + 240 >> 2], Kn = l[D + 360 >> 2], Kt = l[D + 400 >> 2], pn = l[D + 364 >> 2], Hn = l[D + 404 >> 2], Zn = l[D + 368 >> 2], er = l[D + 408 >> 2], Ct = l[D + 372 >> 2], Tt = l[D + 412 >> 2], Gt = l[D + 376 >> 2], en = l[D + 416 >> 2], it = l[D + 380 >> 2], St = l[D + 420 >> 2], Ft = l[D + 384 >> 2], fn = l[D + 424 >> 2], _n = l[D + 388 >> 2], wn = l[D + 428 >> 2], mt = l[D + 392 >> 2], $e = l[D + 432 >> 2], b = l[D + 396 >> 2], g = l[D + 436 >> 2], l[D + 396 >> 2] = b + g, l[D + 392 >> 2] = $e + mt, l[D + 388 >> 2] = _n + wn, l[D + 384 >> 2] = Ft + fn, l[D + 380 >> 2] = it + St, l[D + 376 >> 2] = Gt + en, l[D + 372 >> 2] = Ct + Tt, l[D + 368 >> 2] = Zn + er, l[D + 364 >> 2] = pn + Hn, l[D + 360 >> 2] = Kn + Kt, l[D + 356 >> 2] = g - b, l[D + 352 >> 2] = $e - mt, l[D + 348 >> 2] = wn - _n, l[D + 344 >> 2] = fn - Ft, l[D + 340 >> 2] = St - it, l[D + 336 >> 2] = en - Gt, l[D + 332 >> 2] = Tt - Ct, l[D + 328 >> 2] = er - Zn, l[D + 324 >> 2] = Hn - pn, l[D + 320 >> 2] = Kt - Kn, Ct = U << 1, Tt = l[D + 440 >> 2], l[D + 400 >> 2] = Ct - Tt, Gt = me << 1, en = l[D + 444 >> 2], l[D + 404 >> 2] = Gt - en, it = _e << 1, St = l[D + 448 >> 2], l[D + 408 >> 2] = it - St, Ft = Be << 1, fn = l[D + 452 >> 2], l[D + 412 >> 2] = Ft - fn, _n = ye << 1, wn = l[D + 456 >> 2], l[D + 416 >> 2] = _n - wn, mt = we << 1, $e = l[D + 460 >> 2], l[D + 420 >> 2] = mt - $e, we = qn << 1, ye = l[D + 464 >> 2], l[D + 424 >> 2] = we - ye, Be = $n << 1, _e = l[D + 468 >> 2], l[D + 428 >> 2] = Be - _e, me = or << 1, U = l[D + 472 >> 2], l[D + 432 >> 2] = me - U, b = Sn << 1, g = l[D + 476 >> 2], l[D + 436 >> 2] = b - g, l[D + 440 >> 2] = Ct + Tt, l[D + 444 >> 2] = Gt + en, l[D + 448 >> 2] = it + St, l[D + 452 >> 2] = Ft + fn, l[D + 456 >> 2] = _n + wn, l[D + 460 >> 2] = $e + mt, l[D + 464 >> 2] = we + ye, l[D + 468 >> 2] = _e + Be, l[D + 472 >> 2] = U + me, l[D + 476 >> 2] = g + b), In(ie, D + 320 | 0, Le), In(Gn, Ge, je), In(Zt, je, Le), g = _ - 1 | 0, (0 | _) > 0; )
                                ;
                              break e;
                            }
                            if (g = g - 2 | 0, _)
                              continue;
                          }
                          break;
                        }
                        st = D + 2272 | 0, kr(g = he + 288 | 0, ie), ur = -1, Cr = fu(g, A), me = ((0 | A) == (0 | g) ? ur : Cr) | Ie(A, g, 32);
                      }
                      return st = he + 592 | 0, me;
                    }
                    function wa(A, g, _) {
                      var b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht, Ct, Tt, Gt, en, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0;
                      for (st = b = st - 1008 | 0, Ia(St = b + 464 | 0, g), l[b + 464 >> 2] = l[b + 464 >> 2] + 1, Mn(St, St), g = 0, Ft = De(St = l[b + 500 >> 2], St >> 31, 486662, 0), St = ve, qn = (Kt = Ft + 16777216 | 0) >>> 0 < 16777216 ? St + 1 | 0 : St, Gn = Ft - (-33554432 & Kt) | 0, it = De(St = l[b + 496 >> 2], St >> 31, 486662, 0), Ft = ve, $n = De(St = l[b + 492 >> 2], St >> 31, 486662, 0), St = ve, wn = it, it = (it = (St = (_n = $n + 16777216 | 0) >>> 0 < 16777216 ? St + 1 | 0 : St) >> 25) + Ft | 0, St = (St = (33554431 & St) << 7 | _n >>> 25) >>> 0 > (fn = wn + St | 0) >>> 0 ? it + 1 | 0 : it, U = (St = (67108863 & (St = (Ft = fn + 33554432 | 0) >>> 0 < 33554432 ? St + 1 | 0 : St)) << 6 | Ft >>> 26) + Gn | 0, l[b + 452 >> 2] = 0 - U, Zt = fn - (-67108864 & Ft) | 0, l[b + 448 >> 2] = 0 - Zt, Gn = $n - (-33554432 & _n) | 0, Ft = De(St = l[b + 488 >> 2], St >> 31, 486662, 0), St = ve, _n = De(it = l[b + 484 >> 2], it >> 31, 486662, 0), it = ve, wn = Ft, St = St + (Ft = (it = (fn = _n + 16777216 | 0) >>> 0 < 16777216 ? it + 1 | 0 : it) >> 25) | 0, St = (it = wn + ($n = (33554431 & it) << 7 | fn >>> 25) | 0) >>> 0 < $n >>> 0 ? St + 1 | 0 : St, ie = (St = (67108863 & (St = (Ft = it + 33554432 | 0) >>> 0 < 33554432 ? St + 1 | 0 : St)) << 6 | Ft >>> 26) + Gn | 0, l[b + 444 >> 2] = 0 - ie, _e = it - (-67108864 & Ft) | 0, l[b + 440 >> 2] = 0 - _e, Gn = _n - (-33554432 & fn) | 0, it = De(St = l[b + 480 >> 2], St >> 31, 486662, 0), St = ve, _n = De(Ft = l[b + 476 >> 2], Ft >> 31, 486662, 0), Ft = ve, wn = it, St = (it = (Ft = (fn = _n + 16777216 | 0) >>> 0 < 16777216 ? Ft + 1 | 0 : Ft) >> 25) + St | 0, it = (Ft = wn + ($n = (33554431 & Ft) << 7 | fn >>> 25) | 0) >>> 0 < $n >>> 0 ? St + 1 | 0 : St, he = (it = (67108863 & (it = (St = Ft + 33554432 | 0) >>> 0 < 33554432 ? it + 1 | 0 : it)) << 6 | St >>> 26) + Gn | 0, l[b + 436 >> 2] = 0 - he, Be = Ft - (-67108864 & St) | 0, l[b + 432 >> 2] = 0 - Be, wn = _n - (-33554432 & fn) | 0, St = De(St = l[b + 472 >> 2], St >> 31, 486662, 0), Gn = ve, $n = De(Ft = l[b + 468 >> 2], Ft >> 31, 486662, 0), it = ve, Ft = (33554431 & (it = (_n = $n + 16777216 | 0) >>> 0 < 16777216 ? it + 1 | 0 : it)) << 7 | _n >>> 25, it = (it >> 25) + Gn | 0, Ft = Ft >>> 0 > (fn = Ft + St | 0) >>> 0 ? it + 1 | 0 : it, D = (Ft = (67108863 & (Ft = (St = fn + 33554432 | 0) >>> 0 < 33554432 ? Ft + 1 | 0 : Ft)) << 6 | St >>> 26) + wn | 0, l[b + 428 >> 2] = 0 - D, ye = fn - (-67108864 & St) | 0, l[b + 424 >> 2] = 0 - ye, fn = $n - (-33554432 & _n) | 0, Ft = De((33554431 & qn) << 7 | Kt >>> 25, qn >> 25, 19, 0), St = ve, wn = Ft, Ft = De(it = l[b + 464 >> 2], it >> 31, 486662, 0), St = ve + St | 0, Ft = (it = wn + Ft | 0) >>> 0 < Ft >>> 0 ? St + 1 | 0 : St, me = (Ft = (67108863 & (Ft = (St = it + 33554432 | 0) >>> 0 < 33554432 ? Ft + 1 | 0 : Ft)) << 6 | St >>> 26) + fn | 0, l[b + 420 >> 2] = 0 - me, we = it - (-67108864 & St) | 0, l[b + 416 >> 2] = 0 - we, Ot(Ft = b + 368 | 0, St = b + 416 | 0), In(b + 320 | 0, St, Ft), $e = l[b + 356 >> 2], Le = l[b + 320 >> 2], Kn = l[b + 368 >> 2], Ge = l[b + 324 >> 2], je = l[b + 328 >> 2], pn = l[b + 372 >> 2], Hn = l[b + 376 >> 2], ct = l[b + 332 >> 2], mt = l[b + 336 >> 2], Zn = l[b + 380 >> 2], er = l[b + 384 >> 2], bt = l[b + 340 >> 2], ht = l[b + 344 >> 2], wn = l[b + 388 >> 2], Gn = l[b + 392 >> 2], Ct = l[b + 348 >> 2], Tt = l[b + 352 >> 2], Ft = De(St = l[b + 404 >> 2], St >> 31, 486662, 0), St = ve, qn = (Kt = Ft + 16777216 | 0) >>> 0 < 16777216 ? St + 1 | 0 : St, Gt = Ft - (-33554432 & Kt) | 0, St = De(St = l[b + 400 >> 2], St >> 31, 486662, 0), en = ve, $n = De(Ft = l[b + 396 >> 2], Ft >> 31, 486662, 0), it = ve, Ft = St, St = (33554431 & (it = (_n = $n + 16777216 | 0) >>> 0 < 16777216 ? it + 1 | 0 : it)) << 7 | _n >>> 25, it = (it >> 25) + en | 0, St = St >>> 0 > (fn = Ft + St | 0) >>> 0 ? it + 1 | 0 : it, it = St = (67108863 & (St = (Ft = fn + 33554432 | 0) >>> 0 < 33554432 ? St + 1 | 0 : St)) << 6 | Ft >>> 26, St = St + Gt | 0, l[b + 404 >> 2] = St, l[b + 548 >> 2] = St + ($e - U | 0), St = fn - (-67108864 & Ft) | 0, l[b + 400 >> 2] = St, l[b + 544 >> 2] = St + (Tt - Zt | 0), Zt = $n - (-33554432 & _n) | 0, St = De(Gn, Gn >> 31, 486662, 0), $n = ve, _n = De(wn, wn >> 31, 486662, 0), Ft = ve, wn = St, St = (St = (Ft = (fn = _n + 16777216 | 0) >>> 0 < 16777216 ? Ft + 1 | 0 : Ft) >> 25) + $n | 0, it = (it = (33554431 & Ft) << 7 | fn >>> 25) >>> 0 > (Ft = wn + it | 0) >>> 0 ? St + 1 | 0 : St, wn = it = (67108863 & (it = (St = Ft + 33554432 | 0) >>> 0 < 33554432 ? it + 1 | 0 : it)) << 6 | St >>> 26, it = it + Zt | 0, l[b + 396 >> 2] = it, l[b + 540 >> 2] = it + (Ct - ie | 0), St = Ft - (-67108864 & St) | 0, l[b + 392 >> 2] = St, l[b + 536 >> 2] = St + (ht - _e | 0), Gn = _n - (-33554432 & fn) | 0, it = De(er, er >> 31, 486662, 0), Ft = ve, $n = De(Zn, Zn >> 31, 486662, 0), St = ve, wn = it, it = (it = (St = (_n = $n + 16777216 | 0) >>> 0 < 16777216 ? St + 1 | 0 : St) >> 25) + Ft | 0, Ft = (St = (33554431 & St) << 7 | _n >>> 25) >>> 0 > (fn = wn + St | 0) >>> 0 ? it + 1 | 0 : it, it = Ft = (67108863 & (Ft = (St = fn + 33554432 | 0) >>> 0 < 33554432 ? Ft + 1 | 0 : Ft)) << 6 | St >>> 26, Ft = Ft + Gn | 0, l[b + 388 >> 2] = Ft, l[b + 532 >> 2] = Ft + (bt - he | 0), St = fn - (-67108864 & St) | 0, l[b + 384 >> 2] = St, l[b + 528 >> 2] = St + (mt - Be | 0), Gn = $n - (-33554432 & _n) | 0, St = De(Hn, Hn >> 31, 486662, 0), Ft = ve, _n = De(pn, pn >> 31, 486662, 0), it = ve, wn = St, Ft = (St = (it = (fn = _n + 16777216 | 0) >>> 0 < 16777216 ? it + 1 | 0 : it) >> 25) + Ft | 0, St = (it = wn + ($n = (33554431 & it) << 7 | fn >>> 25) | 0) >>> 0 < $n >>> 0 ? Ft + 1 | 0 : Ft, wn = St = (67108863 & (St = (Ft = it + 33554432 | 0) >>> 0 < 33554432 ? St + 1 | 0 : St)) << 6 | Ft >>> 26, St = St + Gn | 0, l[b + 380 >> 2] = St, l[b + 524 >> 2] = St + (ct - D | 0), St = it - (-67108864 & Ft) | 0, l[b + 376 >> 2] = St, l[b + 520 >> 2] = St + (je - ye | 0), fn = _n - (-33554432 & fn) | 0, Ft = De((33554431 & qn) << 7 | Kt >>> 25, qn >> 25, 19, 0), St = ve, it = Ft, Ft = De(Kn, Kn >> 31, 486662, 0), St = ve + St | 0, St = (it = it + Ft | 0) >>> 0 < Ft >>> 0 ? St + 1 | 0 : St, wn = St = (67108863 & (St = (Ft = it + 33554432 | 0) >>> 0 < 33554432 ? St + 1 | 0 : St)) << 6 | Ft >>> 26, St = St + fn | 0, l[b + 372 >> 2] = St, l[b + 516 >> 2] = St + (Ge - me | 0), St = it - (-67108864 & Ft) | 0, l[b + 368 >> 2] = St, l[b + 512 >> 2] = St + (Le - we | 0), In(St = b + 160 | 0, Ft = b + 512 | 0, Ft), In(b, Ft, St), Ot(Ft = b + 736 | 0, b), Ot(Ft, Ft), In(St = b + 960 | 0, b, Ft), Ot(Ft = b + 912 | 0, St), Ot(Ft, Ft), Ot(Ft, Ft), Ot(Ft, Ft), In(b + 864 | 0, St, Ft), St = l[b + 900 >> 2], l[b + 720 >> 2] = l[b + 896 >> 2], l[b + 724 >> 2] = St, St = l[b + 892 >> 2], l[b + 712 >> 2] = l[b + 888 >> 2], l[b + 716 >> 2] = St, St = l[b + 884 >> 2], l[b + 704 >> 2] = l[b + 880 >> 2], l[b + 708 >> 2] = St, St = l[b + 876 >> 2], l[b + 696 >> 2] = l[b + 872 >> 2], l[b + 700 >> 2] = St, St = l[b + 868 >> 2], l[b + 688 >> 2] = l[b + 864 >> 2], l[b + 692 >> 2] = St, Ot(it = b + 688 | 0, it), Ot(it, it), In(it, it, b), St = l[b + 724 >> 2], l[b + 672 >> 2] = l[b + 720 >> 2], l[b + 676 >> 2] = St, St = l[b + 716 >> 2], l[b + 664 >> 2] = l[b + 712 >> 2], l[b + 668 >> 2] = St, St = l[b + 708 >> 2], l[b + 656 >> 2] = l[b + 704 >> 2], l[b + 660 >> 2] = St, St = l[b + 700 >> 2], l[b + 648 >> 2] = l[b + 696 >> 2], l[b + 652 >> 2] = St, St = l[b + 692 >> 2], l[b + 640 >> 2] = l[b + 688 >> 2], l[b + 644 >> 2] = St, Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), In(it, it, St = b + 640 | 0), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), In(it, it, St), St = l[b + 724 >> 2], l[b + 624 >> 2] = l[b + 720 >> 2], l[b + 628 >> 2] = St, St = l[b + 716 >> 2], l[b + 616 >> 2] = l[b + 712 >> 2], l[b + 620 >> 2] = St, St = l[b + 708 >> 2], l[b + 608 >> 2] = l[b + 704 >> 2], l[b + 612 >> 2] = St, St = l[b + 700 >> 2], l[b + 600 >> 2] = l[b + 696 >> 2], l[b + 604 >> 2] = St, St = l[b + 692 >> 2], l[b + 592 >> 2] = l[b + 688 >> 2], l[b + 596 >> 2] = St, Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), In(it, it, Ft = b + 592 | 0), St = l[b + 724 >> 2], l[b + 624 >> 2] = l[b + 720 >> 2], l[b + 628 >> 2] = St, St = l[b + 716 >> 2], l[b + 616 >> 2] = l[b + 712 >> 2], l[b + 620 >> 2] = St, St = l[b + 708 >> 2], l[b + 608 >> 2] = l[b + 704 >> 2], l[b + 612 >> 2] = St, St = l[b + 700 >> 2], l[b + 600 >> 2] = l[b + 696 >> 2], l[b + 604 >> 2] = St, St = l[b + 692 >> 2], l[b + 592 >> 2] = l[b + 688 >> 2], l[b + 596 >> 2] = St, Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), Ot(it, it), In(it, it, Ft), St = l[b + 724 >> 2], l[b + 624 >> 2] = l[b + 720 >> 2], l[b + 628 >> 2] = St, St = l[b + 716 >> 2], l[b + 616 >> 2] = l[b + 712 >> 2], l[b + 620 >> 2] = St, St = l[b + 708 >> 2], l[b + 608 >> 2] = l[b + 704 >> 2], l[b + 612 >> 2] = St, St = l[b + 700 >> 2], l[b + 600 >> 2] = l[b + 696 >> 2], l[b + 604 >> 2] = St, St = l[b + 692 >> 2], l[b + 592 >> 2] = l[b + 688 >> 2], l[b + 596 >> 2] = St; Ot(St = b + 688 | 0, St), (0 | (g = g + 1 | 0)) != 120; )
                        ;
                      In(g = b + 688 | 0, g, b + 592 | 0), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), In(g, g, b + 640 | 0), Ot(g, g), Ot(g, g), Ot(g, g), In(g, g, b), Ot(g, g), Ei(b + 560 | 0, g), pn = l[b + 416 >> 2], Hn = l[b + 420 >> 2], Zn = l[b + 424 >> 2], er = l[b + 428 >> 2], wn = l[b + 432 >> 2], qn = l[b + 436 >> 2], it = l[b + 440 >> 2], Ft = l[b + 444 >> 2], St = l[b + 448 >> 2], Gn = (Kn = 0 - (1 & j[b + 561 | 0]) | 0) & (0 - (g = l[b + 452 >> 2]) ^ g) ^ g, l[b + 196 >> 2] = Gn, Kt = St ^ Kn & (St ^ 0 - St), l[b + 192 >> 2] = Kt, $n = Ft ^ Kn & (Ft ^ 0 - Ft), l[b + 188 >> 2] = $n, _n = it ^ Kn & (it ^ 0 - it), l[b + 184 >> 2] = _n, fn = qn ^ Kn & (qn ^ 0 - qn), l[b + 180 >> 2] = fn, qn = wn ^ Kn & (wn ^ 0 - wn), l[b + 176 >> 2] = qn, it = er ^ Kn & (er ^ 0 - er), l[b + 172 >> 2] = it, Ft = Zn ^ Kn & (Zn ^ 0 - Zn), l[b + 168 >> 2] = Ft, St = Hn ^ Kn & (Hn ^ 0 - Hn), l[b + 164 >> 2] = St, g = (pn ^ Kn & (pn ^ 0 - pn)) - (486662 & Kn) | 0, l[b + 160 >> 2] = g + 1, l[b + 772 >> 2] = Gn, l[b + 768 >> 2] = Kt, l[b + 764 >> 2] = $n, l[b + 760 >> 2] = _n, l[b + 756 >> 2] = fn, l[b + 752 >> 2] = qn, l[b + 748 >> 2] = it, l[b + 744 >> 2] = Ft, l[b + 740 >> 2] = St, l[b + 736 >> 2] = g - 1, Mn(b, St = b + 160 | 0), In(g = b + 960 | 0, b + 736 | 0, b), Ei(A, g), j[A + 31 | 0] = B[A + 31 | 0] | _, ds(St, A) && (Oa(), Xr()), g = l[b + 236 >> 2], l[b + 808 >> 2] = l[b + 232 >> 2], l[b + 812 >> 2] = g, g = l[b + 228 >> 2], l[b + 800 >> 2] = l[b + 224 >> 2], l[b + 804 >> 2] = g, g = l[b + 220 >> 2], l[b + 792 >> 2] = l[b + 216 >> 2], l[b + 796 >> 2] = g, g = l[b + 212 >> 2], l[b + 784 >> 2] = l[b + 208 >> 2], l[b + 788 >> 2] = g, g = l[b + 196 >> 2], l[b + 768 >> 2] = l[b + 192 >> 2], l[b + 772 >> 2] = g, g = l[b + 188 >> 2], l[b + 760 >> 2] = l[b + 184 >> 2], l[b + 764 >> 2] = g, g = l[b + 180 >> 2], l[b + 752 >> 2] = l[b + 176 >> 2], l[b + 756 >> 2] = g, g = l[b + 172 >> 2], l[b + 744 >> 2] = l[b + 168 >> 2], l[b + 748 >> 2] = g, g = l[b + 164 >> 2], l[b + 736 >> 2] = l[b + 160 >> 2], l[b + 740 >> 2] = g, g = l[b + 204 >> 2], l[b + 776 >> 2] = l[b + 200 >> 2], l[b + 780 >> 2] = g, g = l[b + 252 >> 2], l[b + 824 >> 2] = l[b + 248 >> 2], l[b + 828 >> 2] = g, g = l[b + 260 >> 2], l[b + 832 >> 2] = l[b + 256 >> 2], l[b + 836 >> 2] = g, g = l[b + 268 >> 2], l[b + 840 >> 2] = l[b + 264 >> 2], l[b + 844 >> 2] = g, g = l[b + 276 >> 2], l[b + 848 >> 2] = l[b + 272 >> 2], l[b + 852 >> 2] = g, g = l[b + 244 >> 2], l[b + 816 >> 2] = l[b + 240 >> 2], l[b + 820 >> 2] = g, Se(b, St = b + 736 | 0), In(St, b, fn = b + 120 | 0), In(_ = b + 776 | 0, it = b + 40 | 0, qn = b + 80 | 0), In(g = b + 816 | 0, qn, fn), Se(b, St), In(St, b, fn), In(_, it, qn), In(g, qn, fn), Se(b, St), In(Ft = b + 160 | 0, b, fn), In(St = b + 200 | 0, it, qn), In(g = b + 240 | 0, qn, fn), In(b + 280 | 0, b, it), Mn(it = b + 960 | 0, g), In(_ = b + 912 | 0, Ft, it), In(g = b + 864 | 0, St, it), Ei(A, g), Ei(b + 688 | 0, _), j[A + 31 | 0] = B[A + 31 | 0] ^ B[b + 688 | 0] << 7, st = b + 1008 | 0;
                    }
                    function In(A, g, _) {
                      var b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht, Ct, Tt, Gt, en, it, St, Ft, fn, _n, wn, $n, qn, Gn, Kn, Kt, pn, Hn, Zn, er, Zt, Sn, or, ur, Cr, Je, Ve, ut, Nn, cr, Rr, Ir, Pr, qr, ao, Fn, Wn, wt = 0, jt = 0, an = 0, Ar = 0, Tr = 0, zr = 0, Gr = 0, no = 0, so = 0, co = 0, lo = 0, yo = 0, Co = 0, Io = 0, ko = 0, Po = 0, $o = 0, xo = 0, Go = 0, Xo = 0, ei = 0, ti = 0, oi = 0, vi = 0;
                      wt = De(b = l[_ + 4 >> 2], we = b >> 31, $o = (mt = l[g + 20 >> 2]) << 1, Gn = $o >> 31), an = ve, jt = (Co = De(ko = l[_ >> 2], ie = ko >> 31, U = l[g + 24 >> 2], he = U >> 31)) + wt | 0, wt = ve + an | 0, wt = jt >>> 0 < Co >>> 0 ? wt + 1 | 0 : wt, so = De(D = l[_ + 8 >> 2], Ge = D >> 31, Co = l[g + 16 >> 2], me = Co >> 31), an = ve + wt | 0, an = (jt = so + jt | 0) >>> 0 < so >>> 0 ? an + 1 | 0 : an, wt = (so = De($e = l[_ + 12 >> 2], bt = $e >> 31, St = (ht = l[g + 12 >> 2]) << 1, Kn = St >> 31)) + jt | 0, jt = ve + an | 0, jt = wt >>> 0 < so >>> 0 ? jt + 1 | 0 : jt, an = (Io = De(je = l[_ + 16 >> 2], Ft = je >> 31, so = l[g + 8 >> 2], _e = so >> 31)) + wt | 0, wt = ve + jt | 0, wt = an >>> 0 < Io >>> 0 ? wt + 1 | 0 : wt, jt = an, an = De(Ct = l[_ + 20 >> 2], Kt = Ct >> 31, fn = (Tt = l[g + 4 >> 2]) << 1, pn = fn >> 31), wt = ve + wt | 0, wt = (jt = jt + an | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, Nn = no = l[_ + 24 >> 2], an = (co = De(no, Ve = no >> 31, Io = l[g >> 2], Be = Io >> 31)) + jt | 0, jt = ve + wt | 0, jt = an >>> 0 < co >>> 0 ? jt + 1 | 0 : jt, Hn = l[_ + 28 >> 2], wt = (co = De(yo = wr(Hn, 19), Gt = yo >> 31, _n = (en = l[g + 36 >> 2]) << 1, Zn = _n >> 31)) + an | 0, an = ve + jt | 0, an = wt >>> 0 < co >>> 0 ? an + 1 | 0 : an, Rr = l[_ + 32 >> 2], jt = (Gr = De(Ar = wr(Rr, 19), ct = Ar >> 31, co = l[g + 32 >> 2], ye = co >> 31)) + wt | 0, wt = ve + an | 0, wt = jt >>> 0 < Gr >>> 0 ? wt + 1 | 0 : wt, cr = l[_ + 36 >> 2], _ = De(Gr = wr(cr, 19), Le = Gr >> 31, wn = (it = l[g + 28 >> 2]) << 1, er = wn >> 31), wt = ve + wt | 0, Tr = g = _ + jt | 0, _ = g >>> 0 < _ >>> 0 ? wt + 1 | 0 : wt, g = De(Co, me, b, we), wt = ve, jt = De(ko, ie, mt, Zt = mt >> 31), an = ve + wt | 0, an = (g = jt + g | 0) >>> 0 < jt >>> 0 ? an + 1 | 0 : an, wt = De(D, Ge, ht, Sn = ht >> 31), jt = ve + an | 0, jt = (g = wt + g | 0) >>> 0 < wt >>> 0 ? jt + 1 | 0 : jt, an = De(so, _e, $e, bt), wt = ve + jt | 0, wt = (g = an + g | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, jt = De(je, Ft, Tt, or = Tt >> 31), wt = ve + wt | 0, wt = (g = jt + g | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, jt = De(Io, Be, Ct, Kt), wt = ve + wt | 0, wt = (g = jt + g | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, jt = De(no = wr(no, 19), $n = no >> 31, en, ur = en >> 31), an = ve + wt | 0, an = (g = jt + g | 0) >>> 0 < jt >>> 0 ? an + 1 | 0 : an, wt = De(co, ye, yo, Gt), jt = ve + an | 0, jt = (g = wt + g | 0) >>> 0 < wt >>> 0 ? jt + 1 | 0 : jt, an = De(Ar, ct, it, Cr = it >> 31), wt = ve + jt | 0, wt = (g = an + g | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, jt = De(Gr, Le, U, he), wt = ve + wt | 0, ti = g = jt + g | 0, Go = g >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, g = De(b, we, St, Kn), wt = ve, jt = De(ko, ie, Co, me), wt = ve + wt | 0, wt = (g = jt + g | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, jt = De(so, _e, D, Ge), an = ve + wt | 0, an = (g = jt + g | 0) >>> 0 < jt >>> 0 ? an + 1 | 0 : an, wt = De($e, bt, fn, pn), jt = ve + an | 0, jt = (g = wt + g | 0) >>> 0 < wt >>> 0 ? jt + 1 | 0 : jt, an = De(Io, Be, je, Ft), wt = ve + jt | 0, wt = (g = an + g | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, jt = De(qn = wr(Ct, 19), Je = qn >> 31, _n, Zn), wt = ve + wt | 0, wt = (g = jt + g | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, jt = De(co, ye, no, $n), wt = ve + wt | 0, wt = (g = jt + g | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, jt = De(yo, Gt, wn, er), an = ve + wt | 0, an = (g = jt + g | 0) >>> 0 < jt >>> 0 ? an + 1 | 0 : an, wt = De(Ar, ct, U, he), jt = ve + an | 0, jt = (g = wt + g | 0) >>> 0 < wt >>> 0 ? jt + 1 | 0 : jt, an = De(Gr, Le, $o, Gn), wt = ve + jt | 0, Ir = g = an + g | 0, Pr = wt = g >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, qr = g = g + 33554432 | 0, ao = wt = g >>> 0 < 33554432 ? wt + 1 | 0 : wt, an = (67108863 & wt) << 6 | g >>> 26, wt = (wt >> 26) + Go | 0, ti = g = an + ti | 0, wt = g >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, Fn = g = g + 16777216 | 0, wt = _ + (jt = (an = g >>> 0 < 16777216 ? wt + 1 | 0 : wt) >> 25) | 0, wt = (g = (an = (33554431 & an) << 7 | g >>> 25) + Tr | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, xo = _ = (jt = g) + 33554432 | 0, g = wt = _ >>> 0 < 33554432 ? wt + 1 | 0 : wt, l[A + 24 >> 2] = jt - (-67108864 & _), _ = De(b, we, fn, pn), wt = ve, jt = De(ko, ie, so, _e), an = ve + wt | 0, an = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? an + 1 | 0 : an, jt = (wt = _) + (_ = De(Io, Be, D, Ge)) | 0, wt = ve + an | 0, wt = _ >>> 0 > jt >>> 0 ? wt + 1 | 0 : wt, an = De(_ = wr($e, 19), Xo = _ >> 31, _n, Zn), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, an = (Tr = De(co, ye, Go = wr(je, 19), ut = Go >> 31)) + jt | 0, jt = ve + wt | 0, jt = an >>> 0 < Tr >>> 0 ? jt + 1 | 0 : jt, Tr = De(wn, er, qn, Je), wt = ve + jt | 0, wt = (an = Tr + an | 0) >>> 0 < Tr >>> 0 ? wt + 1 | 0 : wt, jt = (Tr = De(U, he, no, $n)) + an | 0, an = ve + wt | 0, an = jt >>> 0 < Tr >>> 0 ? an + 1 | 0 : an, Tr = De(yo, Gt, $o, Gn), wt = ve + an | 0, wt = (jt = Tr + jt | 0) >>> 0 < Tr >>> 0 ? wt + 1 | 0 : wt, an = De(Ar, ct, Co, me), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, an = (Tr = De(Gr, Le, St, Kn)) + jt | 0, jt = ve + wt | 0, lo = an, oi = an >>> 0 < Tr >>> 0 ? jt + 1 | 0 : jt, wt = De(Io, Be, b, we), jt = ve, an = (Tr = De(ko, ie, Tt, or)) + wt | 0, wt = ve + jt | 0, wt = an >>> 0 < Tr >>> 0 ? wt + 1 | 0 : wt, Tr = jt = wr(D, 19), jt = (zr = De(jt, ei = jt >> 31, en, ur)) + an | 0, an = ve + wt | 0, an = jt >>> 0 < zr >>> 0 ? an + 1 | 0 : an, zr = De(co, ye, _, Xo), wt = ve + an | 0, wt = (jt = zr + jt | 0) >>> 0 < zr >>> 0 ? wt + 1 | 0 : wt, an = De(Go, ut, it, Cr), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, an = (zr = De(U, he, qn, Je)) + jt | 0, jt = ve + wt | 0, jt = an >>> 0 < zr >>> 0 ? jt + 1 | 0 : jt, zr = De(no, $n, mt, Zt), wt = ve + jt | 0, wt = (an = zr + an | 0) >>> 0 < zr >>> 0 ? wt + 1 | 0 : wt, jt = (zr = De(Co, me, yo, Gt)) + an | 0, an = ve + wt | 0, an = jt >>> 0 < zr >>> 0 ? an + 1 | 0 : an, zr = De(Ar, ct, ht, Sn), wt = ve + an | 0, wt = (jt = zr + jt | 0) >>> 0 < zr >>> 0 ? wt + 1 | 0 : wt, an = De(Gr, Le, so, _e), wt = ve + wt | 0, vi = jt = an + jt | 0, zr = jt >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, wt = De(wt = wr(b, 19), wt >> 31, _n, Zn), jt = ve, an = De(ko, ie, Io, Be), jt = ve + jt | 0, jt = (wt = an + wt | 0) >>> 0 < an >>> 0 ? jt + 1 | 0 : jt, an = (Tr = De(co, ye, Tr, ei)) + wt | 0, wt = ve + jt | 0, _ = (jt = De(_, Xo, wn, er)) + an | 0, an = ve + (an >>> 0 < Tr >>> 0 ? wt + 1 | 0 : wt) | 0, an = _ >>> 0 < jt >>> 0 ? an + 1 | 0 : an, jt = De(U, he, Go, ut), wt = ve + an | 0, wt = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, jt = De($o, Gn, qn, Je), wt = ve + wt | 0, wt = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, an = De(Co, me, no, $n), jt = ve + wt | 0, jt = (_ = an + _ | 0) >>> 0 < an >>> 0 ? jt + 1 | 0 : jt, an = De(yo, Gt, St, Kn), wt = ve + jt | 0, wt = (_ = an + _ | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, jt = De(Ar, ct, so, _e), an = ve + wt | 0, an = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? an + 1 | 0 : an, jt = De(Gr, Le, fn, pn), wt = ve + an | 0, Tr = _ = jt + _ | 0, Xo = wt = _ >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, ei = _ = _ + 33554432 | 0, Wn = wt = _ >>> 0 < 33554432 ? wt + 1 | 0 : wt, jt = (an = wt >> 26) + zr | 0, zr = _ = (wt = (67108863 & wt) << 6 | _ >>> 26) + vi | 0, wt = jt = _ >>> 0 < wt >>> 0 ? jt + 1 | 0 : jt, vi = _ = _ + 16777216 | 0, jt = (33554431 & (wt = _ >>> 0 < 16777216 ? wt + 1 | 0 : wt)) << 7 | _ >>> 25, wt = (wt >> 25) + oi | 0, wt = (_ = jt + lo | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, oi = jt = (an = _) + 33554432 | 0, _ = wt = jt >>> 0 < 33554432 ? wt + 1 | 0 : wt, l[A + 8 >> 2] = an - (-67108864 & jt), wt = De(U, he, b, we), an = ve, jt = (lo = De(ko, ie, it, Cr)) + wt | 0, wt = ve + an | 0, wt = jt >>> 0 < lo >>> 0 ? wt + 1 | 0 : wt, an = De(D, Ge, mt, Zt), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, an = De(Co, me, $e, bt), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, lo = De(je, Ft, ht, Sn), an = ve + wt | 0, an = (jt = lo + jt | 0) >>> 0 < lo >>> 0 ? an + 1 | 0 : an, wt = (lo = De(so, _e, Ct, Kt)) + jt | 0, jt = ve + an | 0, jt = wt >>> 0 < lo >>> 0 ? jt + 1 | 0 : jt, an = (lo = De(Tt, or, Nn, Ve)) + wt | 0, wt = ve + jt | 0, wt = an >>> 0 < lo >>> 0 ? wt + 1 | 0 : wt, jt = an, an = De(Io, Be, Hn, lo = Hn >> 31), wt = ve + wt | 0, wt = (jt = jt + an | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, an = De(Ar, ct, en, ur), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, Po = De(Gr, Le, co, ye), an = ve + wt | 0, wt = g >> 26, g = (xo = (67108863 & g) << 6 | xo >>> 26) + (jt = Po + jt | 0) | 0, jt = wt + (jt >>> 0 < Po >>> 0 ? an + 1 | 0 : an) | 0, wt = (an = g) >>> 0 < xo >>> 0 ? jt + 1 | 0 : jt, xo = jt = an + 16777216 | 0, g = wt = jt >>> 0 < 16777216 ? wt + 1 | 0 : wt, l[A + 28 >> 2] = an - (-33554432 & jt), wt = De(so, _e, b, we), jt = ve, Po = De(ko, ie, ht, Sn), an = ve + jt | 0, an = (wt = Po + wt | 0) >>> 0 < Po >>> 0 ? an + 1 | 0 : an, Po = De(D, Ge, Tt, or), jt = ve + an | 0, jt = (wt = Po + wt | 0) >>> 0 < Po >>> 0 ? jt + 1 | 0 : jt, an = (Po = De(Io, Be, $e, bt)) + wt | 0, wt = ve + jt | 0, wt = an >>> 0 < Po >>> 0 ? wt + 1 | 0 : wt, jt = an, an = De(Go, ut, en, ur), wt = ve + wt | 0, wt = (jt = jt + an | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, an = De(co, ye, qn, Je), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, jt = (no = De(no, $n, it, Cr)) + jt | 0, an = ve + wt | 0, wt = (yo = De(U, he, yo, Gt)) + jt | 0, jt = ve + (jt >>> 0 < no >>> 0 ? an + 1 | 0 : an) | 0, an = (Ar = De(Ar, ct, mt, Zt)) + wt | 0, wt = ve + (wt >>> 0 < yo >>> 0 ? jt + 1 | 0 : jt) | 0, wt = an >>> 0 < Ar >>> 0 ? wt + 1 | 0 : wt, jt = an, an = De(Gr, Le, Co, me), wt = ve + wt | 0, Ar = jt = jt + an | 0, wt = (wt = jt >>> 0 < an >>> 0 ? wt + 1 | 0 : wt) + (jt = _ >> 26) | 0, an = (jt = _ = Ar + (an = (67108863 & _) << 6 | oi >>> 26) | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, yo = wt = jt + 16777216 | 0, _ = an = wt >>> 0 < 16777216 ? an + 1 | 0 : an, l[A + 12 >> 2] = jt - (-33554432 & wt), wt = De(b, we, wn, er), an = ve, jt = (Ar = De(ko, ie, co, ye)) + wt | 0, wt = ve + an | 0, wt = jt >>> 0 < Ar >>> 0 ? wt + 1 | 0 : wt, an = De(U, he, D, Ge), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, Ar = De($e, bt, $o, Gn), an = ve + wt | 0, an = (jt = Ar + jt | 0) >>> 0 < Ar >>> 0 ? an + 1 | 0 : an, wt = (Ar = De(Co, me, je, Ft)) + jt | 0, jt = ve + an | 0, jt = wt >>> 0 < Ar >>> 0 ? jt + 1 | 0 : jt, an = (Ar = De(St, Kn, Ct, Kt)) + wt | 0, wt = ve + jt | 0, wt = an >>> 0 < Ar >>> 0 ? wt + 1 | 0 : wt, jt = an, an = De(so, _e, Nn, Ve), wt = ve + wt | 0, wt = (jt = jt + an | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, an = De(Hn, lo, fn, pn), wt = ve + wt | 0, wt = (jt = an + jt | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, jt = ($o = De(Io, Be, Ar = Rr, no = Ar >> 31)) + jt | 0, an = ve + wt | 0, wt = (Gr = De(Gr, Le, _n, Zn)) + jt | 0, jt = ve + (jt >>> 0 < $o >>> 0 ? an + 1 | 0 : an) | 0, jt = wt >>> 0 < Gr >>> 0 ? jt + 1 | 0 : jt, Gr = wt, wt = (wt = g >> 25) + jt | 0, wt = (g = Gr + (an = (33554431 & g) << 7 | xo >>> 25) | 0) >>> 0 < an >>> 0 ? wt + 1 | 0 : wt, Gr = jt = (an = g) + 33554432 | 0, g = wt = jt >>> 0 < 33554432 ? wt + 1 | 0 : wt, l[A + 32 >> 2] = an - (-67108864 & jt), jt = _ >> 25, _ = (yo = (33554431 & _) << 7 | yo >>> 25) + (Ir - (wt = -67108864 & qr) | 0) | 0, wt = jt + (Pr - ((wt >>> 0 > Ir >>> 0) + ao | 0) | 0) | 0, wt = _ >>> 0 < yo >>> 0 ? wt + 1 | 0 : wt, xo = wt = (67108863 & (wt = (_ = (jt = _) + 33554432 | 0) >>> 0 < 33554432 ? wt + 1 | 0 : wt)) << 6 | _ >>> 26, wt = wt + (an = ti - (-33554432 & Fn) | 0) | 0, l[A + 20 >> 2] = wt, l[A + 16 >> 2] = jt - (-67108864 & _), _ = De(co, ye, b, we), wt = ve, jt = De(ko, ie, en, ur), wt = ve + wt | 0, wt = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, an = De(D, Ge, it, Cr), jt = ve + wt | 0, jt = (_ = an + _ | 0) >>> 0 < an >>> 0 ? jt + 1 | 0 : jt, wt = De(U, he, $e, bt), an = ve + jt | 0, an = (_ = wt + _ | 0) >>> 0 < wt >>> 0 ? an + 1 | 0 : an, jt = De(je, Ft, mt, Zt), wt = ve + an | 0, wt = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, jt = De(Co, me, Ct, Kt), wt = ve + wt | 0, wt = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, jt = De(ht, Sn, Nn, Ve), wt = ve + wt | 0, wt = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt, an = De(so, _e, Hn, lo), jt = ve + wt | 0, jt = (_ = an + _ | 0) >>> 0 < an >>> 0 ? jt + 1 | 0 : jt, wt = De(Ar, no, Tt, or), an = ve + jt | 0, an = (_ = wt + _ | 0) >>> 0 < wt >>> 0 ? an + 1 | 0 : an, jt = De(Io, Be, cr, cr >> 31), wt = ve + an | 0, wt = (wt = (_ = jt + _ | 0) >>> 0 < jt >>> 0 ? wt + 1 | 0 : wt) + (jt = g >> 26) | 0, wt = (g = (an = _) + (_ = (67108863 & g) << 6 | Gr >>> 26) | 0) >>> 0 < _ >>> 0 ? wt + 1 | 0 : wt, wt = (g = (_ = g) + 16777216 | 0) >>> 0 < 16777216 ? wt + 1 | 0 : wt, l[A + 36 >> 2] = _ - (-33554432 & g), an = zr - (-33554432 & vi) | 0, jt = Tr - (_ = -67108864 & ei) | 0, ko = Xo - ((_ >>> 0 > Tr >>> 0) + Wn | 0) | 0, g = (_ = De((33554431 & (_ = wt)) << 7 | g >>> 25, wt >>= 25, 19, 0)) + jt | 0, jt = ve + ko | 0, wt = g >>> 0 < _ >>> 0 ? jt + 1 | 0 : jt, jt = wt = (67108863 & (wt = (g = (_ = g) + 33554432 | 0) >>> 0 < 33554432 ? wt + 1 | 0 : wt)) << 6 | g >>> 26, wt = wt + an | 0, l[A + 4 >> 2] = wt, l[A >> 2] = _ - (-67108864 & g);
                    }
                    function Ys(A, g, _, b) {
                      var U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0;
                      for (U = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, l[_ >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, l[_ + 4 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, l[_ + 8 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, l[_ + 12 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, l[_ + 16 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, l[_ + 20 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, l[_ + 24 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, l[_ + 28 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 32 | 0] | B[g + 33 | 0] << 8 | B[g + 34 | 0] << 16 | B[g + 35 | 0] << 24, l[_ + 32 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 36 | 0] | B[g + 37 | 0] << 8 | B[g + 38 | 0] << 16 | B[g + 39 | 0] << 24, l[_ + 36 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 40 | 0] | B[g + 41 | 0] << 8 | B[g + 42 | 0] << 16 | B[g + 43 | 0] << 24, l[_ + 40 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 44 | 0] | B[g + 45 | 0] << 8 | B[g + 46 | 0] << 16 | B[g + 47 | 0] << 24, l[_ + 44 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 48 | 0] | B[g + 49 | 0] << 8 | B[g + 50 | 0] << 16 | B[g + 51 | 0] << 24, l[_ + 48 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 52 | 0] | B[g + 53 | 0] << 8 | B[g + 54 | 0] << 16 | B[g + 55 | 0] << 24, l[_ + 52 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, U = B[g + 56 | 0] | B[g + 57 | 0] << 8 | B[g + 58 | 0] << 16 | B[g + 59 | 0] << 24, l[_ + 56 >> 2] = U << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, g = B[g + 60 | 0] | B[g + 61 | 0] << 8 | B[g + 62 | 0] << 16 | B[g + 63 | 0] << 24, l[_ + 60 >> 2] = g << 24 | (65280 & g) << 8 | g >>> 8 & 65280 | g >>> 24, g = l[A + 28 >> 2], l[b + 24 >> 2] = l[A + 24 >> 2], l[b + 28 >> 2] = g, g = l[A + 20 >> 2], l[b + 16 >> 2] = l[A + 16 >> 2], l[b + 20 >> 2] = g, g = l[A + 12 >> 2], l[b + 8 >> 2] = l[A + 8 >> 2], l[b + 12 >> 2] = g, g = l[A + 4 >> 2], l[b >> 2] = l[A >> 2], l[b + 4 >> 2] = g; D = l[b + 28 >> 2], U = (g = ht << 2) + _ | 0, $e = l[b + 16 >> 2], me = l[U >> 2] + (tn($e, 26) ^ tn($e, 21) ^ tn($e, 7)) | 0, Be = (D = ((ie = l[g + 35360 >> 2] + me | 0) + ($e & ((me = l[b + 24 >> 2]) ^ (we = l[b + 20 >> 2])) ^ me) | 0) + D | 0) + l[b + 12 >> 2] | 0, l[b + 12 >> 2] = Be, D = (Ge = D + (tn(ie = l[b >> 2], 30) ^ tn(ie, 19) ^ tn(ie, 10)) | 0) + (ie & ((ye = l[b + 8 >> 2]) | (he = l[b + 4 >> 2])) | he & ye) | 0, l[b + 28 >> 2] = D, ye = (Ge = ye) + (me = (l[(je = (ye = 4 | g) + _ | 0) >> 2] + ((me + (we ^ Be & (we ^ $e)) | 0) + (tn(Be, 26) ^ tn(Be, 21) ^ tn(Be, 7)) | 0) | 0) + l[ye + 35360 >> 2] | 0) | 0, l[b + 8 >> 2] = ye, me = (me + (D & (ie | he) | ie & he) | 0) + (tn(D, 30) ^ tn(D, 19) ^ tn(D, 10)) | 0, l[b + 24 >> 2] = me, we = (_e = (((we + l[(bt = (_e = 8 | g) + _ | 0) >> 2] | 0) + l[_e + 35360 >> 2] | 0) + ($e ^ ye & (Be ^ $e)) | 0) + (tn(ye, 26) ^ tn(ye, 21) ^ tn(ye, 7)) | 0) + ((me & (D | ie) | D & ie) + (tn(me, 30) ^ tn(me, 19) ^ tn(me, 10)) | 0) | 0, l[b + 20 >> 2] = we, he = _e + he | 0, l[b + 4 >> 2] = he, $e = (_e = ((($e + l[(Ct = (_e = 12 | g) + _ | 0) >> 2] | 0) + l[_e + 35360 >> 2] | 0) + (Be ^ he & (ye ^ Be)) | 0) + (tn(he, 26) ^ tn(he, 21) ^ tn(he, 7)) | 0) + ((we & (D | me) | D & me) + (tn(we, 30) ^ tn(we, 19) ^ tn(we, 10)) | 0) | 0, l[b + 16 >> 2] = $e, ie = _e + ie | 0, l[b >> 2] = ie, Be = (_e = ((((Ge = Be) + l[(Tt = (Be = 16 | g) + _ | 0) >> 2] | 0) + l[Be + 35360 >> 2] | 0) + (ye ^ ie & (he ^ ye)) | 0) + (tn(ie, 26) ^ tn(ie, 21) ^ tn(ie, 7)) | 0) + (($e & (me | we) | me & we) + (tn($e, 30) ^ tn($e, 19) ^ tn($e, 10)) | 0) | 0, l[b + 12 >> 2] = Be, _e = _e + D | 0, l[b + 28 >> 2] = _e, D = (ye = (((ye + l[(Gt = (D = 20 | g) + _ | 0) >> 2] | 0) + l[D + 35360 >> 2] | 0) + (he ^ _e & (ie ^ he)) | 0) + (tn(_e, 26) ^ tn(_e, 21) ^ tn(_e, 7)) | 0) + ((Be & (we | $e) | we & $e) + (tn(Be, 30) ^ tn(Be, 19) ^ tn(Be, 10)) | 0) | 0, l[b + 8 >> 2] = D, ye = me + ye | 0, l[b + 24 >> 2] = ye, me = (he = (((he + l[(en = (me = 24 | g) + _ | 0) >> 2] | 0) + l[me + 35360 >> 2] | 0) + (ie ^ ye & (_e ^ ie)) | 0) + (tn(ye, 26) ^ tn(ye, 21) ^ tn(ye, 7)) | 0) + ((D & (Be | $e) | Be & $e) + (tn(D, 30) ^ tn(D, 19) ^ tn(D, 10)) | 0) | 0, l[b + 4 >> 2] = me, he = he + we | 0, l[b + 20 >> 2] = he, we = (ie = (((ie + l[(it = (we = 28 | g) + _ | 0) >> 2] | 0) + l[we + 35360 >> 2] | 0) + (_e ^ he & (_e ^ ye)) | 0) + (tn(he, 26) ^ tn(he, 21) ^ tn(he, 7)) | 0) + ((me & (D | Be) | D & Be) + (tn(me, 30) ^ tn(me, 19) ^ tn(me, 10)) | 0) | 0, l[b >> 2] = we, ie = ie + $e | 0, l[b + 16 >> 2] = ie, $e = (_e = (((_e + l[(St = ($e = 32 | g) + _ | 0) >> 2] | 0) + l[$e + 35360 >> 2] | 0) + (ye ^ ie & (he ^ ye)) | 0) + (tn(ie, 26) ^ tn(ie, 21) ^ tn(ie, 7)) | 0) + ((we & (D | me) | D & me) + (tn(we, 30) ^ tn(we, 19) ^ tn(we, 10)) | 0) | 0, l[b + 28 >> 2] = $e, _e = _e + Be | 0, l[b + 12 >> 2] = _e, Be = (ye = (((ye + l[(Ft = (Be = 36 | g) + _ | 0) >> 2] | 0) + l[Be + 35360 >> 2] | 0) + (he ^ _e & (ie ^ he)) | 0) + (tn(_e, 26) ^ tn(_e, 21) ^ tn(_e, 7)) | 0) + (($e & (me | we) | me & we) + (tn($e, 30) ^ tn($e, 19) ^ tn($e, 10)) | 0) | 0, l[b + 24 >> 2] = Be, ye = D + ye | 0, l[b + 8 >> 2] = ye, D = (he = (((he + l[(fn = (D = 40 | g) + _ | 0) >> 2] | 0) + l[D + 35360 >> 2] | 0) + (ie ^ ye & (_e ^ ie)) | 0) + (tn(ye, 26) ^ tn(ye, 21) ^ tn(ye, 7)) | 0) + ((Be & (we | $e) | we & $e) + (tn(Be, 30) ^ tn(Be, 19) ^ tn(Be, 10)) | 0) | 0, l[b + 20 >> 2] = D, he = me + he | 0, l[b + 4 >> 2] = he, Ge = (me = 44 | g) + _ | 0, me = (ie = ((ie + (l[me + 35360 >> 2] + l[Ge >> 2] | 0) | 0) + (_e ^ he & (_e ^ ye)) | 0) + (tn(he, 26) ^ tn(he, 21) ^ tn(he, 7)) | 0) + ((D & (Be | $e) | Be & $e) + (tn(D, 30) ^ tn(D, 19) ^ tn(D, 10)) | 0) | 0, l[b + 16 >> 2] = me, we = ie + we | 0, l[b >> 2] = we, mt = (ie = 48 | g) + _ | 0, ie = (_e = ((_e + (l[ie + 35360 >> 2] + l[mt >> 2] | 0) | 0) + (ye ^ we & (he ^ ye)) | 0) + (tn(we, 26) ^ tn(we, 21) ^ tn(we, 7)) | 0) + ((me & (D | Be) | D & Be) + (tn(me, 30) ^ tn(me, 19) ^ tn(me, 10)) | 0) | 0, l[b + 12 >> 2] = ie, $e = _e + $e | 0, l[b + 28 >> 2] = $e, ct = (_e = 52 | g) + _ | 0, ye = (_e = (((l[_e + 35360 >> 2] + l[ct >> 2] | 0) + ye | 0) + (he ^ $e & (he ^ we)) | 0) + (tn($e, 26) ^ tn($e, 21) ^ tn($e, 7)) | 0) + ((ie & (D | me) | D & me) + (tn(ie, 30) ^ tn(ie, 19) ^ tn(ie, 10)) | 0) | 0, l[b + 8 >> 2] = ye, Be = _e + Be | 0, l[b + 24 >> 2] = Be, _e = (Le = 56 | g) + _ | 0, he = (Le = (((l[Le + 35360 >> 2] + l[_e >> 2] | 0) + he | 0) + (we ^ Be & (we ^ $e)) | 0) + (tn(Be, 26) ^ tn(Be, 21) ^ tn(Be, 7)) | 0) + ((ye & (me | ie) | me & ie) + (tn(ye, 30) ^ tn(ye, 19) ^ tn(ye, 10)) | 0) | 0, l[b + 4 >> 2] = he, D = D + Le | 0, l[b + 20 >> 2] = D, Le = (g |= 60) + _ | 0, D = (g = ((we + (l[g + 35360 >> 2] + l[Le >> 2] | 0) | 0) + ($e ^ D & (Be ^ $e)) | 0) + (tn(D, 26) ^ tn(D, 21) ^ tn(D, 7)) | 0) + ((he & (ie | ye) | ie & ye) + (tn(he, 30) ^ tn(he, 19) ^ tn(he, 10)) | 0) | 0, l[b >> 2] = D, l[b + 16 >> 2] = g + me, (0 | ht) != 48; )
                        we = l[Ft >> 2], ht = ht + 16 | 0, g = l[_e >> 2], D = (ie = l[U >> 2] + (we + (tn(g, 15) ^ tn(g, 13) ^ g >>> 10) | 0) | 0) + (tn(me = l[je >> 2], 25) ^ tn(me, 14) ^ me >>> 3) | 0, l[(ht << 2) + _ >> 2] = D, Be = (he = (ie = ($e = l[fn >> 2]) + me | 0) + (tn(me = l[Le >> 2], 15) ^ tn(me, 13) ^ me >>> 10) | 0) + (tn(ie = l[bt >> 2], 25) ^ tn(ie, 14) ^ ie >>> 3) | 0, l[U + 68 >> 2] = Be, ye = (Ge = ((he = ie) + (ie = l[Ge >> 2]) | 0) + (tn(D, 15) ^ tn(D, 13) ^ D >>> 10) | 0) + (tn(he = l[Ct >> 2], 25) ^ tn(he, 14) ^ he >>> 3) | 0, l[U + 72 >> 2] = ye, _e = (Le = ((Ge = he) + (he = l[mt >> 2]) | 0) + (tn(Be, 15) ^ tn(Be, 13) ^ Be >>> 10) | 0) + (tn(Ge = l[Tt >> 2], 25) ^ tn(Ge, 14) ^ Ge >>> 3) | 0, l[U + 76 >> 2] = _e, mt = (Le = ((Le = Ge) + (Ge = l[ct >> 2]) | 0) + (tn(ye, 15) ^ tn(ye, 13) ^ ye >>> 10) | 0) + (tn(ct = l[Gt >> 2], 25) ^ tn(ct, 14) ^ ct >>> 3) | 0, l[U + 80 >> 2] = mt, ct = (je = (g + ct | 0) + (tn(_e, 15) ^ tn(_e, 13) ^ _e >>> 10) | 0) + (tn(Le = l[en >> 2], 25) ^ tn(Le, 14) ^ Le >>> 3) | 0, l[U + 84 >> 2] = ct, Le = ((me + Le | 0) + (tn(bt = l[it >> 2], 25) ^ tn(bt, 14) ^ bt >>> 3) | 0) + (tn(mt, 15) ^ tn(mt, 13) ^ mt >>> 10) | 0, l[U + 88 >> 2] = Le, Be = ((je = l[St >> 2]) + (Be + (tn(we, 25) ^ tn(we, 14) ^ we >>> 3) | 0) | 0) + (tn(Le, 15) ^ tn(Le, 13) ^ Le >>> 10) | 0, l[U + 96 >> 2] = Be, je = ((D + bt | 0) + (tn(je, 25) ^ tn(je, 14) ^ je >>> 3) | 0) + (tn(ct, 15) ^ tn(ct, 13) ^ ct >>> 10) | 0, l[U + 92 >> 2] = je, _e = (_e + ($e + (tn(ie, 25) ^ tn(ie, 14) ^ ie >>> 3) | 0) | 0) + (tn(Be, 15) ^ tn(Be, 13) ^ Be >>> 10) | 0, l[U + 104 >> 2] = _e, we = (ye + (we + (tn($e, 25) ^ tn($e, 14) ^ $e >>> 3) | 0) | 0) + (tn(je, 15) ^ tn(je, 13) ^ je >>> 10) | 0, l[U + 100 >> 2] = we, $e = (ct + (he + (tn(Ge, 25) ^ tn(Ge, 14) ^ Ge >>> 3) | 0) | 0) + (tn(_e, 15) ^ tn(_e, 13) ^ _e >>> 10) | 0, l[U + 112 >> 2] = $e, we = (mt + (ie + (tn(he, 25) ^ tn(he, 14) ^ he >>> 3) | 0) | 0) + (tn(we, 15) ^ tn(we, 13) ^ we >>> 10) | 0, l[U + 108 >> 2] = we, _n = U, wn = (je + (g + (tn(me, 25) ^ tn(me, 14) ^ me >>> 3) | 0) | 0) + (tn($e, 15) ^ tn($e, 13) ^ $e >>> 10) | 0, l[_n + 120 >> 2] = wn, g = (Le + (Ge + (tn(g, 25) ^ tn(g, 14) ^ g >>> 3) | 0) | 0) + (tn(we, 15) ^ tn(we, 13) ^ we >>> 10) | 0, l[U + 116 >> 2] = g, _n = U, wn = (Be + (me + (tn(D, 25) ^ tn(D, 14) ^ D >>> 3) | 0) | 0) + (tn(g, 15) ^ tn(g, 13) ^ g >>> 10) | 0, l[_n + 124 >> 2] = wn;
                      l[A >> 2] = D + l[A >> 2], l[A + 4 >> 2] = l[A + 4 >> 2] + l[b + 4 >> 2], l[A + 8 >> 2] = l[A + 8 >> 2] + l[b + 8 >> 2], l[A + 12 >> 2] = l[A + 12 >> 2] + l[b + 12 >> 2], l[A + 16 >> 2] = l[A + 16 >> 2] + l[b + 16 >> 2], l[A + 20 >> 2] = l[A + 20 >> 2] + l[b + 20 >> 2], l[A + 24 >> 2] = l[A + 24 >> 2] + l[b + 24 >> 2], l[A + 28 >> 2] = l[A + 28 >> 2] + l[b + 28 >> 2];
                    }
                    function Zs(A, g, _) {
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0;
                      for (st = b = st - 4032 | 0, Bi(b + 160 | 0, _), ie = l[_ + 8 >> 2], D = l[_ + 12 >> 2], me = l[_ + 16 >> 2], Be = l[_ + 20 >> 2], Le = l[_ + 24 >> 2], ye = l[_ + 28 >> 2], $e = l[_ >> 2], Ge = l[_ + 4 >> 2], ct = l[_ + 36 >> 2], l[b + 3840 >> 2] = l[_ + 32 >> 2], l[b + 3844 >> 2] = ct, l[b + 3832 >> 2] = Le, l[b + 3836 >> 2] = ye, l[b + 3824 >> 2] = me, l[b + 3828 >> 2] = Be, l[b + 3816 >> 2] = ie, l[b + 3820 >> 2] = D, l[b + 3808 >> 2] = $e, l[b + 3812 >> 2] = Ge, Le = l[_ + 40 >> 2], ye = l[_ + 44 >> 2], $e = l[_ + 48 >> 2], Ge = l[_ + 52 >> 2], Be = l[_ + 56 >> 2], ct = l[_ + 60 >> 2], me = l[(ie = _ - -64 | 0) >> 2], U = l[ie + 4 >> 2], D = l[_ + 76 >> 2], l[(ie = b + 3880 | 0) >> 2] = l[_ + 72 >> 2], l[ie + 4 >> 2] = D, l[(D = b + 3872 | 0) >> 2] = me, l[D + 4 >> 2] = U, l[(me = b + 3864 | 0) >> 2] = Be, l[me + 4 >> 2] = ct, l[(Be = b + 3856 | 0) >> 2] = $e, l[Be + 4 >> 2] = Ge, l[b + 3848 >> 2] = Le, l[b + 3852 >> 2] = ye, ct = l[_ + 80 >> 2], U = l[_ + 84 >> 2], he = l[_ + 88 >> 2], _e = l[_ + 92 >> 2], Ge = l[_ + 96 >> 2], we = l[_ + 100 >> 2], $e = l[_ + 104 >> 2], je = l[_ + 108 >> 2], ye = l[_ + 116 >> 2], l[(Le = b + 3920 | 0) >> 2] = l[_ + 112 >> 2], l[Le + 4 >> 2] = ye, l[(ye = b + 3912 | 0) >> 2] = $e, l[ye + 4 >> 2] = je, l[($e = b + 3904 | 0) >> 2] = Ge, l[$e + 4 >> 2] = we, l[(Ge = b + 3896 | 0) >> 2] = he, l[Ge + 4 >> 2] = _e, l[b + 3888 >> 2] = ct, l[b + 3892 >> 2] = U, Se(U = b + 3528 | 0, ct = b + 3808 | 0), In(he = b + 2408 | 0, U, _e = b + 3648 | 0), In(b + 2448 | 0, we = b + 3568 | 0, je = b + 3608 | 0), In(b + 2488 | 0, je, _e), In(b + 2528 | 0, U, we), Bi(_e = b + 320 | 0, he), Si(U = b + 3368 | 0, _, _e), In(he = b + 2248 | 0, U, _e = b + 3488 | 0), In(b + 2288 | 0, we = b + 3408 | 0, je = b + 3448 | 0), In(b + 2328 | 0, je, _e), In(b + 2368 | 0, U, we), Bi(b + 480 | 0, he), he = l[4 + (U = b + 2480 | 0) >> 2], l[ie >> 2] = l[U >> 2], l[ie + 4 >> 2] = he, he = l[4 + (U = b + 2472 | 0) >> 2], l[D >> 2] = l[U >> 2], l[D + 4 >> 2] = he, he = l[4 + (U = b + 2464 | 0) >> 2], l[me >> 2] = l[U >> 2], l[me + 4 >> 2] = he, he = l[4 + (U = b + 2456 | 0) >> 2], l[Be >> 2] = l[U >> 2], l[Be + 4 >> 2] = he, U = l[b + 2444 >> 2], l[b + 3840 >> 2] = l[b + 2440 >> 2], l[b + 3844 >> 2] = U, U = l[b + 2436 >> 2], l[b + 3832 >> 2] = l[b + 2432 >> 2], l[b + 3836 >> 2] = U, U = l[b + 2428 >> 2], l[b + 3824 >> 2] = l[b + 2424 >> 2], l[b + 3828 >> 2] = U, U = l[b + 2420 >> 2], l[b + 3816 >> 2] = l[b + 2416 >> 2], l[b + 3820 >> 2] = U, U = l[b + 2412 >> 2], l[b + 3808 >> 2] = l[b + 2408 >> 2], l[b + 3812 >> 2] = U, U = l[b + 2452 >> 2], l[b + 3848 >> 2] = l[b + 2448 >> 2], l[b + 3852 >> 2] = U, he = l[4 + (U = b + 2496 | 0) >> 2], l[Ge >> 2] = l[U >> 2], l[Ge + 4 >> 2] = he, he = l[4 + (U = b + 2504 | 0) >> 2], l[$e >> 2] = l[U >> 2], l[$e + 4 >> 2] = he, he = l[4 + (U = b + 2512 | 0) >> 2], l[ye >> 2] = l[U >> 2], l[ye + 4 >> 2] = he, he = l[4 + (U = b + 2520 | 0) >> 2], l[Le >> 2] = l[U >> 2], l[Le + 4 >> 2] = he, U = l[b + 2492 >> 2], l[b + 3888 >> 2] = l[b + 2488 >> 2], l[b + 3892 >> 2] = U, Se(U = b + 3208 | 0, ct), In(he = b + 2088 | 0, U, _e = b + 3328 | 0), In(b + 2128 | 0, we = b + 3248 | 0, je = b + 3288 | 0), In(b + 2168 | 0, je, _e), In(b + 2208 | 0, U, we), Bi(_e = b + 640 | 0, he), Si(U = b + 3048 | 0, _, _e), In(he = b + 1928 | 0, U, _e = b + 3168 | 0), In(b + 1968 | 0, we = b + 3088 | 0, je = b + 3128 | 0), In(b + 2008 | 0, je, _e), In(b + 2048 | 0, U, we), Bi(b + 800 | 0, he), he = l[4 + (U = b + 2320 | 0) >> 2], l[ie >> 2] = l[U >> 2], l[ie + 4 >> 2] = he, he = l[4 + (U = b + 2312 | 0) >> 2], l[D >> 2] = l[U >> 2], l[D + 4 >> 2] = he, he = l[4 + (U = b + 2304 | 0) >> 2], l[me >> 2] = l[U >> 2], l[me + 4 >> 2] = he, he = l[4 + (U = b + 2296 | 0) >> 2], l[Be >> 2] = l[U >> 2], l[Be + 4 >> 2] = he, U = l[b + 2284 >> 2], l[b + 3840 >> 2] = l[b + 2280 >> 2], l[b + 3844 >> 2] = U, U = l[b + 2276 >> 2], l[b + 3832 >> 2] = l[b + 2272 >> 2], l[b + 3836 >> 2] = U, U = l[b + 2268 >> 2], l[b + 3824 >> 2] = l[b + 2264 >> 2], l[b + 3828 >> 2] = U, U = l[b + 2260 >> 2], l[b + 3816 >> 2] = l[b + 2256 >> 2], l[b + 3820 >> 2] = U, U = l[b + 2252 >> 2], l[b + 3808 >> 2] = l[b + 2248 >> 2], l[b + 3812 >> 2] = U, U = l[b + 2292 >> 2], l[b + 3848 >> 2] = l[b + 2288 >> 2], l[b + 3852 >> 2] = U, he = l[4 + (U = b + 2336 | 0) >> 2], l[Ge >> 2] = l[U >> 2], l[Ge + 4 >> 2] = he, he = l[4 + (U = b + 2344 | 0) >> 2], l[$e >> 2] = l[U >> 2], l[$e + 4 >> 2] = he, he = l[4 + (U = b + 2352 | 0) >> 2], l[ye >> 2] = l[U >> 2], l[ye + 4 >> 2] = he, he = l[4 + (U = b + 2360 | 0) >> 2], l[Le >> 2] = l[U >> 2], l[Le + 4 >> 2] = he, U = l[b + 2332 >> 2], l[b + 3888 >> 2] = l[b + 2328 >> 2], l[b + 3892 >> 2] = U, Se(U = b + 2888 | 0, ct), In(he = b + 1768 | 0, U, _e = b + 3008 | 0), In(b + 1808 | 0, we = b + 2928 | 0, je = b + 2968 | 0), In(b + 1848 | 0, je, _e), In(b + 1888 | 0, U, we), Bi(_e = b + 960 | 0, he), Si(U = b + 2728 | 0, _, _e), In(_ = b + 1608 | 0, U, he = b + 2848 | 0), In(b + 1648 | 0, _e = b + 2768 | 0, we = b + 2808 | 0), In(b + 1688 | 0, we, he), In(b + 1728 | 0, U, _e), Bi(b + 1120 | 0, _), U = l[4 + (_ = b + 2160 | 0) >> 2], l[ie >> 2] = l[_ >> 2], l[ie + 4 >> 2] = U, ie = l[4 + (_ = b + 2152 | 0) >> 2], l[D >> 2] = l[_ >> 2], l[D + 4 >> 2] = ie, ie = l[4 + (_ = b + 2144 | 0) >> 2], l[me >> 2] = l[_ >> 2], l[me + 4 >> 2] = ie, ie = l[4 + (_ = b + 2136 | 0) >> 2], l[Be >> 2] = l[_ >> 2], l[Be + 4 >> 2] = ie, _ = l[b + 2124 >> 2], l[b + 3840 >> 2] = l[b + 2120 >> 2], l[b + 3844 >> 2] = _, _ = l[b + 2116 >> 2], l[b + 3832 >> 2] = l[b + 2112 >> 2], l[b + 3836 >> 2] = _, _ = l[b + 2108 >> 2], l[b + 3824 >> 2] = l[b + 2104 >> 2], l[b + 3828 >> 2] = _, _ = l[b + 2100 >> 2], l[b + 3816 >> 2] = l[b + 2096 >> 2], l[b + 3820 >> 2] = _, _ = l[b + 2092 >> 2], l[b + 3808 >> 2] = l[b + 2088 >> 2], l[b + 3812 >> 2] = _, _ = l[b + 2132 >> 2], l[b + 3848 >> 2] = l[b + 2128 >> 2], l[b + 3852 >> 2] = _, ie = l[4 + (_ = b + 2176 | 0) >> 2], l[Ge >> 2] = l[_ >> 2], l[Ge + 4 >> 2] = ie, ie = l[4 + (_ = b + 2184 | 0) >> 2], l[$e >> 2] = l[_ >> 2], l[$e + 4 >> 2] = ie, ie = l[4 + (_ = b + 2192 | 0) >> 2], l[ye >> 2] = l[_ >> 2], l[ye + 4 >> 2] = ie, ie = l[4 + (_ = b + 2200 | 0) >> 2], l[Le >> 2] = l[_ >> 2], l[Le + 4 >> 2] = ie, _ = l[b + 2172 >> 2], l[b + 3888 >> 2] = l[b + 2168 >> 2], l[b + 3892 >> 2] = _, Se(_ = b + 2568 | 0, ct), In(ie = b + 1448 | 0, _, D = b + 2688 | 0), In(b + 1488 | 0, me = b + 2608 | 0, Be = b + 2648 | 0), In(b + 1528 | 0, Be, D), In(b + 1568 | 0, _, me), Bi(b + 1280 | 0, ie), ie = 0, _ = 0; me = (D = b + 3968 | 0) + (_ << 1) | 0, Be = B[g + _ | 0], j[me + 1 | 0] = Be >>> 4, j[0 | me] = 15 & Be, D = D + ((me = 1 | _) << 1) | 0, me = B[g + me | 0], j[D + 1 | 0] = me >>> 4, j[0 | D] = 15 & me, (0 | (_ = _ + 2 | 0)) != 32; )
                        ;
                      for (g = 0; _ = 8 + (D = (_ = g) + B[0 | (g = (b + 3968 | 0) + ie | 0)] | 0) | 0, j[0 | g] = D - (240 & _), _ = 8 + (D = B[g + 1 | 0] + (_ << 24 >> 24 >> 4) | 0) | 0, j[g + 1 | 0] = D - (240 & _), _ = 8 + (D = B[g + 2 | 0] + (_ << 24 >> 24 >> 4) | 0) | 0, j[g + 2 | 0] = D - (240 & _), g = _ << 24 >> 24 >> 4, (0 | (ie = ie + 3 | 0)) != 63; )
                        ;
                      for (j[b + 4031 | 0] = B[b + 4031 | 0] + g, l[A + 32 >> 2] = 0, l[A + 36 >> 2] = 0, l[A + 24 >> 2] = 0, l[A + 28 >> 2] = 0, l[A + 16 >> 2] = 0, l[A + 20 >> 2] = 0, l[A + 8 >> 2] = 0, l[A + 12 >> 2] = 0, l[A >> 2] = 0, l[A + 4 >> 2] = 0, l[A + 44 >> 2] = 0, l[A + 48 >> 2] = 0, l[($e = A + 40 | 0) >> 2] = 1, l[A + 52 >> 2] = 0, l[A + 56 >> 2] = 0, l[A + 60 >> 2] = 0, l[A + 64 >> 2] = 0, l[A + 68 >> 2] = 0, l[A + 72 >> 2] = 0, l[A + 76 >> 2] = 0, l[A + 80 >> 2] = 1, Jt(A + 84 | 0, 0, 76), Ge = A + 120 | 0, ct = A + 80 | 0, Be = b + 3768 | 0, g = b + 3888 | 0, D = b + 3848 | 0, Le = b + 3728 | 0, _ = b + 3928 | 0, ye = 63; Ee(b, b + 160 | 0, j[(b + 3968 | 0) + ye | 0]), Si(ie = b + 3808 | 0, A, b), In(me = b + 3688 | 0, ie, _), In(Le, D, g), In(Be, g, _), Se(ie, me), In(me, ie, _), In(Le, D, g), In(Be, g, _), Se(ie, me), In(me, ie, _), In(Le, D, g), In(Be, g, _), Se(ie, me), In(me, ie, _), In(Le, D, g), In(Be, g, _), Se(ie, me), In(A, ie, _), In($e, D, g), In(ct, g, _), In(Ge, ie, D), ye = ye - 1 | 0; )
                        ;
                      Ee(b, b + 160 | 0, j[b + 3968 | 0]), Si(ie = b + 3808 | 0, A, b), In(A, ie, _), In($e, D, g), In(ct, g, _), In(Ge, ie, D), st = b + 4032 | 0;
                    }
                    function Ia(A, g) {
                      var _, b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht, Ct, Tt, Gt, en, it, St, Ft, fn, _n, wn, $n, qn, Gn, Kn, Kt, pn, Hn, Zn, er, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0, Nn = 0, cr = 0, Rr = 0, Ir = 0, Pr = 0, qr = 0, ao = 0, Fn = 0, Wn = 0, wt = 0, jt = 0;
                      Zt = De(b = (je = l[g + 12 >> 2]) << 1, D = b >> 31, Pr = (ur = l[g + 4 >> 2]) << 1, U = Pr >> 31), or = ve, Ct = cr = l[g + 8 >> 2], Sn = (Rr = De(cr, ct = cr >> 31, cr, ct)) + Zt | 0, Zt = ve + or | 0, Zt = Sn >>> 0 < Rr >>> 0 ? Zt + 1 | 0 : Zt, or = De(Ve = l[g + 16 >> 2], me = Ve >> 31, Rr = (Cr = l[g >> 2]) << 1, ie = Rr >> 31), Zt = ve + Zt | 0, Zt = (Sn = or + Sn | 0) >>> 0 < or >>> 0 ? Zt + 1 | 0 : Zt, we = l[g + 28 >> 2], or = De(Fn = wr(we, 38), mt = Fn >> 31, we, Tt = we >> 31), Zt = ve + Zt | 0, Zt = (Sn = or + Sn | 0) >>> 0 < or >>> 0 ? Zt + 1 | 0 : Zt, or = Sn, $e = l[g + 32 >> 2], ut = De(Nn = wr($e, 19), _e = Nn >> 31, Sn = (_ = l[g + 24 >> 2]) << 1, Sn >> 31), Sn = ve + Zt | 0, Sn = (or = or + ut | 0) >>> 0 < ut >>> 0 ? Sn + 1 | 0 : Sn, Zt = or, _n = l[g + 36 >> 2], or = De(ut = wr(_n, 38), he = ut >> 31, qr = (Be = l[g + 20 >> 2]) << 1, Le = qr >> 31), g = ve + Sn | 0, Sn = Zt = Zt + or | 0, $n = Zt = (Zt >>> 0 < or >>> 0 ? g + 1 | 0 : g) << 1 | Zt >>> 31, qn = Sn = 33554432 + (Gt = Sn << 1) | 0, Gn = Zt = Sn >>> 0 < 33554432 ? Zt + 1 | 0 : Zt, or = (67108863 & Zt) << 6 | Sn >>> 26, Ir = Zt >> 26, g = De(Pr, U, Ve, me), Zt = ve, Sn = De(cr <<= 1, Ge = cr >> 31, je, en = je >> 31), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, wt = De(Be, bt = Be >> 31, Rr, ie), Sn = ve + Zt | 0, Sn = (g = wt + g | 0) >>> 0 < wt >>> 0 ? Sn + 1 | 0 : Sn, jt = De(Nn, _e, wt = we << 1, it = wt >> 31), Zt = ve + Sn | 0, Zt = (g = jt + g | 0) >>> 0 < jt >>> 0 ? Zt + 1 | 0 : Zt, Sn = De(ut, he, _, ye = _ >> 31), Zt = ve + Zt | 0, Sn = ((g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt) << 1 | g >>> 31, Zt = g << 1, g = Sn + Ir | 0, jt = or = Zt + or | 0, Zt = g = Zt >>> 0 > or >>> 0 ? g + 1 | 0 : g, Kn = g = or + 16777216 | 0, Ir = (33554431 & (Zt = g >>> 0 < 16777216 ? Zt + 1 | 0 : Zt)) << 7 | g >>> 25, or = Zt >> 25, g = De(b, D, je, en), Zt = ve, Sn = De(Ve, me, cr, Ge), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = De(Pr, U, qr, Le), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = (Je = De(Rr, ie, _, ye)) + g | 0, g = ve + Zt | 0, g = Sn >>> 0 < Je >>> 0 ? g + 1 | 0 : g, Je = De(Nn, _e, $e, ht = $e >> 31), Zt = ve + g | 0, Zt = (Sn = Je + Sn | 0) >>> 0 < Je >>> 0 ? Zt + 1 | 0 : Zt, g = (Je = De(ut, he, wt, it)) + Sn | 0, Sn = ve + Zt | 0, g = ((Zt = g) >>> 0 < Je >>> 0 ? Sn + 1 | 0 : Sn) << 1 | Zt >>> 31, Sn = Ir, Ir = Zt << 1, Zt = g + or | 0, Zt = (Sn = Sn + Ir | 0) >>> 0 < Ir >>> 0 ? Zt + 1 | 0 : Zt, Kt = g = Sn + 33554432 | 0, or = Zt = g >>> 0 < 33554432 ? Zt + 1 | 0 : Zt, l[A + 24 >> 2] = Sn - (-67108864 & g), Sn = De(g = wr(Be, 38), g >> 31, Be, bt), Ir = ve, g = (Zt = De(g = Cr, Zt = g >> 31, g, Zt)) + Sn | 0, Sn = ve + Ir | 0, Sn = g >>> 0 < Zt >>> 0 ? Sn + 1 | 0 : Sn, Je = De(Cr = wr(_, 19), St = Cr >> 31, Ir = Ve << 1, Ft = Ir >> 31), Zt = ve + Sn | 0, Zt = (g = Je + g | 0) >>> 0 < Je >>> 0 ? Zt + 1 | 0 : Zt, Sn = De(b, D, Fn, mt), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = (Je = De(Nn, _e, cr, Ge)) + g | 0, g = ve + Zt | 0, g = Sn >>> 0 < Je >>> 0 ? g + 1 | 0 : g, Je = De(Pr, U, ut, he), Zt = ve + g | 0, pn = Zt = ((Sn = Je + Sn | 0) >>> 0 < Je >>> 0 ? Zt + 1 | 0 : Zt) << 1 | Sn >>> 31, Hn = g = 33554432 + (fn = Sn << 1) | 0, Zn = Sn = g >>> 0 < 33554432 ? Zt + 1 | 0 : Zt, Wn = (67108863 & Sn) << 6 | g >>> 26, Je = Sn >> 26, g = De(Cr, St, qr, Le), Zt = ve, Sn = De(Rr, ie, ur, wn = ur >> 31), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = (ao = De(Ve, me, Fn, mt)) + g | 0, g = ve + Zt | 0, g = Sn >>> 0 < ao >>> 0 ? g + 1 | 0 : g, ao = De(Nn, _e, b, D), Zt = ve + g | 0, Zt = (Sn = ao + Sn | 0) >>> 0 < ao >>> 0 ? Zt + 1 | 0 : Zt, g = (ao = De(ut, he, Ct, ct)) + Sn | 0, Sn = ve + Zt | 0, g = ((Zt = g) >>> 0 < ao >>> 0 ? Sn + 1 | 0 : Sn) << 1 | Zt >>> 31, Sn = Wn, Wn = Zt << 1, Zt = g + Je | 0, Je = Sn = Sn + Wn | 0, Zt = Sn >>> 0 < Wn >>> 0 ? Zt + 1 | 0 : Zt, ao = Sn = Sn + 16777216 | 0, er = (33554431 & (Zt = Sn >>> 0 < 16777216 ? Zt + 1 | 0 : Zt)) << 7 | Sn >>> 25, Wn = Zt >> 25, g = De(Rr, ie, Ct, ct), Zt = ve, Sn = De(Pr, U, ur, wn), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, ur = De(Cr, St, _, ye), Sn = ve + Zt | 0, Sn = (g = ur + g | 0) >>> 0 < ur >>> 0 ? Sn + 1 | 0 : Sn, ur = De(qr, Le, Fn, mt), Zt = ve + Sn | 0, Zt = (g = ur + g | 0) >>> 0 < ur >>> 0 ? Zt + 1 | 0 : Zt, Sn = De(Nn, _e, Ir, Ft), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = (ur = De(ut, he, b, D)) + g | 0, g = ve + Zt | 0, Zt = (Zt = (Sn >>> 0 < ur >>> 0 ? g + 1 | 0 : g) << 1 | Sn >>> 31) + Wn | 0, Cr = g = (Sn <<= 1) + er | 0, Sn = g >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Wn = g = g + 33554432 | 0, ur = Sn = g >>> 0 < 33554432 ? Sn + 1 | 0 : Sn, l[A + 8 >> 2] = Cr - (-67108864 & g), g = De(cr, Ge, Be, bt), Sn = ve, Zt = (Cr = De(Ve, me, b, D)) + g | 0, g = ve + Sn | 0, g = Zt >>> 0 < Cr >>> 0 ? g + 1 | 0 : g, Sn = (Cr = De(Pr, U, _, ye)) + Zt | 0, Zt = ve + g | 0, Zt = Sn >>> 0 < Cr >>> 0 ? Zt + 1 | 0 : Zt, g = (Cr = De(Rr, ie, we, Tt)) + Sn | 0, Sn = ve + Zt | 0, Sn = g >>> 0 < Cr >>> 0 ? Sn + 1 | 0 : Sn, Cr = De(ut, he, $e, ht), Zt = ve + Sn | 0, Zt = (Zt = ((g = Cr + g | 0) >>> 0 < Cr >>> 0 ? Zt + 1 | 0 : Zt) << 1 | g >>> 31) + (Sn = or >> 26) | 0, g = (Sn = or = (Cr = g << 1) + (g = (67108863 & or) << 6 | Kt >>> 26) | 0) >>> 0 < g >>> 0 ? Zt + 1 | 0 : Zt, Cr = Zt = Sn + 16777216 | 0, or = g = Zt >>> 0 < 16777216 ? g + 1 | 0 : g, l[A + 28 >> 2] = Sn - (-33554432 & Zt), g = De(Rr, ie, je, en), Zt = ve, Sn = De(Pr, U, Ct, ct), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = De(_, ye, Fn, mt), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = (Nn = De(Nn, _e, qr, Le)) + g | 0, g = ve + Zt | 0, g = Sn >>> 0 < Nn >>> 0 ? g + 1 | 0 : g, Zt = (Nn = De(ut, he, Ve, me)) + Sn | 0, Sn = ve + g | 0, g = Zt, Zt = (Zt >>> 0 < Nn >>> 0 ? Sn + 1 | 0 : Sn) << 1 | Zt >>> 31, Sn = g << 1, Zt = (g = ur >> 26) + Zt | 0, Zt = (Sn = Sn + (ur = (67108863 & ur) << 6 | Wn >>> 26) | 0) >>> 0 < ur >>> 0 ? Zt + 1 | 0 : Zt, Nn = g = Sn + 16777216 | 0, ur = Zt = g >>> 0 < 16777216 ? Zt + 1 | 0 : Zt, l[A + 12 >> 2] = Sn - (-33554432 & g), g = De(_, ye, cr, Ge), Zt = ve, Sn = De(Ve, me, Ve, me), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = De(b, D, qr, Le), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = De(Pr, U, wt, it), Zt = ve + Zt | 0, Zt = (g = Sn + g | 0) >>> 0 < Sn >>> 0 ? Zt + 1 | 0 : Zt, Sn = (Ve = De(Rr, ie, $e, ht)) + g | 0, g = ve + Zt | 0, g = Sn >>> 0 < Ve >>> 0 ? g + 1 | 0 : g, Zt = (Ve = De(Zt = ut, he, ut = _n, qr = ut >> 31)) + Sn | 0, Sn = ve + g | 0, g = Zt, Zt = (Zt >>> 0 < Ve >>> 0 ? Sn + 1 | 0 : Sn) << 1 | Zt >>> 31, Sn = g << 1, Zt = (g = or >> 25) + Zt | 0, Zt = (Sn = Sn + (or = (33554431 & or) << 7 | Cr >>> 25) | 0) >>> 0 < or >>> 0 ? Zt + 1 | 0 : Zt, Ve = g = Sn + 33554432 | 0, or = Zt = g >>> 0 < 33554432 ? Zt + 1 | 0 : Zt, l[A + 32 >> 2] = Sn - (-67108864 & g), Zt = ur >> 25, Sn = (ur = (33554431 & ur) << 7 | Nn >>> 25) + (Gt - (g = -67108864 & qn) | 0) | 0, g = Zt + ($n - ((g >>> 0 > Gt >>> 0) + Gn | 0) | 0) | 0, Zt = Sn >>> 0 < ur >>> 0 ? g + 1 | 0 : g, Cr = Zt = (67108863 & (Zt = (g = Sn + 33554432 | 0) >>> 0 < 33554432 ? Zt + 1 | 0 : Zt)) << 6 | g >>> 26, Zt = Zt + (Fn = jt - (-33554432 & Kn) | 0) | 0, l[A + 20 >> 2] = Zt, l[A + 16 >> 2] = Sn - (-67108864 & g), g = De(b, D, _, ye), Sn = ve, Zt = (ur = De(Be, bt, Ir, Ft)) + g | 0, g = ve + Sn | 0, g = Zt >>> 0 < ur >>> 0 ? g + 1 | 0 : g, Sn = (ur = De(cr, Ge, we, Tt)) + Zt | 0, Zt = ve + g | 0, Zt = Sn >>> 0 < ur >>> 0 ? Zt + 1 | 0 : Zt, g = (ur = De(Pr, U, $e, ht)) + Sn | 0, Sn = ve + Zt | 0, Sn = g >>> 0 < ur >>> 0 ? Sn + 1 | 0 : Sn, ur = De(Rr, ie, ut, qr), Zt = ve + Sn | 0, Cr = (g = ur + g | 0) << 1, Zt = (Zt = (g >>> 0 < ur >>> 0 ? Zt + 1 | 0 : Zt) << 1 | g >>> 31) + (Sn = or >> 26) | 0, g = (g = (67108863 & or) << 6 | Ve >>> 26) >>> 0 > (or = Cr + g | 0) >>> 0 ? Zt + 1 | 0 : Zt, g = (Zt = or + 16777216 | 0) >>> 0 < 16777216 ? g + 1 | 0 : g, l[A + 36 >> 2] = or - (-33554432 & Zt), ur = Je - (-33554432 & ao) | 0, or = fn - (Sn = -67108864 & Hn) | 0, Pr = pn - ((Sn >>> 0 > fn >>> 0) + Zn | 0) | 0, g = De((33554431 & g) << 7 | Zt >>> 25, g >> 25, 19, 0), Sn = ve + Pr | 0, or = Zt = g + or | 0, g = g >>> 0 > Zt >>> 0 ? Sn + 1 | 0 : Sn, Sn = g = (67108863 & (g = (Zt = Zt + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g)) << 6 | Zt >>> 26, g = g + ur | 0, l[A + 4 >> 2] = g, l[A >> 2] = or - (-67108864 & Zt);
                    }
                    function Ot(A, g) {
                      var _, b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht, Ct, Tt, Gt, en, it, St, Ft, fn, _n, wn, $n, qn, Gn, Kn, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0, Nn = 0, cr = 0, Rr = 0, Ir = 0, Pr = 0, qr = 0, ao = 0, Fn = 0, Wn = 0;
                      Kt = De(b = (ct = l[g + 12 >> 2]) << 1, D = b >> 31, ct, Tt = ct >> 31), Hn = ve, pn = (ur = De(er = l[g + 16 >> 2], me = er >> 31, _e = (Zn = l[g + 8 >> 2]) << 1, $e = _e >> 31)) + Kt | 0, Kt = ve + Hn | 0, Kt = pn >>> 0 < ur >>> 0 ? Kt + 1 | 0 : Kt, Hn = (Cr = De(ut = (Be = l[g + 20 >> 2]) << 1, Le = ut >> 31, ur = (Zt = l[g + 4 >> 2]) << 1, U = ur >> 31)) + pn | 0, pn = ve + Kt | 0, pn = Hn >>> 0 < Cr >>> 0 ? pn + 1 | 0 : pn, Sn = De(_ = l[g + 24 >> 2], ye = _ >> 31, Cr = (Rr = l[g >> 2]) << 1, ie = Cr >> 31), Kt = ve + pn | 0, Kt = (Hn = Sn + Hn | 0) >>> 0 < Sn >>> 0 ? Kt + 1 | 0 : Kt, pn = Hn, Ge = l[g + 32 >> 2], Hn = De(Je = wr(Ge, 19), we = Je >> 31, Ge, bt = Ge >> 31), Kt = ve + Kt | 0, Kt = (pn = pn + Hn | 0) >>> 0 < Hn >>> 0 ? Kt + 1 | 0 : Kt, Ft = l[g + 36 >> 2], Hn = De(Sn = wr(Ft, 38), he = Sn >> 31, ht = (je = l[g + 28 >> 2]) << 1, Gt = ht >> 31), g = ve + Kt | 0, cr = pn = Hn + pn | 0, Hn = pn >>> 0 < Hn >>> 0 ? g + 1 | 0 : g, g = De(ur, U, er, me), Kt = ve, pn = De(_e, $e, ct, Tt), Kt = ve + Kt | 0, Kt = (g = pn + g | 0) >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, or = De(Be, Ct = Be >> 31, Cr, ie), pn = ve + Kt | 0, pn = (g = or + g | 0) >>> 0 < or >>> 0 ? pn + 1 | 0 : pn, or = De(Je, we, ht, Gt), Kt = ve + pn | 0, Kt = (g = or + g | 0) >>> 0 < or >>> 0 ? Kt + 1 | 0 : Kt, pn = De(Sn, he, _, ye), Kt = ve + Kt | 0, Fn = g = pn + g | 0, Ve = g >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, Kt = De(ur, U, b, D), pn = ve, en = g = Zn, Zn = De(g, Nn = g >> 31, g, Nn), g = ve + pn | 0, g = (Kt = Zn + Kt | 0) >>> 0 < Zn >>> 0 ? g + 1 | 0 : g, pn = (Zn = De(Cr, ie, er, me)) + Kt | 0, Kt = ve + g | 0, Kt = pn >>> 0 < Zn >>> 0 ? Kt + 1 | 0 : Kt, g = (Zn = De(or = wr(je, 38), mt = or >> 31, je, it = je >> 31)) + pn | 0, pn = ve + Kt | 0, pn = g >>> 0 < Zn >>> 0 ? pn + 1 | 0 : pn, g = (Kt = g) + (Zn = De(Je, we, g = _ << 1, g >> 31)) | 0, Kt = ve + pn | 0, Kt = g >>> 0 < Zn >>> 0 ? Kt + 1 | 0 : Kt, pn = g, g = De(Sn, he, ut, Le), Kt = ve + Kt | 0, fn = pn = pn + g | 0, _n = Kt = g >>> 0 > pn >>> 0 ? Kt + 1 | 0 : Kt, g = Kt, wn = pn = pn + 33554432 | 0, $n = g = pn >>> 0 < 33554432 ? g + 1 | 0 : g, Kt = (Kt = g >> 26) + Ve | 0, Fn = g = (pn = (67108863 & g) << 6 | pn >>> 26) + Fn | 0, Kt = g >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, qn = g = g + 16777216 | 0, Kt = (Kt = (pn = g >>> 0 < 16777216 ? Kt + 1 | 0 : Kt) >> 25) + Hn | 0, g = (g = (33554431 & pn) << 7 | g >>> 25) >>> 0 > (pn = g + cr | 0) >>> 0 ? Kt + 1 | 0 : Kt, cr = Kt = pn + 33554432 | 0, Zn = g = Kt >>> 0 < 33554432 ? g + 1 | 0 : g, l[A + 24 >> 2] = pn - (-67108864 & Kt), g = De(Cr, ie, en, Nn), Kt = ve, Hn = De(ur, U, Zt, ao = Zt >> 31), pn = ve + Kt | 0, pn = (g = Hn + g | 0) >>> 0 < Hn >>> 0 ? pn + 1 | 0 : pn, Ve = De(Hn = wr(_, 19), qr = Hn >> 31, _, ye), Kt = ve + pn | 0, Kt = (g = Ve + g | 0) >>> 0 < Ve >>> 0 ? Kt + 1 | 0 : Kt, pn = (Ve = De(ut, Le, or, mt)) + g | 0, g = ve + Kt | 0, g = pn >>> 0 < Ve >>> 0 ? g + 1 | 0 : g, Ir = De(Je, we, Ve = er << 1, St = Ve >> 31), Kt = ve + g | 0, Kt = (pn = Ir + pn | 0) >>> 0 < Ir >>> 0 ? Kt + 1 | 0 : Kt, g = pn, pn = De(Sn, he, b, D), Kt = ve + Kt | 0, Pr = g = g + pn | 0, Ir = g >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, g = De(ut, Le, Hn, qr), Kt = ve, Zt = De(Cr, ie, Zt, ao), pn = ve + Kt | 0, pn = (g = Zt + g | 0) >>> 0 < Zt >>> 0 ? pn + 1 | 0 : pn, Zt = De(er, me, or, mt), Kt = ve + pn | 0, Kt = (g = Zt + g | 0) >>> 0 < Zt >>> 0 ? Kt + 1 | 0 : Kt, pn = (Zt = De(Je, we, b, D)) + g | 0, g = ve + Kt | 0, g = pn >>> 0 < Zt >>> 0 ? g + 1 | 0 : g, Zt = De(Sn, he, en, Nn), Kt = ve + g | 0, Wn = pn = Zt + pn | 0, ao = pn >>> 0 < Zt >>> 0 ? Kt + 1 | 0 : Kt, pn = De(g = wr(Be, 38), g >> 31, Be, Ct), Zt = ve, g = Rr, Rr = pn, pn = De(g, Kt = g >> 31, g, Kt), Kt = ve + Zt | 0, Kt = (g = Rr + pn | 0) >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, Hn = De(Hn, qr, Ve, St), pn = ve + Kt | 0, pn = (g = Hn + g | 0) >>> 0 < Hn >>> 0 ? pn + 1 | 0 : pn, Hn = De(b, D, or, mt), Kt = ve + pn | 0, Kt = (g = Hn + g | 0) >>> 0 < Hn >>> 0 ? Kt + 1 | 0 : Kt, pn = (Hn = De(Je, we, _e, $e)) + g | 0, g = ve + Kt | 0, g = pn >>> 0 < Hn >>> 0 ? g + 1 | 0 : g, Hn = De(ur, U, Sn, he), Kt = ve + g | 0, Zt = pn = Hn + pn | 0, qr = Kt = pn >>> 0 < Hn >>> 0 ? Kt + 1 | 0 : Kt, Gn = pn = pn + 33554432 | 0, Kn = Kt = pn >>> 0 < 33554432 ? Kt + 1 | 0 : Kt, g = Kt >> 26, Kt = (67108863 & Kt) << 6 | pn >>> 26, pn = g + ao | 0, Rr = Hn = Kt + Wn | 0, Kt = pn = Kt >>> 0 > Hn >>> 0 ? pn + 1 | 0 : pn, Wn = pn = Hn + 16777216 | 0, Hn = (33554431 & (Kt = pn >>> 0 < 16777216 ? Kt + 1 | 0 : Kt)) << 7 | pn >>> 25, Kt = (Kt >> 25) + Ir | 0, Kt = (pn = Hn + Pr | 0) >>> 0 < Hn >>> 0 ? Kt + 1 | 0 : Kt, Ir = g = pn + 33554432 | 0, Hn = Kt = g >>> 0 < 33554432 ? Kt + 1 | 0 : Kt, l[A + 8 >> 2] = pn - (-67108864 & g), g = De(_e, $e, Be, Ct), Kt = ve, pn = De(er, me, b, D), Kt = ve + Kt | 0, Kt = (g = pn + g | 0) >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, pn = De(ur, U, _, ye), Kt = ve + Kt | 0, Kt = (g = pn + g | 0) >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, pn = De(Cr, ie, je, it), Kt = ve + Kt | 0, Kt = (g = pn + g | 0) >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, Pr = (pn = De(Sn, he, Ge, bt)) + g | 0, g = ve + Kt | 0, pn = (Kt = Zn >> 26) + (pn = pn >>> 0 > Pr >>> 0 ? g + 1 | 0 : g) | 0, cr = g = (Zn = (67108863 & Zn) << 6 | cr >>> 26) + Pr | 0, Kt = g >>> 0 < Zn >>> 0 ? pn + 1 | 0 : pn, Pr = g = g + 16777216 | 0, Zn = Kt = g >>> 0 < 16777216 ? Kt + 1 | 0 : Kt, l[A + 28 >> 2] = cr - (-33554432 & g), g = De(Cr, ie, ct, Tt), pn = ve, Kt = (Nn = De(ur, U, en, Nn)) + g | 0, g = ve + pn | 0, g = Kt >>> 0 < Nn >>> 0 ? g + 1 | 0 : g, Kt = (or = De(_, ye, or, mt)) + Kt | 0, pn = ve + g | 0, g = (Je = De(Je, we, ut, Le)) + Kt | 0, Kt = ve + (Kt >>> 0 < or >>> 0 ? pn + 1 | 0 : pn) | 0, Kt = g >>> 0 < Je >>> 0 ? Kt + 1 | 0 : Kt, pn = De(Sn, he, er, me), Kt = ve + Kt | 0, Kt = (Kt = (g = pn + g | 0) >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt) + (pn = Hn >> 26) | 0, g = (pn = Hn = (cr = g) + (g = (67108863 & Hn) << 6 | Ir >>> 26) | 0) >>> 0 < g >>> 0 ? Kt + 1 | 0 : Kt, Je = Kt = pn + 16777216 | 0, Hn = g = Kt >>> 0 < 16777216 ? g + 1 | 0 : g, l[A + 12 >> 2] = pn - (-33554432 & Kt), g = De(_, ye, _e, $e), Kt = ve, pn = De(er, me, er, me), Kt = ve + Kt | 0, Kt = (g = pn + g | 0) >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, pn = De(b, D, ut, Le), Kt = ve + Kt | 0, Kt = (g = pn + g | 0) >>> 0 < pn >>> 0 ? Kt + 1 | 0 : Kt, pn = (er = De(ur, U, ht, Gt)) + g | 0, g = ve + Kt | 0, g = pn >>> 0 < er >>> 0 ? g + 1 | 0 : g, Kt = (er = De(Cr, ie, Ge, bt)) + pn | 0, pn = ve + g | 0, pn = Kt >>> 0 < er >>> 0 ? pn + 1 | 0 : pn, g = (er = De(g = Sn, he, Sn = Ft, ut = Sn >> 31)) + Kt | 0, Kt = ve + pn | 0, Kt = g >>> 0 < er >>> 0 ? Kt + 1 | 0 : Kt, pn = g, Kt = (g = Zn >> 25) + Kt | 0, Kt = (pn = pn + (Zn = (33554431 & Zn) << 7 | Pr >>> 25) | 0) >>> 0 < Zn >>> 0 ? Kt + 1 | 0 : Kt, er = g = pn + 33554432 | 0, Zn = Kt = g >>> 0 < 33554432 ? Kt + 1 | 0 : Kt, l[A + 32 >> 2] = pn - (-67108864 & g), Kt = Hn >> 25, pn = (Hn = (33554431 & Hn) << 7 | Je >>> 25) + (fn - (g = -67108864 & wn) | 0) | 0, g = Kt + (_n - ((g >>> 0 > fn >>> 0) + $n | 0) | 0) | 0, Kt = pn >>> 0 < Hn >>> 0 ? g + 1 | 0 : g, Hn = Kt = (67108863 & (Kt = (g = pn + 33554432 | 0) >>> 0 < 33554432 ? Kt + 1 | 0 : Kt)) << 6 | g >>> 26, Kt = Kt + (or = Fn - (-33554432 & qn) | 0) | 0, l[A + 20 >> 2] = Kt, l[A + 16 >> 2] = pn - (-67108864 & g), g = De(b, D, _, ye), pn = ve, Kt = (Hn = De(Be, Ct, Ve, St)) + g | 0, g = ve + pn | 0, g = Kt >>> 0 < Hn >>> 0 ? g + 1 | 0 : g, pn = (Hn = De(_e, $e, je, it)) + Kt | 0, Kt = ve + g | 0, Kt = pn >>> 0 < Hn >>> 0 ? Kt + 1 | 0 : Kt, g = (Hn = De(ur, U, Ge, bt)) + pn | 0, pn = ve + Kt | 0, pn = g >>> 0 < Hn >>> 0 ? pn + 1 | 0 : pn, Hn = (Kt = g) + (g = De(Cr, ie, Sn, ut)) | 0, Kt = ve + pn | 0, Kt = (g = g >>> 0 > Hn >>> 0 ? Kt + 1 | 0 : Kt) + (Kt = Zn >> 26) | 0, g = (pn = (Zn = (67108863 & Zn) << 6 | er >>> 26) + Hn | 0) >>> 0 < Zn >>> 0 ? Kt + 1 | 0 : Kt, g = (Kt = pn + 16777216 | 0) >>> 0 < 16777216 ? g + 1 | 0 : g, l[A + 36 >> 2] = pn - (-33554432 & Kt), Zn = Rr - (-33554432 & Wn) | 0, Hn = Zt - (pn = -67108864 & Gn) | 0, ur = qr - ((pn >>> 0 > Zt >>> 0) + Kn | 0) | 0, g = De((33554431 & g) << 7 | Kt >>> 25, g >> 25, 19, 0), Kt = ve + ur | 0, g = g >>> 0 > (pn = g + Hn | 0) >>> 0 ? Kt + 1 | 0 : Kt, Hn = g = (67108863 & (g = (Kt = pn + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g)) << 6 | Kt >>> 26, g = g + Zn | 0, l[A + 4 >> 2] = g, l[A >> 2] = pn - (-67108864 & Kt);
                    }
                    function js(A, g) {
                      var _, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0;
                      if (st = _ = st - 48 | 0, !((U = Na(A)) || (U = -26, g - 3 >>> 0 < 4294967294))) {
                        b = l[A + 44 >> 2], U = l[A + 48 >> 2], l[_ >> 2] = 0, _e = l[A + 40 >> 2], l[_ + 28 >> 2] = U, l[_ + 12 >> 2] = -1, l[_ + 8 >> 2] = _e, U = ((he = b >>> 0 > (_e = U << 3) >>> 0 ? b : _e) >>> 0) / ((b = U << 2) >>> 0) | 0, l[_ + 20 >> 2] = U, l[_ + 24 >> 2] = U << 2, l[_ + 16 >> 2] = wr(b, U), U = l[A + 52 >> 2], l[_ + 36 >> 2] = g, l[_ + 32 >> 2] = U, Le = g = st, st = b = g - 1152 & -64, g = -25;
                        e: {
                          if (!(!_ | !A) && (U = Qi(l[_ + 20 >> 2] << 3), l[_ + 4 >> 2] = U, g = -22, U)) {
                            t: {
                              if ((g = l[_ + 16 >> 2]) && (((U = g << 10) >>> 0) / (g >>> 0) | 0) == 1024 && (g = Qi(12), l[_ >> 2] = g, g)) {
                                if (l[g >> 2] = 0, l[g + 4 >> 2] = 0, g = Ro(b + 128 | 0, U), l[9129] = g, g)
                                  l[b + 128 >> 2] = 0;
                                else if (g = l[b + 128 >> 2])
                                  break t;
                                wi(l[_ >> 2]), l[_ >> 2] = 0;
                              }
                              Tn(_, l[A + 56 >> 2]), st = Le, g = -22;
                              break e;
                            }
                            if (l[l[_ >> 2] >> 2] = g, l[l[_ >> 2] + 4 >> 2] = g, l[l[_ >> 2] + 8 >> 2] = U, _e = l[_ + 36 >> 2], ea(g = b + 128 | 0, 0, 0, 64), l[b + 124 >> 2] = l[A + 48 >> 2], to(g, U = b + 124 | 0, 4, 0), l[b + 124 >> 2] = l[A + 4 >> 2], to(g, U, 4, 0), l[b + 124 >> 2] = l[A + 44 >> 2], to(g, U, 4, 0), l[b + 124 >> 2] = l[A + 40 >> 2], to(g, U, 4, 0), l[b + 124 >> 2] = 19, to(b + 128 | 0, b + 124 | 0, 4, 0), l[b + 124 >> 2] = _e, to(b + 128 | 0, b + 124 | 0, 4, 0), l[b + 124 >> 2] = l[A + 12 >> 2], to(b + 128 | 0, b + 124 | 0, 4, 0), (g = l[A + 8 >> 2]) && (to(b + 128 | 0, g, l[A + 12 >> 2], 0), 1 & j[A + 56 | 0] && (Wr(l[A + 8 >> 2], l[A + 12 >> 2]), l[A + 12 >> 2] = 0)), l[b + 124 >> 2] = l[A + 20 >> 2], to(b + 128 | 0, b + 124 | 0, 4, 0), (g = l[A + 16 >> 2]) && to(b + 128 | 0, g, l[A + 20 >> 2], 0), l[b + 124 >> 2] = l[A + 28 >> 2], to(b + 128 | 0, b + 124 | 0, 4, 0), (g = l[A + 24 >> 2]) && (to(b + 128 | 0, g, l[A + 28 >> 2], 0), 2 & B[A + 56 | 0] && (Wr(l[A + 24 >> 2], l[A + 28 >> 2]), l[A + 28 >> 2] = 0)), l[b + 124 >> 2] = l[A + 36 >> 2], to(b + 128 | 0, b + 124 | 0, 4, 0), (g = l[A + 32 >> 2]) && to(b + 128 | 0, g, l[A + 36 >> 2], 0), mn(b + 128 | 0, b + 48 | 0, 64), Wr(b + 112 | 0, 8), l[_ + 28 >> 2])
                              for (g = 0; ; ) {
                                for (l[b + 112 >> 2] = 0, l[b + 116 >> 2] = g, ms(b + 128 | 0, 1024, b + 48 | 0, 72), _e = l[l[_ >> 2] + 4 >> 2] + (wr(l[_ + 24 >> 2], g) << 10) | 0, U = 0; ie = (D = U << 3) + _e | 0, we = l[4 + (Be = (he = b + 128 | 0) + D | 0) >> 2], l[ie >> 2] = l[Be >> 2], l[ie + 4 >> 2] = we, Be = (ie = 8 | D) + _e | 0, we = l[4 + (ie = ie + he | 0) >> 2], l[Be >> 2] = l[ie >> 2], l[Be + 4 >> 2] = we, Be = (ie = 16 | D) + _e | 0, we = l[4 + (ie = ie + he | 0) >> 2], l[Be >> 2] = l[ie >> 2], l[Be + 4 >> 2] = we, ie = (D |= 24) + _e | 0, he = l[4 + (D = D + he | 0) >> 2], l[ie >> 2] = l[D >> 2], l[ie + 4 >> 2] = he, (0 | (U = U + 4 | 0)) != 128; )
                                  ;
                                for (l[b + 112 >> 2] = 1, ms(b + 128 | 0, 1024, b + 48 | 0, 72), _e = 1024 + (l[l[_ >> 2] + 4 >> 2] + (wr(l[_ + 24 >> 2], g) << 10) | 0) | 0, U = 0; ie = (D = U << 3) + _e | 0, we = l[4 + (Be = (he = b + 128 | 0) + D | 0) >> 2], l[ie >> 2] = l[Be >> 2], l[ie + 4 >> 2] = we, Be = (ie = 8 | D) + _e | 0, we = l[4 + (ie = ie + he | 0) >> 2], l[Be >> 2] = l[ie >> 2], l[Be + 4 >> 2] = we, Be = (ie = 16 | D) + _e | 0, we = l[4 + (ie = ie + he | 0) >> 2], l[Be >> 2] = l[ie >> 2], l[Be + 4 >> 2] = we, ie = (D |= 24) + _e | 0, he = l[4 + (D = D + he | 0) >> 2], l[ie >> 2] = l[D >> 2], l[ie + 4 >> 2] = he, (0 | (U = U + 4 | 0)) != 128; )
                                  ;
                                if (!((g = g + 1 | 0) >>> 0 < Ri[_ + 28 >> 2]))
                                  break;
                              }
                            Wr(b + 128 | 0, 1024), Wr(b + 48 | 0, 72), g = 0;
                          }
                          st = Le;
                        }
                        if (U = g, !g) {
                          if (l[_ + 8 >> 2])
                            for (; ; ) {
                              if (st = g = st - 80 | 0, !(!_ | !l[_ + 28 >> 2])) {
                                for (j[g + 72 | 0] = 0, l[g + 64 >> 2] = me, U = 0; l[g + 76 >> 2] = 0, b = l[g + 76 >> 2], l[g + 56 >> 2] = l[g + 72 >> 2], l[g + 60 >> 2] = b, l[g + 68 >> 2] = U, b = l[g + 68 >> 2], l[g + 48 >> 2] = l[g + 64 >> 2], l[g + 52 >> 2] = b, Cn(_, g + 48 | 0), (U = U + 1 | 0) >>> 0 < (b = l[_ + 28 >> 2]) >>> 0; )
                                  ;
                                if (j[g + 72 | 0] = 1, b) {
                                  for (U = 0; l[g + 76 >> 2] = 0, b = l[g + 76 >> 2], l[g + 40 >> 2] = l[g + 72 >> 2], l[g + 44 >> 2] = b, l[g + 68 >> 2] = U, b = l[g + 68 >> 2], l[g + 32 >> 2] = l[g + 64 >> 2], l[g + 36 >> 2] = b, Cn(_, g + 32 | 0), (U = U + 1 | 0) >>> 0 < (b = l[_ + 28 >> 2]) >>> 0; )
                                    ;
                                  if (j[g + 72 | 0] = 2, b) {
                                    for (U = 0; l[g + 76 >> 2] = 0, b = l[g + 76 >> 2], l[g + 24 >> 2] = l[g + 72 >> 2], l[g + 28 >> 2] = b, l[g + 68 >> 2] = U, b = l[g + 68 >> 2], l[g + 16 >> 2] = l[g + 64 >> 2], l[g + 20 >> 2] = b, Cn(_, g + 16 | 0), (U = U + 1 | 0) >>> 0 < (b = l[_ + 28 >> 2]) >>> 0; )
                                      ;
                                    if (j[g + 72 | 0] = 3, b)
                                      for (U = 0; l[g + 76 >> 2] = 0, b = l[g + 76 >> 2], l[g + 8 >> 2] = l[g + 72 >> 2], l[g + 12 >> 2] = b, l[g + 68 >> 2] = U, b = l[g + 68 >> 2], l[g >> 2] = l[g + 64 >> 2], l[g + 4 >> 2] = b, Cn(_, g), (U = U + 1 | 0) >>> 0 < Ri[_ + 28 >> 2]; )
                                        ;
                                  }
                                }
                              }
                              if (st = g + 80 | 0, !((me = me + 1 | 0) >>> 0 < Ri[_ + 8 >> 2]))
                                break;
                            }
                          if (st = g = st - 2048 | 0, !(!A | !_)) {
                            if (ie = l[_ >> 2], Le = l[_ + 24 >> 2], xr(g + 1024 | 0, (l[ie + 4 >> 2] + (Le << 10) | 0) - 1024 | 0, 1024), (Be = l[_ + 28 >> 2]) >>> 0 >= 2)
                              for (we = Le - 1 | 0, _e = 1; ; ) {
                                for (U = l[ie + 4 >> 2] + (wr(_e, Le) + we << 10) | 0, D = 0; ye = l[(me = (b = D << 3) + (he = g + 1024 | 0) | 0) >> 2], Ge = l[($e = b + U | 0) >> 2], $e = l[me + 4 >> 2] ^ l[$e + 4 >> 2], l[me >> 2] = ye ^ Ge, l[me + 4 >> 2] = $e, $e = l[(me = (ye = 8 | b) + he | 0) >> 2], Ge = l[(ye = U + ye | 0) >> 2], ye = l[me + 4 >> 2] ^ l[ye + 4 >> 2], l[me >> 2] = $e ^ Ge, l[me + 4 >> 2] = ye, $e = l[(me = (ye = 16 | b) + he | 0) >> 2], Ge = l[(ye = U + ye | 0) >> 2], ye = l[me + 4 >> 2] ^ l[ye + 4 >> 2], l[me >> 2] = $e ^ Ge, l[me + 4 >> 2] = ye, me = l[(b = (me = he) + (he = 24 | b) | 0) >> 2], ye = l[(he = U + he | 0) >> 2], he = l[b + 4 >> 2] ^ l[he + 4 >> 2], l[b >> 2] = me ^ ye, l[b + 4 >> 2] = he, (0 | (D = D + 4 | 0)) != 128; )
                                  ;
                                if ((0 | Be) == (0 | (_e = _e + 1 | 0)))
                                  break;
                              }
                            U = xr(g, g + 1024 | 0, 1024), ms(l[A >> 2], l[A + 4 >> 2], U, 1024), Wr(U + 1024 | 0, 1024), Wr(U, 1024), Tn(_, l[A + 56 >> 2]);
                          }
                          st = g + 2048 | 0, U = 0;
                        }
                      }
                      return st = _ + 48 | 0, U;
                    }
                    function ca(A, g, _, b, U) {
                      var ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0, Nn = 0, cr = 0, Rr = 0, Ir = 0, Pr = 0, qr = 0;
                      for (ie = st + -64 | 0, he = l[A + 60 >> 2], D = l[A + 56 >> 2], er = l[A + 52 >> 2], Zn = l[A + 48 >> 2], me = l[A + 44 >> 2], _e = l[A + 40 >> 2], Be = l[A + 36 >> 2], ye = l[A + 32 >> 2], we = l[A + 28 >> 2], $e = l[A + 24 >> 2], Le = l[A + 20 >> 2], Ge = l[A + 16 >> 2], je = l[A + 12 >> 2], ct = l[A + 8 >> 2], mt = l[A + 4 >> 2], bt = l[A >> 2]; ; ) {
                        if (!U & b >>> 0 > 63 | U)
                          ht = _;
                        else {
                          if (l[ie + 56 >> 2] = 0, l[ie + 60 >> 2] = 0, l[ie + 48 >> 2] = 0, l[ie + 52 >> 2] = 0, l[ie + 40 >> 2] = 0, l[ie + 44 >> 2] = 0, l[ie + 32 >> 2] = 0, l[ie + 36 >> 2] = 0, l[ie + 24 >> 2] = 0, l[ie + 28 >> 2] = 0, l[ie + 16 >> 2] = 0, l[ie + 20 >> 2] = 0, l[ie + 8 >> 2] = 0, l[ie + 12 >> 2] = 0, l[ie >> 2] = 0, l[ie + 4 >> 2] = 0, Tt = 0, b | U)
                            for (; j[Tt + ie | 0] = B[g + Tt | 0], !U & (Tt = Tt + 1 | 0) >>> 0 < b >>> 0 | U; )
                              ;
                          g = ht = ie, Cr = _;
                        }
                        for (Zt = 20, Ct = bt, _n = mt, wn = ct, Gn = je, Tt = Ge, _ = Le, en = $e, it = we, St = ye, Kt = Be, $n = _e, Gt = he, pn = D, Kn = er, qn = Zn, Ft = me; fn = Tt, Ct = tn((Tt = Ct + Tt | 0) ^ qn, 16), fn = qn = tn(fn ^ (St = Ct + St | 0), 12), qn = tn((Hn = Tt + qn | 0) ^ Ct, 8), Tt = tn(fn ^ (St = qn + St | 0), 7), Gt = tn((Ct = it + Gn | 0) ^ Gt, 16), it = tn((Ft = Gt + Ft | 0) ^ it, 12), Gn = tn((wn = en + wn | 0) ^ pn, 16), en = tn(($n = Gn + $n | 0) ^ en, 12), pn = (Sn = Ct + it | 0) + Tt | 0, or = tn((wn = en + wn | 0) ^ Gn, 8), Ct = tn(pn ^ or, 16), Gn = tn((_n = _ + _n | 0) ^ Kn, 16), _ = tn((Kt = Gn + Kt | 0) ^ _, 12), fn = Tt, Kn = tn((_n = _ + _n | 0) ^ Gn, 8), fn = tn(fn ^ (Tt = (ur = Kn + Kt | 0) + Ct | 0), 12), pn = tn(Ct ^ (Gn = fn + pn | 0), 8), Tt = tn((Kt = pn + Tt | 0) ^ fn, 7), fn = St, St = wn, Ct = tn(Gt ^ Sn, 8), wn = tn((Gt = Ct + Ft | 0) ^ it, 7), Kn = tn((St = St + wn | 0) ^ Kn, 16), Ft = tn((it = fn + Kn | 0) ^ wn, 12), Kn = tn(Kn ^ (wn = Ft + St | 0), 8), it = tn((St = it + Kn | 0) ^ Ft, 7), Ft = Gt, Gt = _n, _n = tn(($n = $n + or | 0) ^ en, 7), en = Ft + (qn = tn((Gt = Gt + _n | 0) ^ qn, 16)) | 0, Ft = Gt, Gt = tn(en ^ _n, 12), qn = tn(qn ^ (_n = Ft + Gt | 0), 8), en = tn((Ft = en + qn | 0) ^ Gt, 7), fn = $n, Gt = Ct, Ct = tn(_ ^ ur, 7), Gt = tn(Gt ^ ($n = Ct + Hn | 0), 16), Hn = tn((_ = fn + Gt | 0) ^ Ct, 12), Gt = tn(Gt ^ (Ct = Hn + $n | 0), 8), _ = tn(($n = _ + Gt | 0) ^ Hn, 7), Zt = Zt - 2 | 0; )
                          ;
                        if (Zt = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, Hn = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, Sn = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, or = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, ur = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, fn = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, Je = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, Ve = B[g + 32 | 0] | B[g + 33 | 0] << 8 | B[g + 34 | 0] << 16 | B[g + 35 | 0] << 24, ut = B[g + 36 | 0] | B[g + 37 | 0] << 8 | B[g + 38 | 0] << 16 | B[g + 39 | 0] << 24, Nn = B[g + 40 | 0] | B[g + 41 | 0] << 8 | B[g + 42 | 0] << 16 | B[g + 43 | 0] << 24, cr = B[g + 44 | 0] | B[g + 45 | 0] << 8 | B[g + 46 | 0] << 16 | B[g + 47 | 0] << 24, Rr = B[g + 48 | 0] | B[g + 49 | 0] << 8 | B[g + 50 | 0] << 16 | B[g + 51 | 0] << 24, Ir = B[g + 52 | 0] | B[g + 53 | 0] << 8 | B[g + 54 | 0] << 16 | B[g + 55 | 0] << 24, Pr = B[g + 56 | 0] | B[g + 57 | 0] << 8 | B[g + 58 | 0] << 16 | B[g + 59 | 0] << 24, qr = B[g + 60 | 0] | B[g + 61 | 0] << 8 | B[g + 62 | 0] << 16 | B[g + 63 | 0] << 24, Ct = Ct + bt ^ (B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24), j[0 | ht] = Ct, j[ht + 1 | 0] = Ct >>> 8, j[ht + 2 | 0] = Ct >>> 16, j[ht + 3 | 0] = Ct >>> 24, Ct = Gt + he ^ qr, j[ht + 60 | 0] = Ct, j[ht + 61 | 0] = Ct >>> 8, j[ht + 62 | 0] = Ct >>> 16, j[ht + 63 | 0] = Ct >>> 24, Ct = pn + D ^ Pr, j[ht + 56 | 0] = Ct, j[ht + 57 | 0] = Ct >>> 8, j[ht + 58 | 0] = Ct >>> 16, j[ht + 59 | 0] = Ct >>> 24, Ct = Kn + er ^ Ir, j[ht + 52 | 0] = Ct, j[ht + 53 | 0] = Ct >>> 8, j[ht + 54 | 0] = Ct >>> 16, j[ht + 55 | 0] = Ct >>> 24, Ct = qn + Zn ^ Rr, j[ht + 48 | 0] = Ct, j[ht + 49 | 0] = Ct >>> 8, j[ht + 50 | 0] = Ct >>> 16, j[ht + 51 | 0] = Ct >>> 24, Ct = Ft + me ^ cr, j[ht + 44 | 0] = Ct, j[ht + 45 | 0] = Ct >>> 8, j[ht + 46 | 0] = Ct >>> 16, j[ht + 47 | 0] = Ct >>> 24, Ct = $n + _e ^ Nn, j[ht + 40 | 0] = Ct, j[ht + 41 | 0] = Ct >>> 8, j[ht + 42 | 0] = Ct >>> 16, j[ht + 43 | 0] = Ct >>> 24, Ct = Kt + Be ^ ut, j[ht + 36 | 0] = Ct, j[ht + 37 | 0] = Ct >>> 8, j[ht + 38 | 0] = Ct >>> 16, j[ht + 39 | 0] = Ct >>> 24, Ct = St + ye ^ Ve, j[ht + 32 | 0] = Ct, j[ht + 33 | 0] = Ct >>> 8, j[ht + 34 | 0] = Ct >>> 16, j[ht + 35 | 0] = Ct >>> 24, it = it + we ^ Je, j[ht + 28 | 0] = it, j[ht + 29 | 0] = it >>> 8, j[ht + 30 | 0] = it >>> 16, j[ht + 31 | 0] = it >>> 24, en = fn ^ en + $e, j[ht + 24 | 0] = en, j[ht + 25 | 0] = en >>> 8, j[ht + 26 | 0] = en >>> 16, j[ht + 27 | 0] = en >>> 24, _ = ur ^ _ + Le, j[ht + 20 | 0] = _, j[ht + 21 | 0] = _ >>> 8, j[ht + 22 | 0] = _ >>> 16, j[ht + 23 | 0] = _ >>> 24, _ = or ^ Tt + Ge, j[ht + 16 | 0] = _, j[ht + 17 | 0] = _ >>> 8, j[ht + 18 | 0] = _ >>> 16, j[ht + 19 | 0] = _ >>> 24, _ = Sn ^ Gn + je, j[ht + 12 | 0] = _, j[ht + 13 | 0] = _ >>> 8, j[ht + 14 | 0] = _ >>> 16, j[ht + 15 | 0] = _ >>> 24, _ = Hn ^ wn + ct, j[ht + 8 | 0] = _, j[ht + 9 | 0] = _ >>> 8, j[ht + 10 | 0] = _ >>> 16, j[ht + 11 | 0] = _ >>> 24, _ = Zt ^ _n + mt, j[ht + 4 | 0] = _, j[ht + 5 | 0] = _ >>> 8, j[ht + 6 | 0] = _ >>> 16, j[ht + 7 | 0] = _ >>> 24, er = !(Zn = Zn + 1 | 0) + er | 0, !U & b >>> 0 <= 64) {
                          if (!(!b | !U & b >>> 0 > 63 | (0 | U) != 0))
                            for (Tt = 0; j[Tt + Cr | 0] = B[ht + Tt | 0], b >>> 0 > (Tt = Tt + 1 | 0) >>> 0; )
                              ;
                          l[A + 52 >> 2] = er, l[A + 48 >> 2] = Zn;
                          break;
                        }
                        g = g - -64 | 0, _ = ht - -64 | 0, U = U - 1 | 0, U = (b = b + -64 | 0) >>> 0 < 4294967232 ? U + 1 | 0 : U;
                      }
                    }
                    function Ui(A, g) {
                      g |= 0;
                      var _, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0;
                      return st = _ = st - 704 | 0, b = 80 + ((U = l[72 + (A |= 0) >> 2] >>> 3 & 127) + A | 0) | 0, U >>> 0 <= 111 ? xr(b, 35104, 112 - U | 0) : (xr(b, 35104, 128 - U | 0), rr(A, U = A + 80 | 0, _, _ + 640 | 0), Jt(U, 0, 112)), me = (ie = l[A + 64 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 68 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[A + 192 | 0] = b, j[A + 193 | 0] = b >>> 8, j[A + 194 | 0] = b >>> 16, j[A + 195 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[A + 196 | 0] = U, j[A + 197 | 0] = U >>> 8, j[A + 198 | 0] = U >>> 16, j[A + 199 | 0] = U >>> 24, me = (ie = l[A + 72 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 76 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[A + 200 | 0] = b, j[A + 201 | 0] = b >>> 8, j[A + 202 | 0] = b >>> 16, j[A + 203 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[A + 204 | 0] = U, j[A + 205 | 0] = U >>> 8, j[A + 206 | 0] = U >>> 16, j[A + 207 | 0] = U >>> 24, rr(A, A + 80 | 0, _, _ + 640 | 0), me = (ie = l[A >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 4 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[0 | g] = b, j[g + 1 | 0] = b >>> 8, j[g + 2 | 0] = b >>> 16, j[g + 3 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[g + 4 | 0] = U, j[g + 5 | 0] = U >>> 8, j[g + 6 | 0] = U >>> 16, j[g + 7 | 0] = U >>> 24, me = (ie = l[A + 8 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 12 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[g + 8 | 0] = b, j[g + 9 | 0] = b >>> 8, j[g + 10 | 0] = b >>> 16, j[g + 11 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[g + 12 | 0] = U, j[g + 13 | 0] = U >>> 8, j[g + 14 | 0] = U >>> 16, j[g + 15 | 0] = U >>> 24, me = (ie = l[A + 16 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 20 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[g + 16 | 0] = b, j[g + 17 | 0] = b >>> 8, j[g + 18 | 0] = b >>> 16, j[g + 19 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[g + 20 | 0] = U, j[g + 21 | 0] = U >>> 8, j[g + 22 | 0] = U >>> 16, j[g + 23 | 0] = U >>> 24, me = (ie = l[A + 24 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 28 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[g + 24 | 0] = b, j[g + 25 | 0] = b >>> 8, j[g + 26 | 0] = b >>> 16, j[g + 27 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[g + 28 | 0] = U, j[g + 29 | 0] = U >>> 8, j[g + 30 | 0] = U >>> 16, j[g + 31 | 0] = U >>> 24, me = (ie = l[A + 32 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 36 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[g + 32 | 0] = b, j[g + 33 | 0] = b >>> 8, j[g + 34 | 0] = b >>> 16, j[g + 35 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[g + 36 | 0] = U, j[g + 37 | 0] = U >>> 8, j[g + 38 | 0] = U >>> 16, j[g + 39 | 0] = U >>> 24, me = (ie = l[A + 40 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 44 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[g + 40 | 0] = b, j[g + 41 | 0] = b >>> 8, j[g + 42 | 0] = b >>> 16, j[g + 43 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[g + 44 | 0] = U, j[g + 45 | 0] = U >>> 8, j[g + 46 | 0] = U >>> 16, j[g + 47 | 0] = U >>> 24, me = (ie = l[A + 48 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, b = _e | D << 8 | -16777216 & ((255 & (b = l[A + 52 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & b) << 8 | ie >>> 24) | b >>> 8 & 65280 | b >>> 24, j[g + 48 | 0] = b, j[g + 49 | 0] = b >>> 8, j[g + 50 | 0] = b >>> 16, j[g + 51 | 0] = b >>> 24, U = (b = U | he | me) | (U = 0) | U | 0, j[g + 52 | 0] = U, j[g + 53 | 0] = U >>> 8, j[g + 54 | 0] = U >>> 16, j[g + 55 | 0] = U >>> 24, me = (ie = l[A + 56 >> 2]) << 24 | (65280 & ie) << 8, U = (he = 16711680 & ie) >>> 8 | 0, b = g, _e = he << 24, he = (D = -16777216 & ie) >>> 24 | 0, g = _e | D << 8 | -16777216 & ((255 & (g = l[A + 60 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & g) << 8 | ie >>> 24) | g >>> 8 & 65280 | g >>> 24, j[b + 56 | 0] = g, j[b + 57 | 0] = g >>> 8, j[b + 58 | 0] = g >>> 16, j[b + 59 | 0] = g >>> 24, g = (g = U | he | me) | (U = 0) | U | 0, j[b + 60 | 0] = g, j[b + 61 | 0] = g >>> 8, j[b + 62 | 0] = g >>> 16, j[b + 63 | 0] = g >>> 24, Wr(_, 704), Wr(A, 208), st = _ + 704 | 0, 0;
                    }
                    function Ni(A, g) {
                      var _, b, U, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0;
                      st = _ = st - 848 | 0, D = l[(ie = g + 40 | 0) >> 2], me = l[g + 80 >> 2], he = l[g + 44 >> 2], _e = l[g + 84 >> 2], Be = l[g + 48 >> 2], we = l[g + 88 >> 2], $e = l[g + 52 >> 2], Le = l[g + 92 >> 2], Ge = l[g + 56 >> 2], je = l[g + 96 >> 2], ct = l[g + 60 >> 2], mt = l[g + 100 >> 2], ht = l[(bt = g - -64 | 0) >> 2], Ct = l[g + 104 >> 2], Tt = l[g + 68 >> 2], Gt = l[g + 108 >> 2], en = l[g + 72 >> 2], it = l[g + 112 >> 2], St = l[g + 76 >> 2], ye = l[g + 116 >> 2], l[_ + 324 >> 2] = St + ye, l[_ + 320 >> 2] = en + it, l[_ + 316 >> 2] = Tt + Gt, l[_ + 312 >> 2] = ht + Ct, l[_ + 308 >> 2] = ct + mt, l[_ + 304 >> 2] = Ge + je, l[_ + 300 >> 2] = $e + Le, l[_ + 296 >> 2] = Be + we, l[_ + 292 >> 2] = he + _e, l[_ + 288 >> 2] = D + me, l[_ + 36 >> 2] = ye - St, l[_ + 32 >> 2] = it - en, l[_ + 28 >> 2] = Gt - Tt, l[_ + 24 >> 2] = Ct - ht, l[_ + 20 >> 2] = mt - ct, l[_ + 16 >> 2] = je - Ge, l[_ + 12 >> 2] = Le - $e, l[_ + 8 >> 2] = we - Be, l[_ + 4 >> 2] = _e - he, l[_ >> 2] = me - D, In(D = _ + 288 | 0, D, _), In(he = _ + 240 | 0, g, ie), Ot(me = _ + 192 | 0, he), In(me, D, me), l[_ + 452 >> 2] = 0, l[_ + 456 >> 2] = 0, l[_ + 460 >> 2] = 0, l[_ + 464 >> 2] = 0, l[_ + 468 >> 2] = 0, l[_ + 436 >> 2] = 0, l[_ + 440 >> 2] = 0, l[_ + 444 >> 2] = 0, l[_ + 448 >> 2] = 0, l[_ + 432 >> 2] = 1, ya(_e = _ + 576 | 0, _ + 432 | 0, me), In(me = _ + 768 | 0, _e, D), In(Be = _ + 720 | 0, _e, he), In(D = _ + 48 | 0, me, Be), In(D, D, he = g + 120 | 0), In(_ + 528 | 0, g, 1648), In(_ + 480 | 0, ie, 1648), In(_ + 624 | 0, me, 2960), In(me = _ + 336 | 0, he, D), Ei(b = _ + 672 | 0, me), me = l[ie >> 2], he = l[g + 44 >> 2], _e = l[g + 48 >> 2], Be = l[g + 52 >> 2], we = l[g + 56 >> 2], $e = l[g + 60 >> 2], Le = l[bt >> 2], Ge = l[g + 68 >> 2], je = l[g + 72 >> 2], ct = l[g + 76 >> 2], mt = l[g + 4 >> 2], ht = l[g + 8 >> 2], Ct = l[g + 12 >> 2], Tt = l[g + 16 >> 2], Gt = l[g + 20 >> 2], en = l[g + 24 >> 2], it = l[g + 28 >> 2], bt = l[g + 32 >> 2], St = l[g >> 2], ye = l[_ + 720 >> 2], fn = l[_ + 724 >> 2], _n = l[_ + 728 >> 2], wn = l[_ + 732 >> 2], $n = l[_ + 736 >> 2], qn = l[_ + 740 >> 2], Gn = l[_ + 744 >> 2], Kn = l[_ + 748 >> 2], Kt = l[_ + 752 >> 2], U = l[_ + 756 >> 2], pn = l[_ + 480 >> 2], Hn = l[_ + 484 >> 2], Zn = l[_ + 488 >> 2], er = l[_ + 492 >> 2], Zt = l[_ + 496 >> 2], Sn = l[_ + 500 >> 2], or = l[_ + 504 >> 2], ur = l[_ + 508 >> 2], Cr = l[_ + 512 >> 2], ie = 0 - (1 & j[_ + 672 | 0]) | 0, Ft = l[g + 36 >> 2], l[_ + 180 >> 2] = ie & (Ft ^ l[_ + 516 >> 2]) ^ Ft, l[_ + 176 >> 2] = bt ^ ie & (bt ^ Cr), l[_ + 172 >> 2] = it ^ ie & (it ^ ur), l[_ + 168 >> 2] = en ^ ie & (en ^ or), l[_ + 164 >> 2] = Gt ^ ie & (Gt ^ Sn), l[_ + 160 >> 2] = Tt ^ ie & (Tt ^ Zt), l[_ + 156 >> 2] = Ct ^ ie & (Ct ^ er), l[_ + 152 >> 2] = ht ^ ie & (ht ^ Zn), l[_ + 148 >> 2] = mt ^ ie & (mt ^ Hn), l[_ + 144 >> 2] = St ^ ie & (St ^ pn), mt = l[_ + 528 >> 2], ht = l[_ + 532 >> 2], Ct = l[_ + 536 >> 2], Tt = l[_ + 540 >> 2], Gt = l[_ + 544 >> 2], en = l[_ + 548 >> 2], it = l[_ + 552 >> 2], bt = l[_ + 556 >> 2], St = l[_ + 560 >> 2], pn = l[_ + 564 >> 2], Hn = l[_ + 624 >> 2], Zn = l[_ + 628 >> 2], er = l[_ + 632 >> 2], Zt = l[_ + 636 >> 2], Sn = l[_ + 640 >> 2], or = l[_ + 644 >> 2], ur = l[_ + 648 >> 2], Cr = l[_ + 652 >> 2], Ft = l[_ + 656 >> 2], l[_ + 708 >> 2] = ie & (l[_ + 660 >> 2] ^ U) ^ U, l[_ + 704 >> 2] = Kt ^ ie & (Kt ^ Ft), l[_ + 700 >> 2] = Kn ^ ie & (Kn ^ Cr), l[_ + 696 >> 2] = Gn ^ ie & (Gn ^ ur), l[_ + 692 >> 2] = qn ^ ie & (qn ^ or), l[_ + 688 >> 2] = $n ^ ie & ($n ^ Sn), l[_ + 684 >> 2] = wn ^ ie & (wn ^ Zt), l[_ + 680 >> 2] = _n ^ ie & (_n ^ er), l[_ + 676 >> 2] = fn ^ ie & (fn ^ Zn), l[_ + 672 >> 2] = ye ^ ie & (ye ^ Hn), In(ye = _ + 96 | 0, _ + 144 | 0, D), Ei(D = _ + 384 | 0, ye), ye = l[g + 80 >> 2], fn = l[g + 84 >> 2], _n = l[g + 88 >> 2], wn = l[g + 92 >> 2], $n = l[g + 96 >> 2], qn = l[g + 100 >> 2], Gn = l[g + 104 >> 2], Kn = l[g + 108 >> 2], Kt = l[g + 112 >> 2], Ft = l[g + 116 >> 2], g = 0 - (1 & j[_ + 384 | 0]) | 0, ct ^= ie & (ct ^ pn), l[_ + 420 >> 2] = Ft - (g & (0 - ct ^ ct) ^ ct), je ^= ie & (je ^ St), l[_ + 416 >> 2] = Kt - (g & (0 - je ^ je) ^ je), Ge ^= ie & (Ge ^ bt), l[_ + 412 >> 2] = Kn - (g & (0 - Ge ^ Ge) ^ Ge), Le ^= ie & (Le ^ it), l[_ + 408 >> 2] = Gn - (g & (0 - Le ^ Le) ^ Le), $e ^= ie & ($e ^ en), l[_ + 404 >> 2] = qn - (g & (0 - $e ^ $e) ^ $e), we ^= ie & (we ^ Gt), l[_ + 400 >> 2] = $n - (g & (0 - we ^ we) ^ we), Be ^= ie & (Be ^ Tt), l[_ + 396 >> 2] = wn - (g & (0 - Be ^ Be) ^ Be), _e ^= ie & (_e ^ Ct), l[_ + 392 >> 2] = _n - (g & (0 - _e ^ _e) ^ _e), he ^= ie & (he ^ ht), l[_ + 388 >> 2] = fn - (g & (0 - he ^ he) ^ he), he = g, g = me ^ ie & (me ^ mt), l[_ + 384 >> 2] = ye - (he & (0 - g ^ g) ^ g), In(D, b, D), Ei(_ + 816 | 0, D), g = 0 - (1 & j[_ + 816 | 0]) | 0, ie = l[_ + 384 >> 2], l[_ + 384 >> 2] = g & (0 - ie ^ ie) ^ ie, ie = l[_ + 388 >> 2], l[_ + 388 >> 2] = g & (0 - ie ^ ie) ^ ie, ie = l[_ + 392 >> 2], l[_ + 392 >> 2] = g & (0 - ie ^ ie) ^ ie, ie = l[_ + 396 >> 2], l[_ + 396 >> 2] = g & (0 - ie ^ ie) ^ ie, ie = l[_ + 400 >> 2], l[_ + 400 >> 2] = g & (0 - ie ^ ie) ^ ie, ie = l[_ + 404 >> 2], l[_ + 404 >> 2] = g & (0 - ie ^ ie) ^ ie, ie = l[_ + 408 >> 2], l[_ + 408 >> 2] = g & (0 - ie ^ ie) ^ ie, ie = l[_ + 412 >> 2], l[_ + 412 >> 2] = g & (0 - ie ^ ie) ^ ie, ie = l[_ + 416 >> 2], l[_ + 416 >> 2] = g & (0 - ie ^ ie) ^ ie, he = g, g = l[_ + 420 >> 2], l[_ + 420 >> 2] = he & (0 - g ^ g) ^ g, Ei(A, D), st = _ + 848 | 0;
                    }
                    function da(A, g, _, b, U) {
                      A |= 0, g |= 0, _ |= 0, b |= 0;
                      var ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0;
                      if (me = 1886610805 ^ (b = B[0 | (U |= 0)] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24), he = 1936682341 ^ (ie = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24), _e = 1852142177 ^ b, D = 1819895653 ^ ie, ie = 1852075885 ^ (b = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24), U = 1685025377 ^ (ye = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24), Be = 2037671283 ^ b, ye ^= 1952801890, (0 | (b = (g + _ | 0) - (Le = 7 & _) | 0)) != (0 | g)) {
                        for (; _e = _e + (Be ^= bt = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24) | 0, D = D + (we = ye ^ (ht = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24)) | 0, D = _e >>> 0 < Be >>> 0 ? D + 1 | 0 : D, $e = 1 + (he = U + he | 0) | 0, ye = he, ye = me >>> 0 > (he = ie + me | 0) >>> 0 ? $e : ye, me = _e + (U = q(ie, U, 13) ^ he) | 0, ie = D + ($e = ve ^ ye) | 0, $e = q(U, $e, 17) ^ me, mt = q($e, ct = (je = U >>> 0 > me >>> 0 ? ie + 1 | 0 : ie) ^ ve, 13), Ge = ve, U = q(Be, we, 16), ie = D ^ ve, D = U ^ _e, _e = q(he, ye, 32), he = ve + ie | 0, ye = 1 + (_e = ct + (Be = (U = D + _e | 0) >>> 0 < _e >>> 0 ? he + 1 | 0 : he) | 0) | 0, he = _e, he = (_e = U + $e | 0) >>> 0 < U >>> 0 ? ye : he, ct = q(ye = _e ^ mt, we = he ^ Ge, 17), mt = ve, ie = q(D, ie, 21), D = Be ^ ve, Be = U ^ ie, U = q(me, je, 32), ie = ve + D | 0, U = (je = U >>> 0 > (me = Be + U | 0) >>> 0 ? ie + 1 | 0 : ie) + we | 0, ie = (we = me + ye | 0) ^ ct, U = ($e = we >>> 0 < me >>> 0 ? U + 1 | 0 : U) ^ mt, D = q(Be, D, 16), ye = Be = je ^ ve, D = q(me ^= D, Be, 21), je = ve, Be = (me = (_e = q(_e, he, 32)) + me | 0) ^ D, he = ve + ye | 0, ye = (he = me >>> 0 < _e >>> 0 ? he + 1 | 0 : he) ^ je, _e = q(we, $e, 32), D = ve, me ^= bt, he ^= ht, (0 | b) != (0 | (g = g + 8 | 0)); )
                          ;
                        g = b;
                      }
                      switch (_ <<= 24, b = 0, Le - 1 | 0) {
                        case 6:
                          _ |= B[g + 6 | 0] << 16;
                        case 5:
                          _ |= B[g + 5 | 0] << 8;
                        case 4:
                          _ |= B[g + 4 | 0];
                        case 3:
                          we = (b = B[g + 3 | 0]) >>> 8 | 0, b <<= 24, _ |= we;
                        case 2:
                          b |= (we = B[g + 2 | 0]) << 16, _ |= $e = we >>> 16 | 0;
                        case 1:
                          b |= (we = B[g + 1 | 0]) << 8, _ |= $e = we >>> 24 | 0;
                        case 0:
                          b = B[0 | g] | b;
                      }
                      return ye = q(g = b ^ Be, Be = _ ^ ye, 16), D = D + Be | 0, _e = (g = g + _e | 0) >>> 0 < _e >>> 0 ? D + 1 | 0 : D, ye = q(D = g ^ ye, Be = _e ^ ve, 21), we = ve, Ge = 1 + (he = U + he | 0) | 0, $e = he, $e = me = me >>> 0 > (he = ie + me | 0) >>> 0 ? Ge : $e, Le = q(he, me, 32), Be = ve + Be | 0, we = q(D = ye ^ (me = D + Le | 0), ye = we ^ (Be = me >>> 0 < Le >>> 0 ? Be + 1 | 0 : Be), 16), Le = ve, U = q(ie, U, 13) ^ he, ie = (he = _e) + (_e = ve ^ $e) | 0, $e = q(g = g + U | 0, he = g >>> 0 < U >>> 0 ? ie + 1 | 0 : ie, 32), ye = ve + ye | 0, $e = q(D = we ^ (ie = D + $e | 0), we = (ye = ie >>> 0 < $e >>> 0 ? ye + 1 | 0 : ye) ^ Le, 21), Le = ve, g = me + (U = _e = q(U, _e, 17) ^ g) | 0, me = (he ^= ve) + Be | 0, Be = U = g >>> 0 < U >>> 0 ? me + 1 | 0 : me, Ge = $e, me = D + ($e = q(g, U, 32)) | 0, D = ve + we | 0, $e = q(U = Ge ^ me, we = (D = me >>> 0 < $e >>> 0 ? D + 1 | 0 : D) ^ Le, 16), Le = ve, Ge = ie, he = q(_e, he, 13) ^ g, _e = (Be ^= ve) + ye | 0, ye = ie = (g = Ge + (ie = he) | 0) >>> 0 < ie >>> 0 ? _e + 1 | 0 : _e, ie = q(g, ie, 32), _e = we + ve | 0, we = (Ge = U) >>> 0 > (U = U + (255 ^ ie) | 0) >>> 0 ? _e + 1 | 0 : _e, $e = q(_e = U ^ $e, ie = Le ^ we, 21), Le = ve, he = q(he, Be, 17) ^ g, _ = (Be = ye ^ ve) + (_ ^ D) | 0, _ = q(g = he + (b ^= me) | 0, D = _ = g >>> 0 < b >>> 0 ? _ + 1 | 0 : _, 32), b = ie + ve | 0, _e = q(me = (_ = _ + _e | 0) ^ $e, b = (ie = _ >>> 0 < _e >>> 0 ? b + 1 | 0 : b) ^ Le, 16), ye = ve, he = q(he, Be, 13) ^ g, Be = we + (D ^= ve) | 0, Be = U = (g = U + he | 0) >>> 0 < U >>> 0 ? Be + 1 | 0 : Be, U = q(g, U, 32), $e = ye, Ge = 1 + (b = b + ve | 0) | 0, ye = b, ye = (b = U + me | 0) >>> 0 < me >>> 0 ? Ge : ye, _e = q(me = b ^ _e, U = $e ^ ye, 21), we = ve, he = q(he, D, 17), Ge = 1 + (ie = ie + (D = Be ^ ve) | 0) | 0, $e = ie, he = g = (Be = _) >>> 0 > (_ = _ + (ie = g ^ he) | 0) >>> 0 ? Ge : $e, g = q(_, g, 32), U = U + ve | 0, Be = (g = g + me | 0) >>> 0 < me >>> 0 ? U + 1 | 0 : U, _e = q(me = g ^ _e, U = Be ^ we, 16), we = ve, ie = q(ie, D, 13), D = ye + (he ^= ve) | 0, ye = b, _ = q(b = b + (ie ^= _) | 0, D = _ = ye >>> 0 > b >>> 0 ? D + 1 | 0 : D, 32), U = U + ve | 0, ye = (_ = _ + me | 0) >>> 0 < me >>> 0 ? U + 1 | 0 : U, _e = q(me = _ ^ _e, U = ye ^ we, 21), we = ve, ie = q(ie, he, 17), $e = 1 + (D = Be + (he = D ^ ve) | 0) | 0, Be = D, g = q(b = g + (D = b ^ ie) | 0, ie = b >>> 0 < g >>> 0 ? $e : Be, 32), U = U + ve | 0, Be = (g = g + me | 0) >>> 0 < me >>> 0 ? U + 1 | 0 : U, _e = q(me = g ^ _e, U = Be ^ we, 16), we = ve, he = q(D, he, 13), D = ye + (ie ^= ve) | 0, _ = q(b = _ + (he ^= b) | 0, D = _ = b >>> 0 < _ >>> 0 ? D + 1 | 0 : D, 32), U = U + ve | 0, me = q((_ = _ + me | 0) ^ _e, (U = _ >>> 0 < me >>> 0 ? U + 1 | 0 : U) ^ we, 21), _e = ve, b = q(he, ie, 17) ^ b, he = q(b, ie = D ^ ve, 13), ie = ie + Be | 0, g = ve ^ (g >>> 0 > (b = g + b | 0) >>> 0 ? ie + 1 | 0 : ie), me = q(b ^= he, g, 17) ^ me, ie = ve ^ _e, he = 1 + (g = g + U | 0) | 0, U = g, g = q(g = _ + b | 0, _ = _ >>> 0 > g >>> 0 ? he : U, 32) ^ me ^ g, j[0 | A] = g, j[A + 1 | 0] = g >>> 8, j[A + 2 | 0] = g >>> 16, j[A + 3 | 0] = g >>> 24, g = _ ^ ve ^ ie, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, 0;
                    }
                    function ma(A, g) {
                      var _, b, U, ie, he, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0;
                      st = _ = st - 624 | 0, Ot(D = _ + 480 | 0, g), In(D, 1648, D), _e = l[_ + 516 >> 2], l[_ + 276 >> 2] = _e, Be = l[_ + 512 >> 2], l[_ + 272 >> 2] = Be, ye = l[_ + 508 >> 2], l[_ + 268 >> 2] = ye, we = l[_ + 504 >> 2], l[_ + 264 >> 2] = we, $e = l[_ + 500 >> 2], l[_ + 260 >> 2] = $e, Le = l[_ + 496 >> 2], l[_ + 256 >> 2] = Le, Ge = l[_ + 492 >> 2], l[_ + 252 >> 2] = Ge, je = l[_ + 488 >> 2], l[_ + 248 >> 2] = je, ct = l[_ + 484 >> 2], l[_ + 244 >> 2] = ct, bt = l[_ + 480 >> 2], l[_ + 240 >> 2] = bt + 1, In(me = _ + 240 | 0, me, 33984), l[_ + 468 >> 2] = _e - 12055116, l[_ + 464 >> 2] = Be - 18696448, l[_ + 460 >> 2] = ye - 3247719, l[_ + 456 >> 2] = we - 6275908, l[_ + 452 >> 2] = $e - 8787816, l[_ + 448 >> 2] = Le + 114729, l[_ + 444 >> 2] = Ge + 6949391, l[_ + 440 >> 2] = je - 15372611, l[_ + 436 >> 2] = ct + 13857413, l[_ + 432 >> 2] = bt - 10913610, In(mt = _ + 192 | 0, D, 1600), l[_ + 228 >> 2] = 0 - l[_ + 228 >> 2], l[_ + 224 >> 2] = 0 - l[_ + 224 >> 2], l[_ + 220 >> 2] = 0 - l[_ + 220 >> 2], l[_ + 216 >> 2] = 0 - l[_ + 216 >> 2], l[_ + 212 >> 2] = 0 - l[_ + 212 >> 2], l[_ + 208 >> 2] = 0 - l[_ + 208 >> 2], l[_ + 204 >> 2] = 0 - l[_ + 204 >> 2], l[_ + 200 >> 2] = 0 - l[_ + 200 >> 2], l[_ + 196 >> 2] = 0 - l[_ + 196 >> 2], l[_ + 192 >> 2] = -1 ^ l[_ + 192 >> 2], In(mt, mt, _ + 432 | 0), D = ya(b = _ + 384 | 0, me, mt), In(me = _ + 336 | 0, b, g), Ei(U = _ + 576 | 0, me), he = B[_ + 576 | 0], _n = l[_ + 420 >> 2], me = l[_ + 372 >> 2], wn = l[_ + 416 >> 2], ht = l[_ + 368 >> 2], $n = l[_ + 412 >> 2], Ct = l[_ + 364 >> 2], qn = l[_ + 408 >> 2], Tt = l[_ + 360 >> 2], Gn = l[_ + 404 >> 2], Gt = l[_ + 356 >> 2], Kn = l[_ + 400 >> 2], en = l[_ + 352 >> 2], Kt = l[_ + 396 >> 2], it = l[_ + 348 >> 2], pn = l[_ + 392 >> 2], St = l[_ + 344 >> 2], Hn = l[_ + 388 >> 2], Ft = l[_ + 340 >> 2], ie = l[_ + 384 >> 2], fn = l[_ + 336 >> 2], g = D - 1 | 0, l[_ + 612 >> 2] = g & _e, l[_ + 608 >> 2] = g & Be, l[_ + 604 >> 2] = g & ye, l[_ + 600 >> 2] = g & we, l[_ + 596 >> 2] = g & $e, l[_ + 592 >> 2] = g & Le, l[_ + 588 >> 2] = g & Ge, l[_ + 584 >> 2] = g & je, l[_ + 580 >> 2] = g & ct, l[_ + 576 >> 2] = bt | 0 - D, fn = g & (0 - (fn ^ (D = 0 - (1 & he) | 0) & (fn ^ 0 - fn)) ^ ie) ^ ie, l[_ + 384 >> 2] = fn, Ft = Hn ^ g & (Hn ^ 0 - (Ft ^ D & (Ft ^ 0 - Ft))), l[_ + 388 >> 2] = Ft, St = pn ^ g & (pn ^ 0 - (St ^ D & (St ^ 0 - St))), l[_ + 392 >> 2] = St, it = Kt ^ g & (Kt ^ 0 - (it ^ D & (it ^ 0 - it))), l[_ + 396 >> 2] = it, en = Kn ^ g & (Kn ^ 0 - (en ^ D & (en ^ 0 - en))), l[_ + 400 >> 2] = en, Gt = Gn ^ g & (Gn ^ 0 - (Gt ^ D & (Gt ^ 0 - Gt))), l[_ + 404 >> 2] = Gt, Tt = qn ^ g & (qn ^ 0 - (Tt ^ D & (Tt ^ 0 - Tt))), l[_ + 408 >> 2] = Tt, Ct = $n ^ g & ($n ^ 0 - (Ct ^ D & (Ct ^ 0 - Ct))), l[_ + 412 >> 2] = Ct, ht = wn ^ g & (wn ^ 0 - (ht ^ D & (ht ^ 0 - ht))), l[_ + 416 >> 2] = ht, D = _n ^ g & (_n ^ 0 - (me ^ D & (me ^ 0 - me))), l[_ + 420 >> 2] = D, l[_ + 564 >> 2] = _e, l[_ + 560 >> 2] = Be, l[_ + 556 >> 2] = ye, l[_ + 552 >> 2] = we, l[_ + 548 >> 2] = $e, l[_ + 544 >> 2] = Le, l[_ + 540 >> 2] = Ge, l[_ + 536 >> 2] = je, l[_ + 532 >> 2] = ct, l[_ + 528 >> 2] = bt - 1, In(g = _ + 528 | 0, g, U), In(g, g, 34032), _e = l[_ + 192 >> 2], Be = l[_ + 528 >> 2], ye = l[_ + 196 >> 2], we = l[_ + 532 >> 2], $e = l[_ + 200 >> 2], Le = l[_ + 536 >> 2], Ge = l[_ + 204 >> 2], je = l[_ + 540 >> 2], ct = l[_ + 208 >> 2], bt = l[_ + 544 >> 2], me = l[_ + 212 >> 2], _n = l[_ + 548 >> 2], wn = l[_ + 216 >> 2], $n = l[_ + 552 >> 2], qn = l[_ + 220 >> 2], Gn = l[_ + 556 >> 2], Kn = l[_ + 224 >> 2], Kt = l[_ + 560 >> 2], pn = l[_ + 228 >> 2], Hn = l[_ + 564 >> 2], l[_ + 180 >> 2] = D << 1, l[_ + 176 >> 2] = ht << 1, l[_ + 172 >> 2] = Ct << 1, l[_ + 168 >> 2] = Tt << 1, l[_ + 164 >> 2] = Gt << 1, l[_ + 160 >> 2] = en << 1, l[_ + 156 >> 2] = it << 1, l[_ + 152 >> 2] = St << 1, l[_ + 148 >> 2] = Ft << 1, l[_ + 144 >> 2] = fn << 1, l[_ + 564 >> 2] = Hn - pn, l[_ + 560 >> 2] = Kt - Kn, l[_ + 556 >> 2] = Gn - qn, l[_ + 552 >> 2] = $n - wn, l[_ + 548 >> 2] = _n - me, l[_ + 544 >> 2] = bt - ct, l[_ + 540 >> 2] = je - Ge, l[_ + 536 >> 2] = Le - $e, l[_ + 532 >> 2] = we - ye, l[_ + 528 >> 2] = Be - _e, In(D = _ + 144 | 0, D, mt), In(mt = _ + 96 | 0, g, 34080), Ot(_ + 288 | 0, b), g = l[_ + 324 >> 2], l[_ + 84 >> 2] = 0 - g, _e = l[_ + 320 >> 2], l[_ + 80 >> 2] = 0 - _e, Be = l[_ + 316 >> 2], l[_ + 76 >> 2] = 0 - Be, ye = l[_ + 312 >> 2], l[_ + 72 >> 2] = 0 - ye, we = l[_ + 308 >> 2], l[_ + 68 >> 2] = 0 - we, $e = l[_ + 304 >> 2], l[_ + 64 >> 2] = 0 - $e, Le = l[_ + 300 >> 2], l[_ + 60 >> 2] = 0 - Le, Ge = l[_ + 296 >> 2], l[_ + 56 >> 2] = 0 - Ge, je = l[_ + 292 >> 2], l[_ + 52 >> 2] = 0 - je, ct = l[_ + 288 >> 2], l[_ + 48 >> 2] = 1 - ct, l[_ + 36 >> 2] = g, l[_ + 32 >> 2] = _e, l[_ + 28 >> 2] = Be, l[_ + 24 >> 2] = ye, l[_ + 20 >> 2] = we, l[_ + 16 >> 2] = $e, l[_ + 12 >> 2] = Le, l[_ + 8 >> 2] = Ge, l[_ + 4 >> 2] = je, l[_ >> 2] = ct + 1, In(A, D, _), In(A + 40 | 0, g = _ + 48 | 0, mt), In(A + 80 | 0, mt, _), In(A + 120 | 0, D, g), st = _ + 624 | 0;
                    }
                    function ga(A) {
                      var g, _, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0;
                      for (st = g = st - 2048 | 0, Bi(ye = g + 640 | 0, A), b = l[A + 8 >> 2], U = l[A + 12 >> 2], ie = l[A + 16 >> 2], he = l[A + 20 >> 2], _e = l[A + 24 >> 2], Be = l[A + 28 >> 2], D = l[A >> 2], me = l[A + 4 >> 2], we = l[A + 36 >> 2], l[g + 352 >> 2] = l[A + 32 >> 2], l[g + 356 >> 2] = we, l[g + 344 >> 2] = _e, l[g + 348 >> 2] = Be, l[g + 336 >> 2] = ie, l[g + 340 >> 2] = he, l[g + 328 >> 2] = b, l[g + 332 >> 2] = U, l[g + 320 >> 2] = D, l[g + 324 >> 2] = me, b = l[A + 40 >> 2], U = l[A + 44 >> 2], ie = l[A + 48 >> 2], he = l[A + 52 >> 2], _e = l[A + 56 >> 2], Be = l[A + 60 >> 2], me = l[(D = A - -64 | 0) >> 2], D = l[D + 4 >> 2], we = l[A + 76 >> 2], l[g + 392 >> 2] = l[A + 72 >> 2], l[g + 396 >> 2] = we, l[g + 384 >> 2] = me, l[g + 388 >> 2] = D, l[g + 376 >> 2] = _e, l[g + 380 >> 2] = Be, l[g + 368 >> 2] = ie, l[g + 372 >> 2] = he, l[g + 360 >> 2] = b, l[g + 364 >> 2] = U, b = l[A + 80 >> 2], U = l[A + 84 >> 2], ie = l[A + 88 >> 2], he = l[A + 92 >> 2], _e = l[A + 96 >> 2], Be = l[A + 100 >> 2], D = l[A + 104 >> 2], me = l[A + 108 >> 2], we = l[A + 116 >> 2], l[g + 432 >> 2] = l[A + 112 >> 2], l[g + 436 >> 2] = we, l[g + 424 >> 2] = D, l[g + 428 >> 2] = me, l[g + 416 >> 2] = _e, l[g + 420 >> 2] = Be, l[g + 408 >> 2] = ie, l[g + 412 >> 2] = he, l[g + 400 >> 2] = b, l[g + 404 >> 2] = U, Se(A = g + 480 | 0, b = g + 320 | 0), In(D = g + 160 | 0, A, U = g + 600 | 0), In(g + 200 | 0, ie = g + 520 | 0, he = g + 560 | 0), In(g + 240 | 0, he, U), In(g + 280 | 0, A, ie), Si(A, D, ye), In(b, A, U), In(ye = g + 360 | 0, ie, he), In(_e = g + 400 | 0, he, U), In(Be = g + 440 | 0, A, ie), Bi(me = g + 800 | 0, b), Si(A, D, me), In(b, A, U), In(ye, ie, he), In(_e, he, U), In(Be, A, ie), Bi(me = g + 960 | 0, b), Si(A, D, me), In(b, A, U), In(ye, ie, he), In(_e, he, U), In(Be, A, ie), Bi(me = g + 1120 | 0, b), Si(A, D, me), In(b, A, U), In(ye, ie, he), In(_e, he, U), In(Be, A, ie), Bi(me = g + 1280 | 0, b), Si(A, D, me), In(b, A, U), In(ye, ie, he), In(_e, he, U), In(Be, A, ie), Bi(me = g + 1440 | 0, b), Si(A, D, me), In(b, A, U), In(ye, ie, he), In(_e, he, U), In(Be, A, ie), Bi(me = g + 1600 | 0, b), Si(A, D, me), In(b, A, U), In(ye, ie, he), In(_e, he, U), In(Be, A, ie), Bi(g + 1760 | 0, b), l[g + 32 >> 2] = 0, l[g + 36 >> 2] = 0, l[g + 24 >> 2] = 0, l[g + 28 >> 2] = 0, l[g + 16 >> 2] = 0, l[g + 20 >> 2] = 0, l[g + 8 >> 2] = 0, l[g + 12 >> 2] = 0, l[g + 44 >> 2] = 0, l[g + 48 >> 2] = 0, l[g + 52 >> 2] = 0, l[g + 56 >> 2] = 0, l[g + 60 >> 2] = 0, l[g + 64 >> 2] = 0, l[g + 68 >> 2] = 0, l[g + 72 >> 2] = 0, l[g + 76 >> 2] = 0, l[g + 80 >> 2] = 1, l[g >> 2] = 0, l[g + 4 >> 2] = 0, l[g + 40 >> 2] = 1, Jt(g + 84 | 0, 0, 76), me = g + 120 | 0, we = g + 80 | 0, _ = g + 40 | 0, A = 252; b = l[g + 36 >> 2], l[g + 1960 >> 2] = l[g + 32 >> 2], l[g + 1964 >> 2] = b, b = l[g + 28 >> 2], l[g + 1952 >> 2] = l[g + 24 >> 2], l[g + 1956 >> 2] = b, b = l[g + 20 >> 2], l[g + 1944 >> 2] = l[g + 16 >> 2], l[g + 1948 >> 2] = b, b = l[g + 12 >> 2], l[g + 1936 >> 2] = l[g + 8 >> 2], l[g + 1940 >> 2] = b, b = l[g + 4 >> 2], l[g + 1928 >> 2] = l[g >> 2], l[g + 1932 >> 2] = b, b = l[g + 76 >> 2], l[g + 2e3 >> 2] = l[g + 72 >> 2], l[g + 2004 >> 2] = b, b = l[g + 68 >> 2], l[g + 1992 >> 2] = l[g + 64 >> 2], l[g + 1996 >> 2] = b, b = l[g + 60 >> 2], l[g + 1984 >> 2] = l[g + 56 >> 2], l[g + 1988 >> 2] = b, b = l[g + 52 >> 2], l[g + 1976 >> 2] = l[g + 48 >> 2], l[g + 1980 >> 2] = b, b = l[g + 44 >> 2], l[g + 1968 >> 2] = l[g + 40 >> 2], l[g + 1972 >> 2] = b, b = l[g + 84 >> 2], l[g + 2008 >> 2] = l[g + 80 >> 2], l[g + 2012 >> 2] = b, b = l[g + 92 >> 2], l[g + 2016 >> 2] = l[g + 88 >> 2], l[g + 2020 >> 2] = b, b = l[g + 100 >> 2], l[g + 2024 >> 2] = l[g + 96 >> 2], l[g + 2028 >> 2] = b, b = l[g + 108 >> 2], l[g + 2032 >> 2] = l[g + 104 >> 2], l[g + 2036 >> 2] = b, b = l[g + 116 >> 2], l[g + 2040 >> 2] = l[g + 112 >> 2], l[g + 2044 >> 2] = b, b = A, A = j[A + 33728 | 0], Se(g + 480 | 0, g + 1928 | 0), (0 | A) > 0 ? (In($e = g + 320 | 0, D = g + 480 | 0, U), In(ye, ie, he), In(_e, he, U), In(Be, D, ie), Si(D, $e, (g + 640 | 0) + wr((254 & A) >>> 1 | 0, 160) | 0)) : (0 | A) >= 0 || (In($e = g + 320 | 0, D = g + 480 | 0, U), In(ye, ie, he), In(_e, he, U), In(Be, D, ie), Ts(D, $e, (g + 640 | 0) + wr((0 - A & 254) >>> 1 | 0, 160) | 0)), In(g, A = g + 480 | 0, U), In(_, ie, he), In(we, he, U), In(me, A, ie), A = b - 1 | 0, b; )
                        ;
                      return Ei(A = g + 640 | 0, g), A = le(A, 32), st = g + 2048 | 0, A;
                    }
                    function la(A, g, _) {
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0;
                      st = b = st + -64 | 0;
                      e: {
                        if ((_ - 65 & 255) >>> 0 > 191) {
                          if (U = -1, !(B[A + 80 | 0] | B[A + 81 | 0] << 8 | B[A + 82 | 0] << 16 | B[A + 83 | 0] << 24 | B[A + 84 | 0] | B[A + 85 | 0] << 8 | B[A + 86 | 0] << 16 | B[A + 87 | 0] << 24)) {
                            if ((D = B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24) >>> 0 >= 129) {
                              if (he = B[0 | (U = A - -64 | 0)] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, me = ie = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, ie = (D = he + 128 | 0) >>> 0 < 128 ? ie + 1 | 0 : ie, j[0 | U] = D, j[U + 1 | 0] = D >>> 8, j[U + 2 | 0] = D >>> 16, j[U + 3 | 0] = D >>> 24, j[U + 4 | 0] = ie, j[U + 5 | 0] = ie >>> 8, j[U + 6 | 0] = ie >>> 16, j[U + 7 | 0] = ie >>> 24, ie = B[A + 76 | 0] | B[A + 77 | 0] << 8 | B[A + 78 | 0] << 16 | B[A + 79 | 0] << 24, ie = (U = (0 | me) == -1 & he >>> 0 > 4294967167) >>> 0 > (he = U + (B[A + 72 | 0] | B[A + 73 | 0] << 8 | B[A + 74 | 0] << 16 | B[A + 75 | 0] << 24) | 0) >>> 0 ? ie + 1 | 0 : ie, j[A + 72 | 0] = he, j[A + 73 | 0] = he >>> 8, j[A + 74 | 0] = he >>> 16, j[A + 75 | 0] = he >>> 24, j[A + 76 | 0] = ie, j[A + 77 | 0] = ie >>> 8, j[A + 78 | 0] = ie >>> 16, j[A + 79 | 0] = ie >>> 24, $s(A, ie = A + 96 | 0), U = (B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24) - 128 | 0, j[A + 352 | 0] = U, j[A + 353 | 0] = U >>> 8, j[A + 354 | 0] = U >>> 16, j[A + 355 | 0] = U >>> 24, U >>> 0 >= 129)
                                break e;
                              xr(ie, A + 224 | 0, U), D = B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24;
                            }
                            ie = B[0 | (U = A - -64 | 0)] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, he = _e = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, he = (me = ie + D | 0) >>> 0 < D >>> 0 ? he + 1 | 0 : he, j[0 | U] = me, j[U + 1 | 0] = me >>> 8, j[U + 2 | 0] = me >>> 16, j[U + 3 | 0] = me >>> 24, j[U + 4 | 0] = he, j[U + 5 | 0] = he >>> 8, j[U + 6 | 0] = he >>> 16, j[U + 7 | 0] = he >>> 24, U = (0 | he) == (0 | _e) & ie >>> 0 > me >>> 0 | he >>> 0 < _e >>> 0, ie = B[A + 76 | 0] | B[A + 77 | 0] << 8 | B[A + 78 | 0] << 16 | B[A + 79 | 0] << 24, ie = (he = U + (B[A + 72 | 0] | B[A + 73 | 0] << 8 | B[A + 74 | 0] << 16 | B[A + 75 | 0] << 24) | 0) >>> 0 < U >>> 0 ? ie + 1 | 0 : ie, j[A + 72 | 0] = he, j[A + 73 | 0] = he >>> 8, j[A + 74 | 0] = he >>> 16, j[A + 75 | 0] = he >>> 24, j[A + 76 | 0] = ie, j[A + 77 | 0] = ie >>> 8, j[A + 78 | 0] = ie >>> 16, j[A + 79 | 0] = ie >>> 24, B[A + 356 | 0] && (j[A + 88 | 0] = 255, j[A + 89 | 0] = 255, j[A + 90 | 0] = 255, j[A + 91 | 0] = 255, j[A + 92 | 0] = 255, j[A + 93 | 0] = 255, j[A + 94 | 0] = 255, j[A + 95 | 0] = 255), j[A + 80 | 0] = 255, j[A + 81 | 0] = 255, j[A + 82 | 0] = 255, j[A + 83 | 0] = 255, j[A + 84 | 0] = 255, j[A + 85 | 0] = 255, j[A + 86 | 0] = 255, j[A + 87 | 0] = 255, Jt((U = A + 96 | 0) + D | 0, 0, 256 - D | 0), $s(A, U), ie = B[A + 4 | 0] | B[A + 5 | 0] << 8 | B[A + 6 | 0] << 16 | B[A + 7 | 0] << 24, l[b >> 2] = B[0 | A] | B[A + 1 | 0] << 8 | B[A + 2 | 0] << 16 | B[A + 3 | 0] << 24, l[b + 4 >> 2] = ie, ie = B[A + 12 | 0] | B[A + 13 | 0] << 8 | B[A + 14 | 0] << 16 | B[A + 15 | 0] << 24, l[b + 8 >> 2] = B[A + 8 | 0] | B[A + 9 | 0] << 8 | B[A + 10 | 0] << 16 | B[A + 11 | 0] << 24, l[b + 12 >> 2] = ie, ie = B[A + 20 | 0] | B[A + 21 | 0] << 8 | B[A + 22 | 0] << 16 | B[A + 23 | 0] << 24, l[b + 16 >> 2] = B[A + 16 | 0] | B[A + 17 | 0] << 8 | B[A + 18 | 0] << 16 | B[A + 19 | 0] << 24, l[b + 20 >> 2] = ie, ie = B[A + 28 | 0] | B[A + 29 | 0] << 8 | B[A + 30 | 0] << 16 | B[A + 31 | 0] << 24, l[b + 24 >> 2] = B[A + 24 | 0] | B[A + 25 | 0] << 8 | B[A + 26 | 0] << 16 | B[A + 27 | 0] << 24, l[b + 28 >> 2] = ie, ie = B[A + 36 | 0] | B[A + 37 | 0] << 8 | B[A + 38 | 0] << 16 | B[A + 39 | 0] << 24, l[b + 32 >> 2] = B[A + 32 | 0] | B[A + 33 | 0] << 8 | B[A + 34 | 0] << 16 | B[A + 35 | 0] << 24, l[b + 36 >> 2] = ie, ie = B[A + 44 | 0] | B[A + 45 | 0] << 8 | B[A + 46 | 0] << 16 | B[A + 47 | 0] << 24, l[b + 40 >> 2] = B[A + 40 | 0] | B[A + 41 | 0] << 8 | B[A + 42 | 0] << 16 | B[A + 43 | 0] << 24, l[b + 44 >> 2] = ie, ie = B[A + 52 | 0] | B[A + 53 | 0] << 8 | B[A + 54 | 0] << 16 | B[A + 55 | 0] << 24, l[b + 48 >> 2] = B[A + 48 | 0] | B[A + 49 | 0] << 8 | B[A + 50 | 0] << 16 | B[A + 51 | 0] << 24, l[b + 52 >> 2] = ie, ie = B[A + 60 | 0] | B[A + 61 | 0] << 8 | B[A + 62 | 0] << 16 | B[A + 63 | 0] << 24, l[b + 56 >> 2] = B[A + 56 | 0] | B[A + 57 | 0] << 8 | B[A + 58 | 0] << 16 | B[A + 59 | 0] << 24, l[b + 60 >> 2] = ie, xr(g, b, _), Wr(A, 64), Wr(U, 256), U = 0;
                          }
                          return st = b - -64 | 0, U;
                        }
                        Ai(), Xr();
                      }
                      Hs(1369, 1217, 306, 1142), Xr();
                    }
                    function _s(A, g, _) {
                      A |= 0, g |= 0, _ |= 0;
                      var b, U, ie, he = 0, D = 0;
                      st = b = st - 192 | 0, l[b + 144 >> 2] = 0, l[b + 148 >> 2] = 0, l[b + 152 >> 2] = 0, l[b + 156 >> 2] = 0, l[b + 104 >> 2] = 0, l[b + 108 >> 2] = 0, l[b + 112 >> 2] = 0, l[b + 116 >> 2] = 0, l[b + 120 >> 2] = 0, l[b + 124 >> 2] = 0, he = l[8595], l[b + 168 >> 2] = l[8594], l[b + 172 >> 2] = he, he = l[8597], l[b + 176 >> 2] = l[8596], l[b + 180 >> 2] = he, he = l[8599], l[b + 184 >> 2] = l[8598], l[b + 188 >> 2] = he, l[b + 128 >> 2] = 0, l[b + 132 >> 2] = 0, l[b + 136 >> 2] = 0, l[b + 140 >> 2] = 0, l[b + 96 >> 2] = 0, l[b + 100 >> 2] = 0, he = l[8593], l[b + 160 >> 2] = l[8592], l[b + 164 >> 2] = he, he = B[_ + 20 | 0] | B[_ + 21 | 0] << 8 | B[_ + 22 | 0] << 16 | B[_ + 23 | 0] << 24, l[b + 80 >> 2] = B[_ + 16 | 0] | B[_ + 17 | 0] << 8 | B[_ + 18 | 0] << 16 | B[_ + 19 | 0] << 24, l[b + 84 >> 2] = he, he = B[_ + 28 | 0] | B[_ + 29 | 0] << 8 | B[_ + 30 | 0] << 16 | B[_ + 31 | 0] << 24, l[b + 88 >> 2] = B[_ + 24 | 0] | B[_ + 25 | 0] << 8 | B[_ + 26 | 0] << 16 | B[_ + 27 | 0] << 24, l[b + 92 >> 2] = he, he = B[_ + 4 | 0] | B[_ + 5 | 0] << 8 | B[_ + 6 | 0] << 16 | B[_ + 7 | 0] << 24, l[b + 64 >> 2] = B[0 | _] | B[_ + 1 | 0] << 8 | B[_ + 2 | 0] << 16 | B[_ + 3 | 0] << 24, l[b + 68 >> 2] = he, he = B[_ + 12 | 0] | B[_ + 13 | 0] << 8 | B[_ + 14 | 0] << 16 | B[_ + 15 | 0] << 24, l[b + 72 >> 2] = B[_ + 8 | 0] | B[_ + 9 | 0] << 8 | B[_ + 10 | 0] << 16 | B[_ + 11 | 0] << 24, l[b + 76 >> 2] = he, nn(_ = b + 128 | 0, he = b - -64 | 0), Vi(_), D = l[b + 156 >> 2], l[b + 24 >> 2] = l[b + 152 >> 2], l[b + 28 >> 2] = D, D = l[b + 148 >> 2], l[b + 16 >> 2] = l[b + 144 >> 2], l[b + 20 >> 2] = D, D = l[b + 140 >> 2], l[b + 8 >> 2] = l[b + 136 >> 2], l[b + 12 >> 2] = D, D = l[b + 132 >> 2], l[b >> 2] = l[b + 128 >> 2], l[b + 4 >> 2] = D, l[b + 120 >> 2] = 0, l[b + 124 >> 2] = 0, l[b + 112 >> 2] = 0, l[b + 116 >> 2] = 0, l[b + 104 >> 2] = 0, l[b + 108 >> 2] = 0, l[b + 96 >> 2] = 0, l[b + 100 >> 2] = 0, D = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, l[b + 80 >> 2] = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, l[b + 84 >> 2] = D, D = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, l[b + 88 >> 2] = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, l[b + 92 >> 2] = D, D = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, U = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, ie = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, g = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, l[b + 56 >> 2] = 0, l[b + 60 >> 2] = 0, l[b + 48 >> 2] = 0, l[b + 52 >> 2] = 0, l[b + 40 >> 2] = 0, l[b + 44 >> 2] = 0, l[b + 64 >> 2] = ie, l[b + 68 >> 2] = g, l[b + 72 >> 2] = D, l[b + 76 >> 2] = U, l[b + 32 >> 2] = 0, l[b + 36 >> 2] = 0, zn(he, b), g = l[b + 124 >> 2], l[b + 184 >> 2] = l[b + 120 >> 2], l[b + 188 >> 2] = g, g = l[b + 116 >> 2], l[b + 176 >> 2] = l[b + 112 >> 2], l[b + 180 >> 2] = g, g = l[b + 108 >> 2], l[b + 168 >> 2] = l[b + 104 >> 2], l[b + 172 >> 2] = g, g = l[b + 100 >> 2], l[b + 160 >> 2] = l[b + 96 >> 2], l[b + 164 >> 2] = g, g = l[b + 92 >> 2], l[b + 152 >> 2] = l[b + 88 >> 2], l[b + 156 >> 2] = g, g = l[b + 84 >> 2], l[b + 144 >> 2] = l[b + 80 >> 2], l[b + 148 >> 2] = g, g = l[b + 76 >> 2], l[b + 136 >> 2] = l[b + 72 >> 2], l[b + 140 >> 2] = g, g = l[b + 68 >> 2], l[b + 128 >> 2] = l[b + 64 >> 2], l[b + 132 >> 2] = g, Vi(_), g = l[b + 156 >> 2], he = l[b + 152 >> 2], j[A + 24 | 0] = he, j[A + 25 | 0] = he >>> 8, j[A + 26 | 0] = he >>> 16, j[A + 27 | 0] = he >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[b + 148 >> 2], he = l[b + 144 >> 2], j[A + 16 | 0] = he, j[A + 17 | 0] = he >>> 8, j[A + 18 | 0] = he >>> 16, j[A + 19 | 0] = he >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[b + 140 >> 2], he = l[b + 136 >> 2], j[A + 8 | 0] = he, j[A + 9 | 0] = he >>> 8, j[A + 10 | 0] = he >>> 16, j[A + 11 | 0] = he >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[b + 132 >> 2], he = l[b + 128 >> 2], j[0 | A] = he, j[A + 1 | 0] = he >>> 8, j[A + 2 | 0] = he >>> 16, j[A + 3 | 0] = he >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, Wr(_, 64), st = b + 192 | 0;
                    }
                    function wi(A) {
                      var g = 0, _ = 0, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0;
                      e:
                        if (A |= 0) {
                          ie = (b = A - 8 | 0) + (A = -8 & (g = l[A - 4 >> 2])) | 0;
                          t:
                            if (!(1 & g)) {
                              if (!(3 & g) || (b = b - (g = l[b >> 2]) | 0) >>> 0 < Ri[9134])
                                break e;
                              if (A = A + g | 0, l[9135] == (0 | b)) {
                                if ((3 & (g = l[ie + 4 >> 2])) == 3)
                                  return l[9132] = A, l[ie + 4 >> 2] = -2 & g, l[b + 4 >> 2] = 1 | A, void (l[A + b >> 2] = A);
                              } else {
                                if (g >>> 0 <= 255) {
                                  if (U = l[b + 8 >> 2], g = g >>> 3 | 0, (0 | (_ = l[b + 12 >> 2])) == (0 | U)) {
                                    me = 36520, _e = l[9130] & tn(-2, g), l[me >> 2] = _e;
                                    break t;
                                  }
                                  l[U + 12 >> 2] = _, l[_ + 8 >> 2] = U;
                                  break t;
                                }
                                if (D = l[b + 24 >> 2], (0 | b) == (0 | (g = l[b + 12 >> 2])))
                                  if ((_ = l[(U = b + 20 | 0) >> 2]) || (_ = l[(U = b + 16 | 0) >> 2])) {
                                    for (; he = U, (_ = l[(U = (g = _) + 20 | 0) >> 2]) || (U = g + 16 | 0, _ = l[g + 16 >> 2]); )
                                      ;
                                    l[he >> 2] = 0;
                                  } else
                                    g = 0;
                                else
                                  _ = l[b + 8 >> 2], l[_ + 12 >> 2] = g, l[g + 8 >> 2] = _;
                                if (!D)
                                  break t;
                                U = l[b + 28 >> 2];
                                n: {
                                  if (l[(_ = 36824 + (U << 2) | 0) >> 2] == (0 | b)) {
                                    if (l[_ >> 2] = g, g)
                                      break n;
                                    me = 36524, _e = l[9131] & tn(-2, U), l[me >> 2] = _e;
                                    break t;
                                  }
                                  if (l[D + (l[D + 16 >> 2] == (0 | b) ? 16 : 20) >> 2] = g, !g)
                                    break t;
                                }
                                if (l[g + 24 >> 2] = D, (_ = l[b + 16 >> 2]) && (l[g + 16 >> 2] = _, l[_ + 24 >> 2] = g), !(_ = l[b + 20 >> 2]))
                                  break t;
                                l[g + 20 >> 2] = _, l[_ + 24 >> 2] = g;
                              }
                            }
                          if (!(b >>> 0 >= ie >>> 0) && 1 & (g = l[ie + 4 >> 2])) {
                            t: {
                              if (!(2 & g)) {
                                if (l[9136] == (0 | ie)) {
                                  if (l[9136] = b, A = l[9133] + A | 0, l[9133] = A, l[b + 4 >> 2] = 1 | A, l[9135] != (0 | b))
                                    break e;
                                  return l[9132] = 0, void (l[9135] = 0);
                                }
                                if (l[9135] == (0 | ie))
                                  return l[9135] = b, A = l[9132] + A | 0, l[9132] = A, l[b + 4 >> 2] = 1 | A, void (l[A + b >> 2] = A);
                                A = (-8 & g) + A | 0;
                                n:
                                  if (g >>> 0 <= 255) {
                                    if (U = l[ie + 8 >> 2], g = g >>> 3 | 0, (0 | (_ = l[ie + 12 >> 2])) == (0 | U)) {
                                      me = 36520, _e = l[9130] & tn(-2, g), l[me >> 2] = _e;
                                      break n;
                                    }
                                    l[U + 12 >> 2] = _, l[_ + 8 >> 2] = U;
                                  } else {
                                    if (D = l[ie + 24 >> 2], (0 | ie) == (0 | (g = l[ie + 12 >> 2])))
                                      if ((_ = l[(U = ie + 20 | 0) >> 2]) || (_ = l[(U = ie + 16 | 0) >> 2])) {
                                        for (; he = U, (_ = l[(U = (g = _) + 20 | 0) >> 2]) || (U = g + 16 | 0, _ = l[g + 16 >> 2]); )
                                          ;
                                        l[he >> 2] = 0;
                                      } else
                                        g = 0;
                                    else
                                      _ = l[ie + 8 >> 2], l[_ + 12 >> 2] = g, l[g + 8 >> 2] = _;
                                    if (D) {
                                      U = l[ie + 28 >> 2];
                                      r: {
                                        if (l[(_ = 36824 + (U << 2) | 0) >> 2] == (0 | ie)) {
                                          if (l[_ >> 2] = g, g)
                                            break r;
                                          me = 36524, _e = l[9131] & tn(-2, U), l[me >> 2] = _e;
                                          break n;
                                        }
                                        if (l[D + (l[D + 16 >> 2] == (0 | ie) ? 16 : 20) >> 2] = g, !g)
                                          break n;
                                      }
                                      l[g + 24 >> 2] = D, (_ = l[ie + 16 >> 2]) && (l[g + 16 >> 2] = _, l[_ + 24 >> 2] = g), (_ = l[ie + 20 >> 2]) && (l[g + 20 >> 2] = _, l[_ + 24 >> 2] = g);
                                    }
                                  }
                                if (l[b + 4 >> 2] = 1 | A, l[A + b >> 2] = A, l[9135] != (0 | b))
                                  break t;
                                return void (l[9132] = A);
                              }
                              l[ie + 4 >> 2] = -2 & g, l[b + 4 >> 2] = 1 | A, l[A + b >> 2] = A;
                            }
                            if (A >>> 0 <= 255)
                              return g = 36560 + (-8 & A) | 0, (_ = l[9130]) & (A = 1 << (A >>> 3)) ? A = l[g + 8 >> 2] : (l[9130] = A | _, A = g), l[g + 8 >> 2] = b, l[A + 12 >> 2] = b, l[b + 12 >> 2] = g, void (l[b + 8 >> 2] = A);
                            U = 31, A >>> 0 <= 16777215 && (U = 62 + ((A >>> 38 - (g = zi(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), l[b + 28 >> 2] = U, l[b + 16 >> 2] = 0, l[b + 20 >> 2] = 0, he = 36824 + (U << 2) | 0;
                            t: {
                              n: {
                                if ((_ = l[9131]) & (g = 1 << U)) {
                                  for (U = A << ((0 | U) != 31 ? 25 - (U >>> 1 | 0) | 0 : 0), g = l[he >> 2]; ; ) {
                                    if (_ = g, (-8 & l[g + 4 >> 2]) == (0 | A))
                                      break n;
                                    if (g = U >>> 29 | 0, U <<= 1, !(g = l[16 + (he = _ + (4 & g) | 0) >> 2]))
                                      break;
                                  }
                                  l[he + 16 >> 2] = b, l[b + 24 >> 2] = _;
                                } else
                                  l[9131] = g | _, l[he >> 2] = b, l[b + 24 >> 2] = he;
                                l[b + 12 >> 2] = b, l[b + 8 >> 2] = b;
                                break t;
                              }
                              A = l[_ + 8 >> 2], l[A + 12 >> 2] = b, l[_ + 8 >> 2] = b, l[b + 24 >> 2] = 0, l[b + 12 >> 2] = _, l[b + 8 >> 2] = A;
                            }
                            A = l[9138] - 1 | 0, l[9138] = A || -1;
                          }
                        }
                    }
                    function ha(A, g, _, b, U) {
                      var ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0;
                      if (b ? (Gn = B[b + 12 | 0] | B[b + 13 | 0] << 8 | B[b + 14 | 0] << 16 | B[b + 15 | 0] << 24, Kt = B[b + 8 | 0] | B[b + 9 | 0] << 8 | B[b + 10 | 0] << 16 | B[b + 11 | 0] << 24, Kn = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, pn = B[b + 4 | 0] | B[b + 5 | 0] << 8 | B[b + 6 | 0] << 16 | B[b + 7 | 0] << 24) : (Gn = 1797285236, Kn = 1634760805, Kt = 2036477234, pn = 857760878), b = ie = B[_ + 20 | 0] | B[_ + 21 | 0] << 8 | B[_ + 22 | 0] << 16 | B[_ + 23 | 0] << 24, en = he = B[_ + 24 | 0] | B[_ + 25 | 0] << 8 | B[_ + 26 | 0] << 16 | B[_ + 27 | 0] << 24, fn = D = B[_ + 28 | 0] | B[_ + 29 | 0] << 8 | B[_ + 30 | 0] << 16 | B[_ + 31 | 0] << 24, bt = Gn, Gt = me = B[_ + 16 | 0] | B[_ + 17 | 0] << 8 | B[_ + 18 | 0] << 16 | B[_ + 19 | 0] << 24, it = Kt, _n = _e = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, St = Be = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, ht = ye = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, g = we = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, Ft = pn, ct = $e = B[_ + 12 | 0] | B[_ + 13 | 0] << 8 | B[_ + 14 | 0] << 16 | B[_ + 15 | 0] << 24, mt = Le = B[_ + 8 | 0] | B[_ + 9 | 0] << 8 | B[_ + 10 | 0] << 16 | B[_ + 11 | 0] << 24, Ct = Ge = B[_ + 4 | 0] | B[_ + 5 | 0] << 8 | B[_ + 6 | 0] << 16 | B[_ + 7 | 0] << 24, _ = je = B[0 | _] | B[_ + 1 | 0] << 8 | B[_ + 2 | 0] << 16 | B[_ + 3 | 0] << 24, Tt = Kn, (0 | U) > 0)
                        for (; wn = tn(_ + Ft | 0, 7) ^ _n, Hn = tn(wn + Ft | 0, 9) ^ en, $n = tn(b + Tt | 0, 7) ^ ct, Zn = tn($n + Tt | 0, 9) ^ St, er = tn($n + Zn | 0, 13) ^ b, qn = tn(bt + Gt | 0, 7) ^ mt, ht = tn(qn + bt | 0, 9) ^ ht, mt = tn(ht + qn | 0, 13) ^ Gt, bt = tn(ht + mt | 0, 18) ^ bt, ct = tn(g + it | 0, 7) ^ fn, b = er ^ tn(bt + ct | 0, 7), en = tn(b + bt | 0, 9) ^ Hn, fn = tn(b + en | 0, 13) ^ ct, bt = tn(en + fn | 0, 18) ^ bt, Ct = tn(ct + it | 0, 9) ^ Ct, ct = tn(Ct + ct | 0, 13) ^ g, g = tn(ct + Ct | 0, 18) ^ it, Gt = tn(g + wn | 0, 7) ^ mt, St = tn(Gt + g | 0, 9) ^ Zn, _n = tn(Gt + St | 0, 13) ^ wn, it = tn(St + _n | 0, 18) ^ g, _ = tn(wn + Hn | 0, 13) ^ _, mt = tn(_ + Hn | 0, 18) ^ Ft, g = tn(mt + $n | 0, 7) ^ ct, ht = tn(g + mt | 0, 9) ^ ht, ct = tn(g + ht | 0, 13) ^ $n, Ft = tn(ht + ct | 0, 18) ^ mt, Tt = tn(Zn + er | 0, 18) ^ Tt, _ = tn(Tt + qn | 0, 7) ^ _, Ct = tn(_ + Tt | 0, 9) ^ Ct, mt = tn(_ + Ct | 0, 13) ^ qn, Tt = tn(Ct + mt | 0, 18) ^ Tt, (0 | (Zt = Zt + 2 | 0)) < (0 | U); )
                          ;
                      U = bt + Gn | 0, j[A + 60 | 0] = U, j[A + 61 | 0] = U >>> 8, j[A + 62 | 0] = U >>> 16, j[A + 63 | 0] = U >>> 24, U = fn + D | 0, j[A + 56 | 0] = U, j[A + 57 | 0] = U >>> 8, j[A + 58 | 0] = U >>> 16, j[A + 59 | 0] = U >>> 24, U = en + he | 0, j[A + 52 | 0] = U, j[A + 53 | 0] = U >>> 8, j[A + 54 | 0] = U >>> 16, j[A + 55 | 0] = U >>> 24, b = b + ie | 0, j[A + 48 | 0] = b, j[A + 49 | 0] = b >>> 8, j[A + 50 | 0] = b >>> 16, j[A + 51 | 0] = b >>> 24, b = Gt + me | 0, j[A + 44 | 0] = b, j[A + 45 | 0] = b >>> 8, j[A + 46 | 0] = b >>> 16, j[A + 47 | 0] = b >>> 24, b = it + Kt | 0, j[A + 40 | 0] = b, j[A + 41 | 0] = b >>> 8, j[A + 42 | 0] = b >>> 16, j[A + 43 | 0] = b >>> 24, b = _n + _e | 0, j[A + 36 | 0] = b, j[A + 37 | 0] = b >>> 8, j[A + 38 | 0] = b >>> 16, j[A + 39 | 0] = b >>> 24, b = St + Be | 0, j[A + 32 | 0] = b, j[A + 33 | 0] = b >>> 8, j[A + 34 | 0] = b >>> 16, j[A + 35 | 0] = b >>> 24, b = ht + ye | 0, j[A + 28 | 0] = b, j[A + 29 | 0] = b >>> 8, j[A + 30 | 0] = b >>> 16, j[A + 31 | 0] = b >>> 24, g = g + we | 0, j[A + 24 | 0] = g, j[A + 25 | 0] = g >>> 8, j[A + 26 | 0] = g >>> 16, j[A + 27 | 0] = g >>> 24, g = Ft + pn | 0, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = ct + $e | 0, j[A + 16 | 0] = g, j[A + 17 | 0] = g >>> 8, j[A + 18 | 0] = g >>> 16, j[A + 19 | 0] = g >>> 24, g = mt + Le | 0, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = Ct + Ge | 0, j[A + 8 | 0] = g, j[A + 9 | 0] = g >>> 8, j[A + 10 | 0] = g >>> 16, j[A + 11 | 0] = g >>> 24, g = _ + je | 0, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, g = Tt + Kn | 0, j[0 | A] = g, j[A + 1 | 0] = g >>> 8, j[A + 2 | 0] = g >>> 16, j[A + 3 | 0] = g >>> 24;
                    }
                    function as(A, g, _, b, U, ie) {
                      var he = 0;
                      if (l[ie >> 2] = 8, !(g = (he = !g & A >>> 0 <= 32768) ? 0 : g) & _ >>> 5 >>> 0 <= (A = he ? 32768 : A) >>> 0 | g)
                        return he = 1, _ >>> 0 < 4096 || (he = 2, _ >>> 0 < 8192 || (he = 3, _ >>> 0 < 16384 || (he = 4, _ >>> 0 < 32768 || (he = 5, _ >>> 0 < 65536 || (he = 6, _ >>> 0 < 131072 || (he = 7, _ >>> 0 < 262144 || (he = 8, _ >>> 0 < 524288 || (he = 9, _ >>> 0 < 1048576 || (he = 10, _ >>> 0 < 2097152 || (he = 11, _ >>> 0 < 4194304 || (he = 12, _ >>> 0 < 8388608 || (he = 13, _ >>> 0 < 16777216 || (he = 14, _ >>> 0 < 33554432 || (he = 15, _ >>> 0 < 67108864 || (he = 16, _ >>> 0 < 134217728 || (he = 17, _ >>> 0 < 268435456 || (he = 18, _ >>> 0 < 536870912 || (he = 19, _ >>> 0 < 1073741824 || (he = (0 | _) >= 0 ? 20 : 21))))))))))))))))))), _ = he, l[b >> 2] = _, b = g >>> 2 | 0, g = (3 & g) << 30 | A >>> 2, A = 31 & _, (63 & _) >>> 0 >= 32 ? (_ = 0, A = b >>> A | 0) : (_ = b >>> A | 0, A = ((1 << A) - 1 & b) << 32 - A | g >>> A), void (l[U >> 2] = ((!_ & A >>> 0 >= 1073741823 | _ ? 1073741823 : A) >>> 0) / Ri[ie >> 2]);
                      l[U >> 2] = 1, g = ta(A, g, l[ie >> 2] << 2), _ = 1, !(A = ve) & g >>> 0 < 4 || (_ = 2, !A & g >>> 0 < 8 || (_ = 3, !A & g >>> 0 < 16 || (_ = 4, !A & g >>> 0 < 32 || (_ = 5, !A & g >>> 0 < 64 || (_ = 6, !A & g >>> 0 < 128 || (_ = 7, !A & g >>> 0 < 256 || (_ = 8, !A & g >>> 0 < 512 || (_ = 9, !A & g >>> 0 < 1024 || (_ = 10, !A & g >>> 0 < 2048 || (_ = 11, !A & g >>> 0 < 4096 || (_ = 12, !A & g >>> 0 < 8192 || (_ = 13, !A & g >>> 0 < 16384 || (_ = 14, !A & g >>> 0 < 32768 || (_ = 15, !A & g >>> 0 < 65536 || (_ = 16, !A & g >>> 0 < 131072 || (_ = 17, !A & g >>> 0 < 262144 || (_ = 18, !A & g >>> 0 < 524288 || (_ = 19, !A & g >>> 0 < 1048576 || (_ = 20, !A & g >>> 0 < 2097152 || (_ = 21, !A & g >>> 0 < 4194304 || (_ = 22, !A & g >>> 0 < 8388608 || (_ = 23, !A & g >>> 0 < 16777216 || (_ = 24, !A & g >>> 0 < 33554432 || (_ = 25, !A & g >>> 0 < 67108864 || (_ = 26, !A & g >>> 0 < 134217728 || (_ = 27, !A & g >>> 0 < 268435456 || (_ = 28, !A & g >>> 0 < 536870912 || (_ = 29, !A & g >>> 0 < 1073741824 || (_ = 30, !A & g >>> 0 < 2147483648 || (_ = 31, A && (_ = 32, A >>> 0 < 2 || (_ = 33, A >>> 0 < 4 || (_ = 34, A >>> 0 < 8 || (_ = 35, A >>> 0 < 16 || (_ = 36, A >>> 0 < 32 || (_ = 37, A >>> 0 < 64 || (_ = 38, A >>> 0 < 128 || (_ = 39, A >>> 0 < 256 || (_ = 40, A >>> 0 < 512 || (_ = 41, A >>> 0 < 1024 || (_ = 42, A >>> 0 < 2048 || (_ = 43, A >>> 0 < 4096 || (_ = 44, A >>> 0 < 8192 || (_ = 45, A >>> 0 < 16384 || (_ = 46, A >>> 0 < 32768 || (_ = 47, A >>> 0 < 65536 || (_ = 48, A >>> 0 < 131072 || (_ = 49, A >>> 0 < 262144 || (_ = 50, A >>> 0 < 524288 || (_ = 51, A >>> 0 < 1048576 || (_ = 52, A >>> 0 < 2097152 || (_ = 53, A >>> 0 < 4194304 || (_ = 54, A >>> 0 < 8388608 || (_ = 55, A >>> 0 < 16777216 || (_ = 56, A >>> 0 < 33554432 || (_ = 57, A >>> 0 < 67108864 || (_ = 58, A >>> 0 < 134217728 || (_ = 59, A >>> 0 < 268435456 || (_ = 60, A >>> 0 < 536870912 || (_ = 61, A >>> 0 < 1073741824 || (_ = (0 | A) > 0 | (0 | A) >= 0 ? 62 : 63))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))), l[b >> 2] = _;
                    }
                    function qi(A, g, _, b, U, ie, he, D, me) {
                      var _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0;
                      if (g - 65 >>> 0 < 4294967232 | he >>> 0 > 64)
                        A = -1;
                      else {
                        je = _e = st, st = _e = _e - 512 & -64;
                        e: {
                          t:
                            if (!(!(!(b | U) | _) | !A | ((Le = 255 & g) - 65 & 255) >>> 0 <= 191 | !(!(g = 255 & he) || ie) | g >>> 0 >= 65)) {
                              if (g) {
                                if (!ie)
                                  break t;
                                D ? (Be = 725511199 ^ (B[D + 8 | 0] | B[D + 9 | 0] << 8 | B[D + 10 | 0] << 16 | B[D + 11 | 0] << 24), ye = -1694144372 ^ (B[D + 12 | 0] | B[D + 13 | 0] << 8 | B[D + 14 | 0] << 16 | B[D + 15 | 0] << 24), he = -1377402159 ^ (B[0 | D] | B[D + 1 | 0] << 8 | B[D + 2 | 0] << 16 | B[D + 3 | 0] << 24), D = 1359893119 ^ (B[D + 4 | 0] | B[D + 5 | 0] << 8 | B[D + 6 | 0] << 16 | B[D + 7 | 0] << 24)) : (Be = 725511199, ye = -1694144372, he = -1377402159, D = 1359893119), me ? (we = 327033209 ^ (B[me + 8 | 0] | B[me + 9 | 0] << 8 | B[me + 10 | 0] << 16 | B[me + 11 | 0] << 24), $e = 1541459225 ^ (B[me + 12 | 0] | B[me + 13 | 0] << 8 | B[me + 14 | 0] << 16 | B[me + 15 | 0] << 24), Ge = -79577749 ^ (B[0 | me] | B[me + 1 | 0] << 8 | B[me + 2 | 0] << 16 | B[me + 3 | 0] << 24), me = 528734635 ^ (B[me + 4 | 0] | B[me + 5 | 0] << 8 | B[me + 6 | 0] << 16 | B[me + 7 | 0] << 24)) : (we = 327033209, $e = 1541459225, Ge = -79577749, me = 528734635), Jt(_e - -64 | 0, 0, 293), l[_e + 56 >> 2] = we, l[_e + 60 >> 2] = $e, l[_e + 48 >> 2] = Ge, l[_e + 52 >> 2] = me, l[_e + 40 >> 2] = Be, l[_e + 44 >> 2] = ye, l[_e + 32 >> 2] = he, l[_e + 36 >> 2] = D, l[_e + 24 >> 2] = 1595750129, l[_e + 28 >> 2] = -1521486534, l[_e + 16 >> 2] = -23791573, l[_e + 20 >> 2] = 1013904242, l[_e + 8 >> 2] = -2067093701, l[_e + 12 >> 2] = -1150833019, l[_e >> 2] = -222443256 ^ (g << 8 | Le), l[_e + 4 >> 2] = g >>> 24 ^ 1779033703, Jt((he = _e + 384 | 0) + g | 0, 0, 128 - g | 0), xr(he, ie, g), xr(_e + 96 | 0, he, 128), l[_e + 352 >> 2] = 128, Wr(he, 128), g = 128;
                              } else
                                D ? (Be = 725511199 ^ (B[D + 8 | 0] | B[D + 9 | 0] << 8 | B[D + 10 | 0] << 16 | B[D + 11 | 0] << 24), ye = -1694144372 ^ (B[D + 12 | 0] | B[D + 13 | 0] << 8 | B[D + 14 | 0] << 16 | B[D + 15 | 0] << 24), ie = 1359893119 ^ (B[D + 4 | 0] | B[D + 5 | 0] << 8 | B[D + 6 | 0] << 16 | B[D + 7 | 0] << 24), g = -1377402159 ^ (B[0 | D] | B[D + 1 | 0] << 8 | B[D + 2 | 0] << 16 | B[D + 3 | 0] << 24)) : (Be = 725511199, ye = -1694144372, ie = 1359893119, g = -1377402159), me ? (we = 327033209 ^ (B[me + 8 | 0] | B[me + 9 | 0] << 8 | B[me + 10 | 0] << 16 | B[me + 11 | 0] << 24), $e = 1541459225 ^ (B[me + 12 | 0] | B[me + 13 | 0] << 8 | B[me + 14 | 0] << 16 | B[me + 15 | 0] << 24), D = 528734635 ^ (B[me + 4 | 0] | B[me + 5 | 0] << 8 | B[me + 6 | 0] << 16 | B[me + 7 | 0] << 24), he = -79577749 ^ (B[0 | me] | B[me + 1 | 0] << 8 | B[me + 2 | 0] << 16 | B[me + 3 | 0] << 24)) : (we = 327033209, $e = 1541459225, D = 528734635, he = -79577749), Jt(_e - -64 | 0, 0, 293), l[_e + 56 >> 2] = we, l[_e + 60 >> 2] = $e, l[_e + 48 >> 2] = he, l[_e + 52 >> 2] = D, l[_e + 40 >> 2] = Be, l[_e + 44 >> 2] = ye, l[_e + 32 >> 2] = g, l[_e + 36 >> 2] = ie, l[_e + 24 >> 2] = 1595750129, l[_e + 28 >> 2] = -1521486534, l[_e + 16 >> 2] = -23791573, l[_e + 20 >> 2] = 1013904242, l[_e + 8 >> 2] = -2067093701, l[_e + 12 >> 2] = -1150833019, l[_e >> 2] = -222443256 ^ Le, l[_e + 4 >> 2] = 1779033703, g = 0;
                              n:
                                if (b | U)
                                  for (me = _e + 224 | 0, D = _e + 96 | 0; ; ) {
                                    if (he = g + D | 0, !U & b >>> 0 <= (ie = 256 - g | 0) >>> 0) {
                                      xr(he, _, b), l[_e + 352 >> 2] = b + l[_e + 352 >> 2];
                                      break n;
                                    }
                                    if (xr(he, _, ie), l[_e + 352 >> 2] = ie + l[_e + 352 >> 2], Be = g = l[_e + 68 >> 2], g = (ye = (he = l[_e + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? g + 1 | 0 : g, l[_e + 64 >> 2] = ye, l[_e + 68 >> 2] = g, g = l[_e + 76 >> 2], g = (Be = he = (0 | Be) == -1 & he >>> 0 > 4294967167) >>> 0 > (he = he + l[_e + 72 >> 2] | 0) >>> 0 ? g + 1 | 0 : g, l[_e + 72 >> 2] = he, l[_e + 76 >> 2] = g, $s(_e, D), xr(D, me, 128), g = l[_e + 352 >> 2] - 128 | 0, l[_e + 352 >> 2] = g, _ = _ + ie | 0, !((U = U - (b >>> 0 < ie >>> 0) | 0) | (b = b - ie | 0)))
                                      break;
                                  }
                              la(_e, A, Le), st = je;
                              break e;
                            }
                          Ai(), Xr();
                        }
                        A = 0;
                      }
                      return A;
                    }
                    function Aa(A, g) {
                      var _, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0;
                      _ = A + g | 0;
                      e: {
                        t:
                          if (!(1 & (b = l[A + 4 >> 2]))) {
                            if (!(3 & b))
                              break e;
                            g = (b = l[A >> 2]) + g | 0;
                            n: {
                              if ((0 | (A = A - b | 0)) != l[9135]) {
                                if (b >>> 0 <= 255) {
                                  if (ie = l[A + 8 >> 2], b = b >>> 3 | 0, (0 | (U = l[A + 12 >> 2])) != (0 | ie))
                                    break n;
                                  me = 36520, _e = l[9130] & tn(-2, b), l[me >> 2] = _e;
                                  break t;
                                }
                                if (D = l[A + 24 >> 2], (0 | (b = l[A + 12 >> 2])) == (0 | A))
                                  if ((U = l[(ie = A + 20 | 0) >> 2]) || (U = l[(ie = A + 16 | 0) >> 2])) {
                                    for (; he = ie, (U = l[(ie = (b = U) + 20 | 0) >> 2]) || (ie = b + 16 | 0, U = l[b + 16 >> 2]); )
                                      ;
                                    l[he >> 2] = 0;
                                  } else
                                    b = 0;
                                else
                                  U = l[A + 8 >> 2], l[U + 12 >> 2] = b, l[b + 8 >> 2] = U;
                                if (!D)
                                  break t;
                                ie = l[A + 28 >> 2];
                                r: {
                                  if (l[(U = 36824 + (ie << 2) | 0) >> 2] == (0 | A)) {
                                    if (l[U >> 2] = b, b)
                                      break r;
                                    me = 36524, _e = l[9131] & tn(-2, ie), l[me >> 2] = _e;
                                    break t;
                                  }
                                  if (l[D + (l[D + 16 >> 2] == (0 | A) ? 16 : 20) >> 2] = b, !b)
                                    break t;
                                }
                                if (l[b + 24 >> 2] = D, (U = l[A + 16 >> 2]) && (l[b + 16 >> 2] = U, l[U + 24 >> 2] = b), !(U = l[A + 20 >> 2]))
                                  break t;
                                l[b + 20 >> 2] = U, l[U + 24 >> 2] = b;
                                break t;
                              }
                              if ((3 & (b = l[_ + 4 >> 2])) != 3)
                                break t;
                              return l[9132] = g, l[_ + 4 >> 2] = -2 & b, l[A + 4 >> 2] = 1 | g, void (l[_ >> 2] = g);
                            }
                            l[ie + 12 >> 2] = U, l[U + 8 >> 2] = ie;
                          }
                        t: {
                          if (!(2 & (b = l[_ + 4 >> 2]))) {
                            if (l[9136] == (0 | _)) {
                              if (l[9136] = A, g = l[9133] + g | 0, l[9133] = g, l[A + 4 >> 2] = 1 | g, l[9135] != (0 | A))
                                break e;
                              return l[9132] = 0, void (l[9135] = 0);
                            }
                            if (l[9135] == (0 | _))
                              return l[9135] = A, g = l[9132] + g | 0, l[9132] = g, l[A + 4 >> 2] = 1 | g, void (l[A + g >> 2] = g);
                            g = (-8 & b) + g | 0;
                            n:
                              if (b >>> 0 <= 255) {
                                if (ie = l[_ + 8 >> 2], b = b >>> 3 | 0, (0 | (U = l[_ + 12 >> 2])) == (0 | ie)) {
                                  me = 36520, _e = l[9130] & tn(-2, b), l[me >> 2] = _e;
                                  break n;
                                }
                                l[ie + 12 >> 2] = U, l[U + 8 >> 2] = ie;
                              } else {
                                if (D = l[_ + 24 >> 2], (0 | _) == (0 | (b = l[_ + 12 >> 2])))
                                  if ((ie = l[(U = _ + 20 | 0) >> 2]) || (ie = l[(U = _ + 16 | 0) >> 2])) {
                                    for (; he = U, (ie = l[(U = (b = ie) + 20 | 0) >> 2]) || (U = b + 16 | 0, ie = l[b + 16 >> 2]); )
                                      ;
                                    l[he >> 2] = 0;
                                  } else
                                    b = 0;
                                else
                                  U = l[_ + 8 >> 2], l[U + 12 >> 2] = b, l[b + 8 >> 2] = U;
                                if (D) {
                                  ie = l[_ + 28 >> 2];
                                  r: {
                                    if (l[(U = 36824 + (ie << 2) | 0) >> 2] == (0 | _)) {
                                      if (l[U >> 2] = b, b)
                                        break r;
                                      me = 36524, _e = l[9131] & tn(-2, ie), l[me >> 2] = _e;
                                      break n;
                                    }
                                    if (l[D + (l[D + 16 >> 2] == (0 | _) ? 16 : 20) >> 2] = b, !b)
                                      break n;
                                  }
                                  l[b + 24 >> 2] = D, (U = l[_ + 16 >> 2]) && (l[b + 16 >> 2] = U, l[U + 24 >> 2] = b), (U = l[_ + 20 >> 2]) && (l[b + 20 >> 2] = U, l[U + 24 >> 2] = b);
                                }
                              }
                            if (l[A + 4 >> 2] = 1 | g, l[A + g >> 2] = g, l[9135] != (0 | A))
                              break t;
                            return void (l[9132] = g);
                          }
                          l[_ + 4 >> 2] = -2 & b, l[A + 4 >> 2] = 1 | g, l[A + g >> 2] = g;
                        }
                        if (g >>> 0 <= 255)
                          return b = 36560 + (-8 & g) | 0, (U = l[9130]) & (g = 1 << (g >>> 3)) ? g = l[b + 8 >> 2] : (l[9130] = g | U, g = b), l[b + 8 >> 2] = A, l[g + 12 >> 2] = A, l[A + 12 >> 2] = b, void (l[A + 8 >> 2] = g);
                        ie = 31, g >>> 0 <= 16777215 && (ie = 62 + ((g >>> 38 - (b = zi(g >>> 8 | 0)) & 1) - (b << 1) | 0) | 0), l[A + 28 >> 2] = ie, l[A + 16 >> 2] = 0, l[A + 20 >> 2] = 0, he = 36824 + (ie << 2) | 0;
                        t: {
                          if ((U = l[9131]) & (b = 1 << ie)) {
                            for (ie = g << ((0 | ie) != 31 ? 25 - (ie >>> 1 | 0) | 0 : 0), b = l[he >> 2]; ; ) {
                              if (U = b, (-8 & l[b + 4 >> 2]) == (0 | g))
                                break t;
                              if (b = ie >>> 29 | 0, ie <<= 1, !(b = l[16 + (he = U + (4 & b) | 0) >> 2]))
                                break;
                            }
                            l[he + 16 >> 2] = A, l[A + 24 >> 2] = U;
                          } else
                            l[9131] = b | U, l[he >> 2] = A, l[A + 24 >> 2] = he;
                          return l[A + 12 >> 2] = A, void (l[A + 8 >> 2] = A);
                        }
                        g = l[U + 8 >> 2], l[g + 12 >> 2] = A, l[U + 8 >> 2] = A, l[A + 24 >> 2] = 0, l[A + 12 >> 2] = U, l[A + 8 >> 2] = g;
                      }
                    }
                    function ka(A, g, _, b, U, ie, he) {
                      var D, me, _e = 0, Be = 0;
                      if (st = D = st + -64 | 0, me = Qi(32)) {
                        l[D + 32 >> 2] = 0, l[D + 36 >> 2] = 0, l[D + 24 >> 2] = 0, l[D + 28 >> 2] = 0, l[D + 20 >> 2] = 16, l[D + 16 >> 2] = U, l[D + 12 >> 2] = b, l[D + 8 >> 2] = _, l[D + 4 >> 2] = 32, l[D >> 2] = me, l[D + 56 >> 2] = 0, l[D + 52 >> 2] = 1, l[D + 48 >> 2] = 1, l[D + 44 >> 2] = g, l[D + 40 >> 2] = A;
                        e:
                          if (A = js(D, he))
                            Wr(me, 32);
                          else {
                            if (ie) {
                              st = U = st - 32 | 0, A = -31;
                              t: {
                                n: {
                                  r:
                                    switch (he - 1 | 0) {
                                      case 1:
                                        A = B[1417] | B[1418] << 8 | B[1419] << 16 | B[1420] << 24, g = B[1413] | B[1414] << 8 | B[1415] << 16 | B[1416] << 24, j[0 | ie] = g, j[ie + 1 | 0] = g >>> 8, j[ie + 2 | 0] = g >>> 16, j[ie + 3 | 0] = g >>> 24, j[ie + 4 | 0] = A, j[ie + 5 | 0] = A >>> 8, j[ie + 6 | 0] = A >>> 16, j[ie + 7 | 0] = A >>> 24, A = B[1422] | B[1423] << 8 | B[1424] << 16 | B[1425] << 24, g = B[1418] | B[1419] << 8 | B[1420] << 16 | B[1421] << 24, j[ie + 5 | 0] = g, j[ie + 6 | 0] = g >>> 8, j[ie + 7 | 0] = g >>> 16, j[ie + 8 | 0] = g >>> 24, j[ie + 9 | 0] = A, j[ie + 10 | 0] = A >>> 8, j[ie + 11 | 0] = A >>> 16, j[ie + 12 | 0] = A >>> 24, _ = -12, g = 12;
                                        break n;
                                      case 0:
                                        break r;
                                      default:
                                        break t;
                                    }
                                  A = B[1405] | B[1406] << 8 | B[1407] << 16 | B[1408] << 24, g = B[1401] | B[1402] << 8 | B[1403] << 16 | B[1404] << 24, j[0 | ie] = g, j[ie + 1 | 0] = g >>> 8, j[ie + 2 | 0] = g >>> 16, j[ie + 3 | 0] = g >>> 24, j[ie + 4 | 0] = A, j[ie + 5 | 0] = A >>> 8, j[ie + 6 | 0] = A >>> 16, j[ie + 7 | 0] = A >>> 24, A = B[1409] | B[1410] << 8 | B[1411] << 16 | B[1412] << 24, j[ie + 8 | 0] = A, j[ie + 9 | 0] = A >>> 8, j[ie + 10 | 0] = A >>> 16, j[ie + 11 | 0] = A >>> 24, _ = -11, g = 11;
                                }
                                if (!(A = Na(D)))
                                  if (j[U + 13 | 0] = 0, j[U + 11 | 0] = 49, j[U + 12 | 0] = 57, (_ = _ + 128 | 0) >>> 0 <= (A = gn(U + 11 | 0)) >>> 0)
                                    A = -31;
                                  else if (g = xr(g + ie | 0, U + 11 | 0, A + 1 | 0), (_e = _ - A | 0) >>> 0 < 4)
                                    A = -31;
                                  else {
                                    for (j[0 | (he = A + g | 0)] = 36, j[he + 1 | 0] = 109, j[he + 2 | 0] = 61, j[he + 3 | 0] = 0, A = l[D + 44 >> 2], g = 10; _ = g, b = (A >>> 0) / 10 | 0, j[0 | (Be = (g = g - 1 | 0) + (U + 22 | 0) | 0)] = A - wr(b, 10) | 48, !(A >>> 0 < 10) && (A = b, g); )
                                      ;
                                    if (xr(A = U + 11 | 0, Be, g = 11 - _ | 0), j[A + g | 0] = 0, (g = _e - 3 | 0) >>> 0 <= (A = gn(A)) >>> 0)
                                      A = -31;
                                    else if (_ = xr(he + 3 | 0, U + 11 | 0, A + 1 | 0), (_e = g - A | 0) >>> 0 < 4)
                                      A = -31;
                                    else {
                                      for (j[0 | (he = A + _ | 0)] = 44, j[he + 1 | 0] = 116, j[he + 2 | 0] = 61, j[he + 3 | 0] = 0, A = l[D + 40 >> 2], g = 10; _ = g, b = (A >>> 0) / 10 | 0, j[0 | (Be = (g = g - 1 | 0) + (U + 22 | 0) | 0)] = A - wr(b, 10) | 48, !(A >>> 0 < 10) && (A = b, g); )
                                        ;
                                      if (xr(A = U + 11 | 0, Be, g = 11 - _ | 0), j[A + g | 0] = 0, (g = _e - 3 | 0) >>> 0 <= (A = gn(A)) >>> 0)
                                        A = -31;
                                      else if (_ = xr(he + 3 | 0, U + 11 | 0, A + 1 | 0), (_e = g - A | 0) >>> 0 < 4)
                                        A = -31;
                                      else {
                                        for (j[0 | (he = A + _ | 0)] = 44, j[he + 1 | 0] = 112, j[he + 2 | 0] = 61, j[he + 3 | 0] = 0, A = l[D + 48 >> 2], g = 10; _ = g, b = (A >>> 0) / 10 | 0, j[0 | (Be = (g = g - 1 | 0) + (U + 22 | 0) | 0)] = A - wr(b, 10) | 48, !(A >>> 0 < 10) && (A = b, g); )
                                          ;
                                        xr(A = U + 11 | 0, Be, g = 11 - _ | 0), j[A + g | 0] = 0, (g = _e - 3 | 0) >>> 0 <= (A = gn(A)) >>> 0 ? A = -31 : (_ = xr(he + 3 | 0, U + 11 | 0, A + 1 | 0), (b = g - A | 0) >>> 0 < 2 ? A = -31 : (j[0 | (A = A + _ | 0)] = 36, j[A + 1 | 0] = 0, Un(g = A + 1 | 0, _ = b - 1 | 0, l[D + 16 >> 2], l[D + 20 >> 2], 3) ? (A = -31, (b = (b = _) - (_ = gn(g)) | 0) >>> 0 < 2 || (j[0 | (A = g + _ | 0)] = 36, j[A + 1 | 0] = 0, A = Un(A + 1 | 0, b - 1 | 0, l[D >> 2], l[D + 4 >> 2], 3) ? 0 : -31)) : A = -31));
                                      }
                                    }
                                  }
                              }
                              if (st = U + 32 | 0, A) {
                                Wr(me, 32), Wr(ie, 128), A = -31;
                                break e;
                              }
                            }
                            Wr(me, 32), A = 0;
                          }
                        wi(me);
                      } else
                        A = -22;
                      return st = D - -64 | 0, A;
                    }
                    function ms(A, g, _, b) {
                      var U, ie = 0;
                      U = ie = st, st = ie = ie - 576 & -64, l[ie + 188 >> 2] = g;
                      e:
                        if (g >>> 0 <= 64) {
                          if ((0 | ea(ie + 192 | 0, 0, 0, g)) < 0)
                            break e;
                          (0 | to(ie + 192 | 0, ie + 188 | 0, 4, 0)) < 0, (0 | to(ie + 192 | 0, _, b, 0)) < 0, mn(ie + 192 | 0, A, g);
                        } else if (!((0 | ea(ie + 192 | 0, 0, 0, 64)) < 0 || (0 | to(ie + 192 | 0, ie + 188 | 0, 4, 0)) < 0 || (0 | to(ie + 192 | 0, _, b, 0)) < 0 || (0 | mn(ie + 192 | 0, ie + 112 | 0, 64)) < 0)) {
                          if (_ = l[ie + 116 >> 2], b = l[ie + 112 >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 4 | 0] = _, j[A + 5 | 0] = _ >>> 8, j[A + 6 | 0] = _ >>> 16, j[A + 7 | 0] = _ >>> 24, _ = l[ie + 124 >> 2], b = l[ie + 120 >> 2], j[A + 8 | 0] = b, j[A + 9 | 0] = b >>> 8, j[A + 10 | 0] = b >>> 16, j[A + 11 | 0] = b >>> 24, j[A + 12 | 0] = _, j[A + 13 | 0] = _ >>> 8, j[A + 14 | 0] = _ >>> 16, j[A + 15 | 0] = _ >>> 24, _ = l[ie + 140 >> 2], b = l[ie + 136 >> 2], j[A + 24 | 0] = b, j[A + 25 | 0] = b >>> 8, j[A + 26 | 0] = b >>> 16, j[A + 27 | 0] = b >>> 24, j[A + 28 | 0] = _, j[A + 29 | 0] = _ >>> 8, j[A + 30 | 0] = _ >>> 16, j[A + 31 | 0] = _ >>> 24, _ = l[ie + 132 >> 2], b = l[ie + 128 >> 2], j[A + 16 | 0] = b, j[A + 17 | 0] = b >>> 8, j[A + 18 | 0] = b >>> 16, j[A + 19 | 0] = b >>> 24, j[A + 20 | 0] = _, j[A + 21 | 0] = _ >>> 8, j[A + 22 | 0] = _ >>> 16, j[A + 23 | 0] = _ >>> 24, A = A + 32 | 0, (g = g - 32 | 0) >>> 0 >= 65)
                            for (; ; ) {
                              if (_ = l[ie + 172 >> 2], l[ie + 104 >> 2] = l[ie + 168 >> 2], l[ie + 108 >> 2] = _, _ = l[ie + 164 >> 2], l[ie + 96 >> 2] = l[ie + 160 >> 2], l[ie + 100 >> 2] = _, _ = l[ie + 156 >> 2], l[ie + 88 >> 2] = l[ie + 152 >> 2], l[ie + 92 >> 2] = _, _ = l[ie + 148 >> 2], l[ie + 80 >> 2] = l[ie + 144 >> 2], l[ie + 84 >> 2] = _, _ = l[ie + 140 >> 2], l[ie + 72 >> 2] = l[ie + 136 >> 2], l[ie + 76 >> 2] = _, b = l[ie + 132 >> 2], l[(_ = ie - -64 | 0) >> 2] = l[ie + 128 >> 2], l[_ + 4 >> 2] = b, _ = l[ie + 124 >> 2], l[ie + 56 >> 2] = l[ie + 120 >> 2], l[ie + 60 >> 2] = _, _ = l[ie + 116 >> 2], l[ie + 48 >> 2] = l[ie + 112 >> 2], l[ie + 52 >> 2] = _, (0 | qe(ie + 112 | 0, 64, ie + 48 | 0, 64, 0, 0, 0)) < 0)
                                break e;
                              if (_ = l[ie + 116 >> 2], b = l[ie + 112 >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 4 | 0] = _, j[A + 5 | 0] = _ >>> 8, j[A + 6 | 0] = _ >>> 16, j[A + 7 | 0] = _ >>> 24, _ = l[ie + 124 >> 2], b = l[ie + 120 >> 2], j[A + 8 | 0] = b, j[A + 9 | 0] = b >>> 8, j[A + 10 | 0] = b >>> 16, j[A + 11 | 0] = b >>> 24, j[A + 12 | 0] = _, j[A + 13 | 0] = _ >>> 8, j[A + 14 | 0] = _ >>> 16, j[A + 15 | 0] = _ >>> 24, _ = l[ie + 140 >> 2], b = l[ie + 136 >> 2], j[A + 24 | 0] = b, j[A + 25 | 0] = b >>> 8, j[A + 26 | 0] = b >>> 16, j[A + 27 | 0] = b >>> 24, j[A + 28 | 0] = _, j[A + 29 | 0] = _ >>> 8, j[A + 30 | 0] = _ >>> 16, j[A + 31 | 0] = _ >>> 24, _ = l[ie + 132 >> 2], b = l[ie + 128 >> 2], j[A + 16 | 0] = b, j[A + 17 | 0] = b >>> 8, j[A + 18 | 0] = b >>> 16, j[A + 19 | 0] = b >>> 24, j[A + 20 | 0] = _, j[A + 21 | 0] = _ >>> 8, j[A + 22 | 0] = _ >>> 16, j[A + 23 | 0] = _ >>> 24, A = A + 32 | 0, !((g = g - 32 | 0) >>> 0 > 64))
                                break;
                            }
                          _ = l[ie + 172 >> 2], l[ie + 104 >> 2] = l[ie + 168 >> 2], l[ie + 108 >> 2] = _, _ = l[ie + 164 >> 2], l[ie + 96 >> 2] = l[ie + 160 >> 2], l[ie + 100 >> 2] = _, _ = l[ie + 156 >> 2], l[ie + 88 >> 2] = l[ie + 152 >> 2], l[ie + 92 >> 2] = _, _ = l[ie + 148 >> 2], l[ie + 80 >> 2] = l[ie + 144 >> 2], l[ie + 84 >> 2] = _, _ = l[ie + 140 >> 2], l[ie + 72 >> 2] = l[ie + 136 >> 2], l[ie + 76 >> 2] = _, b = l[ie + 132 >> 2], l[(_ = ie - -64 | 0) >> 2] = l[ie + 128 >> 2], l[_ + 4 >> 2] = b, _ = l[ie + 124 >> 2], l[ie + 56 >> 2] = l[ie + 120 >> 2], l[ie + 60 >> 2] = _, _ = l[ie + 116 >> 2], l[ie + 48 >> 2] = l[ie + 112 >> 2], l[ie + 52 >> 2] = _, (0 | qe(ie + 112 | 0, g, ie + 48 | 0, 64, 0, 0, 0)) < 0 || xr(A, ie + 112 | 0, g);
                        }
                      Wr(ie + 192 | 0, 384), st = U;
                    }
                    function Ps(A, g) {
                      var _, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0;
                      return st = _ = st - 512 | 0, b = -1, ie = B[g + 31 | 0], U = B[0 | g], 1 & (((255 & (127 & (-1 ^ ie) | B[g + 1 | 0] & B[g + 2 | 0] & B[g + 3 | 0] & B[g + 4 | 0] & B[g + 5 | 0] & B[g + 6 | 0] & B[g + 7 | 0] & B[g + 8 | 0] & B[g + 9 | 0] & B[g + 10 | 0] & B[g + 11 | 0] & B[g + 12 | 0] & B[g + 13 | 0] & B[g + 14 | 0] & B[g + 15 | 0] & B[g + 16 | 0] & B[g + 17 | 0] & B[g + 18 | 0] & B[g + 19 | 0] & B[g + 20 | 0] & B[g + 21 | 0] & B[g + 22 | 0] & B[g + 23 | 0] & B[g + 24 | 0] & B[g + 25 | 0] & B[g + 26 | 0] & B[g + 27 | 0] & B[g + 28 | 0] & B[g + 29 | 0] & B[g + 30 | 0] ^ -1)) - 1 & 236 - U) >>> 8 | U | ie >>> 7) || (gs(ie = _ + 336 | 0, g), Ot(_ + 288 | 0, ie), g = l[_ + 324 >> 2], l[_ + 276 >> 2] = 0 - g, b = l[_ + 320 >> 2], l[_ + 272 >> 2] = 0 - b, U = l[_ + 316 >> 2], l[_ + 268 >> 2] = 0 - U, he = l[_ + 312 >> 2], l[_ + 264 >> 2] = 0 - he, D = l[_ + 308 >> 2], l[_ + 260 >> 2] = 0 - D, me = l[_ + 304 >> 2], l[_ + 256 >> 2] = 0 - me, _e = l[_ + 300 >> 2], l[_ + 252 >> 2] = 0 - _e, Be = l[_ + 296 >> 2], l[_ + 248 >> 2] = 0 - Be, ye = l[_ + 292 >> 2], l[_ + 244 >> 2] = 0 - ye, we = l[_ + 288 >> 2], l[_ + 240 >> 2] = 1 - we, Ot($e = _ + 144 | 0, je = _ + 240 | 0), l[_ + 228 >> 2] = g, l[_ + 224 >> 2] = b, l[_ + 220 >> 2] = U, l[_ + 216 >> 2] = he, l[_ + 212 >> 2] = D, l[_ + 208 >> 2] = me, l[_ + 204 >> 2] = _e, l[_ + 200 >> 2] = Be, l[_ + 196 >> 2] = ye, l[_ + 192 >> 2] = we + 1, Ot(b = _ + 96 | 0, he = _ + 192 | 0), In(g = _ + 48 | 0, 1600, $e), U = l[_ + 96 >> 2], D = l[_ + 48 >> 2], me = l[_ + 100 >> 2], _e = l[_ + 52 >> 2], Be = l[_ + 104 >> 2], ye = l[_ + 56 >> 2], we = l[_ + 108 >> 2], $e = l[_ + 60 >> 2], Le = l[_ + 112 >> 2], Ge = l[_ + 64 >> 2], ct = l[_ + 116 >> 2], mt = l[_ + 68 >> 2], bt = l[_ + 120 >> 2], ht = l[_ + 72 >> 2], Ct = l[_ + 124 >> 2], Tt = l[_ + 76 >> 2], Gt = l[_ + 128 >> 2], en = l[_ + 80 >> 2], l[_ + 84 >> 2] = 0 - (l[_ + 84 >> 2] + l[_ + 132 >> 2] | 0), l[_ + 80 >> 2] = 0 - (Gt + en | 0), l[_ + 76 >> 2] = 0 - (Ct + Tt | 0), l[_ + 72 >> 2] = 0 - (bt + ht | 0), l[_ + 68 >> 2] = 0 - (ct + mt | 0), l[_ + 64 >> 2] = 0 - (Le + Ge | 0), l[_ + 60 >> 2] = 0 - (we + $e | 0), l[_ + 56 >> 2] = 0 - (Be + ye | 0), l[_ + 52 >> 2] = 0 - (me + _e | 0), l[_ + 48 >> 2] = 0 - (U + D | 0), In(_, g, b), l[_ + 404 >> 2] = 0, l[_ + 408 >> 2] = 0, l[_ + 412 >> 2] = 0, l[_ + 416 >> 2] = 0, l[_ + 420 >> 2] = 0, l[_ + 388 >> 2] = 0, l[_ + 392 >> 2] = 0, l[_ + 384 >> 2] = 1, l[_ + 396 >> 2] = 0, l[_ + 400 >> 2] = 0, Ge = ya(U = _ + 432 | 0, _ + 384 | 0, _), In(A, U, he), In(b = A + 40 | 0, U, A), In(b, b, g), In(A, A, ie), ie = l[A + 36 >> 2] << 1, l[A + 36 >> 2] = ie, U = l[A + 32 >> 2] << 1, l[A + 32 >> 2] = U, he = l[A + 28 >> 2] << 1, l[A + 28 >> 2] = he, D = l[A + 24 >> 2] << 1, l[A + 24 >> 2] = D, me = l[A + 20 >> 2] << 1, l[A + 20 >> 2] = me, _e = l[A + 16 >> 2] << 1, l[A + 16 >> 2] = _e, Be = l[A + 12 >> 2] << 1, l[A + 12 >> 2] = Be, ye = l[A + 8 >> 2] << 1, l[A + 8 >> 2] = ye, we = l[A + 4 >> 2] << 1, l[A + 4 >> 2] = we, $e = l[A >> 2] << 1, l[A >> 2] = $e, Ei(Le = _ + 480 | 0, A), g = 0 - (1 & j[_ + 480 | 0]) | 0, l[A + 36 >> 2] = ie ^ g & (ie ^ 0 - ie), l[A + 32 >> 2] = U ^ g & (U ^ 0 - U), l[A + 28 >> 2] = he ^ g & (he ^ 0 - he), l[A + 24 >> 2] = D ^ g & (D ^ 0 - D), l[A + 20 >> 2] = me ^ g & (me ^ 0 - me), l[A + 16 >> 2] = _e ^ g & (_e ^ 0 - _e), l[A + 12 >> 2] = Be ^ g & (Be ^ 0 - Be), l[A + 8 >> 2] = ye ^ g & (ye ^ 0 - ye), l[A + 4 >> 2] = we ^ g & (we ^ 0 - we), l[A >> 2] = $e ^ g & ($e ^ 0 - $e), In(b, je, b), l[A + 84 >> 2] = 0, l[A + 88 >> 2] = 0, l[A + 80 >> 2] = 1, l[A + 92 >> 2] = 0, l[A + 96 >> 2] = 0, l[A + 100 >> 2] = 0, l[A + 104 >> 2] = 0, l[A + 108 >> 2] = 0, l[A + 112 >> 2] = 0, l[A + 116 >> 2] = 0, In(g = A + 120 | 0, A, b), Ei(Le, g), A = B[_ + 480 | 0], Ei(Le, b), b = 0 - (le(Le, 32) | 1 - Ge | 1 & A) | 0), st = _ + 512 | 0, b;
                    }
                    function Gs(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      var ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0;
                      if (ye = De(me, 0, D, 0), !(we = ve) & ye >>> 0 >= 1073741824 | we || (0 | he) == 1 | he >>> 0 > 1)
                        return l[9129] = 22, -1;
                      for (ye = ie, Le = he; ye | Le; )
                        we = ye, ye &= ye - 1, Le &= Le - !we, Ge = (je = je + 1 | 0) ? Ge : Ge + 1 | 0;
                      if (!(!(ve = Ge) & je >>> 0 < 2 & (!he & ie >>> 0 >= 2 | (0 | he) != 0)) || !me || !D)
                        return l[9129] = 28, -1;
                      if (!(33554431 / (me >>> 0) >>> 0 < D >>> 0 | D >>> 0 > 16777215) & !he & ie >>> 0 <= 33554431 / (D >>> 0) >>> 0 && !((bt = wr(mt = D << 7, me)) >>> 0 > (we = (je = wr(ie, mt)) + bt | 0) >>> 0 || we >>> 0 > (ye = (we + (D << 8) | 0) - -64 | 0) >>> 0)) {
                        e: {
                          if (ye >>> 0 > Ri[A + 8 >> 2] && (we = -1, Eo(A), st = Le = st - 16 | 0, Ge = Ro(Le + 12 | 0, ye), l[9129] = Ge, Ge = Ge ? 0 : l[Le + 12 >> 2], l[A + 4 >> 2] = Ge, l[A >> 2] = Ge, l[A + 8 >> 2] = Ge ? ye : 0, st = Le + 16 | 0, !Ge))
                            break e;
                          for (za(g, _, b, U, Ct = l[A + 4 >> 2], bt), St = (ye = (ht = bt + Ct | 0) + je | 0) + (b = (A = D << 7) - 64 | 0) | 0, Tt = ye + (D << 8) | 0, Ft = (Le = A + ye | 0) + b | 0, it = ie - 1 | 0, Ge = D << 5; ; ) {
                            for (je = wr(mt, en) + Ct | 0, we = 0; b = (A = we << 2) + je | 0, l[A + ye >> 2] = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, U = (b = 4 | A) + ye | 0, b = b + je | 0, l[U >> 2] = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, U = (b = 8 | A) + ye | 0, b = b + je | 0, l[U >> 2] = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, b = (A |= 12) + ye | 0, A = A + je | 0, l[b >> 2] = B[0 | A] | B[A + 1 | 0] << 8 | B[A + 2 | 0] << 16 | B[A + 3 | 0] << 24, Gt = 0, b = 0, (0 | Ge) != (0 | (we = we + 4 | 0)); )
                              ;
                            for (U = 0, A = 0; xr(ht + (wr(U, Ge) << 2) | 0, ye, mt), Ms(ye, Le, Tt, D), xr(ht + (wr(Ge, 1 | U) << 2) | 0, Le, mt), Ms(Le, ye, Tt, D), (0 | he) == (0 | (A = (U = U + 2 | 0) >>> 0 < 2 ? A + 1 | 0 : A)) & U >>> 0 < ie >>> 0 | A >>> 0 < he >>> 0; )
                              ;
                            for (; ; ) {
                              for (A = ht + (wr(Ge, it & l[St >> 2]) << 2) | 0, we = 0; l[($e = (U = we << 2) + ye | 0) >> 2] = l[$e >> 2] ^ l[A + U >> 2], l[(ct = ($e = 4 | U) + ye | 0) >> 2] = l[ct >> 2] ^ l[A + $e >> 2], l[(ct = ($e = 8 | U) + ye | 0) >> 2] = l[ct >> 2] ^ l[A + $e >> 2], l[($e = (U |= 12) + ye | 0) >> 2] = l[$e >> 2] ^ l[A + U >> 2], (0 | Ge) != (0 | (we = we + 4 | 0)); )
                                ;
                              for (Ms(ye, Le, Tt, D), A = ht + (wr(Ge, it & l[Ft >> 2]) << 2) | 0, we = 0; l[($e = (U = we << 2) + Le | 0) >> 2] = l[$e >> 2] ^ l[A + U >> 2], l[(ct = ($e = 4 | U) + Le | 0) >> 2] = l[ct >> 2] ^ l[A + $e >> 2], l[(ct = ($e = 8 | U) + Le | 0) >> 2] = l[ct >> 2] ^ l[A + $e >> 2], l[($e = (U |= 12) + Le | 0) >> 2] = l[$e >> 2] ^ l[A + U >> 2], (0 | Ge) != (0 | (we = we + 4 | 0)); )
                                ;
                              if (Ms(Le, ye, Tt, D), we = 0, b = A = (Gt = Gt + 2 | 0) >>> 0 < 2 ? b + 1 | 0 : b, !((0 | he) == (0 | A) & ie >>> 0 > Gt >>> 0 | A >>> 0 < he >>> 0))
                                break;
                            }
                            for (; b = (A = we << 2) + je | 0, U = l[A + ye >> 2], j[0 | b] = U, j[b + 1 | 0] = U >>> 8, j[b + 2 | 0] = U >>> 16, j[b + 3 | 0] = U >>> 24, b = (U = 4 | A) + je | 0, U = l[U + ye >> 2], j[0 | b] = U, j[b + 1 | 0] = U >>> 8, j[b + 2 | 0] = U >>> 16, j[b + 3 | 0] = U >>> 24, b = (U = 8 | A) + je | 0, U = l[U + ye >> 2], j[0 | b] = U, j[b + 1 | 0] = U >>> 8, j[b + 2 | 0] = U >>> 16, j[b + 3 | 0] = U >>> 24, A = (b = 12 | A) + je | 0, b = l[b + ye >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, (0 | Ge) != (0 | (we = we + 4 | 0)); )
                              ;
                            if ((0 | (en = en + 1 | 0)) == (0 | me))
                              break;
                          }
                          za(g, _, Ct, bt, _e, Be), we = 0;
                        }
                        return we;
                      }
                      return l[9129] = 48, -1;
                    }
                    function Ba(A, g, _) {
                      A |= 0, g |= 0, _ |= 0;
                      var b, U, ie, he = 0;
                      st = b = st - 192 | 0, l[b + 96 >> 2] = 0, l[b + 100 >> 2] = 0, l[b + 104 >> 2] = 0, l[b + 108 >> 2] = 0, l[b + 112 >> 2] = 0, l[b + 116 >> 2] = 0, l[b + 120 >> 2] = 0, l[b + 124 >> 2] = 0, he = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, l[b + 80 >> 2] = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, l[b + 84 >> 2] = he, he = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, l[b + 88 >> 2] = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, l[b + 92 >> 2] = he, U = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, ie = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, he = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, g = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, l[b + 40 >> 2] = 0, l[b + 44 >> 2] = 0, l[b + 48 >> 2] = 0, l[b + 52 >> 2] = 0, l[b + 56 >> 2] = 0, l[b + 60 >> 2] = 0, l[b + 64 >> 2] = he, l[b + 68 >> 2] = g, l[b + 72 >> 2] = U, l[b + 76 >> 2] = ie, l[b + 32 >> 2] = 0, l[b + 36 >> 2] = 0, g = B[_ + 20 | 0] | B[_ + 21 | 0] << 8 | B[_ + 22 | 0] << 16 | B[_ + 23 | 0] << 24, l[b + 16 >> 2] = B[_ + 16 | 0] | B[_ + 17 | 0] << 8 | B[_ + 18 | 0] << 16 | B[_ + 19 | 0] << 24, l[b + 20 >> 2] = g, g = B[_ + 28 | 0] | B[_ + 29 | 0] << 8 | B[_ + 30 | 0] << 16 | B[_ + 31 | 0] << 24, l[b + 24 >> 2] = B[_ + 24 | 0] | B[_ + 25 | 0] << 8 | B[_ + 26 | 0] << 16 | B[_ + 27 | 0] << 24, l[b + 28 >> 2] = g, g = B[_ + 4 | 0] | B[_ + 5 | 0] << 8 | B[_ + 6 | 0] << 16 | B[_ + 7 | 0] << 24, l[b >> 2] = B[0 | _] | B[_ + 1 | 0] << 8 | B[_ + 2 | 0] << 16 | B[_ + 3 | 0] << 24, l[b + 4 >> 2] = g, g = B[_ + 12 | 0] | B[_ + 13 | 0] << 8 | B[_ + 14 | 0] << 16 | B[_ + 15 | 0] << 24, l[b + 8 >> 2] = B[_ + 8 | 0] | B[_ + 9 | 0] << 8 | B[_ + 10 | 0] << 16 | B[_ + 11 | 0] << 24, l[b + 12 >> 2] = g, zn(b - -64 | 0, b), _ = l[b + 124 >> 2], l[b + 184 >> 2] = l[b + 120 >> 2], l[b + 188 >> 2] = _, g = l[b + 116 >> 2], l[b + 176 >> 2] = l[b + 112 >> 2], l[b + 180 >> 2] = g, g = l[b + 108 >> 2], l[b + 168 >> 2] = l[b + 104 >> 2], l[b + 172 >> 2] = g, g = l[b + 100 >> 2], l[b + 160 >> 2] = l[b + 96 >> 2], l[b + 164 >> 2] = g, g = l[b + 92 >> 2], l[b + 152 >> 2] = l[b + 88 >> 2], l[b + 156 >> 2] = g, g = l[b + 84 >> 2], l[b + 144 >> 2] = l[b + 80 >> 2], l[b + 148 >> 2] = g, g = l[b + 76 >> 2], l[b + 136 >> 2] = l[b + 72 >> 2], l[b + 140 >> 2] = g, g = l[b + 68 >> 2], l[b + 128 >> 2] = l[b + 64 >> 2], l[b + 132 >> 2] = g, Vi(g = b + 128 | 0), he = l[b + 156 >> 2], _ = l[b + 152 >> 2], j[A + 24 | 0] = _, j[A + 25 | 0] = _ >>> 8, j[A + 26 | 0] = _ >>> 16, j[A + 27 | 0] = _ >>> 24, j[A + 28 | 0] = he, j[A + 29 | 0] = he >>> 8, j[A + 30 | 0] = he >>> 16, j[A + 31 | 0] = he >>> 24, he = l[b + 148 >> 2], _ = l[b + 144 >> 2], j[A + 16 | 0] = _, j[A + 17 | 0] = _ >>> 8, j[A + 18 | 0] = _ >>> 16, j[A + 19 | 0] = _ >>> 24, j[A + 20 | 0] = he, j[A + 21 | 0] = he >>> 8, j[A + 22 | 0] = he >>> 16, j[A + 23 | 0] = he >>> 24, he = l[b + 140 >> 2], _ = l[b + 136 >> 2], j[A + 8 | 0] = _, j[A + 9 | 0] = _ >>> 8, j[A + 10 | 0] = _ >>> 16, j[A + 11 | 0] = _ >>> 24, j[A + 12 | 0] = he, j[A + 13 | 0] = he >>> 8, j[A + 14 | 0] = he >>> 16, j[A + 15 | 0] = he >>> 24, he = l[b + 132 >> 2], _ = l[b + 128 >> 2], j[0 | A] = _, j[A + 1 | 0] = _ >>> 8, j[A + 2 | 0] = _ >>> 16, j[A + 3 | 0] = _ >>> 24, j[A + 4 | 0] = he, j[A + 5 | 0] = he >>> 8, j[A + 6 | 0] = he >>> 16, j[A + 7 | 0] = he >>> 24, Wr(g, 64), st = b + 192 | 0;
                    }
                    function Ms(A, g, _, b) {
                      var U = 0, ie = 0, he = 0, D = 0, me = 0;
                      if (ie = l[4 + (U = ((b << 7) + A | 0) - 64 | 0) >> 2], l[_ >> 2] = l[U >> 2], l[_ + 4 >> 2] = ie, ie = l[U + 60 >> 2], l[_ + 56 >> 2] = l[U + 56 >> 2], l[_ + 60 >> 2] = ie, ie = l[U + 52 >> 2], l[_ + 48 >> 2] = l[U + 48 >> 2], l[_ + 52 >> 2] = ie, ie = l[U + 44 >> 2], l[_ + 40 >> 2] = l[U + 40 >> 2], l[_ + 44 >> 2] = ie, ie = l[U + 36 >> 2], l[_ + 32 >> 2] = l[U + 32 >> 2], l[_ + 36 >> 2] = ie, ie = l[U + 28 >> 2], l[_ + 24 >> 2] = l[U + 24 >> 2], l[_ + 28 >> 2] = ie, ie = l[U + 20 >> 2], l[_ + 16 >> 2] = l[U + 16 >> 2], l[_ + 20 >> 2] = ie, ie = l[U + 12 >> 2], l[_ + 8 >> 2] = l[U + 8 >> 2], l[_ + 12 >> 2] = ie, ie = b << 1)
                        for (me = b << 4, b = 0; U = (he = b << 6) + A | 0, l[_ >> 2] = l[_ >> 2] ^ l[U >> 2], l[_ + 4 >> 2] = l[_ + 4 >> 2] ^ l[U + 4 >> 2], l[_ + 8 >> 2] = l[_ + 8 >> 2] ^ l[U + 8 >> 2], l[_ + 12 >> 2] = l[_ + 12 >> 2] ^ l[U + 12 >> 2], l[_ + 16 >> 2] = l[_ + 16 >> 2] ^ l[U + 16 >> 2], l[_ + 20 >> 2] = l[_ + 20 >> 2] ^ l[U + 20 >> 2], l[_ + 24 >> 2] = l[_ + 24 >> 2] ^ l[U + 24 >> 2], l[_ + 28 >> 2] = l[_ + 28 >> 2] ^ l[U + 28 >> 2], l[_ + 32 >> 2] = l[_ + 32 >> 2] ^ l[U + 32 >> 2], l[_ + 36 >> 2] = l[_ + 36 >> 2] ^ l[U + 36 >> 2], l[_ + 40 >> 2] = l[_ + 40 >> 2] ^ l[U + 40 >> 2], l[_ + 44 >> 2] = l[_ + 44 >> 2] ^ l[U + 44 >> 2], l[_ + 48 >> 2] = l[_ + 48 >> 2] ^ l[U + 48 >> 2], l[_ + 52 >> 2] = l[_ + 52 >> 2] ^ l[U + 52 >> 2], l[_ + 56 >> 2] = l[_ + 56 >> 2] ^ l[U + 56 >> 2], l[_ + 60 >> 2] = l[_ + 60 >> 2] ^ l[U + 60 >> 2], Bo(_), D = l[_ + 60 >> 2], l[56 + (U = (b << 5) + g | 0) >> 2] = l[_ + 56 >> 2], l[U + 60 >> 2] = D, D = l[_ + 52 >> 2], l[U + 48 >> 2] = l[_ + 48 >> 2], l[U + 52 >> 2] = D, D = l[_ + 44 >> 2], l[U + 40 >> 2] = l[_ + 40 >> 2], l[U + 44 >> 2] = D, D = l[_ + 36 >> 2], l[U + 32 >> 2] = l[_ + 32 >> 2], l[U + 36 >> 2] = D, D = l[_ + 28 >> 2], l[U + 24 >> 2] = l[_ + 24 >> 2], l[U + 28 >> 2] = D, D = l[_ + 20 >> 2], l[U + 16 >> 2] = l[_ + 16 >> 2], l[U + 20 >> 2] = D, D = l[_ + 12 >> 2], l[U + 8 >> 2] = l[_ + 8 >> 2], l[U + 12 >> 2] = D, D = l[_ + 4 >> 2], l[U >> 2] = l[_ >> 2], l[U + 4 >> 2] = D, U = (64 | he) + A | 0, l[_ >> 2] = l[_ >> 2] ^ l[U >> 2], l[_ + 4 >> 2] = l[_ + 4 >> 2] ^ l[U + 4 >> 2], l[_ + 8 >> 2] = l[_ + 8 >> 2] ^ l[U + 8 >> 2], l[_ + 12 >> 2] = l[_ + 12 >> 2] ^ l[U + 12 >> 2], l[_ + 16 >> 2] = l[_ + 16 >> 2] ^ l[U + 16 >> 2], l[_ + 20 >> 2] = l[_ + 20 >> 2] ^ l[U + 20 >> 2], l[_ + 24 >> 2] = l[_ + 24 >> 2] ^ l[U + 24 >> 2], l[_ + 28 >> 2] = l[_ + 28 >> 2] ^ l[U + 28 >> 2], l[_ + 32 >> 2] = l[_ + 32 >> 2] ^ l[U + 32 >> 2], l[_ + 36 >> 2] = l[_ + 36 >> 2] ^ l[U + 36 >> 2], l[_ + 40 >> 2] = l[_ + 40 >> 2] ^ l[U + 40 >> 2], l[_ + 44 >> 2] = l[_ + 44 >> 2] ^ l[U + 44 >> 2], l[_ + 48 >> 2] = l[_ + 48 >> 2] ^ l[U + 48 >> 2], l[_ + 52 >> 2] = l[_ + 52 >> 2] ^ l[U + 52 >> 2], l[_ + 56 >> 2] = l[_ + 56 >> 2] ^ l[U + 56 >> 2], l[_ + 60 >> 2] = l[_ + 60 >> 2] ^ l[U + 60 >> 2], Bo(_), he = l[_ + 60 >> 2], l[56 + (U = ((b << 3) + me << 2) + g | 0) >> 2] = l[_ + 56 >> 2], l[U + 60 >> 2] = he, he = l[_ + 52 >> 2], l[U + 48 >> 2] = l[_ + 48 >> 2], l[U + 52 >> 2] = he, he = l[_ + 44 >> 2], l[U + 40 >> 2] = l[_ + 40 >> 2], l[U + 44 >> 2] = he, he = l[_ + 36 >> 2], l[U + 32 >> 2] = l[_ + 32 >> 2], l[U + 36 >> 2] = he, he = l[_ + 28 >> 2], l[U + 24 >> 2] = l[_ + 24 >> 2], l[U + 28 >> 2] = he, he = l[_ + 20 >> 2], l[U + 16 >> 2] = l[_ + 16 >> 2], l[U + 20 >> 2] = he, he = l[_ + 12 >> 2], l[U + 8 >> 2] = l[_ + 8 >> 2], l[U + 12 >> 2] = he, he = l[_ + 4 >> 2], l[U >> 2] = l[_ >> 2], l[U + 4 >> 2] = he, ie >>> 0 > (b = b + 2 | 0) >>> 0; )
                          ;
                    }
                    function Xs(A, g, _, b) {
                      var U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0;
                      if (Le = l[A + 36 >> 2], we = l[A + 32 >> 2], $e = l[A + 28 >> 2], Be = l[A + 24 >> 2], ye = l[A + 20 >> 2], !b & _ >>> 0 >= 16 | b)
                        for (en = !B[A + 80 | 0] << 24, je = l[A + 4 >> 2], it = wr(je, 5), mt = l[A + 8 >> 2], Tt = wr(mt, 5), ht = l[A + 12 >> 2], Ct = wr(ht, 5), Gt = l[A + 16 >> 2], bt = wr(Gt, 5), ct = l[A >> 2]; U = De(he = ((B[g + 3 | 0] | B[g + 4 | 0] << 8 | B[g + 5 | 0] << 16 | B[g + 6 | 0] << 24) >>> 2 & 67108863) + Be | 0, 0, ht, 0), me = ve, ye = (D = De(Be = (67108863 & (B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24)) + ye | 0, 0, Gt, 0)) + U | 0, U = ve + me | 0, U = D >>> 0 > ye >>> 0 ? U + 1 | 0 : U, me = De($e = ((B[g + 6 | 0] | B[g + 7 | 0] << 8 | B[g + 8 | 0] << 16 | B[g + 9 | 0] << 24) >>> 4 & 67108863) + $e | 0, 0, mt, 0), U = ve + U | 0, U = me >>> 0 > (ye = me + ye | 0) >>> 0 ? U + 1 | 0 : U, me = De(we = ((B[g + 9 | 0] | B[g + 10 | 0] << 8 | B[g + 11 | 0] << 16 | B[g + 12 | 0] << 24) >>> 6 | 0) + we | 0, 0, je, 0), U = ve + U | 0, U = me >>> 0 > (ye = me + ye | 0) >>> 0 ? U + 1 | 0 : U, me = De(Le = Le + en + ((B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24) >>> 8) | 0, 0, ct, 0), U = ve + U | 0, St = ye = me + ye | 0, ye = me >>> 0 > ye >>> 0 ? U + 1 | 0 : U, U = De(he, 0, mt, 0), me = ve, D = De(Be, 0, ht, 0), ie = ve + me | 0, ie = (U = D + U | 0) >>> 0 < D >>> 0 ? ie + 1 | 0 : ie, me = (D = De($e, 0, je, 0)) + U | 0, U = ve + ie | 0, U = D >>> 0 > me >>> 0 ? U + 1 | 0 : U, D = De(we, 0, ct, 0), U = ve + U | 0, U = D >>> 0 > (me = D + me | 0) >>> 0 ? U + 1 | 0 : U, D = De(Le, 0, bt, 0), U = ve + U | 0, Ft = me = D + me | 0, me = D >>> 0 > me >>> 0 ? U + 1 | 0 : U, U = De(he, 0, je, 0), _e = ve, D = (ie = De(Be, 0, mt, 0)) + U | 0, U = ve + _e | 0, U = ie >>> 0 > D >>> 0 ? U + 1 | 0 : U, _e = De($e, 0, ct, 0), ie = ve + U | 0, ie = (D = _e + D | 0) >>> 0 < _e >>> 0 ? ie + 1 | 0 : ie, _e = De(we, 0, bt, 0), U = ve + ie | 0, U = (D = _e + D | 0) >>> 0 < _e >>> 0 ? U + 1 | 0 : U, _e = De(Le, 0, Ct, 0), U = ve + U | 0, fn = D = _e + D | 0, D = D >>> 0 < _e >>> 0 ? U + 1 | 0 : U, U = De(he, 0, ct, 0), ie = ve, _e = (Ge = De(Be, 0, je, 0)) + U | 0, U = ve + ie | 0, U = _e >>> 0 < Ge >>> 0 ? U + 1 | 0 : U, ie = De($e, 0, bt, 0), U = ve + U | 0, U = ie >>> 0 > (_e = ie + _e | 0) >>> 0 ? U + 1 | 0 : U, Ge = De(we, 0, Ct, 0), ie = ve + U | 0, ie = (_e = Ge + _e | 0) >>> 0 < Ge >>> 0 ? ie + 1 | 0 : ie, Ge = De(Le, 0, Tt, 0), U = ve + ie | 0, U = (_e = Ge + _e | 0) >>> 0 < Ge >>> 0 ? U + 1 | 0 : U, Ge = _e, _e = U, U = De(he, 0, bt, 0), ie = ve, he = (Be = De(Be, 0, ct, 0)) + U | 0, U = ve + ie | 0, U = he >>> 0 < Be >>> 0 ? U + 1 | 0 : U, Be = De($e, 0, Ct, 0), U = ve + U | 0, U = (he = Be + he | 0) >>> 0 < Be >>> 0 ? U + 1 | 0 : U, Be = De(we, 0, Tt, 0), U = ve + U | 0, U = (he = Be + he | 0) >>> 0 < Be >>> 0 ? U + 1 | 0 : U, Be = De(Le, 0, it, 0), ie = ve + U | 0, ie = (he = Be + he | 0) >>> 0 < Be >>> 0 ? ie + 1 | 0 : ie, Be = he, U = _e, U = (he = ($e = (67108863 & ie) << 6 | he >>> 26) + Ge | 0) >>> 0 < $e >>> 0 ? U + 1 | 0 : U, $e = he, we = (67108863 & U) << 6 | he >>> 26, U = D, U = (he = we + fn | 0) >>> 0 < we >>> 0 ? U + 1 | 0 : U, we = he, ie = me, Le = U = (he = (67108863 & U) << 6 | he >>> 26) + Ft | 0, me = (67108863 & (ie = U >>> 0 < he >>> 0 ? ie + 1 | 0 : ie)) << 6 | U >>> 26, U = ye, Be = (67108863 & $e) + ((U = wr((67108863 & ((he = me + St | 0) >>> 0 < me >>> 0 ? U + 1 | 0 : U)) << 6 | he >>> 26, 5) + (67108863 & Be) | 0) >>> 26 | 0) | 0, $e = 67108863 & we, we = 67108863 & Le, Le = 67108863 & he, ye = 67108863 & U, g = g + 16 | 0, !(b = b - (_ >>> 0 < 16) | 0) & (_ = _ - 16 | 0) >>> 0 > 15 | b; )
                          ;
                      l[A + 20 >> 2] = ye, l[A + 36 >> 2] = Le, l[A + 32 >> 2] = we, l[A + 28 >> 2] = $e, l[A + 24 >> 2] = Be;
                    }
                    function ea(A, g, _, b) {
                      A |= 0, g |= 0;
                      var U = 0;
                      return U = -1, (b |= 0) - 65 >>> 0 < 4294967232 | (_ |= 0) >>> 0 > 64 || (_ && g ? (st = U = st - 128 | 0, !g | ((b &= 255) - 65 & 255) >>> 0 <= 191 | ((_ &= 255) - 65 & 255) >>> 0 <= 191 ? (Ai(), Xr()) : (Jt(A - -64 | 0, 0, 293), j[A + 56 | 0] = 121, j[A + 57 | 0] = 33, j[A + 58 | 0] = 126, j[A + 59 | 0] = 19, j[A + 60 | 0] = 25, j[A + 61 | 0] = 205, j[A + 62 | 0] = 224, j[A + 63 | 0] = 91, j[A + 48 | 0] = 107, j[A + 49 | 0] = 189, j[A + 50 | 0] = 65, j[A + 51 | 0] = 251, j[A + 52 | 0] = 171, j[A + 53 | 0] = 217, j[A + 54 | 0] = 131, j[A + 55 | 0] = 31, j[A + 40 | 0] = 31, j[A + 41 | 0] = 108, j[A + 42 | 0] = 62, j[A + 43 | 0] = 43, j[A + 44 | 0] = 140, j[A + 45 | 0] = 104, j[A + 46 | 0] = 5, j[A + 47 | 0] = 155, j[A + 32 | 0] = 209, j[A + 33 | 0] = 130, j[A + 34 | 0] = 230, j[A + 35 | 0] = 173, j[A + 36 | 0] = 127, j[A + 37 | 0] = 82, j[A + 38 | 0] = 14, j[A + 39 | 0] = 81, j[A + 24 | 0] = 241, j[A + 25 | 0] = 54, j[A + 26 | 0] = 29, j[A + 27 | 0] = 95, j[A + 28 | 0] = 58, j[A + 29 | 0] = 245, j[A + 30 | 0] = 79, j[A + 31 | 0] = 165, j[A + 16 | 0] = 43, j[A + 17 | 0] = 248, j[A + 18 | 0] = 148, j[A + 19 | 0] = 254, j[A + 20 | 0] = 114, j[A + 21 | 0] = 243, j[A + 22 | 0] = 110, j[A + 23 | 0] = 60, j[A + 8 | 0] = 59, j[A + 9 | 0] = 167, j[A + 10 | 0] = 202, j[A + 11 | 0] = 132, j[A + 12 | 0] = 133, j[A + 13 | 0] = 174, j[A + 14 | 0] = 103, j[A + 15 | 0] = 187, b = -222443256 ^ (_ << 8 | b), j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, b = _ >>> 24 ^ 1779033703, j[A + 4 | 0] = b, j[A + 5 | 0] = b >>> 8, j[A + 6 | 0] = b >>> 16, j[A + 7 | 0] = b >>> 24, Jt(_ + U | 0, 0, _ << 24 >> 24 >= 0 ? 128 - _ | 0 : 0), _ = xr(U, g, _), xr(A + 96 | 0, _, 128), g = 128 + (B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24) | 0, j[A + 352 | 0] = g, j[A + 353 | 0] = g >>> 8, j[A + 354 | 0] = g >>> 16, j[A + 355 | 0] = g >>> 24, Wr(_, 128), st = _ + 128 | 0)) : (((g = 255 & b) - 65 & 255) >>> 0 <= 191 && (Ai(), Xr()), Jt(A - -64 | 0, 0, 293), j[A + 56 | 0] = 121, j[A + 57 | 0] = 33, j[A + 58 | 0] = 126, j[A + 59 | 0] = 19, j[A + 60 | 0] = 25, j[A + 61 | 0] = 205, j[A + 62 | 0] = 224, j[A + 63 | 0] = 91, j[A + 48 | 0] = 107, j[A + 49 | 0] = 189, j[A + 50 | 0] = 65, j[A + 51 | 0] = 251, j[A + 52 | 0] = 171, j[A + 53 | 0] = 217, j[A + 54 | 0] = 131, j[A + 55 | 0] = 31, j[A + 40 | 0] = 31, j[A + 41 | 0] = 108, j[A + 42 | 0] = 62, j[A + 43 | 0] = 43, j[A + 44 | 0] = 140, j[A + 45 | 0] = 104, j[A + 46 | 0] = 5, j[A + 47 | 0] = 155, j[A + 32 | 0] = 209, j[A + 33 | 0] = 130, j[A + 34 | 0] = 230, j[A + 35 | 0] = 173, j[A + 36 | 0] = 127, j[A + 37 | 0] = 82, j[A + 38 | 0] = 14, j[A + 39 | 0] = 81, j[A + 24 | 0] = 241, j[A + 25 | 0] = 54, j[A + 26 | 0] = 29, j[A + 27 | 0] = 95, j[A + 28 | 0] = 58, j[A + 29 | 0] = 245, j[A + 30 | 0] = 79, j[A + 31 | 0] = 165, j[A + 16 | 0] = 43, j[A + 17 | 0] = 248, j[A + 18 | 0] = 148, j[A + 19 | 0] = 254, j[A + 20 | 0] = 114, j[A + 21 | 0] = 243, j[A + 22 | 0] = 110, j[A + 23 | 0] = 60, j[A + 8 | 0] = 59, j[A + 9 | 0] = 167, j[A + 10 | 0] = 202, j[A + 11 | 0] = 132, j[A + 12 | 0] = 133, j[A + 13 | 0] = 174, j[A + 14 | 0] = 103, j[A + 15 | 0] = 187, g ^= -222443256, j[0 | A] = g, j[A + 1 | 0] = g >>> 8, j[A + 2 | 0] = g >>> 16, j[A + 3 | 0] = g >>> 24, j[A + 4 | 0] = 103, j[A + 5 | 0] = 230, j[A + 6 | 0] = 9, j[A + 7 | 0] = 106), U = 0), 0 | U;
                    }
                    function Ji(A, g, _, b) {
                      A |= 0, g |= 0, _ |= 0;
                      var U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0;
                      for ((b |= 0) ? (ie = B[b + 8 | 0] | B[b + 9 | 0] << 8 | B[b + 10 | 0] << 16 | B[b + 11 | 0] << 24, he = B[b + 4 | 0] | B[b + 5 | 0] << 8 | B[b + 6 | 0] << 16 | B[b + 7 | 0] << 24, U = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, Be = B[b + 12 | 0] | B[b + 13 | 0] << 8 | B[b + 14 | 0] << 16 | B[b + 15 | 0] << 24) : (ie = 2036477234, he = 857760878, U = 1634760805, Be = 1797285236), D = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, we = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, me = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, $e = B[_ + 28 | 0] | B[_ + 29 | 0] << 8 | B[_ + 30 | 0] << 16 | B[_ + 31 | 0] << 24, _e = B[_ + 24 | 0] | B[_ + 25 | 0] << 8 | B[_ + 26 | 0] << 16 | B[_ + 27 | 0] << 24, bt = B[_ + 20 | 0] | B[_ + 21 | 0] << 8 | B[_ + 22 | 0] << 16 | B[_ + 23 | 0] << 24, Le = B[_ + 16 | 0] | B[_ + 17 | 0] << 8 | B[_ + 18 | 0] << 16 | B[_ + 19 | 0] << 24, b = B[_ + 12 | 0] | B[_ + 13 | 0] << 8 | B[_ + 14 | 0] << 16 | B[_ + 15 | 0] << 24, Ge = B[_ + 8 | 0] | B[_ + 9 | 0] << 8 | B[_ + 10 | 0] << 16 | B[_ + 11 | 0] << 24, je = B[_ + 4 | 0] | B[_ + 5 | 0] << 8 | B[_ + 6 | 0] << 16 | B[_ + 7 | 0] << 24, g = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, _ = B[0 | _] | B[_ + 1 | 0] << 8 | B[_ + 2 | 0] << 16 | B[_ + 3 | 0] << 24; ye = _, _ = tn((ct = g) ^ (g = _ + U | 0), 16), ye = Le = tn(ye ^ (U = _ + Le | 0), 12), mt = tn((ct = g + Le | 0) ^ _, 8), g = tn(ye ^ (Le = mt + U | 0), 7), D = tn((_ = b + Be | 0) ^ D, 16), b = tn(($e = D + $e | 0) ^ b, 12), ye = Ge, ie = tn((Be = ie + Ge | 0) ^ we, 16), U = tn(ye ^ (Ge = ie + _e | 0), 12), _e = tn((_e = ie) ^ (ie = U + Be | 0), 8), _ = tn(_e ^ (Be = (ht = _ + b | 0) + g | 0), 16), we = tn((he = he + je | 0) ^ me, 16), je = tn((me = we + bt | 0) ^ je, 12), ye = g, g = tn((he = je + he | 0) ^ we, 8), ye = tn(ye ^ (me = (Ct = g + me | 0) + _ | 0), 12), we = tn(_ ^ (Be = ye + Be | 0), 8), _ = tn((bt = we + me | 0) ^ ye, 7), D = tn(D ^ ht, 8), b = tn(($e = D + $e | 0) ^ b, 7), me = tn((ie = b + ie | 0) ^ g, 16), b = tn((g = me + Le | 0) ^ b, 12), me = tn(me ^ (ie = b + ie | 0), 8), b = tn((Le = g + me | 0) ^ b, 7), g = tn((_e = _e + Ge | 0) ^ U, 7), Ge = tn((he = g + he | 0) ^ mt, 16), mt = tn(g ^ (U = Ge + $e | 0), 12), g = tn(Ge ^ (he = mt + he | 0), 8), Ge = tn(($e = U + g | 0) ^ mt, 7), ye = _e, _e = D, U = tn(je ^ Ct, 7), _e = tn(_e ^ (D = U + ct | 0), 16), ct = tn(U ^ (je = ye + _e | 0), 12), D = tn(_e ^ (U = ct + D | 0), 8), je = tn((_e = je + D | 0) ^ ct, 7), (0 | (Tt = Tt + 1 | 0)) != 10; )
                        ;
                      return j[0 | A] = U, j[A + 1 | 0] = U >>> 8, j[A + 2 | 0] = U >>> 16, j[A + 3 | 0] = U >>> 24, j[A + 28 | 0] = D, j[A + 29 | 0] = D >>> 8, j[A + 30 | 0] = D >>> 16, j[A + 31 | 0] = D >>> 24, j[A + 24 | 0] = we, j[A + 25 | 0] = we >>> 8, j[A + 26 | 0] = we >>> 16, j[A + 27 | 0] = we >>> 24, j[A + 20 | 0] = me, j[A + 21 | 0] = me >>> 8, j[A + 22 | 0] = me >>> 16, j[A + 23 | 0] = me >>> 24, j[A + 16 | 0] = g, j[A + 17 | 0] = g >>> 8, j[A + 18 | 0] = g >>> 16, j[A + 19 | 0] = g >>> 24, j[A + 12 | 0] = Be, j[A + 13 | 0] = Be >>> 8, j[A + 14 | 0] = Be >>> 16, j[A + 15 | 0] = Be >>> 24, j[A + 8 | 0] = ie, j[A + 9 | 0] = ie >>> 8, j[A + 10 | 0] = ie >>> 16, j[A + 11 | 0] = ie >>> 24, j[A + 4 | 0] = he, j[A + 5 | 0] = he >>> 8, j[A + 6 | 0] = he >>> 16, j[A + 7 | 0] = he >>> 24, 0;
                    }
                    function Si(A, g, _) {
                      var b, U, ie, he, D, me, _e, Be, ye, we, $e, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0;
                      Le = l[g + 40 >> 2], Ge = l[g + 4 >> 2], ct = l[g + 44 >> 2], mt = l[g + 8 >> 2], bt = l[g + 48 >> 2], ht = l[g + 12 >> 2], Ct = l[g + 52 >> 2], Tt = l[g + 16 >> 2], Gt = l[g + 56 >> 2], en = l[g + 20 >> 2], it = l[g + 60 >> 2], St = l[g + 24 >> 2], Ft = l[(je = g - -64 | 0) >> 2], fn = l[g + 28 >> 2], _n = l[g + 68 >> 2], wn = l[g + 32 >> 2], $n = l[g + 72 >> 2], qn = l[g >> 2], l[A + 36 >> 2] = l[g + 36 >> 2] + l[g + 76 >> 2], l[A + 32 >> 2] = wn + $n, l[A + 28 >> 2] = fn + _n, l[A + 24 >> 2] = St + Ft, l[A + 20 >> 2] = en + it, l[A + 16 >> 2] = Tt + Gt, l[A + 12 >> 2] = ht + Ct, l[A + 8 >> 2] = mt + bt, l[A + 4 >> 2] = Ge + ct, l[A >> 2] = Le + qn, ct = l[g + 40 >> 2], Le = l[g + 4 >> 2], mt = l[g + 44 >> 2], bt = l[g + 8 >> 2], ht = l[g + 48 >> 2], Ct = l[g + 12 >> 2], Tt = l[g + 52 >> 2], Gt = l[g + 16 >> 2], en = l[g + 56 >> 2], it = l[g + 20 >> 2], St = l[g + 60 >> 2], Ft = l[g + 24 >> 2], je = l[je >> 2], Ge = l[g + 28 >> 2], fn = l[g + 68 >> 2], _n = l[g + 32 >> 2], wn = l[g + 72 >> 2], $n = l[g >> 2], l[A + 76 >> 2] = l[g + 76 >> 2] - l[g + 36 >> 2], l[A + 72 >> 2] = wn - _n, l[A + 68 >> 2] = fn - Ge, l[(Ge = A - -64 | 0) >> 2] = je - Ft, l[A + 60 >> 2] = St - it, l[A + 56 >> 2] = en - Gt, l[A + 52 >> 2] = Tt - Ct, l[A + 48 >> 2] = ht - bt, l[A + 44 >> 2] = mt - Le, l[(Le = A + 40 | 0) >> 2] = ct - $n, In(A + 80 | 0, A, _), In(Le, Le, _ + 40 | 0), In(A + 120 | 0, _ + 120 | 0, g + 120 | 0), In(A, g + 80 | 0, _ + 80 | 0), qn = l[A + 4 >> 2], ie = l[A + 8 >> 2], he = l[A + 12 >> 2], D = l[A + 16 >> 2], me = l[A + 20 >> 2], _e = l[A + 24 >> 2], Be = l[A + 28 >> 2], ye = l[A + 32 >> 2], we = l[A + 36 >> 2], g = l[Le >> 2], _ = l[A + 80 >> 2], ct = l[A + 44 >> 2], mt = l[A + 84 >> 2], bt = l[A + 48 >> 2], ht = l[A + 88 >> 2], Ct = l[A + 52 >> 2], Tt = l[A + 92 >> 2], Gt = l[A + 56 >> 2], en = l[A + 96 >> 2], it = l[A + 60 >> 2], St = l[A + 100 >> 2], je = l[Ge >> 2], Ft = l[A + 104 >> 2], fn = l[A + 68 >> 2], _n = l[A + 108 >> 2], wn = l[A + 72 >> 2], $n = l[A + 112 >> 2], $e = l[A >> 2], b = l[A + 76 >> 2], U = l[A + 116 >> 2], l[A + 76 >> 2] = b + U, l[A + 72 >> 2] = wn + $n, l[A + 68 >> 2] = fn + _n, l[Ge >> 2] = je + Ft, l[A + 60 >> 2] = it + St, l[A + 56 >> 2] = Gt + en, l[A + 52 >> 2] = Ct + Tt, l[A + 48 >> 2] = bt + ht, l[A + 44 >> 2] = ct + mt, l[Le >> 2] = g + _, l[A + 36 >> 2] = U - b, l[A + 32 >> 2] = $n - wn, l[A + 28 >> 2] = _n - fn, l[A + 24 >> 2] = Ft - je, l[A + 20 >> 2] = St - it, l[A + 16 >> 2] = en - Gt, l[A + 12 >> 2] = Tt - Ct, l[A + 8 >> 2] = ht - bt, l[A + 4 >> 2] = mt - ct, l[A >> 2] = _ - g, g = we << 1, _ = l[A + 156 >> 2], l[A + 156 >> 2] = g - _, Le = ye << 1, Ge = l[A + 152 >> 2], l[A + 152 >> 2] = Le - Ge, ct = Be << 1, mt = l[A + 148 >> 2], l[A + 148 >> 2] = ct - mt, bt = _e << 1, ht = l[A + 144 >> 2], l[A + 144 >> 2] = bt - ht, Ct = me << 1, Tt = l[A + 140 >> 2], l[A + 140 >> 2] = Ct - Tt, Gt = D << 1, en = l[A + 136 >> 2], l[A + 136 >> 2] = Gt - en, it = he << 1, St = l[A + 132 >> 2], l[A + 132 >> 2] = it - St, je = ie << 1, Ft = l[A + 128 >> 2], l[A + 128 >> 2] = je - Ft, fn = qn << 1, _n = l[A + 124 >> 2], l[A + 124 >> 2] = fn - _n, wn = $e << 1, $n = l[A + 120 >> 2], l[A + 120 >> 2] = wn - $n, l[A + 112 >> 2] = Le + Ge, l[A + 108 >> 2] = ct + mt, l[A + 104 >> 2] = bt + ht, l[A + 100 >> 2] = Ct + Tt, l[A + 96 >> 2] = Gt + en, l[A + 92 >> 2] = it + St, l[A + 88 >> 2] = je + Ft, l[A + 84 >> 2] = fn + _n, l[A + 80 >> 2] = wn + $n, l[A + 116 >> 2] = g + _;
                    }
                    function Ts(A, g, _) {
                      var b, U, ie, he, D, me, _e, Be, ye, we, $e, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0;
                      Le = l[g + 40 >> 2], Ge = l[g + 4 >> 2], ct = l[g + 44 >> 2], mt = l[g + 8 >> 2], bt = l[g + 48 >> 2], ht = l[g + 12 >> 2], Ct = l[g + 52 >> 2], Tt = l[g + 16 >> 2], Gt = l[g + 56 >> 2], en = l[g + 20 >> 2], it = l[g + 60 >> 2], St = l[g + 24 >> 2], Ft = l[(je = g - -64 | 0) >> 2], fn = l[g + 28 >> 2], _n = l[g + 68 >> 2], wn = l[g + 32 >> 2], $n = l[g + 72 >> 2], qn = l[g >> 2], l[A + 36 >> 2] = l[g + 36 >> 2] + l[g + 76 >> 2], l[A + 32 >> 2] = wn + $n, l[A + 28 >> 2] = fn + _n, l[A + 24 >> 2] = St + Ft, l[A + 20 >> 2] = en + it, l[A + 16 >> 2] = Tt + Gt, l[A + 12 >> 2] = ht + Ct, l[A + 8 >> 2] = mt + bt, l[A + 4 >> 2] = Ge + ct, l[A >> 2] = Le + qn, ct = l[g + 40 >> 2], Le = l[g + 4 >> 2], mt = l[g + 44 >> 2], bt = l[g + 8 >> 2], ht = l[g + 48 >> 2], Ct = l[g + 12 >> 2], Tt = l[g + 52 >> 2], Gt = l[g + 16 >> 2], en = l[g + 56 >> 2], it = l[g + 20 >> 2], St = l[g + 60 >> 2], Ft = l[g + 24 >> 2], je = l[je >> 2], Ge = l[g + 28 >> 2], fn = l[g + 68 >> 2], _n = l[g + 32 >> 2], wn = l[g + 72 >> 2], $n = l[g >> 2], l[A + 76 >> 2] = l[g + 76 >> 2] - l[g + 36 >> 2], l[A + 72 >> 2] = wn - _n, l[A + 68 >> 2] = fn - Ge, l[(Ge = A - -64 | 0) >> 2] = je - Ft, l[A + 60 >> 2] = St - it, l[A + 56 >> 2] = en - Gt, l[A + 52 >> 2] = Tt - Ct, l[A + 48 >> 2] = ht - bt, l[A + 44 >> 2] = mt - Le, l[(Le = A + 40 | 0) >> 2] = ct - $n, In(A + 80 | 0, A, _ + 40 | 0), In(Le, Le, _), In(A + 120 | 0, _ + 120 | 0, g + 120 | 0), In(A, g + 80 | 0, _ + 80 | 0), qn = l[A + 4 >> 2], ie = l[A + 8 >> 2], he = l[A + 12 >> 2], D = l[A + 16 >> 2], me = l[A + 20 >> 2], _e = l[A + 24 >> 2], Be = l[A + 28 >> 2], ye = l[A + 32 >> 2], we = l[A + 36 >> 2], g = l[Le >> 2], _ = l[A + 80 >> 2], ct = l[A + 44 >> 2], mt = l[A + 84 >> 2], bt = l[A + 48 >> 2], ht = l[A + 88 >> 2], Ct = l[A + 52 >> 2], Tt = l[A + 92 >> 2], Gt = l[A + 56 >> 2], en = l[A + 96 >> 2], it = l[A + 60 >> 2], St = l[A + 100 >> 2], je = l[Ge >> 2], Ft = l[A + 104 >> 2], fn = l[A + 68 >> 2], _n = l[A + 108 >> 2], wn = l[A + 72 >> 2], $n = l[A + 112 >> 2], $e = l[A >> 2], b = l[A + 76 >> 2], U = l[A + 116 >> 2], l[A + 76 >> 2] = b + U, l[A + 72 >> 2] = wn + $n, l[A + 68 >> 2] = fn + _n, l[Ge >> 2] = je + Ft, l[A + 60 >> 2] = it + St, l[A + 56 >> 2] = Gt + en, l[A + 52 >> 2] = Ct + Tt, l[A + 48 >> 2] = bt + ht, l[A + 44 >> 2] = ct + mt, l[Le >> 2] = g + _, l[A + 36 >> 2] = U - b, l[A + 32 >> 2] = $n - wn, l[A + 28 >> 2] = _n - fn, l[A + 24 >> 2] = Ft - je, l[A + 20 >> 2] = St - it, l[A + 16 >> 2] = en - Gt, l[A + 12 >> 2] = Tt - Ct, l[A + 8 >> 2] = ht - bt, l[A + 4 >> 2] = mt - ct, l[A >> 2] = _ - g, g = l[A + 156 >> 2], _ = we << 1, l[A + 156 >> 2] = g + _, Le = l[A + 152 >> 2], Ge = ye << 1, l[A + 152 >> 2] = Le + Ge, ct = l[A + 148 >> 2], mt = Be << 1, l[A + 148 >> 2] = ct + mt, bt = l[A + 144 >> 2], ht = _e << 1, l[A + 144 >> 2] = bt + ht, Ct = l[A + 140 >> 2], Tt = me << 1, l[A + 140 >> 2] = Ct + Tt, Gt = l[A + 136 >> 2], en = D << 1, l[A + 136 >> 2] = Gt + en, it = l[A + 132 >> 2], St = he << 1, l[A + 132 >> 2] = it + St, je = l[A + 128 >> 2], Ft = ie << 1, l[A + 128 >> 2] = je + Ft, fn = l[A + 124 >> 2], _n = qn << 1, l[A + 124 >> 2] = fn + _n, wn = l[A + 120 >> 2], $n = $e << 1, l[A + 120 >> 2] = wn + $n, l[A + 112 >> 2] = Ge - Le, l[A + 108 >> 2] = mt - ct, l[A + 104 >> 2] = ht - bt, l[A + 100 >> 2] = Tt - Ct, l[A + 96 >> 2] = en - Gt, l[A + 92 >> 2] = St - it, l[A + 88 >> 2] = Ft - je, l[A + 84 >> 2] = _n - fn, l[A + 80 >> 2] = $n - wn, l[A + 116 >> 2] = _ - g;
                    }
                    function Ds(A, g, _) {
                      var b, U, ie, he, D, me, _e, Be, ye, we, $e, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0;
                      Le = l[g + 40 >> 2], Ge = l[g + 4 >> 2], ct = l[g + 44 >> 2], mt = l[g + 8 >> 2], bt = l[g + 48 >> 2], ht = l[g + 12 >> 2], Ct = l[g + 52 >> 2], Tt = l[g + 16 >> 2], Gt = l[g + 56 >> 2], en = l[g + 20 >> 2], it = l[g + 60 >> 2], St = l[g + 24 >> 2], Ft = l[(je = g - -64 | 0) >> 2], fn = l[g + 28 >> 2], _n = l[g + 68 >> 2], wn = l[g + 32 >> 2], $n = l[g + 72 >> 2], qn = l[g >> 2], l[A + 36 >> 2] = l[g + 36 >> 2] + l[g + 76 >> 2], l[A + 32 >> 2] = wn + $n, l[A + 28 >> 2] = fn + _n, l[A + 24 >> 2] = St + Ft, l[A + 20 >> 2] = en + it, l[A + 16 >> 2] = Tt + Gt, l[A + 12 >> 2] = ht + Ct, l[A + 8 >> 2] = mt + bt, l[A + 4 >> 2] = Ge + ct, l[A >> 2] = Le + qn, ct = l[g + 40 >> 2], Le = l[g + 4 >> 2], mt = l[g + 44 >> 2], bt = l[g + 8 >> 2], ht = l[g + 48 >> 2], Ct = l[g + 12 >> 2], Tt = l[g + 52 >> 2], Gt = l[g + 16 >> 2], en = l[g + 56 >> 2], it = l[g + 20 >> 2], St = l[g + 60 >> 2], Ft = l[g + 24 >> 2], je = l[je >> 2], Ge = l[g + 28 >> 2], fn = l[g + 68 >> 2], _n = l[g + 32 >> 2], wn = l[g + 72 >> 2], $n = l[g >> 2], l[A + 76 >> 2] = l[g + 76 >> 2] - l[g + 36 >> 2], l[A + 72 >> 2] = wn - _n, l[A + 68 >> 2] = fn - Ge, l[(Ge = A - -64 | 0) >> 2] = je - Ft, l[A + 60 >> 2] = St - it, l[A + 56 >> 2] = en - Gt, l[A + 52 >> 2] = Tt - Ct, l[A + 48 >> 2] = ht - bt, l[A + 44 >> 2] = mt - Le, l[(Le = A + 40 | 0) >> 2] = ct - $n, In(A + 80 | 0, A, _), In(Le, Le, _ + 40 | 0), In(A + 120 | 0, _ + 80 | 0, g + 120 | 0), qn = l[g + 80 >> 2], ie = l[g + 84 >> 2], he = l[g + 88 >> 2], D = l[g + 92 >> 2], me = l[g + 96 >> 2], _e = l[g + 100 >> 2], Be = l[g + 104 >> 2], ye = l[g + 108 >> 2], we = l[g + 112 >> 2], $e = l[g + 116 >> 2], g = l[Le >> 2], _ = l[A + 80 >> 2], ct = l[A + 44 >> 2], mt = l[A + 84 >> 2], bt = l[A + 48 >> 2], ht = l[A + 88 >> 2], Ct = l[A + 52 >> 2], Tt = l[A + 92 >> 2], Gt = l[A + 56 >> 2], en = l[A + 96 >> 2], it = l[A + 60 >> 2], St = l[A + 100 >> 2], je = l[Ge >> 2], Ft = l[A + 104 >> 2], fn = l[A + 68 >> 2], _n = l[A + 108 >> 2], wn = l[A + 72 >> 2], $n = l[A + 112 >> 2], b = l[A + 76 >> 2], U = l[A + 116 >> 2], l[A + 76 >> 2] = b + U, l[A + 72 >> 2] = wn + $n, l[A + 68 >> 2] = fn + _n, l[Ge >> 2] = je + Ft, l[A + 60 >> 2] = it + St, l[A + 56 >> 2] = Gt + en, l[A + 52 >> 2] = Ct + Tt, l[A + 48 >> 2] = bt + ht, l[A + 44 >> 2] = ct + mt, l[Le >> 2] = g + _, l[A + 36 >> 2] = U - b, l[A + 32 >> 2] = $n - wn, l[A + 28 >> 2] = _n - fn, l[A + 24 >> 2] = Ft - je, l[A + 20 >> 2] = St - it, l[A + 16 >> 2] = en - Gt, l[A + 12 >> 2] = Tt - Ct, l[A + 8 >> 2] = ht - bt, l[A + 4 >> 2] = mt - ct, l[A >> 2] = _ - g, g = $e << 1, _ = l[A + 156 >> 2], l[A + 156 >> 2] = g - _, Le = we << 1, Ge = l[A + 152 >> 2], l[A + 152 >> 2] = Le - Ge, ct = ye << 1, mt = l[A + 148 >> 2], l[A + 148 >> 2] = ct - mt, bt = Be << 1, ht = l[A + 144 >> 2], l[A + 144 >> 2] = bt - ht, Ct = _e << 1, Tt = l[A + 140 >> 2], l[A + 140 >> 2] = Ct - Tt, Gt = me << 1, en = l[A + 136 >> 2], l[A + 136 >> 2] = Gt - en, it = D << 1, St = l[A + 132 >> 2], l[A + 132 >> 2] = it - St, je = he << 1, Ft = l[A + 128 >> 2], l[A + 128 >> 2] = je - Ft, fn = ie << 1, _n = l[A + 124 >> 2], l[A + 124 >> 2] = fn - _n, wn = qn << 1, $n = l[A + 120 >> 2], l[A + 120 >> 2] = wn - $n, l[A + 112 >> 2] = Le + Ge, l[A + 108 >> 2] = ct + mt, l[A + 104 >> 2] = bt + ht, l[A + 100 >> 2] = Ct + Tt, l[A + 96 >> 2] = Gt + en, l[A + 92 >> 2] = it + St, l[A + 88 >> 2] = je + Ft, l[A + 84 >> 2] = fn + _n, l[A + 80 >> 2] = wn + $n, l[A + 116 >> 2] = g + _;
                    }
                    function gs(A, g) {
                      var _, b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0;
                      $e = B[g + 31 | 0], _ = B[g + 30 | 0], b = B[g + 29 | 0], U = B[g + 6 | 0], ie = B[g + 5 | 0], he = B[g + 4 | 0], D = B[g + 9 | 0], me = B[g + 8 | 0], _e = B[g + 7 | 0], en = B[g + 12 | 0], it = B[g + 11 | 0], Be = B[g + 10 | 0], ye = B[g + 15 | 0], St = B[g + 14 | 0], we = B[g + 13 | 0], Ct = B[g + 28 | 0], Gt = B[g + 27 | 0], Tt = B[g + 26 | 0], ht = B[g + 25 | 0], mt = B[g + 24 | 0], ct = B[g + 23 | 0], Le = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, bt = (Ge = B[g + 21 | 0]) << 15, Ge = je = Ge >>> 17 | 0, fn = bt, je = (bt = B[g + 20 | 0]) >>> 25 | 0, bt = fn | bt << 7, Ft = Ge | je, Ge = (je = B[g + 22 | 0]) >>> 9 | 0, bt |= je << 23, Ge |= Ft, je = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, g = 0, fn = je, je = (33554431 & (g = (Ft = je + 16777216 | 0) >>> 0 < 16777216 ? 1 : g)) << 7 | Ft >>> 25, g = (g >>> 25 | 0) + Ge | 0, je = (Ge = bt = je + bt | 0) >>> 0 < je >>> 0 ? g + 1 | 0 : g, g = (bt = Ge + 33554432 | 0) >>> 0 < 33554432 ? je + 1 | 0 : je, l[A + 24 >> 2] = Ge - (-67108864 & bt), je = (Ge = ct >>> 27 | 0) | mt >>> 19 | ht >>> 11, Ge = ct = (mt = ht << 21 | (ct = mt << 13 | ct << 5)) + (Ge = (67108863 & (Ge = g)) << 6 | bt >>> 26) | 0, g = je, je = (ct = mt + 16777216 | 0) >>> 0 < 16777216 ? g + 1 | 0 : g, l[A + 28 >> 2] = Ge - (1040187392 & ct), Ge = (Ge = Gt >>> 20 | Tt >>> 28 | Ct >>> 12) + (je = (g = je) >>> 25 | 0) | 0, g = (je = ct = (g = (33554431 & g) << 7 | ct >>> 25) + (Gt << 12 | Tt << 4 | Ct << 20) | 0) >>> 0 < g >>> 0 ? Ge + 1 | 0 : Ge, ct = (Ct = je + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g, l[A + 32 >> 2] = je - (-67108864 & Ct), Ge = (g = en >>> 13 | 0) | (je = it >>> 21 | Be >>> 29), g = (Ge = (Gt = 16777216 + (en = it << 11 | Be << 3 | en << 19) | 0) >>> 0 < 16777216 ? Ge + 1 | 0 : Ge) >>> 25 | 0, Ge = (je = mt = St << 10 | we << 2 | ye << 18) + (mt = (33554431 & Ge) << 7 | Gt >>> 25) | 0, je = g + (ht = St >>> 22 | we >>> 30 | ye >>> 14) | 0, g = Ge >>> 0 < mt >>> 0 ? je + 1 | 0 : je, mt = g = (67108863 & (g = (je = Ge + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g)) << 6 | je >>> 26, g = g + (Tt = fn - (-33554432 & Ft) | 0) | 0, l[A + 20 >> 2] = g, l[A + 16 >> 2] = Ge - (-67108864 & je), je = ie >>> 18 | he >>> 26 | U >>> 10, Ge = (je = (Tt = 16777216 + (it = ie << 14 | he << 6 | U << 22) | 0) >>> 0 < 16777216 ? je + 1 | 0 : je) >>> 25 | 0, je = (g = mt = me << 13 | _e << 5 | D << 21) + (mt = (33554431 & je) << 7 | Tt >>> 25) | 0, g = Ge + (ht = me >>> 19 | _e >>> 27 | D >>> 11) | 0, g = je >>> 0 < mt >>> 0 ? g + 1 | 0 : g, Ge = (ht = je + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g, l[A + 8 >> 2] = je - (-67108864 & ht), Ct = (ct = (67108863 & ct) << 6 | Ct >>> 26) + (St = $e << 18 & 33292288 | _ << 10 | b << 2) | 0, g = je = _ >>> 22 | b >>> 30, je = (ct = St + 16777216 | 0) >>> 0 < 16777216 ? g + 1 | 0 : g, l[A + 36 >> 2] = Ct - (33554432 & ct), Ge = en + ((67108863 & Ge) << 6 | ht >>> 26) | 0, l[A + 12 >> 2] = Ge - (234881024 & Gt), mt = it - (2113929216 & Tt) | 0, Ge = De((33554431 & (g = je)) << 7 | ct >>> 25, je = g >>> 25 | 0, 19, 0), g = ve, Ge = Ge >>> 0 > (je = Ge + Le | 0) >>> 0 ? g + 1 | 0 : g, ct = Ge = (67108863 & (Ge = (g = je + 33554432 | 0) >>> 0 < 33554432 ? Ge + 1 | 0 : Ge)) << 6 | g >>> 26, Ge = Ge + mt | 0, l[A + 4 >> 2] = Ge, l[A >> 2] = je - (-67108864 & g);
                    }
                    function Os(A, g) {
                      var _, b, U, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0;
                      for (st = _ = st - 480 | 0; he = (D = _ + 288 | 0) + (ie << 1) | 0, we = B[g + ie | 0], j[he + 1 | 0] = we >>> 4, j[0 | he] = 15 & we, D = D + ((he = 1 | ie) << 1) | 0, he = B[g + he | 0], j[D + 1 | 0] = he >>> 4, j[0 | D] = 15 & he, (0 | (ie = ie + 2 | 0)) != 32; )
                        ;
                      for (g = 0; ie = 8 + (D = (ie = g) + B[0 | (g = (_ + 288 | 0) + me | 0)] | 0) | 0, j[0 | g] = D - (240 & ie), ie = 8 + (D = B[g + 1 | 0] + (ie << 24 >> 24 >> 4) | 0) | 0, j[g + 1 | 0] = D - (240 & ie), ie = 8 + (D = B[g + 2 | 0] + (ie << 24 >> 24 >> 4) | 0) | 0, j[g + 2 | 0] = D - (240 & ie), g = ie << 24 >> 24 >> 4, (0 | (me = me + 3 | 0)) != 63; )
                        ;
                      for (j[_ + 351 | 0] = B[_ + 351 | 0] + g, l[A + 32 >> 2] = 0, l[A + 36 >> 2] = 0, l[A + 24 >> 2] = 0, l[A + 28 >> 2] = 0, l[A + 16 >> 2] = 0, l[A + 20 >> 2] = 0, l[A + 8 >> 2] = 0, l[A + 12 >> 2] = 0, l[A >> 2] = 0, l[A + 4 >> 2] = 0, l[A + 44 >> 2] = 0, l[A + 48 >> 2] = 0, l[(we = A + 40 | 0) >> 2] = 1, l[A + 52 >> 2] = 0, l[A + 56 >> 2] = 0, l[A + 60 >> 2] = 0, l[A + 64 >> 2] = 0, l[A + 68 >> 2] = 0, l[A + 72 >> 2] = 0, l[A + 76 >> 2] = 0, l[A + 80 >> 2] = 1, Jt(A + 84 | 0, 0, 76), b = A + 120 | 0, U = A + 80 | 0, g = _ + 208 | 0, D = _ + 168 | 0, me = _ + 248 | 0, ie = 1; Zr(_e = _ + 8 | 0, ie >>> 1 | 0, j[(_ + 288 | 0) + ie | 0]), Ds(he = _ + 128 | 0, A, _e), In(A, he, me), In(we, D, g), In(U, g, me), In(b, he, D), he = ie >>> 0 < 62, ie = ie + 2 | 0, he; )
                        ;
                      for (ie = l[A + 8 >> 2], he = l[A + 12 >> 2], _e = l[A + 16 >> 2], Be = l[A + 20 >> 2], $e = l[A + 24 >> 2], Le = l[A + 28 >> 2], ye = l[A >> 2], Ge = l[A + 4 >> 2], je = l[A + 36 >> 2], l[_ + 392 >> 2] = l[A + 32 >> 2], l[_ + 396 >> 2] = je, l[_ + 384 >> 2] = $e, l[_ + 388 >> 2] = Le, l[_ + 376 >> 2] = _e, l[_ + 380 >> 2] = Be, l[_ + 368 >> 2] = ie, l[_ + 372 >> 2] = he, l[_ + 360 >> 2] = ye, l[_ + 364 >> 2] = Ge, ie = l[A + 40 >> 2], he = l[A + 44 >> 2], _e = l[A + 48 >> 2], Be = l[A + 52 >> 2], $e = l[A + 56 >> 2], Le = l[A + 60 >> 2], Ge = l[(ye = A - -64 | 0) >> 2], ye = l[ye + 4 >> 2], je = l[A + 76 >> 2], l[_ + 432 >> 2] = l[A + 72 >> 2], l[_ + 436 >> 2] = je, l[_ + 424 >> 2] = Ge, l[_ + 428 >> 2] = ye, l[_ + 416 >> 2] = $e, l[_ + 420 >> 2] = Le, l[_ + 408 >> 2] = _e, l[_ + 412 >> 2] = Be, l[_ + 400 >> 2] = ie, l[_ + 404 >> 2] = he, ie = l[A + 80 >> 2], he = l[A + 84 >> 2], _e = l[A + 88 >> 2], Be = l[A + 92 >> 2], $e = l[A + 96 >> 2], Le = l[A + 100 >> 2], ye = l[A + 104 >> 2], Ge = l[A + 108 >> 2], je = l[A + 116 >> 2], l[_ + 472 >> 2] = l[A + 112 >> 2], l[_ + 476 >> 2] = je, l[_ + 464 >> 2] = ye, l[_ + 468 >> 2] = Ge, l[_ + 456 >> 2] = $e, l[_ + 460 >> 2] = Le, l[_ + 448 >> 2] = _e, l[_ + 452 >> 2] = Be, l[_ + 440 >> 2] = ie, l[_ + 444 >> 2] = he, Se(ie = _ + 128 | 0, he = _ + 360 | 0), In(he, ie, me), In(_e = _ + 400 | 0, D, g), In(Be = _ + 440 | 0, g, me), Se(ie, he), In(he, ie, me), In(_e, D, g), In(Be, g, me), Se(ie, he), In(he, ie, me), In(_e, D, g), In(Be, g, me), Se(ie, he), In(A, ie, me), In(we, D, g), In(U, g, me), In(b, ie, D), ie = 0; Zr(_e = _ + 8 | 0, ie >>> 1 | 0, j[(_ + 288 | 0) + ie | 0]), Ds(he = _ + 128 | 0, A, _e), In(A, he, me), In(we, D, g), In(U, g, me), In(b, he, D), he = ie >>> 0 < 62, ie = ie + 2 | 0, he; )
                        ;
                      st = _ + 480 | 0;
                    }
                    function vt(A, g, _, b, U, ie, he, D) {
                      A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0;
                      var me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              s: {
                                u: {
                                  a: {
                                    d: {
                                      o: {
                                        i: {
                                          c: {
                                            if ((-7 & (D |= 0)) == 1) {
                                              if (Be = 0, !b)
                                                break d;
                                              if (4 & D)
                                                break c;
                                              for (; ; ) {
                                                Be = _e;
                                                l: {
                                                  f: {
                                                    p: {
                                                      m: {
                                                        for (; ; ) {
                                                          if (me = (me = (ye = j[_ + Be | 0]) - 65 | 0) & ((90 - ye ^ -1) & (-1 ^ me)) >>> 8 & 255 | ye + 4 & ((ye + 65488 ^ -1) & (57 - ye ^ -1)) >>> 8 & 255 | ye + 185 & ((ye + 65439 ^ -1) & (122 - ye ^ -1)) >>> 8 & 255 | (1 + (16336 ^ ye) ^ -1) >>> 8 & 63 | (1 + (16340 ^ ye) ^ -1) >>> 8 & 62, (0 | (me |= (me - 1 & 1 + (65470 ^ ye)) >>> 8 & 255)) != 255)
                                                            break m;
                                                          if (me = 0, !U)
                                                            break o;
                                                          if (!Z(U, ye))
                                                            break;
                                                          if ((Be = Be + 1 | 0) >>> 0 >= b >>> 0)
                                                            break p;
                                                        }
                                                        _e = Be;
                                                        break o;
                                                      }
                                                      if (Le = me + (Le << 6) | 0, we >>> 0 > 1)
                                                        break f;
                                                      we = we + 6 | 0;
                                                      break l;
                                                    }
                                                    _e = (A = _e + 1 | 0) >>> 0 < b >>> 0 ? b : A;
                                                    break o;
                                                  }
                                                  if (we = we - 2 | 0, g >>> 0 <= $e >>> 0)
                                                    break i;
                                                  j[A + $e | 0] = Le >>> we, $e = $e + 1 | 0;
                                                }
                                                if (me = 0, !((_e = Be + 1 | 0) >>> 0 < b >>> 0))
                                                  break;
                                              }
                                              break o;
                                            }
                                            Ai(), Xr();
                                          }
                                          c:
                                            for (; ; ) {
                                              for (Be = _e; ; ) {
                                                l: {
                                                  if (me = (me = (ye = j[_ + Be | 0]) - 65 | 0) & ((90 - ye ^ -1) & (-1 ^ me)) >>> 8 & 255 | ye + 4 & ((ye + 65488 ^ -1) & (57 - ye ^ -1)) >>> 8 & 255 | ye + 185 & ((ye + 65439 ^ -1) & (122 - ye ^ -1)) >>> 8 & 255 | (1 + (16288 ^ ye) ^ -1) >>> 8 & 63 | (1 + (16338 ^ ye) ^ -1) >>> 8 & 62, (0 | (me |= (me - 1 & 1 + (65470 ^ ye)) >>> 8 & 255)) == 255) {
                                                    if (me = 0, !U)
                                                      break o;
                                                    if (Z(U, ye))
                                                      break l;
                                                    _e = Be;
                                                    break o;
                                                  }
                                                  if (Le = me + (Le << 6) | 0, we >>> 0 < 2)
                                                    we = we + 6 | 0;
                                                  else {
                                                    if (we = we - 2 | 0, g >>> 0 <= $e >>> 0)
                                                      break i;
                                                    j[A + $e | 0] = Le >>> we, $e = $e + 1 | 0;
                                                  }
                                                  if (me = 0, (_e = Be + 1 | 0) >>> 0 < b >>> 0)
                                                    continue c;
                                                  break o;
                                                }
                                                if (!((Be = Be + 1 | 0) >>> 0 < b >>> 0))
                                                  break;
                                              }
                                              break;
                                            }
                                          _e = (A = _e + 1 | 0) >>> 0 < b >>> 0 ? b : A;
                                          break o;
                                        }
                                        _e = Be, l[9129] = 68, me = 1;
                                      }
                                      if (we >>> 0 > 4)
                                        break a;
                                      Be = _e;
                                    }
                                    if (A = Be, g = -1, me) {
                                      _e = A;
                                      break e;
                                    }
                                    if ((-1 << we ^ -1) & Le) {
                                      _e = A;
                                      break e;
                                    }
                                    if (2 & D) {
                                      D = A;
                                      break s;
                                    }
                                    if (we >>> 0 < 2) {
                                      D = A;
                                      break s;
                                    }
                                    if (_e = A >>> 0 > b >>> 0 ? A : b, Be = we >>> 1 | 0, !U)
                                      break u;
                                    for (D = A; ; ) {
                                      if ((0 | D) == (0 | _e)) {
                                        me = 68;
                                        break r;
                                      }
                                      if ((0 | (A = j[_ + D | 0])) != 61) {
                                        if (!Z(U, A)) {
                                          me = 28, _e = D;
                                          break r;
                                        }
                                      } else
                                        Be = Be - 1 | 0;
                                      if (D = D + 1 | 0, !Be)
                                        break;
                                    }
                                    break s;
                                  }
                                  g = -1;
                                  break e;
                                }
                                if (me = 68, A >>> 0 >= b >>> 0)
                                  break r;
                                if (B[A + _ | 0] != 61) {
                                  _e = A, me = 28;
                                  break r;
                                }
                                if (D = A + Be | 0, (0 | Be) != 1) {
                                  if ((0 | (we = A + 1 | 0)) == (0 | _e))
                                    break r;
                                  if (B[_ + we | 0] != 61) {
                                    _e = we, me = 28;
                                    break r;
                                  }
                                  if ((0 | Be) != 2 && ((0 | (A = A + 2 | 0)) == (0 | _e) || (me = 28, _e = A, B[A + _ | 0] != 61)))
                                    break r;
                                }
                              }
                              if (g = 0, U)
                                break n;
                              break t;
                            }
                            l[9129] = me;
                            break e;
                          }
                          if (!(b >>> 0 <= D >>> 0)) {
                            for (; ; ) {
                              if (!Z(U, j[_ + D | 0]))
                                break t;
                              if ((0 | (D = D + 1 | 0)) == (0 | b))
                                break;
                            }
                            D = b;
                          }
                        }
                        _e = D, Ge = $e;
                      }
                      return he ? l[he >> 2] = _ + _e : (0 | b) != (0 | _e) && (l[9129] = 28, g = -1), ie && (l[ie >> 2] = Ge), 0 | g;
                    }
                    function bs(A, g, _, b) {
                      A |= 0, g |= 0, _ |= 0;
                      var U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0;
                      for ((b |= 0) ? (U = B[b + 12 | 0] | B[b + 13 | 0] << 8 | B[b + 14 | 0] << 16 | B[b + 15 | 0] << 24, me = B[b + 8 | 0] | B[b + 9 | 0] << 8 | B[b + 10 | 0] << 16 | B[b + 11 | 0] << 24, _e = B[b + 4 | 0] | B[b + 5 | 0] << 8 | B[b + 6 | 0] << 16 | B[b + 7 | 0] << 24, b = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24) : (U = 1797285236, me = 2036477234, _e = 857760878, b = 1634760805), ie = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, D = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, he = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, ct = B[_ + 28 | 0] | B[_ + 29 | 0] << 8 | B[_ + 30 | 0] << 16 | B[_ + 31 | 0] << 24, je = B[_ + 24 | 0] | B[_ + 25 | 0] << 8 | B[_ + 26 | 0] << 16 | B[_ + 27 | 0] << 24, mt = 20, Le = B[_ + 20 | 0] | B[_ + 21 | 0] << 8 | B[_ + 22 | 0] << 16 | B[_ + 23 | 0] << 24, Ge = B[_ + 16 | 0] | B[_ + 17 | 0] << 8 | B[_ + 18 | 0] << 16 | B[_ + 19 | 0] << 24, ye = B[_ + 12 | 0] | B[_ + 13 | 0] << 8 | B[_ + 14 | 0] << 16 | B[_ + 15 | 0] << 24, we = B[_ + 8 | 0] | B[_ + 9 | 0] << 8 | B[_ + 10 | 0] << 16 | B[_ + 11 | 0] << 24, $e = B[_ + 4 | 0] | B[_ + 5 | 0] << 8 | B[_ + 6 | 0] << 16 | B[_ + 7 | 0] << 24, g = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, _ = B[0 | _] | B[_ + 1 | 0] << 8 | B[_ + 2 | 0] << 16 | B[_ + 3 | 0] << 24; Be = tn(_ + _e | 0, 7) ^ ie, bt = tn(Be + _e | 0, 9) ^ je, ye = tn(b + Le | 0, 7) ^ ye, ht = tn(ye + b | 0, 9) ^ D, Ct = tn(ht + ye | 0, 13) ^ Le, we = tn(U + Ge | 0, 7) ^ we, he = tn(we + U | 0, 9) ^ he, D = tn(he + we | 0, 13) ^ Ge, U = tn(he + D | 0, 18) ^ U, ie = tn(g + me | 0, 7) ^ ct, Le = Ct ^ tn(U + ie | 0, 7), je = bt ^ tn(Le + U | 0, 9), ct = tn(Le + je | 0, 13) ^ ie, U = tn(je + ct | 0, 18) ^ U, $e = tn(ie + me | 0, 9) ^ $e, Tt = tn($e + ie | 0, 13) ^ g, g = tn(Tt + $e | 0, 18) ^ me, Ge = tn(g + Be | 0, 7) ^ D, D = tn(Ge + g | 0, 9) ^ ht, ie = tn(D + Ge | 0, 13) ^ Be, me = tn(ie + D | 0, 18) ^ g, Be = tn(Be + bt | 0, 13) ^ _, _ = tn(Be + bt | 0, 18) ^ _e, g = tn(_ + ye | 0, 7) ^ Tt, he = tn(g + _ | 0, 9) ^ he, ye = tn(g + he | 0, 13) ^ ye, _e = tn(he + ye | 0, 18) ^ _, b = tn(ht + Ct | 0, 18) ^ b, _ = tn(b + we | 0, 7) ^ Be, $e = tn(_ + b | 0, 9) ^ $e, we = tn(_ + $e | 0, 13) ^ we, b = tn($e + we | 0, 18) ^ b, Be = mt >>> 0 > 2, mt = mt - 2 | 0, Be; )
                        ;
                      return j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 28 | 0] = ie, j[A + 29 | 0] = ie >>> 8, j[A + 30 | 0] = ie >>> 16, j[A + 31 | 0] = ie >>> 24, j[A + 24 | 0] = D, j[A + 25 | 0] = D >>> 8, j[A + 26 | 0] = D >>> 16, j[A + 27 | 0] = D >>> 24, j[A + 20 | 0] = he, j[A + 21 | 0] = he >>> 8, j[A + 22 | 0] = he >>> 16, j[A + 23 | 0] = he >>> 24, j[A + 16 | 0] = g, j[A + 17 | 0] = g >>> 8, j[A + 18 | 0] = g >>> 16, j[A + 19 | 0] = g >>> 24, j[A + 12 | 0] = U, j[A + 13 | 0] = U >>> 8, j[A + 14 | 0] = U >>> 16, j[A + 15 | 0] = U >>> 24, j[A + 8 | 0] = me, j[A + 9 | 0] = me >>> 8, j[A + 10 | 0] = me >>> 16, j[A + 11 | 0] = me >>> 24, j[A + 4 | 0] = _e, j[A + 5 | 0] = _e >>> 8, j[A + 6 | 0] = _e >>> 16, j[A + 7 | 0] = _e >>> 24, 0;
                    }
                    function Di(A, g, _, b) {
                      var U, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0;
                      if (st = U = st - 704 | 0, _ | b)
                        if (ie = (b << 3 | _ >>> 29) + (he = D = l[A + 76 >> 2]) | 0, _e = (Be = l[A + 72 >> 2]) + (me = _ << 3) | 0, l[A + 72 >> 2] = _e, ie = me >>> 0 > _e >>> 0 ? ie + 1 | 0 : ie, l[A + 76 >> 2] = ie, D = l[4 + (me = A - -64 | 0) >> 2], D = (ye = ie = (0 | ie) == (0 | he) & _e >>> 0 < Be >>> 0 | ie >>> 0 < he >>> 0) >>> 0 > (ie = ie + l[me >> 2] | 0) >>> 0 ? D + 1 | 0 : D, _e = (ye = b >>> 29 | 0) + ie | 0, ie = D, l[me >> 2] = _e, l[me + 4 >> 2] = _e >>> 0 < ye >>> 0 ? ie + 1 | 0 : ie, (0 | (D = ye = 0 - ((ie = 0) + ((me = 127 & ((7 & he) << 29 | Be >>> 3)) >>> 0 > 128) | 0) | 0)) == (0 | b) & _ >>> 0 >= (_e = 128 - me | 0) >>> 0 | b >>> 0 > D >>> 0) {
                          if (he = 0, D = 0, !ie & (127 ^ me) >>> 0 >= 3 | ie)
                            for (je = 252 & _e, Be = A + 80 | 0; j[(ie = he + me | 0) + Be | 0] = B[g + he | 0], j[Be + (me + (ie = 1 | he) | 0) | 0] = B[g + ie | 0], j[Be + (me + (ie = 2 | he) | 0) | 0] = B[g + ie | 0], j[Be + (me + (ie = 3 | he) | 0) | 0] = B[g + ie | 0], ie = D, D = (he = he + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, ie = $e, $e = ie = (Le = Le + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, (0 | Le) != (0 | je) | (0 | Ge) != (0 | ie); )
                              ;
                          if (Be = ie = 0, ie | ($e = 3 & _e))
                            for (; j[80 + (A + (ie = he + me | 0) | 0) | 0] = B[g + he | 0], ie = D, D = (he = he + 1 | 0) ? ie : ie + 1 | 0, ie = Ge, Ge = ie = (we = we + 1 | 0) ? ie : ie + 1 | 0, (0 | $e) != (0 | we) | (0 | Be) != (0 | ie); )
                              ;
                          if (rr(A, A + 80 | 0, U, he = U + 640 | 0), g = g + _e | 0, !(b = b - ((_ >>> 0 < _e >>> 0) + ye | 0) | 0) & (_ = _ - _e | 0) >>> 0 > 127 | b)
                            for (; rr(A, g, U, he), g = g + 128 | 0, !(b = b - (_ >>> 0 < 128) | 0) & (_ = _ - 128 | 0) >>> 0 > 127 | b; )
                              ;
                          if (_ | b) {
                            if (Le = 3 & _, _e = 0, we = 0, Ge = 0, he = 0, D = 0, !b & _ >>> 0 >= 4 | b)
                              for (me = -4 & _, Be = b, $e = A + 80 | 0, _ = 0, b = 0; j[he + $e | 0] = B[g + he | 0], j[(ie = 1 | he) + $e | 0] = B[g + ie | 0], j[(ie = 2 | he) + $e | 0] = B[g + ie | 0], j[(ie = 3 | he) + $e | 0] = B[g + ie | 0], ie = D, D = (he = he + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, ie = b, b = ie = (_ = _ + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, (0 | _) != (0 | me) | (0 | Be) != (0 | ie); )
                                ;
                            if (_e | Le)
                              for (; j[80 + (A + he | 0) | 0] = B[g + he | 0], D = (he = he + 1 | 0) ? D : D + 1 | 0, ie = Ge, Ge = ie = (we = we + 1 | 0) ? ie : ie + 1 | 0, (0 | we) != (0 | Le) | (0 | _e) != (0 | ie); )
                                ;
                          }
                          Wr(U, 704);
                        } else {
                          if (he = 0, D = 0, !b & _ >>> 0 >= 4 | b)
                            for (_e = -4 & _, Be = b, b = A + 80 | 0; j[b + (ie = he + me | 0) | 0] = B[g + he | 0], j[b + (ye = me + (ie = 1 | he) | 0) | 0] = B[g + ie | 0], j[b + (ye = me + (ie = 2 | he) | 0) | 0] = B[g + ie | 0], j[b + (ye = me + (ie = 3 | he) | 0) | 0] = B[g + ie | 0], ie = D, D = (he = he + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, ie = $e, $e = ie = (Le = Le + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, (0 | _e) != (0 | Le) | (0 | Be) != (0 | ie); )
                              ;
                          if ((_ &= 3) | (b = 0))
                            for (; j[80 + (A + (ie = he + me | 0) | 0) | 0] = B[g + he | 0], D = (he = he + 1 | 0) ? D : D + 1 | 0, ie = Ge, Ge = ie = (we = we + 1 | 0) ? ie : ie + 1 | 0, (0 | _) != (0 | we) | (0 | b) != (0 | ie); )
                              ;
                        }
                      return st = U + 704 | 0, 0;
                    }
                    function Pa(A, g) {
                      A |= 0;
                      var _, b, U, ie, he, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0;
                      for (st = _ = st - 736 | 0, gr(ye = _ + 704 | 0, g |= 0, g), gr(me = _ + 224 | 0, g, ye), gr(Be = _ + 672 | 0, g, me), gr(_e = _ + 640 | 0, Be, Be), gr(b = _ + 416 | 0, ye, _e), gr(ye = _ + 320 | 0, g, b), gr(D = _ + 608 | 0, _e, _e), gr(_e = _ + 288 | 0, ye, ye), gr(we = _ + 576 | 0, b, _e), gr(he = _ + 448 | 0, D, _e), gr(U = _ + 544 | 0, we, we), gr(we = _ + 384 | 0, D, U), gr(ie = _ + 352 | 0, me, we), gr(me = _ + 192 | 0, D, ie), gr(D = _ + 160 | 0, Be, me), gr(_ + 96 | 0, Be, D), gr(me = _ + 512 | 0, U, ie), gr(D = _ + 480 | 0, Be, me), gr(me = _ + 256 | 0, he, D), gr(_ + 128 | 0, _e, me), gr(_e = _ - -64 | 0, we, D), gr(D = _ + 32 | 0, Be, _e), gr(_, b, D), gr(A, ye, _), Be = 0; gr(A, A, A), (0 | (Be = Be + 1 | 0)) != 126; )
                        ;
                      return gr(A, A, _ + 352 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 704 | 0), gr(A, A, _), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 160 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 256 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ - -64 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 96 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 320 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 512 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 192 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 480 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 128 | 0), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, A), gr(A, A, _ + 32 | 0), st = _ + 736 | 0, 0 - le(g, 32) | 0;
                    }
                    function Ea(A, g, _) {
                      A |= 0;
                      var b, U, ie, he, D = 0, me = 0, _e = 0, Be = 0, ye = 0;
                      return st = ie = st - 160 | 0, L(g |= 0, _ |= 0, 32, 0), j[0 | g] = 248 & B[0 | g], j[g + 31 | 0] = 63 & B[g + 31 | 0] | 64, Os(ie, g), kr(A, ie), me = B[(U = _) + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24, D = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, _e = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, Be = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, ye = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, _ = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, he = B[U + 28 | 0] | B[U + 29 | 0] << 8 | B[U + 30 | 0] << 16 | B[U + 31 | 0] << 24, b = g, g = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, j[b + 24 | 0] = g, j[b + 25 | 0] = g >>> 8, j[b + 26 | 0] = g >>> 16, j[b + 27 | 0] = g >>> 24, j[b + 28 | 0] = he, j[b + 29 | 0] = he >>> 8, j[b + 30 | 0] = he >>> 16, j[b + 31 | 0] = he >>> 24, j[b + 16 | 0] = _e, j[b + 17 | 0] = _e >>> 8, j[b + 18 | 0] = _e >>> 16, j[b + 19 | 0] = _e >>> 24, j[b + 20 | 0] = Be, j[b + 21 | 0] = Be >>> 8, j[b + 22 | 0] = Be >>> 16, j[b + 23 | 0] = Be >>> 24, j[b + 8 | 0] = me, j[b + 9 | 0] = me >>> 8, j[b + 10 | 0] = me >>> 16, j[b + 11 | 0] = me >>> 24, j[b + 12 | 0] = D, j[b + 13 | 0] = D >>> 8, j[b + 14 | 0] = D >>> 16, j[b + 15 | 0] = D >>> 24, j[0 | b] = ye, j[b + 1 | 0] = ye >>> 8, j[b + 2 | 0] = ye >>> 16, j[b + 3 | 0] = ye >>> 24, j[b + 4 | 0] = _, j[b + 5 | 0] = _ >>> 8, j[b + 6 | 0] = _ >>> 16, j[b + 7 | 0] = _ >>> 24, _e = B[(D = A) + 8 | 0] | B[D + 9 | 0] << 8 | B[D + 10 | 0] << 16 | B[D + 11 | 0] << 24, Be = B[D + 12 | 0] | B[D + 13 | 0] << 8 | B[D + 14 | 0] << 16 | B[D + 15 | 0] << 24, ye = B[D + 16 | 0] | B[D + 17 | 0] << 8 | B[D + 18 | 0] << 16 | B[D + 19 | 0] << 24, _ = B[D + 20 | 0] | B[D + 21 | 0] << 8 | B[D + 22 | 0] << 16 | B[D + 23 | 0] << 24, g = B[0 | D] | B[D + 1 | 0] << 8 | B[D + 2 | 0] << 16 | B[D + 3 | 0] << 24, A = B[D + 4 | 0] | B[D + 5 | 0] << 8 | B[D + 6 | 0] << 16 | B[D + 7 | 0] << 24, me = B[D + 28 | 0] | B[D + 29 | 0] << 8 | B[D + 30 | 0] << 16 | B[D + 31 | 0] << 24, D = B[D + 24 | 0] | B[D + 25 | 0] << 8 | B[D + 26 | 0] << 16 | B[D + 27 | 0] << 24, j[b + 56 | 0] = D, j[b + 57 | 0] = D >>> 8, j[b + 58 | 0] = D >>> 16, j[b + 59 | 0] = D >>> 24, j[b + 60 | 0] = me, j[b + 61 | 0] = me >>> 8, j[b + 62 | 0] = me >>> 16, j[b + 63 | 0] = me >>> 24, j[b + 48 | 0] = ye, j[b + 49 | 0] = ye >>> 8, j[b + 50 | 0] = ye >>> 16, j[b + 51 | 0] = ye >>> 24, j[b + 52 | 0] = _, j[b + 53 | 0] = _ >>> 8, j[b + 54 | 0] = _ >>> 16, j[b + 55 | 0] = _ >>> 24, j[b + 40 | 0] = _e, j[b + 41 | 0] = _e >>> 8, j[b + 42 | 0] = _e >>> 16, j[b + 43 | 0] = _e >>> 24, j[b + 44 | 0] = Be, j[b + 45 | 0] = Be >>> 8, j[b + 46 | 0] = Be >>> 16, j[b + 47 | 0] = Be >>> 24, j[b + 32 | 0] = g, j[b + 33 | 0] = g >>> 8, j[b + 34 | 0] = g >>> 16, j[b + 35 | 0] = g >>> 24, j[b + 36 | 0] = A, j[b + 37 | 0] = A >>> 8, j[b + 38 | 0] = A >>> 16, j[b + 39 | 0] = A >>> 24, st = ie + 160 | 0, 0;
                    }
                    function Cs(A, g, _) {
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0;
                      Ge = l[g + 4 >> 2], U = l[A + 4 >> 2], je = l[g + 8 >> 2], ie = l[A + 8 >> 2], ct = l[g + 12 >> 2], he = l[A + 12 >> 2], mt = l[g + 16 >> 2], D = l[A + 16 >> 2], bt = l[g + 20 >> 2], me = l[A + 20 >> 2], ht = l[g + 24 >> 2], _e = l[A + 24 >> 2], Le = l[g + 28 >> 2], Be = l[A + 28 >> 2], Ct = l[g + 32 >> 2], ye = l[A + 32 >> 2], Tt = l[g + 36 >> 2], we = l[A + 36 >> 2], _ = 0 - _ | 0, $e = l[A >> 2], l[A >> 2] = _ & ($e ^ l[g >> 2]) ^ $e, l[A + 36 >> 2] = we ^ _ & (we ^ Tt), l[A + 32 >> 2] = ye ^ _ & (ye ^ Ct), l[A + 28 >> 2] = Be ^ _ & (Be ^ Le), l[A + 24 >> 2] = _e ^ _ & (_e ^ ht), l[A + 20 >> 2] = me ^ _ & (me ^ bt), l[A + 16 >> 2] = D ^ _ & (D ^ mt), l[A + 12 >> 2] = he ^ _ & (he ^ ct), l[A + 8 >> 2] = ie ^ _ & (ie ^ je), l[A + 4 >> 2] = U ^ _ & (U ^ Ge), U = l[A + 40 >> 2], Ge = l[g + 40 >> 2], ie = l[A + 44 >> 2], je = l[g + 44 >> 2], he = l[A + 48 >> 2], ct = l[g + 48 >> 2], D = l[A + 52 >> 2], mt = l[g + 52 >> 2], me = l[A + 56 >> 2], bt = l[g + 56 >> 2], _e = l[A + 60 >> 2], ht = l[g + 60 >> 2], Be = l[(Le = A - -64 | 0) >> 2], Ct = l[g - -64 >> 2], ye = l[A + 68 >> 2], Tt = l[g + 68 >> 2], we = l[A + 72 >> 2], $e = l[g + 72 >> 2], b = l[A + 76 >> 2], l[A + 76 >> 2] = b ^ _ & (l[g + 76 >> 2] ^ b), l[A + 72 >> 2] = we ^ _ & (we ^ $e), l[A + 68 >> 2] = ye ^ _ & (ye ^ Tt), l[Le >> 2] = Be ^ _ & (Be ^ Ct), l[A + 60 >> 2] = _e ^ _ & (_e ^ ht), l[A + 56 >> 2] = me ^ _ & (me ^ bt), l[A + 52 >> 2] = D ^ _ & (D ^ mt), l[A + 48 >> 2] = he ^ _ & (he ^ ct), l[A + 44 >> 2] = ie ^ _ & (ie ^ je), l[A + 40 >> 2] = U ^ _ & (U ^ Ge), U = l[A + 80 >> 2], Ge = l[g + 80 >> 2], ie = l[A + 84 >> 2], je = l[g + 84 >> 2], he = l[A + 88 >> 2], ct = l[g + 88 >> 2], D = l[A + 92 >> 2], mt = l[g + 92 >> 2], me = l[A + 96 >> 2], bt = l[g + 96 >> 2], _e = l[A + 100 >> 2], ht = l[g + 100 >> 2], Be = l[A + 104 >> 2], Le = l[g + 104 >> 2], ye = l[A + 108 >> 2], Ct = l[g + 108 >> 2], we = l[A + 112 >> 2], Tt = l[g + 112 >> 2], $e = l[A + 116 >> 2], l[A + 116 >> 2] = _ & ($e ^ l[g + 116 >> 2]) ^ $e, l[A + 112 >> 2] = we ^ _ & (we ^ Tt), l[A + 108 >> 2] = ye ^ _ & (ye ^ Ct), l[A + 104 >> 2] = Be ^ _ & (Be ^ Le), l[A + 100 >> 2] = _e ^ _ & (_e ^ ht), l[A + 96 >> 2] = me ^ _ & (me ^ bt), l[A + 92 >> 2] = D ^ _ & (D ^ mt), l[A + 88 >> 2] = he ^ _ & (he ^ ct), l[A + 84 >> 2] = ie ^ _ & (ie ^ je), l[A + 80 >> 2] = U ^ _ & (U ^ Ge), U = l[A + 120 >> 2], Ge = l[g + 120 >> 2], ie = l[A + 124 >> 2], je = l[g + 124 >> 2], he = l[A + 128 >> 2], ct = l[g + 128 >> 2], D = l[A + 132 >> 2], mt = l[g + 132 >> 2], me = l[A + 136 >> 2], bt = l[g + 136 >> 2], _e = l[A + 140 >> 2], ht = l[g + 140 >> 2], Be = l[A + 144 >> 2], Le = l[g + 144 >> 2], ye = l[A + 148 >> 2], Ct = l[g + 148 >> 2], we = l[A + 152 >> 2], Tt = l[g + 152 >> 2], $e = l[g + 156 >> 2], g = l[A + 156 >> 2], l[A + 156 >> 2] = _ & ($e ^ g) ^ g, l[A + 152 >> 2] = we ^ _ & (we ^ Tt), l[A + 148 >> 2] = ye ^ _ & (ye ^ Ct), l[A + 144 >> 2] = Be ^ _ & (Be ^ Le), l[A + 140 >> 2] = _e ^ _ & (_e ^ ht), l[A + 136 >> 2] = me ^ _ & (me ^ bt), l[A + 132 >> 2] = D ^ _ & (D ^ mt), l[A + 128 >> 2] = he ^ _ & (he ^ ct), l[A + 124 >> 2] = ie ^ _ & (ie ^ je), l[A + 120 >> 2] = U ^ _ & (U ^ Ge);
                    }
                    function ya(A, g, _) {
                      var b, U, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0;
                      return st = b = st - 320 | 0, Ot(ie = b + 240 | 0, _), In(ie, ie, _), Ot(A, ie), In(A, A, _), In(A, A, g), Jn(A, A), In(A, A, ie), In(A, A, g), Ot(ie = b + 192 | 0, A), In(ie, ie, _), he = l[g + 4 >> 2], Le = l[g + 8 >> 2], je = l[g + 12 >> 2], ct = l[g + 16 >> 2], mt = l[g + 20 >> 2], bt = l[g + 24 >> 2], ht = l[g + 28 >> 2], Ct = l[g + 32 >> 2], Tt = l[g >> 2], _ = l[b + 192 >> 2], ie = l[b + 196 >> 2], D = l[b + 200 >> 2], me = l[b + 204 >> 2], _e = l[b + 208 >> 2], Be = l[b + 212 >> 2], ye = l[b + 216 >> 2], we = l[b + 220 >> 2], $e = l[b + 224 >> 2], Ge = l[b + 228 >> 2], Gt = l[g + 36 >> 2], l[b + 180 >> 2] = Ge - Gt, l[b + 176 >> 2] = $e - Ct, l[b + 172 >> 2] = we - ht, l[b + 168 >> 2] = ye - bt, l[b + 164 >> 2] = Be - mt, l[b + 160 >> 2] = _e - ct, l[b + 156 >> 2] = me - je, l[b + 152 >> 2] = D - Le, l[b + 148 >> 2] = ie - he, l[b + 144 >> 2] = _ - Tt, l[b + 132 >> 2] = Ge + Gt, l[b + 128 >> 2] = $e + Ct, l[b + 124 >> 2] = we + ht, l[b + 120 >> 2] = ye + bt, l[b + 116 >> 2] = Be + mt, l[b + 112 >> 2] = _e + ct, l[b + 108 >> 2] = me + je, l[b + 104 >> 2] = D + Le, l[b + 100 >> 2] = ie + he, l[b + 96 >> 2] = _ + Tt, In(he = b + 48 | 0, g, 1648), l[b + 84 >> 2] = Ge + l[b + 84 >> 2], l[b + 80 >> 2] = $e + l[b + 80 >> 2], l[b + 76 >> 2] = we + l[b + 76 >> 2], l[b + 72 >> 2] = ye + l[b + 72 >> 2], l[b + 68 >> 2] = Be + l[b + 68 >> 2], l[b + 64 >> 2] = _e + l[b + 64 >> 2], l[b + 60 >> 2] = me + l[b + 60 >> 2], l[b + 56 >> 2] = D + l[b + 56 >> 2], l[b + 52 >> 2] = ie + l[b + 52 >> 2], l[b + 48 >> 2] = _ + l[b + 48 >> 2], Ei(b, b + 144 | 0), je = le(b, 32), Ei(b, b + 96 | 0), Le = le(b, 32), Ei(b, he), g = le(b, 32), In(b, A, 1648), $e = l[A + 4 >> 2], we = l[A + 8 >> 2], ye = l[A + 12 >> 2], Be = l[A + 16 >> 2], _e = l[A + 20 >> 2], me = l[A + 24 >> 2], D = l[A + 28 >> 2], ie = l[A + 32 >> 2], he = l[A >> 2], ct = l[b >> 2], mt = l[b + 4 >> 2], bt = l[b + 8 >> 2], ht = l[b + 12 >> 2], Ct = l[b + 16 >> 2], Tt = l[b + 20 >> 2], Ge = l[b + 24 >> 2], Gt = l[b + 28 >> 2], U = l[b + 32 >> 2], _ = (g = 0 - (g | Le) | 0) & ((_ = l[A + 36 >> 2]) ^ l[b + 36 >> 2]) ^ _, l[A + 36 >> 2] = _, ie ^= g & (ie ^ U), l[A + 32 >> 2] = ie, D ^= g & (D ^ Gt), l[A + 28 >> 2] = D, me ^= g & (me ^ Ge), l[A + 24 >> 2] = me, _e ^= g & (_e ^ Tt), l[A + 20 >> 2] = _e, Be ^= g & (Be ^ Ct), l[A + 16 >> 2] = Be, ye ^= g & (ye ^ ht), l[A + 12 >> 2] = ye, we ^= g & (we ^ bt), l[A + 8 >> 2] = we, $e ^= g & ($e ^ mt), l[A + 4 >> 2] = $e, he ^= g & (he ^ ct), l[A >> 2] = he, Ei(b + 288 | 0, A), g = 0 - (1 & j[b + 288 | 0]) | 0, l[A + 36 >> 2] = _ ^ g & (_ ^ 0 - _), l[A + 32 >> 2] = ie ^ g & (ie ^ 0 - ie), l[A + 28 >> 2] = D ^ g & (D ^ 0 - D), l[A + 24 >> 2] = me ^ g & (me ^ 0 - me), l[A + 20 >> 2] = _e ^ g & (_e ^ 0 - _e), l[A + 16 >> 2] = Be ^ g & (Be ^ 0 - Be), l[A + 12 >> 2] = ye ^ g & (ye ^ 0 - ye), l[A + 8 >> 2] = we ^ g & (we ^ 0 - we), l[A + 4 >> 2] = $e ^ g & ($e ^ 0 - $e), l[A >> 2] = he ^ g & (he ^ 0 - he), st = b + 320 | 0, Le | je;
                    }
                    function dt(A, g, _, b) {
                      var U, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0;
                      if (st = U = st - 288 | 0, _ | b)
                        if (ie = (he = l[A + 36 >> 2]) + (b << 3 | _ >>> 29) | 0, me = (D = l[A + 32 >> 2]) + (_e = _ << 3) | 0, l[A + 32 >> 2] = me, l[A + 36 >> 2] = me >>> 0 < _e >>> 0 ? ie + 1 | 0 : ie, D = 64 - (ie = ye = 63 & ((7 & he) << 29 | D >>> 3)) | 0, (0 | (ie = je = 0 - ((_e = 0) + (ie >>> 0 > 64) | 0) | 0)) == (0 | b) & _ >>> 0 >= (me = D) >>> 0 | b >>> 0 > ie >>> 0) {
                          if (he = 0, D = 0, !_e & (63 ^ ye) >>> 0 >= 3 | _e)
                            for (ct = 124 & me, _e = A + 40 | 0; j[(ie = he + ye | 0) + _e | 0] = B[g + he | 0], j[(ie = ye + (Be = 1 | he) | 0) + _e | 0] = B[g + Be | 0], j[(ie = ye + (Be = 2 | he) | 0) + _e | 0] = B[g + Be | 0], j[(ie = ye + (Be = 3 | he) | 0) + _e | 0] = B[g + Be | 0], ie = D, D = (he = he + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, ie = $e, $e = ie = (Le = Le + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, (0 | Le) != (0 | ct) | (0 | Ge) != (0 | ie); )
                              ;
                          if (_e = ie = 0, ie | ($e = 3 & me))
                            for (; j[40 + (A + (ie = he + ye | 0) | 0) | 0] = B[g + he | 0], ie = D, D = (he = he + 1 | 0) ? ie : ie + 1 | 0, ie = Ge, Ge = ie = (we = we + 1 | 0) ? ie : ie + 1 | 0, (0 | $e) != (0 | we) | (0 | _e) != (0 | ie); )
                              ;
                          if (Ys(A, A + 40 | 0, U, Ge = U + 256 | 0), g = g + me | 0, !(b = b - ((_ >>> 0 < me >>> 0) + je | 0) | 0) & (_ = _ - me | 0) >>> 0 > 63 | b)
                            for (; Ys(A, g, U, Ge), g = g - -64 | 0, ie = b - 1 | 0, !(b = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? ie + 1 | 0 : ie) & _ >>> 0 > 63 | b; )
                              ;
                          if (_ | b) {
                            if (me = 3 & _, Le = 0, we = 0, Ge = 0, he = 0, D = 0, !b & _ >>> 0 >= 4 | b)
                              for (_e = -4 & _, $e = b, Be = A + 40 | 0, _ = 0, b = 0; j[he + Be | 0] = B[g + he | 0], j[(ie = 1 | he) + Be | 0] = B[g + ie | 0], j[(ie = 2 | he) + Be | 0] = B[g + ie | 0], j[(ie = 3 | he) + Be | 0] = B[g + ie | 0], ie = D, D = (he = he + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, ie = b, b = ie = (_ = _ + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, (0 | _) != (0 | _e) | (0 | $e) != (0 | ie); )
                                ;
                            if (me | Le)
                              for (; j[40 + (A + he | 0) | 0] = B[g + he | 0], D = (he = he + 1 | 0) ? D : D + 1 | 0, ie = Ge, Ge = ie = (we = we + 1 | 0) ? ie : ie + 1 | 0, (0 | me) != (0 | we) | (0 | Le) != (0 | ie); )
                                ;
                          }
                          Wr(U, 288);
                        } else {
                          if (he = 0, D = 0, !b & _ >>> 0 >= 4 | b)
                            for (Be = -4 & _, _e = b, b = A + 40 | 0; j[b + (ie = he + ye | 0) | 0] = B[g + he | 0], j[b + (ie = ye + (me = 1 | he) | 0) | 0] = B[g + me | 0], j[b + (ie = ye + (me = 2 | he) | 0) | 0] = B[g + me | 0], j[b + (ie = ye + (me = 3 | he) | 0) | 0] = B[g + me | 0], ie = D, D = (he = he + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, ie = $e, $e = ie = (Le = Le + 4 | 0) >>> 0 < 4 ? ie + 1 | 0 : ie, (0 | Be) != (0 | Le) | (0 | _e) != (0 | ie); )
                              ;
                          if ($e = ie = 0, ie | (b = 3 & _))
                            for (; j[40 + (A + (_ = he + ye | 0) | 0) | 0] = B[g + he | 0], D = (he = he + 1 | 0) ? D : D + 1 | 0, ie = Ge, Ge = ie = (we = we + 1 | 0) ? ie : ie + 1 | 0, (0 | b) != (0 | we) | (0 | $e) != (0 | ie); )
                              ;
                        }
                      return st = U + 288 | 0, 0;
                    }
                    function ds(A, g) {
                      var _, b, U, ie, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0;
                      return st = _ = st - 320 | 0, gs(b = A + 40 | 0, g), l[A + 84 >> 2] = 0, l[A + 88 >> 2] = 0, l[A + 80 >> 2] = 1, l[A + 92 >> 2] = 0, l[A + 96 >> 2] = 0, l[A + 100 >> 2] = 0, l[A + 104 >> 2] = 0, l[A + 108 >> 2] = 0, l[A + 112 >> 2] = 0, l[A + 116 >> 2] = 0, Ot(he = _ + 240 | 0, b), In(D = _ + 192 | 0, he, 1600), l[_ + 192 >> 2] = l[_ + 192 >> 2] + 1, me = l[_ + 240 >> 2] - 1 | 0, l[_ + 240 >> 2] = me, _e = l[_ + 244 >> 2], Be = l[_ + 248 >> 2], ye = l[_ + 252 >> 2], we = l[_ + 256 >> 2], $e = l[_ + 260 >> 2], Le = l[_ + 264 >> 2], Ge = l[_ + 268 >> 2], je = l[_ + 272 >> 2], ct = l[_ + 276 >> 2], In(A, he, D), Jn(A, A), In(A, he, A), Ot(he = _ + 144 | 0, A), In(he, he, D), he = l[_ + 180 >> 2], l[_ + 132 >> 2] = he - ct, D = l[_ + 176 >> 2], l[_ + 128 >> 2] = D - je, mt = l[_ + 172 >> 2], l[_ + 124 >> 2] = mt - Ge, bt = l[_ + 168 >> 2], l[_ + 120 >> 2] = bt - Le, ht = l[_ + 164 >> 2], l[_ + 116 >> 2] = ht - $e, Ct = l[_ + 160 >> 2], l[_ + 112 >> 2] = Ct - we, Tt = l[_ + 156 >> 2], l[_ + 108 >> 2] = Tt - ye, Gt = l[_ + 152 >> 2], l[_ + 104 >> 2] = Gt - Be, en = l[_ + 148 >> 2], l[_ + 100 >> 2] = en - _e, it = l[_ + 144 >> 2], l[_ + 96 >> 2] = it - me, l[_ + 84 >> 2] = he + ct, l[_ + 80 >> 2] = D + je, l[_ + 76 >> 2] = Ge + mt, l[_ + 72 >> 2] = Le + bt, l[_ + 68 >> 2] = $e + ht, l[_ + 64 >> 2] = we + Ct, l[_ + 60 >> 2] = ye + Tt, l[_ + 56 >> 2] = Be + Gt, l[_ + 52 >> 2] = _e + en, l[_ + 48 >> 2] = me + it, Ei(_, _ + 96 | 0), je = le(_, 32), Ei(_, _ + 48 | 0), mt = le(_, 32), In(_, A, 1648), Ge = l[A + 4 >> 2], Le = l[A + 8 >> 2], $e = l[A + 12 >> 2], we = l[A + 16 >> 2], ye = l[A + 20 >> 2], Be = l[A + 24 >> 2], _e = l[A + 28 >> 2], me = l[A + 32 >> 2], ct = l[A >> 2], bt = l[_ >> 2], ht = l[_ + 4 >> 2], Ct = l[_ + 8 >> 2], Tt = l[_ + 12 >> 2], Gt = l[_ + 16 >> 2], en = l[_ + 20 >> 2], it = l[_ + 24 >> 2], U = l[_ + 28 >> 2], ie = l[_ + 32 >> 2], D = (he = je - 1 | 0) & ((D = l[A + 36 >> 2]) ^ l[_ + 36 >> 2]) ^ D, l[A + 36 >> 2] = D, me ^= he & (me ^ ie), l[A + 32 >> 2] = me, _e ^= he & (_e ^ U), l[A + 28 >> 2] = _e, Be ^= he & (Be ^ it), l[A + 24 >> 2] = Be, ye ^= he & (ye ^ en), l[A + 20 >> 2] = ye, we ^= he & (we ^ Gt), l[A + 16 >> 2] = we, $e ^= he & ($e ^ Tt), l[A + 12 >> 2] = $e, Le ^= he & (Le ^ Ct), l[A + 8 >> 2] = Le, Ge ^= he & (Ge ^ ht), l[A + 4 >> 2] = Ge, he = ct ^ he & (ct ^ bt), l[A >> 2] = he, Ei(_ + 288 | 0, A), g = 0 - (1 & j[_ + 288 | 0] ^ B[g + 31 | 0] >>> 7) | 0, l[A + 36 >> 2] = D ^ g & (D ^ 0 - D), l[A + 32 >> 2] = me ^ g & (me ^ 0 - me), l[A + 28 >> 2] = _e ^ g & (_e ^ 0 - _e), l[A + 24 >> 2] = Be ^ g & (Be ^ 0 - Be), l[A + 20 >> 2] = ye ^ g & (ye ^ 0 - ye), l[A + 16 >> 2] = we ^ g & (we ^ 0 - we), l[A + 12 >> 2] = $e ^ g & ($e ^ 0 - $e), l[A + 8 >> 2] = Le ^ g & (Le ^ 0 - Le), l[A + 4 >> 2] = Ge ^ g & (Ge ^ 0 - Ge), l[A >> 2] = he ^ g & (he ^ 0 - he), In(A + 120 | 0, A, b), st = _ + 320 | 0, (je | mt) - 1 | 0;
                    }
                    function Se(A, g) {
                      var _, b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0;
                      st = _ = st - 48 | 0, Ot(A, g), Ot(A + 80 | 0, g + 40 | 0), Ia(A + 120 | 0, g + 80 | 0), ht = l[g + 40 >> 2], je = l[g + 44 >> 2], Ge = l[g + 4 >> 2], ct = l[g + 48 >> 2], Ct = l[g + 8 >> 2], mt = l[g + 52 >> 2], Tt = l[g + 12 >> 2], bt = l[g + 56 >> 2], Ft = l[g + 16 >> 2], Gt = l[g + 60 >> 2], fn = l[g + 20 >> 2], en = l[g - -64 >> 2], _n = l[g + 24 >> 2], it = l[g + 68 >> 2], wn = l[g + 28 >> 2], St = l[g + 72 >> 2], $n = l[g + 32 >> 2], Gn = l[g >> 2], l[A + 76 >> 2] = l[g + 76 >> 2] + l[g + 36 >> 2], l[A + 72 >> 2] = St + $n, l[A + 68 >> 2] = it + wn, l[(b = A - -64 | 0) >> 2] = en + _n, l[A + 60 >> 2] = Gt + fn, l[A + 56 >> 2] = bt + Ft, l[A + 52 >> 2] = mt + Tt, l[A + 48 >> 2] = ct + Ct, l[A + 44 >> 2] = je + Ge, l[(g = A + 40 | 0) >> 2] = ht + Gn, Ot(_, g), ht = l[A + 80 >> 2], je = l[A + 4 >> 2], Ge = l[A + 84 >> 2], ct = l[A + 8 >> 2], Ct = l[A + 88 >> 2], mt = l[A + 12 >> 2], Tt = l[A + 92 >> 2], bt = l[A + 16 >> 2], Ft = l[A + 96 >> 2], Gt = l[A + 20 >> 2], fn = l[A + 100 >> 2], en = l[A + 24 >> 2], _n = l[A + 104 >> 2], it = l[A + 28 >> 2], wn = l[A + 108 >> 2], St = l[A + 32 >> 2], $n = l[A + 112 >> 2], Gn = l[A >> 2], ie = (qn = l[A + 116 >> 2]) - (U = l[A + 36 >> 2]) | 0, l[A + 116 >> 2] = ie, he = $n - St | 0, l[A + 112 >> 2] = he, D = wn - it | 0, l[A + 108 >> 2] = D, me = _n - en | 0, l[A + 104 >> 2] = me, _e = fn - Gt | 0, l[A + 100 >> 2] = _e, Be = Ft - bt | 0, l[A + 96 >> 2] = Be, ye = Tt - mt | 0, l[A + 92 >> 2] = ye, we = Ct - ct | 0, l[A + 88 >> 2] = we, $e = Ge - je | 0, l[A + 84 >> 2] = $e, Le = ht - Gn | 0, l[A + 80 >> 2] = Le, qn = qn + U | 0, l[A + 76 >> 2] = qn, St = St + $n | 0, l[A + 72 >> 2] = St, it = it + wn | 0, l[A + 68 >> 2] = it, en = en + _n | 0, l[b >> 2] = en, Gt = Gt + fn | 0, l[A + 60 >> 2] = Gt, bt = bt + Ft | 0, l[A + 56 >> 2] = bt, mt = mt + Tt | 0, l[A + 52 >> 2] = mt, ct = ct + Ct | 0, l[A + 48 >> 2] = ct, je = je + Ge | 0, l[A + 44 >> 2] = je, Ge = g, g = ht + Gn | 0, l[Ge >> 2] = g, ht = l[_ >> 2], Ge = l[_ + 4 >> 2], Ct = l[_ + 8 >> 2], Tt = l[_ + 12 >> 2], Ft = l[_ + 16 >> 2], fn = l[_ + 20 >> 2], _n = l[_ + 24 >> 2], wn = l[_ + 28 >> 2], $n = l[_ + 32 >> 2], l[A + 36 >> 2] = l[_ + 36 >> 2] - qn, l[A + 32 >> 2] = $n - St, l[A + 28 >> 2] = wn - it, l[A + 24 >> 2] = _n - en, l[A + 20 >> 2] = fn - Gt, l[A + 16 >> 2] = Ft - bt, l[A + 12 >> 2] = Tt - mt, l[A + 8 >> 2] = Ct - ct, l[A + 4 >> 2] = Ge - je, l[A >> 2] = ht - g, g = l[A + 120 >> 2], ht = l[A + 124 >> 2], je = l[A + 128 >> 2], Ge = l[A + 132 >> 2], ct = l[A + 136 >> 2], Ct = l[A + 140 >> 2], mt = l[A + 144 >> 2], Tt = l[A + 148 >> 2], bt = l[A + 152 >> 2], l[A + 156 >> 2] = l[A + 156 >> 2] - ie, l[A + 152 >> 2] = bt - he, l[A + 148 >> 2] = Tt - D, l[A + 144 >> 2] = mt - me, l[A + 140 >> 2] = Ct - _e, l[A + 136 >> 2] = ct - Be, l[A + 132 >> 2] = Ge - ye, l[A + 128 >> 2] = je - we, l[A + 124 >> 2] = ht - $e, l[A + 120 >> 2] = g - Le, st = _ + 48 | 0;
                    }
                    function Ee(A, g, _) {
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0;
                      st = U = st - 160 | 0, l[A >> 2] = 1, l[(b = A) + 4 >> 2] = 0, l[b + 8 >> 2] = 0, l[b + 12 >> 2] = 0, l[b + 16 >> 2] = 0, l[b + 20 >> 2] = 0, l[b + 24 >> 2] = 0, l[b + 28 >> 2] = 0, l[b + 32 >> 2] = 0, l[b + 44 >> 2] = 0, l[b + 48 >> 2] = 0, l[b + 36 >> 2] = 0, l[b + 40 >> 2] = 1, l[b + 52 >> 2] = 0, l[b + 56 >> 2] = 0, l[b + 60 >> 2] = 0, l[b + 64 >> 2] = 0, l[b + 68 >> 2] = 0, l[b + 72 >> 2] = 0, l[b + 76 >> 2] = 0, l[b + 80 >> 2] = 1, Jt(b + 84 | 0, 0, 76), Cs(b, g, (255 & (1 ^ (A = _ - ((_ >> 31 & _) << 1) | 0))) - 1 >>> 31 | 0), Cs(b, g + 160 | 0, (255 & (2 ^ A)) - 1 >>> 31 | 0), Cs(b, g + 320 | 0, (255 & (3 ^ A)) - 1 >>> 31 | 0), Cs(b, g + 480 | 0, (255 & (4 ^ A)) - 1 >>> 31 | 0), Cs(b, g + 640 | 0, (255 & (5 ^ A)) - 1 >>> 31 | 0), Cs(b, g + 800 | 0, (255 & (6 ^ A)) - 1 >>> 31 | 0), Cs(b, g + 960 | 0, (255 & (7 ^ A)) - 1 >>> 31 | 0), Cs(b, g + 1120 | 0, (255 & (8 ^ A)) - 1 >>> 31 | 0), g = l[b + 40 >> 2], he = l[b + 44 >> 2], D = l[b + 48 >> 2], me = l[b + 52 >> 2], _e = l[b + 56 >> 2], Be = l[b + 60 >> 2], ye = l[(A = b - -64 | 0) >> 2], ie = l[A + 4 >> 2], A = U, U = l[b + 76 >> 2], l[A + 32 >> 2] = l[b + 72 >> 2], l[A + 36 >> 2] = U, l[A + 24 >> 2] = ye, l[A + 28 >> 2] = ie, l[A + 16 >> 2] = _e, l[A + 20 >> 2] = Be, l[A + 8 >> 2] = D, l[A + 12 >> 2] = me, l[A >> 2] = g, l[A + 4 >> 2] = he, g = l[b + 8 >> 2], U = l[b + 12 >> 2], he = l[b + 16 >> 2], D = l[b + 20 >> 2], me = l[b + 24 >> 2], _e = l[b + 28 >> 2], Be = l[b >> 2], ye = l[b + 4 >> 2], ie = l[b + 36 >> 2], l[A + 72 >> 2] = l[b + 32 >> 2], l[A + 76 >> 2] = ie, l[(ie = A - -64 | 0) >> 2] = me, l[ie + 4 >> 2] = _e, l[A + 56 >> 2] = he, l[A + 60 >> 2] = D, l[A + 48 >> 2] = g, l[A + 52 >> 2] = U, l[A + 40 >> 2] = Be, l[A + 44 >> 2] = ye, g = l[b + 80 >> 2], U = l[b + 84 >> 2], he = l[b + 88 >> 2], D = l[b + 92 >> 2], me = l[b + 96 >> 2], _e = l[b + 100 >> 2], Be = l[b + 104 >> 2], ye = l[b + 108 >> 2], ie = l[b + 116 >> 2], l[A + 112 >> 2] = l[b + 112 >> 2], l[A + 116 >> 2] = ie, l[A + 104 >> 2] = Be, l[A + 108 >> 2] = ye, l[A + 96 >> 2] = me, l[A + 100 >> 2] = _e, l[A + 88 >> 2] = he, l[A + 92 >> 2] = D, l[A + 80 >> 2] = g, l[A + 84 >> 2] = U, g = l[b + 120 >> 2], U = l[b + 124 >> 2], he = l[b + 128 >> 2], D = l[b + 132 >> 2], me = l[b + 136 >> 2], _e = l[b + 140 >> 2], Be = l[b + 144 >> 2], ye = l[b + 148 >> 2], ie = l[b + 152 >> 2], l[A + 156 >> 2] = 0 - l[b + 156 >> 2], l[A + 152 >> 2] = 0 - ie, l[A + 148 >> 2] = 0 - ye, l[A + 144 >> 2] = 0 - Be, l[A + 140 >> 2] = 0 - _e, l[A + 136 >> 2] = 0 - me, l[A + 132 >> 2] = 0 - D, l[A + 128 >> 2] = 0 - he, l[A + 124 >> 2] = 0 - U, l[A + 120 >> 2] = 0 - g, Cs(b, A, (128 & _) >>> 7 | 0), st = A + 160 | 0;
                    }
                    function ke(A, g) {
                      g |= 0;
                      var _, b, U = 0, ie = 0, he = 0, D = 0;
                      return st = _ = st - 288 | 0, ie = 40 + ((U = l[32 + (A |= 0) >> 2] >>> 3 & 63) + A | 0) | 0, U >>> 0 <= 55 ? xr(ie, 35616, 56 - U | 0) : (xr(ie, 35616, 64 - U | 0), Ys(A, A + 40 | 0, _, _ + 256 | 0), l[A + 88 >> 2] = 0, l[A + 92 >> 2] = 0, l[A + 80 >> 2] = 0, l[A + 84 >> 2] = 0, l[A + 72 >> 2] = 0, l[A + 76 >> 2] = 0, l[(U = A - -64 | 0) >> 2] = 0, l[U + 4 >> 2] = 0, l[A + 56 >> 2] = 0, l[A + 60 >> 2] = 0, l[A + 48 >> 2] = 0, l[A + 52 >> 2] = 0, l[A + 40 >> 2] = 0, l[A + 44 >> 2] = 0), he = (U = 16711680 & (ie = l[A + 32 >> 2])) >>> 8 | 0, D = U << 24, b = (U = -16777216 & ie) >>> 24 | 0, U = (D |= U << 8) | -16777216 & ((255 & (U = l[A + 36 >> 2])) << 24 | ie >>> 8) | 16711680 & ((16777215 & U) << 8 | ie >>> 24) | U >>> 8 & 65280 | U >>> 24, j[A + 96 | 0] = U, j[A + 97 | 0] = U >>> 8, j[A + 98 | 0] = U >>> 16, j[A + 99 | 0] = U >>> 24, U = (U = he | b | ie << 24 | (65280 & ie) << 8) | (he = 0) | he, j[A + 100 | 0] = U, j[A + 101 | 0] = U >>> 8, j[A + 102 | 0] = U >>> 16, j[A + 103 | 0] = U >>> 24, Ys(A, A + 40 | 0, _, _ + 256 | 0), U = (U = l[A >> 2]) << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, j[0 | g] = U, j[g + 1 | 0] = U >>> 8, j[g + 2 | 0] = U >>> 16, j[g + 3 | 0] = U >>> 24, U = (U = l[A + 4 >> 2]) << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, j[g + 4 | 0] = U, j[g + 5 | 0] = U >>> 8, j[g + 6 | 0] = U >>> 16, j[g + 7 | 0] = U >>> 24, U = (U = l[A + 8 >> 2]) << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, j[g + 8 | 0] = U, j[g + 9 | 0] = U >>> 8, j[g + 10 | 0] = U >>> 16, j[g + 11 | 0] = U >>> 24, U = (U = l[A + 12 >> 2]) << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, j[g + 12 | 0] = U, j[g + 13 | 0] = U >>> 8, j[g + 14 | 0] = U >>> 16, j[g + 15 | 0] = U >>> 24, U = (U = l[A + 16 >> 2]) << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, j[g + 16 | 0] = U, j[g + 17 | 0] = U >>> 8, j[g + 18 | 0] = U >>> 16, j[g + 19 | 0] = U >>> 24, U = (U = l[A + 20 >> 2]) << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, j[g + 20 | 0] = U, j[g + 21 | 0] = U >>> 8, j[g + 22 | 0] = U >>> 16, j[g + 23 | 0] = U >>> 24, U = (U = l[A + 24 >> 2]) << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, j[g + 24 | 0] = U, j[g + 25 | 0] = U >>> 8, j[g + 26 | 0] = U >>> 16, j[g + 27 | 0] = U >>> 24, U = (U = l[A + 28 >> 2]) << 24 | (65280 & U) << 8 | U >>> 8 & 65280 | U >>> 24, j[g + 28 | 0] = U, j[g + 29 | 0] = U >>> 8, j[g + 30 | 0] = U >>> 16, j[g + 31 | 0] = U >>> 24, Wr(_, 288), Wr(A, 104), st = _ + 288 | 0, 0;
                    }
                    function Ce(A, g) {
                      A |= 0, g |= 0;
                      var _, b, U, ie, he, D = 0, me = 0, _e = 0;
                      return st = me = st - 192 | 0, jn(me, 32), L(g, me, 32, 0), j[0 | g] = 248 & B[0 | g], j[g + 31 | 0] = 63 & B[g + 31 | 0] | 64, Os(_e = me + 32 | 0, g), kr(A, _e), _ = me, _e = l[me + 28 >> 2], me = l[me + 24 >> 2], j[g + 24 | 0] = me, j[g + 25 | 0] = me >>> 8, j[g + 26 | 0] = me >>> 16, j[g + 27 | 0] = me >>> 24, j[g + 28 | 0] = _e, j[g + 29 | 0] = _e >>> 8, j[g + 30 | 0] = _e >>> 16, j[g + 31 | 0] = _e >>> 24, _e = l[_ + 20 >> 2], me = l[_ + 16 >> 2], j[g + 16 | 0] = me, j[g + 17 | 0] = me >>> 8, j[g + 18 | 0] = me >>> 16, j[g + 19 | 0] = me >>> 24, j[g + 20 | 0] = _e, j[g + 21 | 0] = _e >>> 8, j[g + 22 | 0] = _e >>> 16, j[g + 23 | 0] = _e >>> 24, _e = l[_ + 12 >> 2], me = l[_ + 8 >> 2], j[g + 8 | 0] = me, j[g + 9 | 0] = me >>> 8, j[g + 10 | 0] = me >>> 16, j[g + 11 | 0] = me >>> 24, j[g + 12 | 0] = _e, j[g + 13 | 0] = _e >>> 8, j[g + 14 | 0] = _e >>> 16, j[g + 15 | 0] = _e >>> 24, _e = l[_ + 4 >> 2], me = l[_ >> 2], j[0 | g] = me, j[g + 1 | 0] = me >>> 8, j[g + 2 | 0] = me >>> 16, j[g + 3 | 0] = me >>> 24, j[g + 4 | 0] = _e, j[g + 5 | 0] = _e >>> 8, j[g + 6 | 0] = _e >>> 16, j[g + 7 | 0] = _e >>> 24, b = B[(D = A) + 8 | 0] | B[D + 9 | 0] << 8 | B[D + 10 | 0] << 16 | B[D + 11 | 0] << 24, U = B[D + 12 | 0] | B[D + 13 | 0] << 8 | B[D + 14 | 0] << 16 | B[D + 15 | 0] << 24, ie = B[D + 16 | 0] | B[D + 17 | 0] << 8 | B[D + 18 | 0] << 16 | B[D + 19 | 0] << 24, _e = B[D + 20 | 0] | B[D + 21 | 0] << 8 | B[D + 22 | 0] << 16 | B[D + 23 | 0] << 24, me = B[0 | D] | B[D + 1 | 0] << 8 | B[D + 2 | 0] << 16 | B[D + 3 | 0] << 24, A = B[D + 4 | 0] | B[D + 5 | 0] << 8 | B[D + 6 | 0] << 16 | B[D + 7 | 0] << 24, he = B[D + 28 | 0] | B[D + 29 | 0] << 8 | B[D + 30 | 0] << 16 | B[D + 31 | 0] << 24, D = B[D + 24 | 0] | B[D + 25 | 0] << 8 | B[D + 26 | 0] << 16 | B[D + 27 | 0] << 24, j[g + 56 | 0] = D, j[g + 57 | 0] = D >>> 8, j[g + 58 | 0] = D >>> 16, j[g + 59 | 0] = D >>> 24, j[g + 60 | 0] = he, j[g + 61 | 0] = he >>> 8, j[g + 62 | 0] = he >>> 16, j[g + 63 | 0] = he >>> 24, j[g + 48 | 0] = ie, j[g + 49 | 0] = ie >>> 8, j[g + 50 | 0] = ie >>> 16, j[g + 51 | 0] = ie >>> 24, j[g + 52 | 0] = _e, j[g + 53 | 0] = _e >>> 8, j[g + 54 | 0] = _e >>> 16, j[g + 55 | 0] = _e >>> 24, j[g + 40 | 0] = b, j[g + 41 | 0] = b >>> 8, j[g + 42 | 0] = b >>> 16, j[g + 43 | 0] = b >>> 24, j[g + 44 | 0] = U, j[g + 45 | 0] = U >>> 8, j[g + 46 | 0] = U >>> 16, j[g + 47 | 0] = U >>> 24, j[g + 32 | 0] = me, j[g + 33 | 0] = me >>> 8, j[g + 34 | 0] = me >>> 16, j[g + 35 | 0] = me >>> 24, j[g + 36 | 0] = A, j[g + 37 | 0] = A >>> 8, j[g + 38 | 0] = A >>> 16, j[g + 39 | 0] = A >>> 24, Wr(_, 32), st = _ + 192 | 0, 0;
                    }
                    function Re(A, g) {
                      A |= 0;
                      var _, b = 0;
                      st = _ = st + -64 | 0, b = B[60 + (g |= 0) | 0] | B[g + 61 | 0] << 8 | B[g + 62 | 0] << 16 | B[g + 63 | 0] << 24, l[_ + 56 >> 2] = B[g + 56 | 0] | B[g + 57 | 0] << 8 | B[g + 58 | 0] << 16 | B[g + 59 | 0] << 24, l[_ + 60 >> 2] = b, b = B[g + 52 | 0] | B[g + 53 | 0] << 8 | B[g + 54 | 0] << 16 | B[g + 55 | 0] << 24, l[_ + 48 >> 2] = B[g + 48 | 0] | B[g + 49 | 0] << 8 | B[g + 50 | 0] << 16 | B[g + 51 | 0] << 24, l[_ + 52 >> 2] = b, b = B[g + 44 | 0] | B[g + 45 | 0] << 8 | B[g + 46 | 0] << 16 | B[g + 47 | 0] << 24, l[_ + 40 >> 2] = B[g + 40 | 0] | B[g + 41 | 0] << 8 | B[g + 42 | 0] << 16 | B[g + 43 | 0] << 24, l[_ + 44 >> 2] = b, b = B[g + 36 | 0] | B[g + 37 | 0] << 8 | B[g + 38 | 0] << 16 | B[g + 39 | 0] << 24, l[_ + 32 >> 2] = B[g + 32 | 0] | B[g + 33 | 0] << 8 | B[g + 34 | 0] << 16 | B[g + 35 | 0] << 24, l[_ + 36 >> 2] = b, b = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, l[_ + 24 >> 2] = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, l[_ + 28 >> 2] = b, b = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, l[_ + 16 >> 2] = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, l[_ + 20 >> 2] = b, b = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, l[_ >> 2] = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, l[_ + 4 >> 2] = b, b = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, l[_ + 8 >> 2] = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, l[_ + 12 >> 2] = b, Vi(_), g = l[_ + 28 >> 2], b = l[_ + 24 >> 2], j[A + 24 | 0] = b, j[A + 25 | 0] = b >>> 8, j[A + 26 | 0] = b >>> 16, j[A + 27 | 0] = b >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[_ + 20 >> 2], b = l[_ + 16 >> 2], j[A + 16 | 0] = b, j[A + 17 | 0] = b >>> 8, j[A + 18 | 0] = b >>> 16, j[A + 19 | 0] = b >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[_ + 12 >> 2], b = l[_ + 8 >> 2], j[A + 8 | 0] = b, j[A + 9 | 0] = b >>> 8, j[A + 10 | 0] = b >>> 16, j[A + 11 | 0] = b >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[_ + 4 >> 2], b = l[_ >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, Wr(_, 64), st = _ - -64 | 0;
                    }
                    function Fe(A, g, _) {
                      A |= 0, g |= 0;
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0;
                      if (st = b = st - 96 | 0, (_ |= 0) >>> 0 >= 65 && (kn(A), dt(A, g, _, 0), ke(A, b), _ = 32, g = b), kn(A), l[b + 88 >> 2] = 909522486, l[b + 92 >> 2] = 909522486, l[b + 80 >> 2] = 909522486, l[b + 84 >> 2] = 909522486, l[b + 72 >> 2] = 909522486, l[b + 76 >> 2] = 909522486, l[(he = Be = b - -64 | 0) >> 2] = 909522486, l[he + 4 >> 2] = 909522486, l[b + 56 >> 2] = 909522486, l[b + 60 >> 2] = 909522486, l[b + 48 >> 2] = 909522486, l[b + 52 >> 2] = 909522486, l[b + 40 >> 2] = 909522486, l[b + 44 >> 2] = 909522486, l[b + 32 >> 2] = 909522486, l[b + 36 >> 2] = 909522486, _) {
                        if (_ >>> 0 >= 4)
                          for (D = 124 & _; j[0 | (ie = (he = b + 32 | 0) + U | 0)] = B[0 | ie] ^ B[g + U | 0], j[0 | (ye = (ie = 1 | U) + he | 0)] = B[0 | ye] ^ B[g + ie | 0], j[0 | (ye = (ie = 2 | U) + he | 0)] = B[0 | ye] ^ B[g + ie | 0], j[0 | (ie = (ie = he) + (he = 3 | U) | 0)] = B[0 | ie] ^ B[g + he | 0], U = U + 4 | 0, (0 | D) != (0 | (me = me + 4 | 0)); )
                            ;
                        if (me = 3 & _)
                          for (; j[0 | (he = (b + 32 | 0) + U | 0)] = B[0 | he] ^ B[g + U | 0], U = U + 1 | 0, (0 | me) != (0 | (_e = _e + 1 | 0)); )
                            ;
                      }
                      if (dt(A, b + 32 | 0, 64, 0), kn(he = A + 104 | 0), l[b + 88 >> 2] = 1549556828, l[b + 92 >> 2] = 1549556828, l[b + 80 >> 2] = 1549556828, l[b + 84 >> 2] = 1549556828, l[b + 72 >> 2] = 1549556828, l[b + 76 >> 2] = 1549556828, l[Be >> 2] = 1549556828, l[Be + 4 >> 2] = 1549556828, l[b + 56 >> 2] = 1549556828, l[b + 60 >> 2] = 1549556828, l[b + 48 >> 2] = 1549556828, l[b + 52 >> 2] = 1549556828, l[b + 40 >> 2] = 1549556828, l[b + 44 >> 2] = 1549556828, l[b + 32 >> 2] = 1549556828, l[b + 36 >> 2] = 1549556828, _) {
                        if (_e = 0, U = 0, _ >>> 0 >= 4)
                          for (Be = 124 & _, me = 0; j[0 | (D = (A = b + 32 | 0) + U | 0)] = B[0 | D] ^ B[g + U | 0], j[0 | (ie = (D = 1 | U) + A | 0)] = B[0 | ie] ^ B[g + D | 0], j[0 | (ie = (D = 2 | U) + A | 0)] = B[0 | ie] ^ B[g + D | 0], j[0 | (D = (ie = A) + (A = 3 | U) | 0)] = B[0 | D] ^ B[A + g | 0], U = U + 4 | 0, (0 | Be) != (0 | (me = me + 4 | 0)); )
                            ;
                        if (A = 3 & _)
                          for (; j[0 | (_ = (b + 32 | 0) + U | 0)] = B[0 | _] ^ B[g + U | 0], U = U + 1 | 0, (0 | A) != (0 | (_e = _e + 1 | 0)); )
                            ;
                      }
                      return dt(he, A = b + 32 | 0, 64, 0), Wr(A, 64), Wr(b, 32), st = b + 96 | 0, 0;
                    }
                    function qe(A, g, _, b, U, ie, he) {
                      var D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0;
                      if (g - 65 >>> 0 < 4294967232 | he >>> 0 > 64)
                        A = -1;
                      else {
                        we = D = st, st = D = D - 512 & -64;
                        e: {
                          t:
                            if (!(!(!(b | U) | _) | !A | ((me = 255 & g) - 65 & 255) >>> 0 <= 191 | !(!(g = 255 & he) || ie) | g >>> 0 >= 65)) {
                              if (g) {
                                if (!ie)
                                  break t;
                                Jt(D - -64 | 0, 0, 293), l[D + 56 >> 2] = 327033209, l[D + 60 >> 2] = 1541459225, l[D + 48 >> 2] = -79577749, l[D + 52 >> 2] = 528734635, l[D + 40 >> 2] = 725511199, l[D + 44 >> 2] = -1694144372, l[D + 32 >> 2] = -1377402159, l[D + 36 >> 2] = 1359893119, l[D + 24 >> 2] = 1595750129, l[D + 28 >> 2] = -1521486534, l[D + 16 >> 2] = -23791573, l[D + 20 >> 2] = 1013904242, l[D + 8 >> 2] = -2067093701, l[D + 12 >> 2] = -1150833019, l[D >> 2] = -222443256 ^ (g << 8 | me), l[D + 4 >> 2] = g >>> 24 ^ 1779033703, Jt((he = D + 384 | 0) + g | 0, 0, 128 - g | 0), xr(he, ie, g), xr(D + 96 | 0, he, 128), l[D + 352 >> 2] = 128, Wr(he, 128), g = 128;
                              } else
                                Jt(D - -64 | 0, 0, 293), l[D + 56 >> 2] = 327033209, l[D + 60 >> 2] = 1541459225, l[D + 48 >> 2] = -79577749, l[D + 52 >> 2] = 528734635, l[D + 40 >> 2] = 725511199, l[D + 44 >> 2] = -1694144372, l[D + 32 >> 2] = -1377402159, l[D + 36 >> 2] = 1359893119, l[D + 24 >> 2] = 1595750129, l[D + 28 >> 2] = -1521486534, l[D + 16 >> 2] = -23791573, l[D + 20 >> 2] = 1013904242, l[D + 8 >> 2] = -2067093701, l[D + 12 >> 2] = -1150833019, l[D >> 2] = -222443256 ^ me, l[D + 4 >> 2] = 1779033703, g = 0;
                              n:
                                if (b | U)
                                  for ($e = D + 224 | 0, _e = D + 96 | 0; ; ) {
                                    if (he = g + _e | 0, !U & b >>> 0 <= (ie = 256 - g | 0) >>> 0) {
                                      xr(he, _, b), l[D + 352 >> 2] = b + l[D + 352 >> 2];
                                      break n;
                                    }
                                    if (xr(he, _, ie), l[D + 352 >> 2] = ie + l[D + 352 >> 2], Be = g = l[D + 68 >> 2], g = (ye = (he = l[D + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? g + 1 | 0 : g, l[D + 64 >> 2] = ye, l[D + 68 >> 2] = g, g = l[D + 76 >> 2], g = (Be = he = (0 | Be) == -1 & he >>> 0 > 4294967167) >>> 0 > (he = he + l[D + 72 >> 2] | 0) >>> 0 ? g + 1 | 0 : g, l[D + 72 >> 2] = he, l[D + 76 >> 2] = g, $s(D, _e), xr(_e, $e, 128), g = l[D + 352 >> 2] - 128 | 0, l[D + 352 >> 2] = g, _ = _ + ie | 0, !((U = U - (b >>> 0 < ie >>> 0) | 0) | (b = b - ie | 0)))
                                      break;
                                  }
                              la(D, A, me), st = we;
                              break e;
                            }
                          Ai(), Xr();
                        }
                        A = 0;
                      }
                      return A;
                    }
                    function Xe(A, g) {
                      A |= 0, g |= 0;
                      var _, b = 0;
                      st = _ = st - 128 | 0, l[_ + 80 >> 2] = 0, l[_ + 84 >> 2] = 0, l[_ + 88 >> 2] = 0, l[_ + 92 >> 2] = 0, l[_ + 40 >> 2] = 0, l[_ + 44 >> 2] = 0, l[_ + 48 >> 2] = 0, l[_ + 52 >> 2] = 0, l[_ + 56 >> 2] = 0, l[_ + 60 >> 2] = 0, b = l[8595], l[_ + 104 >> 2] = l[8594], l[_ + 108 >> 2] = b, b = l[8597], l[_ + 112 >> 2] = l[8596], l[_ + 116 >> 2] = b, b = l[8599], l[_ + 120 >> 2] = l[8598], l[_ + 124 >> 2] = b, l[_ + 64 >> 2] = 0, l[_ + 68 >> 2] = 0, l[_ + 72 >> 2] = 0, l[_ + 76 >> 2] = 0, j[_ + 64 | 0] = 1, l[_ + 32 >> 2] = 0, l[_ + 36 >> 2] = 0, b = l[8593], l[_ + 96 >> 2] = l[8592], l[_ + 100 >> 2] = b, b = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, l[_ + 24 >> 2] = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, l[_ + 28 >> 2] = b, b = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, l[_ + 16 >> 2] = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, l[_ + 20 >> 2] = b, b = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, l[_ + 8 >> 2] = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, l[_ + 12 >> 2] = b, b = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, l[_ >> 2] = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, l[_ + 4 >> 2] = b, nn(g = _ - -64 | 0, _), Vi(g), g = l[_ + 92 >> 2], b = l[_ + 88 >> 2], j[A + 24 | 0] = b, j[A + 25 | 0] = b >>> 8, j[A + 26 | 0] = b >>> 16, j[A + 27 | 0] = b >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[_ + 84 >> 2], b = l[_ + 80 >> 2], j[A + 16 | 0] = b, j[A + 17 | 0] = b >>> 8, j[A + 18 | 0] = b >>> 16, j[A + 19 | 0] = b >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[_ + 76 >> 2], b = l[_ + 72 >> 2], j[A + 8 | 0] = b, j[A + 9 | 0] = b >>> 8, j[A + 10 | 0] = b >>> 16, j[A + 11 | 0] = b >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[_ + 68 >> 2], b = l[_ + 64 >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, st = _ + 128 | 0;
                    }
                    function yt(A, g, _, b) {
                      var U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0;
                      e: {
                        if ((he = l[A + 56 >> 2]) | (U = l[A + 60 >> 2])) {
                          if (we = ie = 16 - he | 0, me = (ie = (0 | (D = 0 - ((he >>> 0 > 16) + U | 0) | 0)) == (0 | b) & _ >>> 0 > ie >>> 0 | b >>> 0 > D >>> 0) ? we : _, we = ie = ie ? D : b, ie | me) {
                            if (ie = 0, he = 0, !we & me >>> 0 >= 4 | we)
                              for (_e = -4 & me, D = A - -64 | 0; U = ie + l[A + 56 >> 2] | 0, j[U + D | 0] = B[g + ie | 0], U = ($e = 1 | ie) + l[A + 56 >> 2] | 0, j[U + D | 0] = B[g + $e | 0], U = ($e = 2 | ie) + l[A + 56 >> 2] | 0, j[U + D | 0] = B[g + $e | 0], U = ($e = 3 | ie) + l[A + 56 >> 2] | 0, j[U + D | 0] = B[g + $e | 0], U = he, he = (ie = ie + 4 | 0) >>> 0 < 4 ? U + 1 | 0 : U, U = Be, Be = U = (ye = ye + 4 | 0) >>> 0 < 4 ? U + 1 | 0 : U, (0 | ye) != (0 | _e) | (0 | we) != (0 | U); )
                                ;
                            if (D = U = 0, U | (Be = 3 & me))
                              for (; ye = ie + l[A + 56 >> 2] | 0, j[(A + ye | 0) - -64 | 0] = B[g + ie | 0], he = (ie = ie + 1 | 0) ? he : he + 1 | 0, U = Ge, Ge = U = (Le = Le + 1 | 0) ? U : U + 1 | 0, (0 | Be) != (0 | Le) | (0 | D) != (0 | U); )
                                ;
                            he = l[A + 56 >> 2], U = l[A + 60 >> 2];
                          }
                          if (U = U + we | 0, U = (he = he + me | 0) >>> 0 < me >>> 0 ? U + 1 | 0 : U, l[A + 56 >> 2] = he, l[A + 60 >> 2] = U, !U & he >>> 0 < 16)
                            break e;
                          Xs(A, A - -64 | 0, 16, 0), l[A + 56 >> 2] = 0, l[A + 60 >> 2] = 0, _ = (he = _) - me | 0, b = b - ((he >>> 0 < me >>> 0) + we | 0) | 0, g = g + me | 0;
                        }
                        if (!b & _ >>> 0 >= 16 | b && (Xs(A, g, he = -16 & _, b), _ &= 15, b = 0, g = g + he | 0), _ | b) {
                          if (Le = 0, Ge = 0, ie = 0, he = 0, !b & _ >>> 0 >= 4 | b)
                            for (me = 12 & _, we = 0, D = A - -64 | 0, ye = 0, Be = 0; U = ie + l[A + 56 >> 2] | 0, j[U + D | 0] = B[g + ie | 0], U = (_e = 1 | ie) + l[A + 56 >> 2] | 0, j[U + D | 0] = B[g + _e | 0], U = (_e = 2 | ie) + l[A + 56 >> 2] | 0, j[U + D | 0] = B[g + _e | 0], U = (_e = 3 | ie) + l[A + 56 >> 2] | 0, j[U + D | 0] = B[g + _e | 0], he = (ie = ie + 4 | 0) >>> 0 < 4 ? he + 1 | 0 : he, U = Be, Be = U = (ye = ye + 4 | 0) >>> 0 < 4 ? U + 1 | 0 : U, (0 | me) != (0 | ye) | (0 | we) != (0 | U); )
                              ;
                          if (D = U = 0, U | (Be = 3 & _))
                            for (; U = ie + l[A + 56 >> 2] | 0, j[(A + U | 0) - -64 | 0] = B[g + ie | 0], he = (ie = ie + 1 | 0) ? he : he + 1 | 0, U = Ge, Ge = U = (Le = Le + 1 | 0) ? U : U + 1 | 0, (0 | Be) != (0 | Le) | (0 | D) != (0 | U); )
                              ;
                          he = b + l[A + 60 >> 2] | 0, he = (g = _ + l[A + 56 >> 2] | 0) >>> 0 < _ >>> 0 ? he + 1 | 0 : he, l[A + 56 >> 2] = g, l[A + 60 >> 2] = he;
                        }
                      }
                    }
                    function Rt(A, g) {
                      A |= 0, g |= 0;
                      var _, b = 0;
                      st = _ = st - 128 | 0, l[_ + 80 >> 2] = 0, l[_ + 84 >> 2] = 0, l[_ + 88 >> 2] = 0, l[_ + 92 >> 2] = 0, l[_ + 40 >> 2] = 0, l[_ + 44 >> 2] = 0, l[_ + 48 >> 2] = 0, l[_ + 52 >> 2] = 0, l[_ + 56 >> 2] = 0, l[_ + 60 >> 2] = 0, b = l[8595], l[_ + 104 >> 2] = l[8594], l[_ + 108 >> 2] = b, b = l[8597], l[_ + 112 >> 2] = l[8596], l[_ + 116 >> 2] = b, b = l[8599], l[_ + 120 >> 2] = l[8598], l[_ + 124 >> 2] = b, l[_ + 64 >> 2] = 0, l[_ + 68 >> 2] = 0, l[_ + 72 >> 2] = 0, l[_ + 76 >> 2] = 0, l[_ + 32 >> 2] = 0, l[_ + 36 >> 2] = 0, b = l[8593], l[_ + 96 >> 2] = l[8592], l[_ + 100 >> 2] = b, b = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, l[_ + 16 >> 2] = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, l[_ + 20 >> 2] = b, b = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, l[_ + 24 >> 2] = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, l[_ + 28 >> 2] = b, b = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, l[_ >> 2] = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, l[_ + 4 >> 2] = b, b = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, l[_ + 8 >> 2] = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, l[_ + 12 >> 2] = b, nn(g = _ - -64 | 0, _), Vi(g), g = l[_ + 92 >> 2], b = l[_ + 88 >> 2], j[A + 24 | 0] = b, j[A + 25 | 0] = b >>> 8, j[A + 26 | 0] = b >>> 16, j[A + 27 | 0] = b >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[_ + 84 >> 2], b = l[_ + 80 >> 2], j[A + 16 | 0] = b, j[A + 17 | 0] = b >>> 8, j[A + 18 | 0] = b >>> 16, j[A + 19 | 0] = b >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[_ + 76 >> 2], b = l[_ + 72 >> 2], j[A + 8 | 0] = b, j[A + 9 | 0] = b >>> 8, j[A + 10 | 0] = b >>> 16, j[A + 11 | 0] = b >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[_ + 68 >> 2], b = l[_ + 64 >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, st = _ + 128 | 0;
                    }
                    function Yt(A, g, _) {
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0;
                      Ge = l[g + 4 >> 2], U = l[A + 4 >> 2], je = l[g + 8 >> 2], ie = l[A + 8 >> 2], ct = l[g + 12 >> 2], he = l[A + 12 >> 2], mt = l[g + 16 >> 2], D = l[A + 16 >> 2], bt = l[g + 20 >> 2], me = l[A + 20 >> 2], ht = l[g + 24 >> 2], _e = l[A + 24 >> 2], $e = l[g + 28 >> 2], Be = l[A + 28 >> 2], Ct = l[g + 32 >> 2], ye = l[A + 32 >> 2], Tt = l[g + 36 >> 2], we = l[A + 36 >> 2], _ = 0 - _ | 0, Le = l[A >> 2], l[A >> 2] = _ & (Le ^ l[g >> 2]) ^ Le, l[A + 36 >> 2] = we ^ _ & (we ^ Tt), l[A + 32 >> 2] = ye ^ _ & (ye ^ Ct), l[A + 28 >> 2] = Be ^ _ & (Be ^ $e), l[A + 24 >> 2] = _e ^ _ & (_e ^ ht), l[A + 20 >> 2] = me ^ _ & (me ^ bt), l[A + 16 >> 2] = D ^ _ & (D ^ mt), l[A + 12 >> 2] = he ^ _ & (he ^ ct), l[A + 8 >> 2] = ie ^ _ & (ie ^ je), l[A + 4 >> 2] = U ^ _ & (U ^ Ge), U = l[A + 40 >> 2], Ge = l[g + 40 >> 2], ie = l[A + 44 >> 2], je = l[g + 44 >> 2], he = l[A + 48 >> 2], ct = l[g + 48 >> 2], D = l[A + 52 >> 2], mt = l[g + 52 >> 2], me = l[A + 56 >> 2], bt = l[g + 56 >> 2], _e = l[A + 60 >> 2], ht = l[g + 60 >> 2], Be = l[($e = A - -64 | 0) >> 2], Ct = l[g - -64 >> 2], ye = l[A + 68 >> 2], Tt = l[g + 68 >> 2], we = l[A + 72 >> 2], Le = l[g + 72 >> 2], b = l[A + 76 >> 2], l[A + 76 >> 2] = b ^ _ & (l[g + 76 >> 2] ^ b), l[A + 72 >> 2] = we ^ _ & (we ^ Le), l[A + 68 >> 2] = ye ^ _ & (ye ^ Tt), l[$e >> 2] = Be ^ _ & (Be ^ Ct), l[A + 60 >> 2] = _e ^ _ & (_e ^ ht), l[A + 56 >> 2] = me ^ _ & (me ^ bt), l[A + 52 >> 2] = D ^ _ & (D ^ mt), l[A + 48 >> 2] = he ^ _ & (he ^ ct), l[A + 44 >> 2] = ie ^ _ & (ie ^ je), l[A + 40 >> 2] = U ^ _ & (U ^ Ge), U = l[A + 80 >> 2], Ge = l[g + 80 >> 2], ie = l[A + 84 >> 2], je = l[g + 84 >> 2], he = l[A + 88 >> 2], ct = l[g + 88 >> 2], D = l[A + 92 >> 2], mt = l[g + 92 >> 2], me = l[A + 96 >> 2], bt = l[g + 96 >> 2], _e = l[A + 100 >> 2], ht = l[g + 100 >> 2], Be = l[A + 104 >> 2], $e = l[g + 104 >> 2], ye = l[A + 108 >> 2], Ct = l[g + 108 >> 2], we = l[A + 112 >> 2], Tt = l[g + 112 >> 2], Le = l[g + 116 >> 2], g = l[A + 116 >> 2], l[A + 116 >> 2] = _ & (Le ^ g) ^ g, l[A + 112 >> 2] = we ^ _ & (we ^ Tt), l[A + 108 >> 2] = ye ^ _ & (ye ^ Ct), l[A + 104 >> 2] = Be ^ _ & (Be ^ $e), l[A + 100 >> 2] = _e ^ _ & (_e ^ ht), l[A + 96 >> 2] = me ^ _ & (me ^ bt), l[A + 92 >> 2] = D ^ _ & (D ^ mt), l[A + 88 >> 2] = he ^ _ & (he ^ ct), l[A + 84 >> 2] = ie ^ _ & (ie ^ je), l[A + 80 >> 2] = U ^ _ & (U ^ Ge);
                    }
                    function Mn(A, g) {
                      var _, b, U = 0;
                      for (st = _ = st - 192 | 0, Ot(b = _ + 144 | 0, g), Ot(U = _ + 96 | 0, b), Ot(U, U), In(U, g, U), In(b, b, U), Ot(g = _ + 48 | 0, b), In(U, U, g), Ot(g, U), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), In(U, g, U), Ot(g, U), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), In(g, g, U), Ot(_, g), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), In(g, _, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), In(U, g, U), Ot(g, U), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), In(g, g, U), Ot(_, g), g = 1; Ot(_, _), (0 | (g = g + 1 | 0)) != 100; )
                        ;
                      In(g = _ + 48 | 0, _, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), Ot(g, g), In(U = _ + 96 | 0, g, U), Ot(U, U), Ot(U, U), Ot(U, U), Ot(U, U), Ot(U, U), In(A, U, _ + 144 | 0), st = _ + 192 | 0;
                    }
                    function Un(A, g, _, b, U) {
                      A |= 0, g |= 0, _ |= 0, b |= 0;
                      var ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0;
                      e: {
                        t: {
                          n: {
                            if ((-7 & (U |= 0)) == 1 && (me = (ie = (b >>> 0) / 3 | 0) << 2, (ie = wr(ie, -3) + b | 0) && (me = 2 & U ? (2 | me) + (ie >>> 1 | 0) | 0 : me + 4 | 0), !(g >>> 0 <= me >>> 0))) {
                              if (!(4 & U)) {
                                if (ie = 0, !b)
                                  break e;
                                break n;
                              }
                              if (ie = 0, !b)
                                break e;
                              for (; ; ) {
                                for (Be = (we = B[_ + ye | 0]) | Be << 8, _e = ie, ie = 1 + ((((D |= 8) - 6 >>> 0) / 6 | 0) + ie | 0) | 0; $e = 65510 + (he = Be >>> (D = (U = D) - 6 | 0) & 63) >>> 8 | 0, Le = he + 65484 >>> 8 | 0, j[A + _e | 0] = (1 + (16321 ^ he) ^ -1) >>> 8 & 45 | he + 252 & he + 65474 >>> 8 & (-1 ^ Le) | (he + 32705 ^ -1) >>> 8 & 95 | $e & he + 65 | Le & he + 71 & (-1 ^ $e), (0 | (_e = _e + 1 | 0)) != (0 | ie); )
                                  ;
                                if ((0 | (ye = ye + 1 | 0)) == (0 | b))
                                  break;
                              }
                              if (!D)
                                break e;
                              _e = (b = 65510 + (_ = we << 12 - U & 63) >>> 8 | 0) & _ + 65, Be = _ + 252 & _ + 65474 >>> 8 & (-1 ^ (U = _ + 65484 >>> 8 | 0)), D = U & _ + 71 & (-1 ^ b), b = _ + 32705 | 0, U = (1 + (16321 ^ _) ^ -1) >>> 8 & 45, _ = 95;
                              break t;
                            }
                            Ai(), Xr();
                          }
                          for (; ; ) {
                            for (Be = (we = B[_ + ye | 0]) | Be << 8, _e = ie, ie = 1 + ((((D |= 8) - 6 >>> 0) / 6 | 0) + ie | 0) | 0; $e = 65510 + (he = Be >>> (D = (U = D) - 6 | 0) & 63) >>> 8 | 0, Le = he + 65484 >>> 8 | 0, j[A + _e | 0] = (1 + (16321 ^ he) ^ -1) >>> 8 & 43 | he + 252 & he + 65474 >>> 8 & (-1 ^ Le) | (he + 16321 ^ -1) >>> 8 & 47 | $e & he + 65 | Le & he + 71 & (-1 ^ $e), (0 | (_e = _e + 1 | 0)) != (0 | ie); )
                              ;
                            if ((0 | (ye = ye + 1 | 0)) == (0 | b))
                              break;
                          }
                          if (!D)
                            break e;
                          _e = (b = 65510 + (_ = we << 12 - U & 63) >>> 8 | 0) & _ + 65, Be = _ + 252 & _ + 65474 >>> 8 & (-1 ^ (U = _ + 65484 >>> 8 | 0)), D = U & _ + 71 & (-1 ^ b), b = _ + 16321 | 0, U = (1 + (16321 ^ _) ^ -1) >>> 8 & 43, _ = 47;
                        }
                        j[A + ie | 0] = _ & (-1 ^ b) >>> 8 | _e | Be | U | D, ie = ie + 1 | 0;
                      }
                      e: {
                        t: {
                          if (ie >>> 0 <= me >>> 0) {
                            if (ie >>> 0 < me >>> 0)
                              break t;
                            me = ie;
                            break e;
                          }
                          Hs(1104, 1201, 230, 1505), Xr();
                        }
                        Jt(A + ie | 0, 61, me - ie | 0);
                      }
                      return Jt(A + me | 0, 0, (g >>> 0 > (_ = me + 1 | 0) >>> 0 ? g : _) - me | 0), 0 | A;
                    }
                    function Jn(A, g) {
                      var _, b = 0, U = 0;
                      for (st = _ = st - 144 | 0, Ot(U = _ + 96 | 0, g), Ot(b = _ + 48 | 0, U), Ot(b, b), In(b, g, b), In(U, U, b), Ot(U, U), In(U, b, U), Ot(b, U), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), In(U, b, U), Ot(b, U), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), In(b, b, U), Ot(_, b), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), Ot(_, _), In(b, _, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), In(U, b, U), Ot(b, U), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), In(b, b, U), Ot(_, b), b = 1; Ot(_, _), (0 | (b = b + 1 | 0)) != 100; )
                        ;
                      In(b = _ + 48 | 0, _, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), Ot(b, b), In(U = _ + 96 | 0, b, U), Ot(U, U), Ot(U, U), In(A, U, g), st = _ + 144 | 0;
                    }
                    function Rn(A, g) {
                      var _, b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht, Ct = 0, Tt = 0, Gt = 0, en = 0;
                      st = _ = st - 320 | 0, gs(b = A + 40 | 0, g), l[A + 84 >> 2] = 0, l[A + 88 >> 2] = 0, l[A + 80 >> 2] = 1, l[A + 92 >> 2] = 0, l[A + 96 >> 2] = 0, l[A + 100 >> 2] = 0, l[A + 104 >> 2] = 0, l[A + 108 >> 2] = 0, l[A + 112 >> 2] = 0, l[A + 116 >> 2] = 0, Ot(Gt = _ + 240 | 0, b), In(Tt = _ + 192 | 0, Gt, 1600), en = -1, U = l[_ + 240 >> 2] - 1 | 0, l[_ + 240 >> 2] = U, l[_ + 192 >> 2] = l[_ + 192 >> 2] + 1, ie = l[_ + 244 >> 2], he = l[_ + 248 >> 2], D = l[_ + 252 >> 2], me = l[_ + 256 >> 2], _e = l[_ + 260 >> 2], Be = l[_ + 264 >> 2], ye = l[_ + 268 >> 2], we = l[_ + 272 >> 2], $e = l[_ + 276 >> 2], Ot(Ct = _ + 144 | 0, Tt), In(Ct, Ct, Tt), Ot(A, Ct), In(A, A, Tt), In(A, A, Gt), Jn(A, A), In(A, A, Ct), In(A, A, Gt), Ot(Ct = _ + 96 | 0, A), In(Ct, Ct, Tt), Tt = l[_ + 132 >> 2], l[_ + 84 >> 2] = Tt - $e, Ct = l[_ + 128 >> 2], l[_ + 80 >> 2] = Ct - we, Gt = l[_ + 124 >> 2], l[_ + 76 >> 2] = Gt - ye, Le = l[_ + 120 >> 2], l[_ + 72 >> 2] = Le - Be, Ge = l[_ + 116 >> 2], l[_ + 68 >> 2] = Ge - _e, je = l[_ + 112 >> 2], l[_ + 64 >> 2] = je - me, ct = l[_ + 108 >> 2], l[_ + 60 >> 2] = ct - D, mt = l[_ + 104 >> 2], l[_ + 56 >> 2] = mt - he, bt = l[_ + 100 >> 2], l[_ + 52 >> 2] = bt - ie, ht = l[_ + 96 >> 2], l[_ + 48 >> 2] = ht - U, Ei(_, _ + 48 | 0);
                      e: {
                        if (!le(_, 32)) {
                          if (l[_ + 36 >> 2] = Tt + $e, l[_ + 32 >> 2] = Ct + we, l[_ + 28 >> 2] = Gt + ye, l[_ + 24 >> 2] = Be + Le, l[_ + 20 >> 2] = _e + Ge, l[_ + 16 >> 2] = me + je, l[_ + 12 >> 2] = D + ct, l[_ + 8 >> 2] = he + mt, l[_ + 4 >> 2] = ie + bt, l[_ >> 2] = U + ht, Ei(Tt = _ + 288 | 0, _), !le(Tt, 32))
                            break e;
                          In(A, A, 1648);
                        }
                        Ei(_ + 288 | 0, A), (1 & j[_ + 288 | 0]) == (B[g + 31 | 0] >>> 7 | 0) && (l[A >> 2] = 0 - l[A >> 2], l[A + 36 >> 2] = 0 - l[A + 36 >> 2], l[A + 32 >> 2] = 0 - l[A + 32 >> 2], l[A + 28 >> 2] = 0 - l[A + 28 >> 2], l[A + 24 >> 2] = 0 - l[A + 24 >> 2], l[A + 20 >> 2] = 0 - l[A + 20 >> 2], l[A + 16 >> 2] = 0 - l[A + 16 >> 2], l[A + 12 >> 2] = 0 - l[A + 12 >> 2], l[A + 8 >> 2] = 0 - l[A + 8 >> 2], l[A + 4 >> 2] = 0 - l[A + 4 >> 2]), In(A + 120 | 0, A, b), en = 0;
                      }
                      return st = _ + 320 | 0, en;
                    }
                    function Zr(A, g, _) {
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0;
                      st = b = st - 128 | 0, l[A >> 2] = 1, l[A + 4 >> 2] = 0, l[A + 8 >> 2] = 0, l[A + 12 >> 2] = 0, l[A + 16 >> 2] = 0, l[A + 20 >> 2] = 0, l[A + 24 >> 2] = 0, l[A + 28 >> 2] = 0, l[A + 32 >> 2] = 0, l[A + 36 >> 2] = 0, l[A + 40 >> 2] = 1, Jt(A + 44 | 0, 0, 76), Yt(A, U = wr(g, 960) + 3008 | 0, (255 & (1 ^ (g = _ - ((_ >> 31 & _) << 1) | 0))) - 1 >>> 31 | 0), Yt(A, U + 120 | 0, (255 & (2 ^ g)) - 1 >>> 31 | 0), Yt(A, U + 240 | 0, (255 & (3 ^ g)) - 1 >>> 31 | 0), Yt(A, U + 360 | 0, (255 & (4 ^ g)) - 1 >>> 31 | 0), Yt(A, U + 480 | 0, (255 & (5 ^ g)) - 1 >>> 31 | 0), Yt(A, U + 600 | 0, (255 & (6 ^ g)) - 1 >>> 31 | 0), Yt(A, U + 720 | 0, (255 & (7 ^ g)) - 1 >>> 31 | 0), Yt(A, U + 840 | 0, (255 & (8 ^ g)) - 1 >>> 31 | 0), ie = l[A + 40 >> 2], he = l[A + 44 >> 2], D = l[A + 48 >> 2], me = l[A + 52 >> 2], _e = l[A + 56 >> 2], Be = l[A + 60 >> 2], ye = l[(g = A - -64 | 0) >> 2], U = l[g + 4 >> 2], g = l[A + 76 >> 2], l[b + 40 >> 2] = l[A + 72 >> 2], l[b + 44 >> 2] = g, l[b + 32 >> 2] = ye, l[b + 36 >> 2] = U, l[b + 24 >> 2] = _e, l[b + 28 >> 2] = Be, l[b + 16 >> 2] = D, l[b + 20 >> 2] = me, l[b + 8 >> 2] = ie, l[b + 12 >> 2] = he, ie = l[A + 8 >> 2], he = l[A + 12 >> 2], D = l[A + 16 >> 2], me = l[A + 20 >> 2], _e = l[A + 24 >> 2], Be = l[A + 28 >> 2], ye = l[A >> 2], U = l[A + 4 >> 2], g = l[A + 36 >> 2], l[b + 80 >> 2] = l[A + 32 >> 2], l[b + 84 >> 2] = g, l[b + 72 >> 2] = _e, l[b + 76 >> 2] = Be, l[(g = b - -64 | 0) >> 2] = D, l[g + 4 >> 2] = me, l[b + 56 >> 2] = ie, l[b + 60 >> 2] = he, l[b + 48 >> 2] = ye, l[b + 52 >> 2] = U, ie = l[A + 80 >> 2], he = l[A + 84 >> 2], D = l[A + 88 >> 2], me = l[A + 92 >> 2], _e = l[A + 96 >> 2], Be = l[A + 100 >> 2], ye = l[A + 104 >> 2], U = l[A + 108 >> 2], g = l[A + 112 >> 2], l[b + 124 >> 2] = 0 - l[A + 116 >> 2], l[b + 120 >> 2] = 0 - g, l[b + 116 >> 2] = 0 - U, l[b + 112 >> 2] = 0 - ye, l[b + 108 >> 2] = 0 - Be, l[b + 104 >> 2] = 0 - _e, l[b + 100 >> 2] = 0 - me, l[b + 96 >> 2] = 0 - D, l[b + 92 >> 2] = 0 - he, l[b + 88 >> 2] = 0 - ie, Yt(A, b + 8 | 0, (128 & _) >>> 7 | 0), st = b + 128 | 0;
                    }
                    function go(A) {
                      var g, _, b, U, ie, he, D, me, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0;
                      return st = g = st - 320 | 0, Ot(Be = g + 240 | 0, A), Ot(ye = g + 192 | 0, A + 40 | 0), Ot(_e = g + 144 | 0, A + 80 | 0), A = l[g + 240 >> 2], we = l[g + 192 >> 2], $e = l[g + 244 >> 2], Le = l[g + 196 >> 2], Ge = l[g + 248 >> 2], je = l[g + 200 >> 2], ct = l[g + 252 >> 2], mt = l[g + 204 >> 2], bt = l[g + 256 >> 2], ht = l[g + 208 >> 2], Ct = l[g + 260 >> 2], Tt = l[g + 212 >> 2], Gt = l[g + 264 >> 2], en = l[g + 216 >> 2], it = l[g + 268 >> 2], St = l[g + 220 >> 2], Ft = l[g + 272 >> 2], fn = l[g + 224 >> 2], l[g + 84 >> 2] = l[g + 228 >> 2] - l[g + 276 >> 2], l[g + 80 >> 2] = fn - Ft, l[g + 76 >> 2] = St - it, l[g + 72 >> 2] = en - Gt, l[g + 68 >> 2] = Tt - Ct, l[g + 64 >> 2] = ht - bt, l[g + 60 >> 2] = mt - ct, l[g + 56 >> 2] = je - Ge, l[g + 52 >> 2] = Le - $e, l[g + 48 >> 2] = we - A, In(A = g + 48 | 0, A, _e), In(g, Be, ye), In(g, g, 1600), Ot(g + 96 | 0, _e), _e = l[g + 48 >> 2], Be = l[g + 96 >> 2], ye = l[g >> 2], we = l[g + 52 >> 2], $e = l[g + 100 >> 2], Le = l[g + 4 >> 2], Ge = l[g + 56 >> 2], je = l[g + 104 >> 2], ct = l[g + 8 >> 2], mt = l[g + 60 >> 2], bt = l[g + 108 >> 2], ht = l[g + 12 >> 2], Ct = l[g + 64 >> 2], Tt = l[g + 112 >> 2], Gt = l[g + 16 >> 2], en = l[g + 68 >> 2], it = l[g + 116 >> 2], St = l[g + 20 >> 2], Ft = l[g + 72 >> 2], fn = l[g + 120 >> 2], _ = l[g + 24 >> 2], b = l[g + 76 >> 2], U = l[g + 124 >> 2], ie = l[g + 28 >> 2], he = l[g + 80 >> 2], D = l[g + 128 >> 2], me = l[g + 32 >> 2], l[g + 84 >> 2] = l[g + 84 >> 2] - (l[g + 132 >> 2] + l[g + 36 >> 2] | 0), l[g + 80 >> 2] = he - (D + me | 0), l[g + 76 >> 2] = b - (U + ie | 0), l[g + 72 >> 2] = Ft - (fn + _ | 0), l[g + 68 >> 2] = en - (it + St | 0), l[g + 64 >> 2] = Ct - (Tt + Gt | 0), l[g + 60 >> 2] = mt - (bt + ht | 0), l[g + 56 >> 2] = Ge - (je + ct | 0), l[g + 52 >> 2] = we - ($e + Le | 0), l[g + 48 >> 2] = _e - (Be + ye | 0), Ei(_e = g + 288 | 0, A), A = le(_e, 32), st = g + 320 | 0, A;
                    }
                    function to(A, g, _, b) {
                      var U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0;
                      if (_ | b)
                        e:
                          for (Be = A + 224 | 0, me = A + 96 | 0, ie = B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24; ; ) {
                            if (U = ie + me | 0, !b & _ >>> 0 <= (he = 256 - ie | 0) >>> 0) {
                              xr(U, g, _), g = (B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24) + _ | 0, j[A + 352 | 0] = g, j[A + 353 | 0] = g >>> 8, j[A + 354 | 0] = g >>> 16, j[A + 355 | 0] = g >>> 24;
                              break e;
                            }
                            if (xr(U, g, he), U = (B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24) + he | 0, j[A + 352 | 0] = U, j[A + 353 | 0] = U >>> 8, j[A + 354 | 0] = U >>> 16, j[A + 355 | 0] = U >>> 24, _e = ie = B[A + 68 | 0] | B[A + 69 | 0] << 8 | B[A + 70 | 0] << 16 | B[A + 71 | 0] << 24, ie = (D = 128 + (U = B[A + 64 | 0] | B[A + 65 | 0] << 8 | B[A + 66 | 0] << 16 | B[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? ie + 1 | 0 : ie, j[A + 64 | 0] = D, j[A + 65 | 0] = D >>> 8, j[A + 66 | 0] = D >>> 16, j[A + 67 | 0] = D >>> 24, j[A + 68 | 0] = ie, j[A + 69 | 0] = ie >>> 8, j[A + 70 | 0] = ie >>> 16, j[A + 71 | 0] = ie >>> 24, ie = B[A + 76 | 0] | B[A + 77 | 0] << 8 | B[A + 78 | 0] << 16 | B[A + 79 | 0] << 24, ie = (_e = U = (0 | _e) == -1 & U >>> 0 > 4294967167) >>> 0 > (U = U + (B[A + 72 | 0] | B[A + 73 | 0] << 8 | B[A + 74 | 0] << 16 | B[A + 75 | 0] << 24) | 0) >>> 0 ? ie + 1 | 0 : ie, j[A + 72 | 0] = U, j[A + 73 | 0] = U >>> 8, j[A + 74 | 0] = U >>> 16, j[A + 75 | 0] = U >>> 24, j[A + 76 | 0] = ie, j[A + 77 | 0] = ie >>> 8, j[A + 78 | 0] = ie >>> 16, j[A + 79 | 0] = ie >>> 24, $s(A, me), xr(me, Be, 128), U = ie = (B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24) - 128 | 0, j[A + 352 | 0] = U, j[A + 353 | 0] = U >>> 8, j[A + 354 | 0] = U >>> 16, j[A + 355 | 0] = U >>> 24, g = g + he | 0, !((b = b - (_ >>> 0 < he >>> 0) | 0) | (_ = _ - he | 0)))
                              break;
                          }
                      return 0;
                    }
                    function Bo(A) {
                      var g = 0, _ = 0, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0;
                      for (_ = l[A + 60 >> 2], je = l[A + 56 >> 2], Ge = l[A + 52 >> 2], $e = l[A + 48 >> 2], g = l[A + 44 >> 2], b = l[A + 40 >> 2], ct = l[A + 36 >> 2], we = l[A + 32 >> 2], U = l[A + 28 >> 2], ie = l[A + 24 >> 2], he = l[A + 20 >> 2], D = l[A + 16 >> 2], me = l[A + 12 >> 2], _e = l[A + 8 >> 2], Be = l[A + 4 >> 2], ye = l[A >> 2]; Le = tn(he + Be | 0, 7) ^ ct, mt = tn(Le + he | 0, 9) ^ Ge, D = tn(ye + $e | 0, 7) ^ D, bt = tn(D + ye | 0, 9) ^ we, ht = tn(bt + D | 0, 13) ^ $e, me = tn(g + _ | 0, 7) ^ me, U = tn(me + _ | 0, 9) ^ U, we = tn(U + me | 0, 13) ^ g, _ = tn(U + we | 0, 18) ^ _, g = tn(b + ie | 0, 7) ^ je, $e = ht ^ tn(_ + g | 0, 7), Ge = mt ^ tn($e + _ | 0, 9), je = tn($e + Ge | 0, 13) ^ g, _ = tn(Ge + je | 0, 18) ^ _, _e = tn(g + b | 0, 9) ^ _e, ie = tn(_e + g | 0, 13) ^ ie, b = tn(ie + _e | 0, 18) ^ b, g = tn(b + Le | 0, 7) ^ we, we = tn(g + b | 0, 9) ^ bt, ct = tn(g + we | 0, 13) ^ Le, b = tn(we + ct | 0, 18) ^ b, Be = tn(Le + mt | 0, 13) ^ Be, he = tn(Be + mt | 0, 18) ^ he, ie = tn(he + D | 0, 7) ^ ie, U = tn(ie + he | 0, 9) ^ U, D = tn(U + ie | 0, 13) ^ D, he = tn(D + U | 0, 18) ^ he, ye = tn(bt + ht | 0, 18) ^ ye, Be = tn(ye + me | 0, 7) ^ Be, _e = tn(Be + ye | 0, 9) ^ _e, me = tn(_e + Be | 0, 13) ^ me, ye = tn(me + _e | 0, 18) ^ ye, Le = Ct >>> 0 < 6, Ct = Ct + 2 | 0, Le; )
                        ;
                      l[A >> 2] = l[A >> 2] + ye, l[A + 4 >> 2] = l[A + 4 >> 2] + Be, l[A + 8 >> 2] = l[A + 8 >> 2] + _e, l[A + 12 >> 2] = l[A + 12 >> 2] + me, l[A + 16 >> 2] = l[A + 16 >> 2] + D, l[A + 20 >> 2] = l[A + 20 >> 2] + he, l[A + 24 >> 2] = l[A + 24 >> 2] + ie, l[A + 28 >> 2] = l[A + 28 >> 2] + U, l[A + 32 >> 2] = l[A + 32 >> 2] + we, l[A + 36 >> 2] = l[A + 36 >> 2] + ct, l[A + 40 >> 2] = l[A + 40 >> 2] + b, l[A + 44 >> 2] = l[A + 44 >> 2] + g, l[A + 48 >> 2] = l[A + 48 >> 2] + $e, l[A + 52 >> 2] = l[A + 52 >> 2] + Ge, l[A + 56 >> 2] = l[A + 56 >> 2] + je, l[A + 60 >> 2] = l[A + 60 >> 2] + _;
                    }
                    function zo(A, g, _, b) {
                      var U, ie = 0;
                      return st = U = st - 320 | 0, ie = -1, de(_) && (Qe(_) || ds(U, _) || ga(U) && (j[0 | A] = B[0 | g], j[A + 1 | 0] = B[g + 1 | 0], j[A + 2 | 0] = B[g + 2 | 0], j[A + 3 | 0] = B[g + 3 | 0], j[A + 4 | 0] = B[g + 4 | 0], j[A + 5 | 0] = B[g + 5 | 0], j[A + 6 | 0] = B[g + 6 | 0], j[A + 7 | 0] = B[g + 7 | 0], j[A + 8 | 0] = B[g + 8 | 0], j[A + 9 | 0] = B[g + 9 | 0], j[A + 10 | 0] = B[g + 10 | 0], j[A + 11 | 0] = B[g + 11 | 0], j[A + 12 | 0] = B[g + 12 | 0], j[A + 13 | 0] = B[g + 13 | 0], j[A + 14 | 0] = B[g + 14 | 0], j[A + 15 | 0] = B[g + 15 | 0], j[A + 16 | 0] = B[g + 16 | 0], j[A + 17 | 0] = B[g + 17 | 0], j[A + 18 | 0] = B[g + 18 | 0], j[A + 19 | 0] = B[g + 19 | 0], j[A + 20 | 0] = B[g + 20 | 0], j[A + 21 | 0] = B[g + 21 | 0], j[A + 22 | 0] = B[g + 22 | 0], j[A + 23 | 0] = B[g + 23 | 0], j[A + 24 | 0] = B[g + 24 | 0], j[A + 25 | 0] = B[g + 25 | 0], j[A + 26 | 0] = B[g + 26 | 0], j[A + 27 | 0] = B[g + 27 | 0], j[A + 28 | 0] = B[g + 28 | 0], j[A + 29 | 0] = B[g + 29 | 0], j[A + 30 | 0] = B[g + 30 | 0], _ = B[g + 31 | 0], b && (j[0 | A] = 248 & B[0 | A], _ |= 64), j[A + 31 | 0] = 127 & _, Zs(_ = U + 160 | 0, A, U), kr(A, _), (127 & B[A + 31 | 0] | B[A + 30 | 0] | B[A + 29 | 0] | B[A + 28 | 0] | B[A + 27 | 0] | B[A + 26 | 0] | B[A + 25 | 0] | B[A + 24 | 0] | B[A + 23 | 0] | B[A + 22 | 0] | B[A + 21 | 0] | B[A + 20 | 0] | B[A + 19 | 0] | B[A + 18 | 0] | B[A + 17 | 0] | B[A + 16 | 0] | B[A + 15 | 0] | B[A + 14 | 0] | B[A + 13 | 0] | B[A + 12 | 0] | B[A + 11 | 0] | B[A + 10 | 0] | B[A + 9 | 0] | B[A + 8 | 0] | B[A + 7 | 0] | B[A + 6 | 0] | B[A + 5 | 0] | B[A + 4 | 0] | B[A + 3 | 0] | B[A + 2 | 0] | B[A + 1 | 0] | 1 ^ B[0 | A]) - 1 & 256 || (ie = le(g, 32) ? -1 : 0))), st = U + 320 | 0, ie;
                    }
                    function Ko(A, g, _, b, U) {
                      var ie, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0;
                      if (st = ie = st - 48 | 0, U && jn(U, 102), !(B[0 | b] != 36 | B[b + 1 | 0] != 55 | B[b + 2 | 0] != 36) && (ye = ot(B[b + 3 | 0])) && (he = xt(ie + 12 | 0, b + 4 | 0)) && (_e = xt(ie + 8 | 0, he))) {
                        for (me = gn(_e) + 1 | 0; he = 0, me && B[0 | (he = _e + (me = me - 1 | 0) | 0)] != 36; )
                          ;
                        if (D = he - _e | 0, he || (D = gn(_e)), !((D = 45 + (me = (he = D) + (_e - b | 0) | 0) | 0) >>> 0 > 102 | he >>> 0 > D >>> 0 || (D = A, we = g, $e = _, A = 31 & (ye = ye - 1024 | 0), (63 & ye) >>> 0 >= 32 ? (g = 1 << A, _ = 0) : g = (_ = 1 << A) - 1 & 1 >>> 32 - A, Gs(D, we, $e, _e, he, _, g, l[ie + 12 >> 2], l[ie + 8 >> 2], ie + 16 | 0, 32)))) {
                          for (_e = xr(U, b, me), j[0 | (A = _e + me | 0)] = 36, Be = (ye = _e + 102 | 0) - (U = A + 1 | 0) | 0, _ = 0; ; ) {
                            e:
                              if (A = U, (g = _) >>> 0 > 31)
                                b = A;
                              else if (_ = (me = g + 1 | 0) + (D = (_ = 31 - g | 0) >>> 0 >= 2 ? 2 : _) | 0, b = 0, he = 0, U = B[g + (ie + 16 | 0) | 0], D && (U = B[me + (ie + 16 | 0) | 0] << 8 | U, (0 | (g = g + 2 | 0)) != (0 | _) && (he = 1, U = B[g + (ie + 16 | 0) | 0] << 16 | U)), Be && (j[0 | A] = B[1024 + (63 & U) | 0], (0 | Be) != 1)) {
                                if (j[A + 1 | 0] = B[1024 + (U >>> 6 & 63) | 0], D = A + Be | 0, g = A + 2 | 0, (0 | _) != (0 | me)) {
                                  if ((0 | Be) == 2)
                                    break e;
                                  if (j[A + 2 | 0] = B[1024 + (U >>> 12 & 63) | 0], g = A + 3 | 0, he) {
                                    if ((0 | Be) == 3)
                                      break e;
                                    j[A + 3 | 0] = B[1024 + (U >>> 18 | 0) | 0], g = A + 4 | 0;
                                  }
                                }
                                if (Be = D - (U = g) | 0, U)
                                  continue;
                              }
                            break;
                          }
                          Wr(ie + 16 | 0, 32), Be = 0, !b | b >>> 0 >= ye >>> 0 || (j[0 | b] = 0, Be = _e);
                        }
                      }
                      return st = ie + 48 | 0, Be;
                    }
                    function hs(A, g, _) {
                      var b, U, ie, he = 0, D = 0, me = 0, _e = 0;
                      st = b = st - 16 | 0, U = l[A + 20 >> 2], l[A + 20 >> 2] = 0, ie = l[A + 4 >> 2], l[A + 4 >> 2] = 0, he = -26;
                      e: {
                        t: {
                          n: {
                            r:
                              switch (_ - 1 | 0) {
                                case 1:
                                  if (he = -32, Dt(g, 1165, 9))
                                    break e;
                                  g = g + 9 | 0;
                                  break n;
                                case 0:
                                  break r;
                                default:
                                  break e;
                              }
                            if (he = -32, Dt(g, 1156, 8))
                              break e;
                            g = g + 8 | 0;
                          }
                          if (!((he = Dt(g, 1422, 3)) || (_ = g + 3 | 0, ((me = B[0 | (D = he ? g : _)]) - 58 & 255) >>> 0 < 246))) {
                            for (g = 0, he = me; ; ) {
                              if (_e = _, g >>> 0 > 429496729 || (_ = (255 & he) - 48 | 0) >>> 0 > (-1 ^ (g = wr(g, 10))) >>> 0)
                                break t;
                              if (g = g + _ | 0, !(((he = B[0 | (_ = _e + 1 | 0)]) - 58 & 255) >>> 0 > 245))
                                break;
                            }
                            if (!((0 | me) == 48 & (0 | _e) != (0 | D) | (0 | _) == (0 | D))) {
                              if (he = -26, (0 | g) != 19)
                                break e;
                              if (!Dt(_, 1434, 3) && (g = rt(_e + 4 | 0, b + 12 | 0)) && (l[A + 44 >> 2] = l[b + 12 >> 2], !Dt(g, 1426, 3) && (g = rt(g + 3 | 0, b + 12 | 0)) && (l[A + 40 >> 2] = l[b + 12 >> 2], !Dt(g, 1430, 3) && (g = rt(g + 3 | 0, b + 12 | 0)) && (_ = l[b + 12 >> 2], l[A + 48 >> 2] = _, l[A + 52 >> 2] = _, B[0 | g] == 36 && (l[b + 12 >> 2] = U, g = g + 1 | 0, !vt(l[A + 16 >> 2], U, g, gn(g), 0, b + 12 | 0, b + 8 | 0, 3) && (l[A + 20 >> 2] = l[b + 12 >> 2], g = l[b + 8 >> 2], B[0 | g] == 36 && (l[b + 12 >> 2] = ie, g = g + 1 | 0, !vt(l[A >> 2], ie, g, gn(g), 0, b + 12 | 0, b + 8 | 0, 3)))))))) {
                                if (l[A + 4 >> 2] = l[b + 12 >> 2], g = l[b + 8 >> 2], he = Na(A))
                                  break e;
                                he = B[0 | g] ? -32 : 0;
                                break e;
                              }
                            }
                          }
                        }
                        he = -32;
                      }
                      return st = b + 16 | 0, he;
                    }
                    function Bi(A, g) {
                      var _, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0;
                      b = l[g + 40 >> 2], U = l[g + 4 >> 2], ie = l[g + 44 >> 2], he = l[g + 8 >> 2], D = l[g + 48 >> 2], me = l[g + 12 >> 2], _e = l[g + 52 >> 2], Be = l[g + 16 >> 2], ye = l[g + 56 >> 2], $e = l[g + 20 >> 2], Le = l[g + 60 >> 2], Ge = l[g + 24 >> 2], je = l[(we = g - -64 | 0) >> 2], ct = l[g + 28 >> 2], mt = l[g + 68 >> 2], bt = l[g + 32 >> 2], ht = l[g + 72 >> 2], _ = l[g >> 2], l[A + 36 >> 2] = l[g + 36 >> 2] + l[g + 76 >> 2], l[A + 32 >> 2] = bt + ht, l[A + 28 >> 2] = ct + mt, l[A + 24 >> 2] = Ge + je, l[A + 20 >> 2] = $e + Le, l[A + 16 >> 2] = Be + ye, l[A + 12 >> 2] = me + _e, l[A + 8 >> 2] = he + D, l[A + 4 >> 2] = U + ie, l[A >> 2] = b + _, b = l[g + 40 >> 2], U = l[g + 4 >> 2], ie = l[g + 44 >> 2], he = l[g + 8 >> 2], D = l[g + 48 >> 2], me = l[g + 12 >> 2], _e = l[g + 52 >> 2], Be = l[g + 16 >> 2], ye = l[g + 56 >> 2], $e = l[g + 20 >> 2], Le = l[g + 60 >> 2], Ge = l[g + 24 >> 2], we = l[we >> 2], je = l[g + 28 >> 2], ct = l[g + 68 >> 2], mt = l[g + 32 >> 2], bt = l[g + 72 >> 2], ht = l[g >> 2], l[A + 76 >> 2] = l[g + 76 >> 2] - l[g + 36 >> 2], l[A + 72 >> 2] = bt - mt, l[A + 68 >> 2] = ct - je, l[A - -64 >> 2] = we - Ge, l[A + 60 >> 2] = Le - $e, l[A + 56 >> 2] = ye - Be, l[A + 52 >> 2] = _e - me, l[A + 48 >> 2] = D - he, l[A + 44 >> 2] = ie - U, l[A + 40 >> 2] = b - ht, b = l[g + 80 >> 2], U = l[g + 84 >> 2], ie = l[g + 88 >> 2], he = l[g + 92 >> 2], D = l[g + 96 >> 2], me = l[g + 100 >> 2], _e = l[g + 104 >> 2], Be = l[g + 108 >> 2], ye = l[g + 116 >> 2], l[A + 112 >> 2] = l[g + 112 >> 2], l[A + 116 >> 2] = ye, l[A + 104 >> 2] = _e, l[A + 108 >> 2] = Be, l[A + 96 >> 2] = D, l[A + 100 >> 2] = me, l[A + 88 >> 2] = ie, l[A + 92 >> 2] = he, l[A + 80 >> 2] = b, l[A + 84 >> 2] = U, In(A + 120 | 0, g + 120 | 0, 1696);
                    }
                    function Va(A, g, _) {
                      var b, U = 0;
                      return st = b = st - 160 | 0, j[0 | A] = B[0 | g], j[A + 1 | 0] = B[g + 1 | 0], j[A + 2 | 0] = B[g + 2 | 0], j[A + 3 | 0] = B[g + 3 | 0], j[A + 4 | 0] = B[g + 4 | 0], j[A + 5 | 0] = B[g + 5 | 0], j[A + 6 | 0] = B[g + 6 | 0], j[A + 7 | 0] = B[g + 7 | 0], j[A + 8 | 0] = B[g + 8 | 0], j[A + 9 | 0] = B[g + 9 | 0], j[A + 10 | 0] = B[g + 10 | 0], j[A + 11 | 0] = B[g + 11 | 0], j[A + 12 | 0] = B[g + 12 | 0], j[A + 13 | 0] = B[g + 13 | 0], j[A + 14 | 0] = B[g + 14 | 0], j[A + 15 | 0] = B[g + 15 | 0], j[A + 16 | 0] = B[g + 16 | 0], j[A + 17 | 0] = B[g + 17 | 0], j[A + 18 | 0] = B[g + 18 | 0], j[A + 19 | 0] = B[g + 19 | 0], j[A + 20 | 0] = B[g + 20 | 0], j[A + 21 | 0] = B[g + 21 | 0], j[A + 22 | 0] = B[g + 22 | 0], j[A + 23 | 0] = B[g + 23 | 0], j[A + 24 | 0] = B[g + 24 | 0], j[A + 25 | 0] = B[g + 25 | 0], j[A + 26 | 0] = B[g + 26 | 0], j[A + 27 | 0] = B[g + 27 | 0], j[A + 28 | 0] = B[g + 28 | 0], j[A + 29 | 0] = B[g + 29 | 0], j[A + 30 | 0] = B[g + 30 | 0], U = B[g + 31 | 0], _ && (j[0 | A] = 248 & B[0 | A], U |= 64), j[A + 31 | 0] = 127 & U, Os(b, A), kr(A, b), _ = -1, (127 & B[A + 31 | 0] | B[A + 30 | 0] | B[A + 29 | 0] | B[A + 28 | 0] | B[A + 27 | 0] | B[A + 26 | 0] | B[A + 25 | 0] | B[A + 24 | 0] | B[A + 23 | 0] | B[A + 22 | 0] | B[A + 21 | 0] | B[A + 20 | 0] | B[A + 19 | 0] | B[A + 18 | 0] | B[A + 17 | 0] | B[A + 16 | 0] | B[A + 15 | 0] | B[A + 14 | 0] | B[A + 13 | 0] | B[A + 12 | 0] | B[A + 11 | 0] | B[A + 10 | 0] | B[A + 9 | 0] | B[A + 8 | 0] | B[A + 7 | 0] | B[A + 6 | 0] | B[A + 5 | 0] | B[A + 4 | 0] | B[A + 3 | 0] | B[A + 2 | 0] | B[A + 1 | 0] | 1 ^ B[0 | A]) - 1 & 256 || (_ = le(g, 32) ? -1 : 0), st = b + 160 | 0, _;
                    }
                    function Fa(A, g) {
                      var _, b, U, ie, he, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0;
                      (_e = l[A + 56 >> 2]) | (D = l[A + 60 >> 2]) && (j[_e + (me = A - -64 | 0) | 0] = 1, !((je = _e + 1 | 0) ? D : D + 1 | 0) & je >>> 0 <= 15 && Jt(65 + (A + _e | 0) | 0, 0, 15 - _e | 0), j[A + 80 | 0] = 1, Xs(A, me, 16, 0)), je = l[A + 52 >> 2], Le = l[A + 48 >> 2], me = l[A + 44 >> 2], _e = l[A + 24 >> 2], ye = l[A + 28 >> 2] + (_e >>> 26 | 0) | 0, Be = l[A + 32 >> 2] + (ye >>> 26 | 0) | 0, _ = l[A + 36 >> 2] + (Be >>> 26 | 0) | 0, D = ($e = (_e = (_e = (67108863 & _e) + ((we = l[A + 20 >> 2] + wr(_ >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (ye = (Be = (he = (67108863 & _) + ((ie = (b = 67108863 & Be) + ((U = (Ge = 67108863 & ye) + ((we = _e + ((D = 5 + ($e = 67108863 & we) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | we & (Be = 67108863 & (we = (Be >>> 31 | 0) - 1 | 0))) << 26 | D & Be | ye & $e) + l[A + 40 >> 2] | 0, j[0 | g] = D, j[g + 1 | 0] = D >>> 8, j[g + 2 | 0] = D >>> 16, j[g + 3 | 0] = D >>> 24, $e = D >>> 0 < $e >>> 0, D = (Ge = ye & Ge | Be & U) << 20 | _e >>> 6, _e = 0, D = (me = D + me | 0) >>> 0 < D >>> 0 ? 1 : _e, D = (_e = me + $e | 0) >>> 0 < me >>> 0 ? D + 1 | 0 : D, j[(me = g) + 4 | 0] = _e, j[me + 5 | 0] = _e >>> 8, j[me + 6 | 0] = _e >>> 16, j[me + 7 | 0] = _e >>> 24, _e = 0, me = (me = (Be = ye & b | Be & ie) << 14 | Ge >>> 12) >>> 0 > (Le = me + Le | 0) >>> 0 ? 1 : _e, _e = Le, Le = D, _e = (D = _e + D | 0) >>> 0 < Le >>> 0 ? me + 1 | 0 : me, j[(me = g) + 8 | 0] = D, j[me + 9 | 0] = D >>> 8, j[me + 10 | 0] = D >>> 16, j[me + 11 | 0] = D >>> 24, D = me = (we & he | ye & _) << 8 | Be >>> 18, D = (D = _e) + (me = me + je | 0) | 0, j[g + 12 | 0] = D, j[g + 13 | 0] = D >>> 8, j[g + 14 | 0] = D >>> 16, j[g + 15 | 0] = D >>> 24, Wr(A, 88);
                    }
                    function Ja(A, g, _, b, U) {
                      var ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0;
                      e: {
                        if ((0 | b) == 1 | b >>> 0 > 1)
                          l[9129] = 22;
                        else {
                          st = b = st - 128 | 0, l[b + 56 >> 2] = 0, l[b + 48 >> 2] = 0, l[b + 52 >> 2] = 0, l[b + 40 >> 2] = 0, l[b + 44 >> 2] = 0, l[b + 32 >> 2] = 0, l[b + 36 >> 2] = 0, l[b + 24 >> 2] = 0, l[b + 28 >> 2] = 0, l[b + 16 >> 2] = 0, l[b + 20 >> 2] = 0, l[b + 8 >> 2] = 0, l[b + 12 >> 2] = 0, ie = gn(A), l[b + 20 >> 2] = ie, l[b + 36 >> 2] = ie, l[b + 4 >> 2] = ie, he = Qi(ie), l[b + 32 >> 2] = he, D = Qi(ie), l[b + 16 >> 2] = D, me = Qi(ie), l[b >> 2] = me;
                          t:
                            if (!me | !he | !D || !(_e = Qi(ie)))
                              wi(he), wi(D), wi(me), he = -22;
                            else {
                              if (he = hs(b, A, U)) {
                                wi(l[b + 32 >> 2]), wi(l[b + 16 >> 2]), wi(l[b >> 2]), wi(_e);
                                break t;
                              }
                              he = l[b + 20 >> 2], me = l[b + 16 >> 2], D = l[b + 52 >> 2], Be = l[b + 44 >> 2], ye = l[b + 40 >> 2], jn(_e, ie = l[b + 4 >> 2]);
                              n: {
                                r: {
                                  if (A = Qi(ie)) {
                                    if (l[b + 96 >> 2] = 0, l[b + 100 >> 2] = 0, l[b + 88 >> 2] = 0, l[b + 92 >> 2] = 0, l[b + 84 >> 2] = he, l[b + 80 >> 2] = me, l[b + 76 >> 2] = _, l[b + 72 >> 2] = g, l[b + 68 >> 2] = ie, l[b + 64 >> 2] = A, he = 0, l[b + 120 >> 2] = 0, l[b + 116 >> 2] = D, l[b + 112 >> 2] = D, l[b + 108 >> 2] = Be, l[b + 104 >> 2] = ye, !js(b - -64 | 0, U)) {
                                      if (g = xr(_e, A, ie), Wr(A, ie), wi(A), wi(l[b + 32 >> 2]), wi(l[b + 16 >> 2]), Ie(g, l[b >> 2], l[b + 4 >> 2]))
                                        break r;
                                      break n;
                                    }
                                    Wr(A, ie), wi(A);
                                  }
                                  wi(l[b + 32 >> 2]), wi(l[b + 16 >> 2]);
                                }
                                he = -35;
                              }
                              wi(_e), wi(l[b >> 2]);
                            }
                          if (st = b + 128 | 0, g = he, !he)
                            break e;
                          (0 | g) == -35 && (l[9129] = 28);
                        }
                        g = -1;
                      }
                      return g;
                    }
                    function ls(A, g, _) {
                      A |= 0, g |= 0, _ |= 0;
                      var b, U = 0;
                      return st = b = st - 16 | 0, j[b + 15 | 0] = 0, U = -1, 0 | Xi[l[8930]](A, g, _) || (j[b + 15 | 0] = B[0 | A] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 1 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 2 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 3 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 4 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 5 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 6 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 7 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 8 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 9 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 10 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 11 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 12 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 13 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 14 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 15 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 16 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 17 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 18 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 19 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 20 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 21 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 22 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 23 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 24 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 25 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 26 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 27 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 28 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 29 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 30 | 0] | B[b + 15 | 0], j[b + 15 | 0] = B[A + 31 | 0] | B[b + 15 | 0], U = (B[b + 15 | 0] << 23) - 8388608 >> 31), st = b + 16 | 0, 0 | U;
                    }
                    function Ei(A, g) {
                      var _, b, U, ie, he, D, me, _e = 0, Be = 0;
                      b = l[g + 32 >> 2], U = l[g + 28 >> 2], ie = l[g + 24 >> 2], he = l[g + 20 >> 2], D = l[g + 16 >> 2], me = l[g + 12 >> 2], _e = l[g + 4 >> 2], Be = l[g >> 2], _ = l[g + 36 >> 2], g = l[g + 8 >> 2], Be = wr((b + (U + (ie + (he + (D + (me + ((_e + (Be + (wr(_, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + g >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + _ >> 25, 19) + Be | 0, j[0 | A] = Be, j[A + 2 | 0] = Be >>> 16, j[A + 1 | 0] = Be >>> 8, _e = _e + (Be >> 26) | 0, j[A + 5 | 0] = _e >>> 14, j[A + 4 | 0] = _e >>> 6, j[A + 3 | 0] = Be >>> 24 & 3 | _e << 2, g = g + (_e >> 25) | 0, j[A + 8 | 0] = g >>> 13, j[A + 7 | 0] = g >>> 5, j[A + 6 | 0] = g << 3 | (29360128 & _e) >>> 22, Be = (g >> 26) + me | 0, j[A + 11 | 0] = Be >>> 11, j[A + 10 | 0] = Be >>> 3, j[A + 9 | 0] = Be << 5 | (65011712 & g) >>> 21, _e = (Be >> 25) + D | 0, j[A + 15 | 0] = _e >>> 18, j[A + 14 | 0] = _e >>> 10, j[A + 13 | 0] = _e >>> 2, g = (_e >> 26) + he | 0, j[A + 16 | 0] = g, j[A + 12 | 0] = _e << 6 | (33030144 & Be) >>> 19, j[A + 18 | 0] = g >>> 16, j[A + 17 | 0] = g >>> 8, _e = (g >> 25) + ie | 0, j[A + 21 | 0] = _e >>> 15, j[A + 20 | 0] = _e >>> 7, j[A + 19 | 0] = g >>> 24 & 1 | _e << 1, g = (_e >> 26) + U | 0, j[A + 24 | 0] = g >>> 13, j[A + 23 | 0] = g >>> 5, j[A + 22 | 0] = g << 3 | (58720256 & _e) >>> 23, _e = (g >> 25) + b | 0, j[A + 27 | 0] = _e >>> 12, j[A + 26 | 0] = _e >>> 4, j[A + 25 | 0] = _e << 4 | (31457280 & g) >>> 21, g = _ + (_e >> 26) | 0, j[A + 30 | 0] = g >>> 10, j[A + 29 | 0] = g >>> 2, j[A + 31 | 0] = (33292288 & g) >>> 18, j[A + 28 | 0] = g << 6 | (66060288 & _e) >>> 20;
                    }
                    function Yo(A, g, _) {
                      A |= 0, g |= 0;
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0;
                      if (st = b = st - 192 | 0, (_ |= 0) >>> 0 >= 129 && (ae(A), Di(A, g, _, 0), Ui(A, b), _ = 64, g = b), ae(A), Jt(b - -64 | 0, 54, 128), _) {
                        if (_ >>> 0 >= 4)
                          for (Be = 252 & _; j[0 | (U = (he = b - -64 | 0) + ie | 0)] = B[0 | U] ^ B[g + ie | 0], j[0 | (D = (U = 1 | ie) + he | 0)] = B[0 | D] ^ B[g + U | 0], j[0 | (D = (U = 2 | ie) + he | 0)] = B[0 | D] ^ B[g + U | 0], j[0 | (U = (U = he) + (he = 3 | ie) | 0)] = B[0 | U] ^ B[g + he | 0], ie = ie + 4 | 0, (0 | Be) != (0 | (me = me + 4 | 0)); )
                            ;
                        if (me = 3 & _)
                          for (; j[0 | (he = (b - -64 | 0) + ie | 0)] = B[0 | he] ^ B[g + ie | 0], ie = ie + 1 | 0, (0 | me) != (0 | (_e = _e + 1 | 0)); )
                            ;
                      }
                      if (Di(A, ie = b - -64 | 0, 128, 0), ae(he = A + 208 | 0), Jt(ie, 92, 128), _) {
                        if (_e = 0, ie = 0, _ >>> 0 >= 4)
                          for (Be = 252 & _, me = 0; j[0 | (U = (A = b - -64 | 0) + ie | 0)] = B[0 | U] ^ B[g + ie | 0], j[0 | (D = (U = 1 | ie) + A | 0)] = B[0 | D] ^ B[g + U | 0], j[0 | (D = (U = 2 | ie) + A | 0)] = B[0 | D] ^ B[g + U | 0], j[0 | (U = (U = A) + (A = 3 | ie) | 0)] = B[0 | U] ^ B[A + g | 0], ie = ie + 4 | 0, (0 | Be) != (0 | (me = me + 4 | 0)); )
                            ;
                        if (A = 3 & _)
                          for (; j[0 | (_ = (b - -64 | 0) + ie | 0)] = B[0 | _] ^ B[g + ie | 0], ie = ie + 1 | 0, (0 | A) != (0 | (_e = _e + 1 | 0)); )
                            ;
                      }
                      return Di(he, A = b - -64 | 0, 128, 0), Wr(A, 128), Wr(b, 64), st = b + 192 | 0, 0;
                    }
                    function Wa(A, g) {
                      var _, b = 0, U = 0;
                      st = _ = st - 48 | 0, b = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, U = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, j[A + 24 | 0] = U, j[A + 25 | 0] = U >>> 8, j[A + 26 | 0] = U >>> 16, j[A + 27 | 0] = U >>> 24, j[A + 28 | 0] = b, j[A + 29 | 0] = b >>> 8, j[A + 30 | 0] = b >>> 16, j[A + 31 | 0] = b >>> 24, b = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24, U = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24, j[0 | A] = U, j[A + 1 | 0] = U >>> 8, j[A + 2 | 0] = U >>> 16, j[A + 3 | 0] = U >>> 24, j[A + 4 | 0] = b, j[A + 5 | 0] = b >>> 8, j[A + 6 | 0] = b >>> 16, j[A + 7 | 0] = b >>> 24, b = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, U = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, j[A + 16 | 0] = U, j[A + 17 | 0] = U >>> 8, j[A + 18 | 0] = U >>> 16, j[A + 19 | 0] = U >>> 24, j[A + 20 | 0] = b, j[A + 21 | 0] = b >>> 8, j[A + 22 | 0] = b >>> 16, j[A + 23 | 0] = b >>> 24, b = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, g = B[g + 8 | 0] | B[g + 9 | 0] << 8 | B[g + 10 | 0] << 16 | B[g + 11 | 0] << 24, j[A + 8 | 0] = g, j[A + 9 | 0] = g >>> 8, j[A + 10 | 0] = g >>> 16, j[A + 11 | 0] = g >>> 24, j[A + 12 | 0] = b, j[A + 13 | 0] = b >>> 8, j[A + 14 | 0] = b >>> 16, j[A + 15 | 0] = b >>> 24, g = B[A + 31 | 0], j[A + 31 | 0] = 127 & g, gs(_, A), wa(A, _, 128 & g), st = _ + 48 | 0;
                    }
                    function Es(A, g) {
                      var _;
                      return A |= 0, g |= 0, l[12 + (_ = st - 16 | 0) >> 2] = A, l[_ + 8 >> 2] = g, l[_ + 4 >> 2] = 0, l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2]] ^ B[l[_ + 8 >> 2]], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 1 | 0] ^ B[l[_ + 8 >> 2] + 1 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 2 | 0] ^ B[l[_ + 8 >> 2] + 2 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 3 | 0] ^ B[l[_ + 8 >> 2] + 3 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 4 | 0] ^ B[l[_ + 8 >> 2] + 4 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 5 | 0] ^ B[l[_ + 8 >> 2] + 5 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 6 | 0] ^ B[l[_ + 8 >> 2] + 6 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 7 | 0] ^ B[l[_ + 8 >> 2] + 7 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 8 | 0] ^ B[l[_ + 8 >> 2] + 8 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 9 | 0] ^ B[l[_ + 8 >> 2] + 9 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 10 | 0] ^ B[l[_ + 8 >> 2] + 10 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 11 | 0] ^ B[l[_ + 8 >> 2] + 11 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 12 | 0] ^ B[l[_ + 8 >> 2] + 12 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 13 | 0] ^ B[l[_ + 8 >> 2] + 13 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 14 | 0] ^ B[l[_ + 8 >> 2] + 14 | 0], l[_ + 4 >> 2] = l[_ + 4 >> 2] | B[l[_ + 12 >> 2] + 15 | 0] ^ B[l[_ + 8 >> 2] + 15 | 0], (l[_ + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function ta(A, g, _) {
                      var b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0;
                      e: {
                        t: {
                          n: {
                            r: {
                              s: {
                                u: {
                                  a: {
                                    d: {
                                      o: {
                                        if (g) {
                                          if (!_)
                                            break o;
                                          break d;
                                        }
                                        return Oe = (g = A) - wr(A = (A >>> 0) / (_ >>> 0) | 0, _) | 0, Bs = 0, ve = 0, A;
                                      }
                                      if (!A)
                                        break a;
                                      break u;
                                    }
                                    if (!((b = _ - 1 | 0) & _))
                                      break s;
                                    ie = 0 - (he = (zi(_) + 33 | 0) - zi(g) | 0) | 0;
                                    break n;
                                  }
                                  return Oe = 0, Bs = g - wr(A = (g >>> 0) / 0 | 0, 0) | 0, ve = 0, A;
                                }
                                if ((b = 32 - zi(g) | 0) >>> 0 < 31)
                                  break r;
                                break t;
                              }
                              if (Oe = A & b, Bs = 0, (0 | _) == 1)
                                break e;
                              return _ = 31 & (b = lu(_)), (63 & b) >>> 0 >= 32 ? A = g >>> _ | 0 : (U = g >>> _ | 0, A = ((1 << _) - 1 & g) << 32 - _ | A >>> _), ve = U, A;
                            }
                            he = b + 1 | 0, ie = 63 - b | 0;
                          }
                          if (b = 31 & (U = 63 & he), U >>> 0 >= 32 ? (U = 0, D = g >>> b | 0) : (U = g >>> b | 0, D = ((1 << b) - 1 & g) << 32 - b | A >>> b), b = 31 & (ie &= 63), ie >>> 0 >= 32 ? (g = A << b, A = 0) : (g = (1 << b) - 1 & A >>> 32 - b | g << b, A <<= b), he)
                            for (Be = (0 | (b = _ - 1 | 0)) == -1 ? -1 : 0; me = U << 1 | D >>> 31, D = (U = D << 1 | g >>> 31) - (_e = _ & (ie = Be - (me + (U >>> 0 > b >>> 0) | 0) >> 31)) | 0, U = me - (U >>> 0 < _e >>> 0) | 0, g = g << 1 | A >>> 31, A = ye | A << 1, ye = me = 1 & ie, he = he - 1 | 0; )
                              ;
                          return Oe = D, Bs = U, ve = g << 1 | A >>> 31, me | A << 1;
                        }
                        Oe = A, Bs = g, A = 0, g = 0;
                      }
                      return ve = g, A;
                    }
                    function ja(A, g, _, b, U) {
                      var ie;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, st = ie = st - 480 | 0, Yo(ie, U |= 0, 32), Pu(ie, g, _, b), uo(ie, ie + 416 | 0), g = l[ie + 444 >> 2], _ = l[ie + 440 >> 2], j[A + 24 | 0] = _, j[A + 25 | 0] = _ >>> 8, j[A + 26 | 0] = _ >>> 16, j[A + 27 | 0] = _ >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[ie + 436 >> 2], _ = l[ie + 432 >> 2], j[A + 16 | 0] = _, j[A + 17 | 0] = _ >>> 8, j[A + 18 | 0] = _ >>> 16, j[A + 19 | 0] = _ >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[ie + 428 >> 2], _ = l[ie + 424 >> 2], j[A + 8 | 0] = _, j[A + 9 | 0] = _ >>> 8, j[A + 10 | 0] = _ >>> 16, j[A + 11 | 0] = _ >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[ie + 420 >> 2], _ = l[ie + 416 >> 2], j[0 | A] = _, j[A + 1 | 0] = _ >>> 8, j[A + 2 | 0] = _ >>> 16, j[A + 3 | 0] = _ >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, st = ie + 480 | 0, 0;
                    }
                    function na(A, g, _) {
                      A |= 0, g |= 0;
                      var b, U = 0;
                      return st = b = st + -64 | 0, L(b, _ |= 0, 32, 0), _ = l[b + 28 >> 2], U = l[b + 24 >> 2], j[g + 24 | 0] = U, j[g + 25 | 0] = U >>> 8, j[g + 26 | 0] = U >>> 16, j[g + 27 | 0] = U >>> 24, j[g + 28 | 0] = _, j[g + 29 | 0] = _ >>> 8, j[g + 30 | 0] = _ >>> 16, j[g + 31 | 0] = _ >>> 24, _ = l[b + 20 >> 2], U = l[b + 16 >> 2], j[g + 16 | 0] = U, j[g + 17 | 0] = U >>> 8, j[g + 18 | 0] = U >>> 16, j[g + 19 | 0] = U >>> 24, j[g + 20 | 0] = _, j[g + 21 | 0] = _ >>> 8, j[g + 22 | 0] = _ >>> 16, j[g + 23 | 0] = _ >>> 24, _ = l[b + 12 >> 2], U = l[b + 8 >> 2], j[g + 8 | 0] = U, j[g + 9 | 0] = U >>> 8, j[g + 10 | 0] = U >>> 16, j[g + 11 | 0] = U >>> 24, j[g + 12 | 0] = _, j[g + 13 | 0] = _ >>> 8, j[g + 14 | 0] = _ >>> 16, j[g + 15 | 0] = _ >>> 24, _ = l[b + 4 >> 2], U = l[b >> 2], j[0 | g] = U, j[g + 1 | 0] = U >>> 8, j[g + 2 | 0] = U >>> 16, j[g + 3 | 0] = U >>> 24, j[g + 4 | 0] = _, j[g + 5 | 0] = _ >>> 8, j[g + 6 | 0] = _ >>> 16, j[g + 7 | 0] = _ >>> 24, Wr(b, 64), A = Ma(A, g), st = b - -64 | 0, 0 | A;
                    }
                    function Ro(A, g) {
                      var _ = 0, b = 0, U = 0, ie = 0, he = 0, D = 0;
                      if (g >>> 0 > 4294967168)
                        A = 48;
                      else {
                        if (g >>> 0 >= 4294967168 ? (l[9129] = 48, _ = 0) : (_ = 0, (g = Qi(76 + (ie = g >>> 0 < 11 ? 16 : g + 11 & -8) | 0)) && (_ = g - 8 | 0, 63 & g ? (U = (-8 & (D = l[(he = g - 4 | 0) >> 2])) - (b = (g = ((g = (g + 63 & -64) - 8 | 0) - _ >>> 0 <= 15 ? 64 : 0) + g | 0) - _ | 0) | 0, 3 & D ? (l[g + 4 >> 2] = U | 1 & l[g + 4 >> 2] | 2, l[4 + (U = g + U | 0) >> 2] = 1 | l[U + 4 >> 2], l[he >> 2] = b | 1 & l[he >> 2] | 2, l[4 + (U = _ + b | 0) >> 2] = 1 | l[U + 4 >> 2], Aa(_, b)) : (_ = l[_ >> 2], l[g + 4 >> 2] = U, l[g >> 2] = _ + b)) : g = _, 3 & (_ = l[g + 4 >> 2]) && ((b = -8 & _) >>> 0 <= ie + 16 >>> 0 || (l[g + 4 >> 2] = ie | 1 & _ | 2, _ = g + ie | 0, ie = b - ie | 0, l[_ + 4 >> 2] = 3 | ie, l[4 + (b = g + b | 0) >> 2] = 1 | l[b + 4 >> 2], Aa(_, ie))), _ = g + 8 | 0)), !_)
                          return 48;
                        l[A >> 2] = _, A = 0;
                      }
                      return A;
                    }
                    function ra(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      var ye;
                      if (ye = Jt(A, 0, g), (0 | _) == 1 | _ >>> 0 > 1)
                        return l[9129] = 22, -1;
                      if (!(!_ & g >>> 0 <= 15)) {
                        if (!(!(ie | me) & _e >>> 0 < 2147483649))
                          return l[9129] = 22, -1;
                        if (!(!((!me & D >>> 0 >= 3 | (0 | me) != 0) & _e >>> 0 > 8191) | (0 | b) == (0 | ye)))
                          return (0 | Be) == 1 ? (ie = _e >>> 10 | 0, st = A = st + -64 | 0, ye && jn(ye, g), (_ = Qi(g)) ? (l[A + 32 >> 2] = 0, l[A + 36 >> 2] = 0, l[A + 24 >> 2] = 0, l[A + 28 >> 2] = 0, l[A + 20 >> 2] = 16, l[A + 16 >> 2] = he, l[A + 12 >> 2] = U, l[A + 8 >> 2] = b, l[A + 4 >> 2] = g, l[A >> 2] = _, l[A + 56 >> 2] = 0, l[A + 52 >> 2] = 1, l[A + 48 >> 2] = 1, l[A + 44 >> 2] = ie, l[A + 40 >> 2] = D, (b = js(A, 1)) | !ye || xr(ye, _, g), Wr(_, g), wi(_)) : b = -22, st = A - -64 | 0, b ? -1 : 0) : (l[9129] = 28, -1);
                      }
                      return l[9129] = 28, -1;
                    }
                    function $i(A, g, _, b, U, ie, he) {
                      var D, me, _e, Be, ye, we = 0;
                      return st = D = st - 352 | 0, Ji(D, ie, he, 0), !((!U & b >>> 0 > A - _ >>> 0 | (0 | U) != 0) & A >>> 0 > _ >>> 0) & (!U & b >>> 0 <= _ - A >>> 0 | A >>> 0 >= _ >>> 0) || (_ = Qr(A, _, b)), l[D + 56 >> 2] = 0, l[D + 60 >> 2] = 0, l[D + 48 >> 2] = 0, l[D + 52 >> 2] = 0, l[D + 40 >> 2] = 0, l[D + 44 >> 2] = 0, l[D + 32 >> 2] = 0, l[D + 36 >> 2] = 0, he = (we = !U & b >>> 0 >= 32 | (0 | U) != 0) ? 32 : b, ye = we = we ? 0 : U, (_e = !(he | we)) || xr(D - -64 | 0, _, he), po(me = D + 32 | 0, me, Be = he + 32 | 0, we = Be >>> 0 < 32 ? we + 1 | 0 : we, ie = ie + 16 | 0, D), ys(D + 96 | 0, me), _e || xr(A, D - -64 | 0, he), Wr(D + 32 | 0, 64), !U & b >>> 0 >= 33 | U && ro(A + he | 0, _ + he | 0, b - he | 0, U - (ye + (b >>> 0 < he >>> 0) | 0) | 0, ie, 1, 0, D), Wr(D, 32), ni(_ = D + 96 | 0, A, b, U), sa(_, g), Wr(_, 256), st = D + 352 | 0, 0;
                    }
                    function va(A, g, _, b, U, ie, he) {
                      var D, me, _e, Be, ye, we = 0;
                      return st = D = st - 352 | 0, bs(D, ie, he, 0), !((!U & b >>> 0 > A - _ >>> 0 | (0 | U) != 0) & A >>> 0 > _ >>> 0) & (!U & b >>> 0 <= _ - A >>> 0 | A >>> 0 >= _ >>> 0) || (_ = Qr(A, _, b)), l[D + 56 >> 2] = 0, l[D + 60 >> 2] = 0, l[D + 48 >> 2] = 0, l[D + 52 >> 2] = 0, l[D + 40 >> 2] = 0, l[D + 44 >> 2] = 0, l[D + 32 >> 2] = 0, l[D + 36 >> 2] = 0, he = (we = !U & b >>> 0 >= 32 | (0 | U) != 0) ? 32 : b, ye = we = we ? 0 : U, (_e = !(he | we)) || xr(D - -64 | 0, _, he), Us(me = D + 32 | 0, me, Be = he + 32 | 0, we = Be >>> 0 < 32 ? we + 1 | 0 : we, ie = ie + 16 | 0, D), ys(D + 96 | 0, me), _e || xr(A, D - -64 | 0, he), Wr(D + 32 | 0, 64), !U & b >>> 0 >= 33 | U && As(A + he | 0, _ + he | 0, b - he | 0, U - (ye + (b >>> 0 < he >>> 0) | 0) | 0, ie, 1, 0, D), Wr(D, 32), ni(_ = D + 96 | 0, A, b, U), sa(_, g), Wr(_, 256), st = D + 352 | 0, 0;
                    }
                    function Qa(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      var ye;
                      if (ye = Jt(A, 0, g), (0 | _) == 1 | _ >>> 0 > 1)
                        return l[9129] = 22, -1;
                      if (!(!_ & g >>> 0 <= 15)) {
                        if (!(!(ie | me) & _e >>> 0 < 2147483649))
                          return l[9129] = 22, -1;
                        if (!(!(!!(D | me) & _e >>> 0 > 8191) | (0 | b) == (0 | ye)))
                          return (0 | Be) == 2 ? (ie = _e >>> 10 | 0, st = A = st + -64 | 0, ye && jn(ye, g), (_ = Qi(g)) ? (l[A + 32 >> 2] = 0, l[A + 36 >> 2] = 0, l[A + 24 >> 2] = 0, l[A + 28 >> 2] = 0, l[A + 20 >> 2] = 16, l[A + 16 >> 2] = he, l[A + 12 >> 2] = U, l[A + 8 >> 2] = b, l[A + 4 >> 2] = g, l[A >> 2] = _, l[A + 56 >> 2] = 0, l[A + 52 >> 2] = 1, l[A + 48 >> 2] = 1, l[A + 44 >> 2] = ie, l[A + 40 >> 2] = D, (b = js(A, 2)) | !ye || xr(ye, _, g), Wr(_, g), wi(_)) : b = -22, st = A - -64 | 0, b ? -1 : 0) : (l[9129] = 28, -1);
                      }
                      return l[9129] = 28, -1;
                    }
                    function Ra(A, g, _, b, U, ie, he, D, me, _e) {
                      var Be, ye;
                      return st = Be = st - 400 | 0, l[Be + 4 >> 2] = 0, Ji(ye = Be + 16 | 0, me, _e, 0), _e = B[me + 20 | 0] | B[me + 21 | 0] << 8 | B[me + 22 | 0] << 16 | B[me + 23 | 0] << 24, l[Be + 8 >> 2] = B[me + 16 | 0] | B[me + 17 | 0] << 8 | B[me + 18 | 0] << 16 | B[me + 19 | 0] << 24, l[Be + 12 >> 2] = _e, Vo(_e = Be + 80 | 0, 64, 0, Be + 4 | 0, ye), ys(me = Be + 144 | 0, _e), Wr(_e, 64), ni(me, ie, he, D), ni(me, 35312, 0 - he & 15, 0), ni(me, g, _, b), ni(me, 35312, 0 - _ & 15, 0), l[Be + 72 >> 2] = he, l[Be + 76 >> 2] = D, ni(me, ie = Be + 72 | 0, 8, 0), l[Be + 72 >> 2] = _, l[Be + 76 >> 2] = b, ni(me, ie, 8, 0), sa(me, ie = Be + 48 | 0), Wr(me, 256), me = Es(ie, U), Wr(ie, 16), A && (me ? (Jt(A, 0, _), me = -1) : (ri(A, g, _, b, Be + 4 | 0, Be + 16 | 0), me = 0)), Wr(Be + 16 | 0, 32), st = Be + 400 | 0, me;
                    }
                    function La(A, g, _, b, U, ie, he) {
                      var D, me, _e = 0, Be = 0;
                      st = D = st - 96 | 0, bs(D, ie, he, 0), Ua(he = D + 32 | 0, 32, 0, me = ie + 16 | 0, D), ie = -1;
                      e: {
                        if (!du(_, g, b, U, he)) {
                          if (ie = 0, !A)
                            break e;
                          !((!U & b >>> 0 > g - A >>> 0 | (0 | U) != 0) & A >>> 0 < g >>> 0) & (!U & b >>> 0 <= A - g >>> 0 | A >>> 0 <= g >>> 0) || (g = Qr(A, g, b)), (he = (_ = !U & b >>> 0 >= 32 | (0 | U) != 0) ? 32 : b) | (_ = _ ? 0 : U) ? (Be = xr(D - -64 | 0, g, he), Us(ie = D + 32 | 0, ie, _e = he + 32 | 0, _e >>> 0 < 32 ? _ + 1 | 0 : _, me, D), xr(A, Be, he)) : Us(ie = D + 32 | 0, ie, _e = he + 32 | 0, _e >>> 0 < 32 ? _ + 1 | 0 : _, me, D), Wr(D + 32 | 0, 64), ie = 0, !U & b >>> 0 < 33 || As(A + he | 0, g + he | 0, b - he | 0, U - (_ + (b >>> 0 < he >>> 0) | 0) | 0, me, 1, 0, D);
                        }
                        Wr(D, 32);
                      }
                      return st = D + 96 | 0, ie;
                    }
                    function Ha(A, g, _, b, U, ie, he) {
                      var D, me, _e = 0, Be = 0;
                      st = D = st - 96 | 0, Ji(D, ie, he, 0), Ho(he = D + 32 | 0, 32, 0, me = ie + 16 | 0, D), ie = -1;
                      e: {
                        if (!du(_, g, b, U, he)) {
                          if (ie = 0, !A)
                            break e;
                          !((!U & b >>> 0 > g - A >>> 0 | (0 | U) != 0) & A >>> 0 < g >>> 0) & (!U & b >>> 0 <= A - g >>> 0 | A >>> 0 <= g >>> 0) || (g = Qr(A, g, b)), (he = (_ = !U & b >>> 0 >= 32 | (0 | U) != 0) ? 32 : b) | (_ = _ ? 0 : U) ? (Be = xr(D - -64 | 0, g, he), po(ie = D + 32 | 0, ie, _e = he + 32 | 0, _e >>> 0 < 32 ? _ + 1 | 0 : _, me, D), xr(A, Be, he)) : po(ie = D + 32 | 0, ie, _e = he + 32 | 0, _e >>> 0 < 32 ? _ + 1 | 0 : _, me, D), ie = 0, !U & b >>> 0 < 33 || ro(A + he | 0, g + he | 0, b - he | 0, U - (_ + (b >>> 0 < he >>> 0) | 0) | 0, me, 1, 0, D);
                        }
                        Wr(D, 32);
                      }
                      return st = D + 96 | 0, ie;
                    }
                    function za(A, g, _, b, U, ie) {
                      var he, D;
                      if (st = he = st - 496 | 0, Fe(D = he + 288 | 0, A, g), Eu(D, _, b, 0), ie)
                        for (A = 0, g = 0; _ = (g = g + 1 | 0) << 24 | (65280 & g) << 8 | g >>> 8 & 65280 | g >>> 24, j[he + 76 | 0] = _, j[he + 77 | 0] = _ >>> 8, j[he + 78 | 0] = _ >>> 16, j[he + 79 | 0] = _ >>> 24, xr(_ = he + 80 | 0, he + 288 | 0, 208), Eu(_, he + 76 | 0, 4, 0), bo(_, he + 32 | 0), _ = l[he + 60 >> 2], l[he + 24 >> 2] = l[he + 56 >> 2], l[he + 28 >> 2] = _, _ = l[he + 52 >> 2], l[he + 16 >> 2] = l[he + 48 >> 2], l[he + 20 >> 2] = _, _ = l[he + 44 >> 2], l[he + 8 >> 2] = l[he + 40 >> 2], l[he + 12 >> 2] = _, _ = l[he + 36 >> 2], l[he >> 2] = l[he + 32 >> 2], l[he + 4 >> 2] = _, xr(_ = A + U | 0, he, (A = ie - A | 0) >>> 0 >= 32 ? 32 : A), ie >>> 0 > (A = g << 5) >>> 0; )
                          ;
                      Wr(he + 288 | 0, 208), st = he + 496 | 0;
                    }
                    function Na(A) {
                      var g = 0, _ = 0, b = 0;
                      if (!A)
                        return -25;
                      if (!l[A >> 2])
                        return -1;
                      if (g = -2, !(Ri[A + 4 >> 2] < 16) && (l[A + 8 >> 2] || (g = -18, !l[A + 12 >> 2]))) {
                        if (_ = l[A + 20 >> 2], !l[A + 16 >> 2])
                          return _ ? -19 : -6;
                        if (g = -6, !(_ >>> 0 < 8) && (l[A + 24 >> 2] || (g = -20, !l[A + 28 >> 2])) && (l[A + 32 >> 2] || (g = -21, !l[A + 36 >> 2]))) {
                          if (!(_ = l[A + 48 >> 2]))
                            return -16;
                          if (g = -17, !(_ >>> 0 > 16777215 || (g = -14, (b = l[A + 44 >> 2]) >>> 0 < 8 || (g = -15, b >>> 0 > 2097152 || (g = -14, _ << 3 >>> 0 > b >>> 0))))) {
                            if (!l[A + 40 >> 2])
                              return -12;
                            if (!(A = l[A + 52 >> 2]))
                              return -28;
                            g = A >>> 0 > 16777215 ? -29 : 0;
                          }
                        }
                      }
                      return g;
                    }
                    function xa(A, g, _, b, U, ie) {
                      var he, D = 0;
                      return st = he = st - 32 | 0, D = -1, !b & _ >>> 0 < 32 || (Bt(he, 32, 0, U, ie), du(g + 16 | 0, g + 32 | 0, _ - 32 | 0, b - (_ >>> 0 < 32) | 0, he) || (Oo(A, g, _, b, U, ie), j[A + 24 | 0] = 0, j[A + 25 | 0] = 0, j[A + 26 | 0] = 0, j[A + 27 | 0] = 0, j[A + 28 | 0] = 0, j[A + 29 | 0] = 0, j[A + 30 | 0] = 0, j[A + 31 | 0] = 0, j[A + 16 | 0] = 0, j[A + 17 | 0] = 0, j[A + 18 | 0] = 0, j[A + 19 | 0] = 0, j[A + 20 | 0] = 0, j[A + 21 | 0] = 0, j[A + 22 | 0] = 0, j[A + 23 | 0] = 0, j[A + 8 | 0] = 0, j[A + 9 | 0] = 0, j[A + 10 | 0] = 0, j[A + 11 | 0] = 0, j[A + 12 | 0] = 0, j[A + 13 | 0] = 0, j[A + 14 | 0] = 0, j[A + 15 | 0] = 0, j[0 | A] = 0, j[A + 1 | 0] = 0, j[A + 2 | 0] = 0, j[A + 3 | 0] = 0, j[A + 4 | 0] = 0, j[A + 5 | 0] = 0, j[A + 6 | 0] = 0, j[A + 7 | 0] = 0, D = 0)), st = he + 32 | 0, D;
                    }
                    function Ki(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      var ye, we, $e;
                      return st = ye = st - 384 | 0, l[ye + 4 >> 2] = 0, Ji(we = ye + 16 | 0, _e, Be, 0), Be = B[_e + 20 | 0] | B[_e + 21 | 0] << 8 | B[_e + 22 | 0] << 16 | B[_e + 23 | 0] << 24, l[ye + 8 >> 2] = B[_e + 16 | 0] | B[_e + 17 | 0] << 8 | B[_e + 18 | 0] << 16 | B[_e + 19 | 0] << 24, l[ye + 12 >> 2] = Be, Vo(Be = ye - -64 | 0, 64, 0, $e = ye + 4 | 0, we), ys(_e = ye + 128 | 0, Be), Wr(Be, 64), ni(_e, he, D, me), ni(_e, 35312, 0 - D & 15, 0), ri(A, b, U, ie, $e, we), ni(_e, A, U, ie), ni(_e, 35312, 0 - U & 15, 0), l[ye + 56 >> 2] = D, l[ye + 60 >> 2] = me, ni(_e, A = ye + 56 | 0, 8, 0), l[ye + 56 >> 2] = U, l[ye + 60 >> 2] = ie, ni(_e, A, 8, 0), sa(_e, g), Wr(_e, 256), _ && (l[_ >> 2] = 16, l[_ + 4 >> 2] = 0), Wr(ye + 16 | 0, 32), st = ye + 384 | 0, 0;
                    }
                    function Xa(A, g, _, b, U) {
                      var ie, he, D = 0;
                      return st = ie = st + -64 | 0, !_ & (he = gn(A)) >>> 0 < 128 ? (l[ie + 56 >> 2] = 0, l[ie + 48 >> 2] = 0, l[ie + 52 >> 2] = 0, l[ie + 40 >> 2] = 0, l[ie + 44 >> 2] = 0, _ = 0, he && (_ = he, (1 | he) >>> 0 < 65536 || (_ = he)), !(D = Qi(_)) | !(3 & B[D - 4 | 0]) || Jt(D, 0, _), D ? (l[ie + 32 >> 2] = 0, l[ie + 36 >> 2] = 0, l[ie + 8 >> 2] = D, l[ie + 16 >> 2] = D, l[ie + 20 >> 2] = he, l[ie >> 2] = D, l[ie + 12 >> 2] = he, l[ie + 24 >> 2] = 0, l[ie + 28 >> 2] = 0, l[ie + 4 >> 2] = he, hs(ie, A, U) ? (l[9129] = 28, A = -1) : A = l[ie + 40 >> 2] != (0 | g) | l[ie + 44 >> 2] != (b >>> 10 | 0), wi(D)) : A = -1) : (l[9129] = 28, A = -1), st = ie - -64 | 0, A;
                    }
                    function L(A, g, _, b) {
                      var U, ie = 0;
                      return st = U = st - 208 | 0, l[U + 72 >> 2] = 0, l[U + 76 >> 2] = 0, ie = l[8603], l[U + 8 >> 2] = l[8602], l[U + 12 >> 2] = ie, ie = l[8605], l[U + 16 >> 2] = l[8604], l[U + 20 >> 2] = ie, ie = l[8607], l[U + 24 >> 2] = l[8606], l[U + 28 >> 2] = ie, ie = l[8609], l[U + 32 >> 2] = l[8608], l[U + 36 >> 2] = ie, ie = l[8611], l[U + 40 >> 2] = l[8610], l[U + 44 >> 2] = ie, ie = l[8613], l[U + 48 >> 2] = l[8612], l[U + 52 >> 2] = ie, ie = l[8615], l[U + 56 >> 2] = l[8614], l[U + 60 >> 2] = ie, l[U + 64 >> 2] = 0, l[U + 68 >> 2] = 0, ie = l[8601], l[U >> 2] = l[8600], l[U + 4 >> 2] = ie, Di(U, g, _, b), Ui(U, A), st = U + 208 | 0, 0;
                    }
                    function Z(A, g) {
                      var _ = 0, b = 0;
                      e:
                        if (b = 255 & g) {
                          if (3 & A)
                            for (; ; ) {
                              if (!(_ = B[0 | A]) | (0 | _) == (255 & g))
                                break e;
                              if (!(3 & (A = A + 1 | 0)))
                                break;
                            }
                          t:
                            if (!((-1 ^ (_ = l[A >> 2])) & _ - 16843009 & -2139062144))
                              for (b = wr(b, 16843009); ; ) {
                                if ((-1 ^ (_ ^= b)) & _ - 16843009 & -2139062144)
                                  break t;
                                if (_ = l[A + 4 >> 2], A = A + 4 | 0, _ - 16843009 & (-1 ^ _) & -2139062144)
                                  break;
                              }
                          for (; _ = A, (b = B[0 | A]) && (A = _ + 1 | 0, (0 | b) != (255 & g)); )
                            ;
                          A = _;
                        } else
                          A = gn(A) + A | 0;
                      return B[0 | A] == (255 & g) ? A : 0;
                    }
                    function le(A, g) {
                      var _, b = 0, U = 0, ie = 0;
                      if (j[15 + (_ = st - 16 | 0) | 0] = 0, g) {
                        if (U = 3 & g, g >>> 0 >= 4)
                          for (ie = -4 & g, g = 0; j[_ + 15 | 0] = B[A + b | 0] | B[_ + 15 | 0], j[_ + 15 | 0] = B[(1 | b) + A | 0] | B[_ + 15 | 0], j[_ + 15 | 0] = B[(2 | b) + A | 0] | B[_ + 15 | 0], j[_ + 15 | 0] = B[(3 | b) + A | 0] | B[_ + 15 | 0], b = b + 4 | 0, (0 | ie) != (0 | (g = g + 4 | 0)); )
                            ;
                        if (U)
                          for (g = 0; j[_ + 15 | 0] = B[A + b | 0] | B[_ + 15 | 0], b = b + 1 | 0, (0 | U) != (0 | (g = g + 1 | 0)); )
                            ;
                      }
                      return B[_ + 15 | 0] - 1 >>> 8 & 1;
                    }
                    function ae(A) {
                      var g = 0;
                      return l[64 + (A |= 0) >> 2] = 0, l[A + 68 >> 2] = 0, l[A + 72 >> 2] = 0, l[A + 76 >> 2] = 0, g = l[8601], l[A >> 2] = l[8600], l[A + 4 >> 2] = g, g = l[8603], l[A + 8 >> 2] = l[8602], l[A + 12 >> 2] = g, g = l[8605], l[A + 16 >> 2] = l[8604], l[A + 20 >> 2] = g, g = l[8607], l[A + 24 >> 2] = l[8606], l[A + 28 >> 2] = g, g = l[8609], l[A + 32 >> 2] = l[8608], l[A + 36 >> 2] = g, g = l[8611], l[A + 40 >> 2] = l[8610], l[A + 44 >> 2] = g, g = l[8613], l[A + 48 >> 2] = l[8612], l[A + 52 >> 2] = g, g = l[8615], l[A + 56 >> 2] = l[8614], l[A + 60 >> 2] = g, 0;
                    }
                    function de(A) {
                      return ((127 & (-1 ^ B[A + 31 | 0]) | B[A + 1 | 0] & B[A + 2 | 0] & B[A + 3 | 0] & B[A + 4 | 0] & B[A + 5 | 0] & B[A + 6 | 0] & B[A + 7 | 0] & B[A + 8 | 0] & B[A + 9 | 0] & B[A + 10 | 0] & B[A + 11 | 0] & B[A + 12 | 0] & B[A + 13 | 0] & B[A + 14 | 0] & B[A + 15 | 0] & B[A + 16 | 0] & B[A + 17 | 0] & B[A + 18 | 0] & B[A + 19 | 0] & B[A + 20 | 0] & B[A + 21 | 0] & B[A + 22 | 0] & B[A + 23 | 0] & B[A + 24 | 0] & B[A + 25 | 0] & B[A + 26 | 0] & B[A + 27 | 0] & B[A + 28 | 0] & B[A + 30 | 0] & B[A + 29 | 0] ^ 255) - 1 & 236 - B[0 | A] ^ -1) >>> 8 & 1;
                    }
                    function Ie(A, g, _) {
                      var b, U = 0, ie = 0;
                      if (l[12 + (b = st - 16 | 0) >> 2] = A, l[b + 8 >> 2] = g, A = 0, j[b + 7 | 0] = 0, _) {
                        if (g = 1 & _, (0 | _) != 1)
                          for (ie = -2 & _, _ = 0; j[b + 7 | 0] = B[b + 7 | 0] | B[l[b + 12 >> 2] + A | 0] ^ B[l[b + 8 >> 2] + A | 0], U = 1 | A, j[b + 7 | 0] = B[b + 7 | 0] | B[U + l[b + 12 >> 2] | 0] ^ B[l[b + 8 >> 2] + U | 0], A = A + 2 | 0, (0 | ie) != (0 | (_ = _ + 2 | 0)); )
                            ;
                        g && (j[b + 7 | 0] = B[b + 7 | 0] | B[l[b + 12 >> 2] + A | 0] ^ B[l[b + 8 >> 2] + A | 0]);
                      }
                      return (B[b + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Qe(A) {
                      for (var g = 0, _ = 0, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0; U = (_ = B[A + b | 0]) ^ B[0 | (g = b + 2704 | 0)] | U, ie = _ ^ B[g + 192 | 0] | ie, he = _ ^ B[g + 160 | 0] | he, D = _ ^ B[g + 128 | 0] | D, me = _ ^ B[g + 96 | 0] | me, _e = _ ^ B[g - -64 | 0] | _e, Be = _ ^ B[g + 32 | 0] | Be, (0 | (b = b + 1 | 0)) != 31; )
                        ;
                      return ((255 & ((g = 127 ^ (A = 127 & B[A + 31 | 0])) | ie)) - 1 | (255 & (g | he)) - 1 | (255 & (g | D)) - 1 | (255 & (122 ^ A | me)) - 1 | (255 & (5 ^ A | _e)) - 1 | (255 & (A | Be)) - 1 | (255 & (A | U)) - 1) >>> 8 & 1;
                    }
                    function q(A, g, _) {
                      var b = 0, U = 0, ie = 0, he = 0;
                      return U = 31 & (ie = he = 63 & _), ie = ie >>> 0 >= 32 ? -1 >>> U | 0 : (b = -1 >>> U | 0) | (1 << U) - 1 << 32 - U, ie &= A, b &= g, U = 31 & he, he >>> 0 >= 32 ? (b = ie << U, he = 0) : (b = (1 << U) - 1 & ie >>> 32 - U | b << U, he = ie << U), ie = b, b = 31 & (U = 0 - _ & 63), U >>> 0 >= 32 ? (b = -1 << b, _ = 0) : b = (_ = -1 << b) | (1 << b) - 1 & -1 >>> 32 - b, A &= _, g &= b, b = 31 & U, U >>> 0 >= 32 ? (_ = 0, A = g >>> b | 0) : (_ = g >>> b | 0, A = ((1 << b) - 1 & g) << 32 - b | A >>> b), ve = _ | ie, A | he;
                    }
                    function be(A, g, _, b, U, ie) {
                      A |= 0, g |= 0, _ |= 0;
                      var he = 0, D = 0;
                      e:
                        t: {
                          n: {
                            if (!(!(U |= 0) & (b |= 0) >>> 0 < 64 || (D = 1 + (U = U - 1 | 0) | 0, he = U, !(b = (U = b + -64 | 0) >>> 0 < 4294967232 ? D : he) & U >>> 0 > 4294967231 | b))) {
                              if (!ua(he = _, _ = _ - -64 | 0, U, b, ie |= 0, 0))
                                break n;
                              A && Jt(A, 0, U);
                            }
                            if (b = -1, !g)
                              break t;
                            l[g >> 2] = 0, l[g + 4 >> 2] = 0, b = -1;
                            break e;
                          }
                          g && (l[g >> 2] = U, l[g + 4 >> 2] = b), b = 0, A && Qr(A, _, U);
                        }
                      return 0 | b;
                    }
                    function Ue(A, g, _, b, U, ie, he, D, me, _e) {
                      var Be, ye, we;
                      return st = Be = st - 352 | 0, Vo(we = Be + 32 | 0, 64, 0, me, _e), ys(ye = Be + 96 | 0, we), Wr(we, 64), ni(ye, ie, he, D), ni(ye, 34352, 0 - he & 15, 0), ni(ye, g, _, b), ni(ye, 34352, 0 - _ & 15, 0), l[Be + 24 >> 2] = he, l[Be + 28 >> 2] = D, ni(ye, ie = Be + 24 | 0, 8, 0), l[Be + 24 >> 2] = _, l[Be + 28 >> 2] = b, ni(ye, ie, 8, 0), sa(ye, Be), Wr(ye, 256), ie = Es(Be, U), Wr(Be, 16), A && (ie ? (Jt(A, 0, _), ie = -1) : (Vn(A, g, _, b, me, 1, _e), ie = 0)), st = Be + 352 | 0, ie;
                    }
                    function Ye(A, g, _, b, U, ie) {
                      var he, D;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, ie |= 0, st = he = st - 32 | 0, D = B[0 | (U |= 0)] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, U = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[he + 24 >> 2] = 0, l[he + 28 >> 2] = 0, l[he + 16 >> 2] = D, l[he + 20 >> 2] = U, l[he + 8 >> 2] = 0, l[he + 12 >> 2] = 0, l[he >> 2] = _, l[he + 4 >> 2] = b, g - 65 >>> 0 <= 4294967246 ? (l[9129] = 28, A = -1) : A = qi(A, g, 0, 0, 0, ie, 32, he, he + 16 | 0), st = he + 32 | 0, 0 | A;
                    }
                    function Te(A, g, _, b, U) {
                      var ie, he;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, st = ie = st - 512 | 0, Yo(he = ie + 32 | 0, U |= 0, 32), Pu(he, g, _, b), uo(he, ie + 448 | 0), g = l[ie + 476 >> 2], l[ie + 24 >> 2] = l[ie + 472 >> 2], l[ie + 28 >> 2] = g, g = l[ie + 468 >> 2], l[ie + 16 >> 2] = l[ie + 464 >> 2], l[ie + 20 >> 2] = g, g = l[ie + 460 >> 2], l[ie + 8 >> 2] = l[ie + 456 >> 2], l[ie + 12 >> 2] = g, g = l[ie + 452 >> 2], l[ie >> 2] = l[ie + 448 >> 2], l[ie + 4 >> 2] = g, g = fu(A, ie), _ = Ie(ie, A, 32), st = ie + 512 | 0, _ | ((0 | A) == (0 | ie) ? -1 : g);
                    }
                    function Ne(A, g, _, b, U, ie, he, D, me, _e) {
                      var Be, ye, we;
                      return st = Be = st - 352 | 0, Ho(we = Be + 32 | 0, 64, 0, me, _e), ys(ye = Be + 96 | 0, we), Wr(we, 64), ni(ye, ie, he, D), l[Be + 24 >> 2] = he, l[Be + 28 >> 2] = D, ni(ye, ie = Be + 24 | 0, 8, 0), ni(ye, g, _, b), l[Be + 24 >> 2] = _, l[Be + 28 >> 2] = b, ni(ye, ie, 8, 0), sa(ye, Be), Wr(ye, 256), ie = Es(Be, U), Wr(Be, 16), A && (ie ? (Jt(A, 0, _), ie = -1) : (ro(A, g, _, b, me, 1, 0, _e), ie = 0)), st = Be + 352 | 0, ie;
                    }
                    function We(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      var ye, we, $e;
                      return st = ye = st - 336 | 0, Vo($e = ye + 16 | 0, 64, 0, _e, Be), ys(we = ye + 80 | 0, $e), Wr($e, 64), ni(we, he, D, me), ni(we, 34352, 0 - D & 15, 0), Vn(A, b, U, ie, _e, 1, Be), ni(we, A, U, ie), ni(we, 34352, 0 - U & 15, 0), l[ye + 8 >> 2] = D, l[ye + 12 >> 2] = me, ni(we, A = ye + 8 | 0, 8, 0), l[ye + 8 >> 2] = U, l[ye + 12 >> 2] = ie, ni(we, A, 8, 0), sa(we, g), Wr(we, 256), _ && (l[_ >> 2] = 16, l[_ + 4 >> 2] = 0), st = ye + 336 | 0, 0;
                    }
                    function rt(A, g) {
                      var _, b = 0, U = 0, ie = 0, he = 0, D = 0;
                      e:
                        if (!(((_ = B[0 | A]) - 58 & 255) >>> 0 < 246)) {
                          for (U = _, b = A; ; ) {
                            if (he = b, ie >>> 0 > 429496729 || (U = (255 & U) - 48 | 0) >>> 0 > (-1 ^ (b = wr(ie, 10))) >>> 0)
                              break e;
                            if (ie = b + U | 0, !(((U = B[0 | (b = he + 1 | 0)]) - 58 & 255) >>> 0 > 245))
                              break;
                          }
                          (0 | _) == 48 & (0 | A) != (0 | he) | (0 | A) == (0 | b) || (l[g >> 2] = ie, D = b);
                        }
                      return D;
                    }
                    function ot(A) {
                      var g = 0, _ = 0, b = 0, U = 0;
                      g = 65, _ = 1024;
                      e: {
                        t: {
                          if (B[1024] != (255 & A))
                            for (U = wr(255 & A, 16843009); ; ) {
                              if ((-1 ^ (b = l[_ >> 2] ^ U)) & b - 16843009 & -2139062144)
                                break t;
                              if (_ = _ + 4 | 0, !((g = g - 4 | 0) >>> 0 > 3))
                                break;
                            }
                          if (!g)
                            break e;
                        }
                        for (A &= 255; ; ) {
                          if ((0 | A) == B[0 | _])
                            return _;
                          if (_ = _ + 1 | 0, !(g = g - 1 | 0))
                            break;
                        }
                      }
                      return 0;
                    }
                    function _t(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      var ye, we, $e;
                      return st = ye = st - 336 | 0, Ho($e = ye + 16 | 0, 64, 0, _e, Be), ys(we = ye + 80 | 0, $e), Wr($e, 64), ni(we, he, D, me), l[ye + 8 >> 2] = D, l[ye + 12 >> 2] = me, ni(we, he = ye + 8 | 0, 8, 0), ro(A, b, U, ie, _e, 1, 0, Be), ni(we, A, U, ie), l[ye + 8 >> 2] = U, l[ye + 12 >> 2] = ie, ni(we, he, 8, 0), sa(we, g), Wr(we, 256), _ && (l[_ >> 2] = 16, l[_ + 4 >> 2] = 0), st = ye + 336 | 0, 0;
                    }
                    function qt(A, g, _, b, U, ie) {
                      return !b & _ >>> 0 >= 32 | b ? (Oo(A, g, _, b, U, ie), Ga(A + 16 | 0, A + 32 | 0, _ - 32 | 0, b - (_ >>> 0 < 32) | 0, A), j[A + 8 | 0] = 0, j[A + 9 | 0] = 0, j[A + 10 | 0] = 0, j[A + 11 | 0] = 0, j[A + 12 | 0] = 0, j[A + 13 | 0] = 0, j[A + 14 | 0] = 0, j[A + 15 | 0] = 0, j[0 | A] = 0, j[A + 1 | 0] = 0, j[A + 2 | 0] = 0, j[A + 3 | 0] = 0, j[A + 4 | 0] = 0, j[A + 5 | 0] = 0, j[A + 6 | 0] = 0, j[A + 7 | 0] = 0, A = 0) : A = -1, A;
                    }
                    function tt(A, g, _, b, U, ie) {
                      g |= 0, U |= 0, ie |= 0;
                      var he, D = 0;
                      return st = he = st - 16 | 0, aa(A |= 0, he + 8 | 0, Qr(A - -64 | 0, _ |= 0, b |= 0), b, U, ie, 0), l[he + 12 >> 2] | l[he + 8 >> 2] != 64 ? (g && (l[g >> 2] = 0, l[g + 4 >> 2] = 0), Jt(A, 0, b - -64 | 0), D = -1) : g && (l[g >> 2] = b - -64, l[g + 4 >> 2] = U - ((b >>> 0 < 4294967232) - 1 | 0)), st = he + 16 | 0, 0 | D;
                    }
                    function xt(A, g) {
                      var _, b = 0, U = 0, ie = 0, he = 0;
                      return (_ = ot(B[0 | g])) && (b = ot(B[g + 1 | 0])) && (U = ot(B[g + 2 | 0])) && (ie = ot(B[g + 3 | 0])) && (he = ot(B[g + 4 | 0])) ? (l[A >> 2] = _ - 1024 | b - 1024 << 6 | U - 1024 << 12 | ie - 1024 << 18 | he - 1024 << 24, g + 5 | 0) : (l[A >> 2] = 0, 0);
                    }
                    function Mt(A, g, _) {
                      var b;
                      for (l[12 + (b = st - 16 | 0) >> 2] = A, l[b + 8 >> 2] = g, A = 0, l[b + 4 >> 2] = 0; l[b + 4 >> 2] = l[b + 4 >> 2] | B[l[b + 12 >> 2] + A | 0] ^ B[l[b + 8 >> 2] + A | 0], g = 1 | A, l[b + 4 >> 2] = l[b + 4 >> 2] | B[g + l[b + 12 >> 2] | 0] ^ B[g + l[b + 8 >> 2] | 0], (0 | _) != (0 | (A = A + 2 | 0)); )
                        ;
                      return (l[b + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                    }
                    function Vt(A, g) {
                      var _, b = 0, U = 0, ie = 0;
                      st = _ = st - 896 | 0, gs(b = _ + 848 | 0, g), gs(U = _ + 800 | 0, g + 32 | 0), ma(ie = _ + 320 | 0, b), ma(g = _ + 160 | 0, U), Bi(b = _ + 640 | 0, g), Si(g = _ + 480 | 0, ie, b), In(_, g, b = _ + 600 | 0), In(_ + 40 | 0, U = _ + 520 | 0, ie = _ + 560 | 0), In(_ + 80 | 0, ie, b), In(_ + 120 | 0, g, U), Ni(A, _), st = _ + 896 | 0;
                    }
                    function un(A) {
                      var g = 0, _ = 0, b = 0, U = 0;
                      for (g = 1; g = B[0 | (_ = A + b | 0)] + g | 0, j[0 | _] = g, g = B[0 | (_ = (1 | b) + A | 0)] + (g >>> 8 | 0) | 0, j[0 | _] = g, g = B[0 | (_ = (2 | b) + A | 0)] + (g >>> 8 | 0) | 0, j[0 | _] = g, g = B[0 | (_ = (3 | b) + A | 0)] + (g >>> 8 | 0) | 0, j[0 | _] = g, g = g >>> 8 | 0, b = b + 4 | 0, (0 | (U = U + 4 | 0)) != 4; )
                        ;
                    }
                    function gn(A) {
                      var g = 0, _ = 0, b = 0;
                      e: {
                        if (3 & (g = A))
                          for (; ; ) {
                            if (!B[0 | g])
                              break e;
                            if (!(3 & (g = g + 1 | 0)))
                              break;
                          }
                        for (; _ = g, g = g + 4 | 0, !((-1 ^ (b = l[_ >> 2])) & b - 16843009 & -2139062144); )
                          ;
                        for (; _ = (g = _) + 1 | 0, B[0 | g]; )
                          ;
                      }
                      return g - A | 0;
                    }
                    function Bn(A, g, _, b, U, ie, he) {
                      var D;
                      return st = D = st - 16 | 0, A = Jt(A, 0, 128), !(b | ie) & he >>> 0 < 2147483649 ? (!ie & U >>> 0 >= 3 | (0 | ie) != 0) & he >>> 0 > 8191 ? (jn(D, 16), A = ka(U, he >>> 10 | 0, g, _, D, A, 1) ? -1 : 0) : (l[9129] = 28, A = -1) : (l[9129] = 22, A = -1), st = D + 16 | 0, A;
                    }
                    function Tn(A, g) {
                      var _ = 0;
                      4 & g && ((g = l[A >> 2]) && Wr(l[g + 4 >> 2], l[A + 16 >> 2] << 10), (g = l[A + 4 >> 2]) && Wr(g, l[A + 20 >> 2] << 3)), wi(l[A + 4 >> 2]), l[A + 4 >> 2] = 0, (g = l[A >> 2]) && (_ = l[g >> 2]) && wi(_), wi(g), l[A >> 2] = 0;
                    }
                    function Pt(A) {
                      var g = 0, _ = 0, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0;
                      for (g = 32, _ = 1; me = (U = B[(b = g - 2 | 0) + A | 0]) - (ie = B[b + 2928 | 0]) >> 8 & (g = ((he = B[2928 + (g = g - 1 | 0) | 0]) ^ (D = B[A + g | 0])) - 1 >> 8 & _) | 255 & (D - he >>> 8 & _ | me), _ = g & (U ^ ie) - 1 >> 8, g = b; )
                        ;
                      return (255 & me) != 0;
                    }
                    function Dt(A, g, _) {
                      var b = 0, U = 0, ie = 0;
                      if (!_)
                        return 0;
                      e:
                        if (b = B[0 | A]) {
                          for (; ; ) {
                            if ((U = B[0 | g]) && !(!(_ = _ - 1 | 0) | (0 | b) != (0 | U))) {
                              if (g = g + 1 | 0, b = B[A + 1 | 0], A = A + 1 | 0, b)
                                continue;
                              break e;
                            }
                            break;
                          }
                          ie = b;
                        }
                      return (255 & ie) - B[0 | g] | 0;
                    }
                    function An(A, g, _, b, U, ie, he) {
                      var D;
                      return st = D = st - 16 | 0, A = Jt(A, 0, 128), !(b | ie) & he >>> 0 < 2147483649 ? !!(U | ie) & he >>> 0 > 8191 ? (jn(D, 16), A = ka(U, he >>> 10 | 0, g, _, D, A, 2) ? -1 : 0) : (l[9129] = 28, A = -1) : (l[9129] = 22, A = -1), st = D + 16 | 0, A;
                    }
                    function kn(A) {
                      var g = 0;
                      return l[32 + (A |= 0) >> 2] = 0, l[A + 36 >> 2] = 0, g = l[8833], l[A >> 2] = l[8832], l[A + 4 >> 2] = g, g = l[8835], l[A + 8 >> 2] = l[8834], l[A + 12 >> 2] = g, g = l[8837], l[A + 16 >> 2] = l[8836], l[A + 20 >> 2] = g, g = l[8839], l[A + 24 >> 2] = l[8838], l[A + 28 >> 2] = g, 0;
                    }
                    function Dn(A, g, _, b, U, ie, he) {
                      var D, me = 0;
                      return st = D = st + -64 | 0, me = -1, !b & _ >>> 0 < 16 || ls(D + 32 | 0, he, ie) || Ji(D, 35296, D + 32 | 0, 0) || (me = Ha(A, g + 16 | 0, g, _ - 16 | 0, b - (_ >>> 0 < 16) | 0, U, D), Wr(D, 32)), st = D - -64 | 0, me;
                    }
                    function De(A, g, _, b) {
                      var U, ie, he, D, me = 0, _e = 0;
                      return D = wr(me = _ >>> 16 | 0, _e = A >>> 16 | 0), me = (65535 & (_e = ((he = wr(U = 65535 & _, ie = 65535 & A)) >>> 16 | 0) + wr(_e, U) | 0)) + wr(me, ie) | 0, ve = (wr(g, _) + D | 0) + wr(A, b) + (_e >>> 16) + (me >>> 16) | 0, 65535 & he | me << 16;
                    }
                    function Vn(A, g, _, b, U, ie, he) {
                      var D = 0, me = 0;
                      if (D = b, !((((D = (me = _ + 63 | 0) >>> 0 < 63 ? D + 1 | 0 : D) >>> 6 | 0) + ((0 | (D = (63 & D) << 26 | me >>> 6)) != 0) | 0) == 1 & ie >>> 0 > (me = 0 - D | 0) >>> 0 | (0 | b) == 1 | b >>> 0 > 1))
                        return 0 | Xi[l[8937]](A, g, _, b, U, ie, he);
                      Ai(), Xr();
                    }
                    function Xn(A, g, _, b, U, ie, he) {
                      var D;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, st = D = st + -64 | 0, ls(D + 32 | 0, he |= 0, ie |= 0) ? ie = -1 : (ie = -1, bs(D, 35232, D + 32 | 0, 0) || (ie = qt(A, g, _, b, U, D), Wr(D, 32))), st = D - -64 | 0, 0 | ie;
                    }
                    function nr(A, g, _, b, U, ie, he) {
                      var D;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, st = D = st + -64 | 0, ls(D + 32 | 0, he |= 0, ie |= 0) ? ie = -1 : (ie = -1, bs(D, 35232, D + 32 | 0, 0) || (ie = xa(A, g, _, b, U, D), Wr(D, 32))), st = D - -64 | 0, 0 | ie;
                    }
                    function nn(A, g) {
                      for (var _ = 0, b = 0, U = 0, ie = 0, he = 0; _ = (B[0 | (b = A + U | 0)] - B[g + U | 0] | 0) + _ | 0, j[0 | b] = _, _ = (B[0 | (ie = (b = 1 | U) + A | 0)] - B[g + b | 0] | 0) + (_ << 23 >> 31) | 0, j[0 | ie] = _, _ = _ << 23 >> 31, U = U + 2 | 0, (0 | (he = he + 2 | 0)) != 64; )
                        ;
                    }
                    function vn(A, g, _, b, U, ie, he) {
                      var D;
                      if (st = D = st + -64 | 0, !b & _ >>> 0 < 4294967280)
                        return ls(D + 32 | 0, he, ie) ? he = -1 : (he = -1, Ji(D, 35296, D + 32 | 0, 0) || (he = $i(A + 16 | 0, A, g, _, b, U, D), Wr(D, 32))), st = D - -64 | 0, he;
                      Ai(), Xr();
                    }
                    function zn(A, g) {
                      for (var _ = 0, b = 0, U = 0, ie = 0, he = 0; b = A + U | 0, _ = B[g + U | 0] + (B[0 | b] + _ | 0) | 0, j[0 | b] = _, ie = (b = 1 | U) + A | 0, _ = B[g + b | 0] + (B[0 | ie] + (_ >>> 8 | 0) | 0) | 0, j[0 | ie] = _, _ = _ >>> 8 | 0, U = U + 2 | 0, (0 | (he = he + 2 | 0)) != 32; )
                        ;
                    }
                    function jn(A, g) {
                      A |= 0;
                      var _, b = 0, U = 0, ie = 0;
                      if (st = _ = st - 16 | 0, g |= 0)
                        for (; j[_ + 15 | 0] = 0, U = A + b | 0, ie = 0 | ks(35752, _ + 15 | 0, 0), j[0 | U] = ie, (0 | (b = b + 1 | 0)) != (0 | g); )
                          ;
                      st = _ + 16 | 0;
                    }
                    function _r(A, g, _, b, U, ie, he) {
                      var D, me = 0;
                      return st = D = st - 32 | 0, me = -1, !b & _ >>> 0 < 16 || Rs(D, ie, he) || (me = La(A, g + 16 | 0, g, _ - 16 | 0, b - (_ >>> 0 < 16) | 0, U, D), Wr(D, 32)), st = D + 32 | 0, me;
                    }
                    function br(A) {
                      var g, _;
                      return (A = (g = l[8924]) + (_ = A + 7 & -8) | 0) >>> 0 <= g >>> 0 && _ || A >>> 0 > Ic() << 16 >>> 0 && !(0 | qa(0 | A)) ? (l[9129] = 48, -1) : (l[8924] = A, g);
                    }
                    function kr(A, g) {
                      var _, b, U;
                      st = _ = st - 176 | 0, Mn(b = _ + 96 | 0, g + 80 | 0), In(U = _ + 48 | 0, g, b), In(_, g + 40 | 0, b), Ei(A, _), Ei(_ + 144 | 0, U), j[A + 31 | 0] = B[A + 31 | 0] ^ B[_ + 144 | 0] << 7, st = _ + 176 | 0;
                    }
                    function Qr(A, g, _) {
                      var b = 0;
                      if (A >>> 0 < g >>> 0)
                        return xr(A, g, _);
                      if (_)
                        for (b = A + _ | 0, g = g + _ | 0; g = g - 1 | 0, j[0 | (b = b - 1 | 0)] = B[0 | g], _ = _ - 1 | 0; )
                          ;
                      return A;
                    }
                    function Ur(A, g, _, b, U, ie, he) {
                      var D, me = 0;
                      if (st = D = st - 32 | 0, !b & _ >>> 0 < 4294967280)
                        return me = -1, Rs(D, ie, he) || (me = va(A + 16 | 0, A, g, _, b, U, D), Wr(D, 32)), st = D + 32 | 0, me;
                      Ai(), Xr();
                    }
                    function Lr(A, g, _, b, U, ie, he, D, me, _e) {
                      var Be, ye = 0, we = 0, $e = 0;
                      return st = Be = st - 16 | 0, ye = -1, Js(Be) || (we = -1, $e = Gs(Be, A, g, _, b, U, ie, he, D, me, _e), ye = Eo(Be) ? we : $e), st = Be + 16 | 0, ye;
                    }
                    function Jr(A, g, _, b, U, ie) {
                      return g |= 0, 0 | (!(b |= 0) & (_ |= 0) >>> 0 >= 16 | b ? La(A |= 0, g + 16 | 0, g, _ - 16 | 0, b - (_ >>> 0 < 16) | 0, U |= 0, ie |= 0) : -1);
                    }
                    function jr(A, g, _, b, U, ie) {
                      return g |= 0, 0 | (!(b |= 0) & (_ |= 0) >>> 0 >= 16 | b ? Ha(A |= 0, g + 16 | 0, g, _ - 16 | 0, b - (_ >>> 0 < 16) | 0, U |= 0, ie |= 0) : -1);
                    }
                    function oo(A, g, _) {
                      A |= 0;
                      var b, U = 0;
                      return st = b = st - 32 | 0, U = -1, ls(b, _ |= 0, g |= 0) || (U = bs(A, 35232, b, 0)), st = b + 32 | 0, 0 | U;
                    }
                    function uo(A, g) {
                      var _;
                      return g |= 0, st = _ = st + -64 | 0, Ui(A |= 0, _), Di(A = A + 208 | 0, _, 64, 0), Ui(A, g), Wr(_, 64), st = _ - -64 | 0, 0;
                    }
                    function _o(A, g, _, b) {
                      var U;
                      return g |= 0, _ |= 0, b |= 0, st = U = st + -64 | 0, Ui(A |= 0, U), A = aa(g, _, U, 64, 0, b, 1), st = U - -64 | 0, 0 | A;
                    }
                    function So(A, g) {
                      var _, b, U;
                      In(A, g, _ = g + 120 | 0), In(A + 40 | 0, b = g + 40 | 0, U = g + 80 | 0), In(A + 80 | 0, U, _), In(A + 120 | 0, g, b);
                    }
                    function Ao(A, g, _, b, U, ie, he) {
                      return 0 | An(A |= 0, g |= 0, (A = 0) | (_ |= 0), b |= 0, A | (U |= 0), ie |= 0, he |= 0);
                    }
                    function bo(A, g) {
                      var _;
                      return g |= 0, st = _ = st - 32 | 0, ke(A |= 0, _), dt(A = A + 104 | 0, _, 32, 0), ke(A, g), Wr(_, 32), st = _ + 32 | 0, 0;
                    }
                    function xr(A, g, _) {
                      var b = 0;
                      if (_)
                        for (b = A; j[0 | b] = B[0 | g], b = b + 1 | 0, g = g + 1 | 0, _ = _ - 1 | 0; )
                          ;
                      return A;
                    }
                    function Oo(A, g, _, b, U, ie) {
                      var he;
                      return st = he = st - 32 | 0, bs(he, U, ie, 0), A = As(A, g, _, b, U + 16 | 0, 0, 0, he), Wr(he, 32), st = he + 32 | 0, A;
                    }
                    function Yn(A) {
                      for (A |= 0; jn(A, 32), j[A + 31 | 0] = 31 & B[A + 31 | 0], !Pt(A) || le(A, 32); )
                        ;
                    }
                    function ir(A, g, _) {
                      var b;
                      return g |= 0, _ |= 0, st = b = st + -64 | 0, Ui(A |= 0, b), A = ua(g, b, 64, 0, _, 1), st = b - -64 | 0, 0 | A;
                    }
                    function Bt(A, g, _, b, U) {
                      var ie;
                      return st = ie = st - 32 | 0, bs(ie, b, U, 0), A = Ua(A, g, _, b + 16 | 0, ie), Wr(ie, 32), st = ie + 32 | 0, A;
                    }
                    function Jt(A, g, _) {
                      var b = 0;
                      if (_)
                        for (b = A; j[0 | b] = g, b = b + 1 | 0, _ = _ - 1 | 0; )
                          ;
                      return A;
                    }
                    function mn(A, g, _) {
                      return A |= 0, g |= 0, (_ |= 0) >>> 0 >= 256 && (Hs(1349, 1262, 107, 1123), Xr()), 0 | la(A, g, 255 & _);
                    }
                    function Hr(A, g, _, b, U, ie, he) {
                      return 0 | va(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }
                    function Vr(A, g, _, b, U, ie, he) {
                      return 0 | La(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }
                    function ro(A, g, _, b, U, ie, he, D) {
                      return (0 | b) == 1 | b >>> 0 > 1 && (Ai(), Xr()), 0 | Xi[l[8936]](A, g, _, b, U, ie, he, D);
                    }
                    function io(A, g, _, b, U, ie, he) {
                      return 0 | $i(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }
                    function fo(A, g, _, b, U, ie, he) {
                      return 0 | Ha(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }
                    function po(A, g, _, b, U, ie) {
                      return (0 | b) == 1 | b >>> 0 > 1 && (Ai(), Xr()), 0 | Xi[l[8936]](A, g, _, b, U, 0, 0, ie);
                    }
                    function mo(A, g, _, b, U, ie) {
                      return (0 | b) == 1 | b >>> 0 > 1 && (Ai(), Xr()), 0 | Xi[l[8937]](A, g, _, b, U, 0, ie);
                    }
                    function ho(A, g, _, b, U, ie) {
                      return aa(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, 0), 0;
                    }
                    function tn(A, g) {
                      var _ = 0;
                      return (-1 >>> (_ = 31 & g) & A) << _ | ((_ = A) & -1 << (A = 0 - g & 31)) >>> A;
                    }
                    function Eo(A) {
                      var g;
                      return (g = l[A >> 2]) && wi(g), l[A + 8 >> 2] = 0, l[A >> 2] = 0, l[A + 4 >> 2] = 0, 0;
                    }
                    function To(A, g, _, b, U, ie) {
                      return 0 | qt(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0);
                    }
                    function Do(A, g, _, b, U, ie) {
                      return 0 | xa(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0);
                    }
                    function Lo(A, g, _, b, U, ie) {
                      return 0 | Oo(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0);
                    }
                    function Ho(A, g, _, b, U) {
                      return (0 | _) == 1 | _ >>> 0 > 1 && (Ai(), Xr()), 0 | Xi[l[8934]](A, g, _, b, U);
                    }
                    function Vo(A, g, _, b, U) {
                      return (0 | _) == 1 | _ >>> 0 > 1 && (Ai(), Xr()), 0 | Xi[l[8935]](A, g, _, b, U);
                    }
                    function ri(A, g, _, b, U, ie) {
                      (0 | b) == 1 | b >>> 0 > 1 && (Ai(), Xr()), Xi[l[8937]](A, g, _, b, U, 1, ie);
                    }
                    function ci(A, g, _, b, U) {
                      return 0 | ua(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, 0);
                    }
                    function li(A, g, _, b, U) {
                      return 0 | Ga(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0);
                    }
                    function mi(A, g, _, b, U) {
                      return 0 | du(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0);
                    }
                    function yi(A, g, _, b, U) {
                      return 0 | Bt(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0);
                    }
                    function Mi() {
                      var A;
                      st = A = st - 16 | 0, j[A + 15 | 0] = 0, ks(35788, A + 15 | 0, 0), st = A + 16 | 0;
                    }
                    function Fi(A, g, _, b) {
                      return ha(A |= 0, g |= 0, _ |= 0, b |= 0, 20), 0;
                    }
                    function Yi(A, g, _, b) {
                      return ha(A |= 0, g |= 0, _ |= 0, b |= 0, 12), 0;
                    }
                    function us(A, g, _, b) {
                      return ha(A |= 0, g |= 0, _ |= 0, b |= 0, 8), 0;
                    }
                    function As(A, g, _, b, U, ie, he, D) {
                      return 0 | Xi[l[8933]](A, g, _, b, U, ie, he, D);
                    }
                    function Vs(A, g, _, b) {
                      return 0 | Pu(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }
                    function Qs(A, g, _, b) {
                      return 0 | L(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }
                    function oa(A, g, _, b) {
                      return 0 | ni(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }
                    function Ns(A, g, _, b) {
                      return 0 | Di(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }
                    function fs(A, g, _, b) {
                      return 0 | ea(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }
                    function Us(A, g, _, b, U, ie) {
                      return 0 | Xi[l[8933]](A, g, _, b, U, 0, 0, ie);
                    }
                    function Js(A) {
                      return l[A + 8 >> 2] = 0, l[A >> 2] = 0, l[A + 4 >> 2] = 0, 0;
                    }
                    function Rs(A, g, _) {
                      return 0 | oo(A |= 0, g |= 0, _ |= 0);
                    }
                    function ia(A, g, _) {
                      return 0 | ls(A |= 0, g |= 0, _ |= 0);
                    }
                    function Ss(A, g, _) {
                      return 0 | mn(A |= 0, g |= 0, _ |= 0);
                    }
                    function Ai() {
                      var A;
                      (A = l[9261]) && Xi[0 | A](), Oa(), Xr();
                    }
                    function $a(A, g) {
                      return A |= 0, jn(g |= 0, 32), 0 | Ma(A, g);
                    }
                    function Ma(A, g) {
                      return A |= 0, g |= 0, 0 | Xi[l[8931]](A, g);
                    }
                    function Ga(A, g, _, b, U) {
                      return 0 | Xi[l[8925]](A, g, _, b, U);
                    }
                    function Ua(A, g, _, b, U) {
                      return 0 | Xi[l[8932]](A, g, _, b, U);
                    }
                    function ys(A, g) {
                      return A |= 0, g |= 0, 0 | Xi[l[8927]](A, g);
                    }
                    function du(A, g, _, b, U) {
                      return 0 | Xi[l[8926]](A, g, _, b, U);
                    }
                    function sa(A, g) {
                      return A |= 0, g |= 0, 0 | Xi[l[8929]](A, g);
                    }
                    function ku(A, g, _, b, U, ie, he) {
                      return qe(A, g, _, b, U, ie, he);
                    }
                    function lu(A) {
                      return A ? 31 - zi(A - 1 ^ A) | 0 : 32;
                    }
                    function ni(A, g, _, b) {
                      return 0 | Xi[l[8928]](A, g, _, b);
                    }
                    function oc(A, g) {
                      return 0 | Mt(A |= 0, g |= 0, 64);
                    }
                    function fu(A, g) {
                      return 0 | Mt(A |= 0, g |= 0, 32);
                    }
                    function ic(A, g, _) {
                      gr(A |= 0, g |= 0, _ |= 0);
                    }
                    function Bu(A, g) {
                      return 0 | Ma(A |= 0, g |= 0);
                    }
                    function sc(A, g) {
                      return 0 | $a(A |= 0, g |= 0);
                    }
                    function Pu(A, g, _, b) {
                      return Di(A, g, _, b), 0;
                    }
                    function Eu(A, g, _, b) {
                      return dt(A, g, _, b), 0;
                    }
                    function ac(A, g, _, b) {
                      return Ja(A, g, _, b, 1);
                    }
                    function uc(A, g, _, b) {
                      return Xa(A, g, _, b, 1);
                    }
                    function cc(A, g, _, b) {
                      return Xa(A, g, _, b, 2);
                    }
                    function dc(A, g, _, b) {
                      return Ja(A, g, _, b, 2);
                    }
                    function Is(A, g, _, b) {
                      return to(A, g, _, b);
                    }
                    function fc(A) {
                      return ae(A |= 0), 0;
                    }
                    function Ru() {
                      return -2147483648;
                    }
                    function $u() {
                      return 1073741824;
                    }
                    function pc() {
                      return 268435456;
                    }
                    function Li(A) {
                      jn(A |= 0, 32);
                    }
                    function mc() {
                      return 33554432;
                    }
                    function gc() {
                      return 67108864;
                    }
                    function hc() {
                      return 16777216;
                    }
                    function Wr(A, g) {
                      Jt(A, 0, g);
                    }
                    function Mu() {
                      return 8192;
                    }
                    function Ac() {
                      return 1559;
                    }
                    function pu() {
                      return 208;
                    }
                    function yc() {
                      return 1321;
                    }
                    function vc() {
                      return 384;
                    }
                    function _c() {
                      return 416;
                    }
                    function bc() {
                      return 256;
                    }
                    function Tu() {
                      return 128;
                    }
                    function Zi() {
                      return 64;
                    }
                    function si() {
                      return 16;
                    }
                    function wo() {
                      return 32;
                    }
                    function Cc() {
                      return 48;
                    }
                    function Ta() {
                      return -17;
                    }
                    function fa() {
                      return 24;
                    }
                    function Sc() {
                      return 12;
                    }
                    function wc() {
                      return -65;
                    }
                    function Du() {
                      return 4;
                    }
                    function eu() {
                      return 1;
                    }
                    function tu() {
                      return 3;
                    }
                    function ji() {
                      return -1;
                    }
                    function Ka() {
                      return 2;
                    }
                    function Da() {
                      return 0;
                    }
                    function ba() {
                      return 8;
                    }
                    eo(vr = B, 1024, "Li8wMTIzNDU2Nzg5QUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5egBqcwByYW5kb21ieXRlcwBiNjRfcG9zIDw9IGI2NF9sZW4AY3J5cHRvX2dlbmVyaWNoYXNoX2JsYWtlMmJfZmluYWwAJGFyZ29uMmkAJGFyZ29uMmlkAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAeDI1NTE5Ymxha2UyYgBidWZfbGVuIDw9IFNJWkVfTUFYAG91dGxlbiA8PSBVSU5UOF9NQVgAUy0+YnVmbGVuIDw9IEJMQUtFMkJfQkxPQ0tCWVRFUwAkYXJnb24yaSR2PQAkYXJnb24yaWQkdj0ALHQ9ACxwPQAkbT0AY3VydmUyNTUxOQBlZDI1NTE5ADEuMC4xOABobWFjc2hhNTEyMjU2AGN1cnZlMjU1MTl4c2Fsc2EyMHBvbHkxMzA1AHNvZGl1bV9iaW4yYmFzZTY0AHNpcGhhc2gyNABzaGE1MTIAeHNhbHNhMjAAJGFyZ29uMmkkACRhcmdvbjJpZCQAJDckAExpYnNvZGl1bURSRw=="), eo(vr, 1600, "tnhZ/4Vy0wC9bhX/DwpqACnAAQCY6Hn/vDyg/5lxzv8At+L+tA1I/wAAAAAAAAAAsKAO/tPJhv+eGI8Af2k1AGAMvQCn1/v/n0yA/mpl4f8e/AQAkgyu"), eo(vr, 1696, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), eo(vr, 1744, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), eo(vr, 2736, "AQ=="), eo(vr, 2768, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), eo(vr, 2959, "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"), eo(vr, 33980, "AQAAAHbBXwBlcAL/UPyh/vJqxv+FBrIA5N9wAN/uVf4z8xoAPiuL/stBCg=="), eo(vr, 34032, "M03tAJGqVv82JjP/8YBl/yl5Sv/sTpsAqZdp/pwpSADCZq//zqJl/wAAAAAAAAAAGy57ARKo/f/Tr5f+w9tgADh2vv7+0fX/mWR+/uiBFf81uPL/x6Td"), eo(vr, 34160, "AQ=="), eo(vr, 34192, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////fw=="), eo(vr, 34368, "7dP1XBpjEljWnPei3vneFA=="), eo(vr, 34399, "EAjJvPNn5glqO6fKhIWuZ7sr+JT+cvNuPPE2HV869U+l0YLmrX9SDlEfbD4rjGgFm2u9Qfur2YMfeSF+ExnN4FsirijXmC+KQs1l7yORRDdxLztN7M/7wLW824mBpdu16Ti1SPNbwlY5GdAFtvER8VmbTxmvpII/khiBbdrVXhyrQgIDo5iqB9i+b3BFAVuDEoyy5E6+hTEk4rT/1cN9DFVviXvydF2+crGWFjv+sd6ANRLHJacG3JuUJmnPdPGbwdJK8Z7BaZvk4yVPOIZHvu+11YyLxp3BD2WcrHfMoQwkdQIrWW8s6S2D5KZuqoR0StT7Qb3cqbBctVMRg9qI+Xar32buUlE+mBAytC1txjGoPyH7mMgnA7DkDu++x39Zv8KPqD3zC+DGJacKk0eRp9VvggPgUWPKBnBuDgpnKSkU/C/SRoUKtycmySZcOCEbLu0qxFr8bSxN37OVnRMNOFPeY6+LVHMKZaiydzy7Cmp25q7tRy7JwoE7NYIUhSxykmQD8Uyh6L+iATBCvEtmGqiRl/jQcItLwjC+VAajUWzHGFLv1hnoktEQqWVVJAaZ1iogcVeFNQ70uNG7MnCgahDI0NK4FsGkGVOrQVEIbDcemeuO30x3SCeoSJvhtbywNGNaycWzDBw5y4pB40qq2E5z42N3T8qcW6O4stbzby5o/LLvXe6Cj3RgLxdDb2OleHKr8KEUeMiE7DlkGggCx4woHmMj+v++kOm9gt7rbFCkFXnGsvej+b4rU3Lj8nhxxpxhJurOPifKB8LAIce4htEe6+DN1n3a6njRbu5/T331um8Xcqpn8AammMiixX1jCq4N+b4EmD8RG0ccEzULcRuEfQQj9XfbKJMkx0B7q8oyvL7JFQq+njxMDRCcxGcdQ7ZCPsu+1MVMKn5l/Jwpf1ns+tY6q2/LXxdYR0qMGURsgA=="), eo(vr, 35248, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), eo(vr, 35328, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), eo(vr, 35696, "wJABAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0=");
                    var nu, Xi = (nu = [null, function(A, g, _, b, U) {
                      var ie, he, D;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, st = ie = (he = st) - 128 & -64, l[ie >> 2] = 67108863 & (B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24), l[ie + 4 >> 2] = (B[U + 3 | 0] | B[U + 4 | 0] << 8 | B[U + 5 | 0] << 16 | B[U + 6 | 0] << 24) >>> 2 & 67108611, l[ie + 8 >> 2] = (B[U + 6 | 0] | B[U + 7 | 0] << 8 | B[U + 8 | 0] << 16 | B[U + 9 | 0] << 24) >>> 4 & 67092735, l[ie + 12 >> 2] = (B[U + 9 | 0] | B[U + 10 | 0] << 8 | B[U + 11 | 0] << 16 | B[U + 12 | 0] << 24) >>> 6 & 66076671, D = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, l[ie + 20 >> 2] = 0, l[ie + 24 >> 2] = 0, l[ie + 28 >> 2] = 0, l[ie + 32 >> 2] = 0, l[ie + 36 >> 2] = 0, l[ie + 16 >> 2] = D >>> 8 & 1048575, l[ie + 40 >> 2] = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, l[ie + 44 >> 2] = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, l[ie + 48 >> 2] = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, U = B[U + 28 | 0] | B[U + 29 | 0] << 8 | B[U + 30 | 0] << 16 | B[U + 31 | 0] << 24, j[ie + 80 | 0] = 0, l[ie + 56 >> 2] = 0, l[ie + 60 >> 2] = 0, l[ie + 52 >> 2] = U, yt(ie, g, _, b), Fa(ie, A), st = he, 0;
                    }, function(A, g, _, b, U) {
                      var ie, he, D;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, st = ie = (he = st) - 192 & -64, l[ie + 64 >> 2] = 67108863 & (B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24), l[ie + 68 >> 2] = (B[U + 3 | 0] | B[U + 4 | 0] << 8 | B[U + 5 | 0] << 16 | B[U + 6 | 0] << 24) >>> 2 & 67108611, l[ie + 72 >> 2] = (B[U + 6 | 0] | B[U + 7 | 0] << 8 | B[U + 8 | 0] << 16 | B[U + 9 | 0] << 24) >>> 4 & 67092735, l[ie + 76 >> 2] = (B[U + 9 | 0] | B[U + 10 | 0] << 8 | B[U + 11 | 0] << 16 | B[U + 12 | 0] << 24) >>> 6 & 66076671, D = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, l[ie + 84 >> 2] = 0, l[ie + 88 >> 2] = 0, l[ie + 92 >> 2] = 0, l[ie + 96 >> 2] = 0, l[ie + 100 >> 2] = 0, l[ie + 80 >> 2] = D >>> 8 & 1048575, l[ie + 104 >> 2] = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, l[ie + 108 >> 2] = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, l[ie + 112 >> 2] = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, U = B[U + 28 | 0] | B[U + 29 | 0] << 8 | B[U + 30 | 0] << 16 | B[U + 31 | 0] << 24, j[ie + 144 | 0] = 0, l[ie + 120 >> 2] = 0, l[ie + 124 >> 2] = 0, l[ie + 116 >> 2] = U, yt(U = ie - -64 | 0, g, _, b), Fa(U, g = ie + 48 | 0), A = Es(A, g), st = he, 0 | A;
                    }, function(A, g) {
                      var _;
                      return g |= 0, l[(A |= 0) >> 2] = 67108863 & (B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24), l[A + 4 >> 2] = (B[g + 3 | 0] | B[g + 4 | 0] << 8 | B[g + 5 | 0] << 16 | B[g + 6 | 0] << 24) >>> 2 & 67108611, l[A + 8 >> 2] = (B[g + 6 | 0] | B[g + 7 | 0] << 8 | B[g + 8 | 0] << 16 | B[g + 9 | 0] << 24) >>> 4 & 67092735, l[A + 12 >> 2] = (B[g + 9 | 0] | B[g + 10 | 0] << 8 | B[g + 11 | 0] << 16 | B[g + 12 | 0] << 24) >>> 6 & 66076671, _ = B[g + 12 | 0] | B[g + 13 | 0] << 8 | B[g + 14 | 0] << 16 | B[g + 15 | 0] << 24, l[A + 20 >> 2] = 0, l[A + 24 >> 2] = 0, l[A + 28 >> 2] = 0, l[A + 32 >> 2] = 0, l[A + 36 >> 2] = 0, l[A + 16 >> 2] = _ >>> 8 & 1048575, l[A + 40 >> 2] = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, l[A + 44 >> 2] = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, l[A + 48 >> 2] = B[g + 24 | 0] | B[g + 25 | 0] << 8 | B[g + 26 | 0] << 16 | B[g + 27 | 0] << 24, g = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, j[A + 80 | 0] = 0, l[A + 56 >> 2] = 0, l[A + 60 >> 2] = 0, l[A + 52 >> 2] = g, 0;
                    }, function(A, g, _, b) {
                      return yt(A |= 0, g |= 0, _ |= 0, b |= 0), 0;
                    }, function(A, g) {
                      return Fa(A |= 0, g |= 0), 0;
                    }, function(A, g, _) {
                      A |= 0, g |= 0, _ |= 0;
                      var b, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0, Nn = 0, cr = 0, Rr = 0, Ir = 0, Pr = 0, qr = 0, ao = 0, Fn = 0, Wn = 0, wt = 0, jt = 0, an = 0, Ar = 0, Tr = 0, zr = 0, Gr = 0, no = 0, so = 0, co = 0, lo = 0, yo = 0;
                      for (st = b = st - 368 | 0; Le = (he = B[_ + U | 0]) ^ B[0 | (me = U + 34128 | 0)] | Le, we = he ^ B[me + 192 | 0] | we, $e = he ^ B[me + 160 | 0] | $e, ye = he ^ B[me + 128 | 0] | ye, D = he ^ B[me + 96 | 0] | D, _e = he ^ B[me - -64 | 0] | _e, ie = he ^ B[me + 32 | 0] | ie, (0 | (U = U + 1 | 0)) != 31; )
                        ;
                      if (U = -1, !(256 & ((255 & ((he = 127 ^ (me = 127 & B[_ + 31 | 0])) | we)) - 1 | (255 & (he | $e)) - 1 | (255 & (he | ye)) - 1 | (255 & (87 ^ me | D)) - 1 | (255 & (_e | me)) - 1 | (255 & (ie | me)) - 1 | (255 & (me | Le)) - 1))) {
                        for (U = g, g = B[g + 28 | 0] | B[g + 29 | 0] << 8 | B[g + 30 | 0] << 16 | B[g + 31 | 0] << 24, l[b + 360 >> 2] = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, l[b + 364 >> 2] = g, g = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, l[b + 352 >> 2] = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, l[b + 356 >> 2] = g, ie = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, g = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[b + 336 >> 2] = g, l[b + 340 >> 2] = ie, ie = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, l[b + 344 >> 2] = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24, l[b + 348 >> 2] = ie, j[b + 336 | 0] = 248 & g, j[b + 367 | 0] = 63 & B[b + 367 | 0] | 64, gs(b + 288 | 0, _), l[b + 260 >> 2] = 0, l[b + 264 >> 2] = 0, l[b + 268 >> 2] = 0, l[b + 272 >> 2] = 0, l[b + 276 >> 2] = 0, l[b + 208 >> 2] = 0, l[b + 212 >> 2] = 0, l[b + 216 >> 2] = 0, l[b + 220 >> 2] = 0, l[b + 224 >> 2] = 0, l[b + 228 >> 2] = 0, l[b + 244 >> 2] = 0, l[b + 248 >> 2] = 0, l[b + 240 >> 2] = 1, l[b + 252 >> 2] = 0, l[b + 256 >> 2] = 0, l[b + 192 >> 2] = 0, l[b + 196 >> 2] = 0, l[b + 200 >> 2] = 0, l[b + 204 >> 2] = 0, g = l[b + 316 >> 2], l[b + 168 >> 2] = l[b + 312 >> 2], l[b + 172 >> 2] = g, g = l[b + 308 >> 2], l[b + 160 >> 2] = l[b + 304 >> 2], l[b + 164 >> 2] = g, g = l[b + 300 >> 2], l[b + 152 >> 2] = l[b + 296 >> 2], l[b + 156 >> 2] = g, g = l[b + 292 >> 2], l[b + 144 >> 2] = l[b + 288 >> 2], l[b + 148 >> 2] = g, g = l[b + 324 >> 2], l[b + 176 >> 2] = l[b + 320 >> 2], l[b + 180 >> 2] = g, l[b + 116 >> 2] = 0, l[b + 120 >> 2] = 0, l[b + 124 >> 2] = 0, l[b + 128 >> 2] = 0, l[b + 132 >> 2] = 0, l[b + 100 >> 2] = 0, l[b + 104 >> 2] = 0, l[b + 96 >> 2] = 1, l[b + 108 >> 2] = 0, l[b + 112 >> 2] = 0, _ = 254; or = l[b + 276 >> 2], he = l[b + 180 >> 2], ur = l[b + 96 >> 2], Cr = l[b + 192 >> 2], Je = l[b + 144 >> 2], Ve = l[b + 240 >> 2], ut = l[b + 100 >> 2], Nn = l[b + 196 >> 2], cr = l[b + 148 >> 2], Rr = l[b + 244 >> 2], en = l[b + 104 >> 2], Ir = l[b + 200 >> 2], it = l[b + 152 >> 2], Pr = l[b + 248 >> 2], _n = l[b + 108 >> 2], qr = l[b + 204 >> 2], St = l[b + 156 >> 2], ao = l[b + 252 >> 2], Ft = l[b + 112 >> 2], Fn = l[b + 208 >> 2], Tt = l[b + 160 >> 2], Wn = l[b + 256 >> 2], Le = l[b + 116 >> 2], wt = l[b + 212 >> 2], Be = l[b + 164 >> 2], jt = l[b + 260 >> 2], we = l[b + 120 >> 2], an = l[b + 216 >> 2], $e = l[b + 168 >> 2], Ar = l[b + 264 >> 2], ye = l[b + 124 >> 2], Tr = l[b + 220 >> 2], D = l[b + 172 >> 2], zr = l[b + 268 >> 2], _e = l[b + 128 >> 2], Gr = l[b + 224 >> 2], ie = l[b + 176 >> 2], no = l[b + 272 >> 2], so = _, Gt = (ht = (g = 0 - ((g = Sn) ^ (Sn = B[b + 336 + (_ >>> 3) | 0] >>> (7 & _) & 1)) | 0) & ((U = l[b + 132 >> 2]) ^ (Hn = l[b + 228 >> 2]))) ^ U, l[b + 132 >> 2] = Gt, Zn = he ^ (je = g & (he ^ or)), l[b + 84 >> 2] = Zn - Gt, fn = _e ^ (ct = g & (_e ^ Gr)), l[b + 128 >> 2] = fn, er = (Ct = g & (ie ^ no)) ^ ie, l[b + 80 >> 2] = er - fn, $n = ye ^ (mt = g & (ye ^ Tr)), l[b + 124 >> 2] = $n, co = D ^ (bt = g & (D ^ zr)), l[b + 76 >> 2] = co - $n, qn = we ^ (Ge = g & (we ^ an)), l[b + 120 >> 2] = qn, lo = $e ^ (me = g & ($e ^ Ar)), l[b + 72 >> 2] = lo - qn, Gn = Le ^ (he = g & (Le ^ wt)), l[b + 116 >> 2] = Gn, yo = Be ^ (Le = g & (Be ^ jt)), l[b + 68 >> 2] = yo - Gn, Kn = Ft ^ (we = g & (Ft ^ Fn)), l[b + 112 >> 2] = Kn, wn = Tt ^ ($e = g & (Tt ^ Wn)), l[b + 64 >> 2] = wn - Kn, Kt = _n ^ (ye = g & (_n ^ qr)), l[b + 108 >> 2] = Kt, Zt = St ^ (D = g & (St ^ ao)), l[b + 60 >> 2] = Zt - Kt, pn = en ^ (_e = g & (en ^ Ir)), l[b + 104 >> 2] = pn, _n = it ^ (ie = g & (it ^ Pr)), l[b + 56 >> 2] = _n - pn, en = ut ^ (U = g & (ut ^ Nn)), l[b + 100 >> 2] = en, St = cr ^ (_ = g & (cr ^ Rr)), l[b + 52 >> 2] = St - en, it = ur ^ (Ft = g & (ur ^ Cr)), l[b + 96 >> 2] = it, Tt = (g &= Je ^ Ve) ^ Je, l[b + 48 >> 2] = Tt - it, Be = je ^ or, ht ^= Hn, l[b + 36 >> 2] = Be - ht, je = Ct ^ no, ct ^= Gr, l[b + 32 >> 2] = je - ct, Ct = bt ^ zr, mt ^= Tr, l[b + 28 >> 2] = Ct - mt, bt = me ^ Ar, Ge ^= an, l[b + 24 >> 2] = bt - Ge, me = Le ^ jt, he ^= wt, l[b + 20 >> 2] = me - he, Le = $e ^ Wn, we ^= Fn, l[b + 16 >> 2] = Le - we, $e = D ^ ao, ye ^= qr, l[b + 12 >> 2] = $e - ye, D = ie ^ Pr, _e ^= Ir, l[b + 8 >> 2] = D - _e, ie = _ ^ Rr, U ^= Nn, l[b + 4 >> 2] = ie - U, _ = g ^ Ve, g = Ft ^ Cr, l[b >> 2] = _ - g, l[b + 276 >> 2] = Be + ht, l[b + 272 >> 2] = je + ct, l[b + 268 >> 2] = mt + Ct, l[b + 264 >> 2] = Ge + bt, l[b + 260 >> 2] = he + me, l[b + 256 >> 2] = we + Le, l[b + 248 >> 2] = D + _e, l[b + 244 >> 2] = U + ie, l[b + 240 >> 2] = g + _, l[b + 252 >> 2] = ye + $e, l[b + 228 >> 2] = Gt + Zn, l[b + 224 >> 2] = fn + er, l[b + 220 >> 2] = $n + co, l[b + 216 >> 2] = qn + lo, l[b + 212 >> 2] = Gn + yo, l[b + 208 >> 2] = wn + Kn, l[b + 204 >> 2] = Kt + Zt, l[b + 200 >> 2] = _n + pn, l[b + 196 >> 2] = en + St, l[b + 192 >> 2] = Tt + it, In(Zn = b + 96 | 0, fn = b + 48 | 0, Tt = b + 240 | 0), In(Gt = b + 192 | 0, Gt, b), Ot(fn, b), Ot(b, Tt), Be = l[b + 192 >> 2], ht = l[b + 96 >> 2], je = l[b + 196 >> 2], ct = l[b + 100 >> 2], Ct = l[b + 200 >> 2], mt = l[b + 104 >> 2], bt = l[b + 204 >> 2], Ge = l[b + 108 >> 2], me = l[b + 208 >> 2], he = l[b + 112 >> 2], Le = l[b + 212 >> 2], we = l[b + 116 >> 2], $e = l[b + 216 >> 2], ye = l[b + 120 >> 2], D = l[b + 220 >> 2], _e = l[b + 124 >> 2], ie = l[b + 224 >> 2], U = l[b + 128 >> 2], _ = l[b + 228 >> 2], g = l[b + 132 >> 2], l[b + 180 >> 2] = _ + g, l[b + 176 >> 2] = U + ie, l[b + 172 >> 2] = D + _e, l[b + 168 >> 2] = ye + $e, l[b + 164 >> 2] = we + Le, l[b + 160 >> 2] = he + me, l[b + 156 >> 2] = Ge + bt, l[b + 152 >> 2] = mt + Ct, l[b + 148 >> 2] = je + ct, l[b + 144 >> 2] = Be + ht, l[b + 228 >> 2] = g - _, l[b + 224 >> 2] = U - ie, l[b + 220 >> 2] = _e - D, l[b + 216 >> 2] = ye - $e, l[b + 212 >> 2] = we - Le, l[b + 208 >> 2] = he - me, l[b + 204 >> 2] = Ge - bt, l[b + 200 >> 2] = mt - Ct, l[b + 196 >> 2] = ct - je, l[b + 192 >> 2] = ht - Be, In(Tt, b, fn), $n = l[b + 52 >> 2], Ge = l[b + 4 >> 2], qn = l[b + 56 >> 2], me = l[b + 8 >> 2], Gn = l[b + 64 >> 2], he = l[b + 16 >> 2], Kn = l[b + 60 >> 2], ye = l[b + 12 >> 2], Kt = l[b + 72 >> 2], D = l[b + 24 >> 2], pn = l[b + 68 >> 2], _e = l[b + 20 >> 2], en = l[b + 80 >> 2], U = l[b + 32 >> 2], it = l[b + 76 >> 2], _ = l[b + 28 >> 2], Hn = l[b + 84 >> 2], g = l[b + 36 >> 2], er = l[b + 48 >> 2], ie = l[b >> 2] - er | 0, l[b >> 2] = ie, g = g - Hn | 0, l[b + 36 >> 2] = g, Ft = _ - it | 0, l[b + 28 >> 2] = Ft, Tt = U - en | 0, l[b + 32 >> 2] = Tt, Le = _e - pn | 0, l[b + 20 >> 2] = Le, we = D - Kt | 0, l[b + 24 >> 2] = we, $e = ye - Kn | 0, l[b + 12 >> 2] = $e, ye = he - Gn | 0, l[b + 16 >> 2] = ye, D = me - qn | 0, l[b + 8 >> 2] = D, U = Ge - $n | 0, l[b + 4 >> 2] = U, Ot(Gt, Gt), g = De(g, g >> 31, 121666, 0), _ = ve, Zt = g, g = De((33554431 & (_ = (Be = g + 16777216 | 0) >>> 0 < 16777216 ? _ + 1 | 0 : _)) << 7 | Be >>> 25, _ >> 25, 19, 0), _e = ve, _ = g, g = De(ie, ie >> 31, 121666, 0), wn = ve + _e | 0, g = g >>> 0 > (_ = _ + g | 0) >>> 0 ? wn + 1 | 0 : wn, g = (_e = _ + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g, ht = _ - (-67108864 & _e) | 0, l[b + 96 >> 2] = ht, ie = De(U, U >> 31, 121666, 0), _ = ve, _ = (U = ie + 16777216 | 0) >>> 0 < 16777216 ? _ + 1 | 0 : _, je = (g = (67108863 & g) << 6 | _e >>> 26) + (ie - (-33554432 & U) | 0) | 0, l[b + 100 >> 2] = je, wn = _ >> 25, U = (33554431 & _) << 7 | U >>> 25, _ = De(D, D >> 31, 121666, 0) + U | 0, g = wn + ve | 0, g = _ >>> 0 < U >>> 0 ? g + 1 | 0 : g, _e = (ct = _ + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g, Ct = _ - (-67108864 & ct) | 0, l[b + 104 >> 2] = Ct, U = De(ye, ye >> 31, 121666, 0), ie = ve, _ = De($e, $e >> 31, 121666, 0), g = ve, St = U, _n = _, U = (33554431 & (g = (mt = _ + 16777216 | 0) >>> 0 < 16777216 ? g + 1 | 0 : g)) << 7 | mt >>> 25, g = (g >> 25) + ie | 0, g = (_ = St + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, ie = (bt = _ + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g, Ge = _ - (-67108864 & bt) | 0, l[b + 112 >> 2] = Ge, U = De(we, we >> 31, 121666, 0), D = ve, _ = De(Le, Le >> 31, 121666, 0), g = ve, St = _, _ = (33554431 & (g = (me = _ + 16777216 | 0) >>> 0 < 16777216 ? g + 1 | 0 : g)) << 7 | me >>> 25, g = (g >> 25) + D | 0, g = _ >>> 0 > (U = _ + U | 0) >>> 0 ? g + 1 | 0 : g, _ = (he = U + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g, Le = U - (-67108864 & he) | 0, l[b + 120 >> 2] = Le, D = De(Tt, Tt >> 31, 121666, 0), ye = ve, U = De(Ft, Ft >> 31, 121666, 0), g = ve, Tt = U, U = (33554431 & (g = (we = U + 16777216 | 0) >>> 0 < 16777216 ? g + 1 | 0 : g)) << 7 | we >>> 25, g = (g >> 25) + ye | 0, g = U >>> 0 > (D = U + D | 0) >>> 0 ? g + 1 | 0 : g, U = ($e = D + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g, ye = D - (-67108864 & $e) | 0, l[b + 128 >> 2] = ye, D = (_e = _n + ((67108863 & _e) << 6 | ct >>> 26) | 0) - (-33554432 & mt) | 0, l[b + 108 >> 2] = D, _e = (ie = St + ((67108863 & ie) << 6 | bt >>> 26) | 0) - (-33554432 & me) | 0, l[b + 116 >> 2] = _e, ie = (g = Tt + ((67108863 & _) << 6 | he >>> 26) | 0) - (-33554432 & we) | 0, l[b + 124 >> 2] = ie, _ = (U = Zt + ((67108863 & U) << 6 | $e >>> 26) | 0) - (-33554432 & Be) | 0, l[b + 132 >> 2] = _, Ot(g = b + 144 | 0, g), l[b + 84 >> 2] = _ + Hn, l[b + 80 >> 2] = ye + en, l[b + 76 >> 2] = ie + it, l[b + 72 >> 2] = Le + Kt, l[b + 68 >> 2] = _e + pn, l[b + 64 >> 2] = Ge + Gn, l[b + 60 >> 2] = D + Kn, l[b + 56 >> 2] = Ct + qn, l[b + 52 >> 2] = je + $n, l[b + 48 >> 2] = ht + er, _ = so - 1 | 0, In(Zn, b + 288 | 0, Gt), In(Gt, b, fn), so; )
                          ;
                        Le = l[b + 144 >> 2], ht = l[b + 240 >> 2], we = l[b + 148 >> 2], je = l[b + 244 >> 2], $e = l[b + 152 >> 2], ct = l[b + 248 >> 2], ye = l[b + 156 >> 2], Ct = l[b + 252 >> 2], D = l[b + 160 >> 2], mt = l[b + 256 >> 2], _e = l[b + 164 >> 2], bt = l[b + 260 >> 2], ie = l[b + 168 >> 2], Ge = l[b + 264 >> 2], U = l[b + 172 >> 2], me = l[b + 268 >> 2], _ = l[b + 176 >> 2], he = l[b + 272 >> 2], Be = 0 - Sn | 0, g = l[b + 276 >> 2], l[b + 276 >> 2] = Be & (g ^ l[b + 180 >> 2]) ^ g, l[b + 272 >> 2] = he ^ Be & (_ ^ he), l[b + 268 >> 2] = me ^ Be & (U ^ me), l[b + 264 >> 2] = Ge ^ Be & (ie ^ Ge), l[b + 260 >> 2] = bt ^ Be & (_e ^ bt), l[b + 256 >> 2] = mt ^ Be & (D ^ mt), l[b + 252 >> 2] = Ct ^ Be & (ye ^ Ct), l[b + 248 >> 2] = ct ^ Be & ($e ^ ct), l[b + 244 >> 2] = je ^ Be & (we ^ je), l[b + 240 >> 2] = ht ^ Be & (Le ^ ht), ht = l[b + 192 >> 2], Le = l[b + 96 >> 2], je = l[b + 196 >> 2], we = l[b + 100 >> 2], ct = l[b + 200 >> 2], $e = l[b + 104 >> 2], Ct = l[b + 204 >> 2], ye = l[b + 108 >> 2], mt = l[b + 208 >> 2], D = l[b + 112 >> 2], bt = l[b + 212 >> 2], _e = l[b + 116 >> 2], Ge = l[b + 216 >> 2], ie = l[b + 120 >> 2], me = l[b + 220 >> 2], U = l[b + 124 >> 2], he = l[b + 224 >> 2], _ = l[b + 128 >> 2], g = l[b + 228 >> 2], l[b + 228 >> 2] = Be & (g ^ l[b + 132 >> 2]) ^ g, l[b + 224 >> 2] = he ^ Be & (_ ^ he), l[b + 220 >> 2] = me ^ Be & (U ^ me), l[b + 216 >> 2] = Ge ^ Be & (ie ^ Ge), l[b + 212 >> 2] = bt ^ Be & (_e ^ bt), l[b + 208 >> 2] = mt ^ Be & (D ^ mt), l[b + 204 >> 2] = Ct ^ Be & (ye ^ Ct), l[b + 200 >> 2] = ct ^ Be & ($e ^ ct), l[b + 196 >> 2] = je ^ Be & (we ^ je), l[b + 192 >> 2] = ht ^ Be & (Le ^ ht), Mn(_ = b + 192 | 0, _), In(g = b + 240 | 0, g, _), Ei(A, g), Wr(b + 336 | 0, 32), U = 0;
                      }
                      return st = b + 368 | 0, 0 | U;
                    }, function(A, g) {
                      var _, b, U, ie, he, D, me, _e, Be, ye, we, $e, Le, Ge, je, ct, mt, bt, ht, Ct;
                      return g |= 0, st = _ = st - 304 | 0, j[0 | (A |= 0)] = B[0 | g], j[A + 1 | 0] = B[g + 1 | 0], j[A + 2 | 0] = B[g + 2 | 0], j[A + 3 | 0] = B[g + 3 | 0], j[A + 4 | 0] = B[g + 4 | 0], j[A + 5 | 0] = B[g + 5 | 0], j[A + 6 | 0] = B[g + 6 | 0], j[A + 7 | 0] = B[g + 7 | 0], j[A + 8 | 0] = B[g + 8 | 0], j[A + 9 | 0] = B[g + 9 | 0], j[A + 10 | 0] = B[g + 10 | 0], j[A + 11 | 0] = B[g + 11 | 0], j[A + 12 | 0] = B[g + 12 | 0], j[A + 13 | 0] = B[g + 13 | 0], j[A + 14 | 0] = B[g + 14 | 0], j[A + 15 | 0] = B[g + 15 | 0], j[A + 16 | 0] = B[g + 16 | 0], j[A + 17 | 0] = B[g + 17 | 0], j[A + 18 | 0] = B[g + 18 | 0], j[A + 19 | 0] = B[g + 19 | 0], j[A + 20 | 0] = B[g + 20 | 0], j[A + 21 | 0] = B[g + 21 | 0], j[A + 22 | 0] = B[g + 22 | 0], j[A + 23 | 0] = B[g + 23 | 0], j[A + 24 | 0] = B[g + 24 | 0], j[A + 25 | 0] = B[g + 25 | 0], j[A + 26 | 0] = B[g + 26 | 0], j[A + 27 | 0] = B[g + 27 | 0], j[A + 28 | 0] = B[g + 28 | 0], j[A + 29 | 0] = B[g + 29 | 0], j[A + 30 | 0] = B[g + 30 | 0], g = B[g + 31 | 0], j[0 | A] = 248 & B[0 | A], j[A + 31 | 0] = 63 & g | 64, Os(_ + 48 | 0, A), g = l[_ + 132 >> 2], b = l[_ + 92 >> 2], U = l[_ + 136 >> 2], ie = l[_ + 96 >> 2], he = l[_ + 140 >> 2], D = l[_ + 100 >> 2], me = l[_ + 144 >> 2], _e = l[_ + 104 >> 2], Be = l[_ + 148 >> 2], ye = l[_ + 108 >> 2], we = l[_ + 152 >> 2], $e = l[_ + 112 >> 2], Le = l[_ + 156 >> 2], Ge = l[_ + 116 >> 2], je = l[_ + 160 >> 2], ct = l[_ + 120 >> 2], mt = l[_ + 128 >> 2], bt = l[_ + 88 >> 2], ht = l[_ + 124 >> 2], Ct = l[_ + 164 >> 2], l[_ + 292 >> 2] = ht + Ct, l[_ + 288 >> 2] = je + ct, l[_ + 284 >> 2] = Le + Ge, l[_ + 280 >> 2] = we + $e, l[_ + 276 >> 2] = Be + ye, l[_ + 272 >> 2] = me + _e, l[_ + 268 >> 2] = he + D, l[_ + 264 >> 2] = U + ie, l[_ + 260 >> 2] = g + b, l[_ + 256 >> 2] = mt + bt, l[_ + 244 >> 2] = Ct - ht, l[_ + 240 >> 2] = je - ct, l[_ + 236 >> 2] = Le - Ge, l[_ + 232 >> 2] = we - $e, l[_ + 228 >> 2] = Be - ye, l[_ + 224 >> 2] = me - _e, l[_ + 220 >> 2] = he - D, l[_ + 216 >> 2] = U - ie, l[_ + 212 >> 2] = g - b, l[_ + 208 >> 2] = mt - bt, Mn(g = _ + 208 | 0, g), In(_, _ + 256 | 0, g), Ei(A, _), st = _ + 304 | 0, 0;
                    }, function(A, g, _, b, U) {
                      A |= 0, b |= 0, U |= 0;
                      var ie, he = 0, D = 0, me = 0, _e = 0;
                      if (st = ie = st - 112 | 0, (g |= 0) | (_ |= 0)) {
                        he = B[U + 28 | 0] | B[U + 29 | 0] << 8 | B[U + 30 | 0] << 16 | B[U + 31 | 0] << 24, l[ie + 24 >> 2] = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, l[ie + 28 >> 2] = he, he = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, l[ie + 16 >> 2] = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, l[ie + 20 >> 2] = he, he = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[ie >> 2] = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[ie + 4 >> 2] = he, he = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, l[ie + 8 >> 2] = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24, l[ie + 12 >> 2] = he, U = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, b = B[b + 4 | 0] | B[b + 5 | 0] << 8 | B[b + 6 | 0] << 16 | B[b + 7 | 0] << 24, l[ie + 104 >> 2] = 0, l[ie + 108 >> 2] = 0, l[ie + 96 >> 2] = U, l[ie + 100 >> 2] = b;
                        e: {
                          if (!_ & g >>> 0 >= 64 | _) {
                            for (; Fi(A, ie + 96 | 0, ie, 0), b = B[ie + 104 | 0] + 1 | 0, j[ie + 104 | 0] = b, b = B[ie + 105 | 0] + (b >>> 8 | 0) | 0, j[ie + 105 | 0] = b, b = B[ie + 106 | 0] + (b >>> 8 | 0) | 0, j[ie + 106 | 0] = b, b = B[ie + 107 | 0] + (b >>> 8 | 0) | 0, j[ie + 107 | 0] = b, b = B[ie + 108 | 0] + (b >>> 8 | 0) | 0, j[ie + 108 | 0] = b, b = B[ie + 109 | 0] + (b >>> 8 | 0) | 0, j[ie + 109 | 0] = b, b = B[ie + 110 | 0] + (b >>> 8 | 0) | 0, j[ie + 110 | 0] = b, j[ie + 111 | 0] = B[ie + 111 | 0] + (b >>> 8 | 0), A = A - -64 | 0, _ = _ - 1 | 0, !(_ = (g = g + -64 | 0) >>> 0 < 4294967232 ? _ + 1 | 0 : _) & g >>> 0 > 63 | _; )
                              ;
                            if (!(g | _))
                              break e;
                          }
                          if (b = 0, Fi(ie + 32 | 0, ie + 96 | 0, ie, 0), _ = 3 & g, U = 0, g - 1 >>> 0 >= 3)
                            for (he = -4 & g, g = 0; D = me = ie + 32 | 0, j[A + U | 0] = B[D + U | 0], j[(_e = 1 | U) + A | 0] = B[D + _e | 0], j[(D = 2 | U) + A | 0] = B[D + me | 0], j[(D = 3 | U) + A | 0] = B[D + (ie + 32 | 0) | 0], U = U + 4 | 0, (0 | he) != (0 | (g = g + 4 | 0)); )
                              ;
                          if (_)
                            for (; j[A + U | 0] = B[(ie + 32 | 0) + U | 0], U = U + 1 | 0, (0 | _) != (0 | (b = b + 1 | 0)); )
                              ;
                        }
                        Wr(ie + 32 | 0, 64), Wr(ie, 32);
                      }
                      return st = ie + 112 | 0, 0;
                    }, function(A, g, _, b, U, ie, he, D) {
                      A |= 0, g |= 0, U |= 0, ie |= 0, he |= 0, D |= 0;
                      var me, _e = 0;
                      if (st = me = st - 112 | 0, (_ |= 0) | (b |= 0)) {
                        _e = B[D + 28 | 0] | B[D + 29 | 0] << 8 | B[D + 30 | 0] << 16 | B[D + 31 | 0] << 24, l[me + 24 >> 2] = B[D + 24 | 0] | B[D + 25 | 0] << 8 | B[D + 26 | 0] << 16 | B[D + 27 | 0] << 24, l[me + 28 >> 2] = _e, _e = B[D + 20 | 0] | B[D + 21 | 0] << 8 | B[D + 22 | 0] << 16 | B[D + 23 | 0] << 24, l[me + 16 >> 2] = B[D + 16 | 0] | B[D + 17 | 0] << 8 | B[D + 18 | 0] << 16 | B[D + 19 | 0] << 24, l[me + 20 >> 2] = _e, _e = B[D + 4 | 0] | B[D + 5 | 0] << 8 | B[D + 6 | 0] << 16 | B[D + 7 | 0] << 24, l[me >> 2] = B[0 | D] | B[D + 1 | 0] << 8 | B[D + 2 | 0] << 16 | B[D + 3 | 0] << 24, l[me + 4 >> 2] = _e, _e = B[D + 12 | 0] | B[D + 13 | 0] << 8 | B[D + 14 | 0] << 16 | B[D + 15 | 0] << 24, l[me + 8 >> 2] = B[D + 8 | 0] | B[D + 9 | 0] << 8 | B[D + 10 | 0] << 16 | B[D + 11 | 0] << 24, l[me + 12 >> 2] = _e, D = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[me + 96 >> 2] = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[me + 100 >> 2] = D, j[me + 104 | 0] = ie, j[me + 111 | 0] = he >>> 24, j[me + 110 | 0] = he >>> 16, j[me + 109 | 0] = he >>> 8, j[me + 108 | 0] = he, j[me + 107 | 0] = (16777215 & he) << 8 | ie >>> 24, j[me + 106 | 0] = (65535 & he) << 16 | ie >>> 16, j[me + 105 | 0] = (255 & he) << 24 | ie >>> 8;
                        e: {
                          if (!b & _ >>> 0 >= 64 | b) {
                            for (; ; ) {
                              for (D = 0, Fi(me + 32 | 0, me + 96 | 0, me, 0); ie = me + 32 | 0, j[A + D | 0] = B[ie + D | 0] ^ B[g + D | 0], j[(U = 1 | D) + A | 0] = B[U + ie | 0] ^ B[g + U | 0], (0 | (D = D + 2 | 0)) != 64; )
                                ;
                              if (U = B[me + 104 | 0] + 1 | 0, j[me + 104 | 0] = U, U = B[me + 105 | 0] + (U >>> 8 | 0) | 0, j[me + 105 | 0] = U, U = B[me + 106 | 0] + (U >>> 8 | 0) | 0, j[me + 106 | 0] = U, U = B[me + 107 | 0] + (U >>> 8 | 0) | 0, j[me + 107 | 0] = U, U = B[me + 108 | 0] + (U >>> 8 | 0) | 0, j[me + 108 | 0] = U, U = B[me + 109 | 0] + (U >>> 8 | 0) | 0, j[me + 109 | 0] = U, U = B[me + 110 | 0] + (U >>> 8 | 0) | 0, j[me + 110 | 0] = U, j[me + 111 | 0] = B[me + 111 | 0] + (U >>> 8 | 0), g = g - -64 | 0, A = A - -64 | 0, b = b - 1 | 0, !(!(b = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? b + 1 | 0 : b) & _ >>> 0 > 63 | b))
                                break;
                            }
                            if (!(_ | b))
                              break e;
                          }
                          if (D = 0, Fi(me + 32 | 0, me + 96 | 0, me, 0), b = 1 & _, (0 | _) != 1)
                            for (ie = -2 & _, U = 0; he = me + 32 | 0, j[A + D | 0] = B[he + D | 0] ^ B[g + D | 0], j[(_ = 1 | D) + A | 0] = B[_ + he | 0] ^ B[g + _ | 0], D = D + 2 | 0, (0 | ie) != (0 | (U = U + 2 | 0)); )
                              ;
                          b && (j[A + D | 0] = B[(me + 32 | 0) + D | 0] ^ B[g + D | 0]);
                        }
                        Wr(me + 32 | 0, 64), Wr(me, 32);
                      }
                      return st = me + 112 | 0, 0;
                    }, function(A, g, _, b, U) {
                      var ie;
                      return A |= 0, b |= 0, U |= 0, st = ie = st + -64 | 0, (g |= 0) | (_ |= 0) && (l[ie + 8 >> 2] = 2036477234, l[ie + 12 >> 2] = 1797285236, l[ie >> 2] = 1634760805, l[ie + 4 >> 2] = 857760878, l[ie + 16 >> 2] = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[ie + 20 >> 2] = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[ie + 24 >> 2] = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24, l[ie + 28 >> 2] = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, l[ie + 32 >> 2] = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, l[ie + 36 >> 2] = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, l[ie + 40 >> 2] = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, U = B[U + 28 | 0] | B[U + 29 | 0] << 8 | B[U + 30 | 0] << 16 | B[U + 31 | 0] << 24, l[ie + 48 >> 2] = 0, l[ie + 52 >> 2] = 0, l[ie + 44 >> 2] = U, l[ie + 56 >> 2] = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, l[ie + 60 >> 2] = B[b + 4 | 0] | B[b + 5 | 0] << 8 | B[b + 6 | 0] << 16 | B[b + 7 | 0] << 24, ca(ie, A = Jt(A, 0, g), A, g, _), Wr(ie, 64)), st = ie - -64 | 0, 0;
                    }, function(A, g, _, b, U) {
                      var ie;
                      return A |= 0, b |= 0, U |= 0, st = ie = st + -64 | 0, (g |= 0) | (_ |= 0) && (l[ie + 8 >> 2] = 2036477234, l[ie + 12 >> 2] = 1797285236, l[ie >> 2] = 1634760805, l[ie + 4 >> 2] = 857760878, l[ie + 16 >> 2] = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[ie + 20 >> 2] = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[ie + 24 >> 2] = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24, l[ie + 28 >> 2] = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, l[ie + 32 >> 2] = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, l[ie + 36 >> 2] = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, l[ie + 40 >> 2] = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, U = B[U + 28 | 0] | B[U + 29 | 0] << 8 | B[U + 30 | 0] << 16 | B[U + 31 | 0] << 24, l[ie + 48 >> 2] = 0, l[ie + 44 >> 2] = U, l[ie + 52 >> 2] = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, l[ie + 56 >> 2] = B[b + 4 | 0] | B[b + 5 | 0] << 8 | B[b + 6 | 0] << 16 | B[b + 7 | 0] << 24, l[ie + 60 >> 2] = B[b + 8 | 0] | B[b + 9 | 0] << 8 | B[b + 10 | 0] << 16 | B[b + 11 | 0] << 24, ca(ie, A = Jt(A, 0, g), A, g, _), Wr(ie, 64)), st = ie - -64 | 0, 0;
                    }, function(A, g, _, b, U, ie, he, D) {
                      var me;
                      return A |= 0, g |= 0, U |= 0, ie |= 0, he |= 0, D |= 0, st = me = st + -64 | 0, (_ |= 0) | (b |= 0) && (l[me + 8 >> 2] = 2036477234, l[me + 12 >> 2] = 1797285236, l[me >> 2] = 1634760805, l[me + 4 >> 2] = 857760878, l[me + 16 >> 2] = B[0 | D] | B[D + 1 | 0] << 8 | B[D + 2 | 0] << 16 | B[D + 3 | 0] << 24, l[me + 20 >> 2] = B[D + 4 | 0] | B[D + 5 | 0] << 8 | B[D + 6 | 0] << 16 | B[D + 7 | 0] << 24, l[me + 24 >> 2] = B[D + 8 | 0] | B[D + 9 | 0] << 8 | B[D + 10 | 0] << 16 | B[D + 11 | 0] << 24, l[me + 28 >> 2] = B[D + 12 | 0] | B[D + 13 | 0] << 8 | B[D + 14 | 0] << 16 | B[D + 15 | 0] << 24, l[me + 32 >> 2] = B[D + 16 | 0] | B[D + 17 | 0] << 8 | B[D + 18 | 0] << 16 | B[D + 19 | 0] << 24, l[me + 36 >> 2] = B[D + 20 | 0] | B[D + 21 | 0] << 8 | B[D + 22 | 0] << 16 | B[D + 23 | 0] << 24, l[me + 40 >> 2] = B[D + 24 | 0] | B[D + 25 | 0] << 8 | B[D + 26 | 0] << 16 | B[D + 27 | 0] << 24, l[me + 44 >> 2] = B[D + 28 | 0] | B[D + 29 | 0] << 8 | B[D + 30 | 0] << 16 | B[D + 31 | 0] << 24, l[me + 48 >> 2] = ie, l[me + 52 >> 2] = he, l[me + 56 >> 2] = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[me + 60 >> 2] = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, ca(me, g, A, _, b), Wr(me, 64)), st = me - -64 | 0, 0;
                    }, function(A, g, _, b, U, ie, he) {
                      var D;
                      return A |= 0, g |= 0, U |= 0, ie |= 0, he |= 0, st = D = st + -64 | 0, (_ |= 0) | (b |= 0) && (l[D + 8 >> 2] = 2036477234, l[D + 12 >> 2] = 1797285236, l[D >> 2] = 1634760805, l[D + 4 >> 2] = 857760878, l[D + 16 >> 2] = B[0 | he] | B[he + 1 | 0] << 8 | B[he + 2 | 0] << 16 | B[he + 3 | 0] << 24, l[D + 20 >> 2] = B[he + 4 | 0] | B[he + 5 | 0] << 8 | B[he + 6 | 0] << 16 | B[he + 7 | 0] << 24, l[D + 24 >> 2] = B[he + 8 | 0] | B[he + 9 | 0] << 8 | B[he + 10 | 0] << 16 | B[he + 11 | 0] << 24, l[D + 28 >> 2] = B[he + 12 | 0] | B[he + 13 | 0] << 8 | B[he + 14 | 0] << 16 | B[he + 15 | 0] << 24, l[D + 32 >> 2] = B[he + 16 | 0] | B[he + 17 | 0] << 8 | B[he + 18 | 0] << 16 | B[he + 19 | 0] << 24, l[D + 36 >> 2] = B[he + 20 | 0] | B[he + 21 | 0] << 8 | B[he + 22 | 0] << 16 | B[he + 23 | 0] << 24, l[D + 40 >> 2] = B[he + 24 | 0] | B[he + 25 | 0] << 8 | B[he + 26 | 0] << 16 | B[he + 27 | 0] << 24, he = B[he + 28 | 0] | B[he + 29 | 0] << 8 | B[he + 30 | 0] << 16 | B[he + 31 | 0] << 24, l[D + 48 >> 2] = ie, l[D + 44 >> 2] = he, l[D + 52 >> 2] = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[D + 56 >> 2] = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[D + 60 >> 2] = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24, ca(D, g, A, _, b), Wr(D, 64)), st = D - -64 | 0, 0;
                    }], nu.grow = function(A) {
                      var g = this.length;
                      return this.length = this.length + A, g;
                    }, nu.set = function(A, g) {
                      this[A] = g;
                    }, nu.get = function(A) {
                      return this[A];
                    }, nu);
                    function Ic() {
                      return ki.byteLength / 65536 | 0;
                    }
                    return { f: function() {
                    }, g: function(A, g, _, b, U, ie, he, D, me, _e, Be, ye) {
                      return 0 | _t(A |= 0, g |= 0, _ |= 0, b |= 0, (A = 0) | (U |= 0), ie |= 0, he |= 0, A | (D |= 0), me |= 0, Be |= 0, ye |= 0);
                    }, h: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return A |= 0, g |= 0, me |= 0, me = b |= 0, !(b = U |= 0) & (U = 0 | me) >>> 0 < 4294967280 ? (_t(A, A + U | 0, 0, _ |= 0, U, b, ie |= 0, he |= 0, D |= 0, _e |= 0, Be |= 0), g && (b = (A = U + 16 | 0) >>> 0 < 16 ? b + 1 | 0 : b, l[g >> 2] = A, l[g + 4 >> 2] = b)) : (Ai(), Xr()), 0;
                    }, i: function(A, g, _, b, U, ie, he, D, me, _e, Be, ye) {
                      return 0 | We(A |= 0, g |= 0, _ |= 0, b |= 0, (A = 0) | (U |= 0), ie |= 0, he |= 0, A | (D |= 0), me |= 0, Be |= 0, ye |= 0);
                    }, j: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return A |= 0, g |= 0, me |= 0, me = b |= 0, !(b = U |= 0) & (U = 0 | me) >>> 0 < 4294967280 ? (We(A, A + U | 0, 0, _ |= 0, U, b, ie |= 0, he |= 0, D |= 0, _e |= 0, Be |= 0), g && (b = (A = U + 16 | 0) >>> 0 < 16 ? b + 1 | 0 : b, l[g >> 2] = A, l[g + 4 >> 2] = b)) : (Ai(), Xr()), 0;
                    }, k: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return 0 | Ne(A |= 0, _ |= 0, (A = 0) | (b |= 0), U |= 0, ie |= 0, he |= 0, A | (D |= 0), me |= 0, _e |= 0, Be |= 0);
                    }, l: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return g |= 0, _ |= 0, b |= 0, U |= 0, D |= 0, D |= 0, _ = -1, !(ie |= 0) & (U |= 0) >>> 0 >= 16 | ie && (_ = Ne(A |= 0, b, U - 16 | 0, ie - (U >>> 0 < 16) | 0, (b + U | 0) - 16 | 0, he |= 0, D, me |= 0, _e |= 0, Be |= 0)), g && (l[g >> 2] = _ ? 0 : U - 16 | 0, l[g + 4 >> 2] = _ ? 0 : ie - (U >>> 0 < 16) | 0), 0 | _;
                    }, m: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return 0 | Ue(A |= 0, _ |= 0, (A = 0) | (b |= 0), U |= 0, ie |= 0, he |= 0, A | (D |= 0), me |= 0, _e |= 0, Be |= 0);
                    }, n: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return g |= 0, _ |= 0, b |= 0, U |= 0, D |= 0, D |= 0, _ = -1, !(ie |= 0) & (U |= 0) >>> 0 >= 16 | ie && (_ = Ue(A |= 0, b, U - 16 | 0, ie - (U >>> 0 < 16) | 0, (b + U | 0) - 16 | 0, he |= 0, D, me |= 0, _e |= 0, Be |= 0)), g && (l[g >> 2] = _ ? 0 : U - 16 | 0, l[g + 4 >> 2] = _ ? 0 : ie - (U >>> 0 < 16) | 0), 0 | _;
                    }, o: wo, p: Sc, q: Da, r: si, s: Ta, t: Li, u: wo, v: ba, w: Da, x: si, y: Ta, z: Li, A: function(A, g, _, b, U, ie, he, D, me, _e, Be, ye) {
                      return 0 | Ki(A |= 0, g |= 0, _ |= 0, b |= 0, (A = 0) | (U |= 0), ie |= 0, he |= 0, A | (D |= 0), me |= 0, Be |= 0, ye |= 0);
                    }, B: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return A |= 0, g |= 0, me |= 0, me = b |= 0, !(b = U |= 0) & (U = 0 | me) >>> 0 < 4294967280 ? (Ki(A, A + U | 0, 0, _ |= 0, U, b, ie |= 0, he |= 0, D |= 0, _e |= 0, Be |= 0), g && (b = (A = U + 16 | 0) >>> 0 < 16 ? b + 1 | 0 : b, l[g >> 2] = A, l[g + 4 >> 2] = b)) : (Ai(), Xr()), 0;
                    }, C: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return 0 | Ra(A |= 0, _ |= 0, (A = 0) | (b |= 0), U |= 0, ie |= 0, he |= 0, A | (D |= 0), me |= 0, _e |= 0, Be |= 0);
                    }, D: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return g |= 0, _ |= 0, b |= 0, U |= 0, D |= 0, D |= 0, _ = -1, !(ie |= 0) & (U |= 0) >>> 0 >= 16 | ie && (_ = Ra(A |= 0, b, U - 16 | 0, ie - (U >>> 0 < 16) | 0, (b + U | 0) - 16 | 0, he |= 0, D, me |= 0, _e |= 0, Be |= 0)), g && (l[g >> 2] = _ ? 0 : U - 16 | 0, l[g + 4 >> 2] = _ ? 0 : ie - (U >>> 0 < 16) | 0), 0 | _;
                    }, E: wo, F: fa, G: Da, H: si, I: Ta, J: Li, K: wo, L: wo, M: function() {
                      return 1464;
                    }, N: ja, O: Te, P: Li, Q: wo, R: wo, S: pu, T: Li, U: Fe, V: function(A, g, _, b) {
                      return 0 | Eu(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }, W: bo, X: function(A, g, _, b, U) {
                      var ie;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, st = ie = st - 240 | 0, Fe(ie, U |= 0, 32), dt(ie, g, _, b), ke(ie, g = ie + 208 | 0), dt(_ = ie + 104 | 0, g, 32, 0), ke(_, A), Wr(g, 32), st = ie + 240 | 0, 0;
                    }, Y: function(A, g, _, b, U) {
                      var ie, he;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, st = ie = st - 272 | 0, Fe(he = ie + 32 | 0, U |= 0, 32), dt(he, g, _, b), ke(he, g = ie + 240 | 0), dt(_ = ie + 136 | 0, g, 32, 0), ke(_, ie), Wr(g, 32), g = fu(A, ie), _ = Ie(ie, A, 32), st = ie + 272 | 0, _ | ((0 | A) == (0 | ie) ? -1 : g);
                    }, Z: Zi, _: wo, $: _c, aa: Li, ba: Yo, ca: Vs, da: uo, ea: function(A, g, _, b, U) {
                      var ie;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, st = ie = st - 480 | 0, Yo(ie, U |= 0, 32), Di(ie, g, _, b), Ui(ie, g = ie + 416 | 0), Di(_ = ie + 208 | 0, g, 64, 0), Ui(_, A), Wr(g, 64), st = ie + 480 | 0, 0;
                    }, fa: function(A, g, _, b, U) {
                      var ie, he;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, st = ie = st - 544 | 0, Yo(he = ie - -64 | 0, U |= 0, 32), Di(he, g, _, b), Ui(he, g = ie + 480 | 0), Di(_ = ie + 272 | 0, g, 64, 0), Ui(_, ie), Wr(g, 64), g = oc(A, ie), _ = Ie(ie, A, 64), st = ie + 544 | 0, _ | ((0 | A) == (0 | ie) ? -1 : g);
                    }, ga: wo, ha: wo, ia: _c, ja: Li, ka: function(A, g, _) {
                      return 0 | Yo(A |= 0, g |= 0, _ |= 0);
                    }, la: Vs, ma: function(A, g) {
                      g |= 0;
                      var _, b = 0;
                      return st = _ = st + -64 | 0, uo(A |= 0, _), b = l[_ + 28 >> 2], A = l[_ + 24 >> 2], j[g + 24 | 0] = A, j[g + 25 | 0] = A >>> 8, j[g + 26 | 0] = A >>> 16, j[g + 27 | 0] = A >>> 24, j[g + 28 | 0] = b, j[g + 29 | 0] = b >>> 8, j[g + 30 | 0] = b >>> 16, j[g + 31 | 0] = b >>> 24, b = l[_ + 20 >> 2], A = l[_ + 16 >> 2], j[g + 16 | 0] = A, j[g + 17 | 0] = A >>> 8, j[g + 18 | 0] = A >>> 16, j[g + 19 | 0] = A >>> 24, j[g + 20 | 0] = b, j[g + 21 | 0] = b >>> 8, j[g + 22 | 0] = b >>> 16, j[g + 23 | 0] = b >>> 24, b = l[_ + 12 >> 2], A = l[_ + 8 >> 2], j[g + 8 | 0] = A, j[g + 9 | 0] = A >>> 8, j[g + 10 | 0] = A >>> 16, j[g + 11 | 0] = A >>> 24, j[g + 12 | 0] = b, j[g + 13 | 0] = b >>> 8, j[g + 14 | 0] = b >>> 16, j[g + 15 | 0] = b >>> 24, b = l[_ + 4 >> 2], A = l[_ >> 2], j[0 | g] = A, j[g + 1 | 0] = A >>> 8, j[g + 2 | 0] = A >>> 16, j[g + 3 | 0] = A >>> 24, j[g + 4 | 0] = b, j[g + 5 | 0] = b >>> 8, j[g + 6 | 0] = b >>> 16, j[g + 7 | 0] = b >>> 24, st = _ - -64 | 0, 0;
                    }, na: ja, oa: Te, pa: wo, qa: wo, ra: wo, sa: wo, ta: fa, ua: wo, va: si, wa: si, xa: Ta, ya: function() {
                      return 1478;
                    }, za: function(A, g, _) {
                      return 0 | na(A |= 0, g |= 0, _ |= 0);
                    }, Aa: sc, Ba: Rs, Ca: To, Da: Do, Ea: Xn, Fa: nr, Ga: Hr, Ha: function(A, g, _, b, U, ie, he, D) {
                      var me, _e;
                      return A |= 0, g |= 0, _ |= 0, ie |= 0, _e = b |= 0, b = U |= 0, st = me = st - 32 | 0, U = -1, Rs(me, he |= 0, D |= 0) || (U = va(A, g, _, _e, b, ie, me), Wr(me, 32)), st = me + 32 | 0, 0 | U;
                    }, Ia: function(A, g, _, b, U, ie) {
                      return A |= 0, g |= 0, U |= 0, ie |= 0, !(b |= 0) & (_ |= 0) >>> 0 >= 4294967280 | b && (Ai(), Xr()), 0 | va(A + 16 | 0, A, g, _, b, U, ie);
                    }, Ja: function(A, g, _, b, U, ie, he) {
                      return 0 | Ur(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }, Ka: Vr, La: function(A, g, _, b, U, ie, he, D) {
                      var me, _e;
                      return A |= 0, g |= 0, _ |= 0, ie |= 0, _e = b |= 0, b = U |= 0, st = me = st - 32 | 0, U = -1, Rs(me, he |= 0, D |= 0) || (U = La(A, g, _, _e, b, ie, me), Wr(me, 32)), st = me + 32 | 0, 0 | U;
                    }, Ma: Jr, Na: function(A, g, _, b, U, ie, he) {
                      return 0 | _r(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }, Oa: function(A, g, _, b, U) {
                      A |= 0, g |= 0, U |= 0;
                      var ie, he, D, me = 0, _e = 0;
                      return he = _ |= 0, _ = b |= 0, D = b = st, st = ie = b - 512 & -64, b = -1, sc(ie - -64 | 0, ie + 32 | 0) || (fs(b = ie + 128 | 0, 0, 0, 24), Is(b, _e = ie - -64 | 0, 32, 0), Is(b, U, 32, 0), Ss(b, me = ie + 96 | 0, 24), b = Ur(A + 32 | 0, g, he, _, me, b = U, U = ie + 32 | 0), g = l[ie + 92 >> 2], _ = l[ie + 88 >> 2], j[A + 24 | 0] = _, j[A + 25 | 0] = _ >>> 8, j[A + 26 | 0] = _ >>> 16, j[A + 27 | 0] = _ >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[ie + 84 >> 2], _ = l[ie + 80 >> 2], j[A + 16 | 0] = _, j[A + 17 | 0] = _ >>> 8, j[A + 18 | 0] = _ >>> 16, j[A + 19 | 0] = _ >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[ie + 76 >> 2], _ = l[ie + 72 >> 2], j[A + 8 | 0] = _, j[A + 9 | 0] = _ >>> 8, j[A + 10 | 0] = _ >>> 16, j[A + 11 | 0] = _ >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[ie + 68 >> 2], _ = l[ie + 64 >> 2], j[0 | A] = _, j[A + 1 | 0] = _ >>> 8, j[A + 2 | 0] = _ >>> 16, j[A + 3 | 0] = _ >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, Wr(U, 32), Wr(_e, 32), Wr(me, 24)), st = D, 0 | b;
                    }, Pa: function(A, g, _, b, U, ie) {
                      A |= 0, g |= 0, U |= 0, ie |= 0;
                      var he, D, me = 0, _e = 0;
                      return he = me = st, st = me = me - 448 & -64, _e = -1, D = b |= 0, !b & (_ |= 0) >>> 0 >= 48 | b && (fs(b = me - -64 | 0, 0, 0, 24), Is(b, g, 32, 0), Is(b, U, 32, 0), Ss(U = b, b = me + 32 | 0, 24), _e = _r(A, g + 32 | 0, _ - 32 | 0, D - (_ >>> 0 < 32) | 0, b, g, ie)), st = he, 0 | _e;
                    }, Qa: Cc, Ra: na, Sa: $a, Ta: oo, Ua: To, Va: Do, Wa: Xn, Xa: nr, Ya: wo, Za: wo, _a: wo, $a: wo, ab: fa, bb: wo, cb: si, db: si, eb: Ta, fb: Ji, gb: wo, hb: si, ib: wo, jb: si, kb: bs, lb: wo, mb: si, nb: wo, ob: si, pb: Fi, qb: Zi, rb: si, sb: wo, tb: si, ub: Yi, vb: Zi, wb: si, xb: wo, yb: si, zb: us, Ab: Zi, Bb: si, Cb: wo, Db: si, Eb: si, Fb: Zi, Gb: wo, Hb: si, Ib: Zi, Jb: wo, Kb: yc, Lb: vc, Mb: function(A, g, _, b, U, ie, he) {
                      return 0 | ku(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }, Nb: fs, Ob: function(A, g, _, b) {
                      return 0 | Is(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }, Pb: Ss, Qb: Li, Rb: si, Sb: Zi, Tb: wo, Ub: si, Vb: Zi, Wb: wo, Xb: si, Yb: si, Zb: vc, _b: Li, $b: ku, ac: function(A, g, _, b, U, ie, he, D, me) {
                      return 0 | qi(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0, D |= 0, me |= 0);
                    }, bc: ea, cc: function(A, g, _, b, U, ie) {
                      A |= 0, g |= 0, U |= 0, ie |= 0;
                      var he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0;
                      if (he = -1, !((b |= 0) - 65 >>> 0 < 4294967232 | (_ |= 0) >>> 0 > 64)) {
                        e: {
                          if (!_ || !g) {
                            if (((_e = 255 & b) - 65 & 255) >>> 0 > 191) {
                              U ? (D = 725511199 ^ (B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24), _ = -1694144372 ^ (B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24), g = -1377402159 ^ (B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24), U = 1359893119 ^ (B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24)) : (D = 725511199, _ = -1694144372, g = -1377402159, U = 1359893119), ie ? (me = 327033209 ^ (B[ie + 8 | 0] | B[ie + 9 | 0] << 8 | B[ie + 10 | 0] << 16 | B[ie + 11 | 0] << 24), b = 1541459225 ^ (B[ie + 12 | 0] | B[ie + 13 | 0] << 8 | B[ie + 14 | 0] << 16 | B[ie + 15 | 0] << 24), he = -79577749 ^ (B[0 | ie] | B[ie + 1 | 0] << 8 | B[ie + 2 | 0] << 16 | B[ie + 3 | 0] << 24), ie = 528734635 ^ (B[ie + 4 | 0] | B[ie + 5 | 0] << 8 | B[ie + 6 | 0] << 16 | B[ie + 7 | 0] << 24)) : (me = 327033209, b = 1541459225, he = -79577749, ie = 528734635), Jt(A - -64 | 0, 0, 293), j[A + 56 | 0] = me, j[A + 57 | 0] = me >>> 8, j[A + 58 | 0] = me >>> 16, j[A + 59 | 0] = me >>> 24, j[A + 60 | 0] = b, j[A + 61 | 0] = b >>> 8, j[A + 62 | 0] = b >>> 16, j[A + 63 | 0] = b >>> 24, j[A + 48 | 0] = he, j[A + 49 | 0] = he >>> 8, j[A + 50 | 0] = he >>> 16, j[A + 51 | 0] = he >>> 24, j[A + 52 | 0] = ie, j[A + 53 | 0] = ie >>> 8, j[A + 54 | 0] = ie >>> 16, j[A + 55 | 0] = ie >>> 24, j[A + 40 | 0] = D, j[A + 41 | 0] = D >>> 8, j[A + 42 | 0] = D >>> 16, j[A + 43 | 0] = D >>> 24, j[A + 44 | 0] = _, j[A + 45 | 0] = _ >>> 8, j[A + 46 | 0] = _ >>> 16, j[A + 47 | 0] = _ >>> 24, j[A + 32 | 0] = g, j[A + 33 | 0] = g >>> 8, j[A + 34 | 0] = g >>> 16, j[A + 35 | 0] = g >>> 24, j[A + 36 | 0] = U, j[A + 37 | 0] = U >>> 8, j[A + 38 | 0] = U >>> 16, j[A + 39 | 0] = U >>> 24, j[A + 24 | 0] = 241, j[A + 25 | 0] = 54, j[A + 26 | 0] = 29, j[A + 27 | 0] = 95, j[A + 28 | 0] = 58, j[A + 29 | 0] = 245, j[A + 30 | 0] = 79, j[A + 31 | 0] = 165, j[A + 16 | 0] = 43, j[A + 17 | 0] = 248, j[A + 18 | 0] = 148, j[A + 19 | 0] = 254, j[A + 20 | 0] = 114, j[A + 21 | 0] = 243, j[A + 22 | 0] = 110, j[A + 23 | 0] = 60, j[A + 8 | 0] = 59, j[A + 9 | 0] = 167, j[A + 10 | 0] = 202, j[A + 11 | 0] = 132, j[A + 12 | 0] = 133, j[A + 13 | 0] = 174, j[A + 14 | 0] = 103, j[A + 15 | 0] = 187, g = -222443256 ^ _e, j[0 | A] = g, j[A + 1 | 0] = g >>> 8, j[A + 2 | 0] = g >>> 16, j[A + 3 | 0] = g >>> 24, j[A + 4 | 0] = 103, j[A + 5 | 0] = 230, j[A + 6 | 0] = 9, j[A + 7 | 0] = 106;
                              break e;
                            }
                            Ai(), Xr();
                          }
                          st = ye = st - 128 | 0, !g | ((we = 255 & b) - 65 & 255) >>> 0 <= 191 | ((he = 255 & _) - 65 & 255) >>> 0 <= 191 ? (Ai(), Xr()) : (U ? (D = 725511199 ^ (B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24), _ = -1694144372 ^ (B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24), _e = -1377402159 ^ (B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24), U = 1359893119 ^ (B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24)) : (D = 725511199, _ = -1694144372, _e = -1377402159, U = 1359893119), ie ? (me = 327033209 ^ (B[ie + 8 | 0] | B[ie + 9 | 0] << 8 | B[ie + 10 | 0] << 16 | B[ie + 11 | 0] << 24), b = 1541459225 ^ (B[ie + 12 | 0] | B[ie + 13 | 0] << 8 | B[ie + 14 | 0] << 16 | B[ie + 15 | 0] << 24), Be = -79577749 ^ (B[0 | ie] | B[ie + 1 | 0] << 8 | B[ie + 2 | 0] << 16 | B[ie + 3 | 0] << 24), ie = 528734635 ^ (B[ie + 4 | 0] | B[ie + 5 | 0] << 8 | B[ie + 6 | 0] << 16 | B[ie + 7 | 0] << 24)) : (me = 327033209, b = 1541459225, Be = -79577749, ie = 528734635), Jt(A - -64 | 0, 0, 293), j[A + 56 | 0] = me, j[A + 57 | 0] = me >>> 8, j[A + 58 | 0] = me >>> 16, j[A + 59 | 0] = me >>> 24, j[A + 60 | 0] = b, j[A + 61 | 0] = b >>> 8, j[A + 62 | 0] = b >>> 16, j[A + 63 | 0] = b >>> 24, j[A + 48 | 0] = Be, j[A + 49 | 0] = Be >>> 8, j[A + 50 | 0] = Be >>> 16, j[A + 51 | 0] = Be >>> 24, j[A + 52 | 0] = ie, j[A + 53 | 0] = ie >>> 8, j[A + 54 | 0] = ie >>> 16, j[A + 55 | 0] = ie >>> 24, j[A + 40 | 0] = D, j[A + 41 | 0] = D >>> 8, j[A + 42 | 0] = D >>> 16, j[A + 43 | 0] = D >>> 24, j[A + 44 | 0] = _, j[A + 45 | 0] = _ >>> 8, j[A + 46 | 0] = _ >>> 16, j[A + 47 | 0] = _ >>> 24, j[A + 32 | 0] = _e, j[A + 33 | 0] = _e >>> 8, j[A + 34 | 0] = _e >>> 16, j[A + 35 | 0] = _e >>> 24, j[A + 36 | 0] = U, j[A + 37 | 0] = U >>> 8, j[A + 38 | 0] = U >>> 16, j[A + 39 | 0] = U >>> 24, j[A + 24 | 0] = 241, j[A + 25 | 0] = 54, j[A + 26 | 0] = 29, j[A + 27 | 0] = 95, j[A + 28 | 0] = 58, j[A + 29 | 0] = 245, j[A + 30 | 0] = 79, j[A + 31 | 0] = 165, j[A + 16 | 0] = 43, j[A + 17 | 0] = 248, j[A + 18 | 0] = 148, j[A + 19 | 0] = 254, j[A + 20 | 0] = 114, j[A + 21 | 0] = 243, j[A + 22 | 0] = 110, j[A + 23 | 0] = 60, j[A + 8 | 0] = 59, j[A + 9 | 0] = 167, j[A + 10 | 0] = 202, j[A + 11 | 0] = 132, j[A + 12 | 0] = 133, j[A + 13 | 0] = 174, j[A + 14 | 0] = 103, j[A + 15 | 0] = 187, _ = -222443256 ^ (he << 8 | we), j[0 | A] = _, j[A + 1 | 0] = _ >>> 8, j[A + 2 | 0] = _ >>> 16, j[A + 3 | 0] = _ >>> 24, _ = he >>> 24 ^ 1779033703, j[A + 4 | 0] = _, j[A + 5 | 0] = _ >>> 8, j[A + 6 | 0] = _ >>> 16, j[A + 7 | 0] = _ >>> 24, Jt(he + ye | 0, 0, he << 24 >> 24 >= 0 ? 128 - he | 0 : 0), _ = xr(ye, g, he), xr(A + 96 | 0, _, 128), g = 128 + (B[A + 352 | 0] | B[A + 353 | 0] << 8 | B[A + 354 | 0] << 16 | B[A + 355 | 0] << 24) | 0, j[A + 352 | 0] = g, j[A + 353 | 0] = g >>> 8, j[A + 354 | 0] = g >>> 16, j[A + 355 | 0] = g >>> 24, Wr(_, 128), st = _ + 128 | 0);
                        }
                        he = 0;
                      }
                      return 0 | he;
                    }, dc: Is, ec: mn, fc: Zi, gc: Qs, hc: function() {
                      return 1533;
                    }, ic: wo, jc: function() {
                      return 104;
                    }, kc: kn, lc: function(A, g, _, b) {
                      return 0 | dt(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }, mc: ke, nc: function(A, g, _, b) {
                      A |= 0, g |= 0, _ |= 0, b |= 0;
                      var U, ie = 0;
                      return st = U = st - 112 | 0, ie = l[8835], l[U + 16 >> 2] = l[8834], l[U + 20 >> 2] = ie, ie = l[8837], l[U + 24 >> 2] = l[8836], l[U + 28 >> 2] = ie, ie = l[8839], l[U + 32 >> 2] = l[8838], l[U + 36 >> 2] = ie, l[U + 40 >> 2] = 0, l[U + 44 >> 2] = 0, ie = l[8833], l[U + 8 >> 2] = l[8832], l[U + 12 >> 2] = ie, dt(ie = U + 8 | 0, g, _, b), ke(ie, A), st = U + 112 | 0, 0;
                    }, oc: Zi, pc: pu, qc: ae, rc: Ns, sc: Ui, tc: Qs, uc: si, vc: Zi, wc: ba, xc: wo, yc: Ye, zc: yc, Ac: si, Bc: Zi, Cc: ba, Dc: wo, Ec: Ye, Fc: Li, Gc: function(A, g, _) {
                      return A |= 0, ku(g |= 0, 32, _ |= 0, 32, 0, 0, 0), 0 | Bu(A, g);
                    }, Hc: function(A, g) {
                      return A |= 0, jn(g |= 0, 32), 0 | Bu(A, g);
                    }, Ic: function(A, g, _, b, U) {
                      g |= 0, _ |= 0, b |= 0, U |= 0;
                      var ie, he, D = 0, me = 0;
                      if (he = D = st, st = D = D - 512 & -64, ie = (A |= 0) || g) {
                        if (me = -1, !ia(D + 96 | 0, b, U)) {
                          for (b = g || A, A = 0, fs(g = D + 128 | 0, 0, 0, 64), Is(g, me = D + 96 | 0, 32, 0), Wr(me, 32), Is(g, _, 32, 0), Is(g, U, 32, 0), Ss(g, D + 32 | 0, 64), Wr(g, 384); g = (U = D + 32 | 0) + A | 0, j[A + ie | 0] = B[0 | g], j[A + b | 0] = B[g + 32 | 0], j[(_ = 1 | A) + ie | 0] = B[_ + U | 0], j[_ + b | 0] = B[g + 33 | 0], (0 | (A = A + 2 | 0)) != 32; )
                            ;
                          Wr(D + 32 | 0, 64), me = 0;
                        }
                        return st = he, 0 | me;
                      }
                      Ai(), Xr();
                    }, Jc: function(A, g, _, b, U) {
                      g |= 0, _ |= 0, b |= 0, U |= 0;
                      var ie, he, D = 0, me = 0;
                      if (he = D = st, st = D = D - 512 & -64, ie = (A |= 0) || g) {
                        if (me = -1, !ia(D + 96 | 0, b, U)) {
                          for (b = g || A, A = 0, fs(g = D + 128 | 0, 0, 0, 64), Is(g, me = D + 96 | 0, 32, 0), Wr(me, 32), Is(g, U, 32, 0), Is(g, _, 32, 0), Ss(g, D + 32 | 0, 64), Wr(g, 384); g = (U = D + 32 | 0) + A | 0, j[A + b | 0] = B[0 | g], j[A + ie | 0] = B[g + 32 | 0], j[(_ = 1 | A) + b | 0] = B[_ + U | 0], j[_ + ie | 0] = B[g + 33 | 0], (0 | (A = A + 2 | 0)) != 32; )
                            ;
                          Wr(D + 32 | 0, 64), me = 0;
                        }
                        return st = he, 0 | me;
                      }
                      Ai(), Xr();
                    }, Kc: wo, Lc: wo, Mc: wo, Nc: wo, Oc: function() {
                      return 1315;
                    }, Pc: bc, Qc: si, Rc: wo, Sc: li, Tc: mi, Uc: function(A, g) {
                      return 0 | ys(A |= 0, g |= 0);
                    }, Vc: oa, Wc: function(A, g) {
                      return 0 | sa(A |= 0, g |= 0);
                    }, Xc: function() {
                      return 1496;
                    }, Yc: Li, Zc: li, _c: mi, $c: ys, ad: oa, bd: sa, cd: si, dd: wo, ed: bc, fd: Li, gd: eu, hd: si, id: ji, jd: Da, kd: ji, ld: si, md: Tu, nd: function() {
                      return 1549;
                    }, od: tu, pd: ji, qd: Mu, rd: Ru, sd: Du, td: mc, ud: function() {
                      return 6;
                    }, vd: function() {
                      return 134217728;
                    }, wd: ba, xd: function() {
                      return 536870912;
                    }, yd: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return 0 | ra(A |= 0, (A = 0) | (g |= 0), _ |= 0, b |= 0, A | (U |= 0), ie |= 0, he |= 0, A | (D |= 0), me |= 0, _e |= 0, Be |= 0);
                    }, zd: function(A, g, _, b, U, ie, he) {
                      return 0 | Bn(A |= 0, g |= 0, (A = 0) | (_ |= 0), b |= 0, A | (U |= 0), ie |= 0, he |= 0);
                    }, Ad: function(A, g, _, b) {
                      return 0 | ac(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }, Bd: function(A, g, _, b) {
                      return 0 | uc(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }, Cd: function(A, g, _, b) {
                      return 0 | cc(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }, Dd: Ka, Ed: si, Fd: ji, Gd: Da, Hd: ji, Id: si, Jd: Tu, Kd: Ac, Ld: eu, Md: ji, Nd: Mu, Od: Ru, Pd: Ka, Qd: gc, Rd: tu, Sd: pc, Td: Du, Ud: $u, Vd: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      return 0 | Qa(A |= 0, (A = 0) | (g |= 0), _ |= 0, b |= 0, A | (U |= 0), ie |= 0, he |= 0, A | (D |= 0), me |= 0, _e |= 0, Be |= 0);
                    }, Wd: Ao, Xd: function(A, g, _, b) {
                      return 0 | dc(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }, Yd: eu, Zd: Ka, _d: Ka, $d: si, ae: ji, be: Da, ce: ji, de: si, ee: Tu, fe: Ac, ge: eu, he: ji, ie: Mu, je: Ru, ke: Ka, le: gc, me: tu, ne: pc, oe: Du, pe: $u, qe: function(A, g, _, b, U, ie, he, D, me, _e, Be) {
                      A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0, D |= 0, me |= 0, _e |= 0, g |= 0, U |= 0, D |= 0;
                      e: {
                        switch ((Be |= 0) - 1 | 0) {
                          case 0:
                            A = ra(A, g, _, b, U, ie, he, D, me, _e, 1);
                            break e;
                          case 1:
                            A = Qa(A, g, _, b, U, ie, he, D, me, _e, 2);
                            break e;
                        }
                        l[9129] = 28, A = -1;
                      }
                      return 0 | A;
                    }, re: Ao, se: function(A, g, _, b, U, ie, he, D) {
                      A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0, _ |= 0, U |= 0;
                      e: {
                        switch ((D |= 0) - 1 | 0) {
                          case 1:
                            A = An(A, g, _, b, U, ie, he);
                            break e;
                          default:
                            Ai(), Xr();
                          case 0:
                        }
                        A = Bn(A, g, _, b, U, ie, he);
                      }
                      return 0 | A;
                    }, te: function(A, g, _, b) {
                      return g |= 0, _ |= 0, b |= 0, Dt(A |= 0, 1559, 10) ? Dt(A, 1549, 9) ? (l[9129] = 28, A = -1) : A = ac(A, g, _, b) : A = dc(A, g, _, b), 0 | A;
                    }, ue: function(A, g, _, b) {
                      return g |= 0, _ |= 0, b |= 0, Dt(A |= 0, 1559, 10) ? Dt(A, 1549, 9) ? (l[9129] = 28, A = -1) : A = uc(A, g, _, b) : A = cc(A, g, _, b), 0 | A;
                    }, ve: function() {
                      return 1157;
                    }, we: function() {
                      return 1438;
                    }, xe: Bu, ye: ia, ze: wo, Ae: wo, Be: ls, Ce: Ma, De: wo, Ee: wo, Fe: wo, Ge: fa, He: wo, Ie: si, Je: si, Ke: Ta, Le: function() {
                      return 1488;
                    }, Me: To, Ne: Do, Oe: Li, Pe: Hr, Qe: function(A, g, _, b, U, ie) {
                      return A |= 0, g |= 0, U |= 0, ie |= 0, !(b |= 0) & (_ |= 0) >>> 0 >= 4294967280 | b && (Ai(), Xr()), va(A + 16 | 0, A, g, _, b, U, ie), 0;
                    }, Re: Vr, Se: Jr, Te: To, Ue: Do, Ve: wo, We: fa, Xe: wo, Ye: si, Ze: si, _e: Ta, $e: Li, af: Li, bf: function(A, g, _) {
                      return A |= 0, _ |= 0, jn(g |= 0, 24), Ji(A, g, _, 0), j[A + 32 | 0] = 1, j[A + 33 | 0] = 0, j[A + 34 | 0] = 0, j[A + 35 | 0] = 0, _ = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, g = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, j[A + 44 | 0] = 0, j[A + 45 | 0] = 0, j[A + 46 | 0] = 0, j[A + 47 | 0] = 0, j[A + 48 | 0] = 0, j[A + 49 | 0] = 0, j[A + 50 | 0] = 0, j[A + 51 | 0] = 0, j[A + 36 | 0] = _, j[A + 37 | 0] = _ >>> 8, j[A + 38 | 0] = _ >>> 16, j[A + 39 | 0] = _ >>> 24, j[A + 40 | 0] = g, j[A + 41 | 0] = g >>> 8, j[A + 42 | 0] = g >>> 16, j[A + 43 | 0] = g >>> 24, 0;
                    }, cf: function(A, g, _) {
                      return Ji(A |= 0, g |= 0, _ |= 0, 0), j[A + 32 | 0] = 1, j[A + 33 | 0] = 0, j[A + 34 | 0] = 0, j[A + 35 | 0] = 0, _ = B[g + 16 | 0] | B[g + 17 | 0] << 8 | B[g + 18 | 0] << 16 | B[g + 19 | 0] << 24, g = B[g + 20 | 0] | B[g + 21 | 0] << 8 | B[g + 22 | 0] << 16 | B[g + 23 | 0] << 24, j[A + 44 | 0] = 0, j[A + 45 | 0] = 0, j[A + 46 | 0] = 0, j[A + 47 | 0] = 0, j[A + 48 | 0] = 0, j[A + 49 | 0] = 0, j[A + 50 | 0] = 0, j[A + 51 | 0] = 0, j[A + 36 | 0] = _, j[A + 37 | 0] = _ >>> 8, j[A + 38 | 0] = _ >>> 16, j[A + 39 | 0] = _ >>> 24, j[A + 40 | 0] = g, j[A + 41 | 0] = g >>> 8, j[A + 42 | 0] = g >>> 16, j[A + 43 | 0] = g >>> 24, 0;
                    }, df: function(A) {
                      var g, _ = 0, b = 0;
                      st = g = st - 48 | 0, _ = B[28 + (A |= 0) | 0] | B[A + 29 | 0] << 8 | B[A + 30 | 0] << 16 | B[A + 31 | 0] << 24, l[g + 24 >> 2] = B[A + 24 | 0] | B[A + 25 | 0] << 8 | B[A + 26 | 0] << 16 | B[A + 27 | 0] << 24, l[g + 28 >> 2] = _, _ = B[A + 20 | 0] | B[A + 21 | 0] << 8 | B[A + 22 | 0] << 16 | B[A + 23 | 0] << 24, l[g + 16 >> 2] = B[A + 16 | 0] | B[A + 17 | 0] << 8 | B[A + 18 | 0] << 16 | B[A + 19 | 0] << 24, l[g + 20 >> 2] = _, _ = B[A + 4 | 0] | B[A + 5 | 0] << 8 | B[A + 6 | 0] << 16 | B[A + 7 | 0] << 24, l[g >> 2] = B[0 | A] | B[A + 1 | 0] << 8 | B[A + 2 | 0] << 16 | B[A + 3 | 0] << 24, l[g + 4 >> 2] = _, _ = B[A + 12 | 0] | B[A + 13 | 0] << 8 | B[A + 14 | 0] << 16 | B[A + 15 | 0] << 24, l[g + 8 >> 2] = B[A + 8 | 0] | B[A + 9 | 0] << 8 | B[A + 10 | 0] << 16 | B[A + 11 | 0] << 24, l[g + 12 >> 2] = _, _ = B[A + 40 | 0] | B[A + 41 | 0] << 8 | B[A + 42 | 0] << 16 | B[A + 43 | 0] << 24, l[g + 32 >> 2] = B[A + 36 | 0] | B[A + 37 | 0] << 8 | B[A + 38 | 0] << 16 | B[A + 39 | 0] << 24, l[g + 36 >> 2] = _, mo(g, g, 40, 0, A + 32 | 0, A), _ = l[g + 28 >> 2], b = l[g + 24 >> 2], j[A + 24 | 0] = b, j[A + 25 | 0] = b >>> 8, j[A + 26 | 0] = b >>> 16, j[A + 27 | 0] = b >>> 24, j[A + 28 | 0] = _, j[A + 29 | 0] = _ >>> 8, j[A + 30 | 0] = _ >>> 16, j[A + 31 | 0] = _ >>> 24, _ = l[g + 20 >> 2], b = l[g + 16 >> 2], j[A + 16 | 0] = b, j[A + 17 | 0] = b >>> 8, j[A + 18 | 0] = b >>> 16, j[A + 19 | 0] = b >>> 24, j[A + 20 | 0] = _, j[A + 21 | 0] = _ >>> 8, j[A + 22 | 0] = _ >>> 16, j[A + 23 | 0] = _ >>> 24, _ = l[g + 12 >> 2], b = l[g + 8 >> 2], j[A + 8 | 0] = b, j[A + 9 | 0] = b >>> 8, j[A + 10 | 0] = b >>> 16, j[A + 11 | 0] = b >>> 24, j[A + 12 | 0] = _, j[A + 13 | 0] = _ >>> 8, j[A + 14 | 0] = _ >>> 16, j[A + 15 | 0] = _ >>> 24, _ = l[g + 4 >> 2], b = l[g >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 4 | 0] = _, j[A + 5 | 0] = _ >>> 8, j[A + 6 | 0] = _ >>> 16, j[A + 7 | 0] = _ >>> 24, b = l[g + 36 >> 2], _ = l[g + 32 >> 2], j[A + 32 | 0] = 1, j[A + 33 | 0] = 0, j[A + 34 | 0] = 0, j[A + 35 | 0] = 0, j[A + 36 | 0] = _, j[A + 37 | 0] = _ >>> 8, j[A + 38 | 0] = _ >>> 16, j[A + 39 | 0] = _ >>> 24, j[A + 40 | 0] = b, j[A + 41 | 0] = b >>> 8, j[A + 42 | 0] = b >>> 16, j[A + 43 | 0] = b >>> 24, st = g + 48 | 0;
                    }, ef: function(A, g, _, b, U, ie, he, D, me, _e) {
                      A |= 0, g |= 0, b |= 0, he |= 0, me |= 0, _e |= 0;
                      var Be, ye = 0, we = 0, $e = 0;
                      return ye = U |= 0, U = ie |= 0, ye |= ie = 0, Be = ie | (D |= 0), st = ie = st - 384 | 0, (_ |= 0) && (l[_ >> 2] = 0, l[_ + 4 >> 2] = 0), !U & ye >>> 0 < 4294967279 ? (Vo(we = ie + 16 | 0, 64, 0, $e = A + 32 | 0, A), ys(D = ie + 80 | 0, we), Wr(we, 64), ni(D, he, Be, me), ni(D, 35680, 0 - Be & 15, 0), l[ie + 72 >> 2] = 0, l[ie + 76 >> 2] = 0, l[(he = ie - -64 | 0) >> 2] = 0, l[he + 4 >> 2] = 0, l[ie + 56 >> 2] = 0, l[ie + 60 >> 2] = 0, l[ie + 48 >> 2] = 0, l[ie + 52 >> 2] = 0, l[ie + 40 >> 2] = 0, l[ie + 44 >> 2] = 0, l[ie + 32 >> 2] = 0, l[ie + 36 >> 2] = 0, l[ie + 16 >> 2] = 0, l[ie + 20 >> 2] = 0, l[ie + 24 >> 2] = 0, l[ie + 28 >> 2] = 0, j[ie + 16 | 0] = _e, Vn(we, we, 64, 0, $e, 1, A), ni(D, we, 64, 0), j[0 | g] = B[ie + 16 | 0], Vn(g = g + 1 | 0, b, ye, U, $e, 2, A), ni(D, g, ye, U), ni(D, 35680, 15 & ye, 0), l[ie + 8 >> 2] = Be, l[ie + 12 >> 2] = me, ni(D, b = ie + 8 | 0, 8, 0), l[ie + 8 >> 2] = ye - -64, l[ie + 12 >> 2] = U - ((ye >>> 0 < 4294967232) - 1 | 0), ni(D, b, 8, 0), sa(D, g = g + ye | 0), Wr(D, 256), j[A + 36 | 0] = B[A + 36 | 0] ^ B[0 | g], j[A + 37 | 0] = B[A + 37 | 0] ^ B[g + 1 | 0], j[A + 38 | 0] = B[A + 38 | 0] ^ B[g + 2 | 0], j[A + 39 | 0] = B[A + 39 | 0] ^ B[g + 3 | 0], j[A + 40 | 0] = B[A + 40 | 0] ^ B[g + 4 | 0], j[A + 41 | 0] = B[A + 41 | 0] ^ B[g + 5 | 0], j[A + 42 | 0] = B[A + 42 | 0] ^ B[g + 6 | 0], j[A + 43 | 0] = B[A + 43 | 0] ^ B[g + 7 | 0], un($e), (2 & _e || le($e, 4)) && (g = B[A + 28 | 0] | B[A + 29 | 0] << 8 | B[A + 30 | 0] << 16 | B[A + 31 | 0] << 24, l[ie + 360 >> 2] = B[A + 24 | 0] | B[A + 25 | 0] << 8 | B[A + 26 | 0] << 16 | B[A + 27 | 0] << 24, l[ie + 364 >> 2] = g, g = B[A + 20 | 0] | B[A + 21 | 0] << 8 | B[A + 22 | 0] << 16 | B[A + 23 | 0] << 24, l[ie + 352 >> 2] = B[A + 16 | 0] | B[A + 17 | 0] << 8 | B[A + 18 | 0] << 16 | B[A + 19 | 0] << 24, l[ie + 356 >> 2] = g, g = B[A + 4 | 0] | B[A + 5 | 0] << 8 | B[A + 6 | 0] << 16 | B[A + 7 | 0] << 24, l[ie + 336 >> 2] = B[0 | A] | B[A + 1 | 0] << 8 | B[A + 2 | 0] << 16 | B[A + 3 | 0] << 24, l[ie + 340 >> 2] = g, g = B[A + 12 | 0] | B[A + 13 | 0] << 8 | B[A + 14 | 0] << 16 | B[A + 15 | 0] << 24, l[ie + 344 >> 2] = B[A + 8 | 0] | B[A + 9 | 0] << 8 | B[A + 10 | 0] << 16 | B[A + 11 | 0] << 24, l[ie + 348 >> 2] = g, g = B[A + 40 | 0] | B[A + 41 | 0] << 8 | B[A + 42 | 0] << 16 | B[A + 43 | 0] << 24, l[ie + 368 >> 2] = B[A + 36 | 0] | B[A + 37 | 0] << 8 | B[A + 38 | 0] << 16 | B[A + 39 | 0] << 24, l[ie + 372 >> 2] = g, mo(g = ie + 336 | 0, g, 40, 0, $e, A), g = l[ie + 364 >> 2], b = l[ie + 360 >> 2], j[A + 24 | 0] = b, j[A + 25 | 0] = b >>> 8, j[A + 26 | 0] = b >>> 16, j[A + 27 | 0] = b >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[ie + 356 >> 2], b = l[ie + 352 >> 2], j[A + 16 | 0] = b, j[A + 17 | 0] = b >>> 8, j[A + 18 | 0] = b >>> 16, j[A + 19 | 0] = b >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[ie + 348 >> 2], b = l[ie + 344 >> 2], j[A + 8 | 0] = b, j[A + 9 | 0] = b >>> 8, j[A + 10 | 0] = b >>> 16, j[A + 11 | 0] = b >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[ie + 340 >> 2], b = l[ie + 336 >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, g = l[ie + 368 >> 2], b = l[ie + 372 >> 2], j[A + 32 | 0] = 1, j[A + 33 | 0] = 0, j[A + 34 | 0] = 0, j[A + 35 | 0] = 0, j[A + 36 | 0] = g, j[A + 37 | 0] = g >>> 8, j[A + 38 | 0] = g >>> 16, j[A + 39 | 0] = g >>> 24, j[A + 40 | 0] = b, j[A + 41 | 0] = b >>> 8, j[A + 42 | 0] = b >>> 16, j[A + 43 | 0] = b >>> 24), _ && (U = (A = ye + 17 | 0) >>> 0 < 17 ? U + 1 | 0 : U, l[_ >> 2] = A, l[_ + 4 >> 2] = U), st = ie + 384 | 0) : (Ai(), Xr()), 0;
                    }, ff: function(A, g, _, b, U, ie, he, D, me, _e) {
                      A |= 0, g |= 0, b |= 0, U |= 0, D |= 0, _e |= 0;
                      var Be, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0;
                      ye = ie |= 0, ie = he |= 0, we = 0 | ye, Be = me |= 0, st = he = st - 400 | 0, (_ |= 0) && (l[_ >> 2] = 0, l[_ + 4 >> 2] = 0), b && (j[0 | b] = 255), je = -1;
                      e: {
                        t: {
                          if (!(!ie & we >>> 0 < 17)) {
                            if (Ge = ye = ie - (we >>> 0 < 17) | 0, !ye & (me = we - 17 | 0) >>> 0 >= 4294967279 | ye)
                              break t;
                            Vo($e = he + 32 | 0, 64, 0, Le = A + 32 | 0, A), ys(ye = he + 96 | 0, $e), Wr($e, 64), ni(ye, D, Be, _e), ni(ye, 35680, 0 - Be & 15, 0), l[he + 88 >> 2] = 0, l[he + 92 >> 2] = 0, l[he + 80 >> 2] = 0, l[he + 84 >> 2] = 0, l[he + 72 >> 2] = 0, l[he + 76 >> 2] = 0, l[(D = he - -64 | 0) >> 2] = 0, l[D + 4 >> 2] = 0, l[he + 56 >> 2] = 0, l[he + 60 >> 2] = 0, l[he + 48 >> 2] = 0, l[he + 52 >> 2] = 0, l[he + 40 >> 2] = 0, l[he + 44 >> 2] = 0, l[he + 32 >> 2] = 0, l[he + 36 >> 2] = 0, j[he + 32 | 0] = B[0 | U], Vn($e, $e, 64, 0, Le, 1, A), D = B[he + 32 | 0], j[he + 32 | 0] = B[0 | U], ni(ye, $e, 64, 0), ni(ye, U = U + 1 | 0, me, Ge), ni(ye, 35680, we - 1 & 15, 0), l[he + 24 >> 2] = Be, l[he + 28 >> 2] = _e, ni(ye, _e = he + 24 | 0, 8, 0), ie = (we = we + 47 | 0) >>> 0 < 47 ? ie + 1 | 0 : ie, l[he + 24 >> 2] = we, l[he + 28 >> 2] = ie, ni(ye, _e, 8, 0), sa(ye, he), Wr(ye, 256), Ie(he, U + me | 0, 16) ? Wr(he, 16) : (Vn(g, U, me, Ge, Le, 2, A), j[A + 36 | 0] = B[A + 36 | 0] ^ B[0 | he], j[A + 37 | 0] = B[A + 37 | 0] ^ B[he + 1 | 0], j[A + 38 | 0] = B[A + 38 | 0] ^ B[he + 2 | 0], j[A + 39 | 0] = B[A + 39 | 0] ^ B[he + 3 | 0], j[A + 40 | 0] = B[A + 40 | 0] ^ B[he + 4 | 0], j[A + 41 | 0] = B[A + 41 | 0] ^ B[he + 5 | 0], j[A + 42 | 0] = B[A + 42 | 0] ^ B[he + 6 | 0], j[A + 43 | 0] = B[A + 43 | 0] ^ B[he + 7 | 0], un(Le), (2 & D || le(Le, 4)) && (g = B[A + 28 | 0] | B[A + 29 | 0] << 8 | B[A + 30 | 0] << 16 | B[A + 31 | 0] << 24, l[he + 376 >> 2] = B[A + 24 | 0] | B[A + 25 | 0] << 8 | B[A + 26 | 0] << 16 | B[A + 27 | 0] << 24, l[he + 380 >> 2] = g, g = B[A + 20 | 0] | B[A + 21 | 0] << 8 | B[A + 22 | 0] << 16 | B[A + 23 | 0] << 24, l[he + 368 >> 2] = B[A + 16 | 0] | B[A + 17 | 0] << 8 | B[A + 18 | 0] << 16 | B[A + 19 | 0] << 24, l[he + 372 >> 2] = g, g = B[A + 4 | 0] | B[A + 5 | 0] << 8 | B[A + 6 | 0] << 16 | B[A + 7 | 0] << 24, l[he + 352 >> 2] = B[0 | A] | B[A + 1 | 0] << 8 | B[A + 2 | 0] << 16 | B[A + 3 | 0] << 24, l[he + 356 >> 2] = g, g = B[A + 12 | 0] | B[A + 13 | 0] << 8 | B[A + 14 | 0] << 16 | B[A + 15 | 0] << 24, l[he + 360 >> 2] = B[A + 8 | 0] | B[A + 9 | 0] << 8 | B[A + 10 | 0] << 16 | B[A + 11 | 0] << 24, l[he + 364 >> 2] = g, g = B[A + 40 | 0] | B[A + 41 | 0] << 8 | B[A + 42 | 0] << 16 | B[A + 43 | 0] << 24, l[he + 384 >> 2] = B[A + 36 | 0] | B[A + 37 | 0] << 8 | B[A + 38 | 0] << 16 | B[A + 39 | 0] << 24, l[he + 388 >> 2] = g, mo(g = he + 352 | 0, g, 40, 0, Le, A), g = l[he + 380 >> 2], U = l[he + 376 >> 2], j[A + 24 | 0] = U, j[A + 25 | 0] = U >>> 8, j[A + 26 | 0] = U >>> 16, j[A + 27 | 0] = U >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[he + 372 >> 2], U = l[he + 368 >> 2], j[A + 16 | 0] = U, j[A + 17 | 0] = U >>> 8, j[A + 18 | 0] = U >>> 16, j[A + 19 | 0] = U >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[he + 364 >> 2], U = l[he + 360 >> 2], j[A + 8 | 0] = U, j[A + 9 | 0] = U >>> 8, j[A + 10 | 0] = U >>> 16, j[A + 11 | 0] = U >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[he + 356 >> 2], U = l[he + 352 >> 2], j[0 | A] = U, j[A + 1 | 0] = U >>> 8, j[A + 2 | 0] = U >>> 16, j[A + 3 | 0] = U >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, g = l[he + 384 >> 2], U = l[he + 388 >> 2], j[A + 32 | 0] = 1, j[A + 33 | 0] = 0, j[A + 34 | 0] = 0, j[A + 35 | 0] = 0, j[A + 36 | 0] = g, j[A + 37 | 0] = g >>> 8, j[A + 38 | 0] = g >>> 16, j[A + 39 | 0] = g >>> 24, j[A + 40 | 0] = U, j[A + 41 | 0] = U >>> 8, j[A + 42 | 0] = U >>> 16, j[A + 43 | 0] = U >>> 24), _ && (l[_ >> 2] = me, l[_ + 4 >> 2] = Ge), je = 0, b && (j[0 | b] = D));
                          }
                          st = he + 400 | 0;
                          break e;
                        }
                        Ai(), Xr();
                      }
                      return 0 | je;
                    }, gf: function() {
                      return 52;
                    }, hf: function() {
                      return 17;
                    }, jf: fa, kf: wo, lf: function() {
                      return -18;
                    }, mf: Da, nf: eu, of: Ka, pf: tu, qf: ba, rf: si, sf: function() {
                      return 1523;
                    }, tf: da, uf: function(A) {
                      jn(A |= 0, 16);
                    }, vf: ba, wf: si, xf: da, yf: pu, zf: Zi, Af: wo, Bf: wo, Cf: Zi, Df: wc, Ef: function() {
                      return 1449;
                    }, Ff: function(A, g, _) {
                      return 0 | Ea(A |= 0, g |= 0, _ |= 0);
                    }, Gf: function(A, g) {
                      return 0 | Ce(A |= 0, g |= 0);
                    }, Hf: tt, If: be, Jf: ho, Kf: ci, Lf: function(A) {
                      return 0 | fc(A |= 0);
                    }, Mf: Ns, Nf: function(A, g, _, b) {
                      return 0 | _o(A |= 0, g |= 0, _ |= 0, b |= 0);
                    }, Of: function(A, g, _) {
                      return 0 | ir(A |= 0, g |= 0, _ |= 0);
                    }, Pf: pu, Qf: Zi, Rf: wo, Sf: wo, Tf: Zi, Uf: wc, Vf: function(A, g) {
                      A |= 0;
                      var _, b, U, ie, he, D, me = 0;
                      return _ = B[8 + (me = g |= 0) | 0] | B[me + 9 | 0] << 8 | B[me + 10 | 0] << 16 | B[me + 11 | 0] << 24, b = B[me + 12 | 0] | B[me + 13 | 0] << 8 | B[me + 14 | 0] << 16 | B[me + 15 | 0] << 24, U = B[me + 16 | 0] | B[me + 17 | 0] << 8 | B[me + 18 | 0] << 16 | B[me + 19 | 0] << 24, ie = B[me + 20 | 0] | B[me + 21 | 0] << 8 | B[me + 22 | 0] << 16 | B[me + 23 | 0] << 24, he = B[0 | me] | B[me + 1 | 0] << 8 | B[me + 2 | 0] << 16 | B[me + 3 | 0] << 24, g = B[me + 4 | 0] | B[me + 5 | 0] << 8 | B[me + 6 | 0] << 16 | B[me + 7 | 0] << 24, D = B[me + 28 | 0] | B[me + 29 | 0] << 8 | B[me + 30 | 0] << 16 | B[me + 31 | 0] << 24, me = B[me + 24 | 0] | B[me + 25 | 0] << 8 | B[me + 26 | 0] << 16 | B[me + 27 | 0] << 24, j[A + 24 | 0] = me, j[A + 25 | 0] = me >>> 8, j[A + 26 | 0] = me >>> 16, j[A + 27 | 0] = me >>> 24, j[A + 28 | 0] = D, j[A + 29 | 0] = D >>> 8, j[A + 30 | 0] = D >>> 16, j[A + 31 | 0] = D >>> 24, j[A + 16 | 0] = U, j[A + 17 | 0] = U >>> 8, j[A + 18 | 0] = U >>> 16, j[A + 19 | 0] = U >>> 24, j[A + 20 | 0] = ie, j[A + 21 | 0] = ie >>> 8, j[A + 22 | 0] = ie >>> 16, j[A + 23 | 0] = ie >>> 24, j[A + 8 | 0] = _, j[A + 9 | 0] = _ >>> 8, j[A + 10 | 0] = _ >>> 16, j[A + 11 | 0] = _ >>> 24, j[A + 12 | 0] = b, j[A + 13 | 0] = b >>> 8, j[A + 14 | 0] = b >>> 16, j[A + 15 | 0] = b >>> 24, j[0 | A] = he, j[A + 1 | 0] = he >>> 8, j[A + 2 | 0] = he >>> 16, j[A + 3 | 0] = he >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, 0;
                    }, Wf: function(A, g) {
                      A |= 0;
                      var _, b, U, ie, he, D, me = 0;
                      return _ = B[32 + (me = g |= 0) | 0] | B[me + 33 | 0] << 8 | B[me + 34 | 0] << 16 | B[me + 35 | 0] << 24, b = B[me + 36 | 0] | B[me + 37 | 0] << 8 | B[me + 38 | 0] << 16 | B[me + 39 | 0] << 24, U = B[me + 40 | 0] | B[me + 41 | 0] << 8 | B[me + 42 | 0] << 16 | B[me + 43 | 0] << 24, ie = B[me + 44 | 0] | B[me + 45 | 0] << 8 | B[me + 46 | 0] << 16 | B[me + 47 | 0] << 24, he = B[me + 48 | 0] | B[me + 49 | 0] << 8 | B[me + 50 | 0] << 16 | B[me + 51 | 0] << 24, g = B[me + 52 | 0] | B[me + 53 | 0] << 8 | B[me + 54 | 0] << 16 | B[me + 55 | 0] << 24, D = B[me + 60 | 0] | B[me + 61 | 0] << 8 | B[me + 62 | 0] << 16 | B[me + 63 | 0] << 24, me = B[me + 56 | 0] | B[me + 57 | 0] << 8 | B[me + 58 | 0] << 16 | B[me + 59 | 0] << 24, j[A + 24 | 0] = me, j[A + 25 | 0] = me >>> 8, j[A + 26 | 0] = me >>> 16, j[A + 27 | 0] = me >>> 24, j[A + 28 | 0] = D, j[A + 29 | 0] = D >>> 8, j[A + 30 | 0] = D >>> 16, j[A + 31 | 0] = D >>> 24, j[A + 16 | 0] = he, j[A + 17 | 0] = he >>> 8, j[A + 18 | 0] = he >>> 16, j[A + 19 | 0] = he >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, j[A + 8 | 0] = U, j[A + 9 | 0] = U >>> 8, j[A + 10 | 0] = U >>> 16, j[A + 11 | 0] = U >>> 24, j[A + 12 | 0] = ie, j[A + 13 | 0] = ie >>> 8, j[A + 14 | 0] = ie >>> 16, j[A + 15 | 0] = ie >>> 24, j[0 | A] = _, j[A + 1 | 0] = _ >>> 8, j[A + 2 | 0] = _ >>> 16, j[A + 3 | 0] = _ >>> 24, j[A + 4 | 0] = b, j[A + 5 | 0] = b >>> 8, j[A + 6 | 0] = b >>> 16, j[A + 7 | 0] = b >>> 24, 0;
                    }, Xf: fc, Yf: Ns, Zf: _o, _f: ir, $f: Ea, ag: Ce, bg: function(A, g) {
                      A |= 0;
                      var _, b = 0, U = 0, ie = 0, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0, Tt = 0, Gt = 0, en = 0, it = 0, St = 0, Ft = 0, fn = 0, _n = 0, wn = 0, $n = 0, qn = 0, Gn = 0, Kn = 0, Kt = 0, pn = 0, Hn = 0, Zn = 0, er = 0, Zt = 0, Sn = 0, or = 0, ur = 0, Cr = 0, Je = 0, Ve = 0, ut = 0, Nn = 0, cr = 0, Rr = 0, Ir = 0, Pr = 0, qr = 0, ao = 0, Fn = 0, Wn = 0, wt = 0, jt = 0, an = 0, Ar = 0, Tr = 0, zr = 0, Gr = 0, no = 0, so = 0, co = 0, lo = 0, yo = 0, Co = 0, Io = 0, ko = 0, Po = 0, $o = 0, xo = 0, Go = 0, Xo = 0, ei = 0, ti = 0, oi = 0, vi = 0, Ti = 0, Oi = 0;
                      return st = _ = st - 256 | 0, xo = -1, Qe(g |= 0) || Rn(_ + 96 | 0, g) || ga(_ + 96 | 0) && (ie = l[_ + 136 >> 2], l[_ >> 2] = 1 - ie, xo = 0, Kn = l[_ + 172 >> 2], l[_ + 36 >> 2] = 0 - Kn, ct = l[_ + 168 >> 2], l[_ + 32 >> 2] = 0 - ct, Kt = l[_ + 164 >> 2], l[_ + 28 >> 2] = 0 - Kt, mt = l[_ + 160 >> 2], l[_ + 24 >> 2] = 0 - mt, pn = l[_ + 156 >> 2], l[_ + 20 >> 2] = 0 - pn, bt = l[_ + 152 >> 2], l[_ + 16 >> 2] = 0 - bt, Hn = l[_ + 148 >> 2], l[_ + 12 >> 2] = 0 - Hn, ht = l[_ + 144 >> 2], l[_ + 8 >> 2] = 0 - ht, Zn = l[_ + 140 >> 2], l[_ + 4 >> 2] = 0 - Zn, Mn(_, _), g = De(Ct = l[_ + 4 >> 2], $n = Ct >> 31, Tt = pn << 1, Ir = Tt >> 31), b = ve, U = De(je = l[_ >> 2], en = je >> 31, mt, it = mt >> 31), b = ve + b | 0, b = (g = U + g | 0) >>> 0 < U >>> 0 ? b + 1 | 0 : b, U = (he = De(St = l[_ + 8 >> 2], er = St >> 31, bt, Ft = bt >> 31)) + g | 0, g = ve + b | 0, g = U >>> 0 < he >>> 0 ? g + 1 | 0 : g, b = U, U = De(qn = l[_ + 12 >> 2], or = qn >> 31, Je = Hn << 1, Pr = Je >> 31), g = ve + g | 0, g = (b = b + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(Zt = l[_ + 16 >> 2], Ve = Zt >> 31, ht, fn = ht >> 31), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, yo = he = l[_ + 20 >> 2], Le = De(he, qr = he >> 31, ut = Zn << 1, ao = ut >> 31), U = ve + g | 0, U = (b = Le + b | 0) >>> 0 < Le >>> 0 ? U + 1 | 0 : U, Co = ye = l[_ + 24 >> 2], g = (ie = De(ye, so = ye >> 31, Le = ie + 1 | 0, _n = Le >> 31)) + b | 0, b = ve + U | 0, b = g >>> 0 < ie >>> 0 ? b + 1 | 0 : b, Fn = l[_ + 28 >> 2], U = (ie = De(me = wr(Fn, 19), ur = me >> 31, Nn = Kn << 1, Wn = Nn >> 31)) + g | 0, g = ve + b | 0, g = U >>> 0 < ie >>> 0 ? g + 1 | 0 : g, b = U, Go = l[_ + 32 >> 2], U = De(Ge = wr(Go, 19), Sn = Ge >> 31, ct, wn = ct >> 31), g = ve + g | 0, g = (b = b + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, Xo = l[_ + 36 >> 2], U = De($e = wr(Xo, 19), Gn = $e >> 31, cr = Kt << 1, wt = cr >> 31), g = ve + g | 0, _e = b = U + b | 0, ie = b >>> 0 < U >>> 0 ? g + 1 | 0 : g, g = De(bt, Ft, Ct, $n), b = ve, D = De(je, en, pn, jt = pn >> 31), U = ve + b | 0, U = (g = D + g | 0) >>> 0 < D >>> 0 ? U + 1 | 0 : U, D = De(St, er, Hn, an = Hn >> 31), b = ve + U | 0, b = (g = D + g | 0) >>> 0 < D >>> 0 ? b + 1 | 0 : b, U = (D = De(ht, fn, qn, or)) + g | 0, g = ve + b | 0, g = U >>> 0 < D >>> 0 ? g + 1 | 0 : g, b = U, U = De(Zt, Ve, Zn, Ar = Zn >> 31), g = ve + g | 0, g = (b = b + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(Le, _n, he, qr), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, D = De(ye = wr(ye, 19), Rr = ye >> 31, Kn, Tr = Kn >> 31), U = ve + g | 0, U = (b = D + b | 0) >>> 0 < D >>> 0 ? U + 1 | 0 : U, g = (D = De(ct, wn, me, ur)) + b | 0, b = ve + U | 0, b = g >>> 0 < D >>> 0 ? b + 1 | 0 : b, U = (D = De(Ge, Sn, Kt, zr = Kt >> 31)) + g | 0, g = ve + b | 0, g = U >>> 0 < D >>> 0 ? g + 1 | 0 : g, b = U, U = De($e, Gn, mt, it), g = ve + g | 0, Io = b = b + U | 0, Cr = b >>> 0 < U >>> 0 ? g + 1 | 0 : g, g = De(Ct, $n, Je, Pr), U = ve, b = (D = De(je, en, bt, Ft)) + g | 0, g = ve + U | 0, g = b >>> 0 < D >>> 0 ? g + 1 | 0 : g, D = De(ht, fn, St, er), U = ve + g | 0, U = (b = D + b | 0) >>> 0 < D >>> 0 ? U + 1 | 0 : U, g = (D = De(qn, or, ut, ao)) + b | 0, b = ve + U | 0, b = g >>> 0 < D >>> 0 ? b + 1 | 0 : b, U = (D = De(Le, _n, Zt, Ve)) + g | 0, g = ve + b | 0, g = U >>> 0 < D >>> 0 ? g + 1 | 0 : g, b = U, U = De(D = wr(he, 19), Gr = D >> 31, Nn, Wn), g = ve + g | 0, g = (b = b + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(ct, wn, ye, Rr), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, he = De(me, ur, cr, wt), U = ve + g | 0, U = (b = he + b | 0) >>> 0 < he >>> 0 ? U + 1 | 0 : U, g = (he = De(Ge, Sn, mt, it)) + b | 0, b = ve + U | 0, b = g >>> 0 < he >>> 0 ? b + 1 | 0 : b, U = (he = De($e, Gn, Tt, Ir)) + g | 0, g = ve + b | 0, ei = U, ti = g = U >>> 0 < he >>> 0 ? g + 1 | 0 : g, oi = U = U + 33554432 | 0, vi = g = U >>> 0 < 33554432 ? g + 1 | 0 : g, U = (67108863 & g) << 6 | U >>> 26, g = (g >> 26) + Cr | 0, Io = he = U + Io | 0, U = g = U >>> 0 > he >>> 0 ? g + 1 | 0 : g, Ti = g = he + 16777216 | 0, he = (33554431 & (U = g >>> 0 < 16777216 ? U + 1 | 0 : U)) << 7 | g >>> 25, g = (b = U >> 25) + ie | 0, g = (U = he + _e | 0) >>> 0 < he >>> 0 ? g + 1 | 0 : g, ko = b = U + 33554432 | 0, he = g = b >>> 0 < 33554432 ? g + 1 | 0 : g, l[_ + 72 >> 2] = U - (-67108864 & b), g = De(Ct, $n, ut, ao), b = ve, ie = De(je, en, ht, fn), U = ve + b | 0, U = (g = ie + g | 0) >>> 0 < ie >>> 0 ? U + 1 | 0 : U, b = (ie = De(Le, _n, St, er)) + g | 0, g = ve + U | 0, g = b >>> 0 < ie >>> 0 ? g + 1 | 0 : g, U = De(ie = wr(qn, 19), no = ie >> 31, Nn, Wn), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (_e = De(Cr = wr(Zt, 19), co = Cr >> 31, ct, wn)) + b | 0, b = ve + g | 0, b = U >>> 0 < _e >>> 0 ? b + 1 | 0 : b, _e = De(cr, wt, D, Gr), g = ve + b | 0, g = (U = _e + U | 0) >>> 0 < _e >>> 0 ? g + 1 | 0 : g, b = (_e = De(mt, it, ye, Rr)) + U | 0, U = ve + g | 0, U = b >>> 0 < _e >>> 0 ? U + 1 | 0 : U, _e = De(me, ur, Tt, Ir), g = ve + U | 0, g = (b = _e + b | 0) >>> 0 < _e >>> 0 ? g + 1 | 0 : g, U = De(Ge, Sn, bt, Ft), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (_e = De($e, Gn, Je, Pr)) + b | 0, b = ve + g | 0, we = U, Po = U >>> 0 < _e >>> 0 ? b + 1 | 0 : b, g = De(Le, _n, Ct, $n), b = ve, U = (_e = De(je, en, Zn, Ar)) + g | 0, g = ve + b | 0, g = U >>> 0 < _e >>> 0 ? g + 1 | 0 : g, _e = b = wr(St, 19), b = (Be = De(b, lo = b >> 31, Kn, Tr)) + U | 0, U = ve + g | 0, U = b >>> 0 < Be >>> 0 ? U + 1 | 0 : U, Be = De(ct, wn, ie, no), g = ve + U | 0, g = (b = Be + b | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, U = De(Cr, co, Kt, zr), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (Be = De(mt, it, D, Gr)) + b | 0, b = ve + g | 0, b = U >>> 0 < Be >>> 0 ? b + 1 | 0 : b, Be = De(ye, Rr, pn, jt), g = ve + b | 0, g = (U = Be + U | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, b = (Be = De(bt, Ft, me, ur)) + U | 0, U = ve + g | 0, U = b >>> 0 < Be >>> 0 ? U + 1 | 0 : U, Be = De(Ge, Sn, Hn, an), g = ve + U | 0, g = (b = Be + b | 0) >>> 0 < Be >>> 0 ? g + 1 | 0 : g, U = De($e, Gn, ht, fn), g = ve + g | 0, $o = b = U + b | 0, Be = b >>> 0 < U >>> 0 ? g + 1 | 0 : g, g = De(g = wr(Ct, 19), g >> 31, Nn, Wn), b = ve, U = De(je, en, Le, _n), b = ve + b | 0, b = (g = U + g | 0) >>> 0 < U >>> 0 ? b + 1 | 0 : b, U = (_e = De(ct, wn, _e, lo)) + g | 0, g = ve + b | 0, b = (ie = De(ie, no, cr, wt)) + U | 0, U = ve + (U >>> 0 < _e >>> 0 ? g + 1 | 0 : g) | 0, U = b >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = De(mt, it, Cr, co), g = ve + U | 0, g = (b = ie + b | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, U = De(Tt, Ir, D, Gr), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (ie = De(bt, Ft, ye, Rr)) + b | 0, b = ve + g | 0, b = U >>> 0 < ie >>> 0 ? b + 1 | 0 : b, ie = De(me, ur, Je, Pr), g = ve + b | 0, g = (U = ie + U | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, b = (ie = De(Ge, Sn, ht, fn)) + U | 0, U = ve + g | 0, U = b >>> 0 < ie >>> 0 ? U + 1 | 0 : U, ie = De($e, Gn, ut, ao), g = ve + U | 0, _e = b = ie + b | 0, no = g = b >>> 0 < ie >>> 0 ? g + 1 | 0 : g, lo = b = b + 33554432 | 0, Oi = g = b >>> 0 < 33554432 ? g + 1 | 0 : g, U = g >> 26, g = (67108863 & g) << 6 | b >>> 26, b = U + Be | 0, Be = ie = g + $o | 0, g = b = g >>> 0 > ie >>> 0 ? b + 1 | 0 : b, $o = b = ie + 16777216 | 0, ie = (33554431 & (g = b >>> 0 < 16777216 ? g + 1 | 0 : g)) << 7 | b >>> 25, g = (g >> 25) + Po | 0, g = (b = ie + we | 0) >>> 0 < ie >>> 0 ? g + 1 | 0 : g, U = b, Po = b = b + 33554432 | 0, ie = g = b >>> 0 < 33554432 ? g + 1 | 0 : g, l[_ + 56 >> 2] = U - (-67108864 & b), g = De(mt, it, Ct, $n), U = ve, b = (we = De(je, en, Kt, zr)) + g | 0, g = ve + U | 0, g = b >>> 0 < we >>> 0 ? g + 1 | 0 : g, U = De(St, er, pn, jt), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(bt, Ft, qn, or), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, we = De(Zt, Ve, Hn, an), U = ve + g | 0, U = (b = we + b | 0) >>> 0 < we >>> 0 ? U + 1 | 0 : U, g = (we = De(ht, fn, yo, qr)) + b | 0, b = ve + U | 0, b = g >>> 0 < we >>> 0 ? b + 1 | 0 : b, U = (we = De(Zn, Ar, Co, so)) + g | 0, g = ve + b | 0, g = U >>> 0 < we >>> 0 ? g + 1 | 0 : g, b = U, U = De(Fn, we = Fn >> 31, Le, _n), g = ve + g | 0, g = (b = b + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(Ge, Sn, Kn, Tr), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, Gt = (U = b) + (b = De($e, Gn, ct, wn)) | 0, U = ve + g | 0, b = (g = he >> 26) + (b = b >>> 0 > Gt >>> 0 ? U + 1 | 0 : U) | 0, g = (U = (he = (67108863 & he) << 6 | ko >>> 26) + Gt | 0) >>> 0 < he >>> 0 ? b + 1 | 0 : b, ko = b = U + 16777216 | 0, he = g = b >>> 0 < 16777216 ? g + 1 | 0 : g, l[_ + 76 >> 2] = U - (-33554432 & b), g = De(ht, fn, Ct, $n), b = ve, Gt = De(je, en, Hn, an), U = ve + b | 0, U = (g = Gt + g | 0) >>> 0 < Gt >>> 0 ? U + 1 | 0 : U, Gt = De(St, er, Zn, Ar), b = ve + U | 0, b = (g = Gt + g | 0) >>> 0 < Gt >>> 0 ? b + 1 | 0 : b, U = (Gt = De(Le, _n, qn, or)) + g | 0, g = ve + b | 0, g = U >>> 0 < Gt >>> 0 ? g + 1 | 0 : g, b = U, U = De(Cr, co, Kn, Tr), g = ve + g | 0, g = (b = b + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(ct, wn, D, Gr), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, b = (ye = De(ye, Rr, Kt, zr)) + b | 0, U = ve + g | 0, g = (me = De(mt, it, me, ur)) + b | 0, b = ve + (b >>> 0 < ye >>> 0 ? U + 1 | 0 : U) | 0, U = (Ge = De(Ge, Sn, pn, jt)) + g | 0, g = ve + (g >>> 0 < me >>> 0 ? b + 1 | 0 : b) | 0, g = U >>> 0 < Ge >>> 0 ? g + 1 | 0 : g, b = U, U = De($e, Gn, bt, Ft), g = ve + g | 0, me = b = b + U | 0, g = (g = b >>> 0 < U >>> 0 ? g + 1 | 0 : g) + (b = ie >> 26) | 0, U = (b = ie = me + (U = (67108863 & ie) << 6 | Po >>> 26) | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, Ge = g = b + 16777216 | 0, ie = U = g >>> 0 < 16777216 ? U + 1 | 0 : U, l[_ + 60 >> 2] = b - (-33554432 & g), g = De(Ct, $n, cr, wt), U = ve, b = (me = De(je, en, ct, wn)) + g | 0, g = ve + U | 0, g = b >>> 0 < me >>> 0 ? g + 1 | 0 : g, U = De(mt, it, St, er), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, me = De(qn, or, Tt, Ir), U = ve + g | 0, U = (b = me + b | 0) >>> 0 < me >>> 0 ? U + 1 | 0 : U, g = (me = De(bt, Ft, Zt, Ve)) + b | 0, b = ve + U | 0, b = g >>> 0 < me >>> 0 ? b + 1 | 0 : b, U = (me = De(Je, Pr, yo, qr)) + g | 0, g = ve + b | 0, g = U >>> 0 < me >>> 0 ? g + 1 | 0 : g, b = U, U = De(ht, fn, Co, so), g = ve + g | 0, g = (b = b + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = b, b = De(Fn, we, ut, ao), g = ve + g | 0, g = b >>> 0 > (U = U + b | 0) >>> 0 ? g + 1 | 0 : g, me = b = Go, b = (Tt = De(b, ye = b >> 31, Le, _n)) + U | 0, U = ve + g | 0, g = ($e = De($e, Gn, Nn, Wn)) + b | 0, b = ve + (b >>> 0 < Tt >>> 0 ? U + 1 | 0 : U) | 0, U = g >>> 0 < $e >>> 0 ? b + 1 | 0 : b, b = g, g = (g = he >> 25) + U | 0, g = (b = b + (he = (33554431 & he) << 7 | ko >>> 25) | 0) >>> 0 < he >>> 0 ? g + 1 | 0 : g, U = b, $e = b = b + 33554432 | 0, he = g = b >>> 0 < 33554432 ? g + 1 | 0 : g, l[_ + 80 >> 2] = U - (-67108864 & b), b = ie >> 25, U = (ie = (33554431 & ie) << 7 | Ge >>> 25) + (ei - (g = -67108864 & oi) | 0) | 0, g = b + (ti - ((g >>> 0 > ei >>> 0) + vi | 0) | 0) | 0, g = U >>> 0 < ie >>> 0 ? g + 1 | 0 : g, ie = g = (67108863 & (g = (b = U + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g)) << 6 | b >>> 26, g = g + (Tt = Io - (-33554432 & Ti) | 0) | 0, l[_ + 68 >> 2] = g, l[_ + 64 >> 2] = U - (-67108864 & b), g = De(ct, wn, Ct, $n), U = ve, b = (ie = De(je, en, Kn, Tr)) + g | 0, g = ve + U | 0, g = b >>> 0 < ie >>> 0 ? g + 1 | 0 : g, U = (ie = De(St, er, Kt, zr)) + b | 0, b = ve + g | 0, b = U >>> 0 < ie >>> 0 ? b + 1 | 0 : b, g = (ie = De(mt, it, qn, or)) + U | 0, U = ve + b | 0, U = g >>> 0 < ie >>> 0 ? U + 1 | 0 : U, b = (ie = De(Zt, Ve, pn, jt)) + g | 0, g = ve + U | 0, g = b >>> 0 < ie >>> 0 ? g + 1 | 0 : g, U = De(bt, Ft, yo, qr), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = De(Hn, an, Co, so), g = ve + g | 0, g = (b = U + b | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, U = (ie = De(ht, fn, Fn, we)) + b | 0, b = ve + g | 0, b = U >>> 0 < ie >>> 0 ? b + 1 | 0 : b, ie = (g = De(me, ye, Zn, Ar)) + U | 0, U = ve + b | 0, U = g >>> 0 > ie >>> 0 ? U + 1 | 0 : U, b = ie, ie = De(g = Xo, g >> 31, Le, _n), g = ve + U | 0, U = b = b + ie | 0, g = (g = b >>> 0 < ie >>> 0 ? g + 1 | 0 : g) + (b = he >> 26) | 0, g = (U = U + (he = (67108863 & he) << 6 | $e >>> 26) | 0) >>> 0 < he >>> 0 ? g + 1 | 0 : g, g = (b = U + 16777216 | 0) >>> 0 < 16777216 ? g + 1 | 0 : g, l[_ + 84 >> 2] = U - (-33554432 & b), he = Be - (-33554432 & $o) | 0, ie = _e - (U = -67108864 & lo) | 0, je = no - ((U >>> 0 > _e >>> 0) + Oi | 0) | 0, g = De((33554431 & (U = g)) << 7 | b >>> 25, g >>= 25, 19, 0), b = ve + je | 0, g = g >>> 0 > (U = g + ie | 0) >>> 0 ? b + 1 | 0 : b, ie = g = (67108863 & (g = (b = U + 33554432 | 0) >>> 0 < 33554432 ? g + 1 | 0 : g)) << 6 | b >>> 26, g = g + he | 0, l[_ + 52 >> 2] = g, l[_ + 48 >> 2] = U - (-67108864 & b), Ei(A, _ + 48 | 0)), st = _ + 256 | 0, 0 | xo;
                    }, cg: function(A, g) {
                      A |= 0;
                      var _, b = 0;
                      return st = _ = st + -64 | 0, L(_, g |= 0, 32, 0), j[0 | _] = 248 & B[0 | _], j[_ + 31 | 0] = 63 & B[_ + 31 | 0] | 64, g = l[_ + 20 >> 2], b = l[_ + 16 >> 2], j[A + 16 | 0] = b, j[A + 17 | 0] = b >>> 8, j[A + 18 | 0] = b >>> 16, j[A + 19 | 0] = b >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[_ + 12 >> 2], b = l[_ + 8 >> 2], j[A + 8 | 0] = b, j[A + 9 | 0] = b >>> 8, j[A + 10 | 0] = b >>> 16, j[A + 11 | 0] = b >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[_ + 4 >> 2], b = l[_ >> 2], j[0 | A] = b, j[A + 1 | 0] = b >>> 8, j[A + 2 | 0] = b >>> 16, j[A + 3 | 0] = b >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, g = l[_ + 28 >> 2], b = l[_ + 24 >> 2], j[A + 24 | 0] = b, j[A + 25 | 0] = b >>> 8, j[A + 26 | 0] = b >>> 16, j[A + 27 | 0] = b >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, Wr(_, 64), st = _ - -64 | 0, 0;
                    }, dg: ci, eg: be, fg: ho, gg: tt, hg: wo, ig: ba, jg: ji, kg: wo, lg: Sc, mg: ji, ng: function(A, g, _, b, U) {
                      return 0 | Ho(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0);
                    }, og: function(A, g, _, b, U, ie, he, D) {
                      return 0 | ro(A |= 0, g |= 0, (A = 0) | (_ |= 0), b |= 0, U |= 0, A | (ie |= 0), he |= 0, D |= 0);
                    }, pg: function(A, g, _, b, U, ie) {
                      return 0 | po(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0);
                    }, qg: function(A, g, _, b, U) {
                      return 0 | Vo(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0);
                    }, rg: function(A, g, _, b, U, ie, he) {
                      return 0 | Vn(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }, sg: function(A, g, _, b, U, ie) {
                      return 0 | mo(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0);
                    }, tg: Li, ug: Li, vg: wo, wg: fa, xg: ji, yg: function() {
                      return 1540;
                    }, zg: yi, Ag: Lo, Bg: Li, Cg: wo, Dg: ba, Eg: ji, Fg: function(A, g, _, b, U) {
                      return 0 | Ua(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0);
                    }, Gg: function(A, g, _, b, U, ie, he, D) {
                      return 0 | As(A |= 0, g |= 0, (A = 0) | (_ |= 0), b |= 0, U |= 0, A | (ie |= 0), he |= 0, D |= 0);
                    }, Hg: function(A, g, _, b, U, ie) {
                      return 0 | Us(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0);
                    }, Ig: Li, Jg: yi, Kg: function(A, g, _, b, U, ie, he, D) {
                      var me;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, ie |= 0, he |= 0, st = me = st - 32 | 0, bs(me, U |= 0, D |= 0, 0), A = As(D = A, g, (A = 0) | _, b, U + 16 | 0, A | ie, he, me), Wr(me, 32), st = me + 32 | 0, 0 | A;
                    }, Lg: Lo, Mg: wo, Ng: fa, Og: ji, Pg: Li, Qg: si, Rg: wo, Sg: Zi, Tg: Es, Ug: fu, Vg: oc, Wg: function() {
                      return 1089;
                    }, Xg: function() {
                      var A, g;
                      return st = A = st - 16 | 0, j[A + 15 | 0] = 0, g = 0 | ks(35752, A + 15 | 0, 0), st = A + 16 | 0, 0 | g;
                    }, Yg: Mi, Zg: function(A) {
                      var g, _ = 0, b = 0;
                      if (st = g = st - 16 | 0, (A |= 0) >>> 0 >= 2) {
                        for (_ = (0 - A >>> 0) % (A >>> 0) | 0; j[g + 15 | 0] = 0, _ >>> 0 > (b = 0 | ks(35752, g + 15 | 0, 0)) >>> 0; )
                          ;
                        _ = (b >>> 0) % (A >>> 0) | 0;
                      }
                      return st = g + 16 | 0, 0 | _;
                    }, _g: jn, $g: function(A, g, _) {
                      Vo(A |= 0, g |= 0, 0, 1574, _ |= 0);
                    }, ah: wo, bh: function() {
                      var A = 0, g = 0;
                      return (A = l[9128]) && (A = l[A + 20 >> 2]) && (g = 0 | Xi[0 | A]()), 0 | g;
                    }, ch: function(A, g, _) {
                      A |= 0, g |= 0;
                      var b, U = 0, ie = 0, he = 0;
                      if (st = b = st - 16 | 0, _ |= 0)
                        Hs(1329, 1175, 197, 1092), Xr();
                      else {
                        if (g)
                          for (; j[b + 15 | 0] = 0, ie = A + U | 0, he = 0 | ks(35752, b + 15 | 0, 0), j[0 | ie] = he, (0 | g) != (0 | (U = U + 1 | 0)); )
                            ;
                        st = b + 16 | 0;
                      }
                    }, dh: function(A, g, _, b) {
                      A |= 0, _ |= 0;
                      var U = 0, ie = 0, he = 0;
                      if (!((b |= 0) >>> 0 > 2147483646 | b << 1 >>> 0 >= (g |= 0) >>> 0)) {
                        if (g = 0, b) {
                          for (; U = (g << 1) + A | 0, ie = 15 & (he = B[g + _ | 0]), j[U + 1 | 0] = 22272 + ((ie << 8) + (ie + 65526 & 55552) | 0) >>> 8, ie = U, U = he >>> 4 | 0, j[0 | ie] = 87 + ((U + 65526 >>> 8 & 217) + U | 0), (0 | b) != (0 | (g = g + 1 | 0)); )
                            ;
                          g = b << 1;
                        } else
                          g = 0;
                        return j[g + A | 0] = 0, 0 | A;
                      }
                      Ai(), Xr();
                    }, eh: function(A, g, _, b, U, ie, he) {
                      A |= 0, g |= 0, _ |= 0, U |= 0, ie |= 0, he |= 0;
                      var D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0;
                      e:
                        if (b |= 0) {
                          t: {
                            n: {
                              r: {
                                s: {
                                  if (!U) {
                                    for (me = 1, U = 0; ; ) {
                                      if (!(255 & (($e = (65526 + (_e = (223 & (ye = B[_ + D | 0])) - 55 & 255) ^ _e + 65520) >>> 8 | 0) | (Le = 65526 + (ye ^= 48) >>> 8 | 0))))
                                        break r;
                                      if (g >>> 0 <= we >>> 0)
                                        break s;
                                      if (_e = _e & $e | ye & Le, 255 & Be ? (j[A + we | 0] = U | _e, we = we + 1 | 0) : U = _e << 4, Be ^= -1, (0 | (D = D + 1 | 0)) == (0 | b))
                                        break;
                                    }
                                    D = b;
                                    break r;
                                  }
                                  for (; ; ) {
                                    u: {
                                      a: {
                                        d: {
                                          o: {
                                            i: {
                                              if (!(255 & ((ye = (65526 + (_e = (223 & (me = B[_ + D | 0])) - 55 & 255) ^ _e + 65520) >>> 8 | 0) | (Le = 65526 + ($e = 48 ^ me) >>> 8 | 0)))) {
                                                if (255 & Be)
                                                  break n;
                                                if (!Z(U, me))
                                                  break e;
                                                if ((D = Be = D + 1 | 0) >>> 0 < b >>> 0)
                                                  break i;
                                                break e;
                                              }
                                              if (g >>> 0 <= we >>> 0)
                                                break s;
                                              if (me = _e & ye | $e & Le, !(255 & Be))
                                                break o;
                                              j[A + we | 0] = me | je, we = we + 1 | 0;
                                              break u;
                                            }
                                            for (; ; ) {
                                              if (!(255 & ((ye = (65526 + (_e = (223 & (me = B[_ + D | 0])) - 55 & 255) ^ _e + 65520) >>> 8 | 0) | (Le = 65526 + ($e = 48 ^ me) >>> 8 | 0)))) {
                                                if (!Z(U, me))
                                                  break e;
                                                if ((D = D + 1 | 0) >>> 0 < b >>> 0)
                                                  continue;
                                                break d;
                                              }
                                              break;
                                            }
                                            if (g >>> 0 <= we >>> 0)
                                              break a;
                                            me = _e & ye | $e & Le;
                                          }
                                          je = me << 4, Be = 0;
                                          break u;
                                        }
                                        D = b >>> 0 > Be >>> 0 ? b : Be;
                                        break e;
                                      }
                                      Be = 0;
                                      break s;
                                    }
                                    if (Be ^= -1, me = 1, !((D = D + 1 | 0) >>> 0 < b >>> 0))
                                      break;
                                  }
                                  break r;
                                }
                                l[9129] = 68, me = 0;
                              }
                              if (!(255 & Be))
                                break t;
                            }
                            l[9129] = 28, Ge = -1, D = D - 1 | 0, we = 0;
                            break e;
                          }
                          me || (we = 0, Ge = -1);
                        }
                      return he ? l[he >> 2] = _ + D : (0 | b) != (0 | D) && (l[9129] = 28, Ge = -1), ie && (l[ie >> 2] = we), 0 | Ge;
                    }, fh: function(A, g) {
                      A |= 0;
                      var _ = 0;
                      return (-7 & (g |= 0)) != 1 && (Ai(), Xr()), 1 + ((3 & (_ = (_ = A) + wr(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & g ? _ + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                    }, gh: Un, hh: vt, ih: function() {
                      var A = 0;
                      return l[9260] ? A = 1 : (Mi(), jn(37024, 16), l[9260] = 1, A = 0), 0 | A;
                    }, jh: function(A, g, _, b, U) {
                      A |= 0, g |= 0, _ |= 0, U |= 0;
                      var ie, he = 0, D = 0, me = 0;
                      st = ie = st - 16 | 0;
                      e: {
                        if (b |= 0) {
                          if (me = -1, (he = (he = b - 1 | 0) - (D = he & b ? (_ >>> 0) % (b >>> 0) | 0 : _ & he) | 0) >>> 0 >= (-1 ^ _) >>> 0)
                            break e;
                          if (!((_ = _ + he | 0) >>> 0 >= U >>> 0))
                            for (A && (l[A >> 2] = _ + 1), A = g + _ | 0, me = 0, j[ie + 15 | 0] = 0, _ = 0; U = g = A - _ | 0, D = B[0 | g] & B[ie + 15 | 0], g = (_ ^ he) - 1 >>> 24 | 0, j[0 | U] = D | 128 & g, j[ie + 15 | 0] = g | B[ie + 15 | 0], (0 | b) != (0 | (_ = _ + 1 | 0)); )
                              ;
                        } else
                          me = -1;
                        return st = ie + 16 | 0, 0 | me;
                      }
                      Ai(), Xr();
                    }, kh: function(A, g, _, b) {
                      A |= 0, g |= 0, _ |= 0, b |= 0;
                      var U, ie = 0, he = 0, D = 0, me = 0, _e = 0;
                      if (l[12 + (U = st - 16 | 0) >> 2] = 0, b - 1 >>> 0 < _ >>> 0) {
                        for (_e = (he = _ - 1 | 0) + g | 0, _ = 0, g = 0; g &= 255, me = (128 ^ (D = B[_e - ie | 0])) - 1 & l[U + 12 >> 2] - 1 & g - 1, l[U + 12 >> 2] = l[U + 12 >> 2] | me << 23 >> 31 & ie, g |= D, _ |= me >>> 8 & 1, (0 | (ie = ie + 1 | 0)) != (0 | b); )
                          ;
                        l[A >> 2] = he - l[U + 12 >> 2], A = (255 & _) - 1 | 0;
                      } else
                        A = -1;
                      return 0 | A;
                    }, lh: function() {
                      return 1457;
                    }, mh: function() {
                      return 10;
                    }, nh: tu, oh: Da, ph: na, qh: $a, rh: function(A, g, _) {
                      A |= 0;
                      var b, U = 0;
                      return st = b = st - 32 | 0, U = -1, ls(b, _ |= 0, g |= 0) || (U = Ji(A, 35296, b, 0)), st = b + 32 | 0, 0 | U;
                    }, sh: io, th: function(A, g, _, b, U, ie, he, D) {
                      var me, _e;
                      return A |= 0, g |= 0, _ |= 0, ie |= 0, _e = b |= 0, b = U |= 0, st = me = st + -64 | 0, ls(me + 32 | 0, D |= 0, he |= 0) ? U = -1 : (U = -1, Ji(me, 35296, me + 32 | 0, 0) || (U = $i(A, g, _, _e, b, ie, me), Wr(me, 32))), st = me - -64 | 0, 0 | U;
                    }, uh: function(A, g, _, b, U, ie) {
                      return A |= 0, g |= 0, U |= 0, ie |= 0, !(b |= 0) & (_ |= 0) >>> 0 >= 4294967280 | b && (Ai(), Xr()), 0 | $i(A + 16 | 0, A, g, _, b, U, ie);
                    }, vh: function(A, g, _, b, U, ie, he) {
                      return 0 | vn(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }, wh: fo, xh: function(A, g, _, b, U, ie, he, D) {
                      var me, _e;
                      return A |= 0, g |= 0, _ |= 0, ie |= 0, _e = b |= 0, b = U |= 0, st = me = st + -64 | 0, ls(me + 32 | 0, D |= 0, he |= 0) ? U = -1 : (U = -1, Ji(me, 35296, me + 32 | 0, 0) || (U = Ha(A, g, _, _e, b, ie, me), Wr(me, 32))), st = me - -64 | 0, 0 | U;
                    }, yh: jr, zh: function(A, g, _, b, U, ie, he) {
                      return 0 | Dn(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0);
                    }, Ah: wo, Bh: wo, Ch: wo, Dh: wo, Eh: fa, Fh: si, Gh: Ta, Hh: function(A, g, _, b, U) {
                      A |= 0, g |= 0, U |= 0;
                      var ie, he, D, me = 0, _e = 0;
                      return he = _ |= 0, _ = b |= 0, D = b = st, st = ie = b - 512 & -64, b = -1, $a(ie - -64 | 0, ie + 32 | 0) || (fs(b = ie + 128 | 0, 0, 0, 24), Is(b, _e = ie - -64 | 0, 32, 0), Is(b, U, 32, 0), Ss(b, me = ie + 96 | 0, 24), b = vn(A + 32 | 0, g, he, _, me, b = U, U = ie + 32 | 0), g = l[ie + 92 >> 2], _ = l[ie + 88 >> 2], j[A + 24 | 0] = _, j[A + 25 | 0] = _ >>> 8, j[A + 26 | 0] = _ >>> 16, j[A + 27 | 0] = _ >>> 24, j[A + 28 | 0] = g, j[A + 29 | 0] = g >>> 8, j[A + 30 | 0] = g >>> 16, j[A + 31 | 0] = g >>> 24, g = l[ie + 84 >> 2], _ = l[ie + 80 >> 2], j[A + 16 | 0] = _, j[A + 17 | 0] = _ >>> 8, j[A + 18 | 0] = _ >>> 16, j[A + 19 | 0] = _ >>> 24, j[A + 20 | 0] = g, j[A + 21 | 0] = g >>> 8, j[A + 22 | 0] = g >>> 16, j[A + 23 | 0] = g >>> 24, g = l[ie + 76 >> 2], _ = l[ie + 72 >> 2], j[A + 8 | 0] = _, j[A + 9 | 0] = _ >>> 8, j[A + 10 | 0] = _ >>> 16, j[A + 11 | 0] = _ >>> 24, j[A + 12 | 0] = g, j[A + 13 | 0] = g >>> 8, j[A + 14 | 0] = g >>> 16, j[A + 15 | 0] = g >>> 24, g = l[ie + 68 >> 2], _ = l[ie + 64 >> 2], j[0 | A] = _, j[A + 1 | 0] = _ >>> 8, j[A + 2 | 0] = _ >>> 16, j[A + 3 | 0] = _ >>> 24, j[A + 4 | 0] = g, j[A + 5 | 0] = g >>> 8, j[A + 6 | 0] = g >>> 16, j[A + 7 | 0] = g >>> 24, Wr(U, 32), Wr(_e, 32), Wr(me, 24)), st = D, 0 | b;
                    }, Ih: function(A, g, _, b, U, ie) {
                      A |= 0, g |= 0, U |= 0, ie |= 0;
                      var he, D, me = 0, _e = 0;
                      return he = me = st, st = me = me - 448 & -64, _e = -1, D = b |= 0, !b & (_ |= 0) >>> 0 >= 48 | b && (fs(b = me - -64 | 0, 0, 0, 24), Is(b, g, 32, 0), Is(b, U, 32, 0), Ss(U = b, b = me + 32 | 0, 24), _e = Dn(A, g + 32 | 0, _ - 32 | 0, D - (_ >>> 0 < 32) | 0, b, g, ie)), st = he, 0 | _e;
                    }, Jh: Cc, Kh: function(A) {
                      var g, _ = 0;
                      return st = g = st - 160 | 0, de(A |= 0) && (Qe(A) || ds(g, A) || go(g) && (_ = (0 | ga(g)) != 0)), st = g + 160 | 0, 0 | _;
                    }, Lh: function(A, g, _) {
                      A |= 0, _ |= 0;
                      var b, U = 0;
                      return st = b = st - 800 | 0, U = -1, ds(b + 640 | 0, g |= 0) || go(b + 640 | 0) && (ds(b + 480 | 0, _) || go(b + 480 | 0) && (Bi(b, b + 480 | 0), Si(g = b + 160 | 0, b + 640 | 0, b), So(_ = b + 320 | 0, g), kr(A, _), U = 0)), st = b + 800 | 0, 0 | U;
                    }, Mh: function(A, g, _) {
                      A |= 0, _ |= 0;
                      var b, U = 0;
                      return st = b = st - 800 | 0, U = -1, ds(b + 640 | 0, g |= 0) || go(b + 640 | 0) && (ds(b + 480 | 0, _) || go(b + 480 | 0) && (Bi(b, b + 480 | 0), Ts(g = b + 160 | 0, b + 640 | 0, b), So(_ = b + 320 | 0, g), kr(A, _), U = 0)), st = b + 800 | 0, 0 | U;
                    }, Nh: function(A, g) {
                      return Wa(A |= 0, g |= 0), 0;
                    }, Oh: function(A, g) {
                      A |= 0;
                      var _, b, U, ie, he, D, me, _e = 0, Be = 0, ye = 0, we = 0, $e = 0;
                      for (st = _ = st - 160 | 0, me = B[0 | (g |= 0)]; ye = g - _e | 0, j[(Be = _ + 128 | 0) + _e | 0] = B[ye + 63 | 0], j[(we = _ + 96 | 0) + _e | 0] = B[ye + 31 | 0], j[($e = Be) + (Be = 1 | _e) | 0] = B[ye + 62 | 0], j[Be + we | 0] = B[ye + 30 | 0], (0 | (_e = _e + 2 | 0)) != 32; )
                        ;
                      return j[_ + 159 | 0] = 127 & B[_ + 159 | 0], j[_ + 127 | 0] = 127 & B[_ + 127 | 0], gs(ye = _ + 48 | 0, _ + 128 | 0), gs(_, _ + 96 | 0), $e = l[_ + 80 >> 2] + wr(l[_ + 32 >> 2], 38) | 0, b = l[_ + 76 >> 2] + wr(l[_ + 28 >> 2], 38) | 0, U = l[_ + 72 >> 2] + wr(l[_ + 24 >> 2], 38) | 0, ie = l[_ + 68 >> 2] + wr(l[_ + 20 >> 2], 38) | 0, he = l[_ + 64 >> 2] + wr(l[_ + 16 >> 2], 38) | 0, D = l[_ + 60 >> 2] + wr(l[_ + 12 >> 2], 38) | 0, we = l[_ + 56 >> 2] + wr(l[_ + 8 >> 2], 38) | 0, Be = l[_ + 52 >> 2] + wr(l[_ + 4 >> 2], 38) | 0, g = (l[_ + 48 >> 2] + (j[g + 32 | 0] >> 31 & 19) | 0) + wr(l[_ >> 2], 38) | 0, _e = l[_ + 84 >> 2] + wr(l[_ + 36 >> 2], 38) | 0, g = wr(($e + (b + (U + (ie + (he + (D + (we + (Be + (g + (wr(_e, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + _e >> 25, 19) + g | 0, l[_ + 48 >> 2] = 67108863 & g, g = Be + (g >> 26) | 0, l[_ + 52 >> 2] = 33554431 & g, g = we + (g >> 25) | 0, l[_ + 56 >> 2] = 67108863 & g, g = D + (g >> 26) | 0, l[_ + 60 >> 2] = 33554431 & g, g = he + (g >> 25) | 0, l[_ + 64 >> 2] = 67108863 & g, g = ie + (g >> 26) | 0, l[_ + 68 >> 2] = 33554431 & g, g = U + (g >> 25) | 0, l[_ + 72 >> 2] = 67108863 & g, g = b + (g >> 26) | 0, l[_ + 76 >> 2] = 33554431 & g, g = $e + (g >> 25) | 0, l[_ + 80 >> 2] = 67108863 & g, l[_ + 84 >> 2] = _e + (g >> 26) & 33554431, wa(A, ye, 128 & me), st = _ + 160 | 0, 0;
                    }, Ph: function(A) {
                      var g;
                      A |= 0, st = g = st - 32 | 0, jn(g, 32), Wa(A, g), st = g + 32 | 0;
                    }, Qh: Yn, Rh: Pa, Sh: Rt, Th: Xe, Uh: Ba, Vh: Re, Wh: _s, Xh: ic, Yh: wo, Zh: Zi, _h: wo, $h: Zi, ai: wo, bi: function(A) {
                      var g;
                      return st = g = st - 160 | 0, A = Ps(g, A |= 0), st = g + 160 | 0, 0 | !A;
                    }, ci: function(A, g, _) {
                      A |= 0, _ |= 0;
                      var b, U = 0;
                      return st = b = st - 800 | 0, U = -1, Ps(b + 640 | 0, g |= 0) || Ps(b + 480 | 0, _) || (Bi(b, b + 480 | 0), Si(g = b + 160 | 0, b + 640 | 0, b), So(_ = b + 320 | 0, g), Ni(A, _), U = 0), st = b + 800 | 0, 0 | U;
                    }, di: function(A, g, _) {
                      A |= 0, _ |= 0;
                      var b, U = 0;
                      return st = b = st - 800 | 0, U = -1, Ps(b + 640 | 0, g |= 0) || Ps(b + 480 | 0, _) || (Bi(b, b + 480 | 0), Ts(g = b + 160 | 0, b + 640 | 0, b), So(_ = b + 320 | 0, g), Ni(A, _), U = 0), st = b + 800 | 0, 0 | U;
                    }, ei: function(A, g) {
                      return Vt(A |= 0, g |= 0), 0;
                    }, fi: function(A) {
                      var g;
                      A |= 0, st = g = st + -64 | 0, jn(g, 64), Vt(A, g), st = g - -64 | 0;
                    }, gi: function(A) {
                      Yn(A |= 0);
                    }, hi: function(A, g) {
                      return 0 | Pa(A |= 0, g |= 0);
                    }, ii: function(A, g) {
                      Rt(A |= 0, g |= 0);
                    }, ji: function(A, g) {
                      Xe(A |= 0, g |= 0);
                    }, ki: function(A, g, _) {
                      Ba(A |= 0, g |= 0, _ |= 0);
                    }, li: function(A, g, _) {
                      _s(A |= 0, g |= 0, _ |= 0);
                    }, mi: ic, ni: function(A, g) {
                      Re(A |= 0, g |= 0);
                    }, oi: wo, pi: Zi, qi: Zi, ri: wo, si: function(A, g, _, b, U, ie, he, D, me, _e) {
                      return 0 | Lr(A |= 0, g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0, D |= 0, me |= 0, _e |= 0);
                    }, ti: si, ui: ji, vi: Da, wi: ji, xi: wo, yi: function() {
                      return 102;
                    }, zi: function() {
                      return 1570;
                    }, Ai: function() {
                      return 32768;
                    }, Bi: ji, Ci: hc, Di: ji, Ei: function() {
                      return 524288;
                    }, Fi: hc, Gi: mc, Hi: $u, Ii: function(A, g, _, b, U, ie, he, D, me, _e) {
                      var Be, ye, we;
                      g |= 0, _ |= 0, b |= 0, U |= 0, ie |= 0, he |= 0, me |= 0, _e |= 0, ye = 0 | (D |= 0), st = D = st - 16 | 0, we = g |= 0, Be = Jt(A |= 0, 0, g), A = 0 | U;
                      e:
                        if ((0 | (U = _ | ie)) == 1 | U >>> 0 > 1)
                          l[9129] = 22, A = -1;
                        else if (!_ & g >>> 0 >= 16 | _) {
                          if (as(ye, me, _e, D + 12 | 0, D + 8 | 0, D + 4 | 0), (0 | b) == (0 | Be)) {
                            l[9129] = 28, A = -1;
                            break e;
                          }
                          U = A, A = 31 & (g = l[D + 12 >> 2]), (63 & g) >>> 0 >= 32 ? (g = 1 << A, _ = 0) : g = (_ = 1 << A) - 1 & 1 >>> 32 - A, A = Lr(b, U, he, 32, _, g, l[D + 4 >> 2], l[D + 8 >> 2], Be, we);
                        } else
                          l[9129] = 28, A = -1;
                      return st = D + 16 | 0, 0 | A;
                    }, Ji: function(A, g, _, b, U, ie, he) {
                      g |= 0, _ |= 0, b |= 0, ie |= 0, he |= 0;
                      var D, me, _e, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0;
                      Be = U |= 0, Be |= U = 0, st = D = st - 128 | 0, me = Jt(A |= 0, 0, 102), Le = 22, _e = _ | U;
                      e: {
                        if (!b) {
                          as(Be, ie, he, D + 12 | 0, D + 8 | 0, D + 4 | 0), jn(we = D + 96 | 0, 32), Le = 28, _ = D + 32 | 0, ie = l[D + 12 >> 2], he = De(A = l[D + 8 >> 2], 0, b = l[D + 4 >> 2], 0);
                          t:
                            if (!(!(Be = ve) & he >>> 0 > 1073741823 | Be | ie >>> 0 > 63) && (j[0 | _] = 36, j[_ + 1 | 0] = 55, j[_ + 2 | 0] = 36, j[_ + 3 | 0] = B[ie + 1024 | 0], j[_ + 4 | 0] = B[1024 + (63 & b) | 0], j[_ + 5 | 0] = B[1024 + (b >>> 6 & 63) | 0], j[_ + 6 | 0] = B[1024 + (b >>> 12 & 63) | 0], j[_ + 7 | 0] = B[1024 + (b >>> 18 & 63) | 0], j[_ + 8 | 0] = B[1024 + (b >>> 24 & 63) | 0], (b = _ + 9 | 0) && (0 | b) != (0 | ($e = _ + 58 | 0)) && (j[0 | b] = B[1024 + (63 & A) | 0], (b = (-1 ^ b) + $e | 0) && (j[_ + 10 | 0] = B[1024 + (A >>> 6 & 63) | 0], (0 | b) != 1 && (j[_ + 11 | 0] = B[1024 + (A >>> 12 & 63) | 0], (0 | b) != 2 && (j[_ + 12 | 0] = B[1024 + (A >>> 18 & 63) | 0], (0 | b) != 3 && (j[_ + 13 | 0] = B[1024 + (A >>> 24 & 63) | 0], ie = _ + 14 | 0))))))) {
                              for (ye = $e - ie | 0, A = 0; ; ) {
                                if (b = ie, !(A >>> 0 >= 32)) {
                                  if (ie = B[A + we | 0], (Ge = (he = A + 1 | 0) >>> 0 >= 32) ? (A = he, he = 0) : (ie = B[he + we | 0] << 8 | ie, (he = A + 2 | 0) >>> 0 >= 32 ? (A = he, he = 0) : (A = A + 3 | 0, ie = B[he + we | 0] << 16 | ie, he = 1)), !ye || (j[0 | b] = B[1024 + (63 & ie) | 0], (0 | ye) == 1))
                                    break t;
                                  if (Be = he, j[b + 1 | 0] = B[1024 + (ie >>> 6 & 63) | 0], je = b + ye | 0, he = b + 2 | 0, !Ge) {
                                    if ((0 | ye) == 2)
                                      break t;
                                    if (j[b + 2 | 0] = B[1024 + (ie >>> 12 & 63) | 0], he = b + 3 | 0, Be) {
                                      if ((0 | ye) == 3)
                                        break t;
                                      j[b + 3 | 0] = B[1024 + (ie >>> 18 | 0) | 0], he = b + 4 | 0;
                                    }
                                  }
                                  if (ye = je - (ie = he) | 0, ie)
                                    continue;
                                  break t;
                                }
                                break;
                              }
                              b >>> 0 >= $e >>> 0 || (j[0 | b] = 0, U = _);
                            }
                          if (U && (A = -1, Js(D + 16 | 0), g = Ko(A = D + 16 | 0, g, _e, D + 32 | 0, me), Eo(A), A = 0, g))
                            break e;
                        }
                        l[9129] = Le, A = -1;
                      }
                      return st = D + 128 | 0, 0 | A;
                    }, Ki: function(A, g, _, b) {
                      var U, ie;
                      g |= 0, b |= 0, U = A |= 0, ie = _ |= 0, _ = 0, st = b = st - 128 | 0;
                      e: {
                        t: {
                          for (; ; ) {
                            if (!B[_ + U | 0]) {
                              A = _;
                              break t;
                            }
                            if (!B[U + (A = _ + 1 | 0) | 0] || !B[U + (A = _ + 2 | 0) | 0])
                              break t;
                            if ((0 | (_ = _ + 3 | 0)) == 102)
                              break;
                          }
                          _ = -1;
                          break e;
                        }
                        _ = -1, (0 | A) == 101 && (Js(b) || (Jt(A = b + 16 | 0, 0, 102), A = Ko(b, g, ie, U, A), Eo(b), A && (_ = Ie(A = b + 16 | 0, U, 102), Wr(A, 102))));
                      }
                      return st = b + 128 | 0, 0 | _;
                    }, Li: function(A, g, _, b) {
                      var U, ie;
                      ie = A |= 0, st = U = st - 32 | 0, as(g |= 0, _ |= 0, b |= 0, U + 28 | 0, U + 20 | 0, U + 12 | 0), A = 0;
                      e: {
                        t: {
                          n: {
                            for (; ; ) {
                              if (B[A + ie | 0]) {
                                if (B[ie + (g = A + 1 | 0) | 0] && B[ie + (g = A + 2 | 0) | 0]) {
                                  if ((0 | (A = A + 3 | 0)) != 102)
                                    continue;
                                  break n;
                                }
                              } else
                                g = A;
                              break;
                            }
                            if ((0 | g) == 101) {
                              if (_ = U + 8 | 0, b = U + 16 | 0, A = 0, B[0 | ie] != 36 | B[ie + 1 | 0] != 55 | B[ie + 2 | 0] != 36 || (g = ot(B[ie + 3 | 0]), l[U + 24 >> 2] = g ? g - 1024 | 0 : 0, g && (g = xt(_, ie + 4 | 0)) && (A = xt(b, g))), A)
                                break t;
                              l[9129] = 28, A = -1;
                              break e;
                            }
                          }
                          l[9129] = 28, A = -1;
                          break e;
                        }
                        A = 1, l[U + 28 >> 2] != l[U + 24 >> 2] | l[U + 12 >> 2] != l[U + 8 >> 2] || (A = l[U + 20 >> 2] != l[U + 16 >> 2]);
                      }
                      return st = U + 32 | 0, 0 | A;
                    }, Mi: function(A, g, _) {
                      return 0 | zo(A |= 0, g |= 0, _ |= 0, 1);
                    }, Ni: function(A, g, _) {
                      return 0 | zo(A |= 0, g |= 0, _ |= 0, 0);
                    }, Oi: function(A, g) {
                      return 0 | Va(A |= 0, g |= 0, 1);
                    }, Pi: function(A, g) {
                      return 0 | Va(A |= 0, g |= 0, 0);
                    }, Qi: wo, Ri: wo, Si: function(A, g, _) {
                      A |= 0, g |= 0;
                      var b, U = 0;
                      return st = b = st - 320 | 0, U = -1, Ps(b, _ |= 0) || (j[0 | A] = B[0 | g], j[A + 1 | 0] = B[g + 1 | 0], j[A + 2 | 0] = B[g + 2 | 0], j[A + 3 | 0] = B[g + 3 | 0], j[A + 4 | 0] = B[g + 4 | 0], j[A + 5 | 0] = B[g + 5 | 0], j[A + 6 | 0] = B[g + 6 | 0], j[A + 7 | 0] = B[g + 7 | 0], j[A + 8 | 0] = B[g + 8 | 0], j[A + 9 | 0] = B[g + 9 | 0], j[A + 10 | 0] = B[g + 10 | 0], j[A + 11 | 0] = B[g + 11 | 0], j[A + 12 | 0] = B[g + 12 | 0], j[A + 13 | 0] = B[g + 13 | 0], j[A + 14 | 0] = B[g + 14 | 0], j[A + 15 | 0] = B[g + 15 | 0], j[A + 16 | 0] = B[g + 16 | 0], j[A + 17 | 0] = B[g + 17 | 0], j[A + 18 | 0] = B[g + 18 | 0], j[A + 19 | 0] = B[g + 19 | 0], j[A + 20 | 0] = B[g + 20 | 0], j[A + 21 | 0] = B[g + 21 | 0], j[A + 22 | 0] = B[g + 22 | 0], j[A + 23 | 0] = B[g + 23 | 0], j[A + 24 | 0] = B[g + 24 | 0], j[A + 25 | 0] = B[g + 25 | 0], j[A + 26 | 0] = B[g + 26 | 0], j[A + 27 | 0] = B[g + 27 | 0], j[A + 28 | 0] = B[g + 28 | 0], j[A + 29 | 0] = B[g + 29 | 0], j[A + 30 | 0] = B[g + 30 | 0], j[A + 31 | 0] = 127 & B[g + 31 | 0], Zs(g = b + 160 | 0, A, b), Ni(A, g), U = le(A, 32) ? -1 : 0), st = b + 320 | 0, 0 | U;
                    }, Ti: function(A, g) {
                      var _;
                      return g |= 0, st = _ = st - 160 | 0, j[0 | (A |= 0)] = B[0 | g], j[A + 1 | 0] = B[g + 1 | 0], j[A + 2 | 0] = B[g + 2 | 0], j[A + 3 | 0] = B[g + 3 | 0], j[A + 4 | 0] = B[g + 4 | 0], j[A + 5 | 0] = B[g + 5 | 0], j[A + 6 | 0] = B[g + 6 | 0], j[A + 7 | 0] = B[g + 7 | 0], j[A + 8 | 0] = B[g + 8 | 0], j[A + 9 | 0] = B[g + 9 | 0], j[A + 10 | 0] = B[g + 10 | 0], j[A + 11 | 0] = B[g + 11 | 0], j[A + 12 | 0] = B[g + 12 | 0], j[A + 13 | 0] = B[g + 13 | 0], j[A + 14 | 0] = B[g + 14 | 0], j[A + 15 | 0] = B[g + 15 | 0], j[A + 16 | 0] = B[g + 16 | 0], j[A + 17 | 0] = B[g + 17 | 0], j[A + 18 | 0] = B[g + 18 | 0], j[A + 19 | 0] = B[g + 19 | 0], j[A + 20 | 0] = B[g + 20 | 0], j[A + 21 | 0] = B[g + 21 | 0], j[A + 22 | 0] = B[g + 22 | 0], j[A + 23 | 0] = B[g + 23 | 0], j[A + 24 | 0] = B[g + 24 | 0], j[A + 25 | 0] = B[g + 25 | 0], j[A + 26 | 0] = B[g + 26 | 0], j[A + 27 | 0] = B[g + 27 | 0], j[A + 28 | 0] = B[g + 28 | 0], j[A + 29 | 0] = B[g + 29 | 0], j[A + 30 | 0] = B[g + 30 | 0], j[A + 31 | 0] = 127 & B[g + 31 | 0], Os(_, A), Ni(A, _), A = le(A, 32), st = _ + 160 | 0, 0 | (A ? -1 : 0);
                    }, Ui: wo, Vi: wo, Wi: io, Xi: function(A, g, _, b, U, ie) {
                      return A |= 0, g |= 0, U |= 0, ie |= 0, !(b |= 0) & (_ |= 0) >>> 0 >= 4294967280 | b && (Ai(), Xr()), $i(A + 16 | 0, A, g, _, b, U, ie), 0;
                    }, Yi: fo, Zi: jr, _i: wo, $i: fa, aj: si, bj: Ta, cj: si, dj: si, ej: function(A, g, _, b, U) {
                      A |= 0, g |= 0, _ |= 0, b |= 0;
                      var ie, he = 0, D = 0, me = 0, _e = 0, Be = 0, ye = 0, we = 0, $e = 0, Le = 0, Ge = 0, je = 0, ct = 0, mt = 0, bt = 0, ht = 0, Ct = 0;
                      if (bt = 1886610805 ^ (he = B[0 | (U |= 0)] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24), ct = 1936682341 ^ (D = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24), he ^= 1852142177, me = 1819895653 ^ D, ht = 1852075907 ^ (D = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24), mt = 1685025377 ^ (U = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24), _e = 2037671283 ^ D, D = 1952801890 ^ U, Ge = _, (0 | (ye = (g + _ | 0) - (ie = 7 & _) | 0)) != (0 | g)) {
                        for (; _ = (je = D ^ (Ct = B[g + 4 | 0] | B[g + 5 | 0] << 8 | B[g + 6 | 0] << 16 | B[g + 7 | 0] << 24)) + me | 0, _e = U = (U = he) + (he = b = _e ^ (Le = B[0 | g] | B[g + 1 | 0] << 8 | B[g + 2 | 0] << 16 | B[g + 3 | 0] << 24)) | 0, Be = _ = U >>> 0 < he >>> 0 ? _ + 1 | 0 : _, _ = mt + ct | 0, _ = (me = bt + ht | 0) >>> 0 < bt >>> 0 ? _ + 1 | 0 : _, he = q(ht, mt, 13) ^ me, D = _, _ = Be + (U = _ ^ ve) | 0, _ = he >>> 0 > (we = _e + he | 0) >>> 0 ? _ + 1 | 0 : _, he = q(he, U, 17) ^ we, $e = _, mt = q(he, U = _ ^ ve, 13), ct = ve, _ = q(b, je, 16), b = Be ^ ve, je = _ ^ _e, D = q(me, D, 32), _ = ve + b | 0, _ = (D = (me = je + D | 0) >>> 0 < D >>> 0 ? _ + 1 | 0 : _) + U | 0, Be = _ = (_e = he + me | 0) >>> 0 < me >>> 0 ? _ + 1 | 0 : _, mt = q(he = _e ^ mt, U = _ ^ ct, 17), ct = ve, _ = q(je, b, 21), b = D ^ ve, je = _ ^ me, D = q(we, $e, 32), _ = ve + b | 0, _ = (D = (me = je + D | 0) >>> 0 < D >>> 0 ? _ + 1 | 0 : _) + U | 0, ht = (he = he + me | 0) ^ mt, U = _ = he >>> 0 < me >>> 0 ? _ + 1 | 0 : _, mt = _ ^ ct, _ = q(je, b, 16), we = D ^= ve, $e = q(_ ^= me, D, 21), me = ve, Be = (D = q(_e, Be, 32)) + _ | 0, _ = ve + we | 0, _e = Be ^ $e, D = (_ = D >>> 0 > Be >>> 0 ? _ + 1 | 0 : _) ^ me, he = q(he, U, 32), me = ve, bt = Be ^ Le, ct = _ ^ Ct, (0 | ye) != (0 | (g = g + 8 | 0)); )
                          ;
                        g = ye;
                      }
                      switch (we = 0, b = Ge << 24, ie - 1 | 0) {
                        case 6:
                          b |= B[g + 6 | 0] << 16;
                        case 5:
                          b |= B[g + 5 | 0] << 8;
                        case 4:
                          b |= B[g + 4 | 0];
                        case 3:
                          we |= (U = B[g + 3 | 0]) << 24, b |= _ = U >>> 8 | 0;
                        case 2:
                          we |= (U = B[g + 2 | 0]) << 16, b |= _ = U >>> 16 | 0;
                        case 1:
                          we |= (U = B[g + 1 | 0]) << 8, b |= _ = U >>> 24 | 0;
                        case 0:
                          we = B[0 | g] | we;
                      }
                      return $e = b, b = q(U = we ^ _e, g = b ^ D, 16), g = g + me | 0, Be = g = (_e = U + he | 0) >>> 0 < he >>> 0 ? g + 1 | 0 : g, Le = q(U = b ^ _e, g ^= _ = ve, 21), D = ve, _ = mt + ct | 0, b = _ = (he = bt + ht | 0) >>> 0 < bt >>> 0 ? _ + 1 | 0 : _, me = U, U = q(he, _, 32), _ = ve + g | 0, g = D, D = _ = U >>> 0 > (me = me + U | 0) >>> 0 ? _ + 1 | 0 : _, je = q(U = me ^ Le, g ^= _, 16), Ge = ve, he = (ye = q(ht, mt, 13) ^ he) + _e | 0, _ = (_e = ve ^ b) + Be | 0, b = he, Be = U, U = q(he, _ = he >>> 0 < ye >>> 0 ? _ + 1 | 0 : _, 32), g = ve + g | 0, ct = U = (he = U >>> 0 > (Le = Be + U | 0) >>> 0 ? g + 1 | 0 : g) ^ Ge, Be = je ^= Le, Ge = q(ye, _e, 17) ^ b, _ = (ye = ve ^ _) + D | 0, g = _ = (g = Ge) >>> 0 > (b = g + me | 0) >>> 0 ? _ + 1 | 0 : _, D = q(b, _, 32), _ = ve + U | 0, me = we ^ (_e = D + Be | 0), $e ^= Be = D >>> 0 > _e >>> 0 ? _ + 1 | 0 : _, U = q(Ge, ye, 13) ^ b, b = q(U, g ^= ve, 17), g = g + he | 0, _ = (g = (U = g = (D = U + Le | 0) >>> 0 < Le >>> 0 ? g + 1 | 0 : g) ^ (_ = ve)) + $e | 0, _ = (b ^= D) >>> 0 > (me = b + me | 0) >>> 0 ? _ + 1 | 0 : _, b = q(b, g, 13) ^ me, he = _, Le = q(b, g = _ ^ ve, 17), we = ve, $e = q(je, ct, 21), ye = Be ^ ve, Be = _e ^ $e, D = 238 ^ q(D, U, 32), _ = ve + ye | 0, _ = (ct = g) + (g = (U = Be + D | 0) >>> 0 < D >>> 0 ? _ + 1 | 0 : _) | 0, D = _ = (_e = b + U | 0) >>> 0 < U >>> 0 ? _ + 1 | 0 : _, Le = q(b = _e ^ Le, _ ^= we, 13), we = ve, Be = q(Be, ye, 16), ye = g ^ ve, $e = U ^ Be, U = q(me, he, 32), g = ve + ye | 0, _ = (U = U >>> 0 > (he = $e + U | 0) >>> 0 ? g + 1 | 0 : g) + _ | 0, me = _ = (Be = b + he | 0) >>> 0 < he >>> 0 ? _ + 1 | 0 : _, Le = q(b = Be ^ Le, g = _ ^ we, 17), we = ve, _ = q($e, ye, 21), ye = U ^ ve, $e = _ ^ he, U = q(_e, D, 32), _ = ve + ye | 0, _ = (U = U >>> 0 > (he = $e + U | 0) >>> 0 ? _ + 1 | 0 : _) + g | 0, D = _ = (_e = b + he | 0) >>> 0 < he >>> 0 ? _ + 1 | 0 : _, Le = q(b = _e ^ Le, g = _ ^ we, 13), we = ve, _ = q($e, ye, 16), ye = U ^ ve, $e = _ ^ he, U = q(Be, me, 32), _ = ve + ye | 0, _ = (U = U >>> 0 > (he = $e + U | 0) >>> 0 ? _ + 1 | 0 : _) + g | 0, me = _ = (Be = b + he | 0) >>> 0 < he >>> 0 ? _ + 1 | 0 : _, Le = q(b = Be ^ Le, g = _ ^ we, 17), we = ve, _ = q($e, ye, 21), ye = U ^ ve, $e = _ ^ he, he = q(_e, D, 32), _ = ve + ye | 0, g = (_ = (U = $e + he | 0) >>> 0 < he >>> 0 ? _ + 1 | 0 : _) + g | 0, he = g = (D = b + U | 0) >>> 0 < U >>> 0 ? g + 1 | 0 : g, Le = q(b = D ^ Le, g ^= we, 13), we = ve, _e = q($e, ye, 16), ye = _ ^ ve, $e = U ^ _e, me = q(Be, me, 32), _ = ve + ye | 0, _ = (Be = g) + (g = (U = $e + me | 0) >>> 0 < me >>> 0 ? _ + 1 | 0 : _) | 0, Be = _ = (_e = b + U | 0) >>> 0 < U >>> 0 ? _ + 1 | 0 : _, Le = q(b = _e ^ Le, _ ^= we, 17), we = ve, me = q($e, ye, 21), Ge = g ^ ve, $e = U ^ me, U = q(D, he, 32), g = ve + Ge | 0, _ = (D = U >>> 0 > (me = $e + U | 0) >>> 0 ? g + 1 | 0 : g) + _ | 0, U = b = (g = (he = b + me | 0) >>> 0 < me >>> 0 ? _ + 1 | 0 : _) ^ we, ye = he ^ Le, _ = q($e, Ge, 16), Ge = D ^ ve, me = ($e = _ ^ me) + (D = q(_e, Be, 32)) | 0, _ = ve + Ge | 0, g = q(he, g, 32), Le = ve, D = _ = me >>> 0 < D >>> 0 ? _ + 1 | 0 : _, he = A, _e = (Be = q($e, Ge, 21) ^ me) ^ g ^ me ^ ye, j[0 | he] = _e, j[he + 1 | 0] = _e >>> 8, j[he + 2 | 0] = _e >>> 16, j[he + 3 | 0] = _e >>> 24, _ = (_e = _ ^ ve) ^ Le ^ _ ^ U, j[he + 4 | 0] = _, j[he + 5 | 0] = _ >>> 8, j[he + 6 | 0] = _ >>> 16, j[he + 7 | 0] = _ >>> 24, b = he, _ = _e + Le | 0, _ = (A = g + Be | 0) >>> 0 < g >>> 0 ? _ + 1 | 0 : _, we = A, he = q(Be, _e, 16) ^ A, _e = _, Le = g = _ ^ ve, _ = U + D | 0, D = _ = (me = (Be = 221 ^ ye) + me | 0) >>> 0 < Be >>> 0 ? _ + 1 | 0 : _, $e = (_ = q(me, _, 32)) + he | 0, g = ve + g | 0, mt = q(he, Le, 21) ^ $e, ct = g = (he = _ >>> 0 > $e >>> 0 ? g + 1 | 0 : g) ^ ve, je = q(mt, g, 16), Ge = ve, _ = _e + (Le = (_ = U << 13 | Be >>> 19) ^ D) | 0, g = _ = (U = we + (ye = me ^ (Be << 13 | U >>> 19)) | 0) >>> 0 < we >>> 0 ? _ + 1 | 0 : _, A = q(U, _, 32), _ = ct + ve | 0, _ = (D = (A = A + mt | 0) >>> 0 < mt >>> 0 ? _ + 1 | 0 : _) ^ Ge, Be = A, _e = q(Ge = je ^ A, _, 21), me = ve, A = q(ye, Le, 17), g = he + (ye = g ^ ve) | 0, A = q(U = $e + (we = A ^ U) | 0, g = U >>> 0 < $e >>> 0 ? g + 1 | 0 : g, 32), _ = _ + ve | 0, Le = _ = (he = (A = A + Ge | 0) >>> 0 < Ge >>> 0 ? _ + 1 | 0 : _) ^ me, $e = q(Ge = _e ^ (me = A), _, 16), _e = ve, A = q(we, ye, 13), _ = D + (ye = g ^ ve) | 0, g = _ = (U = Be + (we = A ^ U) | 0) >>> 0 < Be >>> 0 ? _ + 1 | 0 : _, A = q(U, _, 32), _ = Le + ve | 0, Le = _ = (D = (A = A + Ge | 0) >>> 0 < Ge >>> 0 ? _ + 1 | 0 : _) ^ _e, Be = A, $e = q(Ge = $e ^ A, _, 21), _e = ve, A = q(we, ye, 17), _ = he + (ye = g ^ ve) | 0, g = _ = (U = me + (we = A ^ U) | 0) >>> 0 < me >>> 0 ? _ + 1 | 0 : _, A = q(U, _, 32), _ = Le + ve | 0, Le = _ = (he = (A = A + Ge | 0) >>> 0 < Ge >>> 0 ? _ + 1 | 0 : _) ^ _e, $e = q(Ge = $e ^ (me = A), _, 16), _e = ve, A = q(we, ye, 13), _ = D + (we = g ^ ve) | 0, A = q(U = Be + (D = A ^ U) | 0, _ = U >>> 0 < Be >>> 0 ? _ + 1 | 0 : _, 32), g = Le + ve | 0, $e = q((A = A + Ge | 0) ^ $e, (g = A >>> 0 < Ge >>> 0 ? g + 1 | 0 : g) ^ _e, 21), _e = ve, U = q(D, we, 17) ^ U, Be = q(U, _ ^= ve, 13), _ = _ + he | 0, he = q(D = (U = U + me | 0) ^ Be, _ = ve ^ (U >>> 0 < me >>> 0 ? _ + 1 | 0 : _), 17) ^ $e, U = ve ^ _e, _ = g + _ | 0, g = A, A = q(A = A + D | 0, _ = g >>> 0 > A >>> 0 ? _ + 1 | 0 : _, 32) ^ he ^ A, j[b + 8 | 0] = A, j[b + 9 | 0] = A >>> 8, j[b + 10 | 0] = A >>> 16, j[b + 11 | 0] = A >>> 24, A = _ ^ ve ^ U, j[b + 12 | 0] = A, j[b + 13 | 0] = A >>> 8, j[b + 14 | 0] = A >>> 16, j[b + 15 | 0] = A >>> 24, 0;
                    }, fj: function(A, g, _, b, U) {
                      A |= 0, b |= 0, U |= 0;
                      var ie, he = 0, D = 0, me = 0, _e = 0;
                      if (st = ie = st - 112 | 0, he = g |= 0, g = _ |= 0, he | _) {
                        _ = B[U + 28 | 0] | B[U + 29 | 0] << 8 | B[U + 30 | 0] << 16 | B[U + 31 | 0] << 24, l[ie + 24 >> 2] = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, l[ie + 28 >> 2] = _, _ = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, l[ie + 16 >> 2] = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, l[ie + 20 >> 2] = _, _ = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[ie >> 2] = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[ie + 4 >> 2] = _, _ = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, l[ie + 8 >> 2] = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24, l[ie + 12 >> 2] = _, _ = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, b = B[b + 4 | 0] | B[b + 5 | 0] << 8 | B[b + 6 | 0] << 16 | B[b + 7 | 0] << 24, l[ie + 104 >> 2] = 0, l[ie + 108 >> 2] = 0, l[ie + 96 >> 2] = _, l[ie + 100 >> 2] = b;
                        e: {
                          if (!g & he >>> 0 >= 64 | g) {
                            for (; Yi(A, ie + 96 | 0, ie, 0), _ = B[ie + 104 | 0] + 1 | 0, j[ie + 104 | 0] = _, _ = B[ie + 105 | 0] + (_ >>> 8 | 0) | 0, j[ie + 105 | 0] = _, _ = B[ie + 106 | 0] + (_ >>> 8 | 0) | 0, j[ie + 106 | 0] = _, _ = B[ie + 107 | 0] + (_ >>> 8 | 0) | 0, j[ie + 107 | 0] = _, _ = B[ie + 108 | 0] + (_ >>> 8 | 0) | 0, j[ie + 108 | 0] = _, _ = B[ie + 109 | 0] + (_ >>> 8 | 0) | 0, j[ie + 109 | 0] = _, _ = B[ie + 110 | 0] + (_ >>> 8 | 0) | 0, j[ie + 110 | 0] = _, j[ie + 111 | 0] = B[ie + 111 | 0] + (_ >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (he = he + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & he >>> 0 > 63 | g; )
                              ;
                            if (!(g | he))
                              break e;
                          }
                          if (_ = 0, Yi(ie + 32 | 0, ie + 96 | 0, ie, 0), U = 3 & he, g = 0, he - 1 >>> 0 >= 3)
                            for (he &= -4, b = 0; D = _e = ie + 32 | 0, j[A + g | 0] = B[D + g | 0], j[(me = 1 | g) + A | 0] = B[D + me | 0], j[(me = 2 | g) + A | 0] = B[D + me | 0], j[(D = 3 | g) + A | 0] = B[D + _e | 0], g = g + 4 | 0, (0 | he) != (0 | (b = b + 4 | 0)); )
                              ;
                          if (U)
                            for (; j[A + g | 0] = B[(ie + 32 | 0) + g | 0], g = g + 1 | 0, (0 | U) != (0 | (_ = _ + 1 | 0)); )
                              ;
                        }
                        Wr(ie + 32 | 0, 64), Wr(ie, 32);
                      }
                      return st = ie + 112 | 0, 0;
                    }, gj: function(A, g, _, b, U, ie) {
                      A |= 0, g |= 0, U |= 0, ie |= 0;
                      var he, D = 0, me = 0;
                      if (st = he = st - 112 | 0, D = b |= 0, b = _ |= 0, D | _) {
                        _ = B[ie + 28 | 0] | B[ie + 29 | 0] << 8 | B[ie + 30 | 0] << 16 | B[ie + 31 | 0] << 24, l[he + 24 >> 2] = B[ie + 24 | 0] | B[ie + 25 | 0] << 8 | B[ie + 26 | 0] << 16 | B[ie + 27 | 0] << 24, l[he + 28 >> 2] = _, _ = B[ie + 20 | 0] | B[ie + 21 | 0] << 8 | B[ie + 22 | 0] << 16 | B[ie + 23 | 0] << 24, l[he + 16 >> 2] = B[ie + 16 | 0] | B[ie + 17 | 0] << 8 | B[ie + 18 | 0] << 16 | B[ie + 19 | 0] << 24, l[he + 20 >> 2] = _, _ = B[ie + 4 | 0] | B[ie + 5 | 0] << 8 | B[ie + 6 | 0] << 16 | B[ie + 7 | 0] << 24, l[he >> 2] = B[0 | ie] | B[ie + 1 | 0] << 8 | B[ie + 2 | 0] << 16 | B[ie + 3 | 0] << 24, l[he + 4 >> 2] = _, _ = B[ie + 12 | 0] | B[ie + 13 | 0] << 8 | B[ie + 14 | 0] << 16 | B[ie + 15 | 0] << 24, l[he + 8 >> 2] = B[ie + 8 | 0] | B[ie + 9 | 0] << 8 | B[ie + 10 | 0] << 16 | B[ie + 11 | 0] << 24, l[he + 12 >> 2] = _, _ = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, U = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[he + 104 >> 2] = 0, l[he + 108 >> 2] = 0, l[he + 96 >> 2] = _, l[he + 100 >> 2] = U;
                        e: {
                          if (!D & b >>> 0 >= 64 | D) {
                            for (; ; ) {
                              for (_ = 0, Yi(he + 32 | 0, he + 96 | 0, he, 0); ie = he + 32 | 0, j[A + _ | 0] = B[ie + _ | 0] ^ B[g + _ | 0], j[(U = 1 | _) + A | 0] = B[U + ie | 0] ^ B[g + U | 0], (0 | (_ = _ + 2 | 0)) != 64; )
                                ;
                              if (_ = B[he + 104 | 0] + 1 | 0, j[he + 104 | 0] = _, _ = B[he + 105 | 0] + (_ >>> 8 | 0) | 0, j[he + 105 | 0] = _, _ = B[he + 106 | 0] + (_ >>> 8 | 0) | 0, j[he + 106 | 0] = _, _ = B[he + 107 | 0] + (_ >>> 8 | 0) | 0, j[he + 107 | 0] = _, _ = B[he + 108 | 0] + (_ >>> 8 | 0) | 0, j[he + 108 | 0] = _, _ = B[he + 109 | 0] + (_ >>> 8 | 0) | 0, j[he + 109 | 0] = _, _ = B[he + 110 | 0] + (_ >>> 8 | 0) | 0, j[he + 110 | 0] = _, j[he + 111 | 0] = B[he + 111 | 0] + (_ >>> 8 | 0), g = g - -64 | 0, A = A - -64 | 0, D = D - 1 | 0, !(!(D = (b = b + -64 | 0) >>> 0 < 4294967232 ? D + 1 | 0 : D) & b >>> 0 > 63 | D))
                                break;
                            }
                            if (!(b | D))
                              break e;
                          }
                          if (_ = 0, Yi(he + 32 | 0, he + 96 | 0, he, 0), ie = 1 & b, (0 | b) != 1)
                            for (D = -2 & b, b = 0; me = he + 32 | 0, j[A + _ | 0] = B[me + _ | 0] ^ B[g + _ | 0], j[(U = 1 | _) + A | 0] = B[U + me | 0] ^ B[g + U | 0], _ = _ + 2 | 0, (0 | D) != (0 | (b = b + 2 | 0)); )
                              ;
                          ie && (j[A + _ | 0] = B[(he + 32 | 0) + _ | 0] ^ B[g + _ | 0]);
                        }
                        Wr(he + 32 | 0, 64), Wr(he, 32);
                      }
                      return st = he + 112 | 0, 0;
                    }, hj: wo, ij: ba, jj: ji, kj: Li, lj: function(A, g, _, b, U) {
                      A |= 0, b |= 0, U |= 0;
                      var ie, he = 0, D = 0, me = 0, _e = 0;
                      if (st = ie = st - 112 | 0, he = g |= 0, g = _ |= 0, he | _) {
                        _ = B[U + 28 | 0] | B[U + 29 | 0] << 8 | B[U + 30 | 0] << 16 | B[U + 31 | 0] << 24, l[ie + 24 >> 2] = B[U + 24 | 0] | B[U + 25 | 0] << 8 | B[U + 26 | 0] << 16 | B[U + 27 | 0] << 24, l[ie + 28 >> 2] = _, _ = B[U + 20 | 0] | B[U + 21 | 0] << 8 | B[U + 22 | 0] << 16 | B[U + 23 | 0] << 24, l[ie + 16 >> 2] = B[U + 16 | 0] | B[U + 17 | 0] << 8 | B[U + 18 | 0] << 16 | B[U + 19 | 0] << 24, l[ie + 20 >> 2] = _, _ = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[ie >> 2] = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, l[ie + 4 >> 2] = _, _ = B[U + 12 | 0] | B[U + 13 | 0] << 8 | B[U + 14 | 0] << 16 | B[U + 15 | 0] << 24, l[ie + 8 >> 2] = B[U + 8 | 0] | B[U + 9 | 0] << 8 | B[U + 10 | 0] << 16 | B[U + 11 | 0] << 24, l[ie + 12 >> 2] = _, _ = B[0 | b] | B[b + 1 | 0] << 8 | B[b + 2 | 0] << 16 | B[b + 3 | 0] << 24, b = B[b + 4 | 0] | B[b + 5 | 0] << 8 | B[b + 6 | 0] << 16 | B[b + 7 | 0] << 24, l[ie + 104 >> 2] = 0, l[ie + 108 >> 2] = 0, l[ie + 96 >> 2] = _, l[ie + 100 >> 2] = b;
                        e: {
                          if (!g & he >>> 0 >= 64 | g) {
                            for (; us(A, ie + 96 | 0, ie, 0), _ = B[ie + 104 | 0] + 1 | 0, j[ie + 104 | 0] = _, _ = B[ie + 105 | 0] + (_ >>> 8 | 0) | 0, j[ie + 105 | 0] = _, _ = B[ie + 106 | 0] + (_ >>> 8 | 0) | 0, j[ie + 106 | 0] = _, _ = B[ie + 107 | 0] + (_ >>> 8 | 0) | 0, j[ie + 107 | 0] = _, _ = B[ie + 108 | 0] + (_ >>> 8 | 0) | 0, j[ie + 108 | 0] = _, _ = B[ie + 109 | 0] + (_ >>> 8 | 0) | 0, j[ie + 109 | 0] = _, _ = B[ie + 110 | 0] + (_ >>> 8 | 0) | 0, j[ie + 110 | 0] = _, j[ie + 111 | 0] = B[ie + 111 | 0] + (_ >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (he = he + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & he >>> 0 > 63 | g; )
                              ;
                            if (!(g | he))
                              break e;
                          }
                          if (_ = 0, us(ie + 32 | 0, ie + 96 | 0, ie, 0), U = 3 & he, g = 0, he - 1 >>> 0 >= 3)
                            for (he &= -4, b = 0; D = _e = ie + 32 | 0, j[A + g | 0] = B[D + g | 0], j[(me = 1 | g) + A | 0] = B[D + me | 0], j[(me = 2 | g) + A | 0] = B[D + me | 0], j[(D = 3 | g) + A | 0] = B[D + _e | 0], g = g + 4 | 0, (0 | he) != (0 | (b = b + 4 | 0)); )
                              ;
                          if (U)
                            for (; j[A + g | 0] = B[(ie + 32 | 0) + g | 0], g = g + 1 | 0, (0 | U) != (0 | (_ = _ + 1 | 0)); )
                              ;
                        }
                        Wr(ie + 32 | 0, 64), Wr(ie, 32);
                      }
                      return st = ie + 112 | 0, 0;
                    }, mj: function(A, g, _, b, U, ie) {
                      A |= 0, g |= 0, U |= 0, ie |= 0;
                      var he, D = 0, me = 0;
                      if (st = he = st - 112 | 0, D = b |= 0, b = _ |= 0, D | _) {
                        _ = B[ie + 28 | 0] | B[ie + 29 | 0] << 8 | B[ie + 30 | 0] << 16 | B[ie + 31 | 0] << 24, l[he + 24 >> 2] = B[ie + 24 | 0] | B[ie + 25 | 0] << 8 | B[ie + 26 | 0] << 16 | B[ie + 27 | 0] << 24, l[he + 28 >> 2] = _, _ = B[ie + 20 | 0] | B[ie + 21 | 0] << 8 | B[ie + 22 | 0] << 16 | B[ie + 23 | 0] << 24, l[he + 16 >> 2] = B[ie + 16 | 0] | B[ie + 17 | 0] << 8 | B[ie + 18 | 0] << 16 | B[ie + 19 | 0] << 24, l[he + 20 >> 2] = _, _ = B[ie + 4 | 0] | B[ie + 5 | 0] << 8 | B[ie + 6 | 0] << 16 | B[ie + 7 | 0] << 24, l[he >> 2] = B[0 | ie] | B[ie + 1 | 0] << 8 | B[ie + 2 | 0] << 16 | B[ie + 3 | 0] << 24, l[he + 4 >> 2] = _, _ = B[ie + 12 | 0] | B[ie + 13 | 0] << 8 | B[ie + 14 | 0] << 16 | B[ie + 15 | 0] << 24, l[he + 8 >> 2] = B[ie + 8 | 0] | B[ie + 9 | 0] << 8 | B[ie + 10 | 0] << 16 | B[ie + 11 | 0] << 24, l[he + 12 >> 2] = _, _ = B[0 | U] | B[U + 1 | 0] << 8 | B[U + 2 | 0] << 16 | B[U + 3 | 0] << 24, U = B[U + 4 | 0] | B[U + 5 | 0] << 8 | B[U + 6 | 0] << 16 | B[U + 7 | 0] << 24, l[he + 104 >> 2] = 0, l[he + 108 >> 2] = 0, l[he + 96 >> 2] = _, l[he + 100 >> 2] = U;
                        e: {
                          if (!D & b >>> 0 >= 64 | D) {
                            for (; ; ) {
                              for (_ = 0, us(he + 32 | 0, he + 96 | 0, he, 0); ie = he + 32 | 0, j[A + _ | 0] = B[ie + _ | 0] ^ B[g + _ | 0], j[(U = 1 | _) + A | 0] = B[U + ie | 0] ^ B[g + U | 0], (0 | (_ = _ + 2 | 0)) != 64; )
                                ;
                              if (_ = B[he + 104 | 0] + 1 | 0, j[he + 104 | 0] = _, _ = B[he + 105 | 0] + (_ >>> 8 | 0) | 0, j[he + 105 | 0] = _, _ = B[he + 106 | 0] + (_ >>> 8 | 0) | 0, j[he + 106 | 0] = _, _ = B[he + 107 | 0] + (_ >>> 8 | 0) | 0, j[he + 107 | 0] = _, _ = B[he + 108 | 0] + (_ >>> 8 | 0) | 0, j[he + 108 | 0] = _, _ = B[he + 109 | 0] + (_ >>> 8 | 0) | 0, j[he + 109 | 0] = _, _ = B[he + 110 | 0] + (_ >>> 8 | 0) | 0, j[he + 110 | 0] = _, j[he + 111 | 0] = B[he + 111 | 0] + (_ >>> 8 | 0), g = g - -64 | 0, A = A - -64 | 0, D = D - 1 | 0, !(!(D = (b = b + -64 | 0) >>> 0 < 4294967232 ? D + 1 | 0 : D) & b >>> 0 > 63 | D))
                                break;
                            }
                            if (!(b | D))
                              break e;
                          }
                          if (_ = 0, us(he + 32 | 0, he + 96 | 0, he, 0), ie = 1 & b, (0 | b) != 1)
                            for (D = -2 & b, b = 0; me = he + 32 | 0, j[A + _ | 0] = B[me + _ | 0] ^ B[g + _ | 0], j[(U = 1 | _) + A | 0] = B[U + me | 0] ^ B[g + U | 0], _ = _ + 2 | 0, (0 | D) != (0 | (b = b + 2 | 0)); )
                              ;
                          ie && (j[A + _ | 0] = B[(he + 32 | 0) + _ | 0] ^ B[g + _ | 0]);
                        }
                        Wr(he + 32 | 0, 64), Wr(he, 32);
                      }
                      return st = he + 112 | 0, 0;
                    }, nj: wo, oj: ba, pj: ji, qj: Li, rj: wo, sj: fa, tj: ji, uj: function(A, g, _, b, U) {
                      var ie;
                      return A |= 0, g |= 0, _ |= 0, st = ie = st - 32 | 0, Ji(ie, b |= 0, U |= 0, 0), A = Ho(A, g, _, b + 16 | 0, ie), st = ie + 32 | 0, 0 | A;
                    }, vj: function(A, g, _, b, U, ie, he, D) {
                      var me;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, ie |= 0, he |= 0, st = me = st - 32 | 0, Ji(me, U |= 0, D |= 0, 0), A = ro(D = A, g, (A = 0) | _, b, U + 16 | 0, A | ie, he, me), st = me + 32 | 0, 0 | A;
                    }, wj: function(A, g, _, b, U, ie) {
                      var he;
                      return A |= 0, g |= 0, _ |= 0, b |= 0, st = he = st - 32 | 0, Ji(he, U |= 0, ie |= 0, 0), A = ro(A, g, _, b, U + 16 | 0, 0, 0, he), st = he + 32 | 0, 0 | A;
                    }, xj: Li, yj: Qi, zj: wi, Aj: Xi };
                  }(Nr);
                }(sr);
              }, instantiate: function(xn, sr) {
                return { then: function(Nr) {
                  var vr = new Wt.Module(xn);
                  Nr({ instance: new Wt.Instance(vr, sr) });
                } };
              }, RuntimeError: Error };
              Me = [], typeof Wt != "object" && Qo("no native wasm support detected");
              var yn, pr, Uo, ar, Sr, Jo, fr, Er = !1, vo = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
              function lr(xn, sr) {
                return xn ? function(Nr, vr, Yr) {
                  for (var Fr = vr + Yr, eo = vr; Nr[eo] && !(eo >= Fr); )
                    ++eo;
                  if (eo - vr > 16 && Nr.buffer && vo)
                    return vo.decode(Nr.subarray(vr, eo));
                  for (var Xr = ""; vr < eo; ) {
                    var Mo = Nr[vr++];
                    if (128 & Mo) {
                      var jo = 63 & Nr[vr++];
                      if ((224 & Mo) != 192) {
                        var Ii = 63 & Nr[vr++];
                        if ((Mo = (240 & Mo) == 224 ? (15 & Mo) << 12 | jo << 6 | Ii : (7 & Mo) << 18 | jo << 12 | Ii << 6 | 63 & Nr[vr++]) < 65536)
                          Xr += String.fromCharCode(Mo);
                        else {
                          var ki = Mo - 65536;
                          Xr += String.fromCharCode(55296 | ki >> 10, 56320 | 1023 & ki);
                        }
                      } else
                        Xr += String.fromCharCode((31 & Mo) << 6 | jo);
                    } else
                      Xr += String.fromCharCode(Mo);
                  }
                  return Xr;
                }(pr, xn, sr) : "";
              }
              function $r() {
                var xn = cn.buffer;
                ce.HEAP8 = yn = new Int8Array(xn), ce.HEAP16 = Uo = new Int16Array(xn), ce.HEAP32 = ar = new Int32Array(xn), ce.HEAPU8 = pr = new Uint8Array(xn), ce.HEAPU16 = new Uint16Array(xn), ce.HEAPU32 = Sr = new Uint32Array(xn), ce.HEAPF32 = Jo = new Float32Array(xn), ce.HEAPF64 = fr = new Float64Array(xn);
              }
              var Wo = ce.INITIAL_MEMORY || 50331648;
              Wo >= 65536 || Qo("INITIAL_MEMORY should be larger than STACK_SIZE, was " + Wo + "! (STACK_SIZE=65536)"), cn = ce.wasmMemory ? ce.wasmMemory : new Wt.Memory({ initial: Wo / 65536, maximum: 32768 }), $r(), Wo = cn.buffer.byteLength;
              var yr = [], Dr = [], Zo = [], dr = 0, Br = null;
              function Qo(xn) {
                throw ce.onAbort && ce.onAbort(xn), He(xn = "Aborted(" + xn + ")"), Er = !0, xn += ". Build with -sASSERTIONS for more info.", new Wt.RuntimeError(xn);
              }
              var tr, Mr, qo, hr, Or = "data:application/octet-stream;base64,";
              function Fo(xn) {
                return xn.startsWith(Or);
              }
              function No(xn) {
                return xn.startsWith("file://");
              }
              function di(xn) {
                try {
                  if (xn == tr && Me)
                    return new Uint8Array(Me);
                  var sr = ii(xn);
                  if (sr)
                    return sr;
                  if (Qn)
                    return Qn(xn);
                  throw "both async and sync fetching of the wasm failed";
                } catch (Nr) {
                  Qo(Nr);
                }
              }
              Fo(tr = "<<< WASM_BINARY_FILE >>>") || (Mr = tr, tr = ce.locateFile ? ce.locateFile(Mr, Ln) : Ln + Mr);
              var gi = { 35752: () => ce.getRandomValue(), 35788: () => {
                if (ce.getRandomValue === void 0)
                  try {
                    var xn = typeof window == "object" ? window : self, sr = xn.crypto !== void 0 ? xn.crypto : xn.msCrypto, Nr = function() {
                      var Fr = new Uint32Array(1);
                      return sr.getRandomValues(Fr), Fr[0] >>> 0;
                    };
                    Nr(), ce.getRandomValue = Nr;
                  } catch {
                    try {
                      var vr = requireCryptoBrowserify(), Yr = function() {
                        var eo = vr.randomBytes(4);
                        return (eo[0] << 24 | eo[1] << 16 | eo[2] << 8 | eo[3]) >>> 0;
                      };
                      Yr(), ce.getRandomValue = Yr;
                    } catch {
                      throw "No secure random number generator found";
                    }
                  }
              } };
              function ai(xn) {
                for (; xn.length > 0; )
                  xn.shift()(ce);
              }
              var ui = [];
              function hi(xn) {
                var sr = cn.buffer;
                try {
                  return cn.grow(xn - sr.byteLength + 65535 >>> 16), $r(), 1;
                } catch {
                }
              }
              var bi = typeof atob == "function" ? atob : function(xn) {
                var sr, Nr, vr, Yr, Fr, eo, Xr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Mo = "", jo = 0;
                xn = xn.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                do
                  sr = Xr.indexOf(xn.charAt(jo++)) << 2 | (Yr = Xr.indexOf(xn.charAt(jo++))) >> 4, Nr = (15 & Yr) << 4 | (Fr = Xr.indexOf(xn.charAt(jo++))) >> 2, vr = (3 & Fr) << 6 | (eo = Xr.indexOf(xn.charAt(jo++))), Mo += String.fromCharCode(sr), Fr !== 64 && (Mo += String.fromCharCode(Nr)), eo !== 64 && (Mo += String.fromCharCode(vr));
                while (jo < xn.length);
                return Mo;
              };
              function ii(xn) {
                if (Fo(xn))
                  return function(sr) {
                    if (typeof rn == "boolean" && rn) {
                      var Nr = Buffer.from(sr, "base64");
                      return new Uint8Array(Nr.buffer, Nr.byteOffset, Nr.byteLength);
                    }
                    try {
                      for (var vr = bi(sr), Yr = new Uint8Array(vr.length), Fr = 0; Fr < vr.length; ++Fr)
                        Yr[Fr] = vr.charCodeAt(Fr);
                      return Yr;
                    } catch {
                      throw new Error("Converting base64 string to bytes failed.");
                    }
                  }(xn.slice(Or.length));
              }
              var pi, Ci = { c: function(xn, sr, Nr, vr) {
                Qo("Assertion failed: " + lr(xn) + ", at: " + [sr ? lr(sr) : "unknown filename", Nr, vr ? lr(vr) : "unknown function"]);
              }, d: function() {
                Qo("");
              }, b: function(xn, sr, Nr) {
                return function(vr, Yr, Fr) {
                  var eo = function(Xr, Mo) {
                    var jo;
                    for (ui.length = 0, Mo >>= 2; jo = pr[Xr++]; )
                      Mo += jo != 105 & Mo, ui.push(jo == 105 ? ar[Mo] : fr[Mo++ >> 1]), ++Mo;
                    return ui;
                  }(Yr, Fr);
                  return gi[vr].apply(null, eo);
                }(xn, sr, Nr);
              }, e: function(xn) {
                var sr, Nr = pr.length, vr = 2147483648;
                if ((xn >>>= 0) > vr)
                  return !1;
                for (var Yr = 1; Yr <= 4; Yr *= 2) {
                  var Fr = Nr * (1 + 0.2 / Yr);
                  if (Fr = Math.min(Fr, xn + 100663296), hi(Math.min(vr, (sr = Math.max(xn, Fr)) + (65536 - sr % 65536) % 65536)))
                    return !0;
                }
                return !1;
              }, a: cn };
              function _i() {
                function xn() {
                  pi || (pi = !0, ce.calledRun = !0, Er || (ai(Dr), ce.onRuntimeInitialized && ce.onRuntimeInitialized(), function() {
                    if (ce.postRun)
                      for (typeof ce.postRun == "function" && (ce.postRun = [ce.postRun]); ce.postRun.length; )
                        sr = ce.postRun.shift(), Zo.unshift(sr);
                    var sr;
                    ai(Zo);
                  }()));
                }
                dr > 0 || (function() {
                  if (ce.preRun)
                    for (typeof ce.preRun == "function" && (ce.preRun = [ce.preRun]); ce.preRun.length; )
                      sr = ce.preRun.shift(), yr.unshift(sr);
                  var sr;
                  ai(yr);
                }(), dr > 0 || (ce.setStatus ? (ce.setStatus("Running..."), setTimeout(function() {
                  setTimeout(function() {
                    ce.setStatus("");
                  }, 1), xn();
                }, 1)) : xn()));
              }
              if (function() {
                var xn = { a: Ci };
                function sr(Yr, Fr) {
                  var eo, Xr = Yr.exports;
                  ce.asm = Xr, ce.asm.Aj, eo = ce.asm.f, Dr.unshift(eo), function(Mo) {
                    if (dr--, ce.monitorRunDependencies && ce.monitorRunDependencies(dr), dr == 0 && Br) {
                      var jo = Br;
                      Br = null, jo();
                    }
                  }();
                }
                function Nr(Yr) {
                  sr(Yr.instance);
                }
                function vr(Yr) {
                  return function() {
                    if (!Me && (ft || It)) {
                      if (typeof fetch == "function" && !No(tr))
                        return fetch(tr, { credentials: "same-origin" }).then(function(Fr) {
                          if (!Fr.ok)
                            throw "failed to load wasm binary file at '" + tr + "'";
                          return Fr.arrayBuffer();
                        }).catch(function() {
                          return di(tr);
                        });
                      if (Lt)
                        return new Promise(function(Fr, eo) {
                          Lt(tr, function(Xr) {
                            Fr(new Uint8Array(Xr));
                          }, eo);
                        });
                    }
                    return Promise.resolve().then(function() {
                      return di(tr);
                    });
                  }().then(function(Fr) {
                    return Wt.instantiate(Fr, xn);
                  }).then(function(Fr) {
                    return Fr;
                  }).then(Yr, function(Fr) {
                    He("failed to asynchronously prepare wasm: " + Fr), Qo(Fr);
                  });
                }
                if (dr++, ce.monitorRunDependencies && ce.monitorRunDependencies(dr), ce.instantiateWasm)
                  try {
                    return ce.instantiateWasm(xn, sr);
                  } catch (Yr) {
                    return He("Module.instantiateWasm callback failed with error: " + Yr), !1;
                  }
                Me || typeof Wt.instantiateStreaming != "function" || Fo(tr) || No(tr) || rn || typeof fetch != "function" ? vr(Nr) : fetch(tr, { credentials: "same-origin" }).then(function(Yr) {
                  return Wt.instantiateStreaming(Yr, xn).then(Nr, function(Fr) {
                    return He("wasm streaming compile failed: " + Fr), He("falling back to ArrayBuffer instantiation"), vr(Nr);
                  });
                });
              }(), ce._crypto_aead_chacha20poly1305_encrypt_detached = function() {
                return (ce._crypto_aead_chacha20poly1305_encrypt_detached = ce.asm.g).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_encrypt = function() {
                return (ce._crypto_aead_chacha20poly1305_encrypt = ce.asm.h).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_encrypt_detached = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_encrypt_detached = ce.asm.i).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_encrypt = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_encrypt = ce.asm.j).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_decrypt_detached = function() {
                return (ce._crypto_aead_chacha20poly1305_decrypt_detached = ce.asm.k).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_decrypt = function() {
                return (ce._crypto_aead_chacha20poly1305_decrypt = ce.asm.l).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_decrypt_detached = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_decrypt_detached = ce.asm.m).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_decrypt = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_decrypt = ce.asm.n).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_keybytes = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_keybytes = ce.asm.o).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_npubbytes = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_npubbytes = ce.asm.p).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_nsecbytes = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_nsecbytes = ce.asm.q).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_abytes = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_abytes = ce.asm.r).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_messagebytes_max = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ce.asm.s).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_ietf_keygen = function() {
                return (ce._crypto_aead_chacha20poly1305_ietf_keygen = ce.asm.t).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_keybytes = function() {
                return (ce._crypto_aead_chacha20poly1305_keybytes = ce.asm.u).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_npubbytes = function() {
                return (ce._crypto_aead_chacha20poly1305_npubbytes = ce.asm.v).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_nsecbytes = function() {
                return (ce._crypto_aead_chacha20poly1305_nsecbytes = ce.asm.w).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_abytes = function() {
                return (ce._crypto_aead_chacha20poly1305_abytes = ce.asm.x).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_messagebytes_max = function() {
                return (ce._crypto_aead_chacha20poly1305_messagebytes_max = ce.asm.y).apply(null, arguments);
              }, ce._crypto_aead_chacha20poly1305_keygen = function() {
                return (ce._crypto_aead_chacha20poly1305_keygen = ce.asm.z).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = ce.asm.A).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_encrypt = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_encrypt = ce.asm.B).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = ce.asm.C).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_decrypt = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_decrypt = ce.asm.D).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_keybytes = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_keybytes = ce.asm.E).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_npubbytes = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_npubbytes = ce.asm.F).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_nsecbytes = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ce.asm.G).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_abytes = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_abytes = ce.asm.H).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ce.asm.I).apply(null, arguments);
              }, ce._crypto_aead_xchacha20poly1305_ietf_keygen = function() {
                return (ce._crypto_aead_xchacha20poly1305_ietf_keygen = ce.asm.J).apply(null, arguments);
              }, ce._crypto_auth_bytes = function() {
                return (ce._crypto_auth_bytes = ce.asm.K).apply(null, arguments);
              }, ce._crypto_auth_keybytes = function() {
                return (ce._crypto_auth_keybytes = ce.asm.L).apply(null, arguments);
              }, ce._crypto_auth_primitive = function() {
                return (ce._crypto_auth_primitive = ce.asm.M).apply(null, arguments);
              }, ce._crypto_auth = function() {
                return (ce._crypto_auth = ce.asm.N).apply(null, arguments);
              }, ce._crypto_auth_verify = function() {
                return (ce._crypto_auth_verify = ce.asm.O).apply(null, arguments);
              }, ce._crypto_auth_keygen = function() {
                return (ce._crypto_auth_keygen = ce.asm.P).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256_bytes = function() {
                return (ce._crypto_auth_hmacsha256_bytes = ce.asm.Q).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256_keybytes = function() {
                return (ce._crypto_auth_hmacsha256_keybytes = ce.asm.R).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256_statebytes = function() {
                return (ce._crypto_auth_hmacsha256_statebytes = ce.asm.S).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256_keygen = function() {
                return (ce._crypto_auth_hmacsha256_keygen = ce.asm.T).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256_init = function() {
                return (ce._crypto_auth_hmacsha256_init = ce.asm.U).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256_update = function() {
                return (ce._crypto_auth_hmacsha256_update = ce.asm.V).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256_final = function() {
                return (ce._crypto_auth_hmacsha256_final = ce.asm.W).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256 = function() {
                return (ce._crypto_auth_hmacsha256 = ce.asm.X).apply(null, arguments);
              }, ce._crypto_auth_hmacsha256_verify = function() {
                return (ce._crypto_auth_hmacsha256_verify = ce.asm.Y).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512_bytes = function() {
                return (ce._crypto_auth_hmacsha512_bytes = ce.asm.Z).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512_keybytes = function() {
                return (ce._crypto_auth_hmacsha512_keybytes = ce.asm._).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512_statebytes = function() {
                return (ce._crypto_auth_hmacsha512_statebytes = ce.asm.$).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512_keygen = function() {
                return (ce._crypto_auth_hmacsha512_keygen = ce.asm.aa).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512_init = function() {
                return (ce._crypto_auth_hmacsha512_init = ce.asm.ba).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512_update = function() {
                return (ce._crypto_auth_hmacsha512_update = ce.asm.ca).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512_final = function() {
                return (ce._crypto_auth_hmacsha512_final = ce.asm.da).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512 = function() {
                return (ce._crypto_auth_hmacsha512 = ce.asm.ea).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512_verify = function() {
                return (ce._crypto_auth_hmacsha512_verify = ce.asm.fa).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256_bytes = function() {
                return (ce._crypto_auth_hmacsha512256_bytes = ce.asm.ga).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256_keybytes = function() {
                return (ce._crypto_auth_hmacsha512256_keybytes = ce.asm.ha).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256_statebytes = function() {
                return (ce._crypto_auth_hmacsha512256_statebytes = ce.asm.ia).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256_keygen = function() {
                return (ce._crypto_auth_hmacsha512256_keygen = ce.asm.ja).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256_init = function() {
                return (ce._crypto_auth_hmacsha512256_init = ce.asm.ka).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256_update = function() {
                return (ce._crypto_auth_hmacsha512256_update = ce.asm.la).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256_final = function() {
                return (ce._crypto_auth_hmacsha512256_final = ce.asm.ma).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256 = function() {
                return (ce._crypto_auth_hmacsha512256 = ce.asm.na).apply(null, arguments);
              }, ce._crypto_auth_hmacsha512256_verify = function() {
                return (ce._crypto_auth_hmacsha512256_verify = ce.asm.oa).apply(null, arguments);
              }, ce._crypto_box_seedbytes = function() {
                return (ce._crypto_box_seedbytes = ce.asm.pa).apply(null, arguments);
              }, ce._crypto_box_publickeybytes = function() {
                return (ce._crypto_box_publickeybytes = ce.asm.qa).apply(null, arguments);
              }, ce._crypto_box_secretkeybytes = function() {
                return (ce._crypto_box_secretkeybytes = ce.asm.ra).apply(null, arguments);
              }, ce._crypto_box_beforenmbytes = function() {
                return (ce._crypto_box_beforenmbytes = ce.asm.sa).apply(null, arguments);
              }, ce._crypto_box_noncebytes = function() {
                return (ce._crypto_box_noncebytes = ce.asm.ta).apply(null, arguments);
              }, ce._crypto_box_zerobytes = function() {
                return (ce._crypto_box_zerobytes = ce.asm.ua).apply(null, arguments);
              }, ce._crypto_box_boxzerobytes = function() {
                return (ce._crypto_box_boxzerobytes = ce.asm.va).apply(null, arguments);
              }, ce._crypto_box_macbytes = function() {
                return (ce._crypto_box_macbytes = ce.asm.wa).apply(null, arguments);
              }, ce._crypto_box_messagebytes_max = function() {
                return (ce._crypto_box_messagebytes_max = ce.asm.xa).apply(null, arguments);
              }, ce._crypto_box_primitive = function() {
                return (ce._crypto_box_primitive = ce.asm.ya).apply(null, arguments);
              }, ce._crypto_box_seed_keypair = function() {
                return (ce._crypto_box_seed_keypair = ce.asm.za).apply(null, arguments);
              }, ce._crypto_box_keypair = function() {
                return (ce._crypto_box_keypair = ce.asm.Aa).apply(null, arguments);
              }, ce._crypto_box_beforenm = function() {
                return (ce._crypto_box_beforenm = ce.asm.Ba).apply(null, arguments);
              }, ce._crypto_box_afternm = function() {
                return (ce._crypto_box_afternm = ce.asm.Ca).apply(null, arguments);
              }, ce._crypto_box_open_afternm = function() {
                return (ce._crypto_box_open_afternm = ce.asm.Da).apply(null, arguments);
              }, ce._crypto_box = function() {
                return (ce._crypto_box = ce.asm.Ea).apply(null, arguments);
              }, ce._crypto_box_open = function() {
                return (ce._crypto_box_open = ce.asm.Fa).apply(null, arguments);
              }, ce._crypto_box_detached_afternm = function() {
                return (ce._crypto_box_detached_afternm = ce.asm.Ga).apply(null, arguments);
              }, ce._crypto_box_detached = function() {
                return (ce._crypto_box_detached = ce.asm.Ha).apply(null, arguments);
              }, ce._crypto_box_easy_afternm = function() {
                return (ce._crypto_box_easy_afternm = ce.asm.Ia).apply(null, arguments);
              }, ce._crypto_box_easy = function() {
                return (ce._crypto_box_easy = ce.asm.Ja).apply(null, arguments);
              }, ce._crypto_box_open_detached_afternm = function() {
                return (ce._crypto_box_open_detached_afternm = ce.asm.Ka).apply(null, arguments);
              }, ce._crypto_box_open_detached = function() {
                return (ce._crypto_box_open_detached = ce.asm.La).apply(null, arguments);
              }, ce._crypto_box_open_easy_afternm = function() {
                return (ce._crypto_box_open_easy_afternm = ce.asm.Ma).apply(null, arguments);
              }, ce._crypto_box_open_easy = function() {
                return (ce._crypto_box_open_easy = ce.asm.Na).apply(null, arguments);
              }, ce._crypto_box_seal = function() {
                return (ce._crypto_box_seal = ce.asm.Oa).apply(null, arguments);
              }, ce._crypto_box_seal_open = function() {
                return (ce._crypto_box_seal_open = ce.asm.Pa).apply(null, arguments);
              }, ce._crypto_box_sealbytes = function() {
                return (ce._crypto_box_sealbytes = ce.asm.Qa).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_seed_keypair = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_seed_keypair = ce.asm.Ra).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_keypair = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_keypair = ce.asm.Sa).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_beforenm = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_beforenm = ce.asm.Ta).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_afternm = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_afternm = ce.asm.Ua).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_open_afternm = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_open_afternm = ce.asm.Va).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305 = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305 = ce.asm.Wa).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_open = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_open = ce.asm.Xa).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_seedbytes = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_seedbytes = ce.asm.Ya).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_publickeybytes = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_publickeybytes = ce.asm.Za).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = ce.asm._a).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = ce.asm.$a).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_noncebytes = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_noncebytes = ce.asm.ab).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_zerobytes = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_zerobytes = ce.asm.bb).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = ce.asm.cb).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_macbytes = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_macbytes = ce.asm.db).apply(null, arguments);
              }, ce._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = function() {
                return (ce._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = ce.asm.eb).apply(null, arguments);
              }, ce._crypto_core_hchacha20 = function() {
                return (ce._crypto_core_hchacha20 = ce.asm.fb).apply(null, arguments);
              }, ce._crypto_core_hchacha20_outputbytes = function() {
                return (ce._crypto_core_hchacha20_outputbytes = ce.asm.gb).apply(null, arguments);
              }, ce._crypto_core_hchacha20_inputbytes = function() {
                return (ce._crypto_core_hchacha20_inputbytes = ce.asm.hb).apply(null, arguments);
              }, ce._crypto_core_hchacha20_keybytes = function() {
                return (ce._crypto_core_hchacha20_keybytes = ce.asm.ib).apply(null, arguments);
              }, ce._crypto_core_hchacha20_constbytes = function() {
                return (ce._crypto_core_hchacha20_constbytes = ce.asm.jb).apply(null, arguments);
              }, ce._crypto_core_hsalsa20 = function() {
                return (ce._crypto_core_hsalsa20 = ce.asm.kb).apply(null, arguments);
              }, ce._crypto_core_hsalsa20_outputbytes = function() {
                return (ce._crypto_core_hsalsa20_outputbytes = ce.asm.lb).apply(null, arguments);
              }, ce._crypto_core_hsalsa20_inputbytes = function() {
                return (ce._crypto_core_hsalsa20_inputbytes = ce.asm.mb).apply(null, arguments);
              }, ce._crypto_core_hsalsa20_keybytes = function() {
                return (ce._crypto_core_hsalsa20_keybytes = ce.asm.nb).apply(null, arguments);
              }, ce._crypto_core_hsalsa20_constbytes = function() {
                return (ce._crypto_core_hsalsa20_constbytes = ce.asm.ob).apply(null, arguments);
              }, ce._crypto_core_salsa20 = function() {
                return (ce._crypto_core_salsa20 = ce.asm.pb).apply(null, arguments);
              }, ce._crypto_core_salsa20_outputbytes = function() {
                return (ce._crypto_core_salsa20_outputbytes = ce.asm.qb).apply(null, arguments);
              }, ce._crypto_core_salsa20_inputbytes = function() {
                return (ce._crypto_core_salsa20_inputbytes = ce.asm.rb).apply(null, arguments);
              }, ce._crypto_core_salsa20_keybytes = function() {
                return (ce._crypto_core_salsa20_keybytes = ce.asm.sb).apply(null, arguments);
              }, ce._crypto_core_salsa20_constbytes = function() {
                return (ce._crypto_core_salsa20_constbytes = ce.asm.tb).apply(null, arguments);
              }, ce._crypto_core_salsa2012 = function() {
                return (ce._crypto_core_salsa2012 = ce.asm.ub).apply(null, arguments);
              }, ce._crypto_core_salsa2012_outputbytes = function() {
                return (ce._crypto_core_salsa2012_outputbytes = ce.asm.vb).apply(null, arguments);
              }, ce._crypto_core_salsa2012_inputbytes = function() {
                return (ce._crypto_core_salsa2012_inputbytes = ce.asm.wb).apply(null, arguments);
              }, ce._crypto_core_salsa2012_keybytes = function() {
                return (ce._crypto_core_salsa2012_keybytes = ce.asm.xb).apply(null, arguments);
              }, ce._crypto_core_salsa2012_constbytes = function() {
                return (ce._crypto_core_salsa2012_constbytes = ce.asm.yb).apply(null, arguments);
              }, ce._crypto_core_salsa208 = function() {
                return (ce._crypto_core_salsa208 = ce.asm.zb).apply(null, arguments);
              }, ce._crypto_core_salsa208_outputbytes = function() {
                return (ce._crypto_core_salsa208_outputbytes = ce.asm.Ab).apply(null, arguments);
              }, ce._crypto_core_salsa208_inputbytes = function() {
                return (ce._crypto_core_salsa208_inputbytes = ce.asm.Bb).apply(null, arguments);
              }, ce._crypto_core_salsa208_keybytes = function() {
                return (ce._crypto_core_salsa208_keybytes = ce.asm.Cb).apply(null, arguments);
              }, ce._crypto_core_salsa208_constbytes = function() {
                return (ce._crypto_core_salsa208_constbytes = ce.asm.Db).apply(null, arguments);
              }, ce._crypto_generichash_bytes_min = function() {
                return (ce._crypto_generichash_bytes_min = ce.asm.Eb).apply(null, arguments);
              }, ce._crypto_generichash_bytes_max = function() {
                return (ce._crypto_generichash_bytes_max = ce.asm.Fb).apply(null, arguments);
              }, ce._crypto_generichash_bytes = function() {
                return (ce._crypto_generichash_bytes = ce.asm.Gb).apply(null, arguments);
              }, ce._crypto_generichash_keybytes_min = function() {
                return (ce._crypto_generichash_keybytes_min = ce.asm.Hb).apply(null, arguments);
              }, ce._crypto_generichash_keybytes_max = function() {
                return (ce._crypto_generichash_keybytes_max = ce.asm.Ib).apply(null, arguments);
              }, ce._crypto_generichash_keybytes = function() {
                return (ce._crypto_generichash_keybytes = ce.asm.Jb).apply(null, arguments);
              }, ce._crypto_generichash_primitive = function() {
                return (ce._crypto_generichash_primitive = ce.asm.Kb).apply(null, arguments);
              }, ce._crypto_generichash_statebytes = function() {
                return (ce._crypto_generichash_statebytes = ce.asm.Lb).apply(null, arguments);
              }, ce._crypto_generichash = function() {
                return (ce._crypto_generichash = ce.asm.Mb).apply(null, arguments);
              }, ce._crypto_generichash_init = function() {
                return (ce._crypto_generichash_init = ce.asm.Nb).apply(null, arguments);
              }, ce._crypto_generichash_update = function() {
                return (ce._crypto_generichash_update = ce.asm.Ob).apply(null, arguments);
              }, ce._crypto_generichash_final = function() {
                return (ce._crypto_generichash_final = ce.asm.Pb).apply(null, arguments);
              }, ce._crypto_generichash_keygen = function() {
                return (ce._crypto_generichash_keygen = ce.asm.Qb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_bytes_min = function() {
                return (ce._crypto_generichash_blake2b_bytes_min = ce.asm.Rb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_bytes_max = function() {
                return (ce._crypto_generichash_blake2b_bytes_max = ce.asm.Sb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_bytes = function() {
                return (ce._crypto_generichash_blake2b_bytes = ce.asm.Tb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_keybytes_min = function() {
                return (ce._crypto_generichash_blake2b_keybytes_min = ce.asm.Ub).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_keybytes_max = function() {
                return (ce._crypto_generichash_blake2b_keybytes_max = ce.asm.Vb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_keybytes = function() {
                return (ce._crypto_generichash_blake2b_keybytes = ce.asm.Wb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_saltbytes = function() {
                return (ce._crypto_generichash_blake2b_saltbytes = ce.asm.Xb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_personalbytes = function() {
                return (ce._crypto_generichash_blake2b_personalbytes = ce.asm.Yb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_statebytes = function() {
                return (ce._crypto_generichash_blake2b_statebytes = ce.asm.Zb).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_keygen = function() {
                return (ce._crypto_generichash_blake2b_keygen = ce.asm._b).apply(null, arguments);
              }, ce._crypto_generichash_blake2b = function() {
                return (ce._crypto_generichash_blake2b = ce.asm.$b).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_salt_personal = function() {
                return (ce._crypto_generichash_blake2b_salt_personal = ce.asm.ac).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_init = function() {
                return (ce._crypto_generichash_blake2b_init = ce.asm.bc).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_init_salt_personal = function() {
                return (ce._crypto_generichash_blake2b_init_salt_personal = ce.asm.cc).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_update = function() {
                return (ce._crypto_generichash_blake2b_update = ce.asm.dc).apply(null, arguments);
              }, ce._crypto_generichash_blake2b_final = function() {
                return (ce._crypto_generichash_blake2b_final = ce.asm.ec).apply(null, arguments);
              }, ce._crypto_hash_bytes = function() {
                return (ce._crypto_hash_bytes = ce.asm.fc).apply(null, arguments);
              }, ce._crypto_hash = function() {
                return (ce._crypto_hash = ce.asm.gc).apply(null, arguments);
              }, ce._crypto_hash_primitive = function() {
                return (ce._crypto_hash_primitive = ce.asm.hc).apply(null, arguments);
              }, ce._crypto_hash_sha256_bytes = function() {
                return (ce._crypto_hash_sha256_bytes = ce.asm.ic).apply(null, arguments);
              }, ce._crypto_hash_sha256_statebytes = function() {
                return (ce._crypto_hash_sha256_statebytes = ce.asm.jc).apply(null, arguments);
              }, ce._crypto_hash_sha256_init = function() {
                return (ce._crypto_hash_sha256_init = ce.asm.kc).apply(null, arguments);
              }, ce._crypto_hash_sha256_update = function() {
                return (ce._crypto_hash_sha256_update = ce.asm.lc).apply(null, arguments);
              }, ce._crypto_hash_sha256_final = function() {
                return (ce._crypto_hash_sha256_final = ce.asm.mc).apply(null, arguments);
              }, ce._crypto_hash_sha256 = function() {
                return (ce._crypto_hash_sha256 = ce.asm.nc).apply(null, arguments);
              }, ce._crypto_hash_sha512_bytes = function() {
                return (ce._crypto_hash_sha512_bytes = ce.asm.oc).apply(null, arguments);
              }, ce._crypto_hash_sha512_statebytes = function() {
                return (ce._crypto_hash_sha512_statebytes = ce.asm.pc).apply(null, arguments);
              }, ce._crypto_hash_sha512_init = function() {
                return (ce._crypto_hash_sha512_init = ce.asm.qc).apply(null, arguments);
              }, ce._crypto_hash_sha512_update = function() {
                return (ce._crypto_hash_sha512_update = ce.asm.rc).apply(null, arguments);
              }, ce._crypto_hash_sha512_final = function() {
                return (ce._crypto_hash_sha512_final = ce.asm.sc).apply(null, arguments);
              }, ce._crypto_hash_sha512 = function() {
                return (ce._crypto_hash_sha512 = ce.asm.tc).apply(null, arguments);
              }, ce._crypto_kdf_blake2b_bytes_min = function() {
                return (ce._crypto_kdf_blake2b_bytes_min = ce.asm.uc).apply(null, arguments);
              }, ce._crypto_kdf_blake2b_bytes_max = function() {
                return (ce._crypto_kdf_blake2b_bytes_max = ce.asm.vc).apply(null, arguments);
              }, ce._crypto_kdf_blake2b_contextbytes = function() {
                return (ce._crypto_kdf_blake2b_contextbytes = ce.asm.wc).apply(null, arguments);
              }, ce._crypto_kdf_blake2b_keybytes = function() {
                return (ce._crypto_kdf_blake2b_keybytes = ce.asm.xc).apply(null, arguments);
              }, ce._crypto_kdf_blake2b_derive_from_key = function() {
                return (ce._crypto_kdf_blake2b_derive_from_key = ce.asm.yc).apply(null, arguments);
              }, ce._crypto_kdf_primitive = function() {
                return (ce._crypto_kdf_primitive = ce.asm.zc).apply(null, arguments);
              }, ce._crypto_kdf_bytes_min = function() {
                return (ce._crypto_kdf_bytes_min = ce.asm.Ac).apply(null, arguments);
              }, ce._crypto_kdf_bytes_max = function() {
                return (ce._crypto_kdf_bytes_max = ce.asm.Bc).apply(null, arguments);
              }, ce._crypto_kdf_contextbytes = function() {
                return (ce._crypto_kdf_contextbytes = ce.asm.Cc).apply(null, arguments);
              }, ce._crypto_kdf_keybytes = function() {
                return (ce._crypto_kdf_keybytes = ce.asm.Dc).apply(null, arguments);
              }, ce._crypto_kdf_derive_from_key = function() {
                return (ce._crypto_kdf_derive_from_key = ce.asm.Ec).apply(null, arguments);
              }, ce._crypto_kdf_keygen = function() {
                return (ce._crypto_kdf_keygen = ce.asm.Fc).apply(null, arguments);
              }, ce._crypto_kx_seed_keypair = function() {
                return (ce._crypto_kx_seed_keypair = ce.asm.Gc).apply(null, arguments);
              }, ce._crypto_kx_keypair = function() {
                return (ce._crypto_kx_keypair = ce.asm.Hc).apply(null, arguments);
              }, ce._crypto_kx_client_session_keys = function() {
                return (ce._crypto_kx_client_session_keys = ce.asm.Ic).apply(null, arguments);
              }, ce._crypto_kx_server_session_keys = function() {
                return (ce._crypto_kx_server_session_keys = ce.asm.Jc).apply(null, arguments);
              }, ce._crypto_kx_publickeybytes = function() {
                return (ce._crypto_kx_publickeybytes = ce.asm.Kc).apply(null, arguments);
              }, ce._crypto_kx_secretkeybytes = function() {
                return (ce._crypto_kx_secretkeybytes = ce.asm.Lc).apply(null, arguments);
              }, ce._crypto_kx_seedbytes = function() {
                return (ce._crypto_kx_seedbytes = ce.asm.Mc).apply(null, arguments);
              }, ce._crypto_kx_sessionkeybytes = function() {
                return (ce._crypto_kx_sessionkeybytes = ce.asm.Nc).apply(null, arguments);
              }, ce._crypto_kx_primitive = function() {
                return (ce._crypto_kx_primitive = ce.asm.Oc).apply(null, arguments);
              }, ce._crypto_onetimeauth_statebytes = function() {
                return (ce._crypto_onetimeauth_statebytes = ce.asm.Pc).apply(null, arguments);
              }, ce._crypto_onetimeauth_bytes = function() {
                return (ce._crypto_onetimeauth_bytes = ce.asm.Qc).apply(null, arguments);
              }, ce._crypto_onetimeauth_keybytes = function() {
                return (ce._crypto_onetimeauth_keybytes = ce.asm.Rc).apply(null, arguments);
              }, ce._crypto_onetimeauth = function() {
                return (ce._crypto_onetimeauth = ce.asm.Sc).apply(null, arguments);
              }, ce._crypto_onetimeauth_verify = function() {
                return (ce._crypto_onetimeauth_verify = ce.asm.Tc).apply(null, arguments);
              }, ce._crypto_onetimeauth_init = function() {
                return (ce._crypto_onetimeauth_init = ce.asm.Uc).apply(null, arguments);
              }, ce._crypto_onetimeauth_update = function() {
                return (ce._crypto_onetimeauth_update = ce.asm.Vc).apply(null, arguments);
              }, ce._crypto_onetimeauth_final = function() {
                return (ce._crypto_onetimeauth_final = ce.asm.Wc).apply(null, arguments);
              }, ce._crypto_onetimeauth_primitive = function() {
                return (ce._crypto_onetimeauth_primitive = ce.asm.Xc).apply(null, arguments);
              }, ce._crypto_onetimeauth_keygen = function() {
                return (ce._crypto_onetimeauth_keygen = ce.asm.Yc).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305 = function() {
                return (ce._crypto_onetimeauth_poly1305 = ce.asm.Zc).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305_verify = function() {
                return (ce._crypto_onetimeauth_poly1305_verify = ce.asm._c).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305_init = function() {
                return (ce._crypto_onetimeauth_poly1305_init = ce.asm.$c).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305_update = function() {
                return (ce._crypto_onetimeauth_poly1305_update = ce.asm.ad).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305_final = function() {
                return (ce._crypto_onetimeauth_poly1305_final = ce.asm.bd).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305_bytes = function() {
                return (ce._crypto_onetimeauth_poly1305_bytes = ce.asm.cd).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305_keybytes = function() {
                return (ce._crypto_onetimeauth_poly1305_keybytes = ce.asm.dd).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305_statebytes = function() {
                return (ce._crypto_onetimeauth_poly1305_statebytes = ce.asm.ed).apply(null, arguments);
              }, ce._crypto_onetimeauth_poly1305_keygen = function() {
                return (ce._crypto_onetimeauth_poly1305_keygen = ce.asm.fd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_alg_argon2i13 = function() {
                return (ce._crypto_pwhash_argon2i_alg_argon2i13 = ce.asm.gd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_bytes_min = function() {
                return (ce._crypto_pwhash_argon2i_bytes_min = ce.asm.hd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_bytes_max = function() {
                return (ce._crypto_pwhash_argon2i_bytes_max = ce.asm.id).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_passwd_min = function() {
                return (ce._crypto_pwhash_argon2i_passwd_min = ce.asm.jd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_passwd_max = function() {
                return (ce._crypto_pwhash_argon2i_passwd_max = ce.asm.kd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_saltbytes = function() {
                return (ce._crypto_pwhash_argon2i_saltbytes = ce.asm.ld).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_strbytes = function() {
                return (ce._crypto_pwhash_argon2i_strbytes = ce.asm.md).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_strprefix = function() {
                return (ce._crypto_pwhash_argon2i_strprefix = ce.asm.nd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_opslimit_min = function() {
                return (ce._crypto_pwhash_argon2i_opslimit_min = ce.asm.od).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_opslimit_max = function() {
                return (ce._crypto_pwhash_argon2i_opslimit_max = ce.asm.pd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_memlimit_min = function() {
                return (ce._crypto_pwhash_argon2i_memlimit_min = ce.asm.qd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_memlimit_max = function() {
                return (ce._crypto_pwhash_argon2i_memlimit_max = ce.asm.rd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_opslimit_interactive = function() {
                return (ce._crypto_pwhash_argon2i_opslimit_interactive = ce.asm.sd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_memlimit_interactive = function() {
                return (ce._crypto_pwhash_argon2i_memlimit_interactive = ce.asm.td).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_opslimit_moderate = function() {
                return (ce._crypto_pwhash_argon2i_opslimit_moderate = ce.asm.ud).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_memlimit_moderate = function() {
                return (ce._crypto_pwhash_argon2i_memlimit_moderate = ce.asm.vd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_opslimit_sensitive = function() {
                return (ce._crypto_pwhash_argon2i_opslimit_sensitive = ce.asm.wd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_memlimit_sensitive = function() {
                return (ce._crypto_pwhash_argon2i_memlimit_sensitive = ce.asm.xd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i = function() {
                return (ce._crypto_pwhash_argon2i = ce.asm.yd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_str = function() {
                return (ce._crypto_pwhash_argon2i_str = ce.asm.zd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_str_verify = function() {
                return (ce._crypto_pwhash_argon2i_str_verify = ce.asm.Ad).apply(null, arguments);
              }, ce._crypto_pwhash_argon2i_str_needs_rehash = function() {
                return (ce._crypto_pwhash_argon2i_str_needs_rehash = ce.asm.Bd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_str_needs_rehash = function() {
                return (ce._crypto_pwhash_argon2id_str_needs_rehash = ce.asm.Cd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_alg_argon2id13 = function() {
                return (ce._crypto_pwhash_argon2id_alg_argon2id13 = ce.asm.Dd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_bytes_min = function() {
                return (ce._crypto_pwhash_argon2id_bytes_min = ce.asm.Ed).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_bytes_max = function() {
                return (ce._crypto_pwhash_argon2id_bytes_max = ce.asm.Fd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_passwd_min = function() {
                return (ce._crypto_pwhash_argon2id_passwd_min = ce.asm.Gd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_passwd_max = function() {
                return (ce._crypto_pwhash_argon2id_passwd_max = ce.asm.Hd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_saltbytes = function() {
                return (ce._crypto_pwhash_argon2id_saltbytes = ce.asm.Id).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_strbytes = function() {
                return (ce._crypto_pwhash_argon2id_strbytes = ce.asm.Jd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_strprefix = function() {
                return (ce._crypto_pwhash_argon2id_strprefix = ce.asm.Kd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_opslimit_min = function() {
                return (ce._crypto_pwhash_argon2id_opslimit_min = ce.asm.Ld).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_opslimit_max = function() {
                return (ce._crypto_pwhash_argon2id_opslimit_max = ce.asm.Md).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_memlimit_min = function() {
                return (ce._crypto_pwhash_argon2id_memlimit_min = ce.asm.Nd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_memlimit_max = function() {
                return (ce._crypto_pwhash_argon2id_memlimit_max = ce.asm.Od).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_opslimit_interactive = function() {
                return (ce._crypto_pwhash_argon2id_opslimit_interactive = ce.asm.Pd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_memlimit_interactive = function() {
                return (ce._crypto_pwhash_argon2id_memlimit_interactive = ce.asm.Qd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_opslimit_moderate = function() {
                return (ce._crypto_pwhash_argon2id_opslimit_moderate = ce.asm.Rd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_memlimit_moderate = function() {
                return (ce._crypto_pwhash_argon2id_memlimit_moderate = ce.asm.Sd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_opslimit_sensitive = function() {
                return (ce._crypto_pwhash_argon2id_opslimit_sensitive = ce.asm.Td).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_memlimit_sensitive = function() {
                return (ce._crypto_pwhash_argon2id_memlimit_sensitive = ce.asm.Ud).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id = function() {
                return (ce._crypto_pwhash_argon2id = ce.asm.Vd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_str = function() {
                return (ce._crypto_pwhash_argon2id_str = ce.asm.Wd).apply(null, arguments);
              }, ce._crypto_pwhash_argon2id_str_verify = function() {
                return (ce._crypto_pwhash_argon2id_str_verify = ce.asm.Xd).apply(null, arguments);
              }, ce._crypto_pwhash_alg_argon2i13 = function() {
                return (ce._crypto_pwhash_alg_argon2i13 = ce.asm.Yd).apply(null, arguments);
              }, ce._crypto_pwhash_alg_argon2id13 = function() {
                return (ce._crypto_pwhash_alg_argon2id13 = ce.asm.Zd).apply(null, arguments);
              }, ce._crypto_pwhash_alg_default = function() {
                return (ce._crypto_pwhash_alg_default = ce.asm._d).apply(null, arguments);
              }, ce._crypto_pwhash_bytes_min = function() {
                return (ce._crypto_pwhash_bytes_min = ce.asm.$d).apply(null, arguments);
              }, ce._crypto_pwhash_bytes_max = function() {
                return (ce._crypto_pwhash_bytes_max = ce.asm.ae).apply(null, arguments);
              }, ce._crypto_pwhash_passwd_min = function() {
                return (ce._crypto_pwhash_passwd_min = ce.asm.be).apply(null, arguments);
              }, ce._crypto_pwhash_passwd_max = function() {
                return (ce._crypto_pwhash_passwd_max = ce.asm.ce).apply(null, arguments);
              }, ce._crypto_pwhash_saltbytes = function() {
                return (ce._crypto_pwhash_saltbytes = ce.asm.de).apply(null, arguments);
              }, ce._crypto_pwhash_strbytes = function() {
                return (ce._crypto_pwhash_strbytes = ce.asm.ee).apply(null, arguments);
              }, ce._crypto_pwhash_strprefix = function() {
                return (ce._crypto_pwhash_strprefix = ce.asm.fe).apply(null, arguments);
              }, ce._crypto_pwhash_opslimit_min = function() {
                return (ce._crypto_pwhash_opslimit_min = ce.asm.ge).apply(null, arguments);
              }, ce._crypto_pwhash_opslimit_max = function() {
                return (ce._crypto_pwhash_opslimit_max = ce.asm.he).apply(null, arguments);
              }, ce._crypto_pwhash_memlimit_min = function() {
                return (ce._crypto_pwhash_memlimit_min = ce.asm.ie).apply(null, arguments);
              }, ce._crypto_pwhash_memlimit_max = function() {
                return (ce._crypto_pwhash_memlimit_max = ce.asm.je).apply(null, arguments);
              }, ce._crypto_pwhash_opslimit_interactive = function() {
                return (ce._crypto_pwhash_opslimit_interactive = ce.asm.ke).apply(null, arguments);
              }, ce._crypto_pwhash_memlimit_interactive = function() {
                return (ce._crypto_pwhash_memlimit_interactive = ce.asm.le).apply(null, arguments);
              }, ce._crypto_pwhash_opslimit_moderate = function() {
                return (ce._crypto_pwhash_opslimit_moderate = ce.asm.me).apply(null, arguments);
              }, ce._crypto_pwhash_memlimit_moderate = function() {
                return (ce._crypto_pwhash_memlimit_moderate = ce.asm.ne).apply(null, arguments);
              }, ce._crypto_pwhash_opslimit_sensitive = function() {
                return (ce._crypto_pwhash_opslimit_sensitive = ce.asm.oe).apply(null, arguments);
              }, ce._crypto_pwhash_memlimit_sensitive = function() {
                return (ce._crypto_pwhash_memlimit_sensitive = ce.asm.pe).apply(null, arguments);
              }, ce._crypto_pwhash = function() {
                return (ce._crypto_pwhash = ce.asm.qe).apply(null, arguments);
              }, ce._crypto_pwhash_str = function() {
                return (ce._crypto_pwhash_str = ce.asm.re).apply(null, arguments);
              }, ce._crypto_pwhash_str_alg = function() {
                return (ce._crypto_pwhash_str_alg = ce.asm.se).apply(null, arguments);
              }, ce._crypto_pwhash_str_verify = function() {
                return (ce._crypto_pwhash_str_verify = ce.asm.te).apply(null, arguments);
              }, ce._crypto_pwhash_str_needs_rehash = function() {
                return (ce._crypto_pwhash_str_needs_rehash = ce.asm.ue).apply(null, arguments);
              }, ce._crypto_pwhash_primitive = function() {
                return (ce._crypto_pwhash_primitive = ce.asm.ve).apply(null, arguments);
              }, ce._crypto_scalarmult_primitive = function() {
                return (ce._crypto_scalarmult_primitive = ce.asm.we).apply(null, arguments);
              }, ce._crypto_scalarmult_base = function() {
                return (ce._crypto_scalarmult_base = ce.asm.xe).apply(null, arguments);
              }, ce._crypto_scalarmult = function() {
                return (ce._crypto_scalarmult = ce.asm.ye).apply(null, arguments);
              }, ce._crypto_scalarmult_bytes = function() {
                return (ce._crypto_scalarmult_bytes = ce.asm.ze).apply(null, arguments);
              }, ce._crypto_scalarmult_scalarbytes = function() {
                return (ce._crypto_scalarmult_scalarbytes = ce.asm.Ae).apply(null, arguments);
              }, ce._crypto_scalarmult_curve25519 = function() {
                return (ce._crypto_scalarmult_curve25519 = ce.asm.Be).apply(null, arguments);
              }, ce._crypto_scalarmult_curve25519_base = function() {
                return (ce._crypto_scalarmult_curve25519_base = ce.asm.Ce).apply(null, arguments);
              }, ce._crypto_scalarmult_curve25519_bytes = function() {
                return (ce._crypto_scalarmult_curve25519_bytes = ce.asm.De).apply(null, arguments);
              }, ce._crypto_scalarmult_curve25519_scalarbytes = function() {
                return (ce._crypto_scalarmult_curve25519_scalarbytes = ce.asm.Ee).apply(null, arguments);
              }, ce._crypto_secretbox_keybytes = function() {
                return (ce._crypto_secretbox_keybytes = ce.asm.Fe).apply(null, arguments);
              }, ce._crypto_secretbox_noncebytes = function() {
                return (ce._crypto_secretbox_noncebytes = ce.asm.Ge).apply(null, arguments);
              }, ce._crypto_secretbox_zerobytes = function() {
                return (ce._crypto_secretbox_zerobytes = ce.asm.He).apply(null, arguments);
              }, ce._crypto_secretbox_boxzerobytes = function() {
                return (ce._crypto_secretbox_boxzerobytes = ce.asm.Ie).apply(null, arguments);
              }, ce._crypto_secretbox_macbytes = function() {
                return (ce._crypto_secretbox_macbytes = ce.asm.Je).apply(null, arguments);
              }, ce._crypto_secretbox_messagebytes_max = function() {
                return (ce._crypto_secretbox_messagebytes_max = ce.asm.Ke).apply(null, arguments);
              }, ce._crypto_secretbox_primitive = function() {
                return (ce._crypto_secretbox_primitive = ce.asm.Le).apply(null, arguments);
              }, ce._crypto_secretbox = function() {
                return (ce._crypto_secretbox = ce.asm.Me).apply(null, arguments);
              }, ce._crypto_secretbox_open = function() {
                return (ce._crypto_secretbox_open = ce.asm.Ne).apply(null, arguments);
              }, ce._crypto_secretbox_keygen = function() {
                return (ce._crypto_secretbox_keygen = ce.asm.Oe).apply(null, arguments);
              }, ce._crypto_secretbox_detached = function() {
                return (ce._crypto_secretbox_detached = ce.asm.Pe).apply(null, arguments);
              }, ce._crypto_secretbox_easy = function() {
                return (ce._crypto_secretbox_easy = ce.asm.Qe).apply(null, arguments);
              }, ce._crypto_secretbox_open_detached = function() {
                return (ce._crypto_secretbox_open_detached = ce.asm.Re).apply(null, arguments);
              }, ce._crypto_secretbox_open_easy = function() {
                return (ce._crypto_secretbox_open_easy = ce.asm.Se).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305 = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305 = ce.asm.Te).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305_open = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305_open = ce.asm.Ue).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305_keybytes = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305_keybytes = ce.asm.Ve).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305_noncebytes = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305_noncebytes = ce.asm.We).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305_zerobytes = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305_zerobytes = ce.asm.Xe).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305_boxzerobytes = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305_boxzerobytes = ce.asm.Ye).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305_macbytes = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305_macbytes = ce.asm.Ze).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305_messagebytes_max = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305_messagebytes_max = ce.asm._e).apply(null, arguments);
              }, ce._crypto_secretbox_xsalsa20poly1305_keygen = function() {
                return (ce._crypto_secretbox_xsalsa20poly1305_keygen = ce.asm.$e).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_keygen = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_keygen = ce.asm.af).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_init_push = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_init_push = ce.asm.bf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_init_pull = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_init_pull = ce.asm.cf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_rekey = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_rekey = ce.asm.df).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_push = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_push = ce.asm.ef).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_pull = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_pull = ce.asm.ff).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_statebytes = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_statebytes = ce.asm.gf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_abytes = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_abytes = ce.asm.hf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_headerbytes = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_headerbytes = ce.asm.jf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_keybytes = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_keybytes = ce.asm.kf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_messagebytes_max = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_messagebytes_max = ce.asm.lf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_tag_message = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_tag_message = ce.asm.mf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_tag_push = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_tag_push = ce.asm.nf).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_tag_rekey = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_tag_rekey = ce.asm.of).apply(null, arguments);
              }, ce._crypto_secretstream_xchacha20poly1305_tag_final = function() {
                return (ce._crypto_secretstream_xchacha20poly1305_tag_final = ce.asm.pf).apply(null, arguments);
              }, ce._crypto_shorthash_bytes = function() {
                return (ce._crypto_shorthash_bytes = ce.asm.qf).apply(null, arguments);
              }, ce._crypto_shorthash_keybytes = function() {
                return (ce._crypto_shorthash_keybytes = ce.asm.rf).apply(null, arguments);
              }, ce._crypto_shorthash_primitive = function() {
                return (ce._crypto_shorthash_primitive = ce.asm.sf).apply(null, arguments);
              }, ce._crypto_shorthash = function() {
                return (ce._crypto_shorthash = ce.asm.tf).apply(null, arguments);
              }, ce._crypto_shorthash_keygen = function() {
                return (ce._crypto_shorthash_keygen = ce.asm.uf).apply(null, arguments);
              }, ce._crypto_shorthash_siphash24_bytes = function() {
                return (ce._crypto_shorthash_siphash24_bytes = ce.asm.vf).apply(null, arguments);
              }, ce._crypto_shorthash_siphash24_keybytes = function() {
                return (ce._crypto_shorthash_siphash24_keybytes = ce.asm.wf).apply(null, arguments);
              }, ce._crypto_shorthash_siphash24 = function() {
                return (ce._crypto_shorthash_siphash24 = ce.asm.xf).apply(null, arguments);
              }, ce._crypto_sign_statebytes = function() {
                return (ce._crypto_sign_statebytes = ce.asm.yf).apply(null, arguments);
              }, ce._crypto_sign_bytes = function() {
                return (ce._crypto_sign_bytes = ce.asm.zf).apply(null, arguments);
              }, ce._crypto_sign_seedbytes = function() {
                return (ce._crypto_sign_seedbytes = ce.asm.Af).apply(null, arguments);
              }, ce._crypto_sign_publickeybytes = function() {
                return (ce._crypto_sign_publickeybytes = ce.asm.Bf).apply(null, arguments);
              }, ce._crypto_sign_secretkeybytes = function() {
                return (ce._crypto_sign_secretkeybytes = ce.asm.Cf).apply(null, arguments);
              }, ce._crypto_sign_messagebytes_max = function() {
                return (ce._crypto_sign_messagebytes_max = ce.asm.Df).apply(null, arguments);
              }, ce._crypto_sign_primitive = function() {
                return (ce._crypto_sign_primitive = ce.asm.Ef).apply(null, arguments);
              }, ce._crypto_sign_seed_keypair = function() {
                return (ce._crypto_sign_seed_keypair = ce.asm.Ff).apply(null, arguments);
              }, ce._crypto_sign_keypair = function() {
                return (ce._crypto_sign_keypair = ce.asm.Gf).apply(null, arguments);
              }, ce._crypto_sign = function() {
                return (ce._crypto_sign = ce.asm.Hf).apply(null, arguments);
              }, ce._crypto_sign_open = function() {
                return (ce._crypto_sign_open = ce.asm.If).apply(null, arguments);
              }, ce._crypto_sign_detached = function() {
                return (ce._crypto_sign_detached = ce.asm.Jf).apply(null, arguments);
              }, ce._crypto_sign_verify_detached = function() {
                return (ce._crypto_sign_verify_detached = ce.asm.Kf).apply(null, arguments);
              }, ce._crypto_sign_init = function() {
                return (ce._crypto_sign_init = ce.asm.Lf).apply(null, arguments);
              }, ce._crypto_sign_update = function() {
                return (ce._crypto_sign_update = ce.asm.Mf).apply(null, arguments);
              }, ce._crypto_sign_final_create = function() {
                return (ce._crypto_sign_final_create = ce.asm.Nf).apply(null, arguments);
              }, ce._crypto_sign_final_verify = function() {
                return (ce._crypto_sign_final_verify = ce.asm.Of).apply(null, arguments);
              }, ce._crypto_sign_ed25519ph_statebytes = function() {
                return (ce._crypto_sign_ed25519ph_statebytes = ce.asm.Pf).apply(null, arguments);
              }, ce._crypto_sign_ed25519_bytes = function() {
                return (ce._crypto_sign_ed25519_bytes = ce.asm.Qf).apply(null, arguments);
              }, ce._crypto_sign_ed25519_seedbytes = function() {
                return (ce._crypto_sign_ed25519_seedbytes = ce.asm.Rf).apply(null, arguments);
              }, ce._crypto_sign_ed25519_publickeybytes = function() {
                return (ce._crypto_sign_ed25519_publickeybytes = ce.asm.Sf).apply(null, arguments);
              }, ce._crypto_sign_ed25519_secretkeybytes = function() {
                return (ce._crypto_sign_ed25519_secretkeybytes = ce.asm.Tf).apply(null, arguments);
              }, ce._crypto_sign_ed25519_messagebytes_max = function() {
                return (ce._crypto_sign_ed25519_messagebytes_max = ce.asm.Uf).apply(null, arguments);
              }, ce._crypto_sign_ed25519_sk_to_seed = function() {
                return (ce._crypto_sign_ed25519_sk_to_seed = ce.asm.Vf).apply(null, arguments);
              }, ce._crypto_sign_ed25519_sk_to_pk = function() {
                return (ce._crypto_sign_ed25519_sk_to_pk = ce.asm.Wf).apply(null, arguments);
              }, ce._crypto_sign_ed25519ph_init = function() {
                return (ce._crypto_sign_ed25519ph_init = ce.asm.Xf).apply(null, arguments);
              }, ce._crypto_sign_ed25519ph_update = function() {
                return (ce._crypto_sign_ed25519ph_update = ce.asm.Yf).apply(null, arguments);
              }, ce._crypto_sign_ed25519ph_final_create = function() {
                return (ce._crypto_sign_ed25519ph_final_create = ce.asm.Zf).apply(null, arguments);
              }, ce._crypto_sign_ed25519ph_final_verify = function() {
                return (ce._crypto_sign_ed25519ph_final_verify = ce.asm._f).apply(null, arguments);
              }, ce._crypto_sign_ed25519_seed_keypair = function() {
                return (ce._crypto_sign_ed25519_seed_keypair = ce.asm.$f).apply(null, arguments);
              }, ce._crypto_sign_ed25519_keypair = function() {
                return (ce._crypto_sign_ed25519_keypair = ce.asm.ag).apply(null, arguments);
              }, ce._crypto_sign_ed25519_pk_to_curve25519 = function() {
                return (ce._crypto_sign_ed25519_pk_to_curve25519 = ce.asm.bg).apply(null, arguments);
              }, ce._crypto_sign_ed25519_sk_to_curve25519 = function() {
                return (ce._crypto_sign_ed25519_sk_to_curve25519 = ce.asm.cg).apply(null, arguments);
              }, ce._crypto_sign_ed25519_verify_detached = function() {
                return (ce._crypto_sign_ed25519_verify_detached = ce.asm.dg).apply(null, arguments);
              }, ce._crypto_sign_ed25519_open = function() {
                return (ce._crypto_sign_ed25519_open = ce.asm.eg).apply(null, arguments);
              }, ce._crypto_sign_ed25519_detached = function() {
                return (ce._crypto_sign_ed25519_detached = ce.asm.fg).apply(null, arguments);
              }, ce._crypto_sign_ed25519 = function() {
                return (ce._crypto_sign_ed25519 = ce.asm.gg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_keybytes = function() {
                return (ce._crypto_stream_chacha20_keybytes = ce.asm.hg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_noncebytes = function() {
                return (ce._crypto_stream_chacha20_noncebytes = ce.asm.ig).apply(null, arguments);
              }, ce._crypto_stream_chacha20_messagebytes_max = function() {
                return (ce._crypto_stream_chacha20_messagebytes_max = ce.asm.jg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_ietf_keybytes = function() {
                return (ce._crypto_stream_chacha20_ietf_keybytes = ce.asm.kg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_ietf_noncebytes = function() {
                return (ce._crypto_stream_chacha20_ietf_noncebytes = ce.asm.lg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_ietf_messagebytes_max = function() {
                return (ce._crypto_stream_chacha20_ietf_messagebytes_max = ce.asm.mg).apply(null, arguments);
              }, ce._crypto_stream_chacha20 = function() {
                return (ce._crypto_stream_chacha20 = ce.asm.ng).apply(null, arguments);
              }, ce._crypto_stream_chacha20_xor_ic = function() {
                return (ce._crypto_stream_chacha20_xor_ic = ce.asm.og).apply(null, arguments);
              }, ce._crypto_stream_chacha20_xor = function() {
                return (ce._crypto_stream_chacha20_xor = ce.asm.pg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_ietf = function() {
                return (ce._crypto_stream_chacha20_ietf = ce.asm.qg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_ietf_xor_ic = function() {
                return (ce._crypto_stream_chacha20_ietf_xor_ic = ce.asm.rg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_ietf_xor = function() {
                return (ce._crypto_stream_chacha20_ietf_xor = ce.asm.sg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_ietf_keygen = function() {
                return (ce._crypto_stream_chacha20_ietf_keygen = ce.asm.tg).apply(null, arguments);
              }, ce._crypto_stream_chacha20_keygen = function() {
                return (ce._crypto_stream_chacha20_keygen = ce.asm.ug).apply(null, arguments);
              }, ce._crypto_stream_keybytes = function() {
                return (ce._crypto_stream_keybytes = ce.asm.vg).apply(null, arguments);
              }, ce._crypto_stream_noncebytes = function() {
                return (ce._crypto_stream_noncebytes = ce.asm.wg).apply(null, arguments);
              }, ce._crypto_stream_messagebytes_max = function() {
                return (ce._crypto_stream_messagebytes_max = ce.asm.xg).apply(null, arguments);
              }, ce._crypto_stream_primitive = function() {
                return (ce._crypto_stream_primitive = ce.asm.yg).apply(null, arguments);
              }, ce._crypto_stream = function() {
                return (ce._crypto_stream = ce.asm.zg).apply(null, arguments);
              }, ce._crypto_stream_xor = function() {
                return (ce._crypto_stream_xor = ce.asm.Ag).apply(null, arguments);
              }, ce._crypto_stream_keygen = function() {
                return (ce._crypto_stream_keygen = ce.asm.Bg).apply(null, arguments);
              }, ce._crypto_stream_salsa20_keybytes = function() {
                return (ce._crypto_stream_salsa20_keybytes = ce.asm.Cg).apply(null, arguments);
              }, ce._crypto_stream_salsa20_noncebytes = function() {
                return (ce._crypto_stream_salsa20_noncebytes = ce.asm.Dg).apply(null, arguments);
              }, ce._crypto_stream_salsa20_messagebytes_max = function() {
                return (ce._crypto_stream_salsa20_messagebytes_max = ce.asm.Eg).apply(null, arguments);
              }, ce._crypto_stream_salsa20 = function() {
                return (ce._crypto_stream_salsa20 = ce.asm.Fg).apply(null, arguments);
              }, ce._crypto_stream_salsa20_xor_ic = function() {
                return (ce._crypto_stream_salsa20_xor_ic = ce.asm.Gg).apply(null, arguments);
              }, ce._crypto_stream_salsa20_xor = function() {
                return (ce._crypto_stream_salsa20_xor = ce.asm.Hg).apply(null, arguments);
              }, ce._crypto_stream_salsa20_keygen = function() {
                return (ce._crypto_stream_salsa20_keygen = ce.asm.Ig).apply(null, arguments);
              }, ce._crypto_stream_xsalsa20 = function() {
                return (ce._crypto_stream_xsalsa20 = ce.asm.Jg).apply(null, arguments);
              }, ce._crypto_stream_xsalsa20_xor_ic = function() {
                return (ce._crypto_stream_xsalsa20_xor_ic = ce.asm.Kg).apply(null, arguments);
              }, ce._crypto_stream_xsalsa20_xor = function() {
                return (ce._crypto_stream_xsalsa20_xor = ce.asm.Lg).apply(null, arguments);
              }, ce._crypto_stream_xsalsa20_keybytes = function() {
                return (ce._crypto_stream_xsalsa20_keybytes = ce.asm.Mg).apply(null, arguments);
              }, ce._crypto_stream_xsalsa20_noncebytes = function() {
                return (ce._crypto_stream_xsalsa20_noncebytes = ce.asm.Ng).apply(null, arguments);
              }, ce._crypto_stream_xsalsa20_messagebytes_max = function() {
                return (ce._crypto_stream_xsalsa20_messagebytes_max = ce.asm.Og).apply(null, arguments);
              }, ce._crypto_stream_xsalsa20_keygen = function() {
                return (ce._crypto_stream_xsalsa20_keygen = ce.asm.Pg).apply(null, arguments);
              }, ce._crypto_verify_16_bytes = function() {
                return (ce._crypto_verify_16_bytes = ce.asm.Qg).apply(null, arguments);
              }, ce._crypto_verify_32_bytes = function() {
                return (ce._crypto_verify_32_bytes = ce.asm.Rg).apply(null, arguments);
              }, ce._crypto_verify_64_bytes = function() {
                return (ce._crypto_verify_64_bytes = ce.asm.Sg).apply(null, arguments);
              }, ce._crypto_verify_16 = function() {
                return (ce._crypto_verify_16 = ce.asm.Tg).apply(null, arguments);
              }, ce._crypto_verify_32 = function() {
                return (ce._crypto_verify_32 = ce.asm.Ug).apply(null, arguments);
              }, ce._crypto_verify_64 = function() {
                return (ce._crypto_verify_64 = ce.asm.Vg).apply(null, arguments);
              }, ce._randombytes_implementation_name = function() {
                return (ce._randombytes_implementation_name = ce.asm.Wg).apply(null, arguments);
              }, ce._randombytes_random = function() {
                return (ce._randombytes_random = ce.asm.Xg).apply(null, arguments);
              }, ce._randombytes_stir = function() {
                return (ce._randombytes_stir = ce.asm.Yg).apply(null, arguments);
              }, ce._randombytes_uniform = function() {
                return (ce._randombytes_uniform = ce.asm.Zg).apply(null, arguments);
              }, ce._randombytes_buf = function() {
                return (ce._randombytes_buf = ce.asm._g).apply(null, arguments);
              }, ce._randombytes_buf_deterministic = function() {
                return (ce._randombytes_buf_deterministic = ce.asm.$g).apply(null, arguments);
              }, ce._randombytes_seedbytes = function() {
                return (ce._randombytes_seedbytes = ce.asm.ah).apply(null, arguments);
              }, ce._randombytes_close = function() {
                return (ce._randombytes_close = ce.asm.bh).apply(null, arguments);
              }, ce._randombytes = function() {
                return (ce._randombytes = ce.asm.ch).apply(null, arguments);
              }, ce._sodium_bin2hex = function() {
                return (ce._sodium_bin2hex = ce.asm.dh).apply(null, arguments);
              }, ce._sodium_hex2bin = function() {
                return (ce._sodium_hex2bin = ce.asm.eh).apply(null, arguments);
              }, ce._sodium_base64_encoded_len = function() {
                return (ce._sodium_base64_encoded_len = ce.asm.fh).apply(null, arguments);
              }, ce._sodium_bin2base64 = function() {
                return (ce._sodium_bin2base64 = ce.asm.gh).apply(null, arguments);
              }, ce._sodium_base642bin = function() {
                return (ce._sodium_base642bin = ce.asm.hh).apply(null, arguments);
              }, ce._sodium_init = function() {
                return (ce._sodium_init = ce.asm.ih).apply(null, arguments);
              }, ce._sodium_pad = function() {
                return (ce._sodium_pad = ce.asm.jh).apply(null, arguments);
              }, ce._sodium_unpad = function() {
                return (ce._sodium_unpad = ce.asm.kh).apply(null, arguments);
              }, ce._sodium_version_string = function() {
                return (ce._sodium_version_string = ce.asm.lh).apply(null, arguments);
              }, ce._sodium_library_version_major = function() {
                return (ce._sodium_library_version_major = ce.asm.mh).apply(null, arguments);
              }, ce._sodium_library_version_minor = function() {
                return (ce._sodium_library_version_minor = ce.asm.nh).apply(null, arguments);
              }, ce._sodium_library_minimal = function() {
                return (ce._sodium_library_minimal = ce.asm.oh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_seed_keypair = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_seed_keypair = ce.asm.ph).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_keypair = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_keypair = ce.asm.qh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_beforenm = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_beforenm = ce.asm.rh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_detached_afternm = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_detached_afternm = ce.asm.sh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_detached = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_detached = ce.asm.th).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_easy_afternm = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_easy_afternm = ce.asm.uh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_easy = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_easy = ce.asm.vh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = ce.asm.wh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_open_detached = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_open_detached = ce.asm.xh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = ce.asm.yh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_open_easy = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_open_easy = ce.asm.zh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_seedbytes = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_seedbytes = ce.asm.Ah).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_publickeybytes = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_publickeybytes = ce.asm.Bh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_secretkeybytes = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_secretkeybytes = ce.asm.Ch).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_beforenmbytes = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_beforenmbytes = ce.asm.Dh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_noncebytes = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_noncebytes = ce.asm.Eh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_macbytes = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_macbytes = ce.asm.Fh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_messagebytes_max = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_messagebytes_max = ce.asm.Gh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_seal = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_seal = ce.asm.Hh).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_seal_open = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_seal_open = ce.asm.Ih).apply(null, arguments);
              }, ce._crypto_box_curve25519xchacha20poly1305_sealbytes = function() {
                return (ce._crypto_box_curve25519xchacha20poly1305_sealbytes = ce.asm.Jh).apply(null, arguments);
              }, ce._crypto_core_ed25519_is_valid_point = function() {
                return (ce._crypto_core_ed25519_is_valid_point = ce.asm.Kh).apply(null, arguments);
              }, ce._crypto_core_ed25519_add = function() {
                return (ce._crypto_core_ed25519_add = ce.asm.Lh).apply(null, arguments);
              }, ce._crypto_core_ed25519_sub = function() {
                return (ce._crypto_core_ed25519_sub = ce.asm.Mh).apply(null, arguments);
              }, ce._crypto_core_ed25519_from_uniform = function() {
                return (ce._crypto_core_ed25519_from_uniform = ce.asm.Nh).apply(null, arguments);
              }, ce._crypto_core_ed25519_from_hash = function() {
                return (ce._crypto_core_ed25519_from_hash = ce.asm.Oh).apply(null, arguments);
              }, ce._crypto_core_ed25519_random = function() {
                return (ce._crypto_core_ed25519_random = ce.asm.Ph).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalar_random = function() {
                return (ce._crypto_core_ed25519_scalar_random = ce.asm.Qh).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalar_invert = function() {
                return (ce._crypto_core_ed25519_scalar_invert = ce.asm.Rh).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalar_negate = function() {
                return (ce._crypto_core_ed25519_scalar_negate = ce.asm.Sh).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalar_complement = function() {
                return (ce._crypto_core_ed25519_scalar_complement = ce.asm.Th).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalar_add = function() {
                return (ce._crypto_core_ed25519_scalar_add = ce.asm.Uh).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalar_reduce = function() {
                return (ce._crypto_core_ed25519_scalar_reduce = ce.asm.Vh).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalar_sub = function() {
                return (ce._crypto_core_ed25519_scalar_sub = ce.asm.Wh).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalar_mul = function() {
                return (ce._crypto_core_ed25519_scalar_mul = ce.asm.Xh).apply(null, arguments);
              }, ce._crypto_core_ed25519_bytes = function() {
                return (ce._crypto_core_ed25519_bytes = ce.asm.Yh).apply(null, arguments);
              }, ce._crypto_core_ed25519_nonreducedscalarbytes = function() {
                return (ce._crypto_core_ed25519_nonreducedscalarbytes = ce.asm.Zh).apply(null, arguments);
              }, ce._crypto_core_ed25519_uniformbytes = function() {
                return (ce._crypto_core_ed25519_uniformbytes = ce.asm._h).apply(null, arguments);
              }, ce._crypto_core_ed25519_hashbytes = function() {
                return (ce._crypto_core_ed25519_hashbytes = ce.asm.$h).apply(null, arguments);
              }, ce._crypto_core_ed25519_scalarbytes = function() {
                return (ce._crypto_core_ed25519_scalarbytes = ce.asm.ai).apply(null, arguments);
              }, ce._crypto_core_ristretto255_is_valid_point = function() {
                return (ce._crypto_core_ristretto255_is_valid_point = ce.asm.bi).apply(null, arguments);
              }, ce._crypto_core_ristretto255_add = function() {
                return (ce._crypto_core_ristretto255_add = ce.asm.ci).apply(null, arguments);
              }, ce._crypto_core_ristretto255_sub = function() {
                return (ce._crypto_core_ristretto255_sub = ce.asm.di).apply(null, arguments);
              }, ce._crypto_core_ristretto255_from_hash = function() {
                return (ce._crypto_core_ristretto255_from_hash = ce.asm.ei).apply(null, arguments);
              }, ce._crypto_core_ristretto255_random = function() {
                return (ce._crypto_core_ristretto255_random = ce.asm.fi).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalar_random = function() {
                return (ce._crypto_core_ristretto255_scalar_random = ce.asm.gi).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalar_invert = function() {
                return (ce._crypto_core_ristretto255_scalar_invert = ce.asm.hi).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalar_negate = function() {
                return (ce._crypto_core_ristretto255_scalar_negate = ce.asm.ii).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalar_complement = function() {
                return (ce._crypto_core_ristretto255_scalar_complement = ce.asm.ji).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalar_add = function() {
                return (ce._crypto_core_ristretto255_scalar_add = ce.asm.ki).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalar_sub = function() {
                return (ce._crypto_core_ristretto255_scalar_sub = ce.asm.li).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalar_mul = function() {
                return (ce._crypto_core_ristretto255_scalar_mul = ce.asm.mi).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalar_reduce = function() {
                return (ce._crypto_core_ristretto255_scalar_reduce = ce.asm.ni).apply(null, arguments);
              }, ce._crypto_core_ristretto255_bytes = function() {
                return (ce._crypto_core_ristretto255_bytes = ce.asm.oi).apply(null, arguments);
              }, ce._crypto_core_ristretto255_nonreducedscalarbytes = function() {
                return (ce._crypto_core_ristretto255_nonreducedscalarbytes = ce.asm.pi).apply(null, arguments);
              }, ce._crypto_core_ristretto255_hashbytes = function() {
                return (ce._crypto_core_ristretto255_hashbytes = ce.asm.qi).apply(null, arguments);
              }, ce._crypto_core_ristretto255_scalarbytes = function() {
                return (ce._crypto_core_ristretto255_scalarbytes = ce.asm.ri).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_ll = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_ll = ce.asm.si).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_bytes_min = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_bytes_min = ce.asm.ti).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_bytes_max = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_bytes_max = ce.asm.ui).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_passwd_min = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_passwd_min = ce.asm.vi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_passwd_max = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_passwd_max = ce.asm.wi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_saltbytes = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_saltbytes = ce.asm.xi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_strbytes = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_strbytes = ce.asm.yi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_strprefix = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_strprefix = ce.asm.zi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_opslimit_min = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_opslimit_min = ce.asm.Ai).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_opslimit_max = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_opslimit_max = ce.asm.Bi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_memlimit_min = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_memlimit_min = ce.asm.Ci).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_memlimit_max = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_memlimit_max = ce.asm.Di).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = ce.asm.Ei).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = ce.asm.Fi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = ce.asm.Gi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = ce.asm.Hi).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256 = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256 = ce.asm.Ii).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_str = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_str = ce.asm.Ji).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_str_verify = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_str_verify = ce.asm.Ki).apply(null, arguments);
              }, ce._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = function() {
                return (ce._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = ce.asm.Li).apply(null, arguments);
              }, ce._crypto_scalarmult_ed25519 = function() {
                return (ce._crypto_scalarmult_ed25519 = ce.asm.Mi).apply(null, arguments);
              }, ce._crypto_scalarmult_ed25519_noclamp = function() {
                return (ce._crypto_scalarmult_ed25519_noclamp = ce.asm.Ni).apply(null, arguments);
              }, ce._crypto_scalarmult_ed25519_base = function() {
                return (ce._crypto_scalarmult_ed25519_base = ce.asm.Oi).apply(null, arguments);
              }, ce._crypto_scalarmult_ed25519_base_noclamp = function() {
                return (ce._crypto_scalarmult_ed25519_base_noclamp = ce.asm.Pi).apply(null, arguments);
              }, ce._crypto_scalarmult_ed25519_bytes = function() {
                return (ce._crypto_scalarmult_ed25519_bytes = ce.asm.Qi).apply(null, arguments);
              }, ce._crypto_scalarmult_ed25519_scalarbytes = function() {
                return (ce._crypto_scalarmult_ed25519_scalarbytes = ce.asm.Ri).apply(null, arguments);
              }, ce._crypto_scalarmult_ristretto255 = function() {
                return (ce._crypto_scalarmult_ristretto255 = ce.asm.Si).apply(null, arguments);
              }, ce._crypto_scalarmult_ristretto255_base = function() {
                return (ce._crypto_scalarmult_ristretto255_base = ce.asm.Ti).apply(null, arguments);
              }, ce._crypto_scalarmult_ristretto255_bytes = function() {
                return (ce._crypto_scalarmult_ristretto255_bytes = ce.asm.Ui).apply(null, arguments);
              }, ce._crypto_scalarmult_ristretto255_scalarbytes = function() {
                return (ce._crypto_scalarmult_ristretto255_scalarbytes = ce.asm.Vi).apply(null, arguments);
              }, ce._crypto_secretbox_xchacha20poly1305_detached = function() {
                return (ce._crypto_secretbox_xchacha20poly1305_detached = ce.asm.Wi).apply(null, arguments);
              }, ce._crypto_secretbox_xchacha20poly1305_easy = function() {
                return (ce._crypto_secretbox_xchacha20poly1305_easy = ce.asm.Xi).apply(null, arguments);
              }, ce._crypto_secretbox_xchacha20poly1305_open_detached = function() {
                return (ce._crypto_secretbox_xchacha20poly1305_open_detached = ce.asm.Yi).apply(null, arguments);
              }, ce._crypto_secretbox_xchacha20poly1305_open_easy = function() {
                return (ce._crypto_secretbox_xchacha20poly1305_open_easy = ce.asm.Zi).apply(null, arguments);
              }, ce._crypto_secretbox_xchacha20poly1305_keybytes = function() {
                return (ce._crypto_secretbox_xchacha20poly1305_keybytes = ce.asm._i).apply(null, arguments);
              }, ce._crypto_secretbox_xchacha20poly1305_noncebytes = function() {
                return (ce._crypto_secretbox_xchacha20poly1305_noncebytes = ce.asm.$i).apply(null, arguments);
              }, ce._crypto_secretbox_xchacha20poly1305_macbytes = function() {
                return (ce._crypto_secretbox_xchacha20poly1305_macbytes = ce.asm.aj).apply(null, arguments);
              }, ce._crypto_secretbox_xchacha20poly1305_messagebytes_max = function() {
                return (ce._crypto_secretbox_xchacha20poly1305_messagebytes_max = ce.asm.bj).apply(null, arguments);
              }, ce._crypto_shorthash_siphashx24_bytes = function() {
                return (ce._crypto_shorthash_siphashx24_bytes = ce.asm.cj).apply(null, arguments);
              }, ce._crypto_shorthash_siphashx24_keybytes = function() {
                return (ce._crypto_shorthash_siphashx24_keybytes = ce.asm.dj).apply(null, arguments);
              }, ce._crypto_shorthash_siphashx24 = function() {
                return (ce._crypto_shorthash_siphashx24 = ce.asm.ej).apply(null, arguments);
              }, ce._crypto_stream_salsa2012 = function() {
                return (ce._crypto_stream_salsa2012 = ce.asm.fj).apply(null, arguments);
              }, ce._crypto_stream_salsa2012_xor = function() {
                return (ce._crypto_stream_salsa2012_xor = ce.asm.gj).apply(null, arguments);
              }, ce._crypto_stream_salsa2012_keybytes = function() {
                return (ce._crypto_stream_salsa2012_keybytes = ce.asm.hj).apply(null, arguments);
              }, ce._crypto_stream_salsa2012_noncebytes = function() {
                return (ce._crypto_stream_salsa2012_noncebytes = ce.asm.ij).apply(null, arguments);
              }, ce._crypto_stream_salsa2012_messagebytes_max = function() {
                return (ce._crypto_stream_salsa2012_messagebytes_max = ce.asm.jj).apply(null, arguments);
              }, ce._crypto_stream_salsa2012_keygen = function() {
                return (ce._crypto_stream_salsa2012_keygen = ce.asm.kj).apply(null, arguments);
              }, ce._crypto_stream_salsa208 = function() {
                return (ce._crypto_stream_salsa208 = ce.asm.lj).apply(null, arguments);
              }, ce._crypto_stream_salsa208_xor = function() {
                return (ce._crypto_stream_salsa208_xor = ce.asm.mj).apply(null, arguments);
              }, ce._crypto_stream_salsa208_keybytes = function() {
                return (ce._crypto_stream_salsa208_keybytes = ce.asm.nj).apply(null, arguments);
              }, ce._crypto_stream_salsa208_noncebytes = function() {
                return (ce._crypto_stream_salsa208_noncebytes = ce.asm.oj).apply(null, arguments);
              }, ce._crypto_stream_salsa208_messagebytes_max = function() {
                return (ce._crypto_stream_salsa208_messagebytes_max = ce.asm.pj).apply(null, arguments);
              }, ce._crypto_stream_salsa208_keygen = function() {
                return (ce._crypto_stream_salsa208_keygen = ce.asm.qj).apply(null, arguments);
              }, ce._crypto_stream_xchacha20_keybytes = function() {
                return (ce._crypto_stream_xchacha20_keybytes = ce.asm.rj).apply(null, arguments);
              }, ce._crypto_stream_xchacha20_noncebytes = function() {
                return (ce._crypto_stream_xchacha20_noncebytes = ce.asm.sj).apply(null, arguments);
              }, ce._crypto_stream_xchacha20_messagebytes_max = function() {
                return (ce._crypto_stream_xchacha20_messagebytes_max = ce.asm.tj).apply(null, arguments);
              }, ce._crypto_stream_xchacha20 = function() {
                return (ce._crypto_stream_xchacha20 = ce.asm.uj).apply(null, arguments);
              }, ce._crypto_stream_xchacha20_xor_ic = function() {
                return (ce._crypto_stream_xchacha20_xor_ic = ce.asm.vj).apply(null, arguments);
              }, ce._crypto_stream_xchacha20_xor = function() {
                return (ce._crypto_stream_xchacha20_xor = ce.asm.wj).apply(null, arguments);
              }, ce._crypto_stream_xchacha20_keygen = function() {
                return (ce._crypto_stream_xchacha20_keygen = ce.asm.xj).apply(null, arguments);
              }, ce._malloc = function() {
                return (ce._malloc = ce.asm.yj).apply(null, arguments);
              }, ce._free = function() {
                return (ce._free = ce.asm.zj).apply(null, arguments);
              }, ce.UTF8ToString = lr, ce.setValue = function(xn, sr, Nr = "i8") {
                switch (Nr.endsWith("*") && (Nr = "*"), Nr) {
                  case "i1":
                  case "i8":
                    yn[xn >> 0] = sr;
                    break;
                  case "i16":
                    Uo[xn >> 1] = sr;
                    break;
                  case "i32":
                    ar[xn >> 2] = sr;
                    break;
                  case "i64":
                    hr = [sr >>> 0, (qo = sr, +Math.abs(qo) >= 1 ? qo > 0 ? (0 | Math.min(+Math.floor(qo / 4294967296), 4294967295)) >>> 0 : ~~+Math.ceil((qo - +(~~qo >>> 0)) / 4294967296) >>> 0 : 0)], ar[xn >> 2] = hr[0], ar[xn + 4 >> 2] = hr[1];
                    break;
                  case "float":
                    Jo[xn >> 2] = sr;
                    break;
                  case "double":
                    fr[xn >> 3] = sr;
                    break;
                  case "*":
                    Sr[xn >> 2] = sr;
                    break;
                  default:
                    Qo("invalid type for setValue: " + Nr);
                }
              }, ce.getValue = function(xn, sr = "i8") {
                switch (sr.endsWith("*") && (sr = "*"), sr) {
                  case "i1":
                  case "i8":
                    return yn[xn >> 0];
                  case "i16":
                    return Uo[xn >> 1];
                  case "i32":
                  case "i64":
                    return ar[xn >> 2];
                  case "float":
                    return Jo[xn >> 2];
                  case "double":
                    return fr[xn >> 3];
                  case "*":
                    return Sr[xn >> 2];
                  default:
                    Qo("invalid type for getValue: " + sr);
                }
                return null;
              }, Br = function xn() {
                pi || _i(), pi || (Br = xn);
              }, ce.preInit)
                for (typeof ce.preInit == "function" && (ce.preInit = [ce.preInit]); ce.preInit.length > 0; )
                  ce.preInit.pop()();
              _i();
            });
          };
          var E, O, T, y = y !== void 0 ? y : {}, V = Object.assign({}, y), M = typeof window == "object", G = typeof importScripts == "function", k = typeof browser$1$1 == "object" && typeof browser$1$1.versions == "object" && typeof browser$1$1.versions.node == "string", F = "";
          if (k) {
            var X = require$$0$3, ee = requirePathBrowserify();
            F = G ? ee.dirname(F) + "/" : __dirname + "/", E = (At, hn) => {
              var $t = Ht(At);
              return $t ? hn ? $t : $t.toString() : (At = Nt(At) ? new URL(At) : ee.normalize(At), X.readFileSync(At, hn ? void 0 : "utf8"));
            }, T = (At) => {
              var hn = E(At, !0);
              return hn.buffer || (hn = new Uint8Array(hn)), hn;
            }, O = (At, hn, $t) => {
              var Lt = Ht(At);
              Lt && hn(Lt), At = Nt(At) ? new URL(At) : ee.normalize(At), X.readFile(At, function(Qn, ce) {
                Qn ? $t(Qn) : hn(ce.buffer);
              });
            }, browser$1$1.argv.length > 1 && browser$1$1.argv[1].replace(/\\/g, "/"), browser$1$1.argv.slice(2), e.exports = y, y.inspect = function() {
              return "[Emscripten Module object]";
            };
          } else
            (M || G) && (G ? F = self.location.href : typeof document < "u" && document.currentScript && (F = document.currentScript.src), F = F.indexOf("blob:") !== 0 ? F.substr(0, F.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", E = (At) => {
              try {
                var hn = new XMLHttpRequest();
                return hn.open("GET", At, !1), hn.send(null), hn.responseText;
              } catch (Lt) {
                var $t = Ht(At);
                if ($t)
                  return function(Qn) {
                    for (var ce = [], Ze = 0; Ze < Qn.length; Ze++) {
                      var ft = Qn[Ze];
                      ft > 255 && (ft &= 255), ce.push(String.fromCharCode(ft));
                    }
                    return ce.join("");
                  }($t);
                throw Lt;
              }
            }, G && (T = (At) => {
              try {
                var hn = new XMLHttpRequest();
                return hn.open("GET", At, !1), hn.responseType = "arraybuffer", hn.send(null), new Uint8Array(hn.response);
              } catch (Lt) {
                var $t = Ht(At);
                if ($t)
                  return $t;
                throw Lt;
              }
            }), O = (At, hn, $t) => {
              var Lt = new XMLHttpRequest();
              Lt.open("GET", At, !0), Lt.responseType = "arraybuffer", Lt.onload = () => {
                if (Lt.status == 200 || Lt.status == 0 && Lt.response)
                  hn(Lt.response);
                else {
                  var Qn = Ht(At);
                  Qn ? hn(Qn.buffer) : $t();
                }
              }, Lt.onerror = $t, Lt.send(null);
            });
          y.print;
          var ue, Q, Y = y.printErr || void 0;
          Object.assign(y, V), V = null, y.arguments && y.arguments, y.thisProgram && y.thisProgram, y.quit && y.quit, y.wasmBinary && (ue = y.wasmBinary), y.noExitRuntime, typeof WebAssembly != "object" && Ke("no native wasm support detected");
          var pe, oe, ne, H, C, w, P, J = !1, se = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
          function fe(At, hn) {
            return At ? function($t, Lt, Qn) {
              for (var ce = Lt + Qn, Ze = Lt; $t[Ze] && !(Ze >= ce); )
                ++Ze;
              if (Ze - Lt > 16 && $t.buffer && se)
                return se.decode($t.subarray(Lt, Ze));
              for (var ft = ""; Lt < Ze; ) {
                var It = $t[Lt++];
                if (128 & It) {
                  var rn = 63 & $t[Lt++];
                  if ((224 & It) != 192) {
                    var Ln = 63 & $t[Lt++];
                    if ((It = (240 & It) == 224 ? (15 & It) << 12 | rn << 6 | Ln : (7 & It) << 18 | rn << 12 | Ln << 6 | 63 & $t[Lt++]) < 65536)
                      ft += String.fromCharCode(It);
                    else {
                      var Pn = It - 65536;
                      ft += String.fromCharCode(55296 | Pn >> 10, 56320 | 1023 & Pn);
                    }
                  } else
                    ft += String.fromCharCode((31 & It) << 6 | rn);
                } else
                  ft += String.fromCharCode(It);
              }
              return ft;
            }(oe, At, hn) : "";
          }
          function N() {
            var At = Q.buffer;
            y.HEAP8 = pe = new Int8Array(At), y.HEAP16 = ne = new Int16Array(At), y.HEAP32 = H = new Int32Array(At), y.HEAPU8 = oe = new Uint8Array(At), y.HEAPU16 = new Uint16Array(At), y.HEAPU32 = C = new Uint32Array(At), y.HEAPF32 = w = new Float32Array(At), y.HEAPF64 = P = new Float64Array(At);
          }
          var W = [], I = [], te = [], ge = 0, Pe = null;
          function Ke(At) {
            throw y.onAbort && y.onAbort(At), Y(At = "Aborted(" + At + ")"), J = !0, At += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(At);
          }
          var xe, ze, nt, Qt, Et = "data:application/octet-stream;base64,";
          function zt(At) {
            return At.startsWith(Et);
          }
          function Nt(At) {
            return At.startsWith("file://");
          }
          function pt(At) {
            try {
              if (At == xe && ue)
                return new Uint8Array(ue);
              var hn = Ht(At);
              if (hn)
                return hn;
              if (T)
                return T(At);
              throw "both async and sync fetching of the wasm failed";
            } catch ($t) {
              Ke($t);
            }
          }
          zt(xe = "data:application/octet-stream;base64,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") || (ze = xe, xe = y.locateFile ? y.locateFile(ze, F) : F + ze);
          var at = { 35752: () => y.getRandomValue(), 35788: () => {
            if (y.getRandomValue === void 0)
              try {
                var At = typeof window == "object" ? window : self, hn = At.crypto !== void 0 ? At.crypto : At.msCrypto, $t = function() {
                  var ce = new Uint32Array(1);
                  return hn.getRandomValues(ce), ce[0] >>> 0;
                };
                $t(), y.getRandomValue = $t;
              } catch {
                try {
                  var Lt = requireCryptoBrowserify(), Qn = function() {
                    var Ze = Lt.randomBytes(4);
                    return (Ze[0] << 24 | Ze[1] << 16 | Ze[2] << 8 | Ze[3]) >>> 0;
                  };
                  Qn(), y.getRandomValue = Qn;
                } catch {
                  throw "No secure random number generator found";
                }
              }
          } };
          function kt(At) {
            for (; At.length > 0; )
              At.shift()(y);
          }
          var Ut = [];
          function dn(At) {
            var hn = Q.buffer;
            try {
              return Q.grow(At - hn.byteLength + 65535 >>> 16), N(), 1;
            } catch {
            }
          }
          var En = typeof atob == "function" ? atob : function(At) {
            var hn, $t, Lt, Qn, ce, Ze, ft = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", It = "", rn = 0;
            At = At.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            do
              hn = ft.indexOf(At.charAt(rn++)) << 2 | (Qn = ft.indexOf(At.charAt(rn++))) >> 4, $t = (15 & Qn) << 4 | (ce = ft.indexOf(At.charAt(rn++))) >> 2, Lt = (3 & ce) << 6 | (Ze = ft.indexOf(At.charAt(rn++))), It += String.fromCharCode(hn), ce !== 64 && (It += String.fromCharCode($t)), Ze !== 64 && (It += String.fromCharCode(Lt));
            while (rn < At.length);
            return It;
          };
          function Ht(At) {
            if (zt(At))
              return function(hn) {
                if (typeof k == "boolean" && k) {
                  var $t = Buffer.from(hn, "base64");
                  return new Uint8Array($t.buffer, $t.byteOffset, $t.byteLength);
                }
                try {
                  for (var Lt = En(hn), Qn = new Uint8Array(Lt.length), ce = 0; ce < Lt.length; ++ce)
                    Qn[ce] = Lt.charCodeAt(ce);
                  return Qn;
                } catch {
                  throw new Error("Converting base64 string to bytes failed.");
                }
              }(At.slice(Et.length));
          }
          var Xt, On = { b: function(At, hn, $t, Lt) {
            Ke("Assertion failed: " + fe(At) + ", at: " + [hn ? fe(hn) : "unknown filename", $t, Lt ? fe(Lt) : "unknown function"]);
          }, c: function() {
            Ke("");
          }, a: function(At, hn, $t) {
            return function(Lt, Qn, ce) {
              var Ze = function(ft, It) {
                var rn;
                for (Ut.length = 0, It >>= 2; rn = oe[ft++]; )
                  It += rn != 105 & It, Ut.push(rn == 105 ? H[It] : P[It++ >> 1]), ++It;
                return Ut;
              }(Qn, ce);
              return at[Lt].apply(null, Ze);
            }(At, hn, $t);
          }, d: function(At, hn, $t) {
            oe.copyWithin(At, hn, hn + $t);
          }, e: function(At) {
            var hn, $t = oe.length, Lt = 2147483648;
            if ((At >>>= 0) > Lt)
              return !1;
            for (var Qn = 1; Qn <= 4; Qn *= 2) {
              var ce = $t * (1 + 0.2 / Qn);
              if (ce = Math.min(ce, At + 100663296), dn(Math.min(Lt, (hn = Math.max(At, ce)) + (65536 - hn % 65536) % 65536)))
                return !0;
            }
            return !1;
          } };
          function sn() {
            function At() {
              Xt || (Xt = !0, y.calledRun = !0, J || (kt(I), y.onRuntimeInitialized && y.onRuntimeInitialized(), function() {
                if (y.postRun)
                  for (typeof y.postRun == "function" && (y.postRun = [y.postRun]); y.postRun.length; )
                    hn = y.postRun.shift(), te.unshift(hn);
                var hn;
                kt(te);
              }()));
            }
            ge > 0 || (function() {
              if (y.preRun)
                for (typeof y.preRun == "function" && (y.preRun = [y.preRun]); y.preRun.length; )
                  hn = y.preRun.shift(), W.unshift(hn);
              var hn;
              kt(W);
            }(), ge > 0 || (y.setStatus ? (y.setStatus("Running..."), setTimeout(function() {
              setTimeout(function() {
                y.setStatus("");
              }, 1), At();
            }, 1)) : At()));
          }
          if (function() {
            var At = { a: On };
            function hn(Qn, ce) {
              var Ze = Qn.exports;
              y.asm = Ze, Q = y.asm.f, N(), y.asm.Aj, function(ft) {
                if (ge--, y.monitorRunDependencies && y.monitorRunDependencies(ge), ge == 0 && Pe) {
                  var It = Pe;
                  Pe = null, It();
                }
              }();
            }
            function $t(Qn) {
              hn(Qn.instance);
            }
            function Lt(Qn) {
              return function() {
                if (!ue && (M || G)) {
                  if (typeof fetch == "function" && !Nt(xe))
                    return fetch(xe, { credentials: "same-origin" }).then(function(ce) {
                      if (!ce.ok)
                        throw "failed to load wasm binary file at '" + xe + "'";
                      return ce.arrayBuffer();
                    }).catch(function() {
                      return pt(xe);
                    });
                  if (O)
                    return new Promise(function(ce, Ze) {
                      O(xe, function(ft) {
                        ce(new Uint8Array(ft));
                      }, Ze);
                    });
                }
                return Promise.resolve().then(function() {
                  return pt(xe);
                });
              }().then(function(ce) {
                return WebAssembly.instantiate(ce, At);
              }).then(function(ce) {
                return ce;
              }).then(Qn, function(ce) {
                Y("failed to asynchronously prepare wasm: " + ce), Ke(ce);
              });
            }
            if (ge++, y.monitorRunDependencies && y.monitorRunDependencies(ge), y.instantiateWasm)
              try {
                return y.instantiateWasm(At, hn);
              } catch (Qn) {
                return Y("Module.instantiateWasm callback failed with error: " + Qn), !1;
              }
            ue || typeof WebAssembly.instantiateStreaming != "function" || zt(xe) || Nt(xe) || k || typeof fetch != "function" ? Lt($t) : fetch(xe, { credentials: "same-origin" }).then(function(Qn) {
              return WebAssembly.instantiateStreaming(Qn, At).then($t, function(ce) {
                return Y("wasm streaming compile failed: " + ce), Y("falling back to ArrayBuffer instantiation"), Lt($t);
              });
            });
          }(), y._crypto_aead_chacha20poly1305_encrypt_detached = function() {
            return (y._crypto_aead_chacha20poly1305_encrypt_detached = y.asm.g).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_encrypt = function() {
            return (y._crypto_aead_chacha20poly1305_encrypt = y.asm.h).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_encrypt_detached = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_encrypt_detached = y.asm.i).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_encrypt = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_encrypt = y.asm.j).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_decrypt_detached = function() {
            return (y._crypto_aead_chacha20poly1305_decrypt_detached = y.asm.k).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_decrypt = function() {
            return (y._crypto_aead_chacha20poly1305_decrypt = y.asm.l).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_decrypt_detached = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_decrypt_detached = y.asm.m).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_decrypt = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_decrypt = y.asm.n).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_keybytes = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_keybytes = y.asm.o).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_npubbytes = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_npubbytes = y.asm.p).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_nsecbytes = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_nsecbytes = y.asm.q).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_abytes = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_abytes = y.asm.r).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_messagebytes_max = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_messagebytes_max = y.asm.s).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_ietf_keygen = function() {
            return (y._crypto_aead_chacha20poly1305_ietf_keygen = y.asm.t).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_keybytes = function() {
            return (y._crypto_aead_chacha20poly1305_keybytes = y.asm.u).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_npubbytes = function() {
            return (y._crypto_aead_chacha20poly1305_npubbytes = y.asm.v).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_nsecbytes = function() {
            return (y._crypto_aead_chacha20poly1305_nsecbytes = y.asm.w).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_abytes = function() {
            return (y._crypto_aead_chacha20poly1305_abytes = y.asm.x).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_messagebytes_max = function() {
            return (y._crypto_aead_chacha20poly1305_messagebytes_max = y.asm.y).apply(null, arguments);
          }, y._crypto_aead_chacha20poly1305_keygen = function() {
            return (y._crypto_aead_chacha20poly1305_keygen = y.asm.z).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = y.asm.A).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_encrypt = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_encrypt = y.asm.B).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = y.asm.C).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_decrypt = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_decrypt = y.asm.D).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_keybytes = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_keybytes = y.asm.E).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_npubbytes = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_npubbytes = y.asm.F).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_nsecbytes = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_nsecbytes = y.asm.G).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_abytes = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_abytes = y.asm.H).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = y.asm.I).apply(null, arguments);
          }, y._crypto_aead_xchacha20poly1305_ietf_keygen = function() {
            return (y._crypto_aead_xchacha20poly1305_ietf_keygen = y.asm.J).apply(null, arguments);
          }, y._crypto_auth_bytes = function() {
            return (y._crypto_auth_bytes = y.asm.K).apply(null, arguments);
          }, y._crypto_auth_keybytes = function() {
            return (y._crypto_auth_keybytes = y.asm.L).apply(null, arguments);
          }, y._crypto_auth_primitive = function() {
            return (y._crypto_auth_primitive = y.asm.M).apply(null, arguments);
          }, y._crypto_auth = function() {
            return (y._crypto_auth = y.asm.N).apply(null, arguments);
          }, y._crypto_auth_verify = function() {
            return (y._crypto_auth_verify = y.asm.O).apply(null, arguments);
          }, y._crypto_auth_keygen = function() {
            return (y._crypto_auth_keygen = y.asm.P).apply(null, arguments);
          }, y._crypto_auth_hmacsha256_bytes = function() {
            return (y._crypto_auth_hmacsha256_bytes = y.asm.Q).apply(null, arguments);
          }, y._crypto_auth_hmacsha256_keybytes = function() {
            return (y._crypto_auth_hmacsha256_keybytes = y.asm.R).apply(null, arguments);
          }, y._crypto_auth_hmacsha256_statebytes = function() {
            return (y._crypto_auth_hmacsha256_statebytes = y.asm.S).apply(null, arguments);
          }, y._crypto_auth_hmacsha256_keygen = function() {
            return (y._crypto_auth_hmacsha256_keygen = y.asm.T).apply(null, arguments);
          }, y._crypto_auth_hmacsha256_init = function() {
            return (y._crypto_auth_hmacsha256_init = y.asm.U).apply(null, arguments);
          }, y._crypto_auth_hmacsha256_update = function() {
            return (y._crypto_auth_hmacsha256_update = y.asm.V).apply(null, arguments);
          }, y._crypto_auth_hmacsha256_final = function() {
            return (y._crypto_auth_hmacsha256_final = y.asm.W).apply(null, arguments);
          }, y._crypto_auth_hmacsha256 = function() {
            return (y._crypto_auth_hmacsha256 = y.asm.X).apply(null, arguments);
          }, y._crypto_auth_hmacsha256_verify = function() {
            return (y._crypto_auth_hmacsha256_verify = y.asm.Y).apply(null, arguments);
          }, y._crypto_auth_hmacsha512_bytes = function() {
            return (y._crypto_auth_hmacsha512_bytes = y.asm.Z).apply(null, arguments);
          }, y._crypto_auth_hmacsha512_keybytes = function() {
            return (y._crypto_auth_hmacsha512_keybytes = y.asm._).apply(null, arguments);
          }, y._crypto_auth_hmacsha512_statebytes = function() {
            return (y._crypto_auth_hmacsha512_statebytes = y.asm.$).apply(null, arguments);
          }, y._crypto_auth_hmacsha512_keygen = function() {
            return (y._crypto_auth_hmacsha512_keygen = y.asm.aa).apply(null, arguments);
          }, y._crypto_auth_hmacsha512_init = function() {
            return (y._crypto_auth_hmacsha512_init = y.asm.ba).apply(null, arguments);
          }, y._crypto_auth_hmacsha512_update = function() {
            return (y._crypto_auth_hmacsha512_update = y.asm.ca).apply(null, arguments);
          }, y._crypto_auth_hmacsha512_final = function() {
            return (y._crypto_auth_hmacsha512_final = y.asm.da).apply(null, arguments);
          }, y._crypto_auth_hmacsha512 = function() {
            return (y._crypto_auth_hmacsha512 = y.asm.ea).apply(null, arguments);
          }, y._crypto_auth_hmacsha512_verify = function() {
            return (y._crypto_auth_hmacsha512_verify = y.asm.fa).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256_bytes = function() {
            return (y._crypto_auth_hmacsha512256_bytes = y.asm.ga).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256_keybytes = function() {
            return (y._crypto_auth_hmacsha512256_keybytes = y.asm.ha).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256_statebytes = function() {
            return (y._crypto_auth_hmacsha512256_statebytes = y.asm.ia).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256_keygen = function() {
            return (y._crypto_auth_hmacsha512256_keygen = y.asm.ja).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256_init = function() {
            return (y._crypto_auth_hmacsha512256_init = y.asm.ka).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256_update = function() {
            return (y._crypto_auth_hmacsha512256_update = y.asm.la).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256_final = function() {
            return (y._crypto_auth_hmacsha512256_final = y.asm.ma).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256 = function() {
            return (y._crypto_auth_hmacsha512256 = y.asm.na).apply(null, arguments);
          }, y._crypto_auth_hmacsha512256_verify = function() {
            return (y._crypto_auth_hmacsha512256_verify = y.asm.oa).apply(null, arguments);
          }, y._crypto_box_seedbytes = function() {
            return (y._crypto_box_seedbytes = y.asm.pa).apply(null, arguments);
          }, y._crypto_box_publickeybytes = function() {
            return (y._crypto_box_publickeybytes = y.asm.qa).apply(null, arguments);
          }, y._crypto_box_secretkeybytes = function() {
            return (y._crypto_box_secretkeybytes = y.asm.ra).apply(null, arguments);
          }, y._crypto_box_beforenmbytes = function() {
            return (y._crypto_box_beforenmbytes = y.asm.sa).apply(null, arguments);
          }, y._crypto_box_noncebytes = function() {
            return (y._crypto_box_noncebytes = y.asm.ta).apply(null, arguments);
          }, y._crypto_box_zerobytes = function() {
            return (y._crypto_box_zerobytes = y.asm.ua).apply(null, arguments);
          }, y._crypto_box_boxzerobytes = function() {
            return (y._crypto_box_boxzerobytes = y.asm.va).apply(null, arguments);
          }, y._crypto_box_macbytes = function() {
            return (y._crypto_box_macbytes = y.asm.wa).apply(null, arguments);
          }, y._crypto_box_messagebytes_max = function() {
            return (y._crypto_box_messagebytes_max = y.asm.xa).apply(null, arguments);
          }, y._crypto_box_primitive = function() {
            return (y._crypto_box_primitive = y.asm.ya).apply(null, arguments);
          }, y._crypto_box_seed_keypair = function() {
            return (y._crypto_box_seed_keypair = y.asm.za).apply(null, arguments);
          }, y._crypto_box_keypair = function() {
            return (y._crypto_box_keypair = y.asm.Aa).apply(null, arguments);
          }, y._crypto_box_beforenm = function() {
            return (y._crypto_box_beforenm = y.asm.Ba).apply(null, arguments);
          }, y._crypto_box_afternm = function() {
            return (y._crypto_box_afternm = y.asm.Ca).apply(null, arguments);
          }, y._crypto_box_open_afternm = function() {
            return (y._crypto_box_open_afternm = y.asm.Da).apply(null, arguments);
          }, y._crypto_box = function() {
            return (y._crypto_box = y.asm.Ea).apply(null, arguments);
          }, y._crypto_box_open = function() {
            return (y._crypto_box_open = y.asm.Fa).apply(null, arguments);
          }, y._crypto_box_detached_afternm = function() {
            return (y._crypto_box_detached_afternm = y.asm.Ga).apply(null, arguments);
          }, y._crypto_box_detached = function() {
            return (y._crypto_box_detached = y.asm.Ha).apply(null, arguments);
          }, y._crypto_box_easy_afternm = function() {
            return (y._crypto_box_easy_afternm = y.asm.Ia).apply(null, arguments);
          }, y._crypto_box_easy = function() {
            return (y._crypto_box_easy = y.asm.Ja).apply(null, arguments);
          }, y._crypto_box_open_detached_afternm = function() {
            return (y._crypto_box_open_detached_afternm = y.asm.Ka).apply(null, arguments);
          }, y._crypto_box_open_detached = function() {
            return (y._crypto_box_open_detached = y.asm.La).apply(null, arguments);
          }, y._crypto_box_open_easy_afternm = function() {
            return (y._crypto_box_open_easy_afternm = y.asm.Ma).apply(null, arguments);
          }, y._crypto_box_open_easy = function() {
            return (y._crypto_box_open_easy = y.asm.Na).apply(null, arguments);
          }, y._crypto_box_seal = function() {
            return (y._crypto_box_seal = y.asm.Oa).apply(null, arguments);
          }, y._crypto_box_seal_open = function() {
            return (y._crypto_box_seal_open = y.asm.Pa).apply(null, arguments);
          }, y._crypto_box_sealbytes = function() {
            return (y._crypto_box_sealbytes = y.asm.Qa).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_seed_keypair = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_seed_keypair = y.asm.Ra).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_keypair = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_keypair = y.asm.Sa).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_beforenm = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_beforenm = y.asm.Ta).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_afternm = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_afternm = y.asm.Ua).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_open_afternm = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_open_afternm = y.asm.Va).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305 = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305 = y.asm.Wa).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_open = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_open = y.asm.Xa).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_seedbytes = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_seedbytes = y.asm.Ya).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_publickeybytes = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_publickeybytes = y.asm.Za).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = y.asm._a).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = y.asm.$a).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_noncebytes = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_noncebytes = y.asm.ab).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_zerobytes = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_zerobytes = y.asm.bb).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = y.asm.cb).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_macbytes = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_macbytes = y.asm.db).apply(null, arguments);
          }, y._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = function() {
            return (y._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = y.asm.eb).apply(null, arguments);
          }, y._crypto_core_hchacha20 = function() {
            return (y._crypto_core_hchacha20 = y.asm.fb).apply(null, arguments);
          }, y._crypto_core_hchacha20_outputbytes = function() {
            return (y._crypto_core_hchacha20_outputbytes = y.asm.gb).apply(null, arguments);
          }, y._crypto_core_hchacha20_inputbytes = function() {
            return (y._crypto_core_hchacha20_inputbytes = y.asm.hb).apply(null, arguments);
          }, y._crypto_core_hchacha20_keybytes = function() {
            return (y._crypto_core_hchacha20_keybytes = y.asm.ib).apply(null, arguments);
          }, y._crypto_core_hchacha20_constbytes = function() {
            return (y._crypto_core_hchacha20_constbytes = y.asm.jb).apply(null, arguments);
          }, y._crypto_core_hsalsa20 = function() {
            return (y._crypto_core_hsalsa20 = y.asm.kb).apply(null, arguments);
          }, y._crypto_core_hsalsa20_outputbytes = function() {
            return (y._crypto_core_hsalsa20_outputbytes = y.asm.lb).apply(null, arguments);
          }, y._crypto_core_hsalsa20_inputbytes = function() {
            return (y._crypto_core_hsalsa20_inputbytes = y.asm.mb).apply(null, arguments);
          }, y._crypto_core_hsalsa20_keybytes = function() {
            return (y._crypto_core_hsalsa20_keybytes = y.asm.nb).apply(null, arguments);
          }, y._crypto_core_hsalsa20_constbytes = function() {
            return (y._crypto_core_hsalsa20_constbytes = y.asm.ob).apply(null, arguments);
          }, y._crypto_core_salsa20 = function() {
            return (y._crypto_core_salsa20 = y.asm.pb).apply(null, arguments);
          }, y._crypto_core_salsa20_outputbytes = function() {
            return (y._crypto_core_salsa20_outputbytes = y.asm.qb).apply(null, arguments);
          }, y._crypto_core_salsa20_inputbytes = function() {
            return (y._crypto_core_salsa20_inputbytes = y.asm.rb).apply(null, arguments);
          }, y._crypto_core_salsa20_keybytes = function() {
            return (y._crypto_core_salsa20_keybytes = y.asm.sb).apply(null, arguments);
          }, y._crypto_core_salsa20_constbytes = function() {
            return (y._crypto_core_salsa20_constbytes = y.asm.tb).apply(null, arguments);
          }, y._crypto_core_salsa2012 = function() {
            return (y._crypto_core_salsa2012 = y.asm.ub).apply(null, arguments);
          }, y._crypto_core_salsa2012_outputbytes = function() {
            return (y._crypto_core_salsa2012_outputbytes = y.asm.vb).apply(null, arguments);
          }, y._crypto_core_salsa2012_inputbytes = function() {
            return (y._crypto_core_salsa2012_inputbytes = y.asm.wb).apply(null, arguments);
          }, y._crypto_core_salsa2012_keybytes = function() {
            return (y._crypto_core_salsa2012_keybytes = y.asm.xb).apply(null, arguments);
          }, y._crypto_core_salsa2012_constbytes = function() {
            return (y._crypto_core_salsa2012_constbytes = y.asm.yb).apply(null, arguments);
          }, y._crypto_core_salsa208 = function() {
            return (y._crypto_core_salsa208 = y.asm.zb).apply(null, arguments);
          }, y._crypto_core_salsa208_outputbytes = function() {
            return (y._crypto_core_salsa208_outputbytes = y.asm.Ab).apply(null, arguments);
          }, y._crypto_core_salsa208_inputbytes = function() {
            return (y._crypto_core_salsa208_inputbytes = y.asm.Bb).apply(null, arguments);
          }, y._crypto_core_salsa208_keybytes = function() {
            return (y._crypto_core_salsa208_keybytes = y.asm.Cb).apply(null, arguments);
          }, y._crypto_core_salsa208_constbytes = function() {
            return (y._crypto_core_salsa208_constbytes = y.asm.Db).apply(null, arguments);
          }, y._crypto_generichash_bytes_min = function() {
            return (y._crypto_generichash_bytes_min = y.asm.Eb).apply(null, arguments);
          }, y._crypto_generichash_bytes_max = function() {
            return (y._crypto_generichash_bytes_max = y.asm.Fb).apply(null, arguments);
          }, y._crypto_generichash_bytes = function() {
            return (y._crypto_generichash_bytes = y.asm.Gb).apply(null, arguments);
          }, y._crypto_generichash_keybytes_min = function() {
            return (y._crypto_generichash_keybytes_min = y.asm.Hb).apply(null, arguments);
          }, y._crypto_generichash_keybytes_max = function() {
            return (y._crypto_generichash_keybytes_max = y.asm.Ib).apply(null, arguments);
          }, y._crypto_generichash_keybytes = function() {
            return (y._crypto_generichash_keybytes = y.asm.Jb).apply(null, arguments);
          }, y._crypto_generichash_primitive = function() {
            return (y._crypto_generichash_primitive = y.asm.Kb).apply(null, arguments);
          }, y._crypto_generichash_statebytes = function() {
            return (y._crypto_generichash_statebytes = y.asm.Lb).apply(null, arguments);
          }, y._crypto_generichash = function() {
            return (y._crypto_generichash = y.asm.Mb).apply(null, arguments);
          }, y._crypto_generichash_init = function() {
            return (y._crypto_generichash_init = y.asm.Nb).apply(null, arguments);
          }, y._crypto_generichash_update = function() {
            return (y._crypto_generichash_update = y.asm.Ob).apply(null, arguments);
          }, y._crypto_generichash_final = function() {
            return (y._crypto_generichash_final = y.asm.Pb).apply(null, arguments);
          }, y._crypto_generichash_keygen = function() {
            return (y._crypto_generichash_keygen = y.asm.Qb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_bytes_min = function() {
            return (y._crypto_generichash_blake2b_bytes_min = y.asm.Rb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_bytes_max = function() {
            return (y._crypto_generichash_blake2b_bytes_max = y.asm.Sb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_bytes = function() {
            return (y._crypto_generichash_blake2b_bytes = y.asm.Tb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_keybytes_min = function() {
            return (y._crypto_generichash_blake2b_keybytes_min = y.asm.Ub).apply(null, arguments);
          }, y._crypto_generichash_blake2b_keybytes_max = function() {
            return (y._crypto_generichash_blake2b_keybytes_max = y.asm.Vb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_keybytes = function() {
            return (y._crypto_generichash_blake2b_keybytes = y.asm.Wb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_saltbytes = function() {
            return (y._crypto_generichash_blake2b_saltbytes = y.asm.Xb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_personalbytes = function() {
            return (y._crypto_generichash_blake2b_personalbytes = y.asm.Yb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_statebytes = function() {
            return (y._crypto_generichash_blake2b_statebytes = y.asm.Zb).apply(null, arguments);
          }, y._crypto_generichash_blake2b_keygen = function() {
            return (y._crypto_generichash_blake2b_keygen = y.asm._b).apply(null, arguments);
          }, y._crypto_generichash_blake2b = function() {
            return (y._crypto_generichash_blake2b = y.asm.$b).apply(null, arguments);
          }, y._crypto_generichash_blake2b_salt_personal = function() {
            return (y._crypto_generichash_blake2b_salt_personal = y.asm.ac).apply(null, arguments);
          }, y._crypto_generichash_blake2b_init = function() {
            return (y._crypto_generichash_blake2b_init = y.asm.bc).apply(null, arguments);
          }, y._crypto_generichash_blake2b_init_salt_personal = function() {
            return (y._crypto_generichash_blake2b_init_salt_personal = y.asm.cc).apply(null, arguments);
          }, y._crypto_generichash_blake2b_update = function() {
            return (y._crypto_generichash_blake2b_update = y.asm.dc).apply(null, arguments);
          }, y._crypto_generichash_blake2b_final = function() {
            return (y._crypto_generichash_blake2b_final = y.asm.ec).apply(null, arguments);
          }, y._crypto_hash_bytes = function() {
            return (y._crypto_hash_bytes = y.asm.fc).apply(null, arguments);
          }, y._crypto_hash = function() {
            return (y._crypto_hash = y.asm.gc).apply(null, arguments);
          }, y._crypto_hash_primitive = function() {
            return (y._crypto_hash_primitive = y.asm.hc).apply(null, arguments);
          }, y._crypto_hash_sha256_bytes = function() {
            return (y._crypto_hash_sha256_bytes = y.asm.ic).apply(null, arguments);
          }, y._crypto_hash_sha256_statebytes = function() {
            return (y._crypto_hash_sha256_statebytes = y.asm.jc).apply(null, arguments);
          }, y._crypto_hash_sha256_init = function() {
            return (y._crypto_hash_sha256_init = y.asm.kc).apply(null, arguments);
          }, y._crypto_hash_sha256_update = function() {
            return (y._crypto_hash_sha256_update = y.asm.lc).apply(null, arguments);
          }, y._crypto_hash_sha256_final = function() {
            return (y._crypto_hash_sha256_final = y.asm.mc).apply(null, arguments);
          }, y._crypto_hash_sha256 = function() {
            return (y._crypto_hash_sha256 = y.asm.nc).apply(null, arguments);
          }, y._crypto_hash_sha512_bytes = function() {
            return (y._crypto_hash_sha512_bytes = y.asm.oc).apply(null, arguments);
          }, y._crypto_hash_sha512_statebytes = function() {
            return (y._crypto_hash_sha512_statebytes = y.asm.pc).apply(null, arguments);
          }, y._crypto_hash_sha512_init = function() {
            return (y._crypto_hash_sha512_init = y.asm.qc).apply(null, arguments);
          }, y._crypto_hash_sha512_update = function() {
            return (y._crypto_hash_sha512_update = y.asm.rc).apply(null, arguments);
          }, y._crypto_hash_sha512_final = function() {
            return (y._crypto_hash_sha512_final = y.asm.sc).apply(null, arguments);
          }, y._crypto_hash_sha512 = function() {
            return (y._crypto_hash_sha512 = y.asm.tc).apply(null, arguments);
          }, y._crypto_kdf_blake2b_bytes_min = function() {
            return (y._crypto_kdf_blake2b_bytes_min = y.asm.uc).apply(null, arguments);
          }, y._crypto_kdf_blake2b_bytes_max = function() {
            return (y._crypto_kdf_blake2b_bytes_max = y.asm.vc).apply(null, arguments);
          }, y._crypto_kdf_blake2b_contextbytes = function() {
            return (y._crypto_kdf_blake2b_contextbytes = y.asm.wc).apply(null, arguments);
          }, y._crypto_kdf_blake2b_keybytes = function() {
            return (y._crypto_kdf_blake2b_keybytes = y.asm.xc).apply(null, arguments);
          }, y._crypto_kdf_blake2b_derive_from_key = function() {
            return (y._crypto_kdf_blake2b_derive_from_key = y.asm.yc).apply(null, arguments);
          }, y._crypto_kdf_primitive = function() {
            return (y._crypto_kdf_primitive = y.asm.zc).apply(null, arguments);
          }, y._crypto_kdf_bytes_min = function() {
            return (y._crypto_kdf_bytes_min = y.asm.Ac).apply(null, arguments);
          }, y._crypto_kdf_bytes_max = function() {
            return (y._crypto_kdf_bytes_max = y.asm.Bc).apply(null, arguments);
          }, y._crypto_kdf_contextbytes = function() {
            return (y._crypto_kdf_contextbytes = y.asm.Cc).apply(null, arguments);
          }, y._crypto_kdf_keybytes = function() {
            return (y._crypto_kdf_keybytes = y.asm.Dc).apply(null, arguments);
          }, y._crypto_kdf_derive_from_key = function() {
            return (y._crypto_kdf_derive_from_key = y.asm.Ec).apply(null, arguments);
          }, y._crypto_kdf_keygen = function() {
            return (y._crypto_kdf_keygen = y.asm.Fc).apply(null, arguments);
          }, y._crypto_kx_seed_keypair = function() {
            return (y._crypto_kx_seed_keypair = y.asm.Gc).apply(null, arguments);
          }, y._crypto_kx_keypair = function() {
            return (y._crypto_kx_keypair = y.asm.Hc).apply(null, arguments);
          }, y._crypto_kx_client_session_keys = function() {
            return (y._crypto_kx_client_session_keys = y.asm.Ic).apply(null, arguments);
          }, y._crypto_kx_server_session_keys = function() {
            return (y._crypto_kx_server_session_keys = y.asm.Jc).apply(null, arguments);
          }, y._crypto_kx_publickeybytes = function() {
            return (y._crypto_kx_publickeybytes = y.asm.Kc).apply(null, arguments);
          }, y._crypto_kx_secretkeybytes = function() {
            return (y._crypto_kx_secretkeybytes = y.asm.Lc).apply(null, arguments);
          }, y._crypto_kx_seedbytes = function() {
            return (y._crypto_kx_seedbytes = y.asm.Mc).apply(null, arguments);
          }, y._crypto_kx_sessionkeybytes = function() {
            return (y._crypto_kx_sessionkeybytes = y.asm.Nc).apply(null, arguments);
          }, y._crypto_kx_primitive = function() {
            return (y._crypto_kx_primitive = y.asm.Oc).apply(null, arguments);
          }, y._crypto_onetimeauth_statebytes = function() {
            return (y._crypto_onetimeauth_statebytes = y.asm.Pc).apply(null, arguments);
          }, y._crypto_onetimeauth_bytes = function() {
            return (y._crypto_onetimeauth_bytes = y.asm.Qc).apply(null, arguments);
          }, y._crypto_onetimeauth_keybytes = function() {
            return (y._crypto_onetimeauth_keybytes = y.asm.Rc).apply(null, arguments);
          }, y._crypto_onetimeauth = function() {
            return (y._crypto_onetimeauth = y.asm.Sc).apply(null, arguments);
          }, y._crypto_onetimeauth_verify = function() {
            return (y._crypto_onetimeauth_verify = y.asm.Tc).apply(null, arguments);
          }, y._crypto_onetimeauth_init = function() {
            return (y._crypto_onetimeauth_init = y.asm.Uc).apply(null, arguments);
          }, y._crypto_onetimeauth_update = function() {
            return (y._crypto_onetimeauth_update = y.asm.Vc).apply(null, arguments);
          }, y._crypto_onetimeauth_final = function() {
            return (y._crypto_onetimeauth_final = y.asm.Wc).apply(null, arguments);
          }, y._crypto_onetimeauth_primitive = function() {
            return (y._crypto_onetimeauth_primitive = y.asm.Xc).apply(null, arguments);
          }, y._crypto_onetimeauth_keygen = function() {
            return (y._crypto_onetimeauth_keygen = y.asm.Yc).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305 = function() {
            return (y._crypto_onetimeauth_poly1305 = y.asm.Zc).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305_verify = function() {
            return (y._crypto_onetimeauth_poly1305_verify = y.asm._c).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305_init = function() {
            return (y._crypto_onetimeauth_poly1305_init = y.asm.$c).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305_update = function() {
            return (y._crypto_onetimeauth_poly1305_update = y.asm.ad).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305_final = function() {
            return (y._crypto_onetimeauth_poly1305_final = y.asm.bd).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305_bytes = function() {
            return (y._crypto_onetimeauth_poly1305_bytes = y.asm.cd).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305_keybytes = function() {
            return (y._crypto_onetimeauth_poly1305_keybytes = y.asm.dd).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305_statebytes = function() {
            return (y._crypto_onetimeauth_poly1305_statebytes = y.asm.ed).apply(null, arguments);
          }, y._crypto_onetimeauth_poly1305_keygen = function() {
            return (y._crypto_onetimeauth_poly1305_keygen = y.asm.fd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_alg_argon2i13 = function() {
            return (y._crypto_pwhash_argon2i_alg_argon2i13 = y.asm.gd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_bytes_min = function() {
            return (y._crypto_pwhash_argon2i_bytes_min = y.asm.hd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_bytes_max = function() {
            return (y._crypto_pwhash_argon2i_bytes_max = y.asm.id).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_passwd_min = function() {
            return (y._crypto_pwhash_argon2i_passwd_min = y.asm.jd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_passwd_max = function() {
            return (y._crypto_pwhash_argon2i_passwd_max = y.asm.kd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_saltbytes = function() {
            return (y._crypto_pwhash_argon2i_saltbytes = y.asm.ld).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_strbytes = function() {
            return (y._crypto_pwhash_argon2i_strbytes = y.asm.md).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_strprefix = function() {
            return (y._crypto_pwhash_argon2i_strprefix = y.asm.nd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_opslimit_min = function() {
            return (y._crypto_pwhash_argon2i_opslimit_min = y.asm.od).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_opslimit_max = function() {
            return (y._crypto_pwhash_argon2i_opslimit_max = y.asm.pd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_memlimit_min = function() {
            return (y._crypto_pwhash_argon2i_memlimit_min = y.asm.qd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_memlimit_max = function() {
            return (y._crypto_pwhash_argon2i_memlimit_max = y.asm.rd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_opslimit_interactive = function() {
            return (y._crypto_pwhash_argon2i_opslimit_interactive = y.asm.sd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_memlimit_interactive = function() {
            return (y._crypto_pwhash_argon2i_memlimit_interactive = y.asm.td).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_opslimit_moderate = function() {
            return (y._crypto_pwhash_argon2i_opslimit_moderate = y.asm.ud).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_memlimit_moderate = function() {
            return (y._crypto_pwhash_argon2i_memlimit_moderate = y.asm.vd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_opslimit_sensitive = function() {
            return (y._crypto_pwhash_argon2i_opslimit_sensitive = y.asm.wd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_memlimit_sensitive = function() {
            return (y._crypto_pwhash_argon2i_memlimit_sensitive = y.asm.xd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i = function() {
            return (y._crypto_pwhash_argon2i = y.asm.yd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_str = function() {
            return (y._crypto_pwhash_argon2i_str = y.asm.zd).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_str_verify = function() {
            return (y._crypto_pwhash_argon2i_str_verify = y.asm.Ad).apply(null, arguments);
          }, y._crypto_pwhash_argon2i_str_needs_rehash = function() {
            return (y._crypto_pwhash_argon2i_str_needs_rehash = y.asm.Bd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_str_needs_rehash = function() {
            return (y._crypto_pwhash_argon2id_str_needs_rehash = y.asm.Cd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_alg_argon2id13 = function() {
            return (y._crypto_pwhash_argon2id_alg_argon2id13 = y.asm.Dd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_bytes_min = function() {
            return (y._crypto_pwhash_argon2id_bytes_min = y.asm.Ed).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_bytes_max = function() {
            return (y._crypto_pwhash_argon2id_bytes_max = y.asm.Fd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_passwd_min = function() {
            return (y._crypto_pwhash_argon2id_passwd_min = y.asm.Gd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_passwd_max = function() {
            return (y._crypto_pwhash_argon2id_passwd_max = y.asm.Hd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_saltbytes = function() {
            return (y._crypto_pwhash_argon2id_saltbytes = y.asm.Id).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_strbytes = function() {
            return (y._crypto_pwhash_argon2id_strbytes = y.asm.Jd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_strprefix = function() {
            return (y._crypto_pwhash_argon2id_strprefix = y.asm.Kd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_opslimit_min = function() {
            return (y._crypto_pwhash_argon2id_opslimit_min = y.asm.Ld).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_opslimit_max = function() {
            return (y._crypto_pwhash_argon2id_opslimit_max = y.asm.Md).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_memlimit_min = function() {
            return (y._crypto_pwhash_argon2id_memlimit_min = y.asm.Nd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_memlimit_max = function() {
            return (y._crypto_pwhash_argon2id_memlimit_max = y.asm.Od).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_opslimit_interactive = function() {
            return (y._crypto_pwhash_argon2id_opslimit_interactive = y.asm.Pd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_memlimit_interactive = function() {
            return (y._crypto_pwhash_argon2id_memlimit_interactive = y.asm.Qd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_opslimit_moderate = function() {
            return (y._crypto_pwhash_argon2id_opslimit_moderate = y.asm.Rd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_memlimit_moderate = function() {
            return (y._crypto_pwhash_argon2id_memlimit_moderate = y.asm.Sd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_opslimit_sensitive = function() {
            return (y._crypto_pwhash_argon2id_opslimit_sensitive = y.asm.Td).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_memlimit_sensitive = function() {
            return (y._crypto_pwhash_argon2id_memlimit_sensitive = y.asm.Ud).apply(null, arguments);
          }, y._crypto_pwhash_argon2id = function() {
            return (y._crypto_pwhash_argon2id = y.asm.Vd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_str = function() {
            return (y._crypto_pwhash_argon2id_str = y.asm.Wd).apply(null, arguments);
          }, y._crypto_pwhash_argon2id_str_verify = function() {
            return (y._crypto_pwhash_argon2id_str_verify = y.asm.Xd).apply(null, arguments);
          }, y._crypto_pwhash_alg_argon2i13 = function() {
            return (y._crypto_pwhash_alg_argon2i13 = y.asm.Yd).apply(null, arguments);
          }, y._crypto_pwhash_alg_argon2id13 = function() {
            return (y._crypto_pwhash_alg_argon2id13 = y.asm.Zd).apply(null, arguments);
          }, y._crypto_pwhash_alg_default = function() {
            return (y._crypto_pwhash_alg_default = y.asm._d).apply(null, arguments);
          }, y._crypto_pwhash_bytes_min = function() {
            return (y._crypto_pwhash_bytes_min = y.asm.$d).apply(null, arguments);
          }, y._crypto_pwhash_bytes_max = function() {
            return (y._crypto_pwhash_bytes_max = y.asm.ae).apply(null, arguments);
          }, y._crypto_pwhash_passwd_min = function() {
            return (y._crypto_pwhash_passwd_min = y.asm.be).apply(null, arguments);
          }, y._crypto_pwhash_passwd_max = function() {
            return (y._crypto_pwhash_passwd_max = y.asm.ce).apply(null, arguments);
          }, y._crypto_pwhash_saltbytes = function() {
            return (y._crypto_pwhash_saltbytes = y.asm.de).apply(null, arguments);
          }, y._crypto_pwhash_strbytes = function() {
            return (y._crypto_pwhash_strbytes = y.asm.ee).apply(null, arguments);
          }, y._crypto_pwhash_strprefix = function() {
            return (y._crypto_pwhash_strprefix = y.asm.fe).apply(null, arguments);
          }, y._crypto_pwhash_opslimit_min = function() {
            return (y._crypto_pwhash_opslimit_min = y.asm.ge).apply(null, arguments);
          }, y._crypto_pwhash_opslimit_max = function() {
            return (y._crypto_pwhash_opslimit_max = y.asm.he).apply(null, arguments);
          }, y._crypto_pwhash_memlimit_min = function() {
            return (y._crypto_pwhash_memlimit_min = y.asm.ie).apply(null, arguments);
          }, y._crypto_pwhash_memlimit_max = function() {
            return (y._crypto_pwhash_memlimit_max = y.asm.je).apply(null, arguments);
          }, y._crypto_pwhash_opslimit_interactive = function() {
            return (y._crypto_pwhash_opslimit_interactive = y.asm.ke).apply(null, arguments);
          }, y._crypto_pwhash_memlimit_interactive = function() {
            return (y._crypto_pwhash_memlimit_interactive = y.asm.le).apply(null, arguments);
          }, y._crypto_pwhash_opslimit_moderate = function() {
            return (y._crypto_pwhash_opslimit_moderate = y.asm.me).apply(null, arguments);
          }, y._crypto_pwhash_memlimit_moderate = function() {
            return (y._crypto_pwhash_memlimit_moderate = y.asm.ne).apply(null, arguments);
          }, y._crypto_pwhash_opslimit_sensitive = function() {
            return (y._crypto_pwhash_opslimit_sensitive = y.asm.oe).apply(null, arguments);
          }, y._crypto_pwhash_memlimit_sensitive = function() {
            return (y._crypto_pwhash_memlimit_sensitive = y.asm.pe).apply(null, arguments);
          }, y._crypto_pwhash = function() {
            return (y._crypto_pwhash = y.asm.qe).apply(null, arguments);
          }, y._crypto_pwhash_str = function() {
            return (y._crypto_pwhash_str = y.asm.re).apply(null, arguments);
          }, y._crypto_pwhash_str_alg = function() {
            return (y._crypto_pwhash_str_alg = y.asm.se).apply(null, arguments);
          }, y._crypto_pwhash_str_verify = function() {
            return (y._crypto_pwhash_str_verify = y.asm.te).apply(null, arguments);
          }, y._crypto_pwhash_str_needs_rehash = function() {
            return (y._crypto_pwhash_str_needs_rehash = y.asm.ue).apply(null, arguments);
          }, y._crypto_pwhash_primitive = function() {
            return (y._crypto_pwhash_primitive = y.asm.ve).apply(null, arguments);
          }, y._crypto_scalarmult_primitive = function() {
            return (y._crypto_scalarmult_primitive = y.asm.we).apply(null, arguments);
          }, y._crypto_scalarmult_base = function() {
            return (y._crypto_scalarmult_base = y.asm.xe).apply(null, arguments);
          }, y._crypto_scalarmult = function() {
            return (y._crypto_scalarmult = y.asm.ye).apply(null, arguments);
          }, y._crypto_scalarmult_bytes = function() {
            return (y._crypto_scalarmult_bytes = y.asm.ze).apply(null, arguments);
          }, y._crypto_scalarmult_scalarbytes = function() {
            return (y._crypto_scalarmult_scalarbytes = y.asm.Ae).apply(null, arguments);
          }, y._crypto_scalarmult_curve25519 = function() {
            return (y._crypto_scalarmult_curve25519 = y.asm.Be).apply(null, arguments);
          }, y._crypto_scalarmult_curve25519_base = function() {
            return (y._crypto_scalarmult_curve25519_base = y.asm.Ce).apply(null, arguments);
          }, y._crypto_scalarmult_curve25519_bytes = function() {
            return (y._crypto_scalarmult_curve25519_bytes = y.asm.De).apply(null, arguments);
          }, y._crypto_scalarmult_curve25519_scalarbytes = function() {
            return (y._crypto_scalarmult_curve25519_scalarbytes = y.asm.Ee).apply(null, arguments);
          }, y._crypto_secretbox_keybytes = function() {
            return (y._crypto_secretbox_keybytes = y.asm.Fe).apply(null, arguments);
          }, y._crypto_secretbox_noncebytes = function() {
            return (y._crypto_secretbox_noncebytes = y.asm.Ge).apply(null, arguments);
          }, y._crypto_secretbox_zerobytes = function() {
            return (y._crypto_secretbox_zerobytes = y.asm.He).apply(null, arguments);
          }, y._crypto_secretbox_boxzerobytes = function() {
            return (y._crypto_secretbox_boxzerobytes = y.asm.Ie).apply(null, arguments);
          }, y._crypto_secretbox_macbytes = function() {
            return (y._crypto_secretbox_macbytes = y.asm.Je).apply(null, arguments);
          }, y._crypto_secretbox_messagebytes_max = function() {
            return (y._crypto_secretbox_messagebytes_max = y.asm.Ke).apply(null, arguments);
          }, y._crypto_secretbox_primitive = function() {
            return (y._crypto_secretbox_primitive = y.asm.Le).apply(null, arguments);
          }, y._crypto_secretbox = function() {
            return (y._crypto_secretbox = y.asm.Me).apply(null, arguments);
          }, y._crypto_secretbox_open = function() {
            return (y._crypto_secretbox_open = y.asm.Ne).apply(null, arguments);
          }, y._crypto_secretbox_keygen = function() {
            return (y._crypto_secretbox_keygen = y.asm.Oe).apply(null, arguments);
          }, y._crypto_secretbox_detached = function() {
            return (y._crypto_secretbox_detached = y.asm.Pe).apply(null, arguments);
          }, y._crypto_secretbox_easy = function() {
            return (y._crypto_secretbox_easy = y.asm.Qe).apply(null, arguments);
          }, y._crypto_secretbox_open_detached = function() {
            return (y._crypto_secretbox_open_detached = y.asm.Re).apply(null, arguments);
          }, y._crypto_secretbox_open_easy = function() {
            return (y._crypto_secretbox_open_easy = y.asm.Se).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305 = function() {
            return (y._crypto_secretbox_xsalsa20poly1305 = y.asm.Te).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305_open = function() {
            return (y._crypto_secretbox_xsalsa20poly1305_open = y.asm.Ue).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305_keybytes = function() {
            return (y._crypto_secretbox_xsalsa20poly1305_keybytes = y.asm.Ve).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305_noncebytes = function() {
            return (y._crypto_secretbox_xsalsa20poly1305_noncebytes = y.asm.We).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305_zerobytes = function() {
            return (y._crypto_secretbox_xsalsa20poly1305_zerobytes = y.asm.Xe).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305_boxzerobytes = function() {
            return (y._crypto_secretbox_xsalsa20poly1305_boxzerobytes = y.asm.Ye).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305_macbytes = function() {
            return (y._crypto_secretbox_xsalsa20poly1305_macbytes = y.asm.Ze).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305_messagebytes_max = function() {
            return (y._crypto_secretbox_xsalsa20poly1305_messagebytes_max = y.asm._e).apply(null, arguments);
          }, y._crypto_secretbox_xsalsa20poly1305_keygen = function() {
            return (y._crypto_secretbox_xsalsa20poly1305_keygen = y.asm.$e).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_keygen = function() {
            return (y._crypto_secretstream_xchacha20poly1305_keygen = y.asm.af).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_init_push = function() {
            return (y._crypto_secretstream_xchacha20poly1305_init_push = y.asm.bf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_init_pull = function() {
            return (y._crypto_secretstream_xchacha20poly1305_init_pull = y.asm.cf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_rekey = function() {
            return (y._crypto_secretstream_xchacha20poly1305_rekey = y.asm.df).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_push = function() {
            return (y._crypto_secretstream_xchacha20poly1305_push = y.asm.ef).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_pull = function() {
            return (y._crypto_secretstream_xchacha20poly1305_pull = y.asm.ff).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_statebytes = function() {
            return (y._crypto_secretstream_xchacha20poly1305_statebytes = y.asm.gf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_abytes = function() {
            return (y._crypto_secretstream_xchacha20poly1305_abytes = y.asm.hf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_headerbytes = function() {
            return (y._crypto_secretstream_xchacha20poly1305_headerbytes = y.asm.jf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_keybytes = function() {
            return (y._crypto_secretstream_xchacha20poly1305_keybytes = y.asm.kf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_messagebytes_max = function() {
            return (y._crypto_secretstream_xchacha20poly1305_messagebytes_max = y.asm.lf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_tag_message = function() {
            return (y._crypto_secretstream_xchacha20poly1305_tag_message = y.asm.mf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_tag_push = function() {
            return (y._crypto_secretstream_xchacha20poly1305_tag_push = y.asm.nf).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_tag_rekey = function() {
            return (y._crypto_secretstream_xchacha20poly1305_tag_rekey = y.asm.of).apply(null, arguments);
          }, y._crypto_secretstream_xchacha20poly1305_tag_final = function() {
            return (y._crypto_secretstream_xchacha20poly1305_tag_final = y.asm.pf).apply(null, arguments);
          }, y._crypto_shorthash_bytes = function() {
            return (y._crypto_shorthash_bytes = y.asm.qf).apply(null, arguments);
          }, y._crypto_shorthash_keybytes = function() {
            return (y._crypto_shorthash_keybytes = y.asm.rf).apply(null, arguments);
          }, y._crypto_shorthash_primitive = function() {
            return (y._crypto_shorthash_primitive = y.asm.sf).apply(null, arguments);
          }, y._crypto_shorthash = function() {
            return (y._crypto_shorthash = y.asm.tf).apply(null, arguments);
          }, y._crypto_shorthash_keygen = function() {
            return (y._crypto_shorthash_keygen = y.asm.uf).apply(null, arguments);
          }, y._crypto_shorthash_siphash24_bytes = function() {
            return (y._crypto_shorthash_siphash24_bytes = y.asm.vf).apply(null, arguments);
          }, y._crypto_shorthash_siphash24_keybytes = function() {
            return (y._crypto_shorthash_siphash24_keybytes = y.asm.wf).apply(null, arguments);
          }, y._crypto_shorthash_siphash24 = function() {
            return (y._crypto_shorthash_siphash24 = y.asm.xf).apply(null, arguments);
          }, y._crypto_sign_statebytes = function() {
            return (y._crypto_sign_statebytes = y.asm.yf).apply(null, arguments);
          }, y._crypto_sign_bytes = function() {
            return (y._crypto_sign_bytes = y.asm.zf).apply(null, arguments);
          }, y._crypto_sign_seedbytes = function() {
            return (y._crypto_sign_seedbytes = y.asm.Af).apply(null, arguments);
          }, y._crypto_sign_publickeybytes = function() {
            return (y._crypto_sign_publickeybytes = y.asm.Bf).apply(null, arguments);
          }, y._crypto_sign_secretkeybytes = function() {
            return (y._crypto_sign_secretkeybytes = y.asm.Cf).apply(null, arguments);
          }, y._crypto_sign_messagebytes_max = function() {
            return (y._crypto_sign_messagebytes_max = y.asm.Df).apply(null, arguments);
          }, y._crypto_sign_primitive = function() {
            return (y._crypto_sign_primitive = y.asm.Ef).apply(null, arguments);
          }, y._crypto_sign_seed_keypair = function() {
            return (y._crypto_sign_seed_keypair = y.asm.Ff).apply(null, arguments);
          }, y._crypto_sign_keypair = function() {
            return (y._crypto_sign_keypair = y.asm.Gf).apply(null, arguments);
          }, y._crypto_sign = function() {
            return (y._crypto_sign = y.asm.Hf).apply(null, arguments);
          }, y._crypto_sign_open = function() {
            return (y._crypto_sign_open = y.asm.If).apply(null, arguments);
          }, y._crypto_sign_detached = function() {
            return (y._crypto_sign_detached = y.asm.Jf).apply(null, arguments);
          }, y._crypto_sign_verify_detached = function() {
            return (y._crypto_sign_verify_detached = y.asm.Kf).apply(null, arguments);
          }, y._crypto_sign_init = function() {
            return (y._crypto_sign_init = y.asm.Lf).apply(null, arguments);
          }, y._crypto_sign_update = function() {
            return (y._crypto_sign_update = y.asm.Mf).apply(null, arguments);
          }, y._crypto_sign_final_create = function() {
            return (y._crypto_sign_final_create = y.asm.Nf).apply(null, arguments);
          }, y._crypto_sign_final_verify = function() {
            return (y._crypto_sign_final_verify = y.asm.Of).apply(null, arguments);
          }, y._crypto_sign_ed25519ph_statebytes = function() {
            return (y._crypto_sign_ed25519ph_statebytes = y.asm.Pf).apply(null, arguments);
          }, y._crypto_sign_ed25519_bytes = function() {
            return (y._crypto_sign_ed25519_bytes = y.asm.Qf).apply(null, arguments);
          }, y._crypto_sign_ed25519_seedbytes = function() {
            return (y._crypto_sign_ed25519_seedbytes = y.asm.Rf).apply(null, arguments);
          }, y._crypto_sign_ed25519_publickeybytes = function() {
            return (y._crypto_sign_ed25519_publickeybytes = y.asm.Sf).apply(null, arguments);
          }, y._crypto_sign_ed25519_secretkeybytes = function() {
            return (y._crypto_sign_ed25519_secretkeybytes = y.asm.Tf).apply(null, arguments);
          }, y._crypto_sign_ed25519_messagebytes_max = function() {
            return (y._crypto_sign_ed25519_messagebytes_max = y.asm.Uf).apply(null, arguments);
          }, y._crypto_sign_ed25519_sk_to_seed = function() {
            return (y._crypto_sign_ed25519_sk_to_seed = y.asm.Vf).apply(null, arguments);
          }, y._crypto_sign_ed25519_sk_to_pk = function() {
            return (y._crypto_sign_ed25519_sk_to_pk = y.asm.Wf).apply(null, arguments);
          }, y._crypto_sign_ed25519ph_init = function() {
            return (y._crypto_sign_ed25519ph_init = y.asm.Xf).apply(null, arguments);
          }, y._crypto_sign_ed25519ph_update = function() {
            return (y._crypto_sign_ed25519ph_update = y.asm.Yf).apply(null, arguments);
          }, y._crypto_sign_ed25519ph_final_create = function() {
            return (y._crypto_sign_ed25519ph_final_create = y.asm.Zf).apply(null, arguments);
          }, y._crypto_sign_ed25519ph_final_verify = function() {
            return (y._crypto_sign_ed25519ph_final_verify = y.asm._f).apply(null, arguments);
          }, y._crypto_sign_ed25519_seed_keypair = function() {
            return (y._crypto_sign_ed25519_seed_keypair = y.asm.$f).apply(null, arguments);
          }, y._crypto_sign_ed25519_keypair = function() {
            return (y._crypto_sign_ed25519_keypair = y.asm.ag).apply(null, arguments);
          }, y._crypto_sign_ed25519_pk_to_curve25519 = function() {
            return (y._crypto_sign_ed25519_pk_to_curve25519 = y.asm.bg).apply(null, arguments);
          }, y._crypto_sign_ed25519_sk_to_curve25519 = function() {
            return (y._crypto_sign_ed25519_sk_to_curve25519 = y.asm.cg).apply(null, arguments);
          }, y._crypto_sign_ed25519_verify_detached = function() {
            return (y._crypto_sign_ed25519_verify_detached = y.asm.dg).apply(null, arguments);
          }, y._crypto_sign_ed25519_open = function() {
            return (y._crypto_sign_ed25519_open = y.asm.eg).apply(null, arguments);
          }, y._crypto_sign_ed25519_detached = function() {
            return (y._crypto_sign_ed25519_detached = y.asm.fg).apply(null, arguments);
          }, y._crypto_sign_ed25519 = function() {
            return (y._crypto_sign_ed25519 = y.asm.gg).apply(null, arguments);
          }, y._crypto_stream_chacha20_keybytes = function() {
            return (y._crypto_stream_chacha20_keybytes = y.asm.hg).apply(null, arguments);
          }, y._crypto_stream_chacha20_noncebytes = function() {
            return (y._crypto_stream_chacha20_noncebytes = y.asm.ig).apply(null, arguments);
          }, y._crypto_stream_chacha20_messagebytes_max = function() {
            return (y._crypto_stream_chacha20_messagebytes_max = y.asm.jg).apply(null, arguments);
          }, y._crypto_stream_chacha20_ietf_keybytes = function() {
            return (y._crypto_stream_chacha20_ietf_keybytes = y.asm.kg).apply(null, arguments);
          }, y._crypto_stream_chacha20_ietf_noncebytes = function() {
            return (y._crypto_stream_chacha20_ietf_noncebytes = y.asm.lg).apply(null, arguments);
          }, y._crypto_stream_chacha20_ietf_messagebytes_max = function() {
            return (y._crypto_stream_chacha20_ietf_messagebytes_max = y.asm.mg).apply(null, arguments);
          }, y._crypto_stream_chacha20 = function() {
            return (y._crypto_stream_chacha20 = y.asm.ng).apply(null, arguments);
          }, y._crypto_stream_chacha20_xor_ic = function() {
            return (y._crypto_stream_chacha20_xor_ic = y.asm.og).apply(null, arguments);
          }, y._crypto_stream_chacha20_xor = function() {
            return (y._crypto_stream_chacha20_xor = y.asm.pg).apply(null, arguments);
          }, y._crypto_stream_chacha20_ietf = function() {
            return (y._crypto_stream_chacha20_ietf = y.asm.qg).apply(null, arguments);
          }, y._crypto_stream_chacha20_ietf_xor_ic = function() {
            return (y._crypto_stream_chacha20_ietf_xor_ic = y.asm.rg).apply(null, arguments);
          }, y._crypto_stream_chacha20_ietf_xor = function() {
            return (y._crypto_stream_chacha20_ietf_xor = y.asm.sg).apply(null, arguments);
          }, y._crypto_stream_chacha20_ietf_keygen = function() {
            return (y._crypto_stream_chacha20_ietf_keygen = y.asm.tg).apply(null, arguments);
          }, y._crypto_stream_chacha20_keygen = function() {
            return (y._crypto_stream_chacha20_keygen = y.asm.ug).apply(null, arguments);
          }, y._crypto_stream_keybytes = function() {
            return (y._crypto_stream_keybytes = y.asm.vg).apply(null, arguments);
          }, y._crypto_stream_noncebytes = function() {
            return (y._crypto_stream_noncebytes = y.asm.wg).apply(null, arguments);
          }, y._crypto_stream_messagebytes_max = function() {
            return (y._crypto_stream_messagebytes_max = y.asm.xg).apply(null, arguments);
          }, y._crypto_stream_primitive = function() {
            return (y._crypto_stream_primitive = y.asm.yg).apply(null, arguments);
          }, y._crypto_stream = function() {
            return (y._crypto_stream = y.asm.zg).apply(null, arguments);
          }, y._crypto_stream_xor = function() {
            return (y._crypto_stream_xor = y.asm.Ag).apply(null, arguments);
          }, y._crypto_stream_keygen = function() {
            return (y._crypto_stream_keygen = y.asm.Bg).apply(null, arguments);
          }, y._crypto_stream_salsa20_keybytes = function() {
            return (y._crypto_stream_salsa20_keybytes = y.asm.Cg).apply(null, arguments);
          }, y._crypto_stream_salsa20_noncebytes = function() {
            return (y._crypto_stream_salsa20_noncebytes = y.asm.Dg).apply(null, arguments);
          }, y._crypto_stream_salsa20_messagebytes_max = function() {
            return (y._crypto_stream_salsa20_messagebytes_max = y.asm.Eg).apply(null, arguments);
          }, y._crypto_stream_salsa20 = function() {
            return (y._crypto_stream_salsa20 = y.asm.Fg).apply(null, arguments);
          }, y._crypto_stream_salsa20_xor_ic = function() {
            return (y._crypto_stream_salsa20_xor_ic = y.asm.Gg).apply(null, arguments);
          }, y._crypto_stream_salsa20_xor = function() {
            return (y._crypto_stream_salsa20_xor = y.asm.Hg).apply(null, arguments);
          }, y._crypto_stream_salsa20_keygen = function() {
            return (y._crypto_stream_salsa20_keygen = y.asm.Ig).apply(null, arguments);
          }, y._crypto_stream_xsalsa20 = function() {
            return (y._crypto_stream_xsalsa20 = y.asm.Jg).apply(null, arguments);
          }, y._crypto_stream_xsalsa20_xor_ic = function() {
            return (y._crypto_stream_xsalsa20_xor_ic = y.asm.Kg).apply(null, arguments);
          }, y._crypto_stream_xsalsa20_xor = function() {
            return (y._crypto_stream_xsalsa20_xor = y.asm.Lg).apply(null, arguments);
          }, y._crypto_stream_xsalsa20_keybytes = function() {
            return (y._crypto_stream_xsalsa20_keybytes = y.asm.Mg).apply(null, arguments);
          }, y._crypto_stream_xsalsa20_noncebytes = function() {
            return (y._crypto_stream_xsalsa20_noncebytes = y.asm.Ng).apply(null, arguments);
          }, y._crypto_stream_xsalsa20_messagebytes_max = function() {
            return (y._crypto_stream_xsalsa20_messagebytes_max = y.asm.Og).apply(null, arguments);
          }, y._crypto_stream_xsalsa20_keygen = function() {
            return (y._crypto_stream_xsalsa20_keygen = y.asm.Pg).apply(null, arguments);
          }, y._crypto_verify_16_bytes = function() {
            return (y._crypto_verify_16_bytes = y.asm.Qg).apply(null, arguments);
          }, y._crypto_verify_32_bytes = function() {
            return (y._crypto_verify_32_bytes = y.asm.Rg).apply(null, arguments);
          }, y._crypto_verify_64_bytes = function() {
            return (y._crypto_verify_64_bytes = y.asm.Sg).apply(null, arguments);
          }, y._crypto_verify_16 = function() {
            return (y._crypto_verify_16 = y.asm.Tg).apply(null, arguments);
          }, y._crypto_verify_32 = function() {
            return (y._crypto_verify_32 = y.asm.Ug).apply(null, arguments);
          }, y._crypto_verify_64 = function() {
            return (y._crypto_verify_64 = y.asm.Vg).apply(null, arguments);
          }, y._randombytes_implementation_name = function() {
            return (y._randombytes_implementation_name = y.asm.Wg).apply(null, arguments);
          }, y._randombytes_random = function() {
            return (y._randombytes_random = y.asm.Xg).apply(null, arguments);
          }, y._randombytes_stir = function() {
            return (y._randombytes_stir = y.asm.Yg).apply(null, arguments);
          }, y._randombytes_uniform = function() {
            return (y._randombytes_uniform = y.asm.Zg).apply(null, arguments);
          }, y._randombytes_buf = function() {
            return (y._randombytes_buf = y.asm._g).apply(null, arguments);
          }, y._randombytes_buf_deterministic = function() {
            return (y._randombytes_buf_deterministic = y.asm.$g).apply(null, arguments);
          }, y._randombytes_seedbytes = function() {
            return (y._randombytes_seedbytes = y.asm.ah).apply(null, arguments);
          }, y._randombytes_close = function() {
            return (y._randombytes_close = y.asm.bh).apply(null, arguments);
          }, y._randombytes = function() {
            return (y._randombytes = y.asm.ch).apply(null, arguments);
          }, y._sodium_bin2hex = function() {
            return (y._sodium_bin2hex = y.asm.dh).apply(null, arguments);
          }, y._sodium_hex2bin = function() {
            return (y._sodium_hex2bin = y.asm.eh).apply(null, arguments);
          }, y._sodium_base64_encoded_len = function() {
            return (y._sodium_base64_encoded_len = y.asm.fh).apply(null, arguments);
          }, y._sodium_bin2base64 = function() {
            return (y._sodium_bin2base64 = y.asm.gh).apply(null, arguments);
          }, y._sodium_base642bin = function() {
            return (y._sodium_base642bin = y.asm.hh).apply(null, arguments);
          }, y._sodium_init = function() {
            return (y._sodium_init = y.asm.ih).apply(null, arguments);
          }, y._sodium_pad = function() {
            return (y._sodium_pad = y.asm.jh).apply(null, arguments);
          }, y._sodium_unpad = function() {
            return (y._sodium_unpad = y.asm.kh).apply(null, arguments);
          }, y._sodium_version_string = function() {
            return (y._sodium_version_string = y.asm.lh).apply(null, arguments);
          }, y._sodium_library_version_major = function() {
            return (y._sodium_library_version_major = y.asm.mh).apply(null, arguments);
          }, y._sodium_library_version_minor = function() {
            return (y._sodium_library_version_minor = y.asm.nh).apply(null, arguments);
          }, y._sodium_library_minimal = function() {
            return (y._sodium_library_minimal = y.asm.oh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_seed_keypair = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_seed_keypair = y.asm.ph).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_keypair = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_keypair = y.asm.qh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_beforenm = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_beforenm = y.asm.rh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_detached_afternm = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_detached_afternm = y.asm.sh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_detached = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_detached = y.asm.th).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_easy_afternm = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_easy_afternm = y.asm.uh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_easy = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_easy = y.asm.vh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = y.asm.wh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_open_detached = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_open_detached = y.asm.xh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = y.asm.yh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_open_easy = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_open_easy = y.asm.zh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_seedbytes = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_seedbytes = y.asm.Ah).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_publickeybytes = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_publickeybytes = y.asm.Bh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_secretkeybytes = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_secretkeybytes = y.asm.Ch).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_beforenmbytes = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_beforenmbytes = y.asm.Dh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_noncebytes = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_noncebytes = y.asm.Eh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_macbytes = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_macbytes = y.asm.Fh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_messagebytes_max = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_messagebytes_max = y.asm.Gh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_seal = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_seal = y.asm.Hh).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_seal_open = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_seal_open = y.asm.Ih).apply(null, arguments);
          }, y._crypto_box_curve25519xchacha20poly1305_sealbytes = function() {
            return (y._crypto_box_curve25519xchacha20poly1305_sealbytes = y.asm.Jh).apply(null, arguments);
          }, y._crypto_core_ed25519_is_valid_point = function() {
            return (y._crypto_core_ed25519_is_valid_point = y.asm.Kh).apply(null, arguments);
          }, y._crypto_core_ed25519_add = function() {
            return (y._crypto_core_ed25519_add = y.asm.Lh).apply(null, arguments);
          }, y._crypto_core_ed25519_sub = function() {
            return (y._crypto_core_ed25519_sub = y.asm.Mh).apply(null, arguments);
          }, y._crypto_core_ed25519_from_uniform = function() {
            return (y._crypto_core_ed25519_from_uniform = y.asm.Nh).apply(null, arguments);
          }, y._crypto_core_ed25519_from_hash = function() {
            return (y._crypto_core_ed25519_from_hash = y.asm.Oh).apply(null, arguments);
          }, y._crypto_core_ed25519_random = function() {
            return (y._crypto_core_ed25519_random = y.asm.Ph).apply(null, arguments);
          }, y._crypto_core_ed25519_scalar_random = function() {
            return (y._crypto_core_ed25519_scalar_random = y.asm.Qh).apply(null, arguments);
          }, y._crypto_core_ed25519_scalar_invert = function() {
            return (y._crypto_core_ed25519_scalar_invert = y.asm.Rh).apply(null, arguments);
          }, y._crypto_core_ed25519_scalar_negate = function() {
            return (y._crypto_core_ed25519_scalar_negate = y.asm.Sh).apply(null, arguments);
          }, y._crypto_core_ed25519_scalar_complement = function() {
            return (y._crypto_core_ed25519_scalar_complement = y.asm.Th).apply(null, arguments);
          }, y._crypto_core_ed25519_scalar_add = function() {
            return (y._crypto_core_ed25519_scalar_add = y.asm.Uh).apply(null, arguments);
          }, y._crypto_core_ed25519_scalar_reduce = function() {
            return (y._crypto_core_ed25519_scalar_reduce = y.asm.Vh).apply(null, arguments);
          }, y._crypto_core_ed25519_scalar_sub = function() {
            return (y._crypto_core_ed25519_scalar_sub = y.asm.Wh).apply(null, arguments);
          }, y._crypto_core_ed25519_scalar_mul = function() {
            return (y._crypto_core_ed25519_scalar_mul = y.asm.Xh).apply(null, arguments);
          }, y._crypto_core_ed25519_bytes = function() {
            return (y._crypto_core_ed25519_bytes = y.asm.Yh).apply(null, arguments);
          }, y._crypto_core_ed25519_nonreducedscalarbytes = function() {
            return (y._crypto_core_ed25519_nonreducedscalarbytes = y.asm.Zh).apply(null, arguments);
          }, y._crypto_core_ed25519_uniformbytes = function() {
            return (y._crypto_core_ed25519_uniformbytes = y.asm._h).apply(null, arguments);
          }, y._crypto_core_ed25519_hashbytes = function() {
            return (y._crypto_core_ed25519_hashbytes = y.asm.$h).apply(null, arguments);
          }, y._crypto_core_ed25519_scalarbytes = function() {
            return (y._crypto_core_ed25519_scalarbytes = y.asm.ai).apply(null, arguments);
          }, y._crypto_core_ristretto255_is_valid_point = function() {
            return (y._crypto_core_ristretto255_is_valid_point = y.asm.bi).apply(null, arguments);
          }, y._crypto_core_ristretto255_add = function() {
            return (y._crypto_core_ristretto255_add = y.asm.ci).apply(null, arguments);
          }, y._crypto_core_ristretto255_sub = function() {
            return (y._crypto_core_ristretto255_sub = y.asm.di).apply(null, arguments);
          }, y._crypto_core_ristretto255_from_hash = function() {
            return (y._crypto_core_ristretto255_from_hash = y.asm.ei).apply(null, arguments);
          }, y._crypto_core_ristretto255_random = function() {
            return (y._crypto_core_ristretto255_random = y.asm.fi).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalar_random = function() {
            return (y._crypto_core_ristretto255_scalar_random = y.asm.gi).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalar_invert = function() {
            return (y._crypto_core_ristretto255_scalar_invert = y.asm.hi).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalar_negate = function() {
            return (y._crypto_core_ristretto255_scalar_negate = y.asm.ii).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalar_complement = function() {
            return (y._crypto_core_ristretto255_scalar_complement = y.asm.ji).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalar_add = function() {
            return (y._crypto_core_ristretto255_scalar_add = y.asm.ki).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalar_sub = function() {
            return (y._crypto_core_ristretto255_scalar_sub = y.asm.li).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalar_mul = function() {
            return (y._crypto_core_ristretto255_scalar_mul = y.asm.mi).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalar_reduce = function() {
            return (y._crypto_core_ristretto255_scalar_reduce = y.asm.ni).apply(null, arguments);
          }, y._crypto_core_ristretto255_bytes = function() {
            return (y._crypto_core_ristretto255_bytes = y.asm.oi).apply(null, arguments);
          }, y._crypto_core_ristretto255_nonreducedscalarbytes = function() {
            return (y._crypto_core_ristretto255_nonreducedscalarbytes = y.asm.pi).apply(null, arguments);
          }, y._crypto_core_ristretto255_hashbytes = function() {
            return (y._crypto_core_ristretto255_hashbytes = y.asm.qi).apply(null, arguments);
          }, y._crypto_core_ristretto255_scalarbytes = function() {
            return (y._crypto_core_ristretto255_scalarbytes = y.asm.ri).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_ll = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_ll = y.asm.si).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_bytes_min = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_bytes_min = y.asm.ti).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_bytes_max = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_bytes_max = y.asm.ui).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_passwd_min = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_passwd_min = y.asm.vi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_passwd_max = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_passwd_max = y.asm.wi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_saltbytes = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_saltbytes = y.asm.xi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_strbytes = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_strbytes = y.asm.yi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_strprefix = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_strprefix = y.asm.zi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_opslimit_min = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_opslimit_min = y.asm.Ai).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_opslimit_max = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_opslimit_max = y.asm.Bi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_memlimit_min = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_memlimit_min = y.asm.Ci).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_memlimit_max = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_memlimit_max = y.asm.Di).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = y.asm.Ei).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = y.asm.Fi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = y.asm.Gi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = y.asm.Hi).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256 = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256 = y.asm.Ii).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_str = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_str = y.asm.Ji).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_str_verify = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_str_verify = y.asm.Ki).apply(null, arguments);
          }, y._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = function() {
            return (y._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = y.asm.Li).apply(null, arguments);
          }, y._crypto_scalarmult_ed25519 = function() {
            return (y._crypto_scalarmult_ed25519 = y.asm.Mi).apply(null, arguments);
          }, y._crypto_scalarmult_ed25519_noclamp = function() {
            return (y._crypto_scalarmult_ed25519_noclamp = y.asm.Ni).apply(null, arguments);
          }, y._crypto_scalarmult_ed25519_base = function() {
            return (y._crypto_scalarmult_ed25519_base = y.asm.Oi).apply(null, arguments);
          }, y._crypto_scalarmult_ed25519_base_noclamp = function() {
            return (y._crypto_scalarmult_ed25519_base_noclamp = y.asm.Pi).apply(null, arguments);
          }, y._crypto_scalarmult_ed25519_bytes = function() {
            return (y._crypto_scalarmult_ed25519_bytes = y.asm.Qi).apply(null, arguments);
          }, y._crypto_scalarmult_ed25519_scalarbytes = function() {
            return (y._crypto_scalarmult_ed25519_scalarbytes = y.asm.Ri).apply(null, arguments);
          }, y._crypto_scalarmult_ristretto255 = function() {
            return (y._crypto_scalarmult_ristretto255 = y.asm.Si).apply(null, arguments);
          }, y._crypto_scalarmult_ristretto255_base = function() {
            return (y._crypto_scalarmult_ristretto255_base = y.asm.Ti).apply(null, arguments);
          }, y._crypto_scalarmult_ristretto255_bytes = function() {
            return (y._crypto_scalarmult_ristretto255_bytes = y.asm.Ui).apply(null, arguments);
          }, y._crypto_scalarmult_ristretto255_scalarbytes = function() {
            return (y._crypto_scalarmult_ristretto255_scalarbytes = y.asm.Vi).apply(null, arguments);
          }, y._crypto_secretbox_xchacha20poly1305_detached = function() {
            return (y._crypto_secretbox_xchacha20poly1305_detached = y.asm.Wi).apply(null, arguments);
          }, y._crypto_secretbox_xchacha20poly1305_easy = function() {
            return (y._crypto_secretbox_xchacha20poly1305_easy = y.asm.Xi).apply(null, arguments);
          }, y._crypto_secretbox_xchacha20poly1305_open_detached = function() {
            return (y._crypto_secretbox_xchacha20poly1305_open_detached = y.asm.Yi).apply(null, arguments);
          }, y._crypto_secretbox_xchacha20poly1305_open_easy = function() {
            return (y._crypto_secretbox_xchacha20poly1305_open_easy = y.asm.Zi).apply(null, arguments);
          }, y._crypto_secretbox_xchacha20poly1305_keybytes = function() {
            return (y._crypto_secretbox_xchacha20poly1305_keybytes = y.asm._i).apply(null, arguments);
          }, y._crypto_secretbox_xchacha20poly1305_noncebytes = function() {
            return (y._crypto_secretbox_xchacha20poly1305_noncebytes = y.asm.$i).apply(null, arguments);
          }, y._crypto_secretbox_xchacha20poly1305_macbytes = function() {
            return (y._crypto_secretbox_xchacha20poly1305_macbytes = y.asm.aj).apply(null, arguments);
          }, y._crypto_secretbox_xchacha20poly1305_messagebytes_max = function() {
            return (y._crypto_secretbox_xchacha20poly1305_messagebytes_max = y.asm.bj).apply(null, arguments);
          }, y._crypto_shorthash_siphashx24_bytes = function() {
            return (y._crypto_shorthash_siphashx24_bytes = y.asm.cj).apply(null, arguments);
          }, y._crypto_shorthash_siphashx24_keybytes = function() {
            return (y._crypto_shorthash_siphashx24_keybytes = y.asm.dj).apply(null, arguments);
          }, y._crypto_shorthash_siphashx24 = function() {
            return (y._crypto_shorthash_siphashx24 = y.asm.ej).apply(null, arguments);
          }, y._crypto_stream_salsa2012 = function() {
            return (y._crypto_stream_salsa2012 = y.asm.fj).apply(null, arguments);
          }, y._crypto_stream_salsa2012_xor = function() {
            return (y._crypto_stream_salsa2012_xor = y.asm.gj).apply(null, arguments);
          }, y._crypto_stream_salsa2012_keybytes = function() {
            return (y._crypto_stream_salsa2012_keybytes = y.asm.hj).apply(null, arguments);
          }, y._crypto_stream_salsa2012_noncebytes = function() {
            return (y._crypto_stream_salsa2012_noncebytes = y.asm.ij).apply(null, arguments);
          }, y._crypto_stream_salsa2012_messagebytes_max = function() {
            return (y._crypto_stream_salsa2012_messagebytes_max = y.asm.jj).apply(null, arguments);
          }, y._crypto_stream_salsa2012_keygen = function() {
            return (y._crypto_stream_salsa2012_keygen = y.asm.kj).apply(null, arguments);
          }, y._crypto_stream_salsa208 = function() {
            return (y._crypto_stream_salsa208 = y.asm.lj).apply(null, arguments);
          }, y._crypto_stream_salsa208_xor = function() {
            return (y._crypto_stream_salsa208_xor = y.asm.mj).apply(null, arguments);
          }, y._crypto_stream_salsa208_keybytes = function() {
            return (y._crypto_stream_salsa208_keybytes = y.asm.nj).apply(null, arguments);
          }, y._crypto_stream_salsa208_noncebytes = function() {
            return (y._crypto_stream_salsa208_noncebytes = y.asm.oj).apply(null, arguments);
          }, y._crypto_stream_salsa208_messagebytes_max = function() {
            return (y._crypto_stream_salsa208_messagebytes_max = y.asm.pj).apply(null, arguments);
          }, y._crypto_stream_salsa208_keygen = function() {
            return (y._crypto_stream_salsa208_keygen = y.asm.qj).apply(null, arguments);
          }, y._crypto_stream_xchacha20_keybytes = function() {
            return (y._crypto_stream_xchacha20_keybytes = y.asm.rj).apply(null, arguments);
          }, y._crypto_stream_xchacha20_noncebytes = function() {
            return (y._crypto_stream_xchacha20_noncebytes = y.asm.sj).apply(null, arguments);
          }, y._crypto_stream_xchacha20_messagebytes_max = function() {
            return (y._crypto_stream_xchacha20_messagebytes_max = y.asm.tj).apply(null, arguments);
          }, y._crypto_stream_xchacha20 = function() {
            return (y._crypto_stream_xchacha20 = y.asm.uj).apply(null, arguments);
          }, y._crypto_stream_xchacha20_xor_ic = function() {
            return (y._crypto_stream_xchacha20_xor_ic = y.asm.vj).apply(null, arguments);
          }, y._crypto_stream_xchacha20_xor = function() {
            return (y._crypto_stream_xchacha20_xor = y.asm.wj).apply(null, arguments);
          }, y._crypto_stream_xchacha20_keygen = function() {
            return (y._crypto_stream_xchacha20_keygen = y.asm.xj).apply(null, arguments);
          }, y._malloc = function() {
            return (y._malloc = y.asm.yj).apply(null, arguments);
          }, y._free = function() {
            return (y._free = y.asm.zj).apply(null, arguments);
          }, y.UTF8ToString = fe, y.setValue = function(At, hn, $t = "i8") {
            switch ($t.endsWith("*") && ($t = "*"), $t) {
              case "i1":
              case "i8":
                pe[At >> 0] = hn;
                break;
              case "i16":
                ne[At >> 1] = hn;
                break;
              case "i32":
                H[At >> 2] = hn;
                break;
              case "i64":
                Qt = [hn >>> 0, (nt = hn, +Math.abs(nt) >= 1 ? nt > 0 ? (0 | Math.min(+Math.floor(nt / 4294967296), 4294967295)) >>> 0 : ~~+Math.ceil((nt - +(~~nt >>> 0)) / 4294967296) >>> 0 : 0)], H[At >> 2] = Qt[0], H[At + 4 >> 2] = Qt[1];
                break;
              case "float":
                w[At >> 2] = hn;
                break;
              case "double":
                P[At >> 3] = hn;
                break;
              case "*":
                C[At >> 2] = hn;
                break;
              default:
                Ke("invalid type for setValue: " + $t);
            }
          }, y.getValue = function(At, hn = "i8") {
            switch (hn.endsWith("*") && (hn = "*"), hn) {
              case "i1":
              case "i8":
                return pe[At >> 0];
              case "i16":
                return ne[At >> 1];
              case "i32":
              case "i64":
                return H[At >> 2];
              case "float":
                return w[At >> 2];
              case "double":
                return P[At >> 3];
              case "*":
                return C[At >> 2];
              default:
                Ke("invalid type for getValue: " + hn);
            }
            return null;
          }, Pe = function At() {
            Xt || sn(), Xt || (Pe = At);
          }, y.preInit)
            for (typeof y.preInit == "function" && (y.preInit = [y.preInit]); y.preInit.length > 0; )
              y.preInit.pop()();
          sn();
        }).catch(function() {
          return v.useBackupModule();
        }), d;
      }
      typeof n.nodeName != "string" ? u(n) : o.libsodium = u(o.libsodium_mod || (o.commonJsStrict = {}));
    })(commonjsGlobal);
  }(libsodiumSumo, libsodiumSumo.exports)), libsodiumSumo.exports;
}
(function(e) {
  (function(n) {
    function o(c, d) {
      var m, v = "uint8array", S = d.ready.then(function() {
        function Se() {
          if (m._sodium_init() !== 0)
            throw new Error("libsodium was not correctly initialized.");
          for (var qe = ["crypto_aead_chacha20poly1305_decrypt", "crypto_aead_chacha20poly1305_decrypt_detached", "crypto_aead_chacha20poly1305_encrypt", "crypto_aead_chacha20poly1305_encrypt_detached", "crypto_aead_chacha20poly1305_ietf_decrypt", "crypto_aead_chacha20poly1305_ietf_decrypt_detached", "crypto_aead_chacha20poly1305_ietf_encrypt", "crypto_aead_chacha20poly1305_ietf_encrypt_detached", "crypto_aead_chacha20poly1305_ietf_keygen", "crypto_aead_chacha20poly1305_keygen", "crypto_aead_xchacha20poly1305_ietf_decrypt", "crypto_aead_xchacha20poly1305_ietf_decrypt_detached", "crypto_aead_xchacha20poly1305_ietf_encrypt", "crypto_aead_xchacha20poly1305_ietf_encrypt_detached", "crypto_aead_xchacha20poly1305_ietf_keygen", "crypto_auth", "crypto_auth_hmacsha256", "crypto_auth_hmacsha256_final", "crypto_auth_hmacsha256_init", "crypto_auth_hmacsha256_keygen", "crypto_auth_hmacsha256_update", "crypto_auth_hmacsha256_verify", "crypto_auth_hmacsha512", "crypto_auth_hmacsha512_final", "crypto_auth_hmacsha512_init", "crypto_auth_hmacsha512_keygen", "crypto_auth_hmacsha512_update", "crypto_auth_hmacsha512_verify", "crypto_auth_keygen", "crypto_auth_verify", "crypto_box_beforenm", "crypto_box_curve25519xchacha20poly1305_keypair", "crypto_box_curve25519xchacha20poly1305_seal", "crypto_box_curve25519xchacha20poly1305_seal_open", "crypto_box_detached", "crypto_box_easy", "crypto_box_easy_afternm", "crypto_box_keypair", "crypto_box_open_detached", "crypto_box_open_easy", "crypto_box_open_easy_afternm", "crypto_box_seal", "crypto_box_seal_open", "crypto_box_seed_keypair", "crypto_core_ed25519_add", "crypto_core_ed25519_from_hash", "crypto_core_ed25519_from_uniform", "crypto_core_ed25519_is_valid_point", "crypto_core_ed25519_random", "crypto_core_ed25519_scalar_add", "crypto_core_ed25519_scalar_complement", "crypto_core_ed25519_scalar_invert", "crypto_core_ed25519_scalar_mul", "crypto_core_ed25519_scalar_negate", "crypto_core_ed25519_scalar_random", "crypto_core_ed25519_scalar_reduce", "crypto_core_ed25519_scalar_sub", "crypto_core_ed25519_sub", "crypto_core_hchacha20", "crypto_core_hsalsa20", "crypto_core_ristretto255_add", "crypto_core_ristretto255_from_hash", "crypto_core_ristretto255_is_valid_point", "crypto_core_ristretto255_random", "crypto_core_ristretto255_scalar_add", "crypto_core_ristretto255_scalar_complement", "crypto_core_ristretto255_scalar_invert", "crypto_core_ristretto255_scalar_mul", "crypto_core_ristretto255_scalar_negate", "crypto_core_ristretto255_scalar_random", "crypto_core_ristretto255_scalar_reduce", "crypto_core_ristretto255_scalar_sub", "crypto_core_ristretto255_sub", "crypto_generichash", "crypto_generichash_blake2b_salt_personal", "crypto_generichash_final", "crypto_generichash_init", "crypto_generichash_keygen", "crypto_generichash_update", "crypto_hash", "crypto_hash_sha256", "crypto_hash_sha256_final", "crypto_hash_sha256_init", "crypto_hash_sha256_update", "crypto_hash_sha512", "crypto_hash_sha512_final", "crypto_hash_sha512_init", "crypto_hash_sha512_update", "crypto_kdf_derive_from_key", "crypto_kdf_keygen", "crypto_kx_client_session_keys", "crypto_kx_keypair", "crypto_kx_seed_keypair", "crypto_kx_server_session_keys", "crypto_onetimeauth", "crypto_onetimeauth_final", "crypto_onetimeauth_init", "crypto_onetimeauth_keygen", "crypto_onetimeauth_update", "crypto_onetimeauth_verify", "crypto_pwhash", "crypto_pwhash_scryptsalsa208sha256", "crypto_pwhash_scryptsalsa208sha256_ll", "crypto_pwhash_scryptsalsa208sha256_str", "crypto_pwhash_scryptsalsa208sha256_str_verify", "crypto_pwhash_str", "crypto_pwhash_str_needs_rehash", "crypto_pwhash_str_verify", "crypto_scalarmult", "crypto_scalarmult_base", "crypto_scalarmult_ed25519", "crypto_scalarmult_ed25519_base", "crypto_scalarmult_ed25519_base_noclamp", "crypto_scalarmult_ed25519_noclamp", "crypto_scalarmult_ristretto255", "crypto_scalarmult_ristretto255_base", "crypto_secretbox_detached", "crypto_secretbox_easy", "crypto_secretbox_keygen", "crypto_secretbox_open_detached", "crypto_secretbox_open_easy", "crypto_secretstream_xchacha20poly1305_init_pull", "crypto_secretstream_xchacha20poly1305_init_push", "crypto_secretstream_xchacha20poly1305_keygen", "crypto_secretstream_xchacha20poly1305_pull", "crypto_secretstream_xchacha20poly1305_push", "crypto_secretstream_xchacha20poly1305_rekey", "crypto_shorthash", "crypto_shorthash_keygen", "crypto_shorthash_siphashx24", "crypto_sign", "crypto_sign_detached", "crypto_sign_ed25519_pk_to_curve25519", "crypto_sign_ed25519_sk_to_curve25519", "crypto_sign_ed25519_sk_to_pk", "crypto_sign_ed25519_sk_to_seed", "crypto_sign_final_create", "crypto_sign_final_verify", "crypto_sign_init", "crypto_sign_keypair", "crypto_sign_open", "crypto_sign_seed_keypair", "crypto_sign_update", "crypto_sign_verify_detached", "crypto_stream_chacha20", "crypto_stream_chacha20_ietf_xor", "crypto_stream_chacha20_ietf_xor_ic", "crypto_stream_chacha20_keygen", "crypto_stream_chacha20_xor", "crypto_stream_chacha20_xor_ic", "crypto_stream_keygen", "crypto_stream_xchacha20_keygen", "crypto_stream_xchacha20_xor", "crypto_stream_xchacha20_xor_ic", "randombytes_buf", "randombytes_buf_deterministic", "randombytes_close", "randombytes_random", "randombytes_set_implementation", "randombytes_stir", "randombytes_uniform", "sodium_version_string"], Xe = [ne, H, C, w, P, J, se, fe, N, W, I, te, ge, Pe, Ke, xe, ze, nt, Qt, Et, zt, Nt, pt, at, kt, Ut, dn, En, Ht, Xt, On, sn, At, hn, $t, Lt, Qn, ce, Ze, ft, It, rn, Ln, Pn, Ae, Me, He, cn, Wt, yn, pr, Uo, ar, Sr, Jo, fr, Er, vo, lr, $r, Wo, yr, Dr, Zo, dr, Br, Qo, tr, Mr, qo, hr, Or, Fo, No, di, gi, ai, ui, hi, bi, ii, pi, Ci, _i, xn, sr, Nr, vr, Yr, Fr, eo, Xr, Mo, jo, Ii, ki, j, l, B, Ri, wr, zi, ks, Hs, Oa, qa, st, Oe, Bs, ve, $s, aa, gr, rr, Vi, Cn, Ks, Qi, ua, wa, In, Ys, Zs, Ia, Ot, js, ca, Ui, Ni, da, ma, ga, la, _s, wi, ha, as, qi, Aa, ka, ms, Ps, Gs, Ba, Ms, Xs, ea, Ji, Si, Ts, Ds, gs, Os, vt, bs, Di, Pa, Ea, Cs, ya, dt, ds], yt = 0; yt < Xe.length; yt++)
            typeof m["_" + qe[yt]] == "function" && (c[qe[yt]] = Xe[yt]);
          var Rt = ["SODIUM_LIBRARY_VERSION_MAJOR", "SODIUM_LIBRARY_VERSION_MINOR", "crypto_aead_chacha20poly1305_ABYTES", "crypto_aead_chacha20poly1305_IETF_ABYTES", "crypto_aead_chacha20poly1305_IETF_KEYBYTES", "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_IETF_NPUBBYTES", "crypto_aead_chacha20poly1305_IETF_NSECBYTES", "crypto_aead_chacha20poly1305_KEYBYTES", "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_NPUBBYTES", "crypto_aead_chacha20poly1305_NSECBYTES", "crypto_aead_chacha20poly1305_ietf_ABYTES", "crypto_aead_chacha20poly1305_ietf_KEYBYTES", "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX", "crypto_aead_chacha20poly1305_ietf_NPUBBYTES", "crypto_aead_chacha20poly1305_ietf_NSECBYTES", "crypto_aead_xchacha20poly1305_IETF_ABYTES", "crypto_aead_xchacha20poly1305_IETF_KEYBYTES", "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX", "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES", "crypto_aead_xchacha20poly1305_IETF_NSECBYTES", "crypto_aead_xchacha20poly1305_ietf_ABYTES", "crypto_aead_xchacha20poly1305_ietf_KEYBYTES", "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX", "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES", "crypto_aead_xchacha20poly1305_ietf_NSECBYTES", "crypto_auth_BYTES", "crypto_auth_KEYBYTES", "crypto_auth_hmacsha256_BYTES", "crypto_auth_hmacsha256_KEYBYTES", "crypto_auth_hmacsha512256_BYTES", "crypto_auth_hmacsha512256_KEYBYTES", "crypto_auth_hmacsha512_BYTES", "crypto_auth_hmacsha512_KEYBYTES", "crypto_box_BEFORENMBYTES", "crypto_box_MACBYTES", "crypto_box_MESSAGEBYTES_MAX", "crypto_box_NONCEBYTES", "crypto_box_PUBLICKEYBYTES", "crypto_box_SEALBYTES", "crypto_box_SECRETKEYBYTES", "crypto_box_SEEDBYTES", "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES", "crypto_box_curve25519xchacha20poly1305_MACBYTES", "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_box_curve25519xchacha20poly1305_NONCEBYTES", "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES", "crypto_box_curve25519xchacha20poly1305_SEALBYTES", "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES", "crypto_box_curve25519xchacha20poly1305_SEEDBYTES", "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES", "crypto_box_curve25519xsalsa20poly1305_MACBYTES", "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX", "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES", "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES", "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES", "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES", "crypto_core_ed25519_BYTES", "crypto_core_ed25519_HASHBYTES", "crypto_core_ed25519_NONREDUCEDSCALARBYTES", "crypto_core_ed25519_SCALARBYTES", "crypto_core_ed25519_UNIFORMBYTES", "crypto_core_hchacha20_CONSTBYTES", "crypto_core_hchacha20_INPUTBYTES", "crypto_core_hchacha20_KEYBYTES", "crypto_core_hchacha20_OUTPUTBYTES", "crypto_core_hsalsa20_CONSTBYTES", "crypto_core_hsalsa20_INPUTBYTES", "crypto_core_hsalsa20_KEYBYTES", "crypto_core_hsalsa20_OUTPUTBYTES", "crypto_core_ristretto255_BYTES", "crypto_core_ristretto255_HASHBYTES", "crypto_core_ristretto255_NONREDUCEDSCALARBYTES", "crypto_core_ristretto255_SCALARBYTES", "crypto_core_salsa2012_CONSTBYTES", "crypto_core_salsa2012_INPUTBYTES", "crypto_core_salsa2012_KEYBYTES", "crypto_core_salsa2012_OUTPUTBYTES", "crypto_core_salsa20_CONSTBYTES", "crypto_core_salsa20_INPUTBYTES", "crypto_core_salsa20_KEYBYTES", "crypto_core_salsa20_OUTPUTBYTES", "crypto_generichash_BYTES", "crypto_generichash_BYTES_MAX", "crypto_generichash_BYTES_MIN", "crypto_generichash_KEYBYTES", "crypto_generichash_KEYBYTES_MAX", "crypto_generichash_KEYBYTES_MIN", "crypto_generichash_blake2b_BYTES", "crypto_generichash_blake2b_BYTES_MAX", "crypto_generichash_blake2b_BYTES_MIN", "crypto_generichash_blake2b_KEYBYTES", "crypto_generichash_blake2b_KEYBYTES_MAX", "crypto_generichash_blake2b_KEYBYTES_MIN", "crypto_generichash_blake2b_PERSONALBYTES", "crypto_generichash_blake2b_SALTBYTES", "crypto_hash_BYTES", "crypto_hash_sha256_BYTES", "crypto_hash_sha512_BYTES", "crypto_kdf_BYTES_MAX", "crypto_kdf_BYTES_MIN", "crypto_kdf_CONTEXTBYTES", "crypto_kdf_KEYBYTES", "crypto_kdf_blake2b_BYTES_MAX", "crypto_kdf_blake2b_BYTES_MIN", "crypto_kdf_blake2b_CONTEXTBYTES", "crypto_kdf_blake2b_KEYBYTES", "crypto_kx_PUBLICKEYBYTES", "crypto_kx_SECRETKEYBYTES", "crypto_kx_SEEDBYTES", "crypto_kx_SESSIONKEYBYTES", "crypto_onetimeauth_BYTES", "crypto_onetimeauth_KEYBYTES", "crypto_onetimeauth_poly1305_BYTES", "crypto_onetimeauth_poly1305_KEYBYTES", "crypto_pwhash_ALG_ARGON2I13", "crypto_pwhash_ALG_ARGON2ID13", "crypto_pwhash_ALG_DEFAULT", "crypto_pwhash_BYTES_MAX", "crypto_pwhash_BYTES_MIN", "crypto_pwhash_MEMLIMIT_INTERACTIVE", "crypto_pwhash_MEMLIMIT_MAX", "crypto_pwhash_MEMLIMIT_MIN", "crypto_pwhash_MEMLIMIT_MODERATE", "crypto_pwhash_MEMLIMIT_SENSITIVE", "crypto_pwhash_OPSLIMIT_INTERACTIVE", "crypto_pwhash_OPSLIMIT_MAX", "crypto_pwhash_OPSLIMIT_MIN", "crypto_pwhash_OPSLIMIT_MODERATE", "crypto_pwhash_OPSLIMIT_SENSITIVE", "crypto_pwhash_PASSWD_MAX", "crypto_pwhash_PASSWD_MIN", "crypto_pwhash_SALTBYTES", "crypto_pwhash_STRBYTES", "crypto_pwhash_argon2i_BYTES_MAX", "crypto_pwhash_argon2i_BYTES_MIN", "crypto_pwhash_argon2i_SALTBYTES", "crypto_pwhash_argon2i_STRBYTES", "crypto_pwhash_argon2id_BYTES_MAX", "crypto_pwhash_argon2id_BYTES_MIN", "crypto_pwhash_argon2id_SALTBYTES", "crypto_pwhash_argon2id_STRBYTES", "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX", "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN", "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN", "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE", "crypto_pwhash_scryptsalsa208sha256_SALTBYTES", "crypto_pwhash_scryptsalsa208sha256_STRBYTES", "crypto_scalarmult_BYTES", "crypto_scalarmult_SCALARBYTES", "crypto_scalarmult_curve25519_BYTES", "crypto_scalarmult_curve25519_SCALARBYTES", "crypto_scalarmult_ed25519_BYTES", "crypto_scalarmult_ed25519_SCALARBYTES", "crypto_scalarmult_ristretto255_BYTES", "crypto_scalarmult_ristretto255_SCALARBYTES", "crypto_secretbox_KEYBYTES", "crypto_secretbox_MACBYTES", "crypto_secretbox_MESSAGEBYTES_MAX", "crypto_secretbox_NONCEBYTES", "crypto_secretbox_xchacha20poly1305_KEYBYTES", "crypto_secretbox_xchacha20poly1305_MACBYTES", "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_secretbox_xchacha20poly1305_NONCEBYTES", "crypto_secretbox_xsalsa20poly1305_KEYBYTES", "crypto_secretbox_xsalsa20poly1305_MACBYTES", "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX", "crypto_secretbox_xsalsa20poly1305_NONCEBYTES", "crypto_secretstream_xchacha20poly1305_ABYTES", "crypto_secretstream_xchacha20poly1305_HEADERBYTES", "crypto_secretstream_xchacha20poly1305_KEYBYTES", "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX", "crypto_secretstream_xchacha20poly1305_TAG_FINAL", "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE", "crypto_secretstream_xchacha20poly1305_TAG_PUSH", "crypto_secretstream_xchacha20poly1305_TAG_REKEY", "crypto_shorthash_BYTES", "crypto_shorthash_KEYBYTES", "crypto_shorthash_siphash24_BYTES", "crypto_shorthash_siphash24_KEYBYTES", "crypto_shorthash_siphashx24_BYTES", "crypto_shorthash_siphashx24_KEYBYTES", "crypto_sign_BYTES", "crypto_sign_MESSAGEBYTES_MAX", "crypto_sign_PUBLICKEYBYTES", "crypto_sign_SECRETKEYBYTES", "crypto_sign_SEEDBYTES", "crypto_sign_ed25519_BYTES", "crypto_sign_ed25519_MESSAGEBYTES_MAX", "crypto_sign_ed25519_PUBLICKEYBYTES", "crypto_sign_ed25519_SECRETKEYBYTES", "crypto_sign_ed25519_SEEDBYTES", "crypto_stream_KEYBYTES", "crypto_stream_MESSAGEBYTES_MAX", "crypto_stream_NONCEBYTES", "crypto_stream_chacha20_IETF_KEYBYTES", "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX", "crypto_stream_chacha20_IETF_NONCEBYTES", "crypto_stream_chacha20_KEYBYTES", "crypto_stream_chacha20_MESSAGEBYTES_MAX", "crypto_stream_chacha20_NONCEBYTES", "crypto_stream_chacha20_ietf_KEYBYTES", "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX", "crypto_stream_chacha20_ietf_NONCEBYTES", "crypto_stream_salsa2012_KEYBYTES", "crypto_stream_salsa2012_MESSAGEBYTES_MAX", "crypto_stream_salsa2012_NONCEBYTES", "crypto_stream_salsa208_KEYBYTES", "crypto_stream_salsa208_MESSAGEBYTES_MAX", "crypto_stream_salsa208_NONCEBYTES", "crypto_stream_salsa20_KEYBYTES", "crypto_stream_salsa20_MESSAGEBYTES_MAX", "crypto_stream_salsa20_NONCEBYTES", "crypto_stream_xchacha20_KEYBYTES", "crypto_stream_xchacha20_MESSAGEBYTES_MAX", "crypto_stream_xchacha20_NONCEBYTES", "crypto_stream_xsalsa20_KEYBYTES", "crypto_stream_xsalsa20_MESSAGEBYTES_MAX", "crypto_stream_xsalsa20_NONCEBYTES", "crypto_verify_16_BYTES", "crypto_verify_32_BYTES", "crypto_verify_64_BYTES"];
          for (yt = 0; yt < Rt.length; yt++)
            typeof (Mn = m["_" + Rt[yt].toLowerCase()]) == "function" && (c[Rt[yt]] = Mn());
          var Yt = ["SODIUM_VERSION_STRING", "crypto_pwhash_STRPREFIX", "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"];
          for (yt = 0; yt < Yt.length; yt++) {
            var Mn;
            typeof (Mn = m["_" + Yt[yt].toLowerCase()]) == "function" && (c[Yt[yt]] = m.UTF8ToString(Mn()));
          }
        }
        m = d;
        try {
          Se();
          var Ee = new Uint8Array([98, 97, 108, 108, 115]), ke = c.randombytes_buf(c.crypto_secretbox_NONCEBYTES), Ce = c.randombytes_buf(c.crypto_secretbox_KEYBYTES), Re = c.crypto_secretbox_easy(Ee, ke, Ce), Fe = c.crypto_secretbox_open_easy(Re, ke, Ce);
          if (c.memcmp(Ee, Fe))
            return;
        } catch (qe) {
          if (m.useBackupModule == null)
            throw new Error("Both wasm and asm failed to load" + qe);
        }
        m.useBackupModule(), Se();
      });
      function $(Se) {
        if (typeof TextEncoder == "function")
          return new TextEncoder().encode(Se);
        Se = unescape(encodeURIComponent(Se));
        for (var Ee = new Uint8Array(Se.length), ke = 0, Ce = Se.length; ke < Ce; ke++)
          Ee[ke] = Se.charCodeAt(ke);
        return Ee;
      }
      function E(Se) {
        if (typeof TextDecoder == "function")
          return new TextDecoder("utf-8", { fatal: !0 }).decode(Se);
        var Ee = 8192, ke = Math.ceil(Se.length / Ee);
        if (ke <= 1)
          try {
            return decodeURIComponent(escape(String.fromCharCode.apply(null, Se)));
          } catch {
            throw new TypeError("The encoded data was not valid.");
          }
        for (var Ce = "", Re = 0, Fe = 0; Fe < ke; Fe++) {
          var qe = Array.prototype.slice.call(Se, Fe * Ee + Re, (Fe + 1) * Ee + Re);
          if (qe.length != 0) {
            var Xe, yt = qe.length, Rt = 0;
            do {
              var Yt = qe[--yt];
              Yt >= 240 ? (Rt = 4, Xe = !0) : Yt >= 224 ? (Rt = 3, Xe = !0) : Yt >= 192 ? (Rt = 2, Xe = !0) : Yt < 128 && (Rt = 1, Xe = !0);
            } while (!Xe);
            for (var Mn = Rt - (qe.length - yt), Un = 0; Un < Mn; Un++)
              Re--, qe.pop();
            Ce += E(qe);
          }
        }
        return Ce;
      }
      function O(Se) {
        Se = oe(null, Se, "input");
        for (var Ee, ke, Ce, Re = "", Fe = 0; Fe < Se.length; Fe++)
          Ce = 87 + (ke = 15 & Se[Fe]) + (ke - 10 >> 8 & -39) << 8 | 87 + (Ee = Se[Fe] >>> 4) + (Ee - 10 >> 8 & -39), Re += String.fromCharCode(255 & Ce) + String.fromCharCode(Ce >>> 8);
        return Re;
      }
      var T = { ORIGINAL: 1, ORIGINAL_NO_PADDING: 3, URLSAFE: 5, URLSAFE_NO_PADDING: 7 };
      function y(Se) {
        if (Se == null)
          return T.URLSAFE_NO_PADDING;
        if (Se !== T.ORIGINAL && Se !== T.ORIGINAL_NO_PADDING && Se !== T.URLSAFE && Se != T.URLSAFE_NO_PADDING)
          throw new Error("unsupported base64 variant");
        return Se;
      }
      function V(Se, Ee) {
        Ee = y(Ee), Se = oe(Ce, Se, "input");
        var ke, Ce = [], Re = 0 | Math.floor(Se.length / 3), Fe = Se.length - 3 * Re, qe = 4 * Re + (Fe !== 0 ? 2 & Ee ? 2 + (Fe >>> 1) : 4 : 0), Xe = new F(qe + 1), yt = X(Se);
        return Ce.push(yt), Ce.push(Xe.address), m._sodium_bin2base64(Xe.address, Xe.length, yt, Se.length, Ee) === 0 && Q(Ce, "conversion failed"), Xe.length = qe, ke = E(Xe.to_Uint8Array()), ue(Ce), ke;
      }
      function M(Se, Ee) {
        var ke = Ee || v;
        if (!G(ke))
          throw new Error(ke + " output format is not available");
        if (Se instanceof F) {
          if (ke === "uint8array")
            return Se.to_Uint8Array();
          if (ke === "text")
            return E(Se.to_Uint8Array());
          if (ke === "hex")
            return O(Se.to_Uint8Array());
          if (ke === "base64")
            return V(Se.to_Uint8Array(), T.URLSAFE_NO_PADDING);
          throw new Error('What is output format "' + ke + '"?');
        }
        if (typeof Se == "object") {
          for (var Ce = Object.keys(Se), Re = {}, Fe = 0; Fe < Ce.length; Fe++)
            Re[Ce[Fe]] = M(Se[Ce[Fe]], ke);
          return Re;
        }
        if (typeof Se == "string")
          return Se;
        throw new TypeError("Cannot format output");
      }
      function G(Se) {
        for (var Ee = ["uint8array", "text", "hex", "base64"], ke = 0; ke < Ee.length; ke++)
          if (Ee[ke] === Se)
            return !0;
        return !1;
      }
      function k(Se) {
        if (Se) {
          if (typeof Se != "string")
            throw new TypeError("When defined, the output format must be a string");
          if (!G(Se))
            throw new Error(Se + " is not a supported output format");
        }
      }
      function F(Se) {
        this.length = Se, this.address = ee(Se);
      }
      function X(Se) {
        var Ee = ee(Se.length);
        return m.HEAPU8.set(Se, Ee), Ee;
      }
      function ee(Se) {
        var Ee = m._malloc(Se);
        if (Ee === 0)
          throw { message: "_malloc() failed", length: Se };
        return Ee;
      }
      function ue(Se) {
        if (Se)
          for (var Ee = 0; Ee < Se.length; Ee++)
            ke = Se[Ee], m._free(ke);
        var ke;
      }
      function Q(Se, Ee) {
        throw ue(Se), new Error(Ee);
      }
      function Y(Se, Ee) {
        throw ue(Se), new TypeError(Ee);
      }
      function pe(Se, Ee, ke) {
        Ee == null && Y(Se, ke + " cannot be null or undefined");
      }
      function oe(Se, Ee, ke) {
        return pe(Se, Ee, ke), Ee instanceof Uint8Array ? Ee : typeof Ee == "string" ? $(Ee) : void Y(Se, "unsupported input type for " + ke);
      }
      function ne(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = null;
        Se != null && (Xe = X(Se = oe(qe, Se, "secret_nonce")), Se.length, qe.push(Xe)), Ee = oe(qe, Ee, "ciphertext");
        var yt, Rt = m._crypto_aead_chacha20poly1305_abytes(), Yt = Ee.length;
        Yt < Rt && Y(qe, "ciphertext is too short"), yt = X(Ee), qe.push(yt);
        var Mn = null, Un = 0;
        ke != null && (Mn = X(ke = oe(qe, ke, "additional_data")), Un = ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Jn, Rn = 0 | m._crypto_aead_chacha20poly1305_npubbytes();
        Ce.length !== Rn && Y(qe, "invalid public_nonce length"), Jn = X(Ce), qe.push(Jn), Re = oe(qe, Re, "key");
        var Zr, go = 0 | m._crypto_aead_chacha20poly1305_keybytes();
        Re.length !== go && Y(qe, "invalid key length"), Zr = X(Re), qe.push(Zr);
        var to = new F(Yt - m._crypto_aead_chacha20poly1305_abytes() | 0), Bo = to.address;
        if (qe.push(Bo), m._crypto_aead_chacha20poly1305_decrypt(Bo, null, Xe, yt, Yt, 0, Mn, Un, 0, Jn, Zr) === 0) {
          var zo = M(to, Fe);
          return ue(qe), zo;
        }
        Q(qe, "ciphertext cannot be decrypted using that key");
      }
      function H(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe);
        var yt = null;
        Se != null && (yt = X(Se = oe(Xe, Se, "secret_nonce")), Se.length, Xe.push(yt));
        var Rt = X(Ee = oe(Xe, Ee, "ciphertext")), Yt = Ee.length;
        Xe.push(Rt), ke = oe(Xe, ke, "mac");
        var Mn, Un = 0 | m._crypto_box_macbytes();
        ke.length !== Un && Y(Xe, "invalid mac length"), Mn = X(ke), Xe.push(Mn);
        var Jn = null, Rn = 0;
        Ce != null && (Jn = X(Ce = oe(Xe, Ce, "additional_data")), Rn = Ce.length, Xe.push(Jn)), Re = oe(Xe, Re, "public_nonce");
        var Zr, go = 0 | m._crypto_aead_chacha20poly1305_npubbytes();
        Re.length !== go && Y(Xe, "invalid public_nonce length"), Zr = X(Re), Xe.push(Zr), Fe = oe(Xe, Fe, "key");
        var to, Bo = 0 | m._crypto_aead_chacha20poly1305_keybytes();
        Fe.length !== Bo && Y(Xe, "invalid key length"), to = X(Fe), Xe.push(to);
        var zo = new F(0 | Yt), Ko = zo.address;
        if (Xe.push(Ko), m._crypto_aead_chacha20poly1305_decrypt_detached(Ko, yt, Rt, Yt, 0, Mn, Jn, Rn, 0, Zr, to) === 0) {
          var hs = M(zo, qe);
          return ue(Xe), hs;
        }
        Q(Xe, "ciphertext cannot be decrypted using that key");
      }
      function C(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_chacha20poly1305_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_chacha20poly1305_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(yt + m._crypto_aead_chacha20poly1305_abytes() | 0), to = go.address;
        if (qe.push(to), m._crypto_aead_chacha20poly1305_encrypt(to, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Bo = M(go, Fe);
          return ue(qe), Bo;
        }
        Q(qe, "invalid usage");
      }
      function w(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_chacha20poly1305_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_chacha20poly1305_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(0 | yt), to = go.address;
        qe.push(to);
        var Bo = new F(0 | m._crypto_aead_chacha20poly1305_abytes()), zo = Bo.address;
        if (qe.push(zo), m._crypto_aead_chacha20poly1305_encrypt_detached(to, zo, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Ko = M({ ciphertext: go, mac: Bo }, Fe);
          return ue(qe), Ko;
        }
        Q(qe, "invalid usage");
      }
      function P(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = null;
        Se != null && (Xe = X(Se = oe(qe, Se, "secret_nonce")), Se.length, qe.push(Xe)), Ee = oe(qe, Ee, "ciphertext");
        var yt, Rt = m._crypto_aead_chacha20poly1305_ietf_abytes(), Yt = Ee.length;
        Yt < Rt && Y(qe, "ciphertext is too short"), yt = X(Ee), qe.push(yt);
        var Mn = null, Un = 0;
        ke != null && (Mn = X(ke = oe(qe, ke, "additional_data")), Un = ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Jn, Rn = 0 | m._crypto_aead_chacha20poly1305_ietf_npubbytes();
        Ce.length !== Rn && Y(qe, "invalid public_nonce length"), Jn = X(Ce), qe.push(Jn), Re = oe(qe, Re, "key");
        var Zr, go = 0 | m._crypto_aead_chacha20poly1305_ietf_keybytes();
        Re.length !== go && Y(qe, "invalid key length"), Zr = X(Re), qe.push(Zr);
        var to = new F(Yt - m._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Bo = to.address;
        if (qe.push(Bo), m._crypto_aead_chacha20poly1305_ietf_decrypt(Bo, null, Xe, yt, Yt, 0, Mn, Un, 0, Jn, Zr) === 0) {
          var zo = M(to, Fe);
          return ue(qe), zo;
        }
        Q(qe, "ciphertext cannot be decrypted using that key");
      }
      function J(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe);
        var yt = null;
        Se != null && (yt = X(Se = oe(Xe, Se, "secret_nonce")), Se.length, Xe.push(yt));
        var Rt = X(Ee = oe(Xe, Ee, "ciphertext")), Yt = Ee.length;
        Xe.push(Rt), ke = oe(Xe, ke, "mac");
        var Mn, Un = 0 | m._crypto_box_macbytes();
        ke.length !== Un && Y(Xe, "invalid mac length"), Mn = X(ke), Xe.push(Mn);
        var Jn = null, Rn = 0;
        Ce != null && (Jn = X(Ce = oe(Xe, Ce, "additional_data")), Rn = Ce.length, Xe.push(Jn)), Re = oe(Xe, Re, "public_nonce");
        var Zr, go = 0 | m._crypto_aead_chacha20poly1305_ietf_npubbytes();
        Re.length !== go && Y(Xe, "invalid public_nonce length"), Zr = X(Re), Xe.push(Zr), Fe = oe(Xe, Fe, "key");
        var to, Bo = 0 | m._crypto_aead_chacha20poly1305_ietf_keybytes();
        Fe.length !== Bo && Y(Xe, "invalid key length"), to = X(Fe), Xe.push(to);
        var zo = new F(0 | Yt), Ko = zo.address;
        if (Xe.push(Ko), m._crypto_aead_chacha20poly1305_ietf_decrypt_detached(Ko, yt, Rt, Yt, 0, Mn, Jn, Rn, 0, Zr, to) === 0) {
          var hs = M(zo, qe);
          return ue(Xe), hs;
        }
        Q(Xe, "ciphertext cannot be decrypted using that key");
      }
      function se(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_chacha20poly1305_ietf_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_chacha20poly1305_ietf_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(yt + m._crypto_aead_chacha20poly1305_ietf_abytes() | 0), to = go.address;
        if (qe.push(to), m._crypto_aead_chacha20poly1305_ietf_encrypt(to, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Bo = M(go, Fe);
          return ue(qe), Bo;
        }
        Q(qe, "invalid usage");
      }
      function fe(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_chacha20poly1305_ietf_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_chacha20poly1305_ietf_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(0 | yt), to = go.address;
        qe.push(to);
        var Bo = new F(0 | m._crypto_aead_chacha20poly1305_ietf_abytes()), zo = Bo.address;
        if (qe.push(zo), m._crypto_aead_chacha20poly1305_ietf_encrypt_detached(to, zo, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Ko = M({ ciphertext: go, mac: Bo }, Fe);
          return ue(qe), Ko;
        }
        Q(qe, "invalid usage");
      }
      function N(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_aead_chacha20poly1305_ietf_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_aead_chacha20poly1305_ietf_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function W(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_aead_chacha20poly1305_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_aead_chacha20poly1305_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function I(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = null;
        Se != null && (Xe = X(Se = oe(qe, Se, "secret_nonce")), Se.length, qe.push(Xe)), Ee = oe(qe, Ee, "ciphertext");
        var yt, Rt = m._crypto_aead_xchacha20poly1305_ietf_abytes(), Yt = Ee.length;
        Yt < Rt && Y(qe, "ciphertext is too short"), yt = X(Ee), qe.push(yt);
        var Mn = null, Un = 0;
        ke != null && (Mn = X(ke = oe(qe, ke, "additional_data")), Un = ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Jn, Rn = 0 | m._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        Ce.length !== Rn && Y(qe, "invalid public_nonce length"), Jn = X(Ce), qe.push(Jn), Re = oe(qe, Re, "key");
        var Zr, go = 0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Re.length !== go && Y(qe, "invalid key length"), Zr = X(Re), qe.push(Zr);
        var to = new F(Yt - m._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Bo = to.address;
        if (qe.push(Bo), m._crypto_aead_xchacha20poly1305_ietf_decrypt(Bo, null, Xe, yt, Yt, 0, Mn, Un, 0, Jn, Zr) === 0) {
          var zo = M(to, Fe);
          return ue(qe), zo;
        }
        Q(qe, "ciphertext cannot be decrypted using that key");
      }
      function te(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe);
        var yt = null;
        Se != null && (yt = X(Se = oe(Xe, Se, "secret_nonce")), Se.length, Xe.push(yt));
        var Rt = X(Ee = oe(Xe, Ee, "ciphertext")), Yt = Ee.length;
        Xe.push(Rt), ke = oe(Xe, ke, "mac");
        var Mn, Un = 0 | m._crypto_box_macbytes();
        ke.length !== Un && Y(Xe, "invalid mac length"), Mn = X(ke), Xe.push(Mn);
        var Jn = null, Rn = 0;
        Ce != null && (Jn = X(Ce = oe(Xe, Ce, "additional_data")), Rn = Ce.length, Xe.push(Jn)), Re = oe(Xe, Re, "public_nonce");
        var Zr, go = 0 | m._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        Re.length !== go && Y(Xe, "invalid public_nonce length"), Zr = X(Re), Xe.push(Zr), Fe = oe(Xe, Fe, "key");
        var to, Bo = 0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Fe.length !== Bo && Y(Xe, "invalid key length"), to = X(Fe), Xe.push(to);
        var zo = new F(0 | Yt), Ko = zo.address;
        if (Xe.push(Ko), m._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(Ko, yt, Rt, Yt, 0, Mn, Jn, Rn, 0, Zr, to) === 0) {
          var hs = M(zo, qe);
          return ue(Xe), hs;
        }
        Q(Xe, "ciphertext cannot be decrypted using that key");
      }
      function ge(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(yt + m._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), to = go.address;
        if (qe.push(to), m._crypto_aead_xchacha20poly1305_ietf_encrypt(to, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Bo = M(go, Fe);
          return ue(qe), Bo;
        }
        Q(qe, "invalid usage");
      }
      function Pe(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "message")), yt = Se.length;
        qe.push(Xe);
        var Rt = null, Yt = 0;
        Ee != null && (Rt = X(Ee = oe(qe, Ee, "additional_data")), Yt = Ee.length, qe.push(Rt));
        var Mn = null;
        ke != null && (Mn = X(ke = oe(qe, ke, "secret_nonce")), ke.length, qe.push(Mn)), Ce = oe(qe, Ce, "public_nonce");
        var Un, Jn = 0 | m._crypto_aead_xchacha20poly1305_ietf_npubbytes();
        Ce.length !== Jn && Y(qe, "invalid public_nonce length"), Un = X(Ce), qe.push(Un), Re = oe(qe, Re, "key");
        var Rn, Zr = 0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes();
        Re.length !== Zr && Y(qe, "invalid key length"), Rn = X(Re), qe.push(Rn);
        var go = new F(0 | yt), to = go.address;
        qe.push(to);
        var Bo = new F(0 | m._crypto_aead_xchacha20poly1305_ietf_abytes()), zo = Bo.address;
        if (qe.push(zo), m._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(to, zo, null, Xe, yt, 0, Rt, Yt, 0, Mn, Un, Rn) === 0) {
          var Ko = M({ ciphertext: go, mac: Bo }, Fe);
          return ue(qe), Ko;
        }
        Q(qe, "invalid usage");
      }
      function Ke(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_aead_xchacha20poly1305_ietf_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_aead_xchacha20poly1305_ietf_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function xe(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_auth_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_auth_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_auth(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function ze(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_auth_hmacsha256_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_auth_hmacsha256_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_auth_hmacsha256(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function nt(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_auth_hmacsha256_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_auth_hmacsha256_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function Qt(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = null, Re = 0;
        Se != null && (Ce = X(Se = oe(ke, Se, "key")), Re = Se.length, ke.push(Ce));
        var Fe = new F(208).address;
        if (!(0 | m._crypto_auth_hmacsha256_init(Fe, Ce, Re))) {
          var qe = Fe;
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function Et(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_auth_hmacsha256_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_auth_hmacsha256_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function zt(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_auth_hmacsha256_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function Nt(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "tag");
        var Re, Fe = 0 | m._crypto_auth_hmacsha256_bytes();
        Se.length !== Fe && Y(Ce, "invalid tag length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "key");
        var yt, Rt = 0 | m._crypto_auth_hmacsha256_keybytes();
        ke.length !== Rt && Y(Ce, "invalid key length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_auth_hmacsha256_verify(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function pt(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_auth_hmacsha512_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_auth_hmacsha512_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_auth_hmacsha512(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function at(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_auth_hmacsha512_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_auth_hmacsha512_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function kt(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = null, Re = 0;
        Se != null && (Ce = X(Se = oe(ke, Se, "key")), Re = Se.length, ke.push(Ce));
        var Fe = new F(416).address;
        if (!(0 | m._crypto_auth_hmacsha512_init(Fe, Ce, Re))) {
          var qe = Fe;
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function Ut(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_auth_hmacsha512_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_auth_hmacsha512_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function dn(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_auth_hmacsha512_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function En(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "tag");
        var Re, Fe = 0 | m._crypto_auth_hmacsha512_bytes();
        Se.length !== Fe && Y(Ce, "invalid tag length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "key");
        var yt, Rt = 0 | m._crypto_auth_hmacsha512_keybytes();
        ke.length !== Rt && Y(Ce, "invalid key length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_auth_hmacsha512_verify(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function Ht(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_auth_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_auth_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function Xt(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "tag");
        var Re, Fe = 0 | m._crypto_auth_bytes();
        Se.length !== Fe && Y(Ce, "invalid tag length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "key");
        var yt, Rt = 0 | m._crypto_auth_keybytes();
        ke.length !== Rt && Y(Ce, "invalid key length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_auth_verify(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function On(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "publicKey");
        var Re, Fe = 0 | m._crypto_box_publickeybytes();
        Se.length !== Fe && Y(Ce, "invalid publicKey length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "privateKey");
        var qe, Xe = 0 | m._crypto_box_secretkeybytes();
        Ee.length !== Xe && Y(Ce, "invalid privateKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_box_beforenmbytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_box_beforenm(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function sn(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_box_curve25519xchacha20poly1305_publickeybytes()), Ce = ke.address;
        Ee.push(Ce);
        var Re = new F(0 | m._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), Fe = Re.address;
        Ee.push(Fe), m._crypto_box_curve25519xchacha20poly1305_keypair(Ce, Fe);
        var qe = M({ publicKey: ke, privateKey: Re, keyType: "curve25519" }, Se);
        return ue(Ee), qe;
      }
      function At(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "publicKey");
        var qe, Xe = 0 | m._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        Ee.length !== Xe && Y(Ce, "invalid publicKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(Fe + m._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), Rt = yt.address;
        Ce.push(Rt), m._crypto_box_curve25519xchacha20poly1305_seal(Rt, Re, Fe, 0, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function hn(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "ciphertext");
        var Fe, qe = m._crypto_box_curve25519xchacha20poly1305_sealbytes(), Xe = Se.length;
        Xe < qe && Y(Re, "ciphertext is too short"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "publicKey");
        var yt, Rt = 0 | m._crypto_box_curve25519xchacha20poly1305_publickeybytes();
        Ee.length !== Rt && Y(Re, "invalid publicKey length"), yt = X(Ee), Re.push(yt), ke = oe(Re, ke, "secretKey");
        var Yt, Mn = 0 | m._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
        ke.length !== Mn && Y(Re, "invalid secretKey length"), Yt = X(ke), Re.push(Yt);
        var Un = new F(Xe - m._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), Jn = Un.address;
        Re.push(Jn), m._crypto_box_curve25519xchacha20poly1305_seal_open(Jn, Fe, Xe, 0, yt, Yt);
        var Rn = M(Un, Ce);
        return ue(Re), Rn;
      }
      function $t(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_box_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), ke = oe(Fe, ke, "publicKey");
        var Yt, Mn = 0 | m._crypto_box_publickeybytes();
        ke.length !== Mn && Y(Fe, "invalid publicKey length"), Yt = X(ke), Fe.push(Yt), Ce = oe(Fe, Ce, "privateKey");
        var Un, Jn = 0 | m._crypto_box_secretkeybytes();
        Ce.length !== Jn && Y(Fe, "invalid privateKey length"), Un = X(Ce), Fe.push(Un);
        var Rn = new F(0 | Xe), Zr = Rn.address;
        Fe.push(Zr);
        var go = new F(0 | m._crypto_box_macbytes()), to = go.address;
        if (Fe.push(to), (0 | m._crypto_box_detached(Zr, to, qe, Xe, 0, yt, Yt, Un)) == 0) {
          var Bo = M({ ciphertext: Rn, mac: go }, Re);
          return ue(Fe), Bo;
        }
        Q(Fe, "invalid usage");
      }
      function Lt(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_box_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), ke = oe(Fe, ke, "publicKey");
        var Yt, Mn = 0 | m._crypto_box_publickeybytes();
        ke.length !== Mn && Y(Fe, "invalid publicKey length"), Yt = X(ke), Fe.push(Yt), Ce = oe(Fe, Ce, "privateKey");
        var Un, Jn = 0 | m._crypto_box_secretkeybytes();
        Ce.length !== Jn && Y(Fe, "invalid privateKey length"), Un = X(Ce), Fe.push(Un);
        var Rn = new F(Xe + m._crypto_box_macbytes() | 0), Zr = Rn.address;
        if (Fe.push(Zr), (0 | m._crypto_box_easy(Zr, qe, Xe, 0, yt, Yt, Un)) == 0) {
          var go = M(Rn, Re);
          return ue(Fe), go;
        }
        Q(Fe, "invalid usage");
      }
      function Qn(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_box_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "sharedKey");
        var Rt, Yt = 0 | m._crypto_box_beforenmbytes();
        ke.length !== Yt && Y(Re, "invalid sharedKey length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(qe + m._crypto_box_macbytes() | 0), Un = Mn.address;
        if (Re.push(Un), (0 | m._crypto_box_easy_afternm(Un, Fe, qe, 0, Xe, Rt)) == 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function ce(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_box_publickeybytes()), Ce = ke.address;
        Ee.push(Ce);
        var Re = new F(0 | m._crypto_box_secretkeybytes()), Fe = Re.address;
        if (Ee.push(Fe), (0 | m._crypto_box_keypair(Ce, Fe)) == 0) {
          var qe = { publicKey: M(ke, Se), privateKey: M(Re, Se), keyType: "x25519" };
          return ue(Ee), qe;
        }
        Q(Ee, "internal error");
      }
      function Ze(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe);
        var Xe = X(Se = oe(qe, Se, "ciphertext")), yt = Se.length;
        qe.push(Xe), Ee = oe(qe, Ee, "mac");
        var Rt, Yt = 0 | m._crypto_box_macbytes();
        Ee.length !== Yt && Y(qe, "invalid mac length"), Rt = X(Ee), qe.push(Rt), ke = oe(qe, ke, "nonce");
        var Mn, Un = 0 | m._crypto_box_noncebytes();
        ke.length !== Un && Y(qe, "invalid nonce length"), Mn = X(ke), qe.push(Mn), Ce = oe(qe, Ce, "publicKey");
        var Jn, Rn = 0 | m._crypto_box_publickeybytes();
        Ce.length !== Rn && Y(qe, "invalid publicKey length"), Jn = X(Ce), qe.push(Jn), Re = oe(qe, Re, "privateKey");
        var Zr, go = 0 | m._crypto_box_secretkeybytes();
        Re.length !== go && Y(qe, "invalid privateKey length"), Zr = X(Re), qe.push(Zr);
        var to = new F(0 | yt), Bo = to.address;
        if (qe.push(Bo), (0 | m._crypto_box_open_detached(Bo, Xe, Rt, yt, 0, Mn, Jn, Zr)) == 0) {
          var zo = M(to, Fe);
          return ue(qe), zo;
        }
        Q(qe, "incorrect key pair for the given ciphertext");
      }
      function ft(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re), Se = oe(Fe, Se, "ciphertext");
        var qe, Xe = m._crypto_box_macbytes(), yt = Se.length;
        yt < Xe && Y(Fe, "ciphertext is too short"), qe = X(Se), Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var Rt, Yt = 0 | m._crypto_box_noncebytes();
        Ee.length !== Yt && Y(Fe, "invalid nonce length"), Rt = X(Ee), Fe.push(Rt), ke = oe(Fe, ke, "publicKey");
        var Mn, Un = 0 | m._crypto_box_publickeybytes();
        ke.length !== Un && Y(Fe, "invalid publicKey length"), Mn = X(ke), Fe.push(Mn), Ce = oe(Fe, Ce, "privateKey");
        var Jn, Rn = 0 | m._crypto_box_secretkeybytes();
        Ce.length !== Rn && Y(Fe, "invalid privateKey length"), Jn = X(Ce), Fe.push(Jn);
        var Zr = new F(yt - m._crypto_box_macbytes() | 0), go = Zr.address;
        if (Fe.push(go), (0 | m._crypto_box_open_easy(go, qe, yt, 0, Rt, Mn, Jn)) == 0) {
          var to = M(Zr, Re);
          return ue(Fe), to;
        }
        Q(Fe, "incorrect key pair for the given ciphertext");
      }
      function It(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "ciphertext")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_box_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "sharedKey");
        var Rt, Yt = 0 | m._crypto_box_beforenmbytes();
        ke.length !== Yt && Y(Re, "invalid sharedKey length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(qe - m._crypto_box_macbytes() | 0), Un = Mn.address;
        if (Re.push(Un), (0 | m._crypto_box_open_easy_afternm(Un, Fe, qe, 0, Xe, Rt)) == 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "incorrect secret key for the given ciphertext");
      }
      function rn(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "publicKey");
        var qe, Xe = 0 | m._crypto_box_publickeybytes();
        Ee.length !== Xe && Y(Ce, "invalid publicKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(Fe + m._crypto_box_sealbytes() | 0), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_box_seal(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function Ln(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "ciphertext");
        var Fe, qe = m._crypto_box_sealbytes(), Xe = Se.length;
        Xe < qe && Y(Re, "ciphertext is too short"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "publicKey");
        var yt, Rt = 0 | m._crypto_box_publickeybytes();
        Ee.length !== Rt && Y(Re, "invalid publicKey length"), yt = X(Ee), Re.push(yt), ke = oe(Re, ke, "privateKey");
        var Yt, Mn = 0 | m._crypto_box_secretkeybytes();
        ke.length !== Mn && Y(Re, "invalid privateKey length"), Yt = X(ke), Re.push(Yt);
        var Un = new F(Xe - m._crypto_box_sealbytes() | 0), Jn = Un.address;
        if (Re.push(Jn), (0 | m._crypto_box_seal_open(Jn, Fe, Xe, 0, yt, Yt)) == 0) {
          var Rn = M(Un, Ce);
          return ue(Re), Rn;
        }
        Q(Re, "incorrect key pair for the given ciphertext");
      }
      function Pn(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "seed");
        var Ce, Re = 0 | m._crypto_box_seedbytes();
        Se.length !== Re && Y(ke, "invalid seed length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_box_publickeybytes()), qe = Fe.address;
        ke.push(qe);
        var Xe = new F(0 | m._crypto_box_secretkeybytes()), yt = Xe.address;
        if (ke.push(yt), (0 | m._crypto_box_seed_keypair(qe, yt, Ce)) == 0) {
          var Rt = { publicKey: M(Fe, Ee), privateKey: M(Xe, Ee), keyType: "x25519" };
          return ue(ke), Rt;
        }
        Q(ke, "invalid usage");
      }
      function Ae(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "p");
        var Re, Fe = 0 | m._crypto_core_ed25519_bytes();
        Se.length !== Fe && Y(Ce, "invalid p length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "q");
        var qe, Xe = 0 | m._crypto_core_ed25519_bytes();
        Ee.length !== Xe && Y(Ce, "invalid q length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_core_ed25519_add(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "input is an invalid element");
      }
      function Me(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "r"));
        Se.length, ke.push(Ce);
        var Re = new F(0 | m._crypto_core_ed25519_bytes()), Fe = Re.address;
        if (ke.push(Fe), (0 | m._crypto_core_ed25519_from_hash(Fe, Ce)) == 0) {
          var qe = M(Re, Ee);
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function He(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "r"));
        Se.length, ke.push(Ce);
        var Re = new F(0 | m._crypto_core_ed25519_bytes()), Fe = Re.address;
        if (ke.push(Fe), (0 | m._crypto_core_ed25519_from_uniform(Fe, Ce)) == 0) {
          var qe = M(Re, Ee);
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function cn(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "repr");
        var Ce, Re = 0 | m._crypto_core_ed25519_bytes();
        Se.length !== Re && Y(ke, "invalid repr length"), Ce = X(Se), ke.push(Ce);
        var Fe = (0 | m._crypto_core_ed25519_is_valid_point(Ce)) == 1;
        return ue(ke), Fe;
      }
      function Wt(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_core_ed25519_bytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_core_ed25519_random(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function yn(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ed25519_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ed25519_scalar_add(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function pr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ed25519_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ed25519_scalar_complement(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Uo(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ed25519_scalarbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_core_ed25519_scalar_invert(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid reciprocate");
      }
      function ar(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ed25519_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ed25519_scalar_mul(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function Sr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ed25519_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ed25519_scalar_negate(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Jo(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_core_ed25519_scalarbytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_core_ed25519_scalar_random(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function fr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "sample");
        var Ce, Re = 0 | m._crypto_core_ed25519_nonreducedscalarbytes();
        Se.length !== Re && Y(ke, "invalid sample length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ed25519_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ed25519_scalar_reduce(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Er(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ed25519_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ed25519_scalar_sub(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function vo(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "p");
        var Re, Fe = 0 | m._crypto_core_ed25519_bytes();
        Se.length !== Fe && Y(Ce, "invalid p length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "q");
        var qe, Xe = 0 | m._crypto_core_ed25519_bytes();
        Ee.length !== Xe && Y(Ce, "invalid q length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ed25519_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_core_ed25519_sub(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "input is an invalid element");
      }
      function lr(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "input");
        var Fe, qe = 0 | m._crypto_core_hchacha20_inputbytes();
        Se.length !== qe && Y(Re, "invalid input length"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "privateKey");
        var Xe, yt = 0 | m._crypto_core_hchacha20_keybytes();
        Ee.length !== yt && Y(Re, "invalid privateKey length"), Xe = X(Ee), Re.push(Xe);
        var Rt = null;
        ke != null && (Rt = X(ke = oe(Re, ke, "constant")), ke.length, Re.push(Rt));
        var Yt = new F(0 | m._crypto_core_hchacha20_outputbytes()), Mn = Yt.address;
        if (Re.push(Mn), (0 | m._crypto_core_hchacha20(Mn, Fe, Xe, Rt)) == 0) {
          var Un = M(Yt, Ce);
          return ue(Re), Un;
        }
        Q(Re, "invalid usage");
      }
      function $r(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "input");
        var Fe, qe = 0 | m._crypto_core_hsalsa20_inputbytes();
        Se.length !== qe && Y(Re, "invalid input length"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "privateKey");
        var Xe, yt = 0 | m._crypto_core_hsalsa20_keybytes();
        Ee.length !== yt && Y(Re, "invalid privateKey length"), Xe = X(Ee), Re.push(Xe);
        var Rt = null;
        ke != null && (Rt = X(ke = oe(Re, ke, "constant")), ke.length, Re.push(Rt));
        var Yt = new F(0 | m._crypto_core_hsalsa20_outputbytes()), Mn = Yt.address;
        if (Re.push(Mn), (0 | m._crypto_core_hsalsa20(Mn, Fe, Xe, Rt)) == 0) {
          var Un = M(Yt, Ce);
          return ue(Re), Un;
        }
        Q(Re, "invalid usage");
      }
      function Wo(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "p");
        var Re, Fe = 0 | m._crypto_core_ristretto255_bytes();
        Se.length !== Fe && Y(Ce, "invalid p length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "q");
        var qe, Xe = 0 | m._crypto_core_ristretto255_bytes();
        Ee.length !== Xe && Y(Ce, "invalid q length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_core_ristretto255_add(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "input is an invalid element");
      }
      function yr(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "r"));
        Se.length, ke.push(Ce);
        var Re = new F(0 | m._crypto_core_ristretto255_bytes()), Fe = Re.address;
        if (ke.push(Fe), (0 | m._crypto_core_ristretto255_from_hash(Fe, Ce)) == 0) {
          var qe = M(Re, Ee);
          return ue(ke), qe;
        }
        Q(ke, "invalid usage");
      }
      function Dr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "repr");
        var Ce, Re = 0 | m._crypto_core_ristretto255_bytes();
        Se.length !== Re && Y(ke, "invalid repr length"), Ce = X(Se), ke.push(Ce);
        var Fe = (0 | m._crypto_core_ristretto255_is_valid_point(Ce)) == 1;
        return ue(ke), Fe;
      }
      function Zo(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_core_ristretto255_bytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_core_ristretto255_random(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function dr(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ristretto255_scalar_add(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function Br(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ristretto255_scalar_complement(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Qo(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_scalarbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_core_ristretto255_scalar_invert(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid reciprocate");
      }
      function tr(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ristretto255_scalar_mul(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function Mr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "s");
        var Ce, Re = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Re && Y(ke, "invalid s length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ristretto255_scalar_negate(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function qo(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_core_ristretto255_scalarbytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_core_ristretto255_scalar_random(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function hr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "sample");
        var Ce, Re = 0 | m._crypto_core_ristretto255_nonreducedscalarbytes();
        Se.length !== Re && Y(ke, "invalid sample length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_scalarbytes()), qe = Fe.address;
        ke.push(qe), m._crypto_core_ristretto255_scalar_reduce(qe, Ce);
        var Xe = M(Fe, Ee);
        return ue(ke), Xe;
      }
      function Or(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "x");
        var Re, Fe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid x length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "y");
        var qe, Xe = 0 | m._crypto_core_ristretto255_scalarbytes();
        Ee.length !== Xe && Y(Ce, "invalid y length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_scalarbytes()), Rt = yt.address;
        Ce.push(Rt), m._crypto_core_ristretto255_scalar_sub(Rt, Re, qe);
        var Yt = M(yt, ke);
        return ue(Ce), Yt;
      }
      function Fo(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "p");
        var Re, Fe = 0 | m._crypto_core_ristretto255_bytes();
        Se.length !== Fe && Y(Ce, "invalid p length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "q");
        var qe, Xe = 0 | m._crypto_core_ristretto255_bytes();
        Ee.length !== Xe && Y(Ce, "invalid q length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_core_ristretto255_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_core_ristretto255_sub(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "input is an invalid element");
      }
      function No(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), pe(Re, Se, "hash_length"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Re, "hash_length must be an unsigned integer");
        var Fe = X(Ee = oe(Re, Ee, "message")), qe = Ee.length;
        Re.push(Fe);
        var Xe = null, yt = 0;
        ke != null && (Xe = X(ke = oe(Re, ke, "key")), yt = ke.length, Re.push(Xe));
        var Rt = new F(Se |= 0), Yt = Rt.address;
        if (Re.push(Yt), (0 | m._crypto_generichash(Yt, Se, Fe, qe, 0, Xe, yt)) == 0) {
          var Mn = M(Rt, Ce);
          return ue(Re), Mn;
        }
        Q(Re, "invalid usage");
      }
      function di(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re), pe(Fe, Se, "subkey_len"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Fe, "subkey_len must be an unsigned integer");
        var qe = null, Xe = 0;
        Ee != null && (qe = X(Ee = oe(Fe, Ee, "key")), Xe = Ee.length, Fe.push(qe));
        var yt = null, Rt = 0;
        ke != null && (ke = oe(Fe, ke, "id"), Rt = 0 | m._crypto_generichash_blake2b_saltbytes(), ke.length !== Rt && Y(Fe, "invalid id length"), yt = X(ke), Fe.push(yt));
        var Yt = null, Mn = 0;
        Ce != null && (Ce = oe(Fe, Ce, "ctx"), Mn = 0 | m._crypto_generichash_blake2b_personalbytes(), Ce.length !== Mn && Y(Fe, "invalid ctx length"), Yt = X(Ce), Fe.push(Yt));
        var Un = new F(0 | Se), Jn = Un.address;
        if (Fe.push(Jn), (0 | m._crypto_generichash_blake2b_salt_personal(Jn, Se, null, 0, 0, qe, Xe, yt, Yt)) == 0) {
          var Rn = M(Un, Re);
          return ue(Fe), Rn;
        }
        Q(Fe, "invalid usage");
      }
      function gi(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address"), pe(Ce, Ee, "hash_length"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Ce, "hash_length must be an unsigned integer");
        var Re = new F(Ee |= 0), Fe = Re.address;
        if (Ce.push(Fe), (0 | m._crypto_generichash_final(Se, Fe, Ee)) == 0) {
          var qe = (m._free(Se), M(Re, ke));
          return ue(Ce), qe;
        }
        Q(Ce, "invalid usage");
      }
      function ai(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = null, Fe = 0;
        Se != null && (Re = X(Se = oe(Ce, Se, "key")), Fe = Se.length, Ce.push(Re)), pe(Ce, Ee, "hash_length"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Ce, "hash_length must be an unsigned integer");
        var qe = new F(357).address;
        if (!(0 | m._crypto_generichash_init(qe, Re, Fe, Ee))) {
          var Xe = qe;
          return ue(Ce), Xe;
        }
        Q(Ce, "invalid usage");
      }
      function ui(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_generichash_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_generichash_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function hi(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_generichash_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function bi(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "message")), Re = Se.length;
        ke.push(Ce);
        var Fe = new F(0 | m._crypto_hash_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_hash(qe, Ce, Re, 0)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid usage");
      }
      function ii(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "message")), Re = Se.length;
        ke.push(Ce);
        var Fe = new F(0 | m._crypto_hash_sha256_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_hash_sha256(qe, Ce, Re, 0)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid usage");
      }
      function pi(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_hash_sha256_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_hash_sha256_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function Ci(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(104).address;
        if (!(0 | m._crypto_hash_sha256_init(ke))) {
          var Ce = ke;
          return ue(Ee), Ce;
        }
        Q(Ee, "invalid usage");
      }
      function _i(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_hash_sha256_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function xn(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = X(Se = oe(ke, Se, "message")), Re = Se.length;
        ke.push(Ce);
        var Fe = new F(0 | m._crypto_hash_sha512_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_hash_sha512(qe, Ce, Re, 0)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid usage");
      }
      function sr(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_hash_sha512_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_hash_sha512_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function Nr(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(208).address;
        if (!(0 | m._crypto_hash_sha512_init(ke))) {
          var Ce = ke;
          return ue(Ee), Ce;
        }
        Q(Ee, "invalid usage");
      }
      function vr(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_hash_sha512_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function Yr(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re), pe(Fe, Se, "subkey_len"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Fe, "subkey_len must be an unsigned integer"), pe(Fe, Ee, "subkey_id"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Fe, "subkey_id must be an unsigned integer"), typeof ke != "string" && Y(Fe, "ctx must be a string"), ke = $(ke + "\0"), Xe != null && ke.length - 1 !== Xe && Y(Fe, "invalid ctx length");
        var qe = X(ke), Xe = ke.length - 1;
        Fe.push(qe), Ce = oe(Fe, Ce, "key");
        var yt, Rt = 0 | m._crypto_kdf_keybytes();
        Ce.length !== Rt && Y(Fe, "invalid key length"), yt = X(Ce), Fe.push(yt);
        var Yt = new F(0 | Se), Mn = Yt.address;
        Fe.push(Mn), m._crypto_kdf_derive_from_key(Mn, Se, Ee, Ee >>> 24 >>> 8, qe, yt);
        var Un = M(Yt, Re);
        return ue(Fe), Un;
      }
      function Fr(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_kdf_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_kdf_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function eo(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "clientPublicKey");
        var Fe, qe = 0 | m._crypto_kx_publickeybytes();
        Se.length !== qe && Y(Re, "invalid clientPublicKey length"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "clientSecretKey");
        var Xe, yt = 0 | m._crypto_kx_secretkeybytes();
        Ee.length !== yt && Y(Re, "invalid clientSecretKey length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "serverPublicKey");
        var Rt, Yt = 0 | m._crypto_kx_publickeybytes();
        ke.length !== Yt && Y(Re, "invalid serverPublicKey length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | m._crypto_kx_sessionkeybytes()), Un = Mn.address;
        Re.push(Un);
        var Jn = new F(0 | m._crypto_kx_sessionkeybytes()), Rn = Jn.address;
        if (Re.push(Rn), (0 | m._crypto_kx_client_session_keys(Un, Rn, Fe, Xe, Rt)) == 0) {
          var Zr = M({ sharedRx: Mn, sharedTx: Jn }, Ce);
          return ue(Re), Zr;
        }
        Q(Re, "invalid usage");
      }
      function Xr(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_kx_publickeybytes()), Ce = ke.address;
        Ee.push(Ce);
        var Re = new F(0 | m._crypto_kx_secretkeybytes()), Fe = Re.address;
        if (Ee.push(Fe), (0 | m._crypto_kx_keypair(Ce, Fe)) == 0) {
          var qe = { publicKey: M(ke, Se), privateKey: M(Re, Se), keyType: "x25519" };
          return ue(Ee), qe;
        }
        Q(Ee, "internal error");
      }
      function Mo(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "seed");
        var Ce, Re = 0 | m._crypto_kx_seedbytes();
        Se.length !== Re && Y(ke, "invalid seed length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_kx_publickeybytes()), qe = Fe.address;
        ke.push(qe);
        var Xe = new F(0 | m._crypto_kx_secretkeybytes()), yt = Xe.address;
        if (ke.push(yt), (0 | m._crypto_kx_seed_keypair(qe, yt, Ce)) == 0) {
          var Rt = { publicKey: M(Fe, Ee), privateKey: M(Xe, Ee), keyType: "x25519" };
          return ue(ke), Rt;
        }
        Q(ke, "internal error");
      }
      function jo(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "serverPublicKey");
        var Fe, qe = 0 | m._crypto_kx_publickeybytes();
        Se.length !== qe && Y(Re, "invalid serverPublicKey length"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "serverSecretKey");
        var Xe, yt = 0 | m._crypto_kx_secretkeybytes();
        Ee.length !== yt && Y(Re, "invalid serverSecretKey length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "clientPublicKey");
        var Rt, Yt = 0 | m._crypto_kx_publickeybytes();
        ke.length !== Yt && Y(Re, "invalid clientPublicKey length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | m._crypto_kx_sessionkeybytes()), Un = Mn.address;
        Re.push(Un);
        var Jn = new F(0 | m._crypto_kx_sessionkeybytes()), Rn = Jn.address;
        if (Re.push(Rn), (0 | m._crypto_kx_server_session_keys(Un, Rn, Fe, Xe, Rt)) == 0) {
          var Zr = M({ sharedRx: Mn, sharedTx: Jn }, Ce);
          return ue(Re), Zr;
        }
        Q(Re, "invalid usage");
      }
      function Ii(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_onetimeauth_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_onetimeauth_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_onetimeauth(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function ki(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "state_address");
        var Ce = new F(0 | m._crypto_onetimeauth_bytes()), Re = Ce.address;
        if (ke.push(Re), (0 | m._crypto_onetimeauth_final(Se, Re)) == 0) {
          var Fe = (m._free(Se), M(Ce, Ee));
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function j(Se, Ee) {
        var ke = [];
        k(Ee);
        var Ce = null;
        Se != null && (Ce = X(Se = oe(ke, Se, "key")), Se.length, ke.push(Ce));
        var Re = new F(144).address;
        if (!(0 | m._crypto_onetimeauth_init(Re, Ce))) {
          var Fe = Re;
          return ue(ke), Fe;
        }
        Q(ke, "invalid usage");
      }
      function l(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_onetimeauth_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_onetimeauth_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function B(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_onetimeauth_update(Se, Re, Fe) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function Ri(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "hash");
        var Re, Fe = 0 | m._crypto_onetimeauth_bytes();
        Se.length !== Fe && Y(Ce, "invalid hash length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "key");
        var yt, Rt = 0 | m._crypto_onetimeauth_keybytes();
        ke.length !== Rt && Y(Ce, "invalid key length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_onetimeauth_verify(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function wr(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe), pe(Xe, Se, "keyLength"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Xe, "keyLength must be an unsigned integer");
        var yt = X(Ee = oe(Xe, Ee, "password")), Rt = Ee.length;
        Xe.push(yt), ke = oe(Xe, ke, "salt");
        var Yt, Mn = 0 | m._crypto_pwhash_saltbytes();
        ke.length !== Mn && Y(Xe, "invalid salt length"), Yt = X(ke), Xe.push(Yt), pe(Xe, Ce, "opsLimit"), (typeof Ce != "number" || (0 | Ce) !== Ce || Ce < 0) && Y(Xe, "opsLimit must be an unsigned integer"), pe(Xe, Re, "memLimit"), (typeof Re != "number" || (0 | Re) !== Re || Re < 0) && Y(Xe, "memLimit must be an unsigned integer"), pe(Xe, Fe, "algorithm"), (typeof Fe != "number" || (0 | Fe) !== Fe || Fe < 0) && Y(Xe, "algorithm must be an unsigned integer");
        var Un = new F(0 | Se), Jn = Un.address;
        if (Xe.push(Jn), (0 | m._crypto_pwhash(Jn, Se, 0, yt, Rt, 0, Yt, Ce, 0, Re, Fe)) == 0) {
          var Rn = M(Un, qe);
          return ue(Xe), Rn;
        }
        Q(Xe, "invalid usage");
      }
      function zi(Se, Ee, ke, Ce, Re, Fe) {
        var qe = [];
        k(Fe), pe(qe, Se, "keyLength"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(qe, "keyLength must be an unsigned integer");
        var Xe = X(Ee = oe(qe, Ee, "password")), yt = Ee.length;
        qe.push(Xe), ke = oe(qe, ke, "salt");
        var Rt, Yt = 0 | m._crypto_pwhash_scryptsalsa208sha256_saltbytes();
        ke.length !== Yt && Y(qe, "invalid salt length"), Rt = X(ke), qe.push(Rt), pe(qe, Ce, "opsLimit"), (typeof Ce != "number" || (0 | Ce) !== Ce || Ce < 0) && Y(qe, "opsLimit must be an unsigned integer"), pe(qe, Re, "memLimit"), (typeof Re != "number" || (0 | Re) !== Re || Re < 0) && Y(qe, "memLimit must be an unsigned integer");
        var Mn = new F(0 | Se), Un = Mn.address;
        if (qe.push(Un), (0 | m._crypto_pwhash_scryptsalsa208sha256(Un, Se, 0, Xe, yt, 0, Rt, Ce, 0, Re)) == 0) {
          var Jn = M(Mn, Fe);
          return ue(qe), Jn;
        }
        Q(qe, "invalid usage");
      }
      function ks(Se, Ee, ke, Ce, Re, Fe, qe) {
        var Xe = [];
        k(qe);
        var yt = X(Se = oe(Xe, Se, "password")), Rt = Se.length;
        Xe.push(yt);
        var Yt = X(Ee = oe(Xe, Ee, "salt")), Mn = Ee.length;
        Xe.push(Yt), pe(Xe, ke, "opsLimit"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Xe, "opsLimit must be an unsigned integer"), pe(Xe, Ce, "r"), (typeof Ce != "number" || (0 | Ce) !== Ce || Ce < 0) && Y(Xe, "r must be an unsigned integer"), pe(Xe, Re, "p"), (typeof Re != "number" || (0 | Re) !== Re || Re < 0) && Y(Xe, "p must be an unsigned integer"), pe(Xe, Fe, "keyLength"), (typeof Fe != "number" || (0 | Fe) !== Fe || Fe < 0) && Y(Xe, "keyLength must be an unsigned integer");
        var Un = new F(0 | Fe), Jn = Un.address;
        if (Xe.push(Jn), (0 | m._crypto_pwhash_scryptsalsa208sha256_ll(yt, Rt, Yt, Mn, ke, 0, Ce, Re, Jn, Fe)) == 0) {
          var Rn = M(Un, qe);
          return ue(Xe), Rn;
        }
        Q(Xe, "invalid usage");
      }
      function Hs(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "password")), qe = Se.length;
        Re.push(Fe), pe(Re, Ee, "opsLimit"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Re, "opsLimit must be an unsigned integer"), pe(Re, ke, "memLimit"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Re, "memLimit must be an unsigned integer");
        var Xe = new F(0 | m._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
        if (Re.push(Xe), (0 | m._crypto_pwhash_scryptsalsa208sha256_str(Xe, Fe, qe, 0, Ee, 0, ke)) == 0) {
          var yt = m.UTF8ToString(Xe);
          return ue(Re), yt;
        }
        Q(Re, "invalid usage");
      }
      function Oa(Se, Ee, ke) {
        var Ce = [];
        k(ke), typeof Se != "string" && Y(Ce, "hashed_password must be a string"), Se = $(Se + "\0"), Fe != null && Se.length - 1 !== Fe && Y(Ce, "invalid hashed_password length");
        var Re = X(Se), Fe = Se.length - 1;
        Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "password")), Xe = Ee.length;
        Ce.push(qe);
        var yt = (0 | m._crypto_pwhash_scryptsalsa208sha256_str_verify(Re, qe, Xe, 0)) == 0;
        return ue(Ce), yt;
      }
      function qa(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "password")), qe = Se.length;
        Re.push(Fe), pe(Re, Ee, "opsLimit"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Re, "opsLimit must be an unsigned integer"), pe(Re, ke, "memLimit"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Re, "memLimit must be an unsigned integer");
        var Xe = new F(0 | m._crypto_pwhash_strbytes()).address;
        if (Re.push(Xe), (0 | m._crypto_pwhash_str(Xe, Fe, qe, 0, Ee, 0, ke)) == 0) {
          var yt = m.UTF8ToString(Xe);
          return ue(Re), yt;
        }
        Q(Re, "invalid usage");
      }
      function st(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), typeof Se != "string" && Y(Re, "hashed_password must be a string"), Se = $(Se + "\0"), qe != null && Se.length - 1 !== qe && Y(Re, "invalid hashed_password length");
        var Fe = X(Se), qe = Se.length - 1;
        Re.push(Fe), pe(Re, Ee, "opsLimit"), (typeof Ee != "number" || (0 | Ee) !== Ee || Ee < 0) && Y(Re, "opsLimit must be an unsigned integer"), pe(Re, ke, "memLimit"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Re, "memLimit must be an unsigned integer");
        var Xe = (0 | m._crypto_pwhash_str_needs_rehash(Fe, Ee, 0, ke)) != 0;
        return ue(Re), Xe;
      }
      function Oe(Se, Ee, ke) {
        var Ce = [];
        k(ke), typeof Se != "string" && Y(Ce, "hashed_password must be a string"), Se = $(Se + "\0"), Fe != null && Se.length - 1 !== Fe && Y(Ce, "invalid hashed_password length");
        var Re = X(Se), Fe = Se.length - 1;
        Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "password")), Xe = Ee.length;
        Ce.push(qe);
        var yt = (0 | m._crypto_pwhash_str_verify(Re, qe, Xe, 0)) == 0;
        return ue(Ce), yt;
      }
      function Bs(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "privateKey");
        var Re, Fe = 0 | m._crypto_scalarmult_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid privateKey length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "publicKey");
        var qe, Xe = 0 | m._crypto_scalarmult_bytes();
        Ee.length !== Xe && Y(Ce, "invalid publicKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_scalarmult_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_scalarmult(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "weak public key");
      }
      function ve(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "privateKey");
        var Ce, Re = 0 | m._crypto_scalarmult_scalarbytes();
        Se.length !== Re && Y(ke, "invalid privateKey length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_scalarmult_base(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "unknown error");
      }
      function $s(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "n");
        var Re, Fe = 0 | m._crypto_scalarmult_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid n length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "p");
        var qe, Xe = 0 | m._crypto_scalarmult_ed25519_bytes();
        Ee.length !== Xe && Y(Ce, "invalid p length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_scalarmult_ed25519_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_scalarmult_ed25519(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid point or scalar is 0");
      }
      function aa(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "scalar");
        var Ce, Re = 0 | m._crypto_scalarmult_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid scalar length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_ed25519_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_scalarmult_ed25519_base(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "scalar is 0");
      }
      function gr(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "scalar");
        var Ce, Re = 0 | m._crypto_scalarmult_ed25519_scalarbytes();
        Se.length !== Re && Y(ke, "invalid scalar length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_ed25519_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_scalarmult_ed25519_base_noclamp(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "scalar is 0");
      }
      function rr(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "n");
        var Re, Fe = 0 | m._crypto_scalarmult_ed25519_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid n length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "p");
        var qe, Xe = 0 | m._crypto_scalarmult_ed25519_bytes();
        Ee.length !== Xe && Y(Ce, "invalid p length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_scalarmult_ed25519_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_scalarmult_ed25519_noclamp(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid point or scalar is 0");
      }
      function Vi(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "scalar");
        var Re, Fe = 0 | m._crypto_scalarmult_ristretto255_scalarbytes();
        Se.length !== Fe && Y(Ce, "invalid scalar length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "element");
        var qe, Xe = 0 | m._crypto_scalarmult_ristretto255_bytes();
        Ee.length !== Xe && Y(Ce, "invalid element length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_scalarmult_ristretto255_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_scalarmult_ristretto255(Rt, Re, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "result is identity element");
      }
      function Cn(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "scalar");
        var Ce, Re = 0 | m._crypto_core_ristretto255_scalarbytes();
        Se.length !== Re && Y(ke, "invalid scalar length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_core_ristretto255_bytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_scalarmult_ristretto255_base(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "scalar is 0");
      }
      function Ks(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_secretbox_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_secretbox_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | qe), Un = Mn.address;
        Re.push(Un);
        var Jn = new F(0 | m._crypto_secretbox_macbytes()), Rn = Jn.address;
        if (Re.push(Rn), (0 | m._crypto_secretbox_detached(Un, Rn, Fe, qe, 0, Xe, Rt)) == 0) {
          var Zr = M({ mac: Jn, cipher: Mn }, Ce);
          return ue(Re), Zr;
        }
        Q(Re, "invalid usage");
      }
      function Qi(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_secretbox_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_secretbox_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(qe + m._crypto_secretbox_macbytes() | 0), Un = Mn.address;
        if (Re.push(Un), (0 | m._crypto_secretbox_easy(Un, Fe, qe, 0, Xe, Rt)) == 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function ua(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_secretbox_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_secretbox_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function wa(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "ciphertext")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "mac");
        var yt, Rt = 0 | m._crypto_secretbox_macbytes();
        Ee.length !== Rt && Y(Fe, "invalid mac length"), yt = X(Ee), Fe.push(yt), ke = oe(Fe, ke, "nonce");
        var Yt, Mn = 0 | m._crypto_secretbox_noncebytes();
        ke.length !== Mn && Y(Fe, "invalid nonce length"), Yt = X(ke), Fe.push(Yt), Ce = oe(Fe, Ce, "key");
        var Un, Jn = 0 | m._crypto_secretbox_keybytes();
        Ce.length !== Jn && Y(Fe, "invalid key length"), Un = X(Ce), Fe.push(Un);
        var Rn = new F(0 | Xe), Zr = Rn.address;
        if (Fe.push(Zr), (0 | m._crypto_secretbox_open_detached(Zr, qe, yt, Xe, 0, Yt, Un)) == 0) {
          var go = M(Rn, Re);
          return ue(Fe), go;
        }
        Q(Fe, "wrong secret key for the given ciphertext");
      }
      function In(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), Se = oe(Re, Se, "ciphertext");
        var Fe, qe = m._crypto_secretbox_macbytes(), Xe = Se.length;
        Xe < qe && Y(Re, "ciphertext is too short"), Fe = X(Se), Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_secretbox_noncebytes();
        Ee.length !== Rt && Y(Re, "invalid nonce length"), yt = X(Ee), Re.push(yt), ke = oe(Re, ke, "key");
        var Yt, Mn = 0 | m._crypto_secretbox_keybytes();
        ke.length !== Mn && Y(Re, "invalid key length"), Yt = X(ke), Re.push(Yt);
        var Un = new F(Xe - m._crypto_secretbox_macbytes() | 0), Jn = Un.address;
        if (Re.push(Jn), (0 | m._crypto_secretbox_open_easy(Jn, Fe, Xe, 0, yt, Yt)) == 0) {
          var Rn = M(Un, Ce);
          return ue(Re), Rn;
        }
        Q(Re, "wrong secret key for the given ciphertext");
      }
      function Ys(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "header");
        var Re, Fe = 0 | m._crypto_secretstream_xchacha20poly1305_headerbytes();
        Se.length !== Fe && Y(Ce, "invalid header length"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_secretstream_xchacha20poly1305_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(52).address;
        if (!(0 | m._crypto_secretstream_xchacha20poly1305_init_pull(yt, Re, qe))) {
          var Rt = yt;
          return ue(Ce), Rt;
        }
        Q(Ce, "invalid usage");
      }
      function Zs(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "key");
        var Ce, Re = 0 | m._crypto_secretstream_xchacha20poly1305_keybytes();
        Se.length !== Re && Y(ke, "invalid key length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(52).address, qe = new F(0 | m._crypto_secretstream_xchacha20poly1305_headerbytes()), Xe = qe.address;
        if (ke.push(Xe), (0 | m._crypto_secretstream_xchacha20poly1305_init_push(Fe, Xe, Ce)) == 0) {
          var yt = { state: Fe, header: M(qe, Ee) };
          return ue(ke), yt;
        }
        Q(ke, "invalid usage");
      }
      function Ia(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_secretstream_xchacha20poly1305_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_secretstream_xchacha20poly1305_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function Ot(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), pe(Re, Se, "state_address"), Ee = oe(Re, Ee, "cipher");
        var Fe, qe = m._crypto_secretstream_xchacha20poly1305_abytes(), Xe = Ee.length;
        Xe < qe && Y(Re, "cipher is too short"), Fe = X(Ee), Re.push(Fe);
        var yt = null, Rt = 0;
        ke != null && (yt = X(ke = oe(Re, ke, "ad")), Rt = ke.length, Re.push(yt));
        var Yt = new F(Xe - m._crypto_secretstream_xchacha20poly1305_abytes() | 0), Mn = Yt.address;
        Re.push(Mn);
        var Un, Jn = (Un = ee(1), Re.push(Un), (Jn = m._crypto_secretstream_xchacha20poly1305_pull(Se, Mn, 0, Un, Fe, Xe, 0, yt, Rt) === 0 && { tag: m.HEAPU8[Un], message: Yt }) && { message: M(Jn.message, Ce), tag: Jn.tag });
        return ue(Re), Jn;
      }
      function js(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re), pe(Fe, Se, "state_address");
        var qe = X(Ee = oe(Fe, Ee, "message_chunk")), Xe = Ee.length;
        Fe.push(qe);
        var yt = null, Rt = 0;
        ke != null && (yt = X(ke = oe(Fe, ke, "ad")), Rt = ke.length, Fe.push(yt)), pe(Fe, Ce, "tag"), (typeof Ce != "number" || (0 | Ce) !== Ce || Ce < 0) && Y(Fe, "tag must be an unsigned integer");
        var Yt = new F(Xe + m._crypto_secretstream_xchacha20poly1305_abytes() | 0), Mn = Yt.address;
        if (Fe.push(Mn), (0 | m._crypto_secretstream_xchacha20poly1305_push(Se, Mn, 0, qe, Xe, 0, yt, Rt, 0, Ce)) == 0) {
          var Un = M(Yt, Re);
          return ue(Fe), Un;
        }
        Q(Fe, "invalid usage");
      }
      function ca(Se, Ee) {
        var ke = [];
        return k(Ee), pe(ke, Se, "state_address"), m._crypto_secretstream_xchacha20poly1305_rekey(Se), ue(ke), !0;
      }
      function Ui(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_shorthash_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_shorthash_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_shorthash(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function Ni(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_shorthash_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_shorthash_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function da(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "key");
        var qe, Xe = 0 | m._crypto_shorthash_siphashx24_keybytes();
        Ee.length !== Xe && Y(Ce, "invalid key length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_shorthash_siphashx24_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_shorthash_siphashx24(Rt, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function ma(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "privateKey");
        var qe, Xe = 0 | m._crypto_sign_secretkeybytes();
        Ee.length !== Xe && Y(Ce, "invalid privateKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(Se.length + m._crypto_sign_bytes() | 0), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_sign(Rt, null, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function ga(Se, Ee, ke) {
        var Ce = [];
        k(ke);
        var Re = X(Se = oe(Ce, Se, "message")), Fe = Se.length;
        Ce.push(Re), Ee = oe(Ce, Ee, "privateKey");
        var qe, Xe = 0 | m._crypto_sign_secretkeybytes();
        Ee.length !== Xe && Y(Ce, "invalid privateKey length"), qe = X(Ee), Ce.push(qe);
        var yt = new F(0 | m._crypto_sign_bytes()), Rt = yt.address;
        if (Ce.push(Rt), (0 | m._crypto_sign_detached(Rt, null, Re, Fe, 0, qe)) == 0) {
          var Yt = M(yt, ke);
          return ue(Ce), Yt;
        }
        Q(Ce, "invalid usage");
      }
      function la(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "edPk");
        var Ce, Re = 0 | m._crypto_sign_publickeybytes();
        Se.length !== Re && Y(ke, "invalid edPk length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_scalarbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_sign_ed25519_pk_to_curve25519(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid key");
      }
      function _s(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "edSk");
        var Ce, Re = 0 | m._crypto_sign_secretkeybytes();
        Se.length !== Re && Y(ke, "invalid edSk length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_scalarmult_scalarbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_sign_ed25519_sk_to_curve25519(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid key");
      }
      function wi(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "privateKey");
        var Ce, Re = 0 | m._crypto_sign_secretkeybytes();
        Se.length !== Re && Y(ke, "invalid privateKey length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_sign_publickeybytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_sign_ed25519_sk_to_pk(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid key");
      }
      function ha(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "privateKey");
        var Ce, Re = 0 | m._crypto_sign_secretkeybytes();
        Se.length !== Re && Y(ke, "invalid privateKey length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_sign_seedbytes()), qe = Fe.address;
        if (ke.push(qe), (0 | m._crypto_sign_ed25519_sk_to_seed(qe, Ce)) == 0) {
          var Xe = M(Fe, Ee);
          return ue(ke), Xe;
        }
        Q(ke, "invalid key");
      }
      function as(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address"), Ee = oe(Ce, Ee, "privateKey");
        var Re, Fe = 0 | m._crypto_sign_secretkeybytes();
        Ee.length !== Fe && Y(Ce, "invalid privateKey length"), Re = X(Ee), Ce.push(Re);
        var qe = new F(0 | m._crypto_sign_bytes()), Xe = qe.address;
        if (Ce.push(Xe), (0 | m._crypto_sign_final_create(Se, Xe, null, Re)) == 0) {
          var yt = (m._free(Se), M(qe, ke));
          return ue(Ce), yt;
        }
        Q(Ce, "invalid usage");
      }
      function qi(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), pe(Re, Se, "state_address"), Ee = oe(Re, Ee, "signature");
        var Fe, qe = 0 | m._crypto_sign_bytes();
        Ee.length !== qe && Y(Re, "invalid signature length"), Fe = X(Ee), Re.push(Fe), ke = oe(Re, ke, "publicKey");
        var Xe, yt = 0 | m._crypto_sign_publickeybytes();
        ke.length !== yt && Y(Re, "invalid publicKey length"), Xe = X(ke), Re.push(Xe);
        var Rt = (0 | m._crypto_sign_final_verify(Se, Fe, Xe)) == 0;
        return ue(Re), Rt;
      }
      function Aa(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(208).address;
        if (!(0 | m._crypto_sign_init(ke))) {
          var Ce = ke;
          return ue(Ee), Ce;
        }
        Q(Ee, "internal error");
      }
      function ka(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_sign_publickeybytes()), Ce = ke.address;
        Ee.push(Ce);
        var Re = new F(0 | m._crypto_sign_secretkeybytes()), Fe = Re.address;
        if (Ee.push(Fe), (0 | m._crypto_sign_keypair(Ce, Fe)) == 0) {
          var qe = { publicKey: M(ke, Se), privateKey: M(Re, Se), keyType: "ed25519" };
          return ue(Ee), qe;
        }
        Q(Ee, "internal error");
      }
      function ms(Se, Ee, ke) {
        var Ce = [];
        k(ke), Se = oe(Ce, Se, "signedMessage");
        var Re, Fe = m._crypto_sign_bytes(), qe = Se.length;
        qe < Fe && Y(Ce, "signedMessage is too short"), Re = X(Se), Ce.push(Re), Ee = oe(Ce, Ee, "publicKey");
        var Xe, yt = 0 | m._crypto_sign_publickeybytes();
        Ee.length !== yt && Y(Ce, "invalid publicKey length"), Xe = X(Ee), Ce.push(Xe);
        var Rt = new F(qe - m._crypto_sign_bytes() | 0), Yt = Rt.address;
        if (Ce.push(Yt), (0 | m._crypto_sign_open(Yt, null, Re, qe, 0, Xe)) == 0) {
          var Mn = M(Rt, ke);
          return ue(Ce), Mn;
        }
        Q(Ce, "incorrect signature for the given public key");
      }
      function Ps(Se, Ee) {
        var ke = [];
        k(Ee), Se = oe(ke, Se, "seed");
        var Ce, Re = 0 | m._crypto_sign_seedbytes();
        Se.length !== Re && Y(ke, "invalid seed length"), Ce = X(Se), ke.push(Ce);
        var Fe = new F(0 | m._crypto_sign_publickeybytes()), qe = Fe.address;
        ke.push(qe);
        var Xe = new F(0 | m._crypto_sign_secretkeybytes()), yt = Xe.address;
        if (ke.push(yt), (0 | m._crypto_sign_seed_keypair(qe, yt, Ce)) == 0) {
          var Rt = { publicKey: M(Fe, Ee), privateKey: M(Xe, Ee), keyType: "ed25519" };
          return ue(ke), Rt;
        }
        Q(ke, "invalid usage");
      }
      function Gs(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "state_address");
        var Re = X(Ee = oe(Ce, Ee, "message_chunk")), Fe = Ee.length;
        Ce.push(Re), 0 | m._crypto_sign_update(Se, Re, Fe, 0) && Q(Ce, "invalid usage"), ue(Ce);
      }
      function Ba(Se, Ee, ke) {
        var Ce = [];
        Se = oe(Ce, Se, "signature");
        var Re, Fe = 0 | m._crypto_sign_bytes();
        Se.length !== Fe && Y(Ce, "invalid signature length"), Re = X(Se), Ce.push(Re);
        var qe = X(Ee = oe(Ce, Ee, "message")), Xe = Ee.length;
        Ce.push(qe), ke = oe(Ce, ke, "publicKey");
        var yt, Rt = 0 | m._crypto_sign_publickeybytes();
        ke.length !== Rt && Y(Ce, "invalid publicKey length"), yt = X(ke), Ce.push(yt);
        var Yt = (0 | m._crypto_sign_verify_detached(Re, qe, Xe, 0, yt)) == 0;
        return ue(Ce), Yt;
      }
      function Ms(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce), pe(Re, Se, "outLength"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Re, "outLength must be an unsigned integer"), Ee = oe(Re, Ee, "key");
        var Fe, qe = 0 | m._crypto_stream_chacha20_keybytes();
        Ee.length !== qe && Y(Re, "invalid key length"), Fe = X(Ee), Re.push(Fe), ke = oe(Re, ke, "nonce");
        var Xe, yt = 0 | m._crypto_stream_chacha20_noncebytes();
        ke.length !== yt && Y(Re, "invalid nonce length"), Xe = X(ke), Re.push(Xe);
        var Rt = new F(0 | Se), Yt = Rt.address;
        Re.push(Yt), m._crypto_stream_chacha20(Yt, Se, 0, Xe, Fe);
        var Mn = M(Rt, Ce);
        return ue(Re), Mn;
      }
      function Xs(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "input_message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_stream_chacha20_ietf_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_stream_chacha20_ietf_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | qe), Un = Mn.address;
        if (Re.push(Un), m._crypto_stream_chacha20_ietf_xor(Un, Fe, qe, 0, Xe, Rt) === 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function ea(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "input_message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_stream_chacha20_ietf_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), pe(Fe, ke, "nonce_increment"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Fe, "nonce_increment must be an unsigned integer"), Ce = oe(Fe, Ce, "key");
        var Yt, Mn = 0 | m._crypto_stream_chacha20_ietf_keybytes();
        Ce.length !== Mn && Y(Fe, "invalid key length"), Yt = X(Ce), Fe.push(Yt);
        var Un = new F(0 | Xe), Jn = Un.address;
        if (Fe.push(Jn), m._crypto_stream_chacha20_ietf_xor_ic(Jn, qe, Xe, 0, yt, ke, Yt) === 0) {
          var Rn = M(Un, Re);
          return ue(Fe), Rn;
        }
        Q(Fe, "invalid usage");
      }
      function Ji(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_stream_chacha20_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_stream_chacha20_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function Si(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "input_message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_stream_chacha20_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_stream_chacha20_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | qe), Un = Mn.address;
        if (Re.push(Un), m._crypto_stream_chacha20_xor(Un, Fe, qe, 0, Xe, Rt) === 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function Ts(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "input_message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_stream_chacha20_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), pe(Fe, ke, "nonce_increment"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Fe, "nonce_increment must be an unsigned integer"), Ce = oe(Fe, Ce, "key");
        var Yt, Mn = 0 | m._crypto_stream_chacha20_keybytes();
        Ce.length !== Mn && Y(Fe, "invalid key length"), Yt = X(Ce), Fe.push(Yt);
        var Un = new F(0 | Xe), Jn = Un.address;
        if (Fe.push(Jn), m._crypto_stream_chacha20_xor_ic(Jn, qe, Xe, 0, yt, ke, 0, Yt) === 0) {
          var Rn = M(Un, Re);
          return ue(Fe), Rn;
        }
        Q(Fe, "invalid usage");
      }
      function Ds(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_stream_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_stream_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function gs(Se) {
        var Ee = [];
        k(Se);
        var ke = new F(0 | m._crypto_stream_xchacha20_keybytes()), Ce = ke.address;
        Ee.push(Ce), m._crypto_stream_xchacha20_keygen(Ce);
        var Re = M(ke, Se);
        return ue(Ee), Re;
      }
      function Os(Se, Ee, ke, Ce) {
        var Re = [];
        k(Ce);
        var Fe = X(Se = oe(Re, Se, "input_message")), qe = Se.length;
        Re.push(Fe), Ee = oe(Re, Ee, "nonce");
        var Xe, yt = 0 | m._crypto_stream_xchacha20_noncebytes();
        Ee.length !== yt && Y(Re, "invalid nonce length"), Xe = X(Ee), Re.push(Xe), ke = oe(Re, ke, "key");
        var Rt, Yt = 0 | m._crypto_stream_xchacha20_keybytes();
        ke.length !== Yt && Y(Re, "invalid key length"), Rt = X(ke), Re.push(Rt);
        var Mn = new F(0 | qe), Un = Mn.address;
        if (Re.push(Un), m._crypto_stream_xchacha20_xor(Un, Fe, qe, 0, Xe, Rt) === 0) {
          var Jn = M(Mn, Ce);
          return ue(Re), Jn;
        }
        Q(Re, "invalid usage");
      }
      function vt(Se, Ee, ke, Ce, Re) {
        var Fe = [];
        k(Re);
        var qe = X(Se = oe(Fe, Se, "input_message")), Xe = Se.length;
        Fe.push(qe), Ee = oe(Fe, Ee, "nonce");
        var yt, Rt = 0 | m._crypto_stream_xchacha20_noncebytes();
        Ee.length !== Rt && Y(Fe, "invalid nonce length"), yt = X(Ee), Fe.push(yt), pe(Fe, ke, "nonce_increment"), (typeof ke != "number" || (0 | ke) !== ke || ke < 0) && Y(Fe, "nonce_increment must be an unsigned integer"), Ce = oe(Fe, Ce, "key");
        var Yt, Mn = 0 | m._crypto_stream_xchacha20_keybytes();
        Ce.length !== Mn && Y(Fe, "invalid key length"), Yt = X(Ce), Fe.push(Yt);
        var Un = new F(0 | Xe), Jn = Un.address;
        if (Fe.push(Jn), m._crypto_stream_xchacha20_xor_ic(Jn, qe, Xe, 0, yt, ke, 0, Yt) === 0) {
          var Rn = M(Un, Re);
          return ue(Fe), Rn;
        }
        Q(Fe, "invalid usage");
      }
      function bs(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "length"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(ke, "length must be an unsigned integer");
        var Ce = new F(0 | Se), Re = Ce.address;
        ke.push(Re), m._randombytes_buf(Re, Se);
        var Fe = M(Ce, Ee);
        return ue(ke), Fe;
      }
      function Di(Se, Ee, ke) {
        var Ce = [];
        k(ke), pe(Ce, Se, "length"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(Ce, "length must be an unsigned integer"), Ee = oe(Ce, Ee, "seed");
        var Re, Fe = 0 | m._randombytes_seedbytes();
        Ee.length !== Fe && Y(Ce, "invalid seed length"), Re = X(Ee), Ce.push(Re);
        var qe = new F(0 | Se), Xe = qe.address;
        Ce.push(Xe), m._randombytes_buf_deterministic(Xe, Se, Re);
        var yt = M(qe, ke);
        return ue(Ce), yt;
      }
      function Pa(Se) {
        k(Se), m._randombytes_close();
      }
      function Ea(Se) {
        k(Se);
        var Ee = m._randombytes_random() >>> 0;
        return ue([]), Ee;
      }
      function Cs(Se, Ee) {
        var ke = [];
        k(Ee);
        for (var Ce = m._malloc(24), Re = 0; Re < 6; Re++)
          m.setValue(Ce + 4 * Re, m.Runtime.addFunction(Se[["implementation_name", "random", "stir", "uniform", "buf", "close"][Re]]), "i32");
        0 | m._randombytes_set_implementation(Ce) && Q(ke, "unsupported implementation"), ue(ke);
      }
      function ya(Se) {
        k(Se), m._randombytes_stir();
      }
      function dt(Se, Ee) {
        var ke = [];
        k(Ee), pe(ke, Se, "upper_bound"), (typeof Se != "number" || (0 | Se) !== Se || Se < 0) && Y(ke, "upper_bound must be an unsigned integer");
        var Ce = m._randombytes_uniform(Se) >>> 0;
        return ue(ke), Ce;
      }
      function ds() {
        var Se = m._sodium_version_string(), Ee = m.UTF8ToString(Se);
        return ue([]), Ee;
      }
      return F.prototype.to_Uint8Array = function() {
        var Se = new Uint8Array(this.length);
        return Se.set(m.HEAPU8.subarray(this.address, this.address + this.length)), Se;
      }, c.add = function(Se, Ee) {
        if (!(Se instanceof Uint8Array && Ee instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can added");
        var ke = Se.length, Ce = 0, Re = 0;
        if (Ee.length != Se.length)
          throw new TypeError("Arguments must have the same length");
        for (Re = 0; Re < ke; Re++)
          Ce >>= 8, Ce += Se[Re] + Ee[Re], Se[Re] = 255 & Ce;
      }, c.base64_variants = T, c.compare = function(Se, Ee) {
        if (!(Se instanceof Uint8Array && Ee instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be compared");
        if (Se.length !== Ee.length)
          throw new TypeError("Only instances of identical length can be compared");
        for (var ke = 0, Ce = 1, Re = Se.length; Re-- > 0; )
          ke |= Ee[Re] - Se[Re] >> 8 & Ce, Ce &= (Ee[Re] ^ Se[Re]) - 1 >> 8;
        return ke + ke + Ce - 1;
      }, c.from_base64 = function(Se, Ee) {
        Ee = y(Ee);
        var ke, Ce = [], Re = new F(3 * (Se = oe(Ce, Se, "input")).length / 4), Fe = X(Se), qe = ee(4), Xe = ee(4);
        return Ce.push(Fe), Ce.push(Re.address), Ce.push(Re.result_bin_len_p), Ce.push(Re.b64_end_p), m._sodium_base642bin(Re.address, Re.length, Fe, Se.length, 0, qe, Xe, Ee) !== 0 && Q(Ce, "invalid input"), m.getValue(Xe, "i32") - Fe !== Se.length && Q(Ce, "incomplete input"), Re.length = m.getValue(qe, "i32"), ke = Re.to_Uint8Array(), ue(Ce), ke;
      }, c.from_hex = function(Se) {
        var Ee, ke = [], Ce = new F((Se = oe(ke, Se, "input")).length / 2), Re = X(Se), Fe = ee(4);
        return ke.push(Re), ke.push(Ce.address), ke.push(Ce.hex_end_p), m._sodium_hex2bin(Ce.address, Ce.length, Re, Se.length, 0, 0, Fe) !== 0 && Q(ke, "invalid input"), m.getValue(Fe, "i32") - Re !== Se.length && Q(ke, "incomplete input"), Ee = Ce.to_Uint8Array(), ue(ke), Ee;
      }, c.from_string = $, c.increment = function(Se) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be incremented");
        for (var Ee = 256, ke = 0, Ce = Se.length; ke < Ce; ke++)
          Ee >>= 8, Ee += Se[ke], Se[ke] = 255 & Ee;
      }, c.is_zero = function(Se) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be checked");
        for (var Ee = 0, ke = 0, Ce = Se.length; ke < Ce; ke++)
          Ee |= Se[ke];
        return Ee === 0;
      }, c.libsodium = d, c.memcmp = function(Se, Ee) {
        if (!(Se instanceof Uint8Array && Ee instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be compared");
        if (Se.length !== Ee.length)
          throw new TypeError("Only instances of identical length can be compared");
        for (var ke = 0, Ce = 0, Re = Se.length; Ce < Re; Ce++)
          ke |= Se[Ce] ^ Ee[Ce];
        return ke === 0;
      }, c.memzero = function(Se) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("Only Uint8Array instances can be wiped");
        for (var Ee = 0, ke = Se.length; Ee < ke; Ee++)
          Se[Ee] = 0;
      }, c.output_formats = function() {
        return ["uint8array", "text", "hex", "base64"];
      }, c.pad = function(Se, Ee) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("buffer must be a Uint8Array");
        if ((Ee |= 0) <= 0)
          throw new Error("block size must be > 0");
        var ke, Ce = [], Re = ee(4), Fe = 1, qe = 0, Xe = 0 | Se.length, yt = new F(Xe + Ee);
        Ce.push(Re), Ce.push(yt.address);
        for (var Rt = yt.address, Yt = yt.address + Xe + Ee; Rt < Yt; Rt++)
          m.HEAPU8[Rt] = Se[qe], qe += Fe = 1 & ~((65535 & ((Xe -= Fe) >>> 48 | Xe >>> 32 | Xe >>> 16 | Xe)) - 1 >> 16);
        return m._sodium_pad(Re, yt.address, Se.length, Ee, yt.length) !== 0 && Q(Ce, "internal error"), yt.length = m.getValue(Re, "i32"), ke = yt.to_Uint8Array(), ue(Ce), ke;
      }, c.unpad = function(Se, Ee) {
        if (!(Se instanceof Uint8Array))
          throw new TypeError("buffer must be a Uint8Array");
        if ((Ee |= 0) <= 0)
          throw new Error("block size must be > 0");
        var ke = [], Ce = X(Se), Re = ee(4);
        return ke.push(Ce), ke.push(Re), m._sodium_unpad(Re, Ce, Se.length, Ee) !== 0 && Q(ke, "unsupported/invalid padding"), Se = (Se = new Uint8Array(Se)).subarray(0, m.getValue(Re, "i32")), ue(ke), Se;
      }, c.ready = S, c.symbols = function() {
        return Object.keys(c).sort();
      }, c.to_base64 = V, c.to_hex = O, c.to_string = E, c;
    }
    var u = typeof n.sodium == "object" && typeof n.sodium.onload == "function" ? n.sodium.onload : null;
    typeof e.nodeName != "string" ? o(e, requireLibsodiumSumo()) : n.sodium = o(n.commonJsStrict = {}, n.libsodium), u && n.sodium.ready.then(function() {
      u(n.sodium);
    });
  })(commonjsGlobal);
})(libsodiumWrappers);
var __importDefault$K = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium$6, "__esModule", { value: !0 });
libsodium$6.Xchacha20poly1305Ietf = libsodium$6.xchacha20NonceLength = libsodium$6.Ed25519 = libsodium$6.Ed25519Keypair = libsodium$6.Argon2id = libsodium$6.isArgon2idOptions = void 0;
const utils_1$16 = build$M, libsodium_wrappers_sumo_1$5 = __importDefault$K(libsodiumWrappers);
function isArgon2idOptions$6(e) {
  return !(!(0, utils_1$16.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium$6.isArgon2idOptions = isArgon2idOptions$6;
let Argon2id$6 = class {
  static async execute(n, o, u) {
    return await libsodium_wrappers_sumo_1$5.default.ready, libsodium_wrappers_sumo_1$5.default.crypto_pwhash(
      u.outputLength,
      n,
      o,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      u.opsLimit,
      u.memLimitKib * 1024,
      libsodium_wrappers_sumo_1$5.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
};
libsodium$6.Argon2id = Argon2id$6;
let Ed25519Keypair$6 = class Mc {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(n) {
    if (n.length !== 64)
      throw new Error(`Unexpected key length ${n.length}. Must be 64.`);
    return new Mc(n.slice(0, 32), n.slice(32, 64));
  }
  constructor(n, o) {
    this.privkey = n, this.pubkey = o;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
};
libsodium$6.Ed25519Keypair = Ed25519Keypair$6;
let Ed25519$6 = class {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(n) {
    await libsodium_wrappers_sumo_1$5.default.ready;
    const o = libsodium_wrappers_sumo_1$5.default.crypto_sign_seed_keypair(n);
    return Ed25519Keypair$6.fromLibsodiumPrivkey(o.privateKey);
  }
  static async createSignature(n, o) {
    return await libsodium_wrappers_sumo_1$5.default.ready, libsodium_wrappers_sumo_1$5.default.crypto_sign_detached(n, o.toLibsodiumPrivkey());
  }
  static async verifySignature(n, o, u) {
    return await libsodium_wrappers_sumo_1$5.default.ready, libsodium_wrappers_sumo_1$5.default.crypto_sign_verify_detached(n, o, u);
  }
};
libsodium$6.Ed25519 = Ed25519$6;
libsodium$6.xchacha20NonceLength = 24;
let Xchacha20poly1305Ietf$6 = class {
  static async encrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$5.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$5.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      n,
      c,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      u,
      o
    );
  }
  static async decrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$5.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$5.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      n,
      c,
      u,
      o
    );
  }
};
libsodium$6.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf$6;
var random$6 = {};
Object.defineProperty(random$6, "__esModule", { value: !0 });
random$6.Random = void 0;
let Random$6 = class {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(n) {
    try {
      const o = typeof window == "object" ? window : self, u = typeof o.crypto < "u" ? o.crypto : o.msCrypto, c = new Uint8Array(n);
      return u.getRandomValues(c), c;
    } catch {
      try {
        const o = requireCryptoBrowserify();
        return new Uint8Array([...o.randomBytes(n)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
};
random$6.Random = Random$6;
var ripemd$6 = {};
Object.defineProperty(ripemd$6, "__esModule", { value: !0 });
ripemd$6.ripemd160 = ripemd$6.Ripemd160 = void 0;
const ripemd160_1$7 = ripemd160$8, utils_1$15 = utils$A;
let Ripemd160$6 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$7.ripemd160.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$15.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
ripemd$6.Ripemd160 = Ripemd160$6;
function ripemd160$6(e) {
  return new Ripemd160$6(e).digest();
}
ripemd$6.ripemd160 = ripemd160$6;
var secp256k1$d = {}, secp256k1signature$6 = {};
Object.defineProperty(secp256k1signature$6, "__esModule", { value: !0 });
secp256k1signature$6.ExtendedSecp256k1Signature = secp256k1signature$6.Secp256k1Signature = void 0;
function trimLeadingNullBytes$6(e) {
  let n = 0;
  for (const o of e)
    if (o === 0)
      n++;
    else
      break;
  return e.slice(n);
}
const derTagInteger$6 = 2;
let Secp256k1Signature$6 = class xu {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(n) {
    if (n.length !== 64)
      throw new Error(`Got invalid data length: ${n.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new xu(trimLeadingNullBytes$6(n.slice(0, 32)), trimLeadingNullBytes$6(n.slice(32, 64)));
  }
  static fromDer(n) {
    let o = 0;
    if (n[o++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const u = n[o++];
    if (n.length - o !== u)
      throw new Error("Data length mismatch detected");
    if (n[o++] !== derTagInteger$6)
      throw new Error("INTEGER tag expected");
    const d = n[o++];
    if (d >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const m = n.slice(o, o + d);
    if (o += d, n[o++] !== derTagInteger$6)
      throw new Error("INTEGER tag expected");
    const S = n[o++];
    if (S >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const $ = n.slice(o, o + S);
    return o += S, new xu(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes$6(m),
      trimLeadingNullBytes$6($)
    );
  }
  constructor(n, o) {
    if (n.length > 32 || n.length === 0 || n[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (o.length > 32 || o.length === 0 || o[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: n,
      s: o
    };
  }
  r(n) {
    if (n === void 0)
      return this.data.r;
    {
      const o = n - this.data.r.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter r");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.r]);
    }
  }
  s(n) {
    if (n === void 0)
      return this.data.s;
    {
      const o = n - this.data.s.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter s");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const n = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, o = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, u = n.length, c = o.length, d = new Uint8Array([derTagInteger$6, u, ...n, derTagInteger$6, c, ...o]);
    return new Uint8Array([48, d.length, ...d]);
  }
};
secp256k1signature$6.Secp256k1Signature = Secp256k1Signature$6;
let ExtendedSecp256k1Signature$6 = class Tc extends Secp256k1Signature$6 {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(n) {
    if (n.length !== 65)
      throw new Error(`Got invalid data length ${n.length}. Expected 32 + 32 + 1`);
    return new Tc(trimLeadingNullBytes$6(n.slice(0, 32)), trimLeadingNullBytes$6(n.slice(32, 64)), n[64]);
  }
  constructor(n, o, u) {
    if (super(n, o), !Number.isInteger(u))
      throw new Error("The recovery parameter must be an integer.");
    if (u < 0 || u > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = u;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
};
secp256k1signature$6.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature$6;
var __importDefault$J = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$d, "__esModule", { value: !0 });
secp256k1$d.Secp256k1 = void 0;
const encoding_1$1p = build$N, bn_js_1$i = __importDefault$J(bnExports$1), elliptic_1$7 = __importDefault$J(requireElliptic()), secp256k1signature_1$6 = secp256k1signature$6, secp256k1$c = new elliptic_1$7.default.ec("secp256k1"), secp256k1N$6 = new bn_js_1$i.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
let Secp256k1$6 = class {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(n) {
    if (n.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const o = secp256k1$c.keyFromPrivate(n);
    if (o.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$i.default(n).gte(secp256k1N$6))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$1p.fromHex)(o.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(o.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(n, o) {
    if (n.length === 0)
      throw new Error("Message hash must not be empty");
    if (n.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const u = secp256k1$c.keyFromPrivate(o), { r: c, s: d, recoveryParam: m } = u.sign(n, { canonical: !0 });
    if (typeof m != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1$6.ExtendedSecp256k1Signature(Uint8Array.from(c.toArray()), Uint8Array.from(d.toArray()), m);
  }
  static async verifySignature(n, o, u) {
    if (o.length === 0)
      throw new Error("Message hash must not be empty");
    if (o.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const c = secp256k1$c.keyFromPublic(u);
    try {
      return c.verify(o, n.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(n, o) {
    const u = { r: (0, encoding_1$1p.toHex)(n.r()), s: (0, encoding_1$1p.toHex)(n.s()) }, c = secp256k1$c.recoverPubKey(o, u, n.recovery), d = secp256k1$c.keyFromPublic(c);
    return (0, encoding_1$1p.fromHex)(d.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(n) {
    switch (n.length) {
      case 33:
        return n;
      case 65:
        return Uint8Array.from(secp256k1$c.keyFromPublic(n).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(n) {
    switch (n.length) {
      case 33:
        return Uint8Array.from(secp256k1$c.keyFromPublic(n).getPublic(!1, "array"));
      case 65:
        return n;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(n) {
    switch (n.length) {
      case 64:
        return n;
      case 65:
        return n.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
};
secp256k1$d.Secp256k1 = Secp256k1$6;
var slip10$6 = {}, build$L = {}, decimal$5 = {}, __importDefault$I = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal$5, "__esModule", { value: !0 });
decimal$5.Decimal = void 0;
const bn_js_1$h = __importDefault$I(bnExports$1), maxFractionalDigits$5 = 100;
let Decimal$5 = class ns {
  static fromUserInput(n, o) {
    ns.verifyFractionalDigits(o);
    const u = n.match(/[^0-9.]/);
    if (u)
      throw new Error(`Invalid character at position ${u.index + 1}`);
    let c, d;
    if (n === "")
      c = "0", d = "";
    else if (n.search(/\./) === -1)
      c = n, d = "";
    else {
      const v = n.split(".");
      switch (v.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!v[1])
            throw new Error("Fractional part missing");
          c = v[0], d = v[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (d.length > o)
      throw new Error("Got more fractional digits than supported");
    const m = `${c}${d.padEnd(o, "0")}`;
    return new ns(m, o);
  }
  static fromAtomics(n, o) {
    return ns.verifyFractionalDigits(o), new ns(n, o);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(n) {
    return ns.verifyFractionalDigits(n), new ns("0", n);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(n) {
    return ns.verifyFractionalDigits(n), new ns("1" + "0".repeat(n), n);
  }
  static verifyFractionalDigits(n) {
    if (!Number.isInteger(n))
      throw new Error("Fractional digits is not an integer");
    if (n < 0)
      throw new Error("Fractional digits must not be negative");
    if (n > maxFractionalDigits$5)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits$5}`);
  }
  static compare(n, o) {
    if (n.fractionalDigits !== o.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return n.data.atomics.cmp(new bn_js_1$h.default(o.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(n, o) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$h.default(n),
      fractionalDigits: o
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new ns(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const n = new bn_js_1$h.default(10).pow(new bn_js_1$h.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : ns.fromAtomics(o.mul(n).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const n = new bn_js_1$h.default(10).pow(new bn_js_1$h.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : ns.fromAtomics(o.addn(1).mul(n).toString(), this.fractionalDigits);
  }
  toString() {
    const n = new bn_js_1$h.default(10).pow(new bn_js_1$h.default(this.data.fractionalDigits)), o = this.data.atomics.div(n), u = this.data.atomics.mod(n);
    if (u.isZero())
      return o.toString();
    {
      const d = u.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${o.toString()}.${d}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const n = Number(this.toString());
    if (Number.isNaN(n))
      throw new Error("Conversion to number failed");
    return n;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.add(new bn_js_1$h.default(n.atomics));
    return new ns(o.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.sub(new bn_js_1$h.default(n.atomics));
    if (o.ltn(0))
      throw new Error("Difference must not be negative");
    return new ns(o.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(n) {
    const o = this.data.atomics.mul(new bn_js_1$h.default(n.toString()));
    return new ns(o.toString(), this.fractionalDigits);
  }
  equals(n) {
    return ns.compare(this, n) === 0;
  }
  isLessThan(n) {
    return ns.compare(this, n) < 0;
  }
  isLessThanOrEqual(n) {
    return ns.compare(this, n) <= 0;
  }
  isGreaterThan(n) {
    return ns.compare(this, n) > 0;
  }
  isGreaterThanOrEqual(n) {
    return ns.compare(this, n) >= 0;
  }
};
decimal$5.Decimal = Decimal$5;
var integers$5 = {}, __importDefault$H = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers$5, "__esModule", { value: !0 });
integers$5.Uint64 = integers$5.Uint53 = integers$5.Int53 = integers$5.Uint32 = void 0;
const bn_js_1$g = __importDefault$H(bnExports$1), uint64MaxValue$5 = new bn_js_1$g.default("18446744073709551615", 10, "be");
let Uint32$5 = class bu {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(n) {
    return bu.fromBytes(n);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? n : Array.from(n).reverse();
    return new bu(u[0] * 2 ** 24 + u[1] * 2 ** 16 + u[2] * 2 ** 8 + u[3]);
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new bu(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < 0 || n > 4294967295)
      throw new Error("Input not in uint32 range: " + n.toString());
    this.data = n;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$5.Uint32 = Uint32$5;
let Int53$5 = class Dc {
  static fromString(n) {
    if (!n.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Dc(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + n.toString());
    this.data = n;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$5.Int53 = Int53$5;
let Uint53$5 = class Oc {
  static fromString(n) {
    const o = Int53$5.fromString(n);
    return new Oc(o.toNumber());
  }
  constructor(n) {
    const o = new Int53$5(n);
    if (o.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = o;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$5.Uint53 = Uint53$5;
let Uint64$5 = class iu {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(n) {
    return iu.fromBytes(n);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? Array.from(n) : Array.from(n).reverse();
    return new iu(new bn_js_1$g.default(u));
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new iu(new bn_js_1$g.default(n, 10, "be"));
  }
  static fromNumber(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    let o;
    try {
      o = new bn_js_1$g.default(n);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new iu(o);
  }
  constructor(n) {
    if (n.isNeg())
      throw new Error("Input is negative");
    if (n.gt(uint64MaxValue$5))
      throw new Error("Input exceeds uint64 range");
    this.data = n;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
};
integers$5.Uint64 = Uint64$5;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var n = decimal$5;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return n.Decimal;
  } });
  var o = integers$5;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return o.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return o.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return o.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return o.Uint64;
  } });
})(build$L);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const o = build$N, u = build$L, c = n(bnExports$1), d = n(requireElliptic()), m = hmac$6, v = sha$6;
  var S;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(S = e.Slip10Curve || (e.Slip10Curve = {}));
  function $(M) {
    switch (M) {
      case S.Ed25519:
        return S.Ed25519;
      case S.Secp256k1:
        return S.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  e.slip10CurveFromString = $;
  class E extends u.Uint32 {
    static hardened(G) {
      return new E(G + 2 ** 31);
    }
    static normal(G) {
      return new E(G);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = E;
  const O = new d.default.ec("secp256k1");
  class T {
    static derivePath(G, k, F) {
      let X = this.master(G, k);
      for (const ee of F)
        X = this.child(G, X.privkey, X.chainCode, ee);
      return X;
    }
    static master(G, k) {
      const F = new m.Hmac(v.Sha512, (0, o.toAscii)(G)).update(k).digest(), X = F.slice(0, 32), ee = F.slice(32, 64);
      return G !== S.Ed25519 && (this.isZero(X) || this.isGteN(G, X)) ? this.master(G, F) : {
        chainCode: ee,
        privkey: X
      };
    }
    static child(G, k, F, X) {
      let ee;
      if (X.isHardened()) {
        const ue = new Uint8Array([0, ...k, ...X.toBytesBigEndian()]);
        ee = new m.Hmac(v.Sha512, F).update(ue).digest();
      } else {
        if (G === S.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ue = new Uint8Array([
            ...T.serializedPoint(G, new c.default(k)),
            ...X.toBytesBigEndian()
          ]);
          ee = new m.Hmac(v.Sha512, F).update(ue).digest();
        }
      }
      return this.childImpl(G, k, F, X, ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(G, k) {
      switch (G) {
        case S.Secp256k1:
          return (0, o.fromHex)(O.g.mul(k).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(G, k, F, X, ee) {
      const ue = ee.slice(0, 32), Q = ee.slice(32, 64), Y = Q;
      if (G === S.Ed25519)
        return {
          chainCode: Y,
          privkey: ue
        };
      const pe = this.n(G), oe = new c.default(ue).add(new c.default(k)).mod(pe), ne = Uint8Array.from(oe.toArray("be", 32));
      if (this.isGteN(G, ue) || this.isZero(ne)) {
        const H = new m.Hmac(v.Sha512, F).update(new Uint8Array([1, ...Q, ...X.toBytesBigEndian()])).digest();
        return this.childImpl(G, k, F, X, H);
      }
      return {
        chainCode: Y,
        privkey: ne
      };
    }
    static isZero(G) {
      return G.every((k) => k === 0);
    }
    static isGteN(G, k) {
      return new c.default(k).gte(this.n(G));
    }
    static n(G) {
      switch (G) {
        case S.Secp256k1:
          return new c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = T;
  function y(M) {
    return M.reduce((G, k) => {
      const F = k.isHardened() ? `${k.toNumber() - 2147483648}'` : k.toString();
      return G + "/" + F;
    }, "m");
  }
  e.pathToString = y;
  function V(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let G = M.slice(1);
    const k = new Array();
    for (; G; ) {
      const F = G.match(/^\/([0-9]+)('?)/);
      if (!F)
        throw new Error("Syntax error while reading path component");
      const [X, ee, ue] = F, Q = u.Uint53.fromString(ee).toNumber();
      if (Q >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ue ? k.push(E.hardened(Q)) : k.push(E.normal(Q)), G = G.slice(X.length);
    }
    return k;
  }
  e.stringToPath = V;
})(slip10$6);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var n = bip39$6;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return n.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return n.EnglishMnemonic;
  } });
  var o = hmac$6;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return o.Hmac;
  } });
  var u = keccak$6;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return u.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return u.keccak256;
  } });
  var c = libsodium$6;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return c.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return c.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return c.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return c.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return c.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return c.Xchacha20poly1305Ietf;
  } });
  var d = random$6;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return d.Random;
  } });
  var m = ripemd$6;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return m.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return m.ripemd160;
  } });
  var v = secp256k1$d;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return v.Secp256k1;
  } });
  var S = secp256k1signature$6;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return S.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return S.Secp256k1Signature;
  } });
  var $ = sha$6;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return $.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return $.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return $.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return $.sha512;
  } });
  var E = slip10$6;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return E.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return E.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return E.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return E.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return E.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return E.stringToPath;
  } });
})(build$O);
var encoding$2 = {}, pubkeys$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isMultisigThresholdPubkey = e.isSinglePubkey = e.pubkeyType = e.isSecp256k1Pubkey = e.isEd25519Pubkey = void 0;
  function n(d) {
    return d.type === "tendermint/PubKeyEd25519";
  }
  e.isEd25519Pubkey = n;
  function o(d) {
    return d.type === "tendermint/PubKeySecp256k1";
  }
  e.isSecp256k1Pubkey = o, e.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */
    secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */
    ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */
    sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
  };
  function u(d) {
    return [e.pubkeyType.ed25519, e.pubkeyType.secp256k1, e.pubkeyType.sr25519].includes(d.type);
  }
  e.isSinglePubkey = u;
  function c(d) {
    return d.type === "tendermint/PubKeyMultisigThreshold";
  }
  e.isMultisigThresholdPubkey = c;
})(pubkeys$1);
Object.defineProperty(encoding$2, "__esModule", { value: !0 });
encoding$2.encodeBech32Pubkey = encoding$2.encodeAminoPubkey = encoding$2.decodeBech32Pubkey = encoding$2.decodeAminoPubkey = encoding$2.encodeEd25519Pubkey = encoding$2.encodeSecp256k1Pubkey = void 0;
const encoding_1$1o = build$N, math_1$y = build$L, utils_1$14 = build$M, pubkeys_1$5 = pubkeys$1;
function encodeSecp256k1Pubkey$1(e) {
  if (e.length !== 33 || e[0] !== 2 && e[0] !== 3)
    throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
  return {
    type: pubkeys_1$5.pubkeyType.secp256k1,
    value: (0, encoding_1$1o.toBase64)(e)
  };
}
encoding$2.encodeSecp256k1Pubkey = encodeSecp256k1Pubkey$1;
function encodeEd25519Pubkey$1(e) {
  if (e.length !== 32)
    throw new Error("Ed25519 public key must be 32 bytes long");
  return {
    type: pubkeys_1$5.pubkeyType.ed25519,
    value: (0, encoding_1$1o.toBase64)(e)
  };
}
encoding$2.encodeEd25519Pubkey = encodeEd25519Pubkey$1;
const pubkeyAminoPrefixSecp256k1$1 = (0, encoding_1$1o.fromHex)(
  "eb5ae98721"
  /* fixed length */
), pubkeyAminoPrefixEd25519$1 = (0, encoding_1$1o.fromHex)(
  "1624de6420"
  /* fixed length */
), pubkeyAminoPrefixSr25519$1 = (0, encoding_1$1o.fromHex)(
  "0dfb100520"
  /* fixed length */
), pubkeyAminoPrefixMultisigThreshold$1 = (0, encoding_1$1o.fromHex)(
  "22c1f7e2"
  /* variable length not included */
);
function decodeAminoPubkey$1(e) {
  if ((0, utils_1$14.arrayContentStartsWith)(e, pubkeyAminoPrefixSecp256k1$1)) {
    const n = e.slice(pubkeyAminoPrefixSecp256k1$1.length);
    if (n.length !== 33)
      throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
    return {
      type: pubkeys_1$5.pubkeyType.secp256k1,
      value: (0, encoding_1$1o.toBase64)(n)
    };
  } else if ((0, utils_1$14.arrayContentStartsWith)(e, pubkeyAminoPrefixEd25519$1)) {
    const n = e.slice(pubkeyAminoPrefixEd25519$1.length);
    if (n.length !== 32)
      throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
    return {
      type: pubkeys_1$5.pubkeyType.ed25519,
      value: (0, encoding_1$1o.toBase64)(n)
    };
  } else if ((0, utils_1$14.arrayContentStartsWith)(e, pubkeyAminoPrefixSr25519$1)) {
    const n = e.slice(pubkeyAminoPrefixSr25519$1.length);
    if (n.length !== 32)
      throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
    return {
      type: pubkeys_1$5.pubkeyType.sr25519,
      value: (0, encoding_1$1o.toBase64)(n)
    };
  } else {
    if ((0, utils_1$14.arrayContentStartsWith)(e, pubkeyAminoPrefixMultisigThreshold$1))
      return decodeMultisigPubkey$1(e);
    throw new Error("Unsupported public key type. Amino data starts with: " + (0, encoding_1$1o.toHex)(e.slice(0, 5)));
  }
}
encoding$2.decodeAminoPubkey = decodeAminoPubkey$1;
function decodeBech32Pubkey$1(e) {
  const { data: n } = (0, encoding_1$1o.fromBech32)(e);
  return decodeAminoPubkey$1(n);
}
encoding$2.decodeBech32Pubkey = decodeBech32Pubkey$1;
function decodeUvarint$1(e) {
  if (e.length < 1)
    throw new Error("Can't decode varint. EOF");
  if (e[0] > 127)
    throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
  return [e[0], 1];
}
function decodeMultisigPubkey$1(e) {
  const n = Array.from(e), o = n.splice(0, pubkeyAminoPrefixMultisigThreshold$1.length);
  if (!(0, utils_1$14.arrayContentStartsWith)(o, pubkeyAminoPrefixMultisigThreshold$1))
    throw new Error("Invalid multisig prefix.");
  if (n.shift() != 8)
    throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
  const [u, c] = decodeUvarint$1(n);
  n.splice(0, c);
  const d = [];
  for (; n.length > 0; ) {
    if (n.shift() != 18)
      throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
    const [m, v] = decodeUvarint$1(n);
    if (n.splice(0, v), n.length < m)
      throw new Error("Invalid multisig data length.");
    const S = n.splice(0, m), $ = decodeAminoPubkey$1(Uint8Array.from(S));
    d.push($);
  }
  return {
    type: pubkeys_1$5.pubkeyType.multisigThreshold,
    value: {
      threshold: u.toString(),
      pubkeys: d
    }
  };
}
function encodeUvarint$b(e) {
  const n = math_1$y.Uint53.fromString(e.toString()).toNumber();
  if (n > 127)
    throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
  return [n];
}
function encodeAminoPubkey$1(e) {
  if ((0, pubkeys_1$5.isMultisigThresholdPubkey)(e)) {
    const n = Array.from(pubkeyAminoPrefixMultisigThreshold$1);
    n.push(8), n.push(...encodeUvarint$b(e.value.threshold));
    for (const o of e.value.pubkeys.map((u) => encodeAminoPubkey$1(u)))
      n.push(18), n.push(...encodeUvarint$b(o.length)), n.push(...o);
    return new Uint8Array(n);
  } else {
    if ((0, pubkeys_1$5.isEd25519Pubkey)(e))
      return new Uint8Array([...pubkeyAminoPrefixEd25519$1, ...(0, encoding_1$1o.fromBase64)(e.value)]);
    if ((0, pubkeys_1$5.isSecp256k1Pubkey)(e))
      return new Uint8Array([...pubkeyAminoPrefixSecp256k1$1, ...(0, encoding_1$1o.fromBase64)(e.value)]);
    throw new Error("Unsupported pubkey type");
  }
}
encoding$2.encodeAminoPubkey = encodeAminoPubkey$1;
function encodeBech32Pubkey$1(e, n) {
  return (0, encoding_1$1o.toBech32)(n, encodeAminoPubkey$1(e));
}
encoding$2.encodeBech32Pubkey = encodeBech32Pubkey$1;
Object.defineProperty(addresses$5, "__esModule", { value: !0 });
addresses$5.pubkeyToAddress = addresses$5.pubkeyToRawAddress = addresses$5.rawSecp256k1PubkeyToRawAddress = addresses$5.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$u = build$O, encoding_1$1n = build$N, encoding_2$3 = encoding$2, pubkeys_1$4 = pubkeys$1;
function rawEd25519PubkeyToRawAddress$5(e) {
  if (e.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${e.length}`);
  return (0, crypto_1$u.sha256)(e).slice(0, 20);
}
addresses$5.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress$5;
function rawSecp256k1PubkeyToRawAddress$5(e) {
  if (e.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${e.length}`);
  return (0, crypto_1$u.ripemd160)((0, crypto_1$u.sha256)(e));
}
addresses$5.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress$5;
function pubkeyToRawAddress$5(e) {
  if ((0, pubkeys_1$4.isSecp256k1Pubkey)(e)) {
    const n = (0, encoding_1$1n.fromBase64)(e.value);
    return rawSecp256k1PubkeyToRawAddress$5(n);
  } else if ((0, pubkeys_1$4.isEd25519Pubkey)(e)) {
    const n = (0, encoding_1$1n.fromBase64)(e.value);
    return rawEd25519PubkeyToRawAddress$5(n);
  } else if ((0, pubkeys_1$4.isMultisigThresholdPubkey)(e)) {
    const n = (0, encoding_2$3.encodeAminoPubkey)(e);
    return (0, crypto_1$u.sha256)(n).slice(0, 20);
  } else
    throw new Error("Unsupported public key type");
}
addresses$5.pubkeyToRawAddress = pubkeyToRawAddress$5;
function pubkeyToAddress$5(e, n) {
  return (0, encoding_1$1n.toBech32)(n, pubkeyToRawAddress$5(e));
}
addresses$5.pubkeyToAddress = pubkeyToAddress$5;
var coins$4 = {};
Object.defineProperty(coins$4, "__esModule", { value: !0 });
coins$4.addCoins = coins$4.parseCoins = coins$4.coins = coins$4.coin = void 0;
const math_1$x = build$L;
function coin$7(e, n) {
  let o;
  if (typeof e == "number")
    try {
      o = new math_1$x.Uint53(e).toString();
    } catch {
      throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
  else {
    if (!e.match(/^[0-9]+$/))
      throw new Error("Invalid unsigned integer string format");
    o = e.replace(/^0*/, "") || "0";
  }
  return {
    amount: o,
    denom: n
  };
}
coins$4.coin = coin$7;
function coins$3(e, n) {
  return [coin$7(e, n)];
}
coins$4.coins = coins$3;
function parseCoins$2(e) {
  return e.replace(/\s/g, "").split(",").filter(Boolean).map((n) => {
    const o = n.match(/^([0-9]+)([a-zA-Z]+)/);
    if (!o)
      throw new Error("Got an invalid coin string");
    return {
      amount: o[1].replace(/^0+/, "") || "0",
      denom: o[2]
    };
  });
}
coins$4.parseCoins = parseCoins$2;
function addCoins$1(e, n) {
  if (e.denom !== n.denom)
    throw new Error("Trying to add two coins with different denoms");
  return {
    amount: math_1$x.Decimal.fromAtomics(e.amount, 0).plus(math_1$x.Decimal.fromAtomics(n.amount, 0)).atomics,
    denom: e.denom
  };
}
coins$4.addCoins = addCoins$1;
var multisig$2 = {};
Object.defineProperty(multisig$2, "__esModule", { value: !0 });
multisig$2.createMultisigThresholdPubkey = multisig$2.compareArrays = void 0;
const encoding_1$1m = build$N, math_1$w = build$L, addresses_1$5 = addresses$5;
function compareArrays$1(e, n) {
  const o = (0, encoding_1$1m.toHex)(e), u = (0, encoding_1$1m.toHex)(n);
  return o === u ? 0 : o < u ? -1 : 1;
}
multisig$2.compareArrays = compareArrays$1;
function createMultisigThresholdPubkey$1(e, n, o = !1) {
  const u = new math_1$w.Uint53(n);
  if (u.toNumber() > e.length)
    throw new Error(`Threshold k = ${u.toNumber()} exceeds number of keys n = ${e.length}`);
  const c = o ? e : Array.from(e).sort((d, m) => {
    const v = (0, addresses_1$5.pubkeyToRawAddress)(d), S = (0, addresses_1$5.pubkeyToRawAddress)(m);
    return compareArrays$1(v, S);
  });
  return {
    type: "tendermint/PubKeyMultisigThreshold",
    value: {
      threshold: u.toString(),
      pubkeys: c
    }
  };
}
multisig$2.createMultisigThresholdPubkey = createMultisigThresholdPubkey$1;
var omitdefault = {};
Object.defineProperty(omitdefault, "__esModule", { value: !0 });
omitdefault.omitDefault = void 0;
function omitDefault$1(e) {
  switch (typeof e) {
    case "string":
      return e === "" ? void 0 : e;
    case "number":
      return e === 0 ? void 0 : e;
    case "bigint":
      return e === BigInt(0) ? void 0 : e;
    case "boolean":
      return e || void 0;
    default:
      throw new Error(`Got unsupported type '${typeof e}'`);
  }
}
omitdefault.omitDefault = omitDefault$1;
var paths$3 = {};
Object.defineProperty(paths$3, "__esModule", { value: !0 });
paths$3.makeCosmoshubPath = void 0;
const crypto_1$t = build$O;
function makeCosmoshubPath$3(e) {
  return [
    crypto_1$t.Slip10RawIndex.hardened(44),
    crypto_1$t.Slip10RawIndex.hardened(118),
    crypto_1$t.Slip10RawIndex.hardened(0),
    crypto_1$t.Slip10RawIndex.normal(0),
    crypto_1$t.Slip10RawIndex.normal(e)
  ];
}
paths$3.makeCosmoshubPath = makeCosmoshubPath$3;
var secp256k1hdwallet$1 = {}, signature$2 = {};
Object.defineProperty(signature$2, "__esModule", { value: !0 });
signature$2.decodeSignature = signature$2.encodeSecp256k1Signature = void 0;
const encoding_1$1l = build$N, encoding_2$2 = encoding$2, pubkeys_1$3 = pubkeys$1;
function encodeSecp256k1Signature$1(e, n) {
  if (n.length !== 64)
    throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
  return {
    pub_key: (0, encoding_2$2.encodeSecp256k1Pubkey)(e),
    signature: (0, encoding_1$1l.toBase64)(n)
  };
}
signature$2.encodeSecp256k1Signature = encodeSecp256k1Signature$1;
function decodeSignature$1(e) {
  switch (e.pub_key.type) {
    case pubkeys_1$3.pubkeyType.secp256k1:
      return {
        pubkey: (0, encoding_1$1l.fromBase64)(e.pub_key.value),
        signature: (0, encoding_1$1l.fromBase64)(e.signature)
      };
    default:
      throw new Error("Unsupported pubkey type");
  }
}
signature$2.decodeSignature = decodeSignature$1;
var signdoc$1 = {};
Object.defineProperty(signdoc$1, "__esModule", { value: !0 });
signdoc$1.serializeSignDoc = signdoc$1.escapeCharacters = signdoc$1.makeSignDoc = signdoc$1.sortedJsonStringify = void 0;
const encoding_1$1k = build$N, math_1$v = build$L;
function sortedObject$1(e) {
  if (typeof e != "object" || e === null)
    return e;
  if (Array.isArray(e))
    return e.map(sortedObject$1);
  const n = Object.keys(e).sort(), o = {};
  return n.forEach((u) => {
    o[u] = sortedObject$1(e[u]);
  }), o;
}
function sortedJsonStringify$1(e) {
  return JSON.stringify(sortedObject$1(e));
}
signdoc$1.sortedJsonStringify = sortedJsonStringify$1;
function makeSignDoc$3(e, n, o, u, c, d, m) {
  return {
    chain_id: o,
    account_number: math_1$v.Uint53.fromString(c.toString()).toString(),
    sequence: math_1$v.Uint53.fromString(d.toString()).toString(),
    fee: n,
    msgs: e,
    memo: u || "",
    ...m && { timeout_height: m.toString() }
  };
}
signdoc$1.makeSignDoc = makeSignDoc$3;
function escapeCharacters(e) {
  const n = /&/g, o = /</g, u = />/g;
  return e.replace(n, "\\u0026").replace(o, "\\u003c").replace(u, "\\u003e");
}
signdoc$1.escapeCharacters = escapeCharacters;
function serializeSignDoc$1(e) {
  const n = escapeCharacters(sortedJsonStringify$1(e));
  return (0, encoding_1$1k.toUtf8)(n);
}
signdoc$1.serializeSignDoc = serializeSignDoc$1;
var wallet$3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decrypt = e.encrypt = e.supportedAlgorithms = e.executeKdf = e.cosmjsSalt = void 0;
  const n = build$O, o = build$N;
  e.cosmjsSalt = (0, o.toAscii)("The CosmJS salt.");
  async function u(m, v) {
    switch (v.algorithm) {
      case "argon2id": {
        const S = v.params;
        if (!(0, n.isArgon2idOptions)(S))
          throw new Error("Invalid format of argon2id params");
        return n.Argon2id.execute(m, e.cosmjsSalt, S);
      }
      default:
        throw new Error("Unsupported KDF algorithm");
    }
  }
  e.executeKdf = u, e.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
  };
  async function c(m, v, S) {
    switch (S.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const $ = n.Random.getBytes(n.xchacha20NonceLength);
        return new Uint8Array([
          ...$,
          ...await n.Xchacha20poly1305Ietf.encrypt(m, v, $)
        ]);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${S.algorithm}'`);
    }
  }
  e.encrypt = c;
  async function d(m, v, S) {
    switch (S.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const $ = m.slice(0, n.xchacha20NonceLength);
        return n.Xchacha20poly1305Ietf.decrypt(m.slice(n.xchacha20NonceLength), v, $);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${S.algorithm}'`);
    }
  }
  e.decrypt = d;
})(wallet$3);
Object.defineProperty(secp256k1hdwallet$1, "__esModule", { value: !0 });
secp256k1hdwallet$1.Secp256k1HdWallet = secp256k1hdwallet$1.extractKdfConfiguration = void 0;
const crypto_1$s = build$O, encoding_1$1j = build$N, utils_1$13 = build$M, addresses_1$4 = addresses$5, paths_1$1 = paths$3, signature_1$3 = signature$2, signdoc_1$3 = signdoc$1, wallet_1$3 = wallet$3, serializationTypeV1$3 = "secp256k1wallet-v1", basicPasswordHashingOptions$3 = {
  algorithm: "argon2id",
  params: {
    outputLength: 32,
    opsLimit: 24,
    memLimitKib: 12 * 1024
  }
};
function isDerivationJson$3(e) {
  return !(!(0, utils_1$13.isNonNullObject)(e) || typeof e.hdPath != "string" || typeof e.prefix != "string");
}
function extractKdfConfigurationV1$3(e) {
  return e.kdf;
}
function extractKdfConfiguration$3(e) {
  const n = JSON.parse(e);
  if (!(0, utils_1$13.isNonNullObject)(n))
    throw new Error("Root document is not an object.");
  switch (n.type) {
    case serializationTypeV1$3:
      return extractKdfConfigurationV1$3(n);
    default:
      throw new Error("Unsupported serialization type");
  }
}
secp256k1hdwallet$1.extractKdfConfiguration = extractKdfConfiguration$3;
const defaultOptions$3 = {
  bip39Password: "",
  hdPaths: [(0, paths_1$1.makeCosmoshubPath)(0)],
  prefix: "cosmos"
};
let Secp256k1HdWallet$1 = class Ya {
  /**
   * Restores a wallet from the given BIP39 mnemonic.
   *
   * @param mnemonic Any valid English mnemonic.
   * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async fromMnemonic(n, o = {}) {
    const u = new crypto_1$s.EnglishMnemonic(n), c = await crypto_1$s.Bip39.mnemonicToSeed(u, o.bip39Password);
    return new Ya(u, {
      ...o,
      seed: c
    });
  }
  /**
   * Generates a new wallet with a BIP39 mnemonic of the given length.
   *
   * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
   * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async generate(n = 12, o = {}) {
    const u = 4 * Math.floor(11 * n / 33), c = crypto_1$s.Random.getBytes(u), d = crypto_1$s.Bip39.encode(c);
    return Ya.fromMnemonic(d.toString(), o);
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  static async deserialize(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$13.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    switch (u.type) {
      case serializationTypeV1$3:
        return Ya.deserializeTypeV1(n, o);
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
   * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
   * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
   */
  static async deserializeWithEncryptionKey(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$13.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    const c = u;
    switch (c.type) {
      case serializationTypeV1$3: {
        const d = await (0, wallet_1$3.decrypt)((0, encoding_1$1j.fromBase64)(c.data), o, c.encryption), m = JSON.parse((0, encoding_1$1j.fromUtf8)(d)), { mnemonic: v, accounts: S } = m;
        if ((0, utils_1$13.assert)(typeof v == "string"), !Array.isArray(S))
          throw new Error("Property 'accounts' is not an array");
        if (!S.every((O) => isDerivationJson$3(O)))
          throw new Error("Account is not in the correct format.");
        const $ = S[0].prefix;
        if (!S.every(({ prefix: O }) => O === $))
          throw new Error("Accounts do not all have the same prefix");
        const E = S.map(({ hdPath: O }) => (0, crypto_1$s.stringToPath)(O));
        return Ya.fromMnemonic(v, {
          hdPaths: E,
          prefix: $
        });
      }
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  static async deserializeTypeV1(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$13.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    const c = await (0, wallet_1$3.executeKdf)(o, u.kdf);
    return Ya.deserializeWithEncryptionKey(n, c);
  }
  constructor(n, o) {
    const u = o.hdPaths ?? defaultOptions$3.hdPaths, c = o.prefix ?? defaultOptions$3.prefix;
    this.secret = n, this.seed = o.seed, this.accounts = u.map((d) => ({
      hdPath: d,
      prefix: c
    }));
  }
  get mnemonic() {
    return this.secret.toString();
  }
  async getAccounts() {
    return (await this.getAccountsWithPrivkeys()).map(({ algo: o, pubkey: u, address: c }) => ({
      algo: o,
      pubkey: u,
      address: c
    }));
  }
  async signAmino(n, o) {
    const c = (await this.getAccountsWithPrivkeys()).find(({ address: E }) => E === n);
    if (c === void 0)
      throw new Error(`Address ${n} not found in wallet`);
    const { privkey: d, pubkey: m } = c, v = (0, crypto_1$s.sha256)((0, signdoc_1$3.serializeSignDoc)(o)), S = await crypto_1$s.Secp256k1.createSignature(v, d), $ = new Uint8Array([...S.r(32), ...S.s(32)]);
    return {
      signed: o,
      signature: (0, signature_1$3.encodeSecp256k1Signature)(m, $)
    };
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  async serialize(n) {
    const o = basicPasswordHashingOptions$3, u = await (0, wallet_1$3.executeKdf)(n, o);
    return this.serializeWithEncryptionKey(u, o);
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
   * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF options. If this
   * is not the case, the wallet cannot be restored with the original password.
   */
  async serializeWithEncryptionKey(n, o) {
    const u = {
      mnemonic: this.mnemonic,
      accounts: this.accounts.map(({ hdPath: S, prefix: $ }) => ({
        hdPath: (0, crypto_1$s.pathToString)(S),
        prefix: $
      }))
    }, c = (0, encoding_1$1j.toUtf8)(JSON.stringify(u)), d = {
      algorithm: wallet_1$3.supportedAlgorithms.xchacha20poly1305Ietf
    }, m = await (0, wallet_1$3.encrypt)(c, n, d), v = {
      type: serializationTypeV1$3,
      kdf: o,
      encryption: d,
      data: (0, encoding_1$1j.toBase64)(m)
    };
    return JSON.stringify(v);
  }
  async getKeyPair(n) {
    const { privkey: o } = crypto_1$s.Slip10.derivePath(crypto_1$s.Slip10Curve.Secp256k1, this.seed, n), { pubkey: u } = await crypto_1$s.Secp256k1.makeKeypair(o);
    return {
      privkey: o,
      pubkey: crypto_1$s.Secp256k1.compressPubkey(u)
    };
  }
  async getAccountsWithPrivkeys() {
    return Promise.all(this.accounts.map(async ({ hdPath: n, prefix: o }) => {
      const { privkey: u, pubkey: c } = await this.getKeyPair(n), d = (0, encoding_1$1j.toBech32)(o, (0, addresses_1$4.rawSecp256k1PubkeyToRawAddress)(c));
      return {
        algo: "secp256k1",
        privkey: u,
        pubkey: c,
        address: d
      };
    }));
  }
};
secp256k1hdwallet$1.Secp256k1HdWallet = Secp256k1HdWallet$1;
var secp256k1wallet$1 = {};
Object.defineProperty(secp256k1wallet$1, "__esModule", { value: !0 });
secp256k1wallet$1.Secp256k1Wallet = void 0;
const crypto_1$r = build$O, encoding_1$1i = build$N, addresses_1$3 = addresses$5, signature_1$2 = signature$2, signdoc_1$2 = signdoc$1;
let Secp256k1Wallet$1 = class Qc {
  /**
   * Creates a Secp256k1Wallet from the given private key
   *
   * @param privkey The private key.
   * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
   */
  static async fromKey(n, o = "cosmos") {
    const u = (await crypto_1$r.Secp256k1.makeKeypair(n)).pubkey;
    return new Qc(n, crypto_1$r.Secp256k1.compressPubkey(u), o);
  }
  constructor(n, o, u) {
    this.privkey = n, this.pubkey = o, this.prefix = u;
  }
  get address() {
    return (0, encoding_1$1i.toBech32)(this.prefix, (0, addresses_1$3.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
  }
  async getAccounts() {
    return [
      {
        algo: "secp256k1",
        address: this.address,
        pubkey: this.pubkey
      }
    ];
  }
  async signAmino(n, o) {
    if (n !== this.address)
      throw new Error(`Address ${n} not found in wallet`);
    const u = new crypto_1$r.Sha256((0, signdoc_1$2.serializeSignDoc)(o)).digest(), c = await crypto_1$r.Secp256k1.createSignature(u, this.privkey), d = new Uint8Array([...c.r(32), ...c.s(32)]);
    return {
      signed: o,
      signature: (0, signature_1$2.encodeSecp256k1Signature)(this.pubkey, d)
    };
  }
};
secp256k1wallet$1.Secp256k1Wallet = Secp256k1Wallet$1;
var stdtx$1 = {};
Object.defineProperty(stdtx$1, "__esModule", { value: !0 });
stdtx$1.makeStdTx = stdtx$1.isStdTx = void 0;
function isStdTx$1(e) {
  const { memo: n, msg: o, fee: u, signatures: c } = e;
  return typeof n == "string" && Array.isArray(o) && typeof u == "object" && Array.isArray(c);
}
stdtx$1.isStdTx = isStdTx$1;
function makeStdTx$1(e, n) {
  return {
    msg: e.msgs,
    fee: e.fee,
    memo: e.memo,
    signatures: Array.isArray(n) ? n : [n]
  };
}
stdtx$1.makeStdTx = makeStdTx$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.executeKdf = e.makeStdTx = e.isStdTx = e.serializeSignDoc = e.makeSignDoc = e.encodeSecp256k1Signature = e.decodeSignature = e.Secp256k1Wallet = e.Secp256k1HdWallet = e.extractKdfConfiguration = e.pubkeyType = e.isSinglePubkey = e.isSecp256k1Pubkey = e.isMultisigThresholdPubkey = e.isEd25519Pubkey = e.makeCosmoshubPath = e.omitDefault = e.createMultisigThresholdPubkey = e.encodeSecp256k1Pubkey = e.encodeEd25519Pubkey = e.encodeBech32Pubkey = e.encodeAminoPubkey = e.decodeBech32Pubkey = e.decodeAminoPubkey = e.parseCoins = e.coins = e.coin = e.addCoins = e.rawSecp256k1PubkeyToRawAddress = e.rawEd25519PubkeyToRawAddress = e.pubkeyToRawAddress = e.pubkeyToAddress = void 0;
  var n = addresses$5;
  Object.defineProperty(e, "pubkeyToAddress", { enumerable: !0, get: function() {
    return n.pubkeyToAddress;
  } }), Object.defineProperty(e, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return n.pubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return n.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return n.rawSecp256k1PubkeyToRawAddress;
  } });
  var o = coins$4;
  Object.defineProperty(e, "addCoins", { enumerable: !0, get: function() {
    return o.addCoins;
  } }), Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return o.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return o.coins;
  } }), Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return o.parseCoins;
  } });
  var u = encoding$2;
  Object.defineProperty(e, "decodeAminoPubkey", { enumerable: !0, get: function() {
    return u.decodeAminoPubkey;
  } }), Object.defineProperty(e, "decodeBech32Pubkey", { enumerable: !0, get: function() {
    return u.decodeBech32Pubkey;
  } }), Object.defineProperty(e, "encodeAminoPubkey", { enumerable: !0, get: function() {
    return u.encodeAminoPubkey;
  } }), Object.defineProperty(e, "encodeBech32Pubkey", { enumerable: !0, get: function() {
    return u.encodeBech32Pubkey;
  } }), Object.defineProperty(e, "encodeEd25519Pubkey", { enumerable: !0, get: function() {
    return u.encodeEd25519Pubkey;
  } }), Object.defineProperty(e, "encodeSecp256k1Pubkey", { enumerable: !0, get: function() {
    return u.encodeSecp256k1Pubkey;
  } });
  var c = multisig$2;
  Object.defineProperty(e, "createMultisigThresholdPubkey", { enumerable: !0, get: function() {
    return c.createMultisigThresholdPubkey;
  } });
  var d = omitdefault;
  Object.defineProperty(e, "omitDefault", { enumerable: !0, get: function() {
    return d.omitDefault;
  } });
  var m = paths$3;
  Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return m.makeCosmoshubPath;
  } });
  var v = pubkeys$1;
  Object.defineProperty(e, "isEd25519Pubkey", { enumerable: !0, get: function() {
    return v.isEd25519Pubkey;
  } }), Object.defineProperty(e, "isMultisigThresholdPubkey", { enumerable: !0, get: function() {
    return v.isMultisigThresholdPubkey;
  } }), Object.defineProperty(e, "isSecp256k1Pubkey", { enumerable: !0, get: function() {
    return v.isSecp256k1Pubkey;
  } }), Object.defineProperty(e, "isSinglePubkey", { enumerable: !0, get: function() {
    return v.isSinglePubkey;
  } }), Object.defineProperty(e, "pubkeyType", { enumerable: !0, get: function() {
    return v.pubkeyType;
  } });
  var S = secp256k1hdwallet$1;
  Object.defineProperty(e, "extractKdfConfiguration", { enumerable: !0, get: function() {
    return S.extractKdfConfiguration;
  } }), Object.defineProperty(e, "Secp256k1HdWallet", { enumerable: !0, get: function() {
    return S.Secp256k1HdWallet;
  } });
  var $ = secp256k1wallet$1;
  Object.defineProperty(e, "Secp256k1Wallet", { enumerable: !0, get: function() {
    return $.Secp256k1Wallet;
  } });
  var E = signature$2;
  Object.defineProperty(e, "decodeSignature", { enumerable: !0, get: function() {
    return E.decodeSignature;
  } }), Object.defineProperty(e, "encodeSecp256k1Signature", { enumerable: !0, get: function() {
    return E.encodeSecp256k1Signature;
  } });
  var O = signdoc$1;
  Object.defineProperty(e, "makeSignDoc", { enumerable: !0, get: function() {
    return O.makeSignDoc;
  } }), Object.defineProperty(e, "serializeSignDoc", { enumerable: !0, get: function() {
    return O.serializeSignDoc;
  } });
  var T = stdtx$1;
  Object.defineProperty(e, "isStdTx", { enumerable: !0, get: function() {
    return T.isStdTx;
  } }), Object.defineProperty(e, "makeStdTx", { enumerable: !0, get: function() {
    return T.makeStdTx;
  } });
  var y = wallet$3;
  Object.defineProperty(e, "executeKdf", { enumerable: !0, get: function() {
    return y.executeKdf;
  } });
})(build$P);
var build$K = {}, bip39$5 = {}, build$J = {}, ascii$5 = {};
Object.defineProperty(ascii$5, "__esModule", { value: !0 });
ascii$5.fromAscii = ascii$5.toAscii = void 0;
function toAscii$5(e) {
  const n = (o) => o.split("").map((u) => {
    const c = u.charCodeAt(0);
    if (c < 32 || c > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + c);
    return c;
  });
  return Uint8Array.from(n(e));
}
ascii$5.toAscii = toAscii$5;
function fromAscii$5(e) {
  return ((o) => o.map((u) => {
    if (u < 32 || u > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + u);
    return String.fromCharCode(u);
  }))(Array.from(e)).join("");
}
ascii$5.fromAscii = fromAscii$5;
var base64$7 = {}, __createBinding$Q = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$Q = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$Q = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$Q(n, e, o);
  return __setModuleDefault$Q(n, e), n;
};
Object.defineProperty(base64$7, "__esModule", { value: !0 });
base64$7.fromBase64 = base64$7.toBase64 = void 0;
const base64js$5 = __importStar$Q(base64Js);
function toBase64$5(e) {
  return base64js$5.fromByteArray(e);
}
base64$7.toBase64 = toBase64$5;
function fromBase64$5(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$5.toByteArray(e);
}
base64$7.fromBase64 = fromBase64$5;
var bech32$b = {}, __createBinding$P = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$P = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$P = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$P(n, e, o);
  return __setModuleDefault$P(n, e), n;
};
Object.defineProperty(bech32$b, "__esModule", { value: !0 });
bech32$b.normalizeBech32 = bech32$b.fromBech32 = bech32$b.toBech32 = void 0;
const bech32$a = __importStar$P(bech32$f);
function toBech32$5(e, n, o) {
  return bech32$a.encode(e, bech32$a.toWords(n), o);
}
bech32$b.toBech32 = toBech32$5;
function fromBech32$5(e, n = 1 / 0) {
  const o = bech32$a.decode(e, n);
  return {
    prefix: o.prefix,
    data: new Uint8Array(bech32$a.fromWords(o.words))
  };
}
bech32$b.fromBech32 = fromBech32$5;
function normalizeBech32$5(e) {
  const { prefix: n, data: o } = fromBech32$5(e);
  return toBech32$5(n, o);
}
bech32$b.normalizeBech32 = normalizeBech32$5;
var hex$5 = {};
Object.defineProperty(hex$5, "__esModule", { value: !0 });
hex$5.fromHex = hex$5.toHex = void 0;
function toHex$5(e) {
  let n = "";
  for (const o of e)
    n += ("0" + o.toString(16)).slice(-2);
  return n;
}
hex$5.toHex = toHex$5;
function fromHex$5(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let o = 0; o < n.length; o++) {
    const u = 2 * o, c = e.slice(u, u + 2);
    if (!c.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[o] = parseInt(c, 16);
  }
  return n;
}
hex$5.fromHex = fromHex$5;
var rfc3339$5 = {};
Object.defineProperty(rfc3339$5, "__esModule", { value: !0 });
rfc3339$5.toRfc3339 = rfc3339$5.fromRfc3339 = void 0;
const rfc3339Matcher$5 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$5(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function fromRfc3339$5(e) {
  const n = rfc3339Matcher$5.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const o = +n[1], u = +n[2], c = +n[3], d = +n[4], m = +n[5], v = +n[6], S = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let $, E, O;
  n[8] === "Z" ? ($ = 1, E = 0, O = 0) : ($ = n[8].substring(0, 1) === "-" ? -1 : 1, E = +n[8].substring(1, 3), O = +n[8].substring(4, 6));
  const T = $ * (E * 60 + O) * 60, y = Date.UTC(o, u - 1, c, d, m, v, S) - T * 1e3;
  return new Date(y);
}
rfc3339$5.fromRfc3339 = fromRfc3339$5;
function toRfc3339$5(e) {
  const n = e.getUTCFullYear(), o = padded$5(e.getUTCMonth() + 1), u = padded$5(e.getUTCDate()), c = padded$5(e.getUTCHours()), d = padded$5(e.getUTCMinutes()), m = padded$5(e.getUTCSeconds()), v = padded$5(e.getUTCMilliseconds(), 3);
  return `${n}-${o}-${u}T${c}:${d}:${m}.${v}Z`;
}
rfc3339$5.toRfc3339 = toRfc3339$5;
var utf8$8 = {};
Object.defineProperty(utf8$8, "__esModule", { value: !0 });
utf8$8.fromUtf8 = utf8$8.toUtf8 = void 0;
function toUtf8$5(e) {
  return new TextEncoder().encode(e);
}
utf8$8.toUtf8 = toUtf8$5;
function fromUtf8$5(e, n = !1) {
  const o = !n;
  return new TextDecoder("utf-8", { fatal: o }).decode(e);
}
utf8$8.fromUtf8 = fromUtf8$5;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = ascii$5;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var o = base64$7;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return o.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return o.toBase64;
  } });
  var u = bech32$b;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return u.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return u.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return u.toBech32;
  } });
  var c = hex$5;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return c.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return c.toHex;
  } });
  var d = rfc3339$5;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return d.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return d.toRfc3339;
  } });
  var m = utf8$8;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return m.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return m.toUtf8;
  } });
})(build$J);
var pbkdf2$5 = {}, build$I = {}, arrays$5 = {};
Object.defineProperty(arrays$5, "__esModule", { value: !0 });
arrays$5.arrayContentStartsWith = arrays$5.arrayContentEquals = void 0;
function arrayContentEquals$5(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$5.arrayContentEquals = arrayContentEquals$5;
function arrayContentStartsWith$5(e, n) {
  if (e.length < n.length)
    return !1;
  for (let o = 0; o < n.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$5.arrayContentStartsWith = arrayContentStartsWith$5;
var assert$f = {};
Object.defineProperty(assert$f, "__esModule", { value: !0 });
assert$f.assertDefinedAndNotNull = assert$f.assertDefined = assert$f.assert = void 0;
function assert$e(e, n) {
  if (!e)
    throw new Error(n || "condition is not truthy");
}
assert$f.assert = assert$e;
function assertDefined$5(e, n) {
  if (e === void 0)
    throw new Error(n ?? "value is undefined");
}
assert$f.assertDefined = assertDefined$5;
function assertDefinedAndNotNull$5(e, n) {
  if (e == null)
    throw new Error(n ?? "value is undefined or null");
}
assert$f.assertDefinedAndNotNull = assertDefinedAndNotNull$5;
var sleep$b = {};
Object.defineProperty(sleep$b, "__esModule", { value: !0 });
sleep$b.sleep = void 0;
async function sleep$a(e) {
  return new Promise((n) => setTimeout(n, e));
}
sleep$b.sleep = sleep$a;
var typechecks$5 = {};
Object.defineProperty(typechecks$5, "__esModule", { value: !0 });
typechecks$5.isDefined = typechecks$5.isUint8Array = typechecks$5.isNonNullObject = void 0;
function isNonNullObject$5(e) {
  return typeof e == "object" && e !== null;
}
typechecks$5.isNonNullObject = isNonNullObject$5;
function isUint8Array$5(e) {
  return !(!isNonNullObject$5(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(e));
}
typechecks$5.isUint8Array = isUint8Array$5;
function isDefined$5(e) {
  return e !== void 0;
}
typechecks$5.isDefined = isDefined$5;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var n = arrays$5;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return n.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return n.arrayContentStartsWith;
  } });
  var o = assert$f;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return o.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return o.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return o.assertDefinedAndNotNull;
  } });
  var u = sleep$b;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return u.sleep;
  } });
  var c = typechecks$5;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return c.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return c.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return c.isUint8Array;
  } });
})(build$I);
var __createBinding$O = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$O = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$O = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$O(n, e, o);
  return __setModuleDefault$O(n, e), n;
};
Object.defineProperty(pbkdf2$5, "__esModule", { value: !0 });
pbkdf2$5.pbkdf2Sha512 = pbkdf2$5.pbkdf2Sha512Noble = pbkdf2$5.pbkdf2Sha512NodeCrypto = pbkdf2$5.pbkdf2Sha512Subtle = pbkdf2$5.getSubtle = pbkdf2$5.getNodeCrypto = void 0;
const utils_1$12 = build$I, pbkdf2_1$b = pbkdf2$8, sha512_1$c = sha512$a;
async function getNodeCrypto$4() {
  try {
    const e = await Promise.resolve().then(() => __importStar$O(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2$5.getNodeCrypto = getNodeCrypto$4;
async function getSubtle$5() {
  var n, o, u;
  let e = (n = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : n.subtle;
  return e || (e = (u = (o = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : o.webcrypto) == null ? void 0 : u.subtle), e;
}
pbkdf2$5.getSubtle = getSubtle$5;
async function pbkdf2Sha512Subtle$5(e, n, o, u, c) {
  return (0, utils_1$12.assert)(e, "Argument subtle is falsy"), (0, utils_1$12.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$12.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$12.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", n, { name: "PBKDF2" }, !1, ["deriveBits"]).then((d) => e.deriveBits({
    name: "PBKDF2",
    salt: o,
    iterations: u,
    hash: { name: "SHA-512" }
  }, d, c * 8).then((m) => new Uint8Array(m)));
}
pbkdf2$5.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle$5;
async function pbkdf2Sha512NodeCrypto$4(e, n, o, u, c) {
  return (0, utils_1$12.assert)(e, "Argument nodeCrypto is falsy"), (0, utils_1$12.assert)(typeof e == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$12.assert)(typeof e.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((d, m) => {
    e.pbkdf2(n, o, u, c, "sha512", (v, S) => {
      v ? m(v) : d(Uint8Array.from(S));
    });
  });
}
pbkdf2$5.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto$4;
async function pbkdf2Sha512Noble$5(e, n, o, u) {
  return (0, pbkdf2_1$b.pbkdf2Async)(sha512_1$c.sha512, e, n, { c: o, dkLen: u });
}
pbkdf2$5.pbkdf2Sha512Noble = pbkdf2Sha512Noble$5;
async function pbkdf2Sha512$5(e, n, o, u) {
  const c = await getSubtle$5();
  if (c)
    return pbkdf2Sha512Subtle$5(c, e, n, o, u);
  {
    const d = await getNodeCrypto$4();
    return d ? pbkdf2Sha512NodeCrypto$4(d, e, n, o, u) : pbkdf2Sha512Noble$5(e, n, o, u);
  }
}
pbkdf2$5.pbkdf2Sha512 = pbkdf2Sha512$5;
var sha$5 = {}, utils$z = {};
Object.defineProperty(utils$z, "__esModule", { value: !0 });
utils$z.toRealUint8Array = void 0;
function toRealUint8Array$5(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$z.toRealUint8Array = toRealUint8Array$5;
Object.defineProperty(sha$5, "__esModule", { value: !0 });
sha$5.sha512 = sha$5.Sha512 = sha$5.sha256 = sha$5.Sha256 = void 0;
const sha256_1$6 = sha256$8, sha512_1$b = sha512$a, utils_1$11 = utils$z;
let Sha256$5 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha256_1$6.sha256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$11.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$5.Sha256 = Sha256$5;
function sha256$5(e) {
  return new Sha256$5(e).digest();
}
sha$5.sha256 = sha256$5;
let Sha512$5 = class {
  constructor(n) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$b.sha512.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$11.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$5.Sha512 = Sha512$5;
function sha512$5(e) {
  return new Sha512$5(e).digest();
}
sha$5.sha512 = sha512$5;
Object.defineProperty(bip39$5, "__esModule", { value: !0 });
bip39$5.Bip39 = bip39$5.EnglishMnemonic = bip39$5.mnemonicToEntropy = bip39$5.entropyToMnemonic = void 0;
const encoding_1$1h = build$J, pbkdf2_1$a = pbkdf2$5, sha_1$5 = sha$5, wordlist$5 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring$5(e) {
  return Array.from(e).map((n) => n.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits$5(e) {
  const o = e.length * 8 / 32, u = (0, sha_1$5.sha256)(e);
  return bytesToBitstring$5(u).slice(0, o);
}
function bitstringToByte$5(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths$5 = [16, 20, 24, 28, 32], allowedWordLengths$5 = [12, 15, 18, 21, 24];
function entropyToMnemonic$5(e) {
  if (allowedEntropyLengths$5.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const n = bytesToBitstring$5(e), o = deriveChecksumBits$5(e);
  return (n + o).match(/(.{11})/g).map((m) => {
    const v = bitstringToByte$5(m);
    return wordlist$5[v];
  }).join(" ");
}
bip39$5.entropyToMnemonic = entropyToMnemonic$5;
const invalidNumberOfWorks$5 = "Invalid number of words", wordNotInWordlist$5 = "Found word that is not in the wordlist", invalidEntropy$5 = "Invalid entropy", invalidChecksum$5 = "Invalid mnemonic checksum";
function normalize$5(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy$5(e) {
  const n = normalize$5(e).split(" ");
  if (!allowedWordLengths$5.includes(n.length))
    throw new Error(invalidNumberOfWorks$5);
  const o = n.map(($) => {
    const E = wordlist$5.indexOf($);
    if (E === -1)
      throw new Error(wordNotInWordlist$5);
    return E.toString(2).padStart(11, "0");
  }).join(""), u = Math.floor(o.length / 33) * 32, c = o.slice(0, u), d = o.slice(u), m = c.match(/(.{1,8})/g).map(bitstringToByte$5);
  if (m.length < 16 || m.length > 32 || m.length % 4 !== 0)
    throw new Error(invalidEntropy$5);
  const v = Uint8Array.from(m);
  if (deriveChecksumBits$5(v) !== d)
    throw new Error(invalidChecksum$5);
  return v;
}
bip39$5.mnemonicToEntropy = mnemonicToEntropy$5;
let EnglishMnemonic$5 = class Uu {
  constructor(n) {
    if (!Uu.mnemonicMatcher.test(n))
      throw new Error("Invalid mnemonic format");
    const o = n.split(" "), u = [12, 15, 18, 21, 24];
    if (u.indexOf(o.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${u} got: ${o.length})`);
    for (const c of o)
      if (Uu.wordlist.indexOf(c) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy$5(n), this.data = n;
  }
  toString() {
    return this.data;
  }
};
bip39$5.EnglishMnemonic = EnglishMnemonic$5;
EnglishMnemonic$5.wordlist = wordlist$5;
EnglishMnemonic$5.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
let Bip39$5 = class {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(n) {
    return new EnglishMnemonic$5(entropyToMnemonic$5(n));
  }
  static decode(n) {
    return mnemonicToEntropy$5(n.toString());
  }
  static async mnemonicToSeed(n, o) {
    const u = (0, encoding_1$1h.toUtf8)(normalize$5(n.toString())), c = "mnemonic" + (o ? normalize$5(o) : ""), d = (0, encoding_1$1h.toUtf8)(c);
    return (0, pbkdf2_1$a.pbkdf2Sha512)(u, d, 2048, 64);
  }
};
bip39$5.Bip39 = Bip39$5;
var hmac$5 = {};
Object.defineProperty(hmac$5, "__esModule", { value: !0 });
hmac$5.Hmac = void 0;
let Hmac$5 = class {
  constructor(n, o) {
    const u = new n().blockSize;
    this.hash = (d) => new n().update(d).digest();
    let c = o;
    if (c.length > u && (c = this.hash(c)), c.length < u) {
      const d = new Uint8Array(u - c.length);
      c = new Uint8Array([...c, ...d]);
    }
    this.oKeyPad = c.map((d) => d ^ 92), this.iKeyPad = c.map((d) => d ^ 54), this.messageHasher = new n(), this.blockSize = u, this.update(this.iKeyPad);
  }
  update(n) {
    return this.messageHasher.update(n), this;
  }
  digest() {
    const n = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...n]));
  }
};
hmac$5.Hmac = Hmac$5;
var keccak$5 = {};
Object.defineProperty(keccak$5, "__esModule", { value: !0 });
keccak$5.keccak256 = keccak$5.Keccak256 = void 0;
const sha3_1$5 = sha3$3, utils_1$10 = utils$z;
let Keccak256$5 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha3_1$5.keccak_256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$10.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
keccak$5.Keccak256 = Keccak256$5;
function keccak256$6(e) {
  return new Keccak256$5(e).digest();
}
keccak$5.keccak256 = keccak256$6;
var libsodium$5 = {}, __importDefault$G = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium$5, "__esModule", { value: !0 });
libsodium$5.Xchacha20poly1305Ietf = libsodium$5.xchacha20NonceLength = libsodium$5.Ed25519 = libsodium$5.Ed25519Keypair = libsodium$5.Argon2id = libsodium$5.isArgon2idOptions = void 0;
const utils_1$$ = build$I, libsodium_wrappers_sumo_1$4 = __importDefault$G(libsodiumWrappers);
function isArgon2idOptions$5(e) {
  return !(!(0, utils_1$$.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium$5.isArgon2idOptions = isArgon2idOptions$5;
let Argon2id$5 = class {
  static async execute(n, o, u) {
    return await libsodium_wrappers_sumo_1$4.default.ready, libsodium_wrappers_sumo_1$4.default.crypto_pwhash(
      u.outputLength,
      n,
      o,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      u.opsLimit,
      u.memLimitKib * 1024,
      libsodium_wrappers_sumo_1$4.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
};
libsodium$5.Argon2id = Argon2id$5;
let Ed25519Keypair$5 = class Nc {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(n) {
    if (n.length !== 64)
      throw new Error(`Unexpected key length ${n.length}. Must be 64.`);
    return new Nc(n.slice(0, 32), n.slice(32, 64));
  }
  constructor(n, o) {
    this.privkey = n, this.pubkey = o;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
};
libsodium$5.Ed25519Keypair = Ed25519Keypair$5;
let Ed25519$5 = class {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(n) {
    await libsodium_wrappers_sumo_1$4.default.ready;
    const o = libsodium_wrappers_sumo_1$4.default.crypto_sign_seed_keypair(n);
    return Ed25519Keypair$5.fromLibsodiumPrivkey(o.privateKey);
  }
  static async createSignature(n, o) {
    return await libsodium_wrappers_sumo_1$4.default.ready, libsodium_wrappers_sumo_1$4.default.crypto_sign_detached(n, o.toLibsodiumPrivkey());
  }
  static async verifySignature(n, o, u) {
    return await libsodium_wrappers_sumo_1$4.default.ready, libsodium_wrappers_sumo_1$4.default.crypto_sign_verify_detached(n, o, u);
  }
};
libsodium$5.Ed25519 = Ed25519$5;
libsodium$5.xchacha20NonceLength = 24;
let Xchacha20poly1305Ietf$5 = class {
  static async encrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$4.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$4.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      n,
      c,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      u,
      o
    );
  }
  static async decrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$4.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$4.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      n,
      c,
      u,
      o
    );
  }
};
libsodium$5.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf$5;
var random$5 = {};
Object.defineProperty(random$5, "__esModule", { value: !0 });
random$5.Random = void 0;
let Random$5 = class {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(n) {
    try {
      const o = typeof window == "object" ? window : self, u = typeof o.crypto < "u" ? o.crypto : o.msCrypto, c = new Uint8Array(n);
      return u.getRandomValues(c), c;
    } catch {
      try {
        const o = requireCryptoBrowserify();
        return new Uint8Array([...o.randomBytes(n)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
};
random$5.Random = Random$5;
var ripemd$5 = {};
Object.defineProperty(ripemd$5, "__esModule", { value: !0 });
ripemd$5.ripemd160 = ripemd$5.Ripemd160 = void 0;
const ripemd160_1$6 = ripemd160$8, utils_1$_ = utils$z;
let Ripemd160$5 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$6.ripemd160.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$_.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
ripemd$5.Ripemd160 = Ripemd160$5;
function ripemd160$5(e) {
  return new Ripemd160$5(e).digest();
}
ripemd$5.ripemd160 = ripemd160$5;
var secp256k1$b = {}, secp256k1signature$5 = {};
Object.defineProperty(secp256k1signature$5, "__esModule", { value: !0 });
secp256k1signature$5.ExtendedSecp256k1Signature = secp256k1signature$5.Secp256k1Signature = void 0;
function trimLeadingNullBytes$5(e) {
  let n = 0;
  for (const o of e)
    if (o === 0)
      n++;
    else
      break;
  return e.slice(n);
}
const derTagInteger$5 = 2;
let Secp256k1Signature$5 = class qu {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(n) {
    if (n.length !== 64)
      throw new Error(`Got invalid data length: ${n.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new qu(trimLeadingNullBytes$5(n.slice(0, 32)), trimLeadingNullBytes$5(n.slice(32, 64)));
  }
  static fromDer(n) {
    let o = 0;
    if (n[o++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const u = n[o++];
    if (n.length - o !== u)
      throw new Error("Data length mismatch detected");
    if (n[o++] !== derTagInteger$5)
      throw new Error("INTEGER tag expected");
    const d = n[o++];
    if (d >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const m = n.slice(o, o + d);
    if (o += d, n[o++] !== derTagInteger$5)
      throw new Error("INTEGER tag expected");
    const S = n[o++];
    if (S >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const $ = n.slice(o, o + S);
    return o += S, new qu(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes$5(m),
      trimLeadingNullBytes$5($)
    );
  }
  constructor(n, o) {
    if (n.length > 32 || n.length === 0 || n[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (o.length > 32 || o.length === 0 || o[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: n,
      s: o
    };
  }
  r(n) {
    if (n === void 0)
      return this.data.r;
    {
      const o = n - this.data.r.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter r");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.r]);
    }
  }
  s(n) {
    if (n === void 0)
      return this.data.s;
    {
      const o = n - this.data.s.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter s");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const n = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, o = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, u = n.length, c = o.length, d = new Uint8Array([derTagInteger$5, u, ...n, derTagInteger$5, c, ...o]);
    return new Uint8Array([48, d.length, ...d]);
  }
};
secp256k1signature$5.Secp256k1Signature = Secp256k1Signature$5;
let ExtendedSecp256k1Signature$5 = class xc extends Secp256k1Signature$5 {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(n) {
    if (n.length !== 65)
      throw new Error(`Got invalid data length ${n.length}. Expected 32 + 32 + 1`);
    return new xc(trimLeadingNullBytes$5(n.slice(0, 32)), trimLeadingNullBytes$5(n.slice(32, 64)), n[64]);
  }
  constructor(n, o, u) {
    if (super(n, o), !Number.isInteger(u))
      throw new Error("The recovery parameter must be an integer.");
    if (u < 0 || u > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = u;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
};
secp256k1signature$5.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature$5;
var __importDefault$F = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$b, "__esModule", { value: !0 });
secp256k1$b.Secp256k1 = void 0;
const encoding_1$1g = build$J, bn_js_1$f = __importDefault$F(bnExports$1), elliptic_1$6 = __importDefault$F(requireElliptic()), secp256k1signature_1$5 = secp256k1signature$5, secp256k1$a = new elliptic_1$6.default.ec("secp256k1"), secp256k1N$5 = new bn_js_1$f.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
let Secp256k1$5 = class {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(n) {
    if (n.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const o = secp256k1$a.keyFromPrivate(n);
    if (o.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$f.default(n).gte(secp256k1N$5))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$1g.fromHex)(o.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(o.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(n, o) {
    if (n.length === 0)
      throw new Error("Message hash must not be empty");
    if (n.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const u = secp256k1$a.keyFromPrivate(o), { r: c, s: d, recoveryParam: m } = u.sign(n, { canonical: !0 });
    if (typeof m != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1$5.ExtendedSecp256k1Signature(Uint8Array.from(c.toArray()), Uint8Array.from(d.toArray()), m);
  }
  static async verifySignature(n, o, u) {
    if (o.length === 0)
      throw new Error("Message hash must not be empty");
    if (o.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const c = secp256k1$a.keyFromPublic(u);
    try {
      return c.verify(o, n.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(n, o) {
    const u = { r: (0, encoding_1$1g.toHex)(n.r()), s: (0, encoding_1$1g.toHex)(n.s()) }, c = secp256k1$a.recoverPubKey(o, u, n.recovery), d = secp256k1$a.keyFromPublic(c);
    return (0, encoding_1$1g.fromHex)(d.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(n) {
    switch (n.length) {
      case 33:
        return n;
      case 65:
        return Uint8Array.from(secp256k1$a.keyFromPublic(n).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(n) {
    switch (n.length) {
      case 33:
        return Uint8Array.from(secp256k1$a.keyFromPublic(n).getPublic(!1, "array"));
      case 65:
        return n;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(n) {
    switch (n.length) {
      case 64:
        return n;
      case 65:
        return n.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
};
secp256k1$b.Secp256k1 = Secp256k1$5;
var slip10$5 = {}, build$H = {}, decimal$4 = {}, __importDefault$E = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal$4, "__esModule", { value: !0 });
decimal$4.Decimal = void 0;
const bn_js_1$e = __importDefault$E(bnExports$1), maxFractionalDigits$4 = 100;
let Decimal$4 = class rs {
  static fromUserInput(n, o) {
    rs.verifyFractionalDigits(o);
    const u = n.match(/[^0-9.]/);
    if (u)
      throw new Error(`Invalid character at position ${u.index + 1}`);
    let c, d;
    if (n === "")
      c = "0", d = "";
    else if (n.search(/\./) === -1)
      c = n, d = "";
    else {
      const v = n.split(".");
      switch (v.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!v[1])
            throw new Error("Fractional part missing");
          c = v[0], d = v[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (d.length > o)
      throw new Error("Got more fractional digits than supported");
    const m = `${c}${d.padEnd(o, "0")}`;
    return new rs(m, o);
  }
  static fromAtomics(n, o) {
    return rs.verifyFractionalDigits(o), new rs(n, o);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(n) {
    return rs.verifyFractionalDigits(n), new rs("0", n);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(n) {
    return rs.verifyFractionalDigits(n), new rs("1" + "0".repeat(n), n);
  }
  static verifyFractionalDigits(n) {
    if (!Number.isInteger(n))
      throw new Error("Fractional digits is not an integer");
    if (n < 0)
      throw new Error("Fractional digits must not be negative");
    if (n > maxFractionalDigits$4)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits$4}`);
  }
  static compare(n, o) {
    if (n.fractionalDigits !== o.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return n.data.atomics.cmp(new bn_js_1$e.default(o.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(n, o) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$e.default(n),
      fractionalDigits: o
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new rs(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const n = new bn_js_1$e.default(10).pow(new bn_js_1$e.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : rs.fromAtomics(o.mul(n).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const n = new bn_js_1$e.default(10).pow(new bn_js_1$e.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : rs.fromAtomics(o.addn(1).mul(n).toString(), this.fractionalDigits);
  }
  toString() {
    const n = new bn_js_1$e.default(10).pow(new bn_js_1$e.default(this.data.fractionalDigits)), o = this.data.atomics.div(n), u = this.data.atomics.mod(n);
    if (u.isZero())
      return o.toString();
    {
      const d = u.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${o.toString()}.${d}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const n = Number(this.toString());
    if (Number.isNaN(n))
      throw new Error("Conversion to number failed");
    return n;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.add(new bn_js_1$e.default(n.atomics));
    return new rs(o.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.sub(new bn_js_1$e.default(n.atomics));
    if (o.ltn(0))
      throw new Error("Difference must not be negative");
    return new rs(o.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(n) {
    const o = this.data.atomics.mul(new bn_js_1$e.default(n.toString()));
    return new rs(o.toString(), this.fractionalDigits);
  }
  equals(n) {
    return rs.compare(this, n) === 0;
  }
  isLessThan(n) {
    return rs.compare(this, n) < 0;
  }
  isLessThanOrEqual(n) {
    return rs.compare(this, n) <= 0;
  }
  isGreaterThan(n) {
    return rs.compare(this, n) > 0;
  }
  isGreaterThanOrEqual(n) {
    return rs.compare(this, n) >= 0;
  }
};
decimal$4.Decimal = Decimal$4;
var integers$4 = {}, __importDefault$D = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers$4, "__esModule", { value: !0 });
integers$4.Uint64 = integers$4.Uint53 = integers$4.Int53 = integers$4.Uint32 = void 0;
const bn_js_1$d = __importDefault$D(bnExports$1), uint64MaxValue$4 = new bn_js_1$d.default("18446744073709551615", 10, "be");
let Uint32$4 = class Cu {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(n) {
    return Cu.fromBytes(n);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? n : Array.from(n).reverse();
    return new Cu(u[0] * 2 ** 24 + u[1] * 2 ** 16 + u[2] * 2 ** 8 + u[3]);
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Cu(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < 0 || n > 4294967295)
      throw new Error("Input not in uint32 range: " + n.toString());
    this.data = n;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$4.Uint32 = Uint32$4;
let Int53$4 = class Uc {
  static fromString(n) {
    if (!n.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uc(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + n.toString());
    this.data = n;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$4.Int53 = Int53$4;
let Uint53$4 = class qc {
  static fromString(n) {
    const o = Int53$4.fromString(n);
    return new qc(o.toNumber());
  }
  constructor(n) {
    const o = new Int53$4(n);
    if (o.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = o;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$4.Uint53 = Uint53$4;
let Uint64$4 = class su {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(n) {
    return su.fromBytes(n);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? Array.from(n) : Array.from(n).reverse();
    return new su(new bn_js_1$d.default(u));
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new su(new bn_js_1$d.default(n, 10, "be"));
  }
  static fromNumber(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    let o;
    try {
      o = new bn_js_1$d.default(n);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new su(o);
  }
  constructor(n) {
    if (n.isNeg())
      throw new Error("Input is negative");
    if (n.gt(uint64MaxValue$4))
      throw new Error("Input exceeds uint64 range");
    this.data = n;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
};
integers$4.Uint64 = Uint64$4;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var n = decimal$4;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return n.Decimal;
  } });
  var o = integers$4;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return o.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return o.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return o.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return o.Uint64;
  } });
})(build$H);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const o = build$J, u = build$H, c = n(bnExports$1), d = n(requireElliptic()), m = hmac$5, v = sha$5;
  var S;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(S = e.Slip10Curve || (e.Slip10Curve = {}));
  function $(M) {
    switch (M) {
      case S.Ed25519:
        return S.Ed25519;
      case S.Secp256k1:
        return S.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  e.slip10CurveFromString = $;
  class E extends u.Uint32 {
    static hardened(G) {
      return new E(G + 2 ** 31);
    }
    static normal(G) {
      return new E(G);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = E;
  const O = new d.default.ec("secp256k1");
  class T {
    static derivePath(G, k, F) {
      let X = this.master(G, k);
      for (const ee of F)
        X = this.child(G, X.privkey, X.chainCode, ee);
      return X;
    }
    static master(G, k) {
      const F = new m.Hmac(v.Sha512, (0, o.toAscii)(G)).update(k).digest(), X = F.slice(0, 32), ee = F.slice(32, 64);
      return G !== S.Ed25519 && (this.isZero(X) || this.isGteN(G, X)) ? this.master(G, F) : {
        chainCode: ee,
        privkey: X
      };
    }
    static child(G, k, F, X) {
      let ee;
      if (X.isHardened()) {
        const ue = new Uint8Array([0, ...k, ...X.toBytesBigEndian()]);
        ee = new m.Hmac(v.Sha512, F).update(ue).digest();
      } else {
        if (G === S.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ue = new Uint8Array([
            ...T.serializedPoint(G, new c.default(k)),
            ...X.toBytesBigEndian()
          ]);
          ee = new m.Hmac(v.Sha512, F).update(ue).digest();
        }
      }
      return this.childImpl(G, k, F, X, ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(G, k) {
      switch (G) {
        case S.Secp256k1:
          return (0, o.fromHex)(O.g.mul(k).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(G, k, F, X, ee) {
      const ue = ee.slice(0, 32), Q = ee.slice(32, 64), Y = Q;
      if (G === S.Ed25519)
        return {
          chainCode: Y,
          privkey: ue
        };
      const pe = this.n(G), oe = new c.default(ue).add(new c.default(k)).mod(pe), ne = Uint8Array.from(oe.toArray("be", 32));
      if (this.isGteN(G, ue) || this.isZero(ne)) {
        const H = new m.Hmac(v.Sha512, F).update(new Uint8Array([1, ...Q, ...X.toBytesBigEndian()])).digest();
        return this.childImpl(G, k, F, X, H);
      }
      return {
        chainCode: Y,
        privkey: ne
      };
    }
    static isZero(G) {
      return G.every((k) => k === 0);
    }
    static isGteN(G, k) {
      return new c.default(k).gte(this.n(G));
    }
    static n(G) {
      switch (G) {
        case S.Secp256k1:
          return new c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = T;
  function y(M) {
    return M.reduce((G, k) => {
      const F = k.isHardened() ? `${k.toNumber() - 2147483648}'` : k.toString();
      return G + "/" + F;
    }, "m");
  }
  e.pathToString = y;
  function V(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let G = M.slice(1);
    const k = new Array();
    for (; G; ) {
      const F = G.match(/^\/([0-9]+)('?)/);
      if (!F)
        throw new Error("Syntax error while reading path component");
      const [X, ee, ue] = F, Q = u.Uint53.fromString(ee).toNumber();
      if (Q >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ue ? k.push(E.hardened(Q)) : k.push(E.normal(Q)), G = G.slice(X.length);
    }
    return k;
  }
  e.stringToPath = V;
})(slip10$5);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var n = bip39$5;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return n.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return n.EnglishMnemonic;
  } });
  var o = hmac$5;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return o.Hmac;
  } });
  var u = keccak$5;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return u.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return u.keccak256;
  } });
  var c = libsodium$5;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return c.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return c.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return c.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return c.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return c.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return c.Xchacha20poly1305Ietf;
  } });
  var d = random$5;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return d.Random;
  } });
  var m = ripemd$5;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return m.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return m.ripemd160;
  } });
  var v = secp256k1$b;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return v.Secp256k1;
  } });
  var S = secp256k1signature$5;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return S.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return S.Secp256k1Signature;
  } });
  var $ = sha$5;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return $.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return $.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return $.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return $.sha512;
  } });
  var E = slip10$5;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return E.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return E.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return E.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return E.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return E.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return E.stringToPath;
  } });
})(build$K);
var signing$2 = {};
Object.defineProperty(signing$2, "__esModule", { value: !0 });
signing$2.makeSignBytes = signing$2.makeSignDoc = signing$2.makeAuthInfoBytes = void 0;
const utils_1$Z = build$I, signing_1$a = signing$3, tx_1$s = tx$p;
function makeSignerInfos$1(e, n) {
  return e.map(({ pubkey: o, sequence: u }) => ({
    publicKey: o,
    modeInfo: {
      single: { mode: n }
    },
    sequence: BigInt(u)
  }));
}
function makeAuthInfoBytes$1(e, n, o, u, c, d = signing_1$a.SignMode.SIGN_MODE_DIRECT) {
  (0, utils_1$Z.assert)(u === void 0 || typeof u == "string", "feeGranter must be undefined or string"), (0, utils_1$Z.assert)(c === void 0 || typeof c == "string", "feePayer must be undefined or string");
  const m = tx_1$s.AuthInfo.fromPartial({
    signerInfos: makeSignerInfos$1(e, d),
    fee: {
      amount: [...n],
      gasLimit: BigInt(o),
      granter: u,
      payer: c
    }
  });
  return tx_1$s.AuthInfo.encode(m).finish();
}
signing$2.makeAuthInfoBytes = makeAuthInfoBytes$1;
function makeSignDoc$2(e, n, o, u) {
  return {
    bodyBytes: e,
    authInfoBytes: n,
    chainId: o,
    accountNumber: BigInt(u)
  };
}
signing$2.makeSignDoc = makeSignDoc$2;
function makeSignBytes$1({ accountNumber: e, authInfoBytes: n, bodyBytes: o, chainId: u }) {
  const c = tx_1$s.SignDoc.fromPartial({
    accountNumber: e,
    authInfoBytes: n,
    bodyBytes: o,
    chainId: u
  });
  return tx_1$s.SignDoc.encode(c).finish();
}
signing$2.makeSignBytes = makeSignBytes$1;
var wallet$2 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decrypt = e.encrypt = e.supportedAlgorithms = e.executeKdf = e.cosmjsSalt = void 0;
  const n = build$K, o = build$J;
  e.cosmjsSalt = (0, o.toAscii)("The CosmJS salt.");
  async function u(m, v) {
    switch (v.algorithm) {
      case "argon2id": {
        const S = v.params;
        if (!(0, n.isArgon2idOptions)(S))
          throw new Error("Invalid format of argon2id params");
        return n.Argon2id.execute(m, e.cosmjsSalt, S);
      }
      default:
        throw new Error("Unsupported KDF algorithm");
    }
  }
  e.executeKdf = u, e.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
  };
  async function c(m, v, S) {
    switch (S.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const $ = n.Random.getBytes(n.xchacha20NonceLength);
        return new Uint8Array([
          ...$,
          ...await n.Xchacha20poly1305Ietf.encrypt(m, v, $)
        ]);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${S.algorithm}'`);
    }
  }
  e.encrypt = c;
  async function d(m, v, S) {
    switch (S.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const $ = m.slice(0, n.xchacha20NonceLength);
        return n.Xchacha20poly1305Ietf.decrypt(m.slice(n.xchacha20NonceLength), v, $);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${S.algorithm}'`);
    }
  }
  e.decrypt = d;
})(wallet$2);
Object.defineProperty(directsecp256k1hdwallet$1, "__esModule", { value: !0 });
directsecp256k1hdwallet$1.DirectSecp256k1HdWallet = directsecp256k1hdwallet$1.extractKdfConfiguration = void 0;
const amino_1$e = build$P, crypto_1$q = build$K, encoding_1$1f = build$J, utils_1$Y = build$I, signing_1$9 = signing$2, wallet_1$2 = wallet$2, serializationTypeV1$2 = "directsecp256k1hdwallet-v1", basicPasswordHashingOptions$2 = {
  algorithm: "argon2id",
  params: {
    outputLength: 32,
    opsLimit: 24,
    memLimitKib: 12 * 1024
  }
};
function isDerivationJson$2(e) {
  return !(!(0, utils_1$Y.isNonNullObject)(e) || typeof e.hdPath != "string" || typeof e.prefix != "string");
}
function extractKdfConfigurationV1$2(e) {
  return e.kdf;
}
function extractKdfConfiguration$2(e) {
  const n = JSON.parse(e);
  if (!(0, utils_1$Y.isNonNullObject)(n))
    throw new Error("Root document is not an object.");
  switch (n.type) {
    case serializationTypeV1$2:
      return extractKdfConfigurationV1$2(n);
    default:
      throw new Error("Unsupported serialization type");
  }
}
directsecp256k1hdwallet$1.extractKdfConfiguration = extractKdfConfiguration$2;
const defaultOptions$2 = {
  bip39Password: "",
  hdPaths: [(0, amino_1$e.makeCosmoshubPath)(0)],
  prefix: "cosmos"
};
let DirectSecp256k1HdWallet$1 = class Za {
  /**
   * Restores a wallet from the given BIP39 mnemonic.
   *
   * @param mnemonic Any valid English mnemonic.
   * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async fromMnemonic(n, o = {}) {
    const u = new crypto_1$q.EnglishMnemonic(n), c = await crypto_1$q.Bip39.mnemonicToSeed(u, o.bip39Password);
    return new Za(u, {
      ...o,
      seed: c
    });
  }
  /**
   * Generates a new wallet with a BIP39 mnemonic of the given length.
   *
   * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
   * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async generate(n = 12, o = {}) {
    const u = 4 * Math.floor(11 * n / 33), c = crypto_1$q.Random.getBytes(u), d = crypto_1$q.Bip39.encode(c);
    return Za.fromMnemonic(d.toString(), o);
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  static async deserialize(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$Y.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    switch (u.type) {
      case serializationTypeV1$2:
        return Za.deserializeTypeV1(n, o);
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
   * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
   * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
   */
  static async deserializeWithEncryptionKey(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$Y.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    const c = u;
    switch (c.type) {
      case serializationTypeV1$2: {
        const d = await (0, wallet_1$2.decrypt)((0, encoding_1$1f.fromBase64)(c.data), o, c.encryption), m = JSON.parse((0, encoding_1$1f.fromUtf8)(d)), { mnemonic: v, accounts: S } = m;
        if ((0, utils_1$Y.assert)(typeof v == "string"), !Array.isArray(S))
          throw new Error("Property 'accounts' is not an array");
        if (!S.every((O) => isDerivationJson$2(O)))
          throw new Error("Account is not in the correct format.");
        const $ = S[0].prefix;
        if (!S.every(({ prefix: O }) => O === $))
          throw new Error("Accounts do not all have the same prefix");
        const E = S.map(({ hdPath: O }) => (0, crypto_1$q.stringToPath)(O));
        return Za.fromMnemonic(v, {
          hdPaths: E,
          prefix: $
        });
      }
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  static async deserializeTypeV1(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$Y.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    const c = await (0, wallet_1$2.executeKdf)(o, u.kdf);
    return Za.deserializeWithEncryptionKey(n, c);
  }
  constructor(n, o) {
    const u = o.prefix ?? defaultOptions$2.prefix, c = o.hdPaths ?? defaultOptions$2.hdPaths;
    this.secret = n, this.seed = o.seed, this.accounts = c.map((d) => ({
      hdPath: d,
      prefix: u
    }));
  }
  get mnemonic() {
    return this.secret.toString();
  }
  async getAccounts() {
    return (await this.getAccountsWithPrivkeys()).map(({ algo: o, pubkey: u, address: c }) => ({
      algo: o,
      pubkey: u,
      address: c
    }));
  }
  async signDirect(n, o) {
    const c = (await this.getAccountsWithPrivkeys()).find(({ address: T }) => T === n);
    if (c === void 0)
      throw new Error(`Address ${n} not found in wallet`);
    const { privkey: d, pubkey: m } = c, v = (0, signing_1$9.makeSignBytes)(o), S = (0, crypto_1$q.sha256)(v), $ = await crypto_1$q.Secp256k1.createSignature(S, d), E = new Uint8Array([...$.r(32), ...$.s(32)]), O = (0, amino_1$e.encodeSecp256k1Signature)(m, E);
    return {
      signed: o,
      signature: O
    };
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  async serialize(n) {
    const o = basicPasswordHashingOptions$2, u = await (0, wallet_1$2.executeKdf)(n, o);
    return this.serializeWithEncryptionKey(u, o);
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
   * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF options. If this
   * is not the case, the wallet cannot be restored with the original password.
   */
  async serializeWithEncryptionKey(n, o) {
    const u = {
      mnemonic: this.mnemonic,
      accounts: this.accounts.map(({ hdPath: S, prefix: $ }) => ({
        hdPath: (0, crypto_1$q.pathToString)(S),
        prefix: $
      }))
    }, c = (0, encoding_1$1f.toUtf8)(JSON.stringify(u)), d = {
      algorithm: wallet_1$2.supportedAlgorithms.xchacha20poly1305Ietf
    }, m = await (0, wallet_1$2.encrypt)(c, n, d), v = {
      type: serializationTypeV1$2,
      kdf: o,
      encryption: d,
      data: (0, encoding_1$1f.toBase64)(m)
    };
    return JSON.stringify(v);
  }
  async getKeyPair(n) {
    const { privkey: o } = crypto_1$q.Slip10.derivePath(crypto_1$q.Slip10Curve.Secp256k1, this.seed, n), { pubkey: u } = await crypto_1$q.Secp256k1.makeKeypair(o);
    return {
      privkey: o,
      pubkey: crypto_1$q.Secp256k1.compressPubkey(u)
    };
  }
  async getAccountsWithPrivkeys() {
    return Promise.all(this.accounts.map(async ({ hdPath: n, prefix: o }) => {
      const { privkey: u, pubkey: c } = await this.getKeyPair(n), d = (0, encoding_1$1f.toBech32)(o, (0, amino_1$e.rawSecp256k1PubkeyToRawAddress)(c));
      return {
        algo: "secp256k1",
        privkey: u,
        pubkey: c,
        address: d
      };
    }));
  }
};
directsecp256k1hdwallet$1.DirectSecp256k1HdWallet = DirectSecp256k1HdWallet$1;
var directsecp256k1wallet$1 = {};
Object.defineProperty(directsecp256k1wallet$1, "__esModule", { value: !0 });
directsecp256k1wallet$1.DirectSecp256k1Wallet = void 0;
const amino_1$d = build$P, crypto_1$p = build$K, encoding_1$1e = build$J, signing_1$8 = signing$2;
let DirectSecp256k1Wallet$1 = class Fc {
  /**
   * Creates a DirectSecp256k1Wallet from the given private key
   *
   * @param privkey The private key.
   * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
   */
  static async fromKey(n, o = "cosmos") {
    const u = (await crypto_1$p.Secp256k1.makeKeypair(n)).pubkey;
    return new Fc(n, crypto_1$p.Secp256k1.compressPubkey(u), o);
  }
  constructor(n, o, u) {
    this.privkey = n, this.pubkey = o, this.prefix = u;
  }
  get address() {
    return (0, encoding_1$1e.toBech32)(this.prefix, (0, amino_1$d.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
  }
  async getAccounts() {
    return [
      {
        algo: "secp256k1",
        address: this.address,
        pubkey: this.pubkey
      }
    ];
  }
  async signDirect(n, o) {
    const u = (0, signing_1$8.makeSignBytes)(o);
    if (n !== this.address)
      throw new Error(`Address ${n} not found in wallet`);
    const c = (0, crypto_1$p.sha256)(u), d = await crypto_1$p.Secp256k1.createSignature(c, this.privkey), m = new Uint8Array([...d.r(32), ...d.s(32)]), v = (0, amino_1$d.encodeSecp256k1Signature)(this.pubkey, m);
    return {
      signed: o,
      signature: v
    };
  }
};
directsecp256k1wallet$1.DirectSecp256k1Wallet = DirectSecp256k1Wallet$1;
var paths$2 = {};
Object.defineProperty(paths$2, "__esModule", { value: !0 });
paths$2.makeCosmoshubPath = void 0;
const crypto_1$o = build$K;
function makeCosmoshubPath$2(e) {
  return [
    crypto_1$o.Slip10RawIndex.hardened(44),
    crypto_1$o.Slip10RawIndex.hardened(118),
    crypto_1$o.Slip10RawIndex.hardened(0),
    crypto_1$o.Slip10RawIndex.normal(0),
    crypto_1$o.Slip10RawIndex.normal(e)
  ];
}
paths$2.makeCosmoshubPath = makeCosmoshubPath$2;
var pubkey$1 = {}, keys$7 = {};
Object.defineProperty(keys$7, "__esModule", { value: !0 });
keys$7.PrivKey = keys$7.PubKey = keys$7.protobufPackage = void 0;
const binary_1$d = binary, helpers_1$d = helpers;
keys$7.protobufPackage = "cosmos.crypto.ed25519";
function createBasePubKey$4() {
  return {
    key: new Uint8Array()
  };
}
keys$7.PubKey = {
  typeUrl: "/cosmos.crypto.ed25519.PubKey",
  encode(e, n = binary_1$d.BinaryWriter.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$d.BinaryReader ? e : new binary_1$d.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePubKey$4();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBasePubKey$4();
    return (0, helpers_1$d.isSet)(e.key) && (n.key = (0, helpers_1$d.bytesFromBase64)(e.key)), n;
  },
  toJSON(e) {
    const n = {};
    return e.key !== void 0 && (n.key = (0, helpers_1$d.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBasePubKey$4();
    return n.key = e.key ?? new Uint8Array(), n;
  }
};
function createBasePrivKey$4() {
  return {
    key: new Uint8Array()
  };
}
keys$7.PrivKey = {
  typeUrl: "/cosmos.crypto.ed25519.PrivKey",
  encode(e, n = binary_1$d.BinaryWriter.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$d.BinaryReader ? e : new binary_1$d.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePrivKey$4();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBasePrivKey$4();
    return (0, helpers_1$d.isSet)(e.key) && (n.key = (0, helpers_1$d.bytesFromBase64)(e.key)), n;
  },
  toJSON(e) {
    const n = {};
    return e.key !== void 0 && (n.key = (0, helpers_1$d.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBasePrivKey$4();
    return n.key = e.key ?? new Uint8Array(), n;
  }
};
var keys$6 = {};
Object.defineProperty(keys$6, "__esModule", { value: !0 });
keys$6.LegacyAminoPubKey = keys$6.protobufPackage = void 0;
const any_1$7 = any$1, binary_1$c = binary, helpers_1$c = helpers;
keys$6.protobufPackage = "cosmos.crypto.multisig";
function createBaseLegacyAminoPubKey$1() {
  return {
    threshold: 0,
    publicKeys: []
  };
}
keys$6.LegacyAminoPubKey = {
  typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
  encode(e, n = binary_1$c.BinaryWriter.create()) {
    e.threshold !== 0 && n.uint32(8).uint32(e.threshold);
    for (const o of e.publicKeys)
      any_1$7.Any.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$c.BinaryReader ? e : new binary_1$c.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLegacyAminoPubKey$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.threshold = o.uint32();
          break;
        case 2:
          c.publicKeys.push(any_1$7.Any.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseLegacyAminoPubKey$1();
    return (0, helpers_1$c.isSet)(e.threshold) && (n.threshold = Number(e.threshold)), Array.isArray(e == null ? void 0 : e.publicKeys) && (n.publicKeys = e.publicKeys.map((o) => any_1$7.Any.fromJSON(o))), n;
  },
  toJSON(e) {
    const n = {};
    return e.threshold !== void 0 && (n.threshold = Math.round(e.threshold)), e.publicKeys ? n.publicKeys = e.publicKeys.map((o) => o ? any_1$7.Any.toJSON(o) : void 0) : n.publicKeys = [], n;
  },
  fromPartial(e) {
    var o;
    const n = createBaseLegacyAminoPubKey$1();
    return n.threshold = e.threshold ?? 0, n.publicKeys = ((o = e.publicKeys) == null ? void 0 : o.map((u) => any_1$7.Any.fromPartial(u))) || [], n;
  }
};
var keys$5 = {};
Object.defineProperty(keys$5, "__esModule", { value: !0 });
keys$5.PrivKey = PubKey$3 = keys$5.PubKey = keys$5.protobufPackage = void 0;
const binary_1$b = binary, helpers_1$b = helpers;
keys$5.protobufPackage = "cosmos.crypto.secp256k1";
function createBasePubKey$3() {
  return {
    key: new Uint8Array()
  };
}
var PubKey$3 = keys$5.PubKey = {
  typeUrl: "/cosmos.crypto.secp256k1.PubKey",
  encode(e, n = binary_1$b.BinaryWriter.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$b.BinaryReader ? e : new binary_1$b.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePubKey$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBasePubKey$3();
    return (0, helpers_1$b.isSet)(e.key) && (n.key = (0, helpers_1$b.bytesFromBase64)(e.key)), n;
  },
  toJSON(e) {
    const n = {};
    return e.key !== void 0 && (n.key = (0, helpers_1$b.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBasePubKey$3();
    return n.key = e.key ?? new Uint8Array(), n;
  }
};
function createBasePrivKey$3() {
  return {
    key: new Uint8Array()
  };
}
keys$5.PrivKey = {
  typeUrl: "/cosmos.crypto.secp256k1.PrivKey",
  encode(e, n = binary_1$b.BinaryWriter.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$b.BinaryReader ? e : new binary_1$b.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePrivKey$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBasePrivKey$3();
    return (0, helpers_1$b.isSet)(e.key) && (n.key = (0, helpers_1$b.bytesFromBase64)(e.key)), n;
  },
  toJSON(e) {
    const n = {};
    return e.key !== void 0 && (n.key = (0, helpers_1$b.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBasePrivKey$3();
    return n.key = e.key ?? new Uint8Array(), n;
  }
};
Object.defineProperty(pubkey$1, "__esModule", { value: !0 });
pubkey$1.decodeOptionalPubkey = pubkey$1.decodePubkey = pubkey$1.anyToSinglePubkey = pubkey$1.encodePubkey = void 0;
const amino_1$c = build$P, encoding_1$1d = build$J, math_1$u = build$H, keys_1$1 = keys$7, keys_2$1 = keys$6, keys_3$1 = keys$5, any_1$6 = any$1;
function encodePubkey$1(e) {
  if ((0, amino_1$c.isSecp256k1Pubkey)(e)) {
    const n = keys_3$1.PubKey.fromPartial({
      key: (0, encoding_1$1d.fromBase64)(e.value)
    });
    return any_1$6.Any.fromPartial({
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: Uint8Array.from(keys_3$1.PubKey.encode(n).finish())
    });
  } else if ((0, amino_1$c.isEd25519Pubkey)(e)) {
    const n = keys_1$1.PubKey.fromPartial({
      key: (0, encoding_1$1d.fromBase64)(e.value)
    });
    return any_1$6.Any.fromPartial({
      typeUrl: "/cosmos.crypto.ed25519.PubKey",
      value: Uint8Array.from(keys_1$1.PubKey.encode(n).finish())
    });
  } else if ((0, amino_1$c.isMultisigThresholdPubkey)(e)) {
    const n = keys_2$1.LegacyAminoPubKey.fromPartial({
      threshold: math_1$u.Uint53.fromString(e.value.threshold).toNumber(),
      publicKeys: e.value.pubkeys.map(encodePubkey$1)
    });
    return any_1$6.Any.fromPartial({
      typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
      value: Uint8Array.from(keys_2$1.LegacyAminoPubKey.encode(n).finish())
    });
  } else
    throw new Error(`Pubkey type ${e.type} not recognized`);
}
pubkey$1.encodePubkey = encodePubkey$1;
function anyToSinglePubkey$1(e) {
  switch (e.typeUrl) {
    case "/cosmos.crypto.secp256k1.PubKey": {
      const { key: n } = keys_3$1.PubKey.decode(e.value);
      return (0, amino_1$c.encodeSecp256k1Pubkey)(n);
    }
    case "/cosmos.crypto.ed25519.PubKey": {
      const { key: n } = keys_1$1.PubKey.decode(e.value);
      return (0, amino_1$c.encodeEd25519Pubkey)(n);
    }
    default:
      throw new Error(`Pubkey type_url ${e.typeUrl} not recognized as single public key type`);
  }
}
pubkey$1.anyToSinglePubkey = anyToSinglePubkey$1;
function decodePubkey$b(e) {
  switch (e.typeUrl) {
    case "/cosmos.crypto.secp256k1.PubKey":
    case "/cosmos.crypto.ed25519.PubKey":
      return anyToSinglePubkey$1(e);
    case "/cosmos.crypto.multisig.LegacyAminoPubKey": {
      const { threshold: n, publicKeys: o } = keys_2$1.LegacyAminoPubKey.decode(e.value);
      return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
          threshold: n.toString(),
          pubkeys: o.map(anyToSinglePubkey$1)
        }
      };
    }
    default:
      throw new Error(`Pubkey type URL '${e.typeUrl}' not recognized`);
  }
}
pubkey$1.decodePubkey = decodePubkey$b;
function decodeOptionalPubkey(e) {
  if (!e)
    return null;
  if (e.typeUrl) {
    if (e.value.length)
      return decodePubkey$b(e);
    throw new Error(`Pubkey is an Any with type URL '${e.typeUrl}' but an empty value`);
  } else {
    if (e.value.length)
      throw new Error("Pubkey is an Any with an empty type URL but a value set");
    return null;
  }
}
pubkey$1.decodeOptionalPubkey = decodeOptionalPubkey;
var registry$r = {}, tx$o = {}, bank$2 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Metadata = e.DenomUnit = e.Supply = e.Output = e.Input = e.SendEnabled = e.Params = e.protobufPackage = void 0;
  const n = coin$8, o = binary, u = helpers;
  e.protobufPackage = "cosmos.bank.v1beta1";
  function c() {
    return {
      sendEnabled: [],
      defaultSendEnabled: !1
    };
  }
  e.Params = {
    typeUrl: "/cosmos.bank.v1beta1.Params",
    encode(O, T = o.BinaryWriter.create()) {
      for (const y of O.sendEnabled)
        e.SendEnabled.encode(y, T.uint32(10).fork()).ldelim();
      return O.defaultSendEnabled === !0 && T.uint32(16).bool(O.defaultSendEnabled), T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = c();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.sendEnabled.push(e.SendEnabled.decode(y, y.uint32()));
            break;
          case 2:
            M.defaultSendEnabled = y.bool();
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = c();
      return Array.isArray(O == null ? void 0 : O.sendEnabled) && (T.sendEnabled = O.sendEnabled.map((y) => e.SendEnabled.fromJSON(y))), (0, u.isSet)(O.defaultSendEnabled) && (T.defaultSendEnabled = !!O.defaultSendEnabled), T;
    },
    toJSON(O) {
      const T = {};
      return O.sendEnabled ? T.sendEnabled = O.sendEnabled.map((y) => y ? e.SendEnabled.toJSON(y) : void 0) : T.sendEnabled = [], O.defaultSendEnabled !== void 0 && (T.defaultSendEnabled = O.defaultSendEnabled), T;
    },
    fromPartial(O) {
      var y;
      const T = c();
      return T.sendEnabled = ((y = O.sendEnabled) == null ? void 0 : y.map((V) => e.SendEnabled.fromPartial(V))) || [], T.defaultSendEnabled = O.defaultSendEnabled ?? !1, T;
    }
  };
  function d() {
    return {
      denom: "",
      enabled: !1
    };
  }
  e.SendEnabled = {
    typeUrl: "/cosmos.bank.v1beta1.SendEnabled",
    encode(O, T = o.BinaryWriter.create()) {
      return O.denom !== "" && T.uint32(10).string(O.denom), O.enabled === !0 && T.uint32(16).bool(O.enabled), T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = d();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.denom = y.string();
            break;
          case 2:
            M.enabled = y.bool();
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = d();
      return (0, u.isSet)(O.denom) && (T.denom = String(O.denom)), (0, u.isSet)(O.enabled) && (T.enabled = !!O.enabled), T;
    },
    toJSON(O) {
      const T = {};
      return O.denom !== void 0 && (T.denom = O.denom), O.enabled !== void 0 && (T.enabled = O.enabled), T;
    },
    fromPartial(O) {
      const T = d();
      return T.denom = O.denom ?? "", T.enabled = O.enabled ?? !1, T;
    }
  };
  function m() {
    return {
      address: "",
      coins: []
    };
  }
  e.Input = {
    typeUrl: "/cosmos.bank.v1beta1.Input",
    encode(O, T = o.BinaryWriter.create()) {
      O.address !== "" && T.uint32(10).string(O.address);
      for (const y of O.coins)
        n.Coin.encode(y, T.uint32(18).fork()).ldelim();
      return T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = m();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.address = y.string();
            break;
          case 2:
            M.coins.push(n.Coin.decode(y, y.uint32()));
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = m();
      return (0, u.isSet)(O.address) && (T.address = String(O.address)), Array.isArray(O == null ? void 0 : O.coins) && (T.coins = O.coins.map((y) => n.Coin.fromJSON(y))), T;
    },
    toJSON(O) {
      const T = {};
      return O.address !== void 0 && (T.address = O.address), O.coins ? T.coins = O.coins.map((y) => y ? n.Coin.toJSON(y) : void 0) : T.coins = [], T;
    },
    fromPartial(O) {
      var y;
      const T = m();
      return T.address = O.address ?? "", T.coins = ((y = O.coins) == null ? void 0 : y.map((V) => n.Coin.fromPartial(V))) || [], T;
    }
  };
  function v() {
    return {
      address: "",
      coins: []
    };
  }
  e.Output = {
    typeUrl: "/cosmos.bank.v1beta1.Output",
    encode(O, T = o.BinaryWriter.create()) {
      O.address !== "" && T.uint32(10).string(O.address);
      for (const y of O.coins)
        n.Coin.encode(y, T.uint32(18).fork()).ldelim();
      return T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = v();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.address = y.string();
            break;
          case 2:
            M.coins.push(n.Coin.decode(y, y.uint32()));
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = v();
      return (0, u.isSet)(O.address) && (T.address = String(O.address)), Array.isArray(O == null ? void 0 : O.coins) && (T.coins = O.coins.map((y) => n.Coin.fromJSON(y))), T;
    },
    toJSON(O) {
      const T = {};
      return O.address !== void 0 && (T.address = O.address), O.coins ? T.coins = O.coins.map((y) => y ? n.Coin.toJSON(y) : void 0) : T.coins = [], T;
    },
    fromPartial(O) {
      var y;
      const T = v();
      return T.address = O.address ?? "", T.coins = ((y = O.coins) == null ? void 0 : y.map((V) => n.Coin.fromPartial(V))) || [], T;
    }
  };
  function S() {
    return {
      total: []
    };
  }
  e.Supply = {
    typeUrl: "/cosmos.bank.v1beta1.Supply",
    encode(O, T = o.BinaryWriter.create()) {
      for (const y of O.total)
        n.Coin.encode(y, T.uint32(10).fork()).ldelim();
      return T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = S();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.total.push(n.Coin.decode(y, y.uint32()));
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = S();
      return Array.isArray(O == null ? void 0 : O.total) && (T.total = O.total.map((y) => n.Coin.fromJSON(y))), T;
    },
    toJSON(O) {
      const T = {};
      return O.total ? T.total = O.total.map((y) => y ? n.Coin.toJSON(y) : void 0) : T.total = [], T;
    },
    fromPartial(O) {
      var y;
      const T = S();
      return T.total = ((y = O.total) == null ? void 0 : y.map((V) => n.Coin.fromPartial(V))) || [], T;
    }
  };
  function $() {
    return {
      denom: "",
      exponent: 0,
      aliases: []
    };
  }
  e.DenomUnit = {
    typeUrl: "/cosmos.bank.v1beta1.DenomUnit",
    encode(O, T = o.BinaryWriter.create()) {
      O.denom !== "" && T.uint32(10).string(O.denom), O.exponent !== 0 && T.uint32(16).uint32(O.exponent);
      for (const y of O.aliases)
        T.uint32(26).string(y);
      return T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = $();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.denom = y.string();
            break;
          case 2:
            M.exponent = y.uint32();
            break;
          case 3:
            M.aliases.push(y.string());
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = $();
      return (0, u.isSet)(O.denom) && (T.denom = String(O.denom)), (0, u.isSet)(O.exponent) && (T.exponent = Number(O.exponent)), Array.isArray(O == null ? void 0 : O.aliases) && (T.aliases = O.aliases.map((y) => String(y))), T;
    },
    toJSON(O) {
      const T = {};
      return O.denom !== void 0 && (T.denom = O.denom), O.exponent !== void 0 && (T.exponent = Math.round(O.exponent)), O.aliases ? T.aliases = O.aliases.map((y) => y) : T.aliases = [], T;
    },
    fromPartial(O) {
      var y;
      const T = $();
      return T.denom = O.denom ?? "", T.exponent = O.exponent ?? 0, T.aliases = ((y = O.aliases) == null ? void 0 : y.map((V) => V)) || [], T;
    }
  };
  function E() {
    return {
      description: "",
      denomUnits: [],
      base: "",
      display: "",
      name: "",
      symbol: "",
      uri: "",
      uriHash: ""
    };
  }
  e.Metadata = {
    typeUrl: "/cosmos.bank.v1beta1.Metadata",
    encode(O, T = o.BinaryWriter.create()) {
      O.description !== "" && T.uint32(10).string(O.description);
      for (const y of O.denomUnits)
        e.DenomUnit.encode(y, T.uint32(18).fork()).ldelim();
      return O.base !== "" && T.uint32(26).string(O.base), O.display !== "" && T.uint32(34).string(O.display), O.name !== "" && T.uint32(42).string(O.name), O.symbol !== "" && T.uint32(50).string(O.symbol), O.uri !== "" && T.uint32(58).string(O.uri), O.uriHash !== "" && T.uint32(66).string(O.uriHash), T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = E();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.description = y.string();
            break;
          case 2:
            M.denomUnits.push(e.DenomUnit.decode(y, y.uint32()));
            break;
          case 3:
            M.base = y.string();
            break;
          case 4:
            M.display = y.string();
            break;
          case 5:
            M.name = y.string();
            break;
          case 6:
            M.symbol = y.string();
            break;
          case 7:
            M.uri = y.string();
            break;
          case 8:
            M.uriHash = y.string();
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = E();
      return (0, u.isSet)(O.description) && (T.description = String(O.description)), Array.isArray(O == null ? void 0 : O.denomUnits) && (T.denomUnits = O.denomUnits.map((y) => e.DenomUnit.fromJSON(y))), (0, u.isSet)(O.base) && (T.base = String(O.base)), (0, u.isSet)(O.display) && (T.display = String(O.display)), (0, u.isSet)(O.name) && (T.name = String(O.name)), (0, u.isSet)(O.symbol) && (T.symbol = String(O.symbol)), (0, u.isSet)(O.uri) && (T.uri = String(O.uri)), (0, u.isSet)(O.uriHash) && (T.uriHash = String(O.uriHash)), T;
    },
    toJSON(O) {
      const T = {};
      return O.description !== void 0 && (T.description = O.description), O.denomUnits ? T.denomUnits = O.denomUnits.map((y) => y ? e.DenomUnit.toJSON(y) : void 0) : T.denomUnits = [], O.base !== void 0 && (T.base = O.base), O.display !== void 0 && (T.display = O.display), O.name !== void 0 && (T.name = O.name), O.symbol !== void 0 && (T.symbol = O.symbol), O.uri !== void 0 && (T.uri = O.uri), O.uriHash !== void 0 && (T.uriHash = O.uriHash), T;
    },
    fromPartial(O) {
      var y;
      const T = E();
      return T.description = O.description ?? "", T.denomUnits = ((y = O.denomUnits) == null ? void 0 : y.map((V) => e.DenomUnit.fromPartial(V))) || [], T.base = O.base ?? "", T.display = O.display ?? "", T.name = O.name ?? "", T.symbol = O.symbol ?? "", T.uri = O.uri ?? "", T.uriHash = O.uriHash ?? "", T;
    }
  };
})(bank$2);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgSetSendEnabledResponse = e.MsgSetSendEnabled = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgMultiSendResponse = e.MsgMultiSend = e.MsgSendResponse = e.MsgSend = e.protobufPackage = void 0;
  const n = coin$8, o = bank$2, u = binary, c = helpers;
  e.protobufPackage = "cosmos.bank.v1beta1";
  function d() {
    return {
      fromAddress: "",
      toAddress: "",
      amount: []
    };
  }
  e.MsgSend = {
    typeUrl: "/cosmos.bank.v1beta1.MsgSend",
    encode(V, M = u.BinaryWriter.create()) {
      V.fromAddress !== "" && M.uint32(10).string(V.fromAddress), V.toAddress !== "" && M.uint32(18).string(V.toAddress);
      for (const G of V.amount)
        n.Coin.encode(G, M.uint32(26).fork()).ldelim();
      return M;
    },
    decode(V, M) {
      const G = V instanceof u.BinaryReader ? V : new u.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = d();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.fromAddress = G.string();
            break;
          case 2:
            F.toAddress = G.string();
            break;
          case 3:
            F.amount.push(n.Coin.decode(G, G.uint32()));
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = d();
      return (0, c.isSet)(V.fromAddress) && (M.fromAddress = String(V.fromAddress)), (0, c.isSet)(V.toAddress) && (M.toAddress = String(V.toAddress)), Array.isArray(V == null ? void 0 : V.amount) && (M.amount = V.amount.map((G) => n.Coin.fromJSON(G))), M;
    },
    toJSON(V) {
      const M = {};
      return V.fromAddress !== void 0 && (M.fromAddress = V.fromAddress), V.toAddress !== void 0 && (M.toAddress = V.toAddress), V.amount ? M.amount = V.amount.map((G) => G ? n.Coin.toJSON(G) : void 0) : M.amount = [], M;
    },
    fromPartial(V) {
      var G;
      const M = d();
      return M.fromAddress = V.fromAddress ?? "", M.toAddress = V.toAddress ?? "", M.amount = ((G = V.amount) == null ? void 0 : G.map((k) => n.Coin.fromPartial(k))) || [], M;
    }
  };
  function m() {
    return {};
  }
  e.MsgSendResponse = {
    typeUrl: "/cosmos.bank.v1beta1.MsgSendResponse",
    encode(V, M = u.BinaryWriter.create()) {
      return M;
    },
    decode(V, M) {
      const G = V instanceof u.BinaryReader ? V : new u.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = m();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      return m();
    },
    toJSON(V) {
      return {};
    },
    fromPartial(V) {
      return m();
    }
  };
  function v() {
    return {
      inputs: [],
      outputs: []
    };
  }
  e.MsgMultiSend = {
    typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
    encode(V, M = u.BinaryWriter.create()) {
      for (const G of V.inputs)
        o.Input.encode(G, M.uint32(10).fork()).ldelim();
      for (const G of V.outputs)
        o.Output.encode(G, M.uint32(18).fork()).ldelim();
      return M;
    },
    decode(V, M) {
      const G = V instanceof u.BinaryReader ? V : new u.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = v();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.inputs.push(o.Input.decode(G, G.uint32()));
            break;
          case 2:
            F.outputs.push(o.Output.decode(G, G.uint32()));
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = v();
      return Array.isArray(V == null ? void 0 : V.inputs) && (M.inputs = V.inputs.map((G) => o.Input.fromJSON(G))), Array.isArray(V == null ? void 0 : V.outputs) && (M.outputs = V.outputs.map((G) => o.Output.fromJSON(G))), M;
    },
    toJSON(V) {
      const M = {};
      return V.inputs ? M.inputs = V.inputs.map((G) => G ? o.Input.toJSON(G) : void 0) : M.inputs = [], V.outputs ? M.outputs = V.outputs.map((G) => G ? o.Output.toJSON(G) : void 0) : M.outputs = [], M;
    },
    fromPartial(V) {
      var G, k;
      const M = v();
      return M.inputs = ((G = V.inputs) == null ? void 0 : G.map((F) => o.Input.fromPartial(F))) || [], M.outputs = ((k = V.outputs) == null ? void 0 : k.map((F) => o.Output.fromPartial(F))) || [], M;
    }
  };
  function S() {
    return {};
  }
  e.MsgMultiSendResponse = {
    typeUrl: "/cosmos.bank.v1beta1.MsgMultiSendResponse",
    encode(V, M = u.BinaryWriter.create()) {
      return M;
    },
    decode(V, M) {
      const G = V instanceof u.BinaryReader ? V : new u.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = S();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      return S();
    },
    toJSON(V) {
      return {};
    },
    fromPartial(V) {
      return S();
    }
  };
  function $() {
    return {
      authority: "",
      params: o.Params.fromPartial({})
    };
  }
  e.MsgUpdateParams = {
    typeUrl: "/cosmos.bank.v1beta1.MsgUpdateParams",
    encode(V, M = u.BinaryWriter.create()) {
      return V.authority !== "" && M.uint32(10).string(V.authority), V.params !== void 0 && o.Params.encode(V.params, M.uint32(18).fork()).ldelim(), M;
    },
    decode(V, M) {
      const G = V instanceof u.BinaryReader ? V : new u.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = $();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.authority = G.string();
            break;
          case 2:
            F.params = o.Params.decode(G, G.uint32());
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = $();
      return (0, c.isSet)(V.authority) && (M.authority = String(V.authority)), (0, c.isSet)(V.params) && (M.params = o.Params.fromJSON(V.params)), M;
    },
    toJSON(V) {
      const M = {};
      return V.authority !== void 0 && (M.authority = V.authority), V.params !== void 0 && (M.params = V.params ? o.Params.toJSON(V.params) : void 0), M;
    },
    fromPartial(V) {
      const M = $();
      return M.authority = V.authority ?? "", V.params !== void 0 && V.params !== null && (M.params = o.Params.fromPartial(V.params)), M;
    }
  };
  function E() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    typeUrl: "/cosmos.bank.v1beta1.MsgUpdateParamsResponse",
    encode(V, M = u.BinaryWriter.create()) {
      return M;
    },
    decode(V, M) {
      const G = V instanceof u.BinaryReader ? V : new u.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = E();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      return E();
    },
    toJSON(V) {
      return {};
    },
    fromPartial(V) {
      return E();
    }
  };
  function O() {
    return {
      authority: "",
      sendEnabled: [],
      useDefaultFor: []
    };
  }
  e.MsgSetSendEnabled = {
    typeUrl: "/cosmos.bank.v1beta1.MsgSetSendEnabled",
    encode(V, M = u.BinaryWriter.create()) {
      V.authority !== "" && M.uint32(10).string(V.authority);
      for (const G of V.sendEnabled)
        o.SendEnabled.encode(G, M.uint32(18).fork()).ldelim();
      for (const G of V.useDefaultFor)
        M.uint32(26).string(G);
      return M;
    },
    decode(V, M) {
      const G = V instanceof u.BinaryReader ? V : new u.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = O();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.authority = G.string();
            break;
          case 2:
            F.sendEnabled.push(o.SendEnabled.decode(G, G.uint32()));
            break;
          case 3:
            F.useDefaultFor.push(G.string());
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = O();
      return (0, c.isSet)(V.authority) && (M.authority = String(V.authority)), Array.isArray(V == null ? void 0 : V.sendEnabled) && (M.sendEnabled = V.sendEnabled.map((G) => o.SendEnabled.fromJSON(G))), Array.isArray(V == null ? void 0 : V.useDefaultFor) && (M.useDefaultFor = V.useDefaultFor.map((G) => String(G))), M;
    },
    toJSON(V) {
      const M = {};
      return V.authority !== void 0 && (M.authority = V.authority), V.sendEnabled ? M.sendEnabled = V.sendEnabled.map((G) => G ? o.SendEnabled.toJSON(G) : void 0) : M.sendEnabled = [], V.useDefaultFor ? M.useDefaultFor = V.useDefaultFor.map((G) => G) : M.useDefaultFor = [], M;
    },
    fromPartial(V) {
      var G, k;
      const M = O();
      return M.authority = V.authority ?? "", M.sendEnabled = ((G = V.sendEnabled) == null ? void 0 : G.map((F) => o.SendEnabled.fromPartial(F))) || [], M.useDefaultFor = ((k = V.useDefaultFor) == null ? void 0 : k.map((F) => F)) || [], M;
    }
  };
  function T() {
    return {};
  }
  e.MsgSetSendEnabledResponse = {
    typeUrl: "/cosmos.bank.v1beta1.MsgSetSendEnabledResponse",
    encode(V, M = u.BinaryWriter.create()) {
      return M;
    },
    decode(V, M) {
      const G = V instanceof u.BinaryReader ? V : new u.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = T();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      return T();
    },
    toJSON(V) {
      return {};
    },
    fromPartial(V) {
      return T();
    }
  };
  class y {
    constructor(M) {
      this.rpc = M, this.Send = this.Send.bind(this), this.MultiSend = this.MultiSend.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    Send(M) {
      const G = e.MsgSend.encode(M).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", G).then((F) => e.MsgSendResponse.decode(new u.BinaryReader(F)));
    }
    MultiSend(M) {
      const G = e.MsgMultiSend.encode(M).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", G).then((F) => e.MsgMultiSendResponse.decode(new u.BinaryReader(F)));
    }
    UpdateParams(M) {
      const G = e.MsgUpdateParams.encode(M).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", G).then((F) => e.MsgUpdateParamsResponse.decode(new u.BinaryReader(F)));
    }
    SetSendEnabled(M) {
      const G = e.MsgSetSendEnabled.encode(M).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", G).then((F) => e.MsgSetSendEnabledResponse.decode(new u.BinaryReader(F)));
    }
  }
  e.MsgClientImpl = y;
})(tx$o);
Object.defineProperty(registry$r, "__esModule", { value: !0 });
registry$r.Registry = registry$r.isTxBodyEncodeObject = registry$r.isPbjsGeneratedType = registry$r.isTsProtoGeneratedType = registry$r.isTelescopeGeneratedType = void 0;
const tx_1$r = tx$o, coin_1$1 = coin$8, tx_2$7 = tx$p, any_1$5 = any$1;
function isTelescopeGeneratedType(e) {
  const n = e;
  return typeof n.fromPartial == "function" && typeof n.typeUrl == "string";
}
registry$r.isTelescopeGeneratedType = isTelescopeGeneratedType;
function isTsProtoGeneratedType$1(e) {
  return typeof e.fromPartial == "function";
}
registry$r.isTsProtoGeneratedType = isTsProtoGeneratedType$1;
function isPbjsGeneratedType$1(e) {
  return !isTsProtoGeneratedType$1(e);
}
registry$r.isPbjsGeneratedType = isPbjsGeneratedType$1;
const defaultTypeUrls$1 = {
  cosmosCoin: "/cosmos.base.v1beta1.Coin",
  cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
  cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
  googleAny: "/google.protobuf.Any"
};
function isTxBodyEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
registry$r.isTxBodyEncodeObject = isTxBodyEncodeObject$1;
let Registry$1 = class {
  /**
   * Creates a new Registry for mapping protobuf type identifiers/type URLs to
   * actual implementations. Those implementations are typically generated with ts-proto
   * but we also support protobuf.js as a type generator.
   *
   * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
   * for historic reasons. Those can be overriden by customTypes.
   *
   * There are currently two methods for adding new types:
   * 1. Passing types to the constructor.
   * 2. Using the `register()` method
   */
  constructor(n) {
    const { cosmosCoin: o, cosmosMsgSend: u } = defaultTypeUrls$1;
    this.types = n ? new Map([...n]) : /* @__PURE__ */ new Map([
      [o, coin_1$1.Coin],
      [u, tx_1$r.MsgSend]
    ]);
  }
  register(n, o) {
    this.types.set(n, o);
  }
  /**
   * Looks up a type that was previously added to the registry.
   *
   * The generator information (ts-proto or pbjs) gets lost along the way.
   * If you need to work with the result type in TypeScript, you can use:
   *
   * ```
   * import { assert } from "@cosmjs/utils";
   *
   * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
   * assert(Coin); // Ensures not unset
   * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
   *
   * // Coin is typed TsProtoGeneratedType now.
   * ```
   */
  lookupType(n) {
    return this.types.get(n);
  }
  lookupTypeWithError(n) {
    const o = this.lookupType(n);
    if (!o)
      throw new Error(`Unregistered type url: ${n}`);
    return o;
  }
  /**
   * Takes a typeUrl/value pair and encodes the value to protobuf if
   * the given type was previously registered.
   *
   * If the value has to be wrapped in an Any, this needs to be done
   * manually after this call. Or use `encodeAsAny` instead.
   */
  encode(n) {
    const { value: o, typeUrl: u } = n;
    if (isTxBodyEncodeObject$1(n))
      return this.encodeTxBody(o);
    const c = this.lookupTypeWithError(u), d = isTelescopeGeneratedType(c) || isTsProtoGeneratedType$1(c) ? c.fromPartial(o) : c.create(o);
    return c.encode(d).finish();
  }
  /**
   * Takes a typeUrl/value pair and encodes the value to an Any if
   * the given type was previously registered.
   */
  encodeAsAny(n) {
    const o = this.encode(n);
    return any_1$5.Any.fromPartial({
      typeUrl: n.typeUrl,
      value: o
    });
  }
  encodeTxBody(n) {
    var c;
    const o = n.messages.map((d) => this.encodeAsAny(d)), u = tx_2$7.TxBody.fromPartial({
      ...n,
      timeoutHeight: BigInt(((c = n.timeoutHeight) == null ? void 0 : c.toString()) ?? "0"),
      messages: o
    });
    return tx_2$7.TxBody.encode(u).finish();
  }
  decode({ typeUrl: n, value: o }) {
    if (n === defaultTypeUrls$1.cosmosTxBody)
      return this.decodeTxBody(o);
    const c = this.lookupTypeWithError(n).decode(o);
    return Object.entries(c).forEach(([d, m]) => {
      typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(m) && (c[d] = Uint8Array.from(m));
    }), c;
  }
  decodeTxBody(n) {
    const o = tx_2$7.TxBody.decode(n);
    return {
      ...o,
      messages: o.messages.map(({ typeUrl: u, value: c }) => {
        if (!u)
          throw new Error("Missing type_url in Any");
        if (!c)
          throw new Error("Missing value in Any");
        return this.decode({ typeUrl: u, value: c });
      })
    };
  }
};
registry$r.Registry = Registry$1;
var signer$1 = {};
Object.defineProperty(signer$1, "__esModule", { value: !0 });
signer$1.isOfflineDirectSigner = void 0;
function isOfflineDirectSigner$1(e) {
  return e.signDirect !== void 0;
}
signer$1.isOfflineDirectSigner = isOfflineDirectSigner$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.coins = e.coin = e.executeKdf = e.makeSignDoc = e.makeSignBytes = e.makeAuthInfoBytes = e.isOfflineDirectSigner = e.Registry = e.isTxBodyEncodeObject = e.isTsProtoGeneratedType = e.isPbjsGeneratedType = e.encodePubkey = e.decodePubkey = e.decodeOptionalPubkey = e.anyToSinglePubkey = e.makeCosmoshubPath = e.DirectSecp256k1Wallet = e.extractKdfConfiguration = e.DirectSecp256k1HdWallet = e.decodeTxRaw = e.parseCoins = void 0;
  var n = coins$5;
  Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return n.parseCoins;
  } });
  var o = decode$1;
  Object.defineProperty(e, "decodeTxRaw", { enumerable: !0, get: function() {
    return o.decodeTxRaw;
  } });
  var u = directsecp256k1hdwallet$1;
  Object.defineProperty(e, "DirectSecp256k1HdWallet", { enumerable: !0, get: function() {
    return u.DirectSecp256k1HdWallet;
  } }), Object.defineProperty(e, "extractKdfConfiguration", { enumerable: !0, get: function() {
    return u.extractKdfConfiguration;
  } });
  var c = directsecp256k1wallet$1;
  Object.defineProperty(e, "DirectSecp256k1Wallet", { enumerable: !0, get: function() {
    return c.DirectSecp256k1Wallet;
  } });
  var d = paths$2;
  Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return d.makeCosmoshubPath;
  } });
  var m = pubkey$1;
  Object.defineProperty(e, "anyToSinglePubkey", { enumerable: !0, get: function() {
    return m.anyToSinglePubkey;
  } }), Object.defineProperty(e, "decodeOptionalPubkey", { enumerable: !0, get: function() {
    return m.decodeOptionalPubkey;
  } }), Object.defineProperty(e, "decodePubkey", { enumerable: !0, get: function() {
    return m.decodePubkey;
  } }), Object.defineProperty(e, "encodePubkey", { enumerable: !0, get: function() {
    return m.encodePubkey;
  } });
  var v = registry$r;
  Object.defineProperty(e, "isPbjsGeneratedType", { enumerable: !0, get: function() {
    return v.isPbjsGeneratedType;
  } }), Object.defineProperty(e, "isTsProtoGeneratedType", { enumerable: !0, get: function() {
    return v.isTsProtoGeneratedType;
  } }), Object.defineProperty(e, "isTxBodyEncodeObject", { enumerable: !0, get: function() {
    return v.isTxBodyEncodeObject;
  } }), Object.defineProperty(e, "Registry", { enumerable: !0, get: function() {
    return v.Registry;
  } });
  var S = signer$1;
  Object.defineProperty(e, "isOfflineDirectSigner", { enumerable: !0, get: function() {
    return S.isOfflineDirectSigner;
  } });
  var $ = signing$2;
  Object.defineProperty(e, "makeAuthInfoBytes", { enumerable: !0, get: function() {
    return $.makeAuthInfoBytes;
  } }), Object.defineProperty(e, "makeSignBytes", { enumerable: !0, get: function() {
    return $.makeSignBytes;
  } }), Object.defineProperty(e, "makeSignDoc", { enumerable: !0, get: function() {
    return $.makeSignDoc;
  } });
  var E = wallet$2;
  Object.defineProperty(e, "executeKdf", { enumerable: !0, get: function() {
    return E.executeKdf;
  } });
  var O = build$P;
  Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return O.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return O.coins;
  } });
})(build$Q);
var build$G = {}, arrays$4 = {};
Object.defineProperty(arrays$4, "__esModule", { value: !0 });
arrays$4.arrayContentStartsWith = arrays$4.arrayContentEquals = void 0;
function arrayContentEquals$4(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$4.arrayContentEquals = arrayContentEquals$4;
function arrayContentStartsWith$4(e, n) {
  if (e.length < n.length)
    return !1;
  for (let o = 0; o < n.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$4.arrayContentStartsWith = arrayContentStartsWith$4;
var assert$d = {};
Object.defineProperty(assert$d, "__esModule", { value: !0 });
assert$d.assertDefinedAndNotNull = assert$d.assertDefined = assert$d.assert = void 0;
function assert$c(e, n) {
  if (!e)
    throw new Error(n || "condition is not truthy");
}
assert$d.assert = assert$c;
function assertDefined$4(e, n) {
  if (e === void 0)
    throw new Error(n ?? "value is undefined");
}
assert$d.assertDefined = assertDefined$4;
function assertDefinedAndNotNull$4(e, n) {
  if (e == null)
    throw new Error(n ?? "value is undefined or null");
}
assert$d.assertDefinedAndNotNull = assertDefinedAndNotNull$4;
var sleep$9 = {};
Object.defineProperty(sleep$9, "__esModule", { value: !0 });
sleep$9.sleep = void 0;
async function sleep$8(e) {
  return new Promise((n) => setTimeout(n, e));
}
sleep$9.sleep = sleep$8;
var typechecks$4 = {};
Object.defineProperty(typechecks$4, "__esModule", { value: !0 });
typechecks$4.isDefined = typechecks$4.isUint8Array = typechecks$4.isNonNullObject = void 0;
function isNonNullObject$4(e) {
  return typeof e == "object" && e !== null;
}
typechecks$4.isNonNullObject = isNonNullObject$4;
function isUint8Array$4(e) {
  return !(!isNonNullObject$4(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(e));
}
typechecks$4.isUint8Array = isUint8Array$4;
function isDefined$4(e) {
  return e !== void 0;
}
typechecks$4.isDefined = isDefined$4;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var n = arrays$4;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return n.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return n.arrayContentStartsWith;
  } });
  var o = assert$d;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return o.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return o.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return o.assertDefinedAndNotNull;
  } });
  var u = sleep$9;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return u.sleep;
  } });
  var c = typechecks$4;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return c.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return c.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return c.isUint8Array;
  } });
})(build$G);
var auth = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.ModuleCredential = e.ModuleAccount = e.BaseAccount = e.protobufPackage = void 0;
  const n = any$1, o = binary, u = helpers;
  e.protobufPackage = "cosmos.auth.v1beta1";
  function c() {
    return {
      address: "",
      pubKey: void 0,
      accountNumber: BigInt(0),
      sequence: BigInt(0)
    };
  }
  e.BaseAccount = {
    typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
    encode(S, $ = o.BinaryWriter.create()) {
      return S.address !== "" && $.uint32(10).string(S.address), S.pubKey !== void 0 && n.Any.encode(S.pubKey, $.uint32(18).fork()).ldelim(), S.accountNumber !== BigInt(0) && $.uint32(24).uint64(S.accountNumber), S.sequence !== BigInt(0) && $.uint32(32).uint64(S.sequence), $;
    },
    decode(S, $) {
      const E = S instanceof o.BinaryReader ? S : new o.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = c();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.address = E.string();
            break;
          case 2:
            T.pubKey = n.Any.decode(E, E.uint32());
            break;
          case 3:
            T.accountNumber = E.uint64();
            break;
          case 4:
            T.sequence = E.uint64();
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = c();
      return (0, u.isSet)(S.address) && ($.address = String(S.address)), (0, u.isSet)(S.pubKey) && ($.pubKey = n.Any.fromJSON(S.pubKey)), (0, u.isSet)(S.accountNumber) && ($.accountNumber = BigInt(S.accountNumber.toString())), (0, u.isSet)(S.sequence) && ($.sequence = BigInt(S.sequence.toString())), $;
    },
    toJSON(S) {
      const $ = {};
      return S.address !== void 0 && ($.address = S.address), S.pubKey !== void 0 && ($.pubKey = S.pubKey ? n.Any.toJSON(S.pubKey) : void 0), S.accountNumber !== void 0 && ($.accountNumber = (S.accountNumber || BigInt(0)).toString()), S.sequence !== void 0 && ($.sequence = (S.sequence || BigInt(0)).toString()), $;
    },
    fromPartial(S) {
      const $ = c();
      return $.address = S.address ?? "", S.pubKey !== void 0 && S.pubKey !== null && ($.pubKey = n.Any.fromPartial(S.pubKey)), S.accountNumber !== void 0 && S.accountNumber !== null && ($.accountNumber = BigInt(S.accountNumber.toString())), S.sequence !== void 0 && S.sequence !== null && ($.sequence = BigInt(S.sequence.toString())), $;
    }
  };
  function d() {
    return {
      baseAccount: void 0,
      name: "",
      permissions: []
    };
  }
  e.ModuleAccount = {
    typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",
    encode(S, $ = o.BinaryWriter.create()) {
      S.baseAccount !== void 0 && e.BaseAccount.encode(S.baseAccount, $.uint32(10).fork()).ldelim(), S.name !== "" && $.uint32(18).string(S.name);
      for (const E of S.permissions)
        $.uint32(26).string(E);
      return $;
    },
    decode(S, $) {
      const E = S instanceof o.BinaryReader ? S : new o.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = d();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.baseAccount = e.BaseAccount.decode(E, E.uint32());
            break;
          case 2:
            T.name = E.string();
            break;
          case 3:
            T.permissions.push(E.string());
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = d();
      return (0, u.isSet)(S.baseAccount) && ($.baseAccount = e.BaseAccount.fromJSON(S.baseAccount)), (0, u.isSet)(S.name) && ($.name = String(S.name)), Array.isArray(S == null ? void 0 : S.permissions) && ($.permissions = S.permissions.map((E) => String(E))), $;
    },
    toJSON(S) {
      const $ = {};
      return S.baseAccount !== void 0 && ($.baseAccount = S.baseAccount ? e.BaseAccount.toJSON(S.baseAccount) : void 0), S.name !== void 0 && ($.name = S.name), S.permissions ? $.permissions = S.permissions.map((E) => E) : $.permissions = [], $;
    },
    fromPartial(S) {
      var E;
      const $ = d();
      return S.baseAccount !== void 0 && S.baseAccount !== null && ($.baseAccount = e.BaseAccount.fromPartial(S.baseAccount)), $.name = S.name ?? "", $.permissions = ((E = S.permissions) == null ? void 0 : E.map((O) => O)) || [], $;
    }
  };
  function m() {
    return {
      moduleName: "",
      derivationKeys: []
    };
  }
  e.ModuleCredential = {
    typeUrl: "/cosmos.auth.v1beta1.ModuleCredential",
    encode(S, $ = o.BinaryWriter.create()) {
      S.moduleName !== "" && $.uint32(10).string(S.moduleName);
      for (const E of S.derivationKeys)
        $.uint32(18).bytes(E);
      return $;
    },
    decode(S, $) {
      const E = S instanceof o.BinaryReader ? S : new o.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = m();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.moduleName = E.string();
            break;
          case 2:
            T.derivationKeys.push(E.bytes());
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = m();
      return (0, u.isSet)(S.moduleName) && ($.moduleName = String(S.moduleName)), Array.isArray(S == null ? void 0 : S.derivationKeys) && ($.derivationKeys = S.derivationKeys.map((E) => (0, u.bytesFromBase64)(E))), $;
    },
    toJSON(S) {
      const $ = {};
      return S.moduleName !== void 0 && ($.moduleName = S.moduleName), S.derivationKeys ? $.derivationKeys = S.derivationKeys.map((E) => (0, u.base64FromBytes)(E !== void 0 ? E : new Uint8Array())) : $.derivationKeys = [], $;
    },
    fromPartial(S) {
      var E;
      const $ = m();
      return $.moduleName = S.moduleName ?? "", $.derivationKeys = ((E = S.derivationKeys) == null ? void 0 : E.map((O) => O)) || [], $;
    }
  };
  function v() {
    return {
      maxMemoCharacters: BigInt(0),
      txSigLimit: BigInt(0),
      txSizeCostPerByte: BigInt(0),
      sigVerifyCostEd25519: BigInt(0),
      sigVerifyCostSecp256k1: BigInt(0)
    };
  }
  e.Params = {
    typeUrl: "/cosmos.auth.v1beta1.Params",
    encode(S, $ = o.BinaryWriter.create()) {
      return S.maxMemoCharacters !== BigInt(0) && $.uint32(8).uint64(S.maxMemoCharacters), S.txSigLimit !== BigInt(0) && $.uint32(16).uint64(S.txSigLimit), S.txSizeCostPerByte !== BigInt(0) && $.uint32(24).uint64(S.txSizeCostPerByte), S.sigVerifyCostEd25519 !== BigInt(0) && $.uint32(32).uint64(S.sigVerifyCostEd25519), S.sigVerifyCostSecp256k1 !== BigInt(0) && $.uint32(40).uint64(S.sigVerifyCostSecp256k1), $;
    },
    decode(S, $) {
      const E = S instanceof o.BinaryReader ? S : new o.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = v();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.maxMemoCharacters = E.uint64();
            break;
          case 2:
            T.txSigLimit = E.uint64();
            break;
          case 3:
            T.txSizeCostPerByte = E.uint64();
            break;
          case 4:
            T.sigVerifyCostEd25519 = E.uint64();
            break;
          case 5:
            T.sigVerifyCostSecp256k1 = E.uint64();
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = v();
      return (0, u.isSet)(S.maxMemoCharacters) && ($.maxMemoCharacters = BigInt(S.maxMemoCharacters.toString())), (0, u.isSet)(S.txSigLimit) && ($.txSigLimit = BigInt(S.txSigLimit.toString())), (0, u.isSet)(S.txSizeCostPerByte) && ($.txSizeCostPerByte = BigInt(S.txSizeCostPerByte.toString())), (0, u.isSet)(S.sigVerifyCostEd25519) && ($.sigVerifyCostEd25519 = BigInt(S.sigVerifyCostEd25519.toString())), (0, u.isSet)(S.sigVerifyCostSecp256k1) && ($.sigVerifyCostSecp256k1 = BigInt(S.sigVerifyCostSecp256k1.toString())), $;
    },
    toJSON(S) {
      const $ = {};
      return S.maxMemoCharacters !== void 0 && ($.maxMemoCharacters = (S.maxMemoCharacters || BigInt(0)).toString()), S.txSigLimit !== void 0 && ($.txSigLimit = (S.txSigLimit || BigInt(0)).toString()), S.txSizeCostPerByte !== void 0 && ($.txSizeCostPerByte = (S.txSizeCostPerByte || BigInt(0)).toString()), S.sigVerifyCostEd25519 !== void 0 && ($.sigVerifyCostEd25519 = (S.sigVerifyCostEd25519 || BigInt(0)).toString()), S.sigVerifyCostSecp256k1 !== void 0 && ($.sigVerifyCostSecp256k1 = (S.sigVerifyCostSecp256k1 || BigInt(0)).toString()), $;
    },
    fromPartial(S) {
      const $ = v();
      return S.maxMemoCharacters !== void 0 && S.maxMemoCharacters !== null && ($.maxMemoCharacters = BigInt(S.maxMemoCharacters.toString())), S.txSigLimit !== void 0 && S.txSigLimit !== null && ($.txSigLimit = BigInt(S.txSigLimit.toString())), S.txSizeCostPerByte !== void 0 && S.txSizeCostPerByte !== null && ($.txSizeCostPerByte = BigInt(S.txSizeCostPerByte.toString())), S.sigVerifyCostEd25519 !== void 0 && S.sigVerifyCostEd25519 !== null && ($.sigVerifyCostEd25519 = BigInt(S.sigVerifyCostEd25519.toString())), S.sigVerifyCostSecp256k1 !== void 0 && S.sigVerifyCostSecp256k1 !== null && ($.sigVerifyCostSecp256k1 = BigInt(S.sigVerifyCostSecp256k1.toString())), $;
    }
  };
})(auth);
var vesting = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.PermanentLockedAccount = e.PeriodicVestingAccount = e.Period = e.DelayedVestingAccount = e.ContinuousVestingAccount = e.BaseVestingAccount = e.protobufPackage = void 0;
  const n = auth, o = coin$8, u = binary, c = helpers;
  e.protobufPackage = "cosmos.vesting.v1beta1";
  function d() {
    return {
      baseAccount: void 0,
      originalVesting: [],
      delegatedFree: [],
      delegatedVesting: [],
      endTime: BigInt(0)
    };
  }
  e.BaseVestingAccount = {
    typeUrl: "/cosmos.vesting.v1beta1.BaseVestingAccount",
    encode(O, T = u.BinaryWriter.create()) {
      O.baseAccount !== void 0 && n.BaseAccount.encode(O.baseAccount, T.uint32(10).fork()).ldelim();
      for (const y of O.originalVesting)
        o.Coin.encode(y, T.uint32(18).fork()).ldelim();
      for (const y of O.delegatedFree)
        o.Coin.encode(y, T.uint32(26).fork()).ldelim();
      for (const y of O.delegatedVesting)
        o.Coin.encode(y, T.uint32(34).fork()).ldelim();
      return O.endTime !== BigInt(0) && T.uint32(40).int64(O.endTime), T;
    },
    decode(O, T) {
      const y = O instanceof u.BinaryReader ? O : new u.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = d();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.baseAccount = n.BaseAccount.decode(y, y.uint32());
            break;
          case 2:
            M.originalVesting.push(o.Coin.decode(y, y.uint32()));
            break;
          case 3:
            M.delegatedFree.push(o.Coin.decode(y, y.uint32()));
            break;
          case 4:
            M.delegatedVesting.push(o.Coin.decode(y, y.uint32()));
            break;
          case 5:
            M.endTime = y.int64();
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = d();
      return (0, c.isSet)(O.baseAccount) && (T.baseAccount = n.BaseAccount.fromJSON(O.baseAccount)), Array.isArray(O == null ? void 0 : O.originalVesting) && (T.originalVesting = O.originalVesting.map((y) => o.Coin.fromJSON(y))), Array.isArray(O == null ? void 0 : O.delegatedFree) && (T.delegatedFree = O.delegatedFree.map((y) => o.Coin.fromJSON(y))), Array.isArray(O == null ? void 0 : O.delegatedVesting) && (T.delegatedVesting = O.delegatedVesting.map((y) => o.Coin.fromJSON(y))), (0, c.isSet)(O.endTime) && (T.endTime = BigInt(O.endTime.toString())), T;
    },
    toJSON(O) {
      const T = {};
      return O.baseAccount !== void 0 && (T.baseAccount = O.baseAccount ? n.BaseAccount.toJSON(O.baseAccount) : void 0), O.originalVesting ? T.originalVesting = O.originalVesting.map((y) => y ? o.Coin.toJSON(y) : void 0) : T.originalVesting = [], O.delegatedFree ? T.delegatedFree = O.delegatedFree.map((y) => y ? o.Coin.toJSON(y) : void 0) : T.delegatedFree = [], O.delegatedVesting ? T.delegatedVesting = O.delegatedVesting.map((y) => y ? o.Coin.toJSON(y) : void 0) : T.delegatedVesting = [], O.endTime !== void 0 && (T.endTime = (O.endTime || BigInt(0)).toString()), T;
    },
    fromPartial(O) {
      var y, V, M;
      const T = d();
      return O.baseAccount !== void 0 && O.baseAccount !== null && (T.baseAccount = n.BaseAccount.fromPartial(O.baseAccount)), T.originalVesting = ((y = O.originalVesting) == null ? void 0 : y.map((G) => o.Coin.fromPartial(G))) || [], T.delegatedFree = ((V = O.delegatedFree) == null ? void 0 : V.map((G) => o.Coin.fromPartial(G))) || [], T.delegatedVesting = ((M = O.delegatedVesting) == null ? void 0 : M.map((G) => o.Coin.fromPartial(G))) || [], O.endTime !== void 0 && O.endTime !== null && (T.endTime = BigInt(O.endTime.toString())), T;
    }
  };
  function m() {
    return {
      baseVestingAccount: void 0,
      startTime: BigInt(0)
    };
  }
  e.ContinuousVestingAccount = {
    typeUrl: "/cosmos.vesting.v1beta1.ContinuousVestingAccount",
    encode(O, T = u.BinaryWriter.create()) {
      return O.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(O.baseVestingAccount, T.uint32(10).fork()).ldelim(), O.startTime !== BigInt(0) && T.uint32(16).int64(O.startTime), T;
    },
    decode(O, T) {
      const y = O instanceof u.BinaryReader ? O : new u.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = m();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.baseVestingAccount = e.BaseVestingAccount.decode(y, y.uint32());
            break;
          case 2:
            M.startTime = y.int64();
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = m();
      return (0, c.isSet)(O.baseVestingAccount) && (T.baseVestingAccount = e.BaseVestingAccount.fromJSON(O.baseVestingAccount)), (0, c.isSet)(O.startTime) && (T.startTime = BigInt(O.startTime.toString())), T;
    },
    toJSON(O) {
      const T = {};
      return O.baseVestingAccount !== void 0 && (T.baseVestingAccount = O.baseVestingAccount ? e.BaseVestingAccount.toJSON(O.baseVestingAccount) : void 0), O.startTime !== void 0 && (T.startTime = (O.startTime || BigInt(0)).toString()), T;
    },
    fromPartial(O) {
      const T = m();
      return O.baseVestingAccount !== void 0 && O.baseVestingAccount !== null && (T.baseVestingAccount = e.BaseVestingAccount.fromPartial(O.baseVestingAccount)), O.startTime !== void 0 && O.startTime !== null && (T.startTime = BigInt(O.startTime.toString())), T;
    }
  };
  function v() {
    return {
      baseVestingAccount: void 0
    };
  }
  e.DelayedVestingAccount = {
    typeUrl: "/cosmos.vesting.v1beta1.DelayedVestingAccount",
    encode(O, T = u.BinaryWriter.create()) {
      return O.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(O.baseVestingAccount, T.uint32(10).fork()).ldelim(), T;
    },
    decode(O, T) {
      const y = O instanceof u.BinaryReader ? O : new u.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = v();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.baseVestingAccount = e.BaseVestingAccount.decode(y, y.uint32());
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = v();
      return (0, c.isSet)(O.baseVestingAccount) && (T.baseVestingAccount = e.BaseVestingAccount.fromJSON(O.baseVestingAccount)), T;
    },
    toJSON(O) {
      const T = {};
      return O.baseVestingAccount !== void 0 && (T.baseVestingAccount = O.baseVestingAccount ? e.BaseVestingAccount.toJSON(O.baseVestingAccount) : void 0), T;
    },
    fromPartial(O) {
      const T = v();
      return O.baseVestingAccount !== void 0 && O.baseVestingAccount !== null && (T.baseVestingAccount = e.BaseVestingAccount.fromPartial(O.baseVestingAccount)), T;
    }
  };
  function S() {
    return {
      length: BigInt(0),
      amount: []
    };
  }
  e.Period = {
    typeUrl: "/cosmos.vesting.v1beta1.Period",
    encode(O, T = u.BinaryWriter.create()) {
      O.length !== BigInt(0) && T.uint32(8).int64(O.length);
      for (const y of O.amount)
        o.Coin.encode(y, T.uint32(18).fork()).ldelim();
      return T;
    },
    decode(O, T) {
      const y = O instanceof u.BinaryReader ? O : new u.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = S();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.length = y.int64();
            break;
          case 2:
            M.amount.push(o.Coin.decode(y, y.uint32()));
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = S();
      return (0, c.isSet)(O.length) && (T.length = BigInt(O.length.toString())), Array.isArray(O == null ? void 0 : O.amount) && (T.amount = O.amount.map((y) => o.Coin.fromJSON(y))), T;
    },
    toJSON(O) {
      const T = {};
      return O.length !== void 0 && (T.length = (O.length || BigInt(0)).toString()), O.amount ? T.amount = O.amount.map((y) => y ? o.Coin.toJSON(y) : void 0) : T.amount = [], T;
    },
    fromPartial(O) {
      var y;
      const T = S();
      return O.length !== void 0 && O.length !== null && (T.length = BigInt(O.length.toString())), T.amount = ((y = O.amount) == null ? void 0 : y.map((V) => o.Coin.fromPartial(V))) || [], T;
    }
  };
  function $() {
    return {
      baseVestingAccount: void 0,
      startTime: BigInt(0),
      vestingPeriods: []
    };
  }
  e.PeriodicVestingAccount = {
    typeUrl: "/cosmos.vesting.v1beta1.PeriodicVestingAccount",
    encode(O, T = u.BinaryWriter.create()) {
      O.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(O.baseVestingAccount, T.uint32(10).fork()).ldelim(), O.startTime !== BigInt(0) && T.uint32(16).int64(O.startTime);
      for (const y of O.vestingPeriods)
        e.Period.encode(y, T.uint32(26).fork()).ldelim();
      return T;
    },
    decode(O, T) {
      const y = O instanceof u.BinaryReader ? O : new u.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = $();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.baseVestingAccount = e.BaseVestingAccount.decode(y, y.uint32());
            break;
          case 2:
            M.startTime = y.int64();
            break;
          case 3:
            M.vestingPeriods.push(e.Period.decode(y, y.uint32()));
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = $();
      return (0, c.isSet)(O.baseVestingAccount) && (T.baseVestingAccount = e.BaseVestingAccount.fromJSON(O.baseVestingAccount)), (0, c.isSet)(O.startTime) && (T.startTime = BigInt(O.startTime.toString())), Array.isArray(O == null ? void 0 : O.vestingPeriods) && (T.vestingPeriods = O.vestingPeriods.map((y) => e.Period.fromJSON(y))), T;
    },
    toJSON(O) {
      const T = {};
      return O.baseVestingAccount !== void 0 && (T.baseVestingAccount = O.baseVestingAccount ? e.BaseVestingAccount.toJSON(O.baseVestingAccount) : void 0), O.startTime !== void 0 && (T.startTime = (O.startTime || BigInt(0)).toString()), O.vestingPeriods ? T.vestingPeriods = O.vestingPeriods.map((y) => y ? e.Period.toJSON(y) : void 0) : T.vestingPeriods = [], T;
    },
    fromPartial(O) {
      var y;
      const T = $();
      return O.baseVestingAccount !== void 0 && O.baseVestingAccount !== null && (T.baseVestingAccount = e.BaseVestingAccount.fromPartial(O.baseVestingAccount)), O.startTime !== void 0 && O.startTime !== null && (T.startTime = BigInt(O.startTime.toString())), T.vestingPeriods = ((y = O.vestingPeriods) == null ? void 0 : y.map((V) => e.Period.fromPartial(V))) || [], T;
    }
  };
  function E() {
    return {
      baseVestingAccount: void 0
    };
  }
  e.PermanentLockedAccount = {
    typeUrl: "/cosmos.vesting.v1beta1.PermanentLockedAccount",
    encode(O, T = u.BinaryWriter.create()) {
      return O.baseVestingAccount !== void 0 && e.BaseVestingAccount.encode(O.baseVestingAccount, T.uint32(10).fork()).ldelim(), T;
    },
    decode(O, T) {
      const y = O instanceof u.BinaryReader ? O : new u.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = E();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.baseVestingAccount = e.BaseVestingAccount.decode(y, y.uint32());
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = E();
      return (0, c.isSet)(O.baseVestingAccount) && (T.baseVestingAccount = e.BaseVestingAccount.fromJSON(O.baseVestingAccount)), T;
    },
    toJSON(O) {
      const T = {};
      return O.baseVestingAccount !== void 0 && (T.baseVestingAccount = O.baseVestingAccount ? e.BaseVestingAccount.toJSON(O.baseVestingAccount) : void 0), T;
    },
    fromPartial(O) {
      const T = E();
      return O.baseVestingAccount !== void 0 && O.baseVestingAccount !== null && (T.baseVestingAccount = e.BaseVestingAccount.fromPartial(O.baseVestingAccount)), T;
    }
  };
})(vesting);
Object.defineProperty(accounts$1, "__esModule", { value: !0 });
accounts$1.accountFromAny = void 0;
const math_1$t = build$R, proto_signing_1$a = build$Q, utils_1$X = build$G, auth_1$1 = auth, vesting_1$1 = vesting;
function uint64FromProto$1(e) {
  return math_1$t.Uint64.fromString(e.toString());
}
function accountFromBaseAccount$1(e) {
  const { address: n, pubKey: o, accountNumber: u, sequence: c } = e, d = (0, proto_signing_1$a.decodeOptionalPubkey)(o);
  return {
    address: n,
    pubkey: d,
    accountNumber: uint64FromProto$1(u).toNumber(),
    sequence: uint64FromProto$1(c).toNumber()
  };
}
function accountFromAny$1(e) {
  var u, c, d, m, v, S, $;
  const { typeUrl: n, value: o } = e;
  switch (n) {
    case "/cosmos.auth.v1beta1.BaseAccount":
      return accountFromBaseAccount$1(auth_1$1.BaseAccount.decode(o));
    case "/cosmos.auth.v1beta1.ModuleAccount": {
      const E = auth_1$1.ModuleAccount.decode(o).baseAccount;
      return (0, utils_1$X.assert)(E), accountFromBaseAccount$1(E);
    }
    case "/cosmos.vesting.v1beta1.BaseVestingAccount": {
      const E = (u = vesting_1$1.BaseVestingAccount.decode(o)) == null ? void 0 : u.baseAccount;
      return (0, utils_1$X.assert)(E), accountFromBaseAccount$1(E);
    }
    case "/cosmos.vesting.v1beta1.ContinuousVestingAccount": {
      const E = (d = (c = vesting_1$1.ContinuousVestingAccount.decode(o)) == null ? void 0 : c.baseVestingAccount) == null ? void 0 : d.baseAccount;
      return (0, utils_1$X.assert)(E), accountFromBaseAccount$1(E);
    }
    case "/cosmos.vesting.v1beta1.DelayedVestingAccount": {
      const E = (v = (m = vesting_1$1.DelayedVestingAccount.decode(o)) == null ? void 0 : m.baseVestingAccount) == null ? void 0 : v.baseAccount;
      return (0, utils_1$X.assert)(E), accountFromBaseAccount$1(E);
    }
    case "/cosmos.vesting.v1beta1.PeriodicVestingAccount": {
      const E = ($ = (S = vesting_1$1.PeriodicVestingAccount.decode(o)) == null ? void 0 : S.baseVestingAccount) == null ? void 0 : $.baseAccount;
      return (0, utils_1$X.assert)(E), accountFromBaseAccount$1(E);
    }
    default:
      throw new Error(`Unsupported type: '${n}'`);
  }
}
accounts$1.accountFromAny = accountFromAny$1;
var aminotypes$1 = {};
Object.defineProperty(aminotypes$1, "__esModule", { value: !0 });
aminotypes$1.AminoTypes = void 0;
let AminoTypes$1 = class {
  constructor(n) {
    this.register = n;
  }
  toAmino({ typeUrl: n, value: o }) {
    const u = this.register[n];
    if (!u)
      throw new Error(`Type URL '${n}' does not exist in the Amino message type register. If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.`);
    return {
      type: u.aminoType,
      value: u.toAmino(o)
    };
  }
  fromAmino({ type: n, value: o }) {
    const u = Object.entries(this.register).filter(([c, { aminoType: d }]) => d === n);
    switch (u.length) {
      case 0:
        throw new Error(`Amino type identifier '${n}' does not exist in the Amino message type register. If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.`);
      case 1: {
        const [c, d] = u[0];
        return {
          typeUrl: c,
          value: d.fromAmino(o)
        };
      }
      default:
        throw new Error(`Multiple types are registered with Amino type identifier '${n}': '` + u.map(([c, d]) => c).sort().join("', '") + "'. Thus fromAmino cannot be performed.");
    }
  }
};
aminotypes$1.AminoTypes = AminoTypes$1;
var events$1 = {}, build$F = {}, ascii$4 = {};
Object.defineProperty(ascii$4, "__esModule", { value: !0 });
ascii$4.fromAscii = ascii$4.toAscii = void 0;
function toAscii$4(e) {
  const n = (o) => o.split("").map((u) => {
    const c = u.charCodeAt(0);
    if (c < 32 || c > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + c);
    return c;
  });
  return Uint8Array.from(n(e));
}
ascii$4.toAscii = toAscii$4;
function fromAscii$4(e) {
  return ((o) => o.map((u) => {
    if (u < 32 || u > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + u);
    return String.fromCharCode(u);
  }))(Array.from(e)).join("");
}
ascii$4.fromAscii = fromAscii$4;
var base64$6 = {}, __createBinding$N = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$N = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$N = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$N(n, e, o);
  return __setModuleDefault$N(n, e), n;
};
Object.defineProperty(base64$6, "__esModule", { value: !0 });
base64$6.fromBase64 = base64$6.toBase64 = void 0;
const base64js$4 = __importStar$N(base64Js);
function toBase64$4(e) {
  return base64js$4.fromByteArray(e);
}
base64$6.toBase64 = toBase64$4;
function fromBase64$4(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$4.toByteArray(e);
}
base64$6.fromBase64 = fromBase64$4;
var bech32$9 = {}, __createBinding$M = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$M = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$M = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$M(n, e, o);
  return __setModuleDefault$M(n, e), n;
};
Object.defineProperty(bech32$9, "__esModule", { value: !0 });
bech32$9.normalizeBech32 = bech32$9.fromBech32 = bech32$9.toBech32 = void 0;
const bech32$8 = __importStar$M(bech32$f);
function toBech32$4(e, n, o) {
  return bech32$8.encode(e, bech32$8.toWords(n), o);
}
bech32$9.toBech32 = toBech32$4;
function fromBech32$4(e, n = 1 / 0) {
  const o = bech32$8.decode(e, n);
  return {
    prefix: o.prefix,
    data: new Uint8Array(bech32$8.fromWords(o.words))
  };
}
bech32$9.fromBech32 = fromBech32$4;
function normalizeBech32$4(e) {
  const { prefix: n, data: o } = fromBech32$4(e);
  return toBech32$4(n, o);
}
bech32$9.normalizeBech32 = normalizeBech32$4;
var hex$4 = {};
Object.defineProperty(hex$4, "__esModule", { value: !0 });
hex$4.fromHex = hex$4.toHex = void 0;
function toHex$4(e) {
  let n = "";
  for (const o of e)
    n += ("0" + o.toString(16)).slice(-2);
  return n;
}
hex$4.toHex = toHex$4;
function fromHex$4(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let o = 0; o < n.length; o++) {
    const u = 2 * o, c = e.slice(u, u + 2);
    if (!c.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[o] = parseInt(c, 16);
  }
  return n;
}
hex$4.fromHex = fromHex$4;
var rfc3339$4 = {};
Object.defineProperty(rfc3339$4, "__esModule", { value: !0 });
rfc3339$4.toRfc3339 = rfc3339$4.fromRfc3339 = void 0;
const rfc3339Matcher$4 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$4(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function fromRfc3339$4(e) {
  const n = rfc3339Matcher$4.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const o = +n[1], u = +n[2], c = +n[3], d = +n[4], m = +n[5], v = +n[6], S = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let $, E, O;
  n[8] === "Z" ? ($ = 1, E = 0, O = 0) : ($ = n[8].substring(0, 1) === "-" ? -1 : 1, E = +n[8].substring(1, 3), O = +n[8].substring(4, 6));
  const T = $ * (E * 60 + O) * 60, y = Date.UTC(o, u - 1, c, d, m, v, S) - T * 1e3;
  return new Date(y);
}
rfc3339$4.fromRfc3339 = fromRfc3339$4;
function toRfc3339$4(e) {
  const n = e.getUTCFullYear(), o = padded$4(e.getUTCMonth() + 1), u = padded$4(e.getUTCDate()), c = padded$4(e.getUTCHours()), d = padded$4(e.getUTCMinutes()), m = padded$4(e.getUTCSeconds()), v = padded$4(e.getUTCMilliseconds(), 3);
  return `${n}-${o}-${u}T${c}:${d}:${m}.${v}Z`;
}
rfc3339$4.toRfc3339 = toRfc3339$4;
var utf8$7 = {};
Object.defineProperty(utf8$7, "__esModule", { value: !0 });
utf8$7.fromUtf8 = utf8$7.toUtf8 = void 0;
function toUtf8$4(e) {
  return new TextEncoder().encode(e);
}
utf8$7.toUtf8 = toUtf8$4;
function fromUtf8$4(e, n = !1) {
  const o = !n;
  return new TextDecoder("utf-8", { fatal: o }).decode(e);
}
utf8$7.fromUtf8 = fromUtf8$4;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = ascii$4;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var o = base64$6;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return o.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return o.toBase64;
  } });
  var u = bech32$9;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return u.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return u.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return u.toBech32;
  } });
  var c = hex$4;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return c.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return c.toHex;
  } });
  var d = rfc3339$4;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return d.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return d.toRfc3339;
  } });
  var m = utf8$7;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return m.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return m.toUtf8;
  } });
})(build$F);
Object.defineProperty(events$1, "__esModule", { value: !0 });
events$1.fromTendermintEvent = void 0;
const encoding_1$1c = build$F;
function fromTendermintEvent(e) {
  return {
    type: e.type,
    attributes: e.attributes.map((n) => ({
      key: typeof n.key == "string" ? n.key : (0, encoding_1$1c.fromUtf8)(n.key, !0),
      value: typeof n.value == "string" ? n.value : (0, encoding_1$1c.fromUtf8)(n.value, !0)
    }))
  };
}
events$1.fromTendermintEvent = fromTendermintEvent;
var fee$1 = {};
Object.defineProperty(fee$1, "__esModule", { value: !0 });
fee$1.calculateFee = fee$1.GasPrice = void 0;
const math_1$s = build$R, proto_signing_1$9 = build$Q;
function checkDenom$1(e) {
  if (e.length < 3 || e.length > 128)
    throw new Error("Denom must be between 3 and 128 characters");
}
let GasPrice$1 = class Lc {
  constructor(n, o) {
    this.amount = n, this.denom = o;
  }
  /**
   * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
   *
   * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
   * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
   *
   * Separators are not yet supported.
   */
  static fromString(n) {
    const o = n.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
    if (!o)
      throw new Error("Invalid gas price string");
    const [u, c, d] = o;
    checkDenom$1(d);
    const m = 18, v = math_1$s.Decimal.fromUserInput(c, m);
    return new Lc(v, d);
  }
  /**
   * Returns a string representation of this gas price, e.g. "0.025uatom".
   * This can be used as an input to `GasPrice.fromString`.
   */
  toString() {
    return this.amount.toString() + this.denom;
  }
};
fee$1.GasPrice = GasPrice$1;
function calculateFee$1(e, n) {
  const o = typeof n == "string" ? GasPrice$1.fromString(n) : n, { denom: u, amount: c } = o, d = c.multiply(new math_1$s.Uint53(e)).ceil().toString();
  return {
    amount: (0, proto_signing_1$9.coins)(d, u),
    gas: e.toString()
  };
}
fee$1.calculateFee = calculateFee$1;
var logs$1 = {};
Object.defineProperty(logs$1, "__esModule", { value: !0 });
logs$1.findAttribute = logs$1.parseRawLog = logs$1.parseLogs = logs$1.parseLog = logs$1.parseEvent = logs$1.parseAttribute = void 0;
const utils_1$W = build$G;
function parseAttribute$1(e) {
  if (!(0, utils_1$W.isNonNullObject)(e))
    throw new Error("Attribute must be a non-null object");
  const { key: n, value: o } = e;
  if (typeof n != "string" || !n)
    throw new Error("Attribute's key must be a non-empty string");
  if (typeof o != "string" && typeof o < "u")
    throw new Error("Attribute's value must be a string or unset");
  return {
    key: n,
    value: o || ""
  };
}
logs$1.parseAttribute = parseAttribute$1;
function parseEvent$1(e) {
  if (!(0, utils_1$W.isNonNullObject)(e))
    throw new Error("Event must be a non-null object");
  const { type: n, attributes: o } = e;
  if (typeof n != "string" || n === "")
    throw new Error("Event type must be a non-empty string");
  if (!Array.isArray(o))
    throw new Error("Event's attributes must be an array");
  return {
    type: n,
    attributes: o.map(parseAttribute$1)
  };
}
logs$1.parseEvent = parseEvent$1;
function parseLog$1(e) {
  if (!(0, utils_1$W.isNonNullObject)(e))
    throw new Error("Log must be a non-null object");
  const { msg_index: n, log: o, events: u } = e;
  if (typeof n != "number")
    throw new Error("Log's msg_index must be a number");
  if (typeof o != "string")
    throw new Error("Log's log must be a string");
  if (!Array.isArray(u))
    throw new Error("Log's events must be an array");
  return {
    msg_index: n,
    log: o,
    events: u.map(parseEvent$1)
  };
}
logs$1.parseLog = parseLog$1;
function parseLogs$1(e) {
  if (!Array.isArray(e))
    throw new Error("Logs must be an array");
  return e.map(parseLog$1);
}
logs$1.parseLogs = parseLogs$1;
function parseRawLog$1(e = "[]") {
  const n = JSON.parse(e).map(({ events: o }, u) => ({
    msg_index: u,
    events: o,
    log: ""
  }));
  return parseLogs$1(n);
}
logs$1.parseRawLog = parseRawLog$1;
function findAttribute$1(e, n, o) {
  var d;
  const u = e.find(() => !0), c = (d = u == null ? void 0 : u.events.find((m) => m.type === n)) == null ? void 0 : d.attributes.find((m) => m.key === o);
  if (!c)
    throw new Error(`Could not find attribute '${o}' in first event of type '${n}' in first log.`);
  return c;
}
logs$1.findAttribute = findAttribute$1;
var modules$2 = {}, queries$m = {}, query$d = {}, pagination = {};
Object.defineProperty(pagination, "__esModule", { value: !0 });
pagination.PageResponse = pagination.PageRequest = pagination.protobufPackage = void 0;
const binary_1$a = binary, helpers_1$a = helpers;
pagination.protobufPackage = "cosmos.base.query.v1beta1";
function createBasePageRequest$1() {
  return {
    key: new Uint8Array(),
    offset: BigInt(0),
    limit: BigInt(0),
    countTotal: !1,
    reverse: !1
  };
}
pagination.PageRequest = {
  typeUrl: "/cosmos.base.query.v1beta1.PageRequest",
  encode(e, n = binary_1$a.BinaryWriter.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.offset !== BigInt(0) && n.uint32(16).uint64(e.offset), e.limit !== BigInt(0) && n.uint32(24).uint64(e.limit), e.countTotal === !0 && n.uint32(32).bool(e.countTotal), e.reverse === !0 && n.uint32(40).bool(e.reverse), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$a.BinaryReader ? e : new binary_1$a.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePageRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.offset = o.uint64();
          break;
        case 3:
          c.limit = o.uint64();
          break;
        case 4:
          c.countTotal = o.bool();
          break;
        case 5:
          c.reverse = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBasePageRequest$1();
    return (0, helpers_1$a.isSet)(e.key) && (n.key = (0, helpers_1$a.bytesFromBase64)(e.key)), (0, helpers_1$a.isSet)(e.offset) && (n.offset = BigInt(e.offset.toString())), (0, helpers_1$a.isSet)(e.limit) && (n.limit = BigInt(e.limit.toString())), (0, helpers_1$a.isSet)(e.countTotal) && (n.countTotal = !!e.countTotal), (0, helpers_1$a.isSet)(e.reverse) && (n.reverse = !!e.reverse), n;
  },
  toJSON(e) {
    const n = {};
    return e.key !== void 0 && (n.key = (0, helpers_1$a.base64FromBytes)(e.key !== void 0 ? e.key : new Uint8Array())), e.offset !== void 0 && (n.offset = (e.offset || BigInt(0)).toString()), e.limit !== void 0 && (n.limit = (e.limit || BigInt(0)).toString()), e.countTotal !== void 0 && (n.countTotal = e.countTotal), e.reverse !== void 0 && (n.reverse = e.reverse), n;
  },
  fromPartial(e) {
    const n = createBasePageRequest$1();
    return n.key = e.key ?? new Uint8Array(), e.offset !== void 0 && e.offset !== null && (n.offset = BigInt(e.offset.toString())), e.limit !== void 0 && e.limit !== null && (n.limit = BigInt(e.limit.toString())), n.countTotal = e.countTotal ?? !1, n.reverse = e.reverse ?? !1, n;
  }
};
function createBasePageResponse$1() {
  return {
    nextKey: new Uint8Array(),
    total: BigInt(0)
  };
}
pagination.PageResponse = {
  typeUrl: "/cosmos.base.query.v1beta1.PageResponse",
  encode(e, n = binary_1$a.BinaryWriter.create()) {
    return e.nextKey.length !== 0 && n.uint32(10).bytes(e.nextKey), e.total !== BigInt(0) && n.uint32(16).uint64(e.total), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$a.BinaryReader ? e : new binary_1$a.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePageResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.nextKey = o.bytes();
          break;
        case 2:
          c.total = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBasePageResponse$1();
    return (0, helpers_1$a.isSet)(e.nextKey) && (n.nextKey = (0, helpers_1$a.bytesFromBase64)(e.nextKey)), (0, helpers_1$a.isSet)(e.total) && (n.total = BigInt(e.total.toString())), n;
  },
  toJSON(e) {
    const n = {};
    return e.nextKey !== void 0 && (n.nextKey = (0, helpers_1$a.base64FromBytes)(e.nextKey !== void 0 ? e.nextKey : new Uint8Array())), e.total !== void 0 && (n.total = (e.total || BigInt(0)).toString()), n;
  },
  fromPartial(e) {
    const n = createBasePageResponse$1();
    return n.nextKey = e.nextKey ?? new Uint8Array(), e.total !== void 0 && e.total !== null && (n.total = BigInt(e.total.toString())), n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryAccountInfoResponse = e.QueryAccountInfoRequest = e.QueryAccountAddressByIDResponse = e.QueryAccountAddressByIDRequest = e.AddressStringToBytesResponse = e.AddressStringToBytesRequest = e.AddressBytesToStringResponse = e.AddressBytesToStringRequest = e.Bech32PrefixResponse = e.Bech32PrefixRequest = e.QueryModuleAccountByNameResponse = e.QueryModuleAccountByNameRequest = e.QueryModuleAccountsResponse = e.QueryModuleAccountsRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryAccountResponse = e.QueryAccountRequest = e.QueryAccountsResponse = e.QueryAccountsRequest = e.protobufPackage = void 0;
  const n = pagination, o = any$1, u = auth, c = binary, d = helpers;
  e.protobufPackage = "cosmos.auth.v1beta1";
  function m() {
    return {
      pagination: void 0
    };
  }
  e.QueryAccountsRequest = {
    typeUrl: "/cosmos.auth.v1beta1.QueryAccountsRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.pagination !== void 0 && n.PageRequest.encode(H.pagination, C.uint32(10).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = m();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.pagination = n.PageRequest.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = m();
      return (0, d.isSet)(H.pagination) && (C.pagination = n.PageRequest.fromJSON(H.pagination)), C;
    },
    toJSON(H) {
      const C = {};
      return H.pagination !== void 0 && (C.pagination = H.pagination ? n.PageRequest.toJSON(H.pagination) : void 0), C;
    },
    fromPartial(H) {
      const C = m();
      return H.pagination !== void 0 && H.pagination !== null && (C.pagination = n.PageRequest.fromPartial(H.pagination)), C;
    }
  };
  function v() {
    return {
      accounts: [],
      pagination: void 0
    };
  }
  e.QueryAccountsResponse = {
    typeUrl: "/cosmos.auth.v1beta1.QueryAccountsResponse",
    encode(H, C = c.BinaryWriter.create()) {
      for (const w of H.accounts)
        o.Any.encode(w, C.uint32(10).fork()).ldelim();
      return H.pagination !== void 0 && n.PageResponse.encode(H.pagination, C.uint32(18).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = v();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.accounts.push(o.Any.decode(w, w.uint32()));
            break;
          case 2:
            J.pagination = n.PageResponse.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = v();
      return Array.isArray(H == null ? void 0 : H.accounts) && (C.accounts = H.accounts.map((w) => o.Any.fromJSON(w))), (0, d.isSet)(H.pagination) && (C.pagination = n.PageResponse.fromJSON(H.pagination)), C;
    },
    toJSON(H) {
      const C = {};
      return H.accounts ? C.accounts = H.accounts.map((w) => w ? o.Any.toJSON(w) : void 0) : C.accounts = [], H.pagination !== void 0 && (C.pagination = H.pagination ? n.PageResponse.toJSON(H.pagination) : void 0), C;
    },
    fromPartial(H) {
      var w;
      const C = v();
      return C.accounts = ((w = H.accounts) == null ? void 0 : w.map((P) => o.Any.fromPartial(P))) || [], H.pagination !== void 0 && H.pagination !== null && (C.pagination = n.PageResponse.fromPartial(H.pagination)), C;
    }
  };
  function S() {
    return {
      address: ""
    };
  }
  e.QueryAccountRequest = {
    typeUrl: "/cosmos.auth.v1beta1.QueryAccountRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.address !== "" && C.uint32(10).string(H.address), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = S();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.address = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = S();
      return (0, d.isSet)(H.address) && (C.address = String(H.address)), C;
    },
    toJSON(H) {
      const C = {};
      return H.address !== void 0 && (C.address = H.address), C;
    },
    fromPartial(H) {
      const C = S();
      return C.address = H.address ?? "", C;
    }
  };
  function $() {
    return {
      account: void 0
    };
  }
  e.QueryAccountResponse = {
    typeUrl: "/cosmos.auth.v1beta1.QueryAccountResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.account !== void 0 && o.Any.encode(H.account, C.uint32(10).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = $();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.account = o.Any.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = $();
      return (0, d.isSet)(H.account) && (C.account = o.Any.fromJSON(H.account)), C;
    },
    toJSON(H) {
      const C = {};
      return H.account !== void 0 && (C.account = H.account ? o.Any.toJSON(H.account) : void 0), C;
    },
    fromPartial(H) {
      const C = $();
      return H.account !== void 0 && H.account !== null && (C.account = o.Any.fromPartial(H.account)), C;
    }
  };
  function E() {
    return {};
  }
  e.QueryParamsRequest = {
    typeUrl: "/cosmos.auth.v1beta1.QueryParamsRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = E();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      return E();
    },
    toJSON(H) {
      return {};
    },
    fromPartial(H) {
      return E();
    }
  };
  function O() {
    return {
      params: u.Params.fromPartial({})
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/cosmos.auth.v1beta1.QueryParamsResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.params !== void 0 && u.Params.encode(H.params, C.uint32(10).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = O();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.params = u.Params.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = O();
      return (0, d.isSet)(H.params) && (C.params = u.Params.fromJSON(H.params)), C;
    },
    toJSON(H) {
      const C = {};
      return H.params !== void 0 && (C.params = H.params ? u.Params.toJSON(H.params) : void 0), C;
    },
    fromPartial(H) {
      const C = O();
      return H.params !== void 0 && H.params !== null && (C.params = u.Params.fromPartial(H.params)), C;
    }
  };
  function T() {
    return {};
  }
  e.QueryModuleAccountsRequest = {
    typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = T();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      return T();
    },
    toJSON(H) {
      return {};
    },
    fromPartial(H) {
      return T();
    }
  };
  function y() {
    return {
      accounts: []
    };
  }
  e.QueryModuleAccountsResponse = {
    typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsResponse",
    encode(H, C = c.BinaryWriter.create()) {
      for (const w of H.accounts)
        o.Any.encode(w, C.uint32(10).fork()).ldelim();
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = y();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.accounts.push(o.Any.decode(w, w.uint32()));
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = y();
      return Array.isArray(H == null ? void 0 : H.accounts) && (C.accounts = H.accounts.map((w) => o.Any.fromJSON(w))), C;
    },
    toJSON(H) {
      const C = {};
      return H.accounts ? C.accounts = H.accounts.map((w) => w ? o.Any.toJSON(w) : void 0) : C.accounts = [], C;
    },
    fromPartial(H) {
      var w;
      const C = y();
      return C.accounts = ((w = H.accounts) == null ? void 0 : w.map((P) => o.Any.fromPartial(P))) || [], C;
    }
  };
  function V() {
    return {
      name: ""
    };
  }
  e.QueryModuleAccountByNameRequest = {
    typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountByNameRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.name !== "" && C.uint32(10).string(H.name), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = V();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.name = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = V();
      return (0, d.isSet)(H.name) && (C.name = String(H.name)), C;
    },
    toJSON(H) {
      const C = {};
      return H.name !== void 0 && (C.name = H.name), C;
    },
    fromPartial(H) {
      const C = V();
      return C.name = H.name ?? "", C;
    }
  };
  function M() {
    return {
      account: void 0
    };
  }
  e.QueryModuleAccountByNameResponse = {
    typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountByNameResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.account !== void 0 && o.Any.encode(H.account, C.uint32(10).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = M();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.account = o.Any.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = M();
      return (0, d.isSet)(H.account) && (C.account = o.Any.fromJSON(H.account)), C;
    },
    toJSON(H) {
      const C = {};
      return H.account !== void 0 && (C.account = H.account ? o.Any.toJSON(H.account) : void 0), C;
    },
    fromPartial(H) {
      const C = M();
      return H.account !== void 0 && H.account !== null && (C.account = o.Any.fromPartial(H.account)), C;
    }
  };
  function G() {
    return {};
  }
  e.Bech32PrefixRequest = {
    typeUrl: "/cosmos.auth.v1beta1.Bech32PrefixRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = G();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      return G();
    },
    toJSON(H) {
      return {};
    },
    fromPartial(H) {
      return G();
    }
  };
  function k() {
    return {
      bech32Prefix: ""
    };
  }
  e.Bech32PrefixResponse = {
    typeUrl: "/cosmos.auth.v1beta1.Bech32PrefixResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.bech32Prefix !== "" && C.uint32(10).string(H.bech32Prefix), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = k();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.bech32Prefix = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = k();
      return (0, d.isSet)(H.bech32Prefix) && (C.bech32Prefix = String(H.bech32Prefix)), C;
    },
    toJSON(H) {
      const C = {};
      return H.bech32Prefix !== void 0 && (C.bech32Prefix = H.bech32Prefix), C;
    },
    fromPartial(H) {
      const C = k();
      return C.bech32Prefix = H.bech32Prefix ?? "", C;
    }
  };
  function F() {
    return {
      addressBytes: new Uint8Array()
    };
  }
  e.AddressBytesToStringRequest = {
    typeUrl: "/cosmos.auth.v1beta1.AddressBytesToStringRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.addressBytes.length !== 0 && C.uint32(10).bytes(H.addressBytes), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = F();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.addressBytes = w.bytes();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = F();
      return (0, d.isSet)(H.addressBytes) && (C.addressBytes = (0, d.bytesFromBase64)(H.addressBytes)), C;
    },
    toJSON(H) {
      const C = {};
      return H.addressBytes !== void 0 && (C.addressBytes = (0, d.base64FromBytes)(H.addressBytes !== void 0 ? H.addressBytes : new Uint8Array())), C;
    },
    fromPartial(H) {
      const C = F();
      return C.addressBytes = H.addressBytes ?? new Uint8Array(), C;
    }
  };
  function X() {
    return {
      addressString: ""
    };
  }
  e.AddressBytesToStringResponse = {
    typeUrl: "/cosmos.auth.v1beta1.AddressBytesToStringResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.addressString !== "" && C.uint32(10).string(H.addressString), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = X();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.addressString = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = X();
      return (0, d.isSet)(H.addressString) && (C.addressString = String(H.addressString)), C;
    },
    toJSON(H) {
      const C = {};
      return H.addressString !== void 0 && (C.addressString = H.addressString), C;
    },
    fromPartial(H) {
      const C = X();
      return C.addressString = H.addressString ?? "", C;
    }
  };
  function ee() {
    return {
      addressString: ""
    };
  }
  e.AddressStringToBytesRequest = {
    typeUrl: "/cosmos.auth.v1beta1.AddressStringToBytesRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.addressString !== "" && C.uint32(10).string(H.addressString), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = ee();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.addressString = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = ee();
      return (0, d.isSet)(H.addressString) && (C.addressString = String(H.addressString)), C;
    },
    toJSON(H) {
      const C = {};
      return H.addressString !== void 0 && (C.addressString = H.addressString), C;
    },
    fromPartial(H) {
      const C = ee();
      return C.addressString = H.addressString ?? "", C;
    }
  };
  function ue() {
    return {
      addressBytes: new Uint8Array()
    };
  }
  e.AddressStringToBytesResponse = {
    typeUrl: "/cosmos.auth.v1beta1.AddressStringToBytesResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.addressBytes.length !== 0 && C.uint32(10).bytes(H.addressBytes), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = ue();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.addressBytes = w.bytes();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = ue();
      return (0, d.isSet)(H.addressBytes) && (C.addressBytes = (0, d.bytesFromBase64)(H.addressBytes)), C;
    },
    toJSON(H) {
      const C = {};
      return H.addressBytes !== void 0 && (C.addressBytes = (0, d.base64FromBytes)(H.addressBytes !== void 0 ? H.addressBytes : new Uint8Array())), C;
    },
    fromPartial(H) {
      const C = ue();
      return C.addressBytes = H.addressBytes ?? new Uint8Array(), C;
    }
  };
  function Q() {
    return {
      id: BigInt(0),
      accountId: BigInt(0)
    };
  }
  e.QueryAccountAddressByIDRequest = {
    typeUrl: "/cosmos.auth.v1beta1.QueryAccountAddressByIDRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.id !== BigInt(0) && C.uint32(8).int64(H.id), H.accountId !== BigInt(0) && C.uint32(16).uint64(H.accountId), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = Q();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.id = w.int64();
            break;
          case 2:
            J.accountId = w.uint64();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = Q();
      return (0, d.isSet)(H.id) && (C.id = BigInt(H.id.toString())), (0, d.isSet)(H.accountId) && (C.accountId = BigInt(H.accountId.toString())), C;
    },
    toJSON(H) {
      const C = {};
      return H.id !== void 0 && (C.id = (H.id || BigInt(0)).toString()), H.accountId !== void 0 && (C.accountId = (H.accountId || BigInt(0)).toString()), C;
    },
    fromPartial(H) {
      const C = Q();
      return H.id !== void 0 && H.id !== null && (C.id = BigInt(H.id.toString())), H.accountId !== void 0 && H.accountId !== null && (C.accountId = BigInt(H.accountId.toString())), C;
    }
  };
  function Y() {
    return {
      accountAddress: ""
    };
  }
  e.QueryAccountAddressByIDResponse = {
    typeUrl: "/cosmos.auth.v1beta1.QueryAccountAddressByIDResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.accountAddress !== "" && C.uint32(10).string(H.accountAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = Y();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.accountAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = Y();
      return (0, d.isSet)(H.accountAddress) && (C.accountAddress = String(H.accountAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.accountAddress !== void 0 && (C.accountAddress = H.accountAddress), C;
    },
    fromPartial(H) {
      const C = Y();
      return C.accountAddress = H.accountAddress ?? "", C;
    }
  };
  function pe() {
    return {
      address: ""
    };
  }
  e.QueryAccountInfoRequest = {
    typeUrl: "/cosmos.auth.v1beta1.QueryAccountInfoRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.address !== "" && C.uint32(10).string(H.address), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = pe();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.address = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = pe();
      return (0, d.isSet)(H.address) && (C.address = String(H.address)), C;
    },
    toJSON(H) {
      const C = {};
      return H.address !== void 0 && (C.address = H.address), C;
    },
    fromPartial(H) {
      const C = pe();
      return C.address = H.address ?? "", C;
    }
  };
  function oe() {
    return {
      info: void 0
    };
  }
  e.QueryAccountInfoResponse = {
    typeUrl: "/cosmos.auth.v1beta1.QueryAccountInfoResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.info !== void 0 && u.BaseAccount.encode(H.info, C.uint32(10).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = oe();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.info = u.BaseAccount.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = oe();
      return (0, d.isSet)(H.info) && (C.info = u.BaseAccount.fromJSON(H.info)), C;
    },
    toJSON(H) {
      const C = {};
      return H.info !== void 0 && (C.info = H.info ? u.BaseAccount.toJSON(H.info) : void 0), C;
    },
    fromPartial(H) {
      const C = oe();
      return H.info !== void 0 && H.info !== null && (C.info = u.BaseAccount.fromPartial(H.info)), C;
    }
  };
  class ne {
    constructor(C) {
      this.rpc = C, this.Accounts = this.Accounts.bind(this), this.Account = this.Account.bind(this), this.AccountAddressByID = this.AccountAddressByID.bind(this), this.Params = this.Params.bind(this), this.ModuleAccounts = this.ModuleAccounts.bind(this), this.ModuleAccountByName = this.ModuleAccountByName.bind(this), this.Bech32Prefix = this.Bech32Prefix.bind(this), this.AddressBytesToString = this.AddressBytesToString.bind(this), this.AddressStringToBytes = this.AddressStringToBytes.bind(this), this.AccountInfo = this.AccountInfo.bind(this);
    }
    Accounts(C = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const w = e.QueryAccountsRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", w).then((J) => e.QueryAccountsResponse.decode(new c.BinaryReader(J)));
    }
    Account(C) {
      const w = e.QueryAccountRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "Account", w).then((J) => e.QueryAccountResponse.decode(new c.BinaryReader(J)));
    }
    AccountAddressByID(C) {
      const w = e.QueryAccountAddressByIDRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "AccountAddressByID", w).then((J) => e.QueryAccountAddressByIDResponse.decode(new c.BinaryReader(J)));
    }
    Params(C = {}) {
      const w = e.QueryParamsRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "Params", w).then((J) => e.QueryParamsResponse.decode(new c.BinaryReader(J)));
    }
    ModuleAccounts(C = {}) {
      const w = e.QueryModuleAccountsRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", w).then((J) => e.QueryModuleAccountsResponse.decode(new c.BinaryReader(J)));
    }
    ModuleAccountByName(C) {
      const w = e.QueryModuleAccountByNameRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccountByName", w).then((J) => e.QueryModuleAccountByNameResponse.decode(new c.BinaryReader(J)));
    }
    Bech32Prefix(C = {}) {
      const w = e.Bech32PrefixRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "Bech32Prefix", w).then((J) => e.Bech32PrefixResponse.decode(new c.BinaryReader(J)));
    }
    AddressBytesToString(C) {
      const w = e.AddressBytesToStringRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "AddressBytesToString", w).then((J) => e.AddressBytesToStringResponse.decode(new c.BinaryReader(J)));
    }
    AddressStringToBytes(C) {
      const w = e.AddressStringToBytesRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "AddressStringToBytes", w).then((J) => e.AddressStringToBytesResponse.decode(new c.BinaryReader(J)));
    }
    AccountInfo(C) {
      const w = e.QueryAccountInfoRequest.encode(C).finish();
      return this.rpc.request("cosmos.auth.v1beta1.Query", "AccountInfo", w).then((J) => e.QueryAccountInfoResponse.decode(new c.BinaryReader(J)));
    }
  }
  e.QueryClientImpl = ne;
})(query$d);
var queryclient$3 = {}, queryclient$2 = {}, build$E = {}, indexMinimal = {}, minimal$1 = {}, aspromise = asPromise;
function asPromise(e, n) {
  for (var o = new Array(arguments.length - 1), u = 0, c = 2, d = !0; c < arguments.length; )
    o[u++] = arguments[c++];
  return new Promise(function(v, S) {
    o[u] = function(E) {
      if (d)
        if (d = !1, E)
          S(E);
        else {
          for (var O = new Array(arguments.length - 1), T = 0; T < O.length; )
            O[T++] = arguments[T];
          v.apply(null, O);
        }
    };
    try {
      e.apply(n || null, o);
    } catch ($) {
      d && (d = !1, S($));
    }
  });
}
var base64$5 = {};
(function(e) {
  var n = e;
  n.length = function(v) {
    var S = v.length;
    if (!S)
      return 0;
    for (var $ = 0; --S % 4 > 1 && v.charAt(S) === "="; )
      ++$;
    return Math.ceil(v.length * 3) / 4 - $;
  };
  for (var o = new Array(64), u = new Array(123), c = 0; c < 64; )
    u[o[c] = c < 26 ? c + 65 : c < 52 ? c + 71 : c < 62 ? c - 4 : c - 59 | 43] = c++;
  n.encode = function(v, S, $) {
    for (var E = null, O = [], T = 0, y = 0, V; S < $; ) {
      var M = v[S++];
      switch (y) {
        case 0:
          O[T++] = o[M >> 2], V = (M & 3) << 4, y = 1;
          break;
        case 1:
          O[T++] = o[V | M >> 4], V = (M & 15) << 2, y = 2;
          break;
        case 2:
          O[T++] = o[V | M >> 6], O[T++] = o[M & 63], y = 0;
          break;
      }
      T > 8191 && ((E || (E = [])).push(String.fromCharCode.apply(String, O)), T = 0);
    }
    return y && (O[T++] = o[V], O[T++] = 61, y === 1 && (O[T++] = 61)), E ? (T && E.push(String.fromCharCode.apply(String, O.slice(0, T))), E.join("")) : String.fromCharCode.apply(String, O.slice(0, T));
  };
  var d = "invalid encoding";
  n.decode = function(v, S, $) {
    for (var E = $, O = 0, T, y = 0; y < v.length; ) {
      var V = v.charCodeAt(y++);
      if (V === 61 && O > 1)
        break;
      if ((V = u[V]) === void 0)
        throw Error(d);
      switch (O) {
        case 0:
          T = V, O = 1;
          break;
        case 1:
          S[$++] = T << 2 | (V & 48) >> 4, T = V, O = 2;
          break;
        case 2:
          S[$++] = (T & 15) << 4 | (V & 60) >> 2, T = V, O = 3;
          break;
        case 3:
          S[$++] = (T & 3) << 6 | V, O = 0;
          break;
      }
    }
    if (O === 1)
      throw Error(d);
    return $ - E;
  }, n.test = function(v) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(v);
  };
})(base64$5);
var eventemitter = EventEmitter;
function EventEmitter() {
  this._listeners = {};
}
EventEmitter.prototype.on = function(n, o, u) {
  return (this._listeners[n] || (this._listeners[n] = [])).push({
    fn: o,
    ctx: u || this
  }), this;
};
EventEmitter.prototype.off = function(n, o) {
  if (n === void 0)
    this._listeners = {};
  else if (o === void 0)
    this._listeners[n] = [];
  else
    for (var u = this._listeners[n], c = 0; c < u.length; )
      u[c].fn === o ? u.splice(c, 1) : ++c;
  return this;
};
EventEmitter.prototype.emit = function(n) {
  var o = this._listeners[n];
  if (o) {
    for (var u = [], c = 1; c < arguments.length; )
      u.push(arguments[c++]);
    for (c = 0; c < o.length; )
      o[c].fn.apply(o[c++].ctx, u);
  }
  return this;
};
var float = factory(factory);
function factory(e) {
  return typeof Float32Array < "u" ? function() {
    var n = new Float32Array([-0]), o = new Uint8Array(n.buffer), u = o[3] === 128;
    function c(S, $, E) {
      n[0] = S, $[E] = o[0], $[E + 1] = o[1], $[E + 2] = o[2], $[E + 3] = o[3];
    }
    function d(S, $, E) {
      n[0] = S, $[E] = o[3], $[E + 1] = o[2], $[E + 2] = o[1], $[E + 3] = o[0];
    }
    e.writeFloatLE = u ? c : d, e.writeFloatBE = u ? d : c;
    function m(S, $) {
      return o[0] = S[$], o[1] = S[$ + 1], o[2] = S[$ + 2], o[3] = S[$ + 3], n[0];
    }
    function v(S, $) {
      return o[3] = S[$], o[2] = S[$ + 1], o[1] = S[$ + 2], o[0] = S[$ + 3], n[0];
    }
    e.readFloatLE = u ? m : v, e.readFloatBE = u ? v : m;
  }() : function() {
    function n(u, c, d, m) {
      var v = c < 0 ? 1 : 0;
      if (v && (c = -c), c === 0)
        u(1 / c > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), d, m);
      else if (isNaN(c))
        u(2143289344, d, m);
      else if (c > 34028234663852886e22)
        u((v << 31 | 2139095040) >>> 0, d, m);
      else if (c < 11754943508222875e-54)
        u((v << 31 | Math.round(c / 1401298464324817e-60)) >>> 0, d, m);
      else {
        var S = Math.floor(Math.log(c) / Math.LN2), $ = Math.round(c * Math.pow(2, -S) * 8388608) & 8388607;
        u((v << 31 | S + 127 << 23 | $) >>> 0, d, m);
      }
    }
    e.writeFloatLE = n.bind(null, writeUintLE), e.writeFloatBE = n.bind(null, writeUintBE);
    function o(u, c, d) {
      var m = u(c, d), v = (m >> 31) * 2 + 1, S = m >>> 23 & 255, $ = m & 8388607;
      return S === 255 ? $ ? NaN : v * (1 / 0) : S === 0 ? v * 1401298464324817e-60 * $ : v * Math.pow(2, S - 150) * ($ + 8388608);
    }
    e.readFloatLE = o.bind(null, readUintLE), e.readFloatBE = o.bind(null, readUintBE);
  }(), typeof Float64Array < "u" ? function() {
    var n = new Float64Array([-0]), o = new Uint8Array(n.buffer), u = o[7] === 128;
    function c(S, $, E) {
      n[0] = S, $[E] = o[0], $[E + 1] = o[1], $[E + 2] = o[2], $[E + 3] = o[3], $[E + 4] = o[4], $[E + 5] = o[5], $[E + 6] = o[6], $[E + 7] = o[7];
    }
    function d(S, $, E) {
      n[0] = S, $[E] = o[7], $[E + 1] = o[6], $[E + 2] = o[5], $[E + 3] = o[4], $[E + 4] = o[3], $[E + 5] = o[2], $[E + 6] = o[1], $[E + 7] = o[0];
    }
    e.writeDoubleLE = u ? c : d, e.writeDoubleBE = u ? d : c;
    function m(S, $) {
      return o[0] = S[$], o[1] = S[$ + 1], o[2] = S[$ + 2], o[3] = S[$ + 3], o[4] = S[$ + 4], o[5] = S[$ + 5], o[6] = S[$ + 6], o[7] = S[$ + 7], n[0];
    }
    function v(S, $) {
      return o[7] = S[$], o[6] = S[$ + 1], o[5] = S[$ + 2], o[4] = S[$ + 3], o[3] = S[$ + 4], o[2] = S[$ + 5], o[1] = S[$ + 6], o[0] = S[$ + 7], n[0];
    }
    e.readDoubleLE = u ? m : v, e.readDoubleBE = u ? v : m;
  }() : function() {
    function n(u, c, d, m, v, S) {
      var $ = m < 0 ? 1 : 0;
      if ($ && (m = -m), m === 0)
        u(0, v, S + c), u(1 / m > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), v, S + d);
      else if (isNaN(m))
        u(0, v, S + c), u(2146959360, v, S + d);
      else if (m > 17976931348623157e292)
        u(0, v, S + c), u(($ << 31 | 2146435072) >>> 0, v, S + d);
      else {
        var E;
        if (m < 22250738585072014e-324)
          E = m / 5e-324, u(E >>> 0, v, S + c), u(($ << 31 | E / 4294967296) >>> 0, v, S + d);
        else {
          var O = Math.floor(Math.log(m) / Math.LN2);
          O === 1024 && (O = 1023), E = m * Math.pow(2, -O), u(E * 4503599627370496 >>> 0, v, S + c), u(($ << 31 | O + 1023 << 20 | E * 1048576 & 1048575) >>> 0, v, S + d);
        }
      }
    }
    e.writeDoubleLE = n.bind(null, writeUintLE, 0, 4), e.writeDoubleBE = n.bind(null, writeUintBE, 4, 0);
    function o(u, c, d, m, v) {
      var S = u(m, v + c), $ = u(m, v + d), E = ($ >> 31) * 2 + 1, O = $ >>> 20 & 2047, T = 4294967296 * ($ & 1048575) + S;
      return O === 2047 ? T ? NaN : E * (1 / 0) : O === 0 ? E * 5e-324 * T : E * Math.pow(2, O - 1075) * (T + 4503599627370496);
    }
    e.readDoubleLE = o.bind(null, readUintLE, 0, 4), e.readDoubleBE = o.bind(null, readUintBE, 4, 0);
  }(), e;
}
function writeUintLE(e, n, o) {
  n[o] = e & 255, n[o + 1] = e >>> 8 & 255, n[o + 2] = e >>> 16 & 255, n[o + 3] = e >>> 24;
}
function writeUintBE(e, n, o) {
  n[o] = e >>> 24, n[o + 1] = e >>> 16 & 255, n[o + 2] = e >>> 8 & 255, n[o + 3] = e & 255;
}
function readUintLE(e, n) {
  return (e[n] | e[n + 1] << 8 | e[n + 2] << 16 | e[n + 3] << 24) >>> 0;
}
function readUintBE(e, n) {
  return (e[n] << 24 | e[n + 1] << 16 | e[n + 2] << 8 | e[n + 3]) >>> 0;
}
var inquire_1 = inquire;
function inquire(moduleName) {
  try {
    var mod = eval("quire".replace(/^/, "re"))(moduleName);
    if (mod && (mod.length || Object.keys(mod).length))
      return mod;
  } catch (e) {
  }
  return null;
}
var utf8$6 = {};
(function(e) {
  var n = e;
  n.length = function(u) {
    for (var c = 0, d = 0, m = 0; m < u.length; ++m)
      d = u.charCodeAt(m), d < 128 ? c += 1 : d < 2048 ? c += 2 : (d & 64512) === 55296 && (u.charCodeAt(m + 1) & 64512) === 56320 ? (++m, c += 4) : c += 3;
    return c;
  }, n.read = function(u, c, d) {
    var m = d - c;
    if (m < 1)
      return "";
    for (var v = null, S = [], $ = 0, E; c < d; )
      E = u[c++], E < 128 ? S[$++] = E : E > 191 && E < 224 ? S[$++] = (E & 31) << 6 | u[c++] & 63 : E > 239 && E < 365 ? (E = ((E & 7) << 18 | (u[c++] & 63) << 12 | (u[c++] & 63) << 6 | u[c++] & 63) - 65536, S[$++] = 55296 + (E >> 10), S[$++] = 56320 + (E & 1023)) : S[$++] = (E & 15) << 12 | (u[c++] & 63) << 6 | u[c++] & 63, $ > 8191 && ((v || (v = [])).push(String.fromCharCode.apply(String, S)), $ = 0);
    return v ? ($ && v.push(String.fromCharCode.apply(String, S.slice(0, $))), v.join("")) : String.fromCharCode.apply(String, S.slice(0, $));
  }, n.write = function(u, c, d) {
    for (var m = d, v, S, $ = 0; $ < u.length; ++$)
      v = u.charCodeAt($), v < 128 ? c[d++] = v : v < 2048 ? (c[d++] = v >> 6 | 192, c[d++] = v & 63 | 128) : (v & 64512) === 55296 && ((S = u.charCodeAt($ + 1)) & 64512) === 56320 ? (v = 65536 + ((v & 1023) << 10) + (S & 1023), ++$, c[d++] = v >> 18 | 240, c[d++] = v >> 12 & 63 | 128, c[d++] = v >> 6 & 63 | 128, c[d++] = v & 63 | 128) : (c[d++] = v >> 12 | 224, c[d++] = v >> 6 & 63 | 128, c[d++] = v & 63 | 128);
    return d - m;
  };
})(utf8$6);
var pool_1 = pool;
function pool(e, n, o) {
  var u = o || 8192, c = u >>> 1, d = null, m = u;
  return function(S) {
    if (S < 1 || S > c)
      return e(S);
    m + S > u && (d = e(u), m = 0);
    var $ = n.call(d, m, m += S);
    return m & 7 && (m = (m | 7) + 1), $;
  };
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits)
    return longbits;
  hasRequiredLongbits = 1, longbits = n;
  var e = requireMinimal();
  function n(d, m) {
    this.lo = d >>> 0, this.hi = m >>> 0;
  }
  var o = n.zero = new n(0, 0);
  o.toNumber = function() {
    return 0;
  }, o.zzEncode = o.zzDecode = function() {
    return this;
  }, o.length = function() {
    return 1;
  };
  var u = n.zeroHash = "\0\0\0\0\0\0\0\0";
  n.fromNumber = function(m) {
    if (m === 0)
      return o;
    var v = m < 0;
    v && (m = -m);
    var S = m >>> 0, $ = (m - S) / 4294967296 >>> 0;
    return v && ($ = ~$ >>> 0, S = ~S >>> 0, ++S > 4294967295 && (S = 0, ++$ > 4294967295 && ($ = 0))), new n(S, $);
  }, n.from = function(m) {
    if (typeof m == "number")
      return n.fromNumber(m);
    if (e.isString(m))
      if (e.Long)
        m = e.Long.fromString(m);
      else
        return n.fromNumber(parseInt(m, 10));
    return m.low || m.high ? new n(m.low >>> 0, m.high >>> 0) : o;
  }, n.prototype.toNumber = function(m) {
    if (!m && this.hi >>> 31) {
      var v = ~this.lo + 1 >>> 0, S = ~this.hi >>> 0;
      return v || (S = S + 1 >>> 0), -(v + S * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, n.prototype.toLong = function(m) {
    return e.Long ? new e.Long(this.lo | 0, this.hi | 0, !!m) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!m };
  };
  var c = String.prototype.charCodeAt;
  return n.fromHash = function(m) {
    return m === u ? o : new n(
      (c.call(m, 0) | c.call(m, 1) << 8 | c.call(m, 2) << 16 | c.call(m, 3) << 24) >>> 0,
      (c.call(m, 4) | c.call(m, 5) << 8 | c.call(m, 6) << 16 | c.call(m, 7) << 24) >>> 0
    );
  }, n.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, n.prototype.zzEncode = function() {
    var m = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ m) >>> 0, this.lo = (this.lo << 1 ^ m) >>> 0, this;
  }, n.prototype.zzDecode = function() {
    var m = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ m) >>> 0, this.hi = (this.hi >>> 1 ^ m) >>> 0, this;
  }, n.prototype.length = function() {
    var m = this.lo, v = (this.lo >>> 28 | this.hi << 4) >>> 0, S = this.hi >>> 24;
    return S === 0 ? v === 0 ? m < 16384 ? m < 128 ? 1 : 2 : m < 2097152 ? 3 : 4 : v < 16384 ? v < 128 ? 5 : 6 : v < 2097152 ? 7 : 8 : S < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, function(e) {
    var n = e;
    n.asPromise = aspromise, n.base64 = base64$5, n.EventEmitter = eventemitter, n.float = float, n.inquire = inquire_1, n.utf8 = utf8$6, n.pool = pool_1, n.LongBits = requireLongbits(), n.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), n.global = n.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal, n.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), n.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), n.isInteger = Number.isInteger || /* istanbul ignore next */
    function(d) {
      return typeof d == "number" && isFinite(d) && Math.floor(d) === d;
    }, n.isString = function(d) {
      return typeof d == "string" || d instanceof String;
    }, n.isObject = function(d) {
      return d && typeof d == "object";
    }, n.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    n.isSet = function(d, m) {
      var v = d[m];
      return v != null && d.hasOwnProperty(m) ? typeof v != "object" || (Array.isArray(v) ? v.length : Object.keys(v).length) > 0 : !1;
    }, n.Buffer = function() {
      try {
        var c = n.inquire("buffer").Buffer;
        return c.prototype.utf8Write ? c : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), n._Buffer_from = null, n._Buffer_allocUnsafe = null, n.newBuffer = function(d) {
      return typeof d == "number" ? n.Buffer ? n._Buffer_allocUnsafe(d) : new n.Array(d) : n.Buffer ? n._Buffer_from(d) : typeof Uint8Array > "u" ? d : new Uint8Array(d);
    }, n.Array = typeof Uint8Array < "u" ? Uint8Array : Array, n.Long = /* istanbul ignore next */
    n.global.dcodeIO && /* istanbul ignore next */
    n.global.dcodeIO.Long || /* istanbul ignore next */
    n.global.Long || n.inquire("long"), n.key2Re = /^true|false|0|1$/, n.key32Re = /^-?(?:0|[1-9][0-9]*)$/, n.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, n.longToHash = function(d) {
      return d ? n.LongBits.from(d).toHash() : n.LongBits.zeroHash;
    }, n.longFromHash = function(d, m) {
      var v = n.LongBits.fromHash(d);
      return n.Long ? n.Long.fromBits(v.lo, v.hi, m) : v.toNumber(!!m);
    };
    function o(c, d, m) {
      for (var v = Object.keys(d), S = 0; S < v.length; ++S)
        (c[v[S]] === void 0 || !m) && (c[v[S]] = d[v[S]]);
      return c;
    }
    n.merge = o, n.lcFirst = function(d) {
      return d.charAt(0).toLowerCase() + d.substring(1);
    };
    function u(c) {
      function d(m, v) {
        if (!(this instanceof d))
          return new d(m, v);
        Object.defineProperty(this, "message", { get: function() {
          return m;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, d) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), v && o(this, v);
      }
      return (d.prototype = Object.create(Error.prototype)).constructor = d, Object.defineProperty(d.prototype, "name", { get: function() {
        return c;
      } }), d.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, d;
    }
    n.newError = u, n.ProtocolError = u("ProtocolError"), n.oneOfGetter = function(d) {
      for (var m = {}, v = 0; v < d.length; ++v)
        m[d[v]] = 1;
      return function() {
        for (var S = Object.keys(this), $ = S.length - 1; $ > -1; --$)
          if (m[S[$]] === 1 && this[S[$]] !== void 0 && this[S[$]] !== null)
            return S[$];
      };
    }, n.oneOfSetter = function(d) {
      return function(m) {
        for (var v = 0; v < d.length; ++v)
          d[v] !== m && delete this[d[v]];
      };
    }, n.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, n._configure = function() {
      var c = n.Buffer;
      if (!c) {
        n._Buffer_from = n._Buffer_allocUnsafe = null;
        return;
      }
      n._Buffer_from = c.from !== Uint8Array.from && c.from || /* istanbul ignore next */
      function(m, v) {
        return new c(m, v);
      }, n._Buffer_allocUnsafe = c.allocUnsafe || /* istanbul ignore next */
      function(m) {
        return new c(m);
      };
    };
  }(minimal$1)), minimal$1;
}
var writer = Writer$1, util$4 = requireMinimal(), BufferWriter$1, LongBits$1 = util$4.LongBits, base64$4 = util$4.base64, utf8$5 = util$4.utf8;
function Op(e, n, o) {
  this.fn = e, this.len = n, this.next = void 0, this.val = o;
}
function noop$5() {
}
function State$2(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}
function Writer$1() {
  this.len = 0, this.head = new Op(noop$5, 0, 0), this.tail = this.head, this.states = null;
}
var create$1 = function e() {
  return util$4.Buffer ? function() {
    return (Writer$1.create = function() {
      return new BufferWriter$1();
    })();
  } : function() {
    return new Writer$1();
  };
};
Writer$1.create = create$1();
Writer$1.alloc = function e(n) {
  return new util$4.Array(n);
};
util$4.Array !== Array && (Writer$1.alloc = util$4.pool(Writer$1.alloc, util$4.Array.prototype.subarray));
Writer$1.prototype._push = function e(n, o, u) {
  return this.tail = this.tail.next = new Op(n, o, u), this.len += o, this;
};
function writeByte(e, n, o) {
  n[o] = e & 255;
}
function writeVarint32(e, n, o) {
  for (; e > 127; )
    n[o++] = e & 127 | 128, e >>>= 7;
  n[o] = e;
}
function VarintOp(e, n) {
  this.len = e, this.next = void 0, this.val = n;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
Writer$1.prototype.uint32 = function e(n) {
  return this.len += (this.tail = this.tail.next = new VarintOp(
    (n = n >>> 0) < 128 ? 1 : n < 16384 ? 2 : n < 2097152 ? 3 : n < 268435456 ? 4 : 5,
    n
  )).len, this;
};
Writer$1.prototype.int32 = function e(n) {
  return n < 0 ? this._push(writeVarint64, 10, LongBits$1.fromNumber(n)) : this.uint32(n);
};
Writer$1.prototype.sint32 = function e(n) {
  return this.uint32((n << 1 ^ n >> 31) >>> 0);
};
function writeVarint64(e, n, o) {
  for (; e.hi; )
    n[o++] = e.lo & 127 | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  for (; e.lo > 127; )
    n[o++] = e.lo & 127 | 128, e.lo = e.lo >>> 7;
  n[o++] = e.lo;
}
Writer$1.prototype.uint64 = function e(n) {
  var o = LongBits$1.from(n);
  return this._push(writeVarint64, o.length(), o);
};
Writer$1.prototype.int64 = Writer$1.prototype.uint64;
Writer$1.prototype.sint64 = function e(n) {
  var o = LongBits$1.from(n).zzEncode();
  return this._push(writeVarint64, o.length(), o);
};
Writer$1.prototype.bool = function e(n) {
  return this._push(writeByte, 1, n ? 1 : 0);
};
function writeFixed32(e, n, o) {
  n[o] = e & 255, n[o + 1] = e >>> 8 & 255, n[o + 2] = e >>> 16 & 255, n[o + 3] = e >>> 24;
}
Writer$1.prototype.fixed32 = function e(n) {
  return this._push(writeFixed32, 4, n >>> 0);
};
Writer$1.prototype.sfixed32 = Writer$1.prototype.fixed32;
Writer$1.prototype.fixed64 = function e(n) {
  var o = LongBits$1.from(n);
  return this._push(writeFixed32, 4, o.lo)._push(writeFixed32, 4, o.hi);
};
Writer$1.prototype.sfixed64 = Writer$1.prototype.fixed64;
Writer$1.prototype.float = function e(n) {
  return this._push(util$4.float.writeFloatLE, 4, n);
};
Writer$1.prototype.double = function e(n) {
  return this._push(util$4.float.writeDoubleLE, 8, n);
};
var writeBytes = util$4.Array.prototype.set ? function e(n, o, u) {
  o.set(n, u);
} : function e(n, o, u) {
  for (var c = 0; c < n.length; ++c)
    o[u + c] = n[c];
};
Writer$1.prototype.bytes = function e(n) {
  var o = n.length >>> 0;
  if (!o)
    return this._push(writeByte, 1, 0);
  if (util$4.isString(n)) {
    var u = Writer$1.alloc(o = base64$4.length(n));
    base64$4.decode(n, u, 0), n = u;
  }
  return this.uint32(o)._push(writeBytes, o, n);
};
Writer$1.prototype.string = function e(n) {
  var o = utf8$5.length(n);
  return o ? this.uint32(o)._push(utf8$5.write, o, n) : this._push(writeByte, 1, 0);
};
Writer$1.prototype.fork = function e() {
  return this.states = new State$2(this), this.head = this.tail = new Op(noop$5, 0, 0), this.len = 0, this;
};
Writer$1.prototype.reset = function e() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(noop$5, 0, 0), this.len = 0), this;
};
Writer$1.prototype.ldelim = function e() {
  var n = this.head, o = this.tail, u = this.len;
  return this.reset().uint32(u), u && (this.tail.next = n.next, this.tail = o, this.len += u), this;
};
Writer$1.prototype.finish = function e() {
  for (var n = this.head.next, o = this.constructor.alloc(this.len), u = 0; n; )
    n.fn(n.val, o, u), u += n.len, n = n.next;
  return o;
};
Writer$1._configure = function(e) {
  BufferWriter$1 = e, Writer$1.create = create$1(), BufferWriter$1._configure();
};
var writer_buffer = BufferWriter, Writer = writer;
(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
var util$3 = requireMinimal();
function BufferWriter() {
  Writer.call(this);
}
BufferWriter._configure = function() {
  BufferWriter.alloc = util$3._Buffer_allocUnsafe, BufferWriter.writeBytesBuffer = util$3.Buffer && util$3.Buffer.prototype instanceof Uint8Array && util$3.Buffer.prototype.set.name === "set" ? function(n, o, u) {
    o.set(n, u);
  } : function(n, o, u) {
    if (n.copy)
      n.copy(o, u, 0, n.length);
    else
      for (var c = 0; c < n.length; )
        o[u++] = n[c++];
  };
};
BufferWriter.prototype.bytes = function e(n) {
  util$3.isString(n) && (n = util$3._Buffer_from(n, "base64"));
  var o = n.length >>> 0;
  return this.uint32(o), o && this._push(BufferWriter.writeBytesBuffer, o, n), this;
};
function writeStringBuffer(e, n, o) {
  e.length < 40 ? util$3.utf8.write(e, n, o) : n.utf8Write ? n.utf8Write(e, o) : n.write(e, o);
}
BufferWriter.prototype.string = function e(n) {
  var o = util$3.Buffer.byteLength(n);
  return this.uint32(o), o && this._push(writeStringBuffer, o, n), this;
};
BufferWriter._configure();
var reader = Reader$1, util$2 = requireMinimal(), BufferReader$1, LongBits = util$2.LongBits, utf8$4 = util$2.utf8;
function indexOutOfRange(e, n) {
  return RangeError("index out of range: " + e.pos + " + " + (n || 1) + " > " + e.len);
}
function Reader$1(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}
var create_array = typeof Uint8Array < "u" ? function e(n) {
  if (n instanceof Uint8Array || Array.isArray(n))
    return new Reader$1(n);
  throw Error("illegal buffer");
} : function e(n) {
  if (Array.isArray(n))
    return new Reader$1(n);
  throw Error("illegal buffer");
}, create = function e() {
  return util$2.Buffer ? function(o) {
    return (Reader$1.create = function(c) {
      return util$2.Buffer.isBuffer(c) ? new BufferReader$1(c) : create_array(c);
    })(o);
  } : create_array;
};
Reader$1.create = create();
Reader$1.prototype._slice = util$2.Array.prototype.subarray || /* istanbul ignore next */
util$2.Array.prototype.slice;
Reader$1.prototype.uint32 = function e() {
  var n = 4294967295;
  return function() {
    if (n = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (n = (n | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (n = (n | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (n = (n | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (n = (n | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return n;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange(this, 10);
    return n;
  };
}();
Reader$1.prototype.int32 = function e() {
  return this.uint32() | 0;
};
Reader$1.prototype.sint32 = function e() {
  var n = this.uint32();
  return n >>> 1 ^ -(n & 1) | 0;
};
function readLongVarint() {
  var e = new LongBits(0, 0), n = 0;
  if (this.len - this.pos > 4) {
    for (; n < 4; ++n)
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << n * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return e;
    n = 0;
  } else {
    for (; n < 3; ++n) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (e.lo = (e.lo | (this.buf[this.pos] & 127) << n * 7) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
    return e.lo = (e.lo | (this.buf[this.pos++] & 127) << n * 7) >>> 0, e;
  }
  if (this.len - this.pos > 4) {
    for (; n < 5; ++n)
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << n * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
  } else
    for (; n < 5; ++n) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (e.hi = (e.hi | (this.buf[this.pos] & 127) << n * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return e;
    }
  throw Error("invalid varint encoding");
}
Reader$1.prototype.bool = function e() {
  return this.uint32() !== 0;
};
function readFixed32_end(e, n) {
  return (e[n - 4] | e[n - 3] << 8 | e[n - 2] << 16 | e[n - 1] << 24) >>> 0;
}
Reader$1.prototype.fixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4);
};
Reader$1.prototype.sfixed32 = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4) | 0;
};
function readFixed64() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 8);
  return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
Reader$1.prototype.float = function e() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  var n = util$2.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, n;
};
Reader$1.prototype.double = function e() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 4);
  var n = util$2.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, n;
};
Reader$1.prototype.bytes = function e() {
  var n = this.uint32(), o = this.pos, u = this.pos + n;
  if (u > this.len)
    throw indexOutOfRange(this, n);
  return this.pos += n, Array.isArray(this.buf) ? this.buf.slice(o, u) : o === u ? new this.buf.constructor(0) : this._slice.call(this.buf, o, u);
};
Reader$1.prototype.string = function e() {
  var n = this.bytes();
  return utf8$4.read(n, 0, n.length);
};
Reader$1.prototype.skip = function e(n) {
  if (typeof n == "number") {
    if (this.pos + n > this.len)
      throw indexOutOfRange(this, n);
    this.pos += n;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$1.prototype.skipType = function(e) {
  switch (e) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (e = this.uint32() & 7) !== 4; )
        this.skipType(e);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);
  }
  return this;
};
Reader$1._configure = function(e) {
  BufferReader$1 = e, Reader$1.create = create(), BufferReader$1._configure();
  var n = util$2.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$2.merge(Reader$1.prototype, {
    int64: function() {
      return readLongVarint.call(this)[n](!1);
    },
    uint64: function() {
      return readLongVarint.call(this)[n](!0);
    },
    sint64: function() {
      return readLongVarint.call(this).zzDecode()[n](!1);
    },
    fixed64: function() {
      return readFixed64.call(this)[n](!0);
    },
    sfixed64: function() {
      return readFixed64.call(this)[n](!1);
    }
  });
};
var reader_buffer = BufferReader, Reader = reader;
(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
var util$1 = requireMinimal();
function BufferReader(e) {
  Reader.call(this, e);
}
BufferReader._configure = function() {
  util$1.Buffer && (BufferReader.prototype._slice = util$1.Buffer.prototype.slice);
};
BufferReader.prototype.string = function e() {
  var n = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + n, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + n, this.len));
};
BufferReader._configure();
var rpc = {}, service$1 = Service, util = requireMinimal();
(Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
function Service(e, n, o) {
  if (typeof e != "function")
    throw TypeError("rpcImpl must be a function");
  util.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!n, this.responseDelimited = !!o;
}
Service.prototype.rpcCall = function e(n, o, u, c, d) {
  if (!c)
    throw TypeError("request must be specified");
  var m = this;
  if (!d)
    return util.asPromise(e, m, n, o, u, c);
  if (!m.rpcImpl) {
    setTimeout(function() {
      d(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return m.rpcImpl(
      n,
      o[m.requestDelimited ? "encodeDelimited" : "encode"](c).finish(),
      function(S, $) {
        if (S)
          return m.emit("error", S, n), d(S);
        if ($ === null) {
          m.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!($ instanceof u))
          try {
            $ = u[m.responseDelimited ? "decodeDelimited" : "decode"]($);
          } catch (E) {
            return m.emit("error", E, n), d(E);
          }
        return m.emit("data", $, n), d(null, $);
      }
    );
  } catch (v) {
    m.emit("error", v, n), setTimeout(function() {
      d(v);
    }, 0);
    return;
  }
};
Service.prototype.end = function e(n) {
  return this.rpcImpl && (n || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(e) {
  var n = e;
  n.Service = service$1;
})(rpc);
var roots = {};
(function(e) {
  var n = e;
  n.build = "minimal", n.Writer = writer, n.BufferWriter = writer_buffer, n.Reader = reader, n.BufferReader = reader_buffer, n.util = requireMinimal(), n.rpc = rpc, n.roots = roots, n.configure = o;
  function o() {
    n.util._configure(), n.Writer._configure(n.BufferWriter), n.Reader._configure(n.BufferReader);
  }
  o();
})(indexMinimal);
var minimal = indexMinimal, $protobuf = minimal, $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util, $root = $protobuf.roots.default || ($protobuf.roots.default = {});
$root.ics23 = function() {
  var e = {};
  return e.HashOp = function() {
    var n = {}, o = Object.create(n);
    return o[n[0] = "NO_HASH"] = 0, o[n[1] = "SHA256"] = 1, o[n[2] = "SHA512"] = 2, o[n[3] = "KECCAK"] = 3, o[n[4] = "RIPEMD160"] = 4, o[n[5] = "BITCOIN"] = 5, o[n[6] = "SHA512_256"] = 6, o;
  }(), e.LengthOp = function() {
    var n = {}, o = Object.create(n);
    return o[n[0] = "NO_PREFIX"] = 0, o[n[1] = "VAR_PROTO"] = 1, o[n[2] = "VAR_RLP"] = 2, o[n[3] = "FIXED32_BIG"] = 3, o[n[4] = "FIXED32_LITTLE"] = 4, o[n[5] = "FIXED64_BIG"] = 5, o[n[6] = "FIXED64_LITTLE"] = 6, o[n[7] = "REQUIRE_32_BYTES"] = 7, o[n[8] = "REQUIRE_64_BYTES"] = 8, o;
  }(), e.ExistenceProof = function() {
    function n(o) {
      if (this.path = [], o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.key = $util.newBuffer([]), n.prototype.value = $util.newBuffer([]), n.prototype.leaf = null, n.prototype.path = $util.emptyArray, n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      if (c || (c = $Writer.create()), u.key != null && u.hasOwnProperty("key") && c.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(u.key), u.value != null && u.hasOwnProperty("value") && c.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(u.value), u.leaf != null && u.hasOwnProperty("leaf") && $root.ics23.LeafOp.encode(u.leaf, c.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), u.path != null && u.path.length)
        for (var d = 0; d < u.path.length; ++d)
          $root.ics23.InnerOp.encode(u.path[d], c.uint32(
            /* id 4, wireType 2 =*/
            34
          ).fork()).ldelim();
      return c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.ExistenceProof(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.key = u.bytes();
            break;
          case 2:
            m.value = u.bytes();
            break;
          case 3:
            m.leaf = $root.ics23.LeafOp.decode(u, u.uint32());
            break;
          case 4:
            m.path && m.path.length || (m.path = []), m.path.push($root.ics23.InnerOp.decode(u, u.uint32()));
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.key != null && u.hasOwnProperty("key") && !(u.key && typeof u.key.length == "number" || $util.isString(u.key)))
        return "key: buffer expected";
      if (u.value != null && u.hasOwnProperty("value") && !(u.value && typeof u.value.length == "number" || $util.isString(u.value)))
        return "value: buffer expected";
      if (u.leaf != null && u.hasOwnProperty("leaf")) {
        var c = $root.ics23.LeafOp.verify(u.leaf);
        if (c)
          return "leaf." + c;
      }
      if (u.path != null && u.hasOwnProperty("path")) {
        if (!Array.isArray(u.path))
          return "path: array expected";
        for (var d = 0; d < u.path.length; ++d) {
          var c = $root.ics23.InnerOp.verify(u.path[d]);
          if (c)
            return "path." + c;
        }
      }
      return null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.ExistenceProof)
        return u;
      var c = new $root.ics23.ExistenceProof();
      if (u.key != null && (typeof u.key == "string" ? $util.base64.decode(u.key, c.key = $util.newBuffer($util.base64.length(u.key)), 0) : u.key.length && (c.key = u.key)), u.value != null && (typeof u.value == "string" ? $util.base64.decode(u.value, c.value = $util.newBuffer($util.base64.length(u.value)), 0) : u.value.length && (c.value = u.value)), u.leaf != null) {
        if (typeof u.leaf != "object")
          throw TypeError(".ics23.ExistenceProof.leaf: object expected");
        c.leaf = $root.ics23.LeafOp.fromObject(u.leaf);
      }
      if (u.path) {
        if (!Array.isArray(u.path))
          throw TypeError(".ics23.ExistenceProof.path: array expected");
        c.path = [];
        for (var d = 0; d < u.path.length; ++d) {
          if (typeof u.path[d] != "object")
            throw TypeError(".ics23.ExistenceProof.path: object expected");
          c.path[d] = $root.ics23.InnerOp.fromObject(u.path[d]);
        }
      }
      return c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      if ((c.arrays || c.defaults) && (d.path = []), c.defaults && (c.bytes === String ? d.key = "" : (d.key = [], c.bytes !== Array && (d.key = $util.newBuffer(d.key))), c.bytes === String ? d.value = "" : (d.value = [], c.bytes !== Array && (d.value = $util.newBuffer(d.value))), d.leaf = null), u.key != null && u.hasOwnProperty("key") && (d.key = c.bytes === String ? $util.base64.encode(u.key, 0, u.key.length) : c.bytes === Array ? Array.prototype.slice.call(u.key) : u.key), u.value != null && u.hasOwnProperty("value") && (d.value = c.bytes === String ? $util.base64.encode(u.value, 0, u.value.length) : c.bytes === Array ? Array.prototype.slice.call(u.value) : u.value), u.leaf != null && u.hasOwnProperty("leaf") && (d.leaf = $root.ics23.LeafOp.toObject(u.leaf, c)), u.path && u.path.length) {
        d.path = [];
        for (var m = 0; m < u.path.length; ++m)
          d.path[m] = $root.ics23.InnerOp.toObject(u.path[m], c);
      }
      return d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.NonExistenceProof = function() {
    function n(o) {
      if (o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.key = $util.newBuffer([]), n.prototype.left = null, n.prototype.right = null, n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      return c || (c = $Writer.create()), u.key != null && u.hasOwnProperty("key") && c.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(u.key), u.left != null && u.hasOwnProperty("left") && $root.ics23.ExistenceProof.encode(u.left, c.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), u.right != null && u.hasOwnProperty("right") && $root.ics23.ExistenceProof.encode(u.right, c.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.NonExistenceProof(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.key = u.bytes();
            break;
          case 2:
            m.left = $root.ics23.ExistenceProof.decode(u, u.uint32());
            break;
          case 3:
            m.right = $root.ics23.ExistenceProof.decode(u, u.uint32());
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.key != null && u.hasOwnProperty("key") && !(u.key && typeof u.key.length == "number" || $util.isString(u.key)))
        return "key: buffer expected";
      if (u.left != null && u.hasOwnProperty("left")) {
        var c = $root.ics23.ExistenceProof.verify(u.left);
        if (c)
          return "left." + c;
      }
      if (u.right != null && u.hasOwnProperty("right")) {
        var c = $root.ics23.ExistenceProof.verify(u.right);
        if (c)
          return "right." + c;
      }
      return null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.NonExistenceProof)
        return u;
      var c = new $root.ics23.NonExistenceProof();
      if (u.key != null && (typeof u.key == "string" ? $util.base64.decode(u.key, c.key = $util.newBuffer($util.base64.length(u.key)), 0) : u.key.length && (c.key = u.key)), u.left != null) {
        if (typeof u.left != "object")
          throw TypeError(".ics23.NonExistenceProof.left: object expected");
        c.left = $root.ics23.ExistenceProof.fromObject(u.left);
      }
      if (u.right != null) {
        if (typeof u.right != "object")
          throw TypeError(".ics23.NonExistenceProof.right: object expected");
        c.right = $root.ics23.ExistenceProof.fromObject(u.right);
      }
      return c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      return c.defaults && (c.bytes === String ? d.key = "" : (d.key = [], c.bytes !== Array && (d.key = $util.newBuffer(d.key))), d.left = null, d.right = null), u.key != null && u.hasOwnProperty("key") && (d.key = c.bytes === String ? $util.base64.encode(u.key, 0, u.key.length) : c.bytes === Array ? Array.prototype.slice.call(u.key) : u.key), u.left != null && u.hasOwnProperty("left") && (d.left = $root.ics23.ExistenceProof.toObject(u.left, c)), u.right != null && u.hasOwnProperty("right") && (d.right = $root.ics23.ExistenceProof.toObject(u.right, c)), d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.CommitmentProof = function() {
    function n(u) {
      if (u)
        for (var c = Object.keys(u), d = 0; d < c.length; ++d)
          u[c[d]] != null && (this[c[d]] = u[c[d]]);
    }
    n.prototype.exist = null, n.prototype.nonexist = null, n.prototype.batch = null, n.prototype.compressed = null;
    var o;
    return Object.defineProperty(n.prototype, "proof", {
      get: $util.oneOfGetter(o = ["exist", "nonexist", "batch", "compressed"]),
      set: $util.oneOfSetter(o)
    }), n.create = function(c) {
      return new n(c);
    }, n.encode = function(c, d) {
      return d || (d = $Writer.create()), c.exist != null && c.hasOwnProperty("exist") && $root.ics23.ExistenceProof.encode(c.exist, d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), c.nonexist != null && c.hasOwnProperty("nonexist") && $root.ics23.NonExistenceProof.encode(c.nonexist, d.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), c.batch != null && c.hasOwnProperty("batch") && $root.ics23.BatchProof.encode(c.batch, d.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), c.compressed != null && c.hasOwnProperty("compressed") && $root.ics23.CompressedBatchProof.encode(c.compressed, d.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), d;
    }, n.encodeDelimited = function(c, d) {
      return this.encode(c, d).ldelim();
    }, n.decode = function(c, d) {
      c instanceof $Reader || (c = $Reader.create(c));
      for (var m = d === void 0 ? c.len : c.pos + d, v = new $root.ics23.CommitmentProof(); c.pos < m; ) {
        var S = c.uint32();
        switch (S >>> 3) {
          case 1:
            v.exist = $root.ics23.ExistenceProof.decode(c, c.uint32());
            break;
          case 2:
            v.nonexist = $root.ics23.NonExistenceProof.decode(c, c.uint32());
            break;
          case 3:
            v.batch = $root.ics23.BatchProof.decode(c, c.uint32());
            break;
          case 4:
            v.compressed = $root.ics23.CompressedBatchProof.decode(c, c.uint32());
            break;
          default:
            c.skipType(S & 7);
            break;
        }
      }
      return v;
    }, n.decodeDelimited = function(c) {
      return c instanceof $Reader || (c = new $Reader(c)), this.decode(c, c.uint32());
    }, n.verify = function(c) {
      if (typeof c != "object" || c === null)
        return "object expected";
      var d = {};
      if (c.exist != null && c.hasOwnProperty("exist")) {
        d.proof = 1;
        {
          var m = $root.ics23.ExistenceProof.verify(c.exist);
          if (m)
            return "exist." + m;
        }
      }
      if (c.nonexist != null && c.hasOwnProperty("nonexist")) {
        if (d.proof === 1)
          return "proof: multiple values";
        d.proof = 1;
        {
          var m = $root.ics23.NonExistenceProof.verify(c.nonexist);
          if (m)
            return "nonexist." + m;
        }
      }
      if (c.batch != null && c.hasOwnProperty("batch")) {
        if (d.proof === 1)
          return "proof: multiple values";
        d.proof = 1;
        {
          var m = $root.ics23.BatchProof.verify(c.batch);
          if (m)
            return "batch." + m;
        }
      }
      if (c.compressed != null && c.hasOwnProperty("compressed")) {
        if (d.proof === 1)
          return "proof: multiple values";
        d.proof = 1;
        {
          var m = $root.ics23.CompressedBatchProof.verify(c.compressed);
          if (m)
            return "compressed." + m;
        }
      }
      return null;
    }, n.fromObject = function(c) {
      if (c instanceof $root.ics23.CommitmentProof)
        return c;
      var d = new $root.ics23.CommitmentProof();
      if (c.exist != null) {
        if (typeof c.exist != "object")
          throw TypeError(".ics23.CommitmentProof.exist: object expected");
        d.exist = $root.ics23.ExistenceProof.fromObject(c.exist);
      }
      if (c.nonexist != null) {
        if (typeof c.nonexist != "object")
          throw TypeError(".ics23.CommitmentProof.nonexist: object expected");
        d.nonexist = $root.ics23.NonExistenceProof.fromObject(c.nonexist);
      }
      if (c.batch != null) {
        if (typeof c.batch != "object")
          throw TypeError(".ics23.CommitmentProof.batch: object expected");
        d.batch = $root.ics23.BatchProof.fromObject(c.batch);
      }
      if (c.compressed != null) {
        if (typeof c.compressed != "object")
          throw TypeError(".ics23.CommitmentProof.compressed: object expected");
        d.compressed = $root.ics23.CompressedBatchProof.fromObject(c.compressed);
      }
      return d;
    }, n.toObject = function(c, d) {
      d || (d = {});
      var m = {};
      return c.exist != null && c.hasOwnProperty("exist") && (m.exist = $root.ics23.ExistenceProof.toObject(c.exist, d), d.oneofs && (m.proof = "exist")), c.nonexist != null && c.hasOwnProperty("nonexist") && (m.nonexist = $root.ics23.NonExistenceProof.toObject(c.nonexist, d), d.oneofs && (m.proof = "nonexist")), c.batch != null && c.hasOwnProperty("batch") && (m.batch = $root.ics23.BatchProof.toObject(c.batch, d), d.oneofs && (m.proof = "batch")), c.compressed != null && c.hasOwnProperty("compressed") && (m.compressed = $root.ics23.CompressedBatchProof.toObject(c.compressed, d), d.oneofs && (m.proof = "compressed")), m;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.LeafOp = function() {
    function n(o) {
      if (o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.hash = 0, n.prototype.prehashKey = 0, n.prototype.prehashValue = 0, n.prototype.length = 0, n.prototype.prefix = $util.newBuffer([]), n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      return c || (c = $Writer.create()), u.hash != null && u.hasOwnProperty("hash") && c.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(u.hash), u.prehashKey != null && u.hasOwnProperty("prehashKey") && c.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(u.prehashKey), u.prehashValue != null && u.hasOwnProperty("prehashValue") && c.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(u.prehashValue), u.length != null && u.hasOwnProperty("length") && c.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(u.length), u.prefix != null && u.hasOwnProperty("prefix") && c.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(u.prefix), c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.LeafOp(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.hash = u.int32();
            break;
          case 2:
            m.prehashKey = u.int32();
            break;
          case 3:
            m.prehashValue = u.int32();
            break;
          case 4:
            m.length = u.int32();
            break;
          case 5:
            m.prefix = u.bytes();
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.hash != null && u.hasOwnProperty("hash"))
        switch (u.hash) {
          default:
            return "hash: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (u.prehashKey != null && u.hasOwnProperty("prehashKey"))
        switch (u.prehashKey) {
          default:
            return "prehashKey: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (u.prehashValue != null && u.hasOwnProperty("prehashValue"))
        switch (u.prehashValue) {
          default:
            return "prehashValue: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (u.length != null && u.hasOwnProperty("length"))
        switch (u.length) {
          default:
            return "length: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
            break;
        }
      return u.prefix != null && u.hasOwnProperty("prefix") && !(u.prefix && typeof u.prefix.length == "number" || $util.isString(u.prefix)) ? "prefix: buffer expected" : null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.LeafOp)
        return u;
      var c = new $root.ics23.LeafOp();
      switch (u.hash) {
        case "NO_HASH":
        case 0:
          c.hash = 0;
          break;
        case "SHA256":
        case 1:
          c.hash = 1;
          break;
        case "SHA512":
        case 2:
          c.hash = 2;
          break;
        case "KECCAK":
        case 3:
          c.hash = 3;
          break;
        case "RIPEMD160":
        case 4:
          c.hash = 4;
          break;
        case "BITCOIN":
        case 5:
          c.hash = 5;
          break;
        case "SHA512_256":
        case 6:
          c.hash = 6;
          break;
      }
      switch (u.prehashKey) {
        case "NO_HASH":
        case 0:
          c.prehashKey = 0;
          break;
        case "SHA256":
        case 1:
          c.prehashKey = 1;
          break;
        case "SHA512":
        case 2:
          c.prehashKey = 2;
          break;
        case "KECCAK":
        case 3:
          c.prehashKey = 3;
          break;
        case "RIPEMD160":
        case 4:
          c.prehashKey = 4;
          break;
        case "BITCOIN":
        case 5:
          c.prehashKey = 5;
          break;
        case "SHA512_256":
        case 6:
          c.prehashKey = 6;
          break;
      }
      switch (u.prehashValue) {
        case "NO_HASH":
        case 0:
          c.prehashValue = 0;
          break;
        case "SHA256":
        case 1:
          c.prehashValue = 1;
          break;
        case "SHA512":
        case 2:
          c.prehashValue = 2;
          break;
        case "KECCAK":
        case 3:
          c.prehashValue = 3;
          break;
        case "RIPEMD160":
        case 4:
          c.prehashValue = 4;
          break;
        case "BITCOIN":
        case 5:
          c.prehashValue = 5;
          break;
        case "SHA512_256":
        case 6:
          c.prehashValue = 6;
          break;
      }
      switch (u.length) {
        case "NO_PREFIX":
        case 0:
          c.length = 0;
          break;
        case "VAR_PROTO":
        case 1:
          c.length = 1;
          break;
        case "VAR_RLP":
        case 2:
          c.length = 2;
          break;
        case "FIXED32_BIG":
        case 3:
          c.length = 3;
          break;
        case "FIXED32_LITTLE":
        case 4:
          c.length = 4;
          break;
        case "FIXED64_BIG":
        case 5:
          c.length = 5;
          break;
        case "FIXED64_LITTLE":
        case 6:
          c.length = 6;
          break;
        case "REQUIRE_32_BYTES":
        case 7:
          c.length = 7;
          break;
        case "REQUIRE_64_BYTES":
        case 8:
          c.length = 8;
          break;
      }
      return u.prefix != null && (typeof u.prefix == "string" ? $util.base64.decode(u.prefix, c.prefix = $util.newBuffer($util.base64.length(u.prefix)), 0) : u.prefix.length && (c.prefix = u.prefix)), c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      return c.defaults && (d.hash = c.enums === String ? "NO_HASH" : 0, d.prehashKey = c.enums === String ? "NO_HASH" : 0, d.prehashValue = c.enums === String ? "NO_HASH" : 0, d.length = c.enums === String ? "NO_PREFIX" : 0, c.bytes === String ? d.prefix = "" : (d.prefix = [], c.bytes !== Array && (d.prefix = $util.newBuffer(d.prefix)))), u.hash != null && u.hasOwnProperty("hash") && (d.hash = c.enums === String ? $root.ics23.HashOp[u.hash] : u.hash), u.prehashKey != null && u.hasOwnProperty("prehashKey") && (d.prehashKey = c.enums === String ? $root.ics23.HashOp[u.prehashKey] : u.prehashKey), u.prehashValue != null && u.hasOwnProperty("prehashValue") && (d.prehashValue = c.enums === String ? $root.ics23.HashOp[u.prehashValue] : u.prehashValue), u.length != null && u.hasOwnProperty("length") && (d.length = c.enums === String ? $root.ics23.LengthOp[u.length] : u.length), u.prefix != null && u.hasOwnProperty("prefix") && (d.prefix = c.bytes === String ? $util.base64.encode(u.prefix, 0, u.prefix.length) : c.bytes === Array ? Array.prototype.slice.call(u.prefix) : u.prefix), d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.InnerOp = function() {
    function n(o) {
      if (o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.hash = 0, n.prototype.prefix = $util.newBuffer([]), n.prototype.suffix = $util.newBuffer([]), n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      return c || (c = $Writer.create()), u.hash != null && u.hasOwnProperty("hash") && c.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(u.hash), u.prefix != null && u.hasOwnProperty("prefix") && c.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(u.prefix), u.suffix != null && u.hasOwnProperty("suffix") && c.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(u.suffix), c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.InnerOp(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.hash = u.int32();
            break;
          case 2:
            m.prefix = u.bytes();
            break;
          case 3:
            m.suffix = u.bytes();
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.hash != null && u.hasOwnProperty("hash"))
        switch (u.hash) {
          default:
            return "hash: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      return u.prefix != null && u.hasOwnProperty("prefix") && !(u.prefix && typeof u.prefix.length == "number" || $util.isString(u.prefix)) ? "prefix: buffer expected" : u.suffix != null && u.hasOwnProperty("suffix") && !(u.suffix && typeof u.suffix.length == "number" || $util.isString(u.suffix)) ? "suffix: buffer expected" : null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.InnerOp)
        return u;
      var c = new $root.ics23.InnerOp();
      switch (u.hash) {
        case "NO_HASH":
        case 0:
          c.hash = 0;
          break;
        case "SHA256":
        case 1:
          c.hash = 1;
          break;
        case "SHA512":
        case 2:
          c.hash = 2;
          break;
        case "KECCAK":
        case 3:
          c.hash = 3;
          break;
        case "RIPEMD160":
        case 4:
          c.hash = 4;
          break;
        case "BITCOIN":
        case 5:
          c.hash = 5;
          break;
        case "SHA512_256":
        case 6:
          c.hash = 6;
          break;
      }
      return u.prefix != null && (typeof u.prefix == "string" ? $util.base64.decode(u.prefix, c.prefix = $util.newBuffer($util.base64.length(u.prefix)), 0) : u.prefix.length && (c.prefix = u.prefix)), u.suffix != null && (typeof u.suffix == "string" ? $util.base64.decode(u.suffix, c.suffix = $util.newBuffer($util.base64.length(u.suffix)), 0) : u.suffix.length && (c.suffix = u.suffix)), c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      return c.defaults && (d.hash = c.enums === String ? "NO_HASH" : 0, c.bytes === String ? d.prefix = "" : (d.prefix = [], c.bytes !== Array && (d.prefix = $util.newBuffer(d.prefix))), c.bytes === String ? d.suffix = "" : (d.suffix = [], c.bytes !== Array && (d.suffix = $util.newBuffer(d.suffix)))), u.hash != null && u.hasOwnProperty("hash") && (d.hash = c.enums === String ? $root.ics23.HashOp[u.hash] : u.hash), u.prefix != null && u.hasOwnProperty("prefix") && (d.prefix = c.bytes === String ? $util.base64.encode(u.prefix, 0, u.prefix.length) : c.bytes === Array ? Array.prototype.slice.call(u.prefix) : u.prefix), u.suffix != null && u.hasOwnProperty("suffix") && (d.suffix = c.bytes === String ? $util.base64.encode(u.suffix, 0, u.suffix.length) : c.bytes === Array ? Array.prototype.slice.call(u.suffix) : u.suffix), d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.ProofSpec = function() {
    function n(o) {
      if (o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.leafSpec = null, n.prototype.innerSpec = null, n.prototype.maxDepth = 0, n.prototype.minDepth = 0, n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      return c || (c = $Writer.create()), u.leafSpec != null && u.hasOwnProperty("leafSpec") && $root.ics23.LeafOp.encode(u.leafSpec, c.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), u.innerSpec != null && u.hasOwnProperty("innerSpec") && $root.ics23.InnerSpec.encode(u.innerSpec, c.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), u.maxDepth != null && u.hasOwnProperty("maxDepth") && c.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(u.maxDepth), u.minDepth != null && u.hasOwnProperty("minDepth") && c.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(u.minDepth), c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.ProofSpec(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.leafSpec = $root.ics23.LeafOp.decode(u, u.uint32());
            break;
          case 2:
            m.innerSpec = $root.ics23.InnerSpec.decode(u, u.uint32());
            break;
          case 3:
            m.maxDepth = u.int32();
            break;
          case 4:
            m.minDepth = u.int32();
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.leafSpec != null && u.hasOwnProperty("leafSpec")) {
        var c = $root.ics23.LeafOp.verify(u.leafSpec);
        if (c)
          return "leafSpec." + c;
      }
      if (u.innerSpec != null && u.hasOwnProperty("innerSpec")) {
        var c = $root.ics23.InnerSpec.verify(u.innerSpec);
        if (c)
          return "innerSpec." + c;
      }
      return u.maxDepth != null && u.hasOwnProperty("maxDepth") && !$util.isInteger(u.maxDepth) ? "maxDepth: integer expected" : u.minDepth != null && u.hasOwnProperty("minDepth") && !$util.isInteger(u.minDepth) ? "minDepth: integer expected" : null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.ProofSpec)
        return u;
      var c = new $root.ics23.ProofSpec();
      if (u.leafSpec != null) {
        if (typeof u.leafSpec != "object")
          throw TypeError(".ics23.ProofSpec.leafSpec: object expected");
        c.leafSpec = $root.ics23.LeafOp.fromObject(u.leafSpec);
      }
      if (u.innerSpec != null) {
        if (typeof u.innerSpec != "object")
          throw TypeError(".ics23.ProofSpec.innerSpec: object expected");
        c.innerSpec = $root.ics23.InnerSpec.fromObject(u.innerSpec);
      }
      return u.maxDepth != null && (c.maxDepth = u.maxDepth | 0), u.minDepth != null && (c.minDepth = u.minDepth | 0), c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      return c.defaults && (d.leafSpec = null, d.innerSpec = null, d.maxDepth = 0, d.minDepth = 0), u.leafSpec != null && u.hasOwnProperty("leafSpec") && (d.leafSpec = $root.ics23.LeafOp.toObject(u.leafSpec, c)), u.innerSpec != null && u.hasOwnProperty("innerSpec") && (d.innerSpec = $root.ics23.InnerSpec.toObject(u.innerSpec, c)), u.maxDepth != null && u.hasOwnProperty("maxDepth") && (d.maxDepth = u.maxDepth), u.minDepth != null && u.hasOwnProperty("minDepth") && (d.minDepth = u.minDepth), d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.InnerSpec = function() {
    function n(o) {
      if (this.childOrder = [], o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.childOrder = $util.emptyArray, n.prototype.childSize = 0, n.prototype.minPrefixLength = 0, n.prototype.maxPrefixLength = 0, n.prototype.emptyChild = $util.newBuffer([]), n.prototype.hash = 0, n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      if (c || (c = $Writer.create()), u.childOrder != null && u.childOrder.length) {
        c.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork();
        for (var d = 0; d < u.childOrder.length; ++d)
          c.int32(u.childOrder[d]);
        c.ldelim();
      }
      return u.childSize != null && u.hasOwnProperty("childSize") && c.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(u.childSize), u.minPrefixLength != null && u.hasOwnProperty("minPrefixLength") && c.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(u.minPrefixLength), u.maxPrefixLength != null && u.hasOwnProperty("maxPrefixLength") && c.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(u.maxPrefixLength), u.emptyChild != null && u.hasOwnProperty("emptyChild") && c.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(u.emptyChild), u.hash != null && u.hasOwnProperty("hash") && c.uint32(
        /* id 6, wireType 0 =*/
        48
      ).int32(u.hash), c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.InnerSpec(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            if (m.childOrder && m.childOrder.length || (m.childOrder = []), (v & 7) === 2)
              for (var S = u.uint32() + u.pos; u.pos < S; )
                m.childOrder.push(u.int32());
            else
              m.childOrder.push(u.int32());
            break;
          case 2:
            m.childSize = u.int32();
            break;
          case 3:
            m.minPrefixLength = u.int32();
            break;
          case 4:
            m.maxPrefixLength = u.int32();
            break;
          case 5:
            m.emptyChild = u.bytes();
            break;
          case 6:
            m.hash = u.int32();
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.childOrder != null && u.hasOwnProperty("childOrder")) {
        if (!Array.isArray(u.childOrder))
          return "childOrder: array expected";
        for (var c = 0; c < u.childOrder.length; ++c)
          if (!$util.isInteger(u.childOrder[c]))
            return "childOrder: integer[] expected";
      }
      if (u.childSize != null && u.hasOwnProperty("childSize") && !$util.isInteger(u.childSize))
        return "childSize: integer expected";
      if (u.minPrefixLength != null && u.hasOwnProperty("minPrefixLength") && !$util.isInteger(u.minPrefixLength))
        return "minPrefixLength: integer expected";
      if (u.maxPrefixLength != null && u.hasOwnProperty("maxPrefixLength") && !$util.isInteger(u.maxPrefixLength))
        return "maxPrefixLength: integer expected";
      if (u.emptyChild != null && u.hasOwnProperty("emptyChild") && !(u.emptyChild && typeof u.emptyChild.length == "number" || $util.isString(u.emptyChild)))
        return "emptyChild: buffer expected";
      if (u.hash != null && u.hasOwnProperty("hash"))
        switch (u.hash) {
          default:
            return "hash: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      return null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.InnerSpec)
        return u;
      var c = new $root.ics23.InnerSpec();
      if (u.childOrder) {
        if (!Array.isArray(u.childOrder))
          throw TypeError(".ics23.InnerSpec.childOrder: array expected");
        c.childOrder = [];
        for (var d = 0; d < u.childOrder.length; ++d)
          c.childOrder[d] = u.childOrder[d] | 0;
      }
      switch (u.childSize != null && (c.childSize = u.childSize | 0), u.minPrefixLength != null && (c.minPrefixLength = u.minPrefixLength | 0), u.maxPrefixLength != null && (c.maxPrefixLength = u.maxPrefixLength | 0), u.emptyChild != null && (typeof u.emptyChild == "string" ? $util.base64.decode(u.emptyChild, c.emptyChild = $util.newBuffer($util.base64.length(u.emptyChild)), 0) : u.emptyChild.length && (c.emptyChild = u.emptyChild)), u.hash) {
        case "NO_HASH":
        case 0:
          c.hash = 0;
          break;
        case "SHA256":
        case 1:
          c.hash = 1;
          break;
        case "SHA512":
        case 2:
          c.hash = 2;
          break;
        case "KECCAK":
        case 3:
          c.hash = 3;
          break;
        case "RIPEMD160":
        case 4:
          c.hash = 4;
          break;
        case "BITCOIN":
        case 5:
          c.hash = 5;
          break;
        case "SHA512_256":
        case 6:
          c.hash = 6;
          break;
      }
      return c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      if ((c.arrays || c.defaults) && (d.childOrder = []), c.defaults && (d.childSize = 0, d.minPrefixLength = 0, d.maxPrefixLength = 0, c.bytes === String ? d.emptyChild = "" : (d.emptyChild = [], c.bytes !== Array && (d.emptyChild = $util.newBuffer(d.emptyChild))), d.hash = c.enums === String ? "NO_HASH" : 0), u.childOrder && u.childOrder.length) {
        d.childOrder = [];
        for (var m = 0; m < u.childOrder.length; ++m)
          d.childOrder[m] = u.childOrder[m];
      }
      return u.childSize != null && u.hasOwnProperty("childSize") && (d.childSize = u.childSize), u.minPrefixLength != null && u.hasOwnProperty("minPrefixLength") && (d.minPrefixLength = u.minPrefixLength), u.maxPrefixLength != null && u.hasOwnProperty("maxPrefixLength") && (d.maxPrefixLength = u.maxPrefixLength), u.emptyChild != null && u.hasOwnProperty("emptyChild") && (d.emptyChild = c.bytes === String ? $util.base64.encode(u.emptyChild, 0, u.emptyChild.length) : c.bytes === Array ? Array.prototype.slice.call(u.emptyChild) : u.emptyChild), u.hash != null && u.hasOwnProperty("hash") && (d.hash = c.enums === String ? $root.ics23.HashOp[u.hash] : u.hash), d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.BatchProof = function() {
    function n(o) {
      if (this.entries = [], o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.entries = $util.emptyArray, n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      if (c || (c = $Writer.create()), u.entries != null && u.entries.length)
        for (var d = 0; d < u.entries.length; ++d)
          $root.ics23.BatchEntry.encode(u.entries[d], c.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.BatchProof(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.entries && m.entries.length || (m.entries = []), m.entries.push($root.ics23.BatchEntry.decode(u, u.uint32()));
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.entries != null && u.hasOwnProperty("entries")) {
        if (!Array.isArray(u.entries))
          return "entries: array expected";
        for (var c = 0; c < u.entries.length; ++c) {
          var d = $root.ics23.BatchEntry.verify(u.entries[c]);
          if (d)
            return "entries." + d;
        }
      }
      return null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.BatchProof)
        return u;
      var c = new $root.ics23.BatchProof();
      if (u.entries) {
        if (!Array.isArray(u.entries))
          throw TypeError(".ics23.BatchProof.entries: array expected");
        c.entries = [];
        for (var d = 0; d < u.entries.length; ++d) {
          if (typeof u.entries[d] != "object")
            throw TypeError(".ics23.BatchProof.entries: object expected");
          c.entries[d] = $root.ics23.BatchEntry.fromObject(u.entries[d]);
        }
      }
      return c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      if ((c.arrays || c.defaults) && (d.entries = []), u.entries && u.entries.length) {
        d.entries = [];
        for (var m = 0; m < u.entries.length; ++m)
          d.entries[m] = $root.ics23.BatchEntry.toObject(u.entries[m], c);
      }
      return d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.BatchEntry = function() {
    function n(u) {
      if (u)
        for (var c = Object.keys(u), d = 0; d < c.length; ++d)
          u[c[d]] != null && (this[c[d]] = u[c[d]]);
    }
    n.prototype.exist = null, n.prototype.nonexist = null;
    var o;
    return Object.defineProperty(n.prototype, "proof", {
      get: $util.oneOfGetter(o = ["exist", "nonexist"]),
      set: $util.oneOfSetter(o)
    }), n.create = function(c) {
      return new n(c);
    }, n.encode = function(c, d) {
      return d || (d = $Writer.create()), c.exist != null && c.hasOwnProperty("exist") && $root.ics23.ExistenceProof.encode(c.exist, d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), c.nonexist != null && c.hasOwnProperty("nonexist") && $root.ics23.NonExistenceProof.encode(c.nonexist, d.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), d;
    }, n.encodeDelimited = function(c, d) {
      return this.encode(c, d).ldelim();
    }, n.decode = function(c, d) {
      c instanceof $Reader || (c = $Reader.create(c));
      for (var m = d === void 0 ? c.len : c.pos + d, v = new $root.ics23.BatchEntry(); c.pos < m; ) {
        var S = c.uint32();
        switch (S >>> 3) {
          case 1:
            v.exist = $root.ics23.ExistenceProof.decode(c, c.uint32());
            break;
          case 2:
            v.nonexist = $root.ics23.NonExistenceProof.decode(c, c.uint32());
            break;
          default:
            c.skipType(S & 7);
            break;
        }
      }
      return v;
    }, n.decodeDelimited = function(c) {
      return c instanceof $Reader || (c = new $Reader(c)), this.decode(c, c.uint32());
    }, n.verify = function(c) {
      if (typeof c != "object" || c === null)
        return "object expected";
      var d = {};
      if (c.exist != null && c.hasOwnProperty("exist")) {
        d.proof = 1;
        {
          var m = $root.ics23.ExistenceProof.verify(c.exist);
          if (m)
            return "exist." + m;
        }
      }
      if (c.nonexist != null && c.hasOwnProperty("nonexist")) {
        if (d.proof === 1)
          return "proof: multiple values";
        d.proof = 1;
        {
          var m = $root.ics23.NonExistenceProof.verify(c.nonexist);
          if (m)
            return "nonexist." + m;
        }
      }
      return null;
    }, n.fromObject = function(c) {
      if (c instanceof $root.ics23.BatchEntry)
        return c;
      var d = new $root.ics23.BatchEntry();
      if (c.exist != null) {
        if (typeof c.exist != "object")
          throw TypeError(".ics23.BatchEntry.exist: object expected");
        d.exist = $root.ics23.ExistenceProof.fromObject(c.exist);
      }
      if (c.nonexist != null) {
        if (typeof c.nonexist != "object")
          throw TypeError(".ics23.BatchEntry.nonexist: object expected");
        d.nonexist = $root.ics23.NonExistenceProof.fromObject(c.nonexist);
      }
      return d;
    }, n.toObject = function(c, d) {
      d || (d = {});
      var m = {};
      return c.exist != null && c.hasOwnProperty("exist") && (m.exist = $root.ics23.ExistenceProof.toObject(c.exist, d), d.oneofs && (m.proof = "exist")), c.nonexist != null && c.hasOwnProperty("nonexist") && (m.nonexist = $root.ics23.NonExistenceProof.toObject(c.nonexist, d), d.oneofs && (m.proof = "nonexist")), m;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.CompressedBatchProof = function() {
    function n(o) {
      if (this.entries = [], this.lookupInners = [], o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.entries = $util.emptyArray, n.prototype.lookupInners = $util.emptyArray, n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      if (c || (c = $Writer.create()), u.entries != null && u.entries.length)
        for (var d = 0; d < u.entries.length; ++d)
          $root.ics23.CompressedBatchEntry.encode(u.entries[d], c.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      if (u.lookupInners != null && u.lookupInners.length)
        for (var d = 0; d < u.lookupInners.length; ++d)
          $root.ics23.InnerOp.encode(u.lookupInners[d], c.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.CompressedBatchProof(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.entries && m.entries.length || (m.entries = []), m.entries.push($root.ics23.CompressedBatchEntry.decode(u, u.uint32()));
            break;
          case 2:
            m.lookupInners && m.lookupInners.length || (m.lookupInners = []), m.lookupInners.push($root.ics23.InnerOp.decode(u, u.uint32()));
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.entries != null && u.hasOwnProperty("entries")) {
        if (!Array.isArray(u.entries))
          return "entries: array expected";
        for (var c = 0; c < u.entries.length; ++c) {
          var d = $root.ics23.CompressedBatchEntry.verify(u.entries[c]);
          if (d)
            return "entries." + d;
        }
      }
      if (u.lookupInners != null && u.hasOwnProperty("lookupInners")) {
        if (!Array.isArray(u.lookupInners))
          return "lookupInners: array expected";
        for (var c = 0; c < u.lookupInners.length; ++c) {
          var d = $root.ics23.InnerOp.verify(u.lookupInners[c]);
          if (d)
            return "lookupInners." + d;
        }
      }
      return null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.CompressedBatchProof)
        return u;
      var c = new $root.ics23.CompressedBatchProof();
      if (u.entries) {
        if (!Array.isArray(u.entries))
          throw TypeError(".ics23.CompressedBatchProof.entries: array expected");
        c.entries = [];
        for (var d = 0; d < u.entries.length; ++d) {
          if (typeof u.entries[d] != "object")
            throw TypeError(".ics23.CompressedBatchProof.entries: object expected");
          c.entries[d] = $root.ics23.CompressedBatchEntry.fromObject(u.entries[d]);
        }
      }
      if (u.lookupInners) {
        if (!Array.isArray(u.lookupInners))
          throw TypeError(".ics23.CompressedBatchProof.lookupInners: array expected");
        c.lookupInners = [];
        for (var d = 0; d < u.lookupInners.length; ++d) {
          if (typeof u.lookupInners[d] != "object")
            throw TypeError(".ics23.CompressedBatchProof.lookupInners: object expected");
          c.lookupInners[d] = $root.ics23.InnerOp.fromObject(u.lookupInners[d]);
        }
      }
      return c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      if ((c.arrays || c.defaults) && (d.entries = [], d.lookupInners = []), u.entries && u.entries.length) {
        d.entries = [];
        for (var m = 0; m < u.entries.length; ++m)
          d.entries[m] = $root.ics23.CompressedBatchEntry.toObject(u.entries[m], c);
      }
      if (u.lookupInners && u.lookupInners.length) {
        d.lookupInners = [];
        for (var m = 0; m < u.lookupInners.length; ++m)
          d.lookupInners[m] = $root.ics23.InnerOp.toObject(u.lookupInners[m], c);
      }
      return d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.CompressedBatchEntry = function() {
    function n(u) {
      if (u)
        for (var c = Object.keys(u), d = 0; d < c.length; ++d)
          u[c[d]] != null && (this[c[d]] = u[c[d]]);
    }
    n.prototype.exist = null, n.prototype.nonexist = null;
    var o;
    return Object.defineProperty(n.prototype, "proof", {
      get: $util.oneOfGetter(o = ["exist", "nonexist"]),
      set: $util.oneOfSetter(o)
    }), n.create = function(c) {
      return new n(c);
    }, n.encode = function(c, d) {
      return d || (d = $Writer.create()), c.exist != null && c.hasOwnProperty("exist") && $root.ics23.CompressedExistenceProof.encode(c.exist, d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), c.nonexist != null && c.hasOwnProperty("nonexist") && $root.ics23.CompressedNonExistenceProof.encode(c.nonexist, d.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), d;
    }, n.encodeDelimited = function(c, d) {
      return this.encode(c, d).ldelim();
    }, n.decode = function(c, d) {
      c instanceof $Reader || (c = $Reader.create(c));
      for (var m = d === void 0 ? c.len : c.pos + d, v = new $root.ics23.CompressedBatchEntry(); c.pos < m; ) {
        var S = c.uint32();
        switch (S >>> 3) {
          case 1:
            v.exist = $root.ics23.CompressedExistenceProof.decode(c, c.uint32());
            break;
          case 2:
            v.nonexist = $root.ics23.CompressedNonExistenceProof.decode(c, c.uint32());
            break;
          default:
            c.skipType(S & 7);
            break;
        }
      }
      return v;
    }, n.decodeDelimited = function(c) {
      return c instanceof $Reader || (c = new $Reader(c)), this.decode(c, c.uint32());
    }, n.verify = function(c) {
      if (typeof c != "object" || c === null)
        return "object expected";
      var d = {};
      if (c.exist != null && c.hasOwnProperty("exist")) {
        d.proof = 1;
        {
          var m = $root.ics23.CompressedExistenceProof.verify(c.exist);
          if (m)
            return "exist." + m;
        }
      }
      if (c.nonexist != null && c.hasOwnProperty("nonexist")) {
        if (d.proof === 1)
          return "proof: multiple values";
        d.proof = 1;
        {
          var m = $root.ics23.CompressedNonExistenceProof.verify(c.nonexist);
          if (m)
            return "nonexist." + m;
        }
      }
      return null;
    }, n.fromObject = function(c) {
      if (c instanceof $root.ics23.CompressedBatchEntry)
        return c;
      var d = new $root.ics23.CompressedBatchEntry();
      if (c.exist != null) {
        if (typeof c.exist != "object")
          throw TypeError(".ics23.CompressedBatchEntry.exist: object expected");
        d.exist = $root.ics23.CompressedExistenceProof.fromObject(c.exist);
      }
      if (c.nonexist != null) {
        if (typeof c.nonexist != "object")
          throw TypeError(".ics23.CompressedBatchEntry.nonexist: object expected");
        d.nonexist = $root.ics23.CompressedNonExistenceProof.fromObject(c.nonexist);
      }
      return d;
    }, n.toObject = function(c, d) {
      d || (d = {});
      var m = {};
      return c.exist != null && c.hasOwnProperty("exist") && (m.exist = $root.ics23.CompressedExistenceProof.toObject(c.exist, d), d.oneofs && (m.proof = "exist")), c.nonexist != null && c.hasOwnProperty("nonexist") && (m.nonexist = $root.ics23.CompressedNonExistenceProof.toObject(c.nonexist, d), d.oneofs && (m.proof = "nonexist")), m;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.CompressedExistenceProof = function() {
    function n(o) {
      if (this.path = [], o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.key = $util.newBuffer([]), n.prototype.value = $util.newBuffer([]), n.prototype.leaf = null, n.prototype.path = $util.emptyArray, n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      if (c || (c = $Writer.create()), u.key != null && u.hasOwnProperty("key") && c.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(u.key), u.value != null && u.hasOwnProperty("value") && c.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(u.value), u.leaf != null && u.hasOwnProperty("leaf") && $root.ics23.LeafOp.encode(u.leaf, c.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), u.path != null && u.path.length) {
        c.uint32(
          /* id 4, wireType 2 =*/
          34
        ).fork();
        for (var d = 0; d < u.path.length; ++d)
          c.int32(u.path[d]);
        c.ldelim();
      }
      return c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.CompressedExistenceProof(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.key = u.bytes();
            break;
          case 2:
            m.value = u.bytes();
            break;
          case 3:
            m.leaf = $root.ics23.LeafOp.decode(u, u.uint32());
            break;
          case 4:
            if (m.path && m.path.length || (m.path = []), (v & 7) === 2)
              for (var S = u.uint32() + u.pos; u.pos < S; )
                m.path.push(u.int32());
            else
              m.path.push(u.int32());
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.key != null && u.hasOwnProperty("key") && !(u.key && typeof u.key.length == "number" || $util.isString(u.key)))
        return "key: buffer expected";
      if (u.value != null && u.hasOwnProperty("value") && !(u.value && typeof u.value.length == "number" || $util.isString(u.value)))
        return "value: buffer expected";
      if (u.leaf != null && u.hasOwnProperty("leaf")) {
        var c = $root.ics23.LeafOp.verify(u.leaf);
        if (c)
          return "leaf." + c;
      }
      if (u.path != null && u.hasOwnProperty("path")) {
        if (!Array.isArray(u.path))
          return "path: array expected";
        for (var d = 0; d < u.path.length; ++d)
          if (!$util.isInteger(u.path[d]))
            return "path: integer[] expected";
      }
      return null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.CompressedExistenceProof)
        return u;
      var c = new $root.ics23.CompressedExistenceProof();
      if (u.key != null && (typeof u.key == "string" ? $util.base64.decode(u.key, c.key = $util.newBuffer($util.base64.length(u.key)), 0) : u.key.length && (c.key = u.key)), u.value != null && (typeof u.value == "string" ? $util.base64.decode(u.value, c.value = $util.newBuffer($util.base64.length(u.value)), 0) : u.value.length && (c.value = u.value)), u.leaf != null) {
        if (typeof u.leaf != "object")
          throw TypeError(".ics23.CompressedExistenceProof.leaf: object expected");
        c.leaf = $root.ics23.LeafOp.fromObject(u.leaf);
      }
      if (u.path) {
        if (!Array.isArray(u.path))
          throw TypeError(".ics23.CompressedExistenceProof.path: array expected");
        c.path = [];
        for (var d = 0; d < u.path.length; ++d)
          c.path[d] = u.path[d] | 0;
      }
      return c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      if ((c.arrays || c.defaults) && (d.path = []), c.defaults && (c.bytes === String ? d.key = "" : (d.key = [], c.bytes !== Array && (d.key = $util.newBuffer(d.key))), c.bytes === String ? d.value = "" : (d.value = [], c.bytes !== Array && (d.value = $util.newBuffer(d.value))), d.leaf = null), u.key != null && u.hasOwnProperty("key") && (d.key = c.bytes === String ? $util.base64.encode(u.key, 0, u.key.length) : c.bytes === Array ? Array.prototype.slice.call(u.key) : u.key), u.value != null && u.hasOwnProperty("value") && (d.value = c.bytes === String ? $util.base64.encode(u.value, 0, u.value.length) : c.bytes === Array ? Array.prototype.slice.call(u.value) : u.value), u.leaf != null && u.hasOwnProperty("leaf") && (d.leaf = $root.ics23.LeafOp.toObject(u.leaf, c)), u.path && u.path.length) {
        d.path = [];
        for (var m = 0; m < u.path.length; ++m)
          d.path[m] = u.path[m];
      }
      return d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e.CompressedNonExistenceProof = function() {
    function n(o) {
      if (o)
        for (var u = Object.keys(o), c = 0; c < u.length; ++c)
          o[u[c]] != null && (this[u[c]] = o[u[c]]);
    }
    return n.prototype.key = $util.newBuffer([]), n.prototype.left = null, n.prototype.right = null, n.create = function(u) {
      return new n(u);
    }, n.encode = function(u, c) {
      return c || (c = $Writer.create()), u.key != null && u.hasOwnProperty("key") && c.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(u.key), u.left != null && u.hasOwnProperty("left") && $root.ics23.CompressedExistenceProof.encode(u.left, c.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), u.right != null && u.hasOwnProperty("right") && $root.ics23.CompressedExistenceProof.encode(u.right, c.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), c;
    }, n.encodeDelimited = function(u, c) {
      return this.encode(u, c).ldelim();
    }, n.decode = function(u, c) {
      u instanceof $Reader || (u = $Reader.create(u));
      for (var d = c === void 0 ? u.len : u.pos + c, m = new $root.ics23.CompressedNonExistenceProof(); u.pos < d; ) {
        var v = u.uint32();
        switch (v >>> 3) {
          case 1:
            m.key = u.bytes();
            break;
          case 2:
            m.left = $root.ics23.CompressedExistenceProof.decode(u, u.uint32());
            break;
          case 3:
            m.right = $root.ics23.CompressedExistenceProof.decode(u, u.uint32());
            break;
          default:
            u.skipType(v & 7);
            break;
        }
      }
      return m;
    }, n.decodeDelimited = function(u) {
      return u instanceof $Reader || (u = new $Reader(u)), this.decode(u, u.uint32());
    }, n.verify = function(u) {
      if (typeof u != "object" || u === null)
        return "object expected";
      if (u.key != null && u.hasOwnProperty("key") && !(u.key && typeof u.key.length == "number" || $util.isString(u.key)))
        return "key: buffer expected";
      if (u.left != null && u.hasOwnProperty("left")) {
        var c = $root.ics23.CompressedExistenceProof.verify(u.left);
        if (c)
          return "left." + c;
      }
      if (u.right != null && u.hasOwnProperty("right")) {
        var c = $root.ics23.CompressedExistenceProof.verify(u.right);
        if (c)
          return "right." + c;
      }
      return null;
    }, n.fromObject = function(u) {
      if (u instanceof $root.ics23.CompressedNonExistenceProof)
        return u;
      var c = new $root.ics23.CompressedNonExistenceProof();
      if (u.key != null && (typeof u.key == "string" ? $util.base64.decode(u.key, c.key = $util.newBuffer($util.base64.length(u.key)), 0) : u.key.length && (c.key = u.key)), u.left != null) {
        if (typeof u.left != "object")
          throw TypeError(".ics23.CompressedNonExistenceProof.left: object expected");
        c.left = $root.ics23.CompressedExistenceProof.fromObject(u.left);
      }
      if (u.right != null) {
        if (typeof u.right != "object")
          throw TypeError(".ics23.CompressedNonExistenceProof.right: object expected");
        c.right = $root.ics23.CompressedExistenceProof.fromObject(u.right);
      }
      return c;
    }, n.toObject = function(u, c) {
      c || (c = {});
      var d = {};
      return c.defaults && (c.bytes === String ? d.key = "" : (d.key = [], c.bytes !== Array && (d.key = $util.newBuffer(d.key))), d.left = null, d.right = null), u.key != null && u.hasOwnProperty("key") && (d.key = c.bytes === String ? $util.base64.encode(u.key, 0, u.key.length) : c.bytes === Array ? Array.prototype.slice.call(u.key) : u.key), u.left != null && u.hasOwnProperty("left") && (d.left = $root.ics23.CompressedExistenceProof.toObject(u.left, c)), u.right != null && u.hasOwnProperty("right") && (d.right = $root.ics23.CompressedExistenceProof.toObject(u.right, c)), d;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    }, n;
  }(), e;
}();
var codecimpl = $root, ics23 = {}, compress$1 = {};
Object.defineProperty(compress$1, "__esModule", { value: !0 });
compress$1.decompress = compress$1.compress = void 0;
const codecimpl_1$2 = codecimpl;
function compress(e) {
  return e.batch ? { compressed: compressBatch(e.batch) } : e;
}
compress$1.compress = compress;
function decompress(e) {
  return e.compressed ? { batch: decompressBatch(e.compressed) } : e;
}
compress$1.decompress = decompress;
function compressBatch(e) {
  const n = [], o = [], u = /* @__PURE__ */ new Map();
  for (const c of e.entries)
    if (c.exist) {
      const d = { exist: compressExist(c.exist, o, u) };
      n.push(d);
    } else if (c.nonexist) {
      const d = c.nonexist, m = {
        nonexist: {
          key: d.key,
          left: compressExist(d.left, o, u),
          right: compressExist(d.right, o, u)
        }
      };
      n.push(m);
    } else
      throw new Error("Unexpected batch entry during compress");
  return {
    entries: n,
    lookupInners: o
  };
}
function compressExist(e, n, o) {
  if (!e)
    return;
  const u = e.path.map((c) => {
    const d = codecimpl_1$2.ics23.InnerOp.encode(c).finish();
    let m = o.get(d);
    return m === void 0 && (m = n.length, n.push(c), o.set(d, m)), m;
  });
  return {
    key: e.key,
    value: e.value,
    leaf: e.leaf,
    path: u
  };
}
function decompressBatch(e) {
  const n = e.lookupInners;
  return {
    entries: e.entries.map((u) => {
      if (u.exist)
        return { exist: decompressExist(u.exist, n) };
      if (u.nonexist) {
        const c = u.nonexist;
        return {
          nonexist: {
            key: c.key,
            left: decompressExist(c.left, n),
            right: decompressExist(c.right, n)
          }
        };
      } else
        throw new Error("Unexpected batch entry during compress");
    })
  };
}
function decompressExist(e, n) {
  if (!e)
    return;
  const { key: o, value: u, leaf: c, path: d } = e, m = (d || []).map((v) => n[v]);
  return { key: o, value: u, leaf: c, path: m };
}
var proofs$1 = {}, ops = {};
Object.defineProperty(ops, "__esModule", { value: !0 });
ops.doHash = ops.applyInner = ops.applyLeaf = void 0;
const ripemd160_1$5 = ripemd160$8, sha256_1$5 = sha256$8, sha512_1$a = sha512$a, codecimpl_1$1 = codecimpl;
function applyLeaf(e, n, o) {
  if (n.length === 0)
    throw new Error("Missing key");
  if (o.length === 0)
    throw new Error("Missing value");
  const u = prepareLeafData(ensureHash(e.prehashKey), ensureLength(e.length), n), c = prepareLeafData(ensureHash(e.prehashValue), ensureLength(e.length), o), d = new Uint8Array([
    ...ensureBytes(e.prefix),
    ...u,
    ...c
  ]);
  return doHash(ensureHash(e.hash), d);
}
ops.applyLeaf = applyLeaf;
function applyInner(e, n) {
  if (n.length === 0)
    throw new Error("Inner op needs child value");
  const o = new Uint8Array([
    ...ensureBytes(e.prefix),
    ...n,
    ...ensureBytes(e.suffix)
  ]);
  return doHash(ensureHash(e.hash), o);
}
ops.applyInner = applyInner;
function ensure(e, n) {
  return e ?? n;
}
const ensureHash = (e) => ensure(e, codecimpl_1$1.ics23.HashOp.NO_HASH), ensureLength = (e) => ensure(e, codecimpl_1$1.ics23.LengthOp.NO_PREFIX), ensureBytes = (e) => ensure(e, new Uint8Array([]));
function prepareLeafData(e, n, o) {
  const u = doHashOrNoop(e, o);
  return doLengthOp(n, u);
}
function doHashOrNoop(e, n) {
  return e === codecimpl_1$1.ics23.HashOp.NO_HASH ? n : doHash(e, n);
}
function doHash(e, n) {
  switch (e) {
    case codecimpl_1$1.ics23.HashOp.SHA256:
      return (0, sha256_1$5.sha256)(n);
    case codecimpl_1$1.ics23.HashOp.SHA512:
      return (0, sha512_1$a.sha512)(n);
    case codecimpl_1$1.ics23.HashOp.RIPEMD160:
      return (0, ripemd160_1$5.ripemd160)(n);
    case codecimpl_1$1.ics23.HashOp.BITCOIN:
      return (0, ripemd160_1$5.ripemd160)((0, sha256_1$5.sha256)(n));
    case codecimpl_1$1.ics23.HashOp.SHA512_256:
      return (0, sha512_1$a.sha512_256)(n);
  }
  throw new Error(`Unsupported hashop: ${e}`);
}
ops.doHash = doHash;
function doLengthOp(e, n) {
  switch (e) {
    case codecimpl_1$1.ics23.LengthOp.NO_PREFIX:
      return n;
    case codecimpl_1$1.ics23.LengthOp.VAR_PROTO:
      return new Uint8Array([...encodeVarintProto(n.length), ...n]);
    case codecimpl_1$1.ics23.LengthOp.REQUIRE_32_BYTES:
      if (n.length !== 32)
        throw new Error(`Length is ${n.length}, not 32 bytes`);
      return n;
    case codecimpl_1$1.ics23.LengthOp.REQUIRE_64_BYTES:
      if (n.length !== 64)
        throw new Error(`Length is ${n.length}, not 64 bytes`);
      return n;
    case codecimpl_1$1.ics23.LengthOp.FIXED32_LITTLE:
      return new Uint8Array([...encodeFixed32Le(n.length), ...n]);
  }
  throw new Error(`Unsupported lengthop: ${e}`);
}
function encodeVarintProto(e) {
  let n = [], o = e;
  for (; o >= 128; ) {
    const u = o % 128 + 128;
    n = [...n, u], o = o / 128;
  }
  return n = [...n, o], new Uint8Array(n);
}
function encodeFixed32Le(e) {
  const n = new Uint8Array(4);
  let o = e;
  for (let u = n.length; u > 0; u--)
    n[Math.abs(u - n.length)] = o % 256, o = Math.floor(o / 256);
  return n;
}
var specs = {};
Object.defineProperty(specs, "__esModule", { value: !0 });
specs.bytesBefore = specs.ensureBytesBefore = specs.bytesEqual = specs.ensureBytesEqual = specs.ensureInner = specs.ensureLeaf = void 0;
function ensureLeaf(e, n) {
  if (e.hash !== n.hash)
    throw new Error(`Unexpected hashOp: ${e.hash}`);
  if (e.prehashKey !== n.prehashKey)
    throw new Error(`Unexpected prehashKey: ${e.prehashKey}`);
  if (e.prehashValue !== n.prehashValue)
    throw new Error(`Unexpected prehashValue: ${e.prehashValue}`);
  if (e.length !== n.length)
    throw new Error(`Unexpected length op: ${e.length}`);
  ensurePrefix(e.prefix, n.prefix);
}
specs.ensureLeaf = ensureLeaf;
function ensureInner(e, n, o) {
  if (e.hash !== o.hash)
    throw new Error(`Unexpected hashOp: ${e.hash}`);
  if (!e.prefix)
    throw new Error("No prefix set for inner node");
  if (hasPrefix(e.prefix, n))
    throw new Error("Inner node has leaf prefix");
  if (e.prefix.length < (o.minPrefixLength || 0))
    throw new Error(`Prefix too short: ${e.prefix.length} bytes`);
  const u = (o.childOrder.length - 1) * o.childSize;
  if (e.prefix.length > (o.maxPrefixLength || 0) + u)
    throw new Error(`Prefix too long: ${e.prefix.length} bytes`);
}
specs.ensureInner = ensureInner;
function ensurePrefix(e, n) {
  if (!(!n || n.length === 0)) {
    if (!e)
      throw new Error("Target bytes missing");
    ensureBytesEqual(n, e.slice(0, n.length));
  }
}
function ensureBytesEqual(e, n) {
  if (e.length !== n.length)
    throw new Error(`Different lengths ${e.length} vs ${n.length}`);
  for (let o = 0; o < e.length; o++)
    if (e[o] !== n[o])
      throw new Error(`Arrays differ at index ${o}: ${e[o]} vs ${n[o]}`);
}
specs.ensureBytesEqual = ensureBytesEqual;
function bytesEqual(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; o++)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
specs.bytesEqual = bytesEqual;
function hasPrefix(e, n) {
  if (!n || n.length === 0 || !e || e.length <= n.length)
    return !1;
  for (let o = 0; o < n.length; o++)
    if (e[o] !== n[o])
      return !1;
  throw !0;
}
function ensureBytesBefore(e, n) {
  if (!bytesBefore(e, n))
    throw new Error("first is after last");
}
specs.ensureBytesBefore = ensureBytesBefore;
function bytesBefore(e, n) {
  const o = e.length < n.length ? e.length : n.length;
  for (let u = 0; u < o; u++) {
    if (e[u] < n[u])
      return !0;
    if (e[u] > n[u])
      return !1;
  }
  return e.length < n.length;
}
specs.bytesBefore = bytesBefore;
Object.defineProperty(proofs$1, "__esModule", { value: !0 });
proofs$1.ensureLeftNeighbor = proofs$1.ensureSpec = proofs$1.calculateExistenceRoot = proofs$1.verifyNonExistence = proofs$1.verifyExistence = proofs$1.smtSpec = proofs$1.tendermintSpec = proofs$1.iavlSpec = void 0;
const codecimpl_1 = codecimpl, ops_1 = ops, specs_1$1 = specs;
proofs$1.iavlSpec = {
  leafSpec: {
    prefix: Uint8Array.from([0]),
    hash: codecimpl_1.ics23.HashOp.SHA256,
    prehashValue: codecimpl_1.ics23.HashOp.SHA256,
    prehashKey: codecimpl_1.ics23.HashOp.NO_HASH,
    length: codecimpl_1.ics23.LengthOp.VAR_PROTO
  },
  innerSpec: {
    childOrder: [0, 1],
    minPrefixLength: 4,
    maxPrefixLength: 12,
    childSize: 33,
    hash: codecimpl_1.ics23.HashOp.SHA256
  }
};
proofs$1.tendermintSpec = {
  leafSpec: {
    prefix: Uint8Array.from([0]),
    hash: codecimpl_1.ics23.HashOp.SHA256,
    prehashValue: codecimpl_1.ics23.HashOp.SHA256,
    prehashKey: codecimpl_1.ics23.HashOp.NO_HASH,
    length: codecimpl_1.ics23.LengthOp.VAR_PROTO
  },
  innerSpec: {
    childOrder: [0, 1],
    minPrefixLength: 1,
    maxPrefixLength: 1,
    childSize: 32,
    hash: codecimpl_1.ics23.HashOp.SHA256
  }
};
proofs$1.smtSpec = {
  leafSpec: {
    hash: codecimpl_1.ics23.HashOp.SHA256,
    prehashKey: codecimpl_1.ics23.HashOp.NO_HASH,
    prehashValue: codecimpl_1.ics23.HashOp.SHA256,
    length: codecimpl_1.ics23.LengthOp.NO_PREFIX,
    prefix: Uint8Array.from([0])
  },
  innerSpec: {
    childOrder: [0, 1],
    childSize: 32,
    minPrefixLength: 1,
    maxPrefixLength: 1,
    emptyChild: new Uint8Array(32),
    hash: codecimpl_1.ics23.HashOp.SHA256
  },
  maxDepth: 256
};
function verifyExistence(e, n, o, u, c) {
  ensureSpec(e, n);
  const d = calculateExistenceRoot(e);
  (0, specs_1$1.ensureBytesEqual)(d, o), (0, specs_1$1.ensureBytesEqual)(u, e.key), (0, specs_1$1.ensureBytesEqual)(c, e.value);
}
proofs$1.verifyExistence = verifyExistence;
function verifyNonExistence(e, n, o, u) {
  let c, d;
  if (e.left && (verifyExistence(e.left, n, o, e.left.key, e.left.value), c = e.left.key), e.right && (verifyExistence(e.right, n, o, e.right.key, e.right.value), d = e.right.key), !c && !d)
    throw new Error("neither left nor right proof defined");
  if (c && (0, specs_1$1.ensureBytesBefore)(c, u), d && (0, specs_1$1.ensureBytesBefore)(u, d), !n.innerSpec)
    throw new Error("no inner spec");
  c ? d ? ensureLeftNeighbor(n.innerSpec, e.left.path, e.right.path) : ensureRightMost(n.innerSpec, e.left.path) : ensureLeftMost(n.innerSpec, e.right.path);
}
proofs$1.verifyNonExistence = verifyNonExistence;
function calculateExistenceRoot(e) {
  if (!e.key || !e.value)
    throw new Error("Existence proof needs key and value set");
  if (!e.leaf)
    throw new Error("Existence proof must start with a leaf operation");
  const n = e.path || [];
  let o = (0, ops_1.applyLeaf)(e.leaf, e.key, e.value);
  for (const u of n)
    o = (0, ops_1.applyInner)(u, o);
  return o;
}
proofs$1.calculateExistenceRoot = calculateExistenceRoot;
function ensureSpec(e, n) {
  if (!e.leaf)
    throw new Error("Existence proof must start with a leaf operation");
  if (!n.leafSpec)
    throw new Error("Spec must include leafSpec");
  if (!n.innerSpec)
    throw new Error("Spec must include innerSpec");
  (0, specs_1$1.ensureLeaf)(e.leaf, n.leafSpec);
  const o = e.path || [];
  if (n.minDepth && o.length < n.minDepth)
    throw new Error(`Too few inner nodes ${o.length}`);
  if (n.maxDepth && o.length > n.maxDepth)
    throw new Error(`Too many inner nodes ${o.length}`);
  for (const u of o)
    (0, specs_1$1.ensureInner)(u, n.leafSpec.prefix, n.innerSpec);
}
proofs$1.ensureSpec = ensureSpec;
function ensureLeftMost(e, n) {
  const { minPrefix: o, maxPrefix: u, suffix: c } = getPadding(e, 0);
  for (const d of n)
    if (!hasPadding(d, o, u, c))
      throw new Error("Step not leftmost");
}
function ensureRightMost(e, n) {
  const o = e.childOrder.length - 1, { minPrefix: u, maxPrefix: c, suffix: d } = getPadding(e, o);
  for (const m of n)
    if (!hasPadding(m, u, c, d))
      throw new Error("Step not leftmost");
}
function ensureLeftNeighbor(e, n, o) {
  const u = [...n], c = [...o];
  let d = u.pop(), m = c.pop();
  for (; (0, specs_1$1.bytesEqual)(d.prefix, m.prefix) && (0, specs_1$1.bytesEqual)(d.suffix, m.suffix); )
    d = u.pop(), m = c.pop();
  if (!isLeftStep(e, d, m))
    throw new Error("Not left neightbor at first divergent step");
  ensureRightMost(e, u), ensureLeftMost(e, c);
}
proofs$1.ensureLeftNeighbor = ensureLeftNeighbor;
function isLeftStep(e, n, o) {
  const u = orderFromPadding(e, n);
  return orderFromPadding(e, o) === u + 1;
}
function orderFromPadding(e, n) {
  for (let o = 0; o < e.childOrder.length; o++) {
    const { minPrefix: u, maxPrefix: c, suffix: d } = getPadding(e, o);
    if (hasPadding(n, u, c, d))
      return o;
  }
  throw new Error("Cannot find any valid spacing for this node");
}
function hasPadding(e, n, o, u) {
  return (e.prefix || []).length < n || (e.prefix || []).length > o ? !1 : (e.suffix || []).length === u;
}
function getPadding(e, n) {
  const o = getPosition(e.childOrder, n), u = o * e.childSize, c = u + e.minPrefixLength, d = u + e.maxPrefixLength, m = (e.childOrder.length - 1 - o) * e.childSize;
  return { minPrefix: c, maxPrefix: d, suffix: m };
}
function getPosition(e, n) {
  if (n < 0 || n >= e.length)
    throw new Error(`Invalid branch: ${n}`);
  return e.findIndex((o) => o === n);
}
Object.defineProperty(ics23, "__esModule", { value: !0 });
ics23.batchVerifyNonMembership = ics23.batchVerifyMembership = ics23.verifyNonMembership = ics23.verifyMembership = void 0;
const compress_1 = compress$1, proofs_1$1 = proofs$1, specs_1 = specs;
function verifyMembership(e, n, o, u, c) {
  const d = (0, compress_1.decompress)(e), m = getExistForKey(d, u);
  if (!m)
    return !1;
  try {
    return (0, proofs_1$1.verifyExistence)(m, n, o, u, c), !0;
  } catch {
    return !1;
  }
}
ics23.verifyMembership = verifyMembership;
function verifyNonMembership(e, n, o, u) {
  const c = (0, compress_1.decompress)(e), d = getNonExistForKey(c, u);
  if (!d)
    return !1;
  try {
    return (0, proofs_1$1.verifyNonExistence)(d, n, o, u), !0;
  } catch {
    return !1;
  }
}
ics23.verifyNonMembership = verifyNonMembership;
function batchVerifyMembership(e, n, o, u) {
  const c = (0, compress_1.decompress)(e);
  for (const [d, m] of u.entries())
    if (!verifyMembership(c, n, o, d, m))
      return !1;
  return !0;
}
ics23.batchVerifyMembership = batchVerifyMembership;
function batchVerifyNonMembership(e, n, o, u) {
  const c = (0, compress_1.decompress)(e);
  for (const d of u)
    if (!verifyNonMembership(c, n, o, d))
      return !1;
  return !0;
}
ics23.batchVerifyNonMembership = batchVerifyNonMembership;
function getExistForKey(e, n) {
  const o = (u) => !!u && (0, specs_1.bytesEqual)(n, u.key);
  if (o(e.exist))
    return e.exist;
  if (e.batch)
    return e.batch.entries.map((u) => u.exist || null).find(o);
}
function getNonExistForKey(e, n) {
  const o = (u) => !!u && (!u.left || (0, specs_1.bytesBefore)(u.left.key, n)) && (!u.right || (0, specs_1.bytesBefore)(n, u.right.key));
  if (o(e.nonexist))
    return e.nonexist;
  if (e.batch)
    return e.batch.entries.map((u) => u.nonexist || null).find(o);
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.verifyNonExistence = e.verifyExistence = e.tendermintSpec = e.iavlSpec = e.calculateExistenceRoot = e.verifyNonMembership = e.verifyMembership = e.ics23 = void 0;
  var n = codecimpl;
  Object.defineProperty(e, "ics23", { enumerable: !0, get: function() {
    return n.ics23;
  } });
  var o = ics23;
  Object.defineProperty(e, "verifyMembership", { enumerable: !0, get: function() {
    return o.verifyMembership;
  } }), Object.defineProperty(e, "verifyNonMembership", { enumerable: !0, get: function() {
    return o.verifyNonMembership;
  } });
  var u = proofs$1;
  Object.defineProperty(e, "calculateExistenceRoot", { enumerable: !0, get: function() {
    return u.calculateExistenceRoot;
  } }), Object.defineProperty(e, "iavlSpec", { enumerable: !0, get: function() {
    return u.iavlSpec;
  } }), Object.defineProperty(e, "tendermintSpec", { enumerable: !0, get: function() {
    return u.tendermintSpec;
  } }), Object.defineProperty(e, "verifyExistence", { enumerable: !0, get: function() {
    return u.verifyExistence;
  } }), Object.defineProperty(e, "verifyNonExistence", { enumerable: !0, get: function() {
    return u.verifyNonExistence;
  } });
})(build$E);
var build$D = {}, concat$d = {}, xstream = {}, ponyfill$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(o) {
    var u, c = o.Symbol;
    if (typeof c == "function")
      if (c.observable)
        u = c.observable;
      else {
        u = c.for("https://github.com/benlesh/symbol-observable");
        try {
          c.observable = u;
        } catch {
        }
      }
    else
      u = "@@observable";
    return u;
  }
})(ponyfill$1);
var ponyfill = ponyfill$1, toStr$3 = Object.prototype.toString, isArguments = function e(n) {
  var o = toStr$3.call(n), u = o === "[object Arguments]";
  return u || (u = o !== "[object Array]" && n !== null && typeof n == "object" && typeof n.length == "number" && n.length >= 0 && toStr$3.call(n.callee) === "[object Function]"), u;
}, implementation$6, hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation)
    return implementation$6;
  hasRequiredImplementation = 1;
  var e;
  if (!Object.keys) {
    var n = Object.prototype.hasOwnProperty, o = Object.prototype.toString, u = isArguments, c = Object.prototype.propertyIsEnumerable, d = !c.call({ toString: null }, "toString"), m = c.call(function() {
    }, "prototype"), v = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], S = function(T) {
      var y = T.constructor;
      return y && y.prototype === T;
    }, $ = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, E = function() {
      if (typeof window > "u")
        return !1;
      for (var T in window)
        try {
          if (!$["$" + T] && n.call(window, T) && window[T] !== null && typeof window[T] == "object")
            try {
              S(window[T]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), O = function(T) {
      if (typeof window > "u" || !E)
        return S(T);
      try {
        return S(T);
      } catch {
        return !1;
      }
    };
    e = function(y) {
      var V = y !== null && typeof y == "object", M = o.call(y) === "[object Function]", G = u(y), k = V && o.call(y) === "[object String]", F = [];
      if (!V && !M && !G)
        throw new TypeError("Object.keys called on a non-object");
      var X = m && M;
      if (k && y.length > 0 && !n.call(y, 0))
        for (var ee = 0; ee < y.length; ++ee)
          F.push(String(ee));
      if (G && y.length > 0)
        for (var ue = 0; ue < y.length; ++ue)
          F.push(String(ue));
      else
        for (var Q in y)
          !(X && Q === "prototype") && n.call(y, Q) && F.push(String(Q));
      if (d)
        for (var Y = O(y), pe = 0; pe < v.length; ++pe)
          !(Y && v[pe] === "constructor") && n.call(y, v[pe]) && F.push(v[pe]);
      return F;
    };
  }
  return implementation$6 = e, implementation$6;
}
var slice$2 = Array.prototype.slice, isArgs = isArguments, origKeys = Object.keys, keysShim = origKeys ? function e(n) {
  return origKeys(n);
} : requireImplementation(), originalKeys = Object.keys;
keysShim.shim = function e() {
  if (Object.keys) {
    var n = function() {
      var o = Object.keys(arguments);
      return o && o.length === arguments.length;
    }(1, 2);
    n || (Object.keys = function(u) {
      return isArgs(u) ? originalKeys(slice$2.call(u)) : originalKeys(u);
    });
  } else
    Object.keys = keysShim;
  return Object.keys || keysShim;
};
var objectKeys = keysShim, shams = function e() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var n = {}, o = Symbol("test"), u = Object(o);
  if (typeof o == "string" || Object.prototype.toString.call(o) !== "[object Symbol]" || Object.prototype.toString.call(u) !== "[object Symbol]")
    return !1;
  var c = 42;
  n[o] = c;
  for (o in n)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(n).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(n).length !== 0)
    return !1;
  var d = Object.getOwnPropertySymbols(n);
  if (d.length !== 1 || d[0] !== o || !Object.prototype.propertyIsEnumerable.call(n, o))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var m = Object.getOwnPropertyDescriptor(n, o);
    if (m.value !== c || m.enumerable !== !0)
      return !1;
  }
  return !0;
}, origSymbol = typeof Symbol < "u" && Symbol, hasSymbolSham = shams, hasSymbols$2 = function e() {
  return typeof origSymbol != "function" || typeof Symbol != "function" || typeof origSymbol("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : hasSymbolSham();
}, test = {
  foo: {}
}, $Object = Object, hasProto$1 = function e() {
  return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
}, ERROR_MESSAGE$1 = "Function.prototype.bind called on incompatible ", slice$1 = Array.prototype.slice, toStr$2 = Object.prototype.toString, funcType$1 = "[object Function]", implementation$5 = function e(n) {
  var o = this;
  if (typeof o != "function" || toStr$2.call(o) !== funcType$1)
    throw new TypeError(ERROR_MESSAGE$1 + o);
  for (var u = slice$1.call(arguments, 1), c, d = function() {
    if (this instanceof c) {
      var E = o.apply(
        this,
        u.concat(slice$1.call(arguments))
      );
      return Object(E) === E ? E : this;
    } else
      return o.apply(
        n,
        u.concat(slice$1.call(arguments))
      );
  }, m = Math.max(0, o.length - u.length), v = [], S = 0; S < m; S++)
    v.push("$" + S);
  if (c = Function("binder", "return function (" + v.join(",") + "){ return binder.apply(this,arguments); }")(d), o.prototype) {
    var $ = function() {
    };
    $.prototype = o.prototype, c.prototype = new $(), $.prototype = null;
  }
  return c;
}, implementation$4 = implementation$5, functionBind$1 = Function.prototype.bind || implementation$4, ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", slice = Array.prototype.slice, toStr$1 = Object.prototype.toString, funcType = "[object Function]", implementation$3 = function e(n) {
  var o = this;
  if (typeof o != "function" || toStr$1.call(o) !== funcType)
    throw new TypeError(ERROR_MESSAGE + o);
  for (var u = slice.call(arguments, 1), c, d = function() {
    if (this instanceof c) {
      var E = o.apply(
        this,
        u.concat(slice.call(arguments))
      );
      return Object(E) === E ? E : this;
    } else
      return o.apply(
        n,
        u.concat(slice.call(arguments))
      );
  }, m = Math.max(0, o.length - u.length), v = [], S = 0; S < m; S++)
    v.push("$" + S);
  if (c = Function("binder", "return function (" + v.join(",") + "){ return binder.apply(this,arguments); }")(d), o.prototype) {
    var $ = function() {
    };
    $.prototype = o.prototype, c.prototype = new $(), $.prototype = null;
  }
  return c;
}, implementation$2 = implementation$3, functionBind = Function.prototype.bind || implementation$2, bind$a = functionBind, src = bind$a.call(Function.call, Object.prototype.hasOwnProperty), undefined$1, $SyntaxError = SyntaxError, $Function = Function, $TypeError = TypeError, getEvalledConstructor = function(e) {
  try {
    return $Function('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD)
  try {
    $gOPD({}, "");
  } catch {
    $gOPD = null;
  }
var throwTypeError = function() {
  throw new $TypeError();
}, ThrowTypeError = $gOPD ? function() {
  try {
    return arguments.callee, throwTypeError;
  } catch {
    try {
      return $gOPD(arguments, "callee").get;
    } catch {
      return throwTypeError;
    }
  }
}() : throwTypeError, hasSymbols$1 = hasSymbols$2(), hasProto = hasProto$1(), getProto = Object.getPrototypeOf || (hasProto ? function(e) {
  return e.__proto__;
} : null), needsEval = {}, TypedArray = typeof Uint8Array > "u" || !getProto ? undefined$1 : getProto(Uint8Array), INTRINSICS = {
  "%AggregateError%": typeof AggregateError > "u" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$1 && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics > "u" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$1 && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$1,
  "%Map%": typeof Map > "u" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols$1 || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols$1 || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$1 && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols$1 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$1 : WeakSet
};
if (getProto)
  try {
    null.error;
  } catch (e) {
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
var doEval = function e(n) {
  var o;
  if (n === "%AsyncFunction%")
    o = getEvalledConstructor("async function () {}");
  else if (n === "%GeneratorFunction%")
    o = getEvalledConstructor("function* () {}");
  else if (n === "%AsyncGeneratorFunction%")
    o = getEvalledConstructor("async function* () {}");
  else if (n === "%AsyncGenerator%") {
    var u = e("%AsyncGeneratorFunction%");
    u && (o = u.prototype);
  } else if (n === "%AsyncIteratorPrototype%") {
    var c = e("%AsyncGenerator%");
    c && getProto && (o = getProto(c.prototype));
  }
  return INTRINSICS[n] = o, o;
}, LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind$9 = functionBind$1, hasOwn = src, $concat = bind$9.call(Function.call, Array.prototype.concat), $spliceApply = bind$9.call(Function.apply, Array.prototype.splice), $replace = bind$9.call(Function.call, String.prototype.replace), $strSlice = bind$9.call(Function.call, String.prototype.slice), $exec = bind$9.call(Function.call, RegExp.prototype.exec), rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = function e(n) {
  var o = $strSlice(n, 0, 1), u = $strSlice(n, -1);
  if (o === "%" && u !== "%")
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  if (u === "%" && o !== "%")
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  var c = [];
  return $replace(n, rePropName, function(d, m, v, S) {
    c[c.length] = v ? $replace(S, reEscapeChar, "$1") : m || d;
  }), c;
}, getBaseIntrinsic = function e(n, o) {
  var u = n, c;
  if (hasOwn(LEGACY_ALIASES, u) && (c = LEGACY_ALIASES[u], u = "%" + c[0] + "%"), hasOwn(INTRINSICS, u)) {
    var d = INTRINSICS[u];
    if (d === needsEval && (d = doEval(u)), typeof d > "u" && !o)
      throw new $TypeError("intrinsic " + n + " exists, but is not available. Please file an issue!");
    return {
      alias: c,
      name: u,
      value: d
    };
  }
  throw new $SyntaxError("intrinsic " + n + " does not exist!");
}, getIntrinsic = function e(n, o) {
  if (typeof n != "string" || n.length === 0)
    throw new $TypeError("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof o != "boolean")
    throw new $TypeError('"allowMissing" argument must be a boolean');
  if ($exec(/^%?[^%]*%?$/, n) === null)
    throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var u = stringToPath(n), c = u.length > 0 ? u[0] : "", d = getBaseIntrinsic("%" + c + "%", o), m = d.name, v = d.value, S = !1, $ = d.alias;
  $ && (c = $[0], $spliceApply(u, $concat([0, 1], $)));
  for (var E = 1, O = !0; E < u.length; E += 1) {
    var T = u[E], y = $strSlice(T, 0, 1), V = $strSlice(T, -1);
    if ((y === '"' || y === "'" || y === "`" || V === '"' || V === "'" || V === "`") && y !== V)
      throw new $SyntaxError("property names with quotes must have matching quotes");
    if ((T === "constructor" || !O) && (S = !0), c += "." + T, m = "%" + c + "%", hasOwn(INTRINSICS, m))
      v = INTRINSICS[m];
    else if (v != null) {
      if (!(T in v)) {
        if (!o)
          throw new $TypeError("base intrinsic for " + n + " exists, but the property is not available.");
        return;
      }
      if ($gOPD && E + 1 >= u.length) {
        var M = $gOPD(v, T);
        O = !!M, O && "get" in M && !("originalValue" in M.get) ? v = M.get : v = v[T];
      } else
        O = hasOwn(v, T), v = v[T];
      O && !S && (INTRINSICS[m] = v);
    }
  }
  return v;
}, GetIntrinsic = getIntrinsic, $defineProperty = GetIntrinsic("%Object.defineProperty%", !0), hasPropertyDescriptors$1 = function e() {
  if ($defineProperty)
    try {
      return $defineProperty({}, "a", { value: 1 }), !0;
    } catch {
      return !1;
    }
  return !1;
};
hasPropertyDescriptors$1.hasArrayLengthDefineBug = function e() {
  if (!hasPropertyDescriptors$1())
    return null;
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors$1, keys$4 = objectKeys, hasSymbols = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", toStr = Object.prototype.toString, concat$c = Array.prototype.concat, origDefineProperty = Object.defineProperty, isFunction$6 = function(e) {
  return typeof e == "function" && toStr.call(e) === "[object Function]";
}, hasPropertyDescriptors = hasPropertyDescriptors_1(), supportsDescriptors = origDefineProperty && hasPropertyDescriptors, defineProperty = function(e, n, o, u) {
  if (n in e) {
    if (u === !0) {
      if (e[n] === o)
        return;
    } else if (!isFunction$6(u) || !u())
      return;
  }
  supportsDescriptors ? origDefineProperty(e, n, {
    configurable: !0,
    enumerable: !1,
    value: o,
    writable: !0
  }) : e[n] = o;
}, defineProperties$1 = function(e, n) {
  var o = arguments.length > 2 ? arguments[2] : {}, u = keys$4(n);
  hasSymbols && (u = concat$c.call(u, Object.getOwnPropertySymbols(n)));
  for (var c = 0; c < u.length; c += 1)
    defineProperty(e, u[c], n[u[c]], o[u[c]]);
};
defineProperties$1.supportsDescriptors = !!supportsDescriptors;
var defineProperties_1 = defineProperties$1, implementation_browser = { exports: {} };
typeof self < "u" ? implementation_browser.exports = self : typeof window < "u" ? implementation_browser.exports = window : implementation_browser.exports = Function("return this")();
var implementation_browserExports = implementation_browser.exports, implementation$1 = implementation_browserExports, polyfill$1 = function e() {
  return typeof commonjsGlobal != "object" || !commonjsGlobal || commonjsGlobal.Math !== Math || commonjsGlobal.Array !== Array ? implementation$1 : commonjsGlobal;
}, define = defineProperties_1, getPolyfill$1 = polyfill$1, shim$1 = function e() {
  var n = getPolyfill$1();
  if (define.supportsDescriptors) {
    var o = Object.getOwnPropertyDescriptor(n, "globalThis");
    (!o || o.configurable && (o.enumerable || !o.writable || globalThis !== n)) && Object.defineProperty(n, "globalThis", {
      configurable: !0,
      enumerable: !1,
      value: n,
      writable: !0
    });
  } else
    (typeof globalThis != "object" || globalThis !== n) && (n.globalThis = n);
  return n;
}, defineProperties = defineProperties_1, implementation = implementation_browserExports, getPolyfill = polyfill$1, shim = shim$1, polyfill = getPolyfill(), getGlobal = function() {
  return polyfill;
};
defineProperties(getGlobal, {
  getPolyfill,
  implementation,
  shim
});
var globalthis = getGlobal, __extends$1 = commonjsGlobal && commonjsGlobal.__extends || function() {
  var e = function(n, o) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, c) {
      u.__proto__ = c;
    } || function(u, c) {
      for (var d in c)
        c.hasOwnProperty(d) && (u[d] = c[d]);
    }, e(n, o);
  };
  return function(n, o) {
    e(n, o);
    function u() {
      this.constructor = n;
    }
    n.prototype = o === null ? Object.create(o) : (u.prototype = o.prototype, new u());
  };
}();
Object.defineProperty(xstream, "__esModule", { value: !0 });
xstream.NO_IL = xstream.NO = xstream.MemoryStream = xstream.Stream = void 0;
var ponyfill_1 = ponyfill, globalthis_1 = globalthis, $$observable = ponyfill_1.default(globalthis_1.getPolyfill()), NO = {};
xstream.NO = NO;
function noop$4() {
}
function cp(e) {
  for (var n = e.length, o = Array(n), u = 0; u < n; ++u)
    o[u] = e[u];
  return o;
}
function and(e, n) {
  return function(u) {
    return e(u) && n(u);
  };
}
function _try(e, n, o) {
  try {
    return e.f(n);
  } catch (u) {
    return o._e(u), NO;
  }
}
var NO_IL = {
  _n: noop$4,
  _e: noop$4,
  _c: noop$4
};
xstream.NO_IL = NO_IL;
function internalizeProducer(e) {
  e._start = function(o) {
    o.next = o._n, o.error = o._e, o.complete = o._c, this.start(o);
  }, e._stop = e.stop;
}
var StreamSub = (
  /** @class */
  function() {
    function e(n, o) {
      this._stream = n, this._listener = o;
    }
    return e.prototype.unsubscribe = function() {
      this._stream._remove(this._listener);
    }, e;
  }()
), Observer = (
  /** @class */
  function() {
    function e(n) {
      this._listener = n;
    }
    return e.prototype.next = function(n) {
      this._listener._n(n);
    }, e.prototype.error = function(n) {
      this._listener._e(n);
    }, e.prototype.complete = function() {
      this._listener._c();
    }, e;
  }()
), FromObservable = (
  /** @class */
  function() {
    function e(n) {
      this.type = "fromObservable", this.ins = n, this.active = !1;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.active = !0, this._sub = this.ins.subscribe(new Observer(n)), this.active || this._sub.unsubscribe();
    }, e.prototype._stop = function() {
      this._sub && this._sub.unsubscribe(), this.active = !1;
    }, e;
  }()
), Merge = (
  /** @class */
  function() {
    function e(n) {
      this.type = "merge", this.insArr = n, this.out = NO, this.ac = 0;
    }
    return e.prototype._start = function(n) {
      this.out = n;
      var o = this.insArr, u = o.length;
      this.ac = u;
      for (var c = 0; c < u; c++)
        o[c]._add(this);
    }, e.prototype._stop = function() {
      for (var n = this.insArr, o = n.length, u = 0; u < o; u++)
        n[u]._remove(this);
      this.out = NO;
    }, e.prototype._n = function(n) {
      var o = this.out;
      o !== NO && o._n(n);
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      if (--this.ac <= 0) {
        var n = this.out;
        if (n === NO)
          return;
        n._c();
      }
    }, e;
  }()
), CombineListener = (
  /** @class */
  function() {
    function e(n, o, u) {
      this.i = n, this.out = o, this.p = u, u.ils.push(this);
    }
    return e.prototype._n = function(n) {
      var o = this.p, u = this.out;
      if (u !== NO && o.up(n, this.i)) {
        var c = cp(o.vals);
        u._n(c);
      }
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      var n = this.p;
      n.out !== NO && --n.Nc === 0 && n.out._c();
    }, e;
  }()
), Combine = (
  /** @class */
  function() {
    function e(n) {
      this.type = "combine", this.insArr = n, this.out = NO, this.ils = [], this.Nc = this.Nn = 0, this.vals = [];
    }
    return e.prototype.up = function(n, o) {
      var u = this.vals[o], c = this.Nn ? u === NO ? --this.Nn : this.Nn : 0;
      return this.vals[o] = n, c === 0;
    }, e.prototype._start = function(n) {
      this.out = n;
      var o = this.insArr, u = this.Nc = this.Nn = o.length, c = this.vals = new Array(u);
      if (u === 0)
        n._n([]), n._c();
      else
        for (var d = 0; d < u; d++)
          c[d] = NO, o[d]._add(new CombineListener(d, n, this));
    }, e.prototype._stop = function() {
      for (var n = this.insArr, o = n.length, u = this.ils, c = 0; c < o; c++)
        n[c]._remove(u[c]);
      this.out = NO, this.ils = [], this.vals = [];
    }, e;
  }()
), FromArray = (
  /** @class */
  function() {
    function e(n) {
      this.type = "fromArray", this.a = n;
    }
    return e.prototype._start = function(n) {
      for (var o = this.a, u = 0, c = o.length; u < c; u++)
        n._n(o[u]);
      n._c();
    }, e.prototype._stop = function() {
    }, e;
  }()
), FromPromise = (
  /** @class */
  function() {
    function e(n) {
      this.type = "fromPromise", this.on = !1, this.p = n;
    }
    return e.prototype._start = function(n) {
      var o = this;
      this.on = !0, this.p.then(function(u) {
        o.on && (n._n(u), n._c());
      }, function(u) {
        n._e(u);
      }).then(noop$4, function(u) {
        setTimeout(function() {
          throw u;
        });
      });
    }, e.prototype._stop = function() {
      this.on = !1;
    }, e;
  }()
), Periodic = (
  /** @class */
  function() {
    function e(n) {
      this.type = "periodic", this.period = n, this.intervalID = -1, this.i = 0;
    }
    return e.prototype._start = function(n) {
      var o = this;
      function u() {
        n._n(o.i++);
      }
      this.intervalID = setInterval(u, this.period);
    }, e.prototype._stop = function() {
      this.intervalID !== -1 && clearInterval(this.intervalID), this.intervalID = -1, this.i = 0;
    }, e;
  }()
), Debug = (
  /** @class */
  function() {
    function e(n, o) {
      this.type = "debug", this.ins = n, this.out = NO, this.s = noop$4, this.l = "", typeof o == "string" ? this.l = o : typeof o == "function" && (this.s = o);
    }
    return e.prototype._start = function(n) {
      this.out = n, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(n) {
      var o = this.out;
      if (o !== NO) {
        var u = this.s, c = this.l;
        if (u !== noop$4)
          try {
            u(n);
          } catch (d) {
            o._e(d);
          }
        else
          c ? console.log(c + ":", n) : console.log(n);
        o._n(n);
      }
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      var n = this.out;
      n !== NO && n._c();
    }, e;
  }()
), Drop = (
  /** @class */
  function() {
    function e(n, o) {
      this.type = "drop", this.ins = o, this.out = NO, this.max = n, this.dropped = 0;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.dropped = 0, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(n) {
      var o = this.out;
      o !== NO && this.dropped++ >= this.max && o._n(n);
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      var n = this.out;
      n !== NO && n._c();
    }, e;
  }()
), EndWhenListener = (
  /** @class */
  function() {
    function e(n, o) {
      this.out = n, this.op = o;
    }
    return e.prototype._n = function() {
      this.op.end();
    }, e.prototype._e = function(n) {
      this.out._e(n);
    }, e.prototype._c = function() {
      this.op.end();
    }, e;
  }()
), EndWhen = (
  /** @class */
  function() {
    function e(n, o) {
      this.type = "endWhen", this.ins = o, this.out = NO, this.o = n, this.oil = NO_IL;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.o._add(this.oil = new EndWhenListener(n, this)), this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.o._remove(this.oil), this.out = NO, this.oil = NO_IL;
    }, e.prototype.end = function() {
      var n = this.out;
      n !== NO && n._c();
    }, e.prototype._n = function(n) {
      var o = this.out;
      o !== NO && o._n(n);
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      this.end();
    }, e;
  }()
), Filter = (
  /** @class */
  function() {
    function e(n, o) {
      this.type = "filter", this.ins = o, this.out = NO, this.f = n;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(n) {
      var o = this.out;
      if (o !== NO) {
        var u = _try(this, n, o);
        u === NO || !u || o._n(n);
      }
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      var n = this.out;
      n !== NO && n._c();
    }, e;
  }()
), FlattenListener = (
  /** @class */
  function() {
    function e(n, o) {
      this.out = n, this.op = o;
    }
    return e.prototype._n = function(n) {
      this.out._n(n);
    }, e.prototype._e = function(n) {
      this.out._e(n);
    }, e.prototype._c = function() {
      this.op.inner = NO, this.op.less();
    }, e;
  }()
), Flatten = (
  /** @class */
  function() {
    function e(n) {
      this.type = "flatten", this.ins = n, this.out = NO, this.open = !0, this.inner = NO, this.il = NO_IL;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.open = !0, this.inner = NO, this.il = NO_IL, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.inner !== NO && this.inner._remove(this.il), this.out = NO, this.open = !0, this.inner = NO, this.il = NO_IL;
    }, e.prototype.less = function() {
      var n = this.out;
      n !== NO && !this.open && this.inner === NO && n._c();
    }, e.prototype._n = function(n) {
      var o = this.out;
      if (o !== NO) {
        var u = this, c = u.inner, d = u.il;
        c !== NO && d !== NO_IL && c._remove(d), (this.inner = n)._add(this.il = new FlattenListener(o, this));
      }
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      this.open = !1, this.less();
    }, e;
  }()
), Fold = (
  /** @class */
  function() {
    function e(n, o, u) {
      var c = this;
      this.type = "fold", this.ins = u, this.out = NO, this.f = function(d) {
        return n(c.acc, d);
      }, this.acc = this.seed = o;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.acc = this.seed, n._n(this.acc), this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO, this.acc = this.seed;
    }, e.prototype._n = function(n) {
      var o = this.out;
      if (o !== NO) {
        var u = _try(this, n, o);
        u !== NO && o._n(this.acc = u);
      }
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      var n = this.out;
      n !== NO && n._c();
    }, e;
  }()
), Last = (
  /** @class */
  function() {
    function e(n) {
      this.type = "last", this.ins = n, this.out = NO, this.has = !1, this.val = NO;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.has = !1, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO, this.val = NO;
    }, e.prototype._n = function(n) {
      this.has = !0, this.val = n;
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      var n = this.out;
      n !== NO && (this.has ? (n._n(this.val), n._c()) : n._e(new Error("last() failed because input stream completed")));
    }, e;
  }()
), MapOp = (
  /** @class */
  function() {
    function e(n, o) {
      this.type = "map", this.ins = o, this.out = NO, this.f = n;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(n) {
      var o = this.out;
      if (o !== NO) {
        var u = _try(this, n, o);
        u !== NO && o._n(u);
      }
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      var n = this.out;
      n !== NO && n._c();
    }, e;
  }()
), Remember = (
  /** @class */
  function() {
    function e(n) {
      this.type = "remember", this.ins = n, this.out = NO;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.ins._add(n);
    }, e.prototype._stop = function() {
      this.ins._remove(this.out), this.out = NO;
    }, e;
  }()
), ReplaceError = (
  /** @class */
  function() {
    function e(n, o) {
      this.type = "replaceError", this.ins = o, this.out = NO, this.f = n;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(n) {
      var o = this.out;
      o !== NO && o._n(n);
    }, e.prototype._e = function(n) {
      var o = this.out;
      if (o !== NO)
        try {
          this.ins._remove(this), (this.ins = this.f(n))._add(this);
        } catch (u) {
          o._e(u);
        }
    }, e.prototype._c = function() {
      var n = this.out;
      n !== NO && n._c();
    }, e;
  }()
), StartWith = (
  /** @class */
  function() {
    function e(n, o) {
      this.type = "startWith", this.ins = n, this.out = NO, this.val = o;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.out._n(this.val), this.ins._add(n);
    }, e.prototype._stop = function() {
      this.ins._remove(this.out), this.out = NO;
    }, e;
  }()
), Take = (
  /** @class */
  function() {
    function e(n, o) {
      this.type = "take", this.ins = o, this.out = NO, this.max = n, this.taken = 0;
    }
    return e.prototype._start = function(n) {
      this.out = n, this.taken = 0, this.max <= 0 ? n._c() : this.ins._add(this);
    }, e.prototype._stop = function() {
      this.ins._remove(this), this.out = NO;
    }, e.prototype._n = function(n) {
      var o = this.out;
      if (o !== NO) {
        var u = ++this.taken;
        u < this.max ? o._n(n) : u === this.max && (o._n(n), o._c());
      }
    }, e.prototype._e = function(n) {
      var o = this.out;
      o !== NO && o._e(n);
    }, e.prototype._c = function() {
      var n = this.out;
      n !== NO && n._c();
    }, e;
  }()
), Stream = (
  /** @class */
  function() {
    function e(n) {
      this._prod = n || NO, this._ils = [], this._stopID = NO, this._dl = NO, this._d = !1, this._target = null, this._err = NO;
    }
    return e.prototype._n = function(n) {
      var o = this._ils, u = o.length;
      if (this._d && this._dl._n(n), u == 1)
        o[0]._n(n);
      else {
        if (u == 0)
          return;
        for (var c = cp(o), d = 0; d < u; d++)
          c[d]._n(n);
      }
    }, e.prototype._e = function(n) {
      if (this._err === NO) {
        this._err = n;
        var o = this._ils, u = o.length;
        if (this._x(), this._d && this._dl._e(n), u == 1)
          o[0]._e(n);
        else {
          if (u == 0)
            return;
          for (var c = cp(o), d = 0; d < u; d++)
            c[d]._e(n);
        }
        if (!this._d && u == 0)
          throw this._err;
      }
    }, e.prototype._c = function() {
      var n = this._ils, o = n.length;
      if (this._x(), this._d && this._dl._c(), o == 1)
        n[0]._c();
      else {
        if (o == 0)
          return;
        for (var u = cp(n), c = 0; c < o; c++)
          u[c]._c();
      }
    }, e.prototype._x = function() {
      this._ils.length !== 0 && (this._prod !== NO && this._prod._stop(), this._err = NO, this._ils = []);
    }, e.prototype._stopNow = function() {
      this._prod._stop(), this._err = NO, this._stopID = NO;
    }, e.prototype._add = function(n) {
      var o = this._target;
      if (o)
        return o._add(n);
      var u = this._ils;
      if (u.push(n), !(u.length > 1))
        if (this._stopID !== NO)
          clearTimeout(this._stopID), this._stopID = NO;
        else {
          var c = this._prod;
          c !== NO && c._start(this);
        }
    }, e.prototype._remove = function(n) {
      var o = this, u = this._target;
      if (u)
        return u._remove(n);
      var c = this._ils, d = c.indexOf(n);
      d > -1 && (c.splice(d, 1), this._prod !== NO && c.length <= 0 ? (this._err = NO, this._stopID = setTimeout(function() {
        return o._stopNow();
      })) : c.length === 1 && this._pruneCycles());
    }, e.prototype._pruneCycles = function() {
      this._hasNoSinks(this, []) && this._remove(this._ils[0]);
    }, e.prototype._hasNoSinks = function(n, o) {
      if (o.indexOf(n) !== -1)
        return !0;
      if (n.out === this)
        return !0;
      if (n.out && n.out !== NO)
        return this._hasNoSinks(n.out, o.concat(n));
      if (n._ils) {
        for (var u = 0, c = n._ils.length; u < c; u++)
          if (!this._hasNoSinks(n._ils[u], o.concat(n)))
            return !1;
        return !0;
      } else
        return !1;
    }, e.prototype.ctor = function() {
      return this instanceof MemoryStream ? MemoryStream : e;
    }, e.prototype.addListener = function(n) {
      n._n = n.next || noop$4, n._e = n.error || noop$4, n._c = n.complete || noop$4, this._add(n);
    }, e.prototype.removeListener = function(n) {
      this._remove(n);
    }, e.prototype.subscribe = function(n) {
      return this.addListener(n), new StreamSub(this, n);
    }, e.prototype[$$observable] = function() {
      return this;
    }, e.create = function(n) {
      if (n) {
        if (typeof n.start != "function" || typeof n.stop != "function")
          throw new Error("producer requires both start and stop functions");
        internalizeProducer(n);
      }
      return new e(n);
    }, e.createWithMemory = function(n) {
      return n && internalizeProducer(n), new MemoryStream(n);
    }, e.never = function() {
      return new e({ _start: noop$4, _stop: noop$4 });
    }, e.empty = function() {
      return new e({
        _start: function(n) {
          n._c();
        },
        _stop: noop$4
      });
    }, e.throw = function(n) {
      return new e({
        _start: function(o) {
          o._e(n);
        },
        _stop: noop$4
      });
    }, e.from = function(n) {
      if (typeof n[$$observable] == "function")
        return e.fromObservable(n);
      if (typeof n.then == "function")
        return e.fromPromise(n);
      if (Array.isArray(n))
        return e.fromArray(n);
      throw new TypeError("Type of input to from() must be an Array, Promise, or Observable");
    }, e.of = function() {
      for (var n = [], o = 0; o < arguments.length; o++)
        n[o] = arguments[o];
      return e.fromArray(n);
    }, e.fromArray = function(n) {
      return new e(new FromArray(n));
    }, e.fromPromise = function(n) {
      return new e(new FromPromise(n));
    }, e.fromObservable = function(n) {
      if (n.endWhen !== void 0)
        return n;
      var o = typeof n[$$observable] == "function" ? n[$$observable]() : n;
      return new e(new FromObservable(o));
    }, e.periodic = function(n) {
      return new e(new Periodic(n));
    }, e.prototype._map = function(n) {
      return new (this.ctor())(new MapOp(n, this));
    }, e.prototype.map = function(n) {
      return this._map(n);
    }, e.prototype.mapTo = function(n) {
      var o = this.map(function() {
        return n;
      }), u = o._prod;
      return u.type = "mapTo", o;
    }, e.prototype.filter = function(n) {
      var o = this._prod;
      return o instanceof Filter ? new e(new Filter(and(o.f, n), o.ins)) : new e(new Filter(n, this));
    }, e.prototype.take = function(n) {
      return new (this.ctor())(new Take(n, this));
    }, e.prototype.drop = function(n) {
      return new e(new Drop(n, this));
    }, e.prototype.last = function() {
      return new e(new Last(this));
    }, e.prototype.startWith = function(n) {
      return new MemoryStream(new StartWith(this, n));
    }, e.prototype.endWhen = function(n) {
      return new (this.ctor())(new EndWhen(n, this));
    }, e.prototype.fold = function(n, o) {
      return new MemoryStream(new Fold(n, o, this));
    }, e.prototype.replaceError = function(n) {
      return new (this.ctor())(new ReplaceError(n, this));
    }, e.prototype.flatten = function() {
      return new e(new Flatten(this));
    }, e.prototype.compose = function(n) {
      return n(this);
    }, e.prototype.remember = function() {
      return new MemoryStream(new Remember(this));
    }, e.prototype.debug = function(n) {
      return new (this.ctor())(new Debug(this, n));
    }, e.prototype.imitate = function(n) {
      if (n instanceof MemoryStream)
        throw new Error("A MemoryStream was given to imitate(), but it only supports a Stream. Read more about this restriction here: https://github.com/staltz/xstream#faq");
      this._target = n;
      for (var o = this._ils, u = o.length, c = 0; c < u; c++)
        n._add(o[c]);
      this._ils = [];
    }, e.prototype.shamefullySendNext = function(n) {
      this._n(n);
    }, e.prototype.shamefullySendError = function(n) {
      this._e(n);
    }, e.prototype.shamefullySendComplete = function() {
      this._c();
    }, e.prototype.setDebugListener = function(n) {
      n ? (this._d = !0, n._n = n.next || noop$4, n._e = n.error || noop$4, n._c = n.complete || noop$4, this._dl = n) : (this._d = !1, this._dl = NO);
    }, e.merge = function() {
      for (var o = [], u = 0; u < arguments.length; u++)
        o[u] = arguments[u];
      return new e(new Merge(o));
    }, e.combine = function() {
      for (var o = [], u = 0; u < arguments.length; u++)
        o[u] = arguments[u];
      return new e(new Combine(o));
    }, e;
  }()
);
xstream.Stream = Stream;
var MemoryStream = (
  /** @class */
  function(e) {
    __extends$1(n, e);
    function n(o) {
      var u = e.call(this, o) || this;
      return u._has = !1, u;
    }
    return n.prototype._n = function(o) {
      this._v = o, this._has = !0, e.prototype._n.call(this, o);
    }, n.prototype._add = function(o) {
      var u = this._target;
      if (u)
        return u._add(o);
      var c = this._ils;
      if (c.push(o), c.length > 1) {
        this._has && o._n(this._v);
        return;
      }
      if (this._stopID !== NO)
        this._has && o._n(this._v), clearTimeout(this._stopID), this._stopID = NO;
      else if (this._has)
        o._n(this._v);
      else {
        var d = this._prod;
        d !== NO && d._start(this);
      }
    }, n.prototype._stopNow = function() {
      this._has = !1, e.prototype._stopNow.call(this);
    }, n.prototype._x = function() {
      this._has = !1, e.prototype._x.call(this);
    }, n.prototype.map = function(o) {
      return this._map(o);
    }, n.prototype.mapTo = function(o) {
      return e.prototype.mapTo.call(this, o);
    }, n.prototype.take = function(o) {
      return e.prototype.take.call(this, o);
    }, n.prototype.endWhen = function(o) {
      return e.prototype.endWhen.call(this, o);
    }, n.prototype.replaceError = function(o) {
      return e.prototype.replaceError.call(this, o);
    }, n.prototype.remember = function() {
      return this;
    }, n.prototype.debug = function(o) {
      return e.prototype.debug.call(this, o);
    }, n;
  }(Stream)
);
xstream.MemoryStream = MemoryStream;
var xs = Stream;
xstream.default = xs;
Object.defineProperty(concat$d, "__esModule", { value: !0 });
concat$d.concat = void 0;
const xstream_1$t = xstream;
function concat$b(...e) {
  const n = new Array(), o = new Array(), u = /* @__PURE__ */ new Set();
  let c = 0;
  function d() {
    for (; n.length > 0; )
      n.shift().unsubscribe();
    o.length = 0, u.clear(), c = 0;
  }
  const m = {
    start: (v) => {
      e.forEach((E) => o.push([]));
      function S(E) {
        for (; ; ) {
          const O = o[E].shift();
          if (O === void 0)
            return;
          v.next(O);
        }
      }
      function $() {
        return c >= e.length;
      }
      if ($()) {
        v.complete();
        return;
      }
      e.forEach((E, O) => {
        n.push(E.subscribe({
          next: (T) => {
            O === c ? v.next(T) : o[O].push(T);
          },
          complete: () => {
            for (u.add(O); u.has(c); )
              S(c), c++;
            $() ? v.complete() : S(c);
          },
          error: (T) => {
            v.error(T), d();
          }
        }));
      });
    },
    stop: () => {
      d();
    }
  };
  return xstream_1$t.Stream.create(m);
}
concat$d.concat = concat$b;
var defaultvalueproducer$5 = {};
Object.defineProperty(defaultvalueproducer$5, "__esModule", { value: !0 });
defaultvalueproducer$5.DefaultValueProducer = void 0;
let DefaultValueProducer$5 = class {
  get value() {
    return this.internalValue;
  }
  constructor(n, o) {
    this.callbacks = o, this.internalValue = n;
  }
  /**
   * Update the current value.
   *
   * If producer is active (i.e. someone is listening), this emits an event.
   * If not, just the current value is updated.
   */
  update(n) {
    this.internalValue = n, this.listener && this.listener.next(n);
  }
  /**
   * Produce an error
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error(n) {
    this.listener && this.listener.error(n);
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  start(n) {
    this.listener = n, n.next(this.internalValue), this.callbacks && this.callbacks.onStarted();
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  stop() {
    this.callbacks && this.callbacks.onStop(), this.listener = void 0;
  }
};
defaultvalueproducer$5.DefaultValueProducer = DefaultValueProducer$5;
var dropduplicates$5 = {};
Object.defineProperty(dropduplicates$5, "__esModule", { value: !0 });
dropduplicates$5.dropDuplicates = void 0;
function dropDuplicates$5(e) {
  return (o) => {
    const u = /* @__PURE__ */ new Set();
    return o.filter((d) => !u.has(e(d))).debug((d) => u.add(e(d)));
  };
}
dropduplicates$5.dropDuplicates = dropDuplicates$5;
var promise$5 = {};
Object.defineProperty(promise$5, "__esModule", { value: !0 });
promise$5.firstEvent = promise$5.toListPromise = promise$5.fromListPromise = void 0;
const xstream_1$s = xstream;
function fromListPromise$5(e) {
  const n = {
    start: (o) => {
      e.then((u) => {
        for (const c of u)
          o.next(c);
        o.complete();
      }).catch((u) => o.error(u));
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    stop: () => {
    }
  };
  return xstream_1$s.Stream.create(n);
}
promise$5.fromListPromise = fromListPromise$5;
async function toListPromise$5(e, n) {
  return new Promise((o, u) => {
    if (n === 0) {
      o([]);
      return;
    }
    const c = new Array();
    e.take(n).subscribe({
      next: (d) => {
        c.push(d), c.length === n && o(c);
      },
      complete: () => {
        u(`Stream completed before all events could be collected. Collected ${c.length}, expected ${n}`);
      },
      error: (d) => u(d)
    });
  });
}
promise$5.toListPromise = toListPromise$5;
async function firstEvent$5(e) {
  return (await toListPromise$5(e, 1))[0];
}
promise$5.firstEvent = firstEvent$5;
var reducer$5 = {};
Object.defineProperty(reducer$5, "__esModule", { value: !0 });
reducer$5.lastValue = reducer$5.asArray = reducer$5.countStream = reducer$5.Reducer = void 0;
let Reducer$5 = class {
  constructor(n, o, u) {
    this.stream = n, this.reducer = o, this.state = u, this.completed = new Promise((c, d) => {
      const m = this.stream.subscribe({
        next: (v) => {
          this.state = this.reducer(this.state, v);
        },
        complete: () => {
          c(), m.unsubscribe();
        },
        error: (v) => {
          d(v), m.unsubscribe();
        }
      });
    });
  }
  // value returns current materialized state
  value() {
    return this.state;
  }
  // finished resolves on completed stream, rejects on stream error
  async finished() {
    return this.completed;
  }
};
reducer$5.Reducer = Reducer$5;
function increment$5(e, n) {
  return e + 1;
}
function countStream$5(e) {
  return new Reducer$5(e, increment$5, 0);
}
reducer$5.countStream = countStream$5;
function append$5(e, n) {
  return [...e, n];
}
function asArray$5(e) {
  return new Reducer$5(e, append$5, []);
}
reducer$5.asArray = asArray$5;
function last$5(e, n) {
  return n;
}
function lastValue$5(e) {
  return new Reducer$5(e, last$5, void 0);
}
reducer$5.lastValue = lastValue$5;
var valueandupdates$5 = {};
Object.defineProperty(valueandupdates$5, "__esModule", { value: !0 });
valueandupdates$5.ValueAndUpdates = void 0;
const xstream_1$r = xstream;
let ValueAndUpdates$5 = class {
  get value() {
    return this.producer.value;
  }
  constructor(n) {
    this.producer = n, this.updates = xstream_1$r.MemoryStream.createWithMemory(this.producer);
  }
  /**
   * Resolves as soon as search value is found.
   *
   * @param search either a value or a function that must return true when found
   * @returns the value of the update that caused the search match
   */
  async waitFor(n) {
    const o = typeof n == "function" ? n : (u) => u === n;
    return new Promise((u, c) => {
      const d = this.updates.subscribe({
        next: (m) => {
          o(m) && (u(m), setTimeout(() => d.unsubscribe(), 0));
        },
        complete: () => {
          d.unsubscribe(), c("Update stream completed without expected value");
        },
        error: (m) => {
          c(m);
        }
      });
    });
  }
};
valueandupdates$5.ValueAndUpdates = ValueAndUpdates$5;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(S, $, E, O) {
    O === void 0 && (O = E);
    var T = Object.getOwnPropertyDescriptor($, E);
    (!T || ("get" in T ? !$.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return $[E];
    } }), Object.defineProperty(S, O, T);
  } : function(S, $, E, O) {
    O === void 0 && (O = E), S[O] = $[E];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(S, $) {
    for (var E in S)
      E !== "default" && !Object.prototype.hasOwnProperty.call($, E) && n($, S, E);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueAndUpdates = e.toListPromise = e.fromListPromise = e.firstEvent = e.dropDuplicates = e.DefaultValueProducer = e.concat = void 0;
  var u = concat$d;
  Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
    return u.concat;
  } });
  var c = defaultvalueproducer$5;
  Object.defineProperty(e, "DefaultValueProducer", { enumerable: !0, get: function() {
    return c.DefaultValueProducer;
  } });
  var d = dropduplicates$5;
  Object.defineProperty(e, "dropDuplicates", { enumerable: !0, get: function() {
    return d.dropDuplicates;
  } });
  var m = promise$5;
  Object.defineProperty(e, "firstEvent", { enumerable: !0, get: function() {
    return m.firstEvent;
  } }), Object.defineProperty(e, "fromListPromise", { enumerable: !0, get: function() {
    return m.fromListPromise;
  } }), Object.defineProperty(e, "toListPromise", { enumerable: !0, get: function() {
    return m.toListPromise;
  } }), o(reducer$5, e);
  var v = valueandupdates$5;
  Object.defineProperty(e, "ValueAndUpdates", { enumerable: !0, get: function() {
    return v.ValueAndUpdates;
  } });
})(build$D);
Object.defineProperty(queryclient$2, "__esModule", { value: !0 });
queryclient$2.QueryClient = void 0;
const ics23_1$1 = build$E, encoding_1$1b = build$F, stream_1$9 = build$D, utils_1$V = build$G;
function checkAndParseOp$1(e, n, o) {
  if (e.type !== n)
    throw new Error(`Op expected to be ${n}, got "${e.type}`);
  if (!(0, utils_1$V.arrayContentEquals)(o, e.key))
    throw new Error(`Proven key different than queried key.
Query: ${(0, encoding_1$1b.toHex)(o)}
Proven: ${(0, encoding_1$1b.toHex)(e.key)}`);
  return ics23_1$1.ics23.CommitmentProof.decode(e.data);
}
let QueryClient$1 = class Hc {
  static withExtensions(n, ...o) {
    const u = new Hc(n), c = o.map((d) => d(u));
    for (const d of c) {
      (0, utils_1$V.assert)((0, utils_1$V.isNonNullObject)(d), "Extension must be a non-null object");
      for (const [m, v] of Object.entries(d)) {
        (0, utils_1$V.assert)((0, utils_1$V.isNonNullObject)(v), `Module must be a non-null object. Found type ${typeof v} for module "${m}".`);
        const S = u[m] || {};
        u[m] = {
          ...S,
          ...v
        };
      }
    }
    return u;
  }
  constructor(n) {
    this.cometClient = n;
  }
  /**
   * Queries the database store with a proof, which is then verified.
   *
   * Please note: the current implementation trusts block headers it gets from the PRC endpoint.
   */
  async queryStoreVerified(n, o, u) {
    const { height: c, proof: d, key: m, value: v } = await this.queryRawProof(n, o, u), S = checkAndParseOp$1(d.ops[0], "ics23:iavl", o), $ = checkAndParseOp$1(d.ops[1], "ics23:simple", (0, encoding_1$1b.toAscii)(n));
    (0, utils_1$V.assert)($.exist), (0, utils_1$V.assert)($.exist.value), !v || v.length === 0 ? ((0, utils_1$V.assert)(S.nonexist), (0, ics23_1$1.verifyNonExistence)(S.nonexist, ics23_1$1.iavlSpec, $.exist.value, o)) : ((0, utils_1$V.assert)(S.exist), (0, utils_1$V.assert)(S.exist.value), (0, ics23_1$1.verifyExistence)(S.exist, ics23_1$1.iavlSpec, $.exist.value, o, v));
    const E = await this.getNextHeader(c);
    return (0, ics23_1$1.verifyExistence)($.exist, ics23_1$1.tendermintSpec, E.appHash, (0, encoding_1$1b.toAscii)(n), $.exist.value), { key: m, value: v, height: c };
  }
  async queryRawProof(n, o, u) {
    const { key: c, value: d, height: m, proof: v, code: S, log: $ } = await this.cometClient.abciQuery({
      // we need the StoreKey for the module, not the module name
      // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
      path: `/store/${n}/key`,
      data: o,
      prove: !0,
      height: u
    });
    if (S)
      throw new Error(`Query failed with (${S}): ${$}`);
    if (!(0, utils_1$V.arrayContentEquals)(o, c))
      throw new Error(`Response key ${(0, encoding_1$1b.toHex)(c)} doesn't match query key ${(0, encoding_1$1b.toHex)(o)}`);
    if (!m)
      throw new Error("No query height returned");
    if (!v || v.ops.length !== 2)
      throw new Error(`Expected 2 proof ops, got ${(v == null ? void 0 : v.ops.length) ?? 0}. Are you using stargate?`);
    return checkAndParseOp$1(v.ops[0], "ics23:iavl", c), checkAndParseOp$1(v.ops[1], "ics23:simple", (0, encoding_1$1b.toAscii)(n)), {
      key: c,
      value: d,
      height: m,
      // need to clone this: readonly input / writeable output
      proof: {
        ops: [...v.ops]
      }
    };
  }
  /**
   * Performs an ABCI query to Tendermint without requesting a proof.
   *
   * If the `desiredHeight` is set, a particular height is requested. Otherwise
   * the latest height is requested. The response contains the actual height of
   * the query.
   */
  async queryAbci(n, o, u) {
    const c = await this.cometClient.abciQuery({
      path: n,
      data: o,
      prove: !1,
      height: u
    });
    if (c.code)
      throw new Error(`Query failed with (${c.code}): ${c.log}`);
    if (!c.height)
      throw new Error("No query height returned");
    return {
      value: c.value,
      height: c.height
    };
  }
  // this must return the header for height+1
  // throws an error if height is 0 or undefined
  async getNextHeader(n) {
    if ((0, utils_1$V.assertDefined)(n), n === 0)
      throw new Error("Query returned height 0, cannot prove it");
    const o = n + 1;
    let u, c;
    try {
      c = this.cometClient.subscribeNewBlockHeader();
    } catch {
    }
    if (c) {
      const d = await (0, stream_1$9.firstEvent)(c);
      d.height === o && (u = d);
    }
    for (; !u; ) {
      const d = (await this.cometClient.blockchain(n, o)).blockMetas.map((m) => m.header).find((m) => m.height === o);
      d ? u = d : await (0, utils_1$V.sleep)(1e3);
    }
    return (0, utils_1$V.assert)(u.height === o, "Got wrong header. This is a bug in the logic above."), u;
  }
};
queryclient$2.QueryClient = QueryClient$1;
var utils$y = {};
Object.defineProperty(utils$y, "__esModule", { value: !0 });
utils$y.decodeCosmosSdkDecFromProto = utils$y.longify = utils$y.createProtobufRpcClient = utils$y.createPagination = utils$y.toAccAddress = void 0;
const encoding_1$1a = build$F, math_1$r = build$R, pagination_1$1 = pagination;
function toAccAddress$1(e) {
  return (0, encoding_1$1a.fromBech32)(e).data;
}
utils$y.toAccAddress = toAccAddress$1;
function createPagination$1(e) {
  return e ? pagination_1$1.PageRequest.fromPartial({ key: e }) : pagination_1$1.PageRequest.fromPartial({});
}
utils$y.createPagination = createPagination$1;
function createProtobufRpcClient$1(e) {
  return {
    request: async (n, o, u) => {
      const c = `/${n}/${o}`;
      return (await e.queryAbci(c, u, void 0)).value;
    }
  };
}
utils$y.createProtobufRpcClient = createProtobufRpcClient$1;
function longify$1(e) {
  const n = math_1$r.Uint64.fromString(e.toString());
  return BigInt(n.toString());
}
utils$y.longify = longify$1;
function decodeCosmosSdkDecFromProto$1(e) {
  const n = typeof e == "string" ? e : (0, encoding_1$1a.fromAscii)(e);
  return math_1$r.Decimal.fromAtomics(n, 18);
}
utils$y.decodeCosmosSdkDecFromProto = decodeCosmosSdkDecFromProto$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.longify = e.decodeCosmosSdkDecFromProto = e.createProtobufRpcClient = e.createPagination = e.QueryClient = void 0;
  var n = queryclient$2;
  Object.defineProperty(e, "QueryClient", { enumerable: !0, get: function() {
    return n.QueryClient;
  } });
  var o = utils$y;
  Object.defineProperty(e, "createPagination", { enumerable: !0, get: function() {
    return o.createPagination;
  } }), Object.defineProperty(e, "createProtobufRpcClient", { enumerable: !0, get: function() {
    return o.createProtobufRpcClient;
  } }), Object.defineProperty(e, "decodeCosmosSdkDecFromProto", { enumerable: !0, get: function() {
    return o.decodeCosmosSdkDecFromProto;
  } }), Object.defineProperty(e, "longify", { enumerable: !0, get: function() {
    return o.longify;
  } });
})(queryclient$3);
Object.defineProperty(queries$m, "__esModule", { value: !0 });
queries$m.setupAuthExtension = void 0;
const query_1$k = query$d, queryclient_1$p = queryclient$3;
function setupAuthExtension$1(e) {
  const n = (0, queryclient_1$p.createProtobufRpcClient)(e), o = new query_1$k.QueryClientImpl(n);
  return {
    auth: {
      account: async (u) => {
        const { account: c } = await o.Account({ address: u });
        return c ?? null;
      }
    }
  };
}
queries$m.setupAuthExtension = setupAuthExtension$1;
var aminomessages$n = {};
Object.defineProperty(aminomessages$n, "__esModule", { value: !0 });
aminomessages$n.createAuthzAminoConverters = void 0;
function createAuthzAminoConverters$1() {
  return {
    // For Cosmos SDK < 0.46 the Amino JSON codec was broken on chain and thus inaccessible.
    // Now this can be implemented for 0.46+ chains, see
    // https://github.com/cosmos/cosmjs/issues/1092
    //
    // "/cosmos.authz.v1beta1.MsgGrant": IMPLEMENT ME,
    // "/cosmos.authz.v1beta1.MsgExec": IMPLEMENT ME,
    // "/cosmos.authz.v1beta1.MsgRevoke": IMPLEMENT ME,
  };
}
aminomessages$n.createAuthzAminoConverters = createAuthzAminoConverters$1;
var messages$i = {}, tx$n = {}, authz$3 = {}, timestamp$1 = {};
Object.defineProperty(timestamp$1, "__esModule", { value: !0 });
timestamp$1.Timestamp = timestamp$1.protobufPackage = void 0;
const binary_1$9 = binary, helpers_1$9 = helpers;
timestamp$1.protobufPackage = "google.protobuf";
function createBaseTimestamp$1() {
  return {
    seconds: BigInt(0),
    nanos: 0
  };
}
timestamp$1.Timestamp = {
  typeUrl: "/google.protobuf.Timestamp",
  encode(e, n = binary_1$9.BinaryWriter.create()) {
    return e.seconds !== BigInt(0) && n.uint32(8).int64(e.seconds), e.nanos !== 0 && n.uint32(16).int32(e.nanos), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$9.BinaryReader ? e : new binary_1$9.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTimestamp$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.seconds = o.int64();
          break;
        case 2:
          c.nanos = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseTimestamp$1();
    return (0, helpers_1$9.isSet)(e.seconds) && (n.seconds = BigInt(e.seconds.toString())), (0, helpers_1$9.isSet)(e.nanos) && (n.nanos = Number(e.nanos)), n;
  },
  toJSON(e) {
    const n = {};
    return e.seconds !== void 0 && (n.seconds = (e.seconds || BigInt(0)).toString()), e.nanos !== void 0 && (n.nanos = Math.round(e.nanos)), n;
  },
  fromPartial(e) {
    const n = createBaseTimestamp$1();
    return e.seconds !== void 0 && e.seconds !== null && (n.seconds = BigInt(e.seconds.toString())), n.nanos = e.nanos ?? 0, n;
  }
};
Object.defineProperty(authz$3, "__esModule", { value: !0 });
authz$3.GrantQueueItem = authz$3.GrantAuthorization = authz$3.Grant = authz$3.GenericAuthorization = authz$3.protobufPackage = void 0;
const any_1$4 = any$1, timestamp_1$1 = timestamp$1, binary_1$8 = binary, helpers_1$8 = helpers;
authz$3.protobufPackage = "cosmos.authz.v1beta1";
function createBaseGenericAuthorization$1() {
  return {
    msg: ""
  };
}
authz$3.GenericAuthorization = {
  typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
  encode(e, n = binary_1$8.BinaryWriter.create()) {
    return e.msg !== "" && n.uint32(10).string(e.msg), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$8.BinaryReader ? e : new binary_1$8.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenericAuthorization$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.msg = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseGenericAuthorization$1();
    return (0, helpers_1$8.isSet)(e.msg) && (n.msg = String(e.msg)), n;
  },
  toJSON(e) {
    const n = {};
    return e.msg !== void 0 && (n.msg = e.msg), n;
  },
  fromPartial(e) {
    const n = createBaseGenericAuthorization$1();
    return n.msg = e.msg ?? "", n;
  }
};
function createBaseGrant$1() {
  return {
    authorization: void 0,
    expiration: void 0
  };
}
authz$3.Grant = {
  typeUrl: "/cosmos.authz.v1beta1.Grant",
  encode(e, n = binary_1$8.BinaryWriter.create()) {
    return e.authorization !== void 0 && any_1$4.Any.encode(e.authorization, n.uint32(10).fork()).ldelim(), e.expiration !== void 0 && timestamp_1$1.Timestamp.encode(e.expiration, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$8.BinaryReader ? e : new binary_1$8.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGrant$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authorization = any_1$4.Any.decode(o, o.uint32());
          break;
        case 2:
          c.expiration = timestamp_1$1.Timestamp.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseGrant$1();
    return (0, helpers_1$8.isSet)(e.authorization) && (n.authorization = any_1$4.Any.fromJSON(e.authorization)), (0, helpers_1$8.isSet)(e.expiration) && (n.expiration = (0, helpers_1$8.fromJsonTimestamp)(e.expiration)), n;
  },
  toJSON(e) {
    const n = {};
    return e.authorization !== void 0 && (n.authorization = e.authorization ? any_1$4.Any.toJSON(e.authorization) : void 0), e.expiration !== void 0 && (n.expiration = (0, helpers_1$8.fromTimestamp)(e.expiration).toISOString()), n;
  },
  fromPartial(e) {
    const n = createBaseGrant$1();
    return e.authorization !== void 0 && e.authorization !== null && (n.authorization = any_1$4.Any.fromPartial(e.authorization)), e.expiration !== void 0 && e.expiration !== null && (n.expiration = timestamp_1$1.Timestamp.fromPartial(e.expiration)), n;
  }
};
function createBaseGrantAuthorization$1() {
  return {
    granter: "",
    grantee: "",
    authorization: void 0,
    expiration: void 0
  };
}
authz$3.GrantAuthorization = {
  typeUrl: "/cosmos.authz.v1beta1.GrantAuthorization",
  encode(e, n = binary_1$8.BinaryWriter.create()) {
    return e.granter !== "" && n.uint32(10).string(e.granter), e.grantee !== "" && n.uint32(18).string(e.grantee), e.authorization !== void 0 && any_1$4.Any.encode(e.authorization, n.uint32(26).fork()).ldelim(), e.expiration !== void 0 && timestamp_1$1.Timestamp.encode(e.expiration, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$8.BinaryReader ? e : new binary_1$8.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGrantAuthorization$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.granter = o.string();
          break;
        case 2:
          c.grantee = o.string();
          break;
        case 3:
          c.authorization = any_1$4.Any.decode(o, o.uint32());
          break;
        case 4:
          c.expiration = timestamp_1$1.Timestamp.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseGrantAuthorization$1();
    return (0, helpers_1$8.isSet)(e.granter) && (n.granter = String(e.granter)), (0, helpers_1$8.isSet)(e.grantee) && (n.grantee = String(e.grantee)), (0, helpers_1$8.isSet)(e.authorization) && (n.authorization = any_1$4.Any.fromJSON(e.authorization)), (0, helpers_1$8.isSet)(e.expiration) && (n.expiration = (0, helpers_1$8.fromJsonTimestamp)(e.expiration)), n;
  },
  toJSON(e) {
    const n = {};
    return e.granter !== void 0 && (n.granter = e.granter), e.grantee !== void 0 && (n.grantee = e.grantee), e.authorization !== void 0 && (n.authorization = e.authorization ? any_1$4.Any.toJSON(e.authorization) : void 0), e.expiration !== void 0 && (n.expiration = (0, helpers_1$8.fromTimestamp)(e.expiration).toISOString()), n;
  },
  fromPartial(e) {
    const n = createBaseGrantAuthorization$1();
    return n.granter = e.granter ?? "", n.grantee = e.grantee ?? "", e.authorization !== void 0 && e.authorization !== null && (n.authorization = any_1$4.Any.fromPartial(e.authorization)), e.expiration !== void 0 && e.expiration !== null && (n.expiration = timestamp_1$1.Timestamp.fromPartial(e.expiration)), n;
  }
};
function createBaseGrantQueueItem() {
  return {
    msgTypeUrls: []
  };
}
authz$3.GrantQueueItem = {
  typeUrl: "/cosmos.authz.v1beta1.GrantQueueItem",
  encode(e, n = binary_1$8.BinaryWriter.create()) {
    for (const o of e.msgTypeUrls)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$8.BinaryReader ? e : new binary_1$8.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGrantQueueItem();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.msgTypeUrls.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseGrantQueueItem();
    return Array.isArray(e == null ? void 0 : e.msgTypeUrls) && (n.msgTypeUrls = e.msgTypeUrls.map((o) => String(o))), n;
  },
  toJSON(e) {
    const n = {};
    return e.msgTypeUrls ? n.msgTypeUrls = e.msgTypeUrls.map((o) => o) : n.msgTypeUrls = [], n;
  },
  fromPartial(e) {
    var o;
    const n = createBaseGrantQueueItem();
    return n.msgTypeUrls = ((o = e.msgTypeUrls) == null ? void 0 : o.map((u) => u)) || [], n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgRevokeResponse = e.MsgRevoke = e.MsgGrantResponse = e.MsgExec = e.MsgExecResponse = e.MsgGrant = e.protobufPackage = void 0;
  const n = authz$3, o = any$1, u = binary, c = helpers;
  e.protobufPackage = "cosmos.authz.v1beta1";
  function d() {
    return {
      granter: "",
      grantee: "",
      grant: n.Grant.fromPartial({})
    };
  }
  e.MsgGrant = {
    typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
    encode(T, y = u.BinaryWriter.create()) {
      return T.granter !== "" && y.uint32(10).string(T.granter), T.grantee !== "" && y.uint32(18).string(T.grantee), T.grant !== void 0 && n.Grant.encode(T.grant, y.uint32(26).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = d();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.granter = V.string();
            break;
          case 2:
            G.grantee = V.string();
            break;
          case 3:
            G.grant = n.Grant.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = d();
      return (0, c.isSet)(T.granter) && (y.granter = String(T.granter)), (0, c.isSet)(T.grantee) && (y.grantee = String(T.grantee)), (0, c.isSet)(T.grant) && (y.grant = n.Grant.fromJSON(T.grant)), y;
    },
    toJSON(T) {
      const y = {};
      return T.granter !== void 0 && (y.granter = T.granter), T.grantee !== void 0 && (y.grantee = T.grantee), T.grant !== void 0 && (y.grant = T.grant ? n.Grant.toJSON(T.grant) : void 0), y;
    },
    fromPartial(T) {
      const y = d();
      return y.granter = T.granter ?? "", y.grantee = T.grantee ?? "", T.grant !== void 0 && T.grant !== null && (y.grant = n.Grant.fromPartial(T.grant)), y;
    }
  };
  function m() {
    return {
      results: []
    };
  }
  e.MsgExecResponse = {
    typeUrl: "/cosmos.authz.v1beta1.MsgExecResponse",
    encode(T, y = u.BinaryWriter.create()) {
      for (const V of T.results)
        y.uint32(10).bytes(V);
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = m();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.results.push(V.bytes());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = m();
      return Array.isArray(T == null ? void 0 : T.results) && (y.results = T.results.map((V) => (0, c.bytesFromBase64)(V))), y;
    },
    toJSON(T) {
      const y = {};
      return T.results ? y.results = T.results.map((V) => (0, c.base64FromBytes)(V !== void 0 ? V : new Uint8Array())) : y.results = [], y;
    },
    fromPartial(T) {
      var V;
      const y = m();
      return y.results = ((V = T.results) == null ? void 0 : V.map((M) => M)) || [], y;
    }
  };
  function v() {
    return {
      grantee: "",
      msgs: []
    };
  }
  e.MsgExec = {
    typeUrl: "/cosmos.authz.v1beta1.MsgExec",
    encode(T, y = u.BinaryWriter.create()) {
      T.grantee !== "" && y.uint32(10).string(T.grantee);
      for (const V of T.msgs)
        o.Any.encode(V, y.uint32(18).fork()).ldelim();
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = v();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.grantee = V.string();
            break;
          case 2:
            G.msgs.push(o.Any.decode(V, V.uint32()));
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = v();
      return (0, c.isSet)(T.grantee) && (y.grantee = String(T.grantee)), Array.isArray(T == null ? void 0 : T.msgs) && (y.msgs = T.msgs.map((V) => o.Any.fromJSON(V))), y;
    },
    toJSON(T) {
      const y = {};
      return T.grantee !== void 0 && (y.grantee = T.grantee), T.msgs ? y.msgs = T.msgs.map((V) => V ? o.Any.toJSON(V) : void 0) : y.msgs = [], y;
    },
    fromPartial(T) {
      var V;
      const y = v();
      return y.grantee = T.grantee ?? "", y.msgs = ((V = T.msgs) == null ? void 0 : V.map((M) => o.Any.fromPartial(M))) || [], y;
    }
  };
  function S() {
    return {};
  }
  e.MsgGrantResponse = {
    typeUrl: "/cosmos.authz.v1beta1.MsgGrantResponse",
    encode(T, y = u.BinaryWriter.create()) {
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = S();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      return S();
    },
    toJSON(T) {
      return {};
    },
    fromPartial(T) {
      return S();
    }
  };
  function $() {
    return {
      granter: "",
      grantee: "",
      msgTypeUrl: ""
    };
  }
  e.MsgRevoke = {
    typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
    encode(T, y = u.BinaryWriter.create()) {
      return T.granter !== "" && y.uint32(10).string(T.granter), T.grantee !== "" && y.uint32(18).string(T.grantee), T.msgTypeUrl !== "" && y.uint32(26).string(T.msgTypeUrl), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = $();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.granter = V.string();
            break;
          case 2:
            G.grantee = V.string();
            break;
          case 3:
            G.msgTypeUrl = V.string();
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = $();
      return (0, c.isSet)(T.granter) && (y.granter = String(T.granter)), (0, c.isSet)(T.grantee) && (y.grantee = String(T.grantee)), (0, c.isSet)(T.msgTypeUrl) && (y.msgTypeUrl = String(T.msgTypeUrl)), y;
    },
    toJSON(T) {
      const y = {};
      return T.granter !== void 0 && (y.granter = T.granter), T.grantee !== void 0 && (y.grantee = T.grantee), T.msgTypeUrl !== void 0 && (y.msgTypeUrl = T.msgTypeUrl), y;
    },
    fromPartial(T) {
      const y = $();
      return y.granter = T.granter ?? "", y.grantee = T.grantee ?? "", y.msgTypeUrl = T.msgTypeUrl ?? "", y;
    }
  };
  function E() {
    return {};
  }
  e.MsgRevokeResponse = {
    typeUrl: "/cosmos.authz.v1beta1.MsgRevokeResponse",
    encode(T, y = u.BinaryWriter.create()) {
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = E();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      return E();
    },
    toJSON(T) {
      return {};
    },
    fromPartial(T) {
      return E();
    }
  };
  class O {
    constructor(y) {
      this.rpc = y, this.Grant = this.Grant.bind(this), this.Exec = this.Exec.bind(this), this.Revoke = this.Revoke.bind(this);
    }
    Grant(y) {
      const V = e.MsgGrant.encode(y).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", V).then((G) => e.MsgGrantResponse.decode(new u.BinaryReader(G)));
    }
    Exec(y) {
      const V = e.MsgExec.encode(y).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", V).then((G) => e.MsgExecResponse.decode(new u.BinaryReader(G)));
    }
    Revoke(y) {
      const V = e.MsgRevoke.encode(y).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", V).then((G) => e.MsgRevokeResponse.decode(new u.BinaryReader(G)));
    }
  }
  e.MsgClientImpl = O;
})(tx$n);
Object.defineProperty(messages$i, "__esModule", { value: !0 });
messages$i.authzTypes = void 0;
const tx_1$q = tx$n;
messages$i.authzTypes = [
  ["/cosmos.authz.v1beta1.MsgExec", tx_1$q.MsgExec],
  ["/cosmos.authz.v1beta1.MsgGrant", tx_1$q.MsgGrant],
  ["/cosmos.authz.v1beta1.MsgRevoke", tx_1$q.MsgRevoke]
];
var queries$l = {}, query$c = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryGranteeGrantsResponse = e.QueryGranteeGrantsRequest = e.QueryGranterGrantsResponse = e.QueryGranterGrantsRequest = e.QueryGrantsResponse = e.QueryGrantsRequest = e.protobufPackage = void 0;
  const n = pagination, o = authz$3, u = binary, c = helpers;
  e.protobufPackage = "cosmos.authz.v1beta1";
  function d() {
    return {
      granter: "",
      grantee: "",
      msgTypeUrl: "",
      pagination: void 0
    };
  }
  e.QueryGrantsRequest = {
    typeUrl: "/cosmos.authz.v1beta1.QueryGrantsRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return T.granter !== "" && y.uint32(10).string(T.granter), T.grantee !== "" && y.uint32(18).string(T.grantee), T.msgTypeUrl !== "" && y.uint32(26).string(T.msgTypeUrl), T.pagination !== void 0 && n.PageRequest.encode(T.pagination, y.uint32(34).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = d();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.granter = V.string();
            break;
          case 2:
            G.grantee = V.string();
            break;
          case 3:
            G.msgTypeUrl = V.string();
            break;
          case 4:
            G.pagination = n.PageRequest.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = d();
      return (0, c.isSet)(T.granter) && (y.granter = String(T.granter)), (0, c.isSet)(T.grantee) && (y.grantee = String(T.grantee)), (0, c.isSet)(T.msgTypeUrl) && (y.msgTypeUrl = String(T.msgTypeUrl)), (0, c.isSet)(T.pagination) && (y.pagination = n.PageRequest.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.granter !== void 0 && (y.granter = T.granter), T.grantee !== void 0 && (y.grantee = T.grantee), T.msgTypeUrl !== void 0 && (y.msgTypeUrl = T.msgTypeUrl), T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageRequest.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      const y = d();
      return y.granter = T.granter ?? "", y.grantee = T.grantee ?? "", y.msgTypeUrl = T.msgTypeUrl ?? "", T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageRequest.fromPartial(T.pagination)), y;
    }
  };
  function m() {
    return {
      grants: [],
      pagination: void 0
    };
  }
  e.QueryGrantsResponse = {
    typeUrl: "/cosmos.authz.v1beta1.QueryGrantsResponse",
    encode(T, y = u.BinaryWriter.create()) {
      for (const V of T.grants)
        o.Grant.encode(V, y.uint32(10).fork()).ldelim();
      return T.pagination !== void 0 && n.PageResponse.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = m();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.grants.push(o.Grant.decode(V, V.uint32()));
            break;
          case 2:
            G.pagination = n.PageResponse.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = m();
      return Array.isArray(T == null ? void 0 : T.grants) && (y.grants = T.grants.map((V) => o.Grant.fromJSON(V))), (0, c.isSet)(T.pagination) && (y.pagination = n.PageResponse.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.grants ? y.grants = T.grants.map((V) => V ? o.Grant.toJSON(V) : void 0) : y.grants = [], T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageResponse.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      var V;
      const y = m();
      return y.grants = ((V = T.grants) == null ? void 0 : V.map((M) => o.Grant.fromPartial(M))) || [], T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageResponse.fromPartial(T.pagination)), y;
    }
  };
  function v() {
    return {
      granter: "",
      pagination: void 0
    };
  }
  e.QueryGranterGrantsRequest = {
    typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return T.granter !== "" && y.uint32(10).string(T.granter), T.pagination !== void 0 && n.PageRequest.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = v();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.granter = V.string();
            break;
          case 2:
            G.pagination = n.PageRequest.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = v();
      return (0, c.isSet)(T.granter) && (y.granter = String(T.granter)), (0, c.isSet)(T.pagination) && (y.pagination = n.PageRequest.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.granter !== void 0 && (y.granter = T.granter), T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageRequest.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      const y = v();
      return y.granter = T.granter ?? "", T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageRequest.fromPartial(T.pagination)), y;
    }
  };
  function S() {
    return {
      grants: [],
      pagination: void 0
    };
  }
  e.QueryGranterGrantsResponse = {
    typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsResponse",
    encode(T, y = u.BinaryWriter.create()) {
      for (const V of T.grants)
        o.GrantAuthorization.encode(V, y.uint32(10).fork()).ldelim();
      return T.pagination !== void 0 && n.PageResponse.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = S();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.grants.push(o.GrantAuthorization.decode(V, V.uint32()));
            break;
          case 2:
            G.pagination = n.PageResponse.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = S();
      return Array.isArray(T == null ? void 0 : T.grants) && (y.grants = T.grants.map((V) => o.GrantAuthorization.fromJSON(V))), (0, c.isSet)(T.pagination) && (y.pagination = n.PageResponse.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.grants ? y.grants = T.grants.map((V) => V ? o.GrantAuthorization.toJSON(V) : void 0) : y.grants = [], T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageResponse.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      var V;
      const y = S();
      return y.grants = ((V = T.grants) == null ? void 0 : V.map((M) => o.GrantAuthorization.fromPartial(M))) || [], T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageResponse.fromPartial(T.pagination)), y;
    }
  };
  function $() {
    return {
      grantee: "",
      pagination: void 0
    };
  }
  e.QueryGranteeGrantsRequest = {
    typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return T.grantee !== "" && y.uint32(10).string(T.grantee), T.pagination !== void 0 && n.PageRequest.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = $();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.grantee = V.string();
            break;
          case 2:
            G.pagination = n.PageRequest.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = $();
      return (0, c.isSet)(T.grantee) && (y.grantee = String(T.grantee)), (0, c.isSet)(T.pagination) && (y.pagination = n.PageRequest.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.grantee !== void 0 && (y.grantee = T.grantee), T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageRequest.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      const y = $();
      return y.grantee = T.grantee ?? "", T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageRequest.fromPartial(T.pagination)), y;
    }
  };
  function E() {
    return {
      grants: [],
      pagination: void 0
    };
  }
  e.QueryGranteeGrantsResponse = {
    typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsResponse",
    encode(T, y = u.BinaryWriter.create()) {
      for (const V of T.grants)
        o.GrantAuthorization.encode(V, y.uint32(10).fork()).ldelim();
      return T.pagination !== void 0 && n.PageResponse.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = E();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.grants.push(o.GrantAuthorization.decode(V, V.uint32()));
            break;
          case 2:
            G.pagination = n.PageResponse.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = E();
      return Array.isArray(T == null ? void 0 : T.grants) && (y.grants = T.grants.map((V) => o.GrantAuthorization.fromJSON(V))), (0, c.isSet)(T.pagination) && (y.pagination = n.PageResponse.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.grants ? y.grants = T.grants.map((V) => V ? o.GrantAuthorization.toJSON(V) : void 0) : y.grants = [], T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageResponse.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      var V;
      const y = E();
      return y.grants = ((V = T.grants) == null ? void 0 : V.map((M) => o.GrantAuthorization.fromPartial(M))) || [], T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageResponse.fromPartial(T.pagination)), y;
    }
  };
  class O {
    constructor(y) {
      this.rpc = y, this.Grants = this.Grants.bind(this), this.GranterGrants = this.GranterGrants.bind(this), this.GranteeGrants = this.GranteeGrants.bind(this);
    }
    Grants(y) {
      const V = e.QueryGrantsRequest.encode(y).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", V).then((G) => e.QueryGrantsResponse.decode(new u.BinaryReader(G)));
    }
    GranterGrants(y) {
      const V = e.QueryGranterGrantsRequest.encode(y).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", V).then((G) => e.QueryGranterGrantsResponse.decode(new u.BinaryReader(G)));
    }
    GranteeGrants(y) {
      const V = e.QueryGranteeGrantsRequest.encode(y).finish();
      return this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", V).then((G) => e.QueryGranteeGrantsResponse.decode(new u.BinaryReader(G)));
    }
  }
  e.QueryClientImpl = O;
})(query$c);
Object.defineProperty(queries$l, "__esModule", { value: !0 });
queries$l.setupAuthzExtension = void 0;
const query_1$j = query$c, queryclient_1$o = queryclient$3;
function setupAuthzExtension$1(e) {
  const n = (0, queryclient_1$o.createProtobufRpcClient)(e), o = new query_1$j.QueryClientImpl(n);
  return {
    authz: {
      grants: async (u, c, d, m) => await o.Grants({
        granter: u,
        grantee: c,
        msgTypeUrl: d,
        pagination: (0, queryclient_1$o.createPagination)(m)
      }),
      granteeGrants: async (u, c) => await o.GranteeGrants({
        grantee: u,
        pagination: (0, queryclient_1$o.createPagination)(c)
      }),
      granterGrants: async (u, c) => await o.GranterGrants({
        granter: u,
        pagination: (0, queryclient_1$o.createPagination)(c)
      })
    }
  };
}
queries$l.setupAuthzExtension = setupAuthzExtension$1;
var aminomessages$m = {};
Object.defineProperty(aminomessages$m, "__esModule", { value: !0 });
aminomessages$m.createBankAminoConverters = aminomessages$m.isAminoMsgMultiSend = aminomessages$m.isAminoMsgSend = void 0;
function isAminoMsgSend$1(e) {
  return e.type === "cosmos-sdk/MsgSend";
}
aminomessages$m.isAminoMsgSend = isAminoMsgSend$1;
function isAminoMsgMultiSend$1(e) {
  return e.type === "cosmos-sdk/MsgMultiSend";
}
aminomessages$m.isAminoMsgMultiSend = isAminoMsgMultiSend$1;
function createBankAminoConverters$1() {
  return {
    "/cosmos.bank.v1beta1.MsgSend": {
      aminoType: "cosmos-sdk/MsgSend",
      toAmino: ({ fromAddress: e, toAddress: n, amount: o }) => ({
        from_address: e,
        to_address: n,
        amount: [...o]
      }),
      fromAmino: ({ from_address: e, to_address: n, amount: o }) => ({
        fromAddress: e,
        toAddress: n,
        amount: [...o]
      })
    },
    "/cosmos.bank.v1beta1.MsgMultiSend": {
      aminoType: "cosmos-sdk/MsgMultiSend",
      toAmino: ({ inputs: e, outputs: n }) => ({
        inputs: e.map((o) => ({
          address: o.address,
          coins: [...o.coins]
        })),
        outputs: n.map((o) => ({
          address: o.address,
          coins: [...o.coins]
        }))
      }),
      fromAmino: ({ inputs: e, outputs: n }) => ({
        inputs: e.map((o) => ({
          address: o.address,
          coins: [...o.coins]
        })),
        outputs: n.map((o) => ({
          address: o.address,
          coins: [...o.coins]
        }))
      })
    }
  };
}
aminomessages$m.createBankAminoConverters = createBankAminoConverters$1;
var messages$h = {};
Object.defineProperty(messages$h, "__esModule", { value: !0 });
messages$h.isMsgSendEncodeObject = messages$h.bankTypes = void 0;
const tx_1$p = tx$o;
messages$h.bankTypes = [
  ["/cosmos.bank.v1beta1.MsgMultiSend", tx_1$p.MsgMultiSend],
  ["/cosmos.bank.v1beta1.MsgSend", tx_1$p.MsgSend]
];
function isMsgSendEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
messages$h.isMsgSendEncodeObject = isMsgSendEncodeObject$1;
var queries$k = {}, query$b = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QuerySendEnabledResponse = e.QuerySendEnabledRequest = e.QueryDenomOwnersResponse = e.DenomOwner = e.QueryDenomOwnersRequest = e.QueryDenomMetadataResponse = e.QueryDenomMetadataRequest = e.QueryDenomsMetadataResponse = e.QueryDenomsMetadataRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QuerySupplyOfResponse = e.QuerySupplyOfRequest = e.QueryTotalSupplyResponse = e.QueryTotalSupplyRequest = e.QuerySpendableBalanceByDenomResponse = e.QuerySpendableBalanceByDenomRequest = e.QuerySpendableBalancesResponse = e.QuerySpendableBalancesRequest = e.QueryAllBalancesResponse = e.QueryAllBalancesRequest = e.QueryBalanceResponse = e.QueryBalanceRequest = e.protobufPackage = void 0;
  const n = pagination, o = coin$8, u = bank$2, c = binary, d = helpers;
  e.protobufPackage = "cosmos.bank.v1beta1";
  function m() {
    return {
      address: "",
      denom: ""
    };
  }
  e.QueryBalanceRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QueryBalanceRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.address !== "" && J.uint32(10).string(P.address), P.denom !== "" && J.uint32(18).string(P.denom), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = m();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.address = se.string();
            break;
          case 2:
            N.denom = se.string();
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = m();
      return (0, d.isSet)(P.address) && (J.address = String(P.address)), (0, d.isSet)(P.denom) && (J.denom = String(P.denom)), J;
    },
    toJSON(P) {
      const J = {};
      return P.address !== void 0 && (J.address = P.address), P.denom !== void 0 && (J.denom = P.denom), J;
    },
    fromPartial(P) {
      const J = m();
      return J.address = P.address ?? "", J.denom = P.denom ?? "", J;
    }
  };
  function v() {
    return {
      balance: void 0
    };
  }
  e.QueryBalanceResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QueryBalanceResponse",
    encode(P, J = c.BinaryWriter.create()) {
      return P.balance !== void 0 && o.Coin.encode(P.balance, J.uint32(10).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = v();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.balance = o.Coin.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = v();
      return (0, d.isSet)(P.balance) && (J.balance = o.Coin.fromJSON(P.balance)), J;
    },
    toJSON(P) {
      const J = {};
      return P.balance !== void 0 && (J.balance = P.balance ? o.Coin.toJSON(P.balance) : void 0), J;
    },
    fromPartial(P) {
      const J = v();
      return P.balance !== void 0 && P.balance !== null && (J.balance = o.Coin.fromPartial(P.balance)), J;
    }
  };
  function S() {
    return {
      address: "",
      pagination: void 0
    };
  }
  e.QueryAllBalancesRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.address !== "" && J.uint32(10).string(P.address), P.pagination !== void 0 && n.PageRequest.encode(P.pagination, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = S();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.address = se.string();
            break;
          case 2:
            N.pagination = n.PageRequest.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = S();
      return (0, d.isSet)(P.address) && (J.address = String(P.address)), (0, d.isSet)(P.pagination) && (J.pagination = n.PageRequest.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.address !== void 0 && (J.address = P.address), P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageRequest.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      const J = S();
      return J.address = P.address ?? "", P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageRequest.fromPartial(P.pagination)), J;
    }
  };
  function $() {
    return {
      balances: [],
      pagination: void 0
    };
  }
  e.QueryAllBalancesResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesResponse",
    encode(P, J = c.BinaryWriter.create()) {
      for (const se of P.balances)
        o.Coin.encode(se, J.uint32(10).fork()).ldelim();
      return P.pagination !== void 0 && n.PageResponse.encode(P.pagination, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = $();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.balances.push(o.Coin.decode(se, se.uint32()));
            break;
          case 2:
            N.pagination = n.PageResponse.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = $();
      return Array.isArray(P == null ? void 0 : P.balances) && (J.balances = P.balances.map((se) => o.Coin.fromJSON(se))), (0, d.isSet)(P.pagination) && (J.pagination = n.PageResponse.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.balances ? J.balances = P.balances.map((se) => se ? o.Coin.toJSON(se) : void 0) : J.balances = [], P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageResponse.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      var se;
      const J = $();
      return J.balances = ((se = P.balances) == null ? void 0 : se.map((fe) => o.Coin.fromPartial(fe))) || [], P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageResponse.fromPartial(P.pagination)), J;
    }
  };
  function E() {
    return {
      address: "",
      pagination: void 0
    };
  }
  e.QuerySpendableBalancesRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QuerySpendableBalancesRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.address !== "" && J.uint32(10).string(P.address), P.pagination !== void 0 && n.PageRequest.encode(P.pagination, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = E();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.address = se.string();
            break;
          case 2:
            N.pagination = n.PageRequest.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = E();
      return (0, d.isSet)(P.address) && (J.address = String(P.address)), (0, d.isSet)(P.pagination) && (J.pagination = n.PageRequest.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.address !== void 0 && (J.address = P.address), P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageRequest.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      const J = E();
      return J.address = P.address ?? "", P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageRequest.fromPartial(P.pagination)), J;
    }
  };
  function O() {
    return {
      balances: [],
      pagination: void 0
    };
  }
  e.QuerySpendableBalancesResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QuerySpendableBalancesResponse",
    encode(P, J = c.BinaryWriter.create()) {
      for (const se of P.balances)
        o.Coin.encode(se, J.uint32(10).fork()).ldelim();
      return P.pagination !== void 0 && n.PageResponse.encode(P.pagination, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = O();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.balances.push(o.Coin.decode(se, se.uint32()));
            break;
          case 2:
            N.pagination = n.PageResponse.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = O();
      return Array.isArray(P == null ? void 0 : P.balances) && (J.balances = P.balances.map((se) => o.Coin.fromJSON(se))), (0, d.isSet)(P.pagination) && (J.pagination = n.PageResponse.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.balances ? J.balances = P.balances.map((se) => se ? o.Coin.toJSON(se) : void 0) : J.balances = [], P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageResponse.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      var se;
      const J = O();
      return J.balances = ((se = P.balances) == null ? void 0 : se.map((fe) => o.Coin.fromPartial(fe))) || [], P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageResponse.fromPartial(P.pagination)), J;
    }
  };
  function T() {
    return {
      address: "",
      denom: ""
    };
  }
  e.QuerySpendableBalanceByDenomRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QuerySpendableBalanceByDenomRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.address !== "" && J.uint32(10).string(P.address), P.denom !== "" && J.uint32(18).string(P.denom), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = T();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.address = se.string();
            break;
          case 2:
            N.denom = se.string();
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = T();
      return (0, d.isSet)(P.address) && (J.address = String(P.address)), (0, d.isSet)(P.denom) && (J.denom = String(P.denom)), J;
    },
    toJSON(P) {
      const J = {};
      return P.address !== void 0 && (J.address = P.address), P.denom !== void 0 && (J.denom = P.denom), J;
    },
    fromPartial(P) {
      const J = T();
      return J.address = P.address ?? "", J.denom = P.denom ?? "", J;
    }
  };
  function y() {
    return {
      balance: void 0
    };
  }
  e.QuerySpendableBalanceByDenomResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QuerySpendableBalanceByDenomResponse",
    encode(P, J = c.BinaryWriter.create()) {
      return P.balance !== void 0 && o.Coin.encode(P.balance, J.uint32(10).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = y();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.balance = o.Coin.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = y();
      return (0, d.isSet)(P.balance) && (J.balance = o.Coin.fromJSON(P.balance)), J;
    },
    toJSON(P) {
      const J = {};
      return P.balance !== void 0 && (J.balance = P.balance ? o.Coin.toJSON(P.balance) : void 0), J;
    },
    fromPartial(P) {
      const J = y();
      return P.balance !== void 0 && P.balance !== null && (J.balance = o.Coin.fromPartial(P.balance)), J;
    }
  };
  function V() {
    return {
      pagination: void 0
    };
  }
  e.QueryTotalSupplyRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.pagination !== void 0 && n.PageRequest.encode(P.pagination, J.uint32(10).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = V();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.pagination = n.PageRequest.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = V();
      return (0, d.isSet)(P.pagination) && (J.pagination = n.PageRequest.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageRequest.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      const J = V();
      return P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageRequest.fromPartial(P.pagination)), J;
    }
  };
  function M() {
    return {
      supply: [],
      pagination: void 0
    };
  }
  e.QueryTotalSupplyResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyResponse",
    encode(P, J = c.BinaryWriter.create()) {
      for (const se of P.supply)
        o.Coin.encode(se, J.uint32(10).fork()).ldelim();
      return P.pagination !== void 0 && n.PageResponse.encode(P.pagination, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = M();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.supply.push(o.Coin.decode(se, se.uint32()));
            break;
          case 2:
            N.pagination = n.PageResponse.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = M();
      return Array.isArray(P == null ? void 0 : P.supply) && (J.supply = P.supply.map((se) => o.Coin.fromJSON(se))), (0, d.isSet)(P.pagination) && (J.pagination = n.PageResponse.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.supply ? J.supply = P.supply.map((se) => se ? o.Coin.toJSON(se) : void 0) : J.supply = [], P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageResponse.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      var se;
      const J = M();
      return J.supply = ((se = P.supply) == null ? void 0 : se.map((fe) => o.Coin.fromPartial(fe))) || [], P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageResponse.fromPartial(P.pagination)), J;
    }
  };
  function G() {
    return {
      denom: ""
    };
  }
  e.QuerySupplyOfRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.denom !== "" && J.uint32(10).string(P.denom), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = G();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.denom = se.string();
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = G();
      return (0, d.isSet)(P.denom) && (J.denom = String(P.denom)), J;
    },
    toJSON(P) {
      const J = {};
      return P.denom !== void 0 && (J.denom = P.denom), J;
    },
    fromPartial(P) {
      const J = G();
      return J.denom = P.denom ?? "", J;
    }
  };
  function k() {
    return {
      amount: o.Coin.fromPartial({})
    };
  }
  e.QuerySupplyOfResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfResponse",
    encode(P, J = c.BinaryWriter.create()) {
      return P.amount !== void 0 && o.Coin.encode(P.amount, J.uint32(10).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = k();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.amount = o.Coin.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = k();
      return (0, d.isSet)(P.amount) && (J.amount = o.Coin.fromJSON(P.amount)), J;
    },
    toJSON(P) {
      const J = {};
      return P.amount !== void 0 && (J.amount = P.amount ? o.Coin.toJSON(P.amount) : void 0), J;
    },
    fromPartial(P) {
      const J = k();
      return P.amount !== void 0 && P.amount !== null && (J.amount = o.Coin.fromPartial(P.amount)), J;
    }
  };
  function F() {
    return {};
  }
  e.QueryParamsRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QueryParamsRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = F();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      return F();
    },
    toJSON(P) {
      return {};
    },
    fromPartial(P) {
      return F();
    }
  };
  function X() {
    return {
      params: u.Params.fromPartial({})
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QueryParamsResponse",
    encode(P, J = c.BinaryWriter.create()) {
      return P.params !== void 0 && u.Params.encode(P.params, J.uint32(10).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = X();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.params = u.Params.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = X();
      return (0, d.isSet)(P.params) && (J.params = u.Params.fromJSON(P.params)), J;
    },
    toJSON(P) {
      const J = {};
      return P.params !== void 0 && (J.params = P.params ? u.Params.toJSON(P.params) : void 0), J;
    },
    fromPartial(P) {
      const J = X();
      return P.params !== void 0 && P.params !== null && (J.params = u.Params.fromPartial(P.params)), J;
    }
  };
  function ee() {
    return {
      pagination: void 0
    };
  }
  e.QueryDenomsMetadataRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.pagination !== void 0 && n.PageRequest.encode(P.pagination, J.uint32(10).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = ee();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.pagination = n.PageRequest.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = ee();
      return (0, d.isSet)(P.pagination) && (J.pagination = n.PageRequest.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageRequest.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      const J = ee();
      return P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageRequest.fromPartial(P.pagination)), J;
    }
  };
  function ue() {
    return {
      metadatas: [],
      pagination: void 0
    };
  }
  e.QueryDenomsMetadataResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataResponse",
    encode(P, J = c.BinaryWriter.create()) {
      for (const se of P.metadatas)
        u.Metadata.encode(se, J.uint32(10).fork()).ldelim();
      return P.pagination !== void 0 && n.PageResponse.encode(P.pagination, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = ue();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.metadatas.push(u.Metadata.decode(se, se.uint32()));
            break;
          case 2:
            N.pagination = n.PageResponse.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = ue();
      return Array.isArray(P == null ? void 0 : P.metadatas) && (J.metadatas = P.metadatas.map((se) => u.Metadata.fromJSON(se))), (0, d.isSet)(P.pagination) && (J.pagination = n.PageResponse.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.metadatas ? J.metadatas = P.metadatas.map((se) => se ? u.Metadata.toJSON(se) : void 0) : J.metadatas = [], P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageResponse.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      var se;
      const J = ue();
      return J.metadatas = ((se = P.metadatas) == null ? void 0 : se.map((fe) => u.Metadata.fromPartial(fe))) || [], P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageResponse.fromPartial(P.pagination)), J;
    }
  };
  function Q() {
    return {
      denom: ""
    };
  }
  e.QueryDenomMetadataRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.denom !== "" && J.uint32(10).string(P.denom), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = Q();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.denom = se.string();
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = Q();
      return (0, d.isSet)(P.denom) && (J.denom = String(P.denom)), J;
    },
    toJSON(P) {
      const J = {};
      return P.denom !== void 0 && (J.denom = P.denom), J;
    },
    fromPartial(P) {
      const J = Q();
      return J.denom = P.denom ?? "", J;
    }
  };
  function Y() {
    return {
      metadata: u.Metadata.fromPartial({})
    };
  }
  e.QueryDenomMetadataResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataResponse",
    encode(P, J = c.BinaryWriter.create()) {
      return P.metadata !== void 0 && u.Metadata.encode(P.metadata, J.uint32(10).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = Y();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.metadata = u.Metadata.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = Y();
      return (0, d.isSet)(P.metadata) && (J.metadata = u.Metadata.fromJSON(P.metadata)), J;
    },
    toJSON(P) {
      const J = {};
      return P.metadata !== void 0 && (J.metadata = P.metadata ? u.Metadata.toJSON(P.metadata) : void 0), J;
    },
    fromPartial(P) {
      const J = Y();
      return P.metadata !== void 0 && P.metadata !== null && (J.metadata = u.Metadata.fromPartial(P.metadata)), J;
    }
  };
  function pe() {
    return {
      denom: "",
      pagination: void 0
    };
  }
  e.QueryDenomOwnersRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QueryDenomOwnersRequest",
    encode(P, J = c.BinaryWriter.create()) {
      return P.denom !== "" && J.uint32(10).string(P.denom), P.pagination !== void 0 && n.PageRequest.encode(P.pagination, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = pe();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.denom = se.string();
            break;
          case 2:
            N.pagination = n.PageRequest.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = pe();
      return (0, d.isSet)(P.denom) && (J.denom = String(P.denom)), (0, d.isSet)(P.pagination) && (J.pagination = n.PageRequest.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.denom !== void 0 && (J.denom = P.denom), P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageRequest.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      const J = pe();
      return J.denom = P.denom ?? "", P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageRequest.fromPartial(P.pagination)), J;
    }
  };
  function oe() {
    return {
      address: "",
      balance: o.Coin.fromPartial({})
    };
  }
  e.DenomOwner = {
    typeUrl: "/cosmos.bank.v1beta1.DenomOwner",
    encode(P, J = c.BinaryWriter.create()) {
      return P.address !== "" && J.uint32(10).string(P.address), P.balance !== void 0 && o.Coin.encode(P.balance, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = oe();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.address = se.string();
            break;
          case 2:
            N.balance = o.Coin.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = oe();
      return (0, d.isSet)(P.address) && (J.address = String(P.address)), (0, d.isSet)(P.balance) && (J.balance = o.Coin.fromJSON(P.balance)), J;
    },
    toJSON(P) {
      const J = {};
      return P.address !== void 0 && (J.address = P.address), P.balance !== void 0 && (J.balance = P.balance ? o.Coin.toJSON(P.balance) : void 0), J;
    },
    fromPartial(P) {
      const J = oe();
      return J.address = P.address ?? "", P.balance !== void 0 && P.balance !== null && (J.balance = o.Coin.fromPartial(P.balance)), J;
    }
  };
  function ne() {
    return {
      denomOwners: [],
      pagination: void 0
    };
  }
  e.QueryDenomOwnersResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QueryDenomOwnersResponse",
    encode(P, J = c.BinaryWriter.create()) {
      for (const se of P.denomOwners)
        e.DenomOwner.encode(se, J.uint32(10).fork()).ldelim();
      return P.pagination !== void 0 && n.PageResponse.encode(P.pagination, J.uint32(18).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = ne();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.denomOwners.push(e.DenomOwner.decode(se, se.uint32()));
            break;
          case 2:
            N.pagination = n.PageResponse.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = ne();
      return Array.isArray(P == null ? void 0 : P.denomOwners) && (J.denomOwners = P.denomOwners.map((se) => e.DenomOwner.fromJSON(se))), (0, d.isSet)(P.pagination) && (J.pagination = n.PageResponse.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.denomOwners ? J.denomOwners = P.denomOwners.map((se) => se ? e.DenomOwner.toJSON(se) : void 0) : J.denomOwners = [], P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageResponse.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      var se;
      const J = ne();
      return J.denomOwners = ((se = P.denomOwners) == null ? void 0 : se.map((fe) => e.DenomOwner.fromPartial(fe))) || [], P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageResponse.fromPartial(P.pagination)), J;
    }
  };
  function H() {
    return {
      denoms: [],
      pagination: void 0
    };
  }
  e.QuerySendEnabledRequest = {
    typeUrl: "/cosmos.bank.v1beta1.QuerySendEnabledRequest",
    encode(P, J = c.BinaryWriter.create()) {
      for (const se of P.denoms)
        J.uint32(10).string(se);
      return P.pagination !== void 0 && n.PageRequest.encode(P.pagination, J.uint32(794).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = H();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.denoms.push(se.string());
            break;
          case 99:
            N.pagination = n.PageRequest.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = H();
      return Array.isArray(P == null ? void 0 : P.denoms) && (J.denoms = P.denoms.map((se) => String(se))), (0, d.isSet)(P.pagination) && (J.pagination = n.PageRequest.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.denoms ? J.denoms = P.denoms.map((se) => se) : J.denoms = [], P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageRequest.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      var se;
      const J = H();
      return J.denoms = ((se = P.denoms) == null ? void 0 : se.map((fe) => fe)) || [], P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageRequest.fromPartial(P.pagination)), J;
    }
  };
  function C() {
    return {
      sendEnabled: [],
      pagination: void 0
    };
  }
  e.QuerySendEnabledResponse = {
    typeUrl: "/cosmos.bank.v1beta1.QuerySendEnabledResponse",
    encode(P, J = c.BinaryWriter.create()) {
      for (const se of P.sendEnabled)
        u.SendEnabled.encode(se, J.uint32(10).fork()).ldelim();
      return P.pagination !== void 0 && n.PageResponse.encode(P.pagination, J.uint32(794).fork()).ldelim(), J;
    },
    decode(P, J) {
      const se = P instanceof c.BinaryReader ? P : new c.BinaryReader(P);
      let fe = J === void 0 ? se.len : se.pos + J;
      const N = C();
      for (; se.pos < fe; ) {
        const W = se.uint32();
        switch (W >>> 3) {
          case 1:
            N.sendEnabled.push(u.SendEnabled.decode(se, se.uint32()));
            break;
          case 99:
            N.pagination = n.PageResponse.decode(se, se.uint32());
            break;
          default:
            se.skipType(W & 7);
            break;
        }
      }
      return N;
    },
    fromJSON(P) {
      const J = C();
      return Array.isArray(P == null ? void 0 : P.sendEnabled) && (J.sendEnabled = P.sendEnabled.map((se) => u.SendEnabled.fromJSON(se))), (0, d.isSet)(P.pagination) && (J.pagination = n.PageResponse.fromJSON(P.pagination)), J;
    },
    toJSON(P) {
      const J = {};
      return P.sendEnabled ? J.sendEnabled = P.sendEnabled.map((se) => se ? u.SendEnabled.toJSON(se) : void 0) : J.sendEnabled = [], P.pagination !== void 0 && (J.pagination = P.pagination ? n.PageResponse.toJSON(P.pagination) : void 0), J;
    },
    fromPartial(P) {
      var se;
      const J = C();
      return J.sendEnabled = ((se = P.sendEnabled) == null ? void 0 : se.map((fe) => u.SendEnabled.fromPartial(fe))) || [], P.pagination !== void 0 && P.pagination !== null && (J.pagination = n.PageResponse.fromPartial(P.pagination)), J;
    }
  };
  class w {
    constructor(J) {
      this.rpc = J, this.Balance = this.Balance.bind(this), this.AllBalances = this.AllBalances.bind(this), this.SpendableBalances = this.SpendableBalances.bind(this), this.SpendableBalanceByDenom = this.SpendableBalanceByDenom.bind(this), this.TotalSupply = this.TotalSupply.bind(this), this.SupplyOf = this.SupplyOf.bind(this), this.Params = this.Params.bind(this), this.DenomMetadata = this.DenomMetadata.bind(this), this.DenomsMetadata = this.DenomsMetadata.bind(this), this.DenomOwners = this.DenomOwners.bind(this), this.SendEnabled = this.SendEnabled.bind(this);
    }
    Balance(J) {
      const se = e.QueryBalanceRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", se).then((N) => e.QueryBalanceResponse.decode(new c.BinaryReader(N)));
    }
    AllBalances(J) {
      const se = e.QueryAllBalancesRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", se).then((N) => e.QueryAllBalancesResponse.decode(new c.BinaryReader(N)));
    }
    SpendableBalances(J) {
      const se = e.QuerySpendableBalancesRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalances", se).then((N) => e.QuerySpendableBalancesResponse.decode(new c.BinaryReader(N)));
    }
    SpendableBalanceByDenom(J) {
      const se = e.QuerySpendableBalanceByDenomRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalanceByDenom", se).then((N) => e.QuerySpendableBalanceByDenomResponse.decode(new c.BinaryReader(N)));
    }
    TotalSupply(J = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const se = e.QueryTotalSupplyRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", se).then((N) => e.QueryTotalSupplyResponse.decode(new c.BinaryReader(N)));
    }
    SupplyOf(J) {
      const se = e.QuerySupplyOfRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", se).then((N) => e.QuerySupplyOfResponse.decode(new c.BinaryReader(N)));
    }
    Params(J = {}) {
      const se = e.QueryParamsRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "Params", se).then((N) => e.QueryParamsResponse.decode(new c.BinaryReader(N)));
    }
    DenomMetadata(J) {
      const se = e.QueryDenomMetadataRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", se).then((N) => e.QueryDenomMetadataResponse.decode(new c.BinaryReader(N)));
    }
    DenomsMetadata(J = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const se = e.QueryDenomsMetadataRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", se).then((N) => e.QueryDenomsMetadataResponse.decode(new c.BinaryReader(N)));
    }
    DenomOwners(J) {
      const se = e.QueryDenomOwnersRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "DenomOwners", se).then((N) => e.QueryDenomOwnersResponse.decode(new c.BinaryReader(N)));
    }
    SendEnabled(J) {
      const se = e.QuerySendEnabledRequest.encode(J).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Query", "SendEnabled", se).then((N) => e.QuerySendEnabledResponse.decode(new c.BinaryReader(N)));
    }
  }
  e.QueryClientImpl = w;
})(query$b);
Object.defineProperty(queries$k, "__esModule", { value: !0 });
queries$k.setupBankExtension = void 0;
const utils_1$U = build$G, query_1$i = query$b, queryclient_1$n = queryclient$3;
function setupBankExtension$1(e) {
  const n = (0, queryclient_1$n.createProtobufRpcClient)(e), o = new query_1$i.QueryClientImpl(n);
  return {
    bank: {
      balance: async (u, c) => {
        const { balance: d } = await o.Balance({ address: u, denom: c });
        return (0, utils_1$U.assert)(d), d;
      },
      allBalances: async (u) => {
        const { balances: c } = await o.AllBalances(query_1$i.QueryAllBalancesRequest.fromPartial({ address: u }));
        return c;
      },
      totalSupply: async (u) => await o.TotalSupply({
        pagination: (0, queryclient_1$n.createPagination)(u)
      }),
      supplyOf: async (u) => {
        const { amount: c } = await o.SupplyOf({ denom: u });
        return (0, utils_1$U.assert)(c), c;
      },
      denomMetadata: async (u) => {
        const { metadata: c } = await o.DenomMetadata({ denom: u });
        return (0, utils_1$U.assert)(c), c;
      },
      denomsMetadata: async () => {
        const { metadatas: u } = await o.DenomsMetadata(query_1$i.QueryDenomsMetadataRequest.fromPartial({
          pagination: void 0
          // Not implemented
        }));
        return u;
      }
    }
  };
}
queries$k.setupBankExtension = setupBankExtension$1;
var aminomessages$l = {};
Object.defineProperty(aminomessages$l, "__esModule", { value: !0 });
aminomessages$l.createCrysisAminoConverters = aminomessages$l.isAminoMsgVerifyInvariant = void 0;
function isAminoMsgVerifyInvariant$1(e) {
  return e.type === "cosmos-sdk/MsgVerifyInvariant";
}
aminomessages$l.isAminoMsgVerifyInvariant = isAminoMsgVerifyInvariant$1;
function createCrysisAminoConverters$1() {
  throw new Error("Not implemented");
}
aminomessages$l.createCrysisAminoConverters = createCrysisAminoConverters$1;
var aminomessages$k = {};
Object.defineProperty(aminomessages$k, "__esModule", { value: !0 });
aminomessages$k.createDistributionAminoConverters = aminomessages$k.isAminoMsgFundCommunityPool = aminomessages$k.isAminoMsgWithdrawValidatorCommission = aminomessages$k.isAminoMsgWithdrawDelegatorReward = aminomessages$k.isAminoMsgSetWithdrawAddress = void 0;
function isAminoMsgSetWithdrawAddress$1(e) {
  return e.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
aminomessages$k.isAminoMsgSetWithdrawAddress = isAminoMsgSetWithdrawAddress$1;
function isAminoMsgWithdrawDelegatorReward$1(e) {
  return e.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
aminomessages$k.isAminoMsgWithdrawDelegatorReward = isAminoMsgWithdrawDelegatorReward$1;
function isAminoMsgWithdrawValidatorCommission$1(e) {
  return e.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
aminomessages$k.isAminoMsgWithdrawValidatorCommission = isAminoMsgWithdrawValidatorCommission$1;
function isAminoMsgFundCommunityPool$1(e) {
  return e.type === "cosmos-sdk/MsgFundCommunityPool";
}
aminomessages$k.isAminoMsgFundCommunityPool = isAminoMsgFundCommunityPool$1;
function createDistributionAminoConverters$1() {
  return {
    "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
      aminoType: "cosmos-sdk/MsgFundCommunityPool",
      toAmino: ({ amount: e, depositor: n }) => ({
        amount: [...e],
        depositor: n
      }),
      fromAmino: ({ amount: e, depositor: n }) => ({
        amount: [...e],
        depositor: n
      })
    },
    "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
      aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
      toAmino: ({ delegatorAddress: e, withdrawAddress: n }) => ({
        delegator_address: e,
        withdraw_address: n
      }),
      fromAmino: ({ delegator_address: e, withdraw_address: n }) => ({
        delegatorAddress: e,
        withdrawAddress: n
      })
    },
    "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
      aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
      toAmino: ({ delegatorAddress: e, validatorAddress: n }) => ({
        delegator_address: e,
        validator_address: n
      }),
      fromAmino: ({ delegator_address: e, validator_address: n }) => ({
        delegatorAddress: e,
        validatorAddress: n
      })
    },
    "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
      aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
      toAmino: ({ validatorAddress: e }) => ({
        validator_address: e
      }),
      fromAmino: ({ validator_address: e }) => ({
        validatorAddress: e
      })
    }
  };
}
aminomessages$k.createDistributionAminoConverters = createDistributionAminoConverters$1;
var messages$g = {}, tx$m = {}, distribution = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CommunityPoolSpendProposalWithDeposit = e.DelegationDelegatorReward = e.DelegatorStartingInfo = e.CommunityPoolSpendProposal = e.FeePool = e.ValidatorSlashEvents = e.ValidatorSlashEvent = e.ValidatorOutstandingRewards = e.ValidatorAccumulatedCommission = e.ValidatorCurrentRewards = e.ValidatorHistoricalRewards = e.Params = e.protobufPackage = void 0;
  const n = coin$8, o = binary, u = helpers;
  e.protobufPackage = "cosmos.distribution.v1beta1";
  function c() {
    return {
      communityTax: "",
      baseProposerReward: "",
      bonusProposerReward: "",
      withdrawAddrEnabled: !1
    };
  }
  e.Params = {
    typeUrl: "/cosmos.distribution.v1beta1.Params",
    encode(G, k = o.BinaryWriter.create()) {
      return G.communityTax !== "" && k.uint32(10).string(G.communityTax), G.baseProposerReward !== "" && k.uint32(18).string(G.baseProposerReward), G.bonusProposerReward !== "" && k.uint32(26).string(G.bonusProposerReward), G.withdrawAddrEnabled === !0 && k.uint32(32).bool(G.withdrawAddrEnabled), k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = c();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.communityTax = F.string();
            break;
          case 2:
            ee.baseProposerReward = F.string();
            break;
          case 3:
            ee.bonusProposerReward = F.string();
            break;
          case 4:
            ee.withdrawAddrEnabled = F.bool();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = c();
      return (0, u.isSet)(G.communityTax) && (k.communityTax = String(G.communityTax)), (0, u.isSet)(G.baseProposerReward) && (k.baseProposerReward = String(G.baseProposerReward)), (0, u.isSet)(G.bonusProposerReward) && (k.bonusProposerReward = String(G.bonusProposerReward)), (0, u.isSet)(G.withdrawAddrEnabled) && (k.withdrawAddrEnabled = !!G.withdrawAddrEnabled), k;
    },
    toJSON(G) {
      const k = {};
      return G.communityTax !== void 0 && (k.communityTax = G.communityTax), G.baseProposerReward !== void 0 && (k.baseProposerReward = G.baseProposerReward), G.bonusProposerReward !== void 0 && (k.bonusProposerReward = G.bonusProposerReward), G.withdrawAddrEnabled !== void 0 && (k.withdrawAddrEnabled = G.withdrawAddrEnabled), k;
    },
    fromPartial(G) {
      const k = c();
      return k.communityTax = G.communityTax ?? "", k.baseProposerReward = G.baseProposerReward ?? "", k.bonusProposerReward = G.bonusProposerReward ?? "", k.withdrawAddrEnabled = G.withdrawAddrEnabled ?? !1, k;
    }
  };
  function d() {
    return {
      cumulativeRewardRatio: [],
      referenceCount: 0
    };
  }
  e.ValidatorHistoricalRewards = {
    typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewards",
    encode(G, k = o.BinaryWriter.create()) {
      for (const F of G.cumulativeRewardRatio)
        n.DecCoin.encode(F, k.uint32(10).fork()).ldelim();
      return G.referenceCount !== 0 && k.uint32(16).uint32(G.referenceCount), k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = d();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.cumulativeRewardRatio.push(n.DecCoin.decode(F, F.uint32()));
            break;
          case 2:
            ee.referenceCount = F.uint32();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = d();
      return Array.isArray(G == null ? void 0 : G.cumulativeRewardRatio) && (k.cumulativeRewardRatio = G.cumulativeRewardRatio.map((F) => n.DecCoin.fromJSON(F))), (0, u.isSet)(G.referenceCount) && (k.referenceCount = Number(G.referenceCount)), k;
    },
    toJSON(G) {
      const k = {};
      return G.cumulativeRewardRatio ? k.cumulativeRewardRatio = G.cumulativeRewardRatio.map((F) => F ? n.DecCoin.toJSON(F) : void 0) : k.cumulativeRewardRatio = [], G.referenceCount !== void 0 && (k.referenceCount = Math.round(G.referenceCount)), k;
    },
    fromPartial(G) {
      var F;
      const k = d();
      return k.cumulativeRewardRatio = ((F = G.cumulativeRewardRatio) == null ? void 0 : F.map((X) => n.DecCoin.fromPartial(X))) || [], k.referenceCount = G.referenceCount ?? 0, k;
    }
  };
  function m() {
    return {
      rewards: [],
      period: BigInt(0)
    };
  }
  e.ValidatorCurrentRewards = {
    typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewards",
    encode(G, k = o.BinaryWriter.create()) {
      for (const F of G.rewards)
        n.DecCoin.encode(F, k.uint32(10).fork()).ldelim();
      return G.period !== BigInt(0) && k.uint32(16).uint64(G.period), k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = m();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.rewards.push(n.DecCoin.decode(F, F.uint32()));
            break;
          case 2:
            ee.period = F.uint64();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = m();
      return Array.isArray(G == null ? void 0 : G.rewards) && (k.rewards = G.rewards.map((F) => n.DecCoin.fromJSON(F))), (0, u.isSet)(G.period) && (k.period = BigInt(G.period.toString())), k;
    },
    toJSON(G) {
      const k = {};
      return G.rewards ? k.rewards = G.rewards.map((F) => F ? n.DecCoin.toJSON(F) : void 0) : k.rewards = [], G.period !== void 0 && (k.period = (G.period || BigInt(0)).toString()), k;
    },
    fromPartial(G) {
      var F;
      const k = m();
      return k.rewards = ((F = G.rewards) == null ? void 0 : F.map((X) => n.DecCoin.fromPartial(X))) || [], G.period !== void 0 && G.period !== null && (k.period = BigInt(G.period.toString())), k;
    }
  };
  function v() {
    return {
      commission: []
    };
  }
  e.ValidatorAccumulatedCommission = {
    typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommission",
    encode(G, k = o.BinaryWriter.create()) {
      for (const F of G.commission)
        n.DecCoin.encode(F, k.uint32(10).fork()).ldelim();
      return k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = v();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.commission.push(n.DecCoin.decode(F, F.uint32()));
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = v();
      return Array.isArray(G == null ? void 0 : G.commission) && (k.commission = G.commission.map((F) => n.DecCoin.fromJSON(F))), k;
    },
    toJSON(G) {
      const k = {};
      return G.commission ? k.commission = G.commission.map((F) => F ? n.DecCoin.toJSON(F) : void 0) : k.commission = [], k;
    },
    fromPartial(G) {
      var F;
      const k = v();
      return k.commission = ((F = G.commission) == null ? void 0 : F.map((X) => n.DecCoin.fromPartial(X))) || [], k;
    }
  };
  function S() {
    return {
      rewards: []
    };
  }
  e.ValidatorOutstandingRewards = {
    typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewards",
    encode(G, k = o.BinaryWriter.create()) {
      for (const F of G.rewards)
        n.DecCoin.encode(F, k.uint32(10).fork()).ldelim();
      return k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = S();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.rewards.push(n.DecCoin.decode(F, F.uint32()));
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = S();
      return Array.isArray(G == null ? void 0 : G.rewards) && (k.rewards = G.rewards.map((F) => n.DecCoin.fromJSON(F))), k;
    },
    toJSON(G) {
      const k = {};
      return G.rewards ? k.rewards = G.rewards.map((F) => F ? n.DecCoin.toJSON(F) : void 0) : k.rewards = [], k;
    },
    fromPartial(G) {
      var F;
      const k = S();
      return k.rewards = ((F = G.rewards) == null ? void 0 : F.map((X) => n.DecCoin.fromPartial(X))) || [], k;
    }
  };
  function $() {
    return {
      validatorPeriod: BigInt(0),
      fraction: ""
    };
  }
  e.ValidatorSlashEvent = {
    typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvent",
    encode(G, k = o.BinaryWriter.create()) {
      return G.validatorPeriod !== BigInt(0) && k.uint32(8).uint64(G.validatorPeriod), G.fraction !== "" && k.uint32(18).string(G.fraction), k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = $();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.validatorPeriod = F.uint64();
            break;
          case 2:
            ee.fraction = F.string();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = $();
      return (0, u.isSet)(G.validatorPeriod) && (k.validatorPeriod = BigInt(G.validatorPeriod.toString())), (0, u.isSet)(G.fraction) && (k.fraction = String(G.fraction)), k;
    },
    toJSON(G) {
      const k = {};
      return G.validatorPeriod !== void 0 && (k.validatorPeriod = (G.validatorPeriod || BigInt(0)).toString()), G.fraction !== void 0 && (k.fraction = G.fraction), k;
    },
    fromPartial(G) {
      const k = $();
      return G.validatorPeriod !== void 0 && G.validatorPeriod !== null && (k.validatorPeriod = BigInt(G.validatorPeriod.toString())), k.fraction = G.fraction ?? "", k;
    }
  };
  function E() {
    return {
      validatorSlashEvents: []
    };
  }
  e.ValidatorSlashEvents = {
    typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvents",
    encode(G, k = o.BinaryWriter.create()) {
      for (const F of G.validatorSlashEvents)
        e.ValidatorSlashEvent.encode(F, k.uint32(10).fork()).ldelim();
      return k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = E();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.validatorSlashEvents.push(e.ValidatorSlashEvent.decode(F, F.uint32()));
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = E();
      return Array.isArray(G == null ? void 0 : G.validatorSlashEvents) && (k.validatorSlashEvents = G.validatorSlashEvents.map((F) => e.ValidatorSlashEvent.fromJSON(F))), k;
    },
    toJSON(G) {
      const k = {};
      return G.validatorSlashEvents ? k.validatorSlashEvents = G.validatorSlashEvents.map((F) => F ? e.ValidatorSlashEvent.toJSON(F) : void 0) : k.validatorSlashEvents = [], k;
    },
    fromPartial(G) {
      var F;
      const k = E();
      return k.validatorSlashEvents = ((F = G.validatorSlashEvents) == null ? void 0 : F.map((X) => e.ValidatorSlashEvent.fromPartial(X))) || [], k;
    }
  };
  function O() {
    return {
      communityPool: []
    };
  }
  e.FeePool = {
    typeUrl: "/cosmos.distribution.v1beta1.FeePool",
    encode(G, k = o.BinaryWriter.create()) {
      for (const F of G.communityPool)
        n.DecCoin.encode(F, k.uint32(10).fork()).ldelim();
      return k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = O();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.communityPool.push(n.DecCoin.decode(F, F.uint32()));
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = O();
      return Array.isArray(G == null ? void 0 : G.communityPool) && (k.communityPool = G.communityPool.map((F) => n.DecCoin.fromJSON(F))), k;
    },
    toJSON(G) {
      const k = {};
      return G.communityPool ? k.communityPool = G.communityPool.map((F) => F ? n.DecCoin.toJSON(F) : void 0) : k.communityPool = [], k;
    },
    fromPartial(G) {
      var F;
      const k = O();
      return k.communityPool = ((F = G.communityPool) == null ? void 0 : F.map((X) => n.DecCoin.fromPartial(X))) || [], k;
    }
  };
  function T() {
    return {
      title: "",
      description: "",
      recipient: "",
      amount: []
    };
  }
  e.CommunityPoolSpendProposal = {
    typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
    encode(G, k = o.BinaryWriter.create()) {
      G.title !== "" && k.uint32(10).string(G.title), G.description !== "" && k.uint32(18).string(G.description), G.recipient !== "" && k.uint32(26).string(G.recipient);
      for (const F of G.amount)
        n.Coin.encode(F, k.uint32(34).fork()).ldelim();
      return k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = T();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.title = F.string();
            break;
          case 2:
            ee.description = F.string();
            break;
          case 3:
            ee.recipient = F.string();
            break;
          case 4:
            ee.amount.push(n.Coin.decode(F, F.uint32()));
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = T();
      return (0, u.isSet)(G.title) && (k.title = String(G.title)), (0, u.isSet)(G.description) && (k.description = String(G.description)), (0, u.isSet)(G.recipient) && (k.recipient = String(G.recipient)), Array.isArray(G == null ? void 0 : G.amount) && (k.amount = G.amount.map((F) => n.Coin.fromJSON(F))), k;
    },
    toJSON(G) {
      const k = {};
      return G.title !== void 0 && (k.title = G.title), G.description !== void 0 && (k.description = G.description), G.recipient !== void 0 && (k.recipient = G.recipient), G.amount ? k.amount = G.amount.map((F) => F ? n.Coin.toJSON(F) : void 0) : k.amount = [], k;
    },
    fromPartial(G) {
      var F;
      const k = T();
      return k.title = G.title ?? "", k.description = G.description ?? "", k.recipient = G.recipient ?? "", k.amount = ((F = G.amount) == null ? void 0 : F.map((X) => n.Coin.fromPartial(X))) || [], k;
    }
  };
  function y() {
    return {
      previousPeriod: BigInt(0),
      stake: "",
      height: BigInt(0)
    };
  }
  e.DelegatorStartingInfo = {
    typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfo",
    encode(G, k = o.BinaryWriter.create()) {
      return G.previousPeriod !== BigInt(0) && k.uint32(8).uint64(G.previousPeriod), G.stake !== "" && k.uint32(18).string(G.stake), G.height !== BigInt(0) && k.uint32(24).uint64(G.height), k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = y();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.previousPeriod = F.uint64();
            break;
          case 2:
            ee.stake = F.string();
            break;
          case 3:
            ee.height = F.uint64();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = y();
      return (0, u.isSet)(G.previousPeriod) && (k.previousPeriod = BigInt(G.previousPeriod.toString())), (0, u.isSet)(G.stake) && (k.stake = String(G.stake)), (0, u.isSet)(G.height) && (k.height = BigInt(G.height.toString())), k;
    },
    toJSON(G) {
      const k = {};
      return G.previousPeriod !== void 0 && (k.previousPeriod = (G.previousPeriod || BigInt(0)).toString()), G.stake !== void 0 && (k.stake = G.stake), G.height !== void 0 && (k.height = (G.height || BigInt(0)).toString()), k;
    },
    fromPartial(G) {
      const k = y();
      return G.previousPeriod !== void 0 && G.previousPeriod !== null && (k.previousPeriod = BigInt(G.previousPeriod.toString())), k.stake = G.stake ?? "", G.height !== void 0 && G.height !== null && (k.height = BigInt(G.height.toString())), k;
    }
  };
  function V() {
    return {
      validatorAddress: "",
      reward: []
    };
  }
  e.DelegationDelegatorReward = {
    typeUrl: "/cosmos.distribution.v1beta1.DelegationDelegatorReward",
    encode(G, k = o.BinaryWriter.create()) {
      G.validatorAddress !== "" && k.uint32(10).string(G.validatorAddress);
      for (const F of G.reward)
        n.DecCoin.encode(F, k.uint32(18).fork()).ldelim();
      return k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = V();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.validatorAddress = F.string();
            break;
          case 2:
            ee.reward.push(n.DecCoin.decode(F, F.uint32()));
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = V();
      return (0, u.isSet)(G.validatorAddress) && (k.validatorAddress = String(G.validatorAddress)), Array.isArray(G == null ? void 0 : G.reward) && (k.reward = G.reward.map((F) => n.DecCoin.fromJSON(F))), k;
    },
    toJSON(G) {
      const k = {};
      return G.validatorAddress !== void 0 && (k.validatorAddress = G.validatorAddress), G.reward ? k.reward = G.reward.map((F) => F ? n.DecCoin.toJSON(F) : void 0) : k.reward = [], k;
    },
    fromPartial(G) {
      var F;
      const k = V();
      return k.validatorAddress = G.validatorAddress ?? "", k.reward = ((F = G.reward) == null ? void 0 : F.map((X) => n.DecCoin.fromPartial(X))) || [], k;
    }
  };
  function M() {
    return {
      title: "",
      description: "",
      recipient: "",
      amount: "",
      deposit: ""
    };
  }
  e.CommunityPoolSpendProposalWithDeposit = {
    typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposalWithDeposit",
    encode(G, k = o.BinaryWriter.create()) {
      return G.title !== "" && k.uint32(10).string(G.title), G.description !== "" && k.uint32(18).string(G.description), G.recipient !== "" && k.uint32(26).string(G.recipient), G.amount !== "" && k.uint32(34).string(G.amount), G.deposit !== "" && k.uint32(42).string(G.deposit), k;
    },
    decode(G, k) {
      const F = G instanceof o.BinaryReader ? G : new o.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = M();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.title = F.string();
            break;
          case 2:
            ee.description = F.string();
            break;
          case 3:
            ee.recipient = F.string();
            break;
          case 4:
            ee.amount = F.string();
            break;
          case 5:
            ee.deposit = F.string();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = M();
      return (0, u.isSet)(G.title) && (k.title = String(G.title)), (0, u.isSet)(G.description) && (k.description = String(G.description)), (0, u.isSet)(G.recipient) && (k.recipient = String(G.recipient)), (0, u.isSet)(G.amount) && (k.amount = String(G.amount)), (0, u.isSet)(G.deposit) && (k.deposit = String(G.deposit)), k;
    },
    toJSON(G) {
      const k = {};
      return G.title !== void 0 && (k.title = G.title), G.description !== void 0 && (k.description = G.description), G.recipient !== void 0 && (k.recipient = G.recipient), G.amount !== void 0 && (k.amount = G.amount), G.deposit !== void 0 && (k.deposit = G.deposit), k;
    },
    fromPartial(G) {
      const k = M();
      return k.title = G.title ?? "", k.description = G.description ?? "", k.recipient = G.recipient ?? "", k.amount = G.amount ?? "", k.deposit = G.deposit ?? "", k;
    }
  };
})(distribution);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgCommunityPoolSpendResponse = e.MsgCommunityPoolSpend = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgFundCommunityPoolResponse = e.MsgFundCommunityPool = e.MsgWithdrawValidatorCommissionResponse = e.MsgWithdrawValidatorCommission = e.MsgWithdrawDelegatorRewardResponse = e.MsgWithdrawDelegatorReward = e.MsgSetWithdrawAddressResponse = e.MsgSetWithdrawAddress = e.protobufPackage = void 0;
  const n = coin$8, o = distribution, u = binary, c = helpers;
  e.protobufPackage = "cosmos.distribution.v1beta1";
  function d() {
    return {
      delegatorAddress: "",
      withdrawAddress: ""
    };
  }
  e.MsgSetWithdrawAddress = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
    encode(F, X = u.BinaryWriter.create()) {
      return F.delegatorAddress !== "" && X.uint32(10).string(F.delegatorAddress), F.withdrawAddress !== "" && X.uint32(18).string(F.withdrawAddress), X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = d();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.delegatorAddress = ee.string();
            break;
          case 2:
            Q.withdrawAddress = ee.string();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = d();
      return (0, c.isSet)(F.delegatorAddress) && (X.delegatorAddress = String(F.delegatorAddress)), (0, c.isSet)(F.withdrawAddress) && (X.withdrawAddress = String(F.withdrawAddress)), X;
    },
    toJSON(F) {
      const X = {};
      return F.delegatorAddress !== void 0 && (X.delegatorAddress = F.delegatorAddress), F.withdrawAddress !== void 0 && (X.withdrawAddress = F.withdrawAddress), X;
    },
    fromPartial(F) {
      const X = d();
      return X.delegatorAddress = F.delegatorAddress ?? "", X.withdrawAddress = F.withdrawAddress ?? "", X;
    }
  };
  function m() {
    return {};
  }
  e.MsgSetWithdrawAddressResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddressResponse",
    encode(F, X = u.BinaryWriter.create()) {
      return X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = m();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      return m();
    },
    toJSON(F) {
      return {};
    },
    fromPartial(F) {
      return m();
    }
  };
  function v() {
    return {
      delegatorAddress: "",
      validatorAddress: ""
    };
  }
  e.MsgWithdrawDelegatorReward = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
    encode(F, X = u.BinaryWriter.create()) {
      return F.delegatorAddress !== "" && X.uint32(10).string(F.delegatorAddress), F.validatorAddress !== "" && X.uint32(18).string(F.validatorAddress), X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = v();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.delegatorAddress = ee.string();
            break;
          case 2:
            Q.validatorAddress = ee.string();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = v();
      return (0, c.isSet)(F.delegatorAddress) && (X.delegatorAddress = String(F.delegatorAddress)), (0, c.isSet)(F.validatorAddress) && (X.validatorAddress = String(F.validatorAddress)), X;
    },
    toJSON(F) {
      const X = {};
      return F.delegatorAddress !== void 0 && (X.delegatorAddress = F.delegatorAddress), F.validatorAddress !== void 0 && (X.validatorAddress = F.validatorAddress), X;
    },
    fromPartial(F) {
      const X = v();
      return X.delegatorAddress = F.delegatorAddress ?? "", X.validatorAddress = F.validatorAddress ?? "", X;
    }
  };
  function S() {
    return {
      amount: []
    };
  }
  e.MsgWithdrawDelegatorRewardResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse",
    encode(F, X = u.BinaryWriter.create()) {
      for (const ee of F.amount)
        n.Coin.encode(ee, X.uint32(10).fork()).ldelim();
      return X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = S();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.amount.push(n.Coin.decode(ee, ee.uint32()));
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = S();
      return Array.isArray(F == null ? void 0 : F.amount) && (X.amount = F.amount.map((ee) => n.Coin.fromJSON(ee))), X;
    },
    toJSON(F) {
      const X = {};
      return F.amount ? X.amount = F.amount.map((ee) => ee ? n.Coin.toJSON(ee) : void 0) : X.amount = [], X;
    },
    fromPartial(F) {
      var ee;
      const X = S();
      return X.amount = ((ee = F.amount) == null ? void 0 : ee.map((ue) => n.Coin.fromPartial(ue))) || [], X;
    }
  };
  function $() {
    return {
      validatorAddress: ""
    };
  }
  e.MsgWithdrawValidatorCommission = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
    encode(F, X = u.BinaryWriter.create()) {
      return F.validatorAddress !== "" && X.uint32(10).string(F.validatorAddress), X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = $();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.validatorAddress = ee.string();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = $();
      return (0, c.isSet)(F.validatorAddress) && (X.validatorAddress = String(F.validatorAddress)), X;
    },
    toJSON(F) {
      const X = {};
      return F.validatorAddress !== void 0 && (X.validatorAddress = F.validatorAddress), X;
    },
    fromPartial(F) {
      const X = $();
      return X.validatorAddress = F.validatorAddress ?? "", X;
    }
  };
  function E() {
    return {
      amount: []
    };
  }
  e.MsgWithdrawValidatorCommissionResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommissionResponse",
    encode(F, X = u.BinaryWriter.create()) {
      for (const ee of F.amount)
        n.Coin.encode(ee, X.uint32(10).fork()).ldelim();
      return X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = E();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.amount.push(n.Coin.decode(ee, ee.uint32()));
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = E();
      return Array.isArray(F == null ? void 0 : F.amount) && (X.amount = F.amount.map((ee) => n.Coin.fromJSON(ee))), X;
    },
    toJSON(F) {
      const X = {};
      return F.amount ? X.amount = F.amount.map((ee) => ee ? n.Coin.toJSON(ee) : void 0) : X.amount = [], X;
    },
    fromPartial(F) {
      var ee;
      const X = E();
      return X.amount = ((ee = F.amount) == null ? void 0 : ee.map((ue) => n.Coin.fromPartial(ue))) || [], X;
    }
  };
  function O() {
    return {
      amount: [],
      depositor: ""
    };
  }
  e.MsgFundCommunityPool = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
    encode(F, X = u.BinaryWriter.create()) {
      for (const ee of F.amount)
        n.Coin.encode(ee, X.uint32(10).fork()).ldelim();
      return F.depositor !== "" && X.uint32(18).string(F.depositor), X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = O();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.amount.push(n.Coin.decode(ee, ee.uint32()));
            break;
          case 2:
            Q.depositor = ee.string();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = O();
      return Array.isArray(F == null ? void 0 : F.amount) && (X.amount = F.amount.map((ee) => n.Coin.fromJSON(ee))), (0, c.isSet)(F.depositor) && (X.depositor = String(F.depositor)), X;
    },
    toJSON(F) {
      const X = {};
      return F.amount ? X.amount = F.amount.map((ee) => ee ? n.Coin.toJSON(ee) : void 0) : X.amount = [], F.depositor !== void 0 && (X.depositor = F.depositor), X;
    },
    fromPartial(F) {
      var ee;
      const X = O();
      return X.amount = ((ee = F.amount) == null ? void 0 : ee.map((ue) => n.Coin.fromPartial(ue))) || [], X.depositor = F.depositor ?? "", X;
    }
  };
  function T() {
    return {};
  }
  e.MsgFundCommunityPoolResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPoolResponse",
    encode(F, X = u.BinaryWriter.create()) {
      return X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = T();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      return T();
    },
    toJSON(F) {
      return {};
    },
    fromPartial(F) {
      return T();
    }
  };
  function y() {
    return {
      authority: "",
      params: o.Params.fromPartial({})
    };
  }
  e.MsgUpdateParams = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgUpdateParams",
    encode(F, X = u.BinaryWriter.create()) {
      return F.authority !== "" && X.uint32(10).string(F.authority), F.params !== void 0 && o.Params.encode(F.params, X.uint32(18).fork()).ldelim(), X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = y();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.authority = ee.string();
            break;
          case 2:
            Q.params = o.Params.decode(ee, ee.uint32());
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = y();
      return (0, c.isSet)(F.authority) && (X.authority = String(F.authority)), (0, c.isSet)(F.params) && (X.params = o.Params.fromJSON(F.params)), X;
    },
    toJSON(F) {
      const X = {};
      return F.authority !== void 0 && (X.authority = F.authority), F.params !== void 0 && (X.params = F.params ? o.Params.toJSON(F.params) : void 0), X;
    },
    fromPartial(F) {
      const X = y();
      return X.authority = F.authority ?? "", F.params !== void 0 && F.params !== null && (X.params = o.Params.fromPartial(F.params)), X;
    }
  };
  function V() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgUpdateParamsResponse",
    encode(F, X = u.BinaryWriter.create()) {
      return X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = V();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      return V();
    },
    toJSON(F) {
      return {};
    },
    fromPartial(F) {
      return V();
    }
  };
  function M() {
    return {
      authority: "",
      recipient: "",
      amount: []
    };
  }
  e.MsgCommunityPoolSpend = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgCommunityPoolSpend",
    encode(F, X = u.BinaryWriter.create()) {
      F.authority !== "" && X.uint32(10).string(F.authority), F.recipient !== "" && X.uint32(18).string(F.recipient);
      for (const ee of F.amount)
        n.Coin.encode(ee, X.uint32(26).fork()).ldelim();
      return X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = M();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.authority = ee.string();
            break;
          case 2:
            Q.recipient = ee.string();
            break;
          case 3:
            Q.amount.push(n.Coin.decode(ee, ee.uint32()));
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = M();
      return (0, c.isSet)(F.authority) && (X.authority = String(F.authority)), (0, c.isSet)(F.recipient) && (X.recipient = String(F.recipient)), Array.isArray(F == null ? void 0 : F.amount) && (X.amount = F.amount.map((ee) => n.Coin.fromJSON(ee))), X;
    },
    toJSON(F) {
      const X = {};
      return F.authority !== void 0 && (X.authority = F.authority), F.recipient !== void 0 && (X.recipient = F.recipient), F.amount ? X.amount = F.amount.map((ee) => ee ? n.Coin.toJSON(ee) : void 0) : X.amount = [], X;
    },
    fromPartial(F) {
      var ee;
      const X = M();
      return X.authority = F.authority ?? "", X.recipient = F.recipient ?? "", X.amount = ((ee = F.amount) == null ? void 0 : ee.map((ue) => n.Coin.fromPartial(ue))) || [], X;
    }
  };
  function G() {
    return {};
  }
  e.MsgCommunityPoolSpendResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.MsgCommunityPoolSpendResponse",
    encode(F, X = u.BinaryWriter.create()) {
      return X;
    },
    decode(F, X) {
      const ee = F instanceof u.BinaryReader ? F : new u.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = G();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      return G();
    },
    toJSON(F) {
      return {};
    },
    fromPartial(F) {
      return G();
    }
  };
  class k {
    constructor(X) {
      this.rpc = X, this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this), this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this), this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this), this.FundCommunityPool = this.FundCommunityPool.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this);
    }
    SetWithdrawAddress(X) {
      const ee = e.MsgSetWithdrawAddress.encode(X).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", ee).then((Q) => e.MsgSetWithdrawAddressResponse.decode(new u.BinaryReader(Q)));
    }
    WithdrawDelegatorReward(X) {
      const ee = e.MsgWithdrawDelegatorReward.encode(X).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", ee).then((Q) => e.MsgWithdrawDelegatorRewardResponse.decode(new u.BinaryReader(Q)));
    }
    WithdrawValidatorCommission(X) {
      const ee = e.MsgWithdrawValidatorCommission.encode(X).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", ee).then((Q) => e.MsgWithdrawValidatorCommissionResponse.decode(new u.BinaryReader(Q)));
    }
    FundCommunityPool(X) {
      const ee = e.MsgFundCommunityPool.encode(X).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", ee).then((Q) => e.MsgFundCommunityPoolResponse.decode(new u.BinaryReader(Q)));
    }
    UpdateParams(X) {
      const ee = e.MsgUpdateParams.encode(X).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", ee).then((Q) => e.MsgUpdateParamsResponse.decode(new u.BinaryReader(Q)));
    }
    CommunityPoolSpend(X) {
      const ee = e.MsgCommunityPoolSpend.encode(X).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", ee).then((Q) => e.MsgCommunityPoolSpendResponse.decode(new u.BinaryReader(Q)));
    }
  }
  e.MsgClientImpl = k;
})(tx$m);
Object.defineProperty(messages$g, "__esModule", { value: !0 });
messages$g.isMsgWithdrawDelegatorRewardEncodeObject = messages$g.distributionTypes = void 0;
const tx_1$o = tx$m;
messages$g.distributionTypes = [
  ["/cosmos.distribution.v1beta1.MsgFundCommunityPool", tx_1$o.MsgFundCommunityPool],
  ["/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", tx_1$o.MsgSetWithdrawAddress],
  ["/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", tx_1$o.MsgWithdrawDelegatorReward],
  ["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", tx_1$o.MsgWithdrawValidatorCommission]
];
function isMsgWithdrawDelegatorRewardEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
}
messages$g.isMsgWithdrawDelegatorRewardEncodeObject = isMsgWithdrawDelegatorRewardEncodeObject$1;
var queries$j = {}, query$a = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryCommunityPoolResponse = e.QueryCommunityPoolRequest = e.QueryDelegatorWithdrawAddressResponse = e.QueryDelegatorWithdrawAddressRequest = e.QueryDelegatorValidatorsResponse = e.QueryDelegatorValidatorsRequest = e.QueryDelegationTotalRewardsResponse = e.QueryDelegationTotalRewardsRequest = e.QueryDelegationRewardsResponse = e.QueryDelegationRewardsRequest = e.QueryValidatorSlashesResponse = e.QueryValidatorSlashesRequest = e.QueryValidatorCommissionResponse = e.QueryValidatorCommissionRequest = e.QueryValidatorOutstandingRewardsResponse = e.QueryValidatorOutstandingRewardsRequest = e.QueryValidatorDistributionInfoResponse = e.QueryValidatorDistributionInfoRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.protobufPackage = void 0;
  const n = pagination, o = distribution, u = coin$8, c = binary, d = helpers;
  e.protobufPackage = "cosmos.distribution.v1beta1";
  function m() {
    return {};
  }
  e.QueryParamsRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryParamsRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = m();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      return m();
    },
    toJSON(H) {
      return {};
    },
    fromPartial(H) {
      return m();
    }
  };
  function v() {
    return {
      params: o.Params.fromPartial({})
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryParamsResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.params !== void 0 && o.Params.encode(H.params, C.uint32(10).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = v();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.params = o.Params.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = v();
      return (0, d.isSet)(H.params) && (C.params = o.Params.fromJSON(H.params)), C;
    },
    toJSON(H) {
      const C = {};
      return H.params !== void 0 && (C.params = H.params ? o.Params.toJSON(H.params) : void 0), C;
    },
    fromPartial(H) {
      const C = v();
      return H.params !== void 0 && H.params !== null && (C.params = o.Params.fromPartial(H.params)), C;
    }
  };
  function S() {
    return {
      validatorAddress: ""
    };
  }
  e.QueryValidatorDistributionInfoRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorDistributionInfoRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.validatorAddress !== "" && C.uint32(10).string(H.validatorAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = S();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.validatorAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = S();
      return (0, d.isSet)(H.validatorAddress) && (C.validatorAddress = String(H.validatorAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.validatorAddress !== void 0 && (C.validatorAddress = H.validatorAddress), C;
    },
    fromPartial(H) {
      const C = S();
      return C.validatorAddress = H.validatorAddress ?? "", C;
    }
  };
  function $() {
    return {
      operatorAddress: "",
      selfBondRewards: [],
      commission: []
    };
  }
  e.QueryValidatorDistributionInfoResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorDistributionInfoResponse",
    encode(H, C = c.BinaryWriter.create()) {
      H.operatorAddress !== "" && C.uint32(10).string(H.operatorAddress);
      for (const w of H.selfBondRewards)
        u.DecCoin.encode(w, C.uint32(18).fork()).ldelim();
      for (const w of H.commission)
        u.DecCoin.encode(w, C.uint32(26).fork()).ldelim();
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = $();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.operatorAddress = w.string();
            break;
          case 2:
            J.selfBondRewards.push(u.DecCoin.decode(w, w.uint32()));
            break;
          case 3:
            J.commission.push(u.DecCoin.decode(w, w.uint32()));
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = $();
      return (0, d.isSet)(H.operatorAddress) && (C.operatorAddress = String(H.operatorAddress)), Array.isArray(H == null ? void 0 : H.selfBondRewards) && (C.selfBondRewards = H.selfBondRewards.map((w) => u.DecCoin.fromJSON(w))), Array.isArray(H == null ? void 0 : H.commission) && (C.commission = H.commission.map((w) => u.DecCoin.fromJSON(w))), C;
    },
    toJSON(H) {
      const C = {};
      return H.operatorAddress !== void 0 && (C.operatorAddress = H.operatorAddress), H.selfBondRewards ? C.selfBondRewards = H.selfBondRewards.map((w) => w ? u.DecCoin.toJSON(w) : void 0) : C.selfBondRewards = [], H.commission ? C.commission = H.commission.map((w) => w ? u.DecCoin.toJSON(w) : void 0) : C.commission = [], C;
    },
    fromPartial(H) {
      var w, P;
      const C = $();
      return C.operatorAddress = H.operatorAddress ?? "", C.selfBondRewards = ((w = H.selfBondRewards) == null ? void 0 : w.map((J) => u.DecCoin.fromPartial(J))) || [], C.commission = ((P = H.commission) == null ? void 0 : P.map((J) => u.DecCoin.fromPartial(J))) || [], C;
    }
  };
  function E() {
    return {
      validatorAddress: ""
    };
  }
  e.QueryValidatorOutstandingRewardsRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.validatorAddress !== "" && C.uint32(10).string(H.validatorAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = E();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.validatorAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = E();
      return (0, d.isSet)(H.validatorAddress) && (C.validatorAddress = String(H.validatorAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.validatorAddress !== void 0 && (C.validatorAddress = H.validatorAddress), C;
    },
    fromPartial(H) {
      const C = E();
      return C.validatorAddress = H.validatorAddress ?? "", C;
    }
  };
  function O() {
    return {
      rewards: o.ValidatorOutstandingRewards.fromPartial({})
    };
  }
  e.QueryValidatorOutstandingRewardsResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.rewards !== void 0 && o.ValidatorOutstandingRewards.encode(H.rewards, C.uint32(10).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = O();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.rewards = o.ValidatorOutstandingRewards.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = O();
      return (0, d.isSet)(H.rewards) && (C.rewards = o.ValidatorOutstandingRewards.fromJSON(H.rewards)), C;
    },
    toJSON(H) {
      const C = {};
      return H.rewards !== void 0 && (C.rewards = H.rewards ? o.ValidatorOutstandingRewards.toJSON(H.rewards) : void 0), C;
    },
    fromPartial(H) {
      const C = O();
      return H.rewards !== void 0 && H.rewards !== null && (C.rewards = o.ValidatorOutstandingRewards.fromPartial(H.rewards)), C;
    }
  };
  function T() {
    return {
      validatorAddress: ""
    };
  }
  e.QueryValidatorCommissionRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.validatorAddress !== "" && C.uint32(10).string(H.validatorAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = T();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.validatorAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = T();
      return (0, d.isSet)(H.validatorAddress) && (C.validatorAddress = String(H.validatorAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.validatorAddress !== void 0 && (C.validatorAddress = H.validatorAddress), C;
    },
    fromPartial(H) {
      const C = T();
      return C.validatorAddress = H.validatorAddress ?? "", C;
    }
  };
  function y() {
    return {
      commission: o.ValidatorAccumulatedCommission.fromPartial({})
    };
  }
  e.QueryValidatorCommissionResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.commission !== void 0 && o.ValidatorAccumulatedCommission.encode(H.commission, C.uint32(10).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = y();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.commission = o.ValidatorAccumulatedCommission.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = y();
      return (0, d.isSet)(H.commission) && (C.commission = o.ValidatorAccumulatedCommission.fromJSON(H.commission)), C;
    },
    toJSON(H) {
      const C = {};
      return H.commission !== void 0 && (C.commission = H.commission ? o.ValidatorAccumulatedCommission.toJSON(H.commission) : void 0), C;
    },
    fromPartial(H) {
      const C = y();
      return H.commission !== void 0 && H.commission !== null && (C.commission = o.ValidatorAccumulatedCommission.fromPartial(H.commission)), C;
    }
  };
  function V() {
    return {
      validatorAddress: "",
      startingHeight: BigInt(0),
      endingHeight: BigInt(0),
      pagination: void 0
    };
  }
  e.QueryValidatorSlashesRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.validatorAddress !== "" && C.uint32(10).string(H.validatorAddress), H.startingHeight !== BigInt(0) && C.uint32(16).uint64(H.startingHeight), H.endingHeight !== BigInt(0) && C.uint32(24).uint64(H.endingHeight), H.pagination !== void 0 && n.PageRequest.encode(H.pagination, C.uint32(34).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = V();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.validatorAddress = w.string();
            break;
          case 2:
            J.startingHeight = w.uint64();
            break;
          case 3:
            J.endingHeight = w.uint64();
            break;
          case 4:
            J.pagination = n.PageRequest.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = V();
      return (0, d.isSet)(H.validatorAddress) && (C.validatorAddress = String(H.validatorAddress)), (0, d.isSet)(H.startingHeight) && (C.startingHeight = BigInt(H.startingHeight.toString())), (0, d.isSet)(H.endingHeight) && (C.endingHeight = BigInt(H.endingHeight.toString())), (0, d.isSet)(H.pagination) && (C.pagination = n.PageRequest.fromJSON(H.pagination)), C;
    },
    toJSON(H) {
      const C = {};
      return H.validatorAddress !== void 0 && (C.validatorAddress = H.validatorAddress), H.startingHeight !== void 0 && (C.startingHeight = (H.startingHeight || BigInt(0)).toString()), H.endingHeight !== void 0 && (C.endingHeight = (H.endingHeight || BigInt(0)).toString()), H.pagination !== void 0 && (C.pagination = H.pagination ? n.PageRequest.toJSON(H.pagination) : void 0), C;
    },
    fromPartial(H) {
      const C = V();
      return C.validatorAddress = H.validatorAddress ?? "", H.startingHeight !== void 0 && H.startingHeight !== null && (C.startingHeight = BigInt(H.startingHeight.toString())), H.endingHeight !== void 0 && H.endingHeight !== null && (C.endingHeight = BigInt(H.endingHeight.toString())), H.pagination !== void 0 && H.pagination !== null && (C.pagination = n.PageRequest.fromPartial(H.pagination)), C;
    }
  };
  function M() {
    return {
      slashes: [],
      pagination: void 0
    };
  }
  e.QueryValidatorSlashesResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesResponse",
    encode(H, C = c.BinaryWriter.create()) {
      for (const w of H.slashes)
        o.ValidatorSlashEvent.encode(w, C.uint32(10).fork()).ldelim();
      return H.pagination !== void 0 && n.PageResponse.encode(H.pagination, C.uint32(18).fork()).ldelim(), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = M();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.slashes.push(o.ValidatorSlashEvent.decode(w, w.uint32()));
            break;
          case 2:
            J.pagination = n.PageResponse.decode(w, w.uint32());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = M();
      return Array.isArray(H == null ? void 0 : H.slashes) && (C.slashes = H.slashes.map((w) => o.ValidatorSlashEvent.fromJSON(w))), (0, d.isSet)(H.pagination) && (C.pagination = n.PageResponse.fromJSON(H.pagination)), C;
    },
    toJSON(H) {
      const C = {};
      return H.slashes ? C.slashes = H.slashes.map((w) => w ? o.ValidatorSlashEvent.toJSON(w) : void 0) : C.slashes = [], H.pagination !== void 0 && (C.pagination = H.pagination ? n.PageResponse.toJSON(H.pagination) : void 0), C;
    },
    fromPartial(H) {
      var w;
      const C = M();
      return C.slashes = ((w = H.slashes) == null ? void 0 : w.map((P) => o.ValidatorSlashEvent.fromPartial(P))) || [], H.pagination !== void 0 && H.pagination !== null && (C.pagination = n.PageResponse.fromPartial(H.pagination)), C;
    }
  };
  function G() {
    return {
      delegatorAddress: "",
      validatorAddress: ""
    };
  }
  e.QueryDelegationRewardsRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.delegatorAddress !== "" && C.uint32(10).string(H.delegatorAddress), H.validatorAddress !== "" && C.uint32(18).string(H.validatorAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = G();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.delegatorAddress = w.string();
            break;
          case 2:
            J.validatorAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = G();
      return (0, d.isSet)(H.delegatorAddress) && (C.delegatorAddress = String(H.delegatorAddress)), (0, d.isSet)(H.validatorAddress) && (C.validatorAddress = String(H.validatorAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.delegatorAddress !== void 0 && (C.delegatorAddress = H.delegatorAddress), H.validatorAddress !== void 0 && (C.validatorAddress = H.validatorAddress), C;
    },
    fromPartial(H) {
      const C = G();
      return C.delegatorAddress = H.delegatorAddress ?? "", C.validatorAddress = H.validatorAddress ?? "", C;
    }
  };
  function k() {
    return {
      rewards: []
    };
  }
  e.QueryDelegationRewardsResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsResponse",
    encode(H, C = c.BinaryWriter.create()) {
      for (const w of H.rewards)
        u.DecCoin.encode(w, C.uint32(10).fork()).ldelim();
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = k();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.rewards.push(u.DecCoin.decode(w, w.uint32()));
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = k();
      return Array.isArray(H == null ? void 0 : H.rewards) && (C.rewards = H.rewards.map((w) => u.DecCoin.fromJSON(w))), C;
    },
    toJSON(H) {
      const C = {};
      return H.rewards ? C.rewards = H.rewards.map((w) => w ? u.DecCoin.toJSON(w) : void 0) : C.rewards = [], C;
    },
    fromPartial(H) {
      var w;
      const C = k();
      return C.rewards = ((w = H.rewards) == null ? void 0 : w.map((P) => u.DecCoin.fromPartial(P))) || [], C;
    }
  };
  function F() {
    return {
      delegatorAddress: ""
    };
  }
  e.QueryDelegationTotalRewardsRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.delegatorAddress !== "" && C.uint32(10).string(H.delegatorAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = F();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.delegatorAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = F();
      return (0, d.isSet)(H.delegatorAddress) && (C.delegatorAddress = String(H.delegatorAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.delegatorAddress !== void 0 && (C.delegatorAddress = H.delegatorAddress), C;
    },
    fromPartial(H) {
      const C = F();
      return C.delegatorAddress = H.delegatorAddress ?? "", C;
    }
  };
  function X() {
    return {
      rewards: [],
      total: []
    };
  }
  e.QueryDelegationTotalRewardsResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsResponse",
    encode(H, C = c.BinaryWriter.create()) {
      for (const w of H.rewards)
        o.DelegationDelegatorReward.encode(w, C.uint32(10).fork()).ldelim();
      for (const w of H.total)
        u.DecCoin.encode(w, C.uint32(18).fork()).ldelim();
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = X();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.rewards.push(o.DelegationDelegatorReward.decode(w, w.uint32()));
            break;
          case 2:
            J.total.push(u.DecCoin.decode(w, w.uint32()));
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = X();
      return Array.isArray(H == null ? void 0 : H.rewards) && (C.rewards = H.rewards.map((w) => o.DelegationDelegatorReward.fromJSON(w))), Array.isArray(H == null ? void 0 : H.total) && (C.total = H.total.map((w) => u.DecCoin.fromJSON(w))), C;
    },
    toJSON(H) {
      const C = {};
      return H.rewards ? C.rewards = H.rewards.map((w) => w ? o.DelegationDelegatorReward.toJSON(w) : void 0) : C.rewards = [], H.total ? C.total = H.total.map((w) => w ? u.DecCoin.toJSON(w) : void 0) : C.total = [], C;
    },
    fromPartial(H) {
      var w, P;
      const C = X();
      return C.rewards = ((w = H.rewards) == null ? void 0 : w.map((J) => o.DelegationDelegatorReward.fromPartial(J))) || [], C.total = ((P = H.total) == null ? void 0 : P.map((J) => u.DecCoin.fromPartial(J))) || [], C;
    }
  };
  function ee() {
    return {
      delegatorAddress: ""
    };
  }
  e.QueryDelegatorValidatorsRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.delegatorAddress !== "" && C.uint32(10).string(H.delegatorAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = ee();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.delegatorAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = ee();
      return (0, d.isSet)(H.delegatorAddress) && (C.delegatorAddress = String(H.delegatorAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.delegatorAddress !== void 0 && (C.delegatorAddress = H.delegatorAddress), C;
    },
    fromPartial(H) {
      const C = ee();
      return C.delegatorAddress = H.delegatorAddress ?? "", C;
    }
  };
  function ue() {
    return {
      validators: []
    };
  }
  e.QueryDelegatorValidatorsResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsResponse",
    encode(H, C = c.BinaryWriter.create()) {
      for (const w of H.validators)
        C.uint32(10).string(w);
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = ue();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.validators.push(w.string());
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = ue();
      return Array.isArray(H == null ? void 0 : H.validators) && (C.validators = H.validators.map((w) => String(w))), C;
    },
    toJSON(H) {
      const C = {};
      return H.validators ? C.validators = H.validators.map((w) => w) : C.validators = [], C;
    },
    fromPartial(H) {
      var w;
      const C = ue();
      return C.validators = ((w = H.validators) == null ? void 0 : w.map((P) => P)) || [], C;
    }
  };
  function Q() {
    return {
      delegatorAddress: ""
    };
  }
  e.QueryDelegatorWithdrawAddressRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return H.delegatorAddress !== "" && C.uint32(10).string(H.delegatorAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = Q();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.delegatorAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = Q();
      return (0, d.isSet)(H.delegatorAddress) && (C.delegatorAddress = String(H.delegatorAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.delegatorAddress !== void 0 && (C.delegatorAddress = H.delegatorAddress), C;
    },
    fromPartial(H) {
      const C = Q();
      return C.delegatorAddress = H.delegatorAddress ?? "", C;
    }
  };
  function Y() {
    return {
      withdrawAddress: ""
    };
  }
  e.QueryDelegatorWithdrawAddressResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressResponse",
    encode(H, C = c.BinaryWriter.create()) {
      return H.withdrawAddress !== "" && C.uint32(10).string(H.withdrawAddress), C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = Y();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.withdrawAddress = w.string();
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = Y();
      return (0, d.isSet)(H.withdrawAddress) && (C.withdrawAddress = String(H.withdrawAddress)), C;
    },
    toJSON(H) {
      const C = {};
      return H.withdrawAddress !== void 0 && (C.withdrawAddress = H.withdrawAddress), C;
    },
    fromPartial(H) {
      const C = Y();
      return C.withdrawAddress = H.withdrawAddress ?? "", C;
    }
  };
  function pe() {
    return {};
  }
  e.QueryCommunityPoolRequest = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolRequest",
    encode(H, C = c.BinaryWriter.create()) {
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = pe();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      return pe();
    },
    toJSON(H) {
      return {};
    },
    fromPartial(H) {
      return pe();
    }
  };
  function oe() {
    return {
      pool: []
    };
  }
  e.QueryCommunityPoolResponse = {
    typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolResponse",
    encode(H, C = c.BinaryWriter.create()) {
      for (const w of H.pool)
        u.DecCoin.encode(w, C.uint32(10).fork()).ldelim();
      return C;
    },
    decode(H, C) {
      const w = H instanceof c.BinaryReader ? H : new c.BinaryReader(H);
      let P = C === void 0 ? w.len : w.pos + C;
      const J = oe();
      for (; w.pos < P; ) {
        const se = w.uint32();
        switch (se >>> 3) {
          case 1:
            J.pool.push(u.DecCoin.decode(w, w.uint32()));
            break;
          default:
            w.skipType(se & 7);
            break;
        }
      }
      return J;
    },
    fromJSON(H) {
      const C = oe();
      return Array.isArray(H == null ? void 0 : H.pool) && (C.pool = H.pool.map((w) => u.DecCoin.fromJSON(w))), C;
    },
    toJSON(H) {
      const C = {};
      return H.pool ? C.pool = H.pool.map((w) => w ? u.DecCoin.toJSON(w) : void 0) : C.pool = [], C;
    },
    fromPartial(H) {
      var w;
      const C = oe();
      return C.pool = ((w = H.pool) == null ? void 0 : w.map((P) => u.DecCoin.fromPartial(P))) || [], C;
    }
  };
  class ne {
    constructor(C) {
      this.rpc = C, this.Params = this.Params.bind(this), this.ValidatorDistributionInfo = this.ValidatorDistributionInfo.bind(this), this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this), this.ValidatorCommission = this.ValidatorCommission.bind(this), this.ValidatorSlashes = this.ValidatorSlashes.bind(this), this.DelegationRewards = this.DelegationRewards.bind(this), this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this), this.DelegatorValidators = this.DelegatorValidators.bind(this), this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this), this.CommunityPool = this.CommunityPool.bind(this);
    }
    Params(C = {}) {
      const w = e.QueryParamsRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", w).then((J) => e.QueryParamsResponse.decode(new c.BinaryReader(J)));
    }
    ValidatorDistributionInfo(C) {
      const w = e.QueryValidatorDistributionInfoRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorDistributionInfo", w).then((J) => e.QueryValidatorDistributionInfoResponse.decode(new c.BinaryReader(J)));
    }
    ValidatorOutstandingRewards(C) {
      const w = e.QueryValidatorOutstandingRewardsRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", w).then((J) => e.QueryValidatorOutstandingRewardsResponse.decode(new c.BinaryReader(J)));
    }
    ValidatorCommission(C) {
      const w = e.QueryValidatorCommissionRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", w).then((J) => e.QueryValidatorCommissionResponse.decode(new c.BinaryReader(J)));
    }
    ValidatorSlashes(C) {
      const w = e.QueryValidatorSlashesRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", w).then((J) => e.QueryValidatorSlashesResponse.decode(new c.BinaryReader(J)));
    }
    DelegationRewards(C) {
      const w = e.QueryDelegationRewardsRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", w).then((J) => e.QueryDelegationRewardsResponse.decode(new c.BinaryReader(J)));
    }
    DelegationTotalRewards(C) {
      const w = e.QueryDelegationTotalRewardsRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", w).then((J) => e.QueryDelegationTotalRewardsResponse.decode(new c.BinaryReader(J)));
    }
    DelegatorValidators(C) {
      const w = e.QueryDelegatorValidatorsRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", w).then((J) => e.QueryDelegatorValidatorsResponse.decode(new c.BinaryReader(J)));
    }
    DelegatorWithdrawAddress(C) {
      const w = e.QueryDelegatorWithdrawAddressRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", w).then((J) => e.QueryDelegatorWithdrawAddressResponse.decode(new c.BinaryReader(J)));
    }
    CommunityPool(C = {}) {
      const w = e.QueryCommunityPoolRequest.encode(C).finish();
      return this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", w).then((J) => e.QueryCommunityPoolResponse.decode(new c.BinaryReader(J)));
    }
  }
  e.QueryClientImpl = ne;
})(query$a);
Object.defineProperty(queries$j, "__esModule", { value: !0 });
queries$j.setupDistributionExtension = void 0;
const query_1$h = query$a, queryclient_1$m = queryclient$3;
function setupDistributionExtension$1(e) {
  const n = (0, queryclient_1$m.createProtobufRpcClient)(e), o = new query_1$h.QueryClientImpl(n);
  return {
    distribution: {
      communityPool: async () => await o.CommunityPool({}),
      delegationRewards: async (u, c) => await o.DelegationRewards({
        delegatorAddress: u,
        validatorAddress: c
      }),
      delegationTotalRewards: async (u) => await o.DelegationTotalRewards({
        delegatorAddress: u
      }),
      delegatorValidators: async (u) => await o.DelegatorValidators({
        delegatorAddress: u
      }),
      delegatorWithdrawAddress: async (u) => await o.DelegatorWithdrawAddress({
        delegatorAddress: u
      }),
      params: async () => await o.Params({}),
      validatorCommission: async (u) => await o.ValidatorCommission({
        validatorAddress: u
      }),
      validatorOutstandingRewards: async (u) => await o.ValidatorOutstandingRewards({
        validatorAddress: u
      }),
      validatorSlashes: async (u, c, d, m) => await o.ValidatorSlashes({
        validatorAddress: u,
        startingHeight: BigInt(c),
        endingHeight: BigInt(d),
        pagination: (0, queryclient_1$m.createPagination)(m)
      })
    }
  };
}
queries$j.setupDistributionExtension = setupDistributionExtension$1;
var aminomessages$j = {};
Object.defineProperty(aminomessages$j, "__esModule", { value: !0 });
aminomessages$j.createEvidenceAminoConverters = aminomessages$j.isAminoMsgSubmitEvidence = void 0;
function isAminoMsgSubmitEvidence$1(e) {
  return e.type === "cosmos-sdk/MsgSubmitEvidence";
}
aminomessages$j.isAminoMsgSubmitEvidence = isAminoMsgSubmitEvidence$1;
function createEvidenceAminoConverters$1() {
  throw new Error("Not implemented");
}
aminomessages$j.createEvidenceAminoConverters = createEvidenceAminoConverters$1;
var aminomessages$i = {};
Object.defineProperty(aminomessages$i, "__esModule", { value: !0 });
aminomessages$i.createFeegrantAminoConverters = void 0;
function createFeegrantAminoConverters$1() {
  return {
    // For Cosmos SDK < 0.46 the Amino JSON codec was broken on chain and thus inaccessible.
    // Now this can be implemented for 0.46+ chains, see
    // https://github.com/cosmos/cosmjs/issues/1092
    //
    // "/cosmos.feegrant.v1beta1.MsgGrantAllowance": IMPLEMENT_ME,
    // "/cosmos.feegrant.v1beta1.MsgRevokeAllowance": IMPLEMENT_ME,
  };
}
aminomessages$i.createFeegrantAminoConverters = createFeegrantAminoConverters$1;
var messages$f = {}, tx$l = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgRevokeAllowanceResponse = e.MsgRevokeAllowance = e.MsgGrantAllowanceResponse = e.MsgGrantAllowance = e.protobufPackage = void 0;
  const n = any$1, o = binary, u = helpers;
  e.protobufPackage = "cosmos.feegrant.v1beta1";
  function c() {
    return {
      granter: "",
      grantee: "",
      allowance: void 0
    };
  }
  e.MsgGrantAllowance = {
    typeUrl: "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
    encode($, E = o.BinaryWriter.create()) {
      return $.granter !== "" && E.uint32(10).string($.granter), $.grantee !== "" && E.uint32(18).string($.grantee), $.allowance !== void 0 && n.Any.encode($.allowance, E.uint32(26).fork()).ldelim(), E;
    },
    decode($, E) {
      const O = $ instanceof o.BinaryReader ? $ : new o.BinaryReader($);
      let T = E === void 0 ? O.len : O.pos + E;
      const y = c();
      for (; O.pos < T; ) {
        const V = O.uint32();
        switch (V >>> 3) {
          case 1:
            y.granter = O.string();
            break;
          case 2:
            y.grantee = O.string();
            break;
          case 3:
            y.allowance = n.Any.decode(O, O.uint32());
            break;
          default:
            O.skipType(V & 7);
            break;
        }
      }
      return y;
    },
    fromJSON($) {
      const E = c();
      return (0, u.isSet)($.granter) && (E.granter = String($.granter)), (0, u.isSet)($.grantee) && (E.grantee = String($.grantee)), (0, u.isSet)($.allowance) && (E.allowance = n.Any.fromJSON($.allowance)), E;
    },
    toJSON($) {
      const E = {};
      return $.granter !== void 0 && (E.granter = $.granter), $.grantee !== void 0 && (E.grantee = $.grantee), $.allowance !== void 0 && (E.allowance = $.allowance ? n.Any.toJSON($.allowance) : void 0), E;
    },
    fromPartial($) {
      const E = c();
      return E.granter = $.granter ?? "", E.grantee = $.grantee ?? "", $.allowance !== void 0 && $.allowance !== null && (E.allowance = n.Any.fromPartial($.allowance)), E;
    }
  };
  function d() {
    return {};
  }
  e.MsgGrantAllowanceResponse = {
    typeUrl: "/cosmos.feegrant.v1beta1.MsgGrantAllowanceResponse",
    encode($, E = o.BinaryWriter.create()) {
      return E;
    },
    decode($, E) {
      const O = $ instanceof o.BinaryReader ? $ : new o.BinaryReader($);
      let T = E === void 0 ? O.len : O.pos + E;
      const y = d();
      for (; O.pos < T; ) {
        const V = O.uint32();
        switch (V >>> 3) {
          default:
            O.skipType(V & 7);
            break;
        }
      }
      return y;
    },
    fromJSON($) {
      return d();
    },
    toJSON($) {
      return {};
    },
    fromPartial($) {
      return d();
    }
  };
  function m() {
    return {
      granter: "",
      grantee: ""
    };
  }
  e.MsgRevokeAllowance = {
    typeUrl: "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
    encode($, E = o.BinaryWriter.create()) {
      return $.granter !== "" && E.uint32(10).string($.granter), $.grantee !== "" && E.uint32(18).string($.grantee), E;
    },
    decode($, E) {
      const O = $ instanceof o.BinaryReader ? $ : new o.BinaryReader($);
      let T = E === void 0 ? O.len : O.pos + E;
      const y = m();
      for (; O.pos < T; ) {
        const V = O.uint32();
        switch (V >>> 3) {
          case 1:
            y.granter = O.string();
            break;
          case 2:
            y.grantee = O.string();
            break;
          default:
            O.skipType(V & 7);
            break;
        }
      }
      return y;
    },
    fromJSON($) {
      const E = m();
      return (0, u.isSet)($.granter) && (E.granter = String($.granter)), (0, u.isSet)($.grantee) && (E.grantee = String($.grantee)), E;
    },
    toJSON($) {
      const E = {};
      return $.granter !== void 0 && (E.granter = $.granter), $.grantee !== void 0 && (E.grantee = $.grantee), E;
    },
    fromPartial($) {
      const E = m();
      return E.granter = $.granter ?? "", E.grantee = $.grantee ?? "", E;
    }
  };
  function v() {
    return {};
  }
  e.MsgRevokeAllowanceResponse = {
    typeUrl: "/cosmos.feegrant.v1beta1.MsgRevokeAllowanceResponse",
    encode($, E = o.BinaryWriter.create()) {
      return E;
    },
    decode($, E) {
      const O = $ instanceof o.BinaryReader ? $ : new o.BinaryReader($);
      let T = E === void 0 ? O.len : O.pos + E;
      const y = v();
      for (; O.pos < T; ) {
        const V = O.uint32();
        switch (V >>> 3) {
          default:
            O.skipType(V & 7);
            break;
        }
      }
      return y;
    },
    fromJSON($) {
      return v();
    },
    toJSON($) {
      return {};
    },
    fromPartial($) {
      return v();
    }
  };
  class S {
    constructor(E) {
      this.rpc = E, this.GrantAllowance = this.GrantAllowance.bind(this), this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    GrantAllowance(E) {
      const O = e.MsgGrantAllowance.encode(E).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", O).then((y) => e.MsgGrantAllowanceResponse.decode(new o.BinaryReader(y)));
    }
    RevokeAllowance(E) {
      const O = e.MsgRevokeAllowance.encode(E).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", O).then((y) => e.MsgRevokeAllowanceResponse.decode(new o.BinaryReader(y)));
    }
  }
  e.MsgClientImpl = S;
})(tx$l);
Object.defineProperty(messages$f, "__esModule", { value: !0 });
messages$f.feegrantTypes = void 0;
const tx_1$n = tx$l;
messages$f.feegrantTypes = [
  ["/cosmos.feegrant.v1beta1.MsgGrantAllowance", tx_1$n.MsgGrantAllowance],
  ["/cosmos.feegrant.v1beta1.MsgRevokeAllowance", tx_1$n.MsgRevokeAllowance]
];
var queries$i = {}, query$9 = {}, feegrant = {}, duration$1 = {};
Object.defineProperty(duration$1, "__esModule", { value: !0 });
duration$1.Duration = duration$1.protobufPackage = void 0;
const binary_1$7 = binary, helpers_1$7 = helpers;
duration$1.protobufPackage = "google.protobuf";
function createBaseDuration$1() {
  return {
    seconds: BigInt(0),
    nanos: 0
  };
}
duration$1.Duration = {
  typeUrl: "/google.protobuf.Duration",
  encode(e, n = binary_1$7.BinaryWriter.create()) {
    return e.seconds !== BigInt(0) && n.uint32(8).int64(e.seconds), e.nanos !== 0 && n.uint32(16).int32(e.nanos), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$7.BinaryReader ? e : new binary_1$7.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDuration$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.seconds = o.int64();
          break;
        case 2:
          c.nanos = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseDuration$1();
    return (0, helpers_1$7.isSet)(e.seconds) && (n.seconds = BigInt(e.seconds.toString())), (0, helpers_1$7.isSet)(e.nanos) && (n.nanos = Number(e.nanos)), n;
  },
  toJSON(e) {
    const n = {};
    return e.seconds !== void 0 && (n.seconds = (e.seconds || BigInt(0)).toString()), e.nanos !== void 0 && (n.nanos = Math.round(e.nanos)), n;
  },
  fromPartial(e) {
    const n = createBaseDuration$1();
    return e.seconds !== void 0 && e.seconds !== null && (n.seconds = BigInt(e.seconds.toString())), n.nanos = e.nanos ?? 0, n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Grant = e.AllowedMsgAllowance = e.PeriodicAllowance = e.BasicAllowance = e.protobufPackage = void 0;
  const n = coin$8, o = timestamp$1, u = duration$1, c = any$1, d = binary, m = helpers;
  e.protobufPackage = "cosmos.feegrant.v1beta1";
  function v() {
    return {
      spendLimit: [],
      expiration: void 0
    };
  }
  e.BasicAllowance = {
    typeUrl: "/cosmos.feegrant.v1beta1.BasicAllowance",
    encode(O, T = d.BinaryWriter.create()) {
      for (const y of O.spendLimit)
        n.Coin.encode(y, T.uint32(10).fork()).ldelim();
      return O.expiration !== void 0 && o.Timestamp.encode(O.expiration, T.uint32(18).fork()).ldelim(), T;
    },
    decode(O, T) {
      const y = O instanceof d.BinaryReader ? O : new d.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = v();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.spendLimit.push(n.Coin.decode(y, y.uint32()));
            break;
          case 2:
            M.expiration = o.Timestamp.decode(y, y.uint32());
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = v();
      return Array.isArray(O == null ? void 0 : O.spendLimit) && (T.spendLimit = O.spendLimit.map((y) => n.Coin.fromJSON(y))), (0, m.isSet)(O.expiration) && (T.expiration = (0, m.fromJsonTimestamp)(O.expiration)), T;
    },
    toJSON(O) {
      const T = {};
      return O.spendLimit ? T.spendLimit = O.spendLimit.map((y) => y ? n.Coin.toJSON(y) : void 0) : T.spendLimit = [], O.expiration !== void 0 && (T.expiration = (0, m.fromTimestamp)(O.expiration).toISOString()), T;
    },
    fromPartial(O) {
      var y;
      const T = v();
      return T.spendLimit = ((y = O.spendLimit) == null ? void 0 : y.map((V) => n.Coin.fromPartial(V))) || [], O.expiration !== void 0 && O.expiration !== null && (T.expiration = o.Timestamp.fromPartial(O.expiration)), T;
    }
  };
  function S() {
    return {
      basic: e.BasicAllowance.fromPartial({}),
      period: u.Duration.fromPartial({}),
      periodSpendLimit: [],
      periodCanSpend: [],
      periodReset: o.Timestamp.fromPartial({})
    };
  }
  e.PeriodicAllowance = {
    typeUrl: "/cosmos.feegrant.v1beta1.PeriodicAllowance",
    encode(O, T = d.BinaryWriter.create()) {
      O.basic !== void 0 && e.BasicAllowance.encode(O.basic, T.uint32(10).fork()).ldelim(), O.period !== void 0 && u.Duration.encode(O.period, T.uint32(18).fork()).ldelim();
      for (const y of O.periodSpendLimit)
        n.Coin.encode(y, T.uint32(26).fork()).ldelim();
      for (const y of O.periodCanSpend)
        n.Coin.encode(y, T.uint32(34).fork()).ldelim();
      return O.periodReset !== void 0 && o.Timestamp.encode(O.periodReset, T.uint32(42).fork()).ldelim(), T;
    },
    decode(O, T) {
      const y = O instanceof d.BinaryReader ? O : new d.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = S();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.basic = e.BasicAllowance.decode(y, y.uint32());
            break;
          case 2:
            M.period = u.Duration.decode(y, y.uint32());
            break;
          case 3:
            M.periodSpendLimit.push(n.Coin.decode(y, y.uint32()));
            break;
          case 4:
            M.periodCanSpend.push(n.Coin.decode(y, y.uint32()));
            break;
          case 5:
            M.periodReset = o.Timestamp.decode(y, y.uint32());
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = S();
      return (0, m.isSet)(O.basic) && (T.basic = e.BasicAllowance.fromJSON(O.basic)), (0, m.isSet)(O.period) && (T.period = u.Duration.fromJSON(O.period)), Array.isArray(O == null ? void 0 : O.periodSpendLimit) && (T.periodSpendLimit = O.periodSpendLimit.map((y) => n.Coin.fromJSON(y))), Array.isArray(O == null ? void 0 : O.periodCanSpend) && (T.periodCanSpend = O.periodCanSpend.map((y) => n.Coin.fromJSON(y))), (0, m.isSet)(O.periodReset) && (T.periodReset = (0, m.fromJsonTimestamp)(O.periodReset)), T;
    },
    toJSON(O) {
      const T = {};
      return O.basic !== void 0 && (T.basic = O.basic ? e.BasicAllowance.toJSON(O.basic) : void 0), O.period !== void 0 && (T.period = O.period ? u.Duration.toJSON(O.period) : void 0), O.periodSpendLimit ? T.periodSpendLimit = O.periodSpendLimit.map((y) => y ? n.Coin.toJSON(y) : void 0) : T.periodSpendLimit = [], O.periodCanSpend ? T.periodCanSpend = O.periodCanSpend.map((y) => y ? n.Coin.toJSON(y) : void 0) : T.periodCanSpend = [], O.periodReset !== void 0 && (T.periodReset = (0, m.fromTimestamp)(O.periodReset).toISOString()), T;
    },
    fromPartial(O) {
      var y, V;
      const T = S();
      return O.basic !== void 0 && O.basic !== null && (T.basic = e.BasicAllowance.fromPartial(O.basic)), O.period !== void 0 && O.period !== null && (T.period = u.Duration.fromPartial(O.period)), T.periodSpendLimit = ((y = O.periodSpendLimit) == null ? void 0 : y.map((M) => n.Coin.fromPartial(M))) || [], T.periodCanSpend = ((V = O.periodCanSpend) == null ? void 0 : V.map((M) => n.Coin.fromPartial(M))) || [], O.periodReset !== void 0 && O.periodReset !== null && (T.periodReset = o.Timestamp.fromPartial(O.periodReset)), T;
    }
  };
  function $() {
    return {
      allowance: void 0,
      allowedMessages: []
    };
  }
  e.AllowedMsgAllowance = {
    typeUrl: "/cosmos.feegrant.v1beta1.AllowedMsgAllowance",
    encode(O, T = d.BinaryWriter.create()) {
      O.allowance !== void 0 && c.Any.encode(O.allowance, T.uint32(10).fork()).ldelim();
      for (const y of O.allowedMessages)
        T.uint32(18).string(y);
      return T;
    },
    decode(O, T) {
      const y = O instanceof d.BinaryReader ? O : new d.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = $();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.allowance = c.Any.decode(y, y.uint32());
            break;
          case 2:
            M.allowedMessages.push(y.string());
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = $();
      return (0, m.isSet)(O.allowance) && (T.allowance = c.Any.fromJSON(O.allowance)), Array.isArray(O == null ? void 0 : O.allowedMessages) && (T.allowedMessages = O.allowedMessages.map((y) => String(y))), T;
    },
    toJSON(O) {
      const T = {};
      return O.allowance !== void 0 && (T.allowance = O.allowance ? c.Any.toJSON(O.allowance) : void 0), O.allowedMessages ? T.allowedMessages = O.allowedMessages.map((y) => y) : T.allowedMessages = [], T;
    },
    fromPartial(O) {
      var y;
      const T = $();
      return O.allowance !== void 0 && O.allowance !== null && (T.allowance = c.Any.fromPartial(O.allowance)), T.allowedMessages = ((y = O.allowedMessages) == null ? void 0 : y.map((V) => V)) || [], T;
    }
  };
  function E() {
    return {
      granter: "",
      grantee: "",
      allowance: void 0
    };
  }
  e.Grant = {
    typeUrl: "/cosmos.feegrant.v1beta1.Grant",
    encode(O, T = d.BinaryWriter.create()) {
      return O.granter !== "" && T.uint32(10).string(O.granter), O.grantee !== "" && T.uint32(18).string(O.grantee), O.allowance !== void 0 && c.Any.encode(O.allowance, T.uint32(26).fork()).ldelim(), T;
    },
    decode(O, T) {
      const y = O instanceof d.BinaryReader ? O : new d.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = E();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.granter = y.string();
            break;
          case 2:
            M.grantee = y.string();
            break;
          case 3:
            M.allowance = c.Any.decode(y, y.uint32());
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = E();
      return (0, m.isSet)(O.granter) && (T.granter = String(O.granter)), (0, m.isSet)(O.grantee) && (T.grantee = String(O.grantee)), (0, m.isSet)(O.allowance) && (T.allowance = c.Any.fromJSON(O.allowance)), T;
    },
    toJSON(O) {
      const T = {};
      return O.granter !== void 0 && (T.granter = O.granter), O.grantee !== void 0 && (T.grantee = O.grantee), O.allowance !== void 0 && (T.allowance = O.allowance ? c.Any.toJSON(O.allowance) : void 0), T;
    },
    fromPartial(O) {
      const T = E();
      return T.granter = O.granter ?? "", T.grantee = O.grantee ?? "", O.allowance !== void 0 && O.allowance !== null && (T.allowance = c.Any.fromPartial(O.allowance)), T;
    }
  };
})(feegrant);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryAllowancesByGranterResponse = e.QueryAllowancesByGranterRequest = e.QueryAllowancesResponse = e.QueryAllowancesRequest = e.QueryAllowanceResponse = e.QueryAllowanceRequest = e.protobufPackage = void 0;
  const n = pagination, o = feegrant, u = binary, c = helpers;
  e.protobufPackage = "cosmos.feegrant.v1beta1";
  function d() {
    return {
      granter: "",
      grantee: ""
    };
  }
  e.QueryAllowanceRequest = {
    typeUrl: "/cosmos.feegrant.v1beta1.QueryAllowanceRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return T.granter !== "" && y.uint32(10).string(T.granter), T.grantee !== "" && y.uint32(18).string(T.grantee), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = d();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.granter = V.string();
            break;
          case 2:
            G.grantee = V.string();
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = d();
      return (0, c.isSet)(T.granter) && (y.granter = String(T.granter)), (0, c.isSet)(T.grantee) && (y.grantee = String(T.grantee)), y;
    },
    toJSON(T) {
      const y = {};
      return T.granter !== void 0 && (y.granter = T.granter), T.grantee !== void 0 && (y.grantee = T.grantee), y;
    },
    fromPartial(T) {
      const y = d();
      return y.granter = T.granter ?? "", y.grantee = T.grantee ?? "", y;
    }
  };
  function m() {
    return {
      allowance: void 0
    };
  }
  e.QueryAllowanceResponse = {
    typeUrl: "/cosmos.feegrant.v1beta1.QueryAllowanceResponse",
    encode(T, y = u.BinaryWriter.create()) {
      return T.allowance !== void 0 && o.Grant.encode(T.allowance, y.uint32(10).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = m();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.allowance = o.Grant.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = m();
      return (0, c.isSet)(T.allowance) && (y.allowance = o.Grant.fromJSON(T.allowance)), y;
    },
    toJSON(T) {
      const y = {};
      return T.allowance !== void 0 && (y.allowance = T.allowance ? o.Grant.toJSON(T.allowance) : void 0), y;
    },
    fromPartial(T) {
      const y = m();
      return T.allowance !== void 0 && T.allowance !== null && (y.allowance = o.Grant.fromPartial(T.allowance)), y;
    }
  };
  function v() {
    return {
      grantee: "",
      pagination: void 0
    };
  }
  e.QueryAllowancesRequest = {
    typeUrl: "/cosmos.feegrant.v1beta1.QueryAllowancesRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return T.grantee !== "" && y.uint32(10).string(T.grantee), T.pagination !== void 0 && n.PageRequest.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = v();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.grantee = V.string();
            break;
          case 2:
            G.pagination = n.PageRequest.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = v();
      return (0, c.isSet)(T.grantee) && (y.grantee = String(T.grantee)), (0, c.isSet)(T.pagination) && (y.pagination = n.PageRequest.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.grantee !== void 0 && (y.grantee = T.grantee), T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageRequest.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      const y = v();
      return y.grantee = T.grantee ?? "", T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageRequest.fromPartial(T.pagination)), y;
    }
  };
  function S() {
    return {
      allowances: [],
      pagination: void 0
    };
  }
  e.QueryAllowancesResponse = {
    typeUrl: "/cosmos.feegrant.v1beta1.QueryAllowancesResponse",
    encode(T, y = u.BinaryWriter.create()) {
      for (const V of T.allowances)
        o.Grant.encode(V, y.uint32(10).fork()).ldelim();
      return T.pagination !== void 0 && n.PageResponse.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = S();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.allowances.push(o.Grant.decode(V, V.uint32()));
            break;
          case 2:
            G.pagination = n.PageResponse.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = S();
      return Array.isArray(T == null ? void 0 : T.allowances) && (y.allowances = T.allowances.map((V) => o.Grant.fromJSON(V))), (0, c.isSet)(T.pagination) && (y.pagination = n.PageResponse.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.allowances ? y.allowances = T.allowances.map((V) => V ? o.Grant.toJSON(V) : void 0) : y.allowances = [], T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageResponse.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      var V;
      const y = S();
      return y.allowances = ((V = T.allowances) == null ? void 0 : V.map((M) => o.Grant.fromPartial(M))) || [], T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageResponse.fromPartial(T.pagination)), y;
    }
  };
  function $() {
    return {
      granter: "",
      pagination: void 0
    };
  }
  e.QueryAllowancesByGranterRequest = {
    typeUrl: "/cosmos.feegrant.v1beta1.QueryAllowancesByGranterRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return T.granter !== "" && y.uint32(10).string(T.granter), T.pagination !== void 0 && n.PageRequest.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = $();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.granter = V.string();
            break;
          case 2:
            G.pagination = n.PageRequest.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = $();
      return (0, c.isSet)(T.granter) && (y.granter = String(T.granter)), (0, c.isSet)(T.pagination) && (y.pagination = n.PageRequest.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.granter !== void 0 && (y.granter = T.granter), T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageRequest.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      const y = $();
      return y.granter = T.granter ?? "", T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageRequest.fromPartial(T.pagination)), y;
    }
  };
  function E() {
    return {
      allowances: [],
      pagination: void 0
    };
  }
  e.QueryAllowancesByGranterResponse = {
    typeUrl: "/cosmos.feegrant.v1beta1.QueryAllowancesByGranterResponse",
    encode(T, y = u.BinaryWriter.create()) {
      for (const V of T.allowances)
        o.Grant.encode(V, y.uint32(10).fork()).ldelim();
      return T.pagination !== void 0 && n.PageResponse.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = E();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.allowances.push(o.Grant.decode(V, V.uint32()));
            break;
          case 2:
            G.pagination = n.PageResponse.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = E();
      return Array.isArray(T == null ? void 0 : T.allowances) && (y.allowances = T.allowances.map((V) => o.Grant.fromJSON(V))), (0, c.isSet)(T.pagination) && (y.pagination = n.PageResponse.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.allowances ? y.allowances = T.allowances.map((V) => V ? o.Grant.toJSON(V) : void 0) : y.allowances = [], T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageResponse.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      var V;
      const y = E();
      return y.allowances = ((V = T.allowances) == null ? void 0 : V.map((M) => o.Grant.fromPartial(M))) || [], T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageResponse.fromPartial(T.pagination)), y;
    }
  };
  class O {
    constructor(y) {
      this.rpc = y, this.Allowance = this.Allowance.bind(this), this.Allowances = this.Allowances.bind(this), this.AllowancesByGranter = this.AllowancesByGranter.bind(this);
    }
    Allowance(y) {
      const V = e.QueryAllowanceRequest.encode(y).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowance", V).then((G) => e.QueryAllowanceResponse.decode(new u.BinaryReader(G)));
    }
    Allowances(y) {
      const V = e.QueryAllowancesRequest.encode(y).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowances", V).then((G) => e.QueryAllowancesResponse.decode(new u.BinaryReader(G)));
    }
    AllowancesByGranter(y) {
      const V = e.QueryAllowancesByGranterRequest.encode(y).finish();
      return this.rpc.request("cosmos.feegrant.v1beta1.Query", "AllowancesByGranter", V).then((G) => e.QueryAllowancesByGranterResponse.decode(new u.BinaryReader(G)));
    }
  }
  e.QueryClientImpl = O;
})(query$9);
Object.defineProperty(queries$i, "__esModule", { value: !0 });
queries$i.setupFeegrantExtension = void 0;
const query_1$g = query$9, queryclient_1$l = queryclient$3;
function setupFeegrantExtension$1(e) {
  const n = (0, queryclient_1$l.createProtobufRpcClient)(e), o = new query_1$g.QueryClientImpl(n);
  return {
    feegrant: {
      allowance: async (u, c) => await o.Allowance({
        granter: u,
        grantee: c
      }),
      allowances: async (u, c) => await o.Allowances({
        grantee: u,
        pagination: (0, queryclient_1$l.createPagination)(c)
      })
    }
  };
}
queries$i.setupFeegrantExtension = setupFeegrantExtension$1;
var aminomessages$h = {}, gov$4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TallyParams = e.VotingParams = e.DepositParams = e.Vote = e.TallyResult = e.Proposal = e.Deposit = e.TextProposal = e.WeightedVoteOption = e.proposalStatusToJSON = e.proposalStatusFromJSON = e.ProposalStatus = e.voteOptionToJSON = e.voteOptionFromJSON = e.VoteOption = e.protobufPackage = void 0;
  const n = coin$8, o = any$1, u = timestamp$1, c = duration$1, d = binary, m = helpers;
  e.protobufPackage = "cosmos.gov.v1beta1";
  var v;
  (function(Q) {
    Q[Q.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", Q[Q.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", Q[Q.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", Q[Q.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", Q[Q.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", Q[Q.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(v || (e.VoteOption = v = {}));
  function S(Q) {
    switch (Q) {
      case 0:
      case "VOTE_OPTION_UNSPECIFIED":
        return v.VOTE_OPTION_UNSPECIFIED;
      case 1:
      case "VOTE_OPTION_YES":
        return v.VOTE_OPTION_YES;
      case 2:
      case "VOTE_OPTION_ABSTAIN":
        return v.VOTE_OPTION_ABSTAIN;
      case 3:
      case "VOTE_OPTION_NO":
        return v.VOTE_OPTION_NO;
      case 4:
      case "VOTE_OPTION_NO_WITH_VETO":
        return v.VOTE_OPTION_NO_WITH_VETO;
      case -1:
      case "UNRECOGNIZED":
      default:
        return v.UNRECOGNIZED;
    }
  }
  e.voteOptionFromJSON = S;
  function $(Q) {
    switch (Q) {
      case v.VOTE_OPTION_UNSPECIFIED:
        return "VOTE_OPTION_UNSPECIFIED";
      case v.VOTE_OPTION_YES:
        return "VOTE_OPTION_YES";
      case v.VOTE_OPTION_ABSTAIN:
        return "VOTE_OPTION_ABSTAIN";
      case v.VOTE_OPTION_NO:
        return "VOTE_OPTION_NO";
      case v.VOTE_OPTION_NO_WITH_VETO:
        return "VOTE_OPTION_NO_WITH_VETO";
      case v.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.voteOptionToJSON = $;
  var E;
  (function(Q) {
    Q[Q.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", Q[Q.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", Q[Q.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", Q[Q.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", Q[Q.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", Q[Q.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED", Q[Q.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(E || (e.ProposalStatus = E = {}));
  function O(Q) {
    switch (Q) {
      case 0:
      case "PROPOSAL_STATUS_UNSPECIFIED":
        return E.PROPOSAL_STATUS_UNSPECIFIED;
      case 1:
      case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
        return E.PROPOSAL_STATUS_DEPOSIT_PERIOD;
      case 2:
      case "PROPOSAL_STATUS_VOTING_PERIOD":
        return E.PROPOSAL_STATUS_VOTING_PERIOD;
      case 3:
      case "PROPOSAL_STATUS_PASSED":
        return E.PROPOSAL_STATUS_PASSED;
      case 4:
      case "PROPOSAL_STATUS_REJECTED":
        return E.PROPOSAL_STATUS_REJECTED;
      case 5:
      case "PROPOSAL_STATUS_FAILED":
        return E.PROPOSAL_STATUS_FAILED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return E.UNRECOGNIZED;
    }
  }
  e.proposalStatusFromJSON = O;
  function T(Q) {
    switch (Q) {
      case E.PROPOSAL_STATUS_UNSPECIFIED:
        return "PROPOSAL_STATUS_UNSPECIFIED";
      case E.PROPOSAL_STATUS_DEPOSIT_PERIOD:
        return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
      case E.PROPOSAL_STATUS_VOTING_PERIOD:
        return "PROPOSAL_STATUS_VOTING_PERIOD";
      case E.PROPOSAL_STATUS_PASSED:
        return "PROPOSAL_STATUS_PASSED";
      case E.PROPOSAL_STATUS_REJECTED:
        return "PROPOSAL_STATUS_REJECTED";
      case E.PROPOSAL_STATUS_FAILED:
        return "PROPOSAL_STATUS_FAILED";
      case E.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.proposalStatusToJSON = T;
  function y() {
    return {
      option: 0,
      weight: ""
    };
  }
  e.WeightedVoteOption = {
    typeUrl: "/cosmos.gov.v1beta1.WeightedVoteOption",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.option !== 0 && Y.uint32(8).int32(Q.option), Q.weight !== "" && Y.uint32(18).string(Q.weight), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = y();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.option = pe.int32();
            break;
          case 2:
            ne.weight = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = y();
      return (0, m.isSet)(Q.option) && (Y.option = S(Q.option)), (0, m.isSet)(Q.weight) && (Y.weight = String(Q.weight)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.option !== void 0 && (Y.option = $(Q.option)), Q.weight !== void 0 && (Y.weight = Q.weight), Y;
    },
    fromPartial(Q) {
      const Y = y();
      return Y.option = Q.option ?? 0, Y.weight = Q.weight ?? "", Y;
    }
  };
  function V() {
    return {
      title: "",
      description: ""
    };
  }
  e.TextProposal = {
    typeUrl: "/cosmos.gov.v1beta1.TextProposal",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.title !== "" && Y.uint32(10).string(Q.title), Q.description !== "" && Y.uint32(18).string(Q.description), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = V();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.title = pe.string();
            break;
          case 2:
            ne.description = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = V();
      return (0, m.isSet)(Q.title) && (Y.title = String(Q.title)), (0, m.isSet)(Q.description) && (Y.description = String(Q.description)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.title !== void 0 && (Y.title = Q.title), Q.description !== void 0 && (Y.description = Q.description), Y;
    },
    fromPartial(Q) {
      const Y = V();
      return Y.title = Q.title ?? "", Y.description = Q.description ?? "", Y;
    }
  };
  function M() {
    return {
      proposalId: BigInt(0),
      depositor: "",
      amount: []
    };
  }
  e.Deposit = {
    typeUrl: "/cosmos.gov.v1beta1.Deposit",
    encode(Q, Y = d.BinaryWriter.create()) {
      Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.depositor !== "" && Y.uint32(18).string(Q.depositor);
      for (const pe of Q.amount)
        n.Coin.encode(pe, Y.uint32(26).fork()).ldelim();
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = M();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.depositor = pe.string();
            break;
          case 3:
            ne.amount.push(n.Coin.decode(pe, pe.uint32()));
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = M();
      return (0, m.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, m.isSet)(Q.depositor) && (Y.depositor = String(Q.depositor)), Array.isArray(Q == null ? void 0 : Q.amount) && (Y.amount = Q.amount.map((pe) => n.Coin.fromJSON(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.depositor !== void 0 && (Y.depositor = Q.depositor), Q.amount ? Y.amount = Q.amount.map((pe) => pe ? n.Coin.toJSON(pe) : void 0) : Y.amount = [], Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = M();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Y.depositor = Q.depositor ?? "", Y.amount = ((pe = Q.amount) == null ? void 0 : pe.map((oe) => n.Coin.fromPartial(oe))) || [], Y;
    }
  };
  function G() {
    return {
      proposalId: BigInt(0),
      content: void 0,
      status: 0,
      finalTallyResult: e.TallyResult.fromPartial({}),
      submitTime: u.Timestamp.fromPartial({}),
      depositEndTime: u.Timestamp.fromPartial({}),
      totalDeposit: [],
      votingStartTime: u.Timestamp.fromPartial({}),
      votingEndTime: u.Timestamp.fromPartial({})
    };
  }
  e.Proposal = {
    typeUrl: "/cosmos.gov.v1beta1.Proposal",
    encode(Q, Y = d.BinaryWriter.create()) {
      Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.content !== void 0 && o.Any.encode(Q.content, Y.uint32(18).fork()).ldelim(), Q.status !== 0 && Y.uint32(24).int32(Q.status), Q.finalTallyResult !== void 0 && e.TallyResult.encode(Q.finalTallyResult, Y.uint32(34).fork()).ldelim(), Q.submitTime !== void 0 && u.Timestamp.encode(Q.submitTime, Y.uint32(42).fork()).ldelim(), Q.depositEndTime !== void 0 && u.Timestamp.encode(Q.depositEndTime, Y.uint32(50).fork()).ldelim();
      for (const pe of Q.totalDeposit)
        n.Coin.encode(pe, Y.uint32(58).fork()).ldelim();
      return Q.votingStartTime !== void 0 && u.Timestamp.encode(Q.votingStartTime, Y.uint32(66).fork()).ldelim(), Q.votingEndTime !== void 0 && u.Timestamp.encode(Q.votingEndTime, Y.uint32(74).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = G();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.content = o.Any.decode(pe, pe.uint32());
            break;
          case 3:
            ne.status = pe.int32();
            break;
          case 4:
            ne.finalTallyResult = e.TallyResult.decode(pe, pe.uint32());
            break;
          case 5:
            ne.submitTime = u.Timestamp.decode(pe, pe.uint32());
            break;
          case 6:
            ne.depositEndTime = u.Timestamp.decode(pe, pe.uint32());
            break;
          case 7:
            ne.totalDeposit.push(n.Coin.decode(pe, pe.uint32()));
            break;
          case 8:
            ne.votingStartTime = u.Timestamp.decode(pe, pe.uint32());
            break;
          case 9:
            ne.votingEndTime = u.Timestamp.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = G();
      return (0, m.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, m.isSet)(Q.content) && (Y.content = o.Any.fromJSON(Q.content)), (0, m.isSet)(Q.status) && (Y.status = O(Q.status)), (0, m.isSet)(Q.finalTallyResult) && (Y.finalTallyResult = e.TallyResult.fromJSON(Q.finalTallyResult)), (0, m.isSet)(Q.submitTime) && (Y.submitTime = (0, m.fromJsonTimestamp)(Q.submitTime)), (0, m.isSet)(Q.depositEndTime) && (Y.depositEndTime = (0, m.fromJsonTimestamp)(Q.depositEndTime)), Array.isArray(Q == null ? void 0 : Q.totalDeposit) && (Y.totalDeposit = Q.totalDeposit.map((pe) => n.Coin.fromJSON(pe))), (0, m.isSet)(Q.votingStartTime) && (Y.votingStartTime = (0, m.fromJsonTimestamp)(Q.votingStartTime)), (0, m.isSet)(Q.votingEndTime) && (Y.votingEndTime = (0, m.fromJsonTimestamp)(Q.votingEndTime)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.content !== void 0 && (Y.content = Q.content ? o.Any.toJSON(Q.content) : void 0), Q.status !== void 0 && (Y.status = T(Q.status)), Q.finalTallyResult !== void 0 && (Y.finalTallyResult = Q.finalTallyResult ? e.TallyResult.toJSON(Q.finalTallyResult) : void 0), Q.submitTime !== void 0 && (Y.submitTime = (0, m.fromTimestamp)(Q.submitTime).toISOString()), Q.depositEndTime !== void 0 && (Y.depositEndTime = (0, m.fromTimestamp)(Q.depositEndTime).toISOString()), Q.totalDeposit ? Y.totalDeposit = Q.totalDeposit.map((pe) => pe ? n.Coin.toJSON(pe) : void 0) : Y.totalDeposit = [], Q.votingStartTime !== void 0 && (Y.votingStartTime = (0, m.fromTimestamp)(Q.votingStartTime).toISOString()), Q.votingEndTime !== void 0 && (Y.votingEndTime = (0, m.fromTimestamp)(Q.votingEndTime).toISOString()), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = G();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Q.content !== void 0 && Q.content !== null && (Y.content = o.Any.fromPartial(Q.content)), Y.status = Q.status ?? 0, Q.finalTallyResult !== void 0 && Q.finalTallyResult !== null && (Y.finalTallyResult = e.TallyResult.fromPartial(Q.finalTallyResult)), Q.submitTime !== void 0 && Q.submitTime !== null && (Y.submitTime = u.Timestamp.fromPartial(Q.submitTime)), Q.depositEndTime !== void 0 && Q.depositEndTime !== null && (Y.depositEndTime = u.Timestamp.fromPartial(Q.depositEndTime)), Y.totalDeposit = ((pe = Q.totalDeposit) == null ? void 0 : pe.map((oe) => n.Coin.fromPartial(oe))) || [], Q.votingStartTime !== void 0 && Q.votingStartTime !== null && (Y.votingStartTime = u.Timestamp.fromPartial(Q.votingStartTime)), Q.votingEndTime !== void 0 && Q.votingEndTime !== null && (Y.votingEndTime = u.Timestamp.fromPartial(Q.votingEndTime)), Y;
    }
  };
  function k() {
    return {
      yes: "",
      abstain: "",
      no: "",
      noWithVeto: ""
    };
  }
  e.TallyResult = {
    typeUrl: "/cosmos.gov.v1beta1.TallyResult",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.yes !== "" && Y.uint32(10).string(Q.yes), Q.abstain !== "" && Y.uint32(18).string(Q.abstain), Q.no !== "" && Y.uint32(26).string(Q.no), Q.noWithVeto !== "" && Y.uint32(34).string(Q.noWithVeto), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = k();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.yes = pe.string();
            break;
          case 2:
            ne.abstain = pe.string();
            break;
          case 3:
            ne.no = pe.string();
            break;
          case 4:
            ne.noWithVeto = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = k();
      return (0, m.isSet)(Q.yes) && (Y.yes = String(Q.yes)), (0, m.isSet)(Q.abstain) && (Y.abstain = String(Q.abstain)), (0, m.isSet)(Q.no) && (Y.no = String(Q.no)), (0, m.isSet)(Q.noWithVeto) && (Y.noWithVeto = String(Q.noWithVeto)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.yes !== void 0 && (Y.yes = Q.yes), Q.abstain !== void 0 && (Y.abstain = Q.abstain), Q.no !== void 0 && (Y.no = Q.no), Q.noWithVeto !== void 0 && (Y.noWithVeto = Q.noWithVeto), Y;
    },
    fromPartial(Q) {
      const Y = k();
      return Y.yes = Q.yes ?? "", Y.abstain = Q.abstain ?? "", Y.no = Q.no ?? "", Y.noWithVeto = Q.noWithVeto ?? "", Y;
    }
  };
  function F() {
    return {
      proposalId: BigInt(0),
      voter: "",
      option: 0,
      options: []
    };
  }
  e.Vote = {
    typeUrl: "/cosmos.gov.v1beta1.Vote",
    encode(Q, Y = d.BinaryWriter.create()) {
      Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.voter !== "" && Y.uint32(18).string(Q.voter), Q.option !== 0 && Y.uint32(24).int32(Q.option);
      for (const pe of Q.options)
        e.WeightedVoteOption.encode(pe, Y.uint32(34).fork()).ldelim();
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = F();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.voter = pe.string();
            break;
          case 3:
            ne.option = pe.int32();
            break;
          case 4:
            ne.options.push(e.WeightedVoteOption.decode(pe, pe.uint32()));
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = F();
      return (0, m.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, m.isSet)(Q.voter) && (Y.voter = String(Q.voter)), (0, m.isSet)(Q.option) && (Y.option = S(Q.option)), Array.isArray(Q == null ? void 0 : Q.options) && (Y.options = Q.options.map((pe) => e.WeightedVoteOption.fromJSON(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.voter !== void 0 && (Y.voter = Q.voter), Q.option !== void 0 && (Y.option = $(Q.option)), Q.options ? Y.options = Q.options.map((pe) => pe ? e.WeightedVoteOption.toJSON(pe) : void 0) : Y.options = [], Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = F();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Y.voter = Q.voter ?? "", Y.option = Q.option ?? 0, Y.options = ((pe = Q.options) == null ? void 0 : pe.map((oe) => e.WeightedVoteOption.fromPartial(oe))) || [], Y;
    }
  };
  function X() {
    return {
      minDeposit: [],
      maxDepositPeriod: c.Duration.fromPartial({})
    };
  }
  e.DepositParams = {
    typeUrl: "/cosmos.gov.v1beta1.DepositParams",
    encode(Q, Y = d.BinaryWriter.create()) {
      for (const pe of Q.minDeposit)
        n.Coin.encode(pe, Y.uint32(10).fork()).ldelim();
      return Q.maxDepositPeriod !== void 0 && c.Duration.encode(Q.maxDepositPeriod, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = X();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.minDeposit.push(n.Coin.decode(pe, pe.uint32()));
            break;
          case 2:
            ne.maxDepositPeriod = c.Duration.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = X();
      return Array.isArray(Q == null ? void 0 : Q.minDeposit) && (Y.minDeposit = Q.minDeposit.map((pe) => n.Coin.fromJSON(pe))), (0, m.isSet)(Q.maxDepositPeriod) && (Y.maxDepositPeriod = c.Duration.fromJSON(Q.maxDepositPeriod)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.minDeposit ? Y.minDeposit = Q.minDeposit.map((pe) => pe ? n.Coin.toJSON(pe) : void 0) : Y.minDeposit = [], Q.maxDepositPeriod !== void 0 && (Y.maxDepositPeriod = Q.maxDepositPeriod ? c.Duration.toJSON(Q.maxDepositPeriod) : void 0), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = X();
      return Y.minDeposit = ((pe = Q.minDeposit) == null ? void 0 : pe.map((oe) => n.Coin.fromPartial(oe))) || [], Q.maxDepositPeriod !== void 0 && Q.maxDepositPeriod !== null && (Y.maxDepositPeriod = c.Duration.fromPartial(Q.maxDepositPeriod)), Y;
    }
  };
  function ee() {
    return {
      votingPeriod: c.Duration.fromPartial({})
    };
  }
  e.VotingParams = {
    typeUrl: "/cosmos.gov.v1beta1.VotingParams",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.votingPeriod !== void 0 && c.Duration.encode(Q.votingPeriod, Y.uint32(10).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ee();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.votingPeriod = c.Duration.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = ee();
      return (0, m.isSet)(Q.votingPeriod) && (Y.votingPeriod = c.Duration.fromJSON(Q.votingPeriod)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.votingPeriod !== void 0 && (Y.votingPeriod = Q.votingPeriod ? c.Duration.toJSON(Q.votingPeriod) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = ee();
      return Q.votingPeriod !== void 0 && Q.votingPeriod !== null && (Y.votingPeriod = c.Duration.fromPartial(Q.votingPeriod)), Y;
    }
  };
  function ue() {
    return {
      quorum: new Uint8Array(),
      threshold: new Uint8Array(),
      vetoThreshold: new Uint8Array()
    };
  }
  e.TallyParams = {
    typeUrl: "/cosmos.gov.v1beta1.TallyParams",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.quorum.length !== 0 && Y.uint32(10).bytes(Q.quorum), Q.threshold.length !== 0 && Y.uint32(18).bytes(Q.threshold), Q.vetoThreshold.length !== 0 && Y.uint32(26).bytes(Q.vetoThreshold), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ue();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.quorum = pe.bytes();
            break;
          case 2:
            ne.threshold = pe.bytes();
            break;
          case 3:
            ne.vetoThreshold = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = ue();
      return (0, m.isSet)(Q.quorum) && (Y.quorum = (0, m.bytesFromBase64)(Q.quorum)), (0, m.isSet)(Q.threshold) && (Y.threshold = (0, m.bytesFromBase64)(Q.threshold)), (0, m.isSet)(Q.vetoThreshold) && (Y.vetoThreshold = (0, m.bytesFromBase64)(Q.vetoThreshold)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.quorum !== void 0 && (Y.quorum = (0, m.base64FromBytes)(Q.quorum !== void 0 ? Q.quorum : new Uint8Array())), Q.threshold !== void 0 && (Y.threshold = (0, m.base64FromBytes)(Q.threshold !== void 0 ? Q.threshold : new Uint8Array())), Q.vetoThreshold !== void 0 && (Y.vetoThreshold = (0, m.base64FromBytes)(Q.vetoThreshold !== void 0 ? Q.vetoThreshold : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = ue();
      return Y.quorum = Q.quorum ?? new Uint8Array(), Y.threshold = Q.threshold ?? new Uint8Array(), Y.vetoThreshold = Q.vetoThreshold ?? new Uint8Array(), Y;
    }
  };
})(gov$4);
Object.defineProperty(aminomessages$h, "__esModule", { value: !0 });
aminomessages$h.createGovAminoConverters = aminomessages$h.isAminoMsgDeposit = aminomessages$h.isAminoMsgVoteWeighted = aminomessages$h.isAminoMsgVote = aminomessages$h.isAminoMsgSubmitProposal = void 0;
const math_1$q = build$R, utils_1$T = build$G, gov_1$1 = gov$4, any_1$3 = any$1, queryclient_1$k = queryclient$3;
function isAminoMsgSubmitProposal$1(e) {
  return e.type === "cosmos-sdk/MsgSubmitProposal";
}
aminomessages$h.isAminoMsgSubmitProposal = isAminoMsgSubmitProposal$1;
function isAminoMsgVote$1(e) {
  return e.type === "cosmos-sdk/MsgVote";
}
aminomessages$h.isAminoMsgVote = isAminoMsgVote$1;
function isAminoMsgVoteWeighted$1(e) {
  return e.type === "cosmos-sdk/MsgVoteWeighted";
}
aminomessages$h.isAminoMsgVoteWeighted = isAminoMsgVoteWeighted$1;
function isAminoMsgDeposit$1(e) {
  return e.type === "cosmos-sdk/MsgDeposit";
}
aminomessages$h.isAminoMsgDeposit = isAminoMsgDeposit$1;
function createGovAminoConverters$1() {
  return {
    "/cosmos.gov.v1beta1.MsgDeposit": {
      aminoType: "cosmos-sdk/MsgDeposit",
      toAmino: ({ amount: e, depositor: n, proposalId: o }) => ({
        amount: e,
        depositor: n,
        proposal_id: o.toString()
      }),
      fromAmino: ({ amount: e, depositor: n, proposal_id: o }) => ({
        amount: Array.from(e),
        depositor: n,
        proposalId: BigInt(o)
      })
    },
    "/cosmos.gov.v1beta1.MsgVote": {
      aminoType: "cosmos-sdk/MsgVote",
      toAmino: ({ option: e, proposalId: n, voter: o }) => ({
        option: e,
        proposal_id: n.toString(),
        voter: o
      }),
      fromAmino: ({ option: e, proposal_id: n, voter: o }) => ({
        option: (0, gov_1$1.voteOptionFromJSON)(e),
        proposalId: BigInt(n),
        voter: o
      })
    },
    "/cosmos.gov.v1beta1.MsgVoteWeighted": {
      aminoType: "cosmos-sdk/MsgVoteWeighted",
      toAmino: ({ options: e, proposalId: n, voter: o }) => ({
        options: e.map((u) => ({
          option: u.option,
          // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
          // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
          weight: (0, queryclient_1$k.decodeCosmosSdkDecFromProto)(u.weight).toString().padEnd(20, "0")
        })),
        proposal_id: n.toString(),
        voter: o
      }),
      fromAmino: ({ options: e, proposal_id: n, voter: o }) => ({
        proposalId: BigInt(n),
        voter: o,
        options: e.map((u) => ({
          option: (0, gov_1$1.voteOptionFromJSON)(u.option),
          weight: math_1$q.Decimal.fromUserInput(u.weight, 18).atomics
        }))
      })
    },
    "/cosmos.gov.v1beta1.MsgSubmitProposal": {
      aminoType: "cosmos-sdk/MsgSubmitProposal",
      toAmino: ({ initialDeposit: e, proposer: n, content: o }) => {
        (0, utils_1$T.assertDefinedAndNotNull)(o);
        let u;
        switch (o.typeUrl) {
          case "/cosmos.gov.v1beta1.TextProposal": {
            const c = gov_1$1.TextProposal.decode(o.value);
            u = {
              type: "cosmos-sdk/TextProposal",
              value: {
                description: c.description,
                title: c.title
              }
            };
            break;
          }
          default:
            throw new Error(`Unsupported proposal type: '${o.typeUrl}'`);
        }
        return {
          initial_deposit: e,
          proposer: n,
          content: u
        };
      },
      fromAmino: ({ initial_deposit: e, proposer: n, content: o }) => {
        let u;
        switch (o.type) {
          case "cosmos-sdk/TextProposal": {
            const { value: c } = o;
            (0, utils_1$T.assert)((0, utils_1$T.isNonNullObject)(c));
            const { title: d, description: m } = c;
            (0, utils_1$T.assert)(typeof d == "string"), (0, utils_1$T.assert)(typeof m == "string"), u = any_1$3.Any.fromPartial({
              typeUrl: "/cosmos.gov.v1beta1.TextProposal",
              value: gov_1$1.TextProposal.encode(gov_1$1.TextProposal.fromPartial({
                title: d,
                description: m
              })).finish()
            });
            break;
          }
          default:
            throw new Error(`Unsupported proposal type: '${o.type}'`);
        }
        return {
          initialDeposit: Array.from(e),
          proposer: n,
          content: u
        };
      }
    }
  };
}
aminomessages$h.createGovAminoConverters = createGovAminoConverters$1;
var messages$e = {}, tx$k = {}, gov$3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.TallyParams = e.VotingParams = e.DepositParams = e.Vote = e.TallyResult = e.Proposal = e.Deposit = e.WeightedVoteOption = e.proposalStatusToJSON = e.proposalStatusFromJSON = e.ProposalStatus = e.voteOptionToJSON = e.voteOptionFromJSON = e.VoteOption = e.protobufPackage = void 0;
  const n = coin$8, o = any$1, u = timestamp$1, c = duration$1, d = binary, m = helpers;
  e.protobufPackage = "cosmos.gov.v1";
  var v;
  (function(Q) {
    Q[Q.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", Q[Q.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", Q[Q.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", Q[Q.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", Q[Q.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", Q[Q.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(v || (e.VoteOption = v = {}));
  function S(Q) {
    switch (Q) {
      case 0:
      case "VOTE_OPTION_UNSPECIFIED":
        return v.VOTE_OPTION_UNSPECIFIED;
      case 1:
      case "VOTE_OPTION_YES":
        return v.VOTE_OPTION_YES;
      case 2:
      case "VOTE_OPTION_ABSTAIN":
        return v.VOTE_OPTION_ABSTAIN;
      case 3:
      case "VOTE_OPTION_NO":
        return v.VOTE_OPTION_NO;
      case 4:
      case "VOTE_OPTION_NO_WITH_VETO":
        return v.VOTE_OPTION_NO_WITH_VETO;
      case -1:
      case "UNRECOGNIZED":
      default:
        return v.UNRECOGNIZED;
    }
  }
  e.voteOptionFromJSON = S;
  function $(Q) {
    switch (Q) {
      case v.VOTE_OPTION_UNSPECIFIED:
        return "VOTE_OPTION_UNSPECIFIED";
      case v.VOTE_OPTION_YES:
        return "VOTE_OPTION_YES";
      case v.VOTE_OPTION_ABSTAIN:
        return "VOTE_OPTION_ABSTAIN";
      case v.VOTE_OPTION_NO:
        return "VOTE_OPTION_NO";
      case v.VOTE_OPTION_NO_WITH_VETO:
        return "VOTE_OPTION_NO_WITH_VETO";
      case v.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.voteOptionToJSON = $;
  var E;
  (function(Q) {
    Q[Q.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", Q[Q.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", Q[Q.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", Q[Q.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", Q[Q.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", Q[Q.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED", Q[Q.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(E || (e.ProposalStatus = E = {}));
  function O(Q) {
    switch (Q) {
      case 0:
      case "PROPOSAL_STATUS_UNSPECIFIED":
        return E.PROPOSAL_STATUS_UNSPECIFIED;
      case 1:
      case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
        return E.PROPOSAL_STATUS_DEPOSIT_PERIOD;
      case 2:
      case "PROPOSAL_STATUS_VOTING_PERIOD":
        return E.PROPOSAL_STATUS_VOTING_PERIOD;
      case 3:
      case "PROPOSAL_STATUS_PASSED":
        return E.PROPOSAL_STATUS_PASSED;
      case 4:
      case "PROPOSAL_STATUS_REJECTED":
        return E.PROPOSAL_STATUS_REJECTED;
      case 5:
      case "PROPOSAL_STATUS_FAILED":
        return E.PROPOSAL_STATUS_FAILED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return E.UNRECOGNIZED;
    }
  }
  e.proposalStatusFromJSON = O;
  function T(Q) {
    switch (Q) {
      case E.PROPOSAL_STATUS_UNSPECIFIED:
        return "PROPOSAL_STATUS_UNSPECIFIED";
      case E.PROPOSAL_STATUS_DEPOSIT_PERIOD:
        return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
      case E.PROPOSAL_STATUS_VOTING_PERIOD:
        return "PROPOSAL_STATUS_VOTING_PERIOD";
      case E.PROPOSAL_STATUS_PASSED:
        return "PROPOSAL_STATUS_PASSED";
      case E.PROPOSAL_STATUS_REJECTED:
        return "PROPOSAL_STATUS_REJECTED";
      case E.PROPOSAL_STATUS_FAILED:
        return "PROPOSAL_STATUS_FAILED";
      case E.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.proposalStatusToJSON = T;
  function y() {
    return {
      option: 0,
      weight: ""
    };
  }
  e.WeightedVoteOption = {
    typeUrl: "/cosmos.gov.v1.WeightedVoteOption",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.option !== 0 && Y.uint32(8).int32(Q.option), Q.weight !== "" && Y.uint32(18).string(Q.weight), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = y();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.option = pe.int32();
            break;
          case 2:
            ne.weight = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = y();
      return (0, m.isSet)(Q.option) && (Y.option = S(Q.option)), (0, m.isSet)(Q.weight) && (Y.weight = String(Q.weight)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.option !== void 0 && (Y.option = $(Q.option)), Q.weight !== void 0 && (Y.weight = Q.weight), Y;
    },
    fromPartial(Q) {
      const Y = y();
      return Y.option = Q.option ?? 0, Y.weight = Q.weight ?? "", Y;
    }
  };
  function V() {
    return {
      proposalId: BigInt(0),
      depositor: "",
      amount: []
    };
  }
  e.Deposit = {
    typeUrl: "/cosmos.gov.v1.Deposit",
    encode(Q, Y = d.BinaryWriter.create()) {
      Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.depositor !== "" && Y.uint32(18).string(Q.depositor);
      for (const pe of Q.amount)
        n.Coin.encode(pe, Y.uint32(26).fork()).ldelim();
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = V();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.depositor = pe.string();
            break;
          case 3:
            ne.amount.push(n.Coin.decode(pe, pe.uint32()));
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = V();
      return (0, m.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, m.isSet)(Q.depositor) && (Y.depositor = String(Q.depositor)), Array.isArray(Q == null ? void 0 : Q.amount) && (Y.amount = Q.amount.map((pe) => n.Coin.fromJSON(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.depositor !== void 0 && (Y.depositor = Q.depositor), Q.amount ? Y.amount = Q.amount.map((pe) => pe ? n.Coin.toJSON(pe) : void 0) : Y.amount = [], Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = V();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Y.depositor = Q.depositor ?? "", Y.amount = ((pe = Q.amount) == null ? void 0 : pe.map((oe) => n.Coin.fromPartial(oe))) || [], Y;
    }
  };
  function M() {
    return {
      id: BigInt(0),
      messages: [],
      status: 0,
      finalTallyResult: void 0,
      submitTime: void 0,
      depositEndTime: void 0,
      totalDeposit: [],
      votingStartTime: void 0,
      votingEndTime: void 0,
      metadata: "",
      title: "",
      summary: "",
      proposer: ""
    };
  }
  e.Proposal = {
    typeUrl: "/cosmos.gov.v1.Proposal",
    encode(Q, Y = d.BinaryWriter.create()) {
      Q.id !== BigInt(0) && Y.uint32(8).uint64(Q.id);
      for (const pe of Q.messages)
        o.Any.encode(pe, Y.uint32(18).fork()).ldelim();
      Q.status !== 0 && Y.uint32(24).int32(Q.status), Q.finalTallyResult !== void 0 && e.TallyResult.encode(Q.finalTallyResult, Y.uint32(34).fork()).ldelim(), Q.submitTime !== void 0 && u.Timestamp.encode(Q.submitTime, Y.uint32(42).fork()).ldelim(), Q.depositEndTime !== void 0 && u.Timestamp.encode(Q.depositEndTime, Y.uint32(50).fork()).ldelim();
      for (const pe of Q.totalDeposit)
        n.Coin.encode(pe, Y.uint32(58).fork()).ldelim();
      return Q.votingStartTime !== void 0 && u.Timestamp.encode(Q.votingStartTime, Y.uint32(66).fork()).ldelim(), Q.votingEndTime !== void 0 && u.Timestamp.encode(Q.votingEndTime, Y.uint32(74).fork()).ldelim(), Q.metadata !== "" && Y.uint32(82).string(Q.metadata), Q.title !== "" && Y.uint32(90).string(Q.title), Q.summary !== "" && Y.uint32(98).string(Q.summary), Q.proposer !== "" && Y.uint32(106).string(Q.proposer), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = M();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.id = pe.uint64();
            break;
          case 2:
            ne.messages.push(o.Any.decode(pe, pe.uint32()));
            break;
          case 3:
            ne.status = pe.int32();
            break;
          case 4:
            ne.finalTallyResult = e.TallyResult.decode(pe, pe.uint32());
            break;
          case 5:
            ne.submitTime = u.Timestamp.decode(pe, pe.uint32());
            break;
          case 6:
            ne.depositEndTime = u.Timestamp.decode(pe, pe.uint32());
            break;
          case 7:
            ne.totalDeposit.push(n.Coin.decode(pe, pe.uint32()));
            break;
          case 8:
            ne.votingStartTime = u.Timestamp.decode(pe, pe.uint32());
            break;
          case 9:
            ne.votingEndTime = u.Timestamp.decode(pe, pe.uint32());
            break;
          case 10:
            ne.metadata = pe.string();
            break;
          case 11:
            ne.title = pe.string();
            break;
          case 12:
            ne.summary = pe.string();
            break;
          case 13:
            ne.proposer = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = M();
      return (0, m.isSet)(Q.id) && (Y.id = BigInt(Q.id.toString())), Array.isArray(Q == null ? void 0 : Q.messages) && (Y.messages = Q.messages.map((pe) => o.Any.fromJSON(pe))), (0, m.isSet)(Q.status) && (Y.status = O(Q.status)), (0, m.isSet)(Q.finalTallyResult) && (Y.finalTallyResult = e.TallyResult.fromJSON(Q.finalTallyResult)), (0, m.isSet)(Q.submitTime) && (Y.submitTime = (0, m.fromJsonTimestamp)(Q.submitTime)), (0, m.isSet)(Q.depositEndTime) && (Y.depositEndTime = (0, m.fromJsonTimestamp)(Q.depositEndTime)), Array.isArray(Q == null ? void 0 : Q.totalDeposit) && (Y.totalDeposit = Q.totalDeposit.map((pe) => n.Coin.fromJSON(pe))), (0, m.isSet)(Q.votingStartTime) && (Y.votingStartTime = (0, m.fromJsonTimestamp)(Q.votingStartTime)), (0, m.isSet)(Q.votingEndTime) && (Y.votingEndTime = (0, m.fromJsonTimestamp)(Q.votingEndTime)), (0, m.isSet)(Q.metadata) && (Y.metadata = String(Q.metadata)), (0, m.isSet)(Q.title) && (Y.title = String(Q.title)), (0, m.isSet)(Q.summary) && (Y.summary = String(Q.summary)), (0, m.isSet)(Q.proposer) && (Y.proposer = String(Q.proposer)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.id !== void 0 && (Y.id = (Q.id || BigInt(0)).toString()), Q.messages ? Y.messages = Q.messages.map((pe) => pe ? o.Any.toJSON(pe) : void 0) : Y.messages = [], Q.status !== void 0 && (Y.status = T(Q.status)), Q.finalTallyResult !== void 0 && (Y.finalTallyResult = Q.finalTallyResult ? e.TallyResult.toJSON(Q.finalTallyResult) : void 0), Q.submitTime !== void 0 && (Y.submitTime = (0, m.fromTimestamp)(Q.submitTime).toISOString()), Q.depositEndTime !== void 0 && (Y.depositEndTime = (0, m.fromTimestamp)(Q.depositEndTime).toISOString()), Q.totalDeposit ? Y.totalDeposit = Q.totalDeposit.map((pe) => pe ? n.Coin.toJSON(pe) : void 0) : Y.totalDeposit = [], Q.votingStartTime !== void 0 && (Y.votingStartTime = (0, m.fromTimestamp)(Q.votingStartTime).toISOString()), Q.votingEndTime !== void 0 && (Y.votingEndTime = (0, m.fromTimestamp)(Q.votingEndTime).toISOString()), Q.metadata !== void 0 && (Y.metadata = Q.metadata), Q.title !== void 0 && (Y.title = Q.title), Q.summary !== void 0 && (Y.summary = Q.summary), Q.proposer !== void 0 && (Y.proposer = Q.proposer), Y;
    },
    fromPartial(Q) {
      var pe, oe;
      const Y = M();
      return Q.id !== void 0 && Q.id !== null && (Y.id = BigInt(Q.id.toString())), Y.messages = ((pe = Q.messages) == null ? void 0 : pe.map((ne) => o.Any.fromPartial(ne))) || [], Y.status = Q.status ?? 0, Q.finalTallyResult !== void 0 && Q.finalTallyResult !== null && (Y.finalTallyResult = e.TallyResult.fromPartial(Q.finalTallyResult)), Q.submitTime !== void 0 && Q.submitTime !== null && (Y.submitTime = u.Timestamp.fromPartial(Q.submitTime)), Q.depositEndTime !== void 0 && Q.depositEndTime !== null && (Y.depositEndTime = u.Timestamp.fromPartial(Q.depositEndTime)), Y.totalDeposit = ((oe = Q.totalDeposit) == null ? void 0 : oe.map((ne) => n.Coin.fromPartial(ne))) || [], Q.votingStartTime !== void 0 && Q.votingStartTime !== null && (Y.votingStartTime = u.Timestamp.fromPartial(Q.votingStartTime)), Q.votingEndTime !== void 0 && Q.votingEndTime !== null && (Y.votingEndTime = u.Timestamp.fromPartial(Q.votingEndTime)), Y.metadata = Q.metadata ?? "", Y.title = Q.title ?? "", Y.summary = Q.summary ?? "", Y.proposer = Q.proposer ?? "", Y;
    }
  };
  function G() {
    return {
      yesCount: "",
      abstainCount: "",
      noCount: "",
      noWithVetoCount: ""
    };
  }
  e.TallyResult = {
    typeUrl: "/cosmos.gov.v1.TallyResult",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.yesCount !== "" && Y.uint32(10).string(Q.yesCount), Q.abstainCount !== "" && Y.uint32(18).string(Q.abstainCount), Q.noCount !== "" && Y.uint32(26).string(Q.noCount), Q.noWithVetoCount !== "" && Y.uint32(34).string(Q.noWithVetoCount), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = G();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.yesCount = pe.string();
            break;
          case 2:
            ne.abstainCount = pe.string();
            break;
          case 3:
            ne.noCount = pe.string();
            break;
          case 4:
            ne.noWithVetoCount = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = G();
      return (0, m.isSet)(Q.yesCount) && (Y.yesCount = String(Q.yesCount)), (0, m.isSet)(Q.abstainCount) && (Y.abstainCount = String(Q.abstainCount)), (0, m.isSet)(Q.noCount) && (Y.noCount = String(Q.noCount)), (0, m.isSet)(Q.noWithVetoCount) && (Y.noWithVetoCount = String(Q.noWithVetoCount)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.yesCount !== void 0 && (Y.yesCount = Q.yesCount), Q.abstainCount !== void 0 && (Y.abstainCount = Q.abstainCount), Q.noCount !== void 0 && (Y.noCount = Q.noCount), Q.noWithVetoCount !== void 0 && (Y.noWithVetoCount = Q.noWithVetoCount), Y;
    },
    fromPartial(Q) {
      const Y = G();
      return Y.yesCount = Q.yesCount ?? "", Y.abstainCount = Q.abstainCount ?? "", Y.noCount = Q.noCount ?? "", Y.noWithVetoCount = Q.noWithVetoCount ?? "", Y;
    }
  };
  function k() {
    return {
      proposalId: BigInt(0),
      voter: "",
      options: [],
      metadata: ""
    };
  }
  e.Vote = {
    typeUrl: "/cosmos.gov.v1.Vote",
    encode(Q, Y = d.BinaryWriter.create()) {
      Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.voter !== "" && Y.uint32(18).string(Q.voter);
      for (const pe of Q.options)
        e.WeightedVoteOption.encode(pe, Y.uint32(34).fork()).ldelim();
      return Q.metadata !== "" && Y.uint32(42).string(Q.metadata), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = k();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.voter = pe.string();
            break;
          case 4:
            ne.options.push(e.WeightedVoteOption.decode(pe, pe.uint32()));
            break;
          case 5:
            ne.metadata = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = k();
      return (0, m.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, m.isSet)(Q.voter) && (Y.voter = String(Q.voter)), Array.isArray(Q == null ? void 0 : Q.options) && (Y.options = Q.options.map((pe) => e.WeightedVoteOption.fromJSON(pe))), (0, m.isSet)(Q.metadata) && (Y.metadata = String(Q.metadata)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.voter !== void 0 && (Y.voter = Q.voter), Q.options ? Y.options = Q.options.map((pe) => pe ? e.WeightedVoteOption.toJSON(pe) : void 0) : Y.options = [], Q.metadata !== void 0 && (Y.metadata = Q.metadata), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = k();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Y.voter = Q.voter ?? "", Y.options = ((pe = Q.options) == null ? void 0 : pe.map((oe) => e.WeightedVoteOption.fromPartial(oe))) || [], Y.metadata = Q.metadata ?? "", Y;
    }
  };
  function F() {
    return {
      minDeposit: [],
      maxDepositPeriod: void 0
    };
  }
  e.DepositParams = {
    typeUrl: "/cosmos.gov.v1.DepositParams",
    encode(Q, Y = d.BinaryWriter.create()) {
      for (const pe of Q.minDeposit)
        n.Coin.encode(pe, Y.uint32(10).fork()).ldelim();
      return Q.maxDepositPeriod !== void 0 && c.Duration.encode(Q.maxDepositPeriod, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = F();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.minDeposit.push(n.Coin.decode(pe, pe.uint32()));
            break;
          case 2:
            ne.maxDepositPeriod = c.Duration.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = F();
      return Array.isArray(Q == null ? void 0 : Q.minDeposit) && (Y.minDeposit = Q.minDeposit.map((pe) => n.Coin.fromJSON(pe))), (0, m.isSet)(Q.maxDepositPeriod) && (Y.maxDepositPeriod = c.Duration.fromJSON(Q.maxDepositPeriod)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.minDeposit ? Y.minDeposit = Q.minDeposit.map((pe) => pe ? n.Coin.toJSON(pe) : void 0) : Y.minDeposit = [], Q.maxDepositPeriod !== void 0 && (Y.maxDepositPeriod = Q.maxDepositPeriod ? c.Duration.toJSON(Q.maxDepositPeriod) : void 0), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = F();
      return Y.minDeposit = ((pe = Q.minDeposit) == null ? void 0 : pe.map((oe) => n.Coin.fromPartial(oe))) || [], Q.maxDepositPeriod !== void 0 && Q.maxDepositPeriod !== null && (Y.maxDepositPeriod = c.Duration.fromPartial(Q.maxDepositPeriod)), Y;
    }
  };
  function X() {
    return {
      votingPeriod: void 0
    };
  }
  e.VotingParams = {
    typeUrl: "/cosmos.gov.v1.VotingParams",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.votingPeriod !== void 0 && c.Duration.encode(Q.votingPeriod, Y.uint32(10).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = X();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.votingPeriod = c.Duration.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = X();
      return (0, m.isSet)(Q.votingPeriod) && (Y.votingPeriod = c.Duration.fromJSON(Q.votingPeriod)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.votingPeriod !== void 0 && (Y.votingPeriod = Q.votingPeriod ? c.Duration.toJSON(Q.votingPeriod) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = X();
      return Q.votingPeriod !== void 0 && Q.votingPeriod !== null && (Y.votingPeriod = c.Duration.fromPartial(Q.votingPeriod)), Y;
    }
  };
  function ee() {
    return {
      quorum: "",
      threshold: "",
      vetoThreshold: ""
    };
  }
  e.TallyParams = {
    typeUrl: "/cosmos.gov.v1.TallyParams",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.quorum !== "" && Y.uint32(10).string(Q.quorum), Q.threshold !== "" && Y.uint32(18).string(Q.threshold), Q.vetoThreshold !== "" && Y.uint32(26).string(Q.vetoThreshold), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ee();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.quorum = pe.string();
            break;
          case 2:
            ne.threshold = pe.string();
            break;
          case 3:
            ne.vetoThreshold = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = ee();
      return (0, m.isSet)(Q.quorum) && (Y.quorum = String(Q.quorum)), (0, m.isSet)(Q.threshold) && (Y.threshold = String(Q.threshold)), (0, m.isSet)(Q.vetoThreshold) && (Y.vetoThreshold = String(Q.vetoThreshold)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.quorum !== void 0 && (Y.quorum = Q.quorum), Q.threshold !== void 0 && (Y.threshold = Q.threshold), Q.vetoThreshold !== void 0 && (Y.vetoThreshold = Q.vetoThreshold), Y;
    },
    fromPartial(Q) {
      const Y = ee();
      return Y.quorum = Q.quorum ?? "", Y.threshold = Q.threshold ?? "", Y.vetoThreshold = Q.vetoThreshold ?? "", Y;
    }
  };
  function ue() {
    return {
      minDeposit: [],
      maxDepositPeriod: void 0,
      votingPeriod: void 0,
      quorum: "",
      threshold: "",
      vetoThreshold: "",
      minInitialDepositRatio: "",
      burnVoteQuorum: !1,
      burnProposalDepositPrevote: !1,
      burnVoteVeto: !1
    };
  }
  e.Params = {
    typeUrl: "/cosmos.gov.v1.Params",
    encode(Q, Y = d.BinaryWriter.create()) {
      for (const pe of Q.minDeposit)
        n.Coin.encode(pe, Y.uint32(10).fork()).ldelim();
      return Q.maxDepositPeriod !== void 0 && c.Duration.encode(Q.maxDepositPeriod, Y.uint32(18).fork()).ldelim(), Q.votingPeriod !== void 0 && c.Duration.encode(Q.votingPeriod, Y.uint32(26).fork()).ldelim(), Q.quorum !== "" && Y.uint32(34).string(Q.quorum), Q.threshold !== "" && Y.uint32(42).string(Q.threshold), Q.vetoThreshold !== "" && Y.uint32(50).string(Q.vetoThreshold), Q.minInitialDepositRatio !== "" && Y.uint32(58).string(Q.minInitialDepositRatio), Q.burnVoteQuorum === !0 && Y.uint32(104).bool(Q.burnVoteQuorum), Q.burnProposalDepositPrevote === !0 && Y.uint32(112).bool(Q.burnProposalDepositPrevote), Q.burnVoteVeto === !0 && Y.uint32(120).bool(Q.burnVoteVeto), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ue();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.minDeposit.push(n.Coin.decode(pe, pe.uint32()));
            break;
          case 2:
            ne.maxDepositPeriod = c.Duration.decode(pe, pe.uint32());
            break;
          case 3:
            ne.votingPeriod = c.Duration.decode(pe, pe.uint32());
            break;
          case 4:
            ne.quorum = pe.string();
            break;
          case 5:
            ne.threshold = pe.string();
            break;
          case 6:
            ne.vetoThreshold = pe.string();
            break;
          case 7:
            ne.minInitialDepositRatio = pe.string();
            break;
          case 13:
            ne.burnVoteQuorum = pe.bool();
            break;
          case 14:
            ne.burnProposalDepositPrevote = pe.bool();
            break;
          case 15:
            ne.burnVoteVeto = pe.bool();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = ue();
      return Array.isArray(Q == null ? void 0 : Q.minDeposit) && (Y.minDeposit = Q.minDeposit.map((pe) => n.Coin.fromJSON(pe))), (0, m.isSet)(Q.maxDepositPeriod) && (Y.maxDepositPeriod = c.Duration.fromJSON(Q.maxDepositPeriod)), (0, m.isSet)(Q.votingPeriod) && (Y.votingPeriod = c.Duration.fromJSON(Q.votingPeriod)), (0, m.isSet)(Q.quorum) && (Y.quorum = String(Q.quorum)), (0, m.isSet)(Q.threshold) && (Y.threshold = String(Q.threshold)), (0, m.isSet)(Q.vetoThreshold) && (Y.vetoThreshold = String(Q.vetoThreshold)), (0, m.isSet)(Q.minInitialDepositRatio) && (Y.minInitialDepositRatio = String(Q.minInitialDepositRatio)), (0, m.isSet)(Q.burnVoteQuorum) && (Y.burnVoteQuorum = !!Q.burnVoteQuorum), (0, m.isSet)(Q.burnProposalDepositPrevote) && (Y.burnProposalDepositPrevote = !!Q.burnProposalDepositPrevote), (0, m.isSet)(Q.burnVoteVeto) && (Y.burnVoteVeto = !!Q.burnVoteVeto), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.minDeposit ? Y.minDeposit = Q.minDeposit.map((pe) => pe ? n.Coin.toJSON(pe) : void 0) : Y.minDeposit = [], Q.maxDepositPeriod !== void 0 && (Y.maxDepositPeriod = Q.maxDepositPeriod ? c.Duration.toJSON(Q.maxDepositPeriod) : void 0), Q.votingPeriod !== void 0 && (Y.votingPeriod = Q.votingPeriod ? c.Duration.toJSON(Q.votingPeriod) : void 0), Q.quorum !== void 0 && (Y.quorum = Q.quorum), Q.threshold !== void 0 && (Y.threshold = Q.threshold), Q.vetoThreshold !== void 0 && (Y.vetoThreshold = Q.vetoThreshold), Q.minInitialDepositRatio !== void 0 && (Y.minInitialDepositRatio = Q.minInitialDepositRatio), Q.burnVoteQuorum !== void 0 && (Y.burnVoteQuorum = Q.burnVoteQuorum), Q.burnProposalDepositPrevote !== void 0 && (Y.burnProposalDepositPrevote = Q.burnProposalDepositPrevote), Q.burnVoteVeto !== void 0 && (Y.burnVoteVeto = Q.burnVoteVeto), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = ue();
      return Y.minDeposit = ((pe = Q.minDeposit) == null ? void 0 : pe.map((oe) => n.Coin.fromPartial(oe))) || [], Q.maxDepositPeriod !== void 0 && Q.maxDepositPeriod !== null && (Y.maxDepositPeriod = c.Duration.fromPartial(Q.maxDepositPeriod)), Q.votingPeriod !== void 0 && Q.votingPeriod !== null && (Y.votingPeriod = c.Duration.fromPartial(Q.votingPeriod)), Y.quorum = Q.quorum ?? "", Y.threshold = Q.threshold ?? "", Y.vetoThreshold = Q.vetoThreshold ?? "", Y.minInitialDepositRatio = Q.minInitialDepositRatio ?? "", Y.burnVoteQuorum = Q.burnVoteQuorum ?? !1, Y.burnProposalDepositPrevote = Q.burnProposalDepositPrevote ?? !1, Y.burnVoteVeto = Q.burnVoteVeto ?? !1, Y;
    }
  };
})(gov$3);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgDepositResponse = e.MsgDeposit = e.MsgVoteWeightedResponse = e.MsgVoteWeighted = e.MsgVoteResponse = e.MsgVote = e.MsgExecLegacyContentResponse = e.MsgExecLegacyContent = e.MsgSubmitProposalResponse = e.MsgSubmitProposal = e.protobufPackage = void 0;
  const n = any$1, o = coin$8, u = gov$3, c = binary, d = helpers;
  e.protobufPackage = "cosmos.gov.v1";
  function m() {
    return {
      messages: [],
      initialDeposit: [],
      proposer: "",
      metadata: "",
      title: "",
      summary: ""
    };
  }
  e.MsgSubmitProposal = {
    typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
    encode(X, ee = c.BinaryWriter.create()) {
      for (const ue of X.messages)
        n.Any.encode(ue, ee.uint32(10).fork()).ldelim();
      for (const ue of X.initialDeposit)
        o.Coin.encode(ue, ee.uint32(18).fork()).ldelim();
      return X.proposer !== "" && ee.uint32(26).string(X.proposer), X.metadata !== "" && ee.uint32(34).string(X.metadata), X.title !== "" && ee.uint32(42).string(X.title), X.summary !== "" && ee.uint32(50).string(X.summary), ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = m();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          case 1:
            Y.messages.push(n.Any.decode(ue, ue.uint32()));
            break;
          case 2:
            Y.initialDeposit.push(o.Coin.decode(ue, ue.uint32()));
            break;
          case 3:
            Y.proposer = ue.string();
            break;
          case 4:
            Y.metadata = ue.string();
            break;
          case 5:
            Y.title = ue.string();
            break;
          case 6:
            Y.summary = ue.string();
            break;
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      const ee = m();
      return Array.isArray(X == null ? void 0 : X.messages) && (ee.messages = X.messages.map((ue) => n.Any.fromJSON(ue))), Array.isArray(X == null ? void 0 : X.initialDeposit) && (ee.initialDeposit = X.initialDeposit.map((ue) => o.Coin.fromJSON(ue))), (0, d.isSet)(X.proposer) && (ee.proposer = String(X.proposer)), (0, d.isSet)(X.metadata) && (ee.metadata = String(X.metadata)), (0, d.isSet)(X.title) && (ee.title = String(X.title)), (0, d.isSet)(X.summary) && (ee.summary = String(X.summary)), ee;
    },
    toJSON(X) {
      const ee = {};
      return X.messages ? ee.messages = X.messages.map((ue) => ue ? n.Any.toJSON(ue) : void 0) : ee.messages = [], X.initialDeposit ? ee.initialDeposit = X.initialDeposit.map((ue) => ue ? o.Coin.toJSON(ue) : void 0) : ee.initialDeposit = [], X.proposer !== void 0 && (ee.proposer = X.proposer), X.metadata !== void 0 && (ee.metadata = X.metadata), X.title !== void 0 && (ee.title = X.title), X.summary !== void 0 && (ee.summary = X.summary), ee;
    },
    fromPartial(X) {
      var ue, Q;
      const ee = m();
      return ee.messages = ((ue = X.messages) == null ? void 0 : ue.map((Y) => n.Any.fromPartial(Y))) || [], ee.initialDeposit = ((Q = X.initialDeposit) == null ? void 0 : Q.map((Y) => o.Coin.fromPartial(Y))) || [], ee.proposer = X.proposer ?? "", ee.metadata = X.metadata ?? "", ee.title = X.title ?? "", ee.summary = X.summary ?? "", ee;
    }
  };
  function v() {
    return {
      proposalId: BigInt(0)
    };
  }
  e.MsgSubmitProposalResponse = {
    typeUrl: "/cosmos.gov.v1.MsgSubmitProposalResponse",
    encode(X, ee = c.BinaryWriter.create()) {
      return X.proposalId !== BigInt(0) && ee.uint32(8).uint64(X.proposalId), ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = v();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          case 1:
            Y.proposalId = ue.uint64();
            break;
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      const ee = v();
      return (0, d.isSet)(X.proposalId) && (ee.proposalId = BigInt(X.proposalId.toString())), ee;
    },
    toJSON(X) {
      const ee = {};
      return X.proposalId !== void 0 && (ee.proposalId = (X.proposalId || BigInt(0)).toString()), ee;
    },
    fromPartial(X) {
      const ee = v();
      return X.proposalId !== void 0 && X.proposalId !== null && (ee.proposalId = BigInt(X.proposalId.toString())), ee;
    }
  };
  function S() {
    return {
      content: void 0,
      authority: ""
    };
  }
  e.MsgExecLegacyContent = {
    typeUrl: "/cosmos.gov.v1.MsgExecLegacyContent",
    encode(X, ee = c.BinaryWriter.create()) {
      return X.content !== void 0 && n.Any.encode(X.content, ee.uint32(10).fork()).ldelim(), X.authority !== "" && ee.uint32(18).string(X.authority), ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = S();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          case 1:
            Y.content = n.Any.decode(ue, ue.uint32());
            break;
          case 2:
            Y.authority = ue.string();
            break;
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      const ee = S();
      return (0, d.isSet)(X.content) && (ee.content = n.Any.fromJSON(X.content)), (0, d.isSet)(X.authority) && (ee.authority = String(X.authority)), ee;
    },
    toJSON(X) {
      const ee = {};
      return X.content !== void 0 && (ee.content = X.content ? n.Any.toJSON(X.content) : void 0), X.authority !== void 0 && (ee.authority = X.authority), ee;
    },
    fromPartial(X) {
      const ee = S();
      return X.content !== void 0 && X.content !== null && (ee.content = n.Any.fromPartial(X.content)), ee.authority = X.authority ?? "", ee;
    }
  };
  function $() {
    return {};
  }
  e.MsgExecLegacyContentResponse = {
    typeUrl: "/cosmos.gov.v1.MsgExecLegacyContentResponse",
    encode(X, ee = c.BinaryWriter.create()) {
      return ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = $();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      return $();
    },
    toJSON(X) {
      return {};
    },
    fromPartial(X) {
      return $();
    }
  };
  function E() {
    return {
      proposalId: BigInt(0),
      voter: "",
      option: 0,
      metadata: ""
    };
  }
  e.MsgVote = {
    typeUrl: "/cosmos.gov.v1.MsgVote",
    encode(X, ee = c.BinaryWriter.create()) {
      return X.proposalId !== BigInt(0) && ee.uint32(8).uint64(X.proposalId), X.voter !== "" && ee.uint32(18).string(X.voter), X.option !== 0 && ee.uint32(24).int32(X.option), X.metadata !== "" && ee.uint32(34).string(X.metadata), ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = E();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          case 1:
            Y.proposalId = ue.uint64();
            break;
          case 2:
            Y.voter = ue.string();
            break;
          case 3:
            Y.option = ue.int32();
            break;
          case 4:
            Y.metadata = ue.string();
            break;
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      const ee = E();
      return (0, d.isSet)(X.proposalId) && (ee.proposalId = BigInt(X.proposalId.toString())), (0, d.isSet)(X.voter) && (ee.voter = String(X.voter)), (0, d.isSet)(X.option) && (ee.option = (0, u.voteOptionFromJSON)(X.option)), (0, d.isSet)(X.metadata) && (ee.metadata = String(X.metadata)), ee;
    },
    toJSON(X) {
      const ee = {};
      return X.proposalId !== void 0 && (ee.proposalId = (X.proposalId || BigInt(0)).toString()), X.voter !== void 0 && (ee.voter = X.voter), X.option !== void 0 && (ee.option = (0, u.voteOptionToJSON)(X.option)), X.metadata !== void 0 && (ee.metadata = X.metadata), ee;
    },
    fromPartial(X) {
      const ee = E();
      return X.proposalId !== void 0 && X.proposalId !== null && (ee.proposalId = BigInt(X.proposalId.toString())), ee.voter = X.voter ?? "", ee.option = X.option ?? 0, ee.metadata = X.metadata ?? "", ee;
    }
  };
  function O() {
    return {};
  }
  e.MsgVoteResponse = {
    typeUrl: "/cosmos.gov.v1.MsgVoteResponse",
    encode(X, ee = c.BinaryWriter.create()) {
      return ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = O();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      return O();
    },
    toJSON(X) {
      return {};
    },
    fromPartial(X) {
      return O();
    }
  };
  function T() {
    return {
      proposalId: BigInt(0),
      voter: "",
      options: [],
      metadata: ""
    };
  }
  e.MsgVoteWeighted = {
    typeUrl: "/cosmos.gov.v1.MsgVoteWeighted",
    encode(X, ee = c.BinaryWriter.create()) {
      X.proposalId !== BigInt(0) && ee.uint32(8).uint64(X.proposalId), X.voter !== "" && ee.uint32(18).string(X.voter);
      for (const ue of X.options)
        u.WeightedVoteOption.encode(ue, ee.uint32(26).fork()).ldelim();
      return X.metadata !== "" && ee.uint32(34).string(X.metadata), ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = T();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          case 1:
            Y.proposalId = ue.uint64();
            break;
          case 2:
            Y.voter = ue.string();
            break;
          case 3:
            Y.options.push(u.WeightedVoteOption.decode(ue, ue.uint32()));
            break;
          case 4:
            Y.metadata = ue.string();
            break;
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      const ee = T();
      return (0, d.isSet)(X.proposalId) && (ee.proposalId = BigInt(X.proposalId.toString())), (0, d.isSet)(X.voter) && (ee.voter = String(X.voter)), Array.isArray(X == null ? void 0 : X.options) && (ee.options = X.options.map((ue) => u.WeightedVoteOption.fromJSON(ue))), (0, d.isSet)(X.metadata) && (ee.metadata = String(X.metadata)), ee;
    },
    toJSON(X) {
      const ee = {};
      return X.proposalId !== void 0 && (ee.proposalId = (X.proposalId || BigInt(0)).toString()), X.voter !== void 0 && (ee.voter = X.voter), X.options ? ee.options = X.options.map((ue) => ue ? u.WeightedVoteOption.toJSON(ue) : void 0) : ee.options = [], X.metadata !== void 0 && (ee.metadata = X.metadata), ee;
    },
    fromPartial(X) {
      var ue;
      const ee = T();
      return X.proposalId !== void 0 && X.proposalId !== null && (ee.proposalId = BigInt(X.proposalId.toString())), ee.voter = X.voter ?? "", ee.options = ((ue = X.options) == null ? void 0 : ue.map((Q) => u.WeightedVoteOption.fromPartial(Q))) || [], ee.metadata = X.metadata ?? "", ee;
    }
  };
  function y() {
    return {};
  }
  e.MsgVoteWeightedResponse = {
    typeUrl: "/cosmos.gov.v1.MsgVoteWeightedResponse",
    encode(X, ee = c.BinaryWriter.create()) {
      return ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = y();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      return y();
    },
    toJSON(X) {
      return {};
    },
    fromPartial(X) {
      return y();
    }
  };
  function V() {
    return {
      proposalId: BigInt(0),
      depositor: "",
      amount: []
    };
  }
  e.MsgDeposit = {
    typeUrl: "/cosmos.gov.v1.MsgDeposit",
    encode(X, ee = c.BinaryWriter.create()) {
      X.proposalId !== BigInt(0) && ee.uint32(8).uint64(X.proposalId), X.depositor !== "" && ee.uint32(18).string(X.depositor);
      for (const ue of X.amount)
        o.Coin.encode(ue, ee.uint32(26).fork()).ldelim();
      return ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = V();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          case 1:
            Y.proposalId = ue.uint64();
            break;
          case 2:
            Y.depositor = ue.string();
            break;
          case 3:
            Y.amount.push(o.Coin.decode(ue, ue.uint32()));
            break;
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      const ee = V();
      return (0, d.isSet)(X.proposalId) && (ee.proposalId = BigInt(X.proposalId.toString())), (0, d.isSet)(X.depositor) && (ee.depositor = String(X.depositor)), Array.isArray(X == null ? void 0 : X.amount) && (ee.amount = X.amount.map((ue) => o.Coin.fromJSON(ue))), ee;
    },
    toJSON(X) {
      const ee = {};
      return X.proposalId !== void 0 && (ee.proposalId = (X.proposalId || BigInt(0)).toString()), X.depositor !== void 0 && (ee.depositor = X.depositor), X.amount ? ee.amount = X.amount.map((ue) => ue ? o.Coin.toJSON(ue) : void 0) : ee.amount = [], ee;
    },
    fromPartial(X) {
      var ue;
      const ee = V();
      return X.proposalId !== void 0 && X.proposalId !== null && (ee.proposalId = BigInt(X.proposalId.toString())), ee.depositor = X.depositor ?? "", ee.amount = ((ue = X.amount) == null ? void 0 : ue.map((Q) => o.Coin.fromPartial(Q))) || [], ee;
    }
  };
  function M() {
    return {};
  }
  e.MsgDepositResponse = {
    typeUrl: "/cosmos.gov.v1.MsgDepositResponse",
    encode(X, ee = c.BinaryWriter.create()) {
      return ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = M();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      return M();
    },
    toJSON(X) {
      return {};
    },
    fromPartial(X) {
      return M();
    }
  };
  function G() {
    return {
      authority: "",
      params: u.Params.fromPartial({})
    };
  }
  e.MsgUpdateParams = {
    typeUrl: "/cosmos.gov.v1.MsgUpdateParams",
    encode(X, ee = c.BinaryWriter.create()) {
      return X.authority !== "" && ee.uint32(10).string(X.authority), X.params !== void 0 && u.Params.encode(X.params, ee.uint32(18).fork()).ldelim(), ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = G();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          case 1:
            Y.authority = ue.string();
            break;
          case 2:
            Y.params = u.Params.decode(ue, ue.uint32());
            break;
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      const ee = G();
      return (0, d.isSet)(X.authority) && (ee.authority = String(X.authority)), (0, d.isSet)(X.params) && (ee.params = u.Params.fromJSON(X.params)), ee;
    },
    toJSON(X) {
      const ee = {};
      return X.authority !== void 0 && (ee.authority = X.authority), X.params !== void 0 && (ee.params = X.params ? u.Params.toJSON(X.params) : void 0), ee;
    },
    fromPartial(X) {
      const ee = G();
      return ee.authority = X.authority ?? "", X.params !== void 0 && X.params !== null && (ee.params = u.Params.fromPartial(X.params)), ee;
    }
  };
  function k() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    typeUrl: "/cosmos.gov.v1.MsgUpdateParamsResponse",
    encode(X, ee = c.BinaryWriter.create()) {
      return ee;
    },
    decode(X, ee) {
      const ue = X instanceof c.BinaryReader ? X : new c.BinaryReader(X);
      let Q = ee === void 0 ? ue.len : ue.pos + ee;
      const Y = k();
      for (; ue.pos < Q; ) {
        const pe = ue.uint32();
        switch (pe >>> 3) {
          default:
            ue.skipType(pe & 7);
            break;
        }
      }
      return Y;
    },
    fromJSON(X) {
      return k();
    },
    toJSON(X) {
      return {};
    },
    fromPartial(X) {
      return k();
    }
  };
  class F {
    constructor(ee) {
      this.rpc = ee, this.SubmitProposal = this.SubmitProposal.bind(this), this.ExecLegacyContent = this.ExecLegacyContent.bind(this), this.Vote = this.Vote.bind(this), this.VoteWeighted = this.VoteWeighted.bind(this), this.Deposit = this.Deposit.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
    }
    SubmitProposal(ee) {
      const ue = e.MsgSubmitProposal.encode(ee).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "SubmitProposal", ue).then((Y) => e.MsgSubmitProposalResponse.decode(new c.BinaryReader(Y)));
    }
    ExecLegacyContent(ee) {
      const ue = e.MsgExecLegacyContent.encode(ee).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "ExecLegacyContent", ue).then((Y) => e.MsgExecLegacyContentResponse.decode(new c.BinaryReader(Y)));
    }
    Vote(ee) {
      const ue = e.MsgVote.encode(ee).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "Vote", ue).then((Y) => e.MsgVoteResponse.decode(new c.BinaryReader(Y)));
    }
    VoteWeighted(ee) {
      const ue = e.MsgVoteWeighted.encode(ee).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "VoteWeighted", ue).then((Y) => e.MsgVoteWeightedResponse.decode(new c.BinaryReader(Y)));
    }
    Deposit(ee) {
      const ue = e.MsgDeposit.encode(ee).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "Deposit", ue).then((Y) => e.MsgDepositResponse.decode(new c.BinaryReader(Y)));
    }
    UpdateParams(ee) {
      const ue = e.MsgUpdateParams.encode(ee).finish();
      return this.rpc.request("cosmos.gov.v1.Msg", "UpdateParams", ue).then((Y) => e.MsgUpdateParamsResponse.decode(new c.BinaryReader(Y)));
    }
  }
  e.MsgClientImpl = F;
})(tx$k);
var tx$j = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgDepositResponse = e.MsgDeposit = e.MsgVoteWeightedResponse = e.MsgVoteWeighted = e.MsgVoteResponse = e.MsgVote = e.MsgSubmitProposalResponse = e.MsgSubmitProposal = e.protobufPackage = void 0;
  const n = any$1, o = coin$8, u = gov$4, c = binary, d = helpers;
  e.protobufPackage = "cosmos.gov.v1beta1";
  function m() {
    return {
      content: void 0,
      initialDeposit: [],
      proposer: ""
    };
  }
  e.MsgSubmitProposal = {
    typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
    encode(M, G = c.BinaryWriter.create()) {
      M.content !== void 0 && n.Any.encode(M.content, G.uint32(10).fork()).ldelim();
      for (const k of M.initialDeposit)
        o.Coin.encode(k, G.uint32(18).fork()).ldelim();
      return M.proposer !== "" && G.uint32(26).string(M.proposer), G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = m();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.content = n.Any.decode(k, k.uint32());
            break;
          case 2:
            X.initialDeposit.push(o.Coin.decode(k, k.uint32()));
            break;
          case 3:
            X.proposer = k.string();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = m();
      return (0, d.isSet)(M.content) && (G.content = n.Any.fromJSON(M.content)), Array.isArray(M == null ? void 0 : M.initialDeposit) && (G.initialDeposit = M.initialDeposit.map((k) => o.Coin.fromJSON(k))), (0, d.isSet)(M.proposer) && (G.proposer = String(M.proposer)), G;
    },
    toJSON(M) {
      const G = {};
      return M.content !== void 0 && (G.content = M.content ? n.Any.toJSON(M.content) : void 0), M.initialDeposit ? G.initialDeposit = M.initialDeposit.map((k) => k ? o.Coin.toJSON(k) : void 0) : G.initialDeposit = [], M.proposer !== void 0 && (G.proposer = M.proposer), G;
    },
    fromPartial(M) {
      var k;
      const G = m();
      return M.content !== void 0 && M.content !== null && (G.content = n.Any.fromPartial(M.content)), G.initialDeposit = ((k = M.initialDeposit) == null ? void 0 : k.map((F) => o.Coin.fromPartial(F))) || [], G.proposer = M.proposer ?? "", G;
    }
  };
  function v() {
    return {
      proposalId: BigInt(0)
    };
  }
  e.MsgSubmitProposalResponse = {
    typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposalResponse",
    encode(M, G = c.BinaryWriter.create()) {
      return M.proposalId !== BigInt(0) && G.uint32(8).uint64(M.proposalId), G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = v();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.proposalId = k.uint64();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = v();
      return (0, d.isSet)(M.proposalId) && (G.proposalId = BigInt(M.proposalId.toString())), G;
    },
    toJSON(M) {
      const G = {};
      return M.proposalId !== void 0 && (G.proposalId = (M.proposalId || BigInt(0)).toString()), G;
    },
    fromPartial(M) {
      const G = v();
      return M.proposalId !== void 0 && M.proposalId !== null && (G.proposalId = BigInt(M.proposalId.toString())), G;
    }
  };
  function S() {
    return {
      proposalId: BigInt(0),
      voter: "",
      option: 0
    };
  }
  e.MsgVote = {
    typeUrl: "/cosmos.gov.v1beta1.MsgVote",
    encode(M, G = c.BinaryWriter.create()) {
      return M.proposalId !== BigInt(0) && G.uint32(8).uint64(M.proposalId), M.voter !== "" && G.uint32(18).string(M.voter), M.option !== 0 && G.uint32(24).int32(M.option), G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = S();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.proposalId = k.uint64();
            break;
          case 2:
            X.voter = k.string();
            break;
          case 3:
            X.option = k.int32();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = S();
      return (0, d.isSet)(M.proposalId) && (G.proposalId = BigInt(M.proposalId.toString())), (0, d.isSet)(M.voter) && (G.voter = String(M.voter)), (0, d.isSet)(M.option) && (G.option = (0, u.voteOptionFromJSON)(M.option)), G;
    },
    toJSON(M) {
      const G = {};
      return M.proposalId !== void 0 && (G.proposalId = (M.proposalId || BigInt(0)).toString()), M.voter !== void 0 && (G.voter = M.voter), M.option !== void 0 && (G.option = (0, u.voteOptionToJSON)(M.option)), G;
    },
    fromPartial(M) {
      const G = S();
      return M.proposalId !== void 0 && M.proposalId !== null && (G.proposalId = BigInt(M.proposalId.toString())), G.voter = M.voter ?? "", G.option = M.option ?? 0, G;
    }
  };
  function $() {
    return {};
  }
  e.MsgVoteResponse = {
    typeUrl: "/cosmos.gov.v1beta1.MsgVoteResponse",
    encode(M, G = c.BinaryWriter.create()) {
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = $();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      return $();
    },
    toJSON(M) {
      return {};
    },
    fromPartial(M) {
      return $();
    }
  };
  function E() {
    return {
      proposalId: BigInt(0),
      voter: "",
      options: []
    };
  }
  e.MsgVoteWeighted = {
    typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
    encode(M, G = c.BinaryWriter.create()) {
      M.proposalId !== BigInt(0) && G.uint32(8).uint64(M.proposalId), M.voter !== "" && G.uint32(18).string(M.voter);
      for (const k of M.options)
        u.WeightedVoteOption.encode(k, G.uint32(26).fork()).ldelim();
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = E();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.proposalId = k.uint64();
            break;
          case 2:
            X.voter = k.string();
            break;
          case 3:
            X.options.push(u.WeightedVoteOption.decode(k, k.uint32()));
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = E();
      return (0, d.isSet)(M.proposalId) && (G.proposalId = BigInt(M.proposalId.toString())), (0, d.isSet)(M.voter) && (G.voter = String(M.voter)), Array.isArray(M == null ? void 0 : M.options) && (G.options = M.options.map((k) => u.WeightedVoteOption.fromJSON(k))), G;
    },
    toJSON(M) {
      const G = {};
      return M.proposalId !== void 0 && (G.proposalId = (M.proposalId || BigInt(0)).toString()), M.voter !== void 0 && (G.voter = M.voter), M.options ? G.options = M.options.map((k) => k ? u.WeightedVoteOption.toJSON(k) : void 0) : G.options = [], G;
    },
    fromPartial(M) {
      var k;
      const G = E();
      return M.proposalId !== void 0 && M.proposalId !== null && (G.proposalId = BigInt(M.proposalId.toString())), G.voter = M.voter ?? "", G.options = ((k = M.options) == null ? void 0 : k.map((F) => u.WeightedVoteOption.fromPartial(F))) || [], G;
    }
  };
  function O() {
    return {};
  }
  e.MsgVoteWeightedResponse = {
    typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeightedResponse",
    encode(M, G = c.BinaryWriter.create()) {
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = O();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      return O();
    },
    toJSON(M) {
      return {};
    },
    fromPartial(M) {
      return O();
    }
  };
  function T() {
    return {
      proposalId: BigInt(0),
      depositor: "",
      amount: []
    };
  }
  e.MsgDeposit = {
    typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
    encode(M, G = c.BinaryWriter.create()) {
      M.proposalId !== BigInt(0) && G.uint32(8).uint64(M.proposalId), M.depositor !== "" && G.uint32(18).string(M.depositor);
      for (const k of M.amount)
        o.Coin.encode(k, G.uint32(26).fork()).ldelim();
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = T();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.proposalId = k.uint64();
            break;
          case 2:
            X.depositor = k.string();
            break;
          case 3:
            X.amount.push(o.Coin.decode(k, k.uint32()));
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = T();
      return (0, d.isSet)(M.proposalId) && (G.proposalId = BigInt(M.proposalId.toString())), (0, d.isSet)(M.depositor) && (G.depositor = String(M.depositor)), Array.isArray(M == null ? void 0 : M.amount) && (G.amount = M.amount.map((k) => o.Coin.fromJSON(k))), G;
    },
    toJSON(M) {
      const G = {};
      return M.proposalId !== void 0 && (G.proposalId = (M.proposalId || BigInt(0)).toString()), M.depositor !== void 0 && (G.depositor = M.depositor), M.amount ? G.amount = M.amount.map((k) => k ? o.Coin.toJSON(k) : void 0) : G.amount = [], G;
    },
    fromPartial(M) {
      var k;
      const G = T();
      return M.proposalId !== void 0 && M.proposalId !== null && (G.proposalId = BigInt(M.proposalId.toString())), G.depositor = M.depositor ?? "", G.amount = ((k = M.amount) == null ? void 0 : k.map((F) => o.Coin.fromPartial(F))) || [], G;
    }
  };
  function y() {
    return {};
  }
  e.MsgDepositResponse = {
    typeUrl: "/cosmos.gov.v1beta1.MsgDepositResponse",
    encode(M, G = c.BinaryWriter.create()) {
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = y();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      return y();
    },
    toJSON(M) {
      return {};
    },
    fromPartial(M) {
      return y();
    }
  };
  class V {
    constructor(G) {
      this.rpc = G, this.SubmitProposal = this.SubmitProposal.bind(this), this.Vote = this.Vote.bind(this), this.VoteWeighted = this.VoteWeighted.bind(this), this.Deposit = this.Deposit.bind(this);
    }
    SubmitProposal(G) {
      const k = e.MsgSubmitProposal.encode(G).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", k).then((X) => e.MsgSubmitProposalResponse.decode(new c.BinaryReader(X)));
    }
    Vote(G) {
      const k = e.MsgVote.encode(G).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", k).then((X) => e.MsgVoteResponse.decode(new c.BinaryReader(X)));
    }
    VoteWeighted(G) {
      const k = e.MsgVoteWeighted.encode(G).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", k).then((X) => e.MsgVoteWeightedResponse.decode(new c.BinaryReader(X)));
    }
    Deposit(G) {
      const k = e.MsgDeposit.encode(G).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", k).then((X) => e.MsgDepositResponse.decode(new c.BinaryReader(X)));
    }
  }
  e.MsgClientImpl = V;
})(tx$j);
Object.defineProperty(messages$e, "__esModule", { value: !0 });
messages$e.isMsgVoteWeightedEncodeObject = messages$e.isMsgVoteEncodeObject = messages$e.isMsgSubmitProposalEncodeObject = messages$e.isMsgDepositEncodeObject = messages$e.govTypes = void 0;
const tx_1$m = tx$k, tx_2$6 = tx$j;
messages$e.govTypes = [
  ["/cosmos.gov.v1.MsgDeposit", tx_1$m.MsgDeposit],
  ["/cosmos.gov.v1.MsgSubmitProposal", tx_1$m.MsgSubmitProposal],
  ["/cosmos.gov.v1.MsgUpdateParams", tx_1$m.MsgUpdateParams],
  ["/cosmos.gov.v1.MsgVote", tx_1$m.MsgVote],
  ["/cosmos.gov.v1.MsgVoteWeighted", tx_1$m.MsgVoteWeighted],
  ["/cosmos.gov.v1beta1.MsgDeposit", tx_2$6.MsgDeposit],
  ["/cosmos.gov.v1beta1.MsgSubmitProposal", tx_2$6.MsgSubmitProposal],
  ["/cosmos.gov.v1beta1.MsgVote", tx_2$6.MsgVote],
  ["/cosmos.gov.v1beta1.MsgVoteWeighted", tx_2$6.MsgVoteWeighted]
];
function isMsgDepositEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
messages$e.isMsgDepositEncodeObject = isMsgDepositEncodeObject$1;
function isMsgSubmitProposalEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
messages$e.isMsgSubmitProposalEncodeObject = isMsgSubmitProposalEncodeObject$1;
function isMsgVoteEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
messages$e.isMsgVoteEncodeObject = isMsgVoteEncodeObject$1;
function isMsgVoteWeightedEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
messages$e.isMsgVoteWeightedEncodeObject = isMsgVoteWeightedEncodeObject$1;
var queries$h = {}, query$8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryTallyResultResponse = e.QueryTallyResultRequest = e.QueryDepositsResponse = e.QueryDepositsRequest = e.QueryDepositResponse = e.QueryDepositRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryVotesResponse = e.QueryVotesRequest = e.QueryVoteResponse = e.QueryVoteRequest = e.QueryProposalsResponse = e.QueryProposalsRequest = e.QueryProposalResponse = e.QueryProposalRequest = e.protobufPackage = void 0;
  const n = gov$4, o = pagination, u = binary, c = helpers;
  e.protobufPackage = "cosmos.gov.v1beta1";
  function d() {
    return {
      proposalId: BigInt(0)
    };
  }
  e.QueryProposalRequest = {
    typeUrl: "/cosmos.gov.v1beta1.QueryProposalRequest",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = d();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = d();
      return (0, c.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Y;
    },
    fromPartial(Q) {
      const Y = d();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Y;
    }
  };
  function m() {
    return {
      proposal: n.Proposal.fromPartial({})
    };
  }
  e.QueryProposalResponse = {
    typeUrl: "/cosmos.gov.v1beta1.QueryProposalResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.proposal !== void 0 && n.Proposal.encode(Q.proposal, Y.uint32(10).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = m();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposal = n.Proposal.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = m();
      return (0, c.isSet)(Q.proposal) && (Y.proposal = n.Proposal.fromJSON(Q.proposal)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposal !== void 0 && (Y.proposal = Q.proposal ? n.Proposal.toJSON(Q.proposal) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = m();
      return Q.proposal !== void 0 && Q.proposal !== null && (Y.proposal = n.Proposal.fromPartial(Q.proposal)), Y;
    }
  };
  function v() {
    return {
      proposalStatus: 0,
      voter: "",
      depositor: "",
      pagination: void 0
    };
  }
  e.QueryProposalsRequest = {
    typeUrl: "/cosmos.gov.v1beta1.QueryProposalsRequest",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.proposalStatus !== 0 && Y.uint32(8).int32(Q.proposalStatus), Q.voter !== "" && Y.uint32(18).string(Q.voter), Q.depositor !== "" && Y.uint32(26).string(Q.depositor), Q.pagination !== void 0 && o.PageRequest.encode(Q.pagination, Y.uint32(34).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = v();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalStatus = pe.int32();
            break;
          case 2:
            ne.voter = pe.string();
            break;
          case 3:
            ne.depositor = pe.string();
            break;
          case 4:
            ne.pagination = o.PageRequest.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = v();
      return (0, c.isSet)(Q.proposalStatus) && (Y.proposalStatus = (0, n.proposalStatusFromJSON)(Q.proposalStatus)), (0, c.isSet)(Q.voter) && (Y.voter = String(Q.voter)), (0, c.isSet)(Q.depositor) && (Y.depositor = String(Q.depositor)), (0, c.isSet)(Q.pagination) && (Y.pagination = o.PageRequest.fromJSON(Q.pagination)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalStatus !== void 0 && (Y.proposalStatus = (0, n.proposalStatusToJSON)(Q.proposalStatus)), Q.voter !== void 0 && (Y.voter = Q.voter), Q.depositor !== void 0 && (Y.depositor = Q.depositor), Q.pagination !== void 0 && (Y.pagination = Q.pagination ? o.PageRequest.toJSON(Q.pagination) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = v();
      return Y.proposalStatus = Q.proposalStatus ?? 0, Y.voter = Q.voter ?? "", Y.depositor = Q.depositor ?? "", Q.pagination !== void 0 && Q.pagination !== null && (Y.pagination = o.PageRequest.fromPartial(Q.pagination)), Y;
    }
  };
  function S() {
    return {
      proposals: [],
      pagination: void 0
    };
  }
  e.QueryProposalsResponse = {
    typeUrl: "/cosmos.gov.v1beta1.QueryProposalsResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      for (const pe of Q.proposals)
        n.Proposal.encode(pe, Y.uint32(10).fork()).ldelim();
      return Q.pagination !== void 0 && o.PageResponse.encode(Q.pagination, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = S();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposals.push(n.Proposal.decode(pe, pe.uint32()));
            break;
          case 2:
            ne.pagination = o.PageResponse.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = S();
      return Array.isArray(Q == null ? void 0 : Q.proposals) && (Y.proposals = Q.proposals.map((pe) => n.Proposal.fromJSON(pe))), (0, c.isSet)(Q.pagination) && (Y.pagination = o.PageResponse.fromJSON(Q.pagination)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposals ? Y.proposals = Q.proposals.map((pe) => pe ? n.Proposal.toJSON(pe) : void 0) : Y.proposals = [], Q.pagination !== void 0 && (Y.pagination = Q.pagination ? o.PageResponse.toJSON(Q.pagination) : void 0), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = S();
      return Y.proposals = ((pe = Q.proposals) == null ? void 0 : pe.map((oe) => n.Proposal.fromPartial(oe))) || [], Q.pagination !== void 0 && Q.pagination !== null && (Y.pagination = o.PageResponse.fromPartial(Q.pagination)), Y;
    }
  };
  function $() {
    return {
      proposalId: BigInt(0),
      voter: ""
    };
  }
  e.QueryVoteRequest = {
    typeUrl: "/cosmos.gov.v1beta1.QueryVoteRequest",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.voter !== "" && Y.uint32(18).string(Q.voter), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = $();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.voter = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = $();
      return (0, c.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, c.isSet)(Q.voter) && (Y.voter = String(Q.voter)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.voter !== void 0 && (Y.voter = Q.voter), Y;
    },
    fromPartial(Q) {
      const Y = $();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Y.voter = Q.voter ?? "", Y;
    }
  };
  function E() {
    return {
      vote: n.Vote.fromPartial({})
    };
  }
  e.QueryVoteResponse = {
    typeUrl: "/cosmos.gov.v1beta1.QueryVoteResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.vote !== void 0 && n.Vote.encode(Q.vote, Y.uint32(10).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = E();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.vote = n.Vote.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = E();
      return (0, c.isSet)(Q.vote) && (Y.vote = n.Vote.fromJSON(Q.vote)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.vote !== void 0 && (Y.vote = Q.vote ? n.Vote.toJSON(Q.vote) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = E();
      return Q.vote !== void 0 && Q.vote !== null && (Y.vote = n.Vote.fromPartial(Q.vote)), Y;
    }
  };
  function O() {
    return {
      proposalId: BigInt(0),
      pagination: void 0
    };
  }
  e.QueryVotesRequest = {
    typeUrl: "/cosmos.gov.v1beta1.QueryVotesRequest",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.pagination !== void 0 && o.PageRequest.encode(Q.pagination, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = O();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.pagination = o.PageRequest.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = O();
      return (0, c.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, c.isSet)(Q.pagination) && (Y.pagination = o.PageRequest.fromJSON(Q.pagination)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.pagination !== void 0 && (Y.pagination = Q.pagination ? o.PageRequest.toJSON(Q.pagination) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = O();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Q.pagination !== void 0 && Q.pagination !== null && (Y.pagination = o.PageRequest.fromPartial(Q.pagination)), Y;
    }
  };
  function T() {
    return {
      votes: [],
      pagination: void 0
    };
  }
  e.QueryVotesResponse = {
    typeUrl: "/cosmos.gov.v1beta1.QueryVotesResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      for (const pe of Q.votes)
        n.Vote.encode(pe, Y.uint32(10).fork()).ldelim();
      return Q.pagination !== void 0 && o.PageResponse.encode(Q.pagination, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = T();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.votes.push(n.Vote.decode(pe, pe.uint32()));
            break;
          case 2:
            ne.pagination = o.PageResponse.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = T();
      return Array.isArray(Q == null ? void 0 : Q.votes) && (Y.votes = Q.votes.map((pe) => n.Vote.fromJSON(pe))), (0, c.isSet)(Q.pagination) && (Y.pagination = o.PageResponse.fromJSON(Q.pagination)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.votes ? Y.votes = Q.votes.map((pe) => pe ? n.Vote.toJSON(pe) : void 0) : Y.votes = [], Q.pagination !== void 0 && (Y.pagination = Q.pagination ? o.PageResponse.toJSON(Q.pagination) : void 0), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = T();
      return Y.votes = ((pe = Q.votes) == null ? void 0 : pe.map((oe) => n.Vote.fromPartial(oe))) || [], Q.pagination !== void 0 && Q.pagination !== null && (Y.pagination = o.PageResponse.fromPartial(Q.pagination)), Y;
    }
  };
  function y() {
    return {
      paramsType: ""
    };
  }
  e.QueryParamsRequest = {
    typeUrl: "/cosmos.gov.v1beta1.QueryParamsRequest",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.paramsType !== "" && Y.uint32(10).string(Q.paramsType), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = y();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.paramsType = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = y();
      return (0, c.isSet)(Q.paramsType) && (Y.paramsType = String(Q.paramsType)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.paramsType !== void 0 && (Y.paramsType = Q.paramsType), Y;
    },
    fromPartial(Q) {
      const Y = y();
      return Y.paramsType = Q.paramsType ?? "", Y;
    }
  };
  function V() {
    return {
      votingParams: n.VotingParams.fromPartial({}),
      depositParams: n.DepositParams.fromPartial({}),
      tallyParams: n.TallyParams.fromPartial({})
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/cosmos.gov.v1beta1.QueryParamsResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.votingParams !== void 0 && n.VotingParams.encode(Q.votingParams, Y.uint32(10).fork()).ldelim(), Q.depositParams !== void 0 && n.DepositParams.encode(Q.depositParams, Y.uint32(18).fork()).ldelim(), Q.tallyParams !== void 0 && n.TallyParams.encode(Q.tallyParams, Y.uint32(26).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = V();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.votingParams = n.VotingParams.decode(pe, pe.uint32());
            break;
          case 2:
            ne.depositParams = n.DepositParams.decode(pe, pe.uint32());
            break;
          case 3:
            ne.tallyParams = n.TallyParams.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = V();
      return (0, c.isSet)(Q.votingParams) && (Y.votingParams = n.VotingParams.fromJSON(Q.votingParams)), (0, c.isSet)(Q.depositParams) && (Y.depositParams = n.DepositParams.fromJSON(Q.depositParams)), (0, c.isSet)(Q.tallyParams) && (Y.tallyParams = n.TallyParams.fromJSON(Q.tallyParams)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.votingParams !== void 0 && (Y.votingParams = Q.votingParams ? n.VotingParams.toJSON(Q.votingParams) : void 0), Q.depositParams !== void 0 && (Y.depositParams = Q.depositParams ? n.DepositParams.toJSON(Q.depositParams) : void 0), Q.tallyParams !== void 0 && (Y.tallyParams = Q.tallyParams ? n.TallyParams.toJSON(Q.tallyParams) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = V();
      return Q.votingParams !== void 0 && Q.votingParams !== null && (Y.votingParams = n.VotingParams.fromPartial(Q.votingParams)), Q.depositParams !== void 0 && Q.depositParams !== null && (Y.depositParams = n.DepositParams.fromPartial(Q.depositParams)), Q.tallyParams !== void 0 && Q.tallyParams !== null && (Y.tallyParams = n.TallyParams.fromPartial(Q.tallyParams)), Y;
    }
  };
  function M() {
    return {
      proposalId: BigInt(0),
      depositor: ""
    };
  }
  e.QueryDepositRequest = {
    typeUrl: "/cosmos.gov.v1beta1.QueryDepositRequest",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.depositor !== "" && Y.uint32(18).string(Q.depositor), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = M();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.depositor = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = M();
      return (0, c.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, c.isSet)(Q.depositor) && (Y.depositor = String(Q.depositor)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.depositor !== void 0 && (Y.depositor = Q.depositor), Y;
    },
    fromPartial(Q) {
      const Y = M();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Y.depositor = Q.depositor ?? "", Y;
    }
  };
  function G() {
    return {
      deposit: n.Deposit.fromPartial({})
    };
  }
  e.QueryDepositResponse = {
    typeUrl: "/cosmos.gov.v1beta1.QueryDepositResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.deposit !== void 0 && n.Deposit.encode(Q.deposit, Y.uint32(10).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = G();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.deposit = n.Deposit.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = G();
      return (0, c.isSet)(Q.deposit) && (Y.deposit = n.Deposit.fromJSON(Q.deposit)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.deposit !== void 0 && (Y.deposit = Q.deposit ? n.Deposit.toJSON(Q.deposit) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = G();
      return Q.deposit !== void 0 && Q.deposit !== null && (Y.deposit = n.Deposit.fromPartial(Q.deposit)), Y;
    }
  };
  function k() {
    return {
      proposalId: BigInt(0),
      pagination: void 0
    };
  }
  e.QueryDepositsRequest = {
    typeUrl: "/cosmos.gov.v1beta1.QueryDepositsRequest",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Q.pagination !== void 0 && o.PageRequest.encode(Q.pagination, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = k();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          case 2:
            ne.pagination = o.PageRequest.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = k();
      return (0, c.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), (0, c.isSet)(Q.pagination) && (Y.pagination = o.PageRequest.fromJSON(Q.pagination)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Q.pagination !== void 0 && (Y.pagination = Q.pagination ? o.PageRequest.toJSON(Q.pagination) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = k();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Q.pagination !== void 0 && Q.pagination !== null && (Y.pagination = o.PageRequest.fromPartial(Q.pagination)), Y;
    }
  };
  function F() {
    return {
      deposits: [],
      pagination: void 0
    };
  }
  e.QueryDepositsResponse = {
    typeUrl: "/cosmos.gov.v1beta1.QueryDepositsResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      for (const pe of Q.deposits)
        n.Deposit.encode(pe, Y.uint32(10).fork()).ldelim();
      return Q.pagination !== void 0 && o.PageResponse.encode(Q.pagination, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = F();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.deposits.push(n.Deposit.decode(pe, pe.uint32()));
            break;
          case 2:
            ne.pagination = o.PageResponse.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = F();
      return Array.isArray(Q == null ? void 0 : Q.deposits) && (Y.deposits = Q.deposits.map((pe) => n.Deposit.fromJSON(pe))), (0, c.isSet)(Q.pagination) && (Y.pagination = o.PageResponse.fromJSON(Q.pagination)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.deposits ? Y.deposits = Q.deposits.map((pe) => pe ? n.Deposit.toJSON(pe) : void 0) : Y.deposits = [], Q.pagination !== void 0 && (Y.pagination = Q.pagination ? o.PageResponse.toJSON(Q.pagination) : void 0), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = F();
      return Y.deposits = ((pe = Q.deposits) == null ? void 0 : pe.map((oe) => n.Deposit.fromPartial(oe))) || [], Q.pagination !== void 0 && Q.pagination !== null && (Y.pagination = o.PageResponse.fromPartial(Q.pagination)), Y;
    }
  };
  function X() {
    return {
      proposalId: BigInt(0)
    };
  }
  e.QueryTallyResultRequest = {
    typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultRequest",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.proposalId !== BigInt(0) && Y.uint32(8).uint64(Q.proposalId), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = X();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.proposalId = pe.uint64();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = X();
      return (0, c.isSet)(Q.proposalId) && (Y.proposalId = BigInt(Q.proposalId.toString())), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.proposalId !== void 0 && (Y.proposalId = (Q.proposalId || BigInt(0)).toString()), Y;
    },
    fromPartial(Q) {
      const Y = X();
      return Q.proposalId !== void 0 && Q.proposalId !== null && (Y.proposalId = BigInt(Q.proposalId.toString())), Y;
    }
  };
  function ee() {
    return {
      tally: n.TallyResult.fromPartial({})
    };
  }
  e.QueryTallyResultResponse = {
    typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.tally !== void 0 && n.TallyResult.encode(Q.tally, Y.uint32(10).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ee();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.tally = n.TallyResult.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = ee();
      return (0, c.isSet)(Q.tally) && (Y.tally = n.TallyResult.fromJSON(Q.tally)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.tally !== void 0 && (Y.tally = Q.tally ? n.TallyResult.toJSON(Q.tally) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = ee();
      return Q.tally !== void 0 && Q.tally !== null && (Y.tally = n.TallyResult.fromPartial(Q.tally)), Y;
    }
  };
  class ue {
    constructor(Y) {
      this.rpc = Y, this.Proposal = this.Proposal.bind(this), this.Proposals = this.Proposals.bind(this), this.Vote = this.Vote.bind(this), this.Votes = this.Votes.bind(this), this.Params = this.Params.bind(this), this.Deposit = this.Deposit.bind(this), this.Deposits = this.Deposits.bind(this), this.TallyResult = this.TallyResult.bind(this);
    }
    Proposal(Y) {
      const pe = e.QueryProposalRequest.encode(Y).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", pe).then((ne) => e.QueryProposalResponse.decode(new u.BinaryReader(ne)));
    }
    Proposals(Y) {
      const pe = e.QueryProposalsRequest.encode(Y).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", pe).then((ne) => e.QueryProposalsResponse.decode(new u.BinaryReader(ne)));
    }
    Vote(Y) {
      const pe = e.QueryVoteRequest.encode(Y).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", pe).then((ne) => e.QueryVoteResponse.decode(new u.BinaryReader(ne)));
    }
    Votes(Y) {
      const pe = e.QueryVotesRequest.encode(Y).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", pe).then((ne) => e.QueryVotesResponse.decode(new u.BinaryReader(ne)));
    }
    Params(Y) {
      const pe = e.QueryParamsRequest.encode(Y).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Params", pe).then((ne) => e.QueryParamsResponse.decode(new u.BinaryReader(ne)));
    }
    Deposit(Y) {
      const pe = e.QueryDepositRequest.encode(Y).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", pe).then((ne) => e.QueryDepositResponse.decode(new u.BinaryReader(ne)));
    }
    Deposits(Y) {
      const pe = e.QueryDepositsRequest.encode(Y).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", pe).then((ne) => e.QueryDepositsResponse.decode(new u.BinaryReader(ne)));
    }
    TallyResult(Y) {
      const pe = e.QueryTallyResultRequest.encode(Y).finish();
      return this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", pe).then((ne) => e.QueryTallyResultResponse.decode(new u.BinaryReader(ne)));
    }
  }
  e.QueryClientImpl = ue;
})(query$8);
Object.defineProperty(queries$h, "__esModule", { value: !0 });
queries$h.setupGovExtension = void 0;
const query_1$f = query$8, queryclient_1$j = queryclient$3;
function setupGovExtension$1(e) {
  const n = (0, queryclient_1$j.createProtobufRpcClient)(e), o = new query_1$f.QueryClientImpl(n);
  return {
    gov: {
      params: async (u) => await o.Params({ paramsType: u }),
      proposals: async (u, c, d, m) => await o.Proposals({
        proposalStatus: u,
        depositor: c,
        voter: d,
        pagination: (0, queryclient_1$j.createPagination)(m)
      }),
      proposal: async (u) => await o.Proposal({ proposalId: (0, queryclient_1$j.longify)(u) }),
      deposits: async (u, c) => await o.Deposits({
        proposalId: (0, queryclient_1$j.longify)(u),
        pagination: (0, queryclient_1$j.createPagination)(c)
      }),
      deposit: async (u, c) => await o.Deposit({
        proposalId: (0, queryclient_1$j.longify)(u),
        depositor: c
      }),
      tally: async (u) => await o.TallyResult({
        proposalId: (0, queryclient_1$j.longify)(u)
      }),
      votes: async (u, c) => await o.Votes({
        proposalId: (0, queryclient_1$j.longify)(u),
        pagination: (0, queryclient_1$j.createPagination)(c)
      }),
      vote: async (u, c) => await o.Vote({
        proposalId: (0, queryclient_1$j.longify)(u),
        voter: c
      })
    }
  };
}
queries$h.setupGovExtension = setupGovExtension$1;
var aminomessages$g = {};
Object.defineProperty(aminomessages$g, "__esModule", { value: !0 });
aminomessages$g.createGroupAminoConverters = void 0;
function createGroupAminoConverters() {
  return {};
}
aminomessages$g.createGroupAminoConverters = createGroupAminoConverters;
var messages$d = {}, tx$i = {}, types$f = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Vote = e.TallyResult = e.Proposal = e.GroupPolicyInfo = e.GroupMember = e.GroupInfo = e.DecisionPolicyWindows = e.PercentageDecisionPolicy = e.ThresholdDecisionPolicy = e.MemberRequest = e.Member = e.proposalExecutorResultToJSON = e.proposalExecutorResultFromJSON = e.ProposalExecutorResult = e.proposalStatusToJSON = e.proposalStatusFromJSON = e.ProposalStatus = e.voteOptionToJSON = e.voteOptionFromJSON = e.VoteOption = e.protobufPackage = void 0;
  const n = timestamp$1, o = duration$1, u = any$1, c = binary, d = helpers;
  e.protobufPackage = "cosmos.group.v1";
  var m;
  (function(ne) {
    ne[ne.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", ne[ne.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", ne[ne.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", ne[ne.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", ne[ne.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", ne[ne.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(m || (e.VoteOption = m = {}));
  function v(ne) {
    switch (ne) {
      case 0:
      case "VOTE_OPTION_UNSPECIFIED":
        return m.VOTE_OPTION_UNSPECIFIED;
      case 1:
      case "VOTE_OPTION_YES":
        return m.VOTE_OPTION_YES;
      case 2:
      case "VOTE_OPTION_ABSTAIN":
        return m.VOTE_OPTION_ABSTAIN;
      case 3:
      case "VOTE_OPTION_NO":
        return m.VOTE_OPTION_NO;
      case 4:
      case "VOTE_OPTION_NO_WITH_VETO":
        return m.VOTE_OPTION_NO_WITH_VETO;
      case -1:
      case "UNRECOGNIZED":
      default:
        return m.UNRECOGNIZED;
    }
  }
  e.voteOptionFromJSON = v;
  function S(ne) {
    switch (ne) {
      case m.VOTE_OPTION_UNSPECIFIED:
        return "VOTE_OPTION_UNSPECIFIED";
      case m.VOTE_OPTION_YES:
        return "VOTE_OPTION_YES";
      case m.VOTE_OPTION_ABSTAIN:
        return "VOTE_OPTION_ABSTAIN";
      case m.VOTE_OPTION_NO:
        return "VOTE_OPTION_NO";
      case m.VOTE_OPTION_NO_WITH_VETO:
        return "VOTE_OPTION_NO_WITH_VETO";
      case m.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.voteOptionToJSON = S;
  var $;
  (function(ne) {
    ne[ne.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", ne[ne.PROPOSAL_STATUS_SUBMITTED = 1] = "PROPOSAL_STATUS_SUBMITTED", ne[ne.PROPOSAL_STATUS_ACCEPTED = 2] = "PROPOSAL_STATUS_ACCEPTED", ne[ne.PROPOSAL_STATUS_REJECTED = 3] = "PROPOSAL_STATUS_REJECTED", ne[ne.PROPOSAL_STATUS_ABORTED = 4] = "PROPOSAL_STATUS_ABORTED", ne[ne.PROPOSAL_STATUS_WITHDRAWN = 5] = "PROPOSAL_STATUS_WITHDRAWN", ne[ne.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })($ || (e.ProposalStatus = $ = {}));
  function E(ne) {
    switch (ne) {
      case 0:
      case "PROPOSAL_STATUS_UNSPECIFIED":
        return $.PROPOSAL_STATUS_UNSPECIFIED;
      case 1:
      case "PROPOSAL_STATUS_SUBMITTED":
        return $.PROPOSAL_STATUS_SUBMITTED;
      case 2:
      case "PROPOSAL_STATUS_ACCEPTED":
        return $.PROPOSAL_STATUS_ACCEPTED;
      case 3:
      case "PROPOSAL_STATUS_REJECTED":
        return $.PROPOSAL_STATUS_REJECTED;
      case 4:
      case "PROPOSAL_STATUS_ABORTED":
        return $.PROPOSAL_STATUS_ABORTED;
      case 5:
      case "PROPOSAL_STATUS_WITHDRAWN":
        return $.PROPOSAL_STATUS_WITHDRAWN;
      case -1:
      case "UNRECOGNIZED":
      default:
        return $.UNRECOGNIZED;
    }
  }
  e.proposalStatusFromJSON = E;
  function O(ne) {
    switch (ne) {
      case $.PROPOSAL_STATUS_UNSPECIFIED:
        return "PROPOSAL_STATUS_UNSPECIFIED";
      case $.PROPOSAL_STATUS_SUBMITTED:
        return "PROPOSAL_STATUS_SUBMITTED";
      case $.PROPOSAL_STATUS_ACCEPTED:
        return "PROPOSAL_STATUS_ACCEPTED";
      case $.PROPOSAL_STATUS_REJECTED:
        return "PROPOSAL_STATUS_REJECTED";
      case $.PROPOSAL_STATUS_ABORTED:
        return "PROPOSAL_STATUS_ABORTED";
      case $.PROPOSAL_STATUS_WITHDRAWN:
        return "PROPOSAL_STATUS_WITHDRAWN";
      case $.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.proposalStatusToJSON = O;
  var T;
  (function(ne) {
    ne[ne.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED = 0] = "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED", ne[ne.PROPOSAL_EXECUTOR_RESULT_NOT_RUN = 1] = "PROPOSAL_EXECUTOR_RESULT_NOT_RUN", ne[ne.PROPOSAL_EXECUTOR_RESULT_SUCCESS = 2] = "PROPOSAL_EXECUTOR_RESULT_SUCCESS", ne[ne.PROPOSAL_EXECUTOR_RESULT_FAILURE = 3] = "PROPOSAL_EXECUTOR_RESULT_FAILURE", ne[ne.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(T || (e.ProposalExecutorResult = T = {}));
  function y(ne) {
    switch (ne) {
      case 0:
      case "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED":
        return T.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED;
      case 1:
      case "PROPOSAL_EXECUTOR_RESULT_NOT_RUN":
        return T.PROPOSAL_EXECUTOR_RESULT_NOT_RUN;
      case 2:
      case "PROPOSAL_EXECUTOR_RESULT_SUCCESS":
        return T.PROPOSAL_EXECUTOR_RESULT_SUCCESS;
      case 3:
      case "PROPOSAL_EXECUTOR_RESULT_FAILURE":
        return T.PROPOSAL_EXECUTOR_RESULT_FAILURE;
      case -1:
      case "UNRECOGNIZED":
      default:
        return T.UNRECOGNIZED;
    }
  }
  e.proposalExecutorResultFromJSON = y;
  function V(ne) {
    switch (ne) {
      case T.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED:
        return "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
      case T.PROPOSAL_EXECUTOR_RESULT_NOT_RUN:
        return "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
      case T.PROPOSAL_EXECUTOR_RESULT_SUCCESS:
        return "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
      case T.PROPOSAL_EXECUTOR_RESULT_FAILURE:
        return "PROPOSAL_EXECUTOR_RESULT_FAILURE";
      case T.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.proposalExecutorResultToJSON = V;
  function M() {
    return {
      address: "",
      weight: "",
      metadata: "",
      addedAt: n.Timestamp.fromPartial({})
    };
  }
  e.Member = {
    typeUrl: "/cosmos.group.v1.Member",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.address !== "" && H.uint32(10).string(ne.address), ne.weight !== "" && H.uint32(18).string(ne.weight), ne.metadata !== "" && H.uint32(26).string(ne.metadata), ne.addedAt !== void 0 && n.Timestamp.encode(ne.addedAt, H.uint32(34).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = M();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.address = C.string();
            break;
          case 2:
            P.weight = C.string();
            break;
          case 3:
            P.metadata = C.string();
            break;
          case 4:
            P.addedAt = n.Timestamp.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = M();
      return (0, d.isSet)(ne.address) && (H.address = String(ne.address)), (0, d.isSet)(ne.weight) && (H.weight = String(ne.weight)), (0, d.isSet)(ne.metadata) && (H.metadata = String(ne.metadata)), (0, d.isSet)(ne.addedAt) && (H.addedAt = (0, d.fromJsonTimestamp)(ne.addedAt)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.address !== void 0 && (H.address = ne.address), ne.weight !== void 0 && (H.weight = ne.weight), ne.metadata !== void 0 && (H.metadata = ne.metadata), ne.addedAt !== void 0 && (H.addedAt = (0, d.fromTimestamp)(ne.addedAt).toISOString()), H;
    },
    fromPartial(ne) {
      const H = M();
      return H.address = ne.address ?? "", H.weight = ne.weight ?? "", H.metadata = ne.metadata ?? "", ne.addedAt !== void 0 && ne.addedAt !== null && (H.addedAt = n.Timestamp.fromPartial(ne.addedAt)), H;
    }
  };
  function G() {
    return {
      address: "",
      weight: "",
      metadata: ""
    };
  }
  e.MemberRequest = {
    typeUrl: "/cosmos.group.v1.MemberRequest",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.address !== "" && H.uint32(10).string(ne.address), ne.weight !== "" && H.uint32(18).string(ne.weight), ne.metadata !== "" && H.uint32(26).string(ne.metadata), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = G();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.address = C.string();
            break;
          case 2:
            P.weight = C.string();
            break;
          case 3:
            P.metadata = C.string();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = G();
      return (0, d.isSet)(ne.address) && (H.address = String(ne.address)), (0, d.isSet)(ne.weight) && (H.weight = String(ne.weight)), (0, d.isSet)(ne.metadata) && (H.metadata = String(ne.metadata)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.address !== void 0 && (H.address = ne.address), ne.weight !== void 0 && (H.weight = ne.weight), ne.metadata !== void 0 && (H.metadata = ne.metadata), H;
    },
    fromPartial(ne) {
      const H = G();
      return H.address = ne.address ?? "", H.weight = ne.weight ?? "", H.metadata = ne.metadata ?? "", H;
    }
  };
  function k() {
    return {
      threshold: "",
      windows: void 0
    };
  }
  e.ThresholdDecisionPolicy = {
    typeUrl: "/cosmos.group.v1.ThresholdDecisionPolicy",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.threshold !== "" && H.uint32(10).string(ne.threshold), ne.windows !== void 0 && e.DecisionPolicyWindows.encode(ne.windows, H.uint32(18).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = k();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.threshold = C.string();
            break;
          case 2:
            P.windows = e.DecisionPolicyWindows.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = k();
      return (0, d.isSet)(ne.threshold) && (H.threshold = String(ne.threshold)), (0, d.isSet)(ne.windows) && (H.windows = e.DecisionPolicyWindows.fromJSON(ne.windows)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.threshold !== void 0 && (H.threshold = ne.threshold), ne.windows !== void 0 && (H.windows = ne.windows ? e.DecisionPolicyWindows.toJSON(ne.windows) : void 0), H;
    },
    fromPartial(ne) {
      const H = k();
      return H.threshold = ne.threshold ?? "", ne.windows !== void 0 && ne.windows !== null && (H.windows = e.DecisionPolicyWindows.fromPartial(ne.windows)), H;
    }
  };
  function F() {
    return {
      percentage: "",
      windows: void 0
    };
  }
  e.PercentageDecisionPolicy = {
    typeUrl: "/cosmos.group.v1.PercentageDecisionPolicy",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.percentage !== "" && H.uint32(10).string(ne.percentage), ne.windows !== void 0 && e.DecisionPolicyWindows.encode(ne.windows, H.uint32(18).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = F();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.percentage = C.string();
            break;
          case 2:
            P.windows = e.DecisionPolicyWindows.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = F();
      return (0, d.isSet)(ne.percentage) && (H.percentage = String(ne.percentage)), (0, d.isSet)(ne.windows) && (H.windows = e.DecisionPolicyWindows.fromJSON(ne.windows)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.percentage !== void 0 && (H.percentage = ne.percentage), ne.windows !== void 0 && (H.windows = ne.windows ? e.DecisionPolicyWindows.toJSON(ne.windows) : void 0), H;
    },
    fromPartial(ne) {
      const H = F();
      return H.percentage = ne.percentage ?? "", ne.windows !== void 0 && ne.windows !== null && (H.windows = e.DecisionPolicyWindows.fromPartial(ne.windows)), H;
    }
  };
  function X() {
    return {
      votingPeriod: o.Duration.fromPartial({}),
      minExecutionPeriod: o.Duration.fromPartial({})
    };
  }
  e.DecisionPolicyWindows = {
    typeUrl: "/cosmos.group.v1.DecisionPolicyWindows",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.votingPeriod !== void 0 && o.Duration.encode(ne.votingPeriod, H.uint32(10).fork()).ldelim(), ne.minExecutionPeriod !== void 0 && o.Duration.encode(ne.minExecutionPeriod, H.uint32(18).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = X();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.votingPeriod = o.Duration.decode(C, C.uint32());
            break;
          case 2:
            P.minExecutionPeriod = o.Duration.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = X();
      return (0, d.isSet)(ne.votingPeriod) && (H.votingPeriod = o.Duration.fromJSON(ne.votingPeriod)), (0, d.isSet)(ne.minExecutionPeriod) && (H.minExecutionPeriod = o.Duration.fromJSON(ne.minExecutionPeriod)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.votingPeriod !== void 0 && (H.votingPeriod = ne.votingPeriod ? o.Duration.toJSON(ne.votingPeriod) : void 0), ne.minExecutionPeriod !== void 0 && (H.minExecutionPeriod = ne.minExecutionPeriod ? o.Duration.toJSON(ne.minExecutionPeriod) : void 0), H;
    },
    fromPartial(ne) {
      const H = X();
      return ne.votingPeriod !== void 0 && ne.votingPeriod !== null && (H.votingPeriod = o.Duration.fromPartial(ne.votingPeriod)), ne.minExecutionPeriod !== void 0 && ne.minExecutionPeriod !== null && (H.minExecutionPeriod = o.Duration.fromPartial(ne.minExecutionPeriod)), H;
    }
  };
  function ee() {
    return {
      id: BigInt(0),
      admin: "",
      metadata: "",
      version: BigInt(0),
      totalWeight: "",
      createdAt: n.Timestamp.fromPartial({})
    };
  }
  e.GroupInfo = {
    typeUrl: "/cosmos.group.v1.GroupInfo",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.id !== BigInt(0) && H.uint32(8).uint64(ne.id), ne.admin !== "" && H.uint32(18).string(ne.admin), ne.metadata !== "" && H.uint32(26).string(ne.metadata), ne.version !== BigInt(0) && H.uint32(32).uint64(ne.version), ne.totalWeight !== "" && H.uint32(42).string(ne.totalWeight), ne.createdAt !== void 0 && n.Timestamp.encode(ne.createdAt, H.uint32(50).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = ee();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.id = C.uint64();
            break;
          case 2:
            P.admin = C.string();
            break;
          case 3:
            P.metadata = C.string();
            break;
          case 4:
            P.version = C.uint64();
            break;
          case 5:
            P.totalWeight = C.string();
            break;
          case 6:
            P.createdAt = n.Timestamp.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = ee();
      return (0, d.isSet)(ne.id) && (H.id = BigInt(ne.id.toString())), (0, d.isSet)(ne.admin) && (H.admin = String(ne.admin)), (0, d.isSet)(ne.metadata) && (H.metadata = String(ne.metadata)), (0, d.isSet)(ne.version) && (H.version = BigInt(ne.version.toString())), (0, d.isSet)(ne.totalWeight) && (H.totalWeight = String(ne.totalWeight)), (0, d.isSet)(ne.createdAt) && (H.createdAt = (0, d.fromJsonTimestamp)(ne.createdAt)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.id !== void 0 && (H.id = (ne.id || BigInt(0)).toString()), ne.admin !== void 0 && (H.admin = ne.admin), ne.metadata !== void 0 && (H.metadata = ne.metadata), ne.version !== void 0 && (H.version = (ne.version || BigInt(0)).toString()), ne.totalWeight !== void 0 && (H.totalWeight = ne.totalWeight), ne.createdAt !== void 0 && (H.createdAt = (0, d.fromTimestamp)(ne.createdAt).toISOString()), H;
    },
    fromPartial(ne) {
      const H = ee();
      return ne.id !== void 0 && ne.id !== null && (H.id = BigInt(ne.id.toString())), H.admin = ne.admin ?? "", H.metadata = ne.metadata ?? "", ne.version !== void 0 && ne.version !== null && (H.version = BigInt(ne.version.toString())), H.totalWeight = ne.totalWeight ?? "", ne.createdAt !== void 0 && ne.createdAt !== null && (H.createdAt = n.Timestamp.fromPartial(ne.createdAt)), H;
    }
  };
  function ue() {
    return {
      groupId: BigInt(0),
      member: void 0
    };
  }
  e.GroupMember = {
    typeUrl: "/cosmos.group.v1.GroupMember",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.groupId !== BigInt(0) && H.uint32(8).uint64(ne.groupId), ne.member !== void 0 && e.Member.encode(ne.member, H.uint32(18).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = ue();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.groupId = C.uint64();
            break;
          case 2:
            P.member = e.Member.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = ue();
      return (0, d.isSet)(ne.groupId) && (H.groupId = BigInt(ne.groupId.toString())), (0, d.isSet)(ne.member) && (H.member = e.Member.fromJSON(ne.member)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.groupId !== void 0 && (H.groupId = (ne.groupId || BigInt(0)).toString()), ne.member !== void 0 && (H.member = ne.member ? e.Member.toJSON(ne.member) : void 0), H;
    },
    fromPartial(ne) {
      const H = ue();
      return ne.groupId !== void 0 && ne.groupId !== null && (H.groupId = BigInt(ne.groupId.toString())), ne.member !== void 0 && ne.member !== null && (H.member = e.Member.fromPartial(ne.member)), H;
    }
  };
  function Q() {
    return {
      address: "",
      groupId: BigInt(0),
      admin: "",
      metadata: "",
      version: BigInt(0),
      decisionPolicy: void 0,
      createdAt: n.Timestamp.fromPartial({})
    };
  }
  e.GroupPolicyInfo = {
    typeUrl: "/cosmos.group.v1.GroupPolicyInfo",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.address !== "" && H.uint32(10).string(ne.address), ne.groupId !== BigInt(0) && H.uint32(16).uint64(ne.groupId), ne.admin !== "" && H.uint32(26).string(ne.admin), ne.metadata !== "" && H.uint32(34).string(ne.metadata), ne.version !== BigInt(0) && H.uint32(40).uint64(ne.version), ne.decisionPolicy !== void 0 && u.Any.encode(ne.decisionPolicy, H.uint32(50).fork()).ldelim(), ne.createdAt !== void 0 && n.Timestamp.encode(ne.createdAt, H.uint32(58).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = Q();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.address = C.string();
            break;
          case 2:
            P.groupId = C.uint64();
            break;
          case 3:
            P.admin = C.string();
            break;
          case 4:
            P.metadata = C.string();
            break;
          case 5:
            P.version = C.uint64();
            break;
          case 6:
            P.decisionPolicy = u.Any.decode(C, C.uint32());
            break;
          case 7:
            P.createdAt = n.Timestamp.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = Q();
      return (0, d.isSet)(ne.address) && (H.address = String(ne.address)), (0, d.isSet)(ne.groupId) && (H.groupId = BigInt(ne.groupId.toString())), (0, d.isSet)(ne.admin) && (H.admin = String(ne.admin)), (0, d.isSet)(ne.metadata) && (H.metadata = String(ne.metadata)), (0, d.isSet)(ne.version) && (H.version = BigInt(ne.version.toString())), (0, d.isSet)(ne.decisionPolicy) && (H.decisionPolicy = u.Any.fromJSON(ne.decisionPolicy)), (0, d.isSet)(ne.createdAt) && (H.createdAt = (0, d.fromJsonTimestamp)(ne.createdAt)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.address !== void 0 && (H.address = ne.address), ne.groupId !== void 0 && (H.groupId = (ne.groupId || BigInt(0)).toString()), ne.admin !== void 0 && (H.admin = ne.admin), ne.metadata !== void 0 && (H.metadata = ne.metadata), ne.version !== void 0 && (H.version = (ne.version || BigInt(0)).toString()), ne.decisionPolicy !== void 0 && (H.decisionPolicy = ne.decisionPolicy ? u.Any.toJSON(ne.decisionPolicy) : void 0), ne.createdAt !== void 0 && (H.createdAt = (0, d.fromTimestamp)(ne.createdAt).toISOString()), H;
    },
    fromPartial(ne) {
      const H = Q();
      return H.address = ne.address ?? "", ne.groupId !== void 0 && ne.groupId !== null && (H.groupId = BigInt(ne.groupId.toString())), H.admin = ne.admin ?? "", H.metadata = ne.metadata ?? "", ne.version !== void 0 && ne.version !== null && (H.version = BigInt(ne.version.toString())), ne.decisionPolicy !== void 0 && ne.decisionPolicy !== null && (H.decisionPolicy = u.Any.fromPartial(ne.decisionPolicy)), ne.createdAt !== void 0 && ne.createdAt !== null && (H.createdAt = n.Timestamp.fromPartial(ne.createdAt)), H;
    }
  };
  function Y() {
    return {
      id: BigInt(0),
      groupPolicyAddress: "",
      metadata: "",
      proposers: [],
      submitTime: n.Timestamp.fromPartial({}),
      groupVersion: BigInt(0),
      groupPolicyVersion: BigInt(0),
      status: 0,
      finalTallyResult: e.TallyResult.fromPartial({}),
      votingPeriodEnd: n.Timestamp.fromPartial({}),
      executorResult: 0,
      messages: [],
      title: "",
      summary: ""
    };
  }
  e.Proposal = {
    typeUrl: "/cosmos.group.v1.Proposal",
    encode(ne, H = c.BinaryWriter.create()) {
      ne.id !== BigInt(0) && H.uint32(8).uint64(ne.id), ne.groupPolicyAddress !== "" && H.uint32(18).string(ne.groupPolicyAddress), ne.metadata !== "" && H.uint32(26).string(ne.metadata);
      for (const C of ne.proposers)
        H.uint32(34).string(C);
      ne.submitTime !== void 0 && n.Timestamp.encode(ne.submitTime, H.uint32(42).fork()).ldelim(), ne.groupVersion !== BigInt(0) && H.uint32(48).uint64(ne.groupVersion), ne.groupPolicyVersion !== BigInt(0) && H.uint32(56).uint64(ne.groupPolicyVersion), ne.status !== 0 && H.uint32(64).int32(ne.status), ne.finalTallyResult !== void 0 && e.TallyResult.encode(ne.finalTallyResult, H.uint32(74).fork()).ldelim(), ne.votingPeriodEnd !== void 0 && n.Timestamp.encode(ne.votingPeriodEnd, H.uint32(82).fork()).ldelim(), ne.executorResult !== 0 && H.uint32(88).int32(ne.executorResult);
      for (const C of ne.messages)
        u.Any.encode(C, H.uint32(98).fork()).ldelim();
      return ne.title !== "" && H.uint32(106).string(ne.title), ne.summary !== "" && H.uint32(114).string(ne.summary), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = Y();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.id = C.uint64();
            break;
          case 2:
            P.groupPolicyAddress = C.string();
            break;
          case 3:
            P.metadata = C.string();
            break;
          case 4:
            P.proposers.push(C.string());
            break;
          case 5:
            P.submitTime = n.Timestamp.decode(C, C.uint32());
            break;
          case 6:
            P.groupVersion = C.uint64();
            break;
          case 7:
            P.groupPolicyVersion = C.uint64();
            break;
          case 8:
            P.status = C.int32();
            break;
          case 9:
            P.finalTallyResult = e.TallyResult.decode(C, C.uint32());
            break;
          case 10:
            P.votingPeriodEnd = n.Timestamp.decode(C, C.uint32());
            break;
          case 11:
            P.executorResult = C.int32();
            break;
          case 12:
            P.messages.push(u.Any.decode(C, C.uint32()));
            break;
          case 13:
            P.title = C.string();
            break;
          case 14:
            P.summary = C.string();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = Y();
      return (0, d.isSet)(ne.id) && (H.id = BigInt(ne.id.toString())), (0, d.isSet)(ne.groupPolicyAddress) && (H.groupPolicyAddress = String(ne.groupPolicyAddress)), (0, d.isSet)(ne.metadata) && (H.metadata = String(ne.metadata)), Array.isArray(ne == null ? void 0 : ne.proposers) && (H.proposers = ne.proposers.map((C) => String(C))), (0, d.isSet)(ne.submitTime) && (H.submitTime = (0, d.fromJsonTimestamp)(ne.submitTime)), (0, d.isSet)(ne.groupVersion) && (H.groupVersion = BigInt(ne.groupVersion.toString())), (0, d.isSet)(ne.groupPolicyVersion) && (H.groupPolicyVersion = BigInt(ne.groupPolicyVersion.toString())), (0, d.isSet)(ne.status) && (H.status = E(ne.status)), (0, d.isSet)(ne.finalTallyResult) && (H.finalTallyResult = e.TallyResult.fromJSON(ne.finalTallyResult)), (0, d.isSet)(ne.votingPeriodEnd) && (H.votingPeriodEnd = (0, d.fromJsonTimestamp)(ne.votingPeriodEnd)), (0, d.isSet)(ne.executorResult) && (H.executorResult = y(ne.executorResult)), Array.isArray(ne == null ? void 0 : ne.messages) && (H.messages = ne.messages.map((C) => u.Any.fromJSON(C))), (0, d.isSet)(ne.title) && (H.title = String(ne.title)), (0, d.isSet)(ne.summary) && (H.summary = String(ne.summary)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.id !== void 0 && (H.id = (ne.id || BigInt(0)).toString()), ne.groupPolicyAddress !== void 0 && (H.groupPolicyAddress = ne.groupPolicyAddress), ne.metadata !== void 0 && (H.metadata = ne.metadata), ne.proposers ? H.proposers = ne.proposers.map((C) => C) : H.proposers = [], ne.submitTime !== void 0 && (H.submitTime = (0, d.fromTimestamp)(ne.submitTime).toISOString()), ne.groupVersion !== void 0 && (H.groupVersion = (ne.groupVersion || BigInt(0)).toString()), ne.groupPolicyVersion !== void 0 && (H.groupPolicyVersion = (ne.groupPolicyVersion || BigInt(0)).toString()), ne.status !== void 0 && (H.status = O(ne.status)), ne.finalTallyResult !== void 0 && (H.finalTallyResult = ne.finalTallyResult ? e.TallyResult.toJSON(ne.finalTallyResult) : void 0), ne.votingPeriodEnd !== void 0 && (H.votingPeriodEnd = (0, d.fromTimestamp)(ne.votingPeriodEnd).toISOString()), ne.executorResult !== void 0 && (H.executorResult = V(ne.executorResult)), ne.messages ? H.messages = ne.messages.map((C) => C ? u.Any.toJSON(C) : void 0) : H.messages = [], ne.title !== void 0 && (H.title = ne.title), ne.summary !== void 0 && (H.summary = ne.summary), H;
    },
    fromPartial(ne) {
      var C, w;
      const H = Y();
      return ne.id !== void 0 && ne.id !== null && (H.id = BigInt(ne.id.toString())), H.groupPolicyAddress = ne.groupPolicyAddress ?? "", H.metadata = ne.metadata ?? "", H.proposers = ((C = ne.proposers) == null ? void 0 : C.map((P) => P)) || [], ne.submitTime !== void 0 && ne.submitTime !== null && (H.submitTime = n.Timestamp.fromPartial(ne.submitTime)), ne.groupVersion !== void 0 && ne.groupVersion !== null && (H.groupVersion = BigInt(ne.groupVersion.toString())), ne.groupPolicyVersion !== void 0 && ne.groupPolicyVersion !== null && (H.groupPolicyVersion = BigInt(ne.groupPolicyVersion.toString())), H.status = ne.status ?? 0, ne.finalTallyResult !== void 0 && ne.finalTallyResult !== null && (H.finalTallyResult = e.TallyResult.fromPartial(ne.finalTallyResult)), ne.votingPeriodEnd !== void 0 && ne.votingPeriodEnd !== null && (H.votingPeriodEnd = n.Timestamp.fromPartial(ne.votingPeriodEnd)), H.executorResult = ne.executorResult ?? 0, H.messages = ((w = ne.messages) == null ? void 0 : w.map((P) => u.Any.fromPartial(P))) || [], H.title = ne.title ?? "", H.summary = ne.summary ?? "", H;
    }
  };
  function pe() {
    return {
      yesCount: "",
      abstainCount: "",
      noCount: "",
      noWithVetoCount: ""
    };
  }
  e.TallyResult = {
    typeUrl: "/cosmos.group.v1.TallyResult",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.yesCount !== "" && H.uint32(10).string(ne.yesCount), ne.abstainCount !== "" && H.uint32(18).string(ne.abstainCount), ne.noCount !== "" && H.uint32(26).string(ne.noCount), ne.noWithVetoCount !== "" && H.uint32(34).string(ne.noWithVetoCount), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = pe();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.yesCount = C.string();
            break;
          case 2:
            P.abstainCount = C.string();
            break;
          case 3:
            P.noCount = C.string();
            break;
          case 4:
            P.noWithVetoCount = C.string();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = pe();
      return (0, d.isSet)(ne.yesCount) && (H.yesCount = String(ne.yesCount)), (0, d.isSet)(ne.abstainCount) && (H.abstainCount = String(ne.abstainCount)), (0, d.isSet)(ne.noCount) && (H.noCount = String(ne.noCount)), (0, d.isSet)(ne.noWithVetoCount) && (H.noWithVetoCount = String(ne.noWithVetoCount)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.yesCount !== void 0 && (H.yesCount = ne.yesCount), ne.abstainCount !== void 0 && (H.abstainCount = ne.abstainCount), ne.noCount !== void 0 && (H.noCount = ne.noCount), ne.noWithVetoCount !== void 0 && (H.noWithVetoCount = ne.noWithVetoCount), H;
    },
    fromPartial(ne) {
      const H = pe();
      return H.yesCount = ne.yesCount ?? "", H.abstainCount = ne.abstainCount ?? "", H.noCount = ne.noCount ?? "", H.noWithVetoCount = ne.noWithVetoCount ?? "", H;
    }
  };
  function oe() {
    return {
      proposalId: BigInt(0),
      voter: "",
      option: 0,
      metadata: "",
      submitTime: n.Timestamp.fromPartial({})
    };
  }
  e.Vote = {
    typeUrl: "/cosmos.group.v1.Vote",
    encode(ne, H = c.BinaryWriter.create()) {
      return ne.proposalId !== BigInt(0) && H.uint32(8).uint64(ne.proposalId), ne.voter !== "" && H.uint32(18).string(ne.voter), ne.option !== 0 && H.uint32(24).int32(ne.option), ne.metadata !== "" && H.uint32(34).string(ne.metadata), ne.submitTime !== void 0 && n.Timestamp.encode(ne.submitTime, H.uint32(42).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof c.BinaryReader ? ne : new c.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = oe();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.proposalId = C.uint64();
            break;
          case 2:
            P.voter = C.string();
            break;
          case 3:
            P.option = C.int32();
            break;
          case 4:
            P.metadata = C.string();
            break;
          case 5:
            P.submitTime = n.Timestamp.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = oe();
      return (0, d.isSet)(ne.proposalId) && (H.proposalId = BigInt(ne.proposalId.toString())), (0, d.isSet)(ne.voter) && (H.voter = String(ne.voter)), (0, d.isSet)(ne.option) && (H.option = v(ne.option)), (0, d.isSet)(ne.metadata) && (H.metadata = String(ne.metadata)), (0, d.isSet)(ne.submitTime) && (H.submitTime = (0, d.fromJsonTimestamp)(ne.submitTime)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.proposalId !== void 0 && (H.proposalId = (ne.proposalId || BigInt(0)).toString()), ne.voter !== void 0 && (H.voter = ne.voter), ne.option !== void 0 && (H.option = S(ne.option)), ne.metadata !== void 0 && (H.metadata = ne.metadata), ne.submitTime !== void 0 && (H.submitTime = (0, d.fromTimestamp)(ne.submitTime).toISOString()), H;
    },
    fromPartial(ne) {
      const H = oe();
      return ne.proposalId !== void 0 && ne.proposalId !== null && (H.proposalId = BigInt(ne.proposalId.toString())), H.voter = ne.voter ?? "", H.option = ne.option ?? 0, H.metadata = ne.metadata ?? "", ne.submitTime !== void 0 && ne.submitTime !== null && (H.submitTime = n.Timestamp.fromPartial(ne.submitTime)), H;
    }
  };
})(types$f);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgLeaveGroupResponse = e.MsgLeaveGroup = e.MsgExecResponse = e.MsgExec = e.MsgVoteResponse = e.MsgVote = e.MsgWithdrawProposalResponse = e.MsgWithdrawProposal = e.MsgSubmitProposalResponse = e.MsgSubmitProposal = e.MsgUpdateGroupPolicyMetadataResponse = e.MsgUpdateGroupPolicyMetadata = e.MsgUpdateGroupPolicyDecisionPolicyResponse = e.MsgUpdateGroupPolicyDecisionPolicy = e.MsgCreateGroupWithPolicyResponse = e.MsgCreateGroupWithPolicy = e.MsgUpdateGroupPolicyAdminResponse = e.MsgUpdateGroupPolicyAdmin = e.MsgCreateGroupPolicyResponse = e.MsgCreateGroupPolicy = e.MsgUpdateGroupMetadataResponse = e.MsgUpdateGroupMetadata = e.MsgUpdateGroupAdminResponse = e.MsgUpdateGroupAdmin = e.MsgUpdateGroupMembersResponse = e.MsgUpdateGroupMembers = e.MsgCreateGroupResponse = e.MsgCreateGroup = e.execToJSON = e.execFromJSON = e.Exec = e.protobufPackage = void 0;
  const n = types$f, o = any$1, u = binary, c = helpers;
  e.protobufPackage = "cosmos.group.v1";
  var d;
  (function(te) {
    te[te.EXEC_UNSPECIFIED = 0] = "EXEC_UNSPECIFIED", te[te.EXEC_TRY = 1] = "EXEC_TRY", te[te.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(d || (e.Exec = d = {}));
  function m(te) {
    switch (te) {
      case 0:
      case "EXEC_UNSPECIFIED":
        return d.EXEC_UNSPECIFIED;
      case 1:
      case "EXEC_TRY":
        return d.EXEC_TRY;
      case -1:
      case "UNRECOGNIZED":
      default:
        return d.UNRECOGNIZED;
    }
  }
  e.execFromJSON = m;
  function v(te) {
    switch (te) {
      case d.EXEC_UNSPECIFIED:
        return "EXEC_UNSPECIFIED";
      case d.EXEC_TRY:
        return "EXEC_TRY";
      case d.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.execToJSON = v;
  function S() {
    return {
      admin: "",
      members: [],
      metadata: ""
    };
  }
  e.MsgCreateGroup = {
    typeUrl: "/cosmos.group.v1.MsgCreateGroup",
    encode(te, ge = u.BinaryWriter.create()) {
      te.admin !== "" && ge.uint32(10).string(te.admin);
      for (const Pe of te.members)
        n.MemberRequest.encode(Pe, ge.uint32(18).fork()).ldelim();
      return te.metadata !== "" && ge.uint32(26).string(te.metadata), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = S();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.members.push(n.MemberRequest.decode(Pe, Pe.uint32()));
            break;
          case 3:
            xe.metadata = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = S();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), Array.isArray(te == null ? void 0 : te.members) && (ge.members = te.members.map((Pe) => n.MemberRequest.fromJSON(Pe))), (0, c.isSet)(te.metadata) && (ge.metadata = String(te.metadata)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.members ? ge.members = te.members.map((Pe) => Pe ? n.MemberRequest.toJSON(Pe) : void 0) : ge.members = [], te.metadata !== void 0 && (ge.metadata = te.metadata), ge;
    },
    fromPartial(te) {
      var Pe;
      const ge = S();
      return ge.admin = te.admin ?? "", ge.members = ((Pe = te.members) == null ? void 0 : Pe.map((Ke) => n.MemberRequest.fromPartial(Ke))) || [], ge.metadata = te.metadata ?? "", ge;
    }
  };
  function $() {
    return {
      groupId: BigInt(0)
    };
  }
  e.MsgCreateGroupResponse = {
    typeUrl: "/cosmos.group.v1.MsgCreateGroupResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.groupId !== BigInt(0) && ge.uint32(8).uint64(te.groupId), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = $();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.groupId = Pe.uint64();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = $();
      return (0, c.isSet)(te.groupId) && (ge.groupId = BigInt(te.groupId.toString())), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.groupId !== void 0 && (ge.groupId = (te.groupId || BigInt(0)).toString()), ge;
    },
    fromPartial(te) {
      const ge = $();
      return te.groupId !== void 0 && te.groupId !== null && (ge.groupId = BigInt(te.groupId.toString())), ge;
    }
  };
  function E() {
    return {
      admin: "",
      groupId: BigInt(0),
      memberUpdates: []
    };
  }
  e.MsgUpdateGroupMembers = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupMembers",
    encode(te, ge = u.BinaryWriter.create()) {
      te.admin !== "" && ge.uint32(10).string(te.admin), te.groupId !== BigInt(0) && ge.uint32(16).uint64(te.groupId);
      for (const Pe of te.memberUpdates)
        n.MemberRequest.encode(Pe, ge.uint32(26).fork()).ldelim();
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = E();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.groupId = Pe.uint64();
            break;
          case 3:
            xe.memberUpdates.push(n.MemberRequest.decode(Pe, Pe.uint32()));
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = E();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), (0, c.isSet)(te.groupId) && (ge.groupId = BigInt(te.groupId.toString())), Array.isArray(te == null ? void 0 : te.memberUpdates) && (ge.memberUpdates = te.memberUpdates.map((Pe) => n.MemberRequest.fromJSON(Pe))), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.groupId !== void 0 && (ge.groupId = (te.groupId || BigInt(0)).toString()), te.memberUpdates ? ge.memberUpdates = te.memberUpdates.map((Pe) => Pe ? n.MemberRequest.toJSON(Pe) : void 0) : ge.memberUpdates = [], ge;
    },
    fromPartial(te) {
      var Pe;
      const ge = E();
      return ge.admin = te.admin ?? "", te.groupId !== void 0 && te.groupId !== null && (ge.groupId = BigInt(te.groupId.toString())), ge.memberUpdates = ((Pe = te.memberUpdates) == null ? void 0 : Pe.map((Ke) => n.MemberRequest.fromPartial(Ke))) || [], ge;
    }
  };
  function O() {
    return {};
  }
  e.MsgUpdateGroupMembersResponse = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupMembersResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = O();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return O();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return O();
    }
  };
  function T() {
    return {
      admin: "",
      groupId: BigInt(0),
      newAdmin: ""
    };
  }
  e.MsgUpdateGroupAdmin = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupAdmin",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.admin !== "" && ge.uint32(10).string(te.admin), te.groupId !== BigInt(0) && ge.uint32(16).uint64(te.groupId), te.newAdmin !== "" && ge.uint32(26).string(te.newAdmin), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = T();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.groupId = Pe.uint64();
            break;
          case 3:
            xe.newAdmin = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = T();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), (0, c.isSet)(te.groupId) && (ge.groupId = BigInt(te.groupId.toString())), (0, c.isSet)(te.newAdmin) && (ge.newAdmin = String(te.newAdmin)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.groupId !== void 0 && (ge.groupId = (te.groupId || BigInt(0)).toString()), te.newAdmin !== void 0 && (ge.newAdmin = te.newAdmin), ge;
    },
    fromPartial(te) {
      const ge = T();
      return ge.admin = te.admin ?? "", te.groupId !== void 0 && te.groupId !== null && (ge.groupId = BigInt(te.groupId.toString())), ge.newAdmin = te.newAdmin ?? "", ge;
    }
  };
  function y() {
    return {};
  }
  e.MsgUpdateGroupAdminResponse = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupAdminResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = y();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return y();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return y();
    }
  };
  function V() {
    return {
      admin: "",
      groupId: BigInt(0),
      metadata: ""
    };
  }
  e.MsgUpdateGroupMetadata = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupMetadata",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.admin !== "" && ge.uint32(10).string(te.admin), te.groupId !== BigInt(0) && ge.uint32(16).uint64(te.groupId), te.metadata !== "" && ge.uint32(26).string(te.metadata), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = V();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.groupId = Pe.uint64();
            break;
          case 3:
            xe.metadata = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = V();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), (0, c.isSet)(te.groupId) && (ge.groupId = BigInt(te.groupId.toString())), (0, c.isSet)(te.metadata) && (ge.metadata = String(te.metadata)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.groupId !== void 0 && (ge.groupId = (te.groupId || BigInt(0)).toString()), te.metadata !== void 0 && (ge.metadata = te.metadata), ge;
    },
    fromPartial(te) {
      const ge = V();
      return ge.admin = te.admin ?? "", te.groupId !== void 0 && te.groupId !== null && (ge.groupId = BigInt(te.groupId.toString())), ge.metadata = te.metadata ?? "", ge;
    }
  };
  function M() {
    return {};
  }
  e.MsgUpdateGroupMetadataResponse = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupMetadataResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = M();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return M();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return M();
    }
  };
  function G() {
    return {
      admin: "",
      groupId: BigInt(0),
      metadata: "",
      decisionPolicy: void 0
    };
  }
  e.MsgCreateGroupPolicy = {
    typeUrl: "/cosmos.group.v1.MsgCreateGroupPolicy",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.admin !== "" && ge.uint32(10).string(te.admin), te.groupId !== BigInt(0) && ge.uint32(16).uint64(te.groupId), te.metadata !== "" && ge.uint32(26).string(te.metadata), te.decisionPolicy !== void 0 && o.Any.encode(te.decisionPolicy, ge.uint32(34).fork()).ldelim(), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = G();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.groupId = Pe.uint64();
            break;
          case 3:
            xe.metadata = Pe.string();
            break;
          case 4:
            xe.decisionPolicy = o.Any.decode(Pe, Pe.uint32());
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = G();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), (0, c.isSet)(te.groupId) && (ge.groupId = BigInt(te.groupId.toString())), (0, c.isSet)(te.metadata) && (ge.metadata = String(te.metadata)), (0, c.isSet)(te.decisionPolicy) && (ge.decisionPolicy = o.Any.fromJSON(te.decisionPolicy)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.groupId !== void 0 && (ge.groupId = (te.groupId || BigInt(0)).toString()), te.metadata !== void 0 && (ge.metadata = te.metadata), te.decisionPolicy !== void 0 && (ge.decisionPolicy = te.decisionPolicy ? o.Any.toJSON(te.decisionPolicy) : void 0), ge;
    },
    fromPartial(te) {
      const ge = G();
      return ge.admin = te.admin ?? "", te.groupId !== void 0 && te.groupId !== null && (ge.groupId = BigInt(te.groupId.toString())), ge.metadata = te.metadata ?? "", te.decisionPolicy !== void 0 && te.decisionPolicy !== null && (ge.decisionPolicy = o.Any.fromPartial(te.decisionPolicy)), ge;
    }
  };
  function k() {
    return {
      address: ""
    };
  }
  e.MsgCreateGroupPolicyResponse = {
    typeUrl: "/cosmos.group.v1.MsgCreateGroupPolicyResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.address !== "" && ge.uint32(10).string(te.address), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = k();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.address = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = k();
      return (0, c.isSet)(te.address) && (ge.address = String(te.address)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.address !== void 0 && (ge.address = te.address), ge;
    },
    fromPartial(te) {
      const ge = k();
      return ge.address = te.address ?? "", ge;
    }
  };
  function F() {
    return {
      admin: "",
      groupPolicyAddress: "",
      newAdmin: ""
    };
  }
  e.MsgUpdateGroupPolicyAdmin = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupPolicyAdmin",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.admin !== "" && ge.uint32(10).string(te.admin), te.groupPolicyAddress !== "" && ge.uint32(18).string(te.groupPolicyAddress), te.newAdmin !== "" && ge.uint32(26).string(te.newAdmin), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = F();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.groupPolicyAddress = Pe.string();
            break;
          case 3:
            xe.newAdmin = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = F();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), (0, c.isSet)(te.groupPolicyAddress) && (ge.groupPolicyAddress = String(te.groupPolicyAddress)), (0, c.isSet)(te.newAdmin) && (ge.newAdmin = String(te.newAdmin)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.groupPolicyAddress !== void 0 && (ge.groupPolicyAddress = te.groupPolicyAddress), te.newAdmin !== void 0 && (ge.newAdmin = te.newAdmin), ge;
    },
    fromPartial(te) {
      const ge = F();
      return ge.admin = te.admin ?? "", ge.groupPolicyAddress = te.groupPolicyAddress ?? "", ge.newAdmin = te.newAdmin ?? "", ge;
    }
  };
  function X() {
    return {};
  }
  e.MsgUpdateGroupPolicyAdminResponse = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupPolicyAdminResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = X();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return X();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return X();
    }
  };
  function ee() {
    return {
      admin: "",
      members: [],
      groupMetadata: "",
      groupPolicyMetadata: "",
      groupPolicyAsAdmin: !1,
      decisionPolicy: void 0
    };
  }
  e.MsgCreateGroupWithPolicy = {
    typeUrl: "/cosmos.group.v1.MsgCreateGroupWithPolicy",
    encode(te, ge = u.BinaryWriter.create()) {
      te.admin !== "" && ge.uint32(10).string(te.admin);
      for (const Pe of te.members)
        n.MemberRequest.encode(Pe, ge.uint32(18).fork()).ldelim();
      return te.groupMetadata !== "" && ge.uint32(26).string(te.groupMetadata), te.groupPolicyMetadata !== "" && ge.uint32(34).string(te.groupPolicyMetadata), te.groupPolicyAsAdmin === !0 && ge.uint32(40).bool(te.groupPolicyAsAdmin), te.decisionPolicy !== void 0 && o.Any.encode(te.decisionPolicy, ge.uint32(50).fork()).ldelim(), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = ee();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.members.push(n.MemberRequest.decode(Pe, Pe.uint32()));
            break;
          case 3:
            xe.groupMetadata = Pe.string();
            break;
          case 4:
            xe.groupPolicyMetadata = Pe.string();
            break;
          case 5:
            xe.groupPolicyAsAdmin = Pe.bool();
            break;
          case 6:
            xe.decisionPolicy = o.Any.decode(Pe, Pe.uint32());
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = ee();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), Array.isArray(te == null ? void 0 : te.members) && (ge.members = te.members.map((Pe) => n.MemberRequest.fromJSON(Pe))), (0, c.isSet)(te.groupMetadata) && (ge.groupMetadata = String(te.groupMetadata)), (0, c.isSet)(te.groupPolicyMetadata) && (ge.groupPolicyMetadata = String(te.groupPolicyMetadata)), (0, c.isSet)(te.groupPolicyAsAdmin) && (ge.groupPolicyAsAdmin = !!te.groupPolicyAsAdmin), (0, c.isSet)(te.decisionPolicy) && (ge.decisionPolicy = o.Any.fromJSON(te.decisionPolicy)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.members ? ge.members = te.members.map((Pe) => Pe ? n.MemberRequest.toJSON(Pe) : void 0) : ge.members = [], te.groupMetadata !== void 0 && (ge.groupMetadata = te.groupMetadata), te.groupPolicyMetadata !== void 0 && (ge.groupPolicyMetadata = te.groupPolicyMetadata), te.groupPolicyAsAdmin !== void 0 && (ge.groupPolicyAsAdmin = te.groupPolicyAsAdmin), te.decisionPolicy !== void 0 && (ge.decisionPolicy = te.decisionPolicy ? o.Any.toJSON(te.decisionPolicy) : void 0), ge;
    },
    fromPartial(te) {
      var Pe;
      const ge = ee();
      return ge.admin = te.admin ?? "", ge.members = ((Pe = te.members) == null ? void 0 : Pe.map((Ke) => n.MemberRequest.fromPartial(Ke))) || [], ge.groupMetadata = te.groupMetadata ?? "", ge.groupPolicyMetadata = te.groupPolicyMetadata ?? "", ge.groupPolicyAsAdmin = te.groupPolicyAsAdmin ?? !1, te.decisionPolicy !== void 0 && te.decisionPolicy !== null && (ge.decisionPolicy = o.Any.fromPartial(te.decisionPolicy)), ge;
    }
  };
  function ue() {
    return {
      groupId: BigInt(0),
      groupPolicyAddress: ""
    };
  }
  e.MsgCreateGroupWithPolicyResponse = {
    typeUrl: "/cosmos.group.v1.MsgCreateGroupWithPolicyResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.groupId !== BigInt(0) && ge.uint32(8).uint64(te.groupId), te.groupPolicyAddress !== "" && ge.uint32(18).string(te.groupPolicyAddress), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = ue();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.groupId = Pe.uint64();
            break;
          case 2:
            xe.groupPolicyAddress = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = ue();
      return (0, c.isSet)(te.groupId) && (ge.groupId = BigInt(te.groupId.toString())), (0, c.isSet)(te.groupPolicyAddress) && (ge.groupPolicyAddress = String(te.groupPolicyAddress)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.groupId !== void 0 && (ge.groupId = (te.groupId || BigInt(0)).toString()), te.groupPolicyAddress !== void 0 && (ge.groupPolicyAddress = te.groupPolicyAddress), ge;
    },
    fromPartial(te) {
      const ge = ue();
      return te.groupId !== void 0 && te.groupId !== null && (ge.groupId = BigInt(te.groupId.toString())), ge.groupPolicyAddress = te.groupPolicyAddress ?? "", ge;
    }
  };
  function Q() {
    return {
      admin: "",
      groupPolicyAddress: "",
      decisionPolicy: void 0
    };
  }
  e.MsgUpdateGroupPolicyDecisionPolicy = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicy",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.admin !== "" && ge.uint32(10).string(te.admin), te.groupPolicyAddress !== "" && ge.uint32(18).string(te.groupPolicyAddress), te.decisionPolicy !== void 0 && o.Any.encode(te.decisionPolicy, ge.uint32(26).fork()).ldelim(), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = Q();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.groupPolicyAddress = Pe.string();
            break;
          case 3:
            xe.decisionPolicy = o.Any.decode(Pe, Pe.uint32());
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = Q();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), (0, c.isSet)(te.groupPolicyAddress) && (ge.groupPolicyAddress = String(te.groupPolicyAddress)), (0, c.isSet)(te.decisionPolicy) && (ge.decisionPolicy = o.Any.fromJSON(te.decisionPolicy)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.groupPolicyAddress !== void 0 && (ge.groupPolicyAddress = te.groupPolicyAddress), te.decisionPolicy !== void 0 && (ge.decisionPolicy = te.decisionPolicy ? o.Any.toJSON(te.decisionPolicy) : void 0), ge;
    },
    fromPartial(te) {
      const ge = Q();
      return ge.admin = te.admin ?? "", ge.groupPolicyAddress = te.groupPolicyAddress ?? "", te.decisionPolicy !== void 0 && te.decisionPolicy !== null && (ge.decisionPolicy = o.Any.fromPartial(te.decisionPolicy)), ge;
    }
  };
  function Y() {
    return {};
  }
  e.MsgUpdateGroupPolicyDecisionPolicyResponse = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicyResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = Y();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return Y();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return Y();
    }
  };
  function pe() {
    return {
      admin: "",
      groupPolicyAddress: "",
      metadata: ""
    };
  }
  e.MsgUpdateGroupPolicyMetadata = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupPolicyMetadata",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.admin !== "" && ge.uint32(10).string(te.admin), te.groupPolicyAddress !== "" && ge.uint32(18).string(te.groupPolicyAddress), te.metadata !== "" && ge.uint32(26).string(te.metadata), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = pe();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.admin = Pe.string();
            break;
          case 2:
            xe.groupPolicyAddress = Pe.string();
            break;
          case 3:
            xe.metadata = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = pe();
      return (0, c.isSet)(te.admin) && (ge.admin = String(te.admin)), (0, c.isSet)(te.groupPolicyAddress) && (ge.groupPolicyAddress = String(te.groupPolicyAddress)), (0, c.isSet)(te.metadata) && (ge.metadata = String(te.metadata)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.admin !== void 0 && (ge.admin = te.admin), te.groupPolicyAddress !== void 0 && (ge.groupPolicyAddress = te.groupPolicyAddress), te.metadata !== void 0 && (ge.metadata = te.metadata), ge;
    },
    fromPartial(te) {
      const ge = pe();
      return ge.admin = te.admin ?? "", ge.groupPolicyAddress = te.groupPolicyAddress ?? "", ge.metadata = te.metadata ?? "", ge;
    }
  };
  function oe() {
    return {};
  }
  e.MsgUpdateGroupPolicyMetadataResponse = {
    typeUrl: "/cosmos.group.v1.MsgUpdateGroupPolicyMetadataResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = oe();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return oe();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return oe();
    }
  };
  function ne() {
    return {
      groupPolicyAddress: "",
      proposers: [],
      metadata: "",
      messages: [],
      exec: 0,
      title: "",
      summary: ""
    };
  }
  e.MsgSubmitProposal = {
    typeUrl: "/cosmos.group.v1.MsgSubmitProposal",
    encode(te, ge = u.BinaryWriter.create()) {
      te.groupPolicyAddress !== "" && ge.uint32(10).string(te.groupPolicyAddress);
      for (const Pe of te.proposers)
        ge.uint32(18).string(Pe);
      te.metadata !== "" && ge.uint32(26).string(te.metadata);
      for (const Pe of te.messages)
        o.Any.encode(Pe, ge.uint32(34).fork()).ldelim();
      return te.exec !== 0 && ge.uint32(40).int32(te.exec), te.title !== "" && ge.uint32(50).string(te.title), te.summary !== "" && ge.uint32(58).string(te.summary), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = ne();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.groupPolicyAddress = Pe.string();
            break;
          case 2:
            xe.proposers.push(Pe.string());
            break;
          case 3:
            xe.metadata = Pe.string();
            break;
          case 4:
            xe.messages.push(o.Any.decode(Pe, Pe.uint32()));
            break;
          case 5:
            xe.exec = Pe.int32();
            break;
          case 6:
            xe.title = Pe.string();
            break;
          case 7:
            xe.summary = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = ne();
      return (0, c.isSet)(te.groupPolicyAddress) && (ge.groupPolicyAddress = String(te.groupPolicyAddress)), Array.isArray(te == null ? void 0 : te.proposers) && (ge.proposers = te.proposers.map((Pe) => String(Pe))), (0, c.isSet)(te.metadata) && (ge.metadata = String(te.metadata)), Array.isArray(te == null ? void 0 : te.messages) && (ge.messages = te.messages.map((Pe) => o.Any.fromJSON(Pe))), (0, c.isSet)(te.exec) && (ge.exec = m(te.exec)), (0, c.isSet)(te.title) && (ge.title = String(te.title)), (0, c.isSet)(te.summary) && (ge.summary = String(te.summary)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.groupPolicyAddress !== void 0 && (ge.groupPolicyAddress = te.groupPolicyAddress), te.proposers ? ge.proposers = te.proposers.map((Pe) => Pe) : ge.proposers = [], te.metadata !== void 0 && (ge.metadata = te.metadata), te.messages ? ge.messages = te.messages.map((Pe) => Pe ? o.Any.toJSON(Pe) : void 0) : ge.messages = [], te.exec !== void 0 && (ge.exec = v(te.exec)), te.title !== void 0 && (ge.title = te.title), te.summary !== void 0 && (ge.summary = te.summary), ge;
    },
    fromPartial(te) {
      var Pe, Ke;
      const ge = ne();
      return ge.groupPolicyAddress = te.groupPolicyAddress ?? "", ge.proposers = ((Pe = te.proposers) == null ? void 0 : Pe.map((xe) => xe)) || [], ge.metadata = te.metadata ?? "", ge.messages = ((Ke = te.messages) == null ? void 0 : Ke.map((xe) => o.Any.fromPartial(xe))) || [], ge.exec = te.exec ?? 0, ge.title = te.title ?? "", ge.summary = te.summary ?? "", ge;
    }
  };
  function H() {
    return {
      proposalId: BigInt(0)
    };
  }
  e.MsgSubmitProposalResponse = {
    typeUrl: "/cosmos.group.v1.MsgSubmitProposalResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.proposalId !== BigInt(0) && ge.uint32(8).uint64(te.proposalId), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = H();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.proposalId = Pe.uint64();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = H();
      return (0, c.isSet)(te.proposalId) && (ge.proposalId = BigInt(te.proposalId.toString())), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.proposalId !== void 0 && (ge.proposalId = (te.proposalId || BigInt(0)).toString()), ge;
    },
    fromPartial(te) {
      const ge = H();
      return te.proposalId !== void 0 && te.proposalId !== null && (ge.proposalId = BigInt(te.proposalId.toString())), ge;
    }
  };
  function C() {
    return {
      proposalId: BigInt(0),
      address: ""
    };
  }
  e.MsgWithdrawProposal = {
    typeUrl: "/cosmos.group.v1.MsgWithdrawProposal",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.proposalId !== BigInt(0) && ge.uint32(8).uint64(te.proposalId), te.address !== "" && ge.uint32(18).string(te.address), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = C();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.proposalId = Pe.uint64();
            break;
          case 2:
            xe.address = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = C();
      return (0, c.isSet)(te.proposalId) && (ge.proposalId = BigInt(te.proposalId.toString())), (0, c.isSet)(te.address) && (ge.address = String(te.address)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.proposalId !== void 0 && (ge.proposalId = (te.proposalId || BigInt(0)).toString()), te.address !== void 0 && (ge.address = te.address), ge;
    },
    fromPartial(te) {
      const ge = C();
      return te.proposalId !== void 0 && te.proposalId !== null && (ge.proposalId = BigInt(te.proposalId.toString())), ge.address = te.address ?? "", ge;
    }
  };
  function w() {
    return {};
  }
  e.MsgWithdrawProposalResponse = {
    typeUrl: "/cosmos.group.v1.MsgWithdrawProposalResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = w();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return w();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return w();
    }
  };
  function P() {
    return {
      proposalId: BigInt(0),
      voter: "",
      option: 0,
      metadata: "",
      exec: 0
    };
  }
  e.MsgVote = {
    typeUrl: "/cosmos.group.v1.MsgVote",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.proposalId !== BigInt(0) && ge.uint32(8).uint64(te.proposalId), te.voter !== "" && ge.uint32(18).string(te.voter), te.option !== 0 && ge.uint32(24).int32(te.option), te.metadata !== "" && ge.uint32(34).string(te.metadata), te.exec !== 0 && ge.uint32(40).int32(te.exec), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = P();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.proposalId = Pe.uint64();
            break;
          case 2:
            xe.voter = Pe.string();
            break;
          case 3:
            xe.option = Pe.int32();
            break;
          case 4:
            xe.metadata = Pe.string();
            break;
          case 5:
            xe.exec = Pe.int32();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = P();
      return (0, c.isSet)(te.proposalId) && (ge.proposalId = BigInt(te.proposalId.toString())), (0, c.isSet)(te.voter) && (ge.voter = String(te.voter)), (0, c.isSet)(te.option) && (ge.option = (0, n.voteOptionFromJSON)(te.option)), (0, c.isSet)(te.metadata) && (ge.metadata = String(te.metadata)), (0, c.isSet)(te.exec) && (ge.exec = m(te.exec)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.proposalId !== void 0 && (ge.proposalId = (te.proposalId || BigInt(0)).toString()), te.voter !== void 0 && (ge.voter = te.voter), te.option !== void 0 && (ge.option = (0, n.voteOptionToJSON)(te.option)), te.metadata !== void 0 && (ge.metadata = te.metadata), te.exec !== void 0 && (ge.exec = v(te.exec)), ge;
    },
    fromPartial(te) {
      const ge = P();
      return te.proposalId !== void 0 && te.proposalId !== null && (ge.proposalId = BigInt(te.proposalId.toString())), ge.voter = te.voter ?? "", ge.option = te.option ?? 0, ge.metadata = te.metadata ?? "", ge.exec = te.exec ?? 0, ge;
    }
  };
  function J() {
    return {};
  }
  e.MsgVoteResponse = {
    typeUrl: "/cosmos.group.v1.MsgVoteResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = J();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return J();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return J();
    }
  };
  function se() {
    return {
      proposalId: BigInt(0),
      executor: ""
    };
  }
  e.MsgExec = {
    typeUrl: "/cosmos.group.v1.MsgExec",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.proposalId !== BigInt(0) && ge.uint32(8).uint64(te.proposalId), te.executor !== "" && ge.uint32(18).string(te.executor), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = se();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.proposalId = Pe.uint64();
            break;
          case 2:
            xe.executor = Pe.string();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = se();
      return (0, c.isSet)(te.proposalId) && (ge.proposalId = BigInt(te.proposalId.toString())), (0, c.isSet)(te.executor) && (ge.executor = String(te.executor)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.proposalId !== void 0 && (ge.proposalId = (te.proposalId || BigInt(0)).toString()), te.executor !== void 0 && (ge.executor = te.executor), ge;
    },
    fromPartial(te) {
      const ge = se();
      return te.proposalId !== void 0 && te.proposalId !== null && (ge.proposalId = BigInt(te.proposalId.toString())), ge.executor = te.executor ?? "", ge;
    }
  };
  function fe() {
    return {
      result: 0
    };
  }
  e.MsgExecResponse = {
    typeUrl: "/cosmos.group.v1.MsgExecResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.result !== 0 && ge.uint32(16).int32(te.result), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = fe();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 2:
            xe.result = Pe.int32();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = fe();
      return (0, c.isSet)(te.result) && (ge.result = (0, n.proposalExecutorResultFromJSON)(te.result)), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.result !== void 0 && (ge.result = (0, n.proposalExecutorResultToJSON)(te.result)), ge;
    },
    fromPartial(te) {
      const ge = fe();
      return ge.result = te.result ?? 0, ge;
    }
  };
  function N() {
    return {
      address: "",
      groupId: BigInt(0)
    };
  }
  e.MsgLeaveGroup = {
    typeUrl: "/cosmos.group.v1.MsgLeaveGroup",
    encode(te, ge = u.BinaryWriter.create()) {
      return te.address !== "" && ge.uint32(10).string(te.address), te.groupId !== BigInt(0) && ge.uint32(16).uint64(te.groupId), ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = N();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          case 1:
            xe.address = Pe.string();
            break;
          case 2:
            xe.groupId = Pe.uint64();
            break;
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      const ge = N();
      return (0, c.isSet)(te.address) && (ge.address = String(te.address)), (0, c.isSet)(te.groupId) && (ge.groupId = BigInt(te.groupId.toString())), ge;
    },
    toJSON(te) {
      const ge = {};
      return te.address !== void 0 && (ge.address = te.address), te.groupId !== void 0 && (ge.groupId = (te.groupId || BigInt(0)).toString()), ge;
    },
    fromPartial(te) {
      const ge = N();
      return ge.address = te.address ?? "", te.groupId !== void 0 && te.groupId !== null && (ge.groupId = BigInt(te.groupId.toString())), ge;
    }
  };
  function W() {
    return {};
  }
  e.MsgLeaveGroupResponse = {
    typeUrl: "/cosmos.group.v1.MsgLeaveGroupResponse",
    encode(te, ge = u.BinaryWriter.create()) {
      return ge;
    },
    decode(te, ge) {
      const Pe = te instanceof u.BinaryReader ? te : new u.BinaryReader(te);
      let Ke = ge === void 0 ? Pe.len : Pe.pos + ge;
      const xe = W();
      for (; Pe.pos < Ke; ) {
        const ze = Pe.uint32();
        switch (ze >>> 3) {
          default:
            Pe.skipType(ze & 7);
            break;
        }
      }
      return xe;
    },
    fromJSON(te) {
      return W();
    },
    toJSON(te) {
      return {};
    },
    fromPartial(te) {
      return W();
    }
  };
  class I {
    constructor(ge) {
      this.rpc = ge, this.CreateGroup = this.CreateGroup.bind(this), this.UpdateGroupMembers = this.UpdateGroupMembers.bind(this), this.UpdateGroupAdmin = this.UpdateGroupAdmin.bind(this), this.UpdateGroupMetadata = this.UpdateGroupMetadata.bind(this), this.CreateGroupPolicy = this.CreateGroupPolicy.bind(this), this.CreateGroupWithPolicy = this.CreateGroupWithPolicy.bind(this), this.UpdateGroupPolicyAdmin = this.UpdateGroupPolicyAdmin.bind(this), this.UpdateGroupPolicyDecisionPolicy = this.UpdateGroupPolicyDecisionPolicy.bind(this), this.UpdateGroupPolicyMetadata = this.UpdateGroupPolicyMetadata.bind(this), this.SubmitProposal = this.SubmitProposal.bind(this), this.WithdrawProposal = this.WithdrawProposal.bind(this), this.Vote = this.Vote.bind(this), this.Exec = this.Exec.bind(this), this.LeaveGroup = this.LeaveGroup.bind(this);
    }
    CreateGroup(ge) {
      const Pe = e.MsgCreateGroup.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "CreateGroup", Pe).then((xe) => e.MsgCreateGroupResponse.decode(new u.BinaryReader(xe)));
    }
    UpdateGroupMembers(ge) {
      const Pe = e.MsgUpdateGroupMembers.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMembers", Pe).then((xe) => e.MsgUpdateGroupMembersResponse.decode(new u.BinaryReader(xe)));
    }
    UpdateGroupAdmin(ge) {
      const Pe = e.MsgUpdateGroupAdmin.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupAdmin", Pe).then((xe) => e.MsgUpdateGroupAdminResponse.decode(new u.BinaryReader(xe)));
    }
    UpdateGroupMetadata(ge) {
      const Pe = e.MsgUpdateGroupMetadata.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMetadata", Pe).then((xe) => e.MsgUpdateGroupMetadataResponse.decode(new u.BinaryReader(xe)));
    }
    CreateGroupPolicy(ge) {
      const Pe = e.MsgCreateGroupPolicy.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "CreateGroupPolicy", Pe).then((xe) => e.MsgCreateGroupPolicyResponse.decode(new u.BinaryReader(xe)));
    }
    CreateGroupWithPolicy(ge) {
      const Pe = e.MsgCreateGroupWithPolicy.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "CreateGroupWithPolicy", Pe).then((xe) => e.MsgCreateGroupWithPolicyResponse.decode(new u.BinaryReader(xe)));
    }
    UpdateGroupPolicyAdmin(ge) {
      const Pe = e.MsgUpdateGroupPolicyAdmin.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyAdmin", Pe).then((xe) => e.MsgUpdateGroupPolicyAdminResponse.decode(new u.BinaryReader(xe)));
    }
    UpdateGroupPolicyDecisionPolicy(ge) {
      const Pe = e.MsgUpdateGroupPolicyDecisionPolicy.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyDecisionPolicy", Pe).then((xe) => e.MsgUpdateGroupPolicyDecisionPolicyResponse.decode(new u.BinaryReader(xe)));
    }
    UpdateGroupPolicyMetadata(ge) {
      const Pe = e.MsgUpdateGroupPolicyMetadata.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyMetadata", Pe).then((xe) => e.MsgUpdateGroupPolicyMetadataResponse.decode(new u.BinaryReader(xe)));
    }
    SubmitProposal(ge) {
      const Pe = e.MsgSubmitProposal.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "SubmitProposal", Pe).then((xe) => e.MsgSubmitProposalResponse.decode(new u.BinaryReader(xe)));
    }
    WithdrawProposal(ge) {
      const Pe = e.MsgWithdrawProposal.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "WithdrawProposal", Pe).then((xe) => e.MsgWithdrawProposalResponse.decode(new u.BinaryReader(xe)));
    }
    Vote(ge) {
      const Pe = e.MsgVote.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "Vote", Pe).then((xe) => e.MsgVoteResponse.decode(new u.BinaryReader(xe)));
    }
    Exec(ge) {
      const Pe = e.MsgExec.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "Exec", Pe).then((xe) => e.MsgExecResponse.decode(new u.BinaryReader(xe)));
    }
    LeaveGroup(ge) {
      const Pe = e.MsgLeaveGroup.encode(ge).finish();
      return this.rpc.request("cosmos.group.v1.Msg", "LeaveGroup", Pe).then((xe) => e.MsgLeaveGroupResponse.decode(new u.BinaryReader(xe)));
    }
  }
  e.MsgClientImpl = I;
})(tx$i);
Object.defineProperty(messages$d, "__esModule", { value: !0 });
messages$d.groupTypes = void 0;
const tx_1$l = tx$i;
messages$d.groupTypes = [
  ["/cosmos.group.v1.MsgCreateGroup", tx_1$l.MsgCreateGroup],
  ["/cosmos.group.v1.MsgCreateGroupPolicy", tx_1$l.MsgCreateGroupPolicy],
  ["/cosmos.group.v1.MsgCreateGroupWithPolicy", tx_1$l.MsgCreateGroupWithPolicy],
  ["/cosmos.group.v1.MsgExec", tx_1$l.MsgExec],
  ["/cosmos.group.v1.MsgLeaveGroup", tx_1$l.MsgLeaveGroup],
  ["/cosmos.group.v1.MsgSubmitProposal", tx_1$l.MsgSubmitProposal],
  ["/cosmos.group.v1.MsgUpdateGroupAdmin", tx_1$l.MsgUpdateGroupAdmin],
  ["/cosmos.group.v1.MsgUpdateGroupMembers", tx_1$l.MsgUpdateGroupMembers],
  ["/cosmos.group.v1.MsgUpdateGroupMetadata", tx_1$l.MsgUpdateGroupMetadata],
  ["/cosmos.group.v1.MsgUpdateGroupPolicyAdmin", tx_1$l.MsgUpdateGroupPolicyAdmin],
  ["/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicy", tx_1$l.MsgUpdateGroupPolicyDecisionPolicy],
  ["/cosmos.group.v1.MsgUpdateGroupPolicyMetadata", tx_1$l.MsgUpdateGroupPolicyMetadata],
  ["/cosmos.group.v1.MsgVote", tx_1$l.MsgVote],
  ["/cosmos.group.v1.MsgWithdrawProposal", tx_1$l.MsgWithdrawProposal]
];
var aminomessages$f = {}, tx$h = {}, client$1 = {}, upgrade$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ModuleVersion = e.CancelSoftwareUpgradeProposal = e.SoftwareUpgradeProposal = e.Plan = e.protobufPackage = void 0;
  const n = timestamp$1, o = any$1, u = binary, c = helpers;
  e.protobufPackage = "cosmos.upgrade.v1beta1";
  function d() {
    return {
      name: "",
      time: n.Timestamp.fromPartial({}),
      height: BigInt(0),
      info: "",
      upgradedClientState: void 0
    };
  }
  e.Plan = {
    typeUrl: "/cosmos.upgrade.v1beta1.Plan",
    encode($, E = u.BinaryWriter.create()) {
      return $.name !== "" && E.uint32(10).string($.name), $.time !== void 0 && n.Timestamp.encode($.time, E.uint32(18).fork()).ldelim(), $.height !== BigInt(0) && E.uint32(24).int64($.height), $.info !== "" && E.uint32(34).string($.info), $.upgradedClientState !== void 0 && o.Any.encode($.upgradedClientState, E.uint32(42).fork()).ldelim(), E;
    },
    decode($, E) {
      const O = $ instanceof u.BinaryReader ? $ : new u.BinaryReader($);
      let T = E === void 0 ? O.len : O.pos + E;
      const y = d();
      for (; O.pos < T; ) {
        const V = O.uint32();
        switch (V >>> 3) {
          case 1:
            y.name = O.string();
            break;
          case 2:
            y.time = n.Timestamp.decode(O, O.uint32());
            break;
          case 3:
            y.height = O.int64();
            break;
          case 4:
            y.info = O.string();
            break;
          case 5:
            y.upgradedClientState = o.Any.decode(O, O.uint32());
            break;
          default:
            O.skipType(V & 7);
            break;
        }
      }
      return y;
    },
    fromJSON($) {
      const E = d();
      return (0, c.isSet)($.name) && (E.name = String($.name)), (0, c.isSet)($.time) && (E.time = (0, c.fromJsonTimestamp)($.time)), (0, c.isSet)($.height) && (E.height = BigInt($.height.toString())), (0, c.isSet)($.info) && (E.info = String($.info)), (0, c.isSet)($.upgradedClientState) && (E.upgradedClientState = o.Any.fromJSON($.upgradedClientState)), E;
    },
    toJSON($) {
      const E = {};
      return $.name !== void 0 && (E.name = $.name), $.time !== void 0 && (E.time = (0, c.fromTimestamp)($.time).toISOString()), $.height !== void 0 && (E.height = ($.height || BigInt(0)).toString()), $.info !== void 0 && (E.info = $.info), $.upgradedClientState !== void 0 && (E.upgradedClientState = $.upgradedClientState ? o.Any.toJSON($.upgradedClientState) : void 0), E;
    },
    fromPartial($) {
      const E = d();
      return E.name = $.name ?? "", $.time !== void 0 && $.time !== null && (E.time = n.Timestamp.fromPartial($.time)), $.height !== void 0 && $.height !== null && (E.height = BigInt($.height.toString())), E.info = $.info ?? "", $.upgradedClientState !== void 0 && $.upgradedClientState !== null && (E.upgradedClientState = o.Any.fromPartial($.upgradedClientState)), E;
    }
  };
  function m() {
    return {
      title: "",
      description: "",
      plan: e.Plan.fromPartial({})
    };
  }
  e.SoftwareUpgradeProposal = {
    typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
    encode($, E = u.BinaryWriter.create()) {
      return $.title !== "" && E.uint32(10).string($.title), $.description !== "" && E.uint32(18).string($.description), $.plan !== void 0 && e.Plan.encode($.plan, E.uint32(26).fork()).ldelim(), E;
    },
    decode($, E) {
      const O = $ instanceof u.BinaryReader ? $ : new u.BinaryReader($);
      let T = E === void 0 ? O.len : O.pos + E;
      const y = m();
      for (; O.pos < T; ) {
        const V = O.uint32();
        switch (V >>> 3) {
          case 1:
            y.title = O.string();
            break;
          case 2:
            y.description = O.string();
            break;
          case 3:
            y.plan = e.Plan.decode(O, O.uint32());
            break;
          default:
            O.skipType(V & 7);
            break;
        }
      }
      return y;
    },
    fromJSON($) {
      const E = m();
      return (0, c.isSet)($.title) && (E.title = String($.title)), (0, c.isSet)($.description) && (E.description = String($.description)), (0, c.isSet)($.plan) && (E.plan = e.Plan.fromJSON($.plan)), E;
    },
    toJSON($) {
      const E = {};
      return $.title !== void 0 && (E.title = $.title), $.description !== void 0 && (E.description = $.description), $.plan !== void 0 && (E.plan = $.plan ? e.Plan.toJSON($.plan) : void 0), E;
    },
    fromPartial($) {
      const E = m();
      return E.title = $.title ?? "", E.description = $.description ?? "", $.plan !== void 0 && $.plan !== null && (E.plan = e.Plan.fromPartial($.plan)), E;
    }
  };
  function v() {
    return {
      title: "",
      description: ""
    };
  }
  e.CancelSoftwareUpgradeProposal = {
    typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
    encode($, E = u.BinaryWriter.create()) {
      return $.title !== "" && E.uint32(10).string($.title), $.description !== "" && E.uint32(18).string($.description), E;
    },
    decode($, E) {
      const O = $ instanceof u.BinaryReader ? $ : new u.BinaryReader($);
      let T = E === void 0 ? O.len : O.pos + E;
      const y = v();
      for (; O.pos < T; ) {
        const V = O.uint32();
        switch (V >>> 3) {
          case 1:
            y.title = O.string();
            break;
          case 2:
            y.description = O.string();
            break;
          default:
            O.skipType(V & 7);
            break;
        }
      }
      return y;
    },
    fromJSON($) {
      const E = v();
      return (0, c.isSet)($.title) && (E.title = String($.title)), (0, c.isSet)($.description) && (E.description = String($.description)), E;
    },
    toJSON($) {
      const E = {};
      return $.title !== void 0 && (E.title = $.title), $.description !== void 0 && (E.description = $.description), E;
    },
    fromPartial($) {
      const E = v();
      return E.title = $.title ?? "", E.description = $.description ?? "", E;
    }
  };
  function S() {
    return {
      name: "",
      version: BigInt(0)
    };
  }
  e.ModuleVersion = {
    typeUrl: "/cosmos.upgrade.v1beta1.ModuleVersion",
    encode($, E = u.BinaryWriter.create()) {
      return $.name !== "" && E.uint32(10).string($.name), $.version !== BigInt(0) && E.uint32(16).uint64($.version), E;
    },
    decode($, E) {
      const O = $ instanceof u.BinaryReader ? $ : new u.BinaryReader($);
      let T = E === void 0 ? O.len : O.pos + E;
      const y = S();
      for (; O.pos < T; ) {
        const V = O.uint32();
        switch (V >>> 3) {
          case 1:
            y.name = O.string();
            break;
          case 2:
            y.version = O.uint64();
            break;
          default:
            O.skipType(V & 7);
            break;
        }
      }
      return y;
    },
    fromJSON($) {
      const E = S();
      return (0, c.isSet)($.name) && (E.name = String($.name)), (0, c.isSet)($.version) && (E.version = BigInt($.version.toString())), E;
    },
    toJSON($) {
      const E = {};
      return $.name !== void 0 && (E.name = $.name), $.version !== void 0 && (E.version = ($.version || BigInt(0)).toString()), E;
    },
    fromPartial($) {
      const E = S();
      return E.name = $.name ?? "", $.version !== void 0 && $.version !== null && (E.version = BigInt($.version.toString())), E;
    }
  };
})(upgrade$1);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.Height = e.UpgradeProposal = e.ClientUpdateProposal = e.ClientConsensusStates = e.ConsensusStateWithHeight = e.IdentifiedClientState = e.protobufPackage = void 0;
  const n = any$1, o = upgrade$1, u = binary, c = helpers;
  e.protobufPackage = "ibc.core.client.v1";
  function d() {
    return {
      clientId: "",
      clientState: void 0
    };
  }
  e.IdentifiedClientState = {
    typeUrl: "/ibc.core.client.v1.IdentifiedClientState",
    encode(T, y = u.BinaryWriter.create()) {
      return T.clientId !== "" && y.uint32(10).string(T.clientId), T.clientState !== void 0 && n.Any.encode(T.clientState, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = d();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.clientId = V.string();
            break;
          case 2:
            G.clientState = n.Any.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = d();
      return (0, c.isSet)(T.clientId) && (y.clientId = String(T.clientId)), (0, c.isSet)(T.clientState) && (y.clientState = n.Any.fromJSON(T.clientState)), y;
    },
    toJSON(T) {
      const y = {};
      return T.clientId !== void 0 && (y.clientId = T.clientId), T.clientState !== void 0 && (y.clientState = T.clientState ? n.Any.toJSON(T.clientState) : void 0), y;
    },
    fromPartial(T) {
      const y = d();
      return y.clientId = T.clientId ?? "", T.clientState !== void 0 && T.clientState !== null && (y.clientState = n.Any.fromPartial(T.clientState)), y;
    }
  };
  function m() {
    return {
      height: e.Height.fromPartial({}),
      consensusState: void 0
    };
  }
  e.ConsensusStateWithHeight = {
    typeUrl: "/ibc.core.client.v1.ConsensusStateWithHeight",
    encode(T, y = u.BinaryWriter.create()) {
      return T.height !== void 0 && e.Height.encode(T.height, y.uint32(10).fork()).ldelim(), T.consensusState !== void 0 && n.Any.encode(T.consensusState, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = m();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.height = e.Height.decode(V, V.uint32());
            break;
          case 2:
            G.consensusState = n.Any.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = m();
      return (0, c.isSet)(T.height) && (y.height = e.Height.fromJSON(T.height)), (0, c.isSet)(T.consensusState) && (y.consensusState = n.Any.fromJSON(T.consensusState)), y;
    },
    toJSON(T) {
      const y = {};
      return T.height !== void 0 && (y.height = T.height ? e.Height.toJSON(T.height) : void 0), T.consensusState !== void 0 && (y.consensusState = T.consensusState ? n.Any.toJSON(T.consensusState) : void 0), y;
    },
    fromPartial(T) {
      const y = m();
      return T.height !== void 0 && T.height !== null && (y.height = e.Height.fromPartial(T.height)), T.consensusState !== void 0 && T.consensusState !== null && (y.consensusState = n.Any.fromPartial(T.consensusState)), y;
    }
  };
  function v() {
    return {
      clientId: "",
      consensusStates: []
    };
  }
  e.ClientConsensusStates = {
    typeUrl: "/ibc.core.client.v1.ClientConsensusStates",
    encode(T, y = u.BinaryWriter.create()) {
      T.clientId !== "" && y.uint32(10).string(T.clientId);
      for (const V of T.consensusStates)
        e.ConsensusStateWithHeight.encode(V, y.uint32(18).fork()).ldelim();
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = v();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.clientId = V.string();
            break;
          case 2:
            G.consensusStates.push(e.ConsensusStateWithHeight.decode(V, V.uint32()));
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = v();
      return (0, c.isSet)(T.clientId) && (y.clientId = String(T.clientId)), Array.isArray(T == null ? void 0 : T.consensusStates) && (y.consensusStates = T.consensusStates.map((V) => e.ConsensusStateWithHeight.fromJSON(V))), y;
    },
    toJSON(T) {
      const y = {};
      return T.clientId !== void 0 && (y.clientId = T.clientId), T.consensusStates ? y.consensusStates = T.consensusStates.map((V) => V ? e.ConsensusStateWithHeight.toJSON(V) : void 0) : y.consensusStates = [], y;
    },
    fromPartial(T) {
      var V;
      const y = v();
      return y.clientId = T.clientId ?? "", y.consensusStates = ((V = T.consensusStates) == null ? void 0 : V.map((M) => e.ConsensusStateWithHeight.fromPartial(M))) || [], y;
    }
  };
  function S() {
    return {
      title: "",
      description: "",
      subjectClientId: "",
      substituteClientId: ""
    };
  }
  e.ClientUpdateProposal = {
    typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
    encode(T, y = u.BinaryWriter.create()) {
      return T.title !== "" && y.uint32(10).string(T.title), T.description !== "" && y.uint32(18).string(T.description), T.subjectClientId !== "" && y.uint32(26).string(T.subjectClientId), T.substituteClientId !== "" && y.uint32(34).string(T.substituteClientId), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = S();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.title = V.string();
            break;
          case 2:
            G.description = V.string();
            break;
          case 3:
            G.subjectClientId = V.string();
            break;
          case 4:
            G.substituteClientId = V.string();
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = S();
      return (0, c.isSet)(T.title) && (y.title = String(T.title)), (0, c.isSet)(T.description) && (y.description = String(T.description)), (0, c.isSet)(T.subjectClientId) && (y.subjectClientId = String(T.subjectClientId)), (0, c.isSet)(T.substituteClientId) && (y.substituteClientId = String(T.substituteClientId)), y;
    },
    toJSON(T) {
      const y = {};
      return T.title !== void 0 && (y.title = T.title), T.description !== void 0 && (y.description = T.description), T.subjectClientId !== void 0 && (y.subjectClientId = T.subjectClientId), T.substituteClientId !== void 0 && (y.substituteClientId = T.substituteClientId), y;
    },
    fromPartial(T) {
      const y = S();
      return y.title = T.title ?? "", y.description = T.description ?? "", y.subjectClientId = T.subjectClientId ?? "", y.substituteClientId = T.substituteClientId ?? "", y;
    }
  };
  function $() {
    return {
      title: "",
      description: "",
      plan: o.Plan.fromPartial({}),
      upgradedClientState: void 0
    };
  }
  e.UpgradeProposal = {
    typeUrl: "/ibc.core.client.v1.UpgradeProposal",
    encode(T, y = u.BinaryWriter.create()) {
      return T.title !== "" && y.uint32(10).string(T.title), T.description !== "" && y.uint32(18).string(T.description), T.plan !== void 0 && o.Plan.encode(T.plan, y.uint32(26).fork()).ldelim(), T.upgradedClientState !== void 0 && n.Any.encode(T.upgradedClientState, y.uint32(34).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = $();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.title = V.string();
            break;
          case 2:
            G.description = V.string();
            break;
          case 3:
            G.plan = o.Plan.decode(V, V.uint32());
            break;
          case 4:
            G.upgradedClientState = n.Any.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = $();
      return (0, c.isSet)(T.title) && (y.title = String(T.title)), (0, c.isSet)(T.description) && (y.description = String(T.description)), (0, c.isSet)(T.plan) && (y.plan = o.Plan.fromJSON(T.plan)), (0, c.isSet)(T.upgradedClientState) && (y.upgradedClientState = n.Any.fromJSON(T.upgradedClientState)), y;
    },
    toJSON(T) {
      const y = {};
      return T.title !== void 0 && (y.title = T.title), T.description !== void 0 && (y.description = T.description), T.plan !== void 0 && (y.plan = T.plan ? o.Plan.toJSON(T.plan) : void 0), T.upgradedClientState !== void 0 && (y.upgradedClientState = T.upgradedClientState ? n.Any.toJSON(T.upgradedClientState) : void 0), y;
    },
    fromPartial(T) {
      const y = $();
      return y.title = T.title ?? "", y.description = T.description ?? "", T.plan !== void 0 && T.plan !== null && (y.plan = o.Plan.fromPartial(T.plan)), T.upgradedClientState !== void 0 && T.upgradedClientState !== null && (y.upgradedClientState = n.Any.fromPartial(T.upgradedClientState)), y;
    }
  };
  function E() {
    return {
      revisionNumber: BigInt(0),
      revisionHeight: BigInt(0)
    };
  }
  e.Height = {
    typeUrl: "/ibc.core.client.v1.Height",
    encode(T, y = u.BinaryWriter.create()) {
      return T.revisionNumber !== BigInt(0) && y.uint32(8).uint64(T.revisionNumber), T.revisionHeight !== BigInt(0) && y.uint32(16).uint64(T.revisionHeight), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = E();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.revisionNumber = V.uint64();
            break;
          case 2:
            G.revisionHeight = V.uint64();
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = E();
      return (0, c.isSet)(T.revisionNumber) && (y.revisionNumber = BigInt(T.revisionNumber.toString())), (0, c.isSet)(T.revisionHeight) && (y.revisionHeight = BigInt(T.revisionHeight.toString())), y;
    },
    toJSON(T) {
      const y = {};
      return T.revisionNumber !== void 0 && (y.revisionNumber = (T.revisionNumber || BigInt(0)).toString()), T.revisionHeight !== void 0 && (y.revisionHeight = (T.revisionHeight || BigInt(0)).toString()), y;
    },
    fromPartial(T) {
      const y = E();
      return T.revisionNumber !== void 0 && T.revisionNumber !== null && (y.revisionNumber = BigInt(T.revisionNumber.toString())), T.revisionHeight !== void 0 && T.revisionHeight !== null && (y.revisionHeight = BigInt(T.revisionHeight.toString())), y;
    }
  };
  function O() {
    return {
      allowedClients: []
    };
  }
  e.Params = {
    typeUrl: "/ibc.core.client.v1.Params",
    encode(T, y = u.BinaryWriter.create()) {
      for (const V of T.allowedClients)
        y.uint32(10).string(V);
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = O();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.allowedClients.push(V.string());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = O();
      return Array.isArray(T == null ? void 0 : T.allowedClients) && (y.allowedClients = T.allowedClients.map((V) => String(V))), y;
    },
    toJSON(T) {
      const y = {};
      return T.allowedClients ? y.allowedClients = T.allowedClients.map((V) => V) : y.allowedClients = [], y;
    },
    fromPartial(T) {
      var V;
      const y = O();
      return y.allowedClients = ((V = T.allowedClients) == null ? void 0 : V.map((M) => M)) || [], y;
    }
  };
})(client$1);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgTransferResponse = e.MsgTransfer = e.protobufPackage = void 0;
  const n = coin$8, o = client$1, u = binary, c = helpers;
  e.protobufPackage = "ibc.applications.transfer.v1";
  function d() {
    return {
      sourcePort: "",
      sourceChannel: "",
      token: n.Coin.fromPartial({}),
      sender: "",
      receiver: "",
      timeoutHeight: o.Height.fromPartial({}),
      timeoutTimestamp: BigInt(0),
      memo: ""
    };
  }
  e.MsgTransfer = {
    typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
    encode(S, $ = u.BinaryWriter.create()) {
      return S.sourcePort !== "" && $.uint32(10).string(S.sourcePort), S.sourceChannel !== "" && $.uint32(18).string(S.sourceChannel), S.token !== void 0 && n.Coin.encode(S.token, $.uint32(26).fork()).ldelim(), S.sender !== "" && $.uint32(34).string(S.sender), S.receiver !== "" && $.uint32(42).string(S.receiver), S.timeoutHeight !== void 0 && o.Height.encode(S.timeoutHeight, $.uint32(50).fork()).ldelim(), S.timeoutTimestamp !== BigInt(0) && $.uint32(56).uint64(S.timeoutTimestamp), S.memo !== "" && $.uint32(66).string(S.memo), $;
    },
    decode(S, $) {
      const E = S instanceof u.BinaryReader ? S : new u.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = d();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.sourcePort = E.string();
            break;
          case 2:
            T.sourceChannel = E.string();
            break;
          case 3:
            T.token = n.Coin.decode(E, E.uint32());
            break;
          case 4:
            T.sender = E.string();
            break;
          case 5:
            T.receiver = E.string();
            break;
          case 6:
            T.timeoutHeight = o.Height.decode(E, E.uint32());
            break;
          case 7:
            T.timeoutTimestamp = E.uint64();
            break;
          case 8:
            T.memo = E.string();
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = d();
      return (0, c.isSet)(S.sourcePort) && ($.sourcePort = String(S.sourcePort)), (0, c.isSet)(S.sourceChannel) && ($.sourceChannel = String(S.sourceChannel)), (0, c.isSet)(S.token) && ($.token = n.Coin.fromJSON(S.token)), (0, c.isSet)(S.sender) && ($.sender = String(S.sender)), (0, c.isSet)(S.receiver) && ($.receiver = String(S.receiver)), (0, c.isSet)(S.timeoutHeight) && ($.timeoutHeight = o.Height.fromJSON(S.timeoutHeight)), (0, c.isSet)(S.timeoutTimestamp) && ($.timeoutTimestamp = BigInt(S.timeoutTimestamp.toString())), (0, c.isSet)(S.memo) && ($.memo = String(S.memo)), $;
    },
    toJSON(S) {
      const $ = {};
      return S.sourcePort !== void 0 && ($.sourcePort = S.sourcePort), S.sourceChannel !== void 0 && ($.sourceChannel = S.sourceChannel), S.token !== void 0 && ($.token = S.token ? n.Coin.toJSON(S.token) : void 0), S.sender !== void 0 && ($.sender = S.sender), S.receiver !== void 0 && ($.receiver = S.receiver), S.timeoutHeight !== void 0 && ($.timeoutHeight = S.timeoutHeight ? o.Height.toJSON(S.timeoutHeight) : void 0), S.timeoutTimestamp !== void 0 && ($.timeoutTimestamp = (S.timeoutTimestamp || BigInt(0)).toString()), S.memo !== void 0 && ($.memo = S.memo), $;
    },
    fromPartial(S) {
      const $ = d();
      return $.sourcePort = S.sourcePort ?? "", $.sourceChannel = S.sourceChannel ?? "", S.token !== void 0 && S.token !== null && ($.token = n.Coin.fromPartial(S.token)), $.sender = S.sender ?? "", $.receiver = S.receiver ?? "", S.timeoutHeight !== void 0 && S.timeoutHeight !== null && ($.timeoutHeight = o.Height.fromPartial(S.timeoutHeight)), S.timeoutTimestamp !== void 0 && S.timeoutTimestamp !== null && ($.timeoutTimestamp = BigInt(S.timeoutTimestamp.toString())), $.memo = S.memo ?? "", $;
    }
  };
  function m() {
    return {
      sequence: BigInt(0)
    };
  }
  e.MsgTransferResponse = {
    typeUrl: "/ibc.applications.transfer.v1.MsgTransferResponse",
    encode(S, $ = u.BinaryWriter.create()) {
      return S.sequence !== BigInt(0) && $.uint32(8).uint64(S.sequence), $;
    },
    decode(S, $) {
      const E = S instanceof u.BinaryReader ? S : new u.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = m();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.sequence = E.uint64();
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = m();
      return (0, c.isSet)(S.sequence) && ($.sequence = BigInt(S.sequence.toString())), $;
    },
    toJSON(S) {
      const $ = {};
      return S.sequence !== void 0 && ($.sequence = (S.sequence || BigInt(0)).toString()), $;
    },
    fromPartial(S) {
      const $ = m();
      return S.sequence !== void 0 && S.sequence !== null && ($.sequence = BigInt(S.sequence.toString())), $;
    }
  };
  class v {
    constructor($) {
      this.rpc = $, this.Transfer = this.Transfer.bind(this);
    }
    Transfer($) {
      const E = e.MsgTransfer.encode($).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", E).then((T) => e.MsgTransferResponse.decode(new u.BinaryReader(T)));
    }
  }
  e.MsgClientImpl = v;
})(tx$h);
Object.defineProperty(aminomessages$f, "__esModule", { value: !0 });
aminomessages$f.createIbcAminoConverters = aminomessages$f.isAminoMsgTransfer = void 0;
const amino_1$b = build$P, tx_1$k = tx$h;
function isAminoMsgTransfer$1(e) {
  return e.type === "cosmos-sdk/MsgTransfer";
}
aminomessages$f.isAminoMsgTransfer = isAminoMsgTransfer$1;
function createIbcAminoConverters$1() {
  return {
    "/ibc.applications.transfer.v1.MsgTransfer": {
      aminoType: "cosmos-sdk/MsgTransfer",
      toAmino: ({ sourcePort: e, sourceChannel: n, token: o, sender: u, receiver: c, timeoutHeight: d, timeoutTimestamp: m, memo: v }) => {
        var S, $, E;
        return {
          source_port: e,
          source_channel: n,
          token: o,
          sender: u,
          receiver: c,
          timeout_height: d ? {
            revision_height: (S = (0, amino_1$b.omitDefault)(d.revisionHeight)) == null ? void 0 : S.toString(),
            revision_number: ($ = (0, amino_1$b.omitDefault)(d.revisionNumber)) == null ? void 0 : $.toString()
          } : {},
          timeout_timestamp: (E = (0, amino_1$b.omitDefault)(m)) == null ? void 0 : E.toString(),
          memo: (0, amino_1$b.omitDefault)(v)
        };
      },
      fromAmino: ({ source_port: e, source_channel: n, token: o, sender: u, receiver: c, timeout_height: d, timeout_timestamp: m, memo: v }) => tx_1$k.MsgTransfer.fromPartial({
        sourcePort: e,
        sourceChannel: n,
        token: o,
        sender: u,
        receiver: c,
        timeoutHeight: d ? {
          revisionHeight: BigInt(d.revision_height || "0"),
          revisionNumber: BigInt(d.revision_number || "0")
        } : void 0,
        timeoutTimestamp: BigInt(m || "0"),
        memo: v ?? ""
      })
    }
  };
}
aminomessages$f.createIbcAminoConverters = createIbcAminoConverters$1;
var messages$c = {}, tx$g = {}, channel = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Acknowledgement = e.PacketId = e.PacketState = e.Packet = e.Counterparty = e.IdentifiedChannel = e.Channel = e.orderToJSON = e.orderFromJSON = e.Order = e.stateToJSON = e.stateFromJSON = e.State = e.protobufPackage = void 0;
  const n = client$1, o = binary, u = helpers;
  e.protobufPackage = "ibc.core.channel.v1";
  var c;
  (function(k) {
    k[k.STATE_UNINITIALIZED_UNSPECIFIED = 0] = "STATE_UNINITIALIZED_UNSPECIFIED", k[k.STATE_INIT = 1] = "STATE_INIT", k[k.STATE_TRYOPEN = 2] = "STATE_TRYOPEN", k[k.STATE_OPEN = 3] = "STATE_OPEN", k[k.STATE_CLOSED = 4] = "STATE_CLOSED", k[k.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(c || (e.State = c = {}));
  function d(k) {
    switch (k) {
      case 0:
      case "STATE_UNINITIALIZED_UNSPECIFIED":
        return c.STATE_UNINITIALIZED_UNSPECIFIED;
      case 1:
      case "STATE_INIT":
        return c.STATE_INIT;
      case 2:
      case "STATE_TRYOPEN":
        return c.STATE_TRYOPEN;
      case 3:
      case "STATE_OPEN":
        return c.STATE_OPEN;
      case 4:
      case "STATE_CLOSED":
        return c.STATE_CLOSED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return c.UNRECOGNIZED;
    }
  }
  e.stateFromJSON = d;
  function m(k) {
    switch (k) {
      case c.STATE_UNINITIALIZED_UNSPECIFIED:
        return "STATE_UNINITIALIZED_UNSPECIFIED";
      case c.STATE_INIT:
        return "STATE_INIT";
      case c.STATE_TRYOPEN:
        return "STATE_TRYOPEN";
      case c.STATE_OPEN:
        return "STATE_OPEN";
      case c.STATE_CLOSED:
        return "STATE_CLOSED";
      case c.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.stateToJSON = m;
  var v;
  (function(k) {
    k[k.ORDER_NONE_UNSPECIFIED = 0] = "ORDER_NONE_UNSPECIFIED", k[k.ORDER_UNORDERED = 1] = "ORDER_UNORDERED", k[k.ORDER_ORDERED = 2] = "ORDER_ORDERED", k[k.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(v || (e.Order = v = {}));
  function S(k) {
    switch (k) {
      case 0:
      case "ORDER_NONE_UNSPECIFIED":
        return v.ORDER_NONE_UNSPECIFIED;
      case 1:
      case "ORDER_UNORDERED":
        return v.ORDER_UNORDERED;
      case 2:
      case "ORDER_ORDERED":
        return v.ORDER_ORDERED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return v.UNRECOGNIZED;
    }
  }
  e.orderFromJSON = S;
  function $(k) {
    switch (k) {
      case v.ORDER_NONE_UNSPECIFIED:
        return "ORDER_NONE_UNSPECIFIED";
      case v.ORDER_UNORDERED:
        return "ORDER_UNORDERED";
      case v.ORDER_ORDERED:
        return "ORDER_ORDERED";
      case v.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.orderToJSON = $;
  function E() {
    return {
      state: 0,
      ordering: 0,
      counterparty: e.Counterparty.fromPartial({}),
      connectionHops: [],
      version: ""
    };
  }
  e.Channel = {
    typeUrl: "/ibc.core.channel.v1.Channel",
    encode(k, F = o.BinaryWriter.create()) {
      k.state !== 0 && F.uint32(8).int32(k.state), k.ordering !== 0 && F.uint32(16).int32(k.ordering), k.counterparty !== void 0 && e.Counterparty.encode(k.counterparty, F.uint32(26).fork()).ldelim();
      for (const X of k.connectionHops)
        F.uint32(34).string(X);
      return k.version !== "" && F.uint32(42).string(k.version), F;
    },
    decode(k, F) {
      const X = k instanceof o.BinaryReader ? k : new o.BinaryReader(k);
      let ee = F === void 0 ? X.len : X.pos + F;
      const ue = E();
      for (; X.pos < ee; ) {
        const Q = X.uint32();
        switch (Q >>> 3) {
          case 1:
            ue.state = X.int32();
            break;
          case 2:
            ue.ordering = X.int32();
            break;
          case 3:
            ue.counterparty = e.Counterparty.decode(X, X.uint32());
            break;
          case 4:
            ue.connectionHops.push(X.string());
            break;
          case 5:
            ue.version = X.string();
            break;
          default:
            X.skipType(Q & 7);
            break;
        }
      }
      return ue;
    },
    fromJSON(k) {
      const F = E();
      return (0, u.isSet)(k.state) && (F.state = d(k.state)), (0, u.isSet)(k.ordering) && (F.ordering = S(k.ordering)), (0, u.isSet)(k.counterparty) && (F.counterparty = e.Counterparty.fromJSON(k.counterparty)), Array.isArray(k == null ? void 0 : k.connectionHops) && (F.connectionHops = k.connectionHops.map((X) => String(X))), (0, u.isSet)(k.version) && (F.version = String(k.version)), F;
    },
    toJSON(k) {
      const F = {};
      return k.state !== void 0 && (F.state = m(k.state)), k.ordering !== void 0 && (F.ordering = $(k.ordering)), k.counterparty !== void 0 && (F.counterparty = k.counterparty ? e.Counterparty.toJSON(k.counterparty) : void 0), k.connectionHops ? F.connectionHops = k.connectionHops.map((X) => X) : F.connectionHops = [], k.version !== void 0 && (F.version = k.version), F;
    },
    fromPartial(k) {
      var X;
      const F = E();
      return F.state = k.state ?? 0, F.ordering = k.ordering ?? 0, k.counterparty !== void 0 && k.counterparty !== null && (F.counterparty = e.Counterparty.fromPartial(k.counterparty)), F.connectionHops = ((X = k.connectionHops) == null ? void 0 : X.map((ee) => ee)) || [], F.version = k.version ?? "", F;
    }
  };
  function O() {
    return {
      state: 0,
      ordering: 0,
      counterparty: e.Counterparty.fromPartial({}),
      connectionHops: [],
      version: "",
      portId: "",
      channelId: ""
    };
  }
  e.IdentifiedChannel = {
    typeUrl: "/ibc.core.channel.v1.IdentifiedChannel",
    encode(k, F = o.BinaryWriter.create()) {
      k.state !== 0 && F.uint32(8).int32(k.state), k.ordering !== 0 && F.uint32(16).int32(k.ordering), k.counterparty !== void 0 && e.Counterparty.encode(k.counterparty, F.uint32(26).fork()).ldelim();
      for (const X of k.connectionHops)
        F.uint32(34).string(X);
      return k.version !== "" && F.uint32(42).string(k.version), k.portId !== "" && F.uint32(50).string(k.portId), k.channelId !== "" && F.uint32(58).string(k.channelId), F;
    },
    decode(k, F) {
      const X = k instanceof o.BinaryReader ? k : new o.BinaryReader(k);
      let ee = F === void 0 ? X.len : X.pos + F;
      const ue = O();
      for (; X.pos < ee; ) {
        const Q = X.uint32();
        switch (Q >>> 3) {
          case 1:
            ue.state = X.int32();
            break;
          case 2:
            ue.ordering = X.int32();
            break;
          case 3:
            ue.counterparty = e.Counterparty.decode(X, X.uint32());
            break;
          case 4:
            ue.connectionHops.push(X.string());
            break;
          case 5:
            ue.version = X.string();
            break;
          case 6:
            ue.portId = X.string();
            break;
          case 7:
            ue.channelId = X.string();
            break;
          default:
            X.skipType(Q & 7);
            break;
        }
      }
      return ue;
    },
    fromJSON(k) {
      const F = O();
      return (0, u.isSet)(k.state) && (F.state = d(k.state)), (0, u.isSet)(k.ordering) && (F.ordering = S(k.ordering)), (0, u.isSet)(k.counterparty) && (F.counterparty = e.Counterparty.fromJSON(k.counterparty)), Array.isArray(k == null ? void 0 : k.connectionHops) && (F.connectionHops = k.connectionHops.map((X) => String(X))), (0, u.isSet)(k.version) && (F.version = String(k.version)), (0, u.isSet)(k.portId) && (F.portId = String(k.portId)), (0, u.isSet)(k.channelId) && (F.channelId = String(k.channelId)), F;
    },
    toJSON(k) {
      const F = {};
      return k.state !== void 0 && (F.state = m(k.state)), k.ordering !== void 0 && (F.ordering = $(k.ordering)), k.counterparty !== void 0 && (F.counterparty = k.counterparty ? e.Counterparty.toJSON(k.counterparty) : void 0), k.connectionHops ? F.connectionHops = k.connectionHops.map((X) => X) : F.connectionHops = [], k.version !== void 0 && (F.version = k.version), k.portId !== void 0 && (F.portId = k.portId), k.channelId !== void 0 && (F.channelId = k.channelId), F;
    },
    fromPartial(k) {
      var X;
      const F = O();
      return F.state = k.state ?? 0, F.ordering = k.ordering ?? 0, k.counterparty !== void 0 && k.counterparty !== null && (F.counterparty = e.Counterparty.fromPartial(k.counterparty)), F.connectionHops = ((X = k.connectionHops) == null ? void 0 : X.map((ee) => ee)) || [], F.version = k.version ?? "", F.portId = k.portId ?? "", F.channelId = k.channelId ?? "", F;
    }
  };
  function T() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.Counterparty = {
    typeUrl: "/ibc.core.channel.v1.Counterparty",
    encode(k, F = o.BinaryWriter.create()) {
      return k.portId !== "" && F.uint32(10).string(k.portId), k.channelId !== "" && F.uint32(18).string(k.channelId), F;
    },
    decode(k, F) {
      const X = k instanceof o.BinaryReader ? k : new o.BinaryReader(k);
      let ee = F === void 0 ? X.len : X.pos + F;
      const ue = T();
      for (; X.pos < ee; ) {
        const Q = X.uint32();
        switch (Q >>> 3) {
          case 1:
            ue.portId = X.string();
            break;
          case 2:
            ue.channelId = X.string();
            break;
          default:
            X.skipType(Q & 7);
            break;
        }
      }
      return ue;
    },
    fromJSON(k) {
      const F = T();
      return (0, u.isSet)(k.portId) && (F.portId = String(k.portId)), (0, u.isSet)(k.channelId) && (F.channelId = String(k.channelId)), F;
    },
    toJSON(k) {
      const F = {};
      return k.portId !== void 0 && (F.portId = k.portId), k.channelId !== void 0 && (F.channelId = k.channelId), F;
    },
    fromPartial(k) {
      const F = T();
      return F.portId = k.portId ?? "", F.channelId = k.channelId ?? "", F;
    }
  };
  function y() {
    return {
      sequence: BigInt(0),
      sourcePort: "",
      sourceChannel: "",
      destinationPort: "",
      destinationChannel: "",
      data: new Uint8Array(),
      timeoutHeight: n.Height.fromPartial({}),
      timeoutTimestamp: BigInt(0)
    };
  }
  e.Packet = {
    typeUrl: "/ibc.core.channel.v1.Packet",
    encode(k, F = o.BinaryWriter.create()) {
      return k.sequence !== BigInt(0) && F.uint32(8).uint64(k.sequence), k.sourcePort !== "" && F.uint32(18).string(k.sourcePort), k.sourceChannel !== "" && F.uint32(26).string(k.sourceChannel), k.destinationPort !== "" && F.uint32(34).string(k.destinationPort), k.destinationChannel !== "" && F.uint32(42).string(k.destinationChannel), k.data.length !== 0 && F.uint32(50).bytes(k.data), k.timeoutHeight !== void 0 && n.Height.encode(k.timeoutHeight, F.uint32(58).fork()).ldelim(), k.timeoutTimestamp !== BigInt(0) && F.uint32(64).uint64(k.timeoutTimestamp), F;
    },
    decode(k, F) {
      const X = k instanceof o.BinaryReader ? k : new o.BinaryReader(k);
      let ee = F === void 0 ? X.len : X.pos + F;
      const ue = y();
      for (; X.pos < ee; ) {
        const Q = X.uint32();
        switch (Q >>> 3) {
          case 1:
            ue.sequence = X.uint64();
            break;
          case 2:
            ue.sourcePort = X.string();
            break;
          case 3:
            ue.sourceChannel = X.string();
            break;
          case 4:
            ue.destinationPort = X.string();
            break;
          case 5:
            ue.destinationChannel = X.string();
            break;
          case 6:
            ue.data = X.bytes();
            break;
          case 7:
            ue.timeoutHeight = n.Height.decode(X, X.uint32());
            break;
          case 8:
            ue.timeoutTimestamp = X.uint64();
            break;
          default:
            X.skipType(Q & 7);
            break;
        }
      }
      return ue;
    },
    fromJSON(k) {
      const F = y();
      return (0, u.isSet)(k.sequence) && (F.sequence = BigInt(k.sequence.toString())), (0, u.isSet)(k.sourcePort) && (F.sourcePort = String(k.sourcePort)), (0, u.isSet)(k.sourceChannel) && (F.sourceChannel = String(k.sourceChannel)), (0, u.isSet)(k.destinationPort) && (F.destinationPort = String(k.destinationPort)), (0, u.isSet)(k.destinationChannel) && (F.destinationChannel = String(k.destinationChannel)), (0, u.isSet)(k.data) && (F.data = (0, u.bytesFromBase64)(k.data)), (0, u.isSet)(k.timeoutHeight) && (F.timeoutHeight = n.Height.fromJSON(k.timeoutHeight)), (0, u.isSet)(k.timeoutTimestamp) && (F.timeoutTimestamp = BigInt(k.timeoutTimestamp.toString())), F;
    },
    toJSON(k) {
      const F = {};
      return k.sequence !== void 0 && (F.sequence = (k.sequence || BigInt(0)).toString()), k.sourcePort !== void 0 && (F.sourcePort = k.sourcePort), k.sourceChannel !== void 0 && (F.sourceChannel = k.sourceChannel), k.destinationPort !== void 0 && (F.destinationPort = k.destinationPort), k.destinationChannel !== void 0 && (F.destinationChannel = k.destinationChannel), k.data !== void 0 && (F.data = (0, u.base64FromBytes)(k.data !== void 0 ? k.data : new Uint8Array())), k.timeoutHeight !== void 0 && (F.timeoutHeight = k.timeoutHeight ? n.Height.toJSON(k.timeoutHeight) : void 0), k.timeoutTimestamp !== void 0 && (F.timeoutTimestamp = (k.timeoutTimestamp || BigInt(0)).toString()), F;
    },
    fromPartial(k) {
      const F = y();
      return k.sequence !== void 0 && k.sequence !== null && (F.sequence = BigInt(k.sequence.toString())), F.sourcePort = k.sourcePort ?? "", F.sourceChannel = k.sourceChannel ?? "", F.destinationPort = k.destinationPort ?? "", F.destinationChannel = k.destinationChannel ?? "", F.data = k.data ?? new Uint8Array(), k.timeoutHeight !== void 0 && k.timeoutHeight !== null && (F.timeoutHeight = n.Height.fromPartial(k.timeoutHeight)), k.timeoutTimestamp !== void 0 && k.timeoutTimestamp !== null && (F.timeoutTimestamp = BigInt(k.timeoutTimestamp.toString())), F;
    }
  };
  function V() {
    return {
      portId: "",
      channelId: "",
      sequence: BigInt(0),
      data: new Uint8Array()
    };
  }
  e.PacketState = {
    typeUrl: "/ibc.core.channel.v1.PacketState",
    encode(k, F = o.BinaryWriter.create()) {
      return k.portId !== "" && F.uint32(10).string(k.portId), k.channelId !== "" && F.uint32(18).string(k.channelId), k.sequence !== BigInt(0) && F.uint32(24).uint64(k.sequence), k.data.length !== 0 && F.uint32(34).bytes(k.data), F;
    },
    decode(k, F) {
      const X = k instanceof o.BinaryReader ? k : new o.BinaryReader(k);
      let ee = F === void 0 ? X.len : X.pos + F;
      const ue = V();
      for (; X.pos < ee; ) {
        const Q = X.uint32();
        switch (Q >>> 3) {
          case 1:
            ue.portId = X.string();
            break;
          case 2:
            ue.channelId = X.string();
            break;
          case 3:
            ue.sequence = X.uint64();
            break;
          case 4:
            ue.data = X.bytes();
            break;
          default:
            X.skipType(Q & 7);
            break;
        }
      }
      return ue;
    },
    fromJSON(k) {
      const F = V();
      return (0, u.isSet)(k.portId) && (F.portId = String(k.portId)), (0, u.isSet)(k.channelId) && (F.channelId = String(k.channelId)), (0, u.isSet)(k.sequence) && (F.sequence = BigInt(k.sequence.toString())), (0, u.isSet)(k.data) && (F.data = (0, u.bytesFromBase64)(k.data)), F;
    },
    toJSON(k) {
      const F = {};
      return k.portId !== void 0 && (F.portId = k.portId), k.channelId !== void 0 && (F.channelId = k.channelId), k.sequence !== void 0 && (F.sequence = (k.sequence || BigInt(0)).toString()), k.data !== void 0 && (F.data = (0, u.base64FromBytes)(k.data !== void 0 ? k.data : new Uint8Array())), F;
    },
    fromPartial(k) {
      const F = V();
      return F.portId = k.portId ?? "", F.channelId = k.channelId ?? "", k.sequence !== void 0 && k.sequence !== null && (F.sequence = BigInt(k.sequence.toString())), F.data = k.data ?? new Uint8Array(), F;
    }
  };
  function M() {
    return {
      portId: "",
      channelId: "",
      sequence: BigInt(0)
    };
  }
  e.PacketId = {
    typeUrl: "/ibc.core.channel.v1.PacketId",
    encode(k, F = o.BinaryWriter.create()) {
      return k.portId !== "" && F.uint32(10).string(k.portId), k.channelId !== "" && F.uint32(18).string(k.channelId), k.sequence !== BigInt(0) && F.uint32(24).uint64(k.sequence), F;
    },
    decode(k, F) {
      const X = k instanceof o.BinaryReader ? k : new o.BinaryReader(k);
      let ee = F === void 0 ? X.len : X.pos + F;
      const ue = M();
      for (; X.pos < ee; ) {
        const Q = X.uint32();
        switch (Q >>> 3) {
          case 1:
            ue.portId = X.string();
            break;
          case 2:
            ue.channelId = X.string();
            break;
          case 3:
            ue.sequence = X.uint64();
            break;
          default:
            X.skipType(Q & 7);
            break;
        }
      }
      return ue;
    },
    fromJSON(k) {
      const F = M();
      return (0, u.isSet)(k.portId) && (F.portId = String(k.portId)), (0, u.isSet)(k.channelId) && (F.channelId = String(k.channelId)), (0, u.isSet)(k.sequence) && (F.sequence = BigInt(k.sequence.toString())), F;
    },
    toJSON(k) {
      const F = {};
      return k.portId !== void 0 && (F.portId = k.portId), k.channelId !== void 0 && (F.channelId = k.channelId), k.sequence !== void 0 && (F.sequence = (k.sequence || BigInt(0)).toString()), F;
    },
    fromPartial(k) {
      const F = M();
      return F.portId = k.portId ?? "", F.channelId = k.channelId ?? "", k.sequence !== void 0 && k.sequence !== null && (F.sequence = BigInt(k.sequence.toString())), F;
    }
  };
  function G() {
    return {
      result: void 0,
      error: void 0
    };
  }
  e.Acknowledgement = {
    typeUrl: "/ibc.core.channel.v1.Acknowledgement",
    encode(k, F = o.BinaryWriter.create()) {
      return k.result !== void 0 && F.uint32(170).bytes(k.result), k.error !== void 0 && F.uint32(178).string(k.error), F;
    },
    decode(k, F) {
      const X = k instanceof o.BinaryReader ? k : new o.BinaryReader(k);
      let ee = F === void 0 ? X.len : X.pos + F;
      const ue = G();
      for (; X.pos < ee; ) {
        const Q = X.uint32();
        switch (Q >>> 3) {
          case 21:
            ue.result = X.bytes();
            break;
          case 22:
            ue.error = X.string();
            break;
          default:
            X.skipType(Q & 7);
            break;
        }
      }
      return ue;
    },
    fromJSON(k) {
      const F = G();
      return (0, u.isSet)(k.result) && (F.result = (0, u.bytesFromBase64)(k.result)), (0, u.isSet)(k.error) && (F.error = String(k.error)), F;
    },
    toJSON(k) {
      const F = {};
      return k.result !== void 0 && (F.result = k.result !== void 0 ? (0, u.base64FromBytes)(k.result) : void 0), k.error !== void 0 && (F.error = k.error), F;
    },
    fromPartial(k) {
      const F = G();
      return F.result = k.result ?? void 0, F.error = k.error ?? void 0, F;
    }
  };
})(channel);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgAcknowledgementResponse = e.MsgAcknowledgement = e.MsgTimeoutOnCloseResponse = e.MsgTimeoutOnClose = e.MsgTimeoutResponse = e.MsgTimeout = e.MsgRecvPacketResponse = e.MsgRecvPacket = e.MsgChannelCloseConfirmResponse = e.MsgChannelCloseConfirm = e.MsgChannelCloseInitResponse = e.MsgChannelCloseInit = e.MsgChannelOpenConfirmResponse = e.MsgChannelOpenConfirm = e.MsgChannelOpenAckResponse = e.MsgChannelOpenAck = e.MsgChannelOpenTryResponse = e.MsgChannelOpenTry = e.MsgChannelOpenInitResponse = e.MsgChannelOpenInit = e.responseResultTypeToJSON = e.responseResultTypeFromJSON = e.ResponseResultType = e.protobufPackage = void 0;
  const n = channel, o = client$1, u = binary, c = helpers;
  e.protobufPackage = "ibc.core.channel.v1";
  var d;
  (function(w) {
    w[w.RESPONSE_RESULT_TYPE_UNSPECIFIED = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED", w[w.RESPONSE_RESULT_TYPE_NOOP = 1] = "RESPONSE_RESULT_TYPE_NOOP", w[w.RESPONSE_RESULT_TYPE_SUCCESS = 2] = "RESPONSE_RESULT_TYPE_SUCCESS", w[w.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(d || (e.ResponseResultType = d = {}));
  function m(w) {
    switch (w) {
      case 0:
      case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
        return d.RESPONSE_RESULT_TYPE_UNSPECIFIED;
      case 1:
      case "RESPONSE_RESULT_TYPE_NOOP":
        return d.RESPONSE_RESULT_TYPE_NOOP;
      case 2:
      case "RESPONSE_RESULT_TYPE_SUCCESS":
        return d.RESPONSE_RESULT_TYPE_SUCCESS;
      case -1:
      case "UNRECOGNIZED":
      default:
        return d.UNRECOGNIZED;
    }
  }
  e.responseResultTypeFromJSON = m;
  function v(w) {
    switch (w) {
      case d.RESPONSE_RESULT_TYPE_UNSPECIFIED:
        return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
      case d.RESPONSE_RESULT_TYPE_NOOP:
        return "RESPONSE_RESULT_TYPE_NOOP";
      case d.RESPONSE_RESULT_TYPE_SUCCESS:
        return "RESPONSE_RESULT_TYPE_SUCCESS";
      case d.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseResultTypeToJSON = v;
  function S() {
    return {
      portId: "",
      channel: n.Channel.fromPartial({}),
      signer: ""
    };
  }
  e.MsgChannelOpenInit = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
    encode(w, P = u.BinaryWriter.create()) {
      return w.portId !== "" && P.uint32(10).string(w.portId), w.channel !== void 0 && n.Channel.encode(w.channel, P.uint32(18).fork()).ldelim(), w.signer !== "" && P.uint32(26).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = S();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.portId = J.string();
            break;
          case 2:
            fe.channel = n.Channel.decode(J, J.uint32());
            break;
          case 3:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = S();
      return (0, c.isSet)(w.portId) && (P.portId = String(w.portId)), (0, c.isSet)(w.channel) && (P.channel = n.Channel.fromJSON(w.channel)), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.portId !== void 0 && (P.portId = w.portId), w.channel !== void 0 && (P.channel = w.channel ? n.Channel.toJSON(w.channel) : void 0), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = S();
      return P.portId = w.portId ?? "", w.channel !== void 0 && w.channel !== null && (P.channel = n.Channel.fromPartial(w.channel)), P.signer = w.signer ?? "", P;
    }
  };
  function $() {
    return {
      channelId: "",
      version: ""
    };
  }
  e.MsgChannelOpenInitResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInitResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.channelId !== "" && P.uint32(10).string(w.channelId), w.version !== "" && P.uint32(18).string(w.version), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = $();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.channelId = J.string();
            break;
          case 2:
            fe.version = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = $();
      return (0, c.isSet)(w.channelId) && (P.channelId = String(w.channelId)), (0, c.isSet)(w.version) && (P.version = String(w.version)), P;
    },
    toJSON(w) {
      const P = {};
      return w.channelId !== void 0 && (P.channelId = w.channelId), w.version !== void 0 && (P.version = w.version), P;
    },
    fromPartial(w) {
      const P = $();
      return P.channelId = w.channelId ?? "", P.version = w.version ?? "", P;
    }
  };
  function E() {
    return {
      portId: "",
      previousChannelId: "",
      channel: n.Channel.fromPartial({}),
      counterpartyVersion: "",
      proofInit: new Uint8Array(),
      proofHeight: o.Height.fromPartial({}),
      signer: ""
    };
  }
  e.MsgChannelOpenTry = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
    encode(w, P = u.BinaryWriter.create()) {
      return w.portId !== "" && P.uint32(10).string(w.portId), w.previousChannelId !== "" && P.uint32(18).string(w.previousChannelId), w.channel !== void 0 && n.Channel.encode(w.channel, P.uint32(26).fork()).ldelim(), w.counterpartyVersion !== "" && P.uint32(34).string(w.counterpartyVersion), w.proofInit.length !== 0 && P.uint32(42).bytes(w.proofInit), w.proofHeight !== void 0 && o.Height.encode(w.proofHeight, P.uint32(50).fork()).ldelim(), w.signer !== "" && P.uint32(58).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = E();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.portId = J.string();
            break;
          case 2:
            fe.previousChannelId = J.string();
            break;
          case 3:
            fe.channel = n.Channel.decode(J, J.uint32());
            break;
          case 4:
            fe.counterpartyVersion = J.string();
            break;
          case 5:
            fe.proofInit = J.bytes();
            break;
          case 6:
            fe.proofHeight = o.Height.decode(J, J.uint32());
            break;
          case 7:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = E();
      return (0, c.isSet)(w.portId) && (P.portId = String(w.portId)), (0, c.isSet)(w.previousChannelId) && (P.previousChannelId = String(w.previousChannelId)), (0, c.isSet)(w.channel) && (P.channel = n.Channel.fromJSON(w.channel)), (0, c.isSet)(w.counterpartyVersion) && (P.counterpartyVersion = String(w.counterpartyVersion)), (0, c.isSet)(w.proofInit) && (P.proofInit = (0, c.bytesFromBase64)(w.proofInit)), (0, c.isSet)(w.proofHeight) && (P.proofHeight = o.Height.fromJSON(w.proofHeight)), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.portId !== void 0 && (P.portId = w.portId), w.previousChannelId !== void 0 && (P.previousChannelId = w.previousChannelId), w.channel !== void 0 && (P.channel = w.channel ? n.Channel.toJSON(w.channel) : void 0), w.counterpartyVersion !== void 0 && (P.counterpartyVersion = w.counterpartyVersion), w.proofInit !== void 0 && (P.proofInit = (0, c.base64FromBytes)(w.proofInit !== void 0 ? w.proofInit : new Uint8Array())), w.proofHeight !== void 0 && (P.proofHeight = w.proofHeight ? o.Height.toJSON(w.proofHeight) : void 0), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = E();
      return P.portId = w.portId ?? "", P.previousChannelId = w.previousChannelId ?? "", w.channel !== void 0 && w.channel !== null && (P.channel = n.Channel.fromPartial(w.channel)), P.counterpartyVersion = w.counterpartyVersion ?? "", P.proofInit = w.proofInit ?? new Uint8Array(), w.proofHeight !== void 0 && w.proofHeight !== null && (P.proofHeight = o.Height.fromPartial(w.proofHeight)), P.signer = w.signer ?? "", P;
    }
  };
  function O() {
    return {
      version: ""
    };
  }
  e.MsgChannelOpenTryResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTryResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.version !== "" && P.uint32(10).string(w.version), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = O();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.version = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = O();
      return (0, c.isSet)(w.version) && (P.version = String(w.version)), P;
    },
    toJSON(w) {
      const P = {};
      return w.version !== void 0 && (P.version = w.version), P;
    },
    fromPartial(w) {
      const P = O();
      return P.version = w.version ?? "", P;
    }
  };
  function T() {
    return {
      portId: "",
      channelId: "",
      counterpartyChannelId: "",
      counterpartyVersion: "",
      proofTry: new Uint8Array(),
      proofHeight: o.Height.fromPartial({}),
      signer: ""
    };
  }
  e.MsgChannelOpenAck = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
    encode(w, P = u.BinaryWriter.create()) {
      return w.portId !== "" && P.uint32(10).string(w.portId), w.channelId !== "" && P.uint32(18).string(w.channelId), w.counterpartyChannelId !== "" && P.uint32(26).string(w.counterpartyChannelId), w.counterpartyVersion !== "" && P.uint32(34).string(w.counterpartyVersion), w.proofTry.length !== 0 && P.uint32(42).bytes(w.proofTry), w.proofHeight !== void 0 && o.Height.encode(w.proofHeight, P.uint32(50).fork()).ldelim(), w.signer !== "" && P.uint32(58).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = T();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.portId = J.string();
            break;
          case 2:
            fe.channelId = J.string();
            break;
          case 3:
            fe.counterpartyChannelId = J.string();
            break;
          case 4:
            fe.counterpartyVersion = J.string();
            break;
          case 5:
            fe.proofTry = J.bytes();
            break;
          case 6:
            fe.proofHeight = o.Height.decode(J, J.uint32());
            break;
          case 7:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = T();
      return (0, c.isSet)(w.portId) && (P.portId = String(w.portId)), (0, c.isSet)(w.channelId) && (P.channelId = String(w.channelId)), (0, c.isSet)(w.counterpartyChannelId) && (P.counterpartyChannelId = String(w.counterpartyChannelId)), (0, c.isSet)(w.counterpartyVersion) && (P.counterpartyVersion = String(w.counterpartyVersion)), (0, c.isSet)(w.proofTry) && (P.proofTry = (0, c.bytesFromBase64)(w.proofTry)), (0, c.isSet)(w.proofHeight) && (P.proofHeight = o.Height.fromJSON(w.proofHeight)), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.portId !== void 0 && (P.portId = w.portId), w.channelId !== void 0 && (P.channelId = w.channelId), w.counterpartyChannelId !== void 0 && (P.counterpartyChannelId = w.counterpartyChannelId), w.counterpartyVersion !== void 0 && (P.counterpartyVersion = w.counterpartyVersion), w.proofTry !== void 0 && (P.proofTry = (0, c.base64FromBytes)(w.proofTry !== void 0 ? w.proofTry : new Uint8Array())), w.proofHeight !== void 0 && (P.proofHeight = w.proofHeight ? o.Height.toJSON(w.proofHeight) : void 0), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = T();
      return P.portId = w.portId ?? "", P.channelId = w.channelId ?? "", P.counterpartyChannelId = w.counterpartyChannelId ?? "", P.counterpartyVersion = w.counterpartyVersion ?? "", P.proofTry = w.proofTry ?? new Uint8Array(), w.proofHeight !== void 0 && w.proofHeight !== null && (P.proofHeight = o.Height.fromPartial(w.proofHeight)), P.signer = w.signer ?? "", P;
    }
  };
  function y() {
    return {};
  }
  e.MsgChannelOpenAckResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAckResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = y();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      return y();
    },
    toJSON(w) {
      return {};
    },
    fromPartial(w) {
      return y();
    }
  };
  function V() {
    return {
      portId: "",
      channelId: "",
      proofAck: new Uint8Array(),
      proofHeight: o.Height.fromPartial({}),
      signer: ""
    };
  }
  e.MsgChannelOpenConfirm = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
    encode(w, P = u.BinaryWriter.create()) {
      return w.portId !== "" && P.uint32(10).string(w.portId), w.channelId !== "" && P.uint32(18).string(w.channelId), w.proofAck.length !== 0 && P.uint32(26).bytes(w.proofAck), w.proofHeight !== void 0 && o.Height.encode(w.proofHeight, P.uint32(34).fork()).ldelim(), w.signer !== "" && P.uint32(42).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = V();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.portId = J.string();
            break;
          case 2:
            fe.channelId = J.string();
            break;
          case 3:
            fe.proofAck = J.bytes();
            break;
          case 4:
            fe.proofHeight = o.Height.decode(J, J.uint32());
            break;
          case 5:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = V();
      return (0, c.isSet)(w.portId) && (P.portId = String(w.portId)), (0, c.isSet)(w.channelId) && (P.channelId = String(w.channelId)), (0, c.isSet)(w.proofAck) && (P.proofAck = (0, c.bytesFromBase64)(w.proofAck)), (0, c.isSet)(w.proofHeight) && (P.proofHeight = o.Height.fromJSON(w.proofHeight)), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.portId !== void 0 && (P.portId = w.portId), w.channelId !== void 0 && (P.channelId = w.channelId), w.proofAck !== void 0 && (P.proofAck = (0, c.base64FromBytes)(w.proofAck !== void 0 ? w.proofAck : new Uint8Array())), w.proofHeight !== void 0 && (P.proofHeight = w.proofHeight ? o.Height.toJSON(w.proofHeight) : void 0), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = V();
      return P.portId = w.portId ?? "", P.channelId = w.channelId ?? "", P.proofAck = w.proofAck ?? new Uint8Array(), w.proofHeight !== void 0 && w.proofHeight !== null && (P.proofHeight = o.Height.fromPartial(w.proofHeight)), P.signer = w.signer ?? "", P;
    }
  };
  function M() {
    return {};
  }
  e.MsgChannelOpenConfirmResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirmResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = M();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      return M();
    },
    toJSON(w) {
      return {};
    },
    fromPartial(w) {
      return M();
    }
  };
  function G() {
    return {
      portId: "",
      channelId: "",
      signer: ""
    };
  }
  e.MsgChannelCloseInit = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
    encode(w, P = u.BinaryWriter.create()) {
      return w.portId !== "" && P.uint32(10).string(w.portId), w.channelId !== "" && P.uint32(18).string(w.channelId), w.signer !== "" && P.uint32(26).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = G();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.portId = J.string();
            break;
          case 2:
            fe.channelId = J.string();
            break;
          case 3:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = G();
      return (0, c.isSet)(w.portId) && (P.portId = String(w.portId)), (0, c.isSet)(w.channelId) && (P.channelId = String(w.channelId)), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.portId !== void 0 && (P.portId = w.portId), w.channelId !== void 0 && (P.channelId = w.channelId), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = G();
      return P.portId = w.portId ?? "", P.channelId = w.channelId ?? "", P.signer = w.signer ?? "", P;
    }
  };
  function k() {
    return {};
  }
  e.MsgChannelCloseInitResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInitResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = k();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      return k();
    },
    toJSON(w) {
      return {};
    },
    fromPartial(w) {
      return k();
    }
  };
  function F() {
    return {
      portId: "",
      channelId: "",
      proofInit: new Uint8Array(),
      proofHeight: o.Height.fromPartial({}),
      signer: ""
    };
  }
  e.MsgChannelCloseConfirm = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
    encode(w, P = u.BinaryWriter.create()) {
      return w.portId !== "" && P.uint32(10).string(w.portId), w.channelId !== "" && P.uint32(18).string(w.channelId), w.proofInit.length !== 0 && P.uint32(26).bytes(w.proofInit), w.proofHeight !== void 0 && o.Height.encode(w.proofHeight, P.uint32(34).fork()).ldelim(), w.signer !== "" && P.uint32(42).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = F();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.portId = J.string();
            break;
          case 2:
            fe.channelId = J.string();
            break;
          case 3:
            fe.proofInit = J.bytes();
            break;
          case 4:
            fe.proofHeight = o.Height.decode(J, J.uint32());
            break;
          case 5:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = F();
      return (0, c.isSet)(w.portId) && (P.portId = String(w.portId)), (0, c.isSet)(w.channelId) && (P.channelId = String(w.channelId)), (0, c.isSet)(w.proofInit) && (P.proofInit = (0, c.bytesFromBase64)(w.proofInit)), (0, c.isSet)(w.proofHeight) && (P.proofHeight = o.Height.fromJSON(w.proofHeight)), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.portId !== void 0 && (P.portId = w.portId), w.channelId !== void 0 && (P.channelId = w.channelId), w.proofInit !== void 0 && (P.proofInit = (0, c.base64FromBytes)(w.proofInit !== void 0 ? w.proofInit : new Uint8Array())), w.proofHeight !== void 0 && (P.proofHeight = w.proofHeight ? o.Height.toJSON(w.proofHeight) : void 0), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = F();
      return P.portId = w.portId ?? "", P.channelId = w.channelId ?? "", P.proofInit = w.proofInit ?? new Uint8Array(), w.proofHeight !== void 0 && w.proofHeight !== null && (P.proofHeight = o.Height.fromPartial(w.proofHeight)), P.signer = w.signer ?? "", P;
    }
  };
  function X() {
    return {};
  }
  e.MsgChannelCloseConfirmResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirmResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = X();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      return X();
    },
    toJSON(w) {
      return {};
    },
    fromPartial(w) {
      return X();
    }
  };
  function ee() {
    return {
      packet: n.Packet.fromPartial({}),
      proofCommitment: new Uint8Array(),
      proofHeight: o.Height.fromPartial({}),
      signer: ""
    };
  }
  e.MsgRecvPacket = {
    typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
    encode(w, P = u.BinaryWriter.create()) {
      return w.packet !== void 0 && n.Packet.encode(w.packet, P.uint32(10).fork()).ldelim(), w.proofCommitment.length !== 0 && P.uint32(18).bytes(w.proofCommitment), w.proofHeight !== void 0 && o.Height.encode(w.proofHeight, P.uint32(26).fork()).ldelim(), w.signer !== "" && P.uint32(34).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = ee();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.packet = n.Packet.decode(J, J.uint32());
            break;
          case 2:
            fe.proofCommitment = J.bytes();
            break;
          case 3:
            fe.proofHeight = o.Height.decode(J, J.uint32());
            break;
          case 4:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = ee();
      return (0, c.isSet)(w.packet) && (P.packet = n.Packet.fromJSON(w.packet)), (0, c.isSet)(w.proofCommitment) && (P.proofCommitment = (0, c.bytesFromBase64)(w.proofCommitment)), (0, c.isSet)(w.proofHeight) && (P.proofHeight = o.Height.fromJSON(w.proofHeight)), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.packet !== void 0 && (P.packet = w.packet ? n.Packet.toJSON(w.packet) : void 0), w.proofCommitment !== void 0 && (P.proofCommitment = (0, c.base64FromBytes)(w.proofCommitment !== void 0 ? w.proofCommitment : new Uint8Array())), w.proofHeight !== void 0 && (P.proofHeight = w.proofHeight ? o.Height.toJSON(w.proofHeight) : void 0), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = ee();
      return w.packet !== void 0 && w.packet !== null && (P.packet = n.Packet.fromPartial(w.packet)), P.proofCommitment = w.proofCommitment ?? new Uint8Array(), w.proofHeight !== void 0 && w.proofHeight !== null && (P.proofHeight = o.Height.fromPartial(w.proofHeight)), P.signer = w.signer ?? "", P;
    }
  };
  function ue() {
    return {
      result: 0
    };
  }
  e.MsgRecvPacketResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgRecvPacketResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.result !== 0 && P.uint32(8).int32(w.result), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = ue();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.result = J.int32();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = ue();
      return (0, c.isSet)(w.result) && (P.result = m(w.result)), P;
    },
    toJSON(w) {
      const P = {};
      return w.result !== void 0 && (P.result = v(w.result)), P;
    },
    fromPartial(w) {
      const P = ue();
      return P.result = w.result ?? 0, P;
    }
  };
  function Q() {
    return {
      packet: n.Packet.fromPartial({}),
      proofUnreceived: new Uint8Array(),
      proofHeight: o.Height.fromPartial({}),
      nextSequenceRecv: BigInt(0),
      signer: ""
    };
  }
  e.MsgTimeout = {
    typeUrl: "/ibc.core.channel.v1.MsgTimeout",
    encode(w, P = u.BinaryWriter.create()) {
      return w.packet !== void 0 && n.Packet.encode(w.packet, P.uint32(10).fork()).ldelim(), w.proofUnreceived.length !== 0 && P.uint32(18).bytes(w.proofUnreceived), w.proofHeight !== void 0 && o.Height.encode(w.proofHeight, P.uint32(26).fork()).ldelim(), w.nextSequenceRecv !== BigInt(0) && P.uint32(32).uint64(w.nextSequenceRecv), w.signer !== "" && P.uint32(42).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = Q();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.packet = n.Packet.decode(J, J.uint32());
            break;
          case 2:
            fe.proofUnreceived = J.bytes();
            break;
          case 3:
            fe.proofHeight = o.Height.decode(J, J.uint32());
            break;
          case 4:
            fe.nextSequenceRecv = J.uint64();
            break;
          case 5:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = Q();
      return (0, c.isSet)(w.packet) && (P.packet = n.Packet.fromJSON(w.packet)), (0, c.isSet)(w.proofUnreceived) && (P.proofUnreceived = (0, c.bytesFromBase64)(w.proofUnreceived)), (0, c.isSet)(w.proofHeight) && (P.proofHeight = o.Height.fromJSON(w.proofHeight)), (0, c.isSet)(w.nextSequenceRecv) && (P.nextSequenceRecv = BigInt(w.nextSequenceRecv.toString())), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.packet !== void 0 && (P.packet = w.packet ? n.Packet.toJSON(w.packet) : void 0), w.proofUnreceived !== void 0 && (P.proofUnreceived = (0, c.base64FromBytes)(w.proofUnreceived !== void 0 ? w.proofUnreceived : new Uint8Array())), w.proofHeight !== void 0 && (P.proofHeight = w.proofHeight ? o.Height.toJSON(w.proofHeight) : void 0), w.nextSequenceRecv !== void 0 && (P.nextSequenceRecv = (w.nextSequenceRecv || BigInt(0)).toString()), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = Q();
      return w.packet !== void 0 && w.packet !== null && (P.packet = n.Packet.fromPartial(w.packet)), P.proofUnreceived = w.proofUnreceived ?? new Uint8Array(), w.proofHeight !== void 0 && w.proofHeight !== null && (P.proofHeight = o.Height.fromPartial(w.proofHeight)), w.nextSequenceRecv !== void 0 && w.nextSequenceRecv !== null && (P.nextSequenceRecv = BigInt(w.nextSequenceRecv.toString())), P.signer = w.signer ?? "", P;
    }
  };
  function Y() {
    return {
      result: 0
    };
  }
  e.MsgTimeoutResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgTimeoutResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.result !== 0 && P.uint32(8).int32(w.result), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = Y();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.result = J.int32();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = Y();
      return (0, c.isSet)(w.result) && (P.result = m(w.result)), P;
    },
    toJSON(w) {
      const P = {};
      return w.result !== void 0 && (P.result = v(w.result)), P;
    },
    fromPartial(w) {
      const P = Y();
      return P.result = w.result ?? 0, P;
    }
  };
  function pe() {
    return {
      packet: n.Packet.fromPartial({}),
      proofUnreceived: new Uint8Array(),
      proofClose: new Uint8Array(),
      proofHeight: o.Height.fromPartial({}),
      nextSequenceRecv: BigInt(0),
      signer: ""
    };
  }
  e.MsgTimeoutOnClose = {
    typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
    encode(w, P = u.BinaryWriter.create()) {
      return w.packet !== void 0 && n.Packet.encode(w.packet, P.uint32(10).fork()).ldelim(), w.proofUnreceived.length !== 0 && P.uint32(18).bytes(w.proofUnreceived), w.proofClose.length !== 0 && P.uint32(26).bytes(w.proofClose), w.proofHeight !== void 0 && o.Height.encode(w.proofHeight, P.uint32(34).fork()).ldelim(), w.nextSequenceRecv !== BigInt(0) && P.uint32(40).uint64(w.nextSequenceRecv), w.signer !== "" && P.uint32(50).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = pe();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.packet = n.Packet.decode(J, J.uint32());
            break;
          case 2:
            fe.proofUnreceived = J.bytes();
            break;
          case 3:
            fe.proofClose = J.bytes();
            break;
          case 4:
            fe.proofHeight = o.Height.decode(J, J.uint32());
            break;
          case 5:
            fe.nextSequenceRecv = J.uint64();
            break;
          case 6:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = pe();
      return (0, c.isSet)(w.packet) && (P.packet = n.Packet.fromJSON(w.packet)), (0, c.isSet)(w.proofUnreceived) && (P.proofUnreceived = (0, c.bytesFromBase64)(w.proofUnreceived)), (0, c.isSet)(w.proofClose) && (P.proofClose = (0, c.bytesFromBase64)(w.proofClose)), (0, c.isSet)(w.proofHeight) && (P.proofHeight = o.Height.fromJSON(w.proofHeight)), (0, c.isSet)(w.nextSequenceRecv) && (P.nextSequenceRecv = BigInt(w.nextSequenceRecv.toString())), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.packet !== void 0 && (P.packet = w.packet ? n.Packet.toJSON(w.packet) : void 0), w.proofUnreceived !== void 0 && (P.proofUnreceived = (0, c.base64FromBytes)(w.proofUnreceived !== void 0 ? w.proofUnreceived : new Uint8Array())), w.proofClose !== void 0 && (P.proofClose = (0, c.base64FromBytes)(w.proofClose !== void 0 ? w.proofClose : new Uint8Array())), w.proofHeight !== void 0 && (P.proofHeight = w.proofHeight ? o.Height.toJSON(w.proofHeight) : void 0), w.nextSequenceRecv !== void 0 && (P.nextSequenceRecv = (w.nextSequenceRecv || BigInt(0)).toString()), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = pe();
      return w.packet !== void 0 && w.packet !== null && (P.packet = n.Packet.fromPartial(w.packet)), P.proofUnreceived = w.proofUnreceived ?? new Uint8Array(), P.proofClose = w.proofClose ?? new Uint8Array(), w.proofHeight !== void 0 && w.proofHeight !== null && (P.proofHeight = o.Height.fromPartial(w.proofHeight)), w.nextSequenceRecv !== void 0 && w.nextSequenceRecv !== null && (P.nextSequenceRecv = BigInt(w.nextSequenceRecv.toString())), P.signer = w.signer ?? "", P;
    }
  };
  function oe() {
    return {
      result: 0
    };
  }
  e.MsgTimeoutOnCloseResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnCloseResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.result !== 0 && P.uint32(8).int32(w.result), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = oe();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.result = J.int32();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = oe();
      return (0, c.isSet)(w.result) && (P.result = m(w.result)), P;
    },
    toJSON(w) {
      const P = {};
      return w.result !== void 0 && (P.result = v(w.result)), P;
    },
    fromPartial(w) {
      const P = oe();
      return P.result = w.result ?? 0, P;
    }
  };
  function ne() {
    return {
      packet: n.Packet.fromPartial({}),
      acknowledgement: new Uint8Array(),
      proofAcked: new Uint8Array(),
      proofHeight: o.Height.fromPartial({}),
      signer: ""
    };
  }
  e.MsgAcknowledgement = {
    typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
    encode(w, P = u.BinaryWriter.create()) {
      return w.packet !== void 0 && n.Packet.encode(w.packet, P.uint32(10).fork()).ldelim(), w.acknowledgement.length !== 0 && P.uint32(18).bytes(w.acknowledgement), w.proofAcked.length !== 0 && P.uint32(26).bytes(w.proofAcked), w.proofHeight !== void 0 && o.Height.encode(w.proofHeight, P.uint32(34).fork()).ldelim(), w.signer !== "" && P.uint32(42).string(w.signer), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = ne();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.packet = n.Packet.decode(J, J.uint32());
            break;
          case 2:
            fe.acknowledgement = J.bytes();
            break;
          case 3:
            fe.proofAcked = J.bytes();
            break;
          case 4:
            fe.proofHeight = o.Height.decode(J, J.uint32());
            break;
          case 5:
            fe.signer = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = ne();
      return (0, c.isSet)(w.packet) && (P.packet = n.Packet.fromJSON(w.packet)), (0, c.isSet)(w.acknowledgement) && (P.acknowledgement = (0, c.bytesFromBase64)(w.acknowledgement)), (0, c.isSet)(w.proofAcked) && (P.proofAcked = (0, c.bytesFromBase64)(w.proofAcked)), (0, c.isSet)(w.proofHeight) && (P.proofHeight = o.Height.fromJSON(w.proofHeight)), (0, c.isSet)(w.signer) && (P.signer = String(w.signer)), P;
    },
    toJSON(w) {
      const P = {};
      return w.packet !== void 0 && (P.packet = w.packet ? n.Packet.toJSON(w.packet) : void 0), w.acknowledgement !== void 0 && (P.acknowledgement = (0, c.base64FromBytes)(w.acknowledgement !== void 0 ? w.acknowledgement : new Uint8Array())), w.proofAcked !== void 0 && (P.proofAcked = (0, c.base64FromBytes)(w.proofAcked !== void 0 ? w.proofAcked : new Uint8Array())), w.proofHeight !== void 0 && (P.proofHeight = w.proofHeight ? o.Height.toJSON(w.proofHeight) : void 0), w.signer !== void 0 && (P.signer = w.signer), P;
    },
    fromPartial(w) {
      const P = ne();
      return w.packet !== void 0 && w.packet !== null && (P.packet = n.Packet.fromPartial(w.packet)), P.acknowledgement = w.acknowledgement ?? new Uint8Array(), P.proofAcked = w.proofAcked ?? new Uint8Array(), w.proofHeight !== void 0 && w.proofHeight !== null && (P.proofHeight = o.Height.fromPartial(w.proofHeight)), P.signer = w.signer ?? "", P;
    }
  };
  function H() {
    return {
      result: 0
    };
  }
  e.MsgAcknowledgementResponse = {
    typeUrl: "/ibc.core.channel.v1.MsgAcknowledgementResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.result !== 0 && P.uint32(8).int32(w.result), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = H();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.result = J.int32();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = H();
      return (0, c.isSet)(w.result) && (P.result = m(w.result)), P;
    },
    toJSON(w) {
      const P = {};
      return w.result !== void 0 && (P.result = v(w.result)), P;
    },
    fromPartial(w) {
      const P = H();
      return P.result = w.result ?? 0, P;
    }
  };
  class C {
    constructor(P) {
      this.rpc = P, this.ChannelOpenInit = this.ChannelOpenInit.bind(this), this.ChannelOpenTry = this.ChannelOpenTry.bind(this), this.ChannelOpenAck = this.ChannelOpenAck.bind(this), this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this), this.ChannelCloseInit = this.ChannelCloseInit.bind(this), this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this), this.RecvPacket = this.RecvPacket.bind(this), this.Timeout = this.Timeout.bind(this), this.TimeoutOnClose = this.TimeoutOnClose.bind(this), this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    ChannelOpenInit(P) {
      const J = e.MsgChannelOpenInit.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", J).then((fe) => e.MsgChannelOpenInitResponse.decode(new u.BinaryReader(fe)));
    }
    ChannelOpenTry(P) {
      const J = e.MsgChannelOpenTry.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", J).then((fe) => e.MsgChannelOpenTryResponse.decode(new u.BinaryReader(fe)));
    }
    ChannelOpenAck(P) {
      const J = e.MsgChannelOpenAck.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", J).then((fe) => e.MsgChannelOpenAckResponse.decode(new u.BinaryReader(fe)));
    }
    ChannelOpenConfirm(P) {
      const J = e.MsgChannelOpenConfirm.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", J).then((fe) => e.MsgChannelOpenConfirmResponse.decode(new u.BinaryReader(fe)));
    }
    ChannelCloseInit(P) {
      const J = e.MsgChannelCloseInit.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", J).then((fe) => e.MsgChannelCloseInitResponse.decode(new u.BinaryReader(fe)));
    }
    ChannelCloseConfirm(P) {
      const J = e.MsgChannelCloseConfirm.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", J).then((fe) => e.MsgChannelCloseConfirmResponse.decode(new u.BinaryReader(fe)));
    }
    RecvPacket(P) {
      const J = e.MsgRecvPacket.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", J).then((fe) => e.MsgRecvPacketResponse.decode(new u.BinaryReader(fe)));
    }
    Timeout(P) {
      const J = e.MsgTimeout.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", J).then((fe) => e.MsgTimeoutResponse.decode(new u.BinaryReader(fe)));
    }
    TimeoutOnClose(P) {
      const J = e.MsgTimeoutOnClose.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", J).then((fe) => e.MsgTimeoutOnCloseResponse.decode(new u.BinaryReader(fe)));
    }
    Acknowledgement(P) {
      const J = e.MsgAcknowledgement.encode(P).finish();
      return this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", J).then((fe) => e.MsgAcknowledgementResponse.decode(new u.BinaryReader(fe)));
    }
  }
  e.MsgClientImpl = C;
})(tx$g);
var tx$f = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgSubmitMisbehaviourResponse = e.MsgSubmitMisbehaviour = e.MsgUpgradeClientResponse = e.MsgUpgradeClient = e.MsgUpdateClientResponse = e.MsgUpdateClient = e.MsgCreateClientResponse = e.MsgCreateClient = e.protobufPackage = void 0;
  const n = any$1, o = binary, u = helpers;
  e.protobufPackage = "ibc.core.client.v1";
  function c() {
    return {
      clientState: void 0,
      consensusState: void 0,
      signer: ""
    };
  }
  e.MsgCreateClient = {
    typeUrl: "/ibc.core.client.v1.MsgCreateClient",
    encode(y, V = o.BinaryWriter.create()) {
      return y.clientState !== void 0 && n.Any.encode(y.clientState, V.uint32(10).fork()).ldelim(), y.consensusState !== void 0 && n.Any.encode(y.consensusState, V.uint32(18).fork()).ldelim(), y.signer !== "" && V.uint32(26).string(y.signer), V;
    },
    decode(y, V) {
      const M = y instanceof o.BinaryReader ? y : new o.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = c();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.clientState = n.Any.decode(M, M.uint32());
            break;
          case 2:
            k.consensusState = n.Any.decode(M, M.uint32());
            break;
          case 3:
            k.signer = M.string();
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = c();
      return (0, u.isSet)(y.clientState) && (V.clientState = n.Any.fromJSON(y.clientState)), (0, u.isSet)(y.consensusState) && (V.consensusState = n.Any.fromJSON(y.consensusState)), (0, u.isSet)(y.signer) && (V.signer = String(y.signer)), V;
    },
    toJSON(y) {
      const V = {};
      return y.clientState !== void 0 && (V.clientState = y.clientState ? n.Any.toJSON(y.clientState) : void 0), y.consensusState !== void 0 && (V.consensusState = y.consensusState ? n.Any.toJSON(y.consensusState) : void 0), y.signer !== void 0 && (V.signer = y.signer), V;
    },
    fromPartial(y) {
      const V = c();
      return y.clientState !== void 0 && y.clientState !== null && (V.clientState = n.Any.fromPartial(y.clientState)), y.consensusState !== void 0 && y.consensusState !== null && (V.consensusState = n.Any.fromPartial(y.consensusState)), V.signer = y.signer ?? "", V;
    }
  };
  function d() {
    return {};
  }
  e.MsgCreateClientResponse = {
    typeUrl: "/ibc.core.client.v1.MsgCreateClientResponse",
    encode(y, V = o.BinaryWriter.create()) {
      return V;
    },
    decode(y, V) {
      const M = y instanceof o.BinaryReader ? y : new o.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = d();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      return d();
    },
    toJSON(y) {
      return {};
    },
    fromPartial(y) {
      return d();
    }
  };
  function m() {
    return {
      clientId: "",
      clientMessage: void 0,
      signer: ""
    };
  }
  e.MsgUpdateClient = {
    typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
    encode(y, V = o.BinaryWriter.create()) {
      return y.clientId !== "" && V.uint32(10).string(y.clientId), y.clientMessage !== void 0 && n.Any.encode(y.clientMessage, V.uint32(18).fork()).ldelim(), y.signer !== "" && V.uint32(26).string(y.signer), V;
    },
    decode(y, V) {
      const M = y instanceof o.BinaryReader ? y : new o.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = m();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.clientId = M.string();
            break;
          case 2:
            k.clientMessage = n.Any.decode(M, M.uint32());
            break;
          case 3:
            k.signer = M.string();
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = m();
      return (0, u.isSet)(y.clientId) && (V.clientId = String(y.clientId)), (0, u.isSet)(y.clientMessage) && (V.clientMessage = n.Any.fromJSON(y.clientMessage)), (0, u.isSet)(y.signer) && (V.signer = String(y.signer)), V;
    },
    toJSON(y) {
      const V = {};
      return y.clientId !== void 0 && (V.clientId = y.clientId), y.clientMessage !== void 0 && (V.clientMessage = y.clientMessage ? n.Any.toJSON(y.clientMessage) : void 0), y.signer !== void 0 && (V.signer = y.signer), V;
    },
    fromPartial(y) {
      const V = m();
      return V.clientId = y.clientId ?? "", y.clientMessage !== void 0 && y.clientMessage !== null && (V.clientMessage = n.Any.fromPartial(y.clientMessage)), V.signer = y.signer ?? "", V;
    }
  };
  function v() {
    return {};
  }
  e.MsgUpdateClientResponse = {
    typeUrl: "/ibc.core.client.v1.MsgUpdateClientResponse",
    encode(y, V = o.BinaryWriter.create()) {
      return V;
    },
    decode(y, V) {
      const M = y instanceof o.BinaryReader ? y : new o.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = v();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      return v();
    },
    toJSON(y) {
      return {};
    },
    fromPartial(y) {
      return v();
    }
  };
  function S() {
    return {
      clientId: "",
      clientState: void 0,
      consensusState: void 0,
      proofUpgradeClient: new Uint8Array(),
      proofUpgradeConsensusState: new Uint8Array(),
      signer: ""
    };
  }
  e.MsgUpgradeClient = {
    typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
    encode(y, V = o.BinaryWriter.create()) {
      return y.clientId !== "" && V.uint32(10).string(y.clientId), y.clientState !== void 0 && n.Any.encode(y.clientState, V.uint32(18).fork()).ldelim(), y.consensusState !== void 0 && n.Any.encode(y.consensusState, V.uint32(26).fork()).ldelim(), y.proofUpgradeClient.length !== 0 && V.uint32(34).bytes(y.proofUpgradeClient), y.proofUpgradeConsensusState.length !== 0 && V.uint32(42).bytes(y.proofUpgradeConsensusState), y.signer !== "" && V.uint32(50).string(y.signer), V;
    },
    decode(y, V) {
      const M = y instanceof o.BinaryReader ? y : new o.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = S();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.clientId = M.string();
            break;
          case 2:
            k.clientState = n.Any.decode(M, M.uint32());
            break;
          case 3:
            k.consensusState = n.Any.decode(M, M.uint32());
            break;
          case 4:
            k.proofUpgradeClient = M.bytes();
            break;
          case 5:
            k.proofUpgradeConsensusState = M.bytes();
            break;
          case 6:
            k.signer = M.string();
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = S();
      return (0, u.isSet)(y.clientId) && (V.clientId = String(y.clientId)), (0, u.isSet)(y.clientState) && (V.clientState = n.Any.fromJSON(y.clientState)), (0, u.isSet)(y.consensusState) && (V.consensusState = n.Any.fromJSON(y.consensusState)), (0, u.isSet)(y.proofUpgradeClient) && (V.proofUpgradeClient = (0, u.bytesFromBase64)(y.proofUpgradeClient)), (0, u.isSet)(y.proofUpgradeConsensusState) && (V.proofUpgradeConsensusState = (0, u.bytesFromBase64)(y.proofUpgradeConsensusState)), (0, u.isSet)(y.signer) && (V.signer = String(y.signer)), V;
    },
    toJSON(y) {
      const V = {};
      return y.clientId !== void 0 && (V.clientId = y.clientId), y.clientState !== void 0 && (V.clientState = y.clientState ? n.Any.toJSON(y.clientState) : void 0), y.consensusState !== void 0 && (V.consensusState = y.consensusState ? n.Any.toJSON(y.consensusState) : void 0), y.proofUpgradeClient !== void 0 && (V.proofUpgradeClient = (0, u.base64FromBytes)(y.proofUpgradeClient !== void 0 ? y.proofUpgradeClient : new Uint8Array())), y.proofUpgradeConsensusState !== void 0 && (V.proofUpgradeConsensusState = (0, u.base64FromBytes)(y.proofUpgradeConsensusState !== void 0 ? y.proofUpgradeConsensusState : new Uint8Array())), y.signer !== void 0 && (V.signer = y.signer), V;
    },
    fromPartial(y) {
      const V = S();
      return V.clientId = y.clientId ?? "", y.clientState !== void 0 && y.clientState !== null && (V.clientState = n.Any.fromPartial(y.clientState)), y.consensusState !== void 0 && y.consensusState !== null && (V.consensusState = n.Any.fromPartial(y.consensusState)), V.proofUpgradeClient = y.proofUpgradeClient ?? new Uint8Array(), V.proofUpgradeConsensusState = y.proofUpgradeConsensusState ?? new Uint8Array(), V.signer = y.signer ?? "", V;
    }
  };
  function $() {
    return {};
  }
  e.MsgUpgradeClientResponse = {
    typeUrl: "/ibc.core.client.v1.MsgUpgradeClientResponse",
    encode(y, V = o.BinaryWriter.create()) {
      return V;
    },
    decode(y, V) {
      const M = y instanceof o.BinaryReader ? y : new o.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = $();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      return $();
    },
    toJSON(y) {
      return {};
    },
    fromPartial(y) {
      return $();
    }
  };
  function E() {
    return {
      clientId: "",
      misbehaviour: void 0,
      signer: ""
    };
  }
  e.MsgSubmitMisbehaviour = {
    typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
    encode(y, V = o.BinaryWriter.create()) {
      return y.clientId !== "" && V.uint32(10).string(y.clientId), y.misbehaviour !== void 0 && n.Any.encode(y.misbehaviour, V.uint32(18).fork()).ldelim(), y.signer !== "" && V.uint32(26).string(y.signer), V;
    },
    decode(y, V) {
      const M = y instanceof o.BinaryReader ? y : new o.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = E();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          case 1:
            k.clientId = M.string();
            break;
          case 2:
            k.misbehaviour = n.Any.decode(M, M.uint32());
            break;
          case 3:
            k.signer = M.string();
            break;
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      const V = E();
      return (0, u.isSet)(y.clientId) && (V.clientId = String(y.clientId)), (0, u.isSet)(y.misbehaviour) && (V.misbehaviour = n.Any.fromJSON(y.misbehaviour)), (0, u.isSet)(y.signer) && (V.signer = String(y.signer)), V;
    },
    toJSON(y) {
      const V = {};
      return y.clientId !== void 0 && (V.clientId = y.clientId), y.misbehaviour !== void 0 && (V.misbehaviour = y.misbehaviour ? n.Any.toJSON(y.misbehaviour) : void 0), y.signer !== void 0 && (V.signer = y.signer), V;
    },
    fromPartial(y) {
      const V = E();
      return V.clientId = y.clientId ?? "", y.misbehaviour !== void 0 && y.misbehaviour !== null && (V.misbehaviour = n.Any.fromPartial(y.misbehaviour)), V.signer = y.signer ?? "", V;
    }
  };
  function O() {
    return {};
  }
  e.MsgSubmitMisbehaviourResponse = {
    typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviourResponse",
    encode(y, V = o.BinaryWriter.create()) {
      return V;
    },
    decode(y, V) {
      const M = y instanceof o.BinaryReader ? y : new o.BinaryReader(y);
      let G = V === void 0 ? M.len : M.pos + V;
      const k = O();
      for (; M.pos < G; ) {
        const F = M.uint32();
        switch (F >>> 3) {
          default:
            M.skipType(F & 7);
            break;
        }
      }
      return k;
    },
    fromJSON(y) {
      return O();
    },
    toJSON(y) {
      return {};
    },
    fromPartial(y) {
      return O();
    }
  };
  class T {
    constructor(V) {
      this.rpc = V, this.CreateClient = this.CreateClient.bind(this), this.UpdateClient = this.UpdateClient.bind(this), this.UpgradeClient = this.UpgradeClient.bind(this), this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    CreateClient(V) {
      const M = e.MsgCreateClient.encode(V).finish();
      return this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", M).then((k) => e.MsgCreateClientResponse.decode(new o.BinaryReader(k)));
    }
    UpdateClient(V) {
      const M = e.MsgUpdateClient.encode(V).finish();
      return this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", M).then((k) => e.MsgUpdateClientResponse.decode(new o.BinaryReader(k)));
    }
    UpgradeClient(V) {
      const M = e.MsgUpgradeClient.encode(V).finish();
      return this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", M).then((k) => e.MsgUpgradeClientResponse.decode(new o.BinaryReader(k)));
    }
    SubmitMisbehaviour(V) {
      const M = e.MsgSubmitMisbehaviour.encode(V).finish();
      return this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", M).then((k) => e.MsgSubmitMisbehaviourResponse.decode(new o.BinaryReader(k)));
    }
  }
  e.MsgClientImpl = T;
})(tx$f);
var tx$e = {}, connection = {}, commitment = {}, proofs = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CompressedNonExistenceProof = e.CompressedExistenceProof = e.CompressedBatchEntry = e.CompressedBatchProof = e.BatchEntry = e.BatchProof = e.InnerSpec = e.ProofSpec = e.InnerOp = e.LeafOp = e.CommitmentProof = e.NonExistenceProof = e.ExistenceProof = e.lengthOpToJSON = e.lengthOpFromJSON = e.LengthOp = e.hashOpToJSON = e.hashOpFromJSON = e.HashOp = e.protobufPackage = void 0;
  const n = binary, o = helpers;
  e.protobufPackage = "cosmos.ics23.v1";
  var u;
  (function(Q) {
    Q[Q.NO_HASH = 0] = "NO_HASH", Q[Q.SHA256 = 1] = "SHA256", Q[Q.SHA512 = 2] = "SHA512", Q[Q.KECCAK = 3] = "KECCAK", Q[Q.RIPEMD160 = 4] = "RIPEMD160", Q[Q.BITCOIN = 5] = "BITCOIN", Q[Q.SHA512_256 = 6] = "SHA512_256", Q[Q.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(u || (e.HashOp = u = {}));
  function c(Q) {
    switch (Q) {
      case 0:
      case "NO_HASH":
        return u.NO_HASH;
      case 1:
      case "SHA256":
        return u.SHA256;
      case 2:
      case "SHA512":
        return u.SHA512;
      case 3:
      case "KECCAK":
        return u.KECCAK;
      case 4:
      case "RIPEMD160":
        return u.RIPEMD160;
      case 5:
      case "BITCOIN":
        return u.BITCOIN;
      case 6:
      case "SHA512_256":
        return u.SHA512_256;
      case -1:
      case "UNRECOGNIZED":
      default:
        return u.UNRECOGNIZED;
    }
  }
  e.hashOpFromJSON = c;
  function d(Q) {
    switch (Q) {
      case u.NO_HASH:
        return "NO_HASH";
      case u.SHA256:
        return "SHA256";
      case u.SHA512:
        return "SHA512";
      case u.KECCAK:
        return "KECCAK";
      case u.RIPEMD160:
        return "RIPEMD160";
      case u.BITCOIN:
        return "BITCOIN";
      case u.SHA512_256:
        return "SHA512_256";
      case u.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.hashOpToJSON = d;
  var m;
  (function(Q) {
    Q[Q.NO_PREFIX = 0] = "NO_PREFIX", Q[Q.VAR_PROTO = 1] = "VAR_PROTO", Q[Q.VAR_RLP = 2] = "VAR_RLP", Q[Q.FIXED32_BIG = 3] = "FIXED32_BIG", Q[Q.FIXED32_LITTLE = 4] = "FIXED32_LITTLE", Q[Q.FIXED64_BIG = 5] = "FIXED64_BIG", Q[Q.FIXED64_LITTLE = 6] = "FIXED64_LITTLE", Q[Q.REQUIRE_32_BYTES = 7] = "REQUIRE_32_BYTES", Q[Q.REQUIRE_64_BYTES = 8] = "REQUIRE_64_BYTES", Q[Q.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(m || (e.LengthOp = m = {}));
  function v(Q) {
    switch (Q) {
      case 0:
      case "NO_PREFIX":
        return m.NO_PREFIX;
      case 1:
      case "VAR_PROTO":
        return m.VAR_PROTO;
      case 2:
      case "VAR_RLP":
        return m.VAR_RLP;
      case 3:
      case "FIXED32_BIG":
        return m.FIXED32_BIG;
      case 4:
      case "FIXED32_LITTLE":
        return m.FIXED32_LITTLE;
      case 5:
      case "FIXED64_BIG":
        return m.FIXED64_BIG;
      case 6:
      case "FIXED64_LITTLE":
        return m.FIXED64_LITTLE;
      case 7:
      case "REQUIRE_32_BYTES":
        return m.REQUIRE_32_BYTES;
      case 8:
      case "REQUIRE_64_BYTES":
        return m.REQUIRE_64_BYTES;
      case -1:
      case "UNRECOGNIZED":
      default:
        return m.UNRECOGNIZED;
    }
  }
  e.lengthOpFromJSON = v;
  function S(Q) {
    switch (Q) {
      case m.NO_PREFIX:
        return "NO_PREFIX";
      case m.VAR_PROTO:
        return "VAR_PROTO";
      case m.VAR_RLP:
        return "VAR_RLP";
      case m.FIXED32_BIG:
        return "FIXED32_BIG";
      case m.FIXED32_LITTLE:
        return "FIXED32_LITTLE";
      case m.FIXED64_BIG:
        return "FIXED64_BIG";
      case m.FIXED64_LITTLE:
        return "FIXED64_LITTLE";
      case m.REQUIRE_32_BYTES:
        return "REQUIRE_32_BYTES";
      case m.REQUIRE_64_BYTES:
        return "REQUIRE_64_BYTES";
      case m.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.lengthOpToJSON = S;
  function $() {
    return {
      key: new Uint8Array(),
      value: new Uint8Array(),
      leaf: void 0,
      path: []
    };
  }
  e.ExistenceProof = {
    typeUrl: "/cosmos.ics23.v1.ExistenceProof",
    encode(Q, Y = n.BinaryWriter.create()) {
      Q.key.length !== 0 && Y.uint32(10).bytes(Q.key), Q.value.length !== 0 && Y.uint32(18).bytes(Q.value), Q.leaf !== void 0 && e.LeafOp.encode(Q.leaf, Y.uint32(26).fork()).ldelim();
      for (const pe of Q.path)
        e.InnerOp.encode(pe, Y.uint32(34).fork()).ldelim();
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = $();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.key = pe.bytes();
            break;
          case 2:
            ne.value = pe.bytes();
            break;
          case 3:
            ne.leaf = e.LeafOp.decode(pe, pe.uint32());
            break;
          case 4:
            ne.path.push(e.InnerOp.decode(pe, pe.uint32()));
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = $();
      return (0, o.isSet)(Q.key) && (Y.key = (0, o.bytesFromBase64)(Q.key)), (0, o.isSet)(Q.value) && (Y.value = (0, o.bytesFromBase64)(Q.value)), (0, o.isSet)(Q.leaf) && (Y.leaf = e.LeafOp.fromJSON(Q.leaf)), Array.isArray(Q == null ? void 0 : Q.path) && (Y.path = Q.path.map((pe) => e.InnerOp.fromJSON(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.key !== void 0 && (Y.key = (0, o.base64FromBytes)(Q.key !== void 0 ? Q.key : new Uint8Array())), Q.value !== void 0 && (Y.value = (0, o.base64FromBytes)(Q.value !== void 0 ? Q.value : new Uint8Array())), Q.leaf !== void 0 && (Y.leaf = Q.leaf ? e.LeafOp.toJSON(Q.leaf) : void 0), Q.path ? Y.path = Q.path.map((pe) => pe ? e.InnerOp.toJSON(pe) : void 0) : Y.path = [], Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = $();
      return Y.key = Q.key ?? new Uint8Array(), Y.value = Q.value ?? new Uint8Array(), Q.leaf !== void 0 && Q.leaf !== null && (Y.leaf = e.LeafOp.fromPartial(Q.leaf)), Y.path = ((pe = Q.path) == null ? void 0 : pe.map((oe) => e.InnerOp.fromPartial(oe))) || [], Y;
    }
  };
  function E() {
    return {
      key: new Uint8Array(),
      left: void 0,
      right: void 0
    };
  }
  e.NonExistenceProof = {
    typeUrl: "/cosmos.ics23.v1.NonExistenceProof",
    encode(Q, Y = n.BinaryWriter.create()) {
      return Q.key.length !== 0 && Y.uint32(10).bytes(Q.key), Q.left !== void 0 && e.ExistenceProof.encode(Q.left, Y.uint32(18).fork()).ldelim(), Q.right !== void 0 && e.ExistenceProof.encode(Q.right, Y.uint32(26).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = E();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.key = pe.bytes();
            break;
          case 2:
            ne.left = e.ExistenceProof.decode(pe, pe.uint32());
            break;
          case 3:
            ne.right = e.ExistenceProof.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = E();
      return (0, o.isSet)(Q.key) && (Y.key = (0, o.bytesFromBase64)(Q.key)), (0, o.isSet)(Q.left) && (Y.left = e.ExistenceProof.fromJSON(Q.left)), (0, o.isSet)(Q.right) && (Y.right = e.ExistenceProof.fromJSON(Q.right)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.key !== void 0 && (Y.key = (0, o.base64FromBytes)(Q.key !== void 0 ? Q.key : new Uint8Array())), Q.left !== void 0 && (Y.left = Q.left ? e.ExistenceProof.toJSON(Q.left) : void 0), Q.right !== void 0 && (Y.right = Q.right ? e.ExistenceProof.toJSON(Q.right) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = E();
      return Y.key = Q.key ?? new Uint8Array(), Q.left !== void 0 && Q.left !== null && (Y.left = e.ExistenceProof.fromPartial(Q.left)), Q.right !== void 0 && Q.right !== null && (Y.right = e.ExistenceProof.fromPartial(Q.right)), Y;
    }
  };
  function O() {
    return {
      exist: void 0,
      nonexist: void 0,
      batch: void 0,
      compressed: void 0
    };
  }
  e.CommitmentProof = {
    typeUrl: "/cosmos.ics23.v1.CommitmentProof",
    encode(Q, Y = n.BinaryWriter.create()) {
      return Q.exist !== void 0 && e.ExistenceProof.encode(Q.exist, Y.uint32(10).fork()).ldelim(), Q.nonexist !== void 0 && e.NonExistenceProof.encode(Q.nonexist, Y.uint32(18).fork()).ldelim(), Q.batch !== void 0 && e.BatchProof.encode(Q.batch, Y.uint32(26).fork()).ldelim(), Q.compressed !== void 0 && e.CompressedBatchProof.encode(Q.compressed, Y.uint32(34).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = O();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.exist = e.ExistenceProof.decode(pe, pe.uint32());
            break;
          case 2:
            ne.nonexist = e.NonExistenceProof.decode(pe, pe.uint32());
            break;
          case 3:
            ne.batch = e.BatchProof.decode(pe, pe.uint32());
            break;
          case 4:
            ne.compressed = e.CompressedBatchProof.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = O();
      return (0, o.isSet)(Q.exist) && (Y.exist = e.ExistenceProof.fromJSON(Q.exist)), (0, o.isSet)(Q.nonexist) && (Y.nonexist = e.NonExistenceProof.fromJSON(Q.nonexist)), (0, o.isSet)(Q.batch) && (Y.batch = e.BatchProof.fromJSON(Q.batch)), (0, o.isSet)(Q.compressed) && (Y.compressed = e.CompressedBatchProof.fromJSON(Q.compressed)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.exist !== void 0 && (Y.exist = Q.exist ? e.ExistenceProof.toJSON(Q.exist) : void 0), Q.nonexist !== void 0 && (Y.nonexist = Q.nonexist ? e.NonExistenceProof.toJSON(Q.nonexist) : void 0), Q.batch !== void 0 && (Y.batch = Q.batch ? e.BatchProof.toJSON(Q.batch) : void 0), Q.compressed !== void 0 && (Y.compressed = Q.compressed ? e.CompressedBatchProof.toJSON(Q.compressed) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = O();
      return Q.exist !== void 0 && Q.exist !== null && (Y.exist = e.ExistenceProof.fromPartial(Q.exist)), Q.nonexist !== void 0 && Q.nonexist !== null && (Y.nonexist = e.NonExistenceProof.fromPartial(Q.nonexist)), Q.batch !== void 0 && Q.batch !== null && (Y.batch = e.BatchProof.fromPartial(Q.batch)), Q.compressed !== void 0 && Q.compressed !== null && (Y.compressed = e.CompressedBatchProof.fromPartial(Q.compressed)), Y;
    }
  };
  function T() {
    return {
      hash: 0,
      prehashKey: 0,
      prehashValue: 0,
      length: 0,
      prefix: new Uint8Array()
    };
  }
  e.LeafOp = {
    typeUrl: "/cosmos.ics23.v1.LeafOp",
    encode(Q, Y = n.BinaryWriter.create()) {
      return Q.hash !== 0 && Y.uint32(8).int32(Q.hash), Q.prehashKey !== 0 && Y.uint32(16).int32(Q.prehashKey), Q.prehashValue !== 0 && Y.uint32(24).int32(Q.prehashValue), Q.length !== 0 && Y.uint32(32).int32(Q.length), Q.prefix.length !== 0 && Y.uint32(42).bytes(Q.prefix), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = T();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.hash = pe.int32();
            break;
          case 2:
            ne.prehashKey = pe.int32();
            break;
          case 3:
            ne.prehashValue = pe.int32();
            break;
          case 4:
            ne.length = pe.int32();
            break;
          case 5:
            ne.prefix = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = T();
      return (0, o.isSet)(Q.hash) && (Y.hash = c(Q.hash)), (0, o.isSet)(Q.prehashKey) && (Y.prehashKey = c(Q.prehashKey)), (0, o.isSet)(Q.prehashValue) && (Y.prehashValue = c(Q.prehashValue)), (0, o.isSet)(Q.length) && (Y.length = v(Q.length)), (0, o.isSet)(Q.prefix) && (Y.prefix = (0, o.bytesFromBase64)(Q.prefix)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.hash !== void 0 && (Y.hash = d(Q.hash)), Q.prehashKey !== void 0 && (Y.prehashKey = d(Q.prehashKey)), Q.prehashValue !== void 0 && (Y.prehashValue = d(Q.prehashValue)), Q.length !== void 0 && (Y.length = S(Q.length)), Q.prefix !== void 0 && (Y.prefix = (0, o.base64FromBytes)(Q.prefix !== void 0 ? Q.prefix : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = T();
      return Y.hash = Q.hash ?? 0, Y.prehashKey = Q.prehashKey ?? 0, Y.prehashValue = Q.prehashValue ?? 0, Y.length = Q.length ?? 0, Y.prefix = Q.prefix ?? new Uint8Array(), Y;
    }
  };
  function y() {
    return {
      hash: 0,
      prefix: new Uint8Array(),
      suffix: new Uint8Array()
    };
  }
  e.InnerOp = {
    typeUrl: "/cosmos.ics23.v1.InnerOp",
    encode(Q, Y = n.BinaryWriter.create()) {
      return Q.hash !== 0 && Y.uint32(8).int32(Q.hash), Q.prefix.length !== 0 && Y.uint32(18).bytes(Q.prefix), Q.suffix.length !== 0 && Y.uint32(26).bytes(Q.suffix), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = y();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.hash = pe.int32();
            break;
          case 2:
            ne.prefix = pe.bytes();
            break;
          case 3:
            ne.suffix = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = y();
      return (0, o.isSet)(Q.hash) && (Y.hash = c(Q.hash)), (0, o.isSet)(Q.prefix) && (Y.prefix = (0, o.bytesFromBase64)(Q.prefix)), (0, o.isSet)(Q.suffix) && (Y.suffix = (0, o.bytesFromBase64)(Q.suffix)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.hash !== void 0 && (Y.hash = d(Q.hash)), Q.prefix !== void 0 && (Y.prefix = (0, o.base64FromBytes)(Q.prefix !== void 0 ? Q.prefix : new Uint8Array())), Q.suffix !== void 0 && (Y.suffix = (0, o.base64FromBytes)(Q.suffix !== void 0 ? Q.suffix : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = y();
      return Y.hash = Q.hash ?? 0, Y.prefix = Q.prefix ?? new Uint8Array(), Y.suffix = Q.suffix ?? new Uint8Array(), Y;
    }
  };
  function V() {
    return {
      leafSpec: void 0,
      innerSpec: void 0,
      maxDepth: 0,
      minDepth: 0
    };
  }
  e.ProofSpec = {
    typeUrl: "/cosmos.ics23.v1.ProofSpec",
    encode(Q, Y = n.BinaryWriter.create()) {
      return Q.leafSpec !== void 0 && e.LeafOp.encode(Q.leafSpec, Y.uint32(10).fork()).ldelim(), Q.innerSpec !== void 0 && e.InnerSpec.encode(Q.innerSpec, Y.uint32(18).fork()).ldelim(), Q.maxDepth !== 0 && Y.uint32(24).int32(Q.maxDepth), Q.minDepth !== 0 && Y.uint32(32).int32(Q.minDepth), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = V();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.leafSpec = e.LeafOp.decode(pe, pe.uint32());
            break;
          case 2:
            ne.innerSpec = e.InnerSpec.decode(pe, pe.uint32());
            break;
          case 3:
            ne.maxDepth = pe.int32();
            break;
          case 4:
            ne.minDepth = pe.int32();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = V();
      return (0, o.isSet)(Q.leafSpec) && (Y.leafSpec = e.LeafOp.fromJSON(Q.leafSpec)), (0, o.isSet)(Q.innerSpec) && (Y.innerSpec = e.InnerSpec.fromJSON(Q.innerSpec)), (0, o.isSet)(Q.maxDepth) && (Y.maxDepth = Number(Q.maxDepth)), (0, o.isSet)(Q.minDepth) && (Y.minDepth = Number(Q.minDepth)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.leafSpec !== void 0 && (Y.leafSpec = Q.leafSpec ? e.LeafOp.toJSON(Q.leafSpec) : void 0), Q.innerSpec !== void 0 && (Y.innerSpec = Q.innerSpec ? e.InnerSpec.toJSON(Q.innerSpec) : void 0), Q.maxDepth !== void 0 && (Y.maxDepth = Math.round(Q.maxDepth)), Q.minDepth !== void 0 && (Y.minDepth = Math.round(Q.minDepth)), Y;
    },
    fromPartial(Q) {
      const Y = V();
      return Q.leafSpec !== void 0 && Q.leafSpec !== null && (Y.leafSpec = e.LeafOp.fromPartial(Q.leafSpec)), Q.innerSpec !== void 0 && Q.innerSpec !== null && (Y.innerSpec = e.InnerSpec.fromPartial(Q.innerSpec)), Y.maxDepth = Q.maxDepth ?? 0, Y.minDepth = Q.minDepth ?? 0, Y;
    }
  };
  function M() {
    return {
      childOrder: [],
      childSize: 0,
      minPrefixLength: 0,
      maxPrefixLength: 0,
      emptyChild: new Uint8Array(),
      hash: 0
    };
  }
  e.InnerSpec = {
    typeUrl: "/cosmos.ics23.v1.InnerSpec",
    encode(Q, Y = n.BinaryWriter.create()) {
      Y.uint32(10).fork();
      for (const pe of Q.childOrder)
        Y.int32(pe);
      return Y.ldelim(), Q.childSize !== 0 && Y.uint32(16).int32(Q.childSize), Q.minPrefixLength !== 0 && Y.uint32(24).int32(Q.minPrefixLength), Q.maxPrefixLength !== 0 && Y.uint32(32).int32(Q.maxPrefixLength), Q.emptyChild.length !== 0 && Y.uint32(42).bytes(Q.emptyChild), Q.hash !== 0 && Y.uint32(48).int32(Q.hash), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = M();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            if ((H & 7) === 2) {
              const C = pe.uint32() + pe.pos;
              for (; pe.pos < C; )
                ne.childOrder.push(pe.int32());
            } else
              ne.childOrder.push(pe.int32());
            break;
          case 2:
            ne.childSize = pe.int32();
            break;
          case 3:
            ne.minPrefixLength = pe.int32();
            break;
          case 4:
            ne.maxPrefixLength = pe.int32();
            break;
          case 5:
            ne.emptyChild = pe.bytes();
            break;
          case 6:
            ne.hash = pe.int32();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = M();
      return Array.isArray(Q == null ? void 0 : Q.childOrder) && (Y.childOrder = Q.childOrder.map((pe) => Number(pe))), (0, o.isSet)(Q.childSize) && (Y.childSize = Number(Q.childSize)), (0, o.isSet)(Q.minPrefixLength) && (Y.minPrefixLength = Number(Q.minPrefixLength)), (0, o.isSet)(Q.maxPrefixLength) && (Y.maxPrefixLength = Number(Q.maxPrefixLength)), (0, o.isSet)(Q.emptyChild) && (Y.emptyChild = (0, o.bytesFromBase64)(Q.emptyChild)), (0, o.isSet)(Q.hash) && (Y.hash = c(Q.hash)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.childOrder ? Y.childOrder = Q.childOrder.map((pe) => Math.round(pe)) : Y.childOrder = [], Q.childSize !== void 0 && (Y.childSize = Math.round(Q.childSize)), Q.minPrefixLength !== void 0 && (Y.minPrefixLength = Math.round(Q.minPrefixLength)), Q.maxPrefixLength !== void 0 && (Y.maxPrefixLength = Math.round(Q.maxPrefixLength)), Q.emptyChild !== void 0 && (Y.emptyChild = (0, o.base64FromBytes)(Q.emptyChild !== void 0 ? Q.emptyChild : new Uint8Array())), Q.hash !== void 0 && (Y.hash = d(Q.hash)), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = M();
      return Y.childOrder = ((pe = Q.childOrder) == null ? void 0 : pe.map((oe) => oe)) || [], Y.childSize = Q.childSize ?? 0, Y.minPrefixLength = Q.minPrefixLength ?? 0, Y.maxPrefixLength = Q.maxPrefixLength ?? 0, Y.emptyChild = Q.emptyChild ?? new Uint8Array(), Y.hash = Q.hash ?? 0, Y;
    }
  };
  function G() {
    return {
      entries: []
    };
  }
  e.BatchProof = {
    typeUrl: "/cosmos.ics23.v1.BatchProof",
    encode(Q, Y = n.BinaryWriter.create()) {
      for (const pe of Q.entries)
        e.BatchEntry.encode(pe, Y.uint32(10).fork()).ldelim();
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = G();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.entries.push(e.BatchEntry.decode(pe, pe.uint32()));
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = G();
      return Array.isArray(Q == null ? void 0 : Q.entries) && (Y.entries = Q.entries.map((pe) => e.BatchEntry.fromJSON(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.entries ? Y.entries = Q.entries.map((pe) => pe ? e.BatchEntry.toJSON(pe) : void 0) : Y.entries = [], Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = G();
      return Y.entries = ((pe = Q.entries) == null ? void 0 : pe.map((oe) => e.BatchEntry.fromPartial(oe))) || [], Y;
    }
  };
  function k() {
    return {
      exist: void 0,
      nonexist: void 0
    };
  }
  e.BatchEntry = {
    typeUrl: "/cosmos.ics23.v1.BatchEntry",
    encode(Q, Y = n.BinaryWriter.create()) {
      return Q.exist !== void 0 && e.ExistenceProof.encode(Q.exist, Y.uint32(10).fork()).ldelim(), Q.nonexist !== void 0 && e.NonExistenceProof.encode(Q.nonexist, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = k();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.exist = e.ExistenceProof.decode(pe, pe.uint32());
            break;
          case 2:
            ne.nonexist = e.NonExistenceProof.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = k();
      return (0, o.isSet)(Q.exist) && (Y.exist = e.ExistenceProof.fromJSON(Q.exist)), (0, o.isSet)(Q.nonexist) && (Y.nonexist = e.NonExistenceProof.fromJSON(Q.nonexist)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.exist !== void 0 && (Y.exist = Q.exist ? e.ExistenceProof.toJSON(Q.exist) : void 0), Q.nonexist !== void 0 && (Y.nonexist = Q.nonexist ? e.NonExistenceProof.toJSON(Q.nonexist) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = k();
      return Q.exist !== void 0 && Q.exist !== null && (Y.exist = e.ExistenceProof.fromPartial(Q.exist)), Q.nonexist !== void 0 && Q.nonexist !== null && (Y.nonexist = e.NonExistenceProof.fromPartial(Q.nonexist)), Y;
    }
  };
  function F() {
    return {
      entries: [],
      lookupInners: []
    };
  }
  e.CompressedBatchProof = {
    typeUrl: "/cosmos.ics23.v1.CompressedBatchProof",
    encode(Q, Y = n.BinaryWriter.create()) {
      for (const pe of Q.entries)
        e.CompressedBatchEntry.encode(pe, Y.uint32(10).fork()).ldelim();
      for (const pe of Q.lookupInners)
        e.InnerOp.encode(pe, Y.uint32(18).fork()).ldelim();
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = F();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.entries.push(e.CompressedBatchEntry.decode(pe, pe.uint32()));
            break;
          case 2:
            ne.lookupInners.push(e.InnerOp.decode(pe, pe.uint32()));
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = F();
      return Array.isArray(Q == null ? void 0 : Q.entries) && (Y.entries = Q.entries.map((pe) => e.CompressedBatchEntry.fromJSON(pe))), Array.isArray(Q == null ? void 0 : Q.lookupInners) && (Y.lookupInners = Q.lookupInners.map((pe) => e.InnerOp.fromJSON(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.entries ? Y.entries = Q.entries.map((pe) => pe ? e.CompressedBatchEntry.toJSON(pe) : void 0) : Y.entries = [], Q.lookupInners ? Y.lookupInners = Q.lookupInners.map((pe) => pe ? e.InnerOp.toJSON(pe) : void 0) : Y.lookupInners = [], Y;
    },
    fromPartial(Q) {
      var pe, oe;
      const Y = F();
      return Y.entries = ((pe = Q.entries) == null ? void 0 : pe.map((ne) => e.CompressedBatchEntry.fromPartial(ne))) || [], Y.lookupInners = ((oe = Q.lookupInners) == null ? void 0 : oe.map((ne) => e.InnerOp.fromPartial(ne))) || [], Y;
    }
  };
  function X() {
    return {
      exist: void 0,
      nonexist: void 0
    };
  }
  e.CompressedBatchEntry = {
    typeUrl: "/cosmos.ics23.v1.CompressedBatchEntry",
    encode(Q, Y = n.BinaryWriter.create()) {
      return Q.exist !== void 0 && e.CompressedExistenceProof.encode(Q.exist, Y.uint32(10).fork()).ldelim(), Q.nonexist !== void 0 && e.CompressedNonExistenceProof.encode(Q.nonexist, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = X();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.exist = e.CompressedExistenceProof.decode(pe, pe.uint32());
            break;
          case 2:
            ne.nonexist = e.CompressedNonExistenceProof.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = X();
      return (0, o.isSet)(Q.exist) && (Y.exist = e.CompressedExistenceProof.fromJSON(Q.exist)), (0, o.isSet)(Q.nonexist) && (Y.nonexist = e.CompressedNonExistenceProof.fromJSON(Q.nonexist)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.exist !== void 0 && (Y.exist = Q.exist ? e.CompressedExistenceProof.toJSON(Q.exist) : void 0), Q.nonexist !== void 0 && (Y.nonexist = Q.nonexist ? e.CompressedNonExistenceProof.toJSON(Q.nonexist) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = X();
      return Q.exist !== void 0 && Q.exist !== null && (Y.exist = e.CompressedExistenceProof.fromPartial(Q.exist)), Q.nonexist !== void 0 && Q.nonexist !== null && (Y.nonexist = e.CompressedNonExistenceProof.fromPartial(Q.nonexist)), Y;
    }
  };
  function ee() {
    return {
      key: new Uint8Array(),
      value: new Uint8Array(),
      leaf: void 0,
      path: []
    };
  }
  e.CompressedExistenceProof = {
    typeUrl: "/cosmos.ics23.v1.CompressedExistenceProof",
    encode(Q, Y = n.BinaryWriter.create()) {
      Q.key.length !== 0 && Y.uint32(10).bytes(Q.key), Q.value.length !== 0 && Y.uint32(18).bytes(Q.value), Q.leaf !== void 0 && e.LeafOp.encode(Q.leaf, Y.uint32(26).fork()).ldelim(), Y.uint32(34).fork();
      for (const pe of Q.path)
        Y.int32(pe);
      return Y.ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ee();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.key = pe.bytes();
            break;
          case 2:
            ne.value = pe.bytes();
            break;
          case 3:
            ne.leaf = e.LeafOp.decode(pe, pe.uint32());
            break;
          case 4:
            if ((H & 7) === 2) {
              const C = pe.uint32() + pe.pos;
              for (; pe.pos < C; )
                ne.path.push(pe.int32());
            } else
              ne.path.push(pe.int32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = ee();
      return (0, o.isSet)(Q.key) && (Y.key = (0, o.bytesFromBase64)(Q.key)), (0, o.isSet)(Q.value) && (Y.value = (0, o.bytesFromBase64)(Q.value)), (0, o.isSet)(Q.leaf) && (Y.leaf = e.LeafOp.fromJSON(Q.leaf)), Array.isArray(Q == null ? void 0 : Q.path) && (Y.path = Q.path.map((pe) => Number(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.key !== void 0 && (Y.key = (0, o.base64FromBytes)(Q.key !== void 0 ? Q.key : new Uint8Array())), Q.value !== void 0 && (Y.value = (0, o.base64FromBytes)(Q.value !== void 0 ? Q.value : new Uint8Array())), Q.leaf !== void 0 && (Y.leaf = Q.leaf ? e.LeafOp.toJSON(Q.leaf) : void 0), Q.path ? Y.path = Q.path.map((pe) => Math.round(pe)) : Y.path = [], Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = ee();
      return Y.key = Q.key ?? new Uint8Array(), Y.value = Q.value ?? new Uint8Array(), Q.leaf !== void 0 && Q.leaf !== null && (Y.leaf = e.LeafOp.fromPartial(Q.leaf)), Y.path = ((pe = Q.path) == null ? void 0 : pe.map((oe) => oe)) || [], Y;
    }
  };
  function ue() {
    return {
      key: new Uint8Array(),
      left: void 0,
      right: void 0
    };
  }
  e.CompressedNonExistenceProof = {
    typeUrl: "/cosmos.ics23.v1.CompressedNonExistenceProof",
    encode(Q, Y = n.BinaryWriter.create()) {
      return Q.key.length !== 0 && Y.uint32(10).bytes(Q.key), Q.left !== void 0 && e.CompressedExistenceProof.encode(Q.left, Y.uint32(18).fork()).ldelim(), Q.right !== void 0 && e.CompressedExistenceProof.encode(Q.right, Y.uint32(26).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof n.BinaryReader ? Q : new n.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ue();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.key = pe.bytes();
            break;
          case 2:
            ne.left = e.CompressedExistenceProof.decode(pe, pe.uint32());
            break;
          case 3:
            ne.right = e.CompressedExistenceProof.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = ue();
      return (0, o.isSet)(Q.key) && (Y.key = (0, o.bytesFromBase64)(Q.key)), (0, o.isSet)(Q.left) && (Y.left = e.CompressedExistenceProof.fromJSON(Q.left)), (0, o.isSet)(Q.right) && (Y.right = e.CompressedExistenceProof.fromJSON(Q.right)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.key !== void 0 && (Y.key = (0, o.base64FromBytes)(Q.key !== void 0 ? Q.key : new Uint8Array())), Q.left !== void 0 && (Y.left = Q.left ? e.CompressedExistenceProof.toJSON(Q.left) : void 0), Q.right !== void 0 && (Y.right = Q.right ? e.CompressedExistenceProof.toJSON(Q.right) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = ue();
      return Y.key = Q.key ?? new Uint8Array(), Q.left !== void 0 && Q.left !== null && (Y.left = e.CompressedExistenceProof.fromPartial(Q.left)), Q.right !== void 0 && Q.right !== null && (Y.right = e.CompressedExistenceProof.fromPartial(Q.right)), Y;
    }
  };
})(proofs);
Object.defineProperty(commitment, "__esModule", { value: !0 });
commitment.MerkleProof = commitment.MerklePath = commitment.MerklePrefix = commitment.MerkleRoot = commitment.protobufPackage = void 0;
const proofs_1 = proofs, binary_1$6 = binary, helpers_1$6 = helpers;
commitment.protobufPackage = "ibc.core.commitment.v1";
function createBaseMerkleRoot$1() {
  return {
    hash: new Uint8Array()
  };
}
commitment.MerkleRoot = {
  typeUrl: "/ibc.core.commitment.v1.MerkleRoot",
  encode(e, n = binary_1$6.BinaryWriter.create()) {
    return e.hash.length !== 0 && n.uint32(10).bytes(e.hash), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$6.BinaryReader ? e : new binary_1$6.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMerkleRoot$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseMerkleRoot$1();
    return (0, helpers_1$6.isSet)(e.hash) && (n.hash = (0, helpers_1$6.bytesFromBase64)(e.hash)), n;
  },
  toJSON(e) {
    const n = {};
    return e.hash !== void 0 && (n.hash = (0, helpers_1$6.base64FromBytes)(e.hash !== void 0 ? e.hash : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBaseMerkleRoot$1();
    return n.hash = e.hash ?? new Uint8Array(), n;
  }
};
function createBaseMerklePrefix$1() {
  return {
    keyPrefix: new Uint8Array()
  };
}
commitment.MerklePrefix = {
  typeUrl: "/ibc.core.commitment.v1.MerklePrefix",
  encode(e, n = binary_1$6.BinaryWriter.create()) {
    return e.keyPrefix.length !== 0 && n.uint32(10).bytes(e.keyPrefix), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$6.BinaryReader ? e : new binary_1$6.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMerklePrefix$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.keyPrefix = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseMerklePrefix$1();
    return (0, helpers_1$6.isSet)(e.keyPrefix) && (n.keyPrefix = (0, helpers_1$6.bytesFromBase64)(e.keyPrefix)), n;
  },
  toJSON(e) {
    const n = {};
    return e.keyPrefix !== void 0 && (n.keyPrefix = (0, helpers_1$6.base64FromBytes)(e.keyPrefix !== void 0 ? e.keyPrefix : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBaseMerklePrefix$1();
    return n.keyPrefix = e.keyPrefix ?? new Uint8Array(), n;
  }
};
function createBaseMerklePath$1() {
  return {
    keyPath: []
  };
}
commitment.MerklePath = {
  typeUrl: "/ibc.core.commitment.v1.MerklePath",
  encode(e, n = binary_1$6.BinaryWriter.create()) {
    for (const o of e.keyPath)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$6.BinaryReader ? e : new binary_1$6.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMerklePath$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.keyPath.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseMerklePath$1();
    return Array.isArray(e == null ? void 0 : e.keyPath) && (n.keyPath = e.keyPath.map((o) => String(o))), n;
  },
  toJSON(e) {
    const n = {};
    return e.keyPath ? n.keyPath = e.keyPath.map((o) => o) : n.keyPath = [], n;
  },
  fromPartial(e) {
    var o;
    const n = createBaseMerklePath$1();
    return n.keyPath = ((o = e.keyPath) == null ? void 0 : o.map((u) => u)) || [], n;
  }
};
function createBaseMerkleProof$1() {
  return {
    proofs: []
  };
}
commitment.MerkleProof = {
  typeUrl: "/ibc.core.commitment.v1.MerkleProof",
  encode(e, n = binary_1$6.BinaryWriter.create()) {
    for (const o of e.proofs)
      proofs_1.CommitmentProof.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$6.BinaryReader ? e : new binary_1$6.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMerkleProof$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proofs.push(proofs_1.CommitmentProof.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseMerkleProof$1();
    return Array.isArray(e == null ? void 0 : e.proofs) && (n.proofs = e.proofs.map((o) => proofs_1.CommitmentProof.fromJSON(o))), n;
  },
  toJSON(e) {
    const n = {};
    return e.proofs ? n.proofs = e.proofs.map((o) => o ? proofs_1.CommitmentProof.toJSON(o) : void 0) : n.proofs = [], n;
  },
  fromPartial(e) {
    var o;
    const n = createBaseMerkleProof$1();
    return n.proofs = ((o = e.proofs) == null ? void 0 : o.map((u) => proofs_1.CommitmentProof.fromPartial(u))) || [], n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Params = e.Version = e.ConnectionPaths = e.ClientPaths = e.Counterparty = e.IdentifiedConnection = e.ConnectionEnd = e.stateToJSON = e.stateFromJSON = e.State = e.protobufPackage = void 0;
  const n = commitment, o = binary, u = helpers;
  e.protobufPackage = "ibc.core.connection.v1";
  var c;
  (function(V) {
    V[V.STATE_UNINITIALIZED_UNSPECIFIED = 0] = "STATE_UNINITIALIZED_UNSPECIFIED", V[V.STATE_INIT = 1] = "STATE_INIT", V[V.STATE_TRYOPEN = 2] = "STATE_TRYOPEN", V[V.STATE_OPEN = 3] = "STATE_OPEN", V[V.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(c || (e.State = c = {}));
  function d(V) {
    switch (V) {
      case 0:
      case "STATE_UNINITIALIZED_UNSPECIFIED":
        return c.STATE_UNINITIALIZED_UNSPECIFIED;
      case 1:
      case "STATE_INIT":
        return c.STATE_INIT;
      case 2:
      case "STATE_TRYOPEN":
        return c.STATE_TRYOPEN;
      case 3:
      case "STATE_OPEN":
        return c.STATE_OPEN;
      case -1:
      case "UNRECOGNIZED":
      default:
        return c.UNRECOGNIZED;
    }
  }
  e.stateFromJSON = d;
  function m(V) {
    switch (V) {
      case c.STATE_UNINITIALIZED_UNSPECIFIED:
        return "STATE_UNINITIALIZED_UNSPECIFIED";
      case c.STATE_INIT:
        return "STATE_INIT";
      case c.STATE_TRYOPEN:
        return "STATE_TRYOPEN";
      case c.STATE_OPEN:
        return "STATE_OPEN";
      case c.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.stateToJSON = m;
  function v() {
    return {
      clientId: "",
      versions: [],
      state: 0,
      counterparty: e.Counterparty.fromPartial({}),
      delayPeriod: BigInt(0)
    };
  }
  e.ConnectionEnd = {
    typeUrl: "/ibc.core.connection.v1.ConnectionEnd",
    encode(V, M = o.BinaryWriter.create()) {
      V.clientId !== "" && M.uint32(10).string(V.clientId);
      for (const G of V.versions)
        e.Version.encode(G, M.uint32(18).fork()).ldelim();
      return V.state !== 0 && M.uint32(24).int32(V.state), V.counterparty !== void 0 && e.Counterparty.encode(V.counterparty, M.uint32(34).fork()).ldelim(), V.delayPeriod !== BigInt(0) && M.uint32(40).uint64(V.delayPeriod), M;
    },
    decode(V, M) {
      const G = V instanceof o.BinaryReader ? V : new o.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = v();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.clientId = G.string();
            break;
          case 2:
            F.versions.push(e.Version.decode(G, G.uint32()));
            break;
          case 3:
            F.state = G.int32();
            break;
          case 4:
            F.counterparty = e.Counterparty.decode(G, G.uint32());
            break;
          case 5:
            F.delayPeriod = G.uint64();
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = v();
      return (0, u.isSet)(V.clientId) && (M.clientId = String(V.clientId)), Array.isArray(V == null ? void 0 : V.versions) && (M.versions = V.versions.map((G) => e.Version.fromJSON(G))), (0, u.isSet)(V.state) && (M.state = d(V.state)), (0, u.isSet)(V.counterparty) && (M.counterparty = e.Counterparty.fromJSON(V.counterparty)), (0, u.isSet)(V.delayPeriod) && (M.delayPeriod = BigInt(V.delayPeriod.toString())), M;
    },
    toJSON(V) {
      const M = {};
      return V.clientId !== void 0 && (M.clientId = V.clientId), V.versions ? M.versions = V.versions.map((G) => G ? e.Version.toJSON(G) : void 0) : M.versions = [], V.state !== void 0 && (M.state = m(V.state)), V.counterparty !== void 0 && (M.counterparty = V.counterparty ? e.Counterparty.toJSON(V.counterparty) : void 0), V.delayPeriod !== void 0 && (M.delayPeriod = (V.delayPeriod || BigInt(0)).toString()), M;
    },
    fromPartial(V) {
      var G;
      const M = v();
      return M.clientId = V.clientId ?? "", M.versions = ((G = V.versions) == null ? void 0 : G.map((k) => e.Version.fromPartial(k))) || [], M.state = V.state ?? 0, V.counterparty !== void 0 && V.counterparty !== null && (M.counterparty = e.Counterparty.fromPartial(V.counterparty)), V.delayPeriod !== void 0 && V.delayPeriod !== null && (M.delayPeriod = BigInt(V.delayPeriod.toString())), M;
    }
  };
  function S() {
    return {
      id: "",
      clientId: "",
      versions: [],
      state: 0,
      counterparty: e.Counterparty.fromPartial({}),
      delayPeriod: BigInt(0)
    };
  }
  e.IdentifiedConnection = {
    typeUrl: "/ibc.core.connection.v1.IdentifiedConnection",
    encode(V, M = o.BinaryWriter.create()) {
      V.id !== "" && M.uint32(10).string(V.id), V.clientId !== "" && M.uint32(18).string(V.clientId);
      for (const G of V.versions)
        e.Version.encode(G, M.uint32(26).fork()).ldelim();
      return V.state !== 0 && M.uint32(32).int32(V.state), V.counterparty !== void 0 && e.Counterparty.encode(V.counterparty, M.uint32(42).fork()).ldelim(), V.delayPeriod !== BigInt(0) && M.uint32(48).uint64(V.delayPeriod), M;
    },
    decode(V, M) {
      const G = V instanceof o.BinaryReader ? V : new o.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = S();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.id = G.string();
            break;
          case 2:
            F.clientId = G.string();
            break;
          case 3:
            F.versions.push(e.Version.decode(G, G.uint32()));
            break;
          case 4:
            F.state = G.int32();
            break;
          case 5:
            F.counterparty = e.Counterparty.decode(G, G.uint32());
            break;
          case 6:
            F.delayPeriod = G.uint64();
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = S();
      return (0, u.isSet)(V.id) && (M.id = String(V.id)), (0, u.isSet)(V.clientId) && (M.clientId = String(V.clientId)), Array.isArray(V == null ? void 0 : V.versions) && (M.versions = V.versions.map((G) => e.Version.fromJSON(G))), (0, u.isSet)(V.state) && (M.state = d(V.state)), (0, u.isSet)(V.counterparty) && (M.counterparty = e.Counterparty.fromJSON(V.counterparty)), (0, u.isSet)(V.delayPeriod) && (M.delayPeriod = BigInt(V.delayPeriod.toString())), M;
    },
    toJSON(V) {
      const M = {};
      return V.id !== void 0 && (M.id = V.id), V.clientId !== void 0 && (M.clientId = V.clientId), V.versions ? M.versions = V.versions.map((G) => G ? e.Version.toJSON(G) : void 0) : M.versions = [], V.state !== void 0 && (M.state = m(V.state)), V.counterparty !== void 0 && (M.counterparty = V.counterparty ? e.Counterparty.toJSON(V.counterparty) : void 0), V.delayPeriod !== void 0 && (M.delayPeriod = (V.delayPeriod || BigInt(0)).toString()), M;
    },
    fromPartial(V) {
      var G;
      const M = S();
      return M.id = V.id ?? "", M.clientId = V.clientId ?? "", M.versions = ((G = V.versions) == null ? void 0 : G.map((k) => e.Version.fromPartial(k))) || [], M.state = V.state ?? 0, V.counterparty !== void 0 && V.counterparty !== null && (M.counterparty = e.Counterparty.fromPartial(V.counterparty)), V.delayPeriod !== void 0 && V.delayPeriod !== null && (M.delayPeriod = BigInt(V.delayPeriod.toString())), M;
    }
  };
  function $() {
    return {
      clientId: "",
      connectionId: "",
      prefix: n.MerklePrefix.fromPartial({})
    };
  }
  e.Counterparty = {
    typeUrl: "/ibc.core.connection.v1.Counterparty",
    encode(V, M = o.BinaryWriter.create()) {
      return V.clientId !== "" && M.uint32(10).string(V.clientId), V.connectionId !== "" && M.uint32(18).string(V.connectionId), V.prefix !== void 0 && n.MerklePrefix.encode(V.prefix, M.uint32(26).fork()).ldelim(), M;
    },
    decode(V, M) {
      const G = V instanceof o.BinaryReader ? V : new o.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = $();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.clientId = G.string();
            break;
          case 2:
            F.connectionId = G.string();
            break;
          case 3:
            F.prefix = n.MerklePrefix.decode(G, G.uint32());
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = $();
      return (0, u.isSet)(V.clientId) && (M.clientId = String(V.clientId)), (0, u.isSet)(V.connectionId) && (M.connectionId = String(V.connectionId)), (0, u.isSet)(V.prefix) && (M.prefix = n.MerklePrefix.fromJSON(V.prefix)), M;
    },
    toJSON(V) {
      const M = {};
      return V.clientId !== void 0 && (M.clientId = V.clientId), V.connectionId !== void 0 && (M.connectionId = V.connectionId), V.prefix !== void 0 && (M.prefix = V.prefix ? n.MerklePrefix.toJSON(V.prefix) : void 0), M;
    },
    fromPartial(V) {
      const M = $();
      return M.clientId = V.clientId ?? "", M.connectionId = V.connectionId ?? "", V.prefix !== void 0 && V.prefix !== null && (M.prefix = n.MerklePrefix.fromPartial(V.prefix)), M;
    }
  };
  function E() {
    return {
      paths: []
    };
  }
  e.ClientPaths = {
    typeUrl: "/ibc.core.connection.v1.ClientPaths",
    encode(V, M = o.BinaryWriter.create()) {
      for (const G of V.paths)
        M.uint32(10).string(G);
      return M;
    },
    decode(V, M) {
      const G = V instanceof o.BinaryReader ? V : new o.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = E();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.paths.push(G.string());
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = E();
      return Array.isArray(V == null ? void 0 : V.paths) && (M.paths = V.paths.map((G) => String(G))), M;
    },
    toJSON(V) {
      const M = {};
      return V.paths ? M.paths = V.paths.map((G) => G) : M.paths = [], M;
    },
    fromPartial(V) {
      var G;
      const M = E();
      return M.paths = ((G = V.paths) == null ? void 0 : G.map((k) => k)) || [], M;
    }
  };
  function O() {
    return {
      clientId: "",
      paths: []
    };
  }
  e.ConnectionPaths = {
    typeUrl: "/ibc.core.connection.v1.ConnectionPaths",
    encode(V, M = o.BinaryWriter.create()) {
      V.clientId !== "" && M.uint32(10).string(V.clientId);
      for (const G of V.paths)
        M.uint32(18).string(G);
      return M;
    },
    decode(V, M) {
      const G = V instanceof o.BinaryReader ? V : new o.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = O();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.clientId = G.string();
            break;
          case 2:
            F.paths.push(G.string());
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = O();
      return (0, u.isSet)(V.clientId) && (M.clientId = String(V.clientId)), Array.isArray(V == null ? void 0 : V.paths) && (M.paths = V.paths.map((G) => String(G))), M;
    },
    toJSON(V) {
      const M = {};
      return V.clientId !== void 0 && (M.clientId = V.clientId), V.paths ? M.paths = V.paths.map((G) => G) : M.paths = [], M;
    },
    fromPartial(V) {
      var G;
      const M = O();
      return M.clientId = V.clientId ?? "", M.paths = ((G = V.paths) == null ? void 0 : G.map((k) => k)) || [], M;
    }
  };
  function T() {
    return {
      identifier: "",
      features: []
    };
  }
  e.Version = {
    typeUrl: "/ibc.core.connection.v1.Version",
    encode(V, M = o.BinaryWriter.create()) {
      V.identifier !== "" && M.uint32(10).string(V.identifier);
      for (const G of V.features)
        M.uint32(18).string(G);
      return M;
    },
    decode(V, M) {
      const G = V instanceof o.BinaryReader ? V : new o.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = T();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.identifier = G.string();
            break;
          case 2:
            F.features.push(G.string());
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = T();
      return (0, u.isSet)(V.identifier) && (M.identifier = String(V.identifier)), Array.isArray(V == null ? void 0 : V.features) && (M.features = V.features.map((G) => String(G))), M;
    },
    toJSON(V) {
      const M = {};
      return V.identifier !== void 0 && (M.identifier = V.identifier), V.features ? M.features = V.features.map((G) => G) : M.features = [], M;
    },
    fromPartial(V) {
      var G;
      const M = T();
      return M.identifier = V.identifier ?? "", M.features = ((G = V.features) == null ? void 0 : G.map((k) => k)) || [], M;
    }
  };
  function y() {
    return {
      maxExpectedTimePerBlock: BigInt(0)
    };
  }
  e.Params = {
    typeUrl: "/ibc.core.connection.v1.Params",
    encode(V, M = o.BinaryWriter.create()) {
      return V.maxExpectedTimePerBlock !== BigInt(0) && M.uint32(8).uint64(V.maxExpectedTimePerBlock), M;
    },
    decode(V, M) {
      const G = V instanceof o.BinaryReader ? V : new o.BinaryReader(V);
      let k = M === void 0 ? G.len : G.pos + M;
      const F = y();
      for (; G.pos < k; ) {
        const X = G.uint32();
        switch (X >>> 3) {
          case 1:
            F.maxExpectedTimePerBlock = G.uint64();
            break;
          default:
            G.skipType(X & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(V) {
      const M = y();
      return (0, u.isSet)(V.maxExpectedTimePerBlock) && (M.maxExpectedTimePerBlock = BigInt(V.maxExpectedTimePerBlock.toString())), M;
    },
    toJSON(V) {
      const M = {};
      return V.maxExpectedTimePerBlock !== void 0 && (M.maxExpectedTimePerBlock = (V.maxExpectedTimePerBlock || BigInt(0)).toString()), M;
    },
    fromPartial(V) {
      const M = y();
      return V.maxExpectedTimePerBlock !== void 0 && V.maxExpectedTimePerBlock !== null && (M.maxExpectedTimePerBlock = BigInt(V.maxExpectedTimePerBlock.toString())), M;
    }
  };
})(connection);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgConnectionOpenConfirmResponse = e.MsgConnectionOpenConfirm = e.MsgConnectionOpenAckResponse = e.MsgConnectionOpenAck = e.MsgConnectionOpenTryResponse = e.MsgConnectionOpenTry = e.MsgConnectionOpenInitResponse = e.MsgConnectionOpenInit = e.protobufPackage = void 0;
  const n = connection, o = any$1, u = client$1, c = binary, d = helpers;
  e.protobufPackage = "ibc.core.connection.v1";
  function m() {
    return {
      clientId: "",
      counterparty: n.Counterparty.fromPartial({}),
      version: void 0,
      delayPeriod: BigInt(0),
      signer: ""
    };
  }
  e.MsgConnectionOpenInit = {
    typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
    encode(M, G = c.BinaryWriter.create()) {
      return M.clientId !== "" && G.uint32(10).string(M.clientId), M.counterparty !== void 0 && n.Counterparty.encode(M.counterparty, G.uint32(18).fork()).ldelim(), M.version !== void 0 && n.Version.encode(M.version, G.uint32(26).fork()).ldelim(), M.delayPeriod !== BigInt(0) && G.uint32(32).uint64(M.delayPeriod), M.signer !== "" && G.uint32(42).string(M.signer), G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = m();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.clientId = k.string();
            break;
          case 2:
            X.counterparty = n.Counterparty.decode(k, k.uint32());
            break;
          case 3:
            X.version = n.Version.decode(k, k.uint32());
            break;
          case 4:
            X.delayPeriod = k.uint64();
            break;
          case 5:
            X.signer = k.string();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = m();
      return (0, d.isSet)(M.clientId) && (G.clientId = String(M.clientId)), (0, d.isSet)(M.counterparty) && (G.counterparty = n.Counterparty.fromJSON(M.counterparty)), (0, d.isSet)(M.version) && (G.version = n.Version.fromJSON(M.version)), (0, d.isSet)(M.delayPeriod) && (G.delayPeriod = BigInt(M.delayPeriod.toString())), (0, d.isSet)(M.signer) && (G.signer = String(M.signer)), G;
    },
    toJSON(M) {
      const G = {};
      return M.clientId !== void 0 && (G.clientId = M.clientId), M.counterparty !== void 0 && (G.counterparty = M.counterparty ? n.Counterparty.toJSON(M.counterparty) : void 0), M.version !== void 0 && (G.version = M.version ? n.Version.toJSON(M.version) : void 0), M.delayPeriod !== void 0 && (G.delayPeriod = (M.delayPeriod || BigInt(0)).toString()), M.signer !== void 0 && (G.signer = M.signer), G;
    },
    fromPartial(M) {
      const G = m();
      return G.clientId = M.clientId ?? "", M.counterparty !== void 0 && M.counterparty !== null && (G.counterparty = n.Counterparty.fromPartial(M.counterparty)), M.version !== void 0 && M.version !== null && (G.version = n.Version.fromPartial(M.version)), M.delayPeriod !== void 0 && M.delayPeriod !== null && (G.delayPeriod = BigInt(M.delayPeriod.toString())), G.signer = M.signer ?? "", G;
    }
  };
  function v() {
    return {};
  }
  e.MsgConnectionOpenInitResponse = {
    typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInitResponse",
    encode(M, G = c.BinaryWriter.create()) {
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = v();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      return v();
    },
    toJSON(M) {
      return {};
    },
    fromPartial(M) {
      return v();
    }
  };
  function S() {
    return {
      clientId: "",
      previousConnectionId: "",
      clientState: void 0,
      counterparty: n.Counterparty.fromPartial({}),
      delayPeriod: BigInt(0),
      counterpartyVersions: [],
      proofHeight: u.Height.fromPartial({}),
      proofInit: new Uint8Array(),
      proofClient: new Uint8Array(),
      proofConsensus: new Uint8Array(),
      consensusHeight: u.Height.fromPartial({}),
      signer: "",
      hostConsensusStateProof: new Uint8Array()
    };
  }
  e.MsgConnectionOpenTry = {
    typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
    encode(M, G = c.BinaryWriter.create()) {
      M.clientId !== "" && G.uint32(10).string(M.clientId), M.previousConnectionId !== "" && G.uint32(18).string(M.previousConnectionId), M.clientState !== void 0 && o.Any.encode(M.clientState, G.uint32(26).fork()).ldelim(), M.counterparty !== void 0 && n.Counterparty.encode(M.counterparty, G.uint32(34).fork()).ldelim(), M.delayPeriod !== BigInt(0) && G.uint32(40).uint64(M.delayPeriod);
      for (const k of M.counterpartyVersions)
        n.Version.encode(k, G.uint32(50).fork()).ldelim();
      return M.proofHeight !== void 0 && u.Height.encode(M.proofHeight, G.uint32(58).fork()).ldelim(), M.proofInit.length !== 0 && G.uint32(66).bytes(M.proofInit), M.proofClient.length !== 0 && G.uint32(74).bytes(M.proofClient), M.proofConsensus.length !== 0 && G.uint32(82).bytes(M.proofConsensus), M.consensusHeight !== void 0 && u.Height.encode(M.consensusHeight, G.uint32(90).fork()).ldelim(), M.signer !== "" && G.uint32(98).string(M.signer), M.hostConsensusStateProof.length !== 0 && G.uint32(106).bytes(M.hostConsensusStateProof), G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = S();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.clientId = k.string();
            break;
          case 2:
            X.previousConnectionId = k.string();
            break;
          case 3:
            X.clientState = o.Any.decode(k, k.uint32());
            break;
          case 4:
            X.counterparty = n.Counterparty.decode(k, k.uint32());
            break;
          case 5:
            X.delayPeriod = k.uint64();
            break;
          case 6:
            X.counterpartyVersions.push(n.Version.decode(k, k.uint32()));
            break;
          case 7:
            X.proofHeight = u.Height.decode(k, k.uint32());
            break;
          case 8:
            X.proofInit = k.bytes();
            break;
          case 9:
            X.proofClient = k.bytes();
            break;
          case 10:
            X.proofConsensus = k.bytes();
            break;
          case 11:
            X.consensusHeight = u.Height.decode(k, k.uint32());
            break;
          case 12:
            X.signer = k.string();
            break;
          case 13:
            X.hostConsensusStateProof = k.bytes();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = S();
      return (0, d.isSet)(M.clientId) && (G.clientId = String(M.clientId)), (0, d.isSet)(M.previousConnectionId) && (G.previousConnectionId = String(M.previousConnectionId)), (0, d.isSet)(M.clientState) && (G.clientState = o.Any.fromJSON(M.clientState)), (0, d.isSet)(M.counterparty) && (G.counterparty = n.Counterparty.fromJSON(M.counterparty)), (0, d.isSet)(M.delayPeriod) && (G.delayPeriod = BigInt(M.delayPeriod.toString())), Array.isArray(M == null ? void 0 : M.counterpartyVersions) && (G.counterpartyVersions = M.counterpartyVersions.map((k) => n.Version.fromJSON(k))), (0, d.isSet)(M.proofHeight) && (G.proofHeight = u.Height.fromJSON(M.proofHeight)), (0, d.isSet)(M.proofInit) && (G.proofInit = (0, d.bytesFromBase64)(M.proofInit)), (0, d.isSet)(M.proofClient) && (G.proofClient = (0, d.bytesFromBase64)(M.proofClient)), (0, d.isSet)(M.proofConsensus) && (G.proofConsensus = (0, d.bytesFromBase64)(M.proofConsensus)), (0, d.isSet)(M.consensusHeight) && (G.consensusHeight = u.Height.fromJSON(M.consensusHeight)), (0, d.isSet)(M.signer) && (G.signer = String(M.signer)), (0, d.isSet)(M.hostConsensusStateProof) && (G.hostConsensusStateProof = (0, d.bytesFromBase64)(M.hostConsensusStateProof)), G;
    },
    toJSON(M) {
      const G = {};
      return M.clientId !== void 0 && (G.clientId = M.clientId), M.previousConnectionId !== void 0 && (G.previousConnectionId = M.previousConnectionId), M.clientState !== void 0 && (G.clientState = M.clientState ? o.Any.toJSON(M.clientState) : void 0), M.counterparty !== void 0 && (G.counterparty = M.counterparty ? n.Counterparty.toJSON(M.counterparty) : void 0), M.delayPeriod !== void 0 && (G.delayPeriod = (M.delayPeriod || BigInt(0)).toString()), M.counterpartyVersions ? G.counterpartyVersions = M.counterpartyVersions.map((k) => k ? n.Version.toJSON(k) : void 0) : G.counterpartyVersions = [], M.proofHeight !== void 0 && (G.proofHeight = M.proofHeight ? u.Height.toJSON(M.proofHeight) : void 0), M.proofInit !== void 0 && (G.proofInit = (0, d.base64FromBytes)(M.proofInit !== void 0 ? M.proofInit : new Uint8Array())), M.proofClient !== void 0 && (G.proofClient = (0, d.base64FromBytes)(M.proofClient !== void 0 ? M.proofClient : new Uint8Array())), M.proofConsensus !== void 0 && (G.proofConsensus = (0, d.base64FromBytes)(M.proofConsensus !== void 0 ? M.proofConsensus : new Uint8Array())), M.consensusHeight !== void 0 && (G.consensusHeight = M.consensusHeight ? u.Height.toJSON(M.consensusHeight) : void 0), M.signer !== void 0 && (G.signer = M.signer), M.hostConsensusStateProof !== void 0 && (G.hostConsensusStateProof = (0, d.base64FromBytes)(M.hostConsensusStateProof !== void 0 ? M.hostConsensusStateProof : new Uint8Array())), G;
    },
    fromPartial(M) {
      var k;
      const G = S();
      return G.clientId = M.clientId ?? "", G.previousConnectionId = M.previousConnectionId ?? "", M.clientState !== void 0 && M.clientState !== null && (G.clientState = o.Any.fromPartial(M.clientState)), M.counterparty !== void 0 && M.counterparty !== null && (G.counterparty = n.Counterparty.fromPartial(M.counterparty)), M.delayPeriod !== void 0 && M.delayPeriod !== null && (G.delayPeriod = BigInt(M.delayPeriod.toString())), G.counterpartyVersions = ((k = M.counterpartyVersions) == null ? void 0 : k.map((F) => n.Version.fromPartial(F))) || [], M.proofHeight !== void 0 && M.proofHeight !== null && (G.proofHeight = u.Height.fromPartial(M.proofHeight)), G.proofInit = M.proofInit ?? new Uint8Array(), G.proofClient = M.proofClient ?? new Uint8Array(), G.proofConsensus = M.proofConsensus ?? new Uint8Array(), M.consensusHeight !== void 0 && M.consensusHeight !== null && (G.consensusHeight = u.Height.fromPartial(M.consensusHeight)), G.signer = M.signer ?? "", G.hostConsensusStateProof = M.hostConsensusStateProof ?? new Uint8Array(), G;
    }
  };
  function $() {
    return {};
  }
  e.MsgConnectionOpenTryResponse = {
    typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTryResponse",
    encode(M, G = c.BinaryWriter.create()) {
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = $();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      return $();
    },
    toJSON(M) {
      return {};
    },
    fromPartial(M) {
      return $();
    }
  };
  function E() {
    return {
      connectionId: "",
      counterpartyConnectionId: "",
      version: void 0,
      clientState: void 0,
      proofHeight: u.Height.fromPartial({}),
      proofTry: new Uint8Array(),
      proofClient: new Uint8Array(),
      proofConsensus: new Uint8Array(),
      consensusHeight: u.Height.fromPartial({}),
      signer: "",
      hostConsensusStateProof: new Uint8Array()
    };
  }
  e.MsgConnectionOpenAck = {
    typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
    encode(M, G = c.BinaryWriter.create()) {
      return M.connectionId !== "" && G.uint32(10).string(M.connectionId), M.counterpartyConnectionId !== "" && G.uint32(18).string(M.counterpartyConnectionId), M.version !== void 0 && n.Version.encode(M.version, G.uint32(26).fork()).ldelim(), M.clientState !== void 0 && o.Any.encode(M.clientState, G.uint32(34).fork()).ldelim(), M.proofHeight !== void 0 && u.Height.encode(M.proofHeight, G.uint32(42).fork()).ldelim(), M.proofTry.length !== 0 && G.uint32(50).bytes(M.proofTry), M.proofClient.length !== 0 && G.uint32(58).bytes(M.proofClient), M.proofConsensus.length !== 0 && G.uint32(66).bytes(M.proofConsensus), M.consensusHeight !== void 0 && u.Height.encode(M.consensusHeight, G.uint32(74).fork()).ldelim(), M.signer !== "" && G.uint32(82).string(M.signer), M.hostConsensusStateProof.length !== 0 && G.uint32(90).bytes(M.hostConsensusStateProof), G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = E();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.connectionId = k.string();
            break;
          case 2:
            X.counterpartyConnectionId = k.string();
            break;
          case 3:
            X.version = n.Version.decode(k, k.uint32());
            break;
          case 4:
            X.clientState = o.Any.decode(k, k.uint32());
            break;
          case 5:
            X.proofHeight = u.Height.decode(k, k.uint32());
            break;
          case 6:
            X.proofTry = k.bytes();
            break;
          case 7:
            X.proofClient = k.bytes();
            break;
          case 8:
            X.proofConsensus = k.bytes();
            break;
          case 9:
            X.consensusHeight = u.Height.decode(k, k.uint32());
            break;
          case 10:
            X.signer = k.string();
            break;
          case 11:
            X.hostConsensusStateProof = k.bytes();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = E();
      return (0, d.isSet)(M.connectionId) && (G.connectionId = String(M.connectionId)), (0, d.isSet)(M.counterpartyConnectionId) && (G.counterpartyConnectionId = String(M.counterpartyConnectionId)), (0, d.isSet)(M.version) && (G.version = n.Version.fromJSON(M.version)), (0, d.isSet)(M.clientState) && (G.clientState = o.Any.fromJSON(M.clientState)), (0, d.isSet)(M.proofHeight) && (G.proofHeight = u.Height.fromJSON(M.proofHeight)), (0, d.isSet)(M.proofTry) && (G.proofTry = (0, d.bytesFromBase64)(M.proofTry)), (0, d.isSet)(M.proofClient) && (G.proofClient = (0, d.bytesFromBase64)(M.proofClient)), (0, d.isSet)(M.proofConsensus) && (G.proofConsensus = (0, d.bytesFromBase64)(M.proofConsensus)), (0, d.isSet)(M.consensusHeight) && (G.consensusHeight = u.Height.fromJSON(M.consensusHeight)), (0, d.isSet)(M.signer) && (G.signer = String(M.signer)), (0, d.isSet)(M.hostConsensusStateProof) && (G.hostConsensusStateProof = (0, d.bytesFromBase64)(M.hostConsensusStateProof)), G;
    },
    toJSON(M) {
      const G = {};
      return M.connectionId !== void 0 && (G.connectionId = M.connectionId), M.counterpartyConnectionId !== void 0 && (G.counterpartyConnectionId = M.counterpartyConnectionId), M.version !== void 0 && (G.version = M.version ? n.Version.toJSON(M.version) : void 0), M.clientState !== void 0 && (G.clientState = M.clientState ? o.Any.toJSON(M.clientState) : void 0), M.proofHeight !== void 0 && (G.proofHeight = M.proofHeight ? u.Height.toJSON(M.proofHeight) : void 0), M.proofTry !== void 0 && (G.proofTry = (0, d.base64FromBytes)(M.proofTry !== void 0 ? M.proofTry : new Uint8Array())), M.proofClient !== void 0 && (G.proofClient = (0, d.base64FromBytes)(M.proofClient !== void 0 ? M.proofClient : new Uint8Array())), M.proofConsensus !== void 0 && (G.proofConsensus = (0, d.base64FromBytes)(M.proofConsensus !== void 0 ? M.proofConsensus : new Uint8Array())), M.consensusHeight !== void 0 && (G.consensusHeight = M.consensusHeight ? u.Height.toJSON(M.consensusHeight) : void 0), M.signer !== void 0 && (G.signer = M.signer), M.hostConsensusStateProof !== void 0 && (G.hostConsensusStateProof = (0, d.base64FromBytes)(M.hostConsensusStateProof !== void 0 ? M.hostConsensusStateProof : new Uint8Array())), G;
    },
    fromPartial(M) {
      const G = E();
      return G.connectionId = M.connectionId ?? "", G.counterpartyConnectionId = M.counterpartyConnectionId ?? "", M.version !== void 0 && M.version !== null && (G.version = n.Version.fromPartial(M.version)), M.clientState !== void 0 && M.clientState !== null && (G.clientState = o.Any.fromPartial(M.clientState)), M.proofHeight !== void 0 && M.proofHeight !== null && (G.proofHeight = u.Height.fromPartial(M.proofHeight)), G.proofTry = M.proofTry ?? new Uint8Array(), G.proofClient = M.proofClient ?? new Uint8Array(), G.proofConsensus = M.proofConsensus ?? new Uint8Array(), M.consensusHeight !== void 0 && M.consensusHeight !== null && (G.consensusHeight = u.Height.fromPartial(M.consensusHeight)), G.signer = M.signer ?? "", G.hostConsensusStateProof = M.hostConsensusStateProof ?? new Uint8Array(), G;
    }
  };
  function O() {
    return {};
  }
  e.MsgConnectionOpenAckResponse = {
    typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAckResponse",
    encode(M, G = c.BinaryWriter.create()) {
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = O();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      return O();
    },
    toJSON(M) {
      return {};
    },
    fromPartial(M) {
      return O();
    }
  };
  function T() {
    return {
      connectionId: "",
      proofAck: new Uint8Array(),
      proofHeight: u.Height.fromPartial({}),
      signer: ""
    };
  }
  e.MsgConnectionOpenConfirm = {
    typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
    encode(M, G = c.BinaryWriter.create()) {
      return M.connectionId !== "" && G.uint32(10).string(M.connectionId), M.proofAck.length !== 0 && G.uint32(18).bytes(M.proofAck), M.proofHeight !== void 0 && u.Height.encode(M.proofHeight, G.uint32(26).fork()).ldelim(), M.signer !== "" && G.uint32(34).string(M.signer), G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = T();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.connectionId = k.string();
            break;
          case 2:
            X.proofAck = k.bytes();
            break;
          case 3:
            X.proofHeight = u.Height.decode(k, k.uint32());
            break;
          case 4:
            X.signer = k.string();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = T();
      return (0, d.isSet)(M.connectionId) && (G.connectionId = String(M.connectionId)), (0, d.isSet)(M.proofAck) && (G.proofAck = (0, d.bytesFromBase64)(M.proofAck)), (0, d.isSet)(M.proofHeight) && (G.proofHeight = u.Height.fromJSON(M.proofHeight)), (0, d.isSet)(M.signer) && (G.signer = String(M.signer)), G;
    },
    toJSON(M) {
      const G = {};
      return M.connectionId !== void 0 && (G.connectionId = M.connectionId), M.proofAck !== void 0 && (G.proofAck = (0, d.base64FromBytes)(M.proofAck !== void 0 ? M.proofAck : new Uint8Array())), M.proofHeight !== void 0 && (G.proofHeight = M.proofHeight ? u.Height.toJSON(M.proofHeight) : void 0), M.signer !== void 0 && (G.signer = M.signer), G;
    },
    fromPartial(M) {
      const G = T();
      return G.connectionId = M.connectionId ?? "", G.proofAck = M.proofAck ?? new Uint8Array(), M.proofHeight !== void 0 && M.proofHeight !== null && (G.proofHeight = u.Height.fromPartial(M.proofHeight)), G.signer = M.signer ?? "", G;
    }
  };
  function y() {
    return {};
  }
  e.MsgConnectionOpenConfirmResponse = {
    typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirmResponse",
    encode(M, G = c.BinaryWriter.create()) {
      return G;
    },
    decode(M, G) {
      const k = M instanceof c.BinaryReader ? M : new c.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = y();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      return y();
    },
    toJSON(M) {
      return {};
    },
    fromPartial(M) {
      return y();
    }
  };
  class V {
    constructor(G) {
      this.rpc = G, this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this), this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this), this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this), this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    ConnectionOpenInit(G) {
      const k = e.MsgConnectionOpenInit.encode(G).finish();
      return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", k).then((X) => e.MsgConnectionOpenInitResponse.decode(new c.BinaryReader(X)));
    }
    ConnectionOpenTry(G) {
      const k = e.MsgConnectionOpenTry.encode(G).finish();
      return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", k).then((X) => e.MsgConnectionOpenTryResponse.decode(new c.BinaryReader(X)));
    }
    ConnectionOpenAck(G) {
      const k = e.MsgConnectionOpenAck.encode(G).finish();
      return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", k).then((X) => e.MsgConnectionOpenAckResponse.decode(new c.BinaryReader(X)));
    }
    ConnectionOpenConfirm(G) {
      const k = e.MsgConnectionOpenConfirm.encode(G).finish();
      return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", k).then((X) => e.MsgConnectionOpenConfirmResponse.decode(new c.BinaryReader(X)));
    }
  }
  e.MsgClientImpl = V;
})(tx$e);
Object.defineProperty(messages$c, "__esModule", { value: !0 });
messages$c.isMsgTransferEncodeObject = messages$c.ibcTypes = void 0;
const tx_1$j = tx$h, tx_2$5 = tx$g, tx_3$2 = tx$f, tx_4$2 = tx$e;
messages$c.ibcTypes = [
  ["/ibc.applications.transfer.v1.MsgTransfer", tx_1$j.MsgTransfer],
  ["/ibc.core.channel.v1.MsgAcknowledgement", tx_2$5.MsgAcknowledgement],
  ["/ibc.core.channel.v1.MsgChannelCloseConfirm", tx_2$5.MsgChannelCloseConfirm],
  ["/ibc.core.channel.v1.MsgChannelCloseInit", tx_2$5.MsgChannelCloseInit],
  ["/ibc.core.channel.v1.MsgChannelOpenAck", tx_2$5.MsgChannelOpenAck],
  ["/ibc.core.channel.v1.MsgChannelOpenConfirm", tx_2$5.MsgChannelOpenConfirm],
  ["/ibc.core.channel.v1.MsgChannelOpenInit", tx_2$5.MsgChannelOpenInit],
  ["/ibc.core.channel.v1.MsgChannelOpenTry", tx_2$5.MsgChannelOpenTry],
  ["/ibc.core.channel.v1.MsgRecvPacket", tx_2$5.MsgRecvPacket],
  ["/ibc.core.channel.v1.MsgTimeout", tx_2$5.MsgTimeout],
  ["/ibc.core.channel.v1.MsgTimeoutOnClose", tx_2$5.MsgTimeoutOnClose],
  ["/ibc.core.client.v1.MsgCreateClient", tx_3$2.MsgCreateClient],
  ["/ibc.core.client.v1.MsgSubmitMisbehaviour", tx_3$2.MsgSubmitMisbehaviour],
  ["/ibc.core.client.v1.MsgUpdateClient", tx_3$2.MsgUpdateClient],
  ["/ibc.core.client.v1.MsgUpgradeClient", tx_3$2.MsgUpgradeClient],
  ["/ibc.core.connection.v1.MsgConnectionOpenAck", tx_4$2.MsgConnectionOpenAck],
  ["/ibc.core.connection.v1.MsgConnectionOpenConfirm", tx_4$2.MsgConnectionOpenConfirm],
  ["/ibc.core.connection.v1.MsgConnectionOpenInit", tx_4$2.MsgConnectionOpenInit],
  ["/ibc.core.connection.v1.MsgConnectionOpenTry", tx_4$2.MsgConnectionOpenTry]
];
function isMsgTransferEncodeObject$1(e) {
  return e.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
messages$c.isMsgTransferEncodeObject = isMsgTransferEncodeObject$1;
var queries$g = {}, query$7 = {}, transfer = {};
Object.defineProperty(transfer, "__esModule", { value: !0 });
transfer.Params = transfer.DenomTrace = transfer.protobufPackage = void 0;
const binary_1$5 = binary, helpers_1$5 = helpers;
transfer.protobufPackage = "ibc.applications.transfer.v1";
function createBaseDenomTrace$1() {
  return {
    path: "",
    baseDenom: ""
  };
}
transfer.DenomTrace = {
  typeUrl: "/ibc.applications.transfer.v1.DenomTrace",
  encode(e, n = binary_1$5.BinaryWriter.create()) {
    return e.path !== "" && n.uint32(10).string(e.path), e.baseDenom !== "" && n.uint32(18).string(e.baseDenom), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$5.BinaryReader ? e : new binary_1$5.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDenomTrace$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.string();
          break;
        case 2:
          c.baseDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseDenomTrace$1();
    return (0, helpers_1$5.isSet)(e.path) && (n.path = String(e.path)), (0, helpers_1$5.isSet)(e.baseDenom) && (n.baseDenom = String(e.baseDenom)), n;
  },
  toJSON(e) {
    const n = {};
    return e.path !== void 0 && (n.path = e.path), e.baseDenom !== void 0 && (n.baseDenom = e.baseDenom), n;
  },
  fromPartial(e) {
    const n = createBaseDenomTrace$1();
    return n.path = e.path ?? "", n.baseDenom = e.baseDenom ?? "", n;
  }
};
function createBaseParams$p() {
  return {
    sendEnabled: !1,
    receiveEnabled: !1
  };
}
transfer.Params = {
  typeUrl: "/ibc.applications.transfer.v1.Params",
  encode(e, n = binary_1$5.BinaryWriter.create()) {
    return e.sendEnabled === !0 && n.uint32(8).bool(e.sendEnabled), e.receiveEnabled === !0 && n.uint32(16).bool(e.receiveEnabled), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$5.BinaryReader ? e : new binary_1$5.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$p();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sendEnabled = o.bool();
          break;
        case 2:
          c.receiveEnabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseParams$p();
    return (0, helpers_1$5.isSet)(e.sendEnabled) && (n.sendEnabled = !!e.sendEnabled), (0, helpers_1$5.isSet)(e.receiveEnabled) && (n.receiveEnabled = !!e.receiveEnabled), n;
  },
  toJSON(e) {
    const n = {};
    return e.sendEnabled !== void 0 && (n.sendEnabled = e.sendEnabled), e.receiveEnabled !== void 0 && (n.receiveEnabled = e.receiveEnabled), n;
  },
  fromPartial(e) {
    const n = createBaseParams$p();
    return n.sendEnabled = e.sendEnabled ?? !1, n.receiveEnabled = e.receiveEnabled ?? !1, n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryEscrowAddressResponse = e.QueryEscrowAddressRequest = e.QueryDenomHashResponse = e.QueryDenomHashRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryDenomTracesResponse = e.QueryDenomTracesRequest = e.QueryDenomTraceResponse = e.QueryDenomTraceRequest = e.protobufPackage = void 0;
  const n = pagination, o = transfer, u = binary, c = helpers;
  e.protobufPackage = "ibc.applications.transfer.v1";
  function d() {
    return {
      hash: ""
    };
  }
  e.QueryDenomTraceRequest = {
    typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceRequest",
    encode(G, k = u.BinaryWriter.create()) {
      return G.hash !== "" && k.uint32(10).string(G.hash), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = d();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.hash = F.string();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = d();
      return (0, c.isSet)(G.hash) && (k.hash = String(G.hash)), k;
    },
    toJSON(G) {
      const k = {};
      return G.hash !== void 0 && (k.hash = G.hash), k;
    },
    fromPartial(G) {
      const k = d();
      return k.hash = G.hash ?? "", k;
    }
  };
  function m() {
    return {
      denomTrace: void 0
    };
  }
  e.QueryDenomTraceResponse = {
    typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceResponse",
    encode(G, k = u.BinaryWriter.create()) {
      return G.denomTrace !== void 0 && o.DenomTrace.encode(G.denomTrace, k.uint32(10).fork()).ldelim(), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = m();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.denomTrace = o.DenomTrace.decode(F, F.uint32());
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = m();
      return (0, c.isSet)(G.denomTrace) && (k.denomTrace = o.DenomTrace.fromJSON(G.denomTrace)), k;
    },
    toJSON(G) {
      const k = {};
      return G.denomTrace !== void 0 && (k.denomTrace = G.denomTrace ? o.DenomTrace.toJSON(G.denomTrace) : void 0), k;
    },
    fromPartial(G) {
      const k = m();
      return G.denomTrace !== void 0 && G.denomTrace !== null && (k.denomTrace = o.DenomTrace.fromPartial(G.denomTrace)), k;
    }
  };
  function v() {
    return {
      pagination: void 0
    };
  }
  e.QueryDenomTracesRequest = {
    typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesRequest",
    encode(G, k = u.BinaryWriter.create()) {
      return G.pagination !== void 0 && n.PageRequest.encode(G.pagination, k.uint32(10).fork()).ldelim(), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = v();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.pagination = n.PageRequest.decode(F, F.uint32());
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = v();
      return (0, c.isSet)(G.pagination) && (k.pagination = n.PageRequest.fromJSON(G.pagination)), k;
    },
    toJSON(G) {
      const k = {};
      return G.pagination !== void 0 && (k.pagination = G.pagination ? n.PageRequest.toJSON(G.pagination) : void 0), k;
    },
    fromPartial(G) {
      const k = v();
      return G.pagination !== void 0 && G.pagination !== null && (k.pagination = n.PageRequest.fromPartial(G.pagination)), k;
    }
  };
  function S() {
    return {
      denomTraces: [],
      pagination: void 0
    };
  }
  e.QueryDenomTracesResponse = {
    typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesResponse",
    encode(G, k = u.BinaryWriter.create()) {
      for (const F of G.denomTraces)
        o.DenomTrace.encode(F, k.uint32(10).fork()).ldelim();
      return G.pagination !== void 0 && n.PageResponse.encode(G.pagination, k.uint32(18).fork()).ldelim(), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = S();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.denomTraces.push(o.DenomTrace.decode(F, F.uint32()));
            break;
          case 2:
            ee.pagination = n.PageResponse.decode(F, F.uint32());
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = S();
      return Array.isArray(G == null ? void 0 : G.denomTraces) && (k.denomTraces = G.denomTraces.map((F) => o.DenomTrace.fromJSON(F))), (0, c.isSet)(G.pagination) && (k.pagination = n.PageResponse.fromJSON(G.pagination)), k;
    },
    toJSON(G) {
      const k = {};
      return G.denomTraces ? k.denomTraces = G.denomTraces.map((F) => F ? o.DenomTrace.toJSON(F) : void 0) : k.denomTraces = [], G.pagination !== void 0 && (k.pagination = G.pagination ? n.PageResponse.toJSON(G.pagination) : void 0), k;
    },
    fromPartial(G) {
      var F;
      const k = S();
      return k.denomTraces = ((F = G.denomTraces) == null ? void 0 : F.map((X) => o.DenomTrace.fromPartial(X))) || [], G.pagination !== void 0 && G.pagination !== null && (k.pagination = n.PageResponse.fromPartial(G.pagination)), k;
    }
  };
  function $() {
    return {};
  }
  e.QueryParamsRequest = {
    typeUrl: "/ibc.applications.transfer.v1.QueryParamsRequest",
    encode(G, k = u.BinaryWriter.create()) {
      return k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = $();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      return $();
    },
    toJSON(G) {
      return {};
    },
    fromPartial(G) {
      return $();
    }
  };
  function E() {
    return {
      params: void 0
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/ibc.applications.transfer.v1.QueryParamsResponse",
    encode(G, k = u.BinaryWriter.create()) {
      return G.params !== void 0 && o.Params.encode(G.params, k.uint32(10).fork()).ldelim(), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = E();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.params = o.Params.decode(F, F.uint32());
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = E();
      return (0, c.isSet)(G.params) && (k.params = o.Params.fromJSON(G.params)), k;
    },
    toJSON(G) {
      const k = {};
      return G.params !== void 0 && (k.params = G.params ? o.Params.toJSON(G.params) : void 0), k;
    },
    fromPartial(G) {
      const k = E();
      return G.params !== void 0 && G.params !== null && (k.params = o.Params.fromPartial(G.params)), k;
    }
  };
  function O() {
    return {
      trace: ""
    };
  }
  e.QueryDenomHashRequest = {
    typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashRequest",
    encode(G, k = u.BinaryWriter.create()) {
      return G.trace !== "" && k.uint32(10).string(G.trace), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = O();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.trace = F.string();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = O();
      return (0, c.isSet)(G.trace) && (k.trace = String(G.trace)), k;
    },
    toJSON(G) {
      const k = {};
      return G.trace !== void 0 && (k.trace = G.trace), k;
    },
    fromPartial(G) {
      const k = O();
      return k.trace = G.trace ?? "", k;
    }
  };
  function T() {
    return {
      hash: ""
    };
  }
  e.QueryDenomHashResponse = {
    typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashResponse",
    encode(G, k = u.BinaryWriter.create()) {
      return G.hash !== "" && k.uint32(10).string(G.hash), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = T();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.hash = F.string();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = T();
      return (0, c.isSet)(G.hash) && (k.hash = String(G.hash)), k;
    },
    toJSON(G) {
      const k = {};
      return G.hash !== void 0 && (k.hash = G.hash), k;
    },
    fromPartial(G) {
      const k = T();
      return k.hash = G.hash ?? "", k;
    }
  };
  function y() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.QueryEscrowAddressRequest = {
    typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressRequest",
    encode(G, k = u.BinaryWriter.create()) {
      return G.portId !== "" && k.uint32(10).string(G.portId), G.channelId !== "" && k.uint32(18).string(G.channelId), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = y();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.portId = F.string();
            break;
          case 2:
            ee.channelId = F.string();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = y();
      return (0, c.isSet)(G.portId) && (k.portId = String(G.portId)), (0, c.isSet)(G.channelId) && (k.channelId = String(G.channelId)), k;
    },
    toJSON(G) {
      const k = {};
      return G.portId !== void 0 && (k.portId = G.portId), G.channelId !== void 0 && (k.channelId = G.channelId), k;
    },
    fromPartial(G) {
      const k = y();
      return k.portId = G.portId ?? "", k.channelId = G.channelId ?? "", k;
    }
  };
  function V() {
    return {
      escrowAddress: ""
    };
  }
  e.QueryEscrowAddressResponse = {
    typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressResponse",
    encode(G, k = u.BinaryWriter.create()) {
      return G.escrowAddress !== "" && k.uint32(10).string(G.escrowAddress), k;
    },
    decode(G, k) {
      const F = G instanceof u.BinaryReader ? G : new u.BinaryReader(G);
      let X = k === void 0 ? F.len : F.pos + k;
      const ee = V();
      for (; F.pos < X; ) {
        const ue = F.uint32();
        switch (ue >>> 3) {
          case 1:
            ee.escrowAddress = F.string();
            break;
          default:
            F.skipType(ue & 7);
            break;
        }
      }
      return ee;
    },
    fromJSON(G) {
      const k = V();
      return (0, c.isSet)(G.escrowAddress) && (k.escrowAddress = String(G.escrowAddress)), k;
    },
    toJSON(G) {
      const k = {};
      return G.escrowAddress !== void 0 && (k.escrowAddress = G.escrowAddress), k;
    },
    fromPartial(G) {
      const k = V();
      return k.escrowAddress = G.escrowAddress ?? "", k;
    }
  };
  class M {
    constructor(k) {
      this.rpc = k, this.DenomTrace = this.DenomTrace.bind(this), this.DenomTraces = this.DenomTraces.bind(this), this.Params = this.Params.bind(this), this.DenomHash = this.DenomHash.bind(this), this.EscrowAddress = this.EscrowAddress.bind(this);
    }
    DenomTrace(k) {
      const F = e.QueryDenomTraceRequest.encode(k).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", F).then((ee) => e.QueryDenomTraceResponse.decode(new u.BinaryReader(ee)));
    }
    DenomTraces(k = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const F = e.QueryDenomTracesRequest.encode(k).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", F).then((ee) => e.QueryDenomTracesResponse.decode(new u.BinaryReader(ee)));
    }
    Params(k = {}) {
      const F = e.QueryParamsRequest.encode(k).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "Params", F).then((ee) => e.QueryParamsResponse.decode(new u.BinaryReader(ee)));
    }
    DenomHash(k) {
      const F = e.QueryDenomHashRequest.encode(k).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", F).then((ee) => e.QueryDenomHashResponse.decode(new u.BinaryReader(ee)));
    }
    EscrowAddress(k) {
      const F = e.QueryEscrowAddressRequest.encode(k).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", F).then((ee) => e.QueryEscrowAddressResponse.decode(new u.BinaryReader(ee)));
    }
  }
  e.QueryClientImpl = M;
})(query$7);
var query$6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryNextSequenceReceiveResponse = e.QueryNextSequenceReceiveRequest = e.QueryUnreceivedAcksResponse = e.QueryUnreceivedAcksRequest = e.QueryUnreceivedPacketsResponse = e.QueryUnreceivedPacketsRequest = e.QueryPacketAcknowledgementsResponse = e.QueryPacketAcknowledgementsRequest = e.QueryPacketAcknowledgementResponse = e.QueryPacketAcknowledgementRequest = e.QueryPacketReceiptResponse = e.QueryPacketReceiptRequest = e.QueryPacketCommitmentsResponse = e.QueryPacketCommitmentsRequest = e.QueryPacketCommitmentResponse = e.QueryPacketCommitmentRequest = e.QueryChannelConsensusStateResponse = e.QueryChannelConsensusStateRequest = e.QueryChannelClientStateResponse = e.QueryChannelClientStateRequest = e.QueryConnectionChannelsResponse = e.QueryConnectionChannelsRequest = e.QueryChannelsResponse = e.QueryChannelsRequest = e.QueryChannelResponse = e.QueryChannelRequest = e.protobufPackage = void 0;
  const n = pagination, o = channel, u = client$1, c = any$1, d = binary, m = helpers;
  e.protobufPackage = "ibc.core.channel.v1";
  function v() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.QueryChannelRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryChannelRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = v();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = v();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), W;
    },
    fromPartial(N) {
      const W = v();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", W;
    }
  };
  function S() {
    return {
      channel: void 0,
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryChannelResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryChannelResponse",
    encode(N, W = d.BinaryWriter.create()) {
      return N.channel !== void 0 && o.Channel.encode(N.channel, W.uint32(10).fork()).ldelim(), N.proof.length !== 0 && W.uint32(18).bytes(N.proof), N.proofHeight !== void 0 && u.Height.encode(N.proofHeight, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = S();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.channel = o.Channel.decode(I, I.uint32());
            break;
          case 2:
            ge.proof = I.bytes();
            break;
          case 3:
            ge.proofHeight = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = S();
      return (0, m.isSet)(N.channel) && (W.channel = o.Channel.fromJSON(N.channel)), (0, m.isSet)(N.proof) && (W.proof = (0, m.bytesFromBase64)(N.proof)), (0, m.isSet)(N.proofHeight) && (W.proofHeight = u.Height.fromJSON(N.proofHeight)), W;
    },
    toJSON(N) {
      const W = {};
      return N.channel !== void 0 && (W.channel = N.channel ? o.Channel.toJSON(N.channel) : void 0), N.proof !== void 0 && (W.proof = (0, m.base64FromBytes)(N.proof !== void 0 ? N.proof : new Uint8Array())), N.proofHeight !== void 0 && (W.proofHeight = N.proofHeight ? u.Height.toJSON(N.proofHeight) : void 0), W;
    },
    fromPartial(N) {
      const W = S();
      return N.channel !== void 0 && N.channel !== null && (W.channel = o.Channel.fromPartial(N.channel)), W.proof = N.proof ?? new Uint8Array(), N.proofHeight !== void 0 && N.proofHeight !== null && (W.proofHeight = u.Height.fromPartial(N.proofHeight)), W;
    }
  };
  function $() {
    return {
      pagination: void 0
    };
  }
  e.QueryChannelsRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryChannelsRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(10).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = $();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = $();
      return (0, m.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = $();
      return N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function E() {
    return {
      channels: [],
      pagination: void 0,
      height: u.Height.fromPartial({})
    };
  }
  e.QueryChannelsResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryChannelsResponse",
    encode(N, W = d.BinaryWriter.create()) {
      for (const I of N.channels)
        o.IdentifiedChannel.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), N.height !== void 0 && u.Height.encode(N.height, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = E();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.channels.push(o.IdentifiedChannel.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          case 3:
            ge.height = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = E();
      return Array.isArray(N == null ? void 0 : N.channels) && (W.channels = N.channels.map((I) => o.IdentifiedChannel.fromJSON(I))), (0, m.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), (0, m.isSet)(N.height) && (W.height = u.Height.fromJSON(N.height)), W;
    },
    toJSON(N) {
      const W = {};
      return N.channels ? W.channels = N.channels.map((I) => I ? o.IdentifiedChannel.toJSON(I) : void 0) : W.channels = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), N.height !== void 0 && (W.height = N.height ? u.Height.toJSON(N.height) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = E();
      return W.channels = ((I = N.channels) == null ? void 0 : I.map((te) => o.IdentifiedChannel.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), N.height !== void 0 && N.height !== null && (W.height = u.Height.fromPartial(N.height)), W;
    }
  };
  function O() {
    return {
      connection: "",
      pagination: void 0
    };
  }
  e.QueryConnectionChannelsRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.connection !== "" && W.uint32(10).string(N.connection), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = O();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.connection = I.string();
            break;
          case 2:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = O();
      return (0, m.isSet)(N.connection) && (W.connection = String(N.connection)), (0, m.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.connection !== void 0 && (W.connection = N.connection), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = O();
      return W.connection = N.connection ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function T() {
    return {
      channels: [],
      pagination: void 0,
      height: u.Height.fromPartial({})
    };
  }
  e.QueryConnectionChannelsResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsResponse",
    encode(N, W = d.BinaryWriter.create()) {
      for (const I of N.channels)
        o.IdentifiedChannel.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), N.height !== void 0 && u.Height.encode(N.height, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = T();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.channels.push(o.IdentifiedChannel.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          case 3:
            ge.height = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = T();
      return Array.isArray(N == null ? void 0 : N.channels) && (W.channels = N.channels.map((I) => o.IdentifiedChannel.fromJSON(I))), (0, m.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), (0, m.isSet)(N.height) && (W.height = u.Height.fromJSON(N.height)), W;
    },
    toJSON(N) {
      const W = {};
      return N.channels ? W.channels = N.channels.map((I) => I ? o.IdentifiedChannel.toJSON(I) : void 0) : W.channels = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), N.height !== void 0 && (W.height = N.height ? u.Height.toJSON(N.height) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = T();
      return W.channels = ((I = N.channels) == null ? void 0 : I.map((te) => o.IdentifiedChannel.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), N.height !== void 0 && N.height !== null && (W.height = u.Height.fromPartial(N.height)), W;
    }
  };
  function y() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.QueryChannelClientStateRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = y();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = y();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), W;
    },
    fromPartial(N) {
      const W = y();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", W;
    }
  };
  function V() {
    return {
      identifiedClientState: void 0,
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryChannelClientStateResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateResponse",
    encode(N, W = d.BinaryWriter.create()) {
      return N.identifiedClientState !== void 0 && u.IdentifiedClientState.encode(N.identifiedClientState, W.uint32(10).fork()).ldelim(), N.proof.length !== 0 && W.uint32(18).bytes(N.proof), N.proofHeight !== void 0 && u.Height.encode(N.proofHeight, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = V();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.identifiedClientState = u.IdentifiedClientState.decode(I, I.uint32());
            break;
          case 2:
            ge.proof = I.bytes();
            break;
          case 3:
            ge.proofHeight = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = V();
      return (0, m.isSet)(N.identifiedClientState) && (W.identifiedClientState = u.IdentifiedClientState.fromJSON(N.identifiedClientState)), (0, m.isSet)(N.proof) && (W.proof = (0, m.bytesFromBase64)(N.proof)), (0, m.isSet)(N.proofHeight) && (W.proofHeight = u.Height.fromJSON(N.proofHeight)), W;
    },
    toJSON(N) {
      const W = {};
      return N.identifiedClientState !== void 0 && (W.identifiedClientState = N.identifiedClientState ? u.IdentifiedClientState.toJSON(N.identifiedClientState) : void 0), N.proof !== void 0 && (W.proof = (0, m.base64FromBytes)(N.proof !== void 0 ? N.proof : new Uint8Array())), N.proofHeight !== void 0 && (W.proofHeight = N.proofHeight ? u.Height.toJSON(N.proofHeight) : void 0), W;
    },
    fromPartial(N) {
      const W = V();
      return N.identifiedClientState !== void 0 && N.identifiedClientState !== null && (W.identifiedClientState = u.IdentifiedClientState.fromPartial(N.identifiedClientState)), W.proof = N.proof ?? new Uint8Array(), N.proofHeight !== void 0 && N.proofHeight !== null && (W.proofHeight = u.Height.fromPartial(N.proofHeight)), W;
    }
  };
  function M() {
    return {
      portId: "",
      channelId: "",
      revisionNumber: BigInt(0),
      revisionHeight: BigInt(0)
    };
  }
  e.QueryChannelConsensusStateRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), N.revisionNumber !== BigInt(0) && W.uint32(24).uint64(N.revisionNumber), N.revisionHeight !== BigInt(0) && W.uint32(32).uint64(N.revisionHeight), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = M();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          case 3:
            ge.revisionNumber = I.uint64();
            break;
          case 4:
            ge.revisionHeight = I.uint64();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = M();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), (0, m.isSet)(N.revisionNumber) && (W.revisionNumber = BigInt(N.revisionNumber.toString())), (0, m.isSet)(N.revisionHeight) && (W.revisionHeight = BigInt(N.revisionHeight.toString())), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), N.revisionNumber !== void 0 && (W.revisionNumber = (N.revisionNumber || BigInt(0)).toString()), N.revisionHeight !== void 0 && (W.revisionHeight = (N.revisionHeight || BigInt(0)).toString()), W;
    },
    fromPartial(N) {
      const W = M();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", N.revisionNumber !== void 0 && N.revisionNumber !== null && (W.revisionNumber = BigInt(N.revisionNumber.toString())), N.revisionHeight !== void 0 && N.revisionHeight !== null && (W.revisionHeight = BigInt(N.revisionHeight.toString())), W;
    }
  };
  function G() {
    return {
      consensusState: void 0,
      clientId: "",
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryChannelConsensusStateResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateResponse",
    encode(N, W = d.BinaryWriter.create()) {
      return N.consensusState !== void 0 && c.Any.encode(N.consensusState, W.uint32(10).fork()).ldelim(), N.clientId !== "" && W.uint32(18).string(N.clientId), N.proof.length !== 0 && W.uint32(26).bytes(N.proof), N.proofHeight !== void 0 && u.Height.encode(N.proofHeight, W.uint32(34).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = G();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.consensusState = c.Any.decode(I, I.uint32());
            break;
          case 2:
            ge.clientId = I.string();
            break;
          case 3:
            ge.proof = I.bytes();
            break;
          case 4:
            ge.proofHeight = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = G();
      return (0, m.isSet)(N.consensusState) && (W.consensusState = c.Any.fromJSON(N.consensusState)), (0, m.isSet)(N.clientId) && (W.clientId = String(N.clientId)), (0, m.isSet)(N.proof) && (W.proof = (0, m.bytesFromBase64)(N.proof)), (0, m.isSet)(N.proofHeight) && (W.proofHeight = u.Height.fromJSON(N.proofHeight)), W;
    },
    toJSON(N) {
      const W = {};
      return N.consensusState !== void 0 && (W.consensusState = N.consensusState ? c.Any.toJSON(N.consensusState) : void 0), N.clientId !== void 0 && (W.clientId = N.clientId), N.proof !== void 0 && (W.proof = (0, m.base64FromBytes)(N.proof !== void 0 ? N.proof : new Uint8Array())), N.proofHeight !== void 0 && (W.proofHeight = N.proofHeight ? u.Height.toJSON(N.proofHeight) : void 0), W;
    },
    fromPartial(N) {
      const W = G();
      return N.consensusState !== void 0 && N.consensusState !== null && (W.consensusState = c.Any.fromPartial(N.consensusState)), W.clientId = N.clientId ?? "", W.proof = N.proof ?? new Uint8Array(), N.proofHeight !== void 0 && N.proofHeight !== null && (W.proofHeight = u.Height.fromPartial(N.proofHeight)), W;
    }
  };
  function k() {
    return {
      portId: "",
      channelId: "",
      sequence: BigInt(0)
    };
  }
  e.QueryPacketCommitmentRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), N.sequence !== BigInt(0) && W.uint32(24).uint64(N.sequence), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = k();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          case 3:
            ge.sequence = I.uint64();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = k();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), (0, m.isSet)(N.sequence) && (W.sequence = BigInt(N.sequence.toString())), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), N.sequence !== void 0 && (W.sequence = (N.sequence || BigInt(0)).toString()), W;
    },
    fromPartial(N) {
      const W = k();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", N.sequence !== void 0 && N.sequence !== null && (W.sequence = BigInt(N.sequence.toString())), W;
    }
  };
  function F() {
    return {
      commitment: new Uint8Array(),
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryPacketCommitmentResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentResponse",
    encode(N, W = d.BinaryWriter.create()) {
      return N.commitment.length !== 0 && W.uint32(10).bytes(N.commitment), N.proof.length !== 0 && W.uint32(18).bytes(N.proof), N.proofHeight !== void 0 && u.Height.encode(N.proofHeight, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = F();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.commitment = I.bytes();
            break;
          case 2:
            ge.proof = I.bytes();
            break;
          case 3:
            ge.proofHeight = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = F();
      return (0, m.isSet)(N.commitment) && (W.commitment = (0, m.bytesFromBase64)(N.commitment)), (0, m.isSet)(N.proof) && (W.proof = (0, m.bytesFromBase64)(N.proof)), (0, m.isSet)(N.proofHeight) && (W.proofHeight = u.Height.fromJSON(N.proofHeight)), W;
    },
    toJSON(N) {
      const W = {};
      return N.commitment !== void 0 && (W.commitment = (0, m.base64FromBytes)(N.commitment !== void 0 ? N.commitment : new Uint8Array())), N.proof !== void 0 && (W.proof = (0, m.base64FromBytes)(N.proof !== void 0 ? N.proof : new Uint8Array())), N.proofHeight !== void 0 && (W.proofHeight = N.proofHeight ? u.Height.toJSON(N.proofHeight) : void 0), W;
    },
    fromPartial(N) {
      const W = F();
      return W.commitment = N.commitment ?? new Uint8Array(), W.proof = N.proof ?? new Uint8Array(), N.proofHeight !== void 0 && N.proofHeight !== null && (W.proofHeight = u.Height.fromPartial(N.proofHeight)), W;
    }
  };
  function X() {
    return {
      portId: "",
      channelId: "",
      pagination: void 0
    };
  }
  e.QueryPacketCommitmentsRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = X();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          case 3:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = X();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), (0, m.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = X();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function ee() {
    return {
      commitments: [],
      pagination: void 0,
      height: u.Height.fromPartial({})
    };
  }
  e.QueryPacketCommitmentsResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsResponse",
    encode(N, W = d.BinaryWriter.create()) {
      for (const I of N.commitments)
        o.PacketState.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), N.height !== void 0 && u.Height.encode(N.height, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = ee();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.commitments.push(o.PacketState.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          case 3:
            ge.height = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = ee();
      return Array.isArray(N == null ? void 0 : N.commitments) && (W.commitments = N.commitments.map((I) => o.PacketState.fromJSON(I))), (0, m.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), (0, m.isSet)(N.height) && (W.height = u.Height.fromJSON(N.height)), W;
    },
    toJSON(N) {
      const W = {};
      return N.commitments ? W.commitments = N.commitments.map((I) => I ? o.PacketState.toJSON(I) : void 0) : W.commitments = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), N.height !== void 0 && (W.height = N.height ? u.Height.toJSON(N.height) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = ee();
      return W.commitments = ((I = N.commitments) == null ? void 0 : I.map((te) => o.PacketState.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), N.height !== void 0 && N.height !== null && (W.height = u.Height.fromPartial(N.height)), W;
    }
  };
  function ue() {
    return {
      portId: "",
      channelId: "",
      sequence: BigInt(0)
    };
  }
  e.QueryPacketReceiptRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), N.sequence !== BigInt(0) && W.uint32(24).uint64(N.sequence), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = ue();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          case 3:
            ge.sequence = I.uint64();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = ue();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), (0, m.isSet)(N.sequence) && (W.sequence = BigInt(N.sequence.toString())), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), N.sequence !== void 0 && (W.sequence = (N.sequence || BigInt(0)).toString()), W;
    },
    fromPartial(N) {
      const W = ue();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", N.sequence !== void 0 && N.sequence !== null && (W.sequence = BigInt(N.sequence.toString())), W;
    }
  };
  function Q() {
    return {
      received: !1,
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryPacketReceiptResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptResponse",
    encode(N, W = d.BinaryWriter.create()) {
      return N.received === !0 && W.uint32(16).bool(N.received), N.proof.length !== 0 && W.uint32(26).bytes(N.proof), N.proofHeight !== void 0 && u.Height.encode(N.proofHeight, W.uint32(34).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = Q();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 2:
            ge.received = I.bool();
            break;
          case 3:
            ge.proof = I.bytes();
            break;
          case 4:
            ge.proofHeight = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = Q();
      return (0, m.isSet)(N.received) && (W.received = !!N.received), (0, m.isSet)(N.proof) && (W.proof = (0, m.bytesFromBase64)(N.proof)), (0, m.isSet)(N.proofHeight) && (W.proofHeight = u.Height.fromJSON(N.proofHeight)), W;
    },
    toJSON(N) {
      const W = {};
      return N.received !== void 0 && (W.received = N.received), N.proof !== void 0 && (W.proof = (0, m.base64FromBytes)(N.proof !== void 0 ? N.proof : new Uint8Array())), N.proofHeight !== void 0 && (W.proofHeight = N.proofHeight ? u.Height.toJSON(N.proofHeight) : void 0), W;
    },
    fromPartial(N) {
      const W = Q();
      return W.received = N.received ?? !1, W.proof = N.proof ?? new Uint8Array(), N.proofHeight !== void 0 && N.proofHeight !== null && (W.proofHeight = u.Height.fromPartial(N.proofHeight)), W;
    }
  };
  function Y() {
    return {
      portId: "",
      channelId: "",
      sequence: BigInt(0)
    };
  }
  e.QueryPacketAcknowledgementRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), N.sequence !== BigInt(0) && W.uint32(24).uint64(N.sequence), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = Y();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          case 3:
            ge.sequence = I.uint64();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = Y();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), (0, m.isSet)(N.sequence) && (W.sequence = BigInt(N.sequence.toString())), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), N.sequence !== void 0 && (W.sequence = (N.sequence || BigInt(0)).toString()), W;
    },
    fromPartial(N) {
      const W = Y();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", N.sequence !== void 0 && N.sequence !== null && (W.sequence = BigInt(N.sequence.toString())), W;
    }
  };
  function pe() {
    return {
      acknowledgement: new Uint8Array(),
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryPacketAcknowledgementResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementResponse",
    encode(N, W = d.BinaryWriter.create()) {
      return N.acknowledgement.length !== 0 && W.uint32(10).bytes(N.acknowledgement), N.proof.length !== 0 && W.uint32(18).bytes(N.proof), N.proofHeight !== void 0 && u.Height.encode(N.proofHeight, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = pe();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.acknowledgement = I.bytes();
            break;
          case 2:
            ge.proof = I.bytes();
            break;
          case 3:
            ge.proofHeight = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = pe();
      return (0, m.isSet)(N.acknowledgement) && (W.acknowledgement = (0, m.bytesFromBase64)(N.acknowledgement)), (0, m.isSet)(N.proof) && (W.proof = (0, m.bytesFromBase64)(N.proof)), (0, m.isSet)(N.proofHeight) && (W.proofHeight = u.Height.fromJSON(N.proofHeight)), W;
    },
    toJSON(N) {
      const W = {};
      return N.acknowledgement !== void 0 && (W.acknowledgement = (0, m.base64FromBytes)(N.acknowledgement !== void 0 ? N.acknowledgement : new Uint8Array())), N.proof !== void 0 && (W.proof = (0, m.base64FromBytes)(N.proof !== void 0 ? N.proof : new Uint8Array())), N.proofHeight !== void 0 && (W.proofHeight = N.proofHeight ? u.Height.toJSON(N.proofHeight) : void 0), W;
    },
    fromPartial(N) {
      const W = pe();
      return W.acknowledgement = N.acknowledgement ?? new Uint8Array(), W.proof = N.proof ?? new Uint8Array(), N.proofHeight !== void 0 && N.proofHeight !== null && (W.proofHeight = u.Height.fromPartial(N.proofHeight)), W;
    }
  };
  function oe() {
    return {
      portId: "",
      channelId: "",
      pagination: void 0,
      packetCommitmentSequences: []
    };
  }
  e.QueryPacketAcknowledgementsRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsRequest",
    encode(N, W = d.BinaryWriter.create()) {
      N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(26).fork()).ldelim(), W.uint32(34).fork();
      for (const I of N.packetCommitmentSequences)
        W.uint64(I);
      return W.ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = oe();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          case 3:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          case 4:
            if ((Pe & 7) === 2) {
              const Ke = I.uint32() + I.pos;
              for (; I.pos < Ke; )
                ge.packetCommitmentSequences.push(I.uint64());
            } else
              ge.packetCommitmentSequences.push(I.uint64());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = oe();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), (0, m.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), Array.isArray(N == null ? void 0 : N.packetCommitmentSequences) && (W.packetCommitmentSequences = N.packetCommitmentSequences.map((I) => BigInt(I.toString()))), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), N.packetCommitmentSequences ? W.packetCommitmentSequences = N.packetCommitmentSequences.map((I) => (I || BigInt(0)).toString()) : W.packetCommitmentSequences = [], W;
    },
    fromPartial(N) {
      var I;
      const W = oe();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W.packetCommitmentSequences = ((I = N.packetCommitmentSequences) == null ? void 0 : I.map((te) => BigInt(te.toString()))) || [], W;
    }
  };
  function ne() {
    return {
      acknowledgements: [],
      pagination: void 0,
      height: u.Height.fromPartial({})
    };
  }
  e.QueryPacketAcknowledgementsResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsResponse",
    encode(N, W = d.BinaryWriter.create()) {
      for (const I of N.acknowledgements)
        o.PacketState.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), N.height !== void 0 && u.Height.encode(N.height, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = ne();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.acknowledgements.push(o.PacketState.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          case 3:
            ge.height = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = ne();
      return Array.isArray(N == null ? void 0 : N.acknowledgements) && (W.acknowledgements = N.acknowledgements.map((I) => o.PacketState.fromJSON(I))), (0, m.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), (0, m.isSet)(N.height) && (W.height = u.Height.fromJSON(N.height)), W;
    },
    toJSON(N) {
      const W = {};
      return N.acknowledgements ? W.acknowledgements = N.acknowledgements.map((I) => I ? o.PacketState.toJSON(I) : void 0) : W.acknowledgements = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), N.height !== void 0 && (W.height = N.height ? u.Height.toJSON(N.height) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = ne();
      return W.acknowledgements = ((I = N.acknowledgements) == null ? void 0 : I.map((te) => o.PacketState.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), N.height !== void 0 && N.height !== null && (W.height = u.Height.fromPartial(N.height)), W;
    }
  };
  function H() {
    return {
      portId: "",
      channelId: "",
      packetCommitmentSequences: []
    };
  }
  e.QueryUnreceivedPacketsRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsRequest",
    encode(N, W = d.BinaryWriter.create()) {
      N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), W.uint32(26).fork();
      for (const I of N.packetCommitmentSequences)
        W.uint64(I);
      return W.ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = H();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          case 3:
            if ((Pe & 7) === 2) {
              const Ke = I.uint32() + I.pos;
              for (; I.pos < Ke; )
                ge.packetCommitmentSequences.push(I.uint64());
            } else
              ge.packetCommitmentSequences.push(I.uint64());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = H();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), Array.isArray(N == null ? void 0 : N.packetCommitmentSequences) && (W.packetCommitmentSequences = N.packetCommitmentSequences.map((I) => BigInt(I.toString()))), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), N.packetCommitmentSequences ? W.packetCommitmentSequences = N.packetCommitmentSequences.map((I) => (I || BigInt(0)).toString()) : W.packetCommitmentSequences = [], W;
    },
    fromPartial(N) {
      var I;
      const W = H();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", W.packetCommitmentSequences = ((I = N.packetCommitmentSequences) == null ? void 0 : I.map((te) => BigInt(te.toString()))) || [], W;
    }
  };
  function C() {
    return {
      sequences: [],
      height: u.Height.fromPartial({})
    };
  }
  e.QueryUnreceivedPacketsResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsResponse",
    encode(N, W = d.BinaryWriter.create()) {
      W.uint32(10).fork();
      for (const I of N.sequences)
        W.uint64(I);
      return W.ldelim(), N.height !== void 0 && u.Height.encode(N.height, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = C();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            if ((Pe & 7) === 2) {
              const Ke = I.uint32() + I.pos;
              for (; I.pos < Ke; )
                ge.sequences.push(I.uint64());
            } else
              ge.sequences.push(I.uint64());
            break;
          case 2:
            ge.height = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = C();
      return Array.isArray(N == null ? void 0 : N.sequences) && (W.sequences = N.sequences.map((I) => BigInt(I.toString()))), (0, m.isSet)(N.height) && (W.height = u.Height.fromJSON(N.height)), W;
    },
    toJSON(N) {
      const W = {};
      return N.sequences ? W.sequences = N.sequences.map((I) => (I || BigInt(0)).toString()) : W.sequences = [], N.height !== void 0 && (W.height = N.height ? u.Height.toJSON(N.height) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = C();
      return W.sequences = ((I = N.sequences) == null ? void 0 : I.map((te) => BigInt(te.toString()))) || [], N.height !== void 0 && N.height !== null && (W.height = u.Height.fromPartial(N.height)), W;
    }
  };
  function w() {
    return {
      portId: "",
      channelId: "",
      packetAckSequences: []
    };
  }
  e.QueryUnreceivedAcksRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksRequest",
    encode(N, W = d.BinaryWriter.create()) {
      N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), W.uint32(26).fork();
      for (const I of N.packetAckSequences)
        W.uint64(I);
      return W.ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = w();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          case 3:
            if ((Pe & 7) === 2) {
              const Ke = I.uint32() + I.pos;
              for (; I.pos < Ke; )
                ge.packetAckSequences.push(I.uint64());
            } else
              ge.packetAckSequences.push(I.uint64());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = w();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), Array.isArray(N == null ? void 0 : N.packetAckSequences) && (W.packetAckSequences = N.packetAckSequences.map((I) => BigInt(I.toString()))), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), N.packetAckSequences ? W.packetAckSequences = N.packetAckSequences.map((I) => (I || BigInt(0)).toString()) : W.packetAckSequences = [], W;
    },
    fromPartial(N) {
      var I;
      const W = w();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", W.packetAckSequences = ((I = N.packetAckSequences) == null ? void 0 : I.map((te) => BigInt(te.toString()))) || [], W;
    }
  };
  function P() {
    return {
      sequences: [],
      height: u.Height.fromPartial({})
    };
  }
  e.QueryUnreceivedAcksResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksResponse",
    encode(N, W = d.BinaryWriter.create()) {
      W.uint32(10).fork();
      for (const I of N.sequences)
        W.uint64(I);
      return W.ldelim(), N.height !== void 0 && u.Height.encode(N.height, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = P();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            if ((Pe & 7) === 2) {
              const Ke = I.uint32() + I.pos;
              for (; I.pos < Ke; )
                ge.sequences.push(I.uint64());
            } else
              ge.sequences.push(I.uint64());
            break;
          case 2:
            ge.height = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = P();
      return Array.isArray(N == null ? void 0 : N.sequences) && (W.sequences = N.sequences.map((I) => BigInt(I.toString()))), (0, m.isSet)(N.height) && (W.height = u.Height.fromJSON(N.height)), W;
    },
    toJSON(N) {
      const W = {};
      return N.sequences ? W.sequences = N.sequences.map((I) => (I || BigInt(0)).toString()) : W.sequences = [], N.height !== void 0 && (W.height = N.height ? u.Height.toJSON(N.height) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = P();
      return W.sequences = ((I = N.sequences) == null ? void 0 : I.map((te) => BigInt(te.toString()))) || [], N.height !== void 0 && N.height !== null && (W.height = u.Height.fromPartial(N.height)), W;
    }
  };
  function J() {
    return {
      portId: "",
      channelId: ""
    };
  }
  e.QueryNextSequenceReceiveRequest = {
    typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveRequest",
    encode(N, W = d.BinaryWriter.create()) {
      return N.portId !== "" && W.uint32(10).string(N.portId), N.channelId !== "" && W.uint32(18).string(N.channelId), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = J();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.portId = I.string();
            break;
          case 2:
            ge.channelId = I.string();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = J();
      return (0, m.isSet)(N.portId) && (W.portId = String(N.portId)), (0, m.isSet)(N.channelId) && (W.channelId = String(N.channelId)), W;
    },
    toJSON(N) {
      const W = {};
      return N.portId !== void 0 && (W.portId = N.portId), N.channelId !== void 0 && (W.channelId = N.channelId), W;
    },
    fromPartial(N) {
      const W = J();
      return W.portId = N.portId ?? "", W.channelId = N.channelId ?? "", W;
    }
  };
  function se() {
    return {
      nextSequenceReceive: BigInt(0),
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryNextSequenceReceiveResponse = {
    typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveResponse",
    encode(N, W = d.BinaryWriter.create()) {
      return N.nextSequenceReceive !== BigInt(0) && W.uint32(8).uint64(N.nextSequenceReceive), N.proof.length !== 0 && W.uint32(18).bytes(N.proof), N.proofHeight !== void 0 && u.Height.encode(N.proofHeight, W.uint32(26).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof d.BinaryReader ? N : new d.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = se();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.nextSequenceReceive = I.uint64();
            break;
          case 2:
            ge.proof = I.bytes();
            break;
          case 3:
            ge.proofHeight = u.Height.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = se();
      return (0, m.isSet)(N.nextSequenceReceive) && (W.nextSequenceReceive = BigInt(N.nextSequenceReceive.toString())), (0, m.isSet)(N.proof) && (W.proof = (0, m.bytesFromBase64)(N.proof)), (0, m.isSet)(N.proofHeight) && (W.proofHeight = u.Height.fromJSON(N.proofHeight)), W;
    },
    toJSON(N) {
      const W = {};
      return N.nextSequenceReceive !== void 0 && (W.nextSequenceReceive = (N.nextSequenceReceive || BigInt(0)).toString()), N.proof !== void 0 && (W.proof = (0, m.base64FromBytes)(N.proof !== void 0 ? N.proof : new Uint8Array())), N.proofHeight !== void 0 && (W.proofHeight = N.proofHeight ? u.Height.toJSON(N.proofHeight) : void 0), W;
    },
    fromPartial(N) {
      const W = se();
      return N.nextSequenceReceive !== void 0 && N.nextSequenceReceive !== null && (W.nextSequenceReceive = BigInt(N.nextSequenceReceive.toString())), W.proof = N.proof ?? new Uint8Array(), N.proofHeight !== void 0 && N.proofHeight !== null && (W.proofHeight = u.Height.fromPartial(N.proofHeight)), W;
    }
  };
  class fe {
    constructor(W) {
      this.rpc = W, this.Channel = this.Channel.bind(this), this.Channels = this.Channels.bind(this), this.ConnectionChannels = this.ConnectionChannels.bind(this), this.ChannelClientState = this.ChannelClientState.bind(this), this.ChannelConsensusState = this.ChannelConsensusState.bind(this), this.PacketCommitment = this.PacketCommitment.bind(this), this.PacketCommitments = this.PacketCommitments.bind(this), this.PacketReceipt = this.PacketReceipt.bind(this), this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this), this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this), this.UnreceivedPackets = this.UnreceivedPackets.bind(this), this.UnreceivedAcks = this.UnreceivedAcks.bind(this), this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
    Channel(W) {
      const I = e.QueryChannelRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "Channel", I).then((ge) => e.QueryChannelResponse.decode(new d.BinaryReader(ge)));
    }
    Channels(W = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const I = e.QueryChannelsRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "Channels", I).then((ge) => e.QueryChannelsResponse.decode(new d.BinaryReader(ge)));
    }
    ConnectionChannels(W) {
      const I = e.QueryConnectionChannelsRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", I).then((ge) => e.QueryConnectionChannelsResponse.decode(new d.BinaryReader(ge)));
    }
    ChannelClientState(W) {
      const I = e.QueryChannelClientStateRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", I).then((ge) => e.QueryChannelClientStateResponse.decode(new d.BinaryReader(ge)));
    }
    ChannelConsensusState(W) {
      const I = e.QueryChannelConsensusStateRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", I).then((ge) => e.QueryChannelConsensusStateResponse.decode(new d.BinaryReader(ge)));
    }
    PacketCommitment(W) {
      const I = e.QueryPacketCommitmentRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", I).then((ge) => e.QueryPacketCommitmentResponse.decode(new d.BinaryReader(ge)));
    }
    PacketCommitments(W) {
      const I = e.QueryPacketCommitmentsRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", I).then((ge) => e.QueryPacketCommitmentsResponse.decode(new d.BinaryReader(ge)));
    }
    PacketReceipt(W) {
      const I = e.QueryPacketReceiptRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", I).then((ge) => e.QueryPacketReceiptResponse.decode(new d.BinaryReader(ge)));
    }
    PacketAcknowledgement(W) {
      const I = e.QueryPacketAcknowledgementRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", I).then((ge) => e.QueryPacketAcknowledgementResponse.decode(new d.BinaryReader(ge)));
    }
    PacketAcknowledgements(W) {
      const I = e.QueryPacketAcknowledgementsRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", I).then((ge) => e.QueryPacketAcknowledgementsResponse.decode(new d.BinaryReader(ge)));
    }
    UnreceivedPackets(W) {
      const I = e.QueryUnreceivedPacketsRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", I).then((ge) => e.QueryUnreceivedPacketsResponse.decode(new d.BinaryReader(ge)));
    }
    UnreceivedAcks(W) {
      const I = e.QueryUnreceivedAcksRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", I).then((ge) => e.QueryUnreceivedAcksResponse.decode(new d.BinaryReader(ge)));
    }
    NextSequenceReceive(W) {
      const I = e.QueryNextSequenceReceiveRequest.encode(W).finish();
      return this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", I).then((ge) => e.QueryNextSequenceReceiveResponse.decode(new d.BinaryReader(ge)));
    }
  }
  e.QueryClientImpl = fe;
})(query$6);
var query$5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryUpgradedConsensusStateResponse = e.QueryUpgradedConsensusStateRequest = e.QueryUpgradedClientStateResponse = e.QueryUpgradedClientStateRequest = e.QueryClientParamsResponse = e.QueryClientParamsRequest = e.QueryClientStatusResponse = e.QueryClientStatusRequest = e.QueryConsensusStateHeightsResponse = e.QueryConsensusStateHeightsRequest = e.QueryConsensusStatesResponse = e.QueryConsensusStatesRequest = e.QueryConsensusStateResponse = e.QueryConsensusStateRequest = e.QueryClientStatesResponse = e.QueryClientStatesRequest = e.QueryClientStateResponse = e.QueryClientStateRequest = e.protobufPackage = void 0;
  const n = pagination, o = any$1, u = client$1, c = binary, d = helpers;
  e.protobufPackage = "ibc.core.client.v1";
  function m() {
    return {
      clientId: ""
    };
  }
  e.QueryClientStateRequest = {
    typeUrl: "/ibc.core.client.v1.QueryClientStateRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.clientId !== "" && ne.uint32(10).string(oe.clientId), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = m();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.clientId = H.string();
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = m();
      return (0, d.isSet)(oe.clientId) && (ne.clientId = String(oe.clientId)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.clientId !== void 0 && (ne.clientId = oe.clientId), ne;
    },
    fromPartial(oe) {
      const ne = m();
      return ne.clientId = oe.clientId ?? "", ne;
    }
  };
  function v() {
    return {
      clientState: void 0,
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryClientStateResponse = {
    typeUrl: "/ibc.core.client.v1.QueryClientStateResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.clientState !== void 0 && o.Any.encode(oe.clientState, ne.uint32(10).fork()).ldelim(), oe.proof.length !== 0 && ne.uint32(18).bytes(oe.proof), oe.proofHeight !== void 0 && u.Height.encode(oe.proofHeight, ne.uint32(26).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = v();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.clientState = o.Any.decode(H, H.uint32());
            break;
          case 2:
            w.proof = H.bytes();
            break;
          case 3:
            w.proofHeight = u.Height.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = v();
      return (0, d.isSet)(oe.clientState) && (ne.clientState = o.Any.fromJSON(oe.clientState)), (0, d.isSet)(oe.proof) && (ne.proof = (0, d.bytesFromBase64)(oe.proof)), (0, d.isSet)(oe.proofHeight) && (ne.proofHeight = u.Height.fromJSON(oe.proofHeight)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.clientState !== void 0 && (ne.clientState = oe.clientState ? o.Any.toJSON(oe.clientState) : void 0), oe.proof !== void 0 && (ne.proof = (0, d.base64FromBytes)(oe.proof !== void 0 ? oe.proof : new Uint8Array())), oe.proofHeight !== void 0 && (ne.proofHeight = oe.proofHeight ? u.Height.toJSON(oe.proofHeight) : void 0), ne;
    },
    fromPartial(oe) {
      const ne = v();
      return oe.clientState !== void 0 && oe.clientState !== null && (ne.clientState = o.Any.fromPartial(oe.clientState)), ne.proof = oe.proof ?? new Uint8Array(), oe.proofHeight !== void 0 && oe.proofHeight !== null && (ne.proofHeight = u.Height.fromPartial(oe.proofHeight)), ne;
    }
  };
  function S() {
    return {
      pagination: void 0
    };
  }
  e.QueryClientStatesRequest = {
    typeUrl: "/ibc.core.client.v1.QueryClientStatesRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.pagination !== void 0 && n.PageRequest.encode(oe.pagination, ne.uint32(10).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = S();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.pagination = n.PageRequest.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = S();
      return (0, d.isSet)(oe.pagination) && (ne.pagination = n.PageRequest.fromJSON(oe.pagination)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.pagination !== void 0 && (ne.pagination = oe.pagination ? n.PageRequest.toJSON(oe.pagination) : void 0), ne;
    },
    fromPartial(oe) {
      const ne = S();
      return oe.pagination !== void 0 && oe.pagination !== null && (ne.pagination = n.PageRequest.fromPartial(oe.pagination)), ne;
    }
  };
  function $() {
    return {
      clientStates: [],
      pagination: void 0
    };
  }
  e.QueryClientStatesResponse = {
    typeUrl: "/ibc.core.client.v1.QueryClientStatesResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      for (const H of oe.clientStates)
        u.IdentifiedClientState.encode(H, ne.uint32(10).fork()).ldelim();
      return oe.pagination !== void 0 && n.PageResponse.encode(oe.pagination, ne.uint32(18).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = $();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.clientStates.push(u.IdentifiedClientState.decode(H, H.uint32()));
            break;
          case 2:
            w.pagination = n.PageResponse.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = $();
      return Array.isArray(oe == null ? void 0 : oe.clientStates) && (ne.clientStates = oe.clientStates.map((H) => u.IdentifiedClientState.fromJSON(H))), (0, d.isSet)(oe.pagination) && (ne.pagination = n.PageResponse.fromJSON(oe.pagination)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.clientStates ? ne.clientStates = oe.clientStates.map((H) => H ? u.IdentifiedClientState.toJSON(H) : void 0) : ne.clientStates = [], oe.pagination !== void 0 && (ne.pagination = oe.pagination ? n.PageResponse.toJSON(oe.pagination) : void 0), ne;
    },
    fromPartial(oe) {
      var H;
      const ne = $();
      return ne.clientStates = ((H = oe.clientStates) == null ? void 0 : H.map((C) => u.IdentifiedClientState.fromPartial(C))) || [], oe.pagination !== void 0 && oe.pagination !== null && (ne.pagination = n.PageResponse.fromPartial(oe.pagination)), ne;
    }
  };
  function E() {
    return {
      clientId: "",
      revisionNumber: BigInt(0),
      revisionHeight: BigInt(0),
      latestHeight: !1
    };
  }
  e.QueryConsensusStateRequest = {
    typeUrl: "/ibc.core.client.v1.QueryConsensusStateRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.clientId !== "" && ne.uint32(10).string(oe.clientId), oe.revisionNumber !== BigInt(0) && ne.uint32(16).uint64(oe.revisionNumber), oe.revisionHeight !== BigInt(0) && ne.uint32(24).uint64(oe.revisionHeight), oe.latestHeight === !0 && ne.uint32(32).bool(oe.latestHeight), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = E();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.clientId = H.string();
            break;
          case 2:
            w.revisionNumber = H.uint64();
            break;
          case 3:
            w.revisionHeight = H.uint64();
            break;
          case 4:
            w.latestHeight = H.bool();
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = E();
      return (0, d.isSet)(oe.clientId) && (ne.clientId = String(oe.clientId)), (0, d.isSet)(oe.revisionNumber) && (ne.revisionNumber = BigInt(oe.revisionNumber.toString())), (0, d.isSet)(oe.revisionHeight) && (ne.revisionHeight = BigInt(oe.revisionHeight.toString())), (0, d.isSet)(oe.latestHeight) && (ne.latestHeight = !!oe.latestHeight), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.clientId !== void 0 && (ne.clientId = oe.clientId), oe.revisionNumber !== void 0 && (ne.revisionNumber = (oe.revisionNumber || BigInt(0)).toString()), oe.revisionHeight !== void 0 && (ne.revisionHeight = (oe.revisionHeight || BigInt(0)).toString()), oe.latestHeight !== void 0 && (ne.latestHeight = oe.latestHeight), ne;
    },
    fromPartial(oe) {
      const ne = E();
      return ne.clientId = oe.clientId ?? "", oe.revisionNumber !== void 0 && oe.revisionNumber !== null && (ne.revisionNumber = BigInt(oe.revisionNumber.toString())), oe.revisionHeight !== void 0 && oe.revisionHeight !== null && (ne.revisionHeight = BigInt(oe.revisionHeight.toString())), ne.latestHeight = oe.latestHeight ?? !1, ne;
    }
  };
  function O() {
    return {
      consensusState: void 0,
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryConsensusStateResponse = {
    typeUrl: "/ibc.core.client.v1.QueryConsensusStateResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.consensusState !== void 0 && o.Any.encode(oe.consensusState, ne.uint32(10).fork()).ldelim(), oe.proof.length !== 0 && ne.uint32(18).bytes(oe.proof), oe.proofHeight !== void 0 && u.Height.encode(oe.proofHeight, ne.uint32(26).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = O();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.consensusState = o.Any.decode(H, H.uint32());
            break;
          case 2:
            w.proof = H.bytes();
            break;
          case 3:
            w.proofHeight = u.Height.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = O();
      return (0, d.isSet)(oe.consensusState) && (ne.consensusState = o.Any.fromJSON(oe.consensusState)), (0, d.isSet)(oe.proof) && (ne.proof = (0, d.bytesFromBase64)(oe.proof)), (0, d.isSet)(oe.proofHeight) && (ne.proofHeight = u.Height.fromJSON(oe.proofHeight)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.consensusState !== void 0 && (ne.consensusState = oe.consensusState ? o.Any.toJSON(oe.consensusState) : void 0), oe.proof !== void 0 && (ne.proof = (0, d.base64FromBytes)(oe.proof !== void 0 ? oe.proof : new Uint8Array())), oe.proofHeight !== void 0 && (ne.proofHeight = oe.proofHeight ? u.Height.toJSON(oe.proofHeight) : void 0), ne;
    },
    fromPartial(oe) {
      const ne = O();
      return oe.consensusState !== void 0 && oe.consensusState !== null && (ne.consensusState = o.Any.fromPartial(oe.consensusState)), ne.proof = oe.proof ?? new Uint8Array(), oe.proofHeight !== void 0 && oe.proofHeight !== null && (ne.proofHeight = u.Height.fromPartial(oe.proofHeight)), ne;
    }
  };
  function T() {
    return {
      clientId: "",
      pagination: void 0
    };
  }
  e.QueryConsensusStatesRequest = {
    typeUrl: "/ibc.core.client.v1.QueryConsensusStatesRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.clientId !== "" && ne.uint32(10).string(oe.clientId), oe.pagination !== void 0 && n.PageRequest.encode(oe.pagination, ne.uint32(18).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = T();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.clientId = H.string();
            break;
          case 2:
            w.pagination = n.PageRequest.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = T();
      return (0, d.isSet)(oe.clientId) && (ne.clientId = String(oe.clientId)), (0, d.isSet)(oe.pagination) && (ne.pagination = n.PageRequest.fromJSON(oe.pagination)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.clientId !== void 0 && (ne.clientId = oe.clientId), oe.pagination !== void 0 && (ne.pagination = oe.pagination ? n.PageRequest.toJSON(oe.pagination) : void 0), ne;
    },
    fromPartial(oe) {
      const ne = T();
      return ne.clientId = oe.clientId ?? "", oe.pagination !== void 0 && oe.pagination !== null && (ne.pagination = n.PageRequest.fromPartial(oe.pagination)), ne;
    }
  };
  function y() {
    return {
      consensusStates: [],
      pagination: void 0
    };
  }
  e.QueryConsensusStatesResponse = {
    typeUrl: "/ibc.core.client.v1.QueryConsensusStatesResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      for (const H of oe.consensusStates)
        u.ConsensusStateWithHeight.encode(H, ne.uint32(10).fork()).ldelim();
      return oe.pagination !== void 0 && n.PageResponse.encode(oe.pagination, ne.uint32(18).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = y();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.consensusStates.push(u.ConsensusStateWithHeight.decode(H, H.uint32()));
            break;
          case 2:
            w.pagination = n.PageResponse.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = y();
      return Array.isArray(oe == null ? void 0 : oe.consensusStates) && (ne.consensusStates = oe.consensusStates.map((H) => u.ConsensusStateWithHeight.fromJSON(H))), (0, d.isSet)(oe.pagination) && (ne.pagination = n.PageResponse.fromJSON(oe.pagination)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.consensusStates ? ne.consensusStates = oe.consensusStates.map((H) => H ? u.ConsensusStateWithHeight.toJSON(H) : void 0) : ne.consensusStates = [], oe.pagination !== void 0 && (ne.pagination = oe.pagination ? n.PageResponse.toJSON(oe.pagination) : void 0), ne;
    },
    fromPartial(oe) {
      var H;
      const ne = y();
      return ne.consensusStates = ((H = oe.consensusStates) == null ? void 0 : H.map((C) => u.ConsensusStateWithHeight.fromPartial(C))) || [], oe.pagination !== void 0 && oe.pagination !== null && (ne.pagination = n.PageResponse.fromPartial(oe.pagination)), ne;
    }
  };
  function V() {
    return {
      clientId: "",
      pagination: void 0
    };
  }
  e.QueryConsensusStateHeightsRequest = {
    typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.clientId !== "" && ne.uint32(10).string(oe.clientId), oe.pagination !== void 0 && n.PageRequest.encode(oe.pagination, ne.uint32(18).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = V();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.clientId = H.string();
            break;
          case 2:
            w.pagination = n.PageRequest.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = V();
      return (0, d.isSet)(oe.clientId) && (ne.clientId = String(oe.clientId)), (0, d.isSet)(oe.pagination) && (ne.pagination = n.PageRequest.fromJSON(oe.pagination)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.clientId !== void 0 && (ne.clientId = oe.clientId), oe.pagination !== void 0 && (ne.pagination = oe.pagination ? n.PageRequest.toJSON(oe.pagination) : void 0), ne;
    },
    fromPartial(oe) {
      const ne = V();
      return ne.clientId = oe.clientId ?? "", oe.pagination !== void 0 && oe.pagination !== null && (ne.pagination = n.PageRequest.fromPartial(oe.pagination)), ne;
    }
  };
  function M() {
    return {
      consensusStateHeights: [],
      pagination: void 0
    };
  }
  e.QueryConsensusStateHeightsResponse = {
    typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      for (const H of oe.consensusStateHeights)
        u.Height.encode(H, ne.uint32(10).fork()).ldelim();
      return oe.pagination !== void 0 && n.PageResponse.encode(oe.pagination, ne.uint32(18).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = M();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.consensusStateHeights.push(u.Height.decode(H, H.uint32()));
            break;
          case 2:
            w.pagination = n.PageResponse.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = M();
      return Array.isArray(oe == null ? void 0 : oe.consensusStateHeights) && (ne.consensusStateHeights = oe.consensusStateHeights.map((H) => u.Height.fromJSON(H))), (0, d.isSet)(oe.pagination) && (ne.pagination = n.PageResponse.fromJSON(oe.pagination)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.consensusStateHeights ? ne.consensusStateHeights = oe.consensusStateHeights.map((H) => H ? u.Height.toJSON(H) : void 0) : ne.consensusStateHeights = [], oe.pagination !== void 0 && (ne.pagination = oe.pagination ? n.PageResponse.toJSON(oe.pagination) : void 0), ne;
    },
    fromPartial(oe) {
      var H;
      const ne = M();
      return ne.consensusStateHeights = ((H = oe.consensusStateHeights) == null ? void 0 : H.map((C) => u.Height.fromPartial(C))) || [], oe.pagination !== void 0 && oe.pagination !== null && (ne.pagination = n.PageResponse.fromPartial(oe.pagination)), ne;
    }
  };
  function G() {
    return {
      clientId: ""
    };
  }
  e.QueryClientStatusRequest = {
    typeUrl: "/ibc.core.client.v1.QueryClientStatusRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.clientId !== "" && ne.uint32(10).string(oe.clientId), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = G();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.clientId = H.string();
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = G();
      return (0, d.isSet)(oe.clientId) && (ne.clientId = String(oe.clientId)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.clientId !== void 0 && (ne.clientId = oe.clientId), ne;
    },
    fromPartial(oe) {
      const ne = G();
      return ne.clientId = oe.clientId ?? "", ne;
    }
  };
  function k() {
    return {
      status: ""
    };
  }
  e.QueryClientStatusResponse = {
    typeUrl: "/ibc.core.client.v1.QueryClientStatusResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.status !== "" && ne.uint32(10).string(oe.status), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = k();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.status = H.string();
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = k();
      return (0, d.isSet)(oe.status) && (ne.status = String(oe.status)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.status !== void 0 && (ne.status = oe.status), ne;
    },
    fromPartial(oe) {
      const ne = k();
      return ne.status = oe.status ?? "", ne;
    }
  };
  function F() {
    return {};
  }
  e.QueryClientParamsRequest = {
    typeUrl: "/ibc.core.client.v1.QueryClientParamsRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = F();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      return F();
    },
    toJSON(oe) {
      return {};
    },
    fromPartial(oe) {
      return F();
    }
  };
  function X() {
    return {
      params: void 0
    };
  }
  e.QueryClientParamsResponse = {
    typeUrl: "/ibc.core.client.v1.QueryClientParamsResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.params !== void 0 && u.Params.encode(oe.params, ne.uint32(10).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = X();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.params = u.Params.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = X();
      return (0, d.isSet)(oe.params) && (ne.params = u.Params.fromJSON(oe.params)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.params !== void 0 && (ne.params = oe.params ? u.Params.toJSON(oe.params) : void 0), ne;
    },
    fromPartial(oe) {
      const ne = X();
      return oe.params !== void 0 && oe.params !== null && (ne.params = u.Params.fromPartial(oe.params)), ne;
    }
  };
  function ee() {
    return {};
  }
  e.QueryUpgradedClientStateRequest = {
    typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = ee();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      return ee();
    },
    toJSON(oe) {
      return {};
    },
    fromPartial(oe) {
      return ee();
    }
  };
  function ue() {
    return {
      upgradedClientState: void 0
    };
  }
  e.QueryUpgradedClientStateResponse = {
    typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.upgradedClientState !== void 0 && o.Any.encode(oe.upgradedClientState, ne.uint32(10).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = ue();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.upgradedClientState = o.Any.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = ue();
      return (0, d.isSet)(oe.upgradedClientState) && (ne.upgradedClientState = o.Any.fromJSON(oe.upgradedClientState)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.upgradedClientState !== void 0 && (ne.upgradedClientState = oe.upgradedClientState ? o.Any.toJSON(oe.upgradedClientState) : void 0), ne;
    },
    fromPartial(oe) {
      const ne = ue();
      return oe.upgradedClientState !== void 0 && oe.upgradedClientState !== null && (ne.upgradedClientState = o.Any.fromPartial(oe.upgradedClientState)), ne;
    }
  };
  function Q() {
    return {};
  }
  e.QueryUpgradedConsensusStateRequest = {
    typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateRequest",
    encode(oe, ne = c.BinaryWriter.create()) {
      return ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = Q();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      return Q();
    },
    toJSON(oe) {
      return {};
    },
    fromPartial(oe) {
      return Q();
    }
  };
  function Y() {
    return {
      upgradedConsensusState: void 0
    };
  }
  e.QueryUpgradedConsensusStateResponse = {
    typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateResponse",
    encode(oe, ne = c.BinaryWriter.create()) {
      return oe.upgradedConsensusState !== void 0 && o.Any.encode(oe.upgradedConsensusState, ne.uint32(10).fork()).ldelim(), ne;
    },
    decode(oe, ne) {
      const H = oe instanceof c.BinaryReader ? oe : new c.BinaryReader(oe);
      let C = ne === void 0 ? H.len : H.pos + ne;
      const w = Y();
      for (; H.pos < C; ) {
        const P = H.uint32();
        switch (P >>> 3) {
          case 1:
            w.upgradedConsensusState = o.Any.decode(H, H.uint32());
            break;
          default:
            H.skipType(P & 7);
            break;
        }
      }
      return w;
    },
    fromJSON(oe) {
      const ne = Y();
      return (0, d.isSet)(oe.upgradedConsensusState) && (ne.upgradedConsensusState = o.Any.fromJSON(oe.upgradedConsensusState)), ne;
    },
    toJSON(oe) {
      const ne = {};
      return oe.upgradedConsensusState !== void 0 && (ne.upgradedConsensusState = oe.upgradedConsensusState ? o.Any.toJSON(oe.upgradedConsensusState) : void 0), ne;
    },
    fromPartial(oe) {
      const ne = Y();
      return oe.upgradedConsensusState !== void 0 && oe.upgradedConsensusState !== null && (ne.upgradedConsensusState = o.Any.fromPartial(oe.upgradedConsensusState)), ne;
    }
  };
  class pe {
    constructor(ne) {
      this.rpc = ne, this.ClientState = this.ClientState.bind(this), this.ClientStates = this.ClientStates.bind(this), this.ConsensusState = this.ConsensusState.bind(this), this.ConsensusStates = this.ConsensusStates.bind(this), this.ConsensusStateHeights = this.ConsensusStateHeights.bind(this), this.ClientStatus = this.ClientStatus.bind(this), this.ClientParams = this.ClientParams.bind(this), this.UpgradedClientState = this.UpgradedClientState.bind(this), this.UpgradedConsensusState = this.UpgradedConsensusState.bind(this);
    }
    ClientState(ne) {
      const H = e.QueryClientStateRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ClientState", H).then((w) => e.QueryClientStateResponse.decode(new c.BinaryReader(w)));
    }
    ClientStates(ne = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const H = e.QueryClientStatesRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ClientStates", H).then((w) => e.QueryClientStatesResponse.decode(new c.BinaryReader(w)));
    }
    ConsensusState(ne) {
      const H = e.QueryConsensusStateRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", H).then((w) => e.QueryConsensusStateResponse.decode(new c.BinaryReader(w)));
    }
    ConsensusStates(ne) {
      const H = e.QueryConsensusStatesRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", H).then((w) => e.QueryConsensusStatesResponse.decode(new c.BinaryReader(w)));
    }
    ConsensusStateHeights(ne) {
      const H = e.QueryConsensusStateHeightsRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", H).then((w) => e.QueryConsensusStateHeightsResponse.decode(new c.BinaryReader(w)));
    }
    ClientStatus(ne) {
      const H = e.QueryClientStatusRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", H).then((w) => e.QueryClientStatusResponse.decode(new c.BinaryReader(w)));
    }
    ClientParams(ne = {}) {
      const H = e.QueryClientParamsRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "ClientParams", H).then((w) => e.QueryClientParamsResponse.decode(new c.BinaryReader(w)));
    }
    UpgradedClientState(ne = {}) {
      const H = e.QueryUpgradedClientStateRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", H).then((w) => e.QueryUpgradedClientStateResponse.decode(new c.BinaryReader(w)));
    }
    UpgradedConsensusState(ne = {}) {
      const H = e.QueryUpgradedConsensusStateRequest.encode(ne).finish();
      return this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", H).then((w) => e.QueryUpgradedConsensusStateResponse.decode(new c.BinaryReader(w)));
    }
  }
  e.QueryClientImpl = pe;
})(query$5);
var query$4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryConnectionParamsResponse = e.QueryConnectionParamsRequest = e.QueryConnectionConsensusStateResponse = e.QueryConnectionConsensusStateRequest = e.QueryConnectionClientStateResponse = e.QueryConnectionClientStateRequest = e.QueryClientConnectionsResponse = e.QueryClientConnectionsRequest = e.QueryConnectionsResponse = e.QueryConnectionsRequest = e.QueryConnectionResponse = e.QueryConnectionRequest = e.protobufPackage = void 0;
  const n = pagination, o = connection, u = client$1, c = any$1, d = binary, m = helpers;
  e.protobufPackage = "ibc.core.connection.v1";
  function v() {
    return {
      connectionId: ""
    };
  }
  e.QueryConnectionRequest = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionRequest",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.connectionId !== "" && ue.uint32(10).string(ee.connectionId), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = v();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.connectionId = Q.string();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = v();
      return (0, m.isSet)(ee.connectionId) && (ue.connectionId = String(ee.connectionId)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.connectionId !== void 0 && (ue.connectionId = ee.connectionId), ue;
    },
    fromPartial(ee) {
      const ue = v();
      return ue.connectionId = ee.connectionId ?? "", ue;
    }
  };
  function S() {
    return {
      connection: void 0,
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryConnectionResponse = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionResponse",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.connection !== void 0 && o.ConnectionEnd.encode(ee.connection, ue.uint32(10).fork()).ldelim(), ee.proof.length !== 0 && ue.uint32(18).bytes(ee.proof), ee.proofHeight !== void 0 && u.Height.encode(ee.proofHeight, ue.uint32(26).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = S();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.connection = o.ConnectionEnd.decode(Q, Q.uint32());
            break;
          case 2:
            pe.proof = Q.bytes();
            break;
          case 3:
            pe.proofHeight = u.Height.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = S();
      return (0, m.isSet)(ee.connection) && (ue.connection = o.ConnectionEnd.fromJSON(ee.connection)), (0, m.isSet)(ee.proof) && (ue.proof = (0, m.bytesFromBase64)(ee.proof)), (0, m.isSet)(ee.proofHeight) && (ue.proofHeight = u.Height.fromJSON(ee.proofHeight)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.connection !== void 0 && (ue.connection = ee.connection ? o.ConnectionEnd.toJSON(ee.connection) : void 0), ee.proof !== void 0 && (ue.proof = (0, m.base64FromBytes)(ee.proof !== void 0 ? ee.proof : new Uint8Array())), ee.proofHeight !== void 0 && (ue.proofHeight = ee.proofHeight ? u.Height.toJSON(ee.proofHeight) : void 0), ue;
    },
    fromPartial(ee) {
      const ue = S();
      return ee.connection !== void 0 && ee.connection !== null && (ue.connection = o.ConnectionEnd.fromPartial(ee.connection)), ue.proof = ee.proof ?? new Uint8Array(), ee.proofHeight !== void 0 && ee.proofHeight !== null && (ue.proofHeight = u.Height.fromPartial(ee.proofHeight)), ue;
    }
  };
  function $() {
    return {
      pagination: void 0
    };
  }
  e.QueryConnectionsRequest = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionsRequest",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.pagination !== void 0 && n.PageRequest.encode(ee.pagination, ue.uint32(10).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = $();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.pagination = n.PageRequest.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = $();
      return (0, m.isSet)(ee.pagination) && (ue.pagination = n.PageRequest.fromJSON(ee.pagination)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.pagination !== void 0 && (ue.pagination = ee.pagination ? n.PageRequest.toJSON(ee.pagination) : void 0), ue;
    },
    fromPartial(ee) {
      const ue = $();
      return ee.pagination !== void 0 && ee.pagination !== null && (ue.pagination = n.PageRequest.fromPartial(ee.pagination)), ue;
    }
  };
  function E() {
    return {
      connections: [],
      pagination: void 0,
      height: u.Height.fromPartial({})
    };
  }
  e.QueryConnectionsResponse = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionsResponse",
    encode(ee, ue = d.BinaryWriter.create()) {
      for (const Q of ee.connections)
        o.IdentifiedConnection.encode(Q, ue.uint32(10).fork()).ldelim();
      return ee.pagination !== void 0 && n.PageResponse.encode(ee.pagination, ue.uint32(18).fork()).ldelim(), ee.height !== void 0 && u.Height.encode(ee.height, ue.uint32(26).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = E();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.connections.push(o.IdentifiedConnection.decode(Q, Q.uint32()));
            break;
          case 2:
            pe.pagination = n.PageResponse.decode(Q, Q.uint32());
            break;
          case 3:
            pe.height = u.Height.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = E();
      return Array.isArray(ee == null ? void 0 : ee.connections) && (ue.connections = ee.connections.map((Q) => o.IdentifiedConnection.fromJSON(Q))), (0, m.isSet)(ee.pagination) && (ue.pagination = n.PageResponse.fromJSON(ee.pagination)), (0, m.isSet)(ee.height) && (ue.height = u.Height.fromJSON(ee.height)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.connections ? ue.connections = ee.connections.map((Q) => Q ? o.IdentifiedConnection.toJSON(Q) : void 0) : ue.connections = [], ee.pagination !== void 0 && (ue.pagination = ee.pagination ? n.PageResponse.toJSON(ee.pagination) : void 0), ee.height !== void 0 && (ue.height = ee.height ? u.Height.toJSON(ee.height) : void 0), ue;
    },
    fromPartial(ee) {
      var Q;
      const ue = E();
      return ue.connections = ((Q = ee.connections) == null ? void 0 : Q.map((Y) => o.IdentifiedConnection.fromPartial(Y))) || [], ee.pagination !== void 0 && ee.pagination !== null && (ue.pagination = n.PageResponse.fromPartial(ee.pagination)), ee.height !== void 0 && ee.height !== null && (ue.height = u.Height.fromPartial(ee.height)), ue;
    }
  };
  function O() {
    return {
      clientId: ""
    };
  }
  e.QueryClientConnectionsRequest = {
    typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsRequest",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.clientId !== "" && ue.uint32(10).string(ee.clientId), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = O();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.clientId = Q.string();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = O();
      return (0, m.isSet)(ee.clientId) && (ue.clientId = String(ee.clientId)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.clientId !== void 0 && (ue.clientId = ee.clientId), ue;
    },
    fromPartial(ee) {
      const ue = O();
      return ue.clientId = ee.clientId ?? "", ue;
    }
  };
  function T() {
    return {
      connectionPaths: [],
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryClientConnectionsResponse = {
    typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsResponse",
    encode(ee, ue = d.BinaryWriter.create()) {
      for (const Q of ee.connectionPaths)
        ue.uint32(10).string(Q);
      return ee.proof.length !== 0 && ue.uint32(18).bytes(ee.proof), ee.proofHeight !== void 0 && u.Height.encode(ee.proofHeight, ue.uint32(26).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = T();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.connectionPaths.push(Q.string());
            break;
          case 2:
            pe.proof = Q.bytes();
            break;
          case 3:
            pe.proofHeight = u.Height.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = T();
      return Array.isArray(ee == null ? void 0 : ee.connectionPaths) && (ue.connectionPaths = ee.connectionPaths.map((Q) => String(Q))), (0, m.isSet)(ee.proof) && (ue.proof = (0, m.bytesFromBase64)(ee.proof)), (0, m.isSet)(ee.proofHeight) && (ue.proofHeight = u.Height.fromJSON(ee.proofHeight)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.connectionPaths ? ue.connectionPaths = ee.connectionPaths.map((Q) => Q) : ue.connectionPaths = [], ee.proof !== void 0 && (ue.proof = (0, m.base64FromBytes)(ee.proof !== void 0 ? ee.proof : new Uint8Array())), ee.proofHeight !== void 0 && (ue.proofHeight = ee.proofHeight ? u.Height.toJSON(ee.proofHeight) : void 0), ue;
    },
    fromPartial(ee) {
      var Q;
      const ue = T();
      return ue.connectionPaths = ((Q = ee.connectionPaths) == null ? void 0 : Q.map((Y) => Y)) || [], ue.proof = ee.proof ?? new Uint8Array(), ee.proofHeight !== void 0 && ee.proofHeight !== null && (ue.proofHeight = u.Height.fromPartial(ee.proofHeight)), ue;
    }
  };
  function y() {
    return {
      connectionId: ""
    };
  }
  e.QueryConnectionClientStateRequest = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateRequest",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.connectionId !== "" && ue.uint32(10).string(ee.connectionId), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = y();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.connectionId = Q.string();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = y();
      return (0, m.isSet)(ee.connectionId) && (ue.connectionId = String(ee.connectionId)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.connectionId !== void 0 && (ue.connectionId = ee.connectionId), ue;
    },
    fromPartial(ee) {
      const ue = y();
      return ue.connectionId = ee.connectionId ?? "", ue;
    }
  };
  function V() {
    return {
      identifiedClientState: void 0,
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryConnectionClientStateResponse = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateResponse",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.identifiedClientState !== void 0 && u.IdentifiedClientState.encode(ee.identifiedClientState, ue.uint32(10).fork()).ldelim(), ee.proof.length !== 0 && ue.uint32(18).bytes(ee.proof), ee.proofHeight !== void 0 && u.Height.encode(ee.proofHeight, ue.uint32(26).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = V();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.identifiedClientState = u.IdentifiedClientState.decode(Q, Q.uint32());
            break;
          case 2:
            pe.proof = Q.bytes();
            break;
          case 3:
            pe.proofHeight = u.Height.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = V();
      return (0, m.isSet)(ee.identifiedClientState) && (ue.identifiedClientState = u.IdentifiedClientState.fromJSON(ee.identifiedClientState)), (0, m.isSet)(ee.proof) && (ue.proof = (0, m.bytesFromBase64)(ee.proof)), (0, m.isSet)(ee.proofHeight) && (ue.proofHeight = u.Height.fromJSON(ee.proofHeight)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.identifiedClientState !== void 0 && (ue.identifiedClientState = ee.identifiedClientState ? u.IdentifiedClientState.toJSON(ee.identifiedClientState) : void 0), ee.proof !== void 0 && (ue.proof = (0, m.base64FromBytes)(ee.proof !== void 0 ? ee.proof : new Uint8Array())), ee.proofHeight !== void 0 && (ue.proofHeight = ee.proofHeight ? u.Height.toJSON(ee.proofHeight) : void 0), ue;
    },
    fromPartial(ee) {
      const ue = V();
      return ee.identifiedClientState !== void 0 && ee.identifiedClientState !== null && (ue.identifiedClientState = u.IdentifiedClientState.fromPartial(ee.identifiedClientState)), ue.proof = ee.proof ?? new Uint8Array(), ee.proofHeight !== void 0 && ee.proofHeight !== null && (ue.proofHeight = u.Height.fromPartial(ee.proofHeight)), ue;
    }
  };
  function M() {
    return {
      connectionId: "",
      revisionNumber: BigInt(0),
      revisionHeight: BigInt(0)
    };
  }
  e.QueryConnectionConsensusStateRequest = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateRequest",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.connectionId !== "" && ue.uint32(10).string(ee.connectionId), ee.revisionNumber !== BigInt(0) && ue.uint32(16).uint64(ee.revisionNumber), ee.revisionHeight !== BigInt(0) && ue.uint32(24).uint64(ee.revisionHeight), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = M();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.connectionId = Q.string();
            break;
          case 2:
            pe.revisionNumber = Q.uint64();
            break;
          case 3:
            pe.revisionHeight = Q.uint64();
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = M();
      return (0, m.isSet)(ee.connectionId) && (ue.connectionId = String(ee.connectionId)), (0, m.isSet)(ee.revisionNumber) && (ue.revisionNumber = BigInt(ee.revisionNumber.toString())), (0, m.isSet)(ee.revisionHeight) && (ue.revisionHeight = BigInt(ee.revisionHeight.toString())), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.connectionId !== void 0 && (ue.connectionId = ee.connectionId), ee.revisionNumber !== void 0 && (ue.revisionNumber = (ee.revisionNumber || BigInt(0)).toString()), ee.revisionHeight !== void 0 && (ue.revisionHeight = (ee.revisionHeight || BigInt(0)).toString()), ue;
    },
    fromPartial(ee) {
      const ue = M();
      return ue.connectionId = ee.connectionId ?? "", ee.revisionNumber !== void 0 && ee.revisionNumber !== null && (ue.revisionNumber = BigInt(ee.revisionNumber.toString())), ee.revisionHeight !== void 0 && ee.revisionHeight !== null && (ue.revisionHeight = BigInt(ee.revisionHeight.toString())), ue;
    }
  };
  function G() {
    return {
      consensusState: void 0,
      clientId: "",
      proof: new Uint8Array(),
      proofHeight: u.Height.fromPartial({})
    };
  }
  e.QueryConnectionConsensusStateResponse = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateResponse",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.consensusState !== void 0 && c.Any.encode(ee.consensusState, ue.uint32(10).fork()).ldelim(), ee.clientId !== "" && ue.uint32(18).string(ee.clientId), ee.proof.length !== 0 && ue.uint32(26).bytes(ee.proof), ee.proofHeight !== void 0 && u.Height.encode(ee.proofHeight, ue.uint32(34).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = G();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.consensusState = c.Any.decode(Q, Q.uint32());
            break;
          case 2:
            pe.clientId = Q.string();
            break;
          case 3:
            pe.proof = Q.bytes();
            break;
          case 4:
            pe.proofHeight = u.Height.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = G();
      return (0, m.isSet)(ee.consensusState) && (ue.consensusState = c.Any.fromJSON(ee.consensusState)), (0, m.isSet)(ee.clientId) && (ue.clientId = String(ee.clientId)), (0, m.isSet)(ee.proof) && (ue.proof = (0, m.bytesFromBase64)(ee.proof)), (0, m.isSet)(ee.proofHeight) && (ue.proofHeight = u.Height.fromJSON(ee.proofHeight)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.consensusState !== void 0 && (ue.consensusState = ee.consensusState ? c.Any.toJSON(ee.consensusState) : void 0), ee.clientId !== void 0 && (ue.clientId = ee.clientId), ee.proof !== void 0 && (ue.proof = (0, m.base64FromBytes)(ee.proof !== void 0 ? ee.proof : new Uint8Array())), ee.proofHeight !== void 0 && (ue.proofHeight = ee.proofHeight ? u.Height.toJSON(ee.proofHeight) : void 0), ue;
    },
    fromPartial(ee) {
      const ue = G();
      return ee.consensusState !== void 0 && ee.consensusState !== null && (ue.consensusState = c.Any.fromPartial(ee.consensusState)), ue.clientId = ee.clientId ?? "", ue.proof = ee.proof ?? new Uint8Array(), ee.proofHeight !== void 0 && ee.proofHeight !== null && (ue.proofHeight = u.Height.fromPartial(ee.proofHeight)), ue;
    }
  };
  function k() {
    return {};
  }
  e.QueryConnectionParamsRequest = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsRequest",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = k();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      return k();
    },
    toJSON(ee) {
      return {};
    },
    fromPartial(ee) {
      return k();
    }
  };
  function F() {
    return {
      params: void 0
    };
  }
  e.QueryConnectionParamsResponse = {
    typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsResponse",
    encode(ee, ue = d.BinaryWriter.create()) {
      return ee.params !== void 0 && u.Params.encode(ee.params, ue.uint32(10).fork()).ldelim(), ue;
    },
    decode(ee, ue) {
      const Q = ee instanceof d.BinaryReader ? ee : new d.BinaryReader(ee);
      let Y = ue === void 0 ? Q.len : Q.pos + ue;
      const pe = F();
      for (; Q.pos < Y; ) {
        const oe = Q.uint32();
        switch (oe >>> 3) {
          case 1:
            pe.params = u.Params.decode(Q, Q.uint32());
            break;
          default:
            Q.skipType(oe & 7);
            break;
        }
      }
      return pe;
    },
    fromJSON(ee) {
      const ue = F();
      return (0, m.isSet)(ee.params) && (ue.params = u.Params.fromJSON(ee.params)), ue;
    },
    toJSON(ee) {
      const ue = {};
      return ee.params !== void 0 && (ue.params = ee.params ? u.Params.toJSON(ee.params) : void 0), ue;
    },
    fromPartial(ee) {
      const ue = F();
      return ee.params !== void 0 && ee.params !== null && (ue.params = u.Params.fromPartial(ee.params)), ue;
    }
  };
  class X {
    constructor(ue) {
      this.rpc = ue, this.Connection = this.Connection.bind(this), this.Connections = this.Connections.bind(this), this.ClientConnections = this.ClientConnections.bind(this), this.ConnectionClientState = this.ConnectionClientState.bind(this), this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this), this.ConnectionParams = this.ConnectionParams.bind(this);
    }
    Connection(ue) {
      const Q = e.QueryConnectionRequest.encode(ue).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "Connection", Q).then((pe) => e.QueryConnectionResponse.decode(new d.BinaryReader(pe)));
    }
    Connections(ue = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const Q = e.QueryConnectionsRequest.encode(ue).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "Connections", Q).then((pe) => e.QueryConnectionsResponse.decode(new d.BinaryReader(pe)));
    }
    ClientConnections(ue) {
      const Q = e.QueryClientConnectionsRequest.encode(ue).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", Q).then((pe) => e.QueryClientConnectionsResponse.decode(new d.BinaryReader(pe)));
    }
    ConnectionClientState(ue) {
      const Q = e.QueryConnectionClientStateRequest.encode(ue).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", Q).then((pe) => e.QueryConnectionClientStateResponse.decode(new d.BinaryReader(pe)));
    }
    ConnectionConsensusState(ue) {
      const Q = e.QueryConnectionConsensusStateRequest.encode(ue).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", Q).then((pe) => e.QueryConnectionConsensusStateResponse.decode(new d.BinaryReader(pe)));
    }
    ConnectionParams(ue = {}) {
      const Q = e.QueryConnectionParamsRequest.encode(ue).finish();
      return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", Q).then((pe) => e.QueryConnectionParamsResponse.decode(new d.BinaryReader(pe)));
    }
  }
  e.QueryClientImpl = X;
})(query$4);
var tendermint$1 = {}, types$e = {}, proof$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ProofOps = e.ProofOp = e.DominoOp = e.ValueOp = e.Proof = e.protobufPackage = void 0;
  const n = binary, o = helpers;
  e.protobufPackage = "tendermint.crypto";
  function u() {
    return {
      total: BigInt(0),
      index: BigInt(0),
      leafHash: new Uint8Array(),
      aunts: []
    };
  }
  e.Proof = {
    typeUrl: "/tendermint.crypto.Proof",
    encode(S, $ = n.BinaryWriter.create()) {
      S.total !== BigInt(0) && $.uint32(8).int64(S.total), S.index !== BigInt(0) && $.uint32(16).int64(S.index), S.leafHash.length !== 0 && $.uint32(26).bytes(S.leafHash);
      for (const E of S.aunts)
        $.uint32(34).bytes(E);
      return $;
    },
    decode(S, $) {
      const E = S instanceof n.BinaryReader ? S : new n.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = u();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.total = E.int64();
            break;
          case 2:
            T.index = E.int64();
            break;
          case 3:
            T.leafHash = E.bytes();
            break;
          case 4:
            T.aunts.push(E.bytes());
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = u();
      return (0, o.isSet)(S.total) && ($.total = BigInt(S.total.toString())), (0, o.isSet)(S.index) && ($.index = BigInt(S.index.toString())), (0, o.isSet)(S.leafHash) && ($.leafHash = (0, o.bytesFromBase64)(S.leafHash)), Array.isArray(S == null ? void 0 : S.aunts) && ($.aunts = S.aunts.map((E) => (0, o.bytesFromBase64)(E))), $;
    },
    toJSON(S) {
      const $ = {};
      return S.total !== void 0 && ($.total = (S.total || BigInt(0)).toString()), S.index !== void 0 && ($.index = (S.index || BigInt(0)).toString()), S.leafHash !== void 0 && ($.leafHash = (0, o.base64FromBytes)(S.leafHash !== void 0 ? S.leafHash : new Uint8Array())), S.aunts ? $.aunts = S.aunts.map((E) => (0, o.base64FromBytes)(E !== void 0 ? E : new Uint8Array())) : $.aunts = [], $;
    },
    fromPartial(S) {
      var E;
      const $ = u();
      return S.total !== void 0 && S.total !== null && ($.total = BigInt(S.total.toString())), S.index !== void 0 && S.index !== null && ($.index = BigInt(S.index.toString())), $.leafHash = S.leafHash ?? new Uint8Array(), $.aunts = ((E = S.aunts) == null ? void 0 : E.map((O) => O)) || [], $;
    }
  };
  function c() {
    return {
      key: new Uint8Array(),
      proof: void 0
    };
  }
  e.ValueOp = {
    typeUrl: "/tendermint.crypto.ValueOp",
    encode(S, $ = n.BinaryWriter.create()) {
      return S.key.length !== 0 && $.uint32(10).bytes(S.key), S.proof !== void 0 && e.Proof.encode(S.proof, $.uint32(18).fork()).ldelim(), $;
    },
    decode(S, $) {
      const E = S instanceof n.BinaryReader ? S : new n.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = c();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.key = E.bytes();
            break;
          case 2:
            T.proof = e.Proof.decode(E, E.uint32());
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = c();
      return (0, o.isSet)(S.key) && ($.key = (0, o.bytesFromBase64)(S.key)), (0, o.isSet)(S.proof) && ($.proof = e.Proof.fromJSON(S.proof)), $;
    },
    toJSON(S) {
      const $ = {};
      return S.key !== void 0 && ($.key = (0, o.base64FromBytes)(S.key !== void 0 ? S.key : new Uint8Array())), S.proof !== void 0 && ($.proof = S.proof ? e.Proof.toJSON(S.proof) : void 0), $;
    },
    fromPartial(S) {
      const $ = c();
      return $.key = S.key ?? new Uint8Array(), S.proof !== void 0 && S.proof !== null && ($.proof = e.Proof.fromPartial(S.proof)), $;
    }
  };
  function d() {
    return {
      key: "",
      input: "",
      output: ""
    };
  }
  e.DominoOp = {
    typeUrl: "/tendermint.crypto.DominoOp",
    encode(S, $ = n.BinaryWriter.create()) {
      return S.key !== "" && $.uint32(10).string(S.key), S.input !== "" && $.uint32(18).string(S.input), S.output !== "" && $.uint32(26).string(S.output), $;
    },
    decode(S, $) {
      const E = S instanceof n.BinaryReader ? S : new n.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = d();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.key = E.string();
            break;
          case 2:
            T.input = E.string();
            break;
          case 3:
            T.output = E.string();
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = d();
      return (0, o.isSet)(S.key) && ($.key = String(S.key)), (0, o.isSet)(S.input) && ($.input = String(S.input)), (0, o.isSet)(S.output) && ($.output = String(S.output)), $;
    },
    toJSON(S) {
      const $ = {};
      return S.key !== void 0 && ($.key = S.key), S.input !== void 0 && ($.input = S.input), S.output !== void 0 && ($.output = S.output), $;
    },
    fromPartial(S) {
      const $ = d();
      return $.key = S.key ?? "", $.input = S.input ?? "", $.output = S.output ?? "", $;
    }
  };
  function m() {
    return {
      type: "",
      key: new Uint8Array(),
      data: new Uint8Array()
    };
  }
  e.ProofOp = {
    typeUrl: "/tendermint.crypto.ProofOp",
    encode(S, $ = n.BinaryWriter.create()) {
      return S.type !== "" && $.uint32(10).string(S.type), S.key.length !== 0 && $.uint32(18).bytes(S.key), S.data.length !== 0 && $.uint32(26).bytes(S.data), $;
    },
    decode(S, $) {
      const E = S instanceof n.BinaryReader ? S : new n.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = m();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.type = E.string();
            break;
          case 2:
            T.key = E.bytes();
            break;
          case 3:
            T.data = E.bytes();
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = m();
      return (0, o.isSet)(S.type) && ($.type = String(S.type)), (0, o.isSet)(S.key) && ($.key = (0, o.bytesFromBase64)(S.key)), (0, o.isSet)(S.data) && ($.data = (0, o.bytesFromBase64)(S.data)), $;
    },
    toJSON(S) {
      const $ = {};
      return S.type !== void 0 && ($.type = S.type), S.key !== void 0 && ($.key = (0, o.base64FromBytes)(S.key !== void 0 ? S.key : new Uint8Array())), S.data !== void 0 && ($.data = (0, o.base64FromBytes)(S.data !== void 0 ? S.data : new Uint8Array())), $;
    },
    fromPartial(S) {
      const $ = m();
      return $.type = S.type ?? "", $.key = S.key ?? new Uint8Array(), $.data = S.data ?? new Uint8Array(), $;
    }
  };
  function v() {
    return {
      ops: []
    };
  }
  e.ProofOps = {
    typeUrl: "/tendermint.crypto.ProofOps",
    encode(S, $ = n.BinaryWriter.create()) {
      for (const E of S.ops)
        e.ProofOp.encode(E, $.uint32(10).fork()).ldelim();
      return $;
    },
    decode(S, $) {
      const E = S instanceof n.BinaryReader ? S : new n.BinaryReader(S);
      let O = $ === void 0 ? E.len : E.pos + $;
      const T = v();
      for (; E.pos < O; ) {
        const y = E.uint32();
        switch (y >>> 3) {
          case 1:
            T.ops.push(e.ProofOp.decode(E, E.uint32()));
            break;
          default:
            E.skipType(y & 7);
            break;
        }
      }
      return T;
    },
    fromJSON(S) {
      const $ = v();
      return Array.isArray(S == null ? void 0 : S.ops) && ($.ops = S.ops.map((E) => e.ProofOp.fromJSON(E))), $;
    },
    toJSON(S) {
      const $ = {};
      return S.ops ? $.ops = S.ops.map((E) => E ? e.ProofOp.toJSON(E) : void 0) : $.ops = [], $;
    },
    fromPartial(S) {
      var E;
      const $ = v();
      return $.ops = ((E = S.ops) == null ? void 0 : E.map((O) => e.ProofOp.fromPartial(O))) || [], $;
    }
  };
})(proof$1);
var types$d = {};
Object.defineProperty(types$d, "__esModule", { value: !0 });
types$d.Consensus = types$d.App = types$d.protobufPackage = void 0;
const binary_1$4 = binary, helpers_1$4 = helpers;
types$d.protobufPackage = "tendermint.version";
function createBaseApp$1() {
  return {
    protocol: BigInt(0),
    software: ""
  };
}
types$d.App = {
  typeUrl: "/tendermint.version.App",
  encode(e, n = binary_1$4.BinaryWriter.create()) {
    return e.protocol !== BigInt(0) && n.uint32(8).uint64(e.protocol), e.software !== "" && n.uint32(18).string(e.software), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$4.BinaryReader ? e : new binary_1$4.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseApp$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.protocol = o.uint64();
          break;
        case 2:
          c.software = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseApp$1();
    return (0, helpers_1$4.isSet)(e.protocol) && (n.protocol = BigInt(e.protocol.toString())), (0, helpers_1$4.isSet)(e.software) && (n.software = String(e.software)), n;
  },
  toJSON(e) {
    const n = {};
    return e.protocol !== void 0 && (n.protocol = (e.protocol || BigInt(0)).toString()), e.software !== void 0 && (n.software = e.software), n;
  },
  fromPartial(e) {
    const n = createBaseApp$1();
    return e.protocol !== void 0 && e.protocol !== null && (n.protocol = BigInt(e.protocol.toString())), n.software = e.software ?? "", n;
  }
};
function createBaseConsensus$1() {
  return {
    block: BigInt(0),
    app: BigInt(0)
  };
}
types$d.Consensus = {
  typeUrl: "/tendermint.version.Consensus",
  encode(e, n = binary_1$4.BinaryWriter.create()) {
    return e.block !== BigInt(0) && n.uint32(8).uint64(e.block), e.app !== BigInt(0) && n.uint32(16).uint64(e.app), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$4.BinaryReader ? e : new binary_1$4.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConsensus$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.block = o.uint64();
          break;
        case 2:
          c.app = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseConsensus$1();
    return (0, helpers_1$4.isSet)(e.block) && (n.block = BigInt(e.block.toString())), (0, helpers_1$4.isSet)(e.app) && (n.app = BigInt(e.app.toString())), n;
  },
  toJSON(e) {
    const n = {};
    return e.block !== void 0 && (n.block = (e.block || BigInt(0)).toString()), e.app !== void 0 && (n.app = (e.app || BigInt(0)).toString()), n;
  },
  fromPartial(e) {
    const n = createBaseConsensus$1();
    return e.block !== void 0 && e.block !== null && (n.block = BigInt(e.block.toString())), e.app !== void 0 && e.app !== null && (n.app = BigInt(e.app.toString())), n;
  }
};
var validator$b = {}, keys$3 = {};
Object.defineProperty(keys$3, "__esModule", { value: !0 });
keys$3.PublicKey = keys$3.protobufPackage = void 0;
const binary_1$3 = binary, helpers_1$3 = helpers;
keys$3.protobufPackage = "tendermint.crypto";
function createBasePublicKey$1() {
  return {
    ed25519: void 0,
    secp256k1: void 0
  };
}
keys$3.PublicKey = {
  typeUrl: "/tendermint.crypto.PublicKey",
  encode(e, n = binary_1$3.BinaryWriter.create()) {
    return e.ed25519 !== void 0 && n.uint32(10).bytes(e.ed25519), e.secp256k1 !== void 0 && n.uint32(18).bytes(e.secp256k1), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$3.BinaryReader ? e : new binary_1$3.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePublicKey$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.ed25519 = o.bytes();
          break;
        case 2:
          c.secp256k1 = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBasePublicKey$1();
    return (0, helpers_1$3.isSet)(e.ed25519) && (n.ed25519 = (0, helpers_1$3.bytesFromBase64)(e.ed25519)), (0, helpers_1$3.isSet)(e.secp256k1) && (n.secp256k1 = (0, helpers_1$3.bytesFromBase64)(e.secp256k1)), n;
  },
  toJSON(e) {
    const n = {};
    return e.ed25519 !== void 0 && (n.ed25519 = e.ed25519 !== void 0 ? (0, helpers_1$3.base64FromBytes)(e.ed25519) : void 0), e.secp256k1 !== void 0 && (n.secp256k1 = e.secp256k1 !== void 0 ? (0, helpers_1$3.base64FromBytes)(e.secp256k1) : void 0), n;
  },
  fromPartial(e) {
    const n = createBasePublicKey$1();
    return n.ed25519 = e.ed25519 ?? void 0, n.secp256k1 = e.secp256k1 ?? void 0, n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SimpleValidator = e.Validator = e.ValidatorSet = e.protobufPackage = void 0;
  const n = keys$3, o = binary, u = helpers;
  e.protobufPackage = "tendermint.types";
  function c() {
    return {
      validators: [],
      proposer: void 0,
      totalVotingPower: BigInt(0)
    };
  }
  e.ValidatorSet = {
    typeUrl: "/tendermint.types.ValidatorSet",
    encode(v, S = o.BinaryWriter.create()) {
      for (const $ of v.validators)
        e.Validator.encode($, S.uint32(10).fork()).ldelim();
      return v.proposer !== void 0 && e.Validator.encode(v.proposer, S.uint32(18).fork()).ldelim(), v.totalVotingPower !== BigInt(0) && S.uint32(24).int64(v.totalVotingPower), S;
    },
    decode(v, S) {
      const $ = v instanceof o.BinaryReader ? v : new o.BinaryReader(v);
      let E = S === void 0 ? $.len : $.pos + S;
      const O = c();
      for (; $.pos < E; ) {
        const T = $.uint32();
        switch (T >>> 3) {
          case 1:
            O.validators.push(e.Validator.decode($, $.uint32()));
            break;
          case 2:
            O.proposer = e.Validator.decode($, $.uint32());
            break;
          case 3:
            O.totalVotingPower = $.int64();
            break;
          default:
            $.skipType(T & 7);
            break;
        }
      }
      return O;
    },
    fromJSON(v) {
      const S = c();
      return Array.isArray(v == null ? void 0 : v.validators) && (S.validators = v.validators.map(($) => e.Validator.fromJSON($))), (0, u.isSet)(v.proposer) && (S.proposer = e.Validator.fromJSON(v.proposer)), (0, u.isSet)(v.totalVotingPower) && (S.totalVotingPower = BigInt(v.totalVotingPower.toString())), S;
    },
    toJSON(v) {
      const S = {};
      return v.validators ? S.validators = v.validators.map(($) => $ ? e.Validator.toJSON($) : void 0) : S.validators = [], v.proposer !== void 0 && (S.proposer = v.proposer ? e.Validator.toJSON(v.proposer) : void 0), v.totalVotingPower !== void 0 && (S.totalVotingPower = (v.totalVotingPower || BigInt(0)).toString()), S;
    },
    fromPartial(v) {
      var $;
      const S = c();
      return S.validators = (($ = v.validators) == null ? void 0 : $.map((E) => e.Validator.fromPartial(E))) || [], v.proposer !== void 0 && v.proposer !== null && (S.proposer = e.Validator.fromPartial(v.proposer)), v.totalVotingPower !== void 0 && v.totalVotingPower !== null && (S.totalVotingPower = BigInt(v.totalVotingPower.toString())), S;
    }
  };
  function d() {
    return {
      address: new Uint8Array(),
      pubKey: n.PublicKey.fromPartial({}),
      votingPower: BigInt(0),
      proposerPriority: BigInt(0)
    };
  }
  e.Validator = {
    typeUrl: "/tendermint.types.Validator",
    encode(v, S = o.BinaryWriter.create()) {
      return v.address.length !== 0 && S.uint32(10).bytes(v.address), v.pubKey !== void 0 && n.PublicKey.encode(v.pubKey, S.uint32(18).fork()).ldelim(), v.votingPower !== BigInt(0) && S.uint32(24).int64(v.votingPower), v.proposerPriority !== BigInt(0) && S.uint32(32).int64(v.proposerPriority), S;
    },
    decode(v, S) {
      const $ = v instanceof o.BinaryReader ? v : new o.BinaryReader(v);
      let E = S === void 0 ? $.len : $.pos + S;
      const O = d();
      for (; $.pos < E; ) {
        const T = $.uint32();
        switch (T >>> 3) {
          case 1:
            O.address = $.bytes();
            break;
          case 2:
            O.pubKey = n.PublicKey.decode($, $.uint32());
            break;
          case 3:
            O.votingPower = $.int64();
            break;
          case 4:
            O.proposerPriority = $.int64();
            break;
          default:
            $.skipType(T & 7);
            break;
        }
      }
      return O;
    },
    fromJSON(v) {
      const S = d();
      return (0, u.isSet)(v.address) && (S.address = (0, u.bytesFromBase64)(v.address)), (0, u.isSet)(v.pubKey) && (S.pubKey = n.PublicKey.fromJSON(v.pubKey)), (0, u.isSet)(v.votingPower) && (S.votingPower = BigInt(v.votingPower.toString())), (0, u.isSet)(v.proposerPriority) && (S.proposerPriority = BigInt(v.proposerPriority.toString())), S;
    },
    toJSON(v) {
      const S = {};
      return v.address !== void 0 && (S.address = (0, u.base64FromBytes)(v.address !== void 0 ? v.address : new Uint8Array())), v.pubKey !== void 0 && (S.pubKey = v.pubKey ? n.PublicKey.toJSON(v.pubKey) : void 0), v.votingPower !== void 0 && (S.votingPower = (v.votingPower || BigInt(0)).toString()), v.proposerPriority !== void 0 && (S.proposerPriority = (v.proposerPriority || BigInt(0)).toString()), S;
    },
    fromPartial(v) {
      const S = d();
      return S.address = v.address ?? new Uint8Array(), v.pubKey !== void 0 && v.pubKey !== null && (S.pubKey = n.PublicKey.fromPartial(v.pubKey)), v.votingPower !== void 0 && v.votingPower !== null && (S.votingPower = BigInt(v.votingPower.toString())), v.proposerPriority !== void 0 && v.proposerPriority !== null && (S.proposerPriority = BigInt(v.proposerPriority.toString())), S;
    }
  };
  function m() {
    return {
      pubKey: void 0,
      votingPower: BigInt(0)
    };
  }
  e.SimpleValidator = {
    typeUrl: "/tendermint.types.SimpleValidator",
    encode(v, S = o.BinaryWriter.create()) {
      return v.pubKey !== void 0 && n.PublicKey.encode(v.pubKey, S.uint32(10).fork()).ldelim(), v.votingPower !== BigInt(0) && S.uint32(16).int64(v.votingPower), S;
    },
    decode(v, S) {
      const $ = v instanceof o.BinaryReader ? v : new o.BinaryReader(v);
      let E = S === void 0 ? $.len : $.pos + S;
      const O = m();
      for (; $.pos < E; ) {
        const T = $.uint32();
        switch (T >>> 3) {
          case 1:
            O.pubKey = n.PublicKey.decode($, $.uint32());
            break;
          case 2:
            O.votingPower = $.int64();
            break;
          default:
            $.skipType(T & 7);
            break;
        }
      }
      return O;
    },
    fromJSON(v) {
      const S = m();
      return (0, u.isSet)(v.pubKey) && (S.pubKey = n.PublicKey.fromJSON(v.pubKey)), (0, u.isSet)(v.votingPower) && (S.votingPower = BigInt(v.votingPower.toString())), S;
    },
    toJSON(v) {
      const S = {};
      return v.pubKey !== void 0 && (S.pubKey = v.pubKey ? n.PublicKey.toJSON(v.pubKey) : void 0), v.votingPower !== void 0 && (S.votingPower = (v.votingPower || BigInt(0)).toString()), S;
    },
    fromPartial(v) {
      const S = m();
      return v.pubKey !== void 0 && v.pubKey !== null && (S.pubKey = n.PublicKey.fromPartial(v.pubKey)), v.votingPower !== void 0 && v.votingPower !== null && (S.votingPower = BigInt(v.votingPower.toString())), S;
    }
  };
})(validator$b);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TxProof = e.BlockMeta = e.LightBlock = e.SignedHeader = e.Proposal = e.CommitSig = e.Commit = e.Vote = e.Data = e.Header = e.BlockID = e.Part = e.PartSetHeader = e.signedMsgTypeToJSON = e.signedMsgTypeFromJSON = e.SignedMsgType = e.blockIDFlagToJSON = e.blockIDFlagFromJSON = e.BlockIDFlag = e.protobufPackage = void 0;
  const n = proof$1, o = types$d, u = timestamp$1, c = validator$b, d = binary, m = helpers;
  e.protobufPackage = "tendermint.types";
  var v;
  (function(ne) {
    ne[ne.BLOCK_ID_FLAG_UNKNOWN = 0] = "BLOCK_ID_FLAG_UNKNOWN", ne[ne.BLOCK_ID_FLAG_ABSENT = 1] = "BLOCK_ID_FLAG_ABSENT", ne[ne.BLOCK_ID_FLAG_COMMIT = 2] = "BLOCK_ID_FLAG_COMMIT", ne[ne.BLOCK_ID_FLAG_NIL = 3] = "BLOCK_ID_FLAG_NIL", ne[ne.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(v || (e.BlockIDFlag = v = {}));
  function S(ne) {
    switch (ne) {
      case 0:
      case "BLOCK_ID_FLAG_UNKNOWN":
        return v.BLOCK_ID_FLAG_UNKNOWN;
      case 1:
      case "BLOCK_ID_FLAG_ABSENT":
        return v.BLOCK_ID_FLAG_ABSENT;
      case 2:
      case "BLOCK_ID_FLAG_COMMIT":
        return v.BLOCK_ID_FLAG_COMMIT;
      case 3:
      case "BLOCK_ID_FLAG_NIL":
        return v.BLOCK_ID_FLAG_NIL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return v.UNRECOGNIZED;
    }
  }
  e.blockIDFlagFromJSON = S;
  function $(ne) {
    switch (ne) {
      case v.BLOCK_ID_FLAG_UNKNOWN:
        return "BLOCK_ID_FLAG_UNKNOWN";
      case v.BLOCK_ID_FLAG_ABSENT:
        return "BLOCK_ID_FLAG_ABSENT";
      case v.BLOCK_ID_FLAG_COMMIT:
        return "BLOCK_ID_FLAG_COMMIT";
      case v.BLOCK_ID_FLAG_NIL:
        return "BLOCK_ID_FLAG_NIL";
      case v.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.blockIDFlagToJSON = $;
  var E;
  (function(ne) {
    ne[ne.SIGNED_MSG_TYPE_UNKNOWN = 0] = "SIGNED_MSG_TYPE_UNKNOWN", ne[ne.SIGNED_MSG_TYPE_PREVOTE = 1] = "SIGNED_MSG_TYPE_PREVOTE", ne[ne.SIGNED_MSG_TYPE_PRECOMMIT = 2] = "SIGNED_MSG_TYPE_PRECOMMIT", ne[ne.SIGNED_MSG_TYPE_PROPOSAL = 32] = "SIGNED_MSG_TYPE_PROPOSAL", ne[ne.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(E || (e.SignedMsgType = E = {}));
  function O(ne) {
    switch (ne) {
      case 0:
      case "SIGNED_MSG_TYPE_UNKNOWN":
        return E.SIGNED_MSG_TYPE_UNKNOWN;
      case 1:
      case "SIGNED_MSG_TYPE_PREVOTE":
        return E.SIGNED_MSG_TYPE_PREVOTE;
      case 2:
      case "SIGNED_MSG_TYPE_PRECOMMIT":
        return E.SIGNED_MSG_TYPE_PRECOMMIT;
      case 32:
      case "SIGNED_MSG_TYPE_PROPOSAL":
        return E.SIGNED_MSG_TYPE_PROPOSAL;
      case -1:
      case "UNRECOGNIZED":
      default:
        return E.UNRECOGNIZED;
    }
  }
  e.signedMsgTypeFromJSON = O;
  function T(ne) {
    switch (ne) {
      case E.SIGNED_MSG_TYPE_UNKNOWN:
        return "SIGNED_MSG_TYPE_UNKNOWN";
      case E.SIGNED_MSG_TYPE_PREVOTE:
        return "SIGNED_MSG_TYPE_PREVOTE";
      case E.SIGNED_MSG_TYPE_PRECOMMIT:
        return "SIGNED_MSG_TYPE_PRECOMMIT";
      case E.SIGNED_MSG_TYPE_PROPOSAL:
        return "SIGNED_MSG_TYPE_PROPOSAL";
      case E.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.signedMsgTypeToJSON = T;
  function y() {
    return {
      total: 0,
      hash: new Uint8Array()
    };
  }
  e.PartSetHeader = {
    typeUrl: "/tendermint.types.PartSetHeader",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.total !== 0 && H.uint32(8).uint32(ne.total), ne.hash.length !== 0 && H.uint32(18).bytes(ne.hash), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = y();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.total = C.uint32();
            break;
          case 2:
            P.hash = C.bytes();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = y();
      return (0, m.isSet)(ne.total) && (H.total = Number(ne.total)), (0, m.isSet)(ne.hash) && (H.hash = (0, m.bytesFromBase64)(ne.hash)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.total !== void 0 && (H.total = Math.round(ne.total)), ne.hash !== void 0 && (H.hash = (0, m.base64FromBytes)(ne.hash !== void 0 ? ne.hash : new Uint8Array())), H;
    },
    fromPartial(ne) {
      const H = y();
      return H.total = ne.total ?? 0, H.hash = ne.hash ?? new Uint8Array(), H;
    }
  };
  function V() {
    return {
      index: 0,
      bytes: new Uint8Array(),
      proof: n.Proof.fromPartial({})
    };
  }
  e.Part = {
    typeUrl: "/tendermint.types.Part",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.index !== 0 && H.uint32(8).uint32(ne.index), ne.bytes.length !== 0 && H.uint32(18).bytes(ne.bytes), ne.proof !== void 0 && n.Proof.encode(ne.proof, H.uint32(26).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = V();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.index = C.uint32();
            break;
          case 2:
            P.bytes = C.bytes();
            break;
          case 3:
            P.proof = n.Proof.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = V();
      return (0, m.isSet)(ne.index) && (H.index = Number(ne.index)), (0, m.isSet)(ne.bytes) && (H.bytes = (0, m.bytesFromBase64)(ne.bytes)), (0, m.isSet)(ne.proof) && (H.proof = n.Proof.fromJSON(ne.proof)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.index !== void 0 && (H.index = Math.round(ne.index)), ne.bytes !== void 0 && (H.bytes = (0, m.base64FromBytes)(ne.bytes !== void 0 ? ne.bytes : new Uint8Array())), ne.proof !== void 0 && (H.proof = ne.proof ? n.Proof.toJSON(ne.proof) : void 0), H;
    },
    fromPartial(ne) {
      const H = V();
      return H.index = ne.index ?? 0, H.bytes = ne.bytes ?? new Uint8Array(), ne.proof !== void 0 && ne.proof !== null && (H.proof = n.Proof.fromPartial(ne.proof)), H;
    }
  };
  function M() {
    return {
      hash: new Uint8Array(),
      partSetHeader: e.PartSetHeader.fromPartial({})
    };
  }
  e.BlockID = {
    typeUrl: "/tendermint.types.BlockID",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.hash.length !== 0 && H.uint32(10).bytes(ne.hash), ne.partSetHeader !== void 0 && e.PartSetHeader.encode(ne.partSetHeader, H.uint32(18).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = M();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.hash = C.bytes();
            break;
          case 2:
            P.partSetHeader = e.PartSetHeader.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = M();
      return (0, m.isSet)(ne.hash) && (H.hash = (0, m.bytesFromBase64)(ne.hash)), (0, m.isSet)(ne.partSetHeader) && (H.partSetHeader = e.PartSetHeader.fromJSON(ne.partSetHeader)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.hash !== void 0 && (H.hash = (0, m.base64FromBytes)(ne.hash !== void 0 ? ne.hash : new Uint8Array())), ne.partSetHeader !== void 0 && (H.partSetHeader = ne.partSetHeader ? e.PartSetHeader.toJSON(ne.partSetHeader) : void 0), H;
    },
    fromPartial(ne) {
      const H = M();
      return H.hash = ne.hash ?? new Uint8Array(), ne.partSetHeader !== void 0 && ne.partSetHeader !== null && (H.partSetHeader = e.PartSetHeader.fromPartial(ne.partSetHeader)), H;
    }
  };
  function G() {
    return {
      version: o.Consensus.fromPartial({}),
      chainId: "",
      height: BigInt(0),
      time: u.Timestamp.fromPartial({}),
      lastBlockId: e.BlockID.fromPartial({}),
      lastCommitHash: new Uint8Array(),
      dataHash: new Uint8Array(),
      validatorsHash: new Uint8Array(),
      nextValidatorsHash: new Uint8Array(),
      consensusHash: new Uint8Array(),
      appHash: new Uint8Array(),
      lastResultsHash: new Uint8Array(),
      evidenceHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.Header = {
    typeUrl: "/tendermint.types.Header",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.version !== void 0 && o.Consensus.encode(ne.version, H.uint32(10).fork()).ldelim(), ne.chainId !== "" && H.uint32(18).string(ne.chainId), ne.height !== BigInt(0) && H.uint32(24).int64(ne.height), ne.time !== void 0 && u.Timestamp.encode(ne.time, H.uint32(34).fork()).ldelim(), ne.lastBlockId !== void 0 && e.BlockID.encode(ne.lastBlockId, H.uint32(42).fork()).ldelim(), ne.lastCommitHash.length !== 0 && H.uint32(50).bytes(ne.lastCommitHash), ne.dataHash.length !== 0 && H.uint32(58).bytes(ne.dataHash), ne.validatorsHash.length !== 0 && H.uint32(66).bytes(ne.validatorsHash), ne.nextValidatorsHash.length !== 0 && H.uint32(74).bytes(ne.nextValidatorsHash), ne.consensusHash.length !== 0 && H.uint32(82).bytes(ne.consensusHash), ne.appHash.length !== 0 && H.uint32(90).bytes(ne.appHash), ne.lastResultsHash.length !== 0 && H.uint32(98).bytes(ne.lastResultsHash), ne.evidenceHash.length !== 0 && H.uint32(106).bytes(ne.evidenceHash), ne.proposerAddress.length !== 0 && H.uint32(114).bytes(ne.proposerAddress), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = G();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.version = o.Consensus.decode(C, C.uint32());
            break;
          case 2:
            P.chainId = C.string();
            break;
          case 3:
            P.height = C.int64();
            break;
          case 4:
            P.time = u.Timestamp.decode(C, C.uint32());
            break;
          case 5:
            P.lastBlockId = e.BlockID.decode(C, C.uint32());
            break;
          case 6:
            P.lastCommitHash = C.bytes();
            break;
          case 7:
            P.dataHash = C.bytes();
            break;
          case 8:
            P.validatorsHash = C.bytes();
            break;
          case 9:
            P.nextValidatorsHash = C.bytes();
            break;
          case 10:
            P.consensusHash = C.bytes();
            break;
          case 11:
            P.appHash = C.bytes();
            break;
          case 12:
            P.lastResultsHash = C.bytes();
            break;
          case 13:
            P.evidenceHash = C.bytes();
            break;
          case 14:
            P.proposerAddress = C.bytes();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = G();
      return (0, m.isSet)(ne.version) && (H.version = o.Consensus.fromJSON(ne.version)), (0, m.isSet)(ne.chainId) && (H.chainId = String(ne.chainId)), (0, m.isSet)(ne.height) && (H.height = BigInt(ne.height.toString())), (0, m.isSet)(ne.time) && (H.time = (0, m.fromJsonTimestamp)(ne.time)), (0, m.isSet)(ne.lastBlockId) && (H.lastBlockId = e.BlockID.fromJSON(ne.lastBlockId)), (0, m.isSet)(ne.lastCommitHash) && (H.lastCommitHash = (0, m.bytesFromBase64)(ne.lastCommitHash)), (0, m.isSet)(ne.dataHash) && (H.dataHash = (0, m.bytesFromBase64)(ne.dataHash)), (0, m.isSet)(ne.validatorsHash) && (H.validatorsHash = (0, m.bytesFromBase64)(ne.validatorsHash)), (0, m.isSet)(ne.nextValidatorsHash) && (H.nextValidatorsHash = (0, m.bytesFromBase64)(ne.nextValidatorsHash)), (0, m.isSet)(ne.consensusHash) && (H.consensusHash = (0, m.bytesFromBase64)(ne.consensusHash)), (0, m.isSet)(ne.appHash) && (H.appHash = (0, m.bytesFromBase64)(ne.appHash)), (0, m.isSet)(ne.lastResultsHash) && (H.lastResultsHash = (0, m.bytesFromBase64)(ne.lastResultsHash)), (0, m.isSet)(ne.evidenceHash) && (H.evidenceHash = (0, m.bytesFromBase64)(ne.evidenceHash)), (0, m.isSet)(ne.proposerAddress) && (H.proposerAddress = (0, m.bytesFromBase64)(ne.proposerAddress)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.version !== void 0 && (H.version = ne.version ? o.Consensus.toJSON(ne.version) : void 0), ne.chainId !== void 0 && (H.chainId = ne.chainId), ne.height !== void 0 && (H.height = (ne.height || BigInt(0)).toString()), ne.time !== void 0 && (H.time = (0, m.fromTimestamp)(ne.time).toISOString()), ne.lastBlockId !== void 0 && (H.lastBlockId = ne.lastBlockId ? e.BlockID.toJSON(ne.lastBlockId) : void 0), ne.lastCommitHash !== void 0 && (H.lastCommitHash = (0, m.base64FromBytes)(ne.lastCommitHash !== void 0 ? ne.lastCommitHash : new Uint8Array())), ne.dataHash !== void 0 && (H.dataHash = (0, m.base64FromBytes)(ne.dataHash !== void 0 ? ne.dataHash : new Uint8Array())), ne.validatorsHash !== void 0 && (H.validatorsHash = (0, m.base64FromBytes)(ne.validatorsHash !== void 0 ? ne.validatorsHash : new Uint8Array())), ne.nextValidatorsHash !== void 0 && (H.nextValidatorsHash = (0, m.base64FromBytes)(ne.nextValidatorsHash !== void 0 ? ne.nextValidatorsHash : new Uint8Array())), ne.consensusHash !== void 0 && (H.consensusHash = (0, m.base64FromBytes)(ne.consensusHash !== void 0 ? ne.consensusHash : new Uint8Array())), ne.appHash !== void 0 && (H.appHash = (0, m.base64FromBytes)(ne.appHash !== void 0 ? ne.appHash : new Uint8Array())), ne.lastResultsHash !== void 0 && (H.lastResultsHash = (0, m.base64FromBytes)(ne.lastResultsHash !== void 0 ? ne.lastResultsHash : new Uint8Array())), ne.evidenceHash !== void 0 && (H.evidenceHash = (0, m.base64FromBytes)(ne.evidenceHash !== void 0 ? ne.evidenceHash : new Uint8Array())), ne.proposerAddress !== void 0 && (H.proposerAddress = (0, m.base64FromBytes)(ne.proposerAddress !== void 0 ? ne.proposerAddress : new Uint8Array())), H;
    },
    fromPartial(ne) {
      const H = G();
      return ne.version !== void 0 && ne.version !== null && (H.version = o.Consensus.fromPartial(ne.version)), H.chainId = ne.chainId ?? "", ne.height !== void 0 && ne.height !== null && (H.height = BigInt(ne.height.toString())), ne.time !== void 0 && ne.time !== null && (H.time = u.Timestamp.fromPartial(ne.time)), ne.lastBlockId !== void 0 && ne.lastBlockId !== null && (H.lastBlockId = e.BlockID.fromPartial(ne.lastBlockId)), H.lastCommitHash = ne.lastCommitHash ?? new Uint8Array(), H.dataHash = ne.dataHash ?? new Uint8Array(), H.validatorsHash = ne.validatorsHash ?? new Uint8Array(), H.nextValidatorsHash = ne.nextValidatorsHash ?? new Uint8Array(), H.consensusHash = ne.consensusHash ?? new Uint8Array(), H.appHash = ne.appHash ?? new Uint8Array(), H.lastResultsHash = ne.lastResultsHash ?? new Uint8Array(), H.evidenceHash = ne.evidenceHash ?? new Uint8Array(), H.proposerAddress = ne.proposerAddress ?? new Uint8Array(), H;
    }
  };
  function k() {
    return {
      txs: []
    };
  }
  e.Data = {
    typeUrl: "/tendermint.types.Data",
    encode(ne, H = d.BinaryWriter.create()) {
      for (const C of ne.txs)
        H.uint32(10).bytes(C);
      return H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = k();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.txs.push(C.bytes());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = k();
      return Array.isArray(ne == null ? void 0 : ne.txs) && (H.txs = ne.txs.map((C) => (0, m.bytesFromBase64)(C))), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.txs ? H.txs = ne.txs.map((C) => (0, m.base64FromBytes)(C !== void 0 ? C : new Uint8Array())) : H.txs = [], H;
    },
    fromPartial(ne) {
      var C;
      const H = k();
      return H.txs = ((C = ne.txs) == null ? void 0 : C.map((w) => w)) || [], H;
    }
  };
  function F() {
    return {
      type: 0,
      height: BigInt(0),
      round: 0,
      blockId: e.BlockID.fromPartial({}),
      timestamp: u.Timestamp.fromPartial({}),
      validatorAddress: new Uint8Array(),
      validatorIndex: 0,
      signature: new Uint8Array()
    };
  }
  e.Vote = {
    typeUrl: "/tendermint.types.Vote",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.type !== 0 && H.uint32(8).int32(ne.type), ne.height !== BigInt(0) && H.uint32(16).int64(ne.height), ne.round !== 0 && H.uint32(24).int32(ne.round), ne.blockId !== void 0 && e.BlockID.encode(ne.blockId, H.uint32(34).fork()).ldelim(), ne.timestamp !== void 0 && u.Timestamp.encode(ne.timestamp, H.uint32(42).fork()).ldelim(), ne.validatorAddress.length !== 0 && H.uint32(50).bytes(ne.validatorAddress), ne.validatorIndex !== 0 && H.uint32(56).int32(ne.validatorIndex), ne.signature.length !== 0 && H.uint32(66).bytes(ne.signature), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = F();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.type = C.int32();
            break;
          case 2:
            P.height = C.int64();
            break;
          case 3:
            P.round = C.int32();
            break;
          case 4:
            P.blockId = e.BlockID.decode(C, C.uint32());
            break;
          case 5:
            P.timestamp = u.Timestamp.decode(C, C.uint32());
            break;
          case 6:
            P.validatorAddress = C.bytes();
            break;
          case 7:
            P.validatorIndex = C.int32();
            break;
          case 8:
            P.signature = C.bytes();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = F();
      return (0, m.isSet)(ne.type) && (H.type = O(ne.type)), (0, m.isSet)(ne.height) && (H.height = BigInt(ne.height.toString())), (0, m.isSet)(ne.round) && (H.round = Number(ne.round)), (0, m.isSet)(ne.blockId) && (H.blockId = e.BlockID.fromJSON(ne.blockId)), (0, m.isSet)(ne.timestamp) && (H.timestamp = (0, m.fromJsonTimestamp)(ne.timestamp)), (0, m.isSet)(ne.validatorAddress) && (H.validatorAddress = (0, m.bytesFromBase64)(ne.validatorAddress)), (0, m.isSet)(ne.validatorIndex) && (H.validatorIndex = Number(ne.validatorIndex)), (0, m.isSet)(ne.signature) && (H.signature = (0, m.bytesFromBase64)(ne.signature)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.type !== void 0 && (H.type = T(ne.type)), ne.height !== void 0 && (H.height = (ne.height || BigInt(0)).toString()), ne.round !== void 0 && (H.round = Math.round(ne.round)), ne.blockId !== void 0 && (H.blockId = ne.blockId ? e.BlockID.toJSON(ne.blockId) : void 0), ne.timestamp !== void 0 && (H.timestamp = (0, m.fromTimestamp)(ne.timestamp).toISOString()), ne.validatorAddress !== void 0 && (H.validatorAddress = (0, m.base64FromBytes)(ne.validatorAddress !== void 0 ? ne.validatorAddress : new Uint8Array())), ne.validatorIndex !== void 0 && (H.validatorIndex = Math.round(ne.validatorIndex)), ne.signature !== void 0 && (H.signature = (0, m.base64FromBytes)(ne.signature !== void 0 ? ne.signature : new Uint8Array())), H;
    },
    fromPartial(ne) {
      const H = F();
      return H.type = ne.type ?? 0, ne.height !== void 0 && ne.height !== null && (H.height = BigInt(ne.height.toString())), H.round = ne.round ?? 0, ne.blockId !== void 0 && ne.blockId !== null && (H.blockId = e.BlockID.fromPartial(ne.blockId)), ne.timestamp !== void 0 && ne.timestamp !== null && (H.timestamp = u.Timestamp.fromPartial(ne.timestamp)), H.validatorAddress = ne.validatorAddress ?? new Uint8Array(), H.validatorIndex = ne.validatorIndex ?? 0, H.signature = ne.signature ?? new Uint8Array(), H;
    }
  };
  function X() {
    return {
      height: BigInt(0),
      round: 0,
      blockId: e.BlockID.fromPartial({}),
      signatures: []
    };
  }
  e.Commit = {
    typeUrl: "/tendermint.types.Commit",
    encode(ne, H = d.BinaryWriter.create()) {
      ne.height !== BigInt(0) && H.uint32(8).int64(ne.height), ne.round !== 0 && H.uint32(16).int32(ne.round), ne.blockId !== void 0 && e.BlockID.encode(ne.blockId, H.uint32(26).fork()).ldelim();
      for (const C of ne.signatures)
        e.CommitSig.encode(C, H.uint32(34).fork()).ldelim();
      return H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = X();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.height = C.int64();
            break;
          case 2:
            P.round = C.int32();
            break;
          case 3:
            P.blockId = e.BlockID.decode(C, C.uint32());
            break;
          case 4:
            P.signatures.push(e.CommitSig.decode(C, C.uint32()));
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = X();
      return (0, m.isSet)(ne.height) && (H.height = BigInt(ne.height.toString())), (0, m.isSet)(ne.round) && (H.round = Number(ne.round)), (0, m.isSet)(ne.blockId) && (H.blockId = e.BlockID.fromJSON(ne.blockId)), Array.isArray(ne == null ? void 0 : ne.signatures) && (H.signatures = ne.signatures.map((C) => e.CommitSig.fromJSON(C))), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.height !== void 0 && (H.height = (ne.height || BigInt(0)).toString()), ne.round !== void 0 && (H.round = Math.round(ne.round)), ne.blockId !== void 0 && (H.blockId = ne.blockId ? e.BlockID.toJSON(ne.blockId) : void 0), ne.signatures ? H.signatures = ne.signatures.map((C) => C ? e.CommitSig.toJSON(C) : void 0) : H.signatures = [], H;
    },
    fromPartial(ne) {
      var C;
      const H = X();
      return ne.height !== void 0 && ne.height !== null && (H.height = BigInt(ne.height.toString())), H.round = ne.round ?? 0, ne.blockId !== void 0 && ne.blockId !== null && (H.blockId = e.BlockID.fromPartial(ne.blockId)), H.signatures = ((C = ne.signatures) == null ? void 0 : C.map((w) => e.CommitSig.fromPartial(w))) || [], H;
    }
  };
  function ee() {
    return {
      blockIdFlag: 0,
      validatorAddress: new Uint8Array(),
      timestamp: u.Timestamp.fromPartial({}),
      signature: new Uint8Array()
    };
  }
  e.CommitSig = {
    typeUrl: "/tendermint.types.CommitSig",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.blockIdFlag !== 0 && H.uint32(8).int32(ne.blockIdFlag), ne.validatorAddress.length !== 0 && H.uint32(18).bytes(ne.validatorAddress), ne.timestamp !== void 0 && u.Timestamp.encode(ne.timestamp, H.uint32(26).fork()).ldelim(), ne.signature.length !== 0 && H.uint32(34).bytes(ne.signature), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = ee();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.blockIdFlag = C.int32();
            break;
          case 2:
            P.validatorAddress = C.bytes();
            break;
          case 3:
            P.timestamp = u.Timestamp.decode(C, C.uint32());
            break;
          case 4:
            P.signature = C.bytes();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = ee();
      return (0, m.isSet)(ne.blockIdFlag) && (H.blockIdFlag = S(ne.blockIdFlag)), (0, m.isSet)(ne.validatorAddress) && (H.validatorAddress = (0, m.bytesFromBase64)(ne.validatorAddress)), (0, m.isSet)(ne.timestamp) && (H.timestamp = (0, m.fromJsonTimestamp)(ne.timestamp)), (0, m.isSet)(ne.signature) && (H.signature = (0, m.bytesFromBase64)(ne.signature)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.blockIdFlag !== void 0 && (H.blockIdFlag = $(ne.blockIdFlag)), ne.validatorAddress !== void 0 && (H.validatorAddress = (0, m.base64FromBytes)(ne.validatorAddress !== void 0 ? ne.validatorAddress : new Uint8Array())), ne.timestamp !== void 0 && (H.timestamp = (0, m.fromTimestamp)(ne.timestamp).toISOString()), ne.signature !== void 0 && (H.signature = (0, m.base64FromBytes)(ne.signature !== void 0 ? ne.signature : new Uint8Array())), H;
    },
    fromPartial(ne) {
      const H = ee();
      return H.blockIdFlag = ne.blockIdFlag ?? 0, H.validatorAddress = ne.validatorAddress ?? new Uint8Array(), ne.timestamp !== void 0 && ne.timestamp !== null && (H.timestamp = u.Timestamp.fromPartial(ne.timestamp)), H.signature = ne.signature ?? new Uint8Array(), H;
    }
  };
  function ue() {
    return {
      type: 0,
      height: BigInt(0),
      round: 0,
      polRound: 0,
      blockId: e.BlockID.fromPartial({}),
      timestamp: u.Timestamp.fromPartial({}),
      signature: new Uint8Array()
    };
  }
  e.Proposal = {
    typeUrl: "/tendermint.types.Proposal",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.type !== 0 && H.uint32(8).int32(ne.type), ne.height !== BigInt(0) && H.uint32(16).int64(ne.height), ne.round !== 0 && H.uint32(24).int32(ne.round), ne.polRound !== 0 && H.uint32(32).int32(ne.polRound), ne.blockId !== void 0 && e.BlockID.encode(ne.blockId, H.uint32(42).fork()).ldelim(), ne.timestamp !== void 0 && u.Timestamp.encode(ne.timestamp, H.uint32(50).fork()).ldelim(), ne.signature.length !== 0 && H.uint32(58).bytes(ne.signature), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = ue();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.type = C.int32();
            break;
          case 2:
            P.height = C.int64();
            break;
          case 3:
            P.round = C.int32();
            break;
          case 4:
            P.polRound = C.int32();
            break;
          case 5:
            P.blockId = e.BlockID.decode(C, C.uint32());
            break;
          case 6:
            P.timestamp = u.Timestamp.decode(C, C.uint32());
            break;
          case 7:
            P.signature = C.bytes();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = ue();
      return (0, m.isSet)(ne.type) && (H.type = O(ne.type)), (0, m.isSet)(ne.height) && (H.height = BigInt(ne.height.toString())), (0, m.isSet)(ne.round) && (H.round = Number(ne.round)), (0, m.isSet)(ne.polRound) && (H.polRound = Number(ne.polRound)), (0, m.isSet)(ne.blockId) && (H.blockId = e.BlockID.fromJSON(ne.blockId)), (0, m.isSet)(ne.timestamp) && (H.timestamp = (0, m.fromJsonTimestamp)(ne.timestamp)), (0, m.isSet)(ne.signature) && (H.signature = (0, m.bytesFromBase64)(ne.signature)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.type !== void 0 && (H.type = T(ne.type)), ne.height !== void 0 && (H.height = (ne.height || BigInt(0)).toString()), ne.round !== void 0 && (H.round = Math.round(ne.round)), ne.polRound !== void 0 && (H.polRound = Math.round(ne.polRound)), ne.blockId !== void 0 && (H.blockId = ne.blockId ? e.BlockID.toJSON(ne.blockId) : void 0), ne.timestamp !== void 0 && (H.timestamp = (0, m.fromTimestamp)(ne.timestamp).toISOString()), ne.signature !== void 0 && (H.signature = (0, m.base64FromBytes)(ne.signature !== void 0 ? ne.signature : new Uint8Array())), H;
    },
    fromPartial(ne) {
      const H = ue();
      return H.type = ne.type ?? 0, ne.height !== void 0 && ne.height !== null && (H.height = BigInt(ne.height.toString())), H.round = ne.round ?? 0, H.polRound = ne.polRound ?? 0, ne.blockId !== void 0 && ne.blockId !== null && (H.blockId = e.BlockID.fromPartial(ne.blockId)), ne.timestamp !== void 0 && ne.timestamp !== null && (H.timestamp = u.Timestamp.fromPartial(ne.timestamp)), H.signature = ne.signature ?? new Uint8Array(), H;
    }
  };
  function Q() {
    return {
      header: void 0,
      commit: void 0
    };
  }
  e.SignedHeader = {
    typeUrl: "/tendermint.types.SignedHeader",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.header !== void 0 && e.Header.encode(ne.header, H.uint32(10).fork()).ldelim(), ne.commit !== void 0 && e.Commit.encode(ne.commit, H.uint32(18).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = Q();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.header = e.Header.decode(C, C.uint32());
            break;
          case 2:
            P.commit = e.Commit.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = Q();
      return (0, m.isSet)(ne.header) && (H.header = e.Header.fromJSON(ne.header)), (0, m.isSet)(ne.commit) && (H.commit = e.Commit.fromJSON(ne.commit)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.header !== void 0 && (H.header = ne.header ? e.Header.toJSON(ne.header) : void 0), ne.commit !== void 0 && (H.commit = ne.commit ? e.Commit.toJSON(ne.commit) : void 0), H;
    },
    fromPartial(ne) {
      const H = Q();
      return ne.header !== void 0 && ne.header !== null && (H.header = e.Header.fromPartial(ne.header)), ne.commit !== void 0 && ne.commit !== null && (H.commit = e.Commit.fromPartial(ne.commit)), H;
    }
  };
  function Y() {
    return {
      signedHeader: void 0,
      validatorSet: void 0
    };
  }
  e.LightBlock = {
    typeUrl: "/tendermint.types.LightBlock",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.signedHeader !== void 0 && e.SignedHeader.encode(ne.signedHeader, H.uint32(10).fork()).ldelim(), ne.validatorSet !== void 0 && c.ValidatorSet.encode(ne.validatorSet, H.uint32(18).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = Y();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.signedHeader = e.SignedHeader.decode(C, C.uint32());
            break;
          case 2:
            P.validatorSet = c.ValidatorSet.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = Y();
      return (0, m.isSet)(ne.signedHeader) && (H.signedHeader = e.SignedHeader.fromJSON(ne.signedHeader)), (0, m.isSet)(ne.validatorSet) && (H.validatorSet = c.ValidatorSet.fromJSON(ne.validatorSet)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.signedHeader !== void 0 && (H.signedHeader = ne.signedHeader ? e.SignedHeader.toJSON(ne.signedHeader) : void 0), ne.validatorSet !== void 0 && (H.validatorSet = ne.validatorSet ? c.ValidatorSet.toJSON(ne.validatorSet) : void 0), H;
    },
    fromPartial(ne) {
      const H = Y();
      return ne.signedHeader !== void 0 && ne.signedHeader !== null && (H.signedHeader = e.SignedHeader.fromPartial(ne.signedHeader)), ne.validatorSet !== void 0 && ne.validatorSet !== null && (H.validatorSet = c.ValidatorSet.fromPartial(ne.validatorSet)), H;
    }
  };
  function pe() {
    return {
      blockId: e.BlockID.fromPartial({}),
      blockSize: BigInt(0),
      header: e.Header.fromPartial({}),
      numTxs: BigInt(0)
    };
  }
  e.BlockMeta = {
    typeUrl: "/tendermint.types.BlockMeta",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.blockId !== void 0 && e.BlockID.encode(ne.blockId, H.uint32(10).fork()).ldelim(), ne.blockSize !== BigInt(0) && H.uint32(16).int64(ne.blockSize), ne.header !== void 0 && e.Header.encode(ne.header, H.uint32(26).fork()).ldelim(), ne.numTxs !== BigInt(0) && H.uint32(32).int64(ne.numTxs), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = pe();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.blockId = e.BlockID.decode(C, C.uint32());
            break;
          case 2:
            P.blockSize = C.int64();
            break;
          case 3:
            P.header = e.Header.decode(C, C.uint32());
            break;
          case 4:
            P.numTxs = C.int64();
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = pe();
      return (0, m.isSet)(ne.blockId) && (H.blockId = e.BlockID.fromJSON(ne.blockId)), (0, m.isSet)(ne.blockSize) && (H.blockSize = BigInt(ne.blockSize.toString())), (0, m.isSet)(ne.header) && (H.header = e.Header.fromJSON(ne.header)), (0, m.isSet)(ne.numTxs) && (H.numTxs = BigInt(ne.numTxs.toString())), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.blockId !== void 0 && (H.blockId = ne.blockId ? e.BlockID.toJSON(ne.blockId) : void 0), ne.blockSize !== void 0 && (H.blockSize = (ne.blockSize || BigInt(0)).toString()), ne.header !== void 0 && (H.header = ne.header ? e.Header.toJSON(ne.header) : void 0), ne.numTxs !== void 0 && (H.numTxs = (ne.numTxs || BigInt(0)).toString()), H;
    },
    fromPartial(ne) {
      const H = pe();
      return ne.blockId !== void 0 && ne.blockId !== null && (H.blockId = e.BlockID.fromPartial(ne.blockId)), ne.blockSize !== void 0 && ne.blockSize !== null && (H.blockSize = BigInt(ne.blockSize.toString())), ne.header !== void 0 && ne.header !== null && (H.header = e.Header.fromPartial(ne.header)), ne.numTxs !== void 0 && ne.numTxs !== null && (H.numTxs = BigInt(ne.numTxs.toString())), H;
    }
  };
  function oe() {
    return {
      rootHash: new Uint8Array(),
      data: new Uint8Array(),
      proof: void 0
    };
  }
  e.TxProof = {
    typeUrl: "/tendermint.types.TxProof",
    encode(ne, H = d.BinaryWriter.create()) {
      return ne.rootHash.length !== 0 && H.uint32(10).bytes(ne.rootHash), ne.data.length !== 0 && H.uint32(18).bytes(ne.data), ne.proof !== void 0 && n.Proof.encode(ne.proof, H.uint32(26).fork()).ldelim(), H;
    },
    decode(ne, H) {
      const C = ne instanceof d.BinaryReader ? ne : new d.BinaryReader(ne);
      let w = H === void 0 ? C.len : C.pos + H;
      const P = oe();
      for (; C.pos < w; ) {
        const J = C.uint32();
        switch (J >>> 3) {
          case 1:
            P.rootHash = C.bytes();
            break;
          case 2:
            P.data = C.bytes();
            break;
          case 3:
            P.proof = n.Proof.decode(C, C.uint32());
            break;
          default:
            C.skipType(J & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(ne) {
      const H = oe();
      return (0, m.isSet)(ne.rootHash) && (H.rootHash = (0, m.bytesFromBase64)(ne.rootHash)), (0, m.isSet)(ne.data) && (H.data = (0, m.bytesFromBase64)(ne.data)), (0, m.isSet)(ne.proof) && (H.proof = n.Proof.fromJSON(ne.proof)), H;
    },
    toJSON(ne) {
      const H = {};
      return ne.rootHash !== void 0 && (H.rootHash = (0, m.base64FromBytes)(ne.rootHash !== void 0 ? ne.rootHash : new Uint8Array())), ne.data !== void 0 && (H.data = (0, m.base64FromBytes)(ne.data !== void 0 ? ne.data : new Uint8Array())), ne.proof !== void 0 && (H.proof = ne.proof ? n.Proof.toJSON(ne.proof) : void 0), H;
    },
    fromPartial(ne) {
      const H = oe();
      return H.rootHash = ne.rootHash ?? new Uint8Array(), H.data = ne.data ?? new Uint8Array(), ne.proof !== void 0 && ne.proof !== null && (H.proof = n.Proof.fromPartial(ne.proof)), H;
    }
  };
})(types$e);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Fraction = e.Header = e.Misbehaviour = e.ConsensusState = e.ClientState = e.protobufPackage = void 0;
  const n = duration$1, o = client$1, u = proofs, c = timestamp$1, d = commitment, m = types$e, v = validator$b, S = binary, $ = helpers;
  e.protobufPackage = "ibc.lightclients.tendermint.v1";
  function E() {
    return {
      chainId: "",
      trustLevel: e.Fraction.fromPartial({}),
      trustingPeriod: n.Duration.fromPartial({}),
      unbondingPeriod: n.Duration.fromPartial({}),
      maxClockDrift: n.Duration.fromPartial({}),
      frozenHeight: o.Height.fromPartial({}),
      latestHeight: o.Height.fromPartial({}),
      proofSpecs: [],
      upgradePath: [],
      allowUpdateAfterExpiry: !1,
      allowUpdateAfterMisbehaviour: !1
    };
  }
  e.ClientState = {
    typeUrl: "/ibc.lightclients.tendermint.v1.ClientState",
    encode(M, G = S.BinaryWriter.create()) {
      M.chainId !== "" && G.uint32(10).string(M.chainId), M.trustLevel !== void 0 && e.Fraction.encode(M.trustLevel, G.uint32(18).fork()).ldelim(), M.trustingPeriod !== void 0 && n.Duration.encode(M.trustingPeriod, G.uint32(26).fork()).ldelim(), M.unbondingPeriod !== void 0 && n.Duration.encode(M.unbondingPeriod, G.uint32(34).fork()).ldelim(), M.maxClockDrift !== void 0 && n.Duration.encode(M.maxClockDrift, G.uint32(42).fork()).ldelim(), M.frozenHeight !== void 0 && o.Height.encode(M.frozenHeight, G.uint32(50).fork()).ldelim(), M.latestHeight !== void 0 && o.Height.encode(M.latestHeight, G.uint32(58).fork()).ldelim();
      for (const k of M.proofSpecs)
        u.ProofSpec.encode(k, G.uint32(66).fork()).ldelim();
      for (const k of M.upgradePath)
        G.uint32(74).string(k);
      return M.allowUpdateAfterExpiry === !0 && G.uint32(80).bool(M.allowUpdateAfterExpiry), M.allowUpdateAfterMisbehaviour === !0 && G.uint32(88).bool(M.allowUpdateAfterMisbehaviour), G;
    },
    decode(M, G) {
      const k = M instanceof S.BinaryReader ? M : new S.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = E();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.chainId = k.string();
            break;
          case 2:
            X.trustLevel = e.Fraction.decode(k, k.uint32());
            break;
          case 3:
            X.trustingPeriod = n.Duration.decode(k, k.uint32());
            break;
          case 4:
            X.unbondingPeriod = n.Duration.decode(k, k.uint32());
            break;
          case 5:
            X.maxClockDrift = n.Duration.decode(k, k.uint32());
            break;
          case 6:
            X.frozenHeight = o.Height.decode(k, k.uint32());
            break;
          case 7:
            X.latestHeight = o.Height.decode(k, k.uint32());
            break;
          case 8:
            X.proofSpecs.push(u.ProofSpec.decode(k, k.uint32()));
            break;
          case 9:
            X.upgradePath.push(k.string());
            break;
          case 10:
            X.allowUpdateAfterExpiry = k.bool();
            break;
          case 11:
            X.allowUpdateAfterMisbehaviour = k.bool();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = E();
      return (0, $.isSet)(M.chainId) && (G.chainId = String(M.chainId)), (0, $.isSet)(M.trustLevel) && (G.trustLevel = e.Fraction.fromJSON(M.trustLevel)), (0, $.isSet)(M.trustingPeriod) && (G.trustingPeriod = n.Duration.fromJSON(M.trustingPeriod)), (0, $.isSet)(M.unbondingPeriod) && (G.unbondingPeriod = n.Duration.fromJSON(M.unbondingPeriod)), (0, $.isSet)(M.maxClockDrift) && (G.maxClockDrift = n.Duration.fromJSON(M.maxClockDrift)), (0, $.isSet)(M.frozenHeight) && (G.frozenHeight = o.Height.fromJSON(M.frozenHeight)), (0, $.isSet)(M.latestHeight) && (G.latestHeight = o.Height.fromJSON(M.latestHeight)), Array.isArray(M == null ? void 0 : M.proofSpecs) && (G.proofSpecs = M.proofSpecs.map((k) => u.ProofSpec.fromJSON(k))), Array.isArray(M == null ? void 0 : M.upgradePath) && (G.upgradePath = M.upgradePath.map((k) => String(k))), (0, $.isSet)(M.allowUpdateAfterExpiry) && (G.allowUpdateAfterExpiry = !!M.allowUpdateAfterExpiry), (0, $.isSet)(M.allowUpdateAfterMisbehaviour) && (G.allowUpdateAfterMisbehaviour = !!M.allowUpdateAfterMisbehaviour), G;
    },
    toJSON(M) {
      const G = {};
      return M.chainId !== void 0 && (G.chainId = M.chainId), M.trustLevel !== void 0 && (G.trustLevel = M.trustLevel ? e.Fraction.toJSON(M.trustLevel) : void 0), M.trustingPeriod !== void 0 && (G.trustingPeriod = M.trustingPeriod ? n.Duration.toJSON(M.trustingPeriod) : void 0), M.unbondingPeriod !== void 0 && (G.unbondingPeriod = M.unbondingPeriod ? n.Duration.toJSON(M.unbondingPeriod) : void 0), M.maxClockDrift !== void 0 && (G.maxClockDrift = M.maxClockDrift ? n.Duration.toJSON(M.maxClockDrift) : void 0), M.frozenHeight !== void 0 && (G.frozenHeight = M.frozenHeight ? o.Height.toJSON(M.frozenHeight) : void 0), M.latestHeight !== void 0 && (G.latestHeight = M.latestHeight ? o.Height.toJSON(M.latestHeight) : void 0), M.proofSpecs ? G.proofSpecs = M.proofSpecs.map((k) => k ? u.ProofSpec.toJSON(k) : void 0) : G.proofSpecs = [], M.upgradePath ? G.upgradePath = M.upgradePath.map((k) => k) : G.upgradePath = [], M.allowUpdateAfterExpiry !== void 0 && (G.allowUpdateAfterExpiry = M.allowUpdateAfterExpiry), M.allowUpdateAfterMisbehaviour !== void 0 && (G.allowUpdateAfterMisbehaviour = M.allowUpdateAfterMisbehaviour), G;
    },
    fromPartial(M) {
      var k, F;
      const G = E();
      return G.chainId = M.chainId ?? "", M.trustLevel !== void 0 && M.trustLevel !== null && (G.trustLevel = e.Fraction.fromPartial(M.trustLevel)), M.trustingPeriod !== void 0 && M.trustingPeriod !== null && (G.trustingPeriod = n.Duration.fromPartial(M.trustingPeriod)), M.unbondingPeriod !== void 0 && M.unbondingPeriod !== null && (G.unbondingPeriod = n.Duration.fromPartial(M.unbondingPeriod)), M.maxClockDrift !== void 0 && M.maxClockDrift !== null && (G.maxClockDrift = n.Duration.fromPartial(M.maxClockDrift)), M.frozenHeight !== void 0 && M.frozenHeight !== null && (G.frozenHeight = o.Height.fromPartial(M.frozenHeight)), M.latestHeight !== void 0 && M.latestHeight !== null && (G.latestHeight = o.Height.fromPartial(M.latestHeight)), G.proofSpecs = ((k = M.proofSpecs) == null ? void 0 : k.map((X) => u.ProofSpec.fromPartial(X))) || [], G.upgradePath = ((F = M.upgradePath) == null ? void 0 : F.map((X) => X)) || [], G.allowUpdateAfterExpiry = M.allowUpdateAfterExpiry ?? !1, G.allowUpdateAfterMisbehaviour = M.allowUpdateAfterMisbehaviour ?? !1, G;
    }
  };
  function O() {
    return {
      timestamp: c.Timestamp.fromPartial({}),
      root: d.MerkleRoot.fromPartial({}),
      nextValidatorsHash: new Uint8Array()
    };
  }
  e.ConsensusState = {
    typeUrl: "/ibc.lightclients.tendermint.v1.ConsensusState",
    encode(M, G = S.BinaryWriter.create()) {
      return M.timestamp !== void 0 && c.Timestamp.encode(M.timestamp, G.uint32(10).fork()).ldelim(), M.root !== void 0 && d.MerkleRoot.encode(M.root, G.uint32(18).fork()).ldelim(), M.nextValidatorsHash.length !== 0 && G.uint32(26).bytes(M.nextValidatorsHash), G;
    },
    decode(M, G) {
      const k = M instanceof S.BinaryReader ? M : new S.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = O();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.timestamp = c.Timestamp.decode(k, k.uint32());
            break;
          case 2:
            X.root = d.MerkleRoot.decode(k, k.uint32());
            break;
          case 3:
            X.nextValidatorsHash = k.bytes();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = O();
      return (0, $.isSet)(M.timestamp) && (G.timestamp = (0, $.fromJsonTimestamp)(M.timestamp)), (0, $.isSet)(M.root) && (G.root = d.MerkleRoot.fromJSON(M.root)), (0, $.isSet)(M.nextValidatorsHash) && (G.nextValidatorsHash = (0, $.bytesFromBase64)(M.nextValidatorsHash)), G;
    },
    toJSON(M) {
      const G = {};
      return M.timestamp !== void 0 && (G.timestamp = (0, $.fromTimestamp)(M.timestamp).toISOString()), M.root !== void 0 && (G.root = M.root ? d.MerkleRoot.toJSON(M.root) : void 0), M.nextValidatorsHash !== void 0 && (G.nextValidatorsHash = (0, $.base64FromBytes)(M.nextValidatorsHash !== void 0 ? M.nextValidatorsHash : new Uint8Array())), G;
    },
    fromPartial(M) {
      const G = O();
      return M.timestamp !== void 0 && M.timestamp !== null && (G.timestamp = c.Timestamp.fromPartial(M.timestamp)), M.root !== void 0 && M.root !== null && (G.root = d.MerkleRoot.fromPartial(M.root)), G.nextValidatorsHash = M.nextValidatorsHash ?? new Uint8Array(), G;
    }
  };
  function T() {
    return {
      clientId: "",
      header1: void 0,
      header2: void 0
    };
  }
  e.Misbehaviour = {
    typeUrl: "/ibc.lightclients.tendermint.v1.Misbehaviour",
    encode(M, G = S.BinaryWriter.create()) {
      return M.clientId !== "" && G.uint32(10).string(M.clientId), M.header1 !== void 0 && e.Header.encode(M.header1, G.uint32(18).fork()).ldelim(), M.header2 !== void 0 && e.Header.encode(M.header2, G.uint32(26).fork()).ldelim(), G;
    },
    decode(M, G) {
      const k = M instanceof S.BinaryReader ? M : new S.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = T();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.clientId = k.string();
            break;
          case 2:
            X.header1 = e.Header.decode(k, k.uint32());
            break;
          case 3:
            X.header2 = e.Header.decode(k, k.uint32());
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = T();
      return (0, $.isSet)(M.clientId) && (G.clientId = String(M.clientId)), (0, $.isSet)(M.header1) && (G.header1 = e.Header.fromJSON(M.header1)), (0, $.isSet)(M.header2) && (G.header2 = e.Header.fromJSON(M.header2)), G;
    },
    toJSON(M) {
      const G = {};
      return M.clientId !== void 0 && (G.clientId = M.clientId), M.header1 !== void 0 && (G.header1 = M.header1 ? e.Header.toJSON(M.header1) : void 0), M.header2 !== void 0 && (G.header2 = M.header2 ? e.Header.toJSON(M.header2) : void 0), G;
    },
    fromPartial(M) {
      const G = T();
      return G.clientId = M.clientId ?? "", M.header1 !== void 0 && M.header1 !== null && (G.header1 = e.Header.fromPartial(M.header1)), M.header2 !== void 0 && M.header2 !== null && (G.header2 = e.Header.fromPartial(M.header2)), G;
    }
  };
  function y() {
    return {
      signedHeader: void 0,
      validatorSet: void 0,
      trustedHeight: o.Height.fromPartial({}),
      trustedValidators: void 0
    };
  }
  e.Header = {
    typeUrl: "/ibc.lightclients.tendermint.v1.Header",
    encode(M, G = S.BinaryWriter.create()) {
      return M.signedHeader !== void 0 && m.SignedHeader.encode(M.signedHeader, G.uint32(10).fork()).ldelim(), M.validatorSet !== void 0 && v.ValidatorSet.encode(M.validatorSet, G.uint32(18).fork()).ldelim(), M.trustedHeight !== void 0 && o.Height.encode(M.trustedHeight, G.uint32(26).fork()).ldelim(), M.trustedValidators !== void 0 && v.ValidatorSet.encode(M.trustedValidators, G.uint32(34).fork()).ldelim(), G;
    },
    decode(M, G) {
      const k = M instanceof S.BinaryReader ? M : new S.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = y();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.signedHeader = m.SignedHeader.decode(k, k.uint32());
            break;
          case 2:
            X.validatorSet = v.ValidatorSet.decode(k, k.uint32());
            break;
          case 3:
            X.trustedHeight = o.Height.decode(k, k.uint32());
            break;
          case 4:
            X.trustedValidators = v.ValidatorSet.decode(k, k.uint32());
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = y();
      return (0, $.isSet)(M.signedHeader) && (G.signedHeader = m.SignedHeader.fromJSON(M.signedHeader)), (0, $.isSet)(M.validatorSet) && (G.validatorSet = v.ValidatorSet.fromJSON(M.validatorSet)), (0, $.isSet)(M.trustedHeight) && (G.trustedHeight = o.Height.fromJSON(M.trustedHeight)), (0, $.isSet)(M.trustedValidators) && (G.trustedValidators = v.ValidatorSet.fromJSON(M.trustedValidators)), G;
    },
    toJSON(M) {
      const G = {};
      return M.signedHeader !== void 0 && (G.signedHeader = M.signedHeader ? m.SignedHeader.toJSON(M.signedHeader) : void 0), M.validatorSet !== void 0 && (G.validatorSet = M.validatorSet ? v.ValidatorSet.toJSON(M.validatorSet) : void 0), M.trustedHeight !== void 0 && (G.trustedHeight = M.trustedHeight ? o.Height.toJSON(M.trustedHeight) : void 0), M.trustedValidators !== void 0 && (G.trustedValidators = M.trustedValidators ? v.ValidatorSet.toJSON(M.trustedValidators) : void 0), G;
    },
    fromPartial(M) {
      const G = y();
      return M.signedHeader !== void 0 && M.signedHeader !== null && (G.signedHeader = m.SignedHeader.fromPartial(M.signedHeader)), M.validatorSet !== void 0 && M.validatorSet !== null && (G.validatorSet = v.ValidatorSet.fromPartial(M.validatorSet)), M.trustedHeight !== void 0 && M.trustedHeight !== null && (G.trustedHeight = o.Height.fromPartial(M.trustedHeight)), M.trustedValidators !== void 0 && M.trustedValidators !== null && (G.trustedValidators = v.ValidatorSet.fromPartial(M.trustedValidators)), G;
    }
  };
  function V() {
    return {
      numerator: BigInt(0),
      denominator: BigInt(0)
    };
  }
  e.Fraction = {
    typeUrl: "/ibc.lightclients.tendermint.v1.Fraction",
    encode(M, G = S.BinaryWriter.create()) {
      return M.numerator !== BigInt(0) && G.uint32(8).uint64(M.numerator), M.denominator !== BigInt(0) && G.uint32(16).uint64(M.denominator), G;
    },
    decode(M, G) {
      const k = M instanceof S.BinaryReader ? M : new S.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = V();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.numerator = k.uint64();
            break;
          case 2:
            X.denominator = k.uint64();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = V();
      return (0, $.isSet)(M.numerator) && (G.numerator = BigInt(M.numerator.toString())), (0, $.isSet)(M.denominator) && (G.denominator = BigInt(M.denominator.toString())), G;
    },
    toJSON(M) {
      const G = {};
      return M.numerator !== void 0 && (G.numerator = (M.numerator || BigInt(0)).toString()), M.denominator !== void 0 && (G.denominator = (M.denominator || BigInt(0)).toString()), G;
    },
    fromPartial(M) {
      const G = V();
      return M.numerator !== void 0 && M.numerator !== null && (G.numerator = BigInt(M.numerator.toString())), M.denominator !== void 0 && M.denominator !== null && (G.denominator = BigInt(M.denominator.toString())), G;
    }
  };
})(tendermint$1);
Object.defineProperty(queries$g, "__esModule", { value: !0 });
queries$g.setupIbcExtension = void 0;
const encoding_1$19 = build$F, math_1$p = build$R, query_1$e = query$7, channel_1$1 = channel, query_2$1 = query$6, query_3$1 = query$5, query_4$1 = query$4, tendermint_1$1 = tendermint$1, queryclient_1$i = queryclient$3;
function decodeTendermintClientStateAny$1(e) {
  if ((e == null ? void 0 : e.typeUrl) !== "/ibc.lightclients.tendermint.v1.ClientState")
    throw new Error(`Unexpected client state type: ${e == null ? void 0 : e.typeUrl}`);
  return tendermint_1$1.ClientState.decode(e.value);
}
function decodeTendermintConsensusStateAny$1(e) {
  if ((e == null ? void 0 : e.typeUrl) !== "/ibc.lightclients.tendermint.v1.ConsensusState")
    throw new Error(`Unexpected client state type: ${e == null ? void 0 : e.typeUrl}`);
  return tendermint_1$1.ConsensusState.decode(e.value);
}
function setupIbcExtension$1(e) {
  const n = (0, queryclient_1$i.createProtobufRpcClient)(e), o = new query_2$1.QueryClientImpl(n), u = new query_3$1.QueryClientImpl(n), c = new query_4$1.QueryClientImpl(n), d = new query_1$e.QueryClientImpl(n);
  return {
    ibc: {
      channel: {
        channel: async (m, v) => o.Channel({
          portId: m,
          channelId: v
        }),
        channels: async (m) => o.Channels({
          pagination: (0, queryclient_1$i.createPagination)(m)
        }),
        allChannels: async () => {
          var $;
          const m = [];
          let v, S;
          do
            v = await o.Channels({
              pagination: (0, queryclient_1$i.createPagination)(S)
            }), m.push(...v.channels), S = ($ = v.pagination) == null ? void 0 : $.nextKey;
          while (S && S.length);
          return query_2$1.QueryChannelsResponse.fromPartial({
            channels: m,
            height: v.height
          });
        },
        connectionChannels: async (m, v) => o.ConnectionChannels({
          connection: m,
          pagination: (0, queryclient_1$i.createPagination)(v)
        }),
        allConnectionChannels: async (m) => {
          var E;
          const v = [];
          let S, $;
          do
            S = await o.ConnectionChannels({
              connection: m,
              pagination: (0, queryclient_1$i.createPagination)($)
            }), v.push(...S.channels), $ = (E = S.pagination) == null ? void 0 : E.nextKey;
          while ($ && $.length);
          return query_2$1.QueryConnectionChannelsResponse.fromPartial({
            channels: v,
            height: S.height
          });
        },
        clientState: async (m, v) => o.ChannelClientState({
          portId: m,
          channelId: v
        }),
        consensusState: async (m, v, S, $) => o.ChannelConsensusState({
          portId: m,
          channelId: v,
          revisionNumber: BigInt(S),
          revisionHeight: BigInt($)
        }),
        packetCommitment: async (m, v, S) => o.PacketCommitment({
          portId: m,
          channelId: v,
          sequence: (0, queryclient_1$i.longify)(S)
        }),
        packetCommitments: async (m, v, S) => o.PacketCommitments({
          channelId: v,
          portId: m,
          pagination: (0, queryclient_1$i.createPagination)(S)
        }),
        allPacketCommitments: async (m, v) => {
          var O;
          const S = [];
          let $, E;
          do
            $ = await o.PacketCommitments({
              channelId: v,
              portId: m,
              pagination: (0, queryclient_1$i.createPagination)(E)
            }), S.push(...$.commitments), E = (O = $.pagination) == null ? void 0 : O.nextKey;
          while (E && E.length);
          return query_2$1.QueryPacketCommitmentsResponse.fromPartial({
            commitments: S,
            height: $.height
          });
        },
        packetReceipt: async (m, v, S) => o.PacketReceipt({
          portId: m,
          channelId: v,
          sequence: (0, queryclient_1$i.longify)(S)
        }),
        packetAcknowledgement: async (m, v, S) => o.PacketAcknowledgement({
          portId: m,
          channelId: v,
          sequence: (0, queryclient_1$i.longify)(S)
        }),
        packetAcknowledgements: async (m, v, S) => {
          const $ = query_2$1.QueryPacketAcknowledgementsRequest.fromPartial({
            portId: m,
            channelId: v,
            pagination: (0, queryclient_1$i.createPagination)(S)
          });
          return o.PacketAcknowledgements($);
        },
        allPacketAcknowledgements: async (m, v) => {
          var O;
          const S = [];
          let $, E;
          do {
            const T = query_2$1.QueryPacketAcknowledgementsRequest.fromPartial({
              channelId: v,
              portId: m,
              pagination: (0, queryclient_1$i.createPagination)(E)
            });
            $ = await o.PacketAcknowledgements(T), S.push(...$.acknowledgements), E = (O = $.pagination) == null ? void 0 : O.nextKey;
          } while (E && E.length);
          return query_2$1.QueryPacketAcknowledgementsResponse.fromPartial({
            acknowledgements: S,
            height: $.height
          });
        },
        unreceivedPackets: async (m, v, S) => o.UnreceivedPackets({
          portId: m,
          channelId: v,
          packetCommitmentSequences: S.map(($) => BigInt($))
        }),
        unreceivedAcks: async (m, v, S) => o.UnreceivedAcks({
          portId: m,
          channelId: v,
          packetAckSequences: S.map(($) => BigInt($))
        }),
        nextSequenceReceive: async (m, v) => o.NextSequenceReceive({
          portId: m,
          channelId: v
        })
      },
      client: {
        state: async (m) => u.ClientState({ clientId: m }),
        states: async (m) => u.ClientStates({
          pagination: (0, queryclient_1$i.createPagination)(m)
        }),
        allStates: async () => {
          var $;
          const m = [];
          let v, S;
          do
            v = await u.ClientStates({
              pagination: (0, queryclient_1$i.createPagination)(S)
            }), m.push(...v.clientStates), S = ($ = v.pagination) == null ? void 0 : $.nextKey;
          while (S && S.length);
          return query_3$1.QueryClientStatesResponse.fromPartial({
            clientStates: m
          });
        },
        consensusState: async (m, v) => u.ConsensusState(query_3$1.QueryConsensusStateRequest.fromPartial({
          clientId: m,
          revisionHeight: v !== void 0 ? BigInt(v) : void 0,
          latestHeight: v === void 0
        })),
        consensusStates: async (m, v) => u.ConsensusStates({
          clientId: m,
          pagination: (0, queryclient_1$i.createPagination)(v)
        }),
        allConsensusStates: async (m) => {
          var E;
          const v = [];
          let S, $;
          do
            S = await u.ConsensusStates({
              clientId: m,
              pagination: (0, queryclient_1$i.createPagination)($)
            }), v.push(...S.consensusStates), $ = (E = S.pagination) == null ? void 0 : E.nextKey;
          while ($ && $.length);
          return query_3$1.QueryConsensusStatesResponse.fromPartial({
            consensusStates: v
          });
        },
        params: async () => u.ClientParams({}),
        stateTm: async (m) => {
          const v = await u.ClientState({ clientId: m });
          return decodeTendermintClientStateAny$1(v.clientState);
        },
        statesTm: async (m) => {
          const { clientStates: v } = await u.ClientStates({
            pagination: (0, queryclient_1$i.createPagination)(m)
          });
          return v.map(({ clientState: S }) => decodeTendermintClientStateAny$1(S));
        },
        allStatesTm: async () => {
          var $;
          const m = [];
          let v, S;
          do
            v = await u.ClientStates({
              pagination: (0, queryclient_1$i.createPagination)(S)
            }), m.push(...v.clientStates), S = ($ = v.pagination) == null ? void 0 : $.nextKey;
          while (S && S.length);
          return m.map(({ clientState: E }) => decodeTendermintClientStateAny$1(E));
        },
        consensusStateTm: async (m, v) => {
          const S = await u.ConsensusState(query_3$1.QueryConsensusStateRequest.fromPartial({
            clientId: m,
            revisionHeight: v == null ? void 0 : v.revisionHeight,
            revisionNumber: v == null ? void 0 : v.revisionNumber,
            latestHeight: v === void 0
          }));
          return decodeTendermintConsensusStateAny$1(S.consensusState);
        }
      },
      connection: {
        connection: async (m) => c.Connection({
          connectionId: m
        }),
        connections: async (m) => c.Connections({
          pagination: (0, queryclient_1$i.createPagination)(m)
        }),
        allConnections: async () => {
          var $;
          const m = [];
          let v, S;
          do
            v = await c.Connections({
              pagination: (0, queryclient_1$i.createPagination)(S)
            }), m.push(...v.connections), S = ($ = v.pagination) == null ? void 0 : $.nextKey;
          while (S && S.length);
          return query_4$1.QueryConnectionsResponse.fromPartial({
            connections: m,
            height: v.height
          });
        },
        clientConnections: async (m) => c.ClientConnections({
          clientId: m
        }),
        clientState: async (m) => c.ConnectionClientState({
          connectionId: m
        }),
        consensusState: async (m, v) => c.ConnectionConsensusState(query_4$1.QueryConnectionConsensusStateRequest.fromPartial({
          connectionId: m,
          revisionHeight: BigInt(v)
        }))
      },
      transfer: {
        denomTrace: async (m) => d.DenomTrace({ hash: m }),
        denomTraces: async (m) => d.DenomTraces({
          pagination: (0, queryclient_1$i.createPagination)(m)
        }),
        allDenomTraces: async () => {
          var $;
          const m = [];
          let v, S;
          do
            v = await d.DenomTraces({
              pagination: (0, queryclient_1$i.createPagination)(S)
            }), m.push(...v.denomTraces), S = ($ = v.pagination) == null ? void 0 : $.nextKey;
          while (S && S.length);
          return query_1$e.QueryDenomTracesResponse.fromPartial({
            denomTraces: m
          });
        },
        params: async () => d.Params({})
      },
      verified: {
        channel: {
          channel: async (m, v) => {
            const S = (0, encoding_1$19.toAscii)(`channelEnds/ports/${m}/channels/${v}`), { value: $ } = await e.queryStoreVerified("ibc", S);
            return $.length ? channel_1$1.Channel.decode($) : null;
          },
          packetCommitment: async (m, v, S) => {
            const $ = (0, encoding_1$19.toAscii)(`commitments/ports/${m}/channels/${v}/packets/${S}`), { value: E } = await e.queryStoreVerified("ibc", $);
            return E;
          },
          packetAcknowledgement: async (m, v, S) => {
            const $ = (0, encoding_1$19.toAscii)(`acks/ports/${m}/channels/${v}/acknowledgements/${S}`), { value: E } = await e.queryStoreVerified("ibc", $);
            return E;
          },
          nextSequenceReceive: async (m, v) => {
            const S = (0, encoding_1$19.toAscii)(`seqAcks/ports/${m}/channels/${v}/nextSequenceAck`), { value: $ } = await e.queryStoreVerified("ibc", S);
            return $.length ? math_1$p.Uint64.fromBytes($).toNumber() : null;
          }
        }
      }
    }
  };
}
queries$g.setupIbcExtension = setupIbcExtension$1;
var queries$f = {}, query$3 = {}, mint = {};
Object.defineProperty(mint, "__esModule", { value: !0 });
mint.Params = mint.Minter = mint.protobufPackage = void 0;
const binary_1$2 = binary, helpers_1$2 = helpers;
mint.protobufPackage = "cosmos.mint.v1beta1";
function createBaseMinter$1() {
  return {
    inflation: "",
    annualProvisions: ""
  };
}
mint.Minter = {
  typeUrl: "/cosmos.mint.v1beta1.Minter",
  encode(e, n = binary_1$2.BinaryWriter.create()) {
    return e.inflation !== "" && n.uint32(10).string(e.inflation), e.annualProvisions !== "" && n.uint32(18).string(e.annualProvisions), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$2.BinaryReader ? e : new binary_1$2.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMinter$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.inflation = o.string();
          break;
        case 2:
          c.annualProvisions = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseMinter$1();
    return (0, helpers_1$2.isSet)(e.inflation) && (n.inflation = String(e.inflation)), (0, helpers_1$2.isSet)(e.annualProvisions) && (n.annualProvisions = String(e.annualProvisions)), n;
  },
  toJSON(e) {
    const n = {};
    return e.inflation !== void 0 && (n.inflation = e.inflation), e.annualProvisions !== void 0 && (n.annualProvisions = e.annualProvisions), n;
  },
  fromPartial(e) {
    const n = createBaseMinter$1();
    return n.inflation = e.inflation ?? "", n.annualProvisions = e.annualProvisions ?? "", n;
  }
};
function createBaseParams$o() {
  return {
    mintDenom: "",
    inflationRateChange: "",
    inflationMax: "",
    inflationMin: "",
    goalBonded: "",
    blocksPerYear: BigInt(0)
  };
}
mint.Params = {
  typeUrl: "/cosmos.mint.v1beta1.Params",
  encode(e, n = binary_1$2.BinaryWriter.create()) {
    return e.mintDenom !== "" && n.uint32(10).string(e.mintDenom), e.inflationRateChange !== "" && n.uint32(18).string(e.inflationRateChange), e.inflationMax !== "" && n.uint32(26).string(e.inflationMax), e.inflationMin !== "" && n.uint32(34).string(e.inflationMin), e.goalBonded !== "" && n.uint32(42).string(e.goalBonded), e.blocksPerYear !== BigInt(0) && n.uint32(48).uint64(e.blocksPerYear), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$2.BinaryReader ? e : new binary_1$2.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$o();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.mintDenom = o.string();
          break;
        case 2:
          c.inflationRateChange = o.string();
          break;
        case 3:
          c.inflationMax = o.string();
          break;
        case 4:
          c.inflationMin = o.string();
          break;
        case 5:
          c.goalBonded = o.string();
          break;
        case 6:
          c.blocksPerYear = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseParams$o();
    return (0, helpers_1$2.isSet)(e.mintDenom) && (n.mintDenom = String(e.mintDenom)), (0, helpers_1$2.isSet)(e.inflationRateChange) && (n.inflationRateChange = String(e.inflationRateChange)), (0, helpers_1$2.isSet)(e.inflationMax) && (n.inflationMax = String(e.inflationMax)), (0, helpers_1$2.isSet)(e.inflationMin) && (n.inflationMin = String(e.inflationMin)), (0, helpers_1$2.isSet)(e.goalBonded) && (n.goalBonded = String(e.goalBonded)), (0, helpers_1$2.isSet)(e.blocksPerYear) && (n.blocksPerYear = BigInt(e.blocksPerYear.toString())), n;
  },
  toJSON(e) {
    const n = {};
    return e.mintDenom !== void 0 && (n.mintDenom = e.mintDenom), e.inflationRateChange !== void 0 && (n.inflationRateChange = e.inflationRateChange), e.inflationMax !== void 0 && (n.inflationMax = e.inflationMax), e.inflationMin !== void 0 && (n.inflationMin = e.inflationMin), e.goalBonded !== void 0 && (n.goalBonded = e.goalBonded), e.blocksPerYear !== void 0 && (n.blocksPerYear = (e.blocksPerYear || BigInt(0)).toString()), n;
  },
  fromPartial(e) {
    const n = createBaseParams$o();
    return n.mintDenom = e.mintDenom ?? "", n.inflationRateChange = e.inflationRateChange ?? "", n.inflationMax = e.inflationMax ?? "", n.inflationMin = e.inflationMin ?? "", n.goalBonded = e.goalBonded ?? "", e.blocksPerYear !== void 0 && e.blocksPerYear !== null && (n.blocksPerYear = BigInt(e.blocksPerYear.toString())), n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryAnnualProvisionsResponse = e.QueryAnnualProvisionsRequest = e.QueryInflationResponse = e.QueryInflationRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.protobufPackage = void 0;
  const n = mint, o = binary, u = helpers;
  e.protobufPackage = "cosmos.mint.v1beta1";
  function c() {
    return {};
  }
  e.QueryParamsRequest = {
    typeUrl: "/cosmos.mint.v1beta1.QueryParamsRequest",
    encode(O, T = o.BinaryWriter.create()) {
      return T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = c();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      return c();
    },
    toJSON(O) {
      return {};
    },
    fromPartial(O) {
      return c();
    }
  };
  function d() {
    return {
      params: n.Params.fromPartial({})
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/cosmos.mint.v1beta1.QueryParamsResponse",
    encode(O, T = o.BinaryWriter.create()) {
      return O.params !== void 0 && n.Params.encode(O.params, T.uint32(10).fork()).ldelim(), T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = d();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.params = n.Params.decode(y, y.uint32());
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = d();
      return (0, u.isSet)(O.params) && (T.params = n.Params.fromJSON(O.params)), T;
    },
    toJSON(O) {
      const T = {};
      return O.params !== void 0 && (T.params = O.params ? n.Params.toJSON(O.params) : void 0), T;
    },
    fromPartial(O) {
      const T = d();
      return O.params !== void 0 && O.params !== null && (T.params = n.Params.fromPartial(O.params)), T;
    }
  };
  function m() {
    return {};
  }
  e.QueryInflationRequest = {
    typeUrl: "/cosmos.mint.v1beta1.QueryInflationRequest",
    encode(O, T = o.BinaryWriter.create()) {
      return T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = m();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      return m();
    },
    toJSON(O) {
      return {};
    },
    fromPartial(O) {
      return m();
    }
  };
  function v() {
    return {
      inflation: new Uint8Array()
    };
  }
  e.QueryInflationResponse = {
    typeUrl: "/cosmos.mint.v1beta1.QueryInflationResponse",
    encode(O, T = o.BinaryWriter.create()) {
      return O.inflation.length !== 0 && T.uint32(10).bytes(O.inflation), T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = v();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.inflation = y.bytes();
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = v();
      return (0, u.isSet)(O.inflation) && (T.inflation = (0, u.bytesFromBase64)(O.inflation)), T;
    },
    toJSON(O) {
      const T = {};
      return O.inflation !== void 0 && (T.inflation = (0, u.base64FromBytes)(O.inflation !== void 0 ? O.inflation : new Uint8Array())), T;
    },
    fromPartial(O) {
      const T = v();
      return T.inflation = O.inflation ?? new Uint8Array(), T;
    }
  };
  function S() {
    return {};
  }
  e.QueryAnnualProvisionsRequest = {
    typeUrl: "/cosmos.mint.v1beta1.QueryAnnualProvisionsRequest",
    encode(O, T = o.BinaryWriter.create()) {
      return T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = S();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      return S();
    },
    toJSON(O) {
      return {};
    },
    fromPartial(O) {
      return S();
    }
  };
  function $() {
    return {
      annualProvisions: new Uint8Array()
    };
  }
  e.QueryAnnualProvisionsResponse = {
    typeUrl: "/cosmos.mint.v1beta1.QueryAnnualProvisionsResponse",
    encode(O, T = o.BinaryWriter.create()) {
      return O.annualProvisions.length !== 0 && T.uint32(10).bytes(O.annualProvisions), T;
    },
    decode(O, T) {
      const y = O instanceof o.BinaryReader ? O : new o.BinaryReader(O);
      let V = T === void 0 ? y.len : y.pos + T;
      const M = $();
      for (; y.pos < V; ) {
        const G = y.uint32();
        switch (G >>> 3) {
          case 1:
            M.annualProvisions = y.bytes();
            break;
          default:
            y.skipType(G & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(O) {
      const T = $();
      return (0, u.isSet)(O.annualProvisions) && (T.annualProvisions = (0, u.bytesFromBase64)(O.annualProvisions)), T;
    },
    toJSON(O) {
      const T = {};
      return O.annualProvisions !== void 0 && (T.annualProvisions = (0, u.base64FromBytes)(O.annualProvisions !== void 0 ? O.annualProvisions : new Uint8Array())), T;
    },
    fromPartial(O) {
      const T = $();
      return T.annualProvisions = O.annualProvisions ?? new Uint8Array(), T;
    }
  };
  class E {
    constructor(T) {
      this.rpc = T, this.Params = this.Params.bind(this), this.Inflation = this.Inflation.bind(this), this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
    Params(T = {}) {
      const y = e.QueryParamsRequest.encode(T).finish();
      return this.rpc.request("cosmos.mint.v1beta1.Query", "Params", y).then((M) => e.QueryParamsResponse.decode(new o.BinaryReader(M)));
    }
    Inflation(T = {}) {
      const y = e.QueryInflationRequest.encode(T).finish();
      return this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", y).then((M) => e.QueryInflationResponse.decode(new o.BinaryReader(M)));
    }
    AnnualProvisions(T = {}) {
      const y = e.QueryAnnualProvisionsRequest.encode(T).finish();
      return this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", y).then((M) => e.QueryAnnualProvisionsResponse.decode(new o.BinaryReader(M)));
    }
  }
  e.QueryClientImpl = E;
})(query$3);
Object.defineProperty(queries$f, "__esModule", { value: !0 });
queries$f.setupMintExtension = void 0;
const utils_1$S = build$G, query_1$d = query$3, queryclient_1$h = queryclient$3;
function setupMintExtension$1(e) {
  const n = (0, queryclient_1$h.createProtobufRpcClient)(e), o = new query_1$d.QueryClientImpl(n);
  return {
    mint: {
      params: async () => {
        const { params: u } = await o.Params({});
        return (0, utils_1$S.assert)(u), {
          blocksPerYear: u.blocksPerYear,
          goalBonded: (0, queryclient_1$h.decodeCosmosSdkDecFromProto)(u.goalBonded),
          inflationMin: (0, queryclient_1$h.decodeCosmosSdkDecFromProto)(u.inflationMin),
          inflationMax: (0, queryclient_1$h.decodeCosmosSdkDecFromProto)(u.inflationMax),
          inflationRateChange: (0, queryclient_1$h.decodeCosmosSdkDecFromProto)(u.inflationRateChange),
          mintDenom: u.mintDenom
        };
      },
      inflation: async () => {
        const { inflation: u } = await o.Inflation({});
        return (0, queryclient_1$h.decodeCosmosSdkDecFromProto)(u);
      },
      annualProvisions: async () => {
        const { annualProvisions: u } = await o.AnnualProvisions({});
        return (0, queryclient_1$h.decodeCosmosSdkDecFromProto)(u);
      }
    }
  };
}
queries$f.setupMintExtension = setupMintExtension$1;
var aminomessages$e = {};
Object.defineProperty(aminomessages$e, "__esModule", { value: !0 });
aminomessages$e.createSlashingAminoConverters = aminomessages$e.isAminoMsgUnjail = void 0;
function isAminoMsgUnjail$1(e) {
  return e.type === "cosmos-sdk/MsgUnjail";
}
aminomessages$e.isAminoMsgUnjail = isAminoMsgUnjail$1;
function createSlashingAminoConverters$1() {
  throw new Error("Not implemented");
}
aminomessages$e.createSlashingAminoConverters = createSlashingAminoConverters$1;
var queries$e = {}, query$2 = {}, slashing = {};
Object.defineProperty(slashing, "__esModule", { value: !0 });
slashing.Params = slashing.ValidatorSigningInfo = slashing.protobufPackage = void 0;
const timestamp_1 = timestamp$1, duration_1 = duration$1, binary_1$1 = binary, helpers_1$1 = helpers;
slashing.protobufPackage = "cosmos.slashing.v1beta1";
function createBaseValidatorSigningInfo() {
  return {
    address: "",
    startHeight: BigInt(0),
    indexOffset: BigInt(0),
    jailedUntil: timestamp_1.Timestamp.fromPartial({}),
    tombstoned: !1,
    missedBlocksCounter: BigInt(0)
  };
}
slashing.ValidatorSigningInfo = {
  typeUrl: "/cosmos.slashing.v1beta1.ValidatorSigningInfo",
  encode(e, n = binary_1$1.BinaryWriter.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.startHeight !== BigInt(0) && n.uint32(16).int64(e.startHeight), e.indexOffset !== BigInt(0) && n.uint32(24).int64(e.indexOffset), e.jailedUntil !== void 0 && timestamp_1.Timestamp.encode(e.jailedUntil, n.uint32(34).fork()).ldelim(), e.tombstoned === !0 && n.uint32(40).bool(e.tombstoned), e.missedBlocksCounter !== BigInt(0) && n.uint32(48).int64(e.missedBlocksCounter), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$1.BinaryReader ? e : new binary_1$1.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorSigningInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.startHeight = o.int64();
          break;
        case 3:
          c.indexOffset = o.int64();
          break;
        case 4:
          c.jailedUntil = timestamp_1.Timestamp.decode(o, o.uint32());
          break;
        case 5:
          c.tombstoned = o.bool();
          break;
        case 6:
          c.missedBlocksCounter = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseValidatorSigningInfo();
    return (0, helpers_1$1.isSet)(e.address) && (n.address = String(e.address)), (0, helpers_1$1.isSet)(e.startHeight) && (n.startHeight = BigInt(e.startHeight.toString())), (0, helpers_1$1.isSet)(e.indexOffset) && (n.indexOffset = BigInt(e.indexOffset.toString())), (0, helpers_1$1.isSet)(e.jailedUntil) && (n.jailedUntil = (0, helpers_1$1.fromJsonTimestamp)(e.jailedUntil)), (0, helpers_1$1.isSet)(e.tombstoned) && (n.tombstoned = !!e.tombstoned), (0, helpers_1$1.isSet)(e.missedBlocksCounter) && (n.missedBlocksCounter = BigInt(e.missedBlocksCounter.toString())), n;
  },
  toJSON(e) {
    const n = {};
    return e.address !== void 0 && (n.address = e.address), e.startHeight !== void 0 && (n.startHeight = (e.startHeight || BigInt(0)).toString()), e.indexOffset !== void 0 && (n.indexOffset = (e.indexOffset || BigInt(0)).toString()), e.jailedUntil !== void 0 && (n.jailedUntil = (0, helpers_1$1.fromTimestamp)(e.jailedUntil).toISOString()), e.tombstoned !== void 0 && (n.tombstoned = e.tombstoned), e.missedBlocksCounter !== void 0 && (n.missedBlocksCounter = (e.missedBlocksCounter || BigInt(0)).toString()), n;
  },
  fromPartial(e) {
    const n = createBaseValidatorSigningInfo();
    return n.address = e.address ?? "", e.startHeight !== void 0 && e.startHeight !== null && (n.startHeight = BigInt(e.startHeight.toString())), e.indexOffset !== void 0 && e.indexOffset !== null && (n.indexOffset = BigInt(e.indexOffset.toString())), e.jailedUntil !== void 0 && e.jailedUntil !== null && (n.jailedUntil = timestamp_1.Timestamp.fromPartial(e.jailedUntil)), n.tombstoned = e.tombstoned ?? !1, e.missedBlocksCounter !== void 0 && e.missedBlocksCounter !== null && (n.missedBlocksCounter = BigInt(e.missedBlocksCounter.toString())), n;
  }
};
function createBaseParams$n() {
  return {
    signedBlocksWindow: BigInt(0),
    minSignedPerWindow: new Uint8Array(),
    downtimeJailDuration: duration_1.Duration.fromPartial({}),
    slashFractionDoubleSign: new Uint8Array(),
    slashFractionDowntime: new Uint8Array()
  };
}
slashing.Params = {
  typeUrl: "/cosmos.slashing.v1beta1.Params",
  encode(e, n = binary_1$1.BinaryWriter.create()) {
    return e.signedBlocksWindow !== BigInt(0) && n.uint32(8).int64(e.signedBlocksWindow), e.minSignedPerWindow.length !== 0 && n.uint32(18).bytes(e.minSignedPerWindow), e.downtimeJailDuration !== void 0 && duration_1.Duration.encode(e.downtimeJailDuration, n.uint32(26).fork()).ldelim(), e.slashFractionDoubleSign.length !== 0 && n.uint32(34).bytes(e.slashFractionDoubleSign), e.slashFractionDowntime.length !== 0 && n.uint32(42).bytes(e.slashFractionDowntime), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1$1.BinaryReader ? e : new binary_1$1.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$n();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signedBlocksWindow = o.int64();
          break;
        case 2:
          c.minSignedPerWindow = o.bytes();
          break;
        case 3:
          c.downtimeJailDuration = duration_1.Duration.decode(o, o.uint32());
          break;
        case 4:
          c.slashFractionDoubleSign = o.bytes();
          break;
        case 5:
          c.slashFractionDowntime = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseParams$n();
    return (0, helpers_1$1.isSet)(e.signedBlocksWindow) && (n.signedBlocksWindow = BigInt(e.signedBlocksWindow.toString())), (0, helpers_1$1.isSet)(e.minSignedPerWindow) && (n.minSignedPerWindow = (0, helpers_1$1.bytesFromBase64)(e.minSignedPerWindow)), (0, helpers_1$1.isSet)(e.downtimeJailDuration) && (n.downtimeJailDuration = duration_1.Duration.fromJSON(e.downtimeJailDuration)), (0, helpers_1$1.isSet)(e.slashFractionDoubleSign) && (n.slashFractionDoubleSign = (0, helpers_1$1.bytesFromBase64)(e.slashFractionDoubleSign)), (0, helpers_1$1.isSet)(e.slashFractionDowntime) && (n.slashFractionDowntime = (0, helpers_1$1.bytesFromBase64)(e.slashFractionDowntime)), n;
  },
  toJSON(e) {
    const n = {};
    return e.signedBlocksWindow !== void 0 && (n.signedBlocksWindow = (e.signedBlocksWindow || BigInt(0)).toString()), e.minSignedPerWindow !== void 0 && (n.minSignedPerWindow = (0, helpers_1$1.base64FromBytes)(e.minSignedPerWindow !== void 0 ? e.minSignedPerWindow : new Uint8Array())), e.downtimeJailDuration !== void 0 && (n.downtimeJailDuration = e.downtimeJailDuration ? duration_1.Duration.toJSON(e.downtimeJailDuration) : void 0), e.slashFractionDoubleSign !== void 0 && (n.slashFractionDoubleSign = (0, helpers_1$1.base64FromBytes)(e.slashFractionDoubleSign !== void 0 ? e.slashFractionDoubleSign : new Uint8Array())), e.slashFractionDowntime !== void 0 && (n.slashFractionDowntime = (0, helpers_1$1.base64FromBytes)(e.slashFractionDowntime !== void 0 ? e.slashFractionDowntime : new Uint8Array())), n;
  },
  fromPartial(e) {
    const n = createBaseParams$n();
    return e.signedBlocksWindow !== void 0 && e.signedBlocksWindow !== null && (n.signedBlocksWindow = BigInt(e.signedBlocksWindow.toString())), n.minSignedPerWindow = e.minSignedPerWindow ?? new Uint8Array(), e.downtimeJailDuration !== void 0 && e.downtimeJailDuration !== null && (n.downtimeJailDuration = duration_1.Duration.fromPartial(e.downtimeJailDuration)), n.slashFractionDoubleSign = e.slashFractionDoubleSign ?? new Uint8Array(), n.slashFractionDowntime = e.slashFractionDowntime ?? new Uint8Array(), n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QuerySigningInfosResponse = e.QuerySigningInfosRequest = e.QuerySigningInfoResponse = e.QuerySigningInfoRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.protobufPackage = void 0;
  const n = pagination, o = slashing, u = binary, c = helpers;
  e.protobufPackage = "cosmos.slashing.v1beta1";
  function d() {
    return {};
  }
  e.QueryParamsRequest = {
    typeUrl: "/cosmos.slashing.v1beta1.QueryParamsRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = d();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      return d();
    },
    toJSON(T) {
      return {};
    },
    fromPartial(T) {
      return d();
    }
  };
  function m() {
    return {
      params: o.Params.fromPartial({})
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/cosmos.slashing.v1beta1.QueryParamsResponse",
    encode(T, y = u.BinaryWriter.create()) {
      return T.params !== void 0 && o.Params.encode(T.params, y.uint32(10).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = m();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.params = o.Params.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = m();
      return (0, c.isSet)(T.params) && (y.params = o.Params.fromJSON(T.params)), y;
    },
    toJSON(T) {
      const y = {};
      return T.params !== void 0 && (y.params = T.params ? o.Params.toJSON(T.params) : void 0), y;
    },
    fromPartial(T) {
      const y = m();
      return T.params !== void 0 && T.params !== null && (y.params = o.Params.fromPartial(T.params)), y;
    }
  };
  function v() {
    return {
      consAddress: ""
    };
  }
  e.QuerySigningInfoRequest = {
    typeUrl: "/cosmos.slashing.v1beta1.QuerySigningInfoRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return T.consAddress !== "" && y.uint32(10).string(T.consAddress), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = v();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.consAddress = V.string();
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = v();
      return (0, c.isSet)(T.consAddress) && (y.consAddress = String(T.consAddress)), y;
    },
    toJSON(T) {
      const y = {};
      return T.consAddress !== void 0 && (y.consAddress = T.consAddress), y;
    },
    fromPartial(T) {
      const y = v();
      return y.consAddress = T.consAddress ?? "", y;
    }
  };
  function S() {
    return {
      valSigningInfo: o.ValidatorSigningInfo.fromPartial({})
    };
  }
  e.QuerySigningInfoResponse = {
    typeUrl: "/cosmos.slashing.v1beta1.QuerySigningInfoResponse",
    encode(T, y = u.BinaryWriter.create()) {
      return T.valSigningInfo !== void 0 && o.ValidatorSigningInfo.encode(T.valSigningInfo, y.uint32(10).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = S();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.valSigningInfo = o.ValidatorSigningInfo.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = S();
      return (0, c.isSet)(T.valSigningInfo) && (y.valSigningInfo = o.ValidatorSigningInfo.fromJSON(T.valSigningInfo)), y;
    },
    toJSON(T) {
      const y = {};
      return T.valSigningInfo !== void 0 && (y.valSigningInfo = T.valSigningInfo ? o.ValidatorSigningInfo.toJSON(T.valSigningInfo) : void 0), y;
    },
    fromPartial(T) {
      const y = S();
      return T.valSigningInfo !== void 0 && T.valSigningInfo !== null && (y.valSigningInfo = o.ValidatorSigningInfo.fromPartial(T.valSigningInfo)), y;
    }
  };
  function $() {
    return {
      pagination: void 0
    };
  }
  e.QuerySigningInfosRequest = {
    typeUrl: "/cosmos.slashing.v1beta1.QuerySigningInfosRequest",
    encode(T, y = u.BinaryWriter.create()) {
      return T.pagination !== void 0 && n.PageRequest.encode(T.pagination, y.uint32(10).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = $();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.pagination = n.PageRequest.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = $();
      return (0, c.isSet)(T.pagination) && (y.pagination = n.PageRequest.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageRequest.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      const y = $();
      return T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageRequest.fromPartial(T.pagination)), y;
    }
  };
  function E() {
    return {
      info: [],
      pagination: void 0
    };
  }
  e.QuerySigningInfosResponse = {
    typeUrl: "/cosmos.slashing.v1beta1.QuerySigningInfosResponse",
    encode(T, y = u.BinaryWriter.create()) {
      for (const V of T.info)
        o.ValidatorSigningInfo.encode(V, y.uint32(10).fork()).ldelim();
      return T.pagination !== void 0 && n.PageResponse.encode(T.pagination, y.uint32(18).fork()).ldelim(), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = E();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.info.push(o.ValidatorSigningInfo.decode(V, V.uint32()));
            break;
          case 2:
            G.pagination = n.PageResponse.decode(V, V.uint32());
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = E();
      return Array.isArray(T == null ? void 0 : T.info) && (y.info = T.info.map((V) => o.ValidatorSigningInfo.fromJSON(V))), (0, c.isSet)(T.pagination) && (y.pagination = n.PageResponse.fromJSON(T.pagination)), y;
    },
    toJSON(T) {
      const y = {};
      return T.info ? y.info = T.info.map((V) => V ? o.ValidatorSigningInfo.toJSON(V) : void 0) : y.info = [], T.pagination !== void 0 && (y.pagination = T.pagination ? n.PageResponse.toJSON(T.pagination) : void 0), y;
    },
    fromPartial(T) {
      var V;
      const y = E();
      return y.info = ((V = T.info) == null ? void 0 : V.map((M) => o.ValidatorSigningInfo.fromPartial(M))) || [], T.pagination !== void 0 && T.pagination !== null && (y.pagination = n.PageResponse.fromPartial(T.pagination)), y;
    }
  };
  class O {
    constructor(y) {
      this.rpc = y, this.Params = this.Params.bind(this), this.SigningInfo = this.SigningInfo.bind(this), this.SigningInfos = this.SigningInfos.bind(this);
    }
    Params(y = {}) {
      const V = e.QueryParamsRequest.encode(y).finish();
      return this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", V).then((G) => e.QueryParamsResponse.decode(new u.BinaryReader(G)));
    }
    SigningInfo(y) {
      const V = e.QuerySigningInfoRequest.encode(y).finish();
      return this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", V).then((G) => e.QuerySigningInfoResponse.decode(new u.BinaryReader(G)));
    }
    SigningInfos(y = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const V = e.QuerySigningInfosRequest.encode(y).finish();
      return this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", V).then((G) => e.QuerySigningInfosResponse.decode(new u.BinaryReader(G)));
    }
  }
  e.QueryClientImpl = O;
})(query$2);
Object.defineProperty(queries$e, "__esModule", { value: !0 });
queries$e.setupSlashingExtension = void 0;
const query_1$c = query$2, queryclient_1$g = queryclient$3;
function setupSlashingExtension$1(e) {
  const n = (0, queryclient_1$g.createProtobufRpcClient)(e), o = new query_1$c.QueryClientImpl(n);
  return {
    slashing: {
      signingInfo: async (u) => await o.SigningInfo({
        consAddress: u
      }),
      signingInfos: async (u) => await o.SigningInfos({
        pagination: (0, queryclient_1$g.createPagination)(u)
      }),
      params: async () => await o.Params({})
    }
  };
}
queries$e.setupSlashingExtension = setupSlashingExtension$1;
var aminomessages$d = {};
Object.defineProperty(aminomessages$d, "__esModule", { value: !0 });
aminomessages$d.createStakingAminoConverters = aminomessages$d.isAminoMsgUndelegate = aminomessages$d.isAminoMsgBeginRedelegate = aminomessages$d.isAminoMsgDelegate = aminomessages$d.isAminoMsgEditValidator = aminomessages$d.isAminoMsgCreateValidator = aminomessages$d.protoDecimalToJson = void 0;
const math_1$o = build$R, proto_signing_1$8 = build$Q, utils_1$R = build$G;
function protoDecimalToJson$1(e) {
  const n = math_1$o.Decimal.fromAtomics(e, 18), [o, u] = n.toString().split(".");
  return `${o}.${(u ?? "").padEnd(18, "0")}`;
}
aminomessages$d.protoDecimalToJson = protoDecimalToJson$1;
function jsonDecimalToProto$1(e) {
  return math_1$o.Decimal.fromUserInput(e, 18).atomics;
}
function isAminoMsgCreateValidator$1(e) {
  return e.type === "cosmos-sdk/MsgCreateValidator";
}
aminomessages$d.isAminoMsgCreateValidator = isAminoMsgCreateValidator$1;
function isAminoMsgEditValidator$1(e) {
  return e.type === "cosmos-sdk/MsgEditValidator";
}
aminomessages$d.isAminoMsgEditValidator = isAminoMsgEditValidator$1;
function isAminoMsgDelegate$1(e) {
  return e.type === "cosmos-sdk/MsgDelegate";
}
aminomessages$d.isAminoMsgDelegate = isAminoMsgDelegate$1;
function isAminoMsgBeginRedelegate$1(e) {
  return e.type === "cosmos-sdk/MsgBeginRedelegate";
}
aminomessages$d.isAminoMsgBeginRedelegate = isAminoMsgBeginRedelegate$1;
function isAminoMsgUndelegate$1(e) {
  return e.type === "cosmos-sdk/MsgUndelegate";
}
aminomessages$d.isAminoMsgUndelegate = isAminoMsgUndelegate$1;
function createStakingAminoConverters$1() {
  return {
    "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
      aminoType: "cosmos-sdk/MsgBeginRedelegate",
      toAmino: ({ delegatorAddress: e, validatorSrcAddress: n, validatorDstAddress: o, amount: u }) => ((0, utils_1$R.assertDefinedAndNotNull)(u, "missing amount"), {
        delegator_address: e,
        validator_src_address: n,
        validator_dst_address: o,
        amount: u
      }),
      fromAmino: ({ delegator_address: e, validator_src_address: n, validator_dst_address: o, amount: u }) => ({
        delegatorAddress: e,
        validatorSrcAddress: n,
        validatorDstAddress: o,
        amount: u
      })
    },
    "/cosmos.staking.v1beta1.MsgCreateValidator": {
      aminoType: "cosmos-sdk/MsgCreateValidator",
      toAmino: ({ description: e, commission: n, minSelfDelegation: o, delegatorAddress: u, validatorAddress: c, pubkey: d, value: m }) => ((0, utils_1$R.assertDefinedAndNotNull)(e, "missing description"), (0, utils_1$R.assertDefinedAndNotNull)(n, "missing commission"), (0, utils_1$R.assertDefinedAndNotNull)(d, "missing pubkey"), (0, utils_1$R.assertDefinedAndNotNull)(m, "missing value"), {
        description: {
          moniker: e.moniker,
          identity: e.identity,
          website: e.website,
          security_contact: e.securityContact,
          details: e.details
        },
        commission: {
          rate: protoDecimalToJson$1(n.rate),
          max_rate: protoDecimalToJson$1(n.maxRate),
          max_change_rate: protoDecimalToJson$1(n.maxChangeRate)
        },
        min_self_delegation: o,
        delegator_address: u,
        validator_address: c,
        pubkey: (0, proto_signing_1$8.decodePubkey)(d),
        value: m
      }),
      fromAmino: ({ description: e, commission: n, min_self_delegation: o, delegator_address: u, validator_address: c, pubkey: d, value: m }) => ({
        description: {
          moniker: e.moniker,
          identity: e.identity,
          website: e.website,
          securityContact: e.security_contact,
          details: e.details
        },
        commission: {
          rate: jsonDecimalToProto$1(n.rate),
          maxRate: jsonDecimalToProto$1(n.max_rate),
          maxChangeRate: jsonDecimalToProto$1(n.max_change_rate)
        },
        minSelfDelegation: o,
        delegatorAddress: u,
        validatorAddress: c,
        pubkey: (0, proto_signing_1$8.encodePubkey)(d),
        value: m
      })
    },
    "/cosmos.staking.v1beta1.MsgDelegate": {
      aminoType: "cosmos-sdk/MsgDelegate",
      toAmino: ({ delegatorAddress: e, validatorAddress: n, amount: o }) => ((0, utils_1$R.assertDefinedAndNotNull)(o, "missing amount"), {
        delegator_address: e,
        validator_address: n,
        amount: o
      }),
      fromAmino: ({ delegator_address: e, validator_address: n, amount: o }) => ({
        delegatorAddress: e,
        validatorAddress: n,
        amount: o
      })
    },
    "/cosmos.staking.v1beta1.MsgEditValidator": {
      aminoType: "cosmos-sdk/MsgEditValidator",
      toAmino: ({ description: e, commissionRate: n, minSelfDelegation: o, validatorAddress: u }) => ((0, utils_1$R.assertDefinedAndNotNull)(e, "missing description"), {
        description: {
          moniker: e.moniker,
          identity: e.identity,
          website: e.website,
          security_contact: e.securityContact,
          details: e.details
        },
        // empty string in the protobuf document means "do not change"
        commission_rate: n ? protoDecimalToJson$1(n) : void 0,
        // empty string in the protobuf document means "do not change"
        min_self_delegation: o || void 0,
        validator_address: u
      }),
      fromAmino: ({ description: e, commission_rate: n, min_self_delegation: o, validator_address: u }) => ({
        description: {
          moniker: e.moniker,
          identity: e.identity,
          website: e.website,
          securityContact: e.security_contact,
          details: e.details
        },
        // empty string in the protobuf document means "do not change"
        commissionRate: n ? jsonDecimalToProto$1(n) : "",
        // empty string in the protobuf document means "do not change"
        minSelfDelegation: o ?? "",
        validatorAddress: u
      })
    },
    "/cosmos.staking.v1beta1.MsgUndelegate": {
      aminoType: "cosmos-sdk/MsgUndelegate",
      toAmino: ({ delegatorAddress: e, validatorAddress: n, amount: o }) => ((0, utils_1$R.assertDefinedAndNotNull)(o, "missing amount"), {
        delegator_address: e,
        validator_address: n,
        amount: o
      }),
      fromAmino: ({ delegator_address: e, validator_address: n, amount: o }) => ({
        delegatorAddress: e,
        validatorAddress: n,
        amount: o
      })
    }
  };
}
aminomessages$d.createStakingAminoConverters = createStakingAminoConverters$1;
var messages$b = {}, tx$d = {}, staking$6 = {}, types$c = {}, params$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.HashedParams = e.VersionParams = e.ValidatorParams = e.EvidenceParams = e.BlockParams = e.ConsensusParams = e.protobufPackage = void 0;
  const n = duration$1, o = binary, u = helpers;
  e.protobufPackage = "tendermint.types";
  function c() {
    return {
      block: void 0,
      evidence: void 0,
      validator: void 0,
      version: void 0
    };
  }
  e.ConsensusParams = {
    typeUrl: "/tendermint.types.ConsensusParams",
    encode(E, O = o.BinaryWriter.create()) {
      return E.block !== void 0 && e.BlockParams.encode(E.block, O.uint32(10).fork()).ldelim(), E.evidence !== void 0 && e.EvidenceParams.encode(E.evidence, O.uint32(18).fork()).ldelim(), E.validator !== void 0 && e.ValidatorParams.encode(E.validator, O.uint32(26).fork()).ldelim(), E.version !== void 0 && e.VersionParams.encode(E.version, O.uint32(34).fork()).ldelim(), O;
    },
    decode(E, O) {
      const T = E instanceof o.BinaryReader ? E : new o.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = c();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.block = e.BlockParams.decode(T, T.uint32());
            break;
          case 2:
            V.evidence = e.EvidenceParams.decode(T, T.uint32());
            break;
          case 3:
            V.validator = e.ValidatorParams.decode(T, T.uint32());
            break;
          case 4:
            V.version = e.VersionParams.decode(T, T.uint32());
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = c();
      return (0, u.isSet)(E.block) && (O.block = e.BlockParams.fromJSON(E.block)), (0, u.isSet)(E.evidence) && (O.evidence = e.EvidenceParams.fromJSON(E.evidence)), (0, u.isSet)(E.validator) && (O.validator = e.ValidatorParams.fromJSON(E.validator)), (0, u.isSet)(E.version) && (O.version = e.VersionParams.fromJSON(E.version)), O;
    },
    toJSON(E) {
      const O = {};
      return E.block !== void 0 && (O.block = E.block ? e.BlockParams.toJSON(E.block) : void 0), E.evidence !== void 0 && (O.evidence = E.evidence ? e.EvidenceParams.toJSON(E.evidence) : void 0), E.validator !== void 0 && (O.validator = E.validator ? e.ValidatorParams.toJSON(E.validator) : void 0), E.version !== void 0 && (O.version = E.version ? e.VersionParams.toJSON(E.version) : void 0), O;
    },
    fromPartial(E) {
      const O = c();
      return E.block !== void 0 && E.block !== null && (O.block = e.BlockParams.fromPartial(E.block)), E.evidence !== void 0 && E.evidence !== null && (O.evidence = e.EvidenceParams.fromPartial(E.evidence)), E.validator !== void 0 && E.validator !== null && (O.validator = e.ValidatorParams.fromPartial(E.validator)), E.version !== void 0 && E.version !== null && (O.version = e.VersionParams.fromPartial(E.version)), O;
    }
  };
  function d() {
    return {
      maxBytes: BigInt(0),
      maxGas: BigInt(0)
    };
  }
  e.BlockParams = {
    typeUrl: "/tendermint.types.BlockParams",
    encode(E, O = o.BinaryWriter.create()) {
      return E.maxBytes !== BigInt(0) && O.uint32(8).int64(E.maxBytes), E.maxGas !== BigInt(0) && O.uint32(16).int64(E.maxGas), O;
    },
    decode(E, O) {
      const T = E instanceof o.BinaryReader ? E : new o.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = d();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.maxBytes = T.int64();
            break;
          case 2:
            V.maxGas = T.int64();
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = d();
      return (0, u.isSet)(E.maxBytes) && (O.maxBytes = BigInt(E.maxBytes.toString())), (0, u.isSet)(E.maxGas) && (O.maxGas = BigInt(E.maxGas.toString())), O;
    },
    toJSON(E) {
      const O = {};
      return E.maxBytes !== void 0 && (O.maxBytes = (E.maxBytes || BigInt(0)).toString()), E.maxGas !== void 0 && (O.maxGas = (E.maxGas || BigInt(0)).toString()), O;
    },
    fromPartial(E) {
      const O = d();
      return E.maxBytes !== void 0 && E.maxBytes !== null && (O.maxBytes = BigInt(E.maxBytes.toString())), E.maxGas !== void 0 && E.maxGas !== null && (O.maxGas = BigInt(E.maxGas.toString())), O;
    }
  };
  function m() {
    return {
      maxAgeNumBlocks: BigInt(0),
      maxAgeDuration: n.Duration.fromPartial({}),
      maxBytes: BigInt(0)
    };
  }
  e.EvidenceParams = {
    typeUrl: "/tendermint.types.EvidenceParams",
    encode(E, O = o.BinaryWriter.create()) {
      return E.maxAgeNumBlocks !== BigInt(0) && O.uint32(8).int64(E.maxAgeNumBlocks), E.maxAgeDuration !== void 0 && n.Duration.encode(E.maxAgeDuration, O.uint32(18).fork()).ldelim(), E.maxBytes !== BigInt(0) && O.uint32(24).int64(E.maxBytes), O;
    },
    decode(E, O) {
      const T = E instanceof o.BinaryReader ? E : new o.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = m();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.maxAgeNumBlocks = T.int64();
            break;
          case 2:
            V.maxAgeDuration = n.Duration.decode(T, T.uint32());
            break;
          case 3:
            V.maxBytes = T.int64();
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = m();
      return (0, u.isSet)(E.maxAgeNumBlocks) && (O.maxAgeNumBlocks = BigInt(E.maxAgeNumBlocks.toString())), (0, u.isSet)(E.maxAgeDuration) && (O.maxAgeDuration = n.Duration.fromJSON(E.maxAgeDuration)), (0, u.isSet)(E.maxBytes) && (O.maxBytes = BigInt(E.maxBytes.toString())), O;
    },
    toJSON(E) {
      const O = {};
      return E.maxAgeNumBlocks !== void 0 && (O.maxAgeNumBlocks = (E.maxAgeNumBlocks || BigInt(0)).toString()), E.maxAgeDuration !== void 0 && (O.maxAgeDuration = E.maxAgeDuration ? n.Duration.toJSON(E.maxAgeDuration) : void 0), E.maxBytes !== void 0 && (O.maxBytes = (E.maxBytes || BigInt(0)).toString()), O;
    },
    fromPartial(E) {
      const O = m();
      return E.maxAgeNumBlocks !== void 0 && E.maxAgeNumBlocks !== null && (O.maxAgeNumBlocks = BigInt(E.maxAgeNumBlocks.toString())), E.maxAgeDuration !== void 0 && E.maxAgeDuration !== null && (O.maxAgeDuration = n.Duration.fromPartial(E.maxAgeDuration)), E.maxBytes !== void 0 && E.maxBytes !== null && (O.maxBytes = BigInt(E.maxBytes.toString())), O;
    }
  };
  function v() {
    return {
      pubKeyTypes: []
    };
  }
  e.ValidatorParams = {
    typeUrl: "/tendermint.types.ValidatorParams",
    encode(E, O = o.BinaryWriter.create()) {
      for (const T of E.pubKeyTypes)
        O.uint32(10).string(T);
      return O;
    },
    decode(E, O) {
      const T = E instanceof o.BinaryReader ? E : new o.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = v();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.pubKeyTypes.push(T.string());
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = v();
      return Array.isArray(E == null ? void 0 : E.pubKeyTypes) && (O.pubKeyTypes = E.pubKeyTypes.map((T) => String(T))), O;
    },
    toJSON(E) {
      const O = {};
      return E.pubKeyTypes ? O.pubKeyTypes = E.pubKeyTypes.map((T) => T) : O.pubKeyTypes = [], O;
    },
    fromPartial(E) {
      var T;
      const O = v();
      return O.pubKeyTypes = ((T = E.pubKeyTypes) == null ? void 0 : T.map((y) => y)) || [], O;
    }
  };
  function S() {
    return {
      app: BigInt(0)
    };
  }
  e.VersionParams = {
    typeUrl: "/tendermint.types.VersionParams",
    encode(E, O = o.BinaryWriter.create()) {
      return E.app !== BigInt(0) && O.uint32(8).uint64(E.app), O;
    },
    decode(E, O) {
      const T = E instanceof o.BinaryReader ? E : new o.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = S();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.app = T.uint64();
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = S();
      return (0, u.isSet)(E.app) && (O.app = BigInt(E.app.toString())), O;
    },
    toJSON(E) {
      const O = {};
      return E.app !== void 0 && (O.app = (E.app || BigInt(0)).toString()), O;
    },
    fromPartial(E) {
      const O = S();
      return E.app !== void 0 && E.app !== null && (O.app = BigInt(E.app.toString())), O;
    }
  };
  function $() {
    return {
      blockMaxBytes: BigInt(0),
      blockMaxGas: BigInt(0)
    };
  }
  e.HashedParams = {
    typeUrl: "/tendermint.types.HashedParams",
    encode(E, O = o.BinaryWriter.create()) {
      return E.blockMaxBytes !== BigInt(0) && O.uint32(8).int64(E.blockMaxBytes), E.blockMaxGas !== BigInt(0) && O.uint32(16).int64(E.blockMaxGas), O;
    },
    decode(E, O) {
      const T = E instanceof o.BinaryReader ? E : new o.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = $();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.blockMaxBytes = T.int64();
            break;
          case 2:
            V.blockMaxGas = T.int64();
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = $();
      return (0, u.isSet)(E.blockMaxBytes) && (O.blockMaxBytes = BigInt(E.blockMaxBytes.toString())), (0, u.isSet)(E.blockMaxGas) && (O.blockMaxGas = BigInt(E.blockMaxGas.toString())), O;
    },
    toJSON(E) {
      const O = {};
      return E.blockMaxBytes !== void 0 && (O.blockMaxBytes = (E.blockMaxBytes || BigInt(0)).toString()), E.blockMaxGas !== void 0 && (O.blockMaxGas = (E.blockMaxGas || BigInt(0)).toString()), O;
    },
    fromPartial(E) {
      const O = $();
      return E.blockMaxBytes !== void 0 && E.blockMaxBytes !== null && (O.blockMaxBytes = BigInt(E.blockMaxBytes.toString())), E.blockMaxGas !== void 0 && E.blockMaxGas !== null && (O.blockMaxGas = BigInt(E.blockMaxGas.toString())), O;
    }
  };
})(params$1);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ResponsePrepareProposal = e.ResponseApplySnapshotChunk = e.ResponseLoadSnapshotChunk = e.ResponseOfferSnapshot = e.ResponseListSnapshots = e.ResponseCommit = e.ResponseEndBlock = e.ResponseDeliverTx = e.ResponseCheckTx = e.ResponseBeginBlock = e.ResponseQuery = e.ResponseInitChain = e.ResponseInfo = e.ResponseFlush = e.ResponseEcho = e.ResponseException = e.Response = e.RequestProcessProposal = e.RequestPrepareProposal = e.RequestApplySnapshotChunk = e.RequestLoadSnapshotChunk = e.RequestOfferSnapshot = e.RequestListSnapshots = e.RequestCommit = e.RequestEndBlock = e.RequestDeliverTx = e.RequestCheckTx = e.RequestBeginBlock = e.RequestQuery = e.RequestInitChain = e.RequestInfo = e.RequestFlush = e.RequestEcho = e.Request = e.misbehaviorTypeToJSON = e.misbehaviorTypeFromJSON = e.MisbehaviorType = e.responseProcessProposal_ProposalStatusToJSON = e.responseProcessProposal_ProposalStatusFromJSON = e.ResponseProcessProposal_ProposalStatus = e.responseApplySnapshotChunk_ResultToJSON = e.responseApplySnapshotChunk_ResultFromJSON = e.ResponseApplySnapshotChunk_Result = e.responseOfferSnapshot_ResultToJSON = e.responseOfferSnapshot_ResultFromJSON = e.ResponseOfferSnapshot_Result = e.checkTxTypeToJSON = e.checkTxTypeFromJSON = e.CheckTxType = e.protobufPackage = void 0, e.ABCIApplicationClientImpl = e.Snapshot = e.Misbehavior = e.ExtendedVoteInfo = e.VoteInfo = e.ValidatorUpdate = e.Validator = e.TxResult = e.EventAttribute = e.Event = e.ExtendedCommitInfo = e.CommitInfo = e.ResponseProcessProposal = void 0;
  const n = timestamp$1, o = params$1, u = types$e, c = proof$1, d = keys$3, m = binary, v = helpers;
  e.protobufPackage = "tendermint.abci";
  var S;
  (function(Ae) {
    Ae[Ae.NEW = 0] = "NEW", Ae[Ae.RECHECK = 1] = "RECHECK", Ae[Ae.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(S || (e.CheckTxType = S = {}));
  function $(Ae) {
    switch (Ae) {
      case 0:
      case "NEW":
        return S.NEW;
      case 1:
      case "RECHECK":
        return S.RECHECK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return S.UNRECOGNIZED;
    }
  }
  e.checkTxTypeFromJSON = $;
  function E(Ae) {
    switch (Ae) {
      case S.NEW:
        return "NEW";
      case S.RECHECK:
        return "RECHECK";
      case S.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.checkTxTypeToJSON = E;
  var O;
  (function(Ae) {
    Ae[Ae.UNKNOWN = 0] = "UNKNOWN", Ae[Ae.ACCEPT = 1] = "ACCEPT", Ae[Ae.ABORT = 2] = "ABORT", Ae[Ae.REJECT = 3] = "REJECT", Ae[Ae.REJECT_FORMAT = 4] = "REJECT_FORMAT", Ae[Ae.REJECT_SENDER = 5] = "REJECT_SENDER", Ae[Ae.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(O || (e.ResponseOfferSnapshot_Result = O = {}));
  function T(Ae) {
    switch (Ae) {
      case 0:
      case "UNKNOWN":
        return O.UNKNOWN;
      case 1:
      case "ACCEPT":
        return O.ACCEPT;
      case 2:
      case "ABORT":
        return O.ABORT;
      case 3:
      case "REJECT":
        return O.REJECT;
      case 4:
      case "REJECT_FORMAT":
        return O.REJECT_FORMAT;
      case 5:
      case "REJECT_SENDER":
        return O.REJECT_SENDER;
      case -1:
      case "UNRECOGNIZED":
      default:
        return O.UNRECOGNIZED;
    }
  }
  e.responseOfferSnapshot_ResultFromJSON = T;
  function y(Ae) {
    switch (Ae) {
      case O.UNKNOWN:
        return "UNKNOWN";
      case O.ACCEPT:
        return "ACCEPT";
      case O.ABORT:
        return "ABORT";
      case O.REJECT:
        return "REJECT";
      case O.REJECT_FORMAT:
        return "REJECT_FORMAT";
      case O.REJECT_SENDER:
        return "REJECT_SENDER";
      case O.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseOfferSnapshot_ResultToJSON = y;
  var V;
  (function(Ae) {
    Ae[Ae.UNKNOWN = 0] = "UNKNOWN", Ae[Ae.ACCEPT = 1] = "ACCEPT", Ae[Ae.ABORT = 2] = "ABORT", Ae[Ae.RETRY = 3] = "RETRY", Ae[Ae.RETRY_SNAPSHOT = 4] = "RETRY_SNAPSHOT", Ae[Ae.REJECT_SNAPSHOT = 5] = "REJECT_SNAPSHOT", Ae[Ae.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(V || (e.ResponseApplySnapshotChunk_Result = V = {}));
  function M(Ae) {
    switch (Ae) {
      case 0:
      case "UNKNOWN":
        return V.UNKNOWN;
      case 1:
      case "ACCEPT":
        return V.ACCEPT;
      case 2:
      case "ABORT":
        return V.ABORT;
      case 3:
      case "RETRY":
        return V.RETRY;
      case 4:
      case "RETRY_SNAPSHOT":
        return V.RETRY_SNAPSHOT;
      case 5:
      case "REJECT_SNAPSHOT":
        return V.REJECT_SNAPSHOT;
      case -1:
      case "UNRECOGNIZED":
      default:
        return V.UNRECOGNIZED;
    }
  }
  e.responseApplySnapshotChunk_ResultFromJSON = M;
  function G(Ae) {
    switch (Ae) {
      case V.UNKNOWN:
        return "UNKNOWN";
      case V.ACCEPT:
        return "ACCEPT";
      case V.ABORT:
        return "ABORT";
      case V.RETRY:
        return "RETRY";
      case V.RETRY_SNAPSHOT:
        return "RETRY_SNAPSHOT";
      case V.REJECT_SNAPSHOT:
        return "REJECT_SNAPSHOT";
      case V.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseApplySnapshotChunk_ResultToJSON = G;
  var k;
  (function(Ae) {
    Ae[Ae.UNKNOWN = 0] = "UNKNOWN", Ae[Ae.ACCEPT = 1] = "ACCEPT", Ae[Ae.REJECT = 2] = "REJECT", Ae[Ae.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(k || (e.ResponseProcessProposal_ProposalStatus = k = {}));
  function F(Ae) {
    switch (Ae) {
      case 0:
      case "UNKNOWN":
        return k.UNKNOWN;
      case 1:
      case "ACCEPT":
        return k.ACCEPT;
      case 2:
      case "REJECT":
        return k.REJECT;
      case -1:
      case "UNRECOGNIZED":
      default:
        return k.UNRECOGNIZED;
    }
  }
  e.responseProcessProposal_ProposalStatusFromJSON = F;
  function X(Ae) {
    switch (Ae) {
      case k.UNKNOWN:
        return "UNKNOWN";
      case k.ACCEPT:
        return "ACCEPT";
      case k.REJECT:
        return "REJECT";
      case k.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.responseProcessProposal_ProposalStatusToJSON = X;
  var ee;
  (function(Ae) {
    Ae[Ae.UNKNOWN = 0] = "UNKNOWN", Ae[Ae.DUPLICATE_VOTE = 1] = "DUPLICATE_VOTE", Ae[Ae.LIGHT_CLIENT_ATTACK = 2] = "LIGHT_CLIENT_ATTACK", Ae[Ae.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ee || (e.MisbehaviorType = ee = {}));
  function ue(Ae) {
    switch (Ae) {
      case 0:
      case "UNKNOWN":
        return ee.UNKNOWN;
      case 1:
      case "DUPLICATE_VOTE":
        return ee.DUPLICATE_VOTE;
      case 2:
      case "LIGHT_CLIENT_ATTACK":
        return ee.LIGHT_CLIENT_ATTACK;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ee.UNRECOGNIZED;
    }
  }
  e.misbehaviorTypeFromJSON = ue;
  function Q(Ae) {
    switch (Ae) {
      case ee.UNKNOWN:
        return "UNKNOWN";
      case ee.DUPLICATE_VOTE:
        return "DUPLICATE_VOTE";
      case ee.LIGHT_CLIENT_ATTACK:
        return "LIGHT_CLIENT_ATTACK";
      case ee.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.misbehaviorTypeToJSON = Q;
  function Y() {
    return {
      echo: void 0,
      flush: void 0,
      info: void 0,
      initChain: void 0,
      query: void 0,
      beginBlock: void 0,
      checkTx: void 0,
      deliverTx: void 0,
      endBlock: void 0,
      commit: void 0,
      listSnapshots: void 0,
      offerSnapshot: void 0,
      loadSnapshotChunk: void 0,
      applySnapshotChunk: void 0,
      prepareProposal: void 0,
      processProposal: void 0
    };
  }
  e.Request = {
    typeUrl: "/tendermint.abci.Request",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.echo !== void 0 && e.RequestEcho.encode(Ae.echo, Me.uint32(10).fork()).ldelim(), Ae.flush !== void 0 && e.RequestFlush.encode(Ae.flush, Me.uint32(18).fork()).ldelim(), Ae.info !== void 0 && e.RequestInfo.encode(Ae.info, Me.uint32(26).fork()).ldelim(), Ae.initChain !== void 0 && e.RequestInitChain.encode(Ae.initChain, Me.uint32(42).fork()).ldelim(), Ae.query !== void 0 && e.RequestQuery.encode(Ae.query, Me.uint32(50).fork()).ldelim(), Ae.beginBlock !== void 0 && e.RequestBeginBlock.encode(Ae.beginBlock, Me.uint32(58).fork()).ldelim(), Ae.checkTx !== void 0 && e.RequestCheckTx.encode(Ae.checkTx, Me.uint32(66).fork()).ldelim(), Ae.deliverTx !== void 0 && e.RequestDeliverTx.encode(Ae.deliverTx, Me.uint32(74).fork()).ldelim(), Ae.endBlock !== void 0 && e.RequestEndBlock.encode(Ae.endBlock, Me.uint32(82).fork()).ldelim(), Ae.commit !== void 0 && e.RequestCommit.encode(Ae.commit, Me.uint32(90).fork()).ldelim(), Ae.listSnapshots !== void 0 && e.RequestListSnapshots.encode(Ae.listSnapshots, Me.uint32(98).fork()).ldelim(), Ae.offerSnapshot !== void 0 && e.RequestOfferSnapshot.encode(Ae.offerSnapshot, Me.uint32(106).fork()).ldelim(), Ae.loadSnapshotChunk !== void 0 && e.RequestLoadSnapshotChunk.encode(Ae.loadSnapshotChunk, Me.uint32(114).fork()).ldelim(), Ae.applySnapshotChunk !== void 0 && e.RequestApplySnapshotChunk.encode(Ae.applySnapshotChunk, Me.uint32(122).fork()).ldelim(), Ae.prepareProposal !== void 0 && e.RequestPrepareProposal.encode(Ae.prepareProposal, Me.uint32(130).fork()).ldelim(), Ae.processProposal !== void 0 && e.RequestProcessProposal.encode(Ae.processProposal, Me.uint32(138).fork()).ldelim(), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Y();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.echo = e.RequestEcho.decode(He, He.uint32());
            break;
          case 2:
            Wt.flush = e.RequestFlush.decode(He, He.uint32());
            break;
          case 3:
            Wt.info = e.RequestInfo.decode(He, He.uint32());
            break;
          case 5:
            Wt.initChain = e.RequestInitChain.decode(He, He.uint32());
            break;
          case 6:
            Wt.query = e.RequestQuery.decode(He, He.uint32());
            break;
          case 7:
            Wt.beginBlock = e.RequestBeginBlock.decode(He, He.uint32());
            break;
          case 8:
            Wt.checkTx = e.RequestCheckTx.decode(He, He.uint32());
            break;
          case 9:
            Wt.deliverTx = e.RequestDeliverTx.decode(He, He.uint32());
            break;
          case 10:
            Wt.endBlock = e.RequestEndBlock.decode(He, He.uint32());
            break;
          case 11:
            Wt.commit = e.RequestCommit.decode(He, He.uint32());
            break;
          case 12:
            Wt.listSnapshots = e.RequestListSnapshots.decode(He, He.uint32());
            break;
          case 13:
            Wt.offerSnapshot = e.RequestOfferSnapshot.decode(He, He.uint32());
            break;
          case 14:
            Wt.loadSnapshotChunk = e.RequestLoadSnapshotChunk.decode(He, He.uint32());
            break;
          case 15:
            Wt.applySnapshotChunk = e.RequestApplySnapshotChunk.decode(He, He.uint32());
            break;
          case 16:
            Wt.prepareProposal = e.RequestPrepareProposal.decode(He, He.uint32());
            break;
          case 17:
            Wt.processProposal = e.RequestProcessProposal.decode(He, He.uint32());
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Y();
      return (0, v.isSet)(Ae.echo) && (Me.echo = e.RequestEcho.fromJSON(Ae.echo)), (0, v.isSet)(Ae.flush) && (Me.flush = e.RequestFlush.fromJSON(Ae.flush)), (0, v.isSet)(Ae.info) && (Me.info = e.RequestInfo.fromJSON(Ae.info)), (0, v.isSet)(Ae.initChain) && (Me.initChain = e.RequestInitChain.fromJSON(Ae.initChain)), (0, v.isSet)(Ae.query) && (Me.query = e.RequestQuery.fromJSON(Ae.query)), (0, v.isSet)(Ae.beginBlock) && (Me.beginBlock = e.RequestBeginBlock.fromJSON(Ae.beginBlock)), (0, v.isSet)(Ae.checkTx) && (Me.checkTx = e.RequestCheckTx.fromJSON(Ae.checkTx)), (0, v.isSet)(Ae.deliverTx) && (Me.deliverTx = e.RequestDeliverTx.fromJSON(Ae.deliverTx)), (0, v.isSet)(Ae.endBlock) && (Me.endBlock = e.RequestEndBlock.fromJSON(Ae.endBlock)), (0, v.isSet)(Ae.commit) && (Me.commit = e.RequestCommit.fromJSON(Ae.commit)), (0, v.isSet)(Ae.listSnapshots) && (Me.listSnapshots = e.RequestListSnapshots.fromJSON(Ae.listSnapshots)), (0, v.isSet)(Ae.offerSnapshot) && (Me.offerSnapshot = e.RequestOfferSnapshot.fromJSON(Ae.offerSnapshot)), (0, v.isSet)(Ae.loadSnapshotChunk) && (Me.loadSnapshotChunk = e.RequestLoadSnapshotChunk.fromJSON(Ae.loadSnapshotChunk)), (0, v.isSet)(Ae.applySnapshotChunk) && (Me.applySnapshotChunk = e.RequestApplySnapshotChunk.fromJSON(Ae.applySnapshotChunk)), (0, v.isSet)(Ae.prepareProposal) && (Me.prepareProposal = e.RequestPrepareProposal.fromJSON(Ae.prepareProposal)), (0, v.isSet)(Ae.processProposal) && (Me.processProposal = e.RequestProcessProposal.fromJSON(Ae.processProposal)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.echo !== void 0 && (Me.echo = Ae.echo ? e.RequestEcho.toJSON(Ae.echo) : void 0), Ae.flush !== void 0 && (Me.flush = Ae.flush ? e.RequestFlush.toJSON(Ae.flush) : void 0), Ae.info !== void 0 && (Me.info = Ae.info ? e.RequestInfo.toJSON(Ae.info) : void 0), Ae.initChain !== void 0 && (Me.initChain = Ae.initChain ? e.RequestInitChain.toJSON(Ae.initChain) : void 0), Ae.query !== void 0 && (Me.query = Ae.query ? e.RequestQuery.toJSON(Ae.query) : void 0), Ae.beginBlock !== void 0 && (Me.beginBlock = Ae.beginBlock ? e.RequestBeginBlock.toJSON(Ae.beginBlock) : void 0), Ae.checkTx !== void 0 && (Me.checkTx = Ae.checkTx ? e.RequestCheckTx.toJSON(Ae.checkTx) : void 0), Ae.deliverTx !== void 0 && (Me.deliverTx = Ae.deliverTx ? e.RequestDeliverTx.toJSON(Ae.deliverTx) : void 0), Ae.endBlock !== void 0 && (Me.endBlock = Ae.endBlock ? e.RequestEndBlock.toJSON(Ae.endBlock) : void 0), Ae.commit !== void 0 && (Me.commit = Ae.commit ? e.RequestCommit.toJSON(Ae.commit) : void 0), Ae.listSnapshots !== void 0 && (Me.listSnapshots = Ae.listSnapshots ? e.RequestListSnapshots.toJSON(Ae.listSnapshots) : void 0), Ae.offerSnapshot !== void 0 && (Me.offerSnapshot = Ae.offerSnapshot ? e.RequestOfferSnapshot.toJSON(Ae.offerSnapshot) : void 0), Ae.loadSnapshotChunk !== void 0 && (Me.loadSnapshotChunk = Ae.loadSnapshotChunk ? e.RequestLoadSnapshotChunk.toJSON(Ae.loadSnapshotChunk) : void 0), Ae.applySnapshotChunk !== void 0 && (Me.applySnapshotChunk = Ae.applySnapshotChunk ? e.RequestApplySnapshotChunk.toJSON(Ae.applySnapshotChunk) : void 0), Ae.prepareProposal !== void 0 && (Me.prepareProposal = Ae.prepareProposal ? e.RequestPrepareProposal.toJSON(Ae.prepareProposal) : void 0), Ae.processProposal !== void 0 && (Me.processProposal = Ae.processProposal ? e.RequestProcessProposal.toJSON(Ae.processProposal) : void 0), Me;
    },
    fromPartial(Ae) {
      const Me = Y();
      return Ae.echo !== void 0 && Ae.echo !== null && (Me.echo = e.RequestEcho.fromPartial(Ae.echo)), Ae.flush !== void 0 && Ae.flush !== null && (Me.flush = e.RequestFlush.fromPartial(Ae.flush)), Ae.info !== void 0 && Ae.info !== null && (Me.info = e.RequestInfo.fromPartial(Ae.info)), Ae.initChain !== void 0 && Ae.initChain !== null && (Me.initChain = e.RequestInitChain.fromPartial(Ae.initChain)), Ae.query !== void 0 && Ae.query !== null && (Me.query = e.RequestQuery.fromPartial(Ae.query)), Ae.beginBlock !== void 0 && Ae.beginBlock !== null && (Me.beginBlock = e.RequestBeginBlock.fromPartial(Ae.beginBlock)), Ae.checkTx !== void 0 && Ae.checkTx !== null && (Me.checkTx = e.RequestCheckTx.fromPartial(Ae.checkTx)), Ae.deliverTx !== void 0 && Ae.deliverTx !== null && (Me.deliverTx = e.RequestDeliverTx.fromPartial(Ae.deliverTx)), Ae.endBlock !== void 0 && Ae.endBlock !== null && (Me.endBlock = e.RequestEndBlock.fromPartial(Ae.endBlock)), Ae.commit !== void 0 && Ae.commit !== null && (Me.commit = e.RequestCommit.fromPartial(Ae.commit)), Ae.listSnapshots !== void 0 && Ae.listSnapshots !== null && (Me.listSnapshots = e.RequestListSnapshots.fromPartial(Ae.listSnapshots)), Ae.offerSnapshot !== void 0 && Ae.offerSnapshot !== null && (Me.offerSnapshot = e.RequestOfferSnapshot.fromPartial(Ae.offerSnapshot)), Ae.loadSnapshotChunk !== void 0 && Ae.loadSnapshotChunk !== null && (Me.loadSnapshotChunk = e.RequestLoadSnapshotChunk.fromPartial(Ae.loadSnapshotChunk)), Ae.applySnapshotChunk !== void 0 && Ae.applySnapshotChunk !== null && (Me.applySnapshotChunk = e.RequestApplySnapshotChunk.fromPartial(Ae.applySnapshotChunk)), Ae.prepareProposal !== void 0 && Ae.prepareProposal !== null && (Me.prepareProposal = e.RequestPrepareProposal.fromPartial(Ae.prepareProposal)), Ae.processProposal !== void 0 && Ae.processProposal !== null && (Me.processProposal = e.RequestProcessProposal.fromPartial(Ae.processProposal)), Me;
    }
  };
  function pe() {
    return {
      message: ""
    };
  }
  e.RequestEcho = {
    typeUrl: "/tendermint.abci.RequestEcho",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.message !== "" && Me.uint32(10).string(Ae.message), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = pe();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.message = He.string();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = pe();
      return (0, v.isSet)(Ae.message) && (Me.message = String(Ae.message)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.message !== void 0 && (Me.message = Ae.message), Me;
    },
    fromPartial(Ae) {
      const Me = pe();
      return Me.message = Ae.message ?? "", Me;
    }
  };
  function oe() {
    return {};
  }
  e.RequestFlush = {
    typeUrl: "/tendermint.abci.RequestFlush",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = oe();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      return oe();
    },
    toJSON(Ae) {
      return {};
    },
    fromPartial(Ae) {
      return oe();
    }
  };
  function ne() {
    return {
      version: "",
      blockVersion: BigInt(0),
      p2pVersion: BigInt(0),
      abciVersion: ""
    };
  }
  e.RequestInfo = {
    typeUrl: "/tendermint.abci.RequestInfo",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.version !== "" && Me.uint32(10).string(Ae.version), Ae.blockVersion !== BigInt(0) && Me.uint32(16).uint64(Ae.blockVersion), Ae.p2pVersion !== BigInt(0) && Me.uint32(24).uint64(Ae.p2pVersion), Ae.abciVersion !== "" && Me.uint32(34).string(Ae.abciVersion), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = ne();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.version = He.string();
            break;
          case 2:
            Wt.blockVersion = He.uint64();
            break;
          case 3:
            Wt.p2pVersion = He.uint64();
            break;
          case 4:
            Wt.abciVersion = He.string();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = ne();
      return (0, v.isSet)(Ae.version) && (Me.version = String(Ae.version)), (0, v.isSet)(Ae.blockVersion) && (Me.blockVersion = BigInt(Ae.blockVersion.toString())), (0, v.isSet)(Ae.p2pVersion) && (Me.p2pVersion = BigInt(Ae.p2pVersion.toString())), (0, v.isSet)(Ae.abciVersion) && (Me.abciVersion = String(Ae.abciVersion)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.version !== void 0 && (Me.version = Ae.version), Ae.blockVersion !== void 0 && (Me.blockVersion = (Ae.blockVersion || BigInt(0)).toString()), Ae.p2pVersion !== void 0 && (Me.p2pVersion = (Ae.p2pVersion || BigInt(0)).toString()), Ae.abciVersion !== void 0 && (Me.abciVersion = Ae.abciVersion), Me;
    },
    fromPartial(Ae) {
      const Me = ne();
      return Me.version = Ae.version ?? "", Ae.blockVersion !== void 0 && Ae.blockVersion !== null && (Me.blockVersion = BigInt(Ae.blockVersion.toString())), Ae.p2pVersion !== void 0 && Ae.p2pVersion !== null && (Me.p2pVersion = BigInt(Ae.p2pVersion.toString())), Me.abciVersion = Ae.abciVersion ?? "", Me;
    }
  };
  function H() {
    return {
      time: n.Timestamp.fromPartial({}),
      chainId: "",
      consensusParams: void 0,
      validators: [],
      appStateBytes: new Uint8Array(),
      initialHeight: BigInt(0)
    };
  }
  e.RequestInitChain = {
    typeUrl: "/tendermint.abci.RequestInitChain",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.time !== void 0 && n.Timestamp.encode(Ae.time, Me.uint32(10).fork()).ldelim(), Ae.chainId !== "" && Me.uint32(18).string(Ae.chainId), Ae.consensusParams !== void 0 && o.ConsensusParams.encode(Ae.consensusParams, Me.uint32(26).fork()).ldelim();
      for (const He of Ae.validators)
        e.ValidatorUpdate.encode(He, Me.uint32(34).fork()).ldelim();
      return Ae.appStateBytes.length !== 0 && Me.uint32(42).bytes(Ae.appStateBytes), Ae.initialHeight !== BigInt(0) && Me.uint32(48).int64(Ae.initialHeight), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = H();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.time = n.Timestamp.decode(He, He.uint32());
            break;
          case 2:
            Wt.chainId = He.string();
            break;
          case 3:
            Wt.consensusParams = o.ConsensusParams.decode(He, He.uint32());
            break;
          case 4:
            Wt.validators.push(e.ValidatorUpdate.decode(He, He.uint32()));
            break;
          case 5:
            Wt.appStateBytes = He.bytes();
            break;
          case 6:
            Wt.initialHeight = He.int64();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = H();
      return (0, v.isSet)(Ae.time) && (Me.time = (0, v.fromJsonTimestamp)(Ae.time)), (0, v.isSet)(Ae.chainId) && (Me.chainId = String(Ae.chainId)), (0, v.isSet)(Ae.consensusParams) && (Me.consensusParams = o.ConsensusParams.fromJSON(Ae.consensusParams)), Array.isArray(Ae == null ? void 0 : Ae.validators) && (Me.validators = Ae.validators.map((He) => e.ValidatorUpdate.fromJSON(He))), (0, v.isSet)(Ae.appStateBytes) && (Me.appStateBytes = (0, v.bytesFromBase64)(Ae.appStateBytes)), (0, v.isSet)(Ae.initialHeight) && (Me.initialHeight = BigInt(Ae.initialHeight.toString())), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.time !== void 0 && (Me.time = (0, v.fromTimestamp)(Ae.time).toISOString()), Ae.chainId !== void 0 && (Me.chainId = Ae.chainId), Ae.consensusParams !== void 0 && (Me.consensusParams = Ae.consensusParams ? o.ConsensusParams.toJSON(Ae.consensusParams) : void 0), Ae.validators ? Me.validators = Ae.validators.map((He) => He ? e.ValidatorUpdate.toJSON(He) : void 0) : Me.validators = [], Ae.appStateBytes !== void 0 && (Me.appStateBytes = (0, v.base64FromBytes)(Ae.appStateBytes !== void 0 ? Ae.appStateBytes : new Uint8Array())), Ae.initialHeight !== void 0 && (Me.initialHeight = (Ae.initialHeight || BigInt(0)).toString()), Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = H();
      return Ae.time !== void 0 && Ae.time !== null && (Me.time = n.Timestamp.fromPartial(Ae.time)), Me.chainId = Ae.chainId ?? "", Ae.consensusParams !== void 0 && Ae.consensusParams !== null && (Me.consensusParams = o.ConsensusParams.fromPartial(Ae.consensusParams)), Me.validators = ((He = Ae.validators) == null ? void 0 : He.map((cn) => e.ValidatorUpdate.fromPartial(cn))) || [], Me.appStateBytes = Ae.appStateBytes ?? new Uint8Array(), Ae.initialHeight !== void 0 && Ae.initialHeight !== null && (Me.initialHeight = BigInt(Ae.initialHeight.toString())), Me;
    }
  };
  function C() {
    return {
      data: new Uint8Array(),
      path: "",
      height: BigInt(0),
      prove: !1
    };
  }
  e.RequestQuery = {
    typeUrl: "/tendermint.abci.RequestQuery",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.data.length !== 0 && Me.uint32(10).bytes(Ae.data), Ae.path !== "" && Me.uint32(18).string(Ae.path), Ae.height !== BigInt(0) && Me.uint32(24).int64(Ae.height), Ae.prove === !0 && Me.uint32(32).bool(Ae.prove), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = C();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.data = He.bytes();
            break;
          case 2:
            Wt.path = He.string();
            break;
          case 3:
            Wt.height = He.int64();
            break;
          case 4:
            Wt.prove = He.bool();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = C();
      return (0, v.isSet)(Ae.data) && (Me.data = (0, v.bytesFromBase64)(Ae.data)), (0, v.isSet)(Ae.path) && (Me.path = String(Ae.path)), (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), (0, v.isSet)(Ae.prove) && (Me.prove = !!Ae.prove), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.data !== void 0 && (Me.data = (0, v.base64FromBytes)(Ae.data !== void 0 ? Ae.data : new Uint8Array())), Ae.path !== void 0 && (Me.path = Ae.path), Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Ae.prove !== void 0 && (Me.prove = Ae.prove), Me;
    },
    fromPartial(Ae) {
      const Me = C();
      return Me.data = Ae.data ?? new Uint8Array(), Me.path = Ae.path ?? "", Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Me.prove = Ae.prove ?? !1, Me;
    }
  };
  function w() {
    return {
      hash: new Uint8Array(),
      header: u.Header.fromPartial({}),
      lastCommitInfo: e.CommitInfo.fromPartial({}),
      byzantineValidators: []
    };
  }
  e.RequestBeginBlock = {
    typeUrl: "/tendermint.abci.RequestBeginBlock",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.hash.length !== 0 && Me.uint32(10).bytes(Ae.hash), Ae.header !== void 0 && u.Header.encode(Ae.header, Me.uint32(18).fork()).ldelim(), Ae.lastCommitInfo !== void 0 && e.CommitInfo.encode(Ae.lastCommitInfo, Me.uint32(26).fork()).ldelim();
      for (const He of Ae.byzantineValidators)
        e.Misbehavior.encode(He, Me.uint32(34).fork()).ldelim();
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = w();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.hash = He.bytes();
            break;
          case 2:
            Wt.header = u.Header.decode(He, He.uint32());
            break;
          case 3:
            Wt.lastCommitInfo = e.CommitInfo.decode(He, He.uint32());
            break;
          case 4:
            Wt.byzantineValidators.push(e.Misbehavior.decode(He, He.uint32()));
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = w();
      return (0, v.isSet)(Ae.hash) && (Me.hash = (0, v.bytesFromBase64)(Ae.hash)), (0, v.isSet)(Ae.header) && (Me.header = u.Header.fromJSON(Ae.header)), (0, v.isSet)(Ae.lastCommitInfo) && (Me.lastCommitInfo = e.CommitInfo.fromJSON(Ae.lastCommitInfo)), Array.isArray(Ae == null ? void 0 : Ae.byzantineValidators) && (Me.byzantineValidators = Ae.byzantineValidators.map((He) => e.Misbehavior.fromJSON(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.hash !== void 0 && (Me.hash = (0, v.base64FromBytes)(Ae.hash !== void 0 ? Ae.hash : new Uint8Array())), Ae.header !== void 0 && (Me.header = Ae.header ? u.Header.toJSON(Ae.header) : void 0), Ae.lastCommitInfo !== void 0 && (Me.lastCommitInfo = Ae.lastCommitInfo ? e.CommitInfo.toJSON(Ae.lastCommitInfo) : void 0), Ae.byzantineValidators ? Me.byzantineValidators = Ae.byzantineValidators.map((He) => He ? e.Misbehavior.toJSON(He) : void 0) : Me.byzantineValidators = [], Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = w();
      return Me.hash = Ae.hash ?? new Uint8Array(), Ae.header !== void 0 && Ae.header !== null && (Me.header = u.Header.fromPartial(Ae.header)), Ae.lastCommitInfo !== void 0 && Ae.lastCommitInfo !== null && (Me.lastCommitInfo = e.CommitInfo.fromPartial(Ae.lastCommitInfo)), Me.byzantineValidators = ((He = Ae.byzantineValidators) == null ? void 0 : He.map((cn) => e.Misbehavior.fromPartial(cn))) || [], Me;
    }
  };
  function P() {
    return {
      tx: new Uint8Array(),
      type: 0
    };
  }
  e.RequestCheckTx = {
    typeUrl: "/tendermint.abci.RequestCheckTx",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.tx.length !== 0 && Me.uint32(10).bytes(Ae.tx), Ae.type !== 0 && Me.uint32(16).int32(Ae.type), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = P();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.tx = He.bytes();
            break;
          case 2:
            Wt.type = He.int32();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = P();
      return (0, v.isSet)(Ae.tx) && (Me.tx = (0, v.bytesFromBase64)(Ae.tx)), (0, v.isSet)(Ae.type) && (Me.type = $(Ae.type)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.tx !== void 0 && (Me.tx = (0, v.base64FromBytes)(Ae.tx !== void 0 ? Ae.tx : new Uint8Array())), Ae.type !== void 0 && (Me.type = E(Ae.type)), Me;
    },
    fromPartial(Ae) {
      const Me = P();
      return Me.tx = Ae.tx ?? new Uint8Array(), Me.type = Ae.type ?? 0, Me;
    }
  };
  function J() {
    return {
      tx: new Uint8Array()
    };
  }
  e.RequestDeliverTx = {
    typeUrl: "/tendermint.abci.RequestDeliverTx",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.tx.length !== 0 && Me.uint32(10).bytes(Ae.tx), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = J();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.tx = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = J();
      return (0, v.isSet)(Ae.tx) && (Me.tx = (0, v.bytesFromBase64)(Ae.tx)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.tx !== void 0 && (Me.tx = (0, v.base64FromBytes)(Ae.tx !== void 0 ? Ae.tx : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      const Me = J();
      return Me.tx = Ae.tx ?? new Uint8Array(), Me;
    }
  };
  function se() {
    return {
      height: BigInt(0)
    };
  }
  e.RequestEndBlock = {
    typeUrl: "/tendermint.abci.RequestEndBlock",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.height !== BigInt(0) && Me.uint32(8).int64(Ae.height), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = se();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.height = He.int64();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = se();
      return (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Me;
    },
    fromPartial(Ae) {
      const Me = se();
      return Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Me;
    }
  };
  function fe() {
    return {};
  }
  e.RequestCommit = {
    typeUrl: "/tendermint.abci.RequestCommit",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = fe();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      return fe();
    },
    toJSON(Ae) {
      return {};
    },
    fromPartial(Ae) {
      return fe();
    }
  };
  function N() {
    return {};
  }
  e.RequestListSnapshots = {
    typeUrl: "/tendermint.abci.RequestListSnapshots",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = N();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      return N();
    },
    toJSON(Ae) {
      return {};
    },
    fromPartial(Ae) {
      return N();
    }
  };
  function W() {
    return {
      snapshot: void 0,
      appHash: new Uint8Array()
    };
  }
  e.RequestOfferSnapshot = {
    typeUrl: "/tendermint.abci.RequestOfferSnapshot",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.snapshot !== void 0 && e.Snapshot.encode(Ae.snapshot, Me.uint32(10).fork()).ldelim(), Ae.appHash.length !== 0 && Me.uint32(18).bytes(Ae.appHash), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = W();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.snapshot = e.Snapshot.decode(He, He.uint32());
            break;
          case 2:
            Wt.appHash = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = W();
      return (0, v.isSet)(Ae.snapshot) && (Me.snapshot = e.Snapshot.fromJSON(Ae.snapshot)), (0, v.isSet)(Ae.appHash) && (Me.appHash = (0, v.bytesFromBase64)(Ae.appHash)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.snapshot !== void 0 && (Me.snapshot = Ae.snapshot ? e.Snapshot.toJSON(Ae.snapshot) : void 0), Ae.appHash !== void 0 && (Me.appHash = (0, v.base64FromBytes)(Ae.appHash !== void 0 ? Ae.appHash : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      const Me = W();
      return Ae.snapshot !== void 0 && Ae.snapshot !== null && (Me.snapshot = e.Snapshot.fromPartial(Ae.snapshot)), Me.appHash = Ae.appHash ?? new Uint8Array(), Me;
    }
  };
  function I() {
    return {
      height: BigInt(0),
      format: 0,
      chunk: 0
    };
  }
  e.RequestLoadSnapshotChunk = {
    typeUrl: "/tendermint.abci.RequestLoadSnapshotChunk",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.height !== BigInt(0) && Me.uint32(8).uint64(Ae.height), Ae.format !== 0 && Me.uint32(16).uint32(Ae.format), Ae.chunk !== 0 && Me.uint32(24).uint32(Ae.chunk), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = I();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.height = He.uint64();
            break;
          case 2:
            Wt.format = He.uint32();
            break;
          case 3:
            Wt.chunk = He.uint32();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = I();
      return (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), (0, v.isSet)(Ae.format) && (Me.format = Number(Ae.format)), (0, v.isSet)(Ae.chunk) && (Me.chunk = Number(Ae.chunk)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Ae.format !== void 0 && (Me.format = Math.round(Ae.format)), Ae.chunk !== void 0 && (Me.chunk = Math.round(Ae.chunk)), Me;
    },
    fromPartial(Ae) {
      const Me = I();
      return Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Me.format = Ae.format ?? 0, Me.chunk = Ae.chunk ?? 0, Me;
    }
  };
  function te() {
    return {
      index: 0,
      chunk: new Uint8Array(),
      sender: ""
    };
  }
  e.RequestApplySnapshotChunk = {
    typeUrl: "/tendermint.abci.RequestApplySnapshotChunk",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.index !== 0 && Me.uint32(8).uint32(Ae.index), Ae.chunk.length !== 0 && Me.uint32(18).bytes(Ae.chunk), Ae.sender !== "" && Me.uint32(26).string(Ae.sender), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = te();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.index = He.uint32();
            break;
          case 2:
            Wt.chunk = He.bytes();
            break;
          case 3:
            Wt.sender = He.string();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = te();
      return (0, v.isSet)(Ae.index) && (Me.index = Number(Ae.index)), (0, v.isSet)(Ae.chunk) && (Me.chunk = (0, v.bytesFromBase64)(Ae.chunk)), (0, v.isSet)(Ae.sender) && (Me.sender = String(Ae.sender)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.index !== void 0 && (Me.index = Math.round(Ae.index)), Ae.chunk !== void 0 && (Me.chunk = (0, v.base64FromBytes)(Ae.chunk !== void 0 ? Ae.chunk : new Uint8Array())), Ae.sender !== void 0 && (Me.sender = Ae.sender), Me;
    },
    fromPartial(Ae) {
      const Me = te();
      return Me.index = Ae.index ?? 0, Me.chunk = Ae.chunk ?? new Uint8Array(), Me.sender = Ae.sender ?? "", Me;
    }
  };
  function ge() {
    return {
      maxTxBytes: BigInt(0),
      txs: [],
      localLastCommit: e.ExtendedCommitInfo.fromPartial({}),
      misbehavior: [],
      height: BigInt(0),
      time: n.Timestamp.fromPartial({}),
      nextValidatorsHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.RequestPrepareProposal = {
    typeUrl: "/tendermint.abci.RequestPrepareProposal",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.maxTxBytes !== BigInt(0) && Me.uint32(8).int64(Ae.maxTxBytes);
      for (const He of Ae.txs)
        Me.uint32(18).bytes(He);
      Ae.localLastCommit !== void 0 && e.ExtendedCommitInfo.encode(Ae.localLastCommit, Me.uint32(26).fork()).ldelim();
      for (const He of Ae.misbehavior)
        e.Misbehavior.encode(He, Me.uint32(34).fork()).ldelim();
      return Ae.height !== BigInt(0) && Me.uint32(40).int64(Ae.height), Ae.time !== void 0 && n.Timestamp.encode(Ae.time, Me.uint32(50).fork()).ldelim(), Ae.nextValidatorsHash.length !== 0 && Me.uint32(58).bytes(Ae.nextValidatorsHash), Ae.proposerAddress.length !== 0 && Me.uint32(66).bytes(Ae.proposerAddress), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = ge();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.maxTxBytes = He.int64();
            break;
          case 2:
            Wt.txs.push(He.bytes());
            break;
          case 3:
            Wt.localLastCommit = e.ExtendedCommitInfo.decode(He, He.uint32());
            break;
          case 4:
            Wt.misbehavior.push(e.Misbehavior.decode(He, He.uint32()));
            break;
          case 5:
            Wt.height = He.int64();
            break;
          case 6:
            Wt.time = n.Timestamp.decode(He, He.uint32());
            break;
          case 7:
            Wt.nextValidatorsHash = He.bytes();
            break;
          case 8:
            Wt.proposerAddress = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = ge();
      return (0, v.isSet)(Ae.maxTxBytes) && (Me.maxTxBytes = BigInt(Ae.maxTxBytes.toString())), Array.isArray(Ae == null ? void 0 : Ae.txs) && (Me.txs = Ae.txs.map((He) => (0, v.bytesFromBase64)(He))), (0, v.isSet)(Ae.localLastCommit) && (Me.localLastCommit = e.ExtendedCommitInfo.fromJSON(Ae.localLastCommit)), Array.isArray(Ae == null ? void 0 : Ae.misbehavior) && (Me.misbehavior = Ae.misbehavior.map((He) => e.Misbehavior.fromJSON(He))), (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), (0, v.isSet)(Ae.time) && (Me.time = (0, v.fromJsonTimestamp)(Ae.time)), (0, v.isSet)(Ae.nextValidatorsHash) && (Me.nextValidatorsHash = (0, v.bytesFromBase64)(Ae.nextValidatorsHash)), (0, v.isSet)(Ae.proposerAddress) && (Me.proposerAddress = (0, v.bytesFromBase64)(Ae.proposerAddress)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.maxTxBytes !== void 0 && (Me.maxTxBytes = (Ae.maxTxBytes || BigInt(0)).toString()), Ae.txs ? Me.txs = Ae.txs.map((He) => (0, v.base64FromBytes)(He !== void 0 ? He : new Uint8Array())) : Me.txs = [], Ae.localLastCommit !== void 0 && (Me.localLastCommit = Ae.localLastCommit ? e.ExtendedCommitInfo.toJSON(Ae.localLastCommit) : void 0), Ae.misbehavior ? Me.misbehavior = Ae.misbehavior.map((He) => He ? e.Misbehavior.toJSON(He) : void 0) : Me.misbehavior = [], Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Ae.time !== void 0 && (Me.time = (0, v.fromTimestamp)(Ae.time).toISOString()), Ae.nextValidatorsHash !== void 0 && (Me.nextValidatorsHash = (0, v.base64FromBytes)(Ae.nextValidatorsHash !== void 0 ? Ae.nextValidatorsHash : new Uint8Array())), Ae.proposerAddress !== void 0 && (Me.proposerAddress = (0, v.base64FromBytes)(Ae.proposerAddress !== void 0 ? Ae.proposerAddress : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      var He, cn;
      const Me = ge();
      return Ae.maxTxBytes !== void 0 && Ae.maxTxBytes !== null && (Me.maxTxBytes = BigInt(Ae.maxTxBytes.toString())), Me.txs = ((He = Ae.txs) == null ? void 0 : He.map((Wt) => Wt)) || [], Ae.localLastCommit !== void 0 && Ae.localLastCommit !== null && (Me.localLastCommit = e.ExtendedCommitInfo.fromPartial(Ae.localLastCommit)), Me.misbehavior = ((cn = Ae.misbehavior) == null ? void 0 : cn.map((Wt) => e.Misbehavior.fromPartial(Wt))) || [], Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Ae.time !== void 0 && Ae.time !== null && (Me.time = n.Timestamp.fromPartial(Ae.time)), Me.nextValidatorsHash = Ae.nextValidatorsHash ?? new Uint8Array(), Me.proposerAddress = Ae.proposerAddress ?? new Uint8Array(), Me;
    }
  };
  function Pe() {
    return {
      txs: [],
      proposedLastCommit: e.CommitInfo.fromPartial({}),
      misbehavior: [],
      hash: new Uint8Array(),
      height: BigInt(0),
      time: n.Timestamp.fromPartial({}),
      nextValidatorsHash: new Uint8Array(),
      proposerAddress: new Uint8Array()
    };
  }
  e.RequestProcessProposal = {
    typeUrl: "/tendermint.abci.RequestProcessProposal",
    encode(Ae, Me = m.BinaryWriter.create()) {
      for (const He of Ae.txs)
        Me.uint32(10).bytes(He);
      Ae.proposedLastCommit !== void 0 && e.CommitInfo.encode(Ae.proposedLastCommit, Me.uint32(18).fork()).ldelim();
      for (const He of Ae.misbehavior)
        e.Misbehavior.encode(He, Me.uint32(26).fork()).ldelim();
      return Ae.hash.length !== 0 && Me.uint32(34).bytes(Ae.hash), Ae.height !== BigInt(0) && Me.uint32(40).int64(Ae.height), Ae.time !== void 0 && n.Timestamp.encode(Ae.time, Me.uint32(50).fork()).ldelim(), Ae.nextValidatorsHash.length !== 0 && Me.uint32(58).bytes(Ae.nextValidatorsHash), Ae.proposerAddress.length !== 0 && Me.uint32(66).bytes(Ae.proposerAddress), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Pe();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.txs.push(He.bytes());
            break;
          case 2:
            Wt.proposedLastCommit = e.CommitInfo.decode(He, He.uint32());
            break;
          case 3:
            Wt.misbehavior.push(e.Misbehavior.decode(He, He.uint32()));
            break;
          case 4:
            Wt.hash = He.bytes();
            break;
          case 5:
            Wt.height = He.int64();
            break;
          case 6:
            Wt.time = n.Timestamp.decode(He, He.uint32());
            break;
          case 7:
            Wt.nextValidatorsHash = He.bytes();
            break;
          case 8:
            Wt.proposerAddress = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Pe();
      return Array.isArray(Ae == null ? void 0 : Ae.txs) && (Me.txs = Ae.txs.map((He) => (0, v.bytesFromBase64)(He))), (0, v.isSet)(Ae.proposedLastCommit) && (Me.proposedLastCommit = e.CommitInfo.fromJSON(Ae.proposedLastCommit)), Array.isArray(Ae == null ? void 0 : Ae.misbehavior) && (Me.misbehavior = Ae.misbehavior.map((He) => e.Misbehavior.fromJSON(He))), (0, v.isSet)(Ae.hash) && (Me.hash = (0, v.bytesFromBase64)(Ae.hash)), (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), (0, v.isSet)(Ae.time) && (Me.time = (0, v.fromJsonTimestamp)(Ae.time)), (0, v.isSet)(Ae.nextValidatorsHash) && (Me.nextValidatorsHash = (0, v.bytesFromBase64)(Ae.nextValidatorsHash)), (0, v.isSet)(Ae.proposerAddress) && (Me.proposerAddress = (0, v.bytesFromBase64)(Ae.proposerAddress)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.txs ? Me.txs = Ae.txs.map((He) => (0, v.base64FromBytes)(He !== void 0 ? He : new Uint8Array())) : Me.txs = [], Ae.proposedLastCommit !== void 0 && (Me.proposedLastCommit = Ae.proposedLastCommit ? e.CommitInfo.toJSON(Ae.proposedLastCommit) : void 0), Ae.misbehavior ? Me.misbehavior = Ae.misbehavior.map((He) => He ? e.Misbehavior.toJSON(He) : void 0) : Me.misbehavior = [], Ae.hash !== void 0 && (Me.hash = (0, v.base64FromBytes)(Ae.hash !== void 0 ? Ae.hash : new Uint8Array())), Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Ae.time !== void 0 && (Me.time = (0, v.fromTimestamp)(Ae.time).toISOString()), Ae.nextValidatorsHash !== void 0 && (Me.nextValidatorsHash = (0, v.base64FromBytes)(Ae.nextValidatorsHash !== void 0 ? Ae.nextValidatorsHash : new Uint8Array())), Ae.proposerAddress !== void 0 && (Me.proposerAddress = (0, v.base64FromBytes)(Ae.proposerAddress !== void 0 ? Ae.proposerAddress : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      var He, cn;
      const Me = Pe();
      return Me.txs = ((He = Ae.txs) == null ? void 0 : He.map((Wt) => Wt)) || [], Ae.proposedLastCommit !== void 0 && Ae.proposedLastCommit !== null && (Me.proposedLastCommit = e.CommitInfo.fromPartial(Ae.proposedLastCommit)), Me.misbehavior = ((cn = Ae.misbehavior) == null ? void 0 : cn.map((Wt) => e.Misbehavior.fromPartial(Wt))) || [], Me.hash = Ae.hash ?? new Uint8Array(), Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Ae.time !== void 0 && Ae.time !== null && (Me.time = n.Timestamp.fromPartial(Ae.time)), Me.nextValidatorsHash = Ae.nextValidatorsHash ?? new Uint8Array(), Me.proposerAddress = Ae.proposerAddress ?? new Uint8Array(), Me;
    }
  };
  function Ke() {
    return {
      exception: void 0,
      echo: void 0,
      flush: void 0,
      info: void 0,
      initChain: void 0,
      query: void 0,
      beginBlock: void 0,
      checkTx: void 0,
      deliverTx: void 0,
      endBlock: void 0,
      commit: void 0,
      listSnapshots: void 0,
      offerSnapshot: void 0,
      loadSnapshotChunk: void 0,
      applySnapshotChunk: void 0,
      prepareProposal: void 0,
      processProposal: void 0
    };
  }
  e.Response = {
    typeUrl: "/tendermint.abci.Response",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.exception !== void 0 && e.ResponseException.encode(Ae.exception, Me.uint32(10).fork()).ldelim(), Ae.echo !== void 0 && e.ResponseEcho.encode(Ae.echo, Me.uint32(18).fork()).ldelim(), Ae.flush !== void 0 && e.ResponseFlush.encode(Ae.flush, Me.uint32(26).fork()).ldelim(), Ae.info !== void 0 && e.ResponseInfo.encode(Ae.info, Me.uint32(34).fork()).ldelim(), Ae.initChain !== void 0 && e.ResponseInitChain.encode(Ae.initChain, Me.uint32(50).fork()).ldelim(), Ae.query !== void 0 && e.ResponseQuery.encode(Ae.query, Me.uint32(58).fork()).ldelim(), Ae.beginBlock !== void 0 && e.ResponseBeginBlock.encode(Ae.beginBlock, Me.uint32(66).fork()).ldelim(), Ae.checkTx !== void 0 && e.ResponseCheckTx.encode(Ae.checkTx, Me.uint32(74).fork()).ldelim(), Ae.deliverTx !== void 0 && e.ResponseDeliverTx.encode(Ae.deliverTx, Me.uint32(82).fork()).ldelim(), Ae.endBlock !== void 0 && e.ResponseEndBlock.encode(Ae.endBlock, Me.uint32(90).fork()).ldelim(), Ae.commit !== void 0 && e.ResponseCommit.encode(Ae.commit, Me.uint32(98).fork()).ldelim(), Ae.listSnapshots !== void 0 && e.ResponseListSnapshots.encode(Ae.listSnapshots, Me.uint32(106).fork()).ldelim(), Ae.offerSnapshot !== void 0 && e.ResponseOfferSnapshot.encode(Ae.offerSnapshot, Me.uint32(114).fork()).ldelim(), Ae.loadSnapshotChunk !== void 0 && e.ResponseLoadSnapshotChunk.encode(Ae.loadSnapshotChunk, Me.uint32(122).fork()).ldelim(), Ae.applySnapshotChunk !== void 0 && e.ResponseApplySnapshotChunk.encode(Ae.applySnapshotChunk, Me.uint32(130).fork()).ldelim(), Ae.prepareProposal !== void 0 && e.ResponsePrepareProposal.encode(Ae.prepareProposal, Me.uint32(138).fork()).ldelim(), Ae.processProposal !== void 0 && e.ResponseProcessProposal.encode(Ae.processProposal, Me.uint32(146).fork()).ldelim(), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Ke();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.exception = e.ResponseException.decode(He, He.uint32());
            break;
          case 2:
            Wt.echo = e.ResponseEcho.decode(He, He.uint32());
            break;
          case 3:
            Wt.flush = e.ResponseFlush.decode(He, He.uint32());
            break;
          case 4:
            Wt.info = e.ResponseInfo.decode(He, He.uint32());
            break;
          case 6:
            Wt.initChain = e.ResponseInitChain.decode(He, He.uint32());
            break;
          case 7:
            Wt.query = e.ResponseQuery.decode(He, He.uint32());
            break;
          case 8:
            Wt.beginBlock = e.ResponseBeginBlock.decode(He, He.uint32());
            break;
          case 9:
            Wt.checkTx = e.ResponseCheckTx.decode(He, He.uint32());
            break;
          case 10:
            Wt.deliverTx = e.ResponseDeliverTx.decode(He, He.uint32());
            break;
          case 11:
            Wt.endBlock = e.ResponseEndBlock.decode(He, He.uint32());
            break;
          case 12:
            Wt.commit = e.ResponseCommit.decode(He, He.uint32());
            break;
          case 13:
            Wt.listSnapshots = e.ResponseListSnapshots.decode(He, He.uint32());
            break;
          case 14:
            Wt.offerSnapshot = e.ResponseOfferSnapshot.decode(He, He.uint32());
            break;
          case 15:
            Wt.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.decode(He, He.uint32());
            break;
          case 16:
            Wt.applySnapshotChunk = e.ResponseApplySnapshotChunk.decode(He, He.uint32());
            break;
          case 17:
            Wt.prepareProposal = e.ResponsePrepareProposal.decode(He, He.uint32());
            break;
          case 18:
            Wt.processProposal = e.ResponseProcessProposal.decode(He, He.uint32());
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Ke();
      return (0, v.isSet)(Ae.exception) && (Me.exception = e.ResponseException.fromJSON(Ae.exception)), (0, v.isSet)(Ae.echo) && (Me.echo = e.ResponseEcho.fromJSON(Ae.echo)), (0, v.isSet)(Ae.flush) && (Me.flush = e.ResponseFlush.fromJSON(Ae.flush)), (0, v.isSet)(Ae.info) && (Me.info = e.ResponseInfo.fromJSON(Ae.info)), (0, v.isSet)(Ae.initChain) && (Me.initChain = e.ResponseInitChain.fromJSON(Ae.initChain)), (0, v.isSet)(Ae.query) && (Me.query = e.ResponseQuery.fromJSON(Ae.query)), (0, v.isSet)(Ae.beginBlock) && (Me.beginBlock = e.ResponseBeginBlock.fromJSON(Ae.beginBlock)), (0, v.isSet)(Ae.checkTx) && (Me.checkTx = e.ResponseCheckTx.fromJSON(Ae.checkTx)), (0, v.isSet)(Ae.deliverTx) && (Me.deliverTx = e.ResponseDeliverTx.fromJSON(Ae.deliverTx)), (0, v.isSet)(Ae.endBlock) && (Me.endBlock = e.ResponseEndBlock.fromJSON(Ae.endBlock)), (0, v.isSet)(Ae.commit) && (Me.commit = e.ResponseCommit.fromJSON(Ae.commit)), (0, v.isSet)(Ae.listSnapshots) && (Me.listSnapshots = e.ResponseListSnapshots.fromJSON(Ae.listSnapshots)), (0, v.isSet)(Ae.offerSnapshot) && (Me.offerSnapshot = e.ResponseOfferSnapshot.fromJSON(Ae.offerSnapshot)), (0, v.isSet)(Ae.loadSnapshotChunk) && (Me.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.fromJSON(Ae.loadSnapshotChunk)), (0, v.isSet)(Ae.applySnapshotChunk) && (Me.applySnapshotChunk = e.ResponseApplySnapshotChunk.fromJSON(Ae.applySnapshotChunk)), (0, v.isSet)(Ae.prepareProposal) && (Me.prepareProposal = e.ResponsePrepareProposal.fromJSON(Ae.prepareProposal)), (0, v.isSet)(Ae.processProposal) && (Me.processProposal = e.ResponseProcessProposal.fromJSON(Ae.processProposal)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.exception !== void 0 && (Me.exception = Ae.exception ? e.ResponseException.toJSON(Ae.exception) : void 0), Ae.echo !== void 0 && (Me.echo = Ae.echo ? e.ResponseEcho.toJSON(Ae.echo) : void 0), Ae.flush !== void 0 && (Me.flush = Ae.flush ? e.ResponseFlush.toJSON(Ae.flush) : void 0), Ae.info !== void 0 && (Me.info = Ae.info ? e.ResponseInfo.toJSON(Ae.info) : void 0), Ae.initChain !== void 0 && (Me.initChain = Ae.initChain ? e.ResponseInitChain.toJSON(Ae.initChain) : void 0), Ae.query !== void 0 && (Me.query = Ae.query ? e.ResponseQuery.toJSON(Ae.query) : void 0), Ae.beginBlock !== void 0 && (Me.beginBlock = Ae.beginBlock ? e.ResponseBeginBlock.toJSON(Ae.beginBlock) : void 0), Ae.checkTx !== void 0 && (Me.checkTx = Ae.checkTx ? e.ResponseCheckTx.toJSON(Ae.checkTx) : void 0), Ae.deliverTx !== void 0 && (Me.deliverTx = Ae.deliverTx ? e.ResponseDeliverTx.toJSON(Ae.deliverTx) : void 0), Ae.endBlock !== void 0 && (Me.endBlock = Ae.endBlock ? e.ResponseEndBlock.toJSON(Ae.endBlock) : void 0), Ae.commit !== void 0 && (Me.commit = Ae.commit ? e.ResponseCommit.toJSON(Ae.commit) : void 0), Ae.listSnapshots !== void 0 && (Me.listSnapshots = Ae.listSnapshots ? e.ResponseListSnapshots.toJSON(Ae.listSnapshots) : void 0), Ae.offerSnapshot !== void 0 && (Me.offerSnapshot = Ae.offerSnapshot ? e.ResponseOfferSnapshot.toJSON(Ae.offerSnapshot) : void 0), Ae.loadSnapshotChunk !== void 0 && (Me.loadSnapshotChunk = Ae.loadSnapshotChunk ? e.ResponseLoadSnapshotChunk.toJSON(Ae.loadSnapshotChunk) : void 0), Ae.applySnapshotChunk !== void 0 && (Me.applySnapshotChunk = Ae.applySnapshotChunk ? e.ResponseApplySnapshotChunk.toJSON(Ae.applySnapshotChunk) : void 0), Ae.prepareProposal !== void 0 && (Me.prepareProposal = Ae.prepareProposal ? e.ResponsePrepareProposal.toJSON(Ae.prepareProposal) : void 0), Ae.processProposal !== void 0 && (Me.processProposal = Ae.processProposal ? e.ResponseProcessProposal.toJSON(Ae.processProposal) : void 0), Me;
    },
    fromPartial(Ae) {
      const Me = Ke();
      return Ae.exception !== void 0 && Ae.exception !== null && (Me.exception = e.ResponseException.fromPartial(Ae.exception)), Ae.echo !== void 0 && Ae.echo !== null && (Me.echo = e.ResponseEcho.fromPartial(Ae.echo)), Ae.flush !== void 0 && Ae.flush !== null && (Me.flush = e.ResponseFlush.fromPartial(Ae.flush)), Ae.info !== void 0 && Ae.info !== null && (Me.info = e.ResponseInfo.fromPartial(Ae.info)), Ae.initChain !== void 0 && Ae.initChain !== null && (Me.initChain = e.ResponseInitChain.fromPartial(Ae.initChain)), Ae.query !== void 0 && Ae.query !== null && (Me.query = e.ResponseQuery.fromPartial(Ae.query)), Ae.beginBlock !== void 0 && Ae.beginBlock !== null && (Me.beginBlock = e.ResponseBeginBlock.fromPartial(Ae.beginBlock)), Ae.checkTx !== void 0 && Ae.checkTx !== null && (Me.checkTx = e.ResponseCheckTx.fromPartial(Ae.checkTx)), Ae.deliverTx !== void 0 && Ae.deliverTx !== null && (Me.deliverTx = e.ResponseDeliverTx.fromPartial(Ae.deliverTx)), Ae.endBlock !== void 0 && Ae.endBlock !== null && (Me.endBlock = e.ResponseEndBlock.fromPartial(Ae.endBlock)), Ae.commit !== void 0 && Ae.commit !== null && (Me.commit = e.ResponseCommit.fromPartial(Ae.commit)), Ae.listSnapshots !== void 0 && Ae.listSnapshots !== null && (Me.listSnapshots = e.ResponseListSnapshots.fromPartial(Ae.listSnapshots)), Ae.offerSnapshot !== void 0 && Ae.offerSnapshot !== null && (Me.offerSnapshot = e.ResponseOfferSnapshot.fromPartial(Ae.offerSnapshot)), Ae.loadSnapshotChunk !== void 0 && Ae.loadSnapshotChunk !== null && (Me.loadSnapshotChunk = e.ResponseLoadSnapshotChunk.fromPartial(Ae.loadSnapshotChunk)), Ae.applySnapshotChunk !== void 0 && Ae.applySnapshotChunk !== null && (Me.applySnapshotChunk = e.ResponseApplySnapshotChunk.fromPartial(Ae.applySnapshotChunk)), Ae.prepareProposal !== void 0 && Ae.prepareProposal !== null && (Me.prepareProposal = e.ResponsePrepareProposal.fromPartial(Ae.prepareProposal)), Ae.processProposal !== void 0 && Ae.processProposal !== null && (Me.processProposal = e.ResponseProcessProposal.fromPartial(Ae.processProposal)), Me;
    }
  };
  function xe() {
    return {
      error: ""
    };
  }
  e.ResponseException = {
    typeUrl: "/tendermint.abci.ResponseException",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.error !== "" && Me.uint32(10).string(Ae.error), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = xe();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.error = He.string();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = xe();
      return (0, v.isSet)(Ae.error) && (Me.error = String(Ae.error)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.error !== void 0 && (Me.error = Ae.error), Me;
    },
    fromPartial(Ae) {
      const Me = xe();
      return Me.error = Ae.error ?? "", Me;
    }
  };
  function ze() {
    return {
      message: ""
    };
  }
  e.ResponseEcho = {
    typeUrl: "/tendermint.abci.ResponseEcho",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.message !== "" && Me.uint32(10).string(Ae.message), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = ze();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.message = He.string();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = ze();
      return (0, v.isSet)(Ae.message) && (Me.message = String(Ae.message)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.message !== void 0 && (Me.message = Ae.message), Me;
    },
    fromPartial(Ae) {
      const Me = ze();
      return Me.message = Ae.message ?? "", Me;
    }
  };
  function nt() {
    return {};
  }
  e.ResponseFlush = {
    typeUrl: "/tendermint.abci.ResponseFlush",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = nt();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      return nt();
    },
    toJSON(Ae) {
      return {};
    },
    fromPartial(Ae) {
      return nt();
    }
  };
  function Qt() {
    return {
      data: "",
      version: "",
      appVersion: BigInt(0),
      lastBlockHeight: BigInt(0),
      lastBlockAppHash: new Uint8Array()
    };
  }
  e.ResponseInfo = {
    typeUrl: "/tendermint.abci.ResponseInfo",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.data !== "" && Me.uint32(10).string(Ae.data), Ae.version !== "" && Me.uint32(18).string(Ae.version), Ae.appVersion !== BigInt(0) && Me.uint32(24).uint64(Ae.appVersion), Ae.lastBlockHeight !== BigInt(0) && Me.uint32(32).int64(Ae.lastBlockHeight), Ae.lastBlockAppHash.length !== 0 && Me.uint32(42).bytes(Ae.lastBlockAppHash), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Qt();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.data = He.string();
            break;
          case 2:
            Wt.version = He.string();
            break;
          case 3:
            Wt.appVersion = He.uint64();
            break;
          case 4:
            Wt.lastBlockHeight = He.int64();
            break;
          case 5:
            Wt.lastBlockAppHash = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Qt();
      return (0, v.isSet)(Ae.data) && (Me.data = String(Ae.data)), (0, v.isSet)(Ae.version) && (Me.version = String(Ae.version)), (0, v.isSet)(Ae.appVersion) && (Me.appVersion = BigInt(Ae.appVersion.toString())), (0, v.isSet)(Ae.lastBlockHeight) && (Me.lastBlockHeight = BigInt(Ae.lastBlockHeight.toString())), (0, v.isSet)(Ae.lastBlockAppHash) && (Me.lastBlockAppHash = (0, v.bytesFromBase64)(Ae.lastBlockAppHash)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.data !== void 0 && (Me.data = Ae.data), Ae.version !== void 0 && (Me.version = Ae.version), Ae.appVersion !== void 0 && (Me.appVersion = (Ae.appVersion || BigInt(0)).toString()), Ae.lastBlockHeight !== void 0 && (Me.lastBlockHeight = (Ae.lastBlockHeight || BigInt(0)).toString()), Ae.lastBlockAppHash !== void 0 && (Me.lastBlockAppHash = (0, v.base64FromBytes)(Ae.lastBlockAppHash !== void 0 ? Ae.lastBlockAppHash : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      const Me = Qt();
      return Me.data = Ae.data ?? "", Me.version = Ae.version ?? "", Ae.appVersion !== void 0 && Ae.appVersion !== null && (Me.appVersion = BigInt(Ae.appVersion.toString())), Ae.lastBlockHeight !== void 0 && Ae.lastBlockHeight !== null && (Me.lastBlockHeight = BigInt(Ae.lastBlockHeight.toString())), Me.lastBlockAppHash = Ae.lastBlockAppHash ?? new Uint8Array(), Me;
    }
  };
  function Et() {
    return {
      consensusParams: void 0,
      validators: [],
      appHash: new Uint8Array()
    };
  }
  e.ResponseInitChain = {
    typeUrl: "/tendermint.abci.ResponseInitChain",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.consensusParams !== void 0 && o.ConsensusParams.encode(Ae.consensusParams, Me.uint32(10).fork()).ldelim();
      for (const He of Ae.validators)
        e.ValidatorUpdate.encode(He, Me.uint32(18).fork()).ldelim();
      return Ae.appHash.length !== 0 && Me.uint32(26).bytes(Ae.appHash), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Et();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.consensusParams = o.ConsensusParams.decode(He, He.uint32());
            break;
          case 2:
            Wt.validators.push(e.ValidatorUpdate.decode(He, He.uint32()));
            break;
          case 3:
            Wt.appHash = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Et();
      return (0, v.isSet)(Ae.consensusParams) && (Me.consensusParams = o.ConsensusParams.fromJSON(Ae.consensusParams)), Array.isArray(Ae == null ? void 0 : Ae.validators) && (Me.validators = Ae.validators.map((He) => e.ValidatorUpdate.fromJSON(He))), (0, v.isSet)(Ae.appHash) && (Me.appHash = (0, v.bytesFromBase64)(Ae.appHash)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.consensusParams !== void 0 && (Me.consensusParams = Ae.consensusParams ? o.ConsensusParams.toJSON(Ae.consensusParams) : void 0), Ae.validators ? Me.validators = Ae.validators.map((He) => He ? e.ValidatorUpdate.toJSON(He) : void 0) : Me.validators = [], Ae.appHash !== void 0 && (Me.appHash = (0, v.base64FromBytes)(Ae.appHash !== void 0 ? Ae.appHash : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = Et();
      return Ae.consensusParams !== void 0 && Ae.consensusParams !== null && (Me.consensusParams = o.ConsensusParams.fromPartial(Ae.consensusParams)), Me.validators = ((He = Ae.validators) == null ? void 0 : He.map((cn) => e.ValidatorUpdate.fromPartial(cn))) || [], Me.appHash = Ae.appHash ?? new Uint8Array(), Me;
    }
  };
  function zt() {
    return {
      code: 0,
      log: "",
      info: "",
      index: BigInt(0),
      key: new Uint8Array(),
      value: new Uint8Array(),
      proofOps: void 0,
      height: BigInt(0),
      codespace: ""
    };
  }
  e.ResponseQuery = {
    typeUrl: "/tendermint.abci.ResponseQuery",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.code !== 0 && Me.uint32(8).uint32(Ae.code), Ae.log !== "" && Me.uint32(26).string(Ae.log), Ae.info !== "" && Me.uint32(34).string(Ae.info), Ae.index !== BigInt(0) && Me.uint32(40).int64(Ae.index), Ae.key.length !== 0 && Me.uint32(50).bytes(Ae.key), Ae.value.length !== 0 && Me.uint32(58).bytes(Ae.value), Ae.proofOps !== void 0 && c.ProofOps.encode(Ae.proofOps, Me.uint32(66).fork()).ldelim(), Ae.height !== BigInt(0) && Me.uint32(72).int64(Ae.height), Ae.codespace !== "" && Me.uint32(82).string(Ae.codespace), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = zt();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.code = He.uint32();
            break;
          case 3:
            Wt.log = He.string();
            break;
          case 4:
            Wt.info = He.string();
            break;
          case 5:
            Wt.index = He.int64();
            break;
          case 6:
            Wt.key = He.bytes();
            break;
          case 7:
            Wt.value = He.bytes();
            break;
          case 8:
            Wt.proofOps = c.ProofOps.decode(He, He.uint32());
            break;
          case 9:
            Wt.height = He.int64();
            break;
          case 10:
            Wt.codespace = He.string();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = zt();
      return (0, v.isSet)(Ae.code) && (Me.code = Number(Ae.code)), (0, v.isSet)(Ae.log) && (Me.log = String(Ae.log)), (0, v.isSet)(Ae.info) && (Me.info = String(Ae.info)), (0, v.isSet)(Ae.index) && (Me.index = BigInt(Ae.index.toString())), (0, v.isSet)(Ae.key) && (Me.key = (0, v.bytesFromBase64)(Ae.key)), (0, v.isSet)(Ae.value) && (Me.value = (0, v.bytesFromBase64)(Ae.value)), (0, v.isSet)(Ae.proofOps) && (Me.proofOps = c.ProofOps.fromJSON(Ae.proofOps)), (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), (0, v.isSet)(Ae.codespace) && (Me.codespace = String(Ae.codespace)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.code !== void 0 && (Me.code = Math.round(Ae.code)), Ae.log !== void 0 && (Me.log = Ae.log), Ae.info !== void 0 && (Me.info = Ae.info), Ae.index !== void 0 && (Me.index = (Ae.index || BigInt(0)).toString()), Ae.key !== void 0 && (Me.key = (0, v.base64FromBytes)(Ae.key !== void 0 ? Ae.key : new Uint8Array())), Ae.value !== void 0 && (Me.value = (0, v.base64FromBytes)(Ae.value !== void 0 ? Ae.value : new Uint8Array())), Ae.proofOps !== void 0 && (Me.proofOps = Ae.proofOps ? c.ProofOps.toJSON(Ae.proofOps) : void 0), Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Ae.codespace !== void 0 && (Me.codespace = Ae.codespace), Me;
    },
    fromPartial(Ae) {
      const Me = zt();
      return Me.code = Ae.code ?? 0, Me.log = Ae.log ?? "", Me.info = Ae.info ?? "", Ae.index !== void 0 && Ae.index !== null && (Me.index = BigInt(Ae.index.toString())), Me.key = Ae.key ?? new Uint8Array(), Me.value = Ae.value ?? new Uint8Array(), Ae.proofOps !== void 0 && Ae.proofOps !== null && (Me.proofOps = c.ProofOps.fromPartial(Ae.proofOps)), Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Me.codespace = Ae.codespace ?? "", Me;
    }
  };
  function Nt() {
    return {
      events: []
    };
  }
  e.ResponseBeginBlock = {
    typeUrl: "/tendermint.abci.ResponseBeginBlock",
    encode(Ae, Me = m.BinaryWriter.create()) {
      for (const He of Ae.events)
        e.Event.encode(He, Me.uint32(10).fork()).ldelim();
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Nt();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.events.push(e.Event.decode(He, He.uint32()));
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Nt();
      return Array.isArray(Ae == null ? void 0 : Ae.events) && (Me.events = Ae.events.map((He) => e.Event.fromJSON(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.events ? Me.events = Ae.events.map((He) => He ? e.Event.toJSON(He) : void 0) : Me.events = [], Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = Nt();
      return Me.events = ((He = Ae.events) == null ? void 0 : He.map((cn) => e.Event.fromPartial(cn))) || [], Me;
    }
  };
  function pt() {
    return {
      code: 0,
      data: new Uint8Array(),
      log: "",
      info: "",
      gasWanted: BigInt(0),
      gasUsed: BigInt(0),
      events: [],
      codespace: "",
      sender: "",
      priority: BigInt(0),
      mempoolError: ""
    };
  }
  e.ResponseCheckTx = {
    typeUrl: "/tendermint.abci.ResponseCheckTx",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.code !== 0 && Me.uint32(8).uint32(Ae.code), Ae.data.length !== 0 && Me.uint32(18).bytes(Ae.data), Ae.log !== "" && Me.uint32(26).string(Ae.log), Ae.info !== "" && Me.uint32(34).string(Ae.info), Ae.gasWanted !== BigInt(0) && Me.uint32(40).int64(Ae.gasWanted), Ae.gasUsed !== BigInt(0) && Me.uint32(48).int64(Ae.gasUsed);
      for (const He of Ae.events)
        e.Event.encode(He, Me.uint32(58).fork()).ldelim();
      return Ae.codespace !== "" && Me.uint32(66).string(Ae.codespace), Ae.sender !== "" && Me.uint32(74).string(Ae.sender), Ae.priority !== BigInt(0) && Me.uint32(80).int64(Ae.priority), Ae.mempoolError !== "" && Me.uint32(90).string(Ae.mempoolError), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = pt();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.code = He.uint32();
            break;
          case 2:
            Wt.data = He.bytes();
            break;
          case 3:
            Wt.log = He.string();
            break;
          case 4:
            Wt.info = He.string();
            break;
          case 5:
            Wt.gasWanted = He.int64();
            break;
          case 6:
            Wt.gasUsed = He.int64();
            break;
          case 7:
            Wt.events.push(e.Event.decode(He, He.uint32()));
            break;
          case 8:
            Wt.codespace = He.string();
            break;
          case 9:
            Wt.sender = He.string();
            break;
          case 10:
            Wt.priority = He.int64();
            break;
          case 11:
            Wt.mempoolError = He.string();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = pt();
      return (0, v.isSet)(Ae.code) && (Me.code = Number(Ae.code)), (0, v.isSet)(Ae.data) && (Me.data = (0, v.bytesFromBase64)(Ae.data)), (0, v.isSet)(Ae.log) && (Me.log = String(Ae.log)), (0, v.isSet)(Ae.info) && (Me.info = String(Ae.info)), (0, v.isSet)(Ae.gas_wanted) && (Me.gasWanted = BigInt(Ae.gas_wanted.toString())), (0, v.isSet)(Ae.gas_used) && (Me.gasUsed = BigInt(Ae.gas_used.toString())), Array.isArray(Ae == null ? void 0 : Ae.events) && (Me.events = Ae.events.map((He) => e.Event.fromJSON(He))), (0, v.isSet)(Ae.codespace) && (Me.codespace = String(Ae.codespace)), (0, v.isSet)(Ae.sender) && (Me.sender = String(Ae.sender)), (0, v.isSet)(Ae.priority) && (Me.priority = BigInt(Ae.priority.toString())), (0, v.isSet)(Ae.mempoolError) && (Me.mempoolError = String(Ae.mempoolError)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.code !== void 0 && (Me.code = Math.round(Ae.code)), Ae.data !== void 0 && (Me.data = (0, v.base64FromBytes)(Ae.data !== void 0 ? Ae.data : new Uint8Array())), Ae.log !== void 0 && (Me.log = Ae.log), Ae.info !== void 0 && (Me.info = Ae.info), Ae.gasWanted !== void 0 && (Me.gas_wanted = (Ae.gasWanted || BigInt(0)).toString()), Ae.gasUsed !== void 0 && (Me.gas_used = (Ae.gasUsed || BigInt(0)).toString()), Ae.events ? Me.events = Ae.events.map((He) => He ? e.Event.toJSON(He) : void 0) : Me.events = [], Ae.codespace !== void 0 && (Me.codespace = Ae.codespace), Ae.sender !== void 0 && (Me.sender = Ae.sender), Ae.priority !== void 0 && (Me.priority = (Ae.priority || BigInt(0)).toString()), Ae.mempoolError !== void 0 && (Me.mempoolError = Ae.mempoolError), Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = pt();
      return Me.code = Ae.code ?? 0, Me.data = Ae.data ?? new Uint8Array(), Me.log = Ae.log ?? "", Me.info = Ae.info ?? "", Ae.gasWanted !== void 0 && Ae.gasWanted !== null && (Me.gasWanted = BigInt(Ae.gasWanted.toString())), Ae.gasUsed !== void 0 && Ae.gasUsed !== null && (Me.gasUsed = BigInt(Ae.gasUsed.toString())), Me.events = ((He = Ae.events) == null ? void 0 : He.map((cn) => e.Event.fromPartial(cn))) || [], Me.codespace = Ae.codespace ?? "", Me.sender = Ae.sender ?? "", Ae.priority !== void 0 && Ae.priority !== null && (Me.priority = BigInt(Ae.priority.toString())), Me.mempoolError = Ae.mempoolError ?? "", Me;
    }
  };
  function at() {
    return {
      code: 0,
      data: new Uint8Array(),
      log: "",
      info: "",
      gasWanted: BigInt(0),
      gasUsed: BigInt(0),
      events: [],
      codespace: ""
    };
  }
  e.ResponseDeliverTx = {
    typeUrl: "/tendermint.abci.ResponseDeliverTx",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.code !== 0 && Me.uint32(8).uint32(Ae.code), Ae.data.length !== 0 && Me.uint32(18).bytes(Ae.data), Ae.log !== "" && Me.uint32(26).string(Ae.log), Ae.info !== "" && Me.uint32(34).string(Ae.info), Ae.gasWanted !== BigInt(0) && Me.uint32(40).int64(Ae.gasWanted), Ae.gasUsed !== BigInt(0) && Me.uint32(48).int64(Ae.gasUsed);
      for (const He of Ae.events)
        e.Event.encode(He, Me.uint32(58).fork()).ldelim();
      return Ae.codespace !== "" && Me.uint32(66).string(Ae.codespace), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = at();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.code = He.uint32();
            break;
          case 2:
            Wt.data = He.bytes();
            break;
          case 3:
            Wt.log = He.string();
            break;
          case 4:
            Wt.info = He.string();
            break;
          case 5:
            Wt.gasWanted = He.int64();
            break;
          case 6:
            Wt.gasUsed = He.int64();
            break;
          case 7:
            Wt.events.push(e.Event.decode(He, He.uint32()));
            break;
          case 8:
            Wt.codespace = He.string();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = at();
      return (0, v.isSet)(Ae.code) && (Me.code = Number(Ae.code)), (0, v.isSet)(Ae.data) && (Me.data = (0, v.bytesFromBase64)(Ae.data)), (0, v.isSet)(Ae.log) && (Me.log = String(Ae.log)), (0, v.isSet)(Ae.info) && (Me.info = String(Ae.info)), (0, v.isSet)(Ae.gas_wanted) && (Me.gasWanted = BigInt(Ae.gas_wanted.toString())), (0, v.isSet)(Ae.gas_used) && (Me.gasUsed = BigInt(Ae.gas_used.toString())), Array.isArray(Ae == null ? void 0 : Ae.events) && (Me.events = Ae.events.map((He) => e.Event.fromJSON(He))), (0, v.isSet)(Ae.codespace) && (Me.codespace = String(Ae.codespace)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.code !== void 0 && (Me.code = Math.round(Ae.code)), Ae.data !== void 0 && (Me.data = (0, v.base64FromBytes)(Ae.data !== void 0 ? Ae.data : new Uint8Array())), Ae.log !== void 0 && (Me.log = Ae.log), Ae.info !== void 0 && (Me.info = Ae.info), Ae.gasWanted !== void 0 && (Me.gas_wanted = (Ae.gasWanted || BigInt(0)).toString()), Ae.gasUsed !== void 0 && (Me.gas_used = (Ae.gasUsed || BigInt(0)).toString()), Ae.events ? Me.events = Ae.events.map((He) => He ? e.Event.toJSON(He) : void 0) : Me.events = [], Ae.codespace !== void 0 && (Me.codespace = Ae.codespace), Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = at();
      return Me.code = Ae.code ?? 0, Me.data = Ae.data ?? new Uint8Array(), Me.log = Ae.log ?? "", Me.info = Ae.info ?? "", Ae.gasWanted !== void 0 && Ae.gasWanted !== null && (Me.gasWanted = BigInt(Ae.gasWanted.toString())), Ae.gasUsed !== void 0 && Ae.gasUsed !== null && (Me.gasUsed = BigInt(Ae.gasUsed.toString())), Me.events = ((He = Ae.events) == null ? void 0 : He.map((cn) => e.Event.fromPartial(cn))) || [], Me.codespace = Ae.codespace ?? "", Me;
    }
  };
  function kt() {
    return {
      validatorUpdates: [],
      consensusParamUpdates: void 0,
      events: []
    };
  }
  e.ResponseEndBlock = {
    typeUrl: "/tendermint.abci.ResponseEndBlock",
    encode(Ae, Me = m.BinaryWriter.create()) {
      for (const He of Ae.validatorUpdates)
        e.ValidatorUpdate.encode(He, Me.uint32(10).fork()).ldelim();
      Ae.consensusParamUpdates !== void 0 && o.ConsensusParams.encode(Ae.consensusParamUpdates, Me.uint32(18).fork()).ldelim();
      for (const He of Ae.events)
        e.Event.encode(He, Me.uint32(26).fork()).ldelim();
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = kt();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.validatorUpdates.push(e.ValidatorUpdate.decode(He, He.uint32()));
            break;
          case 2:
            Wt.consensusParamUpdates = o.ConsensusParams.decode(He, He.uint32());
            break;
          case 3:
            Wt.events.push(e.Event.decode(He, He.uint32()));
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = kt();
      return Array.isArray(Ae == null ? void 0 : Ae.validatorUpdates) && (Me.validatorUpdates = Ae.validatorUpdates.map((He) => e.ValidatorUpdate.fromJSON(He))), (0, v.isSet)(Ae.consensusParamUpdates) && (Me.consensusParamUpdates = o.ConsensusParams.fromJSON(Ae.consensusParamUpdates)), Array.isArray(Ae == null ? void 0 : Ae.events) && (Me.events = Ae.events.map((He) => e.Event.fromJSON(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.validatorUpdates ? Me.validatorUpdates = Ae.validatorUpdates.map((He) => He ? e.ValidatorUpdate.toJSON(He) : void 0) : Me.validatorUpdates = [], Ae.consensusParamUpdates !== void 0 && (Me.consensusParamUpdates = Ae.consensusParamUpdates ? o.ConsensusParams.toJSON(Ae.consensusParamUpdates) : void 0), Ae.events ? Me.events = Ae.events.map((He) => He ? e.Event.toJSON(He) : void 0) : Me.events = [], Me;
    },
    fromPartial(Ae) {
      var He, cn;
      const Me = kt();
      return Me.validatorUpdates = ((He = Ae.validatorUpdates) == null ? void 0 : He.map((Wt) => e.ValidatorUpdate.fromPartial(Wt))) || [], Ae.consensusParamUpdates !== void 0 && Ae.consensusParamUpdates !== null && (Me.consensusParamUpdates = o.ConsensusParams.fromPartial(Ae.consensusParamUpdates)), Me.events = ((cn = Ae.events) == null ? void 0 : cn.map((Wt) => e.Event.fromPartial(Wt))) || [], Me;
    }
  };
  function Ut() {
    return {
      data: new Uint8Array(),
      retainHeight: BigInt(0)
    };
  }
  e.ResponseCommit = {
    typeUrl: "/tendermint.abci.ResponseCommit",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.data.length !== 0 && Me.uint32(18).bytes(Ae.data), Ae.retainHeight !== BigInt(0) && Me.uint32(24).int64(Ae.retainHeight), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Ut();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 2:
            Wt.data = He.bytes();
            break;
          case 3:
            Wt.retainHeight = He.int64();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Ut();
      return (0, v.isSet)(Ae.data) && (Me.data = (0, v.bytesFromBase64)(Ae.data)), (0, v.isSet)(Ae.retainHeight) && (Me.retainHeight = BigInt(Ae.retainHeight.toString())), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.data !== void 0 && (Me.data = (0, v.base64FromBytes)(Ae.data !== void 0 ? Ae.data : new Uint8Array())), Ae.retainHeight !== void 0 && (Me.retainHeight = (Ae.retainHeight || BigInt(0)).toString()), Me;
    },
    fromPartial(Ae) {
      const Me = Ut();
      return Me.data = Ae.data ?? new Uint8Array(), Ae.retainHeight !== void 0 && Ae.retainHeight !== null && (Me.retainHeight = BigInt(Ae.retainHeight.toString())), Me;
    }
  };
  function dn() {
    return {
      snapshots: []
    };
  }
  e.ResponseListSnapshots = {
    typeUrl: "/tendermint.abci.ResponseListSnapshots",
    encode(Ae, Me = m.BinaryWriter.create()) {
      for (const He of Ae.snapshots)
        e.Snapshot.encode(He, Me.uint32(10).fork()).ldelim();
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = dn();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.snapshots.push(e.Snapshot.decode(He, He.uint32()));
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = dn();
      return Array.isArray(Ae == null ? void 0 : Ae.snapshots) && (Me.snapshots = Ae.snapshots.map((He) => e.Snapshot.fromJSON(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.snapshots ? Me.snapshots = Ae.snapshots.map((He) => He ? e.Snapshot.toJSON(He) : void 0) : Me.snapshots = [], Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = dn();
      return Me.snapshots = ((He = Ae.snapshots) == null ? void 0 : He.map((cn) => e.Snapshot.fromPartial(cn))) || [], Me;
    }
  };
  function En() {
    return {
      result: 0
    };
  }
  e.ResponseOfferSnapshot = {
    typeUrl: "/tendermint.abci.ResponseOfferSnapshot",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.result !== 0 && Me.uint32(8).int32(Ae.result), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = En();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.result = He.int32();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = En();
      return (0, v.isSet)(Ae.result) && (Me.result = T(Ae.result)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.result !== void 0 && (Me.result = y(Ae.result)), Me;
    },
    fromPartial(Ae) {
      const Me = En();
      return Me.result = Ae.result ?? 0, Me;
    }
  };
  function Ht() {
    return {
      chunk: new Uint8Array()
    };
  }
  e.ResponseLoadSnapshotChunk = {
    typeUrl: "/tendermint.abci.ResponseLoadSnapshotChunk",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.chunk.length !== 0 && Me.uint32(10).bytes(Ae.chunk), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Ht();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.chunk = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Ht();
      return (0, v.isSet)(Ae.chunk) && (Me.chunk = (0, v.bytesFromBase64)(Ae.chunk)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.chunk !== void 0 && (Me.chunk = (0, v.base64FromBytes)(Ae.chunk !== void 0 ? Ae.chunk : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      const Me = Ht();
      return Me.chunk = Ae.chunk ?? new Uint8Array(), Me;
    }
  };
  function Xt() {
    return {
      result: 0,
      refetchChunks: [],
      rejectSenders: []
    };
  }
  e.ResponseApplySnapshotChunk = {
    typeUrl: "/tendermint.abci.ResponseApplySnapshotChunk",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.result !== 0 && Me.uint32(8).int32(Ae.result), Me.uint32(18).fork();
      for (const He of Ae.refetchChunks)
        Me.uint32(He);
      Me.ldelim();
      for (const He of Ae.rejectSenders)
        Me.uint32(26).string(He);
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Xt();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.result = He.int32();
            break;
          case 2:
            if ((yn & 7) === 2) {
              const pr = He.uint32() + He.pos;
              for (; He.pos < pr; )
                Wt.refetchChunks.push(He.uint32());
            } else
              Wt.refetchChunks.push(He.uint32());
            break;
          case 3:
            Wt.rejectSenders.push(He.string());
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Xt();
      return (0, v.isSet)(Ae.result) && (Me.result = M(Ae.result)), Array.isArray(Ae == null ? void 0 : Ae.refetchChunks) && (Me.refetchChunks = Ae.refetchChunks.map((He) => Number(He))), Array.isArray(Ae == null ? void 0 : Ae.rejectSenders) && (Me.rejectSenders = Ae.rejectSenders.map((He) => String(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.result !== void 0 && (Me.result = G(Ae.result)), Ae.refetchChunks ? Me.refetchChunks = Ae.refetchChunks.map((He) => Math.round(He)) : Me.refetchChunks = [], Ae.rejectSenders ? Me.rejectSenders = Ae.rejectSenders.map((He) => He) : Me.rejectSenders = [], Me;
    },
    fromPartial(Ae) {
      var He, cn;
      const Me = Xt();
      return Me.result = Ae.result ?? 0, Me.refetchChunks = ((He = Ae.refetchChunks) == null ? void 0 : He.map((Wt) => Wt)) || [], Me.rejectSenders = ((cn = Ae.rejectSenders) == null ? void 0 : cn.map((Wt) => Wt)) || [], Me;
    }
  };
  function On() {
    return {
      txs: []
    };
  }
  e.ResponsePrepareProposal = {
    typeUrl: "/tendermint.abci.ResponsePrepareProposal",
    encode(Ae, Me = m.BinaryWriter.create()) {
      for (const He of Ae.txs)
        Me.uint32(10).bytes(He);
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = On();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.txs.push(He.bytes());
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = On();
      return Array.isArray(Ae == null ? void 0 : Ae.txs) && (Me.txs = Ae.txs.map((He) => (0, v.bytesFromBase64)(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.txs ? Me.txs = Ae.txs.map((He) => (0, v.base64FromBytes)(He !== void 0 ? He : new Uint8Array())) : Me.txs = [], Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = On();
      return Me.txs = ((He = Ae.txs) == null ? void 0 : He.map((cn) => cn)) || [], Me;
    }
  };
  function sn() {
    return {
      status: 0
    };
  }
  e.ResponseProcessProposal = {
    typeUrl: "/tendermint.abci.ResponseProcessProposal",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.status !== 0 && Me.uint32(8).int32(Ae.status), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = sn();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.status = He.int32();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = sn();
      return (0, v.isSet)(Ae.status) && (Me.status = F(Ae.status)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.status !== void 0 && (Me.status = X(Ae.status)), Me;
    },
    fromPartial(Ae) {
      const Me = sn();
      return Me.status = Ae.status ?? 0, Me;
    }
  };
  function At() {
    return {
      round: 0,
      votes: []
    };
  }
  e.CommitInfo = {
    typeUrl: "/tendermint.abci.CommitInfo",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.round !== 0 && Me.uint32(8).int32(Ae.round);
      for (const He of Ae.votes)
        e.VoteInfo.encode(He, Me.uint32(18).fork()).ldelim();
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = At();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.round = He.int32();
            break;
          case 2:
            Wt.votes.push(e.VoteInfo.decode(He, He.uint32()));
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = At();
      return (0, v.isSet)(Ae.round) && (Me.round = Number(Ae.round)), Array.isArray(Ae == null ? void 0 : Ae.votes) && (Me.votes = Ae.votes.map((He) => e.VoteInfo.fromJSON(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.round !== void 0 && (Me.round = Math.round(Ae.round)), Ae.votes ? Me.votes = Ae.votes.map((He) => He ? e.VoteInfo.toJSON(He) : void 0) : Me.votes = [], Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = At();
      return Me.round = Ae.round ?? 0, Me.votes = ((He = Ae.votes) == null ? void 0 : He.map((cn) => e.VoteInfo.fromPartial(cn))) || [], Me;
    }
  };
  function hn() {
    return {
      round: 0,
      votes: []
    };
  }
  e.ExtendedCommitInfo = {
    typeUrl: "/tendermint.abci.ExtendedCommitInfo",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.round !== 0 && Me.uint32(8).int32(Ae.round);
      for (const He of Ae.votes)
        e.ExtendedVoteInfo.encode(He, Me.uint32(18).fork()).ldelim();
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = hn();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.round = He.int32();
            break;
          case 2:
            Wt.votes.push(e.ExtendedVoteInfo.decode(He, He.uint32()));
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = hn();
      return (0, v.isSet)(Ae.round) && (Me.round = Number(Ae.round)), Array.isArray(Ae == null ? void 0 : Ae.votes) && (Me.votes = Ae.votes.map((He) => e.ExtendedVoteInfo.fromJSON(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.round !== void 0 && (Me.round = Math.round(Ae.round)), Ae.votes ? Me.votes = Ae.votes.map((He) => He ? e.ExtendedVoteInfo.toJSON(He) : void 0) : Me.votes = [], Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = hn();
      return Me.round = Ae.round ?? 0, Me.votes = ((He = Ae.votes) == null ? void 0 : He.map((cn) => e.ExtendedVoteInfo.fromPartial(cn))) || [], Me;
    }
  };
  function $t() {
    return {
      type: "",
      attributes: []
    };
  }
  e.Event = {
    typeUrl: "/tendermint.abci.Event",
    encode(Ae, Me = m.BinaryWriter.create()) {
      Ae.type !== "" && Me.uint32(10).string(Ae.type);
      for (const He of Ae.attributes)
        e.EventAttribute.encode(He, Me.uint32(18).fork()).ldelim();
      return Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = $t();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.type = He.string();
            break;
          case 2:
            Wt.attributes.push(e.EventAttribute.decode(He, He.uint32()));
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = $t();
      return (0, v.isSet)(Ae.type) && (Me.type = String(Ae.type)), Array.isArray(Ae == null ? void 0 : Ae.attributes) && (Me.attributes = Ae.attributes.map((He) => e.EventAttribute.fromJSON(He))), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.type !== void 0 && (Me.type = Ae.type), Ae.attributes ? Me.attributes = Ae.attributes.map((He) => He ? e.EventAttribute.toJSON(He) : void 0) : Me.attributes = [], Me;
    },
    fromPartial(Ae) {
      var He;
      const Me = $t();
      return Me.type = Ae.type ?? "", Me.attributes = ((He = Ae.attributes) == null ? void 0 : He.map((cn) => e.EventAttribute.fromPartial(cn))) || [], Me;
    }
  };
  function Lt() {
    return {
      key: "",
      value: "",
      index: !1
    };
  }
  e.EventAttribute = {
    typeUrl: "/tendermint.abci.EventAttribute",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.key !== "" && Me.uint32(10).string(Ae.key), Ae.value !== "" && Me.uint32(18).string(Ae.value), Ae.index === !0 && Me.uint32(24).bool(Ae.index), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Lt();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.key = He.string();
            break;
          case 2:
            Wt.value = He.string();
            break;
          case 3:
            Wt.index = He.bool();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Lt();
      return (0, v.isSet)(Ae.key) && (Me.key = String(Ae.key)), (0, v.isSet)(Ae.value) && (Me.value = String(Ae.value)), (0, v.isSet)(Ae.index) && (Me.index = !!Ae.index), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.key !== void 0 && (Me.key = Ae.key), Ae.value !== void 0 && (Me.value = Ae.value), Ae.index !== void 0 && (Me.index = Ae.index), Me;
    },
    fromPartial(Ae) {
      const Me = Lt();
      return Me.key = Ae.key ?? "", Me.value = Ae.value ?? "", Me.index = Ae.index ?? !1, Me;
    }
  };
  function Qn() {
    return {
      height: BigInt(0),
      index: 0,
      tx: new Uint8Array(),
      result: e.ResponseDeliverTx.fromPartial({})
    };
  }
  e.TxResult = {
    typeUrl: "/tendermint.abci.TxResult",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.height !== BigInt(0) && Me.uint32(8).int64(Ae.height), Ae.index !== 0 && Me.uint32(16).uint32(Ae.index), Ae.tx.length !== 0 && Me.uint32(26).bytes(Ae.tx), Ae.result !== void 0 && e.ResponseDeliverTx.encode(Ae.result, Me.uint32(34).fork()).ldelim(), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Qn();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.height = He.int64();
            break;
          case 2:
            Wt.index = He.uint32();
            break;
          case 3:
            Wt.tx = He.bytes();
            break;
          case 4:
            Wt.result = e.ResponseDeliverTx.decode(He, He.uint32());
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Qn();
      return (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), (0, v.isSet)(Ae.index) && (Me.index = Number(Ae.index)), (0, v.isSet)(Ae.tx) && (Me.tx = (0, v.bytesFromBase64)(Ae.tx)), (0, v.isSet)(Ae.result) && (Me.result = e.ResponseDeliverTx.fromJSON(Ae.result)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Ae.index !== void 0 && (Me.index = Math.round(Ae.index)), Ae.tx !== void 0 && (Me.tx = (0, v.base64FromBytes)(Ae.tx !== void 0 ? Ae.tx : new Uint8Array())), Ae.result !== void 0 && (Me.result = Ae.result ? e.ResponseDeliverTx.toJSON(Ae.result) : void 0), Me;
    },
    fromPartial(Ae) {
      const Me = Qn();
      return Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Me.index = Ae.index ?? 0, Me.tx = Ae.tx ?? new Uint8Array(), Ae.result !== void 0 && Ae.result !== null && (Me.result = e.ResponseDeliverTx.fromPartial(Ae.result)), Me;
    }
  };
  function ce() {
    return {
      address: new Uint8Array(),
      power: BigInt(0)
    };
  }
  e.Validator = {
    typeUrl: "/tendermint.abci.Validator",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.address.length !== 0 && Me.uint32(10).bytes(Ae.address), Ae.power !== BigInt(0) && Me.uint32(24).int64(Ae.power), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = ce();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.address = He.bytes();
            break;
          case 3:
            Wt.power = He.int64();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = ce();
      return (0, v.isSet)(Ae.address) && (Me.address = (0, v.bytesFromBase64)(Ae.address)), (0, v.isSet)(Ae.power) && (Me.power = BigInt(Ae.power.toString())), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.address !== void 0 && (Me.address = (0, v.base64FromBytes)(Ae.address !== void 0 ? Ae.address : new Uint8Array())), Ae.power !== void 0 && (Me.power = (Ae.power || BigInt(0)).toString()), Me;
    },
    fromPartial(Ae) {
      const Me = ce();
      return Me.address = Ae.address ?? new Uint8Array(), Ae.power !== void 0 && Ae.power !== null && (Me.power = BigInt(Ae.power.toString())), Me;
    }
  };
  function Ze() {
    return {
      pubKey: d.PublicKey.fromPartial({}),
      power: BigInt(0)
    };
  }
  e.ValidatorUpdate = {
    typeUrl: "/tendermint.abci.ValidatorUpdate",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.pubKey !== void 0 && d.PublicKey.encode(Ae.pubKey, Me.uint32(10).fork()).ldelim(), Ae.power !== BigInt(0) && Me.uint32(16).int64(Ae.power), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Ze();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.pubKey = d.PublicKey.decode(He, He.uint32());
            break;
          case 2:
            Wt.power = He.int64();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Ze();
      return (0, v.isSet)(Ae.pubKey) && (Me.pubKey = d.PublicKey.fromJSON(Ae.pubKey)), (0, v.isSet)(Ae.power) && (Me.power = BigInt(Ae.power.toString())), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.pubKey !== void 0 && (Me.pubKey = Ae.pubKey ? d.PublicKey.toJSON(Ae.pubKey) : void 0), Ae.power !== void 0 && (Me.power = (Ae.power || BigInt(0)).toString()), Me;
    },
    fromPartial(Ae) {
      const Me = Ze();
      return Ae.pubKey !== void 0 && Ae.pubKey !== null && (Me.pubKey = d.PublicKey.fromPartial(Ae.pubKey)), Ae.power !== void 0 && Ae.power !== null && (Me.power = BigInt(Ae.power.toString())), Me;
    }
  };
  function ft() {
    return {
      validator: e.Validator.fromPartial({}),
      signedLastBlock: !1
    };
  }
  e.VoteInfo = {
    typeUrl: "/tendermint.abci.VoteInfo",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.validator !== void 0 && e.Validator.encode(Ae.validator, Me.uint32(10).fork()).ldelim(), Ae.signedLastBlock === !0 && Me.uint32(16).bool(Ae.signedLastBlock), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = ft();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.validator = e.Validator.decode(He, He.uint32());
            break;
          case 2:
            Wt.signedLastBlock = He.bool();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = ft();
      return (0, v.isSet)(Ae.validator) && (Me.validator = e.Validator.fromJSON(Ae.validator)), (0, v.isSet)(Ae.signedLastBlock) && (Me.signedLastBlock = !!Ae.signedLastBlock), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.validator !== void 0 && (Me.validator = Ae.validator ? e.Validator.toJSON(Ae.validator) : void 0), Ae.signedLastBlock !== void 0 && (Me.signedLastBlock = Ae.signedLastBlock), Me;
    },
    fromPartial(Ae) {
      const Me = ft();
      return Ae.validator !== void 0 && Ae.validator !== null && (Me.validator = e.Validator.fromPartial(Ae.validator)), Me.signedLastBlock = Ae.signedLastBlock ?? !1, Me;
    }
  };
  function It() {
    return {
      validator: e.Validator.fromPartial({}),
      signedLastBlock: !1,
      voteExtension: new Uint8Array()
    };
  }
  e.ExtendedVoteInfo = {
    typeUrl: "/tendermint.abci.ExtendedVoteInfo",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.validator !== void 0 && e.Validator.encode(Ae.validator, Me.uint32(10).fork()).ldelim(), Ae.signedLastBlock === !0 && Me.uint32(16).bool(Ae.signedLastBlock), Ae.voteExtension.length !== 0 && Me.uint32(26).bytes(Ae.voteExtension), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = It();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.validator = e.Validator.decode(He, He.uint32());
            break;
          case 2:
            Wt.signedLastBlock = He.bool();
            break;
          case 3:
            Wt.voteExtension = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = It();
      return (0, v.isSet)(Ae.validator) && (Me.validator = e.Validator.fromJSON(Ae.validator)), (0, v.isSet)(Ae.signedLastBlock) && (Me.signedLastBlock = !!Ae.signedLastBlock), (0, v.isSet)(Ae.voteExtension) && (Me.voteExtension = (0, v.bytesFromBase64)(Ae.voteExtension)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.validator !== void 0 && (Me.validator = Ae.validator ? e.Validator.toJSON(Ae.validator) : void 0), Ae.signedLastBlock !== void 0 && (Me.signedLastBlock = Ae.signedLastBlock), Ae.voteExtension !== void 0 && (Me.voteExtension = (0, v.base64FromBytes)(Ae.voteExtension !== void 0 ? Ae.voteExtension : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      const Me = It();
      return Ae.validator !== void 0 && Ae.validator !== null && (Me.validator = e.Validator.fromPartial(Ae.validator)), Me.signedLastBlock = Ae.signedLastBlock ?? !1, Me.voteExtension = Ae.voteExtension ?? new Uint8Array(), Me;
    }
  };
  function rn() {
    return {
      type: 0,
      validator: e.Validator.fromPartial({}),
      height: BigInt(0),
      time: n.Timestamp.fromPartial({}),
      totalVotingPower: BigInt(0)
    };
  }
  e.Misbehavior = {
    typeUrl: "/tendermint.abci.Misbehavior",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.type !== 0 && Me.uint32(8).int32(Ae.type), Ae.validator !== void 0 && e.Validator.encode(Ae.validator, Me.uint32(18).fork()).ldelim(), Ae.height !== BigInt(0) && Me.uint32(24).int64(Ae.height), Ae.time !== void 0 && n.Timestamp.encode(Ae.time, Me.uint32(34).fork()).ldelim(), Ae.totalVotingPower !== BigInt(0) && Me.uint32(40).int64(Ae.totalVotingPower), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = rn();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.type = He.int32();
            break;
          case 2:
            Wt.validator = e.Validator.decode(He, He.uint32());
            break;
          case 3:
            Wt.height = He.int64();
            break;
          case 4:
            Wt.time = n.Timestamp.decode(He, He.uint32());
            break;
          case 5:
            Wt.totalVotingPower = He.int64();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = rn();
      return (0, v.isSet)(Ae.type) && (Me.type = ue(Ae.type)), (0, v.isSet)(Ae.validator) && (Me.validator = e.Validator.fromJSON(Ae.validator)), (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), (0, v.isSet)(Ae.time) && (Me.time = (0, v.fromJsonTimestamp)(Ae.time)), (0, v.isSet)(Ae.totalVotingPower) && (Me.totalVotingPower = BigInt(Ae.totalVotingPower.toString())), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.type !== void 0 && (Me.type = Q(Ae.type)), Ae.validator !== void 0 && (Me.validator = Ae.validator ? e.Validator.toJSON(Ae.validator) : void 0), Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Ae.time !== void 0 && (Me.time = (0, v.fromTimestamp)(Ae.time).toISOString()), Ae.totalVotingPower !== void 0 && (Me.totalVotingPower = (Ae.totalVotingPower || BigInt(0)).toString()), Me;
    },
    fromPartial(Ae) {
      const Me = rn();
      return Me.type = Ae.type ?? 0, Ae.validator !== void 0 && Ae.validator !== null && (Me.validator = e.Validator.fromPartial(Ae.validator)), Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Ae.time !== void 0 && Ae.time !== null && (Me.time = n.Timestamp.fromPartial(Ae.time)), Ae.totalVotingPower !== void 0 && Ae.totalVotingPower !== null && (Me.totalVotingPower = BigInt(Ae.totalVotingPower.toString())), Me;
    }
  };
  function Ln() {
    return {
      height: BigInt(0),
      format: 0,
      chunks: 0,
      hash: new Uint8Array(),
      metadata: new Uint8Array()
    };
  }
  e.Snapshot = {
    typeUrl: "/tendermint.abci.Snapshot",
    encode(Ae, Me = m.BinaryWriter.create()) {
      return Ae.height !== BigInt(0) && Me.uint32(8).uint64(Ae.height), Ae.format !== 0 && Me.uint32(16).uint32(Ae.format), Ae.chunks !== 0 && Me.uint32(24).uint32(Ae.chunks), Ae.hash.length !== 0 && Me.uint32(34).bytes(Ae.hash), Ae.metadata.length !== 0 && Me.uint32(42).bytes(Ae.metadata), Me;
    },
    decode(Ae, Me) {
      const He = Ae instanceof m.BinaryReader ? Ae : new m.BinaryReader(Ae);
      let cn = Me === void 0 ? He.len : He.pos + Me;
      const Wt = Ln();
      for (; He.pos < cn; ) {
        const yn = He.uint32();
        switch (yn >>> 3) {
          case 1:
            Wt.height = He.uint64();
            break;
          case 2:
            Wt.format = He.uint32();
            break;
          case 3:
            Wt.chunks = He.uint32();
            break;
          case 4:
            Wt.hash = He.bytes();
            break;
          case 5:
            Wt.metadata = He.bytes();
            break;
          default:
            He.skipType(yn & 7);
            break;
        }
      }
      return Wt;
    },
    fromJSON(Ae) {
      const Me = Ln();
      return (0, v.isSet)(Ae.height) && (Me.height = BigInt(Ae.height.toString())), (0, v.isSet)(Ae.format) && (Me.format = Number(Ae.format)), (0, v.isSet)(Ae.chunks) && (Me.chunks = Number(Ae.chunks)), (0, v.isSet)(Ae.hash) && (Me.hash = (0, v.bytesFromBase64)(Ae.hash)), (0, v.isSet)(Ae.metadata) && (Me.metadata = (0, v.bytesFromBase64)(Ae.metadata)), Me;
    },
    toJSON(Ae) {
      const Me = {};
      return Ae.height !== void 0 && (Me.height = (Ae.height || BigInt(0)).toString()), Ae.format !== void 0 && (Me.format = Math.round(Ae.format)), Ae.chunks !== void 0 && (Me.chunks = Math.round(Ae.chunks)), Ae.hash !== void 0 && (Me.hash = (0, v.base64FromBytes)(Ae.hash !== void 0 ? Ae.hash : new Uint8Array())), Ae.metadata !== void 0 && (Me.metadata = (0, v.base64FromBytes)(Ae.metadata !== void 0 ? Ae.metadata : new Uint8Array())), Me;
    },
    fromPartial(Ae) {
      const Me = Ln();
      return Ae.height !== void 0 && Ae.height !== null && (Me.height = BigInt(Ae.height.toString())), Me.format = Ae.format ?? 0, Me.chunks = Ae.chunks ?? 0, Me.hash = Ae.hash ?? new Uint8Array(), Me.metadata = Ae.metadata ?? new Uint8Array(), Me;
    }
  };
  class Pn {
    constructor(Me) {
      this.rpc = Me, this.Echo = this.Echo.bind(this), this.Flush = this.Flush.bind(this), this.Info = this.Info.bind(this), this.DeliverTx = this.DeliverTx.bind(this), this.CheckTx = this.CheckTx.bind(this), this.Query = this.Query.bind(this), this.Commit = this.Commit.bind(this), this.InitChain = this.InitChain.bind(this), this.BeginBlock = this.BeginBlock.bind(this), this.EndBlock = this.EndBlock.bind(this), this.ListSnapshots = this.ListSnapshots.bind(this), this.OfferSnapshot = this.OfferSnapshot.bind(this), this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this), this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this), this.PrepareProposal = this.PrepareProposal.bind(this), this.ProcessProposal = this.ProcessProposal.bind(this);
    }
    Echo(Me) {
      const He = e.RequestEcho.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Echo", He).then((Wt) => e.ResponseEcho.decode(new m.BinaryReader(Wt)));
    }
    Flush(Me = {}) {
      const He = e.RequestFlush.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Flush", He).then((Wt) => e.ResponseFlush.decode(new m.BinaryReader(Wt)));
    }
    Info(Me) {
      const He = e.RequestInfo.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Info", He).then((Wt) => e.ResponseInfo.decode(new m.BinaryReader(Wt)));
    }
    DeliverTx(Me) {
      const He = e.RequestDeliverTx.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", He).then((Wt) => e.ResponseDeliverTx.decode(new m.BinaryReader(Wt)));
    }
    CheckTx(Me) {
      const He = e.RequestCheckTx.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", He).then((Wt) => e.ResponseCheckTx.decode(new m.BinaryReader(Wt)));
    }
    Query(Me) {
      const He = e.RequestQuery.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Query", He).then((Wt) => e.ResponseQuery.decode(new m.BinaryReader(Wt)));
    }
    Commit(Me = {}) {
      const He = e.RequestCommit.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "Commit", He).then((Wt) => e.ResponseCommit.decode(new m.BinaryReader(Wt)));
    }
    InitChain(Me) {
      const He = e.RequestInitChain.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", He).then((Wt) => e.ResponseInitChain.decode(new m.BinaryReader(Wt)));
    }
    BeginBlock(Me) {
      const He = e.RequestBeginBlock.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", He).then((Wt) => e.ResponseBeginBlock.decode(new m.BinaryReader(Wt)));
    }
    EndBlock(Me) {
      const He = e.RequestEndBlock.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", He).then((Wt) => e.ResponseEndBlock.decode(new m.BinaryReader(Wt)));
    }
    ListSnapshots(Me = {}) {
      const He = e.RequestListSnapshots.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", He).then((Wt) => e.ResponseListSnapshots.decode(new m.BinaryReader(Wt)));
    }
    OfferSnapshot(Me) {
      const He = e.RequestOfferSnapshot.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", He).then((Wt) => e.ResponseOfferSnapshot.decode(new m.BinaryReader(Wt)));
    }
    LoadSnapshotChunk(Me) {
      const He = e.RequestLoadSnapshotChunk.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", He).then((Wt) => e.ResponseLoadSnapshotChunk.decode(new m.BinaryReader(Wt)));
    }
    ApplySnapshotChunk(Me) {
      const He = e.RequestApplySnapshotChunk.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", He).then((Wt) => e.ResponseApplySnapshotChunk.decode(new m.BinaryReader(Wt)));
    }
    PrepareProposal(Me) {
      const He = e.RequestPrepareProposal.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "PrepareProposal", He).then((Wt) => e.ResponsePrepareProposal.decode(new m.BinaryReader(Wt)));
    }
    ProcessProposal(Me) {
      const He = e.RequestProcessProposal.encode(Me).finish();
      return this.rpc.request("tendermint.abci.ABCIApplication", "ProcessProposal", He).then((Wt) => e.ResponseProcessProposal.decode(new m.BinaryReader(Wt)));
    }
  }
  e.ABCIApplicationClientImpl = Pn;
})(types$c);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValidatorUpdates = e.Pool = e.RedelegationResponse = e.RedelegationEntryResponse = e.DelegationResponse = e.Params = e.Redelegation = e.RedelegationEntry = e.UnbondingDelegationEntry = e.UnbondingDelegation = e.Delegation = e.DVVTriplets = e.DVVTriplet = e.DVPairs = e.DVPair = e.ValAddresses = e.Validator = e.Description = e.Commission = e.CommissionRates = e.HistoricalInfo = e.infractionToJSON = e.infractionFromJSON = e.Infraction = e.bondStatusToJSON = e.bondStatusFromJSON = e.BondStatus = e.protobufPackage = void 0;
  const n = types$e, o = timestamp$1, u = any$1, c = duration$1, d = coin$8, m = types$c, v = binary, S = helpers;
  e.protobufPackage = "cosmos.staking.v1beta1";
  var $;
  (function(I) {
    I[I.BOND_STATUS_UNSPECIFIED = 0] = "BOND_STATUS_UNSPECIFIED", I[I.BOND_STATUS_UNBONDED = 1] = "BOND_STATUS_UNBONDED", I[I.BOND_STATUS_UNBONDING = 2] = "BOND_STATUS_UNBONDING", I[I.BOND_STATUS_BONDED = 3] = "BOND_STATUS_BONDED", I[I.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })($ || (e.BondStatus = $ = {}));
  function E(I) {
    switch (I) {
      case 0:
      case "BOND_STATUS_UNSPECIFIED":
        return $.BOND_STATUS_UNSPECIFIED;
      case 1:
      case "BOND_STATUS_UNBONDED":
        return $.BOND_STATUS_UNBONDED;
      case 2:
      case "BOND_STATUS_UNBONDING":
        return $.BOND_STATUS_UNBONDING;
      case 3:
      case "BOND_STATUS_BONDED":
        return $.BOND_STATUS_BONDED;
      case -1:
      case "UNRECOGNIZED":
      default:
        return $.UNRECOGNIZED;
    }
  }
  e.bondStatusFromJSON = E;
  function O(I) {
    switch (I) {
      case $.BOND_STATUS_UNSPECIFIED:
        return "BOND_STATUS_UNSPECIFIED";
      case $.BOND_STATUS_UNBONDED:
        return "BOND_STATUS_UNBONDED";
      case $.BOND_STATUS_UNBONDING:
        return "BOND_STATUS_UNBONDING";
      case $.BOND_STATUS_BONDED:
        return "BOND_STATUS_BONDED";
      case $.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.bondStatusToJSON = O;
  var T;
  (function(I) {
    I[I.INFRACTION_UNSPECIFIED = 0] = "INFRACTION_UNSPECIFIED", I[I.INFRACTION_DOUBLE_SIGN = 1] = "INFRACTION_DOUBLE_SIGN", I[I.INFRACTION_DOWNTIME = 2] = "INFRACTION_DOWNTIME", I[I.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(T || (e.Infraction = T = {}));
  function y(I) {
    switch (I) {
      case 0:
      case "INFRACTION_UNSPECIFIED":
        return T.INFRACTION_UNSPECIFIED;
      case 1:
      case "INFRACTION_DOUBLE_SIGN":
        return T.INFRACTION_DOUBLE_SIGN;
      case 2:
      case "INFRACTION_DOWNTIME":
        return T.INFRACTION_DOWNTIME;
      case -1:
      case "UNRECOGNIZED":
      default:
        return T.UNRECOGNIZED;
    }
  }
  e.infractionFromJSON = y;
  function V(I) {
    switch (I) {
      case T.INFRACTION_UNSPECIFIED:
        return "INFRACTION_UNSPECIFIED";
      case T.INFRACTION_DOUBLE_SIGN:
        return "INFRACTION_DOUBLE_SIGN";
      case T.INFRACTION_DOWNTIME:
        return "INFRACTION_DOWNTIME";
      case T.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.infractionToJSON = V;
  function M() {
    return {
      header: n.Header.fromPartial({}),
      valset: []
    };
  }
  e.HistoricalInfo = {
    typeUrl: "/cosmos.staking.v1beta1.HistoricalInfo",
    encode(I, te = v.BinaryWriter.create()) {
      I.header !== void 0 && n.Header.encode(I.header, te.uint32(10).fork()).ldelim();
      for (const ge of I.valset)
        e.Validator.encode(ge, te.uint32(18).fork()).ldelim();
      return te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = M();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.header = n.Header.decode(ge, ge.uint32());
            break;
          case 2:
            Ke.valset.push(e.Validator.decode(ge, ge.uint32()));
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = M();
      return (0, S.isSet)(I.header) && (te.header = n.Header.fromJSON(I.header)), Array.isArray(I == null ? void 0 : I.valset) && (te.valset = I.valset.map((ge) => e.Validator.fromJSON(ge))), te;
    },
    toJSON(I) {
      const te = {};
      return I.header !== void 0 && (te.header = I.header ? n.Header.toJSON(I.header) : void 0), I.valset ? te.valset = I.valset.map((ge) => ge ? e.Validator.toJSON(ge) : void 0) : te.valset = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = M();
      return I.header !== void 0 && I.header !== null && (te.header = n.Header.fromPartial(I.header)), te.valset = ((ge = I.valset) == null ? void 0 : ge.map((Pe) => e.Validator.fromPartial(Pe))) || [], te;
    }
  };
  function G() {
    return {
      rate: "",
      maxRate: "",
      maxChangeRate: ""
    };
  }
  e.CommissionRates = {
    typeUrl: "/cosmos.staking.v1beta1.CommissionRates",
    encode(I, te = v.BinaryWriter.create()) {
      return I.rate !== "" && te.uint32(10).string(I.rate), I.maxRate !== "" && te.uint32(18).string(I.maxRate), I.maxChangeRate !== "" && te.uint32(26).string(I.maxChangeRate), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = G();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.rate = ge.string();
            break;
          case 2:
            Ke.maxRate = ge.string();
            break;
          case 3:
            Ke.maxChangeRate = ge.string();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = G();
      return (0, S.isSet)(I.rate) && (te.rate = String(I.rate)), (0, S.isSet)(I.maxRate) && (te.maxRate = String(I.maxRate)), (0, S.isSet)(I.maxChangeRate) && (te.maxChangeRate = String(I.maxChangeRate)), te;
    },
    toJSON(I) {
      const te = {};
      return I.rate !== void 0 && (te.rate = I.rate), I.maxRate !== void 0 && (te.maxRate = I.maxRate), I.maxChangeRate !== void 0 && (te.maxChangeRate = I.maxChangeRate), te;
    },
    fromPartial(I) {
      const te = G();
      return te.rate = I.rate ?? "", te.maxRate = I.maxRate ?? "", te.maxChangeRate = I.maxChangeRate ?? "", te;
    }
  };
  function k() {
    return {
      commissionRates: e.CommissionRates.fromPartial({}),
      updateTime: o.Timestamp.fromPartial({})
    };
  }
  e.Commission = {
    typeUrl: "/cosmos.staking.v1beta1.Commission",
    encode(I, te = v.BinaryWriter.create()) {
      return I.commissionRates !== void 0 && e.CommissionRates.encode(I.commissionRates, te.uint32(10).fork()).ldelim(), I.updateTime !== void 0 && o.Timestamp.encode(I.updateTime, te.uint32(18).fork()).ldelim(), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = k();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.commissionRates = e.CommissionRates.decode(ge, ge.uint32());
            break;
          case 2:
            Ke.updateTime = o.Timestamp.decode(ge, ge.uint32());
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = k();
      return (0, S.isSet)(I.commissionRates) && (te.commissionRates = e.CommissionRates.fromJSON(I.commissionRates)), (0, S.isSet)(I.updateTime) && (te.updateTime = (0, S.fromJsonTimestamp)(I.updateTime)), te;
    },
    toJSON(I) {
      const te = {};
      return I.commissionRates !== void 0 && (te.commissionRates = I.commissionRates ? e.CommissionRates.toJSON(I.commissionRates) : void 0), I.updateTime !== void 0 && (te.updateTime = (0, S.fromTimestamp)(I.updateTime).toISOString()), te;
    },
    fromPartial(I) {
      const te = k();
      return I.commissionRates !== void 0 && I.commissionRates !== null && (te.commissionRates = e.CommissionRates.fromPartial(I.commissionRates)), I.updateTime !== void 0 && I.updateTime !== null && (te.updateTime = o.Timestamp.fromPartial(I.updateTime)), te;
    }
  };
  function F() {
    return {
      moniker: "",
      identity: "",
      website: "",
      securityContact: "",
      details: ""
    };
  }
  e.Description = {
    typeUrl: "/cosmos.staking.v1beta1.Description",
    encode(I, te = v.BinaryWriter.create()) {
      return I.moniker !== "" && te.uint32(10).string(I.moniker), I.identity !== "" && te.uint32(18).string(I.identity), I.website !== "" && te.uint32(26).string(I.website), I.securityContact !== "" && te.uint32(34).string(I.securityContact), I.details !== "" && te.uint32(42).string(I.details), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = F();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.moniker = ge.string();
            break;
          case 2:
            Ke.identity = ge.string();
            break;
          case 3:
            Ke.website = ge.string();
            break;
          case 4:
            Ke.securityContact = ge.string();
            break;
          case 5:
            Ke.details = ge.string();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = F();
      return (0, S.isSet)(I.moniker) && (te.moniker = String(I.moniker)), (0, S.isSet)(I.identity) && (te.identity = String(I.identity)), (0, S.isSet)(I.website) && (te.website = String(I.website)), (0, S.isSet)(I.securityContact) && (te.securityContact = String(I.securityContact)), (0, S.isSet)(I.details) && (te.details = String(I.details)), te;
    },
    toJSON(I) {
      const te = {};
      return I.moniker !== void 0 && (te.moniker = I.moniker), I.identity !== void 0 && (te.identity = I.identity), I.website !== void 0 && (te.website = I.website), I.securityContact !== void 0 && (te.securityContact = I.securityContact), I.details !== void 0 && (te.details = I.details), te;
    },
    fromPartial(I) {
      const te = F();
      return te.moniker = I.moniker ?? "", te.identity = I.identity ?? "", te.website = I.website ?? "", te.securityContact = I.securityContact ?? "", te.details = I.details ?? "", te;
    }
  };
  function X() {
    return {
      operatorAddress: "",
      consensusPubkey: void 0,
      jailed: !1,
      status: 0,
      tokens: "",
      delegatorShares: "",
      description: e.Description.fromPartial({}),
      unbondingHeight: BigInt(0),
      unbondingTime: o.Timestamp.fromPartial({}),
      commission: e.Commission.fromPartial({}),
      minSelfDelegation: "",
      unbondingOnHoldRefCount: BigInt(0),
      unbondingIds: []
    };
  }
  e.Validator = {
    typeUrl: "/cosmos.staking.v1beta1.Validator",
    encode(I, te = v.BinaryWriter.create()) {
      I.operatorAddress !== "" && te.uint32(10).string(I.operatorAddress), I.consensusPubkey !== void 0 && u.Any.encode(I.consensusPubkey, te.uint32(18).fork()).ldelim(), I.jailed === !0 && te.uint32(24).bool(I.jailed), I.status !== 0 && te.uint32(32).int32(I.status), I.tokens !== "" && te.uint32(42).string(I.tokens), I.delegatorShares !== "" && te.uint32(50).string(I.delegatorShares), I.description !== void 0 && e.Description.encode(I.description, te.uint32(58).fork()).ldelim(), I.unbondingHeight !== BigInt(0) && te.uint32(64).int64(I.unbondingHeight), I.unbondingTime !== void 0 && o.Timestamp.encode(I.unbondingTime, te.uint32(74).fork()).ldelim(), I.commission !== void 0 && e.Commission.encode(I.commission, te.uint32(82).fork()).ldelim(), I.minSelfDelegation !== "" && te.uint32(90).string(I.minSelfDelegation), I.unbondingOnHoldRefCount !== BigInt(0) && te.uint32(96).int64(I.unbondingOnHoldRefCount), te.uint32(106).fork();
      for (const ge of I.unbondingIds)
        te.uint64(ge);
      return te.ldelim(), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = X();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.operatorAddress = ge.string();
            break;
          case 2:
            Ke.consensusPubkey = u.Any.decode(ge, ge.uint32());
            break;
          case 3:
            Ke.jailed = ge.bool();
            break;
          case 4:
            Ke.status = ge.int32();
            break;
          case 5:
            Ke.tokens = ge.string();
            break;
          case 6:
            Ke.delegatorShares = ge.string();
            break;
          case 7:
            Ke.description = e.Description.decode(ge, ge.uint32());
            break;
          case 8:
            Ke.unbondingHeight = ge.int64();
            break;
          case 9:
            Ke.unbondingTime = o.Timestamp.decode(ge, ge.uint32());
            break;
          case 10:
            Ke.commission = e.Commission.decode(ge, ge.uint32());
            break;
          case 11:
            Ke.minSelfDelegation = ge.string();
            break;
          case 12:
            Ke.unbondingOnHoldRefCount = ge.int64();
            break;
          case 13:
            if ((xe & 7) === 2) {
              const ze = ge.uint32() + ge.pos;
              for (; ge.pos < ze; )
                Ke.unbondingIds.push(ge.uint64());
            } else
              Ke.unbondingIds.push(ge.uint64());
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = X();
      return (0, S.isSet)(I.operatorAddress) && (te.operatorAddress = String(I.operatorAddress)), (0, S.isSet)(I.consensusPubkey) && (te.consensusPubkey = u.Any.fromJSON(I.consensusPubkey)), (0, S.isSet)(I.jailed) && (te.jailed = !!I.jailed), (0, S.isSet)(I.status) && (te.status = E(I.status)), (0, S.isSet)(I.tokens) && (te.tokens = String(I.tokens)), (0, S.isSet)(I.delegatorShares) && (te.delegatorShares = String(I.delegatorShares)), (0, S.isSet)(I.description) && (te.description = e.Description.fromJSON(I.description)), (0, S.isSet)(I.unbondingHeight) && (te.unbondingHeight = BigInt(I.unbondingHeight.toString())), (0, S.isSet)(I.unbondingTime) && (te.unbondingTime = (0, S.fromJsonTimestamp)(I.unbondingTime)), (0, S.isSet)(I.commission) && (te.commission = e.Commission.fromJSON(I.commission)), (0, S.isSet)(I.minSelfDelegation) && (te.minSelfDelegation = String(I.minSelfDelegation)), (0, S.isSet)(I.unbondingOnHoldRefCount) && (te.unbondingOnHoldRefCount = BigInt(I.unbondingOnHoldRefCount.toString())), Array.isArray(I == null ? void 0 : I.unbondingIds) && (te.unbondingIds = I.unbondingIds.map((ge) => BigInt(ge.toString()))), te;
    },
    toJSON(I) {
      const te = {};
      return I.operatorAddress !== void 0 && (te.operatorAddress = I.operatorAddress), I.consensusPubkey !== void 0 && (te.consensusPubkey = I.consensusPubkey ? u.Any.toJSON(I.consensusPubkey) : void 0), I.jailed !== void 0 && (te.jailed = I.jailed), I.status !== void 0 && (te.status = O(I.status)), I.tokens !== void 0 && (te.tokens = I.tokens), I.delegatorShares !== void 0 && (te.delegatorShares = I.delegatorShares), I.description !== void 0 && (te.description = I.description ? e.Description.toJSON(I.description) : void 0), I.unbondingHeight !== void 0 && (te.unbondingHeight = (I.unbondingHeight || BigInt(0)).toString()), I.unbondingTime !== void 0 && (te.unbondingTime = (0, S.fromTimestamp)(I.unbondingTime).toISOString()), I.commission !== void 0 && (te.commission = I.commission ? e.Commission.toJSON(I.commission) : void 0), I.minSelfDelegation !== void 0 && (te.minSelfDelegation = I.minSelfDelegation), I.unbondingOnHoldRefCount !== void 0 && (te.unbondingOnHoldRefCount = (I.unbondingOnHoldRefCount || BigInt(0)).toString()), I.unbondingIds ? te.unbondingIds = I.unbondingIds.map((ge) => (ge || BigInt(0)).toString()) : te.unbondingIds = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = X();
      return te.operatorAddress = I.operatorAddress ?? "", I.consensusPubkey !== void 0 && I.consensusPubkey !== null && (te.consensusPubkey = u.Any.fromPartial(I.consensusPubkey)), te.jailed = I.jailed ?? !1, te.status = I.status ?? 0, te.tokens = I.tokens ?? "", te.delegatorShares = I.delegatorShares ?? "", I.description !== void 0 && I.description !== null && (te.description = e.Description.fromPartial(I.description)), I.unbondingHeight !== void 0 && I.unbondingHeight !== null && (te.unbondingHeight = BigInt(I.unbondingHeight.toString())), I.unbondingTime !== void 0 && I.unbondingTime !== null && (te.unbondingTime = o.Timestamp.fromPartial(I.unbondingTime)), I.commission !== void 0 && I.commission !== null && (te.commission = e.Commission.fromPartial(I.commission)), te.minSelfDelegation = I.minSelfDelegation ?? "", I.unbondingOnHoldRefCount !== void 0 && I.unbondingOnHoldRefCount !== null && (te.unbondingOnHoldRefCount = BigInt(I.unbondingOnHoldRefCount.toString())), te.unbondingIds = ((ge = I.unbondingIds) == null ? void 0 : ge.map((Pe) => BigInt(Pe.toString()))) || [], te;
    }
  };
  function ee() {
    return {
      addresses: []
    };
  }
  e.ValAddresses = {
    typeUrl: "/cosmos.staking.v1beta1.ValAddresses",
    encode(I, te = v.BinaryWriter.create()) {
      for (const ge of I.addresses)
        te.uint32(10).string(ge);
      return te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = ee();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.addresses.push(ge.string());
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = ee();
      return Array.isArray(I == null ? void 0 : I.addresses) && (te.addresses = I.addresses.map((ge) => String(ge))), te;
    },
    toJSON(I) {
      const te = {};
      return I.addresses ? te.addresses = I.addresses.map((ge) => ge) : te.addresses = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = ee();
      return te.addresses = ((ge = I.addresses) == null ? void 0 : ge.map((Pe) => Pe)) || [], te;
    }
  };
  function ue() {
    return {
      delegatorAddress: "",
      validatorAddress: ""
    };
  }
  e.DVPair = {
    typeUrl: "/cosmos.staking.v1beta1.DVPair",
    encode(I, te = v.BinaryWriter.create()) {
      return I.delegatorAddress !== "" && te.uint32(10).string(I.delegatorAddress), I.validatorAddress !== "" && te.uint32(18).string(I.validatorAddress), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = ue();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.delegatorAddress = ge.string();
            break;
          case 2:
            Ke.validatorAddress = ge.string();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = ue();
      return (0, S.isSet)(I.delegatorAddress) && (te.delegatorAddress = String(I.delegatorAddress)), (0, S.isSet)(I.validatorAddress) && (te.validatorAddress = String(I.validatorAddress)), te;
    },
    toJSON(I) {
      const te = {};
      return I.delegatorAddress !== void 0 && (te.delegatorAddress = I.delegatorAddress), I.validatorAddress !== void 0 && (te.validatorAddress = I.validatorAddress), te;
    },
    fromPartial(I) {
      const te = ue();
      return te.delegatorAddress = I.delegatorAddress ?? "", te.validatorAddress = I.validatorAddress ?? "", te;
    }
  };
  function Q() {
    return {
      pairs: []
    };
  }
  e.DVPairs = {
    typeUrl: "/cosmos.staking.v1beta1.DVPairs",
    encode(I, te = v.BinaryWriter.create()) {
      for (const ge of I.pairs)
        e.DVPair.encode(ge, te.uint32(10).fork()).ldelim();
      return te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = Q();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.pairs.push(e.DVPair.decode(ge, ge.uint32()));
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = Q();
      return Array.isArray(I == null ? void 0 : I.pairs) && (te.pairs = I.pairs.map((ge) => e.DVPair.fromJSON(ge))), te;
    },
    toJSON(I) {
      const te = {};
      return I.pairs ? te.pairs = I.pairs.map((ge) => ge ? e.DVPair.toJSON(ge) : void 0) : te.pairs = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = Q();
      return te.pairs = ((ge = I.pairs) == null ? void 0 : ge.map((Pe) => e.DVPair.fromPartial(Pe))) || [], te;
    }
  };
  function Y() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: ""
    };
  }
  e.DVVTriplet = {
    typeUrl: "/cosmos.staking.v1beta1.DVVTriplet",
    encode(I, te = v.BinaryWriter.create()) {
      return I.delegatorAddress !== "" && te.uint32(10).string(I.delegatorAddress), I.validatorSrcAddress !== "" && te.uint32(18).string(I.validatorSrcAddress), I.validatorDstAddress !== "" && te.uint32(26).string(I.validatorDstAddress), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = Y();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.delegatorAddress = ge.string();
            break;
          case 2:
            Ke.validatorSrcAddress = ge.string();
            break;
          case 3:
            Ke.validatorDstAddress = ge.string();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = Y();
      return (0, S.isSet)(I.delegatorAddress) && (te.delegatorAddress = String(I.delegatorAddress)), (0, S.isSet)(I.validatorSrcAddress) && (te.validatorSrcAddress = String(I.validatorSrcAddress)), (0, S.isSet)(I.validatorDstAddress) && (te.validatorDstAddress = String(I.validatorDstAddress)), te;
    },
    toJSON(I) {
      const te = {};
      return I.delegatorAddress !== void 0 && (te.delegatorAddress = I.delegatorAddress), I.validatorSrcAddress !== void 0 && (te.validatorSrcAddress = I.validatorSrcAddress), I.validatorDstAddress !== void 0 && (te.validatorDstAddress = I.validatorDstAddress), te;
    },
    fromPartial(I) {
      const te = Y();
      return te.delegatorAddress = I.delegatorAddress ?? "", te.validatorSrcAddress = I.validatorSrcAddress ?? "", te.validatorDstAddress = I.validatorDstAddress ?? "", te;
    }
  };
  function pe() {
    return {
      triplets: []
    };
  }
  e.DVVTriplets = {
    typeUrl: "/cosmos.staking.v1beta1.DVVTriplets",
    encode(I, te = v.BinaryWriter.create()) {
      for (const ge of I.triplets)
        e.DVVTriplet.encode(ge, te.uint32(10).fork()).ldelim();
      return te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = pe();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.triplets.push(e.DVVTriplet.decode(ge, ge.uint32()));
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = pe();
      return Array.isArray(I == null ? void 0 : I.triplets) && (te.triplets = I.triplets.map((ge) => e.DVVTriplet.fromJSON(ge))), te;
    },
    toJSON(I) {
      const te = {};
      return I.triplets ? te.triplets = I.triplets.map((ge) => ge ? e.DVVTriplet.toJSON(ge) : void 0) : te.triplets = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = pe();
      return te.triplets = ((ge = I.triplets) == null ? void 0 : ge.map((Pe) => e.DVVTriplet.fromPartial(Pe))) || [], te;
    }
  };
  function oe() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      shares: ""
    };
  }
  e.Delegation = {
    typeUrl: "/cosmos.staking.v1beta1.Delegation",
    encode(I, te = v.BinaryWriter.create()) {
      return I.delegatorAddress !== "" && te.uint32(10).string(I.delegatorAddress), I.validatorAddress !== "" && te.uint32(18).string(I.validatorAddress), I.shares !== "" && te.uint32(26).string(I.shares), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = oe();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.delegatorAddress = ge.string();
            break;
          case 2:
            Ke.validatorAddress = ge.string();
            break;
          case 3:
            Ke.shares = ge.string();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = oe();
      return (0, S.isSet)(I.delegatorAddress) && (te.delegatorAddress = String(I.delegatorAddress)), (0, S.isSet)(I.validatorAddress) && (te.validatorAddress = String(I.validatorAddress)), (0, S.isSet)(I.shares) && (te.shares = String(I.shares)), te;
    },
    toJSON(I) {
      const te = {};
      return I.delegatorAddress !== void 0 && (te.delegatorAddress = I.delegatorAddress), I.validatorAddress !== void 0 && (te.validatorAddress = I.validatorAddress), I.shares !== void 0 && (te.shares = I.shares), te;
    },
    fromPartial(I) {
      const te = oe();
      return te.delegatorAddress = I.delegatorAddress ?? "", te.validatorAddress = I.validatorAddress ?? "", te.shares = I.shares ?? "", te;
    }
  };
  function ne() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      entries: []
    };
  }
  e.UnbondingDelegation = {
    typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegation",
    encode(I, te = v.BinaryWriter.create()) {
      I.delegatorAddress !== "" && te.uint32(10).string(I.delegatorAddress), I.validatorAddress !== "" && te.uint32(18).string(I.validatorAddress);
      for (const ge of I.entries)
        e.UnbondingDelegationEntry.encode(ge, te.uint32(26).fork()).ldelim();
      return te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = ne();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.delegatorAddress = ge.string();
            break;
          case 2:
            Ke.validatorAddress = ge.string();
            break;
          case 3:
            Ke.entries.push(e.UnbondingDelegationEntry.decode(ge, ge.uint32()));
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = ne();
      return (0, S.isSet)(I.delegatorAddress) && (te.delegatorAddress = String(I.delegatorAddress)), (0, S.isSet)(I.validatorAddress) && (te.validatorAddress = String(I.validatorAddress)), Array.isArray(I == null ? void 0 : I.entries) && (te.entries = I.entries.map((ge) => e.UnbondingDelegationEntry.fromJSON(ge))), te;
    },
    toJSON(I) {
      const te = {};
      return I.delegatorAddress !== void 0 && (te.delegatorAddress = I.delegatorAddress), I.validatorAddress !== void 0 && (te.validatorAddress = I.validatorAddress), I.entries ? te.entries = I.entries.map((ge) => ge ? e.UnbondingDelegationEntry.toJSON(ge) : void 0) : te.entries = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = ne();
      return te.delegatorAddress = I.delegatorAddress ?? "", te.validatorAddress = I.validatorAddress ?? "", te.entries = ((ge = I.entries) == null ? void 0 : ge.map((Pe) => e.UnbondingDelegationEntry.fromPartial(Pe))) || [], te;
    }
  };
  function H() {
    return {
      creationHeight: BigInt(0),
      completionTime: o.Timestamp.fromPartial({}),
      initialBalance: "",
      balance: "",
      unbondingId: BigInt(0),
      unbondingOnHoldRefCount: BigInt(0)
    };
  }
  e.UnbondingDelegationEntry = {
    typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegationEntry",
    encode(I, te = v.BinaryWriter.create()) {
      return I.creationHeight !== BigInt(0) && te.uint32(8).int64(I.creationHeight), I.completionTime !== void 0 && o.Timestamp.encode(I.completionTime, te.uint32(18).fork()).ldelim(), I.initialBalance !== "" && te.uint32(26).string(I.initialBalance), I.balance !== "" && te.uint32(34).string(I.balance), I.unbondingId !== BigInt(0) && te.uint32(40).uint64(I.unbondingId), I.unbondingOnHoldRefCount !== BigInt(0) && te.uint32(48).int64(I.unbondingOnHoldRefCount), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = H();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.creationHeight = ge.int64();
            break;
          case 2:
            Ke.completionTime = o.Timestamp.decode(ge, ge.uint32());
            break;
          case 3:
            Ke.initialBalance = ge.string();
            break;
          case 4:
            Ke.balance = ge.string();
            break;
          case 5:
            Ke.unbondingId = ge.uint64();
            break;
          case 6:
            Ke.unbondingOnHoldRefCount = ge.int64();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = H();
      return (0, S.isSet)(I.creationHeight) && (te.creationHeight = BigInt(I.creationHeight.toString())), (0, S.isSet)(I.completionTime) && (te.completionTime = (0, S.fromJsonTimestamp)(I.completionTime)), (0, S.isSet)(I.initialBalance) && (te.initialBalance = String(I.initialBalance)), (0, S.isSet)(I.balance) && (te.balance = String(I.balance)), (0, S.isSet)(I.unbondingId) && (te.unbondingId = BigInt(I.unbondingId.toString())), (0, S.isSet)(I.unbondingOnHoldRefCount) && (te.unbondingOnHoldRefCount = BigInt(I.unbondingOnHoldRefCount.toString())), te;
    },
    toJSON(I) {
      const te = {};
      return I.creationHeight !== void 0 && (te.creationHeight = (I.creationHeight || BigInt(0)).toString()), I.completionTime !== void 0 && (te.completionTime = (0, S.fromTimestamp)(I.completionTime).toISOString()), I.initialBalance !== void 0 && (te.initialBalance = I.initialBalance), I.balance !== void 0 && (te.balance = I.balance), I.unbondingId !== void 0 && (te.unbondingId = (I.unbondingId || BigInt(0)).toString()), I.unbondingOnHoldRefCount !== void 0 && (te.unbondingOnHoldRefCount = (I.unbondingOnHoldRefCount || BigInt(0)).toString()), te;
    },
    fromPartial(I) {
      const te = H();
      return I.creationHeight !== void 0 && I.creationHeight !== null && (te.creationHeight = BigInt(I.creationHeight.toString())), I.completionTime !== void 0 && I.completionTime !== null && (te.completionTime = o.Timestamp.fromPartial(I.completionTime)), te.initialBalance = I.initialBalance ?? "", te.balance = I.balance ?? "", I.unbondingId !== void 0 && I.unbondingId !== null && (te.unbondingId = BigInt(I.unbondingId.toString())), I.unbondingOnHoldRefCount !== void 0 && I.unbondingOnHoldRefCount !== null && (te.unbondingOnHoldRefCount = BigInt(I.unbondingOnHoldRefCount.toString())), te;
    }
  };
  function C() {
    return {
      creationHeight: BigInt(0),
      completionTime: o.Timestamp.fromPartial({}),
      initialBalance: "",
      sharesDst: "",
      unbondingId: BigInt(0),
      unbondingOnHoldRefCount: BigInt(0)
    };
  }
  e.RedelegationEntry = {
    typeUrl: "/cosmos.staking.v1beta1.RedelegationEntry",
    encode(I, te = v.BinaryWriter.create()) {
      return I.creationHeight !== BigInt(0) && te.uint32(8).int64(I.creationHeight), I.completionTime !== void 0 && o.Timestamp.encode(I.completionTime, te.uint32(18).fork()).ldelim(), I.initialBalance !== "" && te.uint32(26).string(I.initialBalance), I.sharesDst !== "" && te.uint32(34).string(I.sharesDst), I.unbondingId !== BigInt(0) && te.uint32(40).uint64(I.unbondingId), I.unbondingOnHoldRefCount !== BigInt(0) && te.uint32(48).int64(I.unbondingOnHoldRefCount), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = C();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.creationHeight = ge.int64();
            break;
          case 2:
            Ke.completionTime = o.Timestamp.decode(ge, ge.uint32());
            break;
          case 3:
            Ke.initialBalance = ge.string();
            break;
          case 4:
            Ke.sharesDst = ge.string();
            break;
          case 5:
            Ke.unbondingId = ge.uint64();
            break;
          case 6:
            Ke.unbondingOnHoldRefCount = ge.int64();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = C();
      return (0, S.isSet)(I.creationHeight) && (te.creationHeight = BigInt(I.creationHeight.toString())), (0, S.isSet)(I.completionTime) && (te.completionTime = (0, S.fromJsonTimestamp)(I.completionTime)), (0, S.isSet)(I.initialBalance) && (te.initialBalance = String(I.initialBalance)), (0, S.isSet)(I.sharesDst) && (te.sharesDst = String(I.sharesDst)), (0, S.isSet)(I.unbondingId) && (te.unbondingId = BigInt(I.unbondingId.toString())), (0, S.isSet)(I.unbondingOnHoldRefCount) && (te.unbondingOnHoldRefCount = BigInt(I.unbondingOnHoldRefCount.toString())), te;
    },
    toJSON(I) {
      const te = {};
      return I.creationHeight !== void 0 && (te.creationHeight = (I.creationHeight || BigInt(0)).toString()), I.completionTime !== void 0 && (te.completionTime = (0, S.fromTimestamp)(I.completionTime).toISOString()), I.initialBalance !== void 0 && (te.initialBalance = I.initialBalance), I.sharesDst !== void 0 && (te.sharesDst = I.sharesDst), I.unbondingId !== void 0 && (te.unbondingId = (I.unbondingId || BigInt(0)).toString()), I.unbondingOnHoldRefCount !== void 0 && (te.unbondingOnHoldRefCount = (I.unbondingOnHoldRefCount || BigInt(0)).toString()), te;
    },
    fromPartial(I) {
      const te = C();
      return I.creationHeight !== void 0 && I.creationHeight !== null && (te.creationHeight = BigInt(I.creationHeight.toString())), I.completionTime !== void 0 && I.completionTime !== null && (te.completionTime = o.Timestamp.fromPartial(I.completionTime)), te.initialBalance = I.initialBalance ?? "", te.sharesDst = I.sharesDst ?? "", I.unbondingId !== void 0 && I.unbondingId !== null && (te.unbondingId = BigInt(I.unbondingId.toString())), I.unbondingOnHoldRefCount !== void 0 && I.unbondingOnHoldRefCount !== null && (te.unbondingOnHoldRefCount = BigInt(I.unbondingOnHoldRefCount.toString())), te;
    }
  };
  function w() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: "",
      entries: []
    };
  }
  e.Redelegation = {
    typeUrl: "/cosmos.staking.v1beta1.Redelegation",
    encode(I, te = v.BinaryWriter.create()) {
      I.delegatorAddress !== "" && te.uint32(10).string(I.delegatorAddress), I.validatorSrcAddress !== "" && te.uint32(18).string(I.validatorSrcAddress), I.validatorDstAddress !== "" && te.uint32(26).string(I.validatorDstAddress);
      for (const ge of I.entries)
        e.RedelegationEntry.encode(ge, te.uint32(34).fork()).ldelim();
      return te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = w();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.delegatorAddress = ge.string();
            break;
          case 2:
            Ke.validatorSrcAddress = ge.string();
            break;
          case 3:
            Ke.validatorDstAddress = ge.string();
            break;
          case 4:
            Ke.entries.push(e.RedelegationEntry.decode(ge, ge.uint32()));
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = w();
      return (0, S.isSet)(I.delegatorAddress) && (te.delegatorAddress = String(I.delegatorAddress)), (0, S.isSet)(I.validatorSrcAddress) && (te.validatorSrcAddress = String(I.validatorSrcAddress)), (0, S.isSet)(I.validatorDstAddress) && (te.validatorDstAddress = String(I.validatorDstAddress)), Array.isArray(I == null ? void 0 : I.entries) && (te.entries = I.entries.map((ge) => e.RedelegationEntry.fromJSON(ge))), te;
    },
    toJSON(I) {
      const te = {};
      return I.delegatorAddress !== void 0 && (te.delegatorAddress = I.delegatorAddress), I.validatorSrcAddress !== void 0 && (te.validatorSrcAddress = I.validatorSrcAddress), I.validatorDstAddress !== void 0 && (te.validatorDstAddress = I.validatorDstAddress), I.entries ? te.entries = I.entries.map((ge) => ge ? e.RedelegationEntry.toJSON(ge) : void 0) : te.entries = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = w();
      return te.delegatorAddress = I.delegatorAddress ?? "", te.validatorSrcAddress = I.validatorSrcAddress ?? "", te.validatorDstAddress = I.validatorDstAddress ?? "", te.entries = ((ge = I.entries) == null ? void 0 : ge.map((Pe) => e.RedelegationEntry.fromPartial(Pe))) || [], te;
    }
  };
  function P() {
    return {
      unbondingTime: c.Duration.fromPartial({}),
      maxValidators: 0,
      maxEntries: 0,
      historicalEntries: 0,
      bondDenom: "",
      minCommissionRate: ""
    };
  }
  e.Params = {
    typeUrl: "/cosmos.staking.v1beta1.Params",
    encode(I, te = v.BinaryWriter.create()) {
      return I.unbondingTime !== void 0 && c.Duration.encode(I.unbondingTime, te.uint32(10).fork()).ldelim(), I.maxValidators !== 0 && te.uint32(16).uint32(I.maxValidators), I.maxEntries !== 0 && te.uint32(24).uint32(I.maxEntries), I.historicalEntries !== 0 && te.uint32(32).uint32(I.historicalEntries), I.bondDenom !== "" && te.uint32(42).string(I.bondDenom), I.minCommissionRate !== "" && te.uint32(50).string(I.minCommissionRate), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = P();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.unbondingTime = c.Duration.decode(ge, ge.uint32());
            break;
          case 2:
            Ke.maxValidators = ge.uint32();
            break;
          case 3:
            Ke.maxEntries = ge.uint32();
            break;
          case 4:
            Ke.historicalEntries = ge.uint32();
            break;
          case 5:
            Ke.bondDenom = ge.string();
            break;
          case 6:
            Ke.minCommissionRate = ge.string();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = P();
      return (0, S.isSet)(I.unbondingTime) && (te.unbondingTime = c.Duration.fromJSON(I.unbondingTime)), (0, S.isSet)(I.maxValidators) && (te.maxValidators = Number(I.maxValidators)), (0, S.isSet)(I.maxEntries) && (te.maxEntries = Number(I.maxEntries)), (0, S.isSet)(I.historicalEntries) && (te.historicalEntries = Number(I.historicalEntries)), (0, S.isSet)(I.bondDenom) && (te.bondDenom = String(I.bondDenom)), (0, S.isSet)(I.minCommissionRate) && (te.minCommissionRate = String(I.minCommissionRate)), te;
    },
    toJSON(I) {
      const te = {};
      return I.unbondingTime !== void 0 && (te.unbondingTime = I.unbondingTime ? c.Duration.toJSON(I.unbondingTime) : void 0), I.maxValidators !== void 0 && (te.maxValidators = Math.round(I.maxValidators)), I.maxEntries !== void 0 && (te.maxEntries = Math.round(I.maxEntries)), I.historicalEntries !== void 0 && (te.historicalEntries = Math.round(I.historicalEntries)), I.bondDenom !== void 0 && (te.bondDenom = I.bondDenom), I.minCommissionRate !== void 0 && (te.minCommissionRate = I.minCommissionRate), te;
    },
    fromPartial(I) {
      const te = P();
      return I.unbondingTime !== void 0 && I.unbondingTime !== null && (te.unbondingTime = c.Duration.fromPartial(I.unbondingTime)), te.maxValidators = I.maxValidators ?? 0, te.maxEntries = I.maxEntries ?? 0, te.historicalEntries = I.historicalEntries ?? 0, te.bondDenom = I.bondDenom ?? "", te.minCommissionRate = I.minCommissionRate ?? "", te;
    }
  };
  function J() {
    return {
      delegation: e.Delegation.fromPartial({}),
      balance: d.Coin.fromPartial({})
    };
  }
  e.DelegationResponse = {
    typeUrl: "/cosmos.staking.v1beta1.DelegationResponse",
    encode(I, te = v.BinaryWriter.create()) {
      return I.delegation !== void 0 && e.Delegation.encode(I.delegation, te.uint32(10).fork()).ldelim(), I.balance !== void 0 && d.Coin.encode(I.balance, te.uint32(18).fork()).ldelim(), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = J();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.delegation = e.Delegation.decode(ge, ge.uint32());
            break;
          case 2:
            Ke.balance = d.Coin.decode(ge, ge.uint32());
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = J();
      return (0, S.isSet)(I.delegation) && (te.delegation = e.Delegation.fromJSON(I.delegation)), (0, S.isSet)(I.balance) && (te.balance = d.Coin.fromJSON(I.balance)), te;
    },
    toJSON(I) {
      const te = {};
      return I.delegation !== void 0 && (te.delegation = I.delegation ? e.Delegation.toJSON(I.delegation) : void 0), I.balance !== void 0 && (te.balance = I.balance ? d.Coin.toJSON(I.balance) : void 0), te;
    },
    fromPartial(I) {
      const te = J();
      return I.delegation !== void 0 && I.delegation !== null && (te.delegation = e.Delegation.fromPartial(I.delegation)), I.balance !== void 0 && I.balance !== null && (te.balance = d.Coin.fromPartial(I.balance)), te;
    }
  };
  function se() {
    return {
      redelegationEntry: e.RedelegationEntry.fromPartial({}),
      balance: ""
    };
  }
  e.RedelegationEntryResponse = {
    typeUrl: "/cosmos.staking.v1beta1.RedelegationEntryResponse",
    encode(I, te = v.BinaryWriter.create()) {
      return I.redelegationEntry !== void 0 && e.RedelegationEntry.encode(I.redelegationEntry, te.uint32(10).fork()).ldelim(), I.balance !== "" && te.uint32(34).string(I.balance), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = se();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.redelegationEntry = e.RedelegationEntry.decode(ge, ge.uint32());
            break;
          case 4:
            Ke.balance = ge.string();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = se();
      return (0, S.isSet)(I.redelegationEntry) && (te.redelegationEntry = e.RedelegationEntry.fromJSON(I.redelegationEntry)), (0, S.isSet)(I.balance) && (te.balance = String(I.balance)), te;
    },
    toJSON(I) {
      const te = {};
      return I.redelegationEntry !== void 0 && (te.redelegationEntry = I.redelegationEntry ? e.RedelegationEntry.toJSON(I.redelegationEntry) : void 0), I.balance !== void 0 && (te.balance = I.balance), te;
    },
    fromPartial(I) {
      const te = se();
      return I.redelegationEntry !== void 0 && I.redelegationEntry !== null && (te.redelegationEntry = e.RedelegationEntry.fromPartial(I.redelegationEntry)), te.balance = I.balance ?? "", te;
    }
  };
  function fe() {
    return {
      redelegation: e.Redelegation.fromPartial({}),
      entries: []
    };
  }
  e.RedelegationResponse = {
    typeUrl: "/cosmos.staking.v1beta1.RedelegationResponse",
    encode(I, te = v.BinaryWriter.create()) {
      I.redelegation !== void 0 && e.Redelegation.encode(I.redelegation, te.uint32(10).fork()).ldelim();
      for (const ge of I.entries)
        e.RedelegationEntryResponse.encode(ge, te.uint32(18).fork()).ldelim();
      return te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = fe();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.redelegation = e.Redelegation.decode(ge, ge.uint32());
            break;
          case 2:
            Ke.entries.push(e.RedelegationEntryResponse.decode(ge, ge.uint32()));
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = fe();
      return (0, S.isSet)(I.redelegation) && (te.redelegation = e.Redelegation.fromJSON(I.redelegation)), Array.isArray(I == null ? void 0 : I.entries) && (te.entries = I.entries.map((ge) => e.RedelegationEntryResponse.fromJSON(ge))), te;
    },
    toJSON(I) {
      const te = {};
      return I.redelegation !== void 0 && (te.redelegation = I.redelegation ? e.Redelegation.toJSON(I.redelegation) : void 0), I.entries ? te.entries = I.entries.map((ge) => ge ? e.RedelegationEntryResponse.toJSON(ge) : void 0) : te.entries = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = fe();
      return I.redelegation !== void 0 && I.redelegation !== null && (te.redelegation = e.Redelegation.fromPartial(I.redelegation)), te.entries = ((ge = I.entries) == null ? void 0 : ge.map((Pe) => e.RedelegationEntryResponse.fromPartial(Pe))) || [], te;
    }
  };
  function N() {
    return {
      notBondedTokens: "",
      bondedTokens: ""
    };
  }
  e.Pool = {
    typeUrl: "/cosmos.staking.v1beta1.Pool",
    encode(I, te = v.BinaryWriter.create()) {
      return I.notBondedTokens !== "" && te.uint32(10).string(I.notBondedTokens), I.bondedTokens !== "" && te.uint32(18).string(I.bondedTokens), te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = N();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.notBondedTokens = ge.string();
            break;
          case 2:
            Ke.bondedTokens = ge.string();
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = N();
      return (0, S.isSet)(I.notBondedTokens) && (te.notBondedTokens = String(I.notBondedTokens)), (0, S.isSet)(I.bondedTokens) && (te.bondedTokens = String(I.bondedTokens)), te;
    },
    toJSON(I) {
      const te = {};
      return I.notBondedTokens !== void 0 && (te.notBondedTokens = I.notBondedTokens), I.bondedTokens !== void 0 && (te.bondedTokens = I.bondedTokens), te;
    },
    fromPartial(I) {
      const te = N();
      return te.notBondedTokens = I.notBondedTokens ?? "", te.bondedTokens = I.bondedTokens ?? "", te;
    }
  };
  function W() {
    return {
      updates: []
    };
  }
  e.ValidatorUpdates = {
    typeUrl: "/cosmos.staking.v1beta1.ValidatorUpdates",
    encode(I, te = v.BinaryWriter.create()) {
      for (const ge of I.updates)
        m.ValidatorUpdate.encode(ge, te.uint32(10).fork()).ldelim();
      return te;
    },
    decode(I, te) {
      const ge = I instanceof v.BinaryReader ? I : new v.BinaryReader(I);
      let Pe = te === void 0 ? ge.len : ge.pos + te;
      const Ke = W();
      for (; ge.pos < Pe; ) {
        const xe = ge.uint32();
        switch (xe >>> 3) {
          case 1:
            Ke.updates.push(m.ValidatorUpdate.decode(ge, ge.uint32()));
            break;
          default:
            ge.skipType(xe & 7);
            break;
        }
      }
      return Ke;
    },
    fromJSON(I) {
      const te = W();
      return Array.isArray(I == null ? void 0 : I.updates) && (te.updates = I.updates.map((ge) => m.ValidatorUpdate.fromJSON(ge))), te;
    },
    toJSON(I) {
      const te = {};
      return I.updates ? te.updates = I.updates.map((ge) => ge ? m.ValidatorUpdate.toJSON(ge) : void 0) : te.updates = [], te;
    },
    fromPartial(I) {
      var ge;
      const te = W();
      return te.updates = ((ge = I.updates) == null ? void 0 : ge.map((Pe) => m.ValidatorUpdate.fromPartial(Pe))) || [], te;
    }
  };
})(staking$6);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgCancelUnbondingDelegationResponse = e.MsgCancelUnbondingDelegation = e.MsgUndelegateResponse = e.MsgUndelegate = e.MsgBeginRedelegateResponse = e.MsgBeginRedelegate = e.MsgDelegateResponse = e.MsgDelegate = e.MsgEditValidatorResponse = e.MsgEditValidator = e.MsgCreateValidatorResponse = e.MsgCreateValidator = e.protobufPackage = void 0;
  const n = staking$6, o = any$1, u = coin$8, c = timestamp$1, d = binary, m = helpers;
  e.protobufPackage = "cosmos.staking.v1beta1";
  function v() {
    return {
      description: n.Description.fromPartial({}),
      commission: n.CommissionRates.fromPartial({}),
      minSelfDelegation: "",
      delegatorAddress: "",
      validatorAddress: "",
      pubkey: void 0,
      value: u.Coin.fromPartial({})
    };
  }
  e.MsgCreateValidator = {
    typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.description !== void 0 && n.Description.encode(Q.description, Y.uint32(10).fork()).ldelim(), Q.commission !== void 0 && n.CommissionRates.encode(Q.commission, Y.uint32(18).fork()).ldelim(), Q.minSelfDelegation !== "" && Y.uint32(26).string(Q.minSelfDelegation), Q.delegatorAddress !== "" && Y.uint32(34).string(Q.delegatorAddress), Q.validatorAddress !== "" && Y.uint32(42).string(Q.validatorAddress), Q.pubkey !== void 0 && o.Any.encode(Q.pubkey, Y.uint32(50).fork()).ldelim(), Q.value !== void 0 && u.Coin.encode(Q.value, Y.uint32(58).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = v();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.description = n.Description.decode(pe, pe.uint32());
            break;
          case 2:
            ne.commission = n.CommissionRates.decode(pe, pe.uint32());
            break;
          case 3:
            ne.minSelfDelegation = pe.string();
            break;
          case 4:
            ne.delegatorAddress = pe.string();
            break;
          case 5:
            ne.validatorAddress = pe.string();
            break;
          case 6:
            ne.pubkey = o.Any.decode(pe, pe.uint32());
            break;
          case 7:
            ne.value = u.Coin.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = v();
      return (0, m.isSet)(Q.description) && (Y.description = n.Description.fromJSON(Q.description)), (0, m.isSet)(Q.commission) && (Y.commission = n.CommissionRates.fromJSON(Q.commission)), (0, m.isSet)(Q.minSelfDelegation) && (Y.minSelfDelegation = String(Q.minSelfDelegation)), (0, m.isSet)(Q.delegatorAddress) && (Y.delegatorAddress = String(Q.delegatorAddress)), (0, m.isSet)(Q.validatorAddress) && (Y.validatorAddress = String(Q.validatorAddress)), (0, m.isSet)(Q.pubkey) && (Y.pubkey = o.Any.fromJSON(Q.pubkey)), (0, m.isSet)(Q.value) && (Y.value = u.Coin.fromJSON(Q.value)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.description !== void 0 && (Y.description = Q.description ? n.Description.toJSON(Q.description) : void 0), Q.commission !== void 0 && (Y.commission = Q.commission ? n.CommissionRates.toJSON(Q.commission) : void 0), Q.minSelfDelegation !== void 0 && (Y.minSelfDelegation = Q.minSelfDelegation), Q.delegatorAddress !== void 0 && (Y.delegatorAddress = Q.delegatorAddress), Q.validatorAddress !== void 0 && (Y.validatorAddress = Q.validatorAddress), Q.pubkey !== void 0 && (Y.pubkey = Q.pubkey ? o.Any.toJSON(Q.pubkey) : void 0), Q.value !== void 0 && (Y.value = Q.value ? u.Coin.toJSON(Q.value) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = v();
      return Q.description !== void 0 && Q.description !== null && (Y.description = n.Description.fromPartial(Q.description)), Q.commission !== void 0 && Q.commission !== null && (Y.commission = n.CommissionRates.fromPartial(Q.commission)), Y.minSelfDelegation = Q.minSelfDelegation ?? "", Y.delegatorAddress = Q.delegatorAddress ?? "", Y.validatorAddress = Q.validatorAddress ?? "", Q.pubkey !== void 0 && Q.pubkey !== null && (Y.pubkey = o.Any.fromPartial(Q.pubkey)), Q.value !== void 0 && Q.value !== null && (Y.value = u.Coin.fromPartial(Q.value)), Y;
    }
  };
  function S() {
    return {};
  }
  e.MsgCreateValidatorResponse = {
    typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidatorResponse",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = S();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      return S();
    },
    toJSON(Q) {
      return {};
    },
    fromPartial(Q) {
      return S();
    }
  };
  function $() {
    return {
      description: n.Description.fromPartial({}),
      validatorAddress: "",
      commissionRate: "",
      minSelfDelegation: ""
    };
  }
  e.MsgEditValidator = {
    typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.description !== void 0 && n.Description.encode(Q.description, Y.uint32(10).fork()).ldelim(), Q.validatorAddress !== "" && Y.uint32(18).string(Q.validatorAddress), Q.commissionRate !== "" && Y.uint32(26).string(Q.commissionRate), Q.minSelfDelegation !== "" && Y.uint32(34).string(Q.minSelfDelegation), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = $();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.description = n.Description.decode(pe, pe.uint32());
            break;
          case 2:
            ne.validatorAddress = pe.string();
            break;
          case 3:
            ne.commissionRate = pe.string();
            break;
          case 4:
            ne.minSelfDelegation = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = $();
      return (0, m.isSet)(Q.description) && (Y.description = n.Description.fromJSON(Q.description)), (0, m.isSet)(Q.validatorAddress) && (Y.validatorAddress = String(Q.validatorAddress)), (0, m.isSet)(Q.commissionRate) && (Y.commissionRate = String(Q.commissionRate)), (0, m.isSet)(Q.minSelfDelegation) && (Y.minSelfDelegation = String(Q.minSelfDelegation)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.description !== void 0 && (Y.description = Q.description ? n.Description.toJSON(Q.description) : void 0), Q.validatorAddress !== void 0 && (Y.validatorAddress = Q.validatorAddress), Q.commissionRate !== void 0 && (Y.commissionRate = Q.commissionRate), Q.minSelfDelegation !== void 0 && (Y.minSelfDelegation = Q.minSelfDelegation), Y;
    },
    fromPartial(Q) {
      const Y = $();
      return Q.description !== void 0 && Q.description !== null && (Y.description = n.Description.fromPartial(Q.description)), Y.validatorAddress = Q.validatorAddress ?? "", Y.commissionRate = Q.commissionRate ?? "", Y.minSelfDelegation = Q.minSelfDelegation ?? "", Y;
    }
  };
  function E() {
    return {};
  }
  e.MsgEditValidatorResponse = {
    typeUrl: "/cosmos.staking.v1beta1.MsgEditValidatorResponse",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = E();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      return E();
    },
    toJSON(Q) {
      return {};
    },
    fromPartial(Q) {
      return E();
    }
  };
  function O() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: u.Coin.fromPartial({})
    };
  }
  e.MsgDelegate = {
    typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.delegatorAddress !== "" && Y.uint32(10).string(Q.delegatorAddress), Q.validatorAddress !== "" && Y.uint32(18).string(Q.validatorAddress), Q.amount !== void 0 && u.Coin.encode(Q.amount, Y.uint32(26).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = O();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.delegatorAddress = pe.string();
            break;
          case 2:
            ne.validatorAddress = pe.string();
            break;
          case 3:
            ne.amount = u.Coin.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = O();
      return (0, m.isSet)(Q.delegatorAddress) && (Y.delegatorAddress = String(Q.delegatorAddress)), (0, m.isSet)(Q.validatorAddress) && (Y.validatorAddress = String(Q.validatorAddress)), (0, m.isSet)(Q.amount) && (Y.amount = u.Coin.fromJSON(Q.amount)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.delegatorAddress !== void 0 && (Y.delegatorAddress = Q.delegatorAddress), Q.validatorAddress !== void 0 && (Y.validatorAddress = Q.validatorAddress), Q.amount !== void 0 && (Y.amount = Q.amount ? u.Coin.toJSON(Q.amount) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = O();
      return Y.delegatorAddress = Q.delegatorAddress ?? "", Y.validatorAddress = Q.validatorAddress ?? "", Q.amount !== void 0 && Q.amount !== null && (Y.amount = u.Coin.fromPartial(Q.amount)), Y;
    }
  };
  function T() {
    return {};
  }
  e.MsgDelegateResponse = {
    typeUrl: "/cosmos.staking.v1beta1.MsgDelegateResponse",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = T();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      return T();
    },
    toJSON(Q) {
      return {};
    },
    fromPartial(Q) {
      return T();
    }
  };
  function y() {
    return {
      delegatorAddress: "",
      validatorSrcAddress: "",
      validatorDstAddress: "",
      amount: u.Coin.fromPartial({})
    };
  }
  e.MsgBeginRedelegate = {
    typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.delegatorAddress !== "" && Y.uint32(10).string(Q.delegatorAddress), Q.validatorSrcAddress !== "" && Y.uint32(18).string(Q.validatorSrcAddress), Q.validatorDstAddress !== "" && Y.uint32(26).string(Q.validatorDstAddress), Q.amount !== void 0 && u.Coin.encode(Q.amount, Y.uint32(34).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = y();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.delegatorAddress = pe.string();
            break;
          case 2:
            ne.validatorSrcAddress = pe.string();
            break;
          case 3:
            ne.validatorDstAddress = pe.string();
            break;
          case 4:
            ne.amount = u.Coin.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = y();
      return (0, m.isSet)(Q.delegatorAddress) && (Y.delegatorAddress = String(Q.delegatorAddress)), (0, m.isSet)(Q.validatorSrcAddress) && (Y.validatorSrcAddress = String(Q.validatorSrcAddress)), (0, m.isSet)(Q.validatorDstAddress) && (Y.validatorDstAddress = String(Q.validatorDstAddress)), (0, m.isSet)(Q.amount) && (Y.amount = u.Coin.fromJSON(Q.amount)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.delegatorAddress !== void 0 && (Y.delegatorAddress = Q.delegatorAddress), Q.validatorSrcAddress !== void 0 && (Y.validatorSrcAddress = Q.validatorSrcAddress), Q.validatorDstAddress !== void 0 && (Y.validatorDstAddress = Q.validatorDstAddress), Q.amount !== void 0 && (Y.amount = Q.amount ? u.Coin.toJSON(Q.amount) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = y();
      return Y.delegatorAddress = Q.delegatorAddress ?? "", Y.validatorSrcAddress = Q.validatorSrcAddress ?? "", Y.validatorDstAddress = Q.validatorDstAddress ?? "", Q.amount !== void 0 && Q.amount !== null && (Y.amount = u.Coin.fromPartial(Q.amount)), Y;
    }
  };
  function V() {
    return {
      completionTime: c.Timestamp.fromPartial({})
    };
  }
  e.MsgBeginRedelegateResponse = {
    typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegateResponse",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.completionTime !== void 0 && c.Timestamp.encode(Q.completionTime, Y.uint32(10).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = V();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.completionTime = c.Timestamp.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = V();
      return (0, m.isSet)(Q.completionTime) && (Y.completionTime = (0, m.fromJsonTimestamp)(Q.completionTime)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.completionTime !== void 0 && (Y.completionTime = (0, m.fromTimestamp)(Q.completionTime).toISOString()), Y;
    },
    fromPartial(Q) {
      const Y = V();
      return Q.completionTime !== void 0 && Q.completionTime !== null && (Y.completionTime = c.Timestamp.fromPartial(Q.completionTime)), Y;
    }
  };
  function M() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: u.Coin.fromPartial({})
    };
  }
  e.MsgUndelegate = {
    typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.delegatorAddress !== "" && Y.uint32(10).string(Q.delegatorAddress), Q.validatorAddress !== "" && Y.uint32(18).string(Q.validatorAddress), Q.amount !== void 0 && u.Coin.encode(Q.amount, Y.uint32(26).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = M();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.delegatorAddress = pe.string();
            break;
          case 2:
            ne.validatorAddress = pe.string();
            break;
          case 3:
            ne.amount = u.Coin.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = M();
      return (0, m.isSet)(Q.delegatorAddress) && (Y.delegatorAddress = String(Q.delegatorAddress)), (0, m.isSet)(Q.validatorAddress) && (Y.validatorAddress = String(Q.validatorAddress)), (0, m.isSet)(Q.amount) && (Y.amount = u.Coin.fromJSON(Q.amount)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.delegatorAddress !== void 0 && (Y.delegatorAddress = Q.delegatorAddress), Q.validatorAddress !== void 0 && (Y.validatorAddress = Q.validatorAddress), Q.amount !== void 0 && (Y.amount = Q.amount ? u.Coin.toJSON(Q.amount) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = M();
      return Y.delegatorAddress = Q.delegatorAddress ?? "", Y.validatorAddress = Q.validatorAddress ?? "", Q.amount !== void 0 && Q.amount !== null && (Y.amount = u.Coin.fromPartial(Q.amount)), Y;
    }
  };
  function G() {
    return {
      completionTime: c.Timestamp.fromPartial({})
    };
  }
  e.MsgUndelegateResponse = {
    typeUrl: "/cosmos.staking.v1beta1.MsgUndelegateResponse",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.completionTime !== void 0 && c.Timestamp.encode(Q.completionTime, Y.uint32(10).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = G();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.completionTime = c.Timestamp.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = G();
      return (0, m.isSet)(Q.completionTime) && (Y.completionTime = (0, m.fromJsonTimestamp)(Q.completionTime)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.completionTime !== void 0 && (Y.completionTime = (0, m.fromTimestamp)(Q.completionTime).toISOString()), Y;
    },
    fromPartial(Q) {
      const Y = G();
      return Q.completionTime !== void 0 && Q.completionTime !== null && (Y.completionTime = c.Timestamp.fromPartial(Q.completionTime)), Y;
    }
  };
  function k() {
    return {
      delegatorAddress: "",
      validatorAddress: "",
      amount: u.Coin.fromPartial({}),
      creationHeight: BigInt(0)
    };
  }
  e.MsgCancelUnbondingDelegation = {
    typeUrl: "/cosmos.staking.v1beta1.MsgCancelUnbondingDelegation",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.delegatorAddress !== "" && Y.uint32(10).string(Q.delegatorAddress), Q.validatorAddress !== "" && Y.uint32(18).string(Q.validatorAddress), Q.amount !== void 0 && u.Coin.encode(Q.amount, Y.uint32(26).fork()).ldelim(), Q.creationHeight !== BigInt(0) && Y.uint32(32).int64(Q.creationHeight), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = k();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.delegatorAddress = pe.string();
            break;
          case 2:
            ne.validatorAddress = pe.string();
            break;
          case 3:
            ne.amount = u.Coin.decode(pe, pe.uint32());
            break;
          case 4:
            ne.creationHeight = pe.int64();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = k();
      return (0, m.isSet)(Q.delegatorAddress) && (Y.delegatorAddress = String(Q.delegatorAddress)), (0, m.isSet)(Q.validatorAddress) && (Y.validatorAddress = String(Q.validatorAddress)), (0, m.isSet)(Q.amount) && (Y.amount = u.Coin.fromJSON(Q.amount)), (0, m.isSet)(Q.creationHeight) && (Y.creationHeight = BigInt(Q.creationHeight.toString())), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.delegatorAddress !== void 0 && (Y.delegatorAddress = Q.delegatorAddress), Q.validatorAddress !== void 0 && (Y.validatorAddress = Q.validatorAddress), Q.amount !== void 0 && (Y.amount = Q.amount ? u.Coin.toJSON(Q.amount) : void 0), Q.creationHeight !== void 0 && (Y.creationHeight = (Q.creationHeight || BigInt(0)).toString()), Y;
    },
    fromPartial(Q) {
      const Y = k();
      return Y.delegatorAddress = Q.delegatorAddress ?? "", Y.validatorAddress = Q.validatorAddress ?? "", Q.amount !== void 0 && Q.amount !== null && (Y.amount = u.Coin.fromPartial(Q.amount)), Q.creationHeight !== void 0 && Q.creationHeight !== null && (Y.creationHeight = BigInt(Q.creationHeight.toString())), Y;
    }
  };
  function F() {
    return {};
  }
  e.MsgCancelUnbondingDelegationResponse = {
    typeUrl: "/cosmos.staking.v1beta1.MsgCancelUnbondingDelegationResponse",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = F();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      return F();
    },
    toJSON(Q) {
      return {};
    },
    fromPartial(Q) {
      return F();
    }
  };
  function X() {
    return {
      authority: "",
      params: n.Params.fromPartial({})
    };
  }
  e.MsgUpdateParams = {
    typeUrl: "/cosmos.staking.v1beta1.MsgUpdateParams",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Q.authority !== "" && Y.uint32(10).string(Q.authority), Q.params !== void 0 && n.Params.encode(Q.params, Y.uint32(18).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = X();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.authority = pe.string();
            break;
          case 2:
            ne.params = n.Params.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = X();
      return (0, m.isSet)(Q.authority) && (Y.authority = String(Q.authority)), (0, m.isSet)(Q.params) && (Y.params = n.Params.fromJSON(Q.params)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.authority !== void 0 && (Y.authority = Q.authority), Q.params !== void 0 && (Y.params = Q.params ? n.Params.toJSON(Q.params) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = X();
      return Y.authority = Q.authority ?? "", Q.params !== void 0 && Q.params !== null && (Y.params = n.Params.fromPartial(Q.params)), Y;
    }
  };
  function ee() {
    return {};
  }
  e.MsgUpdateParamsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.MsgUpdateParamsResponse",
    encode(Q, Y = d.BinaryWriter.create()) {
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof d.BinaryReader ? Q : new d.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ee();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      return ee();
    },
    toJSON(Q) {
      return {};
    },
    fromPartial(Q) {
      return ee();
    }
  };
  class ue {
    constructor(Y) {
      this.rpc = Y, this.CreateValidator = this.CreateValidator.bind(this), this.EditValidator = this.EditValidator.bind(this), this.Delegate = this.Delegate.bind(this), this.BeginRedelegate = this.BeginRedelegate.bind(this), this.Undelegate = this.Undelegate.bind(this), this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
    }
    CreateValidator(Y) {
      const pe = e.MsgCreateValidator.encode(Y).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", pe).then((ne) => e.MsgCreateValidatorResponse.decode(new d.BinaryReader(ne)));
    }
    EditValidator(Y) {
      const pe = e.MsgEditValidator.encode(Y).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", pe).then((ne) => e.MsgEditValidatorResponse.decode(new d.BinaryReader(ne)));
    }
    Delegate(Y) {
      const pe = e.MsgDelegate.encode(Y).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", pe).then((ne) => e.MsgDelegateResponse.decode(new d.BinaryReader(ne)));
    }
    BeginRedelegate(Y) {
      const pe = e.MsgBeginRedelegate.encode(Y).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", pe).then((ne) => e.MsgBeginRedelegateResponse.decode(new d.BinaryReader(ne)));
    }
    Undelegate(Y) {
      const pe = e.MsgUndelegate.encode(Y).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", pe).then((ne) => e.MsgUndelegateResponse.decode(new d.BinaryReader(ne)));
    }
    CancelUnbondingDelegation(Y) {
      const pe = e.MsgCancelUnbondingDelegation.encode(Y).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "CancelUnbondingDelegation", pe).then((ne) => e.MsgCancelUnbondingDelegationResponse.decode(new d.BinaryReader(ne)));
    }
    UpdateParams(Y) {
      const pe = e.MsgUpdateParams.encode(Y).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Msg", "UpdateParams", pe).then((ne) => e.MsgUpdateParamsResponse.decode(new d.BinaryReader(ne)));
    }
  }
  e.MsgClientImpl = ue;
})(tx$d);
Object.defineProperty(messages$b, "__esModule", { value: !0 });
messages$b.isMsgUndelegateEncodeObject = messages$b.isMsgEditValidatorEncodeObject = messages$b.isMsgDelegateEncodeObject = messages$b.isMsgCreateValidatorEncodeObject = messages$b.isMsgBeginRedelegateEncodeObject = messages$b.stakingTypes = void 0;
const tx_1$i = tx$d;
messages$b.stakingTypes = [
  ["/cosmos.staking.v1beta1.MsgBeginRedelegate", tx_1$i.MsgBeginRedelegate],
  ["/cosmos.staking.v1beta1.MsgCreateValidator", tx_1$i.MsgCreateValidator],
  ["/cosmos.staking.v1beta1.MsgDelegate", tx_1$i.MsgDelegate],
  ["/cosmos.staking.v1beta1.MsgEditValidator", tx_1$i.MsgEditValidator],
  ["/cosmos.staking.v1beta1.MsgUndelegate", tx_1$i.MsgUndelegate]
];
function isMsgBeginRedelegateEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
messages$b.isMsgBeginRedelegateEncodeObject = isMsgBeginRedelegateEncodeObject$1;
function isMsgCreateValidatorEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
messages$b.isMsgCreateValidatorEncodeObject = isMsgCreateValidatorEncodeObject$1;
function isMsgDelegateEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
messages$b.isMsgDelegateEncodeObject = isMsgDelegateEncodeObject$1;
function isMsgEditValidatorEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
messages$b.isMsgEditValidatorEncodeObject = isMsgEditValidatorEncodeObject$1;
function isMsgUndelegateEncodeObject$1(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
messages$b.isMsgUndelegateEncodeObject = isMsgUndelegateEncodeObject$1;
var queries$d = {}, query$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryPoolResponse = e.QueryPoolRequest = e.QueryHistoricalInfoResponse = e.QueryHistoricalInfoRequest = e.QueryDelegatorValidatorResponse = e.QueryDelegatorValidatorRequest = e.QueryDelegatorValidatorsResponse = e.QueryDelegatorValidatorsRequest = e.QueryRedelegationsResponse = e.QueryRedelegationsRequest = e.QueryDelegatorUnbondingDelegationsResponse = e.QueryDelegatorUnbondingDelegationsRequest = e.QueryDelegatorDelegationsResponse = e.QueryDelegatorDelegationsRequest = e.QueryUnbondingDelegationResponse = e.QueryUnbondingDelegationRequest = e.QueryDelegationResponse = e.QueryDelegationRequest = e.QueryValidatorUnbondingDelegationsResponse = e.QueryValidatorUnbondingDelegationsRequest = e.QueryValidatorDelegationsResponse = e.QueryValidatorDelegationsRequest = e.QueryValidatorResponse = e.QueryValidatorRequest = e.QueryValidatorsResponse = e.QueryValidatorsRequest = e.protobufPackage = void 0;
  const n = pagination, o = staking$6, u = binary, c = helpers;
  e.protobufPackage = "cosmos.staking.v1beta1";
  function d() {
    return {
      status: "",
      pagination: void 0
    };
  }
  e.QueryValidatorsRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.status !== "" && W.uint32(10).string(N.status), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = d();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.status = I.string();
            break;
          case 2:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = d();
      return (0, c.isSet)(N.status) && (W.status = String(N.status)), (0, c.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.status !== void 0 && (W.status = N.status), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = d();
      return W.status = N.status ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function m() {
    return {
      validators: [],
      pagination: void 0
    };
  }
  e.QueryValidatorsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsResponse",
    encode(N, W = u.BinaryWriter.create()) {
      for (const I of N.validators)
        o.Validator.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = m();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.validators.push(o.Validator.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = m();
      return Array.isArray(N == null ? void 0 : N.validators) && (W.validators = N.validators.map((I) => o.Validator.fromJSON(I))), (0, c.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.validators ? W.validators = N.validators.map((I) => I ? o.Validator.toJSON(I) : void 0) : W.validators = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = m();
      return W.validators = ((I = N.validators) == null ? void 0 : I.map((te) => o.Validator.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), W;
    }
  };
  function v() {
    return {
      validatorAddr: ""
    };
  }
  e.QueryValidatorRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryValidatorRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.validatorAddr !== "" && W.uint32(10).string(N.validatorAddr), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = v();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.validatorAddr = I.string();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = v();
      return (0, c.isSet)(N.validatorAddr) && (W.validatorAddr = String(N.validatorAddr)), W;
    },
    toJSON(N) {
      const W = {};
      return N.validatorAddr !== void 0 && (W.validatorAddr = N.validatorAddr), W;
    },
    fromPartial(N) {
      const W = v();
      return W.validatorAddr = N.validatorAddr ?? "", W;
    }
  };
  function S() {
    return {
      validator: o.Validator.fromPartial({})
    };
  }
  e.QueryValidatorResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryValidatorResponse",
    encode(N, W = u.BinaryWriter.create()) {
      return N.validator !== void 0 && o.Validator.encode(N.validator, W.uint32(10).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = S();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.validator = o.Validator.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = S();
      return (0, c.isSet)(N.validator) && (W.validator = o.Validator.fromJSON(N.validator)), W;
    },
    toJSON(N) {
      const W = {};
      return N.validator !== void 0 && (W.validator = N.validator ? o.Validator.toJSON(N.validator) : void 0), W;
    },
    fromPartial(N) {
      const W = S();
      return N.validator !== void 0 && N.validator !== null && (W.validator = o.Validator.fromPartial(N.validator)), W;
    }
  };
  function $() {
    return {
      validatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryValidatorDelegationsRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.validatorAddr !== "" && W.uint32(10).string(N.validatorAddr), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = $();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.validatorAddr = I.string();
            break;
          case 2:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = $();
      return (0, c.isSet)(N.validatorAddr) && (W.validatorAddr = String(N.validatorAddr)), (0, c.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.validatorAddr !== void 0 && (W.validatorAddr = N.validatorAddr), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = $();
      return W.validatorAddr = N.validatorAddr ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function E() {
    return {
      delegationResponses: [],
      pagination: void 0
    };
  }
  e.QueryValidatorDelegationsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsResponse",
    encode(N, W = u.BinaryWriter.create()) {
      for (const I of N.delegationResponses)
        o.DelegationResponse.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = E();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegationResponses.push(o.DelegationResponse.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = E();
      return Array.isArray(N == null ? void 0 : N.delegationResponses) && (W.delegationResponses = N.delegationResponses.map((I) => o.DelegationResponse.fromJSON(I))), (0, c.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegationResponses ? W.delegationResponses = N.delegationResponses.map((I) => I ? o.DelegationResponse.toJSON(I) : void 0) : W.delegationResponses = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = E();
      return W.delegationResponses = ((I = N.delegationResponses) == null ? void 0 : I.map((te) => o.DelegationResponse.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), W;
    }
  };
  function O() {
    return {
      validatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryValidatorUnbondingDelegationsRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.validatorAddr !== "" && W.uint32(10).string(N.validatorAddr), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = O();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.validatorAddr = I.string();
            break;
          case 2:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = O();
      return (0, c.isSet)(N.validatorAddr) && (W.validatorAddr = String(N.validatorAddr)), (0, c.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.validatorAddr !== void 0 && (W.validatorAddr = N.validatorAddr), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = O();
      return W.validatorAddr = N.validatorAddr ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function T() {
    return {
      unbondingResponses: [],
      pagination: void 0
    };
  }
  e.QueryValidatorUnbondingDelegationsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsResponse",
    encode(N, W = u.BinaryWriter.create()) {
      for (const I of N.unbondingResponses)
        o.UnbondingDelegation.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = T();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.unbondingResponses.push(o.UnbondingDelegation.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = T();
      return Array.isArray(N == null ? void 0 : N.unbondingResponses) && (W.unbondingResponses = N.unbondingResponses.map((I) => o.UnbondingDelegation.fromJSON(I))), (0, c.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.unbondingResponses ? W.unbondingResponses = N.unbondingResponses.map((I) => I ? o.UnbondingDelegation.toJSON(I) : void 0) : W.unbondingResponses = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = T();
      return W.unbondingResponses = ((I = N.unbondingResponses) == null ? void 0 : I.map((te) => o.UnbondingDelegation.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), W;
    }
  };
  function y() {
    return {
      delegatorAddr: "",
      validatorAddr: ""
    };
  }
  e.QueryDelegationRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegationRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.delegatorAddr !== "" && W.uint32(10).string(N.delegatorAddr), N.validatorAddr !== "" && W.uint32(18).string(N.validatorAddr), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = y();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegatorAddr = I.string();
            break;
          case 2:
            ge.validatorAddr = I.string();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = y();
      return (0, c.isSet)(N.delegatorAddr) && (W.delegatorAddr = String(N.delegatorAddr)), (0, c.isSet)(N.validatorAddr) && (W.validatorAddr = String(N.validatorAddr)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegatorAddr !== void 0 && (W.delegatorAddr = N.delegatorAddr), N.validatorAddr !== void 0 && (W.validatorAddr = N.validatorAddr), W;
    },
    fromPartial(N) {
      const W = y();
      return W.delegatorAddr = N.delegatorAddr ?? "", W.validatorAddr = N.validatorAddr ?? "", W;
    }
  };
  function V() {
    return {
      delegationResponse: void 0
    };
  }
  e.QueryDelegationResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegationResponse",
    encode(N, W = u.BinaryWriter.create()) {
      return N.delegationResponse !== void 0 && o.DelegationResponse.encode(N.delegationResponse, W.uint32(10).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = V();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegationResponse = o.DelegationResponse.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = V();
      return (0, c.isSet)(N.delegationResponse) && (W.delegationResponse = o.DelegationResponse.fromJSON(N.delegationResponse)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegationResponse !== void 0 && (W.delegationResponse = N.delegationResponse ? o.DelegationResponse.toJSON(N.delegationResponse) : void 0), W;
    },
    fromPartial(N) {
      const W = V();
      return N.delegationResponse !== void 0 && N.delegationResponse !== null && (W.delegationResponse = o.DelegationResponse.fromPartial(N.delegationResponse)), W;
    }
  };
  function M() {
    return {
      delegatorAddr: "",
      validatorAddr: ""
    };
  }
  e.QueryUnbondingDelegationRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.delegatorAddr !== "" && W.uint32(10).string(N.delegatorAddr), N.validatorAddr !== "" && W.uint32(18).string(N.validatorAddr), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = M();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegatorAddr = I.string();
            break;
          case 2:
            ge.validatorAddr = I.string();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = M();
      return (0, c.isSet)(N.delegatorAddr) && (W.delegatorAddr = String(N.delegatorAddr)), (0, c.isSet)(N.validatorAddr) && (W.validatorAddr = String(N.validatorAddr)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegatorAddr !== void 0 && (W.delegatorAddr = N.delegatorAddr), N.validatorAddr !== void 0 && (W.validatorAddr = N.validatorAddr), W;
    },
    fromPartial(N) {
      const W = M();
      return W.delegatorAddr = N.delegatorAddr ?? "", W.validatorAddr = N.validatorAddr ?? "", W;
    }
  };
  function G() {
    return {
      unbond: o.UnbondingDelegation.fromPartial({})
    };
  }
  e.QueryUnbondingDelegationResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationResponse",
    encode(N, W = u.BinaryWriter.create()) {
      return N.unbond !== void 0 && o.UnbondingDelegation.encode(N.unbond, W.uint32(10).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = G();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.unbond = o.UnbondingDelegation.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = G();
      return (0, c.isSet)(N.unbond) && (W.unbond = o.UnbondingDelegation.fromJSON(N.unbond)), W;
    },
    toJSON(N) {
      const W = {};
      return N.unbond !== void 0 && (W.unbond = N.unbond ? o.UnbondingDelegation.toJSON(N.unbond) : void 0), W;
    },
    fromPartial(N) {
      const W = G();
      return N.unbond !== void 0 && N.unbond !== null && (W.unbond = o.UnbondingDelegation.fromPartial(N.unbond)), W;
    }
  };
  function k() {
    return {
      delegatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryDelegatorDelegationsRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.delegatorAddr !== "" && W.uint32(10).string(N.delegatorAddr), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = k();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegatorAddr = I.string();
            break;
          case 2:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = k();
      return (0, c.isSet)(N.delegatorAddr) && (W.delegatorAddr = String(N.delegatorAddr)), (0, c.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegatorAddr !== void 0 && (W.delegatorAddr = N.delegatorAddr), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = k();
      return W.delegatorAddr = N.delegatorAddr ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function F() {
    return {
      delegationResponses: [],
      pagination: void 0
    };
  }
  e.QueryDelegatorDelegationsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsResponse",
    encode(N, W = u.BinaryWriter.create()) {
      for (const I of N.delegationResponses)
        o.DelegationResponse.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = F();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegationResponses.push(o.DelegationResponse.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = F();
      return Array.isArray(N == null ? void 0 : N.delegationResponses) && (W.delegationResponses = N.delegationResponses.map((I) => o.DelegationResponse.fromJSON(I))), (0, c.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegationResponses ? W.delegationResponses = N.delegationResponses.map((I) => I ? o.DelegationResponse.toJSON(I) : void 0) : W.delegationResponses = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = F();
      return W.delegationResponses = ((I = N.delegationResponses) == null ? void 0 : I.map((te) => o.DelegationResponse.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), W;
    }
  };
  function X() {
    return {
      delegatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryDelegatorUnbondingDelegationsRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.delegatorAddr !== "" && W.uint32(10).string(N.delegatorAddr), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = X();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegatorAddr = I.string();
            break;
          case 2:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = X();
      return (0, c.isSet)(N.delegatorAddr) && (W.delegatorAddr = String(N.delegatorAddr)), (0, c.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegatorAddr !== void 0 && (W.delegatorAddr = N.delegatorAddr), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = X();
      return W.delegatorAddr = N.delegatorAddr ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function ee() {
    return {
      unbondingResponses: [],
      pagination: void 0
    };
  }
  e.QueryDelegatorUnbondingDelegationsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsResponse",
    encode(N, W = u.BinaryWriter.create()) {
      for (const I of N.unbondingResponses)
        o.UnbondingDelegation.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = ee();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.unbondingResponses.push(o.UnbondingDelegation.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = ee();
      return Array.isArray(N == null ? void 0 : N.unbondingResponses) && (W.unbondingResponses = N.unbondingResponses.map((I) => o.UnbondingDelegation.fromJSON(I))), (0, c.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.unbondingResponses ? W.unbondingResponses = N.unbondingResponses.map((I) => I ? o.UnbondingDelegation.toJSON(I) : void 0) : W.unbondingResponses = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = ee();
      return W.unbondingResponses = ((I = N.unbondingResponses) == null ? void 0 : I.map((te) => o.UnbondingDelegation.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), W;
    }
  };
  function ue() {
    return {
      delegatorAddr: "",
      srcValidatorAddr: "",
      dstValidatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryRedelegationsRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.delegatorAddr !== "" && W.uint32(10).string(N.delegatorAddr), N.srcValidatorAddr !== "" && W.uint32(18).string(N.srcValidatorAddr), N.dstValidatorAddr !== "" && W.uint32(26).string(N.dstValidatorAddr), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(34).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = ue();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegatorAddr = I.string();
            break;
          case 2:
            ge.srcValidatorAddr = I.string();
            break;
          case 3:
            ge.dstValidatorAddr = I.string();
            break;
          case 4:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = ue();
      return (0, c.isSet)(N.delegatorAddr) && (W.delegatorAddr = String(N.delegatorAddr)), (0, c.isSet)(N.srcValidatorAddr) && (W.srcValidatorAddr = String(N.srcValidatorAddr)), (0, c.isSet)(N.dstValidatorAddr) && (W.dstValidatorAddr = String(N.dstValidatorAddr)), (0, c.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegatorAddr !== void 0 && (W.delegatorAddr = N.delegatorAddr), N.srcValidatorAddr !== void 0 && (W.srcValidatorAddr = N.srcValidatorAddr), N.dstValidatorAddr !== void 0 && (W.dstValidatorAddr = N.dstValidatorAddr), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = ue();
      return W.delegatorAddr = N.delegatorAddr ?? "", W.srcValidatorAddr = N.srcValidatorAddr ?? "", W.dstValidatorAddr = N.dstValidatorAddr ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function Q() {
    return {
      redelegationResponses: [],
      pagination: void 0
    };
  }
  e.QueryRedelegationsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsResponse",
    encode(N, W = u.BinaryWriter.create()) {
      for (const I of N.redelegationResponses)
        o.RedelegationResponse.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = Q();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.redelegationResponses.push(o.RedelegationResponse.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = Q();
      return Array.isArray(N == null ? void 0 : N.redelegationResponses) && (W.redelegationResponses = N.redelegationResponses.map((I) => o.RedelegationResponse.fromJSON(I))), (0, c.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.redelegationResponses ? W.redelegationResponses = N.redelegationResponses.map((I) => I ? o.RedelegationResponse.toJSON(I) : void 0) : W.redelegationResponses = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = Q();
      return W.redelegationResponses = ((I = N.redelegationResponses) == null ? void 0 : I.map((te) => o.RedelegationResponse.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), W;
    }
  };
  function Y() {
    return {
      delegatorAddr: "",
      pagination: void 0
    };
  }
  e.QueryDelegatorValidatorsRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.delegatorAddr !== "" && W.uint32(10).string(N.delegatorAddr), N.pagination !== void 0 && n.PageRequest.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = Y();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegatorAddr = I.string();
            break;
          case 2:
            ge.pagination = n.PageRequest.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = Y();
      return (0, c.isSet)(N.delegatorAddr) && (W.delegatorAddr = String(N.delegatorAddr)), (0, c.isSet)(N.pagination) && (W.pagination = n.PageRequest.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegatorAddr !== void 0 && (W.delegatorAddr = N.delegatorAddr), N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageRequest.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      const W = Y();
      return W.delegatorAddr = N.delegatorAddr ?? "", N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageRequest.fromPartial(N.pagination)), W;
    }
  };
  function pe() {
    return {
      validators: [],
      pagination: void 0
    };
  }
  e.QueryDelegatorValidatorsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsResponse",
    encode(N, W = u.BinaryWriter.create()) {
      for (const I of N.validators)
        o.Validator.encode(I, W.uint32(10).fork()).ldelim();
      return N.pagination !== void 0 && n.PageResponse.encode(N.pagination, W.uint32(18).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = pe();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.validators.push(o.Validator.decode(I, I.uint32()));
            break;
          case 2:
            ge.pagination = n.PageResponse.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = pe();
      return Array.isArray(N == null ? void 0 : N.validators) && (W.validators = N.validators.map((I) => o.Validator.fromJSON(I))), (0, c.isSet)(N.pagination) && (W.pagination = n.PageResponse.fromJSON(N.pagination)), W;
    },
    toJSON(N) {
      const W = {};
      return N.validators ? W.validators = N.validators.map((I) => I ? o.Validator.toJSON(I) : void 0) : W.validators = [], N.pagination !== void 0 && (W.pagination = N.pagination ? n.PageResponse.toJSON(N.pagination) : void 0), W;
    },
    fromPartial(N) {
      var I;
      const W = pe();
      return W.validators = ((I = N.validators) == null ? void 0 : I.map((te) => o.Validator.fromPartial(te))) || [], N.pagination !== void 0 && N.pagination !== null && (W.pagination = n.PageResponse.fromPartial(N.pagination)), W;
    }
  };
  function oe() {
    return {
      delegatorAddr: "",
      validatorAddr: ""
    };
  }
  e.QueryDelegatorValidatorRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.delegatorAddr !== "" && W.uint32(10).string(N.delegatorAddr), N.validatorAddr !== "" && W.uint32(18).string(N.validatorAddr), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = oe();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.delegatorAddr = I.string();
            break;
          case 2:
            ge.validatorAddr = I.string();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = oe();
      return (0, c.isSet)(N.delegatorAddr) && (W.delegatorAddr = String(N.delegatorAddr)), (0, c.isSet)(N.validatorAddr) && (W.validatorAddr = String(N.validatorAddr)), W;
    },
    toJSON(N) {
      const W = {};
      return N.delegatorAddr !== void 0 && (W.delegatorAddr = N.delegatorAddr), N.validatorAddr !== void 0 && (W.validatorAddr = N.validatorAddr), W;
    },
    fromPartial(N) {
      const W = oe();
      return W.delegatorAddr = N.delegatorAddr ?? "", W.validatorAddr = N.validatorAddr ?? "", W;
    }
  };
  function ne() {
    return {
      validator: o.Validator.fromPartial({})
    };
  }
  e.QueryDelegatorValidatorResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorResponse",
    encode(N, W = u.BinaryWriter.create()) {
      return N.validator !== void 0 && o.Validator.encode(N.validator, W.uint32(10).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = ne();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.validator = o.Validator.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = ne();
      return (0, c.isSet)(N.validator) && (W.validator = o.Validator.fromJSON(N.validator)), W;
    },
    toJSON(N) {
      const W = {};
      return N.validator !== void 0 && (W.validator = N.validator ? o.Validator.toJSON(N.validator) : void 0), W;
    },
    fromPartial(N) {
      const W = ne();
      return N.validator !== void 0 && N.validator !== null && (W.validator = o.Validator.fromPartial(N.validator)), W;
    }
  };
  function H() {
    return {
      height: BigInt(0)
    };
  }
  e.QueryHistoricalInfoRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return N.height !== BigInt(0) && W.uint32(8).int64(N.height), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = H();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.height = I.int64();
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = H();
      return (0, c.isSet)(N.height) && (W.height = BigInt(N.height.toString())), W;
    },
    toJSON(N) {
      const W = {};
      return N.height !== void 0 && (W.height = (N.height || BigInt(0)).toString()), W;
    },
    fromPartial(N) {
      const W = H();
      return N.height !== void 0 && N.height !== null && (W.height = BigInt(N.height.toString())), W;
    }
  };
  function C() {
    return {
      hist: void 0
    };
  }
  e.QueryHistoricalInfoResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoResponse",
    encode(N, W = u.BinaryWriter.create()) {
      return N.hist !== void 0 && o.HistoricalInfo.encode(N.hist, W.uint32(10).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = C();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.hist = o.HistoricalInfo.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = C();
      return (0, c.isSet)(N.hist) && (W.hist = o.HistoricalInfo.fromJSON(N.hist)), W;
    },
    toJSON(N) {
      const W = {};
      return N.hist !== void 0 && (W.hist = N.hist ? o.HistoricalInfo.toJSON(N.hist) : void 0), W;
    },
    fromPartial(N) {
      const W = C();
      return N.hist !== void 0 && N.hist !== null && (W.hist = o.HistoricalInfo.fromPartial(N.hist)), W;
    }
  };
  function w() {
    return {};
  }
  e.QueryPoolRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryPoolRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = w();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      return w();
    },
    toJSON(N) {
      return {};
    },
    fromPartial(N) {
      return w();
    }
  };
  function P() {
    return {
      pool: o.Pool.fromPartial({})
    };
  }
  e.QueryPoolResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryPoolResponse",
    encode(N, W = u.BinaryWriter.create()) {
      return N.pool !== void 0 && o.Pool.encode(N.pool, W.uint32(10).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = P();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.pool = o.Pool.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = P();
      return (0, c.isSet)(N.pool) && (W.pool = o.Pool.fromJSON(N.pool)), W;
    },
    toJSON(N) {
      const W = {};
      return N.pool !== void 0 && (W.pool = N.pool ? o.Pool.toJSON(N.pool) : void 0), W;
    },
    fromPartial(N) {
      const W = P();
      return N.pool !== void 0 && N.pool !== null && (W.pool = o.Pool.fromPartial(N.pool)), W;
    }
  };
  function J() {
    return {};
  }
  e.QueryParamsRequest = {
    typeUrl: "/cosmos.staking.v1beta1.QueryParamsRequest",
    encode(N, W = u.BinaryWriter.create()) {
      return W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = J();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      return J();
    },
    toJSON(N) {
      return {};
    },
    fromPartial(N) {
      return J();
    }
  };
  function se() {
    return {
      params: o.Params.fromPartial({})
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/cosmos.staking.v1beta1.QueryParamsResponse",
    encode(N, W = u.BinaryWriter.create()) {
      return N.params !== void 0 && o.Params.encode(N.params, W.uint32(10).fork()).ldelim(), W;
    },
    decode(N, W) {
      const I = N instanceof u.BinaryReader ? N : new u.BinaryReader(N);
      let te = W === void 0 ? I.len : I.pos + W;
      const ge = se();
      for (; I.pos < te; ) {
        const Pe = I.uint32();
        switch (Pe >>> 3) {
          case 1:
            ge.params = o.Params.decode(I, I.uint32());
            break;
          default:
            I.skipType(Pe & 7);
            break;
        }
      }
      return ge;
    },
    fromJSON(N) {
      const W = se();
      return (0, c.isSet)(N.params) && (W.params = o.Params.fromJSON(N.params)), W;
    },
    toJSON(N) {
      const W = {};
      return N.params !== void 0 && (W.params = N.params ? o.Params.toJSON(N.params) : void 0), W;
    },
    fromPartial(N) {
      const W = se();
      return N.params !== void 0 && N.params !== null && (W.params = o.Params.fromPartial(N.params)), W;
    }
  };
  class fe {
    constructor(W) {
      this.rpc = W, this.Validators = this.Validators.bind(this), this.Validator = this.Validator.bind(this), this.ValidatorDelegations = this.ValidatorDelegations.bind(this), this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this), this.Delegation = this.Delegation.bind(this), this.UnbondingDelegation = this.UnbondingDelegation.bind(this), this.DelegatorDelegations = this.DelegatorDelegations.bind(this), this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this), this.Redelegations = this.Redelegations.bind(this), this.DelegatorValidators = this.DelegatorValidators.bind(this), this.DelegatorValidator = this.DelegatorValidator.bind(this), this.HistoricalInfo = this.HistoricalInfo.bind(this), this.Pool = this.Pool.bind(this), this.Params = this.Params.bind(this);
    }
    Validators(W) {
      const I = e.QueryValidatorsRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", I).then((ge) => e.QueryValidatorsResponse.decode(new u.BinaryReader(ge)));
    }
    Validator(W) {
      const I = e.QueryValidatorRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", I).then((ge) => e.QueryValidatorResponse.decode(new u.BinaryReader(ge)));
    }
    ValidatorDelegations(W) {
      const I = e.QueryValidatorDelegationsRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", I).then((ge) => e.QueryValidatorDelegationsResponse.decode(new u.BinaryReader(ge)));
    }
    ValidatorUnbondingDelegations(W) {
      const I = e.QueryValidatorUnbondingDelegationsRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", I).then((ge) => e.QueryValidatorUnbondingDelegationsResponse.decode(new u.BinaryReader(ge)));
    }
    Delegation(W) {
      const I = e.QueryDelegationRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", I).then((ge) => e.QueryDelegationResponse.decode(new u.BinaryReader(ge)));
    }
    UnbondingDelegation(W) {
      const I = e.QueryUnbondingDelegationRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", I).then((ge) => e.QueryUnbondingDelegationResponse.decode(new u.BinaryReader(ge)));
    }
    DelegatorDelegations(W) {
      const I = e.QueryDelegatorDelegationsRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", I).then((ge) => e.QueryDelegatorDelegationsResponse.decode(new u.BinaryReader(ge)));
    }
    DelegatorUnbondingDelegations(W) {
      const I = e.QueryDelegatorUnbondingDelegationsRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", I).then((ge) => e.QueryDelegatorUnbondingDelegationsResponse.decode(new u.BinaryReader(ge)));
    }
    Redelegations(W) {
      const I = e.QueryRedelegationsRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", I).then((ge) => e.QueryRedelegationsResponse.decode(new u.BinaryReader(ge)));
    }
    DelegatorValidators(W) {
      const I = e.QueryDelegatorValidatorsRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", I).then((ge) => e.QueryDelegatorValidatorsResponse.decode(new u.BinaryReader(ge)));
    }
    DelegatorValidator(W) {
      const I = e.QueryDelegatorValidatorRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", I).then((ge) => e.QueryDelegatorValidatorResponse.decode(new u.BinaryReader(ge)));
    }
    HistoricalInfo(W) {
      const I = e.QueryHistoricalInfoRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", I).then((ge) => e.QueryHistoricalInfoResponse.decode(new u.BinaryReader(ge)));
    }
    Pool(W = {}) {
      const I = e.QueryPoolRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", I).then((ge) => e.QueryPoolResponse.decode(new u.BinaryReader(ge)));
    }
    Params(W = {}) {
      const I = e.QueryParamsRequest.encode(W).finish();
      return this.rpc.request("cosmos.staking.v1beta1.Query", "Params", I).then((ge) => e.QueryParamsResponse.decode(new u.BinaryReader(ge)));
    }
  }
  e.QueryClientImpl = fe;
})(query$1);
Object.defineProperty(queries$d, "__esModule", { value: !0 });
queries$d.setupStakingExtension = void 0;
const query_1$b = query$1, queryclient_1$f = queryclient$3;
function setupStakingExtension$1(e) {
  const n = (0, queryclient_1$f.createProtobufRpcClient)(e), o = new query_1$b.QueryClientImpl(n);
  return {
    staking: {
      delegation: async (u, c) => await o.Delegation({
        delegatorAddr: u,
        validatorAddr: c
      }),
      delegatorDelegations: async (u, c) => await o.DelegatorDelegations({
        delegatorAddr: u,
        pagination: (0, queryclient_1$f.createPagination)(c)
      }),
      delegatorUnbondingDelegations: async (u, c) => await o.DelegatorUnbondingDelegations({
        delegatorAddr: u,
        pagination: (0, queryclient_1$f.createPagination)(c)
      }),
      delegatorValidator: async (u, c) => await o.DelegatorValidator({
        delegatorAddr: u,
        validatorAddr: c
      }),
      delegatorValidators: async (u, c) => await o.DelegatorValidators({
        delegatorAddr: u,
        pagination: (0, queryclient_1$f.createPagination)(c)
      }),
      historicalInfo: async (u) => await o.HistoricalInfo({
        height: BigInt(u)
      }),
      params: async () => await o.Params({}),
      pool: async () => await o.Pool({}),
      redelegations: async (u, c, d, m) => await o.Redelegations({
        delegatorAddr: u,
        srcValidatorAddr: c,
        dstValidatorAddr: d,
        pagination: (0, queryclient_1$f.createPagination)(m)
      }),
      unbondingDelegation: async (u, c) => await o.UnbondingDelegation({
        delegatorAddr: u,
        validatorAddr: c
      }),
      validator: async (u) => await o.Validator({ validatorAddr: u }),
      validatorDelegations: async (u, c) => await o.ValidatorDelegations({
        validatorAddr: u,
        pagination: (0, queryclient_1$f.createPagination)(c)
      }),
      validators: async (u, c) => await o.Validators({
        status: u,
        pagination: (0, queryclient_1$f.createPagination)(c)
      }),
      validatorUnbondingDelegations: async (u, c) => await o.ValidatorUnbondingDelegations({
        validatorAddr: u,
        pagination: (0, queryclient_1$f.createPagination)(c)
      })
    }
  };
}
queries$d.setupStakingExtension = setupStakingExtension$1;
var queries$c = {}, service = {}, abci = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SearchTxsResult = e.TxMsgData = e.MsgData = e.SimulationResponse = e.Result = e.GasInfo = e.Attribute = e.StringEvent = e.ABCIMessageLog = e.TxResponse = e.protobufPackage = void 0;
  const n = any$1, o = types$c, u = binary, c = helpers;
  e.protobufPackage = "cosmos.base.abci.v1beta1";
  function d() {
    return {
      height: BigInt(0),
      txhash: "",
      codespace: "",
      code: 0,
      data: "",
      rawLog: "",
      logs: [],
      info: "",
      gasWanted: BigInt(0),
      gasUsed: BigInt(0),
      tx: void 0,
      timestamp: "",
      events: []
    };
  }
  e.TxResponse = {
    typeUrl: "/cosmos.base.abci.v1beta1.TxResponse",
    encode(M, G = u.BinaryWriter.create()) {
      M.height !== BigInt(0) && G.uint32(8).int64(M.height), M.txhash !== "" && G.uint32(18).string(M.txhash), M.codespace !== "" && G.uint32(26).string(M.codespace), M.code !== 0 && G.uint32(32).uint32(M.code), M.data !== "" && G.uint32(42).string(M.data), M.rawLog !== "" && G.uint32(50).string(M.rawLog);
      for (const k of M.logs)
        e.ABCIMessageLog.encode(k, G.uint32(58).fork()).ldelim();
      M.info !== "" && G.uint32(66).string(M.info), M.gasWanted !== BigInt(0) && G.uint32(72).int64(M.gasWanted), M.gasUsed !== BigInt(0) && G.uint32(80).int64(M.gasUsed), M.tx !== void 0 && n.Any.encode(M.tx, G.uint32(90).fork()).ldelim(), M.timestamp !== "" && G.uint32(98).string(M.timestamp);
      for (const k of M.events)
        o.Event.encode(k, G.uint32(106).fork()).ldelim();
      return G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = d();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.height = k.int64();
            break;
          case 2:
            X.txhash = k.string();
            break;
          case 3:
            X.codespace = k.string();
            break;
          case 4:
            X.code = k.uint32();
            break;
          case 5:
            X.data = k.string();
            break;
          case 6:
            X.rawLog = k.string();
            break;
          case 7:
            X.logs.push(e.ABCIMessageLog.decode(k, k.uint32()));
            break;
          case 8:
            X.info = k.string();
            break;
          case 9:
            X.gasWanted = k.int64();
            break;
          case 10:
            X.gasUsed = k.int64();
            break;
          case 11:
            X.tx = n.Any.decode(k, k.uint32());
            break;
          case 12:
            X.timestamp = k.string();
            break;
          case 13:
            X.events.push(o.Event.decode(k, k.uint32()));
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = d();
      return (0, c.isSet)(M.height) && (G.height = BigInt(M.height.toString())), (0, c.isSet)(M.txhash) && (G.txhash = String(M.txhash)), (0, c.isSet)(M.codespace) && (G.codespace = String(M.codespace)), (0, c.isSet)(M.code) && (G.code = Number(M.code)), (0, c.isSet)(M.data) && (G.data = String(M.data)), (0, c.isSet)(M.rawLog) && (G.rawLog = String(M.rawLog)), Array.isArray(M == null ? void 0 : M.logs) && (G.logs = M.logs.map((k) => e.ABCIMessageLog.fromJSON(k))), (0, c.isSet)(M.info) && (G.info = String(M.info)), (0, c.isSet)(M.gasWanted) && (G.gasWanted = BigInt(M.gasWanted.toString())), (0, c.isSet)(M.gasUsed) && (G.gasUsed = BigInt(M.gasUsed.toString())), (0, c.isSet)(M.tx) && (G.tx = n.Any.fromJSON(M.tx)), (0, c.isSet)(M.timestamp) && (G.timestamp = String(M.timestamp)), Array.isArray(M == null ? void 0 : M.events) && (G.events = M.events.map((k) => o.Event.fromJSON(k))), G;
    },
    toJSON(M) {
      const G = {};
      return M.height !== void 0 && (G.height = (M.height || BigInt(0)).toString()), M.txhash !== void 0 && (G.txhash = M.txhash), M.codespace !== void 0 && (G.codespace = M.codespace), M.code !== void 0 && (G.code = Math.round(M.code)), M.data !== void 0 && (G.data = M.data), M.rawLog !== void 0 && (G.rawLog = M.rawLog), M.logs ? G.logs = M.logs.map((k) => k ? e.ABCIMessageLog.toJSON(k) : void 0) : G.logs = [], M.info !== void 0 && (G.info = M.info), M.gasWanted !== void 0 && (G.gasWanted = (M.gasWanted || BigInt(0)).toString()), M.gasUsed !== void 0 && (G.gasUsed = (M.gasUsed || BigInt(0)).toString()), M.tx !== void 0 && (G.tx = M.tx ? n.Any.toJSON(M.tx) : void 0), M.timestamp !== void 0 && (G.timestamp = M.timestamp), M.events ? G.events = M.events.map((k) => k ? o.Event.toJSON(k) : void 0) : G.events = [], G;
    },
    fromPartial(M) {
      var k, F;
      const G = d();
      return M.height !== void 0 && M.height !== null && (G.height = BigInt(M.height.toString())), G.txhash = M.txhash ?? "", G.codespace = M.codespace ?? "", G.code = M.code ?? 0, G.data = M.data ?? "", G.rawLog = M.rawLog ?? "", G.logs = ((k = M.logs) == null ? void 0 : k.map((X) => e.ABCIMessageLog.fromPartial(X))) || [], G.info = M.info ?? "", M.gasWanted !== void 0 && M.gasWanted !== null && (G.gasWanted = BigInt(M.gasWanted.toString())), M.gasUsed !== void 0 && M.gasUsed !== null && (G.gasUsed = BigInt(M.gasUsed.toString())), M.tx !== void 0 && M.tx !== null && (G.tx = n.Any.fromPartial(M.tx)), G.timestamp = M.timestamp ?? "", G.events = ((F = M.events) == null ? void 0 : F.map((X) => o.Event.fromPartial(X))) || [], G;
    }
  };
  function m() {
    return {
      msgIndex: 0,
      log: "",
      events: []
    };
  }
  e.ABCIMessageLog = {
    typeUrl: "/cosmos.base.abci.v1beta1.ABCIMessageLog",
    encode(M, G = u.BinaryWriter.create()) {
      M.msgIndex !== 0 && G.uint32(8).uint32(M.msgIndex), M.log !== "" && G.uint32(18).string(M.log);
      for (const k of M.events)
        e.StringEvent.encode(k, G.uint32(26).fork()).ldelim();
      return G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = m();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.msgIndex = k.uint32();
            break;
          case 2:
            X.log = k.string();
            break;
          case 3:
            X.events.push(e.StringEvent.decode(k, k.uint32()));
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = m();
      return (0, c.isSet)(M.msgIndex) && (G.msgIndex = Number(M.msgIndex)), (0, c.isSet)(M.log) && (G.log = String(M.log)), Array.isArray(M == null ? void 0 : M.events) && (G.events = M.events.map((k) => e.StringEvent.fromJSON(k))), G;
    },
    toJSON(M) {
      const G = {};
      return M.msgIndex !== void 0 && (G.msgIndex = Math.round(M.msgIndex)), M.log !== void 0 && (G.log = M.log), M.events ? G.events = M.events.map((k) => k ? e.StringEvent.toJSON(k) : void 0) : G.events = [], G;
    },
    fromPartial(M) {
      var k;
      const G = m();
      return G.msgIndex = M.msgIndex ?? 0, G.log = M.log ?? "", G.events = ((k = M.events) == null ? void 0 : k.map((F) => e.StringEvent.fromPartial(F))) || [], G;
    }
  };
  function v() {
    return {
      type: "",
      attributes: []
    };
  }
  e.StringEvent = {
    typeUrl: "/cosmos.base.abci.v1beta1.StringEvent",
    encode(M, G = u.BinaryWriter.create()) {
      M.type !== "" && G.uint32(10).string(M.type);
      for (const k of M.attributes)
        e.Attribute.encode(k, G.uint32(18).fork()).ldelim();
      return G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = v();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.type = k.string();
            break;
          case 2:
            X.attributes.push(e.Attribute.decode(k, k.uint32()));
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = v();
      return (0, c.isSet)(M.type) && (G.type = String(M.type)), Array.isArray(M == null ? void 0 : M.attributes) && (G.attributes = M.attributes.map((k) => e.Attribute.fromJSON(k))), G;
    },
    toJSON(M) {
      const G = {};
      return M.type !== void 0 && (G.type = M.type), M.attributes ? G.attributes = M.attributes.map((k) => k ? e.Attribute.toJSON(k) : void 0) : G.attributes = [], G;
    },
    fromPartial(M) {
      var k;
      const G = v();
      return G.type = M.type ?? "", G.attributes = ((k = M.attributes) == null ? void 0 : k.map((F) => e.Attribute.fromPartial(F))) || [], G;
    }
  };
  function S() {
    return {
      key: "",
      value: ""
    };
  }
  e.Attribute = {
    typeUrl: "/cosmos.base.abci.v1beta1.Attribute",
    encode(M, G = u.BinaryWriter.create()) {
      return M.key !== "" && G.uint32(10).string(M.key), M.value !== "" && G.uint32(18).string(M.value), G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = S();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.key = k.string();
            break;
          case 2:
            X.value = k.string();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = S();
      return (0, c.isSet)(M.key) && (G.key = String(M.key)), (0, c.isSet)(M.value) && (G.value = String(M.value)), G;
    },
    toJSON(M) {
      const G = {};
      return M.key !== void 0 && (G.key = M.key), M.value !== void 0 && (G.value = M.value), G;
    },
    fromPartial(M) {
      const G = S();
      return G.key = M.key ?? "", G.value = M.value ?? "", G;
    }
  };
  function $() {
    return {
      gasWanted: BigInt(0),
      gasUsed: BigInt(0)
    };
  }
  e.GasInfo = {
    typeUrl: "/cosmos.base.abci.v1beta1.GasInfo",
    encode(M, G = u.BinaryWriter.create()) {
      return M.gasWanted !== BigInt(0) && G.uint32(8).uint64(M.gasWanted), M.gasUsed !== BigInt(0) && G.uint32(16).uint64(M.gasUsed), G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = $();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.gasWanted = k.uint64();
            break;
          case 2:
            X.gasUsed = k.uint64();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = $();
      return (0, c.isSet)(M.gasWanted) && (G.gasWanted = BigInt(M.gasWanted.toString())), (0, c.isSet)(M.gasUsed) && (G.gasUsed = BigInt(M.gasUsed.toString())), G;
    },
    toJSON(M) {
      const G = {};
      return M.gasWanted !== void 0 && (G.gasWanted = (M.gasWanted || BigInt(0)).toString()), M.gasUsed !== void 0 && (G.gasUsed = (M.gasUsed || BigInt(0)).toString()), G;
    },
    fromPartial(M) {
      const G = $();
      return M.gasWanted !== void 0 && M.gasWanted !== null && (G.gasWanted = BigInt(M.gasWanted.toString())), M.gasUsed !== void 0 && M.gasUsed !== null && (G.gasUsed = BigInt(M.gasUsed.toString())), G;
    }
  };
  function E() {
    return {
      data: new Uint8Array(),
      log: "",
      events: [],
      msgResponses: []
    };
  }
  e.Result = {
    typeUrl: "/cosmos.base.abci.v1beta1.Result",
    encode(M, G = u.BinaryWriter.create()) {
      M.data.length !== 0 && G.uint32(10).bytes(M.data), M.log !== "" && G.uint32(18).string(M.log);
      for (const k of M.events)
        o.Event.encode(k, G.uint32(26).fork()).ldelim();
      for (const k of M.msgResponses)
        n.Any.encode(k, G.uint32(34).fork()).ldelim();
      return G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = E();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.data = k.bytes();
            break;
          case 2:
            X.log = k.string();
            break;
          case 3:
            X.events.push(o.Event.decode(k, k.uint32()));
            break;
          case 4:
            X.msgResponses.push(n.Any.decode(k, k.uint32()));
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = E();
      return (0, c.isSet)(M.data) && (G.data = (0, c.bytesFromBase64)(M.data)), (0, c.isSet)(M.log) && (G.log = String(M.log)), Array.isArray(M == null ? void 0 : M.events) && (G.events = M.events.map((k) => o.Event.fromJSON(k))), Array.isArray(M == null ? void 0 : M.msgResponses) && (G.msgResponses = M.msgResponses.map((k) => n.Any.fromJSON(k))), G;
    },
    toJSON(M) {
      const G = {};
      return M.data !== void 0 && (G.data = (0, c.base64FromBytes)(M.data !== void 0 ? M.data : new Uint8Array())), M.log !== void 0 && (G.log = M.log), M.events ? G.events = M.events.map((k) => k ? o.Event.toJSON(k) : void 0) : G.events = [], M.msgResponses ? G.msgResponses = M.msgResponses.map((k) => k ? n.Any.toJSON(k) : void 0) : G.msgResponses = [], G;
    },
    fromPartial(M) {
      var k, F;
      const G = E();
      return G.data = M.data ?? new Uint8Array(), G.log = M.log ?? "", G.events = ((k = M.events) == null ? void 0 : k.map((X) => o.Event.fromPartial(X))) || [], G.msgResponses = ((F = M.msgResponses) == null ? void 0 : F.map((X) => n.Any.fromPartial(X))) || [], G;
    }
  };
  function O() {
    return {
      gasInfo: e.GasInfo.fromPartial({}),
      result: void 0
    };
  }
  e.SimulationResponse = {
    typeUrl: "/cosmos.base.abci.v1beta1.SimulationResponse",
    encode(M, G = u.BinaryWriter.create()) {
      return M.gasInfo !== void 0 && e.GasInfo.encode(M.gasInfo, G.uint32(10).fork()).ldelim(), M.result !== void 0 && e.Result.encode(M.result, G.uint32(18).fork()).ldelim(), G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = O();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.gasInfo = e.GasInfo.decode(k, k.uint32());
            break;
          case 2:
            X.result = e.Result.decode(k, k.uint32());
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = O();
      return (0, c.isSet)(M.gasInfo) && (G.gasInfo = e.GasInfo.fromJSON(M.gasInfo)), (0, c.isSet)(M.result) && (G.result = e.Result.fromJSON(M.result)), G;
    },
    toJSON(M) {
      const G = {};
      return M.gasInfo !== void 0 && (G.gasInfo = M.gasInfo ? e.GasInfo.toJSON(M.gasInfo) : void 0), M.result !== void 0 && (G.result = M.result ? e.Result.toJSON(M.result) : void 0), G;
    },
    fromPartial(M) {
      const G = O();
      return M.gasInfo !== void 0 && M.gasInfo !== null && (G.gasInfo = e.GasInfo.fromPartial(M.gasInfo)), M.result !== void 0 && M.result !== null && (G.result = e.Result.fromPartial(M.result)), G;
    }
  };
  function T() {
    return {
      msgType: "",
      data: new Uint8Array()
    };
  }
  e.MsgData = {
    typeUrl: "/cosmos.base.abci.v1beta1.MsgData",
    encode(M, G = u.BinaryWriter.create()) {
      return M.msgType !== "" && G.uint32(10).string(M.msgType), M.data.length !== 0 && G.uint32(18).bytes(M.data), G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = T();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.msgType = k.string();
            break;
          case 2:
            X.data = k.bytes();
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = T();
      return (0, c.isSet)(M.msgType) && (G.msgType = String(M.msgType)), (0, c.isSet)(M.data) && (G.data = (0, c.bytesFromBase64)(M.data)), G;
    },
    toJSON(M) {
      const G = {};
      return M.msgType !== void 0 && (G.msgType = M.msgType), M.data !== void 0 && (G.data = (0, c.base64FromBytes)(M.data !== void 0 ? M.data : new Uint8Array())), G;
    },
    fromPartial(M) {
      const G = T();
      return G.msgType = M.msgType ?? "", G.data = M.data ?? new Uint8Array(), G;
    }
  };
  function y() {
    return {
      data: [],
      msgResponses: []
    };
  }
  e.TxMsgData = {
    typeUrl: "/cosmos.base.abci.v1beta1.TxMsgData",
    encode(M, G = u.BinaryWriter.create()) {
      for (const k of M.data)
        e.MsgData.encode(k, G.uint32(10).fork()).ldelim();
      for (const k of M.msgResponses)
        n.Any.encode(k, G.uint32(18).fork()).ldelim();
      return G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = y();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.data.push(e.MsgData.decode(k, k.uint32()));
            break;
          case 2:
            X.msgResponses.push(n.Any.decode(k, k.uint32()));
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = y();
      return Array.isArray(M == null ? void 0 : M.data) && (G.data = M.data.map((k) => e.MsgData.fromJSON(k))), Array.isArray(M == null ? void 0 : M.msgResponses) && (G.msgResponses = M.msgResponses.map((k) => n.Any.fromJSON(k))), G;
    },
    toJSON(M) {
      const G = {};
      return M.data ? G.data = M.data.map((k) => k ? e.MsgData.toJSON(k) : void 0) : G.data = [], M.msgResponses ? G.msgResponses = M.msgResponses.map((k) => k ? n.Any.toJSON(k) : void 0) : G.msgResponses = [], G;
    },
    fromPartial(M) {
      var k, F;
      const G = y();
      return G.data = ((k = M.data) == null ? void 0 : k.map((X) => e.MsgData.fromPartial(X))) || [], G.msgResponses = ((F = M.msgResponses) == null ? void 0 : F.map((X) => n.Any.fromPartial(X))) || [], G;
    }
  };
  function V() {
    return {
      totalCount: BigInt(0),
      count: BigInt(0),
      pageNumber: BigInt(0),
      pageTotal: BigInt(0),
      limit: BigInt(0),
      txs: []
    };
  }
  e.SearchTxsResult = {
    typeUrl: "/cosmos.base.abci.v1beta1.SearchTxsResult",
    encode(M, G = u.BinaryWriter.create()) {
      M.totalCount !== BigInt(0) && G.uint32(8).uint64(M.totalCount), M.count !== BigInt(0) && G.uint32(16).uint64(M.count), M.pageNumber !== BigInt(0) && G.uint32(24).uint64(M.pageNumber), M.pageTotal !== BigInt(0) && G.uint32(32).uint64(M.pageTotal), M.limit !== BigInt(0) && G.uint32(40).uint64(M.limit);
      for (const k of M.txs)
        e.TxResponse.encode(k, G.uint32(50).fork()).ldelim();
      return G;
    },
    decode(M, G) {
      const k = M instanceof u.BinaryReader ? M : new u.BinaryReader(M);
      let F = G === void 0 ? k.len : k.pos + G;
      const X = V();
      for (; k.pos < F; ) {
        const ee = k.uint32();
        switch (ee >>> 3) {
          case 1:
            X.totalCount = k.uint64();
            break;
          case 2:
            X.count = k.uint64();
            break;
          case 3:
            X.pageNumber = k.uint64();
            break;
          case 4:
            X.pageTotal = k.uint64();
            break;
          case 5:
            X.limit = k.uint64();
            break;
          case 6:
            X.txs.push(e.TxResponse.decode(k, k.uint32()));
            break;
          default:
            k.skipType(ee & 7);
            break;
        }
      }
      return X;
    },
    fromJSON(M) {
      const G = V();
      return (0, c.isSet)(M.totalCount) && (G.totalCount = BigInt(M.totalCount.toString())), (0, c.isSet)(M.count) && (G.count = BigInt(M.count.toString())), (0, c.isSet)(M.pageNumber) && (G.pageNumber = BigInt(M.pageNumber.toString())), (0, c.isSet)(M.pageTotal) && (G.pageTotal = BigInt(M.pageTotal.toString())), (0, c.isSet)(M.limit) && (G.limit = BigInt(M.limit.toString())), Array.isArray(M == null ? void 0 : M.txs) && (G.txs = M.txs.map((k) => e.TxResponse.fromJSON(k))), G;
    },
    toJSON(M) {
      const G = {};
      return M.totalCount !== void 0 && (G.totalCount = (M.totalCount || BigInt(0)).toString()), M.count !== void 0 && (G.count = (M.count || BigInt(0)).toString()), M.pageNumber !== void 0 && (G.pageNumber = (M.pageNumber || BigInt(0)).toString()), M.pageTotal !== void 0 && (G.pageTotal = (M.pageTotal || BigInt(0)).toString()), M.limit !== void 0 && (G.limit = (M.limit || BigInt(0)).toString()), M.txs ? G.txs = M.txs.map((k) => k ? e.TxResponse.toJSON(k) : void 0) : G.txs = [], G;
    },
    fromPartial(M) {
      var k;
      const G = V();
      return M.totalCount !== void 0 && M.totalCount !== null && (G.totalCount = BigInt(M.totalCount.toString())), M.count !== void 0 && M.count !== null && (G.count = BigInt(M.count.toString())), M.pageNumber !== void 0 && M.pageNumber !== null && (G.pageNumber = BigInt(M.pageNumber.toString())), M.pageTotal !== void 0 && M.pageTotal !== null && (G.pageTotal = BigInt(M.pageTotal.toString())), M.limit !== void 0 && M.limit !== null && (G.limit = BigInt(M.limit.toString())), G.txs = ((k = M.txs) == null ? void 0 : k.map((F) => e.TxResponse.fromPartial(F))) || [], G;
    }
  };
})(abci);
var block = {}, evidence = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EvidenceList = e.LightClientAttackEvidence = e.DuplicateVoteEvidence = e.Evidence = e.protobufPackage = void 0;
  const n = types$e, o = timestamp$1, u = validator$b, c = binary, d = helpers;
  e.protobufPackage = "tendermint.types";
  function m() {
    return {
      duplicateVoteEvidence: void 0,
      lightClientAttackEvidence: void 0
    };
  }
  e.Evidence = {
    typeUrl: "/tendermint.types.Evidence",
    encode(E, O = c.BinaryWriter.create()) {
      return E.duplicateVoteEvidence !== void 0 && e.DuplicateVoteEvidence.encode(E.duplicateVoteEvidence, O.uint32(10).fork()).ldelim(), E.lightClientAttackEvidence !== void 0 && e.LightClientAttackEvidence.encode(E.lightClientAttackEvidence, O.uint32(18).fork()).ldelim(), O;
    },
    decode(E, O) {
      const T = E instanceof c.BinaryReader ? E : new c.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = m();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.duplicateVoteEvidence = e.DuplicateVoteEvidence.decode(T, T.uint32());
            break;
          case 2:
            V.lightClientAttackEvidence = e.LightClientAttackEvidence.decode(T, T.uint32());
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = m();
      return (0, d.isSet)(E.duplicateVoteEvidence) && (O.duplicateVoteEvidence = e.DuplicateVoteEvidence.fromJSON(E.duplicateVoteEvidence)), (0, d.isSet)(E.lightClientAttackEvidence) && (O.lightClientAttackEvidence = e.LightClientAttackEvidence.fromJSON(E.lightClientAttackEvidence)), O;
    },
    toJSON(E) {
      const O = {};
      return E.duplicateVoteEvidence !== void 0 && (O.duplicateVoteEvidence = E.duplicateVoteEvidence ? e.DuplicateVoteEvidence.toJSON(E.duplicateVoteEvidence) : void 0), E.lightClientAttackEvidence !== void 0 && (O.lightClientAttackEvidence = E.lightClientAttackEvidence ? e.LightClientAttackEvidence.toJSON(E.lightClientAttackEvidence) : void 0), O;
    },
    fromPartial(E) {
      const O = m();
      return E.duplicateVoteEvidence !== void 0 && E.duplicateVoteEvidence !== null && (O.duplicateVoteEvidence = e.DuplicateVoteEvidence.fromPartial(E.duplicateVoteEvidence)), E.lightClientAttackEvidence !== void 0 && E.lightClientAttackEvidence !== null && (O.lightClientAttackEvidence = e.LightClientAttackEvidence.fromPartial(E.lightClientAttackEvidence)), O;
    }
  };
  function v() {
    return {
      voteA: void 0,
      voteB: void 0,
      totalVotingPower: BigInt(0),
      validatorPower: BigInt(0),
      timestamp: o.Timestamp.fromPartial({})
    };
  }
  e.DuplicateVoteEvidence = {
    typeUrl: "/tendermint.types.DuplicateVoteEvidence",
    encode(E, O = c.BinaryWriter.create()) {
      return E.voteA !== void 0 && n.Vote.encode(E.voteA, O.uint32(10).fork()).ldelim(), E.voteB !== void 0 && n.Vote.encode(E.voteB, O.uint32(18).fork()).ldelim(), E.totalVotingPower !== BigInt(0) && O.uint32(24).int64(E.totalVotingPower), E.validatorPower !== BigInt(0) && O.uint32(32).int64(E.validatorPower), E.timestamp !== void 0 && o.Timestamp.encode(E.timestamp, O.uint32(42).fork()).ldelim(), O;
    },
    decode(E, O) {
      const T = E instanceof c.BinaryReader ? E : new c.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = v();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.voteA = n.Vote.decode(T, T.uint32());
            break;
          case 2:
            V.voteB = n.Vote.decode(T, T.uint32());
            break;
          case 3:
            V.totalVotingPower = T.int64();
            break;
          case 4:
            V.validatorPower = T.int64();
            break;
          case 5:
            V.timestamp = o.Timestamp.decode(T, T.uint32());
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = v();
      return (0, d.isSet)(E.voteA) && (O.voteA = n.Vote.fromJSON(E.voteA)), (0, d.isSet)(E.voteB) && (O.voteB = n.Vote.fromJSON(E.voteB)), (0, d.isSet)(E.totalVotingPower) && (O.totalVotingPower = BigInt(E.totalVotingPower.toString())), (0, d.isSet)(E.validatorPower) && (O.validatorPower = BigInt(E.validatorPower.toString())), (0, d.isSet)(E.timestamp) && (O.timestamp = (0, d.fromJsonTimestamp)(E.timestamp)), O;
    },
    toJSON(E) {
      const O = {};
      return E.voteA !== void 0 && (O.voteA = E.voteA ? n.Vote.toJSON(E.voteA) : void 0), E.voteB !== void 0 && (O.voteB = E.voteB ? n.Vote.toJSON(E.voteB) : void 0), E.totalVotingPower !== void 0 && (O.totalVotingPower = (E.totalVotingPower || BigInt(0)).toString()), E.validatorPower !== void 0 && (O.validatorPower = (E.validatorPower || BigInt(0)).toString()), E.timestamp !== void 0 && (O.timestamp = (0, d.fromTimestamp)(E.timestamp).toISOString()), O;
    },
    fromPartial(E) {
      const O = v();
      return E.voteA !== void 0 && E.voteA !== null && (O.voteA = n.Vote.fromPartial(E.voteA)), E.voteB !== void 0 && E.voteB !== null && (O.voteB = n.Vote.fromPartial(E.voteB)), E.totalVotingPower !== void 0 && E.totalVotingPower !== null && (O.totalVotingPower = BigInt(E.totalVotingPower.toString())), E.validatorPower !== void 0 && E.validatorPower !== null && (O.validatorPower = BigInt(E.validatorPower.toString())), E.timestamp !== void 0 && E.timestamp !== null && (O.timestamp = o.Timestamp.fromPartial(E.timestamp)), O;
    }
  };
  function S() {
    return {
      conflictingBlock: void 0,
      commonHeight: BigInt(0),
      byzantineValidators: [],
      totalVotingPower: BigInt(0),
      timestamp: o.Timestamp.fromPartial({})
    };
  }
  e.LightClientAttackEvidence = {
    typeUrl: "/tendermint.types.LightClientAttackEvidence",
    encode(E, O = c.BinaryWriter.create()) {
      E.conflictingBlock !== void 0 && n.LightBlock.encode(E.conflictingBlock, O.uint32(10).fork()).ldelim(), E.commonHeight !== BigInt(0) && O.uint32(16).int64(E.commonHeight);
      for (const T of E.byzantineValidators)
        u.Validator.encode(T, O.uint32(26).fork()).ldelim();
      return E.totalVotingPower !== BigInt(0) && O.uint32(32).int64(E.totalVotingPower), E.timestamp !== void 0 && o.Timestamp.encode(E.timestamp, O.uint32(42).fork()).ldelim(), O;
    },
    decode(E, O) {
      const T = E instanceof c.BinaryReader ? E : new c.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = S();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.conflictingBlock = n.LightBlock.decode(T, T.uint32());
            break;
          case 2:
            V.commonHeight = T.int64();
            break;
          case 3:
            V.byzantineValidators.push(u.Validator.decode(T, T.uint32()));
            break;
          case 4:
            V.totalVotingPower = T.int64();
            break;
          case 5:
            V.timestamp = o.Timestamp.decode(T, T.uint32());
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = S();
      return (0, d.isSet)(E.conflictingBlock) && (O.conflictingBlock = n.LightBlock.fromJSON(E.conflictingBlock)), (0, d.isSet)(E.commonHeight) && (O.commonHeight = BigInt(E.commonHeight.toString())), Array.isArray(E == null ? void 0 : E.byzantineValidators) && (O.byzantineValidators = E.byzantineValidators.map((T) => u.Validator.fromJSON(T))), (0, d.isSet)(E.totalVotingPower) && (O.totalVotingPower = BigInt(E.totalVotingPower.toString())), (0, d.isSet)(E.timestamp) && (O.timestamp = (0, d.fromJsonTimestamp)(E.timestamp)), O;
    },
    toJSON(E) {
      const O = {};
      return E.conflictingBlock !== void 0 && (O.conflictingBlock = E.conflictingBlock ? n.LightBlock.toJSON(E.conflictingBlock) : void 0), E.commonHeight !== void 0 && (O.commonHeight = (E.commonHeight || BigInt(0)).toString()), E.byzantineValidators ? O.byzantineValidators = E.byzantineValidators.map((T) => T ? u.Validator.toJSON(T) : void 0) : O.byzantineValidators = [], E.totalVotingPower !== void 0 && (O.totalVotingPower = (E.totalVotingPower || BigInt(0)).toString()), E.timestamp !== void 0 && (O.timestamp = (0, d.fromTimestamp)(E.timestamp).toISOString()), O;
    },
    fromPartial(E) {
      var T;
      const O = S();
      return E.conflictingBlock !== void 0 && E.conflictingBlock !== null && (O.conflictingBlock = n.LightBlock.fromPartial(E.conflictingBlock)), E.commonHeight !== void 0 && E.commonHeight !== null && (O.commonHeight = BigInt(E.commonHeight.toString())), O.byzantineValidators = ((T = E.byzantineValidators) == null ? void 0 : T.map((y) => u.Validator.fromPartial(y))) || [], E.totalVotingPower !== void 0 && E.totalVotingPower !== null && (O.totalVotingPower = BigInt(E.totalVotingPower.toString())), E.timestamp !== void 0 && E.timestamp !== null && (O.timestamp = o.Timestamp.fromPartial(E.timestamp)), O;
    }
  };
  function $() {
    return {
      evidence: []
    };
  }
  e.EvidenceList = {
    typeUrl: "/tendermint.types.EvidenceList",
    encode(E, O = c.BinaryWriter.create()) {
      for (const T of E.evidence)
        e.Evidence.encode(T, O.uint32(10).fork()).ldelim();
      return O;
    },
    decode(E, O) {
      const T = E instanceof c.BinaryReader ? E : new c.BinaryReader(E);
      let y = O === void 0 ? T.len : T.pos + O;
      const V = $();
      for (; T.pos < y; ) {
        const M = T.uint32();
        switch (M >>> 3) {
          case 1:
            V.evidence.push(e.Evidence.decode(T, T.uint32()));
            break;
          default:
            T.skipType(M & 7);
            break;
        }
      }
      return V;
    },
    fromJSON(E) {
      const O = $();
      return Array.isArray(E == null ? void 0 : E.evidence) && (O.evidence = E.evidence.map((T) => e.Evidence.fromJSON(T))), O;
    },
    toJSON(E) {
      const O = {};
      return E.evidence ? O.evidence = E.evidence.map((T) => T ? e.Evidence.toJSON(T) : void 0) : O.evidence = [], O;
    },
    fromPartial(E) {
      var T;
      const O = $();
      return O.evidence = ((T = E.evidence) == null ? void 0 : T.map((y) => e.Evidence.fromPartial(y))) || [], O;
    }
  };
})(evidence);
Object.defineProperty(block, "__esModule", { value: !0 });
block.Block = block.protobufPackage = void 0;
const types_1$g = types$e, evidence_1 = evidence, binary_1 = binary, helpers_1 = helpers;
block.protobufPackage = "tendermint.types";
function createBaseBlock$1() {
  return {
    header: types_1$g.Header.fromPartial({}),
    data: types_1$g.Data.fromPartial({}),
    evidence: evidence_1.EvidenceList.fromPartial({}),
    lastCommit: void 0
  };
}
block.Block = {
  typeUrl: "/tendermint.types.Block",
  encode(e, n = binary_1.BinaryWriter.create()) {
    return e.header !== void 0 && types_1$g.Header.encode(e.header, n.uint32(10).fork()).ldelim(), e.data !== void 0 && types_1$g.Data.encode(e.data, n.uint32(18).fork()).ldelim(), e.evidence !== void 0 && evidence_1.EvidenceList.encode(e.evidence, n.uint32(26).fork()).ldelim(), e.lastCommit !== void 0 && types_1$g.Commit.encode(e.lastCommit, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof binary_1.BinaryReader ? e : new binary_1.BinaryReader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBlock$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.header = types_1$g.Header.decode(o, o.uint32());
          break;
        case 2:
          c.data = types_1$g.Data.decode(o, o.uint32());
          break;
        case 3:
          c.evidence = evidence_1.EvidenceList.decode(o, o.uint32());
          break;
        case 4:
          c.lastCommit = types_1$g.Commit.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromJSON(e) {
    const n = createBaseBlock$1();
    return (0, helpers_1.isSet)(e.header) && (n.header = types_1$g.Header.fromJSON(e.header)), (0, helpers_1.isSet)(e.data) && (n.data = types_1$g.Data.fromJSON(e.data)), (0, helpers_1.isSet)(e.evidence) && (n.evidence = evidence_1.EvidenceList.fromJSON(e.evidence)), (0, helpers_1.isSet)(e.lastCommit) && (n.lastCommit = types_1$g.Commit.fromJSON(e.lastCommit)), n;
  },
  toJSON(e) {
    const n = {};
    return e.header !== void 0 && (n.header = e.header ? types_1$g.Header.toJSON(e.header) : void 0), e.data !== void 0 && (n.data = e.data ? types_1$g.Data.toJSON(e.data) : void 0), e.evidence !== void 0 && (n.evidence = e.evidence ? evidence_1.EvidenceList.toJSON(e.evidence) : void 0), e.lastCommit !== void 0 && (n.lastCommit = e.lastCommit ? types_1$g.Commit.toJSON(e.lastCommit) : void 0), n;
  },
  fromPartial(e) {
    const n = createBaseBlock$1();
    return e.header !== void 0 && e.header !== null && (n.header = types_1$g.Header.fromPartial(e.header)), e.data !== void 0 && e.data !== null && (n.data = types_1$g.Data.fromPartial(e.data)), e.evidence !== void 0 && e.evidence !== null && (n.evidence = evidence_1.EvidenceList.fromPartial(e.evidence)), e.lastCommit !== void 0 && e.lastCommit !== null && (n.lastCommit = types_1$g.Commit.fromPartial(e.lastCommit)), n;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ServiceClientImpl = e.TxDecodeAminoResponse = e.TxDecodeAminoRequest = e.TxEncodeAminoResponse = e.TxEncodeAminoRequest = e.TxEncodeResponse = e.TxEncodeRequest = e.TxDecodeResponse = e.TxDecodeRequest = e.GetBlockWithTxsResponse = e.GetBlockWithTxsRequest = e.GetTxResponse = e.GetTxRequest = e.SimulateResponse = e.SimulateRequest = e.BroadcastTxResponse = e.BroadcastTxRequest = e.GetTxsEventResponse = e.GetTxsEventRequest = e.broadcastModeToJSON = e.broadcastModeFromJSON = e.BroadcastMode = e.orderByToJSON = e.orderByFromJSON = e.OrderBy = e.protobufPackage = void 0;
  const n = tx$p, o = pagination, u = abci, c = types$e, d = block, m = binary, v = helpers;
  e.protobufPackage = "cosmos.tx.v1beta1";
  var S;
  (function(fe) {
    fe[fe.ORDER_BY_UNSPECIFIED = 0] = "ORDER_BY_UNSPECIFIED", fe[fe.ORDER_BY_ASC = 1] = "ORDER_BY_ASC", fe[fe.ORDER_BY_DESC = 2] = "ORDER_BY_DESC", fe[fe.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(S || (e.OrderBy = S = {}));
  function $(fe) {
    switch (fe) {
      case 0:
      case "ORDER_BY_UNSPECIFIED":
        return S.ORDER_BY_UNSPECIFIED;
      case 1:
      case "ORDER_BY_ASC":
        return S.ORDER_BY_ASC;
      case 2:
      case "ORDER_BY_DESC":
        return S.ORDER_BY_DESC;
      case -1:
      case "UNRECOGNIZED":
      default:
        return S.UNRECOGNIZED;
    }
  }
  e.orderByFromJSON = $;
  function E(fe) {
    switch (fe) {
      case S.ORDER_BY_UNSPECIFIED:
        return "ORDER_BY_UNSPECIFIED";
      case S.ORDER_BY_ASC:
        return "ORDER_BY_ASC";
      case S.ORDER_BY_DESC:
        return "ORDER_BY_DESC";
      case S.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.orderByToJSON = E;
  var O;
  (function(fe) {
    fe[fe.BROADCAST_MODE_UNSPECIFIED = 0] = "BROADCAST_MODE_UNSPECIFIED", fe[fe.BROADCAST_MODE_BLOCK = 1] = "BROADCAST_MODE_BLOCK", fe[fe.BROADCAST_MODE_SYNC = 2] = "BROADCAST_MODE_SYNC", fe[fe.BROADCAST_MODE_ASYNC = 3] = "BROADCAST_MODE_ASYNC", fe[fe.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(O || (e.BroadcastMode = O = {}));
  function T(fe) {
    switch (fe) {
      case 0:
      case "BROADCAST_MODE_UNSPECIFIED":
        return O.BROADCAST_MODE_UNSPECIFIED;
      case 1:
      case "BROADCAST_MODE_BLOCK":
        return O.BROADCAST_MODE_BLOCK;
      case 2:
      case "BROADCAST_MODE_SYNC":
        return O.BROADCAST_MODE_SYNC;
      case 3:
      case "BROADCAST_MODE_ASYNC":
        return O.BROADCAST_MODE_ASYNC;
      case -1:
      case "UNRECOGNIZED":
      default:
        return O.UNRECOGNIZED;
    }
  }
  e.broadcastModeFromJSON = T;
  function y(fe) {
    switch (fe) {
      case O.BROADCAST_MODE_UNSPECIFIED:
        return "BROADCAST_MODE_UNSPECIFIED";
      case O.BROADCAST_MODE_BLOCK:
        return "BROADCAST_MODE_BLOCK";
      case O.BROADCAST_MODE_SYNC:
        return "BROADCAST_MODE_SYNC";
      case O.BROADCAST_MODE_ASYNC:
        return "BROADCAST_MODE_ASYNC";
      case O.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.broadcastModeToJSON = y;
  function V() {
    return {
      events: [],
      pagination: void 0,
      orderBy: 0,
      page: BigInt(0),
      limit: BigInt(0)
    };
  }
  e.GetTxsEventRequest = {
    typeUrl: "/cosmos.tx.v1beta1.GetTxsEventRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      for (const W of fe.events)
        N.uint32(10).string(W);
      return fe.pagination !== void 0 && o.PageRequest.encode(fe.pagination, N.uint32(18).fork()).ldelim(), fe.orderBy !== 0 && N.uint32(24).int32(fe.orderBy), fe.page !== BigInt(0) && N.uint32(32).uint64(fe.page), fe.limit !== BigInt(0) && N.uint32(40).uint64(fe.limit), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = V();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.events.push(W.string());
            break;
          case 2:
            te.pagination = o.PageRequest.decode(W, W.uint32());
            break;
          case 3:
            te.orderBy = W.int32();
            break;
          case 4:
            te.page = W.uint64();
            break;
          case 5:
            te.limit = W.uint64();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = V();
      return Array.isArray(fe == null ? void 0 : fe.events) && (N.events = fe.events.map((W) => String(W))), (0, v.isSet)(fe.pagination) && (N.pagination = o.PageRequest.fromJSON(fe.pagination)), (0, v.isSet)(fe.orderBy) && (N.orderBy = $(fe.orderBy)), (0, v.isSet)(fe.page) && (N.page = BigInt(fe.page.toString())), (0, v.isSet)(fe.limit) && (N.limit = BigInt(fe.limit.toString())), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.events ? N.events = fe.events.map((W) => W) : N.events = [], fe.pagination !== void 0 && (N.pagination = fe.pagination ? o.PageRequest.toJSON(fe.pagination) : void 0), fe.orderBy !== void 0 && (N.orderBy = E(fe.orderBy)), fe.page !== void 0 && (N.page = (fe.page || BigInt(0)).toString()), fe.limit !== void 0 && (N.limit = (fe.limit || BigInt(0)).toString()), N;
    },
    fromPartial(fe) {
      var W;
      const N = V();
      return N.events = ((W = fe.events) == null ? void 0 : W.map((I) => I)) || [], fe.pagination !== void 0 && fe.pagination !== null && (N.pagination = o.PageRequest.fromPartial(fe.pagination)), N.orderBy = fe.orderBy ?? 0, fe.page !== void 0 && fe.page !== null && (N.page = BigInt(fe.page.toString())), fe.limit !== void 0 && fe.limit !== null && (N.limit = BigInt(fe.limit.toString())), N;
    }
  };
  function M() {
    return {
      txs: [],
      txResponses: [],
      pagination: void 0,
      total: BigInt(0)
    };
  }
  e.GetTxsEventResponse = {
    typeUrl: "/cosmos.tx.v1beta1.GetTxsEventResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      for (const W of fe.txs)
        n.Tx.encode(W, N.uint32(10).fork()).ldelim();
      for (const W of fe.txResponses)
        u.TxResponse.encode(W, N.uint32(18).fork()).ldelim();
      return fe.pagination !== void 0 && o.PageResponse.encode(fe.pagination, N.uint32(26).fork()).ldelim(), fe.total !== BigInt(0) && N.uint32(32).uint64(fe.total), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = M();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.txs.push(n.Tx.decode(W, W.uint32()));
            break;
          case 2:
            te.txResponses.push(u.TxResponse.decode(W, W.uint32()));
            break;
          case 3:
            te.pagination = o.PageResponse.decode(W, W.uint32());
            break;
          case 4:
            te.total = W.uint64();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = M();
      return Array.isArray(fe == null ? void 0 : fe.txs) && (N.txs = fe.txs.map((W) => n.Tx.fromJSON(W))), Array.isArray(fe == null ? void 0 : fe.txResponses) && (N.txResponses = fe.txResponses.map((W) => u.TxResponse.fromJSON(W))), (0, v.isSet)(fe.pagination) && (N.pagination = o.PageResponse.fromJSON(fe.pagination)), (0, v.isSet)(fe.total) && (N.total = BigInt(fe.total.toString())), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.txs ? N.txs = fe.txs.map((W) => W ? n.Tx.toJSON(W) : void 0) : N.txs = [], fe.txResponses ? N.txResponses = fe.txResponses.map((W) => W ? u.TxResponse.toJSON(W) : void 0) : N.txResponses = [], fe.pagination !== void 0 && (N.pagination = fe.pagination ? o.PageResponse.toJSON(fe.pagination) : void 0), fe.total !== void 0 && (N.total = (fe.total || BigInt(0)).toString()), N;
    },
    fromPartial(fe) {
      var W, I;
      const N = M();
      return N.txs = ((W = fe.txs) == null ? void 0 : W.map((te) => n.Tx.fromPartial(te))) || [], N.txResponses = ((I = fe.txResponses) == null ? void 0 : I.map((te) => u.TxResponse.fromPartial(te))) || [], fe.pagination !== void 0 && fe.pagination !== null && (N.pagination = o.PageResponse.fromPartial(fe.pagination)), fe.total !== void 0 && fe.total !== null && (N.total = BigInt(fe.total.toString())), N;
    }
  };
  function G() {
    return {
      txBytes: new Uint8Array(),
      mode: 0
    };
  }
  e.BroadcastTxRequest = {
    typeUrl: "/cosmos.tx.v1beta1.BroadcastTxRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.txBytes.length !== 0 && N.uint32(10).bytes(fe.txBytes), fe.mode !== 0 && N.uint32(16).int32(fe.mode), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = G();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.txBytes = W.bytes();
            break;
          case 2:
            te.mode = W.int32();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = G();
      return (0, v.isSet)(fe.txBytes) && (N.txBytes = (0, v.bytesFromBase64)(fe.txBytes)), (0, v.isSet)(fe.mode) && (N.mode = T(fe.mode)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.txBytes !== void 0 && (N.txBytes = (0, v.base64FromBytes)(fe.txBytes !== void 0 ? fe.txBytes : new Uint8Array())), fe.mode !== void 0 && (N.mode = y(fe.mode)), N;
    },
    fromPartial(fe) {
      const N = G();
      return N.txBytes = fe.txBytes ?? new Uint8Array(), N.mode = fe.mode ?? 0, N;
    }
  };
  function k() {
    return {
      txResponse: void 0
    };
  }
  e.BroadcastTxResponse = {
    typeUrl: "/cosmos.tx.v1beta1.BroadcastTxResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.txResponse !== void 0 && u.TxResponse.encode(fe.txResponse, N.uint32(10).fork()).ldelim(), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = k();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.txResponse = u.TxResponse.decode(W, W.uint32());
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = k();
      return (0, v.isSet)(fe.txResponse) && (N.txResponse = u.TxResponse.fromJSON(fe.txResponse)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.txResponse !== void 0 && (N.txResponse = fe.txResponse ? u.TxResponse.toJSON(fe.txResponse) : void 0), N;
    },
    fromPartial(fe) {
      const N = k();
      return fe.txResponse !== void 0 && fe.txResponse !== null && (N.txResponse = u.TxResponse.fromPartial(fe.txResponse)), N;
    }
  };
  function F() {
    return {
      tx: void 0,
      txBytes: new Uint8Array()
    };
  }
  e.SimulateRequest = {
    typeUrl: "/cosmos.tx.v1beta1.SimulateRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.tx !== void 0 && n.Tx.encode(fe.tx, N.uint32(10).fork()).ldelim(), fe.txBytes.length !== 0 && N.uint32(18).bytes(fe.txBytes), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = F();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.tx = n.Tx.decode(W, W.uint32());
            break;
          case 2:
            te.txBytes = W.bytes();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = F();
      return (0, v.isSet)(fe.tx) && (N.tx = n.Tx.fromJSON(fe.tx)), (0, v.isSet)(fe.txBytes) && (N.txBytes = (0, v.bytesFromBase64)(fe.txBytes)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.tx !== void 0 && (N.tx = fe.tx ? n.Tx.toJSON(fe.tx) : void 0), fe.txBytes !== void 0 && (N.txBytes = (0, v.base64FromBytes)(fe.txBytes !== void 0 ? fe.txBytes : new Uint8Array())), N;
    },
    fromPartial(fe) {
      const N = F();
      return fe.tx !== void 0 && fe.tx !== null && (N.tx = n.Tx.fromPartial(fe.tx)), N.txBytes = fe.txBytes ?? new Uint8Array(), N;
    }
  };
  function X() {
    return {
      gasInfo: void 0,
      result: void 0
    };
  }
  e.SimulateResponse = {
    typeUrl: "/cosmos.tx.v1beta1.SimulateResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.gasInfo !== void 0 && u.GasInfo.encode(fe.gasInfo, N.uint32(10).fork()).ldelim(), fe.result !== void 0 && u.Result.encode(fe.result, N.uint32(18).fork()).ldelim(), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = X();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.gasInfo = u.GasInfo.decode(W, W.uint32());
            break;
          case 2:
            te.result = u.Result.decode(W, W.uint32());
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = X();
      return (0, v.isSet)(fe.gasInfo) && (N.gasInfo = u.GasInfo.fromJSON(fe.gasInfo)), (0, v.isSet)(fe.result) && (N.result = u.Result.fromJSON(fe.result)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.gasInfo !== void 0 && (N.gasInfo = fe.gasInfo ? u.GasInfo.toJSON(fe.gasInfo) : void 0), fe.result !== void 0 && (N.result = fe.result ? u.Result.toJSON(fe.result) : void 0), N;
    },
    fromPartial(fe) {
      const N = X();
      return fe.gasInfo !== void 0 && fe.gasInfo !== null && (N.gasInfo = u.GasInfo.fromPartial(fe.gasInfo)), fe.result !== void 0 && fe.result !== null && (N.result = u.Result.fromPartial(fe.result)), N;
    }
  };
  function ee() {
    return {
      hash: ""
    };
  }
  e.GetTxRequest = {
    typeUrl: "/cosmos.tx.v1beta1.GetTxRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.hash !== "" && N.uint32(10).string(fe.hash), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = ee();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.hash = W.string();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = ee();
      return (0, v.isSet)(fe.hash) && (N.hash = String(fe.hash)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.hash !== void 0 && (N.hash = fe.hash), N;
    },
    fromPartial(fe) {
      const N = ee();
      return N.hash = fe.hash ?? "", N;
    }
  };
  function ue() {
    return {
      tx: void 0,
      txResponse: void 0
    };
  }
  e.GetTxResponse = {
    typeUrl: "/cosmos.tx.v1beta1.GetTxResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.tx !== void 0 && n.Tx.encode(fe.tx, N.uint32(10).fork()).ldelim(), fe.txResponse !== void 0 && u.TxResponse.encode(fe.txResponse, N.uint32(18).fork()).ldelim(), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = ue();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.tx = n.Tx.decode(W, W.uint32());
            break;
          case 2:
            te.txResponse = u.TxResponse.decode(W, W.uint32());
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = ue();
      return (0, v.isSet)(fe.tx) && (N.tx = n.Tx.fromJSON(fe.tx)), (0, v.isSet)(fe.txResponse) && (N.txResponse = u.TxResponse.fromJSON(fe.txResponse)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.tx !== void 0 && (N.tx = fe.tx ? n.Tx.toJSON(fe.tx) : void 0), fe.txResponse !== void 0 && (N.txResponse = fe.txResponse ? u.TxResponse.toJSON(fe.txResponse) : void 0), N;
    },
    fromPartial(fe) {
      const N = ue();
      return fe.tx !== void 0 && fe.tx !== null && (N.tx = n.Tx.fromPartial(fe.tx)), fe.txResponse !== void 0 && fe.txResponse !== null && (N.txResponse = u.TxResponse.fromPartial(fe.txResponse)), N;
    }
  };
  function Q() {
    return {
      height: BigInt(0),
      pagination: void 0
    };
  }
  e.GetBlockWithTxsRequest = {
    typeUrl: "/cosmos.tx.v1beta1.GetBlockWithTxsRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.height !== BigInt(0) && N.uint32(8).int64(fe.height), fe.pagination !== void 0 && o.PageRequest.encode(fe.pagination, N.uint32(18).fork()).ldelim(), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = Q();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.height = W.int64();
            break;
          case 2:
            te.pagination = o.PageRequest.decode(W, W.uint32());
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = Q();
      return (0, v.isSet)(fe.height) && (N.height = BigInt(fe.height.toString())), (0, v.isSet)(fe.pagination) && (N.pagination = o.PageRequest.fromJSON(fe.pagination)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.height !== void 0 && (N.height = (fe.height || BigInt(0)).toString()), fe.pagination !== void 0 && (N.pagination = fe.pagination ? o.PageRequest.toJSON(fe.pagination) : void 0), N;
    },
    fromPartial(fe) {
      const N = Q();
      return fe.height !== void 0 && fe.height !== null && (N.height = BigInt(fe.height.toString())), fe.pagination !== void 0 && fe.pagination !== null && (N.pagination = o.PageRequest.fromPartial(fe.pagination)), N;
    }
  };
  function Y() {
    return {
      txs: [],
      blockId: void 0,
      block: void 0,
      pagination: void 0
    };
  }
  e.GetBlockWithTxsResponse = {
    typeUrl: "/cosmos.tx.v1beta1.GetBlockWithTxsResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      for (const W of fe.txs)
        n.Tx.encode(W, N.uint32(10).fork()).ldelim();
      return fe.blockId !== void 0 && c.BlockID.encode(fe.blockId, N.uint32(18).fork()).ldelim(), fe.block !== void 0 && d.Block.encode(fe.block, N.uint32(26).fork()).ldelim(), fe.pagination !== void 0 && o.PageResponse.encode(fe.pagination, N.uint32(34).fork()).ldelim(), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = Y();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.txs.push(n.Tx.decode(W, W.uint32()));
            break;
          case 2:
            te.blockId = c.BlockID.decode(W, W.uint32());
            break;
          case 3:
            te.block = d.Block.decode(W, W.uint32());
            break;
          case 4:
            te.pagination = o.PageResponse.decode(W, W.uint32());
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = Y();
      return Array.isArray(fe == null ? void 0 : fe.txs) && (N.txs = fe.txs.map((W) => n.Tx.fromJSON(W))), (0, v.isSet)(fe.blockId) && (N.blockId = c.BlockID.fromJSON(fe.blockId)), (0, v.isSet)(fe.block) && (N.block = d.Block.fromJSON(fe.block)), (0, v.isSet)(fe.pagination) && (N.pagination = o.PageResponse.fromJSON(fe.pagination)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.txs ? N.txs = fe.txs.map((W) => W ? n.Tx.toJSON(W) : void 0) : N.txs = [], fe.blockId !== void 0 && (N.blockId = fe.blockId ? c.BlockID.toJSON(fe.blockId) : void 0), fe.block !== void 0 && (N.block = fe.block ? d.Block.toJSON(fe.block) : void 0), fe.pagination !== void 0 && (N.pagination = fe.pagination ? o.PageResponse.toJSON(fe.pagination) : void 0), N;
    },
    fromPartial(fe) {
      var W;
      const N = Y();
      return N.txs = ((W = fe.txs) == null ? void 0 : W.map((I) => n.Tx.fromPartial(I))) || [], fe.blockId !== void 0 && fe.blockId !== null && (N.blockId = c.BlockID.fromPartial(fe.blockId)), fe.block !== void 0 && fe.block !== null && (N.block = d.Block.fromPartial(fe.block)), fe.pagination !== void 0 && fe.pagination !== null && (N.pagination = o.PageResponse.fromPartial(fe.pagination)), N;
    }
  };
  function pe() {
    return {
      txBytes: new Uint8Array()
    };
  }
  e.TxDecodeRequest = {
    typeUrl: "/cosmos.tx.v1beta1.TxDecodeRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.txBytes.length !== 0 && N.uint32(10).bytes(fe.txBytes), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = pe();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.txBytes = W.bytes();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = pe();
      return (0, v.isSet)(fe.txBytes) && (N.txBytes = (0, v.bytesFromBase64)(fe.txBytes)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.txBytes !== void 0 && (N.txBytes = (0, v.base64FromBytes)(fe.txBytes !== void 0 ? fe.txBytes : new Uint8Array())), N;
    },
    fromPartial(fe) {
      const N = pe();
      return N.txBytes = fe.txBytes ?? new Uint8Array(), N;
    }
  };
  function oe() {
    return {
      tx: void 0
    };
  }
  e.TxDecodeResponse = {
    typeUrl: "/cosmos.tx.v1beta1.TxDecodeResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.tx !== void 0 && n.Tx.encode(fe.tx, N.uint32(10).fork()).ldelim(), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = oe();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.tx = n.Tx.decode(W, W.uint32());
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = oe();
      return (0, v.isSet)(fe.tx) && (N.tx = n.Tx.fromJSON(fe.tx)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.tx !== void 0 && (N.tx = fe.tx ? n.Tx.toJSON(fe.tx) : void 0), N;
    },
    fromPartial(fe) {
      const N = oe();
      return fe.tx !== void 0 && fe.tx !== null && (N.tx = n.Tx.fromPartial(fe.tx)), N;
    }
  };
  function ne() {
    return {
      tx: void 0
    };
  }
  e.TxEncodeRequest = {
    typeUrl: "/cosmos.tx.v1beta1.TxEncodeRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.tx !== void 0 && n.Tx.encode(fe.tx, N.uint32(10).fork()).ldelim(), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = ne();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.tx = n.Tx.decode(W, W.uint32());
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = ne();
      return (0, v.isSet)(fe.tx) && (N.tx = n.Tx.fromJSON(fe.tx)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.tx !== void 0 && (N.tx = fe.tx ? n.Tx.toJSON(fe.tx) : void 0), N;
    },
    fromPartial(fe) {
      const N = ne();
      return fe.tx !== void 0 && fe.tx !== null && (N.tx = n.Tx.fromPartial(fe.tx)), N;
    }
  };
  function H() {
    return {
      txBytes: new Uint8Array()
    };
  }
  e.TxEncodeResponse = {
    typeUrl: "/cosmos.tx.v1beta1.TxEncodeResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.txBytes.length !== 0 && N.uint32(10).bytes(fe.txBytes), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = H();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.txBytes = W.bytes();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = H();
      return (0, v.isSet)(fe.txBytes) && (N.txBytes = (0, v.bytesFromBase64)(fe.txBytes)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.txBytes !== void 0 && (N.txBytes = (0, v.base64FromBytes)(fe.txBytes !== void 0 ? fe.txBytes : new Uint8Array())), N;
    },
    fromPartial(fe) {
      const N = H();
      return N.txBytes = fe.txBytes ?? new Uint8Array(), N;
    }
  };
  function C() {
    return {
      aminoJson: ""
    };
  }
  e.TxEncodeAminoRequest = {
    typeUrl: "/cosmos.tx.v1beta1.TxEncodeAminoRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.aminoJson !== "" && N.uint32(10).string(fe.aminoJson), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = C();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.aminoJson = W.string();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = C();
      return (0, v.isSet)(fe.aminoJson) && (N.aminoJson = String(fe.aminoJson)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.aminoJson !== void 0 && (N.aminoJson = fe.aminoJson), N;
    },
    fromPartial(fe) {
      const N = C();
      return N.aminoJson = fe.aminoJson ?? "", N;
    }
  };
  function w() {
    return {
      aminoBinary: new Uint8Array()
    };
  }
  e.TxEncodeAminoResponse = {
    typeUrl: "/cosmos.tx.v1beta1.TxEncodeAminoResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.aminoBinary.length !== 0 && N.uint32(10).bytes(fe.aminoBinary), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = w();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.aminoBinary = W.bytes();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = w();
      return (0, v.isSet)(fe.aminoBinary) && (N.aminoBinary = (0, v.bytesFromBase64)(fe.aminoBinary)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.aminoBinary !== void 0 && (N.aminoBinary = (0, v.base64FromBytes)(fe.aminoBinary !== void 0 ? fe.aminoBinary : new Uint8Array())), N;
    },
    fromPartial(fe) {
      const N = w();
      return N.aminoBinary = fe.aminoBinary ?? new Uint8Array(), N;
    }
  };
  function P() {
    return {
      aminoBinary: new Uint8Array()
    };
  }
  e.TxDecodeAminoRequest = {
    typeUrl: "/cosmos.tx.v1beta1.TxDecodeAminoRequest",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.aminoBinary.length !== 0 && N.uint32(10).bytes(fe.aminoBinary), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = P();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.aminoBinary = W.bytes();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = P();
      return (0, v.isSet)(fe.aminoBinary) && (N.aminoBinary = (0, v.bytesFromBase64)(fe.aminoBinary)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.aminoBinary !== void 0 && (N.aminoBinary = (0, v.base64FromBytes)(fe.aminoBinary !== void 0 ? fe.aminoBinary : new Uint8Array())), N;
    },
    fromPartial(fe) {
      const N = P();
      return N.aminoBinary = fe.aminoBinary ?? new Uint8Array(), N;
    }
  };
  function J() {
    return {
      aminoJson: ""
    };
  }
  e.TxDecodeAminoResponse = {
    typeUrl: "/cosmos.tx.v1beta1.TxDecodeAminoResponse",
    encode(fe, N = m.BinaryWriter.create()) {
      return fe.aminoJson !== "" && N.uint32(10).string(fe.aminoJson), N;
    },
    decode(fe, N) {
      const W = fe instanceof m.BinaryReader ? fe : new m.BinaryReader(fe);
      let I = N === void 0 ? W.len : W.pos + N;
      const te = J();
      for (; W.pos < I; ) {
        const ge = W.uint32();
        switch (ge >>> 3) {
          case 1:
            te.aminoJson = W.string();
            break;
          default:
            W.skipType(ge & 7);
            break;
        }
      }
      return te;
    },
    fromJSON(fe) {
      const N = J();
      return (0, v.isSet)(fe.aminoJson) && (N.aminoJson = String(fe.aminoJson)), N;
    },
    toJSON(fe) {
      const N = {};
      return fe.aminoJson !== void 0 && (N.aminoJson = fe.aminoJson), N;
    },
    fromPartial(fe) {
      const N = J();
      return N.aminoJson = fe.aminoJson ?? "", N;
    }
  };
  class se {
    constructor(N) {
      this.rpc = N, this.Simulate = this.Simulate.bind(this), this.GetTx = this.GetTx.bind(this), this.BroadcastTx = this.BroadcastTx.bind(this), this.GetTxsEvent = this.GetTxsEvent.bind(this), this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this), this.TxDecode = this.TxDecode.bind(this), this.TxEncode = this.TxEncode.bind(this), this.TxEncodeAmino = this.TxEncodeAmino.bind(this), this.TxDecodeAmino = this.TxDecodeAmino.bind(this);
    }
    Simulate(N) {
      const W = e.SimulateRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", W).then((te) => e.SimulateResponse.decode(new m.BinaryReader(te)));
    }
    GetTx(N) {
      const W = e.GetTxRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", W).then((te) => e.GetTxResponse.decode(new m.BinaryReader(te)));
    }
    BroadcastTx(N) {
      const W = e.BroadcastTxRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", W).then((te) => e.BroadcastTxResponse.decode(new m.BinaryReader(te)));
    }
    GetTxsEvent(N) {
      const W = e.GetTxsEventRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", W).then((te) => e.GetTxsEventResponse.decode(new m.BinaryReader(te)));
    }
    GetBlockWithTxs(N) {
      const W = e.GetBlockWithTxsRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "GetBlockWithTxs", W).then((te) => e.GetBlockWithTxsResponse.decode(new m.BinaryReader(te)));
    }
    TxDecode(N) {
      const W = e.TxDecodeRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecode", W).then((te) => e.TxDecodeResponse.decode(new m.BinaryReader(te)));
    }
    TxEncode(N) {
      const W = e.TxEncodeRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncode", W).then((te) => e.TxEncodeResponse.decode(new m.BinaryReader(te)));
    }
    TxEncodeAmino(N) {
      const W = e.TxEncodeAminoRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncodeAmino", W).then((te) => e.TxEncodeAminoResponse.decode(new m.BinaryReader(te)));
    }
    TxDecodeAmino(N) {
      const W = e.TxDecodeAminoRequest.encode(N).finish();
      return this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecodeAmino", W).then((te) => e.TxDecodeAminoResponse.decode(new m.BinaryReader(te)));
    }
  }
  e.ServiceClientImpl = se;
})(service);
Object.defineProperty(queries$c, "__esModule", { value: !0 });
queries$c.setupTxExtension = void 0;
const proto_signing_1$7 = build$Q, signing_1$7 = signing$3, service_1$1 = service, tx_1$h = tx$p, queryclient_1$e = queryclient$3;
function setupTxExtension$1(e) {
  const n = (0, queryclient_1$e.createProtobufRpcClient)(e), o = new service_1$1.ServiceClientImpl(n);
  return {
    tx: {
      getTx: async (u) => {
        const c = {
          hash: u
        };
        return await o.GetTx(c);
      },
      simulate: async (u, c, d, m) => {
        const v = tx_1$h.Tx.fromPartial({
          authInfo: tx_1$h.AuthInfo.fromPartial({
            fee: tx_1$h.Fee.fromPartial({}),
            signerInfos: [
              {
                publicKey: (0, proto_signing_1$7.encodePubkey)(d),
                sequence: BigInt(m),
                modeInfo: { single: { mode: signing_1$7.SignMode.SIGN_MODE_UNSPECIFIED } }
              }
            ]
          }),
          body: tx_1$h.TxBody.fromPartial({
            messages: Array.from(u),
            memo: c
          }),
          signatures: [new Uint8Array()]
        }), S = service_1$1.SimulateRequest.fromPartial({
          txBytes: tx_1$h.Tx.encode(v).finish()
        });
        return await o.Simulate(S);
      }
    }
  };
}
queries$c.setupTxExtension = setupTxExtension$1;
var aminomessages$c = {};
Object.defineProperty(aminomessages$c, "__esModule", { value: !0 });
aminomessages$c.createVestingAminoConverters = aminomessages$c.isAminoMsgCreateVestingAccount = void 0;
function isAminoMsgCreateVestingAccount$1(e) {
  return e.type === "cosmos-sdk/MsgCreateVestingAccount";
}
aminomessages$c.isAminoMsgCreateVestingAccount = isAminoMsgCreateVestingAccount$1;
function createVestingAminoConverters$1() {
  return {
    "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
      aminoType: "cosmos-sdk/MsgCreateVestingAccount",
      toAmino: ({ fromAddress: e, toAddress: n, amount: o, endTime: u, delayed: c }) => ({
        from_address: e,
        to_address: n,
        amount: [...o],
        end_time: u.toString(),
        delayed: c
      }),
      fromAmino: ({ from_address: e, to_address: n, amount: o, end_time: u, delayed: c }) => ({
        fromAddress: e,
        toAddress: n,
        amount: [...o],
        endTime: BigInt(u),
        delayed: c
      })
    }
  };
}
aminomessages$c.createVestingAminoConverters = createVestingAminoConverters$1;
var messages$a = {}, tx$c = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgCreatePeriodicVestingAccountResponse = e.MsgCreatePeriodicVestingAccount = e.MsgCreatePermanentLockedAccountResponse = e.MsgCreatePermanentLockedAccount = e.MsgCreateVestingAccountResponse = e.MsgCreateVestingAccount = e.protobufPackage = void 0;
  const n = coin$8, o = vesting, u = binary, c = helpers;
  e.protobufPackage = "cosmos.vesting.v1beta1";
  function d() {
    return {
      fromAddress: "",
      toAddress: "",
      amount: [],
      endTime: BigInt(0),
      delayed: !1
    };
  }
  e.MsgCreateVestingAccount = {
    typeUrl: "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
    encode(T, y = u.BinaryWriter.create()) {
      T.fromAddress !== "" && y.uint32(10).string(T.fromAddress), T.toAddress !== "" && y.uint32(18).string(T.toAddress);
      for (const V of T.amount)
        n.Coin.encode(V, y.uint32(26).fork()).ldelim();
      return T.endTime !== BigInt(0) && y.uint32(32).int64(T.endTime), T.delayed === !0 && y.uint32(40).bool(T.delayed), y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = d();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.fromAddress = V.string();
            break;
          case 2:
            G.toAddress = V.string();
            break;
          case 3:
            G.amount.push(n.Coin.decode(V, V.uint32()));
            break;
          case 4:
            G.endTime = V.int64();
            break;
          case 5:
            G.delayed = V.bool();
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = d();
      return (0, c.isSet)(T.fromAddress) && (y.fromAddress = String(T.fromAddress)), (0, c.isSet)(T.toAddress) && (y.toAddress = String(T.toAddress)), Array.isArray(T == null ? void 0 : T.amount) && (y.amount = T.amount.map((V) => n.Coin.fromJSON(V))), (0, c.isSet)(T.endTime) && (y.endTime = BigInt(T.endTime.toString())), (0, c.isSet)(T.delayed) && (y.delayed = !!T.delayed), y;
    },
    toJSON(T) {
      const y = {};
      return T.fromAddress !== void 0 && (y.fromAddress = T.fromAddress), T.toAddress !== void 0 && (y.toAddress = T.toAddress), T.amount ? y.amount = T.amount.map((V) => V ? n.Coin.toJSON(V) : void 0) : y.amount = [], T.endTime !== void 0 && (y.endTime = (T.endTime || BigInt(0)).toString()), T.delayed !== void 0 && (y.delayed = T.delayed), y;
    },
    fromPartial(T) {
      var V;
      const y = d();
      return y.fromAddress = T.fromAddress ?? "", y.toAddress = T.toAddress ?? "", y.amount = ((V = T.amount) == null ? void 0 : V.map((M) => n.Coin.fromPartial(M))) || [], T.endTime !== void 0 && T.endTime !== null && (y.endTime = BigInt(T.endTime.toString())), y.delayed = T.delayed ?? !1, y;
    }
  };
  function m() {
    return {};
  }
  e.MsgCreateVestingAccountResponse = {
    typeUrl: "/cosmos.vesting.v1beta1.MsgCreateVestingAccountResponse",
    encode(T, y = u.BinaryWriter.create()) {
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = m();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      return m();
    },
    toJSON(T) {
      return {};
    },
    fromPartial(T) {
      return m();
    }
  };
  function v() {
    return {
      fromAddress: "",
      toAddress: "",
      amount: []
    };
  }
  e.MsgCreatePermanentLockedAccount = {
    typeUrl: "/cosmos.vesting.v1beta1.MsgCreatePermanentLockedAccount",
    encode(T, y = u.BinaryWriter.create()) {
      T.fromAddress !== "" && y.uint32(10).string(T.fromAddress), T.toAddress !== "" && y.uint32(18).string(T.toAddress);
      for (const V of T.amount)
        n.Coin.encode(V, y.uint32(26).fork()).ldelim();
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = v();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.fromAddress = V.string();
            break;
          case 2:
            G.toAddress = V.string();
            break;
          case 3:
            G.amount.push(n.Coin.decode(V, V.uint32()));
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = v();
      return (0, c.isSet)(T.fromAddress) && (y.fromAddress = String(T.fromAddress)), (0, c.isSet)(T.toAddress) && (y.toAddress = String(T.toAddress)), Array.isArray(T == null ? void 0 : T.amount) && (y.amount = T.amount.map((V) => n.Coin.fromJSON(V))), y;
    },
    toJSON(T) {
      const y = {};
      return T.fromAddress !== void 0 && (y.fromAddress = T.fromAddress), T.toAddress !== void 0 && (y.toAddress = T.toAddress), T.amount ? y.amount = T.amount.map((V) => V ? n.Coin.toJSON(V) : void 0) : y.amount = [], y;
    },
    fromPartial(T) {
      var V;
      const y = v();
      return y.fromAddress = T.fromAddress ?? "", y.toAddress = T.toAddress ?? "", y.amount = ((V = T.amount) == null ? void 0 : V.map((M) => n.Coin.fromPartial(M))) || [], y;
    }
  };
  function S() {
    return {};
  }
  e.MsgCreatePermanentLockedAccountResponse = {
    typeUrl: "/cosmos.vesting.v1beta1.MsgCreatePermanentLockedAccountResponse",
    encode(T, y = u.BinaryWriter.create()) {
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = S();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      return S();
    },
    toJSON(T) {
      return {};
    },
    fromPartial(T) {
      return S();
    }
  };
  function $() {
    return {
      fromAddress: "",
      toAddress: "",
      startTime: BigInt(0),
      vestingPeriods: []
    };
  }
  e.MsgCreatePeriodicVestingAccount = {
    typeUrl: "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount",
    encode(T, y = u.BinaryWriter.create()) {
      T.fromAddress !== "" && y.uint32(10).string(T.fromAddress), T.toAddress !== "" && y.uint32(18).string(T.toAddress), T.startTime !== BigInt(0) && y.uint32(24).int64(T.startTime);
      for (const V of T.vestingPeriods)
        o.Period.encode(V, y.uint32(34).fork()).ldelim();
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = $();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          case 1:
            G.fromAddress = V.string();
            break;
          case 2:
            G.toAddress = V.string();
            break;
          case 3:
            G.startTime = V.int64();
            break;
          case 4:
            G.vestingPeriods.push(o.Period.decode(V, V.uint32()));
            break;
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      const y = $();
      return (0, c.isSet)(T.fromAddress) && (y.fromAddress = String(T.fromAddress)), (0, c.isSet)(T.toAddress) && (y.toAddress = String(T.toAddress)), (0, c.isSet)(T.startTime) && (y.startTime = BigInt(T.startTime.toString())), Array.isArray(T == null ? void 0 : T.vestingPeriods) && (y.vestingPeriods = T.vestingPeriods.map((V) => o.Period.fromJSON(V))), y;
    },
    toJSON(T) {
      const y = {};
      return T.fromAddress !== void 0 && (y.fromAddress = T.fromAddress), T.toAddress !== void 0 && (y.toAddress = T.toAddress), T.startTime !== void 0 && (y.startTime = (T.startTime || BigInt(0)).toString()), T.vestingPeriods ? y.vestingPeriods = T.vestingPeriods.map((V) => V ? o.Period.toJSON(V) : void 0) : y.vestingPeriods = [], y;
    },
    fromPartial(T) {
      var V;
      const y = $();
      return y.fromAddress = T.fromAddress ?? "", y.toAddress = T.toAddress ?? "", T.startTime !== void 0 && T.startTime !== null && (y.startTime = BigInt(T.startTime.toString())), y.vestingPeriods = ((V = T.vestingPeriods) == null ? void 0 : V.map((M) => o.Period.fromPartial(M))) || [], y;
    }
  };
  function E() {
    return {};
  }
  e.MsgCreatePeriodicVestingAccountResponse = {
    typeUrl: "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccountResponse",
    encode(T, y = u.BinaryWriter.create()) {
      return y;
    },
    decode(T, y) {
      const V = T instanceof u.BinaryReader ? T : new u.BinaryReader(T);
      let M = y === void 0 ? V.len : V.pos + y;
      const G = E();
      for (; V.pos < M; ) {
        const k = V.uint32();
        switch (k >>> 3) {
          default:
            V.skipType(k & 7);
            break;
        }
      }
      return G;
    },
    fromJSON(T) {
      return E();
    },
    toJSON(T) {
      return {};
    },
    fromPartial(T) {
      return E();
    }
  };
  class O {
    constructor(y) {
      this.rpc = y, this.CreateVestingAccount = this.CreateVestingAccount.bind(this), this.CreatePermanentLockedAccount = this.CreatePermanentLockedAccount.bind(this), this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this);
    }
    CreateVestingAccount(y) {
      const V = e.MsgCreateVestingAccount.encode(y).finish();
      return this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", V).then((G) => e.MsgCreateVestingAccountResponse.decode(new u.BinaryReader(G)));
    }
    CreatePermanentLockedAccount(y) {
      const V = e.MsgCreatePermanentLockedAccount.encode(y).finish();
      return this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePermanentLockedAccount", V).then((G) => e.MsgCreatePermanentLockedAccountResponse.decode(new u.BinaryReader(G)));
    }
    CreatePeriodicVestingAccount(y) {
      const V = e.MsgCreatePeriodicVestingAccount.encode(y).finish();
      return this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePeriodicVestingAccount", V).then((G) => e.MsgCreatePeriodicVestingAccountResponse.decode(new u.BinaryReader(G)));
    }
  }
  e.MsgClientImpl = O;
})(tx$c);
Object.defineProperty(messages$a, "__esModule", { value: !0 });
messages$a.vestingTypes = void 0;
const tx_1$g = tx$c;
messages$a.vestingTypes = [
  ["/cosmos.vesting.v1beta1.MsgCreateVestingAccount", tx_1$g.MsgCreateVestingAccount]
];
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isAminoMsgCreateValidator = e.isAminoMsgBeginRedelegate = e.createStakingAminoConverters = e.setupSlashingExtension = e.isAminoMsgUnjail = e.createSlashingAminoConverters = e.setupMintExtension = e.setupIbcExtension = e.isMsgTransferEncodeObject = e.ibcTypes = e.isAminoMsgTransfer = e.createIbcAminoConverters = e.groupTypes = e.createGroupAminoConverters = e.setupGovExtension = e.isMsgVoteWeightedEncodeObject = e.isMsgVoteEncodeObject = e.isMsgSubmitProposalEncodeObject = e.isMsgDepositEncodeObject = e.govTypes = e.isAminoMsgVoteWeighted = e.isAminoMsgVote = e.isAminoMsgSubmitProposal = e.isAminoMsgDeposit = e.createGovAminoConverters = e.setupFeegrantExtension = e.feegrantTypes = e.createFeegrantAminoConverters = e.isAminoMsgSubmitEvidence = e.createEvidenceAminoConverters = e.setupDistributionExtension = e.isMsgWithdrawDelegatorRewardEncodeObject = e.distributionTypes = e.isAminoMsgWithdrawValidatorCommission = e.isAminoMsgWithdrawDelegatorReward = e.isAminoMsgSetWithdrawAddress = e.isAminoMsgFundCommunityPool = e.createDistributionAminoConverters = e.isAminoMsgVerifyInvariant = e.createCrysisAminoConverters = e.setupBankExtension = e.isMsgSendEncodeObject = e.bankTypes = e.isAminoMsgSend = e.isAminoMsgMultiSend = e.createBankAminoConverters = e.setupAuthzExtension = e.authzTypes = e.createAuthzAminoConverters = e.setupAuthExtension = void 0, e.vestingTypes = e.isAminoMsgCreateVestingAccount = e.createVestingAminoConverters = e.setupTxExtension = e.setupStakingExtension = e.stakingTypes = e.isMsgUndelegateEncodeObject = e.isMsgEditValidatorEncodeObject = e.isMsgDelegateEncodeObject = e.isMsgCreateValidatorEncodeObject = e.isMsgBeginRedelegateEncodeObject = e.isAminoMsgUndelegate = e.isAminoMsgEditValidator = e.isAminoMsgDelegate = void 0;
  var n = queries$m;
  Object.defineProperty(e, "setupAuthExtension", { enumerable: !0, get: function() {
    return n.setupAuthExtension;
  } });
  var o = aminomessages$n;
  Object.defineProperty(e, "createAuthzAminoConverters", { enumerable: !0, get: function() {
    return o.createAuthzAminoConverters;
  } });
  var u = messages$i;
  Object.defineProperty(e, "authzTypes", { enumerable: !0, get: function() {
    return u.authzTypes;
  } });
  var c = queries$l;
  Object.defineProperty(e, "setupAuthzExtension", { enumerable: !0, get: function() {
    return c.setupAuthzExtension;
  } });
  var d = aminomessages$m;
  Object.defineProperty(e, "createBankAminoConverters", { enumerable: !0, get: function() {
    return d.createBankAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgMultiSend", { enumerable: !0, get: function() {
    return d.isAminoMsgMultiSend;
  } }), Object.defineProperty(e, "isAminoMsgSend", { enumerable: !0, get: function() {
    return d.isAminoMsgSend;
  } });
  var m = messages$h;
  Object.defineProperty(e, "bankTypes", { enumerable: !0, get: function() {
    return m.bankTypes;
  } }), Object.defineProperty(e, "isMsgSendEncodeObject", { enumerable: !0, get: function() {
    return m.isMsgSendEncodeObject;
  } });
  var v = queries$k;
  Object.defineProperty(e, "setupBankExtension", { enumerable: !0, get: function() {
    return v.setupBankExtension;
  } });
  var S = aminomessages$l;
  Object.defineProperty(e, "createCrysisAminoConverters", { enumerable: !0, get: function() {
    return S.createCrysisAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgVerifyInvariant", { enumerable: !0, get: function() {
    return S.isAminoMsgVerifyInvariant;
  } });
  var $ = aminomessages$k;
  Object.defineProperty(e, "createDistributionAminoConverters", { enumerable: !0, get: function() {
    return $.createDistributionAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgFundCommunityPool", { enumerable: !0, get: function() {
    return $.isAminoMsgFundCommunityPool;
  } }), Object.defineProperty(e, "isAminoMsgSetWithdrawAddress", { enumerable: !0, get: function() {
    return $.isAminoMsgSetWithdrawAddress;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawDelegatorReward", { enumerable: !0, get: function() {
    return $.isAminoMsgWithdrawDelegatorReward;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawValidatorCommission", { enumerable: !0, get: function() {
    return $.isAminoMsgWithdrawValidatorCommission;
  } });
  var E = messages$g;
  Object.defineProperty(e, "distributionTypes", { enumerable: !0, get: function() {
    return E.distributionTypes;
  } }), Object.defineProperty(e, "isMsgWithdrawDelegatorRewardEncodeObject", { enumerable: !0, get: function() {
    return E.isMsgWithdrawDelegatorRewardEncodeObject;
  } });
  var O = queries$j;
  Object.defineProperty(e, "setupDistributionExtension", { enumerable: !0, get: function() {
    return O.setupDistributionExtension;
  } });
  var T = aminomessages$j;
  Object.defineProperty(e, "createEvidenceAminoConverters", { enumerable: !0, get: function() {
    return T.createEvidenceAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgSubmitEvidence", { enumerable: !0, get: function() {
    return T.isAminoMsgSubmitEvidence;
  } });
  var y = aminomessages$i;
  Object.defineProperty(e, "createFeegrantAminoConverters", { enumerable: !0, get: function() {
    return y.createFeegrantAminoConverters;
  } });
  var V = messages$f;
  Object.defineProperty(e, "feegrantTypes", { enumerable: !0, get: function() {
    return V.feegrantTypes;
  } });
  var M = queries$i;
  Object.defineProperty(e, "setupFeegrantExtension", { enumerable: !0, get: function() {
    return M.setupFeegrantExtension;
  } });
  var G = aminomessages$h;
  Object.defineProperty(e, "createGovAminoConverters", { enumerable: !0, get: function() {
    return G.createGovAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgDeposit", { enumerable: !0, get: function() {
    return G.isAminoMsgDeposit;
  } }), Object.defineProperty(e, "isAminoMsgSubmitProposal", { enumerable: !0, get: function() {
    return G.isAminoMsgSubmitProposal;
  } }), Object.defineProperty(e, "isAminoMsgVote", { enumerable: !0, get: function() {
    return G.isAminoMsgVote;
  } }), Object.defineProperty(e, "isAminoMsgVoteWeighted", { enumerable: !0, get: function() {
    return G.isAminoMsgVoteWeighted;
  } });
  var k = messages$e;
  Object.defineProperty(e, "govTypes", { enumerable: !0, get: function() {
    return k.govTypes;
  } }), Object.defineProperty(e, "isMsgDepositEncodeObject", { enumerable: !0, get: function() {
    return k.isMsgDepositEncodeObject;
  } }), Object.defineProperty(e, "isMsgSubmitProposalEncodeObject", { enumerable: !0, get: function() {
    return k.isMsgSubmitProposalEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteEncodeObject", { enumerable: !0, get: function() {
    return k.isMsgVoteEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteWeightedEncodeObject", { enumerable: !0, get: function() {
    return k.isMsgVoteWeightedEncodeObject;
  } });
  var F = queries$h;
  Object.defineProperty(e, "setupGovExtension", { enumerable: !0, get: function() {
    return F.setupGovExtension;
  } });
  var X = aminomessages$g;
  Object.defineProperty(e, "createGroupAminoConverters", { enumerable: !0, get: function() {
    return X.createGroupAminoConverters;
  } });
  var ee = messages$d;
  Object.defineProperty(e, "groupTypes", { enumerable: !0, get: function() {
    return ee.groupTypes;
  } });
  var ue = aminomessages$f;
  Object.defineProperty(e, "createIbcAminoConverters", { enumerable: !0, get: function() {
    return ue.createIbcAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgTransfer", { enumerable: !0, get: function() {
    return ue.isAminoMsgTransfer;
  } });
  var Q = messages$c;
  Object.defineProperty(e, "ibcTypes", { enumerable: !0, get: function() {
    return Q.ibcTypes;
  } }), Object.defineProperty(e, "isMsgTransferEncodeObject", { enumerable: !0, get: function() {
    return Q.isMsgTransferEncodeObject;
  } });
  var Y = queries$g;
  Object.defineProperty(e, "setupIbcExtension", { enumerable: !0, get: function() {
    return Y.setupIbcExtension;
  } });
  var pe = queries$f;
  Object.defineProperty(e, "setupMintExtension", { enumerable: !0, get: function() {
    return pe.setupMintExtension;
  } });
  var oe = aminomessages$e;
  Object.defineProperty(e, "createSlashingAminoConverters", { enumerable: !0, get: function() {
    return oe.createSlashingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgUnjail", { enumerable: !0, get: function() {
    return oe.isAminoMsgUnjail;
  } });
  var ne = queries$e;
  Object.defineProperty(e, "setupSlashingExtension", { enumerable: !0, get: function() {
    return ne.setupSlashingExtension;
  } });
  var H = aminomessages$d;
  Object.defineProperty(e, "createStakingAminoConverters", { enumerable: !0, get: function() {
    return H.createStakingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgBeginRedelegate", { enumerable: !0, get: function() {
    return H.isAminoMsgBeginRedelegate;
  } }), Object.defineProperty(e, "isAminoMsgCreateValidator", { enumerable: !0, get: function() {
    return H.isAminoMsgCreateValidator;
  } }), Object.defineProperty(e, "isAminoMsgDelegate", { enumerable: !0, get: function() {
    return H.isAminoMsgDelegate;
  } }), Object.defineProperty(e, "isAminoMsgEditValidator", { enumerable: !0, get: function() {
    return H.isAminoMsgEditValidator;
  } }), Object.defineProperty(e, "isAminoMsgUndelegate", { enumerable: !0, get: function() {
    return H.isAminoMsgUndelegate;
  } });
  var C = messages$b;
  Object.defineProperty(e, "isMsgBeginRedelegateEncodeObject", { enumerable: !0, get: function() {
    return C.isMsgBeginRedelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgCreateValidatorEncodeObject", { enumerable: !0, get: function() {
    return C.isMsgCreateValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgDelegateEncodeObject", { enumerable: !0, get: function() {
    return C.isMsgDelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgEditValidatorEncodeObject", { enumerable: !0, get: function() {
    return C.isMsgEditValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgUndelegateEncodeObject", { enumerable: !0, get: function() {
    return C.isMsgUndelegateEncodeObject;
  } }), Object.defineProperty(e, "stakingTypes", { enumerable: !0, get: function() {
    return C.stakingTypes;
  } });
  var w = queries$d;
  Object.defineProperty(e, "setupStakingExtension", { enumerable: !0, get: function() {
    return w.setupStakingExtension;
  } });
  var P = queries$c;
  Object.defineProperty(e, "setupTxExtension", { enumerable: !0, get: function() {
    return P.setupTxExtension;
  } });
  var J = aminomessages$c;
  Object.defineProperty(e, "createVestingAminoConverters", { enumerable: !0, get: function() {
    return J.createVestingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgCreateVestingAccount", { enumerable: !0, get: function() {
    return J.isAminoMsgCreateVestingAccount;
  } });
  var se = messages$a;
  Object.defineProperty(e, "vestingTypes", { enumerable: !0, get: function() {
    return se.vestingTypes;
  } });
})(modules$2);
var multisignature$1 = {};
Object.defineProperty(multisignature$1, "__esModule", { value: !0 });
multisignature$1.makeMultisignedTxBytes = multisignature$1.makeMultisignedTx = multisignature$1.makeCompactBitArray = void 0;
const amino_1$a = build$P, encoding_1$18 = build$F, proto_signing_1$6 = build$Q, multisig_1$1 = multisig$3, signing_1$6 = signing$3, tx_1$f = tx$p, tx_2$4 = tx$p;
function makeCompactBitArray$1(e) {
  const n = Math.ceil(e.length / 8), o = e.length - Math.floor(e.length / 8) * 8, u = new Uint8Array(n);
  return e.forEach((c, d) => {
    const m = Math.floor(d / 8), v = d % 8;
    c && (u[m] |= 1 << 8 - 1 - v);
  }), multisig_1$1.CompactBitArray.fromPartial({ elems: u, extraBitsStored: o });
}
multisignature$1.makeCompactBitArray = makeCompactBitArray$1;
function makeMultisignedTx$1(e, n, o, u, c) {
  const d = Array.from(c.keys()), m = (0, encoding_1$18.fromBech32)(d[0]).prefix, v = Array(e.value.pubkeys.length).fill(!1), S = new Array();
  for (let y = 0; y < e.value.pubkeys.length; y++) {
    const V = (0, amino_1$a.pubkeyToAddress)(e.value.pubkeys[y], m), M = c.get(V);
    M && (v[y] = !0, S.push(M));
  }
  const $ = {
    publicKey: (0, proto_signing_1$6.encodePubkey)(e),
    modeInfo: {
      multi: {
        bitarray: makeCompactBitArray$1(v),
        modeInfos: S.map((y) => ({ single: { mode: signing_1$6.SignMode.SIGN_MODE_LEGACY_AMINO_JSON } }))
      }
    },
    sequence: BigInt(n)
  }, E = tx_1$f.AuthInfo.fromPartial({
    signerInfos: [$],
    fee: {
      amount: [...o.amount],
      gasLimit: BigInt(o.gas)
    }
  }), O = tx_1$f.AuthInfo.encode(E).finish();
  return tx_2$4.TxRaw.fromPartial({
    bodyBytes: u,
    authInfoBytes: O,
    signatures: [multisig_1$1.MultiSignature.encode(multisig_1$1.MultiSignature.fromPartial({ signatures: S })).finish()]
  });
}
multisignature$1.makeMultisignedTx = makeMultisignedTx$1;
function makeMultisignedTxBytes$1(e, n, o, u, c) {
  const d = makeMultisignedTx$1(e, n, o, u, c);
  return Uint8Array.from(tx_2$4.TxRaw.encode(d).finish());
}
multisignature$1.makeMultisignedTxBytes = makeMultisignedTxBytes$1;
var search$1 = {};
Object.defineProperty(search$1, "__esModule", { value: !0 });
search$1.isSearchTxQueryArray = void 0;
function isSearchTxQueryArray(e) {
  return Array.isArray(e);
}
search$1.isSearchTxQueryArray = isSearchTxQueryArray;
var signingstargateclient$1 = {}, build$C = {}, addresses$4 = {}, build$B = {}, bip39$4 = {}, pbkdf2$4 = {}, __createBinding$L = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$L = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$L = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$L(n, e, o);
  return __setModuleDefault$L(n, e), n;
};
Object.defineProperty(pbkdf2$4, "__esModule", { value: !0 });
pbkdf2$4.pbkdf2Sha512 = pbkdf2$4.pbkdf2Sha512Noble = pbkdf2$4.pbkdf2Sha512NodeCrypto = pbkdf2$4.pbkdf2Sha512Subtle = pbkdf2$4.getSubtle = pbkdf2$4.getNodeCrypto = void 0;
const utils_1$Q = build$G, pbkdf2_1$9 = pbkdf2$8, sha512_1$9 = sha512$a;
async function getNodeCrypto$3() {
  try {
    const e = await Promise.resolve().then(() => __importStar$L(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2$4.getNodeCrypto = getNodeCrypto$3;
async function getSubtle$4() {
  var n, o, u;
  let e = (n = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : n.subtle;
  return e || (e = (u = (o = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : o.webcrypto) == null ? void 0 : u.subtle), e;
}
pbkdf2$4.getSubtle = getSubtle$4;
async function pbkdf2Sha512Subtle$4(e, n, o, u, c) {
  return (0, utils_1$Q.assert)(e, "Argument subtle is falsy"), (0, utils_1$Q.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$Q.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$Q.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", n, { name: "PBKDF2" }, !1, ["deriveBits"]).then((d) => e.deriveBits({
    name: "PBKDF2",
    salt: o,
    iterations: u,
    hash: { name: "SHA-512" }
  }, d, c * 8).then((m) => new Uint8Array(m)));
}
pbkdf2$4.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle$4;
async function pbkdf2Sha512NodeCrypto$3(e, n, o, u, c) {
  return (0, utils_1$Q.assert)(e, "Argument nodeCrypto is falsy"), (0, utils_1$Q.assert)(typeof e == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$Q.assert)(typeof e.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((d, m) => {
    e.pbkdf2(n, o, u, c, "sha512", (v, S) => {
      v ? m(v) : d(Uint8Array.from(S));
    });
  });
}
pbkdf2$4.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto$3;
async function pbkdf2Sha512Noble$4(e, n, o, u) {
  return (0, pbkdf2_1$9.pbkdf2Async)(sha512_1$9.sha512, e, n, { c: o, dkLen: u });
}
pbkdf2$4.pbkdf2Sha512Noble = pbkdf2Sha512Noble$4;
async function pbkdf2Sha512$4(e, n, o, u) {
  const c = await getSubtle$4();
  if (c)
    return pbkdf2Sha512Subtle$4(c, e, n, o, u);
  {
    const d = await getNodeCrypto$3();
    return d ? pbkdf2Sha512NodeCrypto$3(d, e, n, o, u) : pbkdf2Sha512Noble$4(e, n, o, u);
  }
}
pbkdf2$4.pbkdf2Sha512 = pbkdf2Sha512$4;
var sha$4 = {}, utils$x = {};
Object.defineProperty(utils$x, "__esModule", { value: !0 });
utils$x.toRealUint8Array = void 0;
function toRealUint8Array$4(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$x.toRealUint8Array = toRealUint8Array$4;
Object.defineProperty(sha$4, "__esModule", { value: !0 });
sha$4.sha512 = sha$4.Sha512 = sha$4.sha256 = sha$4.Sha256 = void 0;
const sha256_1$4 = sha256$8, sha512_1$8 = sha512$a, utils_1$P = utils$x;
let Sha256$4 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha256_1$4.sha256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$P.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$4.Sha256 = Sha256$4;
function sha256$4(e) {
  return new Sha256$4(e).digest();
}
sha$4.sha256 = sha256$4;
let Sha512$4 = class {
  constructor(n) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$8.sha512.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$P.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$4.Sha512 = Sha512$4;
function sha512$4(e) {
  return new Sha512$4(e).digest();
}
sha$4.sha512 = sha512$4;
Object.defineProperty(bip39$4, "__esModule", { value: !0 });
bip39$4.Bip39 = bip39$4.EnglishMnemonic = bip39$4.mnemonicToEntropy = bip39$4.entropyToMnemonic = void 0;
const encoding_1$17 = build$F, pbkdf2_1$8 = pbkdf2$4, sha_1$4 = sha$4, wordlist$4 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring$4(e) {
  return Array.from(e).map((n) => n.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits$4(e) {
  const o = e.length * 8 / 32, u = (0, sha_1$4.sha256)(e);
  return bytesToBitstring$4(u).slice(0, o);
}
function bitstringToByte$4(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths$4 = [16, 20, 24, 28, 32], allowedWordLengths$4 = [12, 15, 18, 21, 24];
function entropyToMnemonic$4(e) {
  if (allowedEntropyLengths$4.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const n = bytesToBitstring$4(e), o = deriveChecksumBits$4(e);
  return (n + o).match(/(.{11})/g).map((m) => {
    const v = bitstringToByte$4(m);
    return wordlist$4[v];
  }).join(" ");
}
bip39$4.entropyToMnemonic = entropyToMnemonic$4;
const invalidNumberOfWorks$4 = "Invalid number of words", wordNotInWordlist$4 = "Found word that is not in the wordlist", invalidEntropy$4 = "Invalid entropy", invalidChecksum$4 = "Invalid mnemonic checksum";
function normalize$4(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy$4(e) {
  const n = normalize$4(e).split(" ");
  if (!allowedWordLengths$4.includes(n.length))
    throw new Error(invalidNumberOfWorks$4);
  const o = n.map(($) => {
    const E = wordlist$4.indexOf($);
    if (E === -1)
      throw new Error(wordNotInWordlist$4);
    return E.toString(2).padStart(11, "0");
  }).join(""), u = Math.floor(o.length / 33) * 32, c = o.slice(0, u), d = o.slice(u), m = c.match(/(.{1,8})/g).map(bitstringToByte$4);
  if (m.length < 16 || m.length > 32 || m.length % 4 !== 0)
    throw new Error(invalidEntropy$4);
  const v = Uint8Array.from(m);
  if (deriveChecksumBits$4(v) !== d)
    throw new Error(invalidChecksum$4);
  return v;
}
bip39$4.mnemonicToEntropy = mnemonicToEntropy$4;
let EnglishMnemonic$4 = class Fu {
  constructor(n) {
    if (!Fu.mnemonicMatcher.test(n))
      throw new Error("Invalid mnemonic format");
    const o = n.split(" "), u = [12, 15, 18, 21, 24];
    if (u.indexOf(o.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${u} got: ${o.length})`);
    for (const c of o)
      if (Fu.wordlist.indexOf(c) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy$4(n), this.data = n;
  }
  toString() {
    return this.data;
  }
};
bip39$4.EnglishMnemonic = EnglishMnemonic$4;
EnglishMnemonic$4.wordlist = wordlist$4;
EnglishMnemonic$4.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
let Bip39$4 = class {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(n) {
    return new EnglishMnemonic$4(entropyToMnemonic$4(n));
  }
  static decode(n) {
    return mnemonicToEntropy$4(n.toString());
  }
  static async mnemonicToSeed(n, o) {
    const u = (0, encoding_1$17.toUtf8)(normalize$4(n.toString())), c = "mnemonic" + (o ? normalize$4(o) : ""), d = (0, encoding_1$17.toUtf8)(c);
    return (0, pbkdf2_1$8.pbkdf2Sha512)(u, d, 2048, 64);
  }
};
bip39$4.Bip39 = Bip39$4;
var hmac$4 = {};
Object.defineProperty(hmac$4, "__esModule", { value: !0 });
hmac$4.Hmac = void 0;
let Hmac$4 = class {
  constructor(n, o) {
    const u = new n().blockSize;
    this.hash = (d) => new n().update(d).digest();
    let c = o;
    if (c.length > u && (c = this.hash(c)), c.length < u) {
      const d = new Uint8Array(u - c.length);
      c = new Uint8Array([...c, ...d]);
    }
    this.oKeyPad = c.map((d) => d ^ 92), this.iKeyPad = c.map((d) => d ^ 54), this.messageHasher = new n(), this.blockSize = u, this.update(this.iKeyPad);
  }
  update(n) {
    return this.messageHasher.update(n), this;
  }
  digest() {
    const n = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...n]));
  }
};
hmac$4.Hmac = Hmac$4;
var keccak$4 = {};
Object.defineProperty(keccak$4, "__esModule", { value: !0 });
keccak$4.keccak256 = keccak$4.Keccak256 = void 0;
const sha3_1$4 = sha3$3, utils_1$O = utils$x;
let Keccak256$4 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha3_1$4.keccak_256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$O.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
keccak$4.Keccak256 = Keccak256$4;
function keccak256$5(e) {
  return new Keccak256$4(e).digest();
}
keccak$4.keccak256 = keccak256$5;
var libsodium$4 = {}, __importDefault$C = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium$4, "__esModule", { value: !0 });
libsodium$4.Xchacha20poly1305Ietf = libsodium$4.xchacha20NonceLength = libsodium$4.Ed25519 = libsodium$4.Ed25519Keypair = libsodium$4.Argon2id = libsodium$4.isArgon2idOptions = void 0;
const utils_1$N = build$G, libsodium_wrappers_sumo_1$3 = __importDefault$C(libsodiumWrappers);
function isArgon2idOptions$4(e) {
  return !(!(0, utils_1$N.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium$4.isArgon2idOptions = isArgon2idOptions$4;
let Argon2id$4 = class {
  static async execute(n, o, u) {
    return await libsodium_wrappers_sumo_1$3.default.ready, libsodium_wrappers_sumo_1$3.default.crypto_pwhash(
      u.outputLength,
      n,
      o,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      u.opsLimit,
      u.memLimitKib * 1024,
      libsodium_wrappers_sumo_1$3.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
};
libsodium$4.Argon2id = Argon2id$4;
let Ed25519Keypair$4 = class Gc {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(n) {
    if (n.length !== 64)
      throw new Error(`Unexpected key length ${n.length}. Must be 64.`);
    return new Gc(n.slice(0, 32), n.slice(32, 64));
  }
  constructor(n, o) {
    this.privkey = n, this.pubkey = o;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
};
libsodium$4.Ed25519Keypair = Ed25519Keypair$4;
let Ed25519$4 = class {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(n) {
    await libsodium_wrappers_sumo_1$3.default.ready;
    const o = libsodium_wrappers_sumo_1$3.default.crypto_sign_seed_keypair(n);
    return Ed25519Keypair$4.fromLibsodiumPrivkey(o.privateKey);
  }
  static async createSignature(n, o) {
    return await libsodium_wrappers_sumo_1$3.default.ready, libsodium_wrappers_sumo_1$3.default.crypto_sign_detached(n, o.toLibsodiumPrivkey());
  }
  static async verifySignature(n, o, u) {
    return await libsodium_wrappers_sumo_1$3.default.ready, libsodium_wrappers_sumo_1$3.default.crypto_sign_verify_detached(n, o, u);
  }
};
libsodium$4.Ed25519 = Ed25519$4;
libsodium$4.xchacha20NonceLength = 24;
let Xchacha20poly1305Ietf$4 = class {
  static async encrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$3.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$3.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      n,
      c,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      u,
      o
    );
  }
  static async decrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$3.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$3.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      n,
      c,
      u,
      o
    );
  }
};
libsodium$4.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf$4;
var random$4 = {};
Object.defineProperty(random$4, "__esModule", { value: !0 });
random$4.Random = void 0;
let Random$4 = class {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(n) {
    try {
      const o = typeof window == "object" ? window : self, u = typeof o.crypto < "u" ? o.crypto : o.msCrypto, c = new Uint8Array(n);
      return u.getRandomValues(c), c;
    } catch {
      try {
        const o = requireCryptoBrowserify();
        return new Uint8Array([...o.randomBytes(n)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
};
random$4.Random = Random$4;
var ripemd$4 = {};
Object.defineProperty(ripemd$4, "__esModule", { value: !0 });
ripemd$4.ripemd160 = ripemd$4.Ripemd160 = void 0;
const ripemd160_1$4 = ripemd160$8, utils_1$M = utils$x;
let Ripemd160$4 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$4.ripemd160.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$M.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
ripemd$4.Ripemd160 = Ripemd160$4;
function ripemd160$4(e) {
  return new Ripemd160$4(e).digest();
}
ripemd$4.ripemd160 = ripemd160$4;
var secp256k1$9 = {}, secp256k1signature$4 = {};
Object.defineProperty(secp256k1signature$4, "__esModule", { value: !0 });
secp256k1signature$4.ExtendedSecp256k1Signature = secp256k1signature$4.Secp256k1Signature = void 0;
function trimLeadingNullBytes$4(e) {
  let n = 0;
  for (const o of e)
    if (o === 0)
      n++;
    else
      break;
  return e.slice(n);
}
const derTagInteger$4 = 2;
let Secp256k1Signature$4 = class Lu {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(n) {
    if (n.length !== 64)
      throw new Error(`Got invalid data length: ${n.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new Lu(trimLeadingNullBytes$4(n.slice(0, 32)), trimLeadingNullBytes$4(n.slice(32, 64)));
  }
  static fromDer(n) {
    let o = 0;
    if (n[o++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const u = n[o++];
    if (n.length - o !== u)
      throw new Error("Data length mismatch detected");
    if (n[o++] !== derTagInteger$4)
      throw new Error("INTEGER tag expected");
    const d = n[o++];
    if (d >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const m = n.slice(o, o + d);
    if (o += d, n[o++] !== derTagInteger$4)
      throw new Error("INTEGER tag expected");
    const S = n[o++];
    if (S >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const $ = n.slice(o, o + S);
    return o += S, new Lu(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes$4(m),
      trimLeadingNullBytes$4($)
    );
  }
  constructor(n, o) {
    if (n.length > 32 || n.length === 0 || n[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (o.length > 32 || o.length === 0 || o[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: n,
      s: o
    };
  }
  r(n) {
    if (n === void 0)
      return this.data.r;
    {
      const o = n - this.data.r.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter r");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.r]);
    }
  }
  s(n) {
    if (n === void 0)
      return this.data.s;
    {
      const o = n - this.data.s.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter s");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const n = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, o = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, u = n.length, c = o.length, d = new Uint8Array([derTagInteger$4, u, ...n, derTagInteger$4, c, ...o]);
    return new Uint8Array([48, d.length, ...d]);
  }
};
secp256k1signature$4.Secp256k1Signature = Secp256k1Signature$4;
let ExtendedSecp256k1Signature$4 = class Vc extends Secp256k1Signature$4 {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(n) {
    if (n.length !== 65)
      throw new Error(`Got invalid data length ${n.length}. Expected 32 + 32 + 1`);
    return new Vc(trimLeadingNullBytes$4(n.slice(0, 32)), trimLeadingNullBytes$4(n.slice(32, 64)), n[64]);
  }
  constructor(n, o, u) {
    if (super(n, o), !Number.isInteger(u))
      throw new Error("The recovery parameter must be an integer.");
    if (u < 0 || u > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = u;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
};
secp256k1signature$4.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature$4;
var __importDefault$B = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$9, "__esModule", { value: !0 });
secp256k1$9.Secp256k1 = void 0;
const encoding_1$16 = build$F, bn_js_1$c = __importDefault$B(bnExports$1), elliptic_1$5 = __importDefault$B(requireElliptic()), secp256k1signature_1$4 = secp256k1signature$4, secp256k1$8 = new elliptic_1$5.default.ec("secp256k1"), secp256k1N$4 = new bn_js_1$c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
let Secp256k1$4 = class {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(n) {
    if (n.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const o = secp256k1$8.keyFromPrivate(n);
    if (o.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$c.default(n).gte(secp256k1N$4))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$16.fromHex)(o.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(o.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(n, o) {
    if (n.length === 0)
      throw new Error("Message hash must not be empty");
    if (n.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const u = secp256k1$8.keyFromPrivate(o), { r: c, s: d, recoveryParam: m } = u.sign(n, { canonical: !0 });
    if (typeof m != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1$4.ExtendedSecp256k1Signature(Uint8Array.from(c.toArray()), Uint8Array.from(d.toArray()), m);
  }
  static async verifySignature(n, o, u) {
    if (o.length === 0)
      throw new Error("Message hash must not be empty");
    if (o.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const c = secp256k1$8.keyFromPublic(u);
    try {
      return c.verify(o, n.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(n, o) {
    const u = { r: (0, encoding_1$16.toHex)(n.r()), s: (0, encoding_1$16.toHex)(n.s()) }, c = secp256k1$8.recoverPubKey(o, u, n.recovery), d = secp256k1$8.keyFromPublic(c);
    return (0, encoding_1$16.fromHex)(d.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(n) {
    switch (n.length) {
      case 33:
        return n;
      case 65:
        return Uint8Array.from(secp256k1$8.keyFromPublic(n).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(n) {
    switch (n.length) {
      case 33:
        return Uint8Array.from(secp256k1$8.keyFromPublic(n).getPublic(!1, "array"));
      case 65:
        return n;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(n) {
    switch (n.length) {
      case 64:
        return n;
      case 65:
        return n.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
};
secp256k1$9.Secp256k1 = Secp256k1$4;
var slip10$4 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const o = build$F, u = build$R, c = n(bnExports$1), d = n(requireElliptic()), m = hmac$4, v = sha$4;
  var S;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(S = e.Slip10Curve || (e.Slip10Curve = {}));
  function $(M) {
    switch (M) {
      case S.Ed25519:
        return S.Ed25519;
      case S.Secp256k1:
        return S.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  e.slip10CurveFromString = $;
  class E extends u.Uint32 {
    static hardened(G) {
      return new E(G + 2 ** 31);
    }
    static normal(G) {
      return new E(G);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = E;
  const O = new d.default.ec("secp256k1");
  class T {
    static derivePath(G, k, F) {
      let X = this.master(G, k);
      for (const ee of F)
        X = this.child(G, X.privkey, X.chainCode, ee);
      return X;
    }
    static master(G, k) {
      const F = new m.Hmac(v.Sha512, (0, o.toAscii)(G)).update(k).digest(), X = F.slice(0, 32), ee = F.slice(32, 64);
      return G !== S.Ed25519 && (this.isZero(X) || this.isGteN(G, X)) ? this.master(G, F) : {
        chainCode: ee,
        privkey: X
      };
    }
    static child(G, k, F, X) {
      let ee;
      if (X.isHardened()) {
        const ue = new Uint8Array([0, ...k, ...X.toBytesBigEndian()]);
        ee = new m.Hmac(v.Sha512, F).update(ue).digest();
      } else {
        if (G === S.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ue = new Uint8Array([
            ...T.serializedPoint(G, new c.default(k)),
            ...X.toBytesBigEndian()
          ]);
          ee = new m.Hmac(v.Sha512, F).update(ue).digest();
        }
      }
      return this.childImpl(G, k, F, X, ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(G, k) {
      switch (G) {
        case S.Secp256k1:
          return (0, o.fromHex)(O.g.mul(k).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(G, k, F, X, ee) {
      const ue = ee.slice(0, 32), Q = ee.slice(32, 64), Y = Q;
      if (G === S.Ed25519)
        return {
          chainCode: Y,
          privkey: ue
        };
      const pe = this.n(G), oe = new c.default(ue).add(new c.default(k)).mod(pe), ne = Uint8Array.from(oe.toArray("be", 32));
      if (this.isGteN(G, ue) || this.isZero(ne)) {
        const H = new m.Hmac(v.Sha512, F).update(new Uint8Array([1, ...Q, ...X.toBytesBigEndian()])).digest();
        return this.childImpl(G, k, F, X, H);
      }
      return {
        chainCode: Y,
        privkey: ne
      };
    }
    static isZero(G) {
      return G.every((k) => k === 0);
    }
    static isGteN(G, k) {
      return new c.default(k).gte(this.n(G));
    }
    static n(G) {
      switch (G) {
        case S.Secp256k1:
          return new c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = T;
  function y(M) {
    return M.reduce((G, k) => {
      const F = k.isHardened() ? `${k.toNumber() - 2147483648}'` : k.toString();
      return G + "/" + F;
    }, "m");
  }
  e.pathToString = y;
  function V(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let G = M.slice(1);
    const k = new Array();
    for (; G; ) {
      const F = G.match(/^\/([0-9]+)('?)/);
      if (!F)
        throw new Error("Syntax error while reading path component");
      const [X, ee, ue] = F, Q = u.Uint53.fromString(ee).toNumber();
      if (Q >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ue ? k.push(E.hardened(Q)) : k.push(E.normal(Q)), G = G.slice(X.length);
    }
    return k;
  }
  e.stringToPath = V;
})(slip10$4);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var n = bip39$4;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return n.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return n.EnglishMnemonic;
  } });
  var o = hmac$4;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return o.Hmac;
  } });
  var u = keccak$4;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return u.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return u.keccak256;
  } });
  var c = libsodium$4;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return c.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return c.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return c.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return c.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return c.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return c.Xchacha20poly1305Ietf;
  } });
  var d = random$4;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return d.Random;
  } });
  var m = ripemd$4;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return m.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return m.ripemd160;
  } });
  var v = secp256k1$9;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return v.Secp256k1;
  } });
  var S = secp256k1signature$4;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return S.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return S.Secp256k1Signature;
  } });
  var $ = sha$4;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return $.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return $.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return $.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return $.sha512;
  } });
  var E = slip10$4;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return E.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return E.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return E.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return E.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return E.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return E.stringToPath;
  } });
})(build$B);
Object.defineProperty(addresses$4, "__esModule", { value: !0 });
addresses$4.pubkeyToAddress = addresses$4.pubkeyToRawAddress = addresses$4.rawSecp256k1PubkeyToRawAddress = addresses$4.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$n = build$B, encoding_1$15 = build$F;
function rawEd25519PubkeyToRawAddress$4(e) {
  if (e.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${e.length}`);
  return (0, crypto_1$n.sha256)(e).slice(0, 20);
}
addresses$4.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress$4;
function rawSecp256k1PubkeyToRawAddress$4(e) {
  if (e.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${e.length}`);
  return (0, crypto_1$n.ripemd160)((0, crypto_1$n.sha256)(e));
}
addresses$4.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress$4;
function pubkeyToRawAddress$4(e, n) {
  switch (e) {
    case "ed25519":
      return rawEd25519PubkeyToRawAddress$4(n);
    case "secp256k1":
      return rawSecp256k1PubkeyToRawAddress$4(n);
    default:
      throw new Error(`Pubkey type ${e} not supported`);
  }
}
addresses$4.pubkeyToRawAddress = pubkeyToRawAddress$4;
function pubkeyToAddress$4(e, n) {
  return (0, encoding_1$15.toHex)(pubkeyToRawAddress$4(e, n)).toUpperCase();
}
addresses$4.pubkeyToAddress = pubkeyToAddress$4;
var dates$3 = {};
Object.defineProperty(dates$3, "__esModule", { value: !0 });
dates$3.DateTime = dates$3.toSeconds = dates$3.fromSeconds = dates$3.toRfc3339WithNanoseconds = dates$3.fromRfc3339WithNanoseconds = void 0;
const encoding_1$14 = build$F, math_1$n = build$R;
function fromRfc3339WithNanoseconds$3(e) {
  const n = (0, encoding_1$14.fromRfc3339)(e), o = e.match(/\.(\d+)Z$/), u = o ? o[1].slice(3) : "";
  return n.nanoseconds = parseInt(u.padEnd(6, "0"), 10), n;
}
dates$3.fromRfc3339WithNanoseconds = fromRfc3339WithNanoseconds$3;
function toRfc3339WithNanoseconds$3(e) {
  var u;
  const n = e.toISOString(), o = ((u = e.nanoseconds) == null ? void 0 : u.toString()) ?? "";
  return `${n.slice(0, -1)}${o.padStart(6, "0")}Z`;
}
dates$3.toRfc3339WithNanoseconds = toRfc3339WithNanoseconds$3;
function fromSeconds$3(e, n = 0) {
  const o = new math_1$n.Uint32(n).toNumber();
  if (o > 999999999)
    throw new Error("Nano seconds must not exceed 999999999");
  const u = new Date(e * 1e3 + Math.floor(o / 1e6));
  return u.nanoseconds = o % 1e6, u;
}
dates$3.fromSeconds = fromSeconds$3;
function toSeconds$3(e) {
  return {
    seconds: Math.floor(e.getTime() / 1e3),
    nanos: e.getTime() % 1e3 * 1e6 + (e.nanoseconds ?? 0)
  };
}
dates$3.toSeconds = toSeconds$3;
let DateTime$3 = class {
  /** @deprecated Use fromRfc3339WithNanoseconds instead */
  static decode(n) {
    return fromRfc3339WithNanoseconds$3(n);
  }
  /** @deprecated Use toRfc3339WithNanoseconds instead */
  static encode(n) {
    return toRfc3339WithNanoseconds$3(n);
  }
};
dates$3.DateTime = DateTime$3;
var comet38$2 = {}, comet38client$2 = {}, jsonrpc$3 = {};
Object.defineProperty(jsonrpc$3, "__esModule", { value: !0 });
jsonrpc$3.createJsonRpcRequest = void 0;
const numbersWithoutZero$3 = "123456789";
function randomNumericChar$3() {
  return numbersWithoutZero$3[Math.floor(Math.random() * numbersWithoutZero$3.length)];
}
function randomId$3() {
  return parseInt(Array.from({ length: 12 }).map(() => randomNumericChar$3()).join(""), 10);
}
function createJsonRpcRequest$3(e, n) {
  const o = n ? { ...n } : {};
  return {
    jsonrpc: "2.0",
    id: randomId$3(),
    method: e,
    params: o
  };
}
jsonrpc$3.createJsonRpcRequest = createJsonRpcRequest$3;
var rpcclients$3 = {}, httpbatchclient$3 = {}, build$A = {}, id$4 = {};
Object.defineProperty(id$4, "__esModule", { value: !0 });
id$4.makeJsonRpcId = void 0;
let counter$4 = 1e4;
function makeJsonRpcId$3() {
  return counter$4 += 1;
}
id$4.makeJsonRpcId = makeJsonRpcId$3;
var jsonrpcclient$3 = {}, types$b = {};
Object.defineProperty(types$b, "__esModule", { value: !0 });
types$b.jsonRpcCode = types$b.isJsonRpcSuccessResponse = types$b.isJsonRpcErrorResponse = void 0;
function isJsonRpcErrorResponse$3(e) {
  return typeof e.error == "object";
}
types$b.isJsonRpcErrorResponse = isJsonRpcErrorResponse$3;
function isJsonRpcSuccessResponse$3(e) {
  return !isJsonRpcErrorResponse$3(e);
}
types$b.isJsonRpcSuccessResponse = isJsonRpcSuccessResponse$3;
types$b.jsonRpcCode = {
  parseError: -32700,
  invalidRequest: -32600,
  methodNotFound: -32601,
  invalidParams: -32602,
  internalError: -32603,
  // server error (Reserved for implementation-defined server-errors.):
  // -32000 to -32099
  serverError: {
    default: -32e3
  }
};
Object.defineProperty(jsonrpcclient$3, "__esModule", { value: !0 });
jsonrpcclient$3.JsonRpcClient = void 0;
const stream_1$8 = build$D, types_1$f = types$b;
let JsonRpcClient$3 = class {
  constructor(n) {
    this.connection = n;
  }
  async run(n) {
    const o = this.connection.responseStream.filter((d) => d.id === n.id), u = (0, stream_1$8.firstEvent)(o);
    this.connection.sendRequest(n);
    const c = await u;
    if ((0, types_1$f.isJsonRpcErrorResponse)(c)) {
      const d = c.error;
      throw new Error(`JSON RPC error: code=${d.code}; message='${d.message}'`);
    }
    return c;
  }
};
jsonrpcclient$3.JsonRpcClient = JsonRpcClient$3;
var parse$h = {}, compatibility$3 = {};
Object.defineProperty(compatibility$3, "__esModule", { value: !0 });
compatibility$3.isJsonCompatibleDictionary = compatibility$3.isJsonCompatibleArray = compatibility$3.isJsonCompatibleValue = void 0;
function isJsonCompatibleValue$3(e) {
  return !!(typeof e == "string" || typeof e == "number" || typeof e == "boolean" || e === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleArray$3(e) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleDictionary$3(e));
}
compatibility$3.isJsonCompatibleValue = isJsonCompatibleValue$3;
function isJsonCompatibleArray$3(e) {
  if (!Array.isArray(e))
    return !1;
  for (const n of e)
    if (!isJsonCompatibleValue$3(n))
      return !1;
  return !0;
}
compatibility$3.isJsonCompatibleArray = isJsonCompatibleArray$3;
function isJsonCompatibleDictionary$3(e) {
  return typeof e != "object" || e === null || Object.prototype.toString.call(e) !== "[object Object]" ? !1 : Object.values(e).every(isJsonCompatibleValue$3);
}
compatibility$3.isJsonCompatibleDictionary = isJsonCompatibleDictionary$3;
Object.defineProperty(parse$h, "__esModule", { value: !0 });
parse$h.parseJsonRpcResponse = parse$h.parseJsonRpcSuccessResponse = parse$h.parseJsonRpcErrorResponse = parse$h.parseJsonRpcRequest = parse$h.parseJsonRpcId = void 0;
const compatibility_1$3 = compatibility$3;
function parseJsonRpcId$3(e) {
  if (!(0, compatibility_1$3.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  const n = e.id;
  return typeof n != "number" && typeof n != "string" ? null : n;
}
parse$h.parseJsonRpcId = parseJsonRpcId$3;
function parseJsonRpcRequest$3(e) {
  if (!(0, compatibility_1$3.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${e.jsonrpc}`);
  const n = parseJsonRpcId$3(e);
  if (n === null)
    throw new Error("Invalid id field");
  const o = e.method;
  if (typeof o != "string")
    throw new Error("Invalid method field");
  if (!(0, compatibility_1$3.isJsonCompatibleArray)(e.params) && !(0, compatibility_1$3.isJsonCompatibleDictionary)(e.params))
    throw new Error("Invalid params field");
  return {
    jsonrpc: "2.0",
    id: n,
    method: o,
    params: e.params
  };
}
parse$h.parseJsonRpcRequest = parseJsonRpcRequest$3;
function parseError$3(e) {
  if (typeof e.code != "number")
    throw new Error("Error property 'code' is not a number");
  if (typeof e.message != "string")
    throw new Error("Error property 'message' is not a string");
  let n;
  if (e.data === void 0)
    n = void 0;
  else if ((0, compatibility_1$3.isJsonCompatibleValue)(e.data))
    n = e.data;
  else
    throw new Error("Error property 'data' is defined but not a JSON compatible value.");
  return {
    code: e.code,
    message: e.message,
    ...n !== void 0 ? { data: n } : {}
  };
}
function parseJsonRpcErrorResponse$3(e) {
  if (!(0, compatibility_1$3.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const n = e.id;
  if (typeof n != "number" && typeof n != "string" && n !== null)
    throw new Error("Invalid id field");
  if (typeof e.error > "u" || !(0, compatibility_1$3.isJsonCompatibleDictionary)(e.error))
    throw new Error("Invalid error field");
  return {
    jsonrpc: "2.0",
    id: n,
    error: parseError$3(e.error)
  };
}
parse$h.parseJsonRpcErrorResponse = parseJsonRpcErrorResponse$3;
function parseJsonRpcSuccessResponse$3(e) {
  if (!(0, compatibility_1$3.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const n = e.id;
  if (typeof n != "number" && typeof n != "string")
    throw new Error("Invalid id field");
  if (typeof e.result > "u")
    throw new Error("Invalid result field");
  const o = e.result;
  return {
    jsonrpc: "2.0",
    id: n,
    result: o
  };
}
parse$h.parseJsonRpcSuccessResponse = parseJsonRpcSuccessResponse$3;
function parseJsonRpcResponse$3(e) {
  let n;
  try {
    n = parseJsonRpcErrorResponse$3(e);
  } catch {
    n = parseJsonRpcSuccessResponse$3(e);
  }
  return n;
}
parse$h.parseJsonRpcResponse = parseJsonRpcResponse$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.jsonRpcCode = e.isJsonRpcSuccessResponse = e.isJsonRpcErrorResponse = e.parseJsonRpcSuccessResponse = e.parseJsonRpcResponse = e.parseJsonRpcRequest = e.parseJsonRpcId = e.parseJsonRpcErrorResponse = e.JsonRpcClient = e.makeJsonRpcId = void 0;
  var n = id$4;
  Object.defineProperty(e, "makeJsonRpcId", { enumerable: !0, get: function() {
    return n.makeJsonRpcId;
  } });
  var o = jsonrpcclient$3;
  Object.defineProperty(e, "JsonRpcClient", { enumerable: !0, get: function() {
    return o.JsonRpcClient;
  } });
  var u = parse$h;
  Object.defineProperty(e, "parseJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "parseJsonRpcId", { enumerable: !0, get: function() {
    return u.parseJsonRpcId;
  } }), Object.defineProperty(e, "parseJsonRpcRequest", { enumerable: !0, get: function() {
    return u.parseJsonRpcRequest;
  } }), Object.defineProperty(e, "parseJsonRpcResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcResponse;
  } }), Object.defineProperty(e, "parseJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcSuccessResponse;
  } });
  var c = types$b;
  Object.defineProperty(e, "isJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return c.isJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "isJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return c.isJsonRpcSuccessResponse;
  } }), Object.defineProperty(e, "jsonRpcCode", { enumerable: !0, get: function() {
    return c.jsonRpcCode;
  } });
})(build$A);
var http$7 = {};
function bind$8(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: toString$6 } = Object.prototype, { getPrototypeOf: getPrototypeOf$2 } = Object, kindOf$3 = ((e) => (n) => {
  const o = toString$6.call(n);
  return e[o] || (e[o] = o.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest$3 = (e) => (e = e.toLowerCase(), (n) => kindOf$3(n) === e), typeOfTest$2 = (e) => (n) => typeof n === e, { isArray: isArray$5 } = Array, isUndefined$4 = typeOfTest$2("undefined");
function isBuffer$4(e) {
  return e !== null && !isUndefined$4(e) && e.constructor !== null && !isUndefined$4(e.constructor) && isFunction$5(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const isArrayBuffer$4 = kindOfTest$3("ArrayBuffer");
function isArrayBufferView$4(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && isArrayBuffer$4(e.buffer), n;
}
const isString$4 = typeOfTest$2("string"), isFunction$5 = typeOfTest$2("function"), isNumber$4 = typeOfTest$2("number"), isObject$6 = (e) => e !== null && typeof e == "object", isBoolean$2 = (e) => e === !0 || e === !1, isPlainObject$4 = (e) => {
  if (kindOf$3(e) !== "object")
    return !1;
  const n = getPrototypeOf$2(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, isDate$4 = kindOfTest$3("Date"), isFile$4 = kindOfTest$3("File"), isBlob$4 = kindOfTest$3("Blob"), isFileList$3 = kindOfTest$3("FileList"), isStream$4 = (e) => isObject$6(e) && isFunction$5(e.pipe), isFormData$4 = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || isFunction$5(e.append) && ((n = kindOf$3(e)) === "formdata" || // detect form-data instance
  n === "object" && isFunction$5(e.toString) && e.toString() === "[object FormData]"));
}, isURLSearchParams$4 = kindOfTest$3("URLSearchParams"), trim$5 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach$4(e, n, { allOwnKeys: o = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let u, c;
  if (typeof e != "object" && (e = [e]), isArray$5(e))
    for (u = 0, c = e.length; u < c; u++)
      n.call(null, e[u], u, e);
  else {
    const d = o ? Object.getOwnPropertyNames(e) : Object.keys(e), m = d.length;
    let v;
    for (u = 0; u < m; u++)
      v = d[u], n.call(null, e[v], v, e);
  }
}
function findKey$2(e, n) {
  n = n.toLowerCase();
  const o = Object.keys(e);
  let u = o.length, c;
  for (; u-- > 0; )
    if (c = o[u], n === c.toLowerCase())
      return c;
  return null;
}
const _global$2 = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : commonjsGlobal)(), isContextDefined$2 = (e) => !isUndefined$4(e) && e !== _global$2;
function merge$5() {
  const { caseless: e } = isContextDefined$2(this) && this || {}, n = {}, o = (u, c) => {
    const d = e && findKey$2(n, c) || c;
    isPlainObject$4(n[d]) && isPlainObject$4(u) ? n[d] = merge$5(n[d], u) : isPlainObject$4(u) ? n[d] = merge$5({}, u) : isArray$5(u) ? n[d] = u.slice() : n[d] = u;
  };
  for (let u = 0, c = arguments.length; u < c; u++)
    arguments[u] && forEach$4(arguments[u], o);
  return n;
}
const extend$4 = (e, n, o, { allOwnKeys: u } = {}) => (forEach$4(n, (c, d) => {
  o && isFunction$5(c) ? e[d] = bind$8(c, o) : e[d] = c;
}, { allOwnKeys: u }), e), stripBOM$4 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits$3 = (e, n, o, u) => {
  e.prototype = Object.create(n.prototype, u), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), o && Object.assign(e.prototype, o);
}, toFlatObject$3 = (e, n, o, u) => {
  let c, d, m;
  const v = {};
  if (n = n || {}, e == null)
    return n;
  do {
    for (c = Object.getOwnPropertyNames(e), d = c.length; d-- > 0; )
      m = c[d], (!u || u(m, e, n)) && !v[m] && (n[m] = e[m], v[m] = !0);
    e = o !== !1 && getPrototypeOf$2(e);
  } while (e && (!o || o(e, n)) && e !== Object.prototype);
  return n;
}, endsWith$3 = (e, n, o) => {
  e = String(e), (o === void 0 || o > e.length) && (o = e.length), o -= n.length;
  const u = e.indexOf(n, o);
  return u !== -1 && u === o;
}, toArray$3 = (e) => {
  if (!e)
    return null;
  if (isArray$5(e))
    return e;
  let n = e.length;
  if (!isNumber$4(n))
    return null;
  const o = new Array(n);
  for (; n-- > 0; )
    o[n] = e[n];
  return o;
}, isTypedArray$3 = ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && getPrototypeOf$2(Uint8Array)), forEachEntry$2 = (e, n) => {
  const u = (e && e[Symbol.iterator]).call(e);
  let c;
  for (; (c = u.next()) && !c.done; ) {
    const d = c.value;
    n.call(e, d[0], d[1]);
  }
}, matchAll$2 = (e, n) => {
  let o;
  const u = [];
  for (; (o = e.exec(n)) !== null; )
    u.push(o);
  return u;
}, isHTMLForm$2 = kindOfTest$3("HTMLFormElement"), toCamelCase$2 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(o, u, c) {
    return u.toUpperCase() + c;
  }
), hasOwnProperty$2 = (({ hasOwnProperty: e }) => (n, o) => e.call(n, o))(Object.prototype), isRegExp$2 = kindOfTest$3("RegExp"), reduceDescriptors$2 = (e, n) => {
  const o = Object.getOwnPropertyDescriptors(e), u = {};
  forEach$4(o, (c, d) => {
    let m;
    (m = n(c, d, e)) !== !1 && (u[d] = m || c);
  }), Object.defineProperties(e, u);
}, freezeMethods$2 = (e) => {
  reduceDescriptors$2(e, (n, o) => {
    if (isFunction$5(e) && ["arguments", "caller", "callee"].indexOf(o) !== -1)
      return !1;
    const u = e[o];
    if (isFunction$5(u)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + o + "'");
      });
    }
  });
}, toObjectSet$2 = (e, n) => {
  const o = {}, u = (c) => {
    c.forEach((d) => {
      o[d] = !0;
    });
  };
  return isArray$5(e) ? u(e) : u(String(e).split(n)), o;
}, noop$3 = () => {
}, toFiniteNumber$2 = (e, n) => (e = +e, Number.isFinite(e) ? e : n), ALPHA$2 = "abcdefghijklmnopqrstuvwxyz", DIGIT$2 = "0123456789", ALPHABET$2 = {
  DIGIT: DIGIT$2,
  ALPHA: ALPHA$2,
  ALPHA_DIGIT: ALPHA$2 + ALPHA$2.toUpperCase() + DIGIT$2
}, generateString$2 = (e = 16, n = ALPHABET$2.ALPHA_DIGIT) => {
  let o = "";
  const { length: u } = n;
  for (; e--; )
    o += n[Math.random() * u | 0];
  return o;
};
function isSpecCompliantForm$2(e) {
  return !!(e && isFunction$5(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const toJSONObject$2 = (e) => {
  const n = new Array(10), o = (u, c) => {
    if (isObject$6(u)) {
      if (n.indexOf(u) >= 0)
        return;
      if (!("toJSON" in u)) {
        n[c] = u;
        const d = isArray$5(u) ? [] : {};
        return forEach$4(u, (m, v) => {
          const S = o(m, c + 1);
          !isUndefined$4(S) && (d[v] = S);
        }), n[c] = void 0, d;
      }
    }
    return u;
  };
  return o(e, 0);
}, isAsyncFn$2 = kindOfTest$3("AsyncFunction"), isThenable$2 = (e) => e && (isObject$6(e) || isFunction$5(e)) && isFunction$5(e.then) && isFunction$5(e.catch);
var utils$1$3 = {
  isArray: isArray$5,
  isArrayBuffer: isArrayBuffer$4,
  isBuffer: isBuffer$4,
  isFormData: isFormData$4,
  isArrayBufferView: isArrayBufferView$4,
  isString: isString$4,
  isNumber: isNumber$4,
  isBoolean: isBoolean$2,
  isObject: isObject$6,
  isPlainObject: isPlainObject$4,
  isUndefined: isUndefined$4,
  isDate: isDate$4,
  isFile: isFile$4,
  isBlob: isBlob$4,
  isRegExp: isRegExp$2,
  isFunction: isFunction$5,
  isStream: isStream$4,
  isURLSearchParams: isURLSearchParams$4,
  isTypedArray: isTypedArray$3,
  isFileList: isFileList$3,
  forEach: forEach$4,
  merge: merge$5,
  extend: extend$4,
  trim: trim$5,
  stripBOM: stripBOM$4,
  inherits: inherits$3,
  toFlatObject: toFlatObject$3,
  kindOf: kindOf$3,
  kindOfTest: kindOfTest$3,
  endsWith: endsWith$3,
  toArray: toArray$3,
  forEachEntry: forEachEntry$2,
  matchAll: matchAll$2,
  isHTMLForm: isHTMLForm$2,
  hasOwnProperty: hasOwnProperty$2,
  hasOwnProp: hasOwnProperty$2,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: reduceDescriptors$2,
  freezeMethods: freezeMethods$2,
  toObjectSet: toObjectSet$2,
  toCamelCase: toCamelCase$2,
  noop: noop$3,
  toFiniteNumber: toFiniteNumber$2,
  findKey: findKey$2,
  global: _global$2,
  isContextDefined: isContextDefined$2,
  ALPHABET: ALPHABET$2,
  generateString: generateString$2,
  isSpecCompliantForm: isSpecCompliantForm$2,
  toJSONObject: toJSONObject$2,
  isAsyncFn: isAsyncFn$2,
  isThenable: isThenable$2
};
function AxiosError$5(e, n, o, u, c) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), o && (this.config = o), u && (this.request = u), c && (this.response = c);
}
utils$1$3.inherits(AxiosError$5, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1$3.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1$2 = AxiosError$5.prototype, descriptors$3 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  descriptors$3[e] = { value: e };
});
Object.defineProperties(AxiosError$5, descriptors$3);
Object.defineProperty(prototype$1$2, "isAxiosError", { value: !0 });
AxiosError$5.from = (e, n, o, u, c, d) => {
  const m = Object.create(prototype$1$2);
  return utils$1$3.toFlatObject(e, m, function(S) {
    return S !== Error.prototype;
  }, (v) => v !== "isAxiosError"), AxiosError$5.call(m, e.message, n, o, u, c), m.cause = e, m.name = e.name, d && Object.assign(m, d), m;
};
var httpAdapter$2 = null;
function isVisitable$2(e) {
  return utils$1$3.isPlainObject(e) || utils$1$3.isArray(e);
}
function removeBrackets$2(e) {
  return utils$1$3.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function renderKey$2(e, n, o) {
  return e ? e.concat(n).map(function(c, d) {
    return c = removeBrackets$2(c), !o && d ? "[" + c + "]" : c;
  }).join(o ? "." : "") : n;
}
function isFlatArray$2(e) {
  return utils$1$3.isArray(e) && !e.some(isVisitable$2);
}
const predicates$2 = utils$1$3.toFlatObject(utils$1$3, {}, null, function e(n) {
  return /^is[A-Z]/.test(n);
});
function toFormData$4(e, n, o) {
  if (!utils$1$3.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), o = utils$1$3.toFlatObject(o, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(M, G) {
    return !utils$1$3.isUndefined(G[M]);
  });
  const u = o.metaTokens, c = o.visitor || E, d = o.dots, m = o.indexes, S = (o.Blob || typeof Blob < "u" && Blob) && utils$1$3.isSpecCompliantForm(n);
  if (!utils$1$3.isFunction(c))
    throw new TypeError("visitor must be a function");
  function $(V) {
    if (V === null)
      return "";
    if (utils$1$3.isDate(V))
      return V.toISOString();
    if (!S && utils$1$3.isBlob(V))
      throw new AxiosError$5("Blob is not supported. Use a Buffer instead.");
    return utils$1$3.isArrayBuffer(V) || utils$1$3.isTypedArray(V) ? S && typeof Blob == "function" ? new Blob([V]) : buffer$1.Buffer.from(V) : V;
  }
  function E(V, M, G) {
    let k = V;
    if (V && !G && typeof V == "object") {
      if (utils$1$3.endsWith(M, "{}"))
        M = u ? M : M.slice(0, -2), V = JSON.stringify(V);
      else if (utils$1$3.isArray(V) && isFlatArray$2(V) || (utils$1$3.isFileList(V) || utils$1$3.endsWith(M, "[]")) && (k = utils$1$3.toArray(V)))
        return M = removeBrackets$2(M), k.forEach(function(X, ee) {
          !(utils$1$3.isUndefined(X) || X === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            m === !0 ? renderKey$2([M], ee, d) : m === null ? M : M + "[]",
            $(X)
          );
        }), !1;
    }
    return isVisitable$2(V) ? !0 : (n.append(renderKey$2(G, M, d), $(V)), !1);
  }
  const O = [], T = Object.assign(predicates$2, {
    defaultVisitor: E,
    convertValue: $,
    isVisitable: isVisitable$2
  });
  function y(V, M) {
    if (!utils$1$3.isUndefined(V)) {
      if (O.indexOf(V) !== -1)
        throw Error("Circular reference detected in " + M.join("."));
      O.push(V), utils$1$3.forEach(V, function(k, F) {
        (!(utils$1$3.isUndefined(k) || k === null) && c.call(
          n,
          k,
          utils$1$3.isString(F) ? F.trim() : F,
          M,
          T
        )) === !0 && y(k, M ? M.concat(F) : [F]);
      }), O.pop();
    }
  }
  if (!utils$1$3.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), n;
}
function encode$1$3(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(u) {
    return n[u];
  });
}
function AxiosURLSearchParams$2(e, n) {
  this._pairs = [], e && toFormData$4(e, this, n);
}
const prototype$4 = AxiosURLSearchParams$2.prototype;
prototype$4.append = function e(n, o) {
  this._pairs.push([n, o]);
};
prototype$4.toString = function e(n) {
  const o = n ? function(u) {
    return n.call(this, u, encode$1$3);
  } : encode$1$3;
  return this._pairs.map(function(c) {
    return o(c[0]) + "=" + o(c[1]);
  }, "").join("&");
};
function encode$4(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL$6(e, n, o) {
  if (!n)
    return e;
  const u = o && o.encode || encode$4, c = o && o.serialize;
  let d;
  if (c ? d = c(n, o) : d = utils$1$3.isURLSearchParams(n) ? n.toString() : new AxiosURLSearchParams$2(n, o).toString(u), d) {
    const m = e.indexOf("#");
    m !== -1 && (e = e.slice(0, m)), e += (e.indexOf("?") === -1 ? "?" : "&") + d;
  }
  return e;
}
let InterceptorManager$6 = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, o, u) {
    return this.handlers.push({
      fulfilled: n,
      rejected: o,
      synchronous: u ? u.synchronous : !1,
      runWhen: u ? u.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    utils$1$3.forEach(this.handlers, function(u) {
      u !== null && n(u);
    });
  }
};
var InterceptorManager$1$3 = InterceptorManager$6, transitionalDefaults$3 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1$2 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams$2, FormData$1$2 = typeof FormData < "u" ? FormData : null, Blob$1$2 = typeof Blob < "u" ? Blob : null, platform$1$2 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1$2,
    FormData: FormData$1$2,
    Blob: Blob$1$2
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv$2 = typeof window < "u" && typeof document < "u", hasStandardBrowserEnv$2 = ((e) => hasBrowserEnv$2 && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), hasStandardBrowserWebWorkerEnv$2 = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")();
var utils$w = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  hasBrowserEnv: hasBrowserEnv$2,
  hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv$2,
  hasStandardBrowserEnv: hasStandardBrowserEnv$2
}), platform$3 = {
  ...utils$w,
  ...platform$1$2
};
function toURLEncodedForm$2(e, n) {
  return toFormData$4(e, new platform$3.classes.URLSearchParams(), Object.assign({
    visitor: function(o, u, c, d) {
      return platform$3.isNode && utils$1$3.isBuffer(o) ? (this.append(u, o.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function parsePropPath$2(e) {
  return utils$1$3.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function arrayToObject$2(e) {
  const n = {}, o = Object.keys(e);
  let u;
  const c = o.length;
  let d;
  for (u = 0; u < c; u++)
    d = o[u], n[d] = e[d];
  return n;
}
function formDataToJSON$2(e) {
  function n(o, u, c, d) {
    let m = o[d++];
    const v = Number.isFinite(+m), S = d >= o.length;
    return m = !m && utils$1$3.isArray(c) ? c.length : m, S ? (utils$1$3.hasOwnProp(c, m) ? c[m] = [c[m], u] : c[m] = u, !v) : ((!c[m] || !utils$1$3.isObject(c[m])) && (c[m] = []), n(o, u, c[m], d) && utils$1$3.isArray(c[m]) && (c[m] = arrayToObject$2(c[m])), !v);
  }
  if (utils$1$3.isFormData(e) && utils$1$3.isFunction(e.entries)) {
    const o = {};
    return utils$1$3.forEachEntry(e, (u, c) => {
      n(parsePropPath$2(u), c, o, 0);
    }), o;
  }
  return null;
}
function stringifySafely$4(e, n, o) {
  if (utils$1$3.isString(e))
    try {
      return (n || JSON.parse)(e), utils$1$3.trim(e);
    } catch (u) {
      if (u.name !== "SyntaxError")
        throw u;
    }
  return (o || JSON.stringify)(e);
}
const defaults$a = {
  transitional: transitionalDefaults$3,
  adapter: ["xhr", "http"],
  transformRequest: [function e(n, o) {
    const u = o.getContentType() || "", c = u.indexOf("application/json") > -1, d = utils$1$3.isObject(n);
    if (d && utils$1$3.isHTMLForm(n) && (n = new FormData(n)), utils$1$3.isFormData(n))
      return c && c ? JSON.stringify(formDataToJSON$2(n)) : n;
    if (utils$1$3.isArrayBuffer(n) || utils$1$3.isBuffer(n) || utils$1$3.isStream(n) || utils$1$3.isFile(n) || utils$1$3.isBlob(n))
      return n;
    if (utils$1$3.isArrayBufferView(n))
      return n.buffer;
    if (utils$1$3.isURLSearchParams(n))
      return o.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let v;
    if (d) {
      if (u.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm$2(n, this.formSerializer).toString();
      if ((v = utils$1$3.isFileList(n)) || u.indexOf("multipart/form-data") > -1) {
        const S = this.env && this.env.FormData;
        return toFormData$4(
          v ? { "files[]": n } : n,
          S && new S(),
          this.formSerializer
        );
      }
    }
    return d || c ? (o.setContentType("application/json", !1), stringifySafely$4(n)) : n;
  }],
  transformResponse: [function e(n) {
    const o = this.transitional || defaults$a.transitional, u = o && o.forcedJSONParsing, c = this.responseType === "json";
    if (n && utils$1$3.isString(n) && (u && !this.responseType || c)) {
      const m = !(o && o.silentJSONParsing) && c;
      try {
        return JSON.parse(n);
      } catch (v) {
        if (m)
          throw v.name === "SyntaxError" ? AxiosError$5.from(v, AxiosError$5.ERR_BAD_RESPONSE, this, null, this.response) : v;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform$3.classes.FormData,
    Blob: platform$3.classes.Blob
  },
  validateStatus: function e(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1$3.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  defaults$a.headers[e] = {};
});
var defaults$1$3 = defaults$a;
const ignoreDuplicateOf$2 = utils$1$3.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
var parseHeaders$4 = (e) => {
  const n = {};
  let o, u, c;
  return e && e.split(`
`).forEach(function(m) {
    c = m.indexOf(":"), o = m.substring(0, c).trim().toLowerCase(), u = m.substring(c + 1).trim(), !(!o || n[o] && ignoreDuplicateOf$2[o]) && (o === "set-cookie" ? n[o] ? n[o].push(u) : n[o] = [u] : n[o] = n[o] ? n[o] + ", " + u : u);
  }), n;
};
const $internals$2 = Symbol("internals");
function normalizeHeader$2(e) {
  return e && String(e).trim().toLowerCase();
}
function normalizeValue$2(e) {
  return e === !1 || e == null ? e : utils$1$3.isArray(e) ? e.map(normalizeValue$2) : String(e);
}
function parseTokens$2(e) {
  const n = /* @__PURE__ */ Object.create(null), o = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let u;
  for (; u = o.exec(e); )
    n[u[1]] = u[2];
  return n;
}
const isValidHeaderName$2 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function matchHeaderValue$2(e, n, o, u, c) {
  if (utils$1$3.isFunction(u))
    return u.call(this, n, o);
  if (c && (n = o), !!utils$1$3.isString(n)) {
    if (utils$1$3.isString(u))
      return n.indexOf(u) !== -1;
    if (utils$1$3.isRegExp(u))
      return u.test(n);
  }
}
function formatHeader$2(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, o, u) => o.toUpperCase() + u);
}
function buildAccessors$2(e, n) {
  const o = utils$1$3.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((u) => {
    Object.defineProperty(e, u + o, {
      value: function(c, d, m) {
        return this[u].call(this, n, c, d, m);
      },
      configurable: !0
    });
  });
}
let AxiosHeaders$3 = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, o, u) {
    const c = this;
    function d(v, S, $) {
      const E = normalizeHeader$2(S);
      if (!E)
        throw new Error("header name must be a non-empty string");
      const O = utils$1$3.findKey(c, E);
      (!O || c[O] === void 0 || $ === !0 || $ === void 0 && c[O] !== !1) && (c[O || S] = normalizeValue$2(v));
    }
    const m = (v, S) => utils$1$3.forEach(v, ($, E) => d($, E, S));
    return utils$1$3.isPlainObject(n) || n instanceof this.constructor ? m(n, o) : utils$1$3.isString(n) && (n = n.trim()) && !isValidHeaderName$2(n) ? m(parseHeaders$4(n), o) : n != null && d(o, n, u), this;
  }
  get(n, o) {
    if (n = normalizeHeader$2(n), n) {
      const u = utils$1$3.findKey(this, n);
      if (u) {
        const c = this[u];
        if (!o)
          return c;
        if (o === !0)
          return parseTokens$2(c);
        if (utils$1$3.isFunction(o))
          return o.call(this, c, u);
        if (utils$1$3.isRegExp(o))
          return o.exec(c);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, o) {
    if (n = normalizeHeader$2(n), n) {
      const u = utils$1$3.findKey(this, n);
      return !!(u && this[u] !== void 0 && (!o || matchHeaderValue$2(this, this[u], u, o)));
    }
    return !1;
  }
  delete(n, o) {
    const u = this;
    let c = !1;
    function d(m) {
      if (m = normalizeHeader$2(m), m) {
        const v = utils$1$3.findKey(u, m);
        v && (!o || matchHeaderValue$2(u, u[v], v, o)) && (delete u[v], c = !0);
      }
    }
    return utils$1$3.isArray(n) ? n.forEach(d) : d(n), c;
  }
  clear(n) {
    const o = Object.keys(this);
    let u = o.length, c = !1;
    for (; u--; ) {
      const d = o[u];
      (!n || matchHeaderValue$2(this, this[d], d, n, !0)) && (delete this[d], c = !0);
    }
    return c;
  }
  normalize(n) {
    const o = this, u = {};
    return utils$1$3.forEach(this, (c, d) => {
      const m = utils$1$3.findKey(u, d);
      if (m) {
        o[m] = normalizeValue$2(c), delete o[d];
        return;
      }
      const v = n ? formatHeader$2(d) : String(d).trim();
      v !== d && delete o[d], o[v] = normalizeValue$2(c), u[v] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const o = /* @__PURE__ */ Object.create(null);
    return utils$1$3.forEach(this, (u, c) => {
      u != null && u !== !1 && (o[c] = n && utils$1$3.isArray(u) ? u.join(", ") : u);
    }), o;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, o]) => n + ": " + o).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...o) {
    const u = new this(n);
    return o.forEach((c) => u.set(c)), u;
  }
  static accessor(n) {
    const u = (this[$internals$2] = this[$internals$2] = {
      accessors: {}
    }).accessors, c = this.prototype;
    function d(m) {
      const v = normalizeHeader$2(m);
      u[v] || (buildAccessors$2(c, m), u[v] = !0);
    }
    return utils$1$3.isArray(n) ? n.forEach(d) : d(n), this;
  }
};
AxiosHeaders$3.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1$3.reduceDescriptors(AxiosHeaders$3.prototype, ({ value: e }, n) => {
  let o = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(u) {
      this[o] = u;
    }
  };
});
utils$1$3.freezeMethods(AxiosHeaders$3);
var AxiosHeaders$1$2 = AxiosHeaders$3;
function transformData$6(e, n) {
  const o = this || defaults$1$3, u = n || o, c = AxiosHeaders$1$2.from(u.headers);
  let d = u.data;
  return utils$1$3.forEach(e, function(v) {
    d = v.call(o, d, c.normalize(), n ? n.status : void 0);
  }), c.normalize(), d;
}
function isCancel$6(e) {
  return !!(e && e.__CANCEL__);
}
function CanceledError$3(e, n, o) {
  AxiosError$5.call(this, e ?? "canceled", AxiosError$5.ERR_CANCELED, n, o), this.name = "CanceledError";
}
utils$1$3.inherits(CanceledError$3, AxiosError$5, {
  __CANCEL__: !0
});
function settle$4(e, n, o) {
  const u = o.config.validateStatus;
  !o.status || !u || u(o.status) ? e(o) : n(new AxiosError$5(
    "Request failed with status code " + o.status,
    [AxiosError$5.ERR_BAD_REQUEST, AxiosError$5.ERR_BAD_RESPONSE][Math.floor(o.status / 100) - 4],
    o.config,
    o.request,
    o
  ));
}
var cookies$4 = platform$3.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, o, u, c, d) {
      const m = [e + "=" + encodeURIComponent(n)];
      utils$1$3.isNumber(o) && m.push("expires=" + new Date(o).toGMTString()), utils$1$3.isString(u) && m.push("path=" + u), utils$1$3.isString(c) && m.push("domain=" + c), d === !0 && m.push("secure"), document.cookie = m.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL$5(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function combineURLs$5(e, n) {
  return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function buildFullPath$5(e, n) {
  return e && !isAbsoluteURL$5(n) ? combineURLs$5(e, n) : n;
}
var isURLSameOrigin$4 = platform$3.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function e() {
    const n = /(msie|trident)/i.test(navigator.userAgent), o = document.createElement("a");
    let u;
    function c(d) {
      let m = d;
      return n && (o.setAttribute("href", m), m = o.href), o.setAttribute("href", m), {
        href: o.href,
        protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
        host: o.host,
        search: o.search ? o.search.replace(/^\?/, "") : "",
        hash: o.hash ? o.hash.replace(/^#/, "") : "",
        hostname: o.hostname,
        port: o.port,
        pathname: o.pathname.charAt(0) === "/" ? o.pathname : "/" + o.pathname
      };
    }
    return u = c(window.location.href), function(m) {
      const v = utils$1$3.isString(m) ? c(m) : m;
      return v.protocol === u.protocol && v.host === u.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function e() {
    return function() {
      return !0;
    };
  }()
);
function parseProtocol$3(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function speedometer$2(e, n) {
  e = e || 10;
  const o = new Array(e), u = new Array(e);
  let c = 0, d = 0, m;
  return n = n !== void 0 ? n : 1e3, function(S) {
    const $ = Date.now(), E = u[d];
    m || (m = $), o[c] = S, u[c] = $;
    let O = d, T = 0;
    for (; O !== c; )
      T += o[O++], O = O % e;
    if (c = (c + 1) % e, c === d && (d = (d + 1) % e), $ - m < n)
      return;
    const y = E && $ - E;
    return y ? Math.round(T * 1e3 / y) : void 0;
  };
}
function progressEventReducer$2(e, n) {
  let o = 0;
  const u = speedometer$2(50, 250);
  return (c) => {
    const d = c.loaded, m = c.lengthComputable ? c.total : void 0, v = d - o, S = u(v), $ = d <= m;
    o = d;
    const E = {
      loaded: d,
      total: m,
      progress: m ? d / m : void 0,
      bytes: v,
      rate: S || void 0,
      estimated: S && m && $ ? (m - d) / S : void 0,
      event: c
    };
    E[n ? "download" : "upload"] = !0, e(E);
  };
}
const isXHRAdapterSupported$2 = typeof XMLHttpRequest < "u";
var xhrAdapter$2 = isXHRAdapterSupported$2 && function(e) {
  return new Promise(function(o, u) {
    let c = e.data;
    const d = AxiosHeaders$1$2.from(e.headers).normalize();
    let { responseType: m, withXSRFToken: v } = e, S;
    function $() {
      e.cancelToken && e.cancelToken.unsubscribe(S), e.signal && e.signal.removeEventListener("abort", S);
    }
    let E;
    if (utils$1$3.isFormData(c)) {
      if (platform$3.hasStandardBrowserEnv || platform$3.hasStandardBrowserWebWorkerEnv)
        d.setContentType(!1);
      else if ((E = d.getContentType()) !== !1) {
        const [M, ...G] = E ? E.split(";").map((k) => k.trim()).filter(Boolean) : [];
        d.setContentType([M || "multipart/form-data", ...G].join("; "));
      }
    }
    let O = new XMLHttpRequest();
    if (e.auth) {
      const M = e.auth.username || "", G = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      d.set("Authorization", "Basic " + btoa(M + ":" + G));
    }
    const T = buildFullPath$5(e.baseURL, e.url);
    O.open(e.method.toUpperCase(), buildURL$6(T, e.params, e.paramsSerializer), !0), O.timeout = e.timeout;
    function y() {
      if (!O)
        return;
      const M = AxiosHeaders$1$2.from(
        "getAllResponseHeaders" in O && O.getAllResponseHeaders()
      ), k = {
        data: !m || m === "text" || m === "json" ? O.responseText : O.response,
        status: O.status,
        statusText: O.statusText,
        headers: M,
        config: e,
        request: O
      };
      settle$4(function(X) {
        o(X), $();
      }, function(X) {
        u(X), $();
      }, k), O = null;
    }
    if ("onloadend" in O ? O.onloadend = y : O.onreadystatechange = function() {
      !O || O.readyState !== 4 || O.status === 0 && !(O.responseURL && O.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, O.onabort = function() {
      O && (u(new AxiosError$5("Request aborted", AxiosError$5.ECONNABORTED, e, O)), O = null);
    }, O.onerror = function() {
      u(new AxiosError$5("Network Error", AxiosError$5.ERR_NETWORK, e, O)), O = null;
    }, O.ontimeout = function() {
      let G = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const k = e.transitional || transitionalDefaults$3;
      e.timeoutErrorMessage && (G = e.timeoutErrorMessage), u(new AxiosError$5(
        G,
        k.clarifyTimeoutError ? AxiosError$5.ETIMEDOUT : AxiosError$5.ECONNABORTED,
        e,
        O
      )), O = null;
    }, platform$3.hasStandardBrowserEnv && (v && utils$1$3.isFunction(v) && (v = v(e)), v || v !== !1 && isURLSameOrigin$4(T))) {
      const M = e.xsrfHeaderName && e.xsrfCookieName && cookies$4.read(e.xsrfCookieName);
      M && d.set(e.xsrfHeaderName, M);
    }
    c === void 0 && d.setContentType(null), "setRequestHeader" in O && utils$1$3.forEach(d.toJSON(), function(G, k) {
      O.setRequestHeader(k, G);
    }), utils$1$3.isUndefined(e.withCredentials) || (O.withCredentials = !!e.withCredentials), m && m !== "json" && (O.responseType = e.responseType), typeof e.onDownloadProgress == "function" && O.addEventListener("progress", progressEventReducer$2(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && O.upload && O.upload.addEventListener("progress", progressEventReducer$2(e.onUploadProgress)), (e.cancelToken || e.signal) && (S = (M) => {
      O && (u(!M || M.type ? new CanceledError$3(null, e, O) : M), O.abort(), O = null);
    }, e.cancelToken && e.cancelToken.subscribe(S), e.signal && (e.signal.aborted ? S() : e.signal.addEventListener("abort", S)));
    const V = parseProtocol$3(T);
    if (V && platform$3.protocols.indexOf(V) === -1) {
      u(new AxiosError$5("Unsupported protocol " + V + ":", AxiosError$5.ERR_BAD_REQUEST, e));
      return;
    }
    O.send(c || null);
  });
};
const knownAdapters$2 = {
  http: httpAdapter$2,
  xhr: xhrAdapter$2
};
utils$1$3.forEach(knownAdapters$2, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const renderReason$2 = (e) => `- ${e}`, isResolvedHandle$2 = (e) => utils$1$3.isFunction(e) || e === null || e === !1;
var adapters$2 = {
  getAdapter: (e) => {
    e = utils$1$3.isArray(e) ? e : [e];
    const { length: n } = e;
    let o, u;
    const c = {};
    for (let d = 0; d < n; d++) {
      o = e[d];
      let m;
      if (u = o, !isResolvedHandle$2(o) && (u = knownAdapters$2[(m = String(o)).toLowerCase()], u === void 0))
        throw new AxiosError$5(`Unknown adapter '${m}'`);
      if (u)
        break;
      c[m || "#" + d] = u;
    }
    if (!u) {
      const d = Object.entries(c).map(
        ([v, S]) => `adapter ${v} ` + (S === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let m = n ? d.length > 1 ? `since :
` + d.map(renderReason$2).join(`
`) : " " + renderReason$2(d[0]) : "as no adapter specified";
      throw new AxiosError$5(
        "There is no suitable adapter to dispatch the request " + m,
        "ERR_NOT_SUPPORT"
      );
    }
    return u;
  },
  adapters: knownAdapters$2
};
function throwIfCancellationRequested$4(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError$3(null, e);
}
function dispatchRequest$6(e) {
  return throwIfCancellationRequested$4(e), e.headers = AxiosHeaders$1$2.from(e.headers), e.data = transformData$6.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), adapters$2.getAdapter(e.adapter || defaults$1$3.adapter)(e).then(function(u) {
    return throwIfCancellationRequested$4(e), u.data = transformData$6.call(
      e,
      e.transformResponse,
      u
    ), u.headers = AxiosHeaders$1$2.from(u.headers), u;
  }, function(u) {
    return isCancel$6(u) || (throwIfCancellationRequested$4(e), u && u.response && (u.response.data = transformData$6.call(
      e,
      e.transformResponse,
      u.response
    ), u.response.headers = AxiosHeaders$1$2.from(u.response.headers))), Promise.reject(u);
  });
}
const headersToObject$2 = (e) => e instanceof AxiosHeaders$1$2 ? e.toJSON() : e;
function mergeConfig$8(e, n) {
  n = n || {};
  const o = {};
  function u($, E, O) {
    return utils$1$3.isPlainObject($) && utils$1$3.isPlainObject(E) ? utils$1$3.merge.call({ caseless: O }, $, E) : utils$1$3.isPlainObject(E) ? utils$1$3.merge({}, E) : utils$1$3.isArray(E) ? E.slice() : E;
  }
  function c($, E, O) {
    if (utils$1$3.isUndefined(E)) {
      if (!utils$1$3.isUndefined($))
        return u(void 0, $, O);
    } else
      return u($, E, O);
  }
  function d($, E) {
    if (!utils$1$3.isUndefined(E))
      return u(void 0, E);
  }
  function m($, E) {
    if (utils$1$3.isUndefined(E)) {
      if (!utils$1$3.isUndefined($))
        return u(void 0, $);
    } else
      return u(void 0, E);
  }
  function v($, E, O) {
    if (O in n)
      return u($, E);
    if (O in e)
      return u(void 0, $);
  }
  const S = {
    url: d,
    method: d,
    data: d,
    baseURL: m,
    transformRequest: m,
    transformResponse: m,
    paramsSerializer: m,
    timeout: m,
    timeoutMessage: m,
    withCredentials: m,
    withXSRFToken: m,
    adapter: m,
    responseType: m,
    xsrfCookieName: m,
    xsrfHeaderName: m,
    onUploadProgress: m,
    onDownloadProgress: m,
    decompress: m,
    maxContentLength: m,
    maxBodyLength: m,
    beforeRedirect: m,
    transport: m,
    httpAgent: m,
    httpsAgent: m,
    cancelToken: m,
    socketPath: m,
    responseEncoding: m,
    validateStatus: v,
    headers: ($, E) => c(headersToObject$2($), headersToObject$2(E), !0)
  };
  return utils$1$3.forEach(Object.keys(Object.assign({}, e, n)), function(E) {
    const O = S[E] || c, T = O(e[E], n[E], E);
    utils$1$3.isUndefined(T) && O !== v || (o[E] = T);
  }), o;
}
const VERSION$3 = "1.6.2", validators$1$3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  validators$1$3[e] = function(u) {
    return typeof u === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const deprecatedWarnings$4 = {};
validators$1$3.transitional = function e(n, o, u) {
  function c(d, m) {
    return "[Axios v" + VERSION$3 + "] Transitional option '" + d + "'" + m + (u ? ". " + u : "");
  }
  return (d, m, v) => {
    if (n === !1)
      throw new AxiosError$5(
        c(m, " has been removed" + (o ? " in " + o : "")),
        AxiosError$5.ERR_DEPRECATED
      );
    return o && !deprecatedWarnings$4[m] && (deprecatedWarnings$4[m] = !0, console.warn(
      c(
        m,
        " has been deprecated since v" + o + " and will be removed in the near future"
      )
    )), n ? n(d, m, v) : !0;
  };
};
function assertOptions$4(e, n, o) {
  if (typeof e != "object")
    throw new AxiosError$5("options must be an object", AxiosError$5.ERR_BAD_OPTION_VALUE);
  const u = Object.keys(e);
  let c = u.length;
  for (; c-- > 0; ) {
    const d = u[c], m = n[d];
    if (m) {
      const v = e[d], S = v === void 0 || m(v, d, e);
      if (S !== !0)
        throw new AxiosError$5("option " + d + " must be " + S, AxiosError$5.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (o !== !0)
      throw new AxiosError$5("Unknown option " + d, AxiosError$5.ERR_BAD_OPTION);
  }
}
var validator$a = {
  assertOptions: assertOptions$4,
  validators: validators$1$3
};
const validators$6 = validator$a.validators;
let Axios$6 = class {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new InterceptorManager$1$3(),
      response: new InterceptorManager$1$3()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(n, o) {
    typeof n == "string" ? (o = o || {}, o.url = n) : o = n || {}, o = mergeConfig$8(this.defaults, o);
    const { transitional: u, paramsSerializer: c, headers: d } = o;
    u !== void 0 && validator$a.assertOptions(u, {
      silentJSONParsing: validators$6.transitional(validators$6.boolean),
      forcedJSONParsing: validators$6.transitional(validators$6.boolean),
      clarifyTimeoutError: validators$6.transitional(validators$6.boolean)
    }, !1), c != null && (utils$1$3.isFunction(c) ? o.paramsSerializer = {
      serialize: c
    } : validator$a.assertOptions(c, {
      encode: validators$6.function,
      serialize: validators$6.function
    }, !0)), o.method = (o.method || this.defaults.method || "get").toLowerCase();
    let m = d && utils$1$3.merge(
      d.common,
      d[o.method]
    );
    d && utils$1$3.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (V) => {
        delete d[V];
      }
    ), o.headers = AxiosHeaders$1$2.concat(m, d);
    const v = [];
    let S = !0;
    this.interceptors.request.forEach(function(M) {
      typeof M.runWhen == "function" && M.runWhen(o) === !1 || (S = S && M.synchronous, v.unshift(M.fulfilled, M.rejected));
    });
    const $ = [];
    this.interceptors.response.forEach(function(M) {
      $.push(M.fulfilled, M.rejected);
    });
    let E, O = 0, T;
    if (!S) {
      const V = [dispatchRequest$6.bind(this), void 0];
      for (V.unshift.apply(V, v), V.push.apply(V, $), T = V.length, E = Promise.resolve(o); O < T; )
        E = E.then(V[O++], V[O++]);
      return E;
    }
    T = v.length;
    let y = o;
    for (O = 0; O < T; ) {
      const V = v[O++], M = v[O++];
      try {
        y = V(y);
      } catch (G) {
        M.call(this, G);
        break;
      }
    }
    try {
      E = dispatchRequest$6.call(this, y);
    } catch (V) {
      return Promise.reject(V);
    }
    for (O = 0, T = $.length; O < T; )
      E = E.then($[O++], $[O++]);
    return E;
  }
  getUri(n) {
    n = mergeConfig$8(this.defaults, n);
    const o = buildFullPath$5(n.baseURL, n.url);
    return buildURL$6(o, n.params, n.paramsSerializer);
  }
};
utils$1$3.forEach(["delete", "get", "head", "options"], function e(n) {
  Axios$6.prototype[n] = function(o, u) {
    return this.request(mergeConfig$8(u || {}, {
      method: n,
      url: o,
      data: (u || {}).data
    }));
  };
});
utils$1$3.forEach(["post", "put", "patch"], function e(n) {
  function o(u) {
    return function(d, m, v) {
      return this.request(mergeConfig$8(v || {}, {
        method: n,
        headers: u ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: d,
        data: m
      }));
    };
  }
  Axios$6.prototype[n] = o(), Axios$6.prototype[n + "Form"] = o(!0);
});
var Axios$1$3 = Axios$6;
let CancelToken$3 = class Jc {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let o;
    this.promise = new Promise(function(d) {
      o = d;
    });
    const u = this;
    this.promise.then((c) => {
      if (!u._listeners)
        return;
      let d = u._listeners.length;
      for (; d-- > 0; )
        u._listeners[d](c);
      u._listeners = null;
    }), this.promise.then = (c) => {
      let d;
      const m = new Promise((v) => {
        u.subscribe(v), d = v;
      }).then(c);
      return m.cancel = function() {
        u.unsubscribe(d);
      }, m;
    }, n(function(d, m, v) {
      u.reason || (u.reason = new CanceledError$3(d, m, v), o(u.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const o = this._listeners.indexOf(n);
    o !== -1 && this._listeners.splice(o, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Jc(function(c) {
        n = c;
      }),
      cancel: n
    };
  }
};
var CancelToken$1$2 = CancelToken$3;
function spread$4(e) {
  return function(o) {
    return e.apply(null, o);
  };
}
function isAxiosError$4(e) {
  return utils$1$3.isObject(e) && e.isAxiosError === !0;
}
const HttpStatusCode$3 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode$3).forEach(([e, n]) => {
  HttpStatusCode$3[n] = e;
});
var HttpStatusCode$1$2 = HttpStatusCode$3;
function createInstance$4(e) {
  const n = new Axios$1$3(e), o = bind$8(Axios$1$3.prototype.request, n);
  return utils$1$3.extend(o, Axios$1$3.prototype, n, { allOwnKeys: !0 }), utils$1$3.extend(o, n, null, { allOwnKeys: !0 }), o.create = function(c) {
    return createInstance$4(mergeConfig$8(e, c));
  }, o;
}
const axios$9 = createInstance$4(defaults$1$3);
axios$9.Axios = Axios$1$3;
axios$9.CanceledError = CanceledError$3;
axios$9.CancelToken = CancelToken$1$2;
axios$9.isCancel = isCancel$6;
axios$9.VERSION = VERSION$3;
axios$9.toFormData = toFormData$4;
axios$9.AxiosError = AxiosError$5;
axios$9.Cancel = axios$9.CanceledError;
axios$9.all = function e(n) {
  return Promise.all(n);
};
axios$9.spread = spread$4;
axios$9.isAxiosError = isAxiosError$4;
axios$9.mergeConfig = mergeConfig$8;
axios$9.AxiosHeaders = AxiosHeaders$1$2;
axios$9.formToJSON = (e) => formDataToJSON$2(utils$1$3.isHTMLForm(e) ? new FormData(e) : e);
axios$9.getAdapter = adapters$2.getAdapter;
axios$9.HttpStatusCode = HttpStatusCode$1$2;
axios$9.default = axios$9;
var axios_1$6 = axios$9, __importDefault$A = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(http$7, "__esModule", { value: !0 });
http$7.http = void 0;
const axios_1$5 = __importDefault$A(axios_1$6);
function filterBadStatus$3(e) {
  if (e.status >= 400)
    throw new Error(`Bad status on response: ${e.status}`);
  return e;
}
function isExperimental$2(e) {
  return e.toString().includes("emitExperimentalWarning");
}
async function http$6(e, n, o, u) {
  if (typeof fetch == "function" && !isExperimental$2(fetch)) {
    const c = {
      method: e,
      body: u ? JSON.stringify(u) : void 0,
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json",
        ...o
      }
    };
    return fetch(n, c).then(filterBadStatus$3).then((d) => d.json());
  } else
    return axios_1$5.default.request({ url: n, method: e, data: u, headers: o }).then((c) => c.data);
}
http$7.http = http$6;
var rpcclient$3 = {};
Object.defineProperty(rpcclient$3, "__esModule", { value: !0 });
rpcclient$3.hasProtocol = rpcclient$3.instanceOfRpcStreamingClient = void 0;
function instanceOfRpcStreamingClient$3(e) {
  return typeof e.listen == "function";
}
rpcclient$3.instanceOfRpcStreamingClient = instanceOfRpcStreamingClient$3;
function hasProtocol$3(e) {
  return e.search("://") !== -1;
}
rpcclient$3.hasProtocol = hasProtocol$3;
Object.defineProperty(httpbatchclient$3, "__esModule", { value: !0 });
httpbatchclient$3.HttpBatchClient = void 0;
const json_rpc_1$b = build$A, http_1$7 = http$7, rpcclient_1$b = rpcclient$3, defaultHttpBatchClientOptions$3 = {
  dispatchInterval: 20,
  batchSizeLimit: 20
};
let HttpBatchClient$3 = class {
  constructor(n, o = {}) {
    this.queue = [], this.options = {
      batchSizeLimit: o.batchSizeLimit ?? defaultHttpBatchClientOptions$3.batchSizeLimit,
      dispatchInterval: o.dispatchInterval ?? defaultHttpBatchClientOptions$3.dispatchInterval
    }, typeof n == "string" ? this.url = (0, rpcclient_1$b.hasProtocol)(n) ? n : "http://" + n : (this.url = n.url, this.headers = n.headers), this.timer = setInterval(() => this.tick(), o.dispatchInterval), this.validate();
  }
  disconnect() {
    this.timer && clearInterval(this.timer), this.timer = void 0;
  }
  async execute(n) {
    return new Promise((o, u) => {
      this.queue.push({ request: n, resolve: o, reject: u }), this.queue.length >= this.options.batchSizeLimit && this.tick();
    });
  }
  validate() {
    if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1)
      throw new Error("batchSizeLimit must be a safe integer >= 1");
  }
  /**
   * This is called in an interval where promise rejections cannot be handled.
   * So this is not async and HTTP errors need to be handled by the queued promises.
   */
  tick() {
    const n = this.queue.splice(0, this.options.batchSizeLimit);
    if (!n.length)
      return;
    const o = n.map((c) => c.request), u = o.map((c) => c.id);
    (0, http_1$7.http)("POST", this.url, this.headers, o).then((c) => {
      (Array.isArray(c) ? c : [c]).forEach((m) => {
        const v = n.find((O) => O.request.id === m.id);
        if (!v)
          return;
        const { reject: S, resolve: $ } = v, E = (0, json_rpc_1$b.parseJsonRpcResponse)(m);
        (0, json_rpc_1$b.isJsonRpcErrorResponse)(E) ? S(new Error(JSON.stringify(E.error))) : $(E);
      });
    }, (c) => {
      for (const d of u) {
        const m = n.find((v) => v.request.id === d);
        if (!m)
          return;
        m.reject(c);
      }
    });
  }
};
httpbatchclient$3.HttpBatchClient = HttpBatchClient$3;
var httpclient$3 = {};
Object.defineProperty(httpclient$3, "__esModule", { value: !0 });
httpclient$3.HttpClient = void 0;
const json_rpc_1$a = build$A, http_1$6 = http$7, rpcclient_1$a = rpcclient$3;
let HttpClient$3 = class {
  constructor(n) {
    typeof n == "string" ? this.url = (0, rpcclient_1$a.hasProtocol)(n) ? n : "http://" + n : (this.url = n.url, this.headers = n.headers);
  }
  disconnect() {
  }
  async execute(n) {
    const o = (0, json_rpc_1$a.parseJsonRpcResponse)(await (0, http_1$6.http)("POST", this.url, this.headers, n));
    if ((0, json_rpc_1$a.isJsonRpcErrorResponse)(o))
      throw new Error(JSON.stringify(o.error));
    return o;
  }
};
httpclient$3.HttpClient = HttpClient$3;
var websocketclient$3 = {}, build$z = {}, queueingstreamingsocket$3 = {}, streamingsocket$3 = {}, socketwrapper$3 = {}, ws = null;
typeof WebSocket < "u" ? ws = WebSocket : typeof MozWebSocket < "u" ? ws = MozWebSocket : typeof commonjsGlobal < "u" ? ws = commonjsGlobal.WebSocket || commonjsGlobal.MozWebSocket : typeof window < "u" ? ws = window.WebSocket || window.MozWebSocket : typeof self < "u" && (ws = self.WebSocket || self.MozWebSocket);
var browser$1 = ws, __importDefault$z = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(socketwrapper$3, "__esModule", { value: !0 });
socketwrapper$3.SocketWrapper = void 0;
const isomorphic_ws_1$3 = __importDefault$z(browser$1);
function environmentIsNodeJs$3() {
  return typeof browser$1$1 < "u" && typeof browser$1$1.versions < "u" && typeof browser$1$1.versions.node < "u";
}
let SocketWrapper$3 = class {
  constructor(n, o, u, c, d, m = 1e4) {
    this.closed = !1, this.connected = new Promise((v, S) => {
      this.connectedResolver = v, this.connectedRejecter = S;
    }), this.url = n, this.messageHandler = o, this.errorHandler = u, this.openHandler = c, this.closeHandler = d, this.timeout = m;
  }
  /**
   * returns a promise that resolves when connection is open
   */
  connect() {
    const n = new isomorphic_ws_1$3.default(this.url);
    n.onerror = (u) => {
      this.clearTimeout(), this.errorHandler && this.errorHandler(u);
    }, n.onmessage = (u) => {
      this.messageHandler({
        type: u.type,
        data: u.data
      });
    }, n.onopen = (u) => {
      this.clearTimeout(), this.connectedResolver(), this.openHandler && this.openHandler();
    }, n.onclose = (u) => {
      this.closed = !0, this.closeHandler && this.closeHandler(u);
    };
    const o = Date.now();
    this.timeoutId = setTimeout(() => {
      n.onmessage = () => 0, n.onerror = () => 0, n.onopen = () => 0, n.onclose = () => 0, n.close(), this.socket = void 0;
      const u = Math.floor(Date.now() - o);
      this.connectedRejecter(`Connection attempt timed out after ${u} ms`);
    }, this.timeout), this.socket = n;
  }
  /**
   * Closes an established connection and aborts other connection states
   */
  disconnect() {
    if (!this.socket)
      throw new Error("Socket undefined. This must be called after connecting.");
    switch (this.clearTimeout(), this.socket.readyState) {
      case isomorphic_ws_1$3.default.OPEN:
        this.socket.close(
          1e3
          /* Normal Closure */
        );
        break;
      case isomorphic_ws_1$3.default.CLOSED:
        break;
      case isomorphic_ws_1$3.default.CONNECTING:
        this.socket.onopen = () => 0, this.socket.onclose = () => 0, this.socket.onerror = () => 0, this.socket.onmessage = () => 0, this.socket = void 0, this.closeHandler && this.closeHandler({ wasClean: !1, code: 4001 });
        break;
      case isomorphic_ws_1$3.default.CLOSING:
        break;
      default:
        throw new Error(`Unknown readyState: ${this.socket.readyState}`);
    }
  }
  async send(n) {
    return new Promise((o, u) => {
      if (!this.socket)
        throw new Error("Socket undefined. This must be called after connecting.");
      if (this.closed)
        throw new Error("Socket was closed, so no data can be sent anymore.");
      if (this.socket.readyState !== isomorphic_ws_1$3.default.OPEN)
        throw new Error("Websocket is not open");
      environmentIsNodeJs$3() ? this.socket.send(n, (c) => c ? u(c) : o()) : (this.socket.send(n), o());
    });
  }
  /**
   * Clears the timeout function, such that no timeout error will be raised anymore. This should be
   * called when the connection is established, a connection error occurred or the socket is disconnected.
   *
   * This method must not be called before `connect()`.
   * This method is idempotent.
   */
  clearTimeout() {
    if (!this.timeoutId)
      throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
    clearTimeout(this.timeoutId);
  }
};
socketwrapper$3.SocketWrapper = SocketWrapper$3;
Object.defineProperty(streamingsocket$3, "__esModule", { value: !0 });
streamingsocket$3.StreamingSocket = void 0;
const xstream_1$q = xstream, socketwrapper_1$3 = socketwrapper$3;
let StreamingSocket$3 = class {
  constructor(n, o = 1e4) {
    this.socket = new socketwrapper_1$3.SocketWrapper(n, (c) => {
      this.eventProducerListener && this.eventProducerListener.next(c);
    }, (c) => {
      this.eventProducerListener && this.eventProducerListener.error(c);
    }, () => {
    }, (c) => {
      this.eventProducerListener && (c.wasClean ? this.eventProducerListener.complete() : this.eventProducerListener.error("Socket was closed unclean"));
    }, o), this.connected = this.socket.connected;
    const u = {
      start: (c) => this.eventProducerListener = c,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$q.Stream.create(u);
  }
  connect() {
    this.socket.connect();
  }
  disconnect() {
    this.socket.disconnect();
  }
  async send(n) {
    return this.socket.send(n);
  }
};
streamingsocket$3.StreamingSocket = StreamingSocket$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  const n = build$D, o = xstream, u = streamingsocket$3;
  var c;
  (function(m) {
    m[m.Unconnected = 0] = "Unconnected", m[m.Connecting = 1] = "Connecting", m[m.Connected = 2] = "Connected", m[m.Disconnected = 3] = "Disconnected";
  })(c = e.ConnectionStatus || (e.ConnectionStatus = {}));
  class d {
    constructor(v, S = 1e4, $) {
      this.queue = [], this.isProcessingQueue = !1, this.url = v, this.timeout = S, this.reconnectedHandler = $;
      const E = {
        start: (O) => this.eventProducerListener = O,
        stop: () => this.eventProducerListener = void 0
      };
      this.events = o.Stream.create(E), this.connectionStatusProducer = new n.DefaultValueProducer(c.Unconnected), this.connectionStatus = new n.ValueAndUpdates(this.connectionStatusProducer), this.socket = new u.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (O) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(O);
        },
        error: () => this.connectionStatusProducer.update(c.Disconnected)
      });
    }
    connect() {
      this.connectionStatusProducer.update(c.Connecting), this.socket.connected.then(async () => (this.connectionStatusProducer.update(c.Connected), this.processQueue()), () => this.connectionStatusProducer.update(c.Disconnected)), this.socket.connect();
    }
    disconnect() {
      this.connectionStatusProducer.update(c.Disconnected), this.socket.disconnect();
    }
    reconnect() {
      this.socket = new u.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (v) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(v);
        },
        error: () => this.connectionStatusProducer.update(c.Disconnected)
      }), this.socket.connected.then(() => {
        this.reconnectedHandler && this.reconnectedHandler();
      }), this.connect();
    }
    getQueueLength() {
      return this.queue.length;
    }
    queueRequest(v) {
      this.queue.push(v), this.processQueue();
    }
    async processQueue() {
      if (this.isProcessingQueue || this.connectionStatus.value !== c.Connected)
        return;
      this.isProcessingQueue = !0;
      let v;
      for (; v = this.queue.shift(); )
        try {
          await this.socket.send(v), this.isProcessingQueue = !1;
        } catch {
          this.queue.unshift(v), this.isProcessingQueue = !1;
          return;
        }
    }
  }
  e.QueueingStreamingSocket = d;
})(queueingstreamingsocket$3);
var reconnectingsocket$3 = {};
Object.defineProperty(reconnectingsocket$3, "__esModule", { value: !0 });
reconnectingsocket$3.ReconnectingSocket = void 0;
const xstream_1$p = xstream, queueingstreamingsocket_1$3 = queueingstreamingsocket$3;
let ReconnectingSocket$3 = class Wc {
  /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */
  static calculateTimeout(n) {
    return Math.min(2 ** n * 100, 5e3);
  }
  constructor(n, o = 1e4, u) {
    this.unconnected = !0, this.disconnected = !1, this.timeoutIndex = 0, this.reconnectTimeout = null;
    const c = {
      start: (d) => this.eventProducerListener = d,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$p.Stream.create(c), this.socket = new queueingstreamingsocket_1$3.QueueingStreamingSocket(n, o, u), this.socket.events.subscribe({
      next: (d) => {
        this.eventProducerListener && this.eventProducerListener.next(d);
      },
      error: (d) => {
        this.eventProducerListener && this.eventProducerListener.error(d);
      }
    }), this.connectionStatus = this.socket.connectionStatus, this.connectionStatus.updates.subscribe({
      next: (d) => {
        d === queueingstreamingsocket_1$3.ConnectionStatus.Connected && (this.timeoutIndex = 0), d === queueingstreamingsocket_1$3.ConnectionStatus.Disconnected && (this.reconnectTimeout && (clearTimeout(this.reconnectTimeout), this.reconnectTimeout = null), this.reconnectTimeout = setTimeout(() => this.socket.reconnect(), Wc.calculateTimeout(this.timeoutIndex++)));
      }
    });
  }
  connect() {
    if (!this.unconnected)
      throw new Error("Cannot connect: socket has already connected");
    this.socket.connect(), this.unconnected = !1;
  }
  disconnect() {
    if (this.unconnected)
      throw new Error("Cannot disconnect: socket has not yet connected");
    this.socket.disconnect(), this.eventProducerListener && this.eventProducerListener.complete(), this.disconnected = !0;
  }
  queueRequest(n) {
    if (this.disconnected)
      throw new Error("Cannot queue request: socket has disconnected");
    this.socket.queueRequest(n);
  }
};
reconnectingsocket$3.ReconnectingSocket = ReconnectingSocket$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.StreamingSocket = e.SocketWrapper = e.ReconnectingSocket = e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  var n = queueingstreamingsocket$3;
  Object.defineProperty(e, "ConnectionStatus", { enumerable: !0, get: function() {
    return n.ConnectionStatus;
  } }), Object.defineProperty(e, "QueueingStreamingSocket", { enumerable: !0, get: function() {
    return n.QueueingStreamingSocket;
  } });
  var o = reconnectingsocket$3;
  Object.defineProperty(e, "ReconnectingSocket", { enumerable: !0, get: function() {
    return o.ReconnectingSocket;
  } });
  var u = socketwrapper$3;
  Object.defineProperty(e, "SocketWrapper", { enumerable: !0, get: function() {
    return u.SocketWrapper;
  } });
  var c = streamingsocket$3;
  Object.defineProperty(e, "StreamingSocket", { enumerable: !0, get: function() {
    return c.StreamingSocket;
  } });
})(build$z);
Object.defineProperty(websocketclient$3, "__esModule", { value: !0 });
websocketclient$3.WebsocketClient = void 0;
const json_rpc_1$9 = build$A, socket_1$3 = build$z, stream_1$7 = build$D, xstream_1$o = xstream, rpcclient_1$9 = rpcclient$3;
function defaultErrorHandler$3(e) {
  throw e;
}
function toJsonRpcResponse$3(e) {
  if (e.type !== "message")
    throw new Error(`Unexcepted message type on websocket: ${e.type}`);
  return (0, json_rpc_1$9.parseJsonRpcResponse)(JSON.parse(e.data));
}
let RpcEventProducer$3 = class {
  constructor(n, o) {
    this.running = !1, this.subscriptions = [], this.request = n, this.socket = o;
  }
  /**
   * Implementation of Producer.start
   */
  start(n) {
    if (this.running)
      throw Error("Already started. Please stop first before restarting.");
    this.running = !0, this.connectToClient(n), this.socket.queueRequest(JSON.stringify(this.request));
  }
  /**
   * Implementation of Producer.stop
   *
   * Called by the stream when the stream's last listener stopped listening
   * or when the producer completed.
   */
  stop() {
    this.running = !1;
    const n = { ...this.request, method: "unsubscribe" };
    try {
      this.socket.queueRequest(JSON.stringify(n));
    } catch (o) {
      if (!(o instanceof Error && o.message.match(/socket has disconnected/i)))
        throw o;
    }
  }
  connectToClient(n) {
    const o = this.socket.events.map(toJsonRpcResponse$3), u = o.filter((m) => m.id === this.request.id).subscribe({
      next: (m) => {
        (0, json_rpc_1$9.isJsonRpcErrorResponse)(m) && (this.closeSubscriptions(), n.error(JSON.stringify(m.error))), u.unsubscribe();
      }
    }), c = o.filter((m) => m.id === this.request.id).subscribe({
      next: (m) => {
        (0, json_rpc_1$9.isJsonRpcErrorResponse)(m) ? (this.closeSubscriptions(), n.error(JSON.stringify(m.error))) : n.next(m.result);
      }
    }), d = o.subscribe({
      error: (m) => {
        this.closeSubscriptions(), n.error(m);
      },
      complete: () => {
        this.closeSubscriptions(), n.complete();
      }
    });
    this.subscriptions.push(u, c, d);
  }
  closeSubscriptions() {
    for (const n of this.subscriptions)
      n.unsubscribe();
    this.subscriptions = [];
  }
}, WebsocketClient$3 = class {
  constructor(n, o = defaultErrorHandler$3) {
    this.subscriptionStreams = /* @__PURE__ */ new Map();
    const u = n.endsWith("/") ? "websocket" : "/websocket", c = (0, rpcclient_1$9.hasProtocol)(n) ? n : "ws://" + n;
    this.url = c + u, this.socket = new socket_1$3.ReconnectingSocket(this.url);
    const d = this.socket.events.subscribe({
      error: (m) => {
        o(m), d.unsubscribe();
      }
    });
    this.jsonRpcResponseStream = this.socket.events.map(toJsonRpcResponse$3), this.socket.connect();
  }
  async execute(n) {
    const o = this.responseForRequestId(n.id);
    this.socket.queueRequest(JSON.stringify(n));
    const u = await o;
    if ((0, json_rpc_1$9.isJsonRpcErrorResponse)(u))
      throw new Error(JSON.stringify(u.error));
    return u;
  }
  listen(n) {
    if (n.method !== "subscribe")
      throw new Error('Request method must be "subscribe" to start event listening');
    const o = n.params.query;
    if (typeof o != "string")
      throw new Error("request.params.query must be a string");
    if (!this.subscriptionStreams.has(o)) {
      const u = new RpcEventProducer$3(n, this.socket), c = xstream_1$o.Stream.create(u);
      this.subscriptionStreams.set(o, c);
    }
    return this.subscriptionStreams.get(o).filter((u) => u.query !== void 0);
  }
  /**
   * Resolves as soon as websocket is connected. execute() queues requests automatically,
   * so this should be required for testing purposes only.
   */
  async connected() {
    await this.socket.connectionStatus.waitFor(socket_1$3.ConnectionStatus.Connected);
  }
  disconnect() {
    this.socket.disconnect();
  }
  async responseForRequestId(n) {
    return (0, stream_1$7.firstEvent)(this.jsonRpcResponseStream.filter((o) => o.id === n));
  }
};
websocketclient$3.WebsocketClient = WebsocketClient$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.WebsocketClient = e.instanceOfRpcStreamingClient = e.HttpClient = e.HttpBatchClient = void 0;
  var n = httpbatchclient$3;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return n.HttpBatchClient;
  } });
  var o = httpclient$3;
  Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return o.HttpClient;
  } });
  var u = rpcclient$3;
  Object.defineProperty(e, "instanceOfRpcStreamingClient", { enumerable: !0, get: function() {
    return u.instanceOfRpcStreamingClient;
  } });
  var c = websocketclient$3;
  Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return c.WebsocketClient;
  } });
})(rpcclients$3);
var adaptor$9 = {}, requests$D = {}, inthelpers$3 = {}, encodings$9 = {};
Object.defineProperty(encodings$9, "__esModule", { value: !0 });
encodings$9.encodeBlockId = encodings$9.encodeVersion = encodings$9.encodeBytes = encodings$9.encodeTime = encodings$9.encodeUvarint = encodings$9.encodeString = encodings$9.dictionaryToStringMap = encodings$9.may = encodings$9.assertNotEmpty = encodings$9.assertObject = encodings$9.assertArray = encodings$9.assertNumber = encodings$9.assertString = encodings$9.assertBoolean = encodings$9.assertSet = void 0;
const encoding_1$13 = build$F;
function assertSet$9(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$9.assertSet = assertSet$9;
function assertBoolean$9(e) {
  if (assertSet$9(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$9.assertBoolean = assertBoolean$9;
function assertString$9(e) {
  if (assertSet$9(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$9.assertString = assertString$9;
function assertNumber$9(e) {
  if (assertSet$9(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$9.assertNumber = assertNumber$9;
function assertArray$9(e) {
  if (assertSet$9(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$9.assertArray = assertArray$9;
function assertObject$9(e) {
  if (assertSet$9(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$9.assertObject = assertObject$9;
function assertNotEmpty$9(e) {
  if (assertSet$9(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$9.assertNotEmpty = assertNotEmpty$9;
function may$9(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$9.may = may$9;
function dictionaryToStringMap$9(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$9.dictionaryToStringMap = dictionaryToStringMap$9;
function encodeString$9(e) {
  const n = (0, encoding_1$13.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$9.encodeString = encodeString$9;
function encodeUvarint$a(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$a(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$9.encodeUvarint = encodeUvarint$a;
function encodeTime$9(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$a(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$a(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$9.encodeTime = encodeTime$9;
function encodeBytes$9(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$9.encodeBytes = encodeBytes$9;
function encodeVersion$9(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$a(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$a(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$9.encodeVersion = encodeVersion$9;
function encodeBlockId$9(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$9.encodeBlockId = encodeBlockId$9;
Object.defineProperty(inthelpers$3, "__esModule", { value: !0 });
inthelpers$3.smallIntToApi = inthelpers$3.apiToBigInt = inthelpers$3.apiToSmallInt = void 0;
const math_1$m = build$R, encodings_1$x = encodings$9;
function apiToSmallInt$3(e) {
  return (typeof e == "number" ? new math_1$m.Int53(e) : math_1$m.Int53.fromString(e)).toNumber();
}
inthelpers$3.apiToSmallInt = apiToSmallInt$3;
function apiToBigInt$3(e) {
  if ((0, encodings_1$x.assertString)(e), !e.match(/^-?[0-9]+$/))
    throw new Error("Invalid string format");
  return BigInt(e);
}
inthelpers$3.apiToBigInt = apiToBigInt$3;
function smallIntToApi$3(e) {
  return new math_1$m.Int53(e).toString();
}
inthelpers$3.smallIntToApi = smallIntToApi$3;
var encodings$8 = {};
Object.defineProperty(encodings$8, "__esModule", { value: !0 });
encodings$8.encodeBlockId = encodings$8.encodeVersion = encodings$8.encodeBytes = encodings$8.encodeTime = encodings$8.encodeUvarint = encodings$8.encodeString = encodings$8.dictionaryToStringMap = encodings$8.may = encodings$8.assertNotEmpty = encodings$8.assertObject = encodings$8.assertArray = encodings$8.assertNumber = encodings$8.assertString = encodings$8.assertBoolean = encodings$8.assertSet = void 0;
const encoding_1$12 = build$F;
function assertSet$8(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$8.assertSet = assertSet$8;
function assertBoolean$8(e) {
  if (assertSet$8(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$8.assertBoolean = assertBoolean$8;
function assertString$8(e) {
  if (assertSet$8(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$8.assertString = assertString$8;
function assertNumber$8(e) {
  if (assertSet$8(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$8.assertNumber = assertNumber$8;
function assertArray$8(e) {
  if (assertSet$8(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$8.assertArray = assertArray$8;
function assertObject$8(e) {
  if (assertSet$8(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$8.assertObject = assertObject$8;
function assertNotEmpty$8(e) {
  if (assertSet$8(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$8.assertNotEmpty = assertNotEmpty$8;
function may$8(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$8.may = may$8;
function dictionaryToStringMap$8(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$8.dictionaryToStringMap = dictionaryToStringMap$8;
function encodeString$8(e) {
  const n = (0, encoding_1$12.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$8.encodeString = encodeString$8;
function encodeUvarint$9(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$9(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$8.encodeUvarint = encodeUvarint$9;
function encodeTime$8(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$9(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$9(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$8.encodeTime = encodeTime$8;
function encodeBytes$8(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$8.encodeBytes = encodeBytes$8;
function encodeVersion$8(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$9(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$9(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$8.encodeVersion = encodeVersion$8;
function encodeBlockId$8(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$8.encodeBlockId = encodeBlockId$8;
var requests$C = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$C);
var __createBinding$K = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$K = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$K = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$K(n, e, o);
  return __setModuleDefault$K(n, e), n;
};
Object.defineProperty(requests$D, "__esModule", { value: !0 });
requests$D.Params = void 0;
const encoding_1$11 = build$F, inthelpers_1$j = inthelpers$3, jsonrpc_1$j = jsonrpc$3, encodings_1$w = encodings$8, requests$B = __importStar$K(requests$C);
function encodeHeightParam$9(e) {
  return {
    height: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$9(e) {
  return {
    minHeight: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$9(e) {
  return {
    query: e.query,
    page: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.page),
    per_page: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$9(e) {
  return {
    path: (0, encodings_1$w.assertNotEmpty)(e.path),
    data: (0, encoding_1$11.toHex)(e.data),
    height: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$9(e) {
  return {
    tx: (0, encoding_1$11.toBase64)((0, encodings_1$w.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$9(e) {
  return {
    hash: (0, encoding_1$11.toBase64)((0, encodings_1$w.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$9(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.page),
    per_page: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$9(e) {
  return {
    height: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.height),
    page: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.page),
    per_page: (0, encodings_1$w.may)(inthelpers_1$j.smallIntToApi, e.per_page)
  };
}
let Params$w = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeAbciQueryParams$9(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeHeightParam$9(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$9(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeHeightParam$9(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeBlockSearchParams$9(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$9(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeHeightParam$9(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$B.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$j.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeTxParams$9(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeTxSearchParams$9(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$j.createJsonRpcRequest)(n.method, encodeValidatorsParams$9(n.params));
  }
};
requests$D.Params = Params$w;
var responses$j = {}, types$a = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = void 0, function(n) {
    n[n.Unknown = 0] = "Unknown", n[n.Absent = 1] = "Absent", n[n.Commit = 2] = "Commit", n[n.Nil = 3] = "Nil", n[n.Unrecognized = -1] = "Unrecognized";
  }(e.BlockIdFlag || (e.BlockIdFlag = {}));
})(types$a);
var hasher$9 = {};
Object.defineProperty(hasher$9, "__esModule", { value: !0 });
hasher$9.hashBlock = hasher$9.hashTx = void 0;
const crypto_1$m = build$B, encodings_1$v = encodings$8;
function hashTx$9(e) {
  return (0, crypto_1$m.sha256)(e);
}
hasher$9.hashTx = hashTx$9;
function getSplitPoint$9(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$9(e) {
  const n = new crypto_1$m.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$9(e, n) {
  const o = new crypto_1$m.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$9(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$9(e[0]);
    default: {
      const n = getSplitPoint$9(e.length), o = hashTree$9(e.slice(0, n)), u = hashTree$9(e.slice(n));
      return hashInner$9(o, u);
    }
  }
}
function hashBlock$9(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$v.encodeVersion)(e.version),
    (0, encodings_1$v.encodeString)(e.chainId),
    (0, encodings_1$v.encodeUvarint)(e.height),
    (0, encodings_1$v.encodeTime)(e.time),
    (0, encodings_1$v.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$v.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$v.encodeBytes)(e.dataHash),
    (0, encodings_1$v.encodeBytes)(e.validatorsHash),
    (0, encodings_1$v.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$v.encodeBytes)(e.consensusHash),
    (0, encodings_1$v.encodeBytes)(e.appHash),
    (0, encodings_1$v.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$v.encodeBytes)(e.evidenceHash),
    (0, encodings_1$v.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$9(n);
}
hasher$9.hashBlock = hashBlock$9;
Object.defineProperty(responses$j, "__esModule", { value: !0 });
responses$j.Responses = responses$j.decodeValidatorInfo = responses$j.decodeValidatorGenesis = responses$j.decodeValidatorUpdate = responses$j.decodeEvent = void 0;
const encoding_1$10 = build$F, utils_1$L = build$G, dates_1$9 = dates$3, inthelpers_1$i = inthelpers$3, types_1$e = types$a, encodings_1$u = encodings$8, hasher_1$a = hasher$9;
function decodeAbciInfo$9(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$u.may)(inthelpers_1$i.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$u.may)(encoding_1$10.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$9(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$10.fromBase64)(n.key),
      data: (0, encoding_1$10.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$9(e) {
  return {
    key: (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertString)(e.key ?? "")),
    value: (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertString)(e.value ?? "")),
    proof: (0, encodings_1$u.may)(decodeQueryProof$9, e.proofOps),
    height: (0, encodings_1$u.may)(inthelpers_1$i.apiToSmallInt, e.height),
    code: (0, encodings_1$u.may)(inthelpers_1$i.apiToSmallInt, e.code),
    codespace: (0, encodings_1$u.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$u.may)(inthelpers_1$i.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$u.assertString)(e.info ?? "")
  };
}
function decodeEventAttribute$5(e) {
  return {
    key: (0, encodings_1$u.assertNotEmpty)(e.key),
    value: e.value ?? ""
  };
}
function decodeAttributes$9(e) {
  return (0, encodings_1$u.assertArray)(e).map(decodeEventAttribute$5);
}
function decodeEvent$9(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$9(e.attributes) : []
  };
}
responses$j.decodeEvent = decodeEvent$9;
function decodeEvents$9(e) {
  return (0, encodings_1$u.assertArray)(e).map(decodeEvent$9);
}
function decodeTxData$9(e) {
  return {
    code: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$u.may)(encoding_1$10.fromBase64, e.data),
    events: e.events ? decodeEvents$9(e.events) : [],
    gasWanted: (0, inthelpers_1$i.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$i.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$a(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$L.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$9(e) {
  return {
    maxBytes: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$9(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$9(e) {
  return {
    block: decodeBlockParams$9((0, encodings_1$u.assertObject)(e.block)),
    evidence: decodeEvidenceParams$9((0, encodings_1$u.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$9(e) {
  return {
    pubkey: decodePubkey$a((0, encodings_1$u.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$i.apiToBigInt)(e.power ?? "0")
  };
}
responses$j.decodeValidatorUpdate = decodeValidatorUpdate$9;
function decodeBlockResults$9(e) {
  return {
    height: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$9),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$9),
    consensusUpdates: (0, encodings_1$u.may)(decodeConsensusParams$9, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$9(e.begin_block_events || []),
    endBlockEvents: decodeEvents$9(e.end_block_events || [])
  };
}
function decodeBlockId$9(e) {
  return {
    hash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$u.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$9(e) {
  return {
    block: (0, inthelpers_1$i.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$i.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$9(e) {
  return {
    version: decodeBlockVersion$9(e.version),
    chainId: (0, encodings_1$u.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.height)),
    time: (0, dates_1$9.fromRfc3339WithNanoseconds)((0, encodings_1$u.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$9(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$9(e) {
  return {
    blockId: decodeBlockId$9(e.block_id),
    blockSize: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.block_size)),
    header: decodeHeader$9(e.header),
    numTxs: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$9(e) {
  return {
    lastHeight: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$u.assertArray)(e.block_metas).map(decodeBlockMeta$9)
  };
}
function decodeBroadcastTxSync$9(e) {
  return {
    ...decodeTxData$9(e),
    hash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$9(e) {
  const n = e.tx_result ? decodeTxData$9(e.tx_result) : void 0;
  return {
    height: (0, inthelpers_1$i.apiToSmallInt)(e.height),
    hash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$9((0, encodings_1$u.assertObject)(e.check_tx)),
    deliverTx: n,
    txResult: n
  };
}
function decodeBlockIdFlag$9(e) {
  return (0, utils_1$L.assert)(e in types_1$e.BlockIdFlag), e;
}
function decodeOptionalTime$6(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1$9.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature$9(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$9(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$10.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime$6(e.timestamp),
    signature: e.signature ? (0, encoding_1$10.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$9(e) {
  return {
    blockId: decodeBlockId$9((0, encodings_1$u.assertObject)(e.block_id)),
    height: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$i.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$u.assertArray)(e.signatures).map(decodeCommitSignature$9)
  };
}
function decodeCommitResponse$9(e) {
  return {
    canonical: (0, encodings_1$u.assertBoolean)(e.canonical),
    header: decodeHeader$9(e.signed_header.header),
    commit: decodeCommit$9(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$9(e) {
  return {
    address: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$a((0, encodings_1$u.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$i.apiToBigInt)((0, encodings_1$u.assertNotEmpty)(e.power))
  };
}
responses$j.decodeValidatorGenesis = decodeValidatorGenesis$9;
function decodeGenesis$9(e) {
  return {
    genesisTime: (0, dates_1$9.fromRfc3339WithNanoseconds)((0, encodings_1$u.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$u.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$9(e.consensus_params),
    validators: e.validators ? (0, encodings_1$u.assertArray)(e.validators).map(decodeValidatorGenesis$9) : [],
    appHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$9(e) {
  return {
    pubkey: decodePubkey$a((0, encodings_1$u.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$i.apiToBigInt)((0, encodings_1$u.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$i.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$j.decodeValidatorInfo = decodeValidatorInfo$9;
function decodeNodeInfo$9(e) {
  return {
    id: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$u.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$u.assertNotEmpty)(e.network),
    version: (0, encodings_1$u.assertString)(e.version),
    channels: (0, encodings_1$u.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$u.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$u.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$9(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$i.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$9.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$10.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$10.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$9.fromRfc3339WithNanoseconds)((0, encodings_1$u.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$u.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$9(e) {
  return {
    nodeInfo: decodeNodeInfo$9(e.node_info),
    syncInfo: decodeSyncInfo$9(e.sync_info),
    validatorInfo: decodeValidatorInfo$9(e.validator_info)
  };
}
function decodeTxProof$9(e) {
  return {
    data: (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$u.assertArray)(e.proof.aunts).map(encoding_1$10.fromBase64)
    }
  };
}
function decodeTxResponse$9(e) {
  return {
    tx: (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertNotEmpty)(e.tx)),
    result: decodeTxData$9((0, encodings_1$u.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNumber)(e.index)),
    hash: (0, encoding_1$10.fromHex)((0, encodings_1$u.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$u.may)(decodeTxProof$9, e.proof)
  };
}
function decodeTxSearch$9(e) {
  return {
    totalCount: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$u.assertArray)(e.txs).map(decodeTxResponse$9)
  };
}
function decodeTxEvent$9(e) {
  const n = (0, encoding_1$10.fromBase64)((0, encodings_1$u.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$a.hashTx)(n),
    result: decodeTxData$9(e.result),
    height: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.height))
  };
}
function decodeValidators$9(e) {
  return {
    blockHeight: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$u.assertArray)(e.validators).map(decodeValidatorInfo$9),
    count: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.total))
  };
}
function decodeBlock$9(e) {
  var n;
  return {
    header: decodeHeader$9((0, encodings_1$u.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$9((0, encodings_1$u.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$u.assertArray)(e.data.txs).map(encoding_1$10.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$9(e) {
  return {
    blockId: decodeBlockId$9(e.block_id),
    block: decodeBlock$9(e.block)
  };
}
function decodeBlockSearch$9(e) {
  return {
    totalCount: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$u.assertArray)(e.blocks).map(decodeBlockResponse$9)
  };
}
function decodeNumUnconfirmedTxs$9(e) {
  return {
    total: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$i.apiToSmallInt)((0, encodings_1$u.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$9 = class zc {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$9((0, encodings_1$u.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$9((0, encodings_1$u.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$9(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$9(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$9(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$9(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$9(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return zc.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$9(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$9(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$9((0, encodings_1$u.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$9(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$9(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$9(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$9(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$9(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$9(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$9(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$9(n.result);
  }
};
responses$j.Responses = Responses$9;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$D;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$j;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$9);
var __createBinding$J = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$J = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$J = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$J(n, e, o);
  return __setModuleDefault$J(n, e), n;
};
Object.defineProperty(comet38client$2, "__esModule", { value: !0 });
comet38client$2.Comet38Client = void 0;
const jsonrpc_1$i = jsonrpc$3, rpcclients_1$9 = rpcclients$3, adaptor_1$9 = adaptor$9, requests$A = __importStar$J(requests$C);
let Comet38Client$2 = class Hu {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$9.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$9.HttpClient(n) : new rpcclients_1$9.WebsocketClient(n), await this.detectVersion(o), Hu.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new Hu(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$i.createJsonRpcRequest)(requests$A.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$A.Method.AbciInfo };
    return this.doCall(n, adaptor_1$9.Params.encodeAbciInfo, adaptor_1$9.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$A.Method.AbciQuery };
    return this.doCall(o, adaptor_1$9.Params.encodeAbciQuery, adaptor_1$9.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$A.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$9.Params.encodeBlock, adaptor_1$9.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$A.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$9.Params.encodeBlockResults, adaptor_1$9.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$A.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$9.Params.encodeBlockSearch, adaptor_1$9.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$A.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$9.Params.encodeBlockchain, adaptor_1$9.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$A.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$9.Params.encodeBroadcastTx, adaptor_1$9.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$A.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$9.Params.encodeBroadcastTx, adaptor_1$9.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$A.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$9.Params.encodeBroadcastTx, adaptor_1$9.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$A.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$9.Params.encodeCommit, adaptor_1$9.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$A.Method.Genesis };
    return this.doCall(n, adaptor_1$9.Params.encodeGenesis, adaptor_1$9.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$A.Method.Health };
    return this.doCall(n, adaptor_1$9.Params.encodeHealth, adaptor_1$9.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$A.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$9.Params.encodeNumUnconfirmedTxs, adaptor_1$9.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$A.Method.Status };
    return this.doCall(n, adaptor_1$9.Params.encodeStatus, adaptor_1$9.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$A.Method.Subscribe,
      query: { type: requests$A.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$9.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$A.Method.Subscribe,
      query: { type: requests$A.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$9.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$A.Method.Subscribe,
      query: {
        type: requests$A.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$9.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$A.Method.Tx };
    return this.doCall(o, adaptor_1$9.Params.encodeTx, adaptor_1$9.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$A.Method.TxSearch };
    return this.doCall(o, adaptor_1$9.Params.encodeTxSearch, adaptor_1$9.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$A.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$9.Params.encodeValidators, adaptor_1$9.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$9.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$9.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
};
comet38client$2.Comet38Client = Comet38Client$2;
var responses$i = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$i);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = e.Comet38Client = void 0;
  var n = comet38client$2;
  Object.defineProperty(e, "Comet38Client", { enumerable: !0, get: function() {
    return n.Comet38Client;
  } });
  var o = requests$C;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return o.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return o.SubscriptionEventType;
  } });
  var u = responses$i;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return u.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return u.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return u.VoteType;
  } });
})(comet38$2);
var tendermint34$3 = {}, requests$z = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$z);
var responses$h = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$h);
var tendermint34client$3 = {}, adaptor$8 = {}, requests$y = {}, __createBinding$I = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$I = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$I = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$I(n, e, o);
  return __setModuleDefault$I(n, e), n;
};
Object.defineProperty(requests$y, "__esModule", { value: !0 });
requests$y.Params = void 0;
const encoding_1$$ = build$F, inthelpers_1$h = inthelpers$3, jsonrpc_1$h = jsonrpc$3, encodings_1$t = encodings$9, requests$x = __importStar$I(requests$z);
function encodeHeightParam$8(e) {
  return {
    height: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$8(e) {
  return {
    minHeight: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$8(e) {
  return {
    query: e.query,
    page: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.page),
    per_page: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$8(e) {
  return {
    path: (0, encodings_1$t.assertNotEmpty)(e.path),
    data: (0, encoding_1$$.toHex)(e.data),
    height: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$8(e) {
  return {
    tx: (0, encoding_1$$.toBase64)((0, encodings_1$t.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$8(e) {
  return {
    hash: (0, encoding_1$$.toBase64)((0, encodings_1$t.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$8(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.page),
    per_page: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$8(e) {
  return {
    height: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.height),
    page: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.page),
    per_page: (0, encodings_1$t.may)(inthelpers_1$h.smallIntToApi, e.per_page)
  };
}
let Params$v = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeAbciQueryParams$8(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeHeightParam$8(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$8(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeHeightParam$8(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeBlockSearchParams$8(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$8(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeHeightParam$8(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$x.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$h.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeTxParams$8(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeTxSearchParams$8(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$h.createJsonRpcRequest)(n.method, encodeValidatorsParams$8(n.params));
  }
};
requests$y.Params = Params$v;
var responses$g = {}, hasher$8 = {};
Object.defineProperty(hasher$8, "__esModule", { value: !0 });
hasher$8.hashBlock = hasher$8.hashTx = void 0;
const crypto_1$l = build$B, encodings_1$s = encodings$9;
function hashTx$8(e) {
  return (0, crypto_1$l.sha256)(e);
}
hasher$8.hashTx = hashTx$8;
function getSplitPoint$8(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$8(e) {
  const n = new crypto_1$l.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$8(e, n) {
  const o = new crypto_1$l.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$8(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$8(e[0]);
    default: {
      const n = getSplitPoint$8(e.length), o = hashTree$8(e.slice(0, n)), u = hashTree$8(e.slice(n));
      return hashInner$8(o, u);
    }
  }
}
function hashBlock$8(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$s.encodeVersion)(e.version),
    (0, encodings_1$s.encodeString)(e.chainId),
    (0, encodings_1$s.encodeUvarint)(e.height),
    (0, encodings_1$s.encodeTime)(e.time),
    (0, encodings_1$s.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$s.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$s.encodeBytes)(e.dataHash),
    (0, encodings_1$s.encodeBytes)(e.validatorsHash),
    (0, encodings_1$s.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$s.encodeBytes)(e.consensusHash),
    (0, encodings_1$s.encodeBytes)(e.appHash),
    (0, encodings_1$s.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$s.encodeBytes)(e.evidenceHash),
    (0, encodings_1$s.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$8(n);
}
hasher$8.hashBlock = hashBlock$8;
Object.defineProperty(responses$g, "__esModule", { value: !0 });
responses$g.Responses = responses$g.decodeValidatorInfo = responses$g.decodeValidatorGenesis = responses$g.decodeValidatorUpdate = responses$g.decodeEvent = void 0;
const encoding_1$_ = build$F, utils_1$K = build$G, dates_1$8 = dates$3, inthelpers_1$g = inthelpers$3, types_1$d = types$a, encodings_1$r = encodings$9, hasher_1$9 = hasher$8;
function decodeAbciInfo$8(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$r.may)(inthelpers_1$g.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$r.may)(encoding_1$_.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$8(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$_.fromBase64)(n.key),
      data: (0, encoding_1$_.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$8(e) {
  return {
    key: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertString)(e.key ?? "")),
    value: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertString)(e.value ?? "")),
    proof: (0, encodings_1$r.may)(decodeQueryProof$8, e.proofOps),
    height: (0, encodings_1$r.may)(inthelpers_1$g.apiToSmallInt, e.height),
    code: (0, encodings_1$r.may)(inthelpers_1$g.apiToSmallInt, e.code),
    codespace: (0, encodings_1$r.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$r.may)(inthelpers_1$g.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$r.assertString)(e.info ?? "")
  };
}
function decodeAttribute$3(e) {
  return {
    key: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertNotEmpty)(e.key)),
    value: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertString)(e.value ?? ""))
  };
}
function decodeAttributes$8(e) {
  return (0, encodings_1$r.assertArray)(e).map(decodeAttribute$3);
}
function decodeEvent$8(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$8(e.attributes) : []
  };
}
responses$g.decodeEvent = decodeEvent$8;
function decodeEvents$8(e) {
  return (0, encodings_1$r.assertArray)(e).map(decodeEvent$8);
}
function decodeTxData$8(e) {
  return {
    code: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$r.may)(encoding_1$_.fromBase64, e.data),
    events: e.events ? decodeEvents$8(e.events) : [],
    gasWanted: (0, inthelpers_1$g.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$g.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$9(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$K.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$8(e) {
  return {
    maxBytes: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$8(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$8(e) {
  return {
    block: decodeBlockParams$8((0, encodings_1$r.assertObject)(e.block)),
    evidence: decodeEvidenceParams$8((0, encodings_1$r.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$8(e) {
  return {
    pubkey: decodePubkey$9((0, encodings_1$r.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$g.apiToBigInt)(e.power ?? "0")
  };
}
responses$g.decodeValidatorUpdate = decodeValidatorUpdate$8;
function decodeBlockResults$8(e) {
  return {
    height: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$8),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$8),
    consensusUpdates: (0, encodings_1$r.may)(decodeConsensusParams$8, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$8(e.begin_block_events || []),
    endBlockEvents: decodeEvents$8(e.end_block_events || [])
  };
}
function decodeBlockId$8(e) {
  return {
    hash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$r.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$8(e) {
  return {
    block: (0, inthelpers_1$g.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$g.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$8(e) {
  return {
    version: decodeBlockVersion$8(e.version),
    chainId: (0, encodings_1$r.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.height)),
    time: (0, dates_1$8.fromRfc3339WithNanoseconds)((0, encodings_1$r.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$8(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$8(e) {
  return {
    blockId: decodeBlockId$8(e.block_id),
    blockSize: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.block_size)),
    header: decodeHeader$8(e.header),
    numTxs: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$8(e) {
  return {
    lastHeight: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$r.assertArray)(e.block_metas).map(decodeBlockMeta$8)
  };
}
function decodeBroadcastTxSync$8(e) {
  return {
    ...decodeTxData$8(e),
    hash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$8(e) {
  return {
    height: (0, inthelpers_1$g.apiToSmallInt)(e.height),
    hash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$8((0, encodings_1$r.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1$r.may)(decodeTxData$8, e.deliver_tx)
  };
}
function decodeBlockIdFlag$8(e) {
  return (0, utils_1$K.assert)(e in types_1$d.BlockIdFlag), e;
}
function decodeOptionalTime$5(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1$8.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature$8(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$8(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$_.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime$5(e.timestamp),
    signature: e.signature ? (0, encoding_1$_.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$8(e) {
  return {
    blockId: decodeBlockId$8((0, encodings_1$r.assertObject)(e.block_id)),
    height: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$g.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$r.assertArray)(e.signatures).map(decodeCommitSignature$8)
  };
}
function decodeCommitResponse$8(e) {
  return {
    canonical: (0, encodings_1$r.assertBoolean)(e.canonical),
    header: decodeHeader$8(e.signed_header.header),
    commit: decodeCommit$8(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$8(e) {
  return {
    address: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$9((0, encodings_1$r.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$g.apiToBigInt)((0, encodings_1$r.assertNotEmpty)(e.power))
  };
}
responses$g.decodeValidatorGenesis = decodeValidatorGenesis$8;
function decodeGenesis$8(e) {
  return {
    genesisTime: (0, dates_1$8.fromRfc3339WithNanoseconds)((0, encodings_1$r.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$r.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$8(e.consensus_params),
    validators: e.validators ? (0, encodings_1$r.assertArray)(e.validators).map(decodeValidatorGenesis$8) : [],
    appHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$8(e) {
  return {
    pubkey: decodePubkey$9((0, encodings_1$r.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$g.apiToBigInt)((0, encodings_1$r.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$g.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$g.decodeValidatorInfo = decodeValidatorInfo$8;
function decodeNodeInfo$8(e) {
  return {
    id: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$r.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$r.assertNotEmpty)(e.network),
    version: (0, encodings_1$r.assertString)(e.version),
    channels: (0, encodings_1$r.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$r.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$r.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$8(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$g.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$8.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$_.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$_.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$8.fromRfc3339WithNanoseconds)((0, encodings_1$r.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$r.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$8(e) {
  return {
    nodeInfo: decodeNodeInfo$8(e.node_info),
    syncInfo: decodeSyncInfo$8(e.sync_info),
    validatorInfo: decodeValidatorInfo$8(e.validator_info)
  };
}
function decodeTxProof$8(e) {
  return {
    data: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$r.assertArray)(e.proof.aunts).map(encoding_1$_.fromBase64)
    }
  };
}
function decodeTxResponse$8(e) {
  return {
    tx: (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertNotEmpty)(e.tx)),
    result: decodeTxData$8((0, encodings_1$r.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNumber)(e.index)),
    hash: (0, encoding_1$_.fromHex)((0, encodings_1$r.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$r.may)(decodeTxProof$8, e.proof)
  };
}
function decodeTxSearch$8(e) {
  return {
    totalCount: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$r.assertArray)(e.txs).map(decodeTxResponse$8)
  };
}
function decodeTxEvent$8(e) {
  const n = (0, encoding_1$_.fromBase64)((0, encodings_1$r.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$9.hashTx)(n),
    result: decodeTxData$8(e.result),
    height: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.height))
  };
}
function decodeValidators$8(e) {
  return {
    blockHeight: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$r.assertArray)(e.validators).map(decodeValidatorInfo$8),
    count: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.total))
  };
}
function decodeBlock$8(e) {
  var n;
  return {
    header: decodeHeader$8((0, encodings_1$r.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$8((0, encodings_1$r.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$r.assertArray)(e.data.txs).map(encoding_1$_.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$8(e) {
  return {
    blockId: decodeBlockId$8(e.block_id),
    block: decodeBlock$8(e.block)
  };
}
function decodeBlockSearch$8(e) {
  return {
    totalCount: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$r.assertArray)(e.blocks).map(decodeBlockResponse$8)
  };
}
function decodeNumUnconfirmedTxs$8(e) {
  return {
    total: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$g.apiToSmallInt)((0, encodings_1$r.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$8 = class Kc {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$8((0, encodings_1$r.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$8((0, encodings_1$r.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$8(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$8(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$8(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$8(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$8(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return Kc.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$8(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$8(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$8((0, encodings_1$r.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$8(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$8(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$8(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$8(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$8(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$8(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$8(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$8(n.result);
  }
};
responses$g.Responses = Responses$8;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$y;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$g;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$8);
var __createBinding$H = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$H = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$H = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$H(n, e, o);
  return __setModuleDefault$H(n, e), n;
};
Object.defineProperty(tendermint34client$3, "__esModule", { value: !0 });
tendermint34client$3.Tendermint34Client = void 0;
const jsonrpc_1$g = jsonrpc$3, rpcclients_1$8 = rpcclients$3, adaptor_1$8 = adaptor$8, requests$w = __importStar$H(requests$z);
let Tendermint34Client$3 = class Gu {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$8.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$8.HttpClient(n) : new rpcclients_1$8.WebsocketClient(n), await this.detectVersion(o), Gu.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new Gu(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$g.createJsonRpcRequest)(requests$w.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$w.Method.AbciInfo };
    return this.doCall(n, adaptor_1$8.Params.encodeAbciInfo, adaptor_1$8.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$w.Method.AbciQuery };
    return this.doCall(o, adaptor_1$8.Params.encodeAbciQuery, adaptor_1$8.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$w.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$8.Params.encodeBlock, adaptor_1$8.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$w.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$8.Params.encodeBlockResults, adaptor_1$8.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$w.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$8.Params.encodeBlockSearch, adaptor_1$8.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$w.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$8.Params.encodeBlockchain, adaptor_1$8.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$w.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$8.Params.encodeBroadcastTx, adaptor_1$8.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$w.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$8.Params.encodeBroadcastTx, adaptor_1$8.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$w.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$8.Params.encodeBroadcastTx, adaptor_1$8.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$w.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$8.Params.encodeCommit, adaptor_1$8.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$w.Method.Genesis };
    return this.doCall(n, adaptor_1$8.Params.encodeGenesis, adaptor_1$8.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$w.Method.Health };
    return this.doCall(n, adaptor_1$8.Params.encodeHealth, adaptor_1$8.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$w.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$8.Params.encodeNumUnconfirmedTxs, adaptor_1$8.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$w.Method.Status };
    return this.doCall(n, adaptor_1$8.Params.encodeStatus, adaptor_1$8.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$w.Method.Subscribe,
      query: { type: requests$w.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$8.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$w.Method.Subscribe,
      query: { type: requests$w.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$8.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$w.Method.Subscribe,
      query: {
        type: requests$w.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$8.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$w.Method.Tx };
    return this.doCall(o, adaptor_1$8.Params.encodeTx, adaptor_1$8.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$w.Method.TxSearch };
    return this.doCall(o, adaptor_1$8.Params.encodeTxSearch, adaptor_1$8.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$w.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$8.Params.encodeValidators, adaptor_1$8.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$8.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$8.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
};
tendermint34client$3.Tendermint34Client = Tendermint34Client$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint34Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var n = requests$z;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return n.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return n.SubscriptionEventType;
  } });
  var o = responses$h;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return o.VoteType;
  } });
  var u = tendermint34client$3;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return u.Tendermint34Client;
  } });
})(tendermint34$3);
var tendermint37$2 = {}, requests$v = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$v);
var responses$f = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$f);
var tendermint37client$2 = {}, adaptor$7 = {}, requests$u = {}, encodings$7 = {};
Object.defineProperty(encodings$7, "__esModule", { value: !0 });
encodings$7.encodeBlockId = encodings$7.encodeVersion = encodings$7.encodeBytes = encodings$7.encodeTime = encodings$7.encodeUvarint = encodings$7.encodeString = encodings$7.dictionaryToStringMap = encodings$7.may = encodings$7.assertNotEmpty = encodings$7.assertObject = encodings$7.assertArray = encodings$7.assertNumber = encodings$7.assertString = encodings$7.assertBoolean = encodings$7.assertSet = void 0;
const encoding_1$Z = build$F;
function assertSet$7(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$7.assertSet = assertSet$7;
function assertBoolean$7(e) {
  if (assertSet$7(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$7.assertBoolean = assertBoolean$7;
function assertString$7(e) {
  if (assertSet$7(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$7.assertString = assertString$7;
function assertNumber$7(e) {
  if (assertSet$7(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$7.assertNumber = assertNumber$7;
function assertArray$7(e) {
  if (assertSet$7(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$7.assertArray = assertArray$7;
function assertObject$7(e) {
  if (assertSet$7(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$7.assertObject = assertObject$7;
function assertNotEmpty$7(e) {
  if (assertSet$7(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$7.assertNotEmpty = assertNotEmpty$7;
function may$7(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$7.may = may$7;
function dictionaryToStringMap$7(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$7.dictionaryToStringMap = dictionaryToStringMap$7;
function encodeString$7(e) {
  const n = (0, encoding_1$Z.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$7.encodeString = encodeString$7;
function encodeUvarint$8(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$8(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$7.encodeUvarint = encodeUvarint$8;
function encodeTime$7(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$8(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$8(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$7.encodeTime = encodeTime$7;
function encodeBytes$7(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$7.encodeBytes = encodeBytes$7;
function encodeVersion$7(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$8(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$8(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$7.encodeVersion = encodeVersion$7;
function encodeBlockId$7(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$7.encodeBlockId = encodeBlockId$7;
var __createBinding$G = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$G = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$G = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$G(n, e, o);
  return __setModuleDefault$G(n, e), n;
};
Object.defineProperty(requests$u, "__esModule", { value: !0 });
requests$u.Params = void 0;
const encoding_1$Y = build$F, inthelpers_1$f = inthelpers$3, jsonrpc_1$f = jsonrpc$3, encodings_1$q = encodings$7, requests$t = __importStar$G(requests$v);
function encodeHeightParam$7(e) {
  return {
    height: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$7(e) {
  return {
    minHeight: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$7(e) {
  return {
    query: e.query,
    page: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.page),
    per_page: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$7(e) {
  return {
    path: (0, encodings_1$q.assertNotEmpty)(e.path),
    data: (0, encoding_1$Y.toHex)(e.data),
    height: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$7(e) {
  return {
    tx: (0, encoding_1$Y.toBase64)((0, encodings_1$q.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$7(e) {
  return {
    hash: (0, encoding_1$Y.toBase64)((0, encodings_1$q.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$7(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.page),
    per_page: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$7(e) {
  return {
    height: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.height),
    page: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.page),
    per_page: (0, encodings_1$q.may)(inthelpers_1$f.smallIntToApi, e.per_page)
  };
}
let Params$u = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeAbciQueryParams$7(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeHeightParam$7(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$7(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeHeightParam$7(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeBlockSearchParams$7(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$7(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeHeightParam$7(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$t.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$f.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeTxParams$7(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeTxSearchParams$7(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$f.createJsonRpcRequest)(n.method, encodeValidatorsParams$7(n.params));
  }
};
requests$u.Params = Params$u;
var responses$e = {}, hasher$7 = {};
Object.defineProperty(hasher$7, "__esModule", { value: !0 });
hasher$7.hashBlock = hasher$7.hashTx = void 0;
const crypto_1$k = build$B, encodings_1$p = encodings$7;
function hashTx$7(e) {
  return (0, crypto_1$k.sha256)(e);
}
hasher$7.hashTx = hashTx$7;
function getSplitPoint$7(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$7(e) {
  const n = new crypto_1$k.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$7(e, n) {
  const o = new crypto_1$k.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$7(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$7(e[0]);
    default: {
      const n = getSplitPoint$7(e.length), o = hashTree$7(e.slice(0, n)), u = hashTree$7(e.slice(n));
      return hashInner$7(o, u);
    }
  }
}
function hashBlock$7(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$p.encodeVersion)(e.version),
    (0, encodings_1$p.encodeString)(e.chainId),
    (0, encodings_1$p.encodeUvarint)(e.height),
    (0, encodings_1$p.encodeTime)(e.time),
    (0, encodings_1$p.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$p.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$p.encodeBytes)(e.dataHash),
    (0, encodings_1$p.encodeBytes)(e.validatorsHash),
    (0, encodings_1$p.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$p.encodeBytes)(e.consensusHash),
    (0, encodings_1$p.encodeBytes)(e.appHash),
    (0, encodings_1$p.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$p.encodeBytes)(e.evidenceHash),
    (0, encodings_1$p.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$7(n);
}
hasher$7.hashBlock = hashBlock$7;
Object.defineProperty(responses$e, "__esModule", { value: !0 });
responses$e.Responses = responses$e.decodeValidatorInfo = responses$e.decodeValidatorGenesis = responses$e.decodeValidatorUpdate = responses$e.decodeEvent = void 0;
const encoding_1$X = build$F, utils_1$J = build$G, dates_1$7 = dates$3, inthelpers_1$e = inthelpers$3, types_1$c = types$a, encodings_1$o = encodings$7, hasher_1$8 = hasher$7;
function decodeAbciInfo$7(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$o.may)(inthelpers_1$e.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$o.may)(encoding_1$X.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$7(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$X.fromBase64)(n.key),
      data: (0, encoding_1$X.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$7(e) {
  return {
    key: (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertString)(e.key ?? "")),
    value: (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertString)(e.value ?? "")),
    proof: (0, encodings_1$o.may)(decodeQueryProof$7, e.proofOps),
    height: (0, encodings_1$o.may)(inthelpers_1$e.apiToSmallInt, e.height),
    code: (0, encodings_1$o.may)(inthelpers_1$e.apiToSmallInt, e.code),
    codespace: (0, encodings_1$o.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$o.may)(inthelpers_1$e.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$o.assertString)(e.info ?? "")
  };
}
function decodeEventAttribute$4(e) {
  return {
    key: (0, encodings_1$o.assertNotEmpty)(e.key),
    value: e.value ?? ""
  };
}
function decodeAttributes$7(e) {
  return (0, encodings_1$o.assertArray)(e).map(decodeEventAttribute$4);
}
function decodeEvent$7(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$7(e.attributes) : []
  };
}
responses$e.decodeEvent = decodeEvent$7;
function decodeEvents$7(e) {
  return (0, encodings_1$o.assertArray)(e).map(decodeEvent$7);
}
function decodeTxData$7(e) {
  return {
    code: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$o.may)(encoding_1$X.fromBase64, e.data),
    events: e.events ? decodeEvents$7(e.events) : [],
    gasWanted: (0, inthelpers_1$e.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$e.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$8(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$J.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$7(e) {
  return {
    maxBytes: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$7(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$7(e) {
  return {
    block: decodeBlockParams$7((0, encodings_1$o.assertObject)(e.block)),
    evidence: decodeEvidenceParams$7((0, encodings_1$o.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$7(e) {
  return {
    pubkey: decodePubkey$8((0, encodings_1$o.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$e.apiToBigInt)(e.power ?? "0")
  };
}
responses$e.decodeValidatorUpdate = decodeValidatorUpdate$7;
function decodeBlockResults$7(e) {
  return {
    height: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$7),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$7),
    consensusUpdates: (0, encodings_1$o.may)(decodeConsensusParams$7, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$7(e.begin_block_events || []),
    endBlockEvents: decodeEvents$7(e.end_block_events || [])
  };
}
function decodeBlockId$7(e) {
  return {
    hash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$o.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$7(e) {
  return {
    block: (0, inthelpers_1$e.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$e.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$7(e) {
  return {
    version: decodeBlockVersion$7(e.version),
    chainId: (0, encodings_1$o.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.height)),
    time: (0, dates_1$7.fromRfc3339WithNanoseconds)((0, encodings_1$o.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$7(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$7(e) {
  return {
    blockId: decodeBlockId$7(e.block_id),
    blockSize: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.block_size)),
    header: decodeHeader$7(e.header),
    numTxs: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$7(e) {
  return {
    lastHeight: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$o.assertArray)(e.block_metas).map(decodeBlockMeta$7)
  };
}
function decodeBroadcastTxSync$7(e) {
  return {
    ...decodeTxData$7(e),
    hash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$7(e) {
  return {
    height: (0, inthelpers_1$e.apiToSmallInt)(e.height),
    hash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$7((0, encodings_1$o.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1$o.may)(decodeTxData$7, e.deliver_tx)
  };
}
function decodeBlockIdFlag$7(e) {
  return (0, utils_1$J.assert)(e in types_1$c.BlockIdFlag), e;
}
function decodeOptionalTime$4(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1$7.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature$7(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$7(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$X.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime$4(e.timestamp),
    signature: e.signature ? (0, encoding_1$X.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$7(e) {
  return {
    blockId: decodeBlockId$7((0, encodings_1$o.assertObject)(e.block_id)),
    height: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$e.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$o.assertArray)(e.signatures).map(decodeCommitSignature$7)
  };
}
function decodeCommitResponse$7(e) {
  return {
    canonical: (0, encodings_1$o.assertBoolean)(e.canonical),
    header: decodeHeader$7(e.signed_header.header),
    commit: decodeCommit$7(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$7(e) {
  return {
    address: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$8((0, encodings_1$o.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$e.apiToBigInt)((0, encodings_1$o.assertNotEmpty)(e.power))
  };
}
responses$e.decodeValidatorGenesis = decodeValidatorGenesis$7;
function decodeGenesis$7(e) {
  return {
    genesisTime: (0, dates_1$7.fromRfc3339WithNanoseconds)((0, encodings_1$o.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$o.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$7(e.consensus_params),
    validators: e.validators ? (0, encodings_1$o.assertArray)(e.validators).map(decodeValidatorGenesis$7) : [],
    appHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$7(e) {
  return {
    pubkey: decodePubkey$8((0, encodings_1$o.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$e.apiToBigInt)((0, encodings_1$o.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$e.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$e.decodeValidatorInfo = decodeValidatorInfo$7;
function decodeNodeInfo$7(e) {
  return {
    id: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$o.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$o.assertNotEmpty)(e.network),
    version: (0, encodings_1$o.assertString)(e.version),
    channels: (0, encodings_1$o.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$o.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$o.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$7(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$e.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$7.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$X.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$X.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$7.fromRfc3339WithNanoseconds)((0, encodings_1$o.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$o.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$7(e) {
  return {
    nodeInfo: decodeNodeInfo$7(e.node_info),
    syncInfo: decodeSyncInfo$7(e.sync_info),
    validatorInfo: decodeValidatorInfo$7(e.validator_info)
  };
}
function decodeTxProof$7(e) {
  return {
    data: (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$o.assertArray)(e.proof.aunts).map(encoding_1$X.fromBase64)
    }
  };
}
function decodeTxResponse$7(e) {
  return {
    tx: (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertNotEmpty)(e.tx)),
    result: decodeTxData$7((0, encodings_1$o.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNumber)(e.index)),
    hash: (0, encoding_1$X.fromHex)((0, encodings_1$o.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$o.may)(decodeTxProof$7, e.proof)
  };
}
function decodeTxSearch$7(e) {
  return {
    totalCount: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$o.assertArray)(e.txs).map(decodeTxResponse$7)
  };
}
function decodeTxEvent$7(e) {
  const n = (0, encoding_1$X.fromBase64)((0, encodings_1$o.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$8.hashTx)(n),
    result: decodeTxData$7(e.result),
    height: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.height))
  };
}
function decodeValidators$7(e) {
  return {
    blockHeight: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$o.assertArray)(e.validators).map(decodeValidatorInfo$7),
    count: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.total))
  };
}
function decodeBlock$7(e) {
  var n;
  return {
    header: decodeHeader$7((0, encodings_1$o.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$7((0, encodings_1$o.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$o.assertArray)(e.data.txs).map(encoding_1$X.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$7(e) {
  return {
    blockId: decodeBlockId$7(e.block_id),
    block: decodeBlock$7(e.block)
  };
}
function decodeBlockSearch$7(e) {
  return {
    totalCount: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$o.assertArray)(e.blocks).map(decodeBlockResponse$7)
  };
}
function decodeNumUnconfirmedTxs$7(e) {
  return {
    total: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$e.apiToSmallInt)((0, encodings_1$o.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$7 = class Yc {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$7((0, encodings_1$o.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$7((0, encodings_1$o.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$7(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$7(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$7(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$7(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$7(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return Yc.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$7(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$7(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$7((0, encodings_1$o.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$7(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$7(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$7(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$7(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$7(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$7(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$7(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$7(n.result);
  }
};
responses$e.Responses = Responses$7;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$u;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$e;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$7);
var __createBinding$F = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$F = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$F = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$F(n, e, o);
  return __setModuleDefault$F(n, e), n;
};
Object.defineProperty(tendermint37client$2, "__esModule", { value: !0 });
tendermint37client$2.Tendermint37Client = void 0;
const jsonrpc_1$e = jsonrpc$3, rpcclients_1$7 = rpcclients$3, adaptor_1$7 = adaptor$7, requests$s = __importStar$F(requests$v);
let Tendermint37Client$2 = class Vu {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$7.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$7.HttpClient(n) : new rpcclients_1$7.WebsocketClient(n), await this.detectVersion(o), Vu.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new Vu(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$e.createJsonRpcRequest)(requests$s.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$s.Method.AbciInfo };
    return this.doCall(n, adaptor_1$7.Params.encodeAbciInfo, adaptor_1$7.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$s.Method.AbciQuery };
    return this.doCall(o, adaptor_1$7.Params.encodeAbciQuery, adaptor_1$7.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$s.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$7.Params.encodeBlock, adaptor_1$7.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$s.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$7.Params.encodeBlockResults, adaptor_1$7.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$s.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$7.Params.encodeBlockSearch, adaptor_1$7.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$s.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$7.Params.encodeBlockchain, adaptor_1$7.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$s.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$7.Params.encodeBroadcastTx, adaptor_1$7.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$s.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$7.Params.encodeBroadcastTx, adaptor_1$7.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$s.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$7.Params.encodeBroadcastTx, adaptor_1$7.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$s.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$7.Params.encodeCommit, adaptor_1$7.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$s.Method.Genesis };
    return this.doCall(n, adaptor_1$7.Params.encodeGenesis, adaptor_1$7.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$s.Method.Health };
    return this.doCall(n, adaptor_1$7.Params.encodeHealth, adaptor_1$7.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$s.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$7.Params.encodeNumUnconfirmedTxs, adaptor_1$7.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$s.Method.Status };
    return this.doCall(n, adaptor_1$7.Params.encodeStatus, adaptor_1$7.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$s.Method.Subscribe,
      query: { type: requests$s.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$7.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$s.Method.Subscribe,
      query: { type: requests$s.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$7.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$s.Method.Subscribe,
      query: {
        type: requests$s.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$7.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$s.Method.Tx };
    return this.doCall(o, adaptor_1$7.Params.encodeTx, adaptor_1$7.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$s.Method.TxSearch };
    return this.doCall(o, adaptor_1$7.Params.encodeTxSearch, adaptor_1$7.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$s.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$7.Params.encodeValidators, adaptor_1$7.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$7.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$7.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
};
tendermint37client$2.Tendermint37Client = Tendermint37Client$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint37Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var n = requests$v;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return n.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return n.SubscriptionEventType;
  } });
  var o = responses$f;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return o.VoteType;
  } });
  var u = tendermint37client$2;
  Object.defineProperty(e, "Tendermint37Client", { enumerable: !0, get: function() {
    return u.Tendermint37Client;
  } });
})(tendermint37$2);
var tendermintclient$2 = {};
Object.defineProperty(tendermintclient$2, "__esModule", { value: !0 });
tendermintclient$2.connectComet = tendermintclient$2.isComet38Client = tendermintclient$2.isTendermint37Client = tendermintclient$2.isTendermint34Client = void 0;
const comet38_1$2 = comet38$2, tendermint34_1$2 = tendermint34$3, tendermint37_1$2 = tendermint37$2;
function isTendermint34Client$2(e) {
  return e instanceof tendermint34_1$2.Tendermint34Client;
}
tendermintclient$2.isTendermint34Client = isTendermint34Client$2;
function isTendermint37Client$2(e) {
  return e instanceof tendermint37_1$2.Tendermint37Client;
}
tendermintclient$2.isTendermint37Client = isTendermint37Client$2;
function isComet38Client$2(e) {
  return e instanceof comet38_1$2.Comet38Client;
}
tendermintclient$2.isComet38Client = isComet38Client$2;
async function connectComet$2(e) {
  let n;
  const o = await tendermint37_1$2.Tendermint37Client.connect(e), u = (await o.status()).nodeInfo.version;
  return u.startsWith("0.37.") ? n = o : u.startsWith("0.38.") ? (o.disconnect(), n = await comet38_1$2.Comet38Client.connect(e)) : (o.disconnect(), n = await tendermint34_1$2.Tendermint34Client.connect(e)), n;
}
tendermintclient$2.connectComet = connectComet$2;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(y, V, M, G) {
    G === void 0 && (G = M);
    var k = Object.getOwnPropertyDescriptor(V, M);
    (!k || ("get" in k ? !V.__esModule : k.writable || k.configurable)) && (k = { enumerable: !0, get: function() {
      return V[M];
    } }), Object.defineProperty(y, G, k);
  } : function(y, V, M, G) {
    G === void 0 && (G = M), y[G] = V[M];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(y, V) {
    Object.defineProperty(y, "default", { enumerable: !0, value: V });
  } : function(y, V) {
    y.default = V;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(y) {
    if (y && y.__esModule)
      return y;
    var V = {};
    if (y != null)
      for (var M in y)
        M !== "default" && Object.prototype.hasOwnProperty.call(y, M) && n(V, y, M);
    return o(V, y), V;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = e.isTendermint37Client = e.isTendermint34Client = e.isComet38Client = e.connectComet = e.Tendermint37Client = e.tendermint37 = e.Tendermint34Client = e.tendermint34 = e.VoteType = e.SubscriptionEventType = e.Method = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.WebsocketClient = e.HttpClient = e.HttpBatchClient = e.Comet38Client = e.comet38 = e.toSeconds = e.toRfc3339WithNanoseconds = e.fromSeconds = e.fromRfc3339WithNanoseconds = e.DateTime = e.rawSecp256k1PubkeyToRawAddress = e.rawEd25519PubkeyToRawAddress = e.pubkeyToRawAddress = e.pubkeyToAddress = void 0;
  var c = addresses$4;
  Object.defineProperty(e, "pubkeyToAddress", { enumerable: !0, get: function() {
    return c.pubkeyToAddress;
  } }), Object.defineProperty(e, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.pubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.rawSecp256k1PubkeyToRawAddress;
  } });
  var d = dates$3;
  Object.defineProperty(e, "DateTime", { enumerable: !0, get: function() {
    return d.DateTime;
  } }), Object.defineProperty(e, "fromRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return d.fromRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "fromSeconds", { enumerable: !0, get: function() {
    return d.fromSeconds;
  } }), Object.defineProperty(e, "toRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return d.toRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "toSeconds", { enumerable: !0, get: function() {
    return d.toSeconds;
  } }), e.comet38 = u(comet38$2);
  var m = comet38$2;
  Object.defineProperty(e, "Comet38Client", { enumerable: !0, get: function() {
    return m.Comet38Client;
  } });
  var v = rpcclients$3;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return v.HttpBatchClient;
  } }), Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return v.HttpClient;
  } }), Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return v.WebsocketClient;
  } });
  var S = tendermint34$3;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return S.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return S.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return S.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return S.SubscriptionEventType;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return S.VoteType;
  } }), e.tendermint34 = u(tendermint34$3);
  var $ = tendermint34$3;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return $.Tendermint34Client;
  } }), e.tendermint37 = u(tendermint37$2);
  var E = tendermint37$2;
  Object.defineProperty(e, "Tendermint37Client", { enumerable: !0, get: function() {
    return E.Tendermint37Client;
  } });
  var O = tendermintclient$2;
  Object.defineProperty(e, "connectComet", { enumerable: !0, get: function() {
    return O.connectComet;
  } }), Object.defineProperty(e, "isComet38Client", { enumerable: !0, get: function() {
    return O.isComet38Client;
  } }), Object.defineProperty(e, "isTendermint34Client", { enumerable: !0, get: function() {
    return O.isTendermint34Client;
  } }), Object.defineProperty(e, "isTendermint37Client", { enumerable: !0, get: function() {
    return O.isTendermint37Client;
  } });
  var T = types$a;
  Object.defineProperty(e, "BlockIdFlag", { enumerable: !0, get: function() {
    return T.BlockIdFlag;
  } });
})(build$C);
var stargateclient$1 = {};
Object.defineProperty(stargateclient$1, "__esModule", { value: !0 });
stargateclient$1.StargateClient = stargateclient$1.BroadcastTxError = stargateclient$1.assertIsDeliverTxFailure = stargateclient$1.assertIsDeliverTxSuccess = stargateclient$1.isDeliverTxSuccess = stargateclient$1.isDeliverTxFailure = stargateclient$1.TimeoutError = void 0;
const amino_1$9 = build$P, encoding_1$W = build$F, math_1$l = build$R, tendermint_rpc_1$3 = build$C, utils_1$I = build$G, abci_1$1 = abci, accounts_1$1 = accounts$1, events_1$1 = events$1, modules_1$3 = modules$2, queryclient_1$d = queryclient$3, search_1$1 = search$1;
let TimeoutError$1 = class extends Error {
  constructor(n, o) {
    super(n), this.txId = o;
  }
};
stargateclient$1.TimeoutError = TimeoutError$1;
function isDeliverTxFailure$1(e) {
  return !!e.code;
}
stargateclient$1.isDeliverTxFailure = isDeliverTxFailure$1;
function isDeliverTxSuccess$1(e) {
  return !isDeliverTxFailure$1(e);
}
stargateclient$1.isDeliverTxSuccess = isDeliverTxSuccess$1;
function assertIsDeliverTxSuccess$1(e) {
  if (isDeliverTxFailure$1(e))
    throw new Error(`Error when broadcasting tx ${e.transactionHash} at height ${e.height}. Code: ${e.code}; Raw log: ${e.rawLog}`);
}
stargateclient$1.assertIsDeliverTxSuccess = assertIsDeliverTxSuccess$1;
function assertIsDeliverTxFailure$1(e) {
  if (isDeliverTxSuccess$1(e))
    throw new Error(`Transaction ${e.transactionHash} did not fail at height ${e.height}. Code: ${e.code}; Raw log: ${e.rawLog}`);
}
stargateclient$1.assertIsDeliverTxFailure = assertIsDeliverTxFailure$1;
let BroadcastTxError$1 = class extends Error {
  constructor(n, o, u) {
    super(`Broadcasting transaction failed with code ${n} (codespace: ${o}). Log: ${u}`), this.code = n, this.codespace = o, this.log = u;
  }
};
stargateclient$1.BroadcastTxError = BroadcastTxError$1;
let StargateClient$1 = class Ju {
  /**
   * Creates an instance by connecting to the given CometBFT RPC endpoint.
   *
   * This uses auto-detection to decide between a CometBFT 0.38, Tendermint 0.37 and 0.34 client.
   * To set the Comet client explicitly, use `create`.
   */
  static async connect(n, o = {}) {
    const u = await (0, tendermint_rpc_1$3.connectComet)(n);
    return Ju.create(u, o);
  }
  /**
   * Creates an instance from a manually created Comet client.
   * Use this to use `Comet38Client` or `Tendermint37Client` instead of `Tendermint34Client`.
   */
  static async create(n, o = {}) {
    return new Ju(n, o);
  }
  constructor(n, o) {
    n && (this.cometClient = n, this.queryClient = queryclient_1$d.QueryClient.withExtensions(n, modules_1$3.setupAuthExtension, modules_1$3.setupBankExtension, modules_1$3.setupStakingExtension, modules_1$3.setupTxExtension));
    const { accountParser: u = accounts_1$1.accountFromAny } = o;
    this.accountParser = u;
  }
  getCometClient() {
    return this.cometClient;
  }
  forceGetCometClient() {
    if (!this.cometClient)
      throw new Error("Comet client not available. You cannot use online functionality in offline mode.");
    return this.cometClient;
  }
  getQueryClient() {
    return this.queryClient;
  }
  forceGetQueryClient() {
    if (!this.queryClient)
      throw new Error("Query client not available. You cannot use online functionality in offline mode.");
    return this.queryClient;
  }
  async getChainId() {
    if (!this.chainId) {
      const o = (await this.forceGetCometClient().status()).nodeInfo.network;
      if (!o)
        throw new Error("Chain ID must not be empty");
      this.chainId = o;
    }
    return this.chainId;
  }
  async getHeight() {
    return (await this.forceGetCometClient().status()).syncInfo.latestBlockHeight;
  }
  async getAccount(n) {
    try {
      const o = await this.forceGetQueryClient().auth.account(n);
      return o ? this.accountParser(o) : null;
    } catch (o) {
      if (/rpc error: code = NotFound/i.test(o.toString()))
        return null;
      throw o;
    }
  }
  async getSequence(n) {
    const o = await this.getAccount(n);
    if (!o)
      throw new Error(`Account '${n}' does not exist on chain. Send some tokens there before trying to query sequence.`);
    return {
      accountNumber: o.accountNumber,
      sequence: o.sequence
    };
  }
  async getBlock(n) {
    const o = await this.forceGetCometClient().block(n);
    return {
      id: (0, encoding_1$W.toHex)(o.blockId.hash).toUpperCase(),
      header: {
        version: {
          block: new math_1$l.Uint53(o.block.header.version.block).toString(),
          app: new math_1$l.Uint53(o.block.header.version.app).toString()
        },
        height: o.block.header.height,
        chainId: o.block.header.chainId,
        time: (0, tendermint_rpc_1$3.toRfc3339WithNanoseconds)(o.block.header.time)
      },
      txs: o.block.txs
    };
  }
  async getBalance(n, o) {
    return this.forceGetQueryClient().bank.balance(n, o);
  }
  /**
   * Queries all balances for all denoms that belong to this address.
   *
   * Uses the grpc queries (which iterates over the store internally), and we cannot get
   * proofs from such a method.
   */
  async getAllBalances(n) {
    return this.forceGetQueryClient().bank.allBalances(n);
  }
  async getBalanceStaked(n) {
    const o = [];
    let u;
    do {
      const { delegationResponses: d, pagination: m } = await this.forceGetQueryClient().staking.delegatorDelegations(n, u), v = d || [];
      o.push(...v), u = m == null ? void 0 : m.nextKey;
    } while (u !== void 0 && u.length !== 0);
    return o.reduce((d, m) => ((0, utils_1$I.assert)(m.balance), d !== null ? (0, amino_1$9.addCoins)(d, m.balance) : m.balance), null);
  }
  async getDelegation(n, o) {
    var c;
    let u;
    try {
      u = (c = (await this.forceGetQueryClient().staking.delegation(n, o)).delegationResponse) == null ? void 0 : c.balance;
    } catch (d) {
      if (!d.toString().includes("key not found"))
        throw d;
    }
    return u || null;
  }
  async getTx(n) {
    return (await this.txsQuery(`tx.hash='${n}'`))[0] ?? null;
  }
  async searchTx(n) {
    let o;
    if (typeof n == "string")
      o = n;
    else if ((0, search_1$1.isSearchTxQueryArray)(n))
      o = n.map((u) => typeof u.value == "string" ? `${u.key}='${u.value}'` : `${u.key}=${u.value}`).join(" AND ");
    else
      throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
    return this.txsQuery(o);
  }
  disconnect() {
    this.cometClient && this.cometClient.disconnect();
  }
  /**
   * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
   *
   * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
   * usually needs to check for execution success or failure.
   */
  async broadcastTx(n, o = 6e4, u = 3e3) {
    let c = !1;
    const d = setTimeout(() => {
      c = !0;
    }, o), m = async (S) => {
      if (c)
        throw new TimeoutError$1(`Transaction with ID ${S} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${o / 1e3} seconds.`, S);
      await (0, utils_1$I.sleep)(u);
      const $ = await this.getTx(S);
      return $ ? {
        code: $.code,
        height: $.height,
        txIndex: $.txIndex,
        events: $.events,
        rawLog: $.rawLog,
        transactionHash: S,
        msgResponses: $.msgResponses,
        gasUsed: $.gasUsed,
        gasWanted: $.gasWanted
      } : m(S);
    }, v = await this.broadcastTxSync(n);
    return new Promise((S, $) => m(v).then((E) => {
      clearTimeout(d), S(E);
    }, (E) => {
      clearTimeout(d), $(E);
    }));
  }
  /**
   * Broadcasts a signed transaction to the network without monitoring it.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
   * usually needs to check if the transaction was included in a block and was successful.
   *
   * @returns Returns the hash of the transaction
   */
  async broadcastTxSync(n) {
    const o = await this.forceGetCometClient().broadcastTxSync({ tx: n });
    return o.code ? Promise.reject(new BroadcastTxError$1(o.code, o.codespace ?? "", o.log)) : (0, encoding_1$W.toHex)(o.hash).toUpperCase();
  }
  async txsQuery(n) {
    return (await this.forceGetCometClient().txSearchAll({ query: n })).txs.map((u) => {
      const c = abci_1$1.TxMsgData.decode(u.result.data ?? new Uint8Array());
      return {
        height: u.height,
        txIndex: u.index,
        hash: (0, encoding_1$W.toHex)(u.hash).toUpperCase(),
        code: u.result.code,
        events: u.result.events.map(events_1$1.fromTendermintEvent),
        rawLog: u.result.log || "",
        tx: u.tx,
        msgResponses: c.msgResponses,
        gasUsed: u.result.gasUsed,
        gasWanted: u.result.gasWanted
      };
    });
  }
};
stargateclient$1.StargateClient = StargateClient$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SigningStargateClient = e.createDefaultAminoConverters = e.defaultRegistryTypes = void 0;
  const n = build$P, o = build$F, u = build$R, c = build$Q, d = build$C, m = build$G, v = coin$8, S = tx$m, $ = tx$d, E = signing$3, O = tx$p, T = tx$h, y = aminotypes$1, V = fee$1, M = modules$2, G = modules$2, k = stargateclient$1;
  e.defaultRegistryTypes = [
    ["/cosmos.base.v1beta1.Coin", v.Coin],
    ...M.authzTypes,
    ...M.bankTypes,
    ...M.distributionTypes,
    ...M.feegrantTypes,
    ...M.govTypes,
    ...M.groupTypes,
    ...M.stakingTypes,
    ...M.ibcTypes,
    ...M.vestingTypes
  ];
  function F() {
    return {
      ...(0, G.createAuthzAminoConverters)(),
      ...(0, G.createBankAminoConverters)(),
      ...(0, G.createDistributionAminoConverters)(),
      ...(0, G.createGovAminoConverters)(),
      ...(0, G.createStakingAminoConverters)(),
      ...(0, G.createIbcAminoConverters)(),
      ...(0, G.createFeegrantAminoConverters)(),
      ...(0, G.createVestingAminoConverters)()
    };
  }
  e.createDefaultAminoConverters = F;
  class X extends k.StargateClient {
    /**
     * Creates an instance by connecting to the given CometBFT RPC endpoint.
     *
     * This uses auto-detection to decide between a CometBFT 0.38, Tendermint 0.37 and 0.34 client.
     * To set the Comet client explicitly, use `createWithSigner`.
     */
    static async connectWithSigner(ue, Q, Y = {}) {
      const pe = await (0, d.connectComet)(ue);
      return X.createWithSigner(pe, Q, Y);
    }
    /**
     * Creates an instance from a manually created Comet client.
     * Use this to use `Comet38Client` or `Tendermint37Client` instead of `Tendermint34Client`.
     */
    static async createWithSigner(ue, Q, Y = {}) {
      return new X(ue, Q, Y);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */
    static async offline(ue, Q = {}) {
      return new X(void 0, ue, Q);
    }
    constructor(ue, Q, Y) {
      super(ue, Y);
      const { registry: pe = new c.Registry(e.defaultRegistryTypes), aminoTypes: oe = new y.AminoTypes(F()) } = Y;
      this.registry = pe, this.aminoTypes = oe, this.signer = Q, this.broadcastTimeoutMs = Y.broadcastTimeoutMs, this.broadcastPollIntervalMs = Y.broadcastPollIntervalMs, this.gasPrice = Y.gasPrice;
    }
    async simulate(ue, Q, Y) {
      const pe = Q.map((w) => this.registry.encodeAsAny(w)), oe = (await this.signer.getAccounts()).find((w) => w.address === ue);
      if (!oe)
        throw new Error("Failed to retrieve account from signer");
      const ne = (0, n.encodeSecp256k1Pubkey)(oe.pubkey), { sequence: H } = await this.getSequence(ue), { gasInfo: C } = await this.forceGetQueryClient().tx.simulate(pe, Y, ne, H);
      return (0, m.assertDefined)(C), u.Uint53.fromString(C.gasUsed.toString()).toNumber();
    }
    async sendTokens(ue, Q, Y, pe, oe = "") {
      const ne = {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: {
          fromAddress: ue,
          toAddress: Q,
          amount: [...Y]
        }
      };
      return this.signAndBroadcast(ue, [ne], pe, oe);
    }
    async delegateTokens(ue, Q, Y, pe, oe = "") {
      const ne = {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: $.MsgDelegate.fromPartial({
          delegatorAddress: ue,
          validatorAddress: Q,
          amount: Y
        })
      };
      return this.signAndBroadcast(ue, [ne], pe, oe);
    }
    async undelegateTokens(ue, Q, Y, pe, oe = "") {
      const ne = {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: $.MsgUndelegate.fromPartial({
          delegatorAddress: ue,
          validatorAddress: Q,
          amount: Y
        })
      };
      return this.signAndBroadcast(ue, [ne], pe, oe);
    }
    async withdrawRewards(ue, Q, Y, pe = "") {
      const oe = {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: S.MsgWithdrawDelegatorReward.fromPartial({
          delegatorAddress: ue,
          validatorAddress: Q
        })
      };
      return this.signAndBroadcast(ue, [oe], Y, pe);
    }
    /**
     * @deprecated This API does not support setting the memo field of `MsgTransfer` (only the transaction memo).
     * We'll remove this method at some point because trying to wrap the various message types is a losing strategy.
     * Please migrate to `signAndBroadcast` with an `MsgTransferEncodeObject` created in the caller code instead.
     * @see https://github.com/cosmos/cosmjs/issues/1493
     */
    async sendIbcTokens(ue, Q, Y, pe, oe, ne, H, C, w = "") {
      const P = H ? BigInt(H) * BigInt(1e9) : void 0, J = {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: T.MsgTransfer.fromPartial({
          sourcePort: pe,
          sourceChannel: oe,
          sender: ue,
          receiver: Q,
          token: Y,
          timeoutHeight: ne,
          timeoutTimestamp: P
        })
      };
      return this.signAndBroadcast(ue, [J], C, w);
    }
    async signAndBroadcast(ue, Q, Y, pe = "", oe) {
      let ne;
      if (Y == "auto" || typeof Y == "number") {
        (0, m.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
        const w = await this.simulate(ue, Q, pe), P = typeof Y == "number" ? Y : 1.4;
        ne = (0, V.calculateFee)(Math.round(w * P), this.gasPrice);
      } else
        ne = Y;
      const H = await this.sign(ue, Q, ne, pe, void 0, oe), C = O.TxRaw.encode(H).finish();
      return this.broadcastTx(C, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     * @returns Returns the hash of the transaction
     */
    async signAndBroadcastSync(ue, Q, Y, pe = "", oe) {
      let ne;
      if (Y == "auto" || typeof Y == "number") {
        (0, m.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
        const w = await this.simulate(ue, Q, pe), P = typeof Y == "number" ? Y : 1.3;
        ne = (0, V.calculateFee)(Math.round(w * P), this.gasPrice);
      } else
        ne = Y;
      const H = await this.sign(ue, Q, ne, pe, void 0, oe), C = O.TxRaw.encode(H).finish();
      return this.broadcastTxSync(C);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */
    async sign(ue, Q, Y, pe, oe, ne) {
      let H;
      if (oe)
        H = oe;
      else {
        const { accountNumber: C, sequence: w } = await this.getSequence(ue), P = await this.getChainId();
        H = {
          accountNumber: C,
          sequence: w,
          chainId: P
        };
      }
      return (0, c.isOfflineDirectSigner)(this.signer) ? this.signDirect(ue, Q, Y, pe, H, ne) : this.signAmino(ue, Q, Y, pe, H, ne);
    }
    async signAmino(ue, Q, Y, pe, { accountNumber: oe, sequence: ne, chainId: H }, C) {
      (0, m.assert)(!(0, c.isOfflineDirectSigner)(this.signer));
      const w = (await this.signer.getAccounts()).find((ze) => ze.address === ue);
      if (!w)
        throw new Error("Failed to retrieve account from signer");
      const P = (0, c.encodePubkey)((0, n.encodeSecp256k1Pubkey)(w.pubkey)), J = E.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, se = Q.map((ze) => this.aminoTypes.toAmino(ze)), fe = (0, n.makeSignDoc)(se, Y, H, pe, oe, ne, C), { signature: N, signed: W } = await this.signer.signAmino(ue, fe), te = {
        typeUrl: "/cosmos.tx.v1beta1.TxBody",
        value: {
          messages: W.msgs.map((ze) => this.aminoTypes.fromAmino(ze)),
          memo: W.memo,
          timeoutHeight: C
        }
      }, ge = this.registry.encode(te), Pe = u.Int53.fromString(W.fee.gas).toNumber(), Ke = u.Int53.fromString(W.sequence).toNumber(), xe = (0, c.makeAuthInfoBytes)([{ pubkey: P, sequence: Ke }], W.fee.amount, Pe, W.fee.granter, W.fee.payer, J);
      return O.TxRaw.fromPartial({
        bodyBytes: ge,
        authInfoBytes: xe,
        signatures: [(0, o.fromBase64)(N.signature)]
      });
    }
    async signDirect(ue, Q, Y, pe, { accountNumber: oe, sequence: ne, chainId: H }, C) {
      (0, m.assert)((0, c.isOfflineDirectSigner)(this.signer));
      const w = (await this.signer.getAccounts()).find((ge) => ge.address === ue);
      if (!w)
        throw new Error("Failed to retrieve account from signer");
      const P = (0, c.encodePubkey)((0, n.encodeSecp256k1Pubkey)(w.pubkey)), J = {
        typeUrl: "/cosmos.tx.v1beta1.TxBody",
        value: {
          messages: Q,
          memo: pe,
          timeoutHeight: C
        }
      }, se = this.registry.encode(J), fe = u.Int53.fromString(Y.gas).toNumber(), N = (0, c.makeAuthInfoBytes)([{ pubkey: P, sequence: ne }], Y.amount, fe, Y.granter, Y.payer), W = (0, c.makeSignDoc)(se, N, H, oe), { signature: I, signed: te } = await this.signer.signDirect(ue, W);
      return O.TxRaw.fromPartial({
        bodyBytes: te.bodyBytes,
        authInfoBytes: te.authInfoBytes,
        signatures: [(0, o.fromBase64)(I.signature)]
      });
    }
  }
  e.SigningStargateClient = X;
})(signingstargateclient$1);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(M, G, k, F) {
    F === void 0 && (F = k);
    var X = Object.getOwnPropertyDescriptor(G, k);
    (!X || ("get" in X ? !G.__esModule : X.writable || X.configurable)) && (X = { enumerable: !0, get: function() {
      return G[k];
    } }), Object.defineProperty(M, F, X);
  } : function(M, G, k, F) {
    F === void 0 && (F = k), M[F] = G[k];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(M, G) {
    Object.defineProperty(M, "default", { enumerable: !0, value: G });
  } : function(M, G) {
    M.default = G;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(M) {
    if (M && M.__esModule)
      return M;
    var G = {};
    if (M != null)
      for (var k in M)
        k !== "default" && Object.prototype.hasOwnProperty.call(M, k) && n(G, M, k);
    return o(G, M), G;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isMsgWithdrawDelegatorRewardEncodeObject = e.isMsgVoteWeightedEncodeObject = e.isMsgVoteEncodeObject = e.isMsgUndelegateEncodeObject = e.isMsgTransferEncodeObject = e.isMsgSubmitProposalEncodeObject = e.isMsgSendEncodeObject = e.isMsgEditValidatorEncodeObject = e.isMsgDepositEncodeObject = e.isMsgDelegateEncodeObject = e.isMsgCreateValidatorEncodeObject = e.isMsgBeginRedelegateEncodeObject = e.isAminoMsgWithdrawValidatorCommission = e.isAminoMsgWithdrawDelegatorReward = e.isAminoMsgVoteWeighted = e.isAminoMsgVote = e.isAminoMsgVerifyInvariant = e.isAminoMsgUnjail = e.isAminoMsgUndelegate = e.isAminoMsgTransfer = e.isAminoMsgSubmitProposal = e.isAminoMsgSubmitEvidence = e.isAminoMsgSetWithdrawAddress = e.isAminoMsgSend = e.isAminoMsgMultiSend = e.isAminoMsgFundCommunityPool = e.isAminoMsgEditValidator = e.isAminoMsgDeposit = e.isAminoMsgDelegate = e.isAminoMsgCreateVestingAccount = e.isAminoMsgCreateValidator = e.isAminoMsgBeginRedelegate = e.createVestingAminoConverters = e.createStakingAminoConverters = e.createSlashingAminoConverters = e.createIbcAminoConverters = e.createGroupAminoConverters = e.createGovAminoConverters = e.createFeegrantAminoConverters = e.createEvidenceAminoConverters = e.createDistributionAminoConverters = e.createCrysisAminoConverters = e.createBankAminoConverters = e.createAuthzAminoConverters = e.logs = e.GasPrice = e.calculateFee = e.fromTendermintEvent = e.AminoTypes = e.accountFromAny = void 0, e.parseCoins = e.makeCosmoshubPath = e.coins = e.coin = e.TimeoutError = e.StargateClient = e.isDeliverTxSuccess = e.isDeliverTxFailure = e.BroadcastTxError = e.assertIsDeliverTxSuccess = e.assertIsDeliverTxFailure = e.SigningStargateClient = e.defaultRegistryTypes = e.createDefaultAminoConverters = e.isSearchTxQueryArray = e.QueryClient = e.decodeCosmosSdkDecFromProto = e.createProtobufRpcClient = e.createPagination = e.makeMultisignedTxBytes = e.makeMultisignedTx = e.setupTxExtension = e.setupStakingExtension = e.setupSlashingExtension = e.setupMintExtension = e.setupIbcExtension = e.setupGovExtension = e.setupFeegrantExtension = e.setupDistributionExtension = e.setupBankExtension = e.setupAuthzExtension = e.setupAuthExtension = void 0;
  var c = accounts$1;
  Object.defineProperty(e, "accountFromAny", { enumerable: !0, get: function() {
    return c.accountFromAny;
  } });
  var d = aminotypes$1;
  Object.defineProperty(e, "AminoTypes", { enumerable: !0, get: function() {
    return d.AminoTypes;
  } });
  var m = events$1;
  Object.defineProperty(e, "fromTendermintEvent", { enumerable: !0, get: function() {
    return m.fromTendermintEvent;
  } });
  var v = fee$1;
  Object.defineProperty(e, "calculateFee", { enumerable: !0, get: function() {
    return v.calculateFee;
  } }), Object.defineProperty(e, "GasPrice", { enumerable: !0, get: function() {
    return v.GasPrice;
  } }), e.logs = u(logs$1);
  var S = modules$2;
  Object.defineProperty(e, "createAuthzAminoConverters", { enumerable: !0, get: function() {
    return S.createAuthzAminoConverters;
  } }), Object.defineProperty(e, "createBankAminoConverters", { enumerable: !0, get: function() {
    return S.createBankAminoConverters;
  } }), Object.defineProperty(e, "createCrysisAminoConverters", { enumerable: !0, get: function() {
    return S.createCrysisAminoConverters;
  } }), Object.defineProperty(e, "createDistributionAminoConverters", { enumerable: !0, get: function() {
    return S.createDistributionAminoConverters;
  } }), Object.defineProperty(e, "createEvidenceAminoConverters", { enumerable: !0, get: function() {
    return S.createEvidenceAminoConverters;
  } }), Object.defineProperty(e, "createFeegrantAminoConverters", { enumerable: !0, get: function() {
    return S.createFeegrantAminoConverters;
  } }), Object.defineProperty(e, "createGovAminoConverters", { enumerable: !0, get: function() {
    return S.createGovAminoConverters;
  } }), Object.defineProperty(e, "createGroupAminoConverters", { enumerable: !0, get: function() {
    return S.createGroupAminoConverters;
  } }), Object.defineProperty(e, "createIbcAminoConverters", { enumerable: !0, get: function() {
    return S.createIbcAminoConverters;
  } }), Object.defineProperty(e, "createSlashingAminoConverters", { enumerable: !0, get: function() {
    return S.createSlashingAminoConverters;
  } }), Object.defineProperty(e, "createStakingAminoConverters", { enumerable: !0, get: function() {
    return S.createStakingAminoConverters;
  } }), Object.defineProperty(e, "createVestingAminoConverters", { enumerable: !0, get: function() {
    return S.createVestingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgBeginRedelegate", { enumerable: !0, get: function() {
    return S.isAminoMsgBeginRedelegate;
  } }), Object.defineProperty(e, "isAminoMsgCreateValidator", { enumerable: !0, get: function() {
    return S.isAminoMsgCreateValidator;
  } }), Object.defineProperty(e, "isAminoMsgCreateVestingAccount", { enumerable: !0, get: function() {
    return S.isAminoMsgCreateVestingAccount;
  } }), Object.defineProperty(e, "isAminoMsgDelegate", { enumerable: !0, get: function() {
    return S.isAminoMsgDelegate;
  } }), Object.defineProperty(e, "isAminoMsgDeposit", { enumerable: !0, get: function() {
    return S.isAminoMsgDeposit;
  } }), Object.defineProperty(e, "isAminoMsgEditValidator", { enumerable: !0, get: function() {
    return S.isAminoMsgEditValidator;
  } }), Object.defineProperty(e, "isAminoMsgFundCommunityPool", { enumerable: !0, get: function() {
    return S.isAminoMsgFundCommunityPool;
  } }), Object.defineProperty(e, "isAminoMsgMultiSend", { enumerable: !0, get: function() {
    return S.isAminoMsgMultiSend;
  } }), Object.defineProperty(e, "isAminoMsgSend", { enumerable: !0, get: function() {
    return S.isAminoMsgSend;
  } }), Object.defineProperty(e, "isAminoMsgSetWithdrawAddress", { enumerable: !0, get: function() {
    return S.isAminoMsgSetWithdrawAddress;
  } }), Object.defineProperty(e, "isAminoMsgSubmitEvidence", { enumerable: !0, get: function() {
    return S.isAminoMsgSubmitEvidence;
  } }), Object.defineProperty(e, "isAminoMsgSubmitProposal", { enumerable: !0, get: function() {
    return S.isAminoMsgSubmitProposal;
  } }), Object.defineProperty(e, "isAminoMsgTransfer", { enumerable: !0, get: function() {
    return S.isAminoMsgTransfer;
  } }), Object.defineProperty(e, "isAminoMsgUndelegate", { enumerable: !0, get: function() {
    return S.isAminoMsgUndelegate;
  } }), Object.defineProperty(e, "isAminoMsgUnjail", { enumerable: !0, get: function() {
    return S.isAminoMsgUnjail;
  } }), Object.defineProperty(e, "isAminoMsgVerifyInvariant", { enumerable: !0, get: function() {
    return S.isAminoMsgVerifyInvariant;
  } }), Object.defineProperty(e, "isAminoMsgVote", { enumerable: !0, get: function() {
    return S.isAminoMsgVote;
  } }), Object.defineProperty(e, "isAminoMsgVoteWeighted", { enumerable: !0, get: function() {
    return S.isAminoMsgVoteWeighted;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawDelegatorReward", { enumerable: !0, get: function() {
    return S.isAminoMsgWithdrawDelegatorReward;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawValidatorCommission", { enumerable: !0, get: function() {
    return S.isAminoMsgWithdrawValidatorCommission;
  } }), Object.defineProperty(e, "isMsgBeginRedelegateEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgBeginRedelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgCreateValidatorEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgCreateValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgDelegateEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgDelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgDepositEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgDepositEncodeObject;
  } }), Object.defineProperty(e, "isMsgEditValidatorEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgEditValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgSendEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgSendEncodeObject;
  } }), Object.defineProperty(e, "isMsgSubmitProposalEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgSubmitProposalEncodeObject;
  } }), Object.defineProperty(e, "isMsgTransferEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgTransferEncodeObject;
  } }), Object.defineProperty(e, "isMsgUndelegateEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgUndelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgVoteEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteWeightedEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgVoteWeightedEncodeObject;
  } }), Object.defineProperty(e, "isMsgWithdrawDelegatorRewardEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgWithdrawDelegatorRewardEncodeObject;
  } }), Object.defineProperty(e, "setupAuthExtension", { enumerable: !0, get: function() {
    return S.setupAuthExtension;
  } }), Object.defineProperty(e, "setupAuthzExtension", { enumerable: !0, get: function() {
    return S.setupAuthzExtension;
  } }), Object.defineProperty(e, "setupBankExtension", { enumerable: !0, get: function() {
    return S.setupBankExtension;
  } }), Object.defineProperty(e, "setupDistributionExtension", { enumerable: !0, get: function() {
    return S.setupDistributionExtension;
  } }), Object.defineProperty(e, "setupFeegrantExtension", { enumerable: !0, get: function() {
    return S.setupFeegrantExtension;
  } }), Object.defineProperty(e, "setupGovExtension", { enumerable: !0, get: function() {
    return S.setupGovExtension;
  } }), Object.defineProperty(e, "setupIbcExtension", { enumerable: !0, get: function() {
    return S.setupIbcExtension;
  } }), Object.defineProperty(e, "setupMintExtension", { enumerable: !0, get: function() {
    return S.setupMintExtension;
  } }), Object.defineProperty(e, "setupSlashingExtension", { enumerable: !0, get: function() {
    return S.setupSlashingExtension;
  } }), Object.defineProperty(e, "setupStakingExtension", { enumerable: !0, get: function() {
    return S.setupStakingExtension;
  } }), Object.defineProperty(e, "setupTxExtension", { enumerable: !0, get: function() {
    return S.setupTxExtension;
  } });
  var $ = multisignature$1;
  Object.defineProperty(e, "makeMultisignedTx", { enumerable: !0, get: function() {
    return $.makeMultisignedTx;
  } }), Object.defineProperty(e, "makeMultisignedTxBytes", { enumerable: !0, get: function() {
    return $.makeMultisignedTxBytes;
  } });
  var E = queryclient$3;
  Object.defineProperty(e, "createPagination", { enumerable: !0, get: function() {
    return E.createPagination;
  } }), Object.defineProperty(e, "createProtobufRpcClient", { enumerable: !0, get: function() {
    return E.createProtobufRpcClient;
  } }), Object.defineProperty(e, "decodeCosmosSdkDecFromProto", { enumerable: !0, get: function() {
    return E.decodeCosmosSdkDecFromProto;
  } }), Object.defineProperty(e, "QueryClient", { enumerable: !0, get: function() {
    return E.QueryClient;
  } });
  var O = search$1;
  Object.defineProperty(e, "isSearchTxQueryArray", { enumerable: !0, get: function() {
    return O.isSearchTxQueryArray;
  } });
  var T = signingstargateclient$1;
  Object.defineProperty(e, "createDefaultAminoConverters", { enumerable: !0, get: function() {
    return T.createDefaultAminoConverters;
  } }), Object.defineProperty(e, "defaultRegistryTypes", { enumerable: !0, get: function() {
    return T.defaultRegistryTypes;
  } }), Object.defineProperty(e, "SigningStargateClient", { enumerable: !0, get: function() {
    return T.SigningStargateClient;
  } });
  var y = stargateclient$1;
  Object.defineProperty(e, "assertIsDeliverTxFailure", { enumerable: !0, get: function() {
    return y.assertIsDeliverTxFailure;
  } }), Object.defineProperty(e, "assertIsDeliverTxSuccess", { enumerable: !0, get: function() {
    return y.assertIsDeliverTxSuccess;
  } }), Object.defineProperty(e, "BroadcastTxError", { enumerable: !0, get: function() {
    return y.BroadcastTxError;
  } }), Object.defineProperty(e, "isDeliverTxFailure", { enumerable: !0, get: function() {
    return y.isDeliverTxFailure;
  } }), Object.defineProperty(e, "isDeliverTxSuccess", { enumerable: !0, get: function() {
    return y.isDeliverTxSuccess;
  } }), Object.defineProperty(e, "StargateClient", { enumerable: !0, get: function() {
    return y.StargateClient;
  } }), Object.defineProperty(e, "TimeoutError", { enumerable: !0, get: function() {
    return y.TimeoutError;
  } });
  var V = build$Q;
  Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return V.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return V.coins;
  } }), Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return V.makeCosmoshubPath;
  } }), Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return V.parseCoins;
  } });
})(build$S);
var build$y = {}, addresses$3 = {}, build$x = {}, bip39$3 = {}, build$w = {}, ascii$3 = {};
Object.defineProperty(ascii$3, "__esModule", { value: !0 });
ascii$3.fromAscii = ascii$3.toAscii = void 0;
function toAscii$3(e) {
  const n = (o) => o.split("").map((u) => {
    const c = u.charCodeAt(0);
    if (c < 32 || c > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + c);
    return c;
  });
  return Uint8Array.from(n(e));
}
ascii$3.toAscii = toAscii$3;
function fromAscii$3(e) {
  return ((o) => o.map((u) => {
    if (u < 32 || u > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + u);
    return String.fromCharCode(u);
  }))(Array.from(e)).join("");
}
ascii$3.fromAscii = fromAscii$3;
var base64$3 = {}, __createBinding$E = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$E = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$E = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$E(n, e, o);
  return __setModuleDefault$E(n, e), n;
};
Object.defineProperty(base64$3, "__esModule", { value: !0 });
base64$3.fromBase64 = base64$3.toBase64 = void 0;
const base64js$3 = __importStar$E(base64Js);
function toBase64$3(e) {
  return base64js$3.fromByteArray(e);
}
base64$3.toBase64 = toBase64$3;
function fromBase64$3(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$3.toByteArray(e);
}
base64$3.fromBase64 = fromBase64$3;
var bech32$7 = {}, __createBinding$D = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$D = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$D = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$D(n, e, o);
  return __setModuleDefault$D(n, e), n;
};
Object.defineProperty(bech32$7, "__esModule", { value: !0 });
bech32$7.normalizeBech32 = bech32$7.fromBech32 = bech32$7.toBech32 = void 0;
const bech32$6 = __importStar$D(bech32$f);
function toBech32$3(e, n, o) {
  return bech32$6.encode(e, bech32$6.toWords(n), o);
}
bech32$7.toBech32 = toBech32$3;
function fromBech32$3(e, n = 1 / 0) {
  const o = bech32$6.decode(e, n);
  return {
    prefix: o.prefix,
    data: new Uint8Array(bech32$6.fromWords(o.words))
  };
}
bech32$7.fromBech32 = fromBech32$3;
function normalizeBech32$3(e) {
  const { prefix: n, data: o } = fromBech32$3(e);
  return toBech32$3(n, o);
}
bech32$7.normalizeBech32 = normalizeBech32$3;
var hex$3 = {};
Object.defineProperty(hex$3, "__esModule", { value: !0 });
hex$3.fromHex = hex$3.toHex = void 0;
function toHex$3(e) {
  let n = "";
  for (const o of e)
    n += ("0" + o.toString(16)).slice(-2);
  return n;
}
hex$3.toHex = toHex$3;
function fromHex$3(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let o = 0; o < n.length; o++) {
    const u = 2 * o, c = e.slice(u, u + 2);
    if (!c.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[o] = parseInt(c, 16);
  }
  return n;
}
hex$3.fromHex = fromHex$3;
var rfc3339$3 = {};
Object.defineProperty(rfc3339$3, "__esModule", { value: !0 });
rfc3339$3.toRfc3339 = rfc3339$3.fromRfc3339 = void 0;
const rfc3339Matcher$3 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$3(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function fromRfc3339$3(e) {
  const n = rfc3339Matcher$3.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const o = +n[1], u = +n[2], c = +n[3], d = +n[4], m = +n[5], v = +n[6], S = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let $, E, O;
  n[8] === "Z" ? ($ = 1, E = 0, O = 0) : ($ = n[8].substring(0, 1) === "-" ? -1 : 1, E = +n[8].substring(1, 3), O = +n[8].substring(4, 6));
  const T = $ * (E * 60 + O) * 60, y = /* @__PURE__ */ new Date();
  return y.setUTCFullYear(o, u - 1, c), y.setUTCHours(d, m, v, S), new Date(y.getTime() - T * 1e3);
}
rfc3339$3.fromRfc3339 = fromRfc3339$3;
function toRfc3339$3(e) {
  const n = e.getUTCFullYear(), o = padded$3(e.getUTCMonth() + 1), u = padded$3(e.getUTCDate()), c = padded$3(e.getUTCHours()), d = padded$3(e.getUTCMinutes()), m = padded$3(e.getUTCSeconds()), v = padded$3(e.getUTCMilliseconds(), 3);
  return `${n}-${o}-${u}T${c}:${d}:${m}.${v}Z`;
}
rfc3339$3.toRfc3339 = toRfc3339$3;
var utf8$3 = {};
Object.defineProperty(utf8$3, "__esModule", { value: !0 });
utf8$3.fromUtf8 = utf8$3.toUtf8 = void 0;
function toUtf8$3(e) {
  return new TextEncoder().encode(e);
}
utf8$3.toUtf8 = toUtf8$3;
function fromUtf8$3(e, n = !1) {
  const o = !n;
  return new TextDecoder("utf-8", { fatal: o }).decode(e);
}
utf8$3.fromUtf8 = fromUtf8$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = ascii$3;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var o = base64$3;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return o.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return o.toBase64;
  } });
  var u = bech32$7;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return u.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return u.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return u.toBech32;
  } });
  var c = hex$3;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return c.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return c.toHex;
  } });
  var d = rfc3339$3;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return d.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return d.toRfc3339;
  } });
  var m = utf8$3;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return m.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return m.toUtf8;
  } });
})(build$w);
var pbkdf2$3 = {}, build$v = {}, arrays$3 = {};
Object.defineProperty(arrays$3, "__esModule", { value: !0 });
arrays$3.arrayContentStartsWith = arrays$3.arrayContentEquals = void 0;
function arrayContentEquals$3(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$3.arrayContentEquals = arrayContentEquals$3;
function arrayContentStartsWith$3(e, n) {
  if (e.length < n.length)
    return !1;
  for (let o = 0; o < n.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$3.arrayContentStartsWith = arrayContentStartsWith$3;
var assert$b = {};
Object.defineProperty(assert$b, "__esModule", { value: !0 });
assert$b.assertDefinedAndNotNull = assert$b.assertDefined = assert$b.assert = void 0;
function assert$a(e, n) {
  if (!e)
    throw new Error(n || "condition is not truthy");
}
assert$b.assert = assert$a;
function assertDefined$3(e, n) {
  if (e === void 0)
    throw new Error(n ?? "value is undefined");
}
assert$b.assertDefined = assertDefined$3;
function assertDefinedAndNotNull$3(e, n) {
  if (e == null)
    throw new Error(n ?? "value is undefined or null");
}
assert$b.assertDefinedAndNotNull = assertDefinedAndNotNull$3;
var sleep$7 = {};
Object.defineProperty(sleep$7, "__esModule", { value: !0 });
sleep$7.sleep = void 0;
async function sleep$6(e) {
  return new Promise((n) => setTimeout(n, e));
}
sleep$7.sleep = sleep$6;
var typechecks$3 = {};
Object.defineProperty(typechecks$3, "__esModule", { value: !0 });
typechecks$3.isDefined = typechecks$3.isUint8Array = typechecks$3.isNonNullObject = void 0;
function isNonNullObject$3(e) {
  return typeof e == "object" && e !== null;
}
typechecks$3.isNonNullObject = isNonNullObject$3;
function isUint8Array$3(e) {
  return !(!isNonNullObject$3(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(e));
}
typechecks$3.isUint8Array = isUint8Array$3;
function isDefined$3(e) {
  return e !== void 0;
}
typechecks$3.isDefined = isDefined$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var n = arrays$3;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return n.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return n.arrayContentStartsWith;
  } });
  var o = assert$b;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return o.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return o.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return o.assertDefinedAndNotNull;
  } });
  var u = sleep$7;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return u.sleep;
  } });
  var c = typechecks$3;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return c.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return c.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return c.isUint8Array;
  } });
})(build$v);
var __createBinding$C = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$C = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$C = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$C(n, e, o);
  return __setModuleDefault$C(n, e), n;
};
Object.defineProperty(pbkdf2$3, "__esModule", { value: !0 });
pbkdf2$3.pbkdf2Sha512 = pbkdf2$3.pbkdf2Sha512Noble = pbkdf2$3.pbkdf2Sha512NodeCrypto = pbkdf2$3.pbkdf2Sha512Subtle = pbkdf2$3.getSubtle = pbkdf2$3.getNodeCrypto = void 0;
const utils_1$H = build$v, pbkdf2_1$7 = pbkdf2$8, sha512_1$7 = sha512$a;
async function getNodeCrypto$2() {
  try {
    const e = await Promise.resolve().then(() => __importStar$C(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2$3.getNodeCrypto = getNodeCrypto$2;
async function getSubtle$3() {
  var n, o, u;
  let e = (n = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : n.subtle;
  return e || (e = (u = (o = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : o.webcrypto) == null ? void 0 : u.subtle), e;
}
pbkdf2$3.getSubtle = getSubtle$3;
async function pbkdf2Sha512Subtle$3(e, n, o, u, c) {
  return (0, utils_1$H.assert)(e, "Argument subtle is falsy"), (0, utils_1$H.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$H.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$H.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", n, { name: "PBKDF2" }, !1, ["deriveBits"]).then((d) => e.deriveBits({
    name: "PBKDF2",
    salt: o,
    iterations: u,
    hash: { name: "SHA-512" }
  }, d, c * 8).then((m) => new Uint8Array(m)));
}
pbkdf2$3.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle$3;
async function pbkdf2Sha512NodeCrypto$2(e, n, o, u, c) {
  return (0, utils_1$H.assert)(e, "Argument nodeCrypto is falsy"), (0, utils_1$H.assert)(typeof e == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$H.assert)(typeof e.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((d, m) => {
    e.pbkdf2(n, o, u, c, "sha512", (v, S) => {
      v ? m(v) : d(Uint8Array.from(S));
    });
  });
}
pbkdf2$3.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto$2;
async function pbkdf2Sha512Noble$3(e, n, o, u) {
  return (0, pbkdf2_1$7.pbkdf2Async)(sha512_1$7.sha512, e, n, { c: o, dkLen: u });
}
pbkdf2$3.pbkdf2Sha512Noble = pbkdf2Sha512Noble$3;
async function pbkdf2Sha512$3(e, n, o, u) {
  const c = await getSubtle$3();
  if (c)
    return pbkdf2Sha512Subtle$3(c, e, n, o, u);
  {
    const d = await getNodeCrypto$2();
    return d ? pbkdf2Sha512NodeCrypto$2(d, e, n, o, u) : pbkdf2Sha512Noble$3(e, n, o, u);
  }
}
pbkdf2$3.pbkdf2Sha512 = pbkdf2Sha512$3;
var sha$3 = {}, utils$v = {};
Object.defineProperty(utils$v, "__esModule", { value: !0 });
utils$v.toRealUint8Array = void 0;
function toRealUint8Array$3(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$v.toRealUint8Array = toRealUint8Array$3;
Object.defineProperty(sha$3, "__esModule", { value: !0 });
sha$3.sha512 = sha$3.Sha512 = sha$3.sha256 = sha$3.Sha256 = void 0;
const sha256_1$3 = sha256$8, sha512_1$6 = sha512$a, utils_1$G = utils$v;
let Sha256$3 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha256_1$3.sha256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$G.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$3.Sha256 = Sha256$3;
function sha256$3(e) {
  return new Sha256$3(e).digest();
}
sha$3.sha256 = sha256$3;
let Sha512$3 = class {
  constructor(n) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$6.sha512.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$G.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$3.Sha512 = Sha512$3;
function sha512$3(e) {
  return new Sha512$3(e).digest();
}
sha$3.sha512 = sha512$3;
Object.defineProperty(bip39$3, "__esModule", { value: !0 });
bip39$3.Bip39 = bip39$3.EnglishMnemonic = bip39$3.mnemonicToEntropy = bip39$3.entropyToMnemonic = void 0;
const encoding_1$V = build$w, pbkdf2_1$6 = pbkdf2$3, sha_1$3 = sha$3, wordlist$3 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring$3(e) {
  return Array.from(e).map((n) => n.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits$3(e) {
  const o = e.length * 8 / 32, u = (0, sha_1$3.sha256)(e);
  return bytesToBitstring$3(u).slice(0, o);
}
function bitstringToByte$3(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths$3 = [16, 20, 24, 28, 32], allowedWordLengths$3 = [12, 15, 18, 21, 24];
function entropyToMnemonic$3(e) {
  if (allowedEntropyLengths$3.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const n = bytesToBitstring$3(e), o = deriveChecksumBits$3(e);
  return (n + o).match(/(.{11})/g).map((m) => {
    const v = bitstringToByte$3(m);
    return wordlist$3[v];
  }).join(" ");
}
bip39$3.entropyToMnemonic = entropyToMnemonic$3;
const invalidNumberOfWorks$3 = "Invalid number of words", wordNotInWordlist$3 = "Found word that is not in the wordlist", invalidEntropy$3 = "Invalid entropy", invalidChecksum$3 = "Invalid mnemonic checksum";
function normalize$3(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy$3(e) {
  const n = normalize$3(e).split(" ");
  if (!allowedWordLengths$3.includes(n.length))
    throw new Error(invalidNumberOfWorks$3);
  const o = n.map(($) => {
    const E = wordlist$3.indexOf($);
    if (E === -1)
      throw new Error(wordNotInWordlist$3);
    return E.toString(2).padStart(11, "0");
  }).join(""), u = Math.floor(o.length / 33) * 32, c = o.slice(0, u), d = o.slice(u), m = c.match(/(.{1,8})/g).map(bitstringToByte$3);
  if (m.length < 16 || m.length > 32 || m.length % 4 !== 0)
    throw new Error(invalidEntropy$3);
  const v = Uint8Array.from(m);
  if (deriveChecksumBits$3(v) !== d)
    throw new Error(invalidChecksum$3);
  return v;
}
bip39$3.mnemonicToEntropy = mnemonicToEntropy$3;
let EnglishMnemonic$3 = class Wu {
  constructor(n) {
    if (!Wu.mnemonicMatcher.test(n))
      throw new Error("Invalid mnemonic format");
    const o = n.split(" "), u = [12, 15, 18, 21, 24];
    if (u.indexOf(o.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${u} got: ${o.length})`);
    for (const c of o)
      if (Wu.wordlist.indexOf(c) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy$3(n), this.data = n;
  }
  toString() {
    return this.data;
  }
};
bip39$3.EnglishMnemonic = EnglishMnemonic$3;
EnglishMnemonic$3.wordlist = wordlist$3;
EnglishMnemonic$3.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
let Bip39$3 = class {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(n) {
    return new EnglishMnemonic$3(entropyToMnemonic$3(n));
  }
  static decode(n) {
    return mnemonicToEntropy$3(n.toString());
  }
  static async mnemonicToSeed(n, o) {
    const u = (0, encoding_1$V.toUtf8)(normalize$3(n.toString())), c = "mnemonic" + (o ? normalize$3(o) : ""), d = (0, encoding_1$V.toUtf8)(c);
    return (0, pbkdf2_1$6.pbkdf2Sha512)(u, d, 2048, 64);
  }
};
bip39$3.Bip39 = Bip39$3;
var hmac$3 = {};
Object.defineProperty(hmac$3, "__esModule", { value: !0 });
hmac$3.Hmac = void 0;
let Hmac$3 = class {
  constructor(n, o) {
    const u = new n().blockSize;
    this.hash = (d) => new n().update(d).digest();
    let c = o;
    if (c.length > u && (c = this.hash(c)), c.length < u) {
      const d = new Uint8Array(u - c.length);
      c = new Uint8Array([...c, ...d]);
    }
    this.oKeyPad = c.map((d) => d ^ 92), this.iKeyPad = c.map((d) => d ^ 54), this.messageHasher = new n(), this.blockSize = u, this.update(this.iKeyPad);
  }
  update(n) {
    return this.messageHasher.update(n), this;
  }
  digest() {
    const n = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...n]));
  }
};
hmac$3.Hmac = Hmac$3;
var keccak$3 = {};
Object.defineProperty(keccak$3, "__esModule", { value: !0 });
keccak$3.keccak256 = keccak$3.Keccak256 = void 0;
const sha3_1$3 = sha3$3, utils_1$F = utils$v;
let Keccak256$3 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha3_1$3.keccak_256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$F.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
keccak$3.Keccak256 = Keccak256$3;
function keccak256$4(e) {
  return new Keccak256$3(e).digest();
}
keccak$3.keccak256 = keccak256$4;
var libsodium$3 = {}, __importDefault$y = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium$3, "__esModule", { value: !0 });
libsodium$3.Xchacha20poly1305Ietf = libsodium$3.xchacha20NonceLength = libsodium$3.Ed25519 = libsodium$3.Ed25519Keypair = libsodium$3.Argon2id = libsodium$3.isArgon2idOptions = void 0;
const utils_1$E = build$v, libsodium_wrappers_sumo_1$2 = __importDefault$y(libsodiumWrappers);
function isArgon2idOptions$3(e) {
  return !(!(0, utils_1$E.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium$3.isArgon2idOptions = isArgon2idOptions$3;
let Argon2id$3 = class {
  static async execute(n, o, u) {
    return await libsodium_wrappers_sumo_1$2.default.ready, libsodium_wrappers_sumo_1$2.default.crypto_pwhash(
      u.outputLength,
      n,
      o,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      u.opsLimit,
      u.memLimitKib * 1024,
      libsodium_wrappers_sumo_1$2.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
};
libsodium$3.Argon2id = Argon2id$3;
let Ed25519Keypair$3 = class Zc {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(n) {
    if (n.length !== 64)
      throw new Error(`Unexpected key length ${n.length}. Must be 64.`);
    return new Zc(n.slice(0, 32), n.slice(32, 64));
  }
  constructor(n, o) {
    this.privkey = n, this.pubkey = o;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
};
libsodium$3.Ed25519Keypair = Ed25519Keypair$3;
let Ed25519$3 = class {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(n) {
    await libsodium_wrappers_sumo_1$2.default.ready;
    const o = libsodium_wrappers_sumo_1$2.default.crypto_sign_seed_keypair(n);
    return Ed25519Keypair$3.fromLibsodiumPrivkey(o.privateKey);
  }
  static async createSignature(n, o) {
    return await libsodium_wrappers_sumo_1$2.default.ready, libsodium_wrappers_sumo_1$2.default.crypto_sign_detached(n, o.toLibsodiumPrivkey());
  }
  static async verifySignature(n, o, u) {
    return await libsodium_wrappers_sumo_1$2.default.ready, libsodium_wrappers_sumo_1$2.default.crypto_sign_verify_detached(n, o, u);
  }
};
libsodium$3.Ed25519 = Ed25519$3;
libsodium$3.xchacha20NonceLength = 24;
let Xchacha20poly1305Ietf$3 = class {
  static async encrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$2.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$2.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      n,
      c,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      u,
      o
    );
  }
  static async decrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$2.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$2.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      n,
      c,
      u,
      o
    );
  }
};
libsodium$3.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf$3;
var random$3 = {};
Object.defineProperty(random$3, "__esModule", { value: !0 });
random$3.Random = void 0;
let Random$3 = class {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(n) {
    try {
      const o = typeof window == "object" ? window : self, u = typeof o.crypto < "u" ? o.crypto : o.msCrypto, c = new Uint8Array(n);
      return u.getRandomValues(c), c;
    } catch {
      try {
        const o = requireCryptoBrowserify();
        return new Uint8Array([...o.randomBytes(n)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
};
random$3.Random = Random$3;
var ripemd$3 = {};
Object.defineProperty(ripemd$3, "__esModule", { value: !0 });
ripemd$3.ripemd160 = ripemd$3.Ripemd160 = void 0;
const ripemd160_1$3 = ripemd160$8, utils_1$D = utils$v;
let Ripemd160$3 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$3.ripemd160.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$D.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
ripemd$3.Ripemd160 = Ripemd160$3;
function ripemd160$3(e) {
  return new Ripemd160$3(e).digest();
}
ripemd$3.ripemd160 = ripemd160$3;
var secp256k1$7 = {}, secp256k1signature$3 = {};
Object.defineProperty(secp256k1signature$3, "__esModule", { value: !0 });
secp256k1signature$3.ExtendedSecp256k1Signature = secp256k1signature$3.Secp256k1Signature = void 0;
function trimLeadingNullBytes$3(e) {
  let n = 0;
  for (const o of e)
    if (o === 0)
      n++;
    else
      break;
  return e.slice(n);
}
const derTagInteger$3 = 2;
let Secp256k1Signature$3 = class zu {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(n) {
    if (n.length !== 64)
      throw new Error(`Got invalid data length: ${n.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new zu(trimLeadingNullBytes$3(n.slice(0, 32)), trimLeadingNullBytes$3(n.slice(32, 64)));
  }
  static fromDer(n) {
    let o = 0;
    if (n[o++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const u = n[o++];
    if (n.length - o !== u)
      throw new Error("Data length mismatch detected");
    if (n[o++] !== derTagInteger$3)
      throw new Error("INTEGER tag expected");
    const d = n[o++];
    if (d >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const m = n.slice(o, o + d);
    if (o += d, n[o++] !== derTagInteger$3)
      throw new Error("INTEGER tag expected");
    const S = n[o++];
    if (S >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const $ = n.slice(o, o + S);
    return o += S, new zu(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes$3(m),
      trimLeadingNullBytes$3($)
    );
  }
  constructor(n, o) {
    if (n.length > 32 || n.length === 0 || n[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (o.length > 32 || o.length === 0 || o[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: n,
      s: o
    };
  }
  r(n) {
    if (n === void 0)
      return this.data.r;
    {
      const o = n - this.data.r.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter r");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.r]);
    }
  }
  s(n) {
    if (n === void 0)
      return this.data.s;
    {
      const o = n - this.data.s.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter s");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const n = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, o = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, u = n.length, c = o.length, d = new Uint8Array([derTagInteger$3, u, ...n, derTagInteger$3, c, ...o]);
    return new Uint8Array([48, d.length, ...d]);
  }
};
secp256k1signature$3.Secp256k1Signature = Secp256k1Signature$3;
let ExtendedSecp256k1Signature$3 = class jc extends Secp256k1Signature$3 {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(n) {
    if (n.length !== 65)
      throw new Error(`Got invalid data length ${n.length}. Expected 32 + 32 + 1`);
    return new jc(trimLeadingNullBytes$3(n.slice(0, 32)), trimLeadingNullBytes$3(n.slice(32, 64)), n[64]);
  }
  constructor(n, o, u) {
    if (super(n, o), !Number.isInteger(u))
      throw new Error("The recovery parameter must be an integer.");
    if (u < 0 || u > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = u;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
};
secp256k1signature$3.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature$3;
var __importDefault$x = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$7, "__esModule", { value: !0 });
secp256k1$7.Secp256k1 = void 0;
const encoding_1$U = build$w, bn_js_1$b = __importDefault$x(bnExports$1), elliptic_1$4 = __importDefault$x(requireElliptic()), secp256k1signature_1$3 = secp256k1signature$3, secp256k1$6 = new elliptic_1$4.default.ec("secp256k1"), secp256k1N$3 = new bn_js_1$b.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
let Secp256k1$3 = class {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(n) {
    if (n.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const o = secp256k1$6.keyFromPrivate(n);
    if (o.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$b.default(n).gte(secp256k1N$3))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$U.fromHex)(o.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(o.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(n, o) {
    if (n.length === 0)
      throw new Error("Message hash must not be empty");
    if (n.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const u = secp256k1$6.keyFromPrivate(o), { r: c, s: d, recoveryParam: m } = u.sign(n, { canonical: !0 });
    if (typeof m != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1$3.ExtendedSecp256k1Signature(Uint8Array.from(c.toArray()), Uint8Array.from(d.toArray()), m);
  }
  static async verifySignature(n, o, u) {
    if (o.length === 0)
      throw new Error("Message hash must not be empty");
    if (o.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const c = secp256k1$6.keyFromPublic(u);
    try {
      return c.verify(o, n.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(n, o) {
    const u = { r: (0, encoding_1$U.toHex)(n.r()), s: (0, encoding_1$U.toHex)(n.s()) }, c = secp256k1$6.recoverPubKey(o, u, n.recovery), d = secp256k1$6.keyFromPublic(c);
    return (0, encoding_1$U.fromHex)(d.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(n) {
    switch (n.length) {
      case 33:
        return n;
      case 65:
        return Uint8Array.from(secp256k1$6.keyFromPublic(n).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(n) {
    switch (n.length) {
      case 33:
        return Uint8Array.from(secp256k1$6.keyFromPublic(n).getPublic(!1, "array"));
      case 65:
        return n;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(n) {
    switch (n.length) {
      case 64:
        return n;
      case 65:
        return n.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
};
secp256k1$7.Secp256k1 = Secp256k1$3;
var slip10$3 = {}, build$u = {}, decimal$3 = {}, __importDefault$w = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal$3, "__esModule", { value: !0 });
decimal$3.Decimal = void 0;
const bn_js_1$a = __importDefault$w(bnExports$1), maxFractionalDigits$3 = 100;
let Decimal$3 = class os {
  static fromUserInput(n, o) {
    os.verifyFractionalDigits(o);
    const u = n.match(/[^0-9.]/);
    if (u)
      throw new Error(`Invalid character at position ${u.index + 1}`);
    let c, d;
    if (n === "")
      c = "0", d = "";
    else if (n.search(/\./) === -1)
      c = n, d = "";
    else {
      const v = n.split(".");
      switch (v.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!v[1])
            throw new Error("Fractional part missing");
          c = v[0], d = v[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (d.length > o)
      throw new Error("Got more fractional digits than supported");
    const m = `${c}${d.padEnd(o, "0")}`;
    return new os(m, o);
  }
  static fromAtomics(n, o) {
    return os.verifyFractionalDigits(o), new os(n, o);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(n) {
    return os.verifyFractionalDigits(n), new os("0", n);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(n) {
    return os.verifyFractionalDigits(n), new os("1" + "0".repeat(n), n);
  }
  static verifyFractionalDigits(n) {
    if (!Number.isInteger(n))
      throw new Error("Fractional digits is not an integer");
    if (n < 0)
      throw new Error("Fractional digits must not be negative");
    if (n > maxFractionalDigits$3)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits$3}`);
  }
  static compare(n, o) {
    if (n.fractionalDigits !== o.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return n.data.atomics.cmp(new bn_js_1$a.default(o.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(n, o) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$a.default(n),
      fractionalDigits: o
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new os(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const n = new bn_js_1$a.default(10).pow(new bn_js_1$a.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : os.fromAtomics(o.mul(n).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const n = new bn_js_1$a.default(10).pow(new bn_js_1$a.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : os.fromAtomics(o.addn(1).mul(n).toString(), this.fractionalDigits);
  }
  toString() {
    const n = new bn_js_1$a.default(10).pow(new bn_js_1$a.default(this.data.fractionalDigits)), o = this.data.atomics.div(n), u = this.data.atomics.mod(n);
    if (u.isZero())
      return o.toString();
    {
      const d = u.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${o.toString()}.${d}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const n = Number(this.toString());
    if (Number.isNaN(n))
      throw new Error("Conversion to number failed");
    return n;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.add(new bn_js_1$a.default(n.atomics));
    return new os(o.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.sub(new bn_js_1$a.default(n.atomics));
    if (o.ltn(0))
      throw new Error("Difference must not be negative");
    return new os(o.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(n) {
    const o = this.data.atomics.mul(new bn_js_1$a.default(n.toString()));
    return new os(o.toString(), this.fractionalDigits);
  }
  equals(n) {
    return os.compare(this, n) === 0;
  }
  isLessThan(n) {
    return os.compare(this, n) < 0;
  }
  isLessThanOrEqual(n) {
    return os.compare(this, n) <= 0;
  }
  isGreaterThan(n) {
    return os.compare(this, n) > 0;
  }
  isGreaterThanOrEqual(n) {
    return os.compare(this, n) >= 0;
  }
};
decimal$3.Decimal = Decimal$3;
var integers$3 = {}, __importDefault$v = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers$3, "__esModule", { value: !0 });
integers$3.Uint64 = integers$3.Uint53 = integers$3.Int53 = integers$3.Uint32 = void 0;
const bn_js_1$9 = __importDefault$v(bnExports$1), uint64MaxValue$3 = new bn_js_1$9.default("18446744073709551615", 10, "be");
let Uint32$3 = class Su {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(n) {
    return Su.fromBytes(n);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? n : Array.from(n).reverse();
    return new Su(u[0] * 2 ** 24 + u[1] * 2 ** 16 + u[2] * 2 ** 8 + u[3]);
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Su(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < 0 || n > 4294967295)
      throw new Error("Input not in uint32 range: " + n.toString());
    this.data = n;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$3.Uint32 = Uint32$3;
let Int53$3 = class Xc {
  static fromString(n) {
    if (!n.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Xc(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + n.toString());
    this.data = n;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$3.Int53 = Int53$3;
let Uint53$3 = class ed {
  static fromString(n) {
    const o = Int53$3.fromString(n);
    return new ed(o.toNumber());
  }
  constructor(n) {
    const o = new Int53$3(n);
    if (o.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = o;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$3.Uint53 = Uint53$3;
let Uint64$3 = class au {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(n) {
    return au.fromBytes(n);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? Array.from(n) : Array.from(n).reverse();
    return new au(new bn_js_1$9.default(u));
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new au(new bn_js_1$9.default(n, 10, "be"));
  }
  static fromNumber(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    let o;
    try {
      o = new bn_js_1$9.default(n);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new au(o);
  }
  constructor(n) {
    if (n.isNeg())
      throw new Error("Input is negative");
    if (n.gt(uint64MaxValue$3))
      throw new Error("Input exceeds uint64 range");
    this.data = n;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
};
integers$3.Uint64 = Uint64$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var n = decimal$3;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return n.Decimal;
  } });
  var o = integers$3;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return o.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return o.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return o.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return o.Uint64;
  } });
})(build$u);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const o = build$w, u = build$u, c = n(bnExports$1), d = n(requireElliptic()), m = hmac$3, v = sha$3;
  var S;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(S = e.Slip10Curve || (e.Slip10Curve = {}));
  function $(M) {
    switch (M) {
      case S.Ed25519:
        return S.Ed25519;
      case S.Secp256k1:
        return S.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  e.slip10CurveFromString = $;
  class E extends u.Uint32 {
    static hardened(G) {
      return new E(G + 2 ** 31);
    }
    static normal(G) {
      return new E(G);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = E;
  const O = new d.default.ec("secp256k1");
  class T {
    static derivePath(G, k, F) {
      let X = this.master(G, k);
      for (const ee of F)
        X = this.child(G, X.privkey, X.chainCode, ee);
      return X;
    }
    static master(G, k) {
      const F = new m.Hmac(v.Sha512, (0, o.toAscii)(G)).update(k).digest(), X = F.slice(0, 32), ee = F.slice(32, 64);
      return G !== S.Ed25519 && (this.isZero(X) || this.isGteN(G, X)) ? this.master(G, F) : {
        chainCode: ee,
        privkey: X
      };
    }
    static child(G, k, F, X) {
      let ee;
      if (X.isHardened()) {
        const ue = new Uint8Array([0, ...k, ...X.toBytesBigEndian()]);
        ee = new m.Hmac(v.Sha512, F).update(ue).digest();
      } else {
        if (G === S.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ue = new Uint8Array([
            ...T.serializedPoint(G, new c.default(k)),
            ...X.toBytesBigEndian()
          ]);
          ee = new m.Hmac(v.Sha512, F).update(ue).digest();
        }
      }
      return this.childImpl(G, k, F, X, ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(G, k) {
      switch (G) {
        case S.Secp256k1:
          return (0, o.fromHex)(O.g.mul(k).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(G, k, F, X, ee) {
      const ue = ee.slice(0, 32), Q = ee.slice(32, 64), Y = Q;
      if (G === S.Ed25519)
        return {
          chainCode: Y,
          privkey: ue
        };
      const pe = this.n(G), oe = new c.default(ue).add(new c.default(k)).mod(pe), ne = Uint8Array.from(oe.toArray("be", 32));
      if (this.isGteN(G, ue) || this.isZero(ne)) {
        const H = new m.Hmac(v.Sha512, F).update(new Uint8Array([1, ...Q, ...X.toBytesBigEndian()])).digest();
        return this.childImpl(G, k, F, X, H);
      }
      return {
        chainCode: Y,
        privkey: ne
      };
    }
    static isZero(G) {
      return G.every((k) => k === 0);
    }
    static isGteN(G, k) {
      return new c.default(k).gte(this.n(G));
    }
    static n(G) {
      switch (G) {
        case S.Secp256k1:
          return new c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = T;
  function y(M) {
    return M.reduce((G, k) => {
      const F = k.isHardened() ? `${k.toNumber() - 2147483648}'` : k.toString();
      return G + "/" + F;
    }, "m");
  }
  e.pathToString = y;
  function V(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let G = M.slice(1);
    const k = new Array();
    for (; G; ) {
      const F = G.match(/^\/([0-9]+)('?)/);
      if (!F)
        throw new Error("Syntax error while reading path component");
      const [X, ee, ue] = F, Q = u.Uint53.fromString(ee).toNumber();
      if (Q >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ue ? k.push(E.hardened(Q)) : k.push(E.normal(Q)), G = G.slice(X.length);
    }
    return k;
  }
  e.stringToPath = V;
})(slip10$3);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var n = bip39$3;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return n.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return n.EnglishMnemonic;
  } });
  var o = hmac$3;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return o.Hmac;
  } });
  var u = keccak$3;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return u.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return u.keccak256;
  } });
  var c = libsodium$3;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return c.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return c.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return c.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return c.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return c.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return c.Xchacha20poly1305Ietf;
  } });
  var d = random$3;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return d.Random;
  } });
  var m = ripemd$3;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return m.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return m.ripemd160;
  } });
  var v = secp256k1$7;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return v.Secp256k1;
  } });
  var S = secp256k1signature$3;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return S.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return S.Secp256k1Signature;
  } });
  var $ = sha$3;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return $.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return $.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return $.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return $.sha512;
  } });
  var E = slip10$3;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return E.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return E.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return E.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return E.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return E.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return E.stringToPath;
  } });
})(build$x);
Object.defineProperty(addresses$3, "__esModule", { value: !0 });
addresses$3.pubkeyToAddress = addresses$3.pubkeyToRawAddress = addresses$3.rawSecp256k1PubkeyToRawAddress = addresses$3.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$j = build$x, encoding_1$T = build$w;
function rawEd25519PubkeyToRawAddress$3(e) {
  if (e.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${e.length}`);
  return (0, crypto_1$j.sha256)(e).slice(0, 20);
}
addresses$3.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress$3;
function rawSecp256k1PubkeyToRawAddress$3(e) {
  if (e.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${e.length}`);
  return (0, crypto_1$j.ripemd160)((0, crypto_1$j.sha256)(e));
}
addresses$3.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress$3;
function pubkeyToRawAddress$3(e, n) {
  switch (e) {
    case "ed25519":
      return rawEd25519PubkeyToRawAddress$3(n);
    case "secp256k1":
      return rawSecp256k1PubkeyToRawAddress$3(n);
    default:
      throw new Error(`Pubkey type ${e} not supported`);
  }
}
addresses$3.pubkeyToRawAddress = pubkeyToRawAddress$3;
function pubkeyToAddress$3(e, n) {
  return (0, encoding_1$T.toHex)(pubkeyToRawAddress$3(e, n)).toUpperCase();
}
addresses$3.pubkeyToAddress = pubkeyToAddress$3;
var dates$2 = {};
Object.defineProperty(dates$2, "__esModule", { value: !0 });
dates$2.DateTime = dates$2.toSeconds = dates$2.fromSeconds = dates$2.toRfc3339WithNanoseconds = dates$2.fromRfc3339WithNanoseconds = void 0;
const encoding_1$S = build$w, math_1$k = build$u;
function fromRfc3339WithNanoseconds$2(e) {
  const n = (0, encoding_1$S.fromRfc3339)(e), o = e.match(/\.(\d+)Z$/), u = o ? o[1].slice(3) : "";
  return n.nanoseconds = parseInt(u.padEnd(6, "0"), 10), n;
}
dates$2.fromRfc3339WithNanoseconds = fromRfc3339WithNanoseconds$2;
function toRfc3339WithNanoseconds$2(e) {
  var u;
  const n = e.toISOString(), o = ((u = e.nanoseconds) == null ? void 0 : u.toString()) ?? "";
  return `${n.slice(0, -1)}${o.padStart(6, "0")}Z`;
}
dates$2.toRfc3339WithNanoseconds = toRfc3339WithNanoseconds$2;
function fromSeconds$2(e, n = 0) {
  const o = new math_1$k.Uint32(n).toNumber();
  if (o > 999999999)
    throw new Error("Nano seconds must not exceed 999999999");
  const u = new Date(e * 1e3 + Math.floor(o / 1e6));
  return u.nanoseconds = o % 1e6, u;
}
dates$2.fromSeconds = fromSeconds$2;
function toSeconds$2(e) {
  return {
    seconds: Math.floor(e.getTime() / 1e3),
    nanos: e.getTime() % 1e3 * 1e6 + (e.nanoseconds ?? 0)
  };
}
dates$2.toSeconds = toSeconds$2;
let DateTime$2 = class {
  /** @deprecated Use fromRfc3339WithNanoseconds instead */
  static decode(n) {
    return fromRfc3339WithNanoseconds$2(n);
  }
  /** @deprecated Use toRfc3339WithNanoseconds instead */
  static encode(n) {
    return toRfc3339WithNanoseconds$2(n);
  }
};
dates$2.DateTime = DateTime$2;
var comet38$1 = {}, comet38client$1 = {}, jsonrpc$2 = {};
Object.defineProperty(jsonrpc$2, "__esModule", { value: !0 });
jsonrpc$2.createJsonRpcRequest = void 0;
const numbersWithoutZero$2 = "123456789";
function randomNumericChar$2() {
  return numbersWithoutZero$2[Math.floor(Math.random() * numbersWithoutZero$2.length)];
}
function randomId$2() {
  return parseInt(Array.from({ length: 12 }).map(() => randomNumericChar$2()).join(""), 10);
}
function createJsonRpcRequest$2(e, n) {
  const o = n ? { ...n } : {};
  return {
    jsonrpc: "2.0",
    id: randomId$2(),
    method: e,
    params: o
  };
}
jsonrpc$2.createJsonRpcRequest = createJsonRpcRequest$2;
var rpcclients$2 = {}, httpbatchclient$2 = {}, build$t = {}, id$3 = {};
Object.defineProperty(id$3, "__esModule", { value: !0 });
id$3.makeJsonRpcId = void 0;
let counter$3 = 1e4;
function makeJsonRpcId$2() {
  return counter$3 += 1;
}
id$3.makeJsonRpcId = makeJsonRpcId$2;
var jsonrpcclient$2 = {}, build$s = {}, concat$a = {};
Object.defineProperty(concat$a, "__esModule", { value: !0 });
concat$a.concat = void 0;
const xstream_1$n = xstream;
function concat$9(...e) {
  const n = new Array(), o = new Array(), u = /* @__PURE__ */ new Set();
  let c = 0;
  function d() {
    for (; n.length > 0; )
      n.shift().unsubscribe();
    o.length = 0, u.clear(), c = 0;
  }
  const m = {
    start: (v) => {
      e.forEach((E) => o.push([]));
      function S(E) {
        for (; ; ) {
          const O = o[E].shift();
          if (O === void 0)
            return;
          v.next(O);
        }
      }
      function $() {
        return c >= e.length;
      }
      if ($()) {
        v.complete();
        return;
      }
      e.forEach((E, O) => {
        n.push(E.subscribe({
          next: (T) => {
            O === c ? v.next(T) : o[O].push(T);
          },
          complete: () => {
            for (u.add(O); u.has(c); )
              S(c), c++;
            $() ? v.complete() : S(c);
          },
          error: (T) => {
            v.error(T), d();
          }
        }));
      });
    },
    stop: () => {
      d();
    }
  };
  return xstream_1$n.Stream.create(m);
}
concat$a.concat = concat$9;
var defaultvalueproducer$4 = {};
Object.defineProperty(defaultvalueproducer$4, "__esModule", { value: !0 });
defaultvalueproducer$4.DefaultValueProducer = void 0;
let DefaultValueProducer$4 = class {
  get value() {
    return this.internalValue;
  }
  constructor(n, o) {
    this.callbacks = o, this.internalValue = n;
  }
  /**
   * Update the current value.
   *
   * If producer is active (i.e. someone is listening), this emits an event.
   * If not, just the current value is updated.
   */
  update(n) {
    this.internalValue = n, this.listener && this.listener.next(n);
  }
  /**
   * Produce an error
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error(n) {
    this.listener && this.listener.error(n);
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  start(n) {
    this.listener = n, n.next(this.internalValue), this.callbacks && this.callbacks.onStarted();
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  stop() {
    this.callbacks && this.callbacks.onStop(), this.listener = void 0;
  }
};
defaultvalueproducer$4.DefaultValueProducer = DefaultValueProducer$4;
var dropduplicates$4 = {};
Object.defineProperty(dropduplicates$4, "__esModule", { value: !0 });
dropduplicates$4.dropDuplicates = void 0;
function dropDuplicates$4(e) {
  return (o) => {
    const u = /* @__PURE__ */ new Set();
    return o.filter((d) => !u.has(e(d))).debug((d) => u.add(e(d)));
  };
}
dropduplicates$4.dropDuplicates = dropDuplicates$4;
var promise$4 = {};
Object.defineProperty(promise$4, "__esModule", { value: !0 });
promise$4.firstEvent = promise$4.toListPromise = promise$4.fromListPromise = void 0;
const xstream_1$m = xstream;
function fromListPromise$4(e) {
  const n = {
    start: (o) => {
      e.then((u) => {
        for (const c of u)
          o.next(c);
        o.complete();
      }).catch((u) => o.error(u));
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    stop: () => {
    }
  };
  return xstream_1$m.Stream.create(n);
}
promise$4.fromListPromise = fromListPromise$4;
async function toListPromise$4(e, n) {
  return new Promise((o, u) => {
    if (n === 0) {
      o([]);
      return;
    }
    const c = new Array();
    e.take(n).subscribe({
      next: (d) => {
        c.push(d), c.length === n && o(c);
      },
      complete: () => {
        u(`Stream completed before all events could be collected. Collected ${c.length}, expected ${n}`);
      },
      error: (d) => u(d)
    });
  });
}
promise$4.toListPromise = toListPromise$4;
async function firstEvent$4(e) {
  return (await toListPromise$4(e, 1))[0];
}
promise$4.firstEvent = firstEvent$4;
var reducer$4 = {};
Object.defineProperty(reducer$4, "__esModule", { value: !0 });
reducer$4.lastValue = reducer$4.asArray = reducer$4.countStream = reducer$4.Reducer = void 0;
let Reducer$4 = class {
  constructor(n, o, u) {
    this.stream = n, this.reducer = o, this.state = u, this.completed = new Promise((c, d) => {
      const m = this.stream.subscribe({
        next: (v) => {
          this.state = this.reducer(this.state, v);
        },
        complete: () => {
          c(), m.unsubscribe();
        },
        error: (v) => {
          d(v), m.unsubscribe();
        }
      });
    });
  }
  // value returns current materialized state
  value() {
    return this.state;
  }
  // finished resolves on completed stream, rejects on stream error
  async finished() {
    return this.completed;
  }
};
reducer$4.Reducer = Reducer$4;
function increment$4(e, n) {
  return e + 1;
}
function countStream$4(e) {
  return new Reducer$4(e, increment$4, 0);
}
reducer$4.countStream = countStream$4;
function append$4(e, n) {
  return [...e, n];
}
function asArray$4(e) {
  return new Reducer$4(e, append$4, []);
}
reducer$4.asArray = asArray$4;
function last$4(e, n) {
  return n;
}
function lastValue$4(e) {
  return new Reducer$4(e, last$4, void 0);
}
reducer$4.lastValue = lastValue$4;
var valueandupdates$4 = {};
Object.defineProperty(valueandupdates$4, "__esModule", { value: !0 });
valueandupdates$4.ValueAndUpdates = void 0;
const xstream_1$l = xstream;
let ValueAndUpdates$4 = class {
  get value() {
    return this.producer.value;
  }
  constructor(n) {
    this.producer = n, this.updates = xstream_1$l.MemoryStream.createWithMemory(this.producer);
  }
  /**
   * Resolves as soon as search value is found.
   *
   * @param search either a value or a function that must return true when found
   * @returns the value of the update that caused the search match
   */
  async waitFor(n) {
    const o = typeof n == "function" ? n : (u) => u === n;
    return new Promise((u, c) => {
      const d = this.updates.subscribe({
        next: (m) => {
          o(m) && (u(m), setTimeout(() => d.unsubscribe(), 0));
        },
        complete: () => {
          d.unsubscribe(), c("Update stream completed without expected value");
        },
        error: (m) => {
          c(m);
        }
      });
    });
  }
};
valueandupdates$4.ValueAndUpdates = ValueAndUpdates$4;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(S, $, E, O) {
    O === void 0 && (O = E);
    var T = Object.getOwnPropertyDescriptor($, E);
    (!T || ("get" in T ? !$.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return $[E];
    } }), Object.defineProperty(S, O, T);
  } : function(S, $, E, O) {
    O === void 0 && (O = E), S[O] = $[E];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(S, $) {
    for (var E in S)
      E !== "default" && !Object.prototype.hasOwnProperty.call($, E) && n($, S, E);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueAndUpdates = e.toListPromise = e.fromListPromise = e.firstEvent = e.dropDuplicates = e.DefaultValueProducer = e.concat = void 0;
  var u = concat$a;
  Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
    return u.concat;
  } });
  var c = defaultvalueproducer$4;
  Object.defineProperty(e, "DefaultValueProducer", { enumerable: !0, get: function() {
    return c.DefaultValueProducer;
  } });
  var d = dropduplicates$4;
  Object.defineProperty(e, "dropDuplicates", { enumerable: !0, get: function() {
    return d.dropDuplicates;
  } });
  var m = promise$4;
  Object.defineProperty(e, "firstEvent", { enumerable: !0, get: function() {
    return m.firstEvent;
  } }), Object.defineProperty(e, "fromListPromise", { enumerable: !0, get: function() {
    return m.fromListPromise;
  } }), Object.defineProperty(e, "toListPromise", { enumerable: !0, get: function() {
    return m.toListPromise;
  } }), o(reducer$4, e);
  var v = valueandupdates$4;
  Object.defineProperty(e, "ValueAndUpdates", { enumerable: !0, get: function() {
    return v.ValueAndUpdates;
  } });
})(build$s);
var types$9 = {};
Object.defineProperty(types$9, "__esModule", { value: !0 });
types$9.jsonRpcCode = types$9.isJsonRpcSuccessResponse = types$9.isJsonRpcErrorResponse = void 0;
function isJsonRpcErrorResponse$2(e) {
  return typeof e.error == "object";
}
types$9.isJsonRpcErrorResponse = isJsonRpcErrorResponse$2;
function isJsonRpcSuccessResponse$2(e) {
  return !isJsonRpcErrorResponse$2(e);
}
types$9.isJsonRpcSuccessResponse = isJsonRpcSuccessResponse$2;
types$9.jsonRpcCode = {
  parseError: -32700,
  invalidRequest: -32600,
  methodNotFound: -32601,
  invalidParams: -32602,
  internalError: -32603,
  // server error (Reserved for implementation-defined server-errors.):
  // -32000 to -32099
  serverError: {
    default: -32e3
  }
};
Object.defineProperty(jsonrpcclient$2, "__esModule", { value: !0 });
jsonrpcclient$2.JsonRpcClient = void 0;
const stream_1$6 = build$s, types_1$b = types$9;
let JsonRpcClient$2 = class {
  constructor(n) {
    this.connection = n;
  }
  async run(n) {
    const o = this.connection.responseStream.filter((d) => d.id === n.id), u = (0, stream_1$6.firstEvent)(o);
    this.connection.sendRequest(n);
    const c = await u;
    if ((0, types_1$b.isJsonRpcErrorResponse)(c)) {
      const d = c.error;
      throw new Error(`JSON RPC error: code=${d.code}; message='${d.message}'`);
    }
    return c;
  }
};
jsonrpcclient$2.JsonRpcClient = JsonRpcClient$2;
var parse$g = {}, compatibility$2 = {};
Object.defineProperty(compatibility$2, "__esModule", { value: !0 });
compatibility$2.isJsonCompatibleDictionary = compatibility$2.isJsonCompatibleArray = compatibility$2.isJsonCompatibleValue = void 0;
function isJsonCompatibleValue$2(e) {
  return !!(typeof e == "string" || typeof e == "number" || typeof e == "boolean" || e === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleArray$2(e) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleDictionary$2(e));
}
compatibility$2.isJsonCompatibleValue = isJsonCompatibleValue$2;
function isJsonCompatibleArray$2(e) {
  if (!Array.isArray(e))
    return !1;
  for (const n of e)
    if (!isJsonCompatibleValue$2(n))
      return !1;
  return !0;
}
compatibility$2.isJsonCompatibleArray = isJsonCompatibleArray$2;
function isJsonCompatibleDictionary$2(e) {
  return typeof e != "object" || e === null || Object.prototype.toString.call(e) !== "[object Object]" ? !1 : Object.values(e).every(isJsonCompatibleValue$2);
}
compatibility$2.isJsonCompatibleDictionary = isJsonCompatibleDictionary$2;
Object.defineProperty(parse$g, "__esModule", { value: !0 });
parse$g.parseJsonRpcResponse = parse$g.parseJsonRpcSuccessResponse = parse$g.parseJsonRpcErrorResponse = parse$g.parseJsonRpcRequest = parse$g.parseJsonRpcId = void 0;
const compatibility_1$2 = compatibility$2;
function parseJsonRpcId$2(e) {
  if (!(0, compatibility_1$2.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  const n = e.id;
  return typeof n != "number" && typeof n != "string" ? null : n;
}
parse$g.parseJsonRpcId = parseJsonRpcId$2;
function parseJsonRpcRequest$2(e) {
  if (!(0, compatibility_1$2.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${e.jsonrpc}`);
  const n = parseJsonRpcId$2(e);
  if (n === null)
    throw new Error("Invalid id field");
  const o = e.method;
  if (typeof o != "string")
    throw new Error("Invalid method field");
  if (!(0, compatibility_1$2.isJsonCompatibleArray)(e.params) && !(0, compatibility_1$2.isJsonCompatibleDictionary)(e.params))
    throw new Error("Invalid params field");
  return {
    jsonrpc: "2.0",
    id: n,
    method: o,
    params: e.params
  };
}
parse$g.parseJsonRpcRequest = parseJsonRpcRequest$2;
function parseError$2(e) {
  if (typeof e.code != "number")
    throw new Error("Error property 'code' is not a number");
  if (typeof e.message != "string")
    throw new Error("Error property 'message' is not a string");
  let n;
  if (e.data === void 0)
    n = void 0;
  else if ((0, compatibility_1$2.isJsonCompatibleValue)(e.data))
    n = e.data;
  else
    throw new Error("Error property 'data' is defined but not a JSON compatible value.");
  return {
    code: e.code,
    message: e.message,
    ...n !== void 0 ? { data: n } : {}
  };
}
function parseJsonRpcErrorResponse$2(e) {
  if (!(0, compatibility_1$2.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const n = e.id;
  if (typeof n != "number" && typeof n != "string" && n !== null)
    throw new Error("Invalid id field");
  if (typeof e.error > "u" || !(0, compatibility_1$2.isJsonCompatibleDictionary)(e.error))
    throw new Error("Invalid error field");
  return {
    jsonrpc: "2.0",
    id: n,
    error: parseError$2(e.error)
  };
}
parse$g.parseJsonRpcErrorResponse = parseJsonRpcErrorResponse$2;
function parseJsonRpcSuccessResponse$2(e) {
  if (!(0, compatibility_1$2.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const n = e.id;
  if (typeof n != "number" && typeof n != "string")
    throw new Error("Invalid id field");
  if (typeof e.result > "u")
    throw new Error("Invalid result field");
  const o = e.result;
  return {
    jsonrpc: "2.0",
    id: n,
    result: o
  };
}
parse$g.parseJsonRpcSuccessResponse = parseJsonRpcSuccessResponse$2;
function parseJsonRpcResponse$2(e) {
  let n;
  try {
    n = parseJsonRpcErrorResponse$2(e);
  } catch {
    n = parseJsonRpcSuccessResponse$2(e);
  }
  return n;
}
parse$g.parseJsonRpcResponse = parseJsonRpcResponse$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.jsonRpcCode = e.isJsonRpcSuccessResponse = e.isJsonRpcErrorResponse = e.parseJsonRpcSuccessResponse = e.parseJsonRpcResponse = e.parseJsonRpcRequest = e.parseJsonRpcId = e.parseJsonRpcErrorResponse = e.JsonRpcClient = e.makeJsonRpcId = void 0;
  var n = id$3;
  Object.defineProperty(e, "makeJsonRpcId", { enumerable: !0, get: function() {
    return n.makeJsonRpcId;
  } });
  var o = jsonrpcclient$2;
  Object.defineProperty(e, "JsonRpcClient", { enumerable: !0, get: function() {
    return o.JsonRpcClient;
  } });
  var u = parse$g;
  Object.defineProperty(e, "parseJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "parseJsonRpcId", { enumerable: !0, get: function() {
    return u.parseJsonRpcId;
  } }), Object.defineProperty(e, "parseJsonRpcRequest", { enumerable: !0, get: function() {
    return u.parseJsonRpcRequest;
  } }), Object.defineProperty(e, "parseJsonRpcResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcResponse;
  } }), Object.defineProperty(e, "parseJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcSuccessResponse;
  } });
  var c = types$9;
  Object.defineProperty(e, "isJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return c.isJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "isJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return c.isJsonRpcSuccessResponse;
  } }), Object.defineProperty(e, "jsonRpcCode", { enumerable: !0, get: function() {
    return c.jsonRpcCode;
  } });
})(build$t);
var http$5 = {};
function bind$7(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: toString$5 } = Object.prototype, { getPrototypeOf: getPrototypeOf$1 } = Object, kindOf$2 = ((e) => (n) => {
  const o = toString$5.call(n);
  return e[o] || (e[o] = o.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest$2 = (e) => (e = e.toLowerCase(), (n) => kindOf$2(n) === e), typeOfTest$1 = (e) => (n) => typeof n === e, { isArray: isArray$4 } = Array, isUndefined$3 = typeOfTest$1("undefined");
function isBuffer$3(e) {
  return e !== null && !isUndefined$3(e) && e.constructor !== null && !isUndefined$3(e.constructor) && isFunction$4(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const isArrayBuffer$3 = kindOfTest$2("ArrayBuffer");
function isArrayBufferView$3(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && isArrayBuffer$3(e.buffer), n;
}
const isString$3 = typeOfTest$1("string"), isFunction$4 = typeOfTest$1("function"), isNumber$3 = typeOfTest$1("number"), isObject$5 = (e) => e !== null && typeof e == "object", isBoolean$1 = (e) => e === !0 || e === !1, isPlainObject$3 = (e) => {
  if (kindOf$2(e) !== "object")
    return !1;
  const n = getPrototypeOf$1(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, isDate$3 = kindOfTest$2("Date"), isFile$3 = kindOfTest$2("File"), isBlob$3 = kindOfTest$2("Blob"), isFileList$2 = kindOfTest$2("FileList"), isStream$3 = (e) => isObject$5(e) && isFunction$4(e.pipe), isFormData$3 = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || isFunction$4(e.append) && ((n = kindOf$2(e)) === "formdata" || // detect form-data instance
  n === "object" && isFunction$4(e.toString) && e.toString() === "[object FormData]"));
}, isURLSearchParams$3 = kindOfTest$2("URLSearchParams"), trim$4 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach$3(e, n, { allOwnKeys: o = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let u, c;
  if (typeof e != "object" && (e = [e]), isArray$4(e))
    for (u = 0, c = e.length; u < c; u++)
      n.call(null, e[u], u, e);
  else {
    const d = o ? Object.getOwnPropertyNames(e) : Object.keys(e), m = d.length;
    let v;
    for (u = 0; u < m; u++)
      v = d[u], n.call(null, e[v], v, e);
  }
}
function findKey$1(e, n) {
  n = n.toLowerCase();
  const o = Object.keys(e);
  let u = o.length, c;
  for (; u-- > 0; )
    if (c = o[u], n === c.toLowerCase())
      return c;
  return null;
}
const _global$1 = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : commonjsGlobal)(), isContextDefined$1 = (e) => !isUndefined$3(e) && e !== _global$1;
function merge$4() {
  const { caseless: e } = isContextDefined$1(this) && this || {}, n = {}, o = (u, c) => {
    const d = e && findKey$1(n, c) || c;
    isPlainObject$3(n[d]) && isPlainObject$3(u) ? n[d] = merge$4(n[d], u) : isPlainObject$3(u) ? n[d] = merge$4({}, u) : isArray$4(u) ? n[d] = u.slice() : n[d] = u;
  };
  for (let u = 0, c = arguments.length; u < c; u++)
    arguments[u] && forEach$3(arguments[u], o);
  return n;
}
const extend$3 = (e, n, o, { allOwnKeys: u } = {}) => (forEach$3(n, (c, d) => {
  o && isFunction$4(c) ? e[d] = bind$7(c, o) : e[d] = c;
}, { allOwnKeys: u }), e), stripBOM$3 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits$2 = (e, n, o, u) => {
  e.prototype = Object.create(n.prototype, u), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), o && Object.assign(e.prototype, o);
}, toFlatObject$2 = (e, n, o, u) => {
  let c, d, m;
  const v = {};
  if (n = n || {}, e == null)
    return n;
  do {
    for (c = Object.getOwnPropertyNames(e), d = c.length; d-- > 0; )
      m = c[d], (!u || u(m, e, n)) && !v[m] && (n[m] = e[m], v[m] = !0);
    e = o !== !1 && getPrototypeOf$1(e);
  } while (e && (!o || o(e, n)) && e !== Object.prototype);
  return n;
}, endsWith$2 = (e, n, o) => {
  e = String(e), (o === void 0 || o > e.length) && (o = e.length), o -= n.length;
  const u = e.indexOf(n, o);
  return u !== -1 && u === o;
}, toArray$2 = (e) => {
  if (!e)
    return null;
  if (isArray$4(e))
    return e;
  let n = e.length;
  if (!isNumber$3(n))
    return null;
  const o = new Array(n);
  for (; n-- > 0; )
    o[n] = e[n];
  return o;
}, isTypedArray$2 = ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && getPrototypeOf$1(Uint8Array)), forEachEntry$1 = (e, n) => {
  const u = (e && e[Symbol.iterator]).call(e);
  let c;
  for (; (c = u.next()) && !c.done; ) {
    const d = c.value;
    n.call(e, d[0], d[1]);
  }
}, matchAll$1 = (e, n) => {
  let o;
  const u = [];
  for (; (o = e.exec(n)) !== null; )
    u.push(o);
  return u;
}, isHTMLForm$1 = kindOfTest$2("HTMLFormElement"), toCamelCase$1 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(o, u, c) {
    return u.toUpperCase() + c;
  }
), hasOwnProperty$1 = (({ hasOwnProperty: e }) => (n, o) => e.call(n, o))(Object.prototype), isRegExp$1 = kindOfTest$2("RegExp"), reduceDescriptors$1 = (e, n) => {
  const o = Object.getOwnPropertyDescriptors(e), u = {};
  forEach$3(o, (c, d) => {
    let m;
    (m = n(c, d, e)) !== !1 && (u[d] = m || c);
  }), Object.defineProperties(e, u);
}, freezeMethods$1 = (e) => {
  reduceDescriptors$1(e, (n, o) => {
    if (isFunction$4(e) && ["arguments", "caller", "callee"].indexOf(o) !== -1)
      return !1;
    const u = e[o];
    if (isFunction$4(u)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + o + "'");
      });
    }
  });
}, toObjectSet$1 = (e, n) => {
  const o = {}, u = (c) => {
    c.forEach((d) => {
      o[d] = !0;
    });
  };
  return isArray$4(e) ? u(e) : u(String(e).split(n)), o;
}, noop$2 = () => {
}, toFiniteNumber$1 = (e, n) => (e = +e, Number.isFinite(e) ? e : n), ALPHA$1 = "abcdefghijklmnopqrstuvwxyz", DIGIT$1 = "0123456789", ALPHABET$1 = {
  DIGIT: DIGIT$1,
  ALPHA: ALPHA$1,
  ALPHA_DIGIT: ALPHA$1 + ALPHA$1.toUpperCase() + DIGIT$1
}, generateString$1 = (e = 16, n = ALPHABET$1.ALPHA_DIGIT) => {
  let o = "";
  const { length: u } = n;
  for (; e--; )
    o += n[Math.random() * u | 0];
  return o;
};
function isSpecCompliantForm$1(e) {
  return !!(e && isFunction$4(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const toJSONObject$1 = (e) => {
  const n = new Array(10), o = (u, c) => {
    if (isObject$5(u)) {
      if (n.indexOf(u) >= 0)
        return;
      if (!("toJSON" in u)) {
        n[c] = u;
        const d = isArray$4(u) ? [] : {};
        return forEach$3(u, (m, v) => {
          const S = o(m, c + 1);
          !isUndefined$3(S) && (d[v] = S);
        }), n[c] = void 0, d;
      }
    }
    return u;
  };
  return o(e, 0);
}, isAsyncFn$1 = kindOfTest$2("AsyncFunction"), isThenable$1 = (e) => e && (isObject$5(e) || isFunction$4(e)) && isFunction$4(e.then) && isFunction$4(e.catch);
var utils$1$2 = {
  isArray: isArray$4,
  isArrayBuffer: isArrayBuffer$3,
  isBuffer: isBuffer$3,
  isFormData: isFormData$3,
  isArrayBufferView: isArrayBufferView$3,
  isString: isString$3,
  isNumber: isNumber$3,
  isBoolean: isBoolean$1,
  isObject: isObject$5,
  isPlainObject: isPlainObject$3,
  isUndefined: isUndefined$3,
  isDate: isDate$3,
  isFile: isFile$3,
  isBlob: isBlob$3,
  isRegExp: isRegExp$1,
  isFunction: isFunction$4,
  isStream: isStream$3,
  isURLSearchParams: isURLSearchParams$3,
  isTypedArray: isTypedArray$2,
  isFileList: isFileList$2,
  forEach: forEach$3,
  merge: merge$4,
  extend: extend$3,
  trim: trim$4,
  stripBOM: stripBOM$3,
  inherits: inherits$2,
  toFlatObject: toFlatObject$2,
  kindOf: kindOf$2,
  kindOfTest: kindOfTest$2,
  endsWith: endsWith$2,
  toArray: toArray$2,
  forEachEntry: forEachEntry$1,
  matchAll: matchAll$1,
  isHTMLForm: isHTMLForm$1,
  hasOwnProperty: hasOwnProperty$1,
  hasOwnProp: hasOwnProperty$1,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: reduceDescriptors$1,
  freezeMethods: freezeMethods$1,
  toObjectSet: toObjectSet$1,
  toCamelCase: toCamelCase$1,
  noop: noop$2,
  toFiniteNumber: toFiniteNumber$1,
  findKey: findKey$1,
  global: _global$1,
  isContextDefined: isContextDefined$1,
  ALPHABET: ALPHABET$1,
  generateString: generateString$1,
  isSpecCompliantForm: isSpecCompliantForm$1,
  toJSONObject: toJSONObject$1,
  isAsyncFn: isAsyncFn$1,
  isThenable: isThenable$1
};
function AxiosError$4(e, n, o, u, c) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), o && (this.config = o), u && (this.request = u), c && (this.response = c);
}
utils$1$2.inherits(AxiosError$4, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1$2.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1$1 = AxiosError$4.prototype, descriptors$2 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  descriptors$2[e] = { value: e };
});
Object.defineProperties(AxiosError$4, descriptors$2);
Object.defineProperty(prototype$1$1, "isAxiosError", { value: !0 });
AxiosError$4.from = (e, n, o, u, c, d) => {
  const m = Object.create(prototype$1$1);
  return utils$1$2.toFlatObject(e, m, function(S) {
    return S !== Error.prototype;
  }, (v) => v !== "isAxiosError"), AxiosError$4.call(m, e.message, n, o, u, c), m.cause = e, m.name = e.name, d && Object.assign(m, d), m;
};
var httpAdapter$1 = null;
function isVisitable$1(e) {
  return utils$1$2.isPlainObject(e) || utils$1$2.isArray(e);
}
function removeBrackets$1(e) {
  return utils$1$2.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function renderKey$1(e, n, o) {
  return e ? e.concat(n).map(function(c, d) {
    return c = removeBrackets$1(c), !o && d ? "[" + c + "]" : c;
  }).join(o ? "." : "") : n;
}
function isFlatArray$1(e) {
  return utils$1$2.isArray(e) && !e.some(isVisitable$1);
}
const predicates$1 = utils$1$2.toFlatObject(utils$1$2, {}, null, function e(n) {
  return /^is[A-Z]/.test(n);
});
function toFormData$3(e, n, o) {
  if (!utils$1$2.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), o = utils$1$2.toFlatObject(o, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(M, G) {
    return !utils$1$2.isUndefined(G[M]);
  });
  const u = o.metaTokens, c = o.visitor || E, d = o.dots, m = o.indexes, S = (o.Blob || typeof Blob < "u" && Blob) && utils$1$2.isSpecCompliantForm(n);
  if (!utils$1$2.isFunction(c))
    throw new TypeError("visitor must be a function");
  function $(V) {
    if (V === null)
      return "";
    if (utils$1$2.isDate(V))
      return V.toISOString();
    if (!S && utils$1$2.isBlob(V))
      throw new AxiosError$4("Blob is not supported. Use a Buffer instead.");
    return utils$1$2.isArrayBuffer(V) || utils$1$2.isTypedArray(V) ? S && typeof Blob == "function" ? new Blob([V]) : buffer$1.Buffer.from(V) : V;
  }
  function E(V, M, G) {
    let k = V;
    if (V && !G && typeof V == "object") {
      if (utils$1$2.endsWith(M, "{}"))
        M = u ? M : M.slice(0, -2), V = JSON.stringify(V);
      else if (utils$1$2.isArray(V) && isFlatArray$1(V) || (utils$1$2.isFileList(V) || utils$1$2.endsWith(M, "[]")) && (k = utils$1$2.toArray(V)))
        return M = removeBrackets$1(M), k.forEach(function(X, ee) {
          !(utils$1$2.isUndefined(X) || X === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            m === !0 ? renderKey$1([M], ee, d) : m === null ? M : M + "[]",
            $(X)
          );
        }), !1;
    }
    return isVisitable$1(V) ? !0 : (n.append(renderKey$1(G, M, d), $(V)), !1);
  }
  const O = [], T = Object.assign(predicates$1, {
    defaultVisitor: E,
    convertValue: $,
    isVisitable: isVisitable$1
  });
  function y(V, M) {
    if (!utils$1$2.isUndefined(V)) {
      if (O.indexOf(V) !== -1)
        throw Error("Circular reference detected in " + M.join("."));
      O.push(V), utils$1$2.forEach(V, function(k, F) {
        (!(utils$1$2.isUndefined(k) || k === null) && c.call(
          n,
          k,
          utils$1$2.isString(F) ? F.trim() : F,
          M,
          T
        )) === !0 && y(k, M ? M.concat(F) : [F]);
      }), O.pop();
    }
  }
  if (!utils$1$2.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), n;
}
function encode$1$2(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(u) {
    return n[u];
  });
}
function AxiosURLSearchParams$1(e, n) {
  this._pairs = [], e && toFormData$3(e, this, n);
}
const prototype$3 = AxiosURLSearchParams$1.prototype;
prototype$3.append = function e(n, o) {
  this._pairs.push([n, o]);
};
prototype$3.toString = function e(n) {
  const o = n ? function(u) {
    return n.call(this, u, encode$1$2);
  } : encode$1$2;
  return this._pairs.map(function(c) {
    return o(c[0]) + "=" + o(c[1]);
  }, "").join("&");
};
function encode$3(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL$5(e, n, o) {
  if (!n)
    return e;
  const u = o && o.encode || encode$3, c = o && o.serialize;
  let d;
  if (c ? d = c(n, o) : d = utils$1$2.isURLSearchParams(n) ? n.toString() : new AxiosURLSearchParams$1(n, o).toString(u), d) {
    const m = e.indexOf("#");
    m !== -1 && (e = e.slice(0, m)), e += (e.indexOf("?") === -1 ? "?" : "&") + d;
  }
  return e;
}
let InterceptorManager$5 = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, o, u) {
    return this.handlers.push({
      fulfilled: n,
      rejected: o,
      synchronous: u ? u.synchronous : !1,
      runWhen: u ? u.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    utils$1$2.forEach(this.handlers, function(u) {
      u !== null && n(u);
    });
  }
};
var InterceptorManager$1$2 = InterceptorManager$5, transitionalDefaults$2 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams$1, FormData$1$1 = typeof FormData < "u" ? FormData : null, Blob$1$1 = typeof Blob < "u" ? Blob : null, platform$1$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1$1,
    FormData: FormData$1$1,
    Blob: Blob$1$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv$1 = typeof window < "u" && typeof document < "u", hasStandardBrowserEnv$1 = ((e) => hasBrowserEnv$1 && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), hasStandardBrowserWebWorkerEnv$1 = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")();
var utils$u = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  hasBrowserEnv: hasBrowserEnv$1,
  hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv$1,
  hasStandardBrowserEnv: hasStandardBrowserEnv$1
}), platform$2 = {
  ...utils$u,
  ...platform$1$1
};
function toURLEncodedForm$1(e, n) {
  return toFormData$3(e, new platform$2.classes.URLSearchParams(), Object.assign({
    visitor: function(o, u, c, d) {
      return platform$2.isNode && utils$1$2.isBuffer(o) ? (this.append(u, o.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function parsePropPath$1(e) {
  return utils$1$2.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function arrayToObject$1(e) {
  const n = {}, o = Object.keys(e);
  let u;
  const c = o.length;
  let d;
  for (u = 0; u < c; u++)
    d = o[u], n[d] = e[d];
  return n;
}
function formDataToJSON$1(e) {
  function n(o, u, c, d) {
    let m = o[d++];
    const v = Number.isFinite(+m), S = d >= o.length;
    return m = !m && utils$1$2.isArray(c) ? c.length : m, S ? (utils$1$2.hasOwnProp(c, m) ? c[m] = [c[m], u] : c[m] = u, !v) : ((!c[m] || !utils$1$2.isObject(c[m])) && (c[m] = []), n(o, u, c[m], d) && utils$1$2.isArray(c[m]) && (c[m] = arrayToObject$1(c[m])), !v);
  }
  if (utils$1$2.isFormData(e) && utils$1$2.isFunction(e.entries)) {
    const o = {};
    return utils$1$2.forEachEntry(e, (u, c) => {
      n(parsePropPath$1(u), c, o, 0);
    }), o;
  }
  return null;
}
function stringifySafely$3(e, n, o) {
  if (utils$1$2.isString(e))
    try {
      return (n || JSON.parse)(e), utils$1$2.trim(e);
    } catch (u) {
      if (u.name !== "SyntaxError")
        throw u;
    }
  return (o || JSON.stringify)(e);
}
const defaults$9 = {
  transitional: transitionalDefaults$2,
  adapter: ["xhr", "http"],
  transformRequest: [function e(n, o) {
    const u = o.getContentType() || "", c = u.indexOf("application/json") > -1, d = utils$1$2.isObject(n);
    if (d && utils$1$2.isHTMLForm(n) && (n = new FormData(n)), utils$1$2.isFormData(n))
      return c && c ? JSON.stringify(formDataToJSON$1(n)) : n;
    if (utils$1$2.isArrayBuffer(n) || utils$1$2.isBuffer(n) || utils$1$2.isStream(n) || utils$1$2.isFile(n) || utils$1$2.isBlob(n))
      return n;
    if (utils$1$2.isArrayBufferView(n))
      return n.buffer;
    if (utils$1$2.isURLSearchParams(n))
      return o.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let v;
    if (d) {
      if (u.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm$1(n, this.formSerializer).toString();
      if ((v = utils$1$2.isFileList(n)) || u.indexOf("multipart/form-data") > -1) {
        const S = this.env && this.env.FormData;
        return toFormData$3(
          v ? { "files[]": n } : n,
          S && new S(),
          this.formSerializer
        );
      }
    }
    return d || c ? (o.setContentType("application/json", !1), stringifySafely$3(n)) : n;
  }],
  transformResponse: [function e(n) {
    const o = this.transitional || defaults$9.transitional, u = o && o.forcedJSONParsing, c = this.responseType === "json";
    if (n && utils$1$2.isString(n) && (u && !this.responseType || c)) {
      const m = !(o && o.silentJSONParsing) && c;
      try {
        return JSON.parse(n);
      } catch (v) {
        if (m)
          throw v.name === "SyntaxError" ? AxiosError$4.from(v, AxiosError$4.ERR_BAD_RESPONSE, this, null, this.response) : v;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform$2.classes.FormData,
    Blob: platform$2.classes.Blob
  },
  validateStatus: function e(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1$2.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  defaults$9.headers[e] = {};
});
var defaults$1$2 = defaults$9;
const ignoreDuplicateOf$1 = utils$1$2.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
var parseHeaders$3 = (e) => {
  const n = {};
  let o, u, c;
  return e && e.split(`
`).forEach(function(m) {
    c = m.indexOf(":"), o = m.substring(0, c).trim().toLowerCase(), u = m.substring(c + 1).trim(), !(!o || n[o] && ignoreDuplicateOf$1[o]) && (o === "set-cookie" ? n[o] ? n[o].push(u) : n[o] = [u] : n[o] = n[o] ? n[o] + ", " + u : u);
  }), n;
};
const $internals$1 = Symbol("internals");
function normalizeHeader$1(e) {
  return e && String(e).trim().toLowerCase();
}
function normalizeValue$1(e) {
  return e === !1 || e == null ? e : utils$1$2.isArray(e) ? e.map(normalizeValue$1) : String(e);
}
function parseTokens$1(e) {
  const n = /* @__PURE__ */ Object.create(null), o = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let u;
  for (; u = o.exec(e); )
    n[u[1]] = u[2];
  return n;
}
const isValidHeaderName$1 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function matchHeaderValue$1(e, n, o, u, c) {
  if (utils$1$2.isFunction(u))
    return u.call(this, n, o);
  if (c && (n = o), !!utils$1$2.isString(n)) {
    if (utils$1$2.isString(u))
      return n.indexOf(u) !== -1;
    if (utils$1$2.isRegExp(u))
      return u.test(n);
  }
}
function formatHeader$1(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, o, u) => o.toUpperCase() + u);
}
function buildAccessors$1(e, n) {
  const o = utils$1$2.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((u) => {
    Object.defineProperty(e, u + o, {
      value: function(c, d, m) {
        return this[u].call(this, n, c, d, m);
      },
      configurable: !0
    });
  });
}
let AxiosHeaders$2 = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, o, u) {
    const c = this;
    function d(v, S, $) {
      const E = normalizeHeader$1(S);
      if (!E)
        throw new Error("header name must be a non-empty string");
      const O = utils$1$2.findKey(c, E);
      (!O || c[O] === void 0 || $ === !0 || $ === void 0 && c[O] !== !1) && (c[O || S] = normalizeValue$1(v));
    }
    const m = (v, S) => utils$1$2.forEach(v, ($, E) => d($, E, S));
    return utils$1$2.isPlainObject(n) || n instanceof this.constructor ? m(n, o) : utils$1$2.isString(n) && (n = n.trim()) && !isValidHeaderName$1(n) ? m(parseHeaders$3(n), o) : n != null && d(o, n, u), this;
  }
  get(n, o) {
    if (n = normalizeHeader$1(n), n) {
      const u = utils$1$2.findKey(this, n);
      if (u) {
        const c = this[u];
        if (!o)
          return c;
        if (o === !0)
          return parseTokens$1(c);
        if (utils$1$2.isFunction(o))
          return o.call(this, c, u);
        if (utils$1$2.isRegExp(o))
          return o.exec(c);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, o) {
    if (n = normalizeHeader$1(n), n) {
      const u = utils$1$2.findKey(this, n);
      return !!(u && this[u] !== void 0 && (!o || matchHeaderValue$1(this, this[u], u, o)));
    }
    return !1;
  }
  delete(n, o) {
    const u = this;
    let c = !1;
    function d(m) {
      if (m = normalizeHeader$1(m), m) {
        const v = utils$1$2.findKey(u, m);
        v && (!o || matchHeaderValue$1(u, u[v], v, o)) && (delete u[v], c = !0);
      }
    }
    return utils$1$2.isArray(n) ? n.forEach(d) : d(n), c;
  }
  clear(n) {
    const o = Object.keys(this);
    let u = o.length, c = !1;
    for (; u--; ) {
      const d = o[u];
      (!n || matchHeaderValue$1(this, this[d], d, n, !0)) && (delete this[d], c = !0);
    }
    return c;
  }
  normalize(n) {
    const o = this, u = {};
    return utils$1$2.forEach(this, (c, d) => {
      const m = utils$1$2.findKey(u, d);
      if (m) {
        o[m] = normalizeValue$1(c), delete o[d];
        return;
      }
      const v = n ? formatHeader$1(d) : String(d).trim();
      v !== d && delete o[d], o[v] = normalizeValue$1(c), u[v] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const o = /* @__PURE__ */ Object.create(null);
    return utils$1$2.forEach(this, (u, c) => {
      u != null && u !== !1 && (o[c] = n && utils$1$2.isArray(u) ? u.join(", ") : u);
    }), o;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, o]) => n + ": " + o).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...o) {
    const u = new this(n);
    return o.forEach((c) => u.set(c)), u;
  }
  static accessor(n) {
    const u = (this[$internals$1] = this[$internals$1] = {
      accessors: {}
    }).accessors, c = this.prototype;
    function d(m) {
      const v = normalizeHeader$1(m);
      u[v] || (buildAccessors$1(c, m), u[v] = !0);
    }
    return utils$1$2.isArray(n) ? n.forEach(d) : d(n), this;
  }
};
AxiosHeaders$2.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1$2.reduceDescriptors(AxiosHeaders$2.prototype, ({ value: e }, n) => {
  let o = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(u) {
      this[o] = u;
    }
  };
});
utils$1$2.freezeMethods(AxiosHeaders$2);
var AxiosHeaders$1$1 = AxiosHeaders$2;
function transformData$5(e, n) {
  const o = this || defaults$1$2, u = n || o, c = AxiosHeaders$1$1.from(u.headers);
  let d = u.data;
  return utils$1$2.forEach(e, function(v) {
    d = v.call(o, d, c.normalize(), n ? n.status : void 0);
  }), c.normalize(), d;
}
function isCancel$5(e) {
  return !!(e && e.__CANCEL__);
}
function CanceledError$2(e, n, o) {
  AxiosError$4.call(this, e ?? "canceled", AxiosError$4.ERR_CANCELED, n, o), this.name = "CanceledError";
}
utils$1$2.inherits(CanceledError$2, AxiosError$4, {
  __CANCEL__: !0
});
function settle$3(e, n, o) {
  const u = o.config.validateStatus;
  !o.status || !u || u(o.status) ? e(o) : n(new AxiosError$4(
    "Request failed with status code " + o.status,
    [AxiosError$4.ERR_BAD_REQUEST, AxiosError$4.ERR_BAD_RESPONSE][Math.floor(o.status / 100) - 4],
    o.config,
    o.request,
    o
  ));
}
var cookies$3 = platform$2.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, o, u, c, d) {
      const m = [e + "=" + encodeURIComponent(n)];
      utils$1$2.isNumber(o) && m.push("expires=" + new Date(o).toGMTString()), utils$1$2.isString(u) && m.push("path=" + u), utils$1$2.isString(c) && m.push("domain=" + c), d === !0 && m.push("secure"), document.cookie = m.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL$4(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function combineURLs$4(e, n) {
  return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function buildFullPath$4(e, n) {
  return e && !isAbsoluteURL$4(n) ? combineURLs$4(e, n) : n;
}
var isURLSameOrigin$3 = platform$2.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function e() {
    const n = /(msie|trident)/i.test(navigator.userAgent), o = document.createElement("a");
    let u;
    function c(d) {
      let m = d;
      return n && (o.setAttribute("href", m), m = o.href), o.setAttribute("href", m), {
        href: o.href,
        protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
        host: o.host,
        search: o.search ? o.search.replace(/^\?/, "") : "",
        hash: o.hash ? o.hash.replace(/^#/, "") : "",
        hostname: o.hostname,
        port: o.port,
        pathname: o.pathname.charAt(0) === "/" ? o.pathname : "/" + o.pathname
      };
    }
    return u = c(window.location.href), function(m) {
      const v = utils$1$2.isString(m) ? c(m) : m;
      return v.protocol === u.protocol && v.host === u.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function e() {
    return function() {
      return !0;
    };
  }()
);
function parseProtocol$2(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function speedometer$1(e, n) {
  e = e || 10;
  const o = new Array(e), u = new Array(e);
  let c = 0, d = 0, m;
  return n = n !== void 0 ? n : 1e3, function(S) {
    const $ = Date.now(), E = u[d];
    m || (m = $), o[c] = S, u[c] = $;
    let O = d, T = 0;
    for (; O !== c; )
      T += o[O++], O = O % e;
    if (c = (c + 1) % e, c === d && (d = (d + 1) % e), $ - m < n)
      return;
    const y = E && $ - E;
    return y ? Math.round(T * 1e3 / y) : void 0;
  };
}
function progressEventReducer$1(e, n) {
  let o = 0;
  const u = speedometer$1(50, 250);
  return (c) => {
    const d = c.loaded, m = c.lengthComputable ? c.total : void 0, v = d - o, S = u(v), $ = d <= m;
    o = d;
    const E = {
      loaded: d,
      total: m,
      progress: m ? d / m : void 0,
      bytes: v,
      rate: S || void 0,
      estimated: S && m && $ ? (m - d) / S : void 0,
      event: c
    };
    E[n ? "download" : "upload"] = !0, e(E);
  };
}
const isXHRAdapterSupported$1 = typeof XMLHttpRequest < "u";
var xhrAdapter$1 = isXHRAdapterSupported$1 && function(e) {
  return new Promise(function(o, u) {
    let c = e.data;
    const d = AxiosHeaders$1$1.from(e.headers).normalize();
    let { responseType: m, withXSRFToken: v } = e, S;
    function $() {
      e.cancelToken && e.cancelToken.unsubscribe(S), e.signal && e.signal.removeEventListener("abort", S);
    }
    let E;
    if (utils$1$2.isFormData(c)) {
      if (platform$2.hasStandardBrowserEnv || platform$2.hasStandardBrowserWebWorkerEnv)
        d.setContentType(!1);
      else if ((E = d.getContentType()) !== !1) {
        const [M, ...G] = E ? E.split(";").map((k) => k.trim()).filter(Boolean) : [];
        d.setContentType([M || "multipart/form-data", ...G].join("; "));
      }
    }
    let O = new XMLHttpRequest();
    if (e.auth) {
      const M = e.auth.username || "", G = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      d.set("Authorization", "Basic " + btoa(M + ":" + G));
    }
    const T = buildFullPath$4(e.baseURL, e.url);
    O.open(e.method.toUpperCase(), buildURL$5(T, e.params, e.paramsSerializer), !0), O.timeout = e.timeout;
    function y() {
      if (!O)
        return;
      const M = AxiosHeaders$1$1.from(
        "getAllResponseHeaders" in O && O.getAllResponseHeaders()
      ), k = {
        data: !m || m === "text" || m === "json" ? O.responseText : O.response,
        status: O.status,
        statusText: O.statusText,
        headers: M,
        config: e,
        request: O
      };
      settle$3(function(X) {
        o(X), $();
      }, function(X) {
        u(X), $();
      }, k), O = null;
    }
    if ("onloadend" in O ? O.onloadend = y : O.onreadystatechange = function() {
      !O || O.readyState !== 4 || O.status === 0 && !(O.responseURL && O.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, O.onabort = function() {
      O && (u(new AxiosError$4("Request aborted", AxiosError$4.ECONNABORTED, e, O)), O = null);
    }, O.onerror = function() {
      u(new AxiosError$4("Network Error", AxiosError$4.ERR_NETWORK, e, O)), O = null;
    }, O.ontimeout = function() {
      let G = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const k = e.transitional || transitionalDefaults$2;
      e.timeoutErrorMessage && (G = e.timeoutErrorMessage), u(new AxiosError$4(
        G,
        k.clarifyTimeoutError ? AxiosError$4.ETIMEDOUT : AxiosError$4.ECONNABORTED,
        e,
        O
      )), O = null;
    }, platform$2.hasStandardBrowserEnv && (v && utils$1$2.isFunction(v) && (v = v(e)), v || v !== !1 && isURLSameOrigin$3(T))) {
      const M = e.xsrfHeaderName && e.xsrfCookieName && cookies$3.read(e.xsrfCookieName);
      M && d.set(e.xsrfHeaderName, M);
    }
    c === void 0 && d.setContentType(null), "setRequestHeader" in O && utils$1$2.forEach(d.toJSON(), function(G, k) {
      O.setRequestHeader(k, G);
    }), utils$1$2.isUndefined(e.withCredentials) || (O.withCredentials = !!e.withCredentials), m && m !== "json" && (O.responseType = e.responseType), typeof e.onDownloadProgress == "function" && O.addEventListener("progress", progressEventReducer$1(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && O.upload && O.upload.addEventListener("progress", progressEventReducer$1(e.onUploadProgress)), (e.cancelToken || e.signal) && (S = (M) => {
      O && (u(!M || M.type ? new CanceledError$2(null, e, O) : M), O.abort(), O = null);
    }, e.cancelToken && e.cancelToken.subscribe(S), e.signal && (e.signal.aborted ? S() : e.signal.addEventListener("abort", S)));
    const V = parseProtocol$2(T);
    if (V && platform$2.protocols.indexOf(V) === -1) {
      u(new AxiosError$4("Unsupported protocol " + V + ":", AxiosError$4.ERR_BAD_REQUEST, e));
      return;
    }
    O.send(c || null);
  });
};
const knownAdapters$1 = {
  http: httpAdapter$1,
  xhr: xhrAdapter$1
};
utils$1$2.forEach(knownAdapters$1, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const renderReason$1 = (e) => `- ${e}`, isResolvedHandle$1 = (e) => utils$1$2.isFunction(e) || e === null || e === !1;
var adapters$1 = {
  getAdapter: (e) => {
    e = utils$1$2.isArray(e) ? e : [e];
    const { length: n } = e;
    let o, u;
    const c = {};
    for (let d = 0; d < n; d++) {
      o = e[d];
      let m;
      if (u = o, !isResolvedHandle$1(o) && (u = knownAdapters$1[(m = String(o)).toLowerCase()], u === void 0))
        throw new AxiosError$4(`Unknown adapter '${m}'`);
      if (u)
        break;
      c[m || "#" + d] = u;
    }
    if (!u) {
      const d = Object.entries(c).map(
        ([v, S]) => `adapter ${v} ` + (S === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let m = n ? d.length > 1 ? `since :
` + d.map(renderReason$1).join(`
`) : " " + renderReason$1(d[0]) : "as no adapter specified";
      throw new AxiosError$4(
        "There is no suitable adapter to dispatch the request " + m,
        "ERR_NOT_SUPPORT"
      );
    }
    return u;
  },
  adapters: knownAdapters$1
};
function throwIfCancellationRequested$3(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError$2(null, e);
}
function dispatchRequest$5(e) {
  return throwIfCancellationRequested$3(e), e.headers = AxiosHeaders$1$1.from(e.headers), e.data = transformData$5.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), adapters$1.getAdapter(e.adapter || defaults$1$2.adapter)(e).then(function(u) {
    return throwIfCancellationRequested$3(e), u.data = transformData$5.call(
      e,
      e.transformResponse,
      u
    ), u.headers = AxiosHeaders$1$1.from(u.headers), u;
  }, function(u) {
    return isCancel$5(u) || (throwIfCancellationRequested$3(e), u && u.response && (u.response.data = transformData$5.call(
      e,
      e.transformResponse,
      u.response
    ), u.response.headers = AxiosHeaders$1$1.from(u.response.headers))), Promise.reject(u);
  });
}
const headersToObject$1 = (e) => e instanceof AxiosHeaders$1$1 ? e.toJSON() : e;
function mergeConfig$7(e, n) {
  n = n || {};
  const o = {};
  function u($, E, O) {
    return utils$1$2.isPlainObject($) && utils$1$2.isPlainObject(E) ? utils$1$2.merge.call({ caseless: O }, $, E) : utils$1$2.isPlainObject(E) ? utils$1$2.merge({}, E) : utils$1$2.isArray(E) ? E.slice() : E;
  }
  function c($, E, O) {
    if (utils$1$2.isUndefined(E)) {
      if (!utils$1$2.isUndefined($))
        return u(void 0, $, O);
    } else
      return u($, E, O);
  }
  function d($, E) {
    if (!utils$1$2.isUndefined(E))
      return u(void 0, E);
  }
  function m($, E) {
    if (utils$1$2.isUndefined(E)) {
      if (!utils$1$2.isUndefined($))
        return u(void 0, $);
    } else
      return u(void 0, E);
  }
  function v($, E, O) {
    if (O in n)
      return u($, E);
    if (O in e)
      return u(void 0, $);
  }
  const S = {
    url: d,
    method: d,
    data: d,
    baseURL: m,
    transformRequest: m,
    transformResponse: m,
    paramsSerializer: m,
    timeout: m,
    timeoutMessage: m,
    withCredentials: m,
    withXSRFToken: m,
    adapter: m,
    responseType: m,
    xsrfCookieName: m,
    xsrfHeaderName: m,
    onUploadProgress: m,
    onDownloadProgress: m,
    decompress: m,
    maxContentLength: m,
    maxBodyLength: m,
    beforeRedirect: m,
    transport: m,
    httpAgent: m,
    httpsAgent: m,
    cancelToken: m,
    socketPath: m,
    responseEncoding: m,
    validateStatus: v,
    headers: ($, E) => c(headersToObject$1($), headersToObject$1(E), !0)
  };
  return utils$1$2.forEach(Object.keys(Object.assign({}, e, n)), function(E) {
    const O = S[E] || c, T = O(e[E], n[E], E);
    utils$1$2.isUndefined(T) && O !== v || (o[E] = T);
  }), o;
}
const VERSION$2 = "1.6.2", validators$1$2 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  validators$1$2[e] = function(u) {
    return typeof u === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const deprecatedWarnings$3 = {};
validators$1$2.transitional = function e(n, o, u) {
  function c(d, m) {
    return "[Axios v" + VERSION$2 + "] Transitional option '" + d + "'" + m + (u ? ". " + u : "");
  }
  return (d, m, v) => {
    if (n === !1)
      throw new AxiosError$4(
        c(m, " has been removed" + (o ? " in " + o : "")),
        AxiosError$4.ERR_DEPRECATED
      );
    return o && !deprecatedWarnings$3[m] && (deprecatedWarnings$3[m] = !0, console.warn(
      c(
        m,
        " has been deprecated since v" + o + " and will be removed in the near future"
      )
    )), n ? n(d, m, v) : !0;
  };
};
function assertOptions$3(e, n, o) {
  if (typeof e != "object")
    throw new AxiosError$4("options must be an object", AxiosError$4.ERR_BAD_OPTION_VALUE);
  const u = Object.keys(e);
  let c = u.length;
  for (; c-- > 0; ) {
    const d = u[c], m = n[d];
    if (m) {
      const v = e[d], S = v === void 0 || m(v, d, e);
      if (S !== !0)
        throw new AxiosError$4("option " + d + " must be " + S, AxiosError$4.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (o !== !0)
      throw new AxiosError$4("Unknown option " + d, AxiosError$4.ERR_BAD_OPTION);
  }
}
var validator$9 = {
  assertOptions: assertOptions$3,
  validators: validators$1$2
};
const validators$5 = validator$9.validators;
let Axios$5 = class {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new InterceptorManager$1$2(),
      response: new InterceptorManager$1$2()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(n, o) {
    typeof n == "string" ? (o = o || {}, o.url = n) : o = n || {}, o = mergeConfig$7(this.defaults, o);
    const { transitional: u, paramsSerializer: c, headers: d } = o;
    u !== void 0 && validator$9.assertOptions(u, {
      silentJSONParsing: validators$5.transitional(validators$5.boolean),
      forcedJSONParsing: validators$5.transitional(validators$5.boolean),
      clarifyTimeoutError: validators$5.transitional(validators$5.boolean)
    }, !1), c != null && (utils$1$2.isFunction(c) ? o.paramsSerializer = {
      serialize: c
    } : validator$9.assertOptions(c, {
      encode: validators$5.function,
      serialize: validators$5.function
    }, !0)), o.method = (o.method || this.defaults.method || "get").toLowerCase();
    let m = d && utils$1$2.merge(
      d.common,
      d[o.method]
    );
    d && utils$1$2.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (V) => {
        delete d[V];
      }
    ), o.headers = AxiosHeaders$1$1.concat(m, d);
    const v = [];
    let S = !0;
    this.interceptors.request.forEach(function(M) {
      typeof M.runWhen == "function" && M.runWhen(o) === !1 || (S = S && M.synchronous, v.unshift(M.fulfilled, M.rejected));
    });
    const $ = [];
    this.interceptors.response.forEach(function(M) {
      $.push(M.fulfilled, M.rejected);
    });
    let E, O = 0, T;
    if (!S) {
      const V = [dispatchRequest$5.bind(this), void 0];
      for (V.unshift.apply(V, v), V.push.apply(V, $), T = V.length, E = Promise.resolve(o); O < T; )
        E = E.then(V[O++], V[O++]);
      return E;
    }
    T = v.length;
    let y = o;
    for (O = 0; O < T; ) {
      const V = v[O++], M = v[O++];
      try {
        y = V(y);
      } catch (G) {
        M.call(this, G);
        break;
      }
    }
    try {
      E = dispatchRequest$5.call(this, y);
    } catch (V) {
      return Promise.reject(V);
    }
    for (O = 0, T = $.length; O < T; )
      E = E.then($[O++], $[O++]);
    return E;
  }
  getUri(n) {
    n = mergeConfig$7(this.defaults, n);
    const o = buildFullPath$4(n.baseURL, n.url);
    return buildURL$5(o, n.params, n.paramsSerializer);
  }
};
utils$1$2.forEach(["delete", "get", "head", "options"], function e(n) {
  Axios$5.prototype[n] = function(o, u) {
    return this.request(mergeConfig$7(u || {}, {
      method: n,
      url: o,
      data: (u || {}).data
    }));
  };
});
utils$1$2.forEach(["post", "put", "patch"], function e(n) {
  function o(u) {
    return function(d, m, v) {
      return this.request(mergeConfig$7(v || {}, {
        method: n,
        headers: u ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: d,
        data: m
      }));
    };
  }
  Axios$5.prototype[n] = o(), Axios$5.prototype[n + "Form"] = o(!0);
});
var Axios$1$2 = Axios$5;
let CancelToken$2 = class nd {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let o;
    this.promise = new Promise(function(d) {
      o = d;
    });
    const u = this;
    this.promise.then((c) => {
      if (!u._listeners)
        return;
      let d = u._listeners.length;
      for (; d-- > 0; )
        u._listeners[d](c);
      u._listeners = null;
    }), this.promise.then = (c) => {
      let d;
      const m = new Promise((v) => {
        u.subscribe(v), d = v;
      }).then(c);
      return m.cancel = function() {
        u.unsubscribe(d);
      }, m;
    }, n(function(d, m, v) {
      u.reason || (u.reason = new CanceledError$2(d, m, v), o(u.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const o = this._listeners.indexOf(n);
    o !== -1 && this._listeners.splice(o, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new nd(function(c) {
        n = c;
      }),
      cancel: n
    };
  }
};
var CancelToken$1$1 = CancelToken$2;
function spread$3(e) {
  return function(o) {
    return e.apply(null, o);
  };
}
function isAxiosError$3(e) {
  return utils$1$2.isObject(e) && e.isAxiosError === !0;
}
const HttpStatusCode$2 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode$2).forEach(([e, n]) => {
  HttpStatusCode$2[n] = e;
});
var HttpStatusCode$1$1 = HttpStatusCode$2;
function createInstance$3(e) {
  const n = new Axios$1$2(e), o = bind$7(Axios$1$2.prototype.request, n);
  return utils$1$2.extend(o, Axios$1$2.prototype, n, { allOwnKeys: !0 }), utils$1$2.extend(o, n, null, { allOwnKeys: !0 }), o.create = function(c) {
    return createInstance$3(mergeConfig$7(e, c));
  }, o;
}
const axios$8 = createInstance$3(defaults$1$2);
axios$8.Axios = Axios$1$2;
axios$8.CanceledError = CanceledError$2;
axios$8.CancelToken = CancelToken$1$1;
axios$8.isCancel = isCancel$5;
axios$8.VERSION = VERSION$2;
axios$8.toFormData = toFormData$3;
axios$8.AxiosError = AxiosError$4;
axios$8.Cancel = axios$8.CanceledError;
axios$8.all = function e(n) {
  return Promise.all(n);
};
axios$8.spread = spread$3;
axios$8.isAxiosError = isAxiosError$3;
axios$8.mergeConfig = mergeConfig$7;
axios$8.AxiosHeaders = AxiosHeaders$1$1;
axios$8.formToJSON = (e) => formDataToJSON$1(utils$1$2.isHTMLForm(e) ? new FormData(e) : e);
axios$8.getAdapter = adapters$1.getAdapter;
axios$8.HttpStatusCode = HttpStatusCode$1$1;
axios$8.default = axios$8;
var axios_1$4 = axios$8, __importDefault$u = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(http$5, "__esModule", { value: !0 });
http$5.http = void 0;
const axios_1$3 = __importDefault$u(axios_1$4);
function filterBadStatus$2(e) {
  if (e.status >= 400)
    throw new Error(`Bad status on response: ${e.status}`);
  return e;
}
function isExperimental$1(e) {
  return e.toString().includes("emitExperimentalWarning");
}
async function http$4(e, n, o, u) {
  if (typeof fetch == "function" && !isExperimental$1(fetch)) {
    const c = {
      method: e,
      body: u ? JSON.stringify(u) : void 0,
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json",
        ...o
      }
    };
    return fetch(n, c).then(filterBadStatus$2).then((d) => d.json());
  } else
    return axios_1$3.default.request({ url: n, method: e, data: u, headers: o }).then((c) => c.data);
}
http$5.http = http$4;
var rpcclient$2 = {};
Object.defineProperty(rpcclient$2, "__esModule", { value: !0 });
rpcclient$2.hasProtocol = rpcclient$2.instanceOfRpcStreamingClient = void 0;
function instanceOfRpcStreamingClient$2(e) {
  return typeof e.listen == "function";
}
rpcclient$2.instanceOfRpcStreamingClient = instanceOfRpcStreamingClient$2;
function hasProtocol$2(e) {
  return e.search("://") !== -1;
}
rpcclient$2.hasProtocol = hasProtocol$2;
Object.defineProperty(httpbatchclient$2, "__esModule", { value: !0 });
httpbatchclient$2.HttpBatchClient = void 0;
const json_rpc_1$8 = build$t, http_1$5 = http$5, rpcclient_1$8 = rpcclient$2, defaultHttpBatchClientOptions$2 = {
  dispatchInterval: 20,
  batchSizeLimit: 20
};
let HttpBatchClient$2 = class {
  constructor(n, o = {}) {
    if (this.queue = [], this.options = {
      batchSizeLimit: o.batchSizeLimit ?? defaultHttpBatchClientOptions$2.batchSizeLimit,
      dispatchInterval: o.dispatchInterval ?? defaultHttpBatchClientOptions$2.dispatchInterval
    }, typeof n == "string") {
      if (!(0, rpcclient_1$8.hasProtocol)(n))
        throw new Error("Endpoint URL is missing a protocol. Expected 'https://' or 'http://'.");
      this.url = n;
    } else
      this.url = n.url, this.headers = n.headers;
    this.timer = setInterval(() => this.tick(), o.dispatchInterval), this.validate();
  }
  disconnect() {
    this.timer && clearInterval(this.timer), this.timer = void 0;
  }
  async execute(n) {
    return new Promise((o, u) => {
      this.queue.push({ request: n, resolve: o, reject: u }), this.queue.length >= this.options.batchSizeLimit && this.tick();
    });
  }
  validate() {
    if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1)
      throw new Error("batchSizeLimit must be a safe integer >= 1");
  }
  /**
   * This is called in an interval where promise rejections cannot be handled.
   * So this is not async and HTTP errors need to be handled by the queued promises.
   */
  tick() {
    const n = this.queue.splice(0, this.options.batchSizeLimit);
    if (!n.length)
      return;
    const o = n.map((c) => c.request), u = o.map((c) => c.id);
    (0, http_1$5.http)("POST", this.url, this.headers, o).then((c) => {
      (Array.isArray(c) ? c : [c]).forEach((m) => {
        const v = n.find((O) => O.request.id === m.id);
        if (!v)
          return;
        const { reject: S, resolve: $ } = v, E = (0, json_rpc_1$8.parseJsonRpcResponse)(m);
        (0, json_rpc_1$8.isJsonRpcErrorResponse)(E) ? S(new Error(JSON.stringify(E.error))) : $(E);
      });
    }, (c) => {
      for (const d of u) {
        const m = n.find((v) => v.request.id === d);
        if (!m)
          return;
        m.reject(c);
      }
    });
  }
};
httpbatchclient$2.HttpBatchClient = HttpBatchClient$2;
var httpclient$2 = {};
Object.defineProperty(httpclient$2, "__esModule", { value: !0 });
httpclient$2.HttpClient = void 0;
const json_rpc_1$7 = build$t, http_1$4 = http$5, rpcclient_1$7 = rpcclient$2;
let HttpClient$2 = class {
  constructor(n) {
    if (typeof n == "string") {
      if (!(0, rpcclient_1$7.hasProtocol)(n))
        throw new Error("Endpoint URL is missing a protocol. Expected 'https://' or 'http://'.");
      this.url = n;
    } else
      this.url = n.url, this.headers = n.headers;
  }
  disconnect() {
  }
  async execute(n) {
    const o = (0, json_rpc_1$7.parseJsonRpcResponse)(await (0, http_1$4.http)("POST", this.url, this.headers, n));
    if ((0, json_rpc_1$7.isJsonRpcErrorResponse)(o))
      throw new Error(JSON.stringify(o.error));
    return o;
  }
};
httpclient$2.HttpClient = HttpClient$2;
var websocketclient$2 = {}, build$r = {}, queueingstreamingsocket$2 = {}, build$q = {}, concat$8 = {};
Object.defineProperty(concat$8, "__esModule", { value: !0 });
concat$8.concat = void 0;
const xstream_1$k = xstream;
function concat$7(...e) {
  const n = new Array(), o = new Array(), u = /* @__PURE__ */ new Set();
  let c = 0;
  function d() {
    for (; n.length > 0; )
      n.shift().unsubscribe();
    o.length = 0, u.clear(), c = 0;
  }
  const m = {
    start: (v) => {
      e.forEach((E) => o.push([]));
      function S(E) {
        for (; ; ) {
          const O = o[E].shift();
          if (O === void 0)
            return;
          v.next(O);
        }
      }
      function $() {
        return c >= e.length;
      }
      if ($()) {
        v.complete();
        return;
      }
      e.forEach((E, O) => {
        n.push(E.subscribe({
          next: (T) => {
            O === c ? v.next(T) : o[O].push(T);
          },
          complete: () => {
            for (u.add(O); u.has(c); )
              S(c), c++;
            $() ? v.complete() : S(c);
          },
          error: (T) => {
            v.error(T), d();
          }
        }));
      });
    },
    stop: () => {
      d();
    }
  };
  return xstream_1$k.Stream.create(m);
}
concat$8.concat = concat$7;
var defaultvalueproducer$3 = {};
Object.defineProperty(defaultvalueproducer$3, "__esModule", { value: !0 });
defaultvalueproducer$3.DefaultValueProducer = void 0;
let DefaultValueProducer$3 = class {
  get value() {
    return this.internalValue;
  }
  constructor(n, o) {
    this.callbacks = o, this.internalValue = n;
  }
  /**
   * Update the current value.
   *
   * If producer is active (i.e. someone is listening), this emits an event.
   * If not, just the current value is updated.
   */
  update(n) {
    this.internalValue = n, this.listener && this.listener.next(n);
  }
  /**
   * Produce an error
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error(n) {
    this.listener && this.listener.error(n);
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  start(n) {
    this.listener = n, n.next(this.internalValue), this.callbacks && this.callbacks.onStarted();
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  stop() {
    this.callbacks && this.callbacks.onStop(), this.listener = void 0;
  }
};
defaultvalueproducer$3.DefaultValueProducer = DefaultValueProducer$3;
var dropduplicates$3 = {};
Object.defineProperty(dropduplicates$3, "__esModule", { value: !0 });
dropduplicates$3.dropDuplicates = void 0;
function dropDuplicates$3(e) {
  return (o) => {
    const u = /* @__PURE__ */ new Set();
    return o.filter((d) => !u.has(e(d))).debug((d) => u.add(e(d)));
  };
}
dropduplicates$3.dropDuplicates = dropDuplicates$3;
var promise$3 = {};
Object.defineProperty(promise$3, "__esModule", { value: !0 });
promise$3.firstEvent = promise$3.toListPromise = promise$3.fromListPromise = void 0;
const xstream_1$j = xstream;
function fromListPromise$3(e) {
  const n = {
    start: (o) => {
      e.then((u) => {
        for (const c of u)
          o.next(c);
        o.complete();
      }).catch((u) => o.error(u));
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    stop: () => {
    }
  };
  return xstream_1$j.Stream.create(n);
}
promise$3.fromListPromise = fromListPromise$3;
async function toListPromise$3(e, n) {
  return new Promise((o, u) => {
    if (n === 0) {
      o([]);
      return;
    }
    const c = new Array();
    e.take(n).subscribe({
      next: (d) => {
        c.push(d), c.length === n && o(c);
      },
      complete: () => {
        u(`Stream completed before all events could be collected. Collected ${c.length}, expected ${n}`);
      },
      error: (d) => u(d)
    });
  });
}
promise$3.toListPromise = toListPromise$3;
async function firstEvent$3(e) {
  return (await toListPromise$3(e, 1))[0];
}
promise$3.firstEvent = firstEvent$3;
var reducer$3 = {};
Object.defineProperty(reducer$3, "__esModule", { value: !0 });
reducer$3.lastValue = reducer$3.asArray = reducer$3.countStream = reducer$3.Reducer = void 0;
let Reducer$3 = class {
  constructor(n, o, u) {
    this.stream = n, this.reducer = o, this.state = u, this.completed = new Promise((c, d) => {
      const m = this.stream.subscribe({
        next: (v) => {
          this.state = this.reducer(this.state, v);
        },
        complete: () => {
          c(), m.unsubscribe();
        },
        error: (v) => {
          d(v), m.unsubscribe();
        }
      });
    });
  }
  // value returns current materialized state
  value() {
    return this.state;
  }
  // finished resolves on completed stream, rejects on stream error
  async finished() {
    return this.completed;
  }
};
reducer$3.Reducer = Reducer$3;
function increment$3(e, n) {
  return e + 1;
}
function countStream$3(e) {
  return new Reducer$3(e, increment$3, 0);
}
reducer$3.countStream = countStream$3;
function append$3(e, n) {
  return [...e, n];
}
function asArray$3(e) {
  return new Reducer$3(e, append$3, []);
}
reducer$3.asArray = asArray$3;
function last$3(e, n) {
  return n;
}
function lastValue$3(e) {
  return new Reducer$3(e, last$3, void 0);
}
reducer$3.lastValue = lastValue$3;
var valueandupdates$3 = {};
Object.defineProperty(valueandupdates$3, "__esModule", { value: !0 });
valueandupdates$3.ValueAndUpdates = void 0;
const xstream_1$i = xstream;
let ValueAndUpdates$3 = class {
  get value() {
    return this.producer.value;
  }
  constructor(n) {
    this.producer = n, this.updates = xstream_1$i.MemoryStream.createWithMemory(this.producer);
  }
  /**
   * Resolves as soon as search value is found.
   *
   * @param search either a value or a function that must return true when found
   * @returns the value of the update that caused the search match
   */
  async waitFor(n) {
    const o = typeof n == "function" ? n : (u) => u === n;
    return new Promise((u, c) => {
      const d = this.updates.subscribe({
        next: (m) => {
          o(m) && (u(m), setTimeout(() => d.unsubscribe(), 0));
        },
        complete: () => {
          d.unsubscribe(), c("Update stream completed without expected value");
        },
        error: (m) => {
          c(m);
        }
      });
    });
  }
};
valueandupdates$3.ValueAndUpdates = ValueAndUpdates$3;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(S, $, E, O) {
    O === void 0 && (O = E);
    var T = Object.getOwnPropertyDescriptor($, E);
    (!T || ("get" in T ? !$.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return $[E];
    } }), Object.defineProperty(S, O, T);
  } : function(S, $, E, O) {
    O === void 0 && (O = E), S[O] = $[E];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(S, $) {
    for (var E in S)
      E !== "default" && !Object.prototype.hasOwnProperty.call($, E) && n($, S, E);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueAndUpdates = e.toListPromise = e.fromListPromise = e.firstEvent = e.dropDuplicates = e.DefaultValueProducer = e.concat = void 0;
  var u = concat$8;
  Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
    return u.concat;
  } });
  var c = defaultvalueproducer$3;
  Object.defineProperty(e, "DefaultValueProducer", { enumerable: !0, get: function() {
    return c.DefaultValueProducer;
  } });
  var d = dropduplicates$3;
  Object.defineProperty(e, "dropDuplicates", { enumerable: !0, get: function() {
    return d.dropDuplicates;
  } });
  var m = promise$3;
  Object.defineProperty(e, "firstEvent", { enumerable: !0, get: function() {
    return m.firstEvent;
  } }), Object.defineProperty(e, "fromListPromise", { enumerable: !0, get: function() {
    return m.fromListPromise;
  } }), Object.defineProperty(e, "toListPromise", { enumerable: !0, get: function() {
    return m.toListPromise;
  } }), o(reducer$3, e);
  var v = valueandupdates$3;
  Object.defineProperty(e, "ValueAndUpdates", { enumerable: !0, get: function() {
    return v.ValueAndUpdates;
  } });
})(build$q);
var streamingsocket$2 = {}, socketwrapper$2 = {}, __importDefault$t = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(socketwrapper$2, "__esModule", { value: !0 });
socketwrapper$2.SocketWrapper = void 0;
const isomorphic_ws_1$2 = __importDefault$t(browser$1);
function environmentIsNodeJs$2() {
  return typeof browser$1$1 < "u" && typeof browser$1$1.versions < "u" && typeof browser$1$1.versions.node < "u";
}
let SocketWrapper$2 = class {
  constructor(n, o, u, c, d, m = 1e4) {
    this.closed = !1, this.connected = new Promise((v, S) => {
      this.connectedResolver = v, this.connectedRejecter = S;
    }), this.url = n, this.messageHandler = o, this.errorHandler = u, this.openHandler = c, this.closeHandler = d, this.timeout = m;
  }
  /**
   * returns a promise that resolves when connection is open
   */
  connect() {
    const n = new isomorphic_ws_1$2.default(this.url);
    n.onerror = (u) => {
      this.clearTimeout(), this.errorHandler && this.errorHandler(u);
    }, n.onmessage = (u) => {
      this.messageHandler({
        type: u.type,
        data: u.data
      });
    }, n.onopen = (u) => {
      this.clearTimeout(), this.connectedResolver(), this.openHandler && this.openHandler();
    }, n.onclose = (u) => {
      this.closed = !0, this.closeHandler && this.closeHandler(u);
    };
    const o = Date.now();
    this.timeoutId = setTimeout(() => {
      n.onmessage = () => 0, n.onerror = () => 0, n.onopen = () => 0, n.onclose = () => 0, n.close(), this.socket = void 0;
      const u = Math.floor(Date.now() - o);
      this.connectedRejecter(`Connection attempt timed out after ${u} ms`);
    }, this.timeout), this.socket = n;
  }
  /**
   * Closes an established connection and aborts other connection states
   */
  disconnect() {
    if (!this.socket)
      throw new Error("Socket undefined. This must be called after connecting.");
    switch (this.clearTimeout(), this.socket.readyState) {
      case isomorphic_ws_1$2.default.OPEN:
        this.socket.close(
          1e3
          /* Normal Closure */
        );
        break;
      case isomorphic_ws_1$2.default.CLOSED:
        break;
      case isomorphic_ws_1$2.default.CONNECTING:
        this.socket.onopen = () => 0, this.socket.onclose = () => 0, this.socket.onerror = () => 0, this.socket.onmessage = () => 0, this.socket = void 0, this.closeHandler && this.closeHandler({ wasClean: !1, code: 4001 });
        break;
      case isomorphic_ws_1$2.default.CLOSING:
        break;
      default:
        throw new Error(`Unknown readyState: ${this.socket.readyState}`);
    }
  }
  async send(n) {
    return new Promise((o, u) => {
      if (!this.socket)
        throw new Error("Socket undefined. This must be called after connecting.");
      if (this.closed)
        throw new Error("Socket was closed, so no data can be sent anymore.");
      if (this.socket.readyState !== isomorphic_ws_1$2.default.OPEN)
        throw new Error("Websocket is not open");
      environmentIsNodeJs$2() ? this.socket.send(n, (c) => c ? u(c) : o()) : (this.socket.send(n), o());
    });
  }
  /**
   * Clears the timeout function, such that no timeout error will be raised anymore. This should be
   * called when the connection is established, a connection error occurred or the socket is disconnected.
   *
   * This method must not be called before `connect()`.
   * This method is idempotent.
   */
  clearTimeout() {
    if (!this.timeoutId)
      throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
    clearTimeout(this.timeoutId);
  }
};
socketwrapper$2.SocketWrapper = SocketWrapper$2;
Object.defineProperty(streamingsocket$2, "__esModule", { value: !0 });
streamingsocket$2.StreamingSocket = void 0;
const xstream_1$h = xstream, socketwrapper_1$2 = socketwrapper$2;
let StreamingSocket$2 = class {
  constructor(n, o = 1e4) {
    this.socket = new socketwrapper_1$2.SocketWrapper(n, (c) => {
      this.eventProducerListener && this.eventProducerListener.next(c);
    }, (c) => {
      this.eventProducerListener && this.eventProducerListener.error(c);
    }, () => {
    }, (c) => {
      this.eventProducerListener && (c.wasClean ? this.eventProducerListener.complete() : this.eventProducerListener.error("Socket was closed unclean"));
    }, o), this.connected = this.socket.connected;
    const u = {
      start: (c) => this.eventProducerListener = c,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$h.Stream.create(u);
  }
  connect() {
    this.socket.connect();
  }
  disconnect() {
    this.socket.disconnect();
  }
  async send(n) {
    return this.socket.send(n);
  }
};
streamingsocket$2.StreamingSocket = StreamingSocket$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  const n = build$q, o = xstream, u = streamingsocket$2;
  var c;
  (function(m) {
    m[m.Unconnected = 0] = "Unconnected", m[m.Connecting = 1] = "Connecting", m[m.Connected = 2] = "Connected", m[m.Disconnected = 3] = "Disconnected";
  })(c = e.ConnectionStatus || (e.ConnectionStatus = {}));
  class d {
    constructor(v, S = 1e4, $) {
      this.queue = [], this.isProcessingQueue = !1, this.url = v, this.timeout = S, this.reconnectedHandler = $;
      const E = {
        start: (O) => this.eventProducerListener = O,
        stop: () => this.eventProducerListener = void 0
      };
      this.events = o.Stream.create(E), this.connectionStatusProducer = new n.DefaultValueProducer(c.Unconnected), this.connectionStatus = new n.ValueAndUpdates(this.connectionStatusProducer), this.socket = new u.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (O) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(O);
        },
        error: () => this.connectionStatusProducer.update(c.Disconnected)
      });
    }
    connect() {
      this.connectionStatusProducer.update(c.Connecting), this.socket.connected.then(async () => (this.connectionStatusProducer.update(c.Connected), this.processQueue()), () => this.connectionStatusProducer.update(c.Disconnected)), this.socket.connect();
    }
    disconnect() {
      this.connectionStatusProducer.update(c.Disconnected), this.socket.disconnect();
    }
    reconnect() {
      this.socket = new u.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (v) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(v);
        },
        error: () => this.connectionStatusProducer.update(c.Disconnected)
      }), this.socket.connected.then(() => {
        this.reconnectedHandler && this.reconnectedHandler();
      }), this.connect();
    }
    getQueueLength() {
      return this.queue.length;
    }
    queueRequest(v) {
      this.queue.push(v), this.processQueue();
    }
    async processQueue() {
      if (this.isProcessingQueue || this.connectionStatus.value !== c.Connected)
        return;
      this.isProcessingQueue = !0;
      let v;
      for (; v = this.queue.shift(); )
        try {
          await this.socket.send(v), this.isProcessingQueue = !1;
        } catch {
          this.queue.unshift(v), this.isProcessingQueue = !1;
          return;
        }
    }
  }
  e.QueueingStreamingSocket = d;
})(queueingstreamingsocket$2);
var reconnectingsocket$2 = {};
Object.defineProperty(reconnectingsocket$2, "__esModule", { value: !0 });
reconnectingsocket$2.ReconnectingSocket = void 0;
const xstream_1$g = xstream, queueingstreamingsocket_1$2 = queueingstreamingsocket$2;
let ReconnectingSocket$2 = class rd {
  /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */
  static calculateTimeout(n) {
    return Math.min(2 ** n * 100, 5e3);
  }
  constructor(n, o = 1e4, u) {
    this.unconnected = !0, this.disconnected = !1, this.timeoutIndex = 0, this.reconnectTimeout = null;
    const c = {
      start: (d) => this.eventProducerListener = d,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$g.Stream.create(c), this.socket = new queueingstreamingsocket_1$2.QueueingStreamingSocket(n, o, u), this.socket.events.subscribe({
      next: (d) => {
        this.eventProducerListener && this.eventProducerListener.next(d);
      },
      error: (d) => {
        this.eventProducerListener && this.eventProducerListener.error(d);
      }
    }), this.connectionStatus = this.socket.connectionStatus, this.connectionStatus.updates.subscribe({
      next: (d) => {
        d === queueingstreamingsocket_1$2.ConnectionStatus.Connected && (this.timeoutIndex = 0), d === queueingstreamingsocket_1$2.ConnectionStatus.Disconnected && (this.reconnectTimeout && (clearTimeout(this.reconnectTimeout), this.reconnectTimeout = null), this.reconnectTimeout = setTimeout(() => this.socket.reconnect(), rd.calculateTimeout(this.timeoutIndex++)));
      }
    });
  }
  connect() {
    if (!this.unconnected)
      throw new Error("Cannot connect: socket has already connected");
    this.socket.connect(), this.unconnected = !1;
  }
  disconnect() {
    if (this.unconnected)
      throw new Error("Cannot disconnect: socket has not yet connected");
    this.socket.disconnect(), this.eventProducerListener && this.eventProducerListener.complete(), this.disconnected = !0;
  }
  queueRequest(n) {
    if (this.disconnected)
      throw new Error("Cannot queue request: socket has disconnected");
    this.socket.queueRequest(n);
  }
};
reconnectingsocket$2.ReconnectingSocket = ReconnectingSocket$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.StreamingSocket = e.SocketWrapper = e.ReconnectingSocket = e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  var n = queueingstreamingsocket$2;
  Object.defineProperty(e, "ConnectionStatus", { enumerable: !0, get: function() {
    return n.ConnectionStatus;
  } }), Object.defineProperty(e, "QueueingStreamingSocket", { enumerable: !0, get: function() {
    return n.QueueingStreamingSocket;
  } });
  var o = reconnectingsocket$2;
  Object.defineProperty(e, "ReconnectingSocket", { enumerable: !0, get: function() {
    return o.ReconnectingSocket;
  } });
  var u = socketwrapper$2;
  Object.defineProperty(e, "SocketWrapper", { enumerable: !0, get: function() {
    return u.SocketWrapper;
  } });
  var c = streamingsocket$2;
  Object.defineProperty(e, "StreamingSocket", { enumerable: !0, get: function() {
    return c.StreamingSocket;
  } });
})(build$r);
var build$p = {}, concat$6 = {};
Object.defineProperty(concat$6, "__esModule", { value: !0 });
concat$6.concat = void 0;
const xstream_1$f = xstream;
function concat$5(...e) {
  const n = new Array(), o = new Array(), u = /* @__PURE__ */ new Set();
  let c = 0;
  function d() {
    for (; n.length > 0; )
      n.shift().unsubscribe();
    o.length = 0, u.clear(), c = 0;
  }
  const m = {
    start: (v) => {
      e.forEach((E) => o.push([]));
      function S(E) {
        for (; ; ) {
          const O = o[E].shift();
          if (O === void 0)
            return;
          v.next(O);
        }
      }
      function $() {
        return c >= e.length;
      }
      if ($()) {
        v.complete();
        return;
      }
      e.forEach((E, O) => {
        n.push(E.subscribe({
          next: (T) => {
            O === c ? v.next(T) : o[O].push(T);
          },
          complete: () => {
            for (u.add(O); u.has(c); )
              S(c), c++;
            $() ? v.complete() : S(c);
          },
          error: (T) => {
            v.error(T), d();
          }
        }));
      });
    },
    stop: () => {
      d();
    }
  };
  return xstream_1$f.Stream.create(m);
}
concat$6.concat = concat$5;
var defaultvalueproducer$2 = {};
Object.defineProperty(defaultvalueproducer$2, "__esModule", { value: !0 });
defaultvalueproducer$2.DefaultValueProducer = void 0;
let DefaultValueProducer$2 = class {
  get value() {
    return this.internalValue;
  }
  constructor(n, o) {
    this.callbacks = o, this.internalValue = n;
  }
  /**
   * Update the current value.
   *
   * If producer is active (i.e. someone is listening), this emits an event.
   * If not, just the current value is updated.
   */
  update(n) {
    this.internalValue = n, this.listener && this.listener.next(n);
  }
  /**
   * Produce an error
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error(n) {
    this.listener && this.listener.error(n);
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  start(n) {
    this.listener = n, n.next(this.internalValue), this.callbacks && this.callbacks.onStarted();
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  stop() {
    this.callbacks && this.callbacks.onStop(), this.listener = void 0;
  }
};
defaultvalueproducer$2.DefaultValueProducer = DefaultValueProducer$2;
var dropduplicates$2 = {};
Object.defineProperty(dropduplicates$2, "__esModule", { value: !0 });
dropduplicates$2.dropDuplicates = void 0;
function dropDuplicates$2(e) {
  return (o) => {
    const u = /* @__PURE__ */ new Set();
    return o.filter((d) => !u.has(e(d))).debug((d) => u.add(e(d)));
  };
}
dropduplicates$2.dropDuplicates = dropDuplicates$2;
var promise$2 = {};
Object.defineProperty(promise$2, "__esModule", { value: !0 });
promise$2.firstEvent = promise$2.toListPromise = promise$2.fromListPromise = void 0;
const xstream_1$e = xstream;
function fromListPromise$2(e) {
  const n = {
    start: (o) => {
      e.then((u) => {
        for (const c of u)
          o.next(c);
        o.complete();
      }).catch((u) => o.error(u));
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    stop: () => {
    }
  };
  return xstream_1$e.Stream.create(n);
}
promise$2.fromListPromise = fromListPromise$2;
async function toListPromise$2(e, n) {
  return new Promise((o, u) => {
    if (n === 0) {
      o([]);
      return;
    }
    const c = new Array();
    e.take(n).subscribe({
      next: (d) => {
        c.push(d), c.length === n && o(c);
      },
      complete: () => {
        u(`Stream completed before all events could be collected. Collected ${c.length}, expected ${n}`);
      },
      error: (d) => u(d)
    });
  });
}
promise$2.toListPromise = toListPromise$2;
async function firstEvent$2(e) {
  return (await toListPromise$2(e, 1))[0];
}
promise$2.firstEvent = firstEvent$2;
var reducer$2 = {};
Object.defineProperty(reducer$2, "__esModule", { value: !0 });
reducer$2.lastValue = reducer$2.asArray = reducer$2.countStream = reducer$2.Reducer = void 0;
let Reducer$2 = class {
  constructor(n, o, u) {
    this.stream = n, this.reducer = o, this.state = u, this.completed = new Promise((c, d) => {
      const m = this.stream.subscribe({
        next: (v) => {
          this.state = this.reducer(this.state, v);
        },
        complete: () => {
          c(), m.unsubscribe();
        },
        error: (v) => {
          d(v), m.unsubscribe();
        }
      });
    });
  }
  // value returns current materialized state
  value() {
    return this.state;
  }
  // finished resolves on completed stream, rejects on stream error
  async finished() {
    return this.completed;
  }
};
reducer$2.Reducer = Reducer$2;
function increment$2(e, n) {
  return e + 1;
}
function countStream$2(e) {
  return new Reducer$2(e, increment$2, 0);
}
reducer$2.countStream = countStream$2;
function append$2(e, n) {
  return [...e, n];
}
function asArray$2(e) {
  return new Reducer$2(e, append$2, []);
}
reducer$2.asArray = asArray$2;
function last$2(e, n) {
  return n;
}
function lastValue$2(e) {
  return new Reducer$2(e, last$2, void 0);
}
reducer$2.lastValue = lastValue$2;
var valueandupdates$2 = {};
Object.defineProperty(valueandupdates$2, "__esModule", { value: !0 });
valueandupdates$2.ValueAndUpdates = void 0;
const xstream_1$d = xstream;
let ValueAndUpdates$2 = class {
  get value() {
    return this.producer.value;
  }
  constructor(n) {
    this.producer = n, this.updates = xstream_1$d.MemoryStream.createWithMemory(this.producer);
  }
  /**
   * Resolves as soon as search value is found.
   *
   * @param search either a value or a function that must return true when found
   * @returns the value of the update that caused the search match
   */
  async waitFor(n) {
    const o = typeof n == "function" ? n : (u) => u === n;
    return new Promise((u, c) => {
      const d = this.updates.subscribe({
        next: (m) => {
          o(m) && (u(m), setTimeout(() => d.unsubscribe(), 0));
        },
        complete: () => {
          d.unsubscribe(), c("Update stream completed without expected value");
        },
        error: (m) => {
          c(m);
        }
      });
    });
  }
};
valueandupdates$2.ValueAndUpdates = ValueAndUpdates$2;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(S, $, E, O) {
    O === void 0 && (O = E);
    var T = Object.getOwnPropertyDescriptor($, E);
    (!T || ("get" in T ? !$.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return $[E];
    } }), Object.defineProperty(S, O, T);
  } : function(S, $, E, O) {
    O === void 0 && (O = E), S[O] = $[E];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(S, $) {
    for (var E in S)
      E !== "default" && !Object.prototype.hasOwnProperty.call($, E) && n($, S, E);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueAndUpdates = e.toListPromise = e.fromListPromise = e.firstEvent = e.dropDuplicates = e.DefaultValueProducer = e.concat = void 0;
  var u = concat$6;
  Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
    return u.concat;
  } });
  var c = defaultvalueproducer$2;
  Object.defineProperty(e, "DefaultValueProducer", { enumerable: !0, get: function() {
    return c.DefaultValueProducer;
  } });
  var d = dropduplicates$2;
  Object.defineProperty(e, "dropDuplicates", { enumerable: !0, get: function() {
    return d.dropDuplicates;
  } });
  var m = promise$2;
  Object.defineProperty(e, "firstEvent", { enumerable: !0, get: function() {
    return m.firstEvent;
  } }), Object.defineProperty(e, "fromListPromise", { enumerable: !0, get: function() {
    return m.fromListPromise;
  } }), Object.defineProperty(e, "toListPromise", { enumerable: !0, get: function() {
    return m.toListPromise;
  } }), o(reducer$2, e);
  var v = valueandupdates$2;
  Object.defineProperty(e, "ValueAndUpdates", { enumerable: !0, get: function() {
    return v.ValueAndUpdates;
  } });
})(build$p);
Object.defineProperty(websocketclient$2, "__esModule", { value: !0 });
websocketclient$2.WebsocketClient = void 0;
const json_rpc_1$6 = build$t, socket_1$2 = build$r, stream_1$5 = build$p, xstream_1$c = xstream, rpcclient_1$6 = rpcclient$2;
function defaultErrorHandler$2(e) {
  throw e;
}
function toJsonRpcResponse$2(e) {
  if (e.type !== "message")
    throw new Error(`Unexcepted message type on websocket: ${e.type}`);
  return (0, json_rpc_1$6.parseJsonRpcResponse)(JSON.parse(e.data));
}
let RpcEventProducer$2 = class {
  constructor(n, o) {
    this.running = !1, this.subscriptions = [], this.request = n, this.socket = o;
  }
  /**
   * Implementation of Producer.start
   */
  start(n) {
    if (this.running)
      throw Error("Already started. Please stop first before restarting.");
    this.running = !0, this.connectToClient(n), this.socket.queueRequest(JSON.stringify(this.request));
  }
  /**
   * Implementation of Producer.stop
   *
   * Called by the stream when the stream's last listener stopped listening
   * or when the producer completed.
   */
  stop() {
    this.running = !1;
    const n = { ...this.request, method: "unsubscribe" };
    try {
      this.socket.queueRequest(JSON.stringify(n));
    } catch (o) {
      if (!(o instanceof Error && o.message.match(/socket has disconnected/i)))
        throw o;
    }
  }
  connectToClient(n) {
    const o = this.socket.events.map(toJsonRpcResponse$2), u = o.filter((m) => m.id === this.request.id).subscribe({
      next: (m) => {
        (0, json_rpc_1$6.isJsonRpcErrorResponse)(m) && (this.closeSubscriptions(), n.error(JSON.stringify(m.error))), u.unsubscribe();
      }
    }), c = o.filter((m) => m.id === this.request.id).subscribe({
      next: (m) => {
        (0, json_rpc_1$6.isJsonRpcErrorResponse)(m) ? (this.closeSubscriptions(), n.error(JSON.stringify(m.error))) : n.next(m.result);
      }
    }), d = o.subscribe({
      error: (m) => {
        this.closeSubscriptions(), n.error(m);
      },
      complete: () => {
        this.closeSubscriptions(), n.complete();
      }
    });
    this.subscriptions.push(u, c, d);
  }
  closeSubscriptions() {
    for (const n of this.subscriptions)
      n.unsubscribe();
    this.subscriptions = [];
  }
}, WebsocketClient$2 = class {
  constructor(n, o = defaultErrorHandler$2) {
    if (this.subscriptionStreams = /* @__PURE__ */ new Map(), !(0, rpcclient_1$6.hasProtocol)(n))
      throw new Error("Base URL is missing a protocol. Expected 'ws://' or 'wss://'.");
    const u = n.endsWith("/") ? "websocket" : "/websocket";
    this.url = n + u, this.socket = new socket_1$2.ReconnectingSocket(this.url);
    const c = this.socket.events.subscribe({
      error: (d) => {
        o(d), c.unsubscribe();
      }
    });
    this.jsonRpcResponseStream = this.socket.events.map(toJsonRpcResponse$2), this.socket.connect();
  }
  async execute(n) {
    const o = this.responseForRequestId(n.id);
    this.socket.queueRequest(JSON.stringify(n));
    const u = await o;
    if ((0, json_rpc_1$6.isJsonRpcErrorResponse)(u))
      throw new Error(JSON.stringify(u.error));
    return u;
  }
  listen(n) {
    if (n.method !== "subscribe")
      throw new Error('Request method must be "subscribe" to start event listening');
    const o = n.params.query;
    if (typeof o != "string")
      throw new Error("request.params.query must be a string");
    if (!this.subscriptionStreams.has(o)) {
      const u = new RpcEventProducer$2(n, this.socket), c = xstream_1$c.Stream.create(u);
      this.subscriptionStreams.set(o, c);
    }
    return this.subscriptionStreams.get(o).filter((u) => u.query !== void 0);
  }
  /**
   * Resolves as soon as websocket is connected. execute() queues requests automatically,
   * so this should be required for testing purposes only.
   */
  async connected() {
    await this.socket.connectionStatus.waitFor(socket_1$2.ConnectionStatus.Connected);
  }
  disconnect() {
    this.socket.disconnect();
  }
  async responseForRequestId(n) {
    return (0, stream_1$5.firstEvent)(this.jsonRpcResponseStream.filter((o) => o.id === n));
  }
};
websocketclient$2.WebsocketClient = WebsocketClient$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.WebsocketClient = e.instanceOfRpcStreamingClient = e.HttpClient = e.HttpBatchClient = void 0;
  var n = httpbatchclient$2;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return n.HttpBatchClient;
  } });
  var o = httpclient$2;
  Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return o.HttpClient;
  } });
  var u = rpcclient$2;
  Object.defineProperty(e, "instanceOfRpcStreamingClient", { enumerable: !0, get: function() {
    return u.instanceOfRpcStreamingClient;
  } });
  var c = websocketclient$2;
  Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return c.WebsocketClient;
  } });
})(rpcclients$2);
var adaptor$6 = {}, requests$r = {}, inthelpers$2 = {}, encodings$6 = {};
Object.defineProperty(encodings$6, "__esModule", { value: !0 });
encodings$6.encodeBlockId = encodings$6.encodeVersion = encodings$6.encodeBytes = encodings$6.encodeTime = encodings$6.encodeUvarint = encodings$6.encodeString = encodings$6.dictionaryToStringMap = encodings$6.may = encodings$6.assertNotEmpty = encodings$6.assertObject = encodings$6.assertArray = encodings$6.assertNumber = encodings$6.assertString = encodings$6.assertBoolean = encodings$6.assertSet = void 0;
const encoding_1$R = build$w;
function assertSet$6(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$6.assertSet = assertSet$6;
function assertBoolean$6(e) {
  if (assertSet$6(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$6.assertBoolean = assertBoolean$6;
function assertString$6(e) {
  if (assertSet$6(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$6.assertString = assertString$6;
function assertNumber$6(e) {
  if (assertSet$6(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$6.assertNumber = assertNumber$6;
function assertArray$6(e) {
  if (assertSet$6(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$6.assertArray = assertArray$6;
function assertObject$6(e) {
  if (assertSet$6(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$6.assertObject = assertObject$6;
function assertNotEmpty$6(e) {
  if (assertSet$6(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$6.assertNotEmpty = assertNotEmpty$6;
function may$6(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$6.may = may$6;
function dictionaryToStringMap$6(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$6.dictionaryToStringMap = dictionaryToStringMap$6;
function encodeString$6(e) {
  const n = (0, encoding_1$R.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$6.encodeString = encodeString$6;
function encodeUvarint$7(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$7(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$6.encodeUvarint = encodeUvarint$7;
function encodeTime$6(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$7(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$7(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$6.encodeTime = encodeTime$6;
function encodeBytes$6(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$6.encodeBytes = encodeBytes$6;
function encodeVersion$6(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$7(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$7(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$6.encodeVersion = encodeVersion$6;
function encodeBlockId$6(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$6.encodeBlockId = encodeBlockId$6;
Object.defineProperty(inthelpers$2, "__esModule", { value: !0 });
inthelpers$2.smallIntToApi = inthelpers$2.apiToBigInt = inthelpers$2.apiToSmallInt = void 0;
const math_1$j = build$u, encodings_1$n = encodings$6;
function apiToSmallInt$2(e) {
  return (typeof e == "number" ? new math_1$j.Int53(e) : math_1$j.Int53.fromString(e)).toNumber();
}
inthelpers$2.apiToSmallInt = apiToSmallInt$2;
function apiToBigInt$2(e) {
  if ((0, encodings_1$n.assertString)(e), !e.match(/^-?[0-9]+$/))
    throw new Error("Invalid string format");
  return BigInt(e);
}
inthelpers$2.apiToBigInt = apiToBigInt$2;
function smallIntToApi$2(e) {
  return new math_1$j.Int53(e).toString();
}
inthelpers$2.smallIntToApi = smallIntToApi$2;
var encodings$5 = {};
Object.defineProperty(encodings$5, "__esModule", { value: !0 });
encodings$5.encodeBlockId = encodings$5.encodeVersion = encodings$5.encodeBytes = encodings$5.encodeTime = encodings$5.encodeUvarint = encodings$5.encodeString = encodings$5.dictionaryToStringMap = encodings$5.may = encodings$5.assertNotEmpty = encodings$5.assertObject = encodings$5.assertArray = encodings$5.assertNumber = encodings$5.assertString = encodings$5.assertBoolean = encodings$5.assertSet = void 0;
const encoding_1$Q = build$w;
function assertSet$5(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$5.assertSet = assertSet$5;
function assertBoolean$5(e) {
  if (assertSet$5(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$5.assertBoolean = assertBoolean$5;
function assertString$5(e) {
  if (assertSet$5(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$5.assertString = assertString$5;
function assertNumber$5(e) {
  if (assertSet$5(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$5.assertNumber = assertNumber$5;
function assertArray$5(e) {
  if (assertSet$5(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$5.assertArray = assertArray$5;
function assertObject$5(e) {
  if (assertSet$5(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$5.assertObject = assertObject$5;
function assertNotEmpty$5(e) {
  if (assertSet$5(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$5.assertNotEmpty = assertNotEmpty$5;
function may$5(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$5.may = may$5;
function dictionaryToStringMap$5(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$5.dictionaryToStringMap = dictionaryToStringMap$5;
function encodeString$5(e) {
  const n = (0, encoding_1$Q.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$5.encodeString = encodeString$5;
function encodeUvarint$6(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$6(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$5.encodeUvarint = encodeUvarint$6;
function encodeTime$5(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$6(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$6(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$5.encodeTime = encodeTime$5;
function encodeBytes$5(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$5.encodeBytes = encodeBytes$5;
function encodeVersion$5(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$6(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$6(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$5.encodeVersion = encodeVersion$5;
function encodeBlockId$5(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$5.encodeBlockId = encodeBlockId$5;
var requests$q = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$q);
var __createBinding$B = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$B = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$B = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$B(n, e, o);
  return __setModuleDefault$B(n, e), n;
};
Object.defineProperty(requests$r, "__esModule", { value: !0 });
requests$r.Params = void 0;
const encoding_1$P = build$w, inthelpers_1$d = inthelpers$2, jsonrpc_1$d = jsonrpc$2, encodings_1$m = encodings$5, requests$p = __importStar$B(requests$q);
function encodeHeightParam$6(e) {
  return {
    height: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$6(e) {
  return {
    minHeight: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$6(e) {
  return {
    query: e.query,
    page: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.page),
    per_page: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$6(e) {
  return {
    path: (0, encodings_1$m.assertNotEmpty)(e.path),
    data: (0, encoding_1$P.toHex)(e.data),
    height: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$6(e) {
  return {
    tx: (0, encoding_1$P.toBase64)((0, encodings_1$m.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$6(e) {
  return {
    hash: (0, encoding_1$P.toBase64)((0, encodings_1$m.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$6(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.page),
    per_page: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$6(e) {
  return {
    height: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.height),
    page: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.page),
    per_page: (0, encodings_1$m.may)(inthelpers_1$d.smallIntToApi, e.per_page)
  };
}
let Params$t = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeAbciQueryParams$6(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeHeightParam$6(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$6(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeHeightParam$6(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeBlockSearchParams$6(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$6(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeHeightParam$6(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$p.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$d.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeTxParams$6(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeTxSearchParams$6(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$d.createJsonRpcRequest)(n.method, encodeValidatorsParams$6(n.params));
  }
};
requests$r.Params = Params$t;
var responses$d = {}, types$8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = void 0, function(n) {
    n[n.Unknown = 0] = "Unknown", n[n.Absent = 1] = "Absent", n[n.Commit = 2] = "Commit", n[n.Nil = 3] = "Nil", n[n.Unrecognized = -1] = "Unrecognized";
  }(e.BlockIdFlag || (e.BlockIdFlag = {}));
})(types$8);
var hasher$6 = {};
Object.defineProperty(hasher$6, "__esModule", { value: !0 });
hasher$6.hashBlock = hasher$6.hashTx = void 0;
const crypto_1$i = build$x, encodings_1$l = encodings$5;
function hashTx$6(e) {
  return (0, crypto_1$i.sha256)(e);
}
hasher$6.hashTx = hashTx$6;
function getSplitPoint$6(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$6(e) {
  const n = new crypto_1$i.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$6(e, n) {
  const o = new crypto_1$i.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$6(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$6(e[0]);
    default: {
      const n = getSplitPoint$6(e.length), o = hashTree$6(e.slice(0, n)), u = hashTree$6(e.slice(n));
      return hashInner$6(o, u);
    }
  }
}
function hashBlock$6(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$l.encodeVersion)(e.version),
    (0, encodings_1$l.encodeString)(e.chainId),
    (0, encodings_1$l.encodeUvarint)(e.height),
    (0, encodings_1$l.encodeTime)(e.time),
    (0, encodings_1$l.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$l.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$l.encodeBytes)(e.dataHash),
    (0, encodings_1$l.encodeBytes)(e.validatorsHash),
    (0, encodings_1$l.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$l.encodeBytes)(e.consensusHash),
    (0, encodings_1$l.encodeBytes)(e.appHash),
    (0, encodings_1$l.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$l.encodeBytes)(e.evidenceHash),
    (0, encodings_1$l.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$6(n);
}
hasher$6.hashBlock = hashBlock$6;
Object.defineProperty(responses$d, "__esModule", { value: !0 });
responses$d.Responses = responses$d.decodeValidatorInfo = responses$d.decodeValidatorGenesis = responses$d.decodeValidatorUpdate = responses$d.decodeEvent = void 0;
const encoding_1$O = build$w, utils_1$C = build$v, dates_1$6 = dates$2, inthelpers_1$c = inthelpers$2, types_1$a = types$8, encodings_1$k = encodings$5, hasher_1$7 = hasher$6;
function decodeAbciInfo$6(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$k.may)(inthelpers_1$c.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$k.may)(encoding_1$O.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$6(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$O.fromBase64)(n.key),
      data: (0, encoding_1$O.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$6(e) {
  return {
    key: (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertString)(e.key ?? "")),
    value: (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertString)(e.value ?? "")),
    proof: (0, encodings_1$k.may)(decodeQueryProof$6, e.proofOps),
    height: (0, encodings_1$k.may)(inthelpers_1$c.apiToSmallInt, e.height),
    code: (0, encodings_1$k.may)(inthelpers_1$c.apiToSmallInt, e.code),
    codespace: (0, encodings_1$k.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$k.may)(inthelpers_1$c.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$k.assertString)(e.info ?? "")
  };
}
function decodeEventAttribute$3(e) {
  return {
    key: (0, encodings_1$k.assertNotEmpty)(e.key),
    value: e.value ?? ""
  };
}
function decodeAttributes$6(e) {
  return (0, encodings_1$k.assertArray)(e).map(decodeEventAttribute$3);
}
function decodeEvent$6(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$6(e.attributes) : []
  };
}
responses$d.decodeEvent = decodeEvent$6;
function decodeEvents$6(e) {
  return (0, encodings_1$k.assertArray)(e).map(decodeEvent$6);
}
function decodeTxData$6(e) {
  return {
    code: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$k.may)(encoding_1$O.fromBase64, e.data),
    events: e.events ? decodeEvents$6(e.events) : [],
    gasWanted: (0, inthelpers_1$c.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$c.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$7(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$C.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$6(e) {
  return {
    maxBytes: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$6(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$6(e) {
  return {
    block: decodeBlockParams$6((0, encodings_1$k.assertObject)(e.block)),
    evidence: decodeEvidenceParams$6((0, encodings_1$k.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$6(e) {
  return {
    pubkey: decodePubkey$7((0, encodings_1$k.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$c.apiToBigInt)(e.power ?? "0")
  };
}
responses$d.decodeValidatorUpdate = decodeValidatorUpdate$6;
function decodeBlockResults$6(e) {
  return {
    height: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$6),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$6),
    consensusUpdates: (0, encodings_1$k.may)(decodeConsensusParams$6, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$6(e.begin_block_events || []),
    endBlockEvents: decodeEvents$6(e.end_block_events || [])
  };
}
function decodeBlockId$6(e) {
  return {
    hash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$k.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$6(e) {
  return {
    block: (0, inthelpers_1$c.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$c.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$6(e) {
  return {
    version: decodeBlockVersion$6(e.version),
    chainId: (0, encodings_1$k.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.height)),
    time: (0, dates_1$6.fromRfc3339WithNanoseconds)((0, encodings_1$k.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$6(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$6(e) {
  return {
    blockId: decodeBlockId$6(e.block_id),
    blockSize: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.block_size)),
    header: decodeHeader$6(e.header),
    numTxs: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$6(e) {
  return {
    lastHeight: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$k.assertArray)(e.block_metas).map(decodeBlockMeta$6)
  };
}
function decodeBroadcastTxSync$6(e) {
  return {
    ...decodeTxData$6(e),
    hash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$6(e) {
  const n = e.tx_result ? decodeTxData$6(e.tx_result) : void 0;
  return {
    height: (0, inthelpers_1$c.apiToSmallInt)(e.height),
    hash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$6((0, encodings_1$k.assertObject)(e.check_tx)),
    deliverTx: n,
    txResult: n
  };
}
function decodeBlockIdFlag$6(e) {
  return (0, utils_1$C.assert)(e in types_1$a.BlockIdFlag), e;
}
function decodeCommitSignature$6(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$6(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$O.fromHex)(e.validator_address) : void 0,
    timestamp: e.timestamp ? (0, dates_1$6.fromRfc3339WithNanoseconds)(e.timestamp) : void 0,
    signature: e.signature ? (0, encoding_1$O.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$6(e) {
  return {
    blockId: decodeBlockId$6((0, encodings_1$k.assertObject)(e.block_id)),
    height: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$c.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$k.assertArray)(e.signatures).map(decodeCommitSignature$6)
  };
}
function decodeCommitResponse$6(e) {
  return {
    canonical: (0, encodings_1$k.assertBoolean)(e.canonical),
    header: decodeHeader$6(e.signed_header.header),
    commit: decodeCommit$6(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$6(e) {
  return {
    address: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$7((0, encodings_1$k.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$c.apiToBigInt)((0, encodings_1$k.assertNotEmpty)(e.power))
  };
}
responses$d.decodeValidatorGenesis = decodeValidatorGenesis$6;
function decodeGenesis$6(e) {
  return {
    genesisTime: (0, dates_1$6.fromRfc3339WithNanoseconds)((0, encodings_1$k.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$k.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$6(e.consensus_params),
    validators: e.validators ? (0, encodings_1$k.assertArray)(e.validators).map(decodeValidatorGenesis$6) : [],
    appHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$6(e) {
  return {
    pubkey: decodePubkey$7((0, encodings_1$k.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$c.apiToBigInt)((0, encodings_1$k.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$c.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$d.decodeValidatorInfo = decodeValidatorInfo$6;
function decodeNodeInfo$6(e) {
  return {
    id: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$k.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$k.assertNotEmpty)(e.network),
    version: (0, encodings_1$k.assertString)(e.version),
    channels: (0, encodings_1$k.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$k.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$k.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$6(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$c.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$6.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$O.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$O.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$6.fromRfc3339WithNanoseconds)((0, encodings_1$k.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$k.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$6(e) {
  return {
    nodeInfo: decodeNodeInfo$6(e.node_info),
    syncInfo: decodeSyncInfo$6(e.sync_info),
    validatorInfo: decodeValidatorInfo$6(e.validator_info)
  };
}
function decodeTxProof$6(e) {
  return {
    data: (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$k.assertArray)(e.proof.aunts).map(encoding_1$O.fromBase64)
    }
  };
}
function decodeTxResponse$6(e) {
  return {
    tx: (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertNotEmpty)(e.tx)),
    result: decodeTxData$6((0, encodings_1$k.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNumber)(e.index)),
    hash: (0, encoding_1$O.fromHex)((0, encodings_1$k.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$k.may)(decodeTxProof$6, e.proof)
  };
}
function decodeTxSearch$6(e) {
  return {
    totalCount: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$k.assertArray)(e.txs).map(decodeTxResponse$6)
  };
}
function decodeTxEvent$6(e) {
  const n = (0, encoding_1$O.fromBase64)((0, encodings_1$k.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$7.hashTx)(n),
    result: decodeTxData$6(e.result),
    height: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.height))
  };
}
function decodeValidators$6(e) {
  return {
    blockHeight: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$k.assertArray)(e.validators).map(decodeValidatorInfo$6),
    count: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.total))
  };
}
function decodeBlock$6(e) {
  var n;
  return {
    header: decodeHeader$6((0, encodings_1$k.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$6((0, encodings_1$k.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$k.assertArray)(e.data.txs).map(encoding_1$O.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$6(e) {
  return {
    blockId: decodeBlockId$6(e.block_id),
    block: decodeBlock$6(e.block)
  };
}
function decodeBlockSearch$6(e) {
  return {
    totalCount: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$k.assertArray)(e.blocks).map(decodeBlockResponse$6)
  };
}
function decodeNumUnconfirmedTxs$6(e) {
  return {
    total: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$c.apiToSmallInt)((0, encodings_1$k.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$6 = class od {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$6((0, encodings_1$k.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$6((0, encodings_1$k.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$6(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$6(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$6(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$6(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$6(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return od.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$6(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$6(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$6((0, encodings_1$k.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$6(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$6(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$6(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$6(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$6(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$6(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$6(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$6(n.result);
  }
};
responses$d.Responses = Responses$6;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$r;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$d;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$6);
var __createBinding$A = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$A = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$A = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$A(n, e, o);
  return __setModuleDefault$A(n, e), n;
};
Object.defineProperty(comet38client$1, "__esModule", { value: !0 });
comet38client$1.Comet38Client = void 0;
const jsonrpc_1$c = jsonrpc$2, rpcclients_1$6 = rpcclients$2, adaptor_1$6 = adaptor$6, requests$o = __importStar$A(requests$q);
let Comet38Client$1 = class Ku {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$6.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$6.HttpClient(n) : new rpcclients_1$6.WebsocketClient(n), await this.detectVersion(o), Ku.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new Ku(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$c.createJsonRpcRequest)(requests$o.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$o.Method.AbciInfo };
    return this.doCall(n, adaptor_1$6.Params.encodeAbciInfo, adaptor_1$6.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$o.Method.AbciQuery };
    return this.doCall(o, adaptor_1$6.Params.encodeAbciQuery, adaptor_1$6.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$o.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$6.Params.encodeBlock, adaptor_1$6.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$o.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$6.Params.encodeBlockResults, adaptor_1$6.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$o.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$6.Params.encodeBlockSearch, adaptor_1$6.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$o.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$6.Params.encodeBlockchain, adaptor_1$6.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$o.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$6.Params.encodeBroadcastTx, adaptor_1$6.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$o.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$6.Params.encodeBroadcastTx, adaptor_1$6.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$o.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$6.Params.encodeBroadcastTx, adaptor_1$6.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$o.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$6.Params.encodeCommit, adaptor_1$6.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$o.Method.Genesis };
    return this.doCall(n, adaptor_1$6.Params.encodeGenesis, adaptor_1$6.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$o.Method.Health };
    return this.doCall(n, adaptor_1$6.Params.encodeHealth, adaptor_1$6.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$o.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$6.Params.encodeNumUnconfirmedTxs, adaptor_1$6.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$o.Method.Status };
    return this.doCall(n, adaptor_1$6.Params.encodeStatus, adaptor_1$6.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$o.Method.Subscribe,
      query: { type: requests$o.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$6.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$o.Method.Subscribe,
      query: { type: requests$o.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$6.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$o.Method.Subscribe,
      query: {
        type: requests$o.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$6.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$o.Method.Tx };
    return this.doCall(o, adaptor_1$6.Params.encodeTx, adaptor_1$6.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$o.Method.TxSearch };
    return this.doCall(o, adaptor_1$6.Params.encodeTxSearch, adaptor_1$6.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$o.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$6.Params.encodeValidators, adaptor_1$6.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$6.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$6.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
};
comet38client$1.Comet38Client = Comet38Client$1;
var responses$c = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$c);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = e.Comet38Client = void 0;
  var n = comet38client$1;
  Object.defineProperty(e, "Comet38Client", { enumerable: !0, get: function() {
    return n.Comet38Client;
  } });
  var o = requests$q;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return o.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return o.SubscriptionEventType;
  } });
  var u = responses$c;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return u.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return u.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return u.VoteType;
  } });
})(comet38$1);
var tendermint34$2 = {}, requests$n = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$n);
var responses$b = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$b);
var tendermint34client$2 = {}, adaptor$5 = {}, requests$m = {}, __createBinding$z = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$z = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$z(n, e, o);
  return __setModuleDefault$z(n, e), n;
};
Object.defineProperty(requests$m, "__esModule", { value: !0 });
requests$m.Params = void 0;
const encoding_1$N = build$w, inthelpers_1$b = inthelpers$2, jsonrpc_1$b = jsonrpc$2, encodings_1$j = encodings$6, requests$l = __importStar$z(requests$n);
function encodeHeightParam$5(e) {
  return {
    height: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$5(e) {
  return {
    minHeight: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$5(e) {
  return {
    query: e.query,
    page: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.page),
    per_page: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$5(e) {
  return {
    path: (0, encodings_1$j.assertNotEmpty)(e.path),
    data: (0, encoding_1$N.toHex)(e.data),
    height: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$5(e) {
  return {
    tx: (0, encoding_1$N.toBase64)((0, encodings_1$j.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$5(e) {
  return {
    hash: (0, encoding_1$N.toBase64)((0, encodings_1$j.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$5(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.page),
    per_page: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$5(e) {
  return {
    height: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.height),
    page: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.page),
    per_page: (0, encodings_1$j.may)(inthelpers_1$b.smallIntToApi, e.per_page)
  };
}
let Params$s = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeAbciQueryParams$5(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeHeightParam$5(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$5(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeHeightParam$5(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeBlockSearchParams$5(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$5(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeHeightParam$5(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$l.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$b.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeTxParams$5(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeTxSearchParams$5(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$b.createJsonRpcRequest)(n.method, encodeValidatorsParams$5(n.params));
  }
};
requests$m.Params = Params$s;
var responses$a = {}, hasher$5 = {};
Object.defineProperty(hasher$5, "__esModule", { value: !0 });
hasher$5.hashBlock = hasher$5.hashTx = void 0;
const crypto_1$h = build$x, encodings_1$i = encodings$6;
function hashTx$5(e) {
  return (0, crypto_1$h.sha256)(e);
}
hasher$5.hashTx = hashTx$5;
function getSplitPoint$5(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$5(e) {
  const n = new crypto_1$h.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$5(e, n) {
  const o = new crypto_1$h.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$5(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$5(e[0]);
    default: {
      const n = getSplitPoint$5(e.length), o = hashTree$5(e.slice(0, n)), u = hashTree$5(e.slice(n));
      return hashInner$5(o, u);
    }
  }
}
function hashBlock$5(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$i.encodeVersion)(e.version),
    (0, encodings_1$i.encodeString)(e.chainId),
    (0, encodings_1$i.encodeUvarint)(e.height),
    (0, encodings_1$i.encodeTime)(e.time),
    (0, encodings_1$i.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$i.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$i.encodeBytes)(e.dataHash),
    (0, encodings_1$i.encodeBytes)(e.validatorsHash),
    (0, encodings_1$i.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$i.encodeBytes)(e.consensusHash),
    (0, encodings_1$i.encodeBytes)(e.appHash),
    (0, encodings_1$i.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$i.encodeBytes)(e.evidenceHash),
    (0, encodings_1$i.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$5(n);
}
hasher$5.hashBlock = hashBlock$5;
Object.defineProperty(responses$a, "__esModule", { value: !0 });
responses$a.Responses = responses$a.decodeValidatorInfo = responses$a.decodeValidatorGenesis = responses$a.decodeValidatorUpdate = responses$a.decodeEvent = void 0;
const encoding_1$M = build$w, utils_1$B = build$v, dates_1$5 = dates$2, inthelpers_1$a = inthelpers$2, types_1$9 = types$8, encodings_1$h = encodings$6, hasher_1$6 = hasher$5;
function decodeAbciInfo$5(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$h.may)(inthelpers_1$a.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$h.may)(encoding_1$M.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$5(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$M.fromBase64)(n.key),
      data: (0, encoding_1$M.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$5(e) {
  return {
    key: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertString)(e.key ?? "")),
    value: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertString)(e.value ?? "")),
    proof: (0, encodings_1$h.may)(decodeQueryProof$5, e.proofOps),
    height: (0, encodings_1$h.may)(inthelpers_1$a.apiToSmallInt, e.height),
    code: (0, encodings_1$h.may)(inthelpers_1$a.apiToSmallInt, e.code),
    codespace: (0, encodings_1$h.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$h.may)(inthelpers_1$a.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$h.assertString)(e.info ?? "")
  };
}
function decodeAttribute$2(e) {
  return {
    key: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertNotEmpty)(e.key)),
    value: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertString)(e.value ?? ""))
  };
}
function decodeAttributes$5(e) {
  return (0, encodings_1$h.assertArray)(e).map(decodeAttribute$2);
}
function decodeEvent$5(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$5(e.attributes) : []
  };
}
responses$a.decodeEvent = decodeEvent$5;
function decodeEvents$5(e) {
  return (0, encodings_1$h.assertArray)(e).map(decodeEvent$5);
}
function decodeTxData$5(e) {
  return {
    code: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$h.may)(encoding_1$M.fromBase64, e.data),
    events: e.events ? decodeEvents$5(e.events) : [],
    gasWanted: (0, inthelpers_1$a.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$a.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$6(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$B.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$5(e) {
  return {
    maxBytes: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$5(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$5(e) {
  return {
    block: decodeBlockParams$5((0, encodings_1$h.assertObject)(e.block)),
    evidence: decodeEvidenceParams$5((0, encodings_1$h.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$5(e) {
  return {
    pubkey: decodePubkey$6((0, encodings_1$h.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$a.apiToBigInt)(e.power ?? "0")
  };
}
responses$a.decodeValidatorUpdate = decodeValidatorUpdate$5;
function decodeBlockResults$5(e) {
  return {
    height: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$5),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$5),
    consensusUpdates: (0, encodings_1$h.may)(decodeConsensusParams$5, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$5(e.begin_block_events || []),
    endBlockEvents: decodeEvents$5(e.end_block_events || [])
  };
}
function decodeBlockId$5(e) {
  return {
    hash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$h.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$5(e) {
  return {
    block: (0, inthelpers_1$a.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$a.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$5(e) {
  return {
    version: decodeBlockVersion$5(e.version),
    chainId: (0, encodings_1$h.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.height)),
    time: (0, dates_1$5.fromRfc3339WithNanoseconds)((0, encodings_1$h.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$5(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$5(e) {
  return {
    blockId: decodeBlockId$5(e.block_id),
    blockSize: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.block_size)),
    header: decodeHeader$5(e.header),
    numTxs: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$5(e) {
  return {
    lastHeight: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$h.assertArray)(e.block_metas).map(decodeBlockMeta$5)
  };
}
function decodeBroadcastTxSync$5(e) {
  return {
    ...decodeTxData$5(e),
    hash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$5(e) {
  return {
    height: (0, inthelpers_1$a.apiToSmallInt)(e.height),
    hash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$5((0, encodings_1$h.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1$h.may)(decodeTxData$5, e.deliver_tx)
  };
}
function decodeBlockIdFlag$5(e) {
  return (0, utils_1$B.assert)(e in types_1$9.BlockIdFlag), e;
}
function decodeCommitSignature$5(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$5(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$M.fromHex)(e.validator_address) : void 0,
    timestamp: e.timestamp ? (0, dates_1$5.fromRfc3339WithNanoseconds)(e.timestamp) : void 0,
    signature: e.signature ? (0, encoding_1$M.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$5(e) {
  return {
    blockId: decodeBlockId$5((0, encodings_1$h.assertObject)(e.block_id)),
    height: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$a.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$h.assertArray)(e.signatures).map(decodeCommitSignature$5)
  };
}
function decodeCommitResponse$5(e) {
  return {
    canonical: (0, encodings_1$h.assertBoolean)(e.canonical),
    header: decodeHeader$5(e.signed_header.header),
    commit: decodeCommit$5(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$5(e) {
  return {
    address: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$6((0, encodings_1$h.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$a.apiToBigInt)((0, encodings_1$h.assertNotEmpty)(e.power))
  };
}
responses$a.decodeValidatorGenesis = decodeValidatorGenesis$5;
function decodeGenesis$5(e) {
  return {
    genesisTime: (0, dates_1$5.fromRfc3339WithNanoseconds)((0, encodings_1$h.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$h.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$5(e.consensus_params),
    validators: e.validators ? (0, encodings_1$h.assertArray)(e.validators).map(decodeValidatorGenesis$5) : [],
    appHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$5(e) {
  return {
    pubkey: decodePubkey$6((0, encodings_1$h.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$a.apiToBigInt)((0, encodings_1$h.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$a.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$a.decodeValidatorInfo = decodeValidatorInfo$5;
function decodeNodeInfo$5(e) {
  return {
    id: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$h.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$h.assertNotEmpty)(e.network),
    version: (0, encodings_1$h.assertString)(e.version),
    channels: (0, encodings_1$h.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$h.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$h.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$5(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$a.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$5.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$M.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$M.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$5.fromRfc3339WithNanoseconds)((0, encodings_1$h.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$h.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$5(e) {
  return {
    nodeInfo: decodeNodeInfo$5(e.node_info),
    syncInfo: decodeSyncInfo$5(e.sync_info),
    validatorInfo: decodeValidatorInfo$5(e.validator_info)
  };
}
function decodeTxProof$5(e) {
  return {
    data: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$h.assertArray)(e.proof.aunts).map(encoding_1$M.fromBase64)
    }
  };
}
function decodeTxResponse$5(e) {
  return {
    tx: (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertNotEmpty)(e.tx)),
    result: decodeTxData$5((0, encodings_1$h.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNumber)(e.index)),
    hash: (0, encoding_1$M.fromHex)((0, encodings_1$h.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$h.may)(decodeTxProof$5, e.proof)
  };
}
function decodeTxSearch$5(e) {
  return {
    totalCount: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$h.assertArray)(e.txs).map(decodeTxResponse$5)
  };
}
function decodeTxEvent$5(e) {
  const n = (0, encoding_1$M.fromBase64)((0, encodings_1$h.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$6.hashTx)(n),
    result: decodeTxData$5(e.result),
    height: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.height))
  };
}
function decodeValidators$5(e) {
  return {
    blockHeight: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$h.assertArray)(e.validators).map(decodeValidatorInfo$5),
    count: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.total))
  };
}
function decodeBlock$5(e) {
  var n;
  return {
    header: decodeHeader$5((0, encodings_1$h.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$5((0, encodings_1$h.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$h.assertArray)(e.data.txs).map(encoding_1$M.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$5(e) {
  return {
    blockId: decodeBlockId$5(e.block_id),
    block: decodeBlock$5(e.block)
  };
}
function decodeBlockSearch$5(e) {
  return {
    totalCount: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$h.assertArray)(e.blocks).map(decodeBlockResponse$5)
  };
}
function decodeNumUnconfirmedTxs$5(e) {
  return {
    total: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$a.apiToSmallInt)((0, encodings_1$h.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$5 = class sd {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$5((0, encodings_1$h.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$5((0, encodings_1$h.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$5(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$5(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$5(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$5(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$5(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return sd.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$5(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$5(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$5((0, encodings_1$h.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$5(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$5(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$5(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$5(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$5(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$5(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$5(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$5(n.result);
  }
};
responses$a.Responses = Responses$5;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$m;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$a;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$5);
var __createBinding$y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$y = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$y = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$y(n, e, o);
  return __setModuleDefault$y(n, e), n;
};
Object.defineProperty(tendermint34client$2, "__esModule", { value: !0 });
tendermint34client$2.Tendermint34Client = void 0;
const jsonrpc_1$a = jsonrpc$2, rpcclients_1$5 = rpcclients$2, adaptor_1$5 = adaptor$5, requests$k = __importStar$y(requests$n);
let Tendermint34Client$2 = class Yu {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$5.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$5.HttpClient(n) : new rpcclients_1$5.WebsocketClient(n), await this.detectVersion(o), Yu.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new Yu(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$a.createJsonRpcRequest)(requests$k.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$k.Method.AbciInfo };
    return this.doCall(n, adaptor_1$5.Params.encodeAbciInfo, adaptor_1$5.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$k.Method.AbciQuery };
    return this.doCall(o, adaptor_1$5.Params.encodeAbciQuery, adaptor_1$5.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$k.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$5.Params.encodeBlock, adaptor_1$5.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$k.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$5.Params.encodeBlockResults, adaptor_1$5.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$k.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$5.Params.encodeBlockSearch, adaptor_1$5.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$k.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$5.Params.encodeBlockchain, adaptor_1$5.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$k.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$5.Params.encodeBroadcastTx, adaptor_1$5.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$k.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$5.Params.encodeBroadcastTx, adaptor_1$5.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$k.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$5.Params.encodeBroadcastTx, adaptor_1$5.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$k.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$5.Params.encodeCommit, adaptor_1$5.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$k.Method.Genesis };
    return this.doCall(n, adaptor_1$5.Params.encodeGenesis, adaptor_1$5.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$k.Method.Health };
    return this.doCall(n, adaptor_1$5.Params.encodeHealth, adaptor_1$5.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$k.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$5.Params.encodeNumUnconfirmedTxs, adaptor_1$5.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$k.Method.Status };
    return this.doCall(n, adaptor_1$5.Params.encodeStatus, adaptor_1$5.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$k.Method.Subscribe,
      query: { type: requests$k.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$5.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$k.Method.Subscribe,
      query: { type: requests$k.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$5.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$k.Method.Subscribe,
      query: {
        type: requests$k.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$5.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$k.Method.Tx };
    return this.doCall(o, adaptor_1$5.Params.encodeTx, adaptor_1$5.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$k.Method.TxSearch };
    return this.doCall(o, adaptor_1$5.Params.encodeTxSearch, adaptor_1$5.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$k.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$5.Params.encodeValidators, adaptor_1$5.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$5.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$5.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
};
tendermint34client$2.Tendermint34Client = Tendermint34Client$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint34Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var n = requests$n;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return n.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return n.SubscriptionEventType;
  } });
  var o = responses$b;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return o.VoteType;
  } });
  var u = tendermint34client$2;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return u.Tendermint34Client;
  } });
})(tendermint34$2);
var tendermint37$1 = {}, requests$j = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$j);
var responses$9 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$9);
var tendermint37client$1 = {}, adaptor$4 = {}, requests$i = {}, encodings$4 = {};
Object.defineProperty(encodings$4, "__esModule", { value: !0 });
encodings$4.encodeBlockId = encodings$4.encodeVersion = encodings$4.encodeBytes = encodings$4.encodeTime = encodings$4.encodeUvarint = encodings$4.encodeString = encodings$4.dictionaryToStringMap = encodings$4.may = encodings$4.assertNotEmpty = encodings$4.assertObject = encodings$4.assertArray = encodings$4.assertNumber = encodings$4.assertString = encodings$4.assertBoolean = encodings$4.assertSet = void 0;
const encoding_1$L = build$w;
function assertSet$4(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$4.assertSet = assertSet$4;
function assertBoolean$4(e) {
  if (assertSet$4(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$4.assertBoolean = assertBoolean$4;
function assertString$4(e) {
  if (assertSet$4(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$4.assertString = assertString$4;
function assertNumber$4(e) {
  if (assertSet$4(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$4.assertNumber = assertNumber$4;
function assertArray$4(e) {
  if (assertSet$4(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$4.assertArray = assertArray$4;
function assertObject$4(e) {
  if (assertSet$4(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$4.assertObject = assertObject$4;
function assertNotEmpty$4(e) {
  if (assertSet$4(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$4.assertNotEmpty = assertNotEmpty$4;
function may$4(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$4.may = may$4;
function dictionaryToStringMap$4(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$4.dictionaryToStringMap = dictionaryToStringMap$4;
function encodeString$4(e) {
  const n = (0, encoding_1$L.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$4.encodeString = encodeString$4;
function encodeUvarint$5(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$5(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$4.encodeUvarint = encodeUvarint$5;
function encodeTime$4(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$5(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$5(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$4.encodeTime = encodeTime$4;
function encodeBytes$4(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$4.encodeBytes = encodeBytes$4;
function encodeVersion$4(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$5(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$5(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$4.encodeVersion = encodeVersion$4;
function encodeBlockId$4(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$4.encodeBlockId = encodeBlockId$4;
var __createBinding$x = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$x = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$x = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$x(n, e, o);
  return __setModuleDefault$x(n, e), n;
};
Object.defineProperty(requests$i, "__esModule", { value: !0 });
requests$i.Params = void 0;
const encoding_1$K = build$w, inthelpers_1$9 = inthelpers$2, jsonrpc_1$9 = jsonrpc$2, encodings_1$g = encodings$4, requests$h = __importStar$x(requests$j);
function encodeHeightParam$4(e) {
  return {
    height: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$4(e) {
  return {
    minHeight: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$4(e) {
  return {
    query: e.query,
    page: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.page),
    per_page: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$4(e) {
  return {
    path: (0, encodings_1$g.assertNotEmpty)(e.path),
    data: (0, encoding_1$K.toHex)(e.data),
    height: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$4(e) {
  return {
    tx: (0, encoding_1$K.toBase64)((0, encodings_1$g.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$4(e) {
  return {
    hash: (0, encoding_1$K.toBase64)((0, encodings_1$g.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$4(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.page),
    per_page: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$4(e) {
  return {
    height: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.height),
    page: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.page),
    per_page: (0, encodings_1$g.may)(inthelpers_1$9.smallIntToApi, e.per_page)
  };
}
let Params$r = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeAbciQueryParams$4(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeHeightParam$4(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$4(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeHeightParam$4(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeBlockSearchParams$4(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$4(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeHeightParam$4(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$h.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$9.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeTxParams$4(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeTxSearchParams$4(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$9.createJsonRpcRequest)(n.method, encodeValidatorsParams$4(n.params));
  }
};
requests$i.Params = Params$r;
var responses$8 = {}, hasher$4 = {};
Object.defineProperty(hasher$4, "__esModule", { value: !0 });
hasher$4.hashBlock = hasher$4.hashTx = void 0;
const crypto_1$g = build$x, encodings_1$f = encodings$4;
function hashTx$4(e) {
  return (0, crypto_1$g.sha256)(e);
}
hasher$4.hashTx = hashTx$4;
function getSplitPoint$4(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$4(e) {
  const n = new crypto_1$g.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$4(e, n) {
  const o = new crypto_1$g.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$4(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$4(e[0]);
    default: {
      const n = getSplitPoint$4(e.length), o = hashTree$4(e.slice(0, n)), u = hashTree$4(e.slice(n));
      return hashInner$4(o, u);
    }
  }
}
function hashBlock$4(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$f.encodeVersion)(e.version),
    (0, encodings_1$f.encodeString)(e.chainId),
    (0, encodings_1$f.encodeUvarint)(e.height),
    (0, encodings_1$f.encodeTime)(e.time),
    (0, encodings_1$f.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$f.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$f.encodeBytes)(e.dataHash),
    (0, encodings_1$f.encodeBytes)(e.validatorsHash),
    (0, encodings_1$f.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$f.encodeBytes)(e.consensusHash),
    (0, encodings_1$f.encodeBytes)(e.appHash),
    (0, encodings_1$f.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$f.encodeBytes)(e.evidenceHash),
    (0, encodings_1$f.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$4(n);
}
hasher$4.hashBlock = hashBlock$4;
Object.defineProperty(responses$8, "__esModule", { value: !0 });
responses$8.Responses = responses$8.decodeValidatorInfo = responses$8.decodeValidatorGenesis = responses$8.decodeValidatorUpdate = responses$8.decodeEvent = void 0;
const encoding_1$J = build$w, utils_1$A = build$v, dates_1$4 = dates$2, inthelpers_1$8 = inthelpers$2, types_1$8 = types$8, encodings_1$e = encodings$4, hasher_1$5 = hasher$4;
function decodeAbciInfo$4(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$e.may)(inthelpers_1$8.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$e.may)(encoding_1$J.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$4(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$J.fromBase64)(n.key),
      data: (0, encoding_1$J.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$4(e) {
  return {
    key: (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertString)(e.key ?? "")),
    value: (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertString)(e.value ?? "")),
    proof: (0, encodings_1$e.may)(decodeQueryProof$4, e.proofOps),
    height: (0, encodings_1$e.may)(inthelpers_1$8.apiToSmallInt, e.height),
    code: (0, encodings_1$e.may)(inthelpers_1$8.apiToSmallInt, e.code),
    codespace: (0, encodings_1$e.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$e.may)(inthelpers_1$8.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$e.assertString)(e.info ?? "")
  };
}
function decodeEventAttribute$2(e) {
  return {
    key: (0, encodings_1$e.assertNotEmpty)(e.key),
    value: e.value ?? ""
  };
}
function decodeAttributes$4(e) {
  return (0, encodings_1$e.assertArray)(e).map(decodeEventAttribute$2);
}
function decodeEvent$4(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$4(e.attributes) : []
  };
}
responses$8.decodeEvent = decodeEvent$4;
function decodeEvents$4(e) {
  return (0, encodings_1$e.assertArray)(e).map(decodeEvent$4);
}
function decodeTxData$4(e) {
  return {
    code: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$e.may)(encoding_1$J.fromBase64, e.data),
    events: e.events ? decodeEvents$4(e.events) : [],
    gasWanted: (0, inthelpers_1$8.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$8.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$5(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$A.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$4(e) {
  return {
    maxBytes: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$4(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$4(e) {
  return {
    block: decodeBlockParams$4((0, encodings_1$e.assertObject)(e.block)),
    evidence: decodeEvidenceParams$4((0, encodings_1$e.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$4(e) {
  return {
    pubkey: decodePubkey$5((0, encodings_1$e.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$8.apiToBigInt)(e.power ?? "0")
  };
}
responses$8.decodeValidatorUpdate = decodeValidatorUpdate$4;
function decodeBlockResults$4(e) {
  return {
    height: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$4),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$4),
    consensusUpdates: (0, encodings_1$e.may)(decodeConsensusParams$4, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$4(e.begin_block_events || []),
    endBlockEvents: decodeEvents$4(e.end_block_events || [])
  };
}
function decodeBlockId$4(e) {
  return {
    hash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$e.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$4(e) {
  return {
    block: (0, inthelpers_1$8.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$8.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$4(e) {
  return {
    version: decodeBlockVersion$4(e.version),
    chainId: (0, encodings_1$e.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.height)),
    time: (0, dates_1$4.fromRfc3339WithNanoseconds)((0, encodings_1$e.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$4(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$4(e) {
  return {
    blockId: decodeBlockId$4(e.block_id),
    blockSize: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.block_size)),
    header: decodeHeader$4(e.header),
    numTxs: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$4(e) {
  return {
    lastHeight: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$e.assertArray)(e.block_metas).map(decodeBlockMeta$4)
  };
}
function decodeBroadcastTxSync$4(e) {
  return {
    ...decodeTxData$4(e),
    hash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$4(e) {
  return {
    height: (0, inthelpers_1$8.apiToSmallInt)(e.height),
    hash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$4((0, encodings_1$e.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1$e.may)(decodeTxData$4, e.deliver_tx)
  };
}
function decodeBlockIdFlag$4(e) {
  return (0, utils_1$A.assert)(e in types_1$8.BlockIdFlag), e;
}
function decodeCommitSignature$4(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$4(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$J.fromHex)(e.validator_address) : void 0,
    timestamp: e.timestamp ? (0, dates_1$4.fromRfc3339WithNanoseconds)(e.timestamp) : void 0,
    signature: e.signature ? (0, encoding_1$J.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$4(e) {
  return {
    blockId: decodeBlockId$4((0, encodings_1$e.assertObject)(e.block_id)),
    height: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$8.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$e.assertArray)(e.signatures).map(decodeCommitSignature$4)
  };
}
function decodeCommitResponse$4(e) {
  return {
    canonical: (0, encodings_1$e.assertBoolean)(e.canonical),
    header: decodeHeader$4(e.signed_header.header),
    commit: decodeCommit$4(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$4(e) {
  return {
    address: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$5((0, encodings_1$e.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$8.apiToBigInt)((0, encodings_1$e.assertNotEmpty)(e.power))
  };
}
responses$8.decodeValidatorGenesis = decodeValidatorGenesis$4;
function decodeGenesis$4(e) {
  return {
    genesisTime: (0, dates_1$4.fromRfc3339WithNanoseconds)((0, encodings_1$e.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$e.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$4(e.consensus_params),
    validators: e.validators ? (0, encodings_1$e.assertArray)(e.validators).map(decodeValidatorGenesis$4) : [],
    appHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$4(e) {
  return {
    pubkey: decodePubkey$5((0, encodings_1$e.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$8.apiToBigInt)((0, encodings_1$e.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$8.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$8.decodeValidatorInfo = decodeValidatorInfo$4;
function decodeNodeInfo$4(e) {
  return {
    id: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$e.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$e.assertNotEmpty)(e.network),
    version: (0, encodings_1$e.assertString)(e.version),
    channels: (0, encodings_1$e.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$e.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$e.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$4(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$8.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$4.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$J.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$J.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$4.fromRfc3339WithNanoseconds)((0, encodings_1$e.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$e.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$4(e) {
  return {
    nodeInfo: decodeNodeInfo$4(e.node_info),
    syncInfo: decodeSyncInfo$4(e.sync_info),
    validatorInfo: decodeValidatorInfo$4(e.validator_info)
  };
}
function decodeTxProof$4(e) {
  return {
    data: (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$e.assertArray)(e.proof.aunts).map(encoding_1$J.fromBase64)
    }
  };
}
function decodeTxResponse$4(e) {
  return {
    tx: (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertNotEmpty)(e.tx)),
    result: decodeTxData$4((0, encodings_1$e.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNumber)(e.index)),
    hash: (0, encoding_1$J.fromHex)((0, encodings_1$e.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$e.may)(decodeTxProof$4, e.proof)
  };
}
function decodeTxSearch$4(e) {
  return {
    totalCount: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$e.assertArray)(e.txs).map(decodeTxResponse$4)
  };
}
function decodeTxEvent$4(e) {
  const n = (0, encoding_1$J.fromBase64)((0, encodings_1$e.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$5.hashTx)(n),
    result: decodeTxData$4(e.result),
    height: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.height))
  };
}
function decodeValidators$4(e) {
  return {
    blockHeight: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$e.assertArray)(e.validators).map(decodeValidatorInfo$4),
    count: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.total))
  };
}
function decodeBlock$4(e) {
  var n;
  return {
    header: decodeHeader$4((0, encodings_1$e.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$4((0, encodings_1$e.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$e.assertArray)(e.data.txs).map(encoding_1$J.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$4(e) {
  return {
    blockId: decodeBlockId$4(e.block_id),
    block: decodeBlock$4(e.block)
  };
}
function decodeBlockSearch$4(e) {
  return {
    totalCount: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$e.assertArray)(e.blocks).map(decodeBlockResponse$4)
  };
}
function decodeNumUnconfirmedTxs$4(e) {
  return {
    total: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$8.apiToSmallInt)((0, encodings_1$e.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$4 = class ad {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$4((0, encodings_1$e.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$4((0, encodings_1$e.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$4(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$4(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$4(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$4(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$4(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return ad.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$4(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$4(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$4((0, encodings_1$e.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$4(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$4(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$4(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$4(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$4(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$4(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$4(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$4(n.result);
  }
};
responses$8.Responses = Responses$4;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$i;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$8;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$4);
var __createBinding$w = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$w = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$w = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$w(n, e, o);
  return __setModuleDefault$w(n, e), n;
};
Object.defineProperty(tendermint37client$1, "__esModule", { value: !0 });
tendermint37client$1.Tendermint37Client = void 0;
const jsonrpc_1$8 = jsonrpc$2, rpcclients_1$4 = rpcclients$2, adaptor_1$4 = adaptor$4, requests$g = __importStar$w(requests$j);
let Tendermint37Client$1 = class Zu {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$4.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$4.HttpClient(n) : new rpcclients_1$4.WebsocketClient(n), await this.detectVersion(o), Zu.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new Zu(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$8.createJsonRpcRequest)(requests$g.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$g.Method.AbciInfo };
    return this.doCall(n, adaptor_1$4.Params.encodeAbciInfo, adaptor_1$4.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$g.Method.AbciQuery };
    return this.doCall(o, adaptor_1$4.Params.encodeAbciQuery, adaptor_1$4.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$g.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$4.Params.encodeBlock, adaptor_1$4.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$g.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$4.Params.encodeBlockResults, adaptor_1$4.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$g.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$4.Params.encodeBlockSearch, adaptor_1$4.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$g.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$4.Params.encodeBlockchain, adaptor_1$4.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$g.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$4.Params.encodeBroadcastTx, adaptor_1$4.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$g.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$4.Params.encodeBroadcastTx, adaptor_1$4.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$g.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$4.Params.encodeBroadcastTx, adaptor_1$4.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$g.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$4.Params.encodeCommit, adaptor_1$4.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$g.Method.Genesis };
    return this.doCall(n, adaptor_1$4.Params.encodeGenesis, adaptor_1$4.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$g.Method.Health };
    return this.doCall(n, adaptor_1$4.Params.encodeHealth, adaptor_1$4.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$g.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$4.Params.encodeNumUnconfirmedTxs, adaptor_1$4.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$g.Method.Status };
    return this.doCall(n, adaptor_1$4.Params.encodeStatus, adaptor_1$4.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$g.Method.Subscribe,
      query: { type: requests$g.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$4.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$g.Method.Subscribe,
      query: { type: requests$g.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$4.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$g.Method.Subscribe,
      query: {
        type: requests$g.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$4.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$g.Method.Tx };
    return this.doCall(o, adaptor_1$4.Params.encodeTx, adaptor_1$4.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$g.Method.TxSearch };
    return this.doCall(o, adaptor_1$4.Params.encodeTxSearch, adaptor_1$4.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$g.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$4.Params.encodeValidators, adaptor_1$4.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$4.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$4.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
};
tendermint37client$1.Tendermint37Client = Tendermint37Client$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint37Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var n = requests$j;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return n.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return n.SubscriptionEventType;
  } });
  var o = responses$9;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return o.VoteType;
  } });
  var u = tendermint37client$1;
  Object.defineProperty(e, "Tendermint37Client", { enumerable: !0, get: function() {
    return u.Tendermint37Client;
  } });
})(tendermint37$1);
var tendermintclient$1 = {};
Object.defineProperty(tendermintclient$1, "__esModule", { value: !0 });
tendermintclient$1.connectComet = tendermintclient$1.isComet38Client = tendermintclient$1.isTendermint37Client = tendermintclient$1.isTendermint34Client = void 0;
const comet38_1$1 = comet38$1, tendermint34_1$1 = tendermint34$2, tendermint37_1$1 = tendermint37$1;
function isTendermint34Client$1(e) {
  return e instanceof tendermint34_1$1.Tendermint34Client;
}
tendermintclient$1.isTendermint34Client = isTendermint34Client$1;
function isTendermint37Client$1(e) {
  return e instanceof tendermint37_1$1.Tendermint37Client;
}
tendermintclient$1.isTendermint37Client = isTendermint37Client$1;
function isComet38Client$1(e) {
  return e instanceof comet38_1$1.Comet38Client;
}
tendermintclient$1.isComet38Client = isComet38Client$1;
async function connectComet$1(e) {
  let n;
  const o = await tendermint37_1$1.Tendermint37Client.connect(e), u = (await o.status()).nodeInfo.version;
  return u.startsWith("0.37.") ? n = o : u.startsWith("0.38.") ? (o.disconnect(), n = await comet38_1$1.Comet38Client.connect(e)) : (o.disconnect(), n = await tendermint34_1$1.Tendermint34Client.connect(e)), n;
}
tendermintclient$1.connectComet = connectComet$1;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(y, V, M, G) {
    G === void 0 && (G = M);
    var k = Object.getOwnPropertyDescriptor(V, M);
    (!k || ("get" in k ? !V.__esModule : k.writable || k.configurable)) && (k = { enumerable: !0, get: function() {
      return V[M];
    } }), Object.defineProperty(y, G, k);
  } : function(y, V, M, G) {
    G === void 0 && (G = M), y[G] = V[M];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(y, V) {
    Object.defineProperty(y, "default", { enumerable: !0, value: V });
  } : function(y, V) {
    y.default = V;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(y) {
    if (y && y.__esModule)
      return y;
    var V = {};
    if (y != null)
      for (var M in y)
        M !== "default" && Object.prototype.hasOwnProperty.call(y, M) && n(V, y, M);
    return o(V, y), V;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = e.isTendermint37Client = e.isTendermint34Client = e.isComet38Client = e.connectComet = e.Tendermint37Client = e.tendermint37 = e.Tendermint34Client = e.tendermint34 = e.VoteType = e.SubscriptionEventType = e.Method = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.WebsocketClient = e.HttpClient = e.HttpBatchClient = e.Comet38Client = e.comet38 = e.toSeconds = e.toRfc3339WithNanoseconds = e.fromSeconds = e.fromRfc3339WithNanoseconds = e.DateTime = e.rawSecp256k1PubkeyToRawAddress = e.rawEd25519PubkeyToRawAddress = e.pubkeyToRawAddress = e.pubkeyToAddress = void 0;
  var c = addresses$3;
  Object.defineProperty(e, "pubkeyToAddress", { enumerable: !0, get: function() {
    return c.pubkeyToAddress;
  } }), Object.defineProperty(e, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.pubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.rawSecp256k1PubkeyToRawAddress;
  } });
  var d = dates$2;
  Object.defineProperty(e, "DateTime", { enumerable: !0, get: function() {
    return d.DateTime;
  } }), Object.defineProperty(e, "fromRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return d.fromRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "fromSeconds", { enumerable: !0, get: function() {
    return d.fromSeconds;
  } }), Object.defineProperty(e, "toRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return d.toRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "toSeconds", { enumerable: !0, get: function() {
    return d.toSeconds;
  } }), e.comet38 = u(comet38$1);
  var m = comet38$1;
  Object.defineProperty(e, "Comet38Client", { enumerable: !0, get: function() {
    return m.Comet38Client;
  } });
  var v = rpcclients$2;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return v.HttpBatchClient;
  } }), Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return v.HttpClient;
  } }), Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return v.WebsocketClient;
  } });
  var S = tendermint34$2;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return S.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return S.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return S.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return S.SubscriptionEventType;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return S.VoteType;
  } }), e.tendermint34 = u(tendermint34$2);
  var $ = tendermint34$2;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return $.Tendermint34Client;
  } }), e.tendermint37 = u(tendermint37$1);
  var E = tendermint37$1;
  Object.defineProperty(e, "Tendermint37Client", { enumerable: !0, get: function() {
    return E.Tendermint37Client;
  } });
  var O = tendermintclient$1;
  Object.defineProperty(e, "connectComet", { enumerable: !0, get: function() {
    return O.connectComet;
  } }), Object.defineProperty(e, "isComet38Client", { enumerable: !0, get: function() {
    return O.isComet38Client;
  } }), Object.defineProperty(e, "isTendermint34Client", { enumerable: !0, get: function() {
    return O.isTendermint34Client;
  } }), Object.defineProperty(e, "isTendermint37Client", { enumerable: !0, get: function() {
    return O.isTendermint37Client;
  } });
  var T = types$8;
  Object.defineProperty(e, "BlockIdFlag", { enumerable: !0, get: function() {
    return T.BlockIdFlag;
  } });
})(build$y);
async function get$1(e) {
  return (await fetch(e)).json();
}
const createTmClient = (e) => {
  const o = e.startsWith("http://") || e.startsWith("https://") ? new build$y.HttpClient(e) : new build$y.WebsocketClient(e);
  return new build$y.Tendermint37Client(o);
}, createQueryClient = (e) => {
  const n = createTmClient(e), o = build$S.QueryClient.withExtensions(
    // @ts-ignore
    n,
    build$S.setupAuthExtension,
    build$S.setupBankExtension,
    build$S.setupStakingExtension,
    build$S.setupMintExtension,
    build$S.setupGovExtension,
    build$S.setupIbcExtension,
    build$S.setupSlashingExtension,
    build$S.setupDistributionExtension,
    build$S.setupTxExtension
  );
  return o.client = n, o;
};
async function getLatestBlock(e) {
  return await createTmClient(e).block();
}
async function getAccount(e, n) {
  const u = await createQueryClient(e).auth.account(n);
  if (u != null && u.value)
    return auth.BaseAccount.decode(u.value);
}
async function getBalance(e, n) {
  return { balances: await createQueryClient(e).bank.allBalances(n) };
}
async function getBalanceMetadata(e, n) {
  return n === "orai" ? {
    metadata: {
      description: "The native token of Osmosis",
      denomUnits: [
        {
          denom: "orai",
          exponent: 6,
          aliases: []
        }
      ],
      base: "orai",
      display: "orai",
      name: "",
      symbol: "",
      uri: "",
      uriHash: ""
    }
  } : { metadata: await createQueryClient(e).bank.denomMetadata(n) };
}
async function getIBCDenomMetadata(e) {
  const n = `https://metadata.ping.pub/metadata/${e.replace(
    "ibc/",
    ""
  )}`;
  return get$1(n);
}
async function getDelegateRewards(e, n) {
  return await createQueryClient(e).distribution.delegationTotalRewards(n);
}
async function getDelegations(e, n, o) {
  return await createQueryClient(e).staking.delegation(o, n);
}
async function getActiveValidators(e) {
  return await createQueryClient(e).staking.validators("BOND_STATUS_BONDED");
}
async function getInactiveValidators(e) {
  return await createQueryClient(e).staking.validators("BOND_STATUS_UNBONDED");
}
async function getDenomTraces(e, n) {
  return await createQueryClient(e).ibc.transfer.denomTrace(n);
}
async function getTxByHash(e, n) {
  return await createQueryClient(e).tx.getTx(n);
}
async function getStakingParam(e) {
  return await createQueryClient(e).staking.params();
}
async function getOsmosisPools(e) {
  const n = `${e}/osmosis/gamm/v1beta1/pools?pagination.limit=1000`;
  return get$1(n);
}
var build$o = {}, cosmwasmclient = {}, build$n = {}, ascii$2 = {};
Object.defineProperty(ascii$2, "__esModule", { value: !0 });
ascii$2.fromAscii = ascii$2.toAscii = void 0;
function toAscii$2(e) {
  const n = (o) => o.split("").map((u) => {
    const c = u.charCodeAt(0);
    if (c < 32 || c > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + c);
    return c;
  });
  return Uint8Array.from(n(e));
}
ascii$2.toAscii = toAscii$2;
function fromAscii$2(e) {
  return ((o) => o.map((u) => {
    if (u < 32 || u > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + u);
    return String.fromCharCode(u);
  }))(Array.from(e)).join("");
}
ascii$2.fromAscii = fromAscii$2;
var base64$2 = {}, __createBinding$v = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$v = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$v = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$v(n, e, o);
  return __setModuleDefault$v(n, e), n;
};
Object.defineProperty(base64$2, "__esModule", { value: !0 });
base64$2.fromBase64 = base64$2.toBase64 = void 0;
const base64js$2 = __importStar$v(base64Js);
function toBase64$2(e) {
  return base64js$2.fromByteArray(e);
}
base64$2.toBase64 = toBase64$2;
function fromBase64$2(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$2.toByteArray(e);
}
base64$2.fromBase64 = fromBase64$2;
var bech32$5 = {}, __createBinding$u = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$u = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$u = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$u(n, e, o);
  return __setModuleDefault$u(n, e), n;
};
Object.defineProperty(bech32$5, "__esModule", { value: !0 });
bech32$5.normalizeBech32 = bech32$5.fromBech32 = bech32$5.toBech32 = void 0;
const bech32$4 = __importStar$u(bech32$f);
function toBech32$2(e, n, o) {
  return bech32$4.encode(e, bech32$4.toWords(n), o);
}
bech32$5.toBech32 = toBech32$2;
function fromBech32$2(e, n = 1 / 0) {
  const o = bech32$4.decode(e, n);
  return {
    prefix: o.prefix,
    data: new Uint8Array(bech32$4.fromWords(o.words))
  };
}
bech32$5.fromBech32 = fromBech32$2;
function normalizeBech32$2(e) {
  const { prefix: n, data: o } = fromBech32$2(e);
  return toBech32$2(n, o);
}
bech32$5.normalizeBech32 = normalizeBech32$2;
var hex$2 = {};
Object.defineProperty(hex$2, "__esModule", { value: !0 });
hex$2.fromHex = hex$2.toHex = void 0;
function toHex$2(e) {
  let n = "";
  for (const o of e)
    n += ("0" + o.toString(16)).slice(-2);
  return n;
}
hex$2.toHex = toHex$2;
function fromHex$2(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let o = 0; o < n.length; o++) {
    const u = 2 * o, c = e.slice(u, u + 2);
    if (!c.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[o] = parseInt(c, 16);
  }
  return n;
}
hex$2.fromHex = fromHex$2;
var rfc3339$2 = {};
Object.defineProperty(rfc3339$2, "__esModule", { value: !0 });
rfc3339$2.toRfc3339 = rfc3339$2.fromRfc3339 = void 0;
const rfc3339Matcher$2 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$2(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function fromRfc3339$2(e) {
  const n = rfc3339Matcher$2.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const o = +n[1], u = +n[2], c = +n[3], d = +n[4], m = +n[5], v = +n[6], S = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let $, E, O;
  n[8] === "Z" ? ($ = 1, E = 0, O = 0) : ($ = n[8].substring(0, 1) === "-" ? -1 : 1, E = +n[8].substring(1, 3), O = +n[8].substring(4, 6));
  const T = $ * (E * 60 + O) * 60, y = Date.UTC(o, u - 1, c, d, m, v, S) - T * 1e3;
  return new Date(y);
}
rfc3339$2.fromRfc3339 = fromRfc3339$2;
function toRfc3339$2(e) {
  const n = e.getUTCFullYear(), o = padded$2(e.getUTCMonth() + 1), u = padded$2(e.getUTCDate()), c = padded$2(e.getUTCHours()), d = padded$2(e.getUTCMinutes()), m = padded$2(e.getUTCSeconds()), v = padded$2(e.getUTCMilliseconds(), 3);
  return `${n}-${o}-${u}T${c}:${d}:${m}.${v}Z`;
}
rfc3339$2.toRfc3339 = toRfc3339$2;
var utf8$2 = {};
Object.defineProperty(utf8$2, "__esModule", { value: !0 });
utf8$2.fromUtf8 = utf8$2.toUtf8 = void 0;
function toUtf8$2(e) {
  return new TextEncoder().encode(e);
}
utf8$2.toUtf8 = toUtf8$2;
function fromUtf8$2(e, n = !1) {
  const o = !n;
  return new TextDecoder("utf-8", { fatal: o }).decode(e);
}
utf8$2.fromUtf8 = fromUtf8$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = ascii$2;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var o = base64$2;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return o.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return o.toBase64;
  } });
  var u = bech32$5;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return u.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return u.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return u.toBech32;
  } });
  var c = hex$2;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return c.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return c.toHex;
  } });
  var d = rfc3339$2;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return d.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return d.toRfc3339;
  } });
  var m = utf8$2;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return m.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return m.toUtf8;
  } });
})(build$n);
var build$m = {}, decimal$2 = {}, __importDefault$s = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal$2, "__esModule", { value: !0 });
decimal$2.Decimal = void 0;
const bn_js_1$8 = __importDefault$s(bnExports$1), maxFractionalDigits$2 = 100;
let Decimal$2 = class is {
  static fromUserInput(n, o) {
    is.verifyFractionalDigits(o);
    const u = n.match(/[^0-9.]/);
    if (u)
      throw new Error(`Invalid character at position ${u.index + 1}`);
    let c, d;
    if (n === "")
      c = "0", d = "";
    else if (n.search(/\./) === -1)
      c = n, d = "";
    else {
      const v = n.split(".");
      switch (v.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!v[1])
            throw new Error("Fractional part missing");
          c = v[0], d = v[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (d.length > o)
      throw new Error("Got more fractional digits than supported");
    const m = `${c}${d.padEnd(o, "0")}`;
    return new is(m, o);
  }
  static fromAtomics(n, o) {
    return is.verifyFractionalDigits(o), new is(n, o);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(n) {
    return is.verifyFractionalDigits(n), new is("0", n);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(n) {
    return is.verifyFractionalDigits(n), new is("1" + "0".repeat(n), n);
  }
  static verifyFractionalDigits(n) {
    if (!Number.isInteger(n))
      throw new Error("Fractional digits is not an integer");
    if (n < 0)
      throw new Error("Fractional digits must not be negative");
    if (n > maxFractionalDigits$2)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits$2}`);
  }
  static compare(n, o) {
    if (n.fractionalDigits !== o.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return n.data.atomics.cmp(new bn_js_1$8.default(o.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(n, o) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$8.default(n),
      fractionalDigits: o
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new is(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const n = new bn_js_1$8.default(10).pow(new bn_js_1$8.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : is.fromAtomics(o.mul(n).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const n = new bn_js_1$8.default(10).pow(new bn_js_1$8.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : is.fromAtomics(o.addn(1).mul(n).toString(), this.fractionalDigits);
  }
  toString() {
    const n = new bn_js_1$8.default(10).pow(new bn_js_1$8.default(this.data.fractionalDigits)), o = this.data.atomics.div(n), u = this.data.atomics.mod(n);
    if (u.isZero())
      return o.toString();
    {
      const d = u.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${o.toString()}.${d}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const n = Number(this.toString());
    if (Number.isNaN(n))
      throw new Error("Conversion to number failed");
    return n;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.add(new bn_js_1$8.default(n.atomics));
    return new is(o.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.sub(new bn_js_1$8.default(n.atomics));
    if (o.ltn(0))
      throw new Error("Difference must not be negative");
    return new is(o.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(n) {
    const o = this.data.atomics.mul(new bn_js_1$8.default(n.toString()));
    return new is(o.toString(), this.fractionalDigits);
  }
  equals(n) {
    return is.compare(this, n) === 0;
  }
  isLessThan(n) {
    return is.compare(this, n) < 0;
  }
  isLessThanOrEqual(n) {
    return is.compare(this, n) <= 0;
  }
  isGreaterThan(n) {
    return is.compare(this, n) > 0;
  }
  isGreaterThanOrEqual(n) {
    return is.compare(this, n) >= 0;
  }
};
decimal$2.Decimal = Decimal$2;
var integers$2 = {}, __importDefault$r = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers$2, "__esModule", { value: !0 });
integers$2.Uint64 = integers$2.Uint53 = integers$2.Int53 = integers$2.Uint32 = void 0;
const bn_js_1$7 = __importDefault$r(bnExports$1), uint64MaxValue$2 = new bn_js_1$7.default("18446744073709551615", 10, "be");
let Uint32$2 = class wu {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(n) {
    return wu.fromBytes(n);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? n : Array.from(n).reverse();
    return new wu(u[0] * 2 ** 24 + u[1] * 2 ** 16 + u[2] * 2 ** 8 + u[3]);
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new wu(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < 0 || n > 4294967295)
      throw new Error("Input not in uint32 range: " + n.toString());
    this.data = n;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$2.Uint32 = Uint32$2;
let Int53$2 = class ud {
  static fromString(n) {
    if (!n.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new ud(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + n.toString());
    this.data = n;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$2.Int53 = Int53$2;
let Uint53$2 = class cd {
  static fromString(n) {
    const o = Int53$2.fromString(n);
    return new cd(o.toNumber());
  }
  constructor(n) {
    const o = new Int53$2(n);
    if (o.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = o;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$2.Uint53 = Uint53$2;
let Uint64$2 = class uu {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(n) {
    return uu.fromBytes(n);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? Array.from(n) : Array.from(n).reverse();
    return new uu(new bn_js_1$7.default(u));
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new uu(new bn_js_1$7.default(n, 10, "be"));
  }
  static fromNumber(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    let o;
    try {
      o = new bn_js_1$7.default(n);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new uu(o);
  }
  constructor(n) {
    if (n.isNeg())
      throw new Error("Input is negative");
    if (n.gt(uint64MaxValue$2))
      throw new Error("Input exceeds uint64 range");
    this.data = n;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
};
integers$2.Uint64 = Uint64$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var n = decimal$2;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return n.Decimal;
  } });
  var o = integers$2;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return o.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return o.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return o.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return o.Uint64;
  } });
})(build$m);
var build$l = {}, addresses$2 = {}, build$k = {}, bip39$2 = {}, pbkdf2$2 = {}, build$j = {}, arrays$2 = {};
Object.defineProperty(arrays$2, "__esModule", { value: !0 });
arrays$2.arrayContentStartsWith = arrays$2.arrayContentEquals = void 0;
function arrayContentEquals$2(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$2.arrayContentEquals = arrayContentEquals$2;
function arrayContentStartsWith$2(e, n) {
  if (e.length < n.length)
    return !1;
  for (let o = 0; o < n.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$2.arrayContentStartsWith = arrayContentStartsWith$2;
var assert$9 = {};
Object.defineProperty(assert$9, "__esModule", { value: !0 });
assert$9.assertDefinedAndNotNull = assert$9.assertDefined = assert$9.assert = void 0;
function assert$8(e, n) {
  if (!e)
    throw new Error(n || "condition is not truthy");
}
assert$9.assert = assert$8;
function assertDefined$2(e, n) {
  if (e === void 0)
    throw new Error(n ?? "value is undefined");
}
assert$9.assertDefined = assertDefined$2;
function assertDefinedAndNotNull$2(e, n) {
  if (e == null)
    throw new Error(n ?? "value is undefined or null");
}
assert$9.assertDefinedAndNotNull = assertDefinedAndNotNull$2;
var sleep$5 = {};
Object.defineProperty(sleep$5, "__esModule", { value: !0 });
sleep$5.sleep = void 0;
async function sleep$4(e) {
  return new Promise((n) => setTimeout(n, e));
}
sleep$5.sleep = sleep$4;
var typechecks$2 = {};
Object.defineProperty(typechecks$2, "__esModule", { value: !0 });
typechecks$2.isDefined = typechecks$2.isUint8Array = typechecks$2.isNonNullObject = void 0;
function isNonNullObject$2(e) {
  return typeof e == "object" && e !== null;
}
typechecks$2.isNonNullObject = isNonNullObject$2;
function isUint8Array$2(e) {
  return !(!isNonNullObject$2(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(e));
}
typechecks$2.isUint8Array = isUint8Array$2;
function isDefined$2(e) {
  return e !== void 0;
}
typechecks$2.isDefined = isDefined$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var n = arrays$2;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return n.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return n.arrayContentStartsWith;
  } });
  var o = assert$9;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return o.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return o.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return o.assertDefinedAndNotNull;
  } });
  var u = sleep$5;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return u.sleep;
  } });
  var c = typechecks$2;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return c.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return c.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return c.isUint8Array;
  } });
})(build$j);
var __createBinding$t = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$t = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$t = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$t(n, e, o);
  return __setModuleDefault$t(n, e), n;
};
Object.defineProperty(pbkdf2$2, "__esModule", { value: !0 });
pbkdf2$2.pbkdf2Sha512 = pbkdf2$2.pbkdf2Sha512Noble = pbkdf2$2.pbkdf2Sha512NodeCrypto = pbkdf2$2.pbkdf2Sha512Subtle = pbkdf2$2.getSubtle = pbkdf2$2.getNodeCrypto = void 0;
const utils_1$z = build$j, pbkdf2_1$5 = pbkdf2$8, sha512_1$5 = sha512$a;
async function getNodeCrypto$1() {
  try {
    const e = await Promise.resolve().then(() => __importStar$t(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2$2.getNodeCrypto = getNodeCrypto$1;
async function getSubtle$2() {
  var n, o, u;
  let e = (n = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : n.subtle;
  return e || (e = (u = (o = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : o.webcrypto) == null ? void 0 : u.subtle), e;
}
pbkdf2$2.getSubtle = getSubtle$2;
async function pbkdf2Sha512Subtle$2(e, n, o, u, c) {
  return (0, utils_1$z.assert)(e, "Argument subtle is falsy"), (0, utils_1$z.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$z.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$z.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", n, { name: "PBKDF2" }, !1, ["deriveBits"]).then((d) => e.deriveBits({
    name: "PBKDF2",
    salt: o,
    iterations: u,
    hash: { name: "SHA-512" }
  }, d, c * 8).then((m) => new Uint8Array(m)));
}
pbkdf2$2.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle$2;
async function pbkdf2Sha512NodeCrypto$1(e, n, o, u, c) {
  return (0, utils_1$z.assert)(e, "Argument nodeCrypto is falsy"), (0, utils_1$z.assert)(typeof e == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$z.assert)(typeof e.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((d, m) => {
    e.pbkdf2(n, o, u, c, "sha512", (v, S) => {
      v ? m(v) : d(Uint8Array.from(S));
    });
  });
}
pbkdf2$2.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto$1;
async function pbkdf2Sha512Noble$2(e, n, o, u) {
  return (0, pbkdf2_1$5.pbkdf2Async)(sha512_1$5.sha512, e, n, { c: o, dkLen: u });
}
pbkdf2$2.pbkdf2Sha512Noble = pbkdf2Sha512Noble$2;
async function pbkdf2Sha512$2(e, n, o, u) {
  const c = await getSubtle$2();
  if (c)
    return pbkdf2Sha512Subtle$2(c, e, n, o, u);
  {
    const d = await getNodeCrypto$1();
    return d ? pbkdf2Sha512NodeCrypto$1(d, e, n, o, u) : pbkdf2Sha512Noble$2(e, n, o, u);
  }
}
pbkdf2$2.pbkdf2Sha512 = pbkdf2Sha512$2;
var sha$2 = {}, utils$t = {};
Object.defineProperty(utils$t, "__esModule", { value: !0 });
utils$t.toRealUint8Array = void 0;
function toRealUint8Array$2(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$t.toRealUint8Array = toRealUint8Array$2;
Object.defineProperty(sha$2, "__esModule", { value: !0 });
sha$2.sha512 = sha$2.Sha512 = sha$2.sha256 = sha$2.Sha256 = void 0;
const sha256_1$2 = sha256$8, sha512_1$4 = sha512$a, utils_1$y = utils$t;
let Sha256$2 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha256_1$2.sha256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$y.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$2.Sha256 = Sha256$2;
function sha256$2(e) {
  return new Sha256$2(e).digest();
}
sha$2.sha256 = sha256$2;
let Sha512$2 = class {
  constructor(n) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$4.sha512.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$y.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$2.Sha512 = Sha512$2;
function sha512$2(e) {
  return new Sha512$2(e).digest();
}
sha$2.sha512 = sha512$2;
Object.defineProperty(bip39$2, "__esModule", { value: !0 });
bip39$2.Bip39 = bip39$2.EnglishMnemonic = bip39$2.mnemonicToEntropy = bip39$2.entropyToMnemonic = void 0;
const encoding_1$I = build$n, pbkdf2_1$4 = pbkdf2$2, sha_1$2 = sha$2, wordlist$2 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring$2(e) {
  return Array.from(e).map((n) => n.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits$2(e) {
  const o = e.length * 8 / 32, u = (0, sha_1$2.sha256)(e);
  return bytesToBitstring$2(u).slice(0, o);
}
function bitstringToByte$2(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths$2 = [16, 20, 24, 28, 32], allowedWordLengths$2 = [12, 15, 18, 21, 24];
function entropyToMnemonic$2(e) {
  if (allowedEntropyLengths$2.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const n = bytesToBitstring$2(e), o = deriveChecksumBits$2(e);
  return (n + o).match(/(.{11})/g).map((m) => {
    const v = bitstringToByte$2(m);
    return wordlist$2[v];
  }).join(" ");
}
bip39$2.entropyToMnemonic = entropyToMnemonic$2;
const invalidNumberOfWorks$2 = "Invalid number of words", wordNotInWordlist$2 = "Found word that is not in the wordlist", invalidEntropy$2 = "Invalid entropy", invalidChecksum$2 = "Invalid mnemonic checksum";
function normalize$2(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy$2(e) {
  const n = normalize$2(e).split(" ");
  if (!allowedWordLengths$2.includes(n.length))
    throw new Error(invalidNumberOfWorks$2);
  const o = n.map(($) => {
    const E = wordlist$2.indexOf($);
    if (E === -1)
      throw new Error(wordNotInWordlist$2);
    return E.toString(2).padStart(11, "0");
  }).join(""), u = Math.floor(o.length / 33) * 32, c = o.slice(0, u), d = o.slice(u), m = c.match(/(.{1,8})/g).map(bitstringToByte$2);
  if (m.length < 16 || m.length > 32 || m.length % 4 !== 0)
    throw new Error(invalidEntropy$2);
  const v = Uint8Array.from(m);
  if (deriveChecksumBits$2(v) !== d)
    throw new Error(invalidChecksum$2);
  return v;
}
bip39$2.mnemonicToEntropy = mnemonicToEntropy$2;
let EnglishMnemonic$2 = class ju {
  constructor(n) {
    if (!ju.mnemonicMatcher.test(n))
      throw new Error("Invalid mnemonic format");
    const o = n.split(" "), u = [12, 15, 18, 21, 24];
    if (u.indexOf(o.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${u} got: ${o.length})`);
    for (const c of o)
      if (ju.wordlist.indexOf(c) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy$2(n), this.data = n;
  }
  toString() {
    return this.data;
  }
};
bip39$2.EnglishMnemonic = EnglishMnemonic$2;
EnglishMnemonic$2.wordlist = wordlist$2;
EnglishMnemonic$2.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
let Bip39$2 = class {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(n) {
    return new EnglishMnemonic$2(entropyToMnemonic$2(n));
  }
  static decode(n) {
    return mnemonicToEntropy$2(n.toString());
  }
  static async mnemonicToSeed(n, o) {
    const u = (0, encoding_1$I.toUtf8)(normalize$2(n.toString())), c = "mnemonic" + (o ? normalize$2(o) : ""), d = (0, encoding_1$I.toUtf8)(c);
    return (0, pbkdf2_1$4.pbkdf2Sha512)(u, d, 2048, 64);
  }
};
bip39$2.Bip39 = Bip39$2;
var hmac$2 = {};
Object.defineProperty(hmac$2, "__esModule", { value: !0 });
hmac$2.Hmac = void 0;
let Hmac$2 = class {
  constructor(n, o) {
    const u = new n().blockSize;
    this.hash = (d) => new n().update(d).digest();
    let c = o;
    if (c.length > u && (c = this.hash(c)), c.length < u) {
      const d = new Uint8Array(u - c.length);
      c = new Uint8Array([...c, ...d]);
    }
    this.oKeyPad = c.map((d) => d ^ 92), this.iKeyPad = c.map((d) => d ^ 54), this.messageHasher = new n(), this.blockSize = u, this.update(this.iKeyPad);
  }
  update(n) {
    return this.messageHasher.update(n), this;
  }
  digest() {
    const n = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...n]));
  }
};
hmac$2.Hmac = Hmac$2;
var keccak$2 = {};
Object.defineProperty(keccak$2, "__esModule", { value: !0 });
keccak$2.keccak256 = keccak$2.Keccak256 = void 0;
const sha3_1$2 = sha3$3, utils_1$x = utils$t;
let Keccak256$2 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha3_1$2.keccak_256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$x.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
keccak$2.Keccak256 = Keccak256$2;
function keccak256$3(e) {
  return new Keccak256$2(e).digest();
}
keccak$2.keccak256 = keccak256$3;
var libsodium$2 = {}, __importDefault$q = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium$2, "__esModule", { value: !0 });
libsodium$2.Xchacha20poly1305Ietf = libsodium$2.xchacha20NonceLength = libsodium$2.Ed25519 = libsodium$2.Ed25519Keypair = libsodium$2.Argon2id = libsodium$2.isArgon2idOptions = void 0;
const utils_1$w = build$j, libsodium_wrappers_sumo_1$1 = __importDefault$q(libsodiumWrappers);
function isArgon2idOptions$2(e) {
  return !(!(0, utils_1$w.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium$2.isArgon2idOptions = isArgon2idOptions$2;
let Argon2id$2 = class {
  static async execute(n, o, u) {
    return await libsodium_wrappers_sumo_1$1.default.ready, libsodium_wrappers_sumo_1$1.default.crypto_pwhash(
      u.outputLength,
      n,
      o,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      u.opsLimit,
      u.memLimitKib * 1024,
      libsodium_wrappers_sumo_1$1.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
};
libsodium$2.Argon2id = Argon2id$2;
let Ed25519Keypair$2 = class dd {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(n) {
    if (n.length !== 64)
      throw new Error(`Unexpected key length ${n.length}. Must be 64.`);
    return new dd(n.slice(0, 32), n.slice(32, 64));
  }
  constructor(n, o) {
    this.privkey = n, this.pubkey = o;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
};
libsodium$2.Ed25519Keypair = Ed25519Keypair$2;
let Ed25519$2 = class {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(n) {
    await libsodium_wrappers_sumo_1$1.default.ready;
    const o = libsodium_wrappers_sumo_1$1.default.crypto_sign_seed_keypair(n);
    return Ed25519Keypair$2.fromLibsodiumPrivkey(o.privateKey);
  }
  static async createSignature(n, o) {
    return await libsodium_wrappers_sumo_1$1.default.ready, libsodium_wrappers_sumo_1$1.default.crypto_sign_detached(n, o.toLibsodiumPrivkey());
  }
  static async verifySignature(n, o, u) {
    return await libsodium_wrappers_sumo_1$1.default.ready, libsodium_wrappers_sumo_1$1.default.crypto_sign_verify_detached(n, o, u);
  }
};
libsodium$2.Ed25519 = Ed25519$2;
libsodium$2.xchacha20NonceLength = 24;
let Xchacha20poly1305Ietf$2 = class {
  static async encrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$1.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      n,
      c,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      u,
      o
    );
  }
  static async decrypt(n, o, u) {
    await libsodium_wrappers_sumo_1$1.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1$1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      n,
      c,
      u,
      o
    );
  }
};
libsodium$2.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf$2;
var random$2 = {};
Object.defineProperty(random$2, "__esModule", { value: !0 });
random$2.Random = void 0;
let Random$2 = class {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(n) {
    try {
      const o = typeof window == "object" ? window : self, u = typeof o.crypto < "u" ? o.crypto : o.msCrypto, c = new Uint8Array(n);
      return u.getRandomValues(c), c;
    } catch {
      try {
        const o = requireCryptoBrowserify();
        return new Uint8Array([...o.randomBytes(n)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
};
random$2.Random = Random$2;
var ripemd$2 = {};
Object.defineProperty(ripemd$2, "__esModule", { value: !0 });
ripemd$2.ripemd160 = ripemd$2.Ripemd160 = void 0;
const ripemd160_1$2 = ripemd160$8, utils_1$v = utils$t;
let Ripemd160$2 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$2.ripemd160.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$v.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
ripemd$2.Ripemd160 = Ripemd160$2;
function ripemd160$2(e) {
  return new Ripemd160$2(e).digest();
}
ripemd$2.ripemd160 = ripemd160$2;
var secp256k1$5 = {}, secp256k1signature$2 = {};
Object.defineProperty(secp256k1signature$2, "__esModule", { value: !0 });
secp256k1signature$2.ExtendedSecp256k1Signature = secp256k1signature$2.Secp256k1Signature = void 0;
function trimLeadingNullBytes$2(e) {
  let n = 0;
  for (const o of e)
    if (o === 0)
      n++;
    else
      break;
  return e.slice(n);
}
const derTagInteger$2 = 2;
let Secp256k1Signature$2 = class Xu {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(n) {
    if (n.length !== 64)
      throw new Error(`Got invalid data length: ${n.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new Xu(trimLeadingNullBytes$2(n.slice(0, 32)), trimLeadingNullBytes$2(n.slice(32, 64)));
  }
  static fromDer(n) {
    let o = 0;
    if (n[o++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const u = n[o++];
    if (n.length - o !== u)
      throw new Error("Data length mismatch detected");
    if (n[o++] !== derTagInteger$2)
      throw new Error("INTEGER tag expected");
    const d = n[o++];
    if (d >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const m = n.slice(o, o + d);
    if (o += d, n[o++] !== derTagInteger$2)
      throw new Error("INTEGER tag expected");
    const S = n[o++];
    if (S >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const $ = n.slice(o, o + S);
    return o += S, new Xu(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes$2(m),
      trimLeadingNullBytes$2($)
    );
  }
  constructor(n, o) {
    if (n.length > 32 || n.length === 0 || n[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (o.length > 32 || o.length === 0 || o[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: n,
      s: o
    };
  }
  r(n) {
    if (n === void 0)
      return this.data.r;
    {
      const o = n - this.data.r.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter r");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.r]);
    }
  }
  s(n) {
    if (n === void 0)
      return this.data.s;
    {
      const o = n - this.data.s.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter s");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const n = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, o = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, u = n.length, c = o.length, d = new Uint8Array([derTagInteger$2, u, ...n, derTagInteger$2, c, ...o]);
    return new Uint8Array([48, d.length, ...d]);
  }
};
secp256k1signature$2.Secp256k1Signature = Secp256k1Signature$2;
let ExtendedSecp256k1Signature$2 = class ld extends Secp256k1Signature$2 {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(n) {
    if (n.length !== 65)
      throw new Error(`Got invalid data length ${n.length}. Expected 32 + 32 + 1`);
    return new ld(trimLeadingNullBytes$2(n.slice(0, 32)), trimLeadingNullBytes$2(n.slice(32, 64)), n[64]);
  }
  constructor(n, o, u) {
    if (super(n, o), !Number.isInteger(u))
      throw new Error("The recovery parameter must be an integer.");
    if (u < 0 || u > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = u;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
};
secp256k1signature$2.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature$2;
var __importDefault$p = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$5, "__esModule", { value: !0 });
secp256k1$5.Secp256k1 = void 0;
const encoding_1$H = build$n, bn_js_1$6 = __importDefault$p(bnExports$1), elliptic_1$3 = __importDefault$p(requireElliptic()), secp256k1signature_1$2 = secp256k1signature$2, secp256k1$4 = new elliptic_1$3.default.ec("secp256k1"), secp256k1N$2 = new bn_js_1$6.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
let Secp256k1$2 = class {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(n) {
    if (n.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const o = secp256k1$4.keyFromPrivate(n);
    if (o.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$6.default(n).gte(secp256k1N$2))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$H.fromHex)(o.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(o.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(n, o) {
    if (n.length === 0)
      throw new Error("Message hash must not be empty");
    if (n.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const u = secp256k1$4.keyFromPrivate(o), { r: c, s: d, recoveryParam: m } = u.sign(n, { canonical: !0 });
    if (typeof m != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1$2.ExtendedSecp256k1Signature(Uint8Array.from(c.toArray()), Uint8Array.from(d.toArray()), m);
  }
  static async verifySignature(n, o, u) {
    if (o.length === 0)
      throw new Error("Message hash must not be empty");
    if (o.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const c = secp256k1$4.keyFromPublic(u);
    try {
      return c.verify(o, n.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(n, o) {
    const u = { r: (0, encoding_1$H.toHex)(n.r()), s: (0, encoding_1$H.toHex)(n.s()) }, c = secp256k1$4.recoverPubKey(o, u, n.recovery), d = secp256k1$4.keyFromPublic(c);
    return (0, encoding_1$H.fromHex)(d.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(n) {
    switch (n.length) {
      case 33:
        return n;
      case 65:
        return Uint8Array.from(secp256k1$4.keyFromPublic(n).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(n) {
    switch (n.length) {
      case 33:
        return Uint8Array.from(secp256k1$4.keyFromPublic(n).getPublic(!1, "array"));
      case 65:
        return n;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(n) {
    switch (n.length) {
      case 64:
        return n;
      case 65:
        return n.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
};
secp256k1$5.Secp256k1 = Secp256k1$2;
var slip10$2 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const o = build$n, u = build$m, c = n(bnExports$1), d = n(requireElliptic()), m = hmac$2, v = sha$2;
  var S;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(S = e.Slip10Curve || (e.Slip10Curve = {}));
  function $(M) {
    switch (M) {
      case S.Ed25519:
        return S.Ed25519;
      case S.Secp256k1:
        return S.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  e.slip10CurveFromString = $;
  class E extends u.Uint32 {
    static hardened(G) {
      return new E(G + 2 ** 31);
    }
    static normal(G) {
      return new E(G);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = E;
  const O = new d.default.ec("secp256k1");
  class T {
    static derivePath(G, k, F) {
      let X = this.master(G, k);
      for (const ee of F)
        X = this.child(G, X.privkey, X.chainCode, ee);
      return X;
    }
    static master(G, k) {
      const F = new m.Hmac(v.Sha512, (0, o.toAscii)(G)).update(k).digest(), X = F.slice(0, 32), ee = F.slice(32, 64);
      return G !== S.Ed25519 && (this.isZero(X) || this.isGteN(G, X)) ? this.master(G, F) : {
        chainCode: ee,
        privkey: X
      };
    }
    static child(G, k, F, X) {
      let ee;
      if (X.isHardened()) {
        const ue = new Uint8Array([0, ...k, ...X.toBytesBigEndian()]);
        ee = new m.Hmac(v.Sha512, F).update(ue).digest();
      } else {
        if (G === S.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ue = new Uint8Array([
            ...T.serializedPoint(G, new c.default(k)),
            ...X.toBytesBigEndian()
          ]);
          ee = new m.Hmac(v.Sha512, F).update(ue).digest();
        }
      }
      return this.childImpl(G, k, F, X, ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(G, k) {
      switch (G) {
        case S.Secp256k1:
          return (0, o.fromHex)(O.g.mul(k).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(G, k, F, X, ee) {
      const ue = ee.slice(0, 32), Q = ee.slice(32, 64), Y = Q;
      if (G === S.Ed25519)
        return {
          chainCode: Y,
          privkey: ue
        };
      const pe = this.n(G), oe = new c.default(ue).add(new c.default(k)).mod(pe), ne = Uint8Array.from(oe.toArray("be", 32));
      if (this.isGteN(G, ue) || this.isZero(ne)) {
        const H = new m.Hmac(v.Sha512, F).update(new Uint8Array([1, ...Q, ...X.toBytesBigEndian()])).digest();
        return this.childImpl(G, k, F, X, H);
      }
      return {
        chainCode: Y,
        privkey: ne
      };
    }
    static isZero(G) {
      return G.every((k) => k === 0);
    }
    static isGteN(G, k) {
      return new c.default(k).gte(this.n(G));
    }
    static n(G) {
      switch (G) {
        case S.Secp256k1:
          return new c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = T;
  function y(M) {
    return M.reduce((G, k) => {
      const F = k.isHardened() ? `${k.toNumber() - 2147483648}'` : k.toString();
      return G + "/" + F;
    }, "m");
  }
  e.pathToString = y;
  function V(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let G = M.slice(1);
    const k = new Array();
    for (; G; ) {
      const F = G.match(/^\/([0-9]+)('?)/);
      if (!F)
        throw new Error("Syntax error while reading path component");
      const [X, ee, ue] = F, Q = u.Uint53.fromString(ee).toNumber();
      if (Q >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ue ? k.push(E.hardened(Q)) : k.push(E.normal(Q)), G = G.slice(X.length);
    }
    return k;
  }
  e.stringToPath = V;
})(slip10$2);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var n = bip39$2;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return n.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return n.EnglishMnemonic;
  } });
  var o = hmac$2;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return o.Hmac;
  } });
  var u = keccak$2;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return u.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return u.keccak256;
  } });
  var c = libsodium$2;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return c.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return c.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return c.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return c.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return c.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return c.Xchacha20poly1305Ietf;
  } });
  var d = random$2;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return d.Random;
  } });
  var m = ripemd$2;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return m.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return m.ripemd160;
  } });
  var v = secp256k1$5;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return v.Secp256k1;
  } });
  var S = secp256k1signature$2;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return S.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return S.Secp256k1Signature;
  } });
  var $ = sha$2;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return $.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return $.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return $.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return $.sha512;
  } });
  var E = slip10$2;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return E.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return E.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return E.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return E.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return E.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return E.stringToPath;
  } });
})(build$k);
Object.defineProperty(addresses$2, "__esModule", { value: !0 });
addresses$2.pubkeyToAddress = addresses$2.pubkeyToRawAddress = addresses$2.rawSecp256k1PubkeyToRawAddress = addresses$2.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$f = build$k, encoding_1$G = build$n;
function rawEd25519PubkeyToRawAddress$2(e) {
  if (e.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${e.length}`);
  return (0, crypto_1$f.sha256)(e).slice(0, 20);
}
addresses$2.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress$2;
function rawSecp256k1PubkeyToRawAddress$2(e) {
  if (e.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${e.length}`);
  return (0, crypto_1$f.ripemd160)((0, crypto_1$f.sha256)(e));
}
addresses$2.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress$2;
function pubkeyToRawAddress$2(e, n) {
  switch (e) {
    case "ed25519":
      return rawEd25519PubkeyToRawAddress$2(n);
    case "secp256k1":
      return rawSecp256k1PubkeyToRawAddress$2(n);
    default:
      throw new Error(`Pubkey type ${e} not supported`);
  }
}
addresses$2.pubkeyToRawAddress = pubkeyToRawAddress$2;
function pubkeyToAddress$2(e, n) {
  return (0, encoding_1$G.toHex)(pubkeyToRawAddress$2(e, n)).toUpperCase();
}
addresses$2.pubkeyToAddress = pubkeyToAddress$2;
var dates$1 = {};
Object.defineProperty(dates$1, "__esModule", { value: !0 });
dates$1.DateTime = dates$1.toSeconds = dates$1.fromSeconds = dates$1.toRfc3339WithNanoseconds = dates$1.fromRfc3339WithNanoseconds = void 0;
const encoding_1$F = build$n, math_1$i = build$m;
function fromRfc3339WithNanoseconds$1(e) {
  const n = (0, encoding_1$F.fromRfc3339)(e), o = e.match(/\.(\d+)Z$/), u = o ? o[1].slice(3) : "";
  return n.nanoseconds = parseInt(u.padEnd(6, "0"), 10), n;
}
dates$1.fromRfc3339WithNanoseconds = fromRfc3339WithNanoseconds$1;
function toRfc3339WithNanoseconds$1(e) {
  var u;
  const n = e.toISOString(), o = ((u = e.nanoseconds) == null ? void 0 : u.toString()) ?? "";
  return `${n.slice(0, -1)}${o.padStart(6, "0")}Z`;
}
dates$1.toRfc3339WithNanoseconds = toRfc3339WithNanoseconds$1;
function fromSeconds$1(e, n = 0) {
  const o = new math_1$i.Uint32(n).toNumber();
  if (o > 999999999)
    throw new Error("Nano seconds must not exceed 999999999");
  const u = new Date(e * 1e3 + Math.floor(o / 1e6));
  return u.nanoseconds = o % 1e6, u;
}
dates$1.fromSeconds = fromSeconds$1;
function toSeconds$1(e) {
  return {
    seconds: Math.floor(e.getTime() / 1e3),
    nanos: e.getTime() % 1e3 * 1e6 + (e.nanoseconds ?? 0)
  };
}
dates$1.toSeconds = toSeconds$1;
let DateTime$1 = class {
  /** @deprecated Use fromRfc3339WithNanoseconds instead */
  static decode(n) {
    return fromRfc3339WithNanoseconds$1(n);
  }
  /** @deprecated Use toRfc3339WithNanoseconds instead */
  static encode(n) {
    return toRfc3339WithNanoseconds$1(n);
  }
};
dates$1.DateTime = DateTime$1;
var comet38 = {}, comet38client = {}, jsonrpc$1 = {};
Object.defineProperty(jsonrpc$1, "__esModule", { value: !0 });
jsonrpc$1.createJsonRpcRequest = void 0;
const numbersWithoutZero$1 = "123456789";
function randomNumericChar$1() {
  return numbersWithoutZero$1[Math.floor(Math.random() * numbersWithoutZero$1.length)];
}
function randomId$1() {
  return parseInt(Array.from({ length: 12 }).map(() => randomNumericChar$1()).join(""), 10);
}
function createJsonRpcRequest$1(e, n) {
  const o = n ? { ...n } : {};
  return {
    jsonrpc: "2.0",
    id: randomId$1(),
    method: e,
    params: o
  };
}
jsonrpc$1.createJsonRpcRequest = createJsonRpcRequest$1;
var rpcclients$1 = {}, httpbatchclient$1 = {}, build$i = {}, id$2 = {};
Object.defineProperty(id$2, "__esModule", { value: !0 });
id$2.makeJsonRpcId = void 0;
let counter$2 = 1e4;
function makeJsonRpcId$1() {
  return counter$2 += 1;
}
id$2.makeJsonRpcId = makeJsonRpcId$1;
var jsonrpcclient$1 = {}, build$h = {}, concat$4 = {};
Object.defineProperty(concat$4, "__esModule", { value: !0 });
concat$4.concat = void 0;
const xstream_1$b = xstream;
function concat$3(...e) {
  const n = new Array(), o = new Array(), u = /* @__PURE__ */ new Set();
  let c = 0;
  function d() {
    for (; n.length > 0; )
      n.shift().unsubscribe();
    o.length = 0, u.clear(), c = 0;
  }
  const m = {
    start: (v) => {
      e.forEach((E) => o.push([]));
      function S(E) {
        for (; ; ) {
          const O = o[E].shift();
          if (O === void 0)
            return;
          v.next(O);
        }
      }
      function $() {
        return c >= e.length;
      }
      if ($()) {
        v.complete();
        return;
      }
      e.forEach((E, O) => {
        n.push(E.subscribe({
          next: (T) => {
            O === c ? v.next(T) : o[O].push(T);
          },
          complete: () => {
            for (u.add(O); u.has(c); )
              S(c), c++;
            $() ? v.complete() : S(c);
          },
          error: (T) => {
            v.error(T), d();
          }
        }));
      });
    },
    stop: () => {
      d();
    }
  };
  return xstream_1$b.Stream.create(m);
}
concat$4.concat = concat$3;
var defaultvalueproducer$1 = {};
Object.defineProperty(defaultvalueproducer$1, "__esModule", { value: !0 });
defaultvalueproducer$1.DefaultValueProducer = void 0;
let DefaultValueProducer$1 = class {
  get value() {
    return this.internalValue;
  }
  constructor(n, o) {
    this.callbacks = o, this.internalValue = n;
  }
  /**
   * Update the current value.
   *
   * If producer is active (i.e. someone is listening), this emits an event.
   * If not, just the current value is updated.
   */
  update(n) {
    this.internalValue = n, this.listener && this.listener.next(n);
  }
  /**
   * Produce an error
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error(n) {
    this.listener && this.listener.error(n);
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  start(n) {
    this.listener = n, n.next(this.internalValue), this.callbacks && this.callbacks.onStarted();
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  stop() {
    this.callbacks && this.callbacks.onStop(), this.listener = void 0;
  }
};
defaultvalueproducer$1.DefaultValueProducer = DefaultValueProducer$1;
var dropduplicates$1 = {};
Object.defineProperty(dropduplicates$1, "__esModule", { value: !0 });
dropduplicates$1.dropDuplicates = void 0;
function dropDuplicates$1(e) {
  return (o) => {
    const u = /* @__PURE__ */ new Set();
    return o.filter((d) => !u.has(e(d))).debug((d) => u.add(e(d)));
  };
}
dropduplicates$1.dropDuplicates = dropDuplicates$1;
var promise$1 = {};
Object.defineProperty(promise$1, "__esModule", { value: !0 });
promise$1.firstEvent = promise$1.toListPromise = promise$1.fromListPromise = void 0;
const xstream_1$a = xstream;
function fromListPromise$1(e) {
  const n = {
    start: (o) => {
      e.then((u) => {
        for (const c of u)
          o.next(c);
        o.complete();
      }).catch((u) => o.error(u));
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    stop: () => {
    }
  };
  return xstream_1$a.Stream.create(n);
}
promise$1.fromListPromise = fromListPromise$1;
async function toListPromise$1(e, n) {
  return new Promise((o, u) => {
    if (n === 0) {
      o([]);
      return;
    }
    const c = new Array();
    e.take(n).subscribe({
      next: (d) => {
        c.push(d), c.length === n && o(c);
      },
      complete: () => {
        u(`Stream completed before all events could be collected. Collected ${c.length}, expected ${n}`);
      },
      error: (d) => u(d)
    });
  });
}
promise$1.toListPromise = toListPromise$1;
async function firstEvent$1(e) {
  return (await toListPromise$1(e, 1))[0];
}
promise$1.firstEvent = firstEvent$1;
var reducer$1 = {};
Object.defineProperty(reducer$1, "__esModule", { value: !0 });
reducer$1.lastValue = reducer$1.asArray = reducer$1.countStream = reducer$1.Reducer = void 0;
let Reducer$1 = class {
  constructor(n, o, u) {
    this.stream = n, this.reducer = o, this.state = u, this.completed = new Promise((c, d) => {
      const m = this.stream.subscribe({
        next: (v) => {
          this.state = this.reducer(this.state, v);
        },
        complete: () => {
          c(), m.unsubscribe();
        },
        error: (v) => {
          d(v), m.unsubscribe();
        }
      });
    });
  }
  // value returns current materialized state
  value() {
    return this.state;
  }
  // finished resolves on completed stream, rejects on stream error
  async finished() {
    return this.completed;
  }
};
reducer$1.Reducer = Reducer$1;
function increment$1(e, n) {
  return e + 1;
}
function countStream$1(e) {
  return new Reducer$1(e, increment$1, 0);
}
reducer$1.countStream = countStream$1;
function append$1(e, n) {
  return [...e, n];
}
function asArray$1(e) {
  return new Reducer$1(e, append$1, []);
}
reducer$1.asArray = asArray$1;
function last$1(e, n) {
  return n;
}
function lastValue$1(e) {
  return new Reducer$1(e, last$1, void 0);
}
reducer$1.lastValue = lastValue$1;
var valueandupdates$1 = {};
Object.defineProperty(valueandupdates$1, "__esModule", { value: !0 });
valueandupdates$1.ValueAndUpdates = void 0;
const xstream_1$9 = xstream;
let ValueAndUpdates$1 = class {
  get value() {
    return this.producer.value;
  }
  constructor(n) {
    this.producer = n, this.updates = xstream_1$9.MemoryStream.createWithMemory(this.producer);
  }
  /**
   * Resolves as soon as search value is found.
   *
   * @param search either a value or a function that must return true when found
   * @returns the value of the update that caused the search match
   */
  async waitFor(n) {
    const o = typeof n == "function" ? n : (u) => u === n;
    return new Promise((u, c) => {
      const d = this.updates.subscribe({
        next: (m) => {
          o(m) && (u(m), setTimeout(() => d.unsubscribe(), 0));
        },
        complete: () => {
          d.unsubscribe(), c("Update stream completed without expected value");
        },
        error: (m) => {
          c(m);
        }
      });
    });
  }
};
valueandupdates$1.ValueAndUpdates = ValueAndUpdates$1;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(S, $, E, O) {
    O === void 0 && (O = E);
    var T = Object.getOwnPropertyDescriptor($, E);
    (!T || ("get" in T ? !$.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return $[E];
    } }), Object.defineProperty(S, O, T);
  } : function(S, $, E, O) {
    O === void 0 && (O = E), S[O] = $[E];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(S, $) {
    for (var E in S)
      E !== "default" && !Object.prototype.hasOwnProperty.call($, E) && n($, S, E);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueAndUpdates = e.toListPromise = e.fromListPromise = e.firstEvent = e.dropDuplicates = e.DefaultValueProducer = e.concat = void 0;
  var u = concat$4;
  Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
    return u.concat;
  } });
  var c = defaultvalueproducer$1;
  Object.defineProperty(e, "DefaultValueProducer", { enumerable: !0, get: function() {
    return c.DefaultValueProducer;
  } });
  var d = dropduplicates$1;
  Object.defineProperty(e, "dropDuplicates", { enumerable: !0, get: function() {
    return d.dropDuplicates;
  } });
  var m = promise$1;
  Object.defineProperty(e, "firstEvent", { enumerable: !0, get: function() {
    return m.firstEvent;
  } }), Object.defineProperty(e, "fromListPromise", { enumerable: !0, get: function() {
    return m.fromListPromise;
  } }), Object.defineProperty(e, "toListPromise", { enumerable: !0, get: function() {
    return m.toListPromise;
  } }), o(reducer$1, e);
  var v = valueandupdates$1;
  Object.defineProperty(e, "ValueAndUpdates", { enumerable: !0, get: function() {
    return v.ValueAndUpdates;
  } });
})(build$h);
var types$7 = {};
Object.defineProperty(types$7, "__esModule", { value: !0 });
types$7.jsonRpcCode = types$7.isJsonRpcSuccessResponse = types$7.isJsonRpcErrorResponse = void 0;
function isJsonRpcErrorResponse$1(e) {
  return typeof e.error == "object";
}
types$7.isJsonRpcErrorResponse = isJsonRpcErrorResponse$1;
function isJsonRpcSuccessResponse$1(e) {
  return !isJsonRpcErrorResponse$1(e);
}
types$7.isJsonRpcSuccessResponse = isJsonRpcSuccessResponse$1;
types$7.jsonRpcCode = {
  parseError: -32700,
  invalidRequest: -32600,
  methodNotFound: -32601,
  invalidParams: -32602,
  internalError: -32603,
  // server error (Reserved for implementation-defined server-errors.):
  // -32000 to -32099
  serverError: {
    default: -32e3
  }
};
Object.defineProperty(jsonrpcclient$1, "__esModule", { value: !0 });
jsonrpcclient$1.JsonRpcClient = void 0;
const stream_1$4 = build$h, types_1$7 = types$7;
let JsonRpcClient$1 = class {
  constructor(n) {
    this.connection = n;
  }
  async run(n) {
    const o = this.connection.responseStream.filter((d) => d.id === n.id), u = (0, stream_1$4.firstEvent)(o);
    this.connection.sendRequest(n);
    const c = await u;
    if ((0, types_1$7.isJsonRpcErrorResponse)(c)) {
      const d = c.error;
      throw new Error(`JSON RPC error: code=${d.code}; message='${d.message}'`);
    }
    return c;
  }
};
jsonrpcclient$1.JsonRpcClient = JsonRpcClient$1;
var parse$f = {}, compatibility$1 = {};
Object.defineProperty(compatibility$1, "__esModule", { value: !0 });
compatibility$1.isJsonCompatibleDictionary = compatibility$1.isJsonCompatibleArray = compatibility$1.isJsonCompatibleValue = void 0;
function isJsonCompatibleValue$1(e) {
  return !!(typeof e == "string" || typeof e == "number" || typeof e == "boolean" || e === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleArray$1(e) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleDictionary$1(e));
}
compatibility$1.isJsonCompatibleValue = isJsonCompatibleValue$1;
function isJsonCompatibleArray$1(e) {
  if (!Array.isArray(e))
    return !1;
  for (const n of e)
    if (!isJsonCompatibleValue$1(n))
      return !1;
  return !0;
}
compatibility$1.isJsonCompatibleArray = isJsonCompatibleArray$1;
function isJsonCompatibleDictionary$1(e) {
  return typeof e != "object" || e === null || Object.prototype.toString.call(e) !== "[object Object]" ? !1 : Object.values(e).every(isJsonCompatibleValue$1);
}
compatibility$1.isJsonCompatibleDictionary = isJsonCompatibleDictionary$1;
Object.defineProperty(parse$f, "__esModule", { value: !0 });
parse$f.parseJsonRpcResponse = parse$f.parseJsonRpcSuccessResponse = parse$f.parseJsonRpcErrorResponse = parse$f.parseJsonRpcRequest = parse$f.parseJsonRpcId = void 0;
const compatibility_1$1 = compatibility$1;
function parseJsonRpcId$1(e) {
  if (!(0, compatibility_1$1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  const n = e.id;
  return typeof n != "number" && typeof n != "string" ? null : n;
}
parse$f.parseJsonRpcId = parseJsonRpcId$1;
function parseJsonRpcRequest$1(e) {
  if (!(0, compatibility_1$1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${e.jsonrpc}`);
  const n = parseJsonRpcId$1(e);
  if (n === null)
    throw new Error("Invalid id field");
  const o = e.method;
  if (typeof o != "string")
    throw new Error("Invalid method field");
  if (!(0, compatibility_1$1.isJsonCompatibleArray)(e.params) && !(0, compatibility_1$1.isJsonCompatibleDictionary)(e.params))
    throw new Error("Invalid params field");
  return {
    jsonrpc: "2.0",
    id: n,
    method: o,
    params: e.params
  };
}
parse$f.parseJsonRpcRequest = parseJsonRpcRequest$1;
function parseError$1(e) {
  if (typeof e.code != "number")
    throw new Error("Error property 'code' is not a number");
  if (typeof e.message != "string")
    throw new Error("Error property 'message' is not a string");
  let n;
  if (e.data === void 0)
    n = void 0;
  else if ((0, compatibility_1$1.isJsonCompatibleValue)(e.data))
    n = e.data;
  else
    throw new Error("Error property 'data' is defined but not a JSON compatible value.");
  return {
    code: e.code,
    message: e.message,
    ...n !== void 0 ? { data: n } : {}
  };
}
function parseJsonRpcErrorResponse$1(e) {
  if (!(0, compatibility_1$1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const n = e.id;
  if (typeof n != "number" && typeof n != "string" && n !== null)
    throw new Error("Invalid id field");
  if (typeof e.error > "u" || !(0, compatibility_1$1.isJsonCompatibleDictionary)(e.error))
    throw new Error("Invalid error field");
  return {
    jsonrpc: "2.0",
    id: n,
    error: parseError$1(e.error)
  };
}
parse$f.parseJsonRpcErrorResponse = parseJsonRpcErrorResponse$1;
function parseJsonRpcSuccessResponse$1(e) {
  if (!(0, compatibility_1$1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const n = e.id;
  if (typeof n != "number" && typeof n != "string")
    throw new Error("Invalid id field");
  if (typeof e.result > "u")
    throw new Error("Invalid result field");
  const o = e.result;
  return {
    jsonrpc: "2.0",
    id: n,
    result: o
  };
}
parse$f.parseJsonRpcSuccessResponse = parseJsonRpcSuccessResponse$1;
function parseJsonRpcResponse$1(e) {
  let n;
  try {
    n = parseJsonRpcErrorResponse$1(e);
  } catch {
    n = parseJsonRpcSuccessResponse$1(e);
  }
  return n;
}
parse$f.parseJsonRpcResponse = parseJsonRpcResponse$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.jsonRpcCode = e.isJsonRpcSuccessResponse = e.isJsonRpcErrorResponse = e.parseJsonRpcSuccessResponse = e.parseJsonRpcResponse = e.parseJsonRpcRequest = e.parseJsonRpcId = e.parseJsonRpcErrorResponse = e.JsonRpcClient = e.makeJsonRpcId = void 0;
  var n = id$2;
  Object.defineProperty(e, "makeJsonRpcId", { enumerable: !0, get: function() {
    return n.makeJsonRpcId;
  } });
  var o = jsonrpcclient$1;
  Object.defineProperty(e, "JsonRpcClient", { enumerable: !0, get: function() {
    return o.JsonRpcClient;
  } });
  var u = parse$f;
  Object.defineProperty(e, "parseJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "parseJsonRpcId", { enumerable: !0, get: function() {
    return u.parseJsonRpcId;
  } }), Object.defineProperty(e, "parseJsonRpcRequest", { enumerable: !0, get: function() {
    return u.parseJsonRpcRequest;
  } }), Object.defineProperty(e, "parseJsonRpcResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcResponse;
  } }), Object.defineProperty(e, "parseJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcSuccessResponse;
  } });
  var c = types$7;
  Object.defineProperty(e, "isJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return c.isJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "isJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return c.isJsonRpcSuccessResponse;
  } }), Object.defineProperty(e, "jsonRpcCode", { enumerable: !0, get: function() {
    return c.jsonRpcCode;
  } });
})(build$i);
var http$3 = {};
function bind$6(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: toString$4 } = Object.prototype, { getPrototypeOf } = Object, kindOf$1 = ((e) => (n) => {
  const o = toString$4.call(n);
  return e[o] || (e[o] = o.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest$1 = (e) => (e = e.toLowerCase(), (n) => kindOf$1(n) === e), typeOfTest = (e) => (n) => typeof n === e, { isArray: isArray$3 } = Array, isUndefined$2 = typeOfTest("undefined");
function isBuffer$2(e) {
  return e !== null && !isUndefined$2(e) && e.constructor !== null && !isUndefined$2(e.constructor) && isFunction$3(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const isArrayBuffer$2 = kindOfTest$1("ArrayBuffer");
function isArrayBufferView$2(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && isArrayBuffer$2(e.buffer), n;
}
const isString$2 = typeOfTest("string"), isFunction$3 = typeOfTest("function"), isNumber$2 = typeOfTest("number"), isObject$4 = (e) => e !== null && typeof e == "object", isBoolean = (e) => e === !0 || e === !1, isPlainObject$2 = (e) => {
  if (kindOf$1(e) !== "object")
    return !1;
  const n = getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, isDate$2 = kindOfTest$1("Date"), isFile$2 = kindOfTest$1("File"), isBlob$2 = kindOfTest$1("Blob"), isFileList$1 = kindOfTest$1("FileList"), isStream$2 = (e) => isObject$4(e) && isFunction$3(e.pipe), isFormData$2 = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || isFunction$3(e.append) && ((n = kindOf$1(e)) === "formdata" || // detect form-data instance
  n === "object" && isFunction$3(e.toString) && e.toString() === "[object FormData]"));
}, isURLSearchParams$2 = kindOfTest$1("URLSearchParams"), trim$3 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach$2(e, n, { allOwnKeys: o = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let u, c;
  if (typeof e != "object" && (e = [e]), isArray$3(e))
    for (u = 0, c = e.length; u < c; u++)
      n.call(null, e[u], u, e);
  else {
    const d = o ? Object.getOwnPropertyNames(e) : Object.keys(e), m = d.length;
    let v;
    for (u = 0; u < m; u++)
      v = d[u], n.call(null, e[v], v, e);
  }
}
function findKey(e, n) {
  n = n.toLowerCase();
  const o = Object.keys(e);
  let u = o.length, c;
  for (; u-- > 0; )
    if (c = o[u], n === c.toLowerCase())
      return c;
  return null;
}
const _global = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : commonjsGlobal)(), isContextDefined = (e) => !isUndefined$2(e) && e !== _global;
function merge$3() {
  const { caseless: e } = isContextDefined(this) && this || {}, n = {}, o = (u, c) => {
    const d = e && findKey(n, c) || c;
    isPlainObject$2(n[d]) && isPlainObject$2(u) ? n[d] = merge$3(n[d], u) : isPlainObject$2(u) ? n[d] = merge$3({}, u) : isArray$3(u) ? n[d] = u.slice() : n[d] = u;
  };
  for (let u = 0, c = arguments.length; u < c; u++)
    arguments[u] && forEach$2(arguments[u], o);
  return n;
}
const extend$2 = (e, n, o, { allOwnKeys: u } = {}) => (forEach$2(n, (c, d) => {
  o && isFunction$3(c) ? e[d] = bind$6(c, o) : e[d] = c;
}, { allOwnKeys: u }), e), stripBOM$2 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits$1 = (e, n, o, u) => {
  e.prototype = Object.create(n.prototype, u), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), o && Object.assign(e.prototype, o);
}, toFlatObject$1 = (e, n, o, u) => {
  let c, d, m;
  const v = {};
  if (n = n || {}, e == null)
    return n;
  do {
    for (c = Object.getOwnPropertyNames(e), d = c.length; d-- > 0; )
      m = c[d], (!u || u(m, e, n)) && !v[m] && (n[m] = e[m], v[m] = !0);
    e = o !== !1 && getPrototypeOf(e);
  } while (e && (!o || o(e, n)) && e !== Object.prototype);
  return n;
}, endsWith$1 = (e, n, o) => {
  e = String(e), (o === void 0 || o > e.length) && (o = e.length), o -= n.length;
  const u = e.indexOf(n, o);
  return u !== -1 && u === o;
}, toArray$1 = (e) => {
  if (!e)
    return null;
  if (isArray$3(e))
    return e;
  let n = e.length;
  if (!isNumber$2(n))
    return null;
  const o = new Array(n);
  for (; n-- > 0; )
    o[n] = e[n];
  return o;
}, isTypedArray$1 = ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (e, n) => {
  const u = (e && e[Symbol.iterator]).call(e);
  let c;
  for (; (c = u.next()) && !c.done; ) {
    const d = c.value;
    n.call(e, d[0], d[1]);
  }
}, matchAll = (e, n) => {
  let o;
  const u = [];
  for (; (o = e.exec(n)) !== null; )
    u.push(o);
  return u;
}, isHTMLForm = kindOfTest$1("HTMLFormElement"), toCamelCase = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(o, u, c) {
    return u.toUpperCase() + c;
  }
), hasOwnProperty = (({ hasOwnProperty: e }) => (n, o) => e.call(n, o))(Object.prototype), isRegExp = kindOfTest$1("RegExp"), reduceDescriptors = (e, n) => {
  const o = Object.getOwnPropertyDescriptors(e), u = {};
  forEach$2(o, (c, d) => {
    let m;
    (m = n(c, d, e)) !== !1 && (u[d] = m || c);
  }), Object.defineProperties(e, u);
}, freezeMethods = (e) => {
  reduceDescriptors(e, (n, o) => {
    if (isFunction$3(e) && ["arguments", "caller", "callee"].indexOf(o) !== -1)
      return !1;
    const u = e[o];
    if (isFunction$3(u)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + o + "'");
      });
    }
  });
}, toObjectSet = (e, n) => {
  const o = {}, u = (c) => {
    c.forEach((d) => {
      o[d] = !0;
    });
  };
  return isArray$3(e) ? u(e) : u(String(e).split(n)), o;
}, noop$1 = () => {
}, toFiniteNumber = (e, n) => (e = +e, Number.isFinite(e) ? e : n), ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = (e = 16, n = ALPHABET.ALPHA_DIGIT) => {
  let o = "";
  const { length: u } = n;
  for (; e--; )
    o += n[Math.random() * u | 0];
  return o;
};
function isSpecCompliantForm(e) {
  return !!(e && isFunction$3(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const toJSONObject = (e) => {
  const n = new Array(10), o = (u, c) => {
    if (isObject$4(u)) {
      if (n.indexOf(u) >= 0)
        return;
      if (!("toJSON" in u)) {
        n[c] = u;
        const d = isArray$3(u) ? [] : {};
        return forEach$2(u, (m, v) => {
          const S = o(m, c + 1);
          !isUndefined$2(S) && (d[v] = S);
        }), n[c] = void 0, d;
      }
    }
    return u;
  };
  return o(e, 0);
}, isAsyncFn = kindOfTest$1("AsyncFunction"), isThenable = (e) => e && (isObject$4(e) || isFunction$3(e)) && isFunction$3(e.then) && isFunction$3(e.catch);
var utils$1$1 = {
  isArray: isArray$3,
  isArrayBuffer: isArrayBuffer$2,
  isBuffer: isBuffer$2,
  isFormData: isFormData$2,
  isArrayBufferView: isArrayBufferView$2,
  isString: isString$2,
  isNumber: isNumber$2,
  isBoolean,
  isObject: isObject$4,
  isPlainObject: isPlainObject$2,
  isUndefined: isUndefined$2,
  isDate: isDate$2,
  isFile: isFile$2,
  isBlob: isBlob$2,
  isRegExp,
  isFunction: isFunction$3,
  isStream: isStream$2,
  isURLSearchParams: isURLSearchParams$2,
  isTypedArray: isTypedArray$1,
  isFileList: isFileList$1,
  forEach: forEach$2,
  merge: merge$3,
  extend: extend$2,
  trim: trim$3,
  stripBOM: stripBOM$2,
  inherits: inherits$1,
  toFlatObject: toFlatObject$1,
  kindOf: kindOf$1,
  kindOfTest: kindOfTest$1,
  endsWith: endsWith$1,
  toArray: toArray$1,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError$3(e, n, o, u, c) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), o && (this.config = o), u && (this.request = u), c && (this.response = c);
}
utils$1$1.inherits(AxiosError$3, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError$3.prototype, descriptors$1 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  descriptors$1[e] = { value: e };
});
Object.defineProperties(AxiosError$3, descriptors$1);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError$3.from = (e, n, o, u, c, d) => {
  const m = Object.create(prototype$1);
  return utils$1$1.toFlatObject(e, m, function(S) {
    return S !== Error.prototype;
  }, (v) => v !== "isAxiosError"), AxiosError$3.call(m, e.message, n, o, u, c), m.cause = e, m.name = e.name, d && Object.assign(m, d), m;
};
var httpAdapter = null;
function isVisitable(e) {
  return utils$1$1.isPlainObject(e) || utils$1$1.isArray(e);
}
function removeBrackets(e) {
  return utils$1$1.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function renderKey(e, n, o) {
  return e ? e.concat(n).map(function(c, d) {
    return c = removeBrackets(c), !o && d ? "[" + c + "]" : c;
  }).join(o ? "." : "") : n;
}
function isFlatArray(e) {
  return utils$1$1.isArray(e) && !e.some(isVisitable);
}
const predicates = utils$1$1.toFlatObject(utils$1$1, {}, null, function e(n) {
  return /^is[A-Z]/.test(n);
});
function toFormData$2(e, n, o) {
  if (!utils$1$1.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), o = utils$1$1.toFlatObject(o, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(M, G) {
    return !utils$1$1.isUndefined(G[M]);
  });
  const u = o.metaTokens, c = o.visitor || E, d = o.dots, m = o.indexes, S = (o.Blob || typeof Blob < "u" && Blob) && utils$1$1.isSpecCompliantForm(n);
  if (!utils$1$1.isFunction(c))
    throw new TypeError("visitor must be a function");
  function $(V) {
    if (V === null)
      return "";
    if (utils$1$1.isDate(V))
      return V.toISOString();
    if (!S && utils$1$1.isBlob(V))
      throw new AxiosError$3("Blob is not supported. Use a Buffer instead.");
    return utils$1$1.isArrayBuffer(V) || utils$1$1.isTypedArray(V) ? S && typeof Blob == "function" ? new Blob([V]) : buffer$1.Buffer.from(V) : V;
  }
  function E(V, M, G) {
    let k = V;
    if (V && !G && typeof V == "object") {
      if (utils$1$1.endsWith(M, "{}"))
        M = u ? M : M.slice(0, -2), V = JSON.stringify(V);
      else if (utils$1$1.isArray(V) && isFlatArray(V) || (utils$1$1.isFileList(V) || utils$1$1.endsWith(M, "[]")) && (k = utils$1$1.toArray(V)))
        return M = removeBrackets(M), k.forEach(function(X, ee) {
          !(utils$1$1.isUndefined(X) || X === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            m === !0 ? renderKey([M], ee, d) : m === null ? M : M + "[]",
            $(X)
          );
        }), !1;
    }
    return isVisitable(V) ? !0 : (n.append(renderKey(G, M, d), $(V)), !1);
  }
  const O = [], T = Object.assign(predicates, {
    defaultVisitor: E,
    convertValue: $,
    isVisitable
  });
  function y(V, M) {
    if (!utils$1$1.isUndefined(V)) {
      if (O.indexOf(V) !== -1)
        throw Error("Circular reference detected in " + M.join("."));
      O.push(V), utils$1$1.forEach(V, function(k, F) {
        (!(utils$1$1.isUndefined(k) || k === null) && c.call(
          n,
          k,
          utils$1$1.isString(F) ? F.trim() : F,
          M,
          T
        )) === !0 && y(k, M ? M.concat(F) : [F]);
      }), O.pop();
    }
  }
  if (!utils$1$1.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), n;
}
function encode$1$1(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(u) {
    return n[u];
  });
}
function AxiosURLSearchParams(e, n) {
  this._pairs = [], e && toFormData$2(e, this, n);
}
const prototype$2 = AxiosURLSearchParams.prototype;
prototype$2.append = function e(n, o) {
  this._pairs.push([n, o]);
};
prototype$2.toString = function e(n) {
  const o = n ? function(u) {
    return n.call(this, u, encode$1$1);
  } : encode$1$1;
  return this._pairs.map(function(c) {
    return o(c[0]) + "=" + o(c[1]);
  }, "").join("&");
};
function encode$2(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL$4(e, n, o) {
  if (!n)
    return e;
  const u = o && o.encode || encode$2, c = o && o.serialize;
  let d;
  if (c ? d = c(n, o) : d = utils$1$1.isURLSearchParams(n) ? n.toString() : new AxiosURLSearchParams(n, o).toString(u), d) {
    const m = e.indexOf("#");
    m !== -1 && (e = e.slice(0, m)), e += (e.indexOf("?") === -1 ? "?" : "&") + d;
  }
  return e;
}
let InterceptorManager$4 = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, o, u) {
    return this.handlers.push({
      fulfilled: n,
      rejected: o,
      synchronous: u ? u.synchronous : !1,
      runWhen: u ? u.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    utils$1$1.forEach(this.handlers, function(u) {
      u !== null && n(u);
    });
  }
};
var InterceptorManager$1$1 = InterceptorManager$4, transitionalDefaults$1 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window < "u" && typeof document < "u", hasStandardBrowserEnv = ((e) => hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), hasStandardBrowserWebWorkerEnv = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")();
var utils$s = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  hasStandardBrowserEnv
}), platform = {
  ...utils$s,
  ...platform$1
};
function toURLEncodedForm(e, n) {
  return toFormData$2(e, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(o, u, c, d) {
      return platform.isNode && utils$1$1.isBuffer(o) ? (this.append(u, o.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function parsePropPath(e) {
  return utils$1$1.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function arrayToObject(e) {
  const n = {}, o = Object.keys(e);
  let u;
  const c = o.length;
  let d;
  for (u = 0; u < c; u++)
    d = o[u], n[d] = e[d];
  return n;
}
function formDataToJSON(e) {
  function n(o, u, c, d) {
    let m = o[d++];
    const v = Number.isFinite(+m), S = d >= o.length;
    return m = !m && utils$1$1.isArray(c) ? c.length : m, S ? (utils$1$1.hasOwnProp(c, m) ? c[m] = [c[m], u] : c[m] = u, !v) : ((!c[m] || !utils$1$1.isObject(c[m])) && (c[m] = []), n(o, u, c[m], d) && utils$1$1.isArray(c[m]) && (c[m] = arrayToObject(c[m])), !v);
  }
  if (utils$1$1.isFormData(e) && utils$1$1.isFunction(e.entries)) {
    const o = {};
    return utils$1$1.forEachEntry(e, (u, c) => {
      n(parsePropPath(u), c, o, 0);
    }), o;
  }
  return null;
}
function stringifySafely$2(e, n, o) {
  if (utils$1$1.isString(e))
    try {
      return (n || JSON.parse)(e), utils$1$1.trim(e);
    } catch (u) {
      if (u.name !== "SyntaxError")
        throw u;
    }
  return (o || JSON.stringify)(e);
}
const defaults$8 = {
  transitional: transitionalDefaults$1,
  adapter: ["xhr", "http"],
  transformRequest: [function e(n, o) {
    const u = o.getContentType() || "", c = u.indexOf("application/json") > -1, d = utils$1$1.isObject(n);
    if (d && utils$1$1.isHTMLForm(n) && (n = new FormData(n)), utils$1$1.isFormData(n))
      return c && c ? JSON.stringify(formDataToJSON(n)) : n;
    if (utils$1$1.isArrayBuffer(n) || utils$1$1.isBuffer(n) || utils$1$1.isStream(n) || utils$1$1.isFile(n) || utils$1$1.isBlob(n))
      return n;
    if (utils$1$1.isArrayBufferView(n))
      return n.buffer;
    if (utils$1$1.isURLSearchParams(n))
      return o.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let v;
    if (d) {
      if (u.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(n, this.formSerializer).toString();
      if ((v = utils$1$1.isFileList(n)) || u.indexOf("multipart/form-data") > -1) {
        const S = this.env && this.env.FormData;
        return toFormData$2(
          v ? { "files[]": n } : n,
          S && new S(),
          this.formSerializer
        );
      }
    }
    return d || c ? (o.setContentType("application/json", !1), stringifySafely$2(n)) : n;
  }],
  transformResponse: [function e(n) {
    const o = this.transitional || defaults$8.transitional, u = o && o.forcedJSONParsing, c = this.responseType === "json";
    if (n && utils$1$1.isString(n) && (u && !this.responseType || c)) {
      const m = !(o && o.silentJSONParsing) && c;
      try {
        return JSON.parse(n);
      } catch (v) {
        if (m)
          throw v.name === "SyntaxError" ? AxiosError$3.from(v, AxiosError$3.ERR_BAD_RESPONSE, this, null, this.response) : v;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function e(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1$1.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  defaults$8.headers[e] = {};
});
var defaults$1$1 = defaults$8;
const ignoreDuplicateOf = utils$1$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
var parseHeaders$2 = (e) => {
  const n = {};
  let o, u, c;
  return e && e.split(`
`).forEach(function(m) {
    c = m.indexOf(":"), o = m.substring(0, c).trim().toLowerCase(), u = m.substring(c + 1).trim(), !(!o || n[o] && ignoreDuplicateOf[o]) && (o === "set-cookie" ? n[o] ? n[o].push(u) : n[o] = [u] : n[o] = n[o] ? n[o] + ", " + u : u);
  }), n;
};
const $internals = Symbol("internals");
function normalizeHeader(e) {
  return e && String(e).trim().toLowerCase();
}
function normalizeValue(e) {
  return e === !1 || e == null ? e : utils$1$1.isArray(e) ? e.map(normalizeValue) : String(e);
}
function parseTokens(e) {
  const n = /* @__PURE__ */ Object.create(null), o = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let u;
  for (; u = o.exec(e); )
    n[u[1]] = u[2];
  return n;
}
const isValidHeaderName = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function matchHeaderValue(e, n, o, u, c) {
  if (utils$1$1.isFunction(u))
    return u.call(this, n, o);
  if (c && (n = o), !!utils$1$1.isString(n)) {
    if (utils$1$1.isString(u))
      return n.indexOf(u) !== -1;
    if (utils$1$1.isRegExp(u))
      return u.test(n);
  }
}
function formatHeader(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, o, u) => o.toUpperCase() + u);
}
function buildAccessors(e, n) {
  const o = utils$1$1.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((u) => {
    Object.defineProperty(e, u + o, {
      value: function(c, d, m) {
        return this[u].call(this, n, c, d, m);
      },
      configurable: !0
    });
  });
}
class AxiosHeaders {
  constructor(n) {
    n && this.set(n);
  }
  set(n, o, u) {
    const c = this;
    function d(v, S, $) {
      const E = normalizeHeader(S);
      if (!E)
        throw new Error("header name must be a non-empty string");
      const O = utils$1$1.findKey(c, E);
      (!O || c[O] === void 0 || $ === !0 || $ === void 0 && c[O] !== !1) && (c[O || S] = normalizeValue(v));
    }
    const m = (v, S) => utils$1$1.forEach(v, ($, E) => d($, E, S));
    return utils$1$1.isPlainObject(n) || n instanceof this.constructor ? m(n, o) : utils$1$1.isString(n) && (n = n.trim()) && !isValidHeaderName(n) ? m(parseHeaders$2(n), o) : n != null && d(o, n, u), this;
  }
  get(n, o) {
    if (n = normalizeHeader(n), n) {
      const u = utils$1$1.findKey(this, n);
      if (u) {
        const c = this[u];
        if (!o)
          return c;
        if (o === !0)
          return parseTokens(c);
        if (utils$1$1.isFunction(o))
          return o.call(this, c, u);
        if (utils$1$1.isRegExp(o))
          return o.exec(c);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, o) {
    if (n = normalizeHeader(n), n) {
      const u = utils$1$1.findKey(this, n);
      return !!(u && this[u] !== void 0 && (!o || matchHeaderValue(this, this[u], u, o)));
    }
    return !1;
  }
  delete(n, o) {
    const u = this;
    let c = !1;
    function d(m) {
      if (m = normalizeHeader(m), m) {
        const v = utils$1$1.findKey(u, m);
        v && (!o || matchHeaderValue(u, u[v], v, o)) && (delete u[v], c = !0);
      }
    }
    return utils$1$1.isArray(n) ? n.forEach(d) : d(n), c;
  }
  clear(n) {
    const o = Object.keys(this);
    let u = o.length, c = !1;
    for (; u--; ) {
      const d = o[u];
      (!n || matchHeaderValue(this, this[d], d, n, !0)) && (delete this[d], c = !0);
    }
    return c;
  }
  normalize(n) {
    const o = this, u = {};
    return utils$1$1.forEach(this, (c, d) => {
      const m = utils$1$1.findKey(u, d);
      if (m) {
        o[m] = normalizeValue(c), delete o[d];
        return;
      }
      const v = n ? formatHeader(d) : String(d).trim();
      v !== d && delete o[d], o[v] = normalizeValue(c), u[v] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const o = /* @__PURE__ */ Object.create(null);
    return utils$1$1.forEach(this, (u, c) => {
      u != null && u !== !1 && (o[c] = n && utils$1$1.isArray(u) ? u.join(", ") : u);
    }), o;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, o]) => n + ": " + o).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...o) {
    const u = new this(n);
    return o.forEach((c) => u.set(c)), u;
  }
  static accessor(n) {
    const u = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, c = this.prototype;
    function d(m) {
      const v = normalizeHeader(m);
      u[v] || (buildAccessors(c, m), u[v] = !0);
    }
    return utils$1$1.isArray(n) ? n.forEach(d) : d(n), this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1$1.reduceDescriptors(AxiosHeaders.prototype, ({ value: e }, n) => {
  let o = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(u) {
      this[o] = u;
    }
  };
});
utils$1$1.freezeMethods(AxiosHeaders);
var AxiosHeaders$1 = AxiosHeaders;
function transformData$4(e, n) {
  const o = this || defaults$1$1, u = n || o, c = AxiosHeaders$1.from(u.headers);
  let d = u.data;
  return utils$1$1.forEach(e, function(v) {
    d = v.call(o, d, c.normalize(), n ? n.status : void 0);
  }), c.normalize(), d;
}
function isCancel$4(e) {
  return !!(e && e.__CANCEL__);
}
function CanceledError$1(e, n, o) {
  AxiosError$3.call(this, e ?? "canceled", AxiosError$3.ERR_CANCELED, n, o), this.name = "CanceledError";
}
utils$1$1.inherits(CanceledError$1, AxiosError$3, {
  __CANCEL__: !0
});
function settle$2(e, n, o) {
  const u = o.config.validateStatus;
  !o.status || !u || u(o.status) ? e(o) : n(new AxiosError$3(
    "Request failed with status code " + o.status,
    [AxiosError$3.ERR_BAD_REQUEST, AxiosError$3.ERR_BAD_RESPONSE][Math.floor(o.status / 100) - 4],
    o.config,
    o.request,
    o
  ));
}
var cookies$2 = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, o, u, c, d) {
      const m = [e + "=" + encodeURIComponent(n)];
      utils$1$1.isNumber(o) && m.push("expires=" + new Date(o).toGMTString()), utils$1$1.isString(u) && m.push("path=" + u), utils$1$1.isString(c) && m.push("domain=" + c), d === !0 && m.push("secure"), document.cookie = m.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL$3(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function combineURLs$3(e, n) {
  return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function buildFullPath$3(e, n) {
  return e && !isAbsoluteURL$3(n) ? combineURLs$3(e, n) : n;
}
var isURLSameOrigin$2 = platform.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function e() {
    const n = /(msie|trident)/i.test(navigator.userAgent), o = document.createElement("a");
    let u;
    function c(d) {
      let m = d;
      return n && (o.setAttribute("href", m), m = o.href), o.setAttribute("href", m), {
        href: o.href,
        protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
        host: o.host,
        search: o.search ? o.search.replace(/^\?/, "") : "",
        hash: o.hash ? o.hash.replace(/^#/, "") : "",
        hostname: o.hostname,
        port: o.port,
        pathname: o.pathname.charAt(0) === "/" ? o.pathname : "/" + o.pathname
      };
    }
    return u = c(window.location.href), function(m) {
      const v = utils$1$1.isString(m) ? c(m) : m;
      return v.protocol === u.protocol && v.host === u.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function e() {
    return function() {
      return !0;
    };
  }()
);
function parseProtocol$1(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function speedometer(e, n) {
  e = e || 10;
  const o = new Array(e), u = new Array(e);
  let c = 0, d = 0, m;
  return n = n !== void 0 ? n : 1e3, function(S) {
    const $ = Date.now(), E = u[d];
    m || (m = $), o[c] = S, u[c] = $;
    let O = d, T = 0;
    for (; O !== c; )
      T += o[O++], O = O % e;
    if (c = (c + 1) % e, c === d && (d = (d + 1) % e), $ - m < n)
      return;
    const y = E && $ - E;
    return y ? Math.round(T * 1e3 / y) : void 0;
  };
}
function progressEventReducer(e, n) {
  let o = 0;
  const u = speedometer(50, 250);
  return (c) => {
    const d = c.loaded, m = c.lengthComputable ? c.total : void 0, v = d - o, S = u(v), $ = d <= m;
    o = d;
    const E = {
      loaded: d,
      total: m,
      progress: m ? d / m : void 0,
      bytes: v,
      rate: S || void 0,
      estimated: S && m && $ ? (m - d) / S : void 0,
      event: c
    };
    E[n ? "download" : "upload"] = !0, e(E);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest < "u";
var xhrAdapter = isXHRAdapterSupported && function(e) {
  return new Promise(function(o, u) {
    let c = e.data;
    const d = AxiosHeaders$1.from(e.headers).normalize();
    let { responseType: m, withXSRFToken: v } = e, S;
    function $() {
      e.cancelToken && e.cancelToken.unsubscribe(S), e.signal && e.signal.removeEventListener("abort", S);
    }
    let E;
    if (utils$1$1.isFormData(c)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
        d.setContentType(!1);
      else if ((E = d.getContentType()) !== !1) {
        const [M, ...G] = E ? E.split(";").map((k) => k.trim()).filter(Boolean) : [];
        d.setContentType([M || "multipart/form-data", ...G].join("; "));
      }
    }
    let O = new XMLHttpRequest();
    if (e.auth) {
      const M = e.auth.username || "", G = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      d.set("Authorization", "Basic " + btoa(M + ":" + G));
    }
    const T = buildFullPath$3(e.baseURL, e.url);
    O.open(e.method.toUpperCase(), buildURL$4(T, e.params, e.paramsSerializer), !0), O.timeout = e.timeout;
    function y() {
      if (!O)
        return;
      const M = AxiosHeaders$1.from(
        "getAllResponseHeaders" in O && O.getAllResponseHeaders()
      ), k = {
        data: !m || m === "text" || m === "json" ? O.responseText : O.response,
        status: O.status,
        statusText: O.statusText,
        headers: M,
        config: e,
        request: O
      };
      settle$2(function(X) {
        o(X), $();
      }, function(X) {
        u(X), $();
      }, k), O = null;
    }
    if ("onloadend" in O ? O.onloadend = y : O.onreadystatechange = function() {
      !O || O.readyState !== 4 || O.status === 0 && !(O.responseURL && O.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, O.onabort = function() {
      O && (u(new AxiosError$3("Request aborted", AxiosError$3.ECONNABORTED, e, O)), O = null);
    }, O.onerror = function() {
      u(new AxiosError$3("Network Error", AxiosError$3.ERR_NETWORK, e, O)), O = null;
    }, O.ontimeout = function() {
      let G = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const k = e.transitional || transitionalDefaults$1;
      e.timeoutErrorMessage && (G = e.timeoutErrorMessage), u(new AxiosError$3(
        G,
        k.clarifyTimeoutError ? AxiosError$3.ETIMEDOUT : AxiosError$3.ECONNABORTED,
        e,
        O
      )), O = null;
    }, platform.hasStandardBrowserEnv && (v && utils$1$1.isFunction(v) && (v = v(e)), v || v !== !1 && isURLSameOrigin$2(T))) {
      const M = e.xsrfHeaderName && e.xsrfCookieName && cookies$2.read(e.xsrfCookieName);
      M && d.set(e.xsrfHeaderName, M);
    }
    c === void 0 && d.setContentType(null), "setRequestHeader" in O && utils$1$1.forEach(d.toJSON(), function(G, k) {
      O.setRequestHeader(k, G);
    }), utils$1$1.isUndefined(e.withCredentials) || (O.withCredentials = !!e.withCredentials), m && m !== "json" && (O.responseType = e.responseType), typeof e.onDownloadProgress == "function" && O.addEventListener("progress", progressEventReducer(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && O.upload && O.upload.addEventListener("progress", progressEventReducer(e.onUploadProgress)), (e.cancelToken || e.signal) && (S = (M) => {
      O && (u(!M || M.type ? new CanceledError$1(null, e, O) : M), O.abort(), O = null);
    }, e.cancelToken && e.cancelToken.subscribe(S), e.signal && (e.signal.aborted ? S() : e.signal.addEventListener("abort", S)));
    const V = parseProtocol$1(T);
    if (V && platform.protocols.indexOf(V) === -1) {
      u(new AxiosError$3("Unsupported protocol " + V + ":", AxiosError$3.ERR_BAD_REQUEST, e));
      return;
    }
    O.send(c || null);
  });
};
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils$1$1.forEach(knownAdapters, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const renderReason = (e) => `- ${e}`, isResolvedHandle = (e) => utils$1$1.isFunction(e) || e === null || e === !1;
var adapters = {
  getAdapter: (e) => {
    e = utils$1$1.isArray(e) ? e : [e];
    const { length: n } = e;
    let o, u;
    const c = {};
    for (let d = 0; d < n; d++) {
      o = e[d];
      let m;
      if (u = o, !isResolvedHandle(o) && (u = knownAdapters[(m = String(o)).toLowerCase()], u === void 0))
        throw new AxiosError$3(`Unknown adapter '${m}'`);
      if (u)
        break;
      c[m || "#" + d] = u;
    }
    if (!u) {
      const d = Object.entries(c).map(
        ([v, S]) => `adapter ${v} ` + (S === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let m = n ? d.length > 1 ? `since :
` + d.map(renderReason).join(`
`) : " " + renderReason(d[0]) : "as no adapter specified";
      throw new AxiosError$3(
        "There is no suitable adapter to dispatch the request " + m,
        "ERR_NOT_SUPPORT"
      );
    }
    return u;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested$2(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError$1(null, e);
}
function dispatchRequest$4(e) {
  return throwIfCancellationRequested$2(e), e.headers = AxiosHeaders$1.from(e.headers), e.data = transformData$4.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(e.adapter || defaults$1$1.adapter)(e).then(function(u) {
    return throwIfCancellationRequested$2(e), u.data = transformData$4.call(
      e,
      e.transformResponse,
      u
    ), u.headers = AxiosHeaders$1.from(u.headers), u;
  }, function(u) {
    return isCancel$4(u) || (throwIfCancellationRequested$2(e), u && u.response && (u.response.data = transformData$4.call(
      e,
      e.transformResponse,
      u.response
    ), u.response.headers = AxiosHeaders$1.from(u.response.headers))), Promise.reject(u);
  });
}
const headersToObject = (e) => e instanceof AxiosHeaders$1 ? e.toJSON() : e;
function mergeConfig$6(e, n) {
  n = n || {};
  const o = {};
  function u($, E, O) {
    return utils$1$1.isPlainObject($) && utils$1$1.isPlainObject(E) ? utils$1$1.merge.call({ caseless: O }, $, E) : utils$1$1.isPlainObject(E) ? utils$1$1.merge({}, E) : utils$1$1.isArray(E) ? E.slice() : E;
  }
  function c($, E, O) {
    if (utils$1$1.isUndefined(E)) {
      if (!utils$1$1.isUndefined($))
        return u(void 0, $, O);
    } else
      return u($, E, O);
  }
  function d($, E) {
    if (!utils$1$1.isUndefined(E))
      return u(void 0, E);
  }
  function m($, E) {
    if (utils$1$1.isUndefined(E)) {
      if (!utils$1$1.isUndefined($))
        return u(void 0, $);
    } else
      return u(void 0, E);
  }
  function v($, E, O) {
    if (O in n)
      return u($, E);
    if (O in e)
      return u(void 0, $);
  }
  const S = {
    url: d,
    method: d,
    data: d,
    baseURL: m,
    transformRequest: m,
    transformResponse: m,
    paramsSerializer: m,
    timeout: m,
    timeoutMessage: m,
    withCredentials: m,
    withXSRFToken: m,
    adapter: m,
    responseType: m,
    xsrfCookieName: m,
    xsrfHeaderName: m,
    onUploadProgress: m,
    onDownloadProgress: m,
    decompress: m,
    maxContentLength: m,
    maxBodyLength: m,
    beforeRedirect: m,
    transport: m,
    httpAgent: m,
    httpsAgent: m,
    cancelToken: m,
    socketPath: m,
    responseEncoding: m,
    validateStatus: v,
    headers: ($, E) => c(headersToObject($), headersToObject(E), !0)
  };
  return utils$1$1.forEach(Object.keys(Object.assign({}, e, n)), function(E) {
    const O = S[E] || c, T = O(e[E], n[E], E);
    utils$1$1.isUndefined(T) && O !== v || (o[E] = T);
  }), o;
}
const VERSION$1 = "1.6.2", validators$1$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  validators$1$1[e] = function(u) {
    return typeof u === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const deprecatedWarnings$2 = {};
validators$1$1.transitional = function e(n, o, u) {
  function c(d, m) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + d + "'" + m + (u ? ". " + u : "");
  }
  return (d, m, v) => {
    if (n === !1)
      throw new AxiosError$3(
        c(m, " has been removed" + (o ? " in " + o : "")),
        AxiosError$3.ERR_DEPRECATED
      );
    return o && !deprecatedWarnings$2[m] && (deprecatedWarnings$2[m] = !0, console.warn(
      c(
        m,
        " has been deprecated since v" + o + " and will be removed in the near future"
      )
    )), n ? n(d, m, v) : !0;
  };
};
function assertOptions$2(e, n, o) {
  if (typeof e != "object")
    throw new AxiosError$3("options must be an object", AxiosError$3.ERR_BAD_OPTION_VALUE);
  const u = Object.keys(e);
  let c = u.length;
  for (; c-- > 0; ) {
    const d = u[c], m = n[d];
    if (m) {
      const v = e[d], S = v === void 0 || m(v, d, e);
      if (S !== !0)
        throw new AxiosError$3("option " + d + " must be " + S, AxiosError$3.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (o !== !0)
      throw new AxiosError$3("Unknown option " + d, AxiosError$3.ERR_BAD_OPTION);
  }
}
var validator$8 = {
  assertOptions: assertOptions$2,
  validators: validators$1$1
};
const validators$4 = validator$8.validators;
let Axios$4 = class {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new InterceptorManager$1$1(),
      response: new InterceptorManager$1$1()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(n, o) {
    typeof n == "string" ? (o = o || {}, o.url = n) : o = n || {}, o = mergeConfig$6(this.defaults, o);
    const { transitional: u, paramsSerializer: c, headers: d } = o;
    u !== void 0 && validator$8.assertOptions(u, {
      silentJSONParsing: validators$4.transitional(validators$4.boolean),
      forcedJSONParsing: validators$4.transitional(validators$4.boolean),
      clarifyTimeoutError: validators$4.transitional(validators$4.boolean)
    }, !1), c != null && (utils$1$1.isFunction(c) ? o.paramsSerializer = {
      serialize: c
    } : validator$8.assertOptions(c, {
      encode: validators$4.function,
      serialize: validators$4.function
    }, !0)), o.method = (o.method || this.defaults.method || "get").toLowerCase();
    let m = d && utils$1$1.merge(
      d.common,
      d[o.method]
    );
    d && utils$1$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (V) => {
        delete d[V];
      }
    ), o.headers = AxiosHeaders$1.concat(m, d);
    const v = [];
    let S = !0;
    this.interceptors.request.forEach(function(M) {
      typeof M.runWhen == "function" && M.runWhen(o) === !1 || (S = S && M.synchronous, v.unshift(M.fulfilled, M.rejected));
    });
    const $ = [];
    this.interceptors.response.forEach(function(M) {
      $.push(M.fulfilled, M.rejected);
    });
    let E, O = 0, T;
    if (!S) {
      const V = [dispatchRequest$4.bind(this), void 0];
      for (V.unshift.apply(V, v), V.push.apply(V, $), T = V.length, E = Promise.resolve(o); O < T; )
        E = E.then(V[O++], V[O++]);
      return E;
    }
    T = v.length;
    let y = o;
    for (O = 0; O < T; ) {
      const V = v[O++], M = v[O++];
      try {
        y = V(y);
      } catch (G) {
        M.call(this, G);
        break;
      }
    }
    try {
      E = dispatchRequest$4.call(this, y);
    } catch (V) {
      return Promise.reject(V);
    }
    for (O = 0, T = $.length; O < T; )
      E = E.then($[O++], $[O++]);
    return E;
  }
  getUri(n) {
    n = mergeConfig$6(this.defaults, n);
    const o = buildFullPath$3(n.baseURL, n.url);
    return buildURL$4(o, n.params, n.paramsSerializer);
  }
};
utils$1$1.forEach(["delete", "get", "head", "options"], function e(n) {
  Axios$4.prototype[n] = function(o, u) {
    return this.request(mergeConfig$6(u || {}, {
      method: n,
      url: o,
      data: (u || {}).data
    }));
  };
});
utils$1$1.forEach(["post", "put", "patch"], function e(n) {
  function o(u) {
    return function(d, m, v) {
      return this.request(mergeConfig$6(v || {}, {
        method: n,
        headers: u ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: d,
        data: m
      }));
    };
  }
  Axios$4.prototype[n] = o(), Axios$4.prototype[n + "Form"] = o(!0);
});
var Axios$1$1 = Axios$4;
class CancelToken {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let o;
    this.promise = new Promise(function(d) {
      o = d;
    });
    const u = this;
    this.promise.then((c) => {
      if (!u._listeners)
        return;
      let d = u._listeners.length;
      for (; d-- > 0; )
        u._listeners[d](c);
      u._listeners = null;
    }), this.promise.then = (c) => {
      let d;
      const m = new Promise((v) => {
        u.subscribe(v), d = v;
      }).then(c);
      return m.cancel = function() {
        u.unsubscribe(d);
      }, m;
    }, n(function(d, m, v) {
      u.reason || (u.reason = new CanceledError$1(d, m, v), o(u.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const o = this._listeners.indexOf(n);
    o !== -1 && this._listeners.splice(o, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new CancelToken(function(c) {
        n = c;
      }),
      cancel: n
    };
  }
}
var CancelToken$1 = CancelToken;
function spread$2(e) {
  return function(o) {
    return e.apply(null, o);
  };
}
function isAxiosError$2(e) {
  return utils$1$1.isObject(e) && e.isAxiosError === !0;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([e, n]) => {
  HttpStatusCode[n] = e;
});
var HttpStatusCode$1 = HttpStatusCode;
function createInstance$2(e) {
  const n = new Axios$1$1(e), o = bind$6(Axios$1$1.prototype.request, n);
  return utils$1$1.extend(o, Axios$1$1.prototype, n, { allOwnKeys: !0 }), utils$1$1.extend(o, n, null, { allOwnKeys: !0 }), o.create = function(c) {
    return createInstance$2(mergeConfig$6(e, c));
  }, o;
}
const axios$7 = createInstance$2(defaults$1$1);
axios$7.Axios = Axios$1$1;
axios$7.CanceledError = CanceledError$1;
axios$7.CancelToken = CancelToken$1;
axios$7.isCancel = isCancel$4;
axios$7.VERSION = VERSION$1;
axios$7.toFormData = toFormData$2;
axios$7.AxiosError = AxiosError$3;
axios$7.Cancel = axios$7.CanceledError;
axios$7.all = function e(n) {
  return Promise.all(n);
};
axios$7.spread = spread$2;
axios$7.isAxiosError = isAxiosError$2;
axios$7.mergeConfig = mergeConfig$6;
axios$7.AxiosHeaders = AxiosHeaders$1;
axios$7.formToJSON = (e) => formDataToJSON(utils$1$1.isHTMLForm(e) ? new FormData(e) : e);
axios$7.getAdapter = adapters.getAdapter;
axios$7.HttpStatusCode = HttpStatusCode$1;
axios$7.default = axios$7;
var axios_1$2 = axios$7, __importDefault$o = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(http$3, "__esModule", { value: !0 });
http$3.http = void 0;
const axios_1$1 = __importDefault$o(axios_1$2);
function filterBadStatus$1(e) {
  if (e.status >= 400)
    throw new Error(`Bad status on response: ${e.status}`);
  return e;
}
function isExperimental(e) {
  return e.toString().includes("emitExperimentalWarning");
}
async function http$2(e, n, o, u) {
  if (typeof fetch == "function" && !isExperimental(fetch)) {
    const c = {
      method: e,
      body: u ? JSON.stringify(u) : void 0,
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json",
        ...o
      }
    };
    return fetch(n, c).then(filterBadStatus$1).then((d) => d.json());
  } else
    return axios_1$1.default.request({ url: n, method: e, data: u, headers: o }).then((c) => c.data);
}
http$3.http = http$2;
var rpcclient$1 = {};
Object.defineProperty(rpcclient$1, "__esModule", { value: !0 });
rpcclient$1.hasProtocol = rpcclient$1.instanceOfRpcStreamingClient = void 0;
function instanceOfRpcStreamingClient$1(e) {
  return typeof e.listen == "function";
}
rpcclient$1.instanceOfRpcStreamingClient = instanceOfRpcStreamingClient$1;
function hasProtocol$1(e) {
  return e.search("://") !== -1;
}
rpcclient$1.hasProtocol = hasProtocol$1;
Object.defineProperty(httpbatchclient$1, "__esModule", { value: !0 });
httpbatchclient$1.HttpBatchClient = void 0;
const json_rpc_1$5 = build$i, http_1$3 = http$3, rpcclient_1$5 = rpcclient$1, defaultHttpBatchClientOptions$1 = {
  dispatchInterval: 20,
  batchSizeLimit: 20
};
let HttpBatchClient$1 = class {
  constructor(n, o = {}) {
    this.queue = [], this.options = {
      batchSizeLimit: o.batchSizeLimit ?? defaultHttpBatchClientOptions$1.batchSizeLimit,
      dispatchInterval: o.dispatchInterval ?? defaultHttpBatchClientOptions$1.dispatchInterval
    }, typeof n == "string" ? this.url = (0, rpcclient_1$5.hasProtocol)(n) ? n : "http://" + n : (this.url = n.url, this.headers = n.headers), this.timer = setInterval(() => this.tick(), o.dispatchInterval), this.validate();
  }
  disconnect() {
    this.timer && clearInterval(this.timer), this.timer = void 0;
  }
  async execute(n) {
    return new Promise((o, u) => {
      this.queue.push({ request: n, resolve: o, reject: u }), this.queue.length >= this.options.batchSizeLimit && this.tick();
    });
  }
  validate() {
    if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1)
      throw new Error("batchSizeLimit must be a safe integer >= 1");
  }
  /**
   * This is called in an interval where promise rejections cannot be handled.
   * So this is not async and HTTP errors need to be handled by the queued promises.
   */
  tick() {
    const n = this.queue.splice(0, this.options.batchSizeLimit);
    if (!n.length)
      return;
    const o = n.map((c) => c.request), u = o.map((c) => c.id);
    (0, http_1$3.http)("POST", this.url, this.headers, o).then((c) => {
      (Array.isArray(c) ? c : [c]).forEach((m) => {
        const v = n.find((O) => O.request.id === m.id);
        if (!v)
          return;
        const { reject: S, resolve: $ } = v, E = (0, json_rpc_1$5.parseJsonRpcResponse)(m);
        (0, json_rpc_1$5.isJsonRpcErrorResponse)(E) ? S(new Error(JSON.stringify(E.error))) : $(E);
      });
    }, (c) => {
      for (const d of u) {
        const m = n.find((v) => v.request.id === d);
        if (!m)
          return;
        m.reject(c);
      }
    });
  }
};
httpbatchclient$1.HttpBatchClient = HttpBatchClient$1;
var httpclient$1 = {};
Object.defineProperty(httpclient$1, "__esModule", { value: !0 });
httpclient$1.HttpClient = void 0;
const json_rpc_1$4 = build$i, http_1$2 = http$3, rpcclient_1$4 = rpcclient$1;
let HttpClient$1 = class {
  constructor(n) {
    typeof n == "string" ? this.url = (0, rpcclient_1$4.hasProtocol)(n) ? n : "http://" + n : (this.url = n.url, this.headers = n.headers);
  }
  disconnect() {
  }
  async execute(n) {
    const o = (0, json_rpc_1$4.parseJsonRpcResponse)(await (0, http_1$2.http)("POST", this.url, this.headers, n));
    if ((0, json_rpc_1$4.isJsonRpcErrorResponse)(o))
      throw new Error(JSON.stringify(o.error));
    return o;
  }
};
httpclient$1.HttpClient = HttpClient$1;
var websocketclient$1 = {}, build$g = {}, queueingstreamingsocket$1 = {}, streamingsocket$1 = {}, socketwrapper$1 = {}, __importDefault$n = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(socketwrapper$1, "__esModule", { value: !0 });
socketwrapper$1.SocketWrapper = void 0;
const isomorphic_ws_1$1 = __importDefault$n(browser$1);
function environmentIsNodeJs$1() {
  return typeof browser$1$1 < "u" && typeof browser$1$1.versions < "u" && typeof browser$1$1.versions.node < "u";
}
let SocketWrapper$1 = class {
  constructor(n, o, u, c, d, m = 1e4) {
    this.closed = !1, this.connected = new Promise((v, S) => {
      this.connectedResolver = v, this.connectedRejecter = S;
    }), this.url = n, this.messageHandler = o, this.errorHandler = u, this.openHandler = c, this.closeHandler = d, this.timeout = m;
  }
  /**
   * returns a promise that resolves when connection is open
   */
  connect() {
    const n = new isomorphic_ws_1$1.default(this.url);
    n.onerror = (u) => {
      this.clearTimeout(), this.errorHandler && this.errorHandler(u);
    }, n.onmessage = (u) => {
      this.messageHandler({
        type: u.type,
        data: u.data
      });
    }, n.onopen = (u) => {
      this.clearTimeout(), this.connectedResolver(), this.openHandler && this.openHandler();
    }, n.onclose = (u) => {
      this.closed = !0, this.closeHandler && this.closeHandler(u);
    };
    const o = Date.now();
    this.timeoutId = setTimeout(() => {
      n.onmessage = () => 0, n.onerror = () => 0, n.onopen = () => 0, n.onclose = () => 0, n.close(), this.socket = void 0;
      const u = Math.floor(Date.now() - o);
      this.connectedRejecter(`Connection attempt timed out after ${u} ms`);
    }, this.timeout), this.socket = n;
  }
  /**
   * Closes an established connection and aborts other connection states
   */
  disconnect() {
    if (!this.socket)
      throw new Error("Socket undefined. This must be called after connecting.");
    switch (this.clearTimeout(), this.socket.readyState) {
      case isomorphic_ws_1$1.default.OPEN:
        this.socket.close(
          1e3
          /* Normal Closure */
        );
        break;
      case isomorphic_ws_1$1.default.CLOSED:
        break;
      case isomorphic_ws_1$1.default.CONNECTING:
        this.socket.onopen = () => 0, this.socket.onclose = () => 0, this.socket.onerror = () => 0, this.socket.onmessage = () => 0, this.socket = void 0, this.closeHandler && this.closeHandler({ wasClean: !1, code: 4001 });
        break;
      case isomorphic_ws_1$1.default.CLOSING:
        break;
      default:
        throw new Error(`Unknown readyState: ${this.socket.readyState}`);
    }
  }
  async send(n) {
    return new Promise((o, u) => {
      if (!this.socket)
        throw new Error("Socket undefined. This must be called after connecting.");
      if (this.closed)
        throw new Error("Socket was closed, so no data can be sent anymore.");
      if (this.socket.readyState !== isomorphic_ws_1$1.default.OPEN)
        throw new Error("Websocket is not open");
      environmentIsNodeJs$1() ? this.socket.send(n, (c) => c ? u(c) : o()) : (this.socket.send(n), o());
    });
  }
  /**
   * Clears the timeout function, such that no timeout error will be raised anymore. This should be
   * called when the connection is established, a connection error occurred or the socket is disconnected.
   *
   * This method must not be called before `connect()`.
   * This method is idempotent.
   */
  clearTimeout() {
    if (!this.timeoutId)
      throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
    clearTimeout(this.timeoutId);
  }
};
socketwrapper$1.SocketWrapper = SocketWrapper$1;
Object.defineProperty(streamingsocket$1, "__esModule", { value: !0 });
streamingsocket$1.StreamingSocket = void 0;
const xstream_1$8 = xstream, socketwrapper_1$1 = socketwrapper$1;
let StreamingSocket$1 = class {
  constructor(n, o = 1e4) {
    this.socket = new socketwrapper_1$1.SocketWrapper(n, (c) => {
      this.eventProducerListener && this.eventProducerListener.next(c);
    }, (c) => {
      this.eventProducerListener && this.eventProducerListener.error(c);
    }, () => {
    }, (c) => {
      this.eventProducerListener && (c.wasClean ? this.eventProducerListener.complete() : this.eventProducerListener.error("Socket was closed unclean"));
    }, o), this.connected = this.socket.connected;
    const u = {
      start: (c) => this.eventProducerListener = c,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$8.Stream.create(u);
  }
  connect() {
    this.socket.connect();
  }
  disconnect() {
    this.socket.disconnect();
  }
  async send(n) {
    return this.socket.send(n);
  }
};
streamingsocket$1.StreamingSocket = StreamingSocket$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  const n = build$h, o = xstream, u = streamingsocket$1;
  var c;
  (function(m) {
    m[m.Unconnected = 0] = "Unconnected", m[m.Connecting = 1] = "Connecting", m[m.Connected = 2] = "Connected", m[m.Disconnected = 3] = "Disconnected";
  })(c = e.ConnectionStatus || (e.ConnectionStatus = {}));
  class d {
    constructor(v, S = 1e4, $) {
      this.queue = [], this.isProcessingQueue = !1, this.url = v, this.timeout = S, this.reconnectedHandler = $;
      const E = {
        start: (O) => this.eventProducerListener = O,
        stop: () => this.eventProducerListener = void 0
      };
      this.events = o.Stream.create(E), this.connectionStatusProducer = new n.DefaultValueProducer(c.Unconnected), this.connectionStatus = new n.ValueAndUpdates(this.connectionStatusProducer), this.socket = new u.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (O) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(O);
        },
        error: () => this.connectionStatusProducer.update(c.Disconnected)
      });
    }
    connect() {
      this.connectionStatusProducer.update(c.Connecting), this.socket.connected.then(async () => (this.connectionStatusProducer.update(c.Connected), this.processQueue()), () => this.connectionStatusProducer.update(c.Disconnected)), this.socket.connect();
    }
    disconnect() {
      this.connectionStatusProducer.update(c.Disconnected), this.socket.disconnect();
    }
    reconnect() {
      this.socket = new u.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (v) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(v);
        },
        error: () => this.connectionStatusProducer.update(c.Disconnected)
      }), this.socket.connected.then(() => {
        this.reconnectedHandler && this.reconnectedHandler();
      }), this.connect();
    }
    getQueueLength() {
      return this.queue.length;
    }
    queueRequest(v) {
      this.queue.push(v), this.processQueue();
    }
    async processQueue() {
      if (this.isProcessingQueue || this.connectionStatus.value !== c.Connected)
        return;
      this.isProcessingQueue = !0;
      let v;
      for (; v = this.queue.shift(); )
        try {
          await this.socket.send(v), this.isProcessingQueue = !1;
        } catch {
          this.queue.unshift(v), this.isProcessingQueue = !1;
          return;
        }
    }
  }
  e.QueueingStreamingSocket = d;
})(queueingstreamingsocket$1);
var reconnectingsocket$1 = {};
Object.defineProperty(reconnectingsocket$1, "__esModule", { value: !0 });
reconnectingsocket$1.ReconnectingSocket = void 0;
const xstream_1$7 = xstream, queueingstreamingsocket_1$1 = queueingstreamingsocket$1;
let ReconnectingSocket$1 = class fd {
  /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */
  static calculateTimeout(n) {
    return Math.min(2 ** n * 100, 5e3);
  }
  constructor(n, o = 1e4, u) {
    this.unconnected = !0, this.disconnected = !1, this.timeoutIndex = 0, this.reconnectTimeout = null;
    const c = {
      start: (d) => this.eventProducerListener = d,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$7.Stream.create(c), this.socket = new queueingstreamingsocket_1$1.QueueingStreamingSocket(n, o, u), this.socket.events.subscribe({
      next: (d) => {
        this.eventProducerListener && this.eventProducerListener.next(d);
      },
      error: (d) => {
        this.eventProducerListener && this.eventProducerListener.error(d);
      }
    }), this.connectionStatus = this.socket.connectionStatus, this.connectionStatus.updates.subscribe({
      next: (d) => {
        d === queueingstreamingsocket_1$1.ConnectionStatus.Connected && (this.timeoutIndex = 0), d === queueingstreamingsocket_1$1.ConnectionStatus.Disconnected && (this.reconnectTimeout && (clearTimeout(this.reconnectTimeout), this.reconnectTimeout = null), this.reconnectTimeout = setTimeout(() => this.socket.reconnect(), fd.calculateTimeout(this.timeoutIndex++)));
      }
    });
  }
  connect() {
    if (!this.unconnected)
      throw new Error("Cannot connect: socket has already connected");
    this.socket.connect(), this.unconnected = !1;
  }
  disconnect() {
    if (this.unconnected)
      throw new Error("Cannot disconnect: socket has not yet connected");
    this.socket.disconnect(), this.eventProducerListener && this.eventProducerListener.complete(), this.disconnected = !0;
  }
  queueRequest(n) {
    if (this.disconnected)
      throw new Error("Cannot queue request: socket has disconnected");
    this.socket.queueRequest(n);
  }
};
reconnectingsocket$1.ReconnectingSocket = ReconnectingSocket$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.StreamingSocket = e.SocketWrapper = e.ReconnectingSocket = e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  var n = queueingstreamingsocket$1;
  Object.defineProperty(e, "ConnectionStatus", { enumerable: !0, get: function() {
    return n.ConnectionStatus;
  } }), Object.defineProperty(e, "QueueingStreamingSocket", { enumerable: !0, get: function() {
    return n.QueueingStreamingSocket;
  } });
  var o = reconnectingsocket$1;
  Object.defineProperty(e, "ReconnectingSocket", { enumerable: !0, get: function() {
    return o.ReconnectingSocket;
  } });
  var u = socketwrapper$1;
  Object.defineProperty(e, "SocketWrapper", { enumerable: !0, get: function() {
    return u.SocketWrapper;
  } });
  var c = streamingsocket$1;
  Object.defineProperty(e, "StreamingSocket", { enumerable: !0, get: function() {
    return c.StreamingSocket;
  } });
})(build$g);
Object.defineProperty(websocketclient$1, "__esModule", { value: !0 });
websocketclient$1.WebsocketClient = void 0;
const json_rpc_1$3 = build$i, socket_1$1 = build$g, stream_1$3 = build$h, xstream_1$6 = xstream, rpcclient_1$3 = rpcclient$1;
function defaultErrorHandler$1(e) {
  throw e;
}
function toJsonRpcResponse$1(e) {
  if (e.type !== "message")
    throw new Error(`Unexcepted message type on websocket: ${e.type}`);
  return (0, json_rpc_1$3.parseJsonRpcResponse)(JSON.parse(e.data));
}
let RpcEventProducer$1 = class {
  constructor(n, o) {
    this.running = !1, this.subscriptions = [], this.request = n, this.socket = o;
  }
  /**
   * Implementation of Producer.start
   */
  start(n) {
    if (this.running)
      throw Error("Already started. Please stop first before restarting.");
    this.running = !0, this.connectToClient(n), this.socket.queueRequest(JSON.stringify(this.request));
  }
  /**
   * Implementation of Producer.stop
   *
   * Called by the stream when the stream's last listener stopped listening
   * or when the producer completed.
   */
  stop() {
    this.running = !1;
    const n = { ...this.request, method: "unsubscribe" };
    try {
      this.socket.queueRequest(JSON.stringify(n));
    } catch (o) {
      if (!(o instanceof Error && o.message.match(/socket has disconnected/i)))
        throw o;
    }
  }
  connectToClient(n) {
    const o = this.socket.events.map(toJsonRpcResponse$1), u = o.filter((m) => m.id === this.request.id).subscribe({
      next: (m) => {
        (0, json_rpc_1$3.isJsonRpcErrorResponse)(m) && (this.closeSubscriptions(), n.error(JSON.stringify(m.error))), u.unsubscribe();
      }
    }), c = o.filter((m) => m.id === this.request.id).subscribe({
      next: (m) => {
        (0, json_rpc_1$3.isJsonRpcErrorResponse)(m) ? (this.closeSubscriptions(), n.error(JSON.stringify(m.error))) : n.next(m.result);
      }
    }), d = o.subscribe({
      error: (m) => {
        this.closeSubscriptions(), n.error(m);
      },
      complete: () => {
        this.closeSubscriptions(), n.complete();
      }
    });
    this.subscriptions.push(u, c, d);
  }
  closeSubscriptions() {
    for (const n of this.subscriptions)
      n.unsubscribe();
    this.subscriptions = [];
  }
}, WebsocketClient$1 = class {
  constructor(n, o = defaultErrorHandler$1) {
    this.subscriptionStreams = /* @__PURE__ */ new Map();
    const u = n.endsWith("/") ? "websocket" : "/websocket", c = (0, rpcclient_1$3.hasProtocol)(n) ? n : "ws://" + n;
    this.url = c + u, this.socket = new socket_1$1.ReconnectingSocket(this.url);
    const d = this.socket.events.subscribe({
      error: (m) => {
        o(m), d.unsubscribe();
      }
    });
    this.jsonRpcResponseStream = this.socket.events.map(toJsonRpcResponse$1), this.socket.connect();
  }
  async execute(n) {
    const o = this.responseForRequestId(n.id);
    this.socket.queueRequest(JSON.stringify(n));
    const u = await o;
    if ((0, json_rpc_1$3.isJsonRpcErrorResponse)(u))
      throw new Error(JSON.stringify(u.error));
    return u;
  }
  listen(n) {
    if (n.method !== "subscribe")
      throw new Error('Request method must be "subscribe" to start event listening');
    const o = n.params.query;
    if (typeof o != "string")
      throw new Error("request.params.query must be a string");
    if (!this.subscriptionStreams.has(o)) {
      const u = new RpcEventProducer$1(n, this.socket), c = xstream_1$6.Stream.create(u);
      this.subscriptionStreams.set(o, c);
    }
    return this.subscriptionStreams.get(o).filter((u) => u.query !== void 0);
  }
  /**
   * Resolves as soon as websocket is connected. execute() queues requests automatically,
   * so this should be required for testing purposes only.
   */
  async connected() {
    await this.socket.connectionStatus.waitFor(socket_1$1.ConnectionStatus.Connected);
  }
  disconnect() {
    this.socket.disconnect();
  }
  async responseForRequestId(n) {
    return (0, stream_1$3.firstEvent)(this.jsonRpcResponseStream.filter((o) => o.id === n));
  }
};
websocketclient$1.WebsocketClient = WebsocketClient$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.WebsocketClient = e.instanceOfRpcStreamingClient = e.HttpClient = e.HttpBatchClient = void 0;
  var n = httpbatchclient$1;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return n.HttpBatchClient;
  } });
  var o = httpclient$1;
  Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return o.HttpClient;
  } });
  var u = rpcclient$1;
  Object.defineProperty(e, "instanceOfRpcStreamingClient", { enumerable: !0, get: function() {
    return u.instanceOfRpcStreamingClient;
  } });
  var c = websocketclient$1;
  Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return c.WebsocketClient;
  } });
})(rpcclients$1);
var adaptor$3 = {}, requests$f = {}, inthelpers$1 = {}, encodings$3 = {};
Object.defineProperty(encodings$3, "__esModule", { value: !0 });
encodings$3.encodeBlockId = encodings$3.encodeVersion = encodings$3.encodeBytes = encodings$3.encodeTime = encodings$3.encodeUvarint = encodings$3.encodeString = encodings$3.dictionaryToStringMap = encodings$3.may = encodings$3.assertNotEmpty = encodings$3.assertObject = encodings$3.assertArray = encodings$3.assertNumber = encodings$3.assertString = encodings$3.assertBoolean = encodings$3.assertSet = void 0;
const encoding_1$E = build$n;
function assertSet$3(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$3.assertSet = assertSet$3;
function assertBoolean$3(e) {
  if (assertSet$3(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$3.assertBoolean = assertBoolean$3;
function assertString$3(e) {
  if (assertSet$3(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$3.assertString = assertString$3;
function assertNumber$3(e) {
  if (assertSet$3(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$3.assertNumber = assertNumber$3;
function assertArray$3(e) {
  if (assertSet$3(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$3.assertArray = assertArray$3;
function assertObject$3(e) {
  if (assertSet$3(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$3.assertObject = assertObject$3;
function assertNotEmpty$3(e) {
  if (assertSet$3(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$3.assertNotEmpty = assertNotEmpty$3;
function may$3(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$3.may = may$3;
function dictionaryToStringMap$3(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$3.dictionaryToStringMap = dictionaryToStringMap$3;
function encodeString$3(e) {
  const n = (0, encoding_1$E.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$3.encodeString = encodeString$3;
function encodeUvarint$4(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$4(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$3.encodeUvarint = encodeUvarint$4;
function encodeTime$3(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$4(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$4(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$3.encodeTime = encodeTime$3;
function encodeBytes$3(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$3.encodeBytes = encodeBytes$3;
function encodeVersion$3(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$4(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$4(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$3.encodeVersion = encodeVersion$3;
function encodeBlockId$3(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$3.encodeBlockId = encodeBlockId$3;
Object.defineProperty(inthelpers$1, "__esModule", { value: !0 });
inthelpers$1.smallIntToApi = inthelpers$1.apiToBigInt = inthelpers$1.apiToSmallInt = void 0;
const math_1$h = build$m, encodings_1$d = encodings$3;
function apiToSmallInt$1(e) {
  return (typeof e == "number" ? new math_1$h.Int53(e) : math_1$h.Int53.fromString(e)).toNumber();
}
inthelpers$1.apiToSmallInt = apiToSmallInt$1;
function apiToBigInt$1(e) {
  if ((0, encodings_1$d.assertString)(e), !e.match(/^-?[0-9]+$/))
    throw new Error("Invalid string format");
  return BigInt(e);
}
inthelpers$1.apiToBigInt = apiToBigInt$1;
function smallIntToApi$1(e) {
  return new math_1$h.Int53(e).toString();
}
inthelpers$1.smallIntToApi = smallIntToApi$1;
var encodings$2 = {};
Object.defineProperty(encodings$2, "__esModule", { value: !0 });
encodings$2.encodeBlockId = encodings$2.encodeVersion = encodings$2.encodeBytes = encodings$2.encodeTime = encodings$2.encodeUvarint = encodings$2.encodeString = encodings$2.dictionaryToStringMap = encodings$2.may = encodings$2.assertNotEmpty = encodings$2.assertObject = encodings$2.assertArray = encodings$2.assertNumber = encodings$2.assertString = encodings$2.assertBoolean = encodings$2.assertSet = void 0;
const encoding_1$D = build$n;
function assertSet$2(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$2.assertSet = assertSet$2;
function assertBoolean$2(e) {
  if (assertSet$2(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$2.assertBoolean = assertBoolean$2;
function assertString$2(e) {
  if (assertSet$2(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$2.assertString = assertString$2;
function assertNumber$2(e) {
  if (assertSet$2(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$2.assertNumber = assertNumber$2;
function assertArray$2(e) {
  if (assertSet$2(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$2.assertArray = assertArray$2;
function assertObject$2(e) {
  if (assertSet$2(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$2.assertObject = assertObject$2;
function assertNotEmpty$2(e) {
  if (assertSet$2(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$2.assertNotEmpty = assertNotEmpty$2;
function may$2(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$2.may = may$2;
function dictionaryToStringMap$2(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$2.dictionaryToStringMap = dictionaryToStringMap$2;
function encodeString$2(e) {
  const n = (0, encoding_1$D.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$2.encodeString = encodeString$2;
function encodeUvarint$3(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$3(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$2.encodeUvarint = encodeUvarint$3;
function encodeTime$2(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$3(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$3(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$2.encodeTime = encodeTime$2;
function encodeBytes$2(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$2.encodeBytes = encodeBytes$2;
function encodeVersion$2(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$3(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$3(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$2.encodeVersion = encodeVersion$2;
function encodeBlockId$2(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$2.encodeBlockId = encodeBlockId$2;
var requests$e = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$e);
var __createBinding$s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$s = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$s = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$s(n, e, o);
  return __setModuleDefault$s(n, e), n;
};
Object.defineProperty(requests$f, "__esModule", { value: !0 });
requests$f.Params = void 0;
const encoding_1$C = build$n, inthelpers_1$7 = inthelpers$1, jsonrpc_1$7 = jsonrpc$1, encodings_1$c = encodings$2, requests$d = __importStar$s(requests$e);
function encodeHeightParam$3(e) {
  return {
    height: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$3(e) {
  return {
    minHeight: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$3(e) {
  return {
    query: e.query,
    page: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.page),
    per_page: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$3(e) {
  return {
    path: (0, encodings_1$c.assertNotEmpty)(e.path),
    data: (0, encoding_1$C.toHex)(e.data),
    height: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$3(e) {
  return {
    tx: (0, encoding_1$C.toBase64)((0, encodings_1$c.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$3(e) {
  return {
    hash: (0, encoding_1$C.toBase64)((0, encodings_1$c.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$3(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.page),
    per_page: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$3(e) {
  return {
    height: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.height),
    page: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.page),
    per_page: (0, encodings_1$c.may)(inthelpers_1$7.smallIntToApi, e.per_page)
  };
}
let Params$q = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeAbciQueryParams$3(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeHeightParam$3(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$3(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeHeightParam$3(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeBlockSearchParams$3(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$3(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeHeightParam$3(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$d.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$7.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeTxParams$3(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeTxSearchParams$3(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$7.createJsonRpcRequest)(n.method, encodeValidatorsParams$3(n.params));
  }
};
requests$f.Params = Params$q;
var responses$7 = {}, types$6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = void 0, function(n) {
    n[n.Unknown = 0] = "Unknown", n[n.Absent = 1] = "Absent", n[n.Commit = 2] = "Commit", n[n.Nil = 3] = "Nil", n[n.Unrecognized = -1] = "Unrecognized";
  }(e.BlockIdFlag || (e.BlockIdFlag = {}));
})(types$6);
var hasher$3 = {};
Object.defineProperty(hasher$3, "__esModule", { value: !0 });
hasher$3.hashBlock = hasher$3.hashTx = void 0;
const crypto_1$e = build$k, encodings_1$b = encodings$2;
function hashTx$3(e) {
  return (0, crypto_1$e.sha256)(e);
}
hasher$3.hashTx = hashTx$3;
function getSplitPoint$3(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$3(e) {
  const n = new crypto_1$e.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$3(e, n) {
  const o = new crypto_1$e.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$3(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$3(e[0]);
    default: {
      const n = getSplitPoint$3(e.length), o = hashTree$3(e.slice(0, n)), u = hashTree$3(e.slice(n));
      return hashInner$3(o, u);
    }
  }
}
function hashBlock$3(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$b.encodeVersion)(e.version),
    (0, encodings_1$b.encodeString)(e.chainId),
    (0, encodings_1$b.encodeUvarint)(e.height),
    (0, encodings_1$b.encodeTime)(e.time),
    (0, encodings_1$b.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$b.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$b.encodeBytes)(e.dataHash),
    (0, encodings_1$b.encodeBytes)(e.validatorsHash),
    (0, encodings_1$b.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$b.encodeBytes)(e.consensusHash),
    (0, encodings_1$b.encodeBytes)(e.appHash),
    (0, encodings_1$b.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$b.encodeBytes)(e.evidenceHash),
    (0, encodings_1$b.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$3(n);
}
hasher$3.hashBlock = hashBlock$3;
Object.defineProperty(responses$7, "__esModule", { value: !0 });
responses$7.Responses = responses$7.decodeValidatorInfo = responses$7.decodeValidatorGenesis = responses$7.decodeValidatorUpdate = responses$7.decodeEvent = void 0;
const encoding_1$B = build$n, utils_1$u = build$j, dates_1$3 = dates$1, inthelpers_1$6 = inthelpers$1, types_1$6 = types$6, encodings_1$a = encodings$2, hasher_1$4 = hasher$3;
function decodeAbciInfo$3(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$a.may)(inthelpers_1$6.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$a.may)(encoding_1$B.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$3(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$B.fromBase64)(n.key),
      data: (0, encoding_1$B.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$3(e) {
  return {
    key: (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertString)(e.key ?? "")),
    value: (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertString)(e.value ?? "")),
    proof: (0, encodings_1$a.may)(decodeQueryProof$3, e.proofOps),
    height: (0, encodings_1$a.may)(inthelpers_1$6.apiToSmallInt, e.height),
    code: (0, encodings_1$a.may)(inthelpers_1$6.apiToSmallInt, e.code),
    codespace: (0, encodings_1$a.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$a.may)(inthelpers_1$6.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$a.assertString)(e.info ?? "")
  };
}
function decodeEventAttribute$1(e) {
  return {
    key: (0, encodings_1$a.assertNotEmpty)(e.key),
    value: e.value ?? ""
  };
}
function decodeAttributes$3(e) {
  return (0, encodings_1$a.assertArray)(e).map(decodeEventAttribute$1);
}
function decodeEvent$3(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$3(e.attributes) : []
  };
}
responses$7.decodeEvent = decodeEvent$3;
function decodeEvents$3(e) {
  return (0, encodings_1$a.assertArray)(e).map(decodeEvent$3);
}
function decodeTxData$3(e) {
  return {
    code: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$a.may)(encoding_1$B.fromBase64, e.data),
    events: e.events ? decodeEvents$3(e.events) : [],
    gasWanted: (0, inthelpers_1$6.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$6.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$4(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$u.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$3(e) {
  return {
    maxBytes: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$3(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$3(e) {
  return {
    block: decodeBlockParams$3((0, encodings_1$a.assertObject)(e.block)),
    evidence: decodeEvidenceParams$3((0, encodings_1$a.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$3(e) {
  return {
    pubkey: decodePubkey$4((0, encodings_1$a.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$6.apiToBigInt)(e.power ?? "0")
  };
}
responses$7.decodeValidatorUpdate = decodeValidatorUpdate$3;
function decodeBlockResults$3(e) {
  return {
    height: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$3),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$3),
    consensusUpdates: (0, encodings_1$a.may)(decodeConsensusParams$3, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$3(e.begin_block_events || []),
    endBlockEvents: decodeEvents$3(e.end_block_events || [])
  };
}
function decodeBlockId$3(e) {
  return {
    hash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$a.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$3(e) {
  return {
    block: (0, inthelpers_1$6.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$6.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$3(e) {
  return {
    version: decodeBlockVersion$3(e.version),
    chainId: (0, encodings_1$a.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.height)),
    time: (0, dates_1$3.fromRfc3339WithNanoseconds)((0, encodings_1$a.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$3(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$3(e) {
  return {
    blockId: decodeBlockId$3(e.block_id),
    blockSize: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.block_size)),
    header: decodeHeader$3(e.header),
    numTxs: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$3(e) {
  return {
    lastHeight: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$a.assertArray)(e.block_metas).map(decodeBlockMeta$3)
  };
}
function decodeBroadcastTxSync$3(e) {
  return {
    ...decodeTxData$3(e),
    hash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$3(e) {
  const n = e.tx_result ? decodeTxData$3(e.tx_result) : void 0;
  return {
    height: (0, inthelpers_1$6.apiToSmallInt)(e.height),
    hash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$3((0, encodings_1$a.assertObject)(e.check_tx)),
    deliverTx: n,
    txResult: n
  };
}
function decodeBlockIdFlag$3(e) {
  return (0, utils_1$u.assert)(e in types_1$6.BlockIdFlag), e;
}
function decodeOptionalTime$3(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1$3.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature$3(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$3(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$B.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime$3(e.timestamp),
    signature: e.signature ? (0, encoding_1$B.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$3(e) {
  return {
    blockId: decodeBlockId$3((0, encodings_1$a.assertObject)(e.block_id)),
    height: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$6.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$a.assertArray)(e.signatures).map(decodeCommitSignature$3)
  };
}
function decodeCommitResponse$3(e) {
  return {
    canonical: (0, encodings_1$a.assertBoolean)(e.canonical),
    header: decodeHeader$3(e.signed_header.header),
    commit: decodeCommit$3(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$3(e) {
  return {
    address: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$4((0, encodings_1$a.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$6.apiToBigInt)((0, encodings_1$a.assertNotEmpty)(e.power))
  };
}
responses$7.decodeValidatorGenesis = decodeValidatorGenesis$3;
function decodeGenesis$3(e) {
  return {
    genesisTime: (0, dates_1$3.fromRfc3339WithNanoseconds)((0, encodings_1$a.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$a.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$3(e.consensus_params),
    validators: e.validators ? (0, encodings_1$a.assertArray)(e.validators).map(decodeValidatorGenesis$3) : [],
    appHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$3(e) {
  return {
    pubkey: decodePubkey$4((0, encodings_1$a.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$6.apiToBigInt)((0, encodings_1$a.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$6.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$7.decodeValidatorInfo = decodeValidatorInfo$3;
function decodeNodeInfo$3(e) {
  return {
    id: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$a.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$a.assertNotEmpty)(e.network),
    version: (0, encodings_1$a.assertString)(e.version),
    channels: (0, encodings_1$a.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$a.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$a.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$3(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$6.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$3.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$B.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$B.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$3.fromRfc3339WithNanoseconds)((0, encodings_1$a.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$a.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$3(e) {
  return {
    nodeInfo: decodeNodeInfo$3(e.node_info),
    syncInfo: decodeSyncInfo$3(e.sync_info),
    validatorInfo: decodeValidatorInfo$3(e.validator_info)
  };
}
function decodeTxProof$3(e) {
  return {
    data: (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$a.assertArray)(e.proof.aunts).map(encoding_1$B.fromBase64)
    }
  };
}
function decodeTxResponse$3(e) {
  return {
    tx: (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertNotEmpty)(e.tx)),
    result: decodeTxData$3((0, encodings_1$a.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNumber)(e.index)),
    hash: (0, encoding_1$B.fromHex)((0, encodings_1$a.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$a.may)(decodeTxProof$3, e.proof)
  };
}
function decodeTxSearch$3(e) {
  return {
    totalCount: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$a.assertArray)(e.txs).map(decodeTxResponse$3)
  };
}
function decodeTxEvent$3(e) {
  const n = (0, encoding_1$B.fromBase64)((0, encodings_1$a.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$4.hashTx)(n),
    result: decodeTxData$3(e.result),
    height: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.height))
  };
}
function decodeValidators$3(e) {
  return {
    blockHeight: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$a.assertArray)(e.validators).map(decodeValidatorInfo$3),
    count: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.total))
  };
}
function decodeBlock$3(e) {
  var n;
  return {
    header: decodeHeader$3((0, encodings_1$a.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$3((0, encodings_1$a.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$a.assertArray)(e.data.txs).map(encoding_1$B.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$3(e) {
  return {
    blockId: decodeBlockId$3(e.block_id),
    block: decodeBlock$3(e.block)
  };
}
function decodeBlockSearch$3(e) {
  return {
    totalCount: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$a.assertArray)(e.blocks).map(decodeBlockResponse$3)
  };
}
function decodeNumUnconfirmedTxs$3(e) {
  return {
    total: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$6.apiToSmallInt)((0, encodings_1$a.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$3 = class pd {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$3((0, encodings_1$a.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$3((0, encodings_1$a.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$3(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$3(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$3(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$3(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$3(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return pd.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$3(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$3(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$3((0, encodings_1$a.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$3(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$3(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$3(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$3(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$3(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$3(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$3(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$3(n.result);
  }
};
responses$7.Responses = Responses$3;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$f;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$7;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$3);
var __createBinding$r = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$r = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$r = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$r(n, e, o);
  return __setModuleDefault$r(n, e), n;
};
Object.defineProperty(comet38client, "__esModule", { value: !0 });
comet38client.Comet38Client = void 0;
const jsonrpc_1$6 = jsonrpc$1, rpcclients_1$3 = rpcclients$1, adaptor_1$3 = adaptor$3, requests$c = __importStar$r(requests$e);
class Comet38Client {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$3.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$3.HttpClient(n) : new rpcclients_1$3.WebsocketClient(n), await this.detectVersion(o), Comet38Client.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new Comet38Client(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$6.createJsonRpcRequest)(requests$c.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$c.Method.AbciInfo };
    return this.doCall(n, adaptor_1$3.Params.encodeAbciInfo, adaptor_1$3.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$c.Method.AbciQuery };
    return this.doCall(o, adaptor_1$3.Params.encodeAbciQuery, adaptor_1$3.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$c.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$3.Params.encodeBlock, adaptor_1$3.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$c.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$3.Params.encodeBlockResults, adaptor_1$3.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$c.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$3.Params.encodeBlockSearch, adaptor_1$3.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$c.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$3.Params.encodeBlockchain, adaptor_1$3.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$c.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$3.Params.encodeBroadcastTx, adaptor_1$3.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$c.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$3.Params.encodeBroadcastTx, adaptor_1$3.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$c.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$3.Params.encodeBroadcastTx, adaptor_1$3.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$c.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$3.Params.encodeCommit, adaptor_1$3.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$c.Method.Genesis };
    return this.doCall(n, adaptor_1$3.Params.encodeGenesis, adaptor_1$3.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$c.Method.Health };
    return this.doCall(n, adaptor_1$3.Params.encodeHealth, adaptor_1$3.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$c.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$3.Params.encodeNumUnconfirmedTxs, adaptor_1$3.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$c.Method.Status };
    return this.doCall(n, adaptor_1$3.Params.encodeStatus, adaptor_1$3.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$c.Method.Subscribe,
      query: { type: requests$c.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$3.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$c.Method.Subscribe,
      query: { type: requests$c.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$3.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$c.Method.Subscribe,
      query: {
        type: requests$c.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$3.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$c.Method.Tx };
    return this.doCall(o, adaptor_1$3.Params.encodeTx, adaptor_1$3.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$c.Method.TxSearch };
    return this.doCall(o, adaptor_1$3.Params.encodeTxSearch, adaptor_1$3.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$c.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$3.Params.encodeValidators, adaptor_1$3.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$3.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$3.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
}
comet38client.Comet38Client = Comet38Client;
var responses$6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$6);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = e.Comet38Client = void 0;
  var n = comet38client;
  Object.defineProperty(e, "Comet38Client", { enumerable: !0, get: function() {
    return n.Comet38Client;
  } });
  var o = requests$e;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return o.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return o.SubscriptionEventType;
  } });
  var u = responses$6;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return u.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return u.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return u.VoteType;
  } });
})(comet38);
var tendermint34$1 = {}, requests$b = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$b);
var responses$5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$5);
var tendermint34client$1 = {}, adaptor$2 = {}, requests$a = {}, __createBinding$q = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$q = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$q = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$q(n, e, o);
  return __setModuleDefault$q(n, e), n;
};
Object.defineProperty(requests$a, "__esModule", { value: !0 });
requests$a.Params = void 0;
const encoding_1$A = build$n, inthelpers_1$5 = inthelpers$1, jsonrpc_1$5 = jsonrpc$1, encodings_1$9 = encodings$3, requests$9 = __importStar$q(requests$b);
function encodeHeightParam$2(e) {
  return {
    height: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$2(e) {
  return {
    minHeight: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$2(e) {
  return {
    query: e.query,
    page: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.page),
    per_page: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$2(e) {
  return {
    path: (0, encodings_1$9.assertNotEmpty)(e.path),
    data: (0, encoding_1$A.toHex)(e.data),
    height: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$2(e) {
  return {
    tx: (0, encoding_1$A.toBase64)((0, encodings_1$9.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$2(e) {
  return {
    hash: (0, encoding_1$A.toBase64)((0, encodings_1$9.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$2(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.page),
    per_page: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$2(e) {
  return {
    height: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.height),
    page: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.page),
    per_page: (0, encodings_1$9.may)(inthelpers_1$5.smallIntToApi, e.per_page)
  };
}
let Params$p = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeAbciQueryParams$2(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeHeightParam$2(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$2(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeHeightParam$2(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeBlockSearchParams$2(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$2(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeHeightParam$2(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$9.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$5.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeTxParams$2(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeTxSearchParams$2(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$5.createJsonRpcRequest)(n.method, encodeValidatorsParams$2(n.params));
  }
};
requests$a.Params = Params$p;
var responses$4 = {}, hasher$2 = {};
Object.defineProperty(hasher$2, "__esModule", { value: !0 });
hasher$2.hashBlock = hasher$2.hashTx = void 0;
const crypto_1$d = build$k, encodings_1$8 = encodings$3;
function hashTx$2(e) {
  return (0, crypto_1$d.sha256)(e);
}
hasher$2.hashTx = hashTx$2;
function getSplitPoint$2(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$2(e) {
  const n = new crypto_1$d.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$2(e, n) {
  const o = new crypto_1$d.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$2(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$2(e[0]);
    default: {
      const n = getSplitPoint$2(e.length), o = hashTree$2(e.slice(0, n)), u = hashTree$2(e.slice(n));
      return hashInner$2(o, u);
    }
  }
}
function hashBlock$2(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$8.encodeVersion)(e.version),
    (0, encodings_1$8.encodeString)(e.chainId),
    (0, encodings_1$8.encodeUvarint)(e.height),
    (0, encodings_1$8.encodeTime)(e.time),
    (0, encodings_1$8.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$8.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$8.encodeBytes)(e.dataHash),
    (0, encodings_1$8.encodeBytes)(e.validatorsHash),
    (0, encodings_1$8.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$8.encodeBytes)(e.consensusHash),
    (0, encodings_1$8.encodeBytes)(e.appHash),
    (0, encodings_1$8.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$8.encodeBytes)(e.evidenceHash),
    (0, encodings_1$8.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$2(n);
}
hasher$2.hashBlock = hashBlock$2;
Object.defineProperty(responses$4, "__esModule", { value: !0 });
responses$4.Responses = responses$4.decodeValidatorInfo = responses$4.decodeValidatorGenesis = responses$4.decodeValidatorUpdate = responses$4.decodeEvent = void 0;
const encoding_1$z = build$n, utils_1$t = build$j, dates_1$2 = dates$1, inthelpers_1$4 = inthelpers$1, types_1$5 = types$6, encodings_1$7 = encodings$3, hasher_1$3 = hasher$2;
function decodeAbciInfo$2(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$7.may)(inthelpers_1$4.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$7.may)(encoding_1$z.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$2(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$z.fromBase64)(n.key),
      data: (0, encoding_1$z.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$2(e) {
  return {
    key: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertString)(e.key ?? "")),
    value: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertString)(e.value ?? "")),
    proof: (0, encodings_1$7.may)(decodeQueryProof$2, e.proofOps),
    height: (0, encodings_1$7.may)(inthelpers_1$4.apiToSmallInt, e.height),
    code: (0, encodings_1$7.may)(inthelpers_1$4.apiToSmallInt, e.code),
    codespace: (0, encodings_1$7.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$7.may)(inthelpers_1$4.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$7.assertString)(e.info ?? "")
  };
}
function decodeAttribute$1(e) {
  return {
    key: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertNotEmpty)(e.key)),
    value: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertString)(e.value ?? ""))
  };
}
function decodeAttributes$2(e) {
  return (0, encodings_1$7.assertArray)(e).map(decodeAttribute$1);
}
function decodeEvent$2(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$2(e.attributes) : []
  };
}
responses$4.decodeEvent = decodeEvent$2;
function decodeEvents$2(e) {
  return (0, encodings_1$7.assertArray)(e).map(decodeEvent$2);
}
function decodeTxData$2(e) {
  return {
    code: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$7.may)(encoding_1$z.fromBase64, e.data),
    events: e.events ? decodeEvents$2(e.events) : [],
    gasWanted: (0, inthelpers_1$4.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$4.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$3(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$t.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$2(e) {
  return {
    maxBytes: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$2(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$2(e) {
  return {
    block: decodeBlockParams$2((0, encodings_1$7.assertObject)(e.block)),
    evidence: decodeEvidenceParams$2((0, encodings_1$7.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$2(e) {
  return {
    pubkey: decodePubkey$3((0, encodings_1$7.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$4.apiToBigInt)(e.power ?? "0")
  };
}
responses$4.decodeValidatorUpdate = decodeValidatorUpdate$2;
function decodeBlockResults$2(e) {
  return {
    height: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$2),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$2),
    consensusUpdates: (0, encodings_1$7.may)(decodeConsensusParams$2, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$2(e.begin_block_events || []),
    endBlockEvents: decodeEvents$2(e.end_block_events || [])
  };
}
function decodeBlockId$2(e) {
  return {
    hash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$7.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$2(e) {
  return {
    block: (0, inthelpers_1$4.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$4.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$2(e) {
  return {
    version: decodeBlockVersion$2(e.version),
    chainId: (0, encodings_1$7.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.height)),
    time: (0, dates_1$2.fromRfc3339WithNanoseconds)((0, encodings_1$7.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$2(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$2(e) {
  return {
    blockId: decodeBlockId$2(e.block_id),
    blockSize: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.block_size)),
    header: decodeHeader$2(e.header),
    numTxs: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$2(e) {
  return {
    lastHeight: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$7.assertArray)(e.block_metas).map(decodeBlockMeta$2)
  };
}
function decodeBroadcastTxSync$2(e) {
  return {
    ...decodeTxData$2(e),
    hash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$2(e) {
  return {
    height: (0, inthelpers_1$4.apiToSmallInt)(e.height),
    hash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$2((0, encodings_1$7.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1$7.may)(decodeTxData$2, e.deliver_tx)
  };
}
function decodeBlockIdFlag$2(e) {
  return (0, utils_1$t.assert)(e in types_1$5.BlockIdFlag), e;
}
function decodeOptionalTime$2(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1$2.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature$2(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$2(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$z.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime$2(e.timestamp),
    signature: e.signature ? (0, encoding_1$z.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$2(e) {
  return {
    blockId: decodeBlockId$2((0, encodings_1$7.assertObject)(e.block_id)),
    height: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$4.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$7.assertArray)(e.signatures).map(decodeCommitSignature$2)
  };
}
function decodeCommitResponse$2(e) {
  return {
    canonical: (0, encodings_1$7.assertBoolean)(e.canonical),
    header: decodeHeader$2(e.signed_header.header),
    commit: decodeCommit$2(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$2(e) {
  return {
    address: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$3((0, encodings_1$7.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$4.apiToBigInt)((0, encodings_1$7.assertNotEmpty)(e.power))
  };
}
responses$4.decodeValidatorGenesis = decodeValidatorGenesis$2;
function decodeGenesis$2(e) {
  return {
    genesisTime: (0, dates_1$2.fromRfc3339WithNanoseconds)((0, encodings_1$7.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$7.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$2(e.consensus_params),
    validators: e.validators ? (0, encodings_1$7.assertArray)(e.validators).map(decodeValidatorGenesis$2) : [],
    appHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$2(e) {
  return {
    pubkey: decodePubkey$3((0, encodings_1$7.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$4.apiToBigInt)((0, encodings_1$7.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$4.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$4.decodeValidatorInfo = decodeValidatorInfo$2;
function decodeNodeInfo$2(e) {
  return {
    id: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$7.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$7.assertNotEmpty)(e.network),
    version: (0, encodings_1$7.assertString)(e.version),
    channels: (0, encodings_1$7.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$7.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$7.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$2(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$4.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$2.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$z.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$z.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$2.fromRfc3339WithNanoseconds)((0, encodings_1$7.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$7.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$2(e) {
  return {
    nodeInfo: decodeNodeInfo$2(e.node_info),
    syncInfo: decodeSyncInfo$2(e.sync_info),
    validatorInfo: decodeValidatorInfo$2(e.validator_info)
  };
}
function decodeTxProof$2(e) {
  return {
    data: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$7.assertArray)(e.proof.aunts).map(encoding_1$z.fromBase64)
    }
  };
}
function decodeTxResponse$2(e) {
  return {
    tx: (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertNotEmpty)(e.tx)),
    result: decodeTxData$2((0, encodings_1$7.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNumber)(e.index)),
    hash: (0, encoding_1$z.fromHex)((0, encodings_1$7.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$7.may)(decodeTxProof$2, e.proof)
  };
}
function decodeTxSearch$2(e) {
  return {
    totalCount: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$7.assertArray)(e.txs).map(decodeTxResponse$2)
  };
}
function decodeTxEvent$2(e) {
  const n = (0, encoding_1$z.fromBase64)((0, encodings_1$7.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$3.hashTx)(n),
    result: decodeTxData$2(e.result),
    height: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.height))
  };
}
function decodeValidators$2(e) {
  return {
    blockHeight: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$7.assertArray)(e.validators).map(decodeValidatorInfo$2),
    count: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.total))
  };
}
function decodeBlock$2(e) {
  var n;
  return {
    header: decodeHeader$2((0, encodings_1$7.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$2((0, encodings_1$7.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$7.assertArray)(e.data.txs).map(encoding_1$z.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$2(e) {
  return {
    blockId: decodeBlockId$2(e.block_id),
    block: decodeBlock$2(e.block)
  };
}
function decodeBlockSearch$2(e) {
  return {
    totalCount: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$7.assertArray)(e.blocks).map(decodeBlockResponse$2)
  };
}
function decodeNumUnconfirmedTxs$2(e) {
  return {
    total: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$4.apiToSmallInt)((0, encodings_1$7.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$2 = class md {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$2((0, encodings_1$7.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$2((0, encodings_1$7.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$2(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$2(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$2(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$2(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$2(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return md.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$2(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$2(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$2((0, encodings_1$7.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$2(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$2(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$2(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$2(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$2(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$2(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$2(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$2(n.result);
  }
};
responses$4.Responses = Responses$2;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$a;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$4;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$2);
var __createBinding$p = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$p = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$p = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$p(n, e, o);
  return __setModuleDefault$p(n, e), n;
};
Object.defineProperty(tendermint34client$1, "__esModule", { value: !0 });
tendermint34client$1.Tendermint34Client = void 0;
const jsonrpc_1$4 = jsonrpc$1, rpcclients_1$2 = rpcclients$1, adaptor_1$2 = adaptor$2, requests$8 = __importStar$p(requests$b);
let Tendermint34Client$1 = class tc {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$2.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$2.HttpClient(n) : new rpcclients_1$2.WebsocketClient(n), await this.detectVersion(o), tc.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new tc(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$4.createJsonRpcRequest)(requests$8.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$8.Method.AbciInfo };
    return this.doCall(n, adaptor_1$2.Params.encodeAbciInfo, adaptor_1$2.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$8.Method.AbciQuery };
    return this.doCall(o, adaptor_1$2.Params.encodeAbciQuery, adaptor_1$2.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$8.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$2.Params.encodeBlock, adaptor_1$2.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$8.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$2.Params.encodeBlockResults, adaptor_1$2.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$8.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$2.Params.encodeBlockSearch, adaptor_1$2.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$8.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$2.Params.encodeBlockchain, adaptor_1$2.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$8.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$2.Params.encodeBroadcastTx, adaptor_1$2.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$8.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$2.Params.encodeBroadcastTx, adaptor_1$2.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$8.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$2.Params.encodeBroadcastTx, adaptor_1$2.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$8.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$2.Params.encodeCommit, adaptor_1$2.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$8.Method.Genesis };
    return this.doCall(n, adaptor_1$2.Params.encodeGenesis, adaptor_1$2.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$8.Method.Health };
    return this.doCall(n, adaptor_1$2.Params.encodeHealth, adaptor_1$2.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$8.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$2.Params.encodeNumUnconfirmedTxs, adaptor_1$2.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$8.Method.Status };
    return this.doCall(n, adaptor_1$2.Params.encodeStatus, adaptor_1$2.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$8.Method.Subscribe,
      query: { type: requests$8.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$2.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$8.Method.Subscribe,
      query: { type: requests$8.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$2.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$8.Method.Subscribe,
      query: {
        type: requests$8.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$2.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$8.Method.Tx };
    return this.doCall(o, adaptor_1$2.Params.encodeTx, adaptor_1$2.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$8.Method.TxSearch };
    return this.doCall(o, adaptor_1$2.Params.encodeTxSearch, adaptor_1$2.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$8.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$2.Params.encodeValidators, adaptor_1$2.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$2.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$2.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
};
tendermint34client$1.Tendermint34Client = Tendermint34Client$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint34Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var n = requests$b;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return n.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return n.SubscriptionEventType;
  } });
  var o = responses$5;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return o.VoteType;
  } });
  var u = tendermint34client$1;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return u.Tendermint34Client;
  } });
})(tendermint34$1);
var tendermint37 = {}, requests$7 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$7);
var responses$3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$3);
var tendermint37client = {}, adaptor$1 = {}, requests$6 = {}, encodings$1 = {};
Object.defineProperty(encodings$1, "__esModule", { value: !0 });
encodings$1.encodeBlockId = encodings$1.encodeVersion = encodings$1.encodeBytes = encodings$1.encodeTime = encodings$1.encodeUvarint = encodings$1.encodeString = encodings$1.dictionaryToStringMap = encodings$1.may = encodings$1.assertNotEmpty = encodings$1.assertObject = encodings$1.assertArray = encodings$1.assertNumber = encodings$1.assertString = encodings$1.assertBoolean = encodings$1.assertSet = void 0;
const encoding_1$y = build$n;
function assertSet$1(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings$1.assertSet = assertSet$1;
function assertBoolean$1(e) {
  if (assertSet$1(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings$1.assertBoolean = assertBoolean$1;
function assertString$1(e) {
  if (assertSet$1(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings$1.assertString = assertString$1;
function assertNumber$1(e) {
  if (assertSet$1(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings$1.assertNumber = assertNumber$1;
function assertArray$1(e) {
  if (assertSet$1(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings$1.assertArray = assertArray$1;
function assertObject$1(e) {
  if (assertSet$1(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings$1.assertObject = assertObject$1;
function assertNotEmpty$1(e) {
  if (assertSet$1(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings$1.assertNotEmpty = assertNotEmpty$1;
function may$1(e, n) {
  return n == null ? void 0 : e(n);
}
encodings$1.may = may$1;
function dictionaryToStringMap$1(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings$1.dictionaryToStringMap = dictionaryToStringMap$1;
function encodeString$1(e) {
  const n = (0, encoding_1$y.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings$1.encodeString = encodeString$1;
function encodeUvarint$2(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint$2(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings$1.encodeUvarint = encodeUvarint$2;
function encodeTime$1(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint$2(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint$2(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings$1.encodeTime = encodeTime$1;
function encodeBytes$1(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings$1.encodeBytes = encodeBytes$1;
function encodeVersion$1(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint$2(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint$2(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings$1.encodeVersion = encodeVersion$1;
function encodeBlockId$1(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings$1.encodeBlockId = encodeBlockId$1;
var __createBinding$o = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$o = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$o(n, e, o);
  return __setModuleDefault$o(n, e), n;
};
Object.defineProperty(requests$6, "__esModule", { value: !0 });
requests$6.Params = void 0;
const encoding_1$x = build$n, inthelpers_1$3 = inthelpers$1, jsonrpc_1$3 = jsonrpc$1, encodings_1$6 = encodings$1, requests$5 = __importStar$o(requests$7);
function encodeHeightParam$1(e) {
  return {
    height: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams$1(e) {
  return {
    minHeight: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams$1(e) {
  return {
    query: e.query,
    page: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.page),
    per_page: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams$1(e) {
  return {
    path: (0, encodings_1$6.assertNotEmpty)(e.path),
    data: (0, encoding_1$x.toHex)(e.data),
    height: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams$1(e) {
  return {
    tx: (0, encoding_1$x.toBase64)((0, encodings_1$6.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams$1(e) {
  return {
    hash: (0, encoding_1$x.toBase64)((0, encodings_1$6.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams$1(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.page),
    per_page: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams$1(e) {
  return {
    height: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.height),
    page: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.page),
    per_page: (0, encodings_1$6.may)(inthelpers_1$3.smallIntToApi, e.per_page)
  };
}
let Params$o = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeAbciQueryParams$1(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeHeightParam$1(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams$1(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeHeightParam$1(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeBlockSearchParams$1(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeBroadcastTxParams$1(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeHeightParam$1(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$5.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$3.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeTxParams$1(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeTxSearchParams$1(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$3.createJsonRpcRequest)(n.method, encodeValidatorsParams$1(n.params));
  }
};
requests$6.Params = Params$o;
var responses$2 = {}, hasher$1 = {};
Object.defineProperty(hasher$1, "__esModule", { value: !0 });
hasher$1.hashBlock = hasher$1.hashTx = void 0;
const crypto_1$c = build$k, encodings_1$5 = encodings$1;
function hashTx$1(e) {
  return (0, crypto_1$c.sha256)(e);
}
hasher$1.hashTx = hashTx$1;
function getSplitPoint$1(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf$1(e) {
  const n = new crypto_1$c.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner$1(e, n) {
  const o = new crypto_1$c.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree$1(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf$1(e[0]);
    default: {
      const n = getSplitPoint$1(e.length), o = hashTree$1(e.slice(0, n)), u = hashTree$1(e.slice(n));
      return hashInner$1(o, u);
    }
  }
}
function hashBlock$1(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$5.encodeVersion)(e.version),
    (0, encodings_1$5.encodeString)(e.chainId),
    (0, encodings_1$5.encodeUvarint)(e.height),
    (0, encodings_1$5.encodeTime)(e.time),
    (0, encodings_1$5.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$5.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$5.encodeBytes)(e.dataHash),
    (0, encodings_1$5.encodeBytes)(e.validatorsHash),
    (0, encodings_1$5.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$5.encodeBytes)(e.consensusHash),
    (0, encodings_1$5.encodeBytes)(e.appHash),
    (0, encodings_1$5.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$5.encodeBytes)(e.evidenceHash),
    (0, encodings_1$5.encodeBytes)(e.proposerAddress)
  ];
  return hashTree$1(n);
}
hasher$1.hashBlock = hashBlock$1;
Object.defineProperty(responses$2, "__esModule", { value: !0 });
responses$2.Responses = responses$2.decodeValidatorInfo = responses$2.decodeValidatorGenesis = responses$2.decodeValidatorUpdate = responses$2.decodeEvent = void 0;
const encoding_1$w = build$n, utils_1$s = build$j, dates_1$1 = dates$1, inthelpers_1$2 = inthelpers$1, types_1$4 = types$6, encodings_1$4 = encodings$1, hasher_1$2 = hasher$1;
function decodeAbciInfo$1(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1$4.may)(inthelpers_1$2.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1$4.may)(encoding_1$w.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof$1(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$w.fromBase64)(n.key),
      data: (0, encoding_1$w.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery$1(e) {
  return {
    key: (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertString)(e.key ?? "")),
    value: (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertString)(e.value ?? "")),
    proof: (0, encodings_1$4.may)(decodeQueryProof$1, e.proofOps),
    height: (0, encodings_1$4.may)(inthelpers_1$2.apiToSmallInt, e.height),
    code: (0, encodings_1$4.may)(inthelpers_1$2.apiToSmallInt, e.code),
    codespace: (0, encodings_1$4.assertString)(e.codespace ?? ""),
    index: (0, encodings_1$4.may)(inthelpers_1$2.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1$4.assertString)(e.info ?? "")
  };
}
function decodeEventAttribute(e) {
  return {
    key: (0, encodings_1$4.assertNotEmpty)(e.key),
    value: e.value ?? ""
  };
}
function decodeAttributes$1(e) {
  return (0, encodings_1$4.assertArray)(e).map(decodeEventAttribute);
}
function decodeEvent$1(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes$1(e.attributes) : []
  };
}
responses$2.decodeEvent = decodeEvent$1;
function decodeEvents$1(e) {
  return (0, encodings_1$4.assertArray)(e).map(decodeEvent$1);
}
function decodeTxData$1(e) {
  return {
    code: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNumber)(e.code ?? 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1$4.may)(encoding_1$w.fromBase64, e.data),
    events: e.events ? decodeEvents$1(e.events) : [],
    gasWanted: (0, inthelpers_1$2.apiToBigInt)(e.gas_wanted ?? "0"),
    gasUsed: (0, inthelpers_1$2.apiToBigInt)(e.gas_used ?? "0")
  };
}
function decodePubkey$2(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$s.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams$1(e) {
  return {
    maxBytes: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams$1(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams$1(e) {
  return {
    block: decodeBlockParams$1((0, encodings_1$4.assertObject)(e.block)),
    evidence: decodeEvidenceParams$1((0, encodings_1$4.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate$1(e) {
  return {
    pubkey: decodePubkey$2((0, encodings_1$4.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$2.apiToBigInt)(e.power ?? "0")
  };
}
responses$2.decodeValidatorUpdate = decodeValidatorUpdate$1;
function decodeBlockResults$1(e) {
  return {
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData$1),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate$1),
    consensusUpdates: (0, encodings_1$4.may)(decodeConsensusParams$1, e.consensus_param_updates),
    beginBlockEvents: decodeEvents$1(e.begin_block_events || []),
    endBlockEvents: decodeEvents$1(e.end_block_events || [])
  };
}
function decodeBlockId$1(e) {
  return {
    hash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1$4.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion$1(e) {
  return {
    block: (0, inthelpers_1$2.apiToSmallInt)(e.block),
    app: (0, inthelpers_1$2.apiToSmallInt)(e.app ?? 0)
  };
}
function decodeHeader$1(e) {
  return {
    version: decodeBlockVersion$1(e.version),
    chainId: (0, encodings_1$4.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.height)),
    time: (0, dates_1$1.fromRfc3339WithNanoseconds)((0, encodings_1$4.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId$1(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta$1(e) {
  return {
    blockId: decodeBlockId$1(e.block_id),
    blockSize: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.block_size)),
    header: decodeHeader$1(e.header),
    numTxs: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain$1(e) {
  return {
    lastHeight: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1$4.assertArray)(e.block_metas).map(decodeBlockMeta$1)
  };
}
function decodeBroadcastTxSync$1(e) {
  return {
    ...decodeTxData$1(e),
    hash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit$1(e) {
  return {
    height: (0, inthelpers_1$2.apiToSmallInt)(e.height),
    hash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData$1((0, encodings_1$4.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1$4.may)(decodeTxData$1, e.deliver_tx)
  };
}
function decodeBlockIdFlag$1(e) {
  return (0, utils_1$s.assert)(e in types_1$4.BlockIdFlag), e;
}
function decodeOptionalTime$1(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1$1.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature$1(e) {
  return {
    blockIdFlag: decodeBlockIdFlag$1(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$w.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime$1(e.timestamp),
    signature: e.signature ? (0, encoding_1$w.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit$1(e) {
  return {
    blockId: decodeBlockId$1((0, encodings_1$4.assertObject)(e.block_id)),
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1$2.apiToSmallInt)(e.round),
    signatures: (0, encodings_1$4.assertArray)(e.signatures).map(decodeCommitSignature$1)
  };
}
function decodeCommitResponse$1(e) {
  return {
    canonical: (0, encodings_1$4.assertBoolean)(e.canonical),
    header: decodeHeader$1(e.signed_header.header),
    commit: decodeCommit$1(e.signed_header.commit)
  };
}
function decodeValidatorGenesis$1(e) {
  return {
    address: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.address)),
    pubkey: decodePubkey$2((0, encodings_1$4.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$2.apiToBigInt)((0, encodings_1$4.assertNotEmpty)(e.power))
  };
}
responses$2.decodeValidatorGenesis = decodeValidatorGenesis$1;
function decodeGenesis$1(e) {
  return {
    genesisTime: (0, dates_1$1.fromRfc3339WithNanoseconds)((0, encodings_1$4.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1$4.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams$1(e.consensus_params),
    validators: e.validators ? (0, encodings_1$4.assertArray)(e.validators).map(decodeValidatorGenesis$1) : [],
    appHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo$1(e) {
  return {
    pubkey: decodePubkey$2((0, encodings_1$4.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1$2.apiToBigInt)((0, encodings_1$4.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1$2.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses$2.decodeValidatorInfo = decodeValidatorInfo$1;
function decodeNodeInfo$1(e) {
  return {
    id: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1$4.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1$4.assertNotEmpty)(e.network),
    version: (0, encodings_1$4.assertString)(e.version),
    channels: (0, encodings_1$4.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1$4.assertNotEmpty)(e.moniker),
    other: (0, encodings_1$4.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo$1(e) {
  const n = e.earliest_block_height ? (0, inthelpers_1$2.apiToSmallInt)(e.earliest_block_height) : void 0, o = e.earliest_block_time ? (0, dates_1$1.fromRfc3339WithNanoseconds)(e.earliest_block_time) : void 0;
  return {
    earliestAppHash: e.earliest_app_hash ? (0, encoding_1$w.fromHex)(e.earliest_app_hash) : void 0,
    earliestBlockHash: e.earliest_block_hash ? (0, encoding_1$w.fromHex)(e.earliest_block_hash) : void 0,
    earliestBlockHeight: n || void 0,
    earliestBlockTime: o != null && o.getTime() ? o : void 0,
    latestBlockHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1$1.fromRfc3339WithNanoseconds)((0, encodings_1$4.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1$4.assertBoolean)(e.catching_up)
  };
}
function decodeStatus$1(e) {
  return {
    nodeInfo: decodeNodeInfo$1(e.node_info),
    syncInfo: decodeSyncInfo$1(e.sync_info),
    validatorInfo: decodeValidatorInfo$1(e.validator_info)
  };
}
function decodeTxProof$1(e) {
  return {
    data: (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1$4.assertArray)(e.proof.aunts).map(encoding_1$w.fromBase64)
    }
  };
}
function decodeTxResponse$1(e) {
  return {
    tx: (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertNotEmpty)(e.tx)),
    result: decodeTxData$1((0, encodings_1$4.assertObject)(e.tx_result)),
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNumber)(e.index)),
    hash: (0, encoding_1$w.fromHex)((0, encodings_1$4.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1$4.may)(decodeTxProof$1, e.proof)
  };
}
function decodeTxSearch$1(e) {
  return {
    totalCount: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1$4.assertArray)(e.txs).map(decodeTxResponse$1)
  };
}
function decodeTxEvent$1(e) {
  const n = (0, encoding_1$w.fromBase64)((0, encodings_1$4.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$2.hashTx)(n),
    result: decodeTxData$1(e.result),
    height: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.height))
  };
}
function decodeValidators$1(e) {
  return {
    blockHeight: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1$4.assertArray)(e.validators).map(decodeValidatorInfo$1),
    count: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.total))
  };
}
function decodeBlock$1(e) {
  var n;
  return {
    header: decodeHeader$1((0, encodings_1$4.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit$1((0, encodings_1$4.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1$4.assertArray)(e.data.txs).map(encoding_1$w.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: ((n = e.evidence) == null ? void 0 : n.evidence) ?? []
  };
}
function decodeBlockResponse$1(e) {
  return {
    blockId: decodeBlockId$1(e.block_id),
    block: decodeBlock$1(e.block)
  };
}
function decodeBlockSearch$1(e) {
  return {
    totalCount: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1$4.assertArray)(e.blocks).map(decodeBlockResponse$1)
  };
}
function decodeNumUnconfirmedTxs$1(e) {
  return {
    total: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1$2.apiToSmallInt)((0, encodings_1$4.assertNotEmpty)(e.total_bytes))
  };
}
let Responses$1 = class gd {
  static decodeAbciInfo(n) {
    return decodeAbciInfo$1((0, encodings_1$4.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery$1((0, encodings_1$4.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse$1(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults$1(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch$1(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain$1(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync$1(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return gd.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit$1(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse$1(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis$1((0, encodings_1$4.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs$1(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus$1(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock$1(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader$1(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent$1(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse$1(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch$1(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators$1(n.result);
  }
};
responses$2.Responses = Responses$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Responses = e.Params = void 0;
  var n = requests$6;
  Object.defineProperty(e, "Params", { enumerable: !0, get: function() {
    return n.Params;
  } });
  var o = responses$2;
  Object.defineProperty(e, "Responses", { enumerable: !0, get: function() {
    return o.Responses;
  } });
})(adaptor$1);
var __createBinding$n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$n = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$n = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$n(n, e, o);
  return __setModuleDefault$n(n, e), n;
};
Object.defineProperty(tendermint37client, "__esModule", { value: !0 });
tendermint37client.Tendermint37Client = void 0;
const jsonrpc_1$2 = jsonrpc$1, rpcclients_1$1 = rpcclients$1, adaptor_1$1 = adaptor$1, requests$4 = __importStar$n(requests$7);
class Tendermint37Client {
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    let o;
    return typeof n == "object" ? o = new rpcclients_1$1.HttpClient(n) : o = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1$1.HttpClient(n) : new rpcclients_1$1.WebsocketClient(n), await this.detectVersion(o), Tendermint37Client.create(o);
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return new Tendermint37Client(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1$2.createJsonRpcRequest)(requests$4.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  /**
   * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests$4.Method.AbciInfo };
    return this.doCall(n, adaptor_1$1.Params.encodeAbciInfo, adaptor_1$1.Responses.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests$4.Method.AbciQuery };
    return this.doCall(o, adaptor_1$1.Params.encodeAbciQuery, adaptor_1$1.Responses.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests$4.Method.Block, params: { height: n } };
    return this.doCall(o, adaptor_1$1.Params.encodeBlock, adaptor_1$1.Responses.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests$4.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, adaptor_1$1.Params.encodeBlockResults, adaptor_1$1.Responses.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests$4.Method.BlockSearch }, u = await this.doCall(o, adaptor_1$1.Params.encodeBlockSearch, adaptor_1$1.Responses.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests$4.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, adaptor_1$1.Params.encodeBlockchain, adaptor_1$1.Responses.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests$4.Method.BroadcastTxSync };
    return this.doCall(o, adaptor_1$1.Params.encodeBroadcastTx, adaptor_1$1.Responses.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests$4.Method.BroadcastTxAsync };
    return this.doCall(o, adaptor_1$1.Params.encodeBroadcastTx, adaptor_1$1.Responses.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests$4.Method.BroadcastTxCommit };
    return this.doCall(o, adaptor_1$1.Params.encodeBroadcastTx, adaptor_1$1.Responses.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests$4.Method.Commit, params: { height: n } };
    return this.doCall(o, adaptor_1$1.Params.encodeCommit, adaptor_1$1.Responses.decodeCommit);
  }
  async genesis() {
    const n = { method: requests$4.Method.Genesis };
    return this.doCall(n, adaptor_1$1.Params.encodeGenesis, adaptor_1$1.Responses.decodeGenesis);
  }
  async health() {
    const n = { method: requests$4.Method.Health };
    return this.doCall(n, adaptor_1$1.Params.encodeHealth, adaptor_1$1.Responses.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests$4.Method.NumUnconfirmedTxs };
    return this.doCall(n, adaptor_1$1.Params.encodeNumUnconfirmedTxs, adaptor_1$1.Responses.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests$4.Method.Status };
    return this.doCall(n, adaptor_1$1.Params.encodeStatus, adaptor_1$1.Responses.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests$4.Method.Subscribe,
      query: { type: requests$4.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, adaptor_1$1.Responses.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests$4.Method.Subscribe,
      query: { type: requests$4.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, adaptor_1$1.Responses.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests$4.Method.Subscribe,
      query: {
        type: requests$4.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, adaptor_1$1.Responses.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests$4.Method.Tx };
    return this.doCall(o, adaptor_1$1.Params.encodeTx, adaptor_1$1.Responses.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests$4.Method.TxSearch };
    return this.doCall(o, adaptor_1$1.Params.encodeTxSearch, adaptor_1$1.Responses.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests$4.Method.Validators,
      params: n
    };
    return this.doCall(o, adaptor_1$1.Params.encodeValidators, adaptor_1$1.Responses.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1$1.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = adaptor_1$1.Params.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
}
tendermint37client.Tendermint37Client = Tendermint37Client;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint37Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var n = requests$7;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return n.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return n.SubscriptionEventType;
  } });
  var o = responses$3;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return o.VoteType;
  } });
  var u = tendermint37client;
  Object.defineProperty(e, "Tendermint37Client", { enumerable: !0, get: function() {
    return u.Tendermint37Client;
  } });
})(tendermint37);
var tendermintclient = {};
Object.defineProperty(tendermintclient, "__esModule", { value: !0 });
tendermintclient.connectComet = tendermintclient.isComet38Client = tendermintclient.isTendermint37Client = tendermintclient.isTendermint34Client = void 0;
const comet38_1 = comet38, tendermint34_1 = tendermint34$1, tendermint37_1 = tendermint37;
function isTendermint34Client(e) {
  return e instanceof tendermint34_1.Tendermint34Client;
}
tendermintclient.isTendermint34Client = isTendermint34Client;
function isTendermint37Client(e) {
  return e instanceof tendermint37_1.Tendermint37Client;
}
tendermintclient.isTendermint37Client = isTendermint37Client;
function isComet38Client(e) {
  return e instanceof comet38_1.Comet38Client;
}
tendermintclient.isComet38Client = isComet38Client;
async function connectComet(e) {
  let n;
  const o = await tendermint37_1.Tendermint37Client.connect(e), u = (await o.status()).nodeInfo.version;
  return u.startsWith("0.37.") ? n = o : u.startsWith("0.38.") ? (o.disconnect(), n = await comet38_1.Comet38Client.connect(e)) : (o.disconnect(), n = await tendermint34_1.Tendermint34Client.connect(e)), n;
}
tendermintclient.connectComet = connectComet;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(y, V, M, G) {
    G === void 0 && (G = M);
    var k = Object.getOwnPropertyDescriptor(V, M);
    (!k || ("get" in k ? !V.__esModule : k.writable || k.configurable)) && (k = { enumerable: !0, get: function() {
      return V[M];
    } }), Object.defineProperty(y, G, k);
  } : function(y, V, M, G) {
    G === void 0 && (G = M), y[G] = V[M];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(y, V) {
    Object.defineProperty(y, "default", { enumerable: !0, value: V });
  } : function(y, V) {
    y.default = V;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(y) {
    if (y && y.__esModule)
      return y;
    var V = {};
    if (y != null)
      for (var M in y)
        M !== "default" && Object.prototype.hasOwnProperty.call(y, M) && n(V, y, M);
    return o(V, y), V;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = e.isTendermint37Client = e.isTendermint34Client = e.isComet38Client = e.connectComet = e.Tendermint37Client = e.tendermint37 = e.Tendermint34Client = e.tendermint34 = e.VoteType = e.SubscriptionEventType = e.Method = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.WebsocketClient = e.HttpClient = e.HttpBatchClient = e.Comet38Client = e.comet38 = e.toSeconds = e.toRfc3339WithNanoseconds = e.fromSeconds = e.fromRfc3339WithNanoseconds = e.DateTime = e.rawSecp256k1PubkeyToRawAddress = e.rawEd25519PubkeyToRawAddress = e.pubkeyToRawAddress = e.pubkeyToAddress = void 0;
  var c = addresses$2;
  Object.defineProperty(e, "pubkeyToAddress", { enumerable: !0, get: function() {
    return c.pubkeyToAddress;
  } }), Object.defineProperty(e, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.pubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.rawSecp256k1PubkeyToRawAddress;
  } });
  var d = dates$1;
  Object.defineProperty(e, "DateTime", { enumerable: !0, get: function() {
    return d.DateTime;
  } }), Object.defineProperty(e, "fromRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return d.fromRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "fromSeconds", { enumerable: !0, get: function() {
    return d.fromSeconds;
  } }), Object.defineProperty(e, "toRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return d.toRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "toSeconds", { enumerable: !0, get: function() {
    return d.toSeconds;
  } }), e.comet38 = u(comet38);
  var m = comet38;
  Object.defineProperty(e, "Comet38Client", { enumerable: !0, get: function() {
    return m.Comet38Client;
  } });
  var v = rpcclients$1;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return v.HttpBatchClient;
  } }), Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return v.HttpClient;
  } }), Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return v.WebsocketClient;
  } });
  var S = tendermint34$1;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return S.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return S.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return S.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return S.SubscriptionEventType;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return S.VoteType;
  } }), e.tendermint34 = u(tendermint34$1);
  var $ = tendermint34$1;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return $.Tendermint34Client;
  } }), e.tendermint37 = u(tendermint37);
  var E = tendermint37;
  Object.defineProperty(e, "Tendermint37Client", { enumerable: !0, get: function() {
    return E.Tendermint37Client;
  } });
  var O = tendermintclient;
  Object.defineProperty(e, "connectComet", { enumerable: !0, get: function() {
    return O.connectComet;
  } }), Object.defineProperty(e, "isComet38Client", { enumerable: !0, get: function() {
    return O.isComet38Client;
  } }), Object.defineProperty(e, "isTendermint34Client", { enumerable: !0, get: function() {
    return O.isTendermint34Client;
  } }), Object.defineProperty(e, "isTendermint37Client", { enumerable: !0, get: function() {
    return O.isTendermint37Client;
  } });
  var T = types$6;
  Object.defineProperty(e, "BlockIdFlag", { enumerable: !0, get: function() {
    return T.BlockIdFlag;
  } });
})(build$l);
var types$5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Model = e.AbsoluteTxPosition = e.ContractCodeHistoryEntry = e.ContractInfo = e.CodeInfo = e.Params = e.AccessConfig = e.AccessTypeParam = e.contractCodeHistoryOperationTypeToJSON = e.contractCodeHistoryOperationTypeFromJSON = e.ContractCodeHistoryOperationType = e.accessTypeToJSON = e.accessTypeFromJSON = e.AccessType = e.protobufPackage = void 0;
  const n = any$1, o = binary, u = helpers;
  e.protobufPackage = "cosmwasm.wasm.v1";
  var c;
  (function(F) {
    F[F.ACCESS_TYPE_UNSPECIFIED = 0] = "ACCESS_TYPE_UNSPECIFIED", F[F.ACCESS_TYPE_NOBODY = 1] = "ACCESS_TYPE_NOBODY", F[F.ACCESS_TYPE_ONLY_ADDRESS = 2] = "ACCESS_TYPE_ONLY_ADDRESS", F[F.ACCESS_TYPE_EVERYBODY = 3] = "ACCESS_TYPE_EVERYBODY", F[F.ACCESS_TYPE_ANY_OF_ADDRESSES = 4] = "ACCESS_TYPE_ANY_OF_ADDRESSES", F[F.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(c || (e.AccessType = c = {}));
  function d(F) {
    switch (F) {
      case 0:
      case "ACCESS_TYPE_UNSPECIFIED":
        return c.ACCESS_TYPE_UNSPECIFIED;
      case 1:
      case "ACCESS_TYPE_NOBODY":
        return c.ACCESS_TYPE_NOBODY;
      case 2:
      case "ACCESS_TYPE_ONLY_ADDRESS":
        return c.ACCESS_TYPE_ONLY_ADDRESS;
      case 3:
      case "ACCESS_TYPE_EVERYBODY":
        return c.ACCESS_TYPE_EVERYBODY;
      case 4:
      case "ACCESS_TYPE_ANY_OF_ADDRESSES":
        return c.ACCESS_TYPE_ANY_OF_ADDRESSES;
      case -1:
      case "UNRECOGNIZED":
      default:
        return c.UNRECOGNIZED;
    }
  }
  e.accessTypeFromJSON = d;
  function m(F) {
    switch (F) {
      case c.ACCESS_TYPE_UNSPECIFIED:
        return "ACCESS_TYPE_UNSPECIFIED";
      case c.ACCESS_TYPE_NOBODY:
        return "ACCESS_TYPE_NOBODY";
      case c.ACCESS_TYPE_ONLY_ADDRESS:
        return "ACCESS_TYPE_ONLY_ADDRESS";
      case c.ACCESS_TYPE_EVERYBODY:
        return "ACCESS_TYPE_EVERYBODY";
      case c.ACCESS_TYPE_ANY_OF_ADDRESSES:
        return "ACCESS_TYPE_ANY_OF_ADDRESSES";
      case c.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.accessTypeToJSON = m;
  var v;
  (function(F) {
    F[F.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED", F[F.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT", F[F.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE", F[F.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS", F[F.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(v || (e.ContractCodeHistoryOperationType = v = {}));
  function S(F) {
    switch (F) {
      case 0:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
        return v.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
      case 1:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
        return v.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
      case 2:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
        return v.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
      case 3:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
        return v.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
      case -1:
      case "UNRECOGNIZED":
      default:
        return v.UNRECOGNIZED;
    }
  }
  e.contractCodeHistoryOperationTypeFromJSON = S;
  function $(F) {
    switch (F) {
      case v.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
      case v.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
      case v.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
      case v.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
      case v.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  e.contractCodeHistoryOperationTypeToJSON = $;
  function E() {
    return {
      value: 0
    };
  }
  e.AccessTypeParam = {
    typeUrl: "/cosmwasm.wasm.v1.AccessTypeParam",
    encode(F, X = o.BinaryWriter.create()) {
      return F.value !== 0 && X.uint32(8).int32(F.value), X;
    },
    decode(F, X) {
      const ee = F instanceof o.BinaryReader ? F : new o.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = E();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.value = ee.int32();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = E();
      return (0, u.isSet)(F.value) && (X.value = d(F.value)), X;
    },
    toJSON(F) {
      const X = {};
      return F.value !== void 0 && (X.value = m(F.value)), X;
    },
    fromPartial(F) {
      const X = E();
      return X.value = F.value ?? 0, X;
    }
  };
  function O() {
    return {
      permission: 0,
      address: "",
      addresses: []
    };
  }
  e.AccessConfig = {
    typeUrl: "/cosmwasm.wasm.v1.AccessConfig",
    encode(F, X = o.BinaryWriter.create()) {
      F.permission !== 0 && X.uint32(8).int32(F.permission), F.address !== "" && X.uint32(18).string(F.address);
      for (const ee of F.addresses)
        X.uint32(26).string(ee);
      return X;
    },
    decode(F, X) {
      const ee = F instanceof o.BinaryReader ? F : new o.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = O();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.permission = ee.int32();
            break;
          case 2:
            Q.address = ee.string();
            break;
          case 3:
            Q.addresses.push(ee.string());
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = O();
      return (0, u.isSet)(F.permission) && (X.permission = d(F.permission)), (0, u.isSet)(F.address) && (X.address = String(F.address)), Array.isArray(F == null ? void 0 : F.addresses) && (X.addresses = F.addresses.map((ee) => String(ee))), X;
    },
    toJSON(F) {
      const X = {};
      return F.permission !== void 0 && (X.permission = m(F.permission)), F.address !== void 0 && (X.address = F.address), F.addresses ? X.addresses = F.addresses.map((ee) => ee) : X.addresses = [], X;
    },
    fromPartial(F) {
      var ee;
      const X = O();
      return X.permission = F.permission ?? 0, X.address = F.address ?? "", X.addresses = ((ee = F.addresses) == null ? void 0 : ee.map((ue) => ue)) || [], X;
    }
  };
  function T() {
    return {
      codeUploadAccess: e.AccessConfig.fromPartial({}),
      instantiateDefaultPermission: 0
    };
  }
  e.Params = {
    typeUrl: "/cosmwasm.wasm.v1.Params",
    encode(F, X = o.BinaryWriter.create()) {
      return F.codeUploadAccess !== void 0 && e.AccessConfig.encode(F.codeUploadAccess, X.uint32(10).fork()).ldelim(), F.instantiateDefaultPermission !== 0 && X.uint32(16).int32(F.instantiateDefaultPermission), X;
    },
    decode(F, X) {
      const ee = F instanceof o.BinaryReader ? F : new o.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = T();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.codeUploadAccess = e.AccessConfig.decode(ee, ee.uint32());
            break;
          case 2:
            Q.instantiateDefaultPermission = ee.int32();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = T();
      return (0, u.isSet)(F.codeUploadAccess) && (X.codeUploadAccess = e.AccessConfig.fromJSON(F.codeUploadAccess)), (0, u.isSet)(F.instantiateDefaultPermission) && (X.instantiateDefaultPermission = d(F.instantiateDefaultPermission)), X;
    },
    toJSON(F) {
      const X = {};
      return F.codeUploadAccess !== void 0 && (X.codeUploadAccess = F.codeUploadAccess ? e.AccessConfig.toJSON(F.codeUploadAccess) : void 0), F.instantiateDefaultPermission !== void 0 && (X.instantiateDefaultPermission = m(F.instantiateDefaultPermission)), X;
    },
    fromPartial(F) {
      const X = T();
      return F.codeUploadAccess !== void 0 && F.codeUploadAccess !== null && (X.codeUploadAccess = e.AccessConfig.fromPartial(F.codeUploadAccess)), X.instantiateDefaultPermission = F.instantiateDefaultPermission ?? 0, X;
    }
  };
  function y() {
    return {
      codeHash: new Uint8Array(),
      creator: "",
      instantiateConfig: e.AccessConfig.fromPartial({})
    };
  }
  e.CodeInfo = {
    typeUrl: "/cosmwasm.wasm.v1.CodeInfo",
    encode(F, X = o.BinaryWriter.create()) {
      return F.codeHash.length !== 0 && X.uint32(10).bytes(F.codeHash), F.creator !== "" && X.uint32(18).string(F.creator), F.instantiateConfig !== void 0 && e.AccessConfig.encode(F.instantiateConfig, X.uint32(42).fork()).ldelim(), X;
    },
    decode(F, X) {
      const ee = F instanceof o.BinaryReader ? F : new o.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = y();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.codeHash = ee.bytes();
            break;
          case 2:
            Q.creator = ee.string();
            break;
          case 5:
            Q.instantiateConfig = e.AccessConfig.decode(ee, ee.uint32());
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = y();
      return (0, u.isSet)(F.codeHash) && (X.codeHash = (0, u.bytesFromBase64)(F.codeHash)), (0, u.isSet)(F.creator) && (X.creator = String(F.creator)), (0, u.isSet)(F.instantiateConfig) && (X.instantiateConfig = e.AccessConfig.fromJSON(F.instantiateConfig)), X;
    },
    toJSON(F) {
      const X = {};
      return F.codeHash !== void 0 && (X.codeHash = (0, u.base64FromBytes)(F.codeHash !== void 0 ? F.codeHash : new Uint8Array())), F.creator !== void 0 && (X.creator = F.creator), F.instantiateConfig !== void 0 && (X.instantiateConfig = F.instantiateConfig ? e.AccessConfig.toJSON(F.instantiateConfig) : void 0), X;
    },
    fromPartial(F) {
      const X = y();
      return X.codeHash = F.codeHash ?? new Uint8Array(), X.creator = F.creator ?? "", F.instantiateConfig !== void 0 && F.instantiateConfig !== null && (X.instantiateConfig = e.AccessConfig.fromPartial(F.instantiateConfig)), X;
    }
  };
  function V() {
    return {
      codeId: BigInt(0),
      creator: "",
      admin: "",
      label: "",
      created: void 0,
      ibcPortId: "",
      extension: void 0
    };
  }
  e.ContractInfo = {
    typeUrl: "/cosmwasm.wasm.v1.ContractInfo",
    encode(F, X = o.BinaryWriter.create()) {
      return F.codeId !== BigInt(0) && X.uint32(8).uint64(F.codeId), F.creator !== "" && X.uint32(18).string(F.creator), F.admin !== "" && X.uint32(26).string(F.admin), F.label !== "" && X.uint32(34).string(F.label), F.created !== void 0 && e.AbsoluteTxPosition.encode(F.created, X.uint32(42).fork()).ldelim(), F.ibcPortId !== "" && X.uint32(50).string(F.ibcPortId), F.extension !== void 0 && n.Any.encode(F.extension, X.uint32(58).fork()).ldelim(), X;
    },
    decode(F, X) {
      const ee = F instanceof o.BinaryReader ? F : new o.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = V();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.codeId = ee.uint64();
            break;
          case 2:
            Q.creator = ee.string();
            break;
          case 3:
            Q.admin = ee.string();
            break;
          case 4:
            Q.label = ee.string();
            break;
          case 5:
            Q.created = e.AbsoluteTxPosition.decode(ee, ee.uint32());
            break;
          case 6:
            Q.ibcPortId = ee.string();
            break;
          case 7:
            Q.extension = n.Any.decode(ee, ee.uint32());
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = V();
      return (0, u.isSet)(F.codeId) && (X.codeId = BigInt(F.codeId.toString())), (0, u.isSet)(F.creator) && (X.creator = String(F.creator)), (0, u.isSet)(F.admin) && (X.admin = String(F.admin)), (0, u.isSet)(F.label) && (X.label = String(F.label)), (0, u.isSet)(F.created) && (X.created = e.AbsoluteTxPosition.fromJSON(F.created)), (0, u.isSet)(F.ibcPortId) && (X.ibcPortId = String(F.ibcPortId)), (0, u.isSet)(F.extension) && (X.extension = n.Any.fromJSON(F.extension)), X;
    },
    toJSON(F) {
      const X = {};
      return F.codeId !== void 0 && (X.codeId = (F.codeId || BigInt(0)).toString()), F.creator !== void 0 && (X.creator = F.creator), F.admin !== void 0 && (X.admin = F.admin), F.label !== void 0 && (X.label = F.label), F.created !== void 0 && (X.created = F.created ? e.AbsoluteTxPosition.toJSON(F.created) : void 0), F.ibcPortId !== void 0 && (X.ibcPortId = F.ibcPortId), F.extension !== void 0 && (X.extension = F.extension ? n.Any.toJSON(F.extension) : void 0), X;
    },
    fromPartial(F) {
      const X = V();
      return F.codeId !== void 0 && F.codeId !== null && (X.codeId = BigInt(F.codeId.toString())), X.creator = F.creator ?? "", X.admin = F.admin ?? "", X.label = F.label ?? "", F.created !== void 0 && F.created !== null && (X.created = e.AbsoluteTxPosition.fromPartial(F.created)), X.ibcPortId = F.ibcPortId ?? "", F.extension !== void 0 && F.extension !== null && (X.extension = n.Any.fromPartial(F.extension)), X;
    }
  };
  function M() {
    return {
      operation: 0,
      codeId: BigInt(0),
      updated: void 0,
      msg: new Uint8Array()
    };
  }
  e.ContractCodeHistoryEntry = {
    typeUrl: "/cosmwasm.wasm.v1.ContractCodeHistoryEntry",
    encode(F, X = o.BinaryWriter.create()) {
      return F.operation !== 0 && X.uint32(8).int32(F.operation), F.codeId !== BigInt(0) && X.uint32(16).uint64(F.codeId), F.updated !== void 0 && e.AbsoluteTxPosition.encode(F.updated, X.uint32(26).fork()).ldelim(), F.msg.length !== 0 && X.uint32(34).bytes(F.msg), X;
    },
    decode(F, X) {
      const ee = F instanceof o.BinaryReader ? F : new o.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = M();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.operation = ee.int32();
            break;
          case 2:
            Q.codeId = ee.uint64();
            break;
          case 3:
            Q.updated = e.AbsoluteTxPosition.decode(ee, ee.uint32());
            break;
          case 4:
            Q.msg = ee.bytes();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = M();
      return (0, u.isSet)(F.operation) && (X.operation = S(F.operation)), (0, u.isSet)(F.codeId) && (X.codeId = BigInt(F.codeId.toString())), (0, u.isSet)(F.updated) && (X.updated = e.AbsoluteTxPosition.fromJSON(F.updated)), (0, u.isSet)(F.msg) && (X.msg = (0, u.bytesFromBase64)(F.msg)), X;
    },
    toJSON(F) {
      const X = {};
      return F.operation !== void 0 && (X.operation = $(F.operation)), F.codeId !== void 0 && (X.codeId = (F.codeId || BigInt(0)).toString()), F.updated !== void 0 && (X.updated = F.updated ? e.AbsoluteTxPosition.toJSON(F.updated) : void 0), F.msg !== void 0 && (X.msg = (0, u.base64FromBytes)(F.msg !== void 0 ? F.msg : new Uint8Array())), X;
    },
    fromPartial(F) {
      const X = M();
      return X.operation = F.operation ?? 0, F.codeId !== void 0 && F.codeId !== null && (X.codeId = BigInt(F.codeId.toString())), F.updated !== void 0 && F.updated !== null && (X.updated = e.AbsoluteTxPosition.fromPartial(F.updated)), X.msg = F.msg ?? new Uint8Array(), X;
    }
  };
  function G() {
    return {
      blockHeight: BigInt(0),
      txIndex: BigInt(0)
    };
  }
  e.AbsoluteTxPosition = {
    typeUrl: "/cosmwasm.wasm.v1.AbsoluteTxPosition",
    encode(F, X = o.BinaryWriter.create()) {
      return F.blockHeight !== BigInt(0) && X.uint32(8).uint64(F.blockHeight), F.txIndex !== BigInt(0) && X.uint32(16).uint64(F.txIndex), X;
    },
    decode(F, X) {
      const ee = F instanceof o.BinaryReader ? F : new o.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = G();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.blockHeight = ee.uint64();
            break;
          case 2:
            Q.txIndex = ee.uint64();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = G();
      return (0, u.isSet)(F.blockHeight) && (X.blockHeight = BigInt(F.blockHeight.toString())), (0, u.isSet)(F.txIndex) && (X.txIndex = BigInt(F.txIndex.toString())), X;
    },
    toJSON(F) {
      const X = {};
      return F.blockHeight !== void 0 && (X.blockHeight = (F.blockHeight || BigInt(0)).toString()), F.txIndex !== void 0 && (X.txIndex = (F.txIndex || BigInt(0)).toString()), X;
    },
    fromPartial(F) {
      const X = G();
      return F.blockHeight !== void 0 && F.blockHeight !== null && (X.blockHeight = BigInt(F.blockHeight.toString())), F.txIndex !== void 0 && F.txIndex !== null && (X.txIndex = BigInt(F.txIndex.toString())), X;
    }
  };
  function k() {
    return {
      key: new Uint8Array(),
      value: new Uint8Array()
    };
  }
  e.Model = {
    typeUrl: "/cosmwasm.wasm.v1.Model",
    encode(F, X = o.BinaryWriter.create()) {
      return F.key.length !== 0 && X.uint32(10).bytes(F.key), F.value.length !== 0 && X.uint32(18).bytes(F.value), X;
    },
    decode(F, X) {
      const ee = F instanceof o.BinaryReader ? F : new o.BinaryReader(F);
      let ue = X === void 0 ? ee.len : ee.pos + X;
      const Q = k();
      for (; ee.pos < ue; ) {
        const Y = ee.uint32();
        switch (Y >>> 3) {
          case 1:
            Q.key = ee.bytes();
            break;
          case 2:
            Q.value = ee.bytes();
            break;
          default:
            ee.skipType(Y & 7);
            break;
        }
      }
      return Q;
    },
    fromJSON(F) {
      const X = k();
      return (0, u.isSet)(F.key) && (X.key = (0, u.bytesFromBase64)(F.key)), (0, u.isSet)(F.value) && (X.value = (0, u.bytesFromBase64)(F.value)), X;
    },
    toJSON(F) {
      const X = {};
      return F.key !== void 0 && (X.key = (0, u.base64FromBytes)(F.key !== void 0 ? F.key : new Uint8Array())), F.value !== void 0 && (X.value = (0, u.base64FromBytes)(F.value !== void 0 ? F.value : new Uint8Array())), X;
    },
    fromPartial(F) {
      const X = k();
      return X.key = F.key ?? new Uint8Array(), X.value = F.value ?? new Uint8Array(), X;
    }
  };
})(types$5);
var modules$1 = {}, aminomessages$b = {};
Object.defineProperty(aminomessages$b, "__esModule", { value: !0 });
aminomessages$b.createWasmAminoConverters = aminomessages$b.accessTypeToString = aminomessages$b.accessTypeFromString = void 0;
const amino_1$8 = build$P, encoding_1$v = build$n, types_1$3 = types$5;
function accessTypeFromString(e) {
  switch (e) {
    case "Unspecified":
      return types_1$3.AccessType.ACCESS_TYPE_UNSPECIFIED;
    case "Nobody":
      return types_1$3.AccessType.ACCESS_TYPE_NOBODY;
    case "OnlyAddress":
      return types_1$3.AccessType.ACCESS_TYPE_ONLY_ADDRESS;
    case "Everybody":
      return types_1$3.AccessType.ACCESS_TYPE_EVERYBODY;
    case "AnyOfAddresses":
      return types_1$3.AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES;
    default:
      return types_1$3.AccessType.UNRECOGNIZED;
  }
}
aminomessages$b.accessTypeFromString = accessTypeFromString;
function accessTypeToString(e) {
  switch (e) {
    case types_1$3.AccessType.ACCESS_TYPE_UNSPECIFIED:
      return "Unspecified";
    case types_1$3.AccessType.ACCESS_TYPE_NOBODY:
      return "Nobody";
    case types_1$3.AccessType.ACCESS_TYPE_ONLY_ADDRESS:
      return "OnlyAddress";
    case types_1$3.AccessType.ACCESS_TYPE_EVERYBODY:
      return "Everybody";
    case types_1$3.AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES:
      return "AnyOfAddresses";
    case types_1$3.AccessType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
aminomessages$b.accessTypeToString = accessTypeToString;
function createWasmAminoConverters() {
  return {
    "/cosmwasm.wasm.v1.MsgStoreCode": {
      aminoType: "wasm/MsgStoreCode",
      toAmino: ({ sender: e, wasmByteCode: n, instantiatePermission: o }) => ({
        sender: e,
        wasm_byte_code: (0, encoding_1$v.toBase64)(n),
        instantiate_permission: o ? {
          permission: accessTypeToString(o.permission),
          address: o.address || void 0,
          addresses: o.addresses.length !== 0 ? o.addresses : void 0
        } : void 0
      }),
      fromAmino: ({ sender: e, wasm_byte_code: n, instantiate_permission: o }) => ({
        sender: e,
        wasmByteCode: (0, encoding_1$v.fromBase64)(n),
        instantiatePermission: o ? types_1$3.AccessConfig.fromPartial({
          permission: accessTypeFromString(o.permission),
          address: o.address ?? "",
          addresses: o.addresses ?? []
        }) : void 0
      })
    },
    "/cosmwasm.wasm.v1.MsgInstantiateContract": {
      aminoType: "wasm/MsgInstantiateContract",
      toAmino: ({ sender: e, codeId: n, label: o, msg: u, funds: c, admin: d }) => ({
        sender: e,
        code_id: n.toString(),
        label: o,
        msg: JSON.parse((0, encoding_1$v.fromUtf8)(u)),
        funds: c,
        admin: (0, amino_1$8.omitDefault)(d)
      }),
      fromAmino: ({ sender: e, code_id: n, label: o, msg: u, funds: c, admin: d }) => ({
        sender: e,
        codeId: BigInt(n),
        label: o,
        msg: (0, encoding_1$v.toUtf8)(JSON.stringify(u)),
        funds: [...c],
        admin: d ?? ""
      })
    },
    "/cosmwasm.wasm.v1.MsgInstantiateContract2": {
      aminoType: "wasm/MsgInstantiateContract2",
      toAmino: ({ sender: e, codeId: n, label: o, msg: u, funds: c, admin: d, salt: m, fixMsg: v }) => ({
        sender: e,
        code_id: n.toString(),
        label: o,
        msg: JSON.parse((0, encoding_1$v.fromUtf8)(u)),
        funds: c,
        admin: (0, amino_1$8.omitDefault)(d),
        salt: (0, encoding_1$v.toBase64)(m),
        fix_msg: (0, amino_1$8.omitDefault)(v)
      }),
      fromAmino: ({ sender: e, code_id: n, label: o, msg: u, funds: c, admin: d, salt: m, fix_msg: v }) => ({
        sender: e,
        codeId: BigInt(n),
        label: o,
        msg: (0, encoding_1$v.toUtf8)(JSON.stringify(u)),
        funds: [...c],
        admin: d ?? "",
        salt: (0, encoding_1$v.fromBase64)(m),
        fixMsg: v ?? !1
      })
    },
    "/cosmwasm.wasm.v1.MsgUpdateAdmin": {
      aminoType: "wasm/MsgUpdateAdmin",
      toAmino: ({ sender: e, newAdmin: n, contract: o }) => ({
        sender: e,
        new_admin: n,
        contract: o
      }),
      fromAmino: ({ sender: e, new_admin: n, contract: o }) => ({
        sender: e,
        newAdmin: n,
        contract: o
      })
    },
    "/cosmwasm.wasm.v1.MsgClearAdmin": {
      aminoType: "wasm/MsgClearAdmin",
      toAmino: ({ sender: e, contract: n }) => ({
        sender: e,
        contract: n
      }),
      fromAmino: ({ sender: e, contract: n }) => ({
        sender: e,
        contract: n
      })
    },
    "/cosmwasm.wasm.v1.MsgExecuteContract": {
      aminoType: "wasm/MsgExecuteContract",
      toAmino: ({ sender: e, contract: n, msg: o, funds: u }) => ({
        sender: e,
        contract: n,
        msg: JSON.parse((0, encoding_1$v.fromUtf8)(o)),
        funds: u
      }),
      fromAmino: ({ sender: e, contract: n, msg: o, funds: u }) => ({
        sender: e,
        contract: n,
        msg: (0, encoding_1$v.toUtf8)(JSON.stringify(o)),
        funds: [...u]
      })
    },
    "/cosmwasm.wasm.v1.MsgMigrateContract": {
      aminoType: "wasm/MsgMigrateContract",
      toAmino: ({ sender: e, contract: n, codeId: o, msg: u }) => ({
        sender: e,
        contract: n,
        code_id: o.toString(),
        msg: JSON.parse((0, encoding_1$v.fromUtf8)(u))
      }),
      fromAmino: ({ sender: e, contract: n, code_id: o, msg: u }) => ({
        sender: e,
        contract: n,
        codeId: BigInt(o),
        msg: (0, encoding_1$v.toUtf8)(JSON.stringify(u))
      })
    }
  };
}
aminomessages$b.createWasmAminoConverters = createWasmAminoConverters;
var messages$9 = {}, tx$b = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgUpdateInstantiateConfigResponse = e.MsgUpdateInstantiateConfig = e.MsgClearAdminResponse = e.MsgClearAdmin = e.MsgUpdateAdminResponse = e.MsgUpdateAdmin = e.MsgMigrateContractResponse = e.MsgMigrateContract = e.MsgExecuteContractResponse = e.MsgExecuteContract = e.MsgInstantiateContract2Response = e.MsgInstantiateContractResponse = e.MsgInstantiateContract2 = e.MsgInstantiateContract = e.MsgStoreCodeResponse = e.MsgStoreCode = e.protobufPackage = void 0;
  const n = types$5, o = coin$8, u = binary, c = helpers;
  e.protobufPackage = "cosmwasm.wasm.v1";
  function d() {
    return {
      sender: "",
      wasmByteCode: new Uint8Array(),
      instantiatePermission: void 0
    };
  }
  e.MsgStoreCode = {
    typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.sender !== "" && Y.uint32(10).string(Q.sender), Q.wasmByteCode.length !== 0 && Y.uint32(18).bytes(Q.wasmByteCode), Q.instantiatePermission !== void 0 && n.AccessConfig.encode(Q.instantiatePermission, Y.uint32(42).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = d();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.sender = pe.string();
            break;
          case 2:
            ne.wasmByteCode = pe.bytes();
            break;
          case 5:
            ne.instantiatePermission = n.AccessConfig.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = d();
      return (0, c.isSet)(Q.sender) && (Y.sender = String(Q.sender)), (0, c.isSet)(Q.wasmByteCode) && (Y.wasmByteCode = (0, c.bytesFromBase64)(Q.wasmByteCode)), (0, c.isSet)(Q.instantiatePermission) && (Y.instantiatePermission = n.AccessConfig.fromJSON(Q.instantiatePermission)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.sender !== void 0 && (Y.sender = Q.sender), Q.wasmByteCode !== void 0 && (Y.wasmByteCode = (0, c.base64FromBytes)(Q.wasmByteCode !== void 0 ? Q.wasmByteCode : new Uint8Array())), Q.instantiatePermission !== void 0 && (Y.instantiatePermission = Q.instantiatePermission ? n.AccessConfig.toJSON(Q.instantiatePermission) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = d();
      return Y.sender = Q.sender ?? "", Y.wasmByteCode = Q.wasmByteCode ?? new Uint8Array(), Q.instantiatePermission !== void 0 && Q.instantiatePermission !== null && (Y.instantiatePermission = n.AccessConfig.fromPartial(Q.instantiatePermission)), Y;
    }
  };
  function m() {
    return {
      codeId: BigInt(0),
      checksum: new Uint8Array()
    };
  }
  e.MsgStoreCodeResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgStoreCodeResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.codeId !== BigInt(0) && Y.uint32(8).uint64(Q.codeId), Q.checksum.length !== 0 && Y.uint32(18).bytes(Q.checksum), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = m();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.codeId = pe.uint64();
            break;
          case 2:
            ne.checksum = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = m();
      return (0, c.isSet)(Q.codeId) && (Y.codeId = BigInt(Q.codeId.toString())), (0, c.isSet)(Q.checksum) && (Y.checksum = (0, c.bytesFromBase64)(Q.checksum)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.codeId !== void 0 && (Y.codeId = (Q.codeId || BigInt(0)).toString()), Q.checksum !== void 0 && (Y.checksum = (0, c.base64FromBytes)(Q.checksum !== void 0 ? Q.checksum : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = m();
      return Q.codeId !== void 0 && Q.codeId !== null && (Y.codeId = BigInt(Q.codeId.toString())), Y.checksum = Q.checksum ?? new Uint8Array(), Y;
    }
  };
  function v() {
    return {
      sender: "",
      admin: "",
      codeId: BigInt(0),
      label: "",
      msg: new Uint8Array(),
      funds: []
    };
  }
  e.MsgInstantiateContract = {
    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
    encode(Q, Y = u.BinaryWriter.create()) {
      Q.sender !== "" && Y.uint32(10).string(Q.sender), Q.admin !== "" && Y.uint32(18).string(Q.admin), Q.codeId !== BigInt(0) && Y.uint32(24).uint64(Q.codeId), Q.label !== "" && Y.uint32(34).string(Q.label), Q.msg.length !== 0 && Y.uint32(42).bytes(Q.msg);
      for (const pe of Q.funds)
        o.Coin.encode(pe, Y.uint32(50).fork()).ldelim();
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = v();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.sender = pe.string();
            break;
          case 2:
            ne.admin = pe.string();
            break;
          case 3:
            ne.codeId = pe.uint64();
            break;
          case 4:
            ne.label = pe.string();
            break;
          case 5:
            ne.msg = pe.bytes();
            break;
          case 6:
            ne.funds.push(o.Coin.decode(pe, pe.uint32()));
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = v();
      return (0, c.isSet)(Q.sender) && (Y.sender = String(Q.sender)), (0, c.isSet)(Q.admin) && (Y.admin = String(Q.admin)), (0, c.isSet)(Q.codeId) && (Y.codeId = BigInt(Q.codeId.toString())), (0, c.isSet)(Q.label) && (Y.label = String(Q.label)), (0, c.isSet)(Q.msg) && (Y.msg = (0, c.bytesFromBase64)(Q.msg)), Array.isArray(Q == null ? void 0 : Q.funds) && (Y.funds = Q.funds.map((pe) => o.Coin.fromJSON(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.sender !== void 0 && (Y.sender = Q.sender), Q.admin !== void 0 && (Y.admin = Q.admin), Q.codeId !== void 0 && (Y.codeId = (Q.codeId || BigInt(0)).toString()), Q.label !== void 0 && (Y.label = Q.label), Q.msg !== void 0 && (Y.msg = (0, c.base64FromBytes)(Q.msg !== void 0 ? Q.msg : new Uint8Array())), Q.funds ? Y.funds = Q.funds.map((pe) => pe ? o.Coin.toJSON(pe) : void 0) : Y.funds = [], Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = v();
      return Y.sender = Q.sender ?? "", Y.admin = Q.admin ?? "", Q.codeId !== void 0 && Q.codeId !== null && (Y.codeId = BigInt(Q.codeId.toString())), Y.label = Q.label ?? "", Y.msg = Q.msg ?? new Uint8Array(), Y.funds = ((pe = Q.funds) == null ? void 0 : pe.map((oe) => o.Coin.fromPartial(oe))) || [], Y;
    }
  };
  function S() {
    return {
      sender: "",
      admin: "",
      codeId: BigInt(0),
      label: "",
      msg: new Uint8Array(),
      funds: [],
      salt: new Uint8Array(),
      fixMsg: !1
    };
  }
  e.MsgInstantiateContract2 = {
    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
    encode(Q, Y = u.BinaryWriter.create()) {
      Q.sender !== "" && Y.uint32(10).string(Q.sender), Q.admin !== "" && Y.uint32(18).string(Q.admin), Q.codeId !== BigInt(0) && Y.uint32(24).uint64(Q.codeId), Q.label !== "" && Y.uint32(34).string(Q.label), Q.msg.length !== 0 && Y.uint32(42).bytes(Q.msg);
      for (const pe of Q.funds)
        o.Coin.encode(pe, Y.uint32(50).fork()).ldelim();
      return Q.salt.length !== 0 && Y.uint32(58).bytes(Q.salt), Q.fixMsg === !0 && Y.uint32(64).bool(Q.fixMsg), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = S();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.sender = pe.string();
            break;
          case 2:
            ne.admin = pe.string();
            break;
          case 3:
            ne.codeId = pe.uint64();
            break;
          case 4:
            ne.label = pe.string();
            break;
          case 5:
            ne.msg = pe.bytes();
            break;
          case 6:
            ne.funds.push(o.Coin.decode(pe, pe.uint32()));
            break;
          case 7:
            ne.salt = pe.bytes();
            break;
          case 8:
            ne.fixMsg = pe.bool();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = S();
      return (0, c.isSet)(Q.sender) && (Y.sender = String(Q.sender)), (0, c.isSet)(Q.admin) && (Y.admin = String(Q.admin)), (0, c.isSet)(Q.codeId) && (Y.codeId = BigInt(Q.codeId.toString())), (0, c.isSet)(Q.label) && (Y.label = String(Q.label)), (0, c.isSet)(Q.msg) && (Y.msg = (0, c.bytesFromBase64)(Q.msg)), Array.isArray(Q == null ? void 0 : Q.funds) && (Y.funds = Q.funds.map((pe) => o.Coin.fromJSON(pe))), (0, c.isSet)(Q.salt) && (Y.salt = (0, c.bytesFromBase64)(Q.salt)), (0, c.isSet)(Q.fixMsg) && (Y.fixMsg = !!Q.fixMsg), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.sender !== void 0 && (Y.sender = Q.sender), Q.admin !== void 0 && (Y.admin = Q.admin), Q.codeId !== void 0 && (Y.codeId = (Q.codeId || BigInt(0)).toString()), Q.label !== void 0 && (Y.label = Q.label), Q.msg !== void 0 && (Y.msg = (0, c.base64FromBytes)(Q.msg !== void 0 ? Q.msg : new Uint8Array())), Q.funds ? Y.funds = Q.funds.map((pe) => pe ? o.Coin.toJSON(pe) : void 0) : Y.funds = [], Q.salt !== void 0 && (Y.salt = (0, c.base64FromBytes)(Q.salt !== void 0 ? Q.salt : new Uint8Array())), Q.fixMsg !== void 0 && (Y.fixMsg = Q.fixMsg), Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = S();
      return Y.sender = Q.sender ?? "", Y.admin = Q.admin ?? "", Q.codeId !== void 0 && Q.codeId !== null && (Y.codeId = BigInt(Q.codeId.toString())), Y.label = Q.label ?? "", Y.msg = Q.msg ?? new Uint8Array(), Y.funds = ((pe = Q.funds) == null ? void 0 : pe.map((oe) => o.Coin.fromPartial(oe))) || [], Y.salt = Q.salt ?? new Uint8Array(), Y.fixMsg = Q.fixMsg ?? !1, Y;
    }
  };
  function $() {
    return {
      address: "",
      data: new Uint8Array()
    };
  }
  e.MsgInstantiateContractResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContractResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.address !== "" && Y.uint32(10).string(Q.address), Q.data.length !== 0 && Y.uint32(18).bytes(Q.data), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = $();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.address = pe.string();
            break;
          case 2:
            ne.data = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = $();
      return (0, c.isSet)(Q.address) && (Y.address = String(Q.address)), (0, c.isSet)(Q.data) && (Y.data = (0, c.bytesFromBase64)(Q.data)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.address !== void 0 && (Y.address = Q.address), Q.data !== void 0 && (Y.data = (0, c.base64FromBytes)(Q.data !== void 0 ? Q.data : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = $();
      return Y.address = Q.address ?? "", Y.data = Q.data ?? new Uint8Array(), Y;
    }
  };
  function E() {
    return {
      address: "",
      data: new Uint8Array()
    };
  }
  e.MsgInstantiateContract2Response = {
    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2Response",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.address !== "" && Y.uint32(10).string(Q.address), Q.data.length !== 0 && Y.uint32(18).bytes(Q.data), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = E();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.address = pe.string();
            break;
          case 2:
            ne.data = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = E();
      return (0, c.isSet)(Q.address) && (Y.address = String(Q.address)), (0, c.isSet)(Q.data) && (Y.data = (0, c.bytesFromBase64)(Q.data)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.address !== void 0 && (Y.address = Q.address), Q.data !== void 0 && (Y.data = (0, c.base64FromBytes)(Q.data !== void 0 ? Q.data : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = E();
      return Y.address = Q.address ?? "", Y.data = Q.data ?? new Uint8Array(), Y;
    }
  };
  function O() {
    return {
      sender: "",
      contract: "",
      msg: new Uint8Array(),
      funds: []
    };
  }
  e.MsgExecuteContract = {
    typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
    encode(Q, Y = u.BinaryWriter.create()) {
      Q.sender !== "" && Y.uint32(10).string(Q.sender), Q.contract !== "" && Y.uint32(18).string(Q.contract), Q.msg.length !== 0 && Y.uint32(26).bytes(Q.msg);
      for (const pe of Q.funds)
        o.Coin.encode(pe, Y.uint32(42).fork()).ldelim();
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = O();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.sender = pe.string();
            break;
          case 2:
            ne.contract = pe.string();
            break;
          case 3:
            ne.msg = pe.bytes();
            break;
          case 5:
            ne.funds.push(o.Coin.decode(pe, pe.uint32()));
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = O();
      return (0, c.isSet)(Q.sender) && (Y.sender = String(Q.sender)), (0, c.isSet)(Q.contract) && (Y.contract = String(Q.contract)), (0, c.isSet)(Q.msg) && (Y.msg = (0, c.bytesFromBase64)(Q.msg)), Array.isArray(Q == null ? void 0 : Q.funds) && (Y.funds = Q.funds.map((pe) => o.Coin.fromJSON(pe))), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.sender !== void 0 && (Y.sender = Q.sender), Q.contract !== void 0 && (Y.contract = Q.contract), Q.msg !== void 0 && (Y.msg = (0, c.base64FromBytes)(Q.msg !== void 0 ? Q.msg : new Uint8Array())), Q.funds ? Y.funds = Q.funds.map((pe) => pe ? o.Coin.toJSON(pe) : void 0) : Y.funds = [], Y;
    },
    fromPartial(Q) {
      var pe;
      const Y = O();
      return Y.sender = Q.sender ?? "", Y.contract = Q.contract ?? "", Y.msg = Q.msg ?? new Uint8Array(), Y.funds = ((pe = Q.funds) == null ? void 0 : pe.map((oe) => o.Coin.fromPartial(oe))) || [], Y;
    }
  };
  function T() {
    return {
      data: new Uint8Array()
    };
  }
  e.MsgExecuteContractResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContractResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.data.length !== 0 && Y.uint32(10).bytes(Q.data), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = T();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.data = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = T();
      return (0, c.isSet)(Q.data) && (Y.data = (0, c.bytesFromBase64)(Q.data)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.data !== void 0 && (Y.data = (0, c.base64FromBytes)(Q.data !== void 0 ? Q.data : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = T();
      return Y.data = Q.data ?? new Uint8Array(), Y;
    }
  };
  function y() {
    return {
      sender: "",
      contract: "",
      codeId: BigInt(0),
      msg: new Uint8Array()
    };
  }
  e.MsgMigrateContract = {
    typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.sender !== "" && Y.uint32(10).string(Q.sender), Q.contract !== "" && Y.uint32(18).string(Q.contract), Q.codeId !== BigInt(0) && Y.uint32(24).uint64(Q.codeId), Q.msg.length !== 0 && Y.uint32(34).bytes(Q.msg), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = y();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.sender = pe.string();
            break;
          case 2:
            ne.contract = pe.string();
            break;
          case 3:
            ne.codeId = pe.uint64();
            break;
          case 4:
            ne.msg = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = y();
      return (0, c.isSet)(Q.sender) && (Y.sender = String(Q.sender)), (0, c.isSet)(Q.contract) && (Y.contract = String(Q.contract)), (0, c.isSet)(Q.codeId) && (Y.codeId = BigInt(Q.codeId.toString())), (0, c.isSet)(Q.msg) && (Y.msg = (0, c.bytesFromBase64)(Q.msg)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.sender !== void 0 && (Y.sender = Q.sender), Q.contract !== void 0 && (Y.contract = Q.contract), Q.codeId !== void 0 && (Y.codeId = (Q.codeId || BigInt(0)).toString()), Q.msg !== void 0 && (Y.msg = (0, c.base64FromBytes)(Q.msg !== void 0 ? Q.msg : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = y();
      return Y.sender = Q.sender ?? "", Y.contract = Q.contract ?? "", Q.codeId !== void 0 && Q.codeId !== null && (Y.codeId = BigInt(Q.codeId.toString())), Y.msg = Q.msg ?? new Uint8Array(), Y;
    }
  };
  function V() {
    return {
      data: new Uint8Array()
    };
  }
  e.MsgMigrateContractResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContractResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.data.length !== 0 && Y.uint32(10).bytes(Q.data), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = V();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.data = pe.bytes();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = V();
      return (0, c.isSet)(Q.data) && (Y.data = (0, c.bytesFromBase64)(Q.data)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.data !== void 0 && (Y.data = (0, c.base64FromBytes)(Q.data !== void 0 ? Q.data : new Uint8Array())), Y;
    },
    fromPartial(Q) {
      const Y = V();
      return Y.data = Q.data ?? new Uint8Array(), Y;
    }
  };
  function M() {
    return {
      sender: "",
      newAdmin: "",
      contract: ""
    };
  }
  e.MsgUpdateAdmin = {
    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.sender !== "" && Y.uint32(10).string(Q.sender), Q.newAdmin !== "" && Y.uint32(18).string(Q.newAdmin), Q.contract !== "" && Y.uint32(26).string(Q.contract), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = M();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.sender = pe.string();
            break;
          case 2:
            ne.newAdmin = pe.string();
            break;
          case 3:
            ne.contract = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = M();
      return (0, c.isSet)(Q.sender) && (Y.sender = String(Q.sender)), (0, c.isSet)(Q.newAdmin) && (Y.newAdmin = String(Q.newAdmin)), (0, c.isSet)(Q.contract) && (Y.contract = String(Q.contract)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.sender !== void 0 && (Y.sender = Q.sender), Q.newAdmin !== void 0 && (Y.newAdmin = Q.newAdmin), Q.contract !== void 0 && (Y.contract = Q.contract), Y;
    },
    fromPartial(Q) {
      const Y = M();
      return Y.sender = Q.sender ?? "", Y.newAdmin = Q.newAdmin ?? "", Y.contract = Q.contract ?? "", Y;
    }
  };
  function G() {
    return {};
  }
  e.MsgUpdateAdminResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdminResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = G();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      return G();
    },
    toJSON(Q) {
      return {};
    },
    fromPartial(Q) {
      return G();
    }
  };
  function k() {
    return {
      sender: "",
      contract: ""
    };
  }
  e.MsgClearAdmin = {
    typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.sender !== "" && Y.uint32(10).string(Q.sender), Q.contract !== "" && Y.uint32(26).string(Q.contract), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = k();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.sender = pe.string();
            break;
          case 3:
            ne.contract = pe.string();
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = k();
      return (0, c.isSet)(Q.sender) && (Y.sender = String(Q.sender)), (0, c.isSet)(Q.contract) && (Y.contract = String(Q.contract)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.sender !== void 0 && (Y.sender = Q.sender), Q.contract !== void 0 && (Y.contract = Q.contract), Y;
    },
    fromPartial(Q) {
      const Y = k();
      return Y.sender = Q.sender ?? "", Y.contract = Q.contract ?? "", Y;
    }
  };
  function F() {
    return {};
  }
  e.MsgClearAdminResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgClearAdminResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = F();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      return F();
    },
    toJSON(Q) {
      return {};
    },
    fromPartial(Q) {
      return F();
    }
  };
  function X() {
    return {
      sender: "",
      codeId: BigInt(0),
      newInstantiatePermission: void 0
    };
  }
  e.MsgUpdateInstantiateConfig = {
    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Q.sender !== "" && Y.uint32(10).string(Q.sender), Q.codeId !== BigInt(0) && Y.uint32(16).uint64(Q.codeId), Q.newInstantiatePermission !== void 0 && n.AccessConfig.encode(Q.newInstantiatePermission, Y.uint32(26).fork()).ldelim(), Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = X();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          case 1:
            ne.sender = pe.string();
            break;
          case 2:
            ne.codeId = pe.uint64();
            break;
          case 3:
            ne.newInstantiatePermission = n.AccessConfig.decode(pe, pe.uint32());
            break;
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      const Y = X();
      return (0, c.isSet)(Q.sender) && (Y.sender = String(Q.sender)), (0, c.isSet)(Q.codeId) && (Y.codeId = BigInt(Q.codeId.toString())), (0, c.isSet)(Q.newInstantiatePermission) && (Y.newInstantiatePermission = n.AccessConfig.fromJSON(Q.newInstantiatePermission)), Y;
    },
    toJSON(Q) {
      const Y = {};
      return Q.sender !== void 0 && (Y.sender = Q.sender), Q.codeId !== void 0 && (Y.codeId = (Q.codeId || BigInt(0)).toString()), Q.newInstantiatePermission !== void 0 && (Y.newInstantiatePermission = Q.newInstantiatePermission ? n.AccessConfig.toJSON(Q.newInstantiatePermission) : void 0), Y;
    },
    fromPartial(Q) {
      const Y = X();
      return Y.sender = Q.sender ?? "", Q.codeId !== void 0 && Q.codeId !== null && (Y.codeId = BigInt(Q.codeId.toString())), Q.newInstantiatePermission !== void 0 && Q.newInstantiatePermission !== null && (Y.newInstantiatePermission = n.AccessConfig.fromPartial(Q.newInstantiatePermission)), Y;
    }
  };
  function ee() {
    return {};
  }
  e.MsgUpdateInstantiateConfigResponse = {
    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfigResponse",
    encode(Q, Y = u.BinaryWriter.create()) {
      return Y;
    },
    decode(Q, Y) {
      const pe = Q instanceof u.BinaryReader ? Q : new u.BinaryReader(Q);
      let oe = Y === void 0 ? pe.len : pe.pos + Y;
      const ne = ee();
      for (; pe.pos < oe; ) {
        const H = pe.uint32();
        switch (H >>> 3) {
          default:
            pe.skipType(H & 7);
            break;
        }
      }
      return ne;
    },
    fromJSON(Q) {
      return ee();
    },
    toJSON(Q) {
      return {};
    },
    fromPartial(Q) {
      return ee();
    }
  };
  class ue {
    constructor(Y) {
      this.rpc = Y, this.StoreCode = this.StoreCode.bind(this), this.InstantiateContract = this.InstantiateContract.bind(this), this.InstantiateContract2 = this.InstantiateContract2.bind(this), this.ExecuteContract = this.ExecuteContract.bind(this), this.MigrateContract = this.MigrateContract.bind(this), this.UpdateAdmin = this.UpdateAdmin.bind(this), this.ClearAdmin = this.ClearAdmin.bind(this), this.UpdateInstantiateConfig = this.UpdateInstantiateConfig.bind(this);
    }
    StoreCode(Y) {
      const pe = e.MsgStoreCode.encode(Y).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", pe).then((ne) => e.MsgStoreCodeResponse.decode(new u.BinaryReader(ne)));
    }
    InstantiateContract(Y) {
      const pe = e.MsgInstantiateContract.encode(Y).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", pe).then((ne) => e.MsgInstantiateContractResponse.decode(new u.BinaryReader(ne)));
    }
    InstantiateContract2(Y) {
      const pe = e.MsgInstantiateContract2.encode(Y).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract2", pe).then((ne) => e.MsgInstantiateContract2Response.decode(new u.BinaryReader(ne)));
    }
    ExecuteContract(Y) {
      const pe = e.MsgExecuteContract.encode(Y).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", pe).then((ne) => e.MsgExecuteContractResponse.decode(new u.BinaryReader(ne)));
    }
    MigrateContract(Y) {
      const pe = e.MsgMigrateContract.encode(Y).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", pe).then((ne) => e.MsgMigrateContractResponse.decode(new u.BinaryReader(ne)));
    }
    UpdateAdmin(Y) {
      const pe = e.MsgUpdateAdmin.encode(Y).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", pe).then((ne) => e.MsgUpdateAdminResponse.decode(new u.BinaryReader(ne)));
    }
    ClearAdmin(Y) {
      const pe = e.MsgClearAdmin.encode(Y).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", pe).then((ne) => e.MsgClearAdminResponse.decode(new u.BinaryReader(ne)));
    }
    UpdateInstantiateConfig(Y) {
      const pe = e.MsgUpdateInstantiateConfig.encode(Y).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateInstantiateConfig", pe).then((ne) => e.MsgUpdateInstantiateConfigResponse.decode(new u.BinaryReader(ne)));
    }
  }
  e.MsgClientImpl = ue;
})(tx$b);
Object.defineProperty(messages$9, "__esModule", { value: !0 });
messages$9.isMsgExecuteEncodeObject = messages$9.isMsgMigrateEncodeObject = messages$9.isMsgClearAdminEncodeObject = messages$9.isMsgUpdateAdminEncodeObject = messages$9.isMsgInstantiateContract2EncodeObject = messages$9.isMsgInstantiateContractEncodeObject = messages$9.isMsgStoreCodeEncodeObject = messages$9.wasmTypes = void 0;
const tx_1$e = tx$b;
messages$9.wasmTypes = [
  ["/cosmwasm.wasm.v1.MsgClearAdmin", tx_1$e.MsgClearAdmin],
  ["/cosmwasm.wasm.v1.MsgExecuteContract", tx_1$e.MsgExecuteContract],
  ["/cosmwasm.wasm.v1.MsgMigrateContract", tx_1$e.MsgMigrateContract],
  ["/cosmwasm.wasm.v1.MsgStoreCode", tx_1$e.MsgStoreCode],
  ["/cosmwasm.wasm.v1.MsgInstantiateContract", tx_1$e.MsgInstantiateContract],
  ["/cosmwasm.wasm.v1.MsgInstantiateContract2", tx_1$e.MsgInstantiateContract2],
  ["/cosmwasm.wasm.v1.MsgUpdateAdmin", tx_1$e.MsgUpdateAdmin]
];
function isMsgStoreCodeEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgStoreCode";
}
messages$9.isMsgStoreCodeEncodeObject = isMsgStoreCodeEncodeObject;
function isMsgInstantiateContractEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgInstantiateContract";
}
messages$9.isMsgInstantiateContractEncodeObject = isMsgInstantiateContractEncodeObject;
function isMsgInstantiateContract2EncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgInstantiateContract2";
}
messages$9.isMsgInstantiateContract2EncodeObject = isMsgInstantiateContract2EncodeObject;
function isMsgUpdateAdminEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgUpdateAdmin";
}
messages$9.isMsgUpdateAdminEncodeObject = isMsgUpdateAdminEncodeObject;
function isMsgClearAdminEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgClearAdmin";
}
messages$9.isMsgClearAdminEncodeObject = isMsgClearAdminEncodeObject;
function isMsgMigrateEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgMigrateContract";
}
messages$9.isMsgMigrateEncodeObject = isMsgMigrateEncodeObject;
function isMsgExecuteEncodeObject(e) {
  return e.typeUrl === "/cosmwasm.wasm.v1.MsgExecuteContract";
}
messages$9.isMsgExecuteEncodeObject = isMsgExecuteEncodeObject;
var queries$b = {}, query = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueryClientImpl = e.QueryContractsByCreatorResponse = e.QueryContractsByCreatorRequest = e.QueryParamsResponse = e.QueryParamsRequest = e.QueryPinnedCodesResponse = e.QueryPinnedCodesRequest = e.QueryCodesResponse = e.QueryCodesRequest = e.QueryCodeResponse = e.CodeInfoResponse = e.QueryCodeRequest = e.QuerySmartContractStateResponse = e.QuerySmartContractStateRequest = e.QueryRawContractStateResponse = e.QueryRawContractStateRequest = e.QueryAllContractStateResponse = e.QueryAllContractStateRequest = e.QueryContractsByCodeResponse = e.QueryContractsByCodeRequest = e.QueryContractHistoryResponse = e.QueryContractHistoryRequest = e.QueryContractInfoResponse = e.QueryContractInfoRequest = e.protobufPackage = void 0;
  const n = pagination, o = types$5, u = binary, c = helpers;
  e.protobufPackage = "cosmwasm.wasm.v1";
  function d() {
    return {
      address: ""
    };
  }
  e.QueryContractInfoRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.address !== "" && P.uint32(10).string(w.address), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = d();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.address = J.string();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = d();
      return (0, c.isSet)(w.address) && (P.address = String(w.address)), P;
    },
    toJSON(w) {
      const P = {};
      return w.address !== void 0 && (P.address = w.address), P;
    },
    fromPartial(w) {
      const P = d();
      return P.address = w.address ?? "", P;
    }
  };
  function m() {
    return {
      address: "",
      contractInfo: o.ContractInfo.fromPartial({})
    };
  }
  e.QueryContractInfoResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.address !== "" && P.uint32(10).string(w.address), w.contractInfo !== void 0 && o.ContractInfo.encode(w.contractInfo, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = m();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.address = J.string();
            break;
          case 2:
            fe.contractInfo = o.ContractInfo.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = m();
      return (0, c.isSet)(w.address) && (P.address = String(w.address)), (0, c.isSet)(w.contractInfo) && (P.contractInfo = o.ContractInfo.fromJSON(w.contractInfo)), P;
    },
    toJSON(w) {
      const P = {};
      return w.address !== void 0 && (P.address = w.address), w.contractInfo !== void 0 && (P.contractInfo = w.contractInfo ? o.ContractInfo.toJSON(w.contractInfo) : void 0), P;
    },
    fromPartial(w) {
      const P = m();
      return P.address = w.address ?? "", w.contractInfo !== void 0 && w.contractInfo !== null && (P.contractInfo = o.ContractInfo.fromPartial(w.contractInfo)), P;
    }
  };
  function v() {
    return {
      address: "",
      pagination: void 0
    };
  }
  e.QueryContractHistoryRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.address !== "" && P.uint32(10).string(w.address), w.pagination !== void 0 && n.PageRequest.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = v();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.address = J.string();
            break;
          case 2:
            fe.pagination = n.PageRequest.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = v();
      return (0, c.isSet)(w.address) && (P.address = String(w.address)), (0, c.isSet)(w.pagination) && (P.pagination = n.PageRequest.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.address !== void 0 && (P.address = w.address), w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageRequest.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      const P = v();
      return P.address = w.address ?? "", w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageRequest.fromPartial(w.pagination)), P;
    }
  };
  function S() {
    return {
      entries: [],
      pagination: void 0
    };
  }
  e.QueryContractHistoryResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryResponse",
    encode(w, P = u.BinaryWriter.create()) {
      for (const J of w.entries)
        o.ContractCodeHistoryEntry.encode(J, P.uint32(10).fork()).ldelim();
      return w.pagination !== void 0 && n.PageResponse.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = S();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.entries.push(o.ContractCodeHistoryEntry.decode(J, J.uint32()));
            break;
          case 2:
            fe.pagination = n.PageResponse.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = S();
      return Array.isArray(w == null ? void 0 : w.entries) && (P.entries = w.entries.map((J) => o.ContractCodeHistoryEntry.fromJSON(J))), (0, c.isSet)(w.pagination) && (P.pagination = n.PageResponse.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.entries ? P.entries = w.entries.map((J) => J ? o.ContractCodeHistoryEntry.toJSON(J) : void 0) : P.entries = [], w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageResponse.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      var J;
      const P = S();
      return P.entries = ((J = w.entries) == null ? void 0 : J.map((se) => o.ContractCodeHistoryEntry.fromPartial(se))) || [], w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageResponse.fromPartial(w.pagination)), P;
    }
  };
  function $() {
    return {
      codeId: BigInt(0),
      pagination: void 0
    };
  }
  e.QueryContractsByCodeRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.codeId !== BigInt(0) && P.uint32(8).uint64(w.codeId), w.pagination !== void 0 && n.PageRequest.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = $();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.codeId = J.uint64();
            break;
          case 2:
            fe.pagination = n.PageRequest.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = $();
      return (0, c.isSet)(w.codeId) && (P.codeId = BigInt(w.codeId.toString())), (0, c.isSet)(w.pagination) && (P.pagination = n.PageRequest.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.codeId !== void 0 && (P.codeId = (w.codeId || BigInt(0)).toString()), w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageRequest.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      const P = $();
      return w.codeId !== void 0 && w.codeId !== null && (P.codeId = BigInt(w.codeId.toString())), w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageRequest.fromPartial(w.pagination)), P;
    }
  };
  function E() {
    return {
      contracts: [],
      pagination: void 0
    };
  }
  e.QueryContractsByCodeResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeResponse",
    encode(w, P = u.BinaryWriter.create()) {
      for (const J of w.contracts)
        P.uint32(10).string(J);
      return w.pagination !== void 0 && n.PageResponse.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = E();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.contracts.push(J.string());
            break;
          case 2:
            fe.pagination = n.PageResponse.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = E();
      return Array.isArray(w == null ? void 0 : w.contracts) && (P.contracts = w.contracts.map((J) => String(J))), (0, c.isSet)(w.pagination) && (P.pagination = n.PageResponse.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.contracts ? P.contracts = w.contracts.map((J) => J) : P.contracts = [], w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageResponse.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      var J;
      const P = E();
      return P.contracts = ((J = w.contracts) == null ? void 0 : J.map((se) => se)) || [], w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageResponse.fromPartial(w.pagination)), P;
    }
  };
  function O() {
    return {
      address: "",
      pagination: void 0
    };
  }
  e.QueryAllContractStateRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.address !== "" && P.uint32(10).string(w.address), w.pagination !== void 0 && n.PageRequest.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = O();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.address = J.string();
            break;
          case 2:
            fe.pagination = n.PageRequest.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = O();
      return (0, c.isSet)(w.address) && (P.address = String(w.address)), (0, c.isSet)(w.pagination) && (P.pagination = n.PageRequest.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.address !== void 0 && (P.address = w.address), w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageRequest.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      const P = O();
      return P.address = w.address ?? "", w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageRequest.fromPartial(w.pagination)), P;
    }
  };
  function T() {
    return {
      models: [],
      pagination: void 0
    };
  }
  e.QueryAllContractStateResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateResponse",
    encode(w, P = u.BinaryWriter.create()) {
      for (const J of w.models)
        o.Model.encode(J, P.uint32(10).fork()).ldelim();
      return w.pagination !== void 0 && n.PageResponse.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = T();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.models.push(o.Model.decode(J, J.uint32()));
            break;
          case 2:
            fe.pagination = n.PageResponse.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = T();
      return Array.isArray(w == null ? void 0 : w.models) && (P.models = w.models.map((J) => o.Model.fromJSON(J))), (0, c.isSet)(w.pagination) && (P.pagination = n.PageResponse.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.models ? P.models = w.models.map((J) => J ? o.Model.toJSON(J) : void 0) : P.models = [], w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageResponse.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      var J;
      const P = T();
      return P.models = ((J = w.models) == null ? void 0 : J.map((se) => o.Model.fromPartial(se))) || [], w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageResponse.fromPartial(w.pagination)), P;
    }
  };
  function y() {
    return {
      address: "",
      queryData: new Uint8Array()
    };
  }
  e.QueryRawContractStateRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.address !== "" && P.uint32(10).string(w.address), w.queryData.length !== 0 && P.uint32(18).bytes(w.queryData), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = y();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.address = J.string();
            break;
          case 2:
            fe.queryData = J.bytes();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = y();
      return (0, c.isSet)(w.address) && (P.address = String(w.address)), (0, c.isSet)(w.queryData) && (P.queryData = (0, c.bytesFromBase64)(w.queryData)), P;
    },
    toJSON(w) {
      const P = {};
      return w.address !== void 0 && (P.address = w.address), w.queryData !== void 0 && (P.queryData = (0, c.base64FromBytes)(w.queryData !== void 0 ? w.queryData : new Uint8Array())), P;
    },
    fromPartial(w) {
      const P = y();
      return P.address = w.address ?? "", P.queryData = w.queryData ?? new Uint8Array(), P;
    }
  };
  function V() {
    return {
      data: new Uint8Array()
    };
  }
  e.QueryRawContractStateResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.data.length !== 0 && P.uint32(10).bytes(w.data), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = V();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.data = J.bytes();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = V();
      return (0, c.isSet)(w.data) && (P.data = (0, c.bytesFromBase64)(w.data)), P;
    },
    toJSON(w) {
      const P = {};
      return w.data !== void 0 && (P.data = (0, c.base64FromBytes)(w.data !== void 0 ? w.data : new Uint8Array())), P;
    },
    fromPartial(w) {
      const P = V();
      return P.data = w.data ?? new Uint8Array(), P;
    }
  };
  function M() {
    return {
      address: "",
      queryData: new Uint8Array()
    };
  }
  e.QuerySmartContractStateRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.address !== "" && P.uint32(10).string(w.address), w.queryData.length !== 0 && P.uint32(18).bytes(w.queryData), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = M();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.address = J.string();
            break;
          case 2:
            fe.queryData = J.bytes();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = M();
      return (0, c.isSet)(w.address) && (P.address = String(w.address)), (0, c.isSet)(w.queryData) && (P.queryData = (0, c.bytesFromBase64)(w.queryData)), P;
    },
    toJSON(w) {
      const P = {};
      return w.address !== void 0 && (P.address = w.address), w.queryData !== void 0 && (P.queryData = (0, c.base64FromBytes)(w.queryData !== void 0 ? w.queryData : new Uint8Array())), P;
    },
    fromPartial(w) {
      const P = M();
      return P.address = w.address ?? "", P.queryData = w.queryData ?? new Uint8Array(), P;
    }
  };
  function G() {
    return {
      data: new Uint8Array()
    };
  }
  e.QuerySmartContractStateResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.data.length !== 0 && P.uint32(10).bytes(w.data), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = G();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.data = J.bytes();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = G();
      return (0, c.isSet)(w.data) && (P.data = (0, c.bytesFromBase64)(w.data)), P;
    },
    toJSON(w) {
      const P = {};
      return w.data !== void 0 && (P.data = (0, c.base64FromBytes)(w.data !== void 0 ? w.data : new Uint8Array())), P;
    },
    fromPartial(w) {
      const P = G();
      return P.data = w.data ?? new Uint8Array(), P;
    }
  };
  function k() {
    return {
      codeId: BigInt(0)
    };
  }
  e.QueryCodeRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryCodeRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.codeId !== BigInt(0) && P.uint32(8).uint64(w.codeId), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = k();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.codeId = J.uint64();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = k();
      return (0, c.isSet)(w.codeId) && (P.codeId = BigInt(w.codeId.toString())), P;
    },
    toJSON(w) {
      const P = {};
      return w.codeId !== void 0 && (P.codeId = (w.codeId || BigInt(0)).toString()), P;
    },
    fromPartial(w) {
      const P = k();
      return w.codeId !== void 0 && w.codeId !== null && (P.codeId = BigInt(w.codeId.toString())), P;
    }
  };
  function F() {
    return {
      codeId: BigInt(0),
      creator: "",
      dataHash: new Uint8Array(),
      instantiatePermission: o.AccessConfig.fromPartial({})
    };
  }
  e.CodeInfoResponse = {
    typeUrl: "/cosmwasm.wasm.v1.CodeInfoResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.codeId !== BigInt(0) && P.uint32(8).uint64(w.codeId), w.creator !== "" && P.uint32(18).string(w.creator), w.dataHash.length !== 0 && P.uint32(26).bytes(w.dataHash), w.instantiatePermission !== void 0 && o.AccessConfig.encode(w.instantiatePermission, P.uint32(50).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = F();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.codeId = J.uint64();
            break;
          case 2:
            fe.creator = J.string();
            break;
          case 3:
            fe.dataHash = J.bytes();
            break;
          case 6:
            fe.instantiatePermission = o.AccessConfig.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = F();
      return (0, c.isSet)(w.codeId) && (P.codeId = BigInt(w.codeId.toString())), (0, c.isSet)(w.creator) && (P.creator = String(w.creator)), (0, c.isSet)(w.dataHash) && (P.dataHash = (0, c.bytesFromBase64)(w.dataHash)), (0, c.isSet)(w.instantiatePermission) && (P.instantiatePermission = o.AccessConfig.fromJSON(w.instantiatePermission)), P;
    },
    toJSON(w) {
      const P = {};
      return w.codeId !== void 0 && (P.codeId = (w.codeId || BigInt(0)).toString()), w.creator !== void 0 && (P.creator = w.creator), w.dataHash !== void 0 && (P.dataHash = (0, c.base64FromBytes)(w.dataHash !== void 0 ? w.dataHash : new Uint8Array())), w.instantiatePermission !== void 0 && (P.instantiatePermission = w.instantiatePermission ? o.AccessConfig.toJSON(w.instantiatePermission) : void 0), P;
    },
    fromPartial(w) {
      const P = F();
      return w.codeId !== void 0 && w.codeId !== null && (P.codeId = BigInt(w.codeId.toString())), P.creator = w.creator ?? "", P.dataHash = w.dataHash ?? new Uint8Array(), w.instantiatePermission !== void 0 && w.instantiatePermission !== null && (P.instantiatePermission = o.AccessConfig.fromPartial(w.instantiatePermission)), P;
    }
  };
  function X() {
    return {
      codeInfo: void 0,
      data: new Uint8Array()
    };
  }
  e.QueryCodeResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryCodeResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.codeInfo !== void 0 && e.CodeInfoResponse.encode(w.codeInfo, P.uint32(10).fork()).ldelim(), w.data.length !== 0 && P.uint32(18).bytes(w.data), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = X();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.codeInfo = e.CodeInfoResponse.decode(J, J.uint32());
            break;
          case 2:
            fe.data = J.bytes();
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = X();
      return (0, c.isSet)(w.codeInfo) && (P.codeInfo = e.CodeInfoResponse.fromJSON(w.codeInfo)), (0, c.isSet)(w.data) && (P.data = (0, c.bytesFromBase64)(w.data)), P;
    },
    toJSON(w) {
      const P = {};
      return w.codeInfo !== void 0 && (P.codeInfo = w.codeInfo ? e.CodeInfoResponse.toJSON(w.codeInfo) : void 0), w.data !== void 0 && (P.data = (0, c.base64FromBytes)(w.data !== void 0 ? w.data : new Uint8Array())), P;
    },
    fromPartial(w) {
      const P = X();
      return w.codeInfo !== void 0 && w.codeInfo !== null && (P.codeInfo = e.CodeInfoResponse.fromPartial(w.codeInfo)), P.data = w.data ?? new Uint8Array(), P;
    }
  };
  function ee() {
    return {
      pagination: void 0
    };
  }
  e.QueryCodesRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryCodesRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.pagination !== void 0 && n.PageRequest.encode(w.pagination, P.uint32(10).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = ee();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.pagination = n.PageRequest.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = ee();
      return (0, c.isSet)(w.pagination) && (P.pagination = n.PageRequest.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageRequest.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      const P = ee();
      return w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageRequest.fromPartial(w.pagination)), P;
    }
  };
  function ue() {
    return {
      codeInfos: [],
      pagination: void 0
    };
  }
  e.QueryCodesResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryCodesResponse",
    encode(w, P = u.BinaryWriter.create()) {
      for (const J of w.codeInfos)
        e.CodeInfoResponse.encode(J, P.uint32(10).fork()).ldelim();
      return w.pagination !== void 0 && n.PageResponse.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = ue();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.codeInfos.push(e.CodeInfoResponse.decode(J, J.uint32()));
            break;
          case 2:
            fe.pagination = n.PageResponse.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = ue();
      return Array.isArray(w == null ? void 0 : w.codeInfos) && (P.codeInfos = w.codeInfos.map((J) => e.CodeInfoResponse.fromJSON(J))), (0, c.isSet)(w.pagination) && (P.pagination = n.PageResponse.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.codeInfos ? P.codeInfos = w.codeInfos.map((J) => J ? e.CodeInfoResponse.toJSON(J) : void 0) : P.codeInfos = [], w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageResponse.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      var J;
      const P = ue();
      return P.codeInfos = ((J = w.codeInfos) == null ? void 0 : J.map((se) => e.CodeInfoResponse.fromPartial(se))) || [], w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageResponse.fromPartial(w.pagination)), P;
    }
  };
  function Q() {
    return {
      pagination: void 0
    };
  }
  e.QueryPinnedCodesRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.pagination !== void 0 && n.PageRequest.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = Q();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 2:
            fe.pagination = n.PageRequest.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = Q();
      return (0, c.isSet)(w.pagination) && (P.pagination = n.PageRequest.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageRequest.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      const P = Q();
      return w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageRequest.fromPartial(w.pagination)), P;
    }
  };
  function Y() {
    return {
      codeIds: [],
      pagination: void 0
    };
  }
  e.QueryPinnedCodesResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesResponse",
    encode(w, P = u.BinaryWriter.create()) {
      P.uint32(10).fork();
      for (const J of w.codeIds)
        P.uint64(J);
      return P.ldelim(), w.pagination !== void 0 && n.PageResponse.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = Y();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            if ((N & 7) === 2) {
              const W = J.uint32() + J.pos;
              for (; J.pos < W; )
                fe.codeIds.push(J.uint64());
            } else
              fe.codeIds.push(J.uint64());
            break;
          case 2:
            fe.pagination = n.PageResponse.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = Y();
      return Array.isArray(w == null ? void 0 : w.codeIds) && (P.codeIds = w.codeIds.map((J) => BigInt(J.toString()))), (0, c.isSet)(w.pagination) && (P.pagination = n.PageResponse.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.codeIds ? P.codeIds = w.codeIds.map((J) => (J || BigInt(0)).toString()) : P.codeIds = [], w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageResponse.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      var J;
      const P = Y();
      return P.codeIds = ((J = w.codeIds) == null ? void 0 : J.map((se) => BigInt(se.toString()))) || [], w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageResponse.fromPartial(w.pagination)), P;
    }
  };
  function pe() {
    return {};
  }
  e.QueryParamsRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryParamsRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = pe();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      return pe();
    },
    toJSON(w) {
      return {};
    },
    fromPartial(w) {
      return pe();
    }
  };
  function oe() {
    return {
      params: o.Params.fromPartial({})
    };
  }
  e.QueryParamsResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryParamsResponse",
    encode(w, P = u.BinaryWriter.create()) {
      return w.params !== void 0 && o.Params.encode(w.params, P.uint32(10).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = oe();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.params = o.Params.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = oe();
      return (0, c.isSet)(w.params) && (P.params = o.Params.fromJSON(w.params)), P;
    },
    toJSON(w) {
      const P = {};
      return w.params !== void 0 && (P.params = w.params ? o.Params.toJSON(w.params) : void 0), P;
    },
    fromPartial(w) {
      const P = oe();
      return w.params !== void 0 && w.params !== null && (P.params = o.Params.fromPartial(w.params)), P;
    }
  };
  function ne() {
    return {
      creatorAddress: "",
      pagination: void 0
    };
  }
  e.QueryContractsByCreatorRequest = {
    typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorRequest",
    encode(w, P = u.BinaryWriter.create()) {
      return w.creatorAddress !== "" && P.uint32(10).string(w.creatorAddress), w.pagination !== void 0 && n.PageRequest.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = ne();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.creatorAddress = J.string();
            break;
          case 2:
            fe.pagination = n.PageRequest.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = ne();
      return (0, c.isSet)(w.creatorAddress) && (P.creatorAddress = String(w.creatorAddress)), (0, c.isSet)(w.pagination) && (P.pagination = n.PageRequest.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.creatorAddress !== void 0 && (P.creatorAddress = w.creatorAddress), w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageRequest.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      const P = ne();
      return P.creatorAddress = w.creatorAddress ?? "", w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageRequest.fromPartial(w.pagination)), P;
    }
  };
  function H() {
    return {
      contractAddresses: [],
      pagination: void 0
    };
  }
  e.QueryContractsByCreatorResponse = {
    typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorResponse",
    encode(w, P = u.BinaryWriter.create()) {
      for (const J of w.contractAddresses)
        P.uint32(10).string(J);
      return w.pagination !== void 0 && n.PageResponse.encode(w.pagination, P.uint32(18).fork()).ldelim(), P;
    },
    decode(w, P) {
      const J = w instanceof u.BinaryReader ? w : new u.BinaryReader(w);
      let se = P === void 0 ? J.len : J.pos + P;
      const fe = H();
      for (; J.pos < se; ) {
        const N = J.uint32();
        switch (N >>> 3) {
          case 1:
            fe.contractAddresses.push(J.string());
            break;
          case 2:
            fe.pagination = n.PageResponse.decode(J, J.uint32());
            break;
          default:
            J.skipType(N & 7);
            break;
        }
      }
      return fe;
    },
    fromJSON(w) {
      const P = H();
      return Array.isArray(w == null ? void 0 : w.contractAddresses) && (P.contractAddresses = w.contractAddresses.map((J) => String(J))), (0, c.isSet)(w.pagination) && (P.pagination = n.PageResponse.fromJSON(w.pagination)), P;
    },
    toJSON(w) {
      const P = {};
      return w.contractAddresses ? P.contractAddresses = w.contractAddresses.map((J) => J) : P.contractAddresses = [], w.pagination !== void 0 && (P.pagination = w.pagination ? n.PageResponse.toJSON(w.pagination) : void 0), P;
    },
    fromPartial(w) {
      var J;
      const P = H();
      return P.contractAddresses = ((J = w.contractAddresses) == null ? void 0 : J.map((se) => se)) || [], w.pagination !== void 0 && w.pagination !== null && (P.pagination = n.PageResponse.fromPartial(w.pagination)), P;
    }
  };
  class C {
    constructor(P) {
      this.rpc = P, this.ContractInfo = this.ContractInfo.bind(this), this.ContractHistory = this.ContractHistory.bind(this), this.ContractsByCode = this.ContractsByCode.bind(this), this.AllContractState = this.AllContractState.bind(this), this.RawContractState = this.RawContractState.bind(this), this.SmartContractState = this.SmartContractState.bind(this), this.Code = this.Code.bind(this), this.Codes = this.Codes.bind(this), this.PinnedCodes = this.PinnedCodes.bind(this), this.Params = this.Params.bind(this), this.ContractsByCreator = this.ContractsByCreator.bind(this);
    }
    ContractInfo(P) {
      const J = e.QueryContractInfoRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractInfo", J).then((fe) => e.QueryContractInfoResponse.decode(new u.BinaryReader(fe)));
    }
    ContractHistory(P) {
      const J = e.QueryContractHistoryRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractHistory", J).then((fe) => e.QueryContractHistoryResponse.decode(new u.BinaryReader(fe)));
    }
    ContractsByCode(P) {
      const J = e.QueryContractsByCodeRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCode", J).then((fe) => e.QueryContractsByCodeResponse.decode(new u.BinaryReader(fe)));
    }
    AllContractState(P) {
      const J = e.QueryAllContractStateRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "AllContractState", J).then((fe) => e.QueryAllContractStateResponse.decode(new u.BinaryReader(fe)));
    }
    RawContractState(P) {
      const J = e.QueryRawContractStateRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "RawContractState", J).then((fe) => e.QueryRawContractStateResponse.decode(new u.BinaryReader(fe)));
    }
    SmartContractState(P) {
      const J = e.QuerySmartContractStateRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "SmartContractState", J).then((fe) => e.QuerySmartContractStateResponse.decode(new u.BinaryReader(fe)));
    }
    Code(P) {
      const J = e.QueryCodeRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "Code", J).then((fe) => e.QueryCodeResponse.decode(new u.BinaryReader(fe)));
    }
    Codes(P = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const J = e.QueryCodesRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "Codes", J).then((fe) => e.QueryCodesResponse.decode(new u.BinaryReader(fe)));
    }
    PinnedCodes(P = {
      pagination: n.PageRequest.fromPartial({})
    }) {
      const J = e.QueryPinnedCodesRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "PinnedCodes", J).then((fe) => e.QueryPinnedCodesResponse.decode(new u.BinaryReader(fe)));
    }
    Params(P = {}) {
      const J = e.QueryParamsRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "Params", J).then((fe) => e.QueryParamsResponse.decode(new u.BinaryReader(fe)));
    }
    ContractsByCreator(P) {
      const J = e.QueryContractsByCreatorRequest.encode(P).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCreator", J).then((fe) => e.QueryContractsByCreatorResponse.decode(new u.BinaryReader(fe)));
    }
  }
  e.QueryClientImpl = C;
})(query);
Object.defineProperty(queries$b, "__esModule", { value: !0 });
queries$b.setupWasmExtension = void 0;
const encoding_1$u = build$n, stargate_1$2 = build$S, query_1$a = query;
function setupWasmExtension(e) {
  const n = (0, stargate_1$2.createProtobufRpcClient)(e), o = new query_1$a.QueryClientImpl(n);
  return {
    wasm: {
      listCodeInfo: async (u) => {
        const c = {
          pagination: (0, stargate_1$2.createPagination)(u)
        };
        return o.Codes(c);
      },
      getCode: async (u) => {
        const c = query_1$a.QueryCodeRequest.fromPartial({ codeId: BigInt(u) });
        return o.Code(c);
      },
      listContractsByCodeId: async (u, c) => {
        const d = query_1$a.QueryContractsByCodeRequest.fromPartial({
          codeId: BigInt(u),
          pagination: (0, stargate_1$2.createPagination)(c)
        });
        return o.ContractsByCode(d);
      },
      listContractsByCreator: async (u, c) => {
        const d = {
          creatorAddress: u,
          pagination: (0, stargate_1$2.createPagination)(c)
        };
        return o.ContractsByCreator(d);
      },
      getContractInfo: async (u) => {
        const c = { address: u };
        return o.ContractInfo(c);
      },
      getContractCodeHistory: async (u, c) => {
        const d = {
          address: u,
          pagination: (0, stargate_1$2.createPagination)(c)
        };
        return o.ContractHistory(d);
      },
      getAllContractState: async (u, c) => {
        const d = {
          address: u,
          pagination: (0, stargate_1$2.createPagination)(c)
        };
        return o.AllContractState(d);
      },
      queryContractRaw: async (u, c) => {
        const d = { address: u, queryData: c };
        return o.RawContractState(d);
      },
      queryContractSmart: async (u, c) => {
        const d = { address: u, queryData: (0, encoding_1$u.toUtf8)(JSON.stringify(c)) }, { data: m } = await o.SmartContractState(d);
        let v;
        try {
          v = (0, encoding_1$u.fromUtf8)(m);
        } catch (S) {
          throw new Error(`Could not UTF-8 decode smart query response from contract: ${S}`);
        }
        try {
          return JSON.parse(v);
        } catch (S) {
          throw new Error(`Could not JSON parse smart query response from contract: ${S}`);
        }
      }
    }
  };
}
queries$b.setupWasmExtension = setupWasmExtension;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.setupWasmExtension = e.wasmTypes = e.isMsgUpdateAdminEncodeObject = e.isMsgStoreCodeEncodeObject = e.isMsgMigrateEncodeObject = e.isMsgInstantiateContractEncodeObject = e.isMsgInstantiateContract2EncodeObject = e.isMsgExecuteEncodeObject = e.isMsgClearAdminEncodeObject = e.createWasmAminoConverters = void 0;
  var n = aminomessages$b;
  Object.defineProperty(e, "createWasmAminoConverters", { enumerable: !0, get: function() {
    return n.createWasmAminoConverters;
  } });
  var o = messages$9;
  Object.defineProperty(e, "isMsgClearAdminEncodeObject", { enumerable: !0, get: function() {
    return o.isMsgClearAdminEncodeObject;
  } }), Object.defineProperty(e, "isMsgExecuteEncodeObject", { enumerable: !0, get: function() {
    return o.isMsgExecuteEncodeObject;
  } }), Object.defineProperty(e, "isMsgInstantiateContract2EncodeObject", { enumerable: !0, get: function() {
    return o.isMsgInstantiateContract2EncodeObject;
  } }), Object.defineProperty(e, "isMsgInstantiateContractEncodeObject", { enumerable: !0, get: function() {
    return o.isMsgInstantiateContractEncodeObject;
  } }), Object.defineProperty(e, "isMsgMigrateEncodeObject", { enumerable: !0, get: function() {
    return o.isMsgMigrateEncodeObject;
  } }), Object.defineProperty(e, "isMsgStoreCodeEncodeObject", { enumerable: !0, get: function() {
    return o.isMsgStoreCodeEncodeObject;
  } }), Object.defineProperty(e, "isMsgUpdateAdminEncodeObject", { enumerable: !0, get: function() {
    return o.isMsgUpdateAdminEncodeObject;
  } }), Object.defineProperty(e, "wasmTypes", { enumerable: !0, get: function() {
    return o.wasmTypes;
  } });
  var u = queries$b;
  Object.defineProperty(e, "setupWasmExtension", { enumerable: !0, get: function() {
    return u.setupWasmExtension;
  } });
})(modules$1);
Object.defineProperty(cosmwasmclient, "__esModule", { value: !0 });
cosmwasmclient.CosmWasmClient = void 0;
const encoding_1$t = build$n, math_1$g = build$m, stargate_1$1 = build$S, tendermint_rpc_1$2 = build$l, utils_1$r = build$j, abci_1 = abci, types_1$2 = types$5, modules_1$2 = modules$1;
class CosmWasmClient {
  /**
   * Creates an instance by connecting to the given CometBFT RPC endpoint.
   *
   * This uses auto-detection to decide between a CometBFT 0.38, Tendermint 0.37 and 0.34 client.
   * To set the Comet client explicitly, use `create`.
   */
  static async connect(n) {
    const o = await (0, tendermint_rpc_1$2.connectComet)(n);
    return CosmWasmClient.create(o);
  }
  /**
   * Creates an instance from a manually created Comet client.
   * Use this to use `Comet38Client` or `Tendermint37Client` instead of `Tendermint34Client`.
   */
  static async create(n) {
    return new CosmWasmClient(n);
  }
  constructor(n) {
    this.codesCache = /* @__PURE__ */ new Map(), n && (this.cometClient = n, this.queryClient = stargate_1$1.QueryClient.withExtensions(n, stargate_1$1.setupAuthExtension, stargate_1$1.setupBankExtension, modules_1$2.setupWasmExtension, stargate_1$1.setupTxExtension));
  }
  getCometClient() {
    return this.cometClient;
  }
  forceGetCometClient() {
    if (!this.cometClient)
      throw new Error("Comet client not available. You cannot use online functionality in offline mode.");
    return this.cometClient;
  }
  getQueryClient() {
    return this.queryClient;
  }
  forceGetQueryClient() {
    if (!this.queryClient)
      throw new Error("Query client not available. You cannot use online functionality in offline mode.");
    return this.queryClient;
  }
  async getChainId() {
    if (!this.chainId) {
      const o = (await this.forceGetCometClient().status()).nodeInfo.network;
      if (!o)
        throw new Error("Chain ID must not be empty");
      this.chainId = o;
    }
    return this.chainId;
  }
  async getHeight() {
    return (await this.forceGetCometClient().status()).syncInfo.latestBlockHeight;
  }
  async getAccount(n) {
    try {
      const o = await this.forceGetQueryClient().auth.account(n);
      return o ? (0, stargate_1$1.accountFromAny)(o) : null;
    } catch (o) {
      if (/rpc error: code = NotFound/i.test(o.toString()))
        return null;
      throw o;
    }
  }
  async getSequence(n) {
    const o = await this.getAccount(n);
    if (!o)
      throw new Error(`Account '${n}' does not exist on chain. Send some tokens there before trying to query sequence.`);
    return {
      accountNumber: o.accountNumber,
      sequence: o.sequence
    };
  }
  async getBlock(n) {
    const o = await this.forceGetCometClient().block(n);
    return {
      id: (0, encoding_1$t.toHex)(o.blockId.hash).toUpperCase(),
      header: {
        version: {
          block: new math_1$g.Uint53(o.block.header.version.block).toString(),
          app: new math_1$g.Uint53(o.block.header.version.app).toString()
        },
        height: o.block.header.height,
        chainId: o.block.header.chainId,
        time: (0, tendermint_rpc_1$2.toRfc3339WithNanoseconds)(o.block.header.time)
      },
      txs: o.block.txs
    };
  }
  async getBalance(n, o) {
    return this.forceGetQueryClient().bank.balance(n, o);
  }
  async getTx(n) {
    return (await this.txsQuery(`tx.hash='${n}'`))[0] ?? null;
  }
  async searchTx(n) {
    let o;
    if (typeof n == "string")
      o = n;
    else if ((0, stargate_1$1.isSearchTxQueryArray)(n))
      o = n.map((u) => typeof u.value == "string" ? `${u.key}='${u.value}'` : `${u.key}=${u.value}`).join(" AND ");
    else
      throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
    return this.txsQuery(o);
  }
  disconnect() {
    this.cometClient && this.cometClient.disconnect();
  }
  /**
   * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
   *
   * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
   * usually needs to check for execution success or failure.
   */
  // NOTE: This method is tested against slow chains and timeouts in the @cosmjs/stargate package.
  // Make sure it is kept in sync!
  async broadcastTx(n, o = 6e4, u = 3e3) {
    let c = !1;
    const d = setTimeout(() => {
      c = !0;
    }, o), m = async (S) => {
      if (c)
        throw new stargate_1$1.TimeoutError(`Transaction with ID ${S} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${o / 1e3} seconds.`, S);
      await (0, utils_1$r.sleep)(u);
      const $ = await this.getTx(S);
      return $ ? {
        code: $.code,
        height: $.height,
        txIndex: $.txIndex,
        rawLog: $.rawLog,
        transactionHash: S,
        events: $.events,
        msgResponses: $.msgResponses,
        gasUsed: $.gasUsed,
        gasWanted: $.gasWanted
      } : m(S);
    }, v = await this.broadcastTxSync(n);
    return new Promise((S, $) => m(v).then((E) => {
      clearTimeout(d), S(E);
    }, (E) => {
      clearTimeout(d), $(E);
    }));
  }
  /**
   * Broadcasts a signed transaction to the network without monitoring it.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
   * usually needs to check if the transaction was included in a block and was successful.
   *
   * @returns Returns the hash of the transaction
   */
  async broadcastTxSync(n) {
    const o = await this.forceGetCometClient().broadcastTxSync({ tx: n });
    return o.code ? Promise.reject(new stargate_1$1.BroadcastTxError(o.code, o.codespace ?? "", o.log)) : (0, encoding_1$t.toHex)(o.hash).toUpperCase();
  }
  /**
   * getCodes() returns all codes and is just looping through all pagination pages.
   *
   * This is potentially inefficient and advanced apps should consider creating
   * their own query client to handle pagination together with the app's screens.
   */
  async getCodes() {
    const n = [];
    let o;
    do {
      const { codeInfos: u, pagination: c } = await this.forceGetQueryClient().wasm.listCodeInfo(o), d = u || [];
      n.push(...d), o = c == null ? void 0 : c.nextKey;
    } while ((o == null ? void 0 : o.length) !== 0);
    return n.map((u) => ((0, utils_1$r.assert)(u.creator && u.codeId && u.dataHash, "entry incomplete"), {
      id: Number(u.codeId),
      creator: u.creator,
      checksum: (0, encoding_1$t.toHex)(u.dataHash)
    }));
  }
  async getCodeDetails(n) {
    const o = this.codesCache.get(n);
    if (o)
      return o;
    const { codeInfo: u, data: c } = await this.forceGetQueryClient().wasm.getCode(n);
    (0, utils_1$r.assert)(u && u.codeId && u.creator && u.dataHash && c, "codeInfo missing or incomplete");
    const d = {
      id: Number(u.codeId),
      creator: u.creator,
      checksum: (0, encoding_1$t.toHex)(u.dataHash),
      data: c
    };
    return this.codesCache.set(n, d), d;
  }
  /**
   * getContracts() returns all contract instances for one code and is just looping through all pagination pages.
   *
   * This is potentially inefficient and advanced apps should consider creating
   * their own query client to handle pagination together with the app's screens.
   */
  async getContracts(n) {
    const o = [];
    let u;
    do {
      const { contracts: c, pagination: d } = await this.forceGetQueryClient().wasm.listContractsByCodeId(n, u);
      o.push(...c), u = d == null ? void 0 : d.nextKey;
    } while ((u == null ? void 0 : u.length) !== 0 && u !== void 0);
    return o;
  }
  /**
   * Returns a list of contract addresses created by the given creator.
   * This just loops through all pagination pages.
   */
  async getContractsByCreator(n) {
    const o = [];
    let u;
    do {
      const { contractAddresses: c, pagination: d } = await this.forceGetQueryClient().wasm.listContractsByCreator(n, u);
      o.push(...c), u = d == null ? void 0 : d.nextKey;
    } while ((u == null ? void 0 : u.length) !== 0 && u !== void 0);
    return o;
  }
  /**
   * Throws an error if no contract was found at the address
   */
  async getContract(n) {
    const { address: o, contractInfo: u } = await this.forceGetQueryClient().wasm.getContractInfo(n);
    if (!u)
      throw new Error(`No contract found at address "${n}"`);
    return (0, utils_1$r.assert)(o, "address missing"), (0, utils_1$r.assert)(u.codeId && u.creator && u.label, "contractInfo incomplete"), {
      address: o,
      codeId: Number(u.codeId),
      creator: u.creator,
      admin: u.admin || void 0,
      label: u.label,
      ibcPortId: u.ibcPortId || void 0
    };
  }
  /**
   * Throws an error if no contract was found at the address
   */
  async getContractCodeHistory(n) {
    const o = await this.forceGetQueryClient().wasm.getContractCodeHistory(n);
    if (!o)
      throw new Error(`No contract history found for address "${n}"`);
    const u = {
      [types_1$2.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT]: "Init",
      [types_1$2.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS]: "Genesis",
      [types_1$2.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE]: "Migrate"
    };
    return (o.entries || []).map((c) => ((0, utils_1$r.assert)(c.operation && c.codeId && c.msg), {
      operation: u[c.operation],
      codeId: Number(c.codeId),
      msg: JSON.parse((0, encoding_1$t.fromUtf8)(c.msg))
    }));
  }
  /**
   * Returns the data at the key if present (raw contract dependent storage data)
   * or null if no data at this key.
   *
   * Promise is rejected when contract does not exist.
   */
  async queryContractRaw(n, o) {
    await this.getContract(n);
    const { data: u } = await this.forceGetQueryClient().wasm.queryContractRaw(n, o);
    return u ?? null;
  }
  /**
   * Makes a smart query on the contract, returns the parsed JSON document.
   *
   * Promise is rejected when contract does not exist.
   * Promise is rejected for invalid query format.
   * Promise is rejected for invalid response format.
   */
  async queryContractSmart(n, o) {
    try {
      return await this.forceGetQueryClient().wasm.queryContractSmart(n, o);
    } catch (u) {
      throw u instanceof Error && u.message.startsWith("not found: contract") ? new Error(`No contract found at address "${n}"`) : u;
    }
  }
  async txsQuery(n) {
    return (await this.forceGetCometClient().txSearchAll({ query: n })).txs.map((u) => {
      const c = abci_1.TxMsgData.decode(u.result.data ?? new Uint8Array());
      return {
        height: u.height,
        txIndex: u.index,
        hash: (0, encoding_1$t.toHex)(u.hash).toUpperCase(),
        code: u.result.code,
        events: u.result.events.map(stargate_1$1.fromTendermintEvent),
        rawLog: u.result.log || "",
        tx: u.tx,
        msgResponses: c.msgResponses,
        gasUsed: u.result.gasUsed,
        gasWanted: u.result.gasWanted
      };
    });
  }
}
cosmwasmclient.CosmWasmClient = CosmWasmClient;
var encoding$1 = {};
Object.defineProperty(encoding$1, "__esModule", { value: !0 });
encoding$1.fromBinary = encoding$1.toBinary = void 0;
const encoding_1$s = build$n;
function toBinary(e) {
  return (0, encoding_1$s.toBase64)((0, encoding_1$s.toUtf8)(JSON.stringify(e)));
}
encoding$1.toBinary = toBinary;
function fromBinary(e) {
  return JSON.parse((0, encoding_1$s.fromUtf8)((0, encoding_1$s.fromBase64)(e)));
}
encoding$1.fromBinary = fromBinary;
var instantiate2 = {};
Object.defineProperty(instantiate2, "__esModule", { value: !0 });
instantiate2.instantiate2Address = instantiate2._instantiate2AddressIntermediate = void 0;
const crypto_1$b = build$k, encoding_1$r = build$n, math_1$f = build$m, utils_1$q = build$j;
function hash(e, n) {
  return new crypto_1$b.Sha256((0, crypto_1$b.sha256)((0, encoding_1$r.toAscii)(e))).update(n).digest();
}
function toUint64(e) {
  return math_1$f.Uint64.fromNumber(e).toBytesBigEndian();
}
function _instantiate2AddressIntermediate(e, n, o, u, c) {
  (0, utils_1$q.assert)(e.length === 32);
  const d = (0, encoding_1$r.fromBech32)(n).data, m = typeof u == "string" ? (0, encoding_1$r.toUtf8)(u) : new Uint8Array();
  if (o.length < 1 || o.length > 64)
    throw new Error("Salt must be between 1 and 64 bytes");
  const v = new Uint8Array([
    ...(0, encoding_1$r.toAscii)("wasm"),
    0,
    ...toUint64(e.length),
    ...e,
    ...toUint64(d.length),
    ...d,
    ...toUint64(o.length),
    ...o,
    ...toUint64(m.length),
    ...m
  ]), S = hash("module", v), $ = (0, encoding_1$r.toBech32)(c, S);
  return { key: v, addressData: S, address: $ };
}
instantiate2._instantiate2AddressIntermediate = _instantiate2AddressIntermediate;
function instantiate2Address(e, n, o, u) {
  return _instantiate2AddressIntermediate(e, n, o, null, u).address;
}
instantiate2.instantiate2Address = instantiate2Address;
var signingcosmwasmclient = {}, pako = {}, deflate$4 = {}, deflate$3 = {}, trees = {};
const Z_FIXED$1 = 4, Z_BINARY = 0, Z_TEXT = 1, Z_UNKNOWN$1 = 2;
function zero$1(e) {
  let n = e.length;
  for (; --n >= 0; )
    e[n] = 0;
}
const STORED_BLOCK = 0, STATIC_TREES = 1, DYN_TREES = 2, MIN_MATCH$1 = 3, MAX_MATCH$1 = 258, LENGTH_CODES$1 = 29, LITERALS$1 = 256, L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1, D_CODES$1 = 30, BL_CODES$1 = 19, HEAP_SIZE$1 = 2 * L_CODES$1 + 1, MAX_BITS$1 = 15, Buf_size = 16, MAX_BL_BITS = 7, END_BLOCK = 256, REP_3_6 = 16, REPZ_3_10 = 17, REPZ_11_138 = 18, extra_lbits = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), extra_dbits = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), extra_blbits = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), DIST_CODE_LEN = 512, static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
const static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
const _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
const _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
const base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
const base_dist = new Array(D_CODES$1);
zero$1(base_dist);
function StaticTreeDesc(e, n, o, u, c) {
  this.static_tree = e, this.extra_bits = n, this.extra_base = o, this.elems = u, this.max_length = c, this.has_stree = e && e.length;
}
let static_l_desc, static_d_desc, static_bl_desc;
function TreeDesc(e, n) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = n;
}
const d_code = (e) => e < 256 ? _dist_code[e] : _dist_code[256 + (e >>> 7)], put_short = (e, n) => {
  e.pending_buf[e.pending++] = n & 255, e.pending_buf[e.pending++] = n >>> 8 & 255;
}, send_bits = (e, n, o) => {
  e.bi_valid > Buf_size - o ? (e.bi_buf |= n << e.bi_valid & 65535, put_short(e, e.bi_buf), e.bi_buf = n >> Buf_size - e.bi_valid, e.bi_valid += o - Buf_size) : (e.bi_buf |= n << e.bi_valid & 65535, e.bi_valid += o);
}, send_code = (e, n, o) => {
  send_bits(
    e,
    o[n * 2],
    o[n * 2 + 1]
    /*.Len*/
  );
}, bi_reverse = (e, n) => {
  let o = 0;
  do
    o |= e & 1, e >>>= 1, o <<= 1;
  while (--n > 0);
  return o >>> 1;
}, bi_flush = (e) => {
  e.bi_valid === 16 ? (put_short(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}, gen_bitlen = (e, n) => {
  const o = n.dyn_tree, u = n.max_code, c = n.stat_desc.static_tree, d = n.stat_desc.has_stree, m = n.stat_desc.extra_bits, v = n.stat_desc.extra_base, S = n.stat_desc.max_length;
  let $, E, O, T, y, V, M = 0;
  for (T = 0; T <= MAX_BITS$1; T++)
    e.bl_count[T] = 0;
  for (o[e.heap[e.heap_max] * 2 + 1] = 0, $ = e.heap_max + 1; $ < HEAP_SIZE$1; $++)
    E = e.heap[$], T = o[o[E * 2 + 1] * 2 + 1] + 1, T > S && (T = S, M++), o[E * 2 + 1] = T, !(E > u) && (e.bl_count[T]++, y = 0, E >= v && (y = m[E - v]), V = o[E * 2], e.opt_len += V * (T + y), d && (e.static_len += V * (c[E * 2 + 1] + y)));
  if (M !== 0) {
    do {
      for (T = S - 1; e.bl_count[T] === 0; )
        T--;
      e.bl_count[T]--, e.bl_count[T + 1] += 2, e.bl_count[S]--, M -= 2;
    } while (M > 0);
    for (T = S; T !== 0; T--)
      for (E = e.bl_count[T]; E !== 0; )
        O = e.heap[--$], !(O > u) && (o[O * 2 + 1] !== T && (e.opt_len += (T - o[O * 2 + 1]) * o[O * 2], o[O * 2 + 1] = T), E--);
  }
}, gen_codes = (e, n, o) => {
  const u = new Array(MAX_BITS$1 + 1);
  let c = 0, d, m;
  for (d = 1; d <= MAX_BITS$1; d++)
    c = c + o[d - 1] << 1, u[d] = c;
  for (m = 0; m <= n; m++) {
    let v = e[m * 2 + 1];
    v !== 0 && (e[m * 2] = bi_reverse(u[v]++, v));
  }
}, tr_static_init = () => {
  let e, n, o, u, c;
  const d = new Array(MAX_BITS$1 + 1);
  for (o = 0, u = 0; u < LENGTH_CODES$1 - 1; u++)
    for (base_length[u] = o, e = 0; e < 1 << extra_lbits[u]; e++)
      _length_code[o++] = u;
  for (_length_code[o - 1] = u, c = 0, u = 0; u < 16; u++)
    for (base_dist[u] = c, e = 0; e < 1 << extra_dbits[u]; e++)
      _dist_code[c++] = u;
  for (c >>= 7; u < D_CODES$1; u++)
    for (base_dist[u] = c << 7, e = 0; e < 1 << extra_dbits[u] - 7; e++)
      _dist_code[256 + c++] = u;
  for (n = 0; n <= MAX_BITS$1; n++)
    d[n] = 0;
  for (e = 0; e <= 143; )
    static_ltree[e * 2 + 1] = 8, e++, d[8]++;
  for (; e <= 255; )
    static_ltree[e * 2 + 1] = 9, e++, d[9]++;
  for (; e <= 279; )
    static_ltree[e * 2 + 1] = 7, e++, d[7]++;
  for (; e <= 287; )
    static_ltree[e * 2 + 1] = 8, e++, d[8]++;
  for (gen_codes(static_ltree, L_CODES$1 + 1, d), e = 0; e < D_CODES$1; e++)
    static_dtree[e * 2 + 1] = 5, static_dtree[e * 2] = bi_reverse(e, 5);
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1), static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1), static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
}, init_block = (e) => {
  let n;
  for (n = 0; n < L_CODES$1; n++)
    e.dyn_ltree[n * 2] = 0;
  for (n = 0; n < D_CODES$1; n++)
    e.dyn_dtree[n * 2] = 0;
  for (n = 0; n < BL_CODES$1; n++)
    e.bl_tree[n * 2] = 0;
  e.dyn_ltree[END_BLOCK * 2] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
}, bi_windup = (e) => {
  e.bi_valid > 8 ? put_short(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, smaller = (e, n, o, u) => {
  const c = n * 2, d = o * 2;
  return e[c] < e[d] || e[c] === e[d] && u[n] <= u[o];
}, pqdownheap = (e, n, o) => {
  const u = e.heap[o];
  let c = o << 1;
  for (; c <= e.heap_len && (c < e.heap_len && smaller(n, e.heap[c + 1], e.heap[c], e.depth) && c++, !smaller(n, u, e.heap[c], e.depth)); )
    e.heap[o] = e.heap[c], o = c, c <<= 1;
  e.heap[o] = u;
}, compress_block = (e, n, o) => {
  let u, c, d = 0, m, v;
  if (e.sym_next !== 0)
    do
      u = e.pending_buf[e.sym_buf + d++] & 255, u += (e.pending_buf[e.sym_buf + d++] & 255) << 8, c = e.pending_buf[e.sym_buf + d++], u === 0 ? send_code(e, c, n) : (m = _length_code[c], send_code(e, m + LITERALS$1 + 1, n), v = extra_lbits[m], v !== 0 && (c -= base_length[m], send_bits(e, c, v)), u--, m = d_code(u), send_code(e, m, o), v = extra_dbits[m], v !== 0 && (u -= base_dist[m], send_bits(e, u, v)));
    while (d < e.sym_next);
  send_code(e, END_BLOCK, n);
}, build_tree = (e, n) => {
  const o = n.dyn_tree, u = n.stat_desc.static_tree, c = n.stat_desc.has_stree, d = n.stat_desc.elems;
  let m, v, S = -1, $;
  for (e.heap_len = 0, e.heap_max = HEAP_SIZE$1, m = 0; m < d; m++)
    o[m * 2] !== 0 ? (e.heap[++e.heap_len] = S = m, e.depth[m] = 0) : o[m * 2 + 1] = 0;
  for (; e.heap_len < 2; )
    $ = e.heap[++e.heap_len] = S < 2 ? ++S : 0, o[$ * 2] = 1, e.depth[$] = 0, e.opt_len--, c && (e.static_len -= u[$ * 2 + 1]);
  for (n.max_code = S, m = e.heap_len >> 1; m >= 1; m--)
    pqdownheap(e, o, m);
  $ = d;
  do
    m = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[
      1
      /*SMALLEST*/
    ] = e.heap[e.heap_len--], pqdownheap(
      e,
      o,
      1
      /*SMALLEST*/
    ), v = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[--e.heap_max] = m, e.heap[--e.heap_max] = v, o[$ * 2] = o[m * 2] + o[v * 2], e.depth[$] = (e.depth[m] >= e.depth[v] ? e.depth[m] : e.depth[v]) + 1, o[m * 2 + 1] = o[v * 2 + 1] = $, e.heap[
      1
      /*SMALLEST*/
    ] = $++, pqdownheap(
      e,
      o,
      1
      /*SMALLEST*/
    );
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[
    1
    /*SMALLEST*/
  ], gen_bitlen(e, n), gen_codes(o, S, e.bl_count);
}, scan_tree = (e, n, o) => {
  let u, c = -1, d, m = n[0 * 2 + 1], v = 0, S = 7, $ = 4;
  for (m === 0 && (S = 138, $ = 3), n[(o + 1) * 2 + 1] = 65535, u = 0; u <= o; u++)
    d = m, m = n[(u + 1) * 2 + 1], !(++v < S && d === m) && (v < $ ? e.bl_tree[d * 2] += v : d !== 0 ? (d !== c && e.bl_tree[d * 2]++, e.bl_tree[REP_3_6 * 2]++) : v <= 10 ? e.bl_tree[REPZ_3_10 * 2]++ : e.bl_tree[REPZ_11_138 * 2]++, v = 0, c = d, m === 0 ? (S = 138, $ = 3) : d === m ? (S = 6, $ = 3) : (S = 7, $ = 4));
}, send_tree = (e, n, o) => {
  let u, c = -1, d, m = n[0 * 2 + 1], v = 0, S = 7, $ = 4;
  for (m === 0 && (S = 138, $ = 3), u = 0; u <= o; u++)
    if (d = m, m = n[(u + 1) * 2 + 1], !(++v < S && d === m)) {
      if (v < $)
        do
          send_code(e, d, e.bl_tree);
        while (--v !== 0);
      else
        d !== 0 ? (d !== c && (send_code(e, d, e.bl_tree), v--), send_code(e, REP_3_6, e.bl_tree), send_bits(e, v - 3, 2)) : v <= 10 ? (send_code(e, REPZ_3_10, e.bl_tree), send_bits(e, v - 3, 3)) : (send_code(e, REPZ_11_138, e.bl_tree), send_bits(e, v - 11, 7));
      v = 0, c = d, m === 0 ? (S = 138, $ = 3) : d === m ? (S = 6, $ = 3) : (S = 7, $ = 4);
    }
}, build_bl_tree = (e) => {
  let n;
  for (scan_tree(e, e.dyn_ltree, e.l_desc.max_code), scan_tree(e, e.dyn_dtree, e.d_desc.max_code), build_tree(e, e.bl_desc), n = BL_CODES$1 - 1; n >= 3 && e.bl_tree[bl_order[n] * 2 + 1] === 0; n--)
    ;
  return e.opt_len += 3 * (n + 1) + 5 + 5 + 4, n;
}, send_all_trees = (e, n, o, u) => {
  let c;
  for (send_bits(e, n - 257, 5), send_bits(e, o - 1, 5), send_bits(e, u - 4, 4), c = 0; c < u; c++)
    send_bits(e, e.bl_tree[bl_order[c] * 2 + 1], 3);
  send_tree(e, e.dyn_ltree, n - 1), send_tree(e, e.dyn_dtree, o - 1);
}, detect_data_type = (e) => {
  let n = 4093624447, o;
  for (o = 0; o <= 31; o++, n >>>= 1)
    if (n & 1 && e.dyn_ltree[o * 2] !== 0)
      return Z_BINARY;
  if (e.dyn_ltree[9 * 2] !== 0 || e.dyn_ltree[10 * 2] !== 0 || e.dyn_ltree[13 * 2] !== 0)
    return Z_TEXT;
  for (o = 32; o < LITERALS$1; o++)
    if (e.dyn_ltree[o * 2] !== 0)
      return Z_TEXT;
  return Z_BINARY;
};
let static_init_done = !1;
const _tr_init$1 = (e) => {
  static_init_done || (tr_static_init(), static_init_done = !0), e.l_desc = new TreeDesc(e.dyn_ltree, static_l_desc), e.d_desc = new TreeDesc(e.dyn_dtree, static_d_desc), e.bl_desc = new TreeDesc(e.bl_tree, static_bl_desc), e.bi_buf = 0, e.bi_valid = 0, init_block(e);
}, _tr_stored_block$1 = (e, n, o, u) => {
  send_bits(e, (STORED_BLOCK << 1) + (u ? 1 : 0), 3), bi_windup(e), put_short(e, o), put_short(e, ~o), o && e.pending_buf.set(e.window.subarray(n, n + o), e.pending), e.pending += o;
}, _tr_align$1 = (e) => {
  send_bits(e, STATIC_TREES << 1, 3), send_code(e, END_BLOCK, static_ltree), bi_flush(e);
}, _tr_flush_block$1 = (e, n, o, u) => {
  let c, d, m = 0;
  e.level > 0 ? (e.strm.data_type === Z_UNKNOWN$1 && (e.strm.data_type = detect_data_type(e)), build_tree(e, e.l_desc), build_tree(e, e.d_desc), m = build_bl_tree(e), c = e.opt_len + 3 + 7 >>> 3, d = e.static_len + 3 + 7 >>> 3, d <= c && (c = d)) : c = d = o + 5, o + 4 <= c && n !== -1 ? _tr_stored_block$1(e, n, o, u) : e.strategy === Z_FIXED$1 || d === c ? (send_bits(e, (STATIC_TREES << 1) + (u ? 1 : 0), 3), compress_block(e, static_ltree, static_dtree)) : (send_bits(e, (DYN_TREES << 1) + (u ? 1 : 0), 3), send_all_trees(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, m + 1), compress_block(e, e.dyn_ltree, e.dyn_dtree)), init_block(e), u && bi_windup(e);
}, _tr_tally$1 = (e, n, o) => (e.pending_buf[e.sym_buf + e.sym_next++] = n, e.pending_buf[e.sym_buf + e.sym_next++] = n >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = o, n === 0 ? e.dyn_ltree[o * 2]++ : (e.matches++, n--, e.dyn_ltree[(_length_code[o] + LITERALS$1 + 1) * 2]++, e.dyn_dtree[d_code(n) * 2]++), e.sym_next === e.sym_end);
trees._tr_init = _tr_init$1;
trees._tr_stored_block = _tr_stored_block$1;
trees._tr_flush_block = _tr_flush_block$1;
trees._tr_tally = _tr_tally$1;
trees._tr_align = _tr_align$1;
const adler32$2 = (e, n, o, u) => {
  let c = e & 65535 | 0, d = e >>> 16 & 65535 | 0, m = 0;
  for (; o !== 0; ) {
    m = o > 2e3 ? 2e3 : o, o -= m;
    do
      c = c + n[u++] | 0, d = d + c | 0;
    while (--m);
    c %= 65521, d %= 65521;
  }
  return c | d << 16 | 0;
};
var adler32_1 = adler32$2;
const makeTable = () => {
  let e, n = [];
  for (var o = 0; o < 256; o++) {
    e = o;
    for (var u = 0; u < 8; u++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    n[o] = e;
  }
  return n;
}, crcTable = new Uint32Array(makeTable()), crc32$2 = (e, n, o, u) => {
  const c = crcTable, d = u + o;
  e ^= -1;
  for (let m = u; m < d; m++)
    e = e >>> 8 ^ c[(e ^ n[m]) & 255];
  return e ^ -1;
};
var crc32_1 = crc32$2, messages$8 = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, constants$5 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees, adler32$1 = adler32_1, crc32$1 = crc32_1, msg$2 = messages$8, {
  Z_NO_FLUSH: Z_NO_FLUSH$2,
  Z_PARTIAL_FLUSH,
  Z_FULL_FLUSH: Z_FULL_FLUSH$1,
  Z_FINISH: Z_FINISH$3,
  Z_BLOCK: Z_BLOCK$1,
  Z_OK: Z_OK$3,
  Z_STREAM_END: Z_STREAM_END$3,
  Z_STREAM_ERROR: Z_STREAM_ERROR$2,
  Z_DATA_ERROR: Z_DATA_ERROR$2,
  Z_BUF_ERROR: Z_BUF_ERROR$1,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED,
  Z_HUFFMAN_ONLY,
  Z_RLE,
  Z_FIXED,
  Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$2
} = constants$5, MAX_MEM_LEVEL = 9, MAX_WBITS$1 = 15, DEF_MEM_LEVEL = 8, LENGTH_CODES = 29, LITERALS = 256, L_CODES = LITERALS + 1 + LENGTH_CODES, D_CODES = 30, BL_CODES = 19, HEAP_SIZE = 2 * L_CODES + 1, MAX_BITS = 15, MIN_MATCH = 3, MAX_MATCH = 258, MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1, PRESET_DICT = 32, INIT_STATE = 42, GZIP_STATE = 57, EXTRA_STATE = 69, NAME_STATE = 73, COMMENT_STATE = 91, HCRC_STATE = 103, BUSY_STATE = 113, FINISH_STATE = 666, BS_NEED_MORE = 1, BS_BLOCK_DONE = 2, BS_FINISH_STARTED = 3, BS_FINISH_DONE = 4, OS_CODE = 3, err = (e, n) => (e.msg = msg$2[n], n), rank = (e) => e * 2 - (e > 4 ? 9 : 0), zero = (e) => {
  let n = e.length;
  for (; --n >= 0; )
    e[n] = 0;
}, slide_hash = (e) => {
  let n, o, u, c = e.w_size;
  n = e.hash_size, u = n;
  do
    o = e.head[--u], e.head[u] = o >= c ? o - c : 0;
  while (--n);
  n = c, u = n;
  do
    o = e.prev[--u], e.prev[u] = o >= c ? o - c : 0;
  while (--n);
};
let HASH_ZLIB = (e, n, o) => (n << e.hash_shift ^ o) & e.hash_mask, HASH = HASH_ZLIB;
const flush_pending = (e) => {
  const n = e.state;
  let o = n.pending;
  o > e.avail_out && (o = e.avail_out), o !== 0 && (e.output.set(n.pending_buf.subarray(n.pending_out, n.pending_out + o), e.next_out), e.next_out += o, n.pending_out += o, e.total_out += o, e.avail_out -= o, n.pending -= o, n.pending === 0 && (n.pending_out = 0));
}, flush_block_only = (e, n) => {
  _tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, n), e.block_start = e.strstart, flush_pending(e.strm);
}, put_byte = (e, n) => {
  e.pending_buf[e.pending++] = n;
}, putShortMSB = (e, n) => {
  e.pending_buf[e.pending++] = n >>> 8 & 255, e.pending_buf[e.pending++] = n & 255;
}, read_buf = (e, n, o, u) => {
  let c = e.avail_in;
  return c > u && (c = u), c === 0 ? 0 : (e.avail_in -= c, n.set(e.input.subarray(e.next_in, e.next_in + c), o), e.state.wrap === 1 ? e.adler = adler32$1(e.adler, n, c, o) : e.state.wrap === 2 && (e.adler = crc32$1(e.adler, n, c, o)), e.next_in += c, e.total_in += c, c);
}, longest_match = (e, n) => {
  let o = e.max_chain_length, u = e.strstart, c, d, m = e.prev_length, v = e.nice_match;
  const S = e.strstart > e.w_size - MIN_LOOKAHEAD ? e.strstart - (e.w_size - MIN_LOOKAHEAD) : 0, $ = e.window, E = e.w_mask, O = e.prev, T = e.strstart + MAX_MATCH;
  let y = $[u + m - 1], V = $[u + m];
  e.prev_length >= e.good_match && (o >>= 2), v > e.lookahead && (v = e.lookahead);
  do
    if (c = n, !($[c + m] !== V || $[c + m - 1] !== y || $[c] !== $[u] || $[++c] !== $[u + 1])) {
      u += 2, c++;
      do
        ;
      while ($[++u] === $[++c] && $[++u] === $[++c] && $[++u] === $[++c] && $[++u] === $[++c] && $[++u] === $[++c] && $[++u] === $[++c] && $[++u] === $[++c] && $[++u] === $[++c] && u < T);
      if (d = MAX_MATCH - (T - u), u = T - MAX_MATCH, d > m) {
        if (e.match_start = n, m = d, d >= v)
          break;
        y = $[u + m - 1], V = $[u + m];
      }
    }
  while ((n = O[n & E]) > S && --o !== 0);
  return m <= e.lookahead ? m : e.lookahead;
}, fill_window = (e) => {
  const n = e.w_size;
  let o, u, c;
  do {
    if (u = e.window_size - e.lookahead - e.strstart, e.strstart >= n + (n - MIN_LOOKAHEAD) && (e.window.set(e.window.subarray(n, n + n - u), 0), e.match_start -= n, e.strstart -= n, e.block_start -= n, e.insert > e.strstart && (e.insert = e.strstart), slide_hash(e), u += n), e.strm.avail_in === 0)
      break;
    if (o = read_buf(e.strm, e.window, e.strstart + e.lookahead, u), e.lookahead += o, e.lookahead + e.insert >= MIN_MATCH)
      for (c = e.strstart - e.insert, e.ins_h = e.window[c], e.ins_h = HASH(e, e.ins_h, e.window[c + 1]); e.insert && (e.ins_h = HASH(e, e.ins_h, e.window[c + MIN_MATCH - 1]), e.prev[c & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = c, c++, e.insert--, !(e.lookahead + e.insert < MIN_MATCH)); )
        ;
  } while (e.lookahead < MIN_LOOKAHEAD && e.strm.avail_in !== 0);
}, deflate_stored = (e, n) => {
  let o = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, u, c, d, m = 0, v = e.strm.avail_in;
  do {
    if (u = 65535, d = e.bi_valid + 42 >> 3, e.strm.avail_out < d || (d = e.strm.avail_out - d, c = e.strstart - e.block_start, u > c + e.strm.avail_in && (u = c + e.strm.avail_in), u > d && (u = d), u < o && (u === 0 && n !== Z_FINISH$3 || n === Z_NO_FLUSH$2 || u !== c + e.strm.avail_in)))
      break;
    m = n === Z_FINISH$3 && u === c + e.strm.avail_in ? 1 : 0, _tr_stored_block(e, 0, 0, m), e.pending_buf[e.pending - 4] = u, e.pending_buf[e.pending - 3] = u >> 8, e.pending_buf[e.pending - 2] = ~u, e.pending_buf[e.pending - 1] = ~u >> 8, flush_pending(e.strm), c && (c > u && (c = u), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + c), e.strm.next_out), e.strm.next_out += c, e.strm.avail_out -= c, e.strm.total_out += c, e.block_start += c, u -= c), u && (read_buf(e.strm, e.strm.output, e.strm.next_out, u), e.strm.next_out += u, e.strm.avail_out -= u, e.strm.total_out += u);
  } while (m === 0);
  return v -= e.strm.avail_in, v && (v >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= v && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - v, e.strm.next_in), e.strstart), e.strstart += v, e.insert += v > e.w_size - e.insert ? e.w_size - e.insert : v), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), m ? BS_FINISH_DONE : n !== Z_NO_FLUSH$2 && n !== Z_FINISH$3 && e.strm.avail_in === 0 && e.strstart === e.block_start ? BS_BLOCK_DONE : (d = e.window_size - e.strstart, e.strm.avail_in > d && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, d += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), d > e.strm.avail_in && (d = e.strm.avail_in), d && (read_buf(e.strm, e.window, e.strstart, d), e.strstart += d, e.insert += d > e.w_size - e.insert ? e.w_size - e.insert : d), e.high_water < e.strstart && (e.high_water = e.strstart), d = e.bi_valid + 42 >> 3, d = e.pending_buf_size - d > 65535 ? 65535 : e.pending_buf_size - d, o = d > e.w_size ? e.w_size : d, c = e.strstart - e.block_start, (c >= o || (c || n === Z_FINISH$3) && n !== Z_NO_FLUSH$2 && e.strm.avail_in === 0 && c <= d) && (u = c > d ? d : c, m = n === Z_FINISH$3 && e.strm.avail_in === 0 && u === c ? 1 : 0, _tr_stored_block(e, e.block_start, u, m), e.block_start += u, flush_pending(e.strm)), m ? BS_FINISH_STARTED : BS_NEED_MORE);
}, deflate_fast = (e, n) => {
  let o, u;
  for (; ; ) {
    if (e.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(e), e.lookahead < MIN_LOOKAHEAD && n === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (o = 0, e.lookahead >= MIN_MATCH && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), o = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), o !== 0 && e.strstart - o <= e.w_size - MIN_LOOKAHEAD && (e.match_length = longest_match(e, o)), e.match_length >= MIN_MATCH)
      if (u = _tr_tally(e, e.strstart - e.match_start, e.match_length - MIN_MATCH), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= MIN_MATCH) {
        e.match_length--;
        do
          e.strstart++, e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), o = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
        while (--e.match_length !== 0);
        e.strstart++;
      } else
        e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + 1]);
    else
      u = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (u && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = e.strstart < MIN_MATCH - 1 ? e.strstart : MIN_MATCH - 1, n === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.sym_next && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_slow = (e, n) => {
  let o, u, c;
  for (; ; ) {
    if (e.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(e), e.lookahead < MIN_LOOKAHEAD && n === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (o = 0, e.lookahead >= MIN_MATCH && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), o = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = MIN_MATCH - 1, o !== 0 && e.prev_length < e.max_lazy_match && e.strstart - o <= e.w_size - MIN_LOOKAHEAD && (e.match_length = longest_match(e, o), e.match_length <= 5 && (e.strategy === Z_FILTERED || e.match_length === MIN_MATCH && e.strstart - e.match_start > 4096) && (e.match_length = MIN_MATCH - 1)), e.prev_length >= MIN_MATCH && e.match_length <= e.prev_length) {
      c = e.strstart + e.lookahead - MIN_MATCH, u = _tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - MIN_MATCH), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= c && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), o = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
      while (--e.prev_length !== 0);
      if (e.match_available = 0, e.match_length = MIN_MATCH - 1, e.strstart++, u && (flush_block_only(e, !1), e.strm.avail_out === 0))
        return BS_NEED_MORE;
    } else if (e.match_available) {
      if (u = _tr_tally(e, 0, e.window[e.strstart - 1]), u && flush_block_only(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0)
        return BS_NEED_MORE;
    } else
      e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (u = _tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < MIN_MATCH - 1 ? e.strstart : MIN_MATCH - 1, n === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.sym_next && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_rle = (e, n) => {
  let o, u, c, d;
  const m = e.window;
  for (; ; ) {
    if (e.lookahead <= MAX_MATCH) {
      if (fill_window(e), e.lookahead <= MAX_MATCH && n === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (e.match_length = 0, e.lookahead >= MIN_MATCH && e.strstart > 0 && (c = e.strstart - 1, u = m[c], u === m[++c] && u === m[++c] && u === m[++c])) {
      d = e.strstart + MAX_MATCH;
      do
        ;
      while (u === m[++c] && u === m[++c] && u === m[++c] && u === m[++c] && u === m[++c] && u === m[++c] && u === m[++c] && u === m[++c] && c < d);
      e.match_length = MAX_MATCH - (d - c), e.match_length > e.lookahead && (e.match_length = e.lookahead);
    }
    if (e.match_length >= MIN_MATCH ? (o = _tr_tally(e, 1, e.match_length - MIN_MATCH), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (o = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), o && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = 0, n === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.sym_next && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_huff = (e, n) => {
  let o;
  for (; ; ) {
    if (e.lookahead === 0 && (fill_window(e), e.lookahead === 0)) {
      if (n === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      break;
    }
    if (e.match_length = 0, o = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, o && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = 0, n === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.sym_next && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
};
function Config(e, n, o, u, c) {
  this.good_length = e, this.max_lazy = n, this.nice_length = o, this.max_chain = u, this.func = c;
}
const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),
  /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),
  /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),
  /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),
  /* 3 */
  new Config(4, 4, 16, 16, deflate_slow),
  /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),
  /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),
  /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),
  /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),
  /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)
  /* 9 max compression */
], lm_init = (e) => {
  e.window_size = 2 * e.w_size, zero(e.head), e.max_lazy_match = configuration_table[e.level].max_lazy, e.good_match = configuration_table[e.level].good_length, e.nice_match = configuration_table[e.level].nice_length, e.max_chain_length = configuration_table[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = MIN_MATCH - 1, e.match_available = 0, e.ins_h = 0;
};
function DeflateState() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z_DEFLATED$2, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2), this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2), this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2), zero(this.dyn_ltree), zero(this.dyn_dtree), zero(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(MAX_BITS + 1), this.heap = new Uint16Array(2 * L_CODES + 1), zero(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * L_CODES + 1), zero(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const deflateStateCheck = (e) => {
  if (!e)
    return 1;
  const n = e.state;
  return !n || n.strm !== e || n.status !== INIT_STATE && //#ifdef GZIP
  n.status !== GZIP_STATE && //#endif
  n.status !== EXTRA_STATE && n.status !== NAME_STATE && n.status !== COMMENT_STATE && n.status !== HCRC_STATE && n.status !== BUSY_STATE && n.status !== FINISH_STATE ? 1 : 0;
}, deflateResetKeep = (e) => {
  if (deflateStateCheck(e))
    return err(e, Z_STREAM_ERROR$2);
  e.total_in = e.total_out = 0, e.data_type = Z_UNKNOWN;
  const n = e.state;
  return n.pending = 0, n.pending_out = 0, n.wrap < 0 && (n.wrap = -n.wrap), n.status = //#ifdef GZIP
  n.wrap === 2 ? GZIP_STATE : (
    //#endif
    n.wrap ? INIT_STATE : BUSY_STATE
  ), e.adler = n.wrap === 2 ? 0 : 1, n.last_flush = -2, _tr_init(n), Z_OK$3;
}, deflateReset = (e) => {
  const n = deflateResetKeep(e);
  return n === Z_OK$3 && lm_init(e.state), n;
}, deflateSetHeader = (e, n) => deflateStateCheck(e) || e.state.wrap !== 2 ? Z_STREAM_ERROR$2 : (e.state.gzhead = n, Z_OK$3), deflateInit2 = (e, n, o, u, c, d) => {
  if (!e)
    return Z_STREAM_ERROR$2;
  let m = 1;
  if (n === Z_DEFAULT_COMPRESSION$1 && (n = 6), u < 0 ? (m = 0, u = -u) : u > 15 && (m = 2, u -= 16), c < 1 || c > MAX_MEM_LEVEL || o !== Z_DEFLATED$2 || u < 8 || u > 15 || n < 0 || n > 9 || d < 0 || d > Z_FIXED || u === 8 && m !== 1)
    return err(e, Z_STREAM_ERROR$2);
  u === 8 && (u = 9);
  const v = new DeflateState();
  return e.state = v, v.strm = e, v.status = INIT_STATE, v.wrap = m, v.gzhead = null, v.w_bits = u, v.w_size = 1 << v.w_bits, v.w_mask = v.w_size - 1, v.hash_bits = c + 7, v.hash_size = 1 << v.hash_bits, v.hash_mask = v.hash_size - 1, v.hash_shift = ~~((v.hash_bits + MIN_MATCH - 1) / MIN_MATCH), v.window = new Uint8Array(v.w_size * 2), v.head = new Uint16Array(v.hash_size), v.prev = new Uint16Array(v.w_size), v.lit_bufsize = 1 << c + 6, v.pending_buf_size = v.lit_bufsize * 4, v.pending_buf = new Uint8Array(v.pending_buf_size), v.sym_buf = v.lit_bufsize, v.sym_end = (v.lit_bufsize - 1) * 3, v.level = n, v.strategy = d, v.method = o, deflateReset(e);
}, deflateInit = (e, n) => deflateInit2(e, n, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1), deflate$2 = (e, n) => {
  if (deflateStateCheck(e) || n > Z_BLOCK$1 || n < 0)
    return e ? err(e, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  const o = e.state;
  if (!e.output || e.avail_in !== 0 && !e.input || o.status === FINISH_STATE && n !== Z_FINISH$3)
    return err(e, e.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  const u = o.last_flush;
  if (o.last_flush = n, o.pending !== 0) {
    if (flush_pending(e), e.avail_out === 0)
      return o.last_flush = -1, Z_OK$3;
  } else if (e.avail_in === 0 && rank(n) <= rank(u) && n !== Z_FINISH$3)
    return err(e, Z_BUF_ERROR$1);
  if (o.status === FINISH_STATE && e.avail_in !== 0)
    return err(e, Z_BUF_ERROR$1);
  if (o.status === INIT_STATE && o.wrap === 0 && (o.status = BUSY_STATE), o.status === INIT_STATE) {
    let c = Z_DEFLATED$2 + (o.w_bits - 8 << 4) << 8, d = -1;
    if (o.strategy >= Z_HUFFMAN_ONLY || o.level < 2 ? d = 0 : o.level < 6 ? d = 1 : o.level === 6 ? d = 2 : d = 3, c |= d << 6, o.strstart !== 0 && (c |= PRESET_DICT), c += 31 - c % 31, putShortMSB(o, c), o.strstart !== 0 && (putShortMSB(o, e.adler >>> 16), putShortMSB(o, e.adler & 65535)), e.adler = 1, o.status = BUSY_STATE, flush_pending(e), o.pending !== 0)
      return o.last_flush = -1, Z_OK$3;
  }
  if (o.status === GZIP_STATE) {
    if (e.adler = 0, put_byte(o, 31), put_byte(o, 139), put_byte(o, 8), o.gzhead)
      put_byte(
        o,
        (o.gzhead.text ? 1 : 0) + (o.gzhead.hcrc ? 2 : 0) + (o.gzhead.extra ? 4 : 0) + (o.gzhead.name ? 8 : 0) + (o.gzhead.comment ? 16 : 0)
      ), put_byte(o, o.gzhead.time & 255), put_byte(o, o.gzhead.time >> 8 & 255), put_byte(o, o.gzhead.time >> 16 & 255), put_byte(o, o.gzhead.time >> 24 & 255), put_byte(o, o.level === 9 ? 2 : o.strategy >= Z_HUFFMAN_ONLY || o.level < 2 ? 4 : 0), put_byte(o, o.gzhead.os & 255), o.gzhead.extra && o.gzhead.extra.length && (put_byte(o, o.gzhead.extra.length & 255), put_byte(o, o.gzhead.extra.length >> 8 & 255)), o.gzhead.hcrc && (e.adler = crc32$1(e.adler, o.pending_buf, o.pending, 0)), o.gzindex = 0, o.status = EXTRA_STATE;
    else if (put_byte(o, 0), put_byte(o, 0), put_byte(o, 0), put_byte(o, 0), put_byte(o, 0), put_byte(o, o.level === 9 ? 2 : o.strategy >= Z_HUFFMAN_ONLY || o.level < 2 ? 4 : 0), put_byte(o, OS_CODE), o.status = BUSY_STATE, flush_pending(e), o.pending !== 0)
      return o.last_flush = -1, Z_OK$3;
  }
  if (o.status === EXTRA_STATE) {
    if (o.gzhead.extra) {
      let c = o.pending, d = (o.gzhead.extra.length & 65535) - o.gzindex;
      for (; o.pending + d > o.pending_buf_size; ) {
        let v = o.pending_buf_size - o.pending;
        if (o.pending_buf.set(o.gzhead.extra.subarray(o.gzindex, o.gzindex + v), o.pending), o.pending = o.pending_buf_size, o.gzhead.hcrc && o.pending > c && (e.adler = crc32$1(e.adler, o.pending_buf, o.pending - c, c)), o.gzindex += v, flush_pending(e), o.pending !== 0)
          return o.last_flush = -1, Z_OK$3;
        c = 0, d -= v;
      }
      let m = new Uint8Array(o.gzhead.extra);
      o.pending_buf.set(m.subarray(o.gzindex, o.gzindex + d), o.pending), o.pending += d, o.gzhead.hcrc && o.pending > c && (e.adler = crc32$1(e.adler, o.pending_buf, o.pending - c, c)), o.gzindex = 0;
    }
    o.status = NAME_STATE;
  }
  if (o.status === NAME_STATE) {
    if (o.gzhead.name) {
      let c = o.pending, d;
      do {
        if (o.pending === o.pending_buf_size) {
          if (o.gzhead.hcrc && o.pending > c && (e.adler = crc32$1(e.adler, o.pending_buf, o.pending - c, c)), flush_pending(e), o.pending !== 0)
            return o.last_flush = -1, Z_OK$3;
          c = 0;
        }
        o.gzindex < o.gzhead.name.length ? d = o.gzhead.name.charCodeAt(o.gzindex++) & 255 : d = 0, put_byte(o, d);
      } while (d !== 0);
      o.gzhead.hcrc && o.pending > c && (e.adler = crc32$1(e.adler, o.pending_buf, o.pending - c, c)), o.gzindex = 0;
    }
    o.status = COMMENT_STATE;
  }
  if (o.status === COMMENT_STATE) {
    if (o.gzhead.comment) {
      let c = o.pending, d;
      do {
        if (o.pending === o.pending_buf_size) {
          if (o.gzhead.hcrc && o.pending > c && (e.adler = crc32$1(e.adler, o.pending_buf, o.pending - c, c)), flush_pending(e), o.pending !== 0)
            return o.last_flush = -1, Z_OK$3;
          c = 0;
        }
        o.gzindex < o.gzhead.comment.length ? d = o.gzhead.comment.charCodeAt(o.gzindex++) & 255 : d = 0, put_byte(o, d);
      } while (d !== 0);
      o.gzhead.hcrc && o.pending > c && (e.adler = crc32$1(e.adler, o.pending_buf, o.pending - c, c));
    }
    o.status = HCRC_STATE;
  }
  if (o.status === HCRC_STATE) {
    if (o.gzhead.hcrc) {
      if (o.pending + 2 > o.pending_buf_size && (flush_pending(e), o.pending !== 0))
        return o.last_flush = -1, Z_OK$3;
      put_byte(o, e.adler & 255), put_byte(o, e.adler >> 8 & 255), e.adler = 0;
    }
    if (o.status = BUSY_STATE, flush_pending(e), o.pending !== 0)
      return o.last_flush = -1, Z_OK$3;
  }
  if (e.avail_in !== 0 || o.lookahead !== 0 || n !== Z_NO_FLUSH$2 && o.status !== FINISH_STATE) {
    let c = o.level === 0 ? deflate_stored(o, n) : o.strategy === Z_HUFFMAN_ONLY ? deflate_huff(o, n) : o.strategy === Z_RLE ? deflate_rle(o, n) : configuration_table[o.level].func(o, n);
    if ((c === BS_FINISH_STARTED || c === BS_FINISH_DONE) && (o.status = FINISH_STATE), c === BS_NEED_MORE || c === BS_FINISH_STARTED)
      return e.avail_out === 0 && (o.last_flush = -1), Z_OK$3;
    if (c === BS_BLOCK_DONE && (n === Z_PARTIAL_FLUSH ? _tr_align(o) : n !== Z_BLOCK$1 && (_tr_stored_block(o, 0, 0, !1), n === Z_FULL_FLUSH$1 && (zero(o.head), o.lookahead === 0 && (o.strstart = 0, o.block_start = 0, o.insert = 0))), flush_pending(e), e.avail_out === 0))
      return o.last_flush = -1, Z_OK$3;
  }
  return n !== Z_FINISH$3 ? Z_OK$3 : o.wrap <= 0 ? Z_STREAM_END$3 : (o.wrap === 2 ? (put_byte(o, e.adler & 255), put_byte(o, e.adler >> 8 & 255), put_byte(o, e.adler >> 16 & 255), put_byte(o, e.adler >> 24 & 255), put_byte(o, e.total_in & 255), put_byte(o, e.total_in >> 8 & 255), put_byte(o, e.total_in >> 16 & 255), put_byte(o, e.total_in >> 24 & 255)) : (putShortMSB(o, e.adler >>> 16), putShortMSB(o, e.adler & 65535)), flush_pending(e), o.wrap > 0 && (o.wrap = -o.wrap), o.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3);
}, deflateEnd = (e) => {
  if (deflateStateCheck(e))
    return Z_STREAM_ERROR$2;
  const n = e.state.status;
  return e.state = null, n === BUSY_STATE ? err(e, Z_DATA_ERROR$2) : Z_OK$3;
}, deflateSetDictionary = (e, n) => {
  let o = n.length;
  if (deflateStateCheck(e))
    return Z_STREAM_ERROR$2;
  const u = e.state, c = u.wrap;
  if (c === 2 || c === 1 && u.status !== INIT_STATE || u.lookahead)
    return Z_STREAM_ERROR$2;
  if (c === 1 && (e.adler = adler32$1(e.adler, n, o, 0)), u.wrap = 0, o >= u.w_size) {
    c === 0 && (zero(u.head), u.strstart = 0, u.block_start = 0, u.insert = 0);
    let S = new Uint8Array(u.w_size);
    S.set(n.subarray(o - u.w_size, o), 0), n = S, o = u.w_size;
  }
  const d = e.avail_in, m = e.next_in, v = e.input;
  for (e.avail_in = o, e.next_in = 0, e.input = n, fill_window(u); u.lookahead >= MIN_MATCH; ) {
    let S = u.strstart, $ = u.lookahead - (MIN_MATCH - 1);
    do
      u.ins_h = HASH(u, u.ins_h, u.window[S + MIN_MATCH - 1]), u.prev[S & u.w_mask] = u.head[u.ins_h], u.head[u.ins_h] = S, S++;
    while (--$);
    u.strstart = S, u.lookahead = MIN_MATCH - 1, fill_window(u);
  }
  return u.strstart += u.lookahead, u.block_start = u.strstart, u.insert = u.lookahead, u.lookahead = 0, u.match_length = u.prev_length = MIN_MATCH - 1, u.match_available = 0, e.next_in = m, e.input = v, e.avail_in = d, u.wrap = c, Z_OK$3;
};
deflate$3.deflateInit = deflateInit;
deflate$3.deflateInit2 = deflateInit2;
deflate$3.deflateReset = deflateReset;
deflate$3.deflateResetKeep = deflateResetKeep;
deflate$3.deflateSetHeader = deflateSetHeader;
deflate$3.deflate = deflate$2;
deflate$3.deflateEnd = deflateEnd;
deflate$3.deflateSetDictionary = deflateSetDictionary;
deflate$3.deflateInfo = "pako deflate (from Nodeca project)";
var common$2 = {};
const _has = (e, n) => Object.prototype.hasOwnProperty.call(e, n);
common$2.assign = function(e) {
  const n = Array.prototype.slice.call(arguments, 1);
  for (; n.length; ) {
    const o = n.shift();
    if (o) {
      if (typeof o != "object")
        throw new TypeError(o + "must be non-object");
      for (const u in o)
        _has(o, u) && (e[u] = o[u]);
    }
  }
  return e;
};
common$2.flattenChunks = (e) => {
  let n = 0;
  for (let u = 0, c = e.length; u < c; u++)
    n += e[u].length;
  const o = new Uint8Array(n);
  for (let u = 0, c = 0, d = e.length; u < d; u++) {
    let m = e[u];
    o.set(m, c), c += m.length;
  }
  return o;
};
var strings$2 = {};
let STR_APPLY_UIA_OK = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (e) {
  STR_APPLY_UIA_OK = !1;
}
const _utf8len = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  _utf8len[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
_utf8len[254] = _utf8len[254] = 1;
strings$2.string2buf = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let n, o, u, c, d, m = e.length, v = 0;
  for (c = 0; c < m; c++)
    o = e.charCodeAt(c), (o & 64512) === 55296 && c + 1 < m && (u = e.charCodeAt(c + 1), (u & 64512) === 56320 && (o = 65536 + (o - 55296 << 10) + (u - 56320), c++)), v += o < 128 ? 1 : o < 2048 ? 2 : o < 65536 ? 3 : 4;
  for (n = new Uint8Array(v), d = 0, c = 0; d < v; c++)
    o = e.charCodeAt(c), (o & 64512) === 55296 && c + 1 < m && (u = e.charCodeAt(c + 1), (u & 64512) === 56320 && (o = 65536 + (o - 55296 << 10) + (u - 56320), c++)), o < 128 ? n[d++] = o : o < 2048 ? (n[d++] = 192 | o >>> 6, n[d++] = 128 | o & 63) : o < 65536 ? (n[d++] = 224 | o >>> 12, n[d++] = 128 | o >>> 6 & 63, n[d++] = 128 | o & 63) : (n[d++] = 240 | o >>> 18, n[d++] = 128 | o >>> 12 & 63, n[d++] = 128 | o >>> 6 & 63, n[d++] = 128 | o & 63);
  return n;
};
const buf2binstring = (e, n) => {
  if (n < 65534 && e.subarray && STR_APPLY_UIA_OK)
    return String.fromCharCode.apply(null, e.length === n ? e : e.subarray(0, n));
  let o = "";
  for (let u = 0; u < n; u++)
    o += String.fromCharCode(e[u]);
  return o;
};
strings$2.buf2string = (e, n) => {
  const o = n || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, n));
  let u, c;
  const d = new Array(o * 2);
  for (c = 0, u = 0; u < o; ) {
    let m = e[u++];
    if (m < 128) {
      d[c++] = m;
      continue;
    }
    let v = _utf8len[m];
    if (v > 4) {
      d[c++] = 65533, u += v - 1;
      continue;
    }
    for (m &= v === 2 ? 31 : v === 3 ? 15 : 7; v > 1 && u < o; )
      m = m << 6 | e[u++] & 63, v--;
    if (v > 1) {
      d[c++] = 65533;
      continue;
    }
    m < 65536 ? d[c++] = m : (m -= 65536, d[c++] = 55296 | m >> 10 & 1023, d[c++] = 56320 | m & 1023);
  }
  return buf2binstring(d, c);
};
strings$2.utf8border = (e, n) => {
  n = n || e.length, n > e.length && (n = e.length);
  let o = n - 1;
  for (; o >= 0 && (e[o] & 192) === 128; )
    o--;
  return o < 0 || o === 0 ? n : o + _utf8len[e[o]] > n ? o : n;
};
function ZStream$2() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var zstream = ZStream$2;
const zlib_deflate = deflate$3, utils$r = common$2, strings$1 = strings$2, msg$1 = messages$8, ZStream$1 = zstream, toString$3 = Object.prototype.toString, {
  Z_NO_FLUSH: Z_NO_FLUSH$1,
  Z_SYNC_FLUSH,
  Z_FULL_FLUSH,
  Z_FINISH: Z_FINISH$2,
  Z_OK: Z_OK$2,
  Z_STREAM_END: Z_STREAM_END$2,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$5;
function Deflate$1(e) {
  this.options = utils$r.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, e || {});
  let n = this.options;
  n.raw && n.windowBits > 0 ? n.windowBits = -n.windowBits : n.gzip && n.windowBits > 0 && n.windowBits < 16 && (n.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ZStream$1(), this.strm.avail_out = 0;
  let o = zlib_deflate.deflateInit2(
    this.strm,
    n.level,
    n.method,
    n.windowBits,
    n.memLevel,
    n.strategy
  );
  if (o !== Z_OK$2)
    throw new Error(msg$1[o]);
  if (n.header && zlib_deflate.deflateSetHeader(this.strm, n.header), n.dictionary) {
    let u;
    if (typeof n.dictionary == "string" ? u = strings$1.string2buf(n.dictionary) : toString$3.call(n.dictionary) === "[object ArrayBuffer]" ? u = new Uint8Array(n.dictionary) : u = n.dictionary, o = zlib_deflate.deflateSetDictionary(this.strm, u), o !== Z_OK$2)
      throw new Error(msg$1[o]);
    this._dict_set = !0;
  }
}
Deflate$1.prototype.push = function(e, n) {
  const o = this.strm, u = this.options.chunkSize;
  let c, d;
  if (this.ended)
    return !1;
  for (n === ~~n ? d = n : d = n === !0 ? Z_FINISH$2 : Z_NO_FLUSH$1, typeof e == "string" ? o.input = strings$1.string2buf(e) : toString$3.call(e) === "[object ArrayBuffer]" ? o.input = new Uint8Array(e) : o.input = e, o.next_in = 0, o.avail_in = o.input.length; ; ) {
    if (o.avail_out === 0 && (o.output = new Uint8Array(u), o.next_out = 0, o.avail_out = u), (d === Z_SYNC_FLUSH || d === Z_FULL_FLUSH) && o.avail_out <= 6) {
      this.onData(o.output.subarray(0, o.next_out)), o.avail_out = 0;
      continue;
    }
    if (c = zlib_deflate.deflate(o, d), c === Z_STREAM_END$2)
      return o.next_out > 0 && this.onData(o.output.subarray(0, o.next_out)), c = zlib_deflate.deflateEnd(this.strm), this.onEnd(c), this.ended = !0, c === Z_OK$2;
    if (o.avail_out === 0) {
      this.onData(o.output);
      continue;
    }
    if (d > 0 && o.next_out > 0) {
      this.onData(o.output.subarray(0, o.next_out)), o.avail_out = 0;
      continue;
    }
    if (o.avail_in === 0)
      break;
  }
  return !0;
};
Deflate$1.prototype.onData = function(e) {
  this.chunks.push(e);
};
Deflate$1.prototype.onEnd = function(e) {
  e === Z_OK$2 && (this.result = utils$r.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function deflate$1(e, n) {
  const o = new Deflate$1(n);
  if (o.push(e, !0), o.err)
    throw o.msg || msg$1[o.err];
  return o.result;
}
function deflateRaw$1(e, n) {
  return n = n || {}, n.raw = !0, deflate$1(e, n);
}
function gzip$1(e, n) {
  return n = n || {}, n.gzip = !0, deflate$1(e, n);
}
deflate$4.Deflate = Deflate$1;
deflate$4.deflate = deflate$1;
deflate$4.deflateRaw = deflateRaw$1;
deflate$4.gzip = gzip$1;
deflate$4.constants = constants$5;
var inflate$4 = {}, inflate$3 = {};
const BAD$1 = 16209, TYPE$1 = 16191;
var inffast = function e(n, o) {
  let u, c, d, m, v, S, $, E, O, T, y, V, M, G, k, F, X, ee, ue, Q, Y, pe, oe, ne;
  const H = n.state;
  u = n.next_in, oe = n.input, c = u + (n.avail_in - 5), d = n.next_out, ne = n.output, m = d - (o - n.avail_out), v = d + (n.avail_out - 257), S = H.dmax, $ = H.wsize, E = H.whave, O = H.wnext, T = H.window, y = H.hold, V = H.bits, M = H.lencode, G = H.distcode, k = (1 << H.lenbits) - 1, F = (1 << H.distbits) - 1;
  e:
    do {
      V < 15 && (y += oe[u++] << V, V += 8, y += oe[u++] << V, V += 8), X = M[y & k];
      t:
        for (; ; ) {
          if (ee = X >>> 24, y >>>= ee, V -= ee, ee = X >>> 16 & 255, ee === 0)
            ne[d++] = X & 65535;
          else if (ee & 16) {
            ue = X & 65535, ee &= 15, ee && (V < ee && (y += oe[u++] << V, V += 8), ue += y & (1 << ee) - 1, y >>>= ee, V -= ee), V < 15 && (y += oe[u++] << V, V += 8, y += oe[u++] << V, V += 8), X = G[y & F];
            n:
              for (; ; ) {
                if (ee = X >>> 24, y >>>= ee, V -= ee, ee = X >>> 16 & 255, ee & 16) {
                  if (Q = X & 65535, ee &= 15, V < ee && (y += oe[u++] << V, V += 8, V < ee && (y += oe[u++] << V, V += 8)), Q += y & (1 << ee) - 1, Q > S) {
                    n.msg = "invalid distance too far back", H.mode = BAD$1;
                    break e;
                  }
                  if (y >>>= ee, V -= ee, ee = d - m, Q > ee) {
                    if (ee = Q - ee, ee > E && H.sane) {
                      n.msg = "invalid distance too far back", H.mode = BAD$1;
                      break e;
                    }
                    if (Y = 0, pe = T, O === 0) {
                      if (Y += $ - ee, ee < ue) {
                        ue -= ee;
                        do
                          ne[d++] = T[Y++];
                        while (--ee);
                        Y = d - Q, pe = ne;
                      }
                    } else if (O < ee) {
                      if (Y += $ + O - ee, ee -= O, ee < ue) {
                        ue -= ee;
                        do
                          ne[d++] = T[Y++];
                        while (--ee);
                        if (Y = 0, O < ue) {
                          ee = O, ue -= ee;
                          do
                            ne[d++] = T[Y++];
                          while (--ee);
                          Y = d - Q, pe = ne;
                        }
                      }
                    } else if (Y += O - ee, ee < ue) {
                      ue -= ee;
                      do
                        ne[d++] = T[Y++];
                      while (--ee);
                      Y = d - Q, pe = ne;
                    }
                    for (; ue > 2; )
                      ne[d++] = pe[Y++], ne[d++] = pe[Y++], ne[d++] = pe[Y++], ue -= 3;
                    ue && (ne[d++] = pe[Y++], ue > 1 && (ne[d++] = pe[Y++]));
                  } else {
                    Y = d - Q;
                    do
                      ne[d++] = ne[Y++], ne[d++] = ne[Y++], ne[d++] = ne[Y++], ue -= 3;
                    while (ue > 2);
                    ue && (ne[d++] = ne[Y++], ue > 1 && (ne[d++] = ne[Y++]));
                  }
                } else if (ee & 64) {
                  n.msg = "invalid distance code", H.mode = BAD$1;
                  break e;
                } else {
                  X = G[(X & 65535) + (y & (1 << ee) - 1)];
                  continue n;
                }
                break;
              }
          } else if (ee & 64)
            if (ee & 32) {
              H.mode = TYPE$1;
              break e;
            } else {
              n.msg = "invalid literal/length code", H.mode = BAD$1;
              break e;
            }
          else {
            X = M[(X & 65535) + (y & (1 << ee) - 1)];
            continue t;
          }
          break;
        }
    } while (u < c && d < v);
  ue = V >> 3, u -= ue, V -= ue << 3, y &= (1 << V) - 1, n.next_in = u, n.next_out = d, n.avail_in = u < c ? 5 + (c - u) : 5 - (u - c), n.avail_out = d < v ? 257 + (v - d) : 257 - (d - v), H.hold = y, H.bits = V;
};
const MAXBITS = 15, ENOUGH_LENS$1 = 852, ENOUGH_DISTS$1 = 592, CODES$1 = 0, LENS$1 = 1, DISTS$1 = 2, lbase = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), lext = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), dbase = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), dext = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), inflate_table$1 = (e, n, o, u, c, d, m, v) => {
  const S = v.bits;
  let $ = 0, E = 0, O = 0, T = 0, y = 0, V = 0, M = 0, G = 0, k = 0, F = 0, X, ee, ue, Q, Y, pe = null, oe;
  const ne = new Uint16Array(MAXBITS + 1), H = new Uint16Array(MAXBITS + 1);
  let C = null, w, P, J;
  for ($ = 0; $ <= MAXBITS; $++)
    ne[$] = 0;
  for (E = 0; E < u; E++)
    ne[n[o + E]]++;
  for (y = S, T = MAXBITS; T >= 1 && ne[T] === 0; T--)
    ;
  if (y > T && (y = T), T === 0)
    return c[d++] = 1 << 24 | 64 << 16 | 0, c[d++] = 1 << 24 | 64 << 16 | 0, v.bits = 1, 0;
  for (O = 1; O < T && ne[O] === 0; O++)
    ;
  for (y < O && (y = O), G = 1, $ = 1; $ <= MAXBITS; $++)
    if (G <<= 1, G -= ne[$], G < 0)
      return -1;
  if (G > 0 && (e === CODES$1 || T !== 1))
    return -1;
  for (H[1] = 0, $ = 1; $ < MAXBITS; $++)
    H[$ + 1] = H[$] + ne[$];
  for (E = 0; E < u; E++)
    n[o + E] !== 0 && (m[H[n[o + E]]++] = E);
  if (e === CODES$1 ? (pe = C = m, oe = 20) : e === LENS$1 ? (pe = lbase, C = lext, oe = 257) : (pe = dbase, C = dext, oe = 0), F = 0, E = 0, $ = O, Y = d, V = y, M = 0, ue = -1, k = 1 << y, Q = k - 1, e === LENS$1 && k > ENOUGH_LENS$1 || e === DISTS$1 && k > ENOUGH_DISTS$1)
    return 1;
  for (; ; ) {
    w = $ - M, m[E] + 1 < oe ? (P = 0, J = m[E]) : m[E] >= oe ? (P = C[m[E] - oe], J = pe[m[E] - oe]) : (P = 32 + 64, J = 0), X = 1 << $ - M, ee = 1 << V, O = ee;
    do
      ee -= X, c[Y + (F >> M) + ee] = w << 24 | P << 16 | J | 0;
    while (ee !== 0);
    for (X = 1 << $ - 1; F & X; )
      X >>= 1;
    if (X !== 0 ? (F &= X - 1, F += X) : F = 0, E++, --ne[$] === 0) {
      if ($ === T)
        break;
      $ = n[o + m[E]];
    }
    if ($ > y && (F & Q) !== ue) {
      for (M === 0 && (M = y), Y += O, V = $ - M, G = 1 << V; V + M < T && (G -= ne[V + M], !(G <= 0)); )
        V++, G <<= 1;
      if (k += 1 << V, e === LENS$1 && k > ENOUGH_LENS$1 || e === DISTS$1 && k > ENOUGH_DISTS$1)
        return 1;
      ue = F & Q, c[ue] = y << 24 | V << 16 | Y - d | 0;
    }
  }
  return F !== 0 && (c[Y + F] = $ - M << 24 | 64 << 16 | 0), v.bits = y, 0;
};
var inftrees = inflate_table$1;
const adler32 = adler32_1, crc32 = crc32_1, inflate_fast = inffast, inflate_table = inftrees, CODES = 0, LENS = 1, DISTS = 2, {
  Z_FINISH: Z_FINISH$1,
  Z_BLOCK,
  Z_TREES,
  Z_OK: Z_OK$1,
  Z_STREAM_END: Z_STREAM_END$1,
  Z_NEED_DICT: Z_NEED_DICT$1,
  Z_STREAM_ERROR: Z_STREAM_ERROR$1,
  Z_DATA_ERROR: Z_DATA_ERROR$1,
  Z_MEM_ERROR: Z_MEM_ERROR$1,
  Z_BUF_ERROR,
  Z_DEFLATED
} = constants$5, HEAD = 16180, FLAGS = 16181, TIME = 16182, OS = 16183, EXLEN = 16184, EXTRA = 16185, NAME = 16186, COMMENT = 16187, HCRC = 16188, DICTID = 16189, DICT = 16190, TYPE = 16191, TYPEDO = 16192, STORED = 16193, COPY_ = 16194, COPY = 16195, TABLE = 16196, LENLENS = 16197, CODELENS = 16198, LEN_ = 16199, LEN = 16200, LENEXT = 16201, DIST = 16202, DISTEXT = 16203, MATCH = 16204, LIT = 16205, CHECK = 16206, LENGTH$1 = 16207, DONE = 16208, BAD = 16209, MEM = 16210, SYNC = 16211, ENOUGH_LENS = 852, ENOUGH_DISTS = 592, MAX_WBITS = 15, DEF_WBITS = MAX_WBITS, zswap32 = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function InflateState() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const inflateStateCheck = (e) => {
  if (!e)
    return 1;
  const n = e.state;
  return !n || n.strm !== e || n.mode < HEAD || n.mode > SYNC ? 1 : 0;
}, inflateResetKeep = (e) => {
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  const n = e.state;
  return e.total_in = e.total_out = n.total = 0, e.msg = "", n.wrap && (e.adler = n.wrap & 1), n.mode = HEAD, n.last = 0, n.havedict = 0, n.flags = -1, n.dmax = 32768, n.head = null, n.hold = 0, n.bits = 0, n.lencode = n.lendyn = new Int32Array(ENOUGH_LENS), n.distcode = n.distdyn = new Int32Array(ENOUGH_DISTS), n.sane = 1, n.back = -1, Z_OK$1;
}, inflateReset = (e) => {
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  const n = e.state;
  return n.wsize = 0, n.whave = 0, n.wnext = 0, inflateResetKeep(e);
}, inflateReset2 = (e, n) => {
  let o;
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  const u = e.state;
  return n < 0 ? (o = 0, n = -n) : (o = (n >> 4) + 5, n < 48 && (n &= 15)), n && (n < 8 || n > 15) ? Z_STREAM_ERROR$1 : (u.window !== null && u.wbits !== n && (u.window = null), u.wrap = o, u.wbits = n, inflateReset(e));
}, inflateInit2 = (e, n) => {
  if (!e)
    return Z_STREAM_ERROR$1;
  const o = new InflateState();
  e.state = o, o.strm = e, o.window = null, o.mode = HEAD;
  const u = inflateReset2(e, n);
  return u !== Z_OK$1 && (e.state = null), u;
}, inflateInit = (e) => inflateInit2(e, DEF_WBITS);
let virgin = !0, lenfix, distfix;
const fixedtables = (e) => {
  if (virgin) {
    lenfix = new Int32Array(512), distfix = new Int32Array(32);
    let n = 0;
    for (; n < 144; )
      e.lens[n++] = 8;
    for (; n < 256; )
      e.lens[n++] = 9;
    for (; n < 280; )
      e.lens[n++] = 7;
    for (; n < 288; )
      e.lens[n++] = 8;
    for (inflate_table(LENS, e.lens, 0, 288, lenfix, 0, e.work, { bits: 9 }), n = 0; n < 32; )
      e.lens[n++] = 5;
    inflate_table(DISTS, e.lens, 0, 32, distfix, 0, e.work, { bits: 5 }), virgin = !1;
  }
  e.lencode = lenfix, e.lenbits = 9, e.distcode = distfix, e.distbits = 5;
}, updatewindow = (e, n, o, u) => {
  let c;
  const d = e.state;
  return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new Uint8Array(d.wsize)), u >= d.wsize ? (d.window.set(n.subarray(o - d.wsize, o), 0), d.wnext = 0, d.whave = d.wsize) : (c = d.wsize - d.wnext, c > u && (c = u), d.window.set(n.subarray(o - u, o - u + c), d.wnext), u -= c, u ? (d.window.set(n.subarray(o - u, o), 0), d.wnext = u, d.whave = d.wsize) : (d.wnext += c, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += c))), 0;
}, inflate$2 = (e, n) => {
  let o, u, c, d, m, v, S, $, E, O, T, y, V, M, G = 0, k, F, X, ee, ue, Q, Y, pe;
  const oe = new Uint8Array(4);
  let ne, H;
  const C = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (inflateStateCheck(e) || !e.output || !e.input && e.avail_in !== 0)
    return Z_STREAM_ERROR$1;
  o = e.state, o.mode === TYPE && (o.mode = TYPEDO), m = e.next_out, c = e.output, S = e.avail_out, d = e.next_in, u = e.input, v = e.avail_in, $ = o.hold, E = o.bits, O = v, T = S, pe = Z_OK$1;
  e:
    for (; ; )
      switch (o.mode) {
        case HEAD:
          if (o.wrap === 0) {
            o.mode = TYPEDO;
            break;
          }
          for (; E < 16; ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          if (o.wrap & 2 && $ === 35615) {
            o.wbits === 0 && (o.wbits = 15), o.check = 0, oe[0] = $ & 255, oe[1] = $ >>> 8 & 255, o.check = crc32(o.check, oe, 2, 0), $ = 0, E = 0, o.mode = FLAGS;
            break;
          }
          if (o.head && (o.head.done = !1), !(o.wrap & 1) || /* check if zlib header allowed */
          ((($ & 255) << 8) + ($ >> 8)) % 31) {
            e.msg = "incorrect header check", o.mode = BAD;
            break;
          }
          if (($ & 15) !== Z_DEFLATED) {
            e.msg = "unknown compression method", o.mode = BAD;
            break;
          }
          if ($ >>>= 4, E -= 4, Y = ($ & 15) + 8, o.wbits === 0 && (o.wbits = Y), Y > 15 || Y > o.wbits) {
            e.msg = "invalid window size", o.mode = BAD;
            break;
          }
          o.dmax = 1 << o.wbits, o.flags = 0, e.adler = o.check = 1, o.mode = $ & 512 ? DICTID : TYPE, $ = 0, E = 0;
          break;
        case FLAGS:
          for (; E < 16; ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          if (o.flags = $, (o.flags & 255) !== Z_DEFLATED) {
            e.msg = "unknown compression method", o.mode = BAD;
            break;
          }
          if (o.flags & 57344) {
            e.msg = "unknown header flags set", o.mode = BAD;
            break;
          }
          o.head && (o.head.text = $ >> 8 & 1), o.flags & 512 && o.wrap & 4 && (oe[0] = $ & 255, oe[1] = $ >>> 8 & 255, o.check = crc32(o.check, oe, 2, 0)), $ = 0, E = 0, o.mode = TIME;
        case TIME:
          for (; E < 32; ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          o.head && (o.head.time = $), o.flags & 512 && o.wrap & 4 && (oe[0] = $ & 255, oe[1] = $ >>> 8 & 255, oe[2] = $ >>> 16 & 255, oe[3] = $ >>> 24 & 255, o.check = crc32(o.check, oe, 4, 0)), $ = 0, E = 0, o.mode = OS;
        case OS:
          for (; E < 16; ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          o.head && (o.head.xflags = $ & 255, o.head.os = $ >> 8), o.flags & 512 && o.wrap & 4 && (oe[0] = $ & 255, oe[1] = $ >>> 8 & 255, o.check = crc32(o.check, oe, 2, 0)), $ = 0, E = 0, o.mode = EXLEN;
        case EXLEN:
          if (o.flags & 1024) {
            for (; E < 16; ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            o.length = $, o.head && (o.head.extra_len = $), o.flags & 512 && o.wrap & 4 && (oe[0] = $ & 255, oe[1] = $ >>> 8 & 255, o.check = crc32(o.check, oe, 2, 0)), $ = 0, E = 0;
          } else
            o.head && (o.head.extra = null);
          o.mode = EXTRA;
        case EXTRA:
          if (o.flags & 1024 && (y = o.length, y > v && (y = v), y && (o.head && (Y = o.head.extra_len - o.length, o.head.extra || (o.head.extra = new Uint8Array(o.head.extra_len)), o.head.extra.set(
            u.subarray(
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              d + y
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            Y
          )), o.flags & 512 && o.wrap & 4 && (o.check = crc32(o.check, u, y, d)), v -= y, d += y, o.length -= y), o.length))
            break e;
          o.length = 0, o.mode = NAME;
        case NAME:
          if (o.flags & 2048) {
            if (v === 0)
              break e;
            y = 0;
            do
              Y = u[d + y++], o.head && Y && o.length < 65536 && (o.head.name += String.fromCharCode(Y));
            while (Y && y < v);
            if (o.flags & 512 && o.wrap & 4 && (o.check = crc32(o.check, u, y, d)), v -= y, d += y, Y)
              break e;
          } else
            o.head && (o.head.name = null);
          o.length = 0, o.mode = COMMENT;
        case COMMENT:
          if (o.flags & 4096) {
            if (v === 0)
              break e;
            y = 0;
            do
              Y = u[d + y++], o.head && Y && o.length < 65536 && (o.head.comment += String.fromCharCode(Y));
            while (Y && y < v);
            if (o.flags & 512 && o.wrap & 4 && (o.check = crc32(o.check, u, y, d)), v -= y, d += y, Y)
              break e;
          } else
            o.head && (o.head.comment = null);
          o.mode = HCRC;
        case HCRC:
          if (o.flags & 512) {
            for (; E < 16; ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            if (o.wrap & 4 && $ !== (o.check & 65535)) {
              e.msg = "header crc mismatch", o.mode = BAD;
              break;
            }
            $ = 0, E = 0;
          }
          o.head && (o.head.hcrc = o.flags >> 9 & 1, o.head.done = !0), e.adler = o.check = 0, o.mode = TYPE;
          break;
        case DICTID:
          for (; E < 32; ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          e.adler = o.check = zswap32($), $ = 0, E = 0, o.mode = DICT;
        case DICT:
          if (o.havedict === 0)
            return e.next_out = m, e.avail_out = S, e.next_in = d, e.avail_in = v, o.hold = $, o.bits = E, Z_NEED_DICT$1;
          e.adler = o.check = 1, o.mode = TYPE;
        case TYPE:
          if (n === Z_BLOCK || n === Z_TREES)
            break e;
        case TYPEDO:
          if (o.last) {
            $ >>>= E & 7, E -= E & 7, o.mode = CHECK;
            break;
          }
          for (; E < 3; ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          switch (o.last = $ & 1, $ >>>= 1, E -= 1, $ & 3) {
            case 0:
              o.mode = STORED;
              break;
            case 1:
              if (fixedtables(o), o.mode = LEN_, n === Z_TREES) {
                $ >>>= 2, E -= 2;
                break e;
              }
              break;
            case 2:
              o.mode = TABLE;
              break;
            case 3:
              e.msg = "invalid block type", o.mode = BAD;
          }
          $ >>>= 2, E -= 2;
          break;
        case STORED:
          for ($ >>>= E & 7, E -= E & 7; E < 32; ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          if (($ & 65535) !== ($ >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", o.mode = BAD;
            break;
          }
          if (o.length = $ & 65535, $ = 0, E = 0, o.mode = COPY_, n === Z_TREES)
            break e;
        case COPY_:
          o.mode = COPY;
        case COPY:
          if (y = o.length, y) {
            if (y > v && (y = v), y > S && (y = S), y === 0)
              break e;
            c.set(u.subarray(d, d + y), m), v -= y, d += y, S -= y, m += y, o.length -= y;
            break;
          }
          o.mode = TYPE;
          break;
        case TABLE:
          for (; E < 14; ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          if (o.nlen = ($ & 31) + 257, $ >>>= 5, E -= 5, o.ndist = ($ & 31) + 1, $ >>>= 5, E -= 5, o.ncode = ($ & 15) + 4, $ >>>= 4, E -= 4, o.nlen > 286 || o.ndist > 30) {
            e.msg = "too many length or distance symbols", o.mode = BAD;
            break;
          }
          o.have = 0, o.mode = LENLENS;
        case LENLENS:
          for (; o.have < o.ncode; ) {
            for (; E < 3; ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            o.lens[C[o.have++]] = $ & 7, $ >>>= 3, E -= 3;
          }
          for (; o.have < 19; )
            o.lens[C[o.have++]] = 0;
          if (o.lencode = o.lendyn, o.lenbits = 7, ne = { bits: o.lenbits }, pe = inflate_table(CODES, o.lens, 0, 19, o.lencode, 0, o.work, ne), o.lenbits = ne.bits, pe) {
            e.msg = "invalid code lengths set", o.mode = BAD;
            break;
          }
          o.have = 0, o.mode = CODELENS;
        case CODELENS:
          for (; o.have < o.nlen + o.ndist; ) {
            for (; G = o.lencode[$ & (1 << o.lenbits) - 1], k = G >>> 24, F = G >>> 16 & 255, X = G & 65535, !(k <= E); ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            if (X < 16)
              $ >>>= k, E -= k, o.lens[o.have++] = X;
            else {
              if (X === 16) {
                for (H = k + 2; E < H; ) {
                  if (v === 0)
                    break e;
                  v--, $ += u[d++] << E, E += 8;
                }
                if ($ >>>= k, E -= k, o.have === 0) {
                  e.msg = "invalid bit length repeat", o.mode = BAD;
                  break;
                }
                Y = o.lens[o.have - 1], y = 3 + ($ & 3), $ >>>= 2, E -= 2;
              } else if (X === 17) {
                for (H = k + 3; E < H; ) {
                  if (v === 0)
                    break e;
                  v--, $ += u[d++] << E, E += 8;
                }
                $ >>>= k, E -= k, Y = 0, y = 3 + ($ & 7), $ >>>= 3, E -= 3;
              } else {
                for (H = k + 7; E < H; ) {
                  if (v === 0)
                    break e;
                  v--, $ += u[d++] << E, E += 8;
                }
                $ >>>= k, E -= k, Y = 0, y = 11 + ($ & 127), $ >>>= 7, E -= 7;
              }
              if (o.have + y > o.nlen + o.ndist) {
                e.msg = "invalid bit length repeat", o.mode = BAD;
                break;
              }
              for (; y--; )
                o.lens[o.have++] = Y;
            }
          }
          if (o.mode === BAD)
            break;
          if (o.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", o.mode = BAD;
            break;
          }
          if (o.lenbits = 9, ne = { bits: o.lenbits }, pe = inflate_table(LENS, o.lens, 0, o.nlen, o.lencode, 0, o.work, ne), o.lenbits = ne.bits, pe) {
            e.msg = "invalid literal/lengths set", o.mode = BAD;
            break;
          }
          if (o.distbits = 6, o.distcode = o.distdyn, ne = { bits: o.distbits }, pe = inflate_table(DISTS, o.lens, o.nlen, o.ndist, o.distcode, 0, o.work, ne), o.distbits = ne.bits, pe) {
            e.msg = "invalid distances set", o.mode = BAD;
            break;
          }
          if (o.mode = LEN_, n === Z_TREES)
            break e;
        case LEN_:
          o.mode = LEN;
        case LEN:
          if (v >= 6 && S >= 258) {
            e.next_out = m, e.avail_out = S, e.next_in = d, e.avail_in = v, o.hold = $, o.bits = E, inflate_fast(e, T), m = e.next_out, c = e.output, S = e.avail_out, d = e.next_in, u = e.input, v = e.avail_in, $ = o.hold, E = o.bits, o.mode === TYPE && (o.back = -1);
            break;
          }
          for (o.back = 0; G = o.lencode[$ & (1 << o.lenbits) - 1], k = G >>> 24, F = G >>> 16 & 255, X = G & 65535, !(k <= E); ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          if (F && !(F & 240)) {
            for (ee = k, ue = F, Q = X; G = o.lencode[Q + (($ & (1 << ee + ue) - 1) >> ee)], k = G >>> 24, F = G >>> 16 & 255, X = G & 65535, !(ee + k <= E); ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            $ >>>= ee, E -= ee, o.back += ee;
          }
          if ($ >>>= k, E -= k, o.back += k, o.length = X, F === 0) {
            o.mode = LIT;
            break;
          }
          if (F & 32) {
            o.back = -1, o.mode = TYPE;
            break;
          }
          if (F & 64) {
            e.msg = "invalid literal/length code", o.mode = BAD;
            break;
          }
          o.extra = F & 15, o.mode = LENEXT;
        case LENEXT:
          if (o.extra) {
            for (H = o.extra; E < H; ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            o.length += $ & (1 << o.extra) - 1, $ >>>= o.extra, E -= o.extra, o.back += o.extra;
          }
          o.was = o.length, o.mode = DIST;
        case DIST:
          for (; G = o.distcode[$ & (1 << o.distbits) - 1], k = G >>> 24, F = G >>> 16 & 255, X = G & 65535, !(k <= E); ) {
            if (v === 0)
              break e;
            v--, $ += u[d++] << E, E += 8;
          }
          if (!(F & 240)) {
            for (ee = k, ue = F, Q = X; G = o.distcode[Q + (($ & (1 << ee + ue) - 1) >> ee)], k = G >>> 24, F = G >>> 16 & 255, X = G & 65535, !(ee + k <= E); ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            $ >>>= ee, E -= ee, o.back += ee;
          }
          if ($ >>>= k, E -= k, o.back += k, F & 64) {
            e.msg = "invalid distance code", o.mode = BAD;
            break;
          }
          o.offset = X, o.extra = F & 15, o.mode = DISTEXT;
        case DISTEXT:
          if (o.extra) {
            for (H = o.extra; E < H; ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            o.offset += $ & (1 << o.extra) - 1, $ >>>= o.extra, E -= o.extra, o.back += o.extra;
          }
          if (o.offset > o.dmax) {
            e.msg = "invalid distance too far back", o.mode = BAD;
            break;
          }
          o.mode = MATCH;
        case MATCH:
          if (S === 0)
            break e;
          if (y = T - S, o.offset > y) {
            if (y = o.offset - y, y > o.whave && o.sane) {
              e.msg = "invalid distance too far back", o.mode = BAD;
              break;
            }
            y > o.wnext ? (y -= o.wnext, V = o.wsize - y) : V = o.wnext - y, y > o.length && (y = o.length), M = o.window;
          } else
            M = c, V = m - o.offset, y = o.length;
          y > S && (y = S), S -= y, o.length -= y;
          do
            c[m++] = M[V++];
          while (--y);
          o.length === 0 && (o.mode = LEN);
          break;
        case LIT:
          if (S === 0)
            break e;
          c[m++] = o.length, S--, o.mode = LEN;
          break;
        case CHECK:
          if (o.wrap) {
            for (; E < 32; ) {
              if (v === 0)
                break e;
              v--, $ |= u[d++] << E, E += 8;
            }
            if (T -= S, e.total_out += T, o.total += T, o.wrap & 4 && T && (e.adler = o.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            o.flags ? crc32(o.check, c, T, m - T) : adler32(o.check, c, T, m - T)), T = S, o.wrap & 4 && (o.flags ? $ : zswap32($)) !== o.check) {
              e.msg = "incorrect data check", o.mode = BAD;
              break;
            }
            $ = 0, E = 0;
          }
          o.mode = LENGTH$1;
        case LENGTH$1:
          if (o.wrap && o.flags) {
            for (; E < 32; ) {
              if (v === 0)
                break e;
              v--, $ += u[d++] << E, E += 8;
            }
            if (o.wrap & 4 && $ !== (o.total & 4294967295)) {
              e.msg = "incorrect length check", o.mode = BAD;
              break;
            }
            $ = 0, E = 0;
          }
          o.mode = DONE;
        case DONE:
          pe = Z_STREAM_END$1;
          break e;
        case BAD:
          pe = Z_DATA_ERROR$1;
          break e;
        case MEM:
          return Z_MEM_ERROR$1;
        case SYNC:
        default:
          return Z_STREAM_ERROR$1;
      }
  return e.next_out = m, e.avail_out = S, e.next_in = d, e.avail_in = v, o.hold = $, o.bits = E, (o.wsize || T !== e.avail_out && o.mode < BAD && (o.mode < CHECK || n !== Z_FINISH$1)) && updatewindow(e, e.output, e.next_out, T - e.avail_out), O -= e.avail_in, T -= e.avail_out, e.total_in += O, e.total_out += T, o.total += T, o.wrap & 4 && T && (e.adler = o.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  o.flags ? crc32(o.check, c, T, e.next_out - T) : adler32(o.check, c, T, e.next_out - T)), e.data_type = o.bits + (o.last ? 64 : 0) + (o.mode === TYPE ? 128 : 0) + (o.mode === LEN_ || o.mode === COPY_ ? 256 : 0), (O === 0 && T === 0 || n === Z_FINISH$1) && pe === Z_OK$1 && (pe = Z_BUF_ERROR), pe;
}, inflateEnd = (e) => {
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  let n = e.state;
  return n.window && (n.window = null), e.state = null, Z_OK$1;
}, inflateGetHeader = (e, n) => {
  if (inflateStateCheck(e))
    return Z_STREAM_ERROR$1;
  const o = e.state;
  return o.wrap & 2 ? (o.head = n, n.done = !1, Z_OK$1) : Z_STREAM_ERROR$1;
}, inflateSetDictionary = (e, n) => {
  const o = n.length;
  let u, c, d;
  return inflateStateCheck(e) || (u = e.state, u.wrap !== 0 && u.mode !== DICT) ? Z_STREAM_ERROR$1 : u.mode === DICT && (c = 1, c = adler32(c, n, o, 0), c !== u.check) ? Z_DATA_ERROR$1 : (d = updatewindow(e, n, o, o), d ? (u.mode = MEM, Z_MEM_ERROR$1) : (u.havedict = 1, Z_OK$1));
};
inflate$3.inflateReset = inflateReset;
inflate$3.inflateReset2 = inflateReset2;
inflate$3.inflateResetKeep = inflateResetKeep;
inflate$3.inflateInit = inflateInit;
inflate$3.inflateInit2 = inflateInit2;
inflate$3.inflate = inflate$2;
inflate$3.inflateEnd = inflateEnd;
inflate$3.inflateGetHeader = inflateGetHeader;
inflate$3.inflateSetDictionary = inflateSetDictionary;
inflate$3.inflateInfo = "pako inflate (from Nodeca project)";
function GZheader$1() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var gzheader = GZheader$1;
const zlib_inflate = inflate$3, utils$q = common$2, strings = strings$2, msg = messages$8, ZStream = zstream, GZheader = gzheader, toString$2 = Object.prototype.toString, {
  Z_NO_FLUSH,
  Z_FINISH,
  Z_OK,
  Z_STREAM_END,
  Z_NEED_DICT,
  Z_STREAM_ERROR,
  Z_DATA_ERROR,
  Z_MEM_ERROR
} = constants$5;
function Inflate$1(e) {
  this.options = utils$q.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, e || {});
  const n = this.options;
  n.raw && n.windowBits >= 0 && n.windowBits < 16 && (n.windowBits = -n.windowBits, n.windowBits === 0 && (n.windowBits = -15)), n.windowBits >= 0 && n.windowBits < 16 && !(e && e.windowBits) && (n.windowBits += 32), n.windowBits > 15 && n.windowBits < 48 && (n.windowBits & 15 || (n.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ZStream(), this.strm.avail_out = 0;
  let o = zlib_inflate.inflateInit2(
    this.strm,
    n.windowBits
  );
  if (o !== Z_OK)
    throw new Error(msg[o]);
  if (this.header = new GZheader(), zlib_inflate.inflateGetHeader(this.strm, this.header), n.dictionary && (typeof n.dictionary == "string" ? n.dictionary = strings.string2buf(n.dictionary) : toString$2.call(n.dictionary) === "[object ArrayBuffer]" && (n.dictionary = new Uint8Array(n.dictionary)), n.raw && (o = zlib_inflate.inflateSetDictionary(this.strm, n.dictionary), o !== Z_OK)))
    throw new Error(msg[o]);
}
Inflate$1.prototype.push = function(e, n) {
  const o = this.strm, u = this.options.chunkSize, c = this.options.dictionary;
  let d, m, v;
  if (this.ended)
    return !1;
  for (n === ~~n ? m = n : m = n === !0 ? Z_FINISH : Z_NO_FLUSH, toString$2.call(e) === "[object ArrayBuffer]" ? o.input = new Uint8Array(e) : o.input = e, o.next_in = 0, o.avail_in = o.input.length; ; ) {
    for (o.avail_out === 0 && (o.output = new Uint8Array(u), o.next_out = 0, o.avail_out = u), d = zlib_inflate.inflate(o, m), d === Z_NEED_DICT && c && (d = zlib_inflate.inflateSetDictionary(o, c), d === Z_OK ? d = zlib_inflate.inflate(o, m) : d === Z_DATA_ERROR && (d = Z_NEED_DICT)); o.avail_in > 0 && d === Z_STREAM_END && o.state.wrap > 0 && e[o.next_in] !== 0; )
      zlib_inflate.inflateReset(o), d = zlib_inflate.inflate(o, m);
    switch (d) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        return this.onEnd(d), this.ended = !0, !1;
    }
    if (v = o.avail_out, o.next_out && (o.avail_out === 0 || d === Z_STREAM_END))
      if (this.options.to === "string") {
        let S = strings.utf8border(o.output, o.next_out), $ = o.next_out - S, E = strings.buf2string(o.output, S);
        o.next_out = $, o.avail_out = u - $, $ && o.output.set(o.output.subarray(S, S + $), 0), this.onData(E);
      } else
        this.onData(o.output.length === o.next_out ? o.output : o.output.subarray(0, o.next_out));
    if (!(d === Z_OK && v === 0)) {
      if (d === Z_STREAM_END)
        return d = zlib_inflate.inflateEnd(this.strm), this.onEnd(d), this.ended = !0, !0;
      if (o.avail_in === 0)
        break;
    }
  }
  return !0;
};
Inflate$1.prototype.onData = function(e) {
  this.chunks.push(e);
};
Inflate$1.prototype.onEnd = function(e) {
  e === Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = utils$q.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function inflate$1(e, n) {
  const o = new Inflate$1(n);
  if (o.push(e), o.err)
    throw o.msg || msg[o.err];
  return o.result;
}
function inflateRaw$1(e, n) {
  return n = n || {}, n.raw = !0, inflate$1(e, n);
}
inflate$4.Inflate = Inflate$1;
inflate$4.inflate = inflate$1;
inflate$4.inflateRaw = inflateRaw$1;
inflate$4.ungzip = inflate$1;
inflate$4.constants = constants$5;
const { Deflate, deflate, deflateRaw, gzip } = deflate$4, { Inflate, inflate, inflateRaw, ungzip } = inflate$4, constants$4 = constants$5;
pako.Deflate = Deflate;
pako.deflate = deflate;
pako.deflateRaw = deflateRaw;
pako.gzip = gzip;
pako.Inflate = Inflate;
pako.inflate = inflate;
pako.inflateRaw = inflateRaw;
pako.ungzip = ungzip;
pako.constants = constants$4;
var __importDefault$m = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(signingcosmwasmclient, "__esModule", { value: !0 });
signingcosmwasmclient.SigningCosmWasmClient = void 0;
const amino_1$7 = build$P, crypto_1$a = build$k, encoding_1$q = build$n, math_1$e = build$m, proto_signing_1$5 = build$Q, stargate_1 = build$S, tendermint_rpc_1$1 = build$l, utils_1$p = build$j, tx_1$d = tx$m, tx_2$3 = tx$d, signing_1$5 = signing$3, tx_3$1 = tx$p, tx_4$1 = tx$b, pako_1 = __importDefault$m(pako), cosmwasmclient_1 = cosmwasmclient, modules_1$1 = modules$1;
function createDeliverTxResponseErrorMessage(e) {
  return `Error when broadcasting tx ${e.transactionHash} at height ${e.height}. Code: ${e.code}; Raw log: ${e.rawLog}`;
}
class SigningCosmWasmClient extends cosmwasmclient_1.CosmWasmClient {
  /**
   * Creates an instance by connecting to the given CometBFT RPC endpoint.
   *
   * This uses auto-detection to decide between a CometBFT 0.38, Tendermint 0.37 and 0.34 client.
   * To set the Comet client explicitly, use `createWithSigner`.
   */
  static async connectWithSigner(n, o, u = {}) {
    const c = await (0, tendermint_rpc_1$1.connectComet)(n);
    return SigningCosmWasmClient.createWithSigner(c, o, u);
  }
  /**
   * Creates an instance from a manually created Comet client.
   * Use this to use `Comet38Client` or `Tendermint37Client` instead of `Tendermint34Client`.
   */
  static async createWithSigner(n, o, u = {}) {
    return new SigningCosmWasmClient(n, o, u);
  }
  /**
   * Creates a client in offline mode.
   *
   * This should only be used in niche cases where you know exactly what you're doing,
   * e.g. when building an offline signing application.
   *
   * When you try to use online functionality with such a signer, an
   * exception will be raised.
   */
  static async offline(n, o = {}) {
    return new SigningCosmWasmClient(void 0, n, o);
  }
  constructor(n, o, u) {
    super(n);
    const { registry: c = new proto_signing_1$5.Registry([...stargate_1.defaultRegistryTypes, ...modules_1$1.wasmTypes]), aminoTypes: d = new stargate_1.AminoTypes({
      ...(0, stargate_1.createDefaultAminoConverters)(),
      ...(0, modules_1$1.createWasmAminoConverters)()
    }) } = u;
    this.registry = c, this.aminoTypes = d, this.signer = o, this.broadcastTimeoutMs = u.broadcastTimeoutMs, this.broadcastPollIntervalMs = u.broadcastPollIntervalMs, this.gasPrice = u.gasPrice;
  }
  async simulate(n, o, u) {
    const c = o.map(($) => this.registry.encodeAsAny($)), d = (await this.signer.getAccounts()).find(($) => $.address === n);
    if (!d)
      throw new Error("Failed to retrieve account from signer");
    const m = (0, amino_1$7.encodeSecp256k1Pubkey)(d.pubkey), { sequence: v } = await this.getSequence(n), { gasInfo: S } = await this.forceGetQueryClient().tx.simulate(c, u, m, v);
    return (0, utils_1$p.assertDefined)(S), math_1$e.Uint53.fromString(S.gasUsed.toString()).toNumber();
  }
  /** Uploads code and returns a receipt, including the code ID */
  async upload(n, o, u, c = "", d) {
    const m = pako_1.default.gzip(o, { level: 9 }), v = {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
      value: tx_4$1.MsgStoreCode.fromPartial({
        sender: n,
        wasmByteCode: m,
        instantiatePermission: d
      })
    }, S = u == "auto" ? 1.1 : u, $ = await this.signAndBroadcast(n, [v], S, c);
    if ((0, stargate_1.isDeliverTxFailure)($))
      throw new Error(createDeliverTxResponseErrorMessage($));
    const E = stargate_1.logs.parseRawLog($.rawLog), O = stargate_1.logs.findAttribute(E, "store_code", "code_id");
    return {
      checksum: (0, encoding_1$q.toHex)((0, crypto_1$a.sha256)(o)),
      originalSize: o.length,
      compressedSize: m.length,
      codeId: Number.parseInt(O.value, 10),
      logs: E,
      height: $.height,
      transactionHash: $.transactionHash,
      events: $.events,
      gasWanted: $.gasWanted,
      gasUsed: $.gasUsed
    };
  }
  async instantiate(n, o, u, c, d, m = {}) {
    const v = {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
      value: tx_4$1.MsgInstantiateContract.fromPartial({
        sender: n,
        codeId: BigInt(new math_1$e.Uint53(o).toString()),
        label: c,
        msg: (0, encoding_1$q.toUtf8)(JSON.stringify(u)),
        funds: [...m.funds || []],
        admin: m.admin
      })
    }, S = await this.signAndBroadcast(n, [v], d, m.memo);
    if ((0, stargate_1.isDeliverTxFailure)(S))
      throw new Error(createDeliverTxResponseErrorMessage(S));
    const $ = stargate_1.logs.parseRawLog(S.rawLog);
    return {
      contractAddress: stargate_1.logs.findAttribute($, "instantiate", "_contract_address").value,
      logs: $,
      height: S.height,
      transactionHash: S.transactionHash,
      events: S.events,
      gasWanted: S.gasWanted,
      gasUsed: S.gasUsed
    };
  }
  async instantiate2(n, o, u, c, d, m, v = {}) {
    const S = {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
      value: tx_4$1.MsgInstantiateContract2.fromPartial({
        sender: n,
        codeId: BigInt(new math_1$e.Uint53(o).toString()),
        label: d,
        msg: (0, encoding_1$q.toUtf8)(JSON.stringify(c)),
        funds: [...v.funds || []],
        admin: v.admin,
        salt: u,
        fixMsg: !1
      })
    }, $ = await this.signAndBroadcast(n, [S], m, v.memo);
    if ((0, stargate_1.isDeliverTxFailure)($))
      throw new Error(createDeliverTxResponseErrorMessage($));
    const E = stargate_1.logs.parseRawLog($.rawLog);
    return {
      contractAddress: stargate_1.logs.findAttribute(E, "instantiate", "_contract_address").value,
      logs: E,
      height: $.height,
      transactionHash: $.transactionHash,
      events: $.events,
      gasWanted: $.gasWanted,
      gasUsed: $.gasUsed
    };
  }
  async updateAdmin(n, o, u, c, d = "") {
    const m = {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
      value: tx_4$1.MsgUpdateAdmin.fromPartial({
        sender: n,
        contract: o,
        newAdmin: u
      })
    }, v = await this.signAndBroadcast(n, [m], c, d);
    if ((0, stargate_1.isDeliverTxFailure)(v))
      throw new Error(createDeliverTxResponseErrorMessage(v));
    return {
      logs: stargate_1.logs.parseRawLog(v.rawLog),
      height: v.height,
      transactionHash: v.transactionHash,
      events: v.events,
      gasWanted: v.gasWanted,
      gasUsed: v.gasUsed
    };
  }
  async clearAdmin(n, o, u, c = "") {
    const d = {
      typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
      value: tx_4$1.MsgClearAdmin.fromPartial({
        sender: n,
        contract: o
      })
    }, m = await this.signAndBroadcast(n, [d], u, c);
    if ((0, stargate_1.isDeliverTxFailure)(m))
      throw new Error(createDeliverTxResponseErrorMessage(m));
    return {
      logs: stargate_1.logs.parseRawLog(m.rawLog),
      height: m.height,
      transactionHash: m.transactionHash,
      events: m.events,
      gasWanted: m.gasWanted,
      gasUsed: m.gasUsed
    };
  }
  async migrate(n, o, u, c, d, m = "") {
    const v = {
      typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
      value: tx_4$1.MsgMigrateContract.fromPartial({
        sender: n,
        contract: o,
        codeId: BigInt(new math_1$e.Uint53(u).toString()),
        msg: (0, encoding_1$q.toUtf8)(JSON.stringify(c))
      })
    }, S = await this.signAndBroadcast(n, [v], d, m);
    if ((0, stargate_1.isDeliverTxFailure)(S))
      throw new Error(createDeliverTxResponseErrorMessage(S));
    return {
      logs: stargate_1.logs.parseRawLog(S.rawLog),
      height: S.height,
      transactionHash: S.transactionHash,
      events: S.events,
      gasWanted: S.gasWanted,
      gasUsed: S.gasUsed
    };
  }
  async execute(n, o, u, c, d = "", m) {
    const v = {
      contractAddress: o,
      msg: u,
      funds: m
    };
    return this.executeMultiple(n, [v], c, d);
  }
  /**
   * Like `execute` but allows executing multiple messages in one transaction.
   */
  async executeMultiple(n, o, u, c = "") {
    const d = o.map((v) => ({
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: tx_4$1.MsgExecuteContract.fromPartial({
        sender: n,
        contract: v.contractAddress,
        msg: (0, encoding_1$q.toUtf8)(JSON.stringify(v.msg)),
        funds: [...v.funds || []]
      })
    })), m = await this.signAndBroadcast(n, d, u, c);
    if ((0, stargate_1.isDeliverTxFailure)(m))
      throw new Error(createDeliverTxResponseErrorMessage(m));
    return {
      logs: stargate_1.logs.parseRawLog(m.rawLog),
      height: m.height,
      transactionHash: m.transactionHash,
      events: m.events,
      gasWanted: m.gasWanted,
      gasUsed: m.gasUsed
    };
  }
  async sendTokens(n, o, u, c, d = "") {
    const m = {
      typeUrl: "/cosmos.bank.v1beta1.MsgSend",
      value: {
        fromAddress: n,
        toAddress: o,
        amount: [...u]
      }
    };
    return this.signAndBroadcast(n, [m], c, d);
  }
  async delegateTokens(n, o, u, c, d = "") {
    const m = {
      typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
      value: tx_2$3.MsgDelegate.fromPartial({ delegatorAddress: n, validatorAddress: o, amount: u })
    };
    return this.signAndBroadcast(n, [m], c, d);
  }
  async undelegateTokens(n, o, u, c, d = "") {
    const m = {
      typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
      value: tx_2$3.MsgUndelegate.fromPartial({ delegatorAddress: n, validatorAddress: o, amount: u })
    };
    return this.signAndBroadcast(n, [m], c, d);
  }
  async withdrawRewards(n, o, u, c = "") {
    const d = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
      value: tx_1$d.MsgWithdrawDelegatorReward.fromPartial({ delegatorAddress: n, validatorAddress: o })
    };
    return this.signAndBroadcast(n, [d], u, c);
  }
  /**
   * Creates a transaction with the given messages, fee, memo and timeout height. Then signs and broadcasts the transaction.
   *
   * @param signerAddress The address that will sign transactions using this instance. The signer must be able to sign with this address.
   * @param messages
   * @param fee
   * @param memo
   * @param timeoutHeight (optional) timeout height to prevent the tx from being committed past a certain height
   */
  async signAndBroadcast(n, o, u, c = "", d) {
    let m;
    if (u == "auto" || typeof u == "number") {
      (0, utils_1$p.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
      const $ = await this.simulate(n, o, c), E = typeof u == "number" ? u : 1.4;
      m = (0, stargate_1.calculateFee)(Math.round($ * E), this.gasPrice);
    } else
      m = u;
    const v = await this.sign(n, o, m, c, void 0, d), S = tx_3$1.TxRaw.encode(v).finish();
    return this.broadcastTx(S, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
  }
  /**
   * Creates a transaction with the given messages, fee, memo and timeout height. Then signs and broadcasts the transaction.
   *
   * This method is useful if you want to send a transaction in broadcast,
   * without waiting for it to be placed inside a block, because for example
   * I would like to receive the hash to later track the transaction with another tool.
   *
   * @param signerAddress The address that will sign transactions using this instance. The signer must be able to sign with this address.
   * @param messages
   * @param fee
   * @param memo
   * @param timeoutHeight (optional) timeout height to prevent the tx from being committed past a certain height
   *
   * @returns Returns the hash of the transaction
   */
  async signAndBroadcastSync(n, o, u, c = "", d) {
    let m;
    if (u == "auto" || typeof u == "number") {
      (0, utils_1$p.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
      const $ = await this.simulate(n, o, c), E = typeof u == "number" ? u : 1.3;
      m = (0, stargate_1.calculateFee)(Math.round($ * E), this.gasPrice);
    } else
      m = u;
    const v = await this.sign(n, o, m, c, void 0, d), S = tx_3$1.TxRaw.encode(v).finish();
    return this.broadcastTxSync(S);
  }
  async sign(n, o, u, c, d, m) {
    let v;
    if (d)
      v = d;
    else {
      const { accountNumber: S, sequence: $ } = await this.getSequence(n), E = await this.getChainId();
      v = {
        accountNumber: S,
        sequence: $,
        chainId: E
      };
    }
    return (0, proto_signing_1$5.isOfflineDirectSigner)(this.signer) ? this.signDirect(n, o, u, c, v, m) : this.signAmino(n, o, u, c, v, m);
  }
  async signAmino(n, o, u, c, { accountNumber: d, sequence: m, chainId: v }, S) {
    (0, utils_1$p.assert)(!(0, proto_signing_1$5.isOfflineDirectSigner)(this.signer));
    const $ = (await this.signer.getAccounts()).find((ue) => ue.address === n);
    if (!$)
      throw new Error("Failed to retrieve account from signer");
    const E = (0, proto_signing_1$5.encodePubkey)((0, amino_1$7.encodeSecp256k1Pubkey)($.pubkey)), O = signing_1$5.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, T = o.map((ue) => this.aminoTypes.toAmino(ue)), y = (0, amino_1$7.makeSignDoc)(T, u, v, c, d, m, S), { signature: V, signed: M } = await this.signer.signAmino(n, y), G = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: M.msgs.map((ue) => this.aminoTypes.fromAmino(ue)),
        memo: M.memo,
        timeoutHeight: S
      }
    }, k = this.registry.encode(G), F = math_1$e.Int53.fromString(M.fee.gas).toNumber(), X = math_1$e.Int53.fromString(M.sequence).toNumber(), ee = (0, proto_signing_1$5.makeAuthInfoBytes)([{ pubkey: E, sequence: X }], M.fee.amount, F, M.fee.granter, M.fee.payer, O);
    return tx_3$1.TxRaw.fromPartial({
      bodyBytes: k,
      authInfoBytes: ee,
      signatures: [(0, encoding_1$q.fromBase64)(V.signature)]
    });
  }
  async signDirect(n, o, u, c, { accountNumber: d, sequence: m, chainId: v }, S) {
    (0, utils_1$p.assert)((0, proto_signing_1$5.isOfflineDirectSigner)(this.signer));
    const $ = (await this.signer.getAccounts()).find((F) => F.address === n);
    if (!$)
      throw new Error("Failed to retrieve account from signer");
    const E = (0, proto_signing_1$5.encodePubkey)((0, amino_1$7.encodeSecp256k1Pubkey)($.pubkey)), O = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: o,
        memo: c,
        timeoutHeight: S
      }
    }, T = this.registry.encode(O), y = math_1$e.Int53.fromString(u.gas).toNumber(), V = (0, proto_signing_1$5.makeAuthInfoBytes)([{ pubkey: E, sequence: m }], u.amount, y, u.granter, u.payer), M = (0, proto_signing_1$5.makeSignDoc)(T, V, v, d), { signature: G, signed: k } = await this.signer.signDirect(n, M);
    return tx_3$1.TxRaw.fromPartial({
      bodyBytes: k.bodyBytes,
      authInfoBytes: k.authInfoBytes,
      signatures: [(0, encoding_1$q.fromBase64)(G.signature)]
    });
  }
}
signingcosmwasmclient.SigningCosmWasmClient = SigningCosmWasmClient;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SigningCosmWasmClient = e.wasmTypes = e.setupWasmExtension = e.isMsgUpdateAdminEncodeObject = e.isMsgStoreCodeEncodeObject = e.isMsgMigrateEncodeObject = e.isMsgInstantiateContractEncodeObject = e.isMsgInstantiateContract2EncodeObject = e.isMsgExecuteEncodeObject = e.isMsgClearAdminEncodeObject = e.createWasmAminoConverters = e.instantiate2Address = e._instantiate2AddressIntermediate = e.toBinary = e.fromBinary = e.CosmWasmClient = void 0;
  var n = cosmwasmclient;
  Object.defineProperty(e, "CosmWasmClient", { enumerable: !0, get: function() {
    return n.CosmWasmClient;
  } });
  var o = encoding$1;
  Object.defineProperty(e, "fromBinary", { enumerable: !0, get: function() {
    return o.fromBinary;
  } }), Object.defineProperty(e, "toBinary", { enumerable: !0, get: function() {
    return o.toBinary;
  } });
  var u = instantiate2;
  Object.defineProperty(e, "_instantiate2AddressIntermediate", { enumerable: !0, get: function() {
    return u._instantiate2AddressIntermediate;
  } }), Object.defineProperty(e, "instantiate2Address", { enumerable: !0, get: function() {
    return u.instantiate2Address;
  } });
  var c = modules$1;
  Object.defineProperty(e, "createWasmAminoConverters", { enumerable: !0, get: function() {
    return c.createWasmAminoConverters;
  } }), Object.defineProperty(e, "isMsgClearAdminEncodeObject", { enumerable: !0, get: function() {
    return c.isMsgClearAdminEncodeObject;
  } }), Object.defineProperty(e, "isMsgExecuteEncodeObject", { enumerable: !0, get: function() {
    return c.isMsgExecuteEncodeObject;
  } }), Object.defineProperty(e, "isMsgInstantiateContract2EncodeObject", { enumerable: !0, get: function() {
    return c.isMsgInstantiateContract2EncodeObject;
  } }), Object.defineProperty(e, "isMsgInstantiateContractEncodeObject", { enumerable: !0, get: function() {
    return c.isMsgInstantiateContractEncodeObject;
  } }), Object.defineProperty(e, "isMsgMigrateEncodeObject", { enumerable: !0, get: function() {
    return c.isMsgMigrateEncodeObject;
  } }), Object.defineProperty(e, "isMsgStoreCodeEncodeObject", { enumerable: !0, get: function() {
    return c.isMsgStoreCodeEncodeObject;
  } }), Object.defineProperty(e, "isMsgUpdateAdminEncodeObject", { enumerable: !0, get: function() {
    return c.isMsgUpdateAdminEncodeObject;
  } }), Object.defineProperty(e, "setupWasmExtension", { enumerable: !0, get: function() {
    return c.setupWasmExtension;
  } }), Object.defineProperty(e, "wasmTypes", { enumerable: !0, get: function() {
    return c.wasmTypes;
  } });
  var d = signingcosmwasmclient;
  Object.defineProperty(e, "SigningCosmWasmClient", { enumerable: !0, get: function() {
    return d.SigningCosmWasmClient;
  } });
})(build$o);
class KeplerWallet {
  constructor(n, o) {
    // @ts-ignore
    fi(this, "name");
    fi(this, "chainId");
    fi(this, "registry");
    fi(this, "conf");
    fi(this, "aminoTypes", new build$S.AminoTypes({ ...build$S.createDefaultAminoConverters(), ...build$o.createWasmAminoConverters() }));
    if (this.chainId = n.chainId || "cosmoshub", !window.getOfflineSigner || !window.keplr)
      throw new Error("Please install keplr extension");
    this.registry = o, this.conf = n;
  }
  async getAccounts() {
    return await window.keplr.enable(this.chainId), window.getOfflineSigner(this.chainId).getAccounts();
  }
  supportCoinType(n) {
    return Promise.resolve(!0);
  }
  isEthermint() {
    return this.conf.hdPath && this.conf.hdPath.startsWith("m/44'/60");
  }
  async sign(n) {
    return n.messages.findIndex((o) => o.typeUrl.startsWith("/cosmwasm.wasm")) > -1 ? this.signDirect(n) : this.signAmino(n);
  }
  // @deprecated use signAmino instead
  // because signDirect is not supported ledger wallet
  async signDirect(n) {
    const o = await this.getAccounts(), u = build$V.toHex(build$V.fromBech32(n.signerAddress).data), c = o.find((V) => build$V.toHex(build$V.fromBech32(V.address).data) === u);
    if (!c)
      throw new Error("Failed to retrieve account from signer");
    const d = Any$1.fromPartial({
      typeUrl: keyType(n.chainId),
      value: PubKey$3.encode({
        key: c.pubkey
      }).finish()
    }), m = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: n.messages,
        memo: n.memo
      }
    }, v = this.registry.encode(m), S = Number(n.fee.gas), $ = build$Q.makeAuthInfoBytes(
      [{ pubkey: d, sequence: n.signerData.sequence }],
      n.fee.amount,
      S,
      n.fee.granter,
      n.fee.payer
    ), E = build$Q.makeSignDoc(v, $, n.chainId, n.signerData.accountNumber), O = window.getOfflineSigner(this.chainId), { signature: T, signed: y } = await O.signDirect(n.signerAddress, E);
    return tx$p.TxRaw.fromPartial({
      bodyBytes: y.bodyBytes,
      authInfoBytes: y.authInfoBytes,
      signatures: [build$V.fromBase64(T.signature)]
    });
  }
  async signAmino(n) {
    const o = await this.getAccounts(), u = build$V.toHex(build$V.fromBech32(n.signerAddress).data), c = o.find((F) => build$V.toHex(build$V.fromBech32(F.address).data) === u);
    if (!c)
      throw new Error("Failed to retrieve account from signer");
    const d = Any$1.fromPartial({
      typeUrl: keyType(n.chainId),
      value: PubKey$3.encode({
        key: c.pubkey
      }).finish()
    }), m = signing$3.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, v = n.messages.map((F) => this.aminoTypes.toAmino(F)), S = build$P.makeSignDoc(v, n.fee, n.chainId, n.memo, n.signerData.accountNumber, n.signerData.sequence), $ = window.getOfflineSigner(this.chainId), { signature: E, signed: O } = await $.signAmino(n.signerAddress, S), y = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: O.msgs.map((F) => this.aminoTypes.fromAmino(F)),
        memo: O.memo
      }
    }, V = this.registry.encode(y), M = Number(O.fee.gas), G = Number(O.sequence), k = build$Q.makeAuthInfoBytes(
      [{ pubkey: d, sequence: G }],
      O.fee.amount,
      M,
      O.fee.granter,
      O.fee.payer,
      m
    );
    return tx$p.TxRaw.fromPartial({
      bodyBytes: V,
      authInfoBytes: k,
      signatures: [build$V.fromBase64(E.signature)]
    });
  }
  async getCosmWasmClient(n, o, u) {
    const c = {
      broadcastPollIntervalMs: 600,
      gasPrice: build$S.GasPrice.fromString(`${o}${u}`)
    }, d = await build$y.Tendermint37Client.connect(n), m = window.getOfflineSigner(this.chainId);
    return await build$o.SigningCosmWasmClient.createWithSigner(
      d,
      m,
      c
    );
  }
  async signAndBroadcast(n, o, u, c, d, m, v) {
    return (await this.getCosmWasmClient(u, c, d)).signAndBroadcast(n, o, {
      amount: [
        {
          amount: c,
          denom: d
        }
      ],
      gas: m
    }, v);
  }
}
const createCustomErrorClass = (e) => {
  class n extends Error {
    constructor(u, c, d) {
      if (super(u || e, d), Object.setPrototypeOf(this, n.prototype), this.name = e, c)
        for (const m in c)
          this[m] = c[m];
      if (d && isObject$3(d) && "cause" in d && !("cause" in this)) {
        const m = d.cause;
        this.cause = m, "stack" in m && (this.stack = this.stack + `
CAUSE: ` + m.stack);
      }
    }
  }
  return n;
};
function isObject$3(e) {
  return typeof e == "object";
}
const LockedDeviceError = createCustomErrorClass("LockedDeviceError"), DisconnectedDevice = createCustomErrorClass("DisconnectedDevice"), DisconnectedDeviceDuringOperation = createCustomErrorClass("DisconnectedDeviceDuringOperation"), TransportOpenUserCancelled = createCustomErrorClass("TransportOpenUserCancelled"), TransportInterfaceNotAvailable = createCustomErrorClass("TransportInterfaceNotAvailable"), TransportRaceCondition = createCustomErrorClass("TransportRaceCondition"), TransportWebUSBGestureRequired = createCustomErrorClass("TransportWebUSBGestureRequired");
var HwTransportErrorType;
(function(e) {
  e.Unknown = "Unknown", e.LocationServicesDisabled = "LocationServicesDisabled", e.LocationServicesUnauthorized = "LocationServicesUnauthorized", e.BluetoothScanStartFailed = "BluetoothScanStartFailed";
})(HwTransportErrorType || (HwTransportErrorType = {}));
class TransportError extends Error {
  constructor(n, o) {
    const u = "TransportError";
    super(n || u), this.name = u, this.message = n, this.stack = new Error().stack, this.id = o;
  }
}
const StatusCodes = {
  ACCESS_CONDITION_NOT_FULFILLED: 38916,
  ALGORITHM_NOT_SUPPORTED: 38020,
  CLA_NOT_SUPPORTED: 28160,
  CODE_BLOCKED: 38976,
  CODE_NOT_INITIALIZED: 38914,
  COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 27009,
  CONDITIONS_OF_USE_NOT_SATISFIED: 27013,
  CONTRADICTION_INVALIDATION: 38928,
  CONTRADICTION_SECRET_CODE_STATUS: 38920,
  CUSTOM_IMAGE_BOOTLOADER: 26159,
  CUSTOM_IMAGE_EMPTY: 26158,
  FILE_ALREADY_EXISTS: 27273,
  FILE_NOT_FOUND: 37892,
  GP_AUTH_FAILED: 25344,
  HALTED: 28586,
  INCONSISTENT_FILE: 37896,
  INCORRECT_DATA: 27264,
  INCORRECT_LENGTH: 26368,
  INCORRECT_P1_P2: 27392,
  INS_NOT_SUPPORTED: 27904,
  DEVICE_NOT_ONBOARDED: 27911,
  DEVICE_NOT_ONBOARDED_2: 26129,
  INVALID_KCV: 38021,
  INVALID_OFFSET: 37890,
  LICENSING: 28482,
  LOCKED_DEVICE: 21781,
  MAX_VALUE_REACHED: 38992,
  MEMORY_PROBLEM: 37440,
  MISSING_CRITICAL_PARAMETER: 26624,
  NO_EF_SELECTED: 37888,
  NOT_ENOUGH_MEMORY_SPACE: 27268,
  OK: 36864,
  PIN_REMAINING_ATTEMPTS: 25536,
  REFERENCED_DATA_NOT_FOUND: 27272,
  SECURITY_STATUS_NOT_SATISFIED: 27010,
  TECHNICAL_PROBLEM: 28416,
  UNKNOWN_APDU: 27906,
  USER_REFUSED_ON_DEVICE: 21761,
  NOT_ENOUGH_SPACE: 20738
};
function getAltStatusMessage(e) {
  switch (e) {
    case 26368:
      return "Incorrect length";
    case 26624:
      return "Missing critical parameter";
    case 27010:
      return "Security not satisfied (dongle locked or have invalid access rights)";
    case 27013:
      return "Condition of use not satisfied (denied by the user?)";
    case 27264:
      return "Invalid data received";
    case 27392:
      return "Invalid parameter received";
    case 21781:
      return "Locked device";
  }
  if (28416 <= e && e <= 28671)
    return "Internal error, please report";
}
function TransportStatusError(e) {
  const n = Object.keys(StatusCodes).find((d) => StatusCodes[d] === e) || "UNKNOWN_ERROR", o = getAltStatusMessage(e) || n, u = e.toString(16), c = `Ledger device: ${o} (0x${u})`;
  if (e === StatusCodes.LOCKED_DEVICE)
    throw new LockedDeviceError(c);
  this.name = "TransportStatusError", this.message = c, this.stack = new Error().stack, this.statusCode = e, this.statusText = n;
}
TransportStatusError.prototype = new Error();
var __awaiter$5 = globalThis && globalThis.__awaiter || function(e, n, o, u) {
  function c(d) {
    return d instanceof o ? d : new o(function(m) {
      m(d);
    });
  }
  return new (o || (o = Promise))(function(d, m) {
    function v(E) {
      try {
        $(u.next(E));
      } catch (O) {
        m(O);
      }
    }
    function S(E) {
      try {
        $(u.throw(E));
      } catch (O) {
        m(O);
      }
    }
    function $(E) {
      E.done ? d(E.value) : c(E.value).then(v, S);
    }
    $((u = u.apply(e, n || [])).next());
  });
};
class Transport {
  constructor() {
    this.exchangeTimeout = 3e4, this.unresponsiveTimeout = 15e3, this.deviceModel = null, this._events = new EventEmitter$2(), this.send = (n, o, u, c, d = Buffer.alloc(0), m = [StatusCodes.OK]) => __awaiter$5(this, void 0, void 0, function* () {
      if (d.length >= 256)
        throw new TransportError("data.length exceed 256 bytes limit. Got: " + d.length, "DataLengthTooBig");
      const v = yield this.exchange(Buffer.concat([
        Buffer.from([n, o, u, c]),
        Buffer.from([d.length]),
        d
      ])), S = v.readUInt16BE(v.length - 2);
      if (!m.some(($) => $ === S))
        throw new TransportStatusError(S);
      return v;
    }), this.exchangeAtomicImpl = (n) => __awaiter$5(this, void 0, void 0, function* () {
      if (this.exchangeBusyPromise)
        throw new TransportRaceCondition("An action was already pending on the Ledger device. Please deny or reconnect.");
      let o;
      const u = new Promise((m) => {
        o = m;
      });
      this.exchangeBusyPromise = u;
      let c = !1;
      const d = setTimeout(() => {
        c = !0, this.emit("unresponsive");
      }, this.unresponsiveTimeout);
      try {
        const m = yield n();
        return c && this.emit("responsive"), m;
      } finally {
        clearTimeout(d), o && o(), this.exchangeBusyPromise = null;
      }
    }), this._appAPIlock = null;
  }
  /**
   * Send data to the device using a low level API.
   * It's recommended to use the "send" method for a higher level API.
   * @param {Buffer} apdu - The data to send.
   * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
   */
  exchange(n) {
    throw new Error("exchange not implemented");
  }
  /**
   * Send apdus in batch to the device using a low level API.
   * The default implementation is to call exchange for each apdu.
   * @param {Array<Buffer>} apdus - array of apdus to send.
   * @param {Observer<Buffer>} observer - an observer that will receive the response of each apdu.
   * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop sending apdus.
   */
  exchangeBulk(n, o) {
    let u = !1;
    const c = () => {
      u = !0;
    };
    return (() => __awaiter$5(this, void 0, void 0, function* () {
      if (!u)
        for (const m of n) {
          const v = yield this.exchange(m);
          if (u)
            return;
          const S = v.readUInt16BE(v.length - 2);
          if (S !== StatusCodes.OK)
            throw new TransportStatusError(S);
          o.next(v);
        }
    }))().then(() => !u && o.complete(), (m) => !u && o.error(m)), { unsubscribe: c };
  }
  /**
   * Set the "scramble key" for the next data exchanges with the device.
   * Each app can have a different scramble key and it is set internally during instantiation.
   * @param {string} key - The scramble key to set.
   * @deprecated This method is no longer needed for modern transports and should be migrated away from.
   */
  setScrambleKey(n) {
  }
  /**
   * Close the connection with the device.
   * @returns {Promise<void>} A promise that resolves when the transport is closed.
   */
  close() {
    return Promise.resolve();
  }
  /**
   * Listen for an event on the transport instance.
   * Transport implementations may have specific events. Common events include:
   * "disconnect" : triggered when the transport is disconnected.
   * @param {string} eventName - The name of the event to listen for.
   * @param {(...args: Array<any>) => any} cb - The callback function to be invoked when the event occurs.
   */
  on(n, o) {
    this._events.on(n, o);
  }
  /**
   * Stop listening to an event on an instance of transport.
   */
  off(n, o) {
    this._events.removeListener(n, o);
  }
  emit(n, ...o) {
    this._events.emit(n, ...o);
  }
  /**
   * Enable or not logs of the binary exchange
   */
  setDebugMode() {
    console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
  }
  /**
   * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
   */
  setExchangeTimeout(n) {
    this.exchangeTimeout = n;
  }
  /**
   * Define the delay before emitting "unresponsive" on an exchange that does not respond
   */
  setExchangeUnresponsiveTimeout(n) {
    this.unresponsiveTimeout = n;
  }
  /**
   * create() allows to open the first descriptor available or
   * throw if there is none or if timeout is reached.
   * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
   * @example
  TransportFoo.create().then(transport => ...)
   */
  static create(n = 3e3, o) {
    return new Promise((u, c) => {
      let d = !1;
      const m = this.listen({
        next: (S) => {
          d = !0, m && m.unsubscribe(), v && clearTimeout(v), this.open(S.descriptor, n).then(u, c);
        },
        error: (S) => {
          v && clearTimeout(v), c(S);
        },
        complete: () => {
          v && clearTimeout(v), d || c(new TransportError(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
        }
      }), v = o ? setTimeout(() => {
        m.unsubscribe(), c(new TransportError(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
      }, o) : null;
    });
  }
  decorateAppAPIMethods(n, o, u) {
    for (const c of o)
      n[c] = this.decorateAppAPIMethod(c, n[c], n, u);
  }
  decorateAppAPIMethod(n, o, u, c) {
    return (...d) => __awaiter$5(this, void 0, void 0, function* () {
      const { _appAPIlock: m } = this;
      if (m)
        return Promise.reject(new TransportError("Ledger Device is busy (lock " + m + ")", "TransportLocked"));
      try {
        return this._appAPIlock = n, this.setScrambleKey(c), yield o.apply(u, d);
      } finally {
        this._appAPIlock = null;
      }
    });
  }
}
Transport.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
Transport.ErrorMessage_NoDeviceFound = "No Ledger device found";
const Tag = 5;
function asUInt16BE(e) {
  const n = Buffer.alloc(2);
  return n.writeUInt16BE(e, 0), n;
}
const initialAcc = {
  data: Buffer.alloc(0),
  dataLength: 0,
  sequence: 0
}, createHIDframing = (e, n) => ({
  makeBlocks(o) {
    let u = Buffer.concat([asUInt16BE(o.length), o]);
    const c = n - 5, d = Math.ceil(u.length / c);
    u = Buffer.concat([
      u,
      Buffer.alloc(d * c - u.length + 1).fill(0)
    ]);
    const m = [];
    for (let v = 0; v < d; v++) {
      const S = Buffer.alloc(5);
      S.writeUInt16BE(e, 0), S.writeUInt8(Tag, 2), S.writeUInt16BE(v, 3);
      const $ = u.slice(v * c, (v + 1) * c);
      m.push(Buffer.concat([S, $]));
    }
    return m;
  },
  reduceResponse(o, u) {
    let { data: c, dataLength: d, sequence: m } = o || initialAcc;
    if (u.readUInt16BE(0) !== e)
      throw new TransportError("Invalid channel", "InvalidChannel");
    if (u.readUInt8(2) !== Tag)
      throw new TransportError("Invalid tag", "InvalidTag");
    if (u.readUInt16BE(3) !== m)
      throw new TransportError("Invalid sequence", "InvalidSequence");
    o || (d = u.readUInt16BE(5)), m++;
    const v = u.slice(o ? 5 : 7);
    return c = Buffer.concat([c, v]), c.length > d && (c = c.slice(0, d)), {
      data: c,
      dataLength: d,
      sequence: m
    };
  },
  getReducedResult(o) {
    if (o && o.dataLength === o.data.length)
      return o.data;
  }
});
var re$5 = { exports: {} };
const SEMVER_SPEC_VERSION$1 = "2.0.0", MAX_LENGTH$3 = 256, MAX_SAFE_INTEGER$4 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, MAX_SAFE_COMPONENT_LENGTH$1 = 16, RELEASE_TYPES$1 = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants$3 = {
  MAX_LENGTH: MAX_LENGTH$3,
  MAX_SAFE_COMPONENT_LENGTH: MAX_SAFE_COMPONENT_LENGTH$1,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$4,
  RELEASE_TYPES: RELEASE_TYPES$1,
  SEMVER_SPEC_VERSION: SEMVER_SPEC_VERSION$1,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const debug$3 = typeof browser$1$1 == "object" && browser$1$1.env && browser$1$1.env.NODE_DEBUG && /\bsemver\b/i.test(browser$1$1.env.NODE_DEBUG) ? (...e) => console.error("SEMVER", ...e) : () => {
};
var debug_1$1 = debug$3;
(function(e, n) {
  const { MAX_SAFE_COMPONENT_LENGTH: o } = constants$3, u = debug_1$1;
  n = e.exports = {};
  const c = n.re = [], d = n.src = [], m = n.t = {};
  let v = 0;
  const S = ($, E, O) => {
    const T = v++;
    u($, T, E), m[$] = T, d[T] = E, c[T] = new RegExp(E, O ? "g" : void 0);
  };
  S("NUMERICIDENTIFIER", "0|[1-9]\\d*"), S("NUMERICIDENTIFIERLOOSE", "[0-9]+"), S("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), S("MAINVERSION", `(${d[m.NUMERICIDENTIFIER]})\\.(${d[m.NUMERICIDENTIFIER]})\\.(${d[m.NUMERICIDENTIFIER]})`), S("MAINVERSIONLOOSE", `(${d[m.NUMERICIDENTIFIERLOOSE]})\\.(${d[m.NUMERICIDENTIFIERLOOSE]})\\.(${d[m.NUMERICIDENTIFIERLOOSE]})`), S("PRERELEASEIDENTIFIER", `(?:${d[m.NUMERICIDENTIFIER]}|${d[m.NONNUMERICIDENTIFIER]})`), S("PRERELEASEIDENTIFIERLOOSE", `(?:${d[m.NUMERICIDENTIFIERLOOSE]}|${d[m.NONNUMERICIDENTIFIER]})`), S("PRERELEASE", `(?:-(${d[m.PRERELEASEIDENTIFIER]}(?:\\.${d[m.PRERELEASEIDENTIFIER]})*))`), S("PRERELEASELOOSE", `(?:-?(${d[m.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${d[m.PRERELEASEIDENTIFIERLOOSE]})*))`), S("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), S("BUILD", `(?:\\+(${d[m.BUILDIDENTIFIER]}(?:\\.${d[m.BUILDIDENTIFIER]})*))`), S("FULLPLAIN", `v?${d[m.MAINVERSION]}${d[m.PRERELEASE]}?${d[m.BUILD]}?`), S("FULL", `^${d[m.FULLPLAIN]}$`), S("LOOSEPLAIN", `[v=\\s]*${d[m.MAINVERSIONLOOSE]}${d[m.PRERELEASELOOSE]}?${d[m.BUILD]}?`), S("LOOSE", `^${d[m.LOOSEPLAIN]}$`), S("GTLT", "((?:<|>)?=?)"), S("XRANGEIDENTIFIERLOOSE", `${d[m.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), S("XRANGEIDENTIFIER", `${d[m.NUMERICIDENTIFIER]}|x|X|\\*`), S("XRANGEPLAIN", `[v=\\s]*(${d[m.XRANGEIDENTIFIER]})(?:\\.(${d[m.XRANGEIDENTIFIER]})(?:\\.(${d[m.XRANGEIDENTIFIER]})(?:${d[m.PRERELEASE]})?${d[m.BUILD]}?)?)?`), S("XRANGEPLAINLOOSE", `[v=\\s]*(${d[m.XRANGEIDENTIFIERLOOSE]})(?:\\.(${d[m.XRANGEIDENTIFIERLOOSE]})(?:\\.(${d[m.XRANGEIDENTIFIERLOOSE]})(?:${d[m.PRERELEASELOOSE]})?${d[m.BUILD]}?)?)?`), S("XRANGE", `^${d[m.GTLT]}\\s*${d[m.XRANGEPLAIN]}$`), S("XRANGELOOSE", `^${d[m.GTLT]}\\s*${d[m.XRANGEPLAINLOOSE]}$`), S("COERCE", `(^|[^\\d])(\\d{1,${o}})(?:\\.(\\d{1,${o}}))?(?:\\.(\\d{1,${o}}))?(?:$|[^\\d])`), S("COERCERTL", d[m.COERCE], !0), S("LONETILDE", "(?:~>?)"), S("TILDETRIM", `(\\s*)${d[m.LONETILDE]}\\s+`, !0), n.tildeTrimReplace = "$1~", S("TILDE", `^${d[m.LONETILDE]}${d[m.XRANGEPLAIN]}$`), S("TILDELOOSE", `^${d[m.LONETILDE]}${d[m.XRANGEPLAINLOOSE]}$`), S("LONECARET", "(?:\\^)"), S("CARETTRIM", `(\\s*)${d[m.LONECARET]}\\s+`, !0), n.caretTrimReplace = "$1^", S("CARET", `^${d[m.LONECARET]}${d[m.XRANGEPLAIN]}$`), S("CARETLOOSE", `^${d[m.LONECARET]}${d[m.XRANGEPLAINLOOSE]}$`), S("COMPARATORLOOSE", `^${d[m.GTLT]}\\s*(${d[m.LOOSEPLAIN]})$|^$`), S("COMPARATOR", `^${d[m.GTLT]}\\s*(${d[m.FULLPLAIN]})$|^$`), S("COMPARATORTRIM", `(\\s*)${d[m.GTLT]}\\s*(${d[m.LOOSEPLAIN]}|${d[m.XRANGEPLAIN]})`, !0), n.comparatorTrimReplace = "$1$2$3", S("HYPHENRANGE", `^\\s*(${d[m.XRANGEPLAIN]})\\s+-\\s+(${d[m.XRANGEPLAIN]})\\s*$`), S("HYPHENRANGELOOSE", `^\\s*(${d[m.XRANGEPLAINLOOSE]})\\s+-\\s+(${d[m.XRANGEPLAINLOOSE]})\\s*$`), S("STAR", "(<|>)?=?\\s*\\*"), S("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), S("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$5, re$5.exports);
var reExports$1 = re$5.exports;
const looseOption$1 = Object.freeze({ loose: !0 }), emptyOpts$1 = Object.freeze({}), parseOptions$3 = (e) => e ? typeof e != "object" ? looseOption$1 : e : emptyOpts$1;
var parseOptions_1$1 = parseOptions$3;
const numeric$1 = /^[0-9]+$/, compareIdentifiers$3 = (e, n) => {
  const o = numeric$1.test(e), u = numeric$1.test(n);
  return o && u && (e = +e, n = +n), e === n ? 0 : o && !u ? -1 : u && !o ? 1 : e < n ? -1 : 1;
}, rcompareIdentifiers$1 = (e, n) => compareIdentifiers$3(n, e);
var identifiers$3 = {
  compareIdentifiers: compareIdentifiers$3,
  rcompareIdentifiers: rcompareIdentifiers$1
};
const debug$2 = debug_1$1, { MAX_LENGTH: MAX_LENGTH$2, MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$3 } = constants$3, { re: re$4, t: t$3 } = reExports$1, parseOptions$2 = parseOptions_1$1, { compareIdentifiers: compareIdentifiers$2 } = identifiers$3;
let SemVer$r = class Ca {
  constructor(n, o) {
    if (o = parseOptions$2(o), n instanceof Ca) {
      if (n.loose === !!o.loose && n.includePrerelease === !!o.includePrerelease)
        return n;
      n = n.version;
    } else if (typeof n != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof n}".`);
    if (n.length > MAX_LENGTH$2)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH$2} characters`
      );
    debug$2("SemVer", n, o), this.options = o, this.loose = !!o.loose, this.includePrerelease = !!o.includePrerelease;
    const u = n.trim().match(o.loose ? re$4[t$3.LOOSE] : re$4[t$3.FULL]);
    if (!u)
      throw new TypeError(`Invalid Version: ${n}`);
    if (this.raw = n, this.major = +u[1], this.minor = +u[2], this.patch = +u[3], this.major > MAX_SAFE_INTEGER$3 || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER$3 || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER$3 || this.patch < 0)
      throw new TypeError("Invalid patch version");
    u[4] ? this.prerelease = u[4].split(".").map((c) => {
      if (/^[0-9]+$/.test(c)) {
        const d = +c;
        if (d >= 0 && d < MAX_SAFE_INTEGER$3)
          return d;
      }
      return c;
    }) : this.prerelease = [], this.build = u[5] ? u[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(n) {
    if (debug$2("SemVer.compare", this.version, this.options, n), !(n instanceof Ca)) {
      if (typeof n == "string" && n === this.version)
        return 0;
      n = new Ca(n, this.options);
    }
    return n.version === this.version ? 0 : this.compareMain(n) || this.comparePre(n);
  }
  compareMain(n) {
    return n instanceof Ca || (n = new Ca(n, this.options)), compareIdentifiers$2(this.major, n.major) || compareIdentifiers$2(this.minor, n.minor) || compareIdentifiers$2(this.patch, n.patch);
  }
  comparePre(n) {
    if (n instanceof Ca || (n = new Ca(n, this.options)), this.prerelease.length && !n.prerelease.length)
      return -1;
    if (!this.prerelease.length && n.prerelease.length)
      return 1;
    if (!this.prerelease.length && !n.prerelease.length)
      return 0;
    let o = 0;
    do {
      const u = this.prerelease[o], c = n.prerelease[o];
      if (debug$2("prerelease compare", o, u, c), u === void 0 && c === void 0)
        return 0;
      if (c === void 0)
        return 1;
      if (u === void 0)
        return -1;
      if (u === c)
        continue;
      return compareIdentifiers$2(u, c);
    } while (++o);
  }
  compareBuild(n) {
    n instanceof Ca || (n = new Ca(n, this.options));
    let o = 0;
    do {
      const u = this.build[o], c = n.build[o];
      if (debug$2("prerelease compare", o, u, c), u === void 0 && c === void 0)
        return 0;
      if (c === void 0)
        return 1;
      if (u === void 0)
        return -1;
      if (u === c)
        continue;
      return compareIdentifiers$2(u, c);
    } while (++o);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(n, o, u) {
    switch (n) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", o, u);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", o, u);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", o, u), this.inc("pre", o, u);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", o, u), this.inc("pre", o, u);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const c = Number(u) ? 1 : 0;
        if (!o && u === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [c];
        else {
          let d = this.prerelease.length;
          for (; --d >= 0; )
            typeof this.prerelease[d] == "number" && (this.prerelease[d]++, d = -2);
          if (d === -1) {
            if (o === this.prerelease.join(".") && u === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(c);
          }
        }
        if (o) {
          let d = [o, c];
          u === !1 && (d = [o]), compareIdentifiers$2(this.prerelease[0], o) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = d) : this.prerelease = d;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${n}`);
    }
    return this.format(), this.raw = this.version, this;
  }
};
var semver$4 = SemVer$r;
const SemVer$q = semver$4, parse$e = (e, n, o = !1) => {
  if (e instanceof SemVer$q)
    return e;
  try {
    return new SemVer$q(e, n);
  } catch (u) {
    if (!o)
      return null;
    throw u;
  }
};
var parse_1$1 = parse$e;
const parse$d = parse_1$1, valid$5 = (e, n) => {
  const o = parse$d(e, n);
  return o ? o.version : null;
};
var valid_1$1 = valid$5;
const parse$c = parse_1$1, clean$3 = (e, n) => {
  const o = parse$c(e.trim().replace(/^[=v]+/, ""), n);
  return o ? o.version : null;
};
var clean_1$1 = clean$3;
const SemVer$p = semver$4, inc$3 = (e, n, o, u, c) => {
  typeof o == "string" && (c = u, u = o, o = void 0);
  try {
    return new SemVer$p(
      e instanceof SemVer$p ? e.version : e,
      o
    ).inc(n, u, c).version;
  } catch {
    return null;
  }
};
var inc_1$1 = inc$3;
const parse$b = parse_1$1, diff$3 = (e, n) => {
  const o = parse$b(e, null, !0), u = parse$b(n, null, !0), c = o.compare(u);
  if (c === 0)
    return null;
  const d = c > 0, m = d ? o : u, v = d ? u : o, S = !!m.prerelease.length, $ = S ? "pre" : "";
  return o.major !== u.major ? $ + "major" : o.minor !== u.minor ? $ + "minor" : o.patch !== u.patch ? $ + "patch" : S ? "prerelease" : v.patch ? "patch" : v.minor ? "minor" : "major";
};
var diff_1$1 = diff$3;
const SemVer$o = semver$4, major$3 = (e, n) => new SemVer$o(e, n).major;
var major_1$1 = major$3;
const SemVer$n = semver$4, minor$3 = (e, n) => new SemVer$n(e, n).minor;
var minor_1$1 = minor$3;
const SemVer$m = semver$4, patch$3 = (e, n) => new SemVer$m(e, n).patch;
var patch_1$1 = patch$3;
const parse$a = parse_1$1, prerelease$3 = (e, n) => {
  const o = parse$a(e, n);
  return o && o.prerelease.length ? o.prerelease : null;
};
var prerelease_1$1 = prerelease$3;
const SemVer$l = semver$4, compare$o = (e, n, o) => new SemVer$l(e, o).compare(new SemVer$l(n, o));
var compare_1$1 = compare$o;
const compare$n = compare_1$1, rcompare$3 = (e, n, o) => compare$n(n, e, o);
var rcompare_1$1 = rcompare$3;
const compare$m = compare_1$1, compareLoose$3 = (e, n) => compare$m(e, n, !0);
var compareLoose_1$1 = compareLoose$3;
const SemVer$k = semver$4, compareBuild$7 = (e, n, o) => {
  const u = new SemVer$k(e, o), c = new SemVer$k(n, o);
  return u.compare(c) || u.compareBuild(c);
};
var compareBuild_1$1 = compareBuild$7;
const compareBuild$6 = compareBuild_1$1, sort$3 = (e, n) => e.sort((o, u) => compareBuild$6(o, u, n));
var sort_1$1 = sort$3;
const compareBuild$5 = compareBuild_1$1, rsort$3 = (e, n) => e.sort((o, u) => compareBuild$5(u, o, n));
var rsort_1$1 = rsort$3;
const compare$l = compare_1$1, gt$9 = (e, n, o) => compare$l(e, n, o) > 0;
var gt_1$1 = gt$9;
const compare$k = compare_1$1, lt$7 = (e, n, o) => compare$k(e, n, o) < 0;
var lt_1$1 = lt$7;
const compare$j = compare_1$1, eq$5 = (e, n, o) => compare$j(e, n, o) === 0;
var eq_1$1 = eq$5;
const compare$i = compare_1$1, neq$5 = (e, n, o) => compare$i(e, n, o) !== 0;
var neq_1$1 = neq$5;
const compare$h = compare_1$1, gte$7 = (e, n, o) => compare$h(e, n, o) >= 0;
var gte_1$1 = gte$7;
const compare$g = compare_1$1, lte$7 = (e, n, o) => compare$g(e, n, o) <= 0;
var lte_1$1 = lte$7;
const eq$4 = eq_1$1, neq$4 = neq_1$1, gt$8 = gt_1$1, gte$6 = gte_1$1, lt$6 = lt_1$1, lte$6 = lte_1$1, cmp$3 = (e, n, o, u) => {
  switch (n) {
    case "===":
      return typeof e == "object" && (e = e.version), typeof o == "object" && (o = o.version), e === o;
    case "!==":
      return typeof e == "object" && (e = e.version), typeof o == "object" && (o = o.version), e !== o;
    case "":
    case "=":
    case "==":
      return eq$4(e, o, u);
    case "!=":
      return neq$4(e, o, u);
    case ">":
      return gt$8(e, o, u);
    case ">=":
      return gte$6(e, o, u);
    case "<":
      return lt$6(e, o, u);
    case "<=":
      return lte$6(e, o, u);
    default:
      throw new TypeError(`Invalid operator: ${n}`);
  }
};
var cmp_1$1 = cmp$3;
const SemVer$j = semver$4, parse$9 = parse_1$1, { re: re$3, t: t$2 } = reExports$1, coerce$3 = (e, n) => {
  if (e instanceof SemVer$j)
    return e;
  if (typeof e == "number" && (e = String(e)), typeof e != "string")
    return null;
  n = n || {};
  let o = null;
  if (!n.rtl)
    o = e.match(re$3[t$2.COERCE]);
  else {
    let u;
    for (; (u = re$3[t$2.COERCERTL].exec(e)) && (!o || o.index + o[0].length !== e.length); )
      (!o || u.index + u[0].length !== o.index + o[0].length) && (o = u), re$3[t$2.COERCERTL].lastIndex = u.index + u[1].length + u[2].length;
    re$3[t$2.COERCERTL].lastIndex = -1;
  }
  return o === null ? null : parse$9(`${o[2]}.${o[3] || "0"}.${o[4] || "0"}`, n);
};
var coerce_1$1 = coerce$3, iterator$1, hasRequiredIterator;
function requireIterator() {
  return hasRequiredIterator || (hasRequiredIterator = 1, iterator$1 = function(e) {
    e.prototype[Symbol.iterator] = function* () {
      for (let n = this.head; n; n = n.next)
        yield n.value;
    };
  }), iterator$1;
}
var yallist = Yallist$1;
Yallist$1.Node = Node$2;
Yallist$1.create = Yallist$1;
function Yallist$1(e) {
  var n = this;
  if (n instanceof Yallist$1 || (n = new Yallist$1()), n.tail = null, n.head = null, n.length = 0, e && typeof e.forEach == "function")
    e.forEach(function(c) {
      n.push(c);
    });
  else if (arguments.length > 0)
    for (var o = 0, u = arguments.length; o < u; o++)
      n.push(arguments[o]);
  return n;
}
Yallist$1.prototype.removeNode = function(e) {
  if (e.list !== this)
    throw new Error("removing node which does not belong to this list");
  var n = e.next, o = e.prev;
  return n && (n.prev = o), o && (o.next = n), e === this.head && (this.head = n), e === this.tail && (this.tail = o), e.list.length--, e.next = null, e.prev = null, e.list = null, n;
};
Yallist$1.prototype.unshiftNode = function(e) {
  if (e !== this.head) {
    e.list && e.list.removeNode(e);
    var n = this.head;
    e.list = this, e.next = n, n && (n.prev = e), this.head = e, this.tail || (this.tail = e), this.length++;
  }
};
Yallist$1.prototype.pushNode = function(e) {
  if (e !== this.tail) {
    e.list && e.list.removeNode(e);
    var n = this.tail;
    e.list = this, e.prev = n, n && (n.next = e), this.tail = e, this.head || (this.head = e), this.length++;
  }
};
Yallist$1.prototype.push = function() {
  for (var e = 0, n = arguments.length; e < n; e++)
    push(this, arguments[e]);
  return this.length;
};
Yallist$1.prototype.unshift = function() {
  for (var e = 0, n = arguments.length; e < n; e++)
    unshift(this, arguments[e]);
  return this.length;
};
Yallist$1.prototype.pop = function() {
  if (this.tail) {
    var e = this.tail.value;
    return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, e;
  }
};
Yallist$1.prototype.shift = function() {
  if (this.head) {
    var e = this.head.value;
    return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, e;
  }
};
Yallist$1.prototype.forEach = function(e, n) {
  n = n || this;
  for (var o = this.head, u = 0; o !== null; u++)
    e.call(n, o.value, u, this), o = o.next;
};
Yallist$1.prototype.forEachReverse = function(e, n) {
  n = n || this;
  for (var o = this.tail, u = this.length - 1; o !== null; u--)
    e.call(n, o.value, u, this), o = o.prev;
};
Yallist$1.prototype.get = function(e) {
  for (var n = 0, o = this.head; o !== null && n < e; n++)
    o = o.next;
  if (n === e && o !== null)
    return o.value;
};
Yallist$1.prototype.getReverse = function(e) {
  for (var n = 0, o = this.tail; o !== null && n < e; n++)
    o = o.prev;
  if (n === e && o !== null)
    return o.value;
};
Yallist$1.prototype.map = function(e, n) {
  n = n || this;
  for (var o = new Yallist$1(), u = this.head; u !== null; )
    o.push(e.call(n, u.value, this)), u = u.next;
  return o;
};
Yallist$1.prototype.mapReverse = function(e, n) {
  n = n || this;
  for (var o = new Yallist$1(), u = this.tail; u !== null; )
    o.push(e.call(n, u.value, this)), u = u.prev;
  return o;
};
Yallist$1.prototype.reduce = function(e, n) {
  var o, u = this.head;
  if (arguments.length > 1)
    o = n;
  else if (this.head)
    u = this.head.next, o = this.head.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var c = 0; u !== null; c++)
    o = e(o, u.value, c), u = u.next;
  return o;
};
Yallist$1.prototype.reduceReverse = function(e, n) {
  var o, u = this.tail;
  if (arguments.length > 1)
    o = n;
  else if (this.tail)
    u = this.tail.prev, o = this.tail.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var c = this.length - 1; u !== null; c--)
    o = e(o, u.value, c), u = u.prev;
  return o;
};
Yallist$1.prototype.toArray = function() {
  for (var e = new Array(this.length), n = 0, o = this.head; o !== null; n++)
    e[n] = o.value, o = o.next;
  return e;
};
Yallist$1.prototype.toArrayReverse = function() {
  for (var e = new Array(this.length), n = 0, o = this.tail; o !== null; n++)
    e[n] = o.value, o = o.prev;
  return e;
};
Yallist$1.prototype.slice = function(e, n) {
  n = n || this.length, n < 0 && (n += this.length), e = e || 0, e < 0 && (e += this.length);
  var o = new Yallist$1();
  if (n < e || n < 0)
    return o;
  e < 0 && (e = 0), n > this.length && (n = this.length);
  for (var u = 0, c = this.head; c !== null && u < e; u++)
    c = c.next;
  for (; c !== null && u < n; u++, c = c.next)
    o.push(c.value);
  return o;
};
Yallist$1.prototype.sliceReverse = function(e, n) {
  n = n || this.length, n < 0 && (n += this.length), e = e || 0, e < 0 && (e += this.length);
  var o = new Yallist$1();
  if (n < e || n < 0)
    return o;
  e < 0 && (e = 0), n > this.length && (n = this.length);
  for (var u = this.length, c = this.tail; c !== null && u > n; u--)
    c = c.prev;
  for (; c !== null && u > e; u--, c = c.prev)
    o.push(c.value);
  return o;
};
Yallist$1.prototype.splice = function(e, n, ...o) {
  e > this.length && (e = this.length - 1), e < 0 && (e = this.length + e);
  for (var u = 0, c = this.head; c !== null && u < e; u++)
    c = c.next;
  for (var d = [], u = 0; c && u < n; u++)
    d.push(c.value), c = this.removeNode(c);
  c === null && (c = this.tail), c !== this.head && c !== this.tail && (c = c.prev);
  for (var u = 0; u < o.length; u++)
    c = insert(this, c, o[u]);
  return d;
};
Yallist$1.prototype.reverse = function() {
  for (var e = this.head, n = this.tail, o = e; o !== null; o = o.prev) {
    var u = o.prev;
    o.prev = o.next, o.next = u;
  }
  return this.head = n, this.tail = e, this;
};
function insert(e, n, o) {
  var u = n === e.head ? new Node$2(o, null, n, e) : new Node$2(o, n, n.next, e);
  return u.next === null && (e.tail = u), u.prev === null && (e.head = u), e.length++, u;
}
function push(e, n) {
  e.tail = new Node$2(n, e.tail, null, e), e.head || (e.head = e.tail), e.length++;
}
function unshift(e, n) {
  e.head = new Node$2(n, null, e.head, e), e.tail || (e.tail = e.head), e.length++;
}
function Node$2(e, n, o, u) {
  if (!(this instanceof Node$2))
    return new Node$2(e, n, o, u);
  this.list = u, this.value = e, n ? (n.next = this, this.prev = n) : this.prev = null, o ? (o.prev = this, this.next = o) : this.next = null;
}
try {
  requireIterator()(Yallist$1);
} catch (e) {
}
const Yallist = yallist, MAX$1 = Symbol("max"), LENGTH = Symbol("length"), LENGTH_CALCULATOR = Symbol("lengthCalculator"), ALLOW_STALE = Symbol("allowStale"), MAX_AGE = Symbol("maxAge"), DISPOSE = Symbol("dispose"), NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet"), LRU_LIST = Symbol("lruList"), CACHE = Symbol("cache"), UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet"), naiveLength = () => 1;
class LRUCache {
  constructor(n) {
    if (typeof n == "number" && (n = { max: n }), n || (n = {}), n.max && (typeof n.max != "number" || n.max < 0))
      throw new TypeError("max must be a non-negative number");
    this[MAX$1] = n.max || 1 / 0;
    const o = n.length || naiveLength;
    if (this[LENGTH_CALCULATOR] = typeof o != "function" ? naiveLength : o, this[ALLOW_STALE] = n.stale || !1, n.maxAge && typeof n.maxAge != "number")
      throw new TypeError("maxAge must be a number");
    this[MAX_AGE] = n.maxAge || 0, this[DISPOSE] = n.dispose, this[NO_DISPOSE_ON_SET] = n.noDisposeOnSet || !1, this[UPDATE_AGE_ON_GET] = n.updateAgeOnGet || !1, this.reset();
  }
  // resize the cache when the max changes.
  set max(n) {
    if (typeof n != "number" || n < 0)
      throw new TypeError("max must be a non-negative number");
    this[MAX$1] = n || 1 / 0, trim$2(this);
  }
  get max() {
    return this[MAX$1];
  }
  set allowStale(n) {
    this[ALLOW_STALE] = !!n;
  }
  get allowStale() {
    return this[ALLOW_STALE];
  }
  set maxAge(n) {
    if (typeof n != "number")
      throw new TypeError("maxAge must be a non-negative number");
    this[MAX_AGE] = n, trim$2(this);
  }
  get maxAge() {
    return this[MAX_AGE];
  }
  // resize the cache when the lengthCalculator changes.
  set lengthCalculator(n) {
    typeof n != "function" && (n = naiveLength), n !== this[LENGTH_CALCULATOR] && (this[LENGTH_CALCULATOR] = n, this[LENGTH] = 0, this[LRU_LIST].forEach((o) => {
      o.length = this[LENGTH_CALCULATOR](o.value, o.key), this[LENGTH] += o.length;
    })), trim$2(this);
  }
  get lengthCalculator() {
    return this[LENGTH_CALCULATOR];
  }
  get length() {
    return this[LENGTH];
  }
  get itemCount() {
    return this[LRU_LIST].length;
  }
  rforEach(n, o) {
    o = o || this;
    for (let u = this[LRU_LIST].tail; u !== null; ) {
      const c = u.prev;
      forEachStep(this, n, u, o), u = c;
    }
  }
  forEach(n, o) {
    o = o || this;
    for (let u = this[LRU_LIST].head; u !== null; ) {
      const c = u.next;
      forEachStep(this, n, u, o), u = c;
    }
  }
  keys() {
    return this[LRU_LIST].toArray().map((n) => n.key);
  }
  values() {
    return this[LRU_LIST].toArray().map((n) => n.value);
  }
  reset() {
    this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length && this[LRU_LIST].forEach((n) => this[DISPOSE](n.key, n.value)), this[CACHE] = /* @__PURE__ */ new Map(), this[LRU_LIST] = new Yallist(), this[LENGTH] = 0;
  }
  dump() {
    return this[LRU_LIST].map((n) => isStale(this, n) ? !1 : {
      k: n.key,
      v: n.value,
      e: n.now + (n.maxAge || 0)
    }).toArray().filter((n) => n);
  }
  dumpLru() {
    return this[LRU_LIST];
  }
  set(n, o, u) {
    if (u = u || this[MAX_AGE], u && typeof u != "number")
      throw new TypeError("maxAge must be a number");
    const c = u ? Date.now() : 0, d = this[LENGTH_CALCULATOR](o, n);
    if (this[CACHE].has(n)) {
      if (d > this[MAX$1])
        return del(this, this[CACHE].get(n)), !1;
      const S = this[CACHE].get(n).value;
      return this[DISPOSE] && (this[NO_DISPOSE_ON_SET] || this[DISPOSE](n, S.value)), S.now = c, S.maxAge = u, S.value = o, this[LENGTH] += d - S.length, S.length = d, this.get(n), trim$2(this), !0;
    }
    const m = new Entry(n, o, d, c, u);
    return m.length > this[MAX$1] ? (this[DISPOSE] && this[DISPOSE](n, o), !1) : (this[LENGTH] += m.length, this[LRU_LIST].unshift(m), this[CACHE].set(n, this[LRU_LIST].head), trim$2(this), !0);
  }
  has(n) {
    if (!this[CACHE].has(n))
      return !1;
    const o = this[CACHE].get(n).value;
    return !isStale(this, o);
  }
  get(n) {
    return get(this, n, !0);
  }
  peek(n) {
    return get(this, n, !1);
  }
  pop() {
    const n = this[LRU_LIST].tail;
    return n ? (del(this, n), n.value) : null;
  }
  del(n) {
    del(this, this[CACHE].get(n));
  }
  load(n) {
    this.reset();
    const o = Date.now();
    for (let u = n.length - 1; u >= 0; u--) {
      const c = n[u], d = c.e || 0;
      if (d === 0)
        this.set(c.k, c.v);
      else {
        const m = d - o;
        m > 0 && this.set(c.k, c.v, m);
      }
    }
  }
  prune() {
    this[CACHE].forEach((n, o) => get(this, o, !1));
  }
}
const get = (e, n, o) => {
  const u = e[CACHE].get(n);
  if (u) {
    const c = u.value;
    if (isStale(e, c)) {
      if (del(e, u), !e[ALLOW_STALE])
        return;
    } else
      o && (e[UPDATE_AGE_ON_GET] && (u.value.now = Date.now()), e[LRU_LIST].unshiftNode(u));
    return c.value;
  }
}, isStale = (e, n) => {
  if (!n || !n.maxAge && !e[MAX_AGE])
    return !1;
  const o = Date.now() - n.now;
  return n.maxAge ? o > n.maxAge : e[MAX_AGE] && o > e[MAX_AGE];
}, trim$2 = (e) => {
  if (e[LENGTH] > e[MAX$1])
    for (let n = e[LRU_LIST].tail; e[LENGTH] > e[MAX$1] && n !== null; ) {
      const o = n.prev;
      del(e, n), n = o;
    }
}, del = (e, n) => {
  if (n) {
    const o = n.value;
    e[DISPOSE] && e[DISPOSE](o.key, o.value), e[LENGTH] -= o.length, e[CACHE].delete(o.key), e[LRU_LIST].removeNode(n);
  }
};
class Entry {
  constructor(n, o, u, c, d) {
    this.key = n, this.value = o, this.length = u, this.now = c, this.maxAge = d || 0;
  }
}
const forEachStep = (e, n, o, u) => {
  let c = o.value;
  isStale(e, c) && (del(e, o), e[ALLOW_STALE] || (c = void 0)), c && n.call(u, c.value, c.key, e);
};
var lruCache = LRUCache, range$1, hasRequiredRange$1;
function requireRange$1() {
  if (hasRequiredRange$1)
    return range$1;
  hasRequiredRange$1 = 1;
  class e {
    constructor(P, J) {
      if (J = u(J), P instanceof e)
        return P.loose === !!J.loose && P.includePrerelease === !!J.includePrerelease ? P : new e(P.raw, J);
      if (P instanceof c)
        return this.raw = P.value, this.set = [[P]], this.format(), this;
      if (this.options = J, this.loose = !!J.loose, this.includePrerelease = !!J.includePrerelease, this.raw = P, this.set = P.split("||").map((se) => this.parseRange(se.trim())).filter((se) => se.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${P}`);
      if (this.set.length > 1) {
        const se = this.set[0];
        if (this.set = this.set.filter((fe) => !V(fe[0])), this.set.length === 0)
          this.set = [se];
        else if (this.set.length > 1) {
          for (const fe of this.set)
            if (fe.length === 1 && M(fe[0])) {
              this.set = [fe];
              break;
            }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((P) => P.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(P) {
      P = P.trim();
      const se = ((this.options.includePrerelease && T) | (this.options.loose && y)) + ":" + P, fe = o.get(se);
      if (fe)
        return fe;
      const N = this.options.loose, W = N ? v[S.HYPHENRANGELOOSE] : v[S.HYPHENRANGE];
      P = P.replace(W, H(this.options.includePrerelease)), d("hyphen replace", P), P = P.replace(v[S.COMPARATORTRIM], $), d("comparator trim", P), P = P.replace(v[S.TILDETRIM], E), P = P.replace(v[S.CARETTRIM], O), P = P.split(/\s+/).join(" ");
      let I = P.split(" ").map((Ke) => k(Ke, this.options)).join(" ").split(/\s+/).map((Ke) => ne(Ke, this.options));
      N && (I = I.filter((Ke) => (d("loose invalid filter", Ke, this.options), !!Ke.match(v[S.COMPARATORLOOSE])))), d("range list", I);
      const te = /* @__PURE__ */ new Map(), ge = I.map((Ke) => new c(Ke, this.options));
      for (const Ke of ge) {
        if (V(Ke))
          return [Ke];
        te.set(Ke.value, Ke);
      }
      te.size > 1 && te.has("") && te.delete("");
      const Pe = [...te.values()];
      return o.set(se, Pe), Pe;
    }
    intersects(P, J) {
      if (!(P instanceof e))
        throw new TypeError("a Range is required");
      return this.set.some((se) => G(se, J) && P.set.some((fe) => G(fe, J) && se.every((N) => fe.every((W) => N.intersects(W, J)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(P) {
      if (!P)
        return !1;
      if (typeof P == "string")
        try {
          P = new m(P, this.options);
        } catch {
          return !1;
        }
      for (let J = 0; J < this.set.length; J++)
        if (C(this.set[J], P, this.options))
          return !0;
      return !1;
    }
  }
  range$1 = e;
  const n = lruCache, o = new n({ max: 1e3 }), u = parseOptions_1$1, c = requireComparator$1(), d = debug_1$1, m = semver$4, {
    re: v,
    t: S,
    comparatorTrimReplace: $,
    tildeTrimReplace: E,
    caretTrimReplace: O
  } = reExports$1, { FLAG_INCLUDE_PRERELEASE: T, FLAG_LOOSE: y } = constants$3, V = (w) => w.value === "<0.0.0-0", M = (w) => w.value === "", G = (w, P) => {
    let J = !0;
    const se = w.slice();
    let fe = se.pop();
    for (; J && se.length; )
      J = se.every((N) => fe.intersects(N, P)), fe = se.pop();
    return J;
  }, k = (w, P) => (d("comp", w, P), w = ue(w, P), d("caret", w), w = X(w, P), d("tildes", w), w = Y(w, P), d("xrange", w), w = oe(w, P), d("stars", w), w), F = (w) => !w || w.toLowerCase() === "x" || w === "*", X = (w, P) => w.trim().split(/\s+/).map((J) => ee(J, P)).join(" "), ee = (w, P) => {
    const J = P.loose ? v[S.TILDELOOSE] : v[S.TILDE];
    return w.replace(J, (se, fe, N, W, I) => {
      d("tilde", w, se, fe, N, W, I);
      let te;
      return F(fe) ? te = "" : F(N) ? te = `>=${fe}.0.0 <${+fe + 1}.0.0-0` : F(W) ? te = `>=${fe}.${N}.0 <${fe}.${+N + 1}.0-0` : I ? (d("replaceTilde pr", I), te = `>=${fe}.${N}.${W}-${I} <${fe}.${+N + 1}.0-0`) : te = `>=${fe}.${N}.${W} <${fe}.${+N + 1}.0-0`, d("tilde return", te), te;
    });
  }, ue = (w, P) => w.trim().split(/\s+/).map((J) => Q(J, P)).join(" "), Q = (w, P) => {
    d("caret", w, P);
    const J = P.loose ? v[S.CARETLOOSE] : v[S.CARET], se = P.includePrerelease ? "-0" : "";
    return w.replace(J, (fe, N, W, I, te) => {
      d("caret", w, fe, N, W, I, te);
      let ge;
      return F(N) ? ge = "" : F(W) ? ge = `>=${N}.0.0${se} <${+N + 1}.0.0-0` : F(I) ? N === "0" ? ge = `>=${N}.${W}.0${se} <${N}.${+W + 1}.0-0` : ge = `>=${N}.${W}.0${se} <${+N + 1}.0.0-0` : te ? (d("replaceCaret pr", te), N === "0" ? W === "0" ? ge = `>=${N}.${W}.${I}-${te} <${N}.${W}.${+I + 1}-0` : ge = `>=${N}.${W}.${I}-${te} <${N}.${+W + 1}.0-0` : ge = `>=${N}.${W}.${I}-${te} <${+N + 1}.0.0-0`) : (d("no pr"), N === "0" ? W === "0" ? ge = `>=${N}.${W}.${I}${se} <${N}.${W}.${+I + 1}-0` : ge = `>=${N}.${W}.${I}${se} <${N}.${+W + 1}.0-0` : ge = `>=${N}.${W}.${I} <${+N + 1}.0.0-0`), d("caret return", ge), ge;
    });
  }, Y = (w, P) => (d("replaceXRanges", w, P), w.split(/\s+/).map((J) => pe(J, P)).join(" ")), pe = (w, P) => {
    w = w.trim();
    const J = P.loose ? v[S.XRANGELOOSE] : v[S.XRANGE];
    return w.replace(J, (se, fe, N, W, I, te) => {
      d("xRange", w, se, fe, N, W, I, te);
      const ge = F(N), Pe = ge || F(W), Ke = Pe || F(I), xe = Ke;
      return fe === "=" && xe && (fe = ""), te = P.includePrerelease ? "-0" : "", ge ? fe === ">" || fe === "<" ? se = "<0.0.0-0" : se = "*" : fe && xe ? (Pe && (W = 0), I = 0, fe === ">" ? (fe = ">=", Pe ? (N = +N + 1, W = 0, I = 0) : (W = +W + 1, I = 0)) : fe === "<=" && (fe = "<", Pe ? N = +N + 1 : W = +W + 1), fe === "<" && (te = "-0"), se = `${fe + N}.${W}.${I}${te}`) : Pe ? se = `>=${N}.0.0${te} <${+N + 1}.0.0-0` : Ke && (se = `>=${N}.${W}.0${te} <${N}.${+W + 1}.0-0`), d("xRange return", se), se;
    });
  }, oe = (w, P) => (d("replaceStars", w, P), w.trim().replace(v[S.STAR], "")), ne = (w, P) => (d("replaceGTE0", w, P), w.trim().replace(v[P.includePrerelease ? S.GTE0PRE : S.GTE0], "")), H = (w) => (P, J, se, fe, N, W, I, te, ge, Pe, Ke, xe, ze) => (F(se) ? J = "" : F(fe) ? J = `>=${se}.0.0${w ? "-0" : ""}` : F(N) ? J = `>=${se}.${fe}.0${w ? "-0" : ""}` : W ? J = `>=${J}` : J = `>=${J}${w ? "-0" : ""}`, F(ge) ? te = "" : F(Pe) ? te = `<${+ge + 1}.0.0-0` : F(Ke) ? te = `<${ge}.${+Pe + 1}.0-0` : xe ? te = `<=${ge}.${Pe}.${Ke}-${xe}` : w ? te = `<${ge}.${Pe}.${+Ke + 1}-0` : te = `<=${te}`, `${J} ${te}`.trim()), C = (w, P, J) => {
    for (let se = 0; se < w.length; se++)
      if (!w[se].test(P))
        return !1;
    if (P.prerelease.length && !J.includePrerelease) {
      for (let se = 0; se < w.length; se++)
        if (d(w[se].semver), w[se].semver !== c.ANY && w[se].semver.prerelease.length > 0) {
          const fe = w[se].semver;
          if (fe.major === P.major && fe.minor === P.minor && fe.patch === P.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range$1;
}
var comparator$1, hasRequiredComparator$1;
function requireComparator$1() {
  if (hasRequiredComparator$1)
    return comparator$1;
  hasRequiredComparator$1 = 1;
  const e = Symbol("SemVer ANY");
  class n {
    static get ANY() {
      return e;
    }
    constructor(E, O) {
      if (O = o(O), E instanceof n) {
        if (E.loose === !!O.loose)
          return E;
        E = E.value;
      }
      m("comparator", E, O), this.options = O, this.loose = !!O.loose, this.parse(E), this.semver === e ? this.value = "" : this.value = this.operator + this.semver.version, m("comp", this);
    }
    parse(E) {
      const O = this.options.loose ? u[c.COMPARATORLOOSE] : u[c.COMPARATOR], T = E.match(O);
      if (!T)
        throw new TypeError(`Invalid comparator: ${E}`);
      this.operator = T[1] !== void 0 ? T[1] : "", this.operator === "=" && (this.operator = ""), T[2] ? this.semver = new v(T[2], this.options.loose) : this.semver = e;
    }
    toString() {
      return this.value;
    }
    test(E) {
      if (m("Comparator.test", E, this.options.loose), this.semver === e || E === e)
        return !0;
      if (typeof E == "string")
        try {
          E = new v(E, this.options);
        } catch {
          return !1;
        }
      return d(E, this.operator, this.semver, this.options);
    }
    intersects(E, O) {
      if (!(E instanceof n))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new S(E.value, O).test(this.value) : E.operator === "" ? E.value === "" ? !0 : new S(this.value, O).test(E.semver) : (O = o(O), O.includePrerelease && (this.value === "<0.0.0-0" || E.value === "<0.0.0-0") || !O.includePrerelease && (this.value.startsWith("<0.0.0") || E.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && E.operator.startsWith(">") || this.operator.startsWith("<") && E.operator.startsWith("<") || this.semver.version === E.semver.version && this.operator.includes("=") && E.operator.includes("=") || d(this.semver, "<", E.semver, O) && this.operator.startsWith(">") && E.operator.startsWith("<") || d(this.semver, ">", E.semver, O) && this.operator.startsWith("<") && E.operator.startsWith(">")));
    }
  }
  comparator$1 = n;
  const o = parseOptions_1$1, { re: u, t: c } = reExports$1, d = cmp_1$1, m = debug_1$1, v = semver$4, S = requireRange$1();
  return comparator$1;
}
const Range$j = requireRange$1(), satisfies$9 = (e, n, o) => {
  try {
    n = new Range$j(n, o);
  } catch {
    return !1;
  }
  return n.test(e);
};
var satisfies_1$1 = satisfies$9;
const Range$i = requireRange$1(), toComparators$3 = (e, n) => new Range$i(e, n).set.map((o) => o.map((u) => u.value).join(" ").trim().split(" "));
var toComparators_1$1 = toComparators$3;
const SemVer$i = semver$4, Range$h = requireRange$1(), maxSatisfying$3 = (e, n, o) => {
  let u = null, c = null, d = null;
  try {
    d = new Range$h(n, o);
  } catch {
    return null;
  }
  return e.forEach((m) => {
    d.test(m) && (!u || c.compare(m) === -1) && (u = m, c = new SemVer$i(u, o));
  }), u;
};
var maxSatisfying_1$1 = maxSatisfying$3;
const SemVer$h = semver$4, Range$g = requireRange$1(), minSatisfying$3 = (e, n, o) => {
  let u = null, c = null, d = null;
  try {
    d = new Range$g(n, o);
  } catch {
    return null;
  }
  return e.forEach((m) => {
    d.test(m) && (!u || c.compare(m) === 1) && (u = m, c = new SemVer$h(u, o));
  }), u;
};
var minSatisfying_1$1 = minSatisfying$3;
const SemVer$g = semver$4, Range$f = requireRange$1(), gt$7 = gt_1$1, minVersion$3 = (e, n) => {
  e = new Range$f(e, n);
  let o = new SemVer$g("0.0.0");
  if (e.test(o) || (o = new SemVer$g("0.0.0-0"), e.test(o)))
    return o;
  o = null;
  for (let u = 0; u < e.set.length; ++u) {
    const c = e.set[u];
    let d = null;
    c.forEach((m) => {
      const v = new SemVer$g(m.semver.version);
      switch (m.operator) {
        case ">":
          v.prerelease.length === 0 ? v.patch++ : v.prerelease.push(0), v.raw = v.format();
        case "":
        case ">=":
          (!d || gt$7(v, d)) && (d = v);
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${m.operator}`);
      }
    }), d && (!o || gt$7(o, d)) && (o = d);
  }
  return o && e.test(o) ? o : null;
};
var minVersion_1$1 = minVersion$3;
const Range$e = requireRange$1(), validRange$3 = (e, n) => {
  try {
    return new Range$e(e, n).range || "*";
  } catch {
    return null;
  }
};
var valid$4 = validRange$3;
const SemVer$f = semver$4, Comparator$5 = requireComparator$1(), { ANY: ANY$3 } = Comparator$5, Range$d = requireRange$1(), satisfies$8 = satisfies_1$1, gt$6 = gt_1$1, lt$5 = lt_1$1, lte$5 = lte_1$1, gte$5 = gte_1$1, outside$7 = (e, n, o, u) => {
  e = new SemVer$f(e, u), n = new Range$d(n, u);
  let c, d, m, v, S;
  switch (o) {
    case ">":
      c = gt$6, d = lte$5, m = lt$5, v = ">", S = ">=";
      break;
    case "<":
      c = lt$5, d = gte$5, m = gt$6, v = "<", S = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (satisfies$8(e, n, u))
    return !1;
  for (let $ = 0; $ < n.set.length; ++$) {
    const E = n.set[$];
    let O = null, T = null;
    if (E.forEach((y) => {
      y.semver === ANY$3 && (y = new Comparator$5(">=0.0.0")), O = O || y, T = T || y, c(y.semver, O.semver, u) ? O = y : m(y.semver, T.semver, u) && (T = y);
    }), O.operator === v || O.operator === S || (!T.operator || T.operator === v) && d(e, T.semver))
      return !1;
    if (T.operator === S && m(e, T.semver))
      return !1;
  }
  return !0;
};
var outside_1$1 = outside$7;
const outside$6 = outside_1$1, gtr$3 = (e, n, o) => outside$6(e, n, ">", o);
var gtr_1$1 = gtr$3;
const outside$5 = outside_1$1, ltr$3 = (e, n, o) => outside$5(e, n, "<", o);
var ltr_1$1 = ltr$3;
const Range$c = requireRange$1(), intersects$3 = (e, n, o) => (e = new Range$c(e, o), n = new Range$c(n, o), e.intersects(n, o));
var intersects_1$1 = intersects$3;
const satisfies$7 = satisfies_1$1, compare$f = compare_1$1;
var simplify$1 = (e, n, o) => {
  const u = [];
  let c = null, d = null;
  const m = e.sort((E, O) => compare$f(E, O, o));
  for (const E of m)
    satisfies$7(E, n, o) ? (d = E, c || (c = E)) : (d && u.push([c, d]), d = null, c = null);
  c && u.push([c, null]);
  const v = [];
  for (const [E, O] of u)
    E === O ? v.push(E) : !O && E === m[0] ? v.push("*") : O ? E === m[0] ? v.push(`<=${O}`) : v.push(`${E} - ${O}`) : v.push(`>=${E}`);
  const S = v.join(" || "), $ = typeof n.raw == "string" ? n.raw : String(n);
  return S.length < $.length ? S : n;
};
const Range$b = requireRange$1(), Comparator$4 = requireComparator$1(), { ANY: ANY$2 } = Comparator$4, satisfies$6 = satisfies_1$1, compare$e = compare_1$1, subset$3 = (e, n, o = {}) => {
  if (e === n)
    return !0;
  e = new Range$b(e, o), n = new Range$b(n, o);
  let u = !1;
  e:
    for (const c of e.set) {
      for (const d of n.set) {
        const m = simpleSubset$1(c, d, o);
        if (u = u || m !== null, m)
          continue e;
      }
      if (u)
        return !1;
    }
  return !0;
}, minimumVersionWithPreRelease$1 = [new Comparator$4(">=0.0.0-0")], minimumVersion$1 = [new Comparator$4(">=0.0.0")], simpleSubset$1 = (e, n, o) => {
  if (e === n)
    return !0;
  if (e.length === 1 && e[0].semver === ANY$2) {
    if (n.length === 1 && n[0].semver === ANY$2)
      return !0;
    o.includePrerelease ? e = minimumVersionWithPreRelease$1 : e = minimumVersion$1;
  }
  if (n.length === 1 && n[0].semver === ANY$2) {
    if (o.includePrerelease)
      return !0;
    n = minimumVersion$1;
  }
  const u = /* @__PURE__ */ new Set();
  let c, d;
  for (const y of e)
    y.operator === ">" || y.operator === ">=" ? c = higherGT$1(c, y, o) : y.operator === "<" || y.operator === "<=" ? d = lowerLT$1(d, y, o) : u.add(y.semver);
  if (u.size > 1)
    return null;
  let m;
  if (c && d) {
    if (m = compare$e(c.semver, d.semver, o), m > 0)
      return null;
    if (m === 0 && (c.operator !== ">=" || d.operator !== "<="))
      return null;
  }
  for (const y of u) {
    if (c && !satisfies$6(y, String(c), o) || d && !satisfies$6(y, String(d), o))
      return null;
    for (const V of n)
      if (!satisfies$6(y, String(V), o))
        return !1;
    return !0;
  }
  let v, S, $, E, O = d && !o.includePrerelease && d.semver.prerelease.length ? d.semver : !1, T = c && !o.includePrerelease && c.semver.prerelease.length ? c.semver : !1;
  O && O.prerelease.length === 1 && d.operator === "<" && O.prerelease[0] === 0 && (O = !1);
  for (const y of n) {
    if (E = E || y.operator === ">" || y.operator === ">=", $ = $ || y.operator === "<" || y.operator === "<=", c) {
      if (T && y.semver.prerelease && y.semver.prerelease.length && y.semver.major === T.major && y.semver.minor === T.minor && y.semver.patch === T.patch && (T = !1), y.operator === ">" || y.operator === ">=") {
        if (v = higherGT$1(c, y, o), v === y && v !== c)
          return !1;
      } else if (c.operator === ">=" && !satisfies$6(c.semver, String(y), o))
        return !1;
    }
    if (d) {
      if (O && y.semver.prerelease && y.semver.prerelease.length && y.semver.major === O.major && y.semver.minor === O.minor && y.semver.patch === O.patch && (O = !1), y.operator === "<" || y.operator === "<=") {
        if (S = lowerLT$1(d, y, o), S === y && S !== d)
          return !1;
      } else if (d.operator === "<=" && !satisfies$6(d.semver, String(y), o))
        return !1;
    }
    if (!y.operator && (d || c) && m !== 0)
      return !1;
  }
  return !(c && $ && !d && m !== 0 || d && E && !c && m !== 0 || T || O);
}, higherGT$1 = (e, n, o) => {
  if (!e)
    return n;
  const u = compare$e(e.semver, n.semver, o);
  return u > 0 ? e : u < 0 || n.operator === ">" && e.operator === ">=" ? n : e;
}, lowerLT$1 = (e, n, o) => {
  if (!e)
    return n;
  const u = compare$e(e.semver, n.semver, o);
  return u < 0 ? e : u > 0 || n.operator === "<" && e.operator === "<=" ? n : e;
};
var subset_1$1 = subset$3;
const internalRe$1 = reExports$1, constants$2 = constants$3, SemVer$e = semver$4, identifiers$2 = identifiers$3, parse$8 = parse_1$1, valid$3 = valid_1$1, clean$2 = clean_1$1, inc$2 = inc_1$1, diff$2 = diff_1$1, major$2 = major_1$1, minor$2 = minor_1$1, patch$2 = patch_1$1, prerelease$2 = prerelease_1$1, compare$d = compare_1$1, rcompare$2 = rcompare_1$1, compareLoose$2 = compareLoose_1$1, compareBuild$4 = compareBuild_1$1, sort$2 = sort_1$1, rsort$2 = rsort_1$1, gt$5 = gt_1$1, lt$4 = lt_1$1, eq$3 = eq_1$1, neq$3 = neq_1$1, gte$4 = gte_1$1, lte$4 = lte_1$1, cmp$2 = cmp_1$1, coerce$2 = coerce_1$1, Comparator$3 = requireComparator$1(), Range$a = requireRange$1(), satisfies$5 = satisfies_1$1, toComparators$2 = toComparators_1$1, maxSatisfying$2 = maxSatisfying_1$1, minSatisfying$2 = minSatisfying_1$1, minVersion$2 = minVersion_1$1, validRange$2 = valid$4, outside$4 = outside_1$1, gtr$2 = gtr_1$1, ltr$2 = ltr_1$1, intersects$2 = intersects_1$1, simplifyRange$1 = simplify$1, subset$2 = subset_1$1;
var semver$2 = {
  parse: parse$8,
  valid: valid$3,
  clean: clean$2,
  inc: inc$2,
  diff: diff$2,
  major: major$2,
  minor: minor$2,
  patch: patch$2,
  prerelease: prerelease$2,
  compare: compare$d,
  rcompare: rcompare$2,
  compareLoose: compareLoose$2,
  compareBuild: compareBuild$4,
  sort: sort$2,
  rsort: rsort$2,
  gt: gt$5,
  lt: lt$4,
  eq: eq$3,
  neq: neq$3,
  gte: gte$4,
  lte: lte$4,
  cmp: cmp$2,
  coerce: coerce$2,
  Comparator: Comparator$3,
  Range: Range$a,
  satisfies: satisfies$5,
  toComparators: toComparators$2,
  maxSatisfying: maxSatisfying$2,
  minSatisfying: minSatisfying$2,
  minVersion: minVersion$2,
  validRange: validRange$2,
  outside: outside$4,
  gtr: gtr$2,
  ltr: ltr$2,
  intersects: intersects$2,
  simplifyRange: simplifyRange$1,
  subset: subset$2,
  SemVer: SemVer$e,
  re: internalRe$1.re,
  src: internalRe$1.src,
  tokens: internalRe$1.t,
  SEMVER_SPEC_VERSION: constants$2.SEMVER_SPEC_VERSION,
  RELEASE_TYPES: constants$2.RELEASE_TYPES,
  compareIdentifiers: identifiers$2.compareIdentifiers,
  rcompareIdentifiers: identifiers$2.rcompareIdentifiers
};
const semver$3 = /* @__PURE__ */ getDefaultExportFromCjs(semver$2);
var DeviceModelId;
(function(e) {
  e.blue = "blue", e.nanoS = "nanoS", e.nanoSP = "nanoSP", e.nanoX = "nanoX", e.stax = "stax";
})(DeviceModelId || (DeviceModelId = {}));
const devices = {
  [DeviceModelId.blue]: {
    id: DeviceModelId.blue,
    productName: "Ledger Blue",
    productIdMM: 0,
    legacyUsbProductId: 0,
    usbOnly: !0,
    memorySize: 480 * 1024,
    masks: [822083584, 822149120],
    getBlockSize: (e) => 4 * 1024
  },
  [DeviceModelId.nanoS]: {
    id: DeviceModelId.nanoS,
    productName: "Ledger Nano S",
    productIdMM: 16,
    legacyUsbProductId: 1,
    usbOnly: !0,
    memorySize: 320 * 1024,
    masks: [823132160],
    getBlockSize: (e) => {
      var n;
      return semver$3.lt((n = semver$3.coerce(e)) !== null && n !== void 0 ? n : "", "2.0.0") ? 4 * 1024 : 2 * 1024;
    }
  },
  [DeviceModelId.nanoSP]: {
    id: DeviceModelId.nanoSP,
    productName: "Ledger Nano S Plus",
    productIdMM: 80,
    legacyUsbProductId: 5,
    usbOnly: !0,
    memorySize: 1536 * 1024,
    masks: [856686592],
    getBlockSize: (e) => 32
  },
  [DeviceModelId.nanoX]: {
    id: DeviceModelId.nanoX,
    productName: "Ledger Nano X",
    productIdMM: 64,
    legacyUsbProductId: 4,
    usbOnly: !1,
    memorySize: 2 * 1024 * 1024,
    masks: [855638016],
    getBlockSize: (e) => 4 * 1024,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId.stax]: {
    id: DeviceModelId.stax,
    productName: "Ledger Stax",
    productIdMM: 96,
    legacyUsbProductId: 6,
    usbOnly: !1,
    memorySize: 1536 * 1024,
    masks: [857735168],
    getBlockSize: (e) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
      }
    ]
  }
};
DeviceModelId.blue, DeviceModelId.nanoS, DeviceModelId.nanoSP, DeviceModelId.nanoX, DeviceModelId.stax;
const devicesList = Object.values(devices), ledgerUSBVendorId = 11415, identifyUSBProductId = (e) => {
  const n = devicesList.find((c) => c.legacyUsbProductId === e);
  if (n)
    return n;
  const o = e >> 8;
  return devicesList.find((c) => c.productIdMM === o);
}, bluetoothServices = [], serviceUuidToInfos = {};
for (const e in devices) {
  const n = devices[e], { bluetoothSpec: o } = n;
  if (o)
    for (let u = 0; u < o.length; u++) {
      const c = o[u];
      bluetoothServices.push(c.serviceUuid), serviceUuidToInfos[c.serviceUuid] = serviceUuidToInfos[c.serviceUuid.replace(/-/g, "")] = Object.assign({ deviceModel: n }, c);
    }
}
const getBluetoothServiceUuids = () => bluetoothServices, getInfosForServiceUuid = (e) => serviceUuidToInfos[e.toLowerCase()];
var id$1 = 0, subscribers = [], log = function(e, n, o) {
  var u = {
    type: e,
    id: String(++id$1),
    date: /* @__PURE__ */ new Date()
  };
  n && (u.message = n), o && (u.data = o), dispatch(u);
}, listen = function(e) {
  return subscribers.push(e), function() {
    var n = subscribers.indexOf(e);
    n !== -1 && (subscribers[n] = subscribers[subscribers.length - 1], subscribers.pop());
  };
};
function dispatch(e) {
  for (var n = 0; n < subscribers.length; n++)
    try {
      subscribers[n](e);
    } catch (o) {
      console.error(o);
    }
}
typeof window < "u" && (window.__ledgerLogsListen = listen);
var __awaiter$4 = globalThis && globalThis.__awaiter || function(e, n, o, u) {
  function c(d) {
    return d instanceof o ? d : new o(function(m) {
      m(d);
    });
  }
  return new (o || (o = Promise))(function(d, m) {
    function v(E) {
      try {
        $(u.next(E));
      } catch (O) {
        m(O);
      }
    }
    function S(E) {
      try {
        $(u.throw(E));
      } catch (O) {
        m(O);
      }
    }
    function $(E) {
      E.done ? d(E.value) : c(E.value).then(v, S);
    }
    $((u = u.apply(e, n || [])).next());
  });
};
const ledgerDevices = [
  {
    vendorId: ledgerUSBVendorId
  }
];
function requestLedgerDevice() {
  return __awaiter$4(this, void 0, void 0, function* () {
    return yield navigator.usb.requestDevice({
      filters: ledgerDevices
    });
  });
}
function getLedgerDevices() {
  return __awaiter$4(this, void 0, void 0, function* () {
    return (yield navigator.usb.getDevices()).filter((n) => n.vendorId === ledgerUSBVendorId);
  });
}
function getFirstLedgerDevice() {
  return __awaiter$4(this, void 0, void 0, function* () {
    const e = yield getLedgerDevices();
    return e.length > 0 ? e[0] : requestLedgerDevice();
  });
}
const isSupported = () => Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices == "function");
var __awaiter$3 = globalThis && globalThis.__awaiter || function(e, n, o, u) {
  function c(d) {
    return d instanceof o ? d : new o(function(m) {
      m(d);
    });
  }
  return new (o || (o = Promise))(function(d, m) {
    function v(E) {
      try {
        $(u.next(E));
      } catch (O) {
        m(O);
      }
    }
    function S(E) {
      try {
        $(u.throw(E));
      } catch (O) {
        m(O);
      }
    }
    function $(E) {
      E.done ? d(E.value) : c(E.value).then(v, S);
    }
    $((u = u.apply(e, n || [])).next());
  });
};
const configurationValue = 1, endpointNumber = 3;
class TransportWebUSB extends Transport {
  constructor(n, o) {
    super(), this.channel = Math.floor(Math.random() * 65535), this.packetSize = 64, this._disconnectEmitted = !1, this._emitDisconnect = (u) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", u));
    }, this.device = n, this.interfaceNumber = o, this.deviceModel = identifyUSBProductId(n.productId);
  }
  /**
   * Similar to create() except it will always display the device permission (even if some devices are already accepted).
   */
  static request() {
    return __awaiter$3(this, void 0, void 0, function* () {
      const n = yield requestLedgerDevice();
      return TransportWebUSB.open(n);
    });
  }
  /**
   * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
   */
  static openConnected() {
    return __awaiter$3(this, void 0, void 0, function* () {
      const n = yield getLedgerDevices();
      return n.length === 0 ? null : TransportWebUSB.open(n[0]);
    });
  }
  /**
   * Create a Ledger transport with a USBDevice
   */
  static open(n) {
    return __awaiter$3(this, void 0, void 0, function* () {
      yield n.open(), n.configuration === null && (yield n.selectConfiguration(configurationValue)), yield gracefullyResetDevice(n);
      const o = n.configurations[0].interfaces.find(({ alternates: m }) => m.some((v) => v.interfaceClass === 255));
      if (!o)
        throw new TransportInterfaceNotAvailable("No WebUSB interface found for your Ledger device. Please upgrade firmware or contact techsupport.");
      const u = o.interfaceNumber;
      try {
        yield n.claimInterface(u);
      } catch (m) {
        throw yield n.close(), new TransportInterfaceNotAvailable(m.message);
      }
      const c = new TransportWebUSB(n, u), d = (m) => {
        n === m.device && (navigator.usb.removeEventListener("disconnect", d), c._emitDisconnect(new DisconnectedDevice()));
      };
      return navigator.usb.addEventListener("disconnect", d), c;
    });
  }
  /**
   * Release the transport device
   */
  close() {
    return __awaiter$3(this, void 0, void 0, function* () {
      yield this.exchangeBusyPromise, yield this.device.releaseInterface(this.interfaceNumber), yield gracefullyResetDevice(this.device), yield this.device.close();
    });
  }
  /**
   * Exchange with the device using APDU protocol.
   * @param apdu
   * @returns a promise of apdu response
   */
  exchange(n) {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield this.exchangeAtomicImpl(() => __awaiter$3(this, void 0, void 0, function* () {
        const { channel: u, packetSize: c } = this;
        log("apdu", "=> " + n.toString("hex"));
        const d = createHIDframing(u, c), m = d.makeBlocks(n);
        for (let $ = 0; $ < m.length; $++)
          yield this.device.transferOut(endpointNumber, m[$]);
        let v, S;
        for (; !(v = d.getReducedResult(S)); ) {
          const $ = yield this.device.transferIn(endpointNumber, c), E = Buffer.from($.data.buffer);
          S = d.reduceResponse(S, E);
        }
        return log("apdu", "<= " + v.toString("hex")), v;
      })).catch((u) => {
        throw u && u.message && u.message.includes("disconnected") ? (this._emitDisconnect(u), new DisconnectedDeviceDuringOperation(u.message)) : u;
      });
    });
  }
  setScrambleKey() {
  }
}
TransportWebUSB.isSupported = isSupported;
TransportWebUSB.list = getLedgerDevices;
TransportWebUSB.listen = (e) => {
  let n = !1;
  getFirstLedgerDevice().then((u) => {
    if (!n) {
      const c = identifyUSBProductId(u.productId);
      e.next({
        type: "add",
        descriptor: u,
        deviceModel: c
      }), e.complete();
    }
  }, (u) => {
    window.DOMException && u instanceof window.DOMException && u.code === 18 ? e.error(new TransportWebUSBGestureRequired(u.message)) : e.error(new TransportOpenUserCancelled(u.message));
  });
  function o() {
    n = !0;
  }
  return {
    unsubscribe: o
  };
};
function gracefullyResetDevice(e) {
  return __awaiter$3(this, void 0, void 0, function* () {
    try {
      yield e.reset();
    } catch (n) {
      console.warn(n);
    }
  });
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(e, n) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, u) {
    o.__proto__ = u;
  } || function(o, u) {
    for (var c in u)
      u.hasOwnProperty(c) && (o[c] = u[c]);
  }, extendStatics(e, n);
};
function __extends(e, n) {
  extendStatics(e, n);
  function o() {
    this.constructor = e;
  }
  e.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
}
function isFunction$2(e) {
  return typeof e == "function";
}
var _enable_super_gross_mode_that_will_cause_bad_things = !1, config$1 = {
  Promise: void 0,
  set useDeprecatedSynchronousErrorHandling(e) {
    if (e) {
      var n = /* @__PURE__ */ new Error();
      "" + n.stack;
    }
    _enable_super_gross_mode_that_will_cause_bad_things = e;
  },
  get useDeprecatedSynchronousErrorHandling() {
    return _enable_super_gross_mode_that_will_cause_bad_things;
  }
};
function hostReportError(e) {
  setTimeout(function() {
    throw e;
  }, 0);
}
var empty$1 = {
  closed: !0,
  next: function(e) {
  },
  error: function(e) {
    if (config$1.useDeprecatedSynchronousErrorHandling)
      throw e;
    hostReportError(e);
  },
  complete: function() {
  }
}, isArray$2 = /* @__PURE__ */ function() {
  return Array.isArray || function(e) {
    return e && typeof e.length == "number";
  };
}();
function isObject$2(e) {
  return e !== null && typeof e == "object";
}
var UnsubscriptionErrorImpl = /* @__PURE__ */ function() {
  function e(n) {
    return Error.call(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(o, u) {
      return u + 1 + ") " + o.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n, this;
  }
  return e.prototype = /* @__PURE__ */ Object.create(Error.prototype), e;
}(), UnsubscriptionError = UnsubscriptionErrorImpl, Subscription = /* @__PURE__ */ function() {
  function e(n) {
    this.closed = !1, this._parentOrParents = null, this._subscriptions = null, n && (this._ctorUnsubscribe = !0, this._unsubscribe = n);
  }
  return e.prototype.unsubscribe = function() {
    var n;
    if (!this.closed) {
      var o = this, u = o._parentOrParents, c = o._ctorUnsubscribe, d = o._unsubscribe, m = o._subscriptions;
      if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, u instanceof e)
        u.remove(this);
      else if (u !== null)
        for (var v = 0; v < u.length; ++v) {
          var S = u[v];
          S.remove(this);
        }
      if (isFunction$2(d)) {
        c && (this._unsubscribe = void 0);
        try {
          d.call(this);
        } catch (O) {
          n = O instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(O.errors) : [O];
        }
      }
      if (isArray$2(m))
        for (var v = -1, $ = m.length; ++v < $; ) {
          var E = m[v];
          if (isObject$2(E))
            try {
              E.unsubscribe();
            } catch (T) {
              n = n || [], T instanceof UnsubscriptionError ? n = n.concat(flattenUnsubscriptionErrors(T.errors)) : n.push(T);
            }
        }
      if (n)
        throw new UnsubscriptionError(n);
    }
  }, e.prototype.add = function(n) {
    var o = n;
    if (!n)
      return e.EMPTY;
    switch (typeof n) {
      case "function":
        o = new e(n);
      case "object":
        if (o === this || o.closed || typeof o.unsubscribe != "function")
          return o;
        if (this.closed)
          return o.unsubscribe(), o;
        if (!(o instanceof e)) {
          var u = o;
          o = new e(), o._subscriptions = [u];
        }
        break;
      default:
        throw new Error("unrecognized teardown " + n + " added to Subscription.");
    }
    var c = o._parentOrParents;
    if (c === null)
      o._parentOrParents = this;
    else if (c instanceof e) {
      if (c === this)
        return o;
      o._parentOrParents = [c, this];
    } else if (c.indexOf(this) === -1)
      c.push(this);
    else
      return o;
    var d = this._subscriptions;
    return d === null ? this._subscriptions = [o] : d.push(o), o;
  }, e.prototype.remove = function(n) {
    var o = this._subscriptions;
    if (o) {
      var u = o.indexOf(n);
      u !== -1 && o.splice(u, 1);
    }
  }, e.EMPTY = function(n) {
    return n.closed = !0, n;
  }(new e()), e;
}();
function flattenUnsubscriptionErrors(e) {
  return e.reduce(function(n, o) {
    return n.concat(o instanceof UnsubscriptionError ? o.errors : o);
  }, []);
}
var rxSubscriber = /* @__PURE__ */ function() {
  return typeof Symbol == "function" ? /* @__PURE__ */ Symbol("rxSubscriber") : "@@rxSubscriber_" + /* @__PURE__ */ Math.random();
}(), Subscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u, c) {
    var d = e.call(this) || this;
    switch (d.syncErrorValue = null, d.syncErrorThrown = !1, d.syncErrorThrowable = !1, d.isStopped = !1, arguments.length) {
      case 0:
        d.destination = empty$1;
        break;
      case 1:
        if (!o) {
          d.destination = empty$1;
          break;
        }
        if (typeof o == "object") {
          o instanceof n ? (d.syncErrorThrowable = o.syncErrorThrowable, d.destination = o, o.add(d)) : (d.syncErrorThrowable = !0, d.destination = new SafeSubscriber(d, o));
          break;
        }
      default:
        d.syncErrorThrowable = !0, d.destination = new SafeSubscriber(d, o, u, c);
        break;
    }
    return d;
  }
  return n.prototype[rxSubscriber] = function() {
    return this;
  }, n.create = function(o, u, c) {
    var d = new n(o, u, c);
    return d.syncErrorThrowable = !1, d;
  }, n.prototype.next = function(o) {
    this.isStopped || this._next(o);
  }, n.prototype.error = function(o) {
    this.isStopped || (this.isStopped = !0, this._error(o));
  }, n.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, n.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this));
  }, n.prototype._next = function(o) {
    this.destination.next(o);
  }, n.prototype._error = function(o) {
    this.destination.error(o), this.unsubscribe();
  }, n.prototype._complete = function() {
    this.destination.complete(), this.unsubscribe();
  }, n.prototype._unsubscribeAndRecycle = function() {
    var o = this._parentOrParents;
    return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = o, this;
  }, n;
}(Subscription), SafeSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u, c, d) {
    var m = e.call(this) || this;
    m._parentSubscriber = o;
    var v, S = m;
    return isFunction$2(u) ? v = u : u && (v = u.next, c = u.error, d = u.complete, u !== empty$1 && (S = Object.create(u), isFunction$2(S.unsubscribe) && m.add(S.unsubscribe.bind(S)), S.unsubscribe = m.unsubscribe.bind(m))), m._context = S, m._next = v, m._error = c, m._complete = d, m;
  }
  return n.prototype.next = function(o) {
    if (!this.isStopped && this._next) {
      var u = this._parentSubscriber;
      !config$1.useDeprecatedSynchronousErrorHandling || !u.syncErrorThrowable ? this.__tryOrUnsub(this._next, o) : this.__tryOrSetError(u, this._next, o) && this.unsubscribe();
    }
  }, n.prototype.error = function(o) {
    if (!this.isStopped) {
      var u = this._parentSubscriber, c = config$1.useDeprecatedSynchronousErrorHandling;
      if (this._error)
        !c || !u.syncErrorThrowable ? (this.__tryOrUnsub(this._error, o), this.unsubscribe()) : (this.__tryOrSetError(u, this._error, o), this.unsubscribe());
      else if (u.syncErrorThrowable)
        c ? (u.syncErrorValue = o, u.syncErrorThrown = !0) : hostReportError(o), this.unsubscribe();
      else {
        if (this.unsubscribe(), c)
          throw o;
        hostReportError(o);
      }
    }
  }, n.prototype.complete = function() {
    var o = this;
    if (!this.isStopped) {
      var u = this._parentSubscriber;
      if (this._complete) {
        var c = function() {
          return o._complete.call(o._context);
        };
        !config$1.useDeprecatedSynchronousErrorHandling || !u.syncErrorThrowable ? (this.__tryOrUnsub(c), this.unsubscribe()) : (this.__tryOrSetError(u, c), this.unsubscribe());
      } else
        this.unsubscribe();
    }
  }, n.prototype.__tryOrUnsub = function(o, u) {
    try {
      o.call(this._context, u);
    } catch (c) {
      if (this.unsubscribe(), config$1.useDeprecatedSynchronousErrorHandling)
        throw c;
      hostReportError(c);
    }
  }, n.prototype.__tryOrSetError = function(o, u, c) {
    if (!config$1.useDeprecatedSynchronousErrorHandling)
      throw new Error("bad call");
    try {
      u.call(this._context, c);
    } catch (d) {
      return config$1.useDeprecatedSynchronousErrorHandling ? (o.syncErrorValue = d, o.syncErrorThrown = !0, !0) : (hostReportError(d), !0);
    }
    return !1;
  }, n.prototype._unsubscribe = function() {
    var o = this._parentSubscriber;
    this._context = null, this._parentSubscriber = null, o.unsubscribe();
  }, n;
}(Subscriber);
function canReportError(e) {
  for (; e; ) {
    var n = e, o = n.closed, u = n.destination, c = n.isStopped;
    if (o || c)
      return !1;
    u && u instanceof Subscriber ? e = u : e = null;
  }
  return !0;
}
function toSubscriber(e, n, o) {
  if (e) {
    if (e instanceof Subscriber)
      return e;
    if (e[rxSubscriber])
      return e[rxSubscriber]();
  }
  return !e && !n && !o ? new Subscriber(empty$1) : new Subscriber(e, n, o);
}
var observable = /* @__PURE__ */ function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function identity(e) {
  return e;
}
function pipeFromArray(e) {
  return e.length === 0 ? identity : e.length === 1 ? e[0] : function(o) {
    return e.reduce(function(u, c) {
      return c(u);
    }, o);
  };
}
var Observable = /* @__PURE__ */ function() {
  function e(n) {
    this._isScalar = !1, n && (this._subscribe = n);
  }
  return e.prototype.lift = function(n) {
    var o = new e();
    return o.source = this, o.operator = n, o;
  }, e.prototype.subscribe = function(n, o, u) {
    var c = this.operator, d = toSubscriber(n, o, u);
    if (c ? d.add(c.call(d, this.source)) : d.add(this.source || config$1.useDeprecatedSynchronousErrorHandling && !d.syncErrorThrowable ? this._subscribe(d) : this._trySubscribe(d)), config$1.useDeprecatedSynchronousErrorHandling && d.syncErrorThrowable && (d.syncErrorThrowable = !1, d.syncErrorThrown))
      throw d.syncErrorValue;
    return d;
  }, e.prototype._trySubscribe = function(n) {
    try {
      return this._subscribe(n);
    } catch (o) {
      config$1.useDeprecatedSynchronousErrorHandling && (n.syncErrorThrown = !0, n.syncErrorValue = o), canReportError(n) ? n.error(o) : console.warn(o);
    }
  }, e.prototype.forEach = function(n, o) {
    var u = this;
    return o = getPromiseCtor(o), new o(function(c, d) {
      var m;
      m = u.subscribe(function(v) {
        try {
          n(v);
        } catch (S) {
          d(S), m && m.unsubscribe();
        }
      }, d, c);
    });
  }, e.prototype._subscribe = function(n) {
    var o = this.source;
    return o && o.subscribe(n);
  }, e.prototype[observable] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var n = [], o = 0; o < arguments.length; o++)
      n[o] = arguments[o];
    return n.length === 0 ? this : pipeFromArray(n)(this);
  }, e.prototype.toPromise = function(n) {
    var o = this;
    return n = getPromiseCtor(n), new n(function(u, c) {
      var d;
      o.subscribe(function(m) {
        return d = m;
      }, function(m) {
        return c(m);
      }, function() {
        return u(d);
      });
    });
  }, e.create = function(n) {
    return new e(n);
  }, e;
}();
function getPromiseCtor(e) {
  if (e || (e = Promise), !e)
    throw new Error("no Promise impl found");
  return e;
}
var ObjectUnsubscribedErrorImpl = /* @__PURE__ */ function() {
  function e() {
    return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this;
  }
  return e.prototype = /* @__PURE__ */ Object.create(Error.prototype), e;
}(), ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl, SubjectSubscription = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u) {
    var c = e.call(this) || this;
    return c.subject = o, c.subscriber = u, c.closed = !1, c;
  }
  return n.prototype.unsubscribe = function() {
    if (!this.closed) {
      this.closed = !0;
      var o = this.subject, u = o.observers;
      if (this.subject = null, !(!u || u.length === 0 || o.isStopped || o.closed)) {
        var c = u.indexOf(this.subscriber);
        c !== -1 && u.splice(c, 1);
      }
    }
  }, n;
}(Subscription), SubjectSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o) {
    var u = e.call(this, o) || this;
    return u.destination = o, u;
  }
  return n;
}(Subscriber), Subject = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n() {
    var o = e.call(this) || this;
    return o.observers = [], o.closed = !1, o.isStopped = !1, o.hasError = !1, o.thrownError = null, o;
  }
  return n.prototype[rxSubscriber] = function() {
    return new SubjectSubscriber(this);
  }, n.prototype.lift = function(o) {
    var u = new AnonymousSubject(this, this);
    return u.operator = o, u;
  }, n.prototype.next = function(o) {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    if (!this.isStopped)
      for (var u = this.observers, c = u.length, d = u.slice(), m = 0; m < c; m++)
        d[m].next(o);
  }, n.prototype.error = function(o) {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    this.hasError = !0, this.thrownError = o, this.isStopped = !0;
    for (var u = this.observers, c = u.length, d = u.slice(), m = 0; m < c; m++)
      d[m].error(o);
    this.observers.length = 0;
  }, n.prototype.complete = function() {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    this.isStopped = !0;
    for (var o = this.observers, u = o.length, c = o.slice(), d = 0; d < u; d++)
      c[d].complete();
    this.observers.length = 0;
  }, n.prototype.unsubscribe = function() {
    this.isStopped = !0, this.closed = !0, this.observers = null;
  }, n.prototype._trySubscribe = function(o) {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    return e.prototype._trySubscribe.call(this, o);
  }, n.prototype._subscribe = function(o) {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    return this.hasError ? (o.error(this.thrownError), Subscription.EMPTY) : this.isStopped ? (o.complete(), Subscription.EMPTY) : (this.observers.push(o), new SubjectSubscription(this, o));
  }, n.prototype.asObservable = function() {
    var o = new Observable();
    return o.source = this, o;
  }, n.create = function(o, u) {
    return new AnonymousSubject(o, u);
  }, n;
}(Observable), AnonymousSubject = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u) {
    var c = e.call(this) || this;
    return c.destination = o, c.source = u, c;
  }
  return n.prototype.next = function(o) {
    var u = this.destination;
    u && u.next && u.next(o);
  }, n.prototype.error = function(o) {
    var u = this.destination;
    u && u.error && this.destination.error(o);
  }, n.prototype.complete = function() {
    var o = this.destination;
    o && o.complete && this.destination.complete();
  }, n.prototype._subscribe = function(o) {
    var u = this.source;
    return u ? this.source.subscribe(o) : Subscription.EMPTY;
  }, n;
}(Subject);
function refCount() {
  return function(n) {
    return n.lift(new RefCountOperator(n));
  };
}
var RefCountOperator = /* @__PURE__ */ function() {
  function e(n) {
    this.connectable = n;
  }
  return e.prototype.call = function(n, o) {
    var u = this.connectable;
    u._refCount++;
    var c = new RefCountSubscriber(n, u), d = o.subscribe(c);
    return c.closed || (c.connection = u.connect()), d;
  }, e;
}(), RefCountSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u) {
    var c = e.call(this, o) || this;
    return c.connectable = u, c;
  }
  return n.prototype._unsubscribe = function() {
    var o = this.connectable;
    if (!o) {
      this.connection = null;
      return;
    }
    this.connectable = null;
    var u = o._refCount;
    if (u <= 0) {
      this.connection = null;
      return;
    }
    if (o._refCount = u - 1, u > 1) {
      this.connection = null;
      return;
    }
    var c = this.connection, d = o._connection;
    this.connection = null, d && (!c || d === c) && d.unsubscribe();
  }, n;
}(Subscriber), ConnectableObservable = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u) {
    var c = e.call(this) || this;
    return c.source = o, c.subjectFactory = u, c._refCount = 0, c._isComplete = !1, c;
  }
  return n.prototype._subscribe = function(o) {
    return this.getSubject().subscribe(o);
  }, n.prototype.getSubject = function() {
    var o = this._subject;
    return (!o || o.isStopped) && (this._subject = this.subjectFactory()), this._subject;
  }, n.prototype.connect = function() {
    var o = this._connection;
    return o || (this._isComplete = !1, o = this._connection = new Subscription(), o.add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this))), o.closed && (this._connection = null, o = Subscription.EMPTY)), o;
  }, n.prototype.refCount = function() {
    return refCount()(this);
  }, n;
}(Observable), connectableObservableDescriptor = /* @__PURE__ */ function() {
  var e = ConnectableObservable.prototype;
  return {
    operator: { value: null },
    _refCount: { value: 0, writable: !0 },
    _subject: { value: null, writable: !0 },
    _connection: { value: null, writable: !0 },
    _subscribe: { value: e._subscribe },
    _isComplete: { value: e._isComplete, writable: !0 },
    getSubject: { value: e.getSubject },
    connect: { value: e.connect },
    refCount: { value: e.refCount }
  };
}(), ConnectableSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u) {
    var c = e.call(this, o) || this;
    return c.connectable = u, c;
  }
  return n.prototype._error = function(o) {
    this._unsubscribe(), e.prototype._error.call(this, o);
  }, n.prototype._complete = function() {
    this.connectable._isComplete = !0, this._unsubscribe(), e.prototype._complete.call(this);
  }, n.prototype._unsubscribe = function() {
    var o = this.connectable;
    if (o) {
      this.connectable = null;
      var u = o._connection;
      o._refCount = 0, o._subject = null, o._connection = null, u && u.unsubscribe();
    }
  }, n;
}(SubjectSubscriber), EMPTY = /* @__PURE__ */ new Observable(function(e) {
  return e.complete();
});
function empty(e) {
  return e ? emptyScheduled(e) : EMPTY;
}
function emptyScheduled(e) {
  return new Observable(function(n) {
    return e.schedule(function() {
      return n.complete();
    });
  });
}
function isScheduler(e) {
  return e && typeof e.schedule == "function";
}
var subscribeToArray = function(e) {
  return function(n) {
    for (var o = 0, u = e.length; o < u && !n.closed; o++)
      n.next(e[o]);
    n.complete();
  };
};
function scheduleArray(e, n) {
  return new Observable(function(o) {
    var u = new Subscription(), c = 0;
    return u.add(n.schedule(function() {
      if (c === e.length) {
        o.complete();
        return;
      }
      o.next(e[c++]), o.closed || u.add(this.schedule());
    })), u;
  });
}
function fromArray(e, n) {
  return n ? scheduleArray(e, n) : new Observable(subscribeToArray(e));
}
function noop() {
}
var ArgumentOutOfRangeErrorImpl = /* @__PURE__ */ function() {
  function e() {
    return Error.call(this), this.message = "argument out of range", this.name = "ArgumentOutOfRangeError", this;
  }
  return e.prototype = /* @__PURE__ */ Object.create(Error.prototype), e;
}(), ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl, EmptyErrorImpl = /* @__PURE__ */ function() {
  function e() {
    return Error.call(this), this.message = "no elements in sequence", this.name = "EmptyError", this;
  }
  return e.prototype = /* @__PURE__ */ Object.create(Error.prototype), e;
}(), EmptyError = EmptyErrorImpl;
function map(e, n) {
  return function(u) {
    if (typeof e != "function")
      throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
    return u.lift(new MapOperator(e, n));
  };
}
var MapOperator = /* @__PURE__ */ function() {
  function e(n, o) {
    this.project = n, this.thisArg = o;
  }
  return e.prototype.call = function(n, o) {
    return o.subscribe(new MapSubscriber(n, this.project, this.thisArg));
  }, e;
}(), MapSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u, c) {
    var d = e.call(this, o) || this;
    return d.project = u, d.count = 0, d.thisArg = c || d, d;
  }
  return n.prototype._next = function(o) {
    var u;
    try {
      u = this.project.call(this.thisArg, o, this.count++);
    } catch (c) {
      this.destination.error(c);
      return;
    }
    this.destination.next(u);
  }, n;
}(Subscriber), subscribeToPromise = function(e) {
  return function(n) {
    return e.then(function(o) {
      n.closed || (n.next(o), n.complete());
    }, function(o) {
      return n.error(o);
    }).then(null, hostReportError), n;
  };
};
function getSymbolIterator() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var iterator = /* @__PURE__ */ getSymbolIterator(), subscribeToIterable = function(e) {
  return function(n) {
    var o = e[iterator]();
    do {
      var u = void 0;
      try {
        u = o.next();
      } catch (c) {
        return n.error(c), n;
      }
      if (u.done) {
        n.complete();
        break;
      }
      if (n.next(u.value), n.closed)
        break;
    } while (!0);
    return typeof o.return == "function" && n.add(function() {
      o.return && o.return();
    }), n;
  };
}, subscribeToObservable = function(e) {
  return function(n) {
    var o = e[observable]();
    if (typeof o.subscribe != "function")
      throw new TypeError("Provided object does not correctly implement Symbol.observable");
    return o.subscribe(n);
  };
}, isArrayLike = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function isPromise(e) {
  return !!e && typeof e.subscribe != "function" && typeof e.then == "function";
}
var subscribeTo = function(e) {
  if (e && typeof e[observable] == "function")
    return subscribeToObservable(e);
  if (isArrayLike(e))
    return subscribeToArray(e);
  if (isPromise(e))
    return subscribeToPromise(e);
  if (e && typeof e[iterator] == "function")
    return subscribeToIterable(e);
  var n = isObject$2(e) ? "an invalid object" : "'" + e + "'", o = "You provided " + n + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
  throw new TypeError(o);
};
function scheduleObservable(e, n) {
  return new Observable(function(o) {
    var u = new Subscription();
    return u.add(n.schedule(function() {
      var c = e[observable]();
      u.add(c.subscribe({
        next: function(d) {
          u.add(n.schedule(function() {
            return o.next(d);
          }));
        },
        error: function(d) {
          u.add(n.schedule(function() {
            return o.error(d);
          }));
        },
        complete: function() {
          u.add(n.schedule(function() {
            return o.complete();
          }));
        }
      }));
    })), u;
  });
}
function schedulePromise(e, n) {
  return new Observable(function(o) {
    var u = new Subscription();
    return u.add(n.schedule(function() {
      return e.then(function(c) {
        u.add(n.schedule(function() {
          o.next(c), u.add(n.schedule(function() {
            return o.complete();
          }));
        }));
      }, function(c) {
        u.add(n.schedule(function() {
          return o.error(c);
        }));
      });
    })), u;
  });
}
function scheduleIterable(e, n) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new Observable(function(o) {
    var u = new Subscription(), c;
    return u.add(function() {
      c && typeof c.return == "function" && c.return();
    }), u.add(n.schedule(function() {
      c = e[iterator](), u.add(n.schedule(function() {
        if (!o.closed) {
          var d, m;
          try {
            var v = c.next();
            d = v.value, m = v.done;
          } catch (S) {
            o.error(S);
            return;
          }
          m ? o.complete() : (o.next(d), this.schedule());
        }
      }));
    })), u;
  });
}
function isInteropObservable(e) {
  return e && typeof e[observable] == "function";
}
function isIterable(e) {
  return e && typeof e[iterator] == "function";
}
function scheduled(e, n) {
  if (e != null) {
    if (isInteropObservable(e))
      return scheduleObservable(e, n);
    if (isPromise(e))
      return schedulePromise(e, n);
    if (isArrayLike(e))
      return scheduleArray(e, n);
    if (isIterable(e) || typeof e == "string")
      return scheduleIterable(e, n);
  }
  throw new TypeError((e !== null && typeof e || e) + " is not observable");
}
function from(e, n) {
  return n ? scheduled(e, n) : e instanceof Observable ? e : new Observable(subscribeTo(e));
}
var SimpleInnerSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o) {
    var u = e.call(this) || this;
    return u.parent = o, u;
  }
  return n.prototype._next = function(o) {
    this.parent.notifyNext(o);
  }, n.prototype._error = function(o) {
    this.parent.notifyError(o), this.unsubscribe();
  }, n.prototype._complete = function() {
    this.parent.notifyComplete(), this.unsubscribe();
  }, n;
}(Subscriber), SimpleOuterSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return n.prototype.notifyNext = function(o) {
    this.destination.next(o);
  }, n.prototype.notifyError = function(o) {
    this.destination.error(o);
  }, n.prototype.notifyComplete = function() {
    this.destination.complete();
  }, n;
}(Subscriber);
function innerSubscribe(e, n) {
  if (!n.closed) {
    if (e instanceof Observable)
      return e.subscribe(n);
    var o;
    try {
      o = subscribeTo(e)(n);
    } catch (u) {
      n.error(u);
    }
    return o;
  }
}
function mergeMap(e, n, o) {
  return o === void 0 && (o = Number.POSITIVE_INFINITY), typeof n == "function" ? function(u) {
    return u.pipe(mergeMap(function(c, d) {
      return from(e(c, d)).pipe(map(function(m, v) {
        return n(c, m, d, v);
      }));
    }, o));
  } : (typeof n == "number" && (o = n), function(u) {
    return u.lift(new MergeMapOperator(e, o));
  });
}
var MergeMapOperator = /* @__PURE__ */ function() {
  function e(n, o) {
    o === void 0 && (o = Number.POSITIVE_INFINITY), this.project = n, this.concurrent = o;
  }
  return e.prototype.call = function(n, o) {
    return o.subscribe(new MergeMapSubscriber(n, this.project, this.concurrent));
  }, e;
}(), MergeMapSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u, c) {
    c === void 0 && (c = Number.POSITIVE_INFINITY);
    var d = e.call(this, o) || this;
    return d.project = u, d.concurrent = c, d.hasCompleted = !1, d.buffer = [], d.active = 0, d.index = 0, d;
  }
  return n.prototype._next = function(o) {
    this.active < this.concurrent ? this._tryNext(o) : this.buffer.push(o);
  }, n.prototype._tryNext = function(o) {
    var u, c = this.index++;
    try {
      u = this.project(o, c);
    } catch (d) {
      this.destination.error(d);
      return;
    }
    this.active++, this._innerSub(u);
  }, n.prototype._innerSub = function(o) {
    var u = new SimpleInnerSubscriber(this), c = this.destination;
    c.add(u);
    var d = innerSubscribe(o, u);
    d !== u && c.add(d);
  }, n.prototype._complete = function() {
    this.hasCompleted = !0, this.active === 0 && this.buffer.length === 0 && this.destination.complete(), this.unsubscribe();
  }, n.prototype.notifyNext = function(o) {
    this.destination.next(o);
  }, n.prototype.notifyComplete = function() {
    var o = this.buffer;
    this.active--, o.length > 0 ? this._next(o.shift()) : this.active === 0 && this.hasCompleted && this.destination.complete();
  }, n;
}(SimpleOuterSubscriber);
function mergeAll(e) {
  return e === void 0 && (e = Number.POSITIVE_INFINITY), mergeMap(identity, e);
}
function defer(e) {
  return new Observable(function(n) {
    var o;
    try {
      o = e();
    } catch (c) {
      n.error(c);
      return;
    }
    var u = o ? from(o) : empty();
    return u.subscribe(n);
  });
}
function merge$2() {
  for (var e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  var o = Number.POSITIVE_INFINITY, u = null, c = e[e.length - 1];
  return isScheduler(c) ? (u = e.pop(), e.length > 1 && typeof e[e.length - 1] == "number" && (o = e.pop())) : typeof c == "number" && (o = e.pop()), u === null && e.length === 1 && e[0] instanceof Observable ? e[0] : mergeAll(o)(fromArray(e, u));
}
function filter(e, n) {
  return function(u) {
    return u.lift(new FilterOperator(e, n));
  };
}
var FilterOperator = /* @__PURE__ */ function() {
  function e(n, o) {
    this.predicate = n, this.thisArg = o;
  }
  return e.prototype.call = function(n, o) {
    return o.subscribe(new FilterSubscriber(n, this.predicate, this.thisArg));
  }, e;
}(), FilterSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u, c) {
    var d = e.call(this, o) || this;
    return d.predicate = u, d.thisArg = c, d.count = 0, d;
  }
  return n.prototype._next = function(o) {
    var u;
    try {
      u = this.predicate.call(this.thisArg, o, this.count++);
    } catch (c) {
      this.destination.error(c);
      return;
    }
    u && this.destination.next(o);
  }, n;
}(Subscriber), __awaiter$2 = globalThis && globalThis.__awaiter || function(e, n, o, u) {
  function c(d) {
    return d instanceof o ? d : new o(function(m) {
      m(d);
    });
  }
  return new (o || (o = Promise))(function(d, m) {
    function v(E) {
      try {
        $(u.next(E));
      } catch (O) {
        m(O);
      }
    }
    function S(E) {
      try {
        $(u.throw(E));
      } catch (O) {
        m(O);
      }
    }
    function $(E) {
      E.done ? d(E.value) : c(E.value).then(v, S);
    }
    $((u = u.apply(e, n || [])).next());
  });
};
const TagId$1 = 5;
function chunkBuffer(e, n) {
  const o = [];
  for (let u = 0, c = n(0); u < e.length; u += c, c = n(u))
    o.push(e.slice(u, u + c));
  return o;
}
const sendAPDU = (e, n, o) => {
  const u = chunkBuffer(n, (c) => o - (c === 0 ? 5 : 3)).map((c, d) => {
    const m = Buffer.alloc(d === 0 ? 5 : 3);
    return m.writeUInt8(TagId$1, 0), m.writeUInt16BE(d, 1), d === 0 && m.writeUInt16BE(n.length, 3), Buffer.concat([m, c]);
  });
  return new Observable((c) => {
    let d = !1;
    function m() {
      return __awaiter$2(this, void 0, void 0, function* () {
        for (const S of u) {
          if (d)
            return;
          yield e(S);
        }
      });
    }
    return m().then(() => {
      d = !0, c.complete();
    }, (S) => {
      d = !0, log("ble-error", "sendAPDU failure " + String(S)), c.error(S);
    }), () => {
      d || (log("ble-verbose", "sendAPDU interruption"), d = !0);
    };
  });
}, TagId = 5, receiveAPDU = (e) => Observable.create((n) => {
  let o = 0, u = 0, c = Buffer.alloc(0);
  const d = e.subscribe({
    complete: () => {
      n.error(new DisconnectedDevice()), d.unsubscribe();
    },
    error: (m) => {
      log("ble-error", "in receiveAPDU " + String(m)), n.error(m), d.unsubscribe();
    },
    next: (m) => {
      const v = m.readUInt8(0), S = m.readUInt16BE(1);
      let $ = m.slice(3);
      if (v !== TagId) {
        n.error(new TransportError("Invalid tag " + v.toString(16), "InvalidTag"));
        return;
      }
      if (o !== S) {
        n.error(new TransportError("BLE: Invalid sequence number. discontinued chunk. Received " + S + " but expected " + o, "InvalidSequence"));
        return;
      }
      if (S === 0 && (u = $.readUInt16BE(0), $ = $.slice(2)), o++, c = Buffer.concat([c, $]), c.length > u) {
        n.error(new TransportError("BLE: received too much data. discontinued chunk. Received " + c.length + " but expected " + u, "BLETooMuchData"));
        return;
      }
      c.length === u && (n.next(c), n.complete(), d.unsubscribe());
    }
  });
  return () => {
    d.unsubscribe();
  };
});
function defaultIfEmpty(e) {
  return e === void 0 && (e = null), function(n) {
    return n.lift(new DefaultIfEmptyOperator(e));
  };
}
var DefaultIfEmptyOperator = /* @__PURE__ */ function() {
  function e(n) {
    this.defaultValue = n;
  }
  return e.prototype.call = function(n, o) {
    return o.subscribe(new DefaultIfEmptySubscriber(n, this.defaultValue));
  }, e;
}(), DefaultIfEmptySubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u) {
    var c = e.call(this, o) || this;
    return c.defaultValue = u, c.isEmpty = !0, c;
  }
  return n.prototype._next = function(o) {
    this.isEmpty = !1, this.destination.next(o);
  }, n.prototype._complete = function() {
    this.isEmpty && this.destination.next(this.defaultValue), this.destination.complete();
  }, n;
}(Subscriber);
function throwIfEmpty(e) {
  return e === void 0 && (e = defaultErrorFactory), function(n) {
    return n.lift(new ThrowIfEmptyOperator(e));
  };
}
var ThrowIfEmptyOperator = /* @__PURE__ */ function() {
  function e(n) {
    this.errorFactory = n;
  }
  return e.prototype.call = function(n, o) {
    return o.subscribe(new ThrowIfEmptySubscriber(n, this.errorFactory));
  }, e;
}(), ThrowIfEmptySubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u) {
    var c = e.call(this, o) || this;
    return c.errorFactory = u, c.hasValue = !1, c;
  }
  return n.prototype._next = function(o) {
    this.hasValue = !0, this.destination.next(o);
  }, n.prototype._complete = function() {
    if (this.hasValue)
      return this.destination.complete();
    var o = void 0;
    try {
      o = this.errorFactory();
    } catch (u) {
      o = u;
    }
    this.destination.error(o);
  }, n;
}(Subscriber);
function defaultErrorFactory() {
  return new EmptyError();
}
function take(e) {
  return function(n) {
    return e === 0 ? empty() : n.lift(new TakeOperator(e));
  };
}
var TakeOperator = /* @__PURE__ */ function() {
  function e(n) {
    if (this.total = n, this.total < 0)
      throw new ArgumentOutOfRangeError();
  }
  return e.prototype.call = function(n, o) {
    return o.subscribe(new TakeSubscriber(n, this.total));
  }, e;
}(), TakeSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u) {
    var c = e.call(this, o) || this;
    return c.total = u, c.count = 0, c;
  }
  return n.prototype._next = function(o) {
    var u = this.total, c = ++this.count;
    c <= u && (this.destination.next(o), c === u && (this.destination.complete(), this.unsubscribe()));
  }, n;
}(Subscriber);
function first(e, n) {
  var o = arguments.length >= 2;
  return function(u) {
    return u.pipe(e ? filter(function(c, d) {
      return e(c, d, u);
    }) : identity, take(1), o ? defaultIfEmpty(n) : throwIfEmpty(function() {
      return new EmptyError();
    }));
  };
}
function ignoreElements() {
  return function(n) {
    return n.lift(new IgnoreElementsOperator());
  };
}
var IgnoreElementsOperator = /* @__PURE__ */ function() {
  function e() {
  }
  return e.prototype.call = function(n, o) {
    return o.subscribe(new IgnoreElementsSubscriber(n));
  }, e;
}(), IgnoreElementsSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return n.prototype._next = function(o) {
  }, n;
}(Subscriber);
function multicast(e, n) {
  return function(u) {
    var c;
    if (typeof e == "function" ? c = e : c = function() {
      return e;
    }, typeof n == "function")
      return u.lift(new MulticastOperator(c, n));
    var d = Object.create(u, connectableObservableDescriptor);
    return d.source = u, d.subjectFactory = c, d;
  };
}
var MulticastOperator = /* @__PURE__ */ function() {
  function e(n, o) {
    this.subjectFactory = n, this.selector = o;
  }
  return e.prototype.call = function(n, o) {
    var u = this.selector, c = this.subjectFactory(), d = u(c).subscribe(n);
    return d.add(o.subscribe(c)), d;
  }, e;
}();
function shareSubjectFactory() {
  return new Subject();
}
function share() {
  return function(e) {
    return refCount()(multicast(shareSubjectFactory)(e));
  };
}
function tap(e, n, o) {
  return function(c) {
    return c.lift(new DoOperator(e, n, o));
  };
}
var DoOperator = /* @__PURE__ */ function() {
  function e(n, o, u) {
    this.nextOrObserver = n, this.error = o, this.complete = u;
  }
  return e.prototype.call = function(n, o) {
    return o.subscribe(new TapSubscriber(n, this.nextOrObserver, this.error, this.complete));
  }, e;
}(), TapSubscriber = /* @__PURE__ */ function(e) {
  __extends(n, e);
  function n(o, u, c, d) {
    var m = e.call(this, o) || this;
    return m._tapNext = noop, m._tapError = noop, m._tapComplete = noop, m._tapError = c || noop, m._tapComplete = d || noop, isFunction$2(u) ? (m._context = m, m._tapNext = u) : u && (m._context = u, m._tapNext = u.next || noop, m._tapError = u.error || noop, m._tapComplete = u.complete || noop), m;
  }
  return n.prototype._next = function(o) {
    try {
      this._tapNext.call(this._context, o);
    } catch (u) {
      this.destination.error(u);
      return;
    }
    this.destination.next(o);
  }, n.prototype._error = function(o) {
    try {
      this._tapError.call(this._context, o);
    } catch (u) {
      this.destination.error(u);
      return;
    }
    this.destination.error(o);
  }, n.prototype._complete = function() {
    try {
      this._tapComplete.call(this._context);
    } catch (o) {
      this.destination.error(o);
      return;
    }
    return this.destination.complete();
  }, n;
}(Subscriber);
const monitorCharacteristic = (e) => Observable.create((n) => {
  log("ble-verbose", "start monitor " + e.uuid);
  function o(u) {
    const c = u.target;
    c.value && n.next(Buffer.from(c.value.buffer));
  }
  return e.startNotifications().then(() => {
    e.addEventListener("characteristicvaluechanged", o);
  }), () => {
    log("ble-verbose", "end monitor " + e.uuid), e.stopNotifications();
  };
});
var __awaiter$1 = globalThis && globalThis.__awaiter || function(e, n, o, u) {
  function c(d) {
    return d instanceof o ? d : new o(function(m) {
      m(d);
    });
  }
  return new (o || (o = Promise))(function(d, m) {
    function v(E) {
      try {
        $(u.next(E));
      } catch (O) {
        m(O);
      }
    }
    function S(E) {
      try {
        $(u.throw(E));
      } catch (O) {
        m(O);
      }
    }
    function $(E) {
      E.done ? d(E.value) : c(E.value).then(v, S);
    }
    $((u = u.apply(e, n || [])).next());
  });
};
const requiresBluetooth = () => {
  const { bluetooth: e } = navigator;
  if (typeof e > "u")
    throw new Error("web bluetooth not supported");
  return e;
}, availability = () => Observable.create((e) => {
  const n = requiresBluetooth(), o = (c) => {
    e.next(c.value);
  };
  n.addEventListener("availabilitychanged", o);
  let u = !1;
  return n.getAvailability().then((c) => {
    u || e.next(c);
  }), () => {
    u = !0, n.removeEventListener("availabilitychanged", o);
  };
}), transportsCache = {}, requestDeviceParam = () => ({
  filters: getBluetoothServiceUuids().map((e) => ({
    services: [e]
  }))
}), retrieveService = (e) => __awaiter$1(void 0, void 0, void 0, function* () {
  if (!e.gatt)
    throw new Error("bluetooth gatt not found");
  const [n] = yield e.gatt.getPrimaryServices();
  if (!n)
    throw new Error("bluetooth service not found");
  const o = getInfosForServiceUuid(n.uuid);
  if (!o)
    throw new Error("bluetooth service infos not found");
  return [n, o];
});
function open(e, n) {
  return __awaiter$1(this, void 0, void 0, function* () {
    let o;
    if (typeof e == "string") {
      if (transportsCache[e])
        return log("ble-verbose", "Transport in cache, using that."), transportsCache[e];
      o = yield requiresBluetooth().requestDevice(requestDeviceParam());
    } else
      o = e;
    o.gatt.connected || (log("ble-verbose", "not connected. connecting..."), yield o.gatt.connect());
    const [u, c] = yield retrieveService(o), { deviceModel: d, writeUuid: m, notifyUuid: v } = c, [S, $] = yield Promise.all([
      u.getCharacteristic(m),
      u.getCharacteristic(v)
    ]), E = monitorCharacteristic($).pipe(tap((M) => {
      log("ble-frame", "<= " + M.toString("hex"));
    }), share()), O = E.subscribe(), T = new BluetoothTransport(o, S, E, d);
    if (!o.gatt.connected)
      throw new DisconnectedDevice();
    transportsCache[T.id] = T;
    const y = (M) => {
      console.log("onDisconnect!", M), delete transportsCache[T.id], T.notYetDisconnected = !1, O.unsubscribe(), o.removeEventListener("gattserverdisconnected", y), log("ble-verbose", `BleTransport(${T.id}) disconnected`), T.emit("disconnect", M);
    };
    o.addEventListener("gattserverdisconnected", y);
    const V = Date.now();
    try {
      yield T.inferMTU();
    } finally {
      Date.now() - V < 1e3 && (n = !1), n && (yield o.gatt.disconnect(), yield new Promise((G) => setTimeout(G, 4e3)));
    }
    return n ? open(o, !1) : T;
  });
}
class BluetoothTransport extends Transport {
  /**
   * Scan for Ledger Bluetooth devices.
   * On this web implementation, it only emits ONE device, the one that was selected in the UI (if any).
   */
  static listen(n) {
    log("ble-verbose", "listen...");
    let o;
    requiresBluetooth().requestDevice(requestDeviceParam()).then((d) => {
      o || (n.next({
        type: "add",
        descriptor: d
      }), n.complete());
    }, (d) => {
      n.error(new TransportOpenUserCancelled(d.message));
    });
    function c() {
      o = !0;
    }
    return {
      unsubscribe: c
    };
  }
  /**
   * open a bluetooth device.
   */
  static open(n) {
    return __awaiter$1(this, void 0, void 0, function* () {
      return open(n, !0);
    });
  }
  constructor(n, o, u, c) {
    super(), this.mtuSize = 20, this.notYetDisconnected = !0, this.write = (d) => __awaiter$1(this, void 0, void 0, function* () {
      log("ble-frame", "=> " + d.toString("hex")), yield this.writeCharacteristic.writeValue(d);
    }), this.id = n.id, this.device = n, this.writeCharacteristic = o, this.notifyObservable = u, this.deviceModel = c, log("ble-verbose", `BleTransport(${String(this.id)}) new instance`);
  }
  inferMTU() {
    return __awaiter$1(this, void 0, void 0, function* () {
      let n = 23;
      if (yield this.exchangeAtomicImpl(() => __awaiter$1(this, void 0, void 0, function* () {
        try {
          n = (yield merge$2(this.notifyObservable.pipe(first((o) => o.readUInt8(0) === 8), map((o) => o.readUInt8(5))), defer(() => from(this.write(Buffer.from([8, 0, 0, 0, 0])))).pipe(ignoreElements())).toPromise()) + 3;
        } catch (o) {
          throw log("ble-error", "inferMTU got " + String(o)), this.device.gatt.disconnect(), o;
        }
      })), n > 23) {
        const o = n - 3;
        log("ble-verbose", `BleTransport(${String(this.id)}) mtu set to ${String(o)}`), this.mtuSize = o;
      }
      return this.mtuSize;
    });
  }
  /**
   * Exchange with the device using APDU protocol.
   * @param apdu
   * @returns a promise of apdu response
   */
  exchange(n) {
    return __awaiter$1(this, void 0, void 0, function* () {
      return yield this.exchangeAtomicImpl(() => __awaiter$1(this, void 0, void 0, function* () {
        try {
          const u = n.toString("hex");
          log("apdu", `=> ${u}`);
          const c = yield merge$2(this.notifyObservable.pipe(receiveAPDU), sendAPDU(this.write, n, this.mtuSize)).toPromise(), d = c.toString("hex");
          return log("apdu", `<= ${d}`), c;
        } catch (u) {
          throw log("ble-error", "exchange got " + String(u)), this.notYetDisconnected && this.device.gatt.disconnect(), u;
        }
      }));
    });
  }
  setScrambleKey() {
  }
  close() {
    return __awaiter$1(this, void 0, void 0, function* () {
      this.exchangeBusyPromise && (yield this.exchangeBusyPromise);
    });
  }
}
BluetoothTransport.isSupported = () => Promise.resolve().then(requiresBluetooth).then(() => !0, () => !1);
BluetoothTransport.observeAvailability = (e) => availability().subscribe(e);
BluetoothTransport.list = () => Promise.resolve([]);
BluetoothTransport.disconnect = (e) => __awaiter$1(void 0, void 0, void 0, function* () {
  log("ble-verbose", `user disconnect(${e})`);
  const n = transportsCache[e];
  n && n.device.gatt.disconnect();
});
var build$f = {}, ledgerconnector = {}, build$e = {}, bip39$1 = {}, build$d = {}, ascii$1 = {};
Object.defineProperty(ascii$1, "__esModule", { value: !0 });
ascii$1.fromAscii = ascii$1.toAscii = void 0;
function toAscii$1(e) {
  const n = (o) => o.split("").map((u) => {
    const c = u.charCodeAt(0);
    if (c < 32 || c > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + c);
    return c;
  });
  return Uint8Array.from(n(e));
}
ascii$1.toAscii = toAscii$1;
function fromAscii$1(e) {
  return ((o) => o.map((u) => {
    if (u < 32 || u > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + u);
    return String.fromCharCode(u);
  }))(Array.from(e)).join("");
}
ascii$1.fromAscii = fromAscii$1;
var base64$1 = {}, __createBinding$m = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$m = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$m = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$m(n, e, o);
  return __setModuleDefault$m(n, e), n;
};
Object.defineProperty(base64$1, "__esModule", { value: !0 });
base64$1.fromBase64 = base64$1.toBase64 = void 0;
const base64js$1 = __importStar$m(base64Js);
function toBase64$1(e) {
  return base64js$1.fromByteArray(e);
}
base64$1.toBase64 = toBase64$1;
function fromBase64$1(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$1.toByteArray(e);
}
base64$1.fromBase64 = fromBase64$1;
var bech32$3 = {}, __createBinding$l = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$l = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$l = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$l(n, e, o);
  return __setModuleDefault$l(n, e), n;
};
Object.defineProperty(bech32$3, "__esModule", { value: !0 });
bech32$3.normalizeBech32 = bech32$3.fromBech32 = bech32$3.toBech32 = void 0;
const bech32$2 = __importStar$l(bech32$f);
function toBech32$1(e, n, o) {
  return bech32$2.encode(e, bech32$2.toWords(n), o);
}
bech32$3.toBech32 = toBech32$1;
function fromBech32$1(e, n = 1 / 0) {
  const o = bech32$2.decode(e, n);
  return {
    prefix: o.prefix,
    data: new Uint8Array(bech32$2.fromWords(o.words))
  };
}
bech32$3.fromBech32 = fromBech32$1;
function normalizeBech32$1(e) {
  const { prefix: n, data: o } = fromBech32$1(e);
  return toBech32$1(n, o);
}
bech32$3.normalizeBech32 = normalizeBech32$1;
var hex$1 = {};
Object.defineProperty(hex$1, "__esModule", { value: !0 });
hex$1.fromHex = hex$1.toHex = void 0;
function toHex$1(e) {
  let n = "";
  for (const o of e)
    n += ("0" + o.toString(16)).slice(-2);
  return n;
}
hex$1.toHex = toHex$1;
function fromHex$1(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let o = 0; o < n.length; o++) {
    const u = 2 * o, c = e.slice(u, u + 2);
    if (!c.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[o] = parseInt(c, 16);
  }
  return n;
}
hex$1.fromHex = fromHex$1;
var rfc3339$1 = {};
Object.defineProperty(rfc3339$1, "__esModule", { value: !0 });
rfc3339$1.toRfc3339 = rfc3339$1.fromRfc3339 = void 0;
const rfc3339Matcher$1 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$1(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function fromRfc3339$1(e) {
  const n = rfc3339Matcher$1.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const o = +n[1], u = +n[2], c = +n[3], d = +n[4], m = +n[5], v = +n[6], S = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let $, E, O;
  n[8] === "Z" ? ($ = 1, E = 0, O = 0) : ($ = n[8].substring(0, 1) === "-" ? -1 : 1, E = +n[8].substring(1, 3), O = +n[8].substring(4, 6));
  const T = $ * (E * 60 + O) * 60, y = Date.UTC(o, u - 1, c, d, m, v, S) - T * 1e3;
  return new Date(y);
}
rfc3339$1.fromRfc3339 = fromRfc3339$1;
function toRfc3339$1(e) {
  const n = e.getUTCFullYear(), o = padded$1(e.getUTCMonth() + 1), u = padded$1(e.getUTCDate()), c = padded$1(e.getUTCHours()), d = padded$1(e.getUTCMinutes()), m = padded$1(e.getUTCSeconds()), v = padded$1(e.getUTCMilliseconds(), 3);
  return `${n}-${o}-${u}T${c}:${d}:${m}.${v}Z`;
}
rfc3339$1.toRfc3339 = toRfc3339$1;
var utf8$1 = {};
Object.defineProperty(utf8$1, "__esModule", { value: !0 });
utf8$1.fromUtf8 = utf8$1.toUtf8 = void 0;
function toUtf8$1(e) {
  return new TextEncoder().encode(e);
}
utf8$1.toUtf8 = toUtf8$1;
function fromUtf8$1(e, n = !1) {
  const o = !n;
  return new TextDecoder("utf-8", { fatal: o }).decode(e);
}
utf8$1.fromUtf8 = fromUtf8$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = ascii$1;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var o = base64$1;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return o.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return o.toBase64;
  } });
  var u = bech32$3;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return u.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return u.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return u.toBech32;
  } });
  var c = hex$1;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return c.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return c.toHex;
  } });
  var d = rfc3339$1;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return d.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return d.toRfc3339;
  } });
  var m = utf8$1;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return m.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return m.toUtf8;
  } });
})(build$d);
var pbkdf2$1 = {}, build$c = {}, arrays$1 = {};
Object.defineProperty(arrays$1, "__esModule", { value: !0 });
arrays$1.arrayContentStartsWith = arrays$1.arrayContentEquals = void 0;
function arrayContentEquals$1(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$1.arrayContentEquals = arrayContentEquals$1;
function arrayContentStartsWith$1(e, n) {
  if (e.length < n.length)
    return !1;
  for (let o = 0; o < n.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays$1.arrayContentStartsWith = arrayContentStartsWith$1;
var assert$7 = {};
Object.defineProperty(assert$7, "__esModule", { value: !0 });
assert$7.assertDefinedAndNotNull = assert$7.assertDefined = assert$7.assert = void 0;
function assert$6(e, n) {
  if (!e)
    throw new Error(n || "condition is not truthy");
}
assert$7.assert = assert$6;
function assertDefined$1(e, n) {
  if (e === void 0)
    throw new Error(n ?? "value is undefined");
}
assert$7.assertDefined = assertDefined$1;
function assertDefinedAndNotNull$1(e, n) {
  if (e == null)
    throw new Error(n ?? "value is undefined or null");
}
assert$7.assertDefinedAndNotNull = assertDefinedAndNotNull$1;
var sleep$3 = {};
Object.defineProperty(sleep$3, "__esModule", { value: !0 });
sleep$3.sleep = void 0;
async function sleep$2(e) {
  return new Promise((n) => setTimeout(n, e));
}
sleep$3.sleep = sleep$2;
var typechecks$1 = {};
Object.defineProperty(typechecks$1, "__esModule", { value: !0 });
typechecks$1.isDefined = typechecks$1.isUint8Array = typechecks$1.isNonNullObject = void 0;
function isNonNullObject$1(e) {
  return typeof e == "object" && e !== null;
}
typechecks$1.isNonNullObject = isNonNullObject$1;
function isUint8Array$1(e) {
  return !(!isNonNullObject$1(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(e));
}
typechecks$1.isUint8Array = isUint8Array$1;
function isDefined$1(e) {
  return e !== void 0;
}
typechecks$1.isDefined = isDefined$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var n = arrays$1;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return n.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return n.arrayContentStartsWith;
  } });
  var o = assert$7;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return o.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return o.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return o.assertDefinedAndNotNull;
  } });
  var u = sleep$3;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return u.sleep;
  } });
  var c = typechecks$1;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return c.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return c.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return c.isUint8Array;
  } });
})(build$c);
var __createBinding$k = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$k = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$k = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$k(n, e, o);
  return __setModuleDefault$k(n, e), n;
};
Object.defineProperty(pbkdf2$1, "__esModule", { value: !0 });
pbkdf2$1.pbkdf2Sha512 = pbkdf2$1.pbkdf2Sha512Noble = pbkdf2$1.pbkdf2Sha512NodeCrypto = pbkdf2$1.pbkdf2Sha512Subtle = pbkdf2$1.getSubtle = pbkdf2$1.getNodeCrypto = void 0;
const utils_1$o = build$c, pbkdf2_1$3 = pbkdf2$8, sha512_1$3 = sha512$a;
async function getNodeCrypto() {
  try {
    const e = await Promise.resolve().then(() => __importStar$k(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2$1.getNodeCrypto = getNodeCrypto;
async function getSubtle$1() {
  var n, o, u;
  let e = (n = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : n.subtle;
  return e || (e = (u = (o = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : o.webcrypto) == null ? void 0 : u.subtle), e;
}
pbkdf2$1.getSubtle = getSubtle$1;
async function pbkdf2Sha512Subtle$1(e, n, o, u, c) {
  return (0, utils_1$o.assert)(e, "Argument subtle is falsy"), (0, utils_1$o.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$o.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$o.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", n, { name: "PBKDF2" }, !1, ["deriveBits"]).then((d) => e.deriveBits({
    name: "PBKDF2",
    salt: o,
    iterations: u,
    hash: { name: "SHA-512" }
  }, d, c * 8).then((m) => new Uint8Array(m)));
}
pbkdf2$1.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle$1;
async function pbkdf2Sha512NodeCrypto(e, n, o, u, c) {
  return (0, utils_1$o.assert)(e, "Argument nodeCrypto is falsy"), (0, utils_1$o.assert)(typeof e == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$o.assert)(typeof e.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((d, m) => {
    e.pbkdf2(n, o, u, c, "sha512", (v, S) => {
      v ? m(v) : d(Uint8Array.from(S));
    });
  });
}
pbkdf2$1.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto;
async function pbkdf2Sha512Noble$1(e, n, o, u) {
  return (0, pbkdf2_1$3.pbkdf2Async)(sha512_1$3.sha512, e, n, { c: o, dkLen: u });
}
pbkdf2$1.pbkdf2Sha512Noble = pbkdf2Sha512Noble$1;
async function pbkdf2Sha512$1(e, n, o, u) {
  const c = await getSubtle$1();
  if (c)
    return pbkdf2Sha512Subtle$1(c, e, n, o, u);
  {
    const d = await getNodeCrypto();
    return d ? pbkdf2Sha512NodeCrypto(d, e, n, o, u) : pbkdf2Sha512Noble$1(e, n, o, u);
  }
}
pbkdf2$1.pbkdf2Sha512 = pbkdf2Sha512$1;
var sha$1 = {}, utils$p = {};
Object.defineProperty(utils$p, "__esModule", { value: !0 });
utils$p.toRealUint8Array = void 0;
function toRealUint8Array$1(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$p.toRealUint8Array = toRealUint8Array$1;
Object.defineProperty(sha$1, "__esModule", { value: !0 });
sha$1.sha512 = sha$1.Sha512 = sha$1.sha256 = sha$1.Sha256 = void 0;
const sha256_1$1 = sha256$8, sha512_1$2 = sha512$a, utils_1$n = utils$p;
let Sha256$1 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha256_1$1.sha256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$n.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$1.Sha256 = Sha256$1;
function sha256$1(e) {
  return new Sha256$1(e).digest();
}
sha$1.sha256 = sha256$1;
let Sha512$1 = class {
  constructor(n) {
    this.blockSize = 1024 / 8, this.impl = sha512_1$2.sha512.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$n.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
sha$1.Sha512 = Sha512$1;
function sha512$1(e) {
  return new Sha512$1(e).digest();
}
sha$1.sha512 = sha512$1;
Object.defineProperty(bip39$1, "__esModule", { value: !0 });
bip39$1.Bip39 = bip39$1.EnglishMnemonic = bip39$1.mnemonicToEntropy = bip39$1.entropyToMnemonic = void 0;
const encoding_1$p = build$d, pbkdf2_1$2 = pbkdf2$1, sha_1$1 = sha$1, wordlist$1 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring$1(e) {
  return Array.from(e).map((n) => n.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits$1(e) {
  const o = e.length * 8 / 32, u = (0, sha_1$1.sha256)(e);
  return bytesToBitstring$1(u).slice(0, o);
}
function bitstringToByte$1(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths$1 = [16, 20, 24, 28, 32], allowedWordLengths$1 = [12, 15, 18, 21, 24];
function entropyToMnemonic$1(e) {
  if (allowedEntropyLengths$1.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const n = bytesToBitstring$1(e), o = deriveChecksumBits$1(e);
  return (n + o).match(/(.{11})/g).map((m) => {
    const v = bitstringToByte$1(m);
    return wordlist$1[v];
  }).join(" ");
}
bip39$1.entropyToMnemonic = entropyToMnemonic$1;
const invalidNumberOfWorks$1 = "Invalid number of words", wordNotInWordlist$1 = "Found word that is not in the wordlist", invalidEntropy$1 = "Invalid entropy", invalidChecksum$1 = "Invalid mnemonic checksum";
function normalize$1(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy$1(e) {
  const n = normalize$1(e).split(" ");
  if (!allowedWordLengths$1.includes(n.length))
    throw new Error(invalidNumberOfWorks$1);
  const o = n.map(($) => {
    const E = wordlist$1.indexOf($);
    if (E === -1)
      throw new Error(wordNotInWordlist$1);
    return E.toString(2).padStart(11, "0");
  }).join(""), u = Math.floor(o.length / 33) * 32, c = o.slice(0, u), d = o.slice(u), m = c.match(/(.{1,8})/g).map(bitstringToByte$1);
  if (m.length < 16 || m.length > 32 || m.length % 4 !== 0)
    throw new Error(invalidEntropy$1);
  const v = Uint8Array.from(m);
  if (deriveChecksumBits$1(v) !== d)
    throw new Error(invalidChecksum$1);
  return v;
}
bip39$1.mnemonicToEntropy = mnemonicToEntropy$1;
let EnglishMnemonic$1 = class nc {
  constructor(n) {
    if (!nc.mnemonicMatcher.test(n))
      throw new Error("Invalid mnemonic format");
    const o = n.split(" "), u = [12, 15, 18, 21, 24];
    if (u.indexOf(o.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${u} got: ${o.length})`);
    for (const c of o)
      if (nc.wordlist.indexOf(c) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy$1(n), this.data = n;
  }
  toString() {
    return this.data;
  }
};
bip39$1.EnglishMnemonic = EnglishMnemonic$1;
EnglishMnemonic$1.wordlist = wordlist$1;
EnglishMnemonic$1.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
let Bip39$1 = class {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(n) {
    return new EnglishMnemonic$1(entropyToMnemonic$1(n));
  }
  static decode(n) {
    return mnemonicToEntropy$1(n.toString());
  }
  static async mnemonicToSeed(n, o) {
    const u = (0, encoding_1$p.toUtf8)(normalize$1(n.toString())), c = "mnemonic" + (o ? normalize$1(o) : ""), d = (0, encoding_1$p.toUtf8)(c);
    return (0, pbkdf2_1$2.pbkdf2Sha512)(u, d, 2048, 64);
  }
};
bip39$1.Bip39 = Bip39$1;
var hmac$1 = {};
Object.defineProperty(hmac$1, "__esModule", { value: !0 });
hmac$1.Hmac = void 0;
let Hmac$1 = class {
  constructor(n, o) {
    const u = new n().blockSize;
    this.hash = (d) => new n().update(d).digest();
    let c = o;
    if (c.length > u && (c = this.hash(c)), c.length < u) {
      const d = new Uint8Array(u - c.length);
      c = new Uint8Array([...c, ...d]);
    }
    this.oKeyPad = c.map((d) => d ^ 92), this.iKeyPad = c.map((d) => d ^ 54), this.messageHasher = new n(), this.blockSize = u, this.update(this.iKeyPad);
  }
  update(n) {
    return this.messageHasher.update(n), this;
  }
  digest() {
    const n = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...n]));
  }
};
hmac$1.Hmac = Hmac$1;
var keccak$1 = {};
Object.defineProperty(keccak$1, "__esModule", { value: !0 });
keccak$1.keccak256 = keccak$1.Keccak256 = void 0;
const sha3_1$1 = sha3$3, utils_1$m = utils$p;
let Keccak256$1 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha3_1$1.keccak_256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$m.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
keccak$1.Keccak256 = Keccak256$1;
function keccak256$2(e) {
  return new Keccak256$1(e).digest();
}
keccak$1.keccak256 = keccak256$2;
var libsodium$1 = {}, __importDefault$l = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium$1, "__esModule", { value: !0 });
libsodium$1.Xchacha20poly1305Ietf = libsodium$1.xchacha20NonceLength = libsodium$1.Ed25519 = libsodium$1.Ed25519Keypair = libsodium$1.Argon2id = libsodium$1.isArgon2idOptions = void 0;
const utils_1$l = build$c, libsodium_wrappers_sumo_1 = __importDefault$l(libsodiumWrappers);
function isArgon2idOptions$1(e) {
  return !(!(0, utils_1$l.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium$1.isArgon2idOptions = isArgon2idOptions$1;
let Argon2id$1 = class {
  static async execute(n, o, u) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_pwhash(
      u.outputLength,
      n,
      o,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      u.opsLimit,
      u.memLimitKib * 1024,
      libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
};
libsodium$1.Argon2id = Argon2id$1;
let Ed25519Keypair$1 = class hd {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(n) {
    if (n.length !== 64)
      throw new Error(`Unexpected key length ${n.length}. Must be 64.`);
    return new hd(n.slice(0, 32), n.slice(32, 64));
  }
  constructor(n, o) {
    this.privkey = n, this.pubkey = o;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
};
libsodium$1.Ed25519Keypair = Ed25519Keypair$1;
let Ed25519$1 = class {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(n) {
    await libsodium_wrappers_sumo_1.default.ready;
    const o = libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(n);
    return Ed25519Keypair$1.fromLibsodiumPrivkey(o.privateKey);
  }
  static async createSignature(n, o) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_sign_detached(n, o.toLibsodiumPrivkey());
  }
  static async verifySignature(n, o, u) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(n, o, u);
  }
};
libsodium$1.Ed25519 = Ed25519$1;
libsodium$1.xchacha20NonceLength = 24;
let Xchacha20poly1305Ietf$1 = class {
  static async encrypt(n, o, u) {
    await libsodium_wrappers_sumo_1.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      n,
      c,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      u,
      o
    );
  }
  static async decrypt(n, o, u) {
    await libsodium_wrappers_sumo_1.default.ready;
    const c = null;
    return libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      n,
      c,
      u,
      o
    );
  }
};
libsodium$1.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf$1;
var random$1 = {};
Object.defineProperty(random$1, "__esModule", { value: !0 });
random$1.Random = void 0;
let Random$1 = class {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(n) {
    try {
      const o = typeof window == "object" ? window : self, u = typeof o.crypto < "u" ? o.crypto : o.msCrypto, c = new Uint8Array(n);
      return u.getRandomValues(c), c;
    } catch {
      try {
        const o = requireCryptoBrowserify();
        return new Uint8Array([...o.randomBytes(n)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
};
random$1.Random = Random$1;
var ripemd$1 = {};
Object.defineProperty(ripemd$1, "__esModule", { value: !0 });
ripemd$1.ripemd160 = ripemd$1.Ripemd160 = void 0;
const ripemd160_1$1 = ripemd160$8, utils_1$k = utils$p;
let Ripemd160$1 = class {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1$1.ripemd160.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$k.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
};
ripemd$1.Ripemd160 = Ripemd160$1;
function ripemd160$1(e) {
  return new Ripemd160$1(e).digest();
}
ripemd$1.ripemd160 = ripemd160$1;
var secp256k1$3 = {}, secp256k1signature$1 = {};
Object.defineProperty(secp256k1signature$1, "__esModule", { value: !0 });
secp256k1signature$1.ExtendedSecp256k1Signature = secp256k1signature$1.Secp256k1Signature = void 0;
function trimLeadingNullBytes$1(e) {
  let n = 0;
  for (const o of e)
    if (o === 0)
      n++;
    else
      break;
  return e.slice(n);
}
const derTagInteger$1 = 2;
let Secp256k1Signature$1 = class rc {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(n) {
    if (n.length !== 64)
      throw new Error(`Got invalid data length: ${n.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new rc(trimLeadingNullBytes$1(n.slice(0, 32)), trimLeadingNullBytes$1(n.slice(32, 64)));
  }
  static fromDer(n) {
    let o = 0;
    if (n[o++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const u = n[o++];
    if (n.length - o !== u)
      throw new Error("Data length mismatch detected");
    if (n[o++] !== derTagInteger$1)
      throw new Error("INTEGER tag expected");
    const d = n[o++];
    if (d >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const m = n.slice(o, o + d);
    if (o += d, n[o++] !== derTagInteger$1)
      throw new Error("INTEGER tag expected");
    const S = n[o++];
    if (S >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const $ = n.slice(o, o + S);
    return o += S, new rc(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes$1(m),
      trimLeadingNullBytes$1($)
    );
  }
  constructor(n, o) {
    if (n.length > 32 || n.length === 0 || n[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (o.length > 32 || o.length === 0 || o[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: n,
      s: o
    };
  }
  r(n) {
    if (n === void 0)
      return this.data.r;
    {
      const o = n - this.data.r.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter r");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.r]);
    }
  }
  s(n) {
    if (n === void 0)
      return this.data.s;
    {
      const o = n - this.data.s.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter s");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const n = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, o = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, u = n.length, c = o.length, d = new Uint8Array([derTagInteger$1, u, ...n, derTagInteger$1, c, ...o]);
    return new Uint8Array([48, d.length, ...d]);
  }
};
secp256k1signature$1.Secp256k1Signature = Secp256k1Signature$1;
let ExtendedSecp256k1Signature$1 = class Ad extends Secp256k1Signature$1 {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(n) {
    if (n.length !== 65)
      throw new Error(`Got invalid data length ${n.length}. Expected 32 + 32 + 1`);
    return new Ad(trimLeadingNullBytes$1(n.slice(0, 32)), trimLeadingNullBytes$1(n.slice(32, 64)), n[64]);
  }
  constructor(n, o, u) {
    if (super(n, o), !Number.isInteger(u))
      throw new Error("The recovery parameter must be an integer.");
    if (u < 0 || u > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = u;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
};
secp256k1signature$1.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature$1;
var __importDefault$k = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$3, "__esModule", { value: !0 });
secp256k1$3.Secp256k1 = void 0;
const encoding_1$o = build$d, bn_js_1$5 = __importDefault$k(bnExports$1), elliptic_1$2 = __importDefault$k(requireElliptic()), secp256k1signature_1$1 = secp256k1signature$1, secp256k1$2 = new elliptic_1$2.default.ec("secp256k1"), secp256k1N$1 = new bn_js_1$5.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
let Secp256k1$1 = class {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(n) {
    if (n.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const o = secp256k1$2.keyFromPrivate(n);
    if (o.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$5.default(n).gte(secp256k1N$1))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$o.fromHex)(o.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(o.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(n, o) {
    if (n.length === 0)
      throw new Error("Message hash must not be empty");
    if (n.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const u = secp256k1$2.keyFromPrivate(o), { r: c, s: d, recoveryParam: m } = u.sign(n, { canonical: !0 });
    if (typeof m != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1$1.ExtendedSecp256k1Signature(Uint8Array.from(c.toArray()), Uint8Array.from(d.toArray()), m);
  }
  static async verifySignature(n, o, u) {
    if (o.length === 0)
      throw new Error("Message hash must not be empty");
    if (o.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const c = secp256k1$2.keyFromPublic(u);
    try {
      return c.verify(o, n.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(n, o) {
    const u = { r: (0, encoding_1$o.toHex)(n.r()), s: (0, encoding_1$o.toHex)(n.s()) }, c = secp256k1$2.recoverPubKey(o, u, n.recovery), d = secp256k1$2.keyFromPublic(c);
    return (0, encoding_1$o.fromHex)(d.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(n) {
    switch (n.length) {
      case 33:
        return n;
      case 65:
        return Uint8Array.from(secp256k1$2.keyFromPublic(n).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(n) {
    switch (n.length) {
      case 33:
        return Uint8Array.from(secp256k1$2.keyFromPublic(n).getPublic(!1, "array"));
      case 65:
        return n;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(n) {
    switch (n.length) {
      case 64:
        return n;
      case 65:
        return n.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
};
secp256k1$3.Secp256k1 = Secp256k1$1;
var slip10$1 = {}, build$b = {}, decimal$1 = {}, __importDefault$j = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal$1, "__esModule", { value: !0 });
decimal$1.Decimal = void 0;
const bn_js_1$4 = __importDefault$j(bnExports$1), maxFractionalDigits$1 = 100;
let Decimal$1 = class ss {
  static fromUserInput(n, o) {
    ss.verifyFractionalDigits(o);
    const u = n.match(/[^0-9.]/);
    if (u)
      throw new Error(`Invalid character at position ${u.index + 1}`);
    let c, d;
    if (n === "")
      c = "0", d = "";
    else if (n.search(/\./) === -1)
      c = n, d = "";
    else {
      const v = n.split(".");
      switch (v.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!v[1])
            throw new Error("Fractional part missing");
          c = v[0], d = v[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (d.length > o)
      throw new Error("Got more fractional digits than supported");
    const m = `${c}${d.padEnd(o, "0")}`;
    return new ss(m, o);
  }
  static fromAtomics(n, o) {
    return ss.verifyFractionalDigits(o), new ss(n, o);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(n) {
    return ss.verifyFractionalDigits(n), new ss("0", n);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(n) {
    return ss.verifyFractionalDigits(n), new ss("1" + "0".repeat(n), n);
  }
  static verifyFractionalDigits(n) {
    if (!Number.isInteger(n))
      throw new Error("Fractional digits is not an integer");
    if (n < 0)
      throw new Error("Fractional digits must not be negative");
    if (n > maxFractionalDigits$1)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits$1}`);
  }
  static compare(n, o) {
    if (n.fractionalDigits !== o.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return n.data.atomics.cmp(new bn_js_1$4.default(o.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(n, o) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$4.default(n),
      fractionalDigits: o
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new ss(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const n = new bn_js_1$4.default(10).pow(new bn_js_1$4.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : ss.fromAtomics(o.mul(n).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const n = new bn_js_1$4.default(10).pow(new bn_js_1$4.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : ss.fromAtomics(o.addn(1).mul(n).toString(), this.fractionalDigits);
  }
  toString() {
    const n = new bn_js_1$4.default(10).pow(new bn_js_1$4.default(this.data.fractionalDigits)), o = this.data.atomics.div(n), u = this.data.atomics.mod(n);
    if (u.isZero())
      return o.toString();
    {
      const d = u.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${o.toString()}.${d}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const n = Number(this.toString());
    if (Number.isNaN(n))
      throw new Error("Conversion to number failed");
    return n;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.add(new bn_js_1$4.default(n.atomics));
    return new ss(o.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.sub(new bn_js_1$4.default(n.atomics));
    if (o.ltn(0))
      throw new Error("Difference must not be negative");
    return new ss(o.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(n) {
    const o = this.data.atomics.mul(new bn_js_1$4.default(n.toString()));
    return new ss(o.toString(), this.fractionalDigits);
  }
  equals(n) {
    return ss.compare(this, n) === 0;
  }
  isLessThan(n) {
    return ss.compare(this, n) < 0;
  }
  isLessThanOrEqual(n) {
    return ss.compare(this, n) <= 0;
  }
  isGreaterThan(n) {
    return ss.compare(this, n) > 0;
  }
  isGreaterThanOrEqual(n) {
    return ss.compare(this, n) >= 0;
  }
};
decimal$1.Decimal = Decimal$1;
var integers$1 = {}, __importDefault$i = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers$1, "__esModule", { value: !0 });
integers$1.Uint64 = integers$1.Uint53 = integers$1.Int53 = integers$1.Uint32 = void 0;
const bn_js_1$3 = __importDefault$i(bnExports$1), uint64MaxValue$1 = new bn_js_1$3.default("18446744073709551615", 10, "be");
let Uint32$1 = class Iu {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(n) {
    return Iu.fromBytes(n);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? n : Array.from(n).reverse();
    return new Iu(u[0] * 2 ** 24 + u[1] * 2 ** 16 + u[2] * 2 ** 8 + u[3]);
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Iu(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < 0 || n > 4294967295)
      throw new Error("Input not in uint32 range: " + n.toString());
    this.data = n;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$1.Uint32 = Uint32$1;
let Int53$1 = class yd {
  static fromString(n) {
    if (!n.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new yd(Number.parseInt(n, 10));
  }
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + n.toString());
    this.data = n;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$1.Int53 = Int53$1;
let Uint53$1 = class vd {
  static fromString(n) {
    const o = Int53$1.fromString(n);
    return new vd(o.toNumber());
  }
  constructor(n) {
    const o = new Int53$1(n);
    if (o.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = o;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
};
integers$1.Uint53 = Uint53$1;
let Uint64$1 = class cu {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(n) {
    return cu.fromBytes(n);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? Array.from(n) : Array.from(n).reverse();
    return new cu(new bn_js_1$3.default(u));
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new cu(new bn_js_1$3.default(n, 10, "be"));
  }
  static fromNumber(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    let o;
    try {
      o = new bn_js_1$3.default(n);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new cu(o);
  }
  constructor(n) {
    if (n.isNeg())
      throw new Error("Input is negative");
    if (n.gt(uint64MaxValue$1))
      throw new Error("Input exceeds uint64 range");
    this.data = n;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
};
integers$1.Uint64 = Uint64$1;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var n = decimal$1;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return n.Decimal;
  } });
  var o = integers$1;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return o.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return o.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return o.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return o.Uint64;
  } });
})(build$b);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const o = build$d, u = build$b, c = n(bnExports$1), d = n(requireElliptic()), m = hmac$1, v = sha$1;
  var S;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(S = e.Slip10Curve || (e.Slip10Curve = {}));
  function $(M) {
    switch (M) {
      case S.Ed25519:
        return S.Ed25519;
      case S.Secp256k1:
        return S.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  e.slip10CurveFromString = $;
  class E extends u.Uint32 {
    static hardened(G) {
      return new E(G + 2 ** 31);
    }
    static normal(G) {
      return new E(G);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = E;
  const O = new d.default.ec("secp256k1");
  class T {
    static derivePath(G, k, F) {
      let X = this.master(G, k);
      for (const ee of F)
        X = this.child(G, X.privkey, X.chainCode, ee);
      return X;
    }
    static master(G, k) {
      const F = new m.Hmac(v.Sha512, (0, o.toAscii)(G)).update(k).digest(), X = F.slice(0, 32), ee = F.slice(32, 64);
      return G !== S.Ed25519 && (this.isZero(X) || this.isGteN(G, X)) ? this.master(G, F) : {
        chainCode: ee,
        privkey: X
      };
    }
    static child(G, k, F, X) {
      let ee;
      if (X.isHardened()) {
        const ue = new Uint8Array([0, ...k, ...X.toBytesBigEndian()]);
        ee = new m.Hmac(v.Sha512, F).update(ue).digest();
      } else {
        if (G === S.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ue = new Uint8Array([
            ...T.serializedPoint(G, new c.default(k)),
            ...X.toBytesBigEndian()
          ]);
          ee = new m.Hmac(v.Sha512, F).update(ue).digest();
        }
      }
      return this.childImpl(G, k, F, X, ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(G, k) {
      switch (G) {
        case S.Secp256k1:
          return (0, o.fromHex)(O.g.mul(k).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(G, k, F, X, ee) {
      const ue = ee.slice(0, 32), Q = ee.slice(32, 64), Y = Q;
      if (G === S.Ed25519)
        return {
          chainCode: Y,
          privkey: ue
        };
      const pe = this.n(G), oe = new c.default(ue).add(new c.default(k)).mod(pe), ne = Uint8Array.from(oe.toArray("be", 32));
      if (this.isGteN(G, ue) || this.isZero(ne)) {
        const H = new m.Hmac(v.Sha512, F).update(new Uint8Array([1, ...Q, ...X.toBytesBigEndian()])).digest();
        return this.childImpl(G, k, F, X, H);
      }
      return {
        chainCode: Y,
        privkey: ne
      };
    }
    static isZero(G) {
      return G.every((k) => k === 0);
    }
    static isGteN(G, k) {
      return new c.default(k).gte(this.n(G));
    }
    static n(G) {
      switch (G) {
        case S.Secp256k1:
          return new c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = T;
  function y(M) {
    return M.reduce((G, k) => {
      const F = k.isHardened() ? `${k.toNumber() - 2147483648}'` : k.toString();
      return G + "/" + F;
    }, "m");
  }
  e.pathToString = y;
  function V(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let G = M.slice(1);
    const k = new Array();
    for (; G; ) {
      const F = G.match(/^\/([0-9]+)('?)/);
      if (!F)
        throw new Error("Syntax error while reading path component");
      const [X, ee, ue] = F, Q = u.Uint53.fromString(ee).toNumber();
      if (Q >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ue ? k.push(E.hardened(Q)) : k.push(E.normal(Q)), G = G.slice(X.length);
    }
    return k;
  }
  e.stringToPath = V;
})(slip10$1);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var n = bip39$1;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return n.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return n.EnglishMnemonic;
  } });
  var o = hmac$1;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return o.Hmac;
  } });
  var u = keccak$1;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return u.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return u.keccak256;
  } });
  var c = libsodium$1;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return c.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return c.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return c.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return c.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return c.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return c.Xchacha20poly1305Ietf;
  } });
  var d = random$1;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return d.Random;
  } });
  var m = ripemd$1;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return m.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return m.ripemd160;
  } });
  var v = secp256k1$3;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return v.Secp256k1;
  } });
  var S = secp256k1signature$1;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return S.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return S.Secp256k1Signature;
  } });
  var $ = sha$1;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return $.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return $.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return $.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return $.sha512;
  } });
  var E = slip10$1;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return E.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return E.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return E.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return E.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return E.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return E.stringToPath;
  } });
})(build$e);
var dist$5 = {}, interopRequireDefault = { exports: {} };
(function(e) {
  function n(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports, regeneratorRuntime$1 = { exports: {} }, _typeof$1 = { exports: {} }, hasRequired_typeof;
function require_typeof() {
  return hasRequired_typeof || (hasRequired_typeof = 1, function(e) {
    function n(o) {
      "@babel/helpers - typeof";
      return e.exports = n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
        return typeof u;
      } : function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, n(o);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(_typeof$1)), _typeof$1.exports;
}
var hasRequiredRegeneratorRuntime;
function requireRegeneratorRuntime() {
  return hasRequiredRegeneratorRuntime || (hasRequiredRegeneratorRuntime = 1, function(e) {
    var n = require_typeof().default;
    function o() {
      e.exports = o = function() {
        return u;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var u = {}, c = Object.prototype, d = c.hasOwnProperty, m = Object.defineProperty || function(J, se, fe) {
        J[se] = fe.value;
      }, v = typeof Symbol == "function" ? Symbol : {}, S = v.iterator || "@@iterator", $ = v.asyncIterator || "@@asyncIterator", E = v.toStringTag || "@@toStringTag";
      function O(J, se, fe) {
        return Object.defineProperty(J, se, {
          value: fe,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), J[se];
      }
      try {
        O({}, "");
      } catch {
        O = function(fe, N, W) {
          return fe[N] = W;
        };
      }
      function T(J, se, fe, N) {
        var W = se && se.prototype instanceof M ? se : M, I = Object.create(W.prototype), te = new C(N || []);
        return m(I, "_invoke", {
          value: pe(J, fe, te)
        }), I;
      }
      function y(J, se, fe) {
        try {
          return {
            type: "normal",
            arg: J.call(se, fe)
          };
        } catch (N) {
          return {
            type: "throw",
            arg: N
          };
        }
      }
      u.wrap = T;
      var V = {};
      function M() {
      }
      function G() {
      }
      function k() {
      }
      var F = {};
      O(F, S, function() {
        return this;
      });
      var X = Object.getPrototypeOf, ee = X && X(X(w([])));
      ee && ee !== c && d.call(ee, S) && (F = ee);
      var ue = k.prototype = M.prototype = Object.create(F);
      function Q(J) {
        ["next", "throw", "return"].forEach(function(se) {
          O(J, se, function(fe) {
            return this._invoke(se, fe);
          });
        });
      }
      function Y(J, se) {
        function fe(W, I, te, ge) {
          var Pe = y(J[W], J, I);
          if (Pe.type !== "throw") {
            var Ke = Pe.arg, xe = Ke.value;
            return xe && n(xe) == "object" && d.call(xe, "__await") ? se.resolve(xe.__await).then(function(ze) {
              fe("next", ze, te, ge);
            }, function(ze) {
              fe("throw", ze, te, ge);
            }) : se.resolve(xe).then(function(ze) {
              Ke.value = ze, te(Ke);
            }, function(ze) {
              return fe("throw", ze, te, ge);
            });
          }
          ge(Pe.arg);
        }
        var N;
        m(this, "_invoke", {
          value: function(I, te) {
            function ge() {
              return new se(function(Pe, Ke) {
                fe(I, te, Pe, Ke);
              });
            }
            return N = N ? N.then(ge, ge) : ge();
          }
        });
      }
      function pe(J, se, fe) {
        var N = "suspendedStart";
        return function(W, I) {
          if (N === "executing")
            throw new Error("Generator is already running");
          if (N === "completed") {
            if (W === "throw")
              throw I;
            return P();
          }
          for (fe.method = W, fe.arg = I; ; ) {
            var te = fe.delegate;
            if (te) {
              var ge = oe(te, fe);
              if (ge) {
                if (ge === V)
                  continue;
                return ge;
              }
            }
            if (fe.method === "next")
              fe.sent = fe._sent = fe.arg;
            else if (fe.method === "throw") {
              if (N === "suspendedStart")
                throw N = "completed", fe.arg;
              fe.dispatchException(fe.arg);
            } else
              fe.method === "return" && fe.abrupt("return", fe.arg);
            N = "executing";
            var Pe = y(J, se, fe);
            if (Pe.type === "normal") {
              if (N = fe.done ? "completed" : "suspendedYield", Pe.arg === V)
                continue;
              return {
                value: Pe.arg,
                done: fe.done
              };
            }
            Pe.type === "throw" && (N = "completed", fe.method = "throw", fe.arg = Pe.arg);
          }
        };
      }
      function oe(J, se) {
        var fe = se.method, N = J.iterator[fe];
        if (N === void 0)
          return se.delegate = null, fe === "throw" && J.iterator.return && (se.method = "return", se.arg = void 0, oe(J, se), se.method === "throw") || fe !== "return" && (se.method = "throw", se.arg = new TypeError("The iterator does not provide a '" + fe + "' method")), V;
        var W = y(N, J.iterator, se.arg);
        if (W.type === "throw")
          return se.method = "throw", se.arg = W.arg, se.delegate = null, V;
        var I = W.arg;
        return I ? I.done ? (se[J.resultName] = I.value, se.next = J.nextLoc, se.method !== "return" && (se.method = "next", se.arg = void 0), se.delegate = null, V) : I : (se.method = "throw", se.arg = new TypeError("iterator result is not an object"), se.delegate = null, V);
      }
      function ne(J) {
        var se = {
          tryLoc: J[0]
        };
        1 in J && (se.catchLoc = J[1]), 2 in J && (se.finallyLoc = J[2], se.afterLoc = J[3]), this.tryEntries.push(se);
      }
      function H(J) {
        var se = J.completion || {};
        se.type = "normal", delete se.arg, J.completion = se;
      }
      function C(J) {
        this.tryEntries = [{
          tryLoc: "root"
        }], J.forEach(ne, this), this.reset(!0);
      }
      function w(J) {
        if (J) {
          var se = J[S];
          if (se)
            return se.call(J);
          if (typeof J.next == "function")
            return J;
          if (!isNaN(J.length)) {
            var fe = -1, N = function W() {
              for (; ++fe < J.length; )
                if (d.call(J, fe))
                  return W.value = J[fe], W.done = !1, W;
              return W.value = void 0, W.done = !0, W;
            };
            return N.next = N;
          }
        }
        return {
          next: P
        };
      }
      function P() {
        return {
          value: void 0,
          done: !0
        };
      }
      return G.prototype = k, m(ue, "constructor", {
        value: k,
        configurable: !0
      }), m(k, "constructor", {
        value: G,
        configurable: !0
      }), G.displayName = O(k, E, "GeneratorFunction"), u.isGeneratorFunction = function(J) {
        var se = typeof J == "function" && J.constructor;
        return !!se && (se === G || (se.displayName || se.name) === "GeneratorFunction");
      }, u.mark = function(J) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(J, k) : (J.__proto__ = k, O(J, E, "GeneratorFunction")), J.prototype = Object.create(ue), J;
      }, u.awrap = function(J) {
        return {
          __await: J
        };
      }, Q(Y.prototype), O(Y.prototype, $, function() {
        return this;
      }), u.AsyncIterator = Y, u.async = function(J, se, fe, N, W) {
        W === void 0 && (W = Promise);
        var I = new Y(T(J, se, fe, N), W);
        return u.isGeneratorFunction(se) ? I : I.next().then(function(te) {
          return te.done ? te.value : I.next();
        });
      }, Q(ue), O(ue, E, "Generator"), O(ue, S, function() {
        return this;
      }), O(ue, "toString", function() {
        return "[object Generator]";
      }), u.keys = function(J) {
        var se = Object(J), fe = [];
        for (var N in se)
          fe.push(N);
        return fe.reverse(), function W() {
          for (; fe.length; ) {
            var I = fe.pop();
            if (I in se)
              return W.value = I, W.done = !1, W;
          }
          return W.done = !0, W;
        };
      }, u.values = w, C.prototype = {
        constructor: C,
        reset: function(se) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(H), !se)
            for (var fe in this)
              fe.charAt(0) === "t" && d.call(this, fe) && !isNaN(+fe.slice(1)) && (this[fe] = void 0);
        },
        stop: function() {
          this.done = !0;
          var se = this.tryEntries[0].completion;
          if (se.type === "throw")
            throw se.arg;
          return this.rval;
        },
        dispatchException: function(se) {
          if (this.done)
            throw se;
          var fe = this;
          function N(Ke, xe) {
            return te.type = "throw", te.arg = se, fe.next = Ke, xe && (fe.method = "next", fe.arg = void 0), !!xe;
          }
          for (var W = this.tryEntries.length - 1; W >= 0; --W) {
            var I = this.tryEntries[W], te = I.completion;
            if (I.tryLoc === "root")
              return N("end");
            if (I.tryLoc <= this.prev) {
              var ge = d.call(I, "catchLoc"), Pe = d.call(I, "finallyLoc");
              if (ge && Pe) {
                if (this.prev < I.catchLoc)
                  return N(I.catchLoc, !0);
                if (this.prev < I.finallyLoc)
                  return N(I.finallyLoc);
              } else if (ge) {
                if (this.prev < I.catchLoc)
                  return N(I.catchLoc, !0);
              } else {
                if (!Pe)
                  throw new Error("try statement without catch or finally");
                if (this.prev < I.finallyLoc)
                  return N(I.finallyLoc);
              }
            }
          }
        },
        abrupt: function(se, fe) {
          for (var N = this.tryEntries.length - 1; N >= 0; --N) {
            var W = this.tryEntries[N];
            if (W.tryLoc <= this.prev && d.call(W, "finallyLoc") && this.prev < W.finallyLoc) {
              var I = W;
              break;
            }
          }
          I && (se === "break" || se === "continue") && I.tryLoc <= fe && fe <= I.finallyLoc && (I = null);
          var te = I ? I.completion : {};
          return te.type = se, te.arg = fe, I ? (this.method = "next", this.next = I.finallyLoc, V) : this.complete(te);
        },
        complete: function(se, fe) {
          if (se.type === "throw")
            throw se.arg;
          return se.type === "break" || se.type === "continue" ? this.next = se.arg : se.type === "return" ? (this.rval = this.arg = se.arg, this.method = "return", this.next = "end") : se.type === "normal" && fe && (this.next = fe), V;
        },
        finish: function(se) {
          for (var fe = this.tryEntries.length - 1; fe >= 0; --fe) {
            var N = this.tryEntries[fe];
            if (N.finallyLoc === se)
              return this.complete(N.completion, N.afterLoc), H(N), V;
          }
        },
        catch: function(se) {
          for (var fe = this.tryEntries.length - 1; fe >= 0; --fe) {
            var N = this.tryEntries[fe];
            if (N.tryLoc === se) {
              var W = N.completion;
              if (W.type === "throw") {
                var I = W.arg;
                H(N);
              }
              return I;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(se, fe, N) {
          return this.delegate = {
            iterator: w(se),
            resultName: fe,
            nextLoc: N
          }, this.method === "next" && (this.arg = void 0), V;
        }
      }, u;
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(regeneratorRuntime$1)), regeneratorRuntime$1.exports;
}
var regenerator, hasRequiredRegenerator;
function requireRegenerator() {
  if (hasRequiredRegenerator)
    return regenerator;
  hasRequiredRegenerator = 1;
  var e = requireRegeneratorRuntime()();
  regenerator = e;
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
  return regenerator;
}
var asyncToGenerator = { exports: {} }, hasRequiredAsyncToGenerator;
function requireAsyncToGenerator() {
  return hasRequiredAsyncToGenerator || (hasRequiredAsyncToGenerator = 1, function(e) {
    function n(u, c, d, m, v, S, $) {
      try {
        var E = u[S]($), O = E.value;
      } catch (T) {
        d(T);
        return;
      }
      E.done ? c(O) : Promise.resolve(O).then(m, v);
    }
    function o(u) {
      return function() {
        var c = this, d = arguments;
        return new Promise(function(m, v) {
          var S = u.apply(c, d);
          function $(O) {
            n(S, m, v, $, E, "next", O);
          }
          function E(O) {
            n(S, m, v, $, E, "throw", O);
          }
          $(void 0);
        });
      };
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(asyncToGenerator)), asyncToGenerator.exports;
}
var classCallCheck = { exports: {} }, hasRequiredClassCallCheck;
function requireClassCallCheck() {
  return hasRequiredClassCallCheck || (hasRequiredClassCallCheck = 1, function(e) {
    function n(o, u) {
      if (!(o instanceof u))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(classCallCheck)), classCallCheck.exports;
}
var createClass = { exports: {} }, toPropertyKey = { exports: {} }, toPrimitive = { exports: {} }, hasRequiredToPrimitive;
function requireToPrimitive() {
  return hasRequiredToPrimitive || (hasRequiredToPrimitive = 1, function(e) {
    var n = require_typeof().default;
    function o(u, c) {
      if (n(u) !== "object" || u === null)
        return u;
      var d = u[Symbol.toPrimitive];
      if (d !== void 0) {
        var m = d.call(u, c || "default");
        if (n(m) !== "object")
          return m;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (c === "string" ? String : Number)(u);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(toPrimitive)), toPrimitive.exports;
}
var hasRequiredToPropertyKey;
function requireToPropertyKey() {
  return hasRequiredToPropertyKey || (hasRequiredToPropertyKey = 1, function(e) {
    var n = require_typeof().default, o = requireToPrimitive();
    function u(c) {
      var d = o(c, "string");
      return n(d) === "symbol" ? d : String(d);
    }
    e.exports = u, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(toPropertyKey)), toPropertyKey.exports;
}
var hasRequiredCreateClass;
function requireCreateClass() {
  return hasRequiredCreateClass || (hasRequiredCreateClass = 1, function(e) {
    var n = requireToPropertyKey();
    function o(c, d) {
      for (var m = 0; m < d.length; m++) {
        var v = d[m];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(c, n(v.key), v);
      }
    }
    function u(c, d, m) {
      return d && o(c.prototype, d), m && o(c, m), Object.defineProperty(c, "prototype", {
        writable: !1
      }), c;
    }
    e.exports = u, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(createClass)), createClass.exports;
}
var helperV1 = {}, common$1 = {}, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon)
    return common$1;
  hasRequiredCommon = 1;
  var e = interopRequireDefaultExports;
  Object.defineProperty(common$1, "__esModule", {
    value: !0
  }), common$1.errorCodeToString = T, common$1.processErrorResponse = V, common$1.getVersion = M, common$1.ERROR_CODE = common$1.P1_VALUES = common$1.PAYLOAD_TYPE = common$1.INS = common$1.APP_KEY = common$1.CHUNK_SIZE = common$1.CLA = void 0;
  var n = e(requireRegenerator()), o = e(requireAsyncToGenerator()), u = e(require_typeof()), c = 85;
  common$1.CLA = c;
  var d = 250;
  common$1.CHUNK_SIZE = d;
  var m = "CSM";
  common$1.APP_KEY = m;
  var v = {
    GET_VERSION: 0,
    INS_PUBLIC_KEY_SECP256K1: 1,
    // Obsolete
    SIGN_SECP256K1: 2,
    GET_ADDR_SECP256K1: 4
  };
  common$1.INS = v;
  var S = {
    INIT: 0,
    ADD: 1,
    LAST: 2
  };
  common$1.PAYLOAD_TYPE = S;
  var $ = {
    ONLY_RETRIEVE: 0,
    SHOW_ADDRESS_IN_DEVICE: 1
  };
  common$1.P1_VALUES = $;
  var E = {
    NoError: 36864
  };
  common$1.ERROR_CODE = E;
  var O = {
    1: "U2F: Unknown",
    2: "U2F: Bad request",
    3: "U2F: Configuration unsupported",
    4: "U2F: Device Ineligible",
    5: "U2F: Timeout",
    14: "Timeout",
    36864: "No errors",
    36865: "Device is busy",
    26626: "Error deriving keys",
    25600: "Execution Error",
    26368: "Wrong Length",
    27010: "Empty Buffer",
    27011: "Output buffer too small",
    27012: "Data is invalid",
    27013: "Conditions not satisfied",
    27014: "Transaction rejected",
    27264: "Bad key handle",
    27392: "Invalid P1/P2",
    27904: "Instruction not supported",
    28160: "App does not seem to be open",
    28416: "Unknown error",
    28417: "Sign/verify error"
  };
  function T(k) {
    return k in O ? O[k] : "Unknown Status Code: ".concat(k);
  }
  function y(k) {
    return (0, u.default)(k) === "object" && k !== null && !(k instanceof Array) && !(k instanceof Date);
  }
  function V(k) {
    if (k) {
      if (y(k)) {
        if (Object.prototype.hasOwnProperty.call(k, "statusCode"))
          return {
            return_code: k.statusCode,
            error_message: T(k.statusCode)
          };
        if (Object.prototype.hasOwnProperty.call(k, "return_code") && Object.prototype.hasOwnProperty.call(k, "error_message"))
          return k;
      }
      return {
        return_code: 65535,
        error_message: k.toString()
      };
    }
    return {
      return_code: 65535,
      error_message: k.toString()
    };
  }
  function M(k) {
    return G.apply(this, arguments);
  }
  function G() {
    return G = (0, o.default)(/* @__PURE__ */ n.default.mark(function k(F) {
      return n.default.wrap(function(ee) {
        for (; ; )
          switch (ee.prev = ee.next) {
            case 0:
              return ee.abrupt("return", F.send(c, v.GET_VERSION, 0, 0).then(function(ue) {
                var Q = ue.slice(-2), Y = Q[0] * 256 + Q[1], pe = 0;
                return ue.length >= 9 && (pe = (ue[5] << 24) + (ue[6] << 16) + (ue[7] << 8) + (ue[8] << 0)), {
                  return_code: Y,
                  error_message: T(Y),
                  // ///
                  test_mode: ue[0] !== 0,
                  major: ue[1],
                  minor: ue[2],
                  patch: ue[3],
                  device_locked: ue[4] === 1,
                  target_id: pe.toString(16)
                };
              }, V));
            case 1:
            case "end":
              return ee.stop();
          }
      }, k);
    })), G.apply(this, arguments);
  }
  return common$1;
}
var hasRequiredHelperV1;
function requireHelperV1() {
  if (hasRequiredHelperV1)
    return helperV1;
  hasRequiredHelperV1 = 1;
  var e = interopRequireDefaultExports;
  Object.defineProperty(helperV1, "__esModule", {
    value: !0
  }), helperV1.serializePathv1 = c, helperV1.signSendChunkv1 = d, helperV1.publicKeyv1 = S;
  var n = e(requireRegenerator()), o = e(requireAsyncToGenerator()), u = requireCommon();
  function c(E) {
    if (E == null || E.length < 3)
      throw new Error("Invalid path.");
    if (E.length > 10)
      throw new Error("Invalid path. Length should be <= 10");
    var O = Buffer.alloc(1 + 4 * E.length);
    O.writeUInt8(E.length, 0);
    for (var T = 0; T < E.length; T += 1) {
      var y = E[T];
      T < 3 && (y |= 2147483648), O.writeInt32LE(y, 1 + T * 4);
    }
    return O;
  }
  function d(E, O, T, y) {
    return m.apply(this, arguments);
  }
  function m() {
    return m = (0, o.default)(/* @__PURE__ */ n.default.mark(function E(O, T, y, V) {
      return n.default.wrap(function(G) {
        for (; ; )
          switch (G.prev = G.next) {
            case 0:
              return G.abrupt("return", O.transport.send(u.CLA, u.INS.SIGN_SECP256K1, T, y, V, [u.ERROR_CODE.NoError, 27012, 27264]).then(function(k) {
                var F = k.slice(-2), X = F[0] * 256 + F[1], ee = (0, u.errorCodeToString)(X);
                (X === 27264 || X === 27012) && (ee = "".concat(ee, " : ").concat(k.slice(0, k.length - 2).toString("ascii")));
                var ue = null;
                return k.length > 2 && (ue = k.slice(0, k.length - 2)), {
                  signature: ue,
                  return_code: X,
                  error_message: ee
                };
              }, u.processErrorResponse));
            case 1:
            case "end":
              return G.stop();
          }
      }, E);
    })), m.apply(this, arguments);
  }
  function v(E) {
    if (E.length !== 65)
      throw new Error("decompressed public key length should be 65 bytes");
    var O = E.slice(33, 65), T = Buffer.from([2 + (O[O.length - 1] & 1)]);
    return Buffer.concat([T, E.slice(1, 33)]);
  }
  function S(E, O) {
    return $.apply(this, arguments);
  }
  function $() {
    return $ = (0, o.default)(/* @__PURE__ */ n.default.mark(function E(O, T) {
      return n.default.wrap(function(V) {
        for (; ; )
          switch (V.prev = V.next) {
            case 0:
              return V.abrupt("return", O.transport.send(u.CLA, u.INS.INS_PUBLIC_KEY_SECP256K1, 0, 0, T, [u.ERROR_CODE.NoError]).then(function(M) {
                var G = M.slice(-2), k = G[0] * 256 + G[1], F = Buffer.from(M.slice(0, 65));
                return {
                  pk: F,
                  compressed_pk: v(F),
                  return_code: k,
                  error_message: (0, u.errorCodeToString)(k)
                };
              }, u.processErrorResponse));
            case 1:
            case "end":
              return V.stop();
          }
      }, E);
    })), $.apply(this, arguments);
  }
  return helperV1;
}
var helperV2 = {}, hasRequiredHelperV2;
function requireHelperV2() {
  if (hasRequiredHelperV2)
    return helperV2;
  hasRequiredHelperV2 = 1;
  var e = interopRequireDefaultExports;
  Object.defineProperty(helperV2, "__esModule", {
    value: !0
  }), helperV2.serializePathv2 = d, helperV2.signSendChunkv2 = m, helperV2.publicKeyv2 = S;
  var n = e(requireRegenerator()), o = e(requireAsyncToGenerator()), u = requireHelperV1(), c = requireCommon();
  function d(E) {
    if (!E || E.length !== 5)
      throw new Error("Invalid path.");
    var O = Buffer.alloc(20);
    return O.writeUInt32LE(2147483648 + E[0], 0), O.writeUInt32LE(2147483648 + E[1], 4), O.writeUInt32LE(2147483648 + E[2], 8), O.writeUInt32LE(E[3], 12), O.writeUInt32LE(E[4], 16), O;
  }
  function m(E, O, T, y) {
    return v.apply(this, arguments);
  }
  function v() {
    return v = (0, o.default)(/* @__PURE__ */ n.default.mark(function E(O, T, y, V) {
      var M;
      return n.default.wrap(function(k) {
        for (; ; )
          switch (k.prev = k.next) {
            case 0:
              return M = c.PAYLOAD_TYPE.ADD, T === 1 && (M = c.PAYLOAD_TYPE.INIT), T === y && (M = c.PAYLOAD_TYPE.LAST), k.abrupt("return", (0, u.signSendChunkv1)(O, M, 0, V));
            case 4:
            case "end":
              return k.stop();
          }
      }, E);
    })), v.apply(this, arguments);
  }
  function S(E, O) {
    return $.apply(this, arguments);
  }
  function $() {
    return $ = (0, o.default)(/* @__PURE__ */ n.default.mark(function E(O, T) {
      return n.default.wrap(function(V) {
        for (; ; )
          switch (V.prev = V.next) {
            case 0:
              return V.abrupt("return", O.transport.send(c.CLA, c.INS.GET_ADDR_SECP256K1, 0, 0, T, [c.ERROR_CODE.NoError]).then(function(M) {
                var G = M.slice(-2), k = G[0] * 256 + G[1], F = Buffer.from(M.slice(0, 33));
                return {
                  pk: "OBSOLETE PROPERTY",
                  compressed_pk: F,
                  return_code: k,
                  error_message: (0, c.errorCodeToString)(k)
                };
              }, c.processErrorResponse));
            case 1:
            case "end":
              return V.stop();
          }
      }, E);
    })), $.apply(this, arguments);
  }
  return helperV2;
}
var _interopRequireDefault = interopRequireDefaultExports;
Object.defineProperty(dist$5, "__esModule", {
  value: !0
});
dist$5.default = void 0;
var _regenerator = _interopRequireDefault(requireRegenerator()), _asyncToGenerator2 = _interopRequireDefault(requireAsyncToGenerator()), _classCallCheck2 = _interopRequireDefault(requireClassCallCheck()), _createClass2 = _interopRequireDefault(requireCreateClass()), _crypto = _interopRequireDefault(requireCryptoBrowserify()), _ripemd = _interopRequireDefault(requireRipemd160()), _bech = _interopRequireDefault(bech32$f), _helperV = requireHelperV1(), _helperV2 = requireHelperV2(), _common = requireCommon(), CosmosApp = /* @__PURE__ */ function() {
  function e(n) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _common.APP_KEY;
    if ((0, _classCallCheck2.default)(this, e), !n)
      throw new Error("Transport has not been defined");
    this.transport = n, n.decorateAppAPIMethods(this, ["getVersion", "sign", "getAddressAndPubKey", "appInfo", "deviceInfo", "getBech32FromPK"], o);
  }
  return (0, _createClass2.default)(e, [{
    key: "serializePath",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u(c) {
        return _regenerator.default.wrap(function(m) {
          for (; ; )
            switch (m.prev = m.next) {
              case 0:
                return m.next = 2, (0, _common.getVersion)(this.transport);
              case 2:
                if (this.versionResponse = m.sent, this.versionResponse.return_code === _common.ERROR_CODE.NoError) {
                  m.next = 5;
                  break;
                }
                throw this.versionResponse;
              case 5:
                m.t0 = this.versionResponse.major, m.next = m.t0 === 1 ? 8 : m.t0 === 2 ? 9 : 10;
                break;
              case 8:
                return m.abrupt("return", (0, _helperV.serializePathv1)(c));
              case 9:
                return m.abrupt("return", (0, _helperV2.serializePathv2)(c));
              case 10:
                return m.abrupt("return", {
                  return_code: 25600,
                  error_message: "App Version is not supported"
                });
              case 11:
              case "end":
                return m.stop();
            }
        }, u, this);
      }));
      function o(u) {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "signGetChunks",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u(c, d) {
        var m, v, S, $, E;
        return _regenerator.default.wrap(function(T) {
          for (; ; )
            switch (T.prev = T.next) {
              case 0:
                return T.next = 2, this.serializePath(c);
              case 2:
                for (m = T.sent, v = [], v.push(m), S = Buffer.from(d), $ = 0; $ < S.length; $ += _common.CHUNK_SIZE)
                  E = $ + _common.CHUNK_SIZE, $ > S.length && (E = S.length), v.push(S.slice($, E));
                return T.abrupt("return", v);
              case 8:
              case "end":
                return T.stop();
            }
        }, u, this);
      }));
      function o(u, c) {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "getVersion",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u() {
        return _regenerator.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                return d.prev = 0, d.next = 3, (0, _common.getVersion)(this.transport);
              case 3:
                return this.versionResponse = d.sent, d.abrupt("return", this.versionResponse);
              case 7:
                return d.prev = 7, d.t0 = d.catch(0), d.abrupt("return", (0, _common.processErrorResponse)(d.t0));
              case 10:
              case "end":
                return d.stop();
            }
        }, u, this, [[0, 7]]);
      }));
      function o() {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "appInfo",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u() {
        return _regenerator.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                return d.abrupt("return", this.transport.send(176, 1, 0, 0).then(function(m) {
                  var v = m.slice(-2), S = v[0] * 256 + v[1], $ = "err", E = "err", O = 0, T = 0;
                  if (m[0] === 1) {
                    var y = m[1];
                    $ = m.slice(2, 2 + y).toString("ascii");
                    var V = 2 + y, M = m[V];
                    V += 1, E = m.slice(V, V + M).toString("ascii"), V += M;
                    var G = m[V];
                    V += 1, O = G, T = m[V];
                  }
                  return {
                    return_code: S,
                    error_message: (0, _common.errorCodeToString)(S),
                    // //
                    appName: $,
                    appVersion: E,
                    flagLen: O,
                    flagsValue: T,
                    // eslint-disable-next-line no-bitwise
                    flag_recovery: (T & 1) !== 0,
                    // eslint-disable-next-line no-bitwise
                    flag_signed_mcu_code: (T & 2) !== 0,
                    // eslint-disable-next-line no-bitwise
                    flag_onboarded: (T & 4) !== 0,
                    // eslint-disable-next-line no-bitwise
                    flag_pin_validated: (T & 128) !== 0
                  };
                }, _common.processErrorResponse));
              case 1:
              case "end":
                return d.stop();
            }
        }, u, this);
      }));
      function o() {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "deviceInfo",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u() {
        return _regenerator.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                return d.abrupt("return", this.transport.send(224, 1, 0, 0, Buffer.from([]), [_common.ERROR_CODE.NoError, 28160]).then(function(m) {
                  var v = m.slice(-2), S = v[0] * 256 + v[1];
                  if (S === 28160)
                    return {
                      return_code: S,
                      error_message: "This command is only available in the Dashboard"
                    };
                  var $ = m.slice(0, 4).toString("hex"), E = 4, O = m[E];
                  E += 1;
                  var T = m.slice(E, E + O).toString();
                  E += O;
                  var y = m[E];
                  E += 1;
                  var V = m.slice(E, E + y).toString("hex");
                  E += y;
                  var M = m[E];
                  E += 1;
                  var G = m.slice(E, E + M);
                  G[M - 1] === 0 && (G = m.slice(E, E + M - 1));
                  var k = G.toString();
                  return {
                    return_code: S,
                    error_message: (0, _common.errorCodeToString)(S),
                    // //
                    targetId: $,
                    seVersion: T,
                    flag: V,
                    mcuVersion: k
                  };
                }, _common.processErrorResponse));
              case 1:
              case "end":
                return d.stop();
            }
        }, u, this);
      }));
      function o() {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "publicKey",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u(c) {
        var d, m;
        return _regenerator.default.wrap(function(S) {
          for (; ; )
            switch (S.prev = S.next) {
              case 0:
                return S.prev = 0, S.next = 3, this.serializePath(c);
              case 3:
                d = S.sent, S.t0 = this.versionResponse.major, S.next = S.t0 === 1 ? 7 : S.t0 === 2 ? 8 : 10;
                break;
              case 7:
                return S.abrupt("return", (0, _helperV.publicKeyv1)(this, d));
              case 8:
                return m = Buffer.concat([e.serializeHRP("cosmos"), d]), S.abrupt("return", (0, _helperV2.publicKeyv2)(this, m));
              case 10:
                return S.abrupt("return", {
                  return_code: 25600,
                  error_message: "App Version is not supported"
                });
              case 11:
                S.next = 16;
                break;
              case 13:
                return S.prev = 13, S.t1 = S.catch(0), S.abrupt("return", (0, _common.processErrorResponse)(S.t1));
              case 16:
              case "end":
                return S.stop();
            }
        }, u, this, [[0, 13]]);
      }));
      function o(u) {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "getAddressAndPubKey",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u(c, d) {
        var m = this;
        return _regenerator.default.wrap(function(S) {
          for (; ; )
            switch (S.prev = S.next) {
              case 0:
                return S.prev = 0, S.abrupt("return", this.serializePath(c).then(function($) {
                  var E = Buffer.concat([e.serializeHRP(d), $]);
                  return m.transport.send(_common.CLA, _common.INS.GET_ADDR_SECP256K1, _common.P1_VALUES.ONLY_RETRIEVE, 0, E, [_common.ERROR_CODE.NoError]).then(function(O) {
                    var T = O.slice(-2), y = T[0] * 256 + T[1], V = Buffer.from(O.slice(0, 33)), M = Buffer.from(O.slice(33, -2)).toString();
                    return {
                      bech32_address: M,
                      compressed_pk: V,
                      return_code: y,
                      error_message: (0, _common.errorCodeToString)(y)
                    };
                  }, _common.processErrorResponse);
                }).catch(function($) {
                  return (0, _common.processErrorResponse)($);
                }));
              case 4:
                return S.prev = 4, S.t0 = S.catch(0), S.abrupt("return", (0, _common.processErrorResponse)(S.t0));
              case 7:
              case "end":
                return S.stop();
            }
        }, u, this, [[0, 4]]);
      }));
      function o(u, c) {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "showAddressAndPubKey",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u(c, d) {
        var m = this;
        return _regenerator.default.wrap(function(S) {
          for (; ; )
            switch (S.prev = S.next) {
              case 0:
                return S.prev = 0, S.abrupt("return", this.serializePath(c).then(function($) {
                  var E = Buffer.concat([e.serializeHRP(d), $]);
                  return m.transport.send(_common.CLA, _common.INS.GET_ADDR_SECP256K1, _common.P1_VALUES.SHOW_ADDRESS_IN_DEVICE, 0, E, [_common.ERROR_CODE.NoError]).then(function(O) {
                    var T = O.slice(-2), y = T[0] * 256 + T[1], V = Buffer.from(O.slice(0, 33)), M = Buffer.from(O.slice(33, -2)).toString();
                    return {
                      bech32_address: M,
                      compressed_pk: V,
                      return_code: y,
                      error_message: (0, _common.errorCodeToString)(y)
                    };
                  }, _common.processErrorResponse);
                }).catch(function($) {
                  return (0, _common.processErrorResponse)($);
                }));
              case 4:
                return S.prev = 4, S.t0 = S.catch(0), S.abrupt("return", (0, _common.processErrorResponse)(S.t0));
              case 7:
              case "end":
                return S.stop();
            }
        }, u, this, [[0, 4]]);
      }));
      function o(u, c) {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "signSendChunk",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u(c, d, m) {
        return _regenerator.default.wrap(function(S) {
          for (; ; )
            switch (S.prev = S.next) {
              case 0:
                S.t0 = this.versionResponse.major, S.next = S.t0 === 1 ? 3 : S.t0 === 2 ? 4 : 5;
                break;
              case 3:
                return S.abrupt("return", (0, _helperV.signSendChunkv1)(this, c, d, m));
              case 4:
                return S.abrupt("return", (0, _helperV2.signSendChunkv2)(this, c, d, m));
              case 5:
                return S.abrupt("return", {
                  return_code: 25600,
                  error_message: "App Version is not supported"
                });
              case 6:
              case "end":
                return S.stop();
            }
        }, u, this);
      }));
      function o(u, c, d) {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }, {
    key: "sign",
    value: function() {
      var n = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function u(c, d) {
        var m = this;
        return _regenerator.default.wrap(function(S) {
          for (; ; )
            switch (S.prev = S.next) {
              case 0:
                return S.abrupt("return", this.signGetChunks(c, d).then(function($) {
                  return m.signSendChunk(1, $.length, $[0], [_common.ERROR_CODE.NoError]).then(/* @__PURE__ */ function() {
                    var E = (0, _asyncToGenerator2.default)(/* @__PURE__ */ _regenerator.default.mark(function O(T) {
                      var y, V;
                      return _regenerator.default.wrap(function(G) {
                        for (; ; )
                          switch (G.prev = G.next) {
                            case 0:
                              y = {
                                return_code: T.return_code,
                                error_message: T.error_message,
                                signature: null
                              }, V = 1;
                            case 2:
                              if (!(V < $.length)) {
                                G.next = 11;
                                break;
                              }
                              return G.next = 5, m.signSendChunk(1 + V, $.length, $[V]);
                            case 5:
                              if (y = G.sent, y.return_code === _common.ERROR_CODE.NoError) {
                                G.next = 8;
                                break;
                              }
                              return G.abrupt("break", 11);
                            case 8:
                              V += 1, G.next = 2;
                              break;
                            case 11:
                              return G.abrupt("return", {
                                return_code: y.return_code,
                                error_message: y.error_message,
                                // ///
                                signature: y.signature
                              });
                            case 12:
                            case "end":
                              return G.stop();
                          }
                      }, O);
                    }));
                    return function(O) {
                      return E.apply(this, arguments);
                    };
                  }(), _common.processErrorResponse);
                }, _common.processErrorResponse));
              case 1:
              case "end":
                return S.stop();
            }
        }, u, this);
      }));
      function o(u, c) {
        return n.apply(this, arguments);
      }
      return o;
    }()
  }], [{
    key: "serializeHRP",
    value: function(o) {
      if (o == null || o.length < 3 || o.length > 83)
        throw new Error("Invalid HRP");
      var u = Buffer.alloc(1 + o.length);
      return u.writeUInt8(o.length, 0), u.write(o, 1), u;
    }
  }, {
    key: "getBech32FromPK",
    value: function(o, u) {
      if (u.length !== 33)
        throw new Error("expected compressed public key [31 bytes]");
      var c = _crypto.default.createHash("sha256").update(u).digest(), d = new _ripemd.default().update(c).digest();
      return _bech.default.encode(o, _bech.default.toWords(d));
    }
  }]), e;
}();
dist$5.default = CosmosApp;
var re$2 = { exports: {} };
const SEMVER_SPEC_VERSION = "2.0.0", MAX_LENGTH$1 = 256, MAX_SAFE_INTEGER$2 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, MAX_SAFE_COMPONENT_LENGTH = 16, MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6, RELEASE_TYPES = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants$1 = {
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_COMPONENT_LENGTH,
  MAX_SAFE_BUILD_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$2,
  RELEASE_TYPES,
  SEMVER_SPEC_VERSION,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const debug$1 = typeof browser$1$1 == "object" && browser$1$1.env && browser$1$1.env.NODE_DEBUG && /\bsemver\b/i.test(browser$1$1.env.NODE_DEBUG) ? (...e) => console.error("SEMVER", ...e) : () => {
};
var debug_1 = debug$1;
(function(e, n) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: o,
    MAX_SAFE_BUILD_LENGTH: u,
    MAX_LENGTH: c
  } = constants$1, d = debug_1;
  n = e.exports = {};
  const m = n.re = [], v = n.safeRe = [], S = n.src = [], $ = n.t = {};
  let E = 0;
  const O = "[a-zA-Z0-9-]", T = [
    ["\\s", 1],
    ["\\d", c],
    [O, u]
  ], y = (M) => {
    for (const [G, k] of T)
      M = M.split(`${G}*`).join(`${G}{0,${k}}`).split(`${G}+`).join(`${G}{1,${k}}`);
    return M;
  }, V = (M, G, k) => {
    const F = y(G), X = E++;
    d(M, X, G), $[M] = X, S[X] = G, m[X] = new RegExp(G, k ? "g" : void 0), v[X] = new RegExp(F, k ? "g" : void 0);
  };
  V("NUMERICIDENTIFIER", "0|[1-9]\\d*"), V("NUMERICIDENTIFIERLOOSE", "\\d+"), V("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${O}*`), V("MAINVERSION", `(${S[$.NUMERICIDENTIFIER]})\\.(${S[$.NUMERICIDENTIFIER]})\\.(${S[$.NUMERICIDENTIFIER]})`), V("MAINVERSIONLOOSE", `(${S[$.NUMERICIDENTIFIERLOOSE]})\\.(${S[$.NUMERICIDENTIFIERLOOSE]})\\.(${S[$.NUMERICIDENTIFIERLOOSE]})`), V("PRERELEASEIDENTIFIER", `(?:${S[$.NUMERICIDENTIFIER]}|${S[$.NONNUMERICIDENTIFIER]})`), V("PRERELEASEIDENTIFIERLOOSE", `(?:${S[$.NUMERICIDENTIFIERLOOSE]}|${S[$.NONNUMERICIDENTIFIER]})`), V("PRERELEASE", `(?:-(${S[$.PRERELEASEIDENTIFIER]}(?:\\.${S[$.PRERELEASEIDENTIFIER]})*))`), V("PRERELEASELOOSE", `(?:-?(${S[$.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${S[$.PRERELEASEIDENTIFIERLOOSE]})*))`), V("BUILDIDENTIFIER", `${O}+`), V("BUILD", `(?:\\+(${S[$.BUILDIDENTIFIER]}(?:\\.${S[$.BUILDIDENTIFIER]})*))`), V("FULLPLAIN", `v?${S[$.MAINVERSION]}${S[$.PRERELEASE]}?${S[$.BUILD]}?`), V("FULL", `^${S[$.FULLPLAIN]}$`), V("LOOSEPLAIN", `[v=\\s]*${S[$.MAINVERSIONLOOSE]}${S[$.PRERELEASELOOSE]}?${S[$.BUILD]}?`), V("LOOSE", `^${S[$.LOOSEPLAIN]}$`), V("GTLT", "((?:<|>)?=?)"), V("XRANGEIDENTIFIERLOOSE", `${S[$.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), V("XRANGEIDENTIFIER", `${S[$.NUMERICIDENTIFIER]}|x|X|\\*`), V("XRANGEPLAIN", `[v=\\s]*(${S[$.XRANGEIDENTIFIER]})(?:\\.(${S[$.XRANGEIDENTIFIER]})(?:\\.(${S[$.XRANGEIDENTIFIER]})(?:${S[$.PRERELEASE]})?${S[$.BUILD]}?)?)?`), V("XRANGEPLAINLOOSE", `[v=\\s]*(${S[$.XRANGEIDENTIFIERLOOSE]})(?:\\.(${S[$.XRANGEIDENTIFIERLOOSE]})(?:\\.(${S[$.XRANGEIDENTIFIERLOOSE]})(?:${S[$.PRERELEASELOOSE]})?${S[$.BUILD]}?)?)?`), V("XRANGE", `^${S[$.GTLT]}\\s*${S[$.XRANGEPLAIN]}$`), V("XRANGELOOSE", `^${S[$.GTLT]}\\s*${S[$.XRANGEPLAINLOOSE]}$`), V("COERCE", `(^|[^\\d])(\\d{1,${o}})(?:\\.(\\d{1,${o}}))?(?:\\.(\\d{1,${o}}))?(?:$|[^\\d])`), V("COERCERTL", S[$.COERCE], !0), V("LONETILDE", "(?:~>?)"), V("TILDETRIM", `(\\s*)${S[$.LONETILDE]}\\s+`, !0), n.tildeTrimReplace = "$1~", V("TILDE", `^${S[$.LONETILDE]}${S[$.XRANGEPLAIN]}$`), V("TILDELOOSE", `^${S[$.LONETILDE]}${S[$.XRANGEPLAINLOOSE]}$`), V("LONECARET", "(?:\\^)"), V("CARETTRIM", `(\\s*)${S[$.LONECARET]}\\s+`, !0), n.caretTrimReplace = "$1^", V("CARET", `^${S[$.LONECARET]}${S[$.XRANGEPLAIN]}$`), V("CARETLOOSE", `^${S[$.LONECARET]}${S[$.XRANGEPLAINLOOSE]}$`), V("COMPARATORLOOSE", `^${S[$.GTLT]}\\s*(${S[$.LOOSEPLAIN]})$|^$`), V("COMPARATOR", `^${S[$.GTLT]}\\s*(${S[$.FULLPLAIN]})$|^$`), V("COMPARATORTRIM", `(\\s*)${S[$.GTLT]}\\s*(${S[$.LOOSEPLAIN]}|${S[$.XRANGEPLAIN]})`, !0), n.comparatorTrimReplace = "$1$2$3", V("HYPHENRANGE", `^\\s*(${S[$.XRANGEPLAIN]})\\s+-\\s+(${S[$.XRANGEPLAIN]})\\s*$`), V("HYPHENRANGELOOSE", `^\\s*(${S[$.XRANGEPLAINLOOSE]})\\s+-\\s+(${S[$.XRANGEPLAINLOOSE]})\\s*$`), V("STAR", "(<|>)?=?\\s*\\*"), V("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), V("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$2, re$2.exports);
var reExports = re$2.exports;
const looseOption = Object.freeze({ loose: !0 }), emptyOpts = Object.freeze({}), parseOptions$1 = (e) => e ? typeof e != "object" ? looseOption : e : emptyOpts;
var parseOptions_1 = parseOptions$1;
const numeric = /^[0-9]+$/, compareIdentifiers$1 = (e, n) => {
  const o = numeric.test(e), u = numeric.test(n);
  return o && u && (e = +e, n = +n), e === n ? 0 : o && !u ? -1 : u && !o ? 1 : e < n ? -1 : 1;
}, rcompareIdentifiers = (e, n) => compareIdentifiers$1(n, e);
var identifiers$1 = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug = debug_1, { MAX_LENGTH, MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1 } = constants$1, { safeRe: re$1, t: t$1 } = reExports, parseOptions = parseOptions_1, { compareIdentifiers } = identifiers$1;
let SemVer$d = class Sa {
  constructor(n, o) {
    if (o = parseOptions(o), n instanceof Sa) {
      if (n.loose === !!o.loose && n.includePrerelease === !!o.includePrerelease)
        return n;
      n = n.version;
    } else if (typeof n != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof n}".`);
    if (n.length > MAX_LENGTH)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    debug("SemVer", n, o), this.options = o, this.loose = !!o.loose, this.includePrerelease = !!o.includePrerelease;
    const u = n.trim().match(o.loose ? re$1[t$1.LOOSE] : re$1[t$1.FULL]);
    if (!u)
      throw new TypeError(`Invalid Version: ${n}`);
    if (this.raw = n, this.major = +u[1], this.minor = +u[2], this.patch = +u[3], this.major > MAX_SAFE_INTEGER$1 || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER$1 || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER$1 || this.patch < 0)
      throw new TypeError("Invalid patch version");
    u[4] ? this.prerelease = u[4].split(".").map((c) => {
      if (/^[0-9]+$/.test(c)) {
        const d = +c;
        if (d >= 0 && d < MAX_SAFE_INTEGER$1)
          return d;
      }
      return c;
    }) : this.prerelease = [], this.build = u[5] ? u[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(n) {
    if (debug("SemVer.compare", this.version, this.options, n), !(n instanceof Sa)) {
      if (typeof n == "string" && n === this.version)
        return 0;
      n = new Sa(n, this.options);
    }
    return n.version === this.version ? 0 : this.compareMain(n) || this.comparePre(n);
  }
  compareMain(n) {
    return n instanceof Sa || (n = new Sa(n, this.options)), compareIdentifiers(this.major, n.major) || compareIdentifiers(this.minor, n.minor) || compareIdentifiers(this.patch, n.patch);
  }
  comparePre(n) {
    if (n instanceof Sa || (n = new Sa(n, this.options)), this.prerelease.length && !n.prerelease.length)
      return -1;
    if (!this.prerelease.length && n.prerelease.length)
      return 1;
    if (!this.prerelease.length && !n.prerelease.length)
      return 0;
    let o = 0;
    do {
      const u = this.prerelease[o], c = n.prerelease[o];
      if (debug("prerelease compare", o, u, c), u === void 0 && c === void 0)
        return 0;
      if (c === void 0)
        return 1;
      if (u === void 0)
        return -1;
      if (u === c)
        continue;
      return compareIdentifiers(u, c);
    } while (++o);
  }
  compareBuild(n) {
    n instanceof Sa || (n = new Sa(n, this.options));
    let o = 0;
    do {
      const u = this.build[o], c = n.build[o];
      if (debug("prerelease compare", o, u, c), u === void 0 && c === void 0)
        return 0;
      if (c === void 0)
        return 1;
      if (u === void 0)
        return -1;
      if (u === c)
        continue;
      return compareIdentifiers(u, c);
    } while (++o);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(n, o, u) {
    switch (n) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", o, u);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", o, u);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", o, u), this.inc("pre", o, u);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", o, u), this.inc("pre", o, u);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const c = Number(u) ? 1 : 0;
        if (!o && u === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [c];
        else {
          let d = this.prerelease.length;
          for (; --d >= 0; )
            typeof this.prerelease[d] == "number" && (this.prerelease[d]++, d = -2);
          if (d === -1) {
            if (o === this.prerelease.join(".") && u === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(c);
          }
        }
        if (o) {
          let d = [o, c];
          u === !1 && (d = [o]), compareIdentifiers(this.prerelease[0], o) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = d) : this.prerelease = d;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${n}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
};
var semver$1 = SemVer$d;
const SemVer$c = semver$1, parse$7 = (e, n, o = !1) => {
  if (e instanceof SemVer$c)
    return e;
  try {
    return new SemVer$c(e, n);
  } catch (u) {
    if (!o)
      return null;
    throw u;
  }
};
var parse_1 = parse$7;
const parse$6 = parse_1, valid$2 = (e, n) => {
  const o = parse$6(e, n);
  return o ? o.version : null;
};
var valid_1 = valid$2;
const parse$5 = parse_1, clean$1 = (e, n) => {
  const o = parse$5(e.trim().replace(/^[=v]+/, ""), n);
  return o ? o.version : null;
};
var clean_1 = clean$1;
const SemVer$b = semver$1, inc$1 = (e, n, o, u, c) => {
  typeof o == "string" && (c = u, u = o, o = void 0);
  try {
    return new SemVer$b(
      e instanceof SemVer$b ? e.version : e,
      o
    ).inc(n, u, c).version;
  } catch {
    return null;
  }
};
var inc_1 = inc$1;
const parse$4 = parse_1, diff$1 = (e, n) => {
  const o = parse$4(e, null, !0), u = parse$4(n, null, !0), c = o.compare(u);
  if (c === 0)
    return null;
  const d = c > 0, m = d ? o : u, v = d ? u : o, S = !!m.prerelease.length;
  if (!!v.prerelease.length && !S)
    return !v.patch && !v.minor ? "major" : m.patch ? "patch" : m.minor ? "minor" : "major";
  const E = S ? "pre" : "";
  return o.major !== u.major ? E + "major" : o.minor !== u.minor ? E + "minor" : o.patch !== u.patch ? E + "patch" : "prerelease";
};
var diff_1 = diff$1;
const SemVer$a = semver$1, major$1 = (e, n) => new SemVer$a(e, n).major;
var major_1 = major$1;
const SemVer$9 = semver$1, minor$1 = (e, n) => new SemVer$9(e, n).minor;
var minor_1 = minor$1;
const SemVer$8 = semver$1, patch$1 = (e, n) => new SemVer$8(e, n).patch;
var patch_1 = patch$1;
const parse$3 = parse_1, prerelease$1 = (e, n) => {
  const o = parse$3(e, n);
  return o && o.prerelease.length ? o.prerelease : null;
};
var prerelease_1 = prerelease$1;
const SemVer$7 = semver$1, compare$c = (e, n, o) => new SemVer$7(e, o).compare(new SemVer$7(n, o));
var compare_1 = compare$c;
const compare$b = compare_1, rcompare$1 = (e, n, o) => compare$b(n, e, o);
var rcompare_1 = rcompare$1;
const compare$a = compare_1, compareLoose$1 = (e, n) => compare$a(e, n, !0);
var compareLoose_1 = compareLoose$1;
const SemVer$6 = semver$1, compareBuild$3 = (e, n, o) => {
  const u = new SemVer$6(e, o), c = new SemVer$6(n, o);
  return u.compare(c) || u.compareBuild(c);
};
var compareBuild_1 = compareBuild$3;
const compareBuild$2 = compareBuild_1, sort$1 = (e, n) => e.sort((o, u) => compareBuild$2(o, u, n));
var sort_1 = sort$1;
const compareBuild$1 = compareBuild_1, rsort$1 = (e, n) => e.sort((o, u) => compareBuild$1(u, o, n));
var rsort_1 = rsort$1;
const compare$9 = compare_1, gt$4 = (e, n, o) => compare$9(e, n, o) > 0;
var gt_1 = gt$4;
const compare$8 = compare_1, lt$3 = (e, n, o) => compare$8(e, n, o) < 0;
var lt_1 = lt$3;
const compare$7 = compare_1, eq$2 = (e, n, o) => compare$7(e, n, o) === 0;
var eq_1 = eq$2;
const compare$6 = compare_1, neq$2 = (e, n, o) => compare$6(e, n, o) !== 0;
var neq_1 = neq$2;
const compare$5 = compare_1, gte$3 = (e, n, o) => compare$5(e, n, o) >= 0;
var gte_1 = gte$3;
const compare$4 = compare_1, lte$3 = (e, n, o) => compare$4(e, n, o) <= 0;
var lte_1 = lte$3;
const eq$1 = eq_1, neq$1 = neq_1, gt$3 = gt_1, gte$2 = gte_1, lt$2 = lt_1, lte$2 = lte_1, cmp$1 = (e, n, o, u) => {
  switch (n) {
    case "===":
      return typeof e == "object" && (e = e.version), typeof o == "object" && (o = o.version), e === o;
    case "!==":
      return typeof e == "object" && (e = e.version), typeof o == "object" && (o = o.version), e !== o;
    case "":
    case "=":
    case "==":
      return eq$1(e, o, u);
    case "!=":
      return neq$1(e, o, u);
    case ">":
      return gt$3(e, o, u);
    case ">=":
      return gte$2(e, o, u);
    case "<":
      return lt$2(e, o, u);
    case "<=":
      return lte$2(e, o, u);
    default:
      throw new TypeError(`Invalid operator: ${n}`);
  }
};
var cmp_1 = cmp$1;
const SemVer$5 = semver$1, parse$2 = parse_1, { safeRe: re, t } = reExports, coerce$1 = (e, n) => {
  if (e instanceof SemVer$5)
    return e;
  if (typeof e == "number" && (e = String(e)), typeof e != "string")
    return null;
  n = n || {};
  let o = null;
  if (!n.rtl)
    o = e.match(re[t.COERCE]);
  else {
    let u;
    for (; (u = re[t.COERCERTL].exec(e)) && (!o || o.index + o[0].length !== e.length); )
      (!o || u.index + u[0].length !== o.index + o[0].length) && (o = u), re[t.COERCERTL].lastIndex = u.index + u[1].length + u[2].length;
    re[t.COERCERTL].lastIndex = -1;
  }
  return o === null ? null : parse$2(`${o[2]}.${o[3] || "0"}.${o[4] || "0"}`, n);
};
var coerce_1 = coerce$1, range, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange)
    return range;
  hasRequiredRange = 1;
  class e {
    constructor(P, J) {
      if (J = u(J), P instanceof e)
        return P.loose === !!J.loose && P.includePrerelease === !!J.includePrerelease ? P : new e(P.raw, J);
      if (P instanceof c)
        return this.raw = P.value, this.set = [[P]], this.format(), this;
      if (this.options = J, this.loose = !!J.loose, this.includePrerelease = !!J.includePrerelease, this.raw = P.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map((se) => this.parseRange(se.trim())).filter((se) => se.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const se = this.set[0];
        if (this.set = this.set.filter((fe) => !V(fe[0])), this.set.length === 0)
          this.set = [se];
        else if (this.set.length > 1) {
          for (const fe of this.set)
            if (fe.length === 1 && M(fe[0])) {
              this.set = [fe];
              break;
            }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((P) => P.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(P) {
      const se = ((this.options.includePrerelease && T) | (this.options.loose && y)) + ":" + P, fe = o.get(se);
      if (fe)
        return fe;
      const N = this.options.loose, W = N ? v[S.HYPHENRANGELOOSE] : v[S.HYPHENRANGE];
      P = P.replace(W, H(this.options.includePrerelease)), d("hyphen replace", P), P = P.replace(v[S.COMPARATORTRIM], $), d("comparator trim", P), P = P.replace(v[S.TILDETRIM], E), d("tilde trim", P), P = P.replace(v[S.CARETTRIM], O), d("caret trim", P);
      let I = P.split(" ").map((Ke) => k(Ke, this.options)).join(" ").split(/\s+/).map((Ke) => ne(Ke, this.options));
      N && (I = I.filter((Ke) => (d("loose invalid filter", Ke, this.options), !!Ke.match(v[S.COMPARATORLOOSE])))), d("range list", I);
      const te = /* @__PURE__ */ new Map(), ge = I.map((Ke) => new c(Ke, this.options));
      for (const Ke of ge) {
        if (V(Ke))
          return [Ke];
        te.set(Ke.value, Ke);
      }
      te.size > 1 && te.has("") && te.delete("");
      const Pe = [...te.values()];
      return o.set(se, Pe), Pe;
    }
    intersects(P, J) {
      if (!(P instanceof e))
        throw new TypeError("a Range is required");
      return this.set.some((se) => G(se, J) && P.set.some((fe) => G(fe, J) && se.every((N) => fe.every((W) => N.intersects(W, J)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(P) {
      if (!P)
        return !1;
      if (typeof P == "string")
        try {
          P = new m(P, this.options);
        } catch {
          return !1;
        }
      for (let J = 0; J < this.set.length; J++)
        if (C(this.set[J], P, this.options))
          return !0;
      return !1;
    }
  }
  range = e;
  const n = lruCache, o = new n({ max: 1e3 }), u = parseOptions_1, c = requireComparator(), d = debug_1, m = semver$1, {
    safeRe: v,
    t: S,
    comparatorTrimReplace: $,
    tildeTrimReplace: E,
    caretTrimReplace: O
  } = reExports, { FLAG_INCLUDE_PRERELEASE: T, FLAG_LOOSE: y } = constants$1, V = (w) => w.value === "<0.0.0-0", M = (w) => w.value === "", G = (w, P) => {
    let J = !0;
    const se = w.slice();
    let fe = se.pop();
    for (; J && se.length; )
      J = se.every((N) => fe.intersects(N, P)), fe = se.pop();
    return J;
  }, k = (w, P) => (d("comp", w, P), w = ue(w, P), d("caret", w), w = X(w, P), d("tildes", w), w = Y(w, P), d("xrange", w), w = oe(w, P), d("stars", w), w), F = (w) => !w || w.toLowerCase() === "x" || w === "*", X = (w, P) => w.trim().split(/\s+/).map((J) => ee(J, P)).join(" "), ee = (w, P) => {
    const J = P.loose ? v[S.TILDELOOSE] : v[S.TILDE];
    return w.replace(J, (se, fe, N, W, I) => {
      d("tilde", w, se, fe, N, W, I);
      let te;
      return F(fe) ? te = "" : F(N) ? te = `>=${fe}.0.0 <${+fe + 1}.0.0-0` : F(W) ? te = `>=${fe}.${N}.0 <${fe}.${+N + 1}.0-0` : I ? (d("replaceTilde pr", I), te = `>=${fe}.${N}.${W}-${I} <${fe}.${+N + 1}.0-0`) : te = `>=${fe}.${N}.${W} <${fe}.${+N + 1}.0-0`, d("tilde return", te), te;
    });
  }, ue = (w, P) => w.trim().split(/\s+/).map((J) => Q(J, P)).join(" "), Q = (w, P) => {
    d("caret", w, P);
    const J = P.loose ? v[S.CARETLOOSE] : v[S.CARET], se = P.includePrerelease ? "-0" : "";
    return w.replace(J, (fe, N, W, I, te) => {
      d("caret", w, fe, N, W, I, te);
      let ge;
      return F(N) ? ge = "" : F(W) ? ge = `>=${N}.0.0${se} <${+N + 1}.0.0-0` : F(I) ? N === "0" ? ge = `>=${N}.${W}.0${se} <${N}.${+W + 1}.0-0` : ge = `>=${N}.${W}.0${se} <${+N + 1}.0.0-0` : te ? (d("replaceCaret pr", te), N === "0" ? W === "0" ? ge = `>=${N}.${W}.${I}-${te} <${N}.${W}.${+I + 1}-0` : ge = `>=${N}.${W}.${I}-${te} <${N}.${+W + 1}.0-0` : ge = `>=${N}.${W}.${I}-${te} <${+N + 1}.0.0-0`) : (d("no pr"), N === "0" ? W === "0" ? ge = `>=${N}.${W}.${I}${se} <${N}.${W}.${+I + 1}-0` : ge = `>=${N}.${W}.${I}${se} <${N}.${+W + 1}.0-0` : ge = `>=${N}.${W}.${I} <${+N + 1}.0.0-0`), d("caret return", ge), ge;
    });
  }, Y = (w, P) => (d("replaceXRanges", w, P), w.split(/\s+/).map((J) => pe(J, P)).join(" ")), pe = (w, P) => {
    w = w.trim();
    const J = P.loose ? v[S.XRANGELOOSE] : v[S.XRANGE];
    return w.replace(J, (se, fe, N, W, I, te) => {
      d("xRange", w, se, fe, N, W, I, te);
      const ge = F(N), Pe = ge || F(W), Ke = Pe || F(I), xe = Ke;
      return fe === "=" && xe && (fe = ""), te = P.includePrerelease ? "-0" : "", ge ? fe === ">" || fe === "<" ? se = "<0.0.0-0" : se = "*" : fe && xe ? (Pe && (W = 0), I = 0, fe === ">" ? (fe = ">=", Pe ? (N = +N + 1, W = 0, I = 0) : (W = +W + 1, I = 0)) : fe === "<=" && (fe = "<", Pe ? N = +N + 1 : W = +W + 1), fe === "<" && (te = "-0"), se = `${fe + N}.${W}.${I}${te}`) : Pe ? se = `>=${N}.0.0${te} <${+N + 1}.0.0-0` : Ke && (se = `>=${N}.${W}.0${te} <${N}.${+W + 1}.0-0`), d("xRange return", se), se;
    });
  }, oe = (w, P) => (d("replaceStars", w, P), w.trim().replace(v[S.STAR], "")), ne = (w, P) => (d("replaceGTE0", w, P), w.trim().replace(v[P.includePrerelease ? S.GTE0PRE : S.GTE0], "")), H = (w) => (P, J, se, fe, N, W, I, te, ge, Pe, Ke, xe, ze) => (F(se) ? J = "" : F(fe) ? J = `>=${se}.0.0${w ? "-0" : ""}` : F(N) ? J = `>=${se}.${fe}.0${w ? "-0" : ""}` : W ? J = `>=${J}` : J = `>=${J}${w ? "-0" : ""}`, F(ge) ? te = "" : F(Pe) ? te = `<${+ge + 1}.0.0-0` : F(Ke) ? te = `<${ge}.${+Pe + 1}.0-0` : xe ? te = `<=${ge}.${Pe}.${Ke}-${xe}` : w ? te = `<${ge}.${Pe}.${+Ke + 1}-0` : te = `<=${te}`, `${J} ${te}`.trim()), C = (w, P, J) => {
    for (let se = 0; se < w.length; se++)
      if (!w[se].test(P))
        return !1;
    if (P.prerelease.length && !J.includePrerelease) {
      for (let se = 0; se < w.length; se++)
        if (d(w[se].semver), w[se].semver !== c.ANY && w[se].semver.prerelease.length > 0) {
          const fe = w[se].semver;
          if (fe.major === P.major && fe.minor === P.minor && fe.patch === P.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range;
}
var comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator)
    return comparator;
  hasRequiredComparator = 1;
  const e = Symbol("SemVer ANY");
  class n {
    static get ANY() {
      return e;
    }
    constructor(E, O) {
      if (O = o(O), E instanceof n) {
        if (E.loose === !!O.loose)
          return E;
        E = E.value;
      }
      E = E.trim().split(/\s+/).join(" "), m("comparator", E, O), this.options = O, this.loose = !!O.loose, this.parse(E), this.semver === e ? this.value = "" : this.value = this.operator + this.semver.version, m("comp", this);
    }
    parse(E) {
      const O = this.options.loose ? u[c.COMPARATORLOOSE] : u[c.COMPARATOR], T = E.match(O);
      if (!T)
        throw new TypeError(`Invalid comparator: ${E}`);
      this.operator = T[1] !== void 0 ? T[1] : "", this.operator === "=" && (this.operator = ""), T[2] ? this.semver = new v(T[2], this.options.loose) : this.semver = e;
    }
    toString() {
      return this.value;
    }
    test(E) {
      if (m("Comparator.test", E, this.options.loose), this.semver === e || E === e)
        return !0;
      if (typeof E == "string")
        try {
          E = new v(E, this.options);
        } catch {
          return !1;
        }
      return d(E, this.operator, this.semver, this.options);
    }
    intersects(E, O) {
      if (!(E instanceof n))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new S(E.value, O).test(this.value) : E.operator === "" ? E.value === "" ? !0 : new S(this.value, O).test(E.semver) : (O = o(O), O.includePrerelease && (this.value === "<0.0.0-0" || E.value === "<0.0.0-0") || !O.includePrerelease && (this.value.startsWith("<0.0.0") || E.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && E.operator.startsWith(">") || this.operator.startsWith("<") && E.operator.startsWith("<") || this.semver.version === E.semver.version && this.operator.includes("=") && E.operator.includes("=") || d(this.semver, "<", E.semver, O) && this.operator.startsWith(">") && E.operator.startsWith("<") || d(this.semver, ">", E.semver, O) && this.operator.startsWith("<") && E.operator.startsWith(">")));
    }
  }
  comparator = n;
  const o = parseOptions_1, { safeRe: u, t: c } = reExports, d = cmp_1, m = debug_1, v = semver$1, S = requireRange();
  return comparator;
}
const Range$9 = requireRange(), satisfies$4 = (e, n, o) => {
  try {
    n = new Range$9(n, o);
  } catch {
    return !1;
  }
  return n.test(e);
};
var satisfies_1 = satisfies$4;
const Range$8 = requireRange(), toComparators$1 = (e, n) => new Range$8(e, n).set.map((o) => o.map((u) => u.value).join(" ").trim().split(" "));
var toComparators_1 = toComparators$1;
const SemVer$4 = semver$1, Range$7 = requireRange(), maxSatisfying$1 = (e, n, o) => {
  let u = null, c = null, d = null;
  try {
    d = new Range$7(n, o);
  } catch {
    return null;
  }
  return e.forEach((m) => {
    d.test(m) && (!u || c.compare(m) === -1) && (u = m, c = new SemVer$4(u, o));
  }), u;
};
var maxSatisfying_1 = maxSatisfying$1;
const SemVer$3 = semver$1, Range$6 = requireRange(), minSatisfying$1 = (e, n, o) => {
  let u = null, c = null, d = null;
  try {
    d = new Range$6(n, o);
  } catch {
    return null;
  }
  return e.forEach((m) => {
    d.test(m) && (!u || c.compare(m) === 1) && (u = m, c = new SemVer$3(u, o));
  }), u;
};
var minSatisfying_1 = minSatisfying$1;
const SemVer$2 = semver$1, Range$5 = requireRange(), gt$2 = gt_1, minVersion$1 = (e, n) => {
  e = new Range$5(e, n);
  let o = new SemVer$2("0.0.0");
  if (e.test(o) || (o = new SemVer$2("0.0.0-0"), e.test(o)))
    return o;
  o = null;
  for (let u = 0; u < e.set.length; ++u) {
    const c = e.set[u];
    let d = null;
    c.forEach((m) => {
      const v = new SemVer$2(m.semver.version);
      switch (m.operator) {
        case ">":
          v.prerelease.length === 0 ? v.patch++ : v.prerelease.push(0), v.raw = v.format();
        case "":
        case ">=":
          (!d || gt$2(v, d)) && (d = v);
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${m.operator}`);
      }
    }), d && (!o || gt$2(o, d)) && (o = d);
  }
  return o && e.test(o) ? o : null;
};
var minVersion_1 = minVersion$1;
const Range$4 = requireRange(), validRange$1 = (e, n) => {
  try {
    return new Range$4(e, n).range || "*";
  } catch {
    return null;
  }
};
var valid$1 = validRange$1;
const SemVer$1 = semver$1, Comparator$2 = requireComparator(), { ANY: ANY$1 } = Comparator$2, Range$3 = requireRange(), satisfies$3 = satisfies_1, gt$1 = gt_1, lt$1 = lt_1, lte$1 = lte_1, gte$1 = gte_1, outside$3 = (e, n, o, u) => {
  e = new SemVer$1(e, u), n = new Range$3(n, u);
  let c, d, m, v, S;
  switch (o) {
    case ">":
      c = gt$1, d = lte$1, m = lt$1, v = ">", S = ">=";
      break;
    case "<":
      c = lt$1, d = gte$1, m = gt$1, v = "<", S = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (satisfies$3(e, n, u))
    return !1;
  for (let $ = 0; $ < n.set.length; ++$) {
    const E = n.set[$];
    let O = null, T = null;
    if (E.forEach((y) => {
      y.semver === ANY$1 && (y = new Comparator$2(">=0.0.0")), O = O || y, T = T || y, c(y.semver, O.semver, u) ? O = y : m(y.semver, T.semver, u) && (T = y);
    }), O.operator === v || O.operator === S || (!T.operator || T.operator === v) && d(e, T.semver))
      return !1;
    if (T.operator === S && m(e, T.semver))
      return !1;
  }
  return !0;
};
var outside_1 = outside$3;
const outside$2 = outside_1, gtr$1 = (e, n, o) => outside$2(e, n, ">", o);
var gtr_1 = gtr$1;
const outside$1 = outside_1, ltr$1 = (e, n, o) => outside$1(e, n, "<", o);
var ltr_1 = ltr$1;
const Range$2 = requireRange(), intersects$1 = (e, n, o) => (e = new Range$2(e, o), n = new Range$2(n, o), e.intersects(n, o));
var intersects_1 = intersects$1;
const satisfies$2 = satisfies_1, compare$3 = compare_1;
var simplify = (e, n, o) => {
  const u = [];
  let c = null, d = null;
  const m = e.sort((E, O) => compare$3(E, O, o));
  for (const E of m)
    satisfies$2(E, n, o) ? (d = E, c || (c = E)) : (d && u.push([c, d]), d = null, c = null);
  c && u.push([c, null]);
  const v = [];
  for (const [E, O] of u)
    E === O ? v.push(E) : !O && E === m[0] ? v.push("*") : O ? E === m[0] ? v.push(`<=${O}`) : v.push(`${E} - ${O}`) : v.push(`>=${E}`);
  const S = v.join(" || "), $ = typeof n.raw == "string" ? n.raw : String(n);
  return S.length < $.length ? S : n;
};
const Range$1 = requireRange(), Comparator$1 = requireComparator(), { ANY } = Comparator$1, satisfies$1 = satisfies_1, compare$2 = compare_1, subset$1 = (e, n, o = {}) => {
  if (e === n)
    return !0;
  e = new Range$1(e, o), n = new Range$1(n, o);
  let u = !1;
  e:
    for (const c of e.set) {
      for (const d of n.set) {
        const m = simpleSubset(c, d, o);
        if (u = u || m !== null, m)
          continue e;
      }
      if (u)
        return !1;
    }
  return !0;
}, minimumVersionWithPreRelease = [new Comparator$1(">=0.0.0-0")], minimumVersion = [new Comparator$1(">=0.0.0")], simpleSubset = (e, n, o) => {
  if (e === n)
    return !0;
  if (e.length === 1 && e[0].semver === ANY) {
    if (n.length === 1 && n[0].semver === ANY)
      return !0;
    o.includePrerelease ? e = minimumVersionWithPreRelease : e = minimumVersion;
  }
  if (n.length === 1 && n[0].semver === ANY) {
    if (o.includePrerelease)
      return !0;
    n = minimumVersion;
  }
  const u = /* @__PURE__ */ new Set();
  let c, d;
  for (const y of e)
    y.operator === ">" || y.operator === ">=" ? c = higherGT(c, y, o) : y.operator === "<" || y.operator === "<=" ? d = lowerLT(d, y, o) : u.add(y.semver);
  if (u.size > 1)
    return null;
  let m;
  if (c && d) {
    if (m = compare$2(c.semver, d.semver, o), m > 0)
      return null;
    if (m === 0 && (c.operator !== ">=" || d.operator !== "<="))
      return null;
  }
  for (const y of u) {
    if (c && !satisfies$1(y, String(c), o) || d && !satisfies$1(y, String(d), o))
      return null;
    for (const V of n)
      if (!satisfies$1(y, String(V), o))
        return !1;
    return !0;
  }
  let v, S, $, E, O = d && !o.includePrerelease && d.semver.prerelease.length ? d.semver : !1, T = c && !o.includePrerelease && c.semver.prerelease.length ? c.semver : !1;
  O && O.prerelease.length === 1 && d.operator === "<" && O.prerelease[0] === 0 && (O = !1);
  for (const y of n) {
    if (E = E || y.operator === ">" || y.operator === ">=", $ = $ || y.operator === "<" || y.operator === "<=", c) {
      if (T && y.semver.prerelease && y.semver.prerelease.length && y.semver.major === T.major && y.semver.minor === T.minor && y.semver.patch === T.patch && (T = !1), y.operator === ">" || y.operator === ">=") {
        if (v = higherGT(c, y, o), v === y && v !== c)
          return !1;
      } else if (c.operator === ">=" && !satisfies$1(c.semver, String(y), o))
        return !1;
    }
    if (d) {
      if (O && y.semver.prerelease && y.semver.prerelease.length && y.semver.major === O.major && y.semver.minor === O.minor && y.semver.patch === O.patch && (O = !1), y.operator === "<" || y.operator === "<=") {
        if (S = lowerLT(d, y, o), S === y && S !== d)
          return !1;
      } else if (d.operator === "<=" && !satisfies$1(d.semver, String(y), o))
        return !1;
    }
    if (!y.operator && (d || c) && m !== 0)
      return !1;
  }
  return !(c && $ && !d && m !== 0 || d && E && !c && m !== 0 || T || O);
}, higherGT = (e, n, o) => {
  if (!e)
    return n;
  const u = compare$2(e.semver, n.semver, o);
  return u > 0 ? e : u < 0 || n.operator === ">" && e.operator === ">=" ? n : e;
}, lowerLT = (e, n, o) => {
  if (!e)
    return n;
  const u = compare$2(e.semver, n.semver, o);
  return u < 0 ? e : u > 0 || n.operator === "<" && e.operator === "<=" ? n : e;
};
var subset_1 = subset$1;
const internalRe = reExports, constants = constants$1, SemVer = semver$1, identifiers = identifiers$1, parse$1 = parse_1, valid = valid_1, clean = clean_1, inc = inc_1, diff = diff_1, major = major_1, minor = minor_1, patch = patch_1, prerelease = prerelease_1, compare$1 = compare_1, rcompare = rcompare_1, compareLoose = compareLoose_1, compareBuild = compareBuild_1, sort = sort_1, rsort = rsort_1, gt = gt_1, lt = lt_1, eq = eq_1, neq = neq_1, gte = gte_1, lte = lte_1, cmp = cmp_1, coerce = coerce_1, Comparator = requireComparator(), Range = requireRange(), satisfies = satisfies_1, toComparators = toComparators_1, maxSatisfying = maxSatisfying_1, minSatisfying = minSatisfying_1, minVersion = minVersion_1, validRange = valid$1, outside = outside_1, gtr = gtr_1, ltr = ltr_1, intersects = intersects_1, simplifyRange = simplify, subset = subset_1;
var semver = {
  parse: parse$1,
  valid,
  clean,
  inc,
  diff,
  major,
  minor,
  patch,
  prerelease,
  compare: compare$1,
  rcompare,
  compareLoose,
  compareBuild,
  sort,
  rsort,
  gt,
  lt,
  eq,
  neq,
  gte,
  lte,
  cmp,
  coerce,
  Comparator,
  Range,
  satisfies,
  toComparators,
  maxSatisfying,
  minSatisfying,
  minVersion,
  validRange,
  outside,
  gtr,
  ltr,
  intersects,
  simplifyRange,
  subset,
  SemVer,
  re: internalRe.re,
  src: internalRe.src,
  tokens: internalRe.t,
  SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
  RELEASE_TYPES: constants.RELEASE_TYPES,
  compareIdentifiers: identifiers.compareIdentifiers,
  rcompareIdentifiers: identifiers.rcompareIdentifiers
}, __importDefault$h = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ledgerconnector, "__esModule", { value: !0 });
ledgerconnector.LedgerConnector = void 0;
const amino_1$6 = build$P, crypto_1$9 = build$e, encoding_1$n = build$d, utils_1$j = build$c, ledger_cosmos_js_1 = __importDefault$h(dist$5), semver_1 = __importDefault$h(semver);
function unharden(e) {
  return e.map((n) => n.isHardened() ? n.toNumber() - 2 ** 31 : n.toNumber());
}
const cosmosHdPath = (0, amino_1$6.makeCosmoshubPath)(0), cosmosBech32Prefix = "cosmos", cosmosLedgerAppName = "Cosmos", requiredCosmosAppVersion = "1.5.3";
class LedgerConnector {
  constructor(n, o = {}) {
    const u = {
      hdPaths: [cosmosHdPath],
      prefix: cosmosBech32Prefix,
      testModeAllowed: !1,
      ledgerAppName: cosmosLedgerAppName,
      requiredLedgerAppVersion: requiredCosmosAppVersion
    };
    this.testModeAllowed = o.testModeAllowed ?? u.testModeAllowed, this.hdPaths = o.hdPaths ?? u.hdPaths, this.prefix = o.prefix ?? u.prefix, this.ledgerAppName = o.ledgerAppName ?? u.ledgerAppName, this.minLedgerAppVersion = o.minLedgerAppVersion ?? u.requiredLedgerAppVersion, this.app = new ledger_cosmos_js_1.default(n);
  }
  async getCosmosAppVersion() {
    await this.verifyCosmosAppIsOpen(), (0, utils_1$j.assert)(this.app, `${this.ledgerAppName} Ledger App is not connected`);
    const n = await this.app.getVersion();
    this.handleLedgerErrors(n);
    const { major: o, minor: u, patch: c, test_mode: d } = n;
    return this.verifyAppMode(d), `${o}.${u}.${c}`;
  }
  async getPubkey(n) {
    await this.verifyDeviceIsReady(), (0, utils_1$j.assert)(this.app, `${this.ledgerAppName} Ledger App is not connected`);
    const o = n || this.hdPaths[0], u = await this.app.publicKey(unharden(o));
    return this.handleLedgerErrors(u), Uint8Array.from(u.compressed_pk);
  }
  async getPubkeys() {
    return this.hdPaths.reduce((n, o) => n.then(async (u) => [...u, await this.getPubkey(o)]), Promise.resolve([]));
  }
  async getCosmosAddress(n) {
    const o = n || await this.getPubkey();
    return (0, amino_1$6.pubkeyToAddress)((0, amino_1$6.encodeSecp256k1Pubkey)(o), this.prefix);
  }
  async sign(n, o) {
    await this.verifyDeviceIsReady(), (0, utils_1$j.assert)(this.app, `${this.ledgerAppName} Ledger App is not connected`);
    const u = o || this.hdPaths[0], c = await this.app.sign(unharden(u), (0, encoding_1$n.fromUtf8)(n));
    return this.handleLedgerErrors(c, "Transaction signing request was rejected by the user"), crypto_1$9.Secp256k1Signature.fromDer(c.signature).toFixedLength();
  }
  verifyAppMode(n) {
    if (n && !this.testModeAllowed)
      throw new Error(`DANGER: The ${this.ledgerAppName} Ledger app is in test mode and should not be used on mainnet!`);
  }
  async getOpenAppName() {
    (0, utils_1$j.assert)(this.app, `${this.ledgerAppName} Ledger App is not connected`);
    const n = await this.app.appInfo();
    return this.handleLedgerErrors(n), n.appName;
  }
  async verifyAppVersion() {
    const n = await this.getCosmosAppVersion();
    if (!semver_1.default.gte(n, this.minLedgerAppVersion))
      throw new Error(`Outdated version: Please update ${this.ledgerAppName} Ledger App to the latest version.`);
  }
  async verifyCosmosAppIsOpen() {
    const n = await this.getOpenAppName();
    if (n.toLowerCase() === "dashboard")
      throw new Error(`Please open the ${this.ledgerAppName} Ledger app on your Ledger device.`);
    if (n.toLowerCase() !== this.ledgerAppName.toLowerCase())
      throw new Error(`Please close ${n} and open the ${this.ledgerAppName} Ledger app on your Ledger device.`);
  }
  async verifyDeviceIsReady() {
    await this.verifyAppVersion(), await this.verifyCosmosAppIsOpen();
  }
  /**
   * Shows the user's address in the device and returns an address/pubkey pair.
   *
   * The address will be shown with the native prefix of the app (e.g. cosmos, persistence, desmos)
   * and does not support the usage of other address prefixes.
   *
   * @param path The HD path to show the address for. If unset, this is the first account.
   */
  async showAddress(n) {
    await this.verifyDeviceIsReady();
    const o = n || this.hdPaths[0], u = await this.app.showAddressAndPubKey(unharden(o), this.prefix);
    this.handleLedgerErrors(u);
    const { address: c, compressed_pk: d } = u;
    return {
      address: c,
      pubkey: (0, amino_1$6.encodeSecp256k1Pubkey)(d)
    };
  }
  handleLedgerErrors({ error_message: n = "No errors", device_locked: o = !1 }, u = "Request was rejected by the user") {
    if (o)
      throw new Error("Ledger’s screensaver mode is on");
    switch (n) {
      case "U2F: Timeout":
        throw new Error("Connection timed out. Please try again.");
      case "Cosmos app does not seem to be open":
        throw new Error(`${this.ledgerAppName} app is not open`);
      case "Command not allowed":
        throw new Error("Transaction rejected");
      case "Transaction rejected":
        throw new Error(u);
      case "Unknown Status Code: 26628":
        throw new Error("Ledger’s screensaver mode is on");
      case "Instruction not supported":
        throw new Error(`Your ${this.ledgerAppName} Ledger App is not up to date. Please update to version ${this.minLedgerAppVersion} or newer.`);
      case "No errors":
        break;
      default:
        throw new Error(`Ledger Native Error: ${n}`);
    }
  }
}
ledgerconnector.LedgerConnector = LedgerConnector;
var ledgersigner = {};
Object.defineProperty(ledgersigner, "__esModule", { value: !0 });
ledgersigner.LedgerSigner = void 0;
const amino_1$5 = build$P, ledgerconnector_1 = ledgerconnector;
class LedgerSigner {
  constructor(n, o = {}) {
    this.hdPaths = o.hdPaths || [(0, amino_1$5.makeCosmoshubPath)(0)], this.connector = new ledgerconnector_1.LedgerConnector(n, o);
  }
  async getAccounts() {
    if (!this.accounts) {
      const n = await this.connector.getPubkeys();
      this.accounts = await Promise.all(n.map(async (o) => ({
        algo: "secp256k1",
        address: await this.connector.getCosmosAddress(o),
        pubkey: o
      })));
    }
    return this.accounts;
  }
  /**
   * Shows the user's address in the device and returns an address/pubkey pair.
   *
   * The address will be shown with the native prefix of the app (e.g. cosmos, persistence, desmos)
   * and does not support the usage of other address prefixes.
   *
   * @param path The HD path to show the address for. If unset, this is the first account.
   */
  async showAddress(n) {
    return this.connector.showAddress(n);
  }
  async signAmino(n, o) {
    const u = this.accounts || await this.getAccounts(), c = u.findIndex(($) => $.address === n);
    if (c === -1)
      throw new Error(`Address ${n} not found in wallet`);
    const d = (0, amino_1$5.serializeSignDoc)(o), m = u[c], v = this.hdPaths[c], S = await this.connector.sign(d, v);
    return {
      signed: o,
      signature: (0, amino_1$5.encodeSecp256k1Signature)(m.pubkey, S)
    };
  }
}
ledgersigner.LedgerSigner = LedgerSigner;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.LedgerSigner = e.LedgerConnector = void 0;
  var n = ledgerconnector;
  Object.defineProperty(e, "LedgerConnector", { enumerable: !0, get: function() {
    return n.LedgerConnector;
  } });
  var o = ledgersigner;
  Object.defineProperty(e, "LedgerSigner", { enumerable: !0, get: function() {
    return o.LedgerSigner;
  } });
})(build$f);
var dist$4 = {}, msgCancelFeeSplit$2 = {}, dist$3 = {}, msgCancelFeeSplit$1 = {}, tx$a = {}, googleProtobuf = {};
(function(exports) {
  var $jscomp = $jscomp || {};
  $jscomp.scope = {}, $jscomp.findInternal = function(e, n, o) {
    e instanceof String && (e = String(e));
    for (var u = e.length, c = 0; c < u; c++) {
      var d = e[c];
      if (n.call(o, d, c, e))
        return { i: c, v: d };
    }
    return { i: -1, v: void 0 };
  }, $jscomp.ASSUME_ES5 = !1, $jscomp.ASSUME_NO_NATIVE_MAP = !1, $jscomp.ASSUME_NO_NATIVE_SET = !1, $jscomp.SIMPLE_FROUND_POLYFILL = !1, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(e, n, o) {
    e != Array.prototype && e != Object.prototype && (e[n] = o.value);
  }, $jscomp.getGlobal = function(e) {
    return typeof window < "u" && window === e ? e : typeof commonjsGlobal < "u" && commonjsGlobal != null ? commonjsGlobal : e;
  }, $jscomp.global = $jscomp.getGlobal(commonjsGlobal), $jscomp.polyfill = function(e, n, o, u) {
    if (n) {
      for (o = $jscomp.global, e = e.split("."), u = 0; u < e.length - 1; u++) {
        var c = e[u];
        c in o || (o[c] = {}), o = o[c];
      }
      e = e[e.length - 1], u = o[e], n = n(u), n != u && n != null && $jscomp.defineProperty(o, e, { configurable: !0, writable: !0, value: n });
    }
  }, $jscomp.polyfill("Array.prototype.findIndex", function(e) {
    return e || function(n, o) {
      return $jscomp.findInternal(this, n, o).i;
    };
  }, "es6", "es3"), $jscomp.checkStringArgs = function(e, n, o) {
    if (e == null)
      throw new TypeError("The 'this' value for String.prototype." + o + " must not be null or undefined");
    if (n instanceof RegExp)
      throw new TypeError("First argument to String.prototype." + o + " must not be a regular expression");
    return e + "";
  }, $jscomp.polyfill("String.prototype.endsWith", function(e) {
    return e || function(n, o) {
      var u = $jscomp.checkStringArgs(this, n, "endsWith");
      n += "", o === void 0 && (o = u.length), o = Math.max(0, Math.min(o | 0, u.length));
      for (var c = n.length; 0 < c && 0 < o; )
        if (u[--o] != n[--c])
          return !1;
      return 0 >= c;
    };
  }, "es6", "es3"), $jscomp.polyfill("Array.prototype.find", function(e) {
    return e || function(n, o) {
      return $jscomp.findInternal(this, n, o).v;
    };
  }, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function(e) {
    return e || function(n, o) {
      var u = $jscomp.checkStringArgs(this, n, "startsWith");
      n += "";
      var c = u.length, d = n.length;
      o = Math.max(0, Math.min(o | 0, u.length));
      for (var m = 0; m < d && o < c; )
        if (u[o++] != n[m++])
          return !1;
      return m >= d;
    };
  }, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function(e) {
    return e || function(n) {
      var o = $jscomp.checkStringArgs(this, null, "repeat");
      if (0 > n || 1342177279 < n)
        throw new RangeError("Invalid count value");
      n |= 0;
      for (var u = ""; n; )
        n & 1 && (u += o), (n >>>= 1) && (o += o);
      return u;
    };
  }, "es6", "es3");
  var COMPILED = !0, goog = goog || {};
  goog.global = commonjsGlobal || self, goog.exportPath_ = function(e, n, o) {
    e = e.split("."), o = o || goog.global, e[0] in o || typeof o.execScript > "u" || o.execScript("var " + e[0]);
    for (var u; e.length && (u = e.shift()); )
      e.length || n === void 0 ? o = o[u] && o[u] !== Object.prototype[u] ? o[u] : o[u] = {} : o[u] = n;
  }, goog.define = function(e, n) {
    return n;
  }, goog.FEATURESET_YEAR = 2012, goog.DEBUG = !0, goog.LOCALE = "en", goog.TRUSTED_SITE = !0, goog.STRICT_MODE_COMPATIBLE = !1, goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1, goog.provide = function(e) {
    if (goog.isInModuleLoader_())
      throw Error("goog.provide cannot be used within a module.");
    goog.constructNamespace_(e);
  }, goog.constructNamespace_ = function(e, n) {
    goog.exportPath_(e, n);
  }, goog.getScriptNonce = function(e) {
    return e && e != goog.global ? goog.getScriptNonce_(e.document) : (goog.cspNonce_ === null && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
  }, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function(e) {
    return (e = e.querySelector && e.querySelector("script[nonce]")) && (e = e.nonce || e.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(e) ? e : "";
  }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function(e) {
    if (typeof e != "string" || !e || e.search(goog.VALID_MODULE_RE_) == -1)
      throw Error("Invalid module identifier");
    if (!goog.isInGoogModuleLoader_())
      throw Error("Module " + e + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
    if (goog.moduleLoaderState_.moduleName)
      throw Error("goog.module may only be called once per module.");
    goog.moduleLoaderState_.moduleName = e;
  }, goog.module.get = function(e) {
    return goog.module.getInternal_(e);
  }, goog.module.getInternal_ = function(e) {
    return null;
  }, goog.ModuleType = { ES6: "es6", GOOG: "goog" }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function() {
    return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
  }, goog.isInGoogModuleLoader_ = function() {
    return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
  }, goog.isInEs6ModuleLoader_ = function() {
    if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6)
      return !0;
    var e = goog.global.$jscomp;
    return e ? typeof e.getCurrentModulePath != "function" ? !1 : !!e.getCurrentModulePath() : !1;
  }, goog.module.declareLegacyNamespace = function() {
    goog.moduleLoaderState_.declareLegacyNamespace = !0;
  }, goog.declareModuleId = function(e) {
    if (goog.moduleLoaderState_)
      goog.moduleLoaderState_.moduleName = e;
    else {
      var n = goog.global.$jscomp;
      if (!n || typeof n.getCurrentModulePath != "function")
        throw Error('Module with namespace "' + e + '" has been loaded incorrectly.');
      n = n.require(n.getCurrentModulePath()), goog.loadedModules_[e] = { exports: n, type: goog.ModuleType.ES6, moduleId: e };
    }
  }, goog.setTestOnly = function(e) {
    if (goog.DISALLOW_TEST_ONLY_CODE)
      throw e = e || "", Error("Importing test-only code into non-debug environment" + (e ? ": " + e : "."));
  }, goog.forwardDeclare = function(e) {
  }, goog.getObjectByName = function(e, n) {
    e = e.split("."), n = n || goog.global;
    for (var o = 0; o < e.length; o++)
      if (n = n[e[o]], n == null)
        return null;
    return n;
  }, goog.globalize = function(e, n) {
    n = n || goog.global;
    for (var o in e)
      n[o] = e[o];
  }, goog.addDependency = function(e, n, o, u) {
  }, goog.ENABLE_DEBUG_LOADER = !0, goog.logToConsole_ = function(e) {
    goog.global.console && goog.global.console.error(e);
  }, goog.require = function(e) {
  }, goog.requireType = function(e) {
    return {};
  }, goog.basePath = "", goog.nullFunction = function() {
  }, goog.abstractMethod = function() {
    throw Error("unimplemented abstract method");
  }, goog.addSingletonGetter = function(e) {
    e.instance_ = void 0, e.getInstance = function() {
      return e.instance_ ? e.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = e), e.instance_ = new e());
    };
  }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = !0, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = !1, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function() {
    if (goog.hasBadLetScoping == null) {
      try {
        var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
      } catch (e) {
        a = !1;
      }
      goog.hasBadLetScoping = a;
    }
    return goog.hasBadLetScoping;
  }, goog.workaroundSafari10EvalBug = function(e) {
    return "(function(){" + e + `
;})();
`;
  }, goog.loadModule = function(e) {
    var n = goog.moduleLoaderState_;
    try {
      if (goog.moduleLoaderState_ = { moduleName: "", declareLegacyNamespace: !1, type: goog.ModuleType.GOOG }, goog.isFunction(e))
        var o = e.call(void 0, {});
      else if (typeof e == "string")
        goog.useSafari10Workaround() && (e = goog.workaroundSafari10EvalBug(e)), o = goog.loadModuleFromSource_.call(void 0, e);
      else
        throw Error("Invalid module definition");
      var u = goog.moduleLoaderState_.moduleName;
      if (typeof u == "string" && u)
        goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(
          u,
          o
        ) : goog.SEAL_MODULE_EXPORTS && Object.seal && typeof o == "object" && o != null && Object.seal(o), goog.loadedModules_[u] = { exports: o, type: goog.ModuleType.GOOG, moduleId: goog.moduleLoaderState_.moduleName };
      else
        throw Error('Invalid module name "' + u + '"');
    } finally {
      goog.moduleLoaderState_ = n;
    }
  }, goog.loadModuleFromSource_ = function(a) {
    return eval(a), {};
  }, goog.normalizePath_ = function(e) {
    e = e.split("/");
    for (var n = 0; n < e.length; )
      e[n] == "." ? e.splice(n, 1) : n && e[n] == ".." && e[n - 1] && e[n - 1] != ".." ? e.splice(--n, 2) : n++;
    return e.join("/");
  }, goog.loadFileSync_ = function(e) {
    if (goog.global.CLOSURE_LOAD_FILE_SYNC)
      return goog.global.CLOSURE_LOAD_FILE_SYNC(e);
    try {
      var n = new goog.global.XMLHttpRequest();
      return n.open("get", e, !1), n.send(), n.status == 0 || n.status == 200 ? n.responseText : null;
    } catch {
      return null;
    }
  }, goog.transpile_ = function(e, n, o) {
    var u = goog.global.$jscomp;
    u || (goog.global.$jscomp = u = {});
    var c = u.transpile;
    if (!c) {
      var d = goog.basePath + goog.TRANSPILER, m = goog.loadFileSync_(d);
      if (m) {
        if (function() {
          (0, eval)(m + `
//# sourceURL=` + d);
        }.call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile)
          throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
        goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, u = goog.global.$jscomp, c = u.transpile;
      }
    }
    return c || (c = u.transpile = function(v, S) {
      return goog.logToConsole_(S + " requires transpilation but no transpiler was found."), v;
    }), c(e, n, o);
  }, goog.typeOf = function(e) {
    var n = typeof e;
    if (n == "object")
      if (e) {
        if (e instanceof Array)
          return "array";
        if (e instanceof Object)
          return n;
        var o = Object.prototype.toString.call(e);
        if (o == "[object Window]")
          return "object";
        if (o == "[object Array]" || typeof e.length == "number" && typeof e.splice < "u" && typeof e.propertyIsEnumerable < "u" && !e.propertyIsEnumerable("splice"))
          return "array";
        if (o == "[object Function]" || typeof e.call < "u" && typeof e.propertyIsEnumerable < "u" && !e.propertyIsEnumerable("call"))
          return "function";
      } else
        return "null";
    else if (n == "function" && typeof e.call > "u")
      return "object";
    return n;
  }, goog.isArray = function(e) {
    return goog.typeOf(e) == "array";
  }, goog.isArrayLike = function(e) {
    var n = goog.typeOf(e);
    return n == "array" || n == "object" && typeof e.length == "number";
  }, goog.isDateLike = function(e) {
    return goog.isObject(e) && typeof e.getFullYear == "function";
  }, goog.isFunction = function(e) {
    return goog.typeOf(e) == "function";
  }, goog.isObject = function(e) {
    var n = typeof e;
    return n == "object" && e != null || n == "function";
  }, goog.getUid = function(e) {
    return Object.prototype.hasOwnProperty.call(e, goog.UID_PROPERTY_) && e[goog.UID_PROPERTY_] || (e[goog.UID_PROPERTY_] = ++goog.uidCounter_);
  }, goog.hasUid = function(e) {
    return !!e[goog.UID_PROPERTY_];
  }, goog.removeUid = function(e) {
    e !== null && "removeAttribute" in e && e.removeAttribute(goog.UID_PROPERTY_);
    try {
      delete e[goog.UID_PROPERTY_];
    } catch {
    }
  }, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.getHashCode = goog.getUid, goog.removeHashCode = goog.removeUid, goog.cloneObject = function(e) {
    var n = goog.typeOf(e);
    if (n == "object" || n == "array") {
      if (typeof e.clone == "function")
        return e.clone();
      n = n == "array" ? [] : {};
      for (var o in e)
        n[o] = goog.cloneObject(e[o]);
      return n;
    }
    return e;
  }, goog.bindNative_ = function(e, n, o) {
    return e.call.apply(e.bind, arguments);
  }, goog.bindJs_ = function(e, n, o) {
    if (!e)
      throw Error();
    if (2 < arguments.length) {
      var u = Array.prototype.slice.call(arguments, 2);
      return function() {
        var c = Array.prototype.slice.call(arguments);
        return Array.prototype.unshift.apply(c, u), e.apply(n, c);
      };
    }
    return function() {
      return e.apply(n, arguments);
    };
  }, goog.bind = function(e, n, o) {
    return Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
  }, goog.partial = function(e, n) {
    var o = Array.prototype.slice.call(arguments, 1);
    return function() {
      var u = o.slice();
      return u.push.apply(u, arguments), e.apply(this, u);
    };
  }, goog.mixin = function(e, n) {
    for (var o in n)
      e[o] = n[o];
  }, goog.now = goog.TRUSTED_SITE && Date.now || function() {
    return +/* @__PURE__ */ new Date();
  }, goog.globalEval = function(e) {
    if (goog.global.execScript)
      goog.global.execScript(e, "JavaScript");
    else if (goog.global.eval) {
      if (goog.evalWorksForGlobals_ == null) {
        try {
          goog.global.eval("var _evalTest_ = 1;");
        } catch {
        }
        if (typeof goog.global._evalTest_ < "u") {
          try {
            delete goog.global._evalTest_;
          } catch {
          }
          goog.evalWorksForGlobals_ = !0;
        } else
          goog.evalWorksForGlobals_ = !1;
      }
      if (goog.evalWorksForGlobals_)
        goog.global.eval(e);
      else {
        var n = goog.global.document, o = n.createElement("script");
        o.type = "text/javascript", o.defer = !1, o.appendChild(n.createTextNode(e)), n.head.appendChild(o), n.head.removeChild(o);
      }
    } else
      throw Error("goog.globalEval not available");
  }, goog.evalWorksForGlobals_ = null, goog.getCssName = function(e, n) {
    if (String(e).charAt(0) == ".")
      throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + e);
    var o = function(c) {
      return goog.cssNameMapping_[c] || c;
    }, u = function(c) {
      c = c.split("-");
      for (var d = [], m = 0; m < c.length; m++)
        d.push(o(c[m]));
      return d.join("-");
    };
    return u = goog.cssNameMapping_ ? goog.cssNameMappingStyle_ == "BY_WHOLE" ? o : u : function(c) {
      return c;
    }, e = n ? e + "-" + u(n) : u(e), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(e) : e;
  }, goog.setCssNameMapping = function(e, n) {
    goog.cssNameMapping_ = e, goog.cssNameMappingStyle_ = n;
  }, goog.getMsg = function(e, n, o) {
    return o && o.html && (e = e.replace(/</g, "&lt;")), n && (e = e.replace(/\{\$([^}]+)}/g, function(u, c) {
      return n != null && c in n ? n[c] : u;
    })), e;
  }, goog.getMsgWithFallback = function(e, n) {
    return e;
  }, goog.exportSymbol = function(e, n, o) {
    goog.exportPath_(e, n, o);
  }, goog.exportProperty = function(e, n, o) {
    e[n] = o;
  }, goog.inherits = function(e, n) {
    function o() {
    }
    o.prototype = n.prototype, e.superClass_ = n.prototype, e.prototype = new o(), e.prototype.constructor = e, e.base = function(u, c, d) {
      for (var m = Array(arguments.length - 2), v = 2; v < arguments.length; v++)
        m[v - 2] = arguments[v];
      return n.prototype[c].apply(u, m);
    };
  }, goog.scope = function(e) {
    if (goog.isInModuleLoader_())
      throw Error("goog.scope is not supported within a module.");
    e.call(goog.global);
  }, goog.defineClass = function(e, n) {
    var o = n.constructor, u = n.statics;
    return o && o != Object.prototype.constructor || (o = function() {
      throw Error("cannot instantiate an interface (no constructor defined).");
    }), o = goog.defineClass.createSealingConstructor_(o, e), e && goog.inherits(o, e), delete n.constructor, delete n.statics, goog.defineClass.applyProperties_(o.prototype, n), u != null && (u instanceof Function ? u(o) : goog.defineClass.applyProperties_(o, u)), o;
  }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function(e, n) {
    if (!goog.defineClass.SEAL_CLASS_INSTANCES)
      return e;
    var o = !goog.defineClass.isUnsealable_(n), u = function() {
      var c = e.apply(this, arguments) || this;
      return c[goog.UID_PROPERTY_] = c[goog.UID_PROPERTY_], this.constructor === u && o && Object.seal instanceof Function && Object.seal(c), c;
    };
    return u;
  }, goog.defineClass.isUnsealable_ = function(e) {
    return e && e.prototype && e.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
  }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function(e, n) {
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    for (var u = 0; u < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; u++)
      o = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[u], Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }, goog.tagUnsealableClass = function(e) {
  }, goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable", goog.TRUSTED_TYPES_POLICY_NAME = "", goog.identity_ = function(e) {
    return e;
  }, goog.createTrustedTypesPolicy = function(e) {
    var n = null, o = goog.global.trustedTypes || goog.global.TrustedTypes;
    if (!o || !o.createPolicy)
      return n;
    try {
      n = o.createPolicy(e, { createHTML: goog.identity_, createScript: goog.identity_, createScriptURL: goog.identity_, createURL: goog.identity_ });
    } catch (u) {
      goog.logToConsole_(u.message);
    }
    return n;
  }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null, goog.object = {}, goog.object.is = function(e, n) {
    return e === n ? e !== 0 || 1 / e === 1 / n : e !== e && n !== n;
  }, goog.object.forEach = function(e, n, o) {
    for (var u in e)
      n.call(o, e[u], u, e);
  }, goog.object.filter = function(e, n, o) {
    var u = {}, c;
    for (c in e)
      n.call(o, e[c], c, e) && (u[c] = e[c]);
    return u;
  }, goog.object.map = function(e, n, o) {
    var u = {}, c;
    for (c in e)
      u[c] = n.call(o, e[c], c, e);
    return u;
  }, goog.object.some = function(e, n, o) {
    for (var u in e)
      if (n.call(o, e[u], u, e))
        return !0;
    return !1;
  }, goog.object.every = function(e, n, o) {
    for (var u in e)
      if (!n.call(o, e[u], u, e))
        return !1;
    return !0;
  }, goog.object.getCount = function(e) {
    var n = 0, o;
    for (o in e)
      n++;
    return n;
  }, goog.object.getAnyKey = function(e) {
    for (var n in e)
      return n;
  }, goog.object.getAnyValue = function(e) {
    for (var n in e)
      return e[n];
  }, goog.object.contains = function(e, n) {
    return goog.object.containsValue(e, n);
  }, goog.object.getValues = function(e) {
    var n = [], o = 0, u;
    for (u in e)
      n[o++] = e[u];
    return n;
  }, goog.object.getKeys = function(e) {
    var n = [], o = 0, u;
    for (u in e)
      n[o++] = u;
    return n;
  }, goog.object.getValueByKeys = function(e, n) {
    var o = goog.isArrayLike(n), u = o ? n : arguments;
    for (o = o ? 0 : 1; o < u.length; o++) {
      if (e == null)
        return;
      e = e[u[o]];
    }
    return e;
  }, goog.object.containsKey = function(e, n) {
    return e !== null && n in e;
  }, goog.object.containsValue = function(e, n) {
    for (var o in e)
      if (e[o] == n)
        return !0;
    return !1;
  }, goog.object.findKey = function(e, n, o) {
    for (var u in e)
      if (n.call(o, e[u], u, e))
        return u;
  }, goog.object.findValue = function(e, n, o) {
    return (n = goog.object.findKey(e, n, o)) && e[n];
  }, goog.object.isEmpty = function(e) {
    for (var n in e)
      return !1;
    return !0;
  }, goog.object.clear = function(e) {
    for (var n in e)
      delete e[n];
  }, goog.object.remove = function(e, n) {
    var o;
    return (o = n in e) && delete e[n], o;
  }, goog.object.add = function(e, n, o) {
    if (e !== null && n in e)
      throw Error('The object already contains the key "' + n + '"');
    goog.object.set(e, n, o);
  }, goog.object.get = function(e, n, o) {
    return e !== null && n in e ? e[n] : o;
  }, goog.object.set = function(e, n, o) {
    e[n] = o;
  }, goog.object.setIfUndefined = function(e, n, o) {
    return n in e ? e[n] : e[n] = o;
  }, goog.object.setWithReturnValueIfNotSet = function(e, n, o) {
    return n in e ? e[n] : (o = o(), e[n] = o);
  }, goog.object.equals = function(e, n) {
    for (var o in e)
      if (!(o in n) || e[o] !== n[o])
        return !1;
    for (var u in n)
      if (!(u in e))
        return !1;
    return !0;
  }, goog.object.clone = function(e) {
    var n = {}, o;
    for (o in e)
      n[o] = e[o];
    return n;
  }, goog.object.unsafeClone = function(e) {
    var n = goog.typeOf(e);
    if (n == "object" || n == "array") {
      if (goog.isFunction(e.clone))
        return e.clone();
      n = n == "array" ? [] : {};
      for (var o in e)
        n[o] = goog.object.unsafeClone(e[o]);
      return n;
    }
    return e;
  }, goog.object.transpose = function(e) {
    var n = {}, o;
    for (o in e)
      n[e[o]] = o;
    return n;
  }, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function(e, n) {
    for (var o, u, c = 1; c < arguments.length; c++) {
      u = arguments[c];
      for (o in u)
        e[o] = u[o];
      for (var d = 0; d < goog.object.PROTOTYPE_FIELDS_.length; d++)
        o = goog.object.PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(u, o) && (e[o] = u[o]);
    }
  }, goog.object.create = function(e) {
    var n = arguments.length;
    if (n == 1 && Array.isArray(arguments[0]))
      return goog.object.create.apply(null, arguments[0]);
    if (n % 2)
      throw Error("Uneven number of arguments");
    for (var o = {}, u = 0; u < n; u += 2)
      o[arguments[u]] = arguments[u + 1];
    return o;
  }, goog.object.createSet = function(e) {
    var n = arguments.length;
    if (n == 1 && Array.isArray(arguments[0]))
      return goog.object.createSet.apply(null, arguments[0]);
    for (var o = {}, u = 0; u < n; u++)
      o[arguments[u]] = !0;
    return o;
  }, goog.object.createImmutableView = function(e) {
    var n = e;
    return Object.isFrozen && !Object.isFrozen(e) && (n = Object.create(e), Object.freeze(n)), n;
  }, goog.object.isImmutableView = function(e) {
    return !!Object.isFrozen && Object.isFrozen(e);
  }, goog.object.getAllPropertyNames = function(e, n, o) {
    if (!e)
      return [];
    if (!Object.getOwnPropertyNames || !Object.getPrototypeOf)
      return goog.object.getKeys(e);
    for (var u = {}; e && (e !== Object.prototype || n) && (e !== Function.prototype || o); ) {
      for (var c = Object.getOwnPropertyNames(e), d = 0; d < c.length; d++)
        u[c[d]] = !0;
      e = Object.getPrototypeOf(e);
    }
    return goog.object.getKeys(u);
  }, goog.object.getSuperClass = function(e) {
    return (e = Object.getPrototypeOf(e.prototype)) && e.constructor;
  };
  var jspb = { asserts: {} };
  jspb.asserts.doAssertFailure = function(e, n, o, u) {
    var c = "Assertion failed";
    if (o) {
      c += ": " + o;
      var d = u;
    } else
      e && (c += ": " + e, d = n);
    throw Error("" + c, d || []);
  }, jspb.asserts.assert = function(e, n, o) {
    for (var u = [], c = 2; c < arguments.length; ++c)
      u[c - 2] = arguments[c];
    return e || jspb.asserts.doAssertFailure("", null, n, u), e;
  }, jspb.asserts.assertString = function(e, n, o) {
    for (var u = [], c = 2; c < arguments.length; ++c)
      u[c - 2] = arguments[c];
    return typeof e != "string" && jspb.asserts.doAssertFailure("Expected string but got %s: %s.", [goog.typeOf(e), e], n, u), e;
  }, jspb.asserts.assertArray = function(e, n, o) {
    for (var u = [], c = 2; c < arguments.length; ++c)
      u[c - 2] = arguments[c];
    return Array.isArray(e) || jspb.asserts.doAssertFailure("Expected array but got %s: %s.", [goog.typeOf(e), e], n, u), e;
  }, jspb.asserts.fail = function(e, n) {
    for (var o = [], u = 1; u < arguments.length; ++u)
      o[u - 1] = arguments[u];
    throw Error("Failure" + (e ? ": " + e : ""), o);
  }, jspb.asserts.assertInstanceof = function(e, n, o, u) {
    for (var c = [], d = 3; d < arguments.length; ++d)
      c[d - 3] = arguments[d];
    return e instanceof n || jspb.asserts.doAssertFailure("Expected instanceof %s but got %s.", [jspb.asserts.getType(n), jspb.asserts.getType(e)], o, c), e;
  }, jspb.asserts.getType = function(e) {
    return e instanceof Function ? e.displayName || e.name || "unknown type name" : e instanceof Object ? e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e) : e === null ? "null" : typeof e;
  }, jspb.BinaryConstants = {}, jspb.ConstBinaryMessage = function() {
  }, jspb.BinaryMessage = function() {
  }, jspb.BinaryConstants.FieldType = { INVALID: -1, DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18, FHASH64: 30, VHASH64: 31 }, jspb.BinaryConstants.WireType = { INVALID: -1, VARINT: 0, FIXED64: 1, DELIMITED: 2, START_GROUP: 3, END_GROUP: 4, FIXED32: 5 }, jspb.BinaryConstants.FieldTypeToWireType = function(e) {
    var n = jspb.BinaryConstants.FieldType, o = jspb.BinaryConstants.WireType;
    switch (e) {
      case n.INT32:
      case n.INT64:
      case n.UINT32:
      case n.UINT64:
      case n.SINT32:
      case n.SINT64:
      case n.BOOL:
      case n.ENUM:
      case n.VHASH64:
        return o.VARINT;
      case n.DOUBLE:
      case n.FIXED64:
      case n.SFIXED64:
      case n.FHASH64:
        return o.FIXED64;
      case n.STRING:
      case n.MESSAGE:
      case n.BYTES:
        return o.DELIMITED;
      case n.FLOAT:
      case n.FIXED32:
      case n.SFIXED32:
        return o.FIXED32;
      default:
        return o.INVALID;
    }
  }, jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1, jspb.BinaryConstants.FLOAT32_EPS = 1401298464324817e-60, jspb.BinaryConstants.FLOAT32_MIN = 11754943508222875e-54, jspb.BinaryConstants.FLOAT32_MAX = 34028234663852886e22, jspb.BinaryConstants.FLOAT64_EPS = 5e-324, jspb.BinaryConstants.FLOAT64_MIN = 22250738585072014e-324, jspb.BinaryConstants.FLOAT64_MAX = 17976931348623157e292, jspb.BinaryConstants.TWO_TO_20 = 1048576, jspb.BinaryConstants.TWO_TO_23 = 8388608, jspb.BinaryConstants.TWO_TO_31 = 2147483648, jspb.BinaryConstants.TWO_TO_32 = 4294967296, jspb.BinaryConstants.TWO_TO_52 = 4503599627370496, jspb.BinaryConstants.TWO_TO_63 = 9223372036854776e3, jspb.BinaryConstants.TWO_TO_64 = 18446744073709552e3, jspb.BinaryConstants.ZERO_HASH = "\0\0\0\0\0\0\0\0", goog.debug = {}, goog.debug.Error = function(e) {
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, goog.debug.Error);
    else {
      var n = Error().stack;
      n && (this.stack = n);
    }
    e && (this.message = String(e)), this.reportErrorToServer = !0;
  }, goog.inherits(goog.debug.Error, Error), goog.debug.Error.prototype.name = "CustomError", goog.dom = {}, goog.dom.NodeType = { ELEMENT: 1, ATTRIBUTE: 2, TEXT: 3, CDATA_SECTION: 4, ENTITY_REFERENCE: 5, ENTITY: 6, PROCESSING_INSTRUCTION: 7, COMMENT: 8, DOCUMENT: 9, DOCUMENT_TYPE: 10, DOCUMENT_FRAGMENT: 11, NOTATION: 12 }, goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function(e, n) {
    goog.debug.Error.call(this, goog.asserts.subs_(e, n)), this.messagePattern = e;
  }, goog.inherits(goog.asserts.AssertionError, goog.debug.Error), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function(e) {
    throw e;
  }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function(e, n) {
    e = e.split("%s");
    for (var o = "", u = e.length - 1, c = 0; c < u; c++)
      o += e[c] + (c < n.length ? n[c] : "%s");
    return o + e[u];
  }, goog.asserts.doAssertFailure_ = function(e, n, o, u) {
    var c = "Assertion failed";
    if (o) {
      c += ": " + o;
      var d = u;
    } else
      e && (c += ": " + e, d = n);
    e = new goog.asserts.AssertionError("" + c, d || []), goog.asserts.errorHandler_(e);
  }, goog.asserts.setErrorHandler = function(e) {
    goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = e);
  }, goog.asserts.assert = function(e, n, o) {
    return goog.asserts.ENABLE_ASSERTS && !e && goog.asserts.doAssertFailure_("", null, n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertExists = function(e, n, o) {
    return goog.asserts.ENABLE_ASSERTS && e == null && goog.asserts.doAssertFailure_("Expected to exist: %s.", [e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.fail = function(e, n) {
    goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (e ? ": " + e : ""), Array.prototype.slice.call(arguments, 1)));
  }, goog.asserts.assertNumber = function(e, n, o) {
    return goog.asserts.ENABLE_ASSERTS && typeof e != "number" && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(e), e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertString = function(e, n, o) {
    return goog.asserts.ENABLE_ASSERTS && typeof e != "string" && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(e), e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertFunction = function(e, n, o) {
    return goog.asserts.ENABLE_ASSERTS && !goog.isFunction(e) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(e), e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertObject = function(e, n, o) {
    return goog.asserts.ENABLE_ASSERTS && !goog.isObject(e) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(e), e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertArray = function(e, n, o) {
    return goog.asserts.ENABLE_ASSERTS && !Array.isArray(e) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(e), e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertBoolean = function(e, n, o) {
    return goog.asserts.ENABLE_ASSERTS && typeof e != "boolean" && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(e), e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertElement = function(e, n, o) {
    return !goog.asserts.ENABLE_ASSERTS || goog.isObject(e) && e.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(e), e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertInstanceof = function(e, n, o, u) {
    return !goog.asserts.ENABLE_ASSERTS || e instanceof n || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(n), goog.asserts.getType_(e)], o, Array.prototype.slice.call(arguments, 3)), e;
  }, goog.asserts.assertFinite = function(e, n, o) {
    return !goog.asserts.ENABLE_ASSERTS || typeof e == "number" && isFinite(e) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [e], n, Array.prototype.slice.call(arguments, 2)), e;
  }, goog.asserts.assertObjectPrototypeIsIntact = function() {
    for (var e in Object.prototype)
      goog.asserts.fail(e + " should not be enumerable in Object.prototype.");
  }, goog.asserts.getType_ = function(e) {
    return e instanceof Function ? e.displayName || e.name || "unknown type name" : e instanceof Object ? e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e) : e === null ? "null" : typeof e;
  }, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE, goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR, goog.array.peek = function(e) {
    return e[e.length - 1];
  }, goog.array.last = goog.array.peek, goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(e, n, o) {
    return goog.asserts.assert(e.length != null), Array.prototype.indexOf.call(e, n, o);
  } : function(e, n, o) {
    if (o = o == null ? 0 : 0 > o ? Math.max(0, e.length + o) : o, typeof e == "string")
      return typeof n != "string" || n.length != 1 ? -1 : e.indexOf(n, o);
    for (; o < e.length; o++)
      if (o in e && e[o] === n)
        return o;
    return -1;
  }, goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(e, n, o) {
    return goog.asserts.assert(e.length != null), Array.prototype.lastIndexOf.call(e, n, o ?? e.length - 1);
  } : function(e, n, o) {
    if (o = o ?? e.length - 1, 0 > o && (o = Math.max(0, e.length + o)), typeof e == "string")
      return typeof n != "string" || n.length != 1 ? -1 : e.lastIndexOf(n, o);
    for (; 0 <= o; o--)
      if (o in e && e[o] === n)
        return o;
    return -1;
  }, goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(e, n, o) {
    goog.asserts.assert(e.length != null), Array.prototype.forEach.call(e, n, o);
  } : function(e, n, o) {
    for (var u = e.length, c = typeof e == "string" ? e.split("") : e, d = 0; d < u; d++)
      d in c && n.call(o, c[d], d, e);
  }, goog.array.forEachRight = function(e, n, o) {
    var u = e.length, c = typeof e == "string" ? e.split("") : e;
    for (--u; 0 <= u; --u)
      u in c && n.call(o, c[u], u, e);
  }, goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(e, n, o) {
    return goog.asserts.assert(e.length != null), Array.prototype.filter.call(e, n, o);
  } : function(e, n, o) {
    for (var u = e.length, c = [], d = 0, m = typeof e == "string" ? e.split("") : e, v = 0; v < u; v++)
      if (v in m) {
        var S = m[v];
        n.call(o, S, v, e) && (c[d++] = S);
      }
    return c;
  }, goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(e, n, o) {
    return goog.asserts.assert(e.length != null), Array.prototype.map.call(e, n, o);
  } : function(e, n, o) {
    for (var u = e.length, c = Array(u), d = typeof e == "string" ? e.split("") : e, m = 0; m < u; m++)
      m in d && (c[m] = n.call(o, d[m], m, e));
    return c;
  }, goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(e, n, o, u) {
    return goog.asserts.assert(e.length != null), u && (n = goog.bind(n, u)), Array.prototype.reduce.call(e, n, o);
  } : function(e, n, o, u) {
    var c = o;
    return goog.array.forEach(e, function(d, m) {
      c = n.call(u, c, d, m, e);
    }), c;
  }, goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(e, n, o, u) {
    return goog.asserts.assert(e.length != null), goog.asserts.assert(n != null), u && (n = goog.bind(n, u)), Array.prototype.reduceRight.call(e, n, o);
  } : function(e, n, o, u) {
    var c = o;
    return goog.array.forEachRight(e, function(d, m) {
      c = n.call(u, c, d, m, e);
    }), c;
  }, goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(e, n, o) {
    return goog.asserts.assert(e.length != null), Array.prototype.some.call(e, n, o);
  } : function(e, n, o) {
    for (var u = e.length, c = typeof e == "string" ? e.split("") : e, d = 0; d < u; d++)
      if (d in c && n.call(o, c[d], d, e))
        return !0;
    return !1;
  }, goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(e, n, o) {
    return goog.asserts.assert(e.length != null), Array.prototype.every.call(e, n, o);
  } : function(e, n, o) {
    for (var u = e.length, c = typeof e == "string" ? e.split("") : e, d = 0; d < u; d++)
      if (d in c && !n.call(o, c[d], d, e))
        return !1;
    return !0;
  }, goog.array.count = function(e, n, o) {
    var u = 0;
    return goog.array.forEach(e, function(c, d, m) {
      n.call(o, c, d, m) && ++u;
    }, o), u;
  }, goog.array.find = function(e, n, o) {
    return n = goog.array.findIndex(e, n, o), 0 > n ? null : typeof e == "string" ? e.charAt(n) : e[n];
  }, goog.array.findIndex = function(e, n, o) {
    for (var u = e.length, c = typeof e == "string" ? e.split("") : e, d = 0; d < u; d++)
      if (d in c && n.call(o, c[d], d, e))
        return d;
    return -1;
  }, goog.array.findRight = function(e, n, o) {
    return n = goog.array.findIndexRight(e, n, o), 0 > n ? null : typeof e == "string" ? e.charAt(n) : e[n];
  }, goog.array.findIndexRight = function(e, n, o) {
    var u = e.length, c = typeof e == "string" ? e.split("") : e;
    for (--u; 0 <= u; u--)
      if (u in c && n.call(o, c[u], u, e))
        return u;
    return -1;
  }, goog.array.contains = function(e, n) {
    return 0 <= goog.array.indexOf(e, n);
  }, goog.array.isEmpty = function(e) {
    return e.length == 0;
  }, goog.array.clear = function(e) {
    if (!Array.isArray(e))
      for (var n = e.length - 1; 0 <= n; n--)
        delete e[n];
    e.length = 0;
  }, goog.array.insert = function(e, n) {
    goog.array.contains(e, n) || e.push(n);
  }, goog.array.insertAt = function(e, n, o) {
    goog.array.splice(e, o, 0, n);
  }, goog.array.insertArrayAt = function(e, n, o) {
    goog.partial(goog.array.splice, e, o, 0).apply(null, n);
  }, goog.array.insertBefore = function(e, n, o) {
    var u;
    arguments.length == 2 || 0 > (u = goog.array.indexOf(e, o)) ? e.push(n) : goog.array.insertAt(e, n, u);
  }, goog.array.remove = function(e, n) {
    n = goog.array.indexOf(e, n);
    var o;
    return (o = 0 <= n) && goog.array.removeAt(e, n), o;
  }, goog.array.removeLast = function(e, n) {
    return n = goog.array.lastIndexOf(e, n), 0 <= n ? (goog.array.removeAt(e, n), !0) : !1;
  }, goog.array.removeAt = function(e, n) {
    return goog.asserts.assert(e.length != null), Array.prototype.splice.call(e, n, 1).length == 1;
  }, goog.array.removeIf = function(e, n, o) {
    return n = goog.array.findIndex(e, n, o), 0 <= n ? (goog.array.removeAt(e, n), !0) : !1;
  }, goog.array.removeAllIf = function(e, n, o) {
    var u = 0;
    return goog.array.forEachRight(e, function(c, d) {
      n.call(o, c, d, e) && goog.array.removeAt(e, d) && u++;
    }), u;
  }, goog.array.concat = function(e) {
    return Array.prototype.concat.apply([], arguments);
  }, goog.array.join = function(e) {
    return Array.prototype.concat.apply([], arguments);
  }, goog.array.toArray = function(e) {
    var n = e.length;
    if (0 < n) {
      for (var o = Array(n), u = 0; u < n; u++)
        o[u] = e[u];
      return o;
    }
    return [];
  }, goog.array.clone = goog.array.toArray, goog.array.extend = function(e, n) {
    for (var o = 1; o < arguments.length; o++) {
      var u = arguments[o];
      if (goog.isArrayLike(u)) {
        var c = e.length || 0, d = u.length || 0;
        e.length = c + d;
        for (var m = 0; m < d; m++)
          e[c + m] = u[m];
      } else
        e.push(u);
    }
  }, goog.array.splice = function(e, n, o, u) {
    return goog.asserts.assert(e.length != null), Array.prototype.splice.apply(e, goog.array.slice(arguments, 1));
  }, goog.array.slice = function(e, n, o) {
    return goog.asserts.assert(e.length != null), 2 >= arguments.length ? Array.prototype.slice.call(e, n) : Array.prototype.slice.call(e, n, o);
  }, goog.array.removeDuplicates = function(e, n, o) {
    n = n || e;
    var u = function(S) {
      return goog.isObject(S) ? "o" + goog.getUid(S) : (typeof S).charAt(0) + S;
    };
    o = o || u, u = {};
    for (var c = 0, d = 0; d < e.length; ) {
      var m = e[d++], v = o(m);
      Object.prototype.hasOwnProperty.call(u, v) || (u[v] = !0, n[c++] = m);
    }
    n.length = c;
  }, goog.array.binarySearch = function(e, n, o) {
    return goog.array.binarySearch_(e, o || goog.array.defaultCompare, !1, n);
  }, goog.array.binarySelect = function(e, n, o) {
    return goog.array.binarySearch_(e, n, !0, void 0, o);
  }, goog.array.binarySearch_ = function(e, n, o, u, c) {
    for (var d = 0, m = e.length, v; d < m; ) {
      var S = d + (m - d >>> 1), $ = o ? n.call(c, e[S], S, e) : n(u, e[S]);
      0 < $ ? d = S + 1 : (m = S, v = !$);
    }
    return v ? d : -d - 1;
  }, goog.array.sort = function(e, n) {
    e.sort(n || goog.array.defaultCompare);
  }, goog.array.stableSort = function(e, n) {
    for (var o = Array(e.length), u = 0; u < e.length; u++)
      o[u] = { index: u, value: e[u] };
    var c = n || goog.array.defaultCompare;
    for (goog.array.sort(o, function(d, m) {
      return c(d.value, m.value) || d.index - m.index;
    }), u = 0; u < e.length; u++)
      e[u] = o[u].value;
  }, goog.array.sortByKey = function(e, n, o) {
    var u = o || goog.array.defaultCompare;
    goog.array.sort(e, function(c, d) {
      return u(n(c), n(d));
    });
  }, goog.array.sortObjectsByKey = function(e, n, o) {
    goog.array.sortByKey(e, function(u) {
      return u[n];
    }, o);
  }, goog.array.isSorted = function(e, n, o) {
    n = n || goog.array.defaultCompare;
    for (var u = 1; u < e.length; u++) {
      var c = n(e[u - 1], e[u]);
      if (0 < c || c == 0 && o)
        return !1;
    }
    return !0;
  }, goog.array.equals = function(e, n, o) {
    if (!goog.isArrayLike(e) || !goog.isArrayLike(n) || e.length != n.length)
      return !1;
    var u = e.length;
    o = o || goog.array.defaultCompareEquality;
    for (var c = 0; c < u; c++)
      if (!o(e[c], n[c]))
        return !1;
    return !0;
  }, goog.array.compare3 = function(e, n, o) {
    o = o || goog.array.defaultCompare;
    for (var u = Math.min(e.length, n.length), c = 0; c < u; c++) {
      var d = o(e[c], n[c]);
      if (d != 0)
        return d;
    }
    return goog.array.defaultCompare(e.length, n.length);
  }, goog.array.defaultCompare = function(e, n) {
    return e > n ? 1 : e < n ? -1 : 0;
  }, goog.array.inverseDefaultCompare = function(e, n) {
    return -goog.array.defaultCompare(e, n);
  }, goog.array.defaultCompareEquality = function(e, n) {
    return e === n;
  }, goog.array.binaryInsert = function(e, n, o) {
    return o = goog.array.binarySearch(e, n, o), 0 > o ? (goog.array.insertAt(e, n, -(o + 1)), !0) : !1;
  }, goog.array.binaryRemove = function(e, n, o) {
    return n = goog.array.binarySearch(e, n, o), 0 <= n ? goog.array.removeAt(e, n) : !1;
  }, goog.array.bucket = function(e, n, o) {
    for (var u = {}, c = 0; c < e.length; c++) {
      var d = e[c], m = n.call(o, d, c, e);
      m !== void 0 && (u[m] || (u[m] = [])).push(d);
    }
    return u;
  }, goog.array.toObject = function(e, n, o) {
    var u = {};
    return goog.array.forEach(e, function(c, d) {
      u[n.call(o, c, d, e)] = c;
    }), u;
  }, goog.array.range = function(e, n, o) {
    var u = [], c = 0, d = e;
    if (o = o || 1, n !== void 0 && (c = e, d = n), 0 > o * (d - c))
      return [];
    if (0 < o)
      for (e = c; e < d; e += o)
        u.push(e);
    else
      for (e = c; e > d; e += o)
        u.push(e);
    return u;
  }, goog.array.repeat = function(e, n) {
    for (var o = [], u = 0; u < n; u++)
      o[u] = e;
    return o;
  }, goog.array.flatten = function(e) {
    for (var n = [], o = 0; o < arguments.length; o++) {
      var u = arguments[o];
      if (Array.isArray(u))
        for (var c = 0; c < u.length; c += 8192) {
          var d = goog.array.slice(u, c, c + 8192);
          d = goog.array.flatten.apply(null, d);
          for (var m = 0; m < d.length; m++)
            n.push(d[m]);
        }
      else
        n.push(u);
    }
    return n;
  }, goog.array.rotate = function(e, n) {
    return goog.asserts.assert(e.length != null), e.length && (n %= e.length, 0 < n ? Array.prototype.unshift.apply(e, e.splice(-n, n)) : 0 > n && Array.prototype.push.apply(e, e.splice(0, -n))), e;
  }, goog.array.moveItem = function(e, n, o) {
    goog.asserts.assert(0 <= n && n < e.length), goog.asserts.assert(0 <= o && o < e.length), n = Array.prototype.splice.call(e, n, 1), Array.prototype.splice.call(e, o, 0, n[0]);
  }, goog.array.zip = function(e) {
    if (!arguments.length)
      return [];
    for (var n = [], o = arguments[0].length, u = 1; u < arguments.length; u++)
      arguments[u].length < o && (o = arguments[u].length);
    for (u = 0; u < o; u++) {
      for (var c = [], d = 0; d < arguments.length; d++)
        c.push(arguments[d][u]);
      n.push(c);
    }
    return n;
  }, goog.array.shuffle = function(e, n) {
    n = n || Math.random;
    for (var o = e.length - 1; 0 < o; o--) {
      var u = Math.floor(n() * (o + 1)), c = e[o];
      e[o] = e[u], e[u] = c;
    }
  }, goog.array.copyByIndex = function(e, n) {
    var o = [];
    return goog.array.forEach(n, function(u) {
      o.push(e[u]);
    }), o;
  }, goog.array.concatMap = function(e, n, o) {
    return goog.array.concat.apply([], goog.array.map(e, n, o));
  }, goog.crypt = {}, goog.crypt.stringToByteArray = function(e) {
    for (var n = [], o = 0, u = 0; u < e.length; u++) {
      var c = e.charCodeAt(u);
      255 < c && (n[o++] = c & 255, c >>= 8), n[o++] = c;
    }
    return n;
  }, goog.crypt.byteArrayToString = function(e) {
    if (8192 >= e.length)
      return String.fromCharCode.apply(null, e);
    for (var n = "", o = 0; o < e.length; o += 8192) {
      var u = goog.array.slice(e, o, o + 8192);
      n += String.fromCharCode.apply(null, u);
    }
    return n;
  }, goog.crypt.byteArrayToHex = function(e, n) {
    return goog.array.map(e, function(o) {
      return o = o.toString(16), 1 < o.length ? o : "0" + o;
    }).join(n || "");
  }, goog.crypt.hexToByteArray = function(e) {
    goog.asserts.assert(e.length % 2 == 0, "Key string length must be multiple of 2");
    for (var n = [], o = 0; o < e.length; o += 2)
      n.push(parseInt(e.substring(o, o + 2), 16));
    return n;
  }, goog.crypt.stringToUtf8ByteArray = function(e) {
    for (var n = [], o = 0, u = 0; u < e.length; u++) {
      var c = e.charCodeAt(u);
      128 > c ? n[o++] = c : (2048 > c ? n[o++] = c >> 6 | 192 : ((c & 64512) == 55296 && u + 1 < e.length && (e.charCodeAt(u + 1) & 64512) == 56320 ? (c = 65536 + ((c & 1023) << 10) + (e.charCodeAt(++u) & 1023), n[o++] = c >> 18 | 240, n[o++] = c >> 12 & 63 | 128) : n[o++] = c >> 12 | 224, n[o++] = c >> 6 & 63 | 128), n[o++] = c & 63 | 128);
    }
    return n;
  }, goog.crypt.utf8ByteArrayToString = function(e) {
    for (var n = [], o = 0, u = 0; o < e.length; ) {
      var c = e[o++];
      if (128 > c)
        n[u++] = String.fromCharCode(c);
      else if (191 < c && 224 > c) {
        var d = e[o++];
        n[u++] = String.fromCharCode((c & 31) << 6 | d & 63);
      } else if (239 < c && 365 > c) {
        d = e[o++];
        var m = e[o++], v = e[o++];
        c = ((c & 7) << 18 | (d & 63) << 12 | (m & 63) << 6 | v & 63) - 65536, n[u++] = String.fromCharCode(55296 + (c >> 10)), n[u++] = String.fromCharCode(56320 + (c & 1023));
      } else
        d = e[o++], m = e[o++], n[u++] = String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | m & 63);
    }
    return n.join("");
  }, goog.crypt.xorByteArray = function(e, n) {
    goog.asserts.assert(e.length == n.length, "XOR array lengths must match");
    for (var o = [], u = 0; u < e.length; u++)
      o.push(e[u] ^ n[u]);
    return o;
  }, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function(e) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var n = goog.dom.asserts.getWindow_(e);
      n && (!e || !(e instanceof n.Location) && e instanceof n.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(e));
    }
    return e;
  }, goog.dom.asserts.assertIsElementType_ = function(e, n) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var o = goog.dom.asserts.getWindow_(e);
      o && typeof o[n] < "u" && (e && (e instanceof o[n] || !(e instanceof o.Location || e instanceof o.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", n, goog.dom.asserts.debugStringForType_(e)));
    }
    return e;
  }, goog.dom.asserts.assertIsHTMLAnchorElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLAnchorElement");
  }, goog.dom.asserts.assertIsHTMLButtonElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLButtonElement");
  }, goog.dom.asserts.assertIsHTMLLinkElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLLinkElement");
  }, goog.dom.asserts.assertIsHTMLImageElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLImageElement");
  }, goog.dom.asserts.assertIsHTMLAudioElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLAudioElement");
  }, goog.dom.asserts.assertIsHTMLVideoElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLVideoElement");
  }, goog.dom.asserts.assertIsHTMLInputElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLInputElement");
  }, goog.dom.asserts.assertIsHTMLTextAreaElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLTextAreaElement");
  }, goog.dom.asserts.assertIsHTMLCanvasElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLCanvasElement");
  }, goog.dom.asserts.assertIsHTMLEmbedElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLEmbedElement");
  }, goog.dom.asserts.assertIsHTMLFormElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLFormElement");
  }, goog.dom.asserts.assertIsHTMLFrameElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLFrameElement");
  }, goog.dom.asserts.assertIsHTMLIFrameElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLIFrameElement");
  }, goog.dom.asserts.assertIsHTMLObjectElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLObjectElement");
  }, goog.dom.asserts.assertIsHTMLScriptElement = function(e) {
    return goog.dom.asserts.assertIsElementType_(e, "HTMLScriptElement");
  }, goog.dom.asserts.debugStringForType_ = function(e) {
    if (goog.isObject(e))
      try {
        return e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e);
      } catch {
        return "<object could not be stringified>";
      }
    else
      return e === void 0 ? "undefined" : e === null ? "null" : typeof e;
  }, goog.dom.asserts.getWindow_ = function(e) {
    try {
      var n = e && e.ownerDocument, o = n && (n.defaultView || n.parentWindow);
      if (o = o || goog.global, o.Element && o.Location)
        return o;
    } catch {
    }
    return null;
  }, goog.functions = {}, goog.functions.constant = function(e) {
    return function() {
      return e;
    };
  }, goog.functions.FALSE = function() {
    return !1;
  }, goog.functions.TRUE = function() {
    return !0;
  }, goog.functions.NULL = function() {
    return null;
  }, goog.functions.identity = function(e, n) {
    return e;
  }, goog.functions.error = function(e) {
    return function() {
      throw Error(e);
    };
  }, goog.functions.fail = function(e) {
    return function() {
      throw e;
    };
  }, goog.functions.lock = function(e, n) {
    return n = n || 0, function() {
      return e.apply(this, Array.prototype.slice.call(arguments, 0, n));
    };
  }, goog.functions.nth = function(e) {
    return function() {
      return arguments[e];
    };
  }, goog.functions.partialRight = function(e, n) {
    var o = Array.prototype.slice.call(arguments, 1);
    return function() {
      var u = Array.prototype.slice.call(arguments);
      return u.push.apply(u, o), e.apply(this, u);
    };
  }, goog.functions.withReturnValue = function(e, n) {
    return goog.functions.sequence(e, goog.functions.constant(n));
  }, goog.functions.equalTo = function(e, n) {
    return function(o) {
      return n ? e == o : e === o;
    };
  }, goog.functions.compose = function(e, n) {
    var o = arguments, u = o.length;
    return function() {
      var c;
      u && (c = o[u - 1].apply(this, arguments));
      for (var d = u - 2; 0 <= d; d--)
        c = o[d].call(this, c);
      return c;
    };
  }, goog.functions.sequence = function(e) {
    var n = arguments, o = n.length;
    return function() {
      for (var u, c = 0; c < o; c++)
        u = n[c].apply(this, arguments);
      return u;
    };
  }, goog.functions.and = function(e) {
    var n = arguments, o = n.length;
    return function() {
      for (var u = 0; u < o; u++)
        if (!n[u].apply(this, arguments))
          return !1;
      return !0;
    };
  }, goog.functions.or = function(e) {
    var n = arguments, o = n.length;
    return function() {
      for (var u = 0; u < o; u++)
        if (n[u].apply(this, arguments))
          return !0;
      return !1;
    };
  }, goog.functions.not = function(e) {
    return function() {
      return !e.apply(this, arguments);
    };
  }, goog.functions.create = function(e, n) {
    var o = function() {
    };
    return o.prototype = e.prototype, o = new o(), e.apply(o, Array.prototype.slice.call(arguments, 1)), o;
  }, goog.functions.CACHE_RETURN_VALUE = !0, goog.functions.cacheReturnValue = function(e) {
    var n = !1, o;
    return function() {
      return goog.functions.CACHE_RETURN_VALUE ? (n || (o = e(), n = !0), o) : e();
    };
  }, goog.functions.once = function(e) {
    var n = e;
    return function() {
      if (n) {
        var o = n;
        n = null, o();
      }
    };
  }, goog.functions.debounce = function(e, n, o) {
    var u = 0;
    return function(c) {
      goog.global.clearTimeout(u);
      var d = arguments;
      u = goog.global.setTimeout(function() {
        e.apply(o, d);
      }, n);
    };
  }, goog.functions.throttle = function(e, n, o) {
    var u = 0, c = !1, d = [], m = function() {
      u = 0, c && (c = !1, v());
    }, v = function() {
      u = goog.global.setTimeout(m, n), e.apply(o, d);
    };
    return function(S) {
      d = arguments, u ? c = !0 : v();
    };
  }, goog.functions.rateLimit = function(e, n, o) {
    var u = 0, c = function() {
      u = 0;
    };
    return function(d) {
      u || (u = goog.global.setTimeout(c, n), e.apply(o, arguments));
    };
  }, goog.dom.HtmlElement = function() {
  }, goog.dom.TagName = function(e) {
    this.tagName_ = e;
  }, goog.dom.TagName.prototype.toString = function() {
    return this.tagName_;
  }, goog.dom.TagName.A = new goog.dom.TagName("A"), goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR"), goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM"), goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS"), goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET"), goog.dom.TagName.AREA = new goog.dom.TagName("AREA"), goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE"), goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE"), goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO"), goog.dom.TagName.B = new goog.dom.TagName("B"), goog.dom.TagName.BASE = new goog.dom.TagName("BASE"), goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT"), goog.dom.TagName.BDI = new goog.dom.TagName("BDI"), goog.dom.TagName.BDO = new goog.dom.TagName("BDO"), goog.dom.TagName.BIG = new goog.dom.TagName("BIG"), goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE"), goog.dom.TagName.BODY = new goog.dom.TagName("BODY"), goog.dom.TagName.BR = new goog.dom.TagName("BR"), goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON"), goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS"), goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION"), goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER"), goog.dom.TagName.CITE = new goog.dom.TagName("CITE"), goog.dom.TagName.CODE = new goog.dom.TagName("CODE"), goog.dom.TagName.COL = new goog.dom.TagName("COL"), goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP"), goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND"), goog.dom.TagName.DATA = new goog.dom.TagName("DATA"), goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST"), goog.dom.TagName.DD = new goog.dom.TagName("DD"), goog.dom.TagName.DEL = new goog.dom.TagName("DEL"), goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS"), goog.dom.TagName.DFN = new goog.dom.TagName("DFN"), goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG"), goog.dom.TagName.DIR = new goog.dom.TagName("DIR"), goog.dom.TagName.DIV = new goog.dom.TagName("DIV"), goog.dom.TagName.DL = new goog.dom.TagName("DL"), goog.dom.TagName.DT = new goog.dom.TagName("DT"), goog.dom.TagName.EM = new goog.dom.TagName("EM"), goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED"), goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET"), goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION"), goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE"), goog.dom.TagName.FONT = new goog.dom.TagName("FONT"), goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER"), goog.dom.TagName.FORM = new goog.dom.TagName("FORM"), goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME"), goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET"), goog.dom.TagName.H1 = new goog.dom.TagName("H1"), goog.dom.TagName.H2 = new goog.dom.TagName("H2"), goog.dom.TagName.H3 = new goog.dom.TagName("H3"), goog.dom.TagName.H4 = new goog.dom.TagName("H4"), goog.dom.TagName.H5 = new goog.dom.TagName("H5"), goog.dom.TagName.H6 = new goog.dom.TagName("H6"), goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD"), goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER"), goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP"), goog.dom.TagName.HR = new goog.dom.TagName("HR"), goog.dom.TagName.HTML = new goog.dom.TagName("HTML"), goog.dom.TagName.I = new goog.dom.TagName("I"), goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME"), goog.dom.TagName.IMG = new goog.dom.TagName("IMG"), goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT"), goog.dom.TagName.INS = new goog.dom.TagName("INS"), goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX"), goog.dom.TagName.KBD = new goog.dom.TagName("KBD"), goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN"), goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL"), goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND"), goog.dom.TagName.LI = new goog.dom.TagName("LI"), goog.dom.TagName.LINK = new goog.dom.TagName("LINK"), goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN"), goog.dom.TagName.MAP = new goog.dom.TagName("MAP"), goog.dom.TagName.MARK = new goog.dom.TagName("MARK"), goog.dom.TagName.MATH = new goog.dom.TagName("MATH"), goog.dom.TagName.MENU = new goog.dom.TagName("MENU"), goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM"), goog.dom.TagName.META = new goog.dom.TagName("META"), goog.dom.TagName.METER = new goog.dom.TagName("METER"), goog.dom.TagName.NAV = new goog.dom.TagName("NAV"), goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES"), goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT"), goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT"), goog.dom.TagName.OL = new goog.dom.TagName("OL"), goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP"), goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION"), goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT"), goog.dom.TagName.P = new goog.dom.TagName("P"), goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM"), goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE"), goog.dom.TagName.PRE = new goog.dom.TagName("PRE"), goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS"), goog.dom.TagName.Q = new goog.dom.TagName("Q"), goog.dom.TagName.RP = new goog.dom.TagName("RP"), goog.dom.TagName.RT = new goog.dom.TagName("RT"), goog.dom.TagName.RTC = new goog.dom.TagName("RTC"), goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY"), goog.dom.TagName.S = new goog.dom.TagName("S"), goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP"), goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT"), goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION"), goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT"), goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL"), goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE"), goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN"), goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE"), goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG"), goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE"), goog.dom.TagName.SUB = new goog.dom.TagName("SUB"), goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY"), goog.dom.TagName.SUP = new goog.dom.TagName("SUP"), goog.dom.TagName.SVG = new goog.dom.TagName("SVG"), goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE"), goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY"), goog.dom.TagName.TD = new goog.dom.TagName("TD"), goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE"), goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA"), goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT"), goog.dom.TagName.TH = new goog.dom.TagName("TH"), goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD"), goog.dom.TagName.TIME = new goog.dom.TagName("TIME"), goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE"), goog.dom.TagName.TR = new goog.dom.TagName("TR"), goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK"), goog.dom.TagName.TT = new goog.dom.TagName("TT"), goog.dom.TagName.U = new goog.dom.TagName("U"), goog.dom.TagName.UL = new goog.dom.TagName("UL"), goog.dom.TagName.VAR = new goog.dom.TagName("VAR"), goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO"), goog.dom.TagName.WBR = new goog.dom.TagName("WBR"), goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = { area: !0, base: !0, br: !0, col: !0, command: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, goog.dom.tags.isVoidTag = function(e) {
    return goog.dom.tags.VOID_TAGS_[e] === !0;
  }, goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null, goog.string = {}, goog.string.TypedString = function() {
  }, goog.string.Const = function(e, n) {
    this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = e === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && n || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
  }, goog.string.Const.prototype.implementsGoogStringTypedString = !0, goog.string.Const.prototype.getTypedStringValue = function() {
    return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
  }, goog.DEBUG && (goog.string.Const.prototype.toString = function() {
    return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
  }), goog.string.Const.unwrap = function(e) {
    return e instanceof goog.string.Const && e.constructor === goog.string.Const && e.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? e.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + e + "'"), "type_error:Const");
  }, goog.string.Const.from = function(e) {
    return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, e);
  }, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.html.SafeScript = function() {
    this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "", this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.SafeScript.prototype.implementsGoogStringTypedString = !0, goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeScript.fromConstant = function(e) {
    return e = goog.string.Const.unwrap(e), e.length === 0 ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SafeScript.fromConstantAndArgs = function(e, n) {
    for (var o = [], u = 1; u < arguments.length; u++)
      o.push(goog.html.SafeScript.stringify_(arguments[u]));
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(e) + ")(" + o.join(", ") + ");");
  }, goog.html.SafeScript.fromJson = function(e) {
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(e));
  }, goog.html.SafeScript.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
  }, goog.DEBUG && (goog.html.SafeScript.prototype.toString = function() {
    return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
  }), goog.html.SafeScript.unwrap = function(e) {
    return goog.html.SafeScript.unwrapTrustedScript(e).toString();
  }, goog.html.SafeScript.unwrapTrustedScript = function(e) {
    return e instanceof goog.html.SafeScript && e.constructor === goog.html.SafeScript && e.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeScriptWrappedValue_ : (goog.asserts.fail("expected object of type SafeScript, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeScript");
  }, goog.html.SafeScript.stringify_ = function(e) {
    return JSON.stringify(e).replace(/</g, "\\x3c");
  }, goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(e) {
    return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(e);
  }, goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(e) {
    return this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(e) : e, this;
  }, goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(""), goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function(e) {
    return goog.fs.url.getUrlObject_().createObjectURL(e);
  }, goog.fs.url.revokeObjectUrl = function(e) {
    goog.fs.url.getUrlObject_().revokeObjectURL(e);
  }, goog.fs.url.UrlObject_ = function() {
  }, goog.fs.url.UrlObject_.prototype.createObjectURL = function(e) {
  }, goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(e) {
  }, goog.fs.url.getUrlObject_ = function() {
    var e = goog.fs.url.findUrlObject_();
    if (e != null)
      return e;
    throw Error("This browser doesn't seem to support blob URLs");
  }, goog.fs.url.findUrlObject_ = function() {
    return goog.global.URL !== void 0 && goog.global.URL.createObjectURL !== void 0 ? goog.global.URL : goog.global.webkitURL !== void 0 && goog.global.webkitURL.createObjectURL !== void 0 ? goog.global.webkitURL : goog.global.createObjectURL !== void 0 ? goog.global : null;
  }, goog.fs.url.browserSupportsObjectUrls = function() {
    return goog.fs.url.findUrlObject_() != null;
  }, goog.fs.blob = {}, goog.fs.blob.getBlob = function(e) {
    var n = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
    if (n !== void 0) {
      n = new n();
      for (var o = 0; o < arguments.length; o++)
        n.append(arguments[o]);
      return n.getBlob();
    }
    return goog.fs.blob.getBlobWithProperties(goog.array.toArray(arguments));
  }, goog.fs.blob.getBlobWithProperties = function(e, n, o) {
    var u = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
    if (u !== void 0) {
      u = new u();
      for (var c = 0; c < e.length; c++)
        u.append(e[c], o);
      return u.getBlob(n);
    }
    if (goog.global.Blob !== void 0)
      return u = {}, n && (u.type = n), o && (u.endings = o), new Blob(e, u);
    throw Error("This browser doesn't seem to support creating Blobs");
  }, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = !1, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || (goog.LOCALE.substring(0, 2).toLowerCase() == "ar" || goog.LOCALE.substring(0, 2).toLowerCase() == "fa" || goog.LOCALE.substring(0, 2).toLowerCase() == "he" || goog.LOCALE.substring(0, 2).toLowerCase() == "iw" || goog.LOCALE.substring(0, 2).toLowerCase() == "ps" || goog.LOCALE.substring(0, 2).toLowerCase() == "sd" || goog.LOCALE.substring(0, 2).toLowerCase() == "ug" || goog.LOCALE.substring(0, 2).toLowerCase() == "ur" || goog.LOCALE.substring(0, 2).toLowerCase() == "yi") && (goog.LOCALE.length == 2 || goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") || 3 <= goog.LOCALE.length && goog.LOCALE.substring(0, 3).toLowerCase() == "ckb" && (goog.LOCALE.length == 3 || goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") || 7 <= goog.LOCALE.length && (goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") && (goog.LOCALE.substring(3, 7).toLowerCase() == "adlm" || goog.LOCALE.substring(3, 7).toLowerCase() == "arab" || goog.LOCALE.substring(3, 7).toLowerCase() == "hebr" || goog.LOCALE.substring(
    3,
    7
  ).toLowerCase() == "nkoo" || goog.LOCALE.substring(3, 7).toLowerCase() == "rohg" || goog.LOCALE.substring(3, 7).toLowerCase() == "thaa") || 8 <= goog.LOCALE.length && (goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") && (goog.LOCALE.substring(4, 8).toLowerCase() == "adlm" || goog.LOCALE.substring(4, 8).toLowerCase() == "arab" || goog.LOCALE.substring(4, 8).toLowerCase() == "hebr" || goog.LOCALE.substring(4, 8).toLowerCase() == "nkoo" || goog.LOCALE.substring(4, 8).toLowerCase() == "rohg" || goog.LOCALE.substring(4, 8).toLowerCase() == "thaa"), goog.i18n.bidi.Format = { LRE: "‪", RLE: "‫", PDF: "‬", LRM: "‎", RLM: "‏" }, goog.i18n.bidi.Dir = { LTR: 1, RTL: -1, NEUTRAL: 0 }, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function(e, n) {
    return typeof e == "number" ? 0 < e ? goog.i18n.bidi.Dir.LTR : 0 > e ? goog.i18n.bidi.Dir.RTL : n ? null : goog.i18n.bidi.Dir.NEUTRAL : e == null ? null : e ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
  }, goog.i18n.bidi.ltrChars_ = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ऀ-῿‎Ⰰ-\uD801\uD804-\uD839\uD83C-\uDBFF豈-﬜︀-﹯﻽-￿", goog.i18n.bidi.rtlChars_ = "֑-ۯۺ-ࣿ‏\uD802-\uD803\uD83A-\uD83Bיִ-﷿ﹰ-ﻼ", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function(e, n) {
    return n ? e.replace(goog.i18n.bidi.htmlSkipReg_, "") : e;
  }, goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function(e, n) {
    return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, n));
  }, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function(e, n) {
    return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, n));
  }, goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function(e) {
    return goog.i18n.bidi.rtlRe_.test(e);
  }, goog.i18n.bidi.isLtrChar = function(e) {
    return goog.i18n.bidi.ltrRe_.test(e);
  }, goog.i18n.bidi.isNeutralChar = function(e) {
    return !goog.i18n.bidi.isLtrChar(e) && !goog.i18n.bidi.isRtlChar(e);
  }, goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function(e, n) {
    return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, n));
  }, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function(e, n) {
    return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, n));
  }, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function(e, n) {
    return e = goog.i18n.bidi.stripHtmlIfNeeded_(e, n), goog.i18n.bidi.isRequiredLtrRe_.test(e) || !goog.i18n.bidi.hasAnyLtr(e) && !goog.i18n.bidi.hasAnyRtl(e);
  }, goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function(e, n) {
    return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, n));
  }, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function(e, n) {
    return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, n));
  }, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function(e) {
    return goog.i18n.bidi.rtlLocalesRe_.test(e);
  }, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function(e, n) {
    return n = (n === void 0 ? goog.i18n.bidi.hasAnyRtl(e) : n) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, e.replace(goog.i18n.bidi.bracketGuardTextRe_, n + "$&" + n);
  }, goog.i18n.bidi.enforceRtlInHtml = function(e) {
    return e.charAt(0) == "<" ? e.replace(/<\w+/, "$& dir=rtl") : `
<span dir=rtl>` + e + "</span>";
  }, goog.i18n.bidi.enforceRtlInText = function(e) {
    return goog.i18n.bidi.Format.RLE + e + goog.i18n.bidi.Format.PDF;
  }, goog.i18n.bidi.enforceLtrInHtml = function(e) {
    return e.charAt(0) == "<" ? e.replace(/<\w+/, "$& dir=ltr") : `
<span dir=ltr>` + e + "</span>";
  }, goog.i18n.bidi.enforceLtrInText = function(e) {
    return goog.i18n.bidi.Format.LRE + e + goog.i18n.bidi.Format.PDF;
  }, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function(e) {
    return e.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
  }, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function(e) {
    return e.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1״").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1׳");
  }, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = 0.4, goog.i18n.bidi.estimateDirection = function(e, n) {
    var o = 0, u = 0, c = !1;
    for (e = goog.i18n.bidi.stripHtmlIfNeeded_(e, n).split(goog.i18n.bidi.wordSeparatorRe_), n = 0; n < e.length; n++) {
      var d = e[n];
      goog.i18n.bidi.startsWithRtl(d) ? (o++, u++) : goog.i18n.bidi.isRequiredLtrRe_.test(d) ? c = !0 : goog.i18n.bidi.hasAnyLtr(d) ? u++ : goog.i18n.bidi.hasNumeralsRe_.test(d) && (c = !0);
    }
    return u == 0 ? c ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : o / u > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
  }, goog.i18n.bidi.detectRtlDirectionality = function(e, n) {
    return goog.i18n.bidi.estimateDirection(e, n) == goog.i18n.bidi.Dir.RTL;
  }, goog.i18n.bidi.setElementDirAndAlign = function(e, n) {
    e && (n = goog.i18n.bidi.toDir(n)) && (e.style.textAlign = n == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, e.dir = n == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
  }, goog.i18n.bidi.setElementDirByTextDirectionality = function(e, n) {
    switch (goog.i18n.bidi.estimateDirection(n)) {
      case goog.i18n.bidi.Dir.LTR:
        e.dir = "ltr";
        break;
      case goog.i18n.bidi.Dir.RTL:
        e.dir = "rtl";
        break;
      default:
        e.removeAttribute("dir");
    }
  }, goog.i18n.bidi.DirectionalString = function() {
  }, goog.html.TrustedResourceUrl = function(e, n) {
    this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = e === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && n || "", this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
  }, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.TrustedResourceUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
  }, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(e, n) {
    var o = goog.html.TrustedResourceUrl.unwrap(this);
    o = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(o);
    var u = o[3] || "";
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(o[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", o[2] || "", e) + goog.html.TrustedResourceUrl.stringifyParams_("#", u, n));
  }, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
    return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
  }), goog.html.TrustedResourceUrl.unwrap = function(e) {
    return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(e).toString();
  }, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(e) {
    return e instanceof goog.html.TrustedResourceUrl && e.constructor === goog.html.TrustedResourceUrl && e.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:TrustedResourceUrl");
  }, goog.html.TrustedResourceUrl.format = function(e, n) {
    var o = goog.string.Const.unwrap(e);
    if (!goog.html.TrustedResourceUrl.BASE_URL_.test(o))
      throw Error("Invalid TrustedResourceUrl format: " + o);
    return e = o.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(u, c) {
      if (!Object.prototype.hasOwnProperty.call(n, c))
        throw Error('Found marker, "' + c + '", in format string, "' + o + '", but no valid label mapping found in args: ' + JSON.stringify(n));
      return u = n[c], u instanceof goog.string.Const ? goog.string.Const.unwrap(u) : encodeURIComponent(String(u));
    }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function(e, n, o, u) {
    return goog.html.TrustedResourceUrl.format(e, n).cloneWithParams(o, u);
  }, goog.html.TrustedResourceUrl.fromConstant = function(e) {
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
  }, goog.html.TrustedResourceUrl.fromConstants = function(e) {
    for (var n = "", o = 0; o < e.length; o++)
      n += goog.string.Const.unwrap(e[o]);
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(n);
  }, goog.html.TrustedResourceUrl.fromSafeScript = function(e) {
    return e = goog.fs.blob.getBlobWithProperties([goog.html.SafeScript.unwrap(e)], "text/javascript"), e = goog.fs.url.createObjectUrl(e), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(e) {
    return e = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(e) : e, new goog.html.TrustedResourceUrl(goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_, e);
  }, goog.html.TrustedResourceUrl.stringifyParams_ = function(e, n, o) {
    if (o == null)
      return n;
    if (typeof o == "string")
      return o ? e + encodeURIComponent(o) : "";
    for (var u in o) {
      var c = o[u];
      c = Array.isArray(c) ? c : [c];
      for (var d = 0; d < c.length; d++) {
        var m = c[d];
        m != null && (n || (n = e), n += (n.length > e.length ? "&" : "") + encodeURIComponent(u) + "=" + encodeURIComponent(String(m)));
      }
    }
    return n;
  }, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.internal = {}, goog.string.internal.startsWith = function(e, n) {
    return e.lastIndexOf(n, 0) == 0;
  }, goog.string.internal.endsWith = function(e, n) {
    var o = e.length - n.length;
    return 0 <= o && e.indexOf(n, o) == o;
  }, goog.string.internal.caseInsensitiveStartsWith = function(e, n) {
    return goog.string.internal.caseInsensitiveCompare(n, e.substr(0, n.length)) == 0;
  }, goog.string.internal.caseInsensitiveEndsWith = function(e, n) {
    return goog.string.internal.caseInsensitiveCompare(n, e.substr(e.length - n.length, n.length)) == 0;
  }, goog.string.internal.caseInsensitiveEquals = function(e, n) {
    return e.toLowerCase() == n.toLowerCase();
  }, goog.string.internal.isEmptyOrWhitespace = function(e) {
    return /^[\s\xa0]*$/.test(e);
  }, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(e) {
    return e.trim();
  } : function(e) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
  }, goog.string.internal.caseInsensitiveCompare = function(e, n) {
    return e = String(e).toLowerCase(), n = String(n).toLowerCase(), e < n ? -1 : e == n ? 0 : 1;
  }, goog.string.internal.newLineToBr = function(e, n) {
    return e.replace(/(\r\n|\r|\n)/g, n ? "<br />" : "<br>");
  }, goog.string.internal.htmlEscape = function(e, n) {
    if (n)
      e = e.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
    else {
      if (!goog.string.internal.ALL_RE_.test(e))
        return e;
      e.indexOf("&") != -1 && (e = e.replace(goog.string.internal.AMP_RE_, "&amp;")), e.indexOf("<") != -1 && (e = e.replace(
        goog.string.internal.LT_RE_,
        "&lt;"
      )), e.indexOf(">") != -1 && (e = e.replace(goog.string.internal.GT_RE_, "&gt;")), e.indexOf('"') != -1 && (e = e.replace(goog.string.internal.QUOT_RE_, "&quot;")), e.indexOf("'") != -1 && (e = e.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), e.indexOf("\0") != -1 && (e = e.replace(goog.string.internal.NULL_RE_, "&#0;"));
    }
    return e;
  }, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function(e, n) {
    return goog.string.internal.newLineToBr(e.replace(/  /g, " &#160;"), n);
  }, goog.string.internal.contains = function(e, n) {
    return e.indexOf(n) != -1;
  }, goog.string.internal.caseInsensitiveContains = function(e, n) {
    return goog.string.internal.contains(e.toLowerCase(), n.toLowerCase());
  }, goog.string.internal.compareVersions = function(e, n) {
    var o = 0;
    e = goog.string.internal.trim(String(e)).split("."), n = goog.string.internal.trim(String(n)).split(".");
    for (var u = Math.max(e.length, n.length), c = 0; o == 0 && c < u; c++) {
      var d = e[c] || "", m = n[c] || "";
      do {
        if (d = /(\d*)(\D*)(.*)/.exec(d) || ["", "", "", ""], m = /(\d*)(\D*)(.*)/.exec(m) || ["", "", "", ""], d[0].length == 0 && m[0].length == 0)
          break;
        o = d[1].length == 0 ? 0 : parseInt(d[1], 10);
        var v = m[1].length == 0 ? 0 : parseInt(m[1], 10);
        o = goog.string.internal.compareElements_(o, v) || goog.string.internal.compareElements_(d[2].length == 0, m[2].length == 0) || goog.string.internal.compareElements_(d[2], m[2]), d = d[3], m = m[3];
      } while (o == 0);
    }
    return o;
  }, goog.string.internal.compareElements_ = function(e, n) {
    return e < n ? -1 : e > n ? 1 : 0;
  }, goog.html.SafeUrl = function(e, n) {
    this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = e === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && n || "", this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0, goog.html.SafeUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
  }, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
  }, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
    return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
  }), goog.html.SafeUrl.unwrap = function(e) {
    return e instanceof goog.html.SafeUrl && e.constructor === goog.html.SafeUrl && e.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeUrl");
  }, goog.html.SafeUrl.fromConstant = function(e) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
  }, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function(e) {
    return goog.html.SAFE_MIME_TYPE_PATTERN_.test(e);
  }, goog.html.SafeUrl.fromBlob = function(e) {
    return e = goog.html.SafeUrl.isSafeMimeType(e.type) ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SafeUrl.fromMediaSource = function(e) {
    return goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource"), e = e instanceof MediaSource ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.fromDataUrl = function(e) {
    e = e.replace(/(%0A|%0D)/g, "");
    var n = e.match(goog.html.DATA_URL_PATTERN_);
    return n = n && goog.html.SafeUrl.isSafeMimeType(n[1]), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(n ? e : goog.html.SafeUrl.INNOCUOUS_STRING);
  }, goog.html.SafeUrl.fromTelUrl = function(e) {
    return goog.string.internal.caseInsensitiveStartsWith(e, "tel:") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function(e) {
    return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(e)) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SafeUrl.fromFacebookMessengerUrl = function(e) {
    return goog.string.internal.caseInsensitiveStartsWith(e, "fb-messenger://share") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SafeUrl.fromWhatsAppUrl = function(e) {
    return goog.string.internal.caseInsensitiveStartsWith(e, "whatsapp://send") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SafeUrl.fromSmsUrl = function(e) {
    return goog.string.internal.caseInsensitiveStartsWith(e, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SafeUrl.isSmsUrlBodyValid_ = function(e) {
    var n = e.indexOf("#");
    if (0 < n && (e = e.substring(0, n)), n = e.match(/[?&]body=/gi), !n)
      return !0;
    if (1 < n.length)
      return !1;
    if (e = e.match(/[?&]body=([^&]*)/)[1], !e)
      return !0;
    try {
      decodeURIComponent(e);
    } catch {
      return !1;
    }
    return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(e);
  }, goog.html.SafeUrl.fromSshUrl = function(e) {
    return goog.string.internal.caseInsensitiveStartsWith(e, "ssh://") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(e, n) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, e, n);
  }, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(e, n) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, e, n);
  }, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(e, n) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, e, n);
  }, goog.html.SafeUrl.sanitizeExtensionUrl_ = function(e, n, o) {
    return (e = e.exec(n)) ? (e = e[1], (o instanceof goog.string.Const ? [goog.string.Const.unwrap(o)] : o.map(function(u) {
      return goog.string.Const.unwrap(u);
    })).indexOf(e) == -1 && (n = goog.html.SafeUrl.INNOCUOUS_STRING)) : n = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(n);
  }, goog.html.SafeUrl.fromTrustedResourceUrl = function(e) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(e));
  }, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.sanitize = function(e) {
    return e instanceof goog.html.SafeUrl ? e : (e = typeof e == "object" && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SAFE_URL_PATTERN_.test(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e));
  }, goog.html.SafeUrl.sanitizeAssertUnchanged = function(e, n) {
    return e instanceof goog.html.SafeUrl ? e : (e = typeof e == "object" && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), n && /^data:/i.test(e) && (n = goog.html.SafeUrl.fromDataUrl(e), n.getTypedStringValue() == e) ? n : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(e), "%s does not match the safe URL pattern", e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e)));
  }, goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(e) {
    return new goog.html.SafeUrl(goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_, e);
  }, goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeStyle = function() {
    this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "", this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyle.fromConstant = function(e) {
    return e = goog.string.Const.unwrap(e), e.length === 0 ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(e, ";"), "Last character of style string is not ';': " + e), goog.asserts.assert(goog.string.internal.contains(e, ":"), `Style string must contain at least one ':', to specify a "name: value" pair: ` + e), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(e));
  }, goog.html.SafeStyle.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
  }, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
    return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
  }), goog.html.SafeStyle.unwrap = function(e) {
    return e instanceof goog.html.SafeStyle && e.constructor === goog.html.SafeStyle && e.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyle");
  }, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(e) {
    return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(e);
  }, goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(e) {
    return this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = e, this;
  }, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function(e) {
    var n = "", o;
    for (o in e) {
      if (!/^[-_a-zA-Z0-9]+$/.test(o))
        throw Error("Name allows only [-_a-zA-Z0-9], got: " + o);
      var u = e[o];
      u != null && (u = Array.isArray(u) ? goog.array.map(u, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(u), n += o + ":" + u + ";");
    }
    return n ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(n) : goog.html.SafeStyle.EMPTY;
  }, goog.html.SafeStyle.sanitizePropertyValue_ = function(e) {
    if (e instanceof goog.html.SafeUrl)
      return 'url("' + goog.html.SafeUrl.unwrap(e).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
    if (e = e instanceof goog.string.Const ? goog.string.Const.unwrap(e) : goog.html.SafeStyle.sanitizePropertyValueString_(String(e)), /[{;}]/.test(e))
      throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [e]);
    return e;
  }, goog.html.SafeStyle.sanitizePropertyValueString_ = function(e) {
    var n = e.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
    if (goog.html.SafeStyle.VALUE_RE_.test(n)) {
      if (goog.html.SafeStyle.COMMENT_RE_.test(e))
        return goog.asserts.fail("String value disallows comments, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
      if (!goog.html.SafeStyle.hasBalancedQuotes_(e))
        return goog.asserts.fail("String value requires balanced quotes, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
      if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(e))
        return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
    } else
      return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
    return goog.html.SafeStyle.sanitizeUrl_(e);
  }, goog.html.SafeStyle.hasBalancedQuotes_ = function(e) {
    for (var n = !0, o = !0, u = 0; u < e.length; u++) {
      var c = e.charAt(u);
      c == "'" && o ? n = !n : c == '"' && n && (o = !o);
    }
    return n && o;
  }, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(e) {
    for (var n = !0, o = /^[-_a-zA-Z0-9]$/, u = 0; u < e.length; u++) {
      var c = e.charAt(u);
      if (c == "]") {
        if (n)
          return !1;
        n = !0;
      } else if (c == "[") {
        if (!n)
          return !1;
        n = !1;
      } else if (!n && !o.test(c))
        return !1;
    }
    return n;
  }, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = `[-,."'%_!# a-zA-Z0-9\\[\\]]`, goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" "), goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g"), goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function(e) {
    return e.replace(goog.html.SafeStyle.URL_RE_, function(n, o, u, c) {
      var d = "";
      return u = u.replace(/^(['"])(.*)\1$/, function(m, v, S) {
        return d = v, S;
      }), n = goog.html.SafeUrl.sanitize(u).getTypedStringValue(), o + d + n + d + c;
    });
  }, goog.html.SafeStyle.concat = function(e) {
    var n = "", o = function(u) {
      Array.isArray(u) ? goog.array.forEach(u, o) : n += goog.html.SafeStyle.unwrap(u);
    };
    return goog.array.forEach(arguments, o), n ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(n) : goog.html.SafeStyle.EMPTY;
  }, goog.html.SafeStyleSheet = function() {
    this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "", this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyleSheet.createRule = function(e, n) {
    if (goog.string.internal.contains(e, "<"))
      throw Error("Selector does not allow '<', got: " + e);
    var o = e.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
    if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(o))
      throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + e);
    if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(o))
      throw Error("() and [] in selector must be balanced, got: " + e);
    return n instanceof goog.html.SafeStyle || (n = goog.html.SafeStyle.create(n)), e = e + "{" + goog.html.SafeStyle.unwrap(n).replace(/</g, "\\3C ") + "}", goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e);
  }, goog.html.SafeStyleSheet.hasBalancedBrackets_ = function(e) {
    for (var n = { "(": ")", "[": "]" }, o = [], u = 0; u < e.length; u++) {
      var c = e[u];
      if (n[c])
        o.push(n[c]);
      else if (goog.object.contains(n, c) && o.pop() != c)
        return !1;
    }
    return o.length == 0;
  }, goog.html.SafeStyleSheet.concat = function(e) {
    var n = "", o = function(u) {
      Array.isArray(u) ? goog.array.forEach(u, o) : n += goog.html.SafeStyleSheet.unwrap(u);
    };
    return goog.array.forEach(arguments, o), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(n);
  }, goog.html.SafeStyleSheet.fromConstant = function(e) {
    return e = goog.string.Const.unwrap(e), e.length === 0 ? goog.html.SafeStyleSheet.EMPTY : (goog.asserts.assert(!goog.string.internal.contains(e, "<"), "Forbidden '<' character in style sheet string: " + e), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e));
  }, goog.html.SafeStyleSheet.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
  }, goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function() {
    return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
  }), goog.html.SafeStyleSheet.unwrap = function(e) {
    return e instanceof goog.html.SafeStyleSheet && e.constructor === goog.html.SafeStyleSheet && e.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyleSheet, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyleSheet");
  }, goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(e) {
    return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(e);
  }, goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(e) {
    return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = e, this;
  }, goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
    var e = goog.labs.userAgent.util.getNavigator_();
    return e && (e = e.userAgent) ? e : "";
  }, goog.labs.userAgent.util.getNavigator_ = function() {
    return goog.global.navigator;
  }, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function(e) {
    goog.labs.userAgent.util.userAgent_ = e || goog.labs.userAgent.util.getNativeUserAgentString_();
  }, goog.labs.userAgent.util.getUserAgent = function() {
    return goog.labs.userAgent.util.userAgent_;
  }, goog.labs.userAgent.util.matchUserAgent = function(e) {
    var n = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.contains(n, e);
  }, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(e) {
    var n = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.caseInsensitiveContains(n, e);
  }, goog.labs.userAgent.util.extractVersionTuples = function(e) {
    for (var n = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, o = [], u; u = n.exec(e); )
      o.push([u[1], u[2], u[3] || void 0]);
    return o;
  }, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Opera");
  }, goog.labs.userAgent.browser.matchIE_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
  }, goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
  }, goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edg/");
  }, goog.labs.userAgent.browser.matchOperaChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("OPR");
  }, goog.labs.userAgent.browser.matchFirefox_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
  }, goog.labs.userAgent.browser.matchSafari_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
  }, goog.labs.userAgent.browser.matchCoast_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Coast");
  }, goog.labs.userAgent.browser.matchIosWebview_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
  }, goog.labs.userAgent.browser.matchChrome_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
  }, goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
  }, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function() {
    return goog.labs.userAgent.util.matchUserAgent("Silk");
  }, goog.labs.userAgent.browser.getVersion = function() {
    function e(c) {
      return c = goog.array.find(c, u), o[c] || "";
    }
    var n = goog.labs.userAgent.util.getUserAgent();
    if (goog.labs.userAgent.browser.isIE())
      return goog.labs.userAgent.browser.getIEVersion_(n);
    n = goog.labs.userAgent.util.extractVersionTuples(n);
    var o = {};
    goog.array.forEach(n, function(c) {
      o[c[0]] = c[1];
    });
    var u = goog.partial(goog.object.containsKey, o);
    return goog.labs.userAgent.browser.isOpera() ? e(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? e(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? e(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? e(["Chrome", "CriOS", "HeadlessChrome"]) : (n = n[2]) && n[1] || "";
  }, goog.labs.userAgent.browser.isVersionOrHigher = function(e) {
    return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), e);
  }, goog.labs.userAgent.browser.getIEVersion_ = function(e) {
    var n = /rv: *([\d\.]*)/.exec(e);
    if (n && n[1])
      return n[1];
    n = "";
    var o = /MSIE +([\d\.]+)/.exec(e);
    if (o && o[1])
      if (e = /Trident\/(\d.\d)/.exec(e), o[1] == "7.0")
        if (e && e[1])
          switch (e[1]) {
            case "4.0":
              n = "8.0";
              break;
            case "5.0":
              n = "9.0";
              break;
            case "6.0":
              n = "10.0";
              break;
            case "7.0":
              n = "11.0";
          }
        else
          n = "7.0";
      else
        n = o[1];
    return n;
  }, goog.html.SafeHtml = function() {
    this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "", this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_, this.dir_ = null;
  }, goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG, goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeHtml.prototype.getDirection = function() {
    return this.dir_;
  }, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0, goog.html.SafeHtml.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
  }, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
    return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
  }), goog.html.SafeHtml.unwrap = function(e) {
    return goog.html.SafeHtml.unwrapTrustedHTML(e).toString();
  }, goog.html.SafeHtml.unwrapTrustedHTML = function(e) {
    return e instanceof goog.html.SafeHtml && e.constructor === goog.html.SafeHtml && e.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeHtml");
  }, goog.html.SafeHtml.htmlEscape = function(e) {
    if (e instanceof goog.html.SafeHtml)
      return e;
    var n = typeof e == "object", o = null;
    return n && e.implementsGoogI18nBidiDirectionalString && (o = e.getDirection()), e = n && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(e), o);
  }, goog.html.SafeHtml.htmlEscapePreservingNewlines = function(e) {
    return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
  }, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(e) {
    return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
  }, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.comment = function(e) {
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!--" + goog.string.internal.htmlEscape(e) + "-->", null);
  }, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = { action: !0, cite: !0, data: !0, formaction: !0, href: !0, manifest: !0, poster: !0, src: !0 }, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = { APPLET: !0, BASE: !0, EMBED: !0, IFRAME: !0, LINK: !0, MATH: !0, META: !0, OBJECT: !0, SCRIPT: !0, STYLE: !0, SVG: !0, TEMPLATE: !0 }, goog.html.SafeHtml.create = function(e, n, o) {
    return goog.html.SafeHtml.verifyTagName(String(e)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(e), n, o);
  }, goog.html.SafeHtml.verifyTagName = function(e) {
    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(e))
      throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + e + ">." : "");
    if (e.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_)
      throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + e + "> is not allowed for SafeHtml." : "");
  }, goog.html.SafeHtml.createIframe = function(e, n, o, u) {
    e && goog.html.TrustedResourceUrl.unwrap(e);
    var c = {};
    return c.src = e || null, c.srcdoc = n && goog.html.SafeHtml.unwrap(n), e = goog.html.SafeHtml.combineAttributes(c, { sandbox: "" }, o), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, u);
  }, goog.html.SafeHtml.createSandboxIframe = function(e, n, o, u) {
    if (!goog.html.SafeHtml.canUseSandboxIframe())
      throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
    var c = {};
    return c.src = e ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)) : null, c.srcdoc = n || null, c.sandbox = "", e = goog.html.SafeHtml.combineAttributes(c, {}, o), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, u);
  }, goog.html.SafeHtml.canUseSandboxIframe = function() {
    return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
  }, goog.html.SafeHtml.createScriptSrc = function(e, n) {
    return goog.html.TrustedResourceUrl.unwrap(e), e = goog.html.SafeHtml.combineAttributes({ src: e }, {}, n), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", e);
  }, goog.html.SafeHtml.createScript = function(e, n) {
    for (var o in n) {
      var u = o.toLowerCase();
      if (u == "language" || u == "src" || u == "text" || u == "type")
        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + u + '" attribute' : "");
    }
    for (o = "", e = goog.array.concat(e), u = 0; u < e.length; u++)
      o += goog.html.SafeScript.unwrap(e[u]);
    return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", n, e);
  }, goog.html.SafeHtml.createStyle = function(e, n) {
    n = goog.html.SafeHtml.combineAttributes({ type: "text/css" }, {}, n);
    var o = "";
    e = goog.array.concat(e);
    for (var u = 0; u < e.length; u++)
      o += goog.html.SafeStyleSheet.unwrap(e[u]);
    return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", n, e);
  }, goog.html.SafeHtml.createMetaRefresh = function(e, n) {
    return e = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(e, ";") && (e = "'" + e.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", { "http-equiv": "refresh", content: (n || 0) + "; url=" + e });
  }, goog.html.SafeHtml.getAttrNameAndValue_ = function(e, n, o) {
    if (o instanceof goog.string.Const)
      o = goog.string.Const.unwrap(o);
    else if (n.toLowerCase() == "style")
      if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE)
        o = goog.html.SafeHtml.getStyleValue_(o);
      else
        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
    else {
      if (/^on/i.test(n))
        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + n + '" requires goog.string.Const value, "' + o + '" given.' : "");
      if (n.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_)
        if (o instanceof goog.html.TrustedResourceUrl)
          o = goog.html.TrustedResourceUrl.unwrap(o);
        else if (o instanceof goog.html.SafeUrl)
          o = goog.html.SafeUrl.unwrap(o);
        else if (typeof o == "string")
          o = goog.html.SafeUrl.sanitize(o).getTypedStringValue();
        else
          throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + n + '" on tag "' + e + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + o + '" given.' : "");
    }
    return o.implementsGoogStringTypedString && (o = o.getTypedStringValue()), goog.asserts.assert(typeof o == "string" || typeof o == "number", "String or number value expected, got " + typeof o + " with value: " + o), n + '="' + goog.string.internal.htmlEscape(String(o)) + '"';
  }, goog.html.SafeHtml.getStyleValue_ = function(e) {
    if (!goog.isObject(e))
      throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof e + " given: " + e : "");
    return e instanceof goog.html.SafeStyle || (e = goog.html.SafeStyle.create(e)), goog.html.SafeStyle.unwrap(e);
  }, goog.html.SafeHtml.createWithDir = function(e, n, o, u) {
    return n = goog.html.SafeHtml.create(n, o, u), n.dir_ = e, n;
  }, goog.html.SafeHtml.join = function(e, n) {
    e = goog.html.SafeHtml.htmlEscape(e);
    var o = e.getDirection(), u = [], c = function(d) {
      Array.isArray(d) ? goog.array.forEach(d, c) : (d = goog.html.SafeHtml.htmlEscape(d), u.push(goog.html.SafeHtml.unwrap(d)), d = d.getDirection(), o == goog.i18n.bidi.Dir.NEUTRAL ? o = d : d != goog.i18n.bidi.Dir.NEUTRAL && o != d && (o = null));
    };
    return goog.array.forEach(n, c), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(u.join(goog.html.SafeHtml.unwrap(e)), o);
  }, goog.html.SafeHtml.concat = function(e) {
    return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
  }, goog.html.SafeHtml.concatWithDir = function(e, n) {
    var o = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
    return o.dir_ = e, o;
  }, goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(e, n) {
    return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(e, n);
  }, goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(e, n) {
    return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(e) : e, this.dir_ = n, this;
  }, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(e, n, o) {
    var u = null, c = "<" + e + goog.html.SafeHtml.stringifyAttributes(e, n);
    return o == null ? o = [] : Array.isArray(o) || (o = [o]), goog.dom.tags.isVoidTag(e.toLowerCase()) ? (goog.asserts.assert(!o.length, "Void tag <" + e + "> does not allow content."), c += ">") : (u = goog.html.SafeHtml.concat(o), c += ">" + goog.html.SafeHtml.unwrap(u) + "</" + e + ">", u = u.getDirection()), (e = n && n.dir) && (u = /^(ltr|rtl|auto)$/i.test(e) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(
      c,
      u
    );
  }, goog.html.SafeHtml.stringifyAttributes = function(e, n) {
    var o = "";
    if (n)
      for (var u in n) {
        if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(u))
          throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + u + '".' : "");
        var c = n[u];
        c != null && (o += " " + goog.html.SafeHtml.getAttrNameAndValue_(e, u, c));
      }
    return o;
  }, goog.html.SafeHtml.combineAttributes = function(e, n, o) {
    var u = {}, c;
    for (c in e)
      goog.asserts.assert(c.toLowerCase() == c, "Must be lower case"), u[c] = e[c];
    for (c in n)
      goog.asserts.assert(c.toLowerCase() == c, "Must be lower case"), u[c] = n[c];
    if (o)
      for (c in o) {
        var d = c.toLowerCase();
        if (d in e)
          throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + d + '" attribute, got "' + c + '" with value "' + o[c] + '"' : "");
        d in n && delete u[d], u[c] = o[c];
      }
    return u;
  }, goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(e, n, o) {
    return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(n, o || null);
  }, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(e, n) {
    return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(n);
  }, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(e, n) {
    return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(n);
  }, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(e, n) {
    return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(n);
  }, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(e, n) {
    return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(n);
  }, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(e, n) {
    return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(n);
  }, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = { AFTERBEGIN: "afterbegin", AFTEREND: "afterend", BEFOREBEGIN: "beforebegin", BEFOREEND: "beforeend" }, goog.dom.safe.insertAdjacentHtml = function(e, n, o) {
    e.insertAdjacentHTML(n, goog.html.SafeHtml.unwrapTrustedHTML(o));
  }, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = { MATH: !0, SCRIPT: !0, STYLE: !0, SVG: !0, TEMPLATE: !0 }, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
    if (goog.DEBUG && typeof document > "u")
      return !1;
    var e = document.createElement("div"), n = document.createElement("div");
    return n.appendChild(document.createElement("div")), e.appendChild(n), goog.DEBUG && !e.firstChild ? !1 : (n = e.firstChild.firstChild, e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !n.parentElement);
  }), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(e, n) {
    if (goog.dom.safe.isInnerHtmlCleanupRecursive_())
      for (; e.lastChild; )
        e.removeChild(e.lastChild);
    e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(n);
  }, goog.dom.safe.setInnerHtml = function(e, n) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var o = e.tagName.toUpperCase();
      if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[o])
        throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + e.tagName + ".");
    }
    goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(e, n);
  }, goog.dom.safe.setOuterHtml = function(e, n) {
    e.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(n);
  }, goog.dom.safe.setFormElementAction = function(e, n) {
    n = n instanceof goog.html.SafeUrl ? n : goog.html.SafeUrl.sanitizeAssertUnchanged(n), goog.dom.asserts.assertIsHTMLFormElement(e).action = goog.html.SafeUrl.unwrap(n);
  }, goog.dom.safe.setButtonFormAction = function(e, n) {
    n = n instanceof goog.html.SafeUrl ? n : goog.html.SafeUrl.sanitizeAssertUnchanged(n), goog.dom.asserts.assertIsHTMLButtonElement(e).formAction = goog.html.SafeUrl.unwrap(n);
  }, goog.dom.safe.setInputFormAction = function(e, n) {
    n = n instanceof goog.html.SafeUrl ? n : goog.html.SafeUrl.sanitizeAssertUnchanged(n), goog.dom.asserts.assertIsHTMLInputElement(e).formAction = goog.html.SafeUrl.unwrap(n);
  }, goog.dom.safe.setStyle = function(e, n) {
    e.style.cssText = goog.html.SafeStyle.unwrap(n);
  }, goog.dom.safe.documentWrite = function(e, n) {
    e.write(goog.html.SafeHtml.unwrapTrustedHTML(n));
  }, goog.dom.safe.setAnchorHref = function(e, n) {
    goog.dom.asserts.assertIsHTMLAnchorElement(e), n = n instanceof goog.html.SafeUrl ? n : goog.html.SafeUrl.sanitizeAssertUnchanged(n), e.href = goog.html.SafeUrl.unwrap(n);
  }, goog.dom.safe.setImageSrc = function(e, n) {
    if (goog.dom.asserts.assertIsHTMLImageElement(e), !(n instanceof goog.html.SafeUrl)) {
      var o = /^data:image\//i.test(n);
      n = goog.html.SafeUrl.sanitizeAssertUnchanged(n, o);
    }
    e.src = goog.html.SafeUrl.unwrap(n);
  }, goog.dom.safe.setAudioSrc = function(e, n) {
    if (goog.dom.asserts.assertIsHTMLAudioElement(e), !(n instanceof goog.html.SafeUrl)) {
      var o = /^data:audio\//i.test(n);
      n = goog.html.SafeUrl.sanitizeAssertUnchanged(n, o);
    }
    e.src = goog.html.SafeUrl.unwrap(n);
  }, goog.dom.safe.setVideoSrc = function(e, n) {
    if (goog.dom.asserts.assertIsHTMLVideoElement(e), !(n instanceof goog.html.SafeUrl)) {
      var o = /^data:video\//i.test(n);
      n = goog.html.SafeUrl.sanitizeAssertUnchanged(n, o);
    }
    e.src = goog.html.SafeUrl.unwrap(n);
  }, goog.dom.safe.setEmbedSrc = function(e, n) {
    goog.dom.asserts.assertIsHTMLEmbedElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(n);
  }, goog.dom.safe.setFrameSrc = function(e, n) {
    goog.dom.asserts.assertIsHTMLFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrap(n);
  }, goog.dom.safe.setIframeSrc = function(e, n) {
    goog.dom.asserts.assertIsHTMLIFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrap(n);
  }, goog.dom.safe.setIframeSrcdoc = function(e, n) {
    goog.dom.asserts.assertIsHTMLIFrameElement(e), e.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(n);
  }, goog.dom.safe.setLinkHrefAndRel = function(e, n, o) {
    goog.dom.asserts.assertIsHTMLLinkElement(e), e.rel = o, goog.string.internal.caseInsensitiveContains(o, "stylesheet") ? (goog.asserts.assert(n instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), e.href = goog.html.TrustedResourceUrl.unwrap(n)) : e.href = n instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(n) : n instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(n) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(n));
  }, goog.dom.safe.setObjectData = function(e, n) {
    goog.dom.asserts.assertIsHTMLObjectElement(e), e.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(n);
  }, goog.dom.safe.setScriptSrc = function(e, n) {
    goog.dom.asserts.assertIsHTMLScriptElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(n), (n = goog.getScriptNonce()) && e.setAttribute("nonce", n);
  }, goog.dom.safe.setScriptContent = function(e, n) {
    goog.dom.asserts.assertIsHTMLScriptElement(e), e.text = goog.html.SafeScript.unwrapTrustedScript(n), (n = goog.getScriptNonce()) && e.setAttribute("nonce", n);
  }, goog.dom.safe.setLocationHref = function(e, n) {
    goog.dom.asserts.assertIsLocation(e), n = n instanceof goog.html.SafeUrl ? n : goog.html.SafeUrl.sanitizeAssertUnchanged(n), e.href = goog.html.SafeUrl.unwrap(n);
  }, goog.dom.safe.assignLocation = function(e, n) {
    goog.dom.asserts.assertIsLocation(e), n = n instanceof goog.html.SafeUrl ? n : goog.html.SafeUrl.sanitizeAssertUnchanged(n), e.assign(goog.html.SafeUrl.unwrap(n));
  }, goog.dom.safe.replaceLocation = function(e, n) {
    n = n instanceof goog.html.SafeUrl ? n : goog.html.SafeUrl.sanitizeAssertUnchanged(n), e.replace(goog.html.SafeUrl.unwrap(n));
  }, goog.dom.safe.openInWindow = function(e, n, o, u, c) {
    return e = e instanceof goog.html.SafeUrl ? e : goog.html.SafeUrl.sanitizeAssertUnchanged(e), n = n || goog.global, o = o instanceof goog.string.Const ? goog.string.Const.unwrap(o) : o || "", n.open(goog.html.SafeUrl.unwrap(e), o, u, c);
  }, goog.dom.safe.parseFromStringHtml = function(e, n) {
    return goog.dom.safe.parseFromString(e, n, "text/html");
  }, goog.dom.safe.parseFromString = function(e, n, o) {
    return e.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(n), o);
  }, goog.dom.safe.createImageFromBlob = function(e) {
    if (!/^image\/.*/g.test(e.type))
      throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
    var n = goog.global.URL.createObjectURL(e);
    return e = new goog.global.Image(), e.onload = function() {
      goog.global.URL.revokeObjectURL(n);
    }, goog.dom.safe.setImageSrc(e, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), n)), e;
  }, goog.string.DETECT_DOUBLE_ESCAPING = !1, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1, goog.string.Unicode = { NBSP: " " }, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function(e, n) {
    for (var o = e.split("%s"), u = "", c = Array.prototype.slice.call(arguments, 1); c.length && 1 < o.length; )
      u += o.shift() + c.shift();
    return u + o.join("%s");
  }, goog.string.collapseWhitespace = function(e) {
    return e.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
  }, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function(e) {
    return e.length == 0;
  }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function(e) {
    return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(e));
  }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function(e) {
    return !/[^\t\n\r ]/.test(e);
  }, goog.string.isAlpha = function(e) {
    return !/[^a-zA-Z]/.test(e);
  }, goog.string.isNumeric = function(e) {
    return !/[^0-9]/.test(e);
  }, goog.string.isAlphaNumeric = function(e) {
    return !/[^a-zA-Z0-9]/.test(e);
  }, goog.string.isSpace = function(e) {
    return e == " ";
  }, goog.string.isUnicodeChar = function(e) {
    return e.length == 1 && " " <= e && "~" >= e || "" <= e && "�" >= e;
  }, goog.string.stripNewlines = function(e) {
    return e.replace(/(\r\n|\r|\n)+/g, " ");
  }, goog.string.canonicalizeNewlines = function(e) {
    return e.replace(/(\r\n|\r|\n)/g, `
`);
  }, goog.string.normalizeWhitespace = function(e) {
    return e.replace(/\xa0|\s/g, " ");
  }, goog.string.normalizeSpaces = function(e) {
    return e.replace(/\xa0|[ \t]+/g, " ");
  }, goog.string.collapseBreakingSpaces = function(e) {
    return e.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
  }, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function(e) {
    return e.replace(/^[\s\xa0]+/, "");
  }, goog.string.trimRight = function(e) {
    return e.replace(/[\s\xa0]+$/, "");
  }, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function(e, n, o) {
    if (e == n)
      return 0;
    if (!e)
      return -1;
    if (!n)
      return 1;
    for (var u = e.toLowerCase().match(o), c = n.toLowerCase().match(o), d = Math.min(u.length, c.length), m = 0; m < d; m++) {
      o = u[m];
      var v = c[m];
      if (o != v)
        return e = parseInt(o, 10), !isNaN(e) && (n = parseInt(v, 10), !isNaN(n) && e - n) ? e - n : o < v ? -1 : 1;
    }
    return u.length != c.length ? u.length - c.length : e < n ? -1 : 1;
  }, goog.string.intAwareCompare = function(e, n) {
    return goog.string.numberAwareCompare_(e, n, /\d+|\D+/g);
  }, goog.string.floatAwareCompare = function(e, n) {
    return goog.string.numberAwareCompare_(e, n, /\d+|\.\d+|\D+/g);
  }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function(e) {
    return encodeURIComponent(String(e));
  }, goog.string.urlDecode = function(e) {
    return decodeURIComponent(e.replace(/\+/g, " "));
  }, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function(e, n) {
    return e = goog.string.internal.htmlEscape(e, n), goog.string.DETECT_DOUBLE_ESCAPING && (e = e.replace(goog.string.E_RE_, "&#101;")), e;
  }, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function(e) {
    return goog.string.contains(e, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(e) : goog.string.unescapePureXmlEntities_(e) : e;
  }, goog.string.unescapeEntitiesWithDocument = function(e, n) {
    return goog.string.contains(e, "&") ? goog.string.unescapeEntitiesUsingDom_(e, n) : e;
  }, goog.string.unescapeEntitiesUsingDom_ = function(e, n) {
    var o = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"' }, u = n ? n.createElement("div") : goog.global.document.createElement("div");
    return e.replace(goog.string.HTML_ENTITY_PATTERN_, function(c, d) {
      var m = o[c];
      return m || (d.charAt(0) == "#" && (d = +("0" + d.substr(1)), isNaN(d) || (m = String.fromCharCode(d))), m || (goog.dom.safe.setInnerHtml(u, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(
        goog.string.Const.from("Single HTML entity."),
        c + " "
      )), m = u.firstChild.nodeValue.slice(0, -1)), o[c] = m);
    });
  }, goog.string.unescapePureXmlEntities_ = function(e) {
    return e.replace(/&([^;]+);/g, function(n, o) {
      switch (o) {
        case "amp":
          return "&";
        case "lt":
          return "<";
        case "gt":
          return ">";
        case "quot":
          return '"';
        default:
          return o.charAt(0) != "#" || (o = +("0" + o.substr(1)), isNaN(o)) ? n : String.fromCharCode(o);
      }
    });
  }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function(e, n) {
    return goog.string.newLineToBr(e.replace(/  /g, " &#160;"), n);
  }, goog.string.preserveSpaces = function(e) {
    return e.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
  }, goog.string.stripQuotes = function(e, n) {
    for (var o = n.length, u = 0; u < o; u++) {
      var c = o == 1 ? n : n.charAt(u);
      if (e.charAt(0) == c && e.charAt(e.length - 1) == c)
        return e.substring(1, e.length - 1);
    }
    return e;
  }, goog.string.truncate = function(e, n, o) {
    return o && (e = goog.string.unescapeEntities(e)), e.length > n && (e = e.substring(0, n - 3) + "..."), o && (e = goog.string.htmlEscape(e)), e;
  }, goog.string.truncateMiddle = function(e, n, o, u) {
    if (o && (e = goog.string.unescapeEntities(e)), u && e.length > n) {
      u > n && (u = n);
      var c = e.length - u;
      e = e.substring(0, n - u) + "..." + e.substring(c);
    } else
      e.length > n && (u = Math.floor(n / 2), c = e.length - u, e = e.substring(0, u + n % 2) + "..." + e.substring(c));
    return o && (e = goog.string.htmlEscape(e)), e;
  }, goog.string.specialEscapeChars_ = { "\0": "\\0", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\x0B", '"': '\\"', "\\": "\\\\", "<": "\\u003C" }, goog.string.jsEscapeCache_ = { "'": "\\'" }, goog.string.quote = function(e) {
    e = String(e);
    for (var n = ['"'], o = 0; o < e.length; o++) {
      var u = e.charAt(o), c = u.charCodeAt(0);
      n[o + 1] = goog.string.specialEscapeChars_[u] || (31 < c && 127 > c ? u : goog.string.escapeChar(u));
    }
    return n.push('"'), n.join("");
  }, goog.string.escapeString = function(e) {
    for (var n = [], o = 0; o < e.length; o++)
      n[o] = goog.string.escapeChar(e.charAt(o));
    return n.join("");
  }, goog.string.escapeChar = function(e) {
    if (e in goog.string.jsEscapeCache_)
      return goog.string.jsEscapeCache_[e];
    if (e in goog.string.specialEscapeChars_)
      return goog.string.jsEscapeCache_[e] = goog.string.specialEscapeChars_[e];
    var n = e.charCodeAt(0);
    if (31 < n && 127 > n)
      var o = e;
    else
      256 > n ? (o = "\\x", (16 > n || 256 < n) && (o += "0")) : (o = "\\u", 4096 > n && (o += "0")), o += n.toString(16).toUpperCase();
    return goog.string.jsEscapeCache_[e] = o;
  }, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function(e, n) {
    return e && n ? e.split(n).length - 1 : 0;
  }, goog.string.removeAt = function(e, n, o) {
    var u = e;
    return 0 <= n && n < e.length && 0 < o && (u = e.substr(0, n) + e.substr(n + o, e.length - n - o)), u;
  }, goog.string.remove = function(e, n) {
    return e.replace(n, "");
  }, goog.string.removeAll = function(e, n) {
    return n = new RegExp(goog.string.regExpEscape(n), "g"), e.replace(n, "");
  }, goog.string.replaceAll = function(e, n, o) {
    return n = new RegExp(goog.string.regExpEscape(n), "g"), e.replace(n, o.replace(/\$/g, "$$$$"));
  }, goog.string.regExpEscape = function(e) {
    return String(e).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
  }, goog.string.repeat = String.prototype.repeat ? function(e, n) {
    return e.repeat(n);
  } : function(e, n) {
    return Array(n + 1).join(e);
  }, goog.string.padNumber = function(e, n, o) {
    return e = o !== void 0 ? e.toFixed(o) : String(e), o = e.indexOf("."), o == -1 && (o = e.length), goog.string.repeat("0", Math.max(0, n - o)) + e;
  }, goog.string.makeSafe = function(e) {
    return e == null ? "" : String(e);
  }, goog.string.buildString = function(e) {
    return Array.prototype.join.call(arguments, "");
  }, goog.string.getRandomString = function() {
    return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
  }, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function(e) {
    for (var n = 0, o = 0; o < e.length; ++o)
      n = 31 * n + e.charCodeAt(o) >>> 0;
    return n;
  }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function() {
    return "goog_" + goog.string.uniqueStringCounter_++;
  }, goog.string.toNumber = function(e) {
    var n = Number(e);
    return n == 0 && goog.string.isEmptyOrWhitespace(e) ? NaN : n;
  }, goog.string.isLowerCamelCase = function(e) {
    return /^[a-z]+([A-Z][a-z]*)*$/.test(e);
  }, goog.string.isUpperCamelCase = function(e) {
    return /^([A-Z][a-z]*)+$/.test(e);
  }, goog.string.toCamelCase = function(e) {
    return String(e).replace(/\-([a-z])/g, function(n, o) {
      return o.toUpperCase();
    });
  }, goog.string.toSelectorCase = function(e) {
    return String(e).replace(/([A-Z])/g, "-$1").toLowerCase();
  }, goog.string.toTitleCase = function(e, n) {
    return n = typeof n == "string" ? goog.string.regExpEscape(n) : "\\s", e.replace(new RegExp("(^" + (n ? "|[" + n + "]+" : "") + ")([a-z])", "g"), function(o, u, c) {
      return u + c.toUpperCase();
    });
  }, goog.string.capitalize = function(e) {
    return String(e.charAt(0)).toUpperCase() + String(e.substr(1)).toLowerCase();
  }, goog.string.parseInt = function(e) {
    return isFinite(e) && (e = String(e)), typeof e == "string" ? /^\s*-?0x/i.test(e) ? parseInt(e, 16) : parseInt(e, 10) : NaN;
  }, goog.string.splitLimit = function(e, n, o) {
    e = e.split(n);
    for (var u = []; 0 < o && e.length; )
      u.push(e.shift()), o--;
    return e.length && u.push(e.join(n)), u;
  }, goog.string.lastComponent = function(e, n) {
    if (n)
      typeof n == "string" && (n = [n]);
    else
      return e;
    for (var o = -1, u = 0; u < n.length; u++)
      if (n[u] != "") {
        var c = e.lastIndexOf(n[u]);
        c > o && (o = c);
      }
    return o == -1 ? e : e.slice(o + 1);
  }, goog.string.editDistance = function(e, n) {
    var o = [], u = [];
    if (e == n)
      return 0;
    if (!e.length || !n.length)
      return Math.max(e.length, n.length);
    for (var c = 0; c < n.length + 1; c++)
      o[c] = c;
    for (c = 0; c < e.length; c++) {
      u[0] = c + 1;
      for (var d = 0; d < n.length; d++)
        u[d + 1] = Math.min(u[d] + 1, o[d + 1] + 1, o[d] + +(e[c] != n[d]));
      for (d = 0; d < o.length; d++)
        o[d] = u[d];
    }
    return u[n.length];
  }, goog.labs.userAgent.engine = {}, goog.labs.userAgent.engine.isPresto = function() {
    return goog.labs.userAgent.util.matchUserAgent("Presto");
  }, goog.labs.userAgent.engine.isTrident = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
  }, goog.labs.userAgent.engine.isEdge = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
  }, goog.labs.userAgent.engine.isWebKit = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
  }, goog.labs.userAgent.engine.isGecko = function() {
    return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
  }, goog.labs.userAgent.engine.getVersion = function() {
    var e = goog.labs.userAgent.util.getUserAgent();
    if (e) {
      e = goog.labs.userAgent.util.extractVersionTuples(e);
      var n = goog.labs.userAgent.engine.getEngineTuple_(e);
      if (n)
        return n[0] == "Gecko" ? goog.labs.userAgent.engine.getVersionForKey_(e, "Firefox") : n[1];
      e = e[0];
      var o;
      if (e && (o = e[2]) && (o = /Trident\/([^\s;]+)/.exec(o)))
        return o[1];
    }
    return "";
  }, goog.labs.userAgent.engine.getEngineTuple_ = function(e) {
    if (!goog.labs.userAgent.engine.isEdge())
      return e[1];
    for (var n = 0; n < e.length; n++) {
      var o = e[n];
      if (o[0] == "Edge")
        return o;
    }
  }, goog.labs.userAgent.engine.isVersionOrHigher = function(e) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), e);
  }, goog.labs.userAgent.engine.getVersionForKey_ = function(e, n) {
    return (e = goog.array.find(e, function(o) {
      return n == o[0];
    })) && e[1] || "";
  }, goog.labs.userAgent.platform = {}, goog.labs.userAgent.platform.isAndroid = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android");
  }, goog.labs.userAgent.platform.isIpod = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPod");
  }, goog.labs.userAgent.platform.isIphone = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
  }, goog.labs.userAgent.platform.isIpad = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPad");
  }, goog.labs.userAgent.platform.isIos = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
  }, goog.labs.userAgent.platform.isMacintosh = function() {
    return goog.labs.userAgent.util.matchUserAgent("Macintosh");
  }, goog.labs.userAgent.platform.isLinux = function() {
    return goog.labs.userAgent.util.matchUserAgent("Linux");
  }, goog.labs.userAgent.platform.isWindows = function() {
    return goog.labs.userAgent.util.matchUserAgent("Windows");
  }, goog.labs.userAgent.platform.isChromeOS = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrOS");
  }, goog.labs.userAgent.platform.isChromecast = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrKey");
  }, goog.labs.userAgent.platform.isKaiOS = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
  }, goog.labs.userAgent.platform.getVersion = function() {
    var e = goog.labs.userAgent.util.getUserAgent(), n = "";
    return goog.labs.userAgent.platform.isWindows() ? (n = /Windows (?:NT|Phone) ([0-9.]+)/, n = (e = n.exec(e)) ? e[1] : "0.0") : goog.labs.userAgent.platform.isIos() ? (n = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/, n = (e = n.exec(e)) && e[1].replace(/_/g, ".")) : goog.labs.userAgent.platform.isMacintosh() ? (n = /Mac OS X ([0-9_.]+)/, n = (e = n.exec(e)) ? e[1].replace(/_/g, ".") : "10") : goog.labs.userAgent.platform.isKaiOS() ? (n = /(?:KaiOS)\/(\S+)/i, n = (e = n.exec(e)) && e[1]) : goog.labs.userAgent.platform.isAndroid() ? (n = /Android\s+([^\);]+)(\)|;)/, n = (e = n.exec(e)) && e[1]) : goog.labs.userAgent.platform.isChromeOS() && (n = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/, n = (e = n.exec(e)) && e[1]), n || "";
  }, goog.labs.userAgent.platform.isVersionOrHigher = function(e) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), e);
  }, goog.reflect = {}, goog.reflect.object = function(e, n) {
    return n;
  }, goog.reflect.objectProperty = function(e, n) {
    return e;
  }, goog.reflect.sinkValue = function(e) {
    return goog.reflect.sinkValue[" "](e), e;
  }, goog.reflect.sinkValue[" "] = goog.nullFunction, goog.reflect.canAccessProperty = function(e, n) {
    try {
      return goog.reflect.sinkValue(e[n]), !0;
    } catch {
    }
    return !1;
  }, goog.reflect.cache = function(e, n, o, u) {
    return u = u ? u(n) : n, Object.prototype.hasOwnProperty.call(e, u) ? e[u] : e[u] = o(n);
  }, goog.userAgent = {}, goog.userAgent.ASSUME_IE = !1, goog.userAgent.ASSUME_EDGE = !1, goog.userAgent.ASSUME_GECKO = !1, goog.userAgent.ASSUME_WEBKIT = !1, goog.userAgent.ASSUME_MOBILE_WEBKIT = !1, goog.userAgent.ASSUME_OPERA = !1, goog.userAgent.ASSUME_ANY_VERSION = !1, goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA, goog.userAgent.getUserAgentString = function() {
    return goog.labs.userAgent.util.getUserAgent();
  }, goog.userAgent.getNavigatorTyped = function() {
    return goog.global.navigator || null;
  }, goog.userAgent.getNavigator = function() {
    return goog.userAgent.getNavigatorTyped();
  }, goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera(), goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE(), goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge(), goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE, goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko(), goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit(), goog.userAgent.isMobile_ = function() {
    return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
  }, goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_(), goog.userAgent.SAFARI = goog.userAgent.WEBKIT, goog.userAgent.determinePlatform_ = function() {
    var e = goog.userAgent.getNavigatorTyped();
    return e && e.platform || "";
  }, goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_(), goog.userAgent.ASSUME_MAC = !1, goog.userAgent.ASSUME_WINDOWS = !1, goog.userAgent.ASSUME_LINUX = !1, goog.userAgent.ASSUME_X11 = !1, goog.userAgent.ASSUME_ANDROID = !1, goog.userAgent.ASSUME_IPHONE = !1, goog.userAgent.ASSUME_IPAD = !1, goog.userAgent.ASSUME_IPOD = !1, goog.userAgent.ASSUME_KAIOS = !1, goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD, goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh(), goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows(), goog.userAgent.isLegacyLinux_ = function() {
    return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
  }, goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_(), goog.userAgent.isX11_ = function() {
    var e = goog.userAgent.getNavigatorTyped();
    return !!e && goog.string.contains(e.appVersion || "", "X11");
  }, goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_(), goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid(), goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone(), goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod(), goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos(), goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS(), goog.userAgent.determineVersion_ = function() {
    var e = "", n = goog.userAgent.getVersionRegexResult_();
    return n && (e = n ? n[1] : ""), goog.userAgent.IE && (n = goog.userAgent.getDocumentMode_(), n != null && n > parseFloat(e)) ? String(n) : e;
  }, goog.userAgent.getVersionRegexResult_ = function() {
    var e = goog.userAgent.getUserAgentString();
    if (goog.userAgent.GECKO)
      return /rv:([^\);]+)(\)|;)/.exec(e);
    if (goog.userAgent.EDGE)
      return /Edge\/([\d\.]+)/.exec(e);
    if (goog.userAgent.IE)
      return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(e);
    if (goog.userAgent.WEBKIT)
      return /WebKit\/(\S+)/.exec(e);
    if (goog.userAgent.OPERA)
      return /(?:Version)[ \/]?(\S+)/.exec(e);
  }, goog.userAgent.getDocumentMode_ = function() {
    var e = goog.global.document;
    return e ? e.documentMode : void 0;
  }, goog.userAgent.VERSION = goog.userAgent.determineVersion_(), goog.userAgent.compare = function(e, n) {
    return goog.string.compareVersions(e, n);
  }, goog.userAgent.isVersionOrHigherCache_ = {}, goog.userAgent.isVersionOrHigher = function(e) {
    return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, e, function() {
      return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, e);
    });
  }, goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher, goog.userAgent.isDocumentModeOrHigher = function(e) {
    return Number(goog.userAgent.DOCUMENT_MODE) >= e;
  }, goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher, goog.userAgent.DOCUMENT_MODE = function() {
    if (goog.global.document && goog.userAgent.IE) {
      var e = goog.userAgent.getDocumentMode_();
      return e || parseInt(goog.userAgent.VERSION, 10) || void 0;
    }
  }(), goog.userAgent.product = {}, goog.userAgent.product.ASSUME_FIREFOX = !1, goog.userAgent.product.ASSUME_IPHONE = !1, goog.userAgent.product.ASSUME_IPAD = !1, goog.userAgent.product.ASSUME_ANDROID = !1, goog.userAgent.product.ASSUME_CHROME = !1, goog.userAgent.product.ASSUME_SAFARI = !1, goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI, goog.userAgent.product.OPERA = goog.userAgent.OPERA, goog.userAgent.product.IE = goog.userAgent.IE, goog.userAgent.product.EDGE = goog.userAgent.EDGE, goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox(), goog.userAgent.product.isIphoneOrIpod_ = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
  }, goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_(), goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser(), goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome(), goog.userAgent.product.isSafariDesktop_ = function() {
    return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
  }, goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_(), goog.crypt.base64 = {}, goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=", goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.", goog.crypt.base64.Alphabet = { DEFAULT: 0, NO_PADDING: 1, WEBSAFE: 2, WEBSAFE_DOT_PADDING: 3, WEBSAFE_NO_PADDING: 4 }, goog.crypt.base64.paddingChars_ = "=.", goog.crypt.base64.isPadding_ = function(e) {
    return goog.string.contains(goog.crypt.base64.paddingChars_, e);
  }, goog.crypt.base64.byteToCharMaps_ = {}, goog.crypt.base64.charToByteMap_ = null, goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA, goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || typeof goog.global.btoa == "function", goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && typeof goog.global.atob == "function", goog.crypt.base64.encodeByteArray = function(e, n) {
    goog.asserts.assert(goog.isArrayLike(e), "encodeByteArray takes an array as a parameter"), n === void 0 && (n = goog.crypt.base64.Alphabet.DEFAULT), goog.crypt.base64.init_(), n = goog.crypt.base64.byteToCharMaps_[n];
    for (var o = [], u = 0; u < e.length; u += 3) {
      var c = e[u], d = u + 1 < e.length, m = d ? e[u + 1] : 0, v = u + 2 < e.length, S = v ? e[u + 2] : 0, $ = c >> 2;
      c = (c & 3) << 4 | m >> 4, m = (m & 15) << 2 | S >> 6, S &= 63, v || (S = 64, d || (m = 64)), o.push(n[$], n[c], n[m] || "", n[S] || "");
    }
    return o.join("");
  }, goog.crypt.base64.encodeString = function(e, n) {
    return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !n ? goog.global.btoa(e) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(e), n);
  }, goog.crypt.base64.decodeString = function(e, n) {
    if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !n)
      return goog.global.atob(e);
    var o = "";
    return goog.crypt.base64.decodeStringInternal_(e, function(u) {
      o += String.fromCharCode(u);
    }), o;
  }, goog.crypt.base64.decodeStringToByteArray = function(e, n) {
    var o = [];
    return goog.crypt.base64.decodeStringInternal_(e, function(u) {
      o.push(u);
    }), o;
  }, goog.crypt.base64.decodeStringToUint8Array = function(e) {
    goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
    var n = e.length, o = 3 * n / 4;
    o % 3 ? o = Math.floor(o) : goog.crypt.base64.isPadding_(e[n - 1]) && (o = goog.crypt.base64.isPadding_(e[n - 2]) ? o - 2 : o - 1);
    var u = new Uint8Array(o), c = 0;
    return goog.crypt.base64.decodeStringInternal_(e, function(d) {
      u[c++] = d;
    }), u.subarray(0, c);
  }, goog.crypt.base64.decodeStringInternal_ = function(e, n) {
    function o(S) {
      for (; u < e.length; ) {
        var $ = e.charAt(u++), E = goog.crypt.base64.charToByteMap_[$];
        if (E != null)
          return E;
        if (!goog.string.isEmptyOrWhitespace($))
          throw Error("Unknown base64 encoding at char: " + $);
      }
      return S;
    }
    goog.crypt.base64.init_();
    for (var u = 0; ; ) {
      var c = o(-1), d = o(0), m = o(64), v = o(64);
      if (v === 64 && c === -1)
        break;
      n(c << 2 | d >> 4), m != 64 && (n(d << 4 & 240 | m >> 2), v != 64 && n(m << 6 & 192 | v));
    }
  }, goog.crypt.base64.init_ = function() {
    if (!goog.crypt.base64.charToByteMap_) {
      goog.crypt.base64.charToByteMap_ = {};
      for (var e = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), n = ["+/=", "+/", "-_=", "-_.", "-_"], o = 0; 5 > o; o++) {
        var u = e.concat(n[o].split(""));
        goog.crypt.base64.byteToCharMaps_[o] = u;
        for (var c = 0; c < u.length; c++) {
          var d = u[c], m = goog.crypt.base64.charToByteMap_[d];
          m === void 0 ? goog.crypt.base64.charToByteMap_[d] = c : goog.asserts.assert(m === c);
        }
      }
    }
  }, jspb.utils = {}, jspb.utils.split64Low = 0, jspb.utils.split64High = 0, jspb.utils.splitUint64 = function(e) {
    var n = e >>> 0;
    e = Math.floor((e - n) / jspb.BinaryConstants.TWO_TO_32) >>> 0, jspb.utils.split64Low = n, jspb.utils.split64High = e;
  }, jspb.utils.splitInt64 = function(e) {
    var n = 0 > e;
    e = Math.abs(e);
    var o = e >>> 0;
    e = Math.floor((e - o) / jspb.BinaryConstants.TWO_TO_32), e >>>= 0, n && (e = ~e >>> 0, o = (~o >>> 0) + 1, 4294967295 < o && (o = 0, e++, 4294967295 < e && (e = 0))), jspb.utils.split64Low = o, jspb.utils.split64High = e;
  }, jspb.utils.splitZigzag64 = function(e) {
    var n = 0 > e;
    e = 2 * Math.abs(e), jspb.utils.splitUint64(e), e = jspb.utils.split64Low;
    var o = jspb.utils.split64High;
    n && (e == 0 ? o == 0 ? o = e = 4294967295 : (o--, e = 4294967295) : e--), jspb.utils.split64Low = e, jspb.utils.split64High = o;
  }, jspb.utils.splitFloat32 = function(e) {
    var n = 0 > e ? 1 : 0;
    if (e = n ? -e : e, e === 0)
      0 < 1 / e ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);
    else if (isNaN(e))
      jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;
    else if (e > jspb.BinaryConstants.FLOAT32_MAX)
      jspb.utils.split64High = 0, jspb.utils.split64Low = (n << 31 | 2139095040) >>> 0;
    else if (e < jspb.BinaryConstants.FLOAT32_MIN)
      e = Math.round(e / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (n << 31 | e) >>> 0;
    else {
      var o = Math.floor(Math.log(e) / Math.LN2);
      e *= Math.pow(2, -o), e = Math.round(e * jspb.BinaryConstants.TWO_TO_23), 16777216 <= e && ++o, jspb.utils.split64High = 0, jspb.utils.split64Low = (n << 31 | o + 127 << 23 | e & 8388607) >>> 0;
    }
  }, jspb.utils.splitFloat64 = function(e) {
    var n = 0 > e ? 1 : 0;
    if (e = n ? -e : e, e === 0)
      jspb.utils.split64High = 0 < 1 / e ? 0 : 2147483648, jspb.utils.split64Low = 0;
    else if (isNaN(e))
      jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;
    else if (e > jspb.BinaryConstants.FLOAT64_MAX)
      jspb.utils.split64High = (n << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;
    else if (e < jspb.BinaryConstants.FLOAT64_MIN) {
      var o = e / Math.pow(2, -1074);
      e = o / jspb.BinaryConstants.TWO_TO_32, jspb.utils.split64High = (n << 31 | e) >>> 0, jspb.utils.split64Low = o >>> 0;
    } else {
      o = e;
      var u = 0;
      if (2 <= o)
        for (; 2 <= o && 1023 > u; )
          u++, o /= 2;
      else
        for (; 1 > o && -1022 < u; )
          o *= 2, u--;
      o = e * Math.pow(2, -u), e = o * jspb.BinaryConstants.TWO_TO_20 & 1048575, o = o * jspb.BinaryConstants.TWO_TO_52 >>> 0, jspb.utils.split64High = (n << 31 | u + 1023 << 20 | e) >>> 0, jspb.utils.split64Low = o;
    }
  }, jspb.utils.splitHash64 = function(e) {
    var n = e.charCodeAt(0), o = e.charCodeAt(1), u = e.charCodeAt(2), c = e.charCodeAt(3), d = e.charCodeAt(4), m = e.charCodeAt(5), v = e.charCodeAt(6);
    e = e.charCodeAt(7), jspb.utils.split64Low = n + (o << 8) + (u << 16) + (c << 24) >>> 0, jspb.utils.split64High = d + (m << 8) + (v << 16) + (e << 24) >>> 0;
  }, jspb.utils.joinUint64 = function(e, n) {
    return n * jspb.BinaryConstants.TWO_TO_32 + (e >>> 0);
  }, jspb.utils.joinInt64 = function(e, n) {
    var o = n & 2147483648;
    return o && (e = ~e + 1 >>> 0, n = ~n >>> 0, e == 0 && (n = n + 1 >>> 0)), e = jspb.utils.joinUint64(e, n), o ? -e : e;
  }, jspb.utils.toZigzag64 = function(e, n, o) {
    var u = n >> 31;
    return o(e << 1 ^ u, (n << 1 | e >>> 31) ^ u);
  }, jspb.utils.joinZigzag64 = function(e, n) {
    return jspb.utils.fromZigzag64(e, n, jspb.utils.joinInt64);
  }, jspb.utils.fromZigzag64 = function(e, n, o) {
    var u = -(e & 1);
    return o((e >>> 1 | n << 31) ^ u, n >>> 1 ^ u);
  }, jspb.utils.joinFloat32 = function(e, n) {
    n = 2 * (e >> 31) + 1;
    var o = e >>> 23 & 255;
    return e &= 8388607, o == 255 ? e ? NaN : 1 / 0 * n : o == 0 ? n * Math.pow(2, -149) * e : n * Math.pow(2, o - 150) * (e + Math.pow(2, 23));
  }, jspb.utils.joinFloat64 = function(e, n) {
    var o = 2 * (n >> 31) + 1, u = n >>> 20 & 2047;
    return e = jspb.BinaryConstants.TWO_TO_32 * (n & 1048575) + e, u == 2047 ? e ? NaN : 1 / 0 * o : u == 0 ? o * Math.pow(2, -1074) * e : o * Math.pow(2, u - 1075) * (e + jspb.BinaryConstants.TWO_TO_52);
  }, jspb.utils.joinHash64 = function(e, n) {
    return String.fromCharCode(e >>> 0 & 255, e >>> 8 & 255, e >>> 16 & 255, e >>> 24 & 255, n >>> 0 & 255, n >>> 8 & 255, n >>> 16 & 255, n >>> 24 & 255);
  }, jspb.utils.DIGITS = "0123456789abcdef".split(""), jspb.utils.ZERO_CHAR_CODE_ = 48, jspb.utils.A_CHAR_CODE_ = 97, jspb.utils.joinUnsignedDecimalString = function(e, n) {
    function o(c, d) {
      return c = c ? String(c) : "", d ? "0000000".slice(c.length) + c : c;
    }
    if (2097151 >= n)
      return "" + jspb.utils.joinUint64(e, n);
    var u = (e >>> 24 | n << 8) >>> 0 & 16777215;
    return n = n >> 16 & 65535, e = (e & 16777215) + 6777216 * u + 6710656 * n, u += 8147497 * n, n *= 2, 1e7 <= e && (u += Math.floor(e / 1e7), e %= 1e7), 1e7 <= u && (n += Math.floor(u / 1e7), u %= 1e7), o(n, 0) + o(u, n) + o(e, 1);
  }, jspb.utils.joinSignedDecimalString = function(e, n) {
    var o = n & 2147483648;
    return o && (e = ~e + 1 >>> 0, n = ~n + (e == 0 ? 1 : 0) >>> 0), e = jspb.utils.joinUnsignedDecimalString(e, n), o ? "-" + e : e;
  }, jspb.utils.hash64ToDecimalString = function(e, n) {
    jspb.utils.splitHash64(e), e = jspb.utils.split64Low;
    var o = jspb.utils.split64High;
    return n ? jspb.utils.joinSignedDecimalString(e, o) : jspb.utils.joinUnsignedDecimalString(e, o);
  }, jspb.utils.hash64ArrayToDecimalStrings = function(e, n) {
    for (var o = Array(e.length), u = 0; u < e.length; u++)
      o[u] = jspb.utils.hash64ToDecimalString(e[u], n);
    return o;
  }, jspb.utils.decimalStringToHash64 = function(e) {
    function n(m, v) {
      for (var S = 0; 8 > S && (m !== 1 || 0 < v); S++)
        v = m * c[S] + v, c[S] = v & 255, v >>>= 8;
    }
    function o() {
      for (var m = 0; 8 > m; m++)
        c[m] = ~c[m] & 255;
    }
    jspb.asserts.assert(0 < e.length);
    var u = !1;
    e[0] === "-" && (u = !0, e = e.slice(1));
    for (var c = [0, 0, 0, 0, 0, 0, 0, 0], d = 0; d < e.length; d++)
      n(10, e.charCodeAt(d) - jspb.utils.ZERO_CHAR_CODE_);
    return u && (o(), n(1, 1)), goog.crypt.byteArrayToString(c);
  }, jspb.utils.splitDecimalString = function(e) {
    jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e));
  }, jspb.utils.toHexDigit_ = function(e) {
    return String.fromCharCode(10 > e ? jspb.utils.ZERO_CHAR_CODE_ + e : jspb.utils.A_CHAR_CODE_ - 10 + e);
  }, jspb.utils.fromHexCharCode_ = function(e) {
    return e >= jspb.utils.A_CHAR_CODE_ ? e - jspb.utils.A_CHAR_CODE_ + 10 : e - jspb.utils.ZERO_CHAR_CODE_;
  }, jspb.utils.hash64ToHexString = function(e) {
    var n = Array(18);
    n[0] = "0", n[1] = "x";
    for (var o = 0; 8 > o; o++) {
      var u = e.charCodeAt(7 - o);
      n[2 * o + 2] = jspb.utils.toHexDigit_(u >> 4), n[2 * o + 3] = jspb.utils.toHexDigit_(u & 15);
    }
    return n.join("");
  }, jspb.utils.hexStringToHash64 = function(e) {
    e = e.toLowerCase(), jspb.asserts.assert(e.length == 18), jspb.asserts.assert(e[0] == "0"), jspb.asserts.assert(e[1] == "x");
    for (var n = "", o = 0; 8 > o; o++) {
      var u = jspb.utils.fromHexCharCode_(e.charCodeAt(2 * o + 2)), c = jspb.utils.fromHexCharCode_(e.charCodeAt(2 * o + 3));
      n = String.fromCharCode(16 * u + c) + n;
    }
    return n;
  }, jspb.utils.hash64ToNumber = function(e, n) {
    jspb.utils.splitHash64(e), e = jspb.utils.split64Low;
    var o = jspb.utils.split64High;
    return n ? jspb.utils.joinInt64(e, o) : jspb.utils.joinUint64(e, o);
  }, jspb.utils.numberToHash64 = function(e) {
    return jspb.utils.splitInt64(e), jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.utils.countVarints = function(e, n, o) {
    for (var u = 0, c = n; c < o; c++)
      u += e[c] >> 7;
    return o - n - u;
  }, jspb.utils.countVarintFields = function(e, n, o, u) {
    var c = 0;
    if (u = 8 * u + jspb.BinaryConstants.WireType.VARINT, 128 > u)
      for (; n < o && e[n++] == u; )
        for (c++; ; ) {
          var d = e[n++];
          if (!(d & 128))
            break;
        }
    else
      for (; n < o; ) {
        for (d = u; 128 < d; ) {
          if (e[n] != (d & 127 | 128))
            return c;
          n++, d >>= 7;
        }
        if (e[n++] != d)
          break;
        for (c++; d = e[n++], (d & 128) != 0; )
          ;
      }
    return c;
  }, jspb.utils.countFixedFields_ = function(e, n, o, u, c) {
    var d = 0;
    if (128 > u)
      for (; n < o && e[n++] == u; )
        d++, n += c;
    else
      for (; n < o; ) {
        for (var m = u; 128 < m; ) {
          if (e[n++] != (m & 127 | 128))
            return d;
          m >>= 7;
        }
        if (e[n++] != m)
          break;
        d++, n += c;
      }
    return d;
  }, jspb.utils.countFixed32Fields = function(e, n, o, u) {
    return jspb.utils.countFixedFields_(e, n, o, 8 * u + jspb.BinaryConstants.WireType.FIXED32, 4);
  }, jspb.utils.countFixed64Fields = function(e, n, o, u) {
    return jspb.utils.countFixedFields_(e, n, o, 8 * u + jspb.BinaryConstants.WireType.FIXED64, 8);
  }, jspb.utils.countDelimitedFields = function(e, n, o, u) {
    var c = 0;
    for (u = 8 * u + jspb.BinaryConstants.WireType.DELIMITED; n < o; ) {
      for (var d = u; 128 < d; ) {
        if (e[n++] != (d & 127 | 128))
          return c;
        d >>= 7;
      }
      if (e[n++] != d)
        break;
      c++;
      for (var m = 0, v = 1; d = e[n++], m += (d & 127) * v, v *= 128, (d & 128) != 0; )
        ;
      n += m;
    }
    return c;
  }, jspb.utils.debugBytesToTextFormat = function(e) {
    var n = '"';
    if (e) {
      e = jspb.utils.byteSourceToUint8Array(e);
      for (var o = 0; o < e.length; o++)
        n += "\\x", 16 > e[o] && (n += "0"), n += e[o].toString(16);
    }
    return n + '"';
  }, jspb.utils.debugScalarToTextFormat = function(e) {
    return typeof e == "string" ? goog.string.quote(e) : e.toString();
  }, jspb.utils.stringToByteArray = function(e) {
    for (var n = new Uint8Array(e.length), o = 0; o < e.length; o++) {
      var u = e.charCodeAt(o);
      if (255 < u)
        throw Error("Conversion error: string contains codepoint outside of byte range");
      n[o] = u;
    }
    return n;
  }, jspb.utils.byteSourceToUint8Array = function(e) {
    return e.constructor === Uint8Array ? e : e.constructor === ArrayBuffer || e.constructor === Array ? new Uint8Array(e) : e.constructor === String ? goog.crypt.base64.decodeStringToUint8Array(e) : e instanceof Uint8Array ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : (jspb.asserts.fail("Type not convertible to Uint8Array."), new Uint8Array(0));
  }, jspb.BinaryDecoder = function(e, n, o) {
    this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1, e && this.setBlock(e, n, o);
  }, jspb.BinaryDecoder.instanceCache_ = [], jspb.BinaryDecoder.alloc = function(e, n, o) {
    if (jspb.BinaryDecoder.instanceCache_.length) {
      var u = jspb.BinaryDecoder.instanceCache_.pop();
      return e && u.setBlock(e, n, o), u;
    }
    return new jspb.BinaryDecoder(e, n, o);
  }, jspb.BinaryDecoder.prototype.free = function() {
    this.clear(), 100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
  }, jspb.BinaryDecoder.prototype.clone = function() {
    return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
  }, jspb.BinaryDecoder.prototype.clear = function() {
    this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1;
  }, jspb.BinaryDecoder.prototype.getBuffer = function() {
    return this.bytes_;
  }, jspb.BinaryDecoder.prototype.setBlock = function(e, n, o) {
    this.bytes_ = jspb.utils.byteSourceToUint8Array(e), this.start_ = n !== void 0 ? n : 0, this.end_ = o !== void 0 ? this.start_ + o : this.bytes_.length, this.cursor_ = this.start_;
  }, jspb.BinaryDecoder.prototype.getEnd = function() {
    return this.end_;
  }, jspb.BinaryDecoder.prototype.setEnd = function(e) {
    this.end_ = e;
  }, jspb.BinaryDecoder.prototype.reset = function() {
    this.cursor_ = this.start_;
  }, jspb.BinaryDecoder.prototype.getCursor = function() {
    return this.cursor_;
  }, jspb.BinaryDecoder.prototype.setCursor = function(e) {
    this.cursor_ = e;
  }, jspb.BinaryDecoder.prototype.advance = function(e) {
    this.cursor_ += e, jspb.asserts.assert(this.cursor_ <= this.end_);
  }, jspb.BinaryDecoder.prototype.atEnd = function() {
    return this.cursor_ == this.end_;
  }, jspb.BinaryDecoder.prototype.pastEnd = function() {
    return this.cursor_ > this.end_;
  }, jspb.BinaryDecoder.prototype.getError = function() {
    return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
  }, jspb.BinaryDecoder.prototype.readSplitVarint64 = function(e) {
    for (var n = 128, o = 0, u = 0, c = 0; 4 > c && 128 <= n; c++)
      n = this.bytes_[this.cursor_++], o |= (n & 127) << 7 * c;
    if (128 <= n && (n = this.bytes_[this.cursor_++], o |= (n & 127) << 28, u |= (n & 127) >> 4), 128 <= n)
      for (c = 0; 5 > c && 128 <= n; c++)
        n = this.bytes_[this.cursor_++], u |= (n & 127) << 7 * c + 3;
    if (128 > n)
      return e(o >>> 0, u >>> 0);
    jspb.asserts.fail("Failed to read varint, encoding is invalid."), this.error_ = !0;
  }, jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function(e) {
    return this.readSplitVarint64(function(n, o) {
      return jspb.utils.fromZigzag64(n, o, e);
    });
  }, jspb.BinaryDecoder.prototype.readSplitFixed64 = function(e) {
    var n = this.bytes_, o = this.cursor_;
    this.cursor_ += 8;
    for (var u = 0, c = 0, d = o + 7; d >= o; d--)
      u = u << 8 | n[d], c = c << 8 | n[d + 4];
    return e(u, c);
  }, jspb.BinaryDecoder.prototype.skipVarint = function() {
    for (; this.bytes_[this.cursor_] & 128; )
      this.cursor_++;
    this.cursor_++;
  }, jspb.BinaryDecoder.prototype.unskipVarint = function(e) {
    for (; 128 < e; )
      this.cursor_--, e >>>= 7;
    this.cursor_--;
  }, jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function() {
    var e = this.bytes_, n = e[this.cursor_ + 0], o = n & 127;
    return 128 > n ? (this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), o) : (n = e[this.cursor_ + 1], o |= (n & 127) << 7, 128 > n ? (this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), o) : (n = e[this.cursor_ + 2], o |= (n & 127) << 14, 128 > n ? (this.cursor_ += 3, jspb.asserts.assert(this.cursor_ <= this.end_), o) : (n = e[this.cursor_ + 3], o |= (n & 127) << 21, 128 > n ? (this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), o) : (n = e[this.cursor_ + 4], o |= (n & 15) << 28, 128 > n ? (this.cursor_ += 5, jspb.asserts.assert(this.cursor_ <= this.end_), o >>> 0) : (this.cursor_ += 5, 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && jspb.asserts.assert(!1), jspb.asserts.assert(this.cursor_ <= this.end_), o)))));
  }, jspb.BinaryDecoder.prototype.readSignedVarint32 = function() {
    return ~~this.readUnsignedVarint32();
  }, jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function() {
    return this.readUnsignedVarint32().toString();
  }, jspb.BinaryDecoder.prototype.readSignedVarint32String = function() {
    return this.readSignedVarint32().toString();
  }, jspb.BinaryDecoder.prototype.readZigzagVarint32 = function() {
    var e = this.readUnsignedVarint32();
    return e >>> 1 ^ -(e & 1);
  }, jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinUint64);
  }, jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
  }, jspb.BinaryDecoder.prototype.readSignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinInt64);
  }, jspb.BinaryDecoder.prototype.readSignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
  }, jspb.BinaryDecoder.prototype.readZigzagVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinZigzag64);
  }, jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
  }, jspb.BinaryDecoder.prototype.readZigzagVarint64String = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
  }, jspb.BinaryDecoder.prototype.readUint8 = function() {
    var e = this.bytes_[this.cursor_ + 0];
    return this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), e;
  }, jspb.BinaryDecoder.prototype.readUint16 = function() {
    var e = this.bytes_[this.cursor_ + 0], n = this.bytes_[this.cursor_ + 1];
    return this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), e << 0 | n << 8;
  }, jspb.BinaryDecoder.prototype.readUint32 = function() {
    var e = this.bytes_[this.cursor_ + 0], n = this.bytes_[this.cursor_ + 1], o = this.bytes_[this.cursor_ + 2], u = this.bytes_[this.cursor_ + 3];
    return this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), (e << 0 | n << 8 | o << 16 | u << 24) >>> 0;
  }, jspb.BinaryDecoder.prototype.readUint64 = function() {
    var e = this.readUint32(), n = this.readUint32();
    return jspb.utils.joinUint64(e, n);
  }, jspb.BinaryDecoder.prototype.readUint64String = function() {
    var e = this.readUint32(), n = this.readUint32();
    return jspb.utils.joinUnsignedDecimalString(e, n);
  }, jspb.BinaryDecoder.prototype.readInt8 = function() {
    var e = this.bytes_[this.cursor_ + 0];
    return this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), e << 24 >> 24;
  }, jspb.BinaryDecoder.prototype.readInt16 = function() {
    var e = this.bytes_[this.cursor_ + 0], n = this.bytes_[this.cursor_ + 1];
    return this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), (e << 0 | n << 8) << 16 >> 16;
  }, jspb.BinaryDecoder.prototype.readInt32 = function() {
    var e = this.bytes_[this.cursor_ + 0], n = this.bytes_[this.cursor_ + 1], o = this.bytes_[this.cursor_ + 2], u = this.bytes_[this.cursor_ + 3];
    return this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), e << 0 | n << 8 | o << 16 | u << 24;
  }, jspb.BinaryDecoder.prototype.readInt64 = function() {
    var e = this.readUint32(), n = this.readUint32();
    return jspb.utils.joinInt64(e, n);
  }, jspb.BinaryDecoder.prototype.readInt64String = function() {
    var e = this.readUint32(), n = this.readUint32();
    return jspb.utils.joinSignedDecimalString(e, n);
  }, jspb.BinaryDecoder.prototype.readFloat = function() {
    var e = this.readUint32();
    return jspb.utils.joinFloat32(e, 0);
  }, jspb.BinaryDecoder.prototype.readDouble = function() {
    var e = this.readUint32(), n = this.readUint32();
    return jspb.utils.joinFloat64(e, n);
  }, jspb.BinaryDecoder.prototype.readBool = function() {
    return !!this.bytes_[this.cursor_++];
  }, jspb.BinaryDecoder.prototype.readEnum = function() {
    return this.readSignedVarint32();
  }, jspb.BinaryDecoder.prototype.readString = function(e) {
    var n = this.bytes_, o = this.cursor_;
    e = o + e;
    for (var u = [], c = ""; o < e; ) {
      var d = n[o++];
      if (128 > d)
        u.push(d);
      else {
        if (192 > d)
          continue;
        if (224 > d) {
          var m = n[o++];
          u.push((d & 31) << 6 | m & 63);
        } else if (240 > d) {
          m = n[o++];
          var v = n[o++];
          u.push((d & 15) << 12 | (m & 63) << 6 | v & 63);
        } else if (248 > d) {
          m = n[o++], v = n[o++];
          var S = n[o++];
          d = (d & 7) << 18 | (m & 63) << 12 | (v & 63) << 6 | S & 63, d -= 65536, u.push((d >> 10 & 1023) + 55296, (d & 1023) + 56320);
        }
      }
      8192 <= u.length && (c += String.fromCharCode.apply(null, u), u.length = 0);
    }
    return c += goog.crypt.byteArrayToString(u), this.cursor_ = o, c;
  }, jspb.BinaryDecoder.prototype.readStringWithLength = function() {
    var e = this.readUnsignedVarint32();
    return this.readString(e);
  }, jspb.BinaryDecoder.prototype.readBytes = function(e) {
    if (0 > e || this.cursor_ + e > this.bytes_.length)
      return this.error_ = !0, jspb.asserts.fail("Invalid byte length!"), new Uint8Array(0);
    var n = this.bytes_.subarray(this.cursor_, this.cursor_ + e);
    return this.cursor_ += e, jspb.asserts.assert(this.cursor_ <= this.end_), n;
  }, jspb.BinaryDecoder.prototype.readVarintHash64 = function() {
    return this.readSplitVarint64(jspb.utils.joinHash64);
  }, jspb.BinaryDecoder.prototype.readFixedHash64 = function() {
    var e = this.bytes_, n = this.cursor_, o = e[n + 0], u = e[n + 1], c = e[n + 2], d = e[n + 3], m = e[n + 4], v = e[n + 5], S = e[n + 6];
    return e = e[n + 7], this.cursor_ += 8, String.fromCharCode(o, u, c, d, m, v, S, e);
  }, jspb.BinaryReader = function(e, n, o) {
    this.decoder_ = jspb.BinaryDecoder.alloc(e, n, o), this.fieldCursor_ = this.decoder_.getCursor(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null;
  }, jspb.BinaryReader.instanceCache_ = [], jspb.BinaryReader.alloc = function(e, n, o) {
    if (jspb.BinaryReader.instanceCache_.length) {
      var u = jspb.BinaryReader.instanceCache_.pop();
      return e && u.decoder_.setBlock(e, n, o), u;
    }
    return new jspb.BinaryReader(e, n, o);
  }, jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc, jspb.BinaryReader.prototype.free = function() {
    this.decoder_.clear(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null, 100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
  }, jspb.BinaryReader.prototype.getFieldCursor = function() {
    return this.fieldCursor_;
  }, jspb.BinaryReader.prototype.getCursor = function() {
    return this.decoder_.getCursor();
  }, jspb.BinaryReader.prototype.getBuffer = function() {
    return this.decoder_.getBuffer();
  }, jspb.BinaryReader.prototype.getFieldNumber = function() {
    return this.nextField_;
  }, goog.exportProperty(jspb.BinaryReader.prototype, "getFieldNumber", jspb.BinaryReader.prototype.getFieldNumber), jspb.BinaryReader.prototype.getWireType = function() {
    return this.nextWireType_;
  }, jspb.BinaryReader.prototype.isDelimited = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
  }, goog.exportProperty(jspb.BinaryReader.prototype, "isDelimited", jspb.BinaryReader.prototype.isDelimited), jspb.BinaryReader.prototype.isEndGroup = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
  }, goog.exportProperty(jspb.BinaryReader.prototype, "isEndGroup", jspb.BinaryReader.prototype.isEndGroup), jspb.BinaryReader.prototype.getError = function() {
    return this.error_ || this.decoder_.getError();
  }, jspb.BinaryReader.prototype.setBlock = function(e, n, o) {
    this.decoder_.setBlock(e, n, o), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
  }, jspb.BinaryReader.prototype.reset = function() {
    this.decoder_.reset(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
  }, jspb.BinaryReader.prototype.advance = function(e) {
    this.decoder_.advance(e);
  }, jspb.BinaryReader.prototype.nextField = function() {
    if (this.decoder_.atEnd())
      return !1;
    if (this.getError())
      return jspb.asserts.fail("Decoder hit an error"), !1;
    this.fieldCursor_ = this.decoder_.getCursor();
    var e = this.decoder_.readUnsignedVarint32(), n = e >>> 3;
    return e &= 7, e != jspb.BinaryConstants.WireType.VARINT && e != jspb.BinaryConstants.WireType.FIXED32 && e != jspb.BinaryConstants.WireType.FIXED64 && e != jspb.BinaryConstants.WireType.DELIMITED && e != jspb.BinaryConstants.WireType.START_GROUP && e != jspb.BinaryConstants.WireType.END_GROUP ? (jspb.asserts.fail(
      "Invalid wire type: %s (at position %s)",
      e,
      this.fieldCursor_
    ), this.error_ = !0, !1) : (this.nextField_ = n, this.nextWireType_ = e, !0);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "nextField", jspb.BinaryReader.prototype.nextField), jspb.BinaryReader.prototype.unskipHeader = function() {
    this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
  }, jspb.BinaryReader.prototype.skipMatchingFields = function() {
    var e = this.nextField_;
    for (this.unskipHeader(); this.nextField() && this.getFieldNumber() == e; )
      this.skipField();
    this.decoder_.atEnd() || this.unskipHeader();
  }, jspb.BinaryReader.prototype.skipVarintField = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (jspb.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
  }, jspb.BinaryReader.prototype.skipDelimitedField = function() {
    if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED)
      jspb.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();
    else {
      var e = this.decoder_.readUnsignedVarint32();
      this.decoder_.advance(e);
    }
  }, jspb.BinaryReader.prototype.skipFixed32Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (jspb.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
  }, jspb.BinaryReader.prototype.skipFixed64Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (jspb.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
  }, jspb.BinaryReader.prototype.skipGroup = function() {
    var e = this.nextField_;
    do {
      if (!this.nextField()) {
        jspb.asserts.fail("Unmatched start-group tag: stream EOF"), this.error_ = !0;
        break;
      }
      if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
        this.nextField_ != e && (jspb.asserts.fail("Unmatched end-group tag"), this.error_ = !0);
        break;
      }
      this.skipField();
    } while (1);
  }, jspb.BinaryReader.prototype.skipField = function() {
    switch (this.nextWireType_) {
      case jspb.BinaryConstants.WireType.VARINT:
        this.skipVarintField();
        break;
      case jspb.BinaryConstants.WireType.FIXED64:
        this.skipFixed64Field();
        break;
      case jspb.BinaryConstants.WireType.DELIMITED:
        this.skipDelimitedField();
        break;
      case jspb.BinaryConstants.WireType.FIXED32:
        this.skipFixed32Field();
        break;
      case jspb.BinaryConstants.WireType.START_GROUP:
        this.skipGroup();
        break;
      default:
        jspb.asserts.fail("Invalid wire encoding for field.");
    }
  }, jspb.BinaryReader.prototype.registerReadCallback = function(e, n) {
    this.readCallbacks_ === null && (this.readCallbacks_ = {}), jspb.asserts.assert(!this.readCallbacks_[e]), this.readCallbacks_[e] = n;
  }, jspb.BinaryReader.prototype.runReadCallback = function(e) {
    return jspb.asserts.assert(this.readCallbacks_ !== null), e = this.readCallbacks_[e], jspb.asserts.assert(e), e(this);
  }, jspb.BinaryReader.prototype.readAny = function(e) {
    this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(e);
    var n = jspb.BinaryConstants.FieldType;
    switch (e) {
      case n.DOUBLE:
        return this.readDouble();
      case n.FLOAT:
        return this.readFloat();
      case n.INT64:
        return this.readInt64();
      case n.UINT64:
        return this.readUint64();
      case n.INT32:
        return this.readInt32();
      case n.FIXED64:
        return this.readFixed64();
      case n.FIXED32:
        return this.readFixed32();
      case n.BOOL:
        return this.readBool();
      case n.STRING:
        return this.readString();
      case n.GROUP:
        jspb.asserts.fail("Group field type not supported in readAny()");
      case n.MESSAGE:
        jspb.asserts.fail("Message field type not supported in readAny()");
      case n.BYTES:
        return this.readBytes();
      case n.UINT32:
        return this.readUint32();
      case n.ENUM:
        return this.readEnum();
      case n.SFIXED32:
        return this.readSfixed32();
      case n.SFIXED64:
        return this.readSfixed64();
      case n.SINT32:
        return this.readSint32();
      case n.SINT64:
        return this.readSint64();
      case n.FHASH64:
        return this.readFixedHash64();
      case n.VHASH64:
        return this.readVarintHash64();
      default:
        jspb.asserts.fail("Invalid field type in readAny()");
    }
    return 0;
  }, jspb.BinaryReader.prototype.readMessage = function(e, n) {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var o = this.decoder_.getEnd(), u = this.decoder_.readUnsignedVarint32();
    u = this.decoder_.getCursor() + u, this.decoder_.setEnd(u), n(e, this), this.decoder_.setCursor(u), this.decoder_.setEnd(o);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readMessage", jspb.BinaryReader.prototype.readMessage), jspb.BinaryReader.prototype.readGroup = function(e, n, o) {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP), jspb.asserts.assert(this.nextField_ == e), o(n, this), this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (jspb.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = !0);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readGroup", jspb.BinaryReader.prototype.readGroup), jspb.BinaryReader.prototype.getFieldDecoder = function() {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var e = this.decoder_.readUnsignedVarint32(), n = this.decoder_.getCursor(), o = n + e;
    return e = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), n, e), this.decoder_.setCursor(o), e;
  }, jspb.BinaryReader.prototype.readInt32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readInt32", jspb.BinaryReader.prototype.readInt32), jspb.BinaryReader.prototype.readInt32String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32String();
  }, jspb.BinaryReader.prototype.readInt64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readInt64", jspb.BinaryReader.prototype.readInt64), jspb.BinaryReader.prototype.readInt64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64String();
  }, jspb.BinaryReader.prototype.readUint32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readUint32", jspb.BinaryReader.prototype.readUint32), jspb.BinaryReader.prototype.readUint32String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32String();
  }, jspb.BinaryReader.prototype.readUint64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readUint64", jspb.BinaryReader.prototype.readUint64), jspb.BinaryReader.prototype.readUint64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64String();
  }, jspb.BinaryReader.prototype.readSint32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readSint32", jspb.BinaryReader.prototype.readSint32), jspb.BinaryReader.prototype.readSint64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readSint64", jspb.BinaryReader.prototype.readSint64), jspb.BinaryReader.prototype.readSint64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64String();
  }, jspb.BinaryReader.prototype.readFixed32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readUint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readFixed32", jspb.BinaryReader.prototype.readFixed32), jspb.BinaryReader.prototype.readFixed64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readFixed64", jspb.BinaryReader.prototype.readFixed64), jspb.BinaryReader.prototype.readFixed64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64String();
  }, jspb.BinaryReader.prototype.readSfixed32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readSfixed32", jspb.BinaryReader.prototype.readSfixed32), jspb.BinaryReader.prototype.readSfixed32String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32().toString();
  }, jspb.BinaryReader.prototype.readSfixed64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readSfixed64", jspb.BinaryReader.prototype.readSfixed64), jspb.BinaryReader.prototype.readSfixed64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64String();
  }, jspb.BinaryReader.prototype.readFloat = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readFloat();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readFloat", jspb.BinaryReader.prototype.readFloat), jspb.BinaryReader.prototype.readDouble = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readDouble();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readDouble", jspb.BinaryReader.prototype.readDouble), jspb.BinaryReader.prototype.readBool = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), !!this.decoder_.readUnsignedVarint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readBool", jspb.BinaryReader.prototype.readBool), jspb.BinaryReader.prototype.readEnum = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readEnum", jspb.BinaryReader.prototype.readEnum), jspb.BinaryReader.prototype.readString = function() {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var e = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readString(e);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readString", jspb.BinaryReader.prototype.readString), jspb.BinaryReader.prototype.readBytes = function() {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var e = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readBytes(e);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readBytes", jspb.BinaryReader.prototype.readBytes), jspb.BinaryReader.prototype.readVarintHash64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readVarintHash64();
  }, jspb.BinaryReader.prototype.readSintHash64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarintHash64();
  }, jspb.BinaryReader.prototype.readSplitVarint64 = function(e) {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(e);
  }, jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function(e) {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(function(n, o) {
      return jspb.utils.fromZigzag64(n, o, e);
    });
  }, jspb.BinaryReader.prototype.readFixedHash64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readFixedHash64();
  }, jspb.BinaryReader.prototype.readSplitFixed64 = function(e) {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readSplitFixed64(e);
  }, jspb.BinaryReader.prototype.readPackedField_ = function(e) {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var n = this.decoder_.readUnsignedVarint32();
    n = this.decoder_.getCursor() + n;
    for (var o = []; this.decoder_.getCursor() < n; )
      o.push(e.call(this.decoder_));
    return o;
  }, jspb.BinaryReader.prototype.readPackedInt32 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedInt32", jspb.BinaryReader.prototype.readPackedInt32), jspb.BinaryReader.prototype.readPackedInt32String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32String);
  }, jspb.BinaryReader.prototype.readPackedInt64 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedInt64", jspb.BinaryReader.prototype.readPackedInt64), jspb.BinaryReader.prototype.readPackedInt64String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64String);
  }, jspb.BinaryReader.prototype.readPackedUint32 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedUint32", jspb.BinaryReader.prototype.readPackedUint32), jspb.BinaryReader.prototype.readPackedUint32String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
  }, jspb.BinaryReader.prototype.readPackedUint64 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedUint64", jspb.BinaryReader.prototype.readPackedUint64), jspb.BinaryReader.prototype.readPackedUint64String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
  }, jspb.BinaryReader.prototype.readPackedSint32 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSint32", jspb.BinaryReader.prototype.readPackedSint32), jspb.BinaryReader.prototype.readPackedSint64 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSint64", jspb.BinaryReader.prototype.readPackedSint64), jspb.BinaryReader.prototype.readPackedSint64String = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64String);
  }, jspb.BinaryReader.prototype.readPackedFixed32 = function() {
    return this.readPackedField_(this.decoder_.readUint32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFixed32", jspb.BinaryReader.prototype.readPackedFixed32), jspb.BinaryReader.prototype.readPackedFixed64 = function() {
    return this.readPackedField_(this.decoder_.readUint64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFixed64", jspb.BinaryReader.prototype.readPackedFixed64), jspb.BinaryReader.prototype.readPackedFixed64String = function() {
    return this.readPackedField_(this.decoder_.readUint64String);
  }, jspb.BinaryReader.prototype.readPackedSfixed32 = function() {
    return this.readPackedField_(this.decoder_.readInt32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSfixed32", jspb.BinaryReader.prototype.readPackedSfixed32), jspb.BinaryReader.prototype.readPackedSfixed64 = function() {
    return this.readPackedField_(this.decoder_.readInt64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSfixed64", jspb.BinaryReader.prototype.readPackedSfixed64), jspb.BinaryReader.prototype.readPackedSfixed64String = function() {
    return this.readPackedField_(this.decoder_.readInt64String);
  }, jspb.BinaryReader.prototype.readPackedFloat = function() {
    return this.readPackedField_(this.decoder_.readFloat);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFloat", jspb.BinaryReader.prototype.readPackedFloat), jspb.BinaryReader.prototype.readPackedDouble = function() {
    return this.readPackedField_(this.decoder_.readDouble);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedDouble", jspb.BinaryReader.prototype.readPackedDouble), jspb.BinaryReader.prototype.readPackedBool = function() {
    return this.readPackedField_(this.decoder_.readBool);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedBool", jspb.BinaryReader.prototype.readPackedBool), jspb.BinaryReader.prototype.readPackedEnum = function() {
    return this.readPackedField_(this.decoder_.readEnum);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedEnum", jspb.BinaryReader.prototype.readPackedEnum), jspb.BinaryReader.prototype.readPackedVarintHash64 = function() {
    return this.readPackedField_(this.decoder_.readVarintHash64);
  }, jspb.BinaryReader.prototype.readPackedFixedHash64 = function() {
    return this.readPackedField_(this.decoder_.readFixedHash64);
  }, jspb.BinaryEncoder = function() {
    this.buffer_ = [];
  }, jspb.BinaryEncoder.prototype.length = function() {
    return this.buffer_.length;
  }, jspb.BinaryEncoder.prototype.end = function() {
    var e = this.buffer_;
    return this.buffer_ = [], e;
  }, jspb.BinaryEncoder.prototype.writeSplitVarint64 = function(e, n) {
    for (jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(n == Math.floor(n)), jspb.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), jspb.asserts.assert(0 <= n && n < jspb.BinaryConstants.TWO_TO_32); 0 < n || 127 < e; )
      this.buffer_.push(e & 127 | 128), e = (e >>> 7 | n << 25) >>> 0, n >>>= 7;
    this.buffer_.push(e);
  }, jspb.BinaryEncoder.prototype.writeSplitFixed64 = function(e, n) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(n == Math.floor(n)), jspb.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), jspb.asserts.assert(0 <= n && n < jspb.BinaryConstants.TWO_TO_32), this.writeUint32(e), this.writeUint32(n);
  }, jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function(e) {
    for (jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32); 127 < e; )
      this.buffer_.push(e & 127 | 128), e >>>= 7;
    this.buffer_.push(e);
  }, jspb.BinaryEncoder.prototype.writeSignedVarint32 = function(e) {
    if (jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), 0 <= e)
      this.writeUnsignedVarint32(e);
    else {
      for (var n = 0; 9 > n; n++)
        this.buffer_.push(e & 127 | 128), e >>= 7;
      this.buffer_.push(1);
    }
  }, jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitInt64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeSignedVarint64 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.writeUnsignedVarint32((e << 1 ^ e >> 31) >>> 0);
  }, jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitZigzag64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function(e) {
    this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(e));
  }, jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function(e) {
    var n = this;
    jspb.utils.splitHash64(e), jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function(o, u) {
      n.writeSplitVarint64(o >>> 0, u >>> 0);
    });
  }, jspb.BinaryEncoder.prototype.writeUint8 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(0 <= e && 256 > e), this.buffer_.push(e >>> 0 & 255);
  }, jspb.BinaryEncoder.prototype.writeUint16 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(0 <= e && 65536 > e), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255);
  }, jspb.BinaryEncoder.prototype.writeUint32 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255), this.buffer_.push(e >>> 16 & 255), this.buffer_.push(e >>> 24 & 255);
  }, jspb.BinaryEncoder.prototype.writeUint64 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitUint64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeInt8 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(-128 <= e && 128 > e), this.buffer_.push(e >>> 0 & 255);
  }, jspb.BinaryEncoder.prototype.writeInt16 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(-32768 <= e && 32768 > e), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255);
  }, jspb.BinaryEncoder.prototype.writeInt32 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255), this.buffer_.push(e >>> 16 & 255), this.buffer_.push(e >>> 24 & 255);
  }, jspb.BinaryEncoder.prototype.writeInt64 = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeInt64String = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(+e >= -jspb.BinaryConstants.TWO_TO_63 && +e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e)), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeFloat = function(e) {
    jspb.asserts.assert(e === 1 / 0 || e === -1 / 0 || isNaN(e) || e >= -jspb.BinaryConstants.FLOAT32_MAX && e <= jspb.BinaryConstants.FLOAT32_MAX), jspb.utils.splitFloat32(e), this.writeUint32(jspb.utils.split64Low);
  }, jspb.BinaryEncoder.prototype.writeDouble = function(e) {
    jspb.asserts.assert(e === 1 / 0 || e === -1 / 0 || isNaN(e) || e >= -jspb.BinaryConstants.FLOAT64_MAX && e <= jspb.BinaryConstants.FLOAT64_MAX), jspb.utils.splitFloat64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeBool = function(e) {
    jspb.asserts.assert(typeof e == "boolean" || typeof e == "number"), this.buffer_.push(e ? 1 : 0);
  }, jspb.BinaryEncoder.prototype.writeEnum = function(e) {
    jspb.asserts.assert(e == Math.floor(e)), jspb.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32(e);
  }, jspb.BinaryEncoder.prototype.writeBytes = function(e) {
    this.buffer_.push.apply(this.buffer_, e);
  }, jspb.BinaryEncoder.prototype.writeVarintHash64 = function(e) {
    jspb.utils.splitHash64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeFixedHash64 = function(e) {
    jspb.utils.splitHash64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeString = function(e) {
    var n = this.buffer_.length;
    jspb.asserts.assertString(e);
    for (var o = 0; o < e.length; o++) {
      var u = e.charCodeAt(o);
      if (128 > u)
        this.buffer_.push(u);
      else if (2048 > u)
        this.buffer_.push(u >> 6 | 192), this.buffer_.push(u & 63 | 128);
      else if (65536 > u)
        if (55296 <= u && 56319 >= u && o + 1 < e.length) {
          var c = e.charCodeAt(o + 1);
          56320 <= c && 57343 >= c && (u = 1024 * (u - 55296) + c - 56320 + 65536, this.buffer_.push(u >> 18 | 240), this.buffer_.push(u >> 12 & 63 | 128), this.buffer_.push(u >> 6 & 63 | 128), this.buffer_.push(u & 63 | 128), o++);
        } else
          this.buffer_.push(u >> 12 | 224), this.buffer_.push(u >> 6 & 63 | 128), this.buffer_.push(u & 63 | 128);
    }
    return this.buffer_.length - n;
  }, jspb.arith = {}, jspb.arith.UInt64 = function(e, n) {
    this.lo = e, this.hi = n;
  }, jspb.arith.UInt64.prototype.cmp = function(e) {
    return this.hi < e.hi || this.hi == e.hi && this.lo < e.lo ? -1 : this.hi == e.hi && this.lo == e.lo ? 0 : 1;
  }, jspb.arith.UInt64.prototype.rightShift = function() {
    return new jspb.arith.UInt64((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
  }, jspb.arith.UInt64.prototype.leftShift = function() {
    return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
  }, jspb.arith.UInt64.prototype.msb = function() {
    return !!(this.hi & 2147483648);
  }, jspb.arith.UInt64.prototype.lsb = function() {
    return !!(this.lo & 1);
  }, jspb.arith.UInt64.prototype.zero = function() {
    return this.lo == 0 && this.hi == 0;
  }, jspb.arith.UInt64.prototype.add = function(e) {
    return new jspb.arith.UInt64((this.lo + e.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e.lo ? 1 : 0) >>> 0);
  }, jspb.arith.UInt64.prototype.sub = function(e) {
    return new jspb.arith.UInt64((this.lo - e.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e.hi & 4294967295) >>> 0) - (0 > this.lo - e.lo ? 1 : 0) >>> 0);
  }, jspb.arith.UInt64.mul32x32 = function(e, n) {
    var o = e & 65535;
    e >>>= 16;
    var u = n & 65535, c = n >>> 16;
    for (n = o * u + 65536 * (o * c & 65535) + 65536 * (e * u & 65535), o = e * c + (o * c >>> 16) + (e * u >>> 16); 4294967296 <= n; )
      n -= 4294967296, o += 1;
    return new jspb.arith.UInt64(n >>> 0, o >>> 0);
  }, jspb.arith.UInt64.prototype.mul = function(e) {
    var n = jspb.arith.UInt64.mul32x32(this.lo, e);
    return e = jspb.arith.UInt64.mul32x32(this.hi, e), e.hi = e.lo, e.lo = 0, n.add(e);
  }, jspb.arith.UInt64.prototype.div = function(e) {
    if (e == 0)
      return [];
    var n = new jspb.arith.UInt64(0, 0), o = new jspb.arith.UInt64(this.lo, this.hi);
    e = new jspb.arith.UInt64(e, 0);
    for (var u = new jspb.arith.UInt64(1, 0); !e.msb(); )
      e = e.leftShift(), u = u.leftShift();
    for (; !u.zero(); )
      0 >= e.cmp(o) && (n = n.add(u), o = o.sub(e)), e = e.rightShift(), u = u.rightShift();
    return [n, o];
  }, jspb.arith.UInt64.prototype.toString = function() {
    for (var e = "", n = this; !n.zero(); ) {
      n = n.div(10);
      var o = n[0];
      e = n[1].lo + e, n = o;
    }
    return e == "" && (e = "0"), e;
  }, jspb.arith.UInt64.fromString = function(e) {
    for (var n = new jspb.arith.UInt64(0, 0), o = new jspb.arith.UInt64(0, 0), u = 0; u < e.length; u++) {
      if ("0" > e[u] || "9" < e[u])
        return null;
      var c = parseInt(e[u], 10);
      o.lo = c, n = n.mul(10).add(o);
    }
    return n;
  }, jspb.arith.UInt64.prototype.clone = function() {
    return new jspb.arith.UInt64(this.lo, this.hi);
  }, jspb.arith.Int64 = function(e, n) {
    this.lo = e, this.hi = n;
  }, jspb.arith.Int64.prototype.add = function(e) {
    return new jspb.arith.Int64((this.lo + e.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e.lo ? 1 : 0) >>> 0);
  }, jspb.arith.Int64.prototype.sub = function(e) {
    return new jspb.arith.Int64((this.lo - e.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e.hi & 4294967295) >>> 0) - (0 > this.lo - e.lo ? 1 : 0) >>> 0);
  }, jspb.arith.Int64.prototype.clone = function() {
    return new jspb.arith.Int64(this.lo, this.hi);
  }, jspb.arith.Int64.prototype.toString = function() {
    var e = (this.hi & 2147483648) != 0, n = new jspb.arith.UInt64(this.lo, this.hi);
    return e && (n = new jspb.arith.UInt64(0, 0).sub(n)), (e ? "-" : "") + n.toString();
  }, jspb.arith.Int64.fromString = function(e) {
    var n = 0 < e.length && e[0] == "-";
    return n && (e = e.substring(1)), e = jspb.arith.UInt64.fromString(e), e === null ? null : (n && (e = new jspb.arith.UInt64(0, 0).sub(e)), new jspb.arith.Int64(e.lo, e.hi));
  }, jspb.BinaryWriter = function() {
    this.blocks_ = [], this.totalLength_ = 0, this.encoder_ = new jspb.BinaryEncoder(), this.bookmarks_ = [];
  }, jspb.BinaryWriter.prototype.appendUint8Array_ = function(e) {
    var n = this.encoder_.end();
    this.blocks_.push(n), this.blocks_.push(e), this.totalLength_ += n.length + e.length;
  }, jspb.BinaryWriter.prototype.beginDelimited_ = function(e) {
    return this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), e = this.encoder_.end(), this.blocks_.push(e), this.totalLength_ += e.length, e.push(this.totalLength_), e;
  }, jspb.BinaryWriter.prototype.endDelimited_ = function(e) {
    var n = e.pop();
    for (n = this.totalLength_ + this.encoder_.length() - n, jspb.asserts.assert(0 <= n); 127 < n; )
      e.push(n & 127 | 128), n >>>= 7, this.totalLength_++;
    e.push(n), this.totalLength_++;
  }, jspb.BinaryWriter.prototype.writeSerializedMessage = function(e, n, o) {
    this.appendUint8Array_(e.subarray(n, o));
  }, jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function(e, n, o) {
    e != null && n != null && o != null && this.writeSerializedMessage(e, n, o);
  }, jspb.BinaryWriter.prototype.reset = function() {
    this.blocks_ = [], this.encoder_.end(), this.totalLength_ = 0, this.bookmarks_ = [];
  }, jspb.BinaryWriter.prototype.getResultBuffer = function() {
    jspb.asserts.assert(this.bookmarks_.length == 0);
    for (var e = new Uint8Array(this.totalLength_ + this.encoder_.length()), n = this.blocks_, o = n.length, u = 0, c = 0; c < o; c++) {
      var d = n[c];
      e.set(d, u), u += d.length;
    }
    return n = this.encoder_.end(), e.set(n, u), u += n.length, jspb.asserts.assert(u == e.length), this.blocks_ = [e], e;
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "getResultBuffer", jspb.BinaryWriter.prototype.getResultBuffer), jspb.BinaryWriter.prototype.getResultBase64String = function(e) {
    return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), e);
  }, jspb.BinaryWriter.prototype.beginSubMessage = function(e) {
    this.bookmarks_.push(this.beginDelimited_(e));
  }, jspb.BinaryWriter.prototype.endSubMessage = function() {
    jspb.asserts.assert(0 <= this.bookmarks_.length), this.endDelimited_(this.bookmarks_.pop());
  }, jspb.BinaryWriter.prototype.writeFieldHeader_ = function(e, n) {
    jspb.asserts.assert(1 <= e && e == Math.floor(e)), this.encoder_.writeUnsignedVarint32(8 * e + n);
  }, jspb.BinaryWriter.prototype.writeAny = function(e, n, o) {
    var u = jspb.BinaryConstants.FieldType;
    switch (e) {
      case u.DOUBLE:
        this.writeDouble(n, o);
        break;
      case u.FLOAT:
        this.writeFloat(n, o);
        break;
      case u.INT64:
        this.writeInt64(n, o);
        break;
      case u.UINT64:
        this.writeUint64(n, o);
        break;
      case u.INT32:
        this.writeInt32(n, o);
        break;
      case u.FIXED64:
        this.writeFixed64(n, o);
        break;
      case u.FIXED32:
        this.writeFixed32(n, o);
        break;
      case u.BOOL:
        this.writeBool(n, o);
        break;
      case u.STRING:
        this.writeString(n, o);
        break;
      case u.GROUP:
        jspb.asserts.fail("Group field type not supported in writeAny()");
        break;
      case u.MESSAGE:
        jspb.asserts.fail("Message field type not supported in writeAny()");
        break;
      case u.BYTES:
        this.writeBytes(n, o);
        break;
      case u.UINT32:
        this.writeUint32(n, o);
        break;
      case u.ENUM:
        this.writeEnum(n, o);
        break;
      case u.SFIXED32:
        this.writeSfixed32(n, o);
        break;
      case u.SFIXED64:
        this.writeSfixed64(n, o);
        break;
      case u.SINT32:
        this.writeSint32(n, o);
        break;
      case u.SINT64:
        this.writeSint64(n, o);
        break;
      case u.FHASH64:
        this.writeFixedHash64(n, o);
        break;
      case u.VHASH64:
        this.writeVarintHash64(n, o);
        break;
      default:
        jspb.asserts.fail("Invalid field type in writeAny()");
    }
  }, jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(n));
  }, jspb.BinaryWriter.prototype.writeSignedVarint32_ = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(n));
  }, jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(n));
  }, jspb.BinaryWriter.prototype.writeSignedVarint64_ = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(n));
  }, jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(n));
  }, jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(n));
  }, jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(n));
  }, jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(n));
  }, jspb.BinaryWriter.prototype.writeInt32 = function(e, n) {
    n != null && (jspb.asserts.assert(n >= -jspb.BinaryConstants.TWO_TO_31 && n < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e, n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeInt32", jspb.BinaryWriter.prototype.writeInt32), jspb.BinaryWriter.prototype.writeInt32String = function(e, n) {
    n != null && (n = parseInt(n, 10), jspb.asserts.assert(n >= -jspb.BinaryConstants.TWO_TO_31 && n < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e, n));
  }, jspb.BinaryWriter.prototype.writeInt64 = function(e, n) {
    n != null && (jspb.asserts.assert(n >= -jspb.BinaryConstants.TWO_TO_63 && n < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(e, n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeInt64", jspb.BinaryWriter.prototype.writeInt64), jspb.BinaryWriter.prototype.writeInt64String = function(e, n) {
    n != null && (n = jspb.arith.Int64.fromString(n), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(n.lo, n.hi));
  }, jspb.BinaryWriter.prototype.writeUint32 = function(e, n) {
    n != null && (jspb.asserts.assert(0 <= n && n < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e, n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeUint32", jspb.BinaryWriter.prototype.writeUint32), jspb.BinaryWriter.prototype.writeUint32String = function(e, n) {
    n != null && (n = parseInt(n, 10), jspb.asserts.assert(0 <= n && n < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e, n));
  }, jspb.BinaryWriter.prototype.writeUint64 = function(e, n) {
    n != null && (jspb.asserts.assert(0 <= n && n < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(e, n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeUint64", jspb.BinaryWriter.prototype.writeUint64), jspb.BinaryWriter.prototype.writeUint64String = function(e, n) {
    n != null && (n = jspb.arith.UInt64.fromString(n), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(n.lo, n.hi));
  }, jspb.BinaryWriter.prototype.writeSint32 = function(e, n) {
    n != null && (jspb.asserts.assert(n >= -jspb.BinaryConstants.TWO_TO_31 && n < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(e, n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSint32", jspb.BinaryWriter.prototype.writeSint32), jspb.BinaryWriter.prototype.writeSint64 = function(e, n) {
    n != null && (jspb.asserts.assert(n >= -jspb.BinaryConstants.TWO_TO_63 && n < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(e, n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSint64", jspb.BinaryWriter.prototype.writeSint64), jspb.BinaryWriter.prototype.writeSintHash64 = function(e, n) {
    n != null && this.writeZigzagVarintHash64_(e, n);
  }, jspb.BinaryWriter.prototype.writeSint64String = function(e, n) {
    n != null && this.writeZigzagVarint64String_(e, n);
  }, jspb.BinaryWriter.prototype.writeFixed32 = function(e, n) {
    n != null && (jspb.asserts.assert(0 <= n && n < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFixed32", jspb.BinaryWriter.prototype.writeFixed32), jspb.BinaryWriter.prototype.writeFixed64 = function(e, n) {
    n != null && (jspb.asserts.assert(0 <= n && n < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFixed64", jspb.BinaryWriter.prototype.writeFixed64), jspb.BinaryWriter.prototype.writeFixed64String = function(e, n) {
    n != null && (n = jspb.arith.UInt64.fromString(n), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(n.lo, n.hi));
  }, jspb.BinaryWriter.prototype.writeSfixed32 = function(e, n) {
    n != null && (jspb.asserts.assert(n >= -jspb.BinaryConstants.TWO_TO_31 && n < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSfixed32", jspb.BinaryWriter.prototype.writeSfixed32), jspb.BinaryWriter.prototype.writeSfixed64 = function(e, n) {
    n != null && (jspb.asserts.assert(n >= -jspb.BinaryConstants.TWO_TO_63 && n < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSfixed64", jspb.BinaryWriter.prototype.writeSfixed64), jspb.BinaryWriter.prototype.writeSfixed64String = function(e, n) {
    n != null && (n = jspb.arith.Int64.fromString(n), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(n.lo, n.hi));
  }, jspb.BinaryWriter.prototype.writeFloat = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFloat", jspb.BinaryWriter.prototype.writeFloat), jspb.BinaryWriter.prototype.writeDouble = function(e, n) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeDouble", jspb.BinaryWriter.prototype.writeDouble), jspb.BinaryWriter.prototype.writeBool = function(e, n) {
    n != null && (jspb.asserts.assert(typeof n == "boolean" || typeof n == "number"), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeBool", jspb.BinaryWriter.prototype.writeBool), jspb.BinaryWriter.prototype.writeEnum = function(e, n) {
    n != null && (jspb.asserts.assert(n >= -jspb.BinaryConstants.TWO_TO_31 && n < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeEnum", jspb.BinaryWriter.prototype.writeEnum), jspb.BinaryWriter.prototype.writeString = function(e, n) {
    n != null && (e = this.beginDelimited_(e), this.encoder_.writeString(n), this.endDelimited_(e));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeString", jspb.BinaryWriter.prototype.writeString), jspb.BinaryWriter.prototype.writeBytes = function(e, n) {
    n != null && (n = jspb.utils.byteSourceToUint8Array(n), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(n.length), this.appendUint8Array_(n));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeBytes", jspb.BinaryWriter.prototype.writeBytes), jspb.BinaryWriter.prototype.writeMessage = function(e, n, o) {
    n != null && (e = this.beginDelimited_(e), o(n, this), this.endDelimited_(e));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeMessage", jspb.BinaryWriter.prototype.writeMessage), jspb.BinaryWriter.prototype.writeMessageSet = function(e, n, o) {
    n != null && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(e), e = this.beginDelimited_(3), o(n, this), this.endDelimited_(e), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
  }, jspb.BinaryWriter.prototype.writeGroup = function(e, n, o) {
    n != null && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.START_GROUP), o(n, this), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.END_GROUP));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeGroup", jspb.BinaryWriter.prototype.writeGroup), jspb.BinaryWriter.prototype.writeFixedHash64 = function(e, n) {
    n != null && (jspb.asserts.assert(n.length == 8), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(n));
  }, jspb.BinaryWriter.prototype.writeVarintHash64 = function(e, n) {
    n != null && (jspb.asserts.assert(n.length == 8), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(n));
  }, jspb.BinaryWriter.prototype.writeSplitFixed64 = function(e, n, o) {
    this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(n, o);
  }, jspb.BinaryWriter.prototype.writeSplitVarint64 = function(e, n, o) {
    this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(n, o);
  }, jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function(e, n, o) {
    this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT);
    var u = this.encoder_;
    jspb.utils.toZigzag64(n, o, function(c, d) {
      u.writeSplitVarint64(c >>> 0, d >>> 0);
    });
  }, jspb.BinaryWriter.prototype.writeRepeatedInt32 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeSignedVarint32_(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedInt32", jspb.BinaryWriter.prototype.writeRepeatedInt32), jspb.BinaryWriter.prototype.writeRepeatedInt32String = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeInt32String(e, n[o]);
  }, jspb.BinaryWriter.prototype.writeRepeatedInt64 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeSignedVarint64_(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedInt64", jspb.BinaryWriter.prototype.writeRepeatedInt64), jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function(e, n, o, u) {
    if (n != null)
      for (var c = 0; c < n.length; c++)
        this.writeSplitFixed64(e, o(n[c]), u(n[c]));
  }, jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function(e, n, o, u) {
    if (n != null)
      for (var c = 0; c < n.length; c++)
        this.writeSplitVarint64(e, o(n[c]), u(n[c]));
  }, jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function(e, n, o, u) {
    if (n != null)
      for (var c = 0; c < n.length; c++)
        this.writeSplitZigzagVarint64(e, o(n[c]), u(n[c]));
  }, jspb.BinaryWriter.prototype.writeRepeatedInt64String = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeInt64String(e, n[o]);
  }, jspb.BinaryWriter.prototype.writeRepeatedUint32 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeUnsignedVarint32_(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedUint32", jspb.BinaryWriter.prototype.writeRepeatedUint32), jspb.BinaryWriter.prototype.writeRepeatedUint32String = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeUint32String(e, n[o]);
  }, jspb.BinaryWriter.prototype.writeRepeatedUint64 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeUnsignedVarint64_(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedUint64", jspb.BinaryWriter.prototype.writeRepeatedUint64), jspb.BinaryWriter.prototype.writeRepeatedUint64String = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeUint64String(e, n[o]);
  }, jspb.BinaryWriter.prototype.writeRepeatedSint32 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeZigzagVarint32_(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSint32", jspb.BinaryWriter.prototype.writeRepeatedSint32), jspb.BinaryWriter.prototype.writeRepeatedSint64 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeZigzagVarint64_(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSint64", jspb.BinaryWriter.prototype.writeRepeatedSint64), jspb.BinaryWriter.prototype.writeRepeatedSint64String = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeZigzagVarint64String_(e, n[o]);
  }, jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeZigzagVarintHash64_(e, n[o]);
  }, jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeFixed32(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed32", jspb.BinaryWriter.prototype.writeRepeatedFixed32), jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeFixed64(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed64", jspb.BinaryWriter.prototype.writeRepeatedFixed64), jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeFixed64String(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed64String", jspb.BinaryWriter.prototype.writeRepeatedFixed64String), jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeSfixed32(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSfixed32", jspb.BinaryWriter.prototype.writeRepeatedSfixed32), jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeSfixed64(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSfixed64", jspb.BinaryWriter.prototype.writeRepeatedSfixed64), jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeSfixed64String(e, n[o]);
  }, jspb.BinaryWriter.prototype.writeRepeatedFloat = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeFloat(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFloat", jspb.BinaryWriter.prototype.writeRepeatedFloat), jspb.BinaryWriter.prototype.writeRepeatedDouble = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeDouble(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedDouble", jspb.BinaryWriter.prototype.writeRepeatedDouble), jspb.BinaryWriter.prototype.writeRepeatedBool = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeBool(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedBool", jspb.BinaryWriter.prototype.writeRepeatedBool), jspb.BinaryWriter.prototype.writeRepeatedEnum = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeEnum(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedEnum", jspb.BinaryWriter.prototype.writeRepeatedEnum), jspb.BinaryWriter.prototype.writeRepeatedString = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeString(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedString", jspb.BinaryWriter.prototype.writeRepeatedString), jspb.BinaryWriter.prototype.writeRepeatedBytes = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeBytes(e, n[o]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedBytes", jspb.BinaryWriter.prototype.writeRepeatedBytes), jspb.BinaryWriter.prototype.writeRepeatedMessage = function(e, n, o) {
    if (n != null)
      for (var u = 0; u < n.length; u++) {
        var c = this.beginDelimited_(e);
        o(n[u], this), this.endDelimited_(c);
      }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedMessage", jspb.BinaryWriter.prototype.writeRepeatedMessage), jspb.BinaryWriter.prototype.writeRepeatedGroup = function(e, n, o) {
    if (n != null)
      for (var u = 0; u < n.length; u++)
        this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.START_GROUP), o(n[u], this), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.END_GROUP);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedGroup", jspb.BinaryWriter.prototype.writeRepeatedGroup), jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeFixedHash64(e, n[o]);
  }, jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function(e, n) {
    if (n != null)
      for (var o = 0; o < n.length; o++)
        this.writeVarintHash64(e, n[o]);
  }, jspb.BinaryWriter.prototype.writePackedInt32 = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeSignedVarint32(n[o]);
      this.endDelimited_(e);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedInt32", jspb.BinaryWriter.prototype.writePackedInt32), jspb.BinaryWriter.prototype.writePackedInt32String = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeSignedVarint32(parseInt(n[o], 10));
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedInt64 = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeSignedVarint64(n[o]);
      this.endDelimited_(e);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedInt64", jspb.BinaryWriter.prototype.writePackedInt64), jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function(e, n, o, u) {
    if (n != null) {
      e = this.beginDelimited_(e);
      for (var c = 0; c < n.length; c++)
        this.encoder_.writeSplitFixed64(o(n[c]), u(n[c]));
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function(e, n, o, u) {
    if (n != null) {
      e = this.beginDelimited_(e);
      for (var c = 0; c < n.length; c++)
        this.encoder_.writeSplitVarint64(o(n[c]), u(n[c]));
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function(e, n, o, u) {
    if (n != null) {
      e = this.beginDelimited_(e);
      for (var c = this.encoder_, d = 0; d < n.length; d++)
        jspb.utils.toZigzag64(o(n[d]), u(n[d]), function(m, v) {
          c.writeSplitVarint64(m >>> 0, v >>> 0);
        });
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedInt64String = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++) {
        var u = jspb.arith.Int64.fromString(n[o]);
        this.encoder_.writeSplitVarint64(u.lo, u.hi);
      }
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedUint32 = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeUnsignedVarint32(n[o]);
      this.endDelimited_(e);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedUint32", jspb.BinaryWriter.prototype.writePackedUint32), jspb.BinaryWriter.prototype.writePackedUint32String = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeUnsignedVarint32(parseInt(n[o], 10));
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedUint64 = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeUnsignedVarint64(n[o]);
      this.endDelimited_(e);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedUint64", jspb.BinaryWriter.prototype.writePackedUint64), jspb.BinaryWriter.prototype.writePackedUint64String = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++) {
        var u = jspb.arith.UInt64.fromString(n[o]);
        this.encoder_.writeSplitVarint64(u.lo, u.hi);
      }
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedSint32 = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeZigzagVarint32(n[o]);
      this.endDelimited_(e);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSint32", jspb.BinaryWriter.prototype.writePackedSint32), jspb.BinaryWriter.prototype.writePackedSint64 = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeZigzagVarint64(n[o]);
      this.endDelimited_(e);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSint64", jspb.BinaryWriter.prototype.writePackedSint64), jspb.BinaryWriter.prototype.writePackedSint64String = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(n[o]));
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedSintHash64 = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeZigzagVarintHash64(n[o]);
      this.endDelimited_(e);
    }
  }, jspb.BinaryWriter.prototype.writePackedFixed32 = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * n.length), e = 0; e < n.length; e++)
        this.encoder_.writeUint32(n[e]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFixed32", jspb.BinaryWriter.prototype.writePackedFixed32), jspb.BinaryWriter.prototype.writePackedFixed64 = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * n.length), e = 0; e < n.length; e++)
        this.encoder_.writeUint64(n[e]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFixed64", jspb.BinaryWriter.prototype.writePackedFixed64), jspb.BinaryWriter.prototype.writePackedFixed64String = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * n.length), e = 0; e < n.length; e++) {
        var o = jspb.arith.UInt64.fromString(n[e]);
        this.encoder_.writeSplitFixed64(o.lo, o.hi);
      }
  }, jspb.BinaryWriter.prototype.writePackedSfixed32 = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * n.length), e = 0; e < n.length; e++)
        this.encoder_.writeInt32(n[e]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSfixed32", jspb.BinaryWriter.prototype.writePackedSfixed32), jspb.BinaryWriter.prototype.writePackedSfixed64 = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * n.length), e = 0; e < n.length; e++)
        this.encoder_.writeInt64(n[e]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSfixed64", jspb.BinaryWriter.prototype.writePackedSfixed64), jspb.BinaryWriter.prototype.writePackedSfixed64String = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * n.length), e = 0; e < n.length; e++)
        this.encoder_.writeInt64String(n[e]);
  }, jspb.BinaryWriter.prototype.writePackedFloat = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * n.length), e = 0; e < n.length; e++)
        this.encoder_.writeFloat(n[e]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFloat", jspb.BinaryWriter.prototype.writePackedFloat), jspb.BinaryWriter.prototype.writePackedDouble = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * n.length), e = 0; e < n.length; e++)
        this.encoder_.writeDouble(n[e]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedDouble", jspb.BinaryWriter.prototype.writePackedDouble), jspb.BinaryWriter.prototype.writePackedBool = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(n.length), e = 0; e < n.length; e++)
        this.encoder_.writeBool(n[e]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedBool", jspb.BinaryWriter.prototype.writePackedBool), jspb.BinaryWriter.prototype.writePackedEnum = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeEnum(n[o]);
      this.endDelimited_(e);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedEnum", jspb.BinaryWriter.prototype.writePackedEnum), jspb.BinaryWriter.prototype.writePackedFixedHash64 = function(e, n) {
    if (n != null && n.length)
      for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * n.length), e = 0; e < n.length; e++)
        this.encoder_.writeFixedHash64(n[e]);
  }, jspb.BinaryWriter.prototype.writePackedVarintHash64 = function(e, n) {
    if (n != null && n.length) {
      e = this.beginDelimited_(e);
      for (var o = 0; o < n.length; o++)
        this.encoder_.writeVarintHash64(n[o]);
      this.endDelimited_(e);
    }
  }, jspb.Map = function(e, n) {
    this.arr_ = e, this.valueCtor_ = n, this.map_ = {}, this.arrClean = !0, 0 < this.arr_.length && this.loadFromArray_();
  }, goog.exportSymbol("jspb.Map", jspb.Map), jspb.Map.prototype.loadFromArray_ = function() {
    for (var e = 0; e < this.arr_.length; e++) {
      var n = this.arr_[e], o = n[0];
      this.map_[o.toString()] = new jspb.Map.Entry_(o, n[1]);
    }
    this.arrClean = !0;
  }, jspb.Map.prototype.toArray = function() {
    if (this.arrClean) {
      if (this.valueCtor_) {
        var e = this.map_, n;
        for (n in e)
          if (Object.prototype.hasOwnProperty.call(e, n)) {
            var o = e[n].valueWrapper;
            o && o.toArray();
          }
      }
    } else {
      for (this.arr_.length = 0, e = this.stringKeys_(), e.sort(), n = 0; n < e.length; n++) {
        var u = this.map_[e[n]];
        (o = u.valueWrapper) && o.toArray(), this.arr_.push([u.key, u.value]);
      }
      this.arrClean = !0;
    }
    return this.arr_;
  }, goog.exportProperty(jspb.Map.prototype, "toArray", jspb.Map.prototype.toArray), jspb.Map.prototype.toObject = function(e, n) {
    for (var o = this.toArray(), u = [], c = 0; c < o.length; c++) {
      var d = this.map_[o[c][0].toString()];
      this.wrapEntry_(d);
      var m = d.valueWrapper;
      m ? (jspb.asserts.assert(n), u.push([d.key, n(e, m)])) : u.push([d.key, d.value]);
    }
    return u;
  }, goog.exportProperty(jspb.Map.prototype, "toObject", jspb.Map.prototype.toObject), jspb.Map.fromObject = function(e, n, o) {
    n = new jspb.Map([], n);
    for (var u = 0; u < e.length; u++) {
      var c = e[u][0], d = o(e[u][1]);
      n.set(c, d);
    }
    return n;
  }, goog.exportProperty(jspb.Map, "fromObject", jspb.Map.fromObject), jspb.Map.ArrayIteratorIterable_ = function(e) {
    this.idx_ = 0, this.arr_ = e;
  }, jspb.Map.ArrayIteratorIterable_.prototype.next = function() {
    return this.idx_ < this.arr_.length ? { done: !1, value: this.arr_[this.idx_++] } : { done: !0, value: void 0 };
  }, typeof Symbol < "u" && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function() {
    return this;
  }), jspb.Map.prototype.getLength = function() {
    return this.stringKeys_().length;
  }, goog.exportProperty(jspb.Map.prototype, "getLength", jspb.Map.prototype.getLength), jspb.Map.prototype.clear = function() {
    this.map_ = {}, this.arrClean = !1;
  }, goog.exportProperty(jspb.Map.prototype, "clear", jspb.Map.prototype.clear), jspb.Map.prototype.del = function(e) {
    e = e.toString();
    var n = this.map_.hasOwnProperty(e);
    return delete this.map_[e], this.arrClean = !1, n;
  }, goog.exportProperty(jspb.Map.prototype, "del", jspb.Map.prototype.del), jspb.Map.prototype.getEntryList = function() {
    var e = [], n = this.stringKeys_();
    n.sort();
    for (var o = 0; o < n.length; o++) {
      var u = this.map_[n[o]];
      e.push([u.key, u.value]);
    }
    return e;
  }, goog.exportProperty(jspb.Map.prototype, "getEntryList", jspb.Map.prototype.getEntryList), jspb.Map.prototype.entries = function() {
    var e = [], n = this.stringKeys_();
    n.sort();
    for (var o = 0; o < n.length; o++) {
      var u = this.map_[n[o]];
      e.push([u.key, this.wrapEntry_(u)]);
    }
    return new jspb.Map.ArrayIteratorIterable_(e);
  }, goog.exportProperty(jspb.Map.prototype, "entries", jspb.Map.prototype.entries), jspb.Map.prototype.keys = function() {
    var e = [], n = this.stringKeys_();
    n.sort();
    for (var o = 0; o < n.length; o++)
      e.push(this.map_[n[o]].key);
    return new jspb.Map.ArrayIteratorIterable_(e);
  }, goog.exportProperty(jspb.Map.prototype, "keys", jspb.Map.prototype.keys), jspb.Map.prototype.values = function() {
    var e = [], n = this.stringKeys_();
    n.sort();
    for (var o = 0; o < n.length; o++)
      e.push(this.wrapEntry_(this.map_[n[o]]));
    return new jspb.Map.ArrayIteratorIterable_(e);
  }, goog.exportProperty(jspb.Map.prototype, "values", jspb.Map.prototype.values), jspb.Map.prototype.forEach = function(e, n) {
    var o = this.stringKeys_();
    o.sort();
    for (var u = 0; u < o.length; u++) {
      var c = this.map_[o[u]];
      e.call(n, this.wrapEntry_(c), c.key, this);
    }
  }, goog.exportProperty(jspb.Map.prototype, "forEach", jspb.Map.prototype.forEach), jspb.Map.prototype.set = function(e, n) {
    var o = new jspb.Map.Entry_(e);
    return this.valueCtor_ ? (o.valueWrapper = n, o.value = n.toArray()) : o.value = n, this.map_[e.toString()] = o, this.arrClean = !1, this;
  }, goog.exportProperty(jspb.Map.prototype, "set", jspb.Map.prototype.set), jspb.Map.prototype.wrapEntry_ = function(e) {
    return this.valueCtor_ ? (e.valueWrapper || (e.valueWrapper = new this.valueCtor_(e.value)), e.valueWrapper) : e.value;
  }, jspb.Map.prototype.get = function(e) {
    if (e = this.map_[e.toString()])
      return this.wrapEntry_(e);
  }, goog.exportProperty(jspb.Map.prototype, "get", jspb.Map.prototype.get), jspb.Map.prototype.has = function(e) {
    return e.toString() in this.map_;
  }, goog.exportProperty(jspb.Map.prototype, "has", jspb.Map.prototype.has), jspb.Map.prototype.serializeBinary = function(e, n, o, u, c) {
    var d = this.stringKeys_();
    d.sort();
    for (var m = 0; m < d.length; m++) {
      var v = this.map_[d[m]];
      n.beginSubMessage(e), o.call(n, 1, v.key), this.valueCtor_ ? u.call(n, 2, this.wrapEntry_(v), c) : u.call(n, 2, v.value), n.endSubMessage();
    }
  }, goog.exportProperty(jspb.Map.prototype, "serializeBinary", jspb.Map.prototype.serializeBinary), jspb.Map.deserializeBinary = function(e, n, o, u, c, d, m) {
    for (; n.nextField() && !n.isEndGroup(); ) {
      var v = n.getFieldNumber();
      v == 1 ? d = o.call(n) : v == 2 && (e.valueCtor_ ? (jspb.asserts.assert(c), m || (m = new e.valueCtor_()), u.call(n, m, c)) : m = u.call(n));
    }
    jspb.asserts.assert(d != null), jspb.asserts.assert(m != null), e.set(d, m);
  }, goog.exportProperty(jspb.Map, "deserializeBinary", jspb.Map.deserializeBinary), jspb.Map.prototype.stringKeys_ = function() {
    var e = this.map_, n = [], o;
    for (o in e)
      Object.prototype.hasOwnProperty.call(e, o) && n.push(o);
    return n;
  }, jspb.Map.Entry_ = function(e, n) {
    this.key = e, this.value = n, this.valueWrapper = void 0;
  }, jspb.ExtensionFieldInfo = function(e, n, o, u, c) {
    this.fieldIndex = e, this.fieldName = n, this.ctor = o, this.toObjectFn = u, this.isRepeated = c;
  }, goog.exportSymbol("jspb.ExtensionFieldInfo", jspb.ExtensionFieldInfo), jspb.ExtensionFieldBinaryInfo = function(e, n, o, u, c, d) {
    this.fieldInfo = e, this.binaryReaderFn = n, this.binaryWriterFn = o, this.binaryMessageSerializeFn = u, this.binaryMessageDeserializeFn = c, this.isPacked = d;
  }, goog.exportSymbol("jspb.ExtensionFieldBinaryInfo", jspb.ExtensionFieldBinaryInfo), jspb.ExtensionFieldInfo.prototype.isMessageType = function() {
    return !!this.ctor;
  }, goog.exportProperty(jspb.ExtensionFieldInfo.prototype, "isMessageType", jspb.ExtensionFieldInfo.prototype.isMessageType), jspb.Message = function() {
  }, goog.exportSymbol("jspb.Message", jspb.Message), jspb.Message.GENERATE_TO_OBJECT = !0, goog.exportProperty(jspb.Message, "GENERATE_TO_OBJECT", jspb.Message.GENERATE_TO_OBJECT), jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE, goog.exportProperty(jspb.Message, "GENERATE_FROM_OBJECT", jspb.Message.GENERATE_FROM_OBJECT), jspb.Message.GENERATE_TO_STRING = !0, jspb.Message.ASSUME_LOCAL_ARRAYS = !1, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = !0, jspb.Message.SUPPORTS_UINT8ARRAY_ = typeof Uint8Array == "function", jspb.Message.prototype.getJsPbMessageId = function() {
    return this.messageId_;
  }, goog.exportProperty(jspb.Message.prototype, "getJsPbMessageId", jspb.Message.prototype.getJsPbMessageId), jspb.Message.getIndex_ = function(e, n) {
    return n + e.arrayIndexOffset_;
  }, jspb.Message.hiddenES6Property_ = function() {
  }, jspb.Message.getFieldNumber_ = function(e, n) {
    return n - e.arrayIndexOffset_;
  }, jspb.Message.initialize = function(e, n, o, u, c, d) {
    if (e.wrappers_ = null, n || (n = o ? [o] : []), e.messageId_ = o ? String(o) : void 0, e.arrayIndexOffset_ = o === 0 ? -1 : 0, e.array = n, jspb.Message.initPivotAndExtensionObject_(e, u), e.convertedPrimitiveFields_ = {}, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (e.repeatedFields = c), c)
      for (n = 0; n < c.length; n++)
        o = c[n], o < e.pivot_ ? (o = jspb.Message.getIndex_(e, o), e.array[o] = e.array[o] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(e), e.extensionObject_[o] = e.extensionObject_[o] || jspb.Message.EMPTY_LIST_SENTINEL_);
    if (d && d.length)
      for (n = 0; n < d.length; n++)
        jspb.Message.computeOneofCase(e, d[n]);
  }, goog.exportProperty(jspb.Message, "initialize", jspb.Message.initialize), jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [], jspb.Message.isArray_ = function(e) {
    return jspb.Message.ASSUME_LOCAL_ARRAYS ? e instanceof Array : Array.isArray(e);
  }, jspb.Message.isExtensionObject_ = function(e) {
    return e !== null && typeof e == "object" && !jspb.Message.isArray_(e) && !(jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array);
  }, jspb.Message.initPivotAndExtensionObject_ = function(e, n) {
    var o = e.array.length, u = -1;
    if (o && (u = o - 1, o = e.array[u], jspb.Message.isExtensionObject_(o))) {
      e.pivot_ = jspb.Message.getFieldNumber_(e, u), e.extensionObject_ = o;
      return;
    }
    -1 < n ? (e.pivot_ = Math.max(n, jspb.Message.getFieldNumber_(e, u + 1)), e.extensionObject_ = null) : e.pivot_ = Number.MAX_VALUE;
  }, jspb.Message.maybeInitEmptyExtensionObject_ = function(e) {
    var n = jspb.Message.getIndex_(e, e.pivot_);
    e.array[n] || (e.extensionObject_ = e.array[n] = {});
  }, jspb.Message.toObjectList = function(e, n, o) {
    for (var u = [], c = 0; c < e.length; c++)
      u[c] = n.call(e[c], o, e[c]);
    return u;
  }, goog.exportProperty(jspb.Message, "toObjectList", jspb.Message.toObjectList), jspb.Message.toObjectExtension = function(e, n, o, u, c) {
    for (var d in o) {
      var m = o[d], v = u.call(e, m);
      if (v != null) {
        for (var S in m.fieldName)
          if (m.fieldName.hasOwnProperty(S))
            break;
        n[S] = m.toObjectFn ? m.isRepeated ? jspb.Message.toObjectList(v, m.toObjectFn, c) : m.toObjectFn(c, v) : v;
      }
    }
  }, goog.exportProperty(jspb.Message, "toObjectExtension", jspb.Message.toObjectExtension), jspb.Message.serializeBinaryExtensions = function(e, n, o, u) {
    for (var c in o) {
      var d = o[c], m = d.fieldInfo;
      if (!d.binaryWriterFn)
        throw Error("Message extension present that was generated without binary serialization support");
      var v = u.call(e, m);
      if (v != null)
        if (m.isMessageType())
          if (d.binaryMessageSerializeFn)
            d.binaryWriterFn.call(n, m.fieldIndex, v, d.binaryMessageSerializeFn);
          else
            throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
        else
          d.binaryWriterFn.call(n, m.fieldIndex, v);
    }
  }, goog.exportProperty(jspb.Message, "serializeBinaryExtensions", jspb.Message.serializeBinaryExtensions), jspb.Message.readBinaryExtension = function(e, n, o, u, c) {
    var d = o[n.getFieldNumber()];
    if (d) {
      if (o = d.fieldInfo, !d.binaryReaderFn)
        throw Error("Deserializing extension whose generated code does not support binary format");
      if (o.isMessageType()) {
        var m = new o.ctor();
        d.binaryReaderFn.call(n, m, d.binaryMessageDeserializeFn);
      } else
        m = d.binaryReaderFn.call(n);
      o.isRepeated && !d.isPacked ? (n = u.call(e, o)) ? n.push(m) : c.call(e, o, [m]) : c.call(e, o, m);
    } else
      n.skipField();
  }, goog.exportProperty(jspb.Message, "readBinaryExtension", jspb.Message.readBinaryExtension), jspb.Message.getField = function(e, n) {
    if (n < e.pivot_) {
      n = jspb.Message.getIndex_(e, n);
      var o = e.array[n];
      return o === jspb.Message.EMPTY_LIST_SENTINEL_ ? e.array[n] = [] : o;
    }
    if (e.extensionObject_)
      return o = e.extensionObject_[n], o === jspb.Message.EMPTY_LIST_SENTINEL_ ? e.extensionObject_[n] = [] : o;
  }, goog.exportProperty(jspb.Message, "getField", jspb.Message.getField), jspb.Message.getRepeatedField = function(e, n) {
    return jspb.Message.getField(e, n);
  }, goog.exportProperty(jspb.Message, "getRepeatedField", jspb.Message.getRepeatedField), jspb.Message.getOptionalFloatingPointField = function(e, n) {
    return e = jspb.Message.getField(e, n), e == null ? e : +e;
  }, goog.exportProperty(jspb.Message, "getOptionalFloatingPointField", jspb.Message.getOptionalFloatingPointField), jspb.Message.getBooleanField = function(e, n) {
    return e = jspb.Message.getField(e, n), e == null ? e : !!e;
  }, goog.exportProperty(jspb.Message, "getBooleanField", jspb.Message.getBooleanField), jspb.Message.getRepeatedFloatingPointField = function(e, n) {
    var o = jspb.Message.getRepeatedField(e, n);
    if (e.convertedPrimitiveFields_ || (e.convertedPrimitiveFields_ = {}), !e.convertedPrimitiveFields_[n]) {
      for (var u = 0; u < o.length; u++)
        o[u] = +o[u];
      e.convertedPrimitiveFields_[n] = !0;
    }
    return o;
  }, goog.exportProperty(jspb.Message, "getRepeatedFloatingPointField", jspb.Message.getRepeatedFloatingPointField), jspb.Message.getRepeatedBooleanField = function(e, n) {
    var o = jspb.Message.getRepeatedField(e, n);
    if (e.convertedPrimitiveFields_ || (e.convertedPrimitiveFields_ = {}), !e.convertedPrimitiveFields_[n]) {
      for (var u = 0; u < o.length; u++)
        o[u] = !!o[u];
      e.convertedPrimitiveFields_[n] = !0;
    }
    return o;
  }, goog.exportProperty(jspb.Message, "getRepeatedBooleanField", jspb.Message.getRepeatedBooleanField), jspb.Message.bytesAsB64 = function(e) {
    return e == null || typeof e == "string" ? e : jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array ? goog.crypt.base64.encodeByteArray(e) : (jspb.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(e)), null);
  }, goog.exportProperty(jspb.Message, "bytesAsB64", jspb.Message.bytesAsB64), jspb.Message.bytesAsU8 = function(e) {
    return e == null || e instanceof Uint8Array ? e : typeof e == "string" ? goog.crypt.base64.decodeStringToUint8Array(e) : (jspb.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(e)), null);
  }, goog.exportProperty(jspb.Message, "bytesAsU8", jspb.Message.bytesAsU8), jspb.Message.bytesListAsB64 = function(e) {
    return jspb.Message.assertConsistentTypes_(e), e.length && typeof e[0] != "string" ? goog.array.map(e, jspb.Message.bytesAsB64) : e;
  }, goog.exportProperty(jspb.Message, "bytesListAsB64", jspb.Message.bytesListAsB64), jspb.Message.bytesListAsU8 = function(e) {
    return jspb.Message.assertConsistentTypes_(e), !e.length || e[0] instanceof Uint8Array ? e : goog.array.map(e, jspb.Message.bytesAsU8);
  }, goog.exportProperty(jspb.Message, "bytesListAsU8", jspb.Message.bytesListAsU8), jspb.Message.assertConsistentTypes_ = function(e) {
    if (goog.DEBUG && e && 1 < e.length) {
      var n = goog.typeOf(e[0]);
      goog.array.forEach(e, function(o) {
        goog.typeOf(o) != n && jspb.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(o) + " expected " + n);
      });
    }
  }, jspb.Message.getFieldWithDefault = function(e, n, o) {
    return e = jspb.Message.getField(e, n), e ?? o;
  }, goog.exportProperty(jspb.Message, "getFieldWithDefault", jspb.Message.getFieldWithDefault), jspb.Message.getBooleanFieldWithDefault = function(e, n, o) {
    return e = jspb.Message.getBooleanField(e, n), e ?? o;
  }, goog.exportProperty(jspb.Message, "getBooleanFieldWithDefault", jspb.Message.getBooleanFieldWithDefault), jspb.Message.getFloatingPointFieldWithDefault = function(e, n, o) {
    return e = jspb.Message.getOptionalFloatingPointField(e, n), e ?? o;
  }, goog.exportProperty(jspb.Message, "getFloatingPointFieldWithDefault", jspb.Message.getFloatingPointFieldWithDefault), jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault, goog.exportProperty(jspb.Message, "getFieldProto3", jspb.Message.getFieldProto3), jspb.Message.getMapField = function(e, n, o, u) {
    if (e.wrappers_ || (e.wrappers_ = {}), n in e.wrappers_)
      return e.wrappers_[n];
    var c = jspb.Message.getField(e, n);
    if (!c) {
      if (o)
        return;
      c = [], jspb.Message.setField(e, n, c);
    }
    return e.wrappers_[n] = new jspb.Map(c, u);
  }, goog.exportProperty(jspb.Message, "getMapField", jspb.Message.getMapField), jspb.Message.setField = function(e, n, o) {
    return jspb.asserts.assertInstanceof(e, jspb.Message), n < e.pivot_ ? e.array[jspb.Message.getIndex_(e, n)] = o : (jspb.Message.maybeInitEmptyExtensionObject_(e), e.extensionObject_[n] = o), e;
  }, goog.exportProperty(jspb.Message, "setField", jspb.Message.setField), jspb.Message.setProto3IntField = function(e, n, o) {
    return jspb.Message.setFieldIgnoringDefault_(e, n, o, 0);
  }, goog.exportProperty(jspb.Message, "setProto3IntField", jspb.Message.setProto3IntField), jspb.Message.setProto3FloatField = function(e, n, o) {
    return jspb.Message.setFieldIgnoringDefault_(e, n, o, 0);
  }, goog.exportProperty(jspb.Message, "setProto3FloatField", jspb.Message.setProto3FloatField), jspb.Message.setProto3BooleanField = function(e, n, o) {
    return jspb.Message.setFieldIgnoringDefault_(e, n, o, !1);
  }, goog.exportProperty(jspb.Message, "setProto3BooleanField", jspb.Message.setProto3BooleanField), jspb.Message.setProto3StringField = function(e, n, o) {
    return jspb.Message.setFieldIgnoringDefault_(e, n, o, "");
  }, goog.exportProperty(jspb.Message, "setProto3StringField", jspb.Message.setProto3StringField), jspb.Message.setProto3BytesField = function(e, n, o) {
    return jspb.Message.setFieldIgnoringDefault_(e, n, o, "");
  }, goog.exportProperty(jspb.Message, "setProto3BytesField", jspb.Message.setProto3BytesField), jspb.Message.setProto3EnumField = function(e, n, o) {
    return jspb.Message.setFieldIgnoringDefault_(e, n, o, 0);
  }, goog.exportProperty(jspb.Message, "setProto3EnumField", jspb.Message.setProto3EnumField), jspb.Message.setProto3StringIntField = function(e, n, o) {
    return jspb.Message.setFieldIgnoringDefault_(e, n, o, "0");
  }, goog.exportProperty(jspb.Message, "setProto3StringIntField", jspb.Message.setProto3StringIntField), jspb.Message.setFieldIgnoringDefault_ = function(e, n, o, u) {
    return jspb.asserts.assertInstanceof(e, jspb.Message), o !== u ? jspb.Message.setField(e, n, o) : n < e.pivot_ ? e.array[jspb.Message.getIndex_(e, n)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(e), delete e.extensionObject_[n]), e;
  }, jspb.Message.addToRepeatedField = function(e, n, o, u) {
    return jspb.asserts.assertInstanceof(e, jspb.Message), n = jspb.Message.getRepeatedField(e, n), u != null ? n.splice(u, 0, o) : n.push(o), e;
  }, goog.exportProperty(jspb.Message, "addToRepeatedField", jspb.Message.addToRepeatedField), jspb.Message.setOneofField = function(e, n, o, u) {
    return jspb.asserts.assertInstanceof(e, jspb.Message), (o = jspb.Message.computeOneofCase(e, o)) && o !== n && u !== void 0 && (e.wrappers_ && o in e.wrappers_ && (e.wrappers_[o] = void 0), jspb.Message.setField(e, o, void 0)), jspb.Message.setField(e, n, u);
  }, goog.exportProperty(jspb.Message, "setOneofField", jspb.Message.setOneofField), jspb.Message.computeOneofCase = function(e, n) {
    for (var o, u, c = 0; c < n.length; c++) {
      var d = n[c], m = jspb.Message.getField(e, d);
      m != null && (o = d, u = m, jspb.Message.setField(e, d, void 0));
    }
    return o ? (jspb.Message.setField(e, o, u), o) : 0;
  }, goog.exportProperty(jspb.Message, "computeOneofCase", jspb.Message.computeOneofCase), jspb.Message.getWrapperField = function(e, n, o, u) {
    if (e.wrappers_ || (e.wrappers_ = {}), !e.wrappers_[o]) {
      var c = jspb.Message.getField(e, o);
      (u || c) && (e.wrappers_[o] = new n(c));
    }
    return e.wrappers_[o];
  }, goog.exportProperty(jspb.Message, "getWrapperField", jspb.Message.getWrapperField), jspb.Message.getRepeatedWrapperField = function(e, n, o) {
    return jspb.Message.wrapRepeatedField_(e, n, o), n = e.wrappers_[o], n == jspb.Message.EMPTY_LIST_SENTINEL_ && (n = e.wrappers_[o] = []), n;
  }, goog.exportProperty(jspb.Message, "getRepeatedWrapperField", jspb.Message.getRepeatedWrapperField), jspb.Message.wrapRepeatedField_ = function(e, n, o) {
    if (e.wrappers_ || (e.wrappers_ = {}), !e.wrappers_[o]) {
      for (var u = jspb.Message.getRepeatedField(e, o), c = [], d = 0; d < u.length; d++)
        c[d] = new n(u[d]);
      e.wrappers_[o] = c;
    }
  }, jspb.Message.setWrapperField = function(e, n, o) {
    jspb.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {});
    var u = o && o.toArray();
    return e.wrappers_[n] = o, jspb.Message.setField(e, n, u);
  }, goog.exportProperty(jspb.Message, "setWrapperField", jspb.Message.setWrapperField), jspb.Message.setOneofWrapperField = function(e, n, o, u) {
    jspb.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {});
    var c = u && u.toArray();
    return e.wrappers_[n] = u, jspb.Message.setOneofField(e, n, o, c);
  }, goog.exportProperty(jspb.Message, "setOneofWrapperField", jspb.Message.setOneofWrapperField), jspb.Message.setRepeatedWrapperField = function(e, n, o) {
    jspb.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {}), o = o || [];
    for (var u = [], c = 0; c < o.length; c++)
      u[c] = o[c].toArray();
    return e.wrappers_[n] = o, jspb.Message.setField(e, n, u);
  }, goog.exportProperty(jspb.Message, "setRepeatedWrapperField", jspb.Message.setRepeatedWrapperField), jspb.Message.addToRepeatedWrapperField = function(e, n, o, u, c) {
    jspb.Message.wrapRepeatedField_(e, u, n);
    var d = e.wrappers_[n];
    return d || (d = e.wrappers_[n] = []), o = o || new u(), e = jspb.Message.getRepeatedField(e, n), c != null ? (d.splice(c, 0, o), e.splice(c, 0, o.toArray())) : (d.push(o), e.push(o.toArray())), o;
  }, goog.exportProperty(jspb.Message, "addToRepeatedWrapperField", jspb.Message.addToRepeatedWrapperField), jspb.Message.toMap = function(e, n, o, u) {
    for (var c = {}, d = 0; d < e.length; d++)
      c[n.call(e[d])] = o ? o.call(e[d], u, e[d]) : e[d];
    return c;
  }, goog.exportProperty(jspb.Message, "toMap", jspb.Message.toMap), jspb.Message.prototype.syncMapFields_ = function() {
    if (this.wrappers_)
      for (var e in this.wrappers_) {
        var n = this.wrappers_[e];
        if (Array.isArray(n))
          for (var o = 0; o < n.length; o++)
            n[o] && n[o].toArray();
        else
          n && n.toArray();
      }
  }, jspb.Message.prototype.toArray = function() {
    return this.syncMapFields_(), this.array;
  }, goog.exportProperty(jspb.Message.prototype, "toArray", jspb.Message.prototype.toArray), jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function() {
    return this.syncMapFields_(), this.array.toString();
  }), jspb.Message.prototype.getExtension = function(e) {
    if (this.extensionObject_) {
      this.wrappers_ || (this.wrappers_ = {});
      var n = e.fieldIndex;
      if (e.isRepeated) {
        if (e.isMessageType())
          return this.wrappers_[n] || (this.wrappers_[n] = goog.array.map(this.extensionObject_[n] || [], function(o) {
            return new e.ctor(o);
          })), this.wrappers_[n];
      } else if (e.isMessageType())
        return !this.wrappers_[n] && this.extensionObject_[n] && (this.wrappers_[n] = new e.ctor(this.extensionObject_[n])), this.wrappers_[n];
      return this.extensionObject_[n];
    }
  }, goog.exportProperty(jspb.Message.prototype, "getExtension", jspb.Message.prototype.getExtension), jspb.Message.prototype.setExtension = function(e, n) {
    this.wrappers_ || (this.wrappers_ = {}), jspb.Message.maybeInitEmptyExtensionObject_(this);
    var o = e.fieldIndex;
    return e.isRepeated ? (n = n || [], e.isMessageType() ? (this.wrappers_[o] = n, this.extensionObject_[o] = goog.array.map(n, function(u) {
      return u.toArray();
    })) : this.extensionObject_[o] = n) : e.isMessageType() ? (this.wrappers_[o] = n, this.extensionObject_[o] = n && n.toArray()) : this.extensionObject_[o] = n, this;
  }, goog.exportProperty(jspb.Message.prototype, "setExtension", jspb.Message.prototype.setExtension), jspb.Message.difference = function(e, n) {
    if (!(e instanceof n.constructor))
      throw Error("Messages have different types.");
    var o = e.toArray();
    n = n.toArray();
    var u = [], c = 0, d = o.length > n.length ? o.length : n.length;
    for (e.getJsPbMessageId() && (u[0] = e.getJsPbMessageId(), c = 1); c < d; c++)
      jspb.Message.compareFields(o[c], n[c]) || (u[c] = n[c]);
    return new e.constructor(u);
  }, goog.exportProperty(jspb.Message, "difference", jspb.Message.difference), jspb.Message.equals = function(e, n) {
    return e == n || !(!e || !n) && e instanceof n.constructor && jspb.Message.compareFields(e.toArray(), n.toArray());
  }, goog.exportProperty(jspb.Message, "equals", jspb.Message.equals), jspb.Message.compareExtensions = function(e, n) {
    e = e || {}, n = n || {};
    var o = {}, u;
    for (u in e)
      o[u] = 0;
    for (u in n)
      o[u] = 0;
    for (u in o)
      if (!jspb.Message.compareFields(e[u], n[u]))
        return !1;
    return !0;
  }, goog.exportProperty(jspb.Message, "compareExtensions", jspb.Message.compareExtensions), jspb.Message.compareFields = function(e, n) {
    if (e == n)
      return !0;
    if (!goog.isObject(e) || !goog.isObject(n))
      return typeof e == "number" && isNaN(e) || typeof n == "number" && isNaN(n) ? String(e) == String(n) : !1;
    if (e.constructor != n.constructor)
      return !1;
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e.constructor === Uint8Array) {
      if (e.length != n.length)
        return !1;
      for (var o = 0; o < e.length; o++)
        if (e[o] != n[o])
          return !1;
      return !0;
    }
    if (e.constructor === Array) {
      var u = void 0, c = void 0, d = Math.max(e.length, n.length);
      for (o = 0; o < d; o++) {
        var m = e[o], v = n[o];
        if (m && m.constructor == Object && (jspb.asserts.assert(u === void 0), jspb.asserts.assert(o === e.length - 1), u = m, m = void 0), v && v.constructor == Object && (jspb.asserts.assert(c === void 0), jspb.asserts.assert(o === n.length - 1), c = v, v = void 0), !jspb.Message.compareFields(m, v))
          return !1;
      }
      return u || c ? (u = u || {}, c = c || {}, jspb.Message.compareExtensions(u, c)) : !0;
    }
    if (e.constructor === Object)
      return jspb.Message.compareExtensions(e, n);
    throw Error("Invalid type in JSPB array");
  }, goog.exportProperty(jspb.Message, "compareFields", jspb.Message.compareFields), jspb.Message.prototype.cloneMessage = function() {
    return jspb.Message.cloneMessage(this);
  }, goog.exportProperty(jspb.Message.prototype, "cloneMessage", jspb.Message.prototype.cloneMessage), jspb.Message.prototype.clone = function() {
    return jspb.Message.cloneMessage(this);
  }, goog.exportProperty(jspb.Message.prototype, "clone", jspb.Message.prototype.clone), jspb.Message.clone = function(e) {
    return jspb.Message.cloneMessage(e);
  }, goog.exportProperty(jspb.Message, "clone", jspb.Message.clone), jspb.Message.cloneMessage = function(e) {
    return new e.constructor(jspb.Message.clone_(e.toArray()));
  }, jspb.Message.copyInto = function(e, n) {
    jspb.asserts.assertInstanceof(e, jspb.Message), jspb.asserts.assertInstanceof(n, jspb.Message), jspb.asserts.assert(e.constructor == n.constructor, "Copy source and target message should have the same type."), e = jspb.Message.clone(e);
    for (var o = n.toArray(), u = e.toArray(), c = o.length = 0; c < u.length; c++)
      o[c] = u[c];
    n.wrappers_ = e.wrappers_, n.extensionObject_ = e.extensionObject_;
  }, goog.exportProperty(jspb.Message, "copyInto", jspb.Message.copyInto), jspb.Message.clone_ = function(e) {
    if (Array.isArray(e)) {
      for (var n = Array(e.length), o = 0; o < e.length; o++) {
        var u = e[o];
        u != null && (n[o] = typeof u == "object" ? jspb.Message.clone_(jspb.asserts.assert(u)) : u);
      }
      return n;
    }
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array)
      return new Uint8Array(e);
    n = {};
    for (o in e)
      u = e[o], u != null && (n[o] = typeof u == "object" ? jspb.Message.clone_(jspb.asserts.assert(u)) : u);
    return n;
  }, jspb.Message.registerMessageType = function(e, n) {
    n.messageId = e;
  }, goog.exportProperty(jspb.Message, "registerMessageType", jspb.Message.registerMessageType), jspb.Message.messageSetExtensions = {}, jspb.Message.messageSetExtensionsBinary = {}, jspb.Export = {}, exports.Map = jspb.Map, exports.Message = jspb.Message, exports.BinaryReader = jspb.BinaryReader, exports.BinaryWriter = jspb.BinaryWriter, exports.ExtensionFieldInfo = jspb.ExtensionFieldInfo, exports.ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo, exports.exportSymbol = goog.exportSymbol, exports.inherits = goog.inherits, exports.object = { extend: goog.object.extend }, exports.typeOf = goog.typeOf;
})(googleProtobuf);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.evmos = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      (function(v) {
        class S extends c.Message {
          constructor(M) {
            super(), c.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [4], []), !Array.isArray(M) && typeof M == "object" && ("contract_address" in M && M.contract_address != null && (this.contract_address = M.contract_address), "deployer_address" in M && M.deployer_address != null && (this.deployer_address = M.deployer_address), "withdrawer_address" in M && M.withdrawer_address != null && (this.withdrawer_address = M.withdrawer_address), "nonces" in M && M.nonces != null && (this.nonces = M.nonces));
          }
          get contract_address() {
            return c.Message.getField(this, 1);
          }
          set contract_address(M) {
            c.Message.setField(this, 1, M);
          }
          get deployer_address() {
            return c.Message.getField(this, 2);
          }
          set deployer_address(M) {
            c.Message.setField(this, 2, M);
          }
          get withdrawer_address() {
            return c.Message.getField(this, 3);
          }
          set withdrawer_address(M) {
            c.Message.setField(this, 3, M);
          }
          get nonces() {
            return c.Message.getField(this, 4);
          }
          set nonces(M) {
            c.Message.setField(this, 4, M);
          }
          static fromObject(M) {
            const G = new S({});
            return M.contract_address != null && (G.contract_address = M.contract_address), M.deployer_address != null && (G.deployer_address = M.deployer_address), M.withdrawer_address != null && (G.withdrawer_address = M.withdrawer_address), M.nonces != null && (G.nonces = M.nonces), G;
          }
          toObject() {
            const M = {};
            return this.contract_address != null && (M.contract_address = this.contract_address), this.deployer_address != null && (M.deployer_address = this.deployer_address), this.withdrawer_address != null && (M.withdrawer_address = this.withdrawer_address), this.nonces != null && (M.nonces = this.nonces), M;
          }
          serialize(M) {
            const G = M || new c.BinaryWriter();
            if (typeof this.contract_address == "string" && this.contract_address.length && G.writeString(1, this.contract_address), typeof this.deployer_address == "string" && this.deployer_address.length && G.writeString(2, this.deployer_address), typeof this.withdrawer_address == "string" && this.withdrawer_address.length && G.writeString(3, this.withdrawer_address), this.nonces !== void 0 && G.writePackedUint64(4, this.nonces), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof c.BinaryReader ? M : new c.BinaryReader(M), k = new S();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  k.contract_address = G.readString();
                  break;
                case 2:
                  k.deployer_address = G.readString();
                  break;
                case 3:
                  k.withdrawer_address = G.readString();
                  break;
                case 4:
                  k.nonces = G.readPackedUint64();
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return S.deserialize(M);
          }
        }
        v.MsgRegisterFeeSplit = S;
        class $ extends c.Message {
          constructor(M) {
            super(), c.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []);
          }
          static fromObject(M) {
            return new $({});
          }
          toObject() {
            return {};
          }
          serialize(M) {
            const G = M || new c.BinaryWriter();
            if (!M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof c.BinaryReader ? M : new c.BinaryReader(M), k = new $();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return $.deserialize(M);
          }
        }
        v.MsgRegisterFeeSplitResponse = $;
        class E extends c.Message {
          constructor(M) {
            super(), c.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []), !Array.isArray(M) && typeof M == "object" && ("contract_address" in M && M.contract_address != null && (this.contract_address = M.contract_address), "deployer_address" in M && M.deployer_address != null && (this.deployer_address = M.deployer_address), "withdrawer_address" in M && M.withdrawer_address != null && (this.withdrawer_address = M.withdrawer_address));
          }
          get contract_address() {
            return c.Message.getField(this, 1);
          }
          set contract_address(M) {
            c.Message.setField(this, 1, M);
          }
          get deployer_address() {
            return c.Message.getField(this, 2);
          }
          set deployer_address(M) {
            c.Message.setField(this, 2, M);
          }
          get withdrawer_address() {
            return c.Message.getField(this, 3);
          }
          set withdrawer_address(M) {
            c.Message.setField(this, 3, M);
          }
          static fromObject(M) {
            const G = new E({});
            return M.contract_address != null && (G.contract_address = M.contract_address), M.deployer_address != null && (G.deployer_address = M.deployer_address), M.withdrawer_address != null && (G.withdrawer_address = M.withdrawer_address), G;
          }
          toObject() {
            const M = {};
            return this.contract_address != null && (M.contract_address = this.contract_address), this.deployer_address != null && (M.deployer_address = this.deployer_address), this.withdrawer_address != null && (M.withdrawer_address = this.withdrawer_address), M;
          }
          serialize(M) {
            const G = M || new c.BinaryWriter();
            if (typeof this.contract_address == "string" && this.contract_address.length && G.writeString(1, this.contract_address), typeof this.deployer_address == "string" && this.deployer_address.length && G.writeString(2, this.deployer_address), typeof this.withdrawer_address == "string" && this.withdrawer_address.length && G.writeString(3, this.withdrawer_address), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof c.BinaryReader ? M : new c.BinaryReader(M), k = new E();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  k.contract_address = G.readString();
                  break;
                case 2:
                  k.deployer_address = G.readString();
                  break;
                case 3:
                  k.withdrawer_address = G.readString();
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return E.deserialize(M);
          }
        }
        v.MsgUpdateFeeSplit = E;
        class O extends c.Message {
          constructor(M) {
            super(), c.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []);
          }
          static fromObject(M) {
            return new O({});
          }
          toObject() {
            return {};
          }
          serialize(M) {
            const G = M || new c.BinaryWriter();
            if (!M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof c.BinaryReader ? M : new c.BinaryReader(M), k = new O();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return O.deserialize(M);
          }
        }
        v.MsgUpdateFeeSplitResponse = O;
        class T extends c.Message {
          constructor(M) {
            super(), c.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []), !Array.isArray(M) && typeof M == "object" && ("contract_address" in M && M.contract_address != null && (this.contract_address = M.contract_address), "deployer_address" in M && M.deployer_address != null && (this.deployer_address = M.deployer_address));
          }
          get contract_address() {
            return c.Message.getField(this, 1);
          }
          set contract_address(M) {
            c.Message.setField(this, 1, M);
          }
          get deployer_address() {
            return c.Message.getField(this, 2);
          }
          set deployer_address(M) {
            c.Message.setField(this, 2, M);
          }
          static fromObject(M) {
            const G = new T({});
            return M.contract_address != null && (G.contract_address = M.contract_address), M.deployer_address != null && (G.deployer_address = M.deployer_address), G;
          }
          toObject() {
            const M = {};
            return this.contract_address != null && (M.contract_address = this.contract_address), this.deployer_address != null && (M.deployer_address = this.deployer_address), M;
          }
          serialize(M) {
            const G = M || new c.BinaryWriter();
            if (typeof this.contract_address == "string" && this.contract_address.length && G.writeString(1, this.contract_address), typeof this.deployer_address == "string" && this.deployer_address.length && G.writeString(2, this.deployer_address), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof c.BinaryReader ? M : new c.BinaryReader(M), k = new T();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  k.contract_address = G.readString();
                  break;
                case 2:
                  k.deployer_address = G.readString();
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return T.deserialize(M);
          }
        }
        v.MsgCancelFeeSplit = T;
        class y extends c.Message {
          constructor(M) {
            super(), c.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []);
          }
          static fromObject(M) {
            return new y({});
          }
          toObject() {
            return {};
          }
          serialize(M) {
            const G = M || new c.BinaryWriter();
            if (!M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof c.BinaryReader ? M : new c.BinaryReader(M), k = new y();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return y.deserialize(M);
          }
        }
        v.MsgCancelFeeSplitResponse = y;
      })(m.v1 || (m.v1 = {}));
    })(d.feesplit || (d.feesplit = {}));
  })(e.evmos || (e.evmos = {}));
})(tx$a);
var __createBinding$j = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$j = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$j = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$j(n, e, o);
  return __setModuleDefault$j(n, e), n;
};
Object.defineProperty(msgCancelFeeSplit$1, "__esModule", { value: !0 });
msgCancelFeeSplit$1.createMsgCancelFeeSplit = void 0;
const feesplit$2 = __importStar$j(tx$a);
function createMsgCancelFeeSplit$1(e, n) {
  return {
    message: new feesplit$2.evmos.feesplit.v1.MsgCancelFeeSplit({
      contract_address: e,
      deployer_address: n
    }),
    path: "evmos.feesplit.v1.MsgCancelFeeSplit"
  };
}
msgCancelFeeSplit$1.createMsgCancelFeeSplit = createMsgCancelFeeSplit$1;
var msgUpdateFeeSplit$2 = {}, __createBinding$i = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$i = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$i = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$i(n, e, o);
  return __setModuleDefault$i(n, e), n;
};
Object.defineProperty(msgUpdateFeeSplit$2, "__esModule", { value: !0 });
msgUpdateFeeSplit$2.createMsgUpdateFeeSplit = void 0;
const feesplit$1 = __importStar$i(tx$a);
function createMsgUpdateFeeSplit$1(e, n, o) {
  return {
    message: new feesplit$1.evmos.feesplit.v1.MsgUpdateFeeSplit({
      contract_address: e,
      deployer_address: n,
      withdrawer_address: o
    }),
    path: "evmos.feesplit.v1.MsgUpdateFeeSplit"
  };
}
msgUpdateFeeSplit$2.createMsgUpdateFeeSplit = createMsgUpdateFeeSplit$1;
var msgRegisterFeeSplit$2 = {}, __createBinding$h = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$h = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$h = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$h(n, e, o);
  return __setModuleDefault$h(n, e), n;
};
Object.defineProperty(msgRegisterFeeSplit$2, "__esModule", { value: !0 });
msgRegisterFeeSplit$2.createMsgRegisterFeeSplit = void 0;
const feesplit = __importStar$h(tx$a);
function createMsgRegisterFeeSplit$1(e, n, o, u) {
  return {
    message: new feesplit.evmos.feesplit.v1.MsgRegisterFeeSplit({
      contract_address: e,
      deployer_address: n,
      withdrawer_address: o,
      nonces: u
    }),
    path: "evmos.feesplit.v1.MsgRegisterFeeSplit"
  };
}
msgRegisterFeeSplit$2.createMsgRegisterFeeSplit = createMsgRegisterFeeSplit$1;
var msgConvertCoin$2 = {}, tx$9 = {}, coin$6 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      (function(v) {
        class S extends c.Message {
          constructor(y) {
            super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [], []), !Array.isArray(y) && typeof y == "object" && ("denom" in y && y.denom != null && (this.denom = y.denom), "amount" in y && y.amount != null && (this.amount = y.amount));
          }
          get denom() {
            return c.Message.getField(this, 1);
          }
          set denom(y) {
            c.Message.setField(this, 1, y);
          }
          get amount() {
            return c.Message.getField(this, 2);
          }
          set amount(y) {
            c.Message.setField(this, 2, y);
          }
          static fromObject(y) {
            const V = new S({});
            return y.denom != null && (V.denom = y.denom), y.amount != null && (V.amount = y.amount), V;
          }
          toObject() {
            const y = {};
            return this.denom != null && (y.denom = this.denom), this.amount != null && (y.amount = this.amount), y;
          }
          serialize(y) {
            const V = y || new c.BinaryWriter();
            if (typeof this.denom == "string" && this.denom.length && V.writeString(1, this.denom), typeof this.amount == "string" && this.amount.length && V.writeString(2, this.amount), !y)
              return V.getResultBuffer();
          }
          static deserialize(y) {
            const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new S();
            for (; V.nextField() && !V.isEndGroup(); )
              switch (V.getFieldNumber()) {
                case 1:
                  M.denom = V.readString();
                  break;
                case 2:
                  M.amount = V.readString();
                  break;
                default:
                  V.skipField();
              }
            return M;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(y) {
            return S.deserialize(y);
          }
        }
        v.Coin = S;
        class $ extends c.Message {
          constructor(y) {
            super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [], []), !Array.isArray(y) && typeof y == "object" && ("denom" in y && y.denom != null && (this.denom = y.denom), "amount" in y && y.amount != null && (this.amount = y.amount));
          }
          get denom() {
            return c.Message.getField(this, 1);
          }
          set denom(y) {
            c.Message.setField(this, 1, y);
          }
          get amount() {
            return c.Message.getField(this, 2);
          }
          set amount(y) {
            c.Message.setField(this, 2, y);
          }
          static fromObject(y) {
            const V = new $({});
            return y.denom != null && (V.denom = y.denom), y.amount != null && (V.amount = y.amount), V;
          }
          toObject() {
            const y = {};
            return this.denom != null && (y.denom = this.denom), this.amount != null && (y.amount = this.amount), y;
          }
          serialize(y) {
            const V = y || new c.BinaryWriter();
            if (typeof this.denom == "string" && this.denom.length && V.writeString(1, this.denom), typeof this.amount == "string" && this.amount.length && V.writeString(2, this.amount), !y)
              return V.getResultBuffer();
          }
          static deserialize(y) {
            const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new $();
            for (; V.nextField() && !V.isEndGroup(); )
              switch (V.getFieldNumber()) {
                case 1:
                  M.denom = V.readString();
                  break;
                case 2:
                  M.amount = V.readString();
                  break;
                default:
                  V.skipField();
              }
            return M;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(y) {
            return $.deserialize(y);
          }
        }
        v.DecCoin = $;
        class E extends c.Message {
          constructor(y) {
            super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [], []), !Array.isArray(y) && typeof y == "object" && "int" in y && y.int != null && (this.int = y.int);
          }
          get int() {
            return c.Message.getField(this, 1);
          }
          set int(y) {
            c.Message.setField(this, 1, y);
          }
          static fromObject(y) {
            const V = new E({});
            return y.int != null && (V.int = y.int), V;
          }
          toObject() {
            const y = {};
            return this.int != null && (y.int = this.int), y;
          }
          serialize(y) {
            const V = y || new c.BinaryWriter();
            if (typeof this.int == "string" && this.int.length && V.writeString(1, this.int), !y)
              return V.getResultBuffer();
          }
          static deserialize(y) {
            const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new E();
            for (; V.nextField() && !V.isEndGroup(); )
              switch (V.getFieldNumber()) {
                case 1:
                  M.int = V.readString();
                  break;
                default:
                  V.skipField();
              }
            return M;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(y) {
            return E.deserialize(y);
          }
        }
        v.IntProto = E;
        class O extends c.Message {
          constructor(y) {
            super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [], []), !Array.isArray(y) && typeof y == "object" && "dec" in y && y.dec != null && (this.dec = y.dec);
          }
          get dec() {
            return c.Message.getField(this, 1);
          }
          set dec(y) {
            c.Message.setField(this, 1, y);
          }
          static fromObject(y) {
            const V = new O({});
            return y.dec != null && (V.dec = y.dec), V;
          }
          toObject() {
            const y = {};
            return this.dec != null && (y.dec = this.dec), y;
          }
          serialize(y) {
            const V = y || new c.BinaryWriter();
            if (typeof this.dec == "string" && this.dec.length && V.writeString(1, this.dec), !y)
              return V.getResultBuffer();
          }
          static deserialize(y) {
            const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new O();
            for (; V.nextField() && !V.isEndGroup(); )
              switch (V.getFieldNumber()) {
                case 1:
                  M.dec = V.readString();
                  break;
                default:
                  V.skipField();
              }
            return M;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(y) {
            return O.deserialize(y);
          }
        }
        v.DecProto = O;
      })(m.v1beta1 || (m.v1beta1 = {}));
    })(d.base || (d.base = {}));
  })(e.cosmos || (e.cosmos = {}));
})(coin$6);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(m, v, S, $) {
    $ === void 0 && ($ = S);
    var E = Object.getOwnPropertyDescriptor(v, S);
    (!E || ("get" in E ? !v.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
      return v[S];
    } }), Object.defineProperty(m, $, E);
  } : function(m, v, S, $) {
    $ === void 0 && ($ = S), m[$] = v[S];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(m, v) {
    Object.defineProperty(m, "default", { enumerable: !0, value: v });
  } : function(m, v) {
    m.default = v;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(m) {
    if (m && m.__esModule)
      return m;
    var v = {};
    if (m != null)
      for (var S in m)
        S !== "default" && Object.prototype.hasOwnProperty.call(m, S) && n(v, m, S);
    return o(v, m), v;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.evmos = void 0;
  const c = u(coin$6), d = u(googleProtobuf);
  (function(m) {
    (function(v) {
      (function(S) {
        class $ extends d.Message {
          constructor(V) {
            super(), d.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []), !Array.isArray(V) && typeof V == "object" && ("coin" in V && V.coin != null && (this.coin = V.coin), "receiver" in V && V.receiver != null && (this.receiver = V.receiver), "sender" in V && V.sender != null && (this.sender = V.sender));
          }
          get coin() {
            return d.Message.getWrapperField(this, c.cosmos.base.v1beta1.Coin, 1);
          }
          set coin(V) {
            d.Message.setWrapperField(this, 1, V);
          }
          get receiver() {
            return d.Message.getField(this, 2);
          }
          set receiver(V) {
            d.Message.setField(this, 2, V);
          }
          get sender() {
            return d.Message.getField(this, 3);
          }
          set sender(V) {
            d.Message.setField(this, 3, V);
          }
          static fromObject(V) {
            const M = new $({});
            return V.coin != null && (M.coin = c.cosmos.base.v1beta1.Coin.fromObject(V.coin)), V.receiver != null && (M.receiver = V.receiver), V.sender != null && (M.sender = V.sender), M;
          }
          toObject() {
            const V = {};
            return this.coin != null && (V.coin = this.coin.toObject()), this.receiver != null && (V.receiver = this.receiver), this.sender != null && (V.sender = this.sender), V;
          }
          serialize(V) {
            const M = V || new d.BinaryWriter();
            if (this.coin !== void 0 && M.writeMessage(1, this.coin, () => this.coin.serialize(M)), typeof this.receiver == "string" && this.receiver.length && M.writeString(2, this.receiver), typeof this.sender == "string" && this.sender.length && M.writeString(3, this.sender), !V)
              return M.getResultBuffer();
          }
          static deserialize(V) {
            const M = V instanceof d.BinaryReader ? V : new d.BinaryReader(V), G = new $();
            for (; M.nextField() && !M.isEndGroup(); )
              switch (M.getFieldNumber()) {
                case 1:
                  M.readMessage(G.coin, () => G.coin = c.cosmos.base.v1beta1.Coin.deserialize(M));
                  break;
                case 2:
                  G.receiver = M.readString();
                  break;
                case 3:
                  G.sender = M.readString();
                  break;
                default:
                  M.skipField();
              }
            return G;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(V) {
            return $.deserialize(V);
          }
        }
        S.MsgConvertCoin = $;
        class E extends d.Message {
          constructor(V) {
            super(), d.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []);
          }
          static fromObject(V) {
            return new E({});
          }
          toObject() {
            return {};
          }
          serialize(V) {
            const M = V || new d.BinaryWriter();
            if (!V)
              return M.getResultBuffer();
          }
          static deserialize(V) {
            const M = V instanceof d.BinaryReader ? V : new d.BinaryReader(V), G = new E();
            for (; M.nextField() && !M.isEndGroup(); )
              switch (M.getFieldNumber()) {
                default:
                  M.skipField();
              }
            return G;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(V) {
            return E.deserialize(V);
          }
        }
        S.MsgConvertCoinResponse = E;
        class O extends d.Message {
          constructor(V) {
            super(), d.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []), !Array.isArray(V) && typeof V == "object" && ("contract_address" in V && V.contract_address != null && (this.contract_address = V.contract_address), "amount" in V && V.amount != null && (this.amount = V.amount), "receiver" in V && V.receiver != null && (this.receiver = V.receiver), "sender" in V && V.sender != null && (this.sender = V.sender));
          }
          get contract_address() {
            return d.Message.getField(this, 1);
          }
          set contract_address(V) {
            d.Message.setField(this, 1, V);
          }
          get amount() {
            return d.Message.getField(this, 2);
          }
          set amount(V) {
            d.Message.setField(this, 2, V);
          }
          get receiver() {
            return d.Message.getField(this, 3);
          }
          set receiver(V) {
            d.Message.setField(this, 3, V);
          }
          get sender() {
            return d.Message.getField(this, 4);
          }
          set sender(V) {
            d.Message.setField(this, 4, V);
          }
          static fromObject(V) {
            const M = new O({});
            return V.contract_address != null && (M.contract_address = V.contract_address), V.amount != null && (M.amount = V.amount), V.receiver != null && (M.receiver = V.receiver), V.sender != null && (M.sender = V.sender), M;
          }
          toObject() {
            const V = {};
            return this.contract_address != null && (V.contract_address = this.contract_address), this.amount != null && (V.amount = this.amount), this.receiver != null && (V.receiver = this.receiver), this.sender != null && (V.sender = this.sender), V;
          }
          serialize(V) {
            const M = V || new d.BinaryWriter();
            if (typeof this.contract_address == "string" && this.contract_address.length && M.writeString(1, this.contract_address), typeof this.amount == "string" && this.amount.length && M.writeString(2, this.amount), typeof this.receiver == "string" && this.receiver.length && M.writeString(3, this.receiver), typeof this.sender == "string" && this.sender.length && M.writeString(4, this.sender), !V)
              return M.getResultBuffer();
          }
          static deserialize(V) {
            const M = V instanceof d.BinaryReader ? V : new d.BinaryReader(V), G = new O();
            for (; M.nextField() && !M.isEndGroup(); )
              switch (M.getFieldNumber()) {
                case 1:
                  G.contract_address = M.readString();
                  break;
                case 2:
                  G.amount = M.readString();
                  break;
                case 3:
                  G.receiver = M.readString();
                  break;
                case 4:
                  G.sender = M.readString();
                  break;
                default:
                  M.skipField();
              }
            return G;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(V) {
            return O.deserialize(V);
          }
        }
        S.MsgConvertERC20 = O;
        class T extends d.Message {
          constructor(V) {
            super(), d.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []);
          }
          static fromObject(V) {
            return new T({});
          }
          toObject() {
            return {};
          }
          serialize(V) {
            const M = V || new d.BinaryWriter();
            if (!V)
              return M.getResultBuffer();
          }
          static deserialize(V) {
            const M = V instanceof d.BinaryReader ? V : new d.BinaryReader(V), G = new T();
            for (; M.nextField() && !M.isEndGroup(); )
              switch (M.getFieldNumber()) {
                default:
                  M.skipField();
              }
            return G;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(V) {
            return T.deserialize(V);
          }
        }
        S.MsgConvertERC20Response = T;
      })(v.v1 || (v.v1 = {}));
    })(m.erc20 || (m.erc20 = {}));
  })(e.evmos || (e.evmos = {}));
})(tx$9);
var __createBinding$g = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$g = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$g = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$g(n, e, o);
  return __setModuleDefault$g(n, e), n;
};
Object.defineProperty(msgConvertCoin$2, "__esModule", { value: !0 });
msgConvertCoin$2.createMsgConvertCoin = void 0;
const erc20$1 = __importStar$g(tx$9), coin$5 = __importStar$g(coin$6);
function createMsgConvertCoin$1(e, n, o, u) {
  return {
    message: new erc20$1.evmos.erc20.v1.MsgConvertCoin({
      coin: new coin$5.cosmos.base.v1beta1.Coin({
        denom: e,
        amount: n
      }),
      receiver: o,
      sender: u
    }),
    path: "evmos.erc20.v1.MsgConvertCoin"
  };
}
msgConvertCoin$2.createMsgConvertCoin = createMsgConvertCoin$1;
var msgConvertERC20$2 = {}, __createBinding$f = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$f = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$f = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$f(n, e, o);
  return __setModuleDefault$f(n, e), n;
};
Object.defineProperty(msgConvertERC20$2, "__esModule", { value: !0 });
msgConvertERC20$2.createMsgConvertERC20 = void 0;
const erc20 = __importStar$f(tx$9);
function createMsgConvertERC20$1(e, n, o, u) {
  return {
    message: new erc20.evmos.erc20.v1.MsgConvertERC20({
      contract_address: e,
      amount: n,
      receiver: o,
      sender: u
    }),
    path: "evmos.erc20.v1.MsgConvertERC20"
  };
}
msgConvertERC20$2.createMsgConvertERC20 = createMsgConvertERC20$1;
var authz$2 = {}, tx$8 = {}, any = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.google = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      class v extends c.Message {
        constructor($) {
          super(), c.Message.initialize(this, Array.isArray($) ? $ : [], 0, -1, [], []), !Array.isArray($) && typeof $ == "object" && ("type_url" in $ && $.type_url != null && (this.type_url = $.type_url), "value" in $ && $.value != null && (this.value = $.value));
        }
        get type_url() {
          return c.Message.getField(this, 1);
        }
        set type_url($) {
          c.Message.setField(this, 1, $);
        }
        get value() {
          return c.Message.getField(this, 2);
        }
        set value($) {
          c.Message.setField(this, 2, $);
        }
        static fromObject($) {
          const E = new v({});
          return $.type_url != null && (E.type_url = $.type_url), $.value != null && (E.value = $.value), E;
        }
        toObject() {
          const $ = {};
          return this.type_url != null && ($.type_url = this.type_url), this.value != null && ($.value = this.value), $;
        }
        serialize($) {
          const E = $ || new c.BinaryWriter();
          if (typeof this.type_url == "string" && this.type_url.length && E.writeString(1, this.type_url), this.value !== void 0 && E.writeBytes(2, this.value), !$)
            return E.getResultBuffer();
        }
        static deserialize($) {
          const E = $ instanceof c.BinaryReader ? $ : new c.BinaryReader($), O = new v();
          for (; E.nextField() && !E.isEndGroup(); )
            switch (E.getFieldNumber()) {
              case 1:
                O.type_url = E.readString();
                break;
              case 2:
                O.value = E.readBytes();
                break;
              default:
                E.skipField();
            }
          return O;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary($) {
          return v.deserialize($);
        }
      }
      m.Any = v;
    })(d.protobuf || (d.protobuf = {}));
  })(e.google || (e.google = {}));
})(any);
var authz$1 = {}, timestamp = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.google = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      class v extends c.Message {
        constructor($) {
          super(), c.Message.initialize(this, Array.isArray($) ? $ : [], 0, -1, [], []), !Array.isArray($) && typeof $ == "object" && ("seconds" in $ && $.seconds != null && (this.seconds = $.seconds), "nanos" in $ && $.nanos != null && (this.nanos = $.nanos));
        }
        get seconds() {
          return c.Message.getField(this, 1);
        }
        set seconds($) {
          c.Message.setField(this, 1, $);
        }
        get nanos() {
          return c.Message.getField(this, 2);
        }
        set nanos($) {
          c.Message.setField(this, 2, $);
        }
        static fromObject($) {
          const E = new v({});
          return $.seconds != null && (E.seconds = $.seconds), $.nanos != null && (E.nanos = $.nanos), E;
        }
        toObject() {
          const $ = {};
          return this.seconds != null && ($.seconds = this.seconds), this.nanos != null && ($.nanos = this.nanos), $;
        }
        serialize($) {
          const E = $ || new c.BinaryWriter();
          if (this.seconds !== void 0 && E.writeInt64(1, this.seconds), this.nanos !== void 0 && E.writeInt32(2, this.nanos), !$)
            return E.getResultBuffer();
        }
        static deserialize($) {
          const E = $ instanceof c.BinaryReader ? $ : new c.BinaryReader($), O = new v();
          for (; E.nextField() && !E.isEndGroup(); )
            switch (E.getFieldNumber()) {
              case 1:
                O.seconds = E.readInt64();
                break;
              case 2:
                O.nanos = E.readInt32();
                break;
              default:
                E.skipField();
            }
          return O;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary($) {
          return v.deserialize($);
        }
      }
      m.Timestamp = v;
    })(d.protobuf || (d.protobuf = {}));
  })(e.google || (e.google = {}));
})(timestamp);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, S, $, E) {
    E === void 0 && (E = $);
    var O = Object.getOwnPropertyDescriptor(S, $);
    (!O || ("get" in O ? !S.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return S[$];
    } }), Object.defineProperty(v, E, O);
  } : function(v, S, $, E) {
    E === void 0 && (E = $), v[E] = S[$];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, S) {
    Object.defineProperty(v, "default", { enumerable: !0, value: S });
  } : function(v, S) {
    v.default = S;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var S = {};
    if (v != null)
      for (var $ in v)
        $ !== "default" && Object.prototype.hasOwnProperty.call(v, $) && n(S, v, $);
    return o(S, v), S;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(timestamp), d = u(any), m = u(googleProtobuf);
  (function(v) {
    (function(S) {
      (function($) {
        class E extends m.Message {
          constructor(V) {
            super(), m.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []), !Array.isArray(V) && typeof V == "object" && "msg" in V && V.msg != null && (this.msg = V.msg);
          }
          get msg() {
            return m.Message.getField(this, 1);
          }
          set msg(V) {
            m.Message.setField(this, 1, V);
          }
          static fromObject(V) {
            const M = new E({});
            return V.msg != null && (M.msg = V.msg), M;
          }
          toObject() {
            const V = {};
            return this.msg != null && (V.msg = this.msg), V;
          }
          serialize(V) {
            const M = V || new m.BinaryWriter();
            if (typeof this.msg == "string" && this.msg.length && M.writeString(1, this.msg), !V)
              return M.getResultBuffer();
          }
          static deserialize(V) {
            const M = V instanceof m.BinaryReader ? V : new m.BinaryReader(V), G = new E();
            for (; M.nextField() && !M.isEndGroup(); )
              switch (M.getFieldNumber()) {
                case 1:
                  G.msg = M.readString();
                  break;
                default:
                  M.skipField();
              }
            return G;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(V) {
            return E.deserialize(V);
          }
        }
        $.GenericAuthorization = E;
        class O extends m.Message {
          constructor(V) {
            super(), m.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []), !Array.isArray(V) && typeof V == "object" && ("authorization" in V && V.authorization != null && (this.authorization = V.authorization), "expiration" in V && V.expiration != null && (this.expiration = V.expiration));
          }
          get authorization() {
            return m.Message.getWrapperField(this, d.google.protobuf.Any, 1);
          }
          set authorization(V) {
            m.Message.setWrapperField(this, 1, V);
          }
          get expiration() {
            return m.Message.getWrapperField(this, c.google.protobuf.Timestamp, 2);
          }
          set expiration(V) {
            m.Message.setWrapperField(this, 2, V);
          }
          static fromObject(V) {
            const M = new O({});
            return V.authorization != null && (M.authorization = d.google.protobuf.Any.fromObject(V.authorization)), V.expiration != null && (M.expiration = c.google.protobuf.Timestamp.fromObject(V.expiration)), M;
          }
          toObject() {
            const V = {};
            return this.authorization != null && (V.authorization = this.authorization.toObject()), this.expiration != null && (V.expiration = this.expiration.toObject()), V;
          }
          serialize(V) {
            const M = V || new m.BinaryWriter();
            if (this.authorization !== void 0 && M.writeMessage(1, this.authorization, () => this.authorization.serialize(M)), this.expiration !== void 0 && M.writeMessage(2, this.expiration, () => this.expiration.serialize(M)), !V)
              return M.getResultBuffer();
          }
          static deserialize(V) {
            const M = V instanceof m.BinaryReader ? V : new m.BinaryReader(V), G = new O();
            for (; M.nextField() && !M.isEndGroup(); )
              switch (M.getFieldNumber()) {
                case 1:
                  M.readMessage(G.authorization, () => G.authorization = d.google.protobuf.Any.deserialize(M));
                  break;
                case 2:
                  M.readMessage(G.expiration, () => G.expiration = c.google.protobuf.Timestamp.deserialize(M));
                  break;
                default:
                  M.skipField();
              }
            return G;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(V) {
            return O.deserialize(V);
          }
        }
        $.Grant = O;
        class T extends m.Message {
          constructor(V) {
            super(), m.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []), !Array.isArray(V) && typeof V == "object" && ("granter" in V && V.granter != null && (this.granter = V.granter), "grantee" in V && V.grantee != null && (this.grantee = V.grantee), "authorization" in V && V.authorization != null && (this.authorization = V.authorization), "expiration" in V && V.expiration != null && (this.expiration = V.expiration));
          }
          get granter() {
            return m.Message.getField(this, 1);
          }
          set granter(V) {
            m.Message.setField(this, 1, V);
          }
          get grantee() {
            return m.Message.getField(this, 2);
          }
          set grantee(V) {
            m.Message.setField(this, 2, V);
          }
          get authorization() {
            return m.Message.getWrapperField(this, d.google.protobuf.Any, 3);
          }
          set authorization(V) {
            m.Message.setWrapperField(this, 3, V);
          }
          get expiration() {
            return m.Message.getWrapperField(this, c.google.protobuf.Timestamp, 4);
          }
          set expiration(V) {
            m.Message.setWrapperField(this, 4, V);
          }
          static fromObject(V) {
            const M = new T({});
            return V.granter != null && (M.granter = V.granter), V.grantee != null && (M.grantee = V.grantee), V.authorization != null && (M.authorization = d.google.protobuf.Any.fromObject(V.authorization)), V.expiration != null && (M.expiration = c.google.protobuf.Timestamp.fromObject(V.expiration)), M;
          }
          toObject() {
            const V = {};
            return this.granter != null && (V.granter = this.granter), this.grantee != null && (V.grantee = this.grantee), this.authorization != null && (V.authorization = this.authorization.toObject()), this.expiration != null && (V.expiration = this.expiration.toObject()), V;
          }
          serialize(V) {
            const M = V || new m.BinaryWriter();
            if (typeof this.granter == "string" && this.granter.length && M.writeString(1, this.granter), typeof this.grantee == "string" && this.grantee.length && M.writeString(2, this.grantee), this.authorization !== void 0 && M.writeMessage(3, this.authorization, () => this.authorization.serialize(M)), this.expiration !== void 0 && M.writeMessage(4, this.expiration, () => this.expiration.serialize(M)), !V)
              return M.getResultBuffer();
          }
          static deserialize(V) {
            const M = V instanceof m.BinaryReader ? V : new m.BinaryReader(V), G = new T();
            for (; M.nextField() && !M.isEndGroup(); )
              switch (M.getFieldNumber()) {
                case 1:
                  G.granter = M.readString();
                  break;
                case 2:
                  G.grantee = M.readString();
                  break;
                case 3:
                  M.readMessage(G.authorization, () => G.authorization = d.google.protobuf.Any.deserialize(M));
                  break;
                case 4:
                  M.readMessage(G.expiration, () => G.expiration = c.google.protobuf.Timestamp.deserialize(M));
                  break;
                default:
                  M.skipField();
              }
            return G;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(V) {
            return T.deserialize(V);
          }
        }
        $.GrantAuthorization = T;
      })(S.v1beta1 || (S.v1beta1 = {}));
    })(v.authz || (v.authz = {}));
  })(e.cosmos || (e.cosmos = {}));
})(authz$1);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, S, $, E) {
    E === void 0 && (E = $);
    var O = Object.getOwnPropertyDescriptor(S, $);
    (!O || ("get" in O ? !S.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return S[$];
    } }), Object.defineProperty(v, E, O);
  } : function(v, S, $, E) {
    E === void 0 && (E = $), v[E] = S[$];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, S) {
    Object.defineProperty(v, "default", { enumerable: !0, value: S });
  } : function(v, S) {
    v.default = S;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var S = {};
    if (v != null)
      for (var $ in v)
        $ !== "default" && Object.prototype.hasOwnProperty.call(v, $) && n(S, v, $);
    return o(S, v), S;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(any), d = u(authz$1), m = u(googleProtobuf);
  (function(v) {
    (function(S) {
      (function($) {
        class E extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("granter" in k && k.granter != null && (this.granter = k.granter), "grantee" in k && k.grantee != null && (this.grantee = k.grantee), "grant" in k && k.grant != null && (this.grant = k.grant));
          }
          get granter() {
            return m.Message.getField(this, 1);
          }
          set granter(k) {
            m.Message.setField(this, 1, k);
          }
          get grantee() {
            return m.Message.getField(this, 2);
          }
          set grantee(k) {
            m.Message.setField(this, 2, k);
          }
          get grant() {
            return m.Message.getWrapperField(this, d.cosmos.authz.v1beta1.Grant, 3);
          }
          set grant(k) {
            m.Message.setWrapperField(this, 3, k);
          }
          static fromObject(k) {
            const F = new E({});
            return k.granter != null && (F.granter = k.granter), k.grantee != null && (F.grantee = k.grantee), k.grant != null && (F.grant = d.cosmos.authz.v1beta1.Grant.fromObject(k.grant)), F;
          }
          toObject() {
            const k = {};
            return this.granter != null && (k.granter = this.granter), this.grantee != null && (k.grantee = this.grantee), this.grant != null && (k.grant = this.grant.toObject()), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (typeof this.granter == "string" && this.granter.length && F.writeString(1, this.granter), typeof this.grantee == "string" && this.grantee.length && F.writeString(2, this.grantee), this.grant !== void 0 && F.writeMessage(3, this.grant, () => this.grant.serialize(F)), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new E();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.granter = F.readString();
                  break;
                case 2:
                  X.grantee = F.readString();
                  break;
                case 3:
                  F.readMessage(X.grant, () => X.grant = d.cosmos.authz.v1beta1.Grant.deserialize(F));
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return E.deserialize(k);
          }
        }
        $.MsgGrant = E;
        class O extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [1], []), !Array.isArray(k) && typeof k == "object" && "results" in k && k.results != null && (this.results = k.results);
          }
          get results() {
            return m.Message.getField(this, 1);
          }
          set results(k) {
            m.Message.setField(this, 1, k);
          }
          static fromObject(k) {
            const F = new O({});
            return k.results != null && (F.results = k.results), F;
          }
          toObject() {
            const k = {};
            return this.results != null && (k.results = this.results), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (this.results !== void 0 && F.writeRepeatedBytes(1, this.results), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new O();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  m.Message.addToRepeatedField(X, 1, F.readBytes());
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return O.deserialize(k);
          }
        }
        $.MsgExecResponse = O;
        class T extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [2], []), !Array.isArray(k) && typeof k == "object" && ("grantee" in k && k.grantee != null && (this.grantee = k.grantee), "msgs" in k && k.msgs != null && (this.msgs = k.msgs));
          }
          get grantee() {
            return m.Message.getField(this, 1);
          }
          set grantee(k) {
            m.Message.setField(this, 1, k);
          }
          get msgs() {
            return m.Message.getRepeatedWrapperField(this, c.google.protobuf.Any, 2);
          }
          set msgs(k) {
            m.Message.setRepeatedWrapperField(this, 2, k);
          }
          static fromObject(k) {
            const F = new T({});
            return k.grantee != null && (F.grantee = k.grantee), k.msgs != null && (F.msgs = k.msgs.map((X) => c.google.protobuf.Any.fromObject(X))), F;
          }
          toObject() {
            const k = {};
            return this.grantee != null && (k.grantee = this.grantee), this.msgs != null && (k.msgs = this.msgs.map((F) => F.toObject())), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (typeof this.grantee == "string" && this.grantee.length && F.writeString(1, this.grantee), this.msgs !== void 0 && F.writeRepeatedMessage(2, this.msgs, (X) => X.serialize(F)), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new T();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.grantee = F.readString();
                  break;
                case 2:
                  F.readMessage(X.msgs, () => m.Message.addToRepeatedWrapperField(X, 2, c.google.protobuf.Any.deserialize(F), c.google.protobuf.Any));
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return T.deserialize(k);
          }
        }
        $.MsgExec = T;
        class y extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []);
          }
          static fromObject(k) {
            return new y({});
          }
          toObject() {
            return {};
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (!k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new y();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return y.deserialize(k);
          }
        }
        $.MsgGrantResponse = y;
        class V extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("granter" in k && k.granter != null && (this.granter = k.granter), "grantee" in k && k.grantee != null && (this.grantee = k.grantee), "msg_type_url" in k && k.msg_type_url != null && (this.msg_type_url = k.msg_type_url));
          }
          get granter() {
            return m.Message.getField(this, 1);
          }
          set granter(k) {
            m.Message.setField(this, 1, k);
          }
          get grantee() {
            return m.Message.getField(this, 2);
          }
          set grantee(k) {
            m.Message.setField(this, 2, k);
          }
          get msg_type_url() {
            return m.Message.getField(this, 3);
          }
          set msg_type_url(k) {
            m.Message.setField(this, 3, k);
          }
          static fromObject(k) {
            const F = new V({});
            return k.granter != null && (F.granter = k.granter), k.grantee != null && (F.grantee = k.grantee), k.msg_type_url != null && (F.msg_type_url = k.msg_type_url), F;
          }
          toObject() {
            const k = {};
            return this.granter != null && (k.granter = this.granter), this.grantee != null && (k.grantee = this.grantee), this.msg_type_url != null && (k.msg_type_url = this.msg_type_url), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (typeof this.granter == "string" && this.granter.length && F.writeString(1, this.granter), typeof this.grantee == "string" && this.grantee.length && F.writeString(2, this.grantee), typeof this.msg_type_url == "string" && this.msg_type_url.length && F.writeString(3, this.msg_type_url), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new V();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.granter = F.readString();
                  break;
                case 2:
                  X.grantee = F.readString();
                  break;
                case 3:
                  X.msg_type_url = F.readString();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return V.deserialize(k);
          }
        }
        $.MsgRevoke = V;
        class M extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []);
          }
          static fromObject(k) {
            return new M({});
          }
          toObject() {
            return {};
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (!k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new M();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return M.deserialize(k);
          }
        }
        $.MsgRevokeResponse = M;
      })(S.v1beta1 || (S.v1beta1 = {}));
    })(v.authz || (v.authz = {}));
  })(e.cosmos || (e.cosmos = {}));
})(tx$8);
var utils$o = {}, __createBinding$e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$e = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$e = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$e(n, e, o);
  return __setModuleDefault$e(n, e), n;
};
Object.defineProperty(utils$o, "__esModule", { value: !0 });
utils$o.createAnyMessage = void 0;
const google$1 = __importStar$e(any);
function createAnyMessage(e) {
  return new google$1.google.protobuf.Any({
    type_url: `/${e.path}`,
    value: e.message.serializeBinary()
  });
}
utils$o.createAnyMessage = createAnyMessage;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(E, O, T, y) {
    y === void 0 && (y = T);
    var V = Object.getOwnPropertyDescriptor(O, T);
    (!V || ("get" in V ? !O.__esModule : V.writable || V.configurable)) && (V = { enumerable: !0, get: function() {
      return O[T];
    } }), Object.defineProperty(E, y, V);
  } : function(E, O, T, y) {
    y === void 0 && (y = T), E[y] = O[T];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(E, O) {
    Object.defineProperty(E, "default", { enumerable: !0, value: O });
  } : function(E, O) {
    E.default = O;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(E) {
    if (E && E.__esModule)
      return E;
    var O = {};
    if (E != null)
      for (var T in E)
        T !== "default" && Object.prototype.hasOwnProperty.call(E, T) && n(O, E, T);
    return o(O, E), O;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createMsgRevoke = e.RevokeMessages = e.createMsgGrant = void 0;
  const c = u(tx$8), d = u(authz$1), m = utils$o, v = u(timestamp);
  function S(E, O, T, y) {
    return {
      message: new c.cosmos.authz.v1beta1.MsgGrant({
        granter: E,
        grantee: O,
        grant: new d.cosmos.authz.v1beta1.Grant({
          authorization: (0, m.createAnyMessage)(T),
          expiration: new v.google.protobuf.Timestamp({
            seconds: y,
            nanos: 0
          })
        })
      }),
      path: "cosmos.authz.v1beta1.MsgGrant"
    };
  }
  e.createMsgGrant = S, function(E) {
    E.REVOKE_MSG_DELEGATE = "/cosmos.staking.v1beta1.MsgDelegate", E.REVOKE_MSG_WITHDRAW_DELEGATOR_REWARDS = "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
  }(e.RevokeMessages || (e.RevokeMessages = {}));
  function $(E, O, T) {
    return {
      message: new c.cosmos.authz.v1beta1.MsgRevoke({
        granter: E,
        grantee: O,
        msg_type_url: T
      }),
      path: "cosmos.authz.v1beta1.MsgRevoke"
    };
  }
  e.createMsgRevoke = $;
})(authz$2);
var stake = {}, authz = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(m, v, S, $) {
    $ === void 0 && ($ = S);
    var E = Object.getOwnPropertyDescriptor(v, S);
    (!E || ("get" in E ? !v.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
      return v[S];
    } }), Object.defineProperty(m, $, E);
  } : function(m, v, S, $) {
    $ === void 0 && ($ = S), m[$] = v[S];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(m, v) {
    Object.defineProperty(m, "default", { enumerable: !0, value: v });
  } : function(m, v) {
    m.default = v;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(m) {
    if (m && m.__esModule)
      return m;
    var v = {};
    if (m != null)
      for (var S in m)
        S !== "default" && Object.prototype.hasOwnProperty.call(m, S) && n(v, m, S);
    return o(v, m), v;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(coin$6), d = u(googleProtobuf);
  (function(m) {
    (function(v) {
      (function(S) {
        (function(E) {
          E[E.AUTHORIZATION_TYPE_UNSPECIFIED = 0] = "AUTHORIZATION_TYPE_UNSPECIFIED", E[E.AUTHORIZATION_TYPE_DELEGATE = 1] = "AUTHORIZATION_TYPE_DELEGATE", E[E.AUTHORIZATION_TYPE_UNDELEGATE = 2] = "AUTHORIZATION_TYPE_UNDELEGATE", E[E.AUTHORIZATION_TYPE_REDELEGATE = 3] = "AUTHORIZATION_TYPE_REDELEGATE";
        })(S.AuthorizationType || (S.AuthorizationType = {}));
        class $ extends d.Message {
          constructor(O) {
            super(), d.Message.initialize(this, Array.isArray(O) ? O : [], 0, -1, [], [[2, 3]]), !Array.isArray(O) && typeof O == "object" && ("max_tokens" in O && O.max_tokens != null && (this.max_tokens = O.max_tokens), "allow_list" in O && O.allow_list != null && (this.allow_list = O.allow_list), "deny_list" in O && O.deny_list != null && (this.deny_list = O.deny_list), "authorization_type" in O && O.authorization_type != null && (this.authorization_type = O.authorization_type));
          }
          get max_tokens() {
            return d.Message.getWrapperField(this, c.cosmos.base.v1beta1.Coin, 1);
          }
          set max_tokens(O) {
            d.Message.setWrapperField(this, 1, O);
          }
          get allow_list() {
            return d.Message.getWrapperField(this, $.Validators, 2);
          }
          set allow_list(O) {
            d.Message.setOneofWrapperField(this, 2, [2, 3], O);
          }
          get deny_list() {
            return d.Message.getWrapperField(this, $.Validators, 3);
          }
          set deny_list(O) {
            d.Message.setOneofWrapperField(this, 3, [2, 3], O);
          }
          get authorization_type() {
            return d.Message.getField(this, 4);
          }
          set authorization_type(O) {
            d.Message.setField(this, 4, O);
          }
          get validators() {
            return {
              0: "none",
              2: "allow_list",
              3: "deny_list"
            }[d.Message.computeOneofCase(this, [2, 3])];
          }
          static fromObject(O) {
            const T = new $({});
            return O.max_tokens != null && (T.max_tokens = c.cosmos.base.v1beta1.Coin.fromObject(O.max_tokens)), O.allow_list != null && (T.allow_list = $.Validators.fromObject(O.allow_list)), O.deny_list != null && (T.deny_list = $.Validators.fromObject(O.deny_list)), O.authorization_type != null && (T.authorization_type = O.authorization_type), T;
          }
          toObject() {
            const O = {};
            return this.max_tokens != null && (O.max_tokens = this.max_tokens.toObject()), this.allow_list != null && (O.allow_list = this.allow_list.toObject()), this.deny_list != null && (O.deny_list = this.deny_list.toObject()), this.authorization_type != null && (O.authorization_type = this.authorization_type), O;
          }
          serialize(O) {
            const T = O || new d.BinaryWriter();
            if (this.max_tokens !== void 0 && T.writeMessage(1, this.max_tokens, () => this.max_tokens.serialize(T)), this.allow_list !== void 0 && T.writeMessage(2, this.allow_list, () => this.allow_list.serialize(T)), this.deny_list !== void 0 && T.writeMessage(3, this.deny_list, () => this.deny_list.serialize(T)), this.authorization_type !== void 0 && T.writeEnum(4, this.authorization_type), !O)
              return T.getResultBuffer();
          }
          static deserialize(O) {
            const T = O instanceof d.BinaryReader ? O : new d.BinaryReader(O), y = new $();
            for (; T.nextField() && !T.isEndGroup(); )
              switch (T.getFieldNumber()) {
                case 1:
                  T.readMessage(y.max_tokens, () => y.max_tokens = c.cosmos.base.v1beta1.Coin.deserialize(T));
                  break;
                case 2:
                  T.readMessage(y.allow_list, () => y.allow_list = $.Validators.deserialize(T));
                  break;
                case 3:
                  T.readMessage(y.deny_list, () => y.deny_list = $.Validators.deserialize(T));
                  break;
                case 4:
                  y.authorization_type = T.readEnum();
                  break;
                default:
                  T.skipField();
              }
            return y;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(O) {
            return $.deserialize(O);
          }
        }
        S.StakeAuthorization = $, function(E) {
          class O extends d.Message {
            constructor(y) {
              super(), d.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [1], []), !Array.isArray(y) && typeof y == "object" && "address" in y && y.address != null && (this.address = y.address);
            }
            get address() {
              return d.Message.getField(this, 1);
            }
            set address(y) {
              d.Message.setField(this, 1, y);
            }
            static fromObject(y) {
              const V = new O({});
              return y.address != null && (V.address = y.address), V;
            }
            toObject() {
              const y = {};
              return this.address != null && (y.address = this.address), y;
            }
            serialize(y) {
              const V = y || new d.BinaryWriter();
              if (this.address !== void 0 && V.writeRepeatedString(1, this.address), !y)
                return V.getResultBuffer();
            }
            static deserialize(y) {
              const V = y instanceof d.BinaryReader ? y : new d.BinaryReader(y), M = new O();
              for (; V.nextField() && !V.isEndGroup(); )
                switch (V.getFieldNumber()) {
                  case 1:
                    d.Message.addToRepeatedField(M, 1, V.readString());
                    break;
                  default:
                    V.skipField();
                }
              return M;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(y) {
              return O.deserialize(y);
            }
          }
          E.Validators = O;
        }($ = S.StakeAuthorization || (S.StakeAuthorization = {}));
      })(v.v1beta1 || (v.v1beta1 = {}));
    })(m.staking || (m.staking = {}));
  })(e.cosmos || (e.cosmos = {}));
})(authz);
var __createBinding$d = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$d = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$d = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$d(n, e, o);
  return __setModuleDefault$d(n, e), n;
};
Object.defineProperty(stake, "__esModule", { value: !0 });
stake.createStakeAuthorization = stake.stakeAuthTypes = void 0;
const coin$4 = __importStar$d(coin$6), authzStake = __importStar$d(authz);
stake.stakeAuthTypes = authzStake.cosmos.staking.v1beta1.AuthorizationType;
function createStakeAuthorization(e, n, o, u) {
  return {
    message: new authzStake.cosmos.staking.v1beta1.StakeAuthorization({
      allow_list: new authzStake.cosmos.staking.v1beta1.StakeAuthorization.Validators({
        address: [e]
      }),
      max_tokens: o ? new coin$4.cosmos.base.v1beta1.Coin({
        denom: n,
        amount: o
      }) : void 0,
      authorization_type: u
    }),
    path: "cosmos.staking.v1beta1.StakeAuthorization"
  };
}
stake.createStakeAuthorization = createStakeAuthorization;
var ibcMsgTransfer$2 = {}, tx$7 = {}, client = {}, upgrade = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, S, $, E) {
    E === void 0 && (E = $);
    var O = Object.getOwnPropertyDescriptor(S, $);
    (!O || ("get" in O ? !S.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return S[$];
    } }), Object.defineProperty(v, E, O);
  } : function(v, S, $, E) {
    E === void 0 && (E = $), v[E] = S[$];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, S) {
    Object.defineProperty(v, "default", { enumerable: !0, value: S });
  } : function(v, S) {
    v.default = S;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var S = {};
    if (v != null)
      for (var $ in v)
        $ !== "default" && Object.prototype.hasOwnProperty.call(v, $) && n(S, v, $);
    return o(S, v), S;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(any), d = u(timestamp), m = u(googleProtobuf);
  (function(v) {
    (function(S) {
      (function($) {
        class E extends m.Message {
          constructor(M) {
            super(), m.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []), !Array.isArray(M) && typeof M == "object" && ("name" in M && M.name != null && (this.name = M.name), "time" in M && M.time != null && (this.time = M.time), "height" in M && M.height != null && (this.height = M.height), "info" in M && M.info != null && (this.info = M.info), "upgraded_client_state" in M && M.upgraded_client_state != null && (this.upgraded_client_state = M.upgraded_client_state));
          }
          get name() {
            return m.Message.getField(this, 1);
          }
          set name(M) {
            m.Message.setField(this, 1, M);
          }
          get time() {
            return m.Message.getWrapperField(this, d.google.protobuf.Timestamp, 2);
          }
          set time(M) {
            m.Message.setWrapperField(this, 2, M);
          }
          get height() {
            return m.Message.getField(this, 3);
          }
          set height(M) {
            m.Message.setField(this, 3, M);
          }
          get info() {
            return m.Message.getField(this, 4);
          }
          set info(M) {
            m.Message.setField(this, 4, M);
          }
          get upgraded_client_state() {
            return m.Message.getWrapperField(this, c.google.protobuf.Any, 5);
          }
          set upgraded_client_state(M) {
            m.Message.setWrapperField(this, 5, M);
          }
          static fromObject(M) {
            const G = new E({});
            return M.name != null && (G.name = M.name), M.time != null && (G.time = d.google.protobuf.Timestamp.fromObject(M.time)), M.height != null && (G.height = M.height), M.info != null && (G.info = M.info), M.upgraded_client_state != null && (G.upgraded_client_state = c.google.protobuf.Any.fromObject(M.upgraded_client_state)), G;
          }
          toObject() {
            const M = {};
            return this.name != null && (M.name = this.name), this.time != null && (M.time = this.time.toObject()), this.height != null && (M.height = this.height), this.info != null && (M.info = this.info), this.upgraded_client_state != null && (M.upgraded_client_state = this.upgraded_client_state.toObject()), M;
          }
          serialize(M) {
            const G = M || new m.BinaryWriter();
            if (typeof this.name == "string" && this.name.length && G.writeString(1, this.name), this.time !== void 0 && G.writeMessage(2, this.time, () => this.time.serialize(G)), this.height !== void 0 && G.writeInt64(3, this.height), typeof this.info == "string" && this.info.length && G.writeString(4, this.info), this.upgraded_client_state !== void 0 && G.writeMessage(5, this.upgraded_client_state, () => this.upgraded_client_state.serialize(G)), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof m.BinaryReader ? M : new m.BinaryReader(M), k = new E();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  k.name = G.readString();
                  break;
                case 2:
                  G.readMessage(k.time, () => k.time = d.google.protobuf.Timestamp.deserialize(G));
                  break;
                case 3:
                  k.height = G.readInt64();
                  break;
                case 4:
                  k.info = G.readString();
                  break;
                case 5:
                  G.readMessage(k.upgraded_client_state, () => k.upgraded_client_state = c.google.protobuf.Any.deserialize(G));
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return E.deserialize(M);
          }
        }
        $.Plan = E;
        class O extends m.Message {
          constructor(M) {
            super(), m.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []), !Array.isArray(M) && typeof M == "object" && ("title" in M && M.title != null && (this.title = M.title), "description" in M && M.description != null && (this.description = M.description), "plan" in M && M.plan != null && (this.plan = M.plan));
          }
          get title() {
            return m.Message.getField(this, 1);
          }
          set title(M) {
            m.Message.setField(this, 1, M);
          }
          get description() {
            return m.Message.getField(this, 2);
          }
          set description(M) {
            m.Message.setField(this, 2, M);
          }
          get plan() {
            return m.Message.getWrapperField(this, E, 3);
          }
          set plan(M) {
            m.Message.setWrapperField(this, 3, M);
          }
          static fromObject(M) {
            const G = new O({});
            return M.title != null && (G.title = M.title), M.description != null && (G.description = M.description), M.plan != null && (G.plan = E.fromObject(M.plan)), G;
          }
          toObject() {
            const M = {};
            return this.title != null && (M.title = this.title), this.description != null && (M.description = this.description), this.plan != null && (M.plan = this.plan.toObject()), M;
          }
          serialize(M) {
            const G = M || new m.BinaryWriter();
            if (typeof this.title == "string" && this.title.length && G.writeString(1, this.title), typeof this.description == "string" && this.description.length && G.writeString(2, this.description), this.plan !== void 0 && G.writeMessage(3, this.plan, () => this.plan.serialize(G)), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof m.BinaryReader ? M : new m.BinaryReader(M), k = new O();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  k.title = G.readString();
                  break;
                case 2:
                  k.description = G.readString();
                  break;
                case 3:
                  G.readMessage(k.plan, () => k.plan = E.deserialize(G));
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return O.deserialize(M);
          }
        }
        $.SoftwareUpgradeProposal = O;
        class T extends m.Message {
          constructor(M) {
            super(), m.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []), !Array.isArray(M) && typeof M == "object" && ("title" in M && M.title != null && (this.title = M.title), "description" in M && M.description != null && (this.description = M.description));
          }
          get title() {
            return m.Message.getField(this, 1);
          }
          set title(M) {
            m.Message.setField(this, 1, M);
          }
          get description() {
            return m.Message.getField(this, 2);
          }
          set description(M) {
            m.Message.setField(this, 2, M);
          }
          static fromObject(M) {
            const G = new T({});
            return M.title != null && (G.title = M.title), M.description != null && (G.description = M.description), G;
          }
          toObject() {
            const M = {};
            return this.title != null && (M.title = this.title), this.description != null && (M.description = this.description), M;
          }
          serialize(M) {
            const G = M || new m.BinaryWriter();
            if (typeof this.title == "string" && this.title.length && G.writeString(1, this.title), typeof this.description == "string" && this.description.length && G.writeString(2, this.description), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof m.BinaryReader ? M : new m.BinaryReader(M), k = new T();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  k.title = G.readString();
                  break;
                case 2:
                  k.description = G.readString();
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return T.deserialize(M);
          }
        }
        $.CancelSoftwareUpgradeProposal = T;
        class y extends m.Message {
          constructor(M) {
            super(), m.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []), !Array.isArray(M) && typeof M == "object" && ("name" in M && M.name != null && (this.name = M.name), "version" in M && M.version != null && (this.version = M.version));
          }
          get name() {
            return m.Message.getField(this, 1);
          }
          set name(M) {
            m.Message.setField(this, 1, M);
          }
          get version() {
            return m.Message.getField(this, 2);
          }
          set version(M) {
            m.Message.setField(this, 2, M);
          }
          static fromObject(M) {
            const G = new y({});
            return M.name != null && (G.name = M.name), M.version != null && (G.version = M.version), G;
          }
          toObject() {
            const M = {};
            return this.name != null && (M.name = this.name), this.version != null && (M.version = this.version), M;
          }
          serialize(M) {
            const G = M || new m.BinaryWriter();
            if (typeof this.name == "string" && this.name.length && G.writeString(1, this.name), this.version !== void 0 && G.writeUint64(2, this.version), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof m.BinaryReader ? M : new m.BinaryReader(M), k = new y();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  k.name = G.readString();
                  break;
                case 2:
                  k.version = G.readUint64();
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return y.deserialize(M);
          }
        }
        $.ModuleVersion = y;
      })(S.v1beta1 || (S.v1beta1 = {}));
    })(v.upgrade || (v.upgrade = {}));
  })(e.cosmos || (e.cosmos = {}));
})(upgrade);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, S, $, E) {
    E === void 0 && (E = $);
    var O = Object.getOwnPropertyDescriptor(S, $);
    (!O || ("get" in O ? !S.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return S[$];
    } }), Object.defineProperty(v, E, O);
  } : function(v, S, $, E) {
    E === void 0 && (E = $), v[E] = S[$];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, S) {
    Object.defineProperty(v, "default", { enumerable: !0, value: S });
  } : function(v, S) {
    v.default = S;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var S = {};
    if (v != null)
      for (var $ in v)
        $ !== "default" && Object.prototype.hasOwnProperty.call(v, $) && n(S, v, $);
    return o(S, v), S;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ibc = void 0;
  const c = u(any), d = u(upgrade), m = u(googleProtobuf);
  (function(v) {
    (function(S) {
      (function($) {
        (function(E) {
          class O extends m.Message {
            constructor(X) {
              super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [], []), !Array.isArray(X) && typeof X == "object" && ("client_id" in X && X.client_id != null && (this.client_id = X.client_id), "client_state" in X && X.client_state != null && (this.client_state = X.client_state));
            }
            get client_id() {
              return m.Message.getField(this, 1);
            }
            set client_id(X) {
              m.Message.setField(this, 1, X);
            }
            get client_state() {
              return m.Message.getWrapperField(this, c.google.protobuf.Any, 2);
            }
            set client_state(X) {
              m.Message.setWrapperField(this, 2, X);
            }
            static fromObject(X) {
              const ee = new O({});
              return X.client_id != null && (ee.client_id = X.client_id), X.client_state != null && (ee.client_state = c.google.protobuf.Any.fromObject(X.client_state)), ee;
            }
            toObject() {
              const X = {};
              return this.client_id != null && (X.client_id = this.client_id), this.client_state != null && (X.client_state = this.client_state.toObject()), X;
            }
            serialize(X) {
              const ee = X || new m.BinaryWriter();
              if (typeof this.client_id == "string" && this.client_id.length && ee.writeString(1, this.client_id), this.client_state !== void 0 && ee.writeMessage(2, this.client_state, () => this.client_state.serialize(ee)), !X)
                return ee.getResultBuffer();
            }
            static deserialize(X) {
              const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new O();
              for (; ee.nextField() && !ee.isEndGroup(); )
                switch (ee.getFieldNumber()) {
                  case 1:
                    ue.client_id = ee.readString();
                    break;
                  case 2:
                    ee.readMessage(ue.client_state, () => ue.client_state = c.google.protobuf.Any.deserialize(ee));
                    break;
                  default:
                    ee.skipField();
                }
              return ue;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(X) {
              return O.deserialize(X);
            }
          }
          E.IdentifiedClientState = O;
          class T extends m.Message {
            constructor(X) {
              super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [], []), !Array.isArray(X) && typeof X == "object" && ("height" in X && X.height != null && (this.height = X.height), "consensus_state" in X && X.consensus_state != null && (this.consensus_state = X.consensus_state));
            }
            get height() {
              return m.Message.getWrapperField(this, G, 1);
            }
            set height(X) {
              m.Message.setWrapperField(this, 1, X);
            }
            get consensus_state() {
              return m.Message.getWrapperField(this, c.google.protobuf.Any, 2);
            }
            set consensus_state(X) {
              m.Message.setWrapperField(this, 2, X);
            }
            static fromObject(X) {
              const ee = new T({});
              return X.height != null && (ee.height = G.fromObject(X.height)), X.consensus_state != null && (ee.consensus_state = c.google.protobuf.Any.fromObject(X.consensus_state)), ee;
            }
            toObject() {
              const X = {};
              return this.height != null && (X.height = this.height.toObject()), this.consensus_state != null && (X.consensus_state = this.consensus_state.toObject()), X;
            }
            serialize(X) {
              const ee = X || new m.BinaryWriter();
              if (this.height !== void 0 && ee.writeMessage(1, this.height, () => this.height.serialize(ee)), this.consensus_state !== void 0 && ee.writeMessage(2, this.consensus_state, () => this.consensus_state.serialize(ee)), !X)
                return ee.getResultBuffer();
            }
            static deserialize(X) {
              const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new T();
              for (; ee.nextField() && !ee.isEndGroup(); )
                switch (ee.getFieldNumber()) {
                  case 1:
                    ee.readMessage(ue.height, () => ue.height = G.deserialize(ee));
                    break;
                  case 2:
                    ee.readMessage(ue.consensus_state, () => ue.consensus_state = c.google.protobuf.Any.deserialize(ee));
                    break;
                  default:
                    ee.skipField();
                }
              return ue;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(X) {
              return T.deserialize(X);
            }
          }
          E.ConsensusStateWithHeight = T;
          class y extends m.Message {
            constructor(X) {
              super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [2], []), !Array.isArray(X) && typeof X == "object" && ("client_id" in X && X.client_id != null && (this.client_id = X.client_id), "consensus_states" in X && X.consensus_states != null && (this.consensus_states = X.consensus_states));
            }
            get client_id() {
              return m.Message.getField(this, 1);
            }
            set client_id(X) {
              m.Message.setField(this, 1, X);
            }
            get consensus_states() {
              return m.Message.getRepeatedWrapperField(this, T, 2);
            }
            set consensus_states(X) {
              m.Message.setRepeatedWrapperField(this, 2, X);
            }
            static fromObject(X) {
              const ee = new y({});
              return X.client_id != null && (ee.client_id = X.client_id), X.consensus_states != null && (ee.consensus_states = X.consensus_states.map((ue) => T.fromObject(ue))), ee;
            }
            toObject() {
              const X = {};
              return this.client_id != null && (X.client_id = this.client_id), this.consensus_states != null && (X.consensus_states = this.consensus_states.map((ee) => ee.toObject())), X;
            }
            serialize(X) {
              const ee = X || new m.BinaryWriter();
              if (typeof this.client_id == "string" && this.client_id.length && ee.writeString(1, this.client_id), this.consensus_states !== void 0 && ee.writeRepeatedMessage(2, this.consensus_states, (ue) => ue.serialize(ee)), !X)
                return ee.getResultBuffer();
            }
            static deserialize(X) {
              const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new y();
              for (; ee.nextField() && !ee.isEndGroup(); )
                switch (ee.getFieldNumber()) {
                  case 1:
                    ue.client_id = ee.readString();
                    break;
                  case 2:
                    ee.readMessage(ue.consensus_states, () => m.Message.addToRepeatedWrapperField(ue, 2, T.deserialize(ee), T));
                    break;
                  default:
                    ee.skipField();
                }
              return ue;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(X) {
              return y.deserialize(X);
            }
          }
          E.ClientConsensusStates = y;
          class V extends m.Message {
            constructor(X) {
              super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [], []), !Array.isArray(X) && typeof X == "object" && ("title" in X && X.title != null && (this.title = X.title), "description" in X && X.description != null && (this.description = X.description), "subject_client_id" in X && X.subject_client_id != null && (this.subject_client_id = X.subject_client_id), "substitute_client_id" in X && X.substitute_client_id != null && (this.substitute_client_id = X.substitute_client_id));
            }
            get title() {
              return m.Message.getField(this, 1);
            }
            set title(X) {
              m.Message.setField(this, 1, X);
            }
            get description() {
              return m.Message.getField(this, 2);
            }
            set description(X) {
              m.Message.setField(this, 2, X);
            }
            get subject_client_id() {
              return m.Message.getField(this, 3);
            }
            set subject_client_id(X) {
              m.Message.setField(this, 3, X);
            }
            get substitute_client_id() {
              return m.Message.getField(this, 4);
            }
            set substitute_client_id(X) {
              m.Message.setField(this, 4, X);
            }
            static fromObject(X) {
              const ee = new V({});
              return X.title != null && (ee.title = X.title), X.description != null && (ee.description = X.description), X.subject_client_id != null && (ee.subject_client_id = X.subject_client_id), X.substitute_client_id != null && (ee.substitute_client_id = X.substitute_client_id), ee;
            }
            toObject() {
              const X = {};
              return this.title != null && (X.title = this.title), this.description != null && (X.description = this.description), this.subject_client_id != null && (X.subject_client_id = this.subject_client_id), this.substitute_client_id != null && (X.substitute_client_id = this.substitute_client_id), X;
            }
            serialize(X) {
              const ee = X || new m.BinaryWriter();
              if (typeof this.title == "string" && this.title.length && ee.writeString(1, this.title), typeof this.description == "string" && this.description.length && ee.writeString(2, this.description), typeof this.subject_client_id == "string" && this.subject_client_id.length && ee.writeString(3, this.subject_client_id), typeof this.substitute_client_id == "string" && this.substitute_client_id.length && ee.writeString(4, this.substitute_client_id), !X)
                return ee.getResultBuffer();
            }
            static deserialize(X) {
              const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new V();
              for (; ee.nextField() && !ee.isEndGroup(); )
                switch (ee.getFieldNumber()) {
                  case 1:
                    ue.title = ee.readString();
                    break;
                  case 2:
                    ue.description = ee.readString();
                    break;
                  case 3:
                    ue.subject_client_id = ee.readString();
                    break;
                  case 4:
                    ue.substitute_client_id = ee.readString();
                    break;
                  default:
                    ee.skipField();
                }
              return ue;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(X) {
              return V.deserialize(X);
            }
          }
          E.ClientUpdateProposal = V;
          class M extends m.Message {
            constructor(X) {
              super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [], []), !Array.isArray(X) && typeof X == "object" && ("title" in X && X.title != null && (this.title = X.title), "description" in X && X.description != null && (this.description = X.description), "plan" in X && X.plan != null && (this.plan = X.plan), "upgraded_client_state" in X && X.upgraded_client_state != null && (this.upgraded_client_state = X.upgraded_client_state));
            }
            get title() {
              return m.Message.getField(this, 1);
            }
            set title(X) {
              m.Message.setField(this, 1, X);
            }
            get description() {
              return m.Message.getField(this, 2);
            }
            set description(X) {
              m.Message.setField(this, 2, X);
            }
            get plan() {
              return m.Message.getWrapperField(this, d.cosmos.upgrade.v1beta1.Plan, 3);
            }
            set plan(X) {
              m.Message.setWrapperField(this, 3, X);
            }
            get upgraded_client_state() {
              return m.Message.getWrapperField(this, c.google.protobuf.Any, 4);
            }
            set upgraded_client_state(X) {
              m.Message.setWrapperField(this, 4, X);
            }
            static fromObject(X) {
              const ee = new M({});
              return X.title != null && (ee.title = X.title), X.description != null && (ee.description = X.description), X.plan != null && (ee.plan = d.cosmos.upgrade.v1beta1.Plan.fromObject(X.plan)), X.upgraded_client_state != null && (ee.upgraded_client_state = c.google.protobuf.Any.fromObject(X.upgraded_client_state)), ee;
            }
            toObject() {
              const X = {};
              return this.title != null && (X.title = this.title), this.description != null && (X.description = this.description), this.plan != null && (X.plan = this.plan.toObject()), this.upgraded_client_state != null && (X.upgraded_client_state = this.upgraded_client_state.toObject()), X;
            }
            serialize(X) {
              const ee = X || new m.BinaryWriter();
              if (typeof this.title == "string" && this.title.length && ee.writeString(1, this.title), typeof this.description == "string" && this.description.length && ee.writeString(2, this.description), this.plan !== void 0 && ee.writeMessage(3, this.plan, () => this.plan.serialize(ee)), this.upgraded_client_state !== void 0 && ee.writeMessage(4, this.upgraded_client_state, () => this.upgraded_client_state.serialize(ee)), !X)
                return ee.getResultBuffer();
            }
            static deserialize(X) {
              const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new M();
              for (; ee.nextField() && !ee.isEndGroup(); )
                switch (ee.getFieldNumber()) {
                  case 1:
                    ue.title = ee.readString();
                    break;
                  case 2:
                    ue.description = ee.readString();
                    break;
                  case 3:
                    ee.readMessage(ue.plan, () => ue.plan = d.cosmos.upgrade.v1beta1.Plan.deserialize(ee));
                    break;
                  case 4:
                    ee.readMessage(ue.upgraded_client_state, () => ue.upgraded_client_state = c.google.protobuf.Any.deserialize(ee));
                    break;
                  default:
                    ee.skipField();
                }
              return ue;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(X) {
              return M.deserialize(X);
            }
          }
          E.UpgradeProposal = M;
          class G extends m.Message {
            constructor(X) {
              super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [], []), !Array.isArray(X) && typeof X == "object" && ("revision_number" in X && X.revision_number != null && (this.revision_number = X.revision_number), "revision_height" in X && X.revision_height != null && (this.revision_height = X.revision_height));
            }
            get revision_number() {
              return m.Message.getField(this, 1);
            }
            set revision_number(X) {
              m.Message.setField(this, 1, X);
            }
            get revision_height() {
              return m.Message.getField(this, 2);
            }
            set revision_height(X) {
              m.Message.setField(this, 2, X);
            }
            static fromObject(X) {
              const ee = new G({});
              return X.revision_number != null && (ee.revision_number = X.revision_number), X.revision_height != null && (ee.revision_height = X.revision_height), ee;
            }
            toObject() {
              const X = {};
              return this.revision_number != null && (X.revision_number = this.revision_number), this.revision_height != null && (X.revision_height = this.revision_height), X;
            }
            serialize(X) {
              const ee = X || new m.BinaryWriter();
              if (this.revision_number !== void 0 && ee.writeUint64(1, this.revision_number), this.revision_height !== void 0 && ee.writeUint64(2, this.revision_height), !X)
                return ee.getResultBuffer();
            }
            static deserialize(X) {
              const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new G();
              for (; ee.nextField() && !ee.isEndGroup(); )
                switch (ee.getFieldNumber()) {
                  case 1:
                    ue.revision_number = ee.readUint64();
                    break;
                  case 2:
                    ue.revision_height = ee.readUint64();
                    break;
                  default:
                    ee.skipField();
                }
              return ue;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(X) {
              return G.deserialize(X);
            }
          }
          E.Height = G;
          class k extends m.Message {
            constructor(X) {
              super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [1], []), !Array.isArray(X) && typeof X == "object" && "allowed_clients" in X && X.allowed_clients != null && (this.allowed_clients = X.allowed_clients);
            }
            get allowed_clients() {
              return m.Message.getField(this, 1);
            }
            set allowed_clients(X) {
              m.Message.setField(this, 1, X);
            }
            static fromObject(X) {
              const ee = new k({});
              return X.allowed_clients != null && (ee.allowed_clients = X.allowed_clients), ee;
            }
            toObject() {
              const X = {};
              return this.allowed_clients != null && (X.allowed_clients = this.allowed_clients), X;
            }
            serialize(X) {
              const ee = X || new m.BinaryWriter();
              if (this.allowed_clients !== void 0 && ee.writeRepeatedString(1, this.allowed_clients), !X)
                return ee.getResultBuffer();
            }
            static deserialize(X) {
              const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new k();
              for (; ee.nextField() && !ee.isEndGroup(); )
                switch (ee.getFieldNumber()) {
                  case 1:
                    m.Message.addToRepeatedField(ue, 1, ee.readString());
                    break;
                  default:
                    ee.skipField();
                }
              return ue;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(X) {
              return k.deserialize(X);
            }
          }
          E.Params = k;
        })($.v1 || ($.v1 = {}));
      })(S.client || (S.client = {}));
    })(v.core || (v.core = {}));
  })(e.ibc || (e.ibc = {}));
})(client);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, S, $, E) {
    E === void 0 && (E = $);
    var O = Object.getOwnPropertyDescriptor(S, $);
    (!O || ("get" in O ? !S.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return S[$];
    } }), Object.defineProperty(v, E, O);
  } : function(v, S, $, E) {
    E === void 0 && (E = $), v[E] = S[$];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, S) {
    Object.defineProperty(v, "default", { enumerable: !0, value: S });
  } : function(v, S) {
    v.default = S;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var S = {};
    if (v != null)
      for (var $ in v)
        $ !== "default" && Object.prototype.hasOwnProperty.call(v, $) && n(S, v, $);
    return o(S, v), S;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ibc = void 0;
  const c = u(coin$6), d = u(client), m = u(googleProtobuf);
  (function(v) {
    (function(S) {
      (function($) {
        (function(E) {
          class O extends m.Message {
            constructor(V) {
              super(), m.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []), !Array.isArray(V) && typeof V == "object" && ("source_port" in V && V.source_port != null && (this.source_port = V.source_port), "source_channel" in V && V.source_channel != null && (this.source_channel = V.source_channel), "token" in V && V.token != null && (this.token = V.token), "sender" in V && V.sender != null && (this.sender = V.sender), "receiver" in V && V.receiver != null && (this.receiver = V.receiver), "timeout_height" in V && V.timeout_height != null && (this.timeout_height = V.timeout_height), "timeout_timestamp" in V && V.timeout_timestamp != null && (this.timeout_timestamp = V.timeout_timestamp));
            }
            get source_port() {
              return m.Message.getField(this, 1);
            }
            set source_port(V) {
              m.Message.setField(this, 1, V);
            }
            get source_channel() {
              return m.Message.getField(this, 2);
            }
            set source_channel(V) {
              m.Message.setField(this, 2, V);
            }
            get token() {
              return m.Message.getWrapperField(this, c.cosmos.base.v1beta1.Coin, 3);
            }
            set token(V) {
              m.Message.setWrapperField(this, 3, V);
            }
            get sender() {
              return m.Message.getField(this, 4);
            }
            set sender(V) {
              m.Message.setField(this, 4, V);
            }
            get receiver() {
              return m.Message.getField(this, 5);
            }
            set receiver(V) {
              m.Message.setField(this, 5, V);
            }
            get timeout_height() {
              return m.Message.getWrapperField(this, d.ibc.core.client.v1.Height, 6);
            }
            set timeout_height(V) {
              m.Message.setWrapperField(this, 6, V);
            }
            get timeout_timestamp() {
              return m.Message.getField(this, 7);
            }
            set timeout_timestamp(V) {
              m.Message.setField(this, 7, V);
            }
            static fromObject(V) {
              const M = new O({});
              return V.source_port != null && (M.source_port = V.source_port), V.source_channel != null && (M.source_channel = V.source_channel), V.token != null && (M.token = c.cosmos.base.v1beta1.Coin.fromObject(V.token)), V.sender != null && (M.sender = V.sender), V.receiver != null && (M.receiver = V.receiver), V.timeout_height != null && (M.timeout_height = d.ibc.core.client.v1.Height.fromObject(V.timeout_height)), V.timeout_timestamp != null && (M.timeout_timestamp = V.timeout_timestamp), M;
            }
            toObject() {
              const V = {};
              return this.source_port != null && (V.source_port = this.source_port), this.source_channel != null && (V.source_channel = this.source_channel), this.token != null && (V.token = this.token.toObject()), this.sender != null && (V.sender = this.sender), this.receiver != null && (V.receiver = this.receiver), this.timeout_height != null && (V.timeout_height = this.timeout_height.toObject()), this.timeout_timestamp != null && (V.timeout_timestamp = this.timeout_timestamp), V;
            }
            serialize(V) {
              const M = V || new m.BinaryWriter();
              if (typeof this.source_port == "string" && this.source_port.length && M.writeString(1, this.source_port), typeof this.source_channel == "string" && this.source_channel.length && M.writeString(2, this.source_channel), this.token !== void 0 && M.writeMessage(3, this.token, () => this.token.serialize(M)), typeof this.sender == "string" && this.sender.length && M.writeString(4, this.sender), typeof this.receiver == "string" && this.receiver.length && M.writeString(5, this.receiver), this.timeout_height !== void 0 && M.writeMessage(6, this.timeout_height, () => this.timeout_height.serialize(M)), this.timeout_timestamp !== void 0 && M.writeUint64(7, this.timeout_timestamp), !V)
                return M.getResultBuffer();
            }
            static deserialize(V) {
              const M = V instanceof m.BinaryReader ? V : new m.BinaryReader(V), G = new O();
              for (; M.nextField() && !M.isEndGroup(); )
                switch (M.getFieldNumber()) {
                  case 1:
                    G.source_port = M.readString();
                    break;
                  case 2:
                    G.source_channel = M.readString();
                    break;
                  case 3:
                    M.readMessage(G.token, () => G.token = c.cosmos.base.v1beta1.Coin.deserialize(M));
                    break;
                  case 4:
                    G.sender = M.readString();
                    break;
                  case 5:
                    G.receiver = M.readString();
                    break;
                  case 6:
                    M.readMessage(G.timeout_height, () => G.timeout_height = d.ibc.core.client.v1.Height.deserialize(M));
                    break;
                  case 7:
                    G.timeout_timestamp = M.readUint64();
                    break;
                  default:
                    M.skipField();
                }
              return G;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(V) {
              return O.deserialize(V);
            }
          }
          E.MsgTransfer = O;
          class T extends m.Message {
            constructor(V) {
              super(), m.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []);
            }
            static fromObject(V) {
              return new T({});
            }
            toObject() {
              return {};
            }
            serialize(V) {
              const M = V || new m.BinaryWriter();
              if (!V)
                return M.getResultBuffer();
            }
            static deserialize(V) {
              const M = V instanceof m.BinaryReader ? V : new m.BinaryReader(V), G = new T();
              for (; M.nextField() && !M.isEndGroup(); )
                switch (M.getFieldNumber()) {
                  default:
                    M.skipField();
                }
              return G;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(V) {
              return T.deserialize(V);
            }
          }
          E.MsgTransferResponse = T;
        })($.v1 || ($.v1 = {}));
      })(S.transfer || (S.transfer = {}));
    })(v.applications || (v.applications = {}));
  })(e.ibc || (e.ibc = {}));
})(tx$7);
var __createBinding$c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$c = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$c = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$c(n, e, o);
  return __setModuleDefault$c(n, e), n;
};
Object.defineProperty(ibcMsgTransfer$2, "__esModule", { value: !0 });
ibcMsgTransfer$2.createIBCMsgTransfer = void 0;
const coin$3 = __importStar$c(coin$6), ibcMsg = __importStar$c(tx$7), ibcCore = __importStar$c(client);
function createIBCMsgTransfer$1(e, n, o, u, c, d, m, v, S) {
  const $ = new coin$3.cosmos.base.v1beta1.Coin({
    denom: u,
    amount: o
  }), E = new ibcCore.ibc.core.client.v1.Height({
    revision_number: m,
    revision_height: v
  });
  return {
    message: new ibcMsg.ibc.applications.transfer.v1.MsgTransfer({
      source_port: e,
      source_channel: n,
      token: $,
      sender: c,
      receiver: d,
      timeout_height: E,
      timeout_timestamp: parseInt(S, 10)
    }),
    path: "ibc.applications.transfer.v1.MsgTransfer"
  };
}
ibcMsgTransfer$2.createIBCMsgTransfer = createIBCMsgTransfer$1;
var msgEthereumTx = {}, tx$6 = {}, evm = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ethermint = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      (function(v) {
        class S extends c.Message {
          constructor(k) {
            super(), c.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [4], []), !Array.isArray(k) && typeof k == "object" && ("evm_denom" in k && k.evm_denom != null && (this.evm_denom = k.evm_denom), "enable_create" in k && k.enable_create != null && (this.enable_create = k.enable_create), "enable_call" in k && k.enable_call != null && (this.enable_call = k.enable_call), "extra_eips" in k && k.extra_eips != null && (this.extra_eips = k.extra_eips), "chain_config" in k && k.chain_config != null && (this.chain_config = k.chain_config), "allow_unprotected_txs" in k && k.allow_unprotected_txs != null && (this.allow_unprotected_txs = k.allow_unprotected_txs));
          }
          get evm_denom() {
            return c.Message.getField(this, 1);
          }
          set evm_denom(k) {
            c.Message.setField(this, 1, k);
          }
          get enable_create() {
            return c.Message.getField(this, 2);
          }
          set enable_create(k) {
            c.Message.setField(this, 2, k);
          }
          get enable_call() {
            return c.Message.getField(this, 3);
          }
          set enable_call(k) {
            c.Message.setField(this, 3, k);
          }
          get extra_eips() {
            return c.Message.getField(this, 4);
          }
          set extra_eips(k) {
            c.Message.setField(this, 4, k);
          }
          get chain_config() {
            return c.Message.getWrapperField(this, $, 5);
          }
          set chain_config(k) {
            c.Message.setWrapperField(this, 5, k);
          }
          get allow_unprotected_txs() {
            return c.Message.getField(this, 6);
          }
          set allow_unprotected_txs(k) {
            c.Message.setField(this, 6, k);
          }
          static fromObject(k) {
            const F = new S({});
            return k.evm_denom != null && (F.evm_denom = k.evm_denom), k.enable_create != null && (F.enable_create = k.enable_create), k.enable_call != null && (F.enable_call = k.enable_call), k.extra_eips != null && (F.extra_eips = k.extra_eips), k.chain_config != null && (F.chain_config = $.fromObject(k.chain_config)), k.allow_unprotected_txs != null && (F.allow_unprotected_txs = k.allow_unprotected_txs), F;
          }
          toObject() {
            const k = {};
            return this.evm_denom != null && (k.evm_denom = this.evm_denom), this.enable_create != null && (k.enable_create = this.enable_create), this.enable_call != null && (k.enable_call = this.enable_call), this.extra_eips != null && (k.extra_eips = this.extra_eips), this.chain_config != null && (k.chain_config = this.chain_config.toObject()), this.allow_unprotected_txs != null && (k.allow_unprotected_txs = this.allow_unprotected_txs), k;
          }
          serialize(k) {
            const F = k || new c.BinaryWriter();
            if (typeof this.evm_denom == "string" && this.evm_denom.length && F.writeString(1, this.evm_denom), this.enable_create !== void 0 && F.writeBool(2, this.enable_create), this.enable_call !== void 0 && F.writeBool(3, this.enable_call), this.extra_eips !== void 0 && F.writePackedInt64(4, this.extra_eips), this.chain_config !== void 0 && F.writeMessage(5, this.chain_config, () => this.chain_config.serialize(F)), this.allow_unprotected_txs !== void 0 && F.writeBool(6, this.allow_unprotected_txs), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof c.BinaryReader ? k : new c.BinaryReader(k), X = new S();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.evm_denom = F.readString();
                  break;
                case 2:
                  X.enable_create = F.readBool();
                  break;
                case 3:
                  X.enable_call = F.readBool();
                  break;
                case 4:
                  X.extra_eips = F.readPackedInt64();
                  break;
                case 5:
                  F.readMessage(X.chain_config, () => X.chain_config = $.deserialize(F));
                  break;
                case 6:
                  X.allow_unprotected_txs = F.readBool();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return S.deserialize(k);
          }
        }
        v.Params = S;
        class $ extends c.Message {
          constructor(k) {
            super(), c.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("homestead_block" in k && k.homestead_block != null && (this.homestead_block = k.homestead_block), "dao_fork_block" in k && k.dao_fork_block != null && (this.dao_fork_block = k.dao_fork_block), "dao_fork_support" in k && k.dao_fork_support != null && (this.dao_fork_support = k.dao_fork_support), "eip150_block" in k && k.eip150_block != null && (this.eip150_block = k.eip150_block), "eip150_hash" in k && k.eip150_hash != null && (this.eip150_hash = k.eip150_hash), "eip155_block" in k && k.eip155_block != null && (this.eip155_block = k.eip155_block), "eip158_block" in k && k.eip158_block != null && (this.eip158_block = k.eip158_block), "byzantium_block" in k && k.byzantium_block != null && (this.byzantium_block = k.byzantium_block), "constantinople_block" in k && k.constantinople_block != null && (this.constantinople_block = k.constantinople_block), "petersburg_block" in k && k.petersburg_block != null && (this.petersburg_block = k.petersburg_block), "istanbul_block" in k && k.istanbul_block != null && (this.istanbul_block = k.istanbul_block), "muir_glacier_block" in k && k.muir_glacier_block != null && (this.muir_glacier_block = k.muir_glacier_block), "berlin_block" in k && k.berlin_block != null && (this.berlin_block = k.berlin_block), "london_block" in k && k.london_block != null && (this.london_block = k.london_block), "arrow_glacier_block" in k && k.arrow_glacier_block != null && (this.arrow_glacier_block = k.arrow_glacier_block), "merge_fork_block" in k && k.merge_fork_block != null && (this.merge_fork_block = k.merge_fork_block));
          }
          get homestead_block() {
            return c.Message.getField(this, 1);
          }
          set homestead_block(k) {
            c.Message.setField(this, 1, k);
          }
          get dao_fork_block() {
            return c.Message.getField(this, 2);
          }
          set dao_fork_block(k) {
            c.Message.setField(this, 2, k);
          }
          get dao_fork_support() {
            return c.Message.getField(this, 3);
          }
          set dao_fork_support(k) {
            c.Message.setField(this, 3, k);
          }
          get eip150_block() {
            return c.Message.getField(this, 4);
          }
          set eip150_block(k) {
            c.Message.setField(this, 4, k);
          }
          get eip150_hash() {
            return c.Message.getField(this, 5);
          }
          set eip150_hash(k) {
            c.Message.setField(this, 5, k);
          }
          get eip155_block() {
            return c.Message.getField(this, 6);
          }
          set eip155_block(k) {
            c.Message.setField(this, 6, k);
          }
          get eip158_block() {
            return c.Message.getField(this, 7);
          }
          set eip158_block(k) {
            c.Message.setField(this, 7, k);
          }
          get byzantium_block() {
            return c.Message.getField(this, 8);
          }
          set byzantium_block(k) {
            c.Message.setField(this, 8, k);
          }
          get constantinople_block() {
            return c.Message.getField(this, 9);
          }
          set constantinople_block(k) {
            c.Message.setField(this, 9, k);
          }
          get petersburg_block() {
            return c.Message.getField(this, 10);
          }
          set petersburg_block(k) {
            c.Message.setField(this, 10, k);
          }
          get istanbul_block() {
            return c.Message.getField(this, 11);
          }
          set istanbul_block(k) {
            c.Message.setField(this, 11, k);
          }
          get muir_glacier_block() {
            return c.Message.getField(this, 12);
          }
          set muir_glacier_block(k) {
            c.Message.setField(this, 12, k);
          }
          get berlin_block() {
            return c.Message.getField(this, 13);
          }
          set berlin_block(k) {
            c.Message.setField(this, 13, k);
          }
          get london_block() {
            return c.Message.getField(this, 17);
          }
          set london_block(k) {
            c.Message.setField(this, 17, k);
          }
          get arrow_glacier_block() {
            return c.Message.getField(this, 18);
          }
          set arrow_glacier_block(k) {
            c.Message.setField(this, 18, k);
          }
          get merge_fork_block() {
            return c.Message.getField(this, 19);
          }
          set merge_fork_block(k) {
            c.Message.setField(this, 19, k);
          }
          static fromObject(k) {
            const F = new $({});
            return k.homestead_block != null && (F.homestead_block = k.homestead_block), k.dao_fork_block != null && (F.dao_fork_block = k.dao_fork_block), k.dao_fork_support != null && (F.dao_fork_support = k.dao_fork_support), k.eip150_block != null && (F.eip150_block = k.eip150_block), k.eip150_hash != null && (F.eip150_hash = k.eip150_hash), k.eip155_block != null && (F.eip155_block = k.eip155_block), k.eip158_block != null && (F.eip158_block = k.eip158_block), k.byzantium_block != null && (F.byzantium_block = k.byzantium_block), k.constantinople_block != null && (F.constantinople_block = k.constantinople_block), k.petersburg_block != null && (F.petersburg_block = k.petersburg_block), k.istanbul_block != null && (F.istanbul_block = k.istanbul_block), k.muir_glacier_block != null && (F.muir_glacier_block = k.muir_glacier_block), k.berlin_block != null && (F.berlin_block = k.berlin_block), k.london_block != null && (F.london_block = k.london_block), k.arrow_glacier_block != null && (F.arrow_glacier_block = k.arrow_glacier_block), k.merge_fork_block != null && (F.merge_fork_block = k.merge_fork_block), F;
          }
          toObject() {
            const k = {};
            return this.homestead_block != null && (k.homestead_block = this.homestead_block), this.dao_fork_block != null && (k.dao_fork_block = this.dao_fork_block), this.dao_fork_support != null && (k.dao_fork_support = this.dao_fork_support), this.eip150_block != null && (k.eip150_block = this.eip150_block), this.eip150_hash != null && (k.eip150_hash = this.eip150_hash), this.eip155_block != null && (k.eip155_block = this.eip155_block), this.eip158_block != null && (k.eip158_block = this.eip158_block), this.byzantium_block != null && (k.byzantium_block = this.byzantium_block), this.constantinople_block != null && (k.constantinople_block = this.constantinople_block), this.petersburg_block != null && (k.petersburg_block = this.petersburg_block), this.istanbul_block != null && (k.istanbul_block = this.istanbul_block), this.muir_glacier_block != null && (k.muir_glacier_block = this.muir_glacier_block), this.berlin_block != null && (k.berlin_block = this.berlin_block), this.london_block != null && (k.london_block = this.london_block), this.arrow_glacier_block != null && (k.arrow_glacier_block = this.arrow_glacier_block), this.merge_fork_block != null && (k.merge_fork_block = this.merge_fork_block), k;
          }
          serialize(k) {
            const F = k || new c.BinaryWriter();
            if (typeof this.homestead_block == "string" && this.homestead_block.length && F.writeString(1, this.homestead_block), typeof this.dao_fork_block == "string" && this.dao_fork_block.length && F.writeString(2, this.dao_fork_block), this.dao_fork_support !== void 0 && F.writeBool(3, this.dao_fork_support), typeof this.eip150_block == "string" && this.eip150_block.length && F.writeString(4, this.eip150_block), typeof this.eip150_hash == "string" && this.eip150_hash.length && F.writeString(5, this.eip150_hash), typeof this.eip155_block == "string" && this.eip155_block.length && F.writeString(6, this.eip155_block), typeof this.eip158_block == "string" && this.eip158_block.length && F.writeString(7, this.eip158_block), typeof this.byzantium_block == "string" && this.byzantium_block.length && F.writeString(8, this.byzantium_block), typeof this.constantinople_block == "string" && this.constantinople_block.length && F.writeString(9, this.constantinople_block), typeof this.petersburg_block == "string" && this.petersburg_block.length && F.writeString(10, this.petersburg_block), typeof this.istanbul_block == "string" && this.istanbul_block.length && F.writeString(11, this.istanbul_block), typeof this.muir_glacier_block == "string" && this.muir_glacier_block.length && F.writeString(12, this.muir_glacier_block), typeof this.berlin_block == "string" && this.berlin_block.length && F.writeString(13, this.berlin_block), typeof this.london_block == "string" && this.london_block.length && F.writeString(17, this.london_block), typeof this.arrow_glacier_block == "string" && this.arrow_glacier_block.length && F.writeString(18, this.arrow_glacier_block), typeof this.merge_fork_block == "string" && this.merge_fork_block.length && F.writeString(19, this.merge_fork_block), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof c.BinaryReader ? k : new c.BinaryReader(k), X = new $();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.homestead_block = F.readString();
                  break;
                case 2:
                  X.dao_fork_block = F.readString();
                  break;
                case 3:
                  X.dao_fork_support = F.readBool();
                  break;
                case 4:
                  X.eip150_block = F.readString();
                  break;
                case 5:
                  X.eip150_hash = F.readString();
                  break;
                case 6:
                  X.eip155_block = F.readString();
                  break;
                case 7:
                  X.eip158_block = F.readString();
                  break;
                case 8:
                  X.byzantium_block = F.readString();
                  break;
                case 9:
                  X.constantinople_block = F.readString();
                  break;
                case 10:
                  X.petersburg_block = F.readString();
                  break;
                case 11:
                  X.istanbul_block = F.readString();
                  break;
                case 12:
                  X.muir_glacier_block = F.readString();
                  break;
                case 13:
                  X.berlin_block = F.readString();
                  break;
                case 17:
                  X.london_block = F.readString();
                  break;
                case 18:
                  X.arrow_glacier_block = F.readString();
                  break;
                case 19:
                  X.merge_fork_block = F.readString();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return $.deserialize(k);
          }
        }
        v.ChainConfig = $;
        class E extends c.Message {
          constructor(k) {
            super(), c.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("key" in k && k.key != null && (this.key = k.key), "value" in k && k.value != null && (this.value = k.value));
          }
          get key() {
            return c.Message.getField(this, 1);
          }
          set key(k) {
            c.Message.setField(this, 1, k);
          }
          get value() {
            return c.Message.getField(this, 2);
          }
          set value(k) {
            c.Message.setField(this, 2, k);
          }
          static fromObject(k) {
            const F = new E({});
            return k.key != null && (F.key = k.key), k.value != null && (F.value = k.value), F;
          }
          toObject() {
            const k = {};
            return this.key != null && (k.key = this.key), this.value != null && (k.value = this.value), k;
          }
          serialize(k) {
            const F = k || new c.BinaryWriter();
            if (typeof this.key == "string" && this.key.length && F.writeString(1, this.key), typeof this.value == "string" && this.value.length && F.writeString(2, this.value), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof c.BinaryReader ? k : new c.BinaryReader(k), X = new E();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.key = F.readString();
                  break;
                case 2:
                  X.value = F.readString();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return E.deserialize(k);
          }
        }
        v.State = E;
        class O extends c.Message {
          constructor(k) {
            super(), c.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [2], []), !Array.isArray(k) && typeof k == "object" && ("hash" in k && k.hash != null && (this.hash = k.hash), "logs" in k && k.logs != null && (this.logs = k.logs));
          }
          get hash() {
            return c.Message.getField(this, 1);
          }
          set hash(k) {
            c.Message.setField(this, 1, k);
          }
          get logs() {
            return c.Message.getRepeatedWrapperField(this, T, 2);
          }
          set logs(k) {
            c.Message.setRepeatedWrapperField(this, 2, k);
          }
          static fromObject(k) {
            const F = new O({});
            return k.hash != null && (F.hash = k.hash), k.logs != null && (F.logs = k.logs.map((X) => T.fromObject(X))), F;
          }
          toObject() {
            const k = {};
            return this.hash != null && (k.hash = this.hash), this.logs != null && (k.logs = this.logs.map((F) => F.toObject())), k;
          }
          serialize(k) {
            const F = k || new c.BinaryWriter();
            if (typeof this.hash == "string" && this.hash.length && F.writeString(1, this.hash), this.logs !== void 0 && F.writeRepeatedMessage(2, this.logs, (X) => X.serialize(F)), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof c.BinaryReader ? k : new c.BinaryReader(k), X = new O();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.hash = F.readString();
                  break;
                case 2:
                  F.readMessage(X.logs, () => c.Message.addToRepeatedWrapperField(X, 2, T.deserialize(F), T));
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return O.deserialize(k);
          }
        }
        v.TransactionLogs = O;
        class T extends c.Message {
          constructor(k) {
            super(), c.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [2], []), !Array.isArray(k) && typeof k == "object" && ("address" in k && k.address != null && (this.address = k.address), "topics" in k && k.topics != null && (this.topics = k.topics), "data" in k && k.data != null && (this.data = k.data), "block_number" in k && k.block_number != null && (this.block_number = k.block_number), "tx_hash" in k && k.tx_hash != null && (this.tx_hash = k.tx_hash), "tx_index" in k && k.tx_index != null && (this.tx_index = k.tx_index), "block_hash" in k && k.block_hash != null && (this.block_hash = k.block_hash), "index" in k && k.index != null && (this.index = k.index), "removed" in k && k.removed != null && (this.removed = k.removed));
          }
          get address() {
            return c.Message.getField(this, 1);
          }
          set address(k) {
            c.Message.setField(this, 1, k);
          }
          get topics() {
            return c.Message.getField(this, 2);
          }
          set topics(k) {
            c.Message.setField(this, 2, k);
          }
          get data() {
            return c.Message.getField(this, 3);
          }
          set data(k) {
            c.Message.setField(this, 3, k);
          }
          get block_number() {
            return c.Message.getField(this, 4);
          }
          set block_number(k) {
            c.Message.setField(this, 4, k);
          }
          get tx_hash() {
            return c.Message.getField(this, 5);
          }
          set tx_hash(k) {
            c.Message.setField(this, 5, k);
          }
          get tx_index() {
            return c.Message.getField(this, 6);
          }
          set tx_index(k) {
            c.Message.setField(this, 6, k);
          }
          get block_hash() {
            return c.Message.getField(this, 7);
          }
          set block_hash(k) {
            c.Message.setField(this, 7, k);
          }
          get index() {
            return c.Message.getField(this, 8);
          }
          set index(k) {
            c.Message.setField(this, 8, k);
          }
          get removed() {
            return c.Message.getField(this, 9);
          }
          set removed(k) {
            c.Message.setField(this, 9, k);
          }
          static fromObject(k) {
            const F = new T({});
            return k.address != null && (F.address = k.address), k.topics != null && (F.topics = k.topics), k.data != null && (F.data = k.data), k.block_number != null && (F.block_number = k.block_number), k.tx_hash != null && (F.tx_hash = k.tx_hash), k.tx_index != null && (F.tx_index = k.tx_index), k.block_hash != null && (F.block_hash = k.block_hash), k.index != null && (F.index = k.index), k.removed != null && (F.removed = k.removed), F;
          }
          toObject() {
            const k = {};
            return this.address != null && (k.address = this.address), this.topics != null && (k.topics = this.topics), this.data != null && (k.data = this.data), this.block_number != null && (k.block_number = this.block_number), this.tx_hash != null && (k.tx_hash = this.tx_hash), this.tx_index != null && (k.tx_index = this.tx_index), this.block_hash != null && (k.block_hash = this.block_hash), this.index != null && (k.index = this.index), this.removed != null && (k.removed = this.removed), k;
          }
          serialize(k) {
            const F = k || new c.BinaryWriter();
            if (typeof this.address == "string" && this.address.length && F.writeString(1, this.address), this.topics !== void 0 && F.writeRepeatedString(2, this.topics), this.data !== void 0 && F.writeBytes(3, this.data), this.block_number !== void 0 && F.writeUint64(4, this.block_number), typeof this.tx_hash == "string" && this.tx_hash.length && F.writeString(5, this.tx_hash), this.tx_index !== void 0 && F.writeUint64(6, this.tx_index), typeof this.block_hash == "string" && this.block_hash.length && F.writeString(7, this.block_hash), this.index !== void 0 && F.writeUint64(8, this.index), this.removed !== void 0 && F.writeBool(9, this.removed), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof c.BinaryReader ? k : new c.BinaryReader(k), X = new T();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.address = F.readString();
                  break;
                case 2:
                  c.Message.addToRepeatedField(X, 2, F.readString());
                  break;
                case 3:
                  X.data = F.readBytes();
                  break;
                case 4:
                  X.block_number = F.readUint64();
                  break;
                case 5:
                  X.tx_hash = F.readString();
                  break;
                case 6:
                  X.tx_index = F.readUint64();
                  break;
                case 7:
                  X.block_hash = F.readString();
                  break;
                case 8:
                  X.index = F.readUint64();
                  break;
                case 9:
                  X.removed = F.readBool();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return T.deserialize(k);
          }
        }
        v.Log = T;
        class y extends c.Message {
          constructor(k) {
            super(), c.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("contract_address" in k && k.contract_address != null && (this.contract_address = k.contract_address), "bloom" in k && k.bloom != null && (this.bloom = k.bloom), "tx_logs" in k && k.tx_logs != null && (this.tx_logs = k.tx_logs), "ret" in k && k.ret != null && (this.ret = k.ret), "reverted" in k && k.reverted != null && (this.reverted = k.reverted), "gas_used" in k && k.gas_used != null && (this.gas_used = k.gas_used));
          }
          get contract_address() {
            return c.Message.getField(this, 1);
          }
          set contract_address(k) {
            c.Message.setField(this, 1, k);
          }
          get bloom() {
            return c.Message.getField(this, 2);
          }
          set bloom(k) {
            c.Message.setField(this, 2, k);
          }
          get tx_logs() {
            return c.Message.getWrapperField(this, O, 3);
          }
          set tx_logs(k) {
            c.Message.setWrapperField(this, 3, k);
          }
          get ret() {
            return c.Message.getField(this, 4);
          }
          set ret(k) {
            c.Message.setField(this, 4, k);
          }
          get reverted() {
            return c.Message.getField(this, 5);
          }
          set reverted(k) {
            c.Message.setField(this, 5, k);
          }
          get gas_used() {
            return c.Message.getField(this, 6);
          }
          set gas_used(k) {
            c.Message.setField(this, 6, k);
          }
          static fromObject(k) {
            const F = new y({});
            return k.contract_address != null && (F.contract_address = k.contract_address), k.bloom != null && (F.bloom = k.bloom), k.tx_logs != null && (F.tx_logs = O.fromObject(k.tx_logs)), k.ret != null && (F.ret = k.ret), k.reverted != null && (F.reverted = k.reverted), k.gas_used != null && (F.gas_used = k.gas_used), F;
          }
          toObject() {
            const k = {};
            return this.contract_address != null && (k.contract_address = this.contract_address), this.bloom != null && (k.bloom = this.bloom), this.tx_logs != null && (k.tx_logs = this.tx_logs.toObject()), this.ret != null && (k.ret = this.ret), this.reverted != null && (k.reverted = this.reverted), this.gas_used != null && (k.gas_used = this.gas_used), k;
          }
          serialize(k) {
            const F = k || new c.BinaryWriter();
            if (typeof this.contract_address == "string" && this.contract_address.length && F.writeString(1, this.contract_address), this.bloom !== void 0 && F.writeBytes(2, this.bloom), this.tx_logs !== void 0 && F.writeMessage(3, this.tx_logs, () => this.tx_logs.serialize(F)), this.ret !== void 0 && F.writeBytes(4, this.ret), this.reverted !== void 0 && F.writeBool(5, this.reverted), this.gas_used !== void 0 && F.writeUint64(6, this.gas_used), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof c.BinaryReader ? k : new c.BinaryReader(k), X = new y();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.contract_address = F.readString();
                  break;
                case 2:
                  X.bloom = F.readBytes();
                  break;
                case 3:
                  F.readMessage(X.tx_logs, () => X.tx_logs = O.deserialize(F));
                  break;
                case 4:
                  X.ret = F.readBytes();
                  break;
                case 5:
                  X.reverted = F.readBool();
                  break;
                case 6:
                  X.gas_used = F.readUint64();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return y.deserialize(k);
          }
        }
        v.TxResult = y;
        class V extends c.Message {
          constructor(k) {
            super(), c.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [2], []), !Array.isArray(k) && typeof k == "object" && ("address" in k && k.address != null && (this.address = k.address), "storage_keys" in k && k.storage_keys != null && (this.storage_keys = k.storage_keys));
          }
          get address() {
            return c.Message.getField(this, 1);
          }
          set address(k) {
            c.Message.setField(this, 1, k);
          }
          get storage_keys() {
            return c.Message.getField(this, 2);
          }
          set storage_keys(k) {
            c.Message.setField(this, 2, k);
          }
          static fromObject(k) {
            const F = new V({});
            return k.address != null && (F.address = k.address), k.storage_keys != null && (F.storage_keys = k.storage_keys), F;
          }
          toObject() {
            const k = {};
            return this.address != null && (k.address = this.address), this.storage_keys != null && (k.storage_keys = this.storage_keys), k;
          }
          serialize(k) {
            const F = k || new c.BinaryWriter();
            if (typeof this.address == "string" && this.address.length && F.writeString(1, this.address), this.storage_keys !== void 0 && F.writeRepeatedString(2, this.storage_keys), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof c.BinaryReader ? k : new c.BinaryReader(k), X = new V();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.address = F.readString();
                  break;
                case 2:
                  c.Message.addToRepeatedField(X, 2, F.readString());
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return V.deserialize(k);
          }
        }
        v.AccessTuple = V;
        class M extends c.Message {
          constructor(k) {
            super(), c.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("tracer" in k && k.tracer != null && (this.tracer = k.tracer), "timeout" in k && k.timeout != null && (this.timeout = k.timeout), "reexec" in k && k.reexec != null && (this.reexec = k.reexec), "disable_stack" in k && k.disable_stack != null && (this.disable_stack = k.disable_stack), "disable_storage" in k && k.disable_storage != null && (this.disable_storage = k.disable_storage), "debug" in k && k.debug != null && (this.debug = k.debug), "limit" in k && k.limit != null && (this.limit = k.limit), "overrides" in k && k.overrides != null && (this.overrides = k.overrides), "enable_memory" in k && k.enable_memory != null && (this.enable_memory = k.enable_memory), "enable_return_data" in k && k.enable_return_data != null && (this.enable_return_data = k.enable_return_data));
          }
          get tracer() {
            return c.Message.getField(this, 1);
          }
          set tracer(k) {
            c.Message.setField(this, 1, k);
          }
          get timeout() {
            return c.Message.getField(this, 2);
          }
          set timeout(k) {
            c.Message.setField(this, 2, k);
          }
          get reexec() {
            return c.Message.getField(this, 3);
          }
          set reexec(k) {
            c.Message.setField(this, 3, k);
          }
          get disable_stack() {
            return c.Message.getField(this, 5);
          }
          set disable_stack(k) {
            c.Message.setField(this, 5, k);
          }
          get disable_storage() {
            return c.Message.getField(this, 6);
          }
          set disable_storage(k) {
            c.Message.setField(this, 6, k);
          }
          get debug() {
            return c.Message.getField(this, 8);
          }
          set debug(k) {
            c.Message.setField(this, 8, k);
          }
          get limit() {
            return c.Message.getField(this, 9);
          }
          set limit(k) {
            c.Message.setField(this, 9, k);
          }
          get overrides() {
            return c.Message.getWrapperField(this, $, 10);
          }
          set overrides(k) {
            c.Message.setWrapperField(this, 10, k);
          }
          get enable_memory() {
            return c.Message.getField(this, 11);
          }
          set enable_memory(k) {
            c.Message.setField(this, 11, k);
          }
          get enable_return_data() {
            return c.Message.getField(this, 12);
          }
          set enable_return_data(k) {
            c.Message.setField(this, 12, k);
          }
          static fromObject(k) {
            const F = new M({});
            return k.tracer != null && (F.tracer = k.tracer), k.timeout != null && (F.timeout = k.timeout), k.reexec != null && (F.reexec = k.reexec), k.disable_stack != null && (F.disable_stack = k.disable_stack), k.disable_storage != null && (F.disable_storage = k.disable_storage), k.debug != null && (F.debug = k.debug), k.limit != null && (F.limit = k.limit), k.overrides != null && (F.overrides = $.fromObject(k.overrides)), k.enable_memory != null && (F.enable_memory = k.enable_memory), k.enable_return_data != null && (F.enable_return_data = k.enable_return_data), F;
          }
          toObject() {
            const k = {};
            return this.tracer != null && (k.tracer = this.tracer), this.timeout != null && (k.timeout = this.timeout), this.reexec != null && (k.reexec = this.reexec), this.disable_stack != null && (k.disable_stack = this.disable_stack), this.disable_storage != null && (k.disable_storage = this.disable_storage), this.debug != null && (k.debug = this.debug), this.limit != null && (k.limit = this.limit), this.overrides != null && (k.overrides = this.overrides.toObject()), this.enable_memory != null && (k.enable_memory = this.enable_memory), this.enable_return_data != null && (k.enable_return_data = this.enable_return_data), k;
          }
          serialize(k) {
            const F = k || new c.BinaryWriter();
            if (typeof this.tracer == "string" && this.tracer.length && F.writeString(1, this.tracer), typeof this.timeout == "string" && this.timeout.length && F.writeString(2, this.timeout), this.reexec !== void 0 && F.writeUint64(3, this.reexec), this.disable_stack !== void 0 && F.writeBool(5, this.disable_stack), this.disable_storage !== void 0 && F.writeBool(6, this.disable_storage), this.debug !== void 0 && F.writeBool(8, this.debug), this.limit !== void 0 && F.writeInt32(9, this.limit), this.overrides !== void 0 && F.writeMessage(10, this.overrides, () => this.overrides.serialize(F)), this.enable_memory !== void 0 && F.writeBool(11, this.enable_memory), this.enable_return_data !== void 0 && F.writeBool(12, this.enable_return_data), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof c.BinaryReader ? k : new c.BinaryReader(k), X = new M();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.tracer = F.readString();
                  break;
                case 2:
                  X.timeout = F.readString();
                  break;
                case 3:
                  X.reexec = F.readUint64();
                  break;
                case 5:
                  X.disable_stack = F.readBool();
                  break;
                case 6:
                  X.disable_storage = F.readBool();
                  break;
                case 8:
                  X.debug = F.readBool();
                  break;
                case 9:
                  X.limit = F.readInt32();
                  break;
                case 10:
                  F.readMessage(X.overrides, () => X.overrides = $.deserialize(F));
                  break;
                case 11:
                  X.enable_memory = F.readBool();
                  break;
                case 12:
                  X.enable_return_data = F.readBool();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return M.deserialize(k);
          }
        }
        v.TraceConfig = M;
      })(m.v1 || (m.v1 = {}));
    })(d.evm || (d.evm = {}));
  })(e.ethermint || (e.ethermint = {}));
})(evm);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, S, $, E) {
    E === void 0 && (E = $);
    var O = Object.getOwnPropertyDescriptor(S, $);
    (!O || ("get" in O ? !S.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return S[$];
    } }), Object.defineProperty(v, E, O);
  } : function(v, S, $, E) {
    E === void 0 && (E = $), v[E] = S[$];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, S) {
    Object.defineProperty(v, "default", { enumerable: !0, value: S });
  } : function(v, S) {
    v.default = S;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var S = {};
    if (v != null)
      for (var $ in v)
        $ !== "default" && Object.prototype.hasOwnProperty.call(v, $) && n(S, v, $);
    return o(S, v), S;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ethermint = void 0;
  const c = u(any), d = u(evm), m = u(googleProtobuf);
  (function(v) {
    (function(S) {
      (function($) {
        class E extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("data" in k && k.data != null && (this.data = k.data), "size" in k && k.size != null && (this.size = k.size), "hash" in k && k.hash != null && (this.hash = k.hash), "from" in k && k.from != null && (this.from = k.from));
          }
          get data() {
            return m.Message.getWrapperField(this, c.google.protobuf.Any, 1);
          }
          set data(k) {
            m.Message.setWrapperField(this, 1, k);
          }
          get size() {
            return m.Message.getField(this, 2);
          }
          set size(k) {
            m.Message.setField(this, 2, k);
          }
          get hash() {
            return m.Message.getField(this, 3);
          }
          set hash(k) {
            m.Message.setField(this, 3, k);
          }
          get from() {
            return m.Message.getField(this, 4);
          }
          set from(k) {
            m.Message.setField(this, 4, k);
          }
          static fromObject(k) {
            const F = new E({});
            return k.data != null && (F.data = c.google.protobuf.Any.fromObject(k.data)), k.size != null && (F.size = k.size), k.hash != null && (F.hash = k.hash), k.from != null && (F.from = k.from), F;
          }
          toObject() {
            const k = {};
            return this.data != null && (k.data = this.data.toObject()), this.size != null && (k.size = this.size), this.hash != null && (k.hash = this.hash), this.from != null && (k.from = this.from), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (this.data !== void 0 && F.writeMessage(1, this.data, () => this.data.serialize(F)), this.size !== void 0 && F.writeDouble(2, this.size), typeof this.hash == "string" && this.hash.length && F.writeString(3, this.hash), typeof this.from == "string" && this.from.length && F.writeString(4, this.from), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new E();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  F.readMessage(X.data, () => X.data = c.google.protobuf.Any.deserialize(F));
                  break;
                case 2:
                  X.size = F.readDouble();
                  break;
                case 3:
                  X.hash = F.readString();
                  break;
                case 4:
                  X.from = F.readString();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return E.deserialize(k);
          }
        }
        $.MsgEthereumTx = E;
        class O extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("nonce" in k && k.nonce != null && (this.nonce = k.nonce), "gas_price" in k && k.gas_price != null && (this.gas_price = k.gas_price), "gas" in k && k.gas != null && (this.gas = k.gas), "to" in k && k.to != null && (this.to = k.to), "value" in k && k.value != null && (this.value = k.value), "data" in k && k.data != null && (this.data = k.data), "v" in k && k.v != null && (this.v = k.v), "r" in k && k.r != null && (this.r = k.r), "s" in k && k.s != null && (this.s = k.s));
          }
          get nonce() {
            return m.Message.getField(this, 1);
          }
          set nonce(k) {
            m.Message.setField(this, 1, k);
          }
          get gas_price() {
            return m.Message.getField(this, 2);
          }
          set gas_price(k) {
            m.Message.setField(this, 2, k);
          }
          get gas() {
            return m.Message.getField(this, 3);
          }
          set gas(k) {
            m.Message.setField(this, 3, k);
          }
          get to() {
            return m.Message.getField(this, 4);
          }
          set to(k) {
            m.Message.setField(this, 4, k);
          }
          get value() {
            return m.Message.getField(this, 5);
          }
          set value(k) {
            m.Message.setField(this, 5, k);
          }
          get data() {
            return m.Message.getField(this, 6);
          }
          set data(k) {
            m.Message.setField(this, 6, k);
          }
          get v() {
            return m.Message.getField(this, 7);
          }
          set v(k) {
            m.Message.setField(this, 7, k);
          }
          get r() {
            return m.Message.getField(this, 8);
          }
          set r(k) {
            m.Message.setField(this, 8, k);
          }
          get s() {
            return m.Message.getField(this, 9);
          }
          set s(k) {
            m.Message.setField(this, 9, k);
          }
          static fromObject(k) {
            const F = new O({});
            return k.nonce != null && (F.nonce = k.nonce), k.gas_price != null && (F.gas_price = k.gas_price), k.gas != null && (F.gas = k.gas), k.to != null && (F.to = k.to), k.value != null && (F.value = k.value), k.data != null && (F.data = k.data), k.v != null && (F.v = k.v), k.r != null && (F.r = k.r), k.s != null && (F.s = k.s), F;
          }
          toObject() {
            const k = {};
            return this.nonce != null && (k.nonce = this.nonce), this.gas_price != null && (k.gas_price = this.gas_price), this.gas != null && (k.gas = this.gas), this.to != null && (k.to = this.to), this.value != null && (k.value = this.value), this.data != null && (k.data = this.data), this.v != null && (k.v = this.v), this.r != null && (k.r = this.r), this.s != null && (k.s = this.s), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (this.nonce !== void 0 && F.writeUint64(1, this.nonce), typeof this.gas_price == "string" && this.gas_price.length && F.writeString(2, this.gas_price), this.gas !== void 0 && F.writeUint64(3, this.gas), typeof this.to == "string" && this.to.length && F.writeString(4, this.to), typeof this.value == "string" && this.value.length && F.writeString(5, this.value), this.data !== void 0 && F.writeBytes(6, this.data), this.v !== void 0 && F.writeBytes(7, this.v), this.r !== void 0 && F.writeBytes(8, this.r), this.s !== void 0 && F.writeBytes(9, this.s), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new O();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.nonce = F.readUint64();
                  break;
                case 2:
                  X.gas_price = F.readString();
                  break;
                case 3:
                  X.gas = F.readUint64();
                  break;
                case 4:
                  X.to = F.readString();
                  break;
                case 5:
                  X.value = F.readString();
                  break;
                case 6:
                  X.data = F.readBytes();
                  break;
                case 7:
                  X.v = F.readBytes();
                  break;
                case 8:
                  X.r = F.readBytes();
                  break;
                case 9:
                  X.s = F.readBytes();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return O.deserialize(k);
          }
        }
        $.LegacyTx = O;
        class T extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [8], []), !Array.isArray(k) && typeof k == "object" && ("chain_id" in k && k.chain_id != null && (this.chain_id = k.chain_id), "nonce" in k && k.nonce != null && (this.nonce = k.nonce), "gas_price" in k && k.gas_price != null && (this.gas_price = k.gas_price), "gas" in k && k.gas != null && (this.gas = k.gas), "to" in k && k.to != null && (this.to = k.to), "value" in k && k.value != null && (this.value = k.value), "data" in k && k.data != null && (this.data = k.data), "accesses" in k && k.accesses != null && (this.accesses = k.accesses), "v" in k && k.v != null && (this.v = k.v), "r" in k && k.r != null && (this.r = k.r), "s" in k && k.s != null && (this.s = k.s));
          }
          get chain_id() {
            return m.Message.getField(this, 1);
          }
          set chain_id(k) {
            m.Message.setField(this, 1, k);
          }
          get nonce() {
            return m.Message.getField(this, 2);
          }
          set nonce(k) {
            m.Message.setField(this, 2, k);
          }
          get gas_price() {
            return m.Message.getField(this, 3);
          }
          set gas_price(k) {
            m.Message.setField(this, 3, k);
          }
          get gas() {
            return m.Message.getField(this, 4);
          }
          set gas(k) {
            m.Message.setField(this, 4, k);
          }
          get to() {
            return m.Message.getField(this, 5);
          }
          set to(k) {
            m.Message.setField(this, 5, k);
          }
          get value() {
            return m.Message.getField(this, 6);
          }
          set value(k) {
            m.Message.setField(this, 6, k);
          }
          get data() {
            return m.Message.getField(this, 7);
          }
          set data(k) {
            m.Message.setField(this, 7, k);
          }
          get accesses() {
            return m.Message.getRepeatedWrapperField(this, d.ethermint.evm.v1.AccessTuple, 8);
          }
          set accesses(k) {
            m.Message.setRepeatedWrapperField(this, 8, k);
          }
          get v() {
            return m.Message.getField(this, 9);
          }
          set v(k) {
            m.Message.setField(this, 9, k);
          }
          get r() {
            return m.Message.getField(this, 10);
          }
          set r(k) {
            m.Message.setField(this, 10, k);
          }
          get s() {
            return m.Message.getField(this, 11);
          }
          set s(k) {
            m.Message.setField(this, 11, k);
          }
          static fromObject(k) {
            const F = new T({});
            return k.chain_id != null && (F.chain_id = k.chain_id), k.nonce != null && (F.nonce = k.nonce), k.gas_price != null && (F.gas_price = k.gas_price), k.gas != null && (F.gas = k.gas), k.to != null && (F.to = k.to), k.value != null && (F.value = k.value), k.data != null && (F.data = k.data), k.accesses != null && (F.accesses = k.accesses.map((X) => d.ethermint.evm.v1.AccessTuple.fromObject(X))), k.v != null && (F.v = k.v), k.r != null && (F.r = k.r), k.s != null && (F.s = k.s), F;
          }
          toObject() {
            const k = {};
            return this.chain_id != null && (k.chain_id = this.chain_id), this.nonce != null && (k.nonce = this.nonce), this.gas_price != null && (k.gas_price = this.gas_price), this.gas != null && (k.gas = this.gas), this.to != null && (k.to = this.to), this.value != null && (k.value = this.value), this.data != null && (k.data = this.data), this.accesses != null && (k.accesses = this.accesses.map((F) => F.toObject())), this.v != null && (k.v = this.v), this.r != null && (k.r = this.r), this.s != null && (k.s = this.s), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (typeof this.chain_id == "string" && this.chain_id.length && F.writeString(1, this.chain_id), this.nonce !== void 0 && F.writeUint64(2, this.nonce), typeof this.gas_price == "string" && this.gas_price.length && F.writeString(3, this.gas_price), this.gas !== void 0 && F.writeUint64(4, this.gas), typeof this.to == "string" && this.to.length && F.writeString(5, this.to), typeof this.value == "string" && this.value.length && F.writeString(6, this.value), this.data !== void 0 && F.writeBytes(7, this.data), this.accesses !== void 0 && F.writeRepeatedMessage(8, this.accesses, (X) => X.serialize(F)), this.v !== void 0 && F.writeBytes(9, this.v), this.r !== void 0 && F.writeBytes(10, this.r), this.s !== void 0 && F.writeBytes(11, this.s), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new T();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.chain_id = F.readString();
                  break;
                case 2:
                  X.nonce = F.readUint64();
                  break;
                case 3:
                  X.gas_price = F.readString();
                  break;
                case 4:
                  X.gas = F.readUint64();
                  break;
                case 5:
                  X.to = F.readString();
                  break;
                case 6:
                  X.value = F.readString();
                  break;
                case 7:
                  X.data = F.readBytes();
                  break;
                case 8:
                  F.readMessage(X.accesses, () => m.Message.addToRepeatedWrapperField(X, 8, d.ethermint.evm.v1.AccessTuple.deserialize(F), d.ethermint.evm.v1.AccessTuple));
                  break;
                case 9:
                  X.v = F.readBytes();
                  break;
                case 10:
                  X.r = F.readBytes();
                  break;
                case 11:
                  X.s = F.readBytes();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return T.deserialize(k);
          }
        }
        $.AccessListTx = T;
        class y extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [9], []), !Array.isArray(k) && typeof k == "object" && ("chain_id" in k && k.chain_id != null && (this.chain_id = k.chain_id), "nonce" in k && k.nonce != null && (this.nonce = k.nonce), "gas_tip_cap" in k && k.gas_tip_cap != null && (this.gas_tip_cap = k.gas_tip_cap), "gas_fee_cap" in k && k.gas_fee_cap != null && (this.gas_fee_cap = k.gas_fee_cap), "gas" in k && k.gas != null && (this.gas = k.gas), "to" in k && k.to != null && (this.to = k.to), "value" in k && k.value != null && (this.value = k.value), "data" in k && k.data != null && (this.data = k.data), "accesses" in k && k.accesses != null && (this.accesses = k.accesses), "v" in k && k.v != null && (this.v = k.v), "r" in k && k.r != null && (this.r = k.r), "s" in k && k.s != null && (this.s = k.s));
          }
          get chain_id() {
            return m.Message.getField(this, 1);
          }
          set chain_id(k) {
            m.Message.setField(this, 1, k);
          }
          get nonce() {
            return m.Message.getField(this, 2);
          }
          set nonce(k) {
            m.Message.setField(this, 2, k);
          }
          get gas_tip_cap() {
            return m.Message.getField(this, 3);
          }
          set gas_tip_cap(k) {
            m.Message.setField(this, 3, k);
          }
          get gas_fee_cap() {
            return m.Message.getField(this, 4);
          }
          set gas_fee_cap(k) {
            m.Message.setField(this, 4, k);
          }
          get gas() {
            return m.Message.getField(this, 5);
          }
          set gas(k) {
            m.Message.setField(this, 5, k);
          }
          get to() {
            return m.Message.getField(this, 6);
          }
          set to(k) {
            m.Message.setField(this, 6, k);
          }
          get value() {
            return m.Message.getField(this, 7);
          }
          set value(k) {
            m.Message.setField(this, 7, k);
          }
          get data() {
            return m.Message.getField(this, 8);
          }
          set data(k) {
            m.Message.setField(this, 8, k);
          }
          get accesses() {
            return m.Message.getRepeatedWrapperField(this, d.ethermint.evm.v1.AccessTuple, 9);
          }
          set accesses(k) {
            m.Message.setRepeatedWrapperField(this, 9, k);
          }
          get v() {
            return m.Message.getField(this, 10);
          }
          set v(k) {
            m.Message.setField(this, 10, k);
          }
          get r() {
            return m.Message.getField(this, 11);
          }
          set r(k) {
            m.Message.setField(this, 11, k);
          }
          get s() {
            return m.Message.getField(this, 12);
          }
          set s(k) {
            m.Message.setField(this, 12, k);
          }
          static fromObject(k) {
            const F = new y({});
            return k.chain_id != null && (F.chain_id = k.chain_id), k.nonce != null && (F.nonce = k.nonce), k.gas_tip_cap != null && (F.gas_tip_cap = k.gas_tip_cap), k.gas_fee_cap != null && (F.gas_fee_cap = k.gas_fee_cap), k.gas != null && (F.gas = k.gas), k.to != null && (F.to = k.to), k.value != null && (F.value = k.value), k.data != null && (F.data = k.data), k.accesses != null && (F.accesses = k.accesses.map((X) => d.ethermint.evm.v1.AccessTuple.fromObject(X))), k.v != null && (F.v = k.v), k.r != null && (F.r = k.r), k.s != null && (F.s = k.s), F;
          }
          toObject() {
            const k = {};
            return this.chain_id != null && (k.chain_id = this.chain_id), this.nonce != null && (k.nonce = this.nonce), this.gas_tip_cap != null && (k.gas_tip_cap = this.gas_tip_cap), this.gas_fee_cap != null && (k.gas_fee_cap = this.gas_fee_cap), this.gas != null && (k.gas = this.gas), this.to != null && (k.to = this.to), this.value != null && (k.value = this.value), this.data != null && (k.data = this.data), this.accesses != null && (k.accesses = this.accesses.map((F) => F.toObject())), this.v != null && (k.v = this.v), this.r != null && (k.r = this.r), this.s != null && (k.s = this.s), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (typeof this.chain_id == "string" && this.chain_id.length && F.writeString(1, this.chain_id), this.nonce !== void 0 && F.writeUint64(2, this.nonce), typeof this.gas_tip_cap == "string" && this.gas_tip_cap.length && F.writeString(3, this.gas_tip_cap), typeof this.gas_fee_cap == "string" && this.gas_fee_cap.length && F.writeString(4, this.gas_fee_cap), this.gas !== void 0 && F.writeUint64(5, this.gas), typeof this.to == "string" && this.to.length && F.writeString(6, this.to), typeof this.value == "string" && this.value.length && F.writeString(7, this.value), this.data !== void 0 && F.writeBytes(8, this.data), this.accesses !== void 0 && F.writeRepeatedMessage(9, this.accesses, (X) => X.serialize(F)), this.v !== void 0 && F.writeBytes(10, this.v), this.r !== void 0 && F.writeBytes(11, this.r), this.s !== void 0 && F.writeBytes(12, this.s), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new y();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.chain_id = F.readString();
                  break;
                case 2:
                  X.nonce = F.readUint64();
                  break;
                case 3:
                  X.gas_tip_cap = F.readString();
                  break;
                case 4:
                  X.gas_fee_cap = F.readString();
                  break;
                case 5:
                  X.gas = F.readUint64();
                  break;
                case 6:
                  X.to = F.readString();
                  break;
                case 7:
                  X.value = F.readString();
                  break;
                case 8:
                  X.data = F.readBytes();
                  break;
                case 9:
                  F.readMessage(X.accesses, () => m.Message.addToRepeatedWrapperField(X, 9, d.ethermint.evm.v1.AccessTuple.deserialize(F), d.ethermint.evm.v1.AccessTuple));
                  break;
                case 10:
                  X.v = F.readBytes();
                  break;
                case 11:
                  X.r = F.readBytes();
                  break;
                case 12:
                  X.s = F.readBytes();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return y.deserialize(k);
          }
        }
        $.DynamicFeeTx = y;
        class V extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []);
          }
          static fromObject(k) {
            return new V({});
          }
          toObject() {
            return {};
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (!k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new V();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return V.deserialize(k);
          }
        }
        $.ExtensionOptionsEthereumTx = V;
        class M extends m.Message {
          constructor(k) {
            super(), m.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [2], []), !Array.isArray(k) && typeof k == "object" && ("hash" in k && k.hash != null && (this.hash = k.hash), "logs" in k && k.logs != null && (this.logs = k.logs), "ret" in k && k.ret != null && (this.ret = k.ret), "vm_error" in k && k.vm_error != null && (this.vm_error = k.vm_error), "gas_used" in k && k.gas_used != null && (this.gas_used = k.gas_used));
          }
          get hash() {
            return m.Message.getField(this, 1);
          }
          set hash(k) {
            m.Message.setField(this, 1, k);
          }
          get logs() {
            return m.Message.getRepeatedWrapperField(this, d.ethermint.evm.v1.Log, 2);
          }
          set logs(k) {
            m.Message.setRepeatedWrapperField(this, 2, k);
          }
          get ret() {
            return m.Message.getField(this, 3);
          }
          set ret(k) {
            m.Message.setField(this, 3, k);
          }
          get vm_error() {
            return m.Message.getField(this, 4);
          }
          set vm_error(k) {
            m.Message.setField(this, 4, k);
          }
          get gas_used() {
            return m.Message.getField(this, 5);
          }
          set gas_used(k) {
            m.Message.setField(this, 5, k);
          }
          static fromObject(k) {
            const F = new M({});
            return k.hash != null && (F.hash = k.hash), k.logs != null && (F.logs = k.logs.map((X) => d.ethermint.evm.v1.Log.fromObject(X))), k.ret != null && (F.ret = k.ret), k.vm_error != null && (F.vm_error = k.vm_error), k.gas_used != null && (F.gas_used = k.gas_used), F;
          }
          toObject() {
            const k = {};
            return this.hash != null && (k.hash = this.hash), this.logs != null && (k.logs = this.logs.map((F) => F.toObject())), this.ret != null && (k.ret = this.ret), this.vm_error != null && (k.vm_error = this.vm_error), this.gas_used != null && (k.gas_used = this.gas_used), k;
          }
          serialize(k) {
            const F = k || new m.BinaryWriter();
            if (typeof this.hash == "string" && this.hash.length && F.writeString(1, this.hash), this.logs !== void 0 && F.writeRepeatedMessage(2, this.logs, (X) => X.serialize(F)), this.ret !== void 0 && F.writeBytes(3, this.ret), typeof this.vm_error == "string" && this.vm_error.length && F.writeString(4, this.vm_error), this.gas_used !== void 0 && F.writeUint64(5, this.gas_used), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof m.BinaryReader ? k : new m.BinaryReader(k), X = new M();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.hash = F.readString();
                  break;
                case 2:
                  F.readMessage(X.logs, () => m.Message.addToRepeatedWrapperField(X, 2, d.ethermint.evm.v1.Log.deserialize(F), d.ethermint.evm.v1.Log));
                  break;
                case 3:
                  X.ret = F.readBytes();
                  break;
                case 4:
                  X.vm_error = F.readString();
                  break;
                case 5:
                  X.gas_used = F.readUint64();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return M.deserialize(k);
          }
        }
        $.MsgEthereumTxResponse = M;
      })(S.v1 || (S.v1 = {}));
    })(v.evm || (v.evm = {}));
  })(e.ethermint || (e.ethermint = {}));
})(tx$6);
var __createBinding$b = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$b = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$b = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$b(n, e, o);
  return __setModuleDefault$b(n, e), n;
};
Object.defineProperty(msgEthereumTx, "__esModule", { value: !0 });
msgEthereumTx.bytesToDynamicFeeTx = msgEthereumTx.bytesToAccessListTx = msgEthereumTx.bytesToLegacyTx = msgEthereumTx.bytesToMsgEthereumTx = void 0;
const ethermint = __importStar$b(tx$6);
function bytesToMsgEthereumTx(e) {
  return ethermint.ethermint.evm.v1.MsgEthereumTx.deserialize(e);
}
msgEthereumTx.bytesToMsgEthereumTx = bytesToMsgEthereumTx;
function bytesToLegacyTx(e) {
  return ethermint.ethermint.evm.v1.LegacyTx.deserialize(e);
}
msgEthereumTx.bytesToLegacyTx = bytesToLegacyTx;
function bytesToAccessListTx(e) {
  return ethermint.ethermint.evm.v1.AccessListTx.deserialize(e);
}
msgEthereumTx.bytesToAccessListTx = bytesToAccessListTx;
function bytesToDynamicFeeTx(e) {
  return ethermint.ethermint.evm.v1.DynamicFeeTx.deserialize(e);
}
msgEthereumTx.bytesToDynamicFeeTx = bytesToDynamicFeeTx;
var msgSend$1 = {}, tx$5 = {}, bank$1 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(m, v, S, $) {
    $ === void 0 && ($ = S);
    var E = Object.getOwnPropertyDescriptor(v, S);
    (!E || ("get" in E ? !v.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
      return v[S];
    } }), Object.defineProperty(m, $, E);
  } : function(m, v, S, $) {
    $ === void 0 && ($ = S), m[$] = v[S];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(m, v) {
    Object.defineProperty(m, "default", { enumerable: !0, value: v });
  } : function(m, v) {
    m.default = v;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(m) {
    if (m && m.__esModule)
      return m;
    var v = {};
    if (m != null)
      for (var S in m)
        S !== "default" && Object.prototype.hasOwnProperty.call(m, S) && n(v, m, S);
    return o(v, m), v;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(coin$6), d = u(googleProtobuf);
  (function(m) {
    (function(v) {
      (function(S) {
        class $ extends d.Message {
          constructor(k) {
            super(), d.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [1], []), !Array.isArray(k) && typeof k == "object" && ("send_enabled" in k && k.send_enabled != null && (this.send_enabled = k.send_enabled), "default_send_enabled" in k && k.default_send_enabled != null && (this.default_send_enabled = k.default_send_enabled));
          }
          get send_enabled() {
            return d.Message.getRepeatedWrapperField(this, E, 1);
          }
          set send_enabled(k) {
            d.Message.setRepeatedWrapperField(this, 1, k);
          }
          get default_send_enabled() {
            return d.Message.getField(this, 2);
          }
          set default_send_enabled(k) {
            d.Message.setField(this, 2, k);
          }
          static fromObject(k) {
            const F = new $({});
            return k.send_enabled != null && (F.send_enabled = k.send_enabled.map((X) => E.fromObject(X))), k.default_send_enabled != null && (F.default_send_enabled = k.default_send_enabled), F;
          }
          toObject() {
            const k = {};
            return this.send_enabled != null && (k.send_enabled = this.send_enabled.map((F) => F.toObject())), this.default_send_enabled != null && (k.default_send_enabled = this.default_send_enabled), k;
          }
          serialize(k) {
            const F = k || new d.BinaryWriter();
            if (this.send_enabled !== void 0 && F.writeRepeatedMessage(1, this.send_enabled, (X) => X.serialize(F)), this.default_send_enabled !== void 0 && F.writeBool(2, this.default_send_enabled), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof d.BinaryReader ? k : new d.BinaryReader(k), X = new $();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  F.readMessage(X.send_enabled, () => d.Message.addToRepeatedWrapperField(X, 1, E.deserialize(F), E));
                  break;
                case 2:
                  X.default_send_enabled = F.readBool();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return $.deserialize(k);
          }
        }
        S.Params = $;
        class E extends d.Message {
          constructor(k) {
            super(), d.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [], []), !Array.isArray(k) && typeof k == "object" && ("denom" in k && k.denom != null && (this.denom = k.denom), "enabled" in k && k.enabled != null && (this.enabled = k.enabled));
          }
          get denom() {
            return d.Message.getField(this, 1);
          }
          set denom(k) {
            d.Message.setField(this, 1, k);
          }
          get enabled() {
            return d.Message.getField(this, 2);
          }
          set enabled(k) {
            d.Message.setField(this, 2, k);
          }
          static fromObject(k) {
            const F = new E({});
            return k.denom != null && (F.denom = k.denom), k.enabled != null && (F.enabled = k.enabled), F;
          }
          toObject() {
            const k = {};
            return this.denom != null && (k.denom = this.denom), this.enabled != null && (k.enabled = this.enabled), k;
          }
          serialize(k) {
            const F = k || new d.BinaryWriter();
            if (typeof this.denom == "string" && this.denom.length && F.writeString(1, this.denom), this.enabled !== void 0 && F.writeBool(2, this.enabled), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof d.BinaryReader ? k : new d.BinaryReader(k), X = new E();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.denom = F.readString();
                  break;
                case 2:
                  X.enabled = F.readBool();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return E.deserialize(k);
          }
        }
        S.SendEnabled = E;
        class O extends d.Message {
          constructor(k) {
            super(), d.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [2], []), !Array.isArray(k) && typeof k == "object" && ("address" in k && k.address != null && (this.address = k.address), "coins" in k && k.coins != null && (this.coins = k.coins));
          }
          get address() {
            return d.Message.getField(this, 1);
          }
          set address(k) {
            d.Message.setField(this, 1, k);
          }
          get coins() {
            return d.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 2);
          }
          set coins(k) {
            d.Message.setRepeatedWrapperField(this, 2, k);
          }
          static fromObject(k) {
            const F = new O({});
            return k.address != null && (F.address = k.address), k.coins != null && (F.coins = k.coins.map((X) => c.cosmos.base.v1beta1.Coin.fromObject(X))), F;
          }
          toObject() {
            const k = {};
            return this.address != null && (k.address = this.address), this.coins != null && (k.coins = this.coins.map((F) => F.toObject())), k;
          }
          serialize(k) {
            const F = k || new d.BinaryWriter();
            if (typeof this.address == "string" && this.address.length && F.writeString(1, this.address), this.coins !== void 0 && F.writeRepeatedMessage(2, this.coins, (X) => X.serialize(F)), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof d.BinaryReader ? k : new d.BinaryReader(k), X = new O();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.address = F.readString();
                  break;
                case 2:
                  F.readMessage(X.coins, () => d.Message.addToRepeatedWrapperField(X, 2, c.cosmos.base.v1beta1.Coin.deserialize(F), c.cosmos.base.v1beta1.Coin));
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return O.deserialize(k);
          }
        }
        S.Input = O;
        class T extends d.Message {
          constructor(k) {
            super(), d.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [2], []), !Array.isArray(k) && typeof k == "object" && ("address" in k && k.address != null && (this.address = k.address), "coins" in k && k.coins != null && (this.coins = k.coins));
          }
          get address() {
            return d.Message.getField(this, 1);
          }
          set address(k) {
            d.Message.setField(this, 1, k);
          }
          get coins() {
            return d.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 2);
          }
          set coins(k) {
            d.Message.setRepeatedWrapperField(this, 2, k);
          }
          static fromObject(k) {
            const F = new T({});
            return k.address != null && (F.address = k.address), k.coins != null && (F.coins = k.coins.map((X) => c.cosmos.base.v1beta1.Coin.fromObject(X))), F;
          }
          toObject() {
            const k = {};
            return this.address != null && (k.address = this.address), this.coins != null && (k.coins = this.coins.map((F) => F.toObject())), k;
          }
          serialize(k) {
            const F = k || new d.BinaryWriter();
            if (typeof this.address == "string" && this.address.length && F.writeString(1, this.address), this.coins !== void 0 && F.writeRepeatedMessage(2, this.coins, (X) => X.serialize(F)), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof d.BinaryReader ? k : new d.BinaryReader(k), X = new T();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.address = F.readString();
                  break;
                case 2:
                  F.readMessage(X.coins, () => d.Message.addToRepeatedWrapperField(X, 2, c.cosmos.base.v1beta1.Coin.deserialize(F), c.cosmos.base.v1beta1.Coin));
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return T.deserialize(k);
          }
        }
        S.Output = T;
        class y extends d.Message {
          constructor(k) {
            super(), d.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [1], []), !Array.isArray(k) && typeof k == "object" && "total" in k && k.total != null && (this.total = k.total);
          }
          get total() {
            return d.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 1);
          }
          set total(k) {
            d.Message.setRepeatedWrapperField(this, 1, k);
          }
          static fromObject(k) {
            const F = new y({});
            return k.total != null && (F.total = k.total.map((X) => c.cosmos.base.v1beta1.Coin.fromObject(X))), F;
          }
          toObject() {
            const k = {};
            return this.total != null && (k.total = this.total.map((F) => F.toObject())), k;
          }
          serialize(k) {
            const F = k || new d.BinaryWriter();
            if (this.total !== void 0 && F.writeRepeatedMessage(1, this.total, (X) => X.serialize(F)), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof d.BinaryReader ? k : new d.BinaryReader(k), X = new y();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  F.readMessage(X.total, () => d.Message.addToRepeatedWrapperField(X, 1, c.cosmos.base.v1beta1.Coin.deserialize(F), c.cosmos.base.v1beta1.Coin));
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return y.deserialize(k);
          }
        }
        S.Supply = y;
        class V extends d.Message {
          constructor(k) {
            super(), d.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [3], []), !Array.isArray(k) && typeof k == "object" && ("denom" in k && k.denom != null && (this.denom = k.denom), "exponent" in k && k.exponent != null && (this.exponent = k.exponent), "aliases" in k && k.aliases != null && (this.aliases = k.aliases));
          }
          get denom() {
            return d.Message.getField(this, 1);
          }
          set denom(k) {
            d.Message.setField(this, 1, k);
          }
          get exponent() {
            return d.Message.getField(this, 2);
          }
          set exponent(k) {
            d.Message.setField(this, 2, k);
          }
          get aliases() {
            return d.Message.getField(this, 3);
          }
          set aliases(k) {
            d.Message.setField(this, 3, k);
          }
          static fromObject(k) {
            const F = new V({});
            return k.denom != null && (F.denom = k.denom), k.exponent != null && (F.exponent = k.exponent), k.aliases != null && (F.aliases = k.aliases), F;
          }
          toObject() {
            const k = {};
            return this.denom != null && (k.denom = this.denom), this.exponent != null && (k.exponent = this.exponent), this.aliases != null && (k.aliases = this.aliases), k;
          }
          serialize(k) {
            const F = k || new d.BinaryWriter();
            if (typeof this.denom == "string" && this.denom.length && F.writeString(1, this.denom), this.exponent !== void 0 && F.writeUint32(2, this.exponent), this.aliases !== void 0 && F.writeRepeatedString(3, this.aliases), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof d.BinaryReader ? k : new d.BinaryReader(k), X = new V();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.denom = F.readString();
                  break;
                case 2:
                  X.exponent = F.readUint32();
                  break;
                case 3:
                  d.Message.addToRepeatedField(X, 3, F.readString());
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return V.deserialize(k);
          }
        }
        S.DenomUnit = V;
        class M extends d.Message {
          constructor(k) {
            super(), d.Message.initialize(this, Array.isArray(k) ? k : [], 0, -1, [2], []), !Array.isArray(k) && typeof k == "object" && ("description" in k && k.description != null && (this.description = k.description), "denom_units" in k && k.denom_units != null && (this.denom_units = k.denom_units), "base" in k && k.base != null && (this.base = k.base), "display" in k && k.display != null && (this.display = k.display), "name" in k && k.name != null && (this.name = k.name), "symbol" in k && k.symbol != null && (this.symbol = k.symbol));
          }
          get description() {
            return d.Message.getField(this, 1);
          }
          set description(k) {
            d.Message.setField(this, 1, k);
          }
          get denom_units() {
            return d.Message.getRepeatedWrapperField(this, V, 2);
          }
          set denom_units(k) {
            d.Message.setRepeatedWrapperField(this, 2, k);
          }
          get base() {
            return d.Message.getField(this, 3);
          }
          set base(k) {
            d.Message.setField(this, 3, k);
          }
          get display() {
            return d.Message.getField(this, 4);
          }
          set display(k) {
            d.Message.setField(this, 4, k);
          }
          get name() {
            return d.Message.getField(this, 5);
          }
          set name(k) {
            d.Message.setField(this, 5, k);
          }
          get symbol() {
            return d.Message.getField(this, 6);
          }
          set symbol(k) {
            d.Message.setField(this, 6, k);
          }
          static fromObject(k) {
            const F = new M({});
            return k.description != null && (F.description = k.description), k.denom_units != null && (F.denom_units = k.denom_units.map((X) => V.fromObject(X))), k.base != null && (F.base = k.base), k.display != null && (F.display = k.display), k.name != null && (F.name = k.name), k.symbol != null && (F.symbol = k.symbol), F;
          }
          toObject() {
            const k = {};
            return this.description != null && (k.description = this.description), this.denom_units != null && (k.denom_units = this.denom_units.map((F) => F.toObject())), this.base != null && (k.base = this.base), this.display != null && (k.display = this.display), this.name != null && (k.name = this.name), this.symbol != null && (k.symbol = this.symbol), k;
          }
          serialize(k) {
            const F = k || new d.BinaryWriter();
            if (typeof this.description == "string" && this.description.length && F.writeString(1, this.description), this.denom_units !== void 0 && F.writeRepeatedMessage(2, this.denom_units, (X) => X.serialize(F)), typeof this.base == "string" && this.base.length && F.writeString(3, this.base), typeof this.display == "string" && this.display.length && F.writeString(4, this.display), typeof this.name == "string" && this.name.length && F.writeString(5, this.name), typeof this.symbol == "string" && this.symbol.length && F.writeString(6, this.symbol), !k)
              return F.getResultBuffer();
          }
          static deserialize(k) {
            const F = k instanceof d.BinaryReader ? k : new d.BinaryReader(k), X = new M();
            for (; F.nextField() && !F.isEndGroup(); )
              switch (F.getFieldNumber()) {
                case 1:
                  X.description = F.readString();
                  break;
                case 2:
                  F.readMessage(X.denom_units, () => d.Message.addToRepeatedWrapperField(X, 2, V.deserialize(F), V));
                  break;
                case 3:
                  X.base = F.readString();
                  break;
                case 4:
                  X.display = F.readString();
                  break;
                case 5:
                  X.name = F.readString();
                  break;
                case 6:
                  X.symbol = F.readString();
                  break;
                default:
                  F.skipField();
              }
            return X;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(k) {
            return M.deserialize(k);
          }
        }
        S.Metadata = M;
      })(v.v1beta1 || (v.v1beta1 = {}));
    })(m.bank || (m.bank = {}));
  })(e.cosmos || (e.cosmos = {}));
})(bank$1);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, S, $, E) {
    E === void 0 && (E = $);
    var O = Object.getOwnPropertyDescriptor(S, $);
    (!O || ("get" in O ? !S.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return S[$];
    } }), Object.defineProperty(v, E, O);
  } : function(v, S, $, E) {
    E === void 0 && (E = $), v[E] = S[$];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, S) {
    Object.defineProperty(v, "default", { enumerable: !0, value: S });
  } : function(v, S) {
    v.default = S;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var S = {};
    if (v != null)
      for (var $ in v)
        $ !== "default" && Object.prototype.hasOwnProperty.call(v, $) && n(S, v, $);
    return o(S, v), S;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(coin$6), d = u(bank$1), m = u(googleProtobuf);
  (function(v) {
    (function(S) {
      (function($) {
        class E extends m.Message {
          constructor(M) {
            super(), m.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [3], []), !Array.isArray(M) && typeof M == "object" && ("from_address" in M && M.from_address != null && (this.from_address = M.from_address), "to_address" in M && M.to_address != null && (this.to_address = M.to_address), "amount" in M && M.amount != null && (this.amount = M.amount));
          }
          get from_address() {
            return m.Message.getField(this, 1);
          }
          set from_address(M) {
            m.Message.setField(this, 1, M);
          }
          get to_address() {
            return m.Message.getField(this, 2);
          }
          set to_address(M) {
            m.Message.setField(this, 2, M);
          }
          get amount() {
            return m.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 3);
          }
          set amount(M) {
            m.Message.setRepeatedWrapperField(this, 3, M);
          }
          static fromObject(M) {
            const G = new E({});
            return M.from_address != null && (G.from_address = M.from_address), M.to_address != null && (G.to_address = M.to_address), M.amount != null && (G.amount = M.amount.map((k) => c.cosmos.base.v1beta1.Coin.fromObject(k))), G;
          }
          toObject() {
            const M = {};
            return this.from_address != null && (M.from_address = this.from_address), this.to_address != null && (M.to_address = this.to_address), this.amount != null && (M.amount = this.amount.map((G) => G.toObject())), M;
          }
          serialize(M) {
            const G = M || new m.BinaryWriter();
            if (typeof this.from_address == "string" && this.from_address.length && G.writeString(1, this.from_address), typeof this.to_address == "string" && this.to_address.length && G.writeString(2, this.to_address), this.amount !== void 0 && G.writeRepeatedMessage(3, this.amount, (k) => k.serialize(G)), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof m.BinaryReader ? M : new m.BinaryReader(M), k = new E();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  k.from_address = G.readString();
                  break;
                case 2:
                  k.to_address = G.readString();
                  break;
                case 3:
                  G.readMessage(k.amount, () => m.Message.addToRepeatedWrapperField(k, 3, c.cosmos.base.v1beta1.Coin.deserialize(G), c.cosmos.base.v1beta1.Coin));
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return E.deserialize(M);
          }
        }
        $.MsgSend = E;
        class O extends m.Message {
          constructor(M) {
            super(), m.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []);
          }
          static fromObject(M) {
            return new O({});
          }
          toObject() {
            return {};
          }
          serialize(M) {
            const G = M || new m.BinaryWriter();
            if (!M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof m.BinaryReader ? M : new m.BinaryReader(M), k = new O();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return O.deserialize(M);
          }
        }
        $.MsgSendResponse = O;
        class T extends m.Message {
          constructor(M) {
            super(), m.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [1, 2], []), !Array.isArray(M) && typeof M == "object" && ("inputs" in M && M.inputs != null && (this.inputs = M.inputs), "outputs" in M && M.outputs != null && (this.outputs = M.outputs));
          }
          get inputs() {
            return m.Message.getRepeatedWrapperField(this, d.cosmos.bank.v1beta1.Input, 1);
          }
          set inputs(M) {
            m.Message.setRepeatedWrapperField(this, 1, M);
          }
          get outputs() {
            return m.Message.getRepeatedWrapperField(this, d.cosmos.bank.v1beta1.Output, 2);
          }
          set outputs(M) {
            m.Message.setRepeatedWrapperField(this, 2, M);
          }
          static fromObject(M) {
            const G = new T({});
            return M.inputs != null && (G.inputs = M.inputs.map((k) => d.cosmos.bank.v1beta1.Input.fromObject(k))), M.outputs != null && (G.outputs = M.outputs.map((k) => d.cosmos.bank.v1beta1.Output.fromObject(k))), G;
          }
          toObject() {
            const M = {};
            return this.inputs != null && (M.inputs = this.inputs.map((G) => G.toObject())), this.outputs != null && (M.outputs = this.outputs.map((G) => G.toObject())), M;
          }
          serialize(M) {
            const G = M || new m.BinaryWriter();
            if (this.inputs !== void 0 && G.writeRepeatedMessage(1, this.inputs, (k) => k.serialize(G)), this.outputs !== void 0 && G.writeRepeatedMessage(2, this.outputs, (k) => k.serialize(G)), !M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof m.BinaryReader ? M : new m.BinaryReader(M), k = new T();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                case 1:
                  G.readMessage(k.inputs, () => m.Message.addToRepeatedWrapperField(k, 1, d.cosmos.bank.v1beta1.Input.deserialize(G), d.cosmos.bank.v1beta1.Input));
                  break;
                case 2:
                  G.readMessage(k.outputs, () => m.Message.addToRepeatedWrapperField(k, 2, d.cosmos.bank.v1beta1.Output.deserialize(G), d.cosmos.bank.v1beta1.Output));
                  break;
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return T.deserialize(M);
          }
        }
        $.MsgMultiSend = T;
        class y extends m.Message {
          constructor(M) {
            super(), m.Message.initialize(this, Array.isArray(M) ? M : [], 0, -1, [], []);
          }
          static fromObject(M) {
            return new y({});
          }
          toObject() {
            return {};
          }
          serialize(M) {
            const G = M || new m.BinaryWriter();
            if (!M)
              return G.getResultBuffer();
          }
          static deserialize(M) {
            const G = M instanceof m.BinaryReader ? M : new m.BinaryReader(M), k = new y();
            for (; G.nextField() && !G.isEndGroup(); )
              switch (G.getFieldNumber()) {
                default:
                  G.skipField();
              }
            return k;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(M) {
            return y.deserialize(M);
          }
        }
        $.MsgMultiSendResponse = y;
      })(S.v1beta1 || (S.v1beta1 = {}));
    })(v.bank || (v.bank = {}));
  })(e.cosmos || (e.cosmos = {}));
})(tx$5);
var __createBinding$a = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$a = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$a = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$a(n, e, o);
  return __setModuleDefault$a(n, e), n;
};
Object.defineProperty(msgSend$1, "__esModule", { value: !0 });
msgSend$1.createMsgSend = void 0;
const bank = __importStar$a(tx$5), coin$2 = __importStar$a(coin$6);
function createMsgSend$1(e, n, o, u) {
  const c = new coin$2.cosmos.base.v1beta1.Coin({
    denom: u,
    amount: o
  });
  return {
    message: new bank.cosmos.bank.v1beta1.MsgSend({
      from_address: e,
      to_address: n,
      amount: [c]
    }),
    path: "cosmos.bank.v1beta1.MsgSend"
  };
}
msgSend$1.createMsgSend = createMsgSend$1;
var staking$5 = {}, tx$4 = {}, staking$4 = {}, duration = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.google = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      class v extends c.Message {
        constructor($) {
          super(), c.Message.initialize(this, Array.isArray($) ? $ : [], 0, -1, [], []), !Array.isArray($) && typeof $ == "object" && ("seconds" in $ && $.seconds != null && (this.seconds = $.seconds), "nanos" in $ && $.nanos != null && (this.nanos = $.nanos));
        }
        get seconds() {
          return c.Message.getField(this, 1);
        }
        set seconds($) {
          c.Message.setField(this, 1, $);
        }
        get nanos() {
          return c.Message.getField(this, 2);
        }
        set nanos($) {
          c.Message.setField(this, 2, $);
        }
        static fromObject($) {
          const E = new v({});
          return $.seconds != null && (E.seconds = $.seconds), $.nanos != null && (E.nanos = $.nanos), E;
        }
        toObject() {
          const $ = {};
          return this.seconds != null && ($.seconds = this.seconds), this.nanos != null && ($.nanos = this.nanos), $;
        }
        serialize($) {
          const E = $ || new c.BinaryWriter();
          if (this.seconds !== void 0 && E.writeInt64(1, this.seconds), this.nanos !== void 0 && E.writeInt32(2, this.nanos), !$)
            return E.getResultBuffer();
        }
        static deserialize($) {
          const E = $ instanceof c.BinaryReader ? $ : new c.BinaryReader($), O = new v();
          for (; E.nextField() && !E.isEndGroup(); )
            switch (E.getFieldNumber()) {
              case 1:
                O.seconds = E.readInt64();
                break;
              case 2:
                O.nanos = E.readInt32();
                break;
              default:
                E.skipField();
            }
          return O;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary($) {
          return v.deserialize($);
        }
      }
      m.Duration = v;
    })(d.protobuf || (d.protobuf = {}));
  })(e.google || (e.google = {}));
})(duration);
var types$4 = {}, proof = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tendermint = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      class v extends c.Message {
        constructor(y) {
          super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [4], []), !Array.isArray(y) && typeof y == "object" && ("total" in y && y.total != null && (this.total = y.total), "index" in y && y.index != null && (this.index = y.index), "leaf_hash" in y && y.leaf_hash != null && (this.leaf_hash = y.leaf_hash), "aunts" in y && y.aunts != null && (this.aunts = y.aunts));
        }
        get total() {
          return c.Message.getField(this, 1);
        }
        set total(y) {
          c.Message.setField(this, 1, y);
        }
        get index() {
          return c.Message.getField(this, 2);
        }
        set index(y) {
          c.Message.setField(this, 2, y);
        }
        get leaf_hash() {
          return c.Message.getField(this, 3);
        }
        set leaf_hash(y) {
          c.Message.setField(this, 3, y);
        }
        get aunts() {
          return c.Message.getField(this, 4);
        }
        set aunts(y) {
          c.Message.setField(this, 4, y);
        }
        static fromObject(y) {
          const V = new v({});
          return y.total != null && (V.total = y.total), y.index != null && (V.index = y.index), y.leaf_hash != null && (V.leaf_hash = y.leaf_hash), y.aunts != null && (V.aunts = y.aunts), V;
        }
        toObject() {
          const y = {};
          return this.total != null && (y.total = this.total), this.index != null && (y.index = this.index), this.leaf_hash != null && (y.leaf_hash = this.leaf_hash), this.aunts != null && (y.aunts = this.aunts), y;
        }
        serialize(y) {
          const V = y || new c.BinaryWriter();
          if (this.total !== void 0 && V.writeInt64(1, this.total), this.index !== void 0 && V.writeInt64(2, this.index), this.leaf_hash !== void 0 && V.writeBytes(3, this.leaf_hash), this.aunts !== void 0 && V.writeRepeatedBytes(4, this.aunts), !y)
            return V.getResultBuffer();
        }
        static deserialize(y) {
          const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new v();
          for (; V.nextField() && !V.isEndGroup(); )
            switch (V.getFieldNumber()) {
              case 1:
                M.total = V.readInt64();
                break;
              case 2:
                M.index = V.readInt64();
                break;
              case 3:
                M.leaf_hash = V.readBytes();
                break;
              case 4:
                c.Message.addToRepeatedField(M, 4, V.readBytes());
                break;
              default:
                V.skipField();
            }
          return M;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(y) {
          return v.deserialize(y);
        }
      }
      m.Proof = v;
      class S extends c.Message {
        constructor(y) {
          super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [], []), !Array.isArray(y) && typeof y == "object" && ("key" in y && y.key != null && (this.key = y.key), "proof" in y && y.proof != null && (this.proof = y.proof));
        }
        get key() {
          return c.Message.getField(this, 1);
        }
        set key(y) {
          c.Message.setField(this, 1, y);
        }
        get proof() {
          return c.Message.getWrapperField(this, v, 2);
        }
        set proof(y) {
          c.Message.setWrapperField(this, 2, y);
        }
        static fromObject(y) {
          const V = new S({});
          return y.key != null && (V.key = y.key), y.proof != null && (V.proof = v.fromObject(y.proof)), V;
        }
        toObject() {
          const y = {};
          return this.key != null && (y.key = this.key), this.proof != null && (y.proof = this.proof.toObject()), y;
        }
        serialize(y) {
          const V = y || new c.BinaryWriter();
          if (this.key !== void 0 && V.writeBytes(1, this.key), this.proof !== void 0 && V.writeMessage(2, this.proof, () => this.proof.serialize(V)), !y)
            return V.getResultBuffer();
        }
        static deserialize(y) {
          const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new S();
          for (; V.nextField() && !V.isEndGroup(); )
            switch (V.getFieldNumber()) {
              case 1:
                M.key = V.readBytes();
                break;
              case 2:
                V.readMessage(M.proof, () => M.proof = v.deserialize(V));
                break;
              default:
                V.skipField();
            }
          return M;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(y) {
          return S.deserialize(y);
        }
      }
      m.ValueOp = S;
      class $ extends c.Message {
        constructor(y) {
          super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [], []), !Array.isArray(y) && typeof y == "object" && ("key" in y && y.key != null && (this.key = y.key), "input" in y && y.input != null && (this.input = y.input), "output" in y && y.output != null && (this.output = y.output));
        }
        get key() {
          return c.Message.getField(this, 1);
        }
        set key(y) {
          c.Message.setField(this, 1, y);
        }
        get input() {
          return c.Message.getField(this, 2);
        }
        set input(y) {
          c.Message.setField(this, 2, y);
        }
        get output() {
          return c.Message.getField(this, 3);
        }
        set output(y) {
          c.Message.setField(this, 3, y);
        }
        static fromObject(y) {
          const V = new $({});
          return y.key != null && (V.key = y.key), y.input != null && (V.input = y.input), y.output != null && (V.output = y.output), V;
        }
        toObject() {
          const y = {};
          return this.key != null && (y.key = this.key), this.input != null && (y.input = this.input), this.output != null && (y.output = this.output), y;
        }
        serialize(y) {
          const V = y || new c.BinaryWriter();
          if (typeof this.key == "string" && this.key.length && V.writeString(1, this.key), typeof this.input == "string" && this.input.length && V.writeString(2, this.input), typeof this.output == "string" && this.output.length && V.writeString(3, this.output), !y)
            return V.getResultBuffer();
        }
        static deserialize(y) {
          const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new $();
          for (; V.nextField() && !V.isEndGroup(); )
            switch (V.getFieldNumber()) {
              case 1:
                M.key = V.readString();
                break;
              case 2:
                M.input = V.readString();
                break;
              case 3:
                M.output = V.readString();
                break;
              default:
                V.skipField();
            }
          return M;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(y) {
          return $.deserialize(y);
        }
      }
      m.DominoOp = $;
      class E extends c.Message {
        constructor(y) {
          super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [], []), !Array.isArray(y) && typeof y == "object" && ("type" in y && y.type != null && (this.type = y.type), "key" in y && y.key != null && (this.key = y.key), "data" in y && y.data != null && (this.data = y.data));
        }
        get type() {
          return c.Message.getField(this, 1);
        }
        set type(y) {
          c.Message.setField(this, 1, y);
        }
        get key() {
          return c.Message.getField(this, 2);
        }
        set key(y) {
          c.Message.setField(this, 2, y);
        }
        get data() {
          return c.Message.getField(this, 3);
        }
        set data(y) {
          c.Message.setField(this, 3, y);
        }
        static fromObject(y) {
          const V = new E({});
          return y.type != null && (V.type = y.type), y.key != null && (V.key = y.key), y.data != null && (V.data = y.data), V;
        }
        toObject() {
          const y = {};
          return this.type != null && (y.type = this.type), this.key != null && (y.key = this.key), this.data != null && (y.data = this.data), y;
        }
        serialize(y) {
          const V = y || new c.BinaryWriter();
          if (typeof this.type == "string" && this.type.length && V.writeString(1, this.type), this.key !== void 0 && V.writeBytes(2, this.key), this.data !== void 0 && V.writeBytes(3, this.data), !y)
            return V.getResultBuffer();
        }
        static deserialize(y) {
          const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new E();
          for (; V.nextField() && !V.isEndGroup(); )
            switch (V.getFieldNumber()) {
              case 1:
                M.type = V.readString();
                break;
              case 2:
                M.key = V.readBytes();
                break;
              case 3:
                M.data = V.readBytes();
                break;
              default:
                V.skipField();
            }
          return M;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(y) {
          return E.deserialize(y);
        }
      }
      m.ProofOp = E;
      class O extends c.Message {
        constructor(y) {
          super(), c.Message.initialize(this, Array.isArray(y) ? y : [], 0, -1, [1], []), !Array.isArray(y) && typeof y == "object" && "ops" in y && y.ops != null && (this.ops = y.ops);
        }
        get ops() {
          return c.Message.getRepeatedWrapperField(this, E, 1);
        }
        set ops(y) {
          c.Message.setRepeatedWrapperField(this, 1, y);
        }
        static fromObject(y) {
          const V = new O({});
          return y.ops != null && (V.ops = y.ops.map((M) => E.fromObject(M))), V;
        }
        toObject() {
          const y = {};
          return this.ops != null && (y.ops = this.ops.map((V) => V.toObject())), y;
        }
        serialize(y) {
          const V = y || new c.BinaryWriter();
          if (this.ops !== void 0 && V.writeRepeatedMessage(1, this.ops, (M) => M.serialize(V)), !y)
            return V.getResultBuffer();
        }
        static deserialize(y) {
          const V = y instanceof c.BinaryReader ? y : new c.BinaryReader(y), M = new O();
          for (; V.nextField() && !V.isEndGroup(); )
            switch (V.getFieldNumber()) {
              case 1:
                V.readMessage(M.ops, () => c.Message.addToRepeatedWrapperField(M, 1, E.deserialize(V), E));
                break;
              default:
                V.skipField();
            }
          return M;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(y) {
          return O.deserialize(y);
        }
      }
      m.ProofOps = O;
    })(d.crypto || (d.crypto = {}));
  })(e.tendermint || (e.tendermint = {}));
})(proof);
var types$3 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tendermint = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      class v extends c.Message {
        constructor(E) {
          super(), c.Message.initialize(this, Array.isArray(E) ? E : [], 0, -1, [], []), !Array.isArray(E) && typeof E == "object" && ("protocol" in E && E.protocol != null && (this.protocol = E.protocol), "software" in E && E.software != null && (this.software = E.software));
        }
        get protocol() {
          return c.Message.getField(this, 1);
        }
        set protocol(E) {
          c.Message.setField(this, 1, E);
        }
        get software() {
          return c.Message.getField(this, 2);
        }
        set software(E) {
          c.Message.setField(this, 2, E);
        }
        static fromObject(E) {
          const O = new v({});
          return E.protocol != null && (O.protocol = E.protocol), E.software != null && (O.software = E.software), O;
        }
        toObject() {
          const E = {};
          return this.protocol != null && (E.protocol = this.protocol), this.software != null && (E.software = this.software), E;
        }
        serialize(E) {
          const O = E || new c.BinaryWriter();
          if (this.protocol !== void 0 && O.writeUint64(1, this.protocol), typeof this.software == "string" && this.software.length && O.writeString(2, this.software), !E)
            return O.getResultBuffer();
        }
        static deserialize(E) {
          const O = E instanceof c.BinaryReader ? E : new c.BinaryReader(E), T = new v();
          for (; O.nextField() && !O.isEndGroup(); )
            switch (O.getFieldNumber()) {
              case 1:
                T.protocol = O.readUint64();
                break;
              case 2:
                T.software = O.readString();
                break;
              default:
                O.skipField();
            }
          return T;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(E) {
          return v.deserialize(E);
        }
      }
      m.App = v;
      class S extends c.Message {
        constructor(E) {
          super(), c.Message.initialize(this, Array.isArray(E) ? E : [], 0, -1, [], []), !Array.isArray(E) && typeof E == "object" && ("block" in E && E.block != null && (this.block = E.block), "app" in E && E.app != null && (this.app = E.app));
        }
        get block() {
          return c.Message.getField(this, 1);
        }
        set block(E) {
          c.Message.setField(this, 1, E);
        }
        get app() {
          return c.Message.getField(this, 2);
        }
        set app(E) {
          c.Message.setField(this, 2, E);
        }
        static fromObject(E) {
          const O = new S({});
          return E.block != null && (O.block = E.block), E.app != null && (O.app = E.app), O;
        }
        toObject() {
          const E = {};
          return this.block != null && (E.block = this.block), this.app != null && (E.app = this.app), E;
        }
        serialize(E) {
          const O = E || new c.BinaryWriter();
          if (this.block !== void 0 && O.writeUint64(1, this.block), this.app !== void 0 && O.writeUint64(2, this.app), !E)
            return O.getResultBuffer();
        }
        static deserialize(E) {
          const O = E instanceof c.BinaryReader ? E : new c.BinaryReader(E), T = new S();
          for (; O.nextField() && !O.isEndGroup(); )
            switch (O.getFieldNumber()) {
              case 1:
                T.block = O.readUint64();
                break;
              case 2:
                T.app = O.readUint64();
                break;
              default:
                O.skipField();
            }
          return T;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(E) {
          return S.deserialize(E);
        }
      }
      m.Consensus = S;
    })(d.version || (d.version = {}));
  })(e.tendermint || (e.tendermint = {}));
})(types$3);
var validator$7 = {}, keys$2 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tendermint = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      class v extends c.Message {
        constructor($) {
          super(), c.Message.initialize(this, Array.isArray($) ? $ : [], 0, -1, [], [[1, 2]]), !Array.isArray($) && typeof $ == "object" && ("ed25519" in $ && $.ed25519 != null && (this.ed25519 = $.ed25519), "secp256k1" in $ && $.secp256k1 != null && (this.secp256k1 = $.secp256k1));
        }
        get ed25519() {
          return c.Message.getField(this, 1);
        }
        set ed25519($) {
          c.Message.setOneofField(this, 1, [1, 2], $);
        }
        get secp256k1() {
          return c.Message.getField(this, 2);
        }
        set secp256k1($) {
          c.Message.setOneofField(this, 2, [1, 2], $);
        }
        get sum() {
          return {
            0: "none",
            1: "ed25519",
            2: "secp256k1"
          }[c.Message.computeOneofCase(this, [1, 2])];
        }
        static fromObject($) {
          const E = new v({});
          return $.ed25519 != null && (E.ed25519 = $.ed25519), $.secp256k1 != null && (E.secp256k1 = $.secp256k1), E;
        }
        toObject() {
          const $ = {};
          return this.ed25519 != null && ($.ed25519 = this.ed25519), this.secp256k1 != null && ($.secp256k1 = this.secp256k1), $;
        }
        serialize($) {
          const E = $ || new c.BinaryWriter();
          if (this.ed25519 !== void 0 && E.writeBytes(1, this.ed25519), this.secp256k1 !== void 0 && E.writeBytes(2, this.secp256k1), !$)
            return E.getResultBuffer();
        }
        static deserialize($) {
          const E = $ instanceof c.BinaryReader ? $ : new c.BinaryReader($), O = new v();
          for (; E.nextField() && !E.isEndGroup(); )
            switch (E.getFieldNumber()) {
              case 1:
                O.ed25519 = E.readBytes();
                break;
              case 2:
                O.secp256k1 = E.readBytes();
                break;
              default:
                E.skipField();
            }
          return O;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary($) {
          return v.deserialize($);
        }
      }
      m.PublicKey = v;
    })(d.crypto || (d.crypto = {}));
  })(e.tendermint || (e.tendermint = {}));
})(keys$2);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(m, v, S, $) {
    $ === void 0 && ($ = S);
    var E = Object.getOwnPropertyDescriptor(v, S);
    (!E || ("get" in E ? !v.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
      return v[S];
    } }), Object.defineProperty(m, $, E);
  } : function(m, v, S, $) {
    $ === void 0 && ($ = S), m[$] = v[S];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(m, v) {
    Object.defineProperty(m, "default", { enumerable: !0, value: v });
  } : function(m, v) {
    m.default = v;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(m) {
    if (m && m.__esModule)
      return m;
    var v = {};
    if (m != null)
      for (var S in m)
        S !== "default" && Object.prototype.hasOwnProperty.call(m, S) && n(v, m, S);
    return o(v, m), v;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tendermint = void 0;
  const c = u(keys$2), d = u(googleProtobuf);
  (function(m) {
    (function(v) {
      class S extends d.Message {
        constructor(T) {
          super(), d.Message.initialize(this, Array.isArray(T) ? T : [], 0, -1, [1], []), !Array.isArray(T) && typeof T == "object" && ("validators" in T && T.validators != null && (this.validators = T.validators), "proposer" in T && T.proposer != null && (this.proposer = T.proposer), "total_voting_power" in T && T.total_voting_power != null && (this.total_voting_power = T.total_voting_power));
        }
        get validators() {
          return d.Message.getRepeatedWrapperField(this, $, 1);
        }
        set validators(T) {
          d.Message.setRepeatedWrapperField(this, 1, T);
        }
        get proposer() {
          return d.Message.getWrapperField(this, $, 2);
        }
        set proposer(T) {
          d.Message.setWrapperField(this, 2, T);
        }
        get total_voting_power() {
          return d.Message.getField(this, 3);
        }
        set total_voting_power(T) {
          d.Message.setField(this, 3, T);
        }
        static fromObject(T) {
          const y = new S({});
          return T.validators != null && (y.validators = T.validators.map((V) => $.fromObject(V))), T.proposer != null && (y.proposer = $.fromObject(T.proposer)), T.total_voting_power != null && (y.total_voting_power = T.total_voting_power), y;
        }
        toObject() {
          const T = {};
          return this.validators != null && (T.validators = this.validators.map((y) => y.toObject())), this.proposer != null && (T.proposer = this.proposer.toObject()), this.total_voting_power != null && (T.total_voting_power = this.total_voting_power), T;
        }
        serialize(T) {
          const y = T || new d.BinaryWriter();
          if (this.validators !== void 0 && y.writeRepeatedMessage(1, this.validators, (V) => V.serialize(y)), this.proposer !== void 0 && y.writeMessage(2, this.proposer, () => this.proposer.serialize(y)), this.total_voting_power !== void 0 && y.writeInt64(3, this.total_voting_power), !T)
            return y.getResultBuffer();
        }
        static deserialize(T) {
          const y = T instanceof d.BinaryReader ? T : new d.BinaryReader(T), V = new S();
          for (; y.nextField() && !y.isEndGroup(); )
            switch (y.getFieldNumber()) {
              case 1:
                y.readMessage(V.validators, () => d.Message.addToRepeatedWrapperField(V, 1, $.deserialize(y), $));
                break;
              case 2:
                y.readMessage(V.proposer, () => V.proposer = $.deserialize(y));
                break;
              case 3:
                V.total_voting_power = y.readInt64();
                break;
              default:
                y.skipField();
            }
          return V;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(T) {
          return S.deserialize(T);
        }
      }
      v.ValidatorSet = S;
      class $ extends d.Message {
        constructor(T) {
          super(), d.Message.initialize(this, Array.isArray(T) ? T : [], 0, -1, [], []), !Array.isArray(T) && typeof T == "object" && ("address" in T && T.address != null && (this.address = T.address), "pub_key" in T && T.pub_key != null && (this.pub_key = T.pub_key), "voting_power" in T && T.voting_power != null && (this.voting_power = T.voting_power), "proposer_priority" in T && T.proposer_priority != null && (this.proposer_priority = T.proposer_priority));
        }
        get address() {
          return d.Message.getField(this, 1);
        }
        set address(T) {
          d.Message.setField(this, 1, T);
        }
        get pub_key() {
          return d.Message.getWrapperField(this, c.tendermint.crypto.PublicKey, 2);
        }
        set pub_key(T) {
          d.Message.setWrapperField(this, 2, T);
        }
        get voting_power() {
          return d.Message.getField(this, 3);
        }
        set voting_power(T) {
          d.Message.setField(this, 3, T);
        }
        get proposer_priority() {
          return d.Message.getField(this, 4);
        }
        set proposer_priority(T) {
          d.Message.setField(this, 4, T);
        }
        static fromObject(T) {
          const y = new $({});
          return T.address != null && (y.address = T.address), T.pub_key != null && (y.pub_key = c.tendermint.crypto.PublicKey.fromObject(T.pub_key)), T.voting_power != null && (y.voting_power = T.voting_power), T.proposer_priority != null && (y.proposer_priority = T.proposer_priority), y;
        }
        toObject() {
          const T = {};
          return this.address != null && (T.address = this.address), this.pub_key != null && (T.pub_key = this.pub_key.toObject()), this.voting_power != null && (T.voting_power = this.voting_power), this.proposer_priority != null && (T.proposer_priority = this.proposer_priority), T;
        }
        serialize(T) {
          const y = T || new d.BinaryWriter();
          if (this.address !== void 0 && y.writeBytes(1, this.address), this.pub_key !== void 0 && y.writeMessage(2, this.pub_key, () => this.pub_key.serialize(y)), this.voting_power !== void 0 && y.writeInt64(3, this.voting_power), this.proposer_priority !== void 0 && y.writeInt64(4, this.proposer_priority), !T)
            return y.getResultBuffer();
        }
        static deserialize(T) {
          const y = T instanceof d.BinaryReader ? T : new d.BinaryReader(T), V = new $();
          for (; y.nextField() && !y.isEndGroup(); )
            switch (y.getFieldNumber()) {
              case 1:
                V.address = y.readBytes();
                break;
              case 2:
                y.readMessage(V.pub_key, () => V.pub_key = c.tendermint.crypto.PublicKey.deserialize(y));
                break;
              case 3:
                V.voting_power = y.readInt64();
                break;
              case 4:
                V.proposer_priority = y.readInt64();
                break;
              default:
                y.skipField();
            }
          return V;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(T) {
          return $.deserialize(T);
        }
      }
      v.Validator = $;
      class E extends d.Message {
        constructor(T) {
          super(), d.Message.initialize(this, Array.isArray(T) ? T : [], 0, -1, [], []), !Array.isArray(T) && typeof T == "object" && ("pub_key" in T && T.pub_key != null && (this.pub_key = T.pub_key), "voting_power" in T && T.voting_power != null && (this.voting_power = T.voting_power));
        }
        get pub_key() {
          return d.Message.getWrapperField(this, c.tendermint.crypto.PublicKey, 1);
        }
        set pub_key(T) {
          d.Message.setWrapperField(this, 1, T);
        }
        get voting_power() {
          return d.Message.getField(this, 2);
        }
        set voting_power(T) {
          d.Message.setField(this, 2, T);
        }
        static fromObject(T) {
          const y = new E({});
          return T.pub_key != null && (y.pub_key = c.tendermint.crypto.PublicKey.fromObject(T.pub_key)), T.voting_power != null && (y.voting_power = T.voting_power), y;
        }
        toObject() {
          const T = {};
          return this.pub_key != null && (T.pub_key = this.pub_key.toObject()), this.voting_power != null && (T.voting_power = this.voting_power), T;
        }
        serialize(T) {
          const y = T || new d.BinaryWriter();
          if (this.pub_key !== void 0 && y.writeMessage(1, this.pub_key, () => this.pub_key.serialize(y)), this.voting_power !== void 0 && y.writeInt64(2, this.voting_power), !T)
            return y.getResultBuffer();
        }
        static deserialize(T) {
          const y = T instanceof d.BinaryReader ? T : new d.BinaryReader(T), V = new E();
          for (; y.nextField() && !y.isEndGroup(); )
            switch (y.getFieldNumber()) {
              case 1:
                y.readMessage(V.pub_key, () => V.pub_key = c.tendermint.crypto.PublicKey.deserialize(y));
                break;
              case 2:
                V.voting_power = y.readInt64();
                break;
              default:
                y.skipField();
            }
          return V;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(T) {
          return E.deserialize(T);
        }
      }
      v.SimpleValidator = E;
    })(m.types || (m.types = {}));
  })(e.tendermint || (e.tendermint = {}));
})(validator$7);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function($, E, O, T) {
    T === void 0 && (T = O);
    var y = Object.getOwnPropertyDescriptor(E, O);
    (!y || ("get" in y ? !E.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return E[O];
    } }), Object.defineProperty($, T, y);
  } : function($, E, O, T) {
    T === void 0 && (T = O), $[T] = E[O];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function($, E) {
    Object.defineProperty($, "default", { enumerable: !0, value: E });
  } : function($, E) {
    $.default = E;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function($) {
    if ($ && $.__esModule)
      return $;
    var E = {};
    if ($ != null)
      for (var O in $)
        O !== "default" && Object.prototype.hasOwnProperty.call($, O) && n(E, $, O);
    return o(E, $), E;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tendermint = void 0;
  const c = u(timestamp), d = u(proof), m = u(types$3), v = u(validator$7), S = u(googleProtobuf);
  (function($) {
    (function(E) {
      (function(pe) {
        pe[pe.BLOCK_ID_FLAG_UNKNOWN = 0] = "BLOCK_ID_FLAG_UNKNOWN", pe[pe.BLOCK_ID_FLAG_ABSENT = 1] = "BLOCK_ID_FLAG_ABSENT", pe[pe.BLOCK_ID_FLAG_COMMIT = 2] = "BLOCK_ID_FLAG_COMMIT", pe[pe.BLOCK_ID_FLAG_NIL = 3] = "BLOCK_ID_FLAG_NIL";
      })(E.BlockIDFlag || (E.BlockIDFlag = {})), function(pe) {
        pe[pe.SIGNED_MSG_TYPE_UNKNOWN = 0] = "SIGNED_MSG_TYPE_UNKNOWN", pe[pe.SIGNED_MSG_TYPE_PREVOTE = 1] = "SIGNED_MSG_TYPE_PREVOTE", pe[pe.SIGNED_MSG_TYPE_PRECOMMIT = 2] = "SIGNED_MSG_TYPE_PRECOMMIT", pe[pe.SIGNED_MSG_TYPE_PROPOSAL = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
      }(E.SignedMsgType || (E.SignedMsgType = {}));
      class O extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("total" in oe && oe.total != null && (this.total = oe.total), "hash" in oe && oe.hash != null && (this.hash = oe.hash));
        }
        get total() {
          return S.Message.getField(this, 1);
        }
        set total(oe) {
          S.Message.setField(this, 1, oe);
        }
        get hash() {
          return S.Message.getField(this, 2);
        }
        set hash(oe) {
          S.Message.setField(this, 2, oe);
        }
        static fromObject(oe) {
          const ne = new O({});
          return oe.total != null && (ne.total = oe.total), oe.hash != null && (ne.hash = oe.hash), ne;
        }
        toObject() {
          const oe = {};
          return this.total != null && (oe.total = this.total), this.hash != null && (oe.hash = this.hash), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.total !== void 0 && ne.writeUint32(1, this.total), this.hash !== void 0 && ne.writeBytes(2, this.hash), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new O();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                H.total = ne.readUint32();
                break;
              case 2:
                H.hash = ne.readBytes();
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return O.deserialize(oe);
        }
      }
      E.PartSetHeader = O;
      class T extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("index" in oe && oe.index != null && (this.index = oe.index), "bytes" in oe && oe.bytes != null && (this.bytes = oe.bytes), "proof" in oe && oe.proof != null && (this.proof = oe.proof));
        }
        get index() {
          return S.Message.getField(this, 1);
        }
        set index(oe) {
          S.Message.setField(this, 1, oe);
        }
        get bytes() {
          return S.Message.getField(this, 2);
        }
        set bytes(oe) {
          S.Message.setField(this, 2, oe);
        }
        get proof() {
          return S.Message.getWrapperField(this, d.tendermint.crypto.Proof, 3);
        }
        set proof(oe) {
          S.Message.setWrapperField(this, 3, oe);
        }
        static fromObject(oe) {
          const ne = new T({});
          return oe.index != null && (ne.index = oe.index), oe.bytes != null && (ne.bytes = oe.bytes), oe.proof != null && (ne.proof = d.tendermint.crypto.Proof.fromObject(oe.proof)), ne;
        }
        toObject() {
          const oe = {};
          return this.index != null && (oe.index = this.index), this.bytes != null && (oe.bytes = this.bytes), this.proof != null && (oe.proof = this.proof.toObject()), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.index !== void 0 && ne.writeUint32(1, this.index), this.bytes !== void 0 && ne.writeBytes(2, this.bytes), this.proof !== void 0 && ne.writeMessage(3, this.proof, () => this.proof.serialize(ne)), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new T();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                H.index = ne.readUint32();
                break;
              case 2:
                H.bytes = ne.readBytes();
                break;
              case 3:
                ne.readMessage(H.proof, () => H.proof = d.tendermint.crypto.Proof.deserialize(ne));
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return T.deserialize(oe);
        }
      }
      E.Part = T;
      class y extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("hash" in oe && oe.hash != null && (this.hash = oe.hash), "part_set_header" in oe && oe.part_set_header != null && (this.part_set_header = oe.part_set_header));
        }
        get hash() {
          return S.Message.getField(this, 1);
        }
        set hash(oe) {
          S.Message.setField(this, 1, oe);
        }
        get part_set_header() {
          return S.Message.getWrapperField(this, O, 2);
        }
        set part_set_header(oe) {
          S.Message.setWrapperField(this, 2, oe);
        }
        static fromObject(oe) {
          const ne = new y({});
          return oe.hash != null && (ne.hash = oe.hash), oe.part_set_header != null && (ne.part_set_header = O.fromObject(oe.part_set_header)), ne;
        }
        toObject() {
          const oe = {};
          return this.hash != null && (oe.hash = this.hash), this.part_set_header != null && (oe.part_set_header = this.part_set_header.toObject()), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.hash !== void 0 && ne.writeBytes(1, this.hash), this.part_set_header !== void 0 && ne.writeMessage(2, this.part_set_header, () => this.part_set_header.serialize(ne)), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new y();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                H.hash = ne.readBytes();
                break;
              case 2:
                ne.readMessage(H.part_set_header, () => H.part_set_header = O.deserialize(ne));
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return y.deserialize(oe);
        }
      }
      E.BlockID = y;
      class V extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("version" in oe && oe.version != null && (this.version = oe.version), "chain_id" in oe && oe.chain_id != null && (this.chain_id = oe.chain_id), "height" in oe && oe.height != null && (this.height = oe.height), "time" in oe && oe.time != null && (this.time = oe.time), "last_block_id" in oe && oe.last_block_id != null && (this.last_block_id = oe.last_block_id), "last_commit_hash" in oe && oe.last_commit_hash != null && (this.last_commit_hash = oe.last_commit_hash), "data_hash" in oe && oe.data_hash != null && (this.data_hash = oe.data_hash), "validators_hash" in oe && oe.validators_hash != null && (this.validators_hash = oe.validators_hash), "next_validators_hash" in oe && oe.next_validators_hash != null && (this.next_validators_hash = oe.next_validators_hash), "consensus_hash" in oe && oe.consensus_hash != null && (this.consensus_hash = oe.consensus_hash), "app_hash" in oe && oe.app_hash != null && (this.app_hash = oe.app_hash), "last_results_hash" in oe && oe.last_results_hash != null && (this.last_results_hash = oe.last_results_hash), "evidence_hash" in oe && oe.evidence_hash != null && (this.evidence_hash = oe.evidence_hash), "proposer_address" in oe && oe.proposer_address != null && (this.proposer_address = oe.proposer_address));
        }
        get version() {
          return S.Message.getWrapperField(this, m.tendermint.version.Consensus, 1);
        }
        set version(oe) {
          S.Message.setWrapperField(this, 1, oe);
        }
        get chain_id() {
          return S.Message.getField(this, 2);
        }
        set chain_id(oe) {
          S.Message.setField(this, 2, oe);
        }
        get height() {
          return S.Message.getField(this, 3);
        }
        set height(oe) {
          S.Message.setField(this, 3, oe);
        }
        get time() {
          return S.Message.getWrapperField(this, c.google.protobuf.Timestamp, 4);
        }
        set time(oe) {
          S.Message.setWrapperField(this, 4, oe);
        }
        get last_block_id() {
          return S.Message.getWrapperField(this, y, 5);
        }
        set last_block_id(oe) {
          S.Message.setWrapperField(this, 5, oe);
        }
        get last_commit_hash() {
          return S.Message.getField(this, 6);
        }
        set last_commit_hash(oe) {
          S.Message.setField(this, 6, oe);
        }
        get data_hash() {
          return S.Message.getField(this, 7);
        }
        set data_hash(oe) {
          S.Message.setField(this, 7, oe);
        }
        get validators_hash() {
          return S.Message.getField(this, 8);
        }
        set validators_hash(oe) {
          S.Message.setField(this, 8, oe);
        }
        get next_validators_hash() {
          return S.Message.getField(this, 9);
        }
        set next_validators_hash(oe) {
          S.Message.setField(this, 9, oe);
        }
        get consensus_hash() {
          return S.Message.getField(this, 10);
        }
        set consensus_hash(oe) {
          S.Message.setField(this, 10, oe);
        }
        get app_hash() {
          return S.Message.getField(this, 11);
        }
        set app_hash(oe) {
          S.Message.setField(this, 11, oe);
        }
        get last_results_hash() {
          return S.Message.getField(this, 12);
        }
        set last_results_hash(oe) {
          S.Message.setField(this, 12, oe);
        }
        get evidence_hash() {
          return S.Message.getField(this, 13);
        }
        set evidence_hash(oe) {
          S.Message.setField(this, 13, oe);
        }
        get proposer_address() {
          return S.Message.getField(this, 14);
        }
        set proposer_address(oe) {
          S.Message.setField(this, 14, oe);
        }
        static fromObject(oe) {
          const ne = new V({});
          return oe.version != null && (ne.version = m.tendermint.version.Consensus.fromObject(oe.version)), oe.chain_id != null && (ne.chain_id = oe.chain_id), oe.height != null && (ne.height = oe.height), oe.time != null && (ne.time = c.google.protobuf.Timestamp.fromObject(oe.time)), oe.last_block_id != null && (ne.last_block_id = y.fromObject(oe.last_block_id)), oe.last_commit_hash != null && (ne.last_commit_hash = oe.last_commit_hash), oe.data_hash != null && (ne.data_hash = oe.data_hash), oe.validators_hash != null && (ne.validators_hash = oe.validators_hash), oe.next_validators_hash != null && (ne.next_validators_hash = oe.next_validators_hash), oe.consensus_hash != null && (ne.consensus_hash = oe.consensus_hash), oe.app_hash != null && (ne.app_hash = oe.app_hash), oe.last_results_hash != null && (ne.last_results_hash = oe.last_results_hash), oe.evidence_hash != null && (ne.evidence_hash = oe.evidence_hash), oe.proposer_address != null && (ne.proposer_address = oe.proposer_address), ne;
        }
        toObject() {
          const oe = {};
          return this.version != null && (oe.version = this.version.toObject()), this.chain_id != null && (oe.chain_id = this.chain_id), this.height != null && (oe.height = this.height), this.time != null && (oe.time = this.time.toObject()), this.last_block_id != null && (oe.last_block_id = this.last_block_id.toObject()), this.last_commit_hash != null && (oe.last_commit_hash = this.last_commit_hash), this.data_hash != null && (oe.data_hash = this.data_hash), this.validators_hash != null && (oe.validators_hash = this.validators_hash), this.next_validators_hash != null && (oe.next_validators_hash = this.next_validators_hash), this.consensus_hash != null && (oe.consensus_hash = this.consensus_hash), this.app_hash != null && (oe.app_hash = this.app_hash), this.last_results_hash != null && (oe.last_results_hash = this.last_results_hash), this.evidence_hash != null && (oe.evidence_hash = this.evidence_hash), this.proposer_address != null && (oe.proposer_address = this.proposer_address), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.version !== void 0 && ne.writeMessage(1, this.version, () => this.version.serialize(ne)), typeof this.chain_id == "string" && this.chain_id.length && ne.writeString(2, this.chain_id), this.height !== void 0 && ne.writeInt64(3, this.height), this.time !== void 0 && ne.writeMessage(4, this.time, () => this.time.serialize(ne)), this.last_block_id !== void 0 && ne.writeMessage(5, this.last_block_id, () => this.last_block_id.serialize(ne)), this.last_commit_hash !== void 0 && ne.writeBytes(6, this.last_commit_hash), this.data_hash !== void 0 && ne.writeBytes(7, this.data_hash), this.validators_hash !== void 0 && ne.writeBytes(8, this.validators_hash), this.next_validators_hash !== void 0 && ne.writeBytes(9, this.next_validators_hash), this.consensus_hash !== void 0 && ne.writeBytes(10, this.consensus_hash), this.app_hash !== void 0 && ne.writeBytes(11, this.app_hash), this.last_results_hash !== void 0 && ne.writeBytes(12, this.last_results_hash), this.evidence_hash !== void 0 && ne.writeBytes(13, this.evidence_hash), this.proposer_address !== void 0 && ne.writeBytes(14, this.proposer_address), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new V();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                ne.readMessage(H.version, () => H.version = m.tendermint.version.Consensus.deserialize(ne));
                break;
              case 2:
                H.chain_id = ne.readString();
                break;
              case 3:
                H.height = ne.readInt64();
                break;
              case 4:
                ne.readMessage(H.time, () => H.time = c.google.protobuf.Timestamp.deserialize(ne));
                break;
              case 5:
                ne.readMessage(H.last_block_id, () => H.last_block_id = y.deserialize(ne));
                break;
              case 6:
                H.last_commit_hash = ne.readBytes();
                break;
              case 7:
                H.data_hash = ne.readBytes();
                break;
              case 8:
                H.validators_hash = ne.readBytes();
                break;
              case 9:
                H.next_validators_hash = ne.readBytes();
                break;
              case 10:
                H.consensus_hash = ne.readBytes();
                break;
              case 11:
                H.app_hash = ne.readBytes();
                break;
              case 12:
                H.last_results_hash = ne.readBytes();
                break;
              case 13:
                H.evidence_hash = ne.readBytes();
                break;
              case 14:
                H.proposer_address = ne.readBytes();
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return V.deserialize(oe);
        }
      }
      E.Header = V;
      class M extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [1], []), !Array.isArray(oe) && typeof oe == "object" && "txs" in oe && oe.txs != null && (this.txs = oe.txs);
        }
        get txs() {
          return S.Message.getField(this, 1);
        }
        set txs(oe) {
          S.Message.setField(this, 1, oe);
        }
        static fromObject(oe) {
          const ne = new M({});
          return oe.txs != null && (ne.txs = oe.txs), ne;
        }
        toObject() {
          const oe = {};
          return this.txs != null && (oe.txs = this.txs), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.txs !== void 0 && ne.writeRepeatedBytes(1, this.txs), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new M();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                S.Message.addToRepeatedField(H, 1, ne.readBytes());
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return M.deserialize(oe);
        }
      }
      E.Data = M;
      class G extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("type" in oe && oe.type != null && (this.type = oe.type), "height" in oe && oe.height != null && (this.height = oe.height), "round" in oe && oe.round != null && (this.round = oe.round), "block_id" in oe && oe.block_id != null && (this.block_id = oe.block_id), "timestamp" in oe && oe.timestamp != null && (this.timestamp = oe.timestamp), "validator_address" in oe && oe.validator_address != null && (this.validator_address = oe.validator_address), "validator_index" in oe && oe.validator_index != null && (this.validator_index = oe.validator_index), "signature" in oe && oe.signature != null && (this.signature = oe.signature));
        }
        get type() {
          return S.Message.getField(this, 1);
        }
        set type(oe) {
          S.Message.setField(this, 1, oe);
        }
        get height() {
          return S.Message.getField(this, 2);
        }
        set height(oe) {
          S.Message.setField(this, 2, oe);
        }
        get round() {
          return S.Message.getField(this, 3);
        }
        set round(oe) {
          S.Message.setField(this, 3, oe);
        }
        get block_id() {
          return S.Message.getWrapperField(this, y, 4);
        }
        set block_id(oe) {
          S.Message.setWrapperField(this, 4, oe);
        }
        get timestamp() {
          return S.Message.getWrapperField(this, c.google.protobuf.Timestamp, 5);
        }
        set timestamp(oe) {
          S.Message.setWrapperField(this, 5, oe);
        }
        get validator_address() {
          return S.Message.getField(this, 6);
        }
        set validator_address(oe) {
          S.Message.setField(this, 6, oe);
        }
        get validator_index() {
          return S.Message.getField(this, 7);
        }
        set validator_index(oe) {
          S.Message.setField(this, 7, oe);
        }
        get signature() {
          return S.Message.getField(this, 8);
        }
        set signature(oe) {
          S.Message.setField(this, 8, oe);
        }
        static fromObject(oe) {
          const ne = new G({});
          return oe.type != null && (ne.type = oe.type), oe.height != null && (ne.height = oe.height), oe.round != null && (ne.round = oe.round), oe.block_id != null && (ne.block_id = y.fromObject(oe.block_id)), oe.timestamp != null && (ne.timestamp = c.google.protobuf.Timestamp.fromObject(oe.timestamp)), oe.validator_address != null && (ne.validator_address = oe.validator_address), oe.validator_index != null && (ne.validator_index = oe.validator_index), oe.signature != null && (ne.signature = oe.signature), ne;
        }
        toObject() {
          const oe = {};
          return this.type != null && (oe.type = this.type), this.height != null && (oe.height = this.height), this.round != null && (oe.round = this.round), this.block_id != null && (oe.block_id = this.block_id.toObject()), this.timestamp != null && (oe.timestamp = this.timestamp.toObject()), this.validator_address != null && (oe.validator_address = this.validator_address), this.validator_index != null && (oe.validator_index = this.validator_index), this.signature != null && (oe.signature = this.signature), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.type !== void 0 && ne.writeEnum(1, this.type), this.height !== void 0 && ne.writeInt64(2, this.height), this.round !== void 0 && ne.writeInt32(3, this.round), this.block_id !== void 0 && ne.writeMessage(4, this.block_id, () => this.block_id.serialize(ne)), this.timestamp !== void 0 && ne.writeMessage(5, this.timestamp, () => this.timestamp.serialize(ne)), this.validator_address !== void 0 && ne.writeBytes(6, this.validator_address), this.validator_index !== void 0 && ne.writeInt32(7, this.validator_index), this.signature !== void 0 && ne.writeBytes(8, this.signature), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new G();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                H.type = ne.readEnum();
                break;
              case 2:
                H.height = ne.readInt64();
                break;
              case 3:
                H.round = ne.readInt32();
                break;
              case 4:
                ne.readMessage(H.block_id, () => H.block_id = y.deserialize(ne));
                break;
              case 5:
                ne.readMessage(H.timestamp, () => H.timestamp = c.google.protobuf.Timestamp.deserialize(ne));
                break;
              case 6:
                H.validator_address = ne.readBytes();
                break;
              case 7:
                H.validator_index = ne.readInt32();
                break;
              case 8:
                H.signature = ne.readBytes();
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return G.deserialize(oe);
        }
      }
      E.Vote = G;
      class k extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [4], []), !Array.isArray(oe) && typeof oe == "object" && ("height" in oe && oe.height != null && (this.height = oe.height), "round" in oe && oe.round != null && (this.round = oe.round), "block_id" in oe && oe.block_id != null && (this.block_id = oe.block_id), "signatures" in oe && oe.signatures != null && (this.signatures = oe.signatures));
        }
        get height() {
          return S.Message.getField(this, 1);
        }
        set height(oe) {
          S.Message.setField(this, 1, oe);
        }
        get round() {
          return S.Message.getField(this, 2);
        }
        set round(oe) {
          S.Message.setField(this, 2, oe);
        }
        get block_id() {
          return S.Message.getWrapperField(this, y, 3);
        }
        set block_id(oe) {
          S.Message.setWrapperField(this, 3, oe);
        }
        get signatures() {
          return S.Message.getRepeatedWrapperField(this, F, 4);
        }
        set signatures(oe) {
          S.Message.setRepeatedWrapperField(this, 4, oe);
        }
        static fromObject(oe) {
          const ne = new k({});
          return oe.height != null && (ne.height = oe.height), oe.round != null && (ne.round = oe.round), oe.block_id != null && (ne.block_id = y.fromObject(oe.block_id)), oe.signatures != null && (ne.signatures = oe.signatures.map((H) => F.fromObject(H))), ne;
        }
        toObject() {
          const oe = {};
          return this.height != null && (oe.height = this.height), this.round != null && (oe.round = this.round), this.block_id != null && (oe.block_id = this.block_id.toObject()), this.signatures != null && (oe.signatures = this.signatures.map((ne) => ne.toObject())), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.height !== void 0 && ne.writeInt64(1, this.height), this.round !== void 0 && ne.writeInt32(2, this.round), this.block_id !== void 0 && ne.writeMessage(3, this.block_id, () => this.block_id.serialize(ne)), this.signatures !== void 0 && ne.writeRepeatedMessage(4, this.signatures, (H) => H.serialize(ne)), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new k();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                H.height = ne.readInt64();
                break;
              case 2:
                H.round = ne.readInt32();
                break;
              case 3:
                ne.readMessage(H.block_id, () => H.block_id = y.deserialize(ne));
                break;
              case 4:
                ne.readMessage(H.signatures, () => S.Message.addToRepeatedWrapperField(H, 4, F.deserialize(ne), F));
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return k.deserialize(oe);
        }
      }
      E.Commit = k;
      class F extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("block_id_flag" in oe && oe.block_id_flag != null && (this.block_id_flag = oe.block_id_flag), "validator_address" in oe && oe.validator_address != null && (this.validator_address = oe.validator_address), "timestamp" in oe && oe.timestamp != null && (this.timestamp = oe.timestamp), "signature" in oe && oe.signature != null && (this.signature = oe.signature));
        }
        get block_id_flag() {
          return S.Message.getField(this, 1);
        }
        set block_id_flag(oe) {
          S.Message.setField(this, 1, oe);
        }
        get validator_address() {
          return S.Message.getField(this, 2);
        }
        set validator_address(oe) {
          S.Message.setField(this, 2, oe);
        }
        get timestamp() {
          return S.Message.getWrapperField(this, c.google.protobuf.Timestamp, 3);
        }
        set timestamp(oe) {
          S.Message.setWrapperField(this, 3, oe);
        }
        get signature() {
          return S.Message.getField(this, 4);
        }
        set signature(oe) {
          S.Message.setField(this, 4, oe);
        }
        static fromObject(oe) {
          const ne = new F({});
          return oe.block_id_flag != null && (ne.block_id_flag = oe.block_id_flag), oe.validator_address != null && (ne.validator_address = oe.validator_address), oe.timestamp != null && (ne.timestamp = c.google.protobuf.Timestamp.fromObject(oe.timestamp)), oe.signature != null && (ne.signature = oe.signature), ne;
        }
        toObject() {
          const oe = {};
          return this.block_id_flag != null && (oe.block_id_flag = this.block_id_flag), this.validator_address != null && (oe.validator_address = this.validator_address), this.timestamp != null && (oe.timestamp = this.timestamp.toObject()), this.signature != null && (oe.signature = this.signature), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.block_id_flag !== void 0 && ne.writeEnum(1, this.block_id_flag), this.validator_address !== void 0 && ne.writeBytes(2, this.validator_address), this.timestamp !== void 0 && ne.writeMessage(3, this.timestamp, () => this.timestamp.serialize(ne)), this.signature !== void 0 && ne.writeBytes(4, this.signature), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new F();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                H.block_id_flag = ne.readEnum();
                break;
              case 2:
                H.validator_address = ne.readBytes();
                break;
              case 3:
                ne.readMessage(H.timestamp, () => H.timestamp = c.google.protobuf.Timestamp.deserialize(ne));
                break;
              case 4:
                H.signature = ne.readBytes();
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return F.deserialize(oe);
        }
      }
      E.CommitSig = F;
      class X extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("type" in oe && oe.type != null && (this.type = oe.type), "height" in oe && oe.height != null && (this.height = oe.height), "round" in oe && oe.round != null && (this.round = oe.round), "pol_round" in oe && oe.pol_round != null && (this.pol_round = oe.pol_round), "block_id" in oe && oe.block_id != null && (this.block_id = oe.block_id), "timestamp" in oe && oe.timestamp != null && (this.timestamp = oe.timestamp), "signature" in oe && oe.signature != null && (this.signature = oe.signature));
        }
        get type() {
          return S.Message.getField(this, 1);
        }
        set type(oe) {
          S.Message.setField(this, 1, oe);
        }
        get height() {
          return S.Message.getField(this, 2);
        }
        set height(oe) {
          S.Message.setField(this, 2, oe);
        }
        get round() {
          return S.Message.getField(this, 3);
        }
        set round(oe) {
          S.Message.setField(this, 3, oe);
        }
        get pol_round() {
          return S.Message.getField(this, 4);
        }
        set pol_round(oe) {
          S.Message.setField(this, 4, oe);
        }
        get block_id() {
          return S.Message.getWrapperField(this, y, 5);
        }
        set block_id(oe) {
          S.Message.setWrapperField(this, 5, oe);
        }
        get timestamp() {
          return S.Message.getWrapperField(this, c.google.protobuf.Timestamp, 6);
        }
        set timestamp(oe) {
          S.Message.setWrapperField(this, 6, oe);
        }
        get signature() {
          return S.Message.getField(this, 7);
        }
        set signature(oe) {
          S.Message.setField(this, 7, oe);
        }
        static fromObject(oe) {
          const ne = new X({});
          return oe.type != null && (ne.type = oe.type), oe.height != null && (ne.height = oe.height), oe.round != null && (ne.round = oe.round), oe.pol_round != null && (ne.pol_round = oe.pol_round), oe.block_id != null && (ne.block_id = y.fromObject(oe.block_id)), oe.timestamp != null && (ne.timestamp = c.google.protobuf.Timestamp.fromObject(oe.timestamp)), oe.signature != null && (ne.signature = oe.signature), ne;
        }
        toObject() {
          const oe = {};
          return this.type != null && (oe.type = this.type), this.height != null && (oe.height = this.height), this.round != null && (oe.round = this.round), this.pol_round != null && (oe.pol_round = this.pol_round), this.block_id != null && (oe.block_id = this.block_id.toObject()), this.timestamp != null && (oe.timestamp = this.timestamp.toObject()), this.signature != null && (oe.signature = this.signature), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.type !== void 0 && ne.writeEnum(1, this.type), this.height !== void 0 && ne.writeInt64(2, this.height), this.round !== void 0 && ne.writeInt32(3, this.round), this.pol_round !== void 0 && ne.writeInt32(4, this.pol_round), this.block_id !== void 0 && ne.writeMessage(5, this.block_id, () => this.block_id.serialize(ne)), this.timestamp !== void 0 && ne.writeMessage(6, this.timestamp, () => this.timestamp.serialize(ne)), this.signature !== void 0 && ne.writeBytes(7, this.signature), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new X();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                H.type = ne.readEnum();
                break;
              case 2:
                H.height = ne.readInt64();
                break;
              case 3:
                H.round = ne.readInt32();
                break;
              case 4:
                H.pol_round = ne.readInt32();
                break;
              case 5:
                ne.readMessage(H.block_id, () => H.block_id = y.deserialize(ne));
                break;
              case 6:
                ne.readMessage(H.timestamp, () => H.timestamp = c.google.protobuf.Timestamp.deserialize(ne));
                break;
              case 7:
                H.signature = ne.readBytes();
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return X.deserialize(oe);
        }
      }
      E.Proposal = X;
      class ee extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("header" in oe && oe.header != null && (this.header = oe.header), "commit" in oe && oe.commit != null && (this.commit = oe.commit));
        }
        get header() {
          return S.Message.getWrapperField(this, V, 1);
        }
        set header(oe) {
          S.Message.setWrapperField(this, 1, oe);
        }
        get commit() {
          return S.Message.getWrapperField(this, k, 2);
        }
        set commit(oe) {
          S.Message.setWrapperField(this, 2, oe);
        }
        static fromObject(oe) {
          const ne = new ee({});
          return oe.header != null && (ne.header = V.fromObject(oe.header)), oe.commit != null && (ne.commit = k.fromObject(oe.commit)), ne;
        }
        toObject() {
          const oe = {};
          return this.header != null && (oe.header = this.header.toObject()), this.commit != null && (oe.commit = this.commit.toObject()), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.header !== void 0 && ne.writeMessage(1, this.header, () => this.header.serialize(ne)), this.commit !== void 0 && ne.writeMessage(2, this.commit, () => this.commit.serialize(ne)), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new ee();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                ne.readMessage(H.header, () => H.header = V.deserialize(ne));
                break;
              case 2:
                ne.readMessage(H.commit, () => H.commit = k.deserialize(ne));
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return ee.deserialize(oe);
        }
      }
      E.SignedHeader = ee;
      class ue extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("signed_header" in oe && oe.signed_header != null && (this.signed_header = oe.signed_header), "validator_set" in oe && oe.validator_set != null && (this.validator_set = oe.validator_set));
        }
        get signed_header() {
          return S.Message.getWrapperField(this, ee, 1);
        }
        set signed_header(oe) {
          S.Message.setWrapperField(this, 1, oe);
        }
        get validator_set() {
          return S.Message.getWrapperField(this, v.tendermint.types.ValidatorSet, 2);
        }
        set validator_set(oe) {
          S.Message.setWrapperField(this, 2, oe);
        }
        static fromObject(oe) {
          const ne = new ue({});
          return oe.signed_header != null && (ne.signed_header = ee.fromObject(oe.signed_header)), oe.validator_set != null && (ne.validator_set = v.tendermint.types.ValidatorSet.fromObject(oe.validator_set)), ne;
        }
        toObject() {
          const oe = {};
          return this.signed_header != null && (oe.signed_header = this.signed_header.toObject()), this.validator_set != null && (oe.validator_set = this.validator_set.toObject()), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.signed_header !== void 0 && ne.writeMessage(1, this.signed_header, () => this.signed_header.serialize(ne)), this.validator_set !== void 0 && ne.writeMessage(2, this.validator_set, () => this.validator_set.serialize(ne)), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new ue();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                ne.readMessage(H.signed_header, () => H.signed_header = ee.deserialize(ne));
                break;
              case 2:
                ne.readMessage(H.validator_set, () => H.validator_set = v.tendermint.types.ValidatorSet.deserialize(ne));
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return ue.deserialize(oe);
        }
      }
      E.LightBlock = ue;
      class Q extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("block_id" in oe && oe.block_id != null && (this.block_id = oe.block_id), "block_size" in oe && oe.block_size != null && (this.block_size = oe.block_size), "header" in oe && oe.header != null && (this.header = oe.header), "num_txs" in oe && oe.num_txs != null && (this.num_txs = oe.num_txs));
        }
        get block_id() {
          return S.Message.getWrapperField(this, y, 1);
        }
        set block_id(oe) {
          S.Message.setWrapperField(this, 1, oe);
        }
        get block_size() {
          return S.Message.getField(this, 2);
        }
        set block_size(oe) {
          S.Message.setField(this, 2, oe);
        }
        get header() {
          return S.Message.getWrapperField(this, V, 3);
        }
        set header(oe) {
          S.Message.setWrapperField(this, 3, oe);
        }
        get num_txs() {
          return S.Message.getField(this, 4);
        }
        set num_txs(oe) {
          S.Message.setField(this, 4, oe);
        }
        static fromObject(oe) {
          const ne = new Q({});
          return oe.block_id != null && (ne.block_id = y.fromObject(oe.block_id)), oe.block_size != null && (ne.block_size = oe.block_size), oe.header != null && (ne.header = V.fromObject(oe.header)), oe.num_txs != null && (ne.num_txs = oe.num_txs), ne;
        }
        toObject() {
          const oe = {};
          return this.block_id != null && (oe.block_id = this.block_id.toObject()), this.block_size != null && (oe.block_size = this.block_size), this.header != null && (oe.header = this.header.toObject()), this.num_txs != null && (oe.num_txs = this.num_txs), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.block_id !== void 0 && ne.writeMessage(1, this.block_id, () => this.block_id.serialize(ne)), this.block_size !== void 0 && ne.writeInt64(2, this.block_size), this.header !== void 0 && ne.writeMessage(3, this.header, () => this.header.serialize(ne)), this.num_txs !== void 0 && ne.writeInt64(4, this.num_txs), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new Q();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                ne.readMessage(H.block_id, () => H.block_id = y.deserialize(ne));
                break;
              case 2:
                H.block_size = ne.readInt64();
                break;
              case 3:
                ne.readMessage(H.header, () => H.header = V.deserialize(ne));
                break;
              case 4:
                H.num_txs = ne.readInt64();
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return Q.deserialize(oe);
        }
      }
      E.BlockMeta = Q;
      class Y extends S.Message {
        constructor(oe) {
          super(), S.Message.initialize(this, Array.isArray(oe) ? oe : [], 0, -1, [], []), !Array.isArray(oe) && typeof oe == "object" && ("root_hash" in oe && oe.root_hash != null && (this.root_hash = oe.root_hash), "data" in oe && oe.data != null && (this.data = oe.data), "proof" in oe && oe.proof != null && (this.proof = oe.proof));
        }
        get root_hash() {
          return S.Message.getField(this, 1);
        }
        set root_hash(oe) {
          S.Message.setField(this, 1, oe);
        }
        get data() {
          return S.Message.getField(this, 2);
        }
        set data(oe) {
          S.Message.setField(this, 2, oe);
        }
        get proof() {
          return S.Message.getWrapperField(this, d.tendermint.crypto.Proof, 3);
        }
        set proof(oe) {
          S.Message.setWrapperField(this, 3, oe);
        }
        static fromObject(oe) {
          const ne = new Y({});
          return oe.root_hash != null && (ne.root_hash = oe.root_hash), oe.data != null && (ne.data = oe.data), oe.proof != null && (ne.proof = d.tendermint.crypto.Proof.fromObject(oe.proof)), ne;
        }
        toObject() {
          const oe = {};
          return this.root_hash != null && (oe.root_hash = this.root_hash), this.data != null && (oe.data = this.data), this.proof != null && (oe.proof = this.proof.toObject()), oe;
        }
        serialize(oe) {
          const ne = oe || new S.BinaryWriter();
          if (this.root_hash !== void 0 && ne.writeBytes(1, this.root_hash), this.data !== void 0 && ne.writeBytes(2, this.data), this.proof !== void 0 && ne.writeMessage(3, this.proof, () => this.proof.serialize(ne)), !oe)
            return ne.getResultBuffer();
        }
        static deserialize(oe) {
          const ne = oe instanceof S.BinaryReader ? oe : new S.BinaryReader(oe), H = new Y();
          for (; ne.nextField() && !ne.isEndGroup(); )
            switch (ne.getFieldNumber()) {
              case 1:
                H.root_hash = ne.readBytes();
                break;
              case 2:
                H.data = ne.readBytes();
                break;
              case 3:
                ne.readMessage(H.proof, () => H.proof = d.tendermint.crypto.Proof.deserialize(ne));
                break;
              default:
                ne.skipField();
            }
          return H;
        }
        serializeBinary() {
          return this.serialize();
        }
        static deserializeBinary(oe) {
          return Y.deserialize(oe);
        }
      }
      E.TxProof = Y;
    })($.types || ($.types = {}));
  })(e.tendermint || (e.tendermint = {}));
})(types$4);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(E, O, T, y) {
    y === void 0 && (y = T);
    var V = Object.getOwnPropertyDescriptor(O, T);
    (!V || ("get" in V ? !O.__esModule : V.writable || V.configurable)) && (V = { enumerable: !0, get: function() {
      return O[T];
    } }), Object.defineProperty(E, y, V);
  } : function(E, O, T, y) {
    y === void 0 && (y = T), E[y] = O[T];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(E, O) {
    Object.defineProperty(E, "default", { enumerable: !0, value: O });
  } : function(E, O) {
    E.default = O;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(E) {
    if (E && E.__esModule)
      return E;
    var O = {};
    if (E != null)
      for (var T in E)
        T !== "default" && Object.prototype.hasOwnProperty.call(E, T) && n(O, E, T);
    return o(O, E), O;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(any), d = u(duration), m = u(timestamp), v = u(coin$6), S = u(types$4), $ = u(googleProtobuf);
  (function(E) {
    (function(O) {
      (function(T) {
        (function(fe) {
          fe[fe.BOND_STATUS_UNSPECIFIED = 0] = "BOND_STATUS_UNSPECIFIED", fe[fe.BOND_STATUS_UNBONDED = 1] = "BOND_STATUS_UNBONDED", fe[fe.BOND_STATUS_UNBONDING = 2] = "BOND_STATUS_UNBONDING", fe[fe.BOND_STATUS_BONDED = 3] = "BOND_STATUS_BONDED";
        })(T.BondStatus || (T.BondStatus = {}));
        class y extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [2], []), !Array.isArray(N) && typeof N == "object" && ("header" in N && N.header != null && (this.header = N.header), "valset" in N && N.valset != null && (this.valset = N.valset));
          }
          get header() {
            return $.Message.getWrapperField(this, S.tendermint.types.Header, 1);
          }
          set header(N) {
            $.Message.setWrapperField(this, 1, N);
          }
          get valset() {
            return $.Message.getRepeatedWrapperField(this, k, 2);
          }
          set valset(N) {
            $.Message.setRepeatedWrapperField(this, 2, N);
          }
          static fromObject(N) {
            const W = new y({});
            return N.header != null && (W.header = S.tendermint.types.Header.fromObject(N.header)), N.valset != null && (W.valset = N.valset.map((I) => k.fromObject(I))), W;
          }
          toObject() {
            const N = {};
            return this.header != null && (N.header = this.header.toObject()), this.valset != null && (N.valset = this.valset.map((W) => W.toObject())), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.header !== void 0 && W.writeMessage(1, this.header, () => this.header.serialize(W)), this.valset !== void 0 && W.writeRepeatedMessage(2, this.valset, (I) => I.serialize(W)), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new y();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  W.readMessage(I.header, () => I.header = S.tendermint.types.Header.deserialize(W));
                  break;
                case 2:
                  W.readMessage(I.valset, () => $.Message.addToRepeatedWrapperField(I, 2, k.deserialize(W), k));
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return y.deserialize(N);
          }
        }
        T.HistoricalInfo = y;
        class V extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("rate" in N && N.rate != null && (this.rate = N.rate), "max_rate" in N && N.max_rate != null && (this.max_rate = N.max_rate), "max_change_rate" in N && N.max_change_rate != null && (this.max_change_rate = N.max_change_rate));
          }
          get rate() {
            return $.Message.getField(this, 1);
          }
          set rate(N) {
            $.Message.setField(this, 1, N);
          }
          get max_rate() {
            return $.Message.getField(this, 2);
          }
          set max_rate(N) {
            $.Message.setField(this, 2, N);
          }
          get max_change_rate() {
            return $.Message.getField(this, 3);
          }
          set max_change_rate(N) {
            $.Message.setField(this, 3, N);
          }
          static fromObject(N) {
            const W = new V({});
            return N.rate != null && (W.rate = N.rate), N.max_rate != null && (W.max_rate = N.max_rate), N.max_change_rate != null && (W.max_change_rate = N.max_change_rate), W;
          }
          toObject() {
            const N = {};
            return this.rate != null && (N.rate = this.rate), this.max_rate != null && (N.max_rate = this.max_rate), this.max_change_rate != null && (N.max_change_rate = this.max_change_rate), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.rate == "string" && this.rate.length && W.writeString(1, this.rate), typeof this.max_rate == "string" && this.max_rate.length && W.writeString(2, this.max_rate), typeof this.max_change_rate == "string" && this.max_change_rate.length && W.writeString(3, this.max_change_rate), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new V();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.rate = W.readString();
                  break;
                case 2:
                  I.max_rate = W.readString();
                  break;
                case 3:
                  I.max_change_rate = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return V.deserialize(N);
          }
        }
        T.CommissionRates = V;
        class M extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("commission_rates" in N && N.commission_rates != null && (this.commission_rates = N.commission_rates), "update_time" in N && N.update_time != null && (this.update_time = N.update_time));
          }
          get commission_rates() {
            return $.Message.getWrapperField(this, V, 1);
          }
          set commission_rates(N) {
            $.Message.setWrapperField(this, 1, N);
          }
          get update_time() {
            return $.Message.getWrapperField(this, m.google.protobuf.Timestamp, 2);
          }
          set update_time(N) {
            $.Message.setWrapperField(this, 2, N);
          }
          static fromObject(N) {
            const W = new M({});
            return N.commission_rates != null && (W.commission_rates = V.fromObject(N.commission_rates)), N.update_time != null && (W.update_time = m.google.protobuf.Timestamp.fromObject(N.update_time)), W;
          }
          toObject() {
            const N = {};
            return this.commission_rates != null && (N.commission_rates = this.commission_rates.toObject()), this.update_time != null && (N.update_time = this.update_time.toObject()), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.commission_rates !== void 0 && W.writeMessage(1, this.commission_rates, () => this.commission_rates.serialize(W)), this.update_time !== void 0 && W.writeMessage(2, this.update_time, () => this.update_time.serialize(W)), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new M();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  W.readMessage(I.commission_rates, () => I.commission_rates = V.deserialize(W));
                  break;
                case 2:
                  W.readMessage(I.update_time, () => I.update_time = m.google.protobuf.Timestamp.deserialize(W));
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return M.deserialize(N);
          }
        }
        T.Commission = M;
        class G extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("moniker" in N && N.moniker != null && (this.moniker = N.moniker), "identity" in N && N.identity != null && (this.identity = N.identity), "website" in N && N.website != null && (this.website = N.website), "security_contact" in N && N.security_contact != null && (this.security_contact = N.security_contact), "details" in N && N.details != null && (this.details = N.details));
          }
          get moniker() {
            return $.Message.getField(this, 1);
          }
          set moniker(N) {
            $.Message.setField(this, 1, N);
          }
          get identity() {
            return $.Message.getField(this, 2);
          }
          set identity(N) {
            $.Message.setField(this, 2, N);
          }
          get website() {
            return $.Message.getField(this, 3);
          }
          set website(N) {
            $.Message.setField(this, 3, N);
          }
          get security_contact() {
            return $.Message.getField(this, 4);
          }
          set security_contact(N) {
            $.Message.setField(this, 4, N);
          }
          get details() {
            return $.Message.getField(this, 5);
          }
          set details(N) {
            $.Message.setField(this, 5, N);
          }
          static fromObject(N) {
            const W = new G({});
            return N.moniker != null && (W.moniker = N.moniker), N.identity != null && (W.identity = N.identity), N.website != null && (W.website = N.website), N.security_contact != null && (W.security_contact = N.security_contact), N.details != null && (W.details = N.details), W;
          }
          toObject() {
            const N = {};
            return this.moniker != null && (N.moniker = this.moniker), this.identity != null && (N.identity = this.identity), this.website != null && (N.website = this.website), this.security_contact != null && (N.security_contact = this.security_contact), this.details != null && (N.details = this.details), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.moniker == "string" && this.moniker.length && W.writeString(1, this.moniker), typeof this.identity == "string" && this.identity.length && W.writeString(2, this.identity), typeof this.website == "string" && this.website.length && W.writeString(3, this.website), typeof this.security_contact == "string" && this.security_contact.length && W.writeString(4, this.security_contact), typeof this.details == "string" && this.details.length && W.writeString(5, this.details), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new G();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.moniker = W.readString();
                  break;
                case 2:
                  I.identity = W.readString();
                  break;
                case 3:
                  I.website = W.readString();
                  break;
                case 4:
                  I.security_contact = W.readString();
                  break;
                case 5:
                  I.details = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return G.deserialize(N);
          }
        }
        T.Description = G;
        class k extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("operator_address" in N && N.operator_address != null && (this.operator_address = N.operator_address), "consensus_pubkey" in N && N.consensus_pubkey != null && (this.consensus_pubkey = N.consensus_pubkey), "jailed" in N && N.jailed != null && (this.jailed = N.jailed), "status" in N && N.status != null && (this.status = N.status), "tokens" in N && N.tokens != null && (this.tokens = N.tokens), "delegator_shares" in N && N.delegator_shares != null && (this.delegator_shares = N.delegator_shares), "description" in N && N.description != null && (this.description = N.description), "unbonding_height" in N && N.unbonding_height != null && (this.unbonding_height = N.unbonding_height), "unbonding_time" in N && N.unbonding_time != null && (this.unbonding_time = N.unbonding_time), "commission" in N && N.commission != null && (this.commission = N.commission), "min_self_delegation" in N && N.min_self_delegation != null && (this.min_self_delegation = N.min_self_delegation));
          }
          get operator_address() {
            return $.Message.getField(this, 1);
          }
          set operator_address(N) {
            $.Message.setField(this, 1, N);
          }
          get consensus_pubkey() {
            return $.Message.getWrapperField(this, c.google.protobuf.Any, 2);
          }
          set consensus_pubkey(N) {
            $.Message.setWrapperField(this, 2, N);
          }
          get jailed() {
            return $.Message.getField(this, 3);
          }
          set jailed(N) {
            $.Message.setField(this, 3, N);
          }
          get status() {
            return $.Message.getField(this, 4);
          }
          set status(N) {
            $.Message.setField(this, 4, N);
          }
          get tokens() {
            return $.Message.getField(this, 5);
          }
          set tokens(N) {
            $.Message.setField(this, 5, N);
          }
          get delegator_shares() {
            return $.Message.getField(this, 6);
          }
          set delegator_shares(N) {
            $.Message.setField(this, 6, N);
          }
          get description() {
            return $.Message.getWrapperField(this, G, 7);
          }
          set description(N) {
            $.Message.setWrapperField(this, 7, N);
          }
          get unbonding_height() {
            return $.Message.getField(this, 8);
          }
          set unbonding_height(N) {
            $.Message.setField(this, 8, N);
          }
          get unbonding_time() {
            return $.Message.getWrapperField(this, m.google.protobuf.Timestamp, 9);
          }
          set unbonding_time(N) {
            $.Message.setWrapperField(this, 9, N);
          }
          get commission() {
            return $.Message.getWrapperField(this, M, 10);
          }
          set commission(N) {
            $.Message.setWrapperField(this, 10, N);
          }
          get min_self_delegation() {
            return $.Message.getField(this, 11);
          }
          set min_self_delegation(N) {
            $.Message.setField(this, 11, N);
          }
          static fromObject(N) {
            const W = new k({});
            return N.operator_address != null && (W.operator_address = N.operator_address), N.consensus_pubkey != null && (W.consensus_pubkey = c.google.protobuf.Any.fromObject(N.consensus_pubkey)), N.jailed != null && (W.jailed = N.jailed), N.status != null && (W.status = N.status), N.tokens != null && (W.tokens = N.tokens), N.delegator_shares != null && (W.delegator_shares = N.delegator_shares), N.description != null && (W.description = G.fromObject(N.description)), N.unbonding_height != null && (W.unbonding_height = N.unbonding_height), N.unbonding_time != null && (W.unbonding_time = m.google.protobuf.Timestamp.fromObject(N.unbonding_time)), N.commission != null && (W.commission = M.fromObject(N.commission)), N.min_self_delegation != null && (W.min_self_delegation = N.min_self_delegation), W;
          }
          toObject() {
            const N = {};
            return this.operator_address != null && (N.operator_address = this.operator_address), this.consensus_pubkey != null && (N.consensus_pubkey = this.consensus_pubkey.toObject()), this.jailed != null && (N.jailed = this.jailed), this.status != null && (N.status = this.status), this.tokens != null && (N.tokens = this.tokens), this.delegator_shares != null && (N.delegator_shares = this.delegator_shares), this.description != null && (N.description = this.description.toObject()), this.unbonding_height != null && (N.unbonding_height = this.unbonding_height), this.unbonding_time != null && (N.unbonding_time = this.unbonding_time.toObject()), this.commission != null && (N.commission = this.commission.toObject()), this.min_self_delegation != null && (N.min_self_delegation = this.min_self_delegation), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.operator_address == "string" && this.operator_address.length && W.writeString(1, this.operator_address), this.consensus_pubkey !== void 0 && W.writeMessage(2, this.consensus_pubkey, () => this.consensus_pubkey.serialize(W)), this.jailed !== void 0 && W.writeBool(3, this.jailed), this.status !== void 0 && W.writeEnum(4, this.status), typeof this.tokens == "string" && this.tokens.length && W.writeString(5, this.tokens), typeof this.delegator_shares == "string" && this.delegator_shares.length && W.writeString(6, this.delegator_shares), this.description !== void 0 && W.writeMessage(7, this.description, () => this.description.serialize(W)), this.unbonding_height !== void 0 && W.writeInt64(8, this.unbonding_height), this.unbonding_time !== void 0 && W.writeMessage(9, this.unbonding_time, () => this.unbonding_time.serialize(W)), this.commission !== void 0 && W.writeMessage(10, this.commission, () => this.commission.serialize(W)), typeof this.min_self_delegation == "string" && this.min_self_delegation.length && W.writeString(11, this.min_self_delegation), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new k();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.operator_address = W.readString();
                  break;
                case 2:
                  W.readMessage(I.consensus_pubkey, () => I.consensus_pubkey = c.google.protobuf.Any.deserialize(W));
                  break;
                case 3:
                  I.jailed = W.readBool();
                  break;
                case 4:
                  I.status = W.readEnum();
                  break;
                case 5:
                  I.tokens = W.readString();
                  break;
                case 6:
                  I.delegator_shares = W.readString();
                  break;
                case 7:
                  W.readMessage(I.description, () => I.description = G.deserialize(W));
                  break;
                case 8:
                  I.unbonding_height = W.readInt64();
                  break;
                case 9:
                  W.readMessage(I.unbonding_time, () => I.unbonding_time = m.google.protobuf.Timestamp.deserialize(W));
                  break;
                case 10:
                  W.readMessage(I.commission, () => I.commission = M.deserialize(W));
                  break;
                case 11:
                  I.min_self_delegation = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return k.deserialize(N);
          }
        }
        T.Validator = k;
        class F extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [1], []), !Array.isArray(N) && typeof N == "object" && "addresses" in N && N.addresses != null && (this.addresses = N.addresses);
          }
          get addresses() {
            return $.Message.getField(this, 1);
          }
          set addresses(N) {
            $.Message.setField(this, 1, N);
          }
          static fromObject(N) {
            const W = new F({});
            return N.addresses != null && (W.addresses = N.addresses), W;
          }
          toObject() {
            const N = {};
            return this.addresses != null && (N.addresses = this.addresses), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.addresses !== void 0 && W.writeRepeatedString(1, this.addresses), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new F();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  $.Message.addToRepeatedField(I, 1, W.readString());
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return F.deserialize(N);
          }
        }
        T.ValAddresses = F;
        class X extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("delegator_address" in N && N.delegator_address != null && (this.delegator_address = N.delegator_address), "validator_address" in N && N.validator_address != null && (this.validator_address = N.validator_address));
          }
          get delegator_address() {
            return $.Message.getField(this, 1);
          }
          set delegator_address(N) {
            $.Message.setField(this, 1, N);
          }
          get validator_address() {
            return $.Message.getField(this, 2);
          }
          set validator_address(N) {
            $.Message.setField(this, 2, N);
          }
          static fromObject(N) {
            const W = new X({});
            return N.delegator_address != null && (W.delegator_address = N.delegator_address), N.validator_address != null && (W.validator_address = N.validator_address), W;
          }
          toObject() {
            const N = {};
            return this.delegator_address != null && (N.delegator_address = this.delegator_address), this.validator_address != null && (N.validator_address = this.validator_address), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && W.writeString(1, this.delegator_address), typeof this.validator_address == "string" && this.validator_address.length && W.writeString(2, this.validator_address), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new X();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.delegator_address = W.readString();
                  break;
                case 2:
                  I.validator_address = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return X.deserialize(N);
          }
        }
        T.DVPair = X;
        class ee extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [1], []), !Array.isArray(N) && typeof N == "object" && "pairs" in N && N.pairs != null && (this.pairs = N.pairs);
          }
          get pairs() {
            return $.Message.getRepeatedWrapperField(this, X, 1);
          }
          set pairs(N) {
            $.Message.setRepeatedWrapperField(this, 1, N);
          }
          static fromObject(N) {
            const W = new ee({});
            return N.pairs != null && (W.pairs = N.pairs.map((I) => X.fromObject(I))), W;
          }
          toObject() {
            const N = {};
            return this.pairs != null && (N.pairs = this.pairs.map((W) => W.toObject())), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.pairs !== void 0 && W.writeRepeatedMessage(1, this.pairs, (I) => I.serialize(W)), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new ee();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  W.readMessage(I.pairs, () => $.Message.addToRepeatedWrapperField(I, 1, X.deserialize(W), X));
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return ee.deserialize(N);
          }
        }
        T.DVPairs = ee;
        class ue extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("delegator_address" in N && N.delegator_address != null && (this.delegator_address = N.delegator_address), "validator_src_address" in N && N.validator_src_address != null && (this.validator_src_address = N.validator_src_address), "validator_dst_address" in N && N.validator_dst_address != null && (this.validator_dst_address = N.validator_dst_address));
          }
          get delegator_address() {
            return $.Message.getField(this, 1);
          }
          set delegator_address(N) {
            $.Message.setField(this, 1, N);
          }
          get validator_src_address() {
            return $.Message.getField(this, 2);
          }
          set validator_src_address(N) {
            $.Message.setField(this, 2, N);
          }
          get validator_dst_address() {
            return $.Message.getField(this, 3);
          }
          set validator_dst_address(N) {
            $.Message.setField(this, 3, N);
          }
          static fromObject(N) {
            const W = new ue({});
            return N.delegator_address != null && (W.delegator_address = N.delegator_address), N.validator_src_address != null && (W.validator_src_address = N.validator_src_address), N.validator_dst_address != null && (W.validator_dst_address = N.validator_dst_address), W;
          }
          toObject() {
            const N = {};
            return this.delegator_address != null && (N.delegator_address = this.delegator_address), this.validator_src_address != null && (N.validator_src_address = this.validator_src_address), this.validator_dst_address != null && (N.validator_dst_address = this.validator_dst_address), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && W.writeString(1, this.delegator_address), typeof this.validator_src_address == "string" && this.validator_src_address.length && W.writeString(2, this.validator_src_address), typeof this.validator_dst_address == "string" && this.validator_dst_address.length && W.writeString(3, this.validator_dst_address), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new ue();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.delegator_address = W.readString();
                  break;
                case 2:
                  I.validator_src_address = W.readString();
                  break;
                case 3:
                  I.validator_dst_address = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return ue.deserialize(N);
          }
        }
        T.DVVTriplet = ue;
        class Q extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [1], []), !Array.isArray(N) && typeof N == "object" && "triplets" in N && N.triplets != null && (this.triplets = N.triplets);
          }
          get triplets() {
            return $.Message.getRepeatedWrapperField(this, ue, 1);
          }
          set triplets(N) {
            $.Message.setRepeatedWrapperField(this, 1, N);
          }
          static fromObject(N) {
            const W = new Q({});
            return N.triplets != null && (W.triplets = N.triplets.map((I) => ue.fromObject(I))), W;
          }
          toObject() {
            const N = {};
            return this.triplets != null && (N.triplets = this.triplets.map((W) => W.toObject())), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.triplets !== void 0 && W.writeRepeatedMessage(1, this.triplets, (I) => I.serialize(W)), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new Q();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  W.readMessage(I.triplets, () => $.Message.addToRepeatedWrapperField(I, 1, ue.deserialize(W), ue));
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return Q.deserialize(N);
          }
        }
        T.DVVTriplets = Q;
        class Y extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("delegator_address" in N && N.delegator_address != null && (this.delegator_address = N.delegator_address), "validator_address" in N && N.validator_address != null && (this.validator_address = N.validator_address), "shares" in N && N.shares != null && (this.shares = N.shares));
          }
          get delegator_address() {
            return $.Message.getField(this, 1);
          }
          set delegator_address(N) {
            $.Message.setField(this, 1, N);
          }
          get validator_address() {
            return $.Message.getField(this, 2);
          }
          set validator_address(N) {
            $.Message.setField(this, 2, N);
          }
          get shares() {
            return $.Message.getField(this, 3);
          }
          set shares(N) {
            $.Message.setField(this, 3, N);
          }
          static fromObject(N) {
            const W = new Y({});
            return N.delegator_address != null && (W.delegator_address = N.delegator_address), N.validator_address != null && (W.validator_address = N.validator_address), N.shares != null && (W.shares = N.shares), W;
          }
          toObject() {
            const N = {};
            return this.delegator_address != null && (N.delegator_address = this.delegator_address), this.validator_address != null && (N.validator_address = this.validator_address), this.shares != null && (N.shares = this.shares), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && W.writeString(1, this.delegator_address), typeof this.validator_address == "string" && this.validator_address.length && W.writeString(2, this.validator_address), typeof this.shares == "string" && this.shares.length && W.writeString(3, this.shares), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new Y();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.delegator_address = W.readString();
                  break;
                case 2:
                  I.validator_address = W.readString();
                  break;
                case 3:
                  I.shares = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return Y.deserialize(N);
          }
        }
        T.Delegation = Y;
        class pe extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [3], []), !Array.isArray(N) && typeof N == "object" && ("delegator_address" in N && N.delegator_address != null && (this.delegator_address = N.delegator_address), "validator_address" in N && N.validator_address != null && (this.validator_address = N.validator_address), "entries" in N && N.entries != null && (this.entries = N.entries));
          }
          get delegator_address() {
            return $.Message.getField(this, 1);
          }
          set delegator_address(N) {
            $.Message.setField(this, 1, N);
          }
          get validator_address() {
            return $.Message.getField(this, 2);
          }
          set validator_address(N) {
            $.Message.setField(this, 2, N);
          }
          get entries() {
            return $.Message.getRepeatedWrapperField(this, oe, 3);
          }
          set entries(N) {
            $.Message.setRepeatedWrapperField(this, 3, N);
          }
          static fromObject(N) {
            const W = new pe({});
            return N.delegator_address != null && (W.delegator_address = N.delegator_address), N.validator_address != null && (W.validator_address = N.validator_address), N.entries != null && (W.entries = N.entries.map((I) => oe.fromObject(I))), W;
          }
          toObject() {
            const N = {};
            return this.delegator_address != null && (N.delegator_address = this.delegator_address), this.validator_address != null && (N.validator_address = this.validator_address), this.entries != null && (N.entries = this.entries.map((W) => W.toObject())), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && W.writeString(1, this.delegator_address), typeof this.validator_address == "string" && this.validator_address.length && W.writeString(2, this.validator_address), this.entries !== void 0 && W.writeRepeatedMessage(3, this.entries, (I) => I.serialize(W)), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new pe();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.delegator_address = W.readString();
                  break;
                case 2:
                  I.validator_address = W.readString();
                  break;
                case 3:
                  W.readMessage(I.entries, () => $.Message.addToRepeatedWrapperField(I, 3, oe.deserialize(W), oe));
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return pe.deserialize(N);
          }
        }
        T.UnbondingDelegation = pe;
        class oe extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("creation_height" in N && N.creation_height != null && (this.creation_height = N.creation_height), "completion_time" in N && N.completion_time != null && (this.completion_time = N.completion_time), "initial_balance" in N && N.initial_balance != null && (this.initial_balance = N.initial_balance), "balance" in N && N.balance != null && (this.balance = N.balance));
          }
          get creation_height() {
            return $.Message.getField(this, 1);
          }
          set creation_height(N) {
            $.Message.setField(this, 1, N);
          }
          get completion_time() {
            return $.Message.getWrapperField(this, m.google.protobuf.Timestamp, 2);
          }
          set completion_time(N) {
            $.Message.setWrapperField(this, 2, N);
          }
          get initial_balance() {
            return $.Message.getField(this, 3);
          }
          set initial_balance(N) {
            $.Message.setField(this, 3, N);
          }
          get balance() {
            return $.Message.getField(this, 4);
          }
          set balance(N) {
            $.Message.setField(this, 4, N);
          }
          static fromObject(N) {
            const W = new oe({});
            return N.creation_height != null && (W.creation_height = N.creation_height), N.completion_time != null && (W.completion_time = m.google.protobuf.Timestamp.fromObject(N.completion_time)), N.initial_balance != null && (W.initial_balance = N.initial_balance), N.balance != null && (W.balance = N.balance), W;
          }
          toObject() {
            const N = {};
            return this.creation_height != null && (N.creation_height = this.creation_height), this.completion_time != null && (N.completion_time = this.completion_time.toObject()), this.initial_balance != null && (N.initial_balance = this.initial_balance), this.balance != null && (N.balance = this.balance), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.creation_height !== void 0 && W.writeInt64(1, this.creation_height), this.completion_time !== void 0 && W.writeMessage(2, this.completion_time, () => this.completion_time.serialize(W)), typeof this.initial_balance == "string" && this.initial_balance.length && W.writeString(3, this.initial_balance), typeof this.balance == "string" && this.balance.length && W.writeString(4, this.balance), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new oe();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.creation_height = W.readInt64();
                  break;
                case 2:
                  W.readMessage(I.completion_time, () => I.completion_time = m.google.protobuf.Timestamp.deserialize(W));
                  break;
                case 3:
                  I.initial_balance = W.readString();
                  break;
                case 4:
                  I.balance = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return oe.deserialize(N);
          }
        }
        T.UnbondingDelegationEntry = oe;
        class ne extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("creation_height" in N && N.creation_height != null && (this.creation_height = N.creation_height), "completion_time" in N && N.completion_time != null && (this.completion_time = N.completion_time), "initial_balance" in N && N.initial_balance != null && (this.initial_balance = N.initial_balance), "shares_dst" in N && N.shares_dst != null && (this.shares_dst = N.shares_dst));
          }
          get creation_height() {
            return $.Message.getField(this, 1);
          }
          set creation_height(N) {
            $.Message.setField(this, 1, N);
          }
          get completion_time() {
            return $.Message.getWrapperField(this, m.google.protobuf.Timestamp, 2);
          }
          set completion_time(N) {
            $.Message.setWrapperField(this, 2, N);
          }
          get initial_balance() {
            return $.Message.getField(this, 3);
          }
          set initial_balance(N) {
            $.Message.setField(this, 3, N);
          }
          get shares_dst() {
            return $.Message.getField(this, 4);
          }
          set shares_dst(N) {
            $.Message.setField(this, 4, N);
          }
          static fromObject(N) {
            const W = new ne({});
            return N.creation_height != null && (W.creation_height = N.creation_height), N.completion_time != null && (W.completion_time = m.google.protobuf.Timestamp.fromObject(N.completion_time)), N.initial_balance != null && (W.initial_balance = N.initial_balance), N.shares_dst != null && (W.shares_dst = N.shares_dst), W;
          }
          toObject() {
            const N = {};
            return this.creation_height != null && (N.creation_height = this.creation_height), this.completion_time != null && (N.completion_time = this.completion_time.toObject()), this.initial_balance != null && (N.initial_balance = this.initial_balance), this.shares_dst != null && (N.shares_dst = this.shares_dst), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.creation_height !== void 0 && W.writeInt64(1, this.creation_height), this.completion_time !== void 0 && W.writeMessage(2, this.completion_time, () => this.completion_time.serialize(W)), typeof this.initial_balance == "string" && this.initial_balance.length && W.writeString(3, this.initial_balance), typeof this.shares_dst == "string" && this.shares_dst.length && W.writeString(4, this.shares_dst), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new ne();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.creation_height = W.readInt64();
                  break;
                case 2:
                  W.readMessage(I.completion_time, () => I.completion_time = m.google.protobuf.Timestamp.deserialize(W));
                  break;
                case 3:
                  I.initial_balance = W.readString();
                  break;
                case 4:
                  I.shares_dst = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return ne.deserialize(N);
          }
        }
        T.RedelegationEntry = ne;
        class H extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [4], []), !Array.isArray(N) && typeof N == "object" && ("delegator_address" in N && N.delegator_address != null && (this.delegator_address = N.delegator_address), "validator_src_address" in N && N.validator_src_address != null && (this.validator_src_address = N.validator_src_address), "validator_dst_address" in N && N.validator_dst_address != null && (this.validator_dst_address = N.validator_dst_address), "entries" in N && N.entries != null && (this.entries = N.entries));
          }
          get delegator_address() {
            return $.Message.getField(this, 1);
          }
          set delegator_address(N) {
            $.Message.setField(this, 1, N);
          }
          get validator_src_address() {
            return $.Message.getField(this, 2);
          }
          set validator_src_address(N) {
            $.Message.setField(this, 2, N);
          }
          get validator_dst_address() {
            return $.Message.getField(this, 3);
          }
          set validator_dst_address(N) {
            $.Message.setField(this, 3, N);
          }
          get entries() {
            return $.Message.getRepeatedWrapperField(this, ne, 4);
          }
          set entries(N) {
            $.Message.setRepeatedWrapperField(this, 4, N);
          }
          static fromObject(N) {
            const W = new H({});
            return N.delegator_address != null && (W.delegator_address = N.delegator_address), N.validator_src_address != null && (W.validator_src_address = N.validator_src_address), N.validator_dst_address != null && (W.validator_dst_address = N.validator_dst_address), N.entries != null && (W.entries = N.entries.map((I) => ne.fromObject(I))), W;
          }
          toObject() {
            const N = {};
            return this.delegator_address != null && (N.delegator_address = this.delegator_address), this.validator_src_address != null && (N.validator_src_address = this.validator_src_address), this.validator_dst_address != null && (N.validator_dst_address = this.validator_dst_address), this.entries != null && (N.entries = this.entries.map((W) => W.toObject())), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && W.writeString(1, this.delegator_address), typeof this.validator_src_address == "string" && this.validator_src_address.length && W.writeString(2, this.validator_src_address), typeof this.validator_dst_address == "string" && this.validator_dst_address.length && W.writeString(3, this.validator_dst_address), this.entries !== void 0 && W.writeRepeatedMessage(4, this.entries, (I) => I.serialize(W)), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new H();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.delegator_address = W.readString();
                  break;
                case 2:
                  I.validator_src_address = W.readString();
                  break;
                case 3:
                  I.validator_dst_address = W.readString();
                  break;
                case 4:
                  W.readMessage(I.entries, () => $.Message.addToRepeatedWrapperField(I, 4, ne.deserialize(W), ne));
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return H.deserialize(N);
          }
        }
        T.Redelegation = H;
        class C extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("unbonding_time" in N && N.unbonding_time != null && (this.unbonding_time = N.unbonding_time), "max_validators" in N && N.max_validators != null && (this.max_validators = N.max_validators), "max_entries" in N && N.max_entries != null && (this.max_entries = N.max_entries), "historical_entries" in N && N.historical_entries != null && (this.historical_entries = N.historical_entries), "bond_denom" in N && N.bond_denom != null && (this.bond_denom = N.bond_denom));
          }
          get unbonding_time() {
            return $.Message.getWrapperField(this, d.google.protobuf.Duration, 1);
          }
          set unbonding_time(N) {
            $.Message.setWrapperField(this, 1, N);
          }
          get max_validators() {
            return $.Message.getField(this, 2);
          }
          set max_validators(N) {
            $.Message.setField(this, 2, N);
          }
          get max_entries() {
            return $.Message.getField(this, 3);
          }
          set max_entries(N) {
            $.Message.setField(this, 3, N);
          }
          get historical_entries() {
            return $.Message.getField(this, 4);
          }
          set historical_entries(N) {
            $.Message.setField(this, 4, N);
          }
          get bond_denom() {
            return $.Message.getField(this, 5);
          }
          set bond_denom(N) {
            $.Message.setField(this, 5, N);
          }
          static fromObject(N) {
            const W = new C({});
            return N.unbonding_time != null && (W.unbonding_time = d.google.protobuf.Duration.fromObject(N.unbonding_time)), N.max_validators != null && (W.max_validators = N.max_validators), N.max_entries != null && (W.max_entries = N.max_entries), N.historical_entries != null && (W.historical_entries = N.historical_entries), N.bond_denom != null && (W.bond_denom = N.bond_denom), W;
          }
          toObject() {
            const N = {};
            return this.unbonding_time != null && (N.unbonding_time = this.unbonding_time.toObject()), this.max_validators != null && (N.max_validators = this.max_validators), this.max_entries != null && (N.max_entries = this.max_entries), this.historical_entries != null && (N.historical_entries = this.historical_entries), this.bond_denom != null && (N.bond_denom = this.bond_denom), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.unbonding_time !== void 0 && W.writeMessage(1, this.unbonding_time, () => this.unbonding_time.serialize(W)), this.max_validators !== void 0 && W.writeUint32(2, this.max_validators), this.max_entries !== void 0 && W.writeUint32(3, this.max_entries), this.historical_entries !== void 0 && W.writeUint32(4, this.historical_entries), typeof this.bond_denom == "string" && this.bond_denom.length && W.writeString(5, this.bond_denom), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new C();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  W.readMessage(I.unbonding_time, () => I.unbonding_time = d.google.protobuf.Duration.deserialize(W));
                  break;
                case 2:
                  I.max_validators = W.readUint32();
                  break;
                case 3:
                  I.max_entries = W.readUint32();
                  break;
                case 4:
                  I.historical_entries = W.readUint32();
                  break;
                case 5:
                  I.bond_denom = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return C.deserialize(N);
          }
        }
        T.Params = C;
        class w extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("delegation" in N && N.delegation != null && (this.delegation = N.delegation), "balance" in N && N.balance != null && (this.balance = N.balance));
          }
          get delegation() {
            return $.Message.getWrapperField(this, Y, 1);
          }
          set delegation(N) {
            $.Message.setWrapperField(this, 1, N);
          }
          get balance() {
            return $.Message.getWrapperField(this, v.cosmos.base.v1beta1.Coin, 2);
          }
          set balance(N) {
            $.Message.setWrapperField(this, 2, N);
          }
          static fromObject(N) {
            const W = new w({});
            return N.delegation != null && (W.delegation = Y.fromObject(N.delegation)), N.balance != null && (W.balance = v.cosmos.base.v1beta1.Coin.fromObject(N.balance)), W;
          }
          toObject() {
            const N = {};
            return this.delegation != null && (N.delegation = this.delegation.toObject()), this.balance != null && (N.balance = this.balance.toObject()), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.delegation !== void 0 && W.writeMessage(1, this.delegation, () => this.delegation.serialize(W)), this.balance !== void 0 && W.writeMessage(2, this.balance, () => this.balance.serialize(W)), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new w();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  W.readMessage(I.delegation, () => I.delegation = Y.deserialize(W));
                  break;
                case 2:
                  W.readMessage(I.balance, () => I.balance = v.cosmos.base.v1beta1.Coin.deserialize(W));
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return w.deserialize(N);
          }
        }
        T.DelegationResponse = w;
        class P extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("redelegation_entry" in N && N.redelegation_entry != null && (this.redelegation_entry = N.redelegation_entry), "balance" in N && N.balance != null && (this.balance = N.balance));
          }
          get redelegation_entry() {
            return $.Message.getWrapperField(this, ne, 1);
          }
          set redelegation_entry(N) {
            $.Message.setWrapperField(this, 1, N);
          }
          get balance() {
            return $.Message.getField(this, 4);
          }
          set balance(N) {
            $.Message.setField(this, 4, N);
          }
          static fromObject(N) {
            const W = new P({});
            return N.redelegation_entry != null && (W.redelegation_entry = ne.fromObject(N.redelegation_entry)), N.balance != null && (W.balance = N.balance), W;
          }
          toObject() {
            const N = {};
            return this.redelegation_entry != null && (N.redelegation_entry = this.redelegation_entry.toObject()), this.balance != null && (N.balance = this.balance), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.redelegation_entry !== void 0 && W.writeMessage(1, this.redelegation_entry, () => this.redelegation_entry.serialize(W)), typeof this.balance == "string" && this.balance.length && W.writeString(4, this.balance), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new P();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  W.readMessage(I.redelegation_entry, () => I.redelegation_entry = ne.deserialize(W));
                  break;
                case 4:
                  I.balance = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return P.deserialize(N);
          }
        }
        T.RedelegationEntryResponse = P;
        class J extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [2], []), !Array.isArray(N) && typeof N == "object" && ("redelegation" in N && N.redelegation != null && (this.redelegation = N.redelegation), "entries" in N && N.entries != null && (this.entries = N.entries));
          }
          get redelegation() {
            return $.Message.getWrapperField(this, H, 1);
          }
          set redelegation(N) {
            $.Message.setWrapperField(this, 1, N);
          }
          get entries() {
            return $.Message.getRepeatedWrapperField(this, P, 2);
          }
          set entries(N) {
            $.Message.setRepeatedWrapperField(this, 2, N);
          }
          static fromObject(N) {
            const W = new J({});
            return N.redelegation != null && (W.redelegation = H.fromObject(N.redelegation)), N.entries != null && (W.entries = N.entries.map((I) => P.fromObject(I))), W;
          }
          toObject() {
            const N = {};
            return this.redelegation != null && (N.redelegation = this.redelegation.toObject()), this.entries != null && (N.entries = this.entries.map((W) => W.toObject())), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (this.redelegation !== void 0 && W.writeMessage(1, this.redelegation, () => this.redelegation.serialize(W)), this.entries !== void 0 && W.writeRepeatedMessage(2, this.entries, (I) => I.serialize(W)), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new J();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  W.readMessage(I.redelegation, () => I.redelegation = H.deserialize(W));
                  break;
                case 2:
                  W.readMessage(I.entries, () => $.Message.addToRepeatedWrapperField(I, 2, P.deserialize(W), P));
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return J.deserialize(N);
          }
        }
        T.RedelegationResponse = J;
        class se extends $.Message {
          constructor(N) {
            super(), $.Message.initialize(this, Array.isArray(N) ? N : [], 0, -1, [], []), !Array.isArray(N) && typeof N == "object" && ("not_bonded_tokens" in N && N.not_bonded_tokens != null && (this.not_bonded_tokens = N.not_bonded_tokens), "bonded_tokens" in N && N.bonded_tokens != null && (this.bonded_tokens = N.bonded_tokens));
          }
          get not_bonded_tokens() {
            return $.Message.getField(this, 1);
          }
          set not_bonded_tokens(N) {
            $.Message.setField(this, 1, N);
          }
          get bonded_tokens() {
            return $.Message.getField(this, 2);
          }
          set bonded_tokens(N) {
            $.Message.setField(this, 2, N);
          }
          static fromObject(N) {
            const W = new se({});
            return N.not_bonded_tokens != null && (W.not_bonded_tokens = N.not_bonded_tokens), N.bonded_tokens != null && (W.bonded_tokens = N.bonded_tokens), W;
          }
          toObject() {
            const N = {};
            return this.not_bonded_tokens != null && (N.not_bonded_tokens = this.not_bonded_tokens), this.bonded_tokens != null && (N.bonded_tokens = this.bonded_tokens), N;
          }
          serialize(N) {
            const W = N || new $.BinaryWriter();
            if (typeof this.not_bonded_tokens == "string" && this.not_bonded_tokens.length && W.writeString(1, this.not_bonded_tokens), typeof this.bonded_tokens == "string" && this.bonded_tokens.length && W.writeString(2, this.bonded_tokens), !N)
              return W.getResultBuffer();
          }
          static deserialize(N) {
            const W = N instanceof $.BinaryReader ? N : new $.BinaryReader(N), I = new se();
            for (; W.nextField() && !W.isEndGroup(); )
              switch (W.getFieldNumber()) {
                case 1:
                  I.not_bonded_tokens = W.readString();
                  break;
                case 2:
                  I.bonded_tokens = W.readString();
                  break;
                default:
                  W.skipField();
              }
            return I;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(N) {
            return se.deserialize(N);
          }
        }
        T.Pool = se;
      })(O.v1beta1 || (O.v1beta1 = {}));
    })(E.staking || (E.staking = {}));
  })(e.cosmos || (e.cosmos = {}));
})(staking$4);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function($, E, O, T) {
    T === void 0 && (T = O);
    var y = Object.getOwnPropertyDescriptor(E, O);
    (!y || ("get" in y ? !E.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return E[O];
    } }), Object.defineProperty($, T, y);
  } : function($, E, O, T) {
    T === void 0 && (T = O), $[T] = E[O];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function($, E) {
    Object.defineProperty($, "default", { enumerable: !0, value: E });
  } : function($, E) {
    $.default = E;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function($) {
    if ($ && $.__esModule)
      return $;
    var E = {};
    if ($ != null)
      for (var O in $)
        O !== "default" && Object.prototype.hasOwnProperty.call($, O) && n(E, $, O);
    return o(E, $), E;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(any), d = u(timestamp), m = u(coin$6), v = u(staking$4), S = u(googleProtobuf);
  (function($) {
    (function(E) {
      (function(O) {
        class T extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []), !Array.isArray(Y) && typeof Y == "object" && ("description" in Y && Y.description != null && (this.description = Y.description), "commission" in Y && Y.commission != null && (this.commission = Y.commission), "min_self_delegation" in Y && Y.min_self_delegation != null && (this.min_self_delegation = Y.min_self_delegation), "delegator_address" in Y && Y.delegator_address != null && (this.delegator_address = Y.delegator_address), "validator_address" in Y && Y.validator_address != null && (this.validator_address = Y.validator_address), "pubkey" in Y && Y.pubkey != null && (this.pubkey = Y.pubkey), "value" in Y && Y.value != null && (this.value = Y.value));
          }
          get description() {
            return S.Message.getWrapperField(this, v.cosmos.staking.v1beta1.Description, 1);
          }
          set description(Y) {
            S.Message.setWrapperField(this, 1, Y);
          }
          get commission() {
            return S.Message.getWrapperField(this, v.cosmos.staking.v1beta1.CommissionRates, 2);
          }
          set commission(Y) {
            S.Message.setWrapperField(this, 2, Y);
          }
          get min_self_delegation() {
            return S.Message.getField(this, 3);
          }
          set min_self_delegation(Y) {
            S.Message.setField(this, 3, Y);
          }
          get delegator_address() {
            return S.Message.getField(this, 4);
          }
          set delegator_address(Y) {
            S.Message.setField(this, 4, Y);
          }
          get validator_address() {
            return S.Message.getField(this, 5);
          }
          set validator_address(Y) {
            S.Message.setField(this, 5, Y);
          }
          get pubkey() {
            return S.Message.getWrapperField(this, c.google.protobuf.Any, 6);
          }
          set pubkey(Y) {
            S.Message.setWrapperField(this, 6, Y);
          }
          get value() {
            return S.Message.getWrapperField(this, m.cosmos.base.v1beta1.Coin, 7);
          }
          set value(Y) {
            S.Message.setWrapperField(this, 7, Y);
          }
          static fromObject(Y) {
            const pe = new T({});
            return Y.description != null && (pe.description = v.cosmos.staking.v1beta1.Description.fromObject(Y.description)), Y.commission != null && (pe.commission = v.cosmos.staking.v1beta1.CommissionRates.fromObject(Y.commission)), Y.min_self_delegation != null && (pe.min_self_delegation = Y.min_self_delegation), Y.delegator_address != null && (pe.delegator_address = Y.delegator_address), Y.validator_address != null && (pe.validator_address = Y.validator_address), Y.pubkey != null && (pe.pubkey = c.google.protobuf.Any.fromObject(Y.pubkey)), Y.value != null && (pe.value = m.cosmos.base.v1beta1.Coin.fromObject(Y.value)), pe;
          }
          toObject() {
            const Y = {};
            return this.description != null && (Y.description = this.description.toObject()), this.commission != null && (Y.commission = this.commission.toObject()), this.min_self_delegation != null && (Y.min_self_delegation = this.min_self_delegation), this.delegator_address != null && (Y.delegator_address = this.delegator_address), this.validator_address != null && (Y.validator_address = this.validator_address), this.pubkey != null && (Y.pubkey = this.pubkey.toObject()), this.value != null && (Y.value = this.value.toObject()), Y;
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (this.description !== void 0 && pe.writeMessage(1, this.description, () => this.description.serialize(pe)), this.commission !== void 0 && pe.writeMessage(2, this.commission, () => this.commission.serialize(pe)), typeof this.min_self_delegation == "string" && this.min_self_delegation.length && pe.writeString(3, this.min_self_delegation), typeof this.delegator_address == "string" && this.delegator_address.length && pe.writeString(4, this.delegator_address), typeof this.validator_address == "string" && this.validator_address.length && pe.writeString(5, this.validator_address), this.pubkey !== void 0 && pe.writeMessage(6, this.pubkey, () => this.pubkey.serialize(pe)), this.value !== void 0 && pe.writeMessage(7, this.value, () => this.value.serialize(pe)), !Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new T();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                case 1:
                  pe.readMessage(oe.description, () => oe.description = v.cosmos.staking.v1beta1.Description.deserialize(pe));
                  break;
                case 2:
                  pe.readMessage(oe.commission, () => oe.commission = v.cosmos.staking.v1beta1.CommissionRates.deserialize(pe));
                  break;
                case 3:
                  oe.min_self_delegation = pe.readString();
                  break;
                case 4:
                  oe.delegator_address = pe.readString();
                  break;
                case 5:
                  oe.validator_address = pe.readString();
                  break;
                case 6:
                  pe.readMessage(oe.pubkey, () => oe.pubkey = c.google.protobuf.Any.deserialize(pe));
                  break;
                case 7:
                  pe.readMessage(oe.value, () => oe.value = m.cosmos.base.v1beta1.Coin.deserialize(pe));
                  break;
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return T.deserialize(Y);
          }
        }
        O.MsgCreateValidator = T;
        class y extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []);
          }
          static fromObject(Y) {
            return new y({});
          }
          toObject() {
            return {};
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (!Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new y();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return y.deserialize(Y);
          }
        }
        O.MsgCreateValidatorResponse = y;
        class V extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []), !Array.isArray(Y) && typeof Y == "object" && ("description" in Y && Y.description != null && (this.description = Y.description), "validator_address" in Y && Y.validator_address != null && (this.validator_address = Y.validator_address), "commission_rate" in Y && Y.commission_rate != null && (this.commission_rate = Y.commission_rate), "min_self_delegation" in Y && Y.min_self_delegation != null && (this.min_self_delegation = Y.min_self_delegation));
          }
          get description() {
            return S.Message.getWrapperField(this, v.cosmos.staking.v1beta1.Description, 1);
          }
          set description(Y) {
            S.Message.setWrapperField(this, 1, Y);
          }
          get validator_address() {
            return S.Message.getField(this, 2);
          }
          set validator_address(Y) {
            S.Message.setField(this, 2, Y);
          }
          get commission_rate() {
            return S.Message.getField(this, 3);
          }
          set commission_rate(Y) {
            S.Message.setField(this, 3, Y);
          }
          get min_self_delegation() {
            return S.Message.getField(this, 4);
          }
          set min_self_delegation(Y) {
            S.Message.setField(this, 4, Y);
          }
          static fromObject(Y) {
            const pe = new V({});
            return Y.description != null && (pe.description = v.cosmos.staking.v1beta1.Description.fromObject(Y.description)), Y.validator_address != null && (pe.validator_address = Y.validator_address), Y.commission_rate != null && (pe.commission_rate = Y.commission_rate), Y.min_self_delegation != null && (pe.min_self_delegation = Y.min_self_delegation), pe;
          }
          toObject() {
            const Y = {};
            return this.description != null && (Y.description = this.description.toObject()), this.validator_address != null && (Y.validator_address = this.validator_address), this.commission_rate != null && (Y.commission_rate = this.commission_rate), this.min_self_delegation != null && (Y.min_self_delegation = this.min_self_delegation), Y;
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (this.description !== void 0 && pe.writeMessage(1, this.description, () => this.description.serialize(pe)), typeof this.validator_address == "string" && this.validator_address.length && pe.writeString(2, this.validator_address), typeof this.commission_rate == "string" && this.commission_rate.length && pe.writeString(3, this.commission_rate), typeof this.min_self_delegation == "string" && this.min_self_delegation.length && pe.writeString(4, this.min_self_delegation), !Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new V();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                case 1:
                  pe.readMessage(oe.description, () => oe.description = v.cosmos.staking.v1beta1.Description.deserialize(pe));
                  break;
                case 2:
                  oe.validator_address = pe.readString();
                  break;
                case 3:
                  oe.commission_rate = pe.readString();
                  break;
                case 4:
                  oe.min_self_delegation = pe.readString();
                  break;
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return V.deserialize(Y);
          }
        }
        O.MsgEditValidator = V;
        class M extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []);
          }
          static fromObject(Y) {
            return new M({});
          }
          toObject() {
            return {};
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (!Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new M();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return M.deserialize(Y);
          }
        }
        O.MsgEditValidatorResponse = M;
        class G extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []), !Array.isArray(Y) && typeof Y == "object" && ("delegator_address" in Y && Y.delegator_address != null && (this.delegator_address = Y.delegator_address), "validator_address" in Y && Y.validator_address != null && (this.validator_address = Y.validator_address), "amount" in Y && Y.amount != null && (this.amount = Y.amount));
          }
          get delegator_address() {
            return S.Message.getField(this, 1);
          }
          set delegator_address(Y) {
            S.Message.setField(this, 1, Y);
          }
          get validator_address() {
            return S.Message.getField(this, 2);
          }
          set validator_address(Y) {
            S.Message.setField(this, 2, Y);
          }
          get amount() {
            return S.Message.getWrapperField(this, m.cosmos.base.v1beta1.Coin, 3);
          }
          set amount(Y) {
            S.Message.setWrapperField(this, 3, Y);
          }
          static fromObject(Y) {
            const pe = new G({});
            return Y.delegator_address != null && (pe.delegator_address = Y.delegator_address), Y.validator_address != null && (pe.validator_address = Y.validator_address), Y.amount != null && (pe.amount = m.cosmos.base.v1beta1.Coin.fromObject(Y.amount)), pe;
          }
          toObject() {
            const Y = {};
            return this.delegator_address != null && (Y.delegator_address = this.delegator_address), this.validator_address != null && (Y.validator_address = this.validator_address), this.amount != null && (Y.amount = this.amount.toObject()), Y;
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && pe.writeString(1, this.delegator_address), typeof this.validator_address == "string" && this.validator_address.length && pe.writeString(2, this.validator_address), this.amount !== void 0 && pe.writeMessage(3, this.amount, () => this.amount.serialize(pe)), !Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new G();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                case 1:
                  oe.delegator_address = pe.readString();
                  break;
                case 2:
                  oe.validator_address = pe.readString();
                  break;
                case 3:
                  pe.readMessage(oe.amount, () => oe.amount = m.cosmos.base.v1beta1.Coin.deserialize(pe));
                  break;
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return G.deserialize(Y);
          }
        }
        O.MsgDelegate = G;
        class k extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []);
          }
          static fromObject(Y) {
            return new k({});
          }
          toObject() {
            return {};
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (!Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new k();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return k.deserialize(Y);
          }
        }
        O.MsgDelegateResponse = k;
        class F extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []), !Array.isArray(Y) && typeof Y == "object" && ("delegator_address" in Y && Y.delegator_address != null && (this.delegator_address = Y.delegator_address), "validator_src_address" in Y && Y.validator_src_address != null && (this.validator_src_address = Y.validator_src_address), "validator_dst_address" in Y && Y.validator_dst_address != null && (this.validator_dst_address = Y.validator_dst_address), "amount" in Y && Y.amount != null && (this.amount = Y.amount));
          }
          get delegator_address() {
            return S.Message.getField(this, 1);
          }
          set delegator_address(Y) {
            S.Message.setField(this, 1, Y);
          }
          get validator_src_address() {
            return S.Message.getField(this, 2);
          }
          set validator_src_address(Y) {
            S.Message.setField(this, 2, Y);
          }
          get validator_dst_address() {
            return S.Message.getField(this, 3);
          }
          set validator_dst_address(Y) {
            S.Message.setField(this, 3, Y);
          }
          get amount() {
            return S.Message.getWrapperField(this, m.cosmos.base.v1beta1.Coin, 4);
          }
          set amount(Y) {
            S.Message.setWrapperField(this, 4, Y);
          }
          static fromObject(Y) {
            const pe = new F({});
            return Y.delegator_address != null && (pe.delegator_address = Y.delegator_address), Y.validator_src_address != null && (pe.validator_src_address = Y.validator_src_address), Y.validator_dst_address != null && (pe.validator_dst_address = Y.validator_dst_address), Y.amount != null && (pe.amount = m.cosmos.base.v1beta1.Coin.fromObject(Y.amount)), pe;
          }
          toObject() {
            const Y = {};
            return this.delegator_address != null && (Y.delegator_address = this.delegator_address), this.validator_src_address != null && (Y.validator_src_address = this.validator_src_address), this.validator_dst_address != null && (Y.validator_dst_address = this.validator_dst_address), this.amount != null && (Y.amount = this.amount.toObject()), Y;
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && pe.writeString(1, this.delegator_address), typeof this.validator_src_address == "string" && this.validator_src_address.length && pe.writeString(2, this.validator_src_address), typeof this.validator_dst_address == "string" && this.validator_dst_address.length && pe.writeString(3, this.validator_dst_address), this.amount !== void 0 && pe.writeMessage(4, this.amount, () => this.amount.serialize(pe)), !Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new F();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                case 1:
                  oe.delegator_address = pe.readString();
                  break;
                case 2:
                  oe.validator_src_address = pe.readString();
                  break;
                case 3:
                  oe.validator_dst_address = pe.readString();
                  break;
                case 4:
                  pe.readMessage(oe.amount, () => oe.amount = m.cosmos.base.v1beta1.Coin.deserialize(pe));
                  break;
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return F.deserialize(Y);
          }
        }
        O.MsgBeginRedelegate = F;
        class X extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []), !Array.isArray(Y) && typeof Y == "object" && "completion_time" in Y && Y.completion_time != null && (this.completion_time = Y.completion_time);
          }
          get completion_time() {
            return S.Message.getWrapperField(this, d.google.protobuf.Timestamp, 1);
          }
          set completion_time(Y) {
            S.Message.setWrapperField(this, 1, Y);
          }
          static fromObject(Y) {
            const pe = new X({});
            return Y.completion_time != null && (pe.completion_time = d.google.protobuf.Timestamp.fromObject(Y.completion_time)), pe;
          }
          toObject() {
            const Y = {};
            return this.completion_time != null && (Y.completion_time = this.completion_time.toObject()), Y;
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (this.completion_time !== void 0 && pe.writeMessage(1, this.completion_time, () => this.completion_time.serialize(pe)), !Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new X();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                case 1:
                  pe.readMessage(oe.completion_time, () => oe.completion_time = d.google.protobuf.Timestamp.deserialize(pe));
                  break;
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return X.deserialize(Y);
          }
        }
        O.MsgBeginRedelegateResponse = X;
        class ee extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []), !Array.isArray(Y) && typeof Y == "object" && ("delegator_address" in Y && Y.delegator_address != null && (this.delegator_address = Y.delegator_address), "validator_address" in Y && Y.validator_address != null && (this.validator_address = Y.validator_address), "amount" in Y && Y.amount != null && (this.amount = Y.amount));
          }
          get delegator_address() {
            return S.Message.getField(this, 1);
          }
          set delegator_address(Y) {
            S.Message.setField(this, 1, Y);
          }
          get validator_address() {
            return S.Message.getField(this, 2);
          }
          set validator_address(Y) {
            S.Message.setField(this, 2, Y);
          }
          get amount() {
            return S.Message.getWrapperField(this, m.cosmos.base.v1beta1.Coin, 3);
          }
          set amount(Y) {
            S.Message.setWrapperField(this, 3, Y);
          }
          static fromObject(Y) {
            const pe = new ee({});
            return Y.delegator_address != null && (pe.delegator_address = Y.delegator_address), Y.validator_address != null && (pe.validator_address = Y.validator_address), Y.amount != null && (pe.amount = m.cosmos.base.v1beta1.Coin.fromObject(Y.amount)), pe;
          }
          toObject() {
            const Y = {};
            return this.delegator_address != null && (Y.delegator_address = this.delegator_address), this.validator_address != null && (Y.validator_address = this.validator_address), this.amount != null && (Y.amount = this.amount.toObject()), Y;
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && pe.writeString(1, this.delegator_address), typeof this.validator_address == "string" && this.validator_address.length && pe.writeString(2, this.validator_address), this.amount !== void 0 && pe.writeMessage(3, this.amount, () => this.amount.serialize(pe)), !Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new ee();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                case 1:
                  oe.delegator_address = pe.readString();
                  break;
                case 2:
                  oe.validator_address = pe.readString();
                  break;
                case 3:
                  pe.readMessage(oe.amount, () => oe.amount = m.cosmos.base.v1beta1.Coin.deserialize(pe));
                  break;
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return ee.deserialize(Y);
          }
        }
        O.MsgUndelegate = ee;
        class ue extends S.Message {
          constructor(Y) {
            super(), S.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []), !Array.isArray(Y) && typeof Y == "object" && "completion_time" in Y && Y.completion_time != null && (this.completion_time = Y.completion_time);
          }
          get completion_time() {
            return S.Message.getWrapperField(this, d.google.protobuf.Timestamp, 1);
          }
          set completion_time(Y) {
            S.Message.setWrapperField(this, 1, Y);
          }
          static fromObject(Y) {
            const pe = new ue({});
            return Y.completion_time != null && (pe.completion_time = d.google.protobuf.Timestamp.fromObject(Y.completion_time)), pe;
          }
          toObject() {
            const Y = {};
            return this.completion_time != null && (Y.completion_time = this.completion_time.toObject()), Y;
          }
          serialize(Y) {
            const pe = Y || new S.BinaryWriter();
            if (this.completion_time !== void 0 && pe.writeMessage(1, this.completion_time, () => this.completion_time.serialize(pe)), !Y)
              return pe.getResultBuffer();
          }
          static deserialize(Y) {
            const pe = Y instanceof S.BinaryReader ? Y : new S.BinaryReader(Y), oe = new ue();
            for (; pe.nextField() && !pe.isEndGroup(); )
              switch (pe.getFieldNumber()) {
                case 1:
                  pe.readMessage(oe.completion_time, () => oe.completion_time = d.google.protobuf.Timestamp.deserialize(pe));
                  break;
                default:
                  pe.skipField();
              }
            return oe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Y) {
            return ue.deserialize(Y);
          }
        }
        O.MsgUndelegateResponse = ue;
      })(E.v1beta1 || (E.v1beta1 = {}));
    })($.staking || ($.staking = {}));
  })(e.cosmos || (e.cosmos = {}));
})(tx$4);
var tx$3 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(m, v, S, $) {
    $ === void 0 && ($ = S);
    var E = Object.getOwnPropertyDescriptor(v, S);
    (!E || ("get" in E ? !v.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
      return v[S];
    } }), Object.defineProperty(m, $, E);
  } : function(m, v, S, $) {
    $ === void 0 && ($ = S), m[$] = v[S];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(m, v) {
    Object.defineProperty(m, "default", { enumerable: !0, value: v });
  } : function(m, v) {
    m.default = v;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(m) {
    if (m && m.__esModule)
      return m;
    var v = {};
    if (m != null)
      for (var S in m)
        S !== "default" && Object.prototype.hasOwnProperty.call(m, S) && n(v, m, S);
    return o(v, m), v;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(coin$6), d = u(googleProtobuf);
  (function(m) {
    (function(v) {
      (function(S) {
        class $ extends d.Message {
          constructor(F) {
            super(), d.Message.initialize(this, Array.isArray(F) ? F : [], 0, -1, [], []), !Array.isArray(F) && typeof F == "object" && ("delegator_address" in F && F.delegator_address != null && (this.delegator_address = F.delegator_address), "withdraw_address" in F && F.withdraw_address != null && (this.withdraw_address = F.withdraw_address));
          }
          get delegator_address() {
            return d.Message.getField(this, 1);
          }
          set delegator_address(F) {
            d.Message.setField(this, 1, F);
          }
          get withdraw_address() {
            return d.Message.getField(this, 2);
          }
          set withdraw_address(F) {
            d.Message.setField(this, 2, F);
          }
          static fromObject(F) {
            const X = new $({});
            return F.delegator_address != null && (X.delegator_address = F.delegator_address), F.withdraw_address != null && (X.withdraw_address = F.withdraw_address), X;
          }
          toObject() {
            const F = {};
            return this.delegator_address != null && (F.delegator_address = this.delegator_address), this.withdraw_address != null && (F.withdraw_address = this.withdraw_address), F;
          }
          serialize(F) {
            const X = F || new d.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && X.writeString(1, this.delegator_address), typeof this.withdraw_address == "string" && this.withdraw_address.length && X.writeString(2, this.withdraw_address), !F)
              return X.getResultBuffer();
          }
          static deserialize(F) {
            const X = F instanceof d.BinaryReader ? F : new d.BinaryReader(F), ee = new $();
            for (; X.nextField() && !X.isEndGroup(); )
              switch (X.getFieldNumber()) {
                case 1:
                  ee.delegator_address = X.readString();
                  break;
                case 2:
                  ee.withdraw_address = X.readString();
                  break;
                default:
                  X.skipField();
              }
            return ee;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(F) {
            return $.deserialize(F);
          }
        }
        S.MsgSetWithdrawAddress = $;
        class E extends d.Message {
          constructor(F) {
            super(), d.Message.initialize(this, Array.isArray(F) ? F : [], 0, -1, [], []);
          }
          static fromObject(F) {
            return new E({});
          }
          toObject() {
            return {};
          }
          serialize(F) {
            const X = F || new d.BinaryWriter();
            if (!F)
              return X.getResultBuffer();
          }
          static deserialize(F) {
            const X = F instanceof d.BinaryReader ? F : new d.BinaryReader(F), ee = new E();
            for (; X.nextField() && !X.isEndGroup(); )
              switch (X.getFieldNumber()) {
                default:
                  X.skipField();
              }
            return ee;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(F) {
            return E.deserialize(F);
          }
        }
        S.MsgSetWithdrawAddressResponse = E;
        class O extends d.Message {
          constructor(F) {
            super(), d.Message.initialize(this, Array.isArray(F) ? F : [], 0, -1, [], []), !Array.isArray(F) && typeof F == "object" && ("delegator_address" in F && F.delegator_address != null && (this.delegator_address = F.delegator_address), "validator_address" in F && F.validator_address != null && (this.validator_address = F.validator_address));
          }
          get delegator_address() {
            return d.Message.getField(this, 1);
          }
          set delegator_address(F) {
            d.Message.setField(this, 1, F);
          }
          get validator_address() {
            return d.Message.getField(this, 2);
          }
          set validator_address(F) {
            d.Message.setField(this, 2, F);
          }
          static fromObject(F) {
            const X = new O({});
            return F.delegator_address != null && (X.delegator_address = F.delegator_address), F.validator_address != null && (X.validator_address = F.validator_address), X;
          }
          toObject() {
            const F = {};
            return this.delegator_address != null && (F.delegator_address = this.delegator_address), this.validator_address != null && (F.validator_address = this.validator_address), F;
          }
          serialize(F) {
            const X = F || new d.BinaryWriter();
            if (typeof this.delegator_address == "string" && this.delegator_address.length && X.writeString(1, this.delegator_address), typeof this.validator_address == "string" && this.validator_address.length && X.writeString(2, this.validator_address), !F)
              return X.getResultBuffer();
          }
          static deserialize(F) {
            const X = F instanceof d.BinaryReader ? F : new d.BinaryReader(F), ee = new O();
            for (; X.nextField() && !X.isEndGroup(); )
              switch (X.getFieldNumber()) {
                case 1:
                  ee.delegator_address = X.readString();
                  break;
                case 2:
                  ee.validator_address = X.readString();
                  break;
                default:
                  X.skipField();
              }
            return ee;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(F) {
            return O.deserialize(F);
          }
        }
        S.MsgWithdrawDelegatorReward = O;
        class T extends d.Message {
          constructor(F) {
            super(), d.Message.initialize(this, Array.isArray(F) ? F : [], 0, -1, [], []);
          }
          static fromObject(F) {
            return new T({});
          }
          toObject() {
            return {};
          }
          serialize(F) {
            const X = F || new d.BinaryWriter();
            if (!F)
              return X.getResultBuffer();
          }
          static deserialize(F) {
            const X = F instanceof d.BinaryReader ? F : new d.BinaryReader(F), ee = new T();
            for (; X.nextField() && !X.isEndGroup(); )
              switch (X.getFieldNumber()) {
                default:
                  X.skipField();
              }
            return ee;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(F) {
            return T.deserialize(F);
          }
        }
        S.MsgWithdrawDelegatorRewardResponse = T;
        class y extends d.Message {
          constructor(F) {
            super(), d.Message.initialize(this, Array.isArray(F) ? F : [], 0, -1, [], []), !Array.isArray(F) && typeof F == "object" && "validator_address" in F && F.validator_address != null && (this.validator_address = F.validator_address);
          }
          get validator_address() {
            return d.Message.getField(this, 1);
          }
          set validator_address(F) {
            d.Message.setField(this, 1, F);
          }
          static fromObject(F) {
            const X = new y({});
            return F.validator_address != null && (X.validator_address = F.validator_address), X;
          }
          toObject() {
            const F = {};
            return this.validator_address != null && (F.validator_address = this.validator_address), F;
          }
          serialize(F) {
            const X = F || new d.BinaryWriter();
            if (typeof this.validator_address == "string" && this.validator_address.length && X.writeString(1, this.validator_address), !F)
              return X.getResultBuffer();
          }
          static deserialize(F) {
            const X = F instanceof d.BinaryReader ? F : new d.BinaryReader(F), ee = new y();
            for (; X.nextField() && !X.isEndGroup(); )
              switch (X.getFieldNumber()) {
                case 1:
                  ee.validator_address = X.readString();
                  break;
                default:
                  X.skipField();
              }
            return ee;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(F) {
            return y.deserialize(F);
          }
        }
        S.MsgWithdrawValidatorCommission = y;
        class V extends d.Message {
          constructor(F) {
            super(), d.Message.initialize(this, Array.isArray(F) ? F : [], 0, -1, [], []);
          }
          static fromObject(F) {
            return new V({});
          }
          toObject() {
            return {};
          }
          serialize(F) {
            const X = F || new d.BinaryWriter();
            if (!F)
              return X.getResultBuffer();
          }
          static deserialize(F) {
            const X = F instanceof d.BinaryReader ? F : new d.BinaryReader(F), ee = new V();
            for (; X.nextField() && !X.isEndGroup(); )
              switch (X.getFieldNumber()) {
                default:
                  X.skipField();
              }
            return ee;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(F) {
            return V.deserialize(F);
          }
        }
        S.MsgWithdrawValidatorCommissionResponse = V;
        class M extends d.Message {
          constructor(F) {
            super(), d.Message.initialize(this, Array.isArray(F) ? F : [], 0, -1, [1], []), !Array.isArray(F) && typeof F == "object" && ("amount" in F && F.amount != null && (this.amount = F.amount), "depositor" in F && F.depositor != null && (this.depositor = F.depositor));
          }
          get amount() {
            return d.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 1);
          }
          set amount(F) {
            d.Message.setRepeatedWrapperField(this, 1, F);
          }
          get depositor() {
            return d.Message.getField(this, 2);
          }
          set depositor(F) {
            d.Message.setField(this, 2, F);
          }
          static fromObject(F) {
            const X = new M({});
            return F.amount != null && (X.amount = F.amount.map((ee) => c.cosmos.base.v1beta1.Coin.fromObject(ee))), F.depositor != null && (X.depositor = F.depositor), X;
          }
          toObject() {
            const F = {};
            return this.amount != null && (F.amount = this.amount.map((X) => X.toObject())), this.depositor != null && (F.depositor = this.depositor), F;
          }
          serialize(F) {
            const X = F || new d.BinaryWriter();
            if (this.amount !== void 0 && X.writeRepeatedMessage(1, this.amount, (ee) => ee.serialize(X)), typeof this.depositor == "string" && this.depositor.length && X.writeString(2, this.depositor), !F)
              return X.getResultBuffer();
          }
          static deserialize(F) {
            const X = F instanceof d.BinaryReader ? F : new d.BinaryReader(F), ee = new M();
            for (; X.nextField() && !X.isEndGroup(); )
              switch (X.getFieldNumber()) {
                case 1:
                  X.readMessage(ee.amount, () => d.Message.addToRepeatedWrapperField(ee, 1, c.cosmos.base.v1beta1.Coin.deserialize(X), c.cosmos.base.v1beta1.Coin));
                  break;
                case 2:
                  ee.depositor = X.readString();
                  break;
                default:
                  X.skipField();
              }
            return ee;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(F) {
            return M.deserialize(F);
          }
        }
        S.MsgFundCommunityPool = M;
        class G extends d.Message {
          constructor(F) {
            super(), d.Message.initialize(this, Array.isArray(F) ? F : [], 0, -1, [], []);
          }
          static fromObject(F) {
            return new G({});
          }
          toObject() {
            return {};
          }
          serialize(F) {
            const X = F || new d.BinaryWriter();
            if (!F)
              return X.getResultBuffer();
          }
          static deserialize(F) {
            const X = F instanceof d.BinaryReader ? F : new d.BinaryReader(F), ee = new G();
            for (; X.nextField() && !X.isEndGroup(); )
              switch (X.getFieldNumber()) {
                default:
                  X.skipField();
              }
            return ee;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(F) {
            return G.deserialize(F);
          }
        }
        S.MsgFundCommunityPoolResponse = G;
      })(v.v1beta1 || (v.v1beta1 = {}));
    })(m.distribution || (m.distribution = {}));
  })(e.cosmos || (e.cosmos = {}));
})(tx$3);
var __createBinding$9 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$9 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$9 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$9(n, e, o);
  return __setModuleDefault$9(n, e), n;
};
Object.defineProperty(staking$5, "__esModule", { value: !0 });
staking$5.createMsgWithdrawValidatorCommission = staking$5.createMsgWithdrawDelegatorReward = staking$5.createMsgUndelegate = staking$5.createMsgBeginRedelegate = staking$5.createMsgDelegate = void 0;
const staking$3 = __importStar$9(tx$4), coin$1 = __importStar$9(coin$6), dist$2 = __importStar$9(tx$3);
function createMsgDelegate$1(e, n, o, u) {
  const c = new coin$1.cosmos.base.v1beta1.Coin({
    denom: u,
    amount: o
  });
  return {
    message: new staking$3.cosmos.staking.v1beta1.MsgDelegate({
      delegator_address: e,
      validator_address: n,
      amount: c
    }),
    path: "cosmos.staking.v1beta1.MsgDelegate"
  };
}
staking$5.createMsgDelegate = createMsgDelegate$1;
function createMsgBeginRedelegate$1(e, n, o, u, c) {
  const d = new coin$1.cosmos.base.v1beta1.Coin({
    denom: c,
    amount: u
  });
  return {
    message: new staking$3.cosmos.staking.v1beta1.MsgBeginRedelegate({
      delegator_address: e,
      validator_src_address: n,
      validator_dst_address: o,
      amount: d
    }),
    path: "cosmos.staking.v1beta1.MsgBeginRedelegate"
  };
}
staking$5.createMsgBeginRedelegate = createMsgBeginRedelegate$1;
function createMsgUndelegate$1(e, n, o, u) {
  const c = new coin$1.cosmos.base.v1beta1.Coin({
    denom: u,
    amount: o
  });
  return {
    message: new staking$3.cosmos.staking.v1beta1.MsgUndelegate({
      delegator_address: e,
      validator_address: n,
      amount: c
    }),
    path: "cosmos.staking.v1beta1.MsgUndelegate"
  };
}
staking$5.createMsgUndelegate = createMsgUndelegate$1;
function createMsgWithdrawDelegatorReward$1(e, n) {
  return {
    message: new dist$2.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward({
      delegator_address: e,
      validator_address: n
    }),
    path: "cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward"
  };
}
staking$5.createMsgWithdrawDelegatorReward = createMsgWithdrawDelegatorReward$1;
function createMsgWithdrawValidatorCommission$1(e) {
  return {
    message: new dist$2.cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission({
      validator_address: e
    }),
    path: "cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission"
  };
}
staking$5.createMsgWithdrawValidatorCommission = createMsgWithdrawValidatorCommission$1;
var txRaw$1 = {}, tx$2 = {}, multisig$1 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      (function(v) {
        (function(S) {
          class $ extends c.Message {
            constructor(T) {
              super(), c.Message.initialize(this, Array.isArray(T) ? T : [], 0, -1, [1], []), !Array.isArray(T) && typeof T == "object" && "signatures" in T && T.signatures != null && (this.signatures = T.signatures);
            }
            get signatures() {
              return c.Message.getField(this, 1);
            }
            set signatures(T) {
              c.Message.setField(this, 1, T);
            }
            static fromObject(T) {
              const y = new $({});
              return T.signatures != null && (y.signatures = T.signatures), y;
            }
            toObject() {
              const T = {};
              return this.signatures != null && (T.signatures = this.signatures), T;
            }
            serialize(T) {
              const y = T || new c.BinaryWriter();
              if (this.signatures !== void 0 && y.writeRepeatedBytes(1, this.signatures), !T)
                return y.getResultBuffer();
            }
            static deserialize(T) {
              const y = T instanceof c.BinaryReader ? T : new c.BinaryReader(T), V = new $();
              for (; y.nextField() && !y.isEndGroup(); )
                switch (y.getFieldNumber()) {
                  case 1:
                    c.Message.addToRepeatedField(V, 1, y.readBytes());
                    break;
                  default:
                    y.skipField();
                }
              return V;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(T) {
              return $.deserialize(T);
            }
          }
          S.MultiSignature = $;
          class E extends c.Message {
            constructor(T) {
              super(), c.Message.initialize(this, Array.isArray(T) ? T : [], 0, -1, [], []), !Array.isArray(T) && typeof T == "object" && ("extra_bits_stored" in T && T.extra_bits_stored != null && (this.extra_bits_stored = T.extra_bits_stored), "elems" in T && T.elems != null && (this.elems = T.elems));
            }
            get extra_bits_stored() {
              return c.Message.getField(this, 1);
            }
            set extra_bits_stored(T) {
              c.Message.setField(this, 1, T);
            }
            get elems() {
              return c.Message.getField(this, 2);
            }
            set elems(T) {
              c.Message.setField(this, 2, T);
            }
            static fromObject(T) {
              const y = new E({});
              return T.extra_bits_stored != null && (y.extra_bits_stored = T.extra_bits_stored), T.elems != null && (y.elems = T.elems), y;
            }
            toObject() {
              const T = {};
              return this.extra_bits_stored != null && (T.extra_bits_stored = this.extra_bits_stored), this.elems != null && (T.elems = this.elems), T;
            }
            serialize(T) {
              const y = T || new c.BinaryWriter();
              if (this.extra_bits_stored !== void 0 && y.writeUint32(1, this.extra_bits_stored), this.elems !== void 0 && y.writeBytes(2, this.elems), !T)
                return y.getResultBuffer();
            }
            static deserialize(T) {
              const y = T instanceof c.BinaryReader ? T : new c.BinaryReader(T), V = new E();
              for (; y.nextField() && !y.isEndGroup(); )
                switch (y.getFieldNumber()) {
                  case 1:
                    V.extra_bits_stored = y.readUint32();
                    break;
                  case 2:
                    V.elems = y.readBytes();
                    break;
                  default:
                    y.skipField();
                }
              return V;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(T) {
              return E.deserialize(T);
            }
          }
          S.CompactBitArray = E;
        })(v.v1beta1 || (v.v1beta1 = {}));
      })(m.multisig || (m.multisig = {}));
    })(d.crypto || (d.crypto = {}));
  })(e.cosmos || (e.cosmos = {}));
})(multisig$1);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(S, $, E, O) {
    O === void 0 && (O = E);
    var T = Object.getOwnPropertyDescriptor($, E);
    (!T || ("get" in T ? !$.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return $[E];
    } }), Object.defineProperty(S, O, T);
  } : function(S, $, E, O) {
    O === void 0 && (O = E), S[O] = $[E];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(S, $) {
    Object.defineProperty(S, "default", { enumerable: !0, value: $ });
  } : function(S, $) {
    S.default = $;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(S) {
    if (S && S.__esModule)
      return S;
    var $ = {};
    if (S != null)
      for (var E in S)
        E !== "default" && Object.prototype.hasOwnProperty.call(S, E) && n($, S, E);
    return o($, S), $;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(multisig$1), d = u(coin$6), m = u(any), v = u(googleProtobuf);
  (function(S) {
    (function($) {
      (function(E) {
        class O extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [3], []), !Array.isArray(ee) && typeof ee == "object" && ("body" in ee && ee.body != null && (this.body = ee.body), "auth_info" in ee && ee.auth_info != null && (this.auth_info = ee.auth_info), "signatures" in ee && ee.signatures != null && (this.signatures = ee.signatures));
          }
          get body() {
            return v.Message.getWrapperField(this, V, 1);
          }
          set body(ee) {
            v.Message.setWrapperField(this, 1, ee);
          }
          get auth_info() {
            return v.Message.getWrapperField(this, M, 2);
          }
          set auth_info(ee) {
            v.Message.setWrapperField(this, 2, ee);
          }
          get signatures() {
            return v.Message.getField(this, 3);
          }
          set signatures(ee) {
            v.Message.setField(this, 3, ee);
          }
          static fromObject(ee) {
            const ue = new O({});
            return ee.body != null && (ue.body = V.fromObject(ee.body)), ee.auth_info != null && (ue.auth_info = M.fromObject(ee.auth_info)), ee.signatures != null && (ue.signatures = ee.signatures), ue;
          }
          toObject() {
            const ee = {};
            return this.body != null && (ee.body = this.body.toObject()), this.auth_info != null && (ee.auth_info = this.auth_info.toObject()), this.signatures != null && (ee.signatures = this.signatures), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.body !== void 0 && ue.writeMessage(1, this.body, () => this.body.serialize(ue)), this.auth_info !== void 0 && ue.writeMessage(2, this.auth_info, () => this.auth_info.serialize(ue)), this.signatures !== void 0 && ue.writeRepeatedBytes(3, this.signatures), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new O();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  ue.readMessage(Q.body, () => Q.body = V.deserialize(ue));
                  break;
                case 2:
                  ue.readMessage(Q.auth_info, () => Q.auth_info = M.deserialize(ue));
                  break;
                case 3:
                  v.Message.addToRepeatedField(Q, 3, ue.readBytes());
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return O.deserialize(ee);
          }
        }
        E.Tx = O;
        class T extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [3], []), !Array.isArray(ee) && typeof ee == "object" && ("body_bytes" in ee && ee.body_bytes != null && (this.body_bytes = ee.body_bytes), "auth_info_bytes" in ee && ee.auth_info_bytes != null && (this.auth_info_bytes = ee.auth_info_bytes), "signatures" in ee && ee.signatures != null && (this.signatures = ee.signatures));
          }
          get body_bytes() {
            return v.Message.getField(this, 1);
          }
          set body_bytes(ee) {
            v.Message.setField(this, 1, ee);
          }
          get auth_info_bytes() {
            return v.Message.getField(this, 2);
          }
          set auth_info_bytes(ee) {
            v.Message.setField(this, 2, ee);
          }
          get signatures() {
            return v.Message.getField(this, 3);
          }
          set signatures(ee) {
            v.Message.setField(this, 3, ee);
          }
          static fromObject(ee) {
            const ue = new T({});
            return ee.body_bytes != null && (ue.body_bytes = ee.body_bytes), ee.auth_info_bytes != null && (ue.auth_info_bytes = ee.auth_info_bytes), ee.signatures != null && (ue.signatures = ee.signatures), ue;
          }
          toObject() {
            const ee = {};
            return this.body_bytes != null && (ee.body_bytes = this.body_bytes), this.auth_info_bytes != null && (ee.auth_info_bytes = this.auth_info_bytes), this.signatures != null && (ee.signatures = this.signatures), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.body_bytes !== void 0 && ue.writeBytes(1, this.body_bytes), this.auth_info_bytes !== void 0 && ue.writeBytes(2, this.auth_info_bytes), this.signatures !== void 0 && ue.writeRepeatedBytes(3, this.signatures), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new T();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  Q.body_bytes = ue.readBytes();
                  break;
                case 2:
                  Q.auth_info_bytes = ue.readBytes();
                  break;
                case 3:
                  v.Message.addToRepeatedField(Q, 3, ue.readBytes());
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return T.deserialize(ee);
          }
        }
        E.TxRaw = T;
        class y extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [], []), !Array.isArray(ee) && typeof ee == "object" && ("body_bytes" in ee && ee.body_bytes != null && (this.body_bytes = ee.body_bytes), "auth_info_bytes" in ee && ee.auth_info_bytes != null && (this.auth_info_bytes = ee.auth_info_bytes), "chain_id" in ee && ee.chain_id != null && (this.chain_id = ee.chain_id), "account_number" in ee && ee.account_number != null && (this.account_number = ee.account_number));
          }
          get body_bytes() {
            return v.Message.getField(this, 1);
          }
          set body_bytes(ee) {
            v.Message.setField(this, 1, ee);
          }
          get auth_info_bytes() {
            return v.Message.getField(this, 2);
          }
          set auth_info_bytes(ee) {
            v.Message.setField(this, 2, ee);
          }
          get chain_id() {
            return v.Message.getField(this, 3);
          }
          set chain_id(ee) {
            v.Message.setField(this, 3, ee);
          }
          get account_number() {
            return v.Message.getField(this, 4);
          }
          set account_number(ee) {
            v.Message.setField(this, 4, ee);
          }
          static fromObject(ee) {
            const ue = new y({});
            return ee.body_bytes != null && (ue.body_bytes = ee.body_bytes), ee.auth_info_bytes != null && (ue.auth_info_bytes = ee.auth_info_bytes), ee.chain_id != null && (ue.chain_id = ee.chain_id), ee.account_number != null && (ue.account_number = ee.account_number), ue;
          }
          toObject() {
            const ee = {};
            return this.body_bytes != null && (ee.body_bytes = this.body_bytes), this.auth_info_bytes != null && (ee.auth_info_bytes = this.auth_info_bytes), this.chain_id != null && (ee.chain_id = this.chain_id), this.account_number != null && (ee.account_number = this.account_number), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.body_bytes !== void 0 && ue.writeBytes(1, this.body_bytes), this.auth_info_bytes !== void 0 && ue.writeBytes(2, this.auth_info_bytes), typeof this.chain_id == "string" && this.chain_id.length && ue.writeString(3, this.chain_id), this.account_number !== void 0 && ue.writeUint64(4, this.account_number), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new y();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  Q.body_bytes = ue.readBytes();
                  break;
                case 2:
                  Q.auth_info_bytes = ue.readBytes();
                  break;
                case 3:
                  Q.chain_id = ue.readString();
                  break;
                case 4:
                  Q.account_number = ue.readUint64();
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return y.deserialize(ee);
          }
        }
        E.SignDoc = y;
        class V extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [1, 1023, 2047], []), !Array.isArray(ee) && typeof ee == "object" && ("messages" in ee && ee.messages != null && (this.messages = ee.messages), "memo" in ee && ee.memo != null && (this.memo = ee.memo), "timeout_height" in ee && ee.timeout_height != null && (this.timeout_height = ee.timeout_height), "extension_options" in ee && ee.extension_options != null && (this.extension_options = ee.extension_options), "non_critical_extension_options" in ee && ee.non_critical_extension_options != null && (this.non_critical_extension_options = ee.non_critical_extension_options));
          }
          get messages() {
            return v.Message.getRepeatedWrapperField(this, m.google.protobuf.Any, 1);
          }
          set messages(ee) {
            v.Message.setRepeatedWrapperField(this, 1, ee);
          }
          get memo() {
            return v.Message.getField(this, 2);
          }
          set memo(ee) {
            v.Message.setField(this, 2, ee);
          }
          get timeout_height() {
            return v.Message.getField(this, 3);
          }
          set timeout_height(ee) {
            v.Message.setField(this, 3, ee);
          }
          get extension_options() {
            return v.Message.getRepeatedWrapperField(this, m.google.protobuf.Any, 1023);
          }
          set extension_options(ee) {
            v.Message.setRepeatedWrapperField(this, 1023, ee);
          }
          get non_critical_extension_options() {
            return v.Message.getRepeatedWrapperField(this, m.google.protobuf.Any, 2047);
          }
          set non_critical_extension_options(ee) {
            v.Message.setRepeatedWrapperField(this, 2047, ee);
          }
          static fromObject(ee) {
            const ue = new V({});
            return ee.messages != null && (ue.messages = ee.messages.map((Q) => m.google.protobuf.Any.fromObject(Q))), ee.memo != null && (ue.memo = ee.memo), ee.timeout_height != null && (ue.timeout_height = ee.timeout_height), ee.extension_options != null && (ue.extension_options = ee.extension_options.map((Q) => m.google.protobuf.Any.fromObject(Q))), ee.non_critical_extension_options != null && (ue.non_critical_extension_options = ee.non_critical_extension_options.map((Q) => m.google.protobuf.Any.fromObject(Q))), ue;
          }
          toObject() {
            const ee = {};
            return this.messages != null && (ee.messages = this.messages.map((ue) => ue.toObject())), this.memo != null && (ee.memo = this.memo), this.timeout_height != null && (ee.timeout_height = this.timeout_height), this.extension_options != null && (ee.extension_options = this.extension_options.map((ue) => ue.toObject())), this.non_critical_extension_options != null && (ee.non_critical_extension_options = this.non_critical_extension_options.map((ue) => ue.toObject())), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.messages !== void 0 && ue.writeRepeatedMessage(1, this.messages, (Q) => Q.serialize(ue)), typeof this.memo == "string" && this.memo.length && ue.writeString(2, this.memo), this.timeout_height !== void 0 && ue.writeUint64(3, this.timeout_height), this.extension_options !== void 0 && ue.writeRepeatedMessage(1023, this.extension_options, (Q) => Q.serialize(ue)), this.non_critical_extension_options !== void 0 && ue.writeRepeatedMessage(2047, this.non_critical_extension_options, (Q) => Q.serialize(ue)), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new V();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  ue.readMessage(Q.messages, () => v.Message.addToRepeatedWrapperField(Q, 1, m.google.protobuf.Any.deserialize(ue), m.google.protobuf.Any));
                  break;
                case 2:
                  Q.memo = ue.readString();
                  break;
                case 3:
                  Q.timeout_height = ue.readUint64();
                  break;
                case 1023:
                  ue.readMessage(Q.extension_options, () => v.Message.addToRepeatedWrapperField(Q, 1023, m.google.protobuf.Any.deserialize(ue), m.google.protobuf.Any));
                  break;
                case 2047:
                  ue.readMessage(Q.non_critical_extension_options, () => v.Message.addToRepeatedWrapperField(Q, 2047, m.google.protobuf.Any.deserialize(ue), m.google.protobuf.Any));
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return V.deserialize(ee);
          }
        }
        E.TxBody = V;
        class M extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [1], []), !Array.isArray(ee) && typeof ee == "object" && ("signer_infos" in ee && ee.signer_infos != null && (this.signer_infos = ee.signer_infos), "fee" in ee && ee.fee != null && (this.fee = ee.fee));
          }
          get signer_infos() {
            return v.Message.getRepeatedWrapperField(this, G, 1);
          }
          set signer_infos(ee) {
            v.Message.setRepeatedWrapperField(this, 1, ee);
          }
          get fee() {
            return v.Message.getWrapperField(this, F, 2);
          }
          set fee(ee) {
            v.Message.setWrapperField(this, 2, ee);
          }
          static fromObject(ee) {
            const ue = new M({});
            return ee.signer_infos != null && (ue.signer_infos = ee.signer_infos.map((Q) => G.fromObject(Q))), ee.fee != null && (ue.fee = F.fromObject(ee.fee)), ue;
          }
          toObject() {
            const ee = {};
            return this.signer_infos != null && (ee.signer_infos = this.signer_infos.map((ue) => ue.toObject())), this.fee != null && (ee.fee = this.fee.toObject()), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.signer_infos !== void 0 && ue.writeRepeatedMessage(1, this.signer_infos, (Q) => Q.serialize(ue)), this.fee !== void 0 && ue.writeMessage(2, this.fee, () => this.fee.serialize(ue)), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new M();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  ue.readMessage(Q.signer_infos, () => v.Message.addToRepeatedWrapperField(Q, 1, G.deserialize(ue), G));
                  break;
                case 2:
                  ue.readMessage(Q.fee, () => Q.fee = F.deserialize(ue));
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return M.deserialize(ee);
          }
        }
        E.AuthInfo = M;
        class G extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [], []), !Array.isArray(ee) && typeof ee == "object" && ("public_key" in ee && ee.public_key != null && (this.public_key = ee.public_key), "mode_info" in ee && ee.mode_info != null && (this.mode_info = ee.mode_info), "sequence" in ee && ee.sequence != null && (this.sequence = ee.sequence));
          }
          get public_key() {
            return v.Message.getWrapperField(this, m.google.protobuf.Any, 1);
          }
          set public_key(ee) {
            v.Message.setWrapperField(this, 1, ee);
          }
          get mode_info() {
            return v.Message.getWrapperField(this, k, 2);
          }
          set mode_info(ee) {
            v.Message.setWrapperField(this, 2, ee);
          }
          get sequence() {
            return v.Message.getField(this, 3);
          }
          set sequence(ee) {
            v.Message.setField(this, 3, ee);
          }
          static fromObject(ee) {
            const ue = new G({});
            return ee.public_key != null && (ue.public_key = m.google.protobuf.Any.fromObject(ee.public_key)), ee.mode_info != null && (ue.mode_info = k.fromObject(ee.mode_info)), ee.sequence != null && (ue.sequence = ee.sequence), ue;
          }
          toObject() {
            const ee = {};
            return this.public_key != null && (ee.public_key = this.public_key.toObject()), this.mode_info != null && (ee.mode_info = this.mode_info.toObject()), this.sequence != null && (ee.sequence = this.sequence), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.public_key !== void 0 && ue.writeMessage(1, this.public_key, () => this.public_key.serialize(ue)), this.mode_info !== void 0 && ue.writeMessage(2, this.mode_info, () => this.mode_info.serialize(ue)), this.sequence !== void 0 && ue.writeUint64(3, this.sequence), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new G();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  ue.readMessage(Q.public_key, () => Q.public_key = m.google.protobuf.Any.deserialize(ue));
                  break;
                case 2:
                  ue.readMessage(Q.mode_info, () => Q.mode_info = k.deserialize(ue));
                  break;
                case 3:
                  Q.sequence = ue.readUint64();
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return G.deserialize(ee);
          }
        }
        E.SignerInfo = G;
        class k extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [], [[1, 2]]), !Array.isArray(ee) && typeof ee == "object" && ("single" in ee && ee.single != null && (this.single = ee.single), "multi" in ee && ee.multi != null && (this.multi = ee.multi));
          }
          get single() {
            return v.Message.getWrapperField(this, k.Single, 1);
          }
          set single(ee) {
            v.Message.setOneofWrapperField(this, 1, [1, 2], ee);
          }
          get multi() {
            return v.Message.getWrapperField(this, k.Multi, 2);
          }
          set multi(ee) {
            v.Message.setOneofWrapperField(this, 2, [1, 2], ee);
          }
          get sum() {
            return {
              0: "none",
              1: "single",
              2: "multi"
            }[v.Message.computeOneofCase(this, [1, 2])];
          }
          static fromObject(ee) {
            const ue = new k({});
            return ee.single != null && (ue.single = k.Single.fromObject(ee.single)), ee.multi != null && (ue.multi = k.Multi.fromObject(ee.multi)), ue;
          }
          toObject() {
            const ee = {};
            return this.single != null && (ee.single = this.single.toObject()), this.multi != null && (ee.multi = this.multi.toObject()), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.single !== void 0 && ue.writeMessage(1, this.single, () => this.single.serialize(ue)), this.multi !== void 0 && ue.writeMessage(2, this.multi, () => this.multi.serialize(ue)), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new k();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  ue.readMessage(Q.single, () => Q.single = k.Single.deserialize(ue));
                  break;
                case 2:
                  ue.readMessage(Q.multi, () => Q.multi = k.Multi.deserialize(ue));
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return k.deserialize(ee);
          }
        }
        E.ModeInfo = k, function(X) {
          class ee extends v.Message {
            constructor(Y) {
              super(), v.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [], []), !Array.isArray(Y) && typeof Y == "object" && "mode" in Y && Y.mode != null && (this.mode = Y.mode);
            }
            get mode() {
              return v.Message.getField(this, 1);
            }
            set mode(Y) {
              v.Message.setField(this, 1, Y);
            }
            static fromObject(Y) {
              const pe = new ee({});
              return Y.mode != null && (pe.mode = Y.mode), pe;
            }
            toObject() {
              const Y = {};
              return this.mode != null && (Y.mode = this.mode), Y;
            }
            serialize(Y) {
              const pe = Y || new v.BinaryWriter();
              if (this.mode !== void 0 && pe.writeEnum(1, this.mode), !Y)
                return pe.getResultBuffer();
            }
            static deserialize(Y) {
              const pe = Y instanceof v.BinaryReader ? Y : new v.BinaryReader(Y), oe = new ee();
              for (; pe.nextField() && !pe.isEndGroup(); )
                switch (pe.getFieldNumber()) {
                  case 1:
                    oe.mode = pe.readEnum();
                    break;
                  default:
                    pe.skipField();
                }
              return oe;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(Y) {
              return ee.deserialize(Y);
            }
          }
          X.Single = ee;
          class ue extends v.Message {
            constructor(Y) {
              super(), v.Message.initialize(this, Array.isArray(Y) ? Y : [], 0, -1, [2], []), !Array.isArray(Y) && typeof Y == "object" && ("bitarray" in Y && Y.bitarray != null && (this.bitarray = Y.bitarray), "mode_infos" in Y && Y.mode_infos != null && (this.mode_infos = Y.mode_infos));
            }
            get bitarray() {
              return v.Message.getWrapperField(this, c.cosmos.crypto.multisig.v1beta1.CompactBitArray, 1);
            }
            set bitarray(Y) {
              v.Message.setWrapperField(this, 1, Y);
            }
            get mode_infos() {
              return v.Message.getRepeatedWrapperField(this, X, 2);
            }
            set mode_infos(Y) {
              v.Message.setRepeatedWrapperField(this, 2, Y);
            }
            static fromObject(Y) {
              const pe = new ue({});
              return Y.bitarray != null && (pe.bitarray = c.cosmos.crypto.multisig.v1beta1.CompactBitArray.fromObject(Y.bitarray)), Y.mode_infos != null && (pe.mode_infos = Y.mode_infos.map((oe) => X.fromObject(oe))), pe;
            }
            toObject() {
              const Y = {};
              return this.bitarray != null && (Y.bitarray = this.bitarray.toObject()), this.mode_infos != null && (Y.mode_infos = this.mode_infos.map((pe) => pe.toObject())), Y;
            }
            serialize(Y) {
              const pe = Y || new v.BinaryWriter();
              if (this.bitarray !== void 0 && pe.writeMessage(1, this.bitarray, () => this.bitarray.serialize(pe)), this.mode_infos !== void 0 && pe.writeRepeatedMessage(2, this.mode_infos, (oe) => oe.serialize(pe)), !Y)
                return pe.getResultBuffer();
            }
            static deserialize(Y) {
              const pe = Y instanceof v.BinaryReader ? Y : new v.BinaryReader(Y), oe = new ue();
              for (; pe.nextField() && !pe.isEndGroup(); )
                switch (pe.getFieldNumber()) {
                  case 1:
                    pe.readMessage(oe.bitarray, () => oe.bitarray = c.cosmos.crypto.multisig.v1beta1.CompactBitArray.deserialize(pe));
                    break;
                  case 2:
                    pe.readMessage(oe.mode_infos, () => v.Message.addToRepeatedWrapperField(oe, 2, X.deserialize(pe), X));
                    break;
                  default:
                    pe.skipField();
                }
              return oe;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(Y) {
              return ue.deserialize(Y);
            }
          }
          X.Multi = ue;
        }(k = E.ModeInfo || (E.ModeInfo = {}));
        class F extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [1], []), !Array.isArray(ee) && typeof ee == "object" && ("amount" in ee && ee.amount != null && (this.amount = ee.amount), "gas_limit" in ee && ee.gas_limit != null && (this.gas_limit = ee.gas_limit), "payer" in ee && ee.payer != null && (this.payer = ee.payer), "granter" in ee && ee.granter != null && (this.granter = ee.granter));
          }
          get amount() {
            return v.Message.getRepeatedWrapperField(this, d.cosmos.base.v1beta1.Coin, 1);
          }
          set amount(ee) {
            v.Message.setRepeatedWrapperField(this, 1, ee);
          }
          get gas_limit() {
            return v.Message.getField(this, 2);
          }
          set gas_limit(ee) {
            v.Message.setField(this, 2, ee);
          }
          get payer() {
            return v.Message.getField(this, 3);
          }
          set payer(ee) {
            v.Message.setField(this, 3, ee);
          }
          get granter() {
            return v.Message.getField(this, 4);
          }
          set granter(ee) {
            v.Message.setField(this, 4, ee);
          }
          static fromObject(ee) {
            const ue = new F({});
            return ee.amount != null && (ue.amount = ee.amount.map((Q) => d.cosmos.base.v1beta1.Coin.fromObject(Q))), ee.gas_limit != null && (ue.gas_limit = ee.gas_limit), ee.payer != null && (ue.payer = ee.payer), ee.granter != null && (ue.granter = ee.granter), ue;
          }
          toObject() {
            const ee = {};
            return this.amount != null && (ee.amount = this.amount.map((ue) => ue.toObject())), this.gas_limit != null && (ee.gas_limit = this.gas_limit), this.payer != null && (ee.payer = this.payer), this.granter != null && (ee.granter = this.granter), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.amount !== void 0 && ue.writeRepeatedMessage(1, this.amount, (Q) => Q.serialize(ue)), this.gas_limit !== void 0 && ue.writeUint64(2, this.gas_limit), typeof this.payer == "string" && this.payer.length && ue.writeString(3, this.payer), typeof this.granter == "string" && this.granter.length && ue.writeString(4, this.granter), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new F();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  ue.readMessage(Q.amount, () => v.Message.addToRepeatedWrapperField(Q, 1, d.cosmos.base.v1beta1.Coin.deserialize(ue), d.cosmos.base.v1beta1.Coin));
                  break;
                case 2:
                  Q.gas_limit = ue.readUint64();
                  break;
                case 3:
                  Q.payer = ue.readString();
                  break;
                case 4:
                  Q.granter = ue.readString();
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return F.deserialize(ee);
          }
        }
        E.Fee = F;
      })($.v1beta1 || ($.v1beta1 = {}));
    })(S.tx || (S.tx = {}));
  })(e.cosmos || (e.cosmos = {}));
})(tx$2);
var __createBinding$8 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$8 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$8 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$8(n, e, o);
  return __setModuleDefault$8(n, e), n;
};
Object.defineProperty(txRaw$1, "__esModule", { value: !0 });
txRaw$1.createTxRaw = txRaw$1.bytesToAuthInfo = txRaw$1.bytesToTxBody = txRaw$1.bytesToTxRaw = void 0;
const tx$1 = __importStar$8(tx$2);
function bytesToTxRaw(e) {
  return tx$1.cosmos.tx.v1beta1.TxRaw.deserialize(e);
}
txRaw$1.bytesToTxRaw = bytesToTxRaw;
function bytesToTxBody(e) {
  return tx$1.cosmos.tx.v1beta1.TxBody.deserialize(e);
}
txRaw$1.bytesToTxBody = bytesToTxBody;
function bytesToAuthInfo(e) {
  return tx$1.cosmos.tx.v1beta1.AuthInfo.deserialize(e);
}
txRaw$1.bytesToAuthInfo = bytesToAuthInfo;
function createTxRaw(e, n, o) {
  return {
    message: new tx$1.cosmos.tx.v1beta1.TxRaw({
      body_bytes: e,
      auth_info_bytes: n,
      signatures: o
    }),
    path: "cosmos.tx.v1beta1.TxRaw"
  };
}
txRaw$1.createTxRaw = createTxRaw;
var validator$6 = {}, __createBinding$7 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$7 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$7 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$7(n, e, o);
  return __setModuleDefault$7(n, e), n;
};
Object.defineProperty(validator$6, "__esModule", { value: !0 });
validator$6.createMsgEditValidator = void 0;
const stakingTypes = __importStar$7(staking$4), staking$2 = __importStar$7(tx$4), NOT_MODIFY$1 = "[do-not-modify]";
function createMsgEditValidator$1(e, n, o, u, c, d, m, v) {
  return {
    message: new staking$2.cosmos.staking.v1beta1.MsgEditValidator({
      description: new stakingTypes.cosmos.staking.v1beta1.Description({
        moniker: e || NOT_MODIFY$1,
        identity: n || NOT_MODIFY$1,
        website: o || NOT_MODIFY$1,
        security_contact: u || NOT_MODIFY$1,
        details: c || NOT_MODIFY$1
      }),
      validator_address: d,
      commission_rate: m,
      min_self_delegation: v
    }),
    path: "cosmos.staking.v1beta1.MsgEditValidator"
  };
}
validator$6.createMsgEditValidator = createMsgEditValidator$1;
var vote = {}, tx = {}, gov$2 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function($, E, O, T) {
    T === void 0 && (T = O);
    var y = Object.getOwnPropertyDescriptor(E, O);
    (!y || ("get" in y ? !E.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return E[O];
    } }), Object.defineProperty($, T, y);
  } : function($, E, O, T) {
    T === void 0 && (T = O), $[T] = E[O];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function($, E) {
    Object.defineProperty($, "default", { enumerable: !0, value: E });
  } : function($, E) {
    $.default = E;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function($) {
    if ($ && $.__esModule)
      return $;
    var E = {};
    if ($ != null)
      for (var O in $)
        O !== "default" && Object.prototype.hasOwnProperty.call($, O) && n(E, $, O);
    return o(E, $), E;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(coin$6), d = u(timestamp), m = u(any), v = u(duration), S = u(googleProtobuf);
  (function($) {
    (function(E) {
      (function(O) {
        (function(ue) {
          ue[ue.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", ue[ue.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", ue[ue.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", ue[ue.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", ue[ue.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO";
        })(O.VoteOption || (O.VoteOption = {})), function(ue) {
          ue[ue.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", ue[ue.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", ue[ue.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", ue[ue.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", ue[ue.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", ue[ue.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED";
        }(O.ProposalStatus || (O.ProposalStatus = {}));
        class T extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [], []), !Array.isArray(Q) && typeof Q == "object" && ("option" in Q && Q.option != null && (this.option = Q.option), "weight" in Q && Q.weight != null && (this.weight = Q.weight));
          }
          get option() {
            return S.Message.getField(this, 1);
          }
          set option(Q) {
            S.Message.setField(this, 1, Q);
          }
          get weight() {
            return S.Message.getField(this, 2);
          }
          set weight(Q) {
            S.Message.setField(this, 2, Q);
          }
          static fromObject(Q) {
            const Y = new T({});
            return Q.option != null && (Y.option = Q.option), Q.weight != null && (Y.weight = Q.weight), Y;
          }
          toObject() {
            const Q = {};
            return this.option != null && (Q.option = this.option), this.weight != null && (Q.weight = this.weight), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (this.option !== void 0 && Y.writeEnum(1, this.option), typeof this.weight == "string" && this.weight.length && Y.writeString(2, this.weight), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new T();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  pe.option = Y.readEnum();
                  break;
                case 2:
                  pe.weight = Y.readString();
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return T.deserialize(Q);
          }
        }
        O.WeightedVoteOption = T;
        class y extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [], []), !Array.isArray(Q) && typeof Q == "object" && ("title" in Q && Q.title != null && (this.title = Q.title), "description" in Q && Q.description != null && (this.description = Q.description));
          }
          get title() {
            return S.Message.getField(this, 1);
          }
          set title(Q) {
            S.Message.setField(this, 1, Q);
          }
          get description() {
            return S.Message.getField(this, 2);
          }
          set description(Q) {
            S.Message.setField(this, 2, Q);
          }
          static fromObject(Q) {
            const Y = new y({});
            return Q.title != null && (Y.title = Q.title), Q.description != null && (Y.description = Q.description), Y;
          }
          toObject() {
            const Q = {};
            return this.title != null && (Q.title = this.title), this.description != null && (Q.description = this.description), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (typeof this.title == "string" && this.title.length && Y.writeString(1, this.title), typeof this.description == "string" && this.description.length && Y.writeString(2, this.description), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new y();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  pe.title = Y.readString();
                  break;
                case 2:
                  pe.description = Y.readString();
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return y.deserialize(Q);
          }
        }
        O.TextProposal = y;
        class V extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [3], []), !Array.isArray(Q) && typeof Q == "object" && ("proposal_id" in Q && Q.proposal_id != null && (this.proposal_id = Q.proposal_id), "depositor" in Q && Q.depositor != null && (this.depositor = Q.depositor), "amount" in Q && Q.amount != null && (this.amount = Q.amount));
          }
          get proposal_id() {
            return S.Message.getField(this, 1);
          }
          set proposal_id(Q) {
            S.Message.setField(this, 1, Q);
          }
          get depositor() {
            return S.Message.getField(this, 2);
          }
          set depositor(Q) {
            S.Message.setField(this, 2, Q);
          }
          get amount() {
            return S.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 3);
          }
          set amount(Q) {
            S.Message.setRepeatedWrapperField(this, 3, Q);
          }
          static fromObject(Q) {
            const Y = new V({});
            return Q.proposal_id != null && (Y.proposal_id = Q.proposal_id), Q.depositor != null && (Y.depositor = Q.depositor), Q.amount != null && (Y.amount = Q.amount.map((pe) => c.cosmos.base.v1beta1.Coin.fromObject(pe))), Y;
          }
          toObject() {
            const Q = {};
            return this.proposal_id != null && (Q.proposal_id = this.proposal_id), this.depositor != null && (Q.depositor = this.depositor), this.amount != null && (Q.amount = this.amount.map((Y) => Y.toObject())), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (this.proposal_id !== void 0 && Y.writeUint64(1, this.proposal_id), typeof this.depositor == "string" && this.depositor.length && Y.writeString(2, this.depositor), this.amount !== void 0 && Y.writeRepeatedMessage(3, this.amount, (pe) => pe.serialize(Y)), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new V();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  pe.proposal_id = Y.readUint64();
                  break;
                case 2:
                  pe.depositor = Y.readString();
                  break;
                case 3:
                  Y.readMessage(pe.amount, () => S.Message.addToRepeatedWrapperField(pe, 3, c.cosmos.base.v1beta1.Coin.deserialize(Y), c.cosmos.base.v1beta1.Coin));
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return V.deserialize(Q);
          }
        }
        O.Deposit = V;
        class M extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [7], []), !Array.isArray(Q) && typeof Q == "object" && ("proposal_id" in Q && Q.proposal_id != null && (this.proposal_id = Q.proposal_id), "content" in Q && Q.content != null && (this.content = Q.content), "status" in Q && Q.status != null && (this.status = Q.status), "final_tally_result" in Q && Q.final_tally_result != null && (this.final_tally_result = Q.final_tally_result), "submit_time" in Q && Q.submit_time != null && (this.submit_time = Q.submit_time), "deposit_end_time" in Q && Q.deposit_end_time != null && (this.deposit_end_time = Q.deposit_end_time), "total_deposit" in Q && Q.total_deposit != null && (this.total_deposit = Q.total_deposit), "voting_start_time" in Q && Q.voting_start_time != null && (this.voting_start_time = Q.voting_start_time), "voting_end_time" in Q && Q.voting_end_time != null && (this.voting_end_time = Q.voting_end_time));
          }
          get proposal_id() {
            return S.Message.getField(this, 1);
          }
          set proposal_id(Q) {
            S.Message.setField(this, 1, Q);
          }
          get content() {
            return S.Message.getWrapperField(this, m.google.protobuf.Any, 2);
          }
          set content(Q) {
            S.Message.setWrapperField(this, 2, Q);
          }
          get status() {
            return S.Message.getField(this, 3);
          }
          set status(Q) {
            S.Message.setField(this, 3, Q);
          }
          get final_tally_result() {
            return S.Message.getWrapperField(this, G, 4);
          }
          set final_tally_result(Q) {
            S.Message.setWrapperField(this, 4, Q);
          }
          get submit_time() {
            return S.Message.getWrapperField(this, d.google.protobuf.Timestamp, 5);
          }
          set submit_time(Q) {
            S.Message.setWrapperField(this, 5, Q);
          }
          get deposit_end_time() {
            return S.Message.getWrapperField(this, d.google.protobuf.Timestamp, 6);
          }
          set deposit_end_time(Q) {
            S.Message.setWrapperField(this, 6, Q);
          }
          get total_deposit() {
            return S.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 7);
          }
          set total_deposit(Q) {
            S.Message.setRepeatedWrapperField(this, 7, Q);
          }
          get voting_start_time() {
            return S.Message.getWrapperField(this, d.google.protobuf.Timestamp, 8);
          }
          set voting_start_time(Q) {
            S.Message.setWrapperField(this, 8, Q);
          }
          get voting_end_time() {
            return S.Message.getWrapperField(this, d.google.protobuf.Timestamp, 9);
          }
          set voting_end_time(Q) {
            S.Message.setWrapperField(this, 9, Q);
          }
          static fromObject(Q) {
            const Y = new M({});
            return Q.proposal_id != null && (Y.proposal_id = Q.proposal_id), Q.content != null && (Y.content = m.google.protobuf.Any.fromObject(Q.content)), Q.status != null && (Y.status = Q.status), Q.final_tally_result != null && (Y.final_tally_result = G.fromObject(Q.final_tally_result)), Q.submit_time != null && (Y.submit_time = d.google.protobuf.Timestamp.fromObject(Q.submit_time)), Q.deposit_end_time != null && (Y.deposit_end_time = d.google.protobuf.Timestamp.fromObject(Q.deposit_end_time)), Q.total_deposit != null && (Y.total_deposit = Q.total_deposit.map((pe) => c.cosmos.base.v1beta1.Coin.fromObject(pe))), Q.voting_start_time != null && (Y.voting_start_time = d.google.protobuf.Timestamp.fromObject(Q.voting_start_time)), Q.voting_end_time != null && (Y.voting_end_time = d.google.protobuf.Timestamp.fromObject(Q.voting_end_time)), Y;
          }
          toObject() {
            const Q = {};
            return this.proposal_id != null && (Q.proposal_id = this.proposal_id), this.content != null && (Q.content = this.content.toObject()), this.status != null && (Q.status = this.status), this.final_tally_result != null && (Q.final_tally_result = this.final_tally_result.toObject()), this.submit_time != null && (Q.submit_time = this.submit_time.toObject()), this.deposit_end_time != null && (Q.deposit_end_time = this.deposit_end_time.toObject()), this.total_deposit != null && (Q.total_deposit = this.total_deposit.map((Y) => Y.toObject())), this.voting_start_time != null && (Q.voting_start_time = this.voting_start_time.toObject()), this.voting_end_time != null && (Q.voting_end_time = this.voting_end_time.toObject()), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (this.proposal_id !== void 0 && Y.writeUint64(1, this.proposal_id), this.content !== void 0 && Y.writeMessage(2, this.content, () => this.content.serialize(Y)), this.status !== void 0 && Y.writeEnum(3, this.status), this.final_tally_result !== void 0 && Y.writeMessage(4, this.final_tally_result, () => this.final_tally_result.serialize(Y)), this.submit_time !== void 0 && Y.writeMessage(5, this.submit_time, () => this.submit_time.serialize(Y)), this.deposit_end_time !== void 0 && Y.writeMessage(6, this.deposit_end_time, () => this.deposit_end_time.serialize(Y)), this.total_deposit !== void 0 && Y.writeRepeatedMessage(7, this.total_deposit, (pe) => pe.serialize(Y)), this.voting_start_time !== void 0 && Y.writeMessage(8, this.voting_start_time, () => this.voting_start_time.serialize(Y)), this.voting_end_time !== void 0 && Y.writeMessage(9, this.voting_end_time, () => this.voting_end_time.serialize(Y)), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new M();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  pe.proposal_id = Y.readUint64();
                  break;
                case 2:
                  Y.readMessage(pe.content, () => pe.content = m.google.protobuf.Any.deserialize(Y));
                  break;
                case 3:
                  pe.status = Y.readEnum();
                  break;
                case 4:
                  Y.readMessage(pe.final_tally_result, () => pe.final_tally_result = G.deserialize(Y));
                  break;
                case 5:
                  Y.readMessage(pe.submit_time, () => pe.submit_time = d.google.protobuf.Timestamp.deserialize(Y));
                  break;
                case 6:
                  Y.readMessage(pe.deposit_end_time, () => pe.deposit_end_time = d.google.protobuf.Timestamp.deserialize(Y));
                  break;
                case 7:
                  Y.readMessage(pe.total_deposit, () => S.Message.addToRepeatedWrapperField(pe, 7, c.cosmos.base.v1beta1.Coin.deserialize(Y), c.cosmos.base.v1beta1.Coin));
                  break;
                case 8:
                  Y.readMessage(pe.voting_start_time, () => pe.voting_start_time = d.google.protobuf.Timestamp.deserialize(Y));
                  break;
                case 9:
                  Y.readMessage(pe.voting_end_time, () => pe.voting_end_time = d.google.protobuf.Timestamp.deserialize(Y));
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return M.deserialize(Q);
          }
        }
        O.Proposal = M;
        class G extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [], []), !Array.isArray(Q) && typeof Q == "object" && ("yes" in Q && Q.yes != null && (this.yes = Q.yes), "abstain" in Q && Q.abstain != null && (this.abstain = Q.abstain), "no" in Q && Q.no != null && (this.no = Q.no), "no_with_veto" in Q && Q.no_with_veto != null && (this.no_with_veto = Q.no_with_veto));
          }
          get yes() {
            return S.Message.getField(this, 1);
          }
          set yes(Q) {
            S.Message.setField(this, 1, Q);
          }
          get abstain() {
            return S.Message.getField(this, 2);
          }
          set abstain(Q) {
            S.Message.setField(this, 2, Q);
          }
          get no() {
            return S.Message.getField(this, 3);
          }
          set no(Q) {
            S.Message.setField(this, 3, Q);
          }
          get no_with_veto() {
            return S.Message.getField(this, 4);
          }
          set no_with_veto(Q) {
            S.Message.setField(this, 4, Q);
          }
          static fromObject(Q) {
            const Y = new G({});
            return Q.yes != null && (Y.yes = Q.yes), Q.abstain != null && (Y.abstain = Q.abstain), Q.no != null && (Y.no = Q.no), Q.no_with_veto != null && (Y.no_with_veto = Q.no_with_veto), Y;
          }
          toObject() {
            const Q = {};
            return this.yes != null && (Q.yes = this.yes), this.abstain != null && (Q.abstain = this.abstain), this.no != null && (Q.no = this.no), this.no_with_veto != null && (Q.no_with_veto = this.no_with_veto), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (typeof this.yes == "string" && this.yes.length && Y.writeString(1, this.yes), typeof this.abstain == "string" && this.abstain.length && Y.writeString(2, this.abstain), typeof this.no == "string" && this.no.length && Y.writeString(3, this.no), typeof this.no_with_veto == "string" && this.no_with_veto.length && Y.writeString(4, this.no_with_veto), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new G();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  pe.yes = Y.readString();
                  break;
                case 2:
                  pe.abstain = Y.readString();
                  break;
                case 3:
                  pe.no = Y.readString();
                  break;
                case 4:
                  pe.no_with_veto = Y.readString();
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return G.deserialize(Q);
          }
        }
        O.TallyResult = G;
        class k extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [4], []), !Array.isArray(Q) && typeof Q == "object" && ("proposal_id" in Q && Q.proposal_id != null && (this.proposal_id = Q.proposal_id), "voter" in Q && Q.voter != null && (this.voter = Q.voter), "option" in Q && Q.option != null && (this.option = Q.option), "options" in Q && Q.options != null && (this.options = Q.options));
          }
          get proposal_id() {
            return S.Message.getField(this, 1);
          }
          set proposal_id(Q) {
            S.Message.setField(this, 1, Q);
          }
          get voter() {
            return S.Message.getField(this, 2);
          }
          set voter(Q) {
            S.Message.setField(this, 2, Q);
          }
          get option() {
            return S.Message.getField(this, 3);
          }
          set option(Q) {
            S.Message.setField(this, 3, Q);
          }
          get options() {
            return S.Message.getRepeatedWrapperField(this, T, 4);
          }
          set options(Q) {
            S.Message.setRepeatedWrapperField(this, 4, Q);
          }
          static fromObject(Q) {
            const Y = new k({});
            return Q.proposal_id != null && (Y.proposal_id = Q.proposal_id), Q.voter != null && (Y.voter = Q.voter), Q.option != null && (Y.option = Q.option), Q.options != null && (Y.options = Q.options.map((pe) => T.fromObject(pe))), Y;
          }
          toObject() {
            const Q = {};
            return this.proposal_id != null && (Q.proposal_id = this.proposal_id), this.voter != null && (Q.voter = this.voter), this.option != null && (Q.option = this.option), this.options != null && (Q.options = this.options.map((Y) => Y.toObject())), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (this.proposal_id !== void 0 && Y.writeUint64(1, this.proposal_id), typeof this.voter == "string" && this.voter.length && Y.writeString(2, this.voter), this.option !== void 0 && Y.writeEnum(3, this.option), this.options !== void 0 && Y.writeRepeatedMessage(4, this.options, (pe) => pe.serialize(Y)), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new k();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  pe.proposal_id = Y.readUint64();
                  break;
                case 2:
                  pe.voter = Y.readString();
                  break;
                case 3:
                  pe.option = Y.readEnum();
                  break;
                case 4:
                  Y.readMessage(pe.options, () => S.Message.addToRepeatedWrapperField(pe, 4, T.deserialize(Y), T));
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return k.deserialize(Q);
          }
        }
        O.Vote = k;
        class F extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [1], []), !Array.isArray(Q) && typeof Q == "object" && ("min_deposit" in Q && Q.min_deposit != null && (this.min_deposit = Q.min_deposit), "max_deposit_period" in Q && Q.max_deposit_period != null && (this.max_deposit_period = Q.max_deposit_period));
          }
          get min_deposit() {
            return S.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 1);
          }
          set min_deposit(Q) {
            S.Message.setRepeatedWrapperField(this, 1, Q);
          }
          get max_deposit_period() {
            return S.Message.getWrapperField(this, v.google.protobuf.Duration, 2);
          }
          set max_deposit_period(Q) {
            S.Message.setWrapperField(this, 2, Q);
          }
          static fromObject(Q) {
            const Y = new F({});
            return Q.min_deposit != null && (Y.min_deposit = Q.min_deposit.map((pe) => c.cosmos.base.v1beta1.Coin.fromObject(pe))), Q.max_deposit_period != null && (Y.max_deposit_period = v.google.protobuf.Duration.fromObject(Q.max_deposit_period)), Y;
          }
          toObject() {
            const Q = {};
            return this.min_deposit != null && (Q.min_deposit = this.min_deposit.map((Y) => Y.toObject())), this.max_deposit_period != null && (Q.max_deposit_period = this.max_deposit_period.toObject()), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (this.min_deposit !== void 0 && Y.writeRepeatedMessage(1, this.min_deposit, (pe) => pe.serialize(Y)), this.max_deposit_period !== void 0 && Y.writeMessage(2, this.max_deposit_period, () => this.max_deposit_period.serialize(Y)), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new F();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  Y.readMessage(pe.min_deposit, () => S.Message.addToRepeatedWrapperField(pe, 1, c.cosmos.base.v1beta1.Coin.deserialize(Y), c.cosmos.base.v1beta1.Coin));
                  break;
                case 2:
                  Y.readMessage(pe.max_deposit_period, () => pe.max_deposit_period = v.google.protobuf.Duration.deserialize(Y));
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return F.deserialize(Q);
          }
        }
        O.DepositParams = F;
        class X extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [], []), !Array.isArray(Q) && typeof Q == "object" && "voting_period" in Q && Q.voting_period != null && (this.voting_period = Q.voting_period);
          }
          get voting_period() {
            return S.Message.getWrapperField(this, v.google.protobuf.Duration, 1);
          }
          set voting_period(Q) {
            S.Message.setWrapperField(this, 1, Q);
          }
          static fromObject(Q) {
            const Y = new X({});
            return Q.voting_period != null && (Y.voting_period = v.google.protobuf.Duration.fromObject(Q.voting_period)), Y;
          }
          toObject() {
            const Q = {};
            return this.voting_period != null && (Q.voting_period = this.voting_period.toObject()), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (this.voting_period !== void 0 && Y.writeMessage(1, this.voting_period, () => this.voting_period.serialize(Y)), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new X();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  Y.readMessage(pe.voting_period, () => pe.voting_period = v.google.protobuf.Duration.deserialize(Y));
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return X.deserialize(Q);
          }
        }
        O.VotingParams = X;
        class ee extends S.Message {
          constructor(Q) {
            super(), S.Message.initialize(this, Array.isArray(Q) ? Q : [], 0, -1, [], []), !Array.isArray(Q) && typeof Q == "object" && ("quorum" in Q && Q.quorum != null && (this.quorum = Q.quorum), "threshold" in Q && Q.threshold != null && (this.threshold = Q.threshold), "veto_threshold" in Q && Q.veto_threshold != null && (this.veto_threshold = Q.veto_threshold));
          }
          get quorum() {
            return S.Message.getField(this, 1);
          }
          set quorum(Q) {
            S.Message.setField(this, 1, Q);
          }
          get threshold() {
            return S.Message.getField(this, 2);
          }
          set threshold(Q) {
            S.Message.setField(this, 2, Q);
          }
          get veto_threshold() {
            return S.Message.getField(this, 3);
          }
          set veto_threshold(Q) {
            S.Message.setField(this, 3, Q);
          }
          static fromObject(Q) {
            const Y = new ee({});
            return Q.quorum != null && (Y.quorum = Q.quorum), Q.threshold != null && (Y.threshold = Q.threshold), Q.veto_threshold != null && (Y.veto_threshold = Q.veto_threshold), Y;
          }
          toObject() {
            const Q = {};
            return this.quorum != null && (Q.quorum = this.quorum), this.threshold != null && (Q.threshold = this.threshold), this.veto_threshold != null && (Q.veto_threshold = this.veto_threshold), Q;
          }
          serialize(Q) {
            const Y = Q || new S.BinaryWriter();
            if (this.quorum !== void 0 && Y.writeBytes(1, this.quorum), this.threshold !== void 0 && Y.writeBytes(2, this.threshold), this.veto_threshold !== void 0 && Y.writeBytes(3, this.veto_threshold), !Q)
              return Y.getResultBuffer();
          }
          static deserialize(Q) {
            const Y = Q instanceof S.BinaryReader ? Q : new S.BinaryReader(Q), pe = new ee();
            for (; Y.nextField() && !Y.isEndGroup(); )
              switch (Y.getFieldNumber()) {
                case 1:
                  pe.quorum = Y.readBytes();
                  break;
                case 2:
                  pe.threshold = Y.readBytes();
                  break;
                case 3:
                  pe.veto_threshold = Y.readBytes();
                  break;
                default:
                  Y.skipField();
              }
            return pe;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(Q) {
            return ee.deserialize(Q);
          }
        }
        O.TallyParams = ee;
      })(E.v1beta1 || (E.v1beta1 = {}));
    })($.gov || ($.gov = {}));
  })(e.cosmos || (e.cosmos = {}));
})(gov$2);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(S, $, E, O) {
    O === void 0 && (O = E);
    var T = Object.getOwnPropertyDescriptor($, E);
    (!T || ("get" in T ? !$.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return $[E];
    } }), Object.defineProperty(S, O, T);
  } : function(S, $, E, O) {
    O === void 0 && (O = E), S[O] = $[E];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(S, $) {
    Object.defineProperty(S, "default", { enumerable: !0, value: $ });
  } : function(S, $) {
    S.default = $;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(S) {
    if (S && S.__esModule)
      return S;
    var $ = {};
    if (S != null)
      for (var E in S)
        E !== "default" && Object.prototype.hasOwnProperty.call(S, E) && n($, S, E);
    return o($, S), $;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(coin$6), d = u(gov$2), m = u(any), v = u(googleProtobuf);
  (function(S) {
    (function($) {
      (function(E) {
        class O extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [2], []), !Array.isArray(ee) && typeof ee == "object" && ("content" in ee && ee.content != null && (this.content = ee.content), "initial_deposit" in ee && ee.initial_deposit != null && (this.initial_deposit = ee.initial_deposit), "proposer" in ee && ee.proposer != null && (this.proposer = ee.proposer));
          }
          get content() {
            return v.Message.getWrapperField(this, m.google.protobuf.Any, 1);
          }
          set content(ee) {
            v.Message.setWrapperField(this, 1, ee);
          }
          get initial_deposit() {
            return v.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 2);
          }
          set initial_deposit(ee) {
            v.Message.setRepeatedWrapperField(this, 2, ee);
          }
          get proposer() {
            return v.Message.getField(this, 3);
          }
          set proposer(ee) {
            v.Message.setField(this, 3, ee);
          }
          static fromObject(ee) {
            const ue = new O({});
            return ee.content != null && (ue.content = m.google.protobuf.Any.fromObject(ee.content)), ee.initial_deposit != null && (ue.initial_deposit = ee.initial_deposit.map((Q) => c.cosmos.base.v1beta1.Coin.fromObject(Q))), ee.proposer != null && (ue.proposer = ee.proposer), ue;
          }
          toObject() {
            const ee = {};
            return this.content != null && (ee.content = this.content.toObject()), this.initial_deposit != null && (ee.initial_deposit = this.initial_deposit.map((ue) => ue.toObject())), this.proposer != null && (ee.proposer = this.proposer), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.content !== void 0 && ue.writeMessage(1, this.content, () => this.content.serialize(ue)), this.initial_deposit !== void 0 && ue.writeRepeatedMessage(2, this.initial_deposit, (Q) => Q.serialize(ue)), typeof this.proposer == "string" && this.proposer.length && ue.writeString(3, this.proposer), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new O();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  ue.readMessage(Q.content, () => Q.content = m.google.protobuf.Any.deserialize(ue));
                  break;
                case 2:
                  ue.readMessage(Q.initial_deposit, () => v.Message.addToRepeatedWrapperField(Q, 2, c.cosmos.base.v1beta1.Coin.deserialize(ue), c.cosmos.base.v1beta1.Coin));
                  break;
                case 3:
                  Q.proposer = ue.readString();
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return O.deserialize(ee);
          }
        }
        E.MsgSubmitProposal = O;
        class T extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [], []), !Array.isArray(ee) && typeof ee == "object" && "proposal_id" in ee && ee.proposal_id != null && (this.proposal_id = ee.proposal_id);
          }
          get proposal_id() {
            return v.Message.getField(this, 1);
          }
          set proposal_id(ee) {
            v.Message.setField(this, 1, ee);
          }
          static fromObject(ee) {
            const ue = new T({});
            return ee.proposal_id != null && (ue.proposal_id = ee.proposal_id), ue;
          }
          toObject() {
            const ee = {};
            return this.proposal_id != null && (ee.proposal_id = this.proposal_id), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.proposal_id !== void 0 && ue.writeUint64(1, this.proposal_id), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new T();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  Q.proposal_id = ue.readUint64();
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return T.deserialize(ee);
          }
        }
        E.MsgSubmitProposalResponse = T;
        class y extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [], []), !Array.isArray(ee) && typeof ee == "object" && ("proposal_id" in ee && ee.proposal_id != null && (this.proposal_id = ee.proposal_id), "voter" in ee && ee.voter != null && (this.voter = ee.voter), "option" in ee && ee.option != null && (this.option = ee.option));
          }
          get proposal_id() {
            return v.Message.getField(this, 1);
          }
          set proposal_id(ee) {
            v.Message.setField(this, 1, ee);
          }
          get voter() {
            return v.Message.getField(this, 2);
          }
          set voter(ee) {
            v.Message.setField(this, 2, ee);
          }
          get option() {
            return v.Message.getField(this, 3);
          }
          set option(ee) {
            v.Message.setField(this, 3, ee);
          }
          static fromObject(ee) {
            const ue = new y({});
            return ee.proposal_id != null && (ue.proposal_id = ee.proposal_id), ee.voter != null && (ue.voter = ee.voter), ee.option != null && (ue.option = ee.option), ue;
          }
          toObject() {
            const ee = {};
            return this.proposal_id != null && (ee.proposal_id = this.proposal_id), this.voter != null && (ee.voter = this.voter), this.option != null && (ee.option = this.option), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.proposal_id !== void 0 && ue.writeUint64(1, this.proposal_id), typeof this.voter == "string" && this.voter.length && ue.writeString(2, this.voter), this.option !== void 0 && ue.writeEnum(3, this.option), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new y();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  Q.proposal_id = ue.readUint64();
                  break;
                case 2:
                  Q.voter = ue.readString();
                  break;
                case 3:
                  Q.option = ue.readEnum();
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return y.deserialize(ee);
          }
        }
        E.MsgVote = y;
        class V extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [], []);
          }
          static fromObject(ee) {
            return new V({});
          }
          toObject() {
            return {};
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (!ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new V();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return V.deserialize(ee);
          }
        }
        E.MsgVoteResponse = V;
        class M extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [3], []), !Array.isArray(ee) && typeof ee == "object" && ("proposal_id" in ee && ee.proposal_id != null && (this.proposal_id = ee.proposal_id), "voter" in ee && ee.voter != null && (this.voter = ee.voter), "options" in ee && ee.options != null && (this.options = ee.options));
          }
          get proposal_id() {
            return v.Message.getField(this, 1);
          }
          set proposal_id(ee) {
            v.Message.setField(this, 1, ee);
          }
          get voter() {
            return v.Message.getField(this, 2);
          }
          set voter(ee) {
            v.Message.setField(this, 2, ee);
          }
          get options() {
            return v.Message.getRepeatedWrapperField(this, d.cosmos.gov.v1beta1.WeightedVoteOption, 3);
          }
          set options(ee) {
            v.Message.setRepeatedWrapperField(this, 3, ee);
          }
          static fromObject(ee) {
            const ue = new M({});
            return ee.proposal_id != null && (ue.proposal_id = ee.proposal_id), ee.voter != null && (ue.voter = ee.voter), ee.options != null && (ue.options = ee.options.map((Q) => d.cosmos.gov.v1beta1.WeightedVoteOption.fromObject(Q))), ue;
          }
          toObject() {
            const ee = {};
            return this.proposal_id != null && (ee.proposal_id = this.proposal_id), this.voter != null && (ee.voter = this.voter), this.options != null && (ee.options = this.options.map((ue) => ue.toObject())), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.proposal_id !== void 0 && ue.writeUint64(1, this.proposal_id), typeof this.voter == "string" && this.voter.length && ue.writeString(2, this.voter), this.options !== void 0 && ue.writeRepeatedMessage(3, this.options, (Q) => Q.serialize(ue)), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new M();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  Q.proposal_id = ue.readUint64();
                  break;
                case 2:
                  Q.voter = ue.readString();
                  break;
                case 3:
                  ue.readMessage(Q.options, () => v.Message.addToRepeatedWrapperField(Q, 3, d.cosmos.gov.v1beta1.WeightedVoteOption.deserialize(ue), d.cosmos.gov.v1beta1.WeightedVoteOption));
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return M.deserialize(ee);
          }
        }
        E.MsgVoteWeighted = M;
        class G extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [], []);
          }
          static fromObject(ee) {
            return new G({});
          }
          toObject() {
            return {};
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (!ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new G();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return G.deserialize(ee);
          }
        }
        E.MsgVoteWeightedResponse = G;
        class k extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [3], []), !Array.isArray(ee) && typeof ee == "object" && ("proposal_id" in ee && ee.proposal_id != null && (this.proposal_id = ee.proposal_id), "depositor" in ee && ee.depositor != null && (this.depositor = ee.depositor), "amount" in ee && ee.amount != null && (this.amount = ee.amount));
          }
          get proposal_id() {
            return v.Message.getField(this, 1);
          }
          set proposal_id(ee) {
            v.Message.setField(this, 1, ee);
          }
          get depositor() {
            return v.Message.getField(this, 2);
          }
          set depositor(ee) {
            v.Message.setField(this, 2, ee);
          }
          get amount() {
            return v.Message.getRepeatedWrapperField(this, c.cosmos.base.v1beta1.Coin, 3);
          }
          set amount(ee) {
            v.Message.setRepeatedWrapperField(this, 3, ee);
          }
          static fromObject(ee) {
            const ue = new k({});
            return ee.proposal_id != null && (ue.proposal_id = ee.proposal_id), ee.depositor != null && (ue.depositor = ee.depositor), ee.amount != null && (ue.amount = ee.amount.map((Q) => c.cosmos.base.v1beta1.Coin.fromObject(Q))), ue;
          }
          toObject() {
            const ee = {};
            return this.proposal_id != null && (ee.proposal_id = this.proposal_id), this.depositor != null && (ee.depositor = this.depositor), this.amount != null && (ee.amount = this.amount.map((ue) => ue.toObject())), ee;
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (this.proposal_id !== void 0 && ue.writeUint64(1, this.proposal_id), typeof this.depositor == "string" && this.depositor.length && ue.writeString(2, this.depositor), this.amount !== void 0 && ue.writeRepeatedMessage(3, this.amount, (Q) => Q.serialize(ue)), !ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new k();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                case 1:
                  Q.proposal_id = ue.readUint64();
                  break;
                case 2:
                  Q.depositor = ue.readString();
                  break;
                case 3:
                  ue.readMessage(Q.amount, () => v.Message.addToRepeatedWrapperField(Q, 3, c.cosmos.base.v1beta1.Coin.deserialize(ue), c.cosmos.base.v1beta1.Coin));
                  break;
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return k.deserialize(ee);
          }
        }
        E.MsgDeposit = k;
        class F extends v.Message {
          constructor(ee) {
            super(), v.Message.initialize(this, Array.isArray(ee) ? ee : [], 0, -1, [], []);
          }
          static fromObject(ee) {
            return new F({});
          }
          toObject() {
            return {};
          }
          serialize(ee) {
            const ue = ee || new v.BinaryWriter();
            if (!ee)
              return ue.getResultBuffer();
          }
          static deserialize(ee) {
            const ue = ee instanceof v.BinaryReader ? ee : new v.BinaryReader(ee), Q = new F();
            for (; ue.nextField() && !ue.isEndGroup(); )
              switch (ue.getFieldNumber()) {
                default:
                  ue.skipField();
              }
            return Q;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(ee) {
            return F.deserialize(ee);
          }
        }
        E.MsgDepositResponse = F;
      })($.v1beta1 || ($.v1beta1 = {}));
    })(S.gov || (S.gov = {}));
  })(e.cosmos || (e.cosmos = {}));
})(tx);
var __createBinding$6 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$6 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$6 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$6(n, e, o);
  return __setModuleDefault$6(n, e), n;
};
Object.defineProperty(vote, "__esModule", { value: !0 });
vote.createMsgVote = void 0;
const govTx = __importStar$6(tx);
function createMsgVote$1(e, n, o) {
  return {
    message: new govTx.cosmos.gov.v1beta1.MsgVote({
      proposal_id: e,
      voter: o,
      option: n
    }),
    path: "cosmos.gov.v1beta1.MsgVote"
  };
}
vote.createMsgVote = createMsgVote$1;
var web3Extension$1 = {}, web3$1 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ethermint = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      (function(v) {
        class S extends c.Message {
          constructor(E) {
            super(), c.Message.initialize(this, Array.isArray(E) ? E : [], 0, -1, [], []), !Array.isArray(E) && typeof E == "object" && ("typed_data_chain_id" in E && E.typed_data_chain_id != null && (this.typed_data_chain_id = E.typed_data_chain_id), "fee_payer" in E && E.fee_payer != null && (this.fee_payer = E.fee_payer), "fee_payer_sig" in E && E.fee_payer_sig != null && (this.fee_payer_sig = E.fee_payer_sig));
          }
          get typed_data_chain_id() {
            return c.Message.getField(this, 1);
          }
          set typed_data_chain_id(E) {
            c.Message.setField(this, 1, E);
          }
          get fee_payer() {
            return c.Message.getField(this, 2);
          }
          set fee_payer(E) {
            c.Message.setField(this, 2, E);
          }
          get fee_payer_sig() {
            return c.Message.getField(this, 3);
          }
          set fee_payer_sig(E) {
            c.Message.setField(this, 3, E);
          }
          static fromObject(E) {
            const O = new S({});
            return E.typed_data_chain_id != null && (O.typed_data_chain_id = E.typed_data_chain_id), E.fee_payer != null && (O.fee_payer = E.fee_payer), E.fee_payer_sig != null && (O.fee_payer_sig = E.fee_payer_sig), O;
          }
          toObject() {
            const E = {};
            return this.typed_data_chain_id != null && (E.typed_data_chain_id = this.typed_data_chain_id), this.fee_payer != null && (E.fee_payer = this.fee_payer), this.fee_payer_sig != null && (E.fee_payer_sig = this.fee_payer_sig), E;
          }
          serialize(E) {
            const O = E || new c.BinaryWriter();
            if (this.typed_data_chain_id !== void 0 && O.writeUint64(1, this.typed_data_chain_id), typeof this.fee_payer == "string" && this.fee_payer.length && O.writeString(2, this.fee_payer), this.fee_payer_sig !== void 0 && O.writeBytes(3, this.fee_payer_sig), !E)
              return O.getResultBuffer();
          }
          static deserialize(E) {
            const O = E instanceof c.BinaryReader ? E : new c.BinaryReader(E), T = new S();
            for (; O.nextField() && !O.isEndGroup(); )
              switch (O.getFieldNumber()) {
                case 1:
                  T.typed_data_chain_id = O.readUint64();
                  break;
                case 2:
                  T.fee_payer = O.readString();
                  break;
                case 3:
                  T.fee_payer_sig = O.readBytes();
                  break;
                default:
                  O.skipField();
              }
            return T;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(E) {
            return S.deserialize(E);
          }
        }
        v.ExtensionOptionsWeb3Tx = S;
      })(m.v1 || (m.v1 = {}));
    })(d.types || (d.types = {}));
  })(e.ethermint || (e.ethermint = {}));
})(web3$1);
var __createBinding$5 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$5 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$5 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$5(n, e, o);
  return __setModuleDefault$5(n, e), n;
};
Object.defineProperty(web3Extension$1, "__esModule", { value: !0 });
web3Extension$1.createWeb3Extension = void 0;
const web3 = __importStar$5(web3$1);
function createWeb3Extension(e, n, o) {
  return {
    message: new web3.ethermint.types.v1.ExtensionOptionsWeb3Tx({
      typed_data_chain_id: e,
      fee_payer: n,
      fee_payer_sig: o
    }),
    path: "ethermint.types.v1.ExtensionOptionsWeb3Tx"
  };
}
web3Extension$1.createWeb3Extension = createWeb3Extension;
var transaction = {}, sha3$2 = {}, sponge = {}, permute = {}, chi = {}, copy = function e(n, o) {
  return function(u, c) {
    var d = c * 2, m = o * 2;
    u[d] = n[m], u[d + 1] = n[m + 1];
  };
}, copy_1 = copy;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = o(copy_1);
  function o(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var u = function(m) {
    for (var v = m.A, S = m.C, $ = 0; $ < 25; $ += 5) {
      for (var E = 0; E < 5; E++)
        (0, n.default)(v, $ + E)(S, E);
      for (var O = 0; O < 5; O++) {
        var T = ($ + O) * 2, y = (O + 1) % 5 * 2, V = (O + 2) % 5 * 2;
        v[T] ^= ~S[y] & S[V], v[T + 1] ^= ~S[y + 1] & S[V + 1];
      }
    }
  }, c = u;
  e.default = c;
})(chi);
var iota = {}, roundConstants = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = new Uint32Array([0, 1, 0, 32898, 2147483648, 32906, 2147483648, 2147516416, 0, 32907, 0, 2147483649, 2147483648, 2147516545, 2147483648, 32777, 0, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 2147483648, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 0, 32778, 2147483648, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 0, 2147483649, 2147483648, 2147516424]), o = n;
  e.default = o;
})(roundConstants);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = o(roundConstants);
  function o(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var u = function(m) {
    var v = m.A, S = m.roundIndex, $ = S * 2;
    v[0] ^= n.default[$], v[1] ^= n.default[$ + 1];
  }, c = u;
  e.default = c;
})(iota);
var rhoPi = {}, piShuffles = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = [10, 7, 11, 17, 18, 3, 5, 16, 8, 21, 24, 4, 15, 23, 19, 13, 12, 2, 20, 14, 22, 9, 6, 1], o = n;
  e.default = o;
})(piShuffles);
var rhoOffsets = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = [1, 3, 6, 10, 15, 21, 28, 36, 45, 55, 2, 14, 27, 41, 56, 8, 25, 43, 62, 18, 39, 61, 20, 44], o = n;
  e.default = o;
})(rhoOffsets);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = c(piShuffles), o = c(rhoOffsets), u = c(copy_1);
  function c(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var d = function(S) {
    var $ = S.A, E = S.C, O = S.W;
    (0, u.default)($, 1)(O, 0);
    for (var T = 0, y = 0, V = 0, M = 32, G = 0; G < 24; G++) {
      var k = n.default[G], F = o.default[G];
      (0, u.default)($, k)(E, 0), T = O[0], y = O[1], M = 32 - F, V = F < 32 ? 0 : 1, O[V] = T << F | y >>> M, O[(V + 1) % 2] = y << F | T >>> M, (0, u.default)(O, 0)($, k), (0, u.default)(E, 0)(O, 0);
    }
  }, m = d;
  e.default = m;
})(rhoPi);
var theta = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = o(copy_1);
  function o(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var u = function(m) {
    for (var v = m.A, S = m.C, $ = m.D, E = m.W, O = 0, T = 0, y = 0; y < 5; y++) {
      var V = y * 2, M = (y + 5) * 2, G = (y + 10) * 2, k = (y + 15) * 2, F = (y + 20) * 2;
      S[V] = v[V] ^ v[M] ^ v[G] ^ v[k] ^ v[F], S[V + 1] = v[V + 1] ^ v[M + 1] ^ v[G + 1] ^ v[k + 1] ^ v[F + 1];
    }
    for (var X = 0; X < 5; X++) {
      (0, n.default)(S, (X + 1) % 5)(E, 0), O = E[0], T = E[1], E[0] = O << 1 | T >>> 31, E[1] = T << 1 | O >>> 31, $[X * 2] = S[(X + 4) % 5 * 2] ^ E[0], $[X * 2 + 1] = S[(X + 4) % 5 * 2 + 1] ^ E[1];
      for (var ee = 0; ee < 25; ee += 5)
        v[(ee + X) * 2] ^= $[X * 2], v[(ee + X) * 2 + 1] ^= $[X * 2 + 1];
    }
  }, c = u;
  e.default = c;
})(theta);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = d(chi), o = d(iota), u = d(rhoPi), c = d(theta);
  function d(S) {
    return S && S.__esModule ? S : { default: S };
  }
  var m = function() {
    var $ = new Uint32Array(10), E = new Uint32Array(10), O = new Uint32Array(2);
    return function(T) {
      for (var y = 0; y < 24; y++)
        (0, c.default)({ A: T, C: $, D: E, W: O }), (0, u.default)({ A: T, C: $, W: O }), (0, n.default)({ A: T, C: $ }), (0, o.default)({ A: T, roundIndex: y });
      $.fill(0), E.fill(0), O.fill(0);
    };
  }, v = m;
  e.default = v;
})(permute);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var n = buffer$1, o = u(permute);
  function u(S) {
    return S && S.__esModule ? S : { default: S };
  }
  var c = function($, E) {
    for (var O = 0; O < $.length; O += 8) {
      var T = O / 4;
      E[T] ^= $[O + 7] << 24 | $[O + 6] << 16 | $[O + 5] << 8 | $[O + 4], E[T + 1] ^= $[O + 3] << 24 | $[O + 2] << 16 | $[O + 1] << 8 | $[O];
    }
    return E;
  }, d = function($, E) {
    for (var O = 0; O < E.length; O += 8) {
      var T = O / 4;
      E[O] = $[T + 1], E[O + 1] = $[T + 1] >>> 8, E[O + 2] = $[T + 1] >>> 16, E[O + 3] = $[T + 1] >>> 24, E[O + 4] = $[T], E[O + 5] = $[T] >>> 8, E[O + 6] = $[T] >>> 16, E[O + 7] = $[T] >>> 24;
    }
    return E;
  }, m = function($) {
    var E = this, O = $.capacity, T = $.padding, y = (0, o.default)(), V = 200, M = O / 8, G = V - O / 4, k = 0, F = new Uint32Array(V / 4), X = n.Buffer.allocUnsafe(G);
    return this.absorb = function(ee) {
      for (var ue = 0; ue < ee.length; ue++)
        X[k] = ee[ue], k += 1, k >= G && (c(X, F), y(F), k = 0);
      return E;
    }, this.squeeze = function() {
      var ee = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ue = { buffer: ee.buffer || n.Buffer.allocUnsafe(M), padding: ee.padding || T, queue: n.Buffer.allocUnsafe(X.length), state: new Uint32Array(F.length) };
      X.copy(ue.queue);
      for (var Q = 0; Q < F.length; Q++)
        ue.state[Q] = F[Q];
      ue.queue.fill(0, k), ue.queue[k] |= ue.padding, ue.queue[G - 1] |= 128, c(ue.queue, ue.state);
      for (var Y = 0; Y < ue.buffer.length; Y += G)
        y(ue.state), d(ue.state, ue.buffer.slice(Y, Y + G));
      return ue.buffer;
    }, this.reset = function() {
      return X.fill(0), F.fill(0), k = 0, E;
    }, this;
  }, v = m;
  e.default = v;
})(sponge);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = e.SHAKE = e.SHA3Hash = e.SHA3 = e.Keccak = void 0;
  var n = buffer$1, o = u(sponge);
  function u(E) {
    return E && E.__esModule ? E : { default: E };
  }
  var c = function(O) {
    var T = O.allowedSizes, y = O.defaultSize, V = O.padding;
    return function M() {
      var G = this, k = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : y;
      if (!this || this.constructor !== M)
        return new M(k);
      if (T && !T.includes(k))
        throw new Error("Unsupported hash length");
      var F = new o.default({ capacity: k });
      return this.update = function(X) {
        var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "utf8";
        if (n.Buffer.isBuffer(X))
          return F.absorb(X), G;
        if (typeof X == "string")
          return G.update(n.Buffer.from(X, ee));
        throw new TypeError("Not a string or buffer");
      }, this.digest = function() {
        var X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "binary", ee = typeof X == "string" ? { format: X } : X, ue = F.squeeze({ buffer: ee.buffer, padding: ee.padding || V });
        return ee.format && ee.format !== "binary" ? ue.toString(ee.format) : ue;
      }, this.reset = function() {
        return F.reset(), G;
      }, this;
    };
  }, d = c({ allowedSizes: [224, 256, 384, 512], defaultSize: 512, padding: 1 });
  e.Keccak = d;
  var m = c({ allowedSizes: [224, 256, 384, 512], defaultSize: 512, padding: 6 });
  e.SHA3 = m;
  var v = c({ allowedSizes: [128, 256], defaultSize: 256, padding: 31 });
  e.SHAKE = v;
  var S = d;
  e.SHA3Hash = S, m.SHA3Hash = S;
  var $ = m;
  e.default = $;
})(sha3$2);
var signing$1 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, S, $, E) {
    E === void 0 && (E = $);
    var O = Object.getOwnPropertyDescriptor(S, $);
    (!O || ("get" in O ? !S.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return S[$];
    } }), Object.defineProperty(v, E, O);
  } : function(v, S, $, E) {
    E === void 0 && (E = $), v[E] = S[$];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, S) {
    Object.defineProperty(v, "default", { enumerable: !0, value: S });
  } : function(v, S) {
    v.default = S;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var S = {};
    if (v != null)
      for (var $ in v)
        $ !== "default" && Object.prototype.hasOwnProperty.call(v, $) && n(S, v, $);
    return o(S, v), S;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(multisig$1), d = u(any), m = u(googleProtobuf);
  (function(v) {
    (function(S) {
      (function($) {
        (function(E) {
          (function(y) {
            y[y.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", y[y.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", y[y.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", y[y.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", y[y.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191";
          })(E.SignMode || (E.SignMode = {}));
          class O extends m.Message {
            constructor(V) {
              super(), m.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [1], []), !Array.isArray(V) && typeof V == "object" && "signatures" in V && V.signatures != null && (this.signatures = V.signatures);
            }
            get signatures() {
              return m.Message.getRepeatedWrapperField(this, T, 1);
            }
            set signatures(V) {
              m.Message.setRepeatedWrapperField(this, 1, V);
            }
            static fromObject(V) {
              const M = new O({});
              return V.signatures != null && (M.signatures = V.signatures.map((G) => T.fromObject(G))), M;
            }
            toObject() {
              const V = {};
              return this.signatures != null && (V.signatures = this.signatures.map((M) => M.toObject())), V;
            }
            serialize(V) {
              const M = V || new m.BinaryWriter();
              if (this.signatures !== void 0 && M.writeRepeatedMessage(1, this.signatures, (G) => G.serialize(M)), !V)
                return M.getResultBuffer();
            }
            static deserialize(V) {
              const M = V instanceof m.BinaryReader ? V : new m.BinaryReader(V), G = new O();
              for (; M.nextField() && !M.isEndGroup(); )
                switch (M.getFieldNumber()) {
                  case 1:
                    M.readMessage(G.signatures, () => m.Message.addToRepeatedWrapperField(G, 1, T.deserialize(M), T));
                    break;
                  default:
                    M.skipField();
                }
              return G;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(V) {
              return O.deserialize(V);
            }
          }
          E.SignatureDescriptors = O;
          class T extends m.Message {
            constructor(V) {
              super(), m.Message.initialize(this, Array.isArray(V) ? V : [], 0, -1, [], []), !Array.isArray(V) && typeof V == "object" && ("public_key" in V && V.public_key != null && (this.public_key = V.public_key), "data" in V && V.data != null && (this.data = V.data), "sequence" in V && V.sequence != null && (this.sequence = V.sequence));
            }
            get public_key() {
              return m.Message.getWrapperField(this, d.google.protobuf.Any, 1);
            }
            set public_key(V) {
              m.Message.setWrapperField(this, 1, V);
            }
            get data() {
              return m.Message.getWrapperField(this, T.Data, 2);
            }
            set data(V) {
              m.Message.setWrapperField(this, 2, V);
            }
            get sequence() {
              return m.Message.getField(this, 3);
            }
            set sequence(V) {
              m.Message.setField(this, 3, V);
            }
            static fromObject(V) {
              const M = new T({});
              return V.public_key != null && (M.public_key = d.google.protobuf.Any.fromObject(V.public_key)), V.data != null && (M.data = T.Data.fromObject(V.data)), V.sequence != null && (M.sequence = V.sequence), M;
            }
            toObject() {
              const V = {};
              return this.public_key != null && (V.public_key = this.public_key.toObject()), this.data != null && (V.data = this.data.toObject()), this.sequence != null && (V.sequence = this.sequence), V;
            }
            serialize(V) {
              const M = V || new m.BinaryWriter();
              if (this.public_key !== void 0 && M.writeMessage(1, this.public_key, () => this.public_key.serialize(M)), this.data !== void 0 && M.writeMessage(2, this.data, () => this.data.serialize(M)), this.sequence !== void 0 && M.writeUint64(3, this.sequence), !V)
                return M.getResultBuffer();
            }
            static deserialize(V) {
              const M = V instanceof m.BinaryReader ? V : new m.BinaryReader(V), G = new T();
              for (; M.nextField() && !M.isEndGroup(); )
                switch (M.getFieldNumber()) {
                  case 1:
                    M.readMessage(G.public_key, () => G.public_key = d.google.protobuf.Any.deserialize(M));
                    break;
                  case 2:
                    M.readMessage(G.data, () => G.data = T.Data.deserialize(M));
                    break;
                  case 3:
                    G.sequence = M.readUint64();
                    break;
                  default:
                    M.skipField();
                }
              return G;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(V) {
              return T.deserialize(V);
            }
          }
          E.SignatureDescriptor = T, function(y) {
            class V extends m.Message {
              constructor(G) {
                super(), m.Message.initialize(this, Array.isArray(G) ? G : [], 0, -1, [], [[1, 2]]), !Array.isArray(G) && typeof G == "object" && ("single" in G && G.single != null && (this.single = G.single), "multi" in G && G.multi != null && (this.multi = G.multi));
              }
              get single() {
                return m.Message.getWrapperField(this, y.Data.Single, 1);
              }
              set single(G) {
                m.Message.setOneofWrapperField(this, 1, [1, 2], G);
              }
              get multi() {
                return m.Message.getWrapperField(this, y.Data.Multi, 2);
              }
              set multi(G) {
                m.Message.setOneofWrapperField(this, 2, [1, 2], G);
              }
              get sum() {
                return {
                  0: "none",
                  1: "single",
                  2: "multi"
                }[m.Message.computeOneofCase(this, [1, 2])];
              }
              static fromObject(G) {
                const k = new V({});
                return G.single != null && (k.single = y.Data.Single.fromObject(G.single)), G.multi != null && (k.multi = y.Data.Multi.fromObject(G.multi)), k;
              }
              toObject() {
                const G = {};
                return this.single != null && (G.single = this.single.toObject()), this.multi != null && (G.multi = this.multi.toObject()), G;
              }
              serialize(G) {
                const k = G || new m.BinaryWriter();
                if (this.single !== void 0 && k.writeMessage(1, this.single, () => this.single.serialize(k)), this.multi !== void 0 && k.writeMessage(2, this.multi, () => this.multi.serialize(k)), !G)
                  return k.getResultBuffer();
              }
              static deserialize(G) {
                const k = G instanceof m.BinaryReader ? G : new m.BinaryReader(G), F = new V();
                for (; k.nextField() && !k.isEndGroup(); )
                  switch (k.getFieldNumber()) {
                    case 1:
                      k.readMessage(F.single, () => F.single = y.Data.Single.deserialize(k));
                      break;
                    case 2:
                      k.readMessage(F.multi, () => F.multi = y.Data.Multi.deserialize(k));
                      break;
                    default:
                      k.skipField();
                  }
                return F;
              }
              serializeBinary() {
                return this.serialize();
              }
              static deserializeBinary(G) {
                return V.deserialize(G);
              }
            }
            y.Data = V, function(M) {
              class G extends m.Message {
                constructor(X) {
                  super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [], []), !Array.isArray(X) && typeof X == "object" && ("mode" in X && X.mode != null && (this.mode = X.mode), "signature" in X && X.signature != null && (this.signature = X.signature));
                }
                get mode() {
                  return m.Message.getField(this, 1);
                }
                set mode(X) {
                  m.Message.setField(this, 1, X);
                }
                get signature() {
                  return m.Message.getField(this, 2);
                }
                set signature(X) {
                  m.Message.setField(this, 2, X);
                }
                static fromObject(X) {
                  const ee = new G({});
                  return X.mode != null && (ee.mode = X.mode), X.signature != null && (ee.signature = X.signature), ee;
                }
                toObject() {
                  const X = {};
                  return this.mode != null && (X.mode = this.mode), this.signature != null && (X.signature = this.signature), X;
                }
                serialize(X) {
                  const ee = X || new m.BinaryWriter();
                  if (this.mode !== void 0 && ee.writeEnum(1, this.mode), this.signature !== void 0 && ee.writeBytes(2, this.signature), !X)
                    return ee.getResultBuffer();
                }
                static deserialize(X) {
                  const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new G();
                  for (; ee.nextField() && !ee.isEndGroup(); )
                    switch (ee.getFieldNumber()) {
                      case 1:
                        ue.mode = ee.readEnum();
                        break;
                      case 2:
                        ue.signature = ee.readBytes();
                        break;
                      default:
                        ee.skipField();
                    }
                  return ue;
                }
                serializeBinary() {
                  return this.serialize();
                }
                static deserializeBinary(X) {
                  return G.deserialize(X);
                }
              }
              M.Single = G;
              class k extends m.Message {
                constructor(X) {
                  super(), m.Message.initialize(this, Array.isArray(X) ? X : [], 0, -1, [2], []), !Array.isArray(X) && typeof X == "object" && ("bitarray" in X && X.bitarray != null && (this.bitarray = X.bitarray), "signatures" in X && X.signatures != null && (this.signatures = X.signatures));
                }
                get bitarray() {
                  return m.Message.getWrapperField(this, c.cosmos.crypto.multisig.v1beta1.CompactBitArray, 1);
                }
                set bitarray(X) {
                  m.Message.setWrapperField(this, 1, X);
                }
                get signatures() {
                  return m.Message.getRepeatedWrapperField(this, y.Data, 2);
                }
                set signatures(X) {
                  m.Message.setRepeatedWrapperField(this, 2, X);
                }
                static fromObject(X) {
                  const ee = new k({});
                  return X.bitarray != null && (ee.bitarray = c.cosmos.crypto.multisig.v1beta1.CompactBitArray.fromObject(X.bitarray)), X.signatures != null && (ee.signatures = X.signatures.map((ue) => y.Data.fromObject(ue))), ee;
                }
                toObject() {
                  const X = {};
                  return this.bitarray != null && (X.bitarray = this.bitarray.toObject()), this.signatures != null && (X.signatures = this.signatures.map((ee) => ee.toObject())), X;
                }
                serialize(X) {
                  const ee = X || new m.BinaryWriter();
                  if (this.bitarray !== void 0 && ee.writeMessage(1, this.bitarray, () => this.bitarray.serialize(ee)), this.signatures !== void 0 && ee.writeRepeatedMessage(2, this.signatures, (ue) => ue.serialize(ee)), !X)
                    return ee.getResultBuffer();
                }
                static deserialize(X) {
                  const ee = X instanceof m.BinaryReader ? X : new m.BinaryReader(X), ue = new k();
                  for (; ee.nextField() && !ee.isEndGroup(); )
                    switch (ee.getFieldNumber()) {
                      case 1:
                        ee.readMessage(ue.bitarray, () => ue.bitarray = c.cosmos.crypto.multisig.v1beta1.CompactBitArray.deserialize(ee));
                        break;
                      case 2:
                        ee.readMessage(ue.signatures, () => m.Message.addToRepeatedWrapperField(ue, 2, y.Data.deserialize(ee), y.Data));
                        break;
                      default:
                        ee.skipField();
                    }
                  return ue;
                }
                serializeBinary() {
                  return this.serialize();
                }
                static deserializeBinary(X) {
                  return k.deserialize(X);
                }
              }
              M.Multi = k;
            }(V = y.Data || (y.Data = {}));
          }(T = E.SignatureDescriptor || (E.SignatureDescriptor = {}));
        })($.v1beta1 || ($.v1beta1 = {}));
      })(S.signing || (S.signing = {}));
    })(v.tx || (v.tx = {}));
  })(e.cosmos || (e.cosmos = {}));
})(signing$1);
var keys$1 = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ethermint = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      (function(v) {
        (function(S) {
          class $ extends c.Message {
            constructor(T) {
              super(), c.Message.initialize(this, Array.isArray(T) ? T : [], 0, -1, [], []), !Array.isArray(T) && typeof T == "object" && "key" in T && T.key != null && (this.key = T.key);
            }
            get key() {
              return c.Message.getField(this, 1);
            }
            set key(T) {
              c.Message.setField(this, 1, T);
            }
            static fromObject(T) {
              const y = new $({});
              return T.key != null && (y.key = T.key), y;
            }
            toObject() {
              const T = {};
              return this.key != null && (T.key = this.key), T;
            }
            serialize(T) {
              const y = T || new c.BinaryWriter();
              if (this.key !== void 0 && y.writeBytes(1, this.key), !T)
                return y.getResultBuffer();
            }
            static deserialize(T) {
              const y = T instanceof c.BinaryReader ? T : new c.BinaryReader(T), V = new $();
              for (; y.nextField() && !y.isEndGroup(); )
                switch (y.getFieldNumber()) {
                  case 1:
                    V.key = y.readBytes();
                    break;
                  default:
                    y.skipField();
                }
              return V;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(T) {
              return $.deserialize(T);
            }
          }
          S.PubKey = $;
          class E extends c.Message {
            constructor(T) {
              super(), c.Message.initialize(this, Array.isArray(T) ? T : [], 0, -1, [], []), !Array.isArray(T) && typeof T == "object" && "key" in T && T.key != null && (this.key = T.key);
            }
            get key() {
              return c.Message.getField(this, 1);
            }
            set key(T) {
              c.Message.setField(this, 1, T);
            }
            static fromObject(T) {
              const y = new E({});
              return T.key != null && (y.key = T.key), y;
            }
            toObject() {
              const T = {};
              return this.key != null && (T.key = this.key), T;
            }
            serialize(T) {
              const y = T || new c.BinaryWriter();
              if (this.key !== void 0 && y.writeBytes(1, this.key), !T)
                return y.getResultBuffer();
            }
            static deserialize(T) {
              const y = T instanceof c.BinaryReader ? T : new c.BinaryReader(T), V = new E();
              for (; y.nextField() && !y.isEndGroup(); )
                switch (y.getFieldNumber()) {
                  case 1:
                    V.key = y.readBytes();
                    break;
                  default:
                    y.skipField();
                }
              return V;
            }
            serializeBinary() {
              return this.serialize();
            }
            static deserializeBinary(T) {
              return E.deserialize(T);
            }
          }
          S.PrivKey = E;
        })(v.ethsecp256k1 || (v.ethsecp256k1 = {}));
      })(m.v1 || (m.v1 = {}));
    })(d.crypto || (d.crypto = {}));
  })(e.ethermint || (e.ethermint = {}));
})(keys$1);
var keys = {};
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(d, m, v, S) {
    S === void 0 && (S = v);
    var $ = Object.getOwnPropertyDescriptor(m, v);
    (!$ || ("get" in $ ? !m.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return m[v];
    } }), Object.defineProperty(d, S, $);
  } : function(d, m, v, S) {
    S === void 0 && (S = v), d[S] = m[v];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var v in d)
        v !== "default" && Object.prototype.hasOwnProperty.call(d, v) && n(m, d, v);
    return o(m, d), m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cosmos = void 0;
  const c = u(googleProtobuf);
  (function(d) {
    (function(m) {
      (function(v) {
        class S extends c.Message {
          constructor(O) {
            super(), c.Message.initialize(this, Array.isArray(O) ? O : [], 0, -1, [], []), !Array.isArray(O) && typeof O == "object" && "key" in O && O.key != null && (this.key = O.key);
          }
          get key() {
            return c.Message.getField(this, 1);
          }
          set key(O) {
            c.Message.setField(this, 1, O);
          }
          static fromObject(O) {
            const T = new S({});
            return O.key != null && (T.key = O.key), T;
          }
          toObject() {
            const O = {};
            return this.key != null && (O.key = this.key), O;
          }
          serialize(O) {
            const T = O || new c.BinaryWriter();
            if (this.key !== void 0 && T.writeBytes(1, this.key), !O)
              return T.getResultBuffer();
          }
          static deserialize(O) {
            const T = O instanceof c.BinaryReader ? O : new c.BinaryReader(O), y = new S();
            for (; T.nextField() && !T.isEndGroup(); )
              switch (T.getFieldNumber()) {
                case 1:
                  y.key = T.readBytes();
                  break;
                default:
                  T.skipField();
              }
            return y;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(O) {
            return S.deserialize(O);
          }
        }
        v.PubKey = S;
        class $ extends c.Message {
          constructor(O) {
            super(), c.Message.initialize(this, Array.isArray(O) ? O : [], 0, -1, [], []), !Array.isArray(O) && typeof O == "object" && "key" in O && O.key != null && (this.key = O.key);
          }
          get key() {
            return c.Message.getField(this, 1);
          }
          set key(O) {
            c.Message.setField(this, 1, O);
          }
          static fromObject(O) {
            const T = new $({});
            return O.key != null && (T.key = O.key), T;
          }
          toObject() {
            const O = {};
            return this.key != null && (O.key = this.key), O;
          }
          serialize(O) {
            const T = O || new c.BinaryWriter();
            if (this.key !== void 0 && T.writeBytes(1, this.key), !O)
              return T.getResultBuffer();
          }
          static deserialize(O) {
            const T = O instanceof c.BinaryReader ? O : new c.BinaryReader(O), y = new $();
            for (; T.nextField() && !T.isEndGroup(); )
              switch (T.getFieldNumber()) {
                case 1:
                  y.key = T.readBytes();
                  break;
                default:
                  T.skipField();
              }
            return y;
          }
          serializeBinary() {
            return this.serialize();
          }
          static deserializeBinary(O) {
            return $.deserialize(O);
          }
        }
        v.PrivKey = $;
      })(m.secp256k1 || (m.secp256k1 = {}));
    })(d.crypto || (d.crypto = {}));
  })(e.cosmos || (e.cosmos = {}));
})(keys);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(X, ee, ue, Q) {
    Q === void 0 && (Q = ue);
    var Y = Object.getOwnPropertyDescriptor(ee, ue);
    (!Y || ("get" in Y ? !ee.__esModule : Y.writable || Y.configurable)) && (Y = { enumerable: !0, get: function() {
      return ee[ue];
    } }), Object.defineProperty(X, Q, Y);
  } : function(X, ee, ue, Q) {
    Q === void 0 && (Q = ue), X[Q] = ee[ue];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(X, ee) {
    Object.defineProperty(X, "default", { enumerable: !0, value: ee });
  } : function(X, ee) {
    X.default = ee;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(X) {
    if (X && X.__esModule)
      return X;
    var ee = {};
    if (X != null)
      for (var ue in X)
        ue !== "default" && Object.prototype.hasOwnProperty.call(X, ue) && n(ee, X, ue);
    return o(ee, X), ee;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createTransaction = e.createTransactionWithMultipleMessages = e.createSigDoc = e.createAuthInfo = e.createSignerInfo = e.createFee = e.createBody = e.createBodyWithMultipleMessages = e.protoTxNamespace = e.LEGACY_AMINO = e.SIGN_DIRECT = void 0;
  const c = sha3$2, d = u(tx$2), m = u(signing$1), v = u(coin$6), S = u(keys$1), $ = u(keys), E = utils$o;
  e.SIGN_DIRECT = m.cosmos.tx.signing.v1beta1.SignMode.SIGN_MODE_DIRECT, e.LEGACY_AMINO = m.cosmos.tx.signing.v1beta1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, function(X) {
    X.txn = d.cosmos.tx.v1beta1;
  }(e.protoTxNamespace || (e.protoTxNamespace = {}));
  function O(X, ee) {
    const ue = [];
    return X.forEach((Q) => {
      ue.push((0, E.createAnyMessage)(Q));
    }), new d.cosmos.tx.v1beta1.TxBody({
      messages: ue,
      memo: ee
    });
  }
  e.createBodyWithMultipleMessages = O;
  function T(X, ee) {
    return O([X], ee);
  }
  e.createBody = T;
  function y(X, ee, ue) {
    return new d.cosmos.tx.v1beta1.Fee({
      amount: [
        new v.cosmos.base.v1beta1.Coin({
          denom: ee,
          amount: X
        })
      ],
      gas_limit: ue
    });
  }
  e.createFee = y;
  function V(X, ee, ue, Q) {
    let Y;
    return X === "secp256k1" ? Y = {
      message: new $.cosmos.crypto.secp256k1.PubKey({
        key: ee
      }),
      path: "cosmos.crypto.secp256k1.PubKey"
    } : Y = {
      message: new S.ethermint.crypto.v1.ethsecp256k1.PubKey({
        key: ee
      }),
      path: "ethermint.crypto.v1.ethsecp256k1.PubKey"
    }, new d.cosmos.tx.v1beta1.SignerInfo({
      public_key: (0, E.createAnyMessage)(Y),
      mode_info: new d.cosmos.tx.v1beta1.ModeInfo({
        single: new d.cosmos.tx.v1beta1.ModeInfo.Single({
          mode: Q
        })
      }),
      sequence: ue
    });
  }
  e.createSignerInfo = V;
  function M(X, ee) {
    return new d.cosmos.tx.v1beta1.AuthInfo({
      signer_infos: [X],
      fee: ee
    });
  }
  e.createAuthInfo = M;
  function G(X, ee, ue, Q) {
    return new d.cosmos.tx.v1beta1.SignDoc({
      body_bytes: X,
      auth_info_bytes: ee,
      chain_id: ue,
      account_number: Q
    });
  }
  e.createSigDoc = G;
  function k(X, ee, ue, Q, Y, pe, oe, ne, H, C) {
    const w = O(X, ee), P = y(ue, Q, Y), J = Buffer.from(oe, "base64"), se = V(pe, new Uint8Array(J), ne, e.LEGACY_AMINO), fe = M(se, P), N = G(w.serializeBinary(), fe.serializeBinary(), C, H), W = new c.Keccak(256);
    W.update(Buffer.from(N.serializeBinary()));
    const I = W.digest("binary"), te = V(pe, new Uint8Array(J), ne, e.SIGN_DIRECT), ge = M(te, P), Pe = G(w.serializeBinary(), ge.serializeBinary(), C, H), Ke = new c.Keccak(256);
    Ke.update(Buffer.from(Pe.serializeBinary()));
    const xe = Ke.digest("binary");
    return {
      legacyAmino: {
        body: w,
        authInfo: fe,
        signBytes: I.toString("base64")
      },
      signDirect: {
        body: w,
        authInfo: ge,
        signBytes: xe.toString("base64")
      }
    };
  }
  e.createTransactionWithMultipleMessages = k;
  function F(X, ee, ue, Q, Y, pe, oe, ne, H, C) {
    return k([X], ee, ue, Q, Y, pe, oe, ne, H, C);
  }
  e.createTransaction = F;
})(transaction);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(u, c, d, m) {
    m === void 0 && (m = d);
    var v = Object.getOwnPropertyDescriptor(c, d);
    (!v || ("get" in v ? !c.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
      return c[d];
    } }), Object.defineProperty(u, m, v);
  } : function(u, c, d, m) {
    m === void 0 && (m = d), u[m] = c[d];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(u, c) {
    for (var d in u)
      d !== "default" && !Object.prototype.hasOwnProperty.call(c, d) && n(c, u, d);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), o(msgCancelFeeSplit$1, e), o(msgUpdateFeeSplit$2, e), o(msgRegisterFeeSplit$2, e), o(msgConvertCoin$2, e), o(msgConvertERC20$2, e), o(authz$2, e), o(stake, e), o(ibcMsgTransfer$2, e), o(msgEthereumTx, e), o(msgSend$1, e), o(staking$5, e), o(txRaw$1, e), o(utils$o, e), o(validator$6, e), o(vote, e), o(web3Extension$1, e), o(transaction, e);
})(dist$3);
var dist$1 = {}, msgCancelFeeSplit = {};
Object.defineProperty(msgCancelFeeSplit, "__esModule", { value: !0 });
msgCancelFeeSplit.createMsgCancelFeeSplit = msgCancelFeeSplit.MSG_CANCEL_FEE_SPLIT_TYPES = void 0;
msgCancelFeeSplit.MSG_CANCEL_FEE_SPLIT_TYPES = {
  MsgValue: [
    { name: "contract_address", type: "string" },
    { name: "deployer_address", type: "string" }
  ]
};
function createMsgCancelFeeSplit(e, n) {
  return {
    type: "evmos/MsgCancelFeeSplit",
    value: {
      contract_address: e,
      deployer_address: n
    }
  };
}
msgCancelFeeSplit.createMsgCancelFeeSplit = createMsgCancelFeeSplit;
var msgUpdateFeeSplit$1 = {};
Object.defineProperty(msgUpdateFeeSplit$1, "__esModule", { value: !0 });
msgUpdateFeeSplit$1.createMsgUpdateFeeSplit = msgUpdateFeeSplit$1.MSG_UPDATE_FEE_SPLIT_TYPES = void 0;
msgUpdateFeeSplit$1.MSG_UPDATE_FEE_SPLIT_TYPES = {
  MsgValue: [
    { name: "contract_address", type: "string" },
    { name: "deployer_address", type: "string" },
    { name: "withdrawer_address", type: "string" }
  ]
};
function createMsgUpdateFeeSplit(e, n, o) {
  return {
    type: "evmos/MsgUpdateFeeSplit",
    value: {
      contract_address: e,
      deployer_address: n,
      withdrawer_address: o
    }
  };
}
msgUpdateFeeSplit$1.createMsgUpdateFeeSplit = createMsgUpdateFeeSplit;
var msgRegisterFeeSplit$1 = {};
Object.defineProperty(msgRegisterFeeSplit$1, "__esModule", { value: !0 });
msgRegisterFeeSplit$1.createMsgRegisterFeeSplit = msgRegisterFeeSplit$1.MSG_REGISTER_FEE_SPLIT_TYPES = void 0;
msgRegisterFeeSplit$1.MSG_REGISTER_FEE_SPLIT_TYPES = {
  MsgValue: [
    { name: "contract_address", type: "string" },
    { name: "deployer_address", type: "string" },
    { name: "withdrawer_address", type: "string" },
    { name: "nonces", type: "uint64[]" }
  ]
};
function createMsgRegisterFeeSplit(e, n, o, u) {
  return {
    type: "evmos/MsgRegisterFeeSplit",
    value: {
      contract_address: e,
      deployer_address: n,
      withdrawer_address: o,
      nonces: u
    }
  };
}
msgRegisterFeeSplit$1.createMsgRegisterFeeSplit = createMsgRegisterFeeSplit;
var msgConvertCoin$1 = {};
Object.defineProperty(msgConvertCoin$1, "__esModule", { value: !0 });
msgConvertCoin$1.createMsgConvertCoin = msgConvertCoin$1.MSG_CONVERT_COIN_TYPES = void 0;
msgConvertCoin$1.MSG_CONVERT_COIN_TYPES = {
  MsgValue: [
    { name: "coin", type: "TypeCoin" },
    { name: "receiver", type: "string" },
    { name: "sender", type: "string" }
  ],
  TypeCoin: [
    { name: "denom", type: "string" },
    { name: "amount", type: "string" }
  ]
};
function createMsgConvertCoin(e, n, o, u) {
  return {
    type: "evmos/MsgConvertCoin",
    value: {
      coin: {
        denom: e,
        amount: n
      },
      receiver: o,
      sender: u
    }
  };
}
msgConvertCoin$1.createMsgConvertCoin = createMsgConvertCoin;
var msgConvertERC20$1 = {};
Object.defineProperty(msgConvertERC20$1, "__esModule", { value: !0 });
msgConvertERC20$1.createMsgConvertERC20 = msgConvertERC20$1.MSG_CONVERT_ERC20_TYPES = void 0;
msgConvertERC20$1.MSG_CONVERT_ERC20_TYPES = {
  MsgValue: [
    { name: "contract_address", type: "string" },
    { name: "amount", type: "string" },
    { name: "receiver", type: "string" },
    { name: "sender", type: "string" }
  ]
};
function createMsgConvertERC20(e, n, o, u) {
  return {
    type: "evmos/MsgConvertERC20",
    value: {
      contract_address: e,
      amount: n,
      receiver: o,
      sender: u
    }
  };
}
msgConvertERC20$1.createMsgConvertERC20 = createMsgConvertERC20;
var base$1 = {};
Object.defineProperty(base$1, "__esModule", { value: !0 });
base$1.generateFee = base$1.generateTypes = base$1.generateMessage = base$1.generateMessageWithMultipleTransactions = base$1.createEIP712 = void 0;
function createEIP712(e, n, o) {
  return {
    types: e,
    primaryType: "Tx",
    domain: {
      name: "Cosmos Web3",
      version: "1.0.0",
      chainId: n,
      verifyingContract: "cosmos",
      salt: "0"
    },
    message: o
  };
}
base$1.createEIP712 = createEIP712;
function generateMessageWithMultipleTransactions(e, n, o, u, c, d) {
  return {
    account_number: e,
    chain_id: o,
    fee: c,
    memo: u,
    msgs: d,
    sequence: n
  };
}
base$1.generateMessageWithMultipleTransactions = generateMessageWithMultipleTransactions;
function generateMessage(e, n, o, u, c, d) {
  return generateMessageWithMultipleTransactions(e, n, o, u, c, [d]);
}
base$1.generateMessage = generateMessage;
function generateTypes(e) {
  const n = {
    EIP712Domain: [
      { name: "name", type: "string" },
      { name: "version", type: "string" },
      { name: "chainId", type: "uint256" },
      { name: "verifyingContract", type: "string" },
      { name: "salt", type: "string" }
    ],
    Tx: [
      { name: "account_number", type: "string" },
      { name: "chain_id", type: "string" },
      { name: "fee", type: "Fee" },
      { name: "memo", type: "string" },
      { name: "msgs", type: "Msg[]" },
      { name: "sequence", type: "string" }
    ],
    Fee: [
      { name: "feePayer", type: "string" },
      { name: "amount", type: "Coin[]" },
      { name: "gas", type: "string" }
    ],
    Coin: [
      { name: "denom", type: "string" },
      { name: "amount", type: "string" }
    ],
    Msg: [
      { name: "type", type: "string" },
      { name: "value", type: "MsgValue" }
    ]
  };
  return Object.assign(n, e), n;
}
base$1.generateTypes = generateTypes;
function generateFee(e, n, o, u) {
  return {
    amount: [
      {
        amount: e,
        denom: n
      }
    ],
    gas: o,
    feePayer: u
  };
}
base$1.generateFee = generateFee;
var gov$1 = {};
Object.defineProperty(gov$1, "__esModule", { value: !0 });
gov$1.createMsgVote = gov$1.MSG_VOTE_TYPES = void 0;
gov$1.MSG_VOTE_TYPES = {
  MsgValue: [
    { name: "proposal_id", type: "uint64" },
    { name: "voter", type: "string" },
    { name: "option", type: "int32" }
  ]
};
function createMsgVote(e, n, o) {
  return {
    type: "cosmos-sdk/MsgVote",
    value: {
      proposal_id: e,
      voter: o,
      option: n
    }
  };
}
gov$1.createMsgVote = createMsgVote;
var ibcMsgTransfer$1 = {};
Object.defineProperty(ibcMsgTransfer$1, "__esModule", { value: !0 });
ibcMsgTransfer$1.createIBCMsgTransfer = ibcMsgTransfer$1.IBC_MSG_TRANSFER_TYPES = void 0;
ibcMsgTransfer$1.IBC_MSG_TRANSFER_TYPES = {
  MsgValue: [
    { name: "source_port", type: "string" },
    { name: "source_channel", type: "string" },
    { name: "token", type: "TypeToken" },
    { name: "sender", type: "string" },
    { name: "receiver", type: "string" },
    { name: "timeout_height", type: "TypeTimeoutHeight" },
    { name: "timeout_timestamp", type: "uint64" }
  ],
  TypeToken: [
    { name: "denom", type: "string" },
    { name: "amount", type: "string" }
  ],
  TypeTimeoutHeight: [
    { name: "revision_number", type: "uint64" },
    { name: "revision_height", type: "uint64" }
  ]
};
function createIBCMsgTransfer(e, n, o, u, c, d, m, v, S) {
  return {
    type: "cosmos-sdk/MsgTransfer",
    value: {
      receiver: e,
      sender: n,
      source_channel: o,
      source_port: u,
      timeout_height: {
        revision_height: c.toString(),
        revision_number: d.toString()
      },
      timeout_timestamp: m,
      token: {
        amount: v,
        denom: S
      }
    }
  };
}
ibcMsgTransfer$1.createIBCMsgTransfer = createIBCMsgTransfer;
var msgsend = {};
Object.defineProperty(msgsend, "__esModule", { value: !0 });
msgsend.createMsgSend = msgsend.MSG_SEND_TYPES = void 0;
msgsend.MSG_SEND_TYPES = {
  MsgValue: [
    { name: "from_address", type: "string" },
    { name: "to_address", type: "string" },
    { name: "amount", type: "TypeAmount[]" }
  ],
  TypeAmount: [
    { name: "denom", type: "string" },
    { name: "amount", type: "string" }
  ]
};
function createMsgSend(e, n, o, u) {
  return {
    type: "cosmos-sdk/MsgSend",
    value: {
      amount: [
        {
          amount: e,
          denom: n
        }
      ],
      from_address: o,
      to_address: u
    }
  };
}
msgsend.createMsgSend = createMsgSend;
var staking$1 = {};
Object.defineProperty(staking$1, "__esModule", { value: !0 });
staking$1.createMsgWithdrawValidatorCommission = staking$1.MSG_WITHDRAW_VALIDATOR_COMMISSION_TYPES = staking$1.createMsgWithdrawDelegatorReward = staking$1.MSG_WITHDRAW_DELEGATOR_REWARD_TYPES = staking$1.createMsgUndelegate = staking$1.MSG_UNDELEGATE_TYPES = staking$1.createMsgBeginRedelegate = staking$1.MSG_BEGIN_REDELEGATE_TYPES = staking$1.createMsgDelegate = staking$1.MSG_DELEGATE_TYPES = void 0;
staking$1.MSG_DELEGATE_TYPES = {
  MsgValue: [
    { name: "delegator_address", type: "string" },
    { name: "validator_address", type: "string" },
    { name: "amount", type: "TypeAmount" }
  ],
  TypeAmount: [
    { name: "denom", type: "string" },
    { name: "amount", type: "string" }
  ]
};
function createMsgDelegate(e, n, o, u) {
  return {
    type: "cosmos-sdk/MsgDelegate",
    value: {
      amount: {
        amount: o,
        denom: u
      },
      delegator_address: e,
      validator_address: n
    }
  };
}
staking$1.createMsgDelegate = createMsgDelegate;
staking$1.MSG_BEGIN_REDELEGATE_TYPES = {
  MsgValue: [
    { name: "delegator_address", type: "string" },
    { name: "validator_src_address", type: "string" },
    { name: "validator_dst_address", type: "string" },
    { name: "amount", type: "TypeAmount" }
  ],
  TypeAmount: [
    { name: "denom", type: "string" },
    { name: "amount", type: "string" }
  ]
};
function createMsgBeginRedelegate(e, n, o, u, c) {
  return {
    type: "cosmos-sdk/MsgBeginRedelegate",
    value: {
      amount: {
        amount: u,
        denom: c
      },
      delegator_address: e,
      validator_src_address: n,
      validator_dst_address: o
    }
  };
}
staking$1.createMsgBeginRedelegate = createMsgBeginRedelegate;
staking$1.MSG_UNDELEGATE_TYPES = {
  MsgValue: [
    { name: "delegator_address", type: "string" },
    { name: "validator_address", type: "string" },
    { name: "amount", type: "TypeAmount" }
  ],
  TypeAmount: [
    { name: "denom", type: "string" },
    { name: "amount", type: "string" }
  ]
};
function createMsgUndelegate(e, n, o, u) {
  return {
    type: "cosmos-sdk/MsgUndelegate",
    value: {
      amount: {
        amount: o,
        denom: u
      },
      delegator_address: e,
      validator_address: n
    }
  };
}
staking$1.createMsgUndelegate = createMsgUndelegate;
staking$1.MSG_WITHDRAW_DELEGATOR_REWARD_TYPES = {
  MsgValue: [
    { name: "delegator_address", type: "string" },
    { name: "validator_address", type: "string" }
  ]
};
function createMsgWithdrawDelegatorReward(e, n) {
  return {
    type: "cosmos-sdk/MsgWithdrawDelegationReward",
    value: {
      delegator_address: e,
      validator_address: n
    }
  };
}
staking$1.createMsgWithdrawDelegatorReward = createMsgWithdrawDelegatorReward;
staking$1.MSG_WITHDRAW_VALIDATOR_COMMISSION_TYPES = {
  MsgValue: [{ name: "validator_address", type: "string" }]
};
function createMsgWithdrawValidatorCommission(e) {
  return {
    type: "cosmos-sdk/MsgWithdrawValidatorCommission",
    value: {
      validator_address: e
    }
  };
}
staking$1.createMsgWithdrawValidatorCommission = createMsgWithdrawValidatorCommission;
var validator$5 = {};
Object.defineProperty(validator$5, "__esModule", { value: !0 });
validator$5.createMsgEditValidator = validator$5.MSG_EDIT_VALIDATOR_TYPES = void 0;
const NOT_MODIFY = "[do-not-modify]";
validator$5.MSG_EDIT_VALIDATOR_TYPES = {
  TypeDescription: [
    { name: "moniker", type: "string" },
    { name: "identity", type: "string" },
    { name: "website", type: "string" },
    { name: "security_contact", type: "string" },
    { name: "details", type: "string" }
  ],
  MsgValue: [
    { name: "description", type: "TypeDescription" },
    { name: "validator_address", type: "string" },
    { name: "commission_rate", type: "string" },
    { name: "min_self_delegation", type: "string" }
  ]
};
function createMsgEditValidator(e, n, o, u, c, d, m, v) {
  return {
    type: "cosmos-sdk/MsgEditValidator",
    value: {
      description: {
        moniker: e || NOT_MODIFY,
        identity: n || NOT_MODIFY,
        website: o || NOT_MODIFY,
        security_contact: u || NOT_MODIFY,
        details: c || NOT_MODIFY
      },
      validator_address: d,
      commission_rate: m || "<nil>",
      min_self_delegation: v || "<nil>"
    }
  };
}
validator$5.createMsgEditValidator = createMsgEditValidator;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(u, c, d, m) {
    m === void 0 && (m = d);
    var v = Object.getOwnPropertyDescriptor(c, d);
    (!v || ("get" in v ? !c.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
      return c[d];
    } }), Object.defineProperty(u, m, v);
  } : function(u, c, d, m) {
    m === void 0 && (m = d), u[m] = c[d];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(u, c) {
    for (var d in u)
      d !== "default" && !Object.prototype.hasOwnProperty.call(c, d) && n(c, u, d);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), o(msgCancelFeeSplit, e), o(msgUpdateFeeSplit$1, e), o(msgRegisterFeeSplit$1, e), o(msgConvertCoin$1, e), o(msgConvertERC20$1, e), o(base$1, e), o(gov$1, e), o(ibcMsgTransfer$1, e), o(msgsend, e), o(staking$1, e), o(validator$5, e);
})(dist$1);
Object.defineProperty(msgCancelFeeSplit$2, "__esModule", { value: !0 });
msgCancelFeeSplit$2.createTxMsgCancelFeeSplit = void 0;
const proto_1$d = dist$3, eip712_1$9 = dist$1;
function createTxMsgCancelFeeSplit(e, n, o, u, c) {
  const d = (0, eip712_1$9.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$9.generateTypes)(eip712_1$9.MSG_CANCEL_FEE_SPLIT_TYPES), v = (0, eip712_1$9.createMsgCancelFeeSplit)(c.contractAddress, c.deployerAddress), S = (0, eip712_1$9.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$9.createEIP712)(m, e.chainId, S), E = (0, proto_1$d.createMsgCancelFeeSplit)(c.contractAddress, c.deployerAddress), O = (0, proto_1$d.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
msgCancelFeeSplit$2.createTxMsgCancelFeeSplit = createTxMsgCancelFeeSplit;
var msgUpdateFeeSplit = {};
Object.defineProperty(msgUpdateFeeSplit, "__esModule", { value: !0 });
msgUpdateFeeSplit.createTxMsgUpdateFeeSplit = void 0;
const proto_1$c = dist$3, eip712_1$8 = dist$1;
function createTxMsgUpdateFeeSplit(e, n, o, u, c) {
  const d = (0, eip712_1$8.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$8.generateTypes)(eip712_1$8.MSG_UPDATE_FEE_SPLIT_TYPES), v = (0, eip712_1$8.createMsgUpdateFeeSplit)(c.contractAddress, c.deployerAddress, c.withdrawerAddress), S = (0, eip712_1$8.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$8.createEIP712)(m, e.chainId, S), E = (0, proto_1$c.createMsgUpdateFeeSplit)(c.contractAddress, c.deployerAddress, c.withdrawerAddress), O = (0, proto_1$c.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
msgUpdateFeeSplit.createTxMsgUpdateFeeSplit = createTxMsgUpdateFeeSplit;
var msgRegisterFeeSplit = {};
Object.defineProperty(msgRegisterFeeSplit, "__esModule", { value: !0 });
msgRegisterFeeSplit.createTxMsgRegisterFeeSplit = void 0;
const proto_1$b = dist$3, eip712_1$7 = dist$1;
function createTxMsgRegisterFeeSplit(e, n, o, u, c) {
  const d = (0, eip712_1$7.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$7.generateTypes)(eip712_1$7.MSG_REGISTER_FEE_SPLIT_TYPES), v = (0, eip712_1$7.createMsgRegisterFeeSplit)(c.contractAddress, c.deployerAddress, c.withdrawerAddress, c.nonces), S = (0, eip712_1$7.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$7.createEIP712)(m, e.chainId, S), E = (0, proto_1$b.createMsgRegisterFeeSplit)(c.contractAddress, c.deployerAddress, c.withdrawerAddress, c.nonces), O = (0, proto_1$b.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
msgRegisterFeeSplit.createTxMsgRegisterFeeSplit = createTxMsgRegisterFeeSplit;
var msgConvertCoin = {};
Object.defineProperty(msgConvertCoin, "__esModule", { value: !0 });
msgConvertCoin.createTxMsgConvertCoin = void 0;
const proto_1$a = dist$3, eip712_1$6 = dist$1;
function createTxMsgConvertCoin(e, n, o, u, c) {
  const d = (0, eip712_1$6.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$6.generateTypes)(eip712_1$6.MSG_CONVERT_COIN_TYPES), v = (0, eip712_1$6.createMsgConvertCoin)(c.denom, c.amount, c.receiverHexFormatted, c.senderEvmosFormatted), S = (0, eip712_1$6.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$6.createEIP712)(m, e.chainId, S), E = (0, proto_1$a.createMsgConvertCoin)(c.denom, c.amount, c.receiverHexFormatted, c.senderEvmosFormatted), O = (0, proto_1$a.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
msgConvertCoin.createTxMsgConvertCoin = createTxMsgConvertCoin;
var msgConvertERC20 = {};
Object.defineProperty(msgConvertERC20, "__esModule", { value: !0 });
msgConvertERC20.createTxMsgConvertERC20 = void 0;
const proto_1$9 = dist$3, eip712_1$5 = dist$1;
function createTxMsgConvertERC20(e, n, o, u, c) {
  const d = (0, eip712_1$5.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$5.generateTypes)(eip712_1$5.MSG_CONVERT_ERC20_TYPES), v = (0, eip712_1$5.createMsgConvertERC20)(c.contract_address, c.amount, c.receiverEvmosFormatted, c.senderHexFormatted), S = (0, eip712_1$5.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$5.createEIP712)(m, e.chainId, S), E = (0, proto_1$9.createMsgConvertERC20)(c.contract_address, c.amount, c.receiverEvmosFormatted, c.senderHexFormatted), O = (0, proto_1$9.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
msgConvertERC20.createTxMsgConvertERC20 = createTxMsgConvertERC20;
var grant = {};
Object.defineProperty(grant, "__esModule", { value: !0 });
grant.createTxMsgStakeAuthorization = void 0;
const proto_1$8 = dist$3;
function createTxMsgStakeAuthorization(e, n, o, u, c) {
  const d = (0, proto_1$8.createStakeAuthorization)(c.validator_address, c.denom, c.maxTokens, proto_1$8.stakeAuthTypes.AUTHORIZATION_TYPE_DELEGATE), m = (0, proto_1$8.createMsgGrant)(n.accountAddress, c.bot_address, d, c.duration_in_seconds), v = (0, proto_1$8.createTransaction)(m, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: v.signDirect,
    legacyAmino: v.legacyAmino
  };
}
grant.createTxMsgStakeAuthorization = createTxMsgStakeAuthorization;
var revoke = {};
Object.defineProperty(revoke, "__esModule", { value: !0 });
revoke.createTxMsgStakeRevokeAuthorization = void 0;
const proto_1$7 = dist$3;
function createTxMsgStakeRevokeAuthorization(e, n, o, u, c) {
  const d = (0, proto_1$7.createMsgRevoke)(n.accountAddress, c.bot_address, proto_1$7.RevokeMessages.REVOKE_MSG_DELEGATE), m = (0, proto_1$7.createTransaction)(d, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: m.signDirect,
    legacyAmino: m.legacyAmino
  };
}
revoke.createTxMsgStakeRevokeAuthorization = createTxMsgStakeRevokeAuthorization;
var common = {};
Object.defineProperty(common, "__esModule", { value: !0 });
var gov = {};
Object.defineProperty(gov, "__esModule", { value: !0 });
gov.createTxMsgVote = void 0;
const proto_1$6 = dist$3, eip712_1$4 = dist$1;
function createTxMsgVote(e, n, o, u, c) {
  const d = (0, eip712_1$4.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$4.generateTypes)(eip712_1$4.MSG_VOTE_TYPES), v = (0, eip712_1$4.createMsgVote)(c.proposalId, c.option, n.accountAddress), S = (0, eip712_1$4.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$4.createEIP712)(m, e.chainId, S), E = (0, proto_1$6.createMsgVote)(c.proposalId, c.option, n.accountAddress), O = (0, proto_1$6.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
gov.createTxMsgVote = createTxMsgVote;
var ibcMsgTransfer = {};
Object.defineProperty(ibcMsgTransfer, "__esModule", { value: !0 });
ibcMsgTransfer.createTxIBCMsgTransfer = void 0;
const proto_1$5 = dist$3, eip712_1$3 = dist$1;
function createTxIBCMsgTransfer(e, n, o, u, c) {
  const d = (0, eip712_1$3.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$3.generateTypes)(eip712_1$3.IBC_MSG_TRANSFER_TYPES), v = (0, eip712_1$3.createIBCMsgTransfer)(c.receiver, n.accountAddress, c.sourceChannel, c.sourcePort, c.revisionHeight, c.revisionNumber, c.timeoutTimestamp, c.amount, c.denom), S = (0, eip712_1$3.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$3.createEIP712)(m, e.chainId, S), E = (0, proto_1$5.createIBCMsgTransfer)(c.sourcePort, c.sourceChannel, c.amount, c.denom, n.accountAddress, c.receiver, c.revisionNumber, c.revisionHeight, c.timeoutTimestamp), O = (0, proto_1$5.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
ibcMsgTransfer.createTxIBCMsgTransfer = createTxIBCMsgTransfer;
var msgSend = {};
Object.defineProperty(msgSend, "__esModule", { value: !0 });
msgSend.createMessageSend = void 0;
const proto_1$4 = dist$3, eip712_1$2 = dist$1;
function createMessageSend(e, n, o, u, c) {
  const d = (0, eip712_1$2.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$2.generateTypes)(eip712_1$2.MSG_SEND_TYPES), v = (0, eip712_1$2.createMsgSend)(c.amount, c.denom, n.accountAddress, c.destinationAddress), S = (0, eip712_1$2.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$2.createEIP712)(m, e.chainId, S), E = (0, proto_1$4.createMsgSend)(n.accountAddress, c.destinationAddress, c.amount, c.denom), O = (0, proto_1$4.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
msgSend.createMessageSend = createMessageSend;
var staking = {};
Object.defineProperty(staking, "__esModule", { value: !0 });
staking.createTxMsgWithdrawValidatorCommission = staking.createTxMsgMultipleWithdrawDelegatorReward = staking.createTxMsgWithdrawDelegatorReward = staking.createTxMsgUndelegate = staking.createTxMsgBeginRedelegate = staking.createTxMsgDelegate = void 0;
const proto_1$3 = dist$3, eip712_1$1 = dist$1;
function createTxMsgDelegate(e, n, o, u, c) {
  const d = (0, eip712_1$1.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$1.generateTypes)(eip712_1$1.MSG_DELEGATE_TYPES), v = (0, eip712_1$1.createMsgDelegate)(n.accountAddress, c.validatorAddress, c.amount, c.denom), S = (0, eip712_1$1.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$1.createEIP712)(m, e.chainId, S), E = (0, proto_1$3.createMsgDelegate)(n.accountAddress, c.validatorAddress, c.amount, c.denom), O = (0, proto_1$3.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
staking.createTxMsgDelegate = createTxMsgDelegate;
function createTxMsgBeginRedelegate(e, n, o, u, c) {
  const d = (0, eip712_1$1.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$1.generateTypes)(eip712_1$1.MSG_BEGIN_REDELEGATE_TYPES), v = (0, eip712_1$1.createMsgBeginRedelegate)(n.accountAddress, c.validatorSrcAddress, c.validatorDstAddress, c.amount, c.denom), S = (0, eip712_1$1.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$1.createEIP712)(m, e.chainId, S), E = (0, proto_1$3.createMsgBeginRedelegate)(n.accountAddress, c.validatorSrcAddress, c.validatorDstAddress, c.amount, c.denom), O = (0, proto_1$3.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
staking.createTxMsgBeginRedelegate = createTxMsgBeginRedelegate;
function createTxMsgUndelegate(e, n, o, u, c) {
  const d = (0, eip712_1$1.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$1.generateTypes)(eip712_1$1.MSG_UNDELEGATE_TYPES), v = (0, eip712_1$1.createMsgUndelegate)(n.accountAddress, c.validatorAddress, c.amount, c.denom), S = (0, eip712_1$1.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$1.createEIP712)(m, e.chainId, S), E = (0, proto_1$3.createMsgUndelegate)(n.accountAddress, c.validatorAddress, c.amount, c.denom), O = (0, proto_1$3.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
staking.createTxMsgUndelegate = createTxMsgUndelegate;
function createTxMsgWithdrawDelegatorReward(e, n, o, u, c) {
  const d = (0, eip712_1$1.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$1.generateTypes)(eip712_1$1.MSG_WITHDRAW_DELEGATOR_REWARD_TYPES), v = (0, eip712_1$1.createMsgWithdrawDelegatorReward)(n.accountAddress, c.validatorAddress), S = (0, eip712_1$1.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$1.createEIP712)(m, e.chainId, S), E = (0, proto_1$3.createMsgWithdrawDelegatorReward)(n.accountAddress, c.validatorAddress), O = (0, proto_1$3.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
staking.createTxMsgWithdrawDelegatorReward = createTxMsgWithdrawDelegatorReward;
function createTxMsgMultipleWithdrawDelegatorReward(e, n, o, u, c) {
  const d = (0, eip712_1$1.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$1.generateTypes)(eip712_1$1.MSG_WITHDRAW_DELEGATOR_REWARD_TYPES), v = [], S = [];
  c.validatorAddresses.forEach((T) => {
    v.push((0, eip712_1$1.createMsgWithdrawDelegatorReward)(n.accountAddress, T)), S.push((0, proto_1$3.createMsgWithdrawDelegatorReward)(n.accountAddress, T));
  });
  const $ = (0, eip712_1$1.generateMessageWithMultipleTransactions)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), E = (0, eip712_1$1.createEIP712)(m, e.chainId, $), O = (0, proto_1$3.createTransactionWithMultipleMessages)(S, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: E
  };
}
staking.createTxMsgMultipleWithdrawDelegatorReward = createTxMsgMultipleWithdrawDelegatorReward;
function createTxMsgWithdrawValidatorCommission(e, n, o, u, c) {
  const d = (0, eip712_1$1.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1$1.generateTypes)(eip712_1$1.MSG_WITHDRAW_VALIDATOR_COMMISSION_TYPES), v = (0, eip712_1$1.createMsgWithdrawValidatorCommission)(c.validatorAddress), S = (0, eip712_1$1.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1$1.createEIP712)(m, e.chainId, S), E = (0, proto_1$3.createMsgWithdrawValidatorCommission)(c.validatorAddress), O = (0, proto_1$3.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
staking.createTxMsgWithdrawValidatorCommission = createTxMsgWithdrawValidatorCommission;
var txRaw = {};
Object.defineProperty(txRaw, "__esModule", { value: !0 });
txRaw.createTxRawEIP712 = void 0;
const proto_1$2 = dist$3;
function createTxRawEIP712(e, n, o) {
  return e.extension_options.push((0, proto_1$2.createAnyMessage)(o)), (0, proto_1$2.createTxRaw)(e.serializeBinary(), n.serializeBinary(), [
    new Uint8Array()
  ]);
}
txRaw.createTxRawEIP712 = createTxRawEIP712;
var validator$4 = {};
Object.defineProperty(validator$4, "__esModule", { value: !0 });
validator$4.createTxMsgEditValidator = void 0;
const proto_1$1 = dist$3, eip712_1 = dist$1;
function createTxMsgEditValidator(e, n, o, u, c) {
  const d = (0, eip712_1.generateFee)(o.amount, o.denom, o.gas, n.accountAddress), m = (0, eip712_1.generateTypes)(eip712_1.MSG_EDIT_VALIDATOR_TYPES), v = (0, eip712_1.createMsgEditValidator)(c.moniker, c.identity, c.website, c.securityContact, c.details, c.validatorAddress, c.commissionRate, c.minSelfDelegation), S = (0, eip712_1.generateMessage)(n.accountNumber.toString(), n.sequence.toString(), e.cosmosChainId, u, d, v), $ = (0, eip712_1.createEIP712)(m, e.chainId, S), E = (0, proto_1$1.createMsgEditValidator)(c.moniker, c.identity, c.website, c.securityContact, c.details, c.validatorAddress, c.commissionRate, c.minSelfDelegation), O = (0, proto_1$1.createTransaction)(E, u, o.amount, o.denom, parseInt(o.gas, 10), "ethsecp256", n.pubkey, n.sequence, n.accountNumber, e.cosmosChainId);
  return {
    signDirect: O.signDirect,
    legacyAmino: O.legacyAmino,
    eipToSign: $
  };
}
validator$4.createTxMsgEditValidator = createTxMsgEditValidator;
var web3Extension = {};
Object.defineProperty(web3Extension, "__esModule", { value: !0 });
web3Extension.signatureToWeb3Extension = void 0;
const proto_1 = dist$3;
function signatureToWeb3Extension(e, n, o) {
  let u = o;
  const c = o.split("0x");
  return c.length === 2 && ([, u] = c), (0, proto_1.createWeb3Extension)(e.chainId, n.accountAddress, Uint8Array.from(Buffer.from(u, "hex")));
}
web3Extension.signatureToWeb3Extension = signatureToWeb3Extension;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(u, c, d, m) {
    m === void 0 && (m = d);
    var v = Object.getOwnPropertyDescriptor(c, d);
    (!v || ("get" in v ? !c.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
      return c[d];
    } }), Object.defineProperty(u, m, v);
  } : function(u, c, d, m) {
    m === void 0 && (m = d), u[m] = c[d];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(u, c) {
    for (var d in u)
      d !== "default" && !Object.prototype.hasOwnProperty.call(c, d) && n(c, u, d);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), o(msgCancelFeeSplit$2, e), o(msgUpdateFeeSplit, e), o(msgRegisterFeeSplit, e), o(msgConvertCoin, e), o(msgConvertERC20, e), o(grant, e), o(revoke, e), o(common, e), o(gov, e), o(ibcMsgTransfer, e), o(msgSend, e), o(staking, e), o(txRaw, e), o(validator$4, e), o(web3Extension, e);
})(dist$4);
class WithdrawMessageAdapter {
  toProto(n) {
    const o = n.value;
    return dist$3.createMsgWithdrawDelegatorReward(o.delegatorAddress, o.validatorAddress);
  }
  getTypes() {
    return dist$1.MSG_WITHDRAW_DELEGATOR_REWARD_TYPES;
  }
}
class WithdrawCommissionMessageAdapter {
  toProto(n) {
    const o = n.value;
    return dist$3.createMsgWithdrawDelegatorReward(o.delegatorAddress, o.validatorAddress);
  }
  getTypes() {
    return dist$1.MSG_WITHDRAW_VALIDATOR_COMMISSION_TYPES;
  }
}
class BeginRedelegateMessageAdapter {
  toProto(n) {
    const o = n.value;
    return dist$3.createMsgBeginRedelegate(
      o.delegatorAddress,
      o.validatorSrcAddress,
      o.validatorDstAddress,
      o.amount.amount,
      o.amount.denom
    );
  }
  getTypes() {
    return dist$1.MSG_BEGIN_REDELEGATE_TYPES;
  }
}
class DelegateMessageAdapter {
  toProto(n) {
    const o = n.value, u = Array.isArray(o.amount) ? o.amount[0] : o.amount;
    return dist$3.createMsgDelegate(o.delegatorAddress, o.validatorAddress, u.amount, u.denom);
  }
  getTypes() {
    return dist$1.MSG_DELEGATE_TYPES;
  }
}
class SendMessageAdapter {
  toProto(n) {
    const o = n.value, u = Array.isArray(o.amount) ? o.amount[0] : o.amount;
    return dist$3.createMsgSend(o.fromAddress, o.toAddress, u.amount, u.denom);
  }
  getTypes() {
    return dist$1.MSG_SEND_TYPES;
  }
}
class UndelegateMessageAdapter {
  toProto(n) {
    const o = n.value, u = Array.isArray(o.amount) ? o.amount[0] : o.amount;
    return dist$3.createMsgUndelegate(o.delegatorAddress, o.validatorAddress, u.amount, u.denom);
  }
  getTypes() {
    return dist$1.MSG_UNDELEGATE_TYPES;
  }
}
class VoteMessageAdapter {
  toProto(n) {
    const o = n.value;
    return dist$3.createMsgVote(o.proposalId, o.option, o.voter);
  }
  getTypes() {
    return dist$1.MSG_VOTE_TYPES;
  }
}
class IBCMessageAdapter {
  toProto(n) {
    const o = n.value;
    return dist$3.createIBCMsgTransfer(
      o.sourcePort,
      o.sourceChannel,
      o.amount.amount,
      o.amount.denom,
      o.sender,
      o.receiver,
      o.revisionNumber,
      o.revisionHeight,
      o.timeoutTimestamp
    );
  }
  getTypes() {
    return dist$1.IBC_MSG_TRANSFER_TYPES;
  }
}
const defaultMessageAdapter = {
  "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": new WithdrawMessageAdapter(),
  "/cosmos.staking.v1beta1.MsgDelegate": new DelegateMessageAdapter(),
  "/cosmos.staking.v1beta1.MsgBeginRedelegate": new BeginRedelegateMessageAdapter(),
  "/cosmos.staking.v1beta1.MsgUndelegate": new UndelegateMessageAdapter(),
  "/cosmos.bank.v1beta1.MsgSend": new SendMessageAdapter(),
  "/cosmos.gov.v1beta1.MsgVote": new VoteMessageAdapter(),
  "/ibc.applications.transfer.v1.MsgTransfer": new IBCMessageAdapter(),
  "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": new WithdrawCommissionMessageAdapter()
}, ethToEthermint = (e, n) => {
  const o = build$V.fromHex(e.replace("0x", ""));
  return build$V.toBech32(n, o);
}, ethermintToEth = (e) => {
  const { data: n } = build$V.fromBech32(e);
  return `0x${build$V.toHex(n)}`;
};
function decimal2percent(e) {
  return e ? parseFloat((Number(e) * 100).toFixed(2)) : "";
}
class LedgerWallet {
  constructor(n, o) {
    fi(this, "name");
    fi(this, "transport");
    fi(this, "hdPath");
    fi(this, "registry");
    fi(this, "aminoTypes", new build$S.AminoTypes({
      ...build$S.createDefaultAminoConverters(),
      ...build$o.createWasmAminoConverters()
    }));
    fi(this, "conf");
    this.transport = n.transport || "usb", this.hdPath = n.hdPath || DEFAULT_HDPATH, this.registry = o, this.conf = n;
  }
  async getSigner() {
    const n = this.transport === "usb" ? await TransportWebUSB.create() : await BluetoothTransport.create(), o = build$W.stringToPath(this.hdPath), u = Number(o[1]);
    let c = "Cosmos";
    switch (u) {
      case 60:
        throw new Error("Not support.");
      case 529:
        c = "Secret";
        break;
      case 852:
        c = "Desmos";
        break;
      case 330:
        c = "Terra";
        break;
    }
    return new build$f.LedgerSigner(n, {
      ledgerAppName: c,
      // @ts-ignore
      hdPaths: [o]
    });
  }
  async getAccounts() {
    return (await (await this.getSigner()).getAccounts()).map((u) => ({
      address: u.address,
      algo: u.algo,
      pubkey: u.pubkey
    }));
  }
  supportCoinType(n) {
    return Promise.resolve(!0);
  }
  isEthermint() {
    return this.conf.hdPath && this.conf.hdPath.startsWith("m/44'/60");
  }
  async sign(n) {
    return this.signAmino(n);
  }
  // not finished, due to the outdated dependency.
  async sign712(n) {
    const o = {
      chainId: extractChainId(n.signerData.chainId),
      cosmosChainId: n.chainId
    }, u = await this.getSigner(), c = ethermintToEth(n.signerAddress), d = await u.getAccounts();
    if (!d.find((M) => M.address === c))
      throw new Error("The signer address dose not exsits in Ledger!");
    const v = {
      accountAddress: n.signerAddress,
      sequence: n.signerData.sequence,
      accountNumber: n.signerData.accountNumber,
      pubkey: build$V.toBase64(d[0].pubkey)
    }, S = dist$1.generateFee(
      n.fee.amount[0].amount,
      n.fee.amount[0].denom,
      n.fee.gas,
      n.signerAddress
    ), $ = n.messages.map((M) => this.aminoTypes.toAmino(M)), E = dist$1.generateMessageWithMultipleTransactions(
      v.accountNumber.toString(),
      v.sequence.toString(),
      n.signerData.chainId,
      n.memo,
      S,
      $
    ), O = dist$1.generateTypes(
      defaultMessageAdapter[n.messages[0].typeUrl].getTypes()
    ), T = dist$1.createEIP712(O, o.chainId, E), y = await this.getSigner().sign712(T);
    return this.makeRawTxEvmos(
      v,
      n.messages,
      n.memo,
      n.fee,
      y,
      o
    );
  }
  makeRawTxEvmos(n, o, u, c, d, m) {
    const v = o.map((O) => defaultMessageAdapter[O.typeUrl].toProto(O)), S = dist$3.createTransactionWithMultipleMessages(
      v,
      u,
      c.amount[0].amount,
      c.amount[0].denom,
      Number(c.gas),
      "ethsecp256",
      n.pubkey,
      n.sequence,
      n.accountNumber,
      m.cosmosChainId
    ), $ = dist$4.signatureToWeb3Extension(m, n, d);
    return dist$4.createTxRawEIP712(
      S.legacyAmino.body,
      S.legacyAmino.authInfo,
      $
    ).message.serializeBinary();
  }
  async signAmino(n) {
    const o = await this.getSigner(), u = await this.getAccounts(), { data: c } = build$V.fromBech32(n.signerAddress), d = build$V.toHex(c), m = build$V.toBech32("cosmos", c), v = u.find(
      (ee) => build$V.toHex(build$V.fromBech32(ee.address).data) === d
    );
    if (!v)
      throw new Error("Failed to retrieve account from signer");
    const S = build$Q.encodePubkey(
      build$P.encodeSecp256k1Pubkey(v.pubkey)
    ), $ = signing$3.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, E = n.messages.map((ee) => this.aminoTypes.toAmino(ee)), O = build$P.makeSignDoc(
      E,
      n.fee,
      n.chainId,
      n.memo,
      n.signerData.accountNumber,
      n.signerData.sequence
    ), { signature: T, signed: y } = await o.signAmino(
      m,
      O
    ), M = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: y.msgs.map((ee) => this.aminoTypes.fromAmino(ee)),
        memo: y.memo
      }
    }, G = this.registry.encode(
      M
    ), k = Number(y.fee.gas), F = Number(y.sequence), X = build$Q.makeAuthInfoBytes(
      [{ pubkey: S, sequence: F }],
      y.fee.amount,
      k,
      y.fee.granter,
      y.fee.payer,
      $
    );
    return tx$p.TxRaw.fromPartial({
      bodyBytes: G,
      authInfoBytes: X,
      signatures: [build$V.fromBase64(T.signature)]
    });
  }
}
var sha3$1 = { exports: {} };
(function(e) {
  (function() {
    var n = "input is invalid type", o = "finalize already called", u = typeof window == "object", c = u ? window : {};
    c.JS_SHA3_NO_WINDOW && (u = !1);
    var d = !u && typeof self == "object", m = !c.JS_SHA3_NO_NODE_JS && typeof browser$1$1 == "object" && browser$1$1.versions && browser$1$1.versions.node;
    m ? c = commonjsGlobal : d && (c = self);
    var v = !c.JS_SHA3_NO_COMMON_JS && !0 && e.exports, S = !c.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", $ = "0123456789abcdef".split(""), E = [31, 7936, 2031616, 520093696], O = [4, 1024, 262144, 67108864], T = [1, 256, 65536, 16777216], y = [6, 1536, 393216, 100663296], V = [0, 8, 16, 24], M = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], G = [224, 256, 384, 512], k = [128, 256], F = ["hex", "buffer", "arrayBuffer", "array", "digest"], X = {
      128: 168,
      256: 136
    };
    (c.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(xe) {
      return Object.prototype.toString.call(xe) === "[object Array]";
    }), S && (c.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(xe) {
      return typeof xe == "object" && xe.buffer && xe.buffer.constructor === ArrayBuffer;
    });
    for (var ee = function(xe, ze, nt) {
      return function(Qt) {
        return new ge(xe, ze, xe).update(Qt)[nt]();
      };
    }, ue = function(xe, ze, nt) {
      return function(Qt, Et) {
        return new ge(xe, ze, Et).update(Qt)[nt]();
      };
    }, Q = function(xe, ze, nt) {
      return function(Qt, Et, zt, Nt) {
        return P["cshake" + xe].update(Qt, Et, zt, Nt)[nt]();
      };
    }, Y = function(xe, ze, nt) {
      return function(Qt, Et, zt, Nt) {
        return P["kmac" + xe].update(Qt, Et, zt, Nt)[nt]();
      };
    }, pe = function(xe, ze, nt, Qt) {
      for (var Et = 0; Et < F.length; ++Et) {
        var zt = F[Et];
        xe[zt] = ze(nt, Qt, zt);
      }
      return xe;
    }, oe = function(xe, ze) {
      var nt = ee(xe, ze, "hex");
      return nt.create = function() {
        return new ge(xe, ze, xe);
      }, nt.update = function(Qt) {
        return nt.create().update(Qt);
      }, pe(nt, ee, xe, ze);
    }, ne = function(xe, ze) {
      var nt = ue(xe, ze, "hex");
      return nt.create = function(Qt) {
        return new ge(xe, ze, Qt);
      }, nt.update = function(Qt, Et) {
        return nt.create(Et).update(Qt);
      }, pe(nt, ue, xe, ze);
    }, H = function(xe, ze) {
      var nt = X[xe], Qt = Q(xe, ze, "hex");
      return Qt.create = function(Et, zt, Nt) {
        return !zt && !Nt ? P["shake" + xe].create(Et) : new ge(xe, ze, Et).bytepad([zt, Nt], nt);
      }, Qt.update = function(Et, zt, Nt, pt) {
        return Qt.create(zt, Nt, pt).update(Et);
      }, pe(Qt, Q, xe, ze);
    }, C = function(xe, ze) {
      var nt = X[xe], Qt = Y(xe, ze, "hex");
      return Qt.create = function(Et, zt, Nt) {
        return new Pe(xe, ze, zt).bytepad(["KMAC", Nt], nt).bytepad([Et], nt);
      }, Qt.update = function(Et, zt, Nt, pt) {
        return Qt.create(Et, Nt, pt).update(zt);
      }, pe(Qt, Y, xe, ze);
    }, w = [
      { name: "keccak", padding: T, bits: G, createMethod: oe },
      { name: "sha3", padding: y, bits: G, createMethod: oe },
      { name: "shake", padding: E, bits: k, createMethod: ne },
      { name: "cshake", padding: O, bits: k, createMethod: H },
      { name: "kmac", padding: O, bits: k, createMethod: C }
    ], P = {}, J = [], se = 0; se < w.length; ++se)
      for (var fe = w[se], N = fe.bits, W = 0; W < N.length; ++W) {
        var I = fe.name + "_" + N[W];
        if (J.push(I), P[I] = fe.createMethod(N[W], fe.padding), fe.name !== "sha3") {
          var te = fe.name + N[W];
          J.push(te), P[te] = P[I];
        }
      }
    function ge(xe, ze, nt) {
      this.blocks = [], this.s = [], this.padding = ze, this.outputBits = nt, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (xe << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = nt >> 5, this.extraBytes = (nt & 31) >> 3;
      for (var Qt = 0; Qt < 50; ++Qt)
        this.s[Qt] = 0;
    }
    ge.prototype.update = function(xe) {
      if (this.finalized)
        throw new Error(o);
      var ze, nt = typeof xe;
      if (nt !== "string") {
        if (nt === "object") {
          if (xe === null)
            throw new Error(n);
          if (S && xe.constructor === ArrayBuffer)
            xe = new Uint8Array(xe);
          else if (!Array.isArray(xe) && (!S || !ArrayBuffer.isView(xe)))
            throw new Error(n);
        } else
          throw new Error(n);
        ze = !0;
      }
      for (var Qt = this.blocks, Et = this.byteCount, zt = xe.length, Nt = this.blockCount, pt = 0, at = this.s, kt, Ut; pt < zt; ) {
        if (this.reset)
          for (this.reset = !1, Qt[0] = this.block, kt = 1; kt < Nt + 1; ++kt)
            Qt[kt] = 0;
        if (ze)
          for (kt = this.start; pt < zt && kt < Et; ++pt)
            Qt[kt >> 2] |= xe[pt] << V[kt++ & 3];
        else
          for (kt = this.start; pt < zt && kt < Et; ++pt)
            Ut = xe.charCodeAt(pt), Ut < 128 ? Qt[kt >> 2] |= Ut << V[kt++ & 3] : Ut < 2048 ? (Qt[kt >> 2] |= (192 | Ut >> 6) << V[kt++ & 3], Qt[kt >> 2] |= (128 | Ut & 63) << V[kt++ & 3]) : Ut < 55296 || Ut >= 57344 ? (Qt[kt >> 2] |= (224 | Ut >> 12) << V[kt++ & 3], Qt[kt >> 2] |= (128 | Ut >> 6 & 63) << V[kt++ & 3], Qt[kt >> 2] |= (128 | Ut & 63) << V[kt++ & 3]) : (Ut = 65536 + ((Ut & 1023) << 10 | xe.charCodeAt(++pt) & 1023), Qt[kt >> 2] |= (240 | Ut >> 18) << V[kt++ & 3], Qt[kt >> 2] |= (128 | Ut >> 12 & 63) << V[kt++ & 3], Qt[kt >> 2] |= (128 | Ut >> 6 & 63) << V[kt++ & 3], Qt[kt >> 2] |= (128 | Ut & 63) << V[kt++ & 3]);
        if (this.lastByteIndex = kt, kt >= Et) {
          for (this.start = kt - Et, this.block = Qt[Nt], kt = 0; kt < Nt; ++kt)
            at[kt] ^= Qt[kt];
          Ke(at), this.reset = !0;
        } else
          this.start = kt;
      }
      return this;
    }, ge.prototype.encode = function(xe, ze) {
      var nt = xe & 255, Qt = 1, Et = [nt];
      for (xe = xe >> 8, nt = xe & 255; nt > 0; )
        Et.unshift(nt), xe = xe >> 8, nt = xe & 255, ++Qt;
      return ze ? Et.push(Qt) : Et.unshift(Qt), this.update(Et), Et.length;
    }, ge.prototype.encodeString = function(xe) {
      var ze, nt = typeof xe;
      if (nt !== "string") {
        if (nt === "object") {
          if (xe === null)
            throw new Error(n);
          if (S && xe.constructor === ArrayBuffer)
            xe = new Uint8Array(xe);
          else if (!Array.isArray(xe) && (!S || !ArrayBuffer.isView(xe)))
            throw new Error(n);
        } else
          throw new Error(n);
        ze = !0;
      }
      var Qt = 0, Et = xe.length;
      if (ze)
        Qt = Et;
      else
        for (var zt = 0; zt < xe.length; ++zt) {
          var Nt = xe.charCodeAt(zt);
          Nt < 128 ? Qt += 1 : Nt < 2048 ? Qt += 2 : Nt < 55296 || Nt >= 57344 ? Qt += 3 : (Nt = 65536 + ((Nt & 1023) << 10 | xe.charCodeAt(++zt) & 1023), Qt += 4);
        }
      return Qt += this.encode(Qt * 8), this.update(xe), Qt;
    }, ge.prototype.bytepad = function(xe, ze) {
      for (var nt = this.encode(ze), Qt = 0; Qt < xe.length; ++Qt)
        nt += this.encodeString(xe[Qt]);
      var Et = ze - nt % ze, zt = [];
      return zt.length = Et, this.update(zt), this;
    }, ge.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var xe = this.blocks, ze = this.lastByteIndex, nt = this.blockCount, Qt = this.s;
        if (xe[ze >> 2] |= this.padding[ze & 3], this.lastByteIndex === this.byteCount)
          for (xe[0] = xe[nt], ze = 1; ze < nt + 1; ++ze)
            xe[ze] = 0;
        for (xe[nt - 1] |= 2147483648, ze = 0; ze < nt; ++ze)
          Qt[ze] ^= xe[ze];
        Ke(Qt);
      }
    }, ge.prototype.toString = ge.prototype.hex = function() {
      this.finalize();
      for (var xe = this.blockCount, ze = this.s, nt = this.outputBlocks, Qt = this.extraBytes, Et = 0, zt = 0, Nt = "", pt; zt < nt; ) {
        for (Et = 0; Et < xe && zt < nt; ++Et, ++zt)
          pt = ze[Et], Nt += $[pt >> 4 & 15] + $[pt & 15] + $[pt >> 12 & 15] + $[pt >> 8 & 15] + $[pt >> 20 & 15] + $[pt >> 16 & 15] + $[pt >> 28 & 15] + $[pt >> 24 & 15];
        zt % xe === 0 && (Ke(ze), Et = 0);
      }
      return Qt && (pt = ze[Et], Nt += $[pt >> 4 & 15] + $[pt & 15], Qt > 1 && (Nt += $[pt >> 12 & 15] + $[pt >> 8 & 15]), Qt > 2 && (Nt += $[pt >> 20 & 15] + $[pt >> 16 & 15])), Nt;
    }, ge.prototype.arrayBuffer = function() {
      this.finalize();
      var xe = this.blockCount, ze = this.s, nt = this.outputBlocks, Qt = this.extraBytes, Et = 0, zt = 0, Nt = this.outputBits >> 3, pt;
      Qt ? pt = new ArrayBuffer(nt + 1 << 2) : pt = new ArrayBuffer(Nt);
      for (var at = new Uint32Array(pt); zt < nt; ) {
        for (Et = 0; Et < xe && zt < nt; ++Et, ++zt)
          at[zt] = ze[Et];
        zt % xe === 0 && Ke(ze);
      }
      return Qt && (at[Et] = ze[Et], pt = pt.slice(0, Nt)), pt;
    }, ge.prototype.buffer = ge.prototype.arrayBuffer, ge.prototype.digest = ge.prototype.array = function() {
      this.finalize();
      for (var xe = this.blockCount, ze = this.s, nt = this.outputBlocks, Qt = this.extraBytes, Et = 0, zt = 0, Nt = [], pt, at; zt < nt; ) {
        for (Et = 0; Et < xe && zt < nt; ++Et, ++zt)
          pt = zt << 2, at = ze[Et], Nt[pt] = at & 255, Nt[pt + 1] = at >> 8 & 255, Nt[pt + 2] = at >> 16 & 255, Nt[pt + 3] = at >> 24 & 255;
        zt % xe === 0 && Ke(ze);
      }
      return Qt && (pt = zt << 2, at = ze[Et], Nt[pt] = at & 255, Qt > 1 && (Nt[pt + 1] = at >> 8 & 255), Qt > 2 && (Nt[pt + 2] = at >> 16 & 255)), Nt;
    };
    function Pe(xe, ze, nt) {
      ge.call(this, xe, ze, nt);
    }
    Pe.prototype = new ge(), Pe.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), ge.prototype.finalize.call(this);
    };
    var Ke = function(xe) {
      var ze, nt, Qt, Et, zt, Nt, pt, at, kt, Ut, dn, En, Ht, Xt, On, sn, At, hn, $t, Lt, Qn, ce, Ze, ft, It, rn, Ln, Pn, Ae, Me, He, cn, Wt, yn, pr, Uo, ar, Sr, Jo, fr, Er, vo, lr, $r, Wo, yr, Dr, Zo, dr, Br, Qo, tr, Mr, qo, hr, Or, Fo, No, di, gi, ai, ui, hi;
      for (Qt = 0; Qt < 48; Qt += 2)
        Et = xe[0] ^ xe[10] ^ xe[20] ^ xe[30] ^ xe[40], zt = xe[1] ^ xe[11] ^ xe[21] ^ xe[31] ^ xe[41], Nt = xe[2] ^ xe[12] ^ xe[22] ^ xe[32] ^ xe[42], pt = xe[3] ^ xe[13] ^ xe[23] ^ xe[33] ^ xe[43], at = xe[4] ^ xe[14] ^ xe[24] ^ xe[34] ^ xe[44], kt = xe[5] ^ xe[15] ^ xe[25] ^ xe[35] ^ xe[45], Ut = xe[6] ^ xe[16] ^ xe[26] ^ xe[36] ^ xe[46], dn = xe[7] ^ xe[17] ^ xe[27] ^ xe[37] ^ xe[47], En = xe[8] ^ xe[18] ^ xe[28] ^ xe[38] ^ xe[48], Ht = xe[9] ^ xe[19] ^ xe[29] ^ xe[39] ^ xe[49], ze = En ^ (Nt << 1 | pt >>> 31), nt = Ht ^ (pt << 1 | Nt >>> 31), xe[0] ^= ze, xe[1] ^= nt, xe[10] ^= ze, xe[11] ^= nt, xe[20] ^= ze, xe[21] ^= nt, xe[30] ^= ze, xe[31] ^= nt, xe[40] ^= ze, xe[41] ^= nt, ze = Et ^ (at << 1 | kt >>> 31), nt = zt ^ (kt << 1 | at >>> 31), xe[2] ^= ze, xe[3] ^= nt, xe[12] ^= ze, xe[13] ^= nt, xe[22] ^= ze, xe[23] ^= nt, xe[32] ^= ze, xe[33] ^= nt, xe[42] ^= ze, xe[43] ^= nt, ze = Nt ^ (Ut << 1 | dn >>> 31), nt = pt ^ (dn << 1 | Ut >>> 31), xe[4] ^= ze, xe[5] ^= nt, xe[14] ^= ze, xe[15] ^= nt, xe[24] ^= ze, xe[25] ^= nt, xe[34] ^= ze, xe[35] ^= nt, xe[44] ^= ze, xe[45] ^= nt, ze = at ^ (En << 1 | Ht >>> 31), nt = kt ^ (Ht << 1 | En >>> 31), xe[6] ^= ze, xe[7] ^= nt, xe[16] ^= ze, xe[17] ^= nt, xe[26] ^= ze, xe[27] ^= nt, xe[36] ^= ze, xe[37] ^= nt, xe[46] ^= ze, xe[47] ^= nt, ze = Ut ^ (Et << 1 | zt >>> 31), nt = dn ^ (zt << 1 | Et >>> 31), xe[8] ^= ze, xe[9] ^= nt, xe[18] ^= ze, xe[19] ^= nt, xe[28] ^= ze, xe[29] ^= nt, xe[38] ^= ze, xe[39] ^= nt, xe[48] ^= ze, xe[49] ^= nt, Xt = xe[0], On = xe[1], yr = xe[11] << 4 | xe[10] >>> 28, Dr = xe[10] << 4 | xe[11] >>> 28, Pn = xe[20] << 3 | xe[21] >>> 29, Ae = xe[21] << 3 | xe[20] >>> 29, gi = xe[31] << 9 | xe[30] >>> 23, ai = xe[30] << 9 | xe[31] >>> 23, vo = xe[40] << 18 | xe[41] >>> 14, lr = xe[41] << 18 | xe[40] >>> 14, yn = xe[2] << 1 | xe[3] >>> 31, pr = xe[3] << 1 | xe[2] >>> 31, sn = xe[13] << 12 | xe[12] >>> 20, At = xe[12] << 12 | xe[13] >>> 20, Zo = xe[22] << 10 | xe[23] >>> 22, dr = xe[23] << 10 | xe[22] >>> 22, Me = xe[33] << 13 | xe[32] >>> 19, He = xe[32] << 13 | xe[33] >>> 19, ui = xe[42] << 2 | xe[43] >>> 30, hi = xe[43] << 2 | xe[42] >>> 30, qo = xe[5] << 30 | xe[4] >>> 2, hr = xe[4] << 30 | xe[5] >>> 2, Uo = xe[14] << 6 | xe[15] >>> 26, ar = xe[15] << 6 | xe[14] >>> 26, hn = xe[25] << 11 | xe[24] >>> 21, $t = xe[24] << 11 | xe[25] >>> 21, Br = xe[34] << 15 | xe[35] >>> 17, Qo = xe[35] << 15 | xe[34] >>> 17, cn = xe[45] << 29 | xe[44] >>> 3, Wt = xe[44] << 29 | xe[45] >>> 3, ft = xe[6] << 28 | xe[7] >>> 4, It = xe[7] << 28 | xe[6] >>> 4, Or = xe[17] << 23 | xe[16] >>> 9, Fo = xe[16] << 23 | xe[17] >>> 9, Sr = xe[26] << 25 | xe[27] >>> 7, Jo = xe[27] << 25 | xe[26] >>> 7, Lt = xe[36] << 21 | xe[37] >>> 11, Qn = xe[37] << 21 | xe[36] >>> 11, tr = xe[47] << 24 | xe[46] >>> 8, Mr = xe[46] << 24 | xe[47] >>> 8, $r = xe[8] << 27 | xe[9] >>> 5, Wo = xe[9] << 27 | xe[8] >>> 5, rn = xe[18] << 20 | xe[19] >>> 12, Ln = xe[19] << 20 | xe[18] >>> 12, No = xe[29] << 7 | xe[28] >>> 25, di = xe[28] << 7 | xe[29] >>> 25, fr = xe[38] << 8 | xe[39] >>> 24, Er = xe[39] << 8 | xe[38] >>> 24, ce = xe[48] << 14 | xe[49] >>> 18, Ze = xe[49] << 14 | xe[48] >>> 18, xe[0] = Xt ^ ~sn & hn, xe[1] = On ^ ~At & $t, xe[10] = ft ^ ~rn & Pn, xe[11] = It ^ ~Ln & Ae, xe[20] = yn ^ ~Uo & Sr, xe[21] = pr ^ ~ar & Jo, xe[30] = $r ^ ~yr & Zo, xe[31] = Wo ^ ~Dr & dr, xe[40] = qo ^ ~Or & No, xe[41] = hr ^ ~Fo & di, xe[2] = sn ^ ~hn & Lt, xe[3] = At ^ ~$t & Qn, xe[12] = rn ^ ~Pn & Me, xe[13] = Ln ^ ~Ae & He, xe[22] = Uo ^ ~Sr & fr, xe[23] = ar ^ ~Jo & Er, xe[32] = yr ^ ~Zo & Br, xe[33] = Dr ^ ~dr & Qo, xe[42] = Or ^ ~No & gi, xe[43] = Fo ^ ~di & ai, xe[4] = hn ^ ~Lt & ce, xe[5] = $t ^ ~Qn & Ze, xe[14] = Pn ^ ~Me & cn, xe[15] = Ae ^ ~He & Wt, xe[24] = Sr ^ ~fr & vo, xe[25] = Jo ^ ~Er & lr, xe[34] = Zo ^ ~Br & tr, xe[35] = dr ^ ~Qo & Mr, xe[44] = No ^ ~gi & ui, xe[45] = di ^ ~ai & hi, xe[6] = Lt ^ ~ce & Xt, xe[7] = Qn ^ ~Ze & On, xe[16] = Me ^ ~cn & ft, xe[17] = He ^ ~Wt & It, xe[26] = fr ^ ~vo & yn, xe[27] = Er ^ ~lr & pr, xe[36] = Br ^ ~tr & $r, xe[37] = Qo ^ ~Mr & Wo, xe[46] = gi ^ ~ui & qo, xe[47] = ai ^ ~hi & hr, xe[8] = ce ^ ~Xt & sn, xe[9] = Ze ^ ~On & At, xe[18] = cn ^ ~ft & rn, xe[19] = Wt ^ ~It & Ln, xe[28] = vo ^ ~yn & Uo, xe[29] = lr ^ ~pr & ar, xe[38] = tr ^ ~$r & yr, xe[39] = Mr ^ ~Wo & Dr, xe[48] = ui ^ ~qo & Or, xe[49] = hi ^ ~hr & Fo, xe[0] ^= M[Qt], xe[1] ^= M[Qt + 1];
    };
    if (v)
      e.exports = P;
    else
      for (se = 0; se < J.length; ++se)
        c[J[se]] = P[J[se]];
  })();
})(sha3$1);
var sha3Exports = sha3$1.exports;
const sha3 = /* @__PURE__ */ getDefaultExportFromCjs(sha3Exports), version$4 = "logger/5.7.0";
let _permanentCensorErrors = !1, _censorErrors = !1;
const LogLevels = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels.default, _globalLogger = null;
function _checkNormalize() {
  try {
    const e = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((n) => {
      try {
        if ("test".normalize(n) !== "test")
          throw new Error("bad normalize");
      } catch {
        e.push(n);
      }
    }), e.length)
      throw new Error("missing " + e.join(", "));
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769))
      throw new Error("broken implementation");
  } catch (e) {
    return e.message;
  }
  return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function(e) {
  e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function(e) {
  e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger {
  constructor(n) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: n,
      writable: !1
    });
  }
  _log(n, o) {
    const u = n.toLowerCase();
    LogLevels[u] == null && this.throwArgumentError("invalid log level name", "logLevel", n), !(_logLevel > LogLevels[u]) && console.log.apply(console, o);
  }
  debug(...n) {
    this._log(Logger.levels.DEBUG, n);
  }
  info(...n) {
    this._log(Logger.levels.INFO, n);
  }
  warn(...n) {
    this._log(Logger.levels.WARNING, n);
  }
  makeError(n, o, u) {
    if (_censorErrors)
      return this.makeError("censored error", o, {});
    o || (o = Logger.errors.UNKNOWN_ERROR), u || (u = {});
    const c = [];
    Object.keys(u).forEach((S) => {
      const $ = u[S];
      try {
        if ($ instanceof Uint8Array) {
          let E = "";
          for (let O = 0; O < $.length; O++)
            E += HEX[$[O] >> 4], E += HEX[$[O] & 15];
          c.push(S + "=Uint8Array(0x" + E + ")");
        } else
          c.push(S + "=" + JSON.stringify($));
      } catch {
        c.push(S + "=" + JSON.stringify(u[S].toString()));
      }
    }), c.push(`code=${o}`), c.push(`version=${this.version}`);
    const d = n;
    let m = "";
    switch (o) {
      case ErrorCode.NUMERIC_FAULT: {
        m = "NUMERIC_FAULT";
        const S = n;
        switch (S) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            m += "-" + S;
            break;
          case "negative-power":
          case "negative-width":
            m += "-unsupported";
            break;
          case "unbound-bitwise-result":
            m += "-unbound-result";
            break;
        }
        break;
      }
      case ErrorCode.CALL_EXCEPTION:
      case ErrorCode.INSUFFICIENT_FUNDS:
      case ErrorCode.MISSING_NEW:
      case ErrorCode.NONCE_EXPIRED:
      case ErrorCode.REPLACEMENT_UNDERPRICED:
      case ErrorCode.TRANSACTION_REPLACED:
      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
        m = o;
        break;
    }
    m && (n += " [ See: https://links.ethers.org/v5-errors-" + m + " ]"), c.length && (n += " (" + c.join(", ") + ")");
    const v = new Error(n);
    return v.reason = d, v.code = o, Object.keys(u).forEach(function(S) {
      v[S] = u[S];
    }), v;
  }
  throwError(n, o, u) {
    throw this.makeError(n, o, u);
  }
  throwArgumentError(n, o, u) {
    return this.throwError(n, Logger.errors.INVALID_ARGUMENT, {
      argument: o,
      value: u
    });
  }
  assert(n, o, u, c) {
    n || this.throwError(o, u, c);
  }
  assertArgument(n, o, u, c) {
    n || this.throwArgumentError(o, u, c);
  }
  checkNormalize(n) {
    _normalizeError && this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: _normalizeError
    });
  }
  checkSafeUint53(n, o) {
    typeof n == "number" && (o == null && (o = "value not safe"), (n < 0 || n >= 9007199254740991) && this.throwError(o, Logger.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: n
    }), n % 1 && this.throwError(o, Logger.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: n
    }));
  }
  checkArgumentCount(n, o, u) {
    u ? u = ": " + u : u = "", n < o && this.throwError("missing argument" + u, Logger.errors.MISSING_ARGUMENT, {
      count: n,
      expectedCount: o
    }), n > o && this.throwError("too many arguments" + u, Logger.errors.UNEXPECTED_ARGUMENT, {
      count: n,
      expectedCount: o
    });
  }
  checkNew(n, o) {
    (n === Object || n == null) && this.throwError("missing new", Logger.errors.MISSING_NEW, { name: o.name });
  }
  checkAbstract(n, o) {
    n === o ? this.throwError("cannot instantiate abstract class " + JSON.stringify(o.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: n.name, operation: "new" }) : (n === Object || n == null) && this.throwError("missing new", Logger.errors.MISSING_NEW, { name: o.name });
  }
  static globalLogger() {
    return _globalLogger || (_globalLogger = new Logger(version$4)), _globalLogger;
  }
  static setCensorship(n, o) {
    if (!n && o && this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), _permanentCensorErrors) {
      if (!n)
        return;
      this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    _censorErrors = !!n, _permanentCensorErrors = !!o;
  }
  static setLogLevel(n) {
    const o = LogLevels[n.toLowerCase()];
    if (o == null) {
      Logger.globalLogger().warn("invalid log level - " + n);
      return;
    }
    _logLevel = o;
  }
  static from(n) {
    return new Logger(n);
  }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel;
const version$3 = "bytes/5.7.0", logger$2 = new Logger(version$3);
function isHexable(e) {
  return !!e.toHexString;
}
function addSlice(e) {
  return e.slice || (e.slice = function() {
    const n = Array.prototype.slice.call(arguments);
    return addSlice(new Uint8Array(Array.prototype.slice.apply(e, n)));
  }), e;
}
function isBytesLike(e) {
  return isHexString(e) && !(e.length % 2) || isBytes(e);
}
function isInteger(e) {
  return typeof e == "number" && e == e && e % 1 === 0;
}
function isBytes(e) {
  if (e == null)
    return !1;
  if (e.constructor === Uint8Array)
    return !0;
  if (typeof e == "string" || !isInteger(e.length) || e.length < 0)
    return !1;
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    if (!isInteger(o) || o < 0 || o >= 256)
      return !1;
  }
  return !0;
}
function arrayify(e, n) {
  if (n || (n = {}), typeof e == "number") {
    logger$2.checkSafeUint53(e, "invalid arrayify value");
    const o = [];
    for (; e; )
      o.unshift(e & 255), e = parseInt(String(e / 256));
    return o.length === 0 && o.push(0), addSlice(new Uint8Array(o));
  }
  if (n.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), isHexable(e) && (e = e.toHexString()), isHexString(e)) {
    let o = e.substring(2);
    o.length % 2 && (n.hexPad === "left" ? o = "0" + o : n.hexPad === "right" ? o += "0" : logger$2.throwArgumentError("hex data is odd-length", "value", e));
    const u = [];
    for (let c = 0; c < o.length; c += 2)
      u.push(parseInt(o.substring(c, c + 2), 16));
    return addSlice(new Uint8Array(u));
  }
  return isBytes(e) ? addSlice(new Uint8Array(e)) : logger$2.throwArgumentError("invalid arrayify value", "value", e);
}
function concat$2(e) {
  const n = e.map((c) => arrayify(c)), o = n.reduce((c, d) => c + d.length, 0), u = new Uint8Array(o);
  return n.reduce((c, d) => (u.set(d, c), c + d.length), 0), addSlice(u);
}
function zeroPad(e, n) {
  e = arrayify(e), e.length > n && logger$2.throwArgumentError("value out of range", "value", arguments[0]);
  const o = new Uint8Array(n);
  return o.set(e, n - e.length), addSlice(o);
}
function isHexString(e, n) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || n && e.length !== 2 + 2 * n);
}
const HexCharacters = "0123456789abcdef";
function hexlify(e, n) {
  if (n || (n = {}), typeof e == "number") {
    logger$2.checkSafeUint53(e, "invalid hexlify value");
    let o = "";
    for (; e; )
      o = HexCharacters[e & 15] + o, e = Math.floor(e / 16);
    return o.length ? (o.length % 2 && (o = "0" + o), "0x" + o) : "0x00";
  }
  if (typeof e == "bigint")
    return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
  if (n.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), isHexable(e))
    return e.toHexString();
  if (isHexString(e))
    return e.length % 2 && (n.hexPad === "left" ? e = "0x0" + e.substring(2) : n.hexPad === "right" ? e += "0" : logger$2.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
  if (isBytes(e)) {
    let o = "0x";
    for (let u = 0; u < e.length; u++) {
      let c = e[u];
      o += HexCharacters[(c & 240) >> 4] + HexCharacters[c & 15];
    }
    return o;
  }
  return logger$2.throwArgumentError("invalid hexlify value", "value", e);
}
function hexDataLength(e) {
  if (typeof e != "string")
    e = hexlify(e);
  else if (!isHexString(e) || e.length % 2)
    return null;
  return (e.length - 2) / 2;
}
function hexZeroPad(e, n) {
  for (typeof e != "string" ? e = hexlify(e) : isHexString(e) || logger$2.throwArgumentError("invalid hex string", "value", e), e.length > 2 * n + 2 && logger$2.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * n + 2; )
    e = "0x0" + e.substring(2);
  return e;
}
function splitSignature(e) {
  const n = {
    r: "0x",
    s: "0x",
    _vs: "0x",
    recoveryParam: 0,
    v: 0,
    yParityAndS: "0x",
    compact: "0x"
  };
  if (isBytesLike(e)) {
    let o = arrayify(e);
    o.length === 64 ? (n.v = 27 + (o[32] >> 7), o[32] &= 127, n.r = hexlify(o.slice(0, 32)), n.s = hexlify(o.slice(32, 64))) : o.length === 65 ? (n.r = hexlify(o.slice(0, 32)), n.s = hexlify(o.slice(32, 64)), n.v = o[64]) : logger$2.throwArgumentError("invalid signature string", "signature", e), n.v < 27 && (n.v === 0 || n.v === 1 ? n.v += 27 : logger$2.throwArgumentError("signature invalid v byte", "signature", e)), n.recoveryParam = 1 - n.v % 2, n.recoveryParam && (o[32] |= 128), n._vs = hexlify(o.slice(32, 64));
  } else {
    if (n.r = e.r, n.s = e.s, n.v = e.v, n.recoveryParam = e.recoveryParam, n._vs = e._vs, n._vs != null) {
      const c = zeroPad(arrayify(n._vs), 32);
      n._vs = hexlify(c);
      const d = c[0] >= 128 ? 1 : 0;
      n.recoveryParam == null ? n.recoveryParam = d : n.recoveryParam !== d && logger$2.throwArgumentError("signature recoveryParam mismatch _vs", "signature", e), c[0] &= 127;
      const m = hexlify(c);
      n.s == null ? n.s = m : n.s !== m && logger$2.throwArgumentError("signature v mismatch _vs", "signature", e);
    }
    if (n.recoveryParam == null)
      n.v == null ? logger$2.throwArgumentError("signature missing v and recoveryParam", "signature", e) : n.v === 0 || n.v === 1 ? n.recoveryParam = n.v : n.recoveryParam = 1 - n.v % 2;
    else if (n.v == null)
      n.v = 27 + n.recoveryParam;
    else {
      const c = n.v === 0 || n.v === 1 ? n.v : 1 - n.v % 2;
      n.recoveryParam !== c && logger$2.throwArgumentError("signature recoveryParam mismatch v", "signature", e);
    }
    n.r == null || !isHexString(n.r) ? logger$2.throwArgumentError("signature missing or invalid r", "signature", e) : n.r = hexZeroPad(n.r, 32), n.s == null || !isHexString(n.s) ? logger$2.throwArgumentError("signature missing or invalid s", "signature", e) : n.s = hexZeroPad(n.s, 32);
    const o = arrayify(n.s);
    o[0] >= 128 && logger$2.throwArgumentError("signature s out of range", "signature", e), n.recoveryParam && (o[0] |= 128);
    const u = hexlify(o);
    n._vs && (isHexString(n._vs) || logger$2.throwArgumentError("signature invalid _vs", "signature", e), n._vs = hexZeroPad(n._vs, 32)), n._vs == null ? n._vs = u : n._vs !== u && logger$2.throwArgumentError("signature _vs mismatch v and s", "signature", e);
  }
  return n.yParityAndS = n._vs, n.compact = n.r + n.yParityAndS.substring(2), n;
}
function keccak256$1(e) {
  return "0x" + sha3.keccak_256(arrayify(e));
}
const version$2 = "strings/5.7.0", logger$1 = new Logger(version$2);
var UnicodeNormalizationForm;
(function(e) {
  e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
var Utf8ErrorReason;
(function(e) {
  e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})(Utf8ErrorReason || (Utf8ErrorReason = {}));
function toUtf8Bytes(e, n = UnicodeNormalizationForm.current) {
  n != UnicodeNormalizationForm.current && (logger$1.checkNormalize(), e = e.normalize(n));
  let o = [];
  for (let u = 0; u < e.length; u++) {
    const c = e.charCodeAt(u);
    if (c < 128)
      o.push(c);
    else if (c < 2048)
      o.push(c >> 6 | 192), o.push(c & 63 | 128);
    else if ((c & 64512) == 55296) {
      u++;
      const d = e.charCodeAt(u);
      if (u >= e.length || (d & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const m = 65536 + ((c & 1023) << 10) + (d & 1023);
      o.push(m >> 18 | 240), o.push(m >> 12 & 63 | 128), o.push(m >> 6 & 63 | 128), o.push(m & 63 | 128);
    } else
      o.push(c >> 12 | 224), o.push(c >> 6 & 63 | 128), o.push(c & 63 | 128);
  }
  return arrayify(o);
}
const messagePrefix = `Ethereum Signed Message:
`;
function hashMessage(e) {
  return typeof e == "string" && (e = toUtf8Bytes(e)), keccak256$1(concat$2([
    toUtf8Bytes(messagePrefix),
    toUtf8Bytes(String(e.length)),
    e
  ]));
}
globalThis && globalThis.__awaiter;
function defineReadOnly(e, n, o) {
  Object.defineProperty(e, n, {
    enumerable: !0,
    value: o,
    writable: !1
  });
}
function createCommonjsModule(e, n, o) {
  return o = {
    path: n,
    exports: {},
    require: function(u, c) {
      return commonjsRequire(u, c ?? o.path);
    }
  }, e(o, o.exports), o.exports;
}
function commonjsRequire() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var minimalisticAssert = assert$2;
function assert$2(e, n) {
  if (!e)
    throw new Error(n || "Assertion failed");
}
assert$2.equal = function e(n, o, u) {
  if (n != o)
    throw new Error(u || "Assertion failed: " + n + " != " + o);
};
var utils_1$i = createCommonjsModule(function(e, n) {
  var o = n;
  function u(m, v) {
    if (Array.isArray(m))
      return m.slice();
    if (!m)
      return [];
    var S = [];
    if (typeof m != "string") {
      for (var $ = 0; $ < m.length; $++)
        S[$] = m[$] | 0;
      return S;
    }
    if (v === "hex") {
      m = m.replace(/[^a-z0-9]+/ig, ""), m.length % 2 !== 0 && (m = "0" + m);
      for (var $ = 0; $ < m.length; $ += 2)
        S.push(parseInt(m[$] + m[$ + 1], 16));
    } else
      for (var $ = 0; $ < m.length; $++) {
        var E = m.charCodeAt($), O = E >> 8, T = E & 255;
        O ? S.push(O, T) : S.push(T);
      }
    return S;
  }
  o.toArray = u;
  function c(m) {
    return m.length === 1 ? "0" + m : m;
  }
  o.zero2 = c;
  function d(m) {
    for (var v = "", S = 0; S < m.length; S++)
      v += c(m[S].toString(16));
    return v;
  }
  o.toHex = d, o.encode = function(v, S) {
    return S === "hex" ? d(v) : v;
  };
}), utils_1$1$1 = createCommonjsModule(function(e, n) {
  var o = n;
  o.assert = minimalisticAssert, o.toArray = utils_1$i.toArray, o.zero2 = utils_1$i.zero2, o.toHex = utils_1$i.toHex, o.encode = utils_1$i.encode;
  function u(S, $, E) {
    var O = new Array(Math.max(S.bitLength(), E) + 1);
    O.fill(0);
    for (var T = 1 << $ + 1, y = S.clone(), V = 0; V < O.length; V++) {
      var M, G = y.andln(T - 1);
      y.isOdd() ? (G > (T >> 1) - 1 ? M = (T >> 1) - G : M = G, y.isubn(M)) : M = 0, O[V] = M, y.iushrn(1);
    }
    return O;
  }
  o.getNAF = u;
  function c(S, $) {
    var E = [
      [],
      []
    ];
    S = S.clone(), $ = $.clone();
    for (var O = 0, T = 0, y; S.cmpn(-O) > 0 || $.cmpn(-T) > 0; ) {
      var V = S.andln(3) + O & 3, M = $.andln(3) + T & 3;
      V === 3 && (V = -1), M === 3 && (M = -1);
      var G;
      V & 1 ? (y = S.andln(7) + O & 7, (y === 3 || y === 5) && M === 2 ? G = -V : G = V) : G = 0, E[0].push(G);
      var k;
      M & 1 ? (y = $.andln(7) + T & 7, (y === 3 || y === 5) && V === 2 ? k = -M : k = M) : k = 0, E[1].push(k), 2 * O === G + 1 && (O = 1 - O), 2 * T === k + 1 && (T = 1 - T), S.iushrn(1), $.iushrn(1);
    }
    return E;
  }
  o.getJSF = c;
  function d(S, $, E) {
    var O = "_" + $;
    S.prototype[$] = function() {
      return this[O] !== void 0 ? this[O] : this[O] = E.call(this);
    };
  }
  o.cachedProperty = d;
  function m(S) {
    return typeof S == "string" ? o.toArray(S, "hex") : S;
  }
  o.parseBytes = m;
  function v(S) {
    return new BN$7(S, "hex", "le");
  }
  o.intFromLE = v;
}), getNAF = utils_1$1$1.getNAF, getJSF = utils_1$1$1.getJSF, assert$1$1 = utils_1$1$1.assert;
function BaseCurve(e, n) {
  this.type = e, this.p = new BN$7(n.p, 16), this.red = n.prime ? BN$7.red(n.prime) : BN$7.mont(this.p), this.zero = new BN$7(0).toRed(this.red), this.one = new BN$7(1).toRed(this.red), this.two = new BN$7(2).toRed(this.red), this.n = n.n && new BN$7(n.n, 16), this.g = n.g && this.pointFromJSON(n.g, n.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var o = this.n && this.p.div(this.n);
  !o || o.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base = BaseCurve;
BaseCurve.prototype.point = function e() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function e() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function e(n, o) {
  assert$1$1(n.precomputed);
  var u = n._getDoubles(), c = getNAF(o, 1, this._bitLength), d = (1 << u.step + 1) - (u.step % 2 === 0 ? 2 : 1);
  d /= 3;
  var m = [], v, S;
  for (v = 0; v < c.length; v += u.step) {
    S = 0;
    for (var $ = v + u.step - 1; $ >= v; $--)
      S = (S << 1) + c[$];
    m.push(S);
  }
  for (var E = this.jpoint(null, null, null), O = this.jpoint(null, null, null), T = d; T > 0; T--) {
    for (v = 0; v < m.length; v++)
      S = m[v], S === T ? O = O.mixedAdd(u.points[v]) : S === -T && (O = O.mixedAdd(u.points[v].neg()));
    E = E.add(O);
  }
  return E.toP();
};
BaseCurve.prototype._wnafMul = function e(n, o) {
  var u = 4, c = n._getNAFPoints(u);
  u = c.wnd;
  for (var d = c.points, m = getNAF(o, u, this._bitLength), v = this.jpoint(null, null, null), S = m.length - 1; S >= 0; S--) {
    for (var $ = 0; S >= 0 && m[S] === 0; S--)
      $++;
    if (S >= 0 && $++, v = v.dblp($), S < 0)
      break;
    var E = m[S];
    assert$1$1(E !== 0), n.type === "affine" ? E > 0 ? v = v.mixedAdd(d[E - 1 >> 1]) : v = v.mixedAdd(d[-E - 1 >> 1].neg()) : E > 0 ? v = v.add(d[E - 1 >> 1]) : v = v.add(d[-E - 1 >> 1].neg());
  }
  return n.type === "affine" ? v.toP() : v;
};
BaseCurve.prototype._wnafMulAdd = function e(n, o, u, c, d) {
  var m = this._wnafT1, v = this._wnafT2, S = this._wnafT3, $ = 0, E, O, T;
  for (E = 0; E < c; E++) {
    T = o[E];
    var y = T._getNAFPoints(n);
    m[E] = y.wnd, v[E] = y.points;
  }
  for (E = c - 1; E >= 1; E -= 2) {
    var V = E - 1, M = E;
    if (m[V] !== 1 || m[M] !== 1) {
      S[V] = getNAF(u[V], m[V], this._bitLength), S[M] = getNAF(u[M], m[M], this._bitLength), $ = Math.max(S[V].length, $), $ = Math.max(S[M].length, $);
      continue;
    }
    var G = [
      o[V],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      o[M]
      /* 7 */
    ];
    o[V].y.cmp(o[M].y) === 0 ? (G[1] = o[V].add(o[M]), G[2] = o[V].toJ().mixedAdd(o[M].neg())) : o[V].y.cmp(o[M].y.redNeg()) === 0 ? (G[1] = o[V].toJ().mixedAdd(o[M]), G[2] = o[V].add(o[M].neg())) : (G[1] = o[V].toJ().mixedAdd(o[M]), G[2] = o[V].toJ().mixedAdd(o[M].neg()));
    var k = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], F = getJSF(u[V], u[M]);
    for ($ = Math.max(F[0].length, $), S[V] = new Array($), S[M] = new Array($), O = 0; O < $; O++) {
      var X = F[0][O] | 0, ee = F[1][O] | 0;
      S[V][O] = k[(X + 1) * 3 + (ee + 1)], S[M][O] = 0, v[V] = G;
    }
  }
  var ue = this.jpoint(null, null, null), Q = this._wnafT4;
  for (E = $; E >= 0; E--) {
    for (var Y = 0; E >= 0; ) {
      var pe = !0;
      for (O = 0; O < c; O++)
        Q[O] = S[O][E] | 0, Q[O] !== 0 && (pe = !1);
      if (!pe)
        break;
      Y++, E--;
    }
    if (E >= 0 && Y++, ue = ue.dblp(Y), E < 0)
      break;
    for (O = 0; O < c; O++) {
      var oe = Q[O];
      oe !== 0 && (oe > 0 ? T = v[O][oe - 1 >> 1] : oe < 0 && (T = v[O][-oe - 1 >> 1].neg()), T.type === "affine" ? ue = ue.mixedAdd(T) : ue = ue.add(T));
    }
  }
  for (E = 0; E < c; E++)
    v[E] = null;
  return d ? ue : ue.toP();
};
function BasePoint(e, n) {
  this.curve = e, this.type = n, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function e() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function e() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function e(n, o) {
  n = utils_1$1$1.toArray(n, o);
  var u = this.p.byteLength();
  if ((n[0] === 4 || n[0] === 6 || n[0] === 7) && n.length - 1 === 2 * u) {
    n[0] === 6 ? assert$1$1(n[n.length - 1] % 2 === 0) : n[0] === 7 && assert$1$1(n[n.length - 1] % 2 === 1);
    var c = this.point(
      n.slice(1, 1 + u),
      n.slice(1 + u, 1 + 2 * u)
    );
    return c;
  } else if ((n[0] === 2 || n[0] === 3) && n.length - 1 === u)
    return this.pointFromX(n.slice(1, 1 + u), n[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function e(n) {
  return this.encode(n, !0);
};
BasePoint.prototype._encode = function e(n) {
  var o = this.curve.p.byteLength(), u = this.getX().toArray("be", o);
  return n ? [this.getY().isEven() ? 2 : 3].concat(u) : [4].concat(u, this.getY().toArray("be", o));
};
BasePoint.prototype.encode = function e(n, o) {
  return utils_1$1$1.encode(this._encode(o), n);
};
BasePoint.prototype.precompute = function e(n) {
  if (this.precomputed)
    return this;
  var o = {
    doubles: null,
    naf: null,
    beta: null
  };
  return o.naf = this._getNAFPoints(8), o.doubles = this._getDoubles(4, n), o.beta = this._getBeta(), this.precomputed = o, this;
};
BasePoint.prototype._hasDoubles = function e(n) {
  if (!this.precomputed)
    return !1;
  var o = this.precomputed.doubles;
  return o ? o.points.length >= Math.ceil((n.bitLength() + 1) / o.step) : !1;
};
BasePoint.prototype._getDoubles = function e(n, o) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var u = [this], c = this, d = 0; d < o; d += n) {
    for (var m = 0; m < n; m++)
      c = c.dbl();
    u.push(c);
  }
  return {
    step: n,
    points: u
  };
};
BasePoint.prototype._getNAFPoints = function e(n) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var o = [this], u = (1 << n) - 1, c = u === 1 ? null : this.dbl(), d = 1; d < u; d++)
    o[d] = o[d - 1].add(c);
  return {
    wnd: n,
    points: o
  };
};
BasePoint.prototype._getBeta = function e() {
  return null;
};
BasePoint.prototype.dblp = function e(n) {
  for (var o = this, u = 0; u < n; u++)
    o = o.dbl();
  return o;
};
var inherits_browser = createCommonjsModule(function(e) {
  typeof Object.create == "function" ? e.exports = function(o, u) {
    u && (o.super_ = u, o.prototype = Object.create(u.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : e.exports = function(o, u) {
    if (u) {
      o.super_ = u;
      var c = function() {
      };
      c.prototype = u.prototype, o.prototype = new c(), o.prototype.constructor = o;
    }
  };
}), assert$2$1 = utils_1$1$1.assert;
function ShortCurve(e) {
  base.call(this, "short", e), this.a = new BN$7(e.a, 16).toRed(this.red), this.b = new BN$7(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits_browser(ShortCurve, base);
var short_1 = ShortCurve;
ShortCurve.prototype._getEndomorphism = function e(n) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var o, u;
    if (n.beta)
      o = new BN$7(n.beta, 16).toRed(this.red);
    else {
      var c = this._getEndoRoots(this.p);
      o = c[0].cmp(c[1]) < 0 ? c[0] : c[1], o = o.toRed(this.red);
    }
    if (n.lambda)
      u = new BN$7(n.lambda, 16);
    else {
      var d = this._getEndoRoots(this.n);
      this.g.mul(d[0]).x.cmp(this.g.x.redMul(o)) === 0 ? u = d[0] : (u = d[1], assert$2$1(this.g.mul(u).x.cmp(this.g.x.redMul(o)) === 0));
    }
    var m;
    return n.basis ? m = n.basis.map(function(v) {
      return {
        a: new BN$7(v.a, 16),
        b: new BN$7(v.b, 16)
      };
    }) : m = this._getEndoBasis(u), {
      beta: o,
      lambda: u,
      basis: m
    };
  }
};
ShortCurve.prototype._getEndoRoots = function e(n) {
  var o = n === this.p ? this.red : BN$7.mont(n), u = new BN$7(2).toRed(o).redInvm(), c = u.redNeg(), d = new BN$7(3).toRed(o).redNeg().redSqrt().redMul(u), m = c.redAdd(d).fromRed(), v = c.redSub(d).fromRed();
  return [m, v];
};
ShortCurve.prototype._getEndoBasis = function e(n) {
  for (var o = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), u = n, c = this.n.clone(), d = new BN$7(1), m = new BN$7(0), v = new BN$7(0), S = new BN$7(1), $, E, O, T, y, V, M, G = 0, k, F; u.cmpn(0) !== 0; ) {
    var X = c.div(u);
    k = c.sub(X.mul(u)), F = v.sub(X.mul(d));
    var ee = S.sub(X.mul(m));
    if (!O && k.cmp(o) < 0)
      $ = M.neg(), E = d, O = k.neg(), T = F;
    else if (O && ++G === 2)
      break;
    M = k, c = u, u = k, v = d, d = F, S = m, m = ee;
  }
  y = k.neg(), V = F;
  var ue = O.sqr().add(T.sqr()), Q = y.sqr().add(V.sqr());
  return Q.cmp(ue) >= 0 && (y = $, V = E), O.negative && (O = O.neg(), T = T.neg()), y.negative && (y = y.neg(), V = V.neg()), [
    { a: O, b: T },
    { a: y, b: V }
  ];
};
ShortCurve.prototype._endoSplit = function e(n) {
  var o = this.endo.basis, u = o[0], c = o[1], d = c.b.mul(n).divRound(this.n), m = u.b.neg().mul(n).divRound(this.n), v = d.mul(u.a), S = m.mul(c.a), $ = d.mul(u.b), E = m.mul(c.b), O = n.sub(v).sub(S), T = $.add(E).neg();
  return { k1: O, k2: T };
};
ShortCurve.prototype.pointFromX = function e(n, o) {
  n = new BN$7(n, 16), n.red || (n = n.toRed(this.red));
  var u = n.redSqr().redMul(n).redIAdd(n.redMul(this.a)).redIAdd(this.b), c = u.redSqrt();
  if (c.redSqr().redSub(u).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var d = c.fromRed().isOdd();
  return (o && !d || !o && d) && (c = c.redNeg()), this.point(n, c);
};
ShortCurve.prototype.validate = function e(n) {
  if (n.inf)
    return !0;
  var o = n.x, u = n.y, c = this.a.redMul(o), d = o.redSqr().redMul(o).redIAdd(c).redIAdd(this.b);
  return u.redSqr().redISub(d).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function e(n, o, u) {
  for (var c = this._endoWnafT1, d = this._endoWnafT2, m = 0; m < n.length; m++) {
    var v = this._endoSplit(o[m]), S = n[m], $ = S._getBeta();
    v.k1.negative && (v.k1.ineg(), S = S.neg(!0)), v.k2.negative && (v.k2.ineg(), $ = $.neg(!0)), c[m * 2] = S, c[m * 2 + 1] = $, d[m * 2] = v.k1, d[m * 2 + 1] = v.k2;
  }
  for (var E = this._wnafMulAdd(1, c, d, m * 2, u), O = 0; O < m * 2; O++)
    c[O] = null, d[O] = null;
  return E;
};
function Point(e, n, o, u) {
  base.BasePoint.call(this, e, "affine"), n === null && o === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$7(n, 16), this.y = new BN$7(o, 16), u && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits_browser(Point, base.BasePoint);
ShortCurve.prototype.point = function e(n, o, u) {
  return new Point(this, n, o, u);
};
ShortCurve.prototype.pointFromJSON = function e(n, o) {
  return Point.fromJSON(this, n, o);
};
Point.prototype._getBeta = function e() {
  if (this.curve.endo) {
    var n = this.precomputed;
    if (n && n.beta)
      return n.beta;
    var o = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (n) {
      var u = this.curve, c = function(d) {
        return u.point(d.x.redMul(u.endo.beta), d.y);
      };
      n.beta = o, o.precomputed = {
        beta: null,
        naf: n.naf && {
          wnd: n.naf.wnd,
          points: n.naf.points.map(c)
        },
        doubles: n.doubles && {
          step: n.doubles.step,
          points: n.doubles.points.map(c)
        }
      };
    }
    return o;
  }
};
Point.prototype.toJSON = function e() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point.fromJSON = function e(n, o, u) {
  typeof o == "string" && (o = JSON.parse(o));
  var c = n.point(o[0], o[1], u);
  if (!o[2])
    return c;
  function d(v) {
    return n.point(v[0], v[1], u);
  }
  var m = o[2];
  return c.precomputed = {
    beta: null,
    doubles: m.doubles && {
      step: m.doubles.step,
      points: [c].concat(m.doubles.points.map(d))
    },
    naf: m.naf && {
      wnd: m.naf.wnd,
      points: [c].concat(m.naf.points.map(d))
    }
  }, c;
};
Point.prototype.inspect = function e() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function e() {
  return this.inf;
};
Point.prototype.add = function e(n) {
  if (this.inf)
    return n;
  if (n.inf)
    return this;
  if (this.eq(n))
    return this.dbl();
  if (this.neg().eq(n))
    return this.curve.point(null, null);
  if (this.x.cmp(n.x) === 0)
    return this.curve.point(null, null);
  var o = this.y.redSub(n.y);
  o.cmpn(0) !== 0 && (o = o.redMul(this.x.redSub(n.x).redInvm()));
  var u = o.redSqr().redISub(this.x).redISub(n.x), c = o.redMul(this.x.redSub(u)).redISub(this.y);
  return this.curve.point(u, c);
};
Point.prototype.dbl = function e() {
  if (this.inf)
    return this;
  var n = this.y.redAdd(this.y);
  if (n.cmpn(0) === 0)
    return this.curve.point(null, null);
  var o = this.curve.a, u = this.x.redSqr(), c = n.redInvm(), d = u.redAdd(u).redIAdd(u).redIAdd(o).redMul(c), m = d.redSqr().redISub(this.x.redAdd(this.x)), v = d.redMul(this.x.redSub(m)).redISub(this.y);
  return this.curve.point(m, v);
};
Point.prototype.getX = function e() {
  return this.x.fromRed();
};
Point.prototype.getY = function e() {
  return this.y.fromRed();
};
Point.prototype.mul = function e(n) {
  return n = new BN$7(n, 16), this.isInfinity() ? this : this._hasDoubles(n) ? this.curve._fixedNafMul(this, n) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [n]) : this.curve._wnafMul(this, n);
};
Point.prototype.mulAdd = function e(n, o, u) {
  var c = [this, o], d = [n, u];
  return this.curve.endo ? this.curve._endoWnafMulAdd(c, d) : this.curve._wnafMulAdd(1, c, d, 2);
};
Point.prototype.jmulAdd = function e(n, o, u) {
  var c = [this, o], d = [n, u];
  return this.curve.endo ? this.curve._endoWnafMulAdd(c, d, !0) : this.curve._wnafMulAdd(1, c, d, 2, !0);
};
Point.prototype.eq = function e(n) {
  return this === n || this.inf === n.inf && (this.inf || this.x.cmp(n.x) === 0 && this.y.cmp(n.y) === 0);
};
Point.prototype.neg = function e(n) {
  if (this.inf)
    return this;
  var o = this.curve.point(this.x, this.y.redNeg());
  if (n && this.precomputed) {
    var u = this.precomputed, c = function(d) {
      return d.neg();
    };
    o.precomputed = {
      naf: u.naf && {
        wnd: u.naf.wnd,
        points: u.naf.points.map(c)
      },
      doubles: u.doubles && {
        step: u.doubles.step,
        points: u.doubles.points.map(c)
      }
    };
  }
  return o;
};
Point.prototype.toJ = function e() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var n = this.curve.jpoint(this.x, this.y, this.curve.one);
  return n;
};
function JPoint(e, n, o, u) {
  base.BasePoint.call(this, e, "jacobian"), n === null && o === null && u === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$7(0)) : (this.x = new BN$7(n, 16), this.y = new BN$7(o, 16), this.z = new BN$7(u, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits_browser(JPoint, base.BasePoint);
ShortCurve.prototype.jpoint = function e(n, o, u) {
  return new JPoint(this, n, o, u);
};
JPoint.prototype.toP = function e() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var n = this.z.redInvm(), o = n.redSqr(), u = this.x.redMul(o), c = this.y.redMul(o).redMul(n);
  return this.curve.point(u, c);
};
JPoint.prototype.neg = function e() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function e(n) {
  if (this.isInfinity())
    return n;
  if (n.isInfinity())
    return this;
  var o = n.z.redSqr(), u = this.z.redSqr(), c = this.x.redMul(o), d = n.x.redMul(u), m = this.y.redMul(o.redMul(n.z)), v = n.y.redMul(u.redMul(this.z)), S = c.redSub(d), $ = m.redSub(v);
  if (S.cmpn(0) === 0)
    return $.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var E = S.redSqr(), O = E.redMul(S), T = c.redMul(E), y = $.redSqr().redIAdd(O).redISub(T).redISub(T), V = $.redMul(T.redISub(y)).redISub(m.redMul(O)), M = this.z.redMul(n.z).redMul(S);
  return this.curve.jpoint(y, V, M);
};
JPoint.prototype.mixedAdd = function e(n) {
  if (this.isInfinity())
    return n.toJ();
  if (n.isInfinity())
    return this;
  var o = this.z.redSqr(), u = this.x, c = n.x.redMul(o), d = this.y, m = n.y.redMul(o).redMul(this.z), v = u.redSub(c), S = d.redSub(m);
  if (v.cmpn(0) === 0)
    return S.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var $ = v.redSqr(), E = $.redMul(v), O = u.redMul($), T = S.redSqr().redIAdd(E).redISub(O).redISub(O), y = S.redMul(O.redISub(T)).redISub(d.redMul(E)), V = this.z.redMul(v);
  return this.curve.jpoint(T, y, V);
};
JPoint.prototype.dblp = function e(n) {
  if (n === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!n)
    return this.dbl();
  var o;
  if (this.curve.zeroA || this.curve.threeA) {
    var u = this;
    for (o = 0; o < n; o++)
      u = u.dbl();
    return u;
  }
  var c = this.curve.a, d = this.curve.tinv, m = this.x, v = this.y, S = this.z, $ = S.redSqr().redSqr(), E = v.redAdd(v);
  for (o = 0; o < n; o++) {
    var O = m.redSqr(), T = E.redSqr(), y = T.redSqr(), V = O.redAdd(O).redIAdd(O).redIAdd(c.redMul($)), M = m.redMul(T), G = V.redSqr().redISub(M.redAdd(M)), k = M.redISub(G), F = V.redMul(k);
    F = F.redIAdd(F).redISub(y);
    var X = E.redMul(S);
    o + 1 < n && ($ = $.redMul(y)), m = G, S = X, E = F;
  }
  return this.curve.jpoint(m, E.redMul(d), S);
};
JPoint.prototype.dbl = function e() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function e() {
  var n, o, u;
  if (this.zOne) {
    var c = this.x.redSqr(), d = this.y.redSqr(), m = d.redSqr(), v = this.x.redAdd(d).redSqr().redISub(c).redISub(m);
    v = v.redIAdd(v);
    var S = c.redAdd(c).redIAdd(c), $ = S.redSqr().redISub(v).redISub(v), E = m.redIAdd(m);
    E = E.redIAdd(E), E = E.redIAdd(E), n = $, o = S.redMul(v.redISub($)).redISub(E), u = this.y.redAdd(this.y);
  } else {
    var O = this.x.redSqr(), T = this.y.redSqr(), y = T.redSqr(), V = this.x.redAdd(T).redSqr().redISub(O).redISub(y);
    V = V.redIAdd(V);
    var M = O.redAdd(O).redIAdd(O), G = M.redSqr(), k = y.redIAdd(y);
    k = k.redIAdd(k), k = k.redIAdd(k), n = G.redISub(V).redISub(V), o = M.redMul(V.redISub(n)).redISub(k), u = this.y.redMul(this.z), u = u.redIAdd(u);
  }
  return this.curve.jpoint(n, o, u);
};
JPoint.prototype._threeDbl = function e() {
  var n, o, u;
  if (this.zOne) {
    var c = this.x.redSqr(), d = this.y.redSqr(), m = d.redSqr(), v = this.x.redAdd(d).redSqr().redISub(c).redISub(m);
    v = v.redIAdd(v);
    var S = c.redAdd(c).redIAdd(c).redIAdd(this.curve.a), $ = S.redSqr().redISub(v).redISub(v);
    n = $;
    var E = m.redIAdd(m);
    E = E.redIAdd(E), E = E.redIAdd(E), o = S.redMul(v.redISub($)).redISub(E), u = this.y.redAdd(this.y);
  } else {
    var O = this.z.redSqr(), T = this.y.redSqr(), y = this.x.redMul(T), V = this.x.redSub(O).redMul(this.x.redAdd(O));
    V = V.redAdd(V).redIAdd(V);
    var M = y.redIAdd(y);
    M = M.redIAdd(M);
    var G = M.redAdd(M);
    n = V.redSqr().redISub(G), u = this.y.redAdd(this.z).redSqr().redISub(T).redISub(O);
    var k = T.redSqr();
    k = k.redIAdd(k), k = k.redIAdd(k), k = k.redIAdd(k), o = V.redMul(M.redISub(n)).redISub(k);
  }
  return this.curve.jpoint(n, o, u);
};
JPoint.prototype._dbl = function e() {
  var n = this.curve.a, o = this.x, u = this.y, c = this.z, d = c.redSqr().redSqr(), m = o.redSqr(), v = u.redSqr(), S = m.redAdd(m).redIAdd(m).redIAdd(n.redMul(d)), $ = o.redAdd(o);
  $ = $.redIAdd($);
  var E = $.redMul(v), O = S.redSqr().redISub(E.redAdd(E)), T = E.redISub(O), y = v.redSqr();
  y = y.redIAdd(y), y = y.redIAdd(y), y = y.redIAdd(y);
  var V = S.redMul(T).redISub(y), M = u.redAdd(u).redMul(c);
  return this.curve.jpoint(O, V, M);
};
JPoint.prototype.trpl = function e() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var n = this.x.redSqr(), o = this.y.redSqr(), u = this.z.redSqr(), c = o.redSqr(), d = n.redAdd(n).redIAdd(n), m = d.redSqr(), v = this.x.redAdd(o).redSqr().redISub(n).redISub(c);
  v = v.redIAdd(v), v = v.redAdd(v).redIAdd(v), v = v.redISub(m);
  var S = v.redSqr(), $ = c.redIAdd(c);
  $ = $.redIAdd($), $ = $.redIAdd($), $ = $.redIAdd($);
  var E = d.redIAdd(v).redSqr().redISub(m).redISub(S).redISub($), O = o.redMul(E);
  O = O.redIAdd(O), O = O.redIAdd(O);
  var T = this.x.redMul(S).redISub(O);
  T = T.redIAdd(T), T = T.redIAdd(T);
  var y = this.y.redMul(E.redMul($.redISub(E)).redISub(v.redMul(S)));
  y = y.redIAdd(y), y = y.redIAdd(y), y = y.redIAdd(y);
  var V = this.z.redAdd(v).redSqr().redISub(u).redISub(S);
  return this.curve.jpoint(T, y, V);
};
JPoint.prototype.mul = function e(n, o) {
  return n = new BN$7(n, o), this.curve._wnafMul(this, n);
};
JPoint.prototype.eq = function e(n) {
  if (n.type === "affine")
    return this.eq(n.toJ());
  if (this === n)
    return !0;
  var o = this.z.redSqr(), u = n.z.redSqr();
  if (this.x.redMul(u).redISub(n.x.redMul(o)).cmpn(0) !== 0)
    return !1;
  var c = o.redMul(this.z), d = u.redMul(n.z);
  return this.y.redMul(d).redISub(n.y.redMul(c)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function e(n) {
  var o = this.z.redSqr(), u = n.toRed(this.curve.red).redMul(o);
  if (this.x.cmp(u) === 0)
    return !0;
  for (var c = n.clone(), d = this.curve.redN.redMul(o); ; ) {
    if (c.iadd(this.curve.n), c.cmp(this.curve.p) >= 0)
      return !1;
    if (u.redIAdd(d), this.x.cmp(u) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function e() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function e() {
  return this.z.cmpn(0) === 0;
};
var curve_1 = createCommonjsModule(function(e, n) {
  var o = n;
  o.base = base, o.short = short_1, o.mont = /*RicMoo:ethers:require(./mont)*/
  null, o.edwards = /*RicMoo:ethers:require(./edwards)*/
  null;
}), curves_1 = createCommonjsModule(function(e, n) {
  var o = n, u = utils_1$1$1.assert;
  function c(v) {
    v.type === "short" ? this.curve = new curve_1.short(v) : v.type === "edwards" ? this.curve = new curve_1.edwards(v) : this.curve = new curve_1.mont(v), this.g = this.curve.g, this.n = this.curve.n, this.hash = v.hash, u(this.g.validate(), "Invalid curve"), u(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  o.PresetCurve = c;
  function d(v, S) {
    Object.defineProperty(o, v, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var $ = new c(S);
        return Object.defineProperty(o, v, {
          configurable: !0,
          enumerable: !0,
          value: $
        }), $;
      }
    });
  }
  d("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash$3.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), d("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash$3.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), d("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash$3.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), d("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash$3.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), d("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash$3.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), d("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash$3.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), d("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash$3.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var m;
  try {
    m = /*RicMoo:ethers:require(./precomputed/secp256k1)*/
    null.crash();
  } catch {
    m = void 0;
  }
  d("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash$3.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      m
    ]
  });
});
function HmacDRBG(e) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(e);
  this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var n = utils_1$i.toArray(e.entropy, e.entropyEnc || "hex"), o = utils_1$i.toArray(e.nonce, e.nonceEnc || "hex"), u = utils_1$i.toArray(e.pers, e.persEnc || "hex");
  minimalisticAssert(
    n.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(n, o, u);
}
var hmacDrbg = HmacDRBG;
HmacDRBG.prototype._init = function e(n, o, u) {
  var c = n.concat(o).concat(u);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var d = 0; d < this.V.length; d++)
    this.K[d] = 0, this.V[d] = 1;
  this._update(c), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG.prototype._hmac = function e() {
  return new hash$3.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function e(n) {
  var o = this._hmac().update(this.V).update([0]);
  n && (o = o.update(n)), this.K = o.digest(), this.V = this._hmac().update(this.V).digest(), n && (this.K = this._hmac().update(this.V).update([1]).update(n).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG.prototype.reseed = function e(n, o, u, c) {
  typeof o != "string" && (c = u, u = o, o = null), n = utils_1$i.toArray(n, o), u = utils_1$i.toArray(u, c), minimalisticAssert(
    n.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(n.concat(u || [])), this._reseed = 1;
};
HmacDRBG.prototype.generate = function e(n, o, u, c) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof o != "string" && (c = u, u = o, o = null), u && (u = utils_1$i.toArray(u, c || "hex"), this._update(u));
  for (var d = []; d.length < n; )
    this.V = this._hmac().update(this.V).digest(), d = d.concat(this.V);
  var m = d.slice(0, n);
  return this._update(u), this._reseed++, utils_1$i.encode(m, o);
};
var assert$3 = utils_1$1$1.assert;
function KeyPair(e, n) {
  this.ec = e, this.priv = null, this.pub = null, n.priv && this._importPrivate(n.priv, n.privEnc), n.pub && this._importPublic(n.pub, n.pubEnc);
}
var key = KeyPair;
KeyPair.fromPublic = function e(n, o, u) {
  return o instanceof KeyPair ? o : new KeyPair(n, {
    pub: o,
    pubEnc: u
  });
};
KeyPair.fromPrivate = function e(n, o, u) {
  return o instanceof KeyPair ? o : new KeyPair(n, {
    priv: o,
    privEnc: u
  });
};
KeyPair.prototype.validate = function e() {
  var n = this.getPublic();
  return n.isInfinity() ? { result: !1, reason: "Invalid public key" } : n.validate() ? n.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair.prototype.getPublic = function e(n, o) {
  return typeof n == "string" && (o = n, n = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), o ? this.pub.encode(o, n) : this.pub;
};
KeyPair.prototype.getPrivate = function e(n) {
  return n === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair.prototype._importPrivate = function e(n, o) {
  this.priv = new BN$7(n, o || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function e(n, o) {
  if (n.x || n.y) {
    this.ec.curve.type === "mont" ? assert$3(n.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$3(n.x && n.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(n.x, n.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(n, o);
};
KeyPair.prototype.derive = function e(n) {
  return n.validate() || assert$3(n.validate(), "public point not validated"), n.mul(this.priv).getX();
};
KeyPair.prototype.sign = function e(n, o, u) {
  return this.ec.sign(n, this, o, u);
};
KeyPair.prototype.verify = function e(n, o) {
  return this.ec.verify(n, o, this);
};
KeyPair.prototype.inspect = function e() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var assert$4 = utils_1$1$1.assert;
function Signature(e, n) {
  if (e instanceof Signature)
    return e;
  this._importDER(e, n) || (assert$4(e.r && e.s, "Signature without r or s"), this.r = new BN$7(e.r, 16), this.s = new BN$7(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var signature$1 = Signature;
function Position() {
  this.place = 0;
}
function getLength(e, n) {
  var o = e[n.place++];
  if (!(o & 128))
    return o;
  var u = o & 15;
  if (u === 0 || u > 4)
    return !1;
  for (var c = 0, d = 0, m = n.place; d < u; d++, m++)
    c <<= 8, c |= e[m], c >>>= 0;
  return c <= 127 ? !1 : (n.place = m, c);
}
function rmPadding(e) {
  for (var n = 0, o = e.length - 1; !e[n] && !(e[n + 1] & 128) && n < o; )
    n++;
  return n === 0 ? e : e.slice(n);
}
Signature.prototype._importDER = function e(n, o) {
  n = utils_1$1$1.toArray(n, o);
  var u = new Position();
  if (n[u.place++] !== 48)
    return !1;
  var c = getLength(n, u);
  if (c === !1 || c + u.place !== n.length || n[u.place++] !== 2)
    return !1;
  var d = getLength(n, u);
  if (d === !1)
    return !1;
  var m = n.slice(u.place, d + u.place);
  if (u.place += d, n[u.place++] !== 2)
    return !1;
  var v = getLength(n, u);
  if (v === !1 || n.length !== v + u.place)
    return !1;
  var S = n.slice(u.place, v + u.place);
  if (m[0] === 0)
    if (m[1] & 128)
      m = m.slice(1);
    else
      return !1;
  if (S[0] === 0)
    if (S[1] & 128)
      S = S.slice(1);
    else
      return !1;
  return this.r = new BN$7(m), this.s = new BN$7(S), this.recoveryParam = null, !0;
};
function constructLength(e, n) {
  if (n < 128) {
    e.push(n);
    return;
  }
  var o = 1 + (Math.log(n) / Math.LN2 >>> 3);
  for (e.push(o | 128); --o; )
    e.push(n >>> (o << 3) & 255);
  e.push(n);
}
Signature.prototype.toDER = function e(n) {
  var o = this.r.toArray(), u = this.s.toArray();
  for (o[0] & 128 && (o = [0].concat(o)), u[0] & 128 && (u = [0].concat(u)), o = rmPadding(o), u = rmPadding(u); !u[0] && !(u[1] & 128); )
    u = u.slice(1);
  var c = [2];
  constructLength(c, o.length), c = c.concat(o), c.push(2), constructLength(c, u.length);
  var d = c.concat(u), m = [48];
  return constructLength(m, d.length), m = m.concat(d), utils_1$1$1.encode(m, n);
};
var rand = (
  /*RicMoo:ethers:require(brorand)*/
  function() {
    throw new Error("unsupported");
  }
), assert$5 = utils_1$1$1.assert;
function EC(e) {
  if (!(this instanceof EC))
    return new EC(e);
  typeof e == "string" && (assert$5(
    Object.prototype.hasOwnProperty.call(curves_1, e),
    "Unknown curve " + e
  ), e = curves_1[e]), e instanceof curves_1.PresetCurve && (e = { curve: e }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
}
var ec = EC;
EC.prototype.keyPair = function e(n) {
  return new key(this, n);
};
EC.prototype.keyFromPrivate = function e(n, o) {
  return key.fromPrivate(this, n, o);
};
EC.prototype.keyFromPublic = function e(n, o) {
  return key.fromPublic(this, n, o);
};
EC.prototype.genKeyPair = function e(n) {
  n || (n = {});
  for (var o = new hmacDrbg({
    hash: this.hash,
    pers: n.pers,
    persEnc: n.persEnc || "utf8",
    entropy: n.entropy || rand(this.hash.hmacStrength),
    entropyEnc: n.entropy && n.entropyEnc || "utf8",
    nonce: this.n.toArray()
  }), u = this.n.byteLength(), c = this.n.sub(new BN$7(2)); ; ) {
    var d = new BN$7(o.generate(u));
    if (!(d.cmp(c) > 0))
      return d.iaddn(1), this.keyFromPrivate(d);
  }
};
EC.prototype._truncateToN = function e(n, o) {
  var u = n.byteLength() * 8 - this.n.bitLength();
  return u > 0 && (n = n.ushrn(u)), !o && n.cmp(this.n) >= 0 ? n.sub(this.n) : n;
};
EC.prototype.sign = function e(n, o, u, c) {
  typeof u == "object" && (c = u, u = null), c || (c = {}), o = this.keyFromPrivate(o, u), n = this._truncateToN(new BN$7(n, 16));
  for (var d = this.n.byteLength(), m = o.getPrivate().toArray("be", d), v = n.toArray("be", d), S = new hmacDrbg({
    hash: this.hash,
    entropy: m,
    nonce: v,
    pers: c.pers,
    persEnc: c.persEnc || "utf8"
  }), $ = this.n.sub(new BN$7(1)), E = 0; ; E++) {
    var O = c.k ? c.k(E) : new BN$7(S.generate(this.n.byteLength()));
    if (O = this._truncateToN(O, !0), !(O.cmpn(1) <= 0 || O.cmp($) >= 0)) {
      var T = this.g.mul(O);
      if (!T.isInfinity()) {
        var y = T.getX(), V = y.umod(this.n);
        if (V.cmpn(0) !== 0) {
          var M = O.invm(this.n).mul(V.mul(o.getPrivate()).iadd(n));
          if (M = M.umod(this.n), M.cmpn(0) !== 0) {
            var G = (T.getY().isOdd() ? 1 : 0) | (y.cmp(V) !== 0 ? 2 : 0);
            return c.canonical && M.cmp(this.nh) > 0 && (M = this.n.sub(M), G ^= 1), new signature$1({ r: V, s: M, recoveryParam: G });
          }
        }
      }
    }
  }
};
EC.prototype.verify = function e(n, o, u, c) {
  n = this._truncateToN(new BN$7(n, 16)), u = this.keyFromPublic(u, c), o = new signature$1(o, "hex");
  var d = o.r, m = o.s;
  if (d.cmpn(1) < 0 || d.cmp(this.n) >= 0 || m.cmpn(1) < 0 || m.cmp(this.n) >= 0)
    return !1;
  var v = m.invm(this.n), S = v.mul(n).umod(this.n), $ = v.mul(d).umod(this.n), E;
  return this.curve._maxwellTrick ? (E = this.g.jmulAdd(S, u.getPublic(), $), E.isInfinity() ? !1 : E.eqXToP(d)) : (E = this.g.mulAdd(S, u.getPublic(), $), E.isInfinity() ? !1 : E.getX().umod(this.n).cmp(d) === 0);
};
EC.prototype.recoverPubKey = function(e, n, o, u) {
  assert$5((3 & o) === o, "The recovery param is more than two bits"), n = new signature$1(n, u);
  var c = this.n, d = new BN$7(e), m = n.r, v = n.s, S = o & 1, $ = o >> 1;
  if (m.cmp(this.curve.p.umod(this.curve.n)) >= 0 && $)
    throw new Error("Unable to find sencond key candinate");
  $ ? m = this.curve.pointFromX(m.add(this.curve.n), S) : m = this.curve.pointFromX(m, S);
  var E = n.r.invm(c), O = c.sub(d).mul(E).umod(c), T = v.mul(E).umod(c);
  return this.g.mulAdd(O, m, T);
};
EC.prototype.getKeyRecoveryParam = function(e, n, o, u) {
  if (n = new signature$1(n, u), n.recoveryParam !== null)
    return n.recoveryParam;
  for (var c = 0; c < 4; c++) {
    var d;
    try {
      d = this.recoverPubKey(e, n, c);
    } catch {
      continue;
    }
    if (d.eq(o))
      return c;
  }
  throw new Error("Unable to find valid recovery factor");
};
var elliptic_1$1 = createCommonjsModule(function(e, n) {
  var o = n;
  o.version = "6.5.4", o.utils = utils_1$1$1, o.rand = /*RicMoo:ethers:require(brorand)*/
  function() {
    throw new Error("unsupported");
  }, o.curve = curve_1, o.curves = curves_1, o.ec = ec, o.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/
  null;
}), EC$1 = elliptic_1$1.ec;
const version$1 = "signing-key/5.7.0", logger = new Logger(version$1);
let _curve = null;
function getCurve() {
  return _curve || (_curve = new EC$1("secp256k1")), _curve;
}
class SigningKey {
  constructor(n) {
    defineReadOnly(this, "curve", "secp256k1"), defineReadOnly(this, "privateKey", hexlify(n)), hexDataLength(this.privateKey) !== 32 && logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
    const o = getCurve().keyFromPrivate(arrayify(this.privateKey));
    defineReadOnly(this, "publicKey", "0x" + o.getPublic(!1, "hex")), defineReadOnly(this, "compressedPublicKey", "0x" + o.getPublic(!0, "hex")), defineReadOnly(this, "_isSigningKey", !0);
  }
  _addPoint(n) {
    const o = getCurve().keyFromPublic(arrayify(this.publicKey)), u = getCurve().keyFromPublic(arrayify(n));
    return "0x" + o.pub.add(u.pub).encodeCompressed("hex");
  }
  signDigest(n) {
    const o = getCurve().keyFromPrivate(arrayify(this.privateKey)), u = arrayify(n);
    u.length !== 32 && logger.throwArgumentError("bad digest length", "digest", n);
    const c = o.sign(u, { canonical: !0 });
    return splitSignature({
      recoveryParam: c.recoveryParam,
      r: hexZeroPad("0x" + c.r.toString(16), 32),
      s: hexZeroPad("0x" + c.s.toString(16), 32)
    });
  }
  computeSharedSecret(n) {
    const o = getCurve().keyFromPrivate(arrayify(this.privateKey)), u = getCurve().keyFromPublic(arrayify(computePublicKey(n)));
    return hexZeroPad("0x" + o.derive(u.getPublic()).toString(16), 32);
  }
  static isSigningKey(n) {
    return !!(n && n._isSigningKey);
  }
}
function recoverPublicKey(e, n) {
  const o = splitSignature(n), u = { r: arrayify(o.r), s: arrayify(o.s) };
  return "0x" + getCurve().recoverPubKey(arrayify(e), u, o.recoveryParam).encode("hex", !1);
}
function computePublicKey(e, n) {
  const o = arrayify(e);
  if (o.length === 32) {
    const u = new SigningKey(o);
    return n ? "0x" + getCurve().keyFromPrivate(o).getPublic(!0, "hex") : u.publicKey;
  } else {
    if (o.length === 33)
      return n ? hexlify(o) : "0x" + getCurve().keyFromPublic(o).getPublic(!1, "hex");
    if (o.length === 65)
      return n ? "0x" + getCurve().keyFromPublic(o).getPublic(!0, "hex") : hexlify(o);
  }
  return logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
class MetamaskWallet {
  constructor(n, o) {
    fi(this, "name");
    fi(this, "chainId");
    fi(this, "registry");
    fi(this, "prefix");
    fi(this, "aminoTypes", new build$S.AminoTypes(build$S.createDefaultAminoConverters()));
    this.chainId = n.chainId || "cosmoshub", this.registry = o, this.prefix = n.prefix || "evmos";
  }
  async getAccounts() {
    var S;
    if (!window.ethereum || !window.ethereum.request)
      throw new Error("Please install Metamask extension");
    const n = await window.ethereum.request({
      method: "eth_requestAccounts"
    }), o = "Verify Public Key", u = await ((S = window == null ? void 0 : window.ethereum) == null ? void 0 : S.request({
      method: "personal_sign",
      params: [o, n[0], ""]
    })), c = recoverPublicKey(
      hashMessage(o),
      u
    ), d = computePublicKey(c, !0), m = build$V.toBase64(build$V.fromHex(d.replace("0x", ""))), v = n.map(($) => ({
      address: ethToEthermint($, this.prefix),
      algo: "secp256k1",
      pubkey: m
    }));
    return localStorage.setItem("metamask-connected", JSON.stringify(v)), v;
  }
  async getConnectedAccounts() {
    const n = localStorage.getItem("metamask-connected");
    return n ? JSON.parse(n) : this.getAccounts();
  }
  async supportCoinType(n) {
    return !0;
  }
  async sign(n) {
    const { signerAddress: o, messages: u, fee: c, signerData: d } = n, m = ethermintToEth(o), v = {
      chainId: extractChainId(d.chainId),
      cosmosChainId: d.chainId
    }, $ = (await this.getConnectedAccounts()).find((Y) => ethermintToEth(Y.address) === m);
    if (!$)
      throw new Error("Account not found");
    console.log("account:", $);
    const E = String($.pubkey);
    console.log("toBase64(pubkeyBytes)", E);
    const O = {
      accountAddress: n.signerAddress,
      sequence: n.signerData.sequence,
      accountNumber: n.signerData.accountNumber,
      pubkey: E
    }, T = dist$1.generateFee(n.fee.amount[0].amount, n.fee.amount[0].denom, n.fee.gas, n.signerAddress), y = n.messages.map((Y) => this.aminoTypes.toAmino(Y)), V = dist$1.generateMessageWithMultipleTransactions(
      O.accountNumber.toString(),
      O.sequence.toString(),
      n.signerData.chainId,
      n.memo,
      T,
      y
    ), M = dist$1.generateTypes(defaultMessageAdapter[n.messages[0].typeUrl].getTypes()), G = dist$1.createEIP712(M, v.chainId, V), k = await window.ethereum.request({
      method: "eth_signTypedData_v4",
      params: [m, JSON.stringify(G)]
    }), F = build$V.fromHex(k.replace("0x", "")), X = this.registry.encode({
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: { messages: u }
    }), ee = Any$1.fromPartial({
      typeUrl: keyType(d.chainId),
      value: PubKey$3.encode({
        key: build$V.fromBase64(E)
      }).finish()
    }), ue = build$Q.makeAuthInfoBytes(
      [{ pubkey: ee, sequence: d.sequence }],
      c.amount,
      Number(c.gas),
      void 0,
      // feeGranter
      void 0
      // feePayer
    );
    return tx$p.TxRaw.fromPartial({
      bodyBytes: X,
      authInfoBytes: ue,
      signatures: [F]
    });
  }
}
var dist = {}, snap = {}, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 9007199254740991, POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], SQRT_BASE = 1e7, MAX = 1e9;
function clone(e) {
  var n, o, u, c = F.prototype = { constructor: F, toString: null, valueOf: null }, d = new F(1), m = 20, v = 4, S = -7, $ = 21, E = -1e7, O = 1e7, T = !1, y = 1, V = 0, M = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, G = "0123456789abcdefghijklmnopqrstuvwxyz", k = !0;
  function F(pe, oe) {
    var ne, H, C, w, P, J, se, fe, N = this;
    if (!(N instanceof F))
      return new F(pe, oe);
    if (oe == null) {
      if (pe && pe._isBigNumber === !0) {
        N.s = pe.s, !pe.c || pe.e > O ? N.c = N.e = null : pe.e < E ? N.c = [N.e = 0] : (N.e = pe.e, N.c = pe.c.slice());
        return;
      }
      if ((J = typeof pe == "number") && pe * 0 == 0) {
        if (N.s = 1 / pe < 0 ? (pe = -pe, -1) : 1, pe === ~~pe) {
          for (w = 0, P = pe; P >= 10; P /= 10, w++)
            ;
          w > O ? N.c = N.e = null : (N.e = w, N.c = [pe]);
          return;
        }
        fe = String(pe);
      } else {
        if (!isNumeric.test(fe = String(pe)))
          return u(N, fe, J);
        N.s = fe.charCodeAt(0) == 45 ? (fe = fe.slice(1), -1) : 1;
      }
      (w = fe.indexOf(".")) > -1 && (fe = fe.replace(".", "")), (P = fe.search(/e/i)) > 0 ? (w < 0 && (w = P), w += +fe.slice(P + 1), fe = fe.substring(0, P)) : w < 0 && (w = fe.length);
    } else {
      if (intCheck(oe, 2, G.length, "Base"), oe == 10 && k)
        return N = new F(pe), Q(N, m + N.e + 1, v);
      if (fe = String(pe), J = typeof pe == "number") {
        if (pe * 0 != 0)
          return u(N, fe, J, oe);
        if (N.s = 1 / pe < 0 ? (fe = fe.slice(1), -1) : 1, F.DEBUG && fe.replace(/^0\.0*|\./, "").length > 15)
          throw Error(tooManyDigits + pe);
      } else
        N.s = fe.charCodeAt(0) === 45 ? (fe = fe.slice(1), -1) : 1;
      for (ne = G.slice(0, oe), w = P = 0, se = fe.length; P < se; P++)
        if (ne.indexOf(H = fe.charAt(P)) < 0) {
          if (H == ".") {
            if (P > w) {
              w = se;
              continue;
            }
          } else if (!C && (fe == fe.toUpperCase() && (fe = fe.toLowerCase()) || fe == fe.toLowerCase() && (fe = fe.toUpperCase()))) {
            C = !0, P = -1, w = 0;
            continue;
          }
          return u(N, String(pe), J, oe);
        }
      J = !1, fe = o(fe, oe, 10, N.s), (w = fe.indexOf(".")) > -1 ? fe = fe.replace(".", "") : w = fe.length;
    }
    for (P = 0; fe.charCodeAt(P) === 48; P++)
      ;
    for (se = fe.length; fe.charCodeAt(--se) === 48; )
      ;
    if (fe = fe.slice(P, ++se)) {
      if (se -= P, J && F.DEBUG && se > 15 && (pe > MAX_SAFE_INTEGER || pe !== mathfloor(pe)))
        throw Error(tooManyDigits + N.s * pe);
      if ((w = w - P - 1) > O)
        N.c = N.e = null;
      else if (w < E)
        N.c = [N.e = 0];
      else {
        if (N.e = w, N.c = [], P = (w + 1) % LOG_BASE, w < 0 && (P += LOG_BASE), P < se) {
          for (P && N.c.push(+fe.slice(0, P)), se -= LOG_BASE; P < se; )
            N.c.push(+fe.slice(P, P += LOG_BASE));
          P = LOG_BASE - (fe = fe.slice(P)).length;
        } else
          P -= se;
        for (; P--; fe += "0")
          ;
        N.c.push(+fe);
      }
    } else
      N.c = [N.e = 0];
  }
  F.clone = clone, F.ROUND_UP = 0, F.ROUND_DOWN = 1, F.ROUND_CEIL = 2, F.ROUND_FLOOR = 3, F.ROUND_HALF_UP = 4, F.ROUND_HALF_DOWN = 5, F.ROUND_HALF_EVEN = 6, F.ROUND_HALF_CEIL = 7, F.ROUND_HALF_FLOOR = 8, F.EUCLID = 9, F.config = F.set = function(pe) {
    var oe, ne;
    if (pe != null)
      if (typeof pe == "object") {
        if (pe.hasOwnProperty(oe = "DECIMAL_PLACES") && (ne = pe[oe], intCheck(ne, 0, MAX, oe), m = ne), pe.hasOwnProperty(oe = "ROUNDING_MODE") && (ne = pe[oe], intCheck(ne, 0, 8, oe), v = ne), pe.hasOwnProperty(oe = "EXPONENTIAL_AT") && (ne = pe[oe], ne && ne.pop ? (intCheck(ne[0], -MAX, 0, oe), intCheck(ne[1], 0, MAX, oe), S = ne[0], $ = ne[1]) : (intCheck(ne, -MAX, MAX, oe), S = -($ = ne < 0 ? -ne : ne))), pe.hasOwnProperty(oe = "RANGE"))
          if (ne = pe[oe], ne && ne.pop)
            intCheck(ne[0], -MAX, -1, oe), intCheck(ne[1], 1, MAX, oe), E = ne[0], O = ne[1];
          else if (intCheck(ne, -MAX, MAX, oe), ne)
            E = -(O = ne < 0 ? -ne : ne);
          else
            throw Error(bignumberError + oe + " cannot be zero: " + ne);
        if (pe.hasOwnProperty(oe = "CRYPTO"))
          if (ne = pe[oe], ne === !!ne)
            if (ne)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                T = ne;
              else
                throw T = !ne, Error(bignumberError + "crypto unavailable");
            else
              T = ne;
          else
            throw Error(bignumberError + oe + " not true or false: " + ne);
        if (pe.hasOwnProperty(oe = "MODULO_MODE") && (ne = pe[oe], intCheck(ne, 0, 9, oe), y = ne), pe.hasOwnProperty(oe = "POW_PRECISION") && (ne = pe[oe], intCheck(ne, 0, MAX, oe), V = ne), pe.hasOwnProperty(oe = "FORMAT"))
          if (ne = pe[oe], typeof ne == "object")
            M = ne;
          else
            throw Error(bignumberError + oe + " not an object: " + ne);
        if (pe.hasOwnProperty(oe = "ALPHABET"))
          if (ne = pe[oe], typeof ne == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(ne))
            k = ne.slice(0, 10) == "0123456789", G = ne;
          else
            throw Error(bignumberError + oe + " invalid: " + ne);
      } else
        throw Error(bignumberError + "Object expected: " + pe);
    return {
      DECIMAL_PLACES: m,
      ROUNDING_MODE: v,
      EXPONENTIAL_AT: [S, $],
      RANGE: [E, O],
      CRYPTO: T,
      MODULO_MODE: y,
      POW_PRECISION: V,
      FORMAT: M,
      ALPHABET: G
    };
  }, F.isBigNumber = function(pe) {
    if (!pe || pe._isBigNumber !== !0)
      return !1;
    if (!F.DEBUG)
      return !0;
    var oe, ne, H = pe.c, C = pe.e, w = pe.s;
    e:
      if ({}.toString.call(H) == "[object Array]") {
        if ((w === 1 || w === -1) && C >= -MAX && C <= MAX && C === mathfloor(C)) {
          if (H[0] === 0) {
            if (C === 0 && H.length === 1)
              return !0;
            break e;
          }
          if (oe = (C + 1) % LOG_BASE, oe < 1 && (oe += LOG_BASE), String(H[0]).length == oe) {
            for (oe = 0; oe < H.length; oe++)
              if (ne = H[oe], ne < 0 || ne >= BASE || ne !== mathfloor(ne))
                break e;
            if (ne !== 0)
              return !0;
          }
        }
      } else if (H === null && C === null && (w === null || w === 1 || w === -1))
        return !0;
    throw Error(bignumberError + "Invalid BigNumber: " + pe);
  }, F.maximum = F.max = function() {
    return ee(arguments, -1);
  }, F.minimum = F.min = function() {
    return ee(arguments, 1);
  }, F.random = function() {
    var pe = 9007199254740992, oe = Math.random() * pe & 2097151 ? function() {
      return mathfloor(Math.random() * pe);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(ne) {
      var H, C, w, P, J, se = 0, fe = [], N = new F(d);
      if (ne == null ? ne = m : intCheck(ne, 0, MAX), P = mathceil(ne / LOG_BASE), T)
        if (crypto.getRandomValues) {
          for (H = crypto.getRandomValues(new Uint32Array(P *= 2)); se < P; )
            J = H[se] * 131072 + (H[se + 1] >>> 11), J >= 9e15 ? (C = crypto.getRandomValues(new Uint32Array(2)), H[se] = C[0], H[se + 1] = C[1]) : (fe.push(J % 1e14), se += 2);
          se = P / 2;
        } else if (crypto.randomBytes) {
          for (H = crypto.randomBytes(P *= 7); se < P; )
            J = (H[se] & 31) * 281474976710656 + H[se + 1] * 1099511627776 + H[se + 2] * 4294967296 + H[se + 3] * 16777216 + (H[se + 4] << 16) + (H[se + 5] << 8) + H[se + 6], J >= 9e15 ? crypto.randomBytes(7).copy(H, se) : (fe.push(J % 1e14), se += 7);
          se = P / 7;
        } else
          throw T = !1, Error(bignumberError + "crypto unavailable");
      if (!T)
        for (; se < P; )
          J = oe(), J < 9e15 && (fe[se++] = J % 1e14);
      for (P = fe[--se], ne %= LOG_BASE, P && ne && (J = POWS_TEN[LOG_BASE - ne], fe[se] = mathfloor(P / J) * J); fe[se] === 0; fe.pop(), se--)
        ;
      if (se < 0)
        fe = [w = 0];
      else {
        for (w = -1; fe[0] === 0; fe.splice(0, 1), w -= LOG_BASE)
          ;
        for (se = 1, J = fe[0]; J >= 10; J /= 10, se++)
          ;
        se < LOG_BASE && (w -= LOG_BASE - se);
      }
      return N.e = w, N.c = fe, N;
    };
  }(), F.sum = function() {
    for (var pe = 1, oe = arguments, ne = new F(oe[0]); pe < oe.length; )
      ne = ne.plus(oe[pe++]);
    return ne;
  }, o = function() {
    var pe = "0123456789";
    function oe(ne, H, C, w) {
      for (var P, J = [0], se, fe = 0, N = ne.length; fe < N; ) {
        for (se = J.length; se--; J[se] *= H)
          ;
        for (J[0] += w.indexOf(ne.charAt(fe++)), P = 0; P < J.length; P++)
          J[P] > C - 1 && (J[P + 1] == null && (J[P + 1] = 0), J[P + 1] += J[P] / C | 0, J[P] %= C);
      }
      return J.reverse();
    }
    return function(ne, H, C, w, P) {
      var J, se, fe, N, W, I, te, ge, Pe = ne.indexOf("."), Ke = m, xe = v;
      for (Pe >= 0 && (N = V, V = 0, ne = ne.replace(".", ""), ge = new F(H), I = ge.pow(ne.length - Pe), V = N, ge.c = oe(
        toFixedPoint(coeffToString(I.c), I.e, "0"),
        10,
        C,
        pe
      ), ge.e = ge.c.length), te = oe(ne, H, C, P ? (J = G, pe) : (J = pe, G)), fe = N = te.length; te[--N] == 0; te.pop())
        ;
      if (!te[0])
        return J.charAt(0);
      if (Pe < 0 ? --fe : (I.c = te, I.e = fe, I.s = w, I = n(I, ge, Ke, xe, C), te = I.c, W = I.r, fe = I.e), se = fe + Ke + 1, Pe = te[se], N = C / 2, W = W || se < 0 || te[se + 1] != null, W = xe < 4 ? (Pe != null || W) && (xe == 0 || xe == (I.s < 0 ? 3 : 2)) : Pe > N || Pe == N && (xe == 4 || W || xe == 6 && te[se - 1] & 1 || xe == (I.s < 0 ? 8 : 7)), se < 1 || !te[0])
        ne = W ? toFixedPoint(J.charAt(1), -Ke, J.charAt(0)) : J.charAt(0);
      else {
        if (te.length = se, W)
          for (--C; ++te[--se] > C; )
            te[se] = 0, se || (++fe, te = [1].concat(te));
        for (N = te.length; !te[--N]; )
          ;
        for (Pe = 0, ne = ""; Pe <= N; ne += J.charAt(te[Pe++]))
          ;
        ne = toFixedPoint(ne, fe, J.charAt(0));
      }
      return ne;
    };
  }(), n = function() {
    function pe(H, C, w) {
      var P, J, se, fe, N = 0, W = H.length, I = C % SQRT_BASE, te = C / SQRT_BASE | 0;
      for (H = H.slice(); W--; )
        se = H[W] % SQRT_BASE, fe = H[W] / SQRT_BASE | 0, P = te * se + fe * I, J = I * se + P % SQRT_BASE * SQRT_BASE + N, N = (J / w | 0) + (P / SQRT_BASE | 0) + te * fe, H[W] = J % w;
      return N && (H = [N].concat(H)), H;
    }
    function oe(H, C, w, P) {
      var J, se;
      if (w != P)
        se = w > P ? 1 : -1;
      else
        for (J = se = 0; J < w; J++)
          if (H[J] != C[J]) {
            se = H[J] > C[J] ? 1 : -1;
            break;
          }
      return se;
    }
    function ne(H, C, w, P) {
      for (var J = 0; w--; )
        H[w] -= J, J = H[w] < C[w] ? 1 : 0, H[w] = J * P + H[w] - C[w];
      for (; !H[0] && H.length > 1; H.splice(0, 1))
        ;
    }
    return function(H, C, w, P, J) {
      var se, fe, N, W, I, te, ge, Pe, Ke, xe, ze, nt, Qt, Et, zt, Nt, pt, at = H.s == C.s ? 1 : -1, kt = H.c, Ut = C.c;
      if (!kt || !kt[0] || !Ut || !Ut[0])
        return new F(
          // Return NaN if either NaN, or both Infinity or 0.
          !H.s || !C.s || (kt ? Ut && kt[0] == Ut[0] : !Ut) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            kt && kt[0] == 0 || !Ut ? at * 0 : at / 0
          )
        );
      for (Pe = new F(at), Ke = Pe.c = [], fe = H.e - C.e, at = w + fe + 1, J || (J = BASE, fe = bitFloor(H.e / LOG_BASE) - bitFloor(C.e / LOG_BASE), at = at / LOG_BASE | 0), N = 0; Ut[N] == (kt[N] || 0); N++)
        ;
      if (Ut[N] > (kt[N] || 0) && fe--, at < 0)
        Ke.push(1), W = !0;
      else {
        for (Et = kt.length, Nt = Ut.length, N = 0, at += 2, I = mathfloor(J / (Ut[0] + 1)), I > 1 && (Ut = pe(Ut, I, J), kt = pe(kt, I, J), Nt = Ut.length, Et = kt.length), Qt = Nt, xe = kt.slice(0, Nt), ze = xe.length; ze < Nt; xe[ze++] = 0)
          ;
        pt = Ut.slice(), pt = [0].concat(pt), zt = Ut[0], Ut[1] >= J / 2 && zt++;
        do {
          if (I = 0, se = oe(Ut, xe, Nt, ze), se < 0) {
            if (nt = xe[0], Nt != ze && (nt = nt * J + (xe[1] || 0)), I = mathfloor(nt / zt), I > 1)
              for (I >= J && (I = J - 1), te = pe(Ut, I, J), ge = te.length, ze = xe.length; oe(te, xe, ge, ze) == 1; )
                I--, ne(te, Nt < ge ? pt : Ut, ge, J), ge = te.length, se = 1;
            else
              I == 0 && (se = I = 1), te = Ut.slice(), ge = te.length;
            if (ge < ze && (te = [0].concat(te)), ne(xe, te, ze, J), ze = xe.length, se == -1)
              for (; oe(Ut, xe, Nt, ze) < 1; )
                I++, ne(xe, Nt < ze ? pt : Ut, ze, J), ze = xe.length;
          } else
            se === 0 && (I++, xe = [0]);
          Ke[N++] = I, xe[0] ? xe[ze++] = kt[Qt] || 0 : (xe = [kt[Qt]], ze = 1);
        } while ((Qt++ < Et || xe[0] != null) && at--);
        W = xe[0] != null, Ke[0] || Ke.splice(0, 1);
      }
      if (J == BASE) {
        for (N = 1, at = Ke[0]; at >= 10; at /= 10, N++)
          ;
        Q(Pe, w + (Pe.e = N + fe * LOG_BASE - 1) + 1, P, W);
      } else
        Pe.e = fe, Pe.r = +W;
      return Pe;
    };
  }();
  function X(pe, oe, ne, H) {
    var C, w, P, J, se;
    if (ne == null ? ne = v : intCheck(ne, 0, 8), !pe.c)
      return pe.toString();
    if (C = pe.c[0], P = pe.e, oe == null)
      se = coeffToString(pe.c), se = H == 1 || H == 2 && (P <= S || P >= $) ? toExponential(se, P) : toFixedPoint(se, P, "0");
    else if (pe = Q(new F(pe), oe, ne), w = pe.e, se = coeffToString(pe.c), J = se.length, H == 1 || H == 2 && (oe <= w || w <= S)) {
      for (; J < oe; se += "0", J++)
        ;
      se = toExponential(se, w);
    } else if (oe -= P, se = toFixedPoint(se, w, "0"), w + 1 > J) {
      if (--oe > 0)
        for (se += "."; oe--; se += "0")
          ;
    } else if (oe += w - J, oe > 0)
      for (w + 1 == J && (se += "."); oe--; se += "0")
        ;
    return pe.s < 0 && C ? "-" + se : se;
  }
  function ee(pe, oe) {
    for (var ne, H, C = 1, w = new F(pe[0]); C < pe.length; C++)
      H = new F(pe[C]), (!H.s || (ne = compare(w, H)) === oe || ne === 0 && w.s === oe) && (w = H);
    return w;
  }
  function ue(pe, oe, ne) {
    for (var H = 1, C = oe.length; !oe[--C]; oe.pop())
      ;
    for (C = oe[0]; C >= 10; C /= 10, H++)
      ;
    return (ne = H + ne * LOG_BASE - 1) > O ? pe.c = pe.e = null : ne < E ? pe.c = [pe.e = 0] : (pe.e = ne, pe.c = oe), pe;
  }
  u = function() {
    var pe = /^(-?)0([xbo])(?=\w[\w.]*$)/i, oe = /^([^.]+)\.$/, ne = /^\.([^.]+)$/, H = /^-?(Infinity|NaN)$/, C = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(w, P, J, se) {
      var fe, N = J ? P : P.replace(C, "");
      if (H.test(N))
        w.s = isNaN(N) ? null : N < 0 ? -1 : 1;
      else {
        if (!J && (N = N.replace(pe, function(W, I, te) {
          return fe = (te = te.toLowerCase()) == "x" ? 16 : te == "b" ? 2 : 8, !se || se == fe ? I : W;
        }), se && (fe = se, N = N.replace(oe, "$1").replace(ne, "0.$1")), P != N))
          return new F(N, fe);
        if (F.DEBUG)
          throw Error(bignumberError + "Not a" + (se ? " base " + se : "") + " number: " + P);
        w.s = null;
      }
      w.c = w.e = null;
    };
  }();
  function Q(pe, oe, ne, H) {
    var C, w, P, J, se, fe, N, W = pe.c, I = POWS_TEN;
    if (W) {
      e: {
        for (C = 1, J = W[0]; J >= 10; J /= 10, C++)
          ;
        if (w = oe - C, w < 0)
          w += LOG_BASE, P = oe, se = W[fe = 0], N = mathfloor(se / I[C - P - 1] % 10);
        else if (fe = mathceil((w + 1) / LOG_BASE), fe >= W.length)
          if (H) {
            for (; W.length <= fe; W.push(0))
              ;
            se = N = 0, C = 1, w %= LOG_BASE, P = w - LOG_BASE + 1;
          } else
            break e;
        else {
          for (se = J = W[fe], C = 1; J >= 10; J /= 10, C++)
            ;
          w %= LOG_BASE, P = w - LOG_BASE + C, N = P < 0 ? 0 : mathfloor(se / I[C - P - 1] % 10);
        }
        if (H = H || oe < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        W[fe + 1] != null || (P < 0 ? se : se % I[C - P - 1]), H = ne < 4 ? (N || H) && (ne == 0 || ne == (pe.s < 0 ? 3 : 2)) : N > 5 || N == 5 && (ne == 4 || H || ne == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (w > 0 ? P > 0 ? se / I[C - P] : 0 : W[fe - 1]) % 10 & 1 || ne == (pe.s < 0 ? 8 : 7)), oe < 1 || !W[0])
          return W.length = 0, H ? (oe -= pe.e + 1, W[0] = I[(LOG_BASE - oe % LOG_BASE) % LOG_BASE], pe.e = -oe || 0) : W[0] = pe.e = 0, pe;
        if (w == 0 ? (W.length = fe, J = 1, fe--) : (W.length = fe + 1, J = I[LOG_BASE - w], W[fe] = P > 0 ? mathfloor(se / I[C - P] % I[P]) * J : 0), H)
          for (; ; )
            if (fe == 0) {
              for (w = 1, P = W[0]; P >= 10; P /= 10, w++)
                ;
              for (P = W[0] += J, J = 1; P >= 10; P /= 10, J++)
                ;
              w != J && (pe.e++, W[0] == BASE && (W[0] = 1));
              break;
            } else {
              if (W[fe] += J, W[fe] != BASE)
                break;
              W[fe--] = 0, J = 1;
            }
        for (w = W.length; W[--w] === 0; W.pop())
          ;
      }
      pe.e > O ? pe.c = pe.e = null : pe.e < E && (pe.c = [pe.e = 0]);
    }
    return pe;
  }
  function Y(pe) {
    var oe, ne = pe.e;
    return ne === null ? pe.toString() : (oe = coeffToString(pe.c), oe = ne <= S || ne >= $ ? toExponential(oe, ne) : toFixedPoint(oe, ne, "0"), pe.s < 0 ? "-" + oe : oe);
  }
  return c.absoluteValue = c.abs = function() {
    var pe = new F(this);
    return pe.s < 0 && (pe.s = 1), pe;
  }, c.comparedTo = function(pe, oe) {
    return compare(this, new F(pe, oe));
  }, c.decimalPlaces = c.dp = function(pe, oe) {
    var ne, H, C, w = this;
    if (pe != null)
      return intCheck(pe, 0, MAX), oe == null ? oe = v : intCheck(oe, 0, 8), Q(new F(w), pe + w.e + 1, oe);
    if (!(ne = w.c))
      return null;
    if (H = ((C = ne.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE, C = ne[C])
      for (; C % 10 == 0; C /= 10, H--)
        ;
    return H < 0 && (H = 0), H;
  }, c.dividedBy = c.div = function(pe, oe) {
    return n(this, new F(pe, oe), m, v);
  }, c.dividedToIntegerBy = c.idiv = function(pe, oe) {
    return n(this, new F(pe, oe), 0, 1);
  }, c.exponentiatedBy = c.pow = function(pe, oe) {
    var ne, H, C, w, P, J, se, fe, N, W = this;
    if (pe = new F(pe), pe.c && !pe.isInteger())
      throw Error(bignumberError + "Exponent not an integer: " + Y(pe));
    if (oe != null && (oe = new F(oe)), J = pe.e > 14, !W.c || !W.c[0] || W.c[0] == 1 && !W.e && W.c.length == 1 || !pe.c || !pe.c[0])
      return N = new F(Math.pow(+Y(W), J ? pe.s * (2 - isOdd(pe)) : +Y(pe))), oe ? N.mod(oe) : N;
    if (se = pe.s < 0, oe) {
      if (oe.c ? !oe.c[0] : !oe.s)
        return new F(NaN);
      H = !se && W.isInteger() && oe.isInteger(), H && (W = W.mod(oe));
    } else {
      if (pe.e > 9 && (W.e > 0 || W.e < -1 || (W.e == 0 ? W.c[0] > 1 || J && W.c[1] >= 24e7 : W.c[0] < 8e13 || J && W.c[0] <= 9999975e7)))
        return w = W.s < 0 && isOdd(pe) ? -0 : 0, W.e > -1 && (w = 1 / w), new F(se ? 1 / w : w);
      V && (w = mathceil(V / LOG_BASE + 2));
    }
    for (J ? (ne = new F(0.5), se && (pe.s = 1), fe = isOdd(pe)) : (C = Math.abs(+Y(pe)), fe = C % 2), N = new F(d); ; ) {
      if (fe) {
        if (N = N.times(W), !N.c)
          break;
        w ? N.c.length > w && (N.c.length = w) : H && (N = N.mod(oe));
      }
      if (C) {
        if (C = mathfloor(C / 2), C === 0)
          break;
        fe = C % 2;
      } else if (pe = pe.times(ne), Q(pe, pe.e + 1, 1), pe.e > 14)
        fe = isOdd(pe);
      else {
        if (C = +Y(pe), C === 0)
          break;
        fe = C % 2;
      }
      W = W.times(W), w ? W.c && W.c.length > w && (W.c.length = w) : H && (W = W.mod(oe));
    }
    return H ? N : (se && (N = d.div(N)), oe ? N.mod(oe) : w ? Q(N, V, v, P) : N);
  }, c.integerValue = function(pe) {
    var oe = new F(this);
    return pe == null ? pe = v : intCheck(pe, 0, 8), Q(oe, oe.e + 1, pe);
  }, c.isEqualTo = c.eq = function(pe, oe) {
    return compare(this, new F(pe, oe)) === 0;
  }, c.isFinite = function() {
    return !!this.c;
  }, c.isGreaterThan = c.gt = function(pe, oe) {
    return compare(this, new F(pe, oe)) > 0;
  }, c.isGreaterThanOrEqualTo = c.gte = function(pe, oe) {
    return (oe = compare(this, new F(pe, oe))) === 1 || oe === 0;
  }, c.isInteger = function() {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  }, c.isLessThan = c.lt = function(pe, oe) {
    return compare(this, new F(pe, oe)) < 0;
  }, c.isLessThanOrEqualTo = c.lte = function(pe, oe) {
    return (oe = compare(this, new F(pe, oe))) === -1 || oe === 0;
  }, c.isNaN = function() {
    return !this.s;
  }, c.isNegative = function() {
    return this.s < 0;
  }, c.isPositive = function() {
    return this.s > 0;
  }, c.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, c.minus = function(pe, oe) {
    var ne, H, C, w, P = this, J = P.s;
    if (pe = new F(pe, oe), oe = pe.s, !J || !oe)
      return new F(NaN);
    if (J != oe)
      return pe.s = -oe, P.plus(pe);
    var se = P.e / LOG_BASE, fe = pe.e / LOG_BASE, N = P.c, W = pe.c;
    if (!se || !fe) {
      if (!N || !W)
        return N ? (pe.s = -oe, pe) : new F(W ? P : NaN);
      if (!N[0] || !W[0])
        return W[0] ? (pe.s = -oe, pe) : new F(N[0] ? P : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          v == 3 ? -0 : 0
        ));
    }
    if (se = bitFloor(se), fe = bitFloor(fe), N = N.slice(), J = se - fe) {
      for ((w = J < 0) ? (J = -J, C = N) : (fe = se, C = W), C.reverse(), oe = J; oe--; C.push(0))
        ;
      C.reverse();
    } else
      for (H = (w = (J = N.length) < (oe = W.length)) ? J : oe, J = oe = 0; oe < H; oe++)
        if (N[oe] != W[oe]) {
          w = N[oe] < W[oe];
          break;
        }
    if (w && (C = N, N = W, W = C, pe.s = -pe.s), oe = (H = W.length) - (ne = N.length), oe > 0)
      for (; oe--; N[ne++] = 0)
        ;
    for (oe = BASE - 1; H > J; ) {
      if (N[--H] < W[H]) {
        for (ne = H; ne && !N[--ne]; N[ne] = oe)
          ;
        --N[ne], N[H] += BASE;
      }
      N[H] -= W[H];
    }
    for (; N[0] == 0; N.splice(0, 1), --fe)
      ;
    return N[0] ? ue(pe, N, fe) : (pe.s = v == 3 ? -1 : 1, pe.c = [pe.e = 0], pe);
  }, c.modulo = c.mod = function(pe, oe) {
    var ne, H, C = this;
    return pe = new F(pe, oe), !C.c || !pe.s || pe.c && !pe.c[0] ? new F(NaN) : !pe.c || C.c && !C.c[0] ? new F(C) : (y == 9 ? (H = pe.s, pe.s = 1, ne = n(C, pe, 0, 3), pe.s = H, ne.s *= H) : ne = n(C, pe, 0, y), pe = C.minus(ne.times(pe)), !pe.c[0] && y == 1 && (pe.s = C.s), pe);
  }, c.multipliedBy = c.times = function(pe, oe) {
    var ne, H, C, w, P, J, se, fe, N, W, I, te, ge, Pe, Ke, xe = this, ze = xe.c, nt = (pe = new F(pe, oe)).c;
    if (!ze || !nt || !ze[0] || !nt[0])
      return !xe.s || !pe.s || ze && !ze[0] && !nt || nt && !nt[0] && !ze ? pe.c = pe.e = pe.s = null : (pe.s *= xe.s, !ze || !nt ? pe.c = pe.e = null : (pe.c = [0], pe.e = 0)), pe;
    for (H = bitFloor(xe.e / LOG_BASE) + bitFloor(pe.e / LOG_BASE), pe.s *= xe.s, se = ze.length, W = nt.length, se < W && (ge = ze, ze = nt, nt = ge, C = se, se = W, W = C), C = se + W, ge = []; C--; ge.push(0))
      ;
    for (Pe = BASE, Ke = SQRT_BASE, C = W; --C >= 0; ) {
      for (ne = 0, I = nt[C] % Ke, te = nt[C] / Ke | 0, P = se, w = C + P; w > C; )
        fe = ze[--P] % Ke, N = ze[P] / Ke | 0, J = te * fe + N * I, fe = I * fe + J % Ke * Ke + ge[w] + ne, ne = (fe / Pe | 0) + (J / Ke | 0) + te * N, ge[w--] = fe % Pe;
      ge[w] = ne;
    }
    return ne ? ++H : ge.splice(0, 1), ue(pe, ge, H);
  }, c.negated = function() {
    var pe = new F(this);
    return pe.s = -pe.s || null, pe;
  }, c.plus = function(pe, oe) {
    var ne, H = this, C = H.s;
    if (pe = new F(pe, oe), oe = pe.s, !C || !oe)
      return new F(NaN);
    if (C != oe)
      return pe.s = -oe, H.minus(pe);
    var w = H.e / LOG_BASE, P = pe.e / LOG_BASE, J = H.c, se = pe.c;
    if (!w || !P) {
      if (!J || !se)
        return new F(C / 0);
      if (!J[0] || !se[0])
        return se[0] ? pe : new F(J[0] ? H : C * 0);
    }
    if (w = bitFloor(w), P = bitFloor(P), J = J.slice(), C = w - P) {
      for (C > 0 ? (P = w, ne = se) : (C = -C, ne = J), ne.reverse(); C--; ne.push(0))
        ;
      ne.reverse();
    }
    for (C = J.length, oe = se.length, C - oe < 0 && (ne = se, se = J, J = ne, oe = C), C = 0; oe; )
      C = (J[--oe] = J[oe] + se[oe] + C) / BASE | 0, J[oe] = BASE === J[oe] ? 0 : J[oe] % BASE;
    return C && (J = [C].concat(J), ++P), ue(pe, J, P);
  }, c.precision = c.sd = function(pe, oe) {
    var ne, H, C, w = this;
    if (pe != null && pe !== !!pe)
      return intCheck(pe, 1, MAX), oe == null ? oe = v : intCheck(oe, 0, 8), Q(new F(w), pe, oe);
    if (!(ne = w.c))
      return null;
    if (C = ne.length - 1, H = C * LOG_BASE + 1, C = ne[C]) {
      for (; C % 10 == 0; C /= 10, H--)
        ;
      for (C = ne[0]; C >= 10; C /= 10, H++)
        ;
    }
    return pe && w.e + 1 > H && (H = w.e + 1), H;
  }, c.shiftedBy = function(pe) {
    return intCheck(pe, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER), this.times("1e" + pe);
  }, c.squareRoot = c.sqrt = function() {
    var pe, oe, ne, H, C, w = this, P = w.c, J = w.s, se = w.e, fe = m + 4, N = new F("0.5");
    if (J !== 1 || !P || !P[0])
      return new F(!J || J < 0 && (!P || P[0]) ? NaN : P ? w : 1 / 0);
    if (J = Math.sqrt(+Y(w)), J == 0 || J == 1 / 0 ? (oe = coeffToString(P), (oe.length + se) % 2 == 0 && (oe += "0"), J = Math.sqrt(+oe), se = bitFloor((se + 1) / 2) - (se < 0 || se % 2), J == 1 / 0 ? oe = "5e" + se : (oe = J.toExponential(), oe = oe.slice(0, oe.indexOf("e") + 1) + se), ne = new F(oe)) : ne = new F(J + ""), ne.c[0]) {
      for (se = ne.e, J = se + fe, J < 3 && (J = 0); ; )
        if (C = ne, ne = N.times(C.plus(n(w, C, fe, 1))), coeffToString(C.c).slice(0, J) === (oe = coeffToString(ne.c)).slice(0, J))
          if (ne.e < se && --J, oe = oe.slice(J - 3, J + 1), oe == "9999" || !H && oe == "4999") {
            if (!H && (Q(C, C.e + m + 2, 0), C.times(C).eq(w))) {
              ne = C;
              break;
            }
            fe += 4, J += 4, H = 1;
          } else {
            (!+oe || !+oe.slice(1) && oe.charAt(0) == "5") && (Q(ne, ne.e + m + 2, 1), pe = !ne.times(ne).eq(w));
            break;
          }
    }
    return Q(ne, ne.e + m + 1, v, pe);
  }, c.toExponential = function(pe, oe) {
    return pe != null && (intCheck(pe, 0, MAX), pe++), X(this, pe, oe, 1);
  }, c.toFixed = function(pe, oe) {
    return pe != null && (intCheck(pe, 0, MAX), pe = pe + this.e + 1), X(this, pe, oe);
  }, c.toFormat = function(pe, oe, ne) {
    var H, C = this;
    if (ne == null)
      pe != null && oe && typeof oe == "object" ? (ne = oe, oe = null) : pe && typeof pe == "object" ? (ne = pe, pe = oe = null) : ne = M;
    else if (typeof ne != "object")
      throw Error(bignumberError + "Argument not an object: " + ne);
    if (H = C.toFixed(pe, oe), C.c) {
      var w, P = H.split("."), J = +ne.groupSize, se = +ne.secondaryGroupSize, fe = ne.groupSeparator || "", N = P[0], W = P[1], I = C.s < 0, te = I ? N.slice(1) : N, ge = te.length;
      if (se && (w = J, J = se, se = w, ge -= w), J > 0 && ge > 0) {
        for (w = ge % J || J, N = te.substr(0, w); w < ge; w += J)
          N += fe + te.substr(w, J);
        se > 0 && (N += fe + te.slice(w)), I && (N = "-" + N);
      }
      H = W ? N + (ne.decimalSeparator || "") + ((se = +ne.fractionGroupSize) ? W.replace(
        new RegExp("\\d{" + se + "}\\B", "g"),
        "$&" + (ne.fractionGroupSeparator || "")
      ) : W) : N;
    }
    return (ne.prefix || "") + H + (ne.suffix || "");
  }, c.toFraction = function(pe) {
    var oe, ne, H, C, w, P, J, se, fe, N, W, I, te = this, ge = te.c;
    if (pe != null && (J = new F(pe), !J.isInteger() && (J.c || J.s !== 1) || J.lt(d)))
      throw Error(bignumberError + "Argument " + (J.isInteger() ? "out of range: " : "not an integer: ") + Y(J));
    if (!ge)
      return new F(te);
    for (oe = new F(d), fe = ne = new F(d), H = se = new F(d), I = coeffToString(ge), w = oe.e = I.length - te.e - 1, oe.c[0] = POWS_TEN[(P = w % LOG_BASE) < 0 ? LOG_BASE + P : P], pe = !pe || J.comparedTo(oe) > 0 ? w > 0 ? oe : fe : J, P = O, O = 1 / 0, J = new F(I), se.c[0] = 0; N = n(J, oe, 0, 1), C = ne.plus(N.times(H)), C.comparedTo(pe) != 1; )
      ne = H, H = C, fe = se.plus(N.times(C = fe)), se = C, oe = J.minus(N.times(C = oe)), J = C;
    return C = n(pe.minus(ne), H, 0, 1), se = se.plus(C.times(fe)), ne = ne.plus(C.times(H)), se.s = fe.s = te.s, w = w * 2, W = n(fe, H, w, v).minus(te).abs().comparedTo(
      n(se, ne, w, v).minus(te).abs()
    ) < 1 ? [fe, H] : [se, ne], O = P, W;
  }, c.toNumber = function() {
    return +Y(this);
  }, c.toPrecision = function(pe, oe) {
    return pe != null && intCheck(pe, 1, MAX), X(this, pe, oe, 2);
  }, c.toString = function(pe) {
    var oe, ne = this, H = ne.s, C = ne.e;
    return C === null ? H ? (oe = "Infinity", H < 0 && (oe = "-" + oe)) : oe = "NaN" : (pe == null ? oe = C <= S || C >= $ ? toExponential(coeffToString(ne.c), C) : toFixedPoint(coeffToString(ne.c), C, "0") : pe === 10 && k ? (ne = Q(new F(ne), m + C + 1, v), oe = toFixedPoint(coeffToString(ne.c), ne.e, "0")) : (intCheck(pe, 2, G.length, "Base"), oe = o(toFixedPoint(coeffToString(ne.c), C, "0"), 10, pe, H, !0)), H < 0 && ne.c[0] && (oe = "-" + oe)), oe;
  }, c.valueOf = c.toJSON = function() {
    return Y(this);
  }, c._isBigNumber = !0, c[Symbol.toStringTag] = "BigNumber", c[Symbol.for("nodejs.util.inspect.custom")] = c.valueOf, e != null && F.set(e), F;
}
function bitFloor(e) {
  var n = e | 0;
  return e > 0 || e === n ? n : n - 1;
}
function coeffToString(e) {
  for (var n, o, u = 1, c = e.length, d = e[0] + ""; u < c; ) {
    for (n = e[u++] + "", o = LOG_BASE - n.length; o--; n = "0" + n)
      ;
    d += n;
  }
  for (c = d.length; d.charCodeAt(--c) === 48; )
    ;
  return d.slice(0, c + 1 || 1);
}
function compare(e, n) {
  var o, u, c = e.c, d = n.c, m = e.s, v = n.s, S = e.e, $ = n.e;
  if (!m || !v)
    return null;
  if (o = c && !c[0], u = d && !d[0], o || u)
    return o ? u ? 0 : -v : m;
  if (m != v)
    return m;
  if (o = m < 0, u = S == $, !c || !d)
    return u ? 0 : !c ^ o ? 1 : -1;
  if (!u)
    return S > $ ^ o ? 1 : -1;
  for (v = (S = c.length) < ($ = d.length) ? S : $, m = 0; m < v; m++)
    if (c[m] != d[m])
      return c[m] > d[m] ^ o ? 1 : -1;
  return S == $ ? 0 : S > $ ^ o ? 1 : -1;
}
function intCheck(e, n, o, u) {
  if (e < n || e > o || e !== mathfloor(e))
    throw Error(bignumberError + (u || "Argument") + (typeof e == "number" ? e < n || e > o ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function isOdd(e) {
  var n = e.c.length - 1;
  return bitFloor(e.e / LOG_BASE) == n && e.c[n] % 2 != 0;
}
function toExponential(e, n) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (n < 0 ? "e" : "e+") + n;
}
function toFixedPoint(e, n, o) {
  var u, c;
  if (n < 0) {
    for (c = o + "."; ++n; c += o)
      ;
    e = c + e;
  } else if (u = e.length, ++n > u) {
    for (c = o, n -= u; --n; c += o)
      ;
    e += c;
  } else
    n < u && (e = e.slice(0, n) + "." + e.slice(n));
  return e;
}
var BigNumber = clone();
const bignumber = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BigNumber,
  default: BigNumber
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(bignumber);
/**
 * @license
 * Copyright 2009 The Closure Library Authors
 * Copyright 2020 Daniel Wirtz / The long.js Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var wasm$2 = null;
try {
  wasm$2 = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch (e) {
}
function Long$2(e, n, o) {
  this.low = e | 0, this.high = n | 0, this.unsigned = !!o;
}
Long$2.prototype.__isLong__;
Object.defineProperty(Long$2.prototype, "__isLong__", { value: !0 });
function isLong$2(e) {
  return (e && e.__isLong__) === !0;
}
function ctz32(e) {
  var n = Math.clz32(e & -e);
  return e ? 31 - n : n;
}
Long$2.isLong = isLong$2;
var INT_CACHE$2 = {}, UINT_CACHE$2 = {};
function fromInt$2(e, n) {
  var o, u, c;
  return n ? (e >>>= 0, (c = 0 <= e && e < 256) && (u = UINT_CACHE$2[e], u) ? u : (o = fromBits$2(e, 0, !0), c && (UINT_CACHE$2[e] = o), o)) : (e |= 0, (c = -128 <= e && e < 128) && (u = INT_CACHE$2[e], u) ? u : (o = fromBits$2(e, e < 0 ? -1 : 0, !1), c && (INT_CACHE$2[e] = o), o));
}
Long$2.fromInt = fromInt$2;
function fromNumber$2(e, n) {
  if (isNaN(e))
    return n ? UZERO$2 : ZERO$2;
  if (n) {
    if (e < 0)
      return UZERO$2;
    if (e >= TWO_PWR_64_DBL$2)
      return MAX_UNSIGNED_VALUE$2;
  } else {
    if (e <= -TWO_PWR_63_DBL$2)
      return MIN_VALUE$2;
    if (e + 1 >= TWO_PWR_63_DBL$2)
      return MAX_VALUE$2;
  }
  return e < 0 ? fromNumber$2(-e, n).neg() : fromBits$2(e % TWO_PWR_32_DBL$2 | 0, e / TWO_PWR_32_DBL$2 | 0, n);
}
Long$2.fromNumber = fromNumber$2;
function fromBits$2(e, n, o) {
  return new Long$2(e, n, o);
}
Long$2.fromBits = fromBits$2;
var pow_dbl$2 = Math.pow;
function fromString$2(e, n, o) {
  if (e.length === 0)
    throw Error("empty string");
  if (typeof n == "number" ? (o = n, n = !1) : n = !!n, e === "NaN" || e === "Infinity" || e === "+Infinity" || e === "-Infinity")
    return n ? UZERO$2 : ZERO$2;
  if (o = o || 10, o < 2 || 36 < o)
    throw RangeError("radix");
  var u;
  if ((u = e.indexOf("-")) > 0)
    throw Error("interior hyphen");
  if (u === 0)
    return fromString$2(e.substring(1), n, o).neg();
  for (var c = fromNumber$2(pow_dbl$2(o, 8)), d = ZERO$2, m = 0; m < e.length; m += 8) {
    var v = Math.min(8, e.length - m), S = parseInt(e.substring(m, m + v), o);
    if (v < 8) {
      var $ = fromNumber$2(pow_dbl$2(o, v));
      d = d.mul($).add(fromNumber$2(S));
    } else
      d = d.mul(c), d = d.add(fromNumber$2(S));
  }
  return d.unsigned = n, d;
}
Long$2.fromString = fromString$2;
function fromValue$2(e, n) {
  return typeof e == "number" ? fromNumber$2(e, n) : typeof e == "string" ? fromString$2(e, n) : fromBits$2(e.low, e.high, typeof n == "boolean" ? n : e.unsigned);
}
Long$2.fromValue = fromValue$2;
var TWO_PWR_16_DBL$2 = 65536, TWO_PWR_24_DBL$2 = 1 << 24, TWO_PWR_32_DBL$2 = TWO_PWR_16_DBL$2 * TWO_PWR_16_DBL$2, TWO_PWR_64_DBL$2 = TWO_PWR_32_DBL$2 * TWO_PWR_32_DBL$2, TWO_PWR_63_DBL$2 = TWO_PWR_64_DBL$2 / 2, TWO_PWR_24$2 = fromInt$2(TWO_PWR_24_DBL$2), ZERO$2 = fromInt$2(0);
Long$2.ZERO = ZERO$2;
var UZERO$2 = fromInt$2(0, !0);
Long$2.UZERO = UZERO$2;
var ONE$2 = fromInt$2(1);
Long$2.ONE = ONE$2;
var UONE$2 = fromInt$2(1, !0);
Long$2.UONE = UONE$2;
var NEG_ONE$2 = fromInt$2(-1);
Long$2.NEG_ONE = NEG_ONE$2;
var MAX_VALUE$2 = fromBits$2(-1, 2147483647, !1);
Long$2.MAX_VALUE = MAX_VALUE$2;
var MAX_UNSIGNED_VALUE$2 = fromBits$2(-1, -1, !0);
Long$2.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE$2;
var MIN_VALUE$2 = fromBits$2(0, -2147483648, !1);
Long$2.MIN_VALUE = MIN_VALUE$2;
var LongPrototype$2 = Long$2.prototype;
LongPrototype$2.toInt = function e() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype$2.toNumber = function e() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL$2 + (this.low >>> 0) : this.high * TWO_PWR_32_DBL$2 + (this.low >>> 0);
};
LongPrototype$2.toString = function e(n) {
  if (n = n || 10, n < 2 || 36 < n)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE$2)) {
      var o = fromNumber$2(n), u = this.div(o), c = u.mul(o).sub(this);
      return u.toString(n) + c.toInt().toString(n);
    } else
      return "-" + this.neg().toString(n);
  for (var d = fromNumber$2(pow_dbl$2(n, 6), this.unsigned), m = this, v = ""; ; ) {
    var S = m.div(d), $ = m.sub(S.mul(d)).toInt() >>> 0, E = $.toString(n);
    if (m = S, m.isZero())
      return E + v;
    for (; E.length < 6; )
      E = "0" + E;
    v = "" + E + v;
  }
};
LongPrototype$2.getHighBits = function e() {
  return this.high;
};
LongPrototype$2.getHighBitsUnsigned = function e() {
  return this.high >>> 0;
};
LongPrototype$2.getLowBits = function e() {
  return this.low;
};
LongPrototype$2.getLowBitsUnsigned = function e() {
  return this.low >>> 0;
};
LongPrototype$2.getNumBitsAbs = function e() {
  if (this.isNegative())
    return this.eq(MIN_VALUE$2) ? 64 : this.neg().getNumBitsAbs();
  for (var n = this.high != 0 ? this.high : this.low, o = 31; o > 0 && !(n & 1 << o); o--)
    ;
  return this.high != 0 ? o + 33 : o + 1;
};
LongPrototype$2.isZero = function e() {
  return this.high === 0 && this.low === 0;
};
LongPrototype$2.eqz = LongPrototype$2.isZero;
LongPrototype$2.isNegative = function e() {
  return !this.unsigned && this.high < 0;
};
LongPrototype$2.isPositive = function e() {
  return this.unsigned || this.high >= 0;
};
LongPrototype$2.isOdd = function e() {
  return (this.low & 1) === 1;
};
LongPrototype$2.isEven = function e() {
  return (this.low & 1) === 0;
};
LongPrototype$2.equals = function e(n) {
  return isLong$2(n) || (n = fromValue$2(n)), this.unsigned !== n.unsigned && this.high >>> 31 === 1 && n.high >>> 31 === 1 ? !1 : this.high === n.high && this.low === n.low;
};
LongPrototype$2.eq = LongPrototype$2.equals;
LongPrototype$2.notEquals = function e(n) {
  return !this.eq(
    /* validates */
    n
  );
};
LongPrototype$2.neq = LongPrototype$2.notEquals;
LongPrototype$2.ne = LongPrototype$2.notEquals;
LongPrototype$2.lessThan = function e(n) {
  return this.comp(
    /* validates */
    n
  ) < 0;
};
LongPrototype$2.lt = LongPrototype$2.lessThan;
LongPrototype$2.lessThanOrEqual = function e(n) {
  return this.comp(
    /* validates */
    n
  ) <= 0;
};
LongPrototype$2.lte = LongPrototype$2.lessThanOrEqual;
LongPrototype$2.le = LongPrototype$2.lessThanOrEqual;
LongPrototype$2.greaterThan = function e(n) {
  return this.comp(
    /* validates */
    n
  ) > 0;
};
LongPrototype$2.gt = LongPrototype$2.greaterThan;
LongPrototype$2.greaterThanOrEqual = function e(n) {
  return this.comp(
    /* validates */
    n
  ) >= 0;
};
LongPrototype$2.gte = LongPrototype$2.greaterThanOrEqual;
LongPrototype$2.ge = LongPrototype$2.greaterThanOrEqual;
LongPrototype$2.compare = function e(n) {
  if (isLong$2(n) || (n = fromValue$2(n)), this.eq(n))
    return 0;
  var o = this.isNegative(), u = n.isNegative();
  return o && !u ? -1 : !o && u ? 1 : this.unsigned ? n.high >>> 0 > this.high >>> 0 || n.high === this.high && n.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(n).isNegative() ? -1 : 1;
};
LongPrototype$2.comp = LongPrototype$2.compare;
LongPrototype$2.negate = function e() {
  return !this.unsigned && this.eq(MIN_VALUE$2) ? MIN_VALUE$2 : this.not().add(ONE$2);
};
LongPrototype$2.neg = LongPrototype$2.negate;
LongPrototype$2.add = function e(n) {
  isLong$2(n) || (n = fromValue$2(n));
  var o = this.high >>> 16, u = this.high & 65535, c = this.low >>> 16, d = this.low & 65535, m = n.high >>> 16, v = n.high & 65535, S = n.low >>> 16, $ = n.low & 65535, E = 0, O = 0, T = 0, y = 0;
  return y += d + $, T += y >>> 16, y &= 65535, T += c + S, O += T >>> 16, T &= 65535, O += u + v, E += O >>> 16, O &= 65535, E += o + m, E &= 65535, fromBits$2(T << 16 | y, E << 16 | O, this.unsigned);
};
LongPrototype$2.subtract = function e(n) {
  return isLong$2(n) || (n = fromValue$2(n)), this.add(n.neg());
};
LongPrototype$2.sub = LongPrototype$2.subtract;
LongPrototype$2.multiply = function e(n) {
  if (this.isZero())
    return this;
  if (isLong$2(n) || (n = fromValue$2(n)), wasm$2) {
    var o = wasm$2.mul(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits$2(o, wasm$2.get_high(), this.unsigned);
  }
  if (n.isZero())
    return this.unsigned ? UZERO$2 : ZERO$2;
  if (this.eq(MIN_VALUE$2))
    return n.isOdd() ? MIN_VALUE$2 : ZERO$2;
  if (n.eq(MIN_VALUE$2))
    return this.isOdd() ? MIN_VALUE$2 : ZERO$2;
  if (this.isNegative())
    return n.isNegative() ? this.neg().mul(n.neg()) : this.neg().mul(n).neg();
  if (n.isNegative())
    return this.mul(n.neg()).neg();
  if (this.lt(TWO_PWR_24$2) && n.lt(TWO_PWR_24$2))
    return fromNumber$2(this.toNumber() * n.toNumber(), this.unsigned);
  var u = this.high >>> 16, c = this.high & 65535, d = this.low >>> 16, m = this.low & 65535, v = n.high >>> 16, S = n.high & 65535, $ = n.low >>> 16, E = n.low & 65535, O = 0, T = 0, y = 0, V = 0;
  return V += m * E, y += V >>> 16, V &= 65535, y += d * E, T += y >>> 16, y &= 65535, y += m * $, T += y >>> 16, y &= 65535, T += c * E, O += T >>> 16, T &= 65535, T += d * $, O += T >>> 16, T &= 65535, T += m * S, O += T >>> 16, T &= 65535, O += u * E + c * $ + d * S + m * v, O &= 65535, fromBits$2(y << 16 | V, O << 16 | T, this.unsigned);
};
LongPrototype$2.mul = LongPrototype$2.multiply;
LongPrototype$2.divide = function e(n) {
  if (isLong$2(n) || (n = fromValue$2(n)), n.isZero())
    throw Error("division by zero");
  if (wasm$2) {
    if (!this.unsigned && this.high === -2147483648 && n.low === -1 && n.high === -1)
      return this;
    var o = (this.unsigned ? wasm$2.div_u : wasm$2.div_s)(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits$2(o, wasm$2.get_high(), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO$2 : ZERO$2;
  var u, c, d;
  if (this.unsigned) {
    if (n.unsigned || (n = n.toUnsigned()), n.gt(this))
      return UZERO$2;
    if (n.gt(this.shru(1)))
      return UONE$2;
    d = UZERO$2;
  } else {
    if (this.eq(MIN_VALUE$2)) {
      if (n.eq(ONE$2) || n.eq(NEG_ONE$2))
        return MIN_VALUE$2;
      if (n.eq(MIN_VALUE$2))
        return ONE$2;
      var m = this.shr(1);
      return u = m.div(n).shl(1), u.eq(ZERO$2) ? n.isNegative() ? ONE$2 : NEG_ONE$2 : (c = this.sub(n.mul(u)), d = u.add(c.div(n)), d);
    } else if (n.eq(MIN_VALUE$2))
      return this.unsigned ? UZERO$2 : ZERO$2;
    if (this.isNegative())
      return n.isNegative() ? this.neg().div(n.neg()) : this.neg().div(n).neg();
    if (n.isNegative())
      return this.div(n.neg()).neg();
    d = ZERO$2;
  }
  for (c = this; c.gte(n); ) {
    u = Math.max(1, Math.floor(c.toNumber() / n.toNumber()));
    for (var v = Math.ceil(Math.log(u) / Math.LN2), S = v <= 48 ? 1 : pow_dbl$2(2, v - 48), $ = fromNumber$2(u), E = $.mul(n); E.isNegative() || E.gt(c); )
      u -= S, $ = fromNumber$2(u, this.unsigned), E = $.mul(n);
    $.isZero() && ($ = ONE$2), d = d.add($), c = c.sub(E);
  }
  return d;
};
LongPrototype$2.div = LongPrototype$2.divide;
LongPrototype$2.modulo = function e(n) {
  if (isLong$2(n) || (n = fromValue$2(n)), wasm$2) {
    var o = (this.unsigned ? wasm$2.rem_u : wasm$2.rem_s)(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits$2(o, wasm$2.get_high(), this.unsigned);
  }
  return this.sub(this.div(n).mul(n));
};
LongPrototype$2.mod = LongPrototype$2.modulo;
LongPrototype$2.rem = LongPrototype$2.modulo;
LongPrototype$2.not = function e() {
  return fromBits$2(~this.low, ~this.high, this.unsigned);
};
LongPrototype$2.countLeadingZeros = function e() {
  return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
};
LongPrototype$2.clz = LongPrototype$2.countLeadingZeros;
LongPrototype$2.countTrailingZeros = function e() {
  return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
};
LongPrototype$2.ctz = LongPrototype$2.countTrailingZeros;
LongPrototype$2.and = function e(n) {
  return isLong$2(n) || (n = fromValue$2(n)), fromBits$2(this.low & n.low, this.high & n.high, this.unsigned);
};
LongPrototype$2.or = function e(n) {
  return isLong$2(n) || (n = fromValue$2(n)), fromBits$2(this.low | n.low, this.high | n.high, this.unsigned);
};
LongPrototype$2.xor = function e(n) {
  return isLong$2(n) || (n = fromValue$2(n)), fromBits$2(this.low ^ n.low, this.high ^ n.high, this.unsigned);
};
LongPrototype$2.shiftLeft = function e(n) {
  return isLong$2(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n < 32 ? fromBits$2(this.low << n, this.high << n | this.low >>> 32 - n, this.unsigned) : fromBits$2(0, this.low << n - 32, this.unsigned);
};
LongPrototype$2.shl = LongPrototype$2.shiftLeft;
LongPrototype$2.shiftRight = function e(n) {
  return isLong$2(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n < 32 ? fromBits$2(this.low >>> n | this.high << 32 - n, this.high >> n, this.unsigned) : fromBits$2(this.high >> n - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype$2.shr = LongPrototype$2.shiftRight;
LongPrototype$2.shiftRightUnsigned = function e(n) {
  return isLong$2(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n < 32 ? fromBits$2(this.low >>> n | this.high << 32 - n, this.high >>> n, this.unsigned) : n === 32 ? fromBits$2(this.high, 0, this.unsigned) : fromBits$2(this.high >>> n - 32, 0, this.unsigned);
};
LongPrototype$2.shru = LongPrototype$2.shiftRightUnsigned;
LongPrototype$2.shr_u = LongPrototype$2.shiftRightUnsigned;
LongPrototype$2.rotateLeft = function e(n) {
  var o;
  return isLong$2(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n === 32 ? fromBits$2(this.high, this.low, this.unsigned) : n < 32 ? (o = 32 - n, fromBits$2(this.low << n | this.high >>> o, this.high << n | this.low >>> o, this.unsigned)) : (n -= 32, o = 32 - n, fromBits$2(this.high << n | this.low >>> o, this.low << n | this.high >>> o, this.unsigned));
};
LongPrototype$2.rotl = LongPrototype$2.rotateLeft;
LongPrototype$2.rotateRight = function e(n) {
  var o;
  return isLong$2(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n === 32 ? fromBits$2(this.high, this.low, this.unsigned) : n < 32 ? (o = 32 - n, fromBits$2(this.high << o | this.low >>> n, this.low << o | this.high >>> n, this.unsigned)) : (n -= 32, o = 32 - n, fromBits$2(this.low << o | this.high >>> n, this.high << o | this.low >>> n, this.unsigned));
};
LongPrototype$2.rotr = LongPrototype$2.rotateRight;
LongPrototype$2.toSigned = function e() {
  return this.unsigned ? fromBits$2(this.low, this.high, !1) : this;
};
LongPrototype$2.toUnsigned = function e() {
  return this.unsigned ? this : fromBits$2(this.low, this.high, !0);
};
LongPrototype$2.toBytes = function e(n) {
  return n ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype$2.toBytesLE = function e() {
  var n = this.high, o = this.low;
  return [
    o & 255,
    o >>> 8 & 255,
    o >>> 16 & 255,
    o >>> 24,
    n & 255,
    n >>> 8 & 255,
    n >>> 16 & 255,
    n >>> 24
  ];
};
LongPrototype$2.toBytesBE = function e() {
  var n = this.high, o = this.low;
  return [
    n >>> 24,
    n >>> 16 & 255,
    n >>> 8 & 255,
    n & 255,
    o >>> 24,
    o >>> 16 & 255,
    o >>> 8 & 255,
    o & 255
  ];
};
Long$2.fromBytes = function e(n, o, u) {
  return u ? Long$2.fromBytesLE(n, o) : Long$2.fromBytesBE(n, o);
};
Long$2.fromBytesLE = function e(n, o) {
  return new Long$2(
    n[0] | n[1] << 8 | n[2] << 16 | n[3] << 24,
    n[4] | n[5] << 8 | n[6] << 16 | n[7] << 24,
    o
  );
};
Long$2.fromBytesBE = function e(n, o) {
  return new Long$2(
    n[4] << 24 | n[5] << 16 | n[6] << 8 | n[7],
    n[0] << 24 | n[1] << 16 | n[2] << 8 | n[3],
    o
  );
};
const long$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Long$2
}, Symbol.toStringTag, { value: "Module" })), require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(long$2);
var config = {}, _a$1;
Object.defineProperty(config, "__esModule", { value: !0 });
config.defaultSnapOrigin = void 0;
config.defaultSnapOrigin = (_a$1 = browser$1$1.env.SNAP_ORIGIN) !== null && _a$1 !== void 0 ? _a$1 : "npm:@leapwallet/metamask-cosmos-snap";
var chainInfo = {};
Object.defineProperty(chainInfo, "__esModule", { value: !0 });
const Chains = {
  "eightball-1": {
    chainId: "eightball-1",
    chainName: "8ball",
    bech32Config: {
      bech32PrefixAccAddr: "8ball"
    },
    bip44: {
      coinType: 118
    },
    denom: "uebl",
    decimals: 6
  },
  "agoric-3": {
    chainId: "agoric-3",
    chainName: "agoric",
    bech32Config: {
      bech32PrefixAccAddr: "agoric"
    },
    bip44: {
      coinType: 564
    },
    denom: "ubld",
    decimals: 6
  },
  "akashnet-2": {
    chainId: "akashnet-2",
    chainName: "akash",
    bech32Config: {
      bech32PrefixAccAddr: "akash"
    },
    bip44: {
      coinType: 118
    },
    denom: "uakt",
    decimals: 6
  },
  "archway-1": {
    chainId: "archway-1",
    chainName: "archway",
    bech32Config: {
      bech32PrefixAccAddr: "archway"
    },
    bip44: {
      coinType: 118
    },
    denom: "aarch",
    decimals: 18
  },
  arkh: {
    chainId: "arkh",
    chainName: "arkh",
    bech32Config: {
      bech32PrefixAccAddr: "arkh"
    },
    bip44: {
      coinType: 118
    },
    denom: "arkh",
    decimals: 6
  },
  "xstaxy-1": {
    chainId: "xstaxy-1",
    chainName: "aura",
    bech32Config: {
      bech32PrefixAccAddr: "aura"
    },
    bip44: {
      coinType: 118
    },
    denom: "uaura",
    decimals: 6
  },
  "axelar-dojo-1": {
    chainId: "axelar-dojo-1",
    chainName: "axelar",
    bech32Config: {
      bech32PrefixAccAddr: "axelar"
    },
    bip44: {
      coinType: 118
    },
    denom: "uaxl",
    decimals: 6
  },
  "laozi-mainnet": {
    chainId: "laozi-mainnet",
    chainName: "bandchain",
    bech32Config: {
      bech32PrefixAccAddr: "band"
    },
    bip44: {
      coinType: 494
    },
    denom: "uband",
    decimals: 6
  },
  "beezee-1": {
    chainId: "beezee-1",
    chainName: "beezee",
    bech32Config: {
      bech32PrefixAccAddr: "bze"
    },
    bip44: {
      coinType: 118
    },
    denom: "ubze",
    decimals: 6
  },
  "bitcanna-1": {
    chainId: "bitcanna-1",
    chainName: "bitcanna",
    bech32Config: {
      bech32PrefixAccAddr: "bcna"
    },
    bip44: {
      coinType: 118
    },
    denom: "ubcna",
    decimals: 6
  },
  "bitsong-2b": {
    chainId: "bitsong-2b",
    chainName: "bitsong",
    bech32Config: {
      bech32PrefixAccAddr: "bitsong"
    },
    bip44: {
      coinType: 639
    },
    denom: "ubtsg",
    decimals: 6
  },
  "bluzelle-9": {
    chainId: "bluzelle-9",
    chainName: "bluzelle",
    bech32Config: {
      bech32PrefixAccAddr: "bluzelle"
    },
    bip44: {
      coinType: 483
    },
    denom: "ubnt",
    decimals: 6
  },
  bostrom: {
    chainId: "bostrom",
    chainName: "bostrom",
    bech32Config: {
      bech32PrefixAccAddr: "bostrom"
    },
    bip44: {
      coinType: 118
    },
    denom: "boot",
    decimals: 0
  },
  "carbon-1": {
    chainId: "carbon-1",
    chainName: "carbon",
    bech32Config: {
      bech32PrefixAccAddr: "swth"
    },
    bip44: {
      coinType: 118
    },
    denom: "swth",
    decimals: 8
  },
  "perun-1": {
    chainId: "perun-1",
    chainName: "chain4energy",
    bech32Config: {
      bech32PrefixAccAddr: "c4e"
    },
    bip44: {
      coinType: 4444
    },
    denom: "uc4e",
    decimals: 6
  },
  "cheqd-mainnet-1": {
    chainId: "cheqd-mainnet-1",
    chainName: "cheqd",
    bech32Config: {
      bech32PrefixAccAddr: "cheqd"
    },
    bip44: {
      coinType: 118
    },
    denom: "ncheq",
    decimals: 9
  },
  "morocco-1": {
    chainId: "morocco-1",
    chainName: "chronicnetwork",
    bech32Config: {
      bech32PrefixAccAddr: "chronic"
    },
    bip44: {
      coinType: 118
    },
    denom: "ucht",
    decimals: 6
  },
  "comdex-1": {
    chainId: "comdex-1",
    chainName: "comdex",
    bech32Config: {
      bech32PrefixAccAddr: "comdex"
    },
    bip44: {
      coinType: 118
    },
    denom: "ucmdx",
    decimals: 6
  },
  "commercio-3": {
    chainId: "commercio-3",
    chainName: "commercionetwork",
    bech32Config: {
      bech32PrefixAccAddr: "did:com:"
    },
    bip44: {
      coinType: 701
    },
    denom: "ucommercio",
    decimals: 6
  },
  "centauri-1": {
    chainId: "centauri-1",
    chainName: "composable",
    bech32Config: {
      bech32PrefixAccAddr: "centauri"
    },
    bip44: {
      coinType: 118
    },
    denom: "ppica",
    decimals: 12
  },
  "coreum-mainnet-1": {
    chainId: "coreum-mainnet-1",
    chainName: "coreum",
    bech32Config: {
      bech32PrefixAccAddr: "core"
    },
    bip44: {
      coinType: 990
    },
    denom: "ucore",
    decimals: 6
  },
  "cosmoshub-4": {
    chainId: "cosmoshub-4",
    chainName: "cosmoshub",
    bech32Config: {
      bech32PrefixAccAddr: "cosmos"
    },
    bip44: {
      coinType: 118
    },
    denom: "uatom",
    decimals: 6
  },
  "crescent-1": {
    chainId: "crescent-1",
    chainName: "crescent",
    bech32Config: {
      bech32PrefixAccAddr: "cre"
    },
    bip44: {
      coinType: 118
    },
    denom: "ucre",
    decimals: 6
  },
  "crypto-org-chain-mainnet-1": {
    chainId: "crypto-org-chain-mainnet-1",
    chainName: "cryptoorgchain",
    bech32Config: {
      bech32PrefixAccAddr: "cro"
    },
    bip44: {
      coinType: 394
    },
    denom: "basecro",
    decimals: 8
  },
  "cudos-1": {
    chainId: "cudos-1",
    chainName: "cudos",
    bech32Config: {
      bech32PrefixAccAddr: "cudos"
    },
    bip44: {
      coinType: 118
    },
    denom: "acudos",
    decimals: 18
  },
  "mainnet-3": {
    chainId: "mainnet-3",
    chainName: "decentr",
    bech32Config: {
      bech32PrefixAccAddr: "decentr"
    },
    bip44: {
      coinType: 118
    },
    denom: "udec",
    decimals: 6
  },
  "desmos-mainnet": {
    chainId: "desmos-mainnet",
    chainName: "desmos",
    bech32Config: {
      bech32PrefixAccAddr: "desmos"
    },
    bip44: {
      coinType: 852
    },
    denom: "udsm",
    decimals: 6
  },
  "dig-1": {
    chainId: "dig-1",
    chainName: "dig",
    bech32Config: {
      bech32PrefixAccAddr: "dig"
    },
    bip44: {
      coinType: 118
    },
    denom: "udig",
    decimals: 6
  },
  "dyson-mainnet-01": {
    chainId: "dyson-mainnet-01",
    chainName: "dyson",
    bech32Config: {
      bech32PrefixAccAddr: "dys"
    },
    bip44: {
      coinType: 118
    },
    denom: "dys",
    decimals: 0
  },
  "emoney-3": {
    chainId: "emoney-3",
    chainName: "emoney",
    bech32Config: {
      bech32PrefixAccAddr: "emoney"
    },
    bip44: {
      coinType: 118
    },
    denom: "ungm",
    decimals: 6
  },
  "empowerchain-1": {
    chainId: "empowerchain-1",
    chainName: "empowerchain",
    bech32Config: {
      bech32PrefixAccAddr: "empower"
    },
    bip44: {
      coinType: 118
    },
    denom: "umpwr",
    decimals: 6
  },
  "fetchhub-4": {
    chainId: "fetchhub-4",
    chainName: "fetchhub",
    bech32Config: {
      bech32PrefixAccAddr: "fetch"
    },
    bip44: {
      coinType: 118
    },
    denom: "afet",
    decimals: 18
  },
  "colosseum-1": {
    chainId: "colosseum-1",
    chainName: "firmachain",
    bech32Config: {
      bech32PrefixAccAddr: "firma"
    },
    bip44: {
      coinType: 7777777
    },
    denom: "ufct",
    decimals: 6
  },
  "galaxy-1": {
    chainId: "galaxy-1",
    chainName: "galaxy",
    bech32Config: {
      bech32PrefixAccAddr: "galaxy"
    },
    bip44: {
      coinType: 118
    },
    denom: "uglx",
    decimals: 6
  },
  "genesis_29-2": {
    chainId: "genesis_29-2",
    chainName: "genesisl1",
    bech32Config: {
      bech32PrefixAccAddr: "genesis"
    },
    bip44: {
      coinType: 118
    },
    denom: "el1",
    decimals: 18
  },
  gitopia: {
    chainId: "gitopia",
    chainName: "gitopia",
    bech32Config: {
      bech32PrefixAccAddr: "gitopia"
    },
    bip44: {
      coinType: 118
    },
    denom: "ulore",
    decimals: 6
  },
  "gravity-bridge-3": {
    chainId: "gravity-bridge-3",
    chainName: "gravitybridge",
    bech32Config: {
      bech32PrefixAccAddr: "gravity"
    },
    bip44: {
      coinType: 118
    },
    denom: "ugraviton",
    decimals: 6
  },
  Antora: {
    chainId: "Antora",
    chainName: "idep",
    bech32Config: {
      bech32PrefixAccAddr: "idep"
    },
    bip44: {
      coinType: 118
    },
    denom: "idep",
    decimals: 6
  },
  "ixo-5": {
    chainId: "ixo-5",
    chainName: "impacthub",
    bech32Config: {
      bech32PrefixAccAddr: "ixo"
    },
    bip44: {
      coinType: 118
    },
    denom: "uixo",
    decimals: 6
  },
  "irishub-1": {
    chainId: "irishub-1",
    chainName: "irisnet",
    bech32Config: {
      bech32PrefixAccAddr: "iaa"
    },
    bip44: {
      coinType: 118
    },
    denom: "uiris",
    decimals: 6
  },
  "jackal-1": {
    chainId: "jackal-1",
    chainName: "jackal",
    bech32Config: {
      bech32PrefixAccAddr: "jkl"
    },
    bip44: {
      coinType: 118
    },
    denom: "ujkl",
    decimals: 6
  },
  "juno-1": {
    chainId: "juno-1",
    chainName: "juno",
    bech32Config: {
      bech32PrefixAccAddr: "juno"
    },
    bip44: {
      coinType: 118
    },
    denom: "ujuno",
    decimals: 6
  },
  "kava_2222-10": {
    chainId: "kava_2222-10",
    chainName: "kava",
    bech32Config: {
      bech32PrefixAccAddr: "kava"
    },
    bip44: {
      coinType: 459
    },
    denom: "ukava",
    decimals: 6
  },
  "kichain-2": {
    chainId: "kichain-2",
    chainName: "kichain",
    bech32Config: {
      bech32PrefixAccAddr: "ki"
    },
    bip44: {
      coinType: 118
    },
    denom: "uxki",
    decimals: 6
  },
  "kaiyo-1": {
    chainId: "kaiyo-1",
    chainName: "kujira",
    bech32Config: {
      bech32PrefixAccAddr: "kujira"
    },
    bip44: {
      coinType: 118
    },
    denom: "ukuji",
    decimals: 6
  },
  "kyve-1": {
    chainId: "kyve-1",
    chainName: "kyve",
    bech32Config: {
      bech32PrefixAccAddr: "kyve"
    },
    bip44: {
      coinType: 118
    },
    denom: "ukyve",
    decimals: 6
  },
  "likecoin-mainnet-2": {
    chainId: "likecoin-mainnet-2",
    chainName: "likecoin",
    bech32Config: {
      bech32PrefixAccAddr: "like"
    },
    bip44: {
      coinType: 118
    },
    denom: "nanolike",
    decimals: 9
  },
  "loyal-main-02": {
    chainId: "loyal-main-02",
    chainName: "loyal",
    bech32Config: {
      bech32PrefixAccAddr: "loyal"
    },
    bip44: {
      coinType: 118
    },
    denom: "ulyl",
    decimals: 6
  },
  LumenX: {
    chainId: "LumenX",
    chainName: "lumenx",
    bech32Config: {
      bech32PrefixAccAddr: "lumen"
    },
    bip44: {
      coinType: 118
    },
    denom: "ulumen",
    decimals: 6
  },
  "lum-network-1": {
    chainId: "lum-network-1",
    chainName: "lumnetwork",
    bech32Config: {
      bech32PrefixAccAddr: "lum"
    },
    bip44: {
      coinType: 880
    },
    denom: "ulum",
    decimals: 6
  },
  "mars-1": {
    chainId: "mars-1",
    chainName: "mars",
    bech32Config: {
      bech32PrefixAccAddr: "mars"
    },
    bip44: {
      coinType: 118
    },
    denom: "umars",
    decimals: 6
  },
  "mayachain-mainnet-v1": {
    chainId: "mayachain-mainnet-v1",
    chainName: "mayachain",
    bech32Config: {
      bech32PrefixAccAddr: "maya"
    },
    bip44: {
      coinType: 931
    },
    denom: "cacao",
    decimals: 10
  },
  "meme-1": {
    chainId: "meme-1",
    chainName: "meme",
    bech32Config: {
      bech32PrefixAccAddr: "meme"
    },
    bip44: {
      coinType: 118
    },
    denom: "umeme",
    decimals: 6
  },
  "migaloo-1": {
    chainId: "migaloo-1",
    chainName: "migaloo",
    bech32Config: {
      bech32PrefixAccAddr: "migaloo"
    },
    bip44: {
      coinType: 118
    },
    denom: "uwhale",
    decimals: 6
  },
  mainnet: {
    chainId: "mainnet",
    chainName: "mises",
    bech32Config: {
      bech32PrefixAccAddr: "mises"
    },
    bip44: {
      coinType: 118
    },
    denom: "umis",
    decimals: 6
  },
  "mun-1": {
    chainId: "mun-1",
    chainName: "mun",
    bech32Config: {
      bech32PrefixAccAddr: "mun"
    },
    bip44: {
      coinType: 118
    },
    denom: "umun",
    decimals: 6
  },
  "neutron-1": {
    chainId: "neutron-1",
    chainName: "neutron",
    bech32Config: {
      bech32PrefixAccAddr: "neutron"
    },
    bip44: {
      coinType: 118
    },
    denom: "untrn",
    decimals: 6
  },
  "noble-1": {
    chainId: "noble-1",
    chainName: "noble",
    bech32Config: {
      bech32PrefixAccAddr: "noble"
    },
    bip44: {
      coinType: 118
    },
    denom: "ustake",
    decimals: 6
  },
  "nois-1": {
    chainId: "nois-1",
    chainName: "nois",
    bech32Config: {
      bech32PrefixAccAddr: "nois"
    },
    bip44: {
      coinType: 118
    },
    denom: "unois",
    decimals: 6
  },
  "pirin-1": {
    chainId: "pirin-1",
    chainName: "nolus",
    bech32Config: {
      bech32PrefixAccAddr: "nolus"
    },
    bip44: {
      coinType: 118
    },
    denom: "unls",
    decimals: 6
  },
  nyx: {
    chainId: "nyx",
    chainName: "nyx",
    bech32Config: {
      bech32PrefixAccAddr: "n"
    },
    bip44: {
      coinType: 118
    },
    denom: "unyx",
    decimals: 6
  },
  octa: {
    chainId: "octa",
    chainName: "octa",
    bech32Config: {
      bech32PrefixAccAddr: "octa"
    },
    bip44: {
      coinType: 118
    },
    denom: "uocta",
    decimals: 6
  },
  "odin-mainnet-freya": {
    chainId: "odin-mainnet-freya",
    chainName: "odin",
    bech32Config: {
      bech32PrefixAccAddr: "odin"
    },
    bip44: {
      coinType: 118
    },
    denom: "loki",
    decimals: 6
  },
  "omniflixhub-1": {
    chainId: "omniflixhub-1",
    chainName: "omniflixhub",
    bech32Config: {
      bech32PrefixAccAddr: "omniflix"
    },
    bip44: {
      coinType: 118
    },
    denom: "uflix",
    decimals: 6
  },
  "onomy-mainnet-1": {
    chainId: "onomy-mainnet-1",
    chainName: "onomy",
    bech32Config: {
      bech32PrefixAccAddr: "onomy"
    },
    bip44: {
      coinType: 118
    },
    denom: "anom",
    decimals: 18
  },
  Oraichain: {
    chainId: "Oraichain",
    chainName: "oraichain",
    bech32Config: {
      bech32PrefixAccAddr: "orai"
    },
    bip44: {
      coinType: 118
    },
    denom: "orai",
    decimals: 6
  },
  "osmosis-1": {
    chainId: "osmosis-1",
    chainName: "osmosis",
    bech32Config: {
      bech32PrefixAccAddr: "osmo"
    },
    bip44: {
      coinType: 118
    },
    denom: "uosmo",
    decimals: 6
  },
  "panacea-3": {
    chainId: "panacea-3",
    chainName: "panacea",
    bech32Config: {
      bech32PrefixAccAddr: "panacea"
    },
    bip44: {
      coinType: 371
    },
    denom: "umed",
    decimals: 6
  },
  "passage-2": {
    chainId: "passage-2",
    chainName: "passage",
    bech32Config: {
      bech32PrefixAccAddr: "pasg"
    },
    bip44: {
      coinType: 118
    },
    denom: "upasg",
    decimals: 6
  },
  "passage-1": {
    chainId: "passage-1",
    chainName: "passage1",
    bech32Config: {
      bech32PrefixAccAddr: "pasg"
    },
    bip44: {
      coinType: 118
    },
    denom: "upasg",
    decimals: 6
  },
  "core-1": {
    chainId: "core-1",
    chainName: "persistence",
    bech32Config: {
      bech32PrefixAccAddr: "persistence"
    },
    bip44: {
      coinType: 118
    },
    denom: "uxprt",
    decimals: 6
  },
  "pio-mainnet-1": {
    chainId: "pio-mainnet-1",
    chainName: "provenance",
    bech32Config: {
      bech32PrefixAccAddr: "pb"
    },
    bip44: {
      coinType: 505
    },
    denom: "nhash",
    decimals: 9
  },
  "quasar-1": {
    chainId: "quasar-1",
    chainName: "quasar",
    bech32Config: {
      bech32PrefixAccAddr: "quasar"
    },
    bip44: {
      coinType: 118
    },
    denom: "uqsr",
    decimals: 6
  },
  "quicksilver-2": {
    chainId: "quicksilver-2",
    chainName: "quicksilver",
    bech32Config: {
      bech32PrefixAccAddr: "quick"
    },
    bip44: {
      coinType: 118
    },
    denom: "uqck",
    decimals: 6
  },
  "qwoyn-1": {
    chainId: "qwoyn-1",
    chainName: "qwoyn",
    bech32Config: {
      bech32PrefixAccAddr: "qwoyn"
    },
    bip44: {
      coinType: 118
    },
    denom: "uqwoyn",
    decimals: 6
  },
  "reb_1111-1": {
    chainId: "reb_1111-1",
    chainName: "rebus",
    bech32Config: {
      bech32PrefixAccAddr: "rebus"
    },
    bip44: {
      coinType: 118
    },
    denom: "arebus",
    decimals: 18
  },
  "regen-1": {
    chainId: "regen-1",
    chainName: "regen",
    bech32Config: {
      bech32PrefixAccAddr: "regen"
    },
    bip44: {
      coinType: 118
    },
    denom: "uregen",
    decimals: 6
  },
  "titan-1": {
    chainId: "titan-1",
    chainName: "rizon",
    bech32Config: {
      bech32PrefixAccAddr: "rizon"
    },
    bip44: {
      coinType: 118
    },
    denom: "uatolo",
    decimals: 6
  },
  "secret-4": {
    chainId: "secret-4",
    chainName: "secretnetwork",
    bech32Config: {
      bech32PrefixAccAddr: "secret"
    },
    bip44: {
      coinType: 529
    },
    denom: "uscrt",
    decimals: 6
  },
  "pacific-1": {
    chainId: "pacific-1",
    chainName: "sei",
    bech32Config: {
      bech32PrefixAccAddr: "sei"
    },
    bip44: {
      coinType: 118
    },
    denom: "usei",
    decimals: 6
  },
  "sentinelhub-2": {
    chainId: "sentinelhub-2",
    chainName: "sentinel",
    bech32Config: {
      bech32PrefixAccAddr: "sent"
    },
    bip44: {
      coinType: 118
    },
    denom: "udvpn",
    decimals: 6
  },
  "ShareRing-VoyagerNet": {
    chainId: "ShareRing-VoyagerNet",
    chainName: "shareledger",
    bech32Config: {
      bech32PrefixAccAddr: "shareledger"
    },
    bip44: {
      coinType: 118
    },
    denom: "nshr",
    decimals: 9
  },
  "shentu-2.2": {
    chainId: "shentu-2.2",
    chainName: "shentu",
    bech32Config: {
      bech32PrefixAccAddr: "certik"
    },
    bip44: {
      coinType: 118
    },
    denom: "uctk",
    decimals: 6
  },
  "sommelier-3": {
    chainId: "sommelier-3",
    chainName: "sommelier",
    bech32Config: {
      bech32PrefixAccAddr: "somm"
    },
    bip44: {
      coinType: 118
    },
    denom: "usomm",
    decimals: 6
  },
  "stafihub-1": {
    chainId: "stafihub-1",
    chainName: "stafihub",
    bech32Config: {
      bech32PrefixAccAddr: "stafi"
    },
    bip44: {
      coinType: 118
    },
    denom: "ufis",
    decimals: 6
  },
  "stargaze-1": {
    chainId: "stargaze-1",
    chainName: "stargaze",
    bech32Config: {
      bech32PrefixAccAddr: "stars"
    },
    bip44: {
      coinType: 118
    },
    denom: "ustars",
    decimals: 6
  },
  "iov-mainnet-ibc": {
    chainId: "iov-mainnet-ibc",
    chainName: "starname",
    bech32Config: {
      bech32PrefixAccAddr: "star"
    },
    bip44: {
      coinType: 234
    },
    denom: "uiov",
    decimals: 6
  },
  "stride-1": {
    chainId: "stride-1",
    chainName: "stride",
    bech32Config: {
      bech32PrefixAccAddr: "stride"
    },
    bip44: {
      coinType: 118
    },
    denom: "ustrd",
    decimals: 6
  },
  "teritori-1": {
    chainId: "teritori-1",
    chainName: "teritori",
    bech32Config: {
      bech32PrefixAccAddr: "tori"
    },
    bip44: {
      coinType: 118
    },
    denom: "utori",
    decimals: 6
  },
  "columbus-5": {
    chainId: "columbus-5",
    chainName: "terra",
    bech32Config: {
      bech32PrefixAccAddr: "terra"
    },
    bip44: {
      coinType: 330
    },
    denom: "uluna",
    decimals: 6
  },
  "phoenix-1": {
    chainId: "phoenix-1",
    chainName: "terra2",
    bech32Config: {
      bech32PrefixAccAddr: "terra"
    },
    bip44: {
      coinType: 330
    },
    denom: "uluna",
    decimals: 6
  },
  "tgrade-mainnet-1": {
    chainId: "tgrade-mainnet-1",
    chainName: "tgrade",
    bech32Config: {
      bech32PrefixAccAddr: "tgrade"
    },
    bip44: {
      coinType: 118
    },
    denom: "utgd",
    decimals: 6
  },
  "umee-1": {
    chainId: "umee-1",
    chainName: "umee",
    bech32Config: {
      bech32PrefixAccAddr: "umee"
    },
    bip44: {
      coinType: 118
    },
    denom: "uumee",
    decimals: 6
  },
  "FUND-MainNet-2": {
    chainId: "FUND-MainNet-2",
    chainName: "unification",
    bech32Config: {
      bech32PrefixAccAddr: "und"
    },
    bip44: {
      coinType: 5555
    },
    denom: "nund",
    decimals: 9
  },
  "ununifi-beta-v1": {
    chainId: "ununifi-beta-v1",
    chainName: "ununifi",
    bech32Config: {
      bech32PrefixAccAddr: "ununifi"
    },
    bip44: {
      coinType: 118
    },
    denom: "uguu",
    decimals: 6
  },
  "vidulum-1": {
    chainId: "vidulum-1",
    chainName: "vidulum",
    bech32Config: {
      bech32PrefixAccAddr: "vdl"
    },
    bip44: {
      coinType: 370
    },
    denom: "uvdl",
    decimals: 6
  }
};
chainInfo.default = Chains;
var gas = {}, __importDefault$g = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(gas, "__esModule", { value: !0 });
gas.toSmall = gas.getGasPriceForChainName = void 0;
const bignumber_js_1 = __importDefault$g(require$$0$1), defaultDecimals = 6, getGasPriceForChainName = async (e, n = "average") => {
  var o;
  const u = await fetch("https://assets.leapwallet.io/cosmos-registry/v1/gas/gas-prices.json");
  if (!u.ok)
    throw new Error(`Failed to get Gas price ${u.status}`);
  const c = await u.json();
  return console.log(c, e, n), (o = c == null ? void 0 : c[e]) === null || o === void 0 ? void 0 : o[n];
};
gas.getGasPriceForChainName = getGasPriceForChainName;
function toSmall(e, n = defaultDecimals) {
  return new bignumber_js_1.default(e).times(Math.pow(10, n)).toFixed().toString();
}
gas.toSmall = toSmall;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.experimentalSuggestChain = e.suggestChain = e.isLocalSnap = e.getKey = e.requestSignAmino = e.requestSignature = e.getSnap = e.connectSnap = e.getSnaps = void 0;
  const o = n(require$$0$1), u = n(require$$1$1), c = config, d = n(chainInfo), m = gas, v = async () => {
    let k = !1;
    if ("detected" in window.ethereum)
      for (const F of window.ethereum.detected)
        try {
          return await F.request({
            method: "wallet_getSnaps"
          }), window.ethereum.setProvider(F), k = !0, F;
        } catch {
        }
    if (!k && "providers" in window.ethereum)
      for (const F of window.ethereum.providers)
        try {
          return await F.request({
            method: "wallet_getSnaps"
          }), window.ethereum = F, k = !0, F;
        } catch {
        }
    return window.ethereum;
  }, S = async (k, F) => (await v()).request({
    method: "wallet_invokeSnap",
    params: {
      snapId: c.defaultSnapOrigin,
      request: {
        method: k,
        params: F
      }
    }
  }), $ = async () => await (await v()).request({
    method: "wallet_getSnaps"
  });
  e.getSnaps = $;
  const E = async (k = c.defaultSnapOrigin, F = {}) => (await v()).request({
    method: "wallet_requestSnaps",
    params: {
      [k]: F
    }
  });
  e.connectSnap = E;
  const O = async (k) => {
    try {
      const F = await (0, e.getSnaps)();
      return Object.values(F).find((X) => X.id === c.defaultSnapOrigin && (!k || X.version === k));
    } catch (F) {
      console.log("Failed to obtain installed snap", F);
      return;
    }
  };
  e.getSnap = O;
  const T = async (k, F, X) => {
    const ee = await S("signDirect", {
      chainId: k,
      signerAddress: F,
      signDoc: X
    }), { accountNumber: ue } = X, Q = new u.default((ue == null ? void 0 : ue.low) || 0, ue == null ? void 0 : ue.high, ue == null ? void 0 : ue.unsigned);
    return {
      signature: ee.signature,
      signed: Object.assign(Object.assign({}, ee.signed), { accountNumber: `${Q.toString()}`, authInfoBytes: new Uint8Array(Object.values(ee.signed.authInfoBytes)), bodyBytes: new Uint8Array(Object.values(ee.signed.bodyBytes)) })
    };
  };
  e.requestSignature = T;
  const y = async (k, F, X, ee) => {
    const { isADR36: ue = !1 } = ee || {};
    if (k !== X.chain_id)
      throw new Error("Chain ID does not match signer chain ID");
    const Q = d.default[k];
    if (!(ee != null && ee.preferNoSetFee) && Q && Q.denom) {
      const pe = await (0, m.getGasPriceForChainName)(Q.chainName), oe = "gasLimit" in X.fee ? X.fee.gasLimit : X.fee.gas;
      if (pe) {
        const ne = [
          {
            amount: new o.default(pe).multipliedBy(new o.default(oe)).decimalPlaces(0, 1).toString(),
            denom: Q.denom
          }
        ];
        X.fee.amount = ne;
      }
    }
    return await S("signAmino", {
      chainId: k,
      signerAddress: F,
      signDoc: X,
      isADR36: ue
    });
  };
  e.requestSignAmino = y;
  const V = async (k) => {
    const F = await S("getKey", {
      chainId: k
    });
    if (!F)
      throw new Error("No account data found");
    return F.pubkey = Uint8Array.from(Object.values(F.pubkey)), F;
  };
  e.getKey = V;
  const M = (k) => k.startsWith("local:");
  e.isLocalSnap = M;
  const G = async (k) => await S("suggestChain", {
    chainInfo: k
  });
  e.suggestChain = G, e.experimentalSuggestChain = e.suggestChain;
})(snap);
var types$2 = {};
Object.defineProperty(types$2, "__esModule", { value: !0 });
var cosmjsOfflineSigner = {};
Object.defineProperty(cosmjsOfflineSigner, "__esModule", { value: !0 });
cosmjsOfflineSigner.signArbitrary = cosmjsOfflineSigner.getOfflineSigner = cosmjsOfflineSigner.CosmjsOfflineSigner = void 0;
const snap_1 = snap;
class CosmjsOfflineSigner {
  constructor(n) {
    this.chainId = n;
  }
  async getAccounts() {
    const n = await (0, snap_1.getKey)(this.chainId);
    return [
      {
        address: n.address,
        algo: "secp256k1",
        pubkey: n.pubkey
      }
    ];
  }
  async signDirect(n, o) {
    if (this.chainId !== o.chainId)
      throw new Error("Chain ID does not match signer chain ID");
    if ((await this.getAccounts()).find((c) => c.address !== n))
      throw new Error("Signer address does not match wallet address");
    return (0, snap_1.requestSignature)(this.chainId, n, o);
  }
  // This has been added as a placeholder.
  async signAmino(n, o, u) {
    if (this.chainId !== o.chain_id)
      throw new Error("Chain ID does not match signer chain ID");
    if ((await this.getAccounts()).find((d) => d.address !== n))
      throw new Error("Signer address does not match wallet address");
    return (0, snap_1.requestSignAmino)(this.chainId, n, o, u);
  }
}
cosmjsOfflineSigner.CosmjsOfflineSigner = CosmjsOfflineSigner;
function getOfflineSigner(e) {
  return new CosmjsOfflineSigner(e);
}
cosmjsOfflineSigner.getOfflineSigner = getOfflineSigner;
async function signArbitrary(e, n, o) {
  const { signDoc: u } = getADR36SignDoc(n, o);
  return (await (0, snap_1.requestSignAmino)(e, n, u, {
    isADR36: !0,
    preferNoSetFee: !0
  })).signature;
}
cosmjsOfflineSigner.signArbitrary = signArbitrary;
function getADR36SignDoc(e, n) {
  let o = !1, u = "";
  return typeof n == "string" ? (u = Buffer.from(n).toString("base64"), o = !0) : u = Buffer.from(n).toString("base64"), { signDoc: {
    chain_id: "",
    account_number: "0",
    sequence: "0",
    fee: {
      gas: "0",
      amount: []
    },
    msgs: [
      {
        type: "sign/MsgSignData",
        value: {
          signer: e,
          b64Data: u
        }
      }
    ],
    memo: ""
  }, isADR36WithString: o };
}
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(u, c, d, m) {
    m === void 0 && (m = d);
    var v = Object.getOwnPropertyDescriptor(c, d);
    (!v || ("get" in v ? !c.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
      return c[d];
    } }), Object.defineProperty(u, m, v);
  } : function(u, c, d, m) {
    m === void 0 && (m = d), u[m] = c[d];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(u, c) {
    for (var d in u)
      d !== "default" && !Object.prototype.hasOwnProperty.call(c, d) && n(c, u, d);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), o(snap, e), o(types$2, e), o(cosmjsOfflineSigner, e);
})(dist);
class MetamaskSnapWallet {
  // aminoTypes = new AminoTypes( {...createDefaultAminoConverters(), ...createWasmAminoConverters()});
  constructor(n, o) {
    fi(this, "name");
    fi(this, "chainId");
    fi(this, "registry");
    fi(this, "prefix");
    this.chainId = n.chainId || "cosmoshub", this.registry = o, this.prefix = n.prefix || "cosmos";
  }
  async getAccounts() {
    return await dist.getSnap().catch(() => {
      throw new Error("Metamask snap not installed");
    }) || await dist.connectSnap(), [await dist.getKey(this.chainId)];
  }
  async supportCoinType(n) {
    return !0;
  }
  async sign(n) {
    const o = await this.getAccounts(), u = build$V.toHex(build$V.fromBech32(n.signerAddress).data), c = o.find(
      (V) => build$V.toHex(build$V.fromBech32(V.address).data) === u
    );
    if (!c)
      throw new Error("Failed to retrieve account from signer");
    const d = Any$1.fromPartial({
      typeUrl: keyType(n.chainId),
      value: PubKey$3.encode({
        key: new Uint8Array(Object.values(c.pubkey))
      }).finish()
    }), m = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: n.messages,
        memo: n.memo
      }
    }, v = this.registry.encode(m), S = Number(n.fee.gas), $ = build$Q.makeAuthInfoBytes(
      [{ pubkey: d, sequence: n.signerData.sequence }],
      n.fee.amount,
      S,
      n.fee.granter,
      n.fee.payer
    ), E = build$Q.makeSignDoc(
      v,
      $,
      n.chainId,
      n.signerData.accountNumber
    ), O = new dist.CosmjsOfflineSigner(this.chainId), { signature: T, signed: y } = await O.signDirect(n.signerAddress, E);
    return tx$p.TxRaw.fromPartial({
      bodyBytes: y.bodyBytes,
      authInfoBytes: y.authInfoBytes,
      signatures: [build$V.fromBase64(T.signature)]
    });
  }
}
class LeapWallet {
  constructor(n, o) {
    fi(this, "name");
    fi(this, "chainId");
    fi(this, "registry");
    fi(this, "conf");
    fi(this, "signer");
    fi(this, "aminoTypes", new build$S.AminoTypes({
      ...build$S.createDefaultAminoConverters(),
      ...build$o.createWasmAminoConverters()
    }));
    if (this.chainId = n.chainId || "cosmoshub", !window.getOfflineSigner || !window.leap)
      throw new Error("Please install Leap extension");
    this.registry = o, this.conf = n;
  }
  async getAccounts() {
    return await window.leap.enable(this.chainId), this.signer = await window.leap.getOfflineSigner(this.chainId), await this.signer.getAccounts();
  }
  supportCoinType(n) {
    return Promise.resolve(!0);
  }
  isEthermint() {
    return this.conf.hdPath && this.conf.hdPath.startsWith("m/44'/60");
  }
  async sign(n) {
    return this.signAmino(n);
  }
  // @deprecated use signAmino instead
  // because signDirect is not supported ledger wallet
  async signDirect(n) {
    const o = await this.getAccounts(), u = build$V.toHex(build$V.fromBech32(n.signerAddress).data), c = o.find(
      (y) => build$V.toHex(build$V.fromBech32(y.address).data) === u
    );
    if (!c)
      throw new Error("Failed to retrieve account from signer");
    const d = Any$1.fromPartial({
      typeUrl: keyType(n.chainId),
      value: PubKey$3.encode({
        key: c.pubkey
      }).finish()
    }), m = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: n.messages,
        memo: n.memo
      }
    }, v = this.registry.encode(m), S = Number(n.fee.gas), $ = build$Q.makeAuthInfoBytes(
      [{ pubkey: d, sequence: n.signerData.sequence }],
      n.fee.amount,
      S,
      n.fee.granter,
      n.fee.payer
    ), E = build$Q.makeSignDoc(
      v,
      $,
      n.chainId,
      n.signerData.accountNumber
    ), { signature: O, signed: T } = await this.signer.signDirect(
      n.signerAddress,
      E
    );
    return tx$p.TxRaw.fromPartial({
      bodyBytes: T.bodyBytes,
      authInfoBytes: T.authInfoBytes,
      signatures: [build$V.fromBase64(O.signature)]
    });
  }
  async signAmino(n) {
    const o = await this.getAccounts(), u = build$V.toHex(build$V.fromBech32(n.signerAddress).data), c = o.find(
      (k) => build$V.toHex(build$V.fromBech32(k.address).data) === u
    );
    if (!c)
      throw new Error("Failed to retrieve account from signer");
    const d = Any$1.fromPartial({
      typeUrl: keyType(n.chainId),
      value: PubKey$3.encode({
        key: c.pubkey
      }).finish()
    }), m = signing$3.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, v = n.messages.map((k) => this.aminoTypes.toAmino(k)), S = build$P.makeSignDoc(
      v,
      n.fee,
      n.chainId,
      n.memo,
      n.signerData.accountNumber,
      n.signerData.sequence
    ), { signature: $, signed: E } = await this.signer.signAmino(
      n.signerAddress,
      S
    );
    console.log($, "signature", E);
    const T = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: E.msgs.map((k) => this.aminoTypes.fromAmino(k)),
        memo: E.memo
      }
    }, y = this.registry.encode(
      T
    ), V = Number(E.fee.gas), M = Number(E.sequence), G = build$Q.makeAuthInfoBytes(
      [{ pubkey: d, sequence: M }],
      E.fee.amount,
      V,
      E.fee.granter,
      E.fee.payer,
      m
    );
    return tx$p.TxRaw.fromPartial({
      bodyBytes: y,
      authInfoBytes: G,
      signatures: [build$V.fromBase64($.signature)]
    });
  }
}
class Owallet {
  constructor(n, o) {
    // @ts-ignore
    fi(this, "name");
    fi(this, "chainId");
    fi(this, "registry");
    fi(this, "conf");
    fi(this, "aminoTypes", new build$S.AminoTypes({
      ...build$S.createDefaultAminoConverters(),
      ...build$o.createWasmAminoConverters()
    }));
    if (this.chainId = n.chainId || "cosmoshub", !window.getOfflineSigner || !window.owallet)
      throw new Error("Please install owallet extension");
    this.registry = o, this.conf = n;
  }
  async getAccounts() {
    return await window.owallet.enable(this.chainId), window.owallet.getOfflineSigner(this.chainId).getAccounts();
  }
  supportCoinType(n) {
    return Promise.resolve(!0);
  }
  isEthermint() {
    return this.conf.hdPath && this.conf.hdPath.startsWith("m/44'/60");
  }
  async sign(n) {
    return n.messages.findIndex(
      (o) => o.typeUrl.startsWith("/cosmwasm.wasm")
    ) > -1 ? this.signDirect(n) : this.signAmino(n);
  }
  // @deprecated use signAmino instead
  // because signDirect is not supported ledger wallet
  async signDirect(n) {
    const o = await this.getAccounts(), u = build$V.toHex(build$V.fromBech32(n.signerAddress).data), c = o.find(
      (V) => build$V.toHex(build$V.fromBech32(V.address).data) === u
    );
    if (!c)
      throw new Error("Failed to retrieve account from signer");
    const d = Any$1.fromPartial({
      typeUrl: keyType(n.chainId),
      value: PubKey$3.encode({
        key: c.pubkey
      }).finish()
    }), m = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: n.messages,
        memo: n.memo
      }
    }, v = this.registry.encode(m), S = Number(n.fee.gas), $ = build$Q.makeAuthInfoBytes(
      [{ pubkey: d, sequence: n.signerData.sequence }],
      n.fee.amount,
      S,
      n.fee.granter,
      n.fee.payer
    ), E = build$Q.makeSignDoc(
      v,
      $,
      n.chainId,
      n.signerData.accountNumber
    ), O = window.owallet.getOfflineSigner(this.chainId), { signature: T, signed: y } = await O.signDirect(
      n.signerAddress,
      E
    );
    return tx$p.TxRaw.fromPartial({
      bodyBytes: y.bodyBytes,
      authInfoBytes: y.authInfoBytes,
      signatures: [build$V.fromBase64(T.signature)]
    });
  }
  async signAmino(n) {
    const o = await this.getAccounts(), u = build$V.toHex(build$V.fromBech32(n.signerAddress).data), c = o.find(
      (F) => build$V.toHex(build$V.fromBech32(F.address).data) === u
    );
    if (!c)
      throw new Error("Failed to retrieve account from signer");
    const d = Any$1.fromPartial({
      typeUrl: keyType(n.chainId),
      value: PubKey$3.encode({
        key: c.pubkey
      }).finish()
    }), m = signing$3.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, v = n.messages.map((F) => this.aminoTypes.toAmino(F)), S = build$P.makeSignDoc(
      v,
      n.fee,
      n.chainId,
      n.memo,
      n.signerData.accountNumber,
      n.signerData.sequence
    ), $ = window.owallet.getOfflineSigner(this.chainId), { signature: E, signed: O } = await $.signAmino(
      n.signerAddress,
      S
    ), y = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: O.msgs.map((F) => this.aminoTypes.fromAmino(F)),
        memo: O.memo
      }
    }, V = this.registry.encode(
      y
    ), M = Number(O.fee.gas), G = Number(O.sequence), k = build$Q.makeAuthInfoBytes(
      [{ pubkey: d, sequence: G }],
      O.fee.amount,
      M,
      O.fee.granter,
      O.fee.payer,
      m
    );
    return tx$p.TxRaw.fromPartial({
      bodyBytes: V,
      authInfoBytes: k,
      signatures: [build$V.fromBase64(E.signature)]
    });
  }
  async getCosmWasmClient(n, o, u) {
    const c = {
      broadcastPollIntervalMs: 600,
      gasPrice: build$S.GasPrice.fromString(`${o}${u}`)
    }, d = await build$y.Tendermint37Client.connect(n), m = window.owallet.getOfflineSigner(this.chainId);
    return await build$o.SigningCosmWasmClient.createWithSigner(
      d,
      m,
      c
    );
  }
  async signAndBroadcast(n, o, u, c, d, m, v) {
    return console.log("signAndBroadcast signAndBroadcast"), await (await this.getCosmWasmClient(
      u,
      c,
      d
    )).signAndBroadcast(
      n,
      o,
      {
        amount: [
          {
            amount: c,
            denom: d
          }
        ],
        gas: m
      },
      v
    );
  }
}
var WalletName = /* @__PURE__ */ ((e) => (e.Owallet = "Owallet", e.Keplr = "Keplr", e.Ledger = "LedgerUSB", e.LedgerBLE = "LedgerBLE", e.Metamask = "Metamask", e.MetamaskSnap = "MetamaskSnap", e.Leap = "Leap", e.Address = "Address", e.NameService = "Nameservice", e))(WalletName || {});
const DEFAULT_HDPATH = "m/44'/118/0'/0/0";
function keyType(e) {
  switch (!0) {
    case e.search(/\w+_\d+-\d+/g) > -1:
      return "/ethermint.crypto.v1.ethsecp256k1.PubKey";
    case e.startsWith("injective"):
      return "/injective.crypto.v1beta1.ethsecp256k1.PubKey";
    default:
      return "/cosmos.crypto.secp256k1.PubKey";
  }
}
function readWallet(e) {
  return JSON.parse(
    localStorage.getItem(e || DEFAULT_HDPATH) || "{}"
  );
}
function writeWallet(e, n) {
  localStorage.setItem(n || DEFAULT_HDPATH, JSON.stringify(e));
}
function removeWallet(e) {
  localStorage.removeItem(e || DEFAULT_HDPATH);
}
function extractChainId(e) {
  const n = e.indexOf("_"), o = e.indexOf("-");
  return o > n && n > 0 ? Number(e.substring(n + 1, o)) : 0;
}
function createWallet(e, n, o) {
  const u = o || new build$Q.Registry(build$S.defaultRegistryTypes);
  switch (e) {
    case "Owallet":
      return new Owallet(n, u);
    case "Keplr":
      return new KeplerWallet(n, u);
    case "LedgerUSB":
      return new LedgerWallet(n, u);
    case "Leap":
      return new LeapWallet(n, u);
    case "MetamaskSnap":
      return new MetamaskSnapWallet(n, u);
    case "Metamask":
      return n.hdPath && (n.hdPath.startsWith("m/44/60") || n.hdPath.startsWith("m/44'/60")) ? new MetamaskWallet(n, u) : new MetamaskSnapWallet(n, u);
  }
  throw new Error("No wallet connected");
}
class UniClient {
  constructor(n, o) {
    fi(this, "registry");
    fi(this, "wallet");
    this.registry = new build$Q.Registry([...build$S.defaultRegistryTypes, ...modules$1.wasmTypes]), this.wallet = createWallet(n, o, this.registry);
  }
  async getAccounts() {
    return this.wallet.getAccounts();
  }
  async sign(n) {
    return this.wallet.sign(n);
  }
  async simulate(n, o) {
    var V;
    const u = Any$1.fromPartial({
      typeUrl: "/cosmos.crypto.ed25519.PubKey",
      value: new Uint8Array()
    }), c = {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: {
        messages: o.messages,
        memo: o.memo
      }
    }, d = this.registry.encode(c), m = Number(o.fee.gas), v = build$Q.makeAuthInfoBytes(
      [{ pubkey: u, sequence: o.signerData.sequence }],
      o.fee.amount,
      m,
      o.fee.granter,
      o.fee.payer
    ), S = tx$p.TxRaw.fromPartial({
      bodyBytes: d,
      authInfoBytes: v,
      signatures: [new Uint8Array()]
    }), $ = createQueryClient(n), E = service.SimulateRequest.fromPartial({
      txBytes: tx$p.TxRaw.encode(S).finish()
    }), O = build$S.createProtobufRpcClient($), y = await new service.ServiceClientImpl(O).Simulate(E);
    return Number((V = y.gasInfo) == null ? void 0 : V.gasUsed);
  }
  // async simulate2(
  //     endpoint: string,
  //     messages: readonly EncodeObject[],
  //     memo: string | undefined,
  //     sequence: number
  // ) {
  //     const [first] = await this.wallet.getAccounts()
  //     const pubkey = encodeSecp256k1Pubkey(first.pubkey);
  //     const anyMsgs = messages.map((m) => this.registry.encodeAsAny(m));
  //     const url = `${endpoint}/cosmos/tx/v1beta1/simulate`
  //     const tx = Tx.fromPartial({
  //         authInfo: AuthInfo.fromPartial({
  //           fee: Fee.fromPartial({}),
  //           signerInfos: [
  //             {
  //               publicKey: encodePubkey(pubkey),
  //               sequence: sequence,
  //               modeInfo: { single: { mode: SignMode.SIGN_MODE_UNSPECIFIED } },
  //             },
  //           ],
  //         }),
  //         body: TxBody.fromPartial({
  //           messages: Array.from(anyMsgs),
  //           memo: memo,
  //         }),
  //         signatures: [new Uint8Array()],
  //       });
  //     const request = SimulateRequest.fromPartial({
  //         tx
  //         // txBytes: Tx.encode(tx).finish(),
  //     });
  //     console.log(tx, request)
  //     return await post(url, request)
  // }
  async broadcastTx(n, o) {
    const u = createTmClient(n), c = Uint8Array.from(tx$p.TxRaw.encode(o).finish());
    return await u.broadcastTxSync({
      tx: c
    });
  }
}
class TokenUnitConverter {
  constructor(n) {
    fi(this, "metadata");
    this.metadata = n || {};
  }
  addMetadata(n, o) {
    this.metadata[n] = o;
  }
  baseToDisplay(n, o = 6) {
    const u = this.metadata[n.denom];
    if (!u)
      return n;
    const c = u.denomUnits.find(
      (m) => m.denom === u.display
    );
    return c ? {
      amount: BigNumber(Number(n.amount)).div(
        BigNumber(10).pow(c.exponent)
      ).toFixed(o),
      denom: c.denom.toUpperCase()
    } : n;
  }
  baseToUnit(n, o, u = 6) {
    const c = this.metadata[n.denom];
    if (!c)
      return n;
    const d = c.denomUnits.find((v) => v.denom === o);
    if (!d)
      return n;
    const m = BigNumber(Number(n.amount)).div(
      BigNumber(10).pow(d.exponent)
    );
    return {
      amount: parseFloat(m.toFixed(u)).toString(),
      denom: d.denom
    };
  }
  displayToBase(n, o) {
    const u = this.metadata[n];
    if (!u)
      return o;
    const c = u.denomUnits.find(
      (m) => m.denom === o.denom
    );
    return c ? {
      amount: BigNumber(Number(o.amount)).times(
        BigNumber(10).pow(c.exponent)
      ).toFixed(),
      denom: n
    } : o;
  }
}
const _hoisted_1$i = { class: "form-control" }, _hoisted_2$i = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$i = ["value"], _hoisted_4$f = { class: "form-control" }, _hoisted_5$g = { class: "label" }, _hoisted_6$g = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Validator", -1), _hoisted_7$f = /* @__PURE__ */ createBaseVNode("option", { value: "" }, "Select a validator", -1), _hoisted_8$f = ["value"], _hoisted_9$d = { key: 0 }, _hoisted_10$d = { class: "form-control" }, _hoisted_11$a = { class: "label" }, _hoisted_12$a = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Amount", -1), _hoisted_13$9 = { class: "join" }, _hoisted_14$9 = { class: "w-full relative flex justify-center items-center" }, _hoisted_15$8 = ["placeholder"], _hoisted_16$8 = { class: "text-white" }, _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "Delegate",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    balances: Object,
    metadata: Object,
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref(""), d = ref([]), m = ref([]), v = ref(""), S = ref(""), $ = ref(""), E = ref(""), O = computed(() => {
      const F = new TokenUnitConverter(o.metadata);
      return [
        {
          typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
          value: {
            delegatorAddress: o.sender,
            validatorAddress: c.value,
            amount: F.displayToBase(v.value, {
              amount: String($.value),
              denom: E.value
            })
          }
        }
      ];
    }), T = computed(() => [...d.value, ...m.value]), y = computed(() => {
      var ee;
      const F = new TokenUnitConverter(o.metadata), X = ((ee = o.balances) == null ? void 0 : ee.find(
        (ue) => ue.denom === v.value
      )) || { amount: "0", denom: v.value };
      return {
        base: X,
        display: F.baseToUnit(X, E.value)
      };
    });
    function V() {
      getInactiveValidators(o.endpoint).then((F) => {
        m.value = F.validators;
      });
    }
    const M = computed(() => {
      if (!o.metadata || !o.metadata[v.value])
        return E.value = v.value, [{ denom: v.value, exponent: 0, aliases: [] }];
      const F = o.metadata[v.value].denomUnits.sort(
        (X, ee) => ee.exponent - X.exponent
      );
      return F.length > 0 && (E.value = F[0].denom), F;
    }), G = computed(() => {
      let F = !0, X = "";
      return c.value || (F = !1, X = "Validator is empty"), Number($.value) > 0 || (F = !1, X = "Amount should be great than 0"), E.value || (F = !1, X = "Amount Denom is empty"), { ok: F, error: X };
    });
    function k() {
      d.value = [], c.value = u.value.validator_address, getStakingParam(o.endpoint).then((F) => {
        v.value = F.params.bondDenom, S.value = fromTimestamp_1(
          F.params.unbondingTime
        ).toDateString();
      }), getActiveValidators(o.endpoint).then((F) => {
        var X;
        d.value = F.validators, u.value.validator_address || (c.value = ((X = F.validators.find(
          (ee) => ee.description.identity === "6783E9F948541962"
        )) == null ? void 0 : X.operatorAddress) ?? "");
      });
    }
    return n({ msgs: O, isValid: G, initial: k }), (F, X) => {
      var ee, ue, Q;
      return openBlock(), createElementBlock("div", null, [
        createBaseVNode("div", _hoisted_1$i, [
          _hoisted_2$i,
          createBaseVNode("input", {
            value: e.sender,
            type: "text",
            class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
          }, null, 8, _hoisted_3$i)
        ]),
        createBaseVNode("div", _hoisted_4$f, [
          createBaseVNode("label", _hoisted_5$g, [
            _hoisted_6$g,
            createBaseVNode("a", {
              class: "label-text",
              onClick: X[0] || (X[0] = (Y) => V())
            }, "Show Inactive")
          ]),
          withDirectives(createBaseVNode("select", {
            "onUpdate:modelValue": X[1] || (X[1] = (Y) => c.value = Y),
            class: "select select-bordered text-white"
          }, [
            _hoisted_7$f,
            (openBlock(!0), createElementBlock(Fragment, null, renderList(T.value, (Y) => (openBlock(), createElementBlock("option", {
              value: Y.operatorAddress
            }, [
              createTextVNode(toDisplayString(Y.description.moniker) + " (" + toDisplayString(Number(unref(decimal2percent)(Y.commission.commissionRates.rate)) / 1e18) + "%) ", 1),
              Y.status !== unref(staking$6.BondStatus).BOND_STATUS_BONDED ? (openBlock(), createElementBlock("span", _hoisted_9$d, "x")) : createCommentVNode("", !0)
            ], 8, _hoisted_8$f))), 256))
          ], 512), [
            [vModelSelect, c.value]
          ])
        ]),
        createBaseVNode("div", _hoisted_10$d, [
          createBaseVNode("label", _hoisted_11$a, [
            _hoisted_12$a,
            createBaseVNode("span", null, toDisplayString((ee = y.value) == null ? void 0 : ee.display.amount) + " " + toDisplayString((ue = y.value) == null ? void 0 : ue.display.denom), 1)
          ]),
          createBaseVNode("label", _hoisted_13$9, [
            createBaseVNode("div", _hoisted_14$9, [
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": X[2] || (X[2] = (Y) => $.value = Y),
                type: "number",
                placeholder: `Available: ${(Q = y.value) == null ? void 0 : Q.display.amount}`,
                class: "input border border-gray-300 dark:border-gray-600 w-full join-item text-white"
              }, null, 8, _hoisted_15$8), [
                [vModelText, $.value]
              ]),
              createBaseVNode("button", {
                class: "absolute right-2 p-1 z-10 bg-[rgb(46,46,51)] text-white hover:bg-[hsl(222,6%,43%)] text-sm",
                onClick: X[3] || (X[3] = (Y) => {
                  var pe;
                  return $.value = (pe = y.value) == null ? void 0 : pe.display.amount;
                })
              }, "Max")
            ]),
            withDirectives(createBaseVNode("select", {
              "onUpdate:modelValue": X[4] || (X[4] = (Y) => E.value = Y),
              class: "select select-bordered join-item text-white"
            }, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(M.value, (Y) => (openBlock(), createElementBlock("option", _hoisted_16$8, toDisplayString(Y.denom), 1))), 256))
            ], 512), [
              [vModelSelect, E.value]
            ])
          ])
        ])
      ]);
    };
  }
}), _hoisted_1$h = { class: "form-control" }, _hoisted_2$h = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$h = ["value"], _hoisted_4$e = { class: "form-control" }, _hoisted_5$f = { class: "label" }, _hoisted_6$f = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Amount", -1), _hoisted_7$e = { class: "input-group" }, _hoisted_8$e = ["placeholder"], _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "Deposit",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    balances: Object,
    metadata: Object,
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref(""), d = ref(""), m = ref(""), v = computed(() => {
      var V;
      const T = new TokenUnitConverter(o.metadata), y = ((V = o.balances) == null ? void 0 : V.find((M) => M.denom === c.value)) || {
        amount: "0",
        denom: c.value
      };
      return {
        base: y,
        display: T.baseToUnit(y, m.value)
      };
    }), S = computed(() => {
      const T = new TokenUnitConverter(o.metadata);
      return [
        {
          typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
          value: {
            depositor: o.sender,
            proposalId: u.value.proposal_id,
            amount: [
              T.displayToBase(c.value, {
                amount: String(d.value),
                denom: m.value
              })
            ]
          }
        }
      ];
    }), $ = computed(() => {
      if (!o.metadata || !o.metadata[c.value])
        return m.value = c.value, [{ denom: c.value, exponent: 0, aliases: [] }];
      const T = o.metadata[c.value].denomUnits.sort(
        (y, V) => V.exponent - y.exponent
      );
      return T.length > 0 && (m.value = T[0].denom), T;
    }), E = computed(() => {
      let T = !0, y = "";
      return u.value.proposal_id || (T = !1, y = "Proposal id is empty"), Number(d.value) > 0 || (T = !1, y = "Amount should be great than 0"), { ok: T, error: y };
    });
    function O() {
      getStakingParam(o.endpoint).then((T) => {
        c.value = T.params.bondDenom;
      });
    }
    return n({ msgs: S, isValid: E, initial: O }), (T, y) => {
      var V, M, G;
      return openBlock(), createElementBlock("div", null, [
        createBaseVNode("div", _hoisted_1$h, [
          _hoisted_2$h,
          createBaseVNode("input", {
            value: e.sender,
            type: "text",
            class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
          }, null, 8, _hoisted_3$h)
        ]),
        createBaseVNode("div", _hoisted_4$e, [
          createBaseVNode("label", _hoisted_5$f, [
            _hoisted_6$f,
            createBaseVNode("span", null, toDisplayString((V = v.value) == null ? void 0 : V.display.amount) + toDisplayString((M = v.value) == null ? void 0 : M.display.denom), 1)
          ]),
          createBaseVNode("label", _hoisted_7$e, [
            withDirectives(createBaseVNode("input", {
              "onUpdate:modelValue": y[0] || (y[0] = (k) => d.value = k),
              type: "number",
              placeholder: `Available: ${(G = v.value) == null ? void 0 : G.display.amount}`,
              class: "input border border-gray-300 dark:border-gray-600 w-full"
            }, null, 8, _hoisted_8$e), [
              [vModelText, d.value]
            ]),
            withDirectives(createBaseVNode("select", {
              "onUpdate:modelValue": y[1] || (y[1] = (k) => m.value = k),
              class: "select select-bordered"
            }, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList($.value, (k) => (openBlock(), createElementBlock("option", null, toDisplayString(k.denom), 1))), 256))
            ], 512), [
              [vModelSelect, m.value]
            ])
          ])
        ])
      ]);
    };
  }
}), _hoisted_1$g = { class: "form-control" }, _hoisted_2$g = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$g = ["value"], _hoisted_4$d = { class: "form-control" }, _hoisted_5$e = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Source Validator")
], -1), _hoisted_6$e = ["value"], _hoisted_7$d = { class: "form-control" }, _hoisted_8$d = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Destination Validator")
], -1), _hoisted_9$c = /* @__PURE__ */ createBaseVNode("option", { value: "" }, "Select a validator", -1), _hoisted_10$c = ["value"], _hoisted_11$9 = { key: 0 }, _hoisted_12$9 = { class: "form-control" }, _hoisted_13$8 = { class: "label" }, _hoisted_14$8 = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Amount", -1), _hoisted_15$7 = { class: "join" }, _hoisted_16$7 = { class: "w-full relative flex justify-center items-center" }, _hoisted_17$6 = ["placeholder"], _hoisted_18$6 = { class: "text-white" }, _hoisted_19$5 = { class: "text-error" }, _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "Redelegate",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    balances: Object,
    metadata: Object,
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref(""), d = ref([]), m = ref([]), v = ref(""), S = ref(""), $ = ref(""), E = ref({}), O = ref(""), T = computed(() => {
      const X = d.value.find(
        // @ts-ignore
        (ee) => ee.operatorAddress === u.validator_address
      );
      return X ? `${X.description.moniker} (${decimal2percent(
        X.commission.commissionRates.rate
      )}%)` : u.value.validator_address;
    }), y = computed(() => {
      var ee;
      const X = new TokenUnitConverter(o.metadata);
      return [
        {
          typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
          value: {
            delegatorAddress: o.sender,
            validatorSrcAddress: u.value.validator_address,
            validatorDstAddress: c.value,
            amount: X.displayToBase(((ee = E.value) == null ? void 0 : ee.denom) ?? "", {
              amount: String(S.value),
              denom: $.value
            })
          }
        }
      ];
    }), V = computed(() => [...d.value, ...m.value]), M = computed(() => {
      const X = new TokenUnitConverter(o.metadata), ee = E.value || { amount: "0", denom: v.value };
      return {
        base: ee,
        display: X.baseToUnit(ee, $.value)
      };
    }), G = computed(() => {
      if (!o.metadata || !o.metadata[v.value])
        return $.value = v.value, [{ denom: v.value, exponent: 0, aliases: [] }];
      const X = o.metadata[v.value].denomUnits.sort(
        (ee, ue) => ue.exponent - ee.exponent
      );
      return X.length > 0 && ($.value = X[0].denom), X;
    }), k = computed(() => {
      let X = !0, ee = "";
      return c.value || (X = !1, ee = "Validator is empty"), c.value || (X = !1, ee = "Validator is empty"), Number(S.value) > 0 || (X = !1, ee = "Amount should be great than 0"), { ok: X, error: ee };
    });
    function F() {
      getDelegations(o.endpoint, u.value.validator_address, o.sender).then((X) => {
        var ee;
        E.value = (ee = X.delegationResponse) == null ? void 0 : ee.balance;
      }).catch((X) => {
        O.value = X;
      }), getStakingParam(o.endpoint).then((X) => {
        v.value = X.params.bondDenom;
      }), getActiveValidators(o.endpoint).then((X) => {
        var ee;
        d.value = X.validators, c.value = ((ee = X.validators.find(
          (ue) => ue.description.identity === "6783E9F948541962"
        )) == null ? void 0 : ee.operatorAddress) ?? "";
      });
    }
    return n({ msgs: y, isValid: k, initial: F }), (X, ee) => {
      var ue, Q;
      return openBlock(), createElementBlock("div", null, [
        createBaseVNode("div", _hoisted_1$g, [
          _hoisted_2$g,
          createBaseVNode("input", {
            value: e.sender,
            type: "text",
            class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
          }, null, 8, _hoisted_3$g)
        ]),
        createBaseVNode("div", _hoisted_4$d, [
          _hoisted_5$e,
          createBaseVNode("input", {
            value: T.value,
            type: "text",
            class: "input border border-gray-300 dark:border-gray-600 text-white",
            readonly: ""
          }, null, 8, _hoisted_6$e)
        ]),
        createBaseVNode("div", _hoisted_7$d, [
          _hoisted_8$d,
          withDirectives(createBaseVNode("select", {
            "onUpdate:modelValue": ee[0] || (ee[0] = (Y) => c.value = Y),
            class: "select select-bordered text-white"
          }, [
            _hoisted_9$c,
            (openBlock(!0), createElementBlock(Fragment, null, renderList(V.value, (Y) => (openBlock(), createElementBlock("option", {
              value: Y.operatorAddress
            }, [
              createTextVNode(toDisplayString(Y.description.moniker) + " (" + toDisplayString(Number(unref(decimal2percent)(Y.commission.commissionRates.rate)) / 1e18) + "%) ", 1),
              Y.status !== unref(staking$6.BondStatus).BOND_STATUS_BONDED ? (openBlock(), createElementBlock("span", _hoisted_11$9, "x")) : createCommentVNode("", !0)
            ], 8, _hoisted_10$c))), 256))
          ], 512), [
            [vModelSelect, c.value]
          ])
        ]),
        createBaseVNode("div", _hoisted_12$9, [
          createBaseVNode("label", _hoisted_13$8, [
            _hoisted_14$8,
            createBaseVNode("span", null, toDisplayString((ue = M.value) == null ? void 0 : ue.display.amount), 1)
          ]),
          createBaseVNode("label", _hoisted_15$7, [
            createBaseVNode("div", _hoisted_16$7, [
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": ee[1] || (ee[1] = (Y) => S.value = Y),
                type: "number",
                placeholder: `Available: ${(Q = M.value) == null ? void 0 : Q.display.amount}`,
                class: "input border border-gray-300 dark:border-gray-600 w-full join-item text-white"
              }, null, 8, _hoisted_17$6), [
                [vModelText, S.value]
              ]),
              createBaseVNode("button", {
                class: "absolute right-2 p-1 z-10 bg-[rgb(46,46,51)] text-white hover:bg-[hsl(222,6%,43%)] text-sm",
                onClick: ee[2] || (ee[2] = (Y) => {
                  var pe;
                  return S.value = (pe = M.value) == null ? void 0 : pe.display.amount;
                })
              }, "Max")
            ]),
            withDirectives(createBaseVNode("select", {
              "onUpdate:modelValue": ee[3] || (ee[3] = (Y) => $.value = Y),
              class: "select select-bordered join-item text-white"
            }, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(G.value, (Y) => (openBlock(), createElementBlock("option", _hoisted_18$6, toDisplayString(Y.denom), 1))), 256))
            ], 512), [
              [vModelSelect, $.value]
            ])
          ])
        ]),
        createBaseVNode("div", _hoisted_19$5, toDisplayString(O.value), 1)
      ]);
    };
  }
}), _hoisted_1$f = { class: "dark:text-gray-400" }, _hoisted_2$f = { class: "form-control" }, _hoisted_3$f = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_4$c = ["value"], _hoisted_5$d = { class: "form-control" }, _hoisted_6$d = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Balances")
], -1), _hoisted_7$c = /* @__PURE__ */ createBaseVNode("option", { value: "" }, "Select a token", -1), _hoisted_8$c = ["value"], _hoisted_9$b = { class: "form-control" }, _hoisted_10$b = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Recipient")
], -1), _hoisted_11$8 = { class: "form-control" }, _hoisted_12$8 = { class: "label" }, _hoisted_13$7 = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Amount", -1), _hoisted_14$7 = { class: "input-group" }, _hoisted_15$6 = ["placeholder"], _hoisted_16$6 = ["value"], _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "Send",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    balances: Object,
    metadata: Object,
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = ref(""), c = ref(""), d = ref(""), m = ref(""), v = computed(() => {
      const V = new TokenUnitConverter(o.metadata);
      return [
        {
          typeUrl: "/cosmos.bank.v1beta1.MsgSend",
          value: {
            fromAddress: o.sender,
            toAddress: c.value,
            amount: [
              V.displayToBase(d.value, {
                amount: String(u.value),
                denom: m.value
              })
            ]
          }
        }
      ];
    }), S = computed(() => {
      var G;
      const V = ((G = o.balances) == null ? void 0 : G.find((k) => k.denom === d.value)) || {
        amount: "0",
        denom: "-"
      }, M = new TokenUnitConverter(o.metadata);
      return {
        base: V,
        display: M.baseToUnit(V, m.value)
      };
    }), $ = computed(() => {
      var M;
      const V = new TokenUnitConverter(o.metadata);
      return ((M = o.balances) == null ? void 0 : M.map((G) => ({
        base: G,
        display: V.baseToDisplay(G)
      }))) || [];
    }), E = computed(() => {
      if (!o.metadata || !o.metadata[d.value])
        return m.value = d.value, [{ denom: d.value, exponent: 0, aliases: [] }];
      const V = o.metadata[d.value].denomUnits.sort(
        (M, G) => G.exponent - M.exponent
      );
      return V.length > 0 && (m.value = V[0].denom), V;
    }), O = computed(() => {
      let V = !0, M = "";
      return c.value || (V = !1, M = "Recipient is empty"), Number(u.value) > 0 || (V = !1, M = "Amount should be great than 0"), { ok: V, error: M };
    });
    function T() {
      getStakingParam(o.endpoint).then((V) => {
        d.value = V.params.bondDenom;
      });
    }
    function y(V) {
      return String(V).substring(0, 10);
    }
    return n({ msgs: v, isValid: O, initial: T }), (V, M) => {
      var G;
      return openBlock(), createElementBlock("div", _hoisted_1$f, [
        createBaseVNode("div", _hoisted_2$f, [
          _hoisted_3$f,
          createBaseVNode("input", {
            value: e.sender,
            type: "text",
            class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
          }, null, 8, _hoisted_4$c)
        ]),
        createBaseVNode("div", _hoisted_5$d, [
          _hoisted_6$d,
          withDirectives(createBaseVNode("select", {
            "onUpdate:modelValue": M[0] || (M[0] = (k) => d.value = k),
            class: "select select-bordered"
          }, [
            _hoisted_7$c,
            (openBlock(!0), createElementBlock(Fragment, null, renderList($.value, ({ base: k, display: F }) => (openBlock(), createElementBlock("option", {
              value: k.denom
            }, toDisplayString(F.amount) + " " + toDisplayString(F.denom), 9, _hoisted_8$c))), 256))
          ], 512), [
            [vModelSelect, d.value]
          ])
        ]),
        createBaseVNode("div", _hoisted_9$b, [
          _hoisted_10$b,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": M[1] || (M[1] = (k) => c.value = k),
            type: "text",
            class: "input border border-gray-300 dark:border-gray-600"
          }, null, 512), [
            [vModelText, c.value]
          ])
        ]),
        createBaseVNode("div", _hoisted_11$8, [
          createBaseVNode("label", _hoisted_12$8, [
            _hoisted_13$7,
            createBaseVNode("span", null, toDisplayString(S.value.display.amount) + " " + toDisplayString(y(S.value.display.denom)), 1)
          ]),
          createBaseVNode("label", _hoisted_14$7, [
            withDirectives(createBaseVNode("input", {
              "onUpdate:modelValue": M[2] || (M[2] = (k) => u.value = k),
              type: "number",
              placeholder: `Available: ${(G = S.value) == null ? void 0 : G.display.amount}`,
              class: "input border border-gray-300 dark:border-gray-600 w-full"
            }, null, 8, _hoisted_15$6), [
              [vModelText, u.value]
            ]),
            withDirectives(createBaseVNode("select", {
              "onUpdate:modelValue": M[3] || (M[3] = (k) => m.value = k),
              class: "select select-bordered"
            }, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(E.value, (k) => (openBlock(), createElementBlock("option", {
                value: k.denom
              }, toDisplayString(y(k.denom)), 9, _hoisted_16$6))), 256))
            ], 512), [
              [vModelSelect, m.value]
            ])
          ])
        ])
      ]);
    };
  }
});
var browserPonyfill = { exports: {} };
(function(e, n) {
  var o = typeof self < "u" ? self : commonjsGlobal, u = function() {
    function d() {
      this.fetch = !1, this.DOMException = o.DOMException;
    }
    return d.prototype = o, new d();
  }();
  (function(d) {
    (function(m) {
      var v = {
        searchParams: "URLSearchParams" in d,
        iterable: "Symbol" in d && "iterator" in Symbol,
        blob: "FileReader" in d && "Blob" in d && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in d,
        arrayBuffer: "ArrayBuffer" in d
      };
      function S(P) {
        return P && DataView.prototype.isPrototypeOf(P);
      }
      if (v.arrayBuffer)
        var $ = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], E = ArrayBuffer.isView || function(P) {
          return P && $.indexOf(Object.prototype.toString.call(P)) > -1;
        };
      function O(P) {
        if (typeof P != "string" && (P = String(P)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(P))
          throw new TypeError("Invalid character in header field name");
        return P.toLowerCase();
      }
      function T(P) {
        return typeof P != "string" && (P = String(P)), P;
      }
      function y(P) {
        var J = {
          next: function() {
            var se = P.shift();
            return { done: se === void 0, value: se };
          }
        };
        return v.iterable && (J[Symbol.iterator] = function() {
          return J;
        }), J;
      }
      function V(P) {
        this.map = {}, P instanceof V ? P.forEach(function(J, se) {
          this.append(se, J);
        }, this) : Array.isArray(P) ? P.forEach(function(J) {
          this.append(J[0], J[1]);
        }, this) : P && Object.getOwnPropertyNames(P).forEach(function(J) {
          this.append(J, P[J]);
        }, this);
      }
      V.prototype.append = function(P, J) {
        P = O(P), J = T(J);
        var se = this.map[P];
        this.map[P] = se ? se + ", " + J : J;
      }, V.prototype.delete = function(P) {
        delete this.map[O(P)];
      }, V.prototype.get = function(P) {
        return P = O(P), this.has(P) ? this.map[P] : null;
      }, V.prototype.has = function(P) {
        return this.map.hasOwnProperty(O(P));
      }, V.prototype.set = function(P, J) {
        this.map[O(P)] = T(J);
      }, V.prototype.forEach = function(P, J) {
        for (var se in this.map)
          this.map.hasOwnProperty(se) && P.call(J, this.map[se], se, this);
      }, V.prototype.keys = function() {
        var P = [];
        return this.forEach(function(J, se) {
          P.push(se);
        }), y(P);
      }, V.prototype.values = function() {
        var P = [];
        return this.forEach(function(J) {
          P.push(J);
        }), y(P);
      }, V.prototype.entries = function() {
        var P = [];
        return this.forEach(function(J, se) {
          P.push([se, J]);
        }), y(P);
      }, v.iterable && (V.prototype[Symbol.iterator] = V.prototype.entries);
      function M(P) {
        if (P.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        P.bodyUsed = !0;
      }
      function G(P) {
        return new Promise(function(J, se) {
          P.onload = function() {
            J(P.result);
          }, P.onerror = function() {
            se(P.error);
          };
        });
      }
      function k(P) {
        var J = new FileReader(), se = G(J);
        return J.readAsArrayBuffer(P), se;
      }
      function F(P) {
        var J = new FileReader(), se = G(J);
        return J.readAsText(P), se;
      }
      function X(P) {
        for (var J = new Uint8Array(P), se = new Array(J.length), fe = 0; fe < J.length; fe++)
          se[fe] = String.fromCharCode(J[fe]);
        return se.join("");
      }
      function ee(P) {
        if (P.slice)
          return P.slice(0);
        var J = new Uint8Array(P.byteLength);
        return J.set(new Uint8Array(P)), J.buffer;
      }
      function ue() {
        return this.bodyUsed = !1, this._initBody = function(P) {
          this._bodyInit = P, P ? typeof P == "string" ? this._bodyText = P : v.blob && Blob.prototype.isPrototypeOf(P) ? this._bodyBlob = P : v.formData && FormData.prototype.isPrototypeOf(P) ? this._bodyFormData = P : v.searchParams && URLSearchParams.prototype.isPrototypeOf(P) ? this._bodyText = P.toString() : v.arrayBuffer && v.blob && S(P) ? (this._bodyArrayBuffer = ee(P.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : v.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(P) || E(P)) ? this._bodyArrayBuffer = ee(P) : this._bodyText = P = Object.prototype.toString.call(P) : this._bodyText = "", this.headers.get("content-type") || (typeof P == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : v.searchParams && URLSearchParams.prototype.isPrototypeOf(P) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, v.blob && (this.blob = function() {
          var P = M(this);
          if (P)
            return P;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? M(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(k);
        }), this.text = function() {
          var P = M(this);
          if (P)
            return P;
          if (this._bodyBlob)
            return F(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(X(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, v.formData && (this.formData = function() {
          return this.text().then(oe);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var Q = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function Y(P) {
        var J = P.toUpperCase();
        return Q.indexOf(J) > -1 ? J : P;
      }
      function pe(P, J) {
        J = J || {};
        var se = J.body;
        if (P instanceof pe) {
          if (P.bodyUsed)
            throw new TypeError("Already read");
          this.url = P.url, this.credentials = P.credentials, J.headers || (this.headers = new V(P.headers)), this.method = P.method, this.mode = P.mode, this.signal = P.signal, !se && P._bodyInit != null && (se = P._bodyInit, P.bodyUsed = !0);
        } else
          this.url = String(P);
        if (this.credentials = J.credentials || this.credentials || "same-origin", (J.headers || !this.headers) && (this.headers = new V(J.headers)), this.method = Y(J.method || this.method || "GET"), this.mode = J.mode || this.mode || null, this.signal = J.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && se)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(se);
      }
      pe.prototype.clone = function() {
        return new pe(this, { body: this._bodyInit });
      };
      function oe(P) {
        var J = new FormData();
        return P.trim().split("&").forEach(function(se) {
          if (se) {
            var fe = se.split("="), N = fe.shift().replace(/\+/g, " "), W = fe.join("=").replace(/\+/g, " ");
            J.append(decodeURIComponent(N), decodeURIComponent(W));
          }
        }), J;
      }
      function ne(P) {
        var J = new V(), se = P.replace(/\r?\n[\t ]+/g, " ");
        return se.split(/\r?\n/).forEach(function(fe) {
          var N = fe.split(":"), W = N.shift().trim();
          if (W) {
            var I = N.join(":").trim();
            J.append(W, I);
          }
        }), J;
      }
      ue.call(pe.prototype);
      function H(P, J) {
        J || (J = {}), this.type = "default", this.status = J.status === void 0 ? 200 : J.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in J ? J.statusText : "OK", this.headers = new V(J.headers), this.url = J.url || "", this._initBody(P);
      }
      ue.call(H.prototype), H.prototype.clone = function() {
        return new H(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new V(this.headers),
          url: this.url
        });
      }, H.error = function() {
        var P = new H(null, { status: 0, statusText: "" });
        return P.type = "error", P;
      };
      var C = [301, 302, 303, 307, 308];
      H.redirect = function(P, J) {
        if (C.indexOf(J) === -1)
          throw new RangeError("Invalid status code");
        return new H(null, { status: J, headers: { location: P } });
      }, m.DOMException = d.DOMException;
      try {
        new m.DOMException();
      } catch {
        m.DOMException = function(J, se) {
          this.message = J, this.name = se;
          var fe = Error(J);
          this.stack = fe.stack;
        }, m.DOMException.prototype = Object.create(Error.prototype), m.DOMException.prototype.constructor = m.DOMException;
      }
      function w(P, J) {
        return new Promise(function(se, fe) {
          var N = new pe(P, J);
          if (N.signal && N.signal.aborted)
            return fe(new m.DOMException("Aborted", "AbortError"));
          var W = new XMLHttpRequest();
          function I() {
            W.abort();
          }
          W.onload = function() {
            var te = {
              status: W.status,
              statusText: W.statusText,
              headers: ne(W.getAllResponseHeaders() || "")
            };
            te.url = "responseURL" in W ? W.responseURL : te.headers.get("X-Request-URL");
            var ge = "response" in W ? W.response : W.responseText;
            se(new H(ge, te));
          }, W.onerror = function() {
            fe(new TypeError("Network request failed"));
          }, W.ontimeout = function() {
            fe(new TypeError("Network request failed"));
          }, W.onabort = function() {
            fe(new m.DOMException("Aborted", "AbortError"));
          }, W.open(N.method, N.url, !0), N.credentials === "include" ? W.withCredentials = !0 : N.credentials === "omit" && (W.withCredentials = !1), "responseType" in W && v.blob && (W.responseType = "blob"), N.headers.forEach(function(te, ge) {
            W.setRequestHeader(ge, te);
          }), N.signal && (N.signal.addEventListener("abort", I), W.onreadystatechange = function() {
            W.readyState === 4 && N.signal.removeEventListener("abort", I);
          }), W.send(typeof N._bodyInit > "u" ? null : N._bodyInit);
        });
      }
      return w.polyfill = !0, d.fetch || (d.fetch = w, d.Headers = V, d.Request = pe, d.Response = H), m.Headers = V, m.Request = pe, m.Response = H, m.fetch = w, Object.defineProperty(m, "__esModule", { value: !0 }), m;
    })({});
  })(u), u.fetch.ponyfill = !0, delete u.fetch.polyfill;
  var c = u;
  n = c.fetch, n.default = c.fetch, n.fetch = c.fetch, n.Headers = c.Headers, n.Request = c.Request, n.Response = c.Response, e.exports = n;
})(browserPonyfill, browserPonyfill.exports);
var browserPonyfillExports = browserPonyfill.exports;
const fetch$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserPonyfillExports);
var __awaiter = globalThis && globalThis.__awaiter || function(e, n, o, u) {
  function c(d) {
    return d instanceof o ? d : new o(function(m) {
      m(d);
    });
  }
  return new (o || (o = Promise))(function(d, m) {
    function v(E) {
      try {
        $(u.next(E));
      } catch (O) {
        m(O);
      }
    }
    function S(E) {
      try {
        $(u.throw(E));
      } catch (O) {
        m(O);
      }
    }
    function $(E) {
      E.done ? d(E.value) : c(E.value).then(v, S);
    }
    $((u = u.apply(e, n || [])).next());
  });
};
class ChainRegistryClient {
  constructor(n = "https://registry.ping.pub") {
    this.endpoint = n;
  }
  getAny(n) {
    return __awaiter(this, void 0, void 0, function* () {
      return fetch$1(`${this.endpoint}${n}`).then((o) => o.json());
    });
  }
  get(n) {
    return __awaiter(this, void 0, void 0, function* () {
      return fetch$1(`${this.endpoint}${n}`).then((o) => o.json());
    });
  }
  fetchChainNames() {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.get("/")).filter((o) => o.type === "directory" && o.name !== "testnet" && !o.name.startsWith("_")).map((o) => o.name);
    });
  }
  fetchChainInfo(n) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.get(`/${n}/chain.json`);
    });
  }
  fetchAssetsList(n) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.get(`/${n}/assetlist.json`);
    });
  }
  fetchIBCPaths() {
    return __awaiter(this, void 0, void 0, function* () {
      const n = yield this.get("/_IBC/"), o = /([\w]+)-([\w]+)\.json/;
      return n.map((u) => {
        const c = u.name.match(o), d = {};
        return d.path = u.name, d.from = c[1], d.to = c[2], d;
      });
    });
  }
  fetchIBCPathInfo(n) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.get(`/_IBC/${n}`);
    });
  }
}
var dayjs_min = { exports: {} };
(function(e, n) {
  (function(o, u) {
    e.exports = u();
  })(commonjsGlobal, function() {
    var o = 1e3, u = 6e4, c = 36e5, d = "millisecond", m = "second", v = "minute", S = "hour", $ = "day", E = "week", O = "month", T = "quarter", y = "year", V = "date", M = "Invalid Date", G = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, k = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, F = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(w) {
      var P = ["th", "st", "nd", "rd"], J = w % 100;
      return "[" + w + (P[(J - 20) % 10] || P[J] || P[0]) + "]";
    } }, X = function(w, P, J) {
      var se = String(w);
      return !se || se.length >= P ? w : "" + Array(P + 1 - se.length).join(J) + w;
    }, ee = { s: X, z: function(w) {
      var P = -w.utcOffset(), J = Math.abs(P), se = Math.floor(J / 60), fe = J % 60;
      return (P <= 0 ? "+" : "-") + X(se, 2, "0") + ":" + X(fe, 2, "0");
    }, m: function w(P, J) {
      if (P.date() < J.date())
        return -w(J, P);
      var se = 12 * (J.year() - P.year()) + (J.month() - P.month()), fe = P.clone().add(se, O), N = J - fe < 0, W = P.clone().add(se + (N ? -1 : 1), O);
      return +(-(se + (J - fe) / (N ? fe - W : W - fe)) || 0);
    }, a: function(w) {
      return w < 0 ? Math.ceil(w) || 0 : Math.floor(w);
    }, p: function(w) {
      return { M: O, y, w: E, d: $, D: V, h: S, m: v, s: m, ms: d, Q: T }[w] || String(w || "").toLowerCase().replace(/s$/, "");
    }, u: function(w) {
      return w === void 0;
    } }, ue = "en", Q = {};
    Q[ue] = F;
    var Y = function(w) {
      return w instanceof H;
    }, pe = function w(P, J, se) {
      var fe;
      if (!P)
        return ue;
      if (typeof P == "string") {
        var N = P.toLowerCase();
        Q[N] && (fe = N), J && (Q[N] = J, fe = N);
        var W = P.split("-");
        if (!fe && W.length > 1)
          return w(W[0]);
      } else {
        var I = P.name;
        Q[I] = P, fe = I;
      }
      return !se && fe && (ue = fe), fe || !se && ue;
    }, oe = function(w, P) {
      if (Y(w))
        return w.clone();
      var J = typeof P == "object" ? P : {};
      return J.date = w, J.args = arguments, new H(J);
    }, ne = ee;
    ne.l = pe, ne.i = Y, ne.w = function(w, P) {
      return oe(w, { locale: P.$L, utc: P.$u, x: P.$x, $offset: P.$offset });
    };
    var H = function() {
      function w(J) {
        this.$L = pe(J.locale, null, !0), this.parse(J);
      }
      var P = w.prototype;
      return P.parse = function(J) {
        this.$d = function(se) {
          var fe = se.date, N = se.utc;
          if (fe === null)
            return /* @__PURE__ */ new Date(NaN);
          if (ne.u(fe))
            return /* @__PURE__ */ new Date();
          if (fe instanceof Date)
            return new Date(fe);
          if (typeof fe == "string" && !/Z$/i.test(fe)) {
            var W = fe.match(G);
            if (W) {
              var I = W[2] - 1 || 0, te = (W[7] || "0").substring(0, 3);
              return N ? new Date(Date.UTC(W[1], I, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, te)) : new Date(W[1], I, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, te);
            }
          }
          return new Date(fe);
        }(J), this.$x = J.x || {}, this.init();
      }, P.init = function() {
        var J = this.$d;
        this.$y = J.getFullYear(), this.$M = J.getMonth(), this.$D = J.getDate(), this.$W = J.getDay(), this.$H = J.getHours(), this.$m = J.getMinutes(), this.$s = J.getSeconds(), this.$ms = J.getMilliseconds();
      }, P.$utils = function() {
        return ne;
      }, P.isValid = function() {
        return this.$d.toString() !== M;
      }, P.isSame = function(J, se) {
        var fe = oe(J);
        return this.startOf(se) <= fe && fe <= this.endOf(se);
      }, P.isAfter = function(J, se) {
        return oe(J) < this.startOf(se);
      }, P.isBefore = function(J, se) {
        return this.endOf(se) < oe(J);
      }, P.$g = function(J, se, fe) {
        return ne.u(J) ? this[se] : this.set(fe, J);
      }, P.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, P.valueOf = function() {
        return this.$d.getTime();
      }, P.startOf = function(J, se) {
        var fe = this, N = !!ne.u(se) || se, W = ne.p(J), I = function(Qt, Et) {
          var zt = ne.w(fe.$u ? Date.UTC(fe.$y, Et, Qt) : new Date(fe.$y, Et, Qt), fe);
          return N ? zt : zt.endOf($);
        }, te = function(Qt, Et) {
          return ne.w(fe.toDate()[Qt].apply(fe.toDate("s"), (N ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Et)), fe);
        }, ge = this.$W, Pe = this.$M, Ke = this.$D, xe = "set" + (this.$u ? "UTC" : "");
        switch (W) {
          case y:
            return N ? I(1, 0) : I(31, 11);
          case O:
            return N ? I(1, Pe) : I(0, Pe + 1);
          case E:
            var ze = this.$locale().weekStart || 0, nt = (ge < ze ? ge + 7 : ge) - ze;
            return I(N ? Ke - nt : Ke + (6 - nt), Pe);
          case $:
          case V:
            return te(xe + "Hours", 0);
          case S:
            return te(xe + "Minutes", 1);
          case v:
            return te(xe + "Seconds", 2);
          case m:
            return te(xe + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, P.endOf = function(J) {
        return this.startOf(J, !1);
      }, P.$set = function(J, se) {
        var fe, N = ne.p(J), W = "set" + (this.$u ? "UTC" : ""), I = (fe = {}, fe[$] = W + "Date", fe[V] = W + "Date", fe[O] = W + "Month", fe[y] = W + "FullYear", fe[S] = W + "Hours", fe[v] = W + "Minutes", fe[m] = W + "Seconds", fe[d] = W + "Milliseconds", fe)[N], te = N === $ ? this.$D + (se - this.$W) : se;
        if (N === O || N === y) {
          var ge = this.clone().set(V, 1);
          ge.$d[I](te), ge.init(), this.$d = ge.set(V, Math.min(this.$D, ge.daysInMonth())).$d;
        } else
          I && this.$d[I](te);
        return this.init(), this;
      }, P.set = function(J, se) {
        return this.clone().$set(J, se);
      }, P.get = function(J) {
        return this[ne.p(J)]();
      }, P.add = function(J, se) {
        var fe, N = this;
        J = Number(J);
        var W = ne.p(se), I = function(Pe) {
          var Ke = oe(N);
          return ne.w(Ke.date(Ke.date() + Math.round(Pe * J)), N);
        };
        if (W === O)
          return this.set(O, this.$M + J);
        if (W === y)
          return this.set(y, this.$y + J);
        if (W === $)
          return I(1);
        if (W === E)
          return I(7);
        var te = (fe = {}, fe[v] = u, fe[S] = c, fe[m] = o, fe)[W] || 1, ge = this.$d.getTime() + J * te;
        return ne.w(ge, this);
      }, P.subtract = function(J, se) {
        return this.add(-1 * J, se);
      }, P.format = function(J) {
        var se = this, fe = this.$locale();
        if (!this.isValid())
          return fe.invalidDate || M;
        var N = J || "YYYY-MM-DDTHH:mm:ssZ", W = ne.z(this), I = this.$H, te = this.$m, ge = this.$M, Pe = fe.weekdays, Ke = fe.months, xe = function(Et, zt, Nt, pt) {
          return Et && (Et[zt] || Et(se, N)) || Nt[zt].slice(0, pt);
        }, ze = function(Et) {
          return ne.s(I % 12 || 12, Et, "0");
        }, nt = fe.meridiem || function(Et, zt, Nt) {
          var pt = Et < 12 ? "AM" : "PM";
          return Nt ? pt.toLowerCase() : pt;
        }, Qt = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: ge + 1, MM: ne.s(ge + 1, 2, "0"), MMM: xe(fe.monthsShort, ge, Ke, 3), MMMM: xe(Ke, ge), D: this.$D, DD: ne.s(this.$D, 2, "0"), d: String(this.$W), dd: xe(fe.weekdaysMin, this.$W, Pe, 2), ddd: xe(fe.weekdaysShort, this.$W, Pe, 3), dddd: Pe[this.$W], H: String(I), HH: ne.s(I, 2, "0"), h: ze(1), hh: ze(2), a: nt(I, te, !0), A: nt(I, te, !1), m: String(te), mm: ne.s(te, 2, "0"), s: String(this.$s), ss: ne.s(this.$s, 2, "0"), SSS: ne.s(this.$ms, 3, "0"), Z: W };
        return N.replace(k, function(Et, zt) {
          return zt || Qt[Et] || W.replace(":", "");
        });
      }, P.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, P.diff = function(J, se, fe) {
        var N, W = ne.p(se), I = oe(J), te = (I.utcOffset() - this.utcOffset()) * u, ge = this - I, Pe = ne.m(this, I);
        return Pe = (N = {}, N[y] = Pe / 12, N[O] = Pe, N[T] = Pe / 3, N[E] = (ge - te) / 6048e5, N[$] = (ge - te) / 864e5, N[S] = ge / c, N[v] = ge / u, N[m] = ge / o, N)[W] || ge, fe ? Pe : ne.a(Pe);
      }, P.daysInMonth = function() {
        return this.endOf(O).$D;
      }, P.$locale = function() {
        return Q[this.$L];
      }, P.locale = function(J, se) {
        if (!J)
          return this.$L;
        var fe = this.clone(), N = pe(J, se, !0);
        return N && (fe.$L = N), fe;
      }, P.clone = function() {
        return ne.w(this.$d, this);
      }, P.toDate = function() {
        return new Date(this.valueOf());
      }, P.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, P.toISOString = function() {
        return this.$d.toISOString();
      }, P.toString = function() {
        return this.$d.toUTCString();
      }, w;
    }(), C = H.prototype;
    return oe.prototype = C, [["$ms", d], ["$s", m], ["$m", v], ["$H", S], ["$W", $], ["$M", O], ["$y", y], ["$D", V]].forEach(function(w) {
      C[w[1]] = function(P) {
        return this.$g(P, w[0], w[1]);
      };
    }), oe.extend = function(w, P) {
      return w.$i || (w(P, H, oe), w.$i = !0), oe;
    }, oe.locale = pe, oe.isDayjs = Y, oe.unix = function(w) {
      return oe(1e3 * w);
    }, oe.en = Q[ue], oe.Ls = Q, oe.p = {}, oe;
  });
})(dayjs_min);
var dayjs_minExports = dayjs_min.exports;
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
var utc$1 = { exports: {} };
(function(e, n) {
  (function(o, u) {
    e.exports = u();
  })(commonjsGlobal, function() {
    var o = "minute", u = /[+-]\d\d(?::?\d\d)?/g, c = /([+-]|\d\d)/g;
    return function(d, m, v) {
      var S = m.prototype;
      v.utc = function(M) {
        var G = { date: M, utc: !0, args: arguments };
        return new m(G);
      }, S.utc = function(M) {
        var G = v(this.toDate(), { locale: this.$L, utc: !0 });
        return M ? G.add(this.utcOffset(), o) : G;
      }, S.local = function() {
        return v(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var $ = S.parse;
      S.parse = function(M) {
        M.utc && (this.$u = !0), this.$utils().u(M.$offset) || (this.$offset = M.$offset), $.call(this, M);
      };
      var E = S.init;
      S.init = function() {
        if (this.$u) {
          var M = this.$d;
          this.$y = M.getUTCFullYear(), this.$M = M.getUTCMonth(), this.$D = M.getUTCDate(), this.$W = M.getUTCDay(), this.$H = M.getUTCHours(), this.$m = M.getUTCMinutes(), this.$s = M.getUTCSeconds(), this.$ms = M.getUTCMilliseconds();
        } else
          E.call(this);
      };
      var O = S.utcOffset;
      S.utcOffset = function(M, G) {
        var k = this.$utils().u;
        if (k(M))
          return this.$u ? 0 : k(this.$offset) ? O.call(this) : this.$offset;
        if (typeof M == "string" && (M = function(ue) {
          ue === void 0 && (ue = "");
          var Q = ue.match(u);
          if (!Q)
            return null;
          var Y = ("" + Q[0]).match(c) || ["-", 0, 0], pe = Y[0], oe = 60 * +Y[1] + +Y[2];
          return oe === 0 ? 0 : pe === "+" ? oe : -oe;
        }(M), M === null))
          return this;
        var F = Math.abs(M) <= 16 ? 60 * M : M, X = this;
        if (G)
          return X.$offset = F, X.$u = M === 0, X;
        if (M !== 0) {
          var ee = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (X = this.local().add(F + ee, o)).$offset = F, X.$x.$localOffset = ee;
        } else
          X = this.utc();
        return X;
      };
      var T = S.format;
      S.format = function(M) {
        var G = M || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return T.call(this, G);
      }, S.valueOf = function() {
        var M = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * M;
      }, S.isUTC = function() {
        return !!this.$u;
      }, S.toISOString = function() {
        return this.toDate().toISOString();
      }, S.toString = function() {
        return this.toDate().toUTCString();
      };
      var y = S.toDate;
      S.toDate = function(M) {
        return M === "s" && this.$offset ? v(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : y.call(this);
      };
      var V = S.diff;
      S.diff = function(M, G, k) {
        if (M && this.$u === M.$u)
          return V.call(this, M, G, k);
        var F = this.local(), X = v(M).local();
        return V.call(F, X, G, k);
      };
    };
  });
})(utc$1);
var utcExports = utc$1.exports;
const utc = /* @__PURE__ */ getDefaultExportFromCjs(utcExports), _hoisted_1$e = { class: "form-control" }, _hoisted_2$e = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$e = ["value"], _hoisted_4$b = { class: "form-control" }, _hoisted_5$c = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Balances")
], -1), _hoisted_6$c = /* @__PURE__ */ createBaseVNode("option", { value: "" }, "Select a token", -1), _hoisted_7$b = ["value"], _hoisted_8$b = { class: "form-control" }, _hoisted_9$a = { class: "label" }, _hoisted_10$a = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Destination", -1), _hoisted_11$7 = {
  key: 0,
  class: "text-xs"
}, _hoisted_12$7 = ["disabled"], _hoisted_13$6 = /* @__PURE__ */ createBaseVNode("option", { value: "" }, "Select Destination", -1), _hoisted_14$6 = ["value"], _hoisted_15$5 = { class: "form-control" }, _hoisted_16$5 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Recipient")
], -1), _hoisted_17$5 = { class: "form-control" }, _hoisted_18$5 = { class: "label" }, _hoisted_19$4 = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Amount", -1), _hoisted_20$4 = { class: "input-group" }, _hoisted_21$4 = ["placeholder"], _hoisted_22$4 = ["value"], _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "Transfer",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    balances: Object,
    metadata: Object,
    params: String
  },
  setup(e, { expose: n }) {
    const o = e;
    dayjs.extend(utc);
    const u = computed(() => JSON.parse(o.params || "{}")), c = u.value.chain_name, d = ref(""), m = ref(""), v = ref(""), S = ref(""), $ = ref(""), E = ref([]), O = ref(
      {}
    ), T = ref({}), y = new ChainRegistryClient(), V = computed(() => {
      var ne, H;
      const pe = dayjs().add(1, "hour"), oe = new TokenUnitConverter(o.metadata);
      return [
        {
          typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
          value: {
            sourcePort: ((ne = O.value) == null ? void 0 : ne.port_id) || "",
            sourceChannel: ((H = O.value) == null ? void 0 : H.channel_id) || "",
            token: oe.displayToBase(S.value, {
              amount: String(d.value),
              denom: m.value
            }),
            sender: o.sender,
            receiver: v.value,
            timeoutTimestamp: String(pe.utc().valueOf() * 1e6)
          }
        }
      ];
    }), M = computed(() => {
      const pe = S.value.startsWith("ibc/");
      return pe && ($.value = ""), pe;
    });
    function G() {
      y.fetchIBCPathInfo($.value).then((pe) => {
        var oe, ne;
        pe.chain_1.chain_name === c ? O.value = (oe = pe.channels.find(
          (H) => H.chain_1.port_id === "transfer"
        )) == null ? void 0 : oe.chain_1 : O.value = (ne = pe.channels.find(
          (H) => H.chain_2.port_id === "transfer"
        )) == null ? void 0 : ne.chain_2;
      });
    }
    function k() {
      const pe = String(S.value).replace("ibc/", "");
      if (S.value.startsWith("ibc/"))
        if (T.value[S.value]) {
          const ne = T.value[S.value].path.split("/");
          O.value = {
            channel_id: ne[1],
            port_id: ne[0]
          };
        } else
          getDenomTraces(o.endpoint, pe).then((oe) => {
            T.value[S.value] = oe.denomTrace;
            const ne = oe.denomTrace.path.split("/");
            O.value = {
              channel_id: ne[1],
              port_id: ne[0]
            };
          });
    }
    const F = computed(() => {
      var ne;
      const pe = ((ne = o.balances) == null ? void 0 : ne.find((H) => H.denom === S.value)) || {
        amount: "0",
        denom: "-"
      }, oe = new TokenUnitConverter(o.metadata);
      return {
        base: pe,
        display: oe.baseToUnit(pe, m.value)
      };
    }), X = computed(() => {
      var oe;
      const pe = new TokenUnitConverter(o.metadata);
      return ((oe = o.balances) == null ? void 0 : oe.map((ne) => ({
        base: ne,
        display: pe.baseToDisplay(ne)
      }))) || [];
    }), ee = computed(() => {
      if (!o.metadata || !o.metadata[S.value])
        return m.value = S.value, [{ denom: S.value, exponent: 0, aliases: [] }];
      const pe = o.metadata[S.value].denomUnits.sort(
        (oe, ne) => ne.exponent - oe.exponent
      );
      return pe.length > 0 && (m.value = pe[0].denom), pe;
    }), ue = computed(() => {
      var ne;
      let pe = !0, oe = "";
      return (!((ne = O.value) != null && ne.channel_id) || !O.value.port_id) && (pe = !1, oe = "Destination chain is empty"), v.value || (pe = !1, oe = "Recipient is empty"), Number(d.value) > 0 || (pe = !1, oe = "Amount should be great than 0"), { ok: pe, error: oe };
    });
    function Q() {
      y.fetchIBCPaths().then((pe) => {
        E.value = pe.filter((oe) => oe.path.indexOf(c) > -1);
      }), getStakingParam(o.endpoint).then((pe) => {
        S.value = pe.params.bondDenom;
      });
    }
    function Y(pe) {
      return String(pe).substring(0, 10);
    }
    return n({ msgs: V, isValid: ue, initial: Q }), (pe, oe) => {
      var ne;
      return openBlock(), createElementBlock("div", null, [
        createBaseVNode("div", _hoisted_1$e, [
          _hoisted_2$e,
          createBaseVNode("input", {
            value: e.sender,
            type: "text",
            class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
          }, null, 8, _hoisted_3$e)
        ]),
        createBaseVNode("div", _hoisted_4$b, [
          _hoisted_5$c,
          withDirectives(createBaseVNode("select", {
            "onUpdate:modelValue": oe[0] || (oe[0] = (H) => S.value = H),
            class: "select select-bordered",
            onChange: k
          }, [
            _hoisted_6$c,
            (openBlock(!0), createElementBlock(Fragment, null, renderList(X.value, ({ base: H, display: C }) => (openBlock(), createElementBlock("option", {
              value: H.denom
            }, toDisplayString(C.amount) + " " + toDisplayString(Y(C.denom)), 9, _hoisted_7$b))), 256))
          ], 544), [
            [vModelSelect, S.value]
          ])
        ]),
        createBaseVNode("div", _hoisted_8$b, [
          createBaseVNode("label", _hoisted_9$a, [
            _hoisted_10$a,
            O.value ? (openBlock(), createElementBlock("span", _hoisted_11$7, toDisplayString(O.value.channel_id) + "/" + toDisplayString(O.value.port_id), 1)) : createCommentVNode("", !0)
          ]),
          withDirectives(createBaseVNode("select", {
            "onUpdate:modelValue": oe[1] || (oe[1] = (H) => $.value = H),
            class: "select select-bordered capitalize",
            onChange: G,
            disabled: M.value
          }, [
            _hoisted_13$6,
            (openBlock(!0), createElementBlock(Fragment, null, renderList(E.value, (H) => (openBlock(), createElementBlock("option", {
              value: H.path
            }, toDisplayString(H.from === u.value.chain_name ? H.to : H.from), 9, _hoisted_14$6))), 256))
          ], 40, _hoisted_12$7), [
            [vModelSelect, $.value]
          ])
        ]),
        createBaseVNode("div", _hoisted_15$5, [
          _hoisted_16$5,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": oe[2] || (oe[2] = (H) => v.value = H),
            type: "text",
            class: "input border border-gray-300 dark:border-gray-600"
          }, null, 512), [
            [vModelText, v.value]
          ])
        ]),
        createBaseVNode("div", _hoisted_17$5, [
          createBaseVNode("label", _hoisted_18$5, [
            _hoisted_19$4,
            createBaseVNode("span", null, toDisplayString(F.value.display.amount) + " " + toDisplayString(Y(F.value.display.denom)), 1)
          ]),
          createBaseVNode("label", _hoisted_20$4, [
            withDirectives(createBaseVNode("input", {
              "onUpdate:modelValue": oe[3] || (oe[3] = (H) => d.value = H),
              type: "number",
              placeholder: `Available: ${(ne = F.value) == null ? void 0 : ne.display.amount}`,
              class: "input border border-gray-300 dark:border-gray-600 w-full"
            }, null, 8, _hoisted_21$4), [
              [vModelText, d.value]
            ]),
            withDirectives(createBaseVNode("select", {
              "onUpdate:modelValue": oe[4] || (oe[4] = (H) => m.value = H),
              class: "select select-bordered"
            }, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(ee.value, (H) => (openBlock(), createElementBlock("option", {
                value: H.denom
              }, toDisplayString(Y(H.denom)), 9, _hoisted_22$4))), 256))
            ], 512), [
              [vModelSelect, m.value]
            ])
          ])
        ])
      ]);
    };
  }
}), _hoisted_1$d = { class: "form-control" }, _hoisted_2$d = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$d = ["value"], _hoisted_4$a = { class: "form-control" }, _hoisted_5$b = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Amount")
], -1), _hoisted_6$b = { class: "join" }, _hoisted_7$a = { class: "w-full relative flex justify-center items-center" }, _hoisted_8$a = ["placeholder"], _hoisted_9$9 = { class: "text-white" }, _hoisted_10$9 = { class: "text-error" }, _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "Unbond",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    metadata: Object,
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref({}), d = ref(""), m = ref(""), v = ref(""), S = computed(() => {
      var V;
      const y = new TokenUnitConverter(o.metadata);
      return c.value ? [
        {
          typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
          value: {
            delegatorAddress: o.sender,
            validatorAddress: u.value.validator_address,
            amount: y.displayToBase((V = c.value.balance) == null ? void 0 : V.denom, {
              amount: String(d.value),
              denom: m.value
            })
          }
        }
      ] : [];
    }), $ = computed(() => {
      var M;
      if (!c.value)
        return [];
      const y = (M = c.value.balance) == null ? void 0 : M.denom;
      if (!o.metadata || !o.metadata[y])
        return m.value = y, [{ denom: y, exponent: 0, aliases: [] }];
      const V = o.metadata[y].denomUnits.sort(
        (G, k) => k.exponent - G.exponent
      );
      return V.length > 0 && (m.value = V[0].denom), V;
    }), E = computed(() => {
      let y = !0, V = "";
      return o.sender || (y = !1, V = "Sender is empty"), u.value.validator_address || (y = !1, V = "Validator is empty"), Number(d.value) > 0 || (y = !1, V = "Amount should be great than 0"), { ok: y, error: V };
    });
    function O() {
      getDelegations(o.endpoint, u.value.validator_address, o.sender).then((y) => {
        c.value = y.delegationResponse;
      }).catch((y) => {
        v.value = y;
      });
    }
    const T = computed(() => {
      var M;
      const y = new TokenUnitConverter(o.metadata), V = ((M = c.value) == null ? void 0 : M.balance) || { amount: "", denom: "" };
      return {
        base: V,
        display: y.baseToUnit(V, m.value)
      };
    });
    return n({ msgs: S, isValid: E, initial: O }), (y, V) => {
      var M;
      return openBlock(), createElementBlock("div", null, [
        createBaseVNode("div", _hoisted_1$d, [
          _hoisted_2$d,
          createBaseVNode("input", {
            value: e.sender,
            type: "text",
            class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
          }, null, 8, _hoisted_3$d)
        ]),
        createBaseVNode("div", _hoisted_4$a, [
          _hoisted_5$b,
          createBaseVNode("label", _hoisted_6$b, [
            createBaseVNode("div", _hoisted_7$a, [
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": V[0] || (V[0] = (G) => d.value = G),
                type: "number",
                placeholder: `Available: ${(M = T.value) == null ? void 0 : M.display.amount}`,
                class: "input border border-gray-300 dark:border-gray-600 w-full join-item text-white"
              }, null, 8, _hoisted_8$a), [
                [vModelText, d.value]
              ]),
              createBaseVNode("button", {
                class: "absolute right-2 p-1 z-10 bg-[rgb(46,46,51)] text-white hover:bg-[hsl(222,6%,43%)] text-sm",
                onClick: V[1] || (V[1] = (G) => {
                  var k;
                  return d.value = (k = T.value) == null ? void 0 : k.display.amount;
                })
              }, "Max")
            ]),
            withDirectives(createBaseVNode("select", {
              "onUpdate:modelValue": V[2] || (V[2] = (G) => m.value = G),
              class: "select select-bordered join-item text-white"
            }, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList($.value, (G) => (openBlock(), createElementBlock("option", _hoisted_9$9, toDisplayString(G.denom), 1))), 256))
            ], 512), [
              [vModelSelect, m.value]
            ])
          ])
        ]),
        createBaseVNode("div", _hoisted_10$9, toDisplayString(v.value), 1)
      ]);
    };
  }
}), _hoisted_1$c = { class: "form-control" }, _hoisted_2$c = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$c = ["value"], _hoisted_4$9 = { class: "form-control" }, _hoisted_5$a = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Option")
], -1), _hoisted_6$a = { class: "flex" }, _hoisted_7$9 = /* @__PURE__ */ createBaseVNode("label", { for: "yes" }, " Yes", -1), _hoisted_8$9 = /* @__PURE__ */ createBaseVNode("label", { for: "no" }, " No", -1), _hoisted_9$8 = /* @__PURE__ */ createBaseVNode("label", { for: "veto" }, " No With Veto", -1), _hoisted_10$8 = /* @__PURE__ */ createBaseVNode("label", { for: "abstain" }, " Abstain", -1), _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "Vote",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref("1"), d = computed(() => [
      {
        typeUrl: "/cosmos.gov.v1beta1.MsgVote",
        value: {
          voter: o.sender,
          proposalId: u.value.proposal_id,
          option: Number(c.value)
        }
      }
    ]), m = computed(() => {
      let S = !0, $ = "";
      return u.value.proposal_id || (S = !1, $ = "Proposal id is empty"), c.value || (S = !1, $ = "Vote is empty"), { ok: S, error: $ };
    });
    function v() {
    }
    return n({ msgs: d, isValid: m, initial: v }), (S, $) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$c, [
        _hoisted_2$c,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$c)
      ]),
      createBaseVNode("div", _hoisted_4$9, [
        _hoisted_5$a,
        createBaseVNode("div", _hoisted_6$a, [
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": $[0] || ($[0] = (E) => c.value = E),
            type: "radio",
            id: "yes",
            value: "1",
            class: "radio radio-success mx-2"
          }, null, 512), [
            [vModelRadio, c.value]
          ]),
          _hoisted_7$9,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": $[1] || ($[1] = (E) => c.value = E),
            type: "radio",
            id: "no",
            value: "3",
            class: "radio radio-error mx-2"
          }, null, 512), [
            [vModelRadio, c.value]
          ]),
          _hoisted_8$9,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": $[2] || ($[2] = (E) => c.value = E),
            type: "radio",
            id: "veto",
            value: "4",
            class: "radio radio-error mx-2"
          }, null, 512), [
            [vModelRadio, c.value]
          ]),
          _hoisted_9$8,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": $[3] || ($[3] = (E) => c.value = E),
            type: "radio",
            id: "abstain",
            value: "2",
            class: "radio radio-dark mx-2"
          }, null, 512), [
            [vModelRadio, c.value]
          ]),
          _hoisted_10$8
        ])
      ])
    ]));
  }
}), _hoisted_1$b = { class: "form-control" }, _hoisted_2$b = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$b = ["value"], _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "Withdraw",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = ref([]), c = computed(() => u.value.map((v) => ({
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
      value: {
        delegatorAddress: o.sender,
        validatorAddress: v.validatorAddress
      }
    }))), d = computed(() => {
      let v = !0, S = "";
      return o.sender || (v = !1, S = "Sender is empty"), u.value.length === 0 && (v = !1, S = "No delegation found"), { ok: v, error: S };
    });
    function m() {
      getDelegateRewards(o.endpoint, o.sender).then((v) => {
        u.value = v.rewards;
      });
    }
    return n({ msgs: c, isValid: d, initial: m }), (v, S) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$b, [
        _hoisted_2$b,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$b)
      ])
    ]));
  }
}), _hoisted_1$a = { class: "form-control" }, _hoisted_2$a = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$a = ["value"], _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "WithdrawCommission",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref([]), d = computed(() => {
      var $;
      return [
        ...($ = c.value) == null ? void 0 : $.map((E) => ({
          typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
          value: {
            delegatorAddress: o.sender,
            validatorAddress: E.validatorAddress
          }
        })),
        {
          typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
          value: {
            validatorAddress: u.value.validator_address
          }
        }
      ];
    }), m = computed(() => {
      let S = !0, $ = "";
      return o.sender || (S = !1, $ = "Sender is empty"), u.value.validator_address || (S = !1, $ = "Validator is empty"), (!c.value || c.value.length < 0) && (S = !1, $ = "No delegation found"), c.value.findIndex(
        (E) => E.validatorAddress === u.value.validator_address
      ) === -1 && (S = !1, $ = "You are not the validator!"), { ok: S, error: $ };
    });
    function v() {
      getDelegateRewards(o.endpoint, o.sender).then((S) => {
        c.value = S.rewards;
      });
    }
    return n({ msgs: d, isValid: m, initial: v }), (S, $) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$a, [
        _hoisted_2$a,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$a)
      ])
    ]));
  }
});
var u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array, fleb = new u8([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), fdeb = new u8([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), freb = function(e, n) {
  for (var o = new u16(31), u = 0; u < 31; ++u)
    o[u] = n += 1 << e[u - 1];
  for (var c = new i32(o[30]), u = 1; u < 30; ++u)
    for (var d = o[u]; d < o[u + 1]; ++d)
      c[d] = d - o[u] << 5 | u;
  return { b: o, r: c };
}, _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), revfd = _b.r, rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
  var x = (i & 43690) >> 1 | (i & 21845) << 1;
  x = (x & 52428) >> 2 | (x & 13107) << 2, x = (x & 61680) >> 4 | (x & 3855) << 4, rev[i] = ((x & 65280) >> 8 | (x & 255) << 8) >> 1;
}
var hMap = function(e, n, o) {
  for (var u = e.length, c = 0, d = new u16(n); c < u; ++c)
    e[c] && ++d[e[c] - 1];
  var m = new u16(n);
  for (c = 1; c < n; ++c)
    m[c] = m[c - 1] + d[c - 1] << 1;
  var v;
  if (o) {
    v = new u16(1 << n);
    var S = 15 - n;
    for (c = 0; c < u; ++c)
      if (e[c])
        for (var $ = c << 4 | e[c], E = n - e[c], O = m[e[c] - 1]++ << E, T = O | (1 << E) - 1; O <= T; ++O)
          v[rev[O] >> S] = $;
  } else
    for (v = new u16(u), c = 0; c < u; ++c)
      e[c] && (v[c] = rev[m[e[c] - 1]++] >> 15 - e[c]);
  return v;
}, flt = new u8(288);
for (var i = 0; i < 144; ++i)
  flt[i] = 8;
for (var i = 144; i < 256; ++i)
  flt[i] = 9;
for (var i = 256; i < 280; ++i)
  flt[i] = 7;
for (var i = 280; i < 288; ++i)
  flt[i] = 8;
var fdt = new u8(32);
for (var i = 0; i < 32; ++i)
  fdt[i] = 5;
var flm = /* @__PURE__ */ hMap(flt, 9, 0), fdm = /* @__PURE__ */ hMap(fdt, 5, 0), shft = function(e) {
  return (e + 7) / 8 | 0;
}, slc = function(e, n, o) {
  (n == null || n < 0) && (n = 0), (o == null || o > e.length) && (o = e.length);
  var u = new u8(o - n);
  return u.set(e.subarray(n, o)), u;
}, wbits = function(e, n, o) {
  o <<= n & 7;
  var u = n / 8 | 0;
  e[u] |= o, e[u + 1] |= o >> 8;
}, wbits16 = function(e, n, o) {
  o <<= n & 7;
  var u = n / 8 | 0;
  e[u] |= o, e[u + 1] |= o >> 8, e[u + 2] |= o >> 16;
}, hTree = function(e, n) {
  for (var o = [], u = 0; u < e.length; ++u)
    e[u] && o.push({ s: u, f: e[u] });
  var c = o.length, d = o.slice();
  if (!c)
    return { t: et, l: 0 };
  if (c == 1) {
    var m = new u8(o[0].s + 1);
    return m[o[0].s] = 1, { t: m, l: 1 };
  }
  o.sort(function(ue, Q) {
    return ue.f - Q.f;
  }), o.push({ s: -1, f: 25001 });
  var v = o[0], S = o[1], $ = 0, E = 1, O = 2;
  for (o[0] = { s: -1, f: v.f + S.f, l: v, r: S }; E != c - 1; )
    v = o[o[$].f < o[O].f ? $++ : O++], S = o[$ != E && o[$].f < o[O].f ? $++ : O++], o[E++] = { s: -1, f: v.f + S.f, l: v, r: S };
  for (var T = d[0].s, u = 1; u < c; ++u)
    d[u].s > T && (T = d[u].s);
  var y = new u16(T + 1), V = ln(o[E - 1], y, 0);
  if (V > n) {
    var u = 0, M = 0, G = V - n, k = 1 << G;
    for (d.sort(function(Q, Y) {
      return y[Y.s] - y[Q.s] || Q.f - Y.f;
    }); u < c; ++u) {
      var F = d[u].s;
      if (y[F] > n)
        M += k - (1 << V - y[F]), y[F] = n;
      else
        break;
    }
    for (M >>= G; M > 0; ) {
      var X = d[u].s;
      y[X] < n ? M -= 1 << n - y[X]++ - 1 : ++u;
    }
    for (; u >= 0 && M; --u) {
      var ee = d[u].s;
      y[ee] == n && (--y[ee], ++M);
    }
    V = n;
  }
  return { t: new u8(y), l: V };
}, ln = function(e, n, o) {
  return e.s == -1 ? Math.max(ln(e.l, n, o + 1), ln(e.r, n, o + 1)) : n[e.s] = o;
}, lc = function(e) {
  for (var n = e.length; n && !e[--n]; )
    ;
  for (var o = new u16(++n), u = 0, c = e[0], d = 1, m = function(S) {
    o[u++] = S;
  }, v = 1; v <= n; ++v)
    if (e[v] == c && v != n)
      ++d;
    else {
      if (!c && d > 2) {
        for (; d > 138; d -= 138)
          m(32754);
        d > 2 && (m(d > 10 ? d - 11 << 5 | 28690 : d - 3 << 5 | 12305), d = 0);
      } else if (d > 3) {
        for (m(c), --d; d > 6; d -= 6)
          m(8304);
        d > 2 && (m(d - 3 << 5 | 8208), d = 0);
      }
      for (; d--; )
        m(c);
      d = 1, c = e[v];
    }
  return { c: o.subarray(0, u), n };
}, clen = function(e, n) {
  for (var o = 0, u = 0; u < n.length; ++u)
    o += e[u] * n[u];
  return o;
}, wfblk = function(e, n, o) {
  var u = o.length, c = shft(n + 2);
  e[c] = u & 255, e[c + 1] = u >> 8, e[c + 2] = e[c] ^ 255, e[c + 3] = e[c + 1] ^ 255;
  for (var d = 0; d < u; ++d)
    e[c + d + 4] = o[d];
  return (c + 4 + u) * 8;
}, wblk = function(e, n, o, u, c, d, m, v, S, $, E) {
  wbits(n, E++, o), ++c[256];
  for (var O = hTree(c, 15), T = O.t, y = O.l, V = hTree(d, 15), M = V.t, G = V.l, k = lc(T), F = k.c, X = k.n, ee = lc(M), ue = ee.c, Q = ee.n, Y = new u16(19), pe = 0; pe < F.length; ++pe)
    ++Y[F[pe] & 31];
  for (var pe = 0; pe < ue.length; ++pe)
    ++Y[ue[pe] & 31];
  for (var oe = hTree(Y, 7), ne = oe.t, H = oe.l, C = 19; C > 4 && !ne[clim[C - 1]]; --C)
    ;
  var w = $ + 5 << 3, P = clen(c, flt) + clen(d, fdt) + m, J = clen(c, T) + clen(d, M) + m + 14 + 3 * C + clen(Y, ne) + 2 * Y[16] + 3 * Y[17] + 7 * Y[18];
  if (S >= 0 && w <= P && w <= J)
    return wfblk(n, E, e.subarray(S, S + $));
  var se, fe, N, W;
  if (wbits(n, E, 1 + (J < P)), E += 2, J < P) {
    se = hMap(T, y, 0), fe = T, N = hMap(M, G, 0), W = M;
    var I = hMap(ne, H, 0);
    wbits(n, E, X - 257), wbits(n, E + 5, Q - 1), wbits(n, E + 10, C - 4), E += 14;
    for (var pe = 0; pe < C; ++pe)
      wbits(n, E + 3 * pe, ne[clim[pe]]);
    E += 3 * C;
    for (var te = [F, ue], ge = 0; ge < 2; ++ge)
      for (var Pe = te[ge], pe = 0; pe < Pe.length; ++pe) {
        var Ke = Pe[pe] & 31;
        wbits(n, E, I[Ke]), E += ne[Ke], Ke > 15 && (wbits(n, E, Pe[pe] >> 5 & 127), E += Pe[pe] >> 12);
      }
  } else
    se = flm, fe = flt, N = fdm, W = fdt;
  for (var pe = 0; pe < v; ++pe) {
    var xe = u[pe];
    if (xe > 255) {
      var Ke = xe >> 18 & 31;
      wbits16(n, E, se[Ke + 257]), E += fe[Ke + 257], Ke > 7 && (wbits(n, E, xe >> 23 & 31), E += fleb[Ke]);
      var ze = xe & 31;
      wbits16(n, E, N[ze]), E += W[ze], ze > 3 && (wbits16(n, E, xe >> 5 & 8191), E += fdeb[ze]);
    } else
      wbits16(n, E, se[xe]), E += fe[xe];
  }
  return wbits16(n, E, se[256]), E + fe[256];
}, deo = /* @__PURE__ */ new i32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), et = /* @__PURE__ */ new u8(0), dflt = function(e, n, o, u, c, d) {
  var m = d.z || e.length, v = new u8(u + m + 5 * (1 + Math.ceil(m / 7e3)) + c), S = v.subarray(u, v.length - c), $ = d.l, E = (d.r || 0) & 7;
  if (n) {
    E && (S[0] = d.r >> 3);
    for (var O = deo[n - 1], T = O >> 13, y = O & 8191, V = (1 << o) - 1, M = d.p || new u16(32768), G = d.h || new u16(V + 1), k = Math.ceil(o / 3), F = 2 * k, X = function(kt) {
      return (e[kt] ^ e[kt + 1] << k ^ e[kt + 2] << F) & V;
    }, ee = new i32(25e3), ue = new u16(288), Q = new u16(32), Y = 0, pe = 0, oe = d.i || 0, ne = 0, H = d.w || 0, C = 0; oe + 2 < m; ++oe) {
      var w = X(oe), P = oe & 32767, J = G[w];
      if (M[P] = J, G[w] = P, H <= oe) {
        var se = m - oe;
        if ((Y > 7e3 || ne > 24576) && (se > 423 || !$)) {
          E = wblk(e, S, 0, ee, ue, Q, pe, ne, C, oe - C, E), ne = Y = pe = 0, C = oe;
          for (var fe = 0; fe < 286; ++fe)
            ue[fe] = 0;
          for (var fe = 0; fe < 30; ++fe)
            Q[fe] = 0;
        }
        var N = 2, W = 0, I = y, te = P - J & 32767;
        if (se > 2 && w == X(oe - te))
          for (var ge = Math.min(T, se) - 1, Pe = Math.min(32767, oe), Ke = Math.min(258, se); te <= Pe && --I && P != J; ) {
            if (e[oe + N] == e[oe + N - te]) {
              for (var xe = 0; xe < Ke && e[oe + xe] == e[oe + xe - te]; ++xe)
                ;
              if (xe > N) {
                if (N = xe, W = te, xe > ge)
                  break;
                for (var ze = Math.min(te, xe - 2), nt = 0, fe = 0; fe < ze; ++fe) {
                  var Qt = oe - te + fe & 32767, Et = M[Qt], zt = Qt - Et & 32767;
                  zt > nt && (nt = zt, J = Qt);
                }
              }
            }
            P = J, J = M[P], te += P - J & 32767;
          }
        if (W) {
          ee[ne++] = 268435456 | revfl[N] << 18 | revfd[W];
          var Nt = revfl[N] & 31, pt = revfd[W] & 31;
          pe += fleb[Nt] + fdeb[pt], ++ue[257 + Nt], ++Q[pt], H = oe + N, ++Y;
        } else
          ee[ne++] = e[oe], ++ue[e[oe]];
      }
    }
    for (oe = Math.max(oe, H); oe < m; ++oe)
      ee[ne++] = e[oe], ++ue[e[oe]];
    E = wblk(e, S, $, ee, ue, Q, pe, ne, C, oe - C, E), $ || (d.r = E & 7 | S[E / 8 | 0] << 3, E -= 7, d.h = G, d.p = M, d.i = oe, d.w = H);
  } else {
    for (var oe = d.w || 0; oe < m + $; oe += 65535) {
      var at = oe + 65535;
      at >= m && (S[E / 8 | 0] = $, at = m), E = wfblk(S, E + 1, e.subarray(oe, at));
    }
    d.i = m;
  }
  return slc(v, 0, u + shft(E) + c);
}, crct = /* @__PURE__ */ function() {
  for (var e = new Int32Array(256), n = 0; n < 256; ++n) {
    for (var o = n, u = 9; --u; )
      o = (o & 1 && -306674912) ^ o >>> 1;
    e[n] = o;
  }
  return e;
}(), crc = function() {
  var e = -1;
  return {
    p: function(n) {
      for (var o = e, u = 0; u < n.length; ++u)
        o = crct[o & 255 ^ n[u]] ^ o >>> 8;
      e = o;
    },
    d: function() {
      return ~e;
    }
  };
}, dopt = function(e, n, o, u, c) {
  if (!c && (c = { l: 1 }, n.dictionary)) {
    var d = n.dictionary.subarray(-32768), m = new u8(d.length + e.length);
    m.set(d), m.set(e, d.length), e = m, c.w = d.length;
  }
  return dflt(e, n.level == null ? 6 : n.level, n.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(e.length))) * 1.5) : 12 + n.mem, o, u, c);
}, wbytes = function(e, n, o) {
  for (; o; ++n)
    e[n] = o, o >>>= 8;
}, gzh = function(e, n) {
  var o = n.filename;
  if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = n.level < 2 ? 4 : n.level == 9 ? 2 : 0, e[9] = 3, n.mtime != 0 && wbytes(e, 4, Math.floor(new Date(n.mtime || Date.now()) / 1e3)), o) {
    e[3] = 8;
    for (var u = 0; u <= o.length; ++u)
      e[u + 10] = o.charCodeAt(u);
  }
}, gzhl = function(e) {
  return 10 + (e.filename ? e.filename.length + 1 : 0);
};
function gzipSync(e, n) {
  n || (n = {});
  var o = crc(), u = e.length;
  o.p(e);
  var c = dopt(e, n, gzhl(n), 8), d = c.length;
  return gzh(c, n), wbytes(c, d - 8, o.d()), wbytes(c, d - 4, u), c;
}
var td = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), tds = 0;
try {
  td.decode(et, { stream: !0 }), tds = 1;
} catch (e) {
}
const _hoisted_1$9 = { class: "form-control" }, _hoisted_2$9 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$9 = ["value"], _hoisted_4$8 = { class: "form-control" }, _hoisted_5$9 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Permission")
], -1), _hoisted_6$9 = { class: "flex" }, _hoisted_7$8 = /* @__PURE__ */ createBaseVNode("label", { for: "nobody" }, "Nobody", -1), _hoisted_8$8 = /* @__PURE__ */ createBaseVNode("label", { for: "everyone" }, "Everybody", -1), _hoisted_9$7 = /* @__PURE__ */ createBaseVNode("label", { for: "anyofaddress" }, "Any Of addresses", -1), _hoisted_10$7 = {
  key: 0,
  class: "form-control"
}, _hoisted_11$6 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Addresses")
], -1), _hoisted_12$6 = { class: "form-control" }, _hoisted_13$5 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Compressing")
], -1), _hoisted_14$5 = { class: "flex" }, _hoisted_15$4 = /* @__PURE__ */ createBaseVNode("label", { for: "raw" }, "Raw", -1), _hoisted_16$4 = /* @__PURE__ */ createBaseVNode("label", { for: "gzip" }, "Gzip", -1), _hoisted_17$4 = { class: "form-control" }, _hoisted_18$4 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Contract")
], -1), _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "StoreCode",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = ref(new Uint8Array()), c = ref(""), d = ref("3"), m = ref("gzip");
    function v(O) {
      const T = O.target.files[0];
      if (T) {
        var y = new FileReader();
        y.addEventListener("load", (V) => {
          V.target && (m.value === "gzip" && (u.value = gzipSync(new Uint8Array(V.target.result))), u.value = new Uint8Array(V.target.result));
        }), y.readAsArrayBuffer(T);
      }
    }
    const S = computed(() => [{
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
      value: {
        sender: o.sender,
        wasmByteCode: u.value,
        instantiatePermission: {
          permission: d.value,
          addresses: c.value.split(",")
        }
      }
    }]), $ = computed(() => {
      let O = !0, T = "";
      return u.value.length < 1 && (O = !1, T = "No contract is selected"), { ok: O, error: T };
    });
    function E() {
    }
    return n({ msgs: S, isValid: $, initial: E }), (O, T) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$9, [
        _hoisted_2$9,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$9)
      ]),
      createBaseVNode("div", _hoisted_4$8, [
        _hoisted_5$9,
        createBaseVNode("div", _hoisted_6$9, [
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": T[0] || (T[0] = (y) => d.value = y),
            type: "radio",
            id: "nobody",
            value: "1",
            class: "radio radio-error mx-2"
          }, null, 512), [
            [vModelRadio, d.value]
          ]),
          _hoisted_7$8,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": T[1] || (T[1] = (y) => d.value = y),
            type: "radio",
            id: "everyone",
            value: "3",
            class: "radio radio-success mx-2"
          }, null, 512), [
            [vModelRadio, d.value]
          ]),
          _hoisted_8$8,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": T[2] || (T[2] = (y) => d.value = y),
            type: "radio",
            id: "anyofaddress",
            value: "4",
            class: "radio radio-success mx-2"
          }, null, 512), [
            [vModelRadio, d.value]
          ]),
          _hoisted_9$7
        ])
      ]),
      d.value === "4" ? (openBlock(), createElementBlock("div", _hoisted_10$7, [
        _hoisted_11$6,
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": T[3] || (T[3] = (y) => c.value = y),
          type: "text",
          placeholder: "use ',' for addresses",
          class: "input border border-gray-300 dark:border-gray-600"
        }, null, 512), [
          [vModelText, c.value]
        ])
      ])) : createCommentVNode("", !0),
      createBaseVNode("div", _hoisted_12$6, [
        _hoisted_13$5,
        createBaseVNode("div", _hoisted_14$5, [
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": T[4] || (T[4] = (y) => m.value = y),
            type: "radio",
            id: "raw",
            value: "raw",
            class: "radio mx-2"
          }, null, 512), [
            [vModelRadio, m.value]
          ]),
          _hoisted_15$4,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": T[5] || (T[5] = (y) => m.value = y),
            type: "radio",
            id: "gzip",
            value: "gzip",
            class: "radio mx-2"
          }, null, 512), [
            [vModelRadio, m.value]
          ]),
          _hoisted_16$4
        ])
      ]),
      createBaseVNode("div", _hoisted_17$4, [
        _hoisted_18$4,
        createBaseVNode("input", {
          type: "file",
          class: "file-input",
          onChange: v
        }, null, 32)
      ])
    ]));
  }
}), _hoisted_1$8 = { class: "form-control" }, _hoisted_2$8 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$8 = ["value"], _hoisted_4$7 = { class: "form-control" }, _hoisted_5$8 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Contract Address")
], -1), _hoisted_6$8 = { class: "form-control" }, _hoisted_7$7 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Messages")
], -1), _hoisted_8$7 = { class: "form-control" }, _hoisted_9$6 = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Funds", -1), _hoisted_10$6 = ["onUpdate:modelValue"], _hoisted_11$5 = ["onUpdate:modelValue"], _hoisted_12$5 = ["value"], _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "ExecuteContract",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    balances: Object,
    metadata: Object,
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref(u.value.contract), d = ref([]), m = ref("");
    function v() {
      var y, V;
      const T = ((V = (y = o.balances) == null ? void 0 : y.at(0)) == null ? void 0 : V.denom) || "";
      d.value.push({ amount: "", denom: T });
    }
    function S() {
      d.value.length > 0 && d.value.pop();
    }
    const $ = computed(() => [{
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: {
        /** Sender is the that actor that signed the messages */
        sender: o.sender,
        contract: c.value,
        /** Msg json encoded message to be passed to the contract on instantiation */
        msg: new TextEncoder().encode(m.value),
        /** Funds coins that are transferred to the contract on instantiation */
        funds: JSON.parse(JSON.stringify(d.value))
      }
    }]), E = computed(() => {
      let T = !0, y = "";
      return c.value.length <= 0 && (T = !1, y = "Contract is not selected"), m.value.length <= 0 && (T = !1, y = "Please input arguments"), { ok: T, error: y };
    });
    function O() {
    }
    return n({ msgs: $, isValid: E, initial: O }), (T, y) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$8, [
        _hoisted_2$8,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$8)
      ]),
      createBaseVNode("div", _hoisted_4$7, [
        _hoisted_5$8,
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": y[0] || (y[0] = (V) => c.value = V),
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 512), [
          [vModelText, c.value]
        ])
      ]),
      createBaseVNode("div", _hoisted_6$8, [
        _hoisted_7$7,
        withDirectives(createBaseVNode("textarea", {
          "onUpdate:modelValue": y[1] || (y[1] = (V) => m.value = V),
          placeholder: "{config: {}}",
          class: "textarea text-gray-800 dark:text-white !border-gray-300 dark:!border-gray-600"
        }, null, 512), [
          [vModelText, m.value]
        ])
      ]),
      createBaseVNode("div", _hoisted_8$7, [
        createBaseVNode("label", { class: "label" }, [
          _hoisted_9$6,
          createBaseVNode("span", { class: "label-text" }, [
            createBaseVNode("a", {
              class: "btn btn-xs",
              onClick: v
            }, "+"),
            createBaseVNode("a", {
              class: "btn btn-xs",
              onClick: S
            }, "-")
          ])
        ]),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(d.value, (V, M) => (openBlock(), createElementBlock("label", {
          class: "input-group",
          key: M
        }, [
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": (G) => V.amount = G,
            type: "text",
            placeholder: "0",
            class: "input border border-gray-300 dark:border-gray-600 w-full"
          }, null, 8, _hoisted_10$6), [
            [vModelText, V.amount]
          ]),
          withDirectives(createBaseVNode("select", {
            "onUpdate:modelValue": (G) => V.denom = G,
            class: "select border border-gray-300 dark:border-gray-600"
          }, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(e.balances, (G) => (openBlock(), createElementBlock("option", {
              value: G.denom
            }, toDisplayString(G.denom.substring(0, 10)), 9, _hoisted_12$5))), 256))
          ], 8, _hoisted_11$5), [
            [vModelSelect, V.denom]
          ])
        ]))), 128))
      ])
    ]));
  }
}), _hoisted_1$7 = { class: "form-control" }, _hoisted_2$7 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$7 = ["value"], _hoisted_4$6 = { class: "form-control" }, _hoisted_5$7 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Admin")
], -1), _hoisted_6$7 = { class: "form-control" }, _hoisted_7$6 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Label")
], -1), _hoisted_8$6 = { class: "form-control" }, _hoisted_9$5 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Messages")
], -1), _hoisted_10$5 = { class: "form-control" }, _hoisted_11$4 = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Funds", -1), _hoisted_12$4 = ["onUpdate:modelValue"], _hoisted_13$4 = ["onUpdate:modelValue"], _hoisted_14$4 = ["value"], _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "InstantiateContract",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    balances: Object,
    metadata: Object,
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref(""), d = ref(""), m = ref([]), v = ref(""), S = computed(() => [{
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
      value: {
        /** Sender is the that actor that signed the messages */
        sender: o.sender,
        /** Admin is an optional address that can execute migrations */
        admin: c.value,
        /** CodeID is the reference to the stored WASM code */
        codeId: u.value.codeId,
        /** Label is optional metadata to be stored with a contract instance. */
        label: d.value,
        /** Msg json encoded message to be passed to the contract on instantiation */
        msg: build$V.toBase64(new TextEncoder().encode(v.value)),
        /** Funds coins that are transferred to the contract on instantiation */
        funds: JSON.parse(JSON.stringify(m.value))
      }
    }]);
    function $() {
      var V, M;
      const y = ((M = (V = o.balances) == null ? void 0 : V.at(0)) == null ? void 0 : M.denom) || "";
      m.value.push({ amount: "", denom: y });
    }
    function E() {
      m.value.length > 0 && m.value.pop();
    }
    const O = computed(() => {
      let y = !0, V = "";
      return Number(u.value.codeId) < 1 && (y = !1, V = "Code Id is not selected"), { ok: y, error: V };
    });
    function T() {
    }
    return n({ msgs: S, isValid: O, initial: T }), (y, V) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$7, [
        _hoisted_2$7,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$7)
      ]),
      createBaseVNode("div", _hoisted_4$6, [
        _hoisted_5$7,
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": V[0] || (V[0] = (M) => c.value = M),
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 512), [
          [vModelText, c.value]
        ])
      ]),
      createBaseVNode("div", _hoisted_6$7, [
        _hoisted_7$6,
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": V[1] || (V[1] = (M) => d.value = M),
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 512), [
          [vModelText, d.value]
        ])
      ]),
      createBaseVNode("div", _hoisted_8$6, [
        _hoisted_9$5,
        withDirectives(createBaseVNode("textarea", {
          "onUpdate:modelValue": V[2] || (V[2] = (M) => v.value = M),
          placeholder: "{config: {}}",
          class: "text-gray-600 dark:text-white textarea border !border-gray-300 dark:!border-gray-600"
        }, null, 512), [
          [vModelText, v.value]
        ])
      ]),
      createBaseVNode("div", _hoisted_10$5, [
        createBaseVNode("label", { class: "label" }, [
          _hoisted_11$4,
          createBaseVNode("span", { class: "label-text" }, [
            createBaseVNode("a", {
              class: "btn btn-xs",
              onClick: $
            }, "+"),
            createBaseVNode("a", {
              class: "btn btn-xs",
              onClick: E
            }, "-")
          ])
        ]),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(m.value, (M, G) => (openBlock(), createElementBlock("label", {
          class: "input-group",
          key: G
        }, [
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": (k) => M.amount = k,
            type: "text",
            placeholder: "0",
            class: "input border border-gray-300 dark:border-gray-600 w-full"
          }, null, 8, _hoisted_12$4), [
            [vModelText, M.amount]
          ]),
          withDirectives(createBaseVNode("select", {
            "onUpdate:modelValue": (k) => M.denom = k,
            class: "select border border-gray-300 dark:border-gray-600"
          }, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(e.balances, (k) => (openBlock(), createElementBlock("option", {
              value: k.denom
            }, toDisplayString(k.denom.substring(0, 10)), 9, _hoisted_14$4))), 256))
          ], 8, _hoisted_13$4), [
            [vModelSelect, M.denom]
          ])
        ]))), 128))
      ])
    ]));
  }
}), _hoisted_1$6 = { class: "form-control" }, _hoisted_2$6 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$6 = ["value"], _hoisted_4$5 = { class: "form-control" }, _hoisted_5$6 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Contract Address")
], -1), _hoisted_6$6 = ["value"], _hoisted_7$5 = { class: "form-control" }, _hoisted_8$5 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Code Id")
], -1), _hoisted_9$4 = { class: "form-control" }, _hoisted_10$4 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Messages")
], -1), _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "MigrateContract",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref(""), d = ref("{}"), m = computed(() => [{
      typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
      value: {
        /** Sender is the that actor that signed the messages */
        sender: o.sender,
        /** contract address that can execute migrations */
        contract: u.value.contract,
        /** CodeID is the reference to the stored WASM code */
        codeId: c.value,
        /** Msg json encoded message to be passed to the contract on instantiation */
        msg: new TextEncoder().encode(d.value)
      }
    }]), v = computed(() => {
      let $ = !0, E = "";
      return Number(c.value) < 1 && ($ = !1, E = "Code Id is not selected"), { ok: $, error: E };
    });
    function S() {
    }
    return n({ msgs: m, isValid: v, initial: S }), ($, E) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$6, [
        _hoisted_2$6,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$6)
      ]),
      createBaseVNode("div", _hoisted_4$5, [
        _hoisted_5$6,
        createBaseVNode("input", {
          type: "text",
          readonly: "",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600",
          value: u.value.contract
        }, null, 8, _hoisted_6$6)
      ]),
      createBaseVNode("div", _hoisted_7$5, [
        _hoisted_8$5,
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": E[0] || (E[0] = (O) => c.value = O),
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 512), [
          [vModelText, c.value]
        ])
      ]),
      createBaseVNode("div", _hoisted_9$4, [
        _hoisted_10$4,
        withDirectives(createBaseVNode("textarea", {
          "onUpdate:modelValue": E[1] || (E[1] = (O) => d.value = O),
          placeholder: "{config: {}}",
          class: "text-gray-600 dark:text-white textarea border !border-gray-300 dark:!border-gray-600"
        }, null, 512), [
          [vModelText, d.value]
        ])
      ])
    ]));
  }
}), _hoisted_1$5 = { class: "form-control" }, _hoisted_2$5 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$5 = ["value"], _hoisted_4$4 = { class: "form-control" }, _hoisted_5$5 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Contract Address")
], -1), _hoisted_6$5 = ["value"], _hoisted_7$4 = { class: "form-control" }, _hoisted_8$4 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "New Admin")
], -1), _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "UpdateAdmin",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = ref(""), d = ref(""), m = computed(() => [{
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
      value: {
        /** Sender is the that actor that signed the messages */
        sender: o.sender,
        /** contract address that can execute migrations */
        contract: u.value.contract,
        /** CodeID is the reference to the stored WASM code */
        newAdmin: c.value,
        /** Msg json encoded message to be passed to the contract on instantiation */
        msg: build$V.toBase64(new TextEncoder().encode(d.value))
      }
    }]), v = computed(() => {
      let $ = !0, E = "";
      return u.value.contract || ($ = !1, E = "Contract is not selected!"), c.value || ($ = !1, E = "Admin should not be empty!"), { ok: $, error: E };
    });
    function S() {
    }
    return n({ msgs: m, isValid: v, initial: S }), ($, E) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$5, [
        _hoisted_2$5,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$5)
      ]),
      createBaseVNode("div", _hoisted_4$4, [
        _hoisted_5$5,
        createBaseVNode("input", {
          type: "text",
          readonly: "",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600",
          value: u.value.contract
        }, null, 8, _hoisted_6$5)
      ]),
      createBaseVNode("div", _hoisted_7$4, [
        _hoisted_8$4,
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": E[0] || (E[0] = (O) => c.value = O),
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 512), [
          [vModelText, c.value]
        ])
      ])
    ]));
  }
}), _hoisted_1$4 = { class: "form-control" }, _hoisted_2$4 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Sender")
], -1), _hoisted_3$4 = ["value"], _hoisted_4$3 = { class: "form-control" }, _hoisted_5$4 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Contract Address")
], -1), _hoisted_6$4 = ["value"], _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "ClearAdmin",
  props: {
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    params: String
  },
  setup(e, { expose: n }) {
    const o = e, u = computed(() => JSON.parse(o.params || "{}")), c = computed(() => [{
      typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
      value: {
        /** Sender is the that actor that signed the messages */
        sender: o.sender,
        /** contract address that can execute migrations */
        contract: u.value.contract
      }
    }]), d = computed(() => {
      let v = !0, S = "";
      return u.value.contract || (v = !1, S = "Code Id is not selected"), { ok: v, error: S };
    });
    function m() {
    }
    return n({ msgs: c, isValid: d, initial: m }), (v, S) => (openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$4, [
        _hoisted_2$4,
        createBaseVNode("input", {
          value: e.sender,
          type: "text",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600"
        }, null, 8, _hoisted_3$4)
      ]),
      createBaseVNode("div", _hoisted_4$3, [
        _hoisted_5$4,
        createBaseVNode("input", {
          type: "text",
          readonly: "",
          class: "text-gray-600 dark:text-white input border !border-gray-300 dark:!border-gray-600",
          value: u.value.contract
        }, null, 8, _hoisted_6$4)
      ])
    ]));
  }
}), _hoisted_1$3 = { class: "text-gray-600" }, _hoisted_2$3 = ["id"], _hoisted_3$3 = ["for"], _hoisted_4$2 = ["for"], _hoisted_5$3 = { class: "text-lg font-bold capitalize dark:text-gray-300" }, _hoisted_6$3 = {
  key: 0,
  class: "text-center h-16 items-center"
}, _hoisted_7$3 = { key: 1 }, _hoisted_8$3 = { key: 0 }, _hoisted_9$3 = {
  class: "space-y-6",
  action: "#",
  method: "POST"
}, _hoisted_10$3 = { class: "form-control" }, _hoisted_11$3 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Fees")
], -1), _hoisted_12$3 = { class: "input-group flex items-center" }, _hoisted_13$3 = /* @__PURE__ */ createBaseVNode("option", {
  disabled: "",
  selected: ""
}, " Select Fee Token ", -1), _hoisted_14$3 = { class: "form-control" }, _hoisted_15$3 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Gas")
], -1), _hoisted_16$3 = { class: "form-control" }, _hoisted_17$3 = /* @__PURE__ */ createBaseVNode("label", { class: "label" }, [
  /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Memo")
], -1), _hoisted_18$3 = { class: "flex" }, _hoisted_19$3 = /* @__PURE__ */ createBaseVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "stroke-current flex-shrink-0 h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ createBaseVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1), _hoisted_20$3 = { class: "modal-action flex justify-between items-center" }, _hoisted_21$3 = { class: "flex items-center cursor-pointer" }, _hoisted_22$3 = ["id"], _hoisted_23$3 = ["for"], _hoisted_24$3 = ["disabled"], _hoisted_25$3 = {
  key: 0,
  class: "loading loading-spinner"
}, _hoisted_26$3 = { key: 1 }, _hoisted_27$3 = { class: "my-10" }, _hoisted_28$3 = {
  key: 0,
  class: "my-5 text-center text-red-500"
}, _hoisted_29$2 = {
  key: 1,
  class: "my-5 text-center text-lg text-green-500"
}, _hoisted_30$2 = { class: "overflow-hidden h-5 mb-2 text-xs flex rounded bg-green-100" }, _hoisted_31$2 = { class: "flex items-center justify-between" }, _hoisted_32$2 = /* @__PURE__ */ createBaseVNode("div", null, [
  /* @__PURE__ */ createBaseVNode("span", { class: "text-xs font-semibold inline-block py-1 px-2 rounded text-gray-600 dark:text-white" }, " Submitted ")
], -1), _hoisted_33$2 = { class: "text-right" }, _hoisted_34$2 = { class: "text-xs font-semibold inline-block text-gray-600 dark:text-white" }, _hoisted_35$2 = /* @__PURE__ */ createBaseVNode("span", { class: "text-white" }, "View Transaction", -1), _hoisted_36$2 = [
  _hoisted_35$2
], __default__$3 = {
  name: "TxDialog"
}, _sfc_main$3 = /* @__PURE__ */ defineComponent({
  ...__default__$3,
  props: {
    type: String,
    endpoint: { type: String, required: !0 },
    sender: { type: String, required: !0 },
    hdPath: String,
    registryName: String,
    params: String
  },
  emits: ["submited", "confirmed", "view"],
  setup(e, { emit: n }) {
    const o = e, u = computed(() => {
      var w;
      switch ((w = o.type) == null ? void 0 : w.toLowerCase()) {
        case "send":
          return _sfc_main$f;
        case "delegate":
          return _sfc_main$i;
        case "withdraw":
          return _sfc_main$b;
        case "withdraw_commission":
          return _sfc_main$a;
        case "redelegate":
          return _sfc_main$g;
        case "transfer":
          return _sfc_main$e;
        case "unbond":
          return _sfc_main$d;
        case "vote":
          return _sfc_main$c;
        case "deposit":
          return _sfc_main$h;
        case "wasm_store_code":
          return _sfc_main$9;
        case "wasm_execute_contract":
          return _sfc_main$8;
        case "wasm_instantiate_contract":
          return _sfc_main$7;
        case "wasm_migrate_contract":
          return _sfc_main$6;
        case "wasm_update_admin":
          return _sfc_main$5;
        case "wasm_clear_admin":
          return _sfc_main$4;
        default:
          return _sfc_main$f;
      }
    }), c = ref(!1), d = ref(!1), m = ref([]), v = ref({}), S = ref({}), $ = ref("input"), E = ref(!1), O = ref(""), T = ref({
      msgs: [],
      isValid: { ok: !1, error: "" },
      initial: function() {
      }
    }), y = ref(2e3), V = ref(""), M = ref(2e5), G = ref(""), k = ref("cosmoshub-4");
    async function F() {
      var w, P, J;
      if (E.value && o.endpoint && o.sender) {
        v.value = {}, $.value = "input", S.value = JSON.parse(o.params || "{}"), G.value = ((w = o.type) == null ? void 0 : w.toLowerCase()) === "send" ? "" : "scanium.io", y.value = Number(((J = (P = S.value) == null ? void 0 : P.fees) == null ? void 0 : J.amount) || 2e3);
        try {
          getBalance(o.endpoint, o.sender).then((se) => {
            var fe;
            m.value = se.balances, (fe = se.balances) == null || fe.forEach((N) => {
              N.denom.length < 12 && getBalanceMetadata(o.endpoint, N.denom).then((W) => {
                W.metadata && (v.value[N.denom] = W.metadata);
              }).catch(() => {
              }), N.denom.startsWith("ibc/") && getIBCDenomMetadata(N.denom).then((W) => {
                W && (v.value[N.denom] = W);
              }).catch(() => {
              });
            });
          }), o.registryName && Object.keys(v.value).length === 0 && new ChainRegistryClient().fetchAssetsList(o.registryName).then((fe) => {
            fe.assets.forEach((N) => {
              var te, ge, Pe;
              const W = ((te = N.logo_URIs) == null ? void 0 : te.svg) || ((ge = N.logo_URIs) == null ? void 0 : ge.png) || ((Pe = N.logo_URIs) == null ? void 0 : Pe.jpeg) || "", I = {
                description: N.description ?? "",
                denomUnits: N.denom_units,
                base: N.base,
                display: N.display,
                name: N.name,
                symbol: N.symbol,
                uri: W,
                uriHash: W ? build$V.fromAscii(build$W.sha256(build$V.toAscii(W))) : ""
              };
              v.value[N.base] = I;
            });
          }).catch(() => {
            console.log(
              `Chain: ${o.registryName} was not found on Cosmos Registry`
            );
          }), getLatestBlock(o.endpoint).then((se) => {
            k.value = se.block.header.chainId;
          }), getStakingParam(o.endpoint).then((se) => {
            var fe;
            V.value = (fe = se.params) == null ? void 0 : fe.bondDenom;
          }), T.value && T.value.initial && T.value.initial();
        } catch (se) {
          O.value = se;
        }
        d.value = !1;
      }
    }
    async function X() {
      var w;
      try {
        if (!o.sender)
          throw new Error("Sender should not be empty!");
        if (!o.endpoint)
          throw new Error("Endpoint is empty");
        if (!V.value)
          throw new Error("Fee Denom is empty");
        if (!T.value.isValid.ok)
          throw new Error(T.value.isValid.error);
        d.value = !0;
        const P = await getAccount(o.endpoint, o.sender), J = T.value.msgs, se = {
          chainId: k.value,
          signerAddress: o.sender,
          messages: J,
          fee: {
            gas: "200000",
            amount: [
              { amount: String(y.value), denom: V.value }
            ]
          },
          memo: G.value,
          signerData: {
            accountNumber: Number(P == null ? void 0 : P.accountNumber),
            sequence: Number(P == null ? void 0 : P.sequence),
            chainId: k.value
          }
        }, fe = readWallet(o.hdPath), N = fe ? fe.wallet : WalletName.Keplr, W = new UniClient(N, {
          chainId: k.value,
          hdPath: fe.hdPath
        });
        c.value ? se.fee.gas = M.value.toString() : await W.simulate(o.endpoint, se).then((te) => {
          se.fee.gas = (te * 1.25).toFixed();
        }).catch((te) => {
          c.value = !0;
        });
        let I;
        if ((w = W.wallet) != null && w.signAndBroadcast)
          I = await W.wallet.signAndBroadcast(
            o.sender,
            J,
            o.endpoint,
            String(y.value),
            V.value,
            String(M.value),
            G.value
          );
        else {
          const te = await W.sign(se);
          I = await W.broadcastTx(o.endpoint, te);
        }
        if (!I)
          return;
        ne.value = (I == null ? void 0 : I.transactionHash) ?? build$V.toHex(I.hash), H(ne.value), n("submited", {
          hash: ne.value,
          eventType: o.type
        });
      } catch (P) {
        d.value = !1, O.value = P;
      }
    }
    function ee() {
      n("view", {
        hash: ne.value,
        eventType: o.type
      }), E.value = !1;
    }
    function ue() {
      return (o.type || "Sending Transaction").replace(/\_/g, " ");
    }
    const Q = ref(0), Y = ref(0), pe = ref(""), oe = 6e3, ne = ref("");
    function H(w) {
      $.value = "submitting", Q.value = 1, Y.value = 20, O.value = "", pe.value = "Proccessing...", setTimeout(() => {
        C(w);
      }, oe);
    }
    function C(w) {
      Q.value += 1, Y.value += 20, getTxByHash(o.endpoint, w).then((P) => {
        var J;
        console.log("res: ", P), Y.value = 100, P.txResponse.code > 0 ? O.value = ((J = P.txResponse) == null ? void 0 : J.rawLog) ?? "" : (pe.value = `Congratulations! ${ue()} completed successfully.`, n("confirmed", { hash: w, eventType: o.type }));
      }).catch(() => {
        Q.value < 5 ? setTimeout(() => C(w), oe) : O.value = "Timeout";
      });
    }
    return (w, P) => (openBlock(), createElementBlock("div", _hoisted_1$3, [
      withDirectives(createBaseVNode("input", {
        "onUpdate:modelValue": P[0] || (P[0] = (J) => E.value = J),
        type: "checkbox",
        id: e.type,
        class: "modal-toggle",
        onChange: P[1] || (P[1] = (J) => F())
      }, null, 40, _hoisted_2$3), [
        [vModelCheckbox, E.value]
      ]),
      createBaseVNode("label", {
        for: e.type,
        class: "modal cursor-pointer"
      }, [
        createBaseVNode("label", {
          class: normalizeClass(["modal-box relative p-5", {
            "!w-11/12 !max-w-5xl": String(e.type).startsWith("wasm")
          }]),
          for: ""
        }, [
          createBaseVNode("label", {
            for: e.type,
            class: "btn btn-sm btn-circle absolute right-4 top-4"
          }, "✕", 8, _hoisted_4$2),
          createBaseVNode("h3", _hoisted_5$3, toDisplayString(ue()), 1),
          e.sender ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", _hoisted_6$3, " No wallet connected! ")),
          e.sender ? (openBlock(), createElementBlock("div", _hoisted_7$3, [
            $.value === "input" ? (openBlock(), createElementBlock("div", _hoisted_8$3, [
              (openBlock(), createBlock(resolveDynamicComponent(u.value), {
                ref_key: "msgBox",
                ref: T,
                endpoint: e.endpoint,
                sender: e.sender,
                balances: m.value,
                metadata: v.value,
                params: o.params
              }, null, 8, ["endpoint", "sender", "balances", "metadata", "params"])),
              createBaseVNode("form", _hoisted_9$3, [
                createBaseVNode("div", {
                  class: normalizeClass(c.value ? "" : "hidden")
                }, [
                  createBaseVNode("div", _hoisted_10$3, [
                    _hoisted_11$3,
                    createBaseVNode("label", _hoisted_12$3, [
                      withDirectives(createBaseVNode("input", {
                        "onUpdate:modelValue": P[2] || (P[2] = (J) => y.value = J),
                        type: "text",
                        placeholder: "0.001",
                        class: "input border border-gray-300 dark:border-gray-600 flex-1 w-0 dark:text-gray-300"
                      }, null, 512), [
                        [vModelText, y.value]
                      ]),
                      withDirectives(createBaseVNode("select", {
                        "onUpdate:modelValue": P[3] || (P[3] = (J) => V.value = J),
                        class: "select input border border-gray-300 dark:border-gray-600 w-[200px]"
                      }, [
                        _hoisted_13$3,
                        (openBlock(!0), createElementBlock(Fragment, null, renderList(m.value, (J) => (openBlock(), createElementBlock("option", null, toDisplayString(J.denom), 1))), 256))
                      ], 512), [
                        [vModelSelect, V.value]
                      ])
                    ])
                  ]),
                  createBaseVNode("div", _hoisted_14$3, [
                    _hoisted_15$3,
                    withDirectives(createBaseVNode("input", {
                      "onUpdate:modelValue": P[4] || (P[4] = (J) => M.value = J),
                      type: "number",
                      placeholder: "2000000",
                      class: "input border border-gray-300 dark:border-gray-600 dark:text-gray-300"
                    }, null, 512), [
                      [vModelText, M.value]
                    ])
                  ]),
                  createBaseVNode("div", _hoisted_16$3, [
                    _hoisted_17$3,
                    withDirectives(createBaseVNode("input", {
                      "onUpdate:modelValue": P[5] || (P[5] = (J) => G.value = J),
                      type: "text",
                      placeholder: "Memo",
                      class: "input border border-gray-300 dark:border-gray-600 dark:text-gray-300"
                    }, null, 512), [
                      [vModelText, G.value]
                    ])
                  ])
                ], 2)
              ]),
              withDirectives(createBaseVNode("div", {
                class: "mt-5 alert alert-error shadow-lg",
                onClick: P[6] || (P[6] = (J) => O.value = "")
              }, [
                createBaseVNode("div", _hoisted_18$3, [
                  _hoisted_19$3,
                  createBaseVNode("span", null, toDisplayString(O.value) + ".", 1)
                ])
              ], 512), [
                [vShow, O.value]
              ]),
              createBaseVNode("div", _hoisted_20$3, [
                createBaseVNode("div", _hoisted_21$3, [
                  withDirectives(createBaseVNode("input", {
                    "onUpdate:modelValue": P[7] || (P[7] = (J) => c.value = J),
                    type: "checkbox",
                    id: `${e.type}-advance`,
                    class: "checkbox checkbox-sm checkbox-primary mr-2"
                  }, null, 8, _hoisted_22$3), [
                    [vModelCheckbox, c.value]
                  ]),
                  createBaseVNode("label", {
                    for: `${e.type}-advance`,
                    class: "cursor-pointer dark:text-gray-400"
                  }, "Advance", 8, _hoisted_23$3)
                ]),
                createBaseVNode("button", {
                  class: "btn btn-primary",
                  onClick: P[8] || (P[8] = (J) => X()),
                  disabled: d.value
                }, [
                  d.value ? (openBlock(), createElementBlock("span", _hoisted_25$3)) : createCommentVNode("", !0),
                  createTextVNode(" Send ")
                ], 8, _hoisted_24$3)
              ])
            ])) : createCommentVNode("", !0),
            $.value === "submitting" ? (openBlock(), createElementBlock("div", _hoisted_26$3, [
              createBaseVNode("div", _hoisted_27$3, [
                O.value ? (openBlock(), createElementBlock("div", _hoisted_28$3, toDisplayString(O.value), 1)) : (openBlock(), createElementBlock("div", _hoisted_29$2, toDisplayString(pe.value), 1)),
                createBaseVNode("div", _hoisted_30$2, [
                  createBaseVNode("div", {
                    style: normalizeStyle(`width: ${Y.value}%`),
                    class: "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-400"
                  }, null, 4)
                ]),
                createBaseVNode("div", _hoisted_31$2, [
                  _hoisted_32$2,
                  createBaseVNode("div", _hoisted_33$2, [
                    createBaseVNode("span", _hoisted_34$2, toDisplayString(Y.value) + "% ", 1)
                  ])
                ])
              ]),
              createBaseVNode("label", {
                class: "mt-10 flex justify-center text-sm btn",
                onClick: ee
              }, _hoisted_36$2)
            ])) : createCommentVNode("", !0)
          ])) : createCommentVNode("", !0)
        ], 2)
      ], 8, _hoisted_3$3)
    ]));
  }
}), matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/, stringToIcon = (e, n, o, u = "") => {
  const c = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (c.length < 2 || c.length > 3)
      return null;
    u = c.shift().slice(1);
  }
  if (c.length > 3 || !c.length)
    return null;
  if (c.length > 1) {
    const v = c.pop(), S = c.pop(), $ = {
      // Allow provider without '@': "provider:prefix:name"
      provider: c.length > 0 ? c[0] : u,
      prefix: S,
      name: v
    };
    return n && !validateIconName($) ? null : $;
  }
  const d = c[0], m = d.split("-");
  if (m.length > 1) {
    const v = {
      provider: u,
      prefix: m.shift(),
      name: m.join("-")
    };
    return n && !validateIconName(v) ? null : v;
  }
  if (o && u === "") {
    const v = {
      provider: u,
      prefix: "",
      name: d
    };
    return n && !validateIconName(v, o) ? null : v;
  }
  return null;
}, validateIconName = (e, n) => e ? !!((e.provider === "" || e.provider.match(matchIconName)) && (n && e.prefix === "" || e.prefix.match(matchIconName)) && e.name.match(matchIconName)) : !1, defaultIconDimensions = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), defaultIconTransformations = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), defaultIconProps = Object.freeze({
  ...defaultIconDimensions,
  ...defaultIconTransformations
}), defaultExtendedIconProps = Object.freeze({
  ...defaultIconProps,
  body: "",
  hidden: !1
});
function mergeIconTransformations(e, n) {
  const o = {};
  !e.hFlip != !n.hFlip && (o.hFlip = !0), !e.vFlip != !n.vFlip && (o.vFlip = !0);
  const u = ((e.rotate || 0) + (n.rotate || 0)) % 4;
  return u && (o.rotate = u), o;
}
function mergeIconData(e, n) {
  const o = mergeIconTransformations(e, n);
  for (const u in defaultExtendedIconProps)
    u in defaultIconTransformations ? u in e && !(u in o) && (o[u] = defaultIconTransformations[u]) : u in n ? o[u] = n[u] : u in e && (o[u] = e[u]);
  return o;
}
function getIconsTree(e, n) {
  const o = e.icons, u = e.aliases || /* @__PURE__ */ Object.create(null), c = /* @__PURE__ */ Object.create(null);
  function d(m) {
    if (o[m])
      return c[m] = [];
    if (!(m in c)) {
      c[m] = null;
      const v = u[m] && u[m].parent, S = v && d(v);
      S && (c[m] = [v].concat(S));
    }
    return c[m];
  }
  return (n || Object.keys(o).concat(Object.keys(u))).forEach(d), c;
}
function internalGetIconData(e, n, o) {
  const u = e.icons, c = e.aliases || /* @__PURE__ */ Object.create(null);
  let d = {};
  function m(v) {
    d = mergeIconData(
      u[v] || c[v],
      d
    );
  }
  return m(n), o.forEach(m), mergeIconData(e, d);
}
function parseIconSet(e, n) {
  const o = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return o;
  e.not_found instanceof Array && e.not_found.forEach((c) => {
    n(c, null), o.push(c);
  });
  const u = getIconsTree(e);
  for (const c in u) {
    const d = u[c];
    d && (n(c, internalGetIconData(e, c, d)), o.push(c));
  }
  return o;
}
const optionalPropertyDefaults = {
  provider: "",
  aliases: {},
  not_found: {},
  ...defaultIconDimensions
};
function checkOptionalProps(e, n) {
  for (const o in n)
    if (o in e && typeof e[o] != typeof n[o])
      return !1;
  return !0;
}
function quicklyValidateIconSet(e) {
  if (typeof e != "object" || e === null)
    return null;
  const n = e;
  if (typeof n.prefix != "string" || !e.icons || typeof e.icons != "object" || !checkOptionalProps(e, optionalPropertyDefaults))
    return null;
  const o = n.icons;
  for (const c in o) {
    const d = o[c];
    if (!c.match(matchIconName) || typeof d.body != "string" || !checkOptionalProps(
      d,
      defaultExtendedIconProps
    ))
      return null;
  }
  const u = n.aliases || /* @__PURE__ */ Object.create(null);
  for (const c in u) {
    const d = u[c], m = d.parent;
    if (!c.match(matchIconName) || typeof m != "string" || !o[m] && !u[m] || !checkOptionalProps(
      d,
      defaultExtendedIconProps
    ))
      return null;
  }
  return n;
}
const dataStorage = /* @__PURE__ */ Object.create(null);
function newStorage(e, n) {
  return {
    provider: e,
    prefix: n,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function getStorage(e, n) {
  const o = dataStorage[e] || (dataStorage[e] = /* @__PURE__ */ Object.create(null));
  return o[n] || (o[n] = newStorage(e, n));
}
function addIconSet(e, n) {
  return quicklyValidateIconSet(n) ? parseIconSet(n, (o, u) => {
    u ? e.icons[o] = u : e.missing.add(o);
  }) : [];
}
function addIconToStorage(e, n, o) {
  try {
    if (typeof o.body == "string")
      return e.icons[n] = { ...o }, !0;
  } catch {
  }
  return !1;
}
let simpleNames = !1;
function allowSimpleNames(e) {
  return typeof e == "boolean" && (simpleNames = e), simpleNames;
}
function getIconData(e) {
  const n = typeof e == "string" ? stringToIcon(e, !0, simpleNames) : e;
  if (n) {
    const o = getStorage(n.provider, n.prefix), u = n.name;
    return o.icons[u] || (o.missing.has(u) ? null : void 0);
  }
}
function addIcon(e, n) {
  const o = stringToIcon(e, !0, simpleNames);
  if (!o)
    return !1;
  const u = getStorage(o.provider, o.prefix);
  return addIconToStorage(u, o.name, n);
}
function addCollection(e, n) {
  if (typeof e != "object")
    return !1;
  if (typeof n != "string" && (n = e.provider || ""), simpleNames && !n && !e.prefix) {
    let c = !1;
    return quicklyValidateIconSet(e) && (e.prefix = "", parseIconSet(e, (d, m) => {
      m && addIcon(d, m) && (c = !0);
    })), c;
  }
  const o = e.prefix;
  if (!validateIconName({
    provider: n,
    prefix: o,
    name: "a"
  }))
    return !1;
  const u = getStorage(n, o);
  return !!addIconSet(u, e);
}
const defaultIconSizeCustomisations = Object.freeze({
  width: null,
  height: null
}), defaultIconCustomisations = Object.freeze({
  // Dimensions
  ...defaultIconSizeCustomisations,
  // Transformations
  ...defaultIconTransformations
}), unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g, unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function calculateSize(e, n, o) {
  if (n === 1)
    return e;
  if (o = o || 100, typeof e == "number")
    return Math.ceil(e * n * o) / o;
  if (typeof e != "string")
    return e;
  const u = e.split(unitsSplit);
  if (u === null || !u.length)
    return e;
  const c = [];
  let d = u.shift(), m = unitsTest.test(d);
  for (; ; ) {
    if (m) {
      const v = parseFloat(d);
      isNaN(v) ? c.push(d) : c.push(Math.ceil(v * n * o) / o);
    } else
      c.push(d);
    if (d = u.shift(), d === void 0)
      return c.join("");
    m = !m;
  }
}
const isUnsetKeyword = (e) => e === "unset" || e === "undefined" || e === "none";
function iconToSVG(e, n) {
  const o = {
    ...defaultIconProps,
    ...e
  }, u = {
    ...defaultIconCustomisations,
    ...n
  }, c = {
    left: o.left,
    top: o.top,
    width: o.width,
    height: o.height
  };
  let d = o.body;
  [o, u].forEach((V) => {
    const M = [], G = V.hFlip, k = V.vFlip;
    let F = V.rotate;
    G ? k ? F += 2 : (M.push(
      "translate(" + (c.width + c.left).toString() + " " + (0 - c.top).toString() + ")"
    ), M.push("scale(-1 1)"), c.top = c.left = 0) : k && (M.push(
      "translate(" + (0 - c.left).toString() + " " + (c.height + c.top).toString() + ")"
    ), M.push("scale(1 -1)"), c.top = c.left = 0);
    let X;
    switch (F < 0 && (F -= Math.floor(F / 4) * 4), F = F % 4, F) {
      case 1:
        X = c.height / 2 + c.top, M.unshift(
          "rotate(90 " + X.toString() + " " + X.toString() + ")"
        );
        break;
      case 2:
        M.unshift(
          "rotate(180 " + (c.width / 2 + c.left).toString() + " " + (c.height / 2 + c.top).toString() + ")"
        );
        break;
      case 3:
        X = c.width / 2 + c.left, M.unshift(
          "rotate(-90 " + X.toString() + " " + X.toString() + ")"
        );
        break;
    }
    F % 2 === 1 && (c.left !== c.top && (X = c.left, c.left = c.top, c.top = X), c.width !== c.height && (X = c.width, c.width = c.height, c.height = X)), M.length && (d = '<g transform="' + M.join(" ") + '">' + d + "</g>");
  });
  const m = u.width, v = u.height, S = c.width, $ = c.height;
  let E, O;
  m === null ? (O = v === null ? "1em" : v === "auto" ? $ : v, E = calculateSize(O, S / $)) : (E = m === "auto" ? S : m, O = v === null ? calculateSize(E, $ / S) : v === "auto" ? $ : v);
  const T = {}, y = (V, M) => {
    isUnsetKeyword(M) || (T[V] = M.toString());
  };
  return y("width", E), y("height", O), T.viewBox = c.left.toString() + " " + c.top.toString() + " " + S.toString() + " " + $.toString(), {
    attributes: T,
    body: d
  };
}
const regex = /\sid="(\S+)"/g, randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let counter$1 = 0;
function replaceIDs(e, n = randomPrefix) {
  const o = [];
  let u;
  for (; u = regex.exec(e); )
    o.push(u[1]);
  if (!o.length)
    return e;
  const c = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return o.forEach((d) => {
    const m = typeof n == "function" ? n(d) : n + (counter$1++).toString(), v = d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + v + ')([")]|\\.[a-z])', "g"),
      "$1" + m + c + "$3"
    );
  }), e = e.replace(new RegExp(c, "g"), ""), e;
}
const storage = /* @__PURE__ */ Object.create(null);
function setAPIModule(e, n) {
  storage[e] = n;
}
function getAPIModule(e) {
  return storage[e] || storage[""];
}
function createAPIConfig(e) {
  let n;
  if (typeof e.resources == "string")
    n = [e.resources];
  else if (n = e.resources, !(n instanceof Array) || !n.length)
    return null;
  return {
    // API hosts
    resources: n,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const configStorage = /* @__PURE__ */ Object.create(null), fallBackAPISources = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], fallBackAPI = [];
for (; fallBackAPISources.length > 0; )
  fallBackAPISources.length === 1 || Math.random() > 0.5 ? fallBackAPI.push(fallBackAPISources.shift()) : fallBackAPI.push(fallBackAPISources.pop());
configStorage[""] = createAPIConfig({
  resources: ["https://api.iconify.design"].concat(fallBackAPI)
});
function addAPIProvider(e, n) {
  const o = createAPIConfig(n);
  return o === null ? !1 : (configStorage[e] = o, !0);
}
function getAPIConfig(e) {
  return configStorage[e];
}
const detectFetch = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let fetchModule = detectFetch();
function calculateMaxLength(e, n) {
  const o = getAPIConfig(e);
  if (!o)
    return 0;
  let u;
  if (!o.maxURL)
    u = 0;
  else {
    let c = 0;
    o.resources.forEach((m) => {
      c = Math.max(c, m.length);
    });
    const d = n + ".json?icons=";
    u = o.maxURL - c - o.path.length - d.length;
  }
  return u;
}
function shouldAbort(e) {
  return e === 404;
}
const prepare = (e, n, o) => {
  const u = [], c = calculateMaxLength(e, n), d = "icons";
  let m = {
    type: d,
    provider: e,
    prefix: n,
    icons: []
  }, v = 0;
  return o.forEach((S, $) => {
    v += S.length + 1, v >= c && $ > 0 && (u.push(m), m = {
      type: d,
      provider: e,
      prefix: n,
      icons: []
    }, v = S.length), m.icons.push(S);
  }), u.push(m), u;
};
function getPath(e) {
  if (typeof e == "string") {
    const n = getAPIConfig(e);
    if (n)
      return n.path;
  }
  return "/";
}
const send = (e, n, o) => {
  if (!fetchModule) {
    o("abort", 424);
    return;
  }
  let u = getPath(n.provider);
  switch (n.type) {
    case "icons": {
      const d = n.prefix, v = n.icons.join(","), S = new URLSearchParams({
        icons: v
      });
      u += d + ".json?" + S.toString();
      break;
    }
    case "custom": {
      const d = n.uri;
      u += d.slice(0, 1) === "/" ? d.slice(1) : d;
      break;
    }
    default:
      o("abort", 400);
      return;
  }
  let c = 503;
  fetchModule(e + u).then((d) => {
    const m = d.status;
    if (m !== 200) {
      setTimeout(() => {
        o(shouldAbort(m) ? "abort" : "next", m);
      });
      return;
    }
    return c = 501, d.json();
  }).then((d) => {
    if (typeof d != "object" || d === null) {
      setTimeout(() => {
        d === 404 ? o("abort", d) : o("next", c);
      });
      return;
    }
    setTimeout(() => {
      o("success", d);
    });
  }).catch(() => {
    o("next", c);
  });
}, fetchAPIModule = {
  prepare,
  send
};
function sortIcons(e) {
  const n = {
    loaded: [],
    missing: [],
    pending: []
  }, o = /* @__PURE__ */ Object.create(null);
  e.sort((c, d) => c.provider !== d.provider ? c.provider.localeCompare(d.provider) : c.prefix !== d.prefix ? c.prefix.localeCompare(d.prefix) : c.name.localeCompare(d.name));
  let u = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((c) => {
    if (u.name === c.name && u.prefix === c.prefix && u.provider === c.provider)
      return;
    u = c;
    const d = c.provider, m = c.prefix, v = c.name, S = o[d] || (o[d] = /* @__PURE__ */ Object.create(null)), $ = S[m] || (S[m] = getStorage(d, m));
    let E;
    v in $.icons ? E = n.loaded : m === "" || $.missing.has(v) ? E = n.missing : E = n.pending;
    const O = {
      provider: d,
      prefix: m,
      name: v
    };
    E.push(O);
  }), n;
}
function removeCallback(e, n) {
  e.forEach((o) => {
    const u = o.loaderCallbacks;
    u && (o.loaderCallbacks = u.filter((c) => c.id !== n));
  });
}
function updateCallbacks(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const n = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!n.length)
      return;
    let o = !1;
    const u = e.provider, c = e.prefix;
    n.forEach((d) => {
      const m = d.icons, v = m.pending.length;
      m.pending = m.pending.filter((S) => {
        if (S.prefix !== c)
          return !0;
        const $ = S.name;
        if (e.icons[$])
          m.loaded.push({
            provider: u,
            prefix: c,
            name: $
          });
        else if (e.missing.has($))
          m.missing.push({
            provider: u,
            prefix: c,
            name: $
          });
        else
          return o = !0, !0;
        return !1;
      }), m.pending.length !== v && (o || removeCallback([e], d.id), d.callback(
        m.loaded.slice(0),
        m.missing.slice(0),
        m.pending.slice(0),
        d.abort
      ));
    });
  }));
}
let idCounter = 0;
function storeCallback(e, n, o) {
  const u = idCounter++, c = removeCallback.bind(null, o, u);
  if (!n.pending.length)
    return c;
  const d = {
    id: u,
    icons: n,
    callback: e,
    abort: c
  };
  return o.forEach((m) => {
    (m.loaderCallbacks || (m.loaderCallbacks = [])).push(d);
  }), c;
}
function listToIcons(e, n = !0, o = !1) {
  const u = [];
  return e.forEach((c) => {
    const d = typeof c == "string" ? stringToIcon(c, n, o) : c;
    d && u.push(d);
  }), u;
}
var defaultConfig = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function sendQuery(e, n, o, u) {
  const c = e.resources.length, d = e.random ? Math.floor(Math.random() * c) : e.index;
  let m;
  if (e.random) {
    let Q = e.resources.slice(0);
    for (m = []; Q.length > 1; ) {
      const Y = Math.floor(Math.random() * Q.length);
      m.push(Q[Y]), Q = Q.slice(0, Y).concat(Q.slice(Y + 1));
    }
    m = m.concat(Q);
  } else
    m = e.resources.slice(d).concat(e.resources.slice(0, d));
  const v = Date.now();
  let S = "pending", $ = 0, E, O = null, T = [], y = [];
  typeof u == "function" && y.push(u);
  function V() {
    O && (clearTimeout(O), O = null);
  }
  function M() {
    S === "pending" && (S = "aborted"), V(), T.forEach((Q) => {
      Q.status === "pending" && (Q.status = "aborted");
    }), T = [];
  }
  function G(Q, Y) {
    Y && (y = []), typeof Q == "function" && y.push(Q);
  }
  function k() {
    return {
      startTime: v,
      payload: n,
      status: S,
      queriesSent: $,
      queriesPending: T.length,
      subscribe: G,
      abort: M
    };
  }
  function F() {
    S = "failed", y.forEach((Q) => {
      Q(void 0, E);
    });
  }
  function X() {
    T.forEach((Q) => {
      Q.status === "pending" && (Q.status = "aborted");
    }), T = [];
  }
  function ee(Q, Y, pe) {
    const oe = Y !== "success";
    switch (T = T.filter((ne) => ne !== Q), S) {
      case "pending":
        break;
      case "failed":
        if (oe || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (Y === "abort") {
      E = pe, F();
      return;
    }
    if (oe) {
      E = pe, T.length || (m.length ? ue() : F());
      return;
    }
    if (V(), X(), !e.random) {
      const ne = e.resources.indexOf(Q.resource);
      ne !== -1 && ne !== e.index && (e.index = ne);
    }
    S = "completed", y.forEach((ne) => {
      ne(pe);
    });
  }
  function ue() {
    if (S !== "pending")
      return;
    V();
    const Q = m.shift();
    if (Q === void 0) {
      if (T.length) {
        O = setTimeout(() => {
          V(), S === "pending" && (X(), F());
        }, e.timeout);
        return;
      }
      F();
      return;
    }
    const Y = {
      status: "pending",
      resource: Q,
      callback: (pe, oe) => {
        ee(Y, pe, oe);
      }
    };
    T.push(Y), $++, O = setTimeout(ue, e.rotate), o(Q, n, Y.callback);
  }
  return setTimeout(ue), k;
}
function initRedundancy(e) {
  const n = {
    ...defaultConfig,
    ...e
  };
  let o = [];
  function u() {
    o = o.filter((v) => v().status === "pending");
  }
  function c(v, S, $) {
    const E = sendQuery(
      n,
      v,
      S,
      (O, T) => {
        u(), $ && $(O, T);
      }
    );
    return o.push(E), E;
  }
  function d(v) {
    return o.find((S) => v(S)) || null;
  }
  return {
    query: c,
    find: d,
    setIndex: (v) => {
      n.index = v;
    },
    getIndex: () => n.index,
    cleanup: u
  };
}
function emptyCallback$1() {
}
const redundancyCache = /* @__PURE__ */ Object.create(null);
function getRedundancyCache(e) {
  if (!redundancyCache[e]) {
    const n = getAPIConfig(e);
    if (!n)
      return;
    const o = initRedundancy(n), u = {
      config: n,
      redundancy: o
    };
    redundancyCache[e] = u;
  }
  return redundancyCache[e];
}
function sendAPIQuery(e, n, o) {
  let u, c;
  if (typeof e == "string") {
    const d = getAPIModule(e);
    if (!d)
      return o(void 0, 424), emptyCallback$1;
    c = d.send;
    const m = getRedundancyCache(e);
    m && (u = m.redundancy);
  } else {
    const d = createAPIConfig(e);
    if (d) {
      u = initRedundancy(d);
      const m = e.resources ? e.resources[0] : "", v = getAPIModule(m);
      v && (c = v.send);
    }
  }
  return !u || !c ? (o(void 0, 424), emptyCallback$1) : u.query(n, c, o)().abort;
}
const browserCacheVersion = "iconify2", browserCachePrefix = "iconify", browserCacheCountKey = browserCachePrefix + "-count", browserCacheVersionKey = browserCachePrefix + "-version", browserStorageHour = 36e5, browserStorageCacheExpiration = 168;
function getStoredItem(e, n) {
  try {
    return e.getItem(n);
  } catch {
  }
}
function setStoredItem(e, n, o) {
  try {
    return e.setItem(n, o), !0;
  } catch {
  }
}
function removeStoredItem(e, n) {
  try {
    e.removeItem(n);
  } catch {
  }
}
function setBrowserStorageItemsCount(e, n) {
  return setStoredItem(e, browserCacheCountKey, n.toString());
}
function getBrowserStorageItemsCount(e) {
  return parseInt(getStoredItem(e, browserCacheCountKey)) || 0;
}
const browserStorageConfig = {
  local: !0,
  session: !0
}, browserStorageEmptyItems = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let browserStorageStatus = !1;
function setBrowserStorageStatus(e) {
  browserStorageStatus = e;
}
let _window = typeof window > "u" ? {} : window;
function getBrowserStorage(e) {
  const n = e + "Storage";
  try {
    if (_window && _window[n] && typeof _window[n].length == "number")
      return _window[n];
  } catch {
  }
  browserStorageConfig[e] = !1;
}
function iterateBrowserStorage(e, n) {
  const o = getBrowserStorage(e);
  if (!o)
    return;
  const u = getStoredItem(o, browserCacheVersionKey);
  if (u !== browserCacheVersion) {
    if (u) {
      const v = getBrowserStorageItemsCount(o);
      for (let S = 0; S < v; S++)
        removeStoredItem(o, browserCachePrefix + S.toString());
    }
    setStoredItem(o, browserCacheVersionKey, browserCacheVersion), setBrowserStorageItemsCount(o, 0);
    return;
  }
  const c = Math.floor(Date.now() / browserStorageHour) - browserStorageCacheExpiration, d = (v) => {
    const S = browserCachePrefix + v.toString(), $ = getStoredItem(o, S);
    if (typeof $ == "string") {
      try {
        const E = JSON.parse($);
        if (typeof E == "object" && typeof E.cached == "number" && E.cached > c && typeof E.provider == "string" && typeof E.data == "object" && typeof E.data.prefix == "string" && // Valid item: run callback
        n(E, v))
          return !0;
      } catch {
      }
      removeStoredItem(o, S);
    }
  };
  let m = getBrowserStorageItemsCount(o);
  for (let v = m - 1; v >= 0; v--)
    d(v) || (v === m - 1 ? (m--, setBrowserStorageItemsCount(o, m)) : browserStorageEmptyItems[e].add(v));
}
function initBrowserStorage() {
  if (!browserStorageStatus) {
    setBrowserStorageStatus(!0);
    for (const e in browserStorageConfig)
      iterateBrowserStorage(e, (n) => {
        const o = n.data, u = n.provider, c = o.prefix, d = getStorage(
          u,
          c
        );
        if (!addIconSet(d, o).length)
          return !1;
        const m = o.lastModified || -1;
        return d.lastModifiedCached = d.lastModifiedCached ? Math.min(d.lastModifiedCached, m) : m, !0;
      });
  }
}
function updateLastModified(e, n) {
  const o = e.lastModifiedCached;
  if (
    // Matches or newer
    o && o >= n
  )
    return o === n;
  if (e.lastModifiedCached = n, o)
    for (const u in browserStorageConfig)
      iterateBrowserStorage(u, (c) => {
        const d = c.data;
        return c.provider !== e.provider || d.prefix !== e.prefix || d.lastModified === n;
      });
  return !0;
}
function storeInBrowserStorage(e, n) {
  browserStorageStatus || initBrowserStorage();
  function o(u) {
    let c;
    if (!browserStorageConfig[u] || !(c = getBrowserStorage(u)))
      return;
    const d = browserStorageEmptyItems[u];
    let m;
    if (d.size)
      d.delete(m = Array.from(d).shift());
    else if (m = getBrowserStorageItemsCount(c), !setBrowserStorageItemsCount(c, m + 1))
      return;
    const v = {
      cached: Math.floor(Date.now() / browserStorageHour),
      provider: e.provider,
      data: n
    };
    return setStoredItem(
      c,
      browserCachePrefix + m.toString(),
      JSON.stringify(v)
    );
  }
  n.lastModified && !updateLastModified(e, n.lastModified) || Object.keys(n.icons).length && (n.not_found && (n = Object.assign({}, n), delete n.not_found), o("local") || o("session"));
}
function emptyCallback() {
}
function loadedNewIcons(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, updateCallbacks(e);
  }));
}
function loadNewIcons(e, n) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(n).sort() : e.iconsToLoad = n, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: o, prefix: u } = e, c = e.iconsToLoad;
    delete e.iconsToLoad;
    let d;
    if (!c || !(d = getAPIModule(o)))
      return;
    d.prepare(o, u, c).forEach((v) => {
      sendAPIQuery(o, v, (S) => {
        if (typeof S != "object")
          v.icons.forEach(($) => {
            e.missing.add($);
          });
        else
          try {
            const $ = addIconSet(
              e,
              S
            );
            if (!$.length)
              return;
            const E = e.pendingIcons;
            E && $.forEach((O) => {
              E.delete(O);
            }), storeInBrowserStorage(e, S);
          } catch ($) {
            console.error($);
          }
        loadedNewIcons(e);
      });
    });
  }));
}
const loadIcons = (e, n) => {
  const o = listToIcons(e, !0, allowSimpleNames()), u = sortIcons(o);
  if (!u.pending.length) {
    let S = !0;
    return n && setTimeout(() => {
      S && n(
        u.loaded,
        u.missing,
        u.pending,
        emptyCallback
      );
    }), () => {
      S = !1;
    };
  }
  const c = /* @__PURE__ */ Object.create(null), d = [];
  let m, v;
  return u.pending.forEach((S) => {
    const { provider: $, prefix: E } = S;
    if (E === v && $ === m)
      return;
    m = $, v = E, d.push(getStorage($, E));
    const O = c[$] || (c[$] = /* @__PURE__ */ Object.create(null));
    O[E] || (O[E] = []);
  }), u.pending.forEach((S) => {
    const { provider: $, prefix: E, name: O } = S, T = getStorage($, E), y = T.pendingIcons || (T.pendingIcons = /* @__PURE__ */ new Set());
    y.has(O) || (y.add(O), c[$][E].push(O));
  }), d.forEach((S) => {
    const { provider: $, prefix: E } = S;
    c[$][E].length && loadNewIcons(S, c[$][E]);
  }), n ? storeCallback(n, u, d) : emptyCallback;
};
function mergeCustomisations(e, n) {
  const o = {
    ...e
  };
  for (const u in n) {
    const c = n[u], d = typeof c;
    u in defaultIconSizeCustomisations ? (c === null || c && (d === "string" || d === "number")) && (o[u] = c) : d === typeof o[u] && (o[u] = u === "rotate" ? c % 4 : c);
  }
  return o;
}
const separator = /[\s,]+/;
function flipFromString(e, n) {
  n.split(separator).forEach((o) => {
    switch (o.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function rotateFromString(e, n = 0) {
  const o = e.replace(/^-?[0-9.]*/, "");
  function u(c) {
    for (; c < 0; )
      c += 4;
    return c % 4;
  }
  if (o === "") {
    const c = parseInt(e);
    return isNaN(c) ? 0 : u(c);
  } else if (o !== e) {
    let c = 0;
    switch (o) {
      case "%":
        c = 25;
        break;
      case "deg":
        c = 90;
    }
    if (c) {
      let d = parseFloat(e.slice(0, e.length - o.length));
      return isNaN(d) ? 0 : (d = d / c, d % 1 === 0 ? u(d) : 0);
    }
  }
  return n;
}
function iconToHTML(e, n) {
  let o = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const u in n)
    o += " " + u + '="' + n[u] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + o + ">" + e + "</svg>";
}
function encodeSVGforURL(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function svgToData(e) {
  return "data:image/svg+xml," + encodeSVGforURL(e);
}
function svgToURL(e) {
  return 'url("' + svgToData(e) + '")';
}
const defaultExtendedIconCustomisations = {
  ...defaultIconCustomisations,
  inline: !1
}, svgDefaults = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, commonProps = {
  display: "inline-block"
}, monotoneProps = {
  backgroundColor: "currentColor"
}, coloredProps = {
  backgroundColor: "transparent"
}, propsToAdd = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, propsToAddTo = {
  webkitMask: monotoneProps,
  mask: monotoneProps,
  background: coloredProps
};
for (const e in propsToAddTo) {
  const n = propsToAddTo[e];
  for (const o in propsToAdd)
    n[e + o] = propsToAdd[o];
}
const customisationAliases = {};
["horizontal", "vertical"].forEach((e) => {
  const n = e.slice(0, 1) + "Flip";
  customisationAliases[e + "-flip"] = n, customisationAliases[e.slice(0, 1) + "-flip"] = n, customisationAliases[e + "Flip"] = n;
});
function fixSize(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const render = (e, n) => {
  const o = mergeCustomisations(defaultExtendedIconCustomisations, n), u = { ...svgDefaults }, c = n.mode || "svg", d = {}, m = n.style, v = typeof m == "object" && !(m instanceof Array) ? m : {};
  for (let M in n) {
    const G = n[M];
    if (G !== void 0)
      switch (M) {
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
          break;
        case "inline":
        case "hFlip":
        case "vFlip":
          o[M] = G === !0 || G === "true" || G === 1;
          break;
        case "flip":
          typeof G == "string" && flipFromString(o, G);
          break;
        case "color":
          d.color = G;
          break;
        case "rotate":
          typeof G == "string" ? o[M] = rotateFromString(G) : typeof G == "number" && (o[M] = G);
          break;
        case "ariaHidden":
        case "aria-hidden":
          G !== !0 && G !== "true" && delete u["aria-hidden"];
          break;
        default: {
          const k = customisationAliases[M];
          k ? (G === !0 || G === "true" || G === 1) && (o[k] = !0) : defaultExtendedIconCustomisations[M] === void 0 && (u[M] = G);
        }
      }
  }
  const S = iconToSVG(e, o), $ = S.attributes;
  if (o.inline && (d.verticalAlign = "-0.125em"), c === "svg") {
    u.style = {
      ...d,
      ...v
    }, Object.assign(u, $);
    let M = 0, G = n.id;
    return typeof G == "string" && (G = G.replace(/-/g, "_")), u.innerHTML = replaceIDs(S.body, G ? () => G + "ID" + M++ : "iconifyVue"), h("svg", u);
  }
  const { body: E, width: O, height: T } = e, y = c === "mask" || (c === "bg" ? !1 : E.indexOf("currentColor") !== -1), V = iconToHTML(E, {
    ...$,
    width: O + "",
    height: T + ""
  });
  return u.style = {
    ...d,
    "--svg": svgToURL(V),
    width: fixSize($.width),
    height: fixSize($.height),
    ...commonProps,
    ...y ? monotoneProps : coloredProps,
    ...v
  }, h("span", u);
};
allowSimpleNames(!0);
setAPIModule("", fetchAPIModule);
if (typeof document < "u" && typeof window < "u") {
  initBrowserStorage();
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const n = e.IconifyPreload, o = "Invalid IconifyPreload syntax.";
    typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((u) => {
      try {
        // Check if item is an object and not null/array
        (typeof u != "object" || u === null || u instanceof Array || // Check for 'icons' and 'prefix'
        typeof u.icons != "object" || typeof u.prefix != "string" || // Add icon set
        !addCollection(u)) && console.error(o);
      } catch {
        console.error(o);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const n = e.IconifyProviders;
    if (typeof n == "object" && n !== null)
      for (let o in n) {
        const u = "IconifyProviders[" + o + "] is invalid.";
        try {
          const c = n[o];
          if (typeof c != "object" || !c || c.resources === void 0)
            continue;
          addAPIProvider(o, c) || console.error(u);
        } catch {
          console.error(u);
        }
      }
  }
}
const emptyIcon = {
  ...defaultIconProps,
  body: ""
}, Icon = defineComponent({
  // Do not inherit other attributes: it is handled by render()
  inheritAttrs: !1,
  // Set initial data
  data() {
    return {
      // Mounted status
      iconMounted: !1,
      // Callback counter to trigger re-render
      counter: 0
    };
  },
  mounted() {
    this._name = "", this._loadingIcon = null, this.iconMounted = !0;
  },
  unmounted() {
    this.abortLoading();
  },
  methods: {
    abortLoading() {
      this._loadingIcon && (this._loadingIcon.abort(), this._loadingIcon = null);
    },
    // Get data for icon to render or null
    getIcon(e, n) {
      if (typeof e == "object" && e !== null && typeof e.body == "string")
        return this._name = "", this.abortLoading(), {
          data: e
        };
      let o;
      if (typeof e != "string" || (o = stringToIcon(e, !1, !0)) === null)
        return this.abortLoading(), null;
      const u = getIconData(o);
      if (!u)
        return (!this._loadingIcon || this._loadingIcon.name !== e) && (this.abortLoading(), this._name = "", u !== null && (this._loadingIcon = {
          name: e,
          abort: loadIcons([o], () => {
            this.counter++;
          })
        })), null;
      this.abortLoading(), this._name !== e && (this._name = e, n && n(e));
      const c = ["iconify"];
      return o.prefix !== "" && c.push("iconify--" + o.prefix), o.provider !== "" && c.push("iconify--" + o.provider), { data: u, classes: c };
    }
  },
  // Render icon
  render() {
    this.counter;
    const e = this.$attrs, n = this.iconMounted ? this.getIcon(e.icon, e.onLoad) : null;
    if (!n)
      return render(emptyIcon, e);
    let o = e;
    return n.classes && (o = {
      ...e,
      class: (typeof e.class == "string" ? e.class + " " : "") + n.classes.join(" ")
    }), render({
      ...defaultIconProps,
      ...n.data
    }, o);
  }
}), _hoisted_1$2 = { class: "mb-4" }, _hoisted_2$2 = {
  key: 0,
  class: "dropdown dropdown-hover ping-connect-dropdown"
}, _hoisted_3$2 = {
  tabindex: "0",
  class: "btn btn-sm m-1 lowercase"
}, _hoisted_4$1 = {
  tabindex: "0",
  class: "dropdown-content menu shadow p-2 bg-base-100 rounded w-64 overflow-auto"
}, _hoisted_5$2 = { class: "px-2 mb-1 text-gray-500 dark:text-gray-400 font-semibold flex justify-between" }, _hoisted_6$2 = { class: "text-lg" }, _hoisted_7$2 = { class: "ml-2 text-xs mt-2" }, _hoisted_8$2 = { class: "" }, _hoisted_9$2 = /* @__PURE__ */ createBaseVNode("div", { class: "divider mt-1 mb-1" }, null, -1), _hoisted_10$2 = { class: "toast" }, _hoisted_11$2 = { class: "alert alert-success" }, _hoisted_12$2 = { class: "text-sm" }, _hoisted_13$2 = { class: "toast" }, _hoisted_14$2 = { class: "alert alert-error" }, _hoisted_15$2 = { class: "text-sm" }, _hoisted_16$2 = {
  key: 1,
  for: "PingConnectWallet",
  class: "btn btn-sm ping-connect-btn capitalize"
}, _hoisted_17$2 = {
  for: "PingConnectWallet",
  class: "modal cursor-pointer z-[999999]"
}, _hoisted_18$2 = {
  class: "modal-box rounded-lg",
  for: ""
}, _hoisted_19$2 = /* @__PURE__ */ createBaseVNode("h3", { class: "text-xl font-semibold" }, "Connect Wallet", -1), _hoisted_20$2 = {
  role: "list",
  class: "bg-gray-100 dark:bg-gray-900 rounded-lg mt-4 px-3 py-3"
}, _hoisted_21$2 = ["onClick"], _hoisted_22$2 = ["src"], _hoisted_23$2 = { class: "text-base font-semibold flex-1 dark:text-gray-300" }, _hoisted_24$2 = {
  key: 0,
  class: "mr-4 rounded-full bg-green-200"
}, _hoisted_25$2 = { class: "text-error mt-3" }, _hoisted_26$2 = ["href"], _hoisted_27$2 = { class: "mt-8 text-right flex" }, _hoisted_28$2 = {
  key: 0,
  class: "loading loading-spinner"
}, __default__$2 = {
  name: "ConnectWallet",
  components: { Icon }
}, _sfc_main$2 = /* @__PURE__ */ defineComponent({
  ...__default__$2,
  props: {
    chainId: String,
    hdPath: String,
    addrPrefix: String
    // address prefix
  },
  emits: ["connect", "disconnect", "update", "keplr-config"],
  setup(e, { emit: n }) {
    const o = e, u = ref(!1), c = ref(!1), d = ref(""), m = ref(WalletName.Owallet), v = [
      {
        wallet: WalletName.Owallet,
        logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/6d/cf/9c/6dcf9c8f-45d9-37a4-d5c3-0da8d4af0650/AppIcon-0-0-1x_U007emarketing-0-6-0-85-220.png/460x0w.webp"
      },
      {
        wallet: WalletName.Keplr,
        logo: "https://ping.pub/logos/keplr-logo.svg"
      },
      {
        wallet: WalletName.Ledger,
        logo: "https://ping.pub/logos/ledger.webp"
      },
      {
        wallet: WalletName.Leap,
        logo: "https://assets.leapwallet.io/logos/leap-cosmos-logo.svg"
      },
      {
        wallet: WalletName.Metamask,
        logo: "https://ping.pub/logos/metamask.png"
      }
    ];
    async function S() {
    }
    const $ = computed(() => v), E = ref(readWallet(o.hdPath));
    function O(X) {
      m.value = X;
    }
    async function T() {
      u.value = !0, d.value = "";
      let X = [];
      try {
        await createWallet(m.value, {
          chainId: o.chainId,
          hdPath: o.hdPath,
          prefix: o.addrPrefix
        }).getAccounts().then((ue) => {
          if (X = ue, X.length > 0) {
            const [Q] = X;
            E.value = {
              wallet: m.value,
              cosmosAddress: Q.address,
              hdPath: o.hdPath
            }, writeWallet(E.value, o.hdPath), n("connect", {
              value: E.value
            });
          }
          c.value = !1;
        }).catch((ue) => {
          d.value = ue;
        });
      } catch (ee) {
        d.value = ee.message;
      }
      u.value = !1;
    }
    function y() {
      removeWallet(o.hdPath), n("disconnect", { value: E.value }), E.value = {};
    }
    function V() {
      n("keplr-config", {}), c.value = !1;
    }
    let M = ref(0);
    async function G(X) {
      try {
        await navigator.clipboard.writeText(X), M.value = 1, setTimeout(() => {
          M.value = 0;
        }, 1e3);
      } catch {
        M.value = 2, setTimeout(() => {
          M.value = 0;
        }, 1e3);
      }
    }
    const k = computed(() => M.value === 2 ? { class: "error", msg: "Copy Error!" } : { class: "success", msg: "Copy Success!" }), F = computed(() => `${location.protocol}//${location.host}/wallet/keplr?chain=${o.chainId}`);
    return (X, ee) => {
      var ue, Q;
      return openBlock(), createElementBlock("div", _hoisted_1$2, [
        E.value.cosmosAddress ? (openBlock(), createElementBlock("div", _hoisted_2$2, [
          createBaseVNode("label", _hoisted_3$2, toDisplayString(E.value.wallet) + "-" + toDisplayString((Q = E.value.cosmosAddress) == null ? void 0 : Q.substring(
            ((ue = E.value.cosmosAddress) == null ? void 0 : ue.length) - 4
          )), 1),
          createBaseVNode("div", _hoisted_4$1, [
            createBaseVNode("div", _hoisted_5$2, [
              createBaseVNode("span", _hoisted_6$2, toDisplayString(E.value.wallet), 1),
              createBaseVNode("span", _hoisted_7$2, toDisplayString(E.value.hdPath), 1)
            ]),
            createBaseVNode("div", _hoisted_8$2, [
              _hoisted_9$2,
              createBaseVNode("a", {
                class: "block py-2 px-2 hover:bg-gray-100 dark:hover:bg-[#353f5a] rounded cursor-pointer",
                style: { "overflow-wrap": "anywhere" },
                onClick: ee[0] || (ee[0] = (Y) => G(E.value.cosmosAddress))
              }, toDisplayString(E.value.cosmosAddress), 1),
              createBaseVNode("a", {
                class: "block py-2 px-2 hover:bg-gray-100 dark:hover:bg-[#353f5a] rounded cursor-pointer",
                onClick: ee[1] || (ee[1] = (Y) => y())
              }, "Disconnect")
            ])
          ]),
          withDirectives(createBaseVNode("div", _hoisted_10$2, [
            createBaseVNode("div", _hoisted_11$2, [
              createBaseVNode("div", _hoisted_12$2, [
                createBaseVNode("span", null, toDisplayString(k.value.msg), 1)
              ])
            ])
          ], 512), [
            [vShow, unref(M) === 1]
          ]),
          withDirectives(createBaseVNode("div", _hoisted_13$2, [
            createBaseVNode("div", _hoisted_14$2, [
              createBaseVNode("div", _hoisted_15$2, [
                createBaseVNode("span", null, toDisplayString(k.value.msg), 1)
              ])
            ])
          ], 512), [
            [vShow, unref(M) === 2]
          ])
        ])) : createCommentVNode("", !0),
        E.value.cosmosAddress ? createCommentVNode("", !0) : (openBlock(), createElementBlock("label", _hoisted_16$2, "Connect Wallet")),
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": ee[2] || (ee[2] = (Y) => c.value = Y),
          type: "checkbox",
          id: "PingConnectWallet",
          class: "modal-toggle",
          onChange: ee[3] || (ee[3] = (Y) => S())
        }, null, 544), [
          [vModelCheckbox, c.value]
        ]),
        createBaseVNode("label", _hoisted_17$2, [
          createBaseVNode("label", _hoisted_18$2, [
            _hoisted_19$2,
            createBaseVNode("ul", _hoisted_20$2, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList($.value, (Y, pe) => (openBlock(), createElementBlock("li", {
                class: "flex items-center px-2 py-3 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-lg cursor-pointer",
                key: pe,
                onClick: (oe) => O(Y.wallet)
              }, [
                createBaseVNode("img", {
                  class: "h-10 w-10 bg-gray-50 rounded-full mr-4",
                  src: Y.logo,
                  alt: ""
                }, null, 8, _hoisted_22$2),
                createBaseVNode("p", _hoisted_23$2, toDisplayString(Y.wallet), 1),
                createBaseVNode("div", null, [
                  Y.wallet === m.value ? (openBlock(), createElementBlock("div", _hoisted_24$2, [
                    createVNode(unref(Icon), {
                      icon: "mdi:check",
                      class: "font-bold text-green-600"
                    })
                  ])) : createCommentVNode("", !0)
                ])
              ], 8, _hoisted_21$2))), 128))
            ]),
            withDirectives(createBaseVNode("div", _hoisted_25$2, [
              createBaseVNode("span", null, toDisplayString(d.value) + ".", 1),
              withDirectives(createBaseVNode("div", null, [
                createBaseVNode("a", {
                  href: F.value,
                  class: "btn btn-link"
                }, "Suggest a chain to Keplr", 8, _hoisted_26$2)
              ], 512), [
                [vShow, String(d.value).search("no chain info") > -1]
              ])
            ], 512), [
              [vShow, d.value]
            ]),
            createBaseVNode("div", _hoisted_27$2, [
              createBaseVNode("label", {
                class: "btn mr-1",
                onClick: V
              }, [
                createVNode(unref(Icon), { icon: "mdi:cog-outline" })
              ]),
              createBaseVNode("label", {
                class: "btn btn-primary ping-connect-confirm grow",
                onClick: ee[4] || (ee[4] = (Y) => T())
              }, [
                u.value ? (openBlock(), createElementBlock("span", _hoisted_28$2)) : createCommentVNode("", !0),
                createTextVNode(" Connect ")
              ])
            ])
          ])
        ])
      ]);
    };
  }
});
function _typeof(e) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof(e);
}
function _toPrimitive(e, n) {
  if (_typeof(e) !== "object" || e === null)
    return e;
  var o = e[Symbol.toPrimitive];
  if (o !== void 0) {
    var u = o.call(e, n || "default");
    if (_typeof(u) !== "object")
      return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function _toPropertyKey(e) {
  var n = _toPrimitive(e, "string");
  return _typeof(n) === "symbol" ? n : String(n);
}
function _defineProperty(e, n, o) {
  return n = _toPropertyKey(n), n in e ? Object.defineProperty(e, n, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = o, e;
}
minimal.util.Long !== Long$2 && (minimal.util.Long = Long$2, minimal.configure());
var globalThis$1 = (() => {
  if (typeof globalThis$1 < "u")
    return globalThis$1;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global$1 < "u")
    return global$1;
  throw "Unable to locate global object";
})();
globalThis$1.atob;
globalThis$1.btoa;
function isSet(e) {
  return e != null;
}
const setPaginationParams = (e, n) => (n && (typeof (n == null ? void 0 : n.countTotal) < "u" && (e.params["pagination.count_total"] = n.countTotal), typeof (n == null ? void 0 : n.key) < "u" && (e.params["pagination.key"] = Buffer.from(n.key).toString("base64")), typeof (n == null ? void 0 : n.limit) < "u" && (e.params["pagination.limit"] = n.limit.toString()), typeof (n == null ? void 0 : n.offset) < "u" && (e.params["pagination.offset"] = n.offset.toString()), typeof (n == null ? void 0 : n.reverse) < "u" && (e.params["pagination.reverse"] = n.reverse)), e);
function toTimestamp(e) {
  const n = numberToLong(e.getTime() / 1e3), o = e.getTime() % 1e3 * 1e6;
  return {
    seconds: n,
    nanos: o
  };
}
function fromTimestamp(e) {
  let n = e.seconds.toNumber() * 1e3;
  return n += e.nanos / 1e6, new Date(n);
}
function numberToLong(e) {
  return Long$2.fromNumber(e);
}
let HashOp$1;
(function(e) {
  e[e.NO_HASH = 0] = "NO_HASH", e[e.SHA256 = 1] = "SHA256", e[e.SHA512 = 2] = "SHA512", e[e.KECCAK = 3] = "KECCAK", e[e.RIPEMD160 = 4] = "RIPEMD160", e[e.BITCOIN = 5] = "BITCOIN", e[e.SHA512_256 = 6] = "SHA512_256", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(HashOp$1 || (HashOp$1 = {}));
const HashOpSDKType$1 = HashOp$1, HashOpAmino$1 = HashOp$1;
function hashOpFromJSON$1(e) {
  switch (e) {
    case 0:
    case "NO_HASH":
      return HashOp$1.NO_HASH;
    case 1:
    case "SHA256":
      return HashOp$1.SHA256;
    case 2:
    case "SHA512":
      return HashOp$1.SHA512;
    case 3:
    case "KECCAK":
      return HashOp$1.KECCAK;
    case 4:
    case "RIPEMD160":
      return HashOp$1.RIPEMD160;
    case 5:
    case "BITCOIN":
      return HashOp$1.BITCOIN;
    case 6:
    case "SHA512_256":
      return HashOp$1.SHA512_256;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HashOp$1.UNRECOGNIZED;
  }
}
function hashOpToJSON$1(e) {
  switch (e) {
    case HashOp$1.NO_HASH:
      return "NO_HASH";
    case HashOp$1.SHA256:
      return "SHA256";
    case HashOp$1.SHA512:
      return "SHA512";
    case HashOp$1.KECCAK:
      return "KECCAK";
    case HashOp$1.RIPEMD160:
      return "RIPEMD160";
    case HashOp$1.BITCOIN:
      return "BITCOIN";
    case HashOp$1.SHA512_256:
      return "SHA512_256";
    case HashOp$1.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let LengthOp$1;
(function(e) {
  e[e.NO_PREFIX = 0] = "NO_PREFIX", e[e.VAR_PROTO = 1] = "VAR_PROTO", e[e.VAR_RLP = 2] = "VAR_RLP", e[e.FIXED32_BIG = 3] = "FIXED32_BIG", e[e.FIXED32_LITTLE = 4] = "FIXED32_LITTLE", e[e.FIXED64_BIG = 5] = "FIXED64_BIG", e[e.FIXED64_LITTLE = 6] = "FIXED64_LITTLE", e[e.REQUIRE_32_BYTES = 7] = "REQUIRE_32_BYTES", e[e.REQUIRE_64_BYTES = 8] = "REQUIRE_64_BYTES", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(LengthOp$1 || (LengthOp$1 = {}));
const LengthOpSDKType$1 = LengthOp$1, LengthOpAmino$1 = LengthOp$1;
function lengthOpFromJSON$1(e) {
  switch (e) {
    case 0:
    case "NO_PREFIX":
      return LengthOp$1.NO_PREFIX;
    case 1:
    case "VAR_PROTO":
      return LengthOp$1.VAR_PROTO;
    case 2:
    case "VAR_RLP":
      return LengthOp$1.VAR_RLP;
    case 3:
    case "FIXED32_BIG":
      return LengthOp$1.FIXED32_BIG;
    case 4:
    case "FIXED32_LITTLE":
      return LengthOp$1.FIXED32_LITTLE;
    case 5:
    case "FIXED64_BIG":
      return LengthOp$1.FIXED64_BIG;
    case 6:
    case "FIXED64_LITTLE":
      return LengthOp$1.FIXED64_LITTLE;
    case 7:
    case "REQUIRE_32_BYTES":
      return LengthOp$1.REQUIRE_32_BYTES;
    case 8:
    case "REQUIRE_64_BYTES":
      return LengthOp$1.REQUIRE_64_BYTES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LengthOp$1.UNRECOGNIZED;
  }
}
function lengthOpToJSON$1(e) {
  switch (e) {
    case LengthOp$1.NO_PREFIX:
      return "NO_PREFIX";
    case LengthOp$1.VAR_PROTO:
      return "VAR_PROTO";
    case LengthOp$1.VAR_RLP:
      return "VAR_RLP";
    case LengthOp$1.FIXED32_BIG:
      return "FIXED32_BIG";
    case LengthOp$1.FIXED32_LITTLE:
      return "FIXED32_LITTLE";
    case LengthOp$1.FIXED64_BIG:
      return "FIXED64_BIG";
    case LengthOp$1.FIXED64_LITTLE:
      return "FIXED64_LITTLE";
    case LengthOp$1.REQUIRE_32_BYTES:
      return "REQUIRE_32_BYTES";
    case LengthOp$1.REQUIRE_64_BYTES:
      return "REQUIRE_64_BYTES";
    case LengthOp$1.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseExistenceProof$1() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array(),
    leaf: void 0,
    path: []
  };
}
const ExistenceProof$1 = {
  typeUrl: "/cosmos.ics23.v1.ExistenceProof",
  encode(e, n = minimal.Writer.create()) {
    e.key.length !== 0 && n.uint32(10).bytes(e.key), e.value.length !== 0 && n.uint32(18).bytes(e.value), e.leaf !== void 0 && LeafOp$1.encode(e.leaf, n.uint32(26).fork()).ldelim();
    for (const o of e.path)
      InnerOp$1.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseExistenceProof$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.value = o.bytes();
          break;
        case 3:
          c.leaf = LeafOp$1.decode(o, o.uint32());
          break;
        case 4:
          c.path.push(InnerOp$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseExistenceProof$1();
    return c.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), c.value = (o = e.value) !== null && o !== void 0 ? o : new Uint8Array(), c.leaf = e.leaf !== void 0 && e.leaf !== null ? LeafOp$1.fromPartial(e.leaf) : void 0, c.path = ((u = e.path) === null || u === void 0 ? void 0 : u.map((d) => InnerOp$1.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      key: e.key,
      value: e.value,
      leaf: e != null && e.leaf ? LeafOp$1.fromAmino(e.leaf) : void 0,
      path: Array.isArray(e == null ? void 0 : e.path) ? e.path.map((n) => InnerOp$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.value = e.value, n.leaf = e.leaf ? LeafOp$1.toAmino(e.leaf) : void 0, e.path ? n.path = e.path.map((o) => o ? InnerOp$1.toAmino(o) : void 0) : n.path = [], n;
  },
  fromAminoMsg(e) {
    return ExistenceProof$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ExistenceProof",
      value: ExistenceProof$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ExistenceProof$1.decode(e.value);
  },
  toProto(e) {
    return ExistenceProof$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.ExistenceProof",
      value: ExistenceProof$1.encode(e).finish()
    };
  }
};
function createBaseNonExistenceProof$1() {
  return {
    key: new Uint8Array(),
    left: void 0,
    right: void 0
  };
}
const NonExistenceProof$1 = {
  typeUrl: "/cosmos.ics23.v1.NonExistenceProof",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.left !== void 0 && ExistenceProof$1.encode(e.left, n.uint32(18).fork()).ldelim(), e.right !== void 0 && ExistenceProof$1.encode(e.right, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNonExistenceProof$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.left = ExistenceProof$1.decode(o, o.uint32());
          break;
        case 3:
          c.right = ExistenceProof$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseNonExistenceProof$1();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o.left = e.left !== void 0 && e.left !== null ? ExistenceProof$1.fromPartial(e.left) : void 0, o.right = e.right !== void 0 && e.right !== null ? ExistenceProof$1.fromPartial(e.right) : void 0, o;
  },
  fromAmino(e) {
    return {
      key: e.key,
      left: e != null && e.left ? ExistenceProof$1.fromAmino(e.left) : void 0,
      right: e != null && e.right ? ExistenceProof$1.fromAmino(e.right) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.left = e.left ? ExistenceProof$1.toAmino(e.left) : void 0, n.right = e.right ? ExistenceProof$1.toAmino(e.right) : void 0, n;
  },
  fromAminoMsg(e) {
    return NonExistenceProof$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/NonExistenceProof",
      value: NonExistenceProof$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return NonExistenceProof$1.decode(e.value);
  },
  toProto(e) {
    return NonExistenceProof$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.NonExistenceProof",
      value: NonExistenceProof$1.encode(e).finish()
    };
  }
};
function createBaseCommitmentProof$1() {
  return {
    exist: void 0,
    nonexist: void 0,
    batch: void 0,
    compressed: void 0
  };
}
const CommitmentProof$1 = {
  typeUrl: "/cosmos.ics23.v1.CommitmentProof",
  encode(e, n = minimal.Writer.create()) {
    return e.exist !== void 0 && ExistenceProof$1.encode(e.exist, n.uint32(10).fork()).ldelim(), e.nonexist !== void 0 && NonExistenceProof$1.encode(e.nonexist, n.uint32(18).fork()).ldelim(), e.batch !== void 0 && BatchProof$1.encode(e.batch, n.uint32(26).fork()).ldelim(), e.compressed !== void 0 && CompressedBatchProof$1.encode(e.compressed, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommitmentProof$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.exist = ExistenceProof$1.decode(o, o.uint32());
          break;
        case 2:
          c.nonexist = NonExistenceProof$1.decode(o, o.uint32());
          break;
        case 3:
          c.batch = BatchProof$1.decode(o, o.uint32());
          break;
        case 4:
          c.compressed = CompressedBatchProof$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseCommitmentProof$1();
    return n.exist = e.exist !== void 0 && e.exist !== null ? ExistenceProof$1.fromPartial(e.exist) : void 0, n.nonexist = e.nonexist !== void 0 && e.nonexist !== null ? NonExistenceProof$1.fromPartial(e.nonexist) : void 0, n.batch = e.batch !== void 0 && e.batch !== null ? BatchProof$1.fromPartial(e.batch) : void 0, n.compressed = e.compressed !== void 0 && e.compressed !== null ? CompressedBatchProof$1.fromPartial(e.compressed) : void 0, n;
  },
  fromAmino(e) {
    return {
      exist: e != null && e.exist ? ExistenceProof$1.fromAmino(e.exist) : void 0,
      nonexist: e != null && e.nonexist ? NonExistenceProof$1.fromAmino(e.nonexist) : void 0,
      batch: e != null && e.batch ? BatchProof$1.fromAmino(e.batch) : void 0,
      compressed: e != null && e.compressed ? CompressedBatchProof$1.fromAmino(e.compressed) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.exist = e.exist ? ExistenceProof$1.toAmino(e.exist) : void 0, n.nonexist = e.nonexist ? NonExistenceProof$1.toAmino(e.nonexist) : void 0, n.batch = e.batch ? BatchProof$1.toAmino(e.batch) : void 0, n.compressed = e.compressed ? CompressedBatchProof$1.toAmino(e.compressed) : void 0, n;
  },
  fromAminoMsg(e) {
    return CommitmentProof$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CommitmentProof",
      value: CommitmentProof$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CommitmentProof$1.decode(e.value);
  },
  toProto(e) {
    return CommitmentProof$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.CommitmentProof",
      value: CommitmentProof$1.encode(e).finish()
    };
  }
};
function createBaseLeafOp$1() {
  return {
    hash: 0,
    prehashKey: 0,
    prehashValue: 0,
    length: 0,
    prefix: new Uint8Array()
  };
}
const LeafOp$1 = {
  typeUrl: "/cosmos.ics23.v1.LeafOp",
  encode(e, n = minimal.Writer.create()) {
    return e.hash !== 0 && n.uint32(8).int32(e.hash), e.prehashKey !== 0 && n.uint32(16).int32(e.prehashKey), e.prehashValue !== 0 && n.uint32(24).int32(e.prehashValue), e.length !== 0 && n.uint32(32).int32(e.length), e.prefix.length !== 0 && n.uint32(42).bytes(e.prefix), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLeafOp$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.int32();
          break;
        case 2:
          c.prehashKey = o.int32();
          break;
        case 3:
          c.prehashValue = o.int32();
          break;
        case 4:
          c.length = o.int32();
          break;
        case 5:
          c.prefix = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseLeafOp$1();
    return m.hash = (n = e.hash) !== null && n !== void 0 ? n : 0, m.prehashKey = (o = e.prehashKey) !== null && o !== void 0 ? o : 0, m.prehashValue = (u = e.prehashValue) !== null && u !== void 0 ? u : 0, m.length = (c = e.length) !== null && c !== void 0 ? c : 0, m.prefix = (d = e.prefix) !== null && d !== void 0 ? d : new Uint8Array(), m;
  },
  fromAmino(e) {
    return {
      hash: isSet(e.hash) ? hashOpFromJSON$1(e.hash) : 0,
      prehashKey: isSet(e.prehash_key) ? hashOpFromJSON$1(e.prehash_key) : 0,
      prehashValue: isSet(e.prehash_value) ? hashOpFromJSON$1(e.prehash_value) : 0,
      length: isSet(e.length) ? lengthOpFromJSON$1(e.length) : 0,
      prefix: e.prefix
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n.prehash_key = e.prehashKey, n.prehash_value = e.prehashValue, n.length = e.length, n.prefix = e.prefix, n;
  },
  fromAminoMsg(e) {
    return LeafOp$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/LeafOp",
      value: LeafOp$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LeafOp$1.decode(e.value);
  },
  toProto(e) {
    return LeafOp$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.LeafOp",
      value: LeafOp$1.encode(e).finish()
    };
  }
};
function createBaseInnerOp$1() {
  return {
    hash: 0,
    prefix: new Uint8Array(),
    suffix: new Uint8Array()
  };
}
const InnerOp$1 = {
  typeUrl: "/cosmos.ics23.v1.InnerOp",
  encode(e, n = minimal.Writer.create()) {
    return e.hash !== 0 && n.uint32(8).int32(e.hash), e.prefix.length !== 0 && n.uint32(18).bytes(e.prefix), e.suffix.length !== 0 && n.uint32(26).bytes(e.suffix), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInnerOp$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.int32();
          break;
        case 2:
          c.prefix = o.bytes();
          break;
        case 3:
          c.suffix = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseInnerOp$1();
    return c.hash = (n = e.hash) !== null && n !== void 0 ? n : 0, c.prefix = (o = e.prefix) !== null && o !== void 0 ? o : new Uint8Array(), c.suffix = (u = e.suffix) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      hash: isSet(e.hash) ? hashOpFromJSON$1(e.hash) : 0,
      prefix: e.prefix,
      suffix: e.suffix
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n.prefix = e.prefix, n.suffix = e.suffix, n;
  },
  fromAminoMsg(e) {
    return InnerOp$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/InnerOp",
      value: InnerOp$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InnerOp$1.decode(e.value);
  },
  toProto(e) {
    return InnerOp$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.InnerOp",
      value: InnerOp$1.encode(e).finish()
    };
  }
};
function createBaseProofSpec$1() {
  return {
    leafSpec: void 0,
    innerSpec: void 0,
    maxDepth: 0,
    minDepth: 0
  };
}
const ProofSpec$1 = {
  typeUrl: "/cosmos.ics23.v1.ProofSpec",
  encode(e, n = minimal.Writer.create()) {
    return e.leafSpec !== void 0 && LeafOp$1.encode(e.leafSpec, n.uint32(10).fork()).ldelim(), e.innerSpec !== void 0 && InnerSpec$1.encode(e.innerSpec, n.uint32(18).fork()).ldelim(), e.maxDepth !== 0 && n.uint32(24).int32(e.maxDepth), e.minDepth !== 0 && n.uint32(32).int32(e.minDepth), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProofSpec$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.leafSpec = LeafOp$1.decode(o, o.uint32());
          break;
        case 2:
          c.innerSpec = InnerSpec$1.decode(o, o.uint32());
          break;
        case 3:
          c.maxDepth = o.int32();
          break;
        case 4:
          c.minDepth = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseProofSpec$1();
    return u.leafSpec = e.leafSpec !== void 0 && e.leafSpec !== null ? LeafOp$1.fromPartial(e.leafSpec) : void 0, u.innerSpec = e.innerSpec !== void 0 && e.innerSpec !== null ? InnerSpec$1.fromPartial(e.innerSpec) : void 0, u.maxDepth = (n = e.maxDepth) !== null && n !== void 0 ? n : 0, u.minDepth = (o = e.minDepth) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      leafSpec: e != null && e.leaf_spec ? LeafOp$1.fromAmino(e.leaf_spec) : void 0,
      innerSpec: e != null && e.inner_spec ? InnerSpec$1.fromAmino(e.inner_spec) : void 0,
      maxDepth: e.max_depth,
      minDepth: e.min_depth
    };
  },
  toAmino(e) {
    const n = {};
    return n.leaf_spec = e.leafSpec ? LeafOp$1.toAmino(e.leafSpec) : void 0, n.inner_spec = e.innerSpec ? InnerSpec$1.toAmino(e.innerSpec) : void 0, n.max_depth = e.maxDepth, n.min_depth = e.minDepth, n;
  },
  fromAminoMsg(e) {
    return ProofSpec$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ProofSpec",
      value: ProofSpec$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ProofSpec$1.decode(e.value);
  },
  toProto(e) {
    return ProofSpec$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.ProofSpec",
      value: ProofSpec$1.encode(e).finish()
    };
  }
};
function createBaseInnerSpec$1() {
  return {
    childOrder: [],
    childSize: 0,
    minPrefixLength: 0,
    maxPrefixLength: 0,
    emptyChild: new Uint8Array(),
    hash: 0
  };
}
const InnerSpec$1 = {
  typeUrl: "/cosmos.ics23.v1.InnerSpec",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.childOrder)
      n.int32(o);
    return n.ldelim(), e.childSize !== 0 && n.uint32(16).int32(e.childSize), e.minPrefixLength !== 0 && n.uint32(24).int32(e.minPrefixLength), e.maxPrefixLength !== 0 && n.uint32(32).int32(e.maxPrefixLength), e.emptyChild.length !== 0 && n.uint32(42).bytes(e.emptyChild), e.hash !== 0 && n.uint32(48).int32(e.hash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInnerSpec$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.childOrder.push(o.int32());
          } else
            c.childOrder.push(o.int32());
          break;
        case 2:
          c.childSize = o.int32();
          break;
        case 3:
          c.minPrefixLength = o.int32();
          break;
        case 4:
          c.maxPrefixLength = o.int32();
          break;
        case 5:
          c.emptyChild = o.bytes();
          break;
        case 6:
          c.hash = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseInnerSpec$1();
    return v.childOrder = ((n = e.childOrder) === null || n === void 0 ? void 0 : n.map((S) => S)) || [], v.childSize = (o = e.childSize) !== null && o !== void 0 ? o : 0, v.minPrefixLength = (u = e.minPrefixLength) !== null && u !== void 0 ? u : 0, v.maxPrefixLength = (c = e.maxPrefixLength) !== null && c !== void 0 ? c : 0, v.emptyChild = (d = e.emptyChild) !== null && d !== void 0 ? d : new Uint8Array(), v.hash = (m = e.hash) !== null && m !== void 0 ? m : 0, v;
  },
  fromAmino(e) {
    return {
      childOrder: Array.isArray(e == null ? void 0 : e.child_order) ? e.child_order.map((n) => n) : [],
      childSize: e.child_size,
      minPrefixLength: e.min_prefix_length,
      maxPrefixLength: e.max_prefix_length,
      emptyChild: e.empty_child,
      hash: isSet(e.hash) ? hashOpFromJSON$1(e.hash) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.childOrder ? n.child_order = e.childOrder.map((o) => o) : n.child_order = [], n.child_size = e.childSize, n.min_prefix_length = e.minPrefixLength, n.max_prefix_length = e.maxPrefixLength, n.empty_child = e.emptyChild, n.hash = e.hash, n;
  },
  fromAminoMsg(e) {
    return InnerSpec$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/InnerSpec",
      value: InnerSpec$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InnerSpec$1.decode(e.value);
  },
  toProto(e) {
    return InnerSpec$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.InnerSpec",
      value: InnerSpec$1.encode(e).finish()
    };
  }
};
function createBaseBatchProof$1() {
  return {
    entries: []
  };
}
const BatchProof$1 = {
  typeUrl: "/cosmos.ics23.v1.BatchProof",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.entries)
      BatchEntry$1.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBatchProof$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.entries.push(BatchEntry$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseBatchProof$1();
    return o.entries = ((n = e.entries) === null || n === void 0 ? void 0 : n.map((u) => BatchEntry$1.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      entries: Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => BatchEntry$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.entries ? n.entries = e.entries.map((o) => o ? BatchEntry$1.toAmino(o) : void 0) : n.entries = [], n;
  },
  fromAminoMsg(e) {
    return BatchProof$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/BatchProof",
      value: BatchProof$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return BatchProof$1.decode(e.value);
  },
  toProto(e) {
    return BatchProof$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.BatchProof",
      value: BatchProof$1.encode(e).finish()
    };
  }
};
function createBaseBatchEntry$1() {
  return {
    exist: void 0,
    nonexist: void 0
  };
}
const BatchEntry$1 = {
  typeUrl: "/cosmos.ics23.v1.BatchEntry",
  encode(e, n = minimal.Writer.create()) {
    return e.exist !== void 0 && ExistenceProof$1.encode(e.exist, n.uint32(10).fork()).ldelim(), e.nonexist !== void 0 && NonExistenceProof$1.encode(e.nonexist, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBatchEntry$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.exist = ExistenceProof$1.decode(o, o.uint32());
          break;
        case 2:
          c.nonexist = NonExistenceProof$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseBatchEntry$1();
    return n.exist = e.exist !== void 0 && e.exist !== null ? ExistenceProof$1.fromPartial(e.exist) : void 0, n.nonexist = e.nonexist !== void 0 && e.nonexist !== null ? NonExistenceProof$1.fromPartial(e.nonexist) : void 0, n;
  },
  fromAmino(e) {
    return {
      exist: e != null && e.exist ? ExistenceProof$1.fromAmino(e.exist) : void 0,
      nonexist: e != null && e.nonexist ? NonExistenceProof$1.fromAmino(e.nonexist) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.exist = e.exist ? ExistenceProof$1.toAmino(e.exist) : void 0, n.nonexist = e.nonexist ? NonExistenceProof$1.toAmino(e.nonexist) : void 0, n;
  },
  fromAminoMsg(e) {
    return BatchEntry$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/BatchEntry",
      value: BatchEntry$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return BatchEntry$1.decode(e.value);
  },
  toProto(e) {
    return BatchEntry$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.BatchEntry",
      value: BatchEntry$1.encode(e).finish()
    };
  }
};
function createBaseCompressedBatchProof$1() {
  return {
    entries: [],
    lookupInners: []
  };
}
const CompressedBatchProof$1 = {
  typeUrl: "/cosmos.ics23.v1.CompressedBatchProof",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.entries)
      CompressedBatchEntry$1.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.lookupInners)
      InnerOp$1.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompressedBatchProof$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.entries.push(CompressedBatchEntry$1.decode(o, o.uint32()));
          break;
        case 2:
          c.lookupInners.push(InnerOp$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCompressedBatchProof$1();
    return u.entries = ((n = e.entries) === null || n === void 0 ? void 0 : n.map((c) => CompressedBatchEntry$1.fromPartial(c))) || [], u.lookupInners = ((o = e.lookupInners) === null || o === void 0 ? void 0 : o.map((c) => InnerOp$1.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      entries: Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => CompressedBatchEntry$1.fromAmino(n)) : [],
      lookupInners: Array.isArray(e == null ? void 0 : e.lookup_inners) ? e.lookup_inners.map((n) => InnerOp$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.entries ? n.entries = e.entries.map((o) => o ? CompressedBatchEntry$1.toAmino(o) : void 0) : n.entries = [], e.lookupInners ? n.lookup_inners = e.lookupInners.map((o) => o ? InnerOp$1.toAmino(o) : void 0) : n.lookup_inners = [], n;
  },
  fromAminoMsg(e) {
    return CompressedBatchProof$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CompressedBatchProof",
      value: CompressedBatchProof$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CompressedBatchProof$1.decode(e.value);
  },
  toProto(e) {
    return CompressedBatchProof$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.CompressedBatchProof",
      value: CompressedBatchProof$1.encode(e).finish()
    };
  }
};
function createBaseCompressedBatchEntry$1() {
  return {
    exist: void 0,
    nonexist: void 0
  };
}
const CompressedBatchEntry$1 = {
  typeUrl: "/cosmos.ics23.v1.CompressedBatchEntry",
  encode(e, n = minimal.Writer.create()) {
    return e.exist !== void 0 && CompressedExistenceProof$1.encode(e.exist, n.uint32(10).fork()).ldelim(), e.nonexist !== void 0 && CompressedNonExistenceProof$1.encode(e.nonexist, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompressedBatchEntry$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.exist = CompressedExistenceProof$1.decode(o, o.uint32());
          break;
        case 2:
          c.nonexist = CompressedNonExistenceProof$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseCompressedBatchEntry$1();
    return n.exist = e.exist !== void 0 && e.exist !== null ? CompressedExistenceProof$1.fromPartial(e.exist) : void 0, n.nonexist = e.nonexist !== void 0 && e.nonexist !== null ? CompressedNonExistenceProof$1.fromPartial(e.nonexist) : void 0, n;
  },
  fromAmino(e) {
    return {
      exist: e != null && e.exist ? CompressedExistenceProof$1.fromAmino(e.exist) : void 0,
      nonexist: e != null && e.nonexist ? CompressedNonExistenceProof$1.fromAmino(e.nonexist) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.exist = e.exist ? CompressedExistenceProof$1.toAmino(e.exist) : void 0, n.nonexist = e.nonexist ? CompressedNonExistenceProof$1.toAmino(e.nonexist) : void 0, n;
  },
  fromAminoMsg(e) {
    return CompressedBatchEntry$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CompressedBatchEntry",
      value: CompressedBatchEntry$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CompressedBatchEntry$1.decode(e.value);
  },
  toProto(e) {
    return CompressedBatchEntry$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.CompressedBatchEntry",
      value: CompressedBatchEntry$1.encode(e).finish()
    };
  }
};
function createBaseCompressedExistenceProof$1() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array(),
    leaf: void 0,
    path: []
  };
}
const CompressedExistenceProof$1 = {
  typeUrl: "/cosmos.ics23.v1.CompressedExistenceProof",
  encode(e, n = minimal.Writer.create()) {
    e.key.length !== 0 && n.uint32(10).bytes(e.key), e.value.length !== 0 && n.uint32(18).bytes(e.value), e.leaf !== void 0 && LeafOp$1.encode(e.leaf, n.uint32(26).fork()).ldelim(), n.uint32(34).fork();
    for (const o of e.path)
      n.int32(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompressedExistenceProof$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.value = o.bytes();
          break;
        case 3:
          c.leaf = LeafOp$1.decode(o, o.uint32());
          break;
        case 4:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.path.push(o.int32());
          } else
            c.path.push(o.int32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseCompressedExistenceProof$1();
    return c.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), c.value = (o = e.value) !== null && o !== void 0 ? o : new Uint8Array(), c.leaf = e.leaf !== void 0 && e.leaf !== null ? LeafOp$1.fromPartial(e.leaf) : void 0, c.path = ((u = e.path) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c;
  },
  fromAmino(e) {
    return {
      key: e.key,
      value: e.value,
      leaf: e != null && e.leaf ? LeafOp$1.fromAmino(e.leaf) : void 0,
      path: Array.isArray(e == null ? void 0 : e.path) ? e.path.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.value = e.value, n.leaf = e.leaf ? LeafOp$1.toAmino(e.leaf) : void 0, e.path ? n.path = e.path.map((o) => o) : n.path = [], n;
  },
  fromAminoMsg(e) {
    return CompressedExistenceProof$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CompressedExistenceProof",
      value: CompressedExistenceProof$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CompressedExistenceProof$1.decode(e.value);
  },
  toProto(e) {
    return CompressedExistenceProof$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.CompressedExistenceProof",
      value: CompressedExistenceProof$1.encode(e).finish()
    };
  }
};
function createBaseCompressedNonExistenceProof$1() {
  return {
    key: new Uint8Array(),
    left: void 0,
    right: void 0
  };
}
const CompressedNonExistenceProof$1 = {
  typeUrl: "/cosmos.ics23.v1.CompressedNonExistenceProof",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.left !== void 0 && CompressedExistenceProof$1.encode(e.left, n.uint32(18).fork()).ldelim(), e.right !== void 0 && CompressedExistenceProof$1.encode(e.right, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompressedNonExistenceProof$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.left = CompressedExistenceProof$1.decode(o, o.uint32());
          break;
        case 3:
          c.right = CompressedExistenceProof$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseCompressedNonExistenceProof$1();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o.left = e.left !== void 0 && e.left !== null ? CompressedExistenceProof$1.fromPartial(e.left) : void 0, o.right = e.right !== void 0 && e.right !== null ? CompressedExistenceProof$1.fromPartial(e.right) : void 0, o;
  },
  fromAmino(e) {
    return {
      key: e.key,
      left: e != null && e.left ? CompressedExistenceProof$1.fromAmino(e.left) : void 0,
      right: e != null && e.right ? CompressedExistenceProof$1.fromAmino(e.right) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.left = e.left ? CompressedExistenceProof$1.toAmino(e.left) : void 0, n.right = e.right ? CompressedExistenceProof$1.toAmino(e.right) : void 0, n;
  },
  fromAminoMsg(e) {
    return CompressedNonExistenceProof$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CompressedNonExistenceProof",
      value: CompressedNonExistenceProof$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CompressedNonExistenceProof$1.decode(e.value);
  },
  toProto(e) {
    return CompressedNonExistenceProof$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.ics23.v1.CompressedNonExistenceProof",
      value: CompressedNonExistenceProof$1.encode(e).finish()
    };
  }
}, _0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BatchEntry: BatchEntry$1,
  BatchProof: BatchProof$1,
  CommitmentProof: CommitmentProof$1,
  CompressedBatchEntry: CompressedBatchEntry$1,
  CompressedBatchProof: CompressedBatchProof$1,
  CompressedExistenceProof: CompressedExistenceProof$1,
  CompressedNonExistenceProof: CompressedNonExistenceProof$1,
  ExistenceProof: ExistenceProof$1,
  get HashOp() {
    return HashOp$1;
  },
  HashOpAmino: HashOpAmino$1,
  HashOpSDKType: HashOpSDKType$1,
  InnerOp: InnerOp$1,
  InnerSpec: InnerSpec$1,
  LeafOp: LeafOp$1,
  get LengthOp() {
    return LengthOp$1;
  },
  LengthOpAmino: LengthOpAmino$1,
  LengthOpSDKType: LengthOpSDKType$1,
  NonExistenceProof: NonExistenceProof$1,
  ProofSpec: ProofSpec$1,
  hashOpFromJSON: hashOpFromJSON$1,
  hashOpToJSON: hashOpToJSON$1,
  lengthOpFromJSON: lengthOpFromJSON$1,
  lengthOpToJSON: lengthOpToJSON$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseAny() {
  return {
    $typeUrl: "/google.protobuf.Any",
    typeUrl: "",
    value: new Uint8Array()
  };
}
const Any = {
  typeUrl: "/google.protobuf.Any",
  encode(e, n = minimal.Writer.create()) {
    return e.typeUrl !== "" && n.uint32(10).string(e.typeUrl), e.value.length !== 0 && n.uint32(18).bytes(e.value), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAny();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.typeUrl = o.string();
          break;
        case 2:
          c.value = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseAny();
    return u.typeUrl = (n = e.typeUrl) !== null && n !== void 0 ? n : "", u.value = (o = e.value) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      typeUrl: e.type_url,
      value: e.value
    };
  },
  toAmino(e) {
    const n = {};
    return n.type_url = e.typeUrl, n.value = e.value, n;
  },
  fromAminoMsg(e) {
    return Any.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Any.decode(e.value);
  },
  toProto(e) {
    return Any.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.Any",
      value: Any.encode(e).finish()
    };
  }
}, _183 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any
}, Symbol.toStringTag, { value: "Module" }));
function createBaseBaseAccount() {
  return {
    $typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
    address: "",
    pubKey: void 0,
    accountNumber: Long$2.UZERO,
    sequence: Long$2.UZERO
  };
}
const BaseAccount = {
  typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.pubKey !== void 0 && Any.encode(e.pubKey, n.uint32(18).fork()).ldelim(), e.accountNumber.isZero() || n.uint32(24).uint64(e.accountNumber), e.sequence.isZero() || n.uint32(32).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBaseAccount();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.pubKey = Any.decode(o, o.uint32());
          break;
        case 3:
          c.accountNumber = o.uint64();
          break;
        case 4:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseBaseAccount();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o.pubKey = e.pubKey !== void 0 && e.pubKey !== null ? Any.fromPartial(e.pubKey) : void 0, o.accountNumber = e.accountNumber !== void 0 && e.accountNumber !== null ? Long$2.fromValue(e.accountNumber) : Long$2.UZERO, o.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      pubKey: e != null && e.pub_key ? Any.fromAmino(e.pub_key) : void 0,
      accountNumber: Long$2.fromString(e.account_number),
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.pub_key = e.pubKey ? Any.toAmino(e.pubKey) : void 0, n.account_number = e.accountNumber ? e.accountNumber.toString() : void 0, n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return BaseAccount.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/BaseAccount",
      value: BaseAccount.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return BaseAccount.decode(e.value);
  },
  toProto(e) {
    return BaseAccount.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
      value: BaseAccount.encode(e).finish()
    };
  }
};
function createBaseModuleAccount() {
  return {
    $typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",
    baseAccount: void 0,
    name: "",
    permissions: []
  };
}
const ModuleAccount = {
  typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",
  encode(e, n = minimal.Writer.create()) {
    e.baseAccount !== void 0 && BaseAccount.encode(e.baseAccount, n.uint32(10).fork()).ldelim(), e.name !== "" && n.uint32(18).string(e.name);
    for (const o of e.permissions)
      n.uint32(26).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleAccount();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.baseAccount = BaseAccount.decode(o, o.uint32());
          break;
        case 2:
          c.name = o.string();
          break;
        case 3:
          c.permissions.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseModuleAccount();
    return u.baseAccount = e.baseAccount !== void 0 && e.baseAccount !== null ? BaseAccount.fromPartial(e.baseAccount) : void 0, u.name = (n = e.name) !== null && n !== void 0 ? n : "", u.permissions = ((o = e.permissions) === null || o === void 0 ? void 0 : o.map((c) => c)) || [], u;
  },
  fromAmino(e) {
    return {
      baseAccount: e != null && e.base_account ? BaseAccount.fromAmino(e.base_account) : void 0,
      name: e.name,
      permissions: Array.isArray(e == null ? void 0 : e.permissions) ? e.permissions.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.base_account = e.baseAccount ? BaseAccount.toAmino(e.baseAccount) : void 0, n.name = e.name, e.permissions ? n.permissions = e.permissions.map((o) => o) : n.permissions = [], n;
  },
  fromAminoMsg(e) {
    return ModuleAccount.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ModuleAccount",
      value: ModuleAccount.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleAccount.decode(e.value);
  },
  toProto(e) {
    return ModuleAccount.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",
      value: ModuleAccount.encode(e).finish()
    };
  }
};
function createBaseParams$m() {
  return {
    maxMemoCharacters: Long$2.UZERO,
    txSigLimit: Long$2.UZERO,
    txSizeCostPerByte: Long$2.UZERO,
    sigVerifyCostEd25519: Long$2.UZERO,
    sigVerifyCostSecp256k1: Long$2.UZERO
  };
}
const Params$n = {
  typeUrl: "/cosmos.auth.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.maxMemoCharacters.isZero() || n.uint32(8).uint64(e.maxMemoCharacters), e.txSigLimit.isZero() || n.uint32(16).uint64(e.txSigLimit), e.txSizeCostPerByte.isZero() || n.uint32(24).uint64(e.txSizeCostPerByte), e.sigVerifyCostEd25519.isZero() || n.uint32(32).uint64(e.sigVerifyCostEd25519), e.sigVerifyCostSecp256k1.isZero() || n.uint32(40).uint64(e.sigVerifyCostSecp256k1), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$m();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.maxMemoCharacters = o.uint64();
          break;
        case 2:
          c.txSigLimit = o.uint64();
          break;
        case 3:
          c.txSizeCostPerByte = o.uint64();
          break;
        case 4:
          c.sigVerifyCostEd25519 = o.uint64();
          break;
        case 5:
          c.sigVerifyCostSecp256k1 = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseParams$m();
    return n.maxMemoCharacters = e.maxMemoCharacters !== void 0 && e.maxMemoCharacters !== null ? Long$2.fromValue(e.maxMemoCharacters) : Long$2.UZERO, n.txSigLimit = e.txSigLimit !== void 0 && e.txSigLimit !== null ? Long$2.fromValue(e.txSigLimit) : Long$2.UZERO, n.txSizeCostPerByte = e.txSizeCostPerByte !== void 0 && e.txSizeCostPerByte !== null ? Long$2.fromValue(e.txSizeCostPerByte) : Long$2.UZERO, n.sigVerifyCostEd25519 = e.sigVerifyCostEd25519 !== void 0 && e.sigVerifyCostEd25519 !== null ? Long$2.fromValue(e.sigVerifyCostEd25519) : Long$2.UZERO, n.sigVerifyCostSecp256k1 = e.sigVerifyCostSecp256k1 !== void 0 && e.sigVerifyCostSecp256k1 !== null ? Long$2.fromValue(e.sigVerifyCostSecp256k1) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      maxMemoCharacters: Long$2.fromString(e.max_memo_characters),
      txSigLimit: Long$2.fromString(e.tx_sig_limit),
      txSizeCostPerByte: Long$2.fromString(e.tx_size_cost_per_byte),
      sigVerifyCostEd25519: Long$2.fromString(e.sig_verify_cost_ed25519),
      sigVerifyCostSecp256k1: Long$2.fromString(e.sig_verify_cost_secp256k1)
    };
  },
  toAmino(e) {
    const n = {};
    return n.max_memo_characters = e.maxMemoCharacters ? e.maxMemoCharacters.toString() : void 0, n.tx_sig_limit = e.txSigLimit ? e.txSigLimit.toString() : void 0, n.tx_size_cost_per_byte = e.txSizeCostPerByte ? e.txSizeCostPerByte.toString() : void 0, n.sig_verify_cost_ed25519 = e.sigVerifyCostEd25519 ? e.sigVerifyCostEd25519.toString() : void 0, n.sig_verify_cost_secp256k1 = e.sigVerifyCostSecp256k1 ? e.sigVerifyCostSecp256k1.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Params$n.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/x/auth/Params",
      value: Params$n.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$n.decode(e.value);
  },
  toProto(e) {
    return Params$n.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.Params",
      value: Params$n.encode(e).finish()
    };
  }
}, _1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseAccount,
  ModuleAccount,
  Params: Params$n
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$t() {
  return {
    params: void 0,
    accounts: []
  };
}
const GenesisState$t = {
  typeUrl: "/cosmos.auth.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$n.encode(e.params, n.uint32(10).fork()).ldelim();
    for (const o of e.accounts)
      Any.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$t();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$n.decode(o, o.uint32());
          break;
        case 2:
          c.accounts.push(Any.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$t();
    return o.params = e.params !== void 0 && e.params !== null ? Params$n.fromPartial(e.params) : void 0, o.accounts = ((n = e.accounts) === null || n === void 0 ? void 0 : n.map((u) => Any.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$n.fromAmino(e.params) : void 0,
      accounts: Array.isArray(e == null ? void 0 : e.accounts) ? e.accounts.map((n) => Any.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$n.toAmino(e.params) : void 0, e.accounts ? n.accounts = e.accounts.map((o) => o ? Any.toAmino(o) : void 0) : n.accounts = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$t.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$t.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$t.decode(e.value);
  },
  toProto(e) {
    return GenesisState$t.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.GenesisState",
      value: GenesisState$t.encode(e).finish()
    };
  }
}, _2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$t
}, Symbol.toStringTag, { value: "Module" }));
function createBasePageRequest() {
  return {
    key: new Uint8Array(),
    offset: Long$2.UZERO,
    limit: Long$2.UZERO,
    countTotal: !1,
    reverse: !1
  };
}
const PageRequest = {
  typeUrl: "/cosmos.base.query.v1beta1.PageRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.offset.isZero() || n.uint32(16).uint64(e.offset), e.limit.isZero() || n.uint32(24).uint64(e.limit), e.countTotal === !0 && n.uint32(32).bool(e.countTotal), e.reverse === !0 && n.uint32(40).bool(e.reverse), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePageRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.offset = o.uint64();
          break;
        case 3:
          c.limit = o.uint64();
          break;
        case 4:
          c.countTotal = o.bool();
          break;
        case 5:
          c.reverse = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBasePageRequest();
    return c.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), c.offset = e.offset !== void 0 && e.offset !== null ? Long$2.fromValue(e.offset) : Long$2.UZERO, c.limit = e.limit !== void 0 && e.limit !== null ? Long$2.fromValue(e.limit) : Long$2.UZERO, c.countTotal = (o = e.countTotal) !== null && o !== void 0 ? o : !1, c.reverse = (u = e.reverse) !== null && u !== void 0 ? u : !1, c;
  },
  fromAmino(e) {
    return {
      key: e.key,
      offset: Long$2.fromString(e.offset),
      limit: Long$2.fromString(e.limit),
      countTotal: e.count_total,
      reverse: e.reverse
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.offset = e.offset ? e.offset.toString() : void 0, n.limit = e.limit ? e.limit.toString() : void 0, n.count_total = e.countTotal, n.reverse = e.reverse, n;
  },
  fromAminoMsg(e) {
    return PageRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PageRequest",
      value: PageRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PageRequest.decode(e.value);
  },
  toProto(e) {
    return PageRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.query.v1beta1.PageRequest",
      value: PageRequest.encode(e).finish()
    };
  }
};
function createBasePageResponse() {
  return {
    nextKey: new Uint8Array(),
    total: Long$2.UZERO
  };
}
const PageResponse = {
  typeUrl: "/cosmos.base.query.v1beta1.PageResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.nextKey.length !== 0 && n.uint32(10).bytes(e.nextKey), e.total.isZero() || n.uint32(16).uint64(e.total), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePageResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.nextKey = o.bytes();
          break;
        case 2:
          c.total = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePageResponse();
    return o.nextKey = (n = e.nextKey) !== null && n !== void 0 ? n : new Uint8Array(), o.total = e.total !== void 0 && e.total !== null ? Long$2.fromValue(e.total) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      nextKey: e.next_key,
      total: Long$2.fromString(e.total)
    };
  },
  toAmino(e) {
    const n = {};
    return n.next_key = e.nextKey, n.total = e.total ? e.total.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return PageResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PageResponse",
      value: PageResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PageResponse.decode(e.value);
  },
  toProto(e) {
    return PageResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.query.v1beta1.PageResponse",
      value: PageResponse.encode(e).finish()
    };
  }
}, _16 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PageRequest,
  PageResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryAccountsRequest() {
  return {
    pagination: void 0
  };
}
const QueryAccountsRequest = {
  typeUrl: "/cosmos.auth.v1beta1.QueryAccountsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAccountsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryAccountsRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryAccountsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryAccountsRequest",
      value: QueryAccountsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAccountsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryAccountsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryAccountsRequest",
      value: QueryAccountsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryAccountsResponse() {
  return {
    accounts: [],
    pagination: void 0
  };
}
const QueryAccountsResponse = {
  typeUrl: "/cosmos.auth.v1beta1.QueryAccountsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.accounts)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAccountsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.accounts.push(AccountI_InterfaceDecoder(o));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryAccountsResponse();
    return o.accounts = ((n = e.accounts) === null || n === void 0 ? void 0 : n.map((u) => Any.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      accounts: Array.isArray(e == null ? void 0 : e.accounts) ? e.accounts.map((n) => AccountI_FromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.accounts ? n.accounts = e.accounts.map((o) => o ? AccountI_ToAmino(o) : void 0) : n.accounts = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryAccountsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryAccountsResponse",
      value: QueryAccountsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAccountsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryAccountsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryAccountsResponse",
      value: QueryAccountsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryAccountRequest() {
  return {
    address: ""
  };
}
const QueryAccountRequest = {
  typeUrl: "/cosmos.auth.v1beta1.QueryAccountRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAccountRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryAccountRequest();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      address: e.address
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n;
  },
  fromAminoMsg(e) {
    return QueryAccountRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryAccountRequest",
      value: QueryAccountRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAccountRequest.decode(e.value);
  },
  toProto(e) {
    return QueryAccountRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryAccountRequest",
      value: QueryAccountRequest.encode(e).finish()
    };
  }
};
function createBaseQueryAccountResponse() {
  return {
    account: void 0
  };
}
const QueryAccountResponse = {
  typeUrl: "/cosmos.auth.v1beta1.QueryAccountResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.account !== void 0 && Any.encode(e.account, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAccountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.account = AccountI_InterfaceDecoder(o);
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryAccountResponse();
    return n.account = e.account !== void 0 && e.account !== null ? Any.fromPartial(e.account) : void 0, n;
  },
  fromAmino(e) {
    return {
      account: e != null && e.account ? AccountI_FromAmino(e.account) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.account = e.account ? AccountI_ToAmino(e.account) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryAccountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryAccountResponse",
      value: QueryAccountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAccountResponse.decode(e.value);
  },
  toProto(e) {
    return QueryAccountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryAccountResponse",
      value: QueryAccountResponse.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$f() {
  return {};
}
const QueryParamsRequest$f = {
  typeUrl: "/cosmos.auth.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$f();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$f();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$f.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest$f.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$f.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$f.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest$f.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$f() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$f = {
  typeUrl: "/cosmos.auth.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$n.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$f();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$n.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$f();
    return n.params = e.params !== void 0 && e.params !== null ? Params$n.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$n.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$n.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$f.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse$f.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$f.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$f.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse$f.encode(e).finish()
    };
  }
};
function createBaseQueryModuleAccountsRequest() {
  return {};
}
const QueryModuleAccountsRequest = {
  typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryModuleAccountsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryModuleAccountsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryModuleAccountsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryModuleAccountsRequest",
      value: QueryModuleAccountsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryModuleAccountsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryModuleAccountsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsRequest",
      value: QueryModuleAccountsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryModuleAccountsResponse() {
  return {
    accounts: []
  };
}
const QueryModuleAccountsResponse = {
  typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.accounts)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryModuleAccountsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.accounts.push(ModuleAccountI_InterfaceDecoder(o));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryModuleAccountsResponse();
    return o.accounts = ((n = e.accounts) === null || n === void 0 ? void 0 : n.map((u) => Any.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      accounts: Array.isArray(e == null ? void 0 : e.accounts) ? e.accounts.map((n) => ModuleAccountI_FromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.accounts ? n.accounts = e.accounts.map((o) => o ? ModuleAccountI_ToAmino(o) : void 0) : n.accounts = [], n;
  },
  fromAminoMsg(e) {
    return QueryModuleAccountsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryModuleAccountsResponse",
      value: QueryModuleAccountsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryModuleAccountsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryModuleAccountsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsResponse",
      value: QueryModuleAccountsResponse.encode(e).finish()
    };
  }
}, AccountI_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/cosmos.auth.v1beta1.BaseAccount":
      return BaseAccount.decode(o.value);
    default:
      return o;
  }
}, AccountI_FromAmino = (e) => {
  switch (e.type) {
    case "cosmos-sdk/BaseAccount":
      return Any.fromPartial({
        typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
        value: BaseAccount.encode(BaseAccount.fromPartial(BaseAccount.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, AccountI_ToAmino = (e) => {
  switch (e.typeUrl) {
    case "/cosmos.auth.v1beta1.BaseAccount":
      return {
        type: "cosmos-sdk/BaseAccount",
        value: BaseAccount.toAmino(BaseAccount.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, ModuleAccountI_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/cosmos.auth.v1beta1.ModuleAccount":
      return ModuleAccount.decode(o.value);
    default:
      return o;
  }
}, ModuleAccountI_FromAmino = (e) => {
  switch (e.type) {
    case "cosmos-sdk/ModuleAccount":
      return Any.fromPartial({
        typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",
        value: ModuleAccount.encode(ModuleAccount.fromPartial(ModuleAccount.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, ModuleAccountI_ToAmino = (e) => {
  switch (e.typeUrl) {
    case "/cosmos.auth.v1beta1.ModuleAccount":
      return {
        type: "cosmos-sdk/ModuleAccount",
        value: ModuleAccount.toAmino(ModuleAccount.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountI_FromAmino,
  AccountI_InterfaceDecoder,
  AccountI_ToAmino,
  ModuleAccountI_FromAmino,
  ModuleAccountI_InterfaceDecoder,
  ModuleAccountI_ToAmino,
  QueryAccountRequest,
  QueryAccountResponse,
  QueryAccountsRequest,
  QueryAccountsResponse,
  QueryModuleAccountsRequest,
  QueryModuleAccountsResponse,
  QueryParamsRequest: QueryParamsRequest$f,
  QueryParamsResponse: QueryParamsResponse$f
}, Symbol.toStringTag, { value: "Module" }));
function createBaseTimestamp() {
  return {
    seconds: Long$2.ZERO,
    nanos: 0
  };
}
const Timestamp = {
  typeUrl: "/google.protobuf.Timestamp",
  encode(e, n = minimal.Writer.create()) {
    return e.seconds.isZero() || n.uint32(8).int64(e.seconds), e.nanos !== 0 && n.uint32(16).int32(e.nanos), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTimestamp();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.seconds = o.int64();
          break;
        case 2:
          c.nanos = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseTimestamp();
    return o.seconds = e.seconds !== void 0 && e.seconds !== null ? Long$2.fromValue(e.seconds) : Long$2.ZERO, o.nanos = (n = e.nanos) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      seconds: Long$2.fromString(e.seconds),
      nanos: e.nanos
    };
  },
  toAmino(e) {
    const n = {};
    return n.seconds = e.seconds ? e.seconds.toString() : void 0, n.nanos = e.nanos, n;
  },
  fromAminoMsg(e) {
    return Timestamp.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Timestamp.decode(e.value);
  },
  toProto(e) {
    return Timestamp.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.Timestamp",
      value: Timestamp.encode(e).finish()
    };
  }
}, _187 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Timestamp
}, Symbol.toStringTag, { value: "Module" }));
function createBaseCoin() {
  return {
    denom: "",
    amount: ""
  };
}
const Coin = {
  typeUrl: "/cosmos.base.v1beta1.Coin",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.amount !== "" && n.uint32(18).string(e.amount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCoin();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.amount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCoin();
    return u.denom = (n = e.denom) !== null && n !== void 0 ? n : "", u.amount = (o = e.amount) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      amount: e.amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.amount = e.amount, n;
  },
  fromAminoMsg(e) {
    return Coin.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Coin",
      value: Coin.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Coin.decode(e.value);
  },
  toProto(e) {
    return Coin.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.v1beta1.Coin",
      value: Coin.encode(e).finish()
    };
  }
};
function createBaseDecCoin() {
  return {
    denom: "",
    amount: ""
  };
}
const DecCoin = {
  typeUrl: "/cosmos.base.v1beta1.DecCoin",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.amount !== "" && n.uint32(18).string(e.amount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDecCoin();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.amount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDecCoin();
    return u.denom = (n = e.denom) !== null && n !== void 0 ? n : "", u.amount = (o = e.amount) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      amount: e.amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.amount = e.amount, n;
  },
  fromAminoMsg(e) {
    return DecCoin.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DecCoin",
      value: DecCoin.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DecCoin.decode(e.value);
  },
  toProto(e) {
    return DecCoin.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.v1beta1.DecCoin",
      value: DecCoin.encode(e).finish()
    };
  }
};
function createBaseIntProto() {
  return {
    int: ""
  };
}
const IntProto = {
  typeUrl: "/cosmos.base.v1beta1.IntProto",
  encode(e, n = minimal.Writer.create()) {
    return e.int !== "" && n.uint32(10).string(e.int), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIntProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.int = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseIntProto();
    return o.int = (n = e.int) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      int: e.int
    };
  },
  toAmino(e) {
    const n = {};
    return n.int = e.int, n;
  },
  fromAminoMsg(e) {
    return IntProto.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/IntProto",
      value: IntProto.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return IntProto.decode(e.value);
  },
  toProto(e) {
    return IntProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.v1beta1.IntProto",
      value: IntProto.encode(e).finish()
    };
  }
};
function createBaseDecProto() {
  return {
    dec: ""
  };
}
const DecProto = {
  typeUrl: "/cosmos.base.v1beta1.DecProto",
  encode(e, n = minimal.Writer.create()) {
    return e.dec !== "" && n.uint32(10).string(e.dec), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDecProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.dec = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDecProto();
    return o.dec = (n = e.dec) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      dec: e.dec
    };
  },
  toAmino(e) {
    const n = {};
    return n.dec = e.dec, n;
  },
  fromAminoMsg(e) {
    return DecProto.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DecProto",
      value: DecProto.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DecProto.decode(e.value);
  },
  toProto(e) {
    return DecProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.v1beta1.DecProto",
      value: DecProto.encode(e).finish()
    };
  }
}, _18 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Coin,
  DecCoin,
  DecProto,
  IntProto
}, Symbol.toStringTag, { value: "Module" }));
function createBaseSendAuthorization() {
  return {
    $typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
    spendLimit: []
  };
}
const SendAuthorization = {
  typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.spendLimit)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSendAuthorization();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.spendLimit.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSendAuthorization();
    return o.spendLimit = ((n = e.spendLimit) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      spendLimit: Array.isArray(e == null ? void 0 : e.spend_limit) ? e.spend_limit.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.spendLimit ? n.spend_limit = e.spendLimit.map((o) => o ? Coin.toAmino(o) : void 0) : n.spend_limit = [], n;
  },
  fromAminoMsg(e) {
    return SendAuthorization.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SendAuthorization",
      value: SendAuthorization.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SendAuthorization.decode(e.value);
  },
  toProto(e) {
    return SendAuthorization.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
      value: SendAuthorization.encode(e).finish()
    };
  }
}, _9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SendAuthorization
}, Symbol.toStringTag, { value: "Module" }));
let AuthorizationType;
(function(e) {
  e[e.AUTHORIZATION_TYPE_UNSPECIFIED = 0] = "AUTHORIZATION_TYPE_UNSPECIFIED", e[e.AUTHORIZATION_TYPE_DELEGATE = 1] = "AUTHORIZATION_TYPE_DELEGATE", e[e.AUTHORIZATION_TYPE_UNDELEGATE = 2] = "AUTHORIZATION_TYPE_UNDELEGATE", e[e.AUTHORIZATION_TYPE_REDELEGATE = 3] = "AUTHORIZATION_TYPE_REDELEGATE", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(AuthorizationType || (AuthorizationType = {}));
const AuthorizationTypeSDKType = AuthorizationType, AuthorizationTypeAmino = AuthorizationType;
function authorizationTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "AUTHORIZATION_TYPE_UNSPECIFIED":
      return AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED;
    case 1:
    case "AUTHORIZATION_TYPE_DELEGATE":
      return AuthorizationType.AUTHORIZATION_TYPE_DELEGATE;
    case 2:
    case "AUTHORIZATION_TYPE_UNDELEGATE":
      return AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE;
    case 3:
    case "AUTHORIZATION_TYPE_REDELEGATE":
      return AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthorizationType.UNRECOGNIZED;
  }
}
function authorizationTypeToJSON(e) {
  switch (e) {
    case AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED:
      return "AUTHORIZATION_TYPE_UNSPECIFIED";
    case AuthorizationType.AUTHORIZATION_TYPE_DELEGATE:
      return "AUTHORIZATION_TYPE_DELEGATE";
    case AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE:
      return "AUTHORIZATION_TYPE_UNDELEGATE";
    case AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE:
      return "AUTHORIZATION_TYPE_REDELEGATE";
    case AuthorizationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseStakeAuthorization() {
  return {
    $typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
    maxTokens: void 0,
    allowList: void 0,
    denyList: void 0,
    authorizationType: 0
  };
}
const StakeAuthorization = {
  typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
  encode(e, n = minimal.Writer.create()) {
    return e.maxTokens !== void 0 && Coin.encode(e.maxTokens, n.uint32(10).fork()).ldelim(), e.allowList !== void 0 && StakeAuthorization_Validators.encode(e.allowList, n.uint32(18).fork()).ldelim(), e.denyList !== void 0 && StakeAuthorization_Validators.encode(e.denyList, n.uint32(26).fork()).ldelim(), e.authorizationType !== 0 && n.uint32(32).int32(e.authorizationType), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseStakeAuthorization();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.maxTokens = Coin.decode(o, o.uint32());
          break;
        case 2:
          c.allowList = StakeAuthorization_Validators.decode(o, o.uint32());
          break;
        case 3:
          c.denyList = StakeAuthorization_Validators.decode(o, o.uint32());
          break;
        case 4:
          c.authorizationType = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseStakeAuthorization();
    return o.maxTokens = e.maxTokens !== void 0 && e.maxTokens !== null ? Coin.fromPartial(e.maxTokens) : void 0, o.allowList = e.allowList !== void 0 && e.allowList !== null ? StakeAuthorization_Validators.fromPartial(e.allowList) : void 0, o.denyList = e.denyList !== void 0 && e.denyList !== null ? StakeAuthorization_Validators.fromPartial(e.denyList) : void 0, o.authorizationType = (n = e.authorizationType) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      maxTokens: e != null && e.max_tokens ? Coin.fromAmino(e.max_tokens) : void 0,
      allowList: e != null && e.allow_list ? StakeAuthorization_Validators.fromAmino(e.allow_list) : void 0,
      denyList: e != null && e.deny_list ? StakeAuthorization_Validators.fromAmino(e.deny_list) : void 0,
      authorizationType: isSet(e.authorization_type) ? authorizationTypeFromJSON(e.authorization_type) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.max_tokens = e.maxTokens ? Coin.toAmino(e.maxTokens) : void 0, n.allow_list = e.allowList ? StakeAuthorization_Validators.toAmino(e.allowList) : void 0, n.deny_list = e.denyList ? StakeAuthorization_Validators.toAmino(e.denyList) : void 0, n.authorization_type = e.authorizationType, n;
  },
  fromAminoMsg(e) {
    return StakeAuthorization.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/StakeAuthorization",
      value: StakeAuthorization.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return StakeAuthorization.decode(e.value);
  },
  toProto(e) {
    return StakeAuthorization.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
      value: StakeAuthorization.encode(e).finish()
    };
  }
};
function createBaseStakeAuthorization_Validators() {
  return {
    address: []
  };
}
const StakeAuthorization_Validators = {
  typeUrl: "/cosmos.staking.v1beta1.Validators",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.address)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseStakeAuthorization_Validators();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseStakeAuthorization_Validators();
    return o.address = ((n = e.address) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      address: Array.isArray(e == null ? void 0 : e.address) ? e.address.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.address ? n.address = e.address.map((o) => o) : n.address = [], n;
  },
  fromAminoMsg(e) {
    return StakeAuthorization_Validators.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Validators",
      value: StakeAuthorization_Validators.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return StakeAuthorization_Validators.decode(e.value);
  },
  toProto(e) {
    return StakeAuthorization_Validators.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Validators",
      value: StakeAuthorization_Validators.encode(e).finish()
    };
  }
}, _37 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get AuthorizationType() {
    return AuthorizationType;
  },
  AuthorizationTypeAmino,
  AuthorizationTypeSDKType,
  StakeAuthorization,
  StakeAuthorization_Validators,
  authorizationTypeFromJSON,
  authorizationTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenericAuthorization() {
  return {
    $typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
    msg: ""
  };
}
const GenericAuthorization = {
  typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
  encode(e, n = minimal.Writer.create()) {
    return e.msg !== "" && n.uint32(10).string(e.msg), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenericAuthorization();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.msg = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenericAuthorization();
    return o.msg = (n = e.msg) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      msg: e.msg
    };
  },
  toAmino(e) {
    const n = {};
    return n.msg = e.msg, n;
  },
  fromAminoMsg(e) {
    return GenericAuthorization.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenericAuthorization",
      value: GenericAuthorization.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenericAuthorization.decode(e.value);
  },
  toProto(e) {
    return GenericAuthorization.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
      value: GenericAuthorization.encode(e).finish()
    };
  }
};
function createBaseGrant() {
  return {
    authorization: void 0,
    expiration: void 0
  };
}
const Grant = {
  typeUrl: "/cosmos.authz.v1beta1.Grant",
  encode(e, n = minimal.Writer.create()) {
    return e.authorization !== void 0 && Any.encode(e.authorization, n.uint32(10).fork()).ldelim(), e.expiration !== void 0 && Timestamp.encode(toTimestamp(e.expiration), n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGrant();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authorization = Authorization_InterfaceDecoder(o);
          break;
        case 2:
          c.expiration = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGrant();
    return o.authorization = e.authorization !== void 0 && e.authorization !== null ? Any.fromPartial(e.authorization) : void 0, o.expiration = (n = e.expiration) !== null && n !== void 0 ? n : void 0, o;
  },
  fromAmino(e) {
    return {
      authorization: e != null && e.authorization ? Authorization_FromAmino(e.authorization) : void 0,
      expiration: e != null && e.expiration ? Timestamp.fromAmino(e.expiration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.authorization = e.authorization ? Authorization_ToAmino(e.authorization) : void 0, n.expiration = e.expiration ? Timestamp.toAmino(e.expiration) : void 0, n;
  },
  fromAminoMsg(e) {
    return Grant.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Grant",
      value: Grant.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Grant.decode(e.value);
  },
  toProto(e) {
    return Grant.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.Grant",
      value: Grant.encode(e).finish()
    };
  }
};
function createBaseGrantAuthorization() {
  return {
    granter: "",
    grantee: "",
    authorization: void 0,
    expiration: void 0
  };
}
const GrantAuthorization = {
  typeUrl: "/cosmos.authz.v1beta1.GrantAuthorization",
  encode(e, n = minimal.Writer.create()) {
    return e.granter !== "" && n.uint32(10).string(e.granter), e.grantee !== "" && n.uint32(18).string(e.grantee), e.authorization !== void 0 && Any.encode(e.authorization, n.uint32(26).fork()).ldelim(), e.expiration !== void 0 && Timestamp.encode(toTimestamp(e.expiration), n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGrantAuthorization();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.granter = o.string();
          break;
        case 2:
          c.grantee = o.string();
          break;
        case 3:
          c.authorization = Authorization_InterfaceDecoder(o);
          break;
        case 4:
          c.expiration = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseGrantAuthorization();
    return c.granter = (n = e.granter) !== null && n !== void 0 ? n : "", c.grantee = (o = e.grantee) !== null && o !== void 0 ? o : "", c.authorization = e.authorization !== void 0 && e.authorization !== null ? Any.fromPartial(e.authorization) : void 0, c.expiration = (u = e.expiration) !== null && u !== void 0 ? u : void 0, c;
  },
  fromAmino(e) {
    return {
      granter: e.granter,
      grantee: e.grantee,
      authorization: e != null && e.authorization ? Authorization_FromAmino(e.authorization) : void 0,
      expiration: e != null && e.expiration ? Timestamp.fromAmino(e.expiration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.granter = e.granter, n.grantee = e.grantee, n.authorization = e.authorization ? Authorization_ToAmino(e.authorization) : void 0, n.expiration = e.expiration ? Timestamp.toAmino(e.expiration) : void 0, n;
  },
  fromAminoMsg(e) {
    return GrantAuthorization.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GrantAuthorization",
      value: GrantAuthorization.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GrantAuthorization.decode(e.value);
  },
  toProto(e) {
    return GrantAuthorization.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.GrantAuthorization",
      value: GrantAuthorization.encode(e).finish()
    };
  }
}, Authorization_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/cosmos.authz.v1beta1.GenericAuthorization":
      return GenericAuthorization.decode(o.value);
    case "/cosmos.bank.v1beta1.SendAuthorization":
      return SendAuthorization.decode(o.value);
    case "/cosmos.staking.v1beta1.StakeAuthorization":
      return StakeAuthorization.decode(o.value);
    default:
      return o;
  }
}, Authorization_FromAmino = (e) => {
  switch (e.type) {
    case "cosmos-sdk/GenericAuthorization":
      return Any.fromPartial({
        typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
        value: GenericAuthorization.encode(GenericAuthorization.fromPartial(GenericAuthorization.fromAmino(e.value))).finish()
      });
    case "cosmos-sdk/SendAuthorization":
      return Any.fromPartial({
        typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
        value: SendAuthorization.encode(SendAuthorization.fromPartial(SendAuthorization.fromAmino(e.value))).finish()
      });
    case "cosmos-sdk/StakeAuthorization":
      return Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
        value: StakeAuthorization.encode(StakeAuthorization.fromPartial(StakeAuthorization.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, Authorization_ToAmino = (e) => {
  switch (e.typeUrl) {
    case "/cosmos.authz.v1beta1.GenericAuthorization":
      return {
        type: "cosmos-sdk/GenericAuthorization",
        value: GenericAuthorization.toAmino(GenericAuthorization.decode(e.value))
      };
    case "/cosmos.bank.v1beta1.SendAuthorization":
      return {
        type: "cosmos-sdk/SendAuthorization",
        value: SendAuthorization.toAmino(SendAuthorization.decode(e.value))
      };
    case "/cosmos.staking.v1beta1.StakeAuthorization":
      return {
        type: "cosmos-sdk/StakeAuthorization",
        value: StakeAuthorization.toAmino(StakeAuthorization.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Authorization_FromAmino,
  Authorization_InterfaceDecoder,
  Authorization_ToAmino,
  GenericAuthorization,
  Grant,
  GrantAuthorization
}, Symbol.toStringTag, { value: "Module" }));
function createBaseEventGrant() {
  return {
    msgTypeUrl: "",
    granter: "",
    grantee: ""
  };
}
const EventGrant = {
  typeUrl: "/cosmos.authz.v1beta1.EventGrant",
  encode(e, n = minimal.Writer.create()) {
    return e.msgTypeUrl !== "" && n.uint32(18).string(e.msgTypeUrl), e.granter !== "" && n.uint32(26).string(e.granter), e.grantee !== "" && n.uint32(34).string(e.grantee), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEventGrant();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.msgTypeUrl = o.string();
          break;
        case 3:
          c.granter = o.string();
          break;
        case 4:
          c.grantee = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseEventGrant();
    return c.msgTypeUrl = (n = e.msgTypeUrl) !== null && n !== void 0 ? n : "", c.granter = (o = e.granter) !== null && o !== void 0 ? o : "", c.grantee = (u = e.grantee) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      msgTypeUrl: e.msg_type_url,
      granter: e.granter,
      grantee: e.grantee
    };
  },
  toAmino(e) {
    const n = {};
    return n.msg_type_url = e.msgTypeUrl, n.granter = e.granter, n.grantee = e.grantee, n;
  },
  fromAminoMsg(e) {
    return EventGrant.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/EventGrant",
      value: EventGrant.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EventGrant.decode(e.value);
  },
  toProto(e) {
    return EventGrant.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.EventGrant",
      value: EventGrant.encode(e).finish()
    };
  }
};
function createBaseEventRevoke() {
  return {
    msgTypeUrl: "",
    granter: "",
    grantee: ""
  };
}
const EventRevoke = {
  typeUrl: "/cosmos.authz.v1beta1.EventRevoke",
  encode(e, n = minimal.Writer.create()) {
    return e.msgTypeUrl !== "" && n.uint32(18).string(e.msgTypeUrl), e.granter !== "" && n.uint32(26).string(e.granter), e.grantee !== "" && n.uint32(34).string(e.grantee), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEventRevoke();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.msgTypeUrl = o.string();
          break;
        case 3:
          c.granter = o.string();
          break;
        case 4:
          c.grantee = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseEventRevoke();
    return c.msgTypeUrl = (n = e.msgTypeUrl) !== null && n !== void 0 ? n : "", c.granter = (o = e.granter) !== null && o !== void 0 ? o : "", c.grantee = (u = e.grantee) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      msgTypeUrl: e.msg_type_url,
      granter: e.granter,
      grantee: e.grantee
    };
  },
  toAmino(e) {
    const n = {};
    return n.msg_type_url = e.msgTypeUrl, n.granter = e.granter, n.grantee = e.grantee, n;
  },
  fromAminoMsg(e) {
    return EventRevoke.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/EventRevoke",
      value: EventRevoke.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EventRevoke.decode(e.value);
  },
  toProto(e) {
    return EventRevoke.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.EventRevoke",
      value: EventRevoke.encode(e).finish()
    };
  }
}, _5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EventGrant,
  EventRevoke
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$s() {
  return {
    authorization: []
  };
}
const GenesisState$s = {
  typeUrl: "/cosmos.authz.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.authorization)
      GrantAuthorization.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$s();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authorization.push(GrantAuthorization.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$s();
    return o.authorization = ((n = e.authorization) === null || n === void 0 ? void 0 : n.map((u) => GrantAuthorization.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      authorization: Array.isArray(e == null ? void 0 : e.authorization) ? e.authorization.map((n) => GrantAuthorization.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.authorization ? n.authorization = e.authorization.map((o) => o ? GrantAuthorization.toAmino(o) : void 0) : n.authorization = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$s.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$s.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$s.decode(e.value);
  },
  toProto(e) {
    return GenesisState$s.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.GenesisState",
      value: GenesisState$s.encode(e).finish()
    };
  }
}, _6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$s
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryGrantsRequest() {
  return {
    granter: "",
    grantee: "",
    msgTypeUrl: "",
    pagination: void 0
  };
}
const QueryGrantsRequest = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGrantsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.granter !== "" && n.uint32(10).string(e.granter), e.grantee !== "" && n.uint32(18).string(e.grantee), e.msgTypeUrl !== "" && n.uint32(26).string(e.msgTypeUrl), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGrantsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.granter = o.string();
          break;
        case 2:
          c.grantee = o.string();
          break;
        case 3:
          c.msgTypeUrl = o.string();
          break;
        case 4:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryGrantsRequest();
    return c.granter = (n = e.granter) !== null && n !== void 0 ? n : "", c.grantee = (o = e.grantee) !== null && o !== void 0 ? o : "", c.msgTypeUrl = (u = e.msgTypeUrl) !== null && u !== void 0 ? u : "", c.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, c;
  },
  fromAmino(e) {
    return {
      granter: e.granter,
      grantee: e.grantee,
      msgTypeUrl: e.msg_type_url,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.granter = e.granter, n.grantee = e.grantee, n.msg_type_url = e.msgTypeUrl, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGrantsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryGrantsRequest",
      value: QueryGrantsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGrantsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGrantsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGrantsRequest",
      value: QueryGrantsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGrantsResponse() {
  return {
    grants: [],
    pagination: void 0
  };
}
const QueryGrantsResponse = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGrantsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.grants)
      Grant.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGrantsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.grants.push(Grant.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGrantsResponse();
    return o.grants = ((n = e.grants) === null || n === void 0 ? void 0 : n.map((u) => Grant.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      grants: Array.isArray(e == null ? void 0 : e.grants) ? e.grants.map((n) => Grant.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.grants ? n.grants = e.grants.map((o) => o ? Grant.toAmino(o) : void 0) : n.grants = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGrantsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryGrantsResponse",
      value: QueryGrantsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGrantsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGrantsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGrantsResponse",
      value: QueryGrantsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGranterGrantsRequest() {
  return {
    granter: "",
    pagination: void 0
  };
}
const QueryGranterGrantsRequest = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.granter !== "" && n.uint32(10).string(e.granter), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGranterGrantsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.granter = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGranterGrantsRequest();
    return o.granter = (n = e.granter) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      granter: e.granter,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.granter = e.granter, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGranterGrantsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryGranterGrantsRequest",
      value: QueryGranterGrantsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGranterGrantsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGranterGrantsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsRequest",
      value: QueryGranterGrantsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGranterGrantsResponse() {
  return {
    grants: [],
    pagination: void 0
  };
}
const QueryGranterGrantsResponse = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.grants)
      GrantAuthorization.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGranterGrantsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.grants.push(GrantAuthorization.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGranterGrantsResponse();
    return o.grants = ((n = e.grants) === null || n === void 0 ? void 0 : n.map((u) => GrantAuthorization.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      grants: Array.isArray(e == null ? void 0 : e.grants) ? e.grants.map((n) => GrantAuthorization.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.grants ? n.grants = e.grants.map((o) => o ? GrantAuthorization.toAmino(o) : void 0) : n.grants = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGranterGrantsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryGranterGrantsResponse",
      value: QueryGranterGrantsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGranterGrantsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGranterGrantsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsResponse",
      value: QueryGranterGrantsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGranteeGrantsRequest() {
  return {
    grantee: "",
    pagination: void 0
  };
}
const QueryGranteeGrantsRequest = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.grantee !== "" && n.uint32(10).string(e.grantee), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGranteeGrantsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.grantee = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGranteeGrantsRequest();
    return o.grantee = (n = e.grantee) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      grantee: e.grantee,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.grantee = e.grantee, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGranteeGrantsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryGranteeGrantsRequest",
      value: QueryGranteeGrantsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGranteeGrantsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGranteeGrantsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsRequest",
      value: QueryGranteeGrantsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGranteeGrantsResponse() {
  return {
    grants: [],
    pagination: void 0
  };
}
const QueryGranteeGrantsResponse = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.grants)
      GrantAuthorization.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGranteeGrantsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.grants.push(GrantAuthorization.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGranteeGrantsResponse();
    return o.grants = ((n = e.grants) === null || n === void 0 ? void 0 : n.map((u) => GrantAuthorization.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      grants: Array.isArray(e == null ? void 0 : e.grants) ? e.grants.map((n) => GrantAuthorization.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.grants ? n.grants = e.grants.map((o) => o ? GrantAuthorization.toAmino(o) : void 0) : n.grants = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGranteeGrantsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryGranteeGrantsResponse",
      value: QueryGranteeGrantsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGranteeGrantsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGranteeGrantsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsResponse",
      value: QueryGranteeGrantsResponse.encode(e).finish()
    };
  }
}, _7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryGranteeGrantsRequest,
  QueryGranteeGrantsResponse,
  QueryGranterGrantsRequest,
  QueryGranterGrantsResponse,
  QueryGrantsRequest,
  QueryGrantsResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgGrant() {
  return {
    granter: "",
    grantee: "",
    grant: void 0
  };
}
const MsgGrant = {
  typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
  encode(e, n = minimal.Writer.create()) {
    return e.granter !== "" && n.uint32(10).string(e.granter), e.grantee !== "" && n.uint32(18).string(e.grantee), e.grant !== void 0 && Grant.encode(e.grant, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgGrant();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.granter = o.string();
          break;
        case 2:
          c.grantee = o.string();
          break;
        case 3:
          c.grant = Grant.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgGrant();
    return u.granter = (n = e.granter) !== null && n !== void 0 ? n : "", u.grantee = (o = e.grantee) !== null && o !== void 0 ? o : "", u.grant = e.grant !== void 0 && e.grant !== null ? Grant.fromPartial(e.grant) : void 0, u;
  },
  fromAmino(e) {
    return {
      granter: e.granter,
      grantee: e.grantee,
      grant: e != null && e.grant ? Grant.fromAmino(e.grant) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.granter = e.granter, n.grantee = e.grantee, n.grant = e.grant ? Grant.toAmino(e.grant) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgGrant.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgGrant",
      value: MsgGrant.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgGrant.decode(e.value);
  },
  toProto(e) {
    return MsgGrant.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
      value: MsgGrant.encode(e).finish()
    };
  }
};
function createBaseMsgExecResponse() {
  return {
    results: []
  };
}
const MsgExecResponse = {
  typeUrl: "/cosmos.authz.v1beta1.MsgExecResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.results)
      n.uint32(10).bytes(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExecResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.results.push(o.bytes());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgExecResponse();
    return o.results = ((n = e.results) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      results: Array.isArray(e == null ? void 0 : e.results) ? e.results.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.results ? n.results = e.results.map((o) => o) : n.results = [], n;
  },
  fromAminoMsg(e) {
    return MsgExecResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgExecResponse",
      value: MsgExecResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExecResponse.decode(e.value);
  },
  toProto(e) {
    return MsgExecResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgExecResponse",
      value: MsgExecResponse.encode(e).finish()
    };
  }
};
function createBaseMsgExec() {
  return {
    grantee: "",
    msgs: []
  };
}
const MsgExec = {
  typeUrl: "/cosmos.authz.v1beta1.MsgExec",
  encode(e, n = minimal.Writer.create()) {
    e.grantee !== "" && n.uint32(10).string(e.grantee);
    for (const o of e.msgs)
      Any.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExec();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.grantee = o.string();
          break;
        case 2:
          c.msgs.push(Sdk_MsgauthzAuthorization_InterfaceDecoder(o));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgExec();
    return u.grantee = (n = e.grantee) !== null && n !== void 0 ? n : "", u.msgs = ((o = e.msgs) === null || o === void 0 ? void 0 : o.map((c) => Any.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      grantee: e.grantee,
      msgs: Array.isArray(e == null ? void 0 : e.msgs) ? e.msgs.map((n) => Sdk_MsgauthzAuthorization_FromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.grantee = e.grantee, e.msgs ? n.msgs = e.msgs.map((o) => o ? Sdk_MsgauthzAuthorization_ToAmino(o) : void 0) : n.msgs = [], n;
  },
  fromAminoMsg(e) {
    return MsgExec.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgExec",
      value: MsgExec.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExec.decode(e.value);
  },
  toProto(e) {
    return MsgExec.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgExec",
      value: MsgExec.encode(e).finish()
    };
  }
};
function createBaseMsgGrantResponse() {
  return {};
}
const MsgGrantResponse = {
  typeUrl: "/cosmos.authz.v1beta1.MsgGrantResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgGrantResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgGrantResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgGrantResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgGrantResponse",
      value: MsgGrantResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgGrantResponse.decode(e.value);
  },
  toProto(e) {
    return MsgGrantResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgGrantResponse",
      value: MsgGrantResponse.encode(e).finish()
    };
  }
};
function createBaseMsgRevoke() {
  return {
    granter: "",
    grantee: "",
    msgTypeUrl: ""
  };
}
const MsgRevoke = {
  typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
  encode(e, n = minimal.Writer.create()) {
    return e.granter !== "" && n.uint32(10).string(e.granter), e.grantee !== "" && n.uint32(18).string(e.grantee), e.msgTypeUrl !== "" && n.uint32(26).string(e.msgTypeUrl), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRevoke();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.granter = o.string();
          break;
        case 2:
          c.grantee = o.string();
          break;
        case 3:
          c.msgTypeUrl = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgRevoke();
    return c.granter = (n = e.granter) !== null && n !== void 0 ? n : "", c.grantee = (o = e.grantee) !== null && o !== void 0 ? o : "", c.msgTypeUrl = (u = e.msgTypeUrl) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      granter: e.granter,
      grantee: e.grantee,
      msgTypeUrl: e.msg_type_url
    };
  },
  toAmino(e) {
    const n = {};
    return n.granter = e.granter, n.grantee = e.grantee, n.msg_type_url = e.msgTypeUrl, n;
  },
  fromAminoMsg(e) {
    return MsgRevoke.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRevoke",
      value: MsgRevoke.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRevoke.decode(e.value);
  },
  toProto(e) {
    return MsgRevoke.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
      value: MsgRevoke.encode(e).finish()
    };
  }
};
function createBaseMsgRevokeResponse() {
  return {};
}
const MsgRevokeResponse = {
  typeUrl: "/cosmos.authz.v1beta1.MsgRevokeResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRevokeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgRevokeResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgRevokeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRevokeResponse",
      value: MsgRevokeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRevokeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgRevokeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgRevokeResponse",
      value: MsgRevokeResponse.encode(e).finish()
    };
  }
}, Sdk_Msg_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    default:
      return o;
  }
}, Sdk_Msg_FromAmino = (e) => Any.fromAmino(e), Sdk_Msg_ToAmino = (e) => Any.toAmino(e), Authz_Authorization_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    default:
      return o;
  }
}, Authz_Authorization_FromAmino = (e) => Any.fromAmino(e), Authz_Authorization_ToAmino = (e) => Any.toAmino(e), _8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Authz_Authorization_FromAmino,
  Authz_Authorization_InterfaceDecoder,
  Authz_Authorization_ToAmino,
  MsgExec,
  MsgExecResponse,
  MsgGrant,
  MsgGrantResponse,
  MsgRevoke,
  MsgRevokeResponse,
  Sdk_Msg_FromAmino,
  Sdk_Msg_InterfaceDecoder,
  Sdk_Msg_ToAmino
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$l() {
  return {
    sendEnabled: [],
    defaultSendEnabled: !1
  };
}
const Params$m = {
  typeUrl: "/cosmos.bank.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.sendEnabled)
      SendEnabled.encode(o, n.uint32(10).fork()).ldelim();
    return e.defaultSendEnabled === !0 && n.uint32(16).bool(e.defaultSendEnabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$l();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sendEnabled.push(SendEnabled.decode(o, o.uint32()));
          break;
        case 2:
          c.defaultSendEnabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseParams$l();
    return u.sendEnabled = ((n = e.sendEnabled) === null || n === void 0 ? void 0 : n.map((c) => SendEnabled.fromPartial(c))) || [], u.defaultSendEnabled = (o = e.defaultSendEnabled) !== null && o !== void 0 ? o : !1, u;
  },
  fromAmino(e) {
    return {
      sendEnabled: Array.isArray(e == null ? void 0 : e.send_enabled) ? e.send_enabled.map((n) => SendEnabled.fromAmino(n)) : [],
      defaultSendEnabled: e.default_send_enabled
    };
  },
  toAmino(e) {
    const n = {};
    return e.sendEnabled ? n.send_enabled = e.sendEnabled.map((o) => o ? SendEnabled.toAmino(o) : void 0) : n.send_enabled = [], n.default_send_enabled = e.defaultSendEnabled, n;
  },
  fromAminoMsg(e) {
    return Params$m.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/x/bank/Params",
      value: Params$m.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$m.decode(e.value);
  },
  toProto(e) {
    return Params$m.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Params",
      value: Params$m.encode(e).finish()
    };
  }
};
function createBaseSendEnabled() {
  return {
    denom: "",
    enabled: !1
  };
}
const SendEnabled = {
  typeUrl: "/cosmos.bank.v1beta1.SendEnabled",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.enabled === !0 && n.uint32(16).bool(e.enabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSendEnabled();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.enabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSendEnabled();
    return u.denom = (n = e.denom) !== null && n !== void 0 ? n : "", u.enabled = (o = e.enabled) !== null && o !== void 0 ? o : !1, u;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      enabled: e.enabled
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.enabled = e.enabled, n;
  },
  fromAminoMsg(e) {
    return SendEnabled.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SendEnabled",
      value: SendEnabled.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SendEnabled.decode(e.value);
  },
  toProto(e) {
    return SendEnabled.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.SendEnabled",
      value: SendEnabled.encode(e).finish()
    };
  }
};
function createBaseInput() {
  return {
    address: "",
    coins: []
  };
}
const Input = {
  typeUrl: "/cosmos.bank.v1beta1.Input",
  encode(e, n = minimal.Writer.create()) {
    e.address !== "" && n.uint32(10).string(e.address);
    for (const o of e.coins)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInput();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseInput();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.coins = ((o = e.coins) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return Input.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Input",
      value: Input.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Input.decode(e.value);
  },
  toProto(e) {
    return Input.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Input",
      value: Input.encode(e).finish()
    };
  }
};
function createBaseOutput() {
  return {
    address: "",
    coins: []
  };
}
const Output = {
  typeUrl: "/cosmos.bank.v1beta1.Output",
  encode(e, n = minimal.Writer.create()) {
    e.address !== "" && n.uint32(10).string(e.address);
    for (const o of e.coins)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseOutput();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseOutput();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.coins = ((o = e.coins) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return Output.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Output",
      value: Output.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Output.decode(e.value);
  },
  toProto(e) {
    return Output.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Output",
      value: Output.encode(e).finish()
    };
  }
};
function createBaseSupply() {
  return {
    $typeUrl: "/cosmos.bank.v1beta1.Supply",
    total: []
  };
}
const Supply = {
  typeUrl: "/cosmos.bank.v1beta1.Supply",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.total)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSupply();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.total.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSupply();
    return o.total = ((n = e.total) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      total: Array.isArray(e == null ? void 0 : e.total) ? e.total.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.total ? n.total = e.total.map((o) => o ? Coin.toAmino(o) : void 0) : n.total = [], n;
  },
  fromAminoMsg(e) {
    return Supply.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Supply",
      value: Supply.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Supply.decode(e.value);
  },
  toProto(e) {
    return Supply.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Supply",
      value: Supply.encode(e).finish()
    };
  }
};
function createBaseDenomUnit() {
  return {
    denom: "",
    exponent: 0,
    aliases: []
  };
}
const DenomUnit = {
  typeUrl: "/cosmos.bank.v1beta1.DenomUnit",
  encode(e, n = minimal.Writer.create()) {
    e.denom !== "" && n.uint32(10).string(e.denom), e.exponent !== 0 && n.uint32(16).uint32(e.exponent);
    for (const o of e.aliases)
      n.uint32(26).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDenomUnit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.exponent = o.uint32();
          break;
        case 3:
          c.aliases.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseDenomUnit();
    return c.denom = (n = e.denom) !== null && n !== void 0 ? n : "", c.exponent = (o = e.exponent) !== null && o !== void 0 ? o : 0, c.aliases = ((u = e.aliases) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      exponent: e.exponent,
      aliases: Array.isArray(e == null ? void 0 : e.aliases) ? e.aliases.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.exponent = e.exponent, e.aliases ? n.aliases = e.aliases.map((o) => o) : n.aliases = [], n;
  },
  fromAminoMsg(e) {
    return DenomUnit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DenomUnit",
      value: DenomUnit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DenomUnit.decode(e.value);
  },
  toProto(e) {
    return DenomUnit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.DenomUnit",
      value: DenomUnit.encode(e).finish()
    };
  }
};
function createBaseMetadata$2() {
  return {
    description: "",
    denomUnits: [],
    base: "",
    display: "",
    name: "",
    symbol: ""
  };
}
const Metadata$2 = {
  typeUrl: "/cosmos.bank.v1beta1.Metadata",
  encode(e, n = minimal.Writer.create()) {
    e.description !== "" && n.uint32(10).string(e.description);
    for (const o of e.denomUnits)
      DenomUnit.encode(o, n.uint32(18).fork()).ldelim();
    return e.base !== "" && n.uint32(26).string(e.base), e.display !== "" && n.uint32(34).string(e.display), e.name !== "" && n.uint32(42).string(e.name), e.symbol !== "" && n.uint32(50).string(e.symbol), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMetadata$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.description = o.string();
          break;
        case 2:
          c.denomUnits.push(DenomUnit.decode(o, o.uint32()));
          break;
        case 3:
          c.base = o.string();
          break;
        case 4:
          c.display = o.string();
          break;
        case 5:
          c.name = o.string();
          break;
        case 6:
          c.symbol = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseMetadata$2();
    return v.description = (n = e.description) !== null && n !== void 0 ? n : "", v.denomUnits = ((o = e.denomUnits) === null || o === void 0 ? void 0 : o.map((S) => DenomUnit.fromPartial(S))) || [], v.base = (u = e.base) !== null && u !== void 0 ? u : "", v.display = (c = e.display) !== null && c !== void 0 ? c : "", v.name = (d = e.name) !== null && d !== void 0 ? d : "", v.symbol = (m = e.symbol) !== null && m !== void 0 ? m : "", v;
  },
  fromAmino(e) {
    return {
      description: e.description,
      denomUnits: Array.isArray(e == null ? void 0 : e.denom_units) ? e.denom_units.map((n) => DenomUnit.fromAmino(n)) : [],
      base: e.base,
      display: e.display,
      name: e.name,
      symbol: e.symbol
    };
  },
  toAmino(e) {
    const n = {};
    return n.description = e.description, e.denomUnits ? n.denom_units = e.denomUnits.map((o) => o ? DenomUnit.toAmino(o) : void 0) : n.denom_units = [], n.base = e.base, n.display = e.display, n.name = e.name, n.symbol = e.symbol, n;
  },
  fromAminoMsg(e) {
    return Metadata$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Metadata",
      value: Metadata$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Metadata$2.decode(e.value);
  },
  toProto(e) {
    return Metadata$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Metadata",
      value: Metadata$2.encode(e).finish()
    };
  }
}, _10 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DenomUnit,
  Input,
  Metadata: Metadata$2,
  Output,
  Params: Params$m,
  SendEnabled,
  Supply
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$r() {
  return {
    params: void 0,
    balances: [],
    supply: [],
    denomMetadata: [],
    supplyOffsets: []
  };
}
const GenesisState$r = {
  typeUrl: "/cosmos.bank.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$m.encode(e.params, n.uint32(10).fork()).ldelim();
    for (const o of e.balances)
      Balance.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.supply)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.denomMetadata)
      Metadata$2.encode(o, n.uint32(34).fork()).ldelim();
    for (const o of e.supplyOffsets)
      GenesisSupplyOffset.encode(o, n.uint32(42).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$r();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$m.decode(o, o.uint32());
          break;
        case 2:
          c.balances.push(Balance.decode(o, o.uint32()));
          break;
        case 3:
          c.supply.push(Coin.decode(o, o.uint32()));
          break;
        case 4:
          c.denomMetadata.push(Metadata$2.decode(o, o.uint32()));
          break;
        case 5:
          c.supplyOffsets.push(GenesisSupplyOffset.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseGenesisState$r();
    return d.params = e.params !== void 0 && e.params !== null ? Params$m.fromPartial(e.params) : void 0, d.balances = ((n = e.balances) === null || n === void 0 ? void 0 : n.map((m) => Balance.fromPartial(m))) || [], d.supply = ((o = e.supply) === null || o === void 0 ? void 0 : o.map((m) => Coin.fromPartial(m))) || [], d.denomMetadata = ((u = e.denomMetadata) === null || u === void 0 ? void 0 : u.map((m) => Metadata$2.fromPartial(m))) || [], d.supplyOffsets = ((c = e.supplyOffsets) === null || c === void 0 ? void 0 : c.map((m) => GenesisSupplyOffset.fromPartial(m))) || [], d;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$m.fromAmino(e.params) : void 0,
      balances: Array.isArray(e == null ? void 0 : e.balances) ? e.balances.map((n) => Balance.fromAmino(n)) : [],
      supply: Array.isArray(e == null ? void 0 : e.supply) ? e.supply.map((n) => Coin.fromAmino(n)) : [],
      denomMetadata: Array.isArray(e == null ? void 0 : e.denom_metadata) ? e.denom_metadata.map((n) => Metadata$2.fromAmino(n)) : [],
      supplyOffsets: Array.isArray(e == null ? void 0 : e.supply_offsets) ? e.supply_offsets.map((n) => GenesisSupplyOffset.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$m.toAmino(e.params) : void 0, e.balances ? n.balances = e.balances.map((o) => o ? Balance.toAmino(o) : void 0) : n.balances = [], e.supply ? n.supply = e.supply.map((o) => o ? Coin.toAmino(o) : void 0) : n.supply = [], e.denomMetadata ? n.denom_metadata = e.denomMetadata.map((o) => o ? Metadata$2.toAmino(o) : void 0) : n.denom_metadata = [], e.supplyOffsets ? n.supply_offsets = e.supplyOffsets.map((o) => o ? GenesisSupplyOffset.toAmino(o) : void 0) : n.supply_offsets = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$r.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$r.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$r.decode(e.value);
  },
  toProto(e) {
    return GenesisState$r.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.GenesisState",
      value: GenesisState$r.encode(e).finish()
    };
  }
};
function createBaseBalance() {
  return {
    address: "",
    coins: []
  };
}
const Balance = {
  typeUrl: "/cosmos.bank.v1beta1.Balance",
  encode(e, n = minimal.Writer.create()) {
    e.address !== "" && n.uint32(10).string(e.address);
    for (const o of e.coins)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBalance();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseBalance();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.coins = ((o = e.coins) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return Balance.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Balance",
      value: Balance.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Balance.decode(e.value);
  },
  toProto(e) {
    return Balance.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Balance",
      value: Balance.encode(e).finish()
    };
  }
};
function createBaseGenesisSupplyOffset() {
  return {
    denom: "",
    offset: ""
  };
}
const GenesisSupplyOffset = {
  typeUrl: "/cosmos.bank.v1beta1.GenesisSupplyOffset",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.offset !== "" && n.uint32(18).string(e.offset), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisSupplyOffset();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.offset = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisSupplyOffset();
    return u.denom = (n = e.denom) !== null && n !== void 0 ? n : "", u.offset = (o = e.offset) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      offset: e.offset
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.offset = e.offset, n;
  },
  fromAminoMsg(e) {
    return GenesisSupplyOffset.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisSupplyOffset",
      value: GenesisSupplyOffset.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisSupplyOffset.decode(e.value);
  },
  toProto(e) {
    return GenesisSupplyOffset.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.GenesisSupplyOffset",
      value: GenesisSupplyOffset.encode(e).finish()
    };
  }
}, _11 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Balance,
  GenesisState: GenesisState$r,
  GenesisSupplyOffset
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryBalanceRequest() {
  return {
    address: "",
    denom: ""
  };
}
const QueryBalanceRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryBalanceRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.denom !== "" && n.uint32(18).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryBalanceRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryBalanceRequest();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.denom = (o = e.denom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryBalanceRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryBalanceRequest",
      value: QueryBalanceRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryBalanceRequest.decode(e.value);
  },
  toProto(e) {
    return QueryBalanceRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryBalanceRequest",
      value: QueryBalanceRequest.encode(e).finish()
    };
  }
};
function createBaseQueryBalanceResponse() {
  return {
    balance: void 0
  };
}
const QueryBalanceResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryBalanceResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.balance !== void 0 && Coin.encode(e.balance, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryBalanceResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.balance = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryBalanceResponse();
    return n.balance = e.balance !== void 0 && e.balance !== null ? Coin.fromPartial(e.balance) : void 0, n;
  },
  fromAmino(e) {
    return {
      balance: e != null && e.balance ? Coin.fromAmino(e.balance) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.balance = e.balance ? Coin.toAmino(e.balance) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryBalanceResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryBalanceResponse",
      value: QueryBalanceResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryBalanceResponse.decode(e.value);
  },
  toProto(e) {
    return QueryBalanceResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryBalanceResponse",
      value: QueryBalanceResponse.encode(e).finish()
    };
  }
};
function createBaseQueryAllBalancesRequest() {
  return {
    address: "",
    pagination: void 0
  };
}
const QueryAllBalancesRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAllBalancesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryAllBalancesRequest();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryAllBalancesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryAllBalancesRequest",
      value: QueryAllBalancesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAllBalancesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryAllBalancesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesRequest",
      value: QueryAllBalancesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryAllBalancesResponse() {
  return {
    balances: [],
    pagination: void 0
  };
}
const QueryAllBalancesResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.balances)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAllBalancesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.balances.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryAllBalancesResponse();
    return o.balances = ((n = e.balances) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      balances: Array.isArray(e == null ? void 0 : e.balances) ? e.balances.map((n) => Coin.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.balances ? n.balances = e.balances.map((o) => o ? Coin.toAmino(o) : void 0) : n.balances = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryAllBalancesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryAllBalancesResponse",
      value: QueryAllBalancesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAllBalancesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryAllBalancesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesResponse",
      value: QueryAllBalancesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalSupplyRequest() {
  return {
    pagination: void 0
  };
}
const QueryTotalSupplyRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalSupplyRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTotalSupplyRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalSupplyRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalSupplyRequest",
      value: QueryTotalSupplyRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalSupplyRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalSupplyRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyRequest",
      value: QueryTotalSupplyRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalSupplyResponse() {
  return {
    supply: [],
    pagination: void 0
  };
}
const QueryTotalSupplyResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.supply)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalSupplyResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.supply.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalSupplyResponse();
    return o.supply = ((n = e.supply) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      supply: Array.isArray(e == null ? void 0 : e.supply) ? e.supply.map((n) => Coin.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.supply ? n.supply = e.supply.map((o) => o ? Coin.toAmino(o) : void 0) : n.supply = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalSupplyResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalSupplyResponse",
      value: QueryTotalSupplyResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalSupplyResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalSupplyResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyResponse",
      value: QueryTotalSupplyResponse.encode(e).finish()
    };
  }
};
function createBaseQuerySupplyOfRequest() {
  return {
    denom: ""
  };
}
const QuerySupplyOfRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySupplyOfRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQuerySupplyOfRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QuerySupplyOfRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QuerySupplyOfRequest",
      value: QuerySupplyOfRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySupplyOfRequest.decode(e.value);
  },
  toProto(e) {
    return QuerySupplyOfRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfRequest",
      value: QuerySupplyOfRequest.encode(e).finish()
    };
  }
};
function createBaseQuerySupplyOfResponse() {
  return {
    amount: void 0
  };
}
const QuerySupplyOfResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.amount !== void 0 && Coin.encode(e.amount, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySupplyOfResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQuerySupplyOfResponse();
    return n.amount = e.amount !== void 0 && e.amount !== null ? Coin.fromPartial(e.amount) : void 0, n;
  },
  fromAmino(e) {
    return {
      amount: e != null && e.amount ? Coin.fromAmino(e.amount) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.amount = e.amount ? Coin.toAmino(e.amount) : void 0, n;
  },
  fromAminoMsg(e) {
    return QuerySupplyOfResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QuerySupplyOfResponse",
      value: QuerySupplyOfResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySupplyOfResponse.decode(e.value);
  },
  toProto(e) {
    return QuerySupplyOfResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfResponse",
      value: QuerySupplyOfResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalSupplyWithoutOffsetRequest() {
  return {
    pagination: void 0
  };
}
const QueryTotalSupplyWithoutOffsetRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyWithoutOffsetRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalSupplyWithoutOffsetRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTotalSupplyWithoutOffsetRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalSupplyWithoutOffsetRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalSupplyWithoutOffsetRequest",
      value: QueryTotalSupplyWithoutOffsetRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalSupplyWithoutOffsetRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalSupplyWithoutOffsetRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyWithoutOffsetRequest",
      value: QueryTotalSupplyWithoutOffsetRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalSupplyWithoutOffsetResponse() {
  return {
    supply: [],
    pagination: void 0
  };
}
const QueryTotalSupplyWithoutOffsetResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyWithoutOffsetResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.supply)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalSupplyWithoutOffsetResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.supply.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalSupplyWithoutOffsetResponse();
    return o.supply = ((n = e.supply) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      supply: Array.isArray(e == null ? void 0 : e.supply) ? e.supply.map((n) => Coin.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.supply ? n.supply = e.supply.map((o) => o ? Coin.toAmino(o) : void 0) : n.supply = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalSupplyWithoutOffsetResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalSupplyWithoutOffsetResponse",
      value: QueryTotalSupplyWithoutOffsetResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalSupplyWithoutOffsetResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalSupplyWithoutOffsetResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyWithoutOffsetResponse",
      value: QueryTotalSupplyWithoutOffsetResponse.encode(e).finish()
    };
  }
};
function createBaseQuerySupplyOfWithoutOffsetRequest() {
  return {
    denom: ""
  };
}
const QuerySupplyOfWithoutOffsetRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfWithoutOffsetRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySupplyOfWithoutOffsetRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQuerySupplyOfWithoutOffsetRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QuerySupplyOfWithoutOffsetRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QuerySupplyOfWithoutOffsetRequest",
      value: QuerySupplyOfWithoutOffsetRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySupplyOfWithoutOffsetRequest.decode(e.value);
  },
  toProto(e) {
    return QuerySupplyOfWithoutOffsetRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfWithoutOffsetRequest",
      value: QuerySupplyOfWithoutOffsetRequest.encode(e).finish()
    };
  }
};
function createBaseQuerySupplyOfWithoutOffsetResponse() {
  return {
    amount: void 0
  };
}
const QuerySupplyOfWithoutOffsetResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfWithoutOffsetResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.amount !== void 0 && Coin.encode(e.amount, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySupplyOfWithoutOffsetResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQuerySupplyOfWithoutOffsetResponse();
    return n.amount = e.amount !== void 0 && e.amount !== null ? Coin.fromPartial(e.amount) : void 0, n;
  },
  fromAmino(e) {
    return {
      amount: e != null && e.amount ? Coin.fromAmino(e.amount) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.amount = e.amount ? Coin.toAmino(e.amount) : void 0, n;
  },
  fromAminoMsg(e) {
    return QuerySupplyOfWithoutOffsetResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QuerySupplyOfWithoutOffsetResponse",
      value: QuerySupplyOfWithoutOffsetResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySupplyOfWithoutOffsetResponse.decode(e.value);
  },
  toProto(e) {
    return QuerySupplyOfWithoutOffsetResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfWithoutOffsetResponse",
      value: QuerySupplyOfWithoutOffsetResponse.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$e() {
  return {};
}
const QueryParamsRequest$e = {
  typeUrl: "/cosmos.bank.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$e();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$e();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$e.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest$e.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$e.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$e.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest$e.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$e() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$e = {
  typeUrl: "/cosmos.bank.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$m.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$e();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$m.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$e();
    return n.params = e.params !== void 0 && e.params !== null ? Params$m.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$m.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$m.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$e.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse$e.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$e.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$e.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse$e.encode(e).finish()
    };
  }
};
function createBaseQueryDenomsMetadataRequest() {
  return {
    pagination: void 0
  };
}
const QueryDenomsMetadataRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomsMetadataRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDenomsMetadataRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDenomsMetadataRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomsMetadataRequest",
      value: QueryDenomsMetadataRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomsMetadataRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomsMetadataRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataRequest",
      value: QueryDenomsMetadataRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomsMetadataResponse() {
  return {
    metadatas: [],
    pagination: void 0
  };
}
const QueryDenomsMetadataResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.metadatas)
      Metadata$2.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomsMetadataResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.metadatas.push(Metadata$2.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomsMetadataResponse();
    return o.metadatas = ((n = e.metadatas) === null || n === void 0 ? void 0 : n.map((u) => Metadata$2.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      metadatas: Array.isArray(e == null ? void 0 : e.metadatas) ? e.metadatas.map((n) => Metadata$2.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.metadatas ? n.metadatas = e.metadatas.map((o) => o ? Metadata$2.toAmino(o) : void 0) : n.metadatas = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDenomsMetadataResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomsMetadataResponse",
      value: QueryDenomsMetadataResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomsMetadataResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomsMetadataResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataResponse",
      value: QueryDenomsMetadataResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDenomMetadataRequest() {
  return {
    denom: ""
  };
}
const QueryDenomMetadataRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomMetadataRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomMetadataRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryDenomMetadataRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomMetadataRequest",
      value: QueryDenomMetadataRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomMetadataRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomMetadataRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataRequest",
      value: QueryDenomMetadataRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomMetadataResponse() {
  return {
    metadata: void 0
  };
}
const QueryDenomMetadataResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.metadata !== void 0 && Metadata$2.encode(e.metadata, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomMetadataResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.metadata = Metadata$2.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDenomMetadataResponse();
    return n.metadata = e.metadata !== void 0 && e.metadata !== null ? Metadata$2.fromPartial(e.metadata) : void 0, n;
  },
  fromAmino(e) {
    return {
      metadata: e != null && e.metadata ? Metadata$2.fromAmino(e.metadata) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.metadata = e.metadata ? Metadata$2.toAmino(e.metadata) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDenomMetadataResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomMetadataResponse",
      value: QueryDenomMetadataResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomMetadataResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomMetadataResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataResponse",
      value: QueryDenomMetadataResponse.encode(e).finish()
    };
  }
};
function createBaseQueryBaseDenomRequest$1() {
  return {
    denom: ""
  };
}
const QueryBaseDenomRequest$1 = {
  typeUrl: "/cosmos.bank.v1beta1.QueryBaseDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryBaseDenomRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryBaseDenomRequest$1();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryBaseDenomRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryBaseDenomRequest",
      value: QueryBaseDenomRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryBaseDenomRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryBaseDenomRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryBaseDenomRequest",
      value: QueryBaseDenomRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryBaseDenomResponse$1() {
  return {
    baseDenom: ""
  };
}
const QueryBaseDenomResponse$1 = {
  typeUrl: "/cosmos.bank.v1beta1.QueryBaseDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.baseDenom !== "" && n.uint32(10).string(e.baseDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryBaseDenomResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.baseDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryBaseDenomResponse$1();
    return o.baseDenom = (n = e.baseDenom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      baseDenom: e.base_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.base_denom = e.baseDenom, n;
  },
  fromAminoMsg(e) {
    return QueryBaseDenomResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryBaseDenomResponse",
      value: QueryBaseDenomResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryBaseDenomResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryBaseDenomResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryBaseDenomResponse",
      value: QueryBaseDenomResponse$1.encode(e).finish()
    };
  }
}, _12 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryAllBalancesRequest,
  QueryAllBalancesResponse,
  QueryBalanceRequest,
  QueryBalanceResponse,
  QueryBaseDenomRequest: QueryBaseDenomRequest$1,
  QueryBaseDenomResponse: QueryBaseDenomResponse$1,
  QueryDenomMetadataRequest,
  QueryDenomMetadataResponse,
  QueryDenomsMetadataRequest,
  QueryDenomsMetadataResponse,
  QueryParamsRequest: QueryParamsRequest$e,
  QueryParamsResponse: QueryParamsResponse$e,
  QuerySupplyOfRequest,
  QuerySupplyOfResponse,
  QuerySupplyOfWithoutOffsetRequest,
  QuerySupplyOfWithoutOffsetResponse,
  QueryTotalSupplyRequest,
  QueryTotalSupplyResponse,
  QueryTotalSupplyWithoutOffsetRequest,
  QueryTotalSupplyWithoutOffsetResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSend() {
  return {
    fromAddress: "",
    toAddress: "",
    amount: []
  };
}
const MsgSend = {
  typeUrl: "/cosmos.bank.v1beta1.MsgSend",
  encode(e, n = minimal.Writer.create()) {
    e.fromAddress !== "" && n.uint32(10).string(e.fromAddress), e.toAddress !== "" && n.uint32(18).string(e.toAddress);
    for (const o of e.amount)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSend();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.fromAddress = o.string();
          break;
        case 2:
          c.toAddress = o.string();
          break;
        case 3:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgSend();
    return c.fromAddress = (n = e.fromAddress) !== null && n !== void 0 ? n : "", c.toAddress = (o = e.toAddress) !== null && o !== void 0 ? o : "", c.amount = ((u = e.amount) === null || u === void 0 ? void 0 : u.map((d) => Coin.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      fromAddress: e.from_address,
      toAddress: e.to_address,
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.from_address = e.fromAddress, n.to_address = e.toAddress, e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n;
  },
  fromAminoMsg(e) {
    return MsgSend.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSend",
      value: MsgSend.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSend.decode(e.value);
  },
  toProto(e) {
    return MsgSend.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.MsgSend",
      value: MsgSend.encode(e).finish()
    };
  }
};
function createBaseMsgSendResponse() {
  return {};
}
const MsgSendResponse = {
  typeUrl: "/cosmos.bank.v1beta1.MsgSendResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSendResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSendResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSendResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSendResponse",
      value: MsgSendResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSendResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSendResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.MsgSendResponse",
      value: MsgSendResponse.encode(e).finish()
    };
  }
};
function createBaseMsgMultiSend() {
  return {
    inputs: [],
    outputs: []
  };
}
const MsgMultiSend = {
  typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.inputs)
      Input.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.outputs)
      Output.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgMultiSend();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.inputs.push(Input.decode(o, o.uint32()));
          break;
        case 2:
          c.outputs.push(Output.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgMultiSend();
    return u.inputs = ((n = e.inputs) === null || n === void 0 ? void 0 : n.map((c) => Input.fromPartial(c))) || [], u.outputs = ((o = e.outputs) === null || o === void 0 ? void 0 : o.map((c) => Output.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      inputs: Array.isArray(e == null ? void 0 : e.inputs) ? e.inputs.map((n) => Input.fromAmino(n)) : [],
      outputs: Array.isArray(e == null ? void 0 : e.outputs) ? e.outputs.map((n) => Output.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.inputs ? n.inputs = e.inputs.map((o) => o ? Input.toAmino(o) : void 0) : n.inputs = [], e.outputs ? n.outputs = e.outputs.map((o) => o ? Output.toAmino(o) : void 0) : n.outputs = [], n;
  },
  fromAminoMsg(e) {
    return MsgMultiSend.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgMultiSend",
      value: MsgMultiSend.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgMultiSend.decode(e.value);
  },
  toProto(e) {
    return MsgMultiSend.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
      value: MsgMultiSend.encode(e).finish()
    };
  }
};
function createBaseMsgMultiSendResponse() {
  return {};
}
const MsgMultiSendResponse = {
  typeUrl: "/cosmos.bank.v1beta1.MsgMultiSendResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgMultiSendResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgMultiSendResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgMultiSendResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgMultiSendResponse",
      value: MsgMultiSendResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgMultiSendResponse.decode(e.value);
  },
  toProto(e) {
    return MsgMultiSendResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.MsgMultiSendResponse",
      value: MsgMultiSendResponse.encode(e).finish()
    };
  }
}, _13 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgMultiSend,
  MsgMultiSendResponse,
  MsgSend,
  MsgSendResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseDuration() {
  return {
    seconds: Long$2.ZERO,
    nanos: 0
  };
}
const Duration = {
  typeUrl: "/google.protobuf.Duration",
  encode(e, n = minimal.Writer.create()) {
    return e.seconds.isZero() || n.uint32(8).int64(e.seconds), e.nanos !== 0 && n.uint32(16).int32(e.nanos), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDuration();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.seconds = o.int64();
          break;
        case 2:
          c.nanos = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDuration();
    return o.seconds = e.seconds !== void 0 && e.seconds !== null ? Long$2.fromValue(e.seconds) : Long$2.ZERO, o.nanos = (n = e.nanos) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    const n = parseInt(e);
    return {
      seconds: Long$2.fromNumber(Math.floor(n / 1e9)),
      nanos: n % 1e9
    };
  },
  toAmino(e) {
    return (e.seconds.toInt() * 1e9 + e.nanos).toString();
  },
  fromAminoMsg(e) {
    return Duration.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Duration.decode(e.value);
  },
  toProto(e) {
    return Duration.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.Duration",
      value: Duration.encode(e).finish()
    };
  }
}, _185 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Duration
}, Symbol.toStringTag, { value: "Module" }));
function createBaseConsensusParams() {
  return {
    block: void 0,
    evidence: void 0,
    validator: void 0,
    version: void 0
  };
}
const ConsensusParams = {
  typeUrl: "/tendermint.types.ConsensusParams",
  encode(e, n = minimal.Writer.create()) {
    return e.block !== void 0 && BlockParams.encode(e.block, n.uint32(10).fork()).ldelim(), e.evidence !== void 0 && EvidenceParams.encode(e.evidence, n.uint32(18).fork()).ldelim(), e.validator !== void 0 && ValidatorParams.encode(e.validator, n.uint32(26).fork()).ldelim(), e.version !== void 0 && VersionParams.encode(e.version, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConsensusParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.block = BlockParams.decode(o, o.uint32());
          break;
        case 2:
          c.evidence = EvidenceParams.decode(o, o.uint32());
          break;
        case 3:
          c.validator = ValidatorParams.decode(o, o.uint32());
          break;
        case 4:
          c.version = VersionParams.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseConsensusParams();
    return n.block = e.block !== void 0 && e.block !== null ? BlockParams.fromPartial(e.block) : void 0, n.evidence = e.evidence !== void 0 && e.evidence !== null ? EvidenceParams.fromPartial(e.evidence) : void 0, n.validator = e.validator !== void 0 && e.validator !== null ? ValidatorParams.fromPartial(e.validator) : void 0, n.version = e.version !== void 0 && e.version !== null ? VersionParams.fromPartial(e.version) : void 0, n;
  },
  fromAmino(e) {
    return {
      block: e != null && e.block ? BlockParams.fromAmino(e.block) : void 0,
      evidence: e != null && e.evidence ? EvidenceParams.fromAmino(e.evidence) : void 0,
      validator: e != null && e.validator ? ValidatorParams.fromAmino(e.validator) : void 0,
      version: e != null && e.version ? VersionParams.fromAmino(e.version) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.block = e.block ? BlockParams.toAmino(e.block) : void 0, n.evidence = e.evidence ? EvidenceParams.toAmino(e.evidence) : void 0, n.validator = e.validator ? ValidatorParams.toAmino(e.validator) : void 0, n.version = e.version ? VersionParams.toAmino(e.version) : void 0, n;
  },
  fromAminoMsg(e) {
    return ConsensusParams.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ConsensusParams.decode(e.value);
  },
  toProto(e) {
    return ConsensusParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.ConsensusParams",
      value: ConsensusParams.encode(e).finish()
    };
  }
};
function createBaseBlockParams() {
  return {
    maxBytes: Long$2.ZERO,
    maxGas: Long$2.ZERO
  };
}
const BlockParams = {
  typeUrl: "/tendermint.types.BlockParams",
  encode(e, n = minimal.Writer.create()) {
    return e.maxBytes.isZero() || n.uint32(8).int64(e.maxBytes), e.maxGas.isZero() || n.uint32(16).int64(e.maxGas), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBlockParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.maxBytes = o.int64();
          break;
        case 2:
          c.maxGas = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseBlockParams();
    return n.maxBytes = e.maxBytes !== void 0 && e.maxBytes !== null ? Long$2.fromValue(e.maxBytes) : Long$2.ZERO, n.maxGas = e.maxGas !== void 0 && e.maxGas !== null ? Long$2.fromValue(e.maxGas) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      maxBytes: Long$2.fromString(e.max_bytes),
      maxGas: Long$2.fromString(e.max_gas)
    };
  },
  toAmino(e) {
    const n = {};
    return n.max_bytes = e.maxBytes ? e.maxBytes.toString() : void 0, n.max_gas = e.maxGas ? e.maxGas.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return BlockParams.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return BlockParams.decode(e.value);
  },
  toProto(e) {
    return BlockParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.BlockParams",
      value: BlockParams.encode(e).finish()
    };
  }
};
function createBaseEvidenceParams() {
  return {
    maxAgeNumBlocks: Long$2.ZERO,
    maxAgeDuration: void 0,
    maxBytes: Long$2.ZERO
  };
}
const EvidenceParams = {
  typeUrl: "/tendermint.types.EvidenceParams",
  encode(e, n = minimal.Writer.create()) {
    return e.maxAgeNumBlocks.isZero() || n.uint32(8).int64(e.maxAgeNumBlocks), e.maxAgeDuration !== void 0 && Duration.encode(e.maxAgeDuration, n.uint32(18).fork()).ldelim(), e.maxBytes.isZero() || n.uint32(24).int64(e.maxBytes), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEvidenceParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.maxAgeNumBlocks = o.int64();
          break;
        case 2:
          c.maxAgeDuration = Duration.decode(o, o.uint32());
          break;
        case 3:
          c.maxBytes = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseEvidenceParams();
    return n.maxAgeNumBlocks = e.maxAgeNumBlocks !== void 0 && e.maxAgeNumBlocks !== null ? Long$2.fromValue(e.maxAgeNumBlocks) : Long$2.ZERO, n.maxAgeDuration = e.maxAgeDuration !== void 0 && e.maxAgeDuration !== null ? Duration.fromPartial(e.maxAgeDuration) : void 0, n.maxBytes = e.maxBytes !== void 0 && e.maxBytes !== null ? Long$2.fromValue(e.maxBytes) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      maxAgeNumBlocks: Long$2.fromString(e.max_age_num_blocks),
      maxAgeDuration: e != null && e.max_age_duration ? Duration.fromAmino(e.max_age_duration) : void 0,
      maxBytes: Long$2.fromString(e.max_bytes)
    };
  },
  toAmino(e) {
    const n = {};
    return n.max_age_num_blocks = e.maxAgeNumBlocks ? e.maxAgeNumBlocks.toString() : void 0, n.max_age_duration = e.maxAgeDuration ? Duration.toAmino(e.maxAgeDuration) : void 0, n.max_bytes = e.maxBytes ? e.maxBytes.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return EvidenceParams.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return EvidenceParams.decode(e.value);
  },
  toProto(e) {
    return EvidenceParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.EvidenceParams",
      value: EvidenceParams.encode(e).finish()
    };
  }
};
function createBaseValidatorParams() {
  return {
    pubKeyTypes: []
  };
}
const ValidatorParams = {
  typeUrl: "/tendermint.types.ValidatorParams",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.pubKeyTypes)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pubKeyTypes.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorParams();
    return o.pubKeyTypes = ((n = e.pubKeyTypes) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      pubKeyTypes: Array.isArray(e == null ? void 0 : e.pub_key_types) ? e.pub_key_types.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.pubKeyTypes ? n.pub_key_types = e.pubKeyTypes.map((o) => o) : n.pub_key_types = [], n;
  },
  fromAminoMsg(e) {
    return ValidatorParams.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ValidatorParams.decode(e.value);
  },
  toProto(e) {
    return ValidatorParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.ValidatorParams",
      value: ValidatorParams.encode(e).finish()
    };
  }
};
function createBaseVersionParams() {
  return {
    app: Long$2.UZERO
  };
}
const VersionParams = {
  typeUrl: "/tendermint.types.VersionParams",
  encode(e, n = minimal.Writer.create()) {
    return e.app.isZero() || n.uint32(8).uint64(e.app), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseVersionParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.app = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseVersionParams();
    return n.app = e.app !== void 0 && e.app !== null ? Long$2.fromValue(e.app) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      app: Long$2.fromString(e.app)
    };
  },
  toAmino(e) {
    const n = {};
    return n.app = e.app ? e.app.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return VersionParams.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return VersionParams.decode(e.value);
  },
  toProto(e) {
    return VersionParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.VersionParams",
      value: VersionParams.encode(e).finish()
    };
  }
};
function createBaseHashedParams() {
  return {
    blockMaxBytes: Long$2.ZERO,
    blockMaxGas: Long$2.ZERO
  };
}
const HashedParams = {
  typeUrl: "/tendermint.types.HashedParams",
  encode(e, n = minimal.Writer.create()) {
    return e.blockMaxBytes.isZero() || n.uint32(8).int64(e.blockMaxBytes), e.blockMaxGas.isZero() || n.uint32(16).int64(e.blockMaxGas), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHashedParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.blockMaxBytes = o.int64();
          break;
        case 2:
          c.blockMaxGas = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseHashedParams();
    return n.blockMaxBytes = e.blockMaxBytes !== void 0 && e.blockMaxBytes !== null ? Long$2.fromValue(e.blockMaxBytes) : Long$2.ZERO, n.blockMaxGas = e.blockMaxGas !== void 0 && e.blockMaxGas !== null ? Long$2.fromValue(e.blockMaxGas) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      blockMaxBytes: Long$2.fromString(e.block_max_bytes),
      blockMaxGas: Long$2.fromString(e.block_max_gas)
    };
  },
  toAmino(e) {
    const n = {};
    return n.block_max_bytes = e.blockMaxBytes ? e.blockMaxBytes.toString() : void 0, n.block_max_gas = e.blockMaxGas ? e.blockMaxGas.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return HashedParams.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return HashedParams.decode(e.value);
  },
  toProto(e) {
    return HashedParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.HashedParams",
      value: HashedParams.encode(e).finish()
    };
  }
}, _56 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BlockParams,
  ConsensusParams,
  EvidenceParams,
  HashedParams,
  ValidatorParams,
  VersionParams
}, Symbol.toStringTag, { value: "Module" }));
function createBaseProof() {
  return {
    total: Long$2.ZERO,
    index: Long$2.ZERO,
    leafHash: new Uint8Array(),
    aunts: []
  };
}
const Proof = {
  typeUrl: "/tendermint.crypto.Proof",
  encode(e, n = minimal.Writer.create()) {
    e.total.isZero() || n.uint32(8).int64(e.total), e.index.isZero() || n.uint32(16).int64(e.index), e.leafHash.length !== 0 && n.uint32(26).bytes(e.leafHash);
    for (const o of e.aunts)
      n.uint32(34).bytes(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.total = o.int64();
          break;
        case 2:
          c.index = o.int64();
          break;
        case 3:
          c.leafHash = o.bytes();
          break;
        case 4:
          c.aunts.push(o.bytes());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseProof();
    return u.total = e.total !== void 0 && e.total !== null ? Long$2.fromValue(e.total) : Long$2.ZERO, u.index = e.index !== void 0 && e.index !== null ? Long$2.fromValue(e.index) : Long$2.ZERO, u.leafHash = (n = e.leafHash) !== null && n !== void 0 ? n : new Uint8Array(), u.aunts = ((o = e.aunts) === null || o === void 0 ? void 0 : o.map((c) => c)) || [], u;
  },
  fromAmino(e) {
    return {
      total: Long$2.fromString(e.total),
      index: Long$2.fromString(e.index),
      leafHash: e.leaf_hash,
      aunts: Array.isArray(e == null ? void 0 : e.aunts) ? e.aunts.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.total = e.total ? e.total.toString() : void 0, n.index = e.index ? e.index.toString() : void 0, n.leaf_hash = e.leafHash, e.aunts ? n.aunts = e.aunts.map((o) => o) : n.aunts = [], n;
  },
  fromAminoMsg(e) {
    return Proof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Proof.decode(e.value);
  },
  toProto(e) {
    return Proof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.crypto.Proof",
      value: Proof.encode(e).finish()
    };
  }
};
function createBaseValueOp() {
  return {
    key: new Uint8Array(),
    proof: void 0
  };
}
const ValueOp = {
  typeUrl: "/tendermint.crypto.ValueOp",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.proof !== void 0 && Proof.encode(e.proof, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValueOp();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.proof = Proof.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValueOp();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o.proof = e.proof !== void 0 && e.proof !== null ? Proof.fromPartial(e.proof) : void 0, o;
  },
  fromAmino(e) {
    return {
      key: e.key,
      proof: e != null && e.proof ? Proof.fromAmino(e.proof) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.proof = e.proof ? Proof.toAmino(e.proof) : void 0, n;
  },
  fromAminoMsg(e) {
    return ValueOp.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ValueOp.decode(e.value);
  },
  toProto(e) {
    return ValueOp.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.crypto.ValueOp",
      value: ValueOp.encode(e).finish()
    };
  }
};
function createBaseDominoOp() {
  return {
    key: "",
    input: "",
    output: ""
  };
}
const DominoOp = {
  typeUrl: "/tendermint.crypto.DominoOp",
  encode(e, n = minimal.Writer.create()) {
    return e.key !== "" && n.uint32(10).string(e.key), e.input !== "" && n.uint32(18).string(e.input), e.output !== "" && n.uint32(26).string(e.output), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDominoOp();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.string();
          break;
        case 2:
          c.input = o.string();
          break;
        case 3:
          c.output = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseDominoOp();
    return c.key = (n = e.key) !== null && n !== void 0 ? n : "", c.input = (o = e.input) !== null && o !== void 0 ? o : "", c.output = (u = e.output) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      key: e.key,
      input: e.input,
      output: e.output
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.input = e.input, n.output = e.output, n;
  },
  fromAminoMsg(e) {
    return DominoOp.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return DominoOp.decode(e.value);
  },
  toProto(e) {
    return DominoOp.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.crypto.DominoOp",
      value: DominoOp.encode(e).finish()
    };
  }
};
function createBaseProofOp() {
  return {
    type: "",
    key: new Uint8Array(),
    data: new Uint8Array()
  };
}
const ProofOp = {
  typeUrl: "/tendermint.crypto.ProofOp",
  encode(e, n = minimal.Writer.create()) {
    return e.type !== "" && n.uint32(10).string(e.type), e.key.length !== 0 && n.uint32(18).bytes(e.key), e.data.length !== 0 && n.uint32(26).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProofOp();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.type = o.string();
          break;
        case 2:
          c.key = o.bytes();
          break;
        case 3:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseProofOp();
    return c.type = (n = e.type) !== null && n !== void 0 ? n : "", c.key = (o = e.key) !== null && o !== void 0 ? o : new Uint8Array(), c.data = (u = e.data) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      type: e.type,
      key: e.key,
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.type = e.type, n.key = e.key, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return ProofOp.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ProofOp.decode(e.value);
  },
  toProto(e) {
    return ProofOp.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.crypto.ProofOp",
      value: ProofOp.encode(e).finish()
    };
  }
};
function createBaseProofOps() {
  return {
    ops: []
  };
}
const ProofOps = {
  typeUrl: "/tendermint.crypto.ProofOps",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.ops)
      ProofOp.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProofOps();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.ops.push(ProofOp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseProofOps();
    return o.ops = ((n = e.ops) === null || n === void 0 ? void 0 : n.map((u) => ProofOp.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      ops: Array.isArray(e == null ? void 0 : e.ops) ? e.ops.map((n) => ProofOp.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.ops ? n.ops = e.ops.map((o) => o ? ProofOp.toAmino(o) : void 0) : n.ops = [], n;
  },
  fromAminoMsg(e) {
    return ProofOps.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ProofOps.decode(e.value);
  },
  toProto(e) {
    return ProofOps.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.crypto.ProofOps",
      value: ProofOps.encode(e).finish()
    };
  }
}, _51 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DominoOp,
  Proof,
  ProofOp,
  ProofOps,
  ValueOp
}, Symbol.toStringTag, { value: "Module" }));
function createBaseApp() {
  return {
    protocol: Long$2.UZERO,
    software: ""
  };
}
const App = {
  typeUrl: "/tendermint.version.App",
  encode(e, n = minimal.Writer.create()) {
    return e.protocol.isZero() || n.uint32(8).uint64(e.protocol), e.software !== "" && n.uint32(18).string(e.software), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseApp();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.protocol = o.uint64();
          break;
        case 2:
          c.software = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseApp();
    return o.protocol = e.protocol !== void 0 && e.protocol !== null ? Long$2.fromValue(e.protocol) : Long$2.UZERO, o.software = (n = e.software) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      protocol: Long$2.fromString(e.protocol),
      software: e.software
    };
  },
  toAmino(e) {
    const n = {};
    return n.protocol = e.protocol ? e.protocol.toString() : void 0, n.software = e.software, n;
  },
  fromAminoMsg(e) {
    return App.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return App.decode(e.value);
  },
  toProto(e) {
    return App.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.version.App",
      value: App.encode(e).finish()
    };
  }
};
function createBaseConsensus() {
  return {
    block: Long$2.UZERO,
    app: Long$2.UZERO
  };
}
const Consensus = {
  typeUrl: "/tendermint.version.Consensus",
  encode(e, n = minimal.Writer.create()) {
    return e.block.isZero() || n.uint32(8).uint64(e.block), e.app.isZero() || n.uint32(16).uint64(e.app), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConsensus();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.block = o.uint64();
          break;
        case 2:
          c.app = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseConsensus();
    return n.block = e.block !== void 0 && e.block !== null ? Long$2.fromValue(e.block) : Long$2.UZERO, n.app = e.app !== void 0 && e.app !== null ? Long$2.fromValue(e.app) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      block: Long$2.fromString(e.block),
      app: Long$2.fromString(e.app)
    };
  },
  toAmino(e) {
    const n = {};
    return n.block = e.block ? e.block.toString() : void 0, n.app = e.app ? e.app.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Consensus.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Consensus.decode(e.value);
  },
  toProto(e) {
    return Consensus.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.version.Consensus",
      value: Consensus.encode(e).finish()
    };
  }
}, _59 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  App,
  Consensus
}, Symbol.toStringTag, { value: "Module" }));
function createBasePublicKey() {
  return {
    ed25519: void 0,
    secp256k1: void 0
  };
}
const PublicKey = {
  typeUrl: "/tendermint.crypto.PublicKey",
  encode(e, n = minimal.Writer.create()) {
    return e.ed25519 !== void 0 && n.uint32(10).bytes(e.ed25519), e.secp256k1 !== void 0 && n.uint32(18).bytes(e.secp256k1), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePublicKey();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.ed25519 = o.bytes();
          break;
        case 2:
          c.secp256k1 = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePublicKey();
    return u.ed25519 = (n = e.ed25519) !== null && n !== void 0 ? n : void 0, u.secp256k1 = (o = e.secp256k1) !== null && o !== void 0 ? o : void 0, u;
  },
  fromAmino(e) {
    return {
      ed25519: e == null ? void 0 : e.ed25519,
      secp256k1: e == null ? void 0 : e.secp256k1
    };
  },
  toAmino(e) {
    const n = {};
    return n.ed25519 = e.ed25519, n.secp256k1 = e.secp256k1, n;
  },
  fromAminoMsg(e) {
    return PublicKey.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return PublicKey.decode(e.value);
  },
  toProto(e) {
    return PublicKey.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.crypto.PublicKey",
      value: PublicKey.encode(e).finish()
    };
  }
}, _50 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PublicKey
}, Symbol.toStringTag, { value: "Module" }));
function createBaseValidatorSet() {
  return {
    validators: [],
    proposer: void 0,
    totalVotingPower: Long$2.ZERO
  };
}
const ValidatorSet = {
  typeUrl: "/tendermint.types.ValidatorSet",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.validators)
      Validator$2.encode(o, n.uint32(10).fork()).ldelim();
    return e.proposer !== void 0 && Validator$2.encode(e.proposer, n.uint32(18).fork()).ldelim(), e.totalVotingPower.isZero() || n.uint32(24).int64(e.totalVotingPower), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorSet();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validators.push(Validator$2.decode(o, o.uint32()));
          break;
        case 2:
          c.proposer = Validator$2.decode(o, o.uint32());
          break;
        case 3:
          c.totalVotingPower = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorSet();
    return o.validators = ((n = e.validators) === null || n === void 0 ? void 0 : n.map((u) => Validator$2.fromPartial(u))) || [], o.proposer = e.proposer !== void 0 && e.proposer !== null ? Validator$2.fromPartial(e.proposer) : void 0, o.totalVotingPower = e.totalVotingPower !== void 0 && e.totalVotingPower !== null ? Long$2.fromValue(e.totalVotingPower) : Long$2.ZERO, o;
  },
  fromAmino(e) {
    return {
      validators: Array.isArray(e == null ? void 0 : e.validators) ? e.validators.map((n) => Validator$2.fromAmino(n)) : [],
      proposer: e != null && e.proposer ? Validator$2.fromAmino(e.proposer) : void 0,
      totalVotingPower: Long$2.fromString(e.total_voting_power)
    };
  },
  toAmino(e) {
    const n = {};
    return e.validators ? n.validators = e.validators.map((o) => o ? Validator$2.toAmino(o) : void 0) : n.validators = [], n.proposer = e.proposer ? Validator$2.toAmino(e.proposer) : void 0, n.total_voting_power = e.totalVotingPower ? e.totalVotingPower.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ValidatorSet.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ValidatorSet.decode(e.value);
  },
  toProto(e) {
    return ValidatorSet.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.ValidatorSet",
      value: ValidatorSet.encode(e).finish()
    };
  }
};
function createBaseValidator$2() {
  return {
    address: new Uint8Array(),
    pubKey: void 0,
    votingPower: Long$2.ZERO,
    proposerPriority: Long$2.ZERO
  };
}
const Validator$2 = {
  typeUrl: "/tendermint.types.Validator",
  encode(e, n = minimal.Writer.create()) {
    return e.address.length !== 0 && n.uint32(10).bytes(e.address), e.pubKey !== void 0 && PublicKey.encode(e.pubKey, n.uint32(18).fork()).ldelim(), e.votingPower.isZero() || n.uint32(24).int64(e.votingPower), e.proposerPriority.isZero() || n.uint32(32).int64(e.proposerPriority), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidator$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.bytes();
          break;
        case 2:
          c.pubKey = PublicKey.decode(o, o.uint32());
          break;
        case 3:
          c.votingPower = o.int64();
          break;
        case 4:
          c.proposerPriority = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidator$2();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : new Uint8Array(), o.pubKey = e.pubKey !== void 0 && e.pubKey !== null ? PublicKey.fromPartial(e.pubKey) : void 0, o.votingPower = e.votingPower !== void 0 && e.votingPower !== null ? Long$2.fromValue(e.votingPower) : Long$2.ZERO, o.proposerPriority = e.proposerPriority !== void 0 && e.proposerPriority !== null ? Long$2.fromValue(e.proposerPriority) : Long$2.ZERO, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      pubKey: e != null && e.pub_key ? PublicKey.fromAmino(e.pub_key) : void 0,
      votingPower: Long$2.fromString(e.voting_power),
      proposerPriority: Long$2.fromString(e.proposer_priority)
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.pub_key = e.pubKey ? PublicKey.toAmino(e.pubKey) : void 0, n.voting_power = e.votingPower ? e.votingPower.toString() : void 0, n.proposer_priority = e.proposerPriority ? e.proposerPriority.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Validator$2.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Validator$2.decode(e.value);
  },
  toProto(e) {
    return Validator$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Validator",
      value: Validator$2.encode(e).finish()
    };
  }
};
function createBaseSimpleValidator() {
  return {
    pubKey: void 0,
    votingPower: Long$2.ZERO
  };
}
const SimpleValidator = {
  typeUrl: "/tendermint.types.SimpleValidator",
  encode(e, n = minimal.Writer.create()) {
    return e.pubKey !== void 0 && PublicKey.encode(e.pubKey, n.uint32(10).fork()).ldelim(), e.votingPower.isZero() || n.uint32(16).int64(e.votingPower), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSimpleValidator();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pubKey = PublicKey.decode(o, o.uint32());
          break;
        case 2:
          c.votingPower = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseSimpleValidator();
    return n.pubKey = e.pubKey !== void 0 && e.pubKey !== null ? PublicKey.fromPartial(e.pubKey) : void 0, n.votingPower = e.votingPower !== void 0 && e.votingPower !== null ? Long$2.fromValue(e.votingPower) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      pubKey: e != null && e.pub_key ? PublicKey.fromAmino(e.pub_key) : void 0,
      votingPower: Long$2.fromString(e.voting_power)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pub_key = e.pubKey ? PublicKey.toAmino(e.pubKey) : void 0, n.voting_power = e.votingPower ? e.votingPower.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return SimpleValidator.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return SimpleValidator.decode(e.value);
  },
  toProto(e) {
    return SimpleValidator.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.SimpleValidator",
      value: SimpleValidator.encode(e).finish()
    };
  }
}, _58 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SimpleValidator,
  Validator: Validator$2,
  ValidatorSet
}, Symbol.toStringTag, { value: "Module" }));
let BlockIDFlag;
(function(e) {
  e[e.BLOCK_ID_FLAG_UNKNOWN = 0] = "BLOCK_ID_FLAG_UNKNOWN", e[e.BLOCK_ID_FLAG_ABSENT = 1] = "BLOCK_ID_FLAG_ABSENT", e[e.BLOCK_ID_FLAG_COMMIT = 2] = "BLOCK_ID_FLAG_COMMIT", e[e.BLOCK_ID_FLAG_NIL = 3] = "BLOCK_ID_FLAG_NIL", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(BlockIDFlag || (BlockIDFlag = {}));
const BlockIDFlagSDKType = BlockIDFlag, BlockIDFlagAmino = BlockIDFlag;
function blockIDFlagFromJSON(e) {
  switch (e) {
    case 0:
    case "BLOCK_ID_FLAG_UNKNOWN":
      return BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
    case 1:
    case "BLOCK_ID_FLAG_ABSENT":
      return BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
    case 2:
    case "BLOCK_ID_FLAG_COMMIT":
      return BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
    case 3:
    case "BLOCK_ID_FLAG_NIL":
      return BlockIDFlag.BLOCK_ID_FLAG_NIL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BlockIDFlag.UNRECOGNIZED;
  }
}
function blockIDFlagToJSON(e) {
  switch (e) {
    case BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
      return "BLOCK_ID_FLAG_UNKNOWN";
    case BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
      return "BLOCK_ID_FLAG_ABSENT";
    case BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
      return "BLOCK_ID_FLAG_COMMIT";
    case BlockIDFlag.BLOCK_ID_FLAG_NIL:
      return "BLOCK_ID_FLAG_NIL";
    case BlockIDFlag.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let SignedMsgType;
(function(e) {
  e[e.SIGNED_MSG_TYPE_UNKNOWN = 0] = "SIGNED_MSG_TYPE_UNKNOWN", e[e.SIGNED_MSG_TYPE_PREVOTE = 1] = "SIGNED_MSG_TYPE_PREVOTE", e[e.SIGNED_MSG_TYPE_PRECOMMIT = 2] = "SIGNED_MSG_TYPE_PRECOMMIT", e[e.SIGNED_MSG_TYPE_PROPOSAL = 32] = "SIGNED_MSG_TYPE_PROPOSAL", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(SignedMsgType || (SignedMsgType = {}));
const SignedMsgTypeSDKType = SignedMsgType, SignedMsgTypeAmino = SignedMsgType;
function signedMsgTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "SIGNED_MSG_TYPE_UNKNOWN":
      return SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
    case 1:
    case "SIGNED_MSG_TYPE_PREVOTE":
      return SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
    case 2:
    case "SIGNED_MSG_TYPE_PRECOMMIT":
      return SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
    case 32:
    case "SIGNED_MSG_TYPE_PROPOSAL":
      return SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SignedMsgType.UNRECOGNIZED;
  }
}
function signedMsgTypeToJSON(e) {
  switch (e) {
    case SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
      return "SIGNED_MSG_TYPE_UNKNOWN";
    case SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
      return "SIGNED_MSG_TYPE_PREVOTE";
    case SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
      return "SIGNED_MSG_TYPE_PRECOMMIT";
    case SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
      return "SIGNED_MSG_TYPE_PROPOSAL";
    case SignedMsgType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBasePartSetHeader() {
  return {
    total: 0,
    hash: new Uint8Array()
  };
}
const PartSetHeader = {
  typeUrl: "/tendermint.types.PartSetHeader",
  encode(e, n = minimal.Writer.create()) {
    return e.total !== 0 && n.uint32(8).uint32(e.total), e.hash.length !== 0 && n.uint32(18).bytes(e.hash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePartSetHeader();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.total = o.uint32();
          break;
        case 2:
          c.hash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePartSetHeader();
    return u.total = (n = e.total) !== null && n !== void 0 ? n : 0, u.hash = (o = e.hash) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      total: e.total,
      hash: e.hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.total = e.total, n.hash = e.hash, n;
  },
  fromAminoMsg(e) {
    return PartSetHeader.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return PartSetHeader.decode(e.value);
  },
  toProto(e) {
    return PartSetHeader.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.PartSetHeader",
      value: PartSetHeader.encode(e).finish()
    };
  }
};
function createBasePart() {
  return {
    index: 0,
    bytes: new Uint8Array(),
    proof: void 0
  };
}
const Part = {
  typeUrl: "/tendermint.types.Part",
  encode(e, n = minimal.Writer.create()) {
    return e.index !== 0 && n.uint32(8).uint32(e.index), e.bytes.length !== 0 && n.uint32(18).bytes(e.bytes), e.proof !== void 0 && Proof.encode(e.proof, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePart();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.index = o.uint32();
          break;
        case 2:
          c.bytes = o.bytes();
          break;
        case 3:
          c.proof = Proof.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePart();
    return u.index = (n = e.index) !== null && n !== void 0 ? n : 0, u.bytes = (o = e.bytes) !== null && o !== void 0 ? o : new Uint8Array(), u.proof = e.proof !== void 0 && e.proof !== null ? Proof.fromPartial(e.proof) : void 0, u;
  },
  fromAmino(e) {
    return {
      index: e.index,
      bytes: e.bytes,
      proof: e != null && e.proof ? Proof.fromAmino(e.proof) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.index = e.index, n.bytes = e.bytes, n.proof = e.proof ? Proof.toAmino(e.proof) : void 0, n;
  },
  fromAminoMsg(e) {
    return Part.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Part.decode(e.value);
  },
  toProto(e) {
    return Part.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Part",
      value: Part.encode(e).finish()
    };
  }
};
function createBaseBlockID() {
  return {
    hash: new Uint8Array(),
    partSetHeader: void 0
  };
}
const BlockID = {
  typeUrl: "/tendermint.types.BlockID",
  encode(e, n = minimal.Writer.create()) {
    return e.hash.length !== 0 && n.uint32(10).bytes(e.hash), e.partSetHeader !== void 0 && PartSetHeader.encode(e.partSetHeader, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBlockID();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.bytes();
          break;
        case 2:
          c.partSetHeader = PartSetHeader.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseBlockID();
    return o.hash = (n = e.hash) !== null && n !== void 0 ? n : new Uint8Array(), o.partSetHeader = e.partSetHeader !== void 0 && e.partSetHeader !== null ? PartSetHeader.fromPartial(e.partSetHeader) : void 0, o;
  },
  fromAmino(e) {
    return {
      hash: e.hash,
      partSetHeader: e != null && e.part_set_header ? PartSetHeader.fromAmino(e.part_set_header) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n.part_set_header = e.partSetHeader ? PartSetHeader.toAmino(e.partSetHeader) : void 0, n;
  },
  fromAminoMsg(e) {
    return BlockID.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return BlockID.decode(e.value);
  },
  toProto(e) {
    return BlockID.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.BlockID",
      value: BlockID.encode(e).finish()
    };
  }
};
function createBaseHeader$3() {
  return {
    version: void 0,
    chainId: "",
    height: Long$2.ZERO,
    time: void 0,
    lastBlockId: void 0,
    lastCommitHash: new Uint8Array(),
    dataHash: new Uint8Array(),
    validatorsHash: new Uint8Array(),
    nextValidatorsHash: new Uint8Array(),
    consensusHash: new Uint8Array(),
    appHash: new Uint8Array(),
    lastResultsHash: new Uint8Array(),
    evidenceHash: new Uint8Array(),
    proposerAddress: new Uint8Array()
  };
}
const Header$3 = {
  typeUrl: "/tendermint.types.Header",
  encode(e, n = minimal.Writer.create()) {
    return e.version !== void 0 && Consensus.encode(e.version, n.uint32(10).fork()).ldelim(), e.chainId !== "" && n.uint32(18).string(e.chainId), e.height.isZero() || n.uint32(24).int64(e.height), e.time !== void 0 && Timestamp.encode(toTimestamp(e.time), n.uint32(34).fork()).ldelim(), e.lastBlockId !== void 0 && BlockID.encode(e.lastBlockId, n.uint32(42).fork()).ldelim(), e.lastCommitHash.length !== 0 && n.uint32(50).bytes(e.lastCommitHash), e.dataHash.length !== 0 && n.uint32(58).bytes(e.dataHash), e.validatorsHash.length !== 0 && n.uint32(66).bytes(e.validatorsHash), e.nextValidatorsHash.length !== 0 && n.uint32(74).bytes(e.nextValidatorsHash), e.consensusHash.length !== 0 && n.uint32(82).bytes(e.consensusHash), e.appHash.length !== 0 && n.uint32(90).bytes(e.appHash), e.lastResultsHash.length !== 0 && n.uint32(98).bytes(e.lastResultsHash), e.evidenceHash.length !== 0 && n.uint32(106).bytes(e.evidenceHash), e.proposerAddress.length !== 0 && n.uint32(114).bytes(e.proposerAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHeader$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.version = Consensus.decode(o, o.uint32());
          break;
        case 2:
          c.chainId = o.string();
          break;
        case 3:
          c.height = o.int64();
          break;
        case 4:
          c.time = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 5:
          c.lastBlockId = BlockID.decode(o, o.uint32());
          break;
        case 6:
          c.lastCommitHash = o.bytes();
          break;
        case 7:
          c.dataHash = o.bytes();
          break;
        case 8:
          c.validatorsHash = o.bytes();
          break;
        case 9:
          c.nextValidatorsHash = o.bytes();
          break;
        case 10:
          c.consensusHash = o.bytes();
          break;
        case 11:
          c.appHash = o.bytes();
          break;
        case 12:
          c.lastResultsHash = o.bytes();
          break;
        case 13:
          c.evidenceHash = o.bytes();
          break;
        case 14:
          c.proposerAddress = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $, E, O;
    const T = createBaseHeader$3();
    return T.version = e.version !== void 0 && e.version !== null ? Consensus.fromPartial(e.version) : void 0, T.chainId = (n = e.chainId) !== null && n !== void 0 ? n : "", T.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, T.time = (o = e.time) !== null && o !== void 0 ? o : void 0, T.lastBlockId = e.lastBlockId !== void 0 && e.lastBlockId !== null ? BlockID.fromPartial(e.lastBlockId) : void 0, T.lastCommitHash = (u = e.lastCommitHash) !== null && u !== void 0 ? u : new Uint8Array(), T.dataHash = (c = e.dataHash) !== null && c !== void 0 ? c : new Uint8Array(), T.validatorsHash = (d = e.validatorsHash) !== null && d !== void 0 ? d : new Uint8Array(), T.nextValidatorsHash = (m = e.nextValidatorsHash) !== null && m !== void 0 ? m : new Uint8Array(), T.consensusHash = (v = e.consensusHash) !== null && v !== void 0 ? v : new Uint8Array(), T.appHash = (S = e.appHash) !== null && S !== void 0 ? S : new Uint8Array(), T.lastResultsHash = ($ = e.lastResultsHash) !== null && $ !== void 0 ? $ : new Uint8Array(), T.evidenceHash = (E = e.evidenceHash) !== null && E !== void 0 ? E : new Uint8Array(), T.proposerAddress = (O = e.proposerAddress) !== null && O !== void 0 ? O : new Uint8Array(), T;
  },
  fromAmino(e) {
    return {
      version: e != null && e.version ? Consensus.fromAmino(e.version) : void 0,
      chainId: e.chain_id,
      height: Long$2.fromString(e.height),
      time: e != null && e.time ? Timestamp.fromAmino(e.time) : void 0,
      lastBlockId: e != null && e.last_block_id ? BlockID.fromAmino(e.last_block_id) : void 0,
      lastCommitHash: e.last_commit_hash,
      dataHash: e.data_hash,
      validatorsHash: e.validators_hash,
      nextValidatorsHash: e.next_validators_hash,
      consensusHash: e.consensus_hash,
      appHash: e.app_hash,
      lastResultsHash: e.last_results_hash,
      evidenceHash: e.evidence_hash,
      proposerAddress: e.proposer_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.version = e.version ? Consensus.toAmino(e.version) : void 0, n.chain_id = e.chainId, n.height = e.height ? e.height.toString() : void 0, n.time = e.time ? Timestamp.toAmino(e.time) : void 0, n.last_block_id = e.lastBlockId ? BlockID.toAmino(e.lastBlockId) : void 0, n.last_commit_hash = e.lastCommitHash, n.data_hash = e.dataHash, n.validators_hash = e.validatorsHash, n.next_validators_hash = e.nextValidatorsHash, n.consensus_hash = e.consensusHash, n.app_hash = e.appHash, n.last_results_hash = e.lastResultsHash, n.evidence_hash = e.evidenceHash, n.proposer_address = e.proposerAddress, n;
  },
  fromAminoMsg(e) {
    return Header$3.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Header$3.decode(e.value);
  },
  toProto(e) {
    return Header$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Header",
      value: Header$3.encode(e).finish()
    };
  }
};
function createBaseData() {
  return {
    txs: []
  };
}
const Data = {
  typeUrl: "/tendermint.types.Data",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.txs)
      n.uint32(10).bytes(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.txs.push(o.bytes());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseData();
    return o.txs = ((n = e.txs) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      txs: Array.isArray(e == null ? void 0 : e.txs) ? e.txs.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.txs ? n.txs = e.txs.map((o) => o) : n.txs = [], n;
  },
  fromAminoMsg(e) {
    return Data.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Data.decode(e.value);
  },
  toProto(e) {
    return Data.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Data",
      value: Data.encode(e).finish()
    };
  }
};
function createBaseVote$2() {
  return {
    type: 0,
    height: Long$2.ZERO,
    round: 0,
    blockId: void 0,
    timestamp: void 0,
    validatorAddress: new Uint8Array(),
    validatorIndex: 0,
    signature: new Uint8Array()
  };
}
const Vote$2 = {
  typeUrl: "/tendermint.types.Vote",
  encode(e, n = minimal.Writer.create()) {
    return e.type !== 0 && n.uint32(8).int32(e.type), e.height.isZero() || n.uint32(16).int64(e.height), e.round !== 0 && n.uint32(24).int32(e.round), e.blockId !== void 0 && BlockID.encode(e.blockId, n.uint32(34).fork()).ldelim(), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(42).fork()).ldelim(), e.validatorAddress.length !== 0 && n.uint32(50).bytes(e.validatorAddress), e.validatorIndex !== 0 && n.uint32(56).int32(e.validatorIndex), e.signature.length !== 0 && n.uint32(66).bytes(e.signature), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseVote$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.type = o.int32();
          break;
        case 2:
          c.height = o.int64();
          break;
        case 3:
          c.round = o.int32();
          break;
        case 4:
          c.blockId = BlockID.decode(o, o.uint32());
          break;
        case 5:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 6:
          c.validatorAddress = o.bytes();
          break;
        case 7:
          c.validatorIndex = o.int32();
          break;
        case 8:
          c.signature = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseVote$2();
    return v.type = (n = e.type) !== null && n !== void 0 ? n : 0, v.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, v.round = (o = e.round) !== null && o !== void 0 ? o : 0, v.blockId = e.blockId !== void 0 && e.blockId !== null ? BlockID.fromPartial(e.blockId) : void 0, v.timestamp = (u = e.timestamp) !== null && u !== void 0 ? u : void 0, v.validatorAddress = (c = e.validatorAddress) !== null && c !== void 0 ? c : new Uint8Array(), v.validatorIndex = (d = e.validatorIndex) !== null && d !== void 0 ? d : 0, v.signature = (m = e.signature) !== null && m !== void 0 ? m : new Uint8Array(), v;
  },
  fromAmino(e) {
    return {
      type: isSet(e.type) ? signedMsgTypeFromJSON(e.type) : 0,
      height: Long$2.fromString(e.height),
      round: e.round,
      blockId: e != null && e.block_id ? BlockID.fromAmino(e.block_id) : void 0,
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0,
      validatorAddress: e.validator_address,
      validatorIndex: e.validator_index,
      signature: e.signature
    };
  },
  toAmino(e) {
    const n = {};
    return n.type = e.type, n.height = e.height ? e.height.toString() : void 0, n.round = e.round, n.block_id = e.blockId ? BlockID.toAmino(e.blockId) : void 0, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n.validator_address = e.validatorAddress, n.validator_index = e.validatorIndex, n.signature = e.signature, n;
  },
  fromAminoMsg(e) {
    return Vote$2.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Vote$2.decode(e.value);
  },
  toProto(e) {
    return Vote$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Vote",
      value: Vote$2.encode(e).finish()
    };
  }
};
function createBaseCommit() {
  return {
    height: Long$2.ZERO,
    round: 0,
    blockId: void 0,
    signatures: []
  };
}
const Commit = {
  typeUrl: "/tendermint.types.Commit",
  encode(e, n = minimal.Writer.create()) {
    e.height.isZero() || n.uint32(8).int64(e.height), e.round !== 0 && n.uint32(16).int32(e.round), e.blockId !== void 0 && BlockID.encode(e.blockId, n.uint32(26).fork()).ldelim();
    for (const o of e.signatures)
      CommitSig.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = o.int64();
          break;
        case 2:
          c.round = o.int32();
          break;
        case 3:
          c.blockId = BlockID.decode(o, o.uint32());
          break;
        case 4:
          c.signatures.push(CommitSig.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCommit();
    return u.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, u.round = (n = e.round) !== null && n !== void 0 ? n : 0, u.blockId = e.blockId !== void 0 && e.blockId !== null ? BlockID.fromPartial(e.blockId) : void 0, u.signatures = ((o = e.signatures) === null || o === void 0 ? void 0 : o.map((c) => CommitSig.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      height: Long$2.fromString(e.height),
      round: e.round,
      blockId: e != null && e.block_id ? BlockID.fromAmino(e.block_id) : void 0,
      signatures: Array.isArray(e == null ? void 0 : e.signatures) ? e.signatures.map((n) => CommitSig.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? e.height.toString() : void 0, n.round = e.round, n.block_id = e.blockId ? BlockID.toAmino(e.blockId) : void 0, e.signatures ? n.signatures = e.signatures.map((o) => o ? CommitSig.toAmino(o) : void 0) : n.signatures = [], n;
  },
  fromAminoMsg(e) {
    return Commit.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Commit.decode(e.value);
  },
  toProto(e) {
    return Commit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Commit",
      value: Commit.encode(e).finish()
    };
  }
};
function createBaseCommitSig() {
  return {
    blockIdFlag: 0,
    validatorAddress: new Uint8Array(),
    timestamp: void 0,
    signature: new Uint8Array()
  };
}
const CommitSig = {
  typeUrl: "/tendermint.types.CommitSig",
  encode(e, n = minimal.Writer.create()) {
    return e.blockIdFlag !== 0 && n.uint32(8).int32(e.blockIdFlag), e.validatorAddress.length !== 0 && n.uint32(18).bytes(e.validatorAddress), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(26).fork()).ldelim(), e.signature.length !== 0 && n.uint32(34).bytes(e.signature), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommitSig();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.blockIdFlag = o.int32();
          break;
        case 2:
          c.validatorAddress = o.bytes();
          break;
        case 3:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 4:
          c.signature = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseCommitSig();
    return d.blockIdFlag = (n = e.blockIdFlag) !== null && n !== void 0 ? n : 0, d.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : new Uint8Array(), d.timestamp = (u = e.timestamp) !== null && u !== void 0 ? u : void 0, d.signature = (c = e.signature) !== null && c !== void 0 ? c : new Uint8Array(), d;
  },
  fromAmino(e) {
    return {
      blockIdFlag: isSet(e.block_id_flag) ? blockIDFlagFromJSON(e.block_id_flag) : 0,
      validatorAddress: e.validator_address,
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0,
      signature: e.signature
    };
  },
  toAmino(e) {
    const n = {};
    return n.block_id_flag = e.blockIdFlag, n.validator_address = e.validatorAddress, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n.signature = e.signature, n;
  },
  fromAminoMsg(e) {
    return CommitSig.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return CommitSig.decode(e.value);
  },
  toProto(e) {
    return CommitSig.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.CommitSig",
      value: CommitSig.encode(e).finish()
    };
  }
};
function createBaseProposal$2() {
  return {
    type: 0,
    height: Long$2.ZERO,
    round: 0,
    polRound: 0,
    blockId: void 0,
    timestamp: void 0,
    signature: new Uint8Array()
  };
}
const Proposal$2 = {
  typeUrl: "/tendermint.types.Proposal",
  encode(e, n = minimal.Writer.create()) {
    return e.type !== 0 && n.uint32(8).int32(e.type), e.height.isZero() || n.uint32(16).int64(e.height), e.round !== 0 && n.uint32(24).int32(e.round), e.polRound !== 0 && n.uint32(32).int32(e.polRound), e.blockId !== void 0 && BlockID.encode(e.blockId, n.uint32(42).fork()).ldelim(), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(50).fork()).ldelim(), e.signature.length !== 0 && n.uint32(58).bytes(e.signature), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProposal$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.type = o.int32();
          break;
        case 2:
          c.height = o.int64();
          break;
        case 3:
          c.round = o.int32();
          break;
        case 4:
          c.polRound = o.int32();
          break;
        case 5:
          c.blockId = BlockID.decode(o, o.uint32());
          break;
        case 6:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 7:
          c.signature = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseProposal$2();
    return m.type = (n = e.type) !== null && n !== void 0 ? n : 0, m.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, m.round = (o = e.round) !== null && o !== void 0 ? o : 0, m.polRound = (u = e.polRound) !== null && u !== void 0 ? u : 0, m.blockId = e.blockId !== void 0 && e.blockId !== null ? BlockID.fromPartial(e.blockId) : void 0, m.timestamp = (c = e.timestamp) !== null && c !== void 0 ? c : void 0, m.signature = (d = e.signature) !== null && d !== void 0 ? d : new Uint8Array(), m;
  },
  fromAmino(e) {
    return {
      type: isSet(e.type) ? signedMsgTypeFromJSON(e.type) : 0,
      height: Long$2.fromString(e.height),
      round: e.round,
      polRound: e.pol_round,
      blockId: e != null && e.block_id ? BlockID.fromAmino(e.block_id) : void 0,
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0,
      signature: e.signature
    };
  },
  toAmino(e) {
    const n = {};
    return n.type = e.type, n.height = e.height ? e.height.toString() : void 0, n.round = e.round, n.pol_round = e.polRound, n.block_id = e.blockId ? BlockID.toAmino(e.blockId) : void 0, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n.signature = e.signature, n;
  },
  fromAminoMsg(e) {
    return Proposal$2.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Proposal$2.decode(e.value);
  },
  toProto(e) {
    return Proposal$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Proposal",
      value: Proposal$2.encode(e).finish()
    };
  }
};
function createBaseSignedHeader() {
  return {
    header: void 0,
    commit: void 0
  };
}
const SignedHeader = {
  typeUrl: "/tendermint.types.SignedHeader",
  encode(e, n = minimal.Writer.create()) {
    return e.header !== void 0 && Header$3.encode(e.header, n.uint32(10).fork()).ldelim(), e.commit !== void 0 && Commit.encode(e.commit, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignedHeader();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.header = Header$3.decode(o, o.uint32());
          break;
        case 2:
          c.commit = Commit.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseSignedHeader();
    return n.header = e.header !== void 0 && e.header !== null ? Header$3.fromPartial(e.header) : void 0, n.commit = e.commit !== void 0 && e.commit !== null ? Commit.fromPartial(e.commit) : void 0, n;
  },
  fromAmino(e) {
    return {
      header: e != null && e.header ? Header$3.fromAmino(e.header) : void 0,
      commit: e != null && e.commit ? Commit.fromAmino(e.commit) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.header = e.header ? Header$3.toAmino(e.header) : void 0, n.commit = e.commit ? Commit.toAmino(e.commit) : void 0, n;
  },
  fromAminoMsg(e) {
    return SignedHeader.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return SignedHeader.decode(e.value);
  },
  toProto(e) {
    return SignedHeader.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.SignedHeader",
      value: SignedHeader.encode(e).finish()
    };
  }
};
function createBaseLightBlock() {
  return {
    signedHeader: void 0,
    validatorSet: void 0
  };
}
const LightBlock = {
  typeUrl: "/tendermint.types.LightBlock",
  encode(e, n = minimal.Writer.create()) {
    return e.signedHeader !== void 0 && SignedHeader.encode(e.signedHeader, n.uint32(10).fork()).ldelim(), e.validatorSet !== void 0 && ValidatorSet.encode(e.validatorSet, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLightBlock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signedHeader = SignedHeader.decode(o, o.uint32());
          break;
        case 2:
          c.validatorSet = ValidatorSet.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseLightBlock();
    return n.signedHeader = e.signedHeader !== void 0 && e.signedHeader !== null ? SignedHeader.fromPartial(e.signedHeader) : void 0, n.validatorSet = e.validatorSet !== void 0 && e.validatorSet !== null ? ValidatorSet.fromPartial(e.validatorSet) : void 0, n;
  },
  fromAmino(e) {
    return {
      signedHeader: e != null && e.signed_header ? SignedHeader.fromAmino(e.signed_header) : void 0,
      validatorSet: e != null && e.validator_set ? ValidatorSet.fromAmino(e.validator_set) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.signed_header = e.signedHeader ? SignedHeader.toAmino(e.signedHeader) : void 0, n.validator_set = e.validatorSet ? ValidatorSet.toAmino(e.validatorSet) : void 0, n;
  },
  fromAminoMsg(e) {
    return LightBlock.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return LightBlock.decode(e.value);
  },
  toProto(e) {
    return LightBlock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.LightBlock",
      value: LightBlock.encode(e).finish()
    };
  }
};
function createBaseBlockMeta() {
  return {
    blockId: void 0,
    blockSize: Long$2.ZERO,
    header: void 0,
    numTxs: Long$2.ZERO
  };
}
const BlockMeta = {
  typeUrl: "/tendermint.types.BlockMeta",
  encode(e, n = minimal.Writer.create()) {
    return e.blockId !== void 0 && BlockID.encode(e.blockId, n.uint32(10).fork()).ldelim(), e.blockSize.isZero() || n.uint32(16).int64(e.blockSize), e.header !== void 0 && Header$3.encode(e.header, n.uint32(26).fork()).ldelim(), e.numTxs.isZero() || n.uint32(32).int64(e.numTxs), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBlockMeta();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.blockId = BlockID.decode(o, o.uint32());
          break;
        case 2:
          c.blockSize = o.int64();
          break;
        case 3:
          c.header = Header$3.decode(o, o.uint32());
          break;
        case 4:
          c.numTxs = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseBlockMeta();
    return n.blockId = e.blockId !== void 0 && e.blockId !== null ? BlockID.fromPartial(e.blockId) : void 0, n.blockSize = e.blockSize !== void 0 && e.blockSize !== null ? Long$2.fromValue(e.blockSize) : Long$2.ZERO, n.header = e.header !== void 0 && e.header !== null ? Header$3.fromPartial(e.header) : void 0, n.numTxs = e.numTxs !== void 0 && e.numTxs !== null ? Long$2.fromValue(e.numTxs) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      blockId: e != null && e.block_id ? BlockID.fromAmino(e.block_id) : void 0,
      blockSize: Long$2.fromString(e.block_size),
      header: e != null && e.header ? Header$3.fromAmino(e.header) : void 0,
      numTxs: Long$2.fromString(e.num_txs)
    };
  },
  toAmino(e) {
    const n = {};
    return n.block_id = e.blockId ? BlockID.toAmino(e.blockId) : void 0, n.block_size = e.blockSize ? e.blockSize.toString() : void 0, n.header = e.header ? Header$3.toAmino(e.header) : void 0, n.num_txs = e.numTxs ? e.numTxs.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return BlockMeta.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return BlockMeta.decode(e.value);
  },
  toProto(e) {
    return BlockMeta.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.BlockMeta",
      value: BlockMeta.encode(e).finish()
    };
  }
};
function createBaseTxProof() {
  return {
    rootHash: new Uint8Array(),
    data: new Uint8Array(),
    proof: void 0
  };
}
const TxProof = {
  typeUrl: "/tendermint.types.TxProof",
  encode(e, n = minimal.Writer.create()) {
    return e.rootHash.length !== 0 && n.uint32(10).bytes(e.rootHash), e.data.length !== 0 && n.uint32(18).bytes(e.data), e.proof !== void 0 && Proof.encode(e.proof, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTxProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.rootHash = o.bytes();
          break;
        case 2:
          c.data = o.bytes();
          break;
        case 3:
          c.proof = Proof.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseTxProof();
    return u.rootHash = (n = e.rootHash) !== null && n !== void 0 ? n : new Uint8Array(), u.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), u.proof = e.proof !== void 0 && e.proof !== null ? Proof.fromPartial(e.proof) : void 0, u;
  },
  fromAmino(e) {
    return {
      rootHash: e.root_hash,
      data: e.data,
      proof: e != null && e.proof ? Proof.fromAmino(e.proof) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.root_hash = e.rootHash, n.data = e.data, n.proof = e.proof ? Proof.toAmino(e.proof) : void 0, n;
  },
  fromAminoMsg(e) {
    return TxProof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return TxProof.decode(e.value);
  },
  toProto(e) {
    return TxProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.TxProof",
      value: TxProof.encode(e).finish()
    };
  }
}, _57 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BlockID,
  get BlockIDFlag() {
    return BlockIDFlag;
  },
  BlockIDFlagAmino,
  BlockIDFlagSDKType,
  BlockMeta,
  Commit,
  CommitSig,
  Data,
  Header: Header$3,
  LightBlock,
  Part,
  PartSetHeader,
  Proposal: Proposal$2,
  SignedHeader,
  get SignedMsgType() {
    return SignedMsgType;
  },
  SignedMsgTypeAmino,
  SignedMsgTypeSDKType,
  TxProof,
  Vote: Vote$2,
  blockIDFlagFromJSON,
  blockIDFlagToJSON,
  signedMsgTypeFromJSON,
  signedMsgTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
let CheckTxType;
(function(e) {
  e[e.NEW = 0] = "NEW", e[e.RECHECK = 1] = "RECHECK", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(CheckTxType || (CheckTxType = {}));
const CheckTxTypeSDKType = CheckTxType, CheckTxTypeAmino = CheckTxType;
function checkTxTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "NEW":
      return CheckTxType.NEW;
    case 1:
    case "RECHECK":
      return CheckTxType.RECHECK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CheckTxType.UNRECOGNIZED;
  }
}
function checkTxTypeToJSON(e) {
  switch (e) {
    case CheckTxType.NEW:
      return "NEW";
    case CheckTxType.RECHECK:
      return "RECHECK";
    case CheckTxType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ResponseOfferSnapshot_Result;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.ACCEPT = 1] = "ACCEPT", e[e.ABORT = 2] = "ABORT", e[e.REJECT = 3] = "REJECT", e[e.REJECT_FORMAT = 4] = "REJECT_FORMAT", e[e.REJECT_SENDER = 5] = "REJECT_SENDER", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ResponseOfferSnapshot_Result || (ResponseOfferSnapshot_Result = {}));
const ResponseOfferSnapshot_ResultSDKType = ResponseOfferSnapshot_Result, ResponseOfferSnapshot_ResultAmino = ResponseOfferSnapshot_Result;
function responseOfferSnapshot_ResultFromJSON(e) {
  switch (e) {
    case 0:
    case "UNKNOWN":
      return ResponseOfferSnapshot_Result.UNKNOWN;
    case 1:
    case "ACCEPT":
      return ResponseOfferSnapshot_Result.ACCEPT;
    case 2:
    case "ABORT":
      return ResponseOfferSnapshot_Result.ABORT;
    case 3:
    case "REJECT":
      return ResponseOfferSnapshot_Result.REJECT;
    case 4:
    case "REJECT_FORMAT":
      return ResponseOfferSnapshot_Result.REJECT_FORMAT;
    case 5:
    case "REJECT_SENDER":
      return ResponseOfferSnapshot_Result.REJECT_SENDER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseOfferSnapshot_Result.UNRECOGNIZED;
  }
}
function responseOfferSnapshot_ResultToJSON(e) {
  switch (e) {
    case ResponseOfferSnapshot_Result.UNKNOWN:
      return "UNKNOWN";
    case ResponseOfferSnapshot_Result.ACCEPT:
      return "ACCEPT";
    case ResponseOfferSnapshot_Result.ABORT:
      return "ABORT";
    case ResponseOfferSnapshot_Result.REJECT:
      return "REJECT";
    case ResponseOfferSnapshot_Result.REJECT_FORMAT:
      return "REJECT_FORMAT";
    case ResponseOfferSnapshot_Result.REJECT_SENDER:
      return "REJECT_SENDER";
    case ResponseOfferSnapshot_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ResponseApplySnapshotChunk_Result;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.ACCEPT = 1] = "ACCEPT", e[e.ABORT = 2] = "ABORT", e[e.RETRY = 3] = "RETRY", e[e.RETRY_SNAPSHOT = 4] = "RETRY_SNAPSHOT", e[e.REJECT_SNAPSHOT = 5] = "REJECT_SNAPSHOT", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ResponseApplySnapshotChunk_Result || (ResponseApplySnapshotChunk_Result = {}));
const ResponseApplySnapshotChunk_ResultSDKType = ResponseApplySnapshotChunk_Result, ResponseApplySnapshotChunk_ResultAmino = ResponseApplySnapshotChunk_Result;
function responseApplySnapshotChunk_ResultFromJSON(e) {
  switch (e) {
    case 0:
    case "UNKNOWN":
      return ResponseApplySnapshotChunk_Result.UNKNOWN;
    case 1:
    case "ACCEPT":
      return ResponseApplySnapshotChunk_Result.ACCEPT;
    case 2:
    case "ABORT":
      return ResponseApplySnapshotChunk_Result.ABORT;
    case 3:
    case "RETRY":
      return ResponseApplySnapshotChunk_Result.RETRY;
    case 4:
    case "RETRY_SNAPSHOT":
      return ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;
    case 5:
    case "REJECT_SNAPSHOT":
      return ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
  }
}
function responseApplySnapshotChunk_ResultToJSON(e) {
  switch (e) {
    case ResponseApplySnapshotChunk_Result.UNKNOWN:
      return "UNKNOWN";
    case ResponseApplySnapshotChunk_Result.ACCEPT:
      return "ACCEPT";
    case ResponseApplySnapshotChunk_Result.ABORT:
      return "ABORT";
    case ResponseApplySnapshotChunk_Result.RETRY:
      return "RETRY";
    case ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
      return "RETRY_SNAPSHOT";
    case ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
      return "REJECT_SNAPSHOT";
    case ResponseApplySnapshotChunk_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ResponseProcessProposal_ProposalStatus;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.ACCEPT = 1] = "ACCEPT", e[e.REJECT = 2] = "REJECT", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ResponseProcessProposal_ProposalStatus || (ResponseProcessProposal_ProposalStatus = {}));
const ResponseProcessProposal_ProposalStatusSDKType = ResponseProcessProposal_ProposalStatus, ResponseProcessProposal_ProposalStatusAmino = ResponseProcessProposal_ProposalStatus;
function responseProcessProposal_ProposalStatusFromJSON(e) {
  switch (e) {
    case 0:
    case "UNKNOWN":
      return ResponseProcessProposal_ProposalStatus.UNKNOWN;
    case 1:
    case "ACCEPT":
      return ResponseProcessProposal_ProposalStatus.ACCEPT;
    case 2:
    case "REJECT":
      return ResponseProcessProposal_ProposalStatus.REJECT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseProcessProposal_ProposalStatus.UNRECOGNIZED;
  }
}
function responseProcessProposal_ProposalStatusToJSON(e) {
  switch (e) {
    case ResponseProcessProposal_ProposalStatus.UNKNOWN:
      return "UNKNOWN";
    case ResponseProcessProposal_ProposalStatus.ACCEPT:
      return "ACCEPT";
    case ResponseProcessProposal_ProposalStatus.REJECT:
      return "REJECT";
    case ResponseProcessProposal_ProposalStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let MisbehaviorType;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.DUPLICATE_VOTE = 1] = "DUPLICATE_VOTE", e[e.LIGHT_CLIENT_ATTACK = 2] = "LIGHT_CLIENT_ATTACK", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(MisbehaviorType || (MisbehaviorType = {}));
const MisbehaviorTypeSDKType = MisbehaviorType, MisbehaviorTypeAmino = MisbehaviorType;
function misbehaviorTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "UNKNOWN":
      return MisbehaviorType.UNKNOWN;
    case 1:
    case "DUPLICATE_VOTE":
      return MisbehaviorType.DUPLICATE_VOTE;
    case 2:
    case "LIGHT_CLIENT_ATTACK":
      return MisbehaviorType.LIGHT_CLIENT_ATTACK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MisbehaviorType.UNRECOGNIZED;
  }
}
function misbehaviorTypeToJSON(e) {
  switch (e) {
    case MisbehaviorType.UNKNOWN:
      return "UNKNOWN";
    case MisbehaviorType.DUPLICATE_VOTE:
      return "DUPLICATE_VOTE";
    case MisbehaviorType.LIGHT_CLIENT_ATTACK:
      return "LIGHT_CLIENT_ATTACK";
    case MisbehaviorType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseRequest() {
  return {
    echo: void 0,
    flush: void 0,
    info: void 0,
    initChain: void 0,
    query: void 0,
    beginBlock: void 0,
    checkTx: void 0,
    deliverTx: void 0,
    endBlock: void 0,
    commit: void 0,
    listSnapshots: void 0,
    offerSnapshot: void 0,
    loadSnapshotChunk: void 0,
    applySnapshotChunk: void 0,
    prepareProposal: void 0,
    processProposal: void 0
  };
}
const Request = {
  typeUrl: "/tendermint.abci.Request",
  encode(e, n = minimal.Writer.create()) {
    return e.echo !== void 0 && RequestEcho.encode(e.echo, n.uint32(10).fork()).ldelim(), e.flush !== void 0 && RequestFlush.encode(e.flush, n.uint32(18).fork()).ldelim(), e.info !== void 0 && RequestInfo.encode(e.info, n.uint32(26).fork()).ldelim(), e.initChain !== void 0 && RequestInitChain.encode(e.initChain, n.uint32(42).fork()).ldelim(), e.query !== void 0 && RequestQuery.encode(e.query, n.uint32(50).fork()).ldelim(), e.beginBlock !== void 0 && RequestBeginBlock.encode(e.beginBlock, n.uint32(58).fork()).ldelim(), e.checkTx !== void 0 && RequestCheckTx.encode(e.checkTx, n.uint32(66).fork()).ldelim(), e.deliverTx !== void 0 && RequestDeliverTx.encode(e.deliverTx, n.uint32(74).fork()).ldelim(), e.endBlock !== void 0 && RequestEndBlock.encode(e.endBlock, n.uint32(82).fork()).ldelim(), e.commit !== void 0 && RequestCommit.encode(e.commit, n.uint32(90).fork()).ldelim(), e.listSnapshots !== void 0 && RequestListSnapshots.encode(e.listSnapshots, n.uint32(98).fork()).ldelim(), e.offerSnapshot !== void 0 && RequestOfferSnapshot.encode(e.offerSnapshot, n.uint32(106).fork()).ldelim(), e.loadSnapshotChunk !== void 0 && RequestLoadSnapshotChunk.encode(e.loadSnapshotChunk, n.uint32(114).fork()).ldelim(), e.applySnapshotChunk !== void 0 && RequestApplySnapshotChunk.encode(e.applySnapshotChunk, n.uint32(122).fork()).ldelim(), e.prepareProposal !== void 0 && RequestPrepareProposal.encode(e.prepareProposal, n.uint32(130).fork()).ldelim(), e.processProposal !== void 0 && RequestProcessProposal.encode(e.processProposal, n.uint32(138).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.echo = RequestEcho.decode(o, o.uint32());
          break;
        case 2:
          c.flush = RequestFlush.decode(o, o.uint32());
          break;
        case 3:
          c.info = RequestInfo.decode(o, o.uint32());
          break;
        case 5:
          c.initChain = RequestInitChain.decode(o, o.uint32());
          break;
        case 6:
          c.query = RequestQuery.decode(o, o.uint32());
          break;
        case 7:
          c.beginBlock = RequestBeginBlock.decode(o, o.uint32());
          break;
        case 8:
          c.checkTx = RequestCheckTx.decode(o, o.uint32());
          break;
        case 9:
          c.deliverTx = RequestDeliverTx.decode(o, o.uint32());
          break;
        case 10:
          c.endBlock = RequestEndBlock.decode(o, o.uint32());
          break;
        case 11:
          c.commit = RequestCommit.decode(o, o.uint32());
          break;
        case 12:
          c.listSnapshots = RequestListSnapshots.decode(o, o.uint32());
          break;
        case 13:
          c.offerSnapshot = RequestOfferSnapshot.decode(o, o.uint32());
          break;
        case 14:
          c.loadSnapshotChunk = RequestLoadSnapshotChunk.decode(o, o.uint32());
          break;
        case 15:
          c.applySnapshotChunk = RequestApplySnapshotChunk.decode(o, o.uint32());
          break;
        case 16:
          c.prepareProposal = RequestPrepareProposal.decode(o, o.uint32());
          break;
        case 17:
          c.processProposal = RequestProcessProposal.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseRequest();
    return n.echo = e.echo !== void 0 && e.echo !== null ? RequestEcho.fromPartial(e.echo) : void 0, n.flush = e.flush !== void 0 && e.flush !== null ? RequestFlush.fromPartial(e.flush) : void 0, n.info = e.info !== void 0 && e.info !== null ? RequestInfo.fromPartial(e.info) : void 0, n.initChain = e.initChain !== void 0 && e.initChain !== null ? RequestInitChain.fromPartial(e.initChain) : void 0, n.query = e.query !== void 0 && e.query !== null ? RequestQuery.fromPartial(e.query) : void 0, n.beginBlock = e.beginBlock !== void 0 && e.beginBlock !== null ? RequestBeginBlock.fromPartial(e.beginBlock) : void 0, n.checkTx = e.checkTx !== void 0 && e.checkTx !== null ? RequestCheckTx.fromPartial(e.checkTx) : void 0, n.deliverTx = e.deliverTx !== void 0 && e.deliverTx !== null ? RequestDeliverTx.fromPartial(e.deliverTx) : void 0, n.endBlock = e.endBlock !== void 0 && e.endBlock !== null ? RequestEndBlock.fromPartial(e.endBlock) : void 0, n.commit = e.commit !== void 0 && e.commit !== null ? RequestCommit.fromPartial(e.commit) : void 0, n.listSnapshots = e.listSnapshots !== void 0 && e.listSnapshots !== null ? RequestListSnapshots.fromPartial(e.listSnapshots) : void 0, n.offerSnapshot = e.offerSnapshot !== void 0 && e.offerSnapshot !== null ? RequestOfferSnapshot.fromPartial(e.offerSnapshot) : void 0, n.loadSnapshotChunk = e.loadSnapshotChunk !== void 0 && e.loadSnapshotChunk !== null ? RequestLoadSnapshotChunk.fromPartial(e.loadSnapshotChunk) : void 0, n.applySnapshotChunk = e.applySnapshotChunk !== void 0 && e.applySnapshotChunk !== null ? RequestApplySnapshotChunk.fromPartial(e.applySnapshotChunk) : void 0, n.prepareProposal = e.prepareProposal !== void 0 && e.prepareProposal !== null ? RequestPrepareProposal.fromPartial(e.prepareProposal) : void 0, n.processProposal = e.processProposal !== void 0 && e.processProposal !== null ? RequestProcessProposal.fromPartial(e.processProposal) : void 0, n;
  },
  fromAmino(e) {
    return {
      echo: e != null && e.echo ? RequestEcho.fromAmino(e.echo) : void 0,
      flush: e != null && e.flush ? RequestFlush.fromAmino(e.flush) : void 0,
      info: e != null && e.info ? RequestInfo.fromAmino(e.info) : void 0,
      initChain: e != null && e.init_chain ? RequestInitChain.fromAmino(e.init_chain) : void 0,
      query: e != null && e.query ? RequestQuery.fromAmino(e.query) : void 0,
      beginBlock: e != null && e.begin_block ? RequestBeginBlock.fromAmino(e.begin_block) : void 0,
      checkTx: e != null && e.check_tx ? RequestCheckTx.fromAmino(e.check_tx) : void 0,
      deliverTx: e != null && e.deliver_tx ? RequestDeliverTx.fromAmino(e.deliver_tx) : void 0,
      endBlock: e != null && e.end_block ? RequestEndBlock.fromAmino(e.end_block) : void 0,
      commit: e != null && e.commit ? RequestCommit.fromAmino(e.commit) : void 0,
      listSnapshots: e != null && e.list_snapshots ? RequestListSnapshots.fromAmino(e.list_snapshots) : void 0,
      offerSnapshot: e != null && e.offer_snapshot ? RequestOfferSnapshot.fromAmino(e.offer_snapshot) : void 0,
      loadSnapshotChunk: e != null && e.load_snapshot_chunk ? RequestLoadSnapshotChunk.fromAmino(e.load_snapshot_chunk) : void 0,
      applySnapshotChunk: e != null && e.apply_snapshot_chunk ? RequestApplySnapshotChunk.fromAmino(e.apply_snapshot_chunk) : void 0,
      prepareProposal: e != null && e.prepare_proposal ? RequestPrepareProposal.fromAmino(e.prepare_proposal) : void 0,
      processProposal: e != null && e.process_proposal ? RequestProcessProposal.fromAmino(e.process_proposal) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.echo = e.echo ? RequestEcho.toAmino(e.echo) : void 0, n.flush = e.flush ? RequestFlush.toAmino(e.flush) : void 0, n.info = e.info ? RequestInfo.toAmino(e.info) : void 0, n.init_chain = e.initChain ? RequestInitChain.toAmino(e.initChain) : void 0, n.query = e.query ? RequestQuery.toAmino(e.query) : void 0, n.begin_block = e.beginBlock ? RequestBeginBlock.toAmino(e.beginBlock) : void 0, n.check_tx = e.checkTx ? RequestCheckTx.toAmino(e.checkTx) : void 0, n.deliver_tx = e.deliverTx ? RequestDeliverTx.toAmino(e.deliverTx) : void 0, n.end_block = e.endBlock ? RequestEndBlock.toAmino(e.endBlock) : void 0, n.commit = e.commit ? RequestCommit.toAmino(e.commit) : void 0, n.list_snapshots = e.listSnapshots ? RequestListSnapshots.toAmino(e.listSnapshots) : void 0, n.offer_snapshot = e.offerSnapshot ? RequestOfferSnapshot.toAmino(e.offerSnapshot) : void 0, n.load_snapshot_chunk = e.loadSnapshotChunk ? RequestLoadSnapshotChunk.toAmino(e.loadSnapshotChunk) : void 0, n.apply_snapshot_chunk = e.applySnapshotChunk ? RequestApplySnapshotChunk.toAmino(e.applySnapshotChunk) : void 0, n.prepare_proposal = e.prepareProposal ? RequestPrepareProposal.toAmino(e.prepareProposal) : void 0, n.process_proposal = e.processProposal ? RequestProcessProposal.toAmino(e.processProposal) : void 0, n;
  },
  fromAminoMsg(e) {
    return Request.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Request.decode(e.value);
  },
  toProto(e) {
    return Request.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.Request",
      value: Request.encode(e).finish()
    };
  }
};
function createBaseRequestEcho() {
  return {
    message: ""
  };
}
const RequestEcho = {
  typeUrl: "/tendermint.abci.RequestEcho",
  encode(e, n = minimal.Writer.create()) {
    return e.message !== "" && n.uint32(10).string(e.message), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestEcho();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.message = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRequestEcho();
    return o.message = (n = e.message) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      message: e.message
    };
  },
  toAmino(e) {
    const n = {};
    return n.message = e.message, n;
  },
  fromAminoMsg(e) {
    return RequestEcho.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestEcho.decode(e.value);
  },
  toProto(e) {
    return RequestEcho.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestEcho",
      value: RequestEcho.encode(e).finish()
    };
  }
};
function createBaseRequestFlush() {
  return {};
}
const RequestFlush = {
  typeUrl: "/tendermint.abci.RequestFlush",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestFlush();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseRequestFlush();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return RequestFlush.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestFlush.decode(e.value);
  },
  toProto(e) {
    return RequestFlush.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestFlush",
      value: RequestFlush.encode(e).finish()
    };
  }
};
function createBaseRequestInfo() {
  return {
    version: "",
    blockVersion: Long$2.UZERO,
    p2pVersion: Long$2.UZERO,
    abciVersion: ""
  };
}
const RequestInfo = {
  typeUrl: "/tendermint.abci.RequestInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.version !== "" && n.uint32(10).string(e.version), e.blockVersion.isZero() || n.uint32(16).uint64(e.blockVersion), e.p2pVersion.isZero() || n.uint32(24).uint64(e.p2pVersion), e.abciVersion !== "" && n.uint32(34).string(e.abciVersion), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.version = o.string();
          break;
        case 2:
          c.blockVersion = o.uint64();
          break;
        case 3:
          c.p2pVersion = o.uint64();
          break;
        case 4:
          c.abciVersion = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseRequestInfo();
    return u.version = (n = e.version) !== null && n !== void 0 ? n : "", u.blockVersion = e.blockVersion !== void 0 && e.blockVersion !== null ? Long$2.fromValue(e.blockVersion) : Long$2.UZERO, u.p2pVersion = e.p2pVersion !== void 0 && e.p2pVersion !== null ? Long$2.fromValue(e.p2pVersion) : Long$2.UZERO, u.abciVersion = (o = e.abciVersion) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      version: e.version,
      blockVersion: Long$2.fromString(e.block_version),
      p2pVersion: Long$2.fromString(e.p2p_version),
      abciVersion: e.abci_version
    };
  },
  toAmino(e) {
    const n = {};
    return n.version = e.version, n.block_version = e.blockVersion ? e.blockVersion.toString() : void 0, n.p2p_version = e.p2pVersion ? e.p2pVersion.toString() : void 0, n.abci_version = e.abciVersion, n;
  },
  fromAminoMsg(e) {
    return RequestInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestInfo.decode(e.value);
  },
  toProto(e) {
    return RequestInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestInfo",
      value: RequestInfo.encode(e).finish()
    };
  }
};
function createBaseRequestInitChain() {
  return {
    time: void 0,
    chainId: "",
    consensusParams: void 0,
    validators: [],
    appStateBytes: new Uint8Array(),
    initialHeight: Long$2.ZERO
  };
}
const RequestInitChain = {
  typeUrl: "/tendermint.abci.RequestInitChain",
  encode(e, n = minimal.Writer.create()) {
    e.time !== void 0 && Timestamp.encode(toTimestamp(e.time), n.uint32(10).fork()).ldelim(), e.chainId !== "" && n.uint32(18).string(e.chainId), e.consensusParams !== void 0 && ConsensusParams.encode(e.consensusParams, n.uint32(26).fork()).ldelim();
    for (const o of e.validators)
      ValidatorUpdate.encode(o, n.uint32(34).fork()).ldelim();
    return e.appStateBytes.length !== 0 && n.uint32(42).bytes(e.appStateBytes), e.initialHeight.isZero() || n.uint32(48).int64(e.initialHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestInitChain();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.time = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 2:
          c.chainId = o.string();
          break;
        case 3:
          c.consensusParams = ConsensusParams.decode(o, o.uint32());
          break;
        case 4:
          c.validators.push(ValidatorUpdate.decode(o, o.uint32()));
          break;
        case 5:
          c.appStateBytes = o.bytes();
          break;
        case 6:
          c.initialHeight = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseRequestInitChain();
    return d.time = (n = e.time) !== null && n !== void 0 ? n : void 0, d.chainId = (o = e.chainId) !== null && o !== void 0 ? o : "", d.consensusParams = e.consensusParams !== void 0 && e.consensusParams !== null ? ConsensusParams.fromPartial(e.consensusParams) : void 0, d.validators = ((u = e.validators) === null || u === void 0 ? void 0 : u.map((m) => ValidatorUpdate.fromPartial(m))) || [], d.appStateBytes = (c = e.appStateBytes) !== null && c !== void 0 ? c : new Uint8Array(), d.initialHeight = e.initialHeight !== void 0 && e.initialHeight !== null ? Long$2.fromValue(e.initialHeight) : Long$2.ZERO, d;
  },
  fromAmino(e) {
    return {
      time: e != null && e.time ? Timestamp.fromAmino(e.time) : void 0,
      chainId: e.chain_id,
      consensusParams: e != null && e.consensus_params ? ConsensusParams.fromAmino(e.consensus_params) : void 0,
      validators: Array.isArray(e == null ? void 0 : e.validators) ? e.validators.map((n) => ValidatorUpdate.fromAmino(n)) : [],
      appStateBytes: e.app_state_bytes,
      initialHeight: Long$2.fromString(e.initial_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.time = e.time ? Timestamp.toAmino(e.time) : void 0, n.chain_id = e.chainId, n.consensus_params = e.consensusParams ? ConsensusParams.toAmino(e.consensusParams) : void 0, e.validators ? n.validators = e.validators.map((o) => o ? ValidatorUpdate.toAmino(o) : void 0) : n.validators = [], n.app_state_bytes = e.appStateBytes, n.initial_height = e.initialHeight ? e.initialHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return RequestInitChain.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestInitChain.decode(e.value);
  },
  toProto(e) {
    return RequestInitChain.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestInitChain",
      value: RequestInitChain.encode(e).finish()
    };
  }
};
function createBaseRequestQuery() {
  return {
    data: new Uint8Array(),
    path: "",
    height: Long$2.ZERO,
    prove: !1
  };
}
const RequestQuery = {
  typeUrl: "/tendermint.abci.RequestQuery",
  encode(e, n = minimal.Writer.create()) {
    return e.data.length !== 0 && n.uint32(10).bytes(e.data), e.path !== "" && n.uint32(18).string(e.path), e.height.isZero() || n.uint32(24).int64(e.height), e.prove === !0 && n.uint32(32).bool(e.prove), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestQuery();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data = o.bytes();
          break;
        case 2:
          c.path = o.string();
          break;
        case 3:
          c.height = o.int64();
          break;
        case 4:
          c.prove = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRequestQuery();
    return c.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), c.path = (o = e.path) !== null && o !== void 0 ? o : "", c.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, c.prove = (u = e.prove) !== null && u !== void 0 ? u : !1, c;
  },
  fromAmino(e) {
    return {
      data: e.data,
      path: e.path,
      height: Long$2.fromString(e.height),
      prove: e.prove
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data, n.path = e.path, n.height = e.height ? e.height.toString() : void 0, n.prove = e.prove, n;
  },
  fromAminoMsg(e) {
    return RequestQuery.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestQuery.decode(e.value);
  },
  toProto(e) {
    return RequestQuery.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestQuery",
      value: RequestQuery.encode(e).finish()
    };
  }
};
function createBaseRequestBeginBlock() {
  return {
    hash: new Uint8Array(),
    header: void 0,
    lastCommitInfo: void 0,
    byzantineValidators: []
  };
}
const RequestBeginBlock = {
  typeUrl: "/tendermint.abci.RequestBeginBlock",
  encode(e, n = minimal.Writer.create()) {
    e.hash.length !== 0 && n.uint32(10).bytes(e.hash), e.header !== void 0 && Header$3.encode(e.header, n.uint32(18).fork()).ldelim(), e.lastCommitInfo !== void 0 && CommitInfo.encode(e.lastCommitInfo, n.uint32(26).fork()).ldelim();
    for (const o of e.byzantineValidators)
      Misbehavior.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestBeginBlock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.bytes();
          break;
        case 2:
          c.header = Header$3.decode(o, o.uint32());
          break;
        case 3:
          c.lastCommitInfo = CommitInfo.decode(o, o.uint32());
          break;
        case 4:
          c.byzantineValidators.push(Misbehavior.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseRequestBeginBlock();
    return u.hash = (n = e.hash) !== null && n !== void 0 ? n : new Uint8Array(), u.header = e.header !== void 0 && e.header !== null ? Header$3.fromPartial(e.header) : void 0, u.lastCommitInfo = e.lastCommitInfo !== void 0 && e.lastCommitInfo !== null ? CommitInfo.fromPartial(e.lastCommitInfo) : void 0, u.byzantineValidators = ((o = e.byzantineValidators) === null || o === void 0 ? void 0 : o.map((c) => Misbehavior.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      hash: e.hash,
      header: e != null && e.header ? Header$3.fromAmino(e.header) : void 0,
      lastCommitInfo: e != null && e.last_commit_info ? CommitInfo.fromAmino(e.last_commit_info) : void 0,
      byzantineValidators: Array.isArray(e == null ? void 0 : e.byzantine_validators) ? e.byzantine_validators.map((n) => Misbehavior.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n.header = e.header ? Header$3.toAmino(e.header) : void 0, n.last_commit_info = e.lastCommitInfo ? CommitInfo.toAmino(e.lastCommitInfo) : void 0, e.byzantineValidators ? n.byzantine_validators = e.byzantineValidators.map((o) => o ? Misbehavior.toAmino(o) : void 0) : n.byzantine_validators = [], n;
  },
  fromAminoMsg(e) {
    return RequestBeginBlock.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestBeginBlock.decode(e.value);
  },
  toProto(e) {
    return RequestBeginBlock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestBeginBlock",
      value: RequestBeginBlock.encode(e).finish()
    };
  }
};
function createBaseRequestCheckTx() {
  return {
    tx: new Uint8Array(),
    type: 0
  };
}
const RequestCheckTx = {
  typeUrl: "/tendermint.abci.RequestCheckTx",
  encode(e, n = minimal.Writer.create()) {
    return e.tx.length !== 0 && n.uint32(10).bytes(e.tx), e.type !== 0 && n.uint32(16).int32(e.type), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestCheckTx();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tx = o.bytes();
          break;
        case 2:
          c.type = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseRequestCheckTx();
    return u.tx = (n = e.tx) !== null && n !== void 0 ? n : new Uint8Array(), u.type = (o = e.type) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      tx: e.tx,
      type: isSet(e.type) ? checkTxTypeFromJSON(e.type) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.tx = e.tx, n.type = e.type, n;
  },
  fromAminoMsg(e) {
    return RequestCheckTx.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestCheckTx.decode(e.value);
  },
  toProto(e) {
    return RequestCheckTx.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestCheckTx",
      value: RequestCheckTx.encode(e).finish()
    };
  }
};
function createBaseRequestDeliverTx() {
  return {
    tx: new Uint8Array()
  };
}
const RequestDeliverTx = {
  typeUrl: "/tendermint.abci.RequestDeliverTx",
  encode(e, n = minimal.Writer.create()) {
    return e.tx.length !== 0 && n.uint32(10).bytes(e.tx), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestDeliverTx();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tx = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRequestDeliverTx();
    return o.tx = (n = e.tx) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      tx: e.tx
    };
  },
  toAmino(e) {
    const n = {};
    return n.tx = e.tx, n;
  },
  fromAminoMsg(e) {
    return RequestDeliverTx.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestDeliverTx.decode(e.value);
  },
  toProto(e) {
    return RequestDeliverTx.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestDeliverTx",
      value: RequestDeliverTx.encode(e).finish()
    };
  }
};
function createBaseRequestEndBlock() {
  return {
    height: Long$2.ZERO
  };
}
const RequestEndBlock = {
  typeUrl: "/tendermint.abci.RequestEndBlock",
  encode(e, n = minimal.Writer.create()) {
    return e.height.isZero() || n.uint32(8).int64(e.height), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestEndBlock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseRequestEndBlock();
    return n.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      height: Long$2.fromString(e.height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? e.height.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return RequestEndBlock.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestEndBlock.decode(e.value);
  },
  toProto(e) {
    return RequestEndBlock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestEndBlock",
      value: RequestEndBlock.encode(e).finish()
    };
  }
};
function createBaseRequestCommit() {
  return {};
}
const RequestCommit = {
  typeUrl: "/tendermint.abci.RequestCommit",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestCommit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseRequestCommit();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return RequestCommit.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestCommit.decode(e.value);
  },
  toProto(e) {
    return RequestCommit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestCommit",
      value: RequestCommit.encode(e).finish()
    };
  }
};
function createBaseRequestListSnapshots() {
  return {};
}
const RequestListSnapshots = {
  typeUrl: "/tendermint.abci.RequestListSnapshots",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestListSnapshots();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseRequestListSnapshots();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return RequestListSnapshots.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestListSnapshots.decode(e.value);
  },
  toProto(e) {
    return RequestListSnapshots.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestListSnapshots",
      value: RequestListSnapshots.encode(e).finish()
    };
  }
};
function createBaseRequestOfferSnapshot() {
  return {
    snapshot: void 0,
    appHash: new Uint8Array()
  };
}
const RequestOfferSnapshot = {
  typeUrl: "/tendermint.abci.RequestOfferSnapshot",
  encode(e, n = minimal.Writer.create()) {
    return e.snapshot !== void 0 && Snapshot.encode(e.snapshot, n.uint32(10).fork()).ldelim(), e.appHash.length !== 0 && n.uint32(18).bytes(e.appHash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestOfferSnapshot();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.snapshot = Snapshot.decode(o, o.uint32());
          break;
        case 2:
          c.appHash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRequestOfferSnapshot();
    return o.snapshot = e.snapshot !== void 0 && e.snapshot !== null ? Snapshot.fromPartial(e.snapshot) : void 0, o.appHash = (n = e.appHash) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      snapshot: e != null && e.snapshot ? Snapshot.fromAmino(e.snapshot) : void 0,
      appHash: e.app_hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.snapshot = e.snapshot ? Snapshot.toAmino(e.snapshot) : void 0, n.app_hash = e.appHash, n;
  },
  fromAminoMsg(e) {
    return RequestOfferSnapshot.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestOfferSnapshot.decode(e.value);
  },
  toProto(e) {
    return RequestOfferSnapshot.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestOfferSnapshot",
      value: RequestOfferSnapshot.encode(e).finish()
    };
  }
};
function createBaseRequestLoadSnapshotChunk() {
  return {
    height: Long$2.UZERO,
    format: 0,
    chunk: 0
  };
}
const RequestLoadSnapshotChunk = {
  typeUrl: "/tendermint.abci.RequestLoadSnapshotChunk",
  encode(e, n = minimal.Writer.create()) {
    return e.height.isZero() || n.uint32(8).uint64(e.height), e.format !== 0 && n.uint32(16).uint32(e.format), e.chunk !== 0 && n.uint32(24).uint32(e.chunk), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestLoadSnapshotChunk();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = o.uint64();
          break;
        case 2:
          c.format = o.uint32();
          break;
        case 3:
          c.chunk = o.uint32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseRequestLoadSnapshotChunk();
    return u.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.UZERO, u.format = (n = e.format) !== null && n !== void 0 ? n : 0, u.chunk = (o = e.chunk) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      height: Long$2.fromString(e.height),
      format: e.format,
      chunk: e.chunk
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? e.height.toString() : void 0, n.format = e.format, n.chunk = e.chunk, n;
  },
  fromAminoMsg(e) {
    return RequestLoadSnapshotChunk.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestLoadSnapshotChunk.decode(e.value);
  },
  toProto(e) {
    return RequestLoadSnapshotChunk.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestLoadSnapshotChunk",
      value: RequestLoadSnapshotChunk.encode(e).finish()
    };
  }
};
function createBaseRequestApplySnapshotChunk() {
  return {
    index: 0,
    chunk: new Uint8Array(),
    sender: ""
  };
}
const RequestApplySnapshotChunk = {
  typeUrl: "/tendermint.abci.RequestApplySnapshotChunk",
  encode(e, n = minimal.Writer.create()) {
    return e.index !== 0 && n.uint32(8).uint32(e.index), e.chunk.length !== 0 && n.uint32(18).bytes(e.chunk), e.sender !== "" && n.uint32(26).string(e.sender), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestApplySnapshotChunk();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.index = o.uint32();
          break;
        case 2:
          c.chunk = o.bytes();
          break;
        case 3:
          c.sender = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRequestApplySnapshotChunk();
    return c.index = (n = e.index) !== null && n !== void 0 ? n : 0, c.chunk = (o = e.chunk) !== null && o !== void 0 ? o : new Uint8Array(), c.sender = (u = e.sender) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      index: e.index,
      chunk: e.chunk,
      sender: e.sender
    };
  },
  toAmino(e) {
    const n = {};
    return n.index = e.index, n.chunk = e.chunk, n.sender = e.sender, n;
  },
  fromAminoMsg(e) {
    return RequestApplySnapshotChunk.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestApplySnapshotChunk.decode(e.value);
  },
  toProto(e) {
    return RequestApplySnapshotChunk.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestApplySnapshotChunk",
      value: RequestApplySnapshotChunk.encode(e).finish()
    };
  }
};
function createBaseRequestPrepareProposal() {
  return {
    maxTxBytes: Long$2.ZERO,
    txs: [],
    localLastCommit: void 0,
    misbehavior: [],
    height: Long$2.ZERO,
    time: void 0,
    nextValidatorsHash: new Uint8Array(),
    proposerAddress: new Uint8Array()
  };
}
const RequestPrepareProposal = {
  typeUrl: "/tendermint.abci.RequestPrepareProposal",
  encode(e, n = minimal.Writer.create()) {
    e.maxTxBytes.isZero() || n.uint32(8).int64(e.maxTxBytes);
    for (const o of e.txs)
      n.uint32(18).bytes(o);
    e.localLastCommit !== void 0 && ExtendedCommitInfo.encode(e.localLastCommit, n.uint32(26).fork()).ldelim();
    for (const o of e.misbehavior)
      Misbehavior.encode(o, n.uint32(34).fork()).ldelim();
    return e.height.isZero() || n.uint32(40).int64(e.height), e.time !== void 0 && Timestamp.encode(toTimestamp(e.time), n.uint32(50).fork()).ldelim(), e.nextValidatorsHash.length !== 0 && n.uint32(58).bytes(e.nextValidatorsHash), e.proposerAddress.length !== 0 && n.uint32(66).bytes(e.proposerAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestPrepareProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.maxTxBytes = o.int64();
          break;
        case 2:
          c.txs.push(o.bytes());
          break;
        case 3:
          c.localLastCommit = ExtendedCommitInfo.decode(o, o.uint32());
          break;
        case 4:
          c.misbehavior.push(Misbehavior.decode(o, o.uint32()));
          break;
        case 5:
          c.height = o.int64();
          break;
        case 6:
          c.time = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 7:
          c.nextValidatorsHash = o.bytes();
          break;
        case 8:
          c.proposerAddress = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseRequestPrepareProposal();
    return m.maxTxBytes = e.maxTxBytes !== void 0 && e.maxTxBytes !== null ? Long$2.fromValue(e.maxTxBytes) : Long$2.ZERO, m.txs = ((n = e.txs) === null || n === void 0 ? void 0 : n.map((v) => v)) || [], m.localLastCommit = e.localLastCommit !== void 0 && e.localLastCommit !== null ? ExtendedCommitInfo.fromPartial(e.localLastCommit) : void 0, m.misbehavior = ((o = e.misbehavior) === null || o === void 0 ? void 0 : o.map((v) => Misbehavior.fromPartial(v))) || [], m.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, m.time = (u = e.time) !== null && u !== void 0 ? u : void 0, m.nextValidatorsHash = (c = e.nextValidatorsHash) !== null && c !== void 0 ? c : new Uint8Array(), m.proposerAddress = (d = e.proposerAddress) !== null && d !== void 0 ? d : new Uint8Array(), m;
  },
  fromAmino(e) {
    return {
      maxTxBytes: Long$2.fromString(e.max_tx_bytes),
      txs: Array.isArray(e == null ? void 0 : e.txs) ? e.txs.map((n) => n) : [],
      localLastCommit: e != null && e.local_last_commit ? ExtendedCommitInfo.fromAmino(e.local_last_commit) : void 0,
      misbehavior: Array.isArray(e == null ? void 0 : e.misbehavior) ? e.misbehavior.map((n) => Misbehavior.fromAmino(n)) : [],
      height: Long$2.fromString(e.height),
      time: e != null && e.time ? Timestamp.fromAmino(e.time) : void 0,
      nextValidatorsHash: e.next_validators_hash,
      proposerAddress: e.proposer_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.max_tx_bytes = e.maxTxBytes ? e.maxTxBytes.toString() : void 0, e.txs ? n.txs = e.txs.map((o) => o) : n.txs = [], n.local_last_commit = e.localLastCommit ? ExtendedCommitInfo.toAmino(e.localLastCommit) : void 0, e.misbehavior ? n.misbehavior = e.misbehavior.map((o) => o ? Misbehavior.toAmino(o) : void 0) : n.misbehavior = [], n.height = e.height ? e.height.toString() : void 0, n.time = e.time ? Timestamp.toAmino(e.time) : void 0, n.next_validators_hash = e.nextValidatorsHash, n.proposer_address = e.proposerAddress, n;
  },
  fromAminoMsg(e) {
    return RequestPrepareProposal.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestPrepareProposal.decode(e.value);
  },
  toProto(e) {
    return RequestPrepareProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestPrepareProposal",
      value: RequestPrepareProposal.encode(e).finish()
    };
  }
};
function createBaseRequestProcessProposal() {
  return {
    txs: [],
    proposedLastCommit: void 0,
    misbehavior: [],
    hash: new Uint8Array(),
    height: Long$2.ZERO,
    time: void 0,
    nextValidatorsHash: new Uint8Array(),
    proposerAddress: new Uint8Array()
  };
}
const RequestProcessProposal = {
  typeUrl: "/tendermint.abci.RequestProcessProposal",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.txs)
      n.uint32(10).bytes(o);
    e.proposedLastCommit !== void 0 && CommitInfo.encode(e.proposedLastCommit, n.uint32(18).fork()).ldelim();
    for (const o of e.misbehavior)
      Misbehavior.encode(o, n.uint32(26).fork()).ldelim();
    return e.hash.length !== 0 && n.uint32(34).bytes(e.hash), e.height.isZero() || n.uint32(40).int64(e.height), e.time !== void 0 && Timestamp.encode(toTimestamp(e.time), n.uint32(50).fork()).ldelim(), e.nextValidatorsHash.length !== 0 && n.uint32(58).bytes(e.nextValidatorsHash), e.proposerAddress.length !== 0 && n.uint32(66).bytes(e.proposerAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRequestProcessProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.txs.push(o.bytes());
          break;
        case 2:
          c.proposedLastCommit = CommitInfo.decode(o, o.uint32());
          break;
        case 3:
          c.misbehavior.push(Misbehavior.decode(o, o.uint32()));
          break;
        case 4:
          c.hash = o.bytes();
          break;
        case 5:
          c.height = o.int64();
          break;
        case 6:
          c.time = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 7:
          c.nextValidatorsHash = o.bytes();
          break;
        case 8:
          c.proposerAddress = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseRequestProcessProposal();
    return v.txs = ((n = e.txs) === null || n === void 0 ? void 0 : n.map((S) => S)) || [], v.proposedLastCommit = e.proposedLastCommit !== void 0 && e.proposedLastCommit !== null ? CommitInfo.fromPartial(e.proposedLastCommit) : void 0, v.misbehavior = ((o = e.misbehavior) === null || o === void 0 ? void 0 : o.map((S) => Misbehavior.fromPartial(S))) || [], v.hash = (u = e.hash) !== null && u !== void 0 ? u : new Uint8Array(), v.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, v.time = (c = e.time) !== null && c !== void 0 ? c : void 0, v.nextValidatorsHash = (d = e.nextValidatorsHash) !== null && d !== void 0 ? d : new Uint8Array(), v.proposerAddress = (m = e.proposerAddress) !== null && m !== void 0 ? m : new Uint8Array(), v;
  },
  fromAmino(e) {
    return {
      txs: Array.isArray(e == null ? void 0 : e.txs) ? e.txs.map((n) => n) : [],
      proposedLastCommit: e != null && e.proposed_last_commit ? CommitInfo.fromAmino(e.proposed_last_commit) : void 0,
      misbehavior: Array.isArray(e == null ? void 0 : e.misbehavior) ? e.misbehavior.map((n) => Misbehavior.fromAmino(n)) : [],
      hash: e.hash,
      height: Long$2.fromString(e.height),
      time: e != null && e.time ? Timestamp.fromAmino(e.time) : void 0,
      nextValidatorsHash: e.next_validators_hash,
      proposerAddress: e.proposer_address
    };
  },
  toAmino(e) {
    const n = {};
    return e.txs ? n.txs = e.txs.map((o) => o) : n.txs = [], n.proposed_last_commit = e.proposedLastCommit ? CommitInfo.toAmino(e.proposedLastCommit) : void 0, e.misbehavior ? n.misbehavior = e.misbehavior.map((o) => o ? Misbehavior.toAmino(o) : void 0) : n.misbehavior = [], n.hash = e.hash, n.height = e.height ? e.height.toString() : void 0, n.time = e.time ? Timestamp.toAmino(e.time) : void 0, n.next_validators_hash = e.nextValidatorsHash, n.proposer_address = e.proposerAddress, n;
  },
  fromAminoMsg(e) {
    return RequestProcessProposal.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return RequestProcessProposal.decode(e.value);
  },
  toProto(e) {
    return RequestProcessProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.RequestProcessProposal",
      value: RequestProcessProposal.encode(e).finish()
    };
  }
};
function createBaseResponse() {
  return {
    exception: void 0,
    echo: void 0,
    flush: void 0,
    info: void 0,
    initChain: void 0,
    query: void 0,
    beginBlock: void 0,
    checkTx: void 0,
    deliverTx: void 0,
    endBlock: void 0,
    commit: void 0,
    listSnapshots: void 0,
    offerSnapshot: void 0,
    loadSnapshotChunk: void 0,
    applySnapshotChunk: void 0,
    prepareProposal: void 0,
    processProposal: void 0
  };
}
const Response = {
  typeUrl: "/tendermint.abci.Response",
  encode(e, n = minimal.Writer.create()) {
    return e.exception !== void 0 && ResponseException.encode(e.exception, n.uint32(10).fork()).ldelim(), e.echo !== void 0 && ResponseEcho.encode(e.echo, n.uint32(18).fork()).ldelim(), e.flush !== void 0 && ResponseFlush.encode(e.flush, n.uint32(26).fork()).ldelim(), e.info !== void 0 && ResponseInfo.encode(e.info, n.uint32(34).fork()).ldelim(), e.initChain !== void 0 && ResponseInitChain.encode(e.initChain, n.uint32(50).fork()).ldelim(), e.query !== void 0 && ResponseQuery.encode(e.query, n.uint32(58).fork()).ldelim(), e.beginBlock !== void 0 && ResponseBeginBlock.encode(e.beginBlock, n.uint32(66).fork()).ldelim(), e.checkTx !== void 0 && ResponseCheckTx.encode(e.checkTx, n.uint32(74).fork()).ldelim(), e.deliverTx !== void 0 && ResponseDeliverTx.encode(e.deliverTx, n.uint32(82).fork()).ldelim(), e.endBlock !== void 0 && ResponseEndBlock.encode(e.endBlock, n.uint32(90).fork()).ldelim(), e.commit !== void 0 && ResponseCommit.encode(e.commit, n.uint32(98).fork()).ldelim(), e.listSnapshots !== void 0 && ResponseListSnapshots.encode(e.listSnapshots, n.uint32(106).fork()).ldelim(), e.offerSnapshot !== void 0 && ResponseOfferSnapshot.encode(e.offerSnapshot, n.uint32(114).fork()).ldelim(), e.loadSnapshotChunk !== void 0 && ResponseLoadSnapshotChunk.encode(e.loadSnapshotChunk, n.uint32(122).fork()).ldelim(), e.applySnapshotChunk !== void 0 && ResponseApplySnapshotChunk.encode(e.applySnapshotChunk, n.uint32(130).fork()).ldelim(), e.prepareProposal !== void 0 && ResponsePrepareProposal.encode(e.prepareProposal, n.uint32(138).fork()).ldelim(), e.processProposal !== void 0 && ResponseProcessProposal.encode(e.processProposal, n.uint32(146).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.exception = ResponseException.decode(o, o.uint32());
          break;
        case 2:
          c.echo = ResponseEcho.decode(o, o.uint32());
          break;
        case 3:
          c.flush = ResponseFlush.decode(o, o.uint32());
          break;
        case 4:
          c.info = ResponseInfo.decode(o, o.uint32());
          break;
        case 6:
          c.initChain = ResponseInitChain.decode(o, o.uint32());
          break;
        case 7:
          c.query = ResponseQuery.decode(o, o.uint32());
          break;
        case 8:
          c.beginBlock = ResponseBeginBlock.decode(o, o.uint32());
          break;
        case 9:
          c.checkTx = ResponseCheckTx.decode(o, o.uint32());
          break;
        case 10:
          c.deliverTx = ResponseDeliverTx.decode(o, o.uint32());
          break;
        case 11:
          c.endBlock = ResponseEndBlock.decode(o, o.uint32());
          break;
        case 12:
          c.commit = ResponseCommit.decode(o, o.uint32());
          break;
        case 13:
          c.listSnapshots = ResponseListSnapshots.decode(o, o.uint32());
          break;
        case 14:
          c.offerSnapshot = ResponseOfferSnapshot.decode(o, o.uint32());
          break;
        case 15:
          c.loadSnapshotChunk = ResponseLoadSnapshotChunk.decode(o, o.uint32());
          break;
        case 16:
          c.applySnapshotChunk = ResponseApplySnapshotChunk.decode(o, o.uint32());
          break;
        case 17:
          c.prepareProposal = ResponsePrepareProposal.decode(o, o.uint32());
          break;
        case 18:
          c.processProposal = ResponseProcessProposal.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseResponse();
    return n.exception = e.exception !== void 0 && e.exception !== null ? ResponseException.fromPartial(e.exception) : void 0, n.echo = e.echo !== void 0 && e.echo !== null ? ResponseEcho.fromPartial(e.echo) : void 0, n.flush = e.flush !== void 0 && e.flush !== null ? ResponseFlush.fromPartial(e.flush) : void 0, n.info = e.info !== void 0 && e.info !== null ? ResponseInfo.fromPartial(e.info) : void 0, n.initChain = e.initChain !== void 0 && e.initChain !== null ? ResponseInitChain.fromPartial(e.initChain) : void 0, n.query = e.query !== void 0 && e.query !== null ? ResponseQuery.fromPartial(e.query) : void 0, n.beginBlock = e.beginBlock !== void 0 && e.beginBlock !== null ? ResponseBeginBlock.fromPartial(e.beginBlock) : void 0, n.checkTx = e.checkTx !== void 0 && e.checkTx !== null ? ResponseCheckTx.fromPartial(e.checkTx) : void 0, n.deliverTx = e.deliverTx !== void 0 && e.deliverTx !== null ? ResponseDeliverTx.fromPartial(e.deliverTx) : void 0, n.endBlock = e.endBlock !== void 0 && e.endBlock !== null ? ResponseEndBlock.fromPartial(e.endBlock) : void 0, n.commit = e.commit !== void 0 && e.commit !== null ? ResponseCommit.fromPartial(e.commit) : void 0, n.listSnapshots = e.listSnapshots !== void 0 && e.listSnapshots !== null ? ResponseListSnapshots.fromPartial(e.listSnapshots) : void 0, n.offerSnapshot = e.offerSnapshot !== void 0 && e.offerSnapshot !== null ? ResponseOfferSnapshot.fromPartial(e.offerSnapshot) : void 0, n.loadSnapshotChunk = e.loadSnapshotChunk !== void 0 && e.loadSnapshotChunk !== null ? ResponseLoadSnapshotChunk.fromPartial(e.loadSnapshotChunk) : void 0, n.applySnapshotChunk = e.applySnapshotChunk !== void 0 && e.applySnapshotChunk !== null ? ResponseApplySnapshotChunk.fromPartial(e.applySnapshotChunk) : void 0, n.prepareProposal = e.prepareProposal !== void 0 && e.prepareProposal !== null ? ResponsePrepareProposal.fromPartial(e.prepareProposal) : void 0, n.processProposal = e.processProposal !== void 0 && e.processProposal !== null ? ResponseProcessProposal.fromPartial(e.processProposal) : void 0, n;
  },
  fromAmino(e) {
    return {
      exception: e != null && e.exception ? ResponseException.fromAmino(e.exception) : void 0,
      echo: e != null && e.echo ? ResponseEcho.fromAmino(e.echo) : void 0,
      flush: e != null && e.flush ? ResponseFlush.fromAmino(e.flush) : void 0,
      info: e != null && e.info ? ResponseInfo.fromAmino(e.info) : void 0,
      initChain: e != null && e.init_chain ? ResponseInitChain.fromAmino(e.init_chain) : void 0,
      query: e != null && e.query ? ResponseQuery.fromAmino(e.query) : void 0,
      beginBlock: e != null && e.begin_block ? ResponseBeginBlock.fromAmino(e.begin_block) : void 0,
      checkTx: e != null && e.check_tx ? ResponseCheckTx.fromAmino(e.check_tx) : void 0,
      deliverTx: e != null && e.deliver_tx ? ResponseDeliverTx.fromAmino(e.deliver_tx) : void 0,
      endBlock: e != null && e.end_block ? ResponseEndBlock.fromAmino(e.end_block) : void 0,
      commit: e != null && e.commit ? ResponseCommit.fromAmino(e.commit) : void 0,
      listSnapshots: e != null && e.list_snapshots ? ResponseListSnapshots.fromAmino(e.list_snapshots) : void 0,
      offerSnapshot: e != null && e.offer_snapshot ? ResponseOfferSnapshot.fromAmino(e.offer_snapshot) : void 0,
      loadSnapshotChunk: e != null && e.load_snapshot_chunk ? ResponseLoadSnapshotChunk.fromAmino(e.load_snapshot_chunk) : void 0,
      applySnapshotChunk: e != null && e.apply_snapshot_chunk ? ResponseApplySnapshotChunk.fromAmino(e.apply_snapshot_chunk) : void 0,
      prepareProposal: e != null && e.prepare_proposal ? ResponsePrepareProposal.fromAmino(e.prepare_proposal) : void 0,
      processProposal: e != null && e.process_proposal ? ResponseProcessProposal.fromAmino(e.process_proposal) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.exception = e.exception ? ResponseException.toAmino(e.exception) : void 0, n.echo = e.echo ? ResponseEcho.toAmino(e.echo) : void 0, n.flush = e.flush ? ResponseFlush.toAmino(e.flush) : void 0, n.info = e.info ? ResponseInfo.toAmino(e.info) : void 0, n.init_chain = e.initChain ? ResponseInitChain.toAmino(e.initChain) : void 0, n.query = e.query ? ResponseQuery.toAmino(e.query) : void 0, n.begin_block = e.beginBlock ? ResponseBeginBlock.toAmino(e.beginBlock) : void 0, n.check_tx = e.checkTx ? ResponseCheckTx.toAmino(e.checkTx) : void 0, n.deliver_tx = e.deliverTx ? ResponseDeliverTx.toAmino(e.deliverTx) : void 0, n.end_block = e.endBlock ? ResponseEndBlock.toAmino(e.endBlock) : void 0, n.commit = e.commit ? ResponseCommit.toAmino(e.commit) : void 0, n.list_snapshots = e.listSnapshots ? ResponseListSnapshots.toAmino(e.listSnapshots) : void 0, n.offer_snapshot = e.offerSnapshot ? ResponseOfferSnapshot.toAmino(e.offerSnapshot) : void 0, n.load_snapshot_chunk = e.loadSnapshotChunk ? ResponseLoadSnapshotChunk.toAmino(e.loadSnapshotChunk) : void 0, n.apply_snapshot_chunk = e.applySnapshotChunk ? ResponseApplySnapshotChunk.toAmino(e.applySnapshotChunk) : void 0, n.prepare_proposal = e.prepareProposal ? ResponsePrepareProposal.toAmino(e.prepareProposal) : void 0, n.process_proposal = e.processProposal ? ResponseProcessProposal.toAmino(e.processProposal) : void 0, n;
  },
  fromAminoMsg(e) {
    return Response.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Response.decode(e.value);
  },
  toProto(e) {
    return Response.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.Response",
      value: Response.encode(e).finish()
    };
  }
};
function createBaseResponseException() {
  return {
    error: ""
  };
}
const ResponseException = {
  typeUrl: "/tendermint.abci.ResponseException",
  encode(e, n = minimal.Writer.create()) {
    return e.error !== "" && n.uint32(10).string(e.error), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseException();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.error = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponseException();
    return o.error = (n = e.error) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      error: e.error
    };
  },
  toAmino(e) {
    const n = {};
    return n.error = e.error, n;
  },
  fromAminoMsg(e) {
    return ResponseException.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseException.decode(e.value);
  },
  toProto(e) {
    return ResponseException.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseException",
      value: ResponseException.encode(e).finish()
    };
  }
};
function createBaseResponseEcho() {
  return {
    message: ""
  };
}
const ResponseEcho = {
  typeUrl: "/tendermint.abci.ResponseEcho",
  encode(e, n = minimal.Writer.create()) {
    return e.message !== "" && n.uint32(10).string(e.message), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseEcho();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.message = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponseEcho();
    return o.message = (n = e.message) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      message: e.message
    };
  },
  toAmino(e) {
    const n = {};
    return n.message = e.message, n;
  },
  fromAminoMsg(e) {
    return ResponseEcho.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseEcho.decode(e.value);
  },
  toProto(e) {
    return ResponseEcho.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseEcho",
      value: ResponseEcho.encode(e).finish()
    };
  }
};
function createBaseResponseFlush() {
  return {};
}
const ResponseFlush = {
  typeUrl: "/tendermint.abci.ResponseFlush",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseFlush();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseResponseFlush();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ResponseFlush.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseFlush.decode(e.value);
  },
  toProto(e) {
    return ResponseFlush.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseFlush",
      value: ResponseFlush.encode(e).finish()
    };
  }
};
function createBaseResponseInfo() {
  return {
    data: "",
    version: "",
    appVersion: Long$2.UZERO,
    lastBlockHeight: Long$2.ZERO,
    lastBlockAppHash: new Uint8Array()
  };
}
const ResponseInfo = {
  typeUrl: "/tendermint.abci.ResponseInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.data !== "" && n.uint32(10).string(e.data), e.version !== "" && n.uint32(18).string(e.version), e.appVersion.isZero() || n.uint32(24).uint64(e.appVersion), e.lastBlockHeight.isZero() || n.uint32(32).int64(e.lastBlockHeight), e.lastBlockAppHash.length !== 0 && n.uint32(42).bytes(e.lastBlockAppHash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data = o.string();
          break;
        case 2:
          c.version = o.string();
          break;
        case 3:
          c.appVersion = o.uint64();
          break;
        case 4:
          c.lastBlockHeight = o.int64();
          break;
        case 5:
          c.lastBlockAppHash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseResponseInfo();
    return c.data = (n = e.data) !== null && n !== void 0 ? n : "", c.version = (o = e.version) !== null && o !== void 0 ? o : "", c.appVersion = e.appVersion !== void 0 && e.appVersion !== null ? Long$2.fromValue(e.appVersion) : Long$2.UZERO, c.lastBlockHeight = e.lastBlockHeight !== void 0 && e.lastBlockHeight !== null ? Long$2.fromValue(e.lastBlockHeight) : Long$2.ZERO, c.lastBlockAppHash = (u = e.lastBlockAppHash) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      data: e.data,
      version: e.version,
      appVersion: Long$2.fromString(e.app_version),
      lastBlockHeight: Long$2.fromString(e.last_block_height),
      lastBlockAppHash: e.last_block_app_hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data, n.version = e.version, n.app_version = e.appVersion ? e.appVersion.toString() : void 0, n.last_block_height = e.lastBlockHeight ? e.lastBlockHeight.toString() : void 0, n.last_block_app_hash = e.lastBlockAppHash, n;
  },
  fromAminoMsg(e) {
    return ResponseInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseInfo.decode(e.value);
  },
  toProto(e) {
    return ResponseInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseInfo",
      value: ResponseInfo.encode(e).finish()
    };
  }
};
function createBaseResponseInitChain() {
  return {
    consensusParams: void 0,
    validators: [],
    appHash: new Uint8Array()
  };
}
const ResponseInitChain = {
  typeUrl: "/tendermint.abci.ResponseInitChain",
  encode(e, n = minimal.Writer.create()) {
    e.consensusParams !== void 0 && ConsensusParams.encode(e.consensusParams, n.uint32(10).fork()).ldelim();
    for (const o of e.validators)
      ValidatorUpdate.encode(o, n.uint32(18).fork()).ldelim();
    return e.appHash.length !== 0 && n.uint32(26).bytes(e.appHash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseInitChain();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.consensusParams = ConsensusParams.decode(o, o.uint32());
          break;
        case 2:
          c.validators.push(ValidatorUpdate.decode(o, o.uint32()));
          break;
        case 3:
          c.appHash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseResponseInitChain();
    return u.consensusParams = e.consensusParams !== void 0 && e.consensusParams !== null ? ConsensusParams.fromPartial(e.consensusParams) : void 0, u.validators = ((n = e.validators) === null || n === void 0 ? void 0 : n.map((c) => ValidatorUpdate.fromPartial(c))) || [], u.appHash = (o = e.appHash) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      consensusParams: e != null && e.consensus_params ? ConsensusParams.fromAmino(e.consensus_params) : void 0,
      validators: Array.isArray(e == null ? void 0 : e.validators) ? e.validators.map((n) => ValidatorUpdate.fromAmino(n)) : [],
      appHash: e.app_hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.consensus_params = e.consensusParams ? ConsensusParams.toAmino(e.consensusParams) : void 0, e.validators ? n.validators = e.validators.map((o) => o ? ValidatorUpdate.toAmino(o) : void 0) : n.validators = [], n.app_hash = e.appHash, n;
  },
  fromAminoMsg(e) {
    return ResponseInitChain.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseInitChain.decode(e.value);
  },
  toProto(e) {
    return ResponseInitChain.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseInitChain",
      value: ResponseInitChain.encode(e).finish()
    };
  }
};
function createBaseResponseQuery() {
  return {
    code: 0,
    log: "",
    info: "",
    index: Long$2.ZERO,
    key: new Uint8Array(),
    value: new Uint8Array(),
    proofOps: void 0,
    height: Long$2.ZERO,
    codespace: ""
  };
}
const ResponseQuery = {
  typeUrl: "/tendermint.abci.ResponseQuery",
  encode(e, n = minimal.Writer.create()) {
    return e.code !== 0 && n.uint32(8).uint32(e.code), e.log !== "" && n.uint32(26).string(e.log), e.info !== "" && n.uint32(34).string(e.info), e.index.isZero() || n.uint32(40).int64(e.index), e.key.length !== 0 && n.uint32(50).bytes(e.key), e.value.length !== 0 && n.uint32(58).bytes(e.value), e.proofOps !== void 0 && ProofOps.encode(e.proofOps, n.uint32(66).fork()).ldelim(), e.height.isZero() || n.uint32(72).int64(e.height), e.codespace !== "" && n.uint32(82).string(e.codespace), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseQuery();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.code = o.uint32();
          break;
        case 3:
          c.log = o.string();
          break;
        case 4:
          c.info = o.string();
          break;
        case 5:
          c.index = o.int64();
          break;
        case 6:
          c.key = o.bytes();
          break;
        case 7:
          c.value = o.bytes();
          break;
        case 8:
          c.proofOps = ProofOps.decode(o, o.uint32());
          break;
        case 9:
          c.height = o.int64();
          break;
        case 10:
          c.codespace = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseResponseQuery();
    return v.code = (n = e.code) !== null && n !== void 0 ? n : 0, v.log = (o = e.log) !== null && o !== void 0 ? o : "", v.info = (u = e.info) !== null && u !== void 0 ? u : "", v.index = e.index !== void 0 && e.index !== null ? Long$2.fromValue(e.index) : Long$2.ZERO, v.key = (c = e.key) !== null && c !== void 0 ? c : new Uint8Array(), v.value = (d = e.value) !== null && d !== void 0 ? d : new Uint8Array(), v.proofOps = e.proofOps !== void 0 && e.proofOps !== null ? ProofOps.fromPartial(e.proofOps) : void 0, v.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, v.codespace = (m = e.codespace) !== null && m !== void 0 ? m : "", v;
  },
  fromAmino(e) {
    return {
      code: e.code,
      log: e.log,
      info: e.info,
      index: Long$2.fromString(e.index),
      key: e.key,
      value: e.value,
      proofOps: e != null && e.proof_ops ? ProofOps.fromAmino(e.proof_ops) : void 0,
      height: Long$2.fromString(e.height),
      codespace: e.codespace
    };
  },
  toAmino(e) {
    const n = {};
    return n.code = e.code, n.log = e.log, n.info = e.info, n.index = e.index ? e.index.toString() : void 0, n.key = e.key, n.value = e.value, n.proof_ops = e.proofOps ? ProofOps.toAmino(e.proofOps) : void 0, n.height = e.height ? e.height.toString() : void 0, n.codespace = e.codespace, n;
  },
  fromAminoMsg(e) {
    return ResponseQuery.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseQuery.decode(e.value);
  },
  toProto(e) {
    return ResponseQuery.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseQuery",
      value: ResponseQuery.encode(e).finish()
    };
  }
};
function createBaseResponseBeginBlock() {
  return {
    events: []
  };
}
const ResponseBeginBlock = {
  typeUrl: "/tendermint.abci.ResponseBeginBlock",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.events)
      Event$1.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseBeginBlock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.events.push(Event$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponseBeginBlock();
    return o.events = ((n = e.events) === null || n === void 0 ? void 0 : n.map((u) => Event$1.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      events: Array.isArray(e == null ? void 0 : e.events) ? e.events.map((n) => Event$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.events ? n.events = e.events.map((o) => o ? Event$1.toAmino(o) : void 0) : n.events = [], n;
  },
  fromAminoMsg(e) {
    return ResponseBeginBlock.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseBeginBlock.decode(e.value);
  },
  toProto(e) {
    return ResponseBeginBlock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseBeginBlock",
      value: ResponseBeginBlock.encode(e).finish()
    };
  }
};
function createBaseResponseCheckTx() {
  return {
    code: 0,
    data: new Uint8Array(),
    log: "",
    info: "",
    gasWanted: Long$2.ZERO,
    gasUsed: Long$2.ZERO,
    events: [],
    codespace: "",
    sender: "",
    priority: Long$2.ZERO,
    mempoolError: ""
  };
}
const ResponseCheckTx = {
  typeUrl: "/tendermint.abci.ResponseCheckTx",
  encode(e, n = minimal.Writer.create()) {
    e.code !== 0 && n.uint32(8).uint32(e.code), e.data.length !== 0 && n.uint32(18).bytes(e.data), e.log !== "" && n.uint32(26).string(e.log), e.info !== "" && n.uint32(34).string(e.info), e.gasWanted.isZero() || n.uint32(40).int64(e.gasWanted), e.gasUsed.isZero() || n.uint32(48).int64(e.gasUsed);
    for (const o of e.events)
      Event$1.encode(o, n.uint32(58).fork()).ldelim();
    return e.codespace !== "" && n.uint32(66).string(e.codespace), e.sender !== "" && n.uint32(74).string(e.sender), e.priority.isZero() || n.uint32(80).int64(e.priority), e.mempoolError !== "" && n.uint32(90).string(e.mempoolError), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseCheckTx();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.code = o.uint32();
          break;
        case 2:
          c.data = o.bytes();
          break;
        case 3:
          c.log = o.string();
          break;
        case 4:
          c.info = o.string();
          break;
        case 5:
          c.gasWanted = o.int64();
          break;
        case 6:
          c.gasUsed = o.int64();
          break;
        case 7:
          c.events.push(Event$1.decode(o, o.uint32()));
          break;
        case 8:
          c.codespace = o.string();
          break;
        case 9:
          c.sender = o.string();
          break;
        case 10:
          c.priority = o.int64();
          break;
        case 11:
          c.mempoolError = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S;
    const $ = createBaseResponseCheckTx();
    return $.code = (n = e.code) !== null && n !== void 0 ? n : 0, $.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), $.log = (u = e.log) !== null && u !== void 0 ? u : "", $.info = (c = e.info) !== null && c !== void 0 ? c : "", $.gasWanted = e.gasWanted !== void 0 && e.gasWanted !== null ? Long$2.fromValue(e.gasWanted) : Long$2.ZERO, $.gasUsed = e.gasUsed !== void 0 && e.gasUsed !== null ? Long$2.fromValue(e.gasUsed) : Long$2.ZERO, $.events = ((d = e.events) === null || d === void 0 ? void 0 : d.map((E) => Event$1.fromPartial(E))) || [], $.codespace = (m = e.codespace) !== null && m !== void 0 ? m : "", $.sender = (v = e.sender) !== null && v !== void 0 ? v : "", $.priority = e.priority !== void 0 && e.priority !== null ? Long$2.fromValue(e.priority) : Long$2.ZERO, $.mempoolError = (S = e.mempoolError) !== null && S !== void 0 ? S : "", $;
  },
  fromAmino(e) {
    return {
      code: e.code,
      data: e.data,
      log: e.log,
      info: e.info,
      gasWanted: Long$2.fromString(e.gas_wanted),
      gasUsed: Long$2.fromString(e.gas_used),
      events: Array.isArray(e == null ? void 0 : e.events) ? e.events.map((n) => Event$1.fromAmino(n)) : [],
      codespace: e.codespace,
      sender: e.sender,
      priority: Long$2.fromString(e.priority),
      mempoolError: e.mempool_error
    };
  },
  toAmino(e) {
    const n = {};
    return n.code = e.code, n.data = e.data, n.log = e.log, n.info = e.info, n.gas_wanted = e.gasWanted ? e.gasWanted.toString() : void 0, n.gas_used = e.gasUsed ? e.gasUsed.toString() : void 0, e.events ? n.events = e.events.map((o) => o ? Event$1.toAmino(o) : void 0) : n.events = [], n.codespace = e.codespace, n.sender = e.sender, n.priority = e.priority ? e.priority.toString() : void 0, n.mempool_error = e.mempoolError, n;
  },
  fromAminoMsg(e) {
    return ResponseCheckTx.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseCheckTx.decode(e.value);
  },
  toProto(e) {
    return ResponseCheckTx.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseCheckTx",
      value: ResponseCheckTx.encode(e).finish()
    };
  }
};
function createBaseResponseDeliverTx() {
  return {
    code: 0,
    data: new Uint8Array(),
    log: "",
    info: "",
    gasWanted: Long$2.ZERO,
    gasUsed: Long$2.ZERO,
    events: [],
    codespace: ""
  };
}
const ResponseDeliverTx = {
  typeUrl: "/tendermint.abci.ResponseDeliverTx",
  encode(e, n = minimal.Writer.create()) {
    e.code !== 0 && n.uint32(8).uint32(e.code), e.data.length !== 0 && n.uint32(18).bytes(e.data), e.log !== "" && n.uint32(26).string(e.log), e.info !== "" && n.uint32(34).string(e.info), e.gasWanted.isZero() || n.uint32(40).int64(e.gasWanted), e.gasUsed.isZero() || n.uint32(48).int64(e.gasUsed);
    for (const o of e.events)
      Event$1.encode(o, n.uint32(58).fork()).ldelim();
    return e.codespace !== "" && n.uint32(66).string(e.codespace), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseDeliverTx();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.code = o.uint32();
          break;
        case 2:
          c.data = o.bytes();
          break;
        case 3:
          c.log = o.string();
          break;
        case 4:
          c.info = o.string();
          break;
        case 5:
          c.gasWanted = o.int64();
          break;
        case 6:
          c.gasUsed = o.int64();
          break;
        case 7:
          c.events.push(Event$1.decode(o, o.uint32()));
          break;
        case 8:
          c.codespace = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseResponseDeliverTx();
    return v.code = (n = e.code) !== null && n !== void 0 ? n : 0, v.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), v.log = (u = e.log) !== null && u !== void 0 ? u : "", v.info = (c = e.info) !== null && c !== void 0 ? c : "", v.gasWanted = e.gasWanted !== void 0 && e.gasWanted !== null ? Long$2.fromValue(e.gasWanted) : Long$2.ZERO, v.gasUsed = e.gasUsed !== void 0 && e.gasUsed !== null ? Long$2.fromValue(e.gasUsed) : Long$2.ZERO, v.events = ((d = e.events) === null || d === void 0 ? void 0 : d.map((S) => Event$1.fromPartial(S))) || [], v.codespace = (m = e.codespace) !== null && m !== void 0 ? m : "", v;
  },
  fromAmino(e) {
    return {
      code: e.code,
      data: e.data,
      log: e.log,
      info: e.info,
      gasWanted: Long$2.fromString(e.gas_wanted),
      gasUsed: Long$2.fromString(e.gas_used),
      events: Array.isArray(e == null ? void 0 : e.events) ? e.events.map((n) => Event$1.fromAmino(n)) : [],
      codespace: e.codespace
    };
  },
  toAmino(e) {
    const n = {};
    return n.code = e.code, n.data = e.data, n.log = e.log, n.info = e.info, n.gas_wanted = e.gasWanted ? e.gasWanted.toString() : void 0, n.gas_used = e.gasUsed ? e.gasUsed.toString() : void 0, e.events ? n.events = e.events.map((o) => o ? Event$1.toAmino(o) : void 0) : n.events = [], n.codespace = e.codespace, n;
  },
  fromAminoMsg(e) {
    return ResponseDeliverTx.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseDeliverTx.decode(e.value);
  },
  toProto(e) {
    return ResponseDeliverTx.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseDeliverTx",
      value: ResponseDeliverTx.encode(e).finish()
    };
  }
};
function createBaseResponseEndBlock() {
  return {
    validatorUpdates: [],
    consensusParamUpdates: void 0,
    events: []
  };
}
const ResponseEndBlock = {
  typeUrl: "/tendermint.abci.ResponseEndBlock",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.validatorUpdates)
      ValidatorUpdate.encode(o, n.uint32(10).fork()).ldelim();
    e.consensusParamUpdates !== void 0 && ConsensusParams.encode(e.consensusParamUpdates, n.uint32(18).fork()).ldelim();
    for (const o of e.events)
      Event$1.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseEndBlock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorUpdates.push(ValidatorUpdate.decode(o, o.uint32()));
          break;
        case 2:
          c.consensusParamUpdates = ConsensusParams.decode(o, o.uint32());
          break;
        case 3:
          c.events.push(Event$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseResponseEndBlock();
    return u.validatorUpdates = ((n = e.validatorUpdates) === null || n === void 0 ? void 0 : n.map((c) => ValidatorUpdate.fromPartial(c))) || [], u.consensusParamUpdates = e.consensusParamUpdates !== void 0 && e.consensusParamUpdates !== null ? ConsensusParams.fromPartial(e.consensusParamUpdates) : void 0, u.events = ((o = e.events) === null || o === void 0 ? void 0 : o.map((c) => Event$1.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      validatorUpdates: Array.isArray(e == null ? void 0 : e.validator_updates) ? e.validator_updates.map((n) => ValidatorUpdate.fromAmino(n)) : [],
      consensusParamUpdates: e != null && e.consensus_param_updates ? ConsensusParams.fromAmino(e.consensus_param_updates) : void 0,
      events: Array.isArray(e == null ? void 0 : e.events) ? e.events.map((n) => Event$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.validatorUpdates ? n.validator_updates = e.validatorUpdates.map((o) => o ? ValidatorUpdate.toAmino(o) : void 0) : n.validator_updates = [], n.consensus_param_updates = e.consensusParamUpdates ? ConsensusParams.toAmino(e.consensusParamUpdates) : void 0, e.events ? n.events = e.events.map((o) => o ? Event$1.toAmino(o) : void 0) : n.events = [], n;
  },
  fromAminoMsg(e) {
    return ResponseEndBlock.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseEndBlock.decode(e.value);
  },
  toProto(e) {
    return ResponseEndBlock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseEndBlock",
      value: ResponseEndBlock.encode(e).finish()
    };
  }
};
function createBaseResponseCommit() {
  return {
    data: new Uint8Array(),
    retainHeight: Long$2.ZERO
  };
}
const ResponseCommit = {
  typeUrl: "/tendermint.abci.ResponseCommit",
  encode(e, n = minimal.Writer.create()) {
    return e.data.length !== 0 && n.uint32(18).bytes(e.data), e.retainHeight.isZero() || n.uint32(24).int64(e.retainHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseCommit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.data = o.bytes();
          break;
        case 3:
          c.retainHeight = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponseCommit();
    return o.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), o.retainHeight = e.retainHeight !== void 0 && e.retainHeight !== null ? Long$2.fromValue(e.retainHeight) : Long$2.ZERO, o;
  },
  fromAmino(e) {
    return {
      data: e.data,
      retainHeight: Long$2.fromString(e.retain_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data, n.retain_height = e.retainHeight ? e.retainHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ResponseCommit.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseCommit.decode(e.value);
  },
  toProto(e) {
    return ResponseCommit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseCommit",
      value: ResponseCommit.encode(e).finish()
    };
  }
};
function createBaseResponseListSnapshots() {
  return {
    snapshots: []
  };
}
const ResponseListSnapshots = {
  typeUrl: "/tendermint.abci.ResponseListSnapshots",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.snapshots)
      Snapshot.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseListSnapshots();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.snapshots.push(Snapshot.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponseListSnapshots();
    return o.snapshots = ((n = e.snapshots) === null || n === void 0 ? void 0 : n.map((u) => Snapshot.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      snapshots: Array.isArray(e == null ? void 0 : e.snapshots) ? e.snapshots.map((n) => Snapshot.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.snapshots ? n.snapshots = e.snapshots.map((o) => o ? Snapshot.toAmino(o) : void 0) : n.snapshots = [], n;
  },
  fromAminoMsg(e) {
    return ResponseListSnapshots.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseListSnapshots.decode(e.value);
  },
  toProto(e) {
    return ResponseListSnapshots.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseListSnapshots",
      value: ResponseListSnapshots.encode(e).finish()
    };
  }
};
function createBaseResponseOfferSnapshot() {
  return {
    result: 0
  };
}
const ResponseOfferSnapshot = {
  typeUrl: "/tendermint.abci.ResponseOfferSnapshot",
  encode(e, n = minimal.Writer.create()) {
    return e.result !== 0 && n.uint32(8).int32(e.result), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseOfferSnapshot();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.result = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponseOfferSnapshot();
    return o.result = (n = e.result) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      result: isSet(e.result) ? responseOfferSnapshot_ResultFromJSON(e.result) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.result = e.result, n;
  },
  fromAminoMsg(e) {
    return ResponseOfferSnapshot.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseOfferSnapshot.decode(e.value);
  },
  toProto(e) {
    return ResponseOfferSnapshot.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseOfferSnapshot",
      value: ResponseOfferSnapshot.encode(e).finish()
    };
  }
};
function createBaseResponseLoadSnapshotChunk() {
  return {
    chunk: new Uint8Array()
  };
}
const ResponseLoadSnapshotChunk = {
  typeUrl: "/tendermint.abci.ResponseLoadSnapshotChunk",
  encode(e, n = minimal.Writer.create()) {
    return e.chunk.length !== 0 && n.uint32(10).bytes(e.chunk), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseLoadSnapshotChunk();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.chunk = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponseLoadSnapshotChunk();
    return o.chunk = (n = e.chunk) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      chunk: e.chunk
    };
  },
  toAmino(e) {
    const n = {};
    return n.chunk = e.chunk, n;
  },
  fromAminoMsg(e) {
    return ResponseLoadSnapshotChunk.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseLoadSnapshotChunk.decode(e.value);
  },
  toProto(e) {
    return ResponseLoadSnapshotChunk.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseLoadSnapshotChunk",
      value: ResponseLoadSnapshotChunk.encode(e).finish()
    };
  }
};
function createBaseResponseApplySnapshotChunk() {
  return {
    result: 0,
    refetchChunks: [],
    rejectSenders: []
  };
}
const ResponseApplySnapshotChunk = {
  typeUrl: "/tendermint.abci.ResponseApplySnapshotChunk",
  encode(e, n = minimal.Writer.create()) {
    e.result !== 0 && n.uint32(8).int32(e.result), n.uint32(18).fork();
    for (const o of e.refetchChunks)
      n.uint32(o);
    n.ldelim();
    for (const o of e.rejectSenders)
      n.uint32(26).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseApplySnapshotChunk();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.result = o.int32();
          break;
        case 2:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.refetchChunks.push(o.uint32());
          } else
            c.refetchChunks.push(o.uint32());
          break;
        case 3:
          c.rejectSenders.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseResponseApplySnapshotChunk();
    return c.result = (n = e.result) !== null && n !== void 0 ? n : 0, c.refetchChunks = ((o = e.refetchChunks) === null || o === void 0 ? void 0 : o.map((d) => d)) || [], c.rejectSenders = ((u = e.rejectSenders) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c;
  },
  fromAmino(e) {
    return {
      result: isSet(e.result) ? responseApplySnapshotChunk_ResultFromJSON(e.result) : 0,
      refetchChunks: Array.isArray(e == null ? void 0 : e.refetch_chunks) ? e.refetch_chunks.map((n) => n) : [],
      rejectSenders: Array.isArray(e == null ? void 0 : e.reject_senders) ? e.reject_senders.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.result = e.result, e.refetchChunks ? n.refetch_chunks = e.refetchChunks.map((o) => o) : n.refetch_chunks = [], e.rejectSenders ? n.reject_senders = e.rejectSenders.map((o) => o) : n.reject_senders = [], n;
  },
  fromAminoMsg(e) {
    return ResponseApplySnapshotChunk.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseApplySnapshotChunk.decode(e.value);
  },
  toProto(e) {
    return ResponseApplySnapshotChunk.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseApplySnapshotChunk",
      value: ResponseApplySnapshotChunk.encode(e).finish()
    };
  }
};
function createBaseResponsePrepareProposal() {
  return {
    txs: []
  };
}
const ResponsePrepareProposal = {
  typeUrl: "/tendermint.abci.ResponsePrepareProposal",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.txs)
      n.uint32(10).bytes(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponsePrepareProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.txs.push(o.bytes());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponsePrepareProposal();
    return o.txs = ((n = e.txs) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      txs: Array.isArray(e == null ? void 0 : e.txs) ? e.txs.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.txs ? n.txs = e.txs.map((o) => o) : n.txs = [], n;
  },
  fromAminoMsg(e) {
    return ResponsePrepareProposal.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponsePrepareProposal.decode(e.value);
  },
  toProto(e) {
    return ResponsePrepareProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponsePrepareProposal",
      value: ResponsePrepareProposal.encode(e).finish()
    };
  }
};
function createBaseResponseProcessProposal() {
  return {
    status: 0
  };
}
const ResponseProcessProposal = {
  typeUrl: "/tendermint.abci.ResponseProcessProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.status !== 0 && n.uint32(8).int32(e.status), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResponseProcessProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.status = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseResponseProcessProposal();
    return o.status = (n = e.status) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      status: isSet(e.status) ? responseProcessProposal_ProposalStatusFromJSON(e.status) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.status = e.status, n;
  },
  fromAminoMsg(e) {
    return ResponseProcessProposal.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ResponseProcessProposal.decode(e.value);
  },
  toProto(e) {
    return ResponseProcessProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ResponseProcessProposal",
      value: ResponseProcessProposal.encode(e).finish()
    };
  }
};
function createBaseCommitInfo() {
  return {
    round: 0,
    votes: []
  };
}
const CommitInfo = {
  typeUrl: "/tendermint.abci.CommitInfo",
  encode(e, n = minimal.Writer.create()) {
    e.round !== 0 && n.uint32(8).int32(e.round);
    for (const o of e.votes)
      VoteInfo.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommitInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.round = o.int32();
          break;
        case 2:
          c.votes.push(VoteInfo.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCommitInfo();
    return u.round = (n = e.round) !== null && n !== void 0 ? n : 0, u.votes = ((o = e.votes) === null || o === void 0 ? void 0 : o.map((c) => VoteInfo.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      round: e.round,
      votes: Array.isArray(e == null ? void 0 : e.votes) ? e.votes.map((n) => VoteInfo.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.round = e.round, e.votes ? n.votes = e.votes.map((o) => o ? VoteInfo.toAmino(o) : void 0) : n.votes = [], n;
  },
  fromAminoMsg(e) {
    return CommitInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return CommitInfo.decode(e.value);
  },
  toProto(e) {
    return CommitInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.CommitInfo",
      value: CommitInfo.encode(e).finish()
    };
  }
};
function createBaseExtendedCommitInfo() {
  return {
    round: 0,
    votes: []
  };
}
const ExtendedCommitInfo = {
  typeUrl: "/tendermint.abci.ExtendedCommitInfo",
  encode(e, n = minimal.Writer.create()) {
    e.round !== 0 && n.uint32(8).int32(e.round);
    for (const o of e.votes)
      ExtendedVoteInfo.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseExtendedCommitInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.round = o.int32();
          break;
        case 2:
          c.votes.push(ExtendedVoteInfo.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseExtendedCommitInfo();
    return u.round = (n = e.round) !== null && n !== void 0 ? n : 0, u.votes = ((o = e.votes) === null || o === void 0 ? void 0 : o.map((c) => ExtendedVoteInfo.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      round: e.round,
      votes: Array.isArray(e == null ? void 0 : e.votes) ? e.votes.map((n) => ExtendedVoteInfo.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.round = e.round, e.votes ? n.votes = e.votes.map((o) => o ? ExtendedVoteInfo.toAmino(o) : void 0) : n.votes = [], n;
  },
  fromAminoMsg(e) {
    return ExtendedCommitInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ExtendedCommitInfo.decode(e.value);
  },
  toProto(e) {
    return ExtendedCommitInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ExtendedCommitInfo",
      value: ExtendedCommitInfo.encode(e).finish()
    };
  }
};
function createBaseEvent() {
  return {
    type: "",
    attributes: []
  };
}
const Event$1 = {
  typeUrl: "/tendermint.abci.Event",
  encode(e, n = minimal.Writer.create()) {
    e.type !== "" && n.uint32(10).string(e.type);
    for (const o of e.attributes)
      EventAttribute.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEvent();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.type = o.string();
          break;
        case 2:
          c.attributes.push(EventAttribute.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEvent();
    return u.type = (n = e.type) !== null && n !== void 0 ? n : "", u.attributes = ((o = e.attributes) === null || o === void 0 ? void 0 : o.map((c) => EventAttribute.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      type: e.type,
      attributes: Array.isArray(e == null ? void 0 : e.attributes) ? e.attributes.map((n) => EventAttribute.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.type = e.type, e.attributes ? n.attributes = e.attributes.map((o) => o ? EventAttribute.toAmino(o) : void 0) : n.attributes = [], n;
  },
  fromAminoMsg(e) {
    return Event$1.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Event$1.decode(e.value);
  },
  toProto(e) {
    return Event$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.Event",
      value: Event$1.encode(e).finish()
    };
  }
};
function createBaseEventAttribute() {
  return {
    key: "",
    value: "",
    index: !1
  };
}
const EventAttribute = {
  typeUrl: "/tendermint.abci.EventAttribute",
  encode(e, n = minimal.Writer.create()) {
    return e.key !== "" && n.uint32(10).string(e.key), e.value !== "" && n.uint32(18).string(e.value), e.index === !0 && n.uint32(24).bool(e.index), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEventAttribute();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.string();
          break;
        case 2:
          c.value = o.string();
          break;
        case 3:
          c.index = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseEventAttribute();
    return c.key = (n = e.key) !== null && n !== void 0 ? n : "", c.value = (o = e.value) !== null && o !== void 0 ? o : "", c.index = (u = e.index) !== null && u !== void 0 ? u : !1, c;
  },
  fromAmino(e) {
    return {
      key: e.key,
      value: e.value,
      index: e.index
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.value = e.value, n.index = e.index, n;
  },
  fromAminoMsg(e) {
    return EventAttribute.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return EventAttribute.decode(e.value);
  },
  toProto(e) {
    return EventAttribute.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.EventAttribute",
      value: EventAttribute.encode(e).finish()
    };
  }
};
function createBaseTxResult() {
  return {
    height: Long$2.ZERO,
    index: 0,
    tx: new Uint8Array(),
    result: void 0
  };
}
const TxResult = {
  typeUrl: "/tendermint.abci.TxResult",
  encode(e, n = minimal.Writer.create()) {
    return e.height.isZero() || n.uint32(8).int64(e.height), e.index !== 0 && n.uint32(16).uint32(e.index), e.tx.length !== 0 && n.uint32(26).bytes(e.tx), e.result !== void 0 && ResponseDeliverTx.encode(e.result, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTxResult();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = o.int64();
          break;
        case 2:
          c.index = o.uint32();
          break;
        case 3:
          c.tx = o.bytes();
          break;
        case 4:
          c.result = ResponseDeliverTx.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseTxResult();
    return u.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, u.index = (n = e.index) !== null && n !== void 0 ? n : 0, u.tx = (o = e.tx) !== null && o !== void 0 ? o : new Uint8Array(), u.result = e.result !== void 0 && e.result !== null ? ResponseDeliverTx.fromPartial(e.result) : void 0, u;
  },
  fromAmino(e) {
    return {
      height: Long$2.fromString(e.height),
      index: e.index,
      tx: e.tx,
      result: e != null && e.result ? ResponseDeliverTx.fromAmino(e.result) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? e.height.toString() : void 0, n.index = e.index, n.tx = e.tx, n.result = e.result ? ResponseDeliverTx.toAmino(e.result) : void 0, n;
  },
  fromAminoMsg(e) {
    return TxResult.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return TxResult.decode(e.value);
  },
  toProto(e) {
    return TxResult.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.TxResult",
      value: TxResult.encode(e).finish()
    };
  }
};
function createBaseValidator$1() {
  return {
    address: new Uint8Array(),
    power: Long$2.ZERO
  };
}
const Validator$1 = {
  typeUrl: "/tendermint.abci.Validator",
  encode(e, n = minimal.Writer.create()) {
    return e.address.length !== 0 && n.uint32(10).bytes(e.address), e.power.isZero() || n.uint32(24).int64(e.power), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidator$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.bytes();
          break;
        case 3:
          c.power = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidator$1();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : new Uint8Array(), o.power = e.power !== void 0 && e.power !== null ? Long$2.fromValue(e.power) : Long$2.ZERO, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      power: Long$2.fromString(e.power)
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.power = e.power ? e.power.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Validator$1.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Validator$1.decode(e.value);
  },
  toProto(e) {
    return Validator$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.Validator",
      value: Validator$1.encode(e).finish()
    };
  }
};
function createBaseValidatorUpdate() {
  return {
    pubKey: void 0,
    power: Long$2.ZERO
  };
}
const ValidatorUpdate = {
  typeUrl: "/tendermint.abci.ValidatorUpdate",
  encode(e, n = minimal.Writer.create()) {
    return e.pubKey !== void 0 && PublicKey.encode(e.pubKey, n.uint32(10).fork()).ldelim(), e.power.isZero() || n.uint32(16).int64(e.power), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorUpdate();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pubKey = PublicKey.decode(o, o.uint32());
          break;
        case 2:
          c.power = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseValidatorUpdate();
    return n.pubKey = e.pubKey !== void 0 && e.pubKey !== null ? PublicKey.fromPartial(e.pubKey) : void 0, n.power = e.power !== void 0 && e.power !== null ? Long$2.fromValue(e.power) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      pubKey: e != null && e.pub_key ? PublicKey.fromAmino(e.pub_key) : void 0,
      power: Long$2.fromString(e.power)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pub_key = e.pubKey ? PublicKey.toAmino(e.pubKey) : void 0, n.power = e.power ? e.power.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ValidatorUpdate.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ValidatorUpdate.decode(e.value);
  },
  toProto(e) {
    return ValidatorUpdate.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ValidatorUpdate",
      value: ValidatorUpdate.encode(e).finish()
    };
  }
};
function createBaseVoteInfo() {
  return {
    validator: void 0,
    signedLastBlock: !1
  };
}
const VoteInfo = {
  typeUrl: "/tendermint.abci.VoteInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.validator !== void 0 && Validator$1.encode(e.validator, n.uint32(10).fork()).ldelim(), e.signedLastBlock === !0 && n.uint32(16).bool(e.signedLastBlock), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseVoteInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validator = Validator$1.decode(o, o.uint32());
          break;
        case 2:
          c.signedLastBlock = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseVoteInfo();
    return o.validator = e.validator !== void 0 && e.validator !== null ? Validator$1.fromPartial(e.validator) : void 0, o.signedLastBlock = (n = e.signedLastBlock) !== null && n !== void 0 ? n : !1, o;
  },
  fromAmino(e) {
    return {
      validator: e != null && e.validator ? Validator$1.fromAmino(e.validator) : void 0,
      signedLastBlock: e.signed_last_block
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator = e.validator ? Validator$1.toAmino(e.validator) : void 0, n.signed_last_block = e.signedLastBlock, n;
  },
  fromAminoMsg(e) {
    return VoteInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return VoteInfo.decode(e.value);
  },
  toProto(e) {
    return VoteInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.VoteInfo",
      value: VoteInfo.encode(e).finish()
    };
  }
};
function createBaseExtendedVoteInfo() {
  return {
    validator: void 0,
    signedLastBlock: !1,
    voteExtension: new Uint8Array()
  };
}
const ExtendedVoteInfo = {
  typeUrl: "/tendermint.abci.ExtendedVoteInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.validator !== void 0 && Validator$1.encode(e.validator, n.uint32(10).fork()).ldelim(), e.signedLastBlock === !0 && n.uint32(16).bool(e.signedLastBlock), e.voteExtension.length !== 0 && n.uint32(26).bytes(e.voteExtension), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseExtendedVoteInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validator = Validator$1.decode(o, o.uint32());
          break;
        case 2:
          c.signedLastBlock = o.bool();
          break;
        case 3:
          c.voteExtension = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseExtendedVoteInfo();
    return u.validator = e.validator !== void 0 && e.validator !== null ? Validator$1.fromPartial(e.validator) : void 0, u.signedLastBlock = (n = e.signedLastBlock) !== null && n !== void 0 ? n : !1, u.voteExtension = (o = e.voteExtension) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      validator: e != null && e.validator ? Validator$1.fromAmino(e.validator) : void 0,
      signedLastBlock: e.signed_last_block,
      voteExtension: e.vote_extension
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator = e.validator ? Validator$1.toAmino(e.validator) : void 0, n.signed_last_block = e.signedLastBlock, n.vote_extension = e.voteExtension, n;
  },
  fromAminoMsg(e) {
    return ExtendedVoteInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ExtendedVoteInfo.decode(e.value);
  },
  toProto(e) {
    return ExtendedVoteInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.ExtendedVoteInfo",
      value: ExtendedVoteInfo.encode(e).finish()
    };
  }
};
function createBaseMisbehavior() {
  return {
    type: 0,
    validator: void 0,
    height: Long$2.ZERO,
    time: void 0,
    totalVotingPower: Long$2.ZERO
  };
}
const Misbehavior = {
  typeUrl: "/tendermint.abci.Misbehavior",
  encode(e, n = minimal.Writer.create()) {
    return e.type !== 0 && n.uint32(8).int32(e.type), e.validator !== void 0 && Validator$1.encode(e.validator, n.uint32(18).fork()).ldelim(), e.height.isZero() || n.uint32(24).int64(e.height), e.time !== void 0 && Timestamp.encode(toTimestamp(e.time), n.uint32(34).fork()).ldelim(), e.totalVotingPower.isZero() || n.uint32(40).int64(e.totalVotingPower), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMisbehavior();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.type = o.int32();
          break;
        case 2:
          c.validator = Validator$1.decode(o, o.uint32());
          break;
        case 3:
          c.height = o.int64();
          break;
        case 4:
          c.time = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 5:
          c.totalVotingPower = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMisbehavior();
    return u.type = (n = e.type) !== null && n !== void 0 ? n : 0, u.validator = e.validator !== void 0 && e.validator !== null ? Validator$1.fromPartial(e.validator) : void 0, u.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, u.time = (o = e.time) !== null && o !== void 0 ? o : void 0, u.totalVotingPower = e.totalVotingPower !== void 0 && e.totalVotingPower !== null ? Long$2.fromValue(e.totalVotingPower) : Long$2.ZERO, u;
  },
  fromAmino(e) {
    return {
      type: isSet(e.type) ? misbehaviorTypeFromJSON(e.type) : 0,
      validator: e != null && e.validator ? Validator$1.fromAmino(e.validator) : void 0,
      height: Long$2.fromString(e.height),
      time: e != null && e.time ? Timestamp.fromAmino(e.time) : void 0,
      totalVotingPower: Long$2.fromString(e.total_voting_power)
    };
  },
  toAmino(e) {
    const n = {};
    return n.type = e.type, n.validator = e.validator ? Validator$1.toAmino(e.validator) : void 0, n.height = e.height ? e.height.toString() : void 0, n.time = e.time ? Timestamp.toAmino(e.time) : void 0, n.total_voting_power = e.totalVotingPower ? e.totalVotingPower.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Misbehavior.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Misbehavior.decode(e.value);
  },
  toProto(e) {
    return Misbehavior.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.Misbehavior",
      value: Misbehavior.encode(e).finish()
    };
  }
};
function createBaseSnapshot() {
  return {
    height: Long$2.UZERO,
    format: 0,
    chunks: 0,
    hash: new Uint8Array(),
    metadata: new Uint8Array()
  };
}
const Snapshot = {
  typeUrl: "/tendermint.abci.Snapshot",
  encode(e, n = minimal.Writer.create()) {
    return e.height.isZero() || n.uint32(8).uint64(e.height), e.format !== 0 && n.uint32(16).uint32(e.format), e.chunks !== 0 && n.uint32(24).uint32(e.chunks), e.hash.length !== 0 && n.uint32(34).bytes(e.hash), e.metadata.length !== 0 && n.uint32(42).bytes(e.metadata), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSnapshot();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = o.uint64();
          break;
        case 2:
          c.format = o.uint32();
          break;
        case 3:
          c.chunks = o.uint32();
          break;
        case 4:
          c.hash = o.bytes();
          break;
        case 5:
          c.metadata = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseSnapshot();
    return d.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.UZERO, d.format = (n = e.format) !== null && n !== void 0 ? n : 0, d.chunks = (o = e.chunks) !== null && o !== void 0 ? o : 0, d.hash = (u = e.hash) !== null && u !== void 0 ? u : new Uint8Array(), d.metadata = (c = e.metadata) !== null && c !== void 0 ? c : new Uint8Array(), d;
  },
  fromAmino(e) {
    return {
      height: Long$2.fromString(e.height),
      format: e.format,
      chunks: e.chunks,
      hash: e.hash,
      metadata: e.metadata
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? e.height.toString() : void 0, n.format = e.format, n.chunks = e.chunks, n.hash = e.hash, n.metadata = e.metadata, n;
  },
  fromAminoMsg(e) {
    return Snapshot.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Snapshot.decode(e.value);
  },
  toProto(e) {
    return Snapshot.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.abci.Snapshot",
      value: Snapshot.encode(e).finish()
    };
  }
}, _49 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get CheckTxType() {
    return CheckTxType;
  },
  CheckTxTypeAmino,
  CheckTxTypeSDKType,
  CommitInfo,
  Event: Event$1,
  EventAttribute,
  ExtendedCommitInfo,
  ExtendedVoteInfo,
  Misbehavior,
  get MisbehaviorType() {
    return MisbehaviorType;
  },
  MisbehaviorTypeAmino,
  MisbehaviorTypeSDKType,
  Request,
  RequestApplySnapshotChunk,
  RequestBeginBlock,
  RequestCheckTx,
  RequestCommit,
  RequestDeliverTx,
  RequestEcho,
  RequestEndBlock,
  RequestFlush,
  RequestInfo,
  RequestInitChain,
  RequestListSnapshots,
  RequestLoadSnapshotChunk,
  RequestOfferSnapshot,
  RequestPrepareProposal,
  RequestProcessProposal,
  RequestQuery,
  Response,
  ResponseApplySnapshotChunk,
  get ResponseApplySnapshotChunk_Result() {
    return ResponseApplySnapshotChunk_Result;
  },
  ResponseApplySnapshotChunk_ResultAmino,
  ResponseApplySnapshotChunk_ResultSDKType,
  ResponseBeginBlock,
  ResponseCheckTx,
  ResponseCommit,
  ResponseDeliverTx,
  ResponseEcho,
  ResponseEndBlock,
  ResponseException,
  ResponseFlush,
  ResponseInfo,
  ResponseInitChain,
  ResponseListSnapshots,
  ResponseLoadSnapshotChunk,
  ResponseOfferSnapshot,
  get ResponseOfferSnapshot_Result() {
    return ResponseOfferSnapshot_Result;
  },
  ResponseOfferSnapshot_ResultAmino,
  ResponseOfferSnapshot_ResultSDKType,
  ResponsePrepareProposal,
  ResponseProcessProposal,
  get ResponseProcessProposal_ProposalStatus() {
    return ResponseProcessProposal_ProposalStatus;
  },
  ResponseProcessProposal_ProposalStatusAmino,
  ResponseProcessProposal_ProposalStatusSDKType,
  ResponseQuery,
  Snapshot,
  TxResult,
  Validator: Validator$1,
  ValidatorUpdate,
  VoteInfo,
  checkTxTypeFromJSON,
  checkTxTypeToJSON,
  misbehaviorTypeFromJSON,
  misbehaviorTypeToJSON,
  responseApplySnapshotChunk_ResultFromJSON,
  responseApplySnapshotChunk_ResultToJSON,
  responseOfferSnapshot_ResultFromJSON,
  responseOfferSnapshot_ResultToJSON,
  responseProcessProposal_ProposalStatusFromJSON,
  responseProcessProposal_ProposalStatusToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseTxResponse() {
  return {
    height: Long$2.ZERO,
    txhash: "",
    codespace: "",
    code: 0,
    data: "",
    rawLog: "",
    logs: [],
    info: "",
    gasWanted: Long$2.ZERO,
    gasUsed: Long$2.ZERO,
    tx: void 0,
    timestamp: "",
    events: []
  };
}
const TxResponse = {
  typeUrl: "/cosmos.base.abci.v1beta1.TxResponse",
  encode(e, n = minimal.Writer.create()) {
    e.height.isZero() || n.uint32(8).int64(e.height), e.txhash !== "" && n.uint32(18).string(e.txhash), e.codespace !== "" && n.uint32(26).string(e.codespace), e.code !== 0 && n.uint32(32).uint32(e.code), e.data !== "" && n.uint32(42).string(e.data), e.rawLog !== "" && n.uint32(50).string(e.rawLog);
    for (const o of e.logs)
      ABCIMessageLog.encode(o, n.uint32(58).fork()).ldelim();
    e.info !== "" && n.uint32(66).string(e.info), e.gasWanted.isZero() || n.uint32(72).int64(e.gasWanted), e.gasUsed.isZero() || n.uint32(80).int64(e.gasUsed), e.tx !== void 0 && Any.encode(e.tx, n.uint32(90).fork()).ldelim(), e.timestamp !== "" && n.uint32(98).string(e.timestamp);
    for (const o of e.events)
      Event$1.encode(o, n.uint32(106).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTxResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = o.int64();
          break;
        case 2:
          c.txhash = o.string();
          break;
        case 3:
          c.codespace = o.string();
          break;
        case 4:
          c.code = o.uint32();
          break;
        case 5:
          c.data = o.string();
          break;
        case 6:
          c.rawLog = o.string();
          break;
        case 7:
          c.logs.push(ABCIMessageLog.decode(o, o.uint32()));
          break;
        case 8:
          c.info = o.string();
          break;
        case 9:
          c.gasWanted = o.int64();
          break;
        case 10:
          c.gasUsed = o.int64();
          break;
        case 11:
          c.tx = Any.decode(o, o.uint32());
          break;
        case 12:
          c.timestamp = o.string();
          break;
        case 13:
          c.events.push(Event$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $;
    const E = createBaseTxResponse();
    return E.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, E.txhash = (n = e.txhash) !== null && n !== void 0 ? n : "", E.codespace = (o = e.codespace) !== null && o !== void 0 ? o : "", E.code = (u = e.code) !== null && u !== void 0 ? u : 0, E.data = (c = e.data) !== null && c !== void 0 ? c : "", E.rawLog = (d = e.rawLog) !== null && d !== void 0 ? d : "", E.logs = ((m = e.logs) === null || m === void 0 ? void 0 : m.map((O) => ABCIMessageLog.fromPartial(O))) || [], E.info = (v = e.info) !== null && v !== void 0 ? v : "", E.gasWanted = e.gasWanted !== void 0 && e.gasWanted !== null ? Long$2.fromValue(e.gasWanted) : Long$2.ZERO, E.gasUsed = e.gasUsed !== void 0 && e.gasUsed !== null ? Long$2.fromValue(e.gasUsed) : Long$2.ZERO, E.tx = e.tx !== void 0 && e.tx !== null ? Any.fromPartial(e.tx) : void 0, E.timestamp = (S = e.timestamp) !== null && S !== void 0 ? S : "", E.events = (($ = e.events) === null || $ === void 0 ? void 0 : $.map((O) => Event$1.fromPartial(O))) || [], E;
  },
  fromAmino(e) {
    return {
      height: Long$2.fromString(e.height),
      txhash: e.txhash,
      codespace: e.codespace,
      code: e.code,
      data: e.data,
      rawLog: e.raw_log,
      logs: Array.isArray(e == null ? void 0 : e.logs) ? e.logs.map((n) => ABCIMessageLog.fromAmino(n)) : [],
      info: e.info,
      gasWanted: Long$2.fromString(e.gas_wanted),
      gasUsed: Long$2.fromString(e.gas_used),
      tx: e != null && e.tx ? Any.fromAmino(e.tx) : void 0,
      timestamp: e.timestamp,
      events: Array.isArray(e == null ? void 0 : e.events) ? e.events.map((n) => Event$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? e.height.toString() : void 0, n.txhash = e.txhash, n.codespace = e.codespace, n.code = e.code, n.data = e.data, n.raw_log = e.rawLog, e.logs ? n.logs = e.logs.map((o) => o ? ABCIMessageLog.toAmino(o) : void 0) : n.logs = [], n.info = e.info, n.gas_wanted = e.gasWanted ? e.gasWanted.toString() : void 0, n.gas_used = e.gasUsed ? e.gasUsed.toString() : void 0, n.tx = e.tx ? Any.toAmino(e.tx) : void 0, n.timestamp = e.timestamp, e.events ? n.events = e.events.map((o) => o ? Event$1.toAmino(o) : void 0) : n.events = [], n;
  },
  fromAminoMsg(e) {
    return TxResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TxResponse",
      value: TxResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TxResponse.decode(e.value);
  },
  toProto(e) {
    return TxResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.TxResponse",
      value: TxResponse.encode(e).finish()
    };
  }
};
function createBaseABCIMessageLog() {
  return {
    msgIndex: 0,
    log: "",
    events: []
  };
}
const ABCIMessageLog = {
  typeUrl: "/cosmos.base.abci.v1beta1.ABCIMessageLog",
  encode(e, n = minimal.Writer.create()) {
    e.msgIndex !== 0 && n.uint32(8).uint32(e.msgIndex), e.log !== "" && n.uint32(18).string(e.log);
    for (const o of e.events)
      StringEvent.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseABCIMessageLog();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.msgIndex = o.uint32();
          break;
        case 2:
          c.log = o.string();
          break;
        case 3:
          c.events.push(StringEvent.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseABCIMessageLog();
    return c.msgIndex = (n = e.msgIndex) !== null && n !== void 0 ? n : 0, c.log = (o = e.log) !== null && o !== void 0 ? o : "", c.events = ((u = e.events) === null || u === void 0 ? void 0 : u.map((d) => StringEvent.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      msgIndex: e.msg_index,
      log: e.log,
      events: Array.isArray(e == null ? void 0 : e.events) ? e.events.map((n) => StringEvent.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.msg_index = e.msgIndex, n.log = e.log, e.events ? n.events = e.events.map((o) => o ? StringEvent.toAmino(o) : void 0) : n.events = [], n;
  },
  fromAminoMsg(e) {
    return ABCIMessageLog.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ABCIMessageLog",
      value: ABCIMessageLog.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ABCIMessageLog.decode(e.value);
  },
  toProto(e) {
    return ABCIMessageLog.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.ABCIMessageLog",
      value: ABCIMessageLog.encode(e).finish()
    };
  }
};
function createBaseStringEvent() {
  return {
    type: "",
    attributes: []
  };
}
const StringEvent = {
  typeUrl: "/cosmos.base.abci.v1beta1.StringEvent",
  encode(e, n = minimal.Writer.create()) {
    e.type !== "" && n.uint32(10).string(e.type);
    for (const o of e.attributes)
      Attribute.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseStringEvent();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.type = o.string();
          break;
        case 2:
          c.attributes.push(Attribute.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseStringEvent();
    return u.type = (n = e.type) !== null && n !== void 0 ? n : "", u.attributes = ((o = e.attributes) === null || o === void 0 ? void 0 : o.map((c) => Attribute.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      type: e.type,
      attributes: Array.isArray(e == null ? void 0 : e.attributes) ? e.attributes.map((n) => Attribute.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.type = e.type, e.attributes ? n.attributes = e.attributes.map((o) => o ? Attribute.toAmino(o) : void 0) : n.attributes = [], n;
  },
  fromAminoMsg(e) {
    return StringEvent.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/StringEvent",
      value: StringEvent.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return StringEvent.decode(e.value);
  },
  toProto(e) {
    return StringEvent.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.StringEvent",
      value: StringEvent.encode(e).finish()
    };
  }
};
function createBaseAttribute() {
  return {
    key: "",
    value: ""
  };
}
const Attribute = {
  typeUrl: "/cosmos.base.abci.v1beta1.Attribute",
  encode(e, n = minimal.Writer.create()) {
    return e.key !== "" && n.uint32(10).string(e.key), e.value !== "" && n.uint32(18).string(e.value), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAttribute();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.string();
          break;
        case 2:
          c.value = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseAttribute();
    return u.key = (n = e.key) !== null && n !== void 0 ? n : "", u.value = (o = e.value) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      key: e.key,
      value: e.value
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.value = e.value, n;
  },
  fromAminoMsg(e) {
    return Attribute.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Attribute",
      value: Attribute.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Attribute.decode(e.value);
  },
  toProto(e) {
    return Attribute.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.Attribute",
      value: Attribute.encode(e).finish()
    };
  }
};
function createBaseGasInfo() {
  return {
    gasWanted: Long$2.UZERO,
    gasUsed: Long$2.UZERO
  };
}
const GasInfo = {
  typeUrl: "/cosmos.base.abci.v1beta1.GasInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.gasWanted.isZero() || n.uint32(8).uint64(e.gasWanted), e.gasUsed.isZero() || n.uint32(16).uint64(e.gasUsed), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGasInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.gasWanted = o.uint64();
          break;
        case 2:
          c.gasUsed = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGasInfo();
    return n.gasWanted = e.gasWanted !== void 0 && e.gasWanted !== null ? Long$2.fromValue(e.gasWanted) : Long$2.UZERO, n.gasUsed = e.gasUsed !== void 0 && e.gasUsed !== null ? Long$2.fromValue(e.gasUsed) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      gasWanted: Long$2.fromString(e.gas_wanted),
      gasUsed: Long$2.fromString(e.gas_used)
    };
  },
  toAmino(e) {
    const n = {};
    return n.gas_wanted = e.gasWanted ? e.gasWanted.toString() : void 0, n.gas_used = e.gasUsed ? e.gasUsed.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return GasInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GasInfo",
      value: GasInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GasInfo.decode(e.value);
  },
  toProto(e) {
    return GasInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.GasInfo",
      value: GasInfo.encode(e).finish()
    };
  }
};
function createBaseResult() {
  return {
    data: new Uint8Array(),
    log: "",
    events: []
  };
}
const Result = {
  typeUrl: "/cosmos.base.abci.v1beta1.Result",
  encode(e, n = minimal.Writer.create()) {
    e.data.length !== 0 && n.uint32(10).bytes(e.data), e.log !== "" && n.uint32(18).string(e.log);
    for (const o of e.events)
      Event$1.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseResult();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data = o.bytes();
          break;
        case 2:
          c.log = o.string();
          break;
        case 3:
          c.events.push(Event$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseResult();
    return c.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), c.log = (o = e.log) !== null && o !== void 0 ? o : "", c.events = ((u = e.events) === null || u === void 0 ? void 0 : u.map((d) => Event$1.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      data: e.data,
      log: e.log,
      events: Array.isArray(e == null ? void 0 : e.events) ? e.events.map((n) => Event$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data, n.log = e.log, e.events ? n.events = e.events.map((o) => o ? Event$1.toAmino(o) : void 0) : n.events = [], n;
  },
  fromAminoMsg(e) {
    return Result.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Result",
      value: Result.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Result.decode(e.value);
  },
  toProto(e) {
    return Result.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.Result",
      value: Result.encode(e).finish()
    };
  }
};
function createBaseSimulationResponse() {
  return {
    gasInfo: void 0,
    result: void 0
  };
}
const SimulationResponse = {
  typeUrl: "/cosmos.base.abci.v1beta1.SimulationResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.gasInfo !== void 0 && GasInfo.encode(e.gasInfo, n.uint32(10).fork()).ldelim(), e.result !== void 0 && Result.encode(e.result, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSimulationResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.gasInfo = GasInfo.decode(o, o.uint32());
          break;
        case 2:
          c.result = Result.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseSimulationResponse();
    return n.gasInfo = e.gasInfo !== void 0 && e.gasInfo !== null ? GasInfo.fromPartial(e.gasInfo) : void 0, n.result = e.result !== void 0 && e.result !== null ? Result.fromPartial(e.result) : void 0, n;
  },
  fromAmino(e) {
    return {
      gasInfo: e != null && e.gas_info ? GasInfo.fromAmino(e.gas_info) : void 0,
      result: e != null && e.result ? Result.fromAmino(e.result) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.gas_info = e.gasInfo ? GasInfo.toAmino(e.gasInfo) : void 0, n.result = e.result ? Result.toAmino(e.result) : void 0, n;
  },
  fromAminoMsg(e) {
    return SimulationResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SimulationResponse",
      value: SimulationResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SimulationResponse.decode(e.value);
  },
  toProto(e) {
    return SimulationResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.SimulationResponse",
      value: SimulationResponse.encode(e).finish()
    };
  }
};
function createBaseMsgData() {
  return {
    msgType: "",
    data: new Uint8Array()
  };
}
const MsgData = {
  typeUrl: "/cosmos.base.abci.v1beta1.MsgData",
  encode(e, n = minimal.Writer.create()) {
    return e.msgType !== "" && n.uint32(10).string(e.msgType), e.data.length !== 0 && n.uint32(18).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.msgType = o.string();
          break;
        case 2:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgData();
    return u.msgType = (n = e.msgType) !== null && n !== void 0 ? n : "", u.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      msgType: e.msg_type,
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.msg_type = e.msgType, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return MsgData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgData",
      value: MsgData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgData.decode(e.value);
  },
  toProto(e) {
    return MsgData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.MsgData",
      value: MsgData.encode(e).finish()
    };
  }
};
function createBaseTxMsgData() {
  return {
    data: []
  };
}
const TxMsgData = {
  typeUrl: "/cosmos.base.abci.v1beta1.TxMsgData",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.data)
      MsgData.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTxMsgData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data.push(MsgData.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseTxMsgData();
    return o.data = ((n = e.data) === null || n === void 0 ? void 0 : n.map((u) => MsgData.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      data: Array.isArray(e == null ? void 0 : e.data) ? e.data.map((n) => MsgData.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.data ? n.data = e.data.map((o) => o ? MsgData.toAmino(o) : void 0) : n.data = [], n;
  },
  fromAminoMsg(e) {
    return TxMsgData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TxMsgData",
      value: TxMsgData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TxMsgData.decode(e.value);
  },
  toProto(e) {
    return TxMsgData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.TxMsgData",
      value: TxMsgData.encode(e).finish()
    };
  }
};
function createBaseSearchTxsResult() {
  return {
    totalCount: Long$2.UZERO,
    count: Long$2.UZERO,
    pageNumber: Long$2.UZERO,
    pageTotal: Long$2.UZERO,
    limit: Long$2.UZERO,
    txs: []
  };
}
const SearchTxsResult = {
  typeUrl: "/cosmos.base.abci.v1beta1.SearchTxsResult",
  encode(e, n = minimal.Writer.create()) {
    e.totalCount.isZero() || n.uint32(8).uint64(e.totalCount), e.count.isZero() || n.uint32(16).uint64(e.count), e.pageNumber.isZero() || n.uint32(24).uint64(e.pageNumber), e.pageTotal.isZero() || n.uint32(32).uint64(e.pageTotal), e.limit.isZero() || n.uint32(40).uint64(e.limit);
    for (const o of e.txs)
      TxResponse.encode(o, n.uint32(50).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSearchTxsResult();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.totalCount = o.uint64();
          break;
        case 2:
          c.count = o.uint64();
          break;
        case 3:
          c.pageNumber = o.uint64();
          break;
        case 4:
          c.pageTotal = o.uint64();
          break;
        case 5:
          c.limit = o.uint64();
          break;
        case 6:
          c.txs.push(TxResponse.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSearchTxsResult();
    return o.totalCount = e.totalCount !== void 0 && e.totalCount !== null ? Long$2.fromValue(e.totalCount) : Long$2.UZERO, o.count = e.count !== void 0 && e.count !== null ? Long$2.fromValue(e.count) : Long$2.UZERO, o.pageNumber = e.pageNumber !== void 0 && e.pageNumber !== null ? Long$2.fromValue(e.pageNumber) : Long$2.UZERO, o.pageTotal = e.pageTotal !== void 0 && e.pageTotal !== null ? Long$2.fromValue(e.pageTotal) : Long$2.UZERO, o.limit = e.limit !== void 0 && e.limit !== null ? Long$2.fromValue(e.limit) : Long$2.UZERO, o.txs = ((n = e.txs) === null || n === void 0 ? void 0 : n.map((u) => TxResponse.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      totalCount: Long$2.fromString(e.total_count),
      count: Long$2.fromString(e.count),
      pageNumber: Long$2.fromString(e.page_number),
      pageTotal: Long$2.fromString(e.page_total),
      limit: Long$2.fromString(e.limit),
      txs: Array.isArray(e == null ? void 0 : e.txs) ? e.txs.map((n) => TxResponse.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.total_count = e.totalCount ? e.totalCount.toString() : void 0, n.count = e.count ? e.count.toString() : void 0, n.page_number = e.pageNumber ? e.pageNumber.toString() : void 0, n.page_total = e.pageTotal ? e.pageTotal.toString() : void 0, n.limit = e.limit ? e.limit.toString() : void 0, e.txs ? n.txs = e.txs.map((o) => o ? TxResponse.toAmino(o) : void 0) : n.txs = [], n;
  },
  fromAminoMsg(e) {
    return SearchTxsResult.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SearchTxsResult",
      value: SearchTxsResult.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SearchTxsResult.decode(e.value);
  },
  toProto(e) {
    return SearchTxsResult.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.SearchTxsResult",
      value: SearchTxsResult.encode(e).finish()
    };
  }
}, _14 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ABCIMessageLog,
  Attribute,
  GasInfo,
  MsgData,
  Result,
  SearchTxsResult,
  SimulationResponse,
  StringEvent,
  TxMsgData,
  TxResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseConfigRequest() {
  return {};
}
const ConfigRequest = {
  typeUrl: "/cosmos.base.node.v1beta1.ConfigRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConfigRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseConfigRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ConfigRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConfigRequest",
      value: ConfigRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConfigRequest.decode(e.value);
  },
  toProto(e) {
    return ConfigRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.node.v1beta1.ConfigRequest",
      value: ConfigRequest.encode(e).finish()
    };
  }
};
function createBaseConfigResponse() {
  return {
    minimumGasPrice: ""
  };
}
const ConfigResponse = {
  typeUrl: "/cosmos.base.node.v1beta1.ConfigResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.minimumGasPrice !== "" && n.uint32(10).string(e.minimumGasPrice), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConfigResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.minimumGasPrice = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseConfigResponse();
    return o.minimumGasPrice = (n = e.minimumGasPrice) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      minimumGasPrice: e.minimum_gas_price
    };
  },
  toAmino(e) {
    const n = {};
    return n.minimum_gas_price = e.minimumGasPrice, n;
  },
  fromAminoMsg(e) {
    return ConfigResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConfigResponse",
      value: ConfigResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConfigResponse.decode(e.value);
  },
  toProto(e) {
    return ConfigResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.node.v1beta1.ConfigResponse",
      value: ConfigResponse.encode(e).finish()
    };
  }
}, _15 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ConfigRequest,
  ConfigResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseAppDescriptor() {
  return {
    authn: void 0,
    chain: void 0,
    codec: void 0,
    configuration: void 0,
    queryServices: void 0,
    tx: void 0
  };
}
const AppDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.AppDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.authn !== void 0 && AuthnDescriptor.encode(e.authn, n.uint32(10).fork()).ldelim(), e.chain !== void 0 && ChainDescriptor.encode(e.chain, n.uint32(18).fork()).ldelim(), e.codec !== void 0 && CodecDescriptor.encode(e.codec, n.uint32(26).fork()).ldelim(), e.configuration !== void 0 && ConfigurationDescriptor.encode(e.configuration, n.uint32(34).fork()).ldelim(), e.queryServices !== void 0 && QueryServicesDescriptor.encode(e.queryServices, n.uint32(42).fork()).ldelim(), e.tx !== void 0 && TxDescriptor.encode(e.tx, n.uint32(50).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAppDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authn = AuthnDescriptor.decode(o, o.uint32());
          break;
        case 2:
          c.chain = ChainDescriptor.decode(o, o.uint32());
          break;
        case 3:
          c.codec = CodecDescriptor.decode(o, o.uint32());
          break;
        case 4:
          c.configuration = ConfigurationDescriptor.decode(o, o.uint32());
          break;
        case 5:
          c.queryServices = QueryServicesDescriptor.decode(o, o.uint32());
          break;
        case 6:
          c.tx = TxDescriptor.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseAppDescriptor();
    return n.authn = e.authn !== void 0 && e.authn !== null ? AuthnDescriptor.fromPartial(e.authn) : void 0, n.chain = e.chain !== void 0 && e.chain !== null ? ChainDescriptor.fromPartial(e.chain) : void 0, n.codec = e.codec !== void 0 && e.codec !== null ? CodecDescriptor.fromPartial(e.codec) : void 0, n.configuration = e.configuration !== void 0 && e.configuration !== null ? ConfigurationDescriptor.fromPartial(e.configuration) : void 0, n.queryServices = e.queryServices !== void 0 && e.queryServices !== null ? QueryServicesDescriptor.fromPartial(e.queryServices) : void 0, n.tx = e.tx !== void 0 && e.tx !== null ? TxDescriptor.fromPartial(e.tx) : void 0, n;
  },
  fromAmino(e) {
    return {
      authn: e != null && e.authn ? AuthnDescriptor.fromAmino(e.authn) : void 0,
      chain: e != null && e.chain ? ChainDescriptor.fromAmino(e.chain) : void 0,
      codec: e != null && e.codec ? CodecDescriptor.fromAmino(e.codec) : void 0,
      configuration: e != null && e.configuration ? ConfigurationDescriptor.fromAmino(e.configuration) : void 0,
      queryServices: e != null && e.query_services ? QueryServicesDescriptor.fromAmino(e.query_services) : void 0,
      tx: e != null && e.tx ? TxDescriptor.fromAmino(e.tx) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.authn = e.authn ? AuthnDescriptor.toAmino(e.authn) : void 0, n.chain = e.chain ? ChainDescriptor.toAmino(e.chain) : void 0, n.codec = e.codec ? CodecDescriptor.toAmino(e.codec) : void 0, n.configuration = e.configuration ? ConfigurationDescriptor.toAmino(e.configuration) : void 0, n.query_services = e.queryServices ? QueryServicesDescriptor.toAmino(e.queryServices) : void 0, n.tx = e.tx ? TxDescriptor.toAmino(e.tx) : void 0, n;
  },
  fromAminoMsg(e) {
    return AppDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/AppDescriptor",
      value: AppDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AppDescriptor.decode(e.value);
  },
  toProto(e) {
    return AppDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.AppDescriptor",
      value: AppDescriptor.encode(e).finish()
    };
  }
};
function createBaseTxDescriptor() {
  return {
    fullname: "",
    msgs: []
  };
}
const TxDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.TxDescriptor",
  encode(e, n = minimal.Writer.create()) {
    e.fullname !== "" && n.uint32(10).string(e.fullname);
    for (const o of e.msgs)
      MsgDescriptor.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTxDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.fullname = o.string();
          break;
        case 2:
          c.msgs.push(MsgDescriptor.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseTxDescriptor();
    return u.fullname = (n = e.fullname) !== null && n !== void 0 ? n : "", u.msgs = ((o = e.msgs) === null || o === void 0 ? void 0 : o.map((c) => MsgDescriptor.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      fullname: e.fullname,
      msgs: Array.isArray(e == null ? void 0 : e.msgs) ? e.msgs.map((n) => MsgDescriptor.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.fullname = e.fullname, e.msgs ? n.msgs = e.msgs.map((o) => o ? MsgDescriptor.toAmino(o) : void 0) : n.msgs = [], n;
  },
  fromAminoMsg(e) {
    return TxDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TxDescriptor",
      value: TxDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TxDescriptor.decode(e.value);
  },
  toProto(e) {
    return TxDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.TxDescriptor",
      value: TxDescriptor.encode(e).finish()
    };
  }
};
function createBaseAuthnDescriptor() {
  return {
    signModes: []
  };
}
const AuthnDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.AuthnDescriptor",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.signModes)
      SigningModeDescriptor.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAuthnDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signModes.push(SigningModeDescriptor.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAuthnDescriptor();
    return o.signModes = ((n = e.signModes) === null || n === void 0 ? void 0 : n.map((u) => SigningModeDescriptor.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      signModes: Array.isArray(e == null ? void 0 : e.sign_modes) ? e.sign_modes.map((n) => SigningModeDescriptor.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.signModes ? n.sign_modes = e.signModes.map((o) => o ? SigningModeDescriptor.toAmino(o) : void 0) : n.sign_modes = [], n;
  },
  fromAminoMsg(e) {
    return AuthnDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/AuthnDescriptor",
      value: AuthnDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AuthnDescriptor.decode(e.value);
  },
  toProto(e) {
    return AuthnDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.AuthnDescriptor",
      value: AuthnDescriptor.encode(e).finish()
    };
  }
};
function createBaseSigningModeDescriptor() {
  return {
    name: "",
    number: 0,
    authnInfoProviderMethodFullname: ""
  };
}
const SigningModeDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.SigningModeDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.number !== 0 && n.uint32(16).int32(e.number), e.authnInfoProviderMethodFullname !== "" && n.uint32(26).string(e.authnInfoProviderMethodFullname), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSigningModeDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.number = o.int32();
          break;
        case 3:
          c.authnInfoProviderMethodFullname = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSigningModeDescriptor();
    return c.name = (n = e.name) !== null && n !== void 0 ? n : "", c.number = (o = e.number) !== null && o !== void 0 ? o : 0, c.authnInfoProviderMethodFullname = (u = e.authnInfoProviderMethodFullname) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      name: e.name,
      number: e.number,
      authnInfoProviderMethodFullname: e.authn_info_provider_method_fullname
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.number = e.number, n.authn_info_provider_method_fullname = e.authnInfoProviderMethodFullname, n;
  },
  fromAminoMsg(e) {
    return SigningModeDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SigningModeDescriptor",
      value: SigningModeDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SigningModeDescriptor.decode(e.value);
  },
  toProto(e) {
    return SigningModeDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.SigningModeDescriptor",
      value: SigningModeDescriptor.encode(e).finish()
    };
  }
};
function createBaseChainDescriptor() {
  return {
    id: ""
  };
}
const ChainDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.ChainDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.id !== "" && n.uint32(10).string(e.id), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseChainDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.id = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseChainDescriptor();
    return o.id = (n = e.id) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      id: e.id
    };
  },
  toAmino(e) {
    const n = {};
    return n.id = e.id, n;
  },
  fromAminoMsg(e) {
    return ChainDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ChainDescriptor",
      value: ChainDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ChainDescriptor.decode(e.value);
  },
  toProto(e) {
    return ChainDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.ChainDescriptor",
      value: ChainDescriptor.encode(e).finish()
    };
  }
};
function createBaseCodecDescriptor() {
  return {
    interfaces: []
  };
}
const CodecDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.CodecDescriptor",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.interfaces)
      InterfaceDescriptor$1.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCodecDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.interfaces.push(InterfaceDescriptor$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseCodecDescriptor();
    return o.interfaces = ((n = e.interfaces) === null || n === void 0 ? void 0 : n.map((u) => InterfaceDescriptor$1.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      interfaces: Array.isArray(e == null ? void 0 : e.interfaces) ? e.interfaces.map((n) => InterfaceDescriptor$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.interfaces ? n.interfaces = e.interfaces.map((o) => o ? InterfaceDescriptor$1.toAmino(o) : void 0) : n.interfaces = [], n;
  },
  fromAminoMsg(e) {
    return CodecDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CodecDescriptor",
      value: CodecDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CodecDescriptor.decode(e.value);
  },
  toProto(e) {
    return CodecDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.CodecDescriptor",
      value: CodecDescriptor.encode(e).finish()
    };
  }
};
function createBaseInterfaceDescriptor$1() {
  return {
    fullname: "",
    interfaceAcceptingMessages: [],
    interfaceImplementers: []
  };
}
const InterfaceDescriptor$1 = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceDescriptor",
  encode(e, n = minimal.Writer.create()) {
    e.fullname !== "" && n.uint32(10).string(e.fullname);
    for (const o of e.interfaceAcceptingMessages)
      InterfaceAcceptingMessageDescriptor.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.interfaceImplementers)
      InterfaceImplementerDescriptor.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInterfaceDescriptor$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.fullname = o.string();
          break;
        case 2:
          c.interfaceAcceptingMessages.push(InterfaceAcceptingMessageDescriptor.decode(o, o.uint32()));
          break;
        case 3:
          c.interfaceImplementers.push(InterfaceImplementerDescriptor.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseInterfaceDescriptor$1();
    return c.fullname = (n = e.fullname) !== null && n !== void 0 ? n : "", c.interfaceAcceptingMessages = ((o = e.interfaceAcceptingMessages) === null || o === void 0 ? void 0 : o.map((d) => InterfaceAcceptingMessageDescriptor.fromPartial(d))) || [], c.interfaceImplementers = ((u = e.interfaceImplementers) === null || u === void 0 ? void 0 : u.map((d) => InterfaceImplementerDescriptor.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      fullname: e.fullname,
      interfaceAcceptingMessages: Array.isArray(e == null ? void 0 : e.interface_accepting_messages) ? e.interface_accepting_messages.map((n) => InterfaceAcceptingMessageDescriptor.fromAmino(n)) : [],
      interfaceImplementers: Array.isArray(e == null ? void 0 : e.interface_implementers) ? e.interface_implementers.map((n) => InterfaceImplementerDescriptor.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.fullname = e.fullname, e.interfaceAcceptingMessages ? n.interface_accepting_messages = e.interfaceAcceptingMessages.map((o) => o ? InterfaceAcceptingMessageDescriptor.toAmino(o) : void 0) : n.interface_accepting_messages = [], e.interfaceImplementers ? n.interface_implementers = e.interfaceImplementers.map((o) => o ? InterfaceImplementerDescriptor.toAmino(o) : void 0) : n.interface_implementers = [], n;
  },
  fromAminoMsg(e) {
    return InterfaceDescriptor$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/InterfaceDescriptor",
      value: InterfaceDescriptor$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InterfaceDescriptor$1.decode(e.value);
  },
  toProto(e) {
    return InterfaceDescriptor$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceDescriptor",
      value: InterfaceDescriptor$1.encode(e).finish()
    };
  }
};
function createBaseInterfaceImplementerDescriptor() {
  return {
    fullname: "",
    typeUrl: ""
  };
}
const InterfaceImplementerDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceImplementerDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.fullname !== "" && n.uint32(10).string(e.fullname), e.typeUrl !== "" && n.uint32(18).string(e.typeUrl), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInterfaceImplementerDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.fullname = o.string();
          break;
        case 2:
          c.typeUrl = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseInterfaceImplementerDescriptor();
    return u.fullname = (n = e.fullname) !== null && n !== void 0 ? n : "", u.typeUrl = (o = e.typeUrl) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      fullname: e.fullname,
      typeUrl: e.type_url
    };
  },
  toAmino(e) {
    const n = {};
    return n.fullname = e.fullname, n.type_url = e.typeUrl, n;
  },
  fromAminoMsg(e) {
    return InterfaceImplementerDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/InterfaceImplementerDescriptor",
      value: InterfaceImplementerDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InterfaceImplementerDescriptor.decode(e.value);
  },
  toProto(e) {
    return InterfaceImplementerDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceImplementerDescriptor",
      value: InterfaceImplementerDescriptor.encode(e).finish()
    };
  }
};
function createBaseInterfaceAcceptingMessageDescriptor() {
  return {
    fullname: "",
    fieldDescriptorNames: []
  };
}
const InterfaceAcceptingMessageDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceAcceptingMessageDescriptor",
  encode(e, n = minimal.Writer.create()) {
    e.fullname !== "" && n.uint32(10).string(e.fullname);
    for (const o of e.fieldDescriptorNames)
      n.uint32(18).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInterfaceAcceptingMessageDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.fullname = o.string();
          break;
        case 2:
          c.fieldDescriptorNames.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseInterfaceAcceptingMessageDescriptor();
    return u.fullname = (n = e.fullname) !== null && n !== void 0 ? n : "", u.fieldDescriptorNames = ((o = e.fieldDescriptorNames) === null || o === void 0 ? void 0 : o.map((c) => c)) || [], u;
  },
  fromAmino(e) {
    return {
      fullname: e.fullname,
      fieldDescriptorNames: Array.isArray(e == null ? void 0 : e.field_descriptor_names) ? e.field_descriptor_names.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.fullname = e.fullname, e.fieldDescriptorNames ? n.field_descriptor_names = e.fieldDescriptorNames.map((o) => o) : n.field_descriptor_names = [], n;
  },
  fromAminoMsg(e) {
    return InterfaceAcceptingMessageDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/InterfaceAcceptingMessageDescriptor",
      value: InterfaceAcceptingMessageDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InterfaceAcceptingMessageDescriptor.decode(e.value);
  },
  toProto(e) {
    return InterfaceAcceptingMessageDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceAcceptingMessageDescriptor",
      value: InterfaceAcceptingMessageDescriptor.encode(e).finish()
    };
  }
};
function createBaseConfigurationDescriptor() {
  return {
    bech32AccountAddressPrefix: ""
  };
}
const ConfigurationDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.ConfigurationDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.bech32AccountAddressPrefix !== "" && n.uint32(10).string(e.bech32AccountAddressPrefix), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConfigurationDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.bech32AccountAddressPrefix = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseConfigurationDescriptor();
    return o.bech32AccountAddressPrefix = (n = e.bech32AccountAddressPrefix) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      bech32AccountAddressPrefix: e.bech32_account_address_prefix
    };
  },
  toAmino(e) {
    const n = {};
    return n.bech32_account_address_prefix = e.bech32AccountAddressPrefix, n;
  },
  fromAminoMsg(e) {
    return ConfigurationDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConfigurationDescriptor",
      value: ConfigurationDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConfigurationDescriptor.decode(e.value);
  },
  toProto(e) {
    return ConfigurationDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.ConfigurationDescriptor",
      value: ConfigurationDescriptor.encode(e).finish()
    };
  }
};
function createBaseMsgDescriptor() {
  return {
    msgTypeUrl: ""
  };
}
const MsgDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.MsgDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.msgTypeUrl !== "" && n.uint32(10).string(e.msgTypeUrl), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.msgTypeUrl = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgDescriptor();
    return o.msgTypeUrl = (n = e.msgTypeUrl) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      msgTypeUrl: e.msg_type_url
    };
  },
  toAmino(e) {
    const n = {};
    return n.msg_type_url = e.msgTypeUrl, n;
  },
  fromAminoMsg(e) {
    return MsgDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgDescriptor",
      value: MsgDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDescriptor.decode(e.value);
  },
  toProto(e) {
    return MsgDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.MsgDescriptor",
      value: MsgDescriptor.encode(e).finish()
    };
  }
};
function createBaseGetAuthnDescriptorRequest() {
  return {};
}
const GetAuthnDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetAuthnDescriptorRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetAuthnDescriptorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseGetAuthnDescriptorRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return GetAuthnDescriptorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetAuthnDescriptorRequest",
      value: GetAuthnDescriptorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetAuthnDescriptorRequest.decode(e.value);
  },
  toProto(e) {
    return GetAuthnDescriptorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetAuthnDescriptorRequest",
      value: GetAuthnDescriptorRequest.encode(e).finish()
    };
  }
};
function createBaseGetAuthnDescriptorResponse() {
  return {
    authn: void 0
  };
}
const GetAuthnDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetAuthnDescriptorResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.authn !== void 0 && AuthnDescriptor.encode(e.authn, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetAuthnDescriptorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authn = AuthnDescriptor.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGetAuthnDescriptorResponse();
    return n.authn = e.authn !== void 0 && e.authn !== null ? AuthnDescriptor.fromPartial(e.authn) : void 0, n;
  },
  fromAmino(e) {
    return {
      authn: e != null && e.authn ? AuthnDescriptor.fromAmino(e.authn) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.authn = e.authn ? AuthnDescriptor.toAmino(e.authn) : void 0, n;
  },
  fromAminoMsg(e) {
    return GetAuthnDescriptorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetAuthnDescriptorResponse",
      value: GetAuthnDescriptorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetAuthnDescriptorResponse.decode(e.value);
  },
  toProto(e) {
    return GetAuthnDescriptorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetAuthnDescriptorResponse",
      value: GetAuthnDescriptorResponse.encode(e).finish()
    };
  }
};
function createBaseGetChainDescriptorRequest() {
  return {};
}
const GetChainDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetChainDescriptorRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetChainDescriptorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseGetChainDescriptorRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return GetChainDescriptorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetChainDescriptorRequest",
      value: GetChainDescriptorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetChainDescriptorRequest.decode(e.value);
  },
  toProto(e) {
    return GetChainDescriptorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetChainDescriptorRequest",
      value: GetChainDescriptorRequest.encode(e).finish()
    };
  }
};
function createBaseGetChainDescriptorResponse() {
  return {
    chain: void 0
  };
}
const GetChainDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetChainDescriptorResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.chain !== void 0 && ChainDescriptor.encode(e.chain, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetChainDescriptorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.chain = ChainDescriptor.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGetChainDescriptorResponse();
    return n.chain = e.chain !== void 0 && e.chain !== null ? ChainDescriptor.fromPartial(e.chain) : void 0, n;
  },
  fromAmino(e) {
    return {
      chain: e != null && e.chain ? ChainDescriptor.fromAmino(e.chain) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.chain = e.chain ? ChainDescriptor.toAmino(e.chain) : void 0, n;
  },
  fromAminoMsg(e) {
    return GetChainDescriptorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetChainDescriptorResponse",
      value: GetChainDescriptorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetChainDescriptorResponse.decode(e.value);
  },
  toProto(e) {
    return GetChainDescriptorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetChainDescriptorResponse",
      value: GetChainDescriptorResponse.encode(e).finish()
    };
  }
};
function createBaseGetCodecDescriptorRequest() {
  return {};
}
const GetCodecDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetCodecDescriptorRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetCodecDescriptorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseGetCodecDescriptorRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return GetCodecDescriptorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetCodecDescriptorRequest",
      value: GetCodecDescriptorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetCodecDescriptorRequest.decode(e.value);
  },
  toProto(e) {
    return GetCodecDescriptorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetCodecDescriptorRequest",
      value: GetCodecDescriptorRequest.encode(e).finish()
    };
  }
};
function createBaseGetCodecDescriptorResponse() {
  return {
    codec: void 0
  };
}
const GetCodecDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetCodecDescriptorResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.codec !== void 0 && CodecDescriptor.encode(e.codec, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetCodecDescriptorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codec = CodecDescriptor.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGetCodecDescriptorResponse();
    return n.codec = e.codec !== void 0 && e.codec !== null ? CodecDescriptor.fromPartial(e.codec) : void 0, n;
  },
  fromAmino(e) {
    return {
      codec: e != null && e.codec ? CodecDescriptor.fromAmino(e.codec) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.codec = e.codec ? CodecDescriptor.toAmino(e.codec) : void 0, n;
  },
  fromAminoMsg(e) {
    return GetCodecDescriptorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetCodecDescriptorResponse",
      value: GetCodecDescriptorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetCodecDescriptorResponse.decode(e.value);
  },
  toProto(e) {
    return GetCodecDescriptorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetCodecDescriptorResponse",
      value: GetCodecDescriptorResponse.encode(e).finish()
    };
  }
};
function createBaseGetConfigurationDescriptorRequest() {
  return {};
}
const GetConfigurationDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetConfigurationDescriptorRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetConfigurationDescriptorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseGetConfigurationDescriptorRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return GetConfigurationDescriptorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetConfigurationDescriptorRequest",
      value: GetConfigurationDescriptorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetConfigurationDescriptorRequest.decode(e.value);
  },
  toProto(e) {
    return GetConfigurationDescriptorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetConfigurationDescriptorRequest",
      value: GetConfigurationDescriptorRequest.encode(e).finish()
    };
  }
};
function createBaseGetConfigurationDescriptorResponse() {
  return {
    config: void 0
  };
}
const GetConfigurationDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetConfigurationDescriptorResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.config !== void 0 && ConfigurationDescriptor.encode(e.config, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetConfigurationDescriptorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.config = ConfigurationDescriptor.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGetConfigurationDescriptorResponse();
    return n.config = e.config !== void 0 && e.config !== null ? ConfigurationDescriptor.fromPartial(e.config) : void 0, n;
  },
  fromAmino(e) {
    return {
      config: e != null && e.config ? ConfigurationDescriptor.fromAmino(e.config) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.config = e.config ? ConfigurationDescriptor.toAmino(e.config) : void 0, n;
  },
  fromAminoMsg(e) {
    return GetConfigurationDescriptorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetConfigurationDescriptorResponse",
      value: GetConfigurationDescriptorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetConfigurationDescriptorResponse.decode(e.value);
  },
  toProto(e) {
    return GetConfigurationDescriptorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetConfigurationDescriptorResponse",
      value: GetConfigurationDescriptorResponse.encode(e).finish()
    };
  }
};
function createBaseGetQueryServicesDescriptorRequest() {
  return {};
}
const GetQueryServicesDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetQueryServicesDescriptorRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetQueryServicesDescriptorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseGetQueryServicesDescriptorRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return GetQueryServicesDescriptorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetQueryServicesDescriptorRequest",
      value: GetQueryServicesDescriptorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetQueryServicesDescriptorRequest.decode(e.value);
  },
  toProto(e) {
    return GetQueryServicesDescriptorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetQueryServicesDescriptorRequest",
      value: GetQueryServicesDescriptorRequest.encode(e).finish()
    };
  }
};
function createBaseGetQueryServicesDescriptorResponse() {
  return {
    queries: void 0
  };
}
const GetQueryServicesDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetQueryServicesDescriptorResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.queries !== void 0 && QueryServicesDescriptor.encode(e.queries, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetQueryServicesDescriptorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.queries = QueryServicesDescriptor.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGetQueryServicesDescriptorResponse();
    return n.queries = e.queries !== void 0 && e.queries !== null ? QueryServicesDescriptor.fromPartial(e.queries) : void 0, n;
  },
  fromAmino(e) {
    return {
      queries: e != null && e.queries ? QueryServicesDescriptor.fromAmino(e.queries) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.queries = e.queries ? QueryServicesDescriptor.toAmino(e.queries) : void 0, n;
  },
  fromAminoMsg(e) {
    return GetQueryServicesDescriptorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetQueryServicesDescriptorResponse",
      value: GetQueryServicesDescriptorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetQueryServicesDescriptorResponse.decode(e.value);
  },
  toProto(e) {
    return GetQueryServicesDescriptorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetQueryServicesDescriptorResponse",
      value: GetQueryServicesDescriptorResponse.encode(e).finish()
    };
  }
};
function createBaseGetTxDescriptorRequest() {
  return {};
}
const GetTxDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetTxDescriptorRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetTxDescriptorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseGetTxDescriptorRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return GetTxDescriptorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetTxDescriptorRequest",
      value: GetTxDescriptorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetTxDescriptorRequest.decode(e.value);
  },
  toProto(e) {
    return GetTxDescriptorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetTxDescriptorRequest",
      value: GetTxDescriptorRequest.encode(e).finish()
    };
  }
};
function createBaseGetTxDescriptorResponse() {
  return {
    tx: void 0
  };
}
const GetTxDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetTxDescriptorResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tx !== void 0 && TxDescriptor.encode(e.tx, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetTxDescriptorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tx = TxDescriptor.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGetTxDescriptorResponse();
    return n.tx = e.tx !== void 0 && e.tx !== null ? TxDescriptor.fromPartial(e.tx) : void 0, n;
  },
  fromAmino(e) {
    return {
      tx: e != null && e.tx ? TxDescriptor.fromAmino(e.tx) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.tx = e.tx ? TxDescriptor.toAmino(e.tx) : void 0, n;
  },
  fromAminoMsg(e) {
    return GetTxDescriptorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetTxDescriptorResponse",
      value: GetTxDescriptorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetTxDescriptorResponse.decode(e.value);
  },
  toProto(e) {
    return GetTxDescriptorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetTxDescriptorResponse",
      value: GetTxDescriptorResponse.encode(e).finish()
    };
  }
};
function createBaseQueryServicesDescriptor() {
  return {
    queryServices: []
  };
}
const QueryServicesDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.QueryServicesDescriptor",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.queryServices)
      QueryServiceDescriptor.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryServicesDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.queryServices.push(QueryServiceDescriptor.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryServicesDescriptor();
    return o.queryServices = ((n = e.queryServices) === null || n === void 0 ? void 0 : n.map((u) => QueryServiceDescriptor.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      queryServices: Array.isArray(e == null ? void 0 : e.query_services) ? e.query_services.map((n) => QueryServiceDescriptor.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.queryServices ? n.query_services = e.queryServices.map((o) => o ? QueryServiceDescriptor.toAmino(o) : void 0) : n.query_services = [], n;
  },
  fromAminoMsg(e) {
    return QueryServicesDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryServicesDescriptor",
      value: QueryServicesDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryServicesDescriptor.decode(e.value);
  },
  toProto(e) {
    return QueryServicesDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.QueryServicesDescriptor",
      value: QueryServicesDescriptor.encode(e).finish()
    };
  }
};
function createBaseQueryServiceDescriptor() {
  return {
    fullname: "",
    isModule: !1,
    methods: []
  };
}
const QueryServiceDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.QueryServiceDescriptor",
  encode(e, n = minimal.Writer.create()) {
    e.fullname !== "" && n.uint32(10).string(e.fullname), e.isModule === !0 && n.uint32(16).bool(e.isModule);
    for (const o of e.methods)
      QueryMethodDescriptor.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryServiceDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.fullname = o.string();
          break;
        case 2:
          c.isModule = o.bool();
          break;
        case 3:
          c.methods.push(QueryMethodDescriptor.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryServiceDescriptor();
    return c.fullname = (n = e.fullname) !== null && n !== void 0 ? n : "", c.isModule = (o = e.isModule) !== null && o !== void 0 ? o : !1, c.methods = ((u = e.methods) === null || u === void 0 ? void 0 : u.map((d) => QueryMethodDescriptor.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      fullname: e.fullname,
      isModule: e.is_module,
      methods: Array.isArray(e == null ? void 0 : e.methods) ? e.methods.map((n) => QueryMethodDescriptor.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.fullname = e.fullname, n.is_module = e.isModule, e.methods ? n.methods = e.methods.map((o) => o ? QueryMethodDescriptor.toAmino(o) : void 0) : n.methods = [], n;
  },
  fromAminoMsg(e) {
    return QueryServiceDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryServiceDescriptor",
      value: QueryServiceDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryServiceDescriptor.decode(e.value);
  },
  toProto(e) {
    return QueryServiceDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.QueryServiceDescriptor",
      value: QueryServiceDescriptor.encode(e).finish()
    };
  }
};
function createBaseQueryMethodDescriptor() {
  return {
    name: "",
    fullQueryPath: ""
  };
}
const QueryMethodDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.QueryMethodDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.fullQueryPath !== "" && n.uint32(18).string(e.fullQueryPath), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryMethodDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.fullQueryPath = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryMethodDescriptor();
    return u.name = (n = e.name) !== null && n !== void 0 ? n : "", u.fullQueryPath = (o = e.fullQueryPath) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      name: e.name,
      fullQueryPath: e.full_query_path
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.full_query_path = e.fullQueryPath, n;
  },
  fromAminoMsg(e) {
    return QueryMethodDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryMethodDescriptor",
      value: QueryMethodDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryMethodDescriptor.decode(e.value);
  },
  toProto(e) {
    return QueryMethodDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.QueryMethodDescriptor",
      value: QueryMethodDescriptor.encode(e).finish()
    };
  }
}, _17 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppDescriptor,
  AuthnDescriptor,
  ChainDescriptor,
  CodecDescriptor,
  ConfigurationDescriptor,
  GetAuthnDescriptorRequest,
  GetAuthnDescriptorResponse,
  GetChainDescriptorRequest,
  GetChainDescriptorResponse,
  GetCodecDescriptorRequest,
  GetCodecDescriptorResponse,
  GetConfigurationDescriptorRequest,
  GetConfigurationDescriptorResponse,
  GetQueryServicesDescriptorRequest,
  GetQueryServicesDescriptorResponse,
  GetTxDescriptorRequest,
  GetTxDescriptorResponse,
  InterfaceAcceptingMessageDescriptor,
  InterfaceDescriptor: InterfaceDescriptor$1,
  InterfaceImplementerDescriptor,
  MsgDescriptor,
  QueryMethodDescriptor,
  QueryServiceDescriptor,
  QueryServicesDescriptor,
  SigningModeDescriptor,
  TxDescriptor
}, Symbol.toStringTag, { value: "Module" }));
function createBasePubKey$2() {
  return {
    key: new Uint8Array()
  };
}
const PubKey$2 = {
  typeUrl: "/cosmos.crypto.ed25519.PubKey",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePubKey$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePubKey$2();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      key: e.key
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n;
  },
  fromAminoMsg(e) {
    return PubKey$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "tendermint/PubKeyEd25519",
      value: PubKey$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PubKey$2.decode(e.value);
  },
  toProto(e) {
    return PubKey$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.ed25519.PubKey",
      value: PubKey$2.encode(e).finish()
    };
  }
};
function createBasePrivKey$2() {
  return {
    key: new Uint8Array()
  };
}
const PrivKey$2 = {
  typeUrl: "/cosmos.crypto.ed25519.PrivKey",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePrivKey$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePrivKey$2();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      key: e.key
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n;
  },
  fromAminoMsg(e) {
    return PrivKey$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "tendermint/PrivKeyEd25519",
      value: PrivKey$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PrivKey$2.decode(e.value);
  },
  toProto(e) {
    return PrivKey$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.ed25519.PrivKey",
      value: PrivKey$2.encode(e).finish()
    };
  }
}, _19 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PrivKey: PrivKey$2,
  PubKey: PubKey$2
}, Symbol.toStringTag, { value: "Module" }));
function createBaseLegacyAminoPubKey() {
  return {
    threshold: 0,
    publicKeys: []
  };
}
const LegacyAminoPubKey = {
  typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
  encode(e, n = minimal.Writer.create()) {
    e.threshold !== 0 && n.uint32(8).uint32(e.threshold);
    for (const o of e.publicKeys)
      Any.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLegacyAminoPubKey();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.threshold = o.uint32();
          break;
        case 2:
          c.publicKeys.push(Any.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseLegacyAminoPubKey();
    return u.threshold = (n = e.threshold) !== null && n !== void 0 ? n : 0, u.publicKeys = ((o = e.publicKeys) === null || o === void 0 ? void 0 : o.map((c) => Any.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      threshold: e.threshold,
      publicKeys: Array.isArray(e == null ? void 0 : e.public_keys) ? e.public_keys.map((n) => Any.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.threshold = e.threshold, e.publicKeys ? n.public_keys = e.publicKeys.map((o) => o ? Any.toAmino(o) : void 0) : n.public_keys = [], n;
  },
  fromAminoMsg(e) {
    return LegacyAminoPubKey.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "tendermint/PubKeyMultisigThreshold",
      value: LegacyAminoPubKey.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LegacyAminoPubKey.decode(e.value);
  },
  toProto(e) {
    return LegacyAminoPubKey.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
      value: LegacyAminoPubKey.encode(e).finish()
    };
  }
}, _20 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LegacyAminoPubKey
}, Symbol.toStringTag, { value: "Module" }));
function createBasePubKey$1() {
  return {
    key: new Uint8Array()
  };
}
const PubKey$1 = {
  typeUrl: "/cosmos.crypto.secp256k1.PubKey",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePubKey$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePubKey$1();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      key: e.key
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n;
  },
  fromAminoMsg(e) {
    return PubKey$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "tendermint/PubKeySecp256k1",
      value: PubKey$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PubKey$1.decode(e.value);
  },
  toProto(e) {
    return PubKey$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: PubKey$1.encode(e).finish()
    };
  }
};
function createBasePrivKey$1() {
  return {
    key: new Uint8Array()
  };
}
const PrivKey$1 = {
  typeUrl: "/cosmos.crypto.secp256k1.PrivKey",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePrivKey$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePrivKey$1();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      key: e.key
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n;
  },
  fromAminoMsg(e) {
    return PrivKey$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "tendermint/PrivKeySecp256k1",
      value: PrivKey$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PrivKey$1.decode(e.value);
  },
  toProto(e) {
    return PrivKey$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.secp256k1.PrivKey",
      value: PrivKey$1.encode(e).finish()
    };
  }
}, _21 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PrivKey: PrivKey$1,
  PubKey: PubKey$1
}, Symbol.toStringTag, { value: "Module" }));
function createBasePubKey() {
  return {
    key: new Uint8Array()
  };
}
const PubKey = {
  typeUrl: "/cosmos.crypto.secp256r1.PubKey",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePubKey();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePubKey();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      key: e.key
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n;
  },
  fromAminoMsg(e) {
    return PubKey.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PubKey",
      value: PubKey.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PubKey.decode(e.value);
  },
  toProto(e) {
    return PubKey.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.secp256r1.PubKey",
      value: PubKey.encode(e).finish()
    };
  }
};
function createBasePrivKey() {
  return {
    secret: new Uint8Array()
  };
}
const PrivKey = {
  typeUrl: "/cosmos.crypto.secp256r1.PrivKey",
  encode(e, n = minimal.Writer.create()) {
    return e.secret.length !== 0 && n.uint32(10).bytes(e.secret), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePrivKey();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.secret = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePrivKey();
    return o.secret = (n = e.secret) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      secret: e.secret
    };
  },
  toAmino(e) {
    const n = {};
    return n.secret = e.secret, n;
  },
  fromAminoMsg(e) {
    return PrivKey.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PrivKey",
      value: PrivKey.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PrivKey.decode(e.value);
  },
  toProto(e) {
    return PrivKey.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.secp256r1.PrivKey",
      value: PrivKey.encode(e).finish()
    };
  }
}, _22 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PrivKey,
  PubKey
}, Symbol.toStringTag, { value: "Module" }));
function createBaseBIP44Params() {
  return {
    purpose: 0,
    coinType: 0,
    account: 0,
    change: !1,
    addressIndex: 0
  };
}
const BIP44Params = {
  typeUrl: "/cosmos.crypto.hd.v1.BIP44Params",
  encode(e, n = minimal.Writer.create()) {
    return e.purpose !== 0 && n.uint32(8).uint32(e.purpose), e.coinType !== 0 && n.uint32(16).uint32(e.coinType), e.account !== 0 && n.uint32(24).uint32(e.account), e.change === !0 && n.uint32(32).bool(e.change), e.addressIndex !== 0 && n.uint32(40).uint32(e.addressIndex), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBIP44Params();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.purpose = o.uint32();
          break;
        case 2:
          c.coinType = o.uint32();
          break;
        case 3:
          c.account = o.uint32();
          break;
        case 4:
          c.change = o.bool();
          break;
        case 5:
          c.addressIndex = o.uint32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseBIP44Params();
    return m.purpose = (n = e.purpose) !== null && n !== void 0 ? n : 0, m.coinType = (o = e.coinType) !== null && o !== void 0 ? o : 0, m.account = (u = e.account) !== null && u !== void 0 ? u : 0, m.change = (c = e.change) !== null && c !== void 0 ? c : !1, m.addressIndex = (d = e.addressIndex) !== null && d !== void 0 ? d : 0, m;
  },
  fromAmino(e) {
    return {
      purpose: e.purpose,
      coinType: e.coin_type,
      account: e.account,
      change: e.change,
      addressIndex: e.address_index
    };
  },
  toAmino(e) {
    const n = {};
    return n.purpose = e.purpose, n.coin_type = e.coinType, n.account = e.account, n.change = e.change, n.address_index = e.addressIndex, n;
  },
  fromAminoMsg(e) {
    return BIP44Params.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/BIP44Params",
      value: BIP44Params.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return BIP44Params.decode(e.value);
  },
  toProto(e) {
    return BIP44Params.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.hd.v1.BIP44Params",
      value: BIP44Params.encode(e).finish()
    };
  }
}, _23 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BIP44Params
}, Symbol.toStringTag, { value: "Module" }));
function createBaseRecord$1() {
  return {
    name: "",
    pubKey: void 0,
    local: void 0,
    ledger: void 0,
    multi: void 0,
    offline: void 0
  };
}
const Record$1 = {
  typeUrl: "/cosmos.crypto.keyring.v1.Record",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.pubKey !== void 0 && Any.encode(e.pubKey, n.uint32(18).fork()).ldelim(), e.local !== void 0 && Record_Local.encode(e.local, n.uint32(26).fork()).ldelim(), e.ledger !== void 0 && Record_Ledger.encode(e.ledger, n.uint32(34).fork()).ldelim(), e.multi !== void 0 && Record_Multi.encode(e.multi, n.uint32(42).fork()).ldelim(), e.offline !== void 0 && Record_Offline.encode(e.offline, n.uint32(50).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRecord$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.pubKey = Any.decode(o, o.uint32());
          break;
        case 3:
          c.local = Record_Local.decode(o, o.uint32());
          break;
        case 4:
          c.ledger = Record_Ledger.decode(o, o.uint32());
          break;
        case 5:
          c.multi = Record_Multi.decode(o, o.uint32());
          break;
        case 6:
          c.offline = Record_Offline.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRecord$1();
    return o.name = (n = e.name) !== null && n !== void 0 ? n : "", o.pubKey = e.pubKey !== void 0 && e.pubKey !== null ? Any.fromPartial(e.pubKey) : void 0, o.local = e.local !== void 0 && e.local !== null ? Record_Local.fromPartial(e.local) : void 0, o.ledger = e.ledger !== void 0 && e.ledger !== null ? Record_Ledger.fromPartial(e.ledger) : void 0, o.multi = e.multi !== void 0 && e.multi !== null ? Record_Multi.fromPartial(e.multi) : void 0, o.offline = e.offline !== void 0 && e.offline !== null ? Record_Offline.fromPartial(e.offline) : void 0, o;
  },
  fromAmino(e) {
    return {
      name: e.name,
      pubKey: e != null && e.pub_key ? Any.fromAmino(e.pub_key) : void 0,
      local: e != null && e.local ? Record_Local.fromAmino(e.local) : void 0,
      ledger: e != null && e.ledger ? Record_Ledger.fromAmino(e.ledger) : void 0,
      multi: e != null && e.multi ? Record_Multi.fromAmino(e.multi) : void 0,
      offline: e != null && e.offline ? Record_Offline.fromAmino(e.offline) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.pub_key = e.pubKey ? Any.toAmino(e.pubKey) : void 0, n.local = e.local ? Record_Local.toAmino(e.local) : void 0, n.ledger = e.ledger ? Record_Ledger.toAmino(e.ledger) : void 0, n.multi = e.multi ? Record_Multi.toAmino(e.multi) : void 0, n.offline = e.offline ? Record_Offline.toAmino(e.offline) : void 0, n;
  },
  fromAminoMsg(e) {
    return Record$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Record",
      value: Record$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Record$1.decode(e.value);
  },
  toProto(e) {
    return Record$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.keyring.v1.Record",
      value: Record$1.encode(e).finish()
    };
  }
};
function createBaseRecord_Local() {
  return {
    privKey: void 0,
    privKeyType: ""
  };
}
const Record_Local = {
  typeUrl: "/cosmos.crypto.keyring.v1.Local",
  encode(e, n = minimal.Writer.create()) {
    return e.privKey !== void 0 && Any.encode(e.privKey, n.uint32(10).fork()).ldelim(), e.privKeyType !== "" && n.uint32(18).string(e.privKeyType), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRecord_Local();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.privKey = Any.decode(o, o.uint32());
          break;
        case 2:
          c.privKeyType = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRecord_Local();
    return o.privKey = e.privKey !== void 0 && e.privKey !== null ? Any.fromPartial(e.privKey) : void 0, o.privKeyType = (n = e.privKeyType) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      privKey: e != null && e.priv_key ? Any.fromAmino(e.priv_key) : void 0,
      privKeyType: e.priv_key_type
    };
  },
  toAmino(e) {
    const n = {};
    return n.priv_key = e.privKey ? Any.toAmino(e.privKey) : void 0, n.priv_key_type = e.privKeyType, n;
  },
  fromAminoMsg(e) {
    return Record_Local.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Local",
      value: Record_Local.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Record_Local.decode(e.value);
  },
  toProto(e) {
    return Record_Local.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.keyring.v1.Local",
      value: Record_Local.encode(e).finish()
    };
  }
};
function createBaseRecord_Ledger() {
  return {
    path: void 0
  };
}
const Record_Ledger = {
  typeUrl: "/cosmos.crypto.keyring.v1.Ledger",
  encode(e, n = minimal.Writer.create()) {
    return e.path !== void 0 && BIP44Params.encode(e.path, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRecord_Ledger();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = BIP44Params.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseRecord_Ledger();
    return n.path = e.path !== void 0 && e.path !== null ? BIP44Params.fromPartial(e.path) : void 0, n;
  },
  fromAmino(e) {
    return {
      path: e != null && e.path ? BIP44Params.fromAmino(e.path) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path ? BIP44Params.toAmino(e.path) : void 0, n;
  },
  fromAminoMsg(e) {
    return Record_Ledger.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Ledger",
      value: Record_Ledger.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Record_Ledger.decode(e.value);
  },
  toProto(e) {
    return Record_Ledger.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.keyring.v1.Ledger",
      value: Record_Ledger.encode(e).finish()
    };
  }
};
function createBaseRecord_Multi() {
  return {};
}
const Record_Multi = {
  typeUrl: "/cosmos.crypto.keyring.v1.Multi",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRecord_Multi();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseRecord_Multi();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return Record_Multi.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Multi",
      value: Record_Multi.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Record_Multi.decode(e.value);
  },
  toProto(e) {
    return Record_Multi.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.keyring.v1.Multi",
      value: Record_Multi.encode(e).finish()
    };
  }
};
function createBaseRecord_Offline() {
  return {};
}
const Record_Offline = {
  typeUrl: "/cosmos.crypto.keyring.v1.Offline",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRecord_Offline();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseRecord_Offline();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return Record_Offline.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Offline",
      value: Record_Offline.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Record_Offline.decode(e.value);
  },
  toProto(e) {
    return Record_Offline.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.keyring.v1.Offline",
      value: Record_Offline.encode(e).finish()
    };
  }
}, _24 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Record: Record$1,
  Record_Ledger,
  Record_Local,
  Record_Multi,
  Record_Offline
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$k() {
  return {
    communityTax: "",
    baseProposerReward: "",
    bonusProposerReward: "",
    withdrawAddrEnabled: !1
  };
}
const Params$l = {
  typeUrl: "/cosmos.distribution.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.communityTax !== "" && n.uint32(10).string(e.communityTax), e.baseProposerReward !== "" && n.uint32(18).string(e.baseProposerReward), e.bonusProposerReward !== "" && n.uint32(26).string(e.bonusProposerReward), e.withdrawAddrEnabled === !0 && n.uint32(32).bool(e.withdrawAddrEnabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$k();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.communityTax = o.string();
          break;
        case 2:
          c.baseProposerReward = o.string();
          break;
        case 3:
          c.bonusProposerReward = o.string();
          break;
        case 4:
          c.withdrawAddrEnabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseParams$k();
    return d.communityTax = (n = e.communityTax) !== null && n !== void 0 ? n : "", d.baseProposerReward = (o = e.baseProposerReward) !== null && o !== void 0 ? o : "", d.bonusProposerReward = (u = e.bonusProposerReward) !== null && u !== void 0 ? u : "", d.withdrawAddrEnabled = (c = e.withdrawAddrEnabled) !== null && c !== void 0 ? c : !1, d;
  },
  fromAmino(e) {
    return {
      communityTax: e.community_tax,
      baseProposerReward: e.base_proposer_reward,
      bonusProposerReward: e.bonus_proposer_reward,
      withdrawAddrEnabled: e.withdraw_addr_enabled
    };
  },
  toAmino(e) {
    const n = {};
    return n.community_tax = e.communityTax, n.base_proposer_reward = e.baseProposerReward, n.bonus_proposer_reward = e.bonusProposerReward, n.withdraw_addr_enabled = e.withdrawAddrEnabled, n;
  },
  fromAminoMsg(e) {
    return Params$l.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/x/distribution/Params",
      value: Params$l.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$l.decode(e.value);
  },
  toProto(e) {
    return Params$l.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.Params",
      value: Params$l.encode(e).finish()
    };
  }
};
function createBaseValidatorHistoricalRewards() {
  return {
    cumulativeRewardRatio: [],
    referenceCount: 0
  };
}
const ValidatorHistoricalRewards = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewards",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.cumulativeRewardRatio)
      DecCoin.encode(o, n.uint32(10).fork()).ldelim();
    return e.referenceCount !== 0 && n.uint32(16).uint32(e.referenceCount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorHistoricalRewards();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.cumulativeRewardRatio.push(DecCoin.decode(o, o.uint32()));
          break;
        case 2:
          c.referenceCount = o.uint32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseValidatorHistoricalRewards();
    return u.cumulativeRewardRatio = ((n = e.cumulativeRewardRatio) === null || n === void 0 ? void 0 : n.map((c) => DecCoin.fromPartial(c))) || [], u.referenceCount = (o = e.referenceCount) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      cumulativeRewardRatio: Array.isArray(e == null ? void 0 : e.cumulative_reward_ratio) ? e.cumulative_reward_ratio.map((n) => DecCoin.fromAmino(n)) : [],
      referenceCount: e.reference_count
    };
  },
  toAmino(e) {
    const n = {};
    return e.cumulativeRewardRatio ? n.cumulative_reward_ratio = e.cumulativeRewardRatio.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.cumulative_reward_ratio = [], n.reference_count = e.referenceCount, n;
  },
  fromAminoMsg(e) {
    return ValidatorHistoricalRewards.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorHistoricalRewards",
      value: ValidatorHistoricalRewards.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorHistoricalRewards.decode(e.value);
  },
  toProto(e) {
    return ValidatorHistoricalRewards.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewards",
      value: ValidatorHistoricalRewards.encode(e).finish()
    };
  }
};
function createBaseValidatorCurrentRewards() {
  return {
    rewards: [],
    period: Long$2.UZERO
  };
}
const ValidatorCurrentRewards = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewards",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.rewards)
      DecCoin.encode(o, n.uint32(10).fork()).ldelim();
    return e.period.isZero() || n.uint32(16).uint64(e.period), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorCurrentRewards();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.rewards.push(DecCoin.decode(o, o.uint32()));
          break;
        case 2:
          c.period = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorCurrentRewards();
    return o.rewards = ((n = e.rewards) === null || n === void 0 ? void 0 : n.map((u) => DecCoin.fromPartial(u))) || [], o.period = e.period !== void 0 && e.period !== null ? Long$2.fromValue(e.period) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      rewards: Array.isArray(e == null ? void 0 : e.rewards) ? e.rewards.map((n) => DecCoin.fromAmino(n)) : [],
      period: Long$2.fromString(e.period)
    };
  },
  toAmino(e) {
    const n = {};
    return e.rewards ? n.rewards = e.rewards.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.rewards = [], n.period = e.period ? e.period.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ValidatorCurrentRewards.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorCurrentRewards",
      value: ValidatorCurrentRewards.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorCurrentRewards.decode(e.value);
  },
  toProto(e) {
    return ValidatorCurrentRewards.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewards",
      value: ValidatorCurrentRewards.encode(e).finish()
    };
  }
};
function createBaseValidatorAccumulatedCommission() {
  return {
    commission: []
  };
}
const ValidatorAccumulatedCommission = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommission",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.commission)
      DecCoin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorAccumulatedCommission();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.commission.push(DecCoin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorAccumulatedCommission();
    return o.commission = ((n = e.commission) === null || n === void 0 ? void 0 : n.map((u) => DecCoin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      commission: Array.isArray(e == null ? void 0 : e.commission) ? e.commission.map((n) => DecCoin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.commission ? n.commission = e.commission.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.commission = [], n;
  },
  fromAminoMsg(e) {
    return ValidatorAccumulatedCommission.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorAccumulatedCommission",
      value: ValidatorAccumulatedCommission.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorAccumulatedCommission.decode(e.value);
  },
  toProto(e) {
    return ValidatorAccumulatedCommission.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommission",
      value: ValidatorAccumulatedCommission.encode(e).finish()
    };
  }
};
function createBaseValidatorOutstandingRewards() {
  return {
    rewards: []
  };
}
const ValidatorOutstandingRewards = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewards",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.rewards)
      DecCoin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorOutstandingRewards();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.rewards.push(DecCoin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorOutstandingRewards();
    return o.rewards = ((n = e.rewards) === null || n === void 0 ? void 0 : n.map((u) => DecCoin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      rewards: Array.isArray(e == null ? void 0 : e.rewards) ? e.rewards.map((n) => DecCoin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.rewards ? n.rewards = e.rewards.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.rewards = [], n;
  },
  fromAminoMsg(e) {
    return ValidatorOutstandingRewards.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorOutstandingRewards",
      value: ValidatorOutstandingRewards.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorOutstandingRewards.decode(e.value);
  },
  toProto(e) {
    return ValidatorOutstandingRewards.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewards",
      value: ValidatorOutstandingRewards.encode(e).finish()
    };
  }
};
function createBaseValidatorSlashEvent() {
  return {
    validatorPeriod: Long$2.UZERO,
    fraction: ""
  };
}
const ValidatorSlashEvent = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvent",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorPeriod.isZero() || n.uint32(8).uint64(e.validatorPeriod), e.fraction !== "" && n.uint32(18).string(e.fraction), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorSlashEvent();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorPeriod = o.uint64();
          break;
        case 2:
          c.fraction = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorSlashEvent();
    return o.validatorPeriod = e.validatorPeriod !== void 0 && e.validatorPeriod !== null ? Long$2.fromValue(e.validatorPeriod) : Long$2.UZERO, o.fraction = (n = e.fraction) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      validatorPeriod: Long$2.fromString(e.validator_period),
      fraction: e.fraction
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_period = e.validatorPeriod ? e.validatorPeriod.toString() : void 0, n.fraction = e.fraction, n;
  },
  fromAminoMsg(e) {
    return ValidatorSlashEvent.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorSlashEvent",
      value: ValidatorSlashEvent.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorSlashEvent.decode(e.value);
  },
  toProto(e) {
    return ValidatorSlashEvent.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvent",
      value: ValidatorSlashEvent.encode(e).finish()
    };
  }
};
function createBaseValidatorSlashEvents() {
  return {
    validatorSlashEvents: []
  };
}
const ValidatorSlashEvents = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvents",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.validatorSlashEvents)
      ValidatorSlashEvent.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorSlashEvents();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorSlashEvents.push(ValidatorSlashEvent.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorSlashEvents();
    return o.validatorSlashEvents = ((n = e.validatorSlashEvents) === null || n === void 0 ? void 0 : n.map((u) => ValidatorSlashEvent.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      validatorSlashEvents: Array.isArray(e == null ? void 0 : e.validator_slash_events) ? e.validator_slash_events.map((n) => ValidatorSlashEvent.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.validatorSlashEvents ? n.validator_slash_events = e.validatorSlashEvents.map((o) => o ? ValidatorSlashEvent.toAmino(o) : void 0) : n.validator_slash_events = [], n;
  },
  fromAminoMsg(e) {
    return ValidatorSlashEvents.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorSlashEvents",
      value: ValidatorSlashEvents.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorSlashEvents.decode(e.value);
  },
  toProto(e) {
    return ValidatorSlashEvents.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvents",
      value: ValidatorSlashEvents.encode(e).finish()
    };
  }
};
function createBaseFeePool() {
  return {
    communityPool: []
  };
}
const FeePool = {
  typeUrl: "/cosmos.distribution.v1beta1.FeePool",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.communityPool)
      DecCoin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFeePool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.communityPool.push(DecCoin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseFeePool();
    return o.communityPool = ((n = e.communityPool) === null || n === void 0 ? void 0 : n.map((u) => DecCoin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      communityPool: Array.isArray(e == null ? void 0 : e.community_pool) ? e.community_pool.map((n) => DecCoin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.communityPool ? n.community_pool = e.communityPool.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.community_pool = [], n;
  },
  fromAminoMsg(e) {
    return FeePool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/FeePool",
      value: FeePool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return FeePool.decode(e.value);
  },
  toProto(e) {
    return FeePool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.FeePool",
      value: FeePool.encode(e).finish()
    };
  }
};
function createBaseCommunityPoolSpendProposal() {
  return {
    title: "",
    description: "",
    recipient: "",
    amount: []
  };
}
const CommunityPoolSpendProposal = {
  typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.recipient !== "" && n.uint32(26).string(e.recipient);
    for (const o of e.amount)
      Coin.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommunityPoolSpendProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.recipient = o.string();
          break;
        case 4:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseCommunityPoolSpendProposal();
    return d.title = (n = e.title) !== null && n !== void 0 ? n : "", d.description = (o = e.description) !== null && o !== void 0 ? o : "", d.recipient = (u = e.recipient) !== null && u !== void 0 ? u : "", d.amount = ((c = e.amount) === null || c === void 0 ? void 0 : c.map((m) => Coin.fromPartial(m))) || [], d;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      recipient: e.recipient,
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.recipient = e.recipient, e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n;
  },
  fromAminoMsg(e) {
    return CommunityPoolSpendProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CommunityPoolSpendProposal",
      value: CommunityPoolSpendProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CommunityPoolSpendProposal.decode(e.value);
  },
  toProto(e) {
    return CommunityPoolSpendProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
      value: CommunityPoolSpendProposal.encode(e).finish()
    };
  }
};
function createBaseDelegatorStartingInfo() {
  return {
    previousPeriod: Long$2.UZERO,
    stake: "",
    height: Long$2.UZERO
  };
}
const DelegatorStartingInfo = {
  typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.previousPeriod.isZero() || n.uint32(8).uint64(e.previousPeriod), e.stake !== "" && n.uint32(18).string(e.stake), e.height.isZero() || n.uint32(24).uint64(e.height), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDelegatorStartingInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.previousPeriod = o.uint64();
          break;
        case 2:
          c.stake = o.string();
          break;
        case 3:
          c.height = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDelegatorStartingInfo();
    return o.previousPeriod = e.previousPeriod !== void 0 && e.previousPeriod !== null ? Long$2.fromValue(e.previousPeriod) : Long$2.UZERO, o.stake = (n = e.stake) !== null && n !== void 0 ? n : "", o.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      previousPeriod: Long$2.fromString(e.previous_period),
      stake: e.stake,
      height: Long$2.fromString(e.height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.previous_period = e.previousPeriod ? e.previousPeriod.toString() : void 0, n.stake = e.stake, n.height = e.height ? e.height.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return DelegatorStartingInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DelegatorStartingInfo",
      value: DelegatorStartingInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DelegatorStartingInfo.decode(e.value);
  },
  toProto(e) {
    return DelegatorStartingInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfo",
      value: DelegatorStartingInfo.encode(e).finish()
    };
  }
};
function createBaseDelegationDelegatorReward() {
  return {
    validatorAddress: "",
    reward: []
  };
}
const DelegationDelegatorReward = {
  typeUrl: "/cosmos.distribution.v1beta1.DelegationDelegatorReward",
  encode(e, n = minimal.Writer.create()) {
    e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress);
    for (const o of e.reward)
      DecCoin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDelegationDelegatorReward();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.reward.push(DecCoin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDelegationDelegatorReward();
    return u.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", u.reward = ((o = e.reward) === null || o === void 0 ? void 0 : o.map((c) => DecCoin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      reward: Array.isArray(e == null ? void 0 : e.reward) ? e.reward.map((n) => DecCoin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, e.reward ? n.reward = e.reward.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.reward = [], n;
  },
  fromAminoMsg(e) {
    return DelegationDelegatorReward.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DelegationDelegatorReward",
      value: DelegationDelegatorReward.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DelegationDelegatorReward.decode(e.value);
  },
  toProto(e) {
    return DelegationDelegatorReward.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.DelegationDelegatorReward",
      value: DelegationDelegatorReward.encode(e).finish()
    };
  }
};
function createBaseCommunityPoolSpendProposalWithDeposit() {
  return {
    title: "",
    description: "",
    recipient: "",
    amount: "",
    deposit: ""
  };
}
const CommunityPoolSpendProposalWithDeposit = {
  typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposalWithDeposit",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.recipient !== "" && n.uint32(26).string(e.recipient), e.amount !== "" && n.uint32(34).string(e.amount), e.deposit !== "" && n.uint32(42).string(e.deposit), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommunityPoolSpendProposalWithDeposit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.recipient = o.string();
          break;
        case 4:
          c.amount = o.string();
          break;
        case 5:
          c.deposit = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseCommunityPoolSpendProposalWithDeposit();
    return m.title = (n = e.title) !== null && n !== void 0 ? n : "", m.description = (o = e.description) !== null && o !== void 0 ? o : "", m.recipient = (u = e.recipient) !== null && u !== void 0 ? u : "", m.amount = (c = e.amount) !== null && c !== void 0 ? c : "", m.deposit = (d = e.deposit) !== null && d !== void 0 ? d : "", m;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      recipient: e.recipient,
      amount: e.amount,
      deposit: e.deposit
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.recipient = e.recipient, n.amount = e.amount, n.deposit = e.deposit, n;
  },
  fromAminoMsg(e) {
    return CommunityPoolSpendProposalWithDeposit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CommunityPoolSpendProposalWithDeposit",
      value: CommunityPoolSpendProposalWithDeposit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CommunityPoolSpendProposalWithDeposit.decode(e.value);
  },
  toProto(e) {
    return CommunityPoolSpendProposalWithDeposit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposalWithDeposit",
      value: CommunityPoolSpendProposalWithDeposit.encode(e).finish()
    };
  }
}, _25 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CommunityPoolSpendProposal,
  CommunityPoolSpendProposalWithDeposit,
  DelegationDelegatorReward,
  DelegatorStartingInfo,
  FeePool,
  Params: Params$l,
  ValidatorAccumulatedCommission,
  ValidatorCurrentRewards,
  ValidatorHistoricalRewards,
  ValidatorOutstandingRewards,
  ValidatorSlashEvent,
  ValidatorSlashEvents
}, Symbol.toStringTag, { value: "Module" }));
function createBaseDelegatorWithdrawInfo() {
  return {
    delegatorAddress: "",
    withdrawAddress: ""
  };
}
const DelegatorWithdrawInfo = {
  typeUrl: "/cosmos.distribution.v1beta1.DelegatorWithdrawInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.withdrawAddress !== "" && n.uint32(18).string(e.withdrawAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDelegatorWithdrawInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.withdrawAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDelegatorWithdrawInfo();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.withdrawAddress = (o = e.withdrawAddress) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      withdrawAddress: e.withdraw_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.withdraw_address = e.withdrawAddress, n;
  },
  fromAminoMsg(e) {
    return DelegatorWithdrawInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DelegatorWithdrawInfo",
      value: DelegatorWithdrawInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DelegatorWithdrawInfo.decode(e.value);
  },
  toProto(e) {
    return DelegatorWithdrawInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.DelegatorWithdrawInfo",
      value: DelegatorWithdrawInfo.encode(e).finish()
    };
  }
};
function createBaseValidatorOutstandingRewardsRecord() {
  return {
    validatorAddress: "",
    outstandingRewards: []
  };
}
const ValidatorOutstandingRewardsRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewardsRecord",
  encode(e, n = minimal.Writer.create()) {
    e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress);
    for (const o of e.outstandingRewards)
      DecCoin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorOutstandingRewardsRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.outstandingRewards.push(DecCoin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseValidatorOutstandingRewardsRecord();
    return u.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", u.outstandingRewards = ((o = e.outstandingRewards) === null || o === void 0 ? void 0 : o.map((c) => DecCoin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      outstandingRewards: Array.isArray(e == null ? void 0 : e.outstanding_rewards) ? e.outstanding_rewards.map((n) => DecCoin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, e.outstandingRewards ? n.outstanding_rewards = e.outstandingRewards.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.outstanding_rewards = [], n;
  },
  fromAminoMsg(e) {
    return ValidatorOutstandingRewardsRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorOutstandingRewardsRecord",
      value: ValidatorOutstandingRewardsRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorOutstandingRewardsRecord.decode(e.value);
  },
  toProto(e) {
    return ValidatorOutstandingRewardsRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewardsRecord",
      value: ValidatorOutstandingRewardsRecord.encode(e).finish()
    };
  }
};
function createBaseValidatorAccumulatedCommissionRecord() {
  return {
    validatorAddress: "",
    accumulated: void 0
  };
}
const ValidatorAccumulatedCommissionRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommissionRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), e.accumulated !== void 0 && ValidatorAccumulatedCommission.encode(e.accumulated, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorAccumulatedCommissionRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.accumulated = ValidatorAccumulatedCommission.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorAccumulatedCommissionRecord();
    return o.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", o.accumulated = e.accumulated !== void 0 && e.accumulated !== null ? ValidatorAccumulatedCommission.fromPartial(e.accumulated) : void 0, o;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      accumulated: e != null && e.accumulated ? ValidatorAccumulatedCommission.fromAmino(e.accumulated) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n.accumulated = e.accumulated ? ValidatorAccumulatedCommission.toAmino(e.accumulated) : void 0, n;
  },
  fromAminoMsg(e) {
    return ValidatorAccumulatedCommissionRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorAccumulatedCommissionRecord",
      value: ValidatorAccumulatedCommissionRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorAccumulatedCommissionRecord.decode(e.value);
  },
  toProto(e) {
    return ValidatorAccumulatedCommissionRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommissionRecord",
      value: ValidatorAccumulatedCommissionRecord.encode(e).finish()
    };
  }
};
function createBaseValidatorHistoricalRewardsRecord() {
  return {
    validatorAddress: "",
    period: Long$2.UZERO,
    rewards: void 0
  };
}
const ValidatorHistoricalRewardsRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewardsRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), e.period.isZero() || n.uint32(16).uint64(e.period), e.rewards !== void 0 && ValidatorHistoricalRewards.encode(e.rewards, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorHistoricalRewardsRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.period = o.uint64();
          break;
        case 3:
          c.rewards = ValidatorHistoricalRewards.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorHistoricalRewardsRecord();
    return o.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", o.period = e.period !== void 0 && e.period !== null ? Long$2.fromValue(e.period) : Long$2.UZERO, o.rewards = e.rewards !== void 0 && e.rewards !== null ? ValidatorHistoricalRewards.fromPartial(e.rewards) : void 0, o;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      period: Long$2.fromString(e.period),
      rewards: e != null && e.rewards ? ValidatorHistoricalRewards.fromAmino(e.rewards) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n.period = e.period ? e.period.toString() : void 0, n.rewards = e.rewards ? ValidatorHistoricalRewards.toAmino(e.rewards) : void 0, n;
  },
  fromAminoMsg(e) {
    return ValidatorHistoricalRewardsRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorHistoricalRewardsRecord",
      value: ValidatorHistoricalRewardsRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorHistoricalRewardsRecord.decode(e.value);
  },
  toProto(e) {
    return ValidatorHistoricalRewardsRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewardsRecord",
      value: ValidatorHistoricalRewardsRecord.encode(e).finish()
    };
  }
};
function createBaseValidatorCurrentRewardsRecord() {
  return {
    validatorAddress: "",
    rewards: void 0
  };
}
const ValidatorCurrentRewardsRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewardsRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), e.rewards !== void 0 && ValidatorCurrentRewards.encode(e.rewards, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorCurrentRewardsRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.rewards = ValidatorCurrentRewards.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorCurrentRewardsRecord();
    return o.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", o.rewards = e.rewards !== void 0 && e.rewards !== null ? ValidatorCurrentRewards.fromPartial(e.rewards) : void 0, o;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      rewards: e != null && e.rewards ? ValidatorCurrentRewards.fromAmino(e.rewards) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n.rewards = e.rewards ? ValidatorCurrentRewards.toAmino(e.rewards) : void 0, n;
  },
  fromAminoMsg(e) {
    return ValidatorCurrentRewardsRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorCurrentRewardsRecord",
      value: ValidatorCurrentRewardsRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorCurrentRewardsRecord.decode(e.value);
  },
  toProto(e) {
    return ValidatorCurrentRewardsRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewardsRecord",
      value: ValidatorCurrentRewardsRecord.encode(e).finish()
    };
  }
};
function createBaseDelegatorStartingInfoRecord() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    startingInfo: void 0
  };
}
const DelegatorStartingInfoRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfoRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.startingInfo !== void 0 && DelegatorStartingInfo.encode(e.startingInfo, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDelegatorStartingInfoRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        case 3:
          c.startingInfo = DelegatorStartingInfo.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDelegatorStartingInfoRecord();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", u.startingInfo = e.startingInfo !== void 0 && e.startingInfo !== null ? DelegatorStartingInfo.fromPartial(e.startingInfo) : void 0, u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address,
      startingInfo: e != null && e.starting_info ? DelegatorStartingInfo.fromAmino(e.starting_info) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n.starting_info = e.startingInfo ? DelegatorStartingInfo.toAmino(e.startingInfo) : void 0, n;
  },
  fromAminoMsg(e) {
    return DelegatorStartingInfoRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DelegatorStartingInfoRecord",
      value: DelegatorStartingInfoRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DelegatorStartingInfoRecord.decode(e.value);
  },
  toProto(e) {
    return DelegatorStartingInfoRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfoRecord",
      value: DelegatorStartingInfoRecord.encode(e).finish()
    };
  }
};
function createBaseValidatorSlashEventRecord() {
  return {
    validatorAddress: "",
    height: Long$2.UZERO,
    period: Long$2.UZERO,
    validatorSlashEvent: void 0
  };
}
const ValidatorSlashEventRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEventRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), e.height.isZero() || n.uint32(16).uint64(e.height), e.period.isZero() || n.uint32(24).uint64(e.period), e.validatorSlashEvent !== void 0 && ValidatorSlashEvent.encode(e.validatorSlashEvent, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorSlashEventRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.height = o.uint64();
          break;
        case 3:
          c.period = o.uint64();
          break;
        case 4:
          c.validatorSlashEvent = ValidatorSlashEvent.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorSlashEventRecord();
    return o.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", o.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.UZERO, o.period = e.period !== void 0 && e.period !== null ? Long$2.fromValue(e.period) : Long$2.UZERO, o.validatorSlashEvent = e.validatorSlashEvent !== void 0 && e.validatorSlashEvent !== null ? ValidatorSlashEvent.fromPartial(e.validatorSlashEvent) : void 0, o;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      height: Long$2.fromString(e.height),
      period: Long$2.fromString(e.period),
      validatorSlashEvent: e != null && e.validator_slash_event ? ValidatorSlashEvent.fromAmino(e.validator_slash_event) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n.height = e.height ? e.height.toString() : void 0, n.period = e.period ? e.period.toString() : void 0, n.validator_slash_event = e.validatorSlashEvent ? ValidatorSlashEvent.toAmino(e.validatorSlashEvent) : void 0, n;
  },
  fromAminoMsg(e) {
    return ValidatorSlashEventRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValidatorSlashEventRecord",
      value: ValidatorSlashEventRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorSlashEventRecord.decode(e.value);
  },
  toProto(e) {
    return ValidatorSlashEventRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEventRecord",
      value: ValidatorSlashEventRecord.encode(e).finish()
    };
  }
};
function createBaseGenesisState$q() {
  return {
    params: void 0,
    feePool: void 0,
    delegatorWithdrawInfos: [],
    previousProposer: "",
    outstandingRewards: [],
    validatorAccumulatedCommissions: [],
    validatorHistoricalRewards: [],
    validatorCurrentRewards: [],
    delegatorStartingInfos: [],
    validatorSlashEvents: []
  };
}
const GenesisState$q = {
  typeUrl: "/cosmos.distribution.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$l.encode(e.params, n.uint32(10).fork()).ldelim(), e.feePool !== void 0 && FeePool.encode(e.feePool, n.uint32(18).fork()).ldelim();
    for (const o of e.delegatorWithdrawInfos)
      DelegatorWithdrawInfo.encode(o, n.uint32(26).fork()).ldelim();
    e.previousProposer !== "" && n.uint32(34).string(e.previousProposer);
    for (const o of e.outstandingRewards)
      ValidatorOutstandingRewardsRecord.encode(o, n.uint32(42).fork()).ldelim();
    for (const o of e.validatorAccumulatedCommissions)
      ValidatorAccumulatedCommissionRecord.encode(o, n.uint32(50).fork()).ldelim();
    for (const o of e.validatorHistoricalRewards)
      ValidatorHistoricalRewardsRecord.encode(o, n.uint32(58).fork()).ldelim();
    for (const o of e.validatorCurrentRewards)
      ValidatorCurrentRewardsRecord.encode(o, n.uint32(66).fork()).ldelim();
    for (const o of e.delegatorStartingInfos)
      DelegatorStartingInfoRecord.encode(o, n.uint32(74).fork()).ldelim();
    for (const o of e.validatorSlashEvents)
      ValidatorSlashEventRecord.encode(o, n.uint32(82).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$q();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$l.decode(o, o.uint32());
          break;
        case 2:
          c.feePool = FeePool.decode(o, o.uint32());
          break;
        case 3:
          c.delegatorWithdrawInfos.push(DelegatorWithdrawInfo.decode(o, o.uint32()));
          break;
        case 4:
          c.previousProposer = o.string();
          break;
        case 5:
          c.outstandingRewards.push(ValidatorOutstandingRewardsRecord.decode(o, o.uint32()));
          break;
        case 6:
          c.validatorAccumulatedCommissions.push(ValidatorAccumulatedCommissionRecord.decode(o, o.uint32()));
          break;
        case 7:
          c.validatorHistoricalRewards.push(ValidatorHistoricalRewardsRecord.decode(o, o.uint32()));
          break;
        case 8:
          c.validatorCurrentRewards.push(ValidatorCurrentRewardsRecord.decode(o, o.uint32()));
          break;
        case 9:
          c.delegatorStartingInfos.push(DelegatorStartingInfoRecord.decode(o, o.uint32()));
          break;
        case 10:
          c.validatorSlashEvents.push(ValidatorSlashEventRecord.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S;
    const $ = createBaseGenesisState$q();
    return $.params = e.params !== void 0 && e.params !== null ? Params$l.fromPartial(e.params) : void 0, $.feePool = e.feePool !== void 0 && e.feePool !== null ? FeePool.fromPartial(e.feePool) : void 0, $.delegatorWithdrawInfos = ((n = e.delegatorWithdrawInfos) === null || n === void 0 ? void 0 : n.map((E) => DelegatorWithdrawInfo.fromPartial(E))) || [], $.previousProposer = (o = e.previousProposer) !== null && o !== void 0 ? o : "", $.outstandingRewards = ((u = e.outstandingRewards) === null || u === void 0 ? void 0 : u.map((E) => ValidatorOutstandingRewardsRecord.fromPartial(E))) || [], $.validatorAccumulatedCommissions = ((c = e.validatorAccumulatedCommissions) === null || c === void 0 ? void 0 : c.map((E) => ValidatorAccumulatedCommissionRecord.fromPartial(E))) || [], $.validatorHistoricalRewards = ((d = e.validatorHistoricalRewards) === null || d === void 0 ? void 0 : d.map((E) => ValidatorHistoricalRewardsRecord.fromPartial(E))) || [], $.validatorCurrentRewards = ((m = e.validatorCurrentRewards) === null || m === void 0 ? void 0 : m.map((E) => ValidatorCurrentRewardsRecord.fromPartial(E))) || [], $.delegatorStartingInfos = ((v = e.delegatorStartingInfos) === null || v === void 0 ? void 0 : v.map((E) => DelegatorStartingInfoRecord.fromPartial(E))) || [], $.validatorSlashEvents = ((S = e.validatorSlashEvents) === null || S === void 0 ? void 0 : S.map((E) => ValidatorSlashEventRecord.fromPartial(E))) || [], $;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$l.fromAmino(e.params) : void 0,
      feePool: e != null && e.fee_pool ? FeePool.fromAmino(e.fee_pool) : void 0,
      delegatorWithdrawInfos: Array.isArray(e == null ? void 0 : e.delegator_withdraw_infos) ? e.delegator_withdraw_infos.map((n) => DelegatorWithdrawInfo.fromAmino(n)) : [],
      previousProposer: e.previous_proposer,
      outstandingRewards: Array.isArray(e == null ? void 0 : e.outstanding_rewards) ? e.outstanding_rewards.map((n) => ValidatorOutstandingRewardsRecord.fromAmino(n)) : [],
      validatorAccumulatedCommissions: Array.isArray(e == null ? void 0 : e.validator_accumulated_commissions) ? e.validator_accumulated_commissions.map((n) => ValidatorAccumulatedCommissionRecord.fromAmino(n)) : [],
      validatorHistoricalRewards: Array.isArray(e == null ? void 0 : e.validator_historical_rewards) ? e.validator_historical_rewards.map((n) => ValidatorHistoricalRewardsRecord.fromAmino(n)) : [],
      validatorCurrentRewards: Array.isArray(e == null ? void 0 : e.validator_current_rewards) ? e.validator_current_rewards.map((n) => ValidatorCurrentRewardsRecord.fromAmino(n)) : [],
      delegatorStartingInfos: Array.isArray(e == null ? void 0 : e.delegator_starting_infos) ? e.delegator_starting_infos.map((n) => DelegatorStartingInfoRecord.fromAmino(n)) : [],
      validatorSlashEvents: Array.isArray(e == null ? void 0 : e.validator_slash_events) ? e.validator_slash_events.map((n) => ValidatorSlashEventRecord.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$l.toAmino(e.params) : void 0, n.fee_pool = e.feePool ? FeePool.toAmino(e.feePool) : void 0, e.delegatorWithdrawInfos ? n.delegator_withdraw_infos = e.delegatorWithdrawInfos.map((o) => o ? DelegatorWithdrawInfo.toAmino(o) : void 0) : n.delegator_withdraw_infos = [], n.previous_proposer = e.previousProposer, e.outstandingRewards ? n.outstanding_rewards = e.outstandingRewards.map((o) => o ? ValidatorOutstandingRewardsRecord.toAmino(o) : void 0) : n.outstanding_rewards = [], e.validatorAccumulatedCommissions ? n.validator_accumulated_commissions = e.validatorAccumulatedCommissions.map((o) => o ? ValidatorAccumulatedCommissionRecord.toAmino(o) : void 0) : n.validator_accumulated_commissions = [], e.validatorHistoricalRewards ? n.validator_historical_rewards = e.validatorHistoricalRewards.map((o) => o ? ValidatorHistoricalRewardsRecord.toAmino(o) : void 0) : n.validator_historical_rewards = [], e.validatorCurrentRewards ? n.validator_current_rewards = e.validatorCurrentRewards.map((o) => o ? ValidatorCurrentRewardsRecord.toAmino(o) : void 0) : n.validator_current_rewards = [], e.delegatorStartingInfos ? n.delegator_starting_infos = e.delegatorStartingInfos.map((o) => o ? DelegatorStartingInfoRecord.toAmino(o) : void 0) : n.delegator_starting_infos = [], e.validatorSlashEvents ? n.validator_slash_events = e.validatorSlashEvents.map((o) => o ? ValidatorSlashEventRecord.toAmino(o) : void 0) : n.validator_slash_events = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$q.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$q.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$q.decode(e.value);
  },
  toProto(e) {
    return GenesisState$q.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.GenesisState",
      value: GenesisState$q.encode(e).finish()
    };
  }
}, _26 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DelegatorStartingInfoRecord,
  DelegatorWithdrawInfo,
  GenesisState: GenesisState$q,
  ValidatorAccumulatedCommissionRecord,
  ValidatorCurrentRewardsRecord,
  ValidatorHistoricalRewardsRecord,
  ValidatorOutstandingRewardsRecord,
  ValidatorSlashEventRecord
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryParamsRequest$d() {
  return {};
}
const QueryParamsRequest$d = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$d();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$d();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$d.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest$d.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$d.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$d.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest$d.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$d() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$d = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$l.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$d();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$l.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$d();
    return n.params = e.params !== void 0 && e.params !== null ? Params$l.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$l.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$l.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$d.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse$d.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$d.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$d.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse$d.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorOutstandingRewardsRequest() {
  return {
    validatorAddress: ""
  };
}
const QueryValidatorOutstandingRewardsRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorOutstandingRewardsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorOutstandingRewardsRequest();
    return o.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorOutstandingRewardsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorOutstandingRewardsRequest",
      value: QueryValidatorOutstandingRewardsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorOutstandingRewardsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorOutstandingRewardsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsRequest",
      value: QueryValidatorOutstandingRewardsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorOutstandingRewardsResponse() {
  return {
    rewards: void 0
  };
}
const QueryValidatorOutstandingRewardsResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.rewards !== void 0 && ValidatorOutstandingRewards.encode(e.rewards, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorOutstandingRewardsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.rewards = ValidatorOutstandingRewards.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryValidatorOutstandingRewardsResponse();
    return n.rewards = e.rewards !== void 0 && e.rewards !== null ? ValidatorOutstandingRewards.fromPartial(e.rewards) : void 0, n;
  },
  fromAmino(e) {
    return {
      rewards: e != null && e.rewards ? ValidatorOutstandingRewards.fromAmino(e.rewards) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.rewards = e.rewards ? ValidatorOutstandingRewards.toAmino(e.rewards) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorOutstandingRewardsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorOutstandingRewardsResponse",
      value: QueryValidatorOutstandingRewardsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorOutstandingRewardsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorOutstandingRewardsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsResponse",
      value: QueryValidatorOutstandingRewardsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorCommissionRequest() {
  return {
    validatorAddress: ""
  };
}
const QueryValidatorCommissionRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorCommissionRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorCommissionRequest();
    return o.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorCommissionRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorCommissionRequest",
      value: QueryValidatorCommissionRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorCommissionRequest.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorCommissionRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionRequest",
      value: QueryValidatorCommissionRequest.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorCommissionResponse() {
  return {
    commission: void 0
  };
}
const QueryValidatorCommissionResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.commission !== void 0 && ValidatorAccumulatedCommission.encode(e.commission, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorCommissionResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.commission = ValidatorAccumulatedCommission.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryValidatorCommissionResponse();
    return n.commission = e.commission !== void 0 && e.commission !== null ? ValidatorAccumulatedCommission.fromPartial(e.commission) : void 0, n;
  },
  fromAmino(e) {
    return {
      commission: e != null && e.commission ? ValidatorAccumulatedCommission.fromAmino(e.commission) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.commission = e.commission ? ValidatorAccumulatedCommission.toAmino(e.commission) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorCommissionResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorCommissionResponse",
      value: QueryValidatorCommissionResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorCommissionResponse.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorCommissionResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionResponse",
      value: QueryValidatorCommissionResponse.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorSlashesRequest() {
  return {
    validatorAddress: "",
    startingHeight: Long$2.UZERO,
    endingHeight: Long$2.UZERO,
    pagination: void 0
  };
}
const QueryValidatorSlashesRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), e.startingHeight.isZero() || n.uint32(16).uint64(e.startingHeight), e.endingHeight.isZero() || n.uint32(24).uint64(e.endingHeight), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorSlashesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.startingHeight = o.uint64();
          break;
        case 3:
          c.endingHeight = o.uint64();
          break;
        case 4:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorSlashesRequest();
    return o.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", o.startingHeight = e.startingHeight !== void 0 && e.startingHeight !== null ? Long$2.fromValue(e.startingHeight) : Long$2.UZERO, o.endingHeight = e.endingHeight !== void 0 && e.endingHeight !== null ? Long$2.fromValue(e.endingHeight) : Long$2.UZERO, o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      startingHeight: Long$2.fromString(e.starting_height),
      endingHeight: Long$2.fromString(e.ending_height),
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n.starting_height = e.startingHeight ? e.startingHeight.toString() : void 0, n.ending_height = e.endingHeight ? e.endingHeight.toString() : void 0, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorSlashesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorSlashesRequest",
      value: QueryValidatorSlashesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorSlashesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorSlashesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesRequest",
      value: QueryValidatorSlashesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorSlashesResponse() {
  return {
    slashes: [],
    pagination: void 0
  };
}
const QueryValidatorSlashesResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.slashes)
      ValidatorSlashEvent.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorSlashesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.slashes.push(ValidatorSlashEvent.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorSlashesResponse();
    return o.slashes = ((n = e.slashes) === null || n === void 0 ? void 0 : n.map((u) => ValidatorSlashEvent.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      slashes: Array.isArray(e == null ? void 0 : e.slashes) ? e.slashes.map((n) => ValidatorSlashEvent.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.slashes ? n.slashes = e.slashes.map((o) => o ? ValidatorSlashEvent.toAmino(o) : void 0) : n.slashes = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorSlashesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorSlashesResponse",
      value: QueryValidatorSlashesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorSlashesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorSlashesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesResponse",
      value: QueryValidatorSlashesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDelegationRewardsRequest() {
  return {
    delegatorAddress: "",
    validatorAddress: ""
  };
}
const QueryDelegationRewardsRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegationRewardsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryDelegationRewardsRequest();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n;
  },
  fromAminoMsg(e) {
    return QueryDelegationRewardsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegationRewardsRequest",
      value: QueryDelegationRewardsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegationRewardsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDelegationRewardsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsRequest",
      value: QueryDelegationRewardsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDelegationRewardsResponse() {
  return {
    rewards: []
  };
}
const QueryDelegationRewardsResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.rewards)
      DecCoin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegationRewardsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.rewards.push(DecCoin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegationRewardsResponse();
    return o.rewards = ((n = e.rewards) === null || n === void 0 ? void 0 : n.map((u) => DecCoin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      rewards: Array.isArray(e == null ? void 0 : e.rewards) ? e.rewards.map((n) => DecCoin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.rewards ? n.rewards = e.rewards.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.rewards = [], n;
  },
  fromAminoMsg(e) {
    return QueryDelegationRewardsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegationRewardsResponse",
      value: QueryDelegationRewardsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegationRewardsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDelegationRewardsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsResponse",
      value: QueryDelegationRewardsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDelegationTotalRewardsRequest() {
  return {
    delegatorAddress: ""
  };
}
const QueryDelegationTotalRewardsRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegationTotalRewardsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegationTotalRewardsRequest();
    return o.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n;
  },
  fromAminoMsg(e) {
    return QueryDelegationTotalRewardsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegationTotalRewardsRequest",
      value: QueryDelegationTotalRewardsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegationTotalRewardsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDelegationTotalRewardsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsRequest",
      value: QueryDelegationTotalRewardsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDelegationTotalRewardsResponse() {
  return {
    rewards: [],
    total: []
  };
}
const QueryDelegationTotalRewardsResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.rewards)
      DelegationDelegatorReward.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.total)
      DecCoin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegationTotalRewardsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.rewards.push(DelegationDelegatorReward.decode(o, o.uint32()));
          break;
        case 2:
          c.total.push(DecCoin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryDelegationTotalRewardsResponse();
    return u.rewards = ((n = e.rewards) === null || n === void 0 ? void 0 : n.map((c) => DelegationDelegatorReward.fromPartial(c))) || [], u.total = ((o = e.total) === null || o === void 0 ? void 0 : o.map((c) => DecCoin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      rewards: Array.isArray(e == null ? void 0 : e.rewards) ? e.rewards.map((n) => DelegationDelegatorReward.fromAmino(n)) : [],
      total: Array.isArray(e == null ? void 0 : e.total) ? e.total.map((n) => DecCoin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.rewards ? n.rewards = e.rewards.map((o) => o ? DelegationDelegatorReward.toAmino(o) : void 0) : n.rewards = [], e.total ? n.total = e.total.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.total = [], n;
  },
  fromAminoMsg(e) {
    return QueryDelegationTotalRewardsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegationTotalRewardsResponse",
      value: QueryDelegationTotalRewardsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegationTotalRewardsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDelegationTotalRewardsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsResponse",
      value: QueryDelegationTotalRewardsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorValidatorsRequest$1() {
  return {
    delegatorAddress: ""
  };
}
const QueryDelegatorValidatorsRequest$1 = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorValidatorsRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorValidatorsRequest$1();
    return o.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorValidatorsRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorsRequest",
      value: QueryDelegatorValidatorsRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorValidatorsRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorValidatorsRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsRequest",
      value: QueryDelegatorValidatorsRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorValidatorsResponse$1() {
  return {
    validators: []
  };
}
const QueryDelegatorValidatorsResponse$1 = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.validators)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorValidatorsResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validators.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorValidatorsResponse$1();
    return o.validators = ((n = e.validators) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      validators: Array.isArray(e == null ? void 0 : e.validators) ? e.validators.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.validators ? n.validators = e.validators.map((o) => o) : n.validators = [], n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorValidatorsResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorsResponse",
      value: QueryDelegatorValidatorsResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorValidatorsResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorValidatorsResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsResponse",
      value: QueryDelegatorValidatorsResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorWithdrawAddressRequest() {
  return {
    delegatorAddress: ""
  };
}
const QueryDelegatorWithdrawAddressRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorWithdrawAddressRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorWithdrawAddressRequest();
    return o.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorWithdrawAddressRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorWithdrawAddressRequest",
      value: QueryDelegatorWithdrawAddressRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorWithdrawAddressRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorWithdrawAddressRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressRequest",
      value: QueryDelegatorWithdrawAddressRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorWithdrawAddressResponse() {
  return {
    withdrawAddress: ""
  };
}
const QueryDelegatorWithdrawAddressResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.withdrawAddress !== "" && n.uint32(10).string(e.withdrawAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorWithdrawAddressResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.withdrawAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorWithdrawAddressResponse();
    return o.withdrawAddress = (n = e.withdrawAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      withdrawAddress: e.withdraw_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.withdraw_address = e.withdrawAddress, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorWithdrawAddressResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorWithdrawAddressResponse",
      value: QueryDelegatorWithdrawAddressResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorWithdrawAddressResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorWithdrawAddressResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressResponse",
      value: QueryDelegatorWithdrawAddressResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCommunityPoolRequest() {
  return {};
}
const QueryCommunityPoolRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCommunityPoolRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryCommunityPoolRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryCommunityPoolRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryCommunityPoolRequest",
      value: QueryCommunityPoolRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCommunityPoolRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCommunityPoolRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolRequest",
      value: QueryCommunityPoolRequest.encode(e).finish()
    };
  }
};
function createBaseQueryCommunityPoolResponse() {
  return {
    pool: []
  };
}
const QueryCommunityPoolResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.pool)
      DecCoin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCommunityPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pool.push(DecCoin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCommunityPoolResponse();
    return o.pool = ((n = e.pool) === null || n === void 0 ? void 0 : n.map((u) => DecCoin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      pool: Array.isArray(e == null ? void 0 : e.pool) ? e.pool.map((n) => DecCoin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.pool ? n.pool = e.pool.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.pool = [], n;
  },
  fromAminoMsg(e) {
    return QueryCommunityPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryCommunityPoolResponse",
      value: QueryCommunityPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCommunityPoolResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCommunityPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolResponse",
      value: QueryCommunityPoolResponse.encode(e).finish()
    };
  }
}, _27 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryCommunityPoolRequest,
  QueryCommunityPoolResponse,
  QueryDelegationRewardsRequest,
  QueryDelegationRewardsResponse,
  QueryDelegationTotalRewardsRequest,
  QueryDelegationTotalRewardsResponse,
  QueryDelegatorValidatorsRequest: QueryDelegatorValidatorsRequest$1,
  QueryDelegatorValidatorsResponse: QueryDelegatorValidatorsResponse$1,
  QueryDelegatorWithdrawAddressRequest,
  QueryDelegatorWithdrawAddressResponse,
  QueryParamsRequest: QueryParamsRequest$d,
  QueryParamsResponse: QueryParamsResponse$d,
  QueryValidatorCommissionRequest,
  QueryValidatorCommissionResponse,
  QueryValidatorOutstandingRewardsRequest,
  QueryValidatorOutstandingRewardsResponse,
  QueryValidatorSlashesRequest,
  QueryValidatorSlashesResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSetWithdrawAddress() {
  return {
    delegatorAddress: "",
    withdrawAddress: ""
  };
}
const MsgSetWithdrawAddress = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.withdrawAddress !== "" && n.uint32(18).string(e.withdrawAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetWithdrawAddress();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.withdrawAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgSetWithdrawAddress();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.withdrawAddress = (o = e.withdrawAddress) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      withdrawAddress: e.withdraw_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.withdraw_address = e.withdrawAddress, n;
  },
  fromAminoMsg(e) {
    return MsgSetWithdrawAddress.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgModifyWithdrawAddress",
      value: MsgSetWithdrawAddress.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetWithdrawAddress.decode(e.value);
  },
  toProto(e) {
    return MsgSetWithdrawAddress.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
      value: MsgSetWithdrawAddress.encode(e).finish()
    };
  }
};
function createBaseMsgSetWithdrawAddressResponse() {
  return {};
}
const MsgSetWithdrawAddressResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddressResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetWithdrawAddressResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetWithdrawAddressResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetWithdrawAddressResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSetWithdrawAddressResponse",
      value: MsgSetWithdrawAddressResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetWithdrawAddressResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetWithdrawAddressResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddressResponse",
      value: MsgSetWithdrawAddressResponse.encode(e).finish()
    };
  }
};
function createBaseMsgWithdrawDelegatorReward() {
  return {
    delegatorAddress: "",
    validatorAddress: ""
  };
}
const MsgWithdrawDelegatorReward = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgWithdrawDelegatorReward();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgWithdrawDelegatorReward();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n;
  },
  fromAminoMsg(e) {
    return MsgWithdrawDelegatorReward.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgWithdrawDelegationReward",
      value: MsgWithdrawDelegatorReward.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgWithdrawDelegatorReward.decode(e.value);
  },
  toProto(e) {
    return MsgWithdrawDelegatorReward.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
      value: MsgWithdrawDelegatorReward.encode(e).finish()
    };
  }
};
function createBaseMsgWithdrawDelegatorRewardResponse() {
  return {};
}
const MsgWithdrawDelegatorRewardResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgWithdrawDelegatorRewardResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgWithdrawDelegatorRewardResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgWithdrawDelegatorRewardResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgWithdrawDelegatorRewardResponse",
      value: MsgWithdrawDelegatorRewardResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgWithdrawDelegatorRewardResponse.decode(e.value);
  },
  toProto(e) {
    return MsgWithdrawDelegatorRewardResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse",
      value: MsgWithdrawDelegatorRewardResponse.encode(e).finish()
    };
  }
};
function createBaseMsgWithdrawValidatorCommission() {
  return {
    validatorAddress: ""
  };
}
const MsgWithdrawValidatorCommission = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgWithdrawValidatorCommission();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgWithdrawValidatorCommission();
    return o.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n;
  },
  fromAminoMsg(e) {
    return MsgWithdrawValidatorCommission.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgWithdrawValCommission",
      value: MsgWithdrawValidatorCommission.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgWithdrawValidatorCommission.decode(e.value);
  },
  toProto(e) {
    return MsgWithdrawValidatorCommission.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
      value: MsgWithdrawValidatorCommission.encode(e).finish()
    };
  }
};
function createBaseMsgWithdrawValidatorCommissionResponse() {
  return {};
}
const MsgWithdrawValidatorCommissionResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommissionResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgWithdrawValidatorCommissionResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgWithdrawValidatorCommissionResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgWithdrawValidatorCommissionResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgWithdrawValidatorCommissionResponse",
      value: MsgWithdrawValidatorCommissionResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgWithdrawValidatorCommissionResponse.decode(e.value);
  },
  toProto(e) {
    return MsgWithdrawValidatorCommissionResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommissionResponse",
      value: MsgWithdrawValidatorCommissionResponse.encode(e).finish()
    };
  }
};
function createBaseMsgFundCommunityPool() {
  return {
    amount: [],
    depositor: ""
  };
}
const MsgFundCommunityPool = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.amount)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return e.depositor !== "" && n.uint32(18).string(e.depositor), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgFundCommunityPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.depositor = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgFundCommunityPool();
    return u.amount = ((n = e.amount) === null || n === void 0 ? void 0 : n.map((c) => Coin.fromPartial(c))) || [], u.depositor = (o = e.depositor) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : [],
      depositor: e.depositor
    };
  },
  toAmino(e) {
    const n = {};
    return e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n.depositor = e.depositor, n;
  },
  fromAminoMsg(e) {
    return MsgFundCommunityPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgFundCommunityPool",
      value: MsgFundCommunityPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgFundCommunityPool.decode(e.value);
  },
  toProto(e) {
    return MsgFundCommunityPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
      value: MsgFundCommunityPool.encode(e).finish()
    };
  }
};
function createBaseMsgFundCommunityPoolResponse() {
  return {};
}
const MsgFundCommunityPoolResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgFundCommunityPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgFundCommunityPoolResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgFundCommunityPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgFundCommunityPoolResponse",
      value: MsgFundCommunityPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgFundCommunityPoolResponse.decode(e.value);
  },
  toProto(e) {
    return MsgFundCommunityPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPoolResponse",
      value: MsgFundCommunityPoolResponse.encode(e).finish()
    };
  }
}, _28 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgFundCommunityPool,
  MsgFundCommunityPoolResponse,
  MsgSetWithdrawAddress,
  MsgSetWithdrawAddressResponse,
  MsgWithdrawDelegatorReward,
  MsgWithdrawDelegatorRewardResponse,
  MsgWithdrawValidatorCommission,
  MsgWithdrawValidatorCommissionResponse
}, Symbol.toStringTag, { value: "Module" }));
let VoteOption$1;
(function(e) {
  e[e.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", e[e.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", e[e.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", e[e.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", e[e.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(VoteOption$1 || (VoteOption$1 = {}));
const VoteOptionSDKType$1 = VoteOption$1, VoteOptionAmino$1 = VoteOption$1;
function voteOptionFromJSON$1(e) {
  switch (e) {
    case 0:
    case "VOTE_OPTION_UNSPECIFIED":
      return VoteOption$1.VOTE_OPTION_UNSPECIFIED;
    case 1:
    case "VOTE_OPTION_YES":
      return VoteOption$1.VOTE_OPTION_YES;
    case 2:
    case "VOTE_OPTION_ABSTAIN":
      return VoteOption$1.VOTE_OPTION_ABSTAIN;
    case 3:
    case "VOTE_OPTION_NO":
      return VoteOption$1.VOTE_OPTION_NO;
    case 4:
    case "VOTE_OPTION_NO_WITH_VETO":
      return VoteOption$1.VOTE_OPTION_NO_WITH_VETO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VoteOption$1.UNRECOGNIZED;
  }
}
function voteOptionToJSON$1(e) {
  switch (e) {
    case VoteOption$1.VOTE_OPTION_UNSPECIFIED:
      return "VOTE_OPTION_UNSPECIFIED";
    case VoteOption$1.VOTE_OPTION_YES:
      return "VOTE_OPTION_YES";
    case VoteOption$1.VOTE_OPTION_ABSTAIN:
      return "VOTE_OPTION_ABSTAIN";
    case VoteOption$1.VOTE_OPTION_NO:
      return "VOTE_OPTION_NO";
    case VoteOption$1.VOTE_OPTION_NO_WITH_VETO:
      return "VOTE_OPTION_NO_WITH_VETO";
    case VoteOption$1.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ProposalStatus$1;
(function(e) {
  e[e.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", e[e.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", e[e.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", e[e.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", e[e.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", e[e.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ProposalStatus$1 || (ProposalStatus$1 = {}));
const ProposalStatusSDKType$1 = ProposalStatus$1, ProposalStatusAmino$1 = ProposalStatus$1;
function proposalStatusFromJSON$1(e) {
  switch (e) {
    case 0:
    case "PROPOSAL_STATUS_UNSPECIFIED":
      return ProposalStatus$1.PROPOSAL_STATUS_UNSPECIFIED;
    case 1:
    case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
      return ProposalStatus$1.PROPOSAL_STATUS_DEPOSIT_PERIOD;
    case 2:
    case "PROPOSAL_STATUS_VOTING_PERIOD":
      return ProposalStatus$1.PROPOSAL_STATUS_VOTING_PERIOD;
    case 3:
    case "PROPOSAL_STATUS_PASSED":
      return ProposalStatus$1.PROPOSAL_STATUS_PASSED;
    case 4:
    case "PROPOSAL_STATUS_REJECTED":
      return ProposalStatus$1.PROPOSAL_STATUS_REJECTED;
    case 5:
    case "PROPOSAL_STATUS_FAILED":
      return ProposalStatus$1.PROPOSAL_STATUS_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProposalStatus$1.UNRECOGNIZED;
  }
}
function proposalStatusToJSON$1(e) {
  switch (e) {
    case ProposalStatus$1.PROPOSAL_STATUS_UNSPECIFIED:
      return "PROPOSAL_STATUS_UNSPECIFIED";
    case ProposalStatus$1.PROPOSAL_STATUS_DEPOSIT_PERIOD:
      return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    case ProposalStatus$1.PROPOSAL_STATUS_VOTING_PERIOD:
      return "PROPOSAL_STATUS_VOTING_PERIOD";
    case ProposalStatus$1.PROPOSAL_STATUS_PASSED:
      return "PROPOSAL_STATUS_PASSED";
    case ProposalStatus$1.PROPOSAL_STATUS_REJECTED:
      return "PROPOSAL_STATUS_REJECTED";
    case ProposalStatus$1.PROPOSAL_STATUS_FAILED:
      return "PROPOSAL_STATUS_FAILED";
    case ProposalStatus$1.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseWeightedVoteOption$1() {
  return {
    option: 0,
    weight: ""
  };
}
const WeightedVoteOption$1 = {
  typeUrl: "/cosmos.gov.v1beta1.WeightedVoteOption",
  encode(e, n = minimal.Writer.create()) {
    return e.option !== 0 && n.uint32(8).int32(e.option), e.weight !== "" && n.uint32(18).string(e.weight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseWeightedVoteOption$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.option = o.int32();
          break;
        case 2:
          c.weight = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseWeightedVoteOption$1();
    return u.option = (n = e.option) !== null && n !== void 0 ? n : 0, u.weight = (o = e.weight) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      option: isSet(e.option) ? voteOptionFromJSON$1(e.option) : 0,
      weight: e.weight
    };
  },
  toAmino(e) {
    const n = {};
    return n.option = e.option, n.weight = e.weight, n;
  },
  fromAminoMsg(e) {
    return WeightedVoteOption$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/WeightedVoteOption",
      value: WeightedVoteOption$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return WeightedVoteOption$1.decode(e.value);
  },
  toProto(e) {
    return WeightedVoteOption$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.WeightedVoteOption",
      value: WeightedVoteOption$1.encode(e).finish()
    };
  }
};
function createBaseTextProposal() {
  return {
    $typeUrl: "/cosmos.gov.v1beta1.TextProposal",
    title: "",
    description: ""
  };
}
const TextProposal = {
  typeUrl: "/cosmos.gov.v1beta1.TextProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTextProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseTextProposal();
    return u.title = (n = e.title) !== null && n !== void 0 ? n : "", u.description = (o = e.description) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n;
  },
  fromAminoMsg(e) {
    return TextProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TextProposal",
      value: TextProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TextProposal.decode(e.value);
  },
  toProto(e) {
    return TextProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.TextProposal",
      value: TextProposal.encode(e).finish()
    };
  }
};
function createBaseDeposit$1() {
  return {
    proposalId: Long$2.UZERO,
    depositor: "",
    amount: []
  };
}
const Deposit$1 = {
  typeUrl: "/cosmos.gov.v1beta1.Deposit",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.depositor !== "" && n.uint32(18).string(e.depositor);
    for (const o of e.amount)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDeposit$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.depositor = o.string();
          break;
        case 3:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDeposit$1();
    return u.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, u.depositor = (n = e.depositor) !== null && n !== void 0 ? n : "", u.amount = ((o = e.amount) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      depositor: e.depositor,
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.depositor = e.depositor, e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n;
  },
  fromAminoMsg(e) {
    return Deposit$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Deposit",
      value: Deposit$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Deposit$1.decode(e.value);
  },
  toProto(e) {
    return Deposit$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.Deposit",
      value: Deposit$1.encode(e).finish()
    };
  }
};
function createBaseProposal$1() {
  return {
    proposalId: Long$2.UZERO,
    content: void 0,
    status: 0,
    finalTallyResult: void 0,
    submitTime: void 0,
    depositEndTime: void 0,
    totalDeposit: [],
    votingStartTime: void 0,
    votingEndTime: void 0,
    isExpedited: !1
  };
}
const Proposal$1 = {
  typeUrl: "/cosmos.gov.v1beta1.Proposal",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.content !== void 0 && Any.encode(e.content, n.uint32(18).fork()).ldelim(), e.status !== 0 && n.uint32(24).int32(e.status), e.finalTallyResult !== void 0 && TallyResult$1.encode(e.finalTallyResult, n.uint32(34).fork()).ldelim(), e.submitTime !== void 0 && Timestamp.encode(toTimestamp(e.submitTime), n.uint32(42).fork()).ldelim(), e.depositEndTime !== void 0 && Timestamp.encode(toTimestamp(e.depositEndTime), n.uint32(50).fork()).ldelim();
    for (const o of e.totalDeposit)
      Coin.encode(o, n.uint32(58).fork()).ldelim();
    return e.votingStartTime !== void 0 && Timestamp.encode(toTimestamp(e.votingStartTime), n.uint32(66).fork()).ldelim(), e.votingEndTime !== void 0 && Timestamp.encode(toTimestamp(e.votingEndTime), n.uint32(74).fork()).ldelim(), e.isExpedited === !0 && n.uint32(80).bool(e.isExpedited), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProposal$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.content = Content_InterfaceDecoder$1(o);
          break;
        case 3:
          c.status = o.int32();
          break;
        case 4:
          c.finalTallyResult = TallyResult$1.decode(o, o.uint32());
          break;
        case 5:
          c.submitTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 6:
          c.depositEndTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 7:
          c.totalDeposit.push(Coin.decode(o, o.uint32()));
          break;
        case 8:
          c.votingStartTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 9:
          c.votingEndTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 10:
          c.isExpedited = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v;
    const S = createBaseProposal$1();
    return S.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, S.content = e.content !== void 0 && e.content !== null ? Any.fromPartial(e.content) : void 0, S.status = (n = e.status) !== null && n !== void 0 ? n : 0, S.finalTallyResult = e.finalTallyResult !== void 0 && e.finalTallyResult !== null ? TallyResult$1.fromPartial(e.finalTallyResult) : void 0, S.submitTime = (o = e.submitTime) !== null && o !== void 0 ? o : void 0, S.depositEndTime = (u = e.depositEndTime) !== null && u !== void 0 ? u : void 0, S.totalDeposit = ((c = e.totalDeposit) === null || c === void 0 ? void 0 : c.map(($) => Coin.fromPartial($))) || [], S.votingStartTime = (d = e.votingStartTime) !== null && d !== void 0 ? d : void 0, S.votingEndTime = (m = e.votingEndTime) !== null && m !== void 0 ? m : void 0, S.isExpedited = (v = e.isExpedited) !== null && v !== void 0 ? v : !1, S;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      content: e != null && e.content ? Content_FromAmino$1(e.content) : void 0,
      status: isSet(e.status) ? proposalStatusFromJSON$1(e.status) : 0,
      finalTallyResult: e != null && e.final_tally_result ? TallyResult$1.fromAmino(e.final_tally_result) : void 0,
      submitTime: e != null && e.submit_time ? Timestamp.fromAmino(e.submit_time) : void 0,
      depositEndTime: e != null && e.deposit_end_time ? Timestamp.fromAmino(e.deposit_end_time) : void 0,
      totalDeposit: Array.isArray(e == null ? void 0 : e.total_deposit) ? e.total_deposit.map((n) => Coin.fromAmino(n)) : [],
      votingStartTime: e != null && e.voting_start_time ? Timestamp.fromAmino(e.voting_start_time) : void 0,
      votingEndTime: e != null && e.voting_end_time ? Timestamp.fromAmino(e.voting_end_time) : void 0,
      isExpedited: e.is_expedited
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.content = e.content ? Content_ToAmino$1(e.content) : void 0, n.status = e.status, n.final_tally_result = e.finalTallyResult ? TallyResult$1.toAmino(e.finalTallyResult) : void 0, n.submit_time = e.submitTime ? Timestamp.toAmino(e.submitTime) : void 0, n.deposit_end_time = e.depositEndTime ? Timestamp.toAmino(e.depositEndTime) : void 0, e.totalDeposit ? n.total_deposit = e.totalDeposit.map((o) => o ? Coin.toAmino(o) : void 0) : n.total_deposit = [], n.voting_start_time = e.votingStartTime ? Timestamp.toAmino(e.votingStartTime) : void 0, n.voting_end_time = e.votingEndTime ? Timestamp.toAmino(e.votingEndTime) : void 0, n.is_expedited = e.isExpedited, n;
  },
  fromAminoMsg(e) {
    return Proposal$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Proposal",
      value: Proposal$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Proposal$1.decode(e.value);
  },
  toProto(e) {
    return Proposal$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.Proposal",
      value: Proposal$1.encode(e).finish()
    };
  }
};
function createBaseTallyResult$1() {
  return {
    yes: "",
    abstain: "",
    no: "",
    noWithVeto: ""
  };
}
const TallyResult$1 = {
  typeUrl: "/cosmos.gov.v1beta1.TallyResult",
  encode(e, n = minimal.Writer.create()) {
    return e.yes !== "" && n.uint32(10).string(e.yes), e.abstain !== "" && n.uint32(18).string(e.abstain), e.no !== "" && n.uint32(26).string(e.no), e.noWithVeto !== "" && n.uint32(34).string(e.noWithVeto), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTallyResult$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.yes = o.string();
          break;
        case 2:
          c.abstain = o.string();
          break;
        case 3:
          c.no = o.string();
          break;
        case 4:
          c.noWithVeto = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseTallyResult$1();
    return d.yes = (n = e.yes) !== null && n !== void 0 ? n : "", d.abstain = (o = e.abstain) !== null && o !== void 0 ? o : "", d.no = (u = e.no) !== null && u !== void 0 ? u : "", d.noWithVeto = (c = e.noWithVeto) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      yes: e.yes,
      abstain: e.abstain,
      no: e.no,
      noWithVeto: e.no_with_veto
    };
  },
  toAmino(e) {
    const n = {};
    return n.yes = e.yes, n.abstain = e.abstain, n.no = e.no, n.no_with_veto = e.noWithVeto, n;
  },
  fromAminoMsg(e) {
    return TallyResult$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TallyResult",
      value: TallyResult$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TallyResult$1.decode(e.value);
  },
  toProto(e) {
    return TallyResult$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.TallyResult",
      value: TallyResult$1.encode(e).finish()
    };
  }
};
function createBaseVote$1() {
  return {
    proposalId: Long$2.UZERO,
    voter: "",
    option: 0,
    options: []
  };
}
const Vote$1 = {
  typeUrl: "/cosmos.gov.v1beta1.Vote",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.voter !== "" && n.uint32(18).string(e.voter), e.option !== 0 && n.uint32(24).int32(e.option);
    for (const o of e.options)
      WeightedVoteOption$1.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseVote$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.voter = o.string();
          break;
        case 3:
          c.option = o.int32();
          break;
        case 4:
          c.options.push(WeightedVoteOption$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseVote$1();
    return c.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, c.voter = (n = e.voter) !== null && n !== void 0 ? n : "", c.option = (o = e.option) !== null && o !== void 0 ? o : 0, c.options = ((u = e.options) === null || u === void 0 ? void 0 : u.map((d) => WeightedVoteOption$1.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      voter: e.voter,
      option: isSet(e.option) ? voteOptionFromJSON$1(e.option) : 0,
      options: Array.isArray(e == null ? void 0 : e.options) ? e.options.map((n) => WeightedVoteOption$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.voter = e.voter, n.option = e.option, e.options ? n.options = e.options.map((o) => o ? WeightedVoteOption$1.toAmino(o) : void 0) : n.options = [], n;
  },
  fromAminoMsg(e) {
    return Vote$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Vote",
      value: Vote$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Vote$1.decode(e.value);
  },
  toProto(e) {
    return Vote$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.Vote",
      value: Vote$1.encode(e).finish()
    };
  }
};
function createBaseDepositParams$1() {
  return {
    minDeposit: [],
    maxDepositPeriod: void 0,
    minExpeditedDeposit: [],
    minInitialDepositRatio: ""
  };
}
const DepositParams$1 = {
  typeUrl: "/cosmos.gov.v1beta1.DepositParams",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.minDeposit)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    e.maxDepositPeriod !== void 0 && Duration.encode(e.maxDepositPeriod, n.uint32(18).fork()).ldelim();
    for (const o of e.minExpeditedDeposit)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return e.minInitialDepositRatio !== "" && n.uint32(34).string(e.minInitialDepositRatio), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDepositParams$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.minDeposit.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.maxDepositPeriod = Duration.decode(o, o.uint32());
          break;
        case 3:
          c.minExpeditedDeposit.push(Coin.decode(o, o.uint32()));
          break;
        case 4:
          c.minInitialDepositRatio = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseDepositParams$1();
    return c.minDeposit = ((n = e.minDeposit) === null || n === void 0 ? void 0 : n.map((d) => Coin.fromPartial(d))) || [], c.maxDepositPeriod = e.maxDepositPeriod !== void 0 && e.maxDepositPeriod !== null ? Duration.fromPartial(e.maxDepositPeriod) : void 0, c.minExpeditedDeposit = ((o = e.minExpeditedDeposit) === null || o === void 0 ? void 0 : o.map((d) => Coin.fromPartial(d))) || [], c.minInitialDepositRatio = (u = e.minInitialDepositRatio) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      minDeposit: Array.isArray(e == null ? void 0 : e.min_deposit) ? e.min_deposit.map((n) => Coin.fromAmino(n)) : [],
      maxDepositPeriod: e != null && e.max_deposit_period ? Duration.fromAmino(e.max_deposit_period) : void 0,
      minExpeditedDeposit: Array.isArray(e == null ? void 0 : e.min_expedited_deposit) ? e.min_expedited_deposit.map((n) => Coin.fromAmino(n)) : [],
      minInitialDepositRatio: e.min_initial_deposit_ratio
    };
  },
  toAmino(e) {
    const n = {};
    return e.minDeposit ? n.min_deposit = e.minDeposit.map((o) => o ? Coin.toAmino(o) : void 0) : n.min_deposit = [], n.max_deposit_period = e.maxDepositPeriod ? Duration.toAmino(e.maxDepositPeriod) : void 0, e.minExpeditedDeposit ? n.min_expedited_deposit = e.minExpeditedDeposit.map((o) => o ? Coin.toAmino(o) : void 0) : n.min_expedited_deposit = [], n.min_initial_deposit_ratio = e.minInitialDepositRatio, n;
  },
  fromAminoMsg(e) {
    return DepositParams$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DepositParams",
      value: DepositParams$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DepositParams$1.decode(e.value);
  },
  toProto(e) {
    return DepositParams$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.DepositParams",
      value: DepositParams$1.encode(e).finish()
    };
  }
};
function createBaseVotingParams$1() {
  return {
    votingPeriod: void 0,
    proposalVotingPeriods: [],
    expeditedVotingPeriod: void 0
  };
}
const VotingParams$1 = {
  typeUrl: "/cosmos.gov.v1beta1.VotingParams",
  encode(e, n = minimal.Writer.create()) {
    e.votingPeriod !== void 0 && Duration.encode(e.votingPeriod, n.uint32(10).fork()).ldelim();
    for (const o of e.proposalVotingPeriods)
      ProposalVotingPeriod.encode(o, n.uint32(18).fork()).ldelim();
    return e.expeditedVotingPeriod !== void 0 && Duration.encode(e.expeditedVotingPeriod, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseVotingParams$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.votingPeriod = Duration.decode(o, o.uint32());
          break;
        case 2:
          c.proposalVotingPeriods.push(ProposalVotingPeriod.decode(o, o.uint32()));
          break;
        case 3:
          c.expeditedVotingPeriod = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseVotingParams$1();
    return o.votingPeriod = e.votingPeriod !== void 0 && e.votingPeriod !== null ? Duration.fromPartial(e.votingPeriod) : void 0, o.proposalVotingPeriods = ((n = e.proposalVotingPeriods) === null || n === void 0 ? void 0 : n.map((u) => ProposalVotingPeriod.fromPartial(u))) || [], o.expeditedVotingPeriod = e.expeditedVotingPeriod !== void 0 && e.expeditedVotingPeriod !== null ? Duration.fromPartial(e.expeditedVotingPeriod) : void 0, o;
  },
  fromAmino(e) {
    return {
      votingPeriod: e != null && e.voting_period ? Duration.fromAmino(e.voting_period) : void 0,
      proposalVotingPeriods: Array.isArray(e == null ? void 0 : e.proposal_voting_periods) ? e.proposal_voting_periods.map((n) => ProposalVotingPeriod.fromAmino(n)) : [],
      expeditedVotingPeriod: e != null && e.expedited_voting_period ? Duration.fromAmino(e.expedited_voting_period) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.voting_period = e.votingPeriod ? Duration.toAmino(e.votingPeriod) : void 0, e.proposalVotingPeriods ? n.proposal_voting_periods = e.proposalVotingPeriods.map((o) => o ? ProposalVotingPeriod.toAmino(o) : void 0) : n.proposal_voting_periods = [], n.expedited_voting_period = e.expeditedVotingPeriod ? Duration.toAmino(e.expeditedVotingPeriod) : void 0, n;
  },
  fromAminoMsg(e) {
    return VotingParams$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/VotingParams",
      value: VotingParams$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return VotingParams$1.decode(e.value);
  },
  toProto(e) {
    return VotingParams$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.VotingParams",
      value: VotingParams$1.encode(e).finish()
    };
  }
};
function createBaseTallyParams$1() {
  return {
    quorum: new Uint8Array(),
    threshold: new Uint8Array(),
    vetoThreshold: new Uint8Array(),
    expeditedThreshold: new Uint8Array()
  };
}
const TallyParams$1 = {
  typeUrl: "/cosmos.gov.v1beta1.TallyParams",
  encode(e, n = minimal.Writer.create()) {
    return e.quorum.length !== 0 && n.uint32(10).bytes(e.quorum), e.threshold.length !== 0 && n.uint32(18).bytes(e.threshold), e.vetoThreshold.length !== 0 && n.uint32(26).bytes(e.vetoThreshold), e.expeditedThreshold.length !== 0 && n.uint32(34).bytes(e.expeditedThreshold), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTallyParams$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.quorum = o.bytes();
          break;
        case 2:
          c.threshold = o.bytes();
          break;
        case 3:
          c.vetoThreshold = o.bytes();
          break;
        case 4:
          c.expeditedThreshold = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseTallyParams$1();
    return d.quorum = (n = e.quorum) !== null && n !== void 0 ? n : new Uint8Array(), d.threshold = (o = e.threshold) !== null && o !== void 0 ? o : new Uint8Array(), d.vetoThreshold = (u = e.vetoThreshold) !== null && u !== void 0 ? u : new Uint8Array(), d.expeditedThreshold = (c = e.expeditedThreshold) !== null && c !== void 0 ? c : new Uint8Array(), d;
  },
  fromAmino(e) {
    return {
      quorum: e.quorum,
      threshold: e.threshold,
      vetoThreshold: e.veto_threshold,
      expeditedThreshold: e.expedited_threshold
    };
  },
  toAmino(e) {
    const n = {};
    return n.quorum = e.quorum, n.threshold = e.threshold, n.veto_threshold = e.vetoThreshold, n.expedited_threshold = e.expeditedThreshold, n;
  },
  fromAminoMsg(e) {
    return TallyParams$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TallyParams",
      value: TallyParams$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TallyParams$1.decode(e.value);
  },
  toProto(e) {
    return TallyParams$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.TallyParams",
      value: TallyParams$1.encode(e).finish()
    };
  }
};
function createBaseProposalVotingPeriod() {
  return {
    proposalType: "",
    votingPeriod: void 0
  };
}
const ProposalVotingPeriod = {
  typeUrl: "/cosmos.gov.v1beta1.ProposalVotingPeriod",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalType !== "" && n.uint32(10).string(e.proposalType), e.votingPeriod !== void 0 && Duration.encode(e.votingPeriod, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProposalVotingPeriod();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalType = o.string();
          break;
        case 2:
          c.votingPeriod = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseProposalVotingPeriod();
    return o.proposalType = (n = e.proposalType) !== null && n !== void 0 ? n : "", o.votingPeriod = e.votingPeriod !== void 0 && e.votingPeriod !== null ? Duration.fromPartial(e.votingPeriod) : void 0, o;
  },
  fromAmino(e) {
    return {
      proposalType: e.proposal_type,
      votingPeriod: e != null && e.voting_period ? Duration.fromAmino(e.voting_period) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_type = e.proposalType, n.voting_period = e.votingPeriod ? Duration.toAmino(e.votingPeriod) : void 0, n;
  },
  fromAminoMsg(e) {
    return ProposalVotingPeriod.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ProposalVotingPeriod",
      value: ProposalVotingPeriod.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ProposalVotingPeriod.decode(e.value);
  },
  toProto(e) {
    return ProposalVotingPeriod.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.ProposalVotingPeriod",
      value: ProposalVotingPeriod.encode(e).finish()
    };
  }
}, Content_InterfaceDecoder$1 = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/cosmos.gov.v1beta1.TextProposal":
      return TextProposal.decode(o.value);
    default:
      return o;
  }
}, Content_FromAmino$1 = (e) => {
  switch (e.type) {
    case "cosmos-sdk/TextProposal":
      return Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.TextProposal",
        value: TextProposal.encode(TextProposal.fromPartial(TextProposal.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, Content_ToAmino$1 = (e) => {
  switch (e.typeUrl) {
    case "/cosmos.gov.v1beta1.TextProposal":
      return {
        type: "cosmos-sdk/TextProposal",
        value: TextProposal.toAmino(TextProposal.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _30 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Content_FromAmino: Content_FromAmino$1,
  Content_InterfaceDecoder: Content_InterfaceDecoder$1,
  Content_ToAmino: Content_ToAmino$1,
  Deposit: Deposit$1,
  DepositParams: DepositParams$1,
  Proposal: Proposal$1,
  get ProposalStatus() {
    return ProposalStatus$1;
  },
  ProposalStatusAmino: ProposalStatusAmino$1,
  ProposalStatusSDKType: ProposalStatusSDKType$1,
  ProposalVotingPeriod,
  TallyParams: TallyParams$1,
  TallyResult: TallyResult$1,
  TextProposal,
  Vote: Vote$1,
  get VoteOption() {
    return VoteOption$1;
  },
  VoteOptionAmino: VoteOptionAmino$1,
  VoteOptionSDKType: VoteOptionSDKType$1,
  VotingParams: VotingParams$1,
  WeightedVoteOption: WeightedVoteOption$1,
  proposalStatusFromJSON: proposalStatusFromJSON$1,
  proposalStatusToJSON: proposalStatusToJSON$1,
  voteOptionFromJSON: voteOptionFromJSON$1,
  voteOptionToJSON: voteOptionToJSON$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$p() {
  return {
    startingProposalId: Long$2.UZERO,
    deposits: [],
    votes: [],
    proposals: [],
    depositParams: void 0,
    votingParams: void 0,
    tallyParams: void 0
  };
}
const GenesisState$p = {
  typeUrl: "/cosmos.gov.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.startingProposalId.isZero() || n.uint32(8).uint64(e.startingProposalId);
    for (const o of e.deposits)
      Deposit$1.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.votes)
      Vote$1.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.proposals)
      Proposal$1.encode(o, n.uint32(34).fork()).ldelim();
    return e.depositParams !== void 0 && DepositParams$1.encode(e.depositParams, n.uint32(42).fork()).ldelim(), e.votingParams !== void 0 && VotingParams$1.encode(e.votingParams, n.uint32(50).fork()).ldelim(), e.tallyParams !== void 0 && TallyParams$1.encode(e.tallyParams, n.uint32(58).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$p();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.startingProposalId = o.uint64();
          break;
        case 2:
          c.deposits.push(Deposit$1.decode(o, o.uint32()));
          break;
        case 3:
          c.votes.push(Vote$1.decode(o, o.uint32()));
          break;
        case 4:
          c.proposals.push(Proposal$1.decode(o, o.uint32()));
          break;
        case 5:
          c.depositParams = DepositParams$1.decode(o, o.uint32());
          break;
        case 6:
          c.votingParams = VotingParams$1.decode(o, o.uint32());
          break;
        case 7:
          c.tallyParams = TallyParams$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseGenesisState$p();
    return c.startingProposalId = e.startingProposalId !== void 0 && e.startingProposalId !== null ? Long$2.fromValue(e.startingProposalId) : Long$2.UZERO, c.deposits = ((n = e.deposits) === null || n === void 0 ? void 0 : n.map((d) => Deposit$1.fromPartial(d))) || [], c.votes = ((o = e.votes) === null || o === void 0 ? void 0 : o.map((d) => Vote$1.fromPartial(d))) || [], c.proposals = ((u = e.proposals) === null || u === void 0 ? void 0 : u.map((d) => Proposal$1.fromPartial(d))) || [], c.depositParams = e.depositParams !== void 0 && e.depositParams !== null ? DepositParams$1.fromPartial(e.depositParams) : void 0, c.votingParams = e.votingParams !== void 0 && e.votingParams !== null ? VotingParams$1.fromPartial(e.votingParams) : void 0, c.tallyParams = e.tallyParams !== void 0 && e.tallyParams !== null ? TallyParams$1.fromPartial(e.tallyParams) : void 0, c;
  },
  fromAmino(e) {
    return {
      startingProposalId: Long$2.fromString(e.starting_proposal_id),
      deposits: Array.isArray(e == null ? void 0 : e.deposits) ? e.deposits.map((n) => Deposit$1.fromAmino(n)) : [],
      votes: Array.isArray(e == null ? void 0 : e.votes) ? e.votes.map((n) => Vote$1.fromAmino(n)) : [],
      proposals: Array.isArray(e == null ? void 0 : e.proposals) ? e.proposals.map((n) => Proposal$1.fromAmino(n)) : [],
      depositParams: e != null && e.deposit_params ? DepositParams$1.fromAmino(e.deposit_params) : void 0,
      votingParams: e != null && e.voting_params ? VotingParams$1.fromAmino(e.voting_params) : void 0,
      tallyParams: e != null && e.tally_params ? TallyParams$1.fromAmino(e.tally_params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.starting_proposal_id = e.startingProposalId ? e.startingProposalId.toString() : void 0, e.deposits ? n.deposits = e.deposits.map((o) => o ? Deposit$1.toAmino(o) : void 0) : n.deposits = [], e.votes ? n.votes = e.votes.map((o) => o ? Vote$1.toAmino(o) : void 0) : n.votes = [], e.proposals ? n.proposals = e.proposals.map((o) => o ? Proposal$1.toAmino(o) : void 0) : n.proposals = [], n.deposit_params = e.depositParams ? DepositParams$1.toAmino(e.depositParams) : void 0, n.voting_params = e.votingParams ? VotingParams$1.toAmino(e.votingParams) : void 0, n.tally_params = e.tallyParams ? TallyParams$1.toAmino(e.tallyParams) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$p.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$p.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$p.decode(e.value);
  },
  toProto(e) {
    return GenesisState$p.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.GenesisState",
      value: GenesisState$p.encode(e).finish()
    };
  }
}, _29 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$p
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryProposalRequest$1() {
  return {
    proposalId: Long$2.UZERO
  };
}
const QueryProposalRequest$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryProposalRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryProposalRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryProposalRequest$1();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryProposalRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryProposalRequest",
      value: QueryProposalRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryProposalRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryProposalRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryProposalRequest",
      value: QueryProposalRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryProposalResponse$1() {
  return {
    proposal: void 0
  };
}
const QueryProposalResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryProposalResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.proposal !== void 0 && Proposal$1.encode(e.proposal, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryProposalResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposal = Proposal$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryProposalResponse$1();
    return n.proposal = e.proposal !== void 0 && e.proposal !== null ? Proposal$1.fromPartial(e.proposal) : void 0, n;
  },
  fromAmino(e) {
    return {
      proposal: e != null && e.proposal ? Proposal$1.fromAmino(e.proposal) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal = e.proposal ? Proposal$1.toAmino(e.proposal) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryProposalResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryProposalResponse",
      value: QueryProposalResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryProposalResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryProposalResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryProposalResponse",
      value: QueryProposalResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryProposalsRequest$1() {
  return {
    proposalStatus: 0,
    voter: "",
    depositor: "",
    pagination: void 0
  };
}
const QueryProposalsRequest$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryProposalsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalStatus !== 0 && n.uint32(8).int32(e.proposalStatus), e.voter !== "" && n.uint32(18).string(e.voter), e.depositor !== "" && n.uint32(26).string(e.depositor), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryProposalsRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalStatus = o.int32();
          break;
        case 2:
          c.voter = o.string();
          break;
        case 3:
          c.depositor = o.string();
          break;
        case 4:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryProposalsRequest$1();
    return c.proposalStatus = (n = e.proposalStatus) !== null && n !== void 0 ? n : 0, c.voter = (o = e.voter) !== null && o !== void 0 ? o : "", c.depositor = (u = e.depositor) !== null && u !== void 0 ? u : "", c.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, c;
  },
  fromAmino(e) {
    return {
      proposalStatus: isSet(e.proposal_status) ? proposalStatusFromJSON$1(e.proposal_status) : 0,
      voter: e.voter,
      depositor: e.depositor,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_status = e.proposalStatus, n.voter = e.voter, n.depositor = e.depositor, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryProposalsRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryProposalsRequest",
      value: QueryProposalsRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryProposalsRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryProposalsRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryProposalsRequest",
      value: QueryProposalsRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryProposalsResponse$1() {
  return {
    proposals: [],
    pagination: void 0
  };
}
const QueryProposalsResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryProposalsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.proposals)
      Proposal$1.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryProposalsResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposals.push(Proposal$1.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryProposalsResponse$1();
    return o.proposals = ((n = e.proposals) === null || n === void 0 ? void 0 : n.map((u) => Proposal$1.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      proposals: Array.isArray(e == null ? void 0 : e.proposals) ? e.proposals.map((n) => Proposal$1.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.proposals ? n.proposals = e.proposals.map((o) => o ? Proposal$1.toAmino(o) : void 0) : n.proposals = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryProposalsResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryProposalsResponse",
      value: QueryProposalsResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryProposalsResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryProposalsResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryProposalsResponse",
      value: QueryProposalsResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryVoteRequest$1() {
  return {
    proposalId: Long$2.UZERO,
    voter: ""
  };
}
const QueryVoteRequest$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryVoteRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.voter !== "" && n.uint32(18).string(e.voter), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryVoteRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.voter = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryVoteRequest$1();
    return o.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, o.voter = (n = e.voter) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      voter: e.voter
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.voter = e.voter, n;
  },
  fromAminoMsg(e) {
    return QueryVoteRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryVoteRequest",
      value: QueryVoteRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryVoteRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryVoteRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryVoteRequest",
      value: QueryVoteRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryVoteResponse$1() {
  return {
    vote: void 0
  };
}
const QueryVoteResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryVoteResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.vote !== void 0 && Vote$1.encode(e.vote, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryVoteResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.vote = Vote$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryVoteResponse$1();
    return n.vote = e.vote !== void 0 && e.vote !== null ? Vote$1.fromPartial(e.vote) : void 0, n;
  },
  fromAmino(e) {
    return {
      vote: e != null && e.vote ? Vote$1.fromAmino(e.vote) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.vote = e.vote ? Vote$1.toAmino(e.vote) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryVoteResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryVoteResponse",
      value: QueryVoteResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryVoteResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryVoteResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryVoteResponse",
      value: QueryVoteResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryVotesRequest$1() {
  return {
    proposalId: Long$2.UZERO,
    pagination: void 0
  };
}
const QueryVotesRequest$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryVotesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryVotesRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryVotesRequest$1();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryVotesRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryVotesRequest",
      value: QueryVotesRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryVotesRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryVotesRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryVotesRequest",
      value: QueryVotesRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryVotesResponse$1() {
  return {
    votes: [],
    pagination: void 0
  };
}
const QueryVotesResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryVotesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.votes)
      Vote$1.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryVotesResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.votes.push(Vote$1.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryVotesResponse$1();
    return o.votes = ((n = e.votes) === null || n === void 0 ? void 0 : n.map((u) => Vote$1.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      votes: Array.isArray(e == null ? void 0 : e.votes) ? e.votes.map((n) => Vote$1.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.votes ? n.votes = e.votes.map((o) => o ? Vote$1.toAmino(o) : void 0) : n.votes = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryVotesResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryVotesResponse",
      value: QueryVotesResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryVotesResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryVotesResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryVotesResponse",
      value: QueryVotesResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$c() {
  return {
    paramsType: ""
  };
}
const QueryParamsRequest$c = {
  typeUrl: "/cosmos.gov.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.paramsType !== "" && n.uint32(10).string(e.paramsType), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$c();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.paramsType = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryParamsRequest$c();
    return o.paramsType = (n = e.paramsType) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      paramsType: e.params_type
    };
  },
  toAmino(e) {
    const n = {};
    return n.params_type = e.paramsType, n;
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$c.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest$c.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$c.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$c.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest$c.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$c() {
  return {
    votingParams: void 0,
    depositParams: void 0,
    tallyParams: void 0
  };
}
const QueryParamsResponse$c = {
  typeUrl: "/cosmos.gov.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.votingParams !== void 0 && VotingParams$1.encode(e.votingParams, n.uint32(10).fork()).ldelim(), e.depositParams !== void 0 && DepositParams$1.encode(e.depositParams, n.uint32(18).fork()).ldelim(), e.tallyParams !== void 0 && TallyParams$1.encode(e.tallyParams, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$c();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.votingParams = VotingParams$1.decode(o, o.uint32());
          break;
        case 2:
          c.depositParams = DepositParams$1.decode(o, o.uint32());
          break;
        case 3:
          c.tallyParams = TallyParams$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$c();
    return n.votingParams = e.votingParams !== void 0 && e.votingParams !== null ? VotingParams$1.fromPartial(e.votingParams) : void 0, n.depositParams = e.depositParams !== void 0 && e.depositParams !== null ? DepositParams$1.fromPartial(e.depositParams) : void 0, n.tallyParams = e.tallyParams !== void 0 && e.tallyParams !== null ? TallyParams$1.fromPartial(e.tallyParams) : void 0, n;
  },
  fromAmino(e) {
    return {
      votingParams: e != null && e.voting_params ? VotingParams$1.fromAmino(e.voting_params) : void 0,
      depositParams: e != null && e.deposit_params ? DepositParams$1.fromAmino(e.deposit_params) : void 0,
      tallyParams: e != null && e.tally_params ? TallyParams$1.fromAmino(e.tally_params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.voting_params = e.votingParams ? VotingParams$1.toAmino(e.votingParams) : void 0, n.deposit_params = e.depositParams ? DepositParams$1.toAmino(e.depositParams) : void 0, n.tally_params = e.tallyParams ? TallyParams$1.toAmino(e.tallyParams) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$c.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse$c.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$c.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$c.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse$c.encode(e).finish()
    };
  }
};
function createBaseQueryDepositRequest$1() {
  return {
    proposalId: Long$2.UZERO,
    depositor: ""
  };
}
const QueryDepositRequest$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryDepositRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.depositor !== "" && n.uint32(18).string(e.depositor), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDepositRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.depositor = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDepositRequest$1();
    return o.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, o.depositor = (n = e.depositor) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      depositor: e.depositor
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.depositor = e.depositor, n;
  },
  fromAminoMsg(e) {
    return QueryDepositRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDepositRequest",
      value: QueryDepositRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDepositRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryDepositRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryDepositRequest",
      value: QueryDepositRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryDepositResponse$1() {
  return {
    deposit: void 0
  };
}
const QueryDepositResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryDepositResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.deposit !== void 0 && Deposit$1.encode(e.deposit, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDepositResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.deposit = Deposit$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDepositResponse$1();
    return n.deposit = e.deposit !== void 0 && e.deposit !== null ? Deposit$1.fromPartial(e.deposit) : void 0, n;
  },
  fromAmino(e) {
    return {
      deposit: e != null && e.deposit ? Deposit$1.fromAmino(e.deposit) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.deposit = e.deposit ? Deposit$1.toAmino(e.deposit) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDepositResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDepositResponse",
      value: QueryDepositResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDepositResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryDepositResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryDepositResponse",
      value: QueryDepositResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryDepositsRequest$1() {
  return {
    proposalId: Long$2.UZERO,
    pagination: void 0
  };
}
const QueryDepositsRequest$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryDepositsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDepositsRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDepositsRequest$1();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDepositsRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDepositsRequest",
      value: QueryDepositsRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDepositsRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryDepositsRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryDepositsRequest",
      value: QueryDepositsRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryDepositsResponse$1() {
  return {
    deposits: [],
    pagination: void 0
  };
}
const QueryDepositsResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryDepositsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.deposits)
      Deposit$1.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDepositsResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.deposits.push(Deposit$1.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDepositsResponse$1();
    return o.deposits = ((n = e.deposits) === null || n === void 0 ? void 0 : n.map((u) => Deposit$1.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      deposits: Array.isArray(e == null ? void 0 : e.deposits) ? e.deposits.map((n) => Deposit$1.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.deposits ? n.deposits = e.deposits.map((o) => o ? Deposit$1.toAmino(o) : void 0) : n.deposits = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDepositsResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDepositsResponse",
      value: QueryDepositsResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDepositsResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryDepositsResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryDepositsResponse",
      value: QueryDepositsResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryTallyResultRequest$1() {
  return {
    proposalId: Long$2.UZERO
  };
}
const QueryTallyResultRequest$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTallyResultRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTallyResultRequest$1();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTallyResultRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTallyResultRequest",
      value: QueryTallyResultRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTallyResultRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryTallyResultRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultRequest",
      value: QueryTallyResultRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryTallyResultResponse$1() {
  return {
    tally: void 0
  };
}
const QueryTallyResultResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tally !== void 0 && TallyResult$1.encode(e.tally, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTallyResultResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tally = TallyResult$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTallyResultResponse$1();
    return n.tally = e.tally !== void 0 && e.tally !== null ? TallyResult$1.fromPartial(e.tally) : void 0, n;
  },
  fromAmino(e) {
    return {
      tally: e != null && e.tally ? TallyResult$1.fromAmino(e.tally) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.tally = e.tally ? TallyResult$1.toAmino(e.tally) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTallyResultResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTallyResultResponse",
      value: QueryTallyResultResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTallyResultResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryTallyResultResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultResponse",
      value: QueryTallyResultResponse$1.encode(e).finish()
    };
  }
}, _31 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryDepositRequest: QueryDepositRequest$1,
  QueryDepositResponse: QueryDepositResponse$1,
  QueryDepositsRequest: QueryDepositsRequest$1,
  QueryDepositsResponse: QueryDepositsResponse$1,
  QueryParamsRequest: QueryParamsRequest$c,
  QueryParamsResponse: QueryParamsResponse$c,
  QueryProposalRequest: QueryProposalRequest$1,
  QueryProposalResponse: QueryProposalResponse$1,
  QueryProposalsRequest: QueryProposalsRequest$1,
  QueryProposalsResponse: QueryProposalsResponse$1,
  QueryTallyResultRequest: QueryTallyResultRequest$1,
  QueryTallyResultResponse: QueryTallyResultResponse$1,
  QueryVoteRequest: QueryVoteRequest$1,
  QueryVoteResponse: QueryVoteResponse$1,
  QueryVotesRequest: QueryVotesRequest$1,
  QueryVotesResponse: QueryVotesResponse$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSubmitProposal$1() {
  return {
    content: void 0,
    initialDeposit: [],
    proposer: "",
    isExpedited: !1
  };
}
const MsgSubmitProposal$1 = {
  typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
  encode(e, n = minimal.Writer.create()) {
    e.content !== void 0 && Any.encode(e.content, n.uint32(10).fork()).ldelim();
    for (const o of e.initialDeposit)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return e.proposer !== "" && n.uint32(26).string(e.proposer), e.isExpedited === !0 && n.uint32(32).bool(e.isExpedited), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSubmitProposal$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.content = Content_InterfaceDecoder(o);
          break;
        case 2:
          c.initialDeposit.push(Coin.decode(o, o.uint32()));
          break;
        case 3:
          c.proposer = o.string();
          break;
        case 4:
          c.isExpedited = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgSubmitProposal$1();
    return c.content = e.content !== void 0 && e.content !== null ? Any.fromPartial(e.content) : void 0, c.initialDeposit = ((n = e.initialDeposit) === null || n === void 0 ? void 0 : n.map((d) => Coin.fromPartial(d))) || [], c.proposer = (o = e.proposer) !== null && o !== void 0 ? o : "", c.isExpedited = (u = e.isExpedited) !== null && u !== void 0 ? u : !1, c;
  },
  fromAmino(e) {
    return {
      content: e != null && e.content ? Content_FromAmino(e.content) : void 0,
      initialDeposit: Array.isArray(e == null ? void 0 : e.initial_deposit) ? e.initial_deposit.map((n) => Coin.fromAmino(n)) : [],
      proposer: e.proposer,
      isExpedited: e.is_expedited
    };
  },
  toAmino(e) {
    const n = {};
    return n.content = e.content ? Content_ToAmino(e.content) : void 0, e.initialDeposit ? n.initial_deposit = e.initialDeposit.map((o) => o ? Coin.toAmino(o) : void 0) : n.initial_deposit = [], n.proposer = e.proposer, n.is_expedited = e.isExpedited, n;
  },
  fromAminoMsg(e) {
    return MsgSubmitProposal$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgSubmitProposal",
      value: MsgSubmitProposal$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSubmitProposal$1.decode(e.value);
  },
  toProto(e) {
    return MsgSubmitProposal$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
      value: MsgSubmitProposal$1.encode(e).finish()
    };
  }
};
function createBaseMsgSubmitProposalResponse$1() {
  return {
    proposalId: Long$2.UZERO
  };
}
const MsgSubmitProposalResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposalResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSubmitProposalResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgSubmitProposalResponse$1();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSubmitProposalResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSubmitProposalResponse",
      value: MsgSubmitProposalResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSubmitProposalResponse$1.decode(e.value);
  },
  toProto(e) {
    return MsgSubmitProposalResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposalResponse",
      value: MsgSubmitProposalResponse$1.encode(e).finish()
    };
  }
};
function createBaseMsgVote$1() {
  return {
    proposalId: Long$2.UZERO,
    voter: "",
    option: 0
  };
}
const MsgVote$1 = {
  typeUrl: "/cosmos.gov.v1beta1.MsgVote",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.voter !== "" && n.uint32(18).string(e.voter), e.option !== 0 && n.uint32(24).int32(e.option), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgVote$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.voter = o.string();
          break;
        case 3:
          c.option = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgVote$1();
    return u.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, u.voter = (n = e.voter) !== null && n !== void 0 ? n : "", u.option = (o = e.option) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      voter: e.voter,
      option: isSet(e.option) ? voteOptionFromJSON$1(e.option) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.voter = e.voter, n.option = e.option, n;
  },
  fromAminoMsg(e) {
    return MsgVote$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgVote",
      value: MsgVote$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgVote$1.decode(e.value);
  },
  toProto(e) {
    return MsgVote$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgVote",
      value: MsgVote$1.encode(e).finish()
    };
  }
};
function createBaseMsgVoteResponse$1() {
  return {};
}
const MsgVoteResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.MsgVoteResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgVoteResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgVoteResponse$1();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgVoteResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgVoteResponse",
      value: MsgVoteResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgVoteResponse$1.decode(e.value);
  },
  toProto(e) {
    return MsgVoteResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgVoteResponse",
      value: MsgVoteResponse$1.encode(e).finish()
    };
  }
};
function createBaseMsgVoteWeighted$1() {
  return {
    proposalId: Long$2.UZERO,
    voter: "",
    options: []
  };
}
const MsgVoteWeighted$1 = {
  typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.voter !== "" && n.uint32(18).string(e.voter);
    for (const o of e.options)
      WeightedVoteOption$1.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgVoteWeighted$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.voter = o.string();
          break;
        case 3:
          c.options.push(WeightedVoteOption$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgVoteWeighted$1();
    return u.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, u.voter = (n = e.voter) !== null && n !== void 0 ? n : "", u.options = ((o = e.options) === null || o === void 0 ? void 0 : o.map((c) => WeightedVoteOption$1.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      voter: e.voter,
      options: Array.isArray(e == null ? void 0 : e.options) ? e.options.map((n) => WeightedVoteOption$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.voter = e.voter, e.options ? n.options = e.options.map((o) => o ? WeightedVoteOption$1.toAmino(o) : void 0) : n.options = [], n;
  },
  fromAminoMsg(e) {
    return MsgVoteWeighted$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgVoteWeighted",
      value: MsgVoteWeighted$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgVoteWeighted$1.decode(e.value);
  },
  toProto(e) {
    return MsgVoteWeighted$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
      value: MsgVoteWeighted$1.encode(e).finish()
    };
  }
};
function createBaseMsgVoteWeightedResponse$1() {
  return {};
}
const MsgVoteWeightedResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeightedResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgVoteWeightedResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgVoteWeightedResponse$1();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgVoteWeightedResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgVoteWeightedResponse",
      value: MsgVoteWeightedResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgVoteWeightedResponse$1.decode(e.value);
  },
  toProto(e) {
    return MsgVoteWeightedResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeightedResponse",
      value: MsgVoteWeightedResponse$1.encode(e).finish()
    };
  }
};
function createBaseMsgDeposit$1() {
  return {
    proposalId: Long$2.UZERO,
    depositor: "",
    amount: []
  };
}
const MsgDeposit$1 = {
  typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.depositor !== "" && n.uint32(18).string(e.depositor);
    for (const o of e.amount)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDeposit$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.depositor = o.string();
          break;
        case 3:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgDeposit$1();
    return u.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, u.depositor = (n = e.depositor) !== null && n !== void 0 ? n : "", u.amount = ((o = e.amount) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      depositor: e.depositor,
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.depositor = e.depositor, e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n;
  },
  fromAminoMsg(e) {
    return MsgDeposit$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgDeposit",
      value: MsgDeposit$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDeposit$1.decode(e.value);
  },
  toProto(e) {
    return MsgDeposit$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
      value: MsgDeposit$1.encode(e).finish()
    };
  }
};
function createBaseMsgDepositResponse$1() {
  return {};
}
const MsgDepositResponse$1 = {
  typeUrl: "/cosmos.gov.v1beta1.MsgDepositResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDepositResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgDepositResponse$1();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgDepositResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgDepositResponse",
      value: MsgDepositResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDepositResponse$1.decode(e.value);
  },
  toProto(e) {
    return MsgDepositResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgDepositResponse",
      value: MsgDepositResponse$1.encode(e).finish()
    };
  }
}, Content_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/cosmos.gov.v1beta1.TextProposal":
      return TextProposal.decode(o.value);
    default:
      return o;
  }
}, Content_FromAmino = (e) => {
  switch (e.type) {
    case "cosmos-sdk/TextProposal":
      return Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.TextProposal",
        value: TextProposal.encode(TextProposal.fromPartial(TextProposal.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, Content_ToAmino = (e) => {
  switch (e.typeUrl) {
    case "/cosmos.gov.v1beta1.TextProposal":
      return {
        type: "cosmos-sdk/TextProposal",
        value: TextProposal.toAmino(TextProposal.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _32 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Content_FromAmino,
  Content_InterfaceDecoder,
  Content_ToAmino,
  MsgDeposit: MsgDeposit$1,
  MsgDepositResponse: MsgDepositResponse$1,
  MsgSubmitProposal: MsgSubmitProposal$1,
  MsgSubmitProposalResponse: MsgSubmitProposalResponse$1,
  MsgVote: MsgVote$1,
  MsgVoteResponse: MsgVoteResponse$1,
  MsgVoteWeighted: MsgVoteWeighted$1,
  MsgVoteWeightedResponse: MsgVoteWeightedResponse$1
}, Symbol.toStringTag, { value: "Module" }));
let VoteOption;
(function(e) {
  e[e.VOTE_OPTION_UNSPECIFIED = 0] = "VOTE_OPTION_UNSPECIFIED", e[e.VOTE_OPTION_YES = 1] = "VOTE_OPTION_YES", e[e.VOTE_OPTION_ABSTAIN = 2] = "VOTE_OPTION_ABSTAIN", e[e.VOTE_OPTION_NO = 3] = "VOTE_OPTION_NO", e[e.VOTE_OPTION_NO_WITH_VETO = 4] = "VOTE_OPTION_NO_WITH_VETO", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(VoteOption || (VoteOption = {}));
const VoteOptionSDKType = VoteOption, VoteOptionAmino = VoteOption;
function voteOptionFromJSON(e) {
  switch (e) {
    case 0:
    case "VOTE_OPTION_UNSPECIFIED":
      return VoteOption.VOTE_OPTION_UNSPECIFIED;
    case 1:
    case "VOTE_OPTION_YES":
      return VoteOption.VOTE_OPTION_YES;
    case 2:
    case "VOTE_OPTION_ABSTAIN":
      return VoteOption.VOTE_OPTION_ABSTAIN;
    case 3:
    case "VOTE_OPTION_NO":
      return VoteOption.VOTE_OPTION_NO;
    case 4:
    case "VOTE_OPTION_NO_WITH_VETO":
      return VoteOption.VOTE_OPTION_NO_WITH_VETO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VoteOption.UNRECOGNIZED;
  }
}
function voteOptionToJSON(e) {
  switch (e) {
    case VoteOption.VOTE_OPTION_UNSPECIFIED:
      return "VOTE_OPTION_UNSPECIFIED";
    case VoteOption.VOTE_OPTION_YES:
      return "VOTE_OPTION_YES";
    case VoteOption.VOTE_OPTION_ABSTAIN:
      return "VOTE_OPTION_ABSTAIN";
    case VoteOption.VOTE_OPTION_NO:
      return "VOTE_OPTION_NO";
    case VoteOption.VOTE_OPTION_NO_WITH_VETO:
      return "VOTE_OPTION_NO_WITH_VETO";
    case VoteOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ProposalStatus;
(function(e) {
  e[e.PROPOSAL_STATUS_UNSPECIFIED = 0] = "PROPOSAL_STATUS_UNSPECIFIED", e[e.PROPOSAL_STATUS_DEPOSIT_PERIOD = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD", e[e.PROPOSAL_STATUS_VOTING_PERIOD = 2] = "PROPOSAL_STATUS_VOTING_PERIOD", e[e.PROPOSAL_STATUS_PASSED = 3] = "PROPOSAL_STATUS_PASSED", e[e.PROPOSAL_STATUS_REJECTED = 4] = "PROPOSAL_STATUS_REJECTED", e[e.PROPOSAL_STATUS_FAILED = 5] = "PROPOSAL_STATUS_FAILED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ProposalStatus || (ProposalStatus = {}));
const ProposalStatusSDKType = ProposalStatus, ProposalStatusAmino = ProposalStatus;
function proposalStatusFromJSON(e) {
  switch (e) {
    case 0:
    case "PROPOSAL_STATUS_UNSPECIFIED":
      return ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
    case 1:
    case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
      return ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
    case 2:
    case "PROPOSAL_STATUS_VOTING_PERIOD":
      return ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
    case 3:
    case "PROPOSAL_STATUS_PASSED":
      return ProposalStatus.PROPOSAL_STATUS_PASSED;
    case 4:
    case "PROPOSAL_STATUS_REJECTED":
      return ProposalStatus.PROPOSAL_STATUS_REJECTED;
    case 5:
    case "PROPOSAL_STATUS_FAILED":
      return ProposalStatus.PROPOSAL_STATUS_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProposalStatus.UNRECOGNIZED;
  }
}
function proposalStatusToJSON(e) {
  switch (e) {
    case ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
      return "PROPOSAL_STATUS_UNSPECIFIED";
    case ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
      return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    case ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
      return "PROPOSAL_STATUS_VOTING_PERIOD";
    case ProposalStatus.PROPOSAL_STATUS_PASSED:
      return "PROPOSAL_STATUS_PASSED";
    case ProposalStatus.PROPOSAL_STATUS_REJECTED:
      return "PROPOSAL_STATUS_REJECTED";
    case ProposalStatus.PROPOSAL_STATUS_FAILED:
      return "PROPOSAL_STATUS_FAILED";
    case ProposalStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseWeightedVoteOption() {
  return {
    option: 0,
    weight: ""
  };
}
const WeightedVoteOption = {
  typeUrl: "/cosmos.gov.v1.WeightedVoteOption",
  encode(e, n = minimal.Writer.create()) {
    return e.option !== 0 && n.uint32(8).int32(e.option), e.weight !== "" && n.uint32(18).string(e.weight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseWeightedVoteOption();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.option = o.int32();
          break;
        case 2:
          c.weight = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseWeightedVoteOption();
    return u.option = (n = e.option) !== null && n !== void 0 ? n : 0, u.weight = (o = e.weight) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      option: isSet(e.option) ? voteOptionFromJSON(e.option) : 0,
      weight: e.weight
    };
  },
  toAmino(e) {
    const n = {};
    return n.option = e.option, n.weight = e.weight, n;
  },
  fromAminoMsg(e) {
    return WeightedVoteOption.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/WeightedVoteOption",
      value: WeightedVoteOption.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return WeightedVoteOption.decode(e.value);
  },
  toProto(e) {
    return WeightedVoteOption.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.WeightedVoteOption",
      value: WeightedVoteOption.encode(e).finish()
    };
  }
};
function createBaseDeposit() {
  return {
    proposalId: Long$2.UZERO,
    depositor: "",
    amount: []
  };
}
const Deposit = {
  typeUrl: "/cosmos.gov.v1.Deposit",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.depositor !== "" && n.uint32(18).string(e.depositor);
    for (const o of e.amount)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDeposit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.depositor = o.string();
          break;
        case 3:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDeposit();
    return u.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, u.depositor = (n = e.depositor) !== null && n !== void 0 ? n : "", u.amount = ((o = e.amount) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      depositor: e.depositor,
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.depositor = e.depositor, e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n;
  },
  fromAminoMsg(e) {
    return Deposit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/Deposit",
      value: Deposit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Deposit.decode(e.value);
  },
  toProto(e) {
    return Deposit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.Deposit",
      value: Deposit.encode(e).finish()
    };
  }
};
function createBaseProposal() {
  return {
    id: Long$2.UZERO,
    messages: [],
    status: 0,
    finalTallyResult: void 0,
    submitTime: void 0,
    depositEndTime: void 0,
    totalDeposit: [],
    votingStartTime: void 0,
    votingEndTime: void 0,
    metadata: ""
  };
}
const Proposal = {
  typeUrl: "/cosmos.gov.v1.Proposal",
  encode(e, n = minimal.Writer.create()) {
    e.id.isZero() || n.uint32(8).uint64(e.id);
    for (const o of e.messages)
      Any.encode(o, n.uint32(18).fork()).ldelim();
    e.status !== 0 && n.uint32(24).int32(e.status), e.finalTallyResult !== void 0 && TallyResult.encode(e.finalTallyResult, n.uint32(34).fork()).ldelim(), e.submitTime !== void 0 && Timestamp.encode(toTimestamp(e.submitTime), n.uint32(42).fork()).ldelim(), e.depositEndTime !== void 0 && Timestamp.encode(toTimestamp(e.depositEndTime), n.uint32(50).fork()).ldelim();
    for (const o of e.totalDeposit)
      Coin.encode(o, n.uint32(58).fork()).ldelim();
    return e.votingStartTime !== void 0 && Timestamp.encode(toTimestamp(e.votingStartTime), n.uint32(66).fork()).ldelim(), e.votingEndTime !== void 0 && Timestamp.encode(toTimestamp(e.votingEndTime), n.uint32(74).fork()).ldelim(), e.metadata !== "" && n.uint32(82).string(e.metadata), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.id = o.uint64();
          break;
        case 2:
          c.messages.push(Any.decode(o, o.uint32()));
          break;
        case 3:
          c.status = o.int32();
          break;
        case 4:
          c.finalTallyResult = TallyResult.decode(o, o.uint32());
          break;
        case 5:
          c.submitTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 6:
          c.depositEndTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 7:
          c.totalDeposit.push(Coin.decode(o, o.uint32()));
          break;
        case 8:
          c.votingStartTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 9:
          c.votingEndTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 10:
          c.metadata = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S;
    const $ = createBaseProposal();
    return $.id = e.id !== void 0 && e.id !== null ? Long$2.fromValue(e.id) : Long$2.UZERO, $.messages = ((n = e.messages) === null || n === void 0 ? void 0 : n.map((E) => Any.fromPartial(E))) || [], $.status = (o = e.status) !== null && o !== void 0 ? o : 0, $.finalTallyResult = e.finalTallyResult !== void 0 && e.finalTallyResult !== null ? TallyResult.fromPartial(e.finalTallyResult) : void 0, $.submitTime = (u = e.submitTime) !== null && u !== void 0 ? u : void 0, $.depositEndTime = (c = e.depositEndTime) !== null && c !== void 0 ? c : void 0, $.totalDeposit = ((d = e.totalDeposit) === null || d === void 0 ? void 0 : d.map((E) => Coin.fromPartial(E))) || [], $.votingStartTime = (m = e.votingStartTime) !== null && m !== void 0 ? m : void 0, $.votingEndTime = (v = e.votingEndTime) !== null && v !== void 0 ? v : void 0, $.metadata = (S = e.metadata) !== null && S !== void 0 ? S : "", $;
  },
  fromAmino(e) {
    return {
      id: Long$2.fromString(e.id),
      messages: Array.isArray(e == null ? void 0 : e.messages) ? e.messages.map((n) => Any.fromAmino(n)) : [],
      status: isSet(e.status) ? proposalStatusFromJSON(e.status) : 0,
      finalTallyResult: e != null && e.final_tally_result ? TallyResult.fromAmino(e.final_tally_result) : void 0,
      submitTime: e != null && e.submit_time ? Timestamp.fromAmino(e.submit_time) : void 0,
      depositEndTime: e != null && e.deposit_end_time ? Timestamp.fromAmino(e.deposit_end_time) : void 0,
      totalDeposit: Array.isArray(e == null ? void 0 : e.total_deposit) ? e.total_deposit.map((n) => Coin.fromAmino(n)) : [],
      votingStartTime: e != null && e.voting_start_time ? Timestamp.fromAmino(e.voting_start_time) : void 0,
      votingEndTime: e != null && e.voting_end_time ? Timestamp.fromAmino(e.voting_end_time) : void 0,
      metadata: e.metadata
    };
  },
  toAmino(e) {
    const n = {};
    return n.id = e.id ? e.id.toString() : void 0, e.messages ? n.messages = e.messages.map((o) => o ? Any.toAmino(o) : void 0) : n.messages = [], n.status = e.status, n.final_tally_result = e.finalTallyResult ? TallyResult.toAmino(e.finalTallyResult) : void 0, n.submit_time = e.submitTime ? Timestamp.toAmino(e.submitTime) : void 0, n.deposit_end_time = e.depositEndTime ? Timestamp.toAmino(e.depositEndTime) : void 0, e.totalDeposit ? n.total_deposit = e.totalDeposit.map((o) => o ? Coin.toAmino(o) : void 0) : n.total_deposit = [], n.voting_start_time = e.votingStartTime ? Timestamp.toAmino(e.votingStartTime) : void 0, n.voting_end_time = e.votingEndTime ? Timestamp.toAmino(e.votingEndTime) : void 0, n.metadata = e.metadata, n;
  },
  fromAminoMsg(e) {
    return Proposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/Proposal",
      value: Proposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Proposal.decode(e.value);
  },
  toProto(e) {
    return Proposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.Proposal",
      value: Proposal.encode(e).finish()
    };
  }
};
function createBaseTallyResult() {
  return {
    yesCount: "",
    abstainCount: "",
    noCount: "",
    noWithVetoCount: ""
  };
}
const TallyResult = {
  typeUrl: "/cosmos.gov.v1.TallyResult",
  encode(e, n = minimal.Writer.create()) {
    return e.yesCount !== "" && n.uint32(10).string(e.yesCount), e.abstainCount !== "" && n.uint32(18).string(e.abstainCount), e.noCount !== "" && n.uint32(26).string(e.noCount), e.noWithVetoCount !== "" && n.uint32(34).string(e.noWithVetoCount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTallyResult();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.yesCount = o.string();
          break;
        case 2:
          c.abstainCount = o.string();
          break;
        case 3:
          c.noCount = o.string();
          break;
        case 4:
          c.noWithVetoCount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseTallyResult();
    return d.yesCount = (n = e.yesCount) !== null && n !== void 0 ? n : "", d.abstainCount = (o = e.abstainCount) !== null && o !== void 0 ? o : "", d.noCount = (u = e.noCount) !== null && u !== void 0 ? u : "", d.noWithVetoCount = (c = e.noWithVetoCount) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      yesCount: e.yes_count,
      abstainCount: e.abstain_count,
      noCount: e.no_count,
      noWithVetoCount: e.no_with_veto_count
    };
  },
  toAmino(e) {
    const n = {};
    return n.yes_count = e.yesCount, n.abstain_count = e.abstainCount, n.no_count = e.noCount, n.no_with_veto_count = e.noWithVetoCount, n;
  },
  fromAminoMsg(e) {
    return TallyResult.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/TallyResult",
      value: TallyResult.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TallyResult.decode(e.value);
  },
  toProto(e) {
    return TallyResult.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.TallyResult",
      value: TallyResult.encode(e).finish()
    };
  }
};
function createBaseVote() {
  return {
    proposalId: Long$2.UZERO,
    voter: "",
    options: [],
    metadata: ""
  };
}
const Vote = {
  typeUrl: "/cosmos.gov.v1.Vote",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.voter !== "" && n.uint32(18).string(e.voter);
    for (const o of e.options)
      WeightedVoteOption.encode(o, n.uint32(34).fork()).ldelim();
    return e.metadata !== "" && n.uint32(42).string(e.metadata), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseVote();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.voter = o.string();
          break;
        case 4:
          c.options.push(WeightedVoteOption.decode(o, o.uint32()));
          break;
        case 5:
          c.metadata = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseVote();
    return c.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, c.voter = (n = e.voter) !== null && n !== void 0 ? n : "", c.options = ((o = e.options) === null || o === void 0 ? void 0 : o.map((d) => WeightedVoteOption.fromPartial(d))) || [], c.metadata = (u = e.metadata) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      voter: e.voter,
      options: Array.isArray(e == null ? void 0 : e.options) ? e.options.map((n) => WeightedVoteOption.fromAmino(n)) : [],
      metadata: e.metadata
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.voter = e.voter, e.options ? n.options = e.options.map((o) => o ? WeightedVoteOption.toAmino(o) : void 0) : n.options = [], n.metadata = e.metadata, n;
  },
  fromAminoMsg(e) {
    return Vote.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/Vote",
      value: Vote.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Vote.decode(e.value);
  },
  toProto(e) {
    return Vote.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.Vote",
      value: Vote.encode(e).finish()
    };
  }
};
function createBaseDepositParams() {
  return {
    minDeposit: [],
    maxDepositPeriod: void 0
  };
}
const DepositParams = {
  typeUrl: "/cosmos.gov.v1.DepositParams",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.minDeposit)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return e.maxDepositPeriod !== void 0 && Duration.encode(e.maxDepositPeriod, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDepositParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.minDeposit.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.maxDepositPeriod = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDepositParams();
    return o.minDeposit = ((n = e.minDeposit) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o.maxDepositPeriod = e.maxDepositPeriod !== void 0 && e.maxDepositPeriod !== null ? Duration.fromPartial(e.maxDepositPeriod) : void 0, o;
  },
  fromAmino(e) {
    return {
      minDeposit: Array.isArray(e == null ? void 0 : e.min_deposit) ? e.min_deposit.map((n) => Coin.fromAmino(n)) : [],
      maxDepositPeriod: e != null && e.max_deposit_period ? Duration.fromAmino(e.max_deposit_period) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.minDeposit ? n.min_deposit = e.minDeposit.map((o) => o ? Coin.toAmino(o) : void 0) : n.min_deposit = [], n.max_deposit_period = e.maxDepositPeriod ? Duration.toAmino(e.maxDepositPeriod) : void 0, n;
  },
  fromAminoMsg(e) {
    return DepositParams.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/DepositParams",
      value: DepositParams.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DepositParams.decode(e.value);
  },
  toProto(e) {
    return DepositParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.DepositParams",
      value: DepositParams.encode(e).finish()
    };
  }
};
function createBaseVotingParams() {
  return {
    votingPeriod: void 0
  };
}
const VotingParams = {
  typeUrl: "/cosmos.gov.v1.VotingParams",
  encode(e, n = minimal.Writer.create()) {
    return e.votingPeriod !== void 0 && Duration.encode(e.votingPeriod, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseVotingParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.votingPeriod = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseVotingParams();
    return n.votingPeriod = e.votingPeriod !== void 0 && e.votingPeriod !== null ? Duration.fromPartial(e.votingPeriod) : void 0, n;
  },
  fromAmino(e) {
    return {
      votingPeriod: e != null && e.voting_period ? Duration.fromAmino(e.voting_period) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.voting_period = e.votingPeriod ? Duration.toAmino(e.votingPeriod) : void 0, n;
  },
  fromAminoMsg(e) {
    return VotingParams.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/VotingParams",
      value: VotingParams.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return VotingParams.decode(e.value);
  },
  toProto(e) {
    return VotingParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.VotingParams",
      value: VotingParams.encode(e).finish()
    };
  }
};
function createBaseTallyParams() {
  return {
    quorum: "",
    threshold: "",
    vetoThreshold: ""
  };
}
const TallyParams = {
  typeUrl: "/cosmos.gov.v1.TallyParams",
  encode(e, n = minimal.Writer.create()) {
    return e.quorum !== "" && n.uint32(10).string(e.quorum), e.threshold !== "" && n.uint32(18).string(e.threshold), e.vetoThreshold !== "" && n.uint32(26).string(e.vetoThreshold), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTallyParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.quorum = o.string();
          break;
        case 2:
          c.threshold = o.string();
          break;
        case 3:
          c.vetoThreshold = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseTallyParams();
    return c.quorum = (n = e.quorum) !== null && n !== void 0 ? n : "", c.threshold = (o = e.threshold) !== null && o !== void 0 ? o : "", c.vetoThreshold = (u = e.vetoThreshold) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      quorum: e.quorum,
      threshold: e.threshold,
      vetoThreshold: e.veto_threshold
    };
  },
  toAmino(e) {
    const n = {};
    return n.quorum = e.quorum, n.threshold = e.threshold, n.veto_threshold = e.vetoThreshold, n;
  },
  fromAminoMsg(e) {
    return TallyParams.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/TallyParams",
      value: TallyParams.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TallyParams.decode(e.value);
  },
  toProto(e) {
    return TallyParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.TallyParams",
      value: TallyParams.encode(e).finish()
    };
  }
}, _34 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Deposit,
  DepositParams,
  Proposal,
  get ProposalStatus() {
    return ProposalStatus;
  },
  ProposalStatusAmino,
  ProposalStatusSDKType,
  TallyParams,
  TallyResult,
  Vote,
  get VoteOption() {
    return VoteOption;
  },
  VoteOptionAmino,
  VoteOptionSDKType,
  VotingParams,
  WeightedVoteOption,
  proposalStatusFromJSON,
  proposalStatusToJSON,
  voteOptionFromJSON,
  voteOptionToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$o() {
  return {
    startingProposalId: Long$2.UZERO,
    deposits: [],
    votes: [],
    proposals: [],
    depositParams: void 0,
    votingParams: void 0,
    tallyParams: void 0
  };
}
const GenesisState$o = {
  typeUrl: "/cosmos.gov.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.startingProposalId.isZero() || n.uint32(8).uint64(e.startingProposalId);
    for (const o of e.deposits)
      Deposit.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.votes)
      Vote.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.proposals)
      Proposal.encode(o, n.uint32(34).fork()).ldelim();
    return e.depositParams !== void 0 && DepositParams.encode(e.depositParams, n.uint32(42).fork()).ldelim(), e.votingParams !== void 0 && VotingParams.encode(e.votingParams, n.uint32(50).fork()).ldelim(), e.tallyParams !== void 0 && TallyParams.encode(e.tallyParams, n.uint32(58).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$o();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.startingProposalId = o.uint64();
          break;
        case 2:
          c.deposits.push(Deposit.decode(o, o.uint32()));
          break;
        case 3:
          c.votes.push(Vote.decode(o, o.uint32()));
          break;
        case 4:
          c.proposals.push(Proposal.decode(o, o.uint32()));
          break;
        case 5:
          c.depositParams = DepositParams.decode(o, o.uint32());
          break;
        case 6:
          c.votingParams = VotingParams.decode(o, o.uint32());
          break;
        case 7:
          c.tallyParams = TallyParams.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseGenesisState$o();
    return c.startingProposalId = e.startingProposalId !== void 0 && e.startingProposalId !== null ? Long$2.fromValue(e.startingProposalId) : Long$2.UZERO, c.deposits = ((n = e.deposits) === null || n === void 0 ? void 0 : n.map((d) => Deposit.fromPartial(d))) || [], c.votes = ((o = e.votes) === null || o === void 0 ? void 0 : o.map((d) => Vote.fromPartial(d))) || [], c.proposals = ((u = e.proposals) === null || u === void 0 ? void 0 : u.map((d) => Proposal.fromPartial(d))) || [], c.depositParams = e.depositParams !== void 0 && e.depositParams !== null ? DepositParams.fromPartial(e.depositParams) : void 0, c.votingParams = e.votingParams !== void 0 && e.votingParams !== null ? VotingParams.fromPartial(e.votingParams) : void 0, c.tallyParams = e.tallyParams !== void 0 && e.tallyParams !== null ? TallyParams.fromPartial(e.tallyParams) : void 0, c;
  },
  fromAmino(e) {
    return {
      startingProposalId: Long$2.fromString(e.starting_proposal_id),
      deposits: Array.isArray(e == null ? void 0 : e.deposits) ? e.deposits.map((n) => Deposit.fromAmino(n)) : [],
      votes: Array.isArray(e == null ? void 0 : e.votes) ? e.votes.map((n) => Vote.fromAmino(n)) : [],
      proposals: Array.isArray(e == null ? void 0 : e.proposals) ? e.proposals.map((n) => Proposal.fromAmino(n)) : [],
      depositParams: e != null && e.deposit_params ? DepositParams.fromAmino(e.deposit_params) : void 0,
      votingParams: e != null && e.voting_params ? VotingParams.fromAmino(e.voting_params) : void 0,
      tallyParams: e != null && e.tally_params ? TallyParams.fromAmino(e.tally_params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.starting_proposal_id = e.startingProposalId ? e.startingProposalId.toString() : void 0, e.deposits ? n.deposits = e.deposits.map((o) => o ? Deposit.toAmino(o) : void 0) : n.deposits = [], e.votes ? n.votes = e.votes.map((o) => o ? Vote.toAmino(o) : void 0) : n.votes = [], e.proposals ? n.proposals = e.proposals.map((o) => o ? Proposal.toAmino(o) : void 0) : n.proposals = [], n.deposit_params = e.depositParams ? DepositParams.toAmino(e.depositParams) : void 0, n.voting_params = e.votingParams ? VotingParams.toAmino(e.votingParams) : void 0, n.tally_params = e.tallyParams ? TallyParams.toAmino(e.tallyParams) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$o.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/GenesisState",
      value: GenesisState$o.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$o.decode(e.value);
  },
  toProto(e) {
    return GenesisState$o.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.GenesisState",
      value: GenesisState$o.encode(e).finish()
    };
  }
}, _33 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$o
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryProposalRequest() {
  return {
    proposalId: Long$2.UZERO
  };
}
const QueryProposalRequest = {
  typeUrl: "/cosmos.gov.v1.QueryProposalRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryProposalRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryProposalRequest();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryProposalRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryProposalRequest",
      value: QueryProposalRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryProposalRequest.decode(e.value);
  },
  toProto(e) {
    return QueryProposalRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryProposalRequest",
      value: QueryProposalRequest.encode(e).finish()
    };
  }
};
function createBaseQueryProposalResponse() {
  return {
    proposal: void 0
  };
}
const QueryProposalResponse = {
  typeUrl: "/cosmos.gov.v1.QueryProposalResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.proposal !== void 0 && Proposal.encode(e.proposal, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryProposalResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposal = Proposal.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryProposalResponse();
    return n.proposal = e.proposal !== void 0 && e.proposal !== null ? Proposal.fromPartial(e.proposal) : void 0, n;
  },
  fromAmino(e) {
    return {
      proposal: e != null && e.proposal ? Proposal.fromAmino(e.proposal) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal = e.proposal ? Proposal.toAmino(e.proposal) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryProposalResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryProposalResponse",
      value: QueryProposalResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryProposalResponse.decode(e.value);
  },
  toProto(e) {
    return QueryProposalResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryProposalResponse",
      value: QueryProposalResponse.encode(e).finish()
    };
  }
};
function createBaseQueryProposalsRequest() {
  return {
    proposalStatus: 0,
    voter: "",
    depositor: "",
    pagination: void 0
  };
}
const QueryProposalsRequest = {
  typeUrl: "/cosmos.gov.v1.QueryProposalsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalStatus !== 0 && n.uint32(8).int32(e.proposalStatus), e.voter !== "" && n.uint32(18).string(e.voter), e.depositor !== "" && n.uint32(26).string(e.depositor), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryProposalsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalStatus = o.int32();
          break;
        case 2:
          c.voter = o.string();
          break;
        case 3:
          c.depositor = o.string();
          break;
        case 4:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryProposalsRequest();
    return c.proposalStatus = (n = e.proposalStatus) !== null && n !== void 0 ? n : 0, c.voter = (o = e.voter) !== null && o !== void 0 ? o : "", c.depositor = (u = e.depositor) !== null && u !== void 0 ? u : "", c.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, c;
  },
  fromAmino(e) {
    return {
      proposalStatus: isSet(e.proposal_status) ? proposalStatusFromJSON(e.proposal_status) : 0,
      voter: e.voter,
      depositor: e.depositor,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_status = e.proposalStatus, n.voter = e.voter, n.depositor = e.depositor, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryProposalsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryProposalsRequest",
      value: QueryProposalsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryProposalsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryProposalsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryProposalsRequest",
      value: QueryProposalsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryProposalsResponse() {
  return {
    proposals: [],
    pagination: void 0
  };
}
const QueryProposalsResponse = {
  typeUrl: "/cosmos.gov.v1.QueryProposalsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.proposals)
      Proposal.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryProposalsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposals.push(Proposal.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryProposalsResponse();
    return o.proposals = ((n = e.proposals) === null || n === void 0 ? void 0 : n.map((u) => Proposal.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      proposals: Array.isArray(e == null ? void 0 : e.proposals) ? e.proposals.map((n) => Proposal.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.proposals ? n.proposals = e.proposals.map((o) => o ? Proposal.toAmino(o) : void 0) : n.proposals = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryProposalsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryProposalsResponse",
      value: QueryProposalsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryProposalsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryProposalsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryProposalsResponse",
      value: QueryProposalsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryVoteRequest() {
  return {
    proposalId: Long$2.UZERO,
    voter: ""
  };
}
const QueryVoteRequest = {
  typeUrl: "/cosmos.gov.v1.QueryVoteRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.voter !== "" && n.uint32(18).string(e.voter), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryVoteRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.voter = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryVoteRequest();
    return o.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, o.voter = (n = e.voter) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      voter: e.voter
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.voter = e.voter, n;
  },
  fromAminoMsg(e) {
    return QueryVoteRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryVoteRequest",
      value: QueryVoteRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryVoteRequest.decode(e.value);
  },
  toProto(e) {
    return QueryVoteRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryVoteRequest",
      value: QueryVoteRequest.encode(e).finish()
    };
  }
};
function createBaseQueryVoteResponse() {
  return {
    vote: void 0
  };
}
const QueryVoteResponse = {
  typeUrl: "/cosmos.gov.v1.QueryVoteResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.vote !== void 0 && Vote.encode(e.vote, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryVoteResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.vote = Vote.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryVoteResponse();
    return n.vote = e.vote !== void 0 && e.vote !== null ? Vote.fromPartial(e.vote) : void 0, n;
  },
  fromAmino(e) {
    return {
      vote: e != null && e.vote ? Vote.fromAmino(e.vote) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.vote = e.vote ? Vote.toAmino(e.vote) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryVoteResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryVoteResponse",
      value: QueryVoteResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryVoteResponse.decode(e.value);
  },
  toProto(e) {
    return QueryVoteResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryVoteResponse",
      value: QueryVoteResponse.encode(e).finish()
    };
  }
};
function createBaseQueryVotesRequest() {
  return {
    proposalId: Long$2.UZERO,
    pagination: void 0
  };
}
const QueryVotesRequest = {
  typeUrl: "/cosmos.gov.v1.QueryVotesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryVotesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryVotesRequest();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryVotesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryVotesRequest",
      value: QueryVotesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryVotesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryVotesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryVotesRequest",
      value: QueryVotesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryVotesResponse() {
  return {
    votes: [],
    pagination: void 0
  };
}
const QueryVotesResponse = {
  typeUrl: "/cosmos.gov.v1.QueryVotesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.votes)
      Vote.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryVotesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.votes.push(Vote.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryVotesResponse();
    return o.votes = ((n = e.votes) === null || n === void 0 ? void 0 : n.map((u) => Vote.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      votes: Array.isArray(e == null ? void 0 : e.votes) ? e.votes.map((n) => Vote.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.votes ? n.votes = e.votes.map((o) => o ? Vote.toAmino(o) : void 0) : n.votes = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryVotesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryVotesResponse",
      value: QueryVotesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryVotesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryVotesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryVotesResponse",
      value: QueryVotesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$b() {
  return {
    paramsType: ""
  };
}
const QueryParamsRequest$b = {
  typeUrl: "/cosmos.gov.v1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.paramsType !== "" && n.uint32(10).string(e.paramsType), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$b();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.paramsType = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryParamsRequest$b();
    return o.paramsType = (n = e.paramsType) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      paramsType: e.params_type
    };
  },
  toAmino(e) {
    const n = {};
    return n.params_type = e.paramsType, n;
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$b.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryParamsRequest",
      value: QueryParamsRequest$b.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$b.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$b.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryParamsRequest",
      value: QueryParamsRequest$b.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$b() {
  return {
    votingParams: void 0,
    depositParams: void 0,
    tallyParams: void 0
  };
}
const QueryParamsResponse$b = {
  typeUrl: "/cosmos.gov.v1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.votingParams !== void 0 && VotingParams.encode(e.votingParams, n.uint32(10).fork()).ldelim(), e.depositParams !== void 0 && DepositParams.encode(e.depositParams, n.uint32(18).fork()).ldelim(), e.tallyParams !== void 0 && TallyParams.encode(e.tallyParams, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$b();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.votingParams = VotingParams.decode(o, o.uint32());
          break;
        case 2:
          c.depositParams = DepositParams.decode(o, o.uint32());
          break;
        case 3:
          c.tallyParams = TallyParams.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$b();
    return n.votingParams = e.votingParams !== void 0 && e.votingParams !== null ? VotingParams.fromPartial(e.votingParams) : void 0, n.depositParams = e.depositParams !== void 0 && e.depositParams !== null ? DepositParams.fromPartial(e.depositParams) : void 0, n.tallyParams = e.tallyParams !== void 0 && e.tallyParams !== null ? TallyParams.fromPartial(e.tallyParams) : void 0, n;
  },
  fromAmino(e) {
    return {
      votingParams: e != null && e.voting_params ? VotingParams.fromAmino(e.voting_params) : void 0,
      depositParams: e != null && e.deposit_params ? DepositParams.fromAmino(e.deposit_params) : void 0,
      tallyParams: e != null && e.tally_params ? TallyParams.fromAmino(e.tally_params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.voting_params = e.votingParams ? VotingParams.toAmino(e.votingParams) : void 0, n.deposit_params = e.depositParams ? DepositParams.toAmino(e.depositParams) : void 0, n.tally_params = e.tallyParams ? TallyParams.toAmino(e.tallyParams) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$b.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryParamsResponse",
      value: QueryParamsResponse$b.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$b.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$b.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryParamsResponse",
      value: QueryParamsResponse$b.encode(e).finish()
    };
  }
};
function createBaseQueryDepositRequest() {
  return {
    proposalId: Long$2.UZERO,
    depositor: ""
  };
}
const QueryDepositRequest = {
  typeUrl: "/cosmos.gov.v1.QueryDepositRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.depositor !== "" && n.uint32(18).string(e.depositor), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDepositRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.depositor = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDepositRequest();
    return o.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, o.depositor = (n = e.depositor) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      depositor: e.depositor
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.depositor = e.depositor, n;
  },
  fromAminoMsg(e) {
    return QueryDepositRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryDepositRequest",
      value: QueryDepositRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDepositRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDepositRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryDepositRequest",
      value: QueryDepositRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDepositResponse() {
  return {
    deposit: void 0
  };
}
const QueryDepositResponse = {
  typeUrl: "/cosmos.gov.v1.QueryDepositResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.deposit !== void 0 && Deposit.encode(e.deposit, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDepositResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.deposit = Deposit.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDepositResponse();
    return n.deposit = e.deposit !== void 0 && e.deposit !== null ? Deposit.fromPartial(e.deposit) : void 0, n;
  },
  fromAmino(e) {
    return {
      deposit: e != null && e.deposit ? Deposit.fromAmino(e.deposit) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.deposit = e.deposit ? Deposit.toAmino(e.deposit) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDepositResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryDepositResponse",
      value: QueryDepositResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDepositResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDepositResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryDepositResponse",
      value: QueryDepositResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDepositsRequest() {
  return {
    proposalId: Long$2.UZERO,
    pagination: void 0
  };
}
const QueryDepositsRequest = {
  typeUrl: "/cosmos.gov.v1.QueryDepositsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDepositsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDepositsRequest();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDepositsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryDepositsRequest",
      value: QueryDepositsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDepositsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDepositsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryDepositsRequest",
      value: QueryDepositsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDepositsResponse() {
  return {
    deposits: [],
    pagination: void 0
  };
}
const QueryDepositsResponse = {
  typeUrl: "/cosmos.gov.v1.QueryDepositsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.deposits)
      Deposit.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDepositsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.deposits.push(Deposit.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDepositsResponse();
    return o.deposits = ((n = e.deposits) === null || n === void 0 ? void 0 : n.map((u) => Deposit.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      deposits: Array.isArray(e == null ? void 0 : e.deposits) ? e.deposits.map((n) => Deposit.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.deposits ? n.deposits = e.deposits.map((o) => o ? Deposit.toAmino(o) : void 0) : n.deposits = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDepositsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryDepositsResponse",
      value: QueryDepositsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDepositsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDepositsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryDepositsResponse",
      value: QueryDepositsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTallyResultRequest() {
  return {
    proposalId: Long$2.UZERO
  };
}
const QueryTallyResultRequest = {
  typeUrl: "/cosmos.gov.v1.QueryTallyResultRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTallyResultRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTallyResultRequest();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTallyResultRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryTallyResultRequest",
      value: QueryTallyResultRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTallyResultRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTallyResultRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryTallyResultRequest",
      value: QueryTallyResultRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTallyResultResponse() {
  return {
    tally: void 0
  };
}
const QueryTallyResultResponse = {
  typeUrl: "/cosmos.gov.v1.QueryTallyResultResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tally !== void 0 && TallyResult.encode(e.tally, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTallyResultResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tally = TallyResult.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTallyResultResponse();
    return n.tally = e.tally !== void 0 && e.tally !== null ? TallyResult.fromPartial(e.tally) : void 0, n;
  },
  fromAmino(e) {
    return {
      tally: e != null && e.tally ? TallyResult.fromAmino(e.tally) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.tally = e.tally ? TallyResult.toAmino(e.tally) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTallyResultResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/QueryTallyResultResponse",
      value: QueryTallyResultResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTallyResultResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTallyResultResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.QueryTallyResultResponse",
      value: QueryTallyResultResponse.encode(e).finish()
    };
  }
}, _35 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryDepositRequest,
  QueryDepositResponse,
  QueryDepositsRequest,
  QueryDepositsResponse,
  QueryParamsRequest: QueryParamsRequest$b,
  QueryParamsResponse: QueryParamsResponse$b,
  QueryProposalRequest,
  QueryProposalResponse,
  QueryProposalsRequest,
  QueryProposalsResponse,
  QueryTallyResultRequest,
  QueryTallyResultResponse,
  QueryVoteRequest,
  QueryVoteResponse,
  QueryVotesRequest,
  QueryVotesResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBasePlan() {
  return {
    name: "",
    time: void 0,
    height: Long$2.ZERO,
    info: "",
    upgradedClientState: void 0
  };
}
const Plan = {
  typeUrl: "/cosmos.upgrade.v1beta1.Plan",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.time !== void 0 && Timestamp.encode(toTimestamp(e.time), n.uint32(18).fork()).ldelim(), e.height.isZero() || n.uint32(24).int64(e.height), e.info !== "" && n.uint32(34).string(e.info), e.upgradedClientState !== void 0 && Any.encode(e.upgradedClientState, n.uint32(42).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePlan();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.time = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 3:
          c.height = o.int64();
          break;
        case 4:
          c.info = o.string();
          break;
        case 5:
          c.upgradedClientState = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBasePlan();
    return c.name = (n = e.name) !== null && n !== void 0 ? n : "", c.time = (o = e.time) !== null && o !== void 0 ? o : void 0, c.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, c.info = (u = e.info) !== null && u !== void 0 ? u : "", c.upgradedClientState = e.upgradedClientState !== void 0 && e.upgradedClientState !== null ? Any.fromPartial(e.upgradedClientState) : void 0, c;
  },
  fromAmino(e) {
    return {
      name: e.name,
      time: e != null && e.time ? Timestamp.fromAmino(e.time) : void 0,
      height: Long$2.fromString(e.height),
      info: e.info,
      upgradedClientState: e != null && e.upgraded_client_state ? Any.fromAmino(e.upgraded_client_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.time = e.time ? Timestamp.toAmino(e.time) : void 0, n.height = e.height ? e.height.toString() : void 0, n.info = e.info, n.upgraded_client_state = e.upgradedClientState ? Any.toAmino(e.upgradedClientState) : void 0, n;
  },
  fromAminoMsg(e) {
    return Plan.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Plan",
      value: Plan.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Plan.decode(e.value);
  },
  toProto(e) {
    return Plan.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.Plan",
      value: Plan.encode(e).finish()
    };
  }
};
function createBaseSoftwareUpgradeProposal() {
  return {
    title: "",
    description: "",
    plan: void 0
  };
}
const SoftwareUpgradeProposal = {
  typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.plan !== void 0 && Plan.encode(e.plan, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSoftwareUpgradeProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.plan = Plan.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSoftwareUpgradeProposal();
    return u.title = (n = e.title) !== null && n !== void 0 ? n : "", u.description = (o = e.description) !== null && o !== void 0 ? o : "", u.plan = e.plan !== void 0 && e.plan !== null ? Plan.fromPartial(e.plan) : void 0, u;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      plan: e != null && e.plan ? Plan.fromAmino(e.plan) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.plan = e.plan ? Plan.toAmino(e.plan) : void 0, n;
  },
  fromAminoMsg(e) {
    return SoftwareUpgradeProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SoftwareUpgradeProposal",
      value: SoftwareUpgradeProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SoftwareUpgradeProposal.decode(e.value);
  },
  toProto(e) {
    return SoftwareUpgradeProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
      value: SoftwareUpgradeProposal.encode(e).finish()
    };
  }
};
function createBaseCancelSoftwareUpgradeProposal() {
  return {
    title: "",
    description: ""
  };
}
const CancelSoftwareUpgradeProposal = {
  typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCancelSoftwareUpgradeProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCancelSoftwareUpgradeProposal();
    return u.title = (n = e.title) !== null && n !== void 0 ? n : "", u.description = (o = e.description) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n;
  },
  fromAminoMsg(e) {
    return CancelSoftwareUpgradeProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CancelSoftwareUpgradeProposal",
      value: CancelSoftwareUpgradeProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CancelSoftwareUpgradeProposal.decode(e.value);
  },
  toProto(e) {
    return CancelSoftwareUpgradeProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
      value: CancelSoftwareUpgradeProposal.encode(e).finish()
    };
  }
};
function createBaseModuleVersion() {
  return {
    name: "",
    version: Long$2.UZERO
  };
}
const ModuleVersion = {
  typeUrl: "/cosmos.upgrade.v1beta1.ModuleVersion",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.version.isZero() || n.uint32(16).uint64(e.version), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleVersion();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.version = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseModuleVersion();
    return o.name = (n = e.name) !== null && n !== void 0 ? n : "", o.version = e.version !== void 0 && e.version !== null ? Long$2.fromValue(e.version) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      name: e.name,
      version: Long$2.fromString(e.version)
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.version = e.version ? e.version.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ModuleVersion.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ModuleVersion",
      value: ModuleVersion.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleVersion.decode(e.value);
  },
  toProto(e) {
    return ModuleVersion.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.ModuleVersion",
      value: ModuleVersion.encode(e).finish()
    };
  }
}, _46 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CancelSoftwareUpgradeProposal,
  ModuleVersion,
  Plan,
  SoftwareUpgradeProposal
}, Symbol.toStringTag, { value: "Module" }));
function createBaseIdentifiedClientState() {
  return {
    clientId: "",
    clientState: void 0
  };
}
const IdentifiedClientState = {
  typeUrl: "/ibc.core.client.v1.IdentifiedClientState",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.clientState !== void 0 && Any.encode(e.clientState, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIdentifiedClientState();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.clientState = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseIdentifiedClientState();
    return o.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", o.clientState = e.clientState !== void 0 && e.clientState !== null ? Any.fromPartial(e.clientState) : void 0, o;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      clientState: e != null && e.client_state ? Any.fromAmino(e.client_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.client_state = e.clientState ? Any.toAmino(e.clientState) : void 0, n;
  },
  fromAminoMsg(e) {
    return IdentifiedClientState.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/IdentifiedClientState",
      value: IdentifiedClientState.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return IdentifiedClientState.decode(e.value);
  },
  toProto(e) {
    return IdentifiedClientState.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.IdentifiedClientState",
      value: IdentifiedClientState.encode(e).finish()
    };
  }
};
function createBaseConsensusStateWithHeight() {
  return {
    height: void 0,
    consensusState: void 0
  };
}
const ConsensusStateWithHeight = {
  typeUrl: "/ibc.core.client.v1.ConsensusStateWithHeight",
  encode(e, n = minimal.Writer.create()) {
    return e.height !== void 0 && Height.encode(e.height, n.uint32(10).fork()).ldelim(), e.consensusState !== void 0 && Any.encode(e.consensusState, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConsensusStateWithHeight();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = Height.decode(o, o.uint32());
          break;
        case 2:
          c.consensusState = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseConsensusStateWithHeight();
    return n.height = e.height !== void 0 && e.height !== null ? Height.fromPartial(e.height) : void 0, n.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? Any.fromPartial(e.consensusState) : void 0, n;
  },
  fromAmino(e) {
    return {
      height: e != null && e.height ? Height.fromAmino(e.height) : void 0,
      consensusState: e != null && e.consensus_state ? Any.fromAmino(e.consensus_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? Height.toAmino(e.height) : void 0, n.consensus_state = e.consensusState ? Any.toAmino(e.consensusState) : void 0, n;
  },
  fromAminoMsg(e) {
    return ConsensusStateWithHeight.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConsensusStateWithHeight",
      value: ConsensusStateWithHeight.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConsensusStateWithHeight.decode(e.value);
  },
  toProto(e) {
    return ConsensusStateWithHeight.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.ConsensusStateWithHeight",
      value: ConsensusStateWithHeight.encode(e).finish()
    };
  }
};
function createBaseClientConsensusStates() {
  return {
    clientId: "",
    consensusStates: []
  };
}
const ClientConsensusStates = {
  typeUrl: "/ibc.core.client.v1.ClientConsensusStates",
  encode(e, n = minimal.Writer.create()) {
    e.clientId !== "" && n.uint32(10).string(e.clientId);
    for (const o of e.consensusStates)
      ConsensusStateWithHeight.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClientConsensusStates();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.consensusStates.push(ConsensusStateWithHeight.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseClientConsensusStates();
    return u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.consensusStates = ((o = e.consensusStates) === null || o === void 0 ? void 0 : o.map((c) => ConsensusStateWithHeight.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      consensusStates: Array.isArray(e == null ? void 0 : e.consensus_states) ? e.consensus_states.map((n) => ConsensusStateWithHeight.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, e.consensusStates ? n.consensus_states = e.consensusStates.map((o) => o ? ConsensusStateWithHeight.toAmino(o) : void 0) : n.consensus_states = [], n;
  },
  fromAminoMsg(e) {
    return ClientConsensusStates.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ClientConsensusStates",
      value: ClientConsensusStates.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClientConsensusStates.decode(e.value);
  },
  toProto(e) {
    return ClientConsensusStates.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.ClientConsensusStates",
      value: ClientConsensusStates.encode(e).finish()
    };
  }
};
function createBaseClientUpdateProposal() {
  return {
    $typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
    title: "",
    description: "",
    subjectClientId: "",
    substituteClientId: ""
  };
}
const ClientUpdateProposal = {
  typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.subjectClientId !== "" && n.uint32(26).string(e.subjectClientId), e.substituteClientId !== "" && n.uint32(34).string(e.substituteClientId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClientUpdateProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.subjectClientId = o.string();
          break;
        case 4:
          c.substituteClientId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseClientUpdateProposal();
    return d.title = (n = e.title) !== null && n !== void 0 ? n : "", d.description = (o = e.description) !== null && o !== void 0 ? o : "", d.subjectClientId = (u = e.subjectClientId) !== null && u !== void 0 ? u : "", d.substituteClientId = (c = e.substituteClientId) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      subjectClientId: e.subject_client_id,
      substituteClientId: e.substitute_client_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.subject_client_id = e.subjectClientId, n.substitute_client_id = e.substituteClientId, n;
  },
  fromAminoMsg(e) {
    return ClientUpdateProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ClientUpdateProposal",
      value: ClientUpdateProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClientUpdateProposal.decode(e.value);
  },
  toProto(e) {
    return ClientUpdateProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
      value: ClientUpdateProposal.encode(e).finish()
    };
  }
};
function createBaseUpgradeProposal() {
  return {
    $typeUrl: "/ibc.core.client.v1.UpgradeProposal",
    title: "",
    description: "",
    plan: void 0,
    upgradedClientState: void 0
  };
}
const UpgradeProposal = {
  typeUrl: "/ibc.core.client.v1.UpgradeProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.plan !== void 0 && Plan.encode(e.plan, n.uint32(26).fork()).ldelim(), e.upgradedClientState !== void 0 && Any.encode(e.upgradedClientState, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpgradeProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.plan = Plan.decode(o, o.uint32());
          break;
        case 4:
          c.upgradedClientState = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseUpgradeProposal();
    return u.title = (n = e.title) !== null && n !== void 0 ? n : "", u.description = (o = e.description) !== null && o !== void 0 ? o : "", u.plan = e.plan !== void 0 && e.plan !== null ? Plan.fromPartial(e.plan) : void 0, u.upgradedClientState = e.upgradedClientState !== void 0 && e.upgradedClientState !== null ? Any.fromPartial(e.upgradedClientState) : void 0, u;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      plan: e != null && e.plan ? Plan.fromAmino(e.plan) : void 0,
      upgradedClientState: e != null && e.upgraded_client_state ? Any.fromAmino(e.upgraded_client_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.plan = e.plan ? Plan.toAmino(e.plan) : void 0, n.upgraded_client_state = e.upgradedClientState ? Any.toAmino(e.upgradedClientState) : void 0, n;
  },
  fromAminoMsg(e) {
    return UpgradeProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/UpgradeProposal",
      value: UpgradeProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpgradeProposal.decode(e.value);
  },
  toProto(e) {
    return UpgradeProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.UpgradeProposal",
      value: UpgradeProposal.encode(e).finish()
    };
  }
};
function createBaseHeight() {
  return {
    revisionNumber: Long$2.UZERO,
    revisionHeight: Long$2.UZERO
  };
}
const Height = {
  typeUrl: "/ibc.core.client.v1.Height",
  encode(e, n = minimal.Writer.create()) {
    return e.revisionNumber.isZero() || n.uint32(8).uint64(e.revisionNumber), e.revisionHeight.isZero() || n.uint32(16).uint64(e.revisionHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHeight();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.revisionNumber = o.uint64();
          break;
        case 2:
          c.revisionHeight = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseHeight();
    return n.revisionNumber = e.revisionNumber !== void 0 && e.revisionNumber !== null ? Long$2.fromValue(e.revisionNumber) : Long$2.UZERO, n.revisionHeight = e.revisionHeight !== void 0 && e.revisionHeight !== null ? Long$2.fromValue(e.revisionHeight) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      revisionNumber: Long$2.fromString(e.revision_number || "0", !0),
      revisionHeight: Long$2.fromString(e.revision_height || "0", !0)
    };
  },
  toAmino(e) {
    const n = {};
    return n.revision_number = e.revisionNumber ? e.revisionNumber.toString() : void 0, n.revision_height = e.revisionHeight ? e.revisionHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Height.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Height",
      value: Height.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Height.decode(e.value);
  },
  toProto(e) {
    return Height.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.Height",
      value: Height.encode(e).finish()
    };
  }
};
function createBaseParams$j() {
  return {
    allowedClients: []
  };
}
const Params$k = {
  typeUrl: "/ibc.core.client.v1.Params",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.allowedClients)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$j();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.allowedClients.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$j();
    return o.allowedClients = ((n = e.allowedClients) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      allowedClients: Array.isArray(e == null ? void 0 : e.allowed_clients) ? e.allowed_clients.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.allowedClients ? n.allowed_clients = e.allowedClients.map((o) => o) : n.allowed_clients = [], n;
  },
  fromAminoMsg(e) {
    return Params$k.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Params",
      value: Params$k.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$k.decode(e.value);
  },
  toProto(e) {
    return Params$k.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.Params",
      value: Params$k.encode(e).finish()
    };
  }
}, _87 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClientConsensusStates,
  ClientUpdateProposal,
  ConsensusStateWithHeight,
  Height,
  IdentifiedClientState,
  Params: Params$k,
  UpgradeProposal
}, Symbol.toStringTag, { value: "Module" }));
var build$a = {}, ascii = {};
Object.defineProperty(ascii, "__esModule", { value: !0 });
ascii.fromAscii = ascii.toAscii = void 0;
function toAscii(e) {
  const n = (o) => o.split("").map((u) => {
    const c = u.charCodeAt(0);
    if (c < 32 || c > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + c);
    return c;
  });
  return Uint8Array.from(n(e));
}
ascii.toAscii = toAscii;
function fromAscii(e) {
  return ((o) => o.map((u) => {
    if (u < 32 || u > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + u);
    return String.fromCharCode(u);
  }))(Array.from(e)).join("");
}
ascii.fromAscii = fromAscii;
var base64 = {}, __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$4(n, e, o);
  return __setModuleDefault$4(n, e), n;
};
Object.defineProperty(base64, "__esModule", { value: !0 });
base64.fromBase64 = base64.toBase64 = void 0;
const base64js = __importStar$4(base64Js);
function toBase64(e) {
  return base64js.fromByteArray(e);
}
base64.toBase64 = toBase64;
function fromBase64(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js.toByteArray(e);
}
base64.fromBase64 = fromBase64;
var bech32$1 = {}, __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$3(n, e, o);
  return __setModuleDefault$3(n, e), n;
};
Object.defineProperty(bech32$1, "__esModule", { value: !0 });
bech32$1.Bech32 = bech32$1.normalizeBech32 = bech32$1.fromBech32 = bech32$1.toBech32 = void 0;
const bech32 = __importStar$3(bech32$f);
function toBech32(e, n, o) {
  return bech32.encode(e, bech32.toWords(n), o);
}
bech32$1.toBech32 = toBech32;
function fromBech32(e, n = 1 / 0) {
  const o = bech32.decode(e, n);
  return {
    prefix: o.prefix,
    data: new Uint8Array(bech32.fromWords(o.words))
  };
}
bech32$1.fromBech32 = fromBech32;
function normalizeBech32(e) {
  const { prefix: n, data: o } = fromBech32(e);
  return toBech32(n, o);
}
bech32$1.normalizeBech32 = normalizeBech32;
class Bech32 {
  /**
   * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
   */
  static encode(n, o, u) {
    return toBech32(n, o, u);
  }
  /**
   * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
   */
  static decode(n, o = 1 / 0) {
    return fromBech32(n, o);
  }
}
bech32$1.Bech32 = Bech32;
var hex = {};
Object.defineProperty(hex, "__esModule", { value: !0 });
hex.fromHex = hex.toHex = void 0;
function toHex(e) {
  let n = "";
  for (const o of e)
    n += ("0" + o.toString(16)).slice(-2);
  return n;
}
hex.toHex = toHex;
function fromHex(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let o = 0; o < n.length; o++) {
    const u = 2 * o, c = e.slice(u, u + 2);
    if (!c.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[o] = parseInt(c, 16);
  }
  return n;
}
hex.fromHex = fromHex;
var rfc3339 = {};
Object.defineProperty(rfc3339, "__esModule", { value: !0 });
rfc3339.toRfc3339 = rfc3339.fromRfc3339 = void 0;
const rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function fromRfc3339(e) {
  const n = rfc3339Matcher.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const o = +n[1], u = +n[2], c = +n[3], d = +n[4], m = +n[5], v = +n[6], S = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let $, E, O;
  n[8] === "Z" ? ($ = 1, E = 0, O = 0) : ($ = n[8].substring(0, 1) === "-" ? -1 : 1, E = +n[8].substring(1, 3), O = +n[8].substring(4, 6));
  const T = $ * (E * 60 + O) * 60, y = Date.UTC(o, u - 1, c, d, m, v, S) - T * 1e3;
  return new Date(y);
}
rfc3339.fromRfc3339 = fromRfc3339;
function toRfc3339(e) {
  const n = e.getUTCFullYear(), o = padded(e.getUTCMonth() + 1), u = padded(e.getUTCDate()), c = padded(e.getUTCHours()), d = padded(e.getUTCMinutes()), m = padded(e.getUTCSeconds()), v = padded(e.getUTCMilliseconds(), 3);
  return `${n}-${o}-${u}T${c}:${d}:${m}.${v}Z`;
}
rfc3339.toRfc3339 = toRfc3339;
var utf8 = {};
Object.defineProperty(utf8, "__esModule", { value: !0 });
utf8.fromUtf8 = utf8.toUtf8 = void 0;
function toUtf8(e) {
  return new TextEncoder().encode(e);
}
utf8.toUtf8 = toUtf8;
function fromUtf8(e, n = !1) {
  const o = !n;
  return new TextDecoder("utf-8", { fatal: o }).decode(e);
}
utf8.fromUtf8 = fromUtf8;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.Bech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = ascii;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var o = base64;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return o.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return o.toBase64;
  } });
  var u = bech32$1;
  Object.defineProperty(e, "Bech32", { enumerable: !0, get: function() {
    return u.Bech32;
  } }), Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return u.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return u.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return u.toBech32;
  } });
  var c = hex;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return c.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return c.toHex;
  } });
  var d = rfc3339;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return d.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return d.toRfc3339;
  } });
  var m = utf8;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return m.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return m.toUtf8;
  } });
})(build$a);
let AccessType;
(function(e) {
  e[e.ACCESS_TYPE_UNSPECIFIED = 0] = "ACCESS_TYPE_UNSPECIFIED", e[e.ACCESS_TYPE_NOBODY = 1] = "ACCESS_TYPE_NOBODY", e[e.ACCESS_TYPE_ONLY_ADDRESS = 2] = "ACCESS_TYPE_ONLY_ADDRESS", e[e.ACCESS_TYPE_EVERYBODY = 3] = "ACCESS_TYPE_EVERYBODY", e[e.ACCESS_TYPE_ANY_OF_ADDRESSES = 4] = "ACCESS_TYPE_ANY_OF_ADDRESSES", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(AccessType || (AccessType = {}));
const AccessTypeSDKType = AccessType, AccessTypeAmino = AccessType;
function accessTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "ACCESS_TYPE_UNSPECIFIED":
      return AccessType.ACCESS_TYPE_UNSPECIFIED;
    case 1:
    case "ACCESS_TYPE_NOBODY":
      return AccessType.ACCESS_TYPE_NOBODY;
    case 2:
    case "ACCESS_TYPE_ONLY_ADDRESS":
      return AccessType.ACCESS_TYPE_ONLY_ADDRESS;
    case 3:
    case "ACCESS_TYPE_EVERYBODY":
      return AccessType.ACCESS_TYPE_EVERYBODY;
    case 4:
    case "ACCESS_TYPE_ANY_OF_ADDRESSES":
      return AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccessType.UNRECOGNIZED;
  }
}
function accessTypeToJSON(e) {
  switch (e) {
    case AccessType.ACCESS_TYPE_UNSPECIFIED:
      return "ACCESS_TYPE_UNSPECIFIED";
    case AccessType.ACCESS_TYPE_NOBODY:
      return "ACCESS_TYPE_NOBODY";
    case AccessType.ACCESS_TYPE_ONLY_ADDRESS:
      return "ACCESS_TYPE_ONLY_ADDRESS";
    case AccessType.ACCESS_TYPE_EVERYBODY:
      return "ACCESS_TYPE_EVERYBODY";
    case AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES:
      return "ACCESS_TYPE_ANY_OF_ADDRESSES";
    case AccessType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ContractCodeHistoryOperationType;
(function(e) {
  e[e.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED", e[e.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT", e[e.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE", e[e.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ContractCodeHistoryOperationType || (ContractCodeHistoryOperationType = {}));
const ContractCodeHistoryOperationTypeSDKType = ContractCodeHistoryOperationType, ContractCodeHistoryOperationTypeAmino = ContractCodeHistoryOperationType;
function contractCodeHistoryOperationTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
      return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
    case 1:
    case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
      return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
    case 2:
    case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
      return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
    case 3:
    case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
      return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ContractCodeHistoryOperationType.UNRECOGNIZED;
  }
}
function contractCodeHistoryOperationTypeToJSON(e) {
  switch (e) {
    case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
      return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
    case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
      return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
    case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
      return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
    case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
      return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
    case ContractCodeHistoryOperationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseAccessTypeParam() {
  return {
    value: 0
  };
}
const AccessTypeParam = {
  typeUrl: "/cosmwasm.wasm.v1.AccessTypeParam",
  encode(e, n = minimal.Writer.create()) {
    return e.value !== 0 && n.uint32(8).int32(e.value), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccessTypeParam();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.value = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccessTypeParam();
    return o.value = (n = e.value) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      value: isSet(e.value) ? accessTypeFromJSON(e.value) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.value = e.value, n;
  },
  fromAminoMsg(e) {
    return AccessTypeParam.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/AccessTypeParam",
      value: AccessTypeParam.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccessTypeParam.decode(e.value);
  },
  toProto(e) {
    return AccessTypeParam.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AccessTypeParam",
      value: AccessTypeParam.encode(e).finish()
    };
  }
};
function createBaseAccessConfig() {
  return {
    permission: 0,
    address: "",
    addresses: []
  };
}
const AccessConfig = {
  typeUrl: "/cosmwasm.wasm.v1.AccessConfig",
  encode(e, n = minimal.Writer.create()) {
    e.permission !== 0 && n.uint32(8).int32(e.permission), e.address !== "" && n.uint32(18).string(e.address);
    for (const o of e.addresses)
      n.uint32(26).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccessConfig();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.permission = o.int32();
          break;
        case 2:
          c.address = o.string();
          break;
        case 3:
          c.addresses.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseAccessConfig();
    return c.permission = (n = e.permission) !== null && n !== void 0 ? n : 0, c.address = (o = e.address) !== null && o !== void 0 ? o : "", c.addresses = ((u = e.addresses) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c;
  },
  fromAmino(e) {
    return {
      permission: isSet(e.permission) ? accessTypeFromJSON(e.permission) : 0,
      address: e.address,
      addresses: Array.isArray(e == null ? void 0 : e.addresses) ? e.addresses.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.permission = e.permission, n.address = e.address, e.addresses ? n.addresses = e.addresses.map((o) => o) : n.addresses = [], n;
  },
  fromAminoMsg(e) {
    return AccessConfig.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/AccessConfig",
      value: AccessConfig.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccessConfig.decode(e.value);
  },
  toProto(e) {
    return AccessConfig.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AccessConfig",
      value: AccessConfig.encode(e).finish()
    };
  }
};
function createBaseParams$i() {
  return {
    codeUploadAccess: void 0,
    instantiateDefaultPermission: 0
  };
}
const Params$j = {
  typeUrl: "/cosmwasm.wasm.v1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.codeUploadAccess !== void 0 && AccessConfig.encode(e.codeUploadAccess, n.uint32(10).fork()).ldelim(), e.instantiateDefaultPermission !== 0 && n.uint32(16).int32(e.instantiateDefaultPermission), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$i();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeUploadAccess = AccessConfig.decode(o, o.uint32());
          break;
        case 2:
          c.instantiateDefaultPermission = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$i();
    return o.codeUploadAccess = e.codeUploadAccess !== void 0 && e.codeUploadAccess !== null ? AccessConfig.fromPartial(e.codeUploadAccess) : void 0, o.instantiateDefaultPermission = (n = e.instantiateDefaultPermission) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      codeUploadAccess: e != null && e.code_upload_access ? AccessConfig.fromAmino(e.code_upload_access) : void 0,
      instantiateDefaultPermission: isSet(e.instantiate_default_permission) ? accessTypeFromJSON(e.instantiate_default_permission) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_upload_access = e.codeUploadAccess ? AccessConfig.toAmino(e.codeUploadAccess) : void 0, n.instantiate_default_permission = e.instantiateDefaultPermission, n;
  },
  fromAminoMsg(e) {
    return Params$j.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/Params",
      value: Params$j.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$j.decode(e.value);
  },
  toProto(e) {
    return Params$j.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Params",
      value: Params$j.encode(e).finish()
    };
  }
};
function createBaseCodeInfo() {
  return {
    codeHash: new Uint8Array(),
    creator: "",
    instantiateConfig: void 0
  };
}
const CodeInfo = {
  typeUrl: "/cosmwasm.wasm.v1.CodeInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.codeHash.length !== 0 && n.uint32(10).bytes(e.codeHash), e.creator !== "" && n.uint32(18).string(e.creator), e.instantiateConfig !== void 0 && AccessConfig.encode(e.instantiateConfig, n.uint32(42).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCodeInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeHash = o.bytes();
          break;
        case 2:
          c.creator = o.string();
          break;
        case 5:
          c.instantiateConfig = AccessConfig.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCodeInfo();
    return u.codeHash = (n = e.codeHash) !== null && n !== void 0 ? n : new Uint8Array(), u.creator = (o = e.creator) !== null && o !== void 0 ? o : "", u.instantiateConfig = e.instantiateConfig !== void 0 && e.instantiateConfig !== null ? AccessConfig.fromPartial(e.instantiateConfig) : void 0, u;
  },
  fromAmino(e) {
    return {
      codeHash: e.code_hash,
      creator: e.creator,
      instantiateConfig: e != null && e.instantiate_config ? AccessConfig.fromAmino(e.instantiate_config) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_hash = e.codeHash, n.creator = e.creator, n.instantiate_config = e.instantiateConfig ? AccessConfig.toAmino(e.instantiateConfig) : void 0, n;
  },
  fromAminoMsg(e) {
    return CodeInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/CodeInfo",
      value: CodeInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CodeInfo.decode(e.value);
  },
  toProto(e) {
    return CodeInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.CodeInfo",
      value: CodeInfo.encode(e).finish()
    };
  }
};
function createBaseContractInfo() {
  return {
    codeId: Long$2.UZERO,
    creator: "",
    admin: "",
    label: "",
    created: void 0,
    ibcPortId: "",
    extension: void 0
  };
}
const ContractInfo = {
  typeUrl: "/cosmwasm.wasm.v1.ContractInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.codeId.isZero() || n.uint32(8).uint64(e.codeId), e.creator !== "" && n.uint32(18).string(e.creator), e.admin !== "" && n.uint32(26).string(e.admin), e.label !== "" && n.uint32(34).string(e.label), e.created !== void 0 && AbsoluteTxPosition.encode(e.created, n.uint32(42).fork()).ldelim(), e.ibcPortId !== "" && n.uint32(50).string(e.ibcPortId), e.extension !== void 0 && Any.encode(e.extension, n.uint32(58).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseContractInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeId = o.uint64();
          break;
        case 2:
          c.creator = o.string();
          break;
        case 3:
          c.admin = o.string();
          break;
        case 4:
          c.label = o.string();
          break;
        case 5:
          c.created = AbsoluteTxPosition.decode(o, o.uint32());
          break;
        case 6:
          c.ibcPortId = o.string();
          break;
        case 7:
          c.extension = Cosmwasm_wasmv1ContractInfoExtension_InterfaceDecoder(o);
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseContractInfo();
    return d.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, d.creator = (n = e.creator) !== null && n !== void 0 ? n : "", d.admin = (o = e.admin) !== null && o !== void 0 ? o : "", d.label = (u = e.label) !== null && u !== void 0 ? u : "", d.created = e.created !== void 0 && e.created !== null ? AbsoluteTxPosition.fromPartial(e.created) : void 0, d.ibcPortId = (c = e.ibcPortId) !== null && c !== void 0 ? c : "", d.extension = e.extension !== void 0 && e.extension !== null ? Any.fromPartial(e.extension) : void 0, d;
  },
  fromAmino(e) {
    return {
      codeId: Long$2.fromString(e.code_id),
      creator: e.creator,
      admin: e.admin,
      label: e.label,
      created: e != null && e.created ? AbsoluteTxPosition.fromAmino(e.created) : void 0,
      ibcPortId: e.ibc_port_id,
      extension: e != null && e.extension ? Cosmwasm_wasmv1ContractInfoExtension_FromAmino(e.extension) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_id = e.codeId ? e.codeId.toString() : void 0, n.creator = e.creator, n.admin = e.admin, n.label = e.label, n.created = e.created ? AbsoluteTxPosition.toAmino(e.created) : void 0, n.ibc_port_id = e.ibcPortId, n.extension = e.extension ? Cosmwasm_wasmv1ContractInfoExtension_ToAmino(e.extension) : void 0, n;
  },
  fromAminoMsg(e) {
    return ContractInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/ContractInfo",
      value: ContractInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ContractInfo.decode(e.value);
  },
  toProto(e) {
    return ContractInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractInfo",
      value: ContractInfo.encode(e).finish()
    };
  }
};
function createBaseContractCodeHistoryEntry() {
  return {
    operation: 0,
    codeId: Long$2.UZERO,
    updated: void 0,
    msg: new Uint8Array()
  };
}
const ContractCodeHistoryEntry = {
  typeUrl: "/cosmwasm.wasm.v1.ContractCodeHistoryEntry",
  encode(e, n = minimal.Writer.create()) {
    return e.operation !== 0 && n.uint32(8).int32(e.operation), e.codeId.isZero() || n.uint32(16).uint64(e.codeId), e.updated !== void 0 && AbsoluteTxPosition.encode(e.updated, n.uint32(26).fork()).ldelim(), e.msg.length !== 0 && n.uint32(34).bytes(e.msg), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseContractCodeHistoryEntry();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.operation = o.int32();
          break;
        case 2:
          c.codeId = o.uint64();
          break;
        case 3:
          c.updated = AbsoluteTxPosition.decode(o, o.uint32());
          break;
        case 4:
          c.msg = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseContractCodeHistoryEntry();
    return u.operation = (n = e.operation) !== null && n !== void 0 ? n : 0, u.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, u.updated = e.updated !== void 0 && e.updated !== null ? AbsoluteTxPosition.fromPartial(e.updated) : void 0, u.msg = (o = e.msg) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      operation: isSet(e.operation) ? contractCodeHistoryOperationTypeFromJSON(e.operation) : 0,
      codeId: Long$2.fromString(e.code_id),
      updated: e != null && e.updated ? AbsoluteTxPosition.fromAmino(e.updated) : void 0,
      msg: build$a.toUtf8(JSON.stringify(e.msg))
    };
  },
  toAmino(e) {
    const n = {};
    return n.operation = e.operation, n.code_id = e.codeId ? e.codeId.toString() : void 0, n.updated = e.updated ? AbsoluteTxPosition.toAmino(e.updated) : void 0, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, n;
  },
  fromAminoMsg(e) {
    return ContractCodeHistoryEntry.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/ContractCodeHistoryEntry",
      value: ContractCodeHistoryEntry.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ContractCodeHistoryEntry.decode(e.value);
  },
  toProto(e) {
    return ContractCodeHistoryEntry.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractCodeHistoryEntry",
      value: ContractCodeHistoryEntry.encode(e).finish()
    };
  }
};
function createBaseAbsoluteTxPosition() {
  return {
    blockHeight: Long$2.UZERO,
    txIndex: Long$2.UZERO
  };
}
const AbsoluteTxPosition = {
  typeUrl: "/cosmwasm.wasm.v1.AbsoluteTxPosition",
  encode(e, n = minimal.Writer.create()) {
    return e.blockHeight.isZero() || n.uint32(8).uint64(e.blockHeight), e.txIndex.isZero() || n.uint32(16).uint64(e.txIndex), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAbsoluteTxPosition();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.blockHeight = o.uint64();
          break;
        case 2:
          c.txIndex = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseAbsoluteTxPosition();
    return n.blockHeight = e.blockHeight !== void 0 && e.blockHeight !== null ? Long$2.fromValue(e.blockHeight) : Long$2.UZERO, n.txIndex = e.txIndex !== void 0 && e.txIndex !== null ? Long$2.fromValue(e.txIndex) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      blockHeight: Long$2.fromString(e.block_height),
      txIndex: Long$2.fromString(e.tx_index)
    };
  },
  toAmino(e) {
    const n = {};
    return n.block_height = e.blockHeight ? e.blockHeight.toString() : void 0, n.tx_index = e.txIndex ? e.txIndex.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return AbsoluteTxPosition.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/AbsoluteTxPosition",
      value: AbsoluteTxPosition.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AbsoluteTxPosition.decode(e.value);
  },
  toProto(e) {
    return AbsoluteTxPosition.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AbsoluteTxPosition",
      value: AbsoluteTxPosition.encode(e).finish()
    };
  }
};
function createBaseModel() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array()
  };
}
const Model = {
  typeUrl: "/cosmwasm.wasm.v1.Model",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.value.length !== 0 && n.uint32(18).bytes(e.value), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModel();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.value = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseModel();
    return u.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), u.value = (o = e.value) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      key: e.key,
      value: e.value
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.value = e.value, n;
  },
  fromAminoMsg(e) {
    return Model.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/Model",
      value: Model.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Model.decode(e.value);
  },
  toProto(e) {
    return Model.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Model",
      value: Model.encode(e).finish()
    };
  }
}, Cosmwasm_wasmv1ContractInfoExtension_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    default:
      return o;
  }
}, Cosmwasm_wasmv1ContractInfoExtension_FromAmino = (e) => Any.fromAmino(e), Cosmwasm_wasmv1ContractInfoExtension_ToAmino = (e) => Any.toAmino(e), _106 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbsoluteTxPosition,
  AccessConfig,
  get AccessType() {
    return AccessType;
  },
  AccessTypeAmino,
  AccessTypeParam,
  AccessTypeSDKType,
  CodeInfo,
  ContractCodeHistoryEntry,
  get ContractCodeHistoryOperationType() {
    return ContractCodeHistoryOperationType;
  },
  ContractCodeHistoryOperationTypeAmino,
  ContractCodeHistoryOperationTypeSDKType,
  ContractInfo,
  Cosmwasm_wasmv1ContractInfoExtension_FromAmino,
  Cosmwasm_wasmv1ContractInfoExtension_InterfaceDecoder,
  Cosmwasm_wasmv1ContractInfoExtension_ToAmino,
  Model,
  Params: Params$j,
  accessTypeFromJSON,
  accessTypeToJSON,
  contractCodeHistoryOperationTypeFromJSON,
  contractCodeHistoryOperationTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseStoreCodeProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
    title: "",
    description: "",
    runAs: "",
    wasmByteCode: new Uint8Array(),
    instantiatePermission: void 0,
    unpinCode: !1,
    source: "",
    builder: "",
    codeHash: new Uint8Array()
  };
}
const StoreCodeProposal = {
  typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.runAs !== "" && n.uint32(26).string(e.runAs), e.wasmByteCode.length !== 0 && n.uint32(34).bytes(e.wasmByteCode), e.instantiatePermission !== void 0 && AccessConfig.encode(e.instantiatePermission, n.uint32(58).fork()).ldelim(), e.unpinCode === !0 && n.uint32(64).bool(e.unpinCode), e.source !== "" && n.uint32(74).string(e.source), e.builder !== "" && n.uint32(82).string(e.builder), e.codeHash.length !== 0 && n.uint32(90).bytes(e.codeHash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseStoreCodeProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.runAs = o.string();
          break;
        case 4:
          c.wasmByteCode = o.bytes();
          break;
        case 7:
          c.instantiatePermission = AccessConfig.decode(o, o.uint32());
          break;
        case 8:
          c.unpinCode = o.bool();
          break;
        case 9:
          c.source = o.string();
          break;
        case 10:
          c.builder = o.string();
          break;
        case 11:
          c.codeHash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S;
    const $ = createBaseStoreCodeProposal();
    return $.title = (n = e.title) !== null && n !== void 0 ? n : "", $.description = (o = e.description) !== null && o !== void 0 ? o : "", $.runAs = (u = e.runAs) !== null && u !== void 0 ? u : "", $.wasmByteCode = (c = e.wasmByteCode) !== null && c !== void 0 ? c : new Uint8Array(), $.instantiatePermission = e.instantiatePermission !== void 0 && e.instantiatePermission !== null ? AccessConfig.fromPartial(e.instantiatePermission) : void 0, $.unpinCode = (d = e.unpinCode) !== null && d !== void 0 ? d : !1, $.source = (m = e.source) !== null && m !== void 0 ? m : "", $.builder = (v = e.builder) !== null && v !== void 0 ? v : "", $.codeHash = (S = e.codeHash) !== null && S !== void 0 ? S : new Uint8Array(), $;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      runAs: e.run_as,
      wasmByteCode: build$a.fromBase64(e.wasm_byte_code),
      instantiatePermission: e != null && e.instantiate_permission ? AccessConfig.fromAmino(e.instantiate_permission) : void 0,
      unpinCode: e.unpin_code,
      source: e.source,
      builder: e.builder,
      codeHash: e.code_hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.run_as = e.runAs, n.wasm_byte_code = e.wasmByteCode ? build$a.toBase64(e.wasmByteCode) : void 0, n.instantiate_permission = e.instantiatePermission ? AccessConfig.toAmino(e.instantiatePermission) : void 0, n.unpin_code = e.unpinCode, n.source = e.source, n.builder = e.builder, n.code_hash = e.codeHash, n;
  },
  fromAminoMsg(e) {
    return StoreCodeProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/StoreCodeProposal",
      value: StoreCodeProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return StoreCodeProposal.decode(e.value);
  },
  toProto(e) {
    return StoreCodeProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
      value: StoreCodeProposal.encode(e).finish()
    };
  }
};
function createBaseInstantiateContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
    title: "",
    description: "",
    runAs: "",
    admin: "",
    codeId: Long$2.UZERO,
    label: "",
    msg: new Uint8Array(),
    funds: []
  };
}
const InstantiateContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.runAs !== "" && n.uint32(26).string(e.runAs), e.admin !== "" && n.uint32(34).string(e.admin), e.codeId.isZero() || n.uint32(40).uint64(e.codeId), e.label !== "" && n.uint32(50).string(e.label), e.msg.length !== 0 && n.uint32(58).bytes(e.msg);
    for (const o of e.funds)
      Coin.encode(o, n.uint32(66).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInstantiateContractProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.runAs = o.string();
          break;
        case 4:
          c.admin = o.string();
          break;
        case 5:
          c.codeId = o.uint64();
          break;
        case 6:
          c.label = o.string();
          break;
        case 7:
          c.msg = o.bytes();
          break;
        case 8:
          c.funds.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v;
    const S = createBaseInstantiateContractProposal();
    return S.title = (n = e.title) !== null && n !== void 0 ? n : "", S.description = (o = e.description) !== null && o !== void 0 ? o : "", S.runAs = (u = e.runAs) !== null && u !== void 0 ? u : "", S.admin = (c = e.admin) !== null && c !== void 0 ? c : "", S.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, S.label = (d = e.label) !== null && d !== void 0 ? d : "", S.msg = (m = e.msg) !== null && m !== void 0 ? m : new Uint8Array(), S.funds = ((v = e.funds) === null || v === void 0 ? void 0 : v.map(($) => Coin.fromPartial($))) || [], S;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      runAs: e.run_as,
      admin: e.admin,
      codeId: Long$2.fromString(e.code_id),
      label: e.label,
      msg: build$a.toUtf8(JSON.stringify(e.msg)),
      funds: Array.isArray(e == null ? void 0 : e.funds) ? e.funds.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.run_as = e.runAs, n.admin = e.admin, n.code_id = e.codeId ? e.codeId.toString() : void 0, n.label = e.label, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, e.funds ? n.funds = e.funds.map((o) => o ? Coin.toAmino(o) : void 0) : n.funds = [], n;
  },
  fromAminoMsg(e) {
    return InstantiateContractProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/InstantiateContractProposal",
      value: InstantiateContractProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InstantiateContractProposal.decode(e.value);
  },
  toProto(e) {
    return InstantiateContractProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
      value: InstantiateContractProposal.encode(e).finish()
    };
  }
};
function createBaseInstantiateContract2Proposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.InstantiateContract2Proposal",
    title: "",
    description: "",
    runAs: "",
    admin: "",
    codeId: Long$2.UZERO,
    label: "",
    msg: new Uint8Array(),
    funds: [],
    salt: new Uint8Array(),
    fixMsg: !1
  };
}
const InstantiateContract2Proposal = {
  typeUrl: "/cosmwasm.wasm.v1.InstantiateContract2Proposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.runAs !== "" && n.uint32(26).string(e.runAs), e.admin !== "" && n.uint32(34).string(e.admin), e.codeId.isZero() || n.uint32(40).uint64(e.codeId), e.label !== "" && n.uint32(50).string(e.label), e.msg.length !== 0 && n.uint32(58).bytes(e.msg);
    for (const o of e.funds)
      Coin.encode(o, n.uint32(66).fork()).ldelim();
    return e.salt.length !== 0 && n.uint32(74).bytes(e.salt), e.fixMsg === !0 && n.uint32(80).bool(e.fixMsg), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInstantiateContract2Proposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.runAs = o.string();
          break;
        case 4:
          c.admin = o.string();
          break;
        case 5:
          c.codeId = o.uint64();
          break;
        case 6:
          c.label = o.string();
          break;
        case 7:
          c.msg = o.bytes();
          break;
        case 8:
          c.funds.push(Coin.decode(o, o.uint32()));
          break;
        case 9:
          c.salt = o.bytes();
          break;
        case 10:
          c.fixMsg = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $;
    const E = createBaseInstantiateContract2Proposal();
    return E.title = (n = e.title) !== null && n !== void 0 ? n : "", E.description = (o = e.description) !== null && o !== void 0 ? o : "", E.runAs = (u = e.runAs) !== null && u !== void 0 ? u : "", E.admin = (c = e.admin) !== null && c !== void 0 ? c : "", E.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, E.label = (d = e.label) !== null && d !== void 0 ? d : "", E.msg = (m = e.msg) !== null && m !== void 0 ? m : new Uint8Array(), E.funds = ((v = e.funds) === null || v === void 0 ? void 0 : v.map((O) => Coin.fromPartial(O))) || [], E.salt = (S = e.salt) !== null && S !== void 0 ? S : new Uint8Array(), E.fixMsg = ($ = e.fixMsg) !== null && $ !== void 0 ? $ : !1, E;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      runAs: e.run_as,
      admin: e.admin,
      codeId: Long$2.fromString(e.code_id),
      label: e.label,
      msg: build$a.toUtf8(JSON.stringify(e.msg)),
      funds: Array.isArray(e == null ? void 0 : e.funds) ? e.funds.map((n) => Coin.fromAmino(n)) : [],
      salt: e.salt,
      fixMsg: e.fix_msg
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.run_as = e.runAs, n.admin = e.admin, n.code_id = e.codeId ? e.codeId.toString() : void 0, n.label = e.label, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, e.funds ? n.funds = e.funds.map((o) => o ? Coin.toAmino(o) : void 0) : n.funds = [], n.salt = e.salt, n.fix_msg = e.fixMsg, n;
  },
  fromAminoMsg(e) {
    return InstantiateContract2Proposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/InstantiateContract2Proposal",
      value: InstantiateContract2Proposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InstantiateContract2Proposal.decode(e.value);
  },
  toProto(e) {
    return InstantiateContract2Proposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.InstantiateContract2Proposal",
      value: InstantiateContract2Proposal.encode(e).finish()
    };
  }
};
function createBaseMigrateContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
    title: "",
    description: "",
    contract: "",
    codeId: Long$2.UZERO,
    msg: new Uint8Array()
  };
}
const MigrateContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.contract !== "" && n.uint32(34).string(e.contract), e.codeId.isZero() || n.uint32(40).uint64(e.codeId), e.msg.length !== 0 && n.uint32(50).bytes(e.msg), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMigrateContractProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 4:
          c.contract = o.string();
          break;
        case 5:
          c.codeId = o.uint64();
          break;
        case 6:
          c.msg = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMigrateContractProposal();
    return d.title = (n = e.title) !== null && n !== void 0 ? n : "", d.description = (o = e.description) !== null && o !== void 0 ? o : "", d.contract = (u = e.contract) !== null && u !== void 0 ? u : "", d.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, d.msg = (c = e.msg) !== null && c !== void 0 ? c : new Uint8Array(), d;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      contract: e.contract,
      codeId: Long$2.fromString(e.code_id),
      msg: build$a.toUtf8(JSON.stringify(e.msg))
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.contract = e.contract, n.code_id = e.codeId ? e.codeId.toString() : void 0, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, n;
  },
  fromAminoMsg(e) {
    return MigrateContractProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MigrateContractProposal",
      value: MigrateContractProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MigrateContractProposal.decode(e.value);
  },
  toProto(e) {
    return MigrateContractProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
      value: MigrateContractProposal.encode(e).finish()
    };
  }
};
function createBaseSudoContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
    title: "",
    description: "",
    contract: "",
    msg: new Uint8Array()
  };
}
const SudoContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.contract !== "" && n.uint32(26).string(e.contract), e.msg.length !== 0 && n.uint32(34).bytes(e.msg), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSudoContractProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.contract = o.string();
          break;
        case 4:
          c.msg = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseSudoContractProposal();
    return d.title = (n = e.title) !== null && n !== void 0 ? n : "", d.description = (o = e.description) !== null && o !== void 0 ? o : "", d.contract = (u = e.contract) !== null && u !== void 0 ? u : "", d.msg = (c = e.msg) !== null && c !== void 0 ? c : new Uint8Array(), d;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      contract: e.contract,
      msg: build$a.toUtf8(JSON.stringify(e.msg))
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.contract = e.contract, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, n;
  },
  fromAminoMsg(e) {
    return SudoContractProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/SudoContractProposal",
      value: SudoContractProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SudoContractProposal.decode(e.value);
  },
  toProto(e) {
    return SudoContractProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
      value: SudoContractProposal.encode(e).finish()
    };
  }
};
function createBaseExecuteContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
    title: "",
    description: "",
    runAs: "",
    contract: "",
    msg: new Uint8Array(),
    funds: []
  };
}
const ExecuteContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.runAs !== "" && n.uint32(26).string(e.runAs), e.contract !== "" && n.uint32(34).string(e.contract), e.msg.length !== 0 && n.uint32(42).bytes(e.msg);
    for (const o of e.funds)
      Coin.encode(o, n.uint32(50).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseExecuteContractProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.runAs = o.string();
          break;
        case 4:
          c.contract = o.string();
          break;
        case 5:
          c.msg = o.bytes();
          break;
        case 6:
          c.funds.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseExecuteContractProposal();
    return v.title = (n = e.title) !== null && n !== void 0 ? n : "", v.description = (o = e.description) !== null && o !== void 0 ? o : "", v.runAs = (u = e.runAs) !== null && u !== void 0 ? u : "", v.contract = (c = e.contract) !== null && c !== void 0 ? c : "", v.msg = (d = e.msg) !== null && d !== void 0 ? d : new Uint8Array(), v.funds = ((m = e.funds) === null || m === void 0 ? void 0 : m.map((S) => Coin.fromPartial(S))) || [], v;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      runAs: e.run_as,
      contract: e.contract,
      msg: build$a.toUtf8(JSON.stringify(e.msg)),
      funds: Array.isArray(e == null ? void 0 : e.funds) ? e.funds.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.run_as = e.runAs, n.contract = e.contract, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, e.funds ? n.funds = e.funds.map((o) => o ? Coin.toAmino(o) : void 0) : n.funds = [], n;
  },
  fromAminoMsg(e) {
    return ExecuteContractProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/ExecuteContractProposal",
      value: ExecuteContractProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ExecuteContractProposal.decode(e.value);
  },
  toProto(e) {
    return ExecuteContractProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
      value: ExecuteContractProposal.encode(e).finish()
    };
  }
};
function createBaseUpdateAdminProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
    title: "",
    description: "",
    newAdmin: "",
    contract: ""
  };
}
const UpdateAdminProposal = {
  typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.newAdmin !== "" && n.uint32(26).string(e.newAdmin), e.contract !== "" && n.uint32(34).string(e.contract), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpdateAdminProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.newAdmin = o.string();
          break;
        case 4:
          c.contract = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseUpdateAdminProposal();
    return d.title = (n = e.title) !== null && n !== void 0 ? n : "", d.description = (o = e.description) !== null && o !== void 0 ? o : "", d.newAdmin = (u = e.newAdmin) !== null && u !== void 0 ? u : "", d.contract = (c = e.contract) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      newAdmin: e.new_admin,
      contract: e.contract
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.new_admin = e.newAdmin, n.contract = e.contract, n;
  },
  fromAminoMsg(e) {
    return UpdateAdminProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/UpdateAdminProposal",
      value: UpdateAdminProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpdateAdminProposal.decode(e.value);
  },
  toProto(e) {
    return UpdateAdminProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
      value: UpdateAdminProposal.encode(e).finish()
    };
  }
};
function createBaseClearAdminProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
    title: "",
    description: "",
    contract: ""
  };
}
const ClearAdminProposal = {
  typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.contract !== "" && n.uint32(26).string(e.contract), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClearAdminProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.contract = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseClearAdminProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.contract = (u = e.contract) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      contract: e.contract
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.contract = e.contract, n;
  },
  fromAminoMsg(e) {
    return ClearAdminProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/ClearAdminProposal",
      value: ClearAdminProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClearAdminProposal.decode(e.value);
  },
  toProto(e) {
    return ClearAdminProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
      value: ClearAdminProposal.encode(e).finish()
    };
  }
};
function createBasePinCodesProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
    title: "",
    description: "",
    codeIds: []
  };
}
const PinCodesProposal = {
  typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), n.uint32(26).fork();
    for (const o of e.codeIds)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePinCodesProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.codeIds.push(o.uint64());
          } else
            c.codeIds.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBasePinCodesProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.codeIds = ((u = e.codeIds) === null || u === void 0 ? void 0 : u.map((d) => Long$2.fromValue(d))) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      codeIds: Array.isArray(e == null ? void 0 : e.code_ids) ? e.code_ids.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.codeIds ? n.code_ids = e.codeIds.map((o) => o) : n.code_ids = [], n;
  },
  fromAminoMsg(e) {
    return PinCodesProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/PinCodesProposal",
      value: PinCodesProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PinCodesProposal.decode(e.value);
  },
  toProto(e) {
    return PinCodesProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
      value: PinCodesProposal.encode(e).finish()
    };
  }
};
function createBaseUnpinCodesProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
    title: "",
    description: "",
    codeIds: []
  };
}
const UnpinCodesProposal = {
  typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), n.uint32(26).fork();
    for (const o of e.codeIds)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUnpinCodesProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.codeIds.push(o.uint64());
          } else
            c.codeIds.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseUnpinCodesProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.codeIds = ((u = e.codeIds) === null || u === void 0 ? void 0 : u.map((d) => Long$2.fromValue(d))) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      codeIds: Array.isArray(e == null ? void 0 : e.code_ids) ? e.code_ids.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.codeIds ? n.code_ids = e.codeIds.map((o) => o) : n.code_ids = [], n;
  },
  fromAminoMsg(e) {
    return UnpinCodesProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/UnpinCodesProposal",
      value: UnpinCodesProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UnpinCodesProposal.decode(e.value);
  },
  toProto(e) {
    return UnpinCodesProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
      value: UnpinCodesProposal.encode(e).finish()
    };
  }
};
function createBaseAccessConfigUpdate() {
  return {
    codeId: Long$2.UZERO,
    instantiatePermission: void 0
  };
}
const AccessConfigUpdate = {
  typeUrl: "/cosmwasm.wasm.v1.AccessConfigUpdate",
  encode(e, n = minimal.Writer.create()) {
    return e.codeId.isZero() || n.uint32(8).uint64(e.codeId), e.instantiatePermission !== void 0 && AccessConfig.encode(e.instantiatePermission, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccessConfigUpdate();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeId = o.uint64();
          break;
        case 2:
          c.instantiatePermission = AccessConfig.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseAccessConfigUpdate();
    return n.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, n.instantiatePermission = e.instantiatePermission !== void 0 && e.instantiatePermission !== null ? AccessConfig.fromPartial(e.instantiatePermission) : void 0, n;
  },
  fromAmino(e) {
    return {
      codeId: Long$2.fromString(e.code_id),
      instantiatePermission: e != null && e.instantiate_permission ? AccessConfig.fromAmino(e.instantiate_permission) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_id = e.codeId ? e.codeId.toString() : void 0, n.instantiate_permission = e.instantiatePermission ? AccessConfig.toAmino(e.instantiatePermission) : void 0, n;
  },
  fromAminoMsg(e) {
    return AccessConfigUpdate.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/AccessConfigUpdate",
      value: AccessConfigUpdate.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccessConfigUpdate.decode(e.value);
  },
  toProto(e) {
    return AccessConfigUpdate.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AccessConfigUpdate",
      value: AccessConfigUpdate.encode(e).finish()
    };
  }
};
function createBaseUpdateInstantiateConfigProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
    title: "",
    description: "",
    accessConfigUpdates: []
  };
}
const UpdateInstantiateConfigProposal = {
  typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description);
    for (const o of e.accessConfigUpdates)
      AccessConfigUpdate.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpdateInstantiateConfigProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.accessConfigUpdates.push(AccessConfigUpdate.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseUpdateInstantiateConfigProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.accessConfigUpdates = ((u = e.accessConfigUpdates) === null || u === void 0 ? void 0 : u.map((d) => AccessConfigUpdate.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      accessConfigUpdates: Array.isArray(e == null ? void 0 : e.access_config_updates) ? e.access_config_updates.map((n) => AccessConfigUpdate.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.accessConfigUpdates ? n.access_config_updates = e.accessConfigUpdates.map((o) => o ? AccessConfigUpdate.toAmino(o) : void 0) : n.access_config_updates = [], n;
  },
  fromAminoMsg(e) {
    return UpdateInstantiateConfigProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/UpdateInstantiateConfigProposal",
      value: UpdateInstantiateConfigProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpdateInstantiateConfigProposal.decode(e.value);
  },
  toProto(e) {
    return UpdateInstantiateConfigProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
      value: UpdateInstantiateConfigProposal.encode(e).finish()
    };
  }
};
function createBaseStoreAndInstantiateContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal",
    title: "",
    description: "",
    runAs: "",
    wasmByteCode: new Uint8Array(),
    instantiatePermission: void 0,
    unpinCode: !1,
    admin: "",
    label: "",
    msg: new Uint8Array(),
    funds: [],
    source: "",
    builder: "",
    codeHash: new Uint8Array()
  };
}
const StoreAndInstantiateContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.runAs !== "" && n.uint32(26).string(e.runAs), e.wasmByteCode.length !== 0 && n.uint32(34).bytes(e.wasmByteCode), e.instantiatePermission !== void 0 && AccessConfig.encode(e.instantiatePermission, n.uint32(42).fork()).ldelim(), e.unpinCode === !0 && n.uint32(48).bool(e.unpinCode), e.admin !== "" && n.uint32(58).string(e.admin), e.label !== "" && n.uint32(66).string(e.label), e.msg.length !== 0 && n.uint32(74).bytes(e.msg);
    for (const o of e.funds)
      Coin.encode(o, n.uint32(82).fork()).ldelim();
    return e.source !== "" && n.uint32(90).string(e.source), e.builder !== "" && n.uint32(98).string(e.builder), e.codeHash.length !== 0 && n.uint32(106).bytes(e.codeHash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseStoreAndInstantiateContractProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.runAs = o.string();
          break;
        case 4:
          c.wasmByteCode = o.bytes();
          break;
        case 5:
          c.instantiatePermission = AccessConfig.decode(o, o.uint32());
          break;
        case 6:
          c.unpinCode = o.bool();
          break;
        case 7:
          c.admin = o.string();
          break;
        case 8:
          c.label = o.string();
          break;
        case 9:
          c.msg = o.bytes();
          break;
        case 10:
          c.funds.push(Coin.decode(o, o.uint32()));
          break;
        case 11:
          c.source = o.string();
          break;
        case 12:
          c.builder = o.string();
          break;
        case 13:
          c.codeHash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $, E, O, T;
    const y = createBaseStoreAndInstantiateContractProposal();
    return y.title = (n = e.title) !== null && n !== void 0 ? n : "", y.description = (o = e.description) !== null && o !== void 0 ? o : "", y.runAs = (u = e.runAs) !== null && u !== void 0 ? u : "", y.wasmByteCode = (c = e.wasmByteCode) !== null && c !== void 0 ? c : new Uint8Array(), y.instantiatePermission = e.instantiatePermission !== void 0 && e.instantiatePermission !== null ? AccessConfig.fromPartial(e.instantiatePermission) : void 0, y.unpinCode = (d = e.unpinCode) !== null && d !== void 0 ? d : !1, y.admin = (m = e.admin) !== null && m !== void 0 ? m : "", y.label = (v = e.label) !== null && v !== void 0 ? v : "", y.msg = (S = e.msg) !== null && S !== void 0 ? S : new Uint8Array(), y.funds = (($ = e.funds) === null || $ === void 0 ? void 0 : $.map((V) => Coin.fromPartial(V))) || [], y.source = (E = e.source) !== null && E !== void 0 ? E : "", y.builder = (O = e.builder) !== null && O !== void 0 ? O : "", y.codeHash = (T = e.codeHash) !== null && T !== void 0 ? T : new Uint8Array(), y;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      runAs: e.run_as,
      wasmByteCode: build$a.fromBase64(e.wasm_byte_code),
      instantiatePermission: e != null && e.instantiate_permission ? AccessConfig.fromAmino(e.instantiate_permission) : void 0,
      unpinCode: e.unpin_code,
      admin: e.admin,
      label: e.label,
      msg: build$a.toUtf8(JSON.stringify(e.msg)),
      funds: Array.isArray(e == null ? void 0 : e.funds) ? e.funds.map((n) => Coin.fromAmino(n)) : [],
      source: e.source,
      builder: e.builder,
      codeHash: e.code_hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.run_as = e.runAs, n.wasm_byte_code = e.wasmByteCode ? build$a.toBase64(e.wasmByteCode) : void 0, n.instantiate_permission = e.instantiatePermission ? AccessConfig.toAmino(e.instantiatePermission) : void 0, n.unpin_code = e.unpinCode, n.admin = e.admin, n.label = e.label, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, e.funds ? n.funds = e.funds.map((o) => o ? Coin.toAmino(o) : void 0) : n.funds = [], n.source = e.source, n.builder = e.builder, n.code_hash = e.codeHash, n;
  },
  fromAminoMsg(e) {
    return StoreAndInstantiateContractProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/StoreAndInstantiateContractProposal",
      value: StoreAndInstantiateContractProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return StoreAndInstantiateContractProposal.decode(e.value);
  },
  toProto(e) {
    return StoreAndInstantiateContractProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal",
      value: StoreAndInstantiateContractProposal.encode(e).finish()
    };
  }
}, _103 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccessConfigUpdate,
  ClearAdminProposal,
  ExecuteContractProposal,
  InstantiateContract2Proposal,
  InstantiateContractProposal,
  MigrateContractProposal,
  PinCodesProposal,
  StoreAndInstantiateContractProposal,
  StoreCodeProposal,
  SudoContractProposal,
  UnpinCodesProposal,
  UpdateAdminProposal,
  UpdateInstantiateConfigProposal
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$h() {
  return {
    mintedDenom: ""
  };
}
const Params$i = {
  typeUrl: "/osmosis.poolincentives.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.mintedDenom !== "" && n.uint32(10).string(e.mintedDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$h();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.mintedDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$h();
    return o.mintedDenom = (n = e.mintedDenom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      mintedDenom: e.minted_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.minted_denom = e.mintedDenom, n;
  },
  fromAminoMsg(e) {
    return Params$i.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/params",
      value: Params$i.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$i.decode(e.value);
  },
  toProto(e) {
    return Params$i.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.Params",
      value: Params$i.encode(e).finish()
    };
  }
};
function createBaseLockableDurationsInfo$1() {
  return {
    lockableDurations: []
  };
}
const LockableDurationsInfo$1 = {
  typeUrl: "/osmosis.poolincentives.v1beta1.LockableDurationsInfo",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.lockableDurations)
      Duration.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLockableDurationsInfo$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockableDurations.push(Duration.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseLockableDurationsInfo$1();
    return o.lockableDurations = ((n = e.lockableDurations) === null || n === void 0 ? void 0 : n.map((u) => Duration.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      lockableDurations: Array.isArray(e == null ? void 0 : e.lockable_durations) ? e.lockable_durations.map((n) => Duration.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.lockableDurations ? n.lockable_durations = e.lockableDurations.map((o) => o ? Duration.toAmino(o) : void 0) : n.lockable_durations = [], n;
  },
  fromAminoMsg(e) {
    return LockableDurationsInfo$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/lockable-durations-info",
      value: LockableDurationsInfo$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LockableDurationsInfo$1.decode(e.value);
  },
  toProto(e) {
    return LockableDurationsInfo$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.LockableDurationsInfo",
      value: LockableDurationsInfo$1.encode(e).finish()
    };
  }
};
function createBaseDistrInfo() {
  return {
    totalWeight: "",
    records: []
  };
}
const DistrInfo = {
  typeUrl: "/osmosis.poolincentives.v1beta1.DistrInfo",
  encode(e, n = minimal.Writer.create()) {
    e.totalWeight !== "" && n.uint32(10).string(e.totalWeight);
    for (const o of e.records)
      DistrRecord.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDistrInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.totalWeight = o.string();
          break;
        case 2:
          c.records.push(DistrRecord.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDistrInfo();
    return u.totalWeight = (n = e.totalWeight) !== null && n !== void 0 ? n : "", u.records = ((o = e.records) === null || o === void 0 ? void 0 : o.map((c) => DistrRecord.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      totalWeight: e.total_weight,
      records: Array.isArray(e == null ? void 0 : e.records) ? e.records.map((n) => DistrRecord.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.total_weight = e.totalWeight, e.records ? n.records = e.records.map((o) => o ? DistrRecord.toAmino(o) : void 0) : n.records = [], n;
  },
  fromAminoMsg(e) {
    return DistrInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/distr-info",
      value: DistrInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DistrInfo.decode(e.value);
  },
  toProto(e) {
    return DistrInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.DistrInfo",
      value: DistrInfo.encode(e).finish()
    };
  }
};
function createBaseDistrRecord() {
  return {
    gaugeId: Long$2.UZERO,
    weight: ""
  };
}
const DistrRecord = {
  typeUrl: "/osmosis.poolincentives.v1beta1.DistrRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.gaugeId.isZero() || n.uint32(8).uint64(e.gaugeId), e.weight !== "" && n.uint32(18).string(e.weight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDistrRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.gaugeId = o.uint64();
          break;
        case 2:
          c.weight = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDistrRecord();
    return o.gaugeId = e.gaugeId !== void 0 && e.gaugeId !== null ? Long$2.fromValue(e.gaugeId) : Long$2.UZERO, o.weight = (n = e.weight) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      gaugeId: Long$2.fromString(e.gauge_id),
      weight: e.weight
    };
  },
  toAmino(e) {
    const n = {};
    return n.gauge_id = e.gaugeId ? e.gaugeId.toString() : void 0, n.weight = e.weight, n;
  },
  fromAminoMsg(e) {
    return DistrRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/distr-record",
      value: DistrRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DistrRecord.decode(e.value);
  },
  toProto(e) {
    return DistrRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.DistrRecord",
      value: DistrRecord.encode(e).finish()
    };
  }
};
function createBasePoolToGauge() {
  return {
    poolId: Long$2.UZERO,
    gaugeId: Long$2.UZERO,
    duration: void 0
  };
}
const PoolToGauge = {
  typeUrl: "/osmosis.poolincentives.v1beta1.PoolToGauge",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.gaugeId.isZero() || n.uint32(16).uint64(e.gaugeId), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePoolToGauge();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.gaugeId = o.uint64();
          break;
        case 3:
          c.duration = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBasePoolToGauge();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n.gaugeId = e.gaugeId !== void 0 && e.gaugeId !== null ? Long$2.fromValue(e.gaugeId) : Long$2.UZERO, n.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      gaugeId: Long$2.fromString(e.gauge_id),
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.gauge_id = e.gaugeId ? e.gaugeId.toString() : void 0, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n;
  },
  fromAminoMsg(e) {
    return PoolToGauge.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/pool-to-gauge",
      value: PoolToGauge.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PoolToGauge.decode(e.value);
  },
  toProto(e) {
    return PoolToGauge.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.PoolToGauge",
      value: PoolToGauge.encode(e).finish()
    };
  }
};
function createBasePoolToGauges() {
  return {
    poolToGauge: []
  };
}
const PoolToGauges = {
  typeUrl: "/osmosis.poolincentives.v1beta1.PoolToGauges",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.poolToGauge)
      PoolToGauge.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePoolToGauges();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.poolToGauge.push(PoolToGauge.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePoolToGauges();
    return o.poolToGauge = ((n = e.poolToGauge) === null || n === void 0 ? void 0 : n.map((u) => PoolToGauge.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      poolToGauge: Array.isArray(e == null ? void 0 : e.pool_to_gauge) ? e.pool_to_gauge.map((n) => PoolToGauge.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.poolToGauge ? n.pool_to_gauge = e.poolToGauge.map((o) => o ? PoolToGauge.toAmino(o) : void 0) : n.pool_to_gauge = [], n;
  },
  fromAminoMsg(e) {
    return PoolToGauges.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/pool-to-gauges",
      value: PoolToGauges.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PoolToGauges.decode(e.value);
  },
  toProto(e) {
    return PoolToGauges.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.PoolToGauges",
      value: PoolToGauges.encode(e).finish()
    };
  }
}, _146 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DistrInfo,
  DistrRecord,
  LockableDurationsInfo: LockableDurationsInfo$1,
  Params: Params$i,
  PoolToGauge,
  PoolToGauges
}, Symbol.toStringTag, { value: "Module" }));
function createBaseReplacePoolIncentivesProposal() {
  return {
    $typeUrl: "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal",
    title: "",
    description: "",
    records: []
  };
}
const ReplacePoolIncentivesProposal = {
  typeUrl: "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description);
    for (const o of e.records)
      DistrRecord.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseReplacePoolIncentivesProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.records.push(DistrRecord.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseReplacePoolIncentivesProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.records = ((u = e.records) === null || u === void 0 ? void 0 : u.map((d) => DistrRecord.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      records: Array.isArray(e == null ? void 0 : e.records) ? e.records.map((n) => DistrRecord.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.records ? n.records = e.records.map((o) => o ? DistrRecord.toAmino(o) : void 0) : n.records = [], n;
  },
  fromAminoMsg(e) {
    return ReplacePoolIncentivesProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/replace-pool-incentives-proposal",
      value: ReplacePoolIncentivesProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ReplacePoolIncentivesProposal.decode(e.value);
  },
  toProto(e) {
    return ReplacePoolIncentivesProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal",
      value: ReplacePoolIncentivesProposal.encode(e).finish()
    };
  }
};
function createBaseUpdatePoolIncentivesProposal() {
  return {
    $typeUrl: "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal",
    title: "",
    description: "",
    records: []
  };
}
const UpdatePoolIncentivesProposal = {
  typeUrl: "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description);
    for (const o of e.records)
      DistrRecord.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpdatePoolIncentivesProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.records.push(DistrRecord.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseUpdatePoolIncentivesProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.records = ((u = e.records) === null || u === void 0 ? void 0 : u.map((d) => DistrRecord.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      records: Array.isArray(e == null ? void 0 : e.records) ? e.records.map((n) => DistrRecord.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.records ? n.records = e.records.map((o) => o ? DistrRecord.toAmino(o) : void 0) : n.records = [], n;
  },
  fromAminoMsg(e) {
    return UpdatePoolIncentivesProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/UpdatePoolIncentivesProposal",
      value: UpdatePoolIncentivesProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpdatePoolIncentivesProposal.decode(e.value);
  },
  toProto(e) {
    return UpdatePoolIncentivesProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal",
      value: UpdatePoolIncentivesProposal.encode(e).finish()
    };
  }
}, _145 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ReplacePoolIncentivesProposal,
  UpdatePoolIncentivesProposal
}, Symbol.toStringTag, { value: "Module" }));
function createBaseSetProtoRevEnabledProposal() {
  return {
    $typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal",
    title: "",
    description: "",
    enabled: !1
  };
}
const SetProtoRevEnabledProposal = {
  typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.enabled === !0 && n.uint32(24).bool(e.enabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSetProtoRevEnabledProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.enabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSetProtoRevEnabledProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.enabled = (u = e.enabled) !== null && u !== void 0 ? u : !1, c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      enabled: e.enabled
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.enabled = e.enabled, n;
  },
  fromAminoMsg(e) {
    return SetProtoRevEnabledProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-proto-rev-enabled-proposal",
      value: SetProtoRevEnabledProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SetProtoRevEnabledProposal.decode(e.value);
  },
  toProto(e) {
    return SetProtoRevEnabledProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal",
      value: SetProtoRevEnabledProposal.encode(e).finish()
    };
  }
};
function createBaseSetProtoRevAdminAccountProposal() {
  return {
    $typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal",
    title: "",
    description: "",
    account: ""
  };
}
const SetProtoRevAdminAccountProposal = {
  typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.account !== "" && n.uint32(26).string(e.account), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSetProtoRevAdminAccountProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.account = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSetProtoRevAdminAccountProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.account = (u = e.account) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      account: e.account
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.account = e.account, n;
  },
  fromAminoMsg(e) {
    return SetProtoRevAdminAccountProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-proto-rev-admin-account-proposal",
      value: SetProtoRevAdminAccountProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SetProtoRevAdminAccountProposal.decode(e.value);
  },
  toProto(e) {
    return SetProtoRevAdminAccountProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal",
      value: SetProtoRevAdminAccountProposal.encode(e).finish()
    };
  }
}, _154 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SetProtoRevAdminAccountProposal,
  SetProtoRevEnabledProposal
}, Symbol.toStringTag, { value: "Module" }));
let SuperfluidAssetType;
(function(e) {
  e[e.SuperfluidAssetTypeNative = 0] = "SuperfluidAssetTypeNative", e[e.SuperfluidAssetTypeLPShare = 1] = "SuperfluidAssetTypeLPShare", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(SuperfluidAssetType || (SuperfluidAssetType = {}));
const SuperfluidAssetTypeSDKType = SuperfluidAssetType, SuperfluidAssetTypeAmino = SuperfluidAssetType;
function superfluidAssetTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "SuperfluidAssetTypeNative":
      return SuperfluidAssetType.SuperfluidAssetTypeNative;
    case 1:
    case "SuperfluidAssetTypeLPShare":
      return SuperfluidAssetType.SuperfluidAssetTypeLPShare;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SuperfluidAssetType.UNRECOGNIZED;
  }
}
function superfluidAssetTypeToJSON(e) {
  switch (e) {
    case SuperfluidAssetType.SuperfluidAssetTypeNative:
      return "SuperfluidAssetTypeNative";
    case SuperfluidAssetType.SuperfluidAssetTypeLPShare:
      return "SuperfluidAssetTypeLPShare";
    case SuperfluidAssetType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseSuperfluidAsset() {
  return {
    denom: "",
    assetType: 0
  };
}
const SuperfluidAsset = {
  typeUrl: "/osmosis.superfluid.SuperfluidAsset",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.assetType !== 0 && n.uint32(16).int32(e.assetType), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidAsset();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.assetType = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSuperfluidAsset();
    return u.denom = (n = e.denom) !== null && n !== void 0 ? n : "", u.assetType = (o = e.assetType) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      assetType: isSet(e.asset_type) ? superfluidAssetTypeFromJSON(e.asset_type) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.asset_type = e.assetType, n;
  },
  fromAminoMsg(e) {
    return SuperfluidAsset.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-asset",
      value: SuperfluidAsset.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidAsset.decode(e.value);
  },
  toProto(e) {
    return SuperfluidAsset.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidAsset",
      value: SuperfluidAsset.encode(e).finish()
    };
  }
};
function createBaseSuperfluidIntermediaryAccount() {
  return {
    denom: "",
    valAddr: "",
    gaugeId: Long$2.UZERO
  };
}
const SuperfluidIntermediaryAccount = {
  typeUrl: "/osmosis.superfluid.SuperfluidIntermediaryAccount",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.valAddr !== "" && n.uint32(18).string(e.valAddr), e.gaugeId.isZero() || n.uint32(24).uint64(e.gaugeId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidIntermediaryAccount();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.valAddr = o.string();
          break;
        case 3:
          c.gaugeId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSuperfluidIntermediaryAccount();
    return u.denom = (n = e.denom) !== null && n !== void 0 ? n : "", u.valAddr = (o = e.valAddr) !== null && o !== void 0 ? o : "", u.gaugeId = e.gaugeId !== void 0 && e.gaugeId !== null ? Long$2.fromValue(e.gaugeId) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      valAddr: e.val_addr,
      gaugeId: Long$2.fromString(e.gauge_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.val_addr = e.valAddr, n.gauge_id = e.gaugeId ? e.gaugeId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return SuperfluidIntermediaryAccount.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-intermediary-account",
      value: SuperfluidIntermediaryAccount.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidIntermediaryAccount.decode(e.value);
  },
  toProto(e) {
    return SuperfluidIntermediaryAccount.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidIntermediaryAccount",
      value: SuperfluidIntermediaryAccount.encode(e).finish()
    };
  }
};
function createBaseOsmoEquivalentMultiplierRecord() {
  return {
    epochNumber: Long$2.ZERO,
    denom: "",
    multiplier: ""
  };
}
const OsmoEquivalentMultiplierRecord = {
  typeUrl: "/osmosis.superfluid.OsmoEquivalentMultiplierRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.epochNumber.isZero() || n.uint32(8).int64(e.epochNumber), e.denom !== "" && n.uint32(18).string(e.denom), e.multiplier !== "" && n.uint32(26).string(e.multiplier), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseOsmoEquivalentMultiplierRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.epochNumber = o.int64();
          break;
        case 2:
          c.denom = o.string();
          break;
        case 3:
          c.multiplier = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseOsmoEquivalentMultiplierRecord();
    return u.epochNumber = e.epochNumber !== void 0 && e.epochNumber !== null ? Long$2.fromValue(e.epochNumber) : Long$2.ZERO, u.denom = (n = e.denom) !== null && n !== void 0 ? n : "", u.multiplier = (o = e.multiplier) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      epochNumber: Long$2.fromString(e.epoch_number),
      denom: e.denom,
      multiplier: e.multiplier
    };
  },
  toAmino(e) {
    const n = {};
    return n.epoch_number = e.epochNumber ? e.epochNumber.toString() : void 0, n.denom = e.denom, n.multiplier = e.multiplier, n;
  },
  fromAminoMsg(e) {
    return OsmoEquivalentMultiplierRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/osmo-equivalent-multiplier-record",
      value: OsmoEquivalentMultiplierRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return OsmoEquivalentMultiplierRecord.decode(e.value);
  },
  toProto(e) {
    return OsmoEquivalentMultiplierRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.OsmoEquivalentMultiplierRecord",
      value: OsmoEquivalentMultiplierRecord.encode(e).finish()
    };
  }
};
function createBaseSuperfluidDelegationRecord() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    delegationAmount: void 0,
    equivalentStakedAmount: void 0
  };
}
const SuperfluidDelegationRecord = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.delegationAmount !== void 0 && Coin.encode(e.delegationAmount, n.uint32(26).fork()).ldelim(), e.equivalentStakedAmount !== void 0 && Coin.encode(e.equivalentStakedAmount, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidDelegationRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        case 3:
          c.delegationAmount = Coin.decode(o, o.uint32());
          break;
        case 4:
          c.equivalentStakedAmount = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSuperfluidDelegationRecord();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", u.delegationAmount = e.delegationAmount !== void 0 && e.delegationAmount !== null ? Coin.fromPartial(e.delegationAmount) : void 0, u.equivalentStakedAmount = e.equivalentStakedAmount !== void 0 && e.equivalentStakedAmount !== null ? Coin.fromPartial(e.equivalentStakedAmount) : void 0, u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address,
      delegationAmount: e != null && e.delegation_amount ? Coin.fromAmino(e.delegation_amount) : void 0,
      equivalentStakedAmount: e != null && e.equivalent_staked_amount ? Coin.fromAmino(e.equivalent_staked_amount) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n.delegation_amount = e.delegationAmount ? Coin.toAmino(e.delegationAmount) : void 0, n.equivalent_staked_amount = e.equivalentStakedAmount ? Coin.toAmino(e.equivalentStakedAmount) : void 0, n;
  },
  fromAminoMsg(e) {
    return SuperfluidDelegationRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegation-record",
      value: SuperfluidDelegationRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidDelegationRecord.decode(e.value);
  },
  toProto(e) {
    return SuperfluidDelegationRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationRecord",
      value: SuperfluidDelegationRecord.encode(e).finish()
    };
  }
};
function createBaseLockIdIntermediaryAccountConnection() {
  return {
    lockId: Long$2.UZERO,
    intermediaryAccount: ""
  };
}
const LockIdIntermediaryAccountConnection = {
  typeUrl: "/osmosis.superfluid.LockIdIntermediaryAccountConnection",
  encode(e, n = minimal.Writer.create()) {
    return e.lockId.isZero() || n.uint32(8).uint64(e.lockId), e.intermediaryAccount !== "" && n.uint32(18).string(e.intermediaryAccount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLockIdIntermediaryAccountConnection();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockId = o.uint64();
          break;
        case 2:
          c.intermediaryAccount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseLockIdIntermediaryAccountConnection();
    return o.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, o.intermediaryAccount = (n = e.intermediaryAccount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      lockId: Long$2.fromString(e.lock_id),
      intermediaryAccount: e.intermediary_account
    };
  },
  toAmino(e) {
    const n = {};
    return n.lock_id = e.lockId ? e.lockId.toString() : void 0, n.intermediary_account = e.intermediaryAccount, n;
  },
  fromAminoMsg(e) {
    return LockIdIntermediaryAccountConnection.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lock-id-intermediary-account-connection",
      value: LockIdIntermediaryAccountConnection.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LockIdIntermediaryAccountConnection.decode(e.value);
  },
  toProto(e) {
    return LockIdIntermediaryAccountConnection.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.LockIdIntermediaryAccountConnection",
      value: LockIdIntermediaryAccountConnection.encode(e).finish()
    };
  }
};
function createBaseUnpoolWhitelistedPools() {
  return {
    ids: []
  };
}
const UnpoolWhitelistedPools = {
  typeUrl: "/osmosis.superfluid.UnpoolWhitelistedPools",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.ids)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUnpoolWhitelistedPools();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.ids.push(o.uint64());
          } else
            c.ids.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseUnpoolWhitelistedPools();
    return o.ids = ((n = e.ids) === null || n === void 0 ? void 0 : n.map((u) => Long$2.fromValue(u))) || [], o;
  },
  fromAmino(e) {
    return {
      ids: Array.isArray(e == null ? void 0 : e.ids) ? e.ids.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.ids ? n.ids = e.ids.map((o) => o) : n.ids = [], n;
  },
  fromAminoMsg(e) {
    return UnpoolWhitelistedPools.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/unpool-whitelisted-pools",
      value: UnpoolWhitelistedPools.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UnpoolWhitelistedPools.decode(e.value);
  },
  toProto(e) {
    return UnpoolWhitelistedPools.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.UnpoolWhitelistedPools",
      value: UnpoolWhitelistedPools.encode(e).finish()
    };
  }
}, _163 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LockIdIntermediaryAccountConnection,
  OsmoEquivalentMultiplierRecord,
  SuperfluidAsset,
  get SuperfluidAssetType() {
    return SuperfluidAssetType;
  },
  SuperfluidAssetTypeAmino,
  SuperfluidAssetTypeSDKType,
  SuperfluidDelegationRecord,
  SuperfluidIntermediaryAccount,
  UnpoolWhitelistedPools,
  superfluidAssetTypeFromJSON,
  superfluidAssetTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseSetSuperfluidAssetsProposal() {
  return {
    $typeUrl: "/osmosis.superfluid.v1beta1.SetSuperfluidAssetsProposal",
    title: "",
    description: "",
    assets: []
  };
}
const SetSuperfluidAssetsProposal = {
  typeUrl: "/osmosis.superfluid.v1beta1.SetSuperfluidAssetsProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description);
    for (const o of e.assets)
      SuperfluidAsset.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSetSuperfluidAssetsProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.assets.push(SuperfluidAsset.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSetSuperfluidAssetsProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.assets = ((u = e.assets) === null || u === void 0 ? void 0 : u.map((d) => SuperfluidAsset.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      assets: Array.isArray(e == null ? void 0 : e.assets) ? e.assets.map((n) => SuperfluidAsset.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.assets ? n.assets = e.assets.map((o) => o ? SuperfluidAsset.toAmino(o) : void 0) : n.assets = [], n;
  },
  fromAminoMsg(e) {
    return SetSuperfluidAssetsProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/set-superfluid-assets-proposal",
      value: SetSuperfluidAssetsProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SetSuperfluidAssetsProposal.decode(e.value);
  },
  toProto(e) {
    return SetSuperfluidAssetsProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.v1beta1.SetSuperfluidAssetsProposal",
      value: SetSuperfluidAssetsProposal.encode(e).finish()
    };
  }
};
function createBaseRemoveSuperfluidAssetsProposal() {
  return {
    $typeUrl: "/osmosis.superfluid.v1beta1.RemoveSuperfluidAssetsProposal",
    title: "",
    description: "",
    superfluidAssetDenoms: []
  };
}
const RemoveSuperfluidAssetsProposal = {
  typeUrl: "/osmosis.superfluid.v1beta1.RemoveSuperfluidAssetsProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description);
    for (const o of e.superfluidAssetDenoms)
      n.uint32(26).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRemoveSuperfluidAssetsProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.superfluidAssetDenoms.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRemoveSuperfluidAssetsProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.superfluidAssetDenoms = ((u = e.superfluidAssetDenoms) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      superfluidAssetDenoms: Array.isArray(e == null ? void 0 : e.superfluid_asset_denoms) ? e.superfluid_asset_denoms.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.superfluidAssetDenoms ? n.superfluid_asset_denoms = e.superfluidAssetDenoms.map((o) => o) : n.superfluid_asset_denoms = [], n;
  },
  fromAminoMsg(e) {
    return RemoveSuperfluidAssetsProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/del-superfluid-assets-proposal",
      value: RemoveSuperfluidAssetsProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RemoveSuperfluidAssetsProposal.decode(e.value);
  },
  toProto(e) {
    return RemoveSuperfluidAssetsProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.v1beta1.RemoveSuperfluidAssetsProposal",
      value: RemoveSuperfluidAssetsProposal.encode(e).finish()
    };
  }
};
function createBaseUpdateUnpoolWhiteListProposal() {
  return {
    $typeUrl: "/osmosis.superfluid.v1beta1.UpdateUnpoolWhiteListProposal",
    title: "",
    description: "",
    ids: [],
    isOverwrite: !1
  };
}
const UpdateUnpoolWhiteListProposal = {
  typeUrl: "/osmosis.superfluid.v1beta1.UpdateUnpoolWhiteListProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), n.uint32(26).fork();
    for (const o of e.ids)
      n.uint64(o);
    return n.ldelim(), e.isOverwrite === !0 && n.uint32(32).bool(e.isOverwrite), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpdateUnpoolWhiteListProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.ids.push(o.uint64());
          } else
            c.ids.push(o.uint64());
          break;
        case 4:
          c.isOverwrite = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseUpdateUnpoolWhiteListProposal();
    return d.title = (n = e.title) !== null && n !== void 0 ? n : "", d.description = (o = e.description) !== null && o !== void 0 ? o : "", d.ids = ((u = e.ids) === null || u === void 0 ? void 0 : u.map((m) => Long$2.fromValue(m))) || [], d.isOverwrite = (c = e.isOverwrite) !== null && c !== void 0 ? c : !1, d;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      ids: Array.isArray(e == null ? void 0 : e.ids) ? e.ids.map((n) => n) : [],
      isOverwrite: e.is_overwrite
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.ids ? n.ids = e.ids.map((o) => o) : n.ids = [], n.is_overwrite = e.isOverwrite, n;
  },
  fromAminoMsg(e) {
    return UpdateUnpoolWhiteListProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/update-unpool-whitelist",
      value: UpdateUnpoolWhiteListProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpdateUnpoolWhiteListProposal.decode(e.value);
  },
  toProto(e) {
    return UpdateUnpoolWhiteListProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.v1beta1.UpdateUnpoolWhiteListProposal",
      value: UpdateUnpoolWhiteListProposal.encode(e).finish()
    };
  }
};
function createBaseFeeToken() {
  return {
    denom: "",
    poolID: Long$2.UZERO
  };
}
const FeeToken = {
  typeUrl: "/osmosis.txfees.v1beta1.FeeToken",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.poolID.isZero() || n.uint32(16).uint64(e.poolID), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFeeToken();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.poolID = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseFeeToken();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o.poolID = e.poolID !== void 0 && e.poolID !== null ? Long$2.fromValue(e.poolID) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      poolID: Long$2.fromString(e.poolID)
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.poolID = e.poolID ? e.poolID.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return FeeToken.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/fee-token",
      value: FeeToken.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return FeeToken.decode(e.value);
  },
  toProto(e) {
    return FeeToken.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.FeeToken",
      value: FeeToken.encode(e).finish()
    };
  }
}, _173 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FeeToken
}, Symbol.toStringTag, { value: "Module" }));
function createBaseUpdateFeeTokenProposal() {
  return {
    $typeUrl: "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal",
    title: "",
    description: "",
    feetoken: void 0
  };
}
const UpdateFeeTokenProposal = {
  typeUrl: "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal",
  encode(e, n = minimal.Writer.create()) {
    return e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description), e.feetoken !== void 0 && FeeToken.encode(e.feetoken, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpdateFeeTokenProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.feetoken = FeeToken.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseUpdateFeeTokenProposal();
    return u.title = (n = e.title) !== null && n !== void 0 ? n : "", u.description = (o = e.description) !== null && o !== void 0 ? o : "", u.feetoken = e.feetoken !== void 0 && e.feetoken !== null ? FeeToken.fromPartial(e.feetoken) : void 0, u;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      feetoken: e != null && e.feetoken ? FeeToken.fromAmino(e.feetoken) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, n.feetoken = e.feetoken ? FeeToken.toAmino(e.feetoken) : void 0, n;
  },
  fromAminoMsg(e) {
    return UpdateFeeTokenProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/UpdateFeeTokenProposal",
      value: UpdateFeeTokenProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpdateFeeTokenProposal.decode(e.value);
  },
  toProto(e) {
    return UpdateFeeTokenProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal",
      value: UpdateFeeTokenProposal.encode(e).finish()
    };
  }
}, _175 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UpdateFeeTokenProposal
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSubmitProposal() {
  return {
    messages: [],
    initialDeposit: [],
    proposer: "",
    metadata: ""
  };
}
const MsgSubmitProposal = {
  typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.messages)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.initialDeposit)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return e.proposer !== "" && n.uint32(26).string(e.proposer), e.metadata !== "" && n.uint32(34).string(e.metadata), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSubmitProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.messages.push(Any.decode(o, o.uint32()));
          break;
        case 2:
          c.initialDeposit.push(Coin.decode(o, o.uint32()));
          break;
        case 3:
          c.proposer = o.string();
          break;
        case 4:
          c.metadata = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgSubmitProposal();
    return d.messages = ((n = e.messages) === null || n === void 0 ? void 0 : n.map((m) => Any.fromPartial(m))) || [], d.initialDeposit = ((o = e.initialDeposit) === null || o === void 0 ? void 0 : o.map((m) => Coin.fromPartial(m))) || [], d.proposer = (u = e.proposer) !== null && u !== void 0 ? u : "", d.metadata = (c = e.metadata) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      messages: Array.isArray(e == null ? void 0 : e.messages) ? e.messages.map((n) => Any.fromAmino(n)) : [],
      initialDeposit: Array.isArray(e == null ? void 0 : e.initial_deposit) ? e.initial_deposit.map((n) => Coin.fromAmino(n)) : [],
      proposer: e.proposer,
      metadata: e.metadata
    };
  },
  toAmino(e) {
    const n = {};
    return e.messages ? n.messages = e.messages.map((o) => o ? Any.toAmino(o) : void 0) : n.messages = [], e.initialDeposit ? n.initial_deposit = e.initialDeposit.map((o) => o ? Coin.toAmino(o) : void 0) : n.initial_deposit = [], n.proposer = e.proposer, n.metadata = e.metadata, n;
  },
  fromAminoMsg(e) {
    return MsgSubmitProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgSubmitProposal",
      value: MsgSubmitProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSubmitProposal.decode(e.value);
  },
  toProto(e) {
    return MsgSubmitProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
      value: MsgSubmitProposal.encode(e).finish()
    };
  }
};
function createBaseMsgSubmitProposalResponse() {
  return {
    proposalId: Long$2.UZERO
  };
}
const MsgSubmitProposalResponse = {
  typeUrl: "/cosmos.gov.v1.MsgSubmitProposalResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSubmitProposalResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgSubmitProposalResponse();
    return n.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSubmitProposalResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgSubmitProposalResponse",
      value: MsgSubmitProposalResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSubmitProposalResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSubmitProposalResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgSubmitProposalResponse",
      value: MsgSubmitProposalResponse.encode(e).finish()
    };
  }
};
function createBaseMsgExecLegacyContent() {
  return {
    content: void 0,
    authority: ""
  };
}
const MsgExecLegacyContent = {
  typeUrl: "/cosmos.gov.v1.MsgExecLegacyContent",
  encode(e, n = minimal.Writer.create()) {
    return e.content !== void 0 && Any.encode(e.content, n.uint32(10).fork()).ldelim(), e.authority !== "" && n.uint32(18).string(e.authority), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExecLegacyContent();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.content = Cosmos_govv1beta1Content_InterfaceDecoder(o);
          break;
        case 2:
          c.authority = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgExecLegacyContent();
    return o.content = e.content !== void 0 && e.content !== null ? Any.fromPartial(e.content) : void 0, o.authority = (n = e.authority) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      content: e != null && e.content ? Cosmos_govv1beta1Content_FromAmino(e.content) : void 0,
      authority: e.authority
    };
  },
  toAmino(e) {
    const n = {};
    return n.content = e.content ? Cosmos_govv1beta1Content_ToAmino(e.content) : void 0, n.authority = e.authority, n;
  },
  fromAminoMsg(e) {
    return MsgExecLegacyContent.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgExecLegacyContent",
      value: MsgExecLegacyContent.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExecLegacyContent.decode(e.value);
  },
  toProto(e) {
    return MsgExecLegacyContent.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgExecLegacyContent",
      value: MsgExecLegacyContent.encode(e).finish()
    };
  }
};
function createBaseMsgExecLegacyContentResponse() {
  return {};
}
const MsgExecLegacyContentResponse = {
  typeUrl: "/cosmos.gov.v1.MsgExecLegacyContentResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExecLegacyContentResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgExecLegacyContentResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgExecLegacyContentResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgExecLegacyContentResponse",
      value: MsgExecLegacyContentResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExecLegacyContentResponse.decode(e.value);
  },
  toProto(e) {
    return MsgExecLegacyContentResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgExecLegacyContentResponse",
      value: MsgExecLegacyContentResponse.encode(e).finish()
    };
  }
};
function createBaseMsgVote() {
  return {
    proposalId: Long$2.UZERO,
    voter: "",
    option: 0,
    metadata: ""
  };
}
const MsgVote = {
  typeUrl: "/cosmos.gov.v1.MsgVote",
  encode(e, n = minimal.Writer.create()) {
    return e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.voter !== "" && n.uint32(18).string(e.voter), e.option !== 0 && n.uint32(24).int32(e.option), e.metadata !== "" && n.uint32(34).string(e.metadata), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgVote();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.voter = o.string();
          break;
        case 3:
          c.option = o.int32();
          break;
        case 4:
          c.metadata = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgVote();
    return c.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, c.voter = (n = e.voter) !== null && n !== void 0 ? n : "", c.option = (o = e.option) !== null && o !== void 0 ? o : 0, c.metadata = (u = e.metadata) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      voter: e.voter,
      option: isSet(e.option) ? voteOptionFromJSON(e.option) : 0,
      metadata: e.metadata
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.voter = e.voter, n.option = e.option, n.metadata = e.metadata, n;
  },
  fromAminoMsg(e) {
    return MsgVote.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgVote",
      value: MsgVote.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgVote.decode(e.value);
  },
  toProto(e) {
    return MsgVote.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgVote",
      value: MsgVote.encode(e).finish()
    };
  }
};
function createBaseMsgVoteResponse() {
  return {};
}
const MsgVoteResponse = {
  typeUrl: "/cosmos.gov.v1.MsgVoteResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgVoteResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgVoteResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgVoteResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgVoteResponse",
      value: MsgVoteResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgVoteResponse.decode(e.value);
  },
  toProto(e) {
    return MsgVoteResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgVoteResponse",
      value: MsgVoteResponse.encode(e).finish()
    };
  }
};
function createBaseMsgVoteWeighted() {
  return {
    proposalId: Long$2.UZERO,
    voter: "",
    options: [],
    metadata: ""
  };
}
const MsgVoteWeighted = {
  typeUrl: "/cosmos.gov.v1.MsgVoteWeighted",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.voter !== "" && n.uint32(18).string(e.voter);
    for (const o of e.options)
      WeightedVoteOption.encode(o, n.uint32(26).fork()).ldelim();
    return e.metadata !== "" && n.uint32(34).string(e.metadata), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgVoteWeighted();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.voter = o.string();
          break;
        case 3:
          c.options.push(WeightedVoteOption.decode(o, o.uint32()));
          break;
        case 4:
          c.metadata = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgVoteWeighted();
    return c.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, c.voter = (n = e.voter) !== null && n !== void 0 ? n : "", c.options = ((o = e.options) === null || o === void 0 ? void 0 : o.map((d) => WeightedVoteOption.fromPartial(d))) || [], c.metadata = (u = e.metadata) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      voter: e.voter,
      options: Array.isArray(e == null ? void 0 : e.options) ? e.options.map((n) => WeightedVoteOption.fromAmino(n)) : [],
      metadata: e.metadata
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.voter = e.voter, e.options ? n.options = e.options.map((o) => o ? WeightedVoteOption.toAmino(o) : void 0) : n.options = [], n.metadata = e.metadata, n;
  },
  fromAminoMsg(e) {
    return MsgVoteWeighted.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgVoteWeighted",
      value: MsgVoteWeighted.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgVoteWeighted.decode(e.value);
  },
  toProto(e) {
    return MsgVoteWeighted.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgVoteWeighted",
      value: MsgVoteWeighted.encode(e).finish()
    };
  }
};
function createBaseMsgVoteWeightedResponse() {
  return {};
}
const MsgVoteWeightedResponse = {
  typeUrl: "/cosmos.gov.v1.MsgVoteWeightedResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgVoteWeightedResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgVoteWeightedResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgVoteWeightedResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgVoteWeightedResponse",
      value: MsgVoteWeightedResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgVoteWeightedResponse.decode(e.value);
  },
  toProto(e) {
    return MsgVoteWeightedResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgVoteWeightedResponse",
      value: MsgVoteWeightedResponse.encode(e).finish()
    };
  }
};
function createBaseMsgDeposit() {
  return {
    proposalId: Long$2.UZERO,
    depositor: "",
    amount: []
  };
}
const MsgDeposit = {
  typeUrl: "/cosmos.gov.v1.MsgDeposit",
  encode(e, n = minimal.Writer.create()) {
    e.proposalId.isZero() || n.uint32(8).uint64(e.proposalId), e.depositor !== "" && n.uint32(18).string(e.depositor);
    for (const o of e.amount)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDeposit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proposalId = o.uint64();
          break;
        case 2:
          c.depositor = o.string();
          break;
        case 3:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgDeposit();
    return u.proposalId = e.proposalId !== void 0 && e.proposalId !== null ? Long$2.fromValue(e.proposalId) : Long$2.UZERO, u.depositor = (n = e.depositor) !== null && n !== void 0 ? n : "", u.amount = ((o = e.amount) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      proposalId: Long$2.fromString(e.proposal_id),
      depositor: e.depositor,
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.proposal_id = e.proposalId ? e.proposalId.toString() : void 0, n.depositor = e.depositor, e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n;
  },
  fromAminoMsg(e) {
    return MsgDeposit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgDeposit",
      value: MsgDeposit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDeposit.decode(e.value);
  },
  toProto(e) {
    return MsgDeposit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgDeposit",
      value: MsgDeposit.encode(e).finish()
    };
  }
};
function createBaseMsgDepositResponse() {
  return {};
}
const MsgDepositResponse = {
  typeUrl: "/cosmos.gov.v1.MsgDepositResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDepositResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgDepositResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgDepositResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/v1/MsgDepositResponse",
      value: MsgDepositResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDepositResponse.decode(e.value);
  },
  toProto(e) {
    return MsgDepositResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.gov.v1.MsgDepositResponse",
      value: MsgDepositResponse.encode(e).finish()
    };
  }
}, Cosmos_govv1beta1Content_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/ibc.core.client.v1.ClientUpdateProposal":
      return ClientUpdateProposal.decode(o.value);
    case "/ibc.core.client.v1.UpgradeProposal":
      return UpgradeProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.StoreCodeProposal":
      return StoreCodeProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.InstantiateContractProposal":
      return InstantiateContractProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.InstantiateContract2Proposal":
      return InstantiateContract2Proposal.decode(o.value);
    case "/cosmwasm.wasm.v1.MigrateContractProposal":
      return MigrateContractProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.SudoContractProposal":
      return SudoContractProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.ExecuteContractProposal":
      return ExecuteContractProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.UpdateAdminProposal":
      return UpdateAdminProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.ClearAdminProposal":
      return ClearAdminProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.PinCodesProposal":
      return PinCodesProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.UnpinCodesProposal":
      return UnpinCodesProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal":
      return UpdateInstantiateConfigProposal.decode(o.value);
    case "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal":
      return StoreAndInstantiateContractProposal.decode(o.value);
    case "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal":
      return ReplacePoolIncentivesProposal.decode(o.value);
    case "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal":
      return UpdatePoolIncentivesProposal.decode(o.value);
    case "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal":
      return SetProtoRevEnabledProposal.decode(o.value);
    case "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal":
      return SetProtoRevAdminAccountProposal.decode(o.value);
    case "/osmosis.superfluid.v1beta1.SetSuperfluidAssetsProposal":
      return SetSuperfluidAssetsProposal.decode(o.value);
    case "/osmosis.superfluid.v1beta1.RemoveSuperfluidAssetsProposal":
      return RemoveSuperfluidAssetsProposal.decode(o.value);
    case "/osmosis.superfluid.v1beta1.UpdateUnpoolWhiteListProposal":
      return UpdateUnpoolWhiteListProposal.decode(o.value);
    case "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal":
      return UpdateFeeTokenProposal.decode(o.value);
    default:
      return o;
  }
}, Cosmos_govv1beta1Content_FromAmino = (e) => {
  switch (e.type) {
    case "cosmos-sdk/ClientUpdateProposal":
      return Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
        value: ClientUpdateProposal.encode(ClientUpdateProposal.fromPartial(ClientUpdateProposal.fromAmino(e.value))).finish()
      });
    case "cosmos-sdk/UpgradeProposal":
      return Any.fromPartial({
        typeUrl: "/ibc.core.client.v1.UpgradeProposal",
        value: UpgradeProposal.encode(UpgradeProposal.fromPartial(UpgradeProposal.fromAmino(e.value))).finish()
      });
    case "wasm/StoreCodeProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
        value: StoreCodeProposal.encode(StoreCodeProposal.fromPartial(StoreCodeProposal.fromAmino(e.value))).finish()
      });
    case "wasm/InstantiateContractProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
        value: InstantiateContractProposal.encode(InstantiateContractProposal.fromPartial(InstantiateContractProposal.fromAmino(e.value))).finish()
      });
    case "wasm/InstantiateContract2Proposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.InstantiateContract2Proposal",
        value: InstantiateContract2Proposal.encode(InstantiateContract2Proposal.fromPartial(InstantiateContract2Proposal.fromAmino(e.value))).finish()
      });
    case "wasm/MigrateContractProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
        value: MigrateContractProposal.encode(MigrateContractProposal.fromPartial(MigrateContractProposal.fromAmino(e.value))).finish()
      });
    case "wasm/SudoContractProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
        value: SudoContractProposal.encode(SudoContractProposal.fromPartial(SudoContractProposal.fromAmino(e.value))).finish()
      });
    case "wasm/ExecuteContractProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
        value: ExecuteContractProposal.encode(ExecuteContractProposal.fromPartial(ExecuteContractProposal.fromAmino(e.value))).finish()
      });
    case "wasm/UpdateAdminProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
        value: UpdateAdminProposal.encode(UpdateAdminProposal.fromPartial(UpdateAdminProposal.fromAmino(e.value))).finish()
      });
    case "wasm/ClearAdminProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
        value: ClearAdminProposal.encode(ClearAdminProposal.fromPartial(ClearAdminProposal.fromAmino(e.value))).finish()
      });
    case "wasm/PinCodesProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
        value: PinCodesProposal.encode(PinCodesProposal.fromPartial(PinCodesProposal.fromAmino(e.value))).finish()
      });
    case "wasm/UnpinCodesProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
        value: UnpinCodesProposal.encode(UnpinCodesProposal.fromPartial(UnpinCodesProposal.fromAmino(e.value))).finish()
      });
    case "wasm/UpdateInstantiateConfigProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
        value: UpdateInstantiateConfigProposal.encode(UpdateInstantiateConfigProposal.fromPartial(UpdateInstantiateConfigProposal.fromAmino(e.value))).finish()
      });
    case "wasm/StoreAndInstantiateContractProposal":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal",
        value: StoreAndInstantiateContractProposal.encode(StoreAndInstantiateContractProposal.fromPartial(StoreAndInstantiateContractProposal.fromAmino(e.value))).finish()
      });
    case "osmosis/poolincentives/replace-pool-incentives-proposal":
      return Any.fromPartial({
        typeUrl: "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal",
        value: ReplacePoolIncentivesProposal.encode(ReplacePoolIncentivesProposal.fromPartial(ReplacePoolIncentivesProposal.fromAmino(e.value))).finish()
      });
    case "osmosis/UpdatePoolIncentivesProposal":
      return Any.fromPartial({
        typeUrl: "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal",
        value: UpdatePoolIncentivesProposal.encode(UpdatePoolIncentivesProposal.fromPartial(UpdatePoolIncentivesProposal.fromAmino(e.value))).finish()
      });
    case "osmosis/protorev/set-proto-rev-enabled-proposal":
      return Any.fromPartial({
        typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal",
        value: SetProtoRevEnabledProposal.encode(SetProtoRevEnabledProposal.fromPartial(SetProtoRevEnabledProposal.fromAmino(e.value))).finish()
      });
    case "osmosis/protorev/set-proto-rev-admin-account-proposal":
      return Any.fromPartial({
        typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal",
        value: SetProtoRevAdminAccountProposal.encode(SetProtoRevAdminAccountProposal.fromPartial(SetProtoRevAdminAccountProposal.fromAmino(e.value))).finish()
      });
    case "osmosis/set-superfluid-assets-proposal":
      return Any.fromPartial({
        typeUrl: "/osmosis.superfluid.v1beta1.SetSuperfluidAssetsProposal",
        value: SetSuperfluidAssetsProposal.encode(SetSuperfluidAssetsProposal.fromPartial(SetSuperfluidAssetsProposal.fromAmino(e.value))).finish()
      });
    case "osmosis/del-superfluid-assets-proposal":
      return Any.fromPartial({
        typeUrl: "/osmosis.superfluid.v1beta1.RemoveSuperfluidAssetsProposal",
        value: RemoveSuperfluidAssetsProposal.encode(RemoveSuperfluidAssetsProposal.fromPartial(RemoveSuperfluidAssetsProposal.fromAmino(e.value))).finish()
      });
    case "osmosis/update-unpool-whitelist":
      return Any.fromPartial({
        typeUrl: "/osmosis.superfluid.v1beta1.UpdateUnpoolWhiteListProposal",
        value: UpdateUnpoolWhiteListProposal.encode(UpdateUnpoolWhiteListProposal.fromPartial(UpdateUnpoolWhiteListProposal.fromAmino(e.value))).finish()
      });
    case "osmosis/UpdateFeeTokenProposal":
      return Any.fromPartial({
        typeUrl: "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal",
        value: UpdateFeeTokenProposal.encode(UpdateFeeTokenProposal.fromPartial(UpdateFeeTokenProposal.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, Cosmos_govv1beta1Content_ToAmino = (e) => {
  switch (e.typeUrl) {
    case "/ibc.core.client.v1.ClientUpdateProposal":
      return {
        type: "cosmos-sdk/ClientUpdateProposal",
        value: ClientUpdateProposal.toAmino(ClientUpdateProposal.decode(e.value))
      };
    case "/ibc.core.client.v1.UpgradeProposal":
      return {
        type: "cosmos-sdk/UpgradeProposal",
        value: UpgradeProposal.toAmino(UpgradeProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.StoreCodeProposal":
      return {
        type: "wasm/StoreCodeProposal",
        value: StoreCodeProposal.toAmino(StoreCodeProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.InstantiateContractProposal":
      return {
        type: "wasm/InstantiateContractProposal",
        value: InstantiateContractProposal.toAmino(InstantiateContractProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.InstantiateContract2Proposal":
      return {
        type: "wasm/InstantiateContract2Proposal",
        value: InstantiateContract2Proposal.toAmino(InstantiateContract2Proposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.MigrateContractProposal":
      return {
        type: "wasm/MigrateContractProposal",
        value: MigrateContractProposal.toAmino(MigrateContractProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.SudoContractProposal":
      return {
        type: "wasm/SudoContractProposal",
        value: SudoContractProposal.toAmino(SudoContractProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.ExecuteContractProposal":
      return {
        type: "wasm/ExecuteContractProposal",
        value: ExecuteContractProposal.toAmino(ExecuteContractProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.UpdateAdminProposal":
      return {
        type: "wasm/UpdateAdminProposal",
        value: UpdateAdminProposal.toAmino(UpdateAdminProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.ClearAdminProposal":
      return {
        type: "wasm/ClearAdminProposal",
        value: ClearAdminProposal.toAmino(ClearAdminProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.PinCodesProposal":
      return {
        type: "wasm/PinCodesProposal",
        value: PinCodesProposal.toAmino(PinCodesProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.UnpinCodesProposal":
      return {
        type: "wasm/UnpinCodesProposal",
        value: UnpinCodesProposal.toAmino(UnpinCodesProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal":
      return {
        type: "wasm/UpdateInstantiateConfigProposal",
        value: UpdateInstantiateConfigProposal.toAmino(UpdateInstantiateConfigProposal.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal":
      return {
        type: "wasm/StoreAndInstantiateContractProposal",
        value: StoreAndInstantiateContractProposal.toAmino(StoreAndInstantiateContractProposal.decode(e.value))
      };
    case "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal":
      return {
        type: "osmosis/poolincentives/replace-pool-incentives-proposal",
        value: ReplacePoolIncentivesProposal.toAmino(ReplacePoolIncentivesProposal.decode(e.value))
      };
    case "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal":
      return {
        type: "osmosis/UpdatePoolIncentivesProposal",
        value: UpdatePoolIncentivesProposal.toAmino(UpdatePoolIncentivesProposal.decode(e.value))
      };
    case "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal":
      return {
        type: "osmosis/protorev/set-proto-rev-enabled-proposal",
        value: SetProtoRevEnabledProposal.toAmino(SetProtoRevEnabledProposal.decode(e.value))
      };
    case "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal":
      return {
        type: "osmosis/protorev/set-proto-rev-admin-account-proposal",
        value: SetProtoRevAdminAccountProposal.toAmino(SetProtoRevAdminAccountProposal.decode(e.value))
      };
    case "/osmosis.superfluid.v1beta1.SetSuperfluidAssetsProposal":
      return {
        type: "osmosis/set-superfluid-assets-proposal",
        value: SetSuperfluidAssetsProposal.toAmino(SetSuperfluidAssetsProposal.decode(e.value))
      };
    case "/osmosis.superfluid.v1beta1.RemoveSuperfluidAssetsProposal":
      return {
        type: "osmosis/del-superfluid-assets-proposal",
        value: RemoveSuperfluidAssetsProposal.toAmino(RemoveSuperfluidAssetsProposal.decode(e.value))
      };
    case "/osmosis.superfluid.v1beta1.UpdateUnpoolWhiteListProposal":
      return {
        type: "osmosis/update-unpool-whitelist",
        value: UpdateUnpoolWhiteListProposal.toAmino(UpdateUnpoolWhiteListProposal.decode(e.value))
      };
    case "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal":
      return {
        type: "osmosis/UpdateFeeTokenProposal",
        value: UpdateFeeTokenProposal.toAmino(UpdateFeeTokenProposal.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _36 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Cosmos_govv1beta1Content_FromAmino,
  Cosmos_govv1beta1Content_InterfaceDecoder,
  Cosmos_govv1beta1Content_ToAmino,
  MsgDeposit,
  MsgDepositResponse,
  MsgExecLegacyContent,
  MsgExecLegacyContentResponse,
  MsgSubmitProposal,
  MsgSubmitProposalResponse,
  MsgVote,
  MsgVoteResponse,
  MsgVoteWeighted,
  MsgVoteWeightedResponse
}, Symbol.toStringTag, { value: "Module" }));
var build$9 = {}, addresses$1 = {}, build$8 = {}, bip39 = {}, pbkdf2 = {}, build$7 = {}, arrays = {};
Object.defineProperty(arrays, "__esModule", { value: !0 });
arrays.arrayContentStartsWith = arrays.arrayContentEquals = void 0;
function arrayContentEquals(e, n) {
  if (e.length !== n.length)
    return !1;
  for (let o = 0; o < e.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays.arrayContentEquals = arrayContentEquals;
function arrayContentStartsWith(e, n) {
  if (e.length < n.length)
    return !1;
  for (let o = 0; o < n.length; ++o)
    if (e[o] !== n[o])
      return !1;
  return !0;
}
arrays.arrayContentStartsWith = arrayContentStartsWith;
var assert$1 = {};
Object.defineProperty(assert$1, "__esModule", { value: !0 });
assert$1.assertDefinedAndNotNull = assert$1.assertDefined = assert$1.assert = void 0;
function assert(e, n) {
  if (!e)
    throw new Error(n || "condition is not truthy");
}
assert$1.assert = assert;
function assertDefined(e, n) {
  if (e === void 0)
    throw new Error(n ?? "value is undefined");
}
assert$1.assertDefined = assertDefined;
function assertDefinedAndNotNull(e, n) {
  if (e == null)
    throw new Error(n ?? "value is undefined or null");
}
assert$1.assertDefinedAndNotNull = assertDefinedAndNotNull;
var sleep$1 = {};
Object.defineProperty(sleep$1, "__esModule", { value: !0 });
sleep$1.sleep = void 0;
async function sleep(e) {
  return new Promise((n) => setTimeout(n, e));
}
sleep$1.sleep = sleep;
var typechecks = {};
Object.defineProperty(typechecks, "__esModule", { value: !0 });
typechecks.isDefined = typechecks.isUint8Array = typechecks.isNonNullObject = void 0;
function isNonNullObject(e) {
  return typeof e == "object" && e !== null;
}
typechecks.isNonNullObject = isNonNullObject;
function isUint8Array(e) {
  return !(!isNonNullObject(e) || Object.prototype.toString.call(e) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(e));
}
typechecks.isUint8Array = isUint8Array;
function isDefined(e) {
  return e !== void 0;
}
typechecks.isDefined = isDefined;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isUint8Array = e.isNonNullObject = e.isDefined = e.sleep = e.assertDefinedAndNotNull = e.assertDefined = e.assert = e.arrayContentStartsWith = e.arrayContentEquals = void 0;
  var n = arrays;
  Object.defineProperty(e, "arrayContentEquals", { enumerable: !0, get: function() {
    return n.arrayContentEquals;
  } }), Object.defineProperty(e, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return n.arrayContentStartsWith;
  } });
  var o = assert$1;
  Object.defineProperty(e, "assert", { enumerable: !0, get: function() {
    return o.assert;
  } }), Object.defineProperty(e, "assertDefined", { enumerable: !0, get: function() {
    return o.assertDefined;
  } }), Object.defineProperty(e, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return o.assertDefinedAndNotNull;
  } });
  var u = sleep$1;
  Object.defineProperty(e, "sleep", { enumerable: !0, get: function() {
    return u.sleep;
  } });
  var c = typechecks;
  Object.defineProperty(e, "isDefined", { enumerable: !0, get: function() {
    return c.isDefined;
  } }), Object.defineProperty(e, "isNonNullObject", { enumerable: !0, get: function() {
    return c.isNonNullObject;
  } }), Object.defineProperty(e, "isUint8Array", { enumerable: !0, get: function() {
    return c.isUint8Array;
  } });
})(build$7);
var __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$2(n, e, o);
  return __setModuleDefault$2(n, e), n;
};
Object.defineProperty(pbkdf2, "__esModule", { value: !0 });
pbkdf2.pbkdf2Sha512 = pbkdf2.pbkdf2Sha512Noble = pbkdf2.pbkdf2Sha512Crypto = pbkdf2.pbkdf2Sha512Subtle = pbkdf2.getSubtle = pbkdf2.getCryptoModule = void 0;
const utils_1$h = build$7, pbkdf2_1$1 = pbkdf2$8, sha512_1$1 = sha512$a;
async function getCryptoModule() {
  try {
    const e = await Promise.resolve().then(() => __importStar$2(requireCryptoBrowserify()));
    return typeof e == "object" && Object.keys(e).length <= 1 ? void 0 : e;
  } catch {
    return;
  }
}
pbkdf2.getCryptoModule = getCryptoModule;
async function getSubtle() {
  var e, n, o;
  let u = (e = globalThis == null ? void 0 : globalThis.crypto) === null || e === void 0 ? void 0 : e.subtle;
  return u || (u = (o = (n = globalThis == null ? void 0 : globalThis.crypto) === null || n === void 0 ? void 0 : n.webcrypto) === null || o === void 0 ? void 0 : o.subtle), u;
}
pbkdf2.getSubtle = getSubtle;
async function pbkdf2Sha512Subtle(e, n, o, u, c) {
  return (0, utils_1$h.assert)(e, "Argument subtle is falsy"), (0, utils_1$h.assert)(typeof e == "object", "Argument subtle is not of type object"), (0, utils_1$h.assert)(typeof e.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$h.assert)(typeof e.deriveBits == "function", "subtle.deriveBits is not a function"), e.importKey("raw", n, { name: "PBKDF2" }, !1, ["deriveBits"]).then((d) => e.deriveBits({
    name: "PBKDF2",
    salt: o,
    iterations: u,
    hash: { name: "SHA-512" }
  }, d, c * 8).then((m) => new Uint8Array(m)));
}
pbkdf2.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle;
async function pbkdf2Sha512Crypto(e, n, o, u, c) {
  return (0, utils_1$h.assert)(e, "Argument crypto is falsy"), (0, utils_1$h.assert)(typeof e == "object", "Argument crypto is not of type object"), (0, utils_1$h.assert)(typeof e.pbkdf2 == "function", "crypto.pbkdf2 is not a function"), new Promise((d, m) => {
    e.pbkdf2(n, o, u, c, "sha512", (v, S) => {
      v ? m(v) : d(Uint8Array.from(S));
    });
  });
}
pbkdf2.pbkdf2Sha512Crypto = pbkdf2Sha512Crypto;
async function pbkdf2Sha512Noble(e, n, o, u) {
  return (0, pbkdf2_1$1.pbkdf2Async)(sha512_1$1.sha512, e, n, { c: o, dkLen: u });
}
pbkdf2.pbkdf2Sha512Noble = pbkdf2Sha512Noble;
async function pbkdf2Sha512(e, n, o, u) {
  const c = await getSubtle();
  if (c)
    return pbkdf2Sha512Subtle(c, e, n, o, u);
  {
    const d = await getCryptoModule();
    return d ? pbkdf2Sha512Crypto(d, e, n, o, u) : pbkdf2Sha512Noble(e, n, o, u);
  }
}
pbkdf2.pbkdf2Sha512 = pbkdf2Sha512;
var sha = {}, utils$n = {};
Object.defineProperty(utils$n, "__esModule", { value: !0 });
utils$n.toRealUint8Array = void 0;
function toRealUint8Array(e) {
  return e instanceof Uint8Array ? e : Uint8Array.from(e);
}
utils$n.toRealUint8Array = toRealUint8Array;
Object.defineProperty(sha, "__esModule", { value: !0 });
sha.sha512 = sha.Sha512 = sha.sha256 = sha.Sha256 = void 0;
const sha256_1 = sha256$8, sha512_1 = sha512$a, utils_1$g = utils$n;
class Sha256 {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha256_1.sha256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$g.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
sha.Sha256 = Sha256;
function sha256(e) {
  return new Sha256(e).digest();
}
sha.sha256 = sha256;
class Sha512 {
  constructor(n) {
    this.blockSize = 1024 / 8, this.impl = sha512_1.sha512.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$g.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
sha.Sha512 = Sha512;
function sha512(e) {
  return new Sha512(e).digest();
}
sha.sha512 = sha512;
Object.defineProperty(bip39, "__esModule", { value: !0 });
bip39.Bip39 = bip39.EnglishMnemonic = bip39.mnemonicToEntropy = bip39.entropyToMnemonic = void 0;
const encoding_1$m = build$a, pbkdf2_1 = pbkdf2, sha_1 = sha, wordlist = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring(e) {
  return Array.from(e).map((n) => n.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits(e) {
  const o = e.length * 8 / 32, u = (0, sha_1.sha256)(e);
  return bytesToBitstring(u).slice(0, o);
}
function bitstringToByte(e) {
  return parseInt(e, 2);
}
const allowedEntropyLengths = [16, 20, 24, 28, 32], allowedWordLengths = [12, 15, 18, 21, 24];
function entropyToMnemonic(e) {
  if (allowedEntropyLengths.indexOf(e.length) === -1)
    throw new Error("invalid input length");
  const n = bytesToBitstring(e), o = deriveChecksumBits(e);
  return (n + o).match(/(.{11})/g).map((m) => {
    const v = bitstringToByte(m);
    return wordlist[v];
  }).join(" ");
}
bip39.entropyToMnemonic = entropyToMnemonic;
const invalidNumberOfWorks = "Invalid number of words", wordNotInWordlist = "Found word that is not in the wordlist", invalidEntropy = "Invalid entropy", invalidChecksum = "Invalid mnemonic checksum";
function normalize(e) {
  return e.normalize("NFKD");
}
function mnemonicToEntropy(e) {
  const n = normalize(e).split(" ");
  if (!allowedWordLengths.includes(n.length))
    throw new Error(invalidNumberOfWorks);
  const o = n.map(($) => {
    const E = wordlist.indexOf($);
    if (E === -1)
      throw new Error(wordNotInWordlist);
    return E.toString(2).padStart(11, "0");
  }).join(""), u = Math.floor(o.length / 33) * 32, c = o.slice(0, u), d = o.slice(u), m = c.match(/(.{1,8})/g).map(bitstringToByte);
  if (m.length < 16 || m.length > 32 || m.length % 4 !== 0)
    throw new Error(invalidEntropy);
  const v = Uint8Array.from(m);
  if (deriveChecksumBits(v) !== d)
    throw new Error(invalidChecksum);
  return v;
}
bip39.mnemonicToEntropy = mnemonicToEntropy;
class EnglishMnemonic {
  constructor(n) {
    if (!EnglishMnemonic.mnemonicMatcher.test(n))
      throw new Error("Invalid mnemonic format");
    const o = n.split(" "), u = [12, 15, 18, 21, 24];
    if (u.indexOf(o.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${u} got: ${o.length})`);
    for (const c of o)
      if (EnglishMnemonic.wordlist.indexOf(c) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy(n), this.data = n;
  }
  toString() {
    return this.data;
  }
}
bip39.EnglishMnemonic = EnglishMnemonic;
EnglishMnemonic.wordlist = wordlist;
EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class Bip39 {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(n) {
    return new EnglishMnemonic(entropyToMnemonic(n));
  }
  static decode(n) {
    return mnemonicToEntropy(n.toString());
  }
  static async mnemonicToSeed(n, o) {
    const u = (0, encoding_1$m.toUtf8)(normalize(n.toString())), c = "mnemonic" + (o ? normalize(o) : ""), d = (0, encoding_1$m.toUtf8)(c);
    return (0, pbkdf2_1.pbkdf2Sha512)(u, d, 2048, 64);
  }
}
bip39.Bip39 = Bip39;
var hmac = {};
Object.defineProperty(hmac, "__esModule", { value: !0 });
hmac.Hmac = void 0;
class Hmac {
  constructor(n, o) {
    const u = new n().blockSize;
    this.hash = (d) => new n().update(d).digest();
    let c = o;
    if (c.length > u && (c = this.hash(c)), c.length < u) {
      const d = new Uint8Array(u - c.length);
      c = new Uint8Array([...c, ...d]);
    }
    this.oKeyPad = c.map((d) => d ^ 92), this.iKeyPad = c.map((d) => d ^ 54), this.messageHasher = new n(), this.blockSize = u, this.update(this.iKeyPad);
  }
  update(n) {
    return this.messageHasher.update(n), this;
  }
  digest() {
    const n = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...n]));
  }
}
hmac.Hmac = Hmac;
var keccak = {};
Object.defineProperty(keccak, "__esModule", { value: !0 });
keccak.keccak256 = keccak.Keccak256 = void 0;
const sha3_1 = sha3$3, utils_1$f = utils$n;
class Keccak256 {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = sha3_1.keccak_256.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$f.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
keccak.Keccak256 = Keccak256;
function keccak256(e) {
  return new Keccak256(e).digest();
}
keccak.keccak256 = keccak256;
var libsodium = {}, __importDefault$f = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(libsodium, "__esModule", { value: !0 });
libsodium.Xchacha20poly1305Ietf = libsodium.xchacha20NonceLength = libsodium.Ed25519 = libsodium.Ed25519Keypair = libsodium.Argon2id = libsodium.isArgon2idOptions = void 0;
const utils_1$e = build$7, libsodium_wrappers_1 = __importDefault$f(libsodiumWrappers$1);
function isArgon2idOptions(e) {
  return !(!(0, utils_1$e.isNonNullObject)(e) || typeof e.outputLength != "number" || typeof e.opsLimit != "number" || typeof e.memLimitKib != "number");
}
libsodium.isArgon2idOptions = isArgon2idOptions;
class Argon2id {
  static async execute(n, o, u) {
    return await libsodium_wrappers_1.default.ready, libsodium_wrappers_1.default.crypto_pwhash(
      u.outputLength,
      n,
      o,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      u.opsLimit,
      u.memLimitKib * 1024,
      libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
}
libsodium.Argon2id = Argon2id;
class Ed25519Keypair {
  constructor(n, o) {
    this.privkey = n, this.pubkey = o;
  }
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(n) {
    if (n.length !== 64)
      throw new Error(`Unexpected key length ${n.length}. Must be 64.`);
    return new Ed25519Keypair(n.slice(0, 32), n.slice(32, 64));
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
}
libsodium.Ed25519Keypair = Ed25519Keypair;
class Ed25519 {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(n) {
    await libsodium_wrappers_1.default.ready;
    const o = libsodium_wrappers_1.default.crypto_sign_seed_keypair(n);
    return Ed25519Keypair.fromLibsodiumPrivkey(o.privateKey);
  }
  static async createSignature(n, o) {
    return await libsodium_wrappers_1.default.ready, libsodium_wrappers_1.default.crypto_sign_detached(n, o.toLibsodiumPrivkey());
  }
  static async verifySignature(n, o, u) {
    return await libsodium_wrappers_1.default.ready, libsodium_wrappers_1.default.crypto_sign_verify_detached(n, o, u);
  }
}
libsodium.Ed25519 = Ed25519;
libsodium.xchacha20NonceLength = 24;
class Xchacha20poly1305Ietf {
  static async encrypt(n, o, u) {
    await libsodium_wrappers_1.default.ready;
    const c = null;
    return libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      n,
      c,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      u,
      o
    );
  }
  static async decrypt(n, o, u) {
    await libsodium_wrappers_1.default.ready;
    const c = null;
    return libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      n,
      c,
      u,
      o
    );
  }
}
libsodium.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf;
var random = {};
Object.defineProperty(random, "__esModule", { value: !0 });
random.Random = void 0;
class Random {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(n) {
    try {
      const o = typeof window == "object" ? window : self, u = typeof o.crypto < "u" ? o.crypto : o.msCrypto, c = new Uint8Array(n);
      return u.getRandomValues(c), c;
    } catch {
      try {
        const u = requireCryptoBrowserify();
        return new Uint8Array([...u.randomBytes(n)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
}
random.Random = Random;
var ripemd = {};
Object.defineProperty(ripemd, "__esModule", { value: !0 });
ripemd.ripemd160 = ripemd.Ripemd160 = void 0;
const ripemd160_1 = ripemd160$8, utils_1$d = utils$n;
class Ripemd160 {
  constructor(n) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1.ripemd160.create(), n && this.update(n);
  }
  update(n) {
    return this.impl.update((0, utils_1$d.toRealUint8Array)(n)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
ripemd.Ripemd160 = Ripemd160;
function ripemd160(e) {
  return new Ripemd160(e).digest();
}
ripemd.ripemd160 = ripemd160;
var secp256k1$1 = {}, secp256k1signature = {};
Object.defineProperty(secp256k1signature, "__esModule", { value: !0 });
secp256k1signature.ExtendedSecp256k1Signature = secp256k1signature.Secp256k1Signature = void 0;
function trimLeadingNullBytes(e) {
  let n = 0;
  for (const o of e)
    if (o === 0)
      n++;
    else
      break;
  return e.slice(n);
}
const derTagInteger = 2;
class Secp256k1Signature {
  constructor(n, o) {
    if (n.length > 32 || n.length === 0 || n[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (o.length > 32 || o.length === 0 || o[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: n,
      s: o
    };
  }
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(n) {
    if (n.length !== 64)
      throw new Error(`Got invalid data length: ${n.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new Secp256k1Signature(trimLeadingNullBytes(n.slice(0, 32)), trimLeadingNullBytes(n.slice(32, 64)));
  }
  static fromDer(n) {
    let o = 0;
    if (n[o++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const u = n[o++];
    if (n.length - o !== u)
      throw new Error("Data length mismatch detected");
    if (n[o++] !== derTagInteger)
      throw new Error("INTEGER tag expected");
    const d = n[o++];
    if (d >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const m = n.slice(o, o + d);
    if (o += d, n[o++] !== derTagInteger)
      throw new Error("INTEGER tag expected");
    const S = n[o++];
    if (S >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const $ = n.slice(o, o + S);
    return o += S, new Secp256k1Signature(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes(m),
      trimLeadingNullBytes($)
    );
  }
  r(n) {
    if (n === void 0)
      return this.data.r;
    {
      const o = n - this.data.r.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter r");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.r]);
    }
  }
  s(n) {
    if (n === void 0)
      return this.data.s;
    {
      const o = n - this.data.s.length;
      if (o < 0)
        throw new Error("Length too small to hold parameter s");
      const u = new Uint8Array(o);
      return new Uint8Array([...u, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const n = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, o = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, u = n.length, c = o.length, d = new Uint8Array([derTagInteger, u, ...n, derTagInteger, c, ...o]);
    return new Uint8Array([48, d.length, ...d]);
  }
}
secp256k1signature.Secp256k1Signature = Secp256k1Signature;
class ExtendedSecp256k1Signature extends Secp256k1Signature {
  constructor(n, o, u) {
    if (super(n, o), !Number.isInteger(u))
      throw new Error("The recovery parameter must be an integer.");
    if (u < 0 || u > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = u;
  }
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(n) {
    if (n.length !== 65)
      throw new Error(`Got invalid data length ${n.length}. Expected 32 + 32 + 1`);
    return new ExtendedSecp256k1Signature(trimLeadingNullBytes(n.slice(0, 32)), trimLeadingNullBytes(n.slice(32, 64)), n[64]);
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
}
secp256k1signature.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature;
var __importDefault$e = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(secp256k1$1, "__esModule", { value: !0 });
secp256k1$1.Secp256k1 = void 0;
const encoding_1$l = build$a, bn_js_1$2 = __importDefault$e(bnExports$1), elliptic_1 = __importDefault$e(requireElliptic()), secp256k1signature_1 = secp256k1signature, secp256k1 = new elliptic_1.default.ec("secp256k1"), secp256k1N = new bn_js_1$2.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class Secp256k1 {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(n) {
    if (n.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const o = secp256k1.keyFromPrivate(n);
    if (o.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$2.default(n).gte(secp256k1N))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$l.fromHex)(o.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(o.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(n, o) {
    if (n.length === 0)
      throw new Error("Message hash must not be empty");
    if (n.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const u = secp256k1.keyFromPrivate(o), { r: c, s: d, recoveryParam: m } = u.sign(n, { canonical: !0 });
    if (typeof m != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1.ExtendedSecp256k1Signature(Uint8Array.from(c.toArray()), Uint8Array.from(d.toArray()), m);
  }
  static async verifySignature(n, o, u) {
    if (o.length === 0)
      throw new Error("Message hash must not be empty");
    if (o.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const c = secp256k1.keyFromPublic(u);
    try {
      return c.verify(o, n.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(n, o) {
    const u = { r: (0, encoding_1$l.toHex)(n.r()), s: (0, encoding_1$l.toHex)(n.s()) }, c = secp256k1.recoverPubKey(o, u, n.recovery), d = secp256k1.keyFromPublic(c);
    return (0, encoding_1$l.fromHex)(d.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(n) {
    switch (n.length) {
      case 33:
        return n;
      case 65:
        return Uint8Array.from(secp256k1.keyFromPublic(n).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(n) {
    switch (n.length) {
      case 33:
        return Uint8Array.from(secp256k1.keyFromPublic(n).getPublic(!1, "array"));
      case 65:
        return n;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(n) {
    switch (n.length) {
      case 64:
        return n;
      case 65:
        return n.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
}
secp256k1$1.Secp256k1 = Secp256k1;
var slip10 = {}, build$6 = {}, decimal = {}, __importDefault$d = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(decimal, "__esModule", { value: !0 });
decimal.Decimal = void 0;
const bn_js_1$1 = __importDefault$d(bnExports$1), maxFractionalDigits = 100;
class Decimal {
  constructor(n, o) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$1.default(n),
      fractionalDigits: o
    };
  }
  static fromUserInput(n, o) {
    Decimal.verifyFractionalDigits(o);
    const u = n.match(/[^0-9.]/);
    if (u)
      throw new Error(`Invalid character at position ${u.index + 1}`);
    let c, d;
    if (n === "")
      c = "0", d = "";
    else if (n.search(/\./) === -1)
      c = n, d = "";
    else {
      const v = n.split(".");
      switch (v.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!v[1])
            throw new Error("Fractional part missing");
          c = v[0], d = v[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (d.length > o)
      throw new Error("Got more fractional digits than supported");
    const m = `${c}${d.padEnd(o, "0")}`;
    return new Decimal(m, o);
  }
  static fromAtomics(n, o) {
    return Decimal.verifyFractionalDigits(o), new Decimal(n, o);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(n) {
    return Decimal.verifyFractionalDigits(n), new Decimal("0", n);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(n) {
    return Decimal.verifyFractionalDigits(n), new Decimal("1" + "0".repeat(n), n);
  }
  static verifyFractionalDigits(n) {
    if (!Number.isInteger(n))
      throw new Error("Fractional digits is not an integer");
    if (n < 0)
      throw new Error("Fractional digits must not be negative");
    if (n > maxFractionalDigits)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits}`);
  }
  static compare(n, o) {
    if (n.fractionalDigits !== o.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return n.data.atomics.cmp(new bn_js_1$1.default(o.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  /** Creates a new instance with the same value */
  clone() {
    return new Decimal(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const n = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : Decimal.fromAtomics(o.mul(n).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const n = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), o = this.data.atomics.div(n);
    return this.data.atomics.mod(n).isZero() ? this.clone() : Decimal.fromAtomics(o.addn(1).mul(n).toString(), this.fractionalDigits);
  }
  toString() {
    const n = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), o = this.data.atomics.div(n), u = this.data.atomics.mod(n);
    if (u.isZero())
      return o.toString();
    {
      const d = u.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${o.toString()}.${d}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const n = Number(this.toString());
    if (Number.isNaN(n))
      throw new Error("Conversion to number failed");
    return n;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.add(new bn_js_1$1.default(n.atomics));
    return new Decimal(o.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(n) {
    if (this.fractionalDigits !== n.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const o = this.data.atomics.sub(new bn_js_1$1.default(n.atomics));
    if (o.ltn(0))
      throw new Error("Difference must not be negative");
    return new Decimal(o.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(n) {
    const o = this.data.atomics.mul(new bn_js_1$1.default(n.toString()));
    return new Decimal(o.toString(), this.fractionalDigits);
  }
  equals(n) {
    return Decimal.compare(this, n) === 0;
  }
  isLessThan(n) {
    return Decimal.compare(this, n) < 0;
  }
  isLessThanOrEqual(n) {
    return Decimal.compare(this, n) <= 0;
  }
  isGreaterThan(n) {
    return Decimal.compare(this, n) > 0;
  }
  isGreaterThanOrEqual(n) {
    return Decimal.compare(this, n) >= 0;
  }
}
decimal.Decimal = Decimal;
var integers = {}, __importDefault$c = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(integers, "__esModule", { value: !0 });
integers.Uint64 = integers.Uint53 = integers.Int53 = integers.Uint32 = void 0;
const bn_js_1 = __importDefault$c(bnExports$1), uint64MaxValue = new bn_js_1.default("18446744073709551615", 10, "be");
class Uint32 {
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < 0 || n > 4294967295)
      throw new Error("Input not in uint32 range: " + n.toString());
    this.data = n;
  }
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(n) {
    return Uint32.fromBytes(n);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? n : Array.from(n).reverse();
    return new Uint32(u[0] * 2 ** 24 + u[1] * 2 ** 16 + u[2] * 2 ** 8 + u[3]);
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uint32(Number.parseInt(n, 10));
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Uint32 = Uint32;
class Int53 {
  constructor(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    if (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + n.toString());
    this.data = n;
  }
  static fromString(n) {
    if (!n.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Int53(Number.parseInt(n, 10));
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Int53 = Int53;
class Uint53 {
  constructor(n) {
    const o = new Int53(n);
    if (o.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = o;
  }
  static fromString(n) {
    const o = Int53.fromString(n);
    return new Uint53(o.toNumber());
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Uint53 = Uint53;
class Uint64 {
  constructor(n) {
    if (n.isNeg())
      throw new Error("Input is negative");
    if (n.gt(uint64MaxValue))
      throw new Error("Input exceeds uint64 range");
    this.data = n;
  }
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(n) {
    return Uint64.fromBytes(n);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(n, o = "be") {
    if (n.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let c = 0; c < n.length; ++c)
      if (!Number.isInteger(n[c]) || n[c] > 255 || n[c] < 0)
        throw new Error("Invalid value in byte. Found: " + n[c]);
    const u = o === "be" ? Array.from(n) : Array.from(n).reverse();
    return new Uint64(new bn_js_1.default(u));
  }
  static fromString(n) {
    if (!n.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uint64(new bn_js_1.default(n, 10, "be"));
  }
  static fromNumber(n) {
    if (Number.isNaN(n))
      throw new Error("Input is not a number");
    if (!Number.isInteger(n))
      throw new Error("Input is not an integer");
    let o;
    try {
      o = new bn_js_1.default(n);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new Uint64(o);
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
}
integers.Uint64 = Uint64;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Uint64 = e.Uint53 = e.Uint32 = e.Int53 = e.Decimal = void 0;
  var n = decimal;
  Object.defineProperty(e, "Decimal", { enumerable: !0, get: function() {
    return n.Decimal;
  } });
  var o = integers;
  Object.defineProperty(e, "Int53", { enumerable: !0, get: function() {
    return o.Int53;
  } }), Object.defineProperty(e, "Uint32", { enumerable: !0, get: function() {
    return o.Uint32;
  } }), Object.defineProperty(e, "Uint53", { enumerable: !0, get: function() {
    return o.Uint53;
  } }), Object.defineProperty(e, "Uint64", { enumerable: !0, get: function() {
    return o.Uint64;
  } });
})(build$6);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.pathToString = e.Slip10 = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = void 0;
  const o = build$a, u = build$6, c = n(bnExports$1), d = n(requireElliptic()), m = hmac, v = sha;
  var S;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(S = e.Slip10Curve || (e.Slip10Curve = {}));
  function $(M) {
    switch (M) {
      case S.Ed25519:
        return S.Ed25519;
      case S.Secp256k1:
        return S.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  e.slip10CurveFromString = $;
  class E extends u.Uint32 {
    static hardened(G) {
      return new E(G + 2 ** 31);
    }
    static normal(G) {
      return new E(G);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  e.Slip10RawIndex = E;
  const O = new d.default.ec("secp256k1");
  class T {
    static derivePath(G, k, F) {
      let X = this.master(G, k);
      for (const ee of F)
        X = this.child(G, X.privkey, X.chainCode, ee);
      return X;
    }
    static master(G, k) {
      const F = new m.Hmac(v.Sha512, (0, o.toAscii)(G)).update(k).digest(), X = F.slice(0, 32), ee = F.slice(32, 64);
      return G !== S.Ed25519 && (this.isZero(X) || this.isGteN(G, X)) ? this.master(G, F) : {
        chainCode: ee,
        privkey: X
      };
    }
    static child(G, k, F, X) {
      let ee;
      if (X.isHardened()) {
        const ue = new Uint8Array([0, ...k, ...X.toBytesBigEndian()]);
        ee = new m.Hmac(v.Sha512, F).update(ue).digest();
      } else {
        if (G === S.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const ue = new Uint8Array([
            ...T.serializedPoint(G, new c.default(k)),
            ...X.toBytesBigEndian()
          ]);
          ee = new m.Hmac(v.Sha512, F).update(ue).digest();
        }
      }
      return this.childImpl(G, k, F, X, ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(G, k) {
      switch (G) {
        case S.Secp256k1:
          return (0, o.fromHex)(O.g.mul(k).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(G, k, F, X, ee) {
      const ue = ee.slice(0, 32), Q = ee.slice(32, 64), Y = Q;
      if (G === S.Ed25519)
        return {
          chainCode: Y,
          privkey: ue
        };
      const pe = this.n(G), oe = new c.default(ue).add(new c.default(k)).mod(pe), ne = Uint8Array.from(oe.toArray("be", 32));
      if (this.isGteN(G, ue) || this.isZero(ne)) {
        const H = new m.Hmac(v.Sha512, F).update(new Uint8Array([1, ...Q, ...X.toBytesBigEndian()])).digest();
        return this.childImpl(G, k, F, X, H);
      }
      return {
        chainCode: Y,
        privkey: ne
      };
    }
    static isZero(G) {
      return G.every((k) => k === 0);
    }
    static isGteN(G, k) {
      return new c.default(k).gte(this.n(G));
    }
    static n(G) {
      switch (G) {
        case S.Secp256k1:
          return new c.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  e.Slip10 = T;
  function y(M) {
    return M.reduce((G, k) => {
      const F = k.isHardened() ? `${k.toNumber() - 2147483648}'` : k.toString();
      return G + "/" + F;
    }, "m");
  }
  e.pathToString = y;
  function V(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let G = M.slice(1);
    const k = new Array();
    for (; G; ) {
      const F = G.match(/^\/([0-9]+)('?)/);
      if (!F)
        throw new Error("Syntax error while reading path component");
      const [X, ee, ue] = F, Q = u.Uint53.fromString(ee).toNumber();
      if (Q >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      ue ? k.push(E.hardened(Q)) : k.push(E.normal(Q)), G = G.slice(X.length);
    }
    return k;
  }
  e.stringToPath = V;
})(slip10);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringToPath = e.Slip10RawIndex = e.slip10CurveFromString = e.Slip10Curve = e.Slip10 = e.pathToString = e.sha512 = e.Sha512 = e.sha256 = e.Sha256 = e.Secp256k1Signature = e.ExtendedSecp256k1Signature = e.Secp256k1 = e.ripemd160 = e.Ripemd160 = e.Random = e.Xchacha20poly1305Ietf = e.xchacha20NonceLength = e.isArgon2idOptions = e.Ed25519Keypair = e.Ed25519 = e.Argon2id = e.keccak256 = e.Keccak256 = e.Hmac = e.EnglishMnemonic = e.Bip39 = void 0;
  var n = bip39;
  Object.defineProperty(e, "Bip39", { enumerable: !0, get: function() {
    return n.Bip39;
  } }), Object.defineProperty(e, "EnglishMnemonic", { enumerable: !0, get: function() {
    return n.EnglishMnemonic;
  } });
  var o = hmac;
  Object.defineProperty(e, "Hmac", { enumerable: !0, get: function() {
    return o.Hmac;
  } });
  var u = keccak;
  Object.defineProperty(e, "Keccak256", { enumerable: !0, get: function() {
    return u.Keccak256;
  } }), Object.defineProperty(e, "keccak256", { enumerable: !0, get: function() {
    return u.keccak256;
  } });
  var c = libsodium;
  Object.defineProperty(e, "Argon2id", { enumerable: !0, get: function() {
    return c.Argon2id;
  } }), Object.defineProperty(e, "Ed25519", { enumerable: !0, get: function() {
    return c.Ed25519;
  } }), Object.defineProperty(e, "Ed25519Keypair", { enumerable: !0, get: function() {
    return c.Ed25519Keypair;
  } }), Object.defineProperty(e, "isArgon2idOptions", { enumerable: !0, get: function() {
    return c.isArgon2idOptions;
  } }), Object.defineProperty(e, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return c.xchacha20NonceLength;
  } }), Object.defineProperty(e, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return c.Xchacha20poly1305Ietf;
  } });
  var d = random;
  Object.defineProperty(e, "Random", { enumerable: !0, get: function() {
    return d.Random;
  } });
  var m = ripemd;
  Object.defineProperty(e, "Ripemd160", { enumerable: !0, get: function() {
    return m.Ripemd160;
  } }), Object.defineProperty(e, "ripemd160", { enumerable: !0, get: function() {
    return m.ripemd160;
  } });
  var v = secp256k1$1;
  Object.defineProperty(e, "Secp256k1", { enumerable: !0, get: function() {
    return v.Secp256k1;
  } });
  var S = secp256k1signature;
  Object.defineProperty(e, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return S.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(e, "Secp256k1Signature", { enumerable: !0, get: function() {
    return S.Secp256k1Signature;
  } });
  var $ = sha;
  Object.defineProperty(e, "Sha256", { enumerable: !0, get: function() {
    return $.Sha256;
  } }), Object.defineProperty(e, "sha256", { enumerable: !0, get: function() {
    return $.sha256;
  } }), Object.defineProperty(e, "Sha512", { enumerable: !0, get: function() {
    return $.Sha512;
  } }), Object.defineProperty(e, "sha512", { enumerable: !0, get: function() {
    return $.sha512;
  } });
  var E = slip10;
  Object.defineProperty(e, "pathToString", { enumerable: !0, get: function() {
    return E.pathToString;
  } }), Object.defineProperty(e, "Slip10", { enumerable: !0, get: function() {
    return E.Slip10;
  } }), Object.defineProperty(e, "Slip10Curve", { enumerable: !0, get: function() {
    return E.Slip10Curve;
  } }), Object.defineProperty(e, "slip10CurveFromString", { enumerable: !0, get: function() {
    return E.slip10CurveFromString;
  } }), Object.defineProperty(e, "Slip10RawIndex", { enumerable: !0, get: function() {
    return E.Slip10RawIndex;
  } }), Object.defineProperty(e, "stringToPath", { enumerable: !0, get: function() {
    return E.stringToPath;
  } });
})(build$8);
var encoding = {}, pubkeys = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isMultisigThresholdPubkey = e.isSinglePubkey = e.pubkeyType = e.isSecp256k1Pubkey = e.isEd25519Pubkey = void 0;
  function n(d) {
    return d.type === "tendermint/PubKeyEd25519";
  }
  e.isEd25519Pubkey = n;
  function o(d) {
    return d.type === "tendermint/PubKeySecp256k1";
  }
  e.isSecp256k1Pubkey = o, e.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */
    secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */
    ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */
    sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
  };
  function u(d) {
    return [e.pubkeyType.ed25519, e.pubkeyType.secp256k1, e.pubkeyType.sr25519].includes(d.type);
  }
  e.isSinglePubkey = u;
  function c(d) {
    return d.type === "tendermint/PubKeyMultisigThreshold";
  }
  e.isMultisigThresholdPubkey = c;
})(pubkeys);
Object.defineProperty(encoding, "__esModule", { value: !0 });
encoding.encodeBech32Pubkey = encoding.encodeAminoPubkey = encoding.decodeBech32Pubkey = encoding.decodeAminoPubkey = encoding.encodeEd25519Pubkey = encoding.encodeSecp256k1Pubkey = void 0;
const encoding_1$k = build$a, math_1$d = build$6, utils_1$c = build$7, pubkeys_1$2 = pubkeys;
function encodeSecp256k1Pubkey(e) {
  if (e.length !== 33 || e[0] !== 2 && e[0] !== 3)
    throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
  return {
    type: pubkeys_1$2.pubkeyType.secp256k1,
    value: (0, encoding_1$k.toBase64)(e)
  };
}
encoding.encodeSecp256k1Pubkey = encodeSecp256k1Pubkey;
function encodeEd25519Pubkey(e) {
  if (e.length !== 32)
    throw new Error("Ed25519 public key must be 32 bytes long");
  return {
    type: pubkeys_1$2.pubkeyType.ed25519,
    value: (0, encoding_1$k.toBase64)(e)
  };
}
encoding.encodeEd25519Pubkey = encodeEd25519Pubkey;
const pubkeyAminoPrefixSecp256k1 = (0, encoding_1$k.fromHex)(
  "eb5ae98721"
  /* fixed length */
), pubkeyAminoPrefixEd25519 = (0, encoding_1$k.fromHex)(
  "1624de6420"
  /* fixed length */
), pubkeyAminoPrefixSr25519 = (0, encoding_1$k.fromHex)(
  "0dfb100520"
  /* fixed length */
), pubkeyAminoPrefixMultisigThreshold = (0, encoding_1$k.fromHex)(
  "22c1f7e2"
  /* variable length not included */
);
function decodeAminoPubkey(e) {
  if ((0, utils_1$c.arrayContentStartsWith)(e, pubkeyAminoPrefixSecp256k1)) {
    const n = e.slice(pubkeyAminoPrefixSecp256k1.length);
    if (n.length !== 33)
      throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.secp256k1,
      value: (0, encoding_1$k.toBase64)(n)
    };
  } else if ((0, utils_1$c.arrayContentStartsWith)(e, pubkeyAminoPrefixEd25519)) {
    const n = e.slice(pubkeyAminoPrefixEd25519.length);
    if (n.length !== 32)
      throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.ed25519,
      value: (0, encoding_1$k.toBase64)(n)
    };
  } else if ((0, utils_1$c.arrayContentStartsWith)(e, pubkeyAminoPrefixSr25519)) {
    const n = e.slice(pubkeyAminoPrefixSr25519.length);
    if (n.length !== 32)
      throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.sr25519,
      value: (0, encoding_1$k.toBase64)(n)
    };
  } else {
    if ((0, utils_1$c.arrayContentStartsWith)(e, pubkeyAminoPrefixMultisigThreshold))
      return decodeMultisigPubkey(e);
    throw new Error("Unsupported public key type. Amino data starts with: " + (0, encoding_1$k.toHex)(e.slice(0, 5)));
  }
}
encoding.decodeAminoPubkey = decodeAminoPubkey;
function decodeBech32Pubkey(e) {
  const { data: n } = (0, encoding_1$k.fromBech32)(e);
  return decodeAminoPubkey(n);
}
encoding.decodeBech32Pubkey = decodeBech32Pubkey;
function decodeUvarint(e) {
  if (e.length < 1)
    throw new Error("Can't decode varint. EOF");
  if (e[0] > 127)
    throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
  return [e[0], 1];
}
function decodeMultisigPubkey(e) {
  const n = Array.from(e), o = n.splice(0, pubkeyAminoPrefixMultisigThreshold.length);
  if (!(0, utils_1$c.arrayContentStartsWith)(o, pubkeyAminoPrefixMultisigThreshold))
    throw new Error("Invalid multisig prefix.");
  if (n.shift() != 8)
    throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
  const [u, c] = decodeUvarint(n);
  n.splice(0, c);
  const d = [];
  for (; n.length > 0; ) {
    if (n.shift() != 18)
      throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
    const [m, v] = decodeUvarint(n);
    if (n.splice(0, v), n.length < m)
      throw new Error("Invalid multisig data length.");
    const S = n.splice(0, m), $ = decodeAminoPubkey(Uint8Array.from(S));
    d.push($);
  }
  return {
    type: pubkeys_1$2.pubkeyType.multisigThreshold,
    value: {
      threshold: u.toString(),
      pubkeys: d
    }
  };
}
function encodeUvarint$1(e) {
  const n = math_1$d.Uint53.fromString(e.toString()).toNumber();
  if (n > 127)
    throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
  return [n];
}
function encodeAminoPubkey(e) {
  if ((0, pubkeys_1$2.isMultisigThresholdPubkey)(e)) {
    const n = Array.from(pubkeyAminoPrefixMultisigThreshold);
    n.push(8), n.push(...encodeUvarint$1(e.value.threshold));
    for (const o of e.value.pubkeys.map((u) => encodeAminoPubkey(u)))
      n.push(18), n.push(...encodeUvarint$1(o.length)), n.push(...o);
    return new Uint8Array(n);
  } else {
    if ((0, pubkeys_1$2.isEd25519Pubkey)(e))
      return new Uint8Array([...pubkeyAminoPrefixEd25519, ...(0, encoding_1$k.fromBase64)(e.value)]);
    if ((0, pubkeys_1$2.isSecp256k1Pubkey)(e))
      return new Uint8Array([...pubkeyAminoPrefixSecp256k1, ...(0, encoding_1$k.fromBase64)(e.value)]);
    throw new Error("Unsupported pubkey type");
  }
}
encoding.encodeAminoPubkey = encodeAminoPubkey;
function encodeBech32Pubkey(e, n) {
  return (0, encoding_1$k.toBech32)(n, encodeAminoPubkey(e));
}
encoding.encodeBech32Pubkey = encodeBech32Pubkey;
Object.defineProperty(addresses$1, "__esModule", { value: !0 });
addresses$1.pubkeyToAddress = addresses$1.pubkeyToRawAddress = addresses$1.rawSecp256k1PubkeyToRawAddress = addresses$1.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$8 = build$8, encoding_1$j = build$a, encoding_2$1 = encoding, pubkeys_1$1 = pubkeys;
function rawEd25519PubkeyToRawAddress$1(e) {
  if (e.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${e.length}`);
  return (0, crypto_1$8.sha256)(e).slice(0, 20);
}
addresses$1.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress$1;
function rawSecp256k1PubkeyToRawAddress$1(e) {
  if (e.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${e.length}`);
  return (0, crypto_1$8.ripemd160)((0, crypto_1$8.sha256)(e));
}
addresses$1.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress$1;
function pubkeyToRawAddress$1(e) {
  if ((0, pubkeys_1$1.isSecp256k1Pubkey)(e)) {
    const n = (0, encoding_1$j.fromBase64)(e.value);
    return rawSecp256k1PubkeyToRawAddress$1(n);
  } else if ((0, pubkeys_1$1.isEd25519Pubkey)(e)) {
    const n = (0, encoding_1$j.fromBase64)(e.value);
    return rawEd25519PubkeyToRawAddress$1(n);
  } else if ((0, pubkeys_1$1.isMultisigThresholdPubkey)(e)) {
    const n = (0, encoding_2$1.encodeAminoPubkey)(e);
    return (0, crypto_1$8.sha256)(n).slice(0, 20);
  } else
    throw new Error("Unsupported public key type");
}
addresses$1.pubkeyToRawAddress = pubkeyToRawAddress$1;
function pubkeyToAddress$1(e, n) {
  return (0, encoding_1$j.toBech32)(n, pubkeyToRawAddress$1(e));
}
addresses$1.pubkeyToAddress = pubkeyToAddress$1;
var coins$2 = {};
Object.defineProperty(coins$2, "__esModule", { value: !0 });
coins$2.addCoins = coins$2.parseCoins = coins$2.coins = coins$2.coin = void 0;
const math_1$c = build$6;
function coin(e, n) {
  let o;
  if (typeof e == "number")
    try {
      o = new math_1$c.Uint53(e).toString();
    } catch {
      throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
  else {
    if (!e.match(/^[0-9]+$/))
      throw new Error("Invalid unsigned integer string format");
    o = e.replace(/^0*/, "") || "0";
  }
  return {
    amount: o,
    denom: n
  };
}
coins$2.coin = coin;
function coins$1(e, n) {
  return [coin(e, n)];
}
coins$2.coins = coins$1;
function parseCoins$1(e) {
  return e.replace(/\s/g, "").split(",").filter(Boolean).map((n) => {
    const o = n.match(/^([0-9]+)([a-zA-Z]+)/);
    if (!o)
      throw new Error("Got an invalid coin string");
    return {
      amount: o[1].replace(/^0+/, "") || "0",
      denom: o[2]
    };
  });
}
coins$2.parseCoins = parseCoins$1;
function addCoins(e, n) {
  if (e.denom !== n.denom)
    throw new Error("Trying to add two coins with different denoms");
  return {
    amount: math_1$c.Decimal.fromAtomics(e.amount, 0).plus(math_1$c.Decimal.fromAtomics(n.amount, 0)).atomics,
    denom: e.denom
  };
}
coins$2.addCoins = addCoins;
var multisig = {};
Object.defineProperty(multisig, "__esModule", { value: !0 });
multisig.createMultisigThresholdPubkey = multisig.compareArrays = void 0;
const encoding_1$i = build$a, math_1$b = build$6, addresses_1$2 = addresses$1;
function compareArrays(e, n) {
  const o = (0, encoding_1$i.toHex)(e), u = (0, encoding_1$i.toHex)(n);
  return o === u ? 0 : o < u ? -1 : 1;
}
multisig.compareArrays = compareArrays;
function createMultisigThresholdPubkey(e, n, o = !1) {
  const u = new math_1$b.Uint53(n);
  if (u.toNumber() > e.length)
    throw new Error(`Threshold k = ${u.toNumber()} exceeds number of keys n = ${e.length}`);
  const c = o ? e : Array.from(e).sort((d, m) => {
    const v = (0, addresses_1$2.pubkeyToRawAddress)(d), S = (0, addresses_1$2.pubkeyToRawAddress)(m);
    return compareArrays(v, S);
  });
  return {
    type: "tendermint/PubKeyMultisigThreshold",
    value: {
      threshold: u.toString(),
      pubkeys: c
    }
  };
}
multisig.createMultisigThresholdPubkey = createMultisigThresholdPubkey;
var paths$1 = {};
Object.defineProperty(paths$1, "__esModule", { value: !0 });
paths$1.makeCosmoshubPath = void 0;
const crypto_1$7 = build$8;
function makeCosmoshubPath$1(e) {
  return [
    crypto_1$7.Slip10RawIndex.hardened(44),
    crypto_1$7.Slip10RawIndex.hardened(118),
    crypto_1$7.Slip10RawIndex.hardened(0),
    crypto_1$7.Slip10RawIndex.normal(0),
    crypto_1$7.Slip10RawIndex.normal(e)
  ];
}
paths$1.makeCosmoshubPath = makeCosmoshubPath$1;
var secp256k1hdwallet = {}, signature = {};
Object.defineProperty(signature, "__esModule", { value: !0 });
signature.decodeSignature = signature.encodeSecp256k1Signature = void 0;
const encoding_1$h = build$a, encoding_2 = encoding, pubkeys_1 = pubkeys;
function encodeSecp256k1Signature(e, n) {
  if (n.length !== 64)
    throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
  return {
    pub_key: (0, encoding_2.encodeSecp256k1Pubkey)(e),
    signature: (0, encoding_1$h.toBase64)(n)
  };
}
signature.encodeSecp256k1Signature = encodeSecp256k1Signature;
function decodeSignature(e) {
  switch (e.pub_key.type) {
    case pubkeys_1.pubkeyType.secp256k1:
      return {
        pubkey: (0, encoding_1$h.fromBase64)(e.pub_key.value),
        signature: (0, encoding_1$h.fromBase64)(e.signature)
      };
    default:
      throw new Error("Unsupported pubkey type");
  }
}
signature.decodeSignature = decodeSignature;
var signdoc = {};
Object.defineProperty(signdoc, "__esModule", { value: !0 });
signdoc.serializeSignDoc = signdoc.makeSignDoc = signdoc.sortedJsonStringify = void 0;
const encoding_1$g = build$a, math_1$a = build$6;
function sortedObject(e) {
  if (typeof e != "object" || e === null)
    return e;
  if (Array.isArray(e))
    return e.map(sortedObject);
  const n = Object.keys(e).sort(), o = {};
  return n.forEach((u) => {
    o[u] = sortedObject(e[u]);
  }), o;
}
function sortedJsonStringify(e) {
  return JSON.stringify(sortedObject(e));
}
signdoc.sortedJsonStringify = sortedJsonStringify;
function makeSignDoc$1(e, n, o, u, c, d) {
  return {
    chain_id: o,
    account_number: math_1$a.Uint53.fromString(c.toString()).toString(),
    sequence: math_1$a.Uint53.fromString(d.toString()).toString(),
    fee: n,
    msgs: e,
    memo: u || ""
  };
}
signdoc.makeSignDoc = makeSignDoc$1;
function serializeSignDoc(e) {
  return (0, encoding_1$g.toUtf8)(sortedJsonStringify(e));
}
signdoc.serializeSignDoc = serializeSignDoc;
var wallet$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decrypt = e.encrypt = e.supportedAlgorithms = e.executeKdf = e.cosmjsSalt = void 0;
  const n = build$8, o = build$a;
  e.cosmjsSalt = (0, o.toAscii)("The CosmJS salt.");
  async function u(m, v) {
    switch (v.algorithm) {
      case "argon2id": {
        const S = v.params;
        if (!(0, n.isArgon2idOptions)(S))
          throw new Error("Invalid format of argon2id params");
        return n.Argon2id.execute(m, e.cosmjsSalt, S);
      }
      default:
        throw new Error("Unsupported KDF algorithm");
    }
  }
  e.executeKdf = u, e.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
  };
  async function c(m, v, S) {
    switch (S.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const $ = n.Random.getBytes(n.xchacha20NonceLength);
        return new Uint8Array([
          ...$,
          ...await n.Xchacha20poly1305Ietf.encrypt(m, v, $)
        ]);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${S.algorithm}'`);
    }
  }
  e.encrypt = c;
  async function d(m, v, S) {
    switch (S.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const $ = m.slice(0, n.xchacha20NonceLength);
        return n.Xchacha20poly1305Ietf.decrypt(m.slice(n.xchacha20NonceLength), v, $);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${S.algorithm}'`);
    }
  }
  e.decrypt = d;
})(wallet$1);
Object.defineProperty(secp256k1hdwallet, "__esModule", { value: !0 });
secp256k1hdwallet.Secp256k1HdWallet = secp256k1hdwallet.extractKdfConfiguration = void 0;
const crypto_1$6 = build$8, encoding_1$f = build$a, utils_1$b = build$7, addresses_1$1 = addresses$1, paths_1 = paths$1, signature_1$1 = signature, signdoc_1$1 = signdoc, wallet_1$1 = wallet$1, serializationTypeV1$1 = "secp256k1wallet-v1", basicPasswordHashingOptions$1 = {
  algorithm: "argon2id",
  params: {
    outputLength: 32,
    opsLimit: 24,
    memLimitKib: 12 * 1024
  }
};
function isDerivationJson$1(e) {
  return !(!(0, utils_1$b.isNonNullObject)(e) || typeof e.hdPath != "string" || typeof e.prefix != "string");
}
function extractKdfConfigurationV1$1(e) {
  return e.kdf;
}
function extractKdfConfiguration$1(e) {
  const n = JSON.parse(e);
  if (!(0, utils_1$b.isNonNullObject)(n))
    throw new Error("Root document is not an object.");
  switch (n.type) {
    case serializationTypeV1$1:
      return extractKdfConfigurationV1$1(n);
    default:
      throw new Error("Unsupported serialization type");
  }
}
secp256k1hdwallet.extractKdfConfiguration = extractKdfConfiguration$1;
const defaultOptions$1 = {
  bip39Password: "",
  hdPaths: [(0, paths_1.makeCosmoshubPath)(0)],
  prefix: "cosmos"
};
class Secp256k1HdWallet {
  constructor(n, o) {
    var u, c;
    const d = (u = o.hdPaths) !== null && u !== void 0 ? u : defaultOptions$1.hdPaths, m = (c = o.prefix) !== null && c !== void 0 ? c : defaultOptions$1.prefix;
    this.secret = n, this.seed = o.seed, this.accounts = d.map((v) => ({
      hdPath: v,
      prefix: m
    }));
  }
  /**
   * Restores a wallet from the given BIP39 mnemonic.
   *
   * @param mnemonic Any valid English mnemonic.
   * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async fromMnemonic(n, o = {}) {
    const u = new crypto_1$6.EnglishMnemonic(n), c = await crypto_1$6.Bip39.mnemonicToSeed(u, o.bip39Password);
    return new Secp256k1HdWallet(u, {
      ...o,
      seed: c
    });
  }
  /**
   * Generates a new wallet with a BIP39 mnemonic of the given length.
   *
   * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
   * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async generate(n = 12, o = {}) {
    const u = 4 * Math.floor(11 * n / 33), c = crypto_1$6.Random.getBytes(u), d = crypto_1$6.Bip39.encode(c);
    return Secp256k1HdWallet.fromMnemonic(d.toString(), o);
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  static async deserialize(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$b.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    switch (u.type) {
      case serializationTypeV1$1:
        return Secp256k1HdWallet.deserializeTypeV1(n, o);
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
   * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
   * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
   */
  static async deserializeWithEncryptionKey(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$b.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    const c = u;
    switch (c.type) {
      case serializationTypeV1$1: {
        const d = await (0, wallet_1$1.decrypt)((0, encoding_1$f.fromBase64)(c.data), o, c.encryption), m = JSON.parse((0, encoding_1$f.fromUtf8)(d)), { mnemonic: v, accounts: S } = m;
        if ((0, utils_1$b.assert)(typeof v == "string"), !Array.isArray(S))
          throw new Error("Property 'accounts' is not an array");
        if (!S.every((O) => isDerivationJson$1(O)))
          throw new Error("Account is not in the correct format.");
        const $ = S[0].prefix;
        if (!S.every(({ prefix: O }) => O === $))
          throw new Error("Accounts do not all have the same prefix");
        const E = S.map(({ hdPath: O }) => (0, crypto_1$6.stringToPath)(O));
        return Secp256k1HdWallet.fromMnemonic(v, {
          hdPaths: E,
          prefix: $
        });
      }
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  static async deserializeTypeV1(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$b.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    const c = await (0, wallet_1$1.executeKdf)(o, u.kdf);
    return Secp256k1HdWallet.deserializeWithEncryptionKey(n, c);
  }
  get mnemonic() {
    return this.secret.toString();
  }
  async getAccounts() {
    return (await this.getAccountsWithPrivkeys()).map(({ algo: o, pubkey: u, address: c }) => ({
      algo: o,
      pubkey: u,
      address: c
    }));
  }
  async signAmino(n, o) {
    const c = (await this.getAccountsWithPrivkeys()).find(({ address: E }) => E === n);
    if (c === void 0)
      throw new Error(`Address ${n} not found in wallet`);
    const { privkey: d, pubkey: m } = c, v = (0, crypto_1$6.sha256)((0, signdoc_1$1.serializeSignDoc)(o)), S = await crypto_1$6.Secp256k1.createSignature(v, d), $ = new Uint8Array([...S.r(32), ...S.s(32)]);
    return {
      signed: o,
      signature: (0, signature_1$1.encodeSecp256k1Signature)(m, $)
    };
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  async serialize(n) {
    const o = basicPasswordHashingOptions$1, u = await (0, wallet_1$1.executeKdf)(n, o);
    return this.serializeWithEncryptionKey(u, o);
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
   * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF options. If this
   * is not the case, the wallet cannot be restored with the original password.
   */
  async serializeWithEncryptionKey(n, o) {
    const u = {
      mnemonic: this.mnemonic,
      accounts: this.accounts.map(({ hdPath: S, prefix: $ }) => ({
        hdPath: (0, crypto_1$6.pathToString)(S),
        prefix: $
      }))
    }, c = (0, encoding_1$f.toUtf8)(JSON.stringify(u)), d = {
      algorithm: wallet_1$1.supportedAlgorithms.xchacha20poly1305Ietf
    }, m = await (0, wallet_1$1.encrypt)(c, n, d), v = {
      type: serializationTypeV1$1,
      kdf: o,
      encryption: d,
      data: (0, encoding_1$f.toBase64)(m)
    };
    return JSON.stringify(v);
  }
  async getKeyPair(n) {
    const { privkey: o } = crypto_1$6.Slip10.derivePath(crypto_1$6.Slip10Curve.Secp256k1, this.seed, n), { pubkey: u } = await crypto_1$6.Secp256k1.makeKeypair(o);
    return {
      privkey: o,
      pubkey: crypto_1$6.Secp256k1.compressPubkey(u)
    };
  }
  async getAccountsWithPrivkeys() {
    return Promise.all(this.accounts.map(async ({ hdPath: n, prefix: o }) => {
      const { privkey: u, pubkey: c } = await this.getKeyPair(n), d = (0, encoding_1$f.toBech32)(o, (0, addresses_1$1.rawSecp256k1PubkeyToRawAddress)(c));
      return {
        algo: "secp256k1",
        privkey: u,
        pubkey: c,
        address: d
      };
    }));
  }
}
secp256k1hdwallet.Secp256k1HdWallet = Secp256k1HdWallet;
var secp256k1wallet = {};
Object.defineProperty(secp256k1wallet, "__esModule", { value: !0 });
secp256k1wallet.Secp256k1Wallet = void 0;
const crypto_1$5 = build$8, encoding_1$e = build$a, addresses_1 = addresses$1, signature_1 = signature, signdoc_1 = signdoc;
class Secp256k1Wallet {
  constructor(n, o, u) {
    this.privkey = n, this.pubkey = o, this.prefix = u;
  }
  /**
   * Creates a Secp256k1Wallet from the given private key
   *
   * @param privkey The private key.
   * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
   */
  static async fromKey(n, o = "cosmos") {
    const u = (await crypto_1$5.Secp256k1.makeKeypair(n)).pubkey;
    return new Secp256k1Wallet(n, crypto_1$5.Secp256k1.compressPubkey(u), o);
  }
  get address() {
    return (0, encoding_1$e.toBech32)(this.prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
  }
  async getAccounts() {
    return [
      {
        algo: "secp256k1",
        address: this.address,
        pubkey: this.pubkey
      }
    ];
  }
  async signAmino(n, o) {
    if (n !== this.address)
      throw new Error(`Address ${n} not found in wallet`);
    const u = new crypto_1$5.Sha256((0, signdoc_1.serializeSignDoc)(o)).digest(), c = await crypto_1$5.Secp256k1.createSignature(u, this.privkey), d = new Uint8Array([...c.r(32), ...c.s(32)]);
    return {
      signed: o,
      signature: (0, signature_1.encodeSecp256k1Signature)(this.pubkey, d)
    };
  }
}
secp256k1wallet.Secp256k1Wallet = Secp256k1Wallet;
var stdtx = {};
Object.defineProperty(stdtx, "__esModule", { value: !0 });
stdtx.makeStdTx = stdtx.isStdTx = void 0;
function isStdTx(e) {
  const { memo: n, msg: o, fee: u, signatures: c } = e;
  return typeof n == "string" && Array.isArray(o) && typeof u == "object" && Array.isArray(c);
}
stdtx.isStdTx = isStdTx;
function makeStdTx(e, n) {
  return {
    msg: e.msgs,
    fee: e.fee,
    memo: e.memo,
    signatures: Array.isArray(n) ? n : [n]
  };
}
stdtx.makeStdTx = makeStdTx;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.executeKdf = e.makeStdTx = e.isStdTx = e.serializeSignDoc = e.makeSignDoc = e.encodeSecp256k1Signature = e.decodeSignature = e.Secp256k1Wallet = e.Secp256k1HdWallet = e.extractKdfConfiguration = e.pubkeyType = e.isSinglePubkey = e.isSecp256k1Pubkey = e.isMultisigThresholdPubkey = e.isEd25519Pubkey = e.makeCosmoshubPath = e.createMultisigThresholdPubkey = e.encodeSecp256k1Pubkey = e.encodeEd25519Pubkey = e.encodeBech32Pubkey = e.encodeAminoPubkey = e.decodeBech32Pubkey = e.decodeAminoPubkey = e.parseCoins = e.coins = e.coin = e.addCoins = e.rawSecp256k1PubkeyToRawAddress = e.rawEd25519PubkeyToRawAddress = e.pubkeyToRawAddress = e.pubkeyToAddress = void 0;
  var n = addresses$1;
  Object.defineProperty(e, "pubkeyToAddress", { enumerable: !0, get: function() {
    return n.pubkeyToAddress;
  } }), Object.defineProperty(e, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return n.pubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return n.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return n.rawSecp256k1PubkeyToRawAddress;
  } });
  var o = coins$2;
  Object.defineProperty(e, "addCoins", { enumerable: !0, get: function() {
    return o.addCoins;
  } }), Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return o.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return o.coins;
  } }), Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return o.parseCoins;
  } });
  var u = encoding;
  Object.defineProperty(e, "decodeAminoPubkey", { enumerable: !0, get: function() {
    return u.decodeAminoPubkey;
  } }), Object.defineProperty(e, "decodeBech32Pubkey", { enumerable: !0, get: function() {
    return u.decodeBech32Pubkey;
  } }), Object.defineProperty(e, "encodeAminoPubkey", { enumerable: !0, get: function() {
    return u.encodeAminoPubkey;
  } }), Object.defineProperty(e, "encodeBech32Pubkey", { enumerable: !0, get: function() {
    return u.encodeBech32Pubkey;
  } }), Object.defineProperty(e, "encodeEd25519Pubkey", { enumerable: !0, get: function() {
    return u.encodeEd25519Pubkey;
  } }), Object.defineProperty(e, "encodeSecp256k1Pubkey", { enumerable: !0, get: function() {
    return u.encodeSecp256k1Pubkey;
  } });
  var c = multisig;
  Object.defineProperty(e, "createMultisigThresholdPubkey", { enumerable: !0, get: function() {
    return c.createMultisigThresholdPubkey;
  } });
  var d = paths$1;
  Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return d.makeCosmoshubPath;
  } });
  var m = pubkeys;
  Object.defineProperty(e, "isEd25519Pubkey", { enumerable: !0, get: function() {
    return m.isEd25519Pubkey;
  } }), Object.defineProperty(e, "isMultisigThresholdPubkey", { enumerable: !0, get: function() {
    return m.isMultisigThresholdPubkey;
  } }), Object.defineProperty(e, "isSecp256k1Pubkey", { enumerable: !0, get: function() {
    return m.isSecp256k1Pubkey;
  } }), Object.defineProperty(e, "isSinglePubkey", { enumerable: !0, get: function() {
    return m.isSinglePubkey;
  } }), Object.defineProperty(e, "pubkeyType", { enumerable: !0, get: function() {
    return m.pubkeyType;
  } });
  var v = secp256k1hdwallet;
  Object.defineProperty(e, "extractKdfConfiguration", { enumerable: !0, get: function() {
    return v.extractKdfConfiguration;
  } }), Object.defineProperty(e, "Secp256k1HdWallet", { enumerable: !0, get: function() {
    return v.Secp256k1HdWallet;
  } });
  var S = secp256k1wallet;
  Object.defineProperty(e, "Secp256k1Wallet", { enumerable: !0, get: function() {
    return S.Secp256k1Wallet;
  } });
  var $ = signature;
  Object.defineProperty(e, "decodeSignature", { enumerable: !0, get: function() {
    return $.decodeSignature;
  } }), Object.defineProperty(e, "encodeSecp256k1Signature", { enumerable: !0, get: function() {
    return $.encodeSecp256k1Signature;
  } });
  var E = signdoc;
  Object.defineProperty(e, "makeSignDoc", { enumerable: !0, get: function() {
    return E.makeSignDoc;
  } }), Object.defineProperty(e, "serializeSignDoc", { enumerable: !0, get: function() {
    return E.serializeSignDoc;
  } });
  var O = stdtx;
  Object.defineProperty(e, "isStdTx", { enumerable: !0, get: function() {
    return O.isStdTx;
  } }), Object.defineProperty(e, "makeStdTx", { enumerable: !0, get: function() {
    return O.makeStdTx;
  } });
  var T = wallet$1;
  Object.defineProperty(e, "executeKdf", { enumerable: !0, get: function() {
    return T.executeKdf;
  } });
})(build$9);
let BondStatus;
(function(e) {
  e[e.BOND_STATUS_UNSPECIFIED = 0] = "BOND_STATUS_UNSPECIFIED", e[e.BOND_STATUS_UNBONDED = 1] = "BOND_STATUS_UNBONDED", e[e.BOND_STATUS_UNBONDING = 2] = "BOND_STATUS_UNBONDING", e[e.BOND_STATUS_BONDED = 3] = "BOND_STATUS_BONDED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(BondStatus || (BondStatus = {}));
const BondStatusSDKType = BondStatus, BondStatusAmino = BondStatus;
function bondStatusFromJSON(e) {
  switch (e) {
    case 0:
    case "BOND_STATUS_UNSPECIFIED":
      return BondStatus.BOND_STATUS_UNSPECIFIED;
    case 1:
    case "BOND_STATUS_UNBONDED":
      return BondStatus.BOND_STATUS_UNBONDED;
    case 2:
    case "BOND_STATUS_UNBONDING":
      return BondStatus.BOND_STATUS_UNBONDING;
    case 3:
    case "BOND_STATUS_BONDED":
      return BondStatus.BOND_STATUS_BONDED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BondStatus.UNRECOGNIZED;
  }
}
function bondStatusToJSON(e) {
  switch (e) {
    case BondStatus.BOND_STATUS_UNSPECIFIED:
      return "BOND_STATUS_UNSPECIFIED";
    case BondStatus.BOND_STATUS_UNBONDED:
      return "BOND_STATUS_UNBONDED";
    case BondStatus.BOND_STATUS_UNBONDING:
      return "BOND_STATUS_UNBONDING";
    case BondStatus.BOND_STATUS_BONDED:
      return "BOND_STATUS_BONDED";
    case BondStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseHistoricalInfo() {
  return {
    header: void 0,
    valset: []
  };
}
const HistoricalInfo = {
  typeUrl: "/cosmos.staking.v1beta1.HistoricalInfo",
  encode(e, n = minimal.Writer.create()) {
    e.header !== void 0 && Header$3.encode(e.header, n.uint32(10).fork()).ldelim();
    for (const o of e.valset)
      Validator.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHistoricalInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.header = Header$3.decode(o, o.uint32());
          break;
        case 2:
          c.valset.push(Validator.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseHistoricalInfo();
    return o.header = e.header !== void 0 && e.header !== null ? Header$3.fromPartial(e.header) : void 0, o.valset = ((n = e.valset) === null || n === void 0 ? void 0 : n.map((u) => Validator.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      header: e != null && e.header ? Header$3.fromAmino(e.header) : void 0,
      valset: Array.isArray(e == null ? void 0 : e.valset) ? e.valset.map((n) => Validator.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.header = e.header ? Header$3.toAmino(e.header) : void 0, e.valset ? n.valset = e.valset.map((o) => o ? Validator.toAmino(o) : void 0) : n.valset = [], n;
  },
  fromAminoMsg(e) {
    return HistoricalInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/HistoricalInfo",
      value: HistoricalInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return HistoricalInfo.decode(e.value);
  },
  toProto(e) {
    return HistoricalInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.HistoricalInfo",
      value: HistoricalInfo.encode(e).finish()
    };
  }
};
function createBaseCommissionRates() {
  return {
    rate: "",
    maxRate: "",
    maxChangeRate: ""
  };
}
const CommissionRates = {
  typeUrl: "/cosmos.staking.v1beta1.CommissionRates",
  encode(e, n = minimal.Writer.create()) {
    return e.rate !== "" && n.uint32(10).string(e.rate), e.maxRate !== "" && n.uint32(18).string(e.maxRate), e.maxChangeRate !== "" && n.uint32(26).string(e.maxChangeRate), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommissionRates();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.rate = o.string();
          break;
        case 2:
          c.maxRate = o.string();
          break;
        case 3:
          c.maxChangeRate = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseCommissionRates();
    return c.rate = (n = e.rate) !== null && n !== void 0 ? n : "", c.maxRate = (o = e.maxRate) !== null && o !== void 0 ? o : "", c.maxChangeRate = (u = e.maxChangeRate) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      rate: e.rate,
      maxRate: e.max_rate,
      maxChangeRate: e.max_change_rate
    };
  },
  toAmino(e) {
    const n = {};
    return n.rate = e.rate, n.max_rate = e.maxRate, n.max_change_rate = e.maxChangeRate, n;
  },
  fromAminoMsg(e) {
    return CommissionRates.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CommissionRates",
      value: CommissionRates.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CommissionRates.decode(e.value);
  },
  toProto(e) {
    return CommissionRates.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.CommissionRates",
      value: CommissionRates.encode(e).finish()
    };
  }
};
function createBaseCommission() {
  return {
    commissionRates: void 0,
    updateTime: void 0
  };
}
const Commission = {
  typeUrl: "/cosmos.staking.v1beta1.Commission",
  encode(e, n = minimal.Writer.create()) {
    return e.commissionRates !== void 0 && CommissionRates.encode(e.commissionRates, n.uint32(10).fork()).ldelim(), e.updateTime !== void 0 && Timestamp.encode(toTimestamp(e.updateTime), n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommission();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.commissionRates = CommissionRates.decode(o, o.uint32());
          break;
        case 2:
          c.updateTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseCommission();
    return o.commissionRates = e.commissionRates !== void 0 && e.commissionRates !== null ? CommissionRates.fromPartial(e.commissionRates) : void 0, o.updateTime = (n = e.updateTime) !== null && n !== void 0 ? n : void 0, o;
  },
  fromAmino(e) {
    return {
      commissionRates: e != null && e.commission_rates ? CommissionRates.fromAmino(e.commission_rates) : void 0,
      updateTime: e != null && e.update_time ? Timestamp.fromAmino(e.update_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.commission_rates = e.commissionRates ? CommissionRates.toAmino(e.commissionRates) : void 0, n.update_time = e.updateTime ? Timestamp.toAmino(e.updateTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return Commission.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Commission",
      value: Commission.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Commission.decode(e.value);
  },
  toProto(e) {
    return Commission.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Commission",
      value: Commission.encode(e).finish()
    };
  }
};
function createBaseDescription() {
  return {
    moniker: "",
    identity: "",
    website: "",
    securityContact: "",
    details: ""
  };
}
const Description = {
  typeUrl: "/cosmos.staking.v1beta1.Description",
  encode(e, n = minimal.Writer.create()) {
    return e.moniker !== "" && n.uint32(10).string(e.moniker), e.identity !== "" && n.uint32(18).string(e.identity), e.website !== "" && n.uint32(26).string(e.website), e.securityContact !== "" && n.uint32(34).string(e.securityContact), e.details !== "" && n.uint32(42).string(e.details), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDescription();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.moniker = o.string();
          break;
        case 2:
          c.identity = o.string();
          break;
        case 3:
          c.website = o.string();
          break;
        case 4:
          c.securityContact = o.string();
          break;
        case 5:
          c.details = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseDescription();
    return m.moniker = (n = e.moniker) !== null && n !== void 0 ? n : "", m.identity = (o = e.identity) !== null && o !== void 0 ? o : "", m.website = (u = e.website) !== null && u !== void 0 ? u : "", m.securityContact = (c = e.securityContact) !== null && c !== void 0 ? c : "", m.details = (d = e.details) !== null && d !== void 0 ? d : "", m;
  },
  fromAmino(e) {
    return {
      moniker: e.moniker,
      identity: e.identity,
      website: e.website,
      securityContact: e.security_contact,
      details: e.details
    };
  },
  toAmino(e) {
    const n = {};
    return n.moniker = e.moniker, n.identity = e.identity, n.website = e.website, n.security_contact = e.securityContact, n.details = e.details, n;
  },
  fromAminoMsg(e) {
    return Description.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Description",
      value: Description.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Description.decode(e.value);
  },
  toProto(e) {
    return Description.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Description",
      value: Description.encode(e).finish()
    };
  }
};
function createBaseValidator() {
  return {
    operatorAddress: "",
    consensusPubkey: void 0,
    jailed: !1,
    status: 0,
    tokens: "",
    delegatorShares: "",
    description: void 0,
    unbondingHeight: Long$2.ZERO,
    unbondingTime: void 0,
    commission: void 0,
    minSelfDelegation: ""
  };
}
const Validator = {
  typeUrl: "/cosmos.staking.v1beta1.Validator",
  encode(e, n = minimal.Writer.create()) {
    return e.operatorAddress !== "" && n.uint32(10).string(e.operatorAddress), e.consensusPubkey !== void 0 && Any.encode(e.consensusPubkey, n.uint32(18).fork()).ldelim(), e.jailed === !0 && n.uint32(24).bool(e.jailed), e.status !== 0 && n.uint32(32).int32(e.status), e.tokens !== "" && n.uint32(42).string(e.tokens), e.delegatorShares !== "" && n.uint32(50).string(e.delegatorShares), e.description !== void 0 && Description.encode(e.description, n.uint32(58).fork()).ldelim(), e.unbondingHeight.isZero() || n.uint32(64).int64(e.unbondingHeight), e.unbondingTime !== void 0 && Timestamp.encode(toTimestamp(e.unbondingTime), n.uint32(74).fork()).ldelim(), e.commission !== void 0 && Commission.encode(e.commission, n.uint32(82).fork()).ldelim(), e.minSelfDelegation !== "" && n.uint32(90).string(e.minSelfDelegation), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidator();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.operatorAddress = o.string();
          break;
        case 2:
          c.consensusPubkey = Cosmos_cryptoPubKey_InterfaceDecoder$1(o);
          break;
        case 3:
          c.jailed = o.bool();
          break;
        case 4:
          c.status = o.int32();
          break;
        case 5:
          c.tokens = o.string();
          break;
        case 6:
          c.delegatorShares = o.string();
          break;
        case 7:
          c.description = Description.decode(o, o.uint32());
          break;
        case 8:
          c.unbondingHeight = o.int64();
          break;
        case 9:
          c.unbondingTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 10:
          c.commission = Commission.decode(o, o.uint32());
          break;
        case 11:
          c.minSelfDelegation = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v;
    const S = createBaseValidator();
    return S.operatorAddress = (n = e.operatorAddress) !== null && n !== void 0 ? n : "", S.consensusPubkey = e.consensusPubkey !== void 0 && e.consensusPubkey !== null ? Any.fromPartial(e.consensusPubkey) : void 0, S.jailed = (o = e.jailed) !== null && o !== void 0 ? o : !1, S.status = (u = e.status) !== null && u !== void 0 ? u : 0, S.tokens = (c = e.tokens) !== null && c !== void 0 ? c : "", S.delegatorShares = (d = e.delegatorShares) !== null && d !== void 0 ? d : "", S.description = e.description !== void 0 && e.description !== null ? Description.fromPartial(e.description) : void 0, S.unbondingHeight = e.unbondingHeight !== void 0 && e.unbondingHeight !== null ? Long$2.fromValue(e.unbondingHeight) : Long$2.ZERO, S.unbondingTime = (m = e.unbondingTime) !== null && m !== void 0 ? m : void 0, S.commission = e.commission !== void 0 && e.commission !== null ? Commission.fromPartial(e.commission) : void 0, S.minSelfDelegation = (v = e.minSelfDelegation) !== null && v !== void 0 ? v : "", S;
  },
  fromAmino(e) {
    return {
      operatorAddress: e.operator_address,
      consensusPubkey: build$9.encodeBech32Pubkey({
        type: "tendermint/PubKeySecp256k1",
        value: build$a.toBase64(e.consensus_pubkey.value)
      }, "cosmos"),
      jailed: e.jailed,
      status: isSet(e.status) ? bondStatusFromJSON(e.status) : 0,
      tokens: e.tokens,
      delegatorShares: e.delegator_shares,
      description: e != null && e.description ? Description.fromAmino(e.description) : void 0,
      unbondingHeight: Long$2.fromString(e.unbonding_height),
      unbondingTime: e != null && e.unbonding_time ? Timestamp.fromAmino(e.unbonding_time) : void 0,
      commission: e != null && e.commission ? Commission.fromAmino(e.commission) : void 0,
      minSelfDelegation: e.min_self_delegation
    };
  },
  toAmino(e) {
    const n = {};
    return n.operator_address = e.operatorAddress, n.consensus_pubkey = e.consensusPubkey ? {
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: build$a.fromBase64(build$9.decodeBech32Pubkey(e.consensusPubkey).value)
    } : void 0, n.jailed = e.jailed, n.status = e.status, n.tokens = e.tokens, n.delegator_shares = e.delegatorShares, n.description = e.description ? Description.toAmino(e.description) : void 0, n.unbonding_height = e.unbondingHeight ? e.unbondingHeight.toString() : void 0, n.unbonding_time = e.unbondingTime ? Timestamp.toAmino(e.unbondingTime) : void 0, n.commission = e.commission ? Commission.toAmino(e.commission) : void 0, n.min_self_delegation = e.minSelfDelegation, n;
  },
  fromAminoMsg(e) {
    return Validator.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Validator",
      value: Validator.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Validator.decode(e.value);
  },
  toProto(e) {
    return Validator.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Validator",
      value: Validator.encode(e).finish()
    };
  }
};
function createBaseValAddresses() {
  return {
    addresses: []
  };
}
const ValAddresses = {
  typeUrl: "/cosmos.staking.v1beta1.ValAddresses",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.addresses)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValAddresses();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.addresses.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValAddresses();
    return o.addresses = ((n = e.addresses) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      addresses: Array.isArray(e == null ? void 0 : e.addresses) ? e.addresses.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.addresses ? n.addresses = e.addresses.map((o) => o) : n.addresses = [], n;
  },
  fromAminoMsg(e) {
    return ValAddresses.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ValAddresses",
      value: ValAddresses.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValAddresses.decode(e.value);
  },
  toProto(e) {
    return ValAddresses.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.ValAddresses",
      value: ValAddresses.encode(e).finish()
    };
  }
};
function createBaseDVPair() {
  return {
    delegatorAddress: "",
    validatorAddress: ""
  };
}
const DVPair = {
  typeUrl: "/cosmos.staking.v1beta1.DVPair",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDVPair();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDVPair();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n;
  },
  fromAminoMsg(e) {
    return DVPair.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DVPair",
      value: DVPair.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DVPair.decode(e.value);
  },
  toProto(e) {
    return DVPair.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DVPair",
      value: DVPair.encode(e).finish()
    };
  }
};
function createBaseDVPairs() {
  return {
    pairs: []
  };
}
const DVPairs = {
  typeUrl: "/cosmos.staking.v1beta1.DVPairs",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.pairs)
      DVPair.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDVPairs();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pairs.push(DVPair.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDVPairs();
    return o.pairs = ((n = e.pairs) === null || n === void 0 ? void 0 : n.map((u) => DVPair.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      pairs: Array.isArray(e == null ? void 0 : e.pairs) ? e.pairs.map((n) => DVPair.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.pairs ? n.pairs = e.pairs.map((o) => o ? DVPair.toAmino(o) : void 0) : n.pairs = [], n;
  },
  fromAminoMsg(e) {
    return DVPairs.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DVPairs",
      value: DVPairs.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DVPairs.decode(e.value);
  },
  toProto(e) {
    return DVPairs.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DVPairs",
      value: DVPairs.encode(e).finish()
    };
  }
};
function createBaseDVVTriplet() {
  return {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
  };
}
const DVVTriplet = {
  typeUrl: "/cosmos.staking.v1beta1.DVVTriplet",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorSrcAddress !== "" && n.uint32(18).string(e.validatorSrcAddress), e.validatorDstAddress !== "" && n.uint32(26).string(e.validatorDstAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDVVTriplet();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorSrcAddress = o.string();
          break;
        case 3:
          c.validatorDstAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseDVVTriplet();
    return c.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", c.validatorSrcAddress = (o = e.validatorSrcAddress) !== null && o !== void 0 ? o : "", c.validatorDstAddress = (u = e.validatorDstAddress) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorSrcAddress: e.validator_src_address,
      validatorDstAddress: e.validator_dst_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_src_address = e.validatorSrcAddress, n.validator_dst_address = e.validatorDstAddress, n;
  },
  fromAminoMsg(e) {
    return DVVTriplet.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DVVTriplet",
      value: DVVTriplet.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DVVTriplet.decode(e.value);
  },
  toProto(e) {
    return DVVTriplet.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DVVTriplet",
      value: DVVTriplet.encode(e).finish()
    };
  }
};
function createBaseDVVTriplets() {
  return {
    triplets: []
  };
}
const DVVTriplets = {
  typeUrl: "/cosmos.staking.v1beta1.DVVTriplets",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.triplets)
      DVVTriplet.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDVVTriplets();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.triplets.push(DVVTriplet.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDVVTriplets();
    return o.triplets = ((n = e.triplets) === null || n === void 0 ? void 0 : n.map((u) => DVVTriplet.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      triplets: Array.isArray(e == null ? void 0 : e.triplets) ? e.triplets.map((n) => DVVTriplet.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.triplets ? n.triplets = e.triplets.map((o) => o ? DVVTriplet.toAmino(o) : void 0) : n.triplets = [], n;
  },
  fromAminoMsg(e) {
    return DVVTriplets.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DVVTriplets",
      value: DVVTriplets.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DVVTriplets.decode(e.value);
  },
  toProto(e) {
    return DVVTriplets.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DVVTriplets",
      value: DVVTriplets.encode(e).finish()
    };
  }
};
function createBaseDelegation() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    shares: ""
  };
}
const Delegation = {
  typeUrl: "/cosmos.staking.v1beta1.Delegation",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.shares !== "" && n.uint32(26).string(e.shares), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDelegation();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        case 3:
          c.shares = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseDelegation();
    return c.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", c.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", c.shares = (u = e.shares) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address,
      shares: e.shares
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n.shares = e.shares, n;
  },
  fromAminoMsg(e) {
    return Delegation.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Delegation",
      value: Delegation.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Delegation.decode(e.value);
  },
  toProto(e) {
    return Delegation.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Delegation",
      value: Delegation.encode(e).finish()
    };
  }
};
function createBaseUnbondingDelegation() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    entries: []
  };
}
const UnbondingDelegation = {
  typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegation",
  encode(e, n = minimal.Writer.create()) {
    e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress);
    for (const o of e.entries)
      UnbondingDelegationEntry.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUnbondingDelegation();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        case 3:
          c.entries.push(UnbondingDelegationEntry.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseUnbondingDelegation();
    return c.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", c.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", c.entries = ((u = e.entries) === null || u === void 0 ? void 0 : u.map((d) => UnbondingDelegationEntry.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address,
      entries: Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => UnbondingDelegationEntry.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, e.entries ? n.entries = e.entries.map((o) => o ? UnbondingDelegationEntry.toAmino(o) : void 0) : n.entries = [], n;
  },
  fromAminoMsg(e) {
    return UnbondingDelegation.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/UnbondingDelegation",
      value: UnbondingDelegation.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UnbondingDelegation.decode(e.value);
  },
  toProto(e) {
    return UnbondingDelegation.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegation",
      value: UnbondingDelegation.encode(e).finish()
    };
  }
};
function createBaseUnbondingDelegationEntry() {
  return {
    creationHeight: Long$2.ZERO,
    completionTime: void 0,
    initialBalance: "",
    balance: ""
  };
}
const UnbondingDelegationEntry = {
  typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegationEntry",
  encode(e, n = minimal.Writer.create()) {
    return e.creationHeight.isZero() || n.uint32(8).int64(e.creationHeight), e.completionTime !== void 0 && Timestamp.encode(toTimestamp(e.completionTime), n.uint32(18).fork()).ldelim(), e.initialBalance !== "" && n.uint32(26).string(e.initialBalance), e.balance !== "" && n.uint32(34).string(e.balance), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUnbondingDelegationEntry();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.creationHeight = o.int64();
          break;
        case 2:
          c.completionTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 3:
          c.initialBalance = o.string();
          break;
        case 4:
          c.balance = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseUnbondingDelegationEntry();
    return c.creationHeight = e.creationHeight !== void 0 && e.creationHeight !== null ? Long$2.fromValue(e.creationHeight) : Long$2.ZERO, c.completionTime = (n = e.completionTime) !== null && n !== void 0 ? n : void 0, c.initialBalance = (o = e.initialBalance) !== null && o !== void 0 ? o : "", c.balance = (u = e.balance) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      creationHeight: Long$2.fromString(e.creation_height),
      completionTime: e != null && e.completion_time ? Timestamp.fromAmino(e.completion_time) : void 0,
      initialBalance: e.initial_balance,
      balance: e.balance
    };
  },
  toAmino(e) {
    const n = {};
    return n.creation_height = e.creationHeight ? e.creationHeight.toString() : void 0, n.completion_time = e.completionTime ? Timestamp.toAmino(e.completionTime) : void 0, n.initial_balance = e.initialBalance, n.balance = e.balance, n;
  },
  fromAminoMsg(e) {
    return UnbondingDelegationEntry.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/UnbondingDelegationEntry",
      value: UnbondingDelegationEntry.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UnbondingDelegationEntry.decode(e.value);
  },
  toProto(e) {
    return UnbondingDelegationEntry.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegationEntry",
      value: UnbondingDelegationEntry.encode(e).finish()
    };
  }
};
function createBaseRedelegationEntry() {
  return {
    creationHeight: Long$2.ZERO,
    completionTime: void 0,
    initialBalance: "",
    sharesDst: ""
  };
}
const RedelegationEntry = {
  typeUrl: "/cosmos.staking.v1beta1.RedelegationEntry",
  encode(e, n = minimal.Writer.create()) {
    return e.creationHeight.isZero() || n.uint32(8).int64(e.creationHeight), e.completionTime !== void 0 && Timestamp.encode(toTimestamp(e.completionTime), n.uint32(18).fork()).ldelim(), e.initialBalance !== "" && n.uint32(26).string(e.initialBalance), e.sharesDst !== "" && n.uint32(34).string(e.sharesDst), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRedelegationEntry();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.creationHeight = o.int64();
          break;
        case 2:
          c.completionTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 3:
          c.initialBalance = o.string();
          break;
        case 4:
          c.sharesDst = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRedelegationEntry();
    return c.creationHeight = e.creationHeight !== void 0 && e.creationHeight !== null ? Long$2.fromValue(e.creationHeight) : Long$2.ZERO, c.completionTime = (n = e.completionTime) !== null && n !== void 0 ? n : void 0, c.initialBalance = (o = e.initialBalance) !== null && o !== void 0 ? o : "", c.sharesDst = (u = e.sharesDst) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      creationHeight: Long$2.fromString(e.creation_height),
      completionTime: e != null && e.completion_time ? Timestamp.fromAmino(e.completion_time) : void 0,
      initialBalance: e.initial_balance,
      sharesDst: e.shares_dst
    };
  },
  toAmino(e) {
    const n = {};
    return n.creation_height = e.creationHeight ? e.creationHeight.toString() : void 0, n.completion_time = e.completionTime ? Timestamp.toAmino(e.completionTime) : void 0, n.initial_balance = e.initialBalance, n.shares_dst = e.sharesDst, n;
  },
  fromAminoMsg(e) {
    return RedelegationEntry.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/RedelegationEntry",
      value: RedelegationEntry.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RedelegationEntry.decode(e.value);
  },
  toProto(e) {
    return RedelegationEntry.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.RedelegationEntry",
      value: RedelegationEntry.encode(e).finish()
    };
  }
};
function createBaseRedelegation() {
  return {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: "",
    entries: []
  };
}
const Redelegation = {
  typeUrl: "/cosmos.staking.v1beta1.Redelegation",
  encode(e, n = minimal.Writer.create()) {
    e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorSrcAddress !== "" && n.uint32(18).string(e.validatorSrcAddress), e.validatorDstAddress !== "" && n.uint32(26).string(e.validatorDstAddress);
    for (const o of e.entries)
      RedelegationEntry.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRedelegation();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorSrcAddress = o.string();
          break;
        case 3:
          c.validatorDstAddress = o.string();
          break;
        case 4:
          c.entries.push(RedelegationEntry.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseRedelegation();
    return d.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", d.validatorSrcAddress = (o = e.validatorSrcAddress) !== null && o !== void 0 ? o : "", d.validatorDstAddress = (u = e.validatorDstAddress) !== null && u !== void 0 ? u : "", d.entries = ((c = e.entries) === null || c === void 0 ? void 0 : c.map((m) => RedelegationEntry.fromPartial(m))) || [], d;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorSrcAddress: e.validator_src_address,
      validatorDstAddress: e.validator_dst_address,
      entries: Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => RedelegationEntry.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_src_address = e.validatorSrcAddress, n.validator_dst_address = e.validatorDstAddress, e.entries ? n.entries = e.entries.map((o) => o ? RedelegationEntry.toAmino(o) : void 0) : n.entries = [], n;
  },
  fromAminoMsg(e) {
    return Redelegation.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Redelegation",
      value: Redelegation.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Redelegation.decode(e.value);
  },
  toProto(e) {
    return Redelegation.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Redelegation",
      value: Redelegation.encode(e).finish()
    };
  }
};
function createBaseParams$g() {
  return {
    unbondingTime: void 0,
    maxValidators: 0,
    maxEntries: 0,
    historicalEntries: 0,
    bondDenom: "",
    minCommissionRate: "",
    minSelfDelegation: ""
  };
}
const Params$h = {
  typeUrl: "/cosmos.staking.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.unbondingTime !== void 0 && Duration.encode(e.unbondingTime, n.uint32(10).fork()).ldelim(), e.maxValidators !== 0 && n.uint32(16).uint32(e.maxValidators), e.maxEntries !== 0 && n.uint32(24).uint32(e.maxEntries), e.historicalEntries !== 0 && n.uint32(32).uint32(e.historicalEntries), e.bondDenom !== "" && n.uint32(42).string(e.bondDenom), e.minCommissionRate !== "" && n.uint32(50).string(e.minCommissionRate), e.minSelfDelegation !== "" && n.uint32(58).string(e.minSelfDelegation), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$g();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.unbondingTime = Duration.decode(o, o.uint32());
          break;
        case 2:
          c.maxValidators = o.uint32();
          break;
        case 3:
          c.maxEntries = o.uint32();
          break;
        case 4:
          c.historicalEntries = o.uint32();
          break;
        case 5:
          c.bondDenom = o.string();
          break;
        case 6:
          c.minCommissionRate = o.string();
          break;
        case 7:
          c.minSelfDelegation = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseParams$g();
    return v.unbondingTime = e.unbondingTime !== void 0 && e.unbondingTime !== null ? Duration.fromPartial(e.unbondingTime) : void 0, v.maxValidators = (n = e.maxValidators) !== null && n !== void 0 ? n : 0, v.maxEntries = (o = e.maxEntries) !== null && o !== void 0 ? o : 0, v.historicalEntries = (u = e.historicalEntries) !== null && u !== void 0 ? u : 0, v.bondDenom = (c = e.bondDenom) !== null && c !== void 0 ? c : "", v.minCommissionRate = (d = e.minCommissionRate) !== null && d !== void 0 ? d : "", v.minSelfDelegation = (m = e.minSelfDelegation) !== null && m !== void 0 ? m : "", v;
  },
  fromAmino(e) {
    return {
      unbondingTime: e != null && e.unbonding_time ? Duration.fromAmino(e.unbonding_time) : void 0,
      maxValidators: e.max_validators,
      maxEntries: e.max_entries,
      historicalEntries: e.historical_entries,
      bondDenom: e.bond_denom,
      minCommissionRate: e.min_commission_rate,
      minSelfDelegation: e.min_self_delegation
    };
  },
  toAmino(e) {
    const n = {};
    return n.unbonding_time = e.unbondingTime ? Duration.toAmino(e.unbondingTime) : void 0, n.max_validators = e.maxValidators, n.max_entries = e.maxEntries, n.historical_entries = e.historicalEntries, n.bond_denom = e.bondDenom, n.min_commission_rate = e.minCommissionRate, n.min_self_delegation = e.minSelfDelegation, n;
  },
  fromAminoMsg(e) {
    return Params$h.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/x/staking/Params",
      value: Params$h.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$h.decode(e.value);
  },
  toProto(e) {
    return Params$h.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Params",
      value: Params$h.encode(e).finish()
    };
  }
};
function createBaseDelegationResponse() {
  return {
    delegation: void 0,
    balance: void 0
  };
}
const DelegationResponse = {
  typeUrl: "/cosmos.staking.v1beta1.DelegationResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.delegation !== void 0 && Delegation.encode(e.delegation, n.uint32(10).fork()).ldelim(), e.balance !== void 0 && Coin.encode(e.balance, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDelegationResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegation = Delegation.decode(o, o.uint32());
          break;
        case 2:
          c.balance = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseDelegationResponse();
    return n.delegation = e.delegation !== void 0 && e.delegation !== null ? Delegation.fromPartial(e.delegation) : void 0, n.balance = e.balance !== void 0 && e.balance !== null ? Coin.fromPartial(e.balance) : void 0, n;
  },
  fromAmino(e) {
    return {
      delegation: e != null && e.delegation ? Delegation.fromAmino(e.delegation) : void 0,
      balance: e != null && e.balance ? Coin.fromAmino(e.balance) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegation = e.delegation ? Delegation.toAmino(e.delegation) : void 0, n.balance = e.balance ? Coin.toAmino(e.balance) : void 0, n;
  },
  fromAminoMsg(e) {
    return DelegationResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DelegationResponse",
      value: DelegationResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DelegationResponse.decode(e.value);
  },
  toProto(e) {
    return DelegationResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DelegationResponse",
      value: DelegationResponse.encode(e).finish()
    };
  }
};
function createBaseRedelegationEntryResponse() {
  return {
    redelegationEntry: void 0,
    balance: ""
  };
}
const RedelegationEntryResponse = {
  typeUrl: "/cosmos.staking.v1beta1.RedelegationEntryResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.redelegationEntry !== void 0 && RedelegationEntry.encode(e.redelegationEntry, n.uint32(10).fork()).ldelim(), e.balance !== "" && n.uint32(34).string(e.balance), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRedelegationEntryResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.redelegationEntry = RedelegationEntry.decode(o, o.uint32());
          break;
        case 4:
          c.balance = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRedelegationEntryResponse();
    return o.redelegationEntry = e.redelegationEntry !== void 0 && e.redelegationEntry !== null ? RedelegationEntry.fromPartial(e.redelegationEntry) : void 0, o.balance = (n = e.balance) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      redelegationEntry: e != null && e.redelegation_entry ? RedelegationEntry.fromAmino(e.redelegation_entry) : void 0,
      balance: e.balance
    };
  },
  toAmino(e) {
    const n = {};
    return n.redelegation_entry = e.redelegationEntry ? RedelegationEntry.toAmino(e.redelegationEntry) : void 0, n.balance = e.balance, n;
  },
  fromAminoMsg(e) {
    return RedelegationEntryResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/RedelegationEntryResponse",
      value: RedelegationEntryResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RedelegationEntryResponse.decode(e.value);
  },
  toProto(e) {
    return RedelegationEntryResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.RedelegationEntryResponse",
      value: RedelegationEntryResponse.encode(e).finish()
    };
  }
};
function createBaseRedelegationResponse() {
  return {
    redelegation: void 0,
    entries: []
  };
}
const RedelegationResponse = {
  typeUrl: "/cosmos.staking.v1beta1.RedelegationResponse",
  encode(e, n = minimal.Writer.create()) {
    e.redelegation !== void 0 && Redelegation.encode(e.redelegation, n.uint32(10).fork()).ldelim();
    for (const o of e.entries)
      RedelegationEntryResponse.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRedelegationResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.redelegation = Redelegation.decode(o, o.uint32());
          break;
        case 2:
          c.entries.push(RedelegationEntryResponse.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRedelegationResponse();
    return o.redelegation = e.redelegation !== void 0 && e.redelegation !== null ? Redelegation.fromPartial(e.redelegation) : void 0, o.entries = ((n = e.entries) === null || n === void 0 ? void 0 : n.map((u) => RedelegationEntryResponse.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      redelegation: e != null && e.redelegation ? Redelegation.fromAmino(e.redelegation) : void 0,
      entries: Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => RedelegationEntryResponse.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.redelegation = e.redelegation ? Redelegation.toAmino(e.redelegation) : void 0, e.entries ? n.entries = e.entries.map((o) => o ? RedelegationEntryResponse.toAmino(o) : void 0) : n.entries = [], n;
  },
  fromAminoMsg(e) {
    return RedelegationResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/RedelegationResponse",
      value: RedelegationResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RedelegationResponse.decode(e.value);
  },
  toProto(e) {
    return RedelegationResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.RedelegationResponse",
      value: RedelegationResponse.encode(e).finish()
    };
  }
};
function createBasePool$3() {
  return {
    notBondedTokens: "",
    bondedTokens: ""
  };
}
const Pool$3 = {
  typeUrl: "/cosmos.staking.v1beta1.Pool",
  encode(e, n = minimal.Writer.create()) {
    return e.notBondedTokens !== "" && n.uint32(10).string(e.notBondedTokens), e.bondedTokens !== "" && n.uint32(18).string(e.bondedTokens), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePool$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.notBondedTokens = o.string();
          break;
        case 2:
          c.bondedTokens = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePool$3();
    return u.notBondedTokens = (n = e.notBondedTokens) !== null && n !== void 0 ? n : "", u.bondedTokens = (o = e.bondedTokens) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      notBondedTokens: e.not_bonded_tokens,
      bondedTokens: e.bonded_tokens
    };
  },
  toAmino(e) {
    const n = {};
    return n.not_bonded_tokens = e.notBondedTokens, n.bonded_tokens = e.bondedTokens, n;
  },
  fromAminoMsg(e) {
    return Pool$3.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Pool",
      value: Pool$3.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Pool$3.decode(e.value);
  },
  toProto(e) {
    return Pool$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Pool",
      value: Pool$3.encode(e).finish()
    };
  }
}, Cosmos_cryptoPubKey_InterfaceDecoder$1 = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    default:
      return o;
  }
}, Cosmos_cryptoPubKey_FromAmino$1 = (e) => build$9.encodeBech32Pubkey({
  type: "tendermint/PubKeySecp256k1",
  value: build$a.toBase64(e.value)
}, "cosmos"), Cosmos_cryptoPubKey_ToAmino$1 = (e) => ({
  typeUrl: "/cosmos.crypto.secp256k1.PubKey",
  value: build$a.fromBase64(build$9.decodeBech32Pubkey(e).value)
}), _40 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get BondStatus() {
    return BondStatus;
  },
  BondStatusAmino,
  BondStatusSDKType,
  Commission,
  CommissionRates,
  Cosmos_cryptoPubKey_FromAmino: Cosmos_cryptoPubKey_FromAmino$1,
  Cosmos_cryptoPubKey_InterfaceDecoder: Cosmos_cryptoPubKey_InterfaceDecoder$1,
  Cosmos_cryptoPubKey_ToAmino: Cosmos_cryptoPubKey_ToAmino$1,
  DVPair,
  DVPairs,
  DVVTriplet,
  DVVTriplets,
  Delegation,
  DelegationResponse,
  Description,
  HistoricalInfo,
  Params: Params$h,
  Pool: Pool$3,
  Redelegation,
  RedelegationEntry,
  RedelegationEntryResponse,
  RedelegationResponse,
  UnbondingDelegation,
  UnbondingDelegationEntry,
  ValAddresses,
  Validator,
  bondStatusFromJSON,
  bondStatusToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$n() {
  return {
    params: void 0,
    lastTotalPower: new Uint8Array(),
    lastValidatorPowers: [],
    validators: [],
    delegations: [],
    unbondingDelegations: [],
    redelegations: [],
    exported: !1
  };
}
const GenesisState$n = {
  typeUrl: "/cosmos.staking.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$h.encode(e.params, n.uint32(10).fork()).ldelim(), e.lastTotalPower.length !== 0 && n.uint32(18).bytes(e.lastTotalPower);
    for (const o of e.lastValidatorPowers)
      LastValidatorPower.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.validators)
      Validator.encode(o, n.uint32(34).fork()).ldelim();
    for (const o of e.delegations)
      Delegation.encode(o, n.uint32(42).fork()).ldelim();
    for (const o of e.unbondingDelegations)
      UnbondingDelegation.encode(o, n.uint32(50).fork()).ldelim();
    for (const o of e.redelegations)
      Redelegation.encode(o, n.uint32(58).fork()).ldelim();
    return e.exported === !0 && n.uint32(64).bool(e.exported), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$n();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$h.decode(o, o.uint32());
          break;
        case 2:
          c.lastTotalPower = o.bytes();
          break;
        case 3:
          c.lastValidatorPowers.push(LastValidatorPower.decode(o, o.uint32()));
          break;
        case 4:
          c.validators.push(Validator.decode(o, o.uint32()));
          break;
        case 5:
          c.delegations.push(Delegation.decode(o, o.uint32()));
          break;
        case 6:
          c.unbondingDelegations.push(UnbondingDelegation.decode(o, o.uint32()));
          break;
        case 7:
          c.redelegations.push(Redelegation.decode(o, o.uint32()));
          break;
        case 8:
          c.exported = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v;
    const S = createBaseGenesisState$n();
    return S.params = e.params !== void 0 && e.params !== null ? Params$h.fromPartial(e.params) : void 0, S.lastTotalPower = (n = e.lastTotalPower) !== null && n !== void 0 ? n : new Uint8Array(), S.lastValidatorPowers = ((o = e.lastValidatorPowers) === null || o === void 0 ? void 0 : o.map(($) => LastValidatorPower.fromPartial($))) || [], S.validators = ((u = e.validators) === null || u === void 0 ? void 0 : u.map(($) => Validator.fromPartial($))) || [], S.delegations = ((c = e.delegations) === null || c === void 0 ? void 0 : c.map(($) => Delegation.fromPartial($))) || [], S.unbondingDelegations = ((d = e.unbondingDelegations) === null || d === void 0 ? void 0 : d.map(($) => UnbondingDelegation.fromPartial($))) || [], S.redelegations = ((m = e.redelegations) === null || m === void 0 ? void 0 : m.map(($) => Redelegation.fromPartial($))) || [], S.exported = (v = e.exported) !== null && v !== void 0 ? v : !1, S;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$h.fromAmino(e.params) : void 0,
      lastTotalPower: e.last_total_power,
      lastValidatorPowers: Array.isArray(e == null ? void 0 : e.last_validator_powers) ? e.last_validator_powers.map((n) => LastValidatorPower.fromAmino(n)) : [],
      validators: Array.isArray(e == null ? void 0 : e.validators) ? e.validators.map((n) => Validator.fromAmino(n)) : [],
      delegations: Array.isArray(e == null ? void 0 : e.delegations) ? e.delegations.map((n) => Delegation.fromAmino(n)) : [],
      unbondingDelegations: Array.isArray(e == null ? void 0 : e.unbonding_delegations) ? e.unbonding_delegations.map((n) => UnbondingDelegation.fromAmino(n)) : [],
      redelegations: Array.isArray(e == null ? void 0 : e.redelegations) ? e.redelegations.map((n) => Redelegation.fromAmino(n)) : [],
      exported: e.exported
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$h.toAmino(e.params) : void 0, n.last_total_power = e.lastTotalPower, e.lastValidatorPowers ? n.last_validator_powers = e.lastValidatorPowers.map((o) => o ? LastValidatorPower.toAmino(o) : void 0) : n.last_validator_powers = [], e.validators ? n.validators = e.validators.map((o) => o ? Validator.toAmino(o) : void 0) : n.validators = [], e.delegations ? n.delegations = e.delegations.map((o) => o ? Delegation.toAmino(o) : void 0) : n.delegations = [], e.unbondingDelegations ? n.unbonding_delegations = e.unbondingDelegations.map((o) => o ? UnbondingDelegation.toAmino(o) : void 0) : n.unbonding_delegations = [], e.redelegations ? n.redelegations = e.redelegations.map((o) => o ? Redelegation.toAmino(o) : void 0) : n.redelegations = [], n.exported = e.exported, n;
  },
  fromAminoMsg(e) {
    return GenesisState$n.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$n.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$n.decode(e.value);
  },
  toProto(e) {
    return GenesisState$n.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.GenesisState",
      value: GenesisState$n.encode(e).finish()
    };
  }
};
function createBaseLastValidatorPower() {
  return {
    address: "",
    power: Long$2.ZERO
  };
}
const LastValidatorPower = {
  typeUrl: "/cosmos.staking.v1beta1.LastValidatorPower",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.power.isZero() || n.uint32(16).int64(e.power), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLastValidatorPower();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.power = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseLastValidatorPower();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o.power = e.power !== void 0 && e.power !== null ? Long$2.fromValue(e.power) : Long$2.ZERO, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      power: Long$2.fromString(e.power)
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.power = e.power ? e.power.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return LastValidatorPower.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/LastValidatorPower",
      value: LastValidatorPower.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LastValidatorPower.decode(e.value);
  },
  toProto(e) {
    return LastValidatorPower.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.LastValidatorPower",
      value: LastValidatorPower.encode(e).finish()
    };
  }
}, _38 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$n,
  LastValidatorPower
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryValidatorsRequest() {
  return {
    status: "",
    pagination: void 0
  };
}
const QueryValidatorsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.status !== "" && n.uint32(10).string(e.status), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.status = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorsRequest();
    return o.status = (n = e.status) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      status: e.status,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.status = e.status, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorsRequest",
      value: QueryValidatorsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsRequest",
      value: QueryValidatorsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorsResponse() {
  return {
    validators: [],
    pagination: void 0
  };
}
const QueryValidatorsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.validators)
      Validator.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validators.push(Validator.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorsResponse();
    return o.validators = ((n = e.validators) === null || n === void 0 ? void 0 : n.map((u) => Validator.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      validators: Array.isArray(e == null ? void 0 : e.validators) ? e.validators.map((n) => Validator.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.validators ? n.validators = e.validators.map((o) => o ? Validator.toAmino(o) : void 0) : n.validators = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorsResponse",
      value: QueryValidatorsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsResponse",
      value: QueryValidatorsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorRequest() {
  return {
    validatorAddr: ""
  };
}
const QueryValidatorRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddr !== "" && n.uint32(10).string(e.validatorAddr), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddr = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorRequest();
    return o.validatorAddr = (n = e.validatorAddr) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      validatorAddr: e.validator_addr
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_addr = e.validatorAddr, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorRequest",
      value: QueryValidatorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorRequest.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorRequest",
      value: QueryValidatorRequest.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorResponse() {
  return {
    validator: void 0
  };
}
const QueryValidatorResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.validator !== void 0 && Validator.encode(e.validator, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validator = Validator.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryValidatorResponse();
    return n.validator = e.validator !== void 0 && e.validator !== null ? Validator.fromPartial(e.validator) : void 0, n;
  },
  fromAmino(e) {
    return {
      validator: e != null && e.validator ? Validator.fromAmino(e.validator) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator = e.validator ? Validator.toAmino(e.validator) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorResponse",
      value: QueryValidatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorResponse.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorResponse",
      value: QueryValidatorResponse.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorDelegationsRequest() {
  return {
    validatorAddr: "",
    pagination: void 0
  };
}
const QueryValidatorDelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddr !== "" && n.uint32(10).string(e.validatorAddr), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorDelegationsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddr = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorDelegationsRequest();
    return o.validatorAddr = (n = e.validatorAddr) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      validatorAddr: e.validator_addr,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_addr = e.validatorAddr, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorDelegationsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorDelegationsRequest",
      value: QueryValidatorDelegationsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorDelegationsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorDelegationsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsRequest",
      value: QueryValidatorDelegationsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorDelegationsResponse() {
  return {
    delegationResponses: [],
    pagination: void 0
  };
}
const QueryValidatorDelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.delegationResponses)
      DelegationResponse.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorDelegationsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegationResponses.push(DelegationResponse.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorDelegationsResponse();
    return o.delegationResponses = ((n = e.delegationResponses) === null || n === void 0 ? void 0 : n.map((u) => DelegationResponse.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      delegationResponses: Array.isArray(e == null ? void 0 : e.delegation_responses) ? e.delegation_responses.map((n) => DelegationResponse.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.delegationResponses ? n.delegation_responses = e.delegationResponses.map((o) => o ? DelegationResponse.toAmino(o) : void 0) : n.delegation_responses = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorDelegationsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorDelegationsResponse",
      value: QueryValidatorDelegationsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorDelegationsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorDelegationsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsResponse",
      value: QueryValidatorDelegationsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorUnbondingDelegationsRequest() {
  return {
    validatorAddr: "",
    pagination: void 0
  };
}
const QueryValidatorUnbondingDelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddr !== "" && n.uint32(10).string(e.validatorAddr), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorUnbondingDelegationsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddr = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorUnbondingDelegationsRequest();
    return o.validatorAddr = (n = e.validatorAddr) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      validatorAddr: e.validator_addr,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_addr = e.validatorAddr, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorUnbondingDelegationsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorUnbondingDelegationsRequest",
      value: QueryValidatorUnbondingDelegationsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorUnbondingDelegationsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorUnbondingDelegationsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsRequest",
      value: QueryValidatorUnbondingDelegationsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryValidatorUnbondingDelegationsResponse() {
  return {
    unbondingResponses: [],
    pagination: void 0
  };
}
const QueryValidatorUnbondingDelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.unbondingResponses)
      UnbondingDelegation.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryValidatorUnbondingDelegationsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.unbondingResponses.push(UnbondingDelegation.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryValidatorUnbondingDelegationsResponse();
    return o.unbondingResponses = ((n = e.unbondingResponses) === null || n === void 0 ? void 0 : n.map((u) => UnbondingDelegation.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      unbondingResponses: Array.isArray(e == null ? void 0 : e.unbonding_responses) ? e.unbonding_responses.map((n) => UnbondingDelegation.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.unbondingResponses ? n.unbonding_responses = e.unbondingResponses.map((o) => o ? UnbondingDelegation.toAmino(o) : void 0) : n.unbonding_responses = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryValidatorUnbondingDelegationsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryValidatorUnbondingDelegationsResponse",
      value: QueryValidatorUnbondingDelegationsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryValidatorUnbondingDelegationsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryValidatorUnbondingDelegationsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsResponse",
      value: QueryValidatorUnbondingDelegationsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDelegationRequest() {
  return {
    delegatorAddr: "",
    validatorAddr: ""
  };
}
const QueryDelegationRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegationRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddr !== "" && n.uint32(10).string(e.delegatorAddr), e.validatorAddr !== "" && n.uint32(18).string(e.validatorAddr), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegationRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddr = o.string();
          break;
        case 2:
          c.validatorAddr = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryDelegationRequest();
    return u.delegatorAddr = (n = e.delegatorAddr) !== null && n !== void 0 ? n : "", u.validatorAddr = (o = e.validatorAddr) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddr: e.delegator_addr,
      validatorAddr: e.validator_addr
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_addr = e.delegatorAddr, n.validator_addr = e.validatorAddr, n;
  },
  fromAminoMsg(e) {
    return QueryDelegationRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegationRequest",
      value: QueryDelegationRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegationRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDelegationRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegationRequest",
      value: QueryDelegationRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDelegationResponse() {
  return {
    delegationResponse: void 0
  };
}
const QueryDelegationResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegationResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.delegationResponse !== void 0 && DelegationResponse.encode(e.delegationResponse, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegationResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegationResponse = DelegationResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDelegationResponse();
    return n.delegationResponse = e.delegationResponse !== void 0 && e.delegationResponse !== null ? DelegationResponse.fromPartial(e.delegationResponse) : void 0, n;
  },
  fromAmino(e) {
    return {
      delegationResponse: e != null && e.delegation_response ? DelegationResponse.fromAmino(e.delegation_response) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegation_response = e.delegationResponse ? DelegationResponse.toAmino(e.delegationResponse) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDelegationResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegationResponse",
      value: QueryDelegationResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegationResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDelegationResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegationResponse",
      value: QueryDelegationResponse.encode(e).finish()
    };
  }
};
function createBaseQueryUnbondingDelegationRequest() {
  return {
    delegatorAddr: "",
    validatorAddr: ""
  };
}
const QueryUnbondingDelegationRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddr !== "" && n.uint32(10).string(e.delegatorAddr), e.validatorAddr !== "" && n.uint32(18).string(e.validatorAddr), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUnbondingDelegationRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddr = o.string();
          break;
        case 2:
          c.validatorAddr = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryUnbondingDelegationRequest();
    return u.delegatorAddr = (n = e.delegatorAddr) !== null && n !== void 0 ? n : "", u.validatorAddr = (o = e.validatorAddr) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddr: e.delegator_addr,
      validatorAddr: e.validator_addr
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_addr = e.delegatorAddr, n.validator_addr = e.validatorAddr, n;
  },
  fromAminoMsg(e) {
    return QueryUnbondingDelegationRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUnbondingDelegationRequest",
      value: QueryUnbondingDelegationRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUnbondingDelegationRequest.decode(e.value);
  },
  toProto(e) {
    return QueryUnbondingDelegationRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationRequest",
      value: QueryUnbondingDelegationRequest.encode(e).finish()
    };
  }
};
function createBaseQueryUnbondingDelegationResponse() {
  return {
    unbond: void 0
  };
}
const QueryUnbondingDelegationResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.unbond !== void 0 && UnbondingDelegation.encode(e.unbond, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUnbondingDelegationResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.unbond = UnbondingDelegation.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryUnbondingDelegationResponse();
    return n.unbond = e.unbond !== void 0 && e.unbond !== null ? UnbondingDelegation.fromPartial(e.unbond) : void 0, n;
  },
  fromAmino(e) {
    return {
      unbond: e != null && e.unbond ? UnbondingDelegation.fromAmino(e.unbond) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.unbond = e.unbond ? UnbondingDelegation.toAmino(e.unbond) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryUnbondingDelegationResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUnbondingDelegationResponse",
      value: QueryUnbondingDelegationResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUnbondingDelegationResponse.decode(e.value);
  },
  toProto(e) {
    return QueryUnbondingDelegationResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationResponse",
      value: QueryUnbondingDelegationResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorDelegationsRequest() {
  return {
    delegatorAddr: "",
    pagination: void 0
  };
}
const QueryDelegatorDelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddr !== "" && n.uint32(10).string(e.delegatorAddr), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorDelegationsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddr = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorDelegationsRequest();
    return o.delegatorAddr = (n = e.delegatorAddr) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      delegatorAddr: e.delegator_addr,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_addr = e.delegatorAddr, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorDelegationsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorDelegationsRequest",
      value: QueryDelegatorDelegationsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorDelegationsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorDelegationsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsRequest",
      value: QueryDelegatorDelegationsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorDelegationsResponse() {
  return {
    delegationResponses: [],
    pagination: void 0
  };
}
const QueryDelegatorDelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.delegationResponses)
      DelegationResponse.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorDelegationsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegationResponses.push(DelegationResponse.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorDelegationsResponse();
    return o.delegationResponses = ((n = e.delegationResponses) === null || n === void 0 ? void 0 : n.map((u) => DelegationResponse.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      delegationResponses: Array.isArray(e == null ? void 0 : e.delegation_responses) ? e.delegation_responses.map((n) => DelegationResponse.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.delegationResponses ? n.delegation_responses = e.delegationResponses.map((o) => o ? DelegationResponse.toAmino(o) : void 0) : n.delegation_responses = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorDelegationsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorDelegationsResponse",
      value: QueryDelegatorDelegationsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorDelegationsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorDelegationsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsResponse",
      value: QueryDelegatorDelegationsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorUnbondingDelegationsRequest() {
  return {
    delegatorAddr: "",
    pagination: void 0
  };
}
const QueryDelegatorUnbondingDelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddr !== "" && n.uint32(10).string(e.delegatorAddr), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorUnbondingDelegationsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddr = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorUnbondingDelegationsRequest();
    return o.delegatorAddr = (n = e.delegatorAddr) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      delegatorAddr: e.delegator_addr,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_addr = e.delegatorAddr, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorUnbondingDelegationsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorUnbondingDelegationsRequest",
      value: QueryDelegatorUnbondingDelegationsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorUnbondingDelegationsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorUnbondingDelegationsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsRequest",
      value: QueryDelegatorUnbondingDelegationsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorUnbondingDelegationsResponse() {
  return {
    unbondingResponses: [],
    pagination: void 0
  };
}
const QueryDelegatorUnbondingDelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.unbondingResponses)
      UnbondingDelegation.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorUnbondingDelegationsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.unbondingResponses.push(UnbondingDelegation.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorUnbondingDelegationsResponse();
    return o.unbondingResponses = ((n = e.unbondingResponses) === null || n === void 0 ? void 0 : n.map((u) => UnbondingDelegation.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      unbondingResponses: Array.isArray(e == null ? void 0 : e.unbonding_responses) ? e.unbonding_responses.map((n) => UnbondingDelegation.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.unbondingResponses ? n.unbonding_responses = e.unbondingResponses.map((o) => o ? UnbondingDelegation.toAmino(o) : void 0) : n.unbonding_responses = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorUnbondingDelegationsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorUnbondingDelegationsResponse",
      value: QueryDelegatorUnbondingDelegationsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorUnbondingDelegationsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorUnbondingDelegationsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsResponse",
      value: QueryDelegatorUnbondingDelegationsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryRedelegationsRequest() {
  return {
    delegatorAddr: "",
    srcValidatorAddr: "",
    dstValidatorAddr: "",
    pagination: void 0
  };
}
const QueryRedelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddr !== "" && n.uint32(10).string(e.delegatorAddr), e.srcValidatorAddr !== "" && n.uint32(18).string(e.srcValidatorAddr), e.dstValidatorAddr !== "" && n.uint32(26).string(e.dstValidatorAddr), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryRedelegationsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddr = o.string();
          break;
        case 2:
          c.srcValidatorAddr = o.string();
          break;
        case 3:
          c.dstValidatorAddr = o.string();
          break;
        case 4:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryRedelegationsRequest();
    return c.delegatorAddr = (n = e.delegatorAddr) !== null && n !== void 0 ? n : "", c.srcValidatorAddr = (o = e.srcValidatorAddr) !== null && o !== void 0 ? o : "", c.dstValidatorAddr = (u = e.dstValidatorAddr) !== null && u !== void 0 ? u : "", c.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, c;
  },
  fromAmino(e) {
    return {
      delegatorAddr: e.delegator_addr,
      srcValidatorAddr: e.src_validator_addr,
      dstValidatorAddr: e.dst_validator_addr,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_addr = e.delegatorAddr, n.src_validator_addr = e.srcValidatorAddr, n.dst_validator_addr = e.dstValidatorAddr, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryRedelegationsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryRedelegationsRequest",
      value: QueryRedelegationsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryRedelegationsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryRedelegationsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsRequest",
      value: QueryRedelegationsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryRedelegationsResponse() {
  return {
    redelegationResponses: [],
    pagination: void 0
  };
}
const QueryRedelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.redelegationResponses)
      RedelegationResponse.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryRedelegationsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.redelegationResponses.push(RedelegationResponse.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryRedelegationsResponse();
    return o.redelegationResponses = ((n = e.redelegationResponses) === null || n === void 0 ? void 0 : n.map((u) => RedelegationResponse.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      redelegationResponses: Array.isArray(e == null ? void 0 : e.redelegation_responses) ? e.redelegation_responses.map((n) => RedelegationResponse.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.redelegationResponses ? n.redelegation_responses = e.redelegationResponses.map((o) => o ? RedelegationResponse.toAmino(o) : void 0) : n.redelegation_responses = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryRedelegationsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryRedelegationsResponse",
      value: QueryRedelegationsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryRedelegationsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryRedelegationsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsResponse",
      value: QueryRedelegationsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorValidatorsRequest() {
  return {
    delegatorAddr: "",
    pagination: void 0
  };
}
const QueryDelegatorValidatorsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddr !== "" && n.uint32(10).string(e.delegatorAddr), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorValidatorsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddr = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorValidatorsRequest();
    return o.delegatorAddr = (n = e.delegatorAddr) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      delegatorAddr: e.delegator_addr,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_addr = e.delegatorAddr, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorValidatorsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorsRequest",
      value: QueryDelegatorValidatorsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorValidatorsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorValidatorsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsRequest",
      value: QueryDelegatorValidatorsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorValidatorsResponse() {
  return {
    validators: [],
    pagination: void 0
  };
}
const QueryDelegatorValidatorsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.validators)
      Validator.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorValidatorsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validators.push(Validator.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDelegatorValidatorsResponse();
    return o.validators = ((n = e.validators) === null || n === void 0 ? void 0 : n.map((u) => Validator.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      validators: Array.isArray(e == null ? void 0 : e.validators) ? e.validators.map((n) => Validator.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.validators ? n.validators = e.validators.map((o) => o ? Validator.toAmino(o) : void 0) : n.validators = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorValidatorsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorsResponse",
      value: QueryDelegatorValidatorsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorValidatorsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorValidatorsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsResponse",
      value: QueryDelegatorValidatorsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorValidatorRequest() {
  return {
    delegatorAddr: "",
    validatorAddr: ""
  };
}
const QueryDelegatorValidatorRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddr !== "" && n.uint32(10).string(e.delegatorAddr), e.validatorAddr !== "" && n.uint32(18).string(e.validatorAddr), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorValidatorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddr = o.string();
          break;
        case 2:
          c.validatorAddr = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryDelegatorValidatorRequest();
    return u.delegatorAddr = (n = e.delegatorAddr) !== null && n !== void 0 ? n : "", u.validatorAddr = (o = e.validatorAddr) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddr: e.delegator_addr,
      validatorAddr: e.validator_addr
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_addr = e.delegatorAddr, n.validator_addr = e.validatorAddr, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorValidatorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorRequest",
      value: QueryDelegatorValidatorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorValidatorRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorValidatorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorRequest",
      value: QueryDelegatorValidatorRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDelegatorValidatorResponse() {
  return {
    validator: void 0
  };
}
const QueryDelegatorValidatorResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.validator !== void 0 && Validator.encode(e.validator, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDelegatorValidatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validator = Validator.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDelegatorValidatorResponse();
    return n.validator = e.validator !== void 0 && e.validator !== null ? Validator.fromPartial(e.validator) : void 0, n;
  },
  fromAmino(e) {
    return {
      validator: e != null && e.validator ? Validator.fromAmino(e.validator) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator = e.validator ? Validator.toAmino(e.validator) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDelegatorValidatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorResponse",
      value: QueryDelegatorValidatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDelegatorValidatorResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDelegatorValidatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorResponse",
      value: QueryDelegatorValidatorResponse.encode(e).finish()
    };
  }
};
function createBaseQueryHistoricalInfoRequest() {
  return {
    height: Long$2.ZERO
  };
}
const QueryHistoricalInfoRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.height.isZero() || n.uint32(8).int64(e.height), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryHistoricalInfoRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryHistoricalInfoRequest();
    return n.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      height: Long$2.fromString(e.height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? e.height.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryHistoricalInfoRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryHistoricalInfoRequest",
      value: QueryHistoricalInfoRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryHistoricalInfoRequest.decode(e.value);
  },
  toProto(e) {
    return QueryHistoricalInfoRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoRequest",
      value: QueryHistoricalInfoRequest.encode(e).finish()
    };
  }
};
function createBaseQueryHistoricalInfoResponse() {
  return {
    hist: void 0
  };
}
const QueryHistoricalInfoResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.hist !== void 0 && HistoricalInfo.encode(e.hist, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryHistoricalInfoResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hist = HistoricalInfo.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryHistoricalInfoResponse();
    return n.hist = e.hist !== void 0 && e.hist !== null ? HistoricalInfo.fromPartial(e.hist) : void 0, n;
  },
  fromAmino(e) {
    return {
      hist: e != null && e.hist ? HistoricalInfo.fromAmino(e.hist) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.hist = e.hist ? HistoricalInfo.toAmino(e.hist) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryHistoricalInfoResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryHistoricalInfoResponse",
      value: QueryHistoricalInfoResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryHistoricalInfoResponse.decode(e.value);
  },
  toProto(e) {
    return QueryHistoricalInfoResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoResponse",
      value: QueryHistoricalInfoResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPoolRequest$1() {
  return {};
}
const QueryPoolRequest$1 = {
  typeUrl: "/cosmos.staking.v1beta1.QueryPoolRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryPoolRequest$1();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryPoolRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPoolRequest",
      value: QueryPoolRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryPoolRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryPoolRequest",
      value: QueryPoolRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryPoolResponse$1() {
  return {
    pool: void 0
  };
}
const QueryPoolResponse$1 = {
  typeUrl: "/cosmos.staking.v1beta1.QueryPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.pool !== void 0 && Pool$3.encode(e.pool, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pool = Pool$3.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryPoolResponse$1();
    return n.pool = e.pool !== void 0 && e.pool !== null ? Pool$3.fromPartial(e.pool) : void 0, n;
  },
  fromAmino(e) {
    return {
      pool: e != null && e.pool ? Pool$3.fromAmino(e.pool) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool = e.pool ? Pool$3.toAmino(e.pool) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPoolResponse",
      value: QueryPoolResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryPoolResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryPoolResponse",
      value: QueryPoolResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$a() {
  return {};
}
const QueryParamsRequest$a = {
  typeUrl: "/cosmos.staking.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$a();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$a();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$a.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest$a.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$a.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$a.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest$a.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$a() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$a = {
  typeUrl: "/cosmos.staking.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$h.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$a();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$h.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$a();
    return n.params = e.params !== void 0 && e.params !== null ? Params$h.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$h.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$h.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$a.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse$a.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$a.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$a.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse$a.encode(e).finish()
    };
  }
}, _39 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryDelegationRequest,
  QueryDelegationResponse,
  QueryDelegatorDelegationsRequest,
  QueryDelegatorDelegationsResponse,
  QueryDelegatorUnbondingDelegationsRequest,
  QueryDelegatorUnbondingDelegationsResponse,
  QueryDelegatorValidatorRequest,
  QueryDelegatorValidatorResponse,
  QueryDelegatorValidatorsRequest,
  QueryDelegatorValidatorsResponse,
  QueryHistoricalInfoRequest,
  QueryHistoricalInfoResponse,
  QueryParamsRequest: QueryParamsRequest$a,
  QueryParamsResponse: QueryParamsResponse$a,
  QueryPoolRequest: QueryPoolRequest$1,
  QueryPoolResponse: QueryPoolResponse$1,
  QueryRedelegationsRequest,
  QueryRedelegationsResponse,
  QueryUnbondingDelegationRequest,
  QueryUnbondingDelegationResponse,
  QueryValidatorDelegationsRequest,
  QueryValidatorDelegationsResponse,
  QueryValidatorRequest,
  QueryValidatorResponse,
  QueryValidatorUnbondingDelegationsRequest,
  QueryValidatorUnbondingDelegationsResponse,
  QueryValidatorsRequest,
  QueryValidatorsResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgCreateValidator() {
  return {
    description: void 0,
    commission: void 0,
    minSelfDelegation: "",
    delegatorAddress: "",
    validatorAddress: "",
    pubkey: void 0,
    value: void 0
  };
}
const MsgCreateValidator = {
  typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
  encode(e, n = minimal.Writer.create()) {
    return e.description !== void 0 && Description.encode(e.description, n.uint32(10).fork()).ldelim(), e.commission !== void 0 && CommissionRates.encode(e.commission, n.uint32(18).fork()).ldelim(), e.minSelfDelegation !== "" && n.uint32(26).string(e.minSelfDelegation), e.delegatorAddress !== "" && n.uint32(34).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(42).string(e.validatorAddress), e.pubkey !== void 0 && Any.encode(e.pubkey, n.uint32(50).fork()).ldelim(), e.value !== void 0 && Coin.encode(e.value, n.uint32(58).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateValidator();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.description = Description.decode(o, o.uint32());
          break;
        case 2:
          c.commission = CommissionRates.decode(o, o.uint32());
          break;
        case 3:
          c.minSelfDelegation = o.string();
          break;
        case 4:
          c.delegatorAddress = o.string();
          break;
        case 5:
          c.validatorAddress = o.string();
          break;
        case 6:
          c.pubkey = Cosmos_cryptoPubKey_InterfaceDecoder(o);
          break;
        case 7:
          c.value = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgCreateValidator();
    return c.description = e.description !== void 0 && e.description !== null ? Description.fromPartial(e.description) : void 0, c.commission = e.commission !== void 0 && e.commission !== null ? CommissionRates.fromPartial(e.commission) : void 0, c.minSelfDelegation = (n = e.minSelfDelegation) !== null && n !== void 0 ? n : "", c.delegatorAddress = (o = e.delegatorAddress) !== null && o !== void 0 ? o : "", c.validatorAddress = (u = e.validatorAddress) !== null && u !== void 0 ? u : "", c.pubkey = e.pubkey !== void 0 && e.pubkey !== null ? Any.fromPartial(e.pubkey) : void 0, c.value = e.value !== void 0 && e.value !== null ? Coin.fromPartial(e.value) : void 0, c;
  },
  fromAmino(e) {
    return {
      description: e != null && e.description ? Description.fromAmino(e.description) : void 0,
      commission: e != null && e.commission ? CommissionRates.fromAmino(e.commission) : void 0,
      minSelfDelegation: e.min_self_delegation,
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address,
      pubkey: build$9.encodeBech32Pubkey({
        type: "tendermint/PubKeySecp256k1",
        value: build$a.toBase64(e.pubkey.value)
      }, "cosmos"),
      value: e != null && e.value ? Coin.fromAmino(e.value) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.description = e.description ? Description.toAmino(e.description) : void 0, n.commission = e.commission ? CommissionRates.toAmino(e.commission) : void 0, n.min_self_delegation = e.minSelfDelegation, n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n.pubkey = e.pubkey ? {
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: build$a.fromBase64(build$9.decodeBech32Pubkey(e.pubkey).value)
    } : void 0, n.value = e.value ? Coin.toAmino(e.value) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgCreateValidator.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgCreateValidator",
      value: MsgCreateValidator.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateValidator.decode(e.value);
  },
  toProto(e) {
    return MsgCreateValidator.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
      value: MsgCreateValidator.encode(e).finish()
    };
  }
};
function createBaseMsgCreateValidatorResponse() {
  return {};
}
const MsgCreateValidatorResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidatorResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateValidatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgCreateValidatorResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgCreateValidatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgCreateValidatorResponse",
      value: MsgCreateValidatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateValidatorResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCreateValidatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidatorResponse",
      value: MsgCreateValidatorResponse.encode(e).finish()
    };
  }
};
function createBaseMsgEditValidator() {
  return {
    description: void 0,
    validatorAddress: "",
    commissionRate: "",
    minSelfDelegation: ""
  };
}
const MsgEditValidator = {
  typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
  encode(e, n = minimal.Writer.create()) {
    return e.description !== void 0 && Description.encode(e.description, n.uint32(10).fork()).ldelim(), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.commissionRate !== "" && n.uint32(26).string(e.commissionRate), e.minSelfDelegation !== "" && n.uint32(34).string(e.minSelfDelegation), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgEditValidator();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.description = Description.decode(o, o.uint32());
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        case 3:
          c.commissionRate = o.string();
          break;
        case 4:
          c.minSelfDelegation = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgEditValidator();
    return c.description = e.description !== void 0 && e.description !== null ? Description.fromPartial(e.description) : void 0, c.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", c.commissionRate = (o = e.commissionRate) !== null && o !== void 0 ? o : "", c.minSelfDelegation = (u = e.minSelfDelegation) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      description: e != null && e.description ? Description.fromAmino(e.description) : void 0,
      validatorAddress: e.validator_address,
      commissionRate: e.commission_rate,
      minSelfDelegation: e.min_self_delegation
    };
  },
  toAmino(e) {
    const n = {};
    return n.description = e.description ? Description.toAmino(e.description) : void 0, n.validator_address = e.validatorAddress, n.commission_rate = e.commissionRate, n.min_self_delegation = e.minSelfDelegation, n;
  },
  fromAminoMsg(e) {
    return MsgEditValidator.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgEditValidator",
      value: MsgEditValidator.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgEditValidator.decode(e.value);
  },
  toProto(e) {
    return MsgEditValidator.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
      value: MsgEditValidator.encode(e).finish()
    };
  }
};
function createBaseMsgEditValidatorResponse() {
  return {};
}
const MsgEditValidatorResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgEditValidatorResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgEditValidatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgEditValidatorResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgEditValidatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgEditValidatorResponse",
      value: MsgEditValidatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgEditValidatorResponse.decode(e.value);
  },
  toProto(e) {
    return MsgEditValidatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgEditValidatorResponse",
      value: MsgEditValidatorResponse.encode(e).finish()
    };
  }
};
function createBaseMsgDelegate() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    amount: void 0
  };
}
const MsgDelegate = {
  typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.amount !== void 0 && Coin.encode(e.amount, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDelegate();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        case 3:
          c.amount = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgDelegate();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", u.amount = e.amount !== void 0 && e.amount !== null ? Coin.fromPartial(e.amount) : void 0, u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address,
      amount: e != null && e.amount ? Coin.fromAmino(e.amount) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n.amount = e.amount ? Coin.toAmino(e.amount) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgDelegate.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgDelegate",
      value: MsgDelegate.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDelegate.decode(e.value);
  },
  toProto(e) {
    return MsgDelegate.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
      value: MsgDelegate.encode(e).finish()
    };
  }
};
function createBaseMsgDelegateResponse() {
  return {};
}
const MsgDelegateResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgDelegateResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDelegateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgDelegateResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgDelegateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgDelegateResponse",
      value: MsgDelegateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDelegateResponse.decode(e.value);
  },
  toProto(e) {
    return MsgDelegateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgDelegateResponse",
      value: MsgDelegateResponse.encode(e).finish()
    };
  }
};
function createBaseMsgBeginRedelegate() {
  return {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: "",
    amount: void 0
  };
}
const MsgBeginRedelegate = {
  typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorSrcAddress !== "" && n.uint32(18).string(e.validatorSrcAddress), e.validatorDstAddress !== "" && n.uint32(26).string(e.validatorDstAddress), e.amount !== void 0 && Coin.encode(e.amount, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgBeginRedelegate();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorSrcAddress = o.string();
          break;
        case 3:
          c.validatorDstAddress = o.string();
          break;
        case 4:
          c.amount = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgBeginRedelegate();
    return c.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", c.validatorSrcAddress = (o = e.validatorSrcAddress) !== null && o !== void 0 ? o : "", c.validatorDstAddress = (u = e.validatorDstAddress) !== null && u !== void 0 ? u : "", c.amount = e.amount !== void 0 && e.amount !== null ? Coin.fromPartial(e.amount) : void 0, c;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorSrcAddress: e.validator_src_address,
      validatorDstAddress: e.validator_dst_address,
      amount: e != null && e.amount ? Coin.fromAmino(e.amount) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_src_address = e.validatorSrcAddress, n.validator_dst_address = e.validatorDstAddress, n.amount = e.amount ? Coin.toAmino(e.amount) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgBeginRedelegate.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgBeginRedelegate",
      value: MsgBeginRedelegate.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgBeginRedelegate.decode(e.value);
  },
  toProto(e) {
    return MsgBeginRedelegate.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
      value: MsgBeginRedelegate.encode(e).finish()
    };
  }
};
function createBaseMsgBeginRedelegateResponse() {
  return {
    completionTime: void 0
  };
}
const MsgBeginRedelegateResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.completionTime !== void 0 && Timestamp.encode(toTimestamp(e.completionTime), n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgBeginRedelegateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.completionTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgBeginRedelegateResponse();
    return o.completionTime = (n = e.completionTime) !== null && n !== void 0 ? n : void 0, o;
  },
  fromAmino(e) {
    return {
      completionTime: e != null && e.completion_time ? Timestamp.fromAmino(e.completion_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.completion_time = e.completionTime ? Timestamp.toAmino(e.completionTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgBeginRedelegateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgBeginRedelegateResponse",
      value: MsgBeginRedelegateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgBeginRedelegateResponse.decode(e.value);
  },
  toProto(e) {
    return MsgBeginRedelegateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegateResponse",
      value: MsgBeginRedelegateResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUndelegate() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    amount: void 0
  };
}
const MsgUndelegate = {
  typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.amount !== void 0 && Coin.encode(e.amount, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUndelegate();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        case 3:
          c.amount = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgUndelegate();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", u.amount = e.amount !== void 0 && e.amount !== null ? Coin.fromPartial(e.amount) : void 0, u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address,
      amount: e != null && e.amount ? Coin.fromAmino(e.amount) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n.amount = e.amount ? Coin.toAmino(e.amount) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgUndelegate.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgUndelegate",
      value: MsgUndelegate.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUndelegate.decode(e.value);
  },
  toProto(e) {
    return MsgUndelegate.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
      value: MsgUndelegate.encode(e).finish()
    };
  }
};
function createBaseMsgUndelegateResponse() {
  return {
    completionTime: void 0
  };
}
const MsgUndelegateResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgUndelegateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.completionTime !== void 0 && Timestamp.encode(toTimestamp(e.completionTime), n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUndelegateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.completionTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgUndelegateResponse();
    return o.completionTime = (n = e.completionTime) !== null && n !== void 0 ? n : void 0, o;
  },
  fromAmino(e) {
    return {
      completionTime: e != null && e.completion_time ? Timestamp.fromAmino(e.completion_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.completion_time = e.completionTime ? Timestamp.toAmino(e.completionTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgUndelegateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgUndelegateResponse",
      value: MsgUndelegateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUndelegateResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUndelegateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgUndelegateResponse",
      value: MsgUndelegateResponse.encode(e).finish()
    };
  }
}, Cosmos_cryptoPubKey_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    default:
      return o;
  }
}, Cosmos_cryptoPubKey_FromAmino = (e) => build$9.encodeBech32Pubkey({
  type: "tendermint/PubKeySecp256k1",
  value: build$a.toBase64(e.value)
}, "cosmos"), Cosmos_cryptoPubKey_ToAmino = (e) => ({
  typeUrl: "/cosmos.crypto.secp256k1.PubKey",
  value: build$a.fromBase64(build$9.decodeBech32Pubkey(e).value)
}), _41 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Cosmos_cryptoPubKey_FromAmino,
  Cosmos_cryptoPubKey_InterfaceDecoder,
  Cosmos_cryptoPubKey_ToAmino,
  MsgBeginRedelegate,
  MsgBeginRedelegateResponse,
  MsgCreateValidator,
  MsgCreateValidatorResponse,
  MsgDelegate,
  MsgDelegateResponse,
  MsgEditValidator,
  MsgEditValidatorResponse,
  MsgUndelegate,
  MsgUndelegateResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseCompactBitArray() {
  return {
    extraBitsStored: 0,
    elems: new Uint8Array()
  };
}
const CompactBitArray = {
  typeUrl: "/cosmos.crypto.multisig.v1beta1.CompactBitArray",
  encode(e, n = minimal.Writer.create()) {
    return e.extraBitsStored !== 0 && n.uint32(8).uint32(e.extraBitsStored), e.elems.length !== 0 && n.uint32(18).bytes(e.elems), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompactBitArray();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.extraBitsStored = o.uint32();
          break;
        case 2:
          c.elems = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCompactBitArray();
    return u.extraBitsStored = (n = e.extraBitsStored) !== null && n !== void 0 ? n : 0, u.elems = (o = e.elems) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      extraBitsStored: e.extra_bits_stored,
      elems: e.elems
    };
  },
  toAmino(e) {
    const n = {};
    return n.extra_bits_stored = e.extraBitsStored, n.elems = e.elems, n;
  },
  fromAminoMsg(e) {
    return CompactBitArray.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CompactBitArray",
      value: CompactBitArray.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CompactBitArray.decode(e.value);
  },
  toProto(e) {
    return CompactBitArray.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.crypto.multisig.v1beta1.CompactBitArray",
      value: CompactBitArray.encode(e).finish()
    };
  }
};
let SignMode;
(function(e) {
  e[e.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", e[e.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", e[e.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", e[e.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", e[e.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(SignMode || (SignMode = {}));
const SignModeSDKType = SignMode, SignModeAmino = SignMode;
function signModeFromJSON(e) {
  switch (e) {
    case 0:
    case "SIGN_MODE_UNSPECIFIED":
      return SignMode.SIGN_MODE_UNSPECIFIED;
    case 1:
    case "SIGN_MODE_DIRECT":
      return SignMode.SIGN_MODE_DIRECT;
    case 2:
    case "SIGN_MODE_TEXTUAL":
      return SignMode.SIGN_MODE_TEXTUAL;
    case 127:
    case "SIGN_MODE_LEGACY_AMINO_JSON":
      return SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
    case 191:
    case "SIGN_MODE_EIP_191":
      return SignMode.SIGN_MODE_EIP_191;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SignMode.UNRECOGNIZED;
  }
}
function signModeToJSON(e) {
  switch (e) {
    case SignMode.SIGN_MODE_UNSPECIFIED:
      return "SIGN_MODE_UNSPECIFIED";
    case SignMode.SIGN_MODE_DIRECT:
      return "SIGN_MODE_DIRECT";
    case SignMode.SIGN_MODE_TEXTUAL:
      return "SIGN_MODE_TEXTUAL";
    case SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
      return "SIGN_MODE_LEGACY_AMINO_JSON";
    case SignMode.SIGN_MODE_EIP_191:
      return "SIGN_MODE_EIP_191";
    case SignMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseSignatureDescriptors() {
  return {
    signatures: []
  };
}
const SignatureDescriptors = {
  typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptors",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.signatures)
      SignatureDescriptor.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignatureDescriptors();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signatures.push(SignatureDescriptor.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSignatureDescriptors();
    return o.signatures = ((n = e.signatures) === null || n === void 0 ? void 0 : n.map((u) => SignatureDescriptor.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      signatures: Array.isArray(e == null ? void 0 : e.signatures) ? e.signatures.map((n) => SignatureDescriptor.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.signatures ? n.signatures = e.signatures.map((o) => o ? SignatureDescriptor.toAmino(o) : void 0) : n.signatures = [], n;
  },
  fromAminoMsg(e) {
    return SignatureDescriptors.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SignatureDescriptors",
      value: SignatureDescriptors.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignatureDescriptors.decode(e.value);
  },
  toProto(e) {
    return SignatureDescriptors.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptors",
      value: SignatureDescriptors.encode(e).finish()
    };
  }
};
function createBaseSignatureDescriptor() {
  return {
    publicKey: void 0,
    data: void 0,
    sequence: Long$2.UZERO
  };
}
const SignatureDescriptor = {
  typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.publicKey !== void 0 && Any.encode(e.publicKey, n.uint32(10).fork()).ldelim(), e.data !== void 0 && SignatureDescriptor_Data.encode(e.data, n.uint32(18).fork()).ldelim(), e.sequence.isZero() || n.uint32(24).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignatureDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.publicKey = Any.decode(o, o.uint32());
          break;
        case 2:
          c.data = SignatureDescriptor_Data.decode(o, o.uint32());
          break;
        case 3:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseSignatureDescriptor();
    return n.publicKey = e.publicKey !== void 0 && e.publicKey !== null ? Any.fromPartial(e.publicKey) : void 0, n.data = e.data !== void 0 && e.data !== null ? SignatureDescriptor_Data.fromPartial(e.data) : void 0, n.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      publicKey: e != null && e.public_key ? Any.fromAmino(e.public_key) : void 0,
      data: e != null && e.data ? SignatureDescriptor_Data.fromAmino(e.data) : void 0,
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.public_key = e.publicKey ? Any.toAmino(e.publicKey) : void 0, n.data = e.data ? SignatureDescriptor_Data.toAmino(e.data) : void 0, n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return SignatureDescriptor.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SignatureDescriptor",
      value: SignatureDescriptor.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignatureDescriptor.decode(e.value);
  },
  toProto(e) {
    return SignatureDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptor",
      value: SignatureDescriptor.encode(e).finish()
    };
  }
};
function createBaseSignatureDescriptor_Data() {
  return {
    single: void 0,
    multi: void 0
  };
}
const SignatureDescriptor_Data = {
  typeUrl: "/cosmos.tx.signing.v1beta1.Data",
  encode(e, n = minimal.Writer.create()) {
    return e.single !== void 0 && SignatureDescriptor_Data_Single.encode(e.single, n.uint32(10).fork()).ldelim(), e.multi !== void 0 && SignatureDescriptor_Data_Multi.encode(e.multi, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignatureDescriptor_Data();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.single = SignatureDescriptor_Data_Single.decode(o, o.uint32());
          break;
        case 2:
          c.multi = SignatureDescriptor_Data_Multi.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseSignatureDescriptor_Data();
    return n.single = e.single !== void 0 && e.single !== null ? SignatureDescriptor_Data_Single.fromPartial(e.single) : void 0, n.multi = e.multi !== void 0 && e.multi !== null ? SignatureDescriptor_Data_Multi.fromPartial(e.multi) : void 0, n;
  },
  fromAmino(e) {
    return {
      single: e != null && e.single ? SignatureDescriptor_Data_Single.fromAmino(e.single) : void 0,
      multi: e != null && e.multi ? SignatureDescriptor_Data_Multi.fromAmino(e.multi) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.single = e.single ? SignatureDescriptor_Data_Single.toAmino(e.single) : void 0, n.multi = e.multi ? SignatureDescriptor_Data_Multi.toAmino(e.multi) : void 0, n;
  },
  fromAminoMsg(e) {
    return SignatureDescriptor_Data.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Data",
      value: SignatureDescriptor_Data.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignatureDescriptor_Data.decode(e.value);
  },
  toProto(e) {
    return SignatureDescriptor_Data.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.Data",
      value: SignatureDescriptor_Data.encode(e).finish()
    };
  }
};
function createBaseSignatureDescriptor_Data_Single() {
  return {
    mode: 0,
    signature: new Uint8Array()
  };
}
const SignatureDescriptor_Data_Single = {
  typeUrl: "/cosmos.tx.signing.v1beta1.Single",
  encode(e, n = minimal.Writer.create()) {
    return e.mode !== 0 && n.uint32(8).int32(e.mode), e.signature.length !== 0 && n.uint32(18).bytes(e.signature), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignatureDescriptor_Data_Single();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.mode = o.int32();
          break;
        case 2:
          c.signature = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSignatureDescriptor_Data_Single();
    return u.mode = (n = e.mode) !== null && n !== void 0 ? n : 0, u.signature = (o = e.signature) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      mode: isSet(e.mode) ? signModeFromJSON(e.mode) : 0,
      signature: e.signature
    };
  },
  toAmino(e) {
    const n = {};
    return n.mode = e.mode, n.signature = e.signature, n;
  },
  fromAminoMsg(e) {
    return SignatureDescriptor_Data_Single.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Single",
      value: SignatureDescriptor_Data_Single.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignatureDescriptor_Data_Single.decode(e.value);
  },
  toProto(e) {
    return SignatureDescriptor_Data_Single.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.Single",
      value: SignatureDescriptor_Data_Single.encode(e).finish()
    };
  }
};
function createBaseSignatureDescriptor_Data_Multi() {
  return {
    bitarray: void 0,
    signatures: []
  };
}
const SignatureDescriptor_Data_Multi = {
  typeUrl: "/cosmos.tx.signing.v1beta1.Multi",
  encode(e, n = minimal.Writer.create()) {
    e.bitarray !== void 0 && CompactBitArray.encode(e.bitarray, n.uint32(10).fork()).ldelim();
    for (const o of e.signatures)
      SignatureDescriptor_Data.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignatureDescriptor_Data_Multi();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.bitarray = CompactBitArray.decode(o, o.uint32());
          break;
        case 2:
          c.signatures.push(SignatureDescriptor_Data.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSignatureDescriptor_Data_Multi();
    return o.bitarray = e.bitarray !== void 0 && e.bitarray !== null ? CompactBitArray.fromPartial(e.bitarray) : void 0, o.signatures = ((n = e.signatures) === null || n === void 0 ? void 0 : n.map((u) => SignatureDescriptor_Data.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      bitarray: e != null && e.bitarray ? CompactBitArray.fromAmino(e.bitarray) : void 0,
      signatures: Array.isArray(e == null ? void 0 : e.signatures) ? e.signatures.map((n) => SignatureDescriptor_Data.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.bitarray = e.bitarray ? CompactBitArray.toAmino(e.bitarray) : void 0, e.signatures ? n.signatures = e.signatures.map((o) => o ? SignatureDescriptor_Data.toAmino(o) : void 0) : n.signatures = [], n;
  },
  fromAminoMsg(e) {
    return SignatureDescriptor_Data_Multi.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Multi",
      value: SignatureDescriptor_Data_Multi.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignatureDescriptor_Data_Multi.decode(e.value);
  },
  toProto(e) {
    return SignatureDescriptor_Data_Multi.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.Multi",
      value: SignatureDescriptor_Data_Multi.encode(e).finish()
    };
  }
}, _42 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get SignMode() {
    return SignMode;
  },
  SignModeAmino,
  SignModeSDKType,
  SignatureDescriptor,
  SignatureDescriptor_Data,
  SignatureDescriptor_Data_Multi,
  SignatureDescriptor_Data_Single,
  SignatureDescriptors,
  signModeFromJSON,
  signModeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseTx() {
  return {
    body: void 0,
    authInfo: void 0,
    signatures: []
  };
}
const Tx = {
  typeUrl: "/cosmos.tx.v1beta1.Tx",
  encode(e, n = minimal.Writer.create()) {
    e.body !== void 0 && TxBody.encode(e.body, n.uint32(10).fork()).ldelim(), e.authInfo !== void 0 && AuthInfo.encode(e.authInfo, n.uint32(18).fork()).ldelim();
    for (const o of e.signatures)
      n.uint32(26).bytes(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTx();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.body = TxBody.decode(o, o.uint32());
          break;
        case 2:
          c.authInfo = AuthInfo.decode(o, o.uint32());
          break;
        case 3:
          c.signatures.push(o.bytes());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseTx();
    return o.body = e.body !== void 0 && e.body !== null ? TxBody.fromPartial(e.body) : void 0, o.authInfo = e.authInfo !== void 0 && e.authInfo !== null ? AuthInfo.fromPartial(e.authInfo) : void 0, o.signatures = ((n = e.signatures) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      body: e != null && e.body ? TxBody.fromAmino(e.body) : void 0,
      authInfo: e != null && e.auth_info ? AuthInfo.fromAmino(e.auth_info) : void 0,
      signatures: Array.isArray(e == null ? void 0 : e.signatures) ? e.signatures.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.body = e.body ? TxBody.toAmino(e.body) : void 0, n.auth_info = e.authInfo ? AuthInfo.toAmino(e.authInfo) : void 0, e.signatures ? n.signatures = e.signatures.map((o) => o) : n.signatures = [], n;
  },
  fromAminoMsg(e) {
    return Tx.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Tx",
      value: Tx.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Tx.decode(e.value);
  },
  toProto(e) {
    return Tx.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.Tx",
      value: Tx.encode(e).finish()
    };
  }
};
function createBaseTxRaw() {
  return {
    bodyBytes: new Uint8Array(),
    authInfoBytes: new Uint8Array(),
    signatures: []
  };
}
const TxRaw = {
  typeUrl: "/cosmos.tx.v1beta1.TxRaw",
  encode(e, n = minimal.Writer.create()) {
    e.bodyBytes.length !== 0 && n.uint32(10).bytes(e.bodyBytes), e.authInfoBytes.length !== 0 && n.uint32(18).bytes(e.authInfoBytes);
    for (const o of e.signatures)
      n.uint32(26).bytes(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTxRaw();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.bodyBytes = o.bytes();
          break;
        case 2:
          c.authInfoBytes = o.bytes();
          break;
        case 3:
          c.signatures.push(o.bytes());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseTxRaw();
    return c.bodyBytes = (n = e.bodyBytes) !== null && n !== void 0 ? n : new Uint8Array(), c.authInfoBytes = (o = e.authInfoBytes) !== null && o !== void 0 ? o : new Uint8Array(), c.signatures = ((u = e.signatures) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c;
  },
  fromAmino(e) {
    return {
      bodyBytes: e.body_bytes,
      authInfoBytes: e.auth_info_bytes,
      signatures: Array.isArray(e == null ? void 0 : e.signatures) ? e.signatures.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.body_bytes = e.bodyBytes, n.auth_info_bytes = e.authInfoBytes, e.signatures ? n.signatures = e.signatures.map((o) => o) : n.signatures = [], n;
  },
  fromAminoMsg(e) {
    return TxRaw.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TxRaw",
      value: TxRaw.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TxRaw.decode(e.value);
  },
  toProto(e) {
    return TxRaw.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.TxRaw",
      value: TxRaw.encode(e).finish()
    };
  }
};
function createBaseSignDoc() {
  return {
    bodyBytes: new Uint8Array(),
    authInfoBytes: new Uint8Array(),
    chainId: "",
    accountNumber: Long$2.UZERO
  };
}
const SignDoc = {
  typeUrl: "/cosmos.tx.v1beta1.SignDoc",
  encode(e, n = minimal.Writer.create()) {
    return e.bodyBytes.length !== 0 && n.uint32(10).bytes(e.bodyBytes), e.authInfoBytes.length !== 0 && n.uint32(18).bytes(e.authInfoBytes), e.chainId !== "" && n.uint32(26).string(e.chainId), e.accountNumber.isZero() || n.uint32(32).uint64(e.accountNumber), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignDoc();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.bodyBytes = o.bytes();
          break;
        case 2:
          c.authInfoBytes = o.bytes();
          break;
        case 3:
          c.chainId = o.string();
          break;
        case 4:
          c.accountNumber = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSignDoc();
    return c.bodyBytes = (n = e.bodyBytes) !== null && n !== void 0 ? n : new Uint8Array(), c.authInfoBytes = (o = e.authInfoBytes) !== null && o !== void 0 ? o : new Uint8Array(), c.chainId = (u = e.chainId) !== null && u !== void 0 ? u : "", c.accountNumber = e.accountNumber !== void 0 && e.accountNumber !== null ? Long$2.fromValue(e.accountNumber) : Long$2.UZERO, c;
  },
  fromAmino(e) {
    return {
      bodyBytes: e.body_bytes,
      authInfoBytes: e.auth_info_bytes,
      chainId: e.chain_id,
      accountNumber: Long$2.fromString(e.account_number)
    };
  },
  toAmino(e) {
    const n = {};
    return n.body_bytes = e.bodyBytes, n.auth_info_bytes = e.authInfoBytes, n.chain_id = e.chainId, n.account_number = e.accountNumber ? e.accountNumber.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return SignDoc.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SignDoc",
      value: SignDoc.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignDoc.decode(e.value);
  },
  toProto(e) {
    return SignDoc.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.SignDoc",
      value: SignDoc.encode(e).finish()
    };
  }
};
function createBaseTxBody() {
  return {
    messages: [],
    memo: "",
    timeoutHeight: Long$2.UZERO,
    extensionOptions: [],
    nonCriticalExtensionOptions: []
  };
}
const TxBody = {
  typeUrl: "/cosmos.tx.v1beta1.TxBody",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.messages)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    e.memo !== "" && n.uint32(18).string(e.memo), e.timeoutHeight.isZero() || n.uint32(24).uint64(e.timeoutHeight);
    for (const o of e.extensionOptions)
      Any.encode(o, n.uint32(8186).fork()).ldelim();
    for (const o of e.nonCriticalExtensionOptions)
      Any.encode(o, n.uint32(16378).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTxBody();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.messages.push(Any.decode(o, o.uint32()));
          break;
        case 2:
          c.memo = o.string();
          break;
        case 3:
          c.timeoutHeight = o.uint64();
          break;
        case 1023:
          c.extensionOptions.push(Any.decode(o, o.uint32()));
          break;
        case 2047:
          c.nonCriticalExtensionOptions.push(Any.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseTxBody();
    return d.messages = ((n = e.messages) === null || n === void 0 ? void 0 : n.map((m) => Any.fromPartial(m))) || [], d.memo = (o = e.memo) !== null && o !== void 0 ? o : "", d.timeoutHeight = e.timeoutHeight !== void 0 && e.timeoutHeight !== null ? Long$2.fromValue(e.timeoutHeight) : Long$2.UZERO, d.extensionOptions = ((u = e.extensionOptions) === null || u === void 0 ? void 0 : u.map((m) => Any.fromPartial(m))) || [], d.nonCriticalExtensionOptions = ((c = e.nonCriticalExtensionOptions) === null || c === void 0 ? void 0 : c.map((m) => Any.fromPartial(m))) || [], d;
  },
  fromAmino(e) {
    return {
      messages: Array.isArray(e == null ? void 0 : e.messages) ? e.messages.map((n) => Any.fromAmino(n)) : [],
      memo: e.memo,
      timeoutHeight: Long$2.fromString(e.timeout_height),
      extensionOptions: Array.isArray(e == null ? void 0 : e.extension_options) ? e.extension_options.map((n) => Any.fromAmino(n)) : [],
      nonCriticalExtensionOptions: Array.isArray(e == null ? void 0 : e.non_critical_extension_options) ? e.non_critical_extension_options.map((n) => Any.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.messages ? n.messages = e.messages.map((o) => o ? Any.toAmino(o) : void 0) : n.messages = [], n.memo = e.memo, n.timeout_height = e.timeoutHeight ? e.timeoutHeight.toString() : void 0, e.extensionOptions ? n.extension_options = e.extensionOptions.map((o) => o ? Any.toAmino(o) : void 0) : n.extension_options = [], e.nonCriticalExtensionOptions ? n.non_critical_extension_options = e.nonCriticalExtensionOptions.map((o) => o ? Any.toAmino(o) : void 0) : n.non_critical_extension_options = [], n;
  },
  fromAminoMsg(e) {
    return TxBody.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TxBody",
      value: TxBody.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TxBody.decode(e.value);
  },
  toProto(e) {
    return TxBody.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: TxBody.encode(e).finish()
    };
  }
};
function createBaseAuthInfo() {
  return {
    signerInfos: [],
    fee: void 0
  };
}
const AuthInfo = {
  typeUrl: "/cosmos.tx.v1beta1.AuthInfo",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.signerInfos)
      SignerInfo.encode(o, n.uint32(10).fork()).ldelim();
    return e.fee !== void 0 && Fee$1.encode(e.fee, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAuthInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signerInfos.push(SignerInfo.decode(o, o.uint32()));
          break;
        case 2:
          c.fee = Fee$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAuthInfo();
    return o.signerInfos = ((n = e.signerInfos) === null || n === void 0 ? void 0 : n.map((u) => SignerInfo.fromPartial(u))) || [], o.fee = e.fee !== void 0 && e.fee !== null ? Fee$1.fromPartial(e.fee) : void 0, o;
  },
  fromAmino(e) {
    return {
      signerInfos: Array.isArray(e == null ? void 0 : e.signer_infos) ? e.signer_infos.map((n) => SignerInfo.fromAmino(n)) : [],
      fee: e != null && e.fee ? Fee$1.fromAmino(e.fee) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.signerInfos ? n.signer_infos = e.signerInfos.map((o) => o ? SignerInfo.toAmino(o) : void 0) : n.signer_infos = [], n.fee = e.fee ? Fee$1.toAmino(e.fee) : void 0, n;
  },
  fromAminoMsg(e) {
    return AuthInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/AuthInfo",
      value: AuthInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AuthInfo.decode(e.value);
  },
  toProto(e) {
    return AuthInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.AuthInfo",
      value: AuthInfo.encode(e).finish()
    };
  }
};
function createBaseSignerInfo() {
  return {
    publicKey: void 0,
    modeInfo: void 0,
    sequence: Long$2.UZERO
  };
}
const SignerInfo = {
  typeUrl: "/cosmos.tx.v1beta1.SignerInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.publicKey !== void 0 && Any.encode(e.publicKey, n.uint32(10).fork()).ldelim(), e.modeInfo !== void 0 && ModeInfo.encode(e.modeInfo, n.uint32(18).fork()).ldelim(), e.sequence.isZero() || n.uint32(24).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignerInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.publicKey = Any.decode(o, o.uint32());
          break;
        case 2:
          c.modeInfo = ModeInfo.decode(o, o.uint32());
          break;
        case 3:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseSignerInfo();
    return n.publicKey = e.publicKey !== void 0 && e.publicKey !== null ? Any.fromPartial(e.publicKey) : void 0, n.modeInfo = e.modeInfo !== void 0 && e.modeInfo !== null ? ModeInfo.fromPartial(e.modeInfo) : void 0, n.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      publicKey: e != null && e.public_key ? Any.fromAmino(e.public_key) : void 0,
      modeInfo: e != null && e.mode_info ? ModeInfo.fromAmino(e.mode_info) : void 0,
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.public_key = e.publicKey ? Any.toAmino(e.publicKey) : void 0, n.mode_info = e.modeInfo ? ModeInfo.toAmino(e.modeInfo) : void 0, n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return SignerInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SignerInfo",
      value: SignerInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignerInfo.decode(e.value);
  },
  toProto(e) {
    return SignerInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.SignerInfo",
      value: SignerInfo.encode(e).finish()
    };
  }
};
function createBaseModeInfo() {
  return {
    single: void 0,
    multi: void 0
  };
}
const ModeInfo = {
  typeUrl: "/cosmos.tx.v1beta1.ModeInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.single !== void 0 && ModeInfo_Single.encode(e.single, n.uint32(10).fork()).ldelim(), e.multi !== void 0 && ModeInfo_Multi.encode(e.multi, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModeInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.single = ModeInfo_Single.decode(o, o.uint32());
          break;
        case 2:
          c.multi = ModeInfo_Multi.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseModeInfo();
    return n.single = e.single !== void 0 && e.single !== null ? ModeInfo_Single.fromPartial(e.single) : void 0, n.multi = e.multi !== void 0 && e.multi !== null ? ModeInfo_Multi.fromPartial(e.multi) : void 0, n;
  },
  fromAmino(e) {
    return {
      single: e != null && e.single ? ModeInfo_Single.fromAmino(e.single) : void 0,
      multi: e != null && e.multi ? ModeInfo_Multi.fromAmino(e.multi) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.single = e.single ? ModeInfo_Single.toAmino(e.single) : void 0, n.multi = e.multi ? ModeInfo_Multi.toAmino(e.multi) : void 0, n;
  },
  fromAminoMsg(e) {
    return ModeInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ModeInfo",
      value: ModeInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModeInfo.decode(e.value);
  },
  toProto(e) {
    return ModeInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.ModeInfo",
      value: ModeInfo.encode(e).finish()
    };
  }
};
function createBaseModeInfo_Single() {
  return {
    mode: 0
  };
}
const ModeInfo_Single = {
  typeUrl: "/cosmos.tx.v1beta1.Single",
  encode(e, n = minimal.Writer.create()) {
    return e.mode !== 0 && n.uint32(8).int32(e.mode), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModeInfo_Single();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.mode = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseModeInfo_Single();
    return o.mode = (n = e.mode) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      mode: isSet(e.mode) ? signModeFromJSON(e.mode) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.mode = e.mode, n;
  },
  fromAminoMsg(e) {
    return ModeInfo_Single.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Single",
      value: ModeInfo_Single.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModeInfo_Single.decode(e.value);
  },
  toProto(e) {
    return ModeInfo_Single.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.Single",
      value: ModeInfo_Single.encode(e).finish()
    };
  }
};
function createBaseModeInfo_Multi() {
  return {
    bitarray: void 0,
    modeInfos: []
  };
}
const ModeInfo_Multi = {
  typeUrl: "/cosmos.tx.v1beta1.Multi",
  encode(e, n = minimal.Writer.create()) {
    e.bitarray !== void 0 && CompactBitArray.encode(e.bitarray, n.uint32(10).fork()).ldelim();
    for (const o of e.modeInfos)
      ModeInfo.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModeInfo_Multi();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.bitarray = CompactBitArray.decode(o, o.uint32());
          break;
        case 2:
          c.modeInfos.push(ModeInfo.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseModeInfo_Multi();
    return o.bitarray = e.bitarray !== void 0 && e.bitarray !== null ? CompactBitArray.fromPartial(e.bitarray) : void 0, o.modeInfos = ((n = e.modeInfos) === null || n === void 0 ? void 0 : n.map((u) => ModeInfo.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      bitarray: e != null && e.bitarray ? CompactBitArray.fromAmino(e.bitarray) : void 0,
      modeInfos: Array.isArray(e == null ? void 0 : e.mode_infos) ? e.mode_infos.map((n) => ModeInfo.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.bitarray = e.bitarray ? CompactBitArray.toAmino(e.bitarray) : void 0, e.modeInfos ? n.mode_infos = e.modeInfos.map((o) => o ? ModeInfo.toAmino(o) : void 0) : n.mode_infos = [], n;
  },
  fromAminoMsg(e) {
    return ModeInfo_Multi.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Multi",
      value: ModeInfo_Multi.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModeInfo_Multi.decode(e.value);
  },
  toProto(e) {
    return ModeInfo_Multi.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.Multi",
      value: ModeInfo_Multi.encode(e).finish()
    };
  }
};
function createBaseFee$1() {
  return {
    amount: [],
    gasLimit: Long$2.UZERO,
    payer: "",
    granter: ""
  };
}
const Fee$1 = {
  typeUrl: "/cosmos.tx.v1beta1.Fee",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.amount)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return e.gasLimit.isZero() || n.uint32(16).uint64(e.gasLimit), e.payer !== "" && n.uint32(26).string(e.payer), e.granter !== "" && n.uint32(34).string(e.granter), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFee$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.gasLimit = o.uint64();
          break;
        case 3:
          c.payer = o.string();
          break;
        case 4:
          c.granter = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseFee$1();
    return c.amount = ((n = e.amount) === null || n === void 0 ? void 0 : n.map((d) => Coin.fromPartial(d))) || [], c.gasLimit = e.gasLimit !== void 0 && e.gasLimit !== null ? Long$2.fromValue(e.gasLimit) : Long$2.UZERO, c.payer = (o = e.payer) !== null && o !== void 0 ? o : "", c.granter = (u = e.granter) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : [],
      gasLimit: Long$2.fromString(e.gas_limit),
      payer: e.payer,
      granter: e.granter
    };
  },
  toAmino(e) {
    const n = {};
    return e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n.gas_limit = e.gasLimit ? e.gasLimit.toString() : void 0, n.payer = e.payer, n.granter = e.granter, n;
  },
  fromAminoMsg(e) {
    return Fee$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Fee",
      value: Fee$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Fee$1.decode(e.value);
  },
  toProto(e) {
    return Fee$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.Fee",
      value: Fee$1.encode(e).finish()
    };
  }
}, _44 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AuthInfo,
  Fee: Fee$1,
  ModeInfo,
  ModeInfo_Multi,
  ModeInfo_Single,
  SignDoc,
  SignerInfo,
  Tx,
  TxBody,
  TxRaw
}, Symbol.toStringTag, { value: "Module" }));
let OrderBy;
(function(e) {
  e[e.ORDER_BY_UNSPECIFIED = 0] = "ORDER_BY_UNSPECIFIED", e[e.ORDER_BY_ASC = 1] = "ORDER_BY_ASC", e[e.ORDER_BY_DESC = 2] = "ORDER_BY_DESC", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(OrderBy || (OrderBy = {}));
const OrderBySDKType = OrderBy, OrderByAmino = OrderBy;
function orderByFromJSON(e) {
  switch (e) {
    case 0:
    case "ORDER_BY_UNSPECIFIED":
      return OrderBy.ORDER_BY_UNSPECIFIED;
    case 1:
    case "ORDER_BY_ASC":
      return OrderBy.ORDER_BY_ASC;
    case 2:
    case "ORDER_BY_DESC":
      return OrderBy.ORDER_BY_DESC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrderBy.UNRECOGNIZED;
  }
}
function orderByToJSON(e) {
  switch (e) {
    case OrderBy.ORDER_BY_UNSPECIFIED:
      return "ORDER_BY_UNSPECIFIED";
    case OrderBy.ORDER_BY_ASC:
      return "ORDER_BY_ASC";
    case OrderBy.ORDER_BY_DESC:
      return "ORDER_BY_DESC";
    case OrderBy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let BroadcastMode;
(function(e) {
  e[e.BROADCAST_MODE_UNSPECIFIED = 0] = "BROADCAST_MODE_UNSPECIFIED", e[e.BROADCAST_MODE_BLOCK = 1] = "BROADCAST_MODE_BLOCK", e[e.BROADCAST_MODE_SYNC = 2] = "BROADCAST_MODE_SYNC", e[e.BROADCAST_MODE_ASYNC = 3] = "BROADCAST_MODE_ASYNC", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(BroadcastMode || (BroadcastMode = {}));
const BroadcastModeSDKType = BroadcastMode, BroadcastModeAmino = BroadcastMode;
function broadcastModeFromJSON(e) {
  switch (e) {
    case 0:
    case "BROADCAST_MODE_UNSPECIFIED":
      return BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
    case 1:
    case "BROADCAST_MODE_BLOCK":
      return BroadcastMode.BROADCAST_MODE_BLOCK;
    case 2:
    case "BROADCAST_MODE_SYNC":
      return BroadcastMode.BROADCAST_MODE_SYNC;
    case 3:
    case "BROADCAST_MODE_ASYNC":
      return BroadcastMode.BROADCAST_MODE_ASYNC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BroadcastMode.UNRECOGNIZED;
  }
}
function broadcastModeToJSON(e) {
  switch (e) {
    case BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
      return "BROADCAST_MODE_UNSPECIFIED";
    case BroadcastMode.BROADCAST_MODE_BLOCK:
      return "BROADCAST_MODE_BLOCK";
    case BroadcastMode.BROADCAST_MODE_SYNC:
      return "BROADCAST_MODE_SYNC";
    case BroadcastMode.BROADCAST_MODE_ASYNC:
      return "BROADCAST_MODE_ASYNC";
    case BroadcastMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseGetTxsEventRequest() {
  return {
    events: [],
    pagination: void 0,
    orderBy: 0
  };
}
const GetTxsEventRequest = {
  typeUrl: "/cosmos.tx.v1beta1.GetTxsEventRequest",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.events)
      n.uint32(10).string(o);
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), e.orderBy !== 0 && n.uint32(24).int32(e.orderBy), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetTxsEventRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.events.push(o.string());
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        case 3:
          c.orderBy = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGetTxsEventRequest();
    return u.events = ((n = e.events) === null || n === void 0 ? void 0 : n.map((c) => c)) || [], u.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, u.orderBy = (o = e.orderBy) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      events: Array.isArray(e == null ? void 0 : e.events) ? e.events.map((n) => n) : [],
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0,
      orderBy: isSet(e.order_by) ? orderByFromJSON(e.order_by) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.events ? n.events = e.events.map((o) => o) : n.events = [], n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n.order_by = e.orderBy, n;
  },
  fromAminoMsg(e) {
    return GetTxsEventRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetTxsEventRequest",
      value: GetTxsEventRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetTxsEventRequest.decode(e.value);
  },
  toProto(e) {
    return GetTxsEventRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.GetTxsEventRequest",
      value: GetTxsEventRequest.encode(e).finish()
    };
  }
};
function createBaseGetTxsEventResponse() {
  return {
    txs: [],
    txResponses: [],
    pagination: void 0
  };
}
const GetTxsEventResponse = {
  typeUrl: "/cosmos.tx.v1beta1.GetTxsEventResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.txs)
      Tx.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.txResponses)
      TxResponse.encode(o, n.uint32(18).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetTxsEventResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.txs.push(Tx.decode(o, o.uint32()));
          break;
        case 2:
          c.txResponses.push(TxResponse.decode(o, o.uint32()));
          break;
        case 3:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGetTxsEventResponse();
    return u.txs = ((n = e.txs) === null || n === void 0 ? void 0 : n.map((c) => Tx.fromPartial(c))) || [], u.txResponses = ((o = e.txResponses) === null || o === void 0 ? void 0 : o.map((c) => TxResponse.fromPartial(c))) || [], u.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, u;
  },
  fromAmino(e) {
    return {
      txs: Array.isArray(e == null ? void 0 : e.txs) ? e.txs.map((n) => Tx.fromAmino(n)) : [],
      txResponses: Array.isArray(e == null ? void 0 : e.tx_responses) ? e.tx_responses.map((n) => TxResponse.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.txs ? n.txs = e.txs.map((o) => o ? Tx.toAmino(o) : void 0) : n.txs = [], e.txResponses ? n.tx_responses = e.txResponses.map((o) => o ? TxResponse.toAmino(o) : void 0) : n.tx_responses = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return GetTxsEventResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetTxsEventResponse",
      value: GetTxsEventResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetTxsEventResponse.decode(e.value);
  },
  toProto(e) {
    return GetTxsEventResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.GetTxsEventResponse",
      value: GetTxsEventResponse.encode(e).finish()
    };
  }
};
function createBaseBroadcastTxRequest() {
  return {
    txBytes: new Uint8Array(),
    mode: 0
  };
}
const BroadcastTxRequest = {
  typeUrl: "/cosmos.tx.v1beta1.BroadcastTxRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.txBytes.length !== 0 && n.uint32(10).bytes(e.txBytes), e.mode !== 0 && n.uint32(16).int32(e.mode), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBroadcastTxRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.txBytes = o.bytes();
          break;
        case 2:
          c.mode = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseBroadcastTxRequest();
    return u.txBytes = (n = e.txBytes) !== null && n !== void 0 ? n : new Uint8Array(), u.mode = (o = e.mode) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      txBytes: e.tx_bytes,
      mode: isSet(e.mode) ? broadcastModeFromJSON(e.mode) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.tx_bytes = e.txBytes, n.mode = e.mode, n;
  },
  fromAminoMsg(e) {
    return BroadcastTxRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/BroadcastTxRequest",
      value: BroadcastTxRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return BroadcastTxRequest.decode(e.value);
  },
  toProto(e) {
    return BroadcastTxRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.BroadcastTxRequest",
      value: BroadcastTxRequest.encode(e).finish()
    };
  }
};
function createBaseBroadcastTxResponse() {
  return {
    txResponse: void 0
  };
}
const BroadcastTxResponse = {
  typeUrl: "/cosmos.tx.v1beta1.BroadcastTxResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.txResponse !== void 0 && TxResponse.encode(e.txResponse, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBroadcastTxResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.txResponse = TxResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseBroadcastTxResponse();
    return n.txResponse = e.txResponse !== void 0 && e.txResponse !== null ? TxResponse.fromPartial(e.txResponse) : void 0, n;
  },
  fromAmino(e) {
    return {
      txResponse: e != null && e.tx_response ? TxResponse.fromAmino(e.tx_response) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.tx_response = e.txResponse ? TxResponse.toAmino(e.txResponse) : void 0, n;
  },
  fromAminoMsg(e) {
    return BroadcastTxResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/BroadcastTxResponse",
      value: BroadcastTxResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return BroadcastTxResponse.decode(e.value);
  },
  toProto(e) {
    return BroadcastTxResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.BroadcastTxResponse",
      value: BroadcastTxResponse.encode(e).finish()
    };
  }
};
function createBaseSimulateRequest() {
  return {
    tx: void 0,
    txBytes: new Uint8Array()
  };
}
const SimulateRequest = {
  typeUrl: "/cosmos.tx.v1beta1.SimulateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.tx !== void 0 && Tx.encode(e.tx, n.uint32(10).fork()).ldelim(), e.txBytes.length !== 0 && n.uint32(18).bytes(e.txBytes), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSimulateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tx = Tx.decode(o, o.uint32());
          break;
        case 2:
          c.txBytes = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSimulateRequest();
    return o.tx = e.tx !== void 0 && e.tx !== null ? Tx.fromPartial(e.tx) : void 0, o.txBytes = (n = e.txBytes) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      tx: e != null && e.tx ? Tx.fromAmino(e.tx) : void 0,
      txBytes: e.tx_bytes
    };
  },
  toAmino(e) {
    const n = {};
    return n.tx = e.tx ? Tx.toAmino(e.tx) : void 0, n.tx_bytes = e.txBytes, n;
  },
  fromAminoMsg(e) {
    return SimulateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SimulateRequest",
      value: SimulateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SimulateRequest.decode(e.value);
  },
  toProto(e) {
    return SimulateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.SimulateRequest",
      value: SimulateRequest.encode(e).finish()
    };
  }
};
function createBaseSimulateResponse() {
  return {
    gasInfo: void 0,
    result: void 0
  };
}
const SimulateResponse = {
  typeUrl: "/cosmos.tx.v1beta1.SimulateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.gasInfo !== void 0 && GasInfo.encode(e.gasInfo, n.uint32(10).fork()).ldelim(), e.result !== void 0 && Result.encode(e.result, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSimulateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.gasInfo = GasInfo.decode(o, o.uint32());
          break;
        case 2:
          c.result = Result.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseSimulateResponse();
    return n.gasInfo = e.gasInfo !== void 0 && e.gasInfo !== null ? GasInfo.fromPartial(e.gasInfo) : void 0, n.result = e.result !== void 0 && e.result !== null ? Result.fromPartial(e.result) : void 0, n;
  },
  fromAmino(e) {
    return {
      gasInfo: e != null && e.gas_info ? GasInfo.fromAmino(e.gas_info) : void 0,
      result: e != null && e.result ? Result.fromAmino(e.result) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.gas_info = e.gasInfo ? GasInfo.toAmino(e.gasInfo) : void 0, n.result = e.result ? Result.toAmino(e.result) : void 0, n;
  },
  fromAminoMsg(e) {
    return SimulateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SimulateResponse",
      value: SimulateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SimulateResponse.decode(e.value);
  },
  toProto(e) {
    return SimulateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.SimulateResponse",
      value: SimulateResponse.encode(e).finish()
    };
  }
};
function createBaseGetTxRequest() {
  return {
    hash: ""
  };
}
const GetTxRequest = {
  typeUrl: "/cosmos.tx.v1beta1.GetTxRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.hash !== "" && n.uint32(10).string(e.hash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetTxRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGetTxRequest();
    return o.hash = (n = e.hash) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      hash: e.hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n;
  },
  fromAminoMsg(e) {
    return GetTxRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetTxRequest",
      value: GetTxRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetTxRequest.decode(e.value);
  },
  toProto(e) {
    return GetTxRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.GetTxRequest",
      value: GetTxRequest.encode(e).finish()
    };
  }
};
function createBaseGetTxResponse() {
  return {
    tx: void 0,
    txResponse: void 0
  };
}
const GetTxResponse = {
  typeUrl: "/cosmos.tx.v1beta1.GetTxResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tx !== void 0 && Tx.encode(e.tx, n.uint32(10).fork()).ldelim(), e.txResponse !== void 0 && TxResponse.encode(e.txResponse, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGetTxResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tx = Tx.decode(o, o.uint32());
          break;
        case 2:
          c.txResponse = TxResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGetTxResponse();
    return n.tx = e.tx !== void 0 && e.tx !== null ? Tx.fromPartial(e.tx) : void 0, n.txResponse = e.txResponse !== void 0 && e.txResponse !== null ? TxResponse.fromPartial(e.txResponse) : void 0, n;
  },
  fromAmino(e) {
    return {
      tx: e != null && e.tx ? Tx.fromAmino(e.tx) : void 0,
      txResponse: e != null && e.tx_response ? TxResponse.fromAmino(e.tx_response) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.tx = e.tx ? Tx.toAmino(e.tx) : void 0, n.tx_response = e.txResponse ? TxResponse.toAmino(e.txResponse) : void 0, n;
  },
  fromAminoMsg(e) {
    return GetTxResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GetTxResponse",
      value: GetTxResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GetTxResponse.decode(e.value);
  },
  toProto(e) {
    return GetTxResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.GetTxResponse",
      value: GetTxResponse.encode(e).finish()
    };
  }
}, _43 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get BroadcastMode() {
    return BroadcastMode;
  },
  BroadcastModeAmino,
  BroadcastModeSDKType,
  BroadcastTxRequest,
  BroadcastTxResponse,
  GetTxRequest,
  GetTxResponse,
  GetTxsEventRequest,
  GetTxsEventResponse,
  get OrderBy() {
    return OrderBy;
  },
  OrderByAmino,
  OrderBySDKType,
  SimulateRequest,
  SimulateResponse,
  broadcastModeFromJSON,
  broadcastModeToJSON,
  orderByFromJSON,
  orderByToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryCurrentPlanRequest() {
  return {};
}
const QueryCurrentPlanRequest = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryCurrentPlanRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCurrentPlanRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryCurrentPlanRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryCurrentPlanRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryCurrentPlanRequest",
      value: QueryCurrentPlanRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCurrentPlanRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCurrentPlanRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryCurrentPlanRequest",
      value: QueryCurrentPlanRequest.encode(e).finish()
    };
  }
};
function createBaseQueryCurrentPlanResponse() {
  return {
    plan: void 0
  };
}
const QueryCurrentPlanResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryCurrentPlanResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.plan !== void 0 && Plan.encode(e.plan, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCurrentPlanResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.plan = Plan.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryCurrentPlanResponse();
    return n.plan = e.plan !== void 0 && e.plan !== null ? Plan.fromPartial(e.plan) : void 0, n;
  },
  fromAmino(e) {
    return {
      plan: e != null && e.plan ? Plan.fromAmino(e.plan) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.plan = e.plan ? Plan.toAmino(e.plan) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryCurrentPlanResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryCurrentPlanResponse",
      value: QueryCurrentPlanResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCurrentPlanResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCurrentPlanResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryCurrentPlanResponse",
      value: QueryCurrentPlanResponse.encode(e).finish()
    };
  }
};
function createBaseQueryAppliedPlanRequest() {
  return {
    name: ""
  };
}
const QueryAppliedPlanRequest = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryAppliedPlanRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAppliedPlanRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryAppliedPlanRequest();
    return o.name = (n = e.name) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      name: e.name
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n;
  },
  fromAminoMsg(e) {
    return QueryAppliedPlanRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryAppliedPlanRequest",
      value: QueryAppliedPlanRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAppliedPlanRequest.decode(e.value);
  },
  toProto(e) {
    return QueryAppliedPlanRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryAppliedPlanRequest",
      value: QueryAppliedPlanRequest.encode(e).finish()
    };
  }
};
function createBaseQueryAppliedPlanResponse() {
  return {
    height: Long$2.ZERO
  };
}
const QueryAppliedPlanResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryAppliedPlanResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.height.isZero() || n.uint32(8).int64(e.height), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAppliedPlanResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.height = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryAppliedPlanResponse();
    return n.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      height: Long$2.fromString(e.height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.height = e.height ? e.height.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryAppliedPlanResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryAppliedPlanResponse",
      value: QueryAppliedPlanResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAppliedPlanResponse.decode(e.value);
  },
  toProto(e) {
    return QueryAppliedPlanResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryAppliedPlanResponse",
      value: QueryAppliedPlanResponse.encode(e).finish()
    };
  }
};
function createBaseQueryUpgradedConsensusStateRequest$1() {
  return {
    lastHeight: Long$2.ZERO
  };
}
const QueryUpgradedConsensusStateRequest$1 = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryUpgradedConsensusStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.lastHeight.isZero() || n.uint32(8).int64(e.lastHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUpgradedConsensusStateRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lastHeight = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryUpgradedConsensusStateRequest$1();
    return n.lastHeight = e.lastHeight !== void 0 && e.lastHeight !== null ? Long$2.fromValue(e.lastHeight) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      lastHeight: Long$2.fromString(e.last_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.last_height = e.lastHeight ? e.lastHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryUpgradedConsensusStateRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUpgradedConsensusStateRequest",
      value: QueryUpgradedConsensusStateRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUpgradedConsensusStateRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryUpgradedConsensusStateRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryUpgradedConsensusStateRequest",
      value: QueryUpgradedConsensusStateRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryUpgradedConsensusStateResponse$1() {
  return {
    upgradedConsensusState: new Uint8Array()
  };
}
const QueryUpgradedConsensusStateResponse$1 = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryUpgradedConsensusStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.upgradedConsensusState.length !== 0 && n.uint32(18).bytes(e.upgradedConsensusState), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUpgradedConsensusStateResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.upgradedConsensusState = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryUpgradedConsensusStateResponse$1();
    return o.upgradedConsensusState = (n = e.upgradedConsensusState) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      upgradedConsensusState: e.upgraded_consensus_state
    };
  },
  toAmino(e) {
    const n = {};
    return n.upgraded_consensus_state = e.upgradedConsensusState, n;
  },
  fromAminoMsg(e) {
    return QueryUpgradedConsensusStateResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUpgradedConsensusStateResponse",
      value: QueryUpgradedConsensusStateResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUpgradedConsensusStateResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryUpgradedConsensusStateResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryUpgradedConsensusStateResponse",
      value: QueryUpgradedConsensusStateResponse$1.encode(e).finish()
    };
  }
};
function createBaseQueryModuleVersionsRequest() {
  return {
    moduleName: ""
  };
}
const QueryModuleVersionsRequest = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryModuleVersionsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.moduleName !== "" && n.uint32(10).string(e.moduleName), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryModuleVersionsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.moduleName = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryModuleVersionsRequest();
    return o.moduleName = (n = e.moduleName) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      moduleName: e.module_name
    };
  },
  toAmino(e) {
    const n = {};
    return n.module_name = e.moduleName, n;
  },
  fromAminoMsg(e) {
    return QueryModuleVersionsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryModuleVersionsRequest",
      value: QueryModuleVersionsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryModuleVersionsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryModuleVersionsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryModuleVersionsRequest",
      value: QueryModuleVersionsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryModuleVersionsResponse() {
  return {
    moduleVersions: []
  };
}
const QueryModuleVersionsResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryModuleVersionsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.moduleVersions)
      ModuleVersion.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryModuleVersionsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.moduleVersions.push(ModuleVersion.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryModuleVersionsResponse();
    return o.moduleVersions = ((n = e.moduleVersions) === null || n === void 0 ? void 0 : n.map((u) => ModuleVersion.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      moduleVersions: Array.isArray(e == null ? void 0 : e.module_versions) ? e.module_versions.map((n) => ModuleVersion.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.moduleVersions ? n.module_versions = e.moduleVersions.map((o) => o ? ModuleVersion.toAmino(o) : void 0) : n.module_versions = [], n;
  },
  fromAminoMsg(e) {
    return QueryModuleVersionsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryModuleVersionsResponse",
      value: QueryModuleVersionsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryModuleVersionsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryModuleVersionsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryModuleVersionsResponse",
      value: QueryModuleVersionsResponse.encode(e).finish()
    };
  }
}, _45 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryAppliedPlanRequest,
  QueryAppliedPlanResponse,
  QueryCurrentPlanRequest,
  QueryCurrentPlanResponse,
  QueryModuleVersionsRequest,
  QueryModuleVersionsResponse,
  QueryUpgradedConsensusStateRequest: QueryUpgradedConsensusStateRequest$1,
  QueryUpgradedConsensusStateResponse: QueryUpgradedConsensusStateResponse$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSoftwareUpgrade() {
  return {
    authority: "",
    plan: void 0
  };
}
const MsgSoftwareUpgrade = {
  typeUrl: "/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade",
  encode(e, n = minimal.Writer.create()) {
    return e.authority !== "" && n.uint32(10).string(e.authority), e.plan !== void 0 && Plan.encode(e.plan, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSoftwareUpgrade();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authority = o.string();
          break;
        case 2:
          c.plan = Plan.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSoftwareUpgrade();
    return o.authority = (n = e.authority) !== null && n !== void 0 ? n : "", o.plan = e.plan !== void 0 && e.plan !== null ? Plan.fromPartial(e.plan) : void 0, o;
  },
  fromAmino(e) {
    return {
      authority: e.authority,
      plan: e != null && e.plan ? Plan.fromAmino(e.plan) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.authority = e.authority, n.plan = e.plan ? Plan.toAmino(e.plan) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSoftwareUpgrade.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSoftwareUpgrade",
      value: MsgSoftwareUpgrade.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSoftwareUpgrade.decode(e.value);
  },
  toProto(e) {
    return MsgSoftwareUpgrade.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade",
      value: MsgSoftwareUpgrade.encode(e).finish()
    };
  }
};
function createBaseMsgSoftwareUpgradeResponse() {
  return {};
}
const MsgSoftwareUpgradeResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.MsgSoftwareUpgradeResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSoftwareUpgradeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSoftwareUpgradeResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSoftwareUpgradeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSoftwareUpgradeResponse",
      value: MsgSoftwareUpgradeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSoftwareUpgradeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSoftwareUpgradeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.MsgSoftwareUpgradeResponse",
      value: MsgSoftwareUpgradeResponse.encode(e).finish()
    };
  }
};
function createBaseMsgCancelUpgrade() {
  return {
    authority: ""
  };
}
const MsgCancelUpgrade = {
  typeUrl: "/cosmos.upgrade.v1beta1.MsgCancelUpgrade",
  encode(e, n = minimal.Writer.create()) {
    return e.authority !== "" && n.uint32(10).string(e.authority), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCancelUpgrade();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authority = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgCancelUpgrade();
    return o.authority = (n = e.authority) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      authority: e.authority
    };
  },
  toAmino(e) {
    const n = {};
    return n.authority = e.authority, n;
  },
  fromAminoMsg(e) {
    return MsgCancelUpgrade.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgCancelUpgrade",
      value: MsgCancelUpgrade.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCancelUpgrade.decode(e.value);
  },
  toProto(e) {
    return MsgCancelUpgrade.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.MsgCancelUpgrade",
      value: MsgCancelUpgrade.encode(e).finish()
    };
  }
};
function createBaseMsgCancelUpgradeResponse() {
  return {};
}
const MsgCancelUpgradeResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.MsgCancelUpgradeResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCancelUpgradeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgCancelUpgradeResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgCancelUpgradeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgCancelUpgradeResponse",
      value: MsgCancelUpgradeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCancelUpgradeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCancelUpgradeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.MsgCancelUpgradeResponse",
      value: MsgCancelUpgradeResponse.encode(e).finish()
    };
  }
}, _47 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgCancelUpgrade,
  MsgCancelUpgradeResponse,
  MsgSoftwareUpgrade,
  MsgSoftwareUpgradeResponse
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$o = {
  "/cosmos.authz.v1beta1.MsgGrant": {
    aminoType: "cosmos-sdk/MsgGrant",
    toAmino: MsgGrant.toAmino,
    fromAmino: MsgGrant.fromAmino
  },
  "/cosmos.authz.v1beta1.MsgExec": {
    aminoType: "cosmos-sdk/MsgExec",
    toAmino: MsgExec.toAmino,
    fromAmino: MsgExec.fromAmino
  },
  "/cosmos.authz.v1beta1.MsgRevoke": {
    aminoType: "cosmos-sdk/MsgRevoke",
    toAmino: MsgRevoke.toAmino,
    fromAmino: MsgRevoke.fromAmino
  }
}, _188 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$o
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$n = {
  "/cosmos.bank.v1beta1.MsgSend": {
    aminoType: "cosmos-sdk/MsgSend",
    toAmino: MsgSend.toAmino,
    fromAmino: MsgSend.fromAmino
  },
  "/cosmos.bank.v1beta1.MsgMultiSend": {
    aminoType: "cosmos-sdk/MsgMultiSend",
    toAmino: MsgMultiSend.toAmino,
    fromAmino: MsgMultiSend.fromAmino
  }
}, _189 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$n
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$m = {
  "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
    aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
    toAmino: MsgSetWithdrawAddress.toAmino,
    fromAmino: MsgSetWithdrawAddress.fromAmino
  },
  "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
    aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
    toAmino: MsgWithdrawDelegatorReward.toAmino,
    fromAmino: MsgWithdrawDelegatorReward.fromAmino
  },
  "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
    aminoType: "cosmos-sdk/MsgWithdrawValCommission",
    toAmino: MsgWithdrawValidatorCommission.toAmino,
    fromAmino: MsgWithdrawValidatorCommission.fromAmino
  },
  "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
    aminoType: "cosmos-sdk/MsgFundCommunityPool",
    toAmino: MsgFundCommunityPool.toAmino,
    fromAmino: MsgFundCommunityPool.fromAmino
  }
}, _190 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$m
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$l = {
  "/cosmos.gov.v1beta1.MsgSubmitProposal": {
    aminoType: "cosmos-sdk/v1/MsgSubmitProposal",
    toAmino: MsgSubmitProposal$1.toAmino,
    fromAmino: MsgSubmitProposal$1.fromAmino
  },
  "/cosmos.gov.v1beta1.MsgVote": {
    aminoType: "cosmos-sdk/v1/MsgVote",
    toAmino: MsgVote$1.toAmino,
    fromAmino: MsgVote$1.fromAmino
  },
  "/cosmos.gov.v1beta1.MsgVoteWeighted": {
    aminoType: "cosmos-sdk/v1/MsgVoteWeighted",
    toAmino: MsgVoteWeighted$1.toAmino,
    fromAmino: MsgVoteWeighted$1.fromAmino
  },
  "/cosmos.gov.v1beta1.MsgDeposit": {
    aminoType: "cosmos-sdk/v1/MsgDeposit",
    toAmino: MsgDeposit$1.toAmino,
    fromAmino: MsgDeposit$1.fromAmino
  }
}, _191 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$l
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$k = {
  "/cosmos.staking.v1beta1.MsgCreateValidator": {
    aminoType: "cosmos-sdk/MsgCreateValidator",
    toAmino: MsgCreateValidator.toAmino,
    fromAmino: MsgCreateValidator.fromAmino
  },
  "/cosmos.staking.v1beta1.MsgEditValidator": {
    aminoType: "cosmos-sdk/MsgEditValidator",
    toAmino: MsgEditValidator.toAmino,
    fromAmino: MsgEditValidator.fromAmino
  },
  "/cosmos.staking.v1beta1.MsgDelegate": {
    aminoType: "cosmos-sdk/MsgDelegate",
    toAmino: MsgDelegate.toAmino,
    fromAmino: MsgDelegate.fromAmino
  },
  "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
    aminoType: "cosmos-sdk/MsgBeginRedelegate",
    toAmino: MsgBeginRedelegate.toAmino,
    fromAmino: MsgBeginRedelegate.fromAmino
  },
  "/cosmos.staking.v1beta1.MsgUndelegate": {
    aminoType: "cosmos-sdk/MsgUndelegate",
    toAmino: MsgUndelegate.toAmino,
    fromAmino: MsgUndelegate.fromAmino
  }
}, _192 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$k
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$j = {
  "/cosmos.gov.v1.MsgSubmitProposal": {
    aminoType: "cosmos-sdk/v1/MsgSubmitProposal",
    toAmino: MsgSubmitProposal.toAmino,
    fromAmino: MsgSubmitProposal.fromAmino
  },
  "/cosmos.gov.v1.MsgExecLegacyContent": {
    aminoType: "cosmos-sdk/v1/MsgExecLegacyContent",
    toAmino: MsgExecLegacyContent.toAmino,
    fromAmino: MsgExecLegacyContent.fromAmino
  },
  "/cosmos.gov.v1.MsgVote": {
    aminoType: "cosmos-sdk/v1/MsgVote",
    toAmino: MsgVote.toAmino,
    fromAmino: MsgVote.fromAmino
  },
  "/cosmos.gov.v1.MsgVoteWeighted": {
    aminoType: "cosmos-sdk/v1/MsgVoteWeighted",
    toAmino: MsgVoteWeighted.toAmino,
    fromAmino: MsgVoteWeighted.fromAmino
  },
  "/cosmos.gov.v1.MsgDeposit": {
    aminoType: "cosmos-sdk/v1/MsgDeposit",
    toAmino: MsgDeposit.toAmino,
    fromAmino: MsgDeposit.fromAmino
  }
}, _193 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$j
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$i = {
  "/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade": {
    aminoType: "cosmos-sdk/MsgSoftwareUpgrade",
    toAmino: MsgSoftwareUpgrade.toAmino,
    fromAmino: MsgSoftwareUpgrade.fromAmino
  },
  "/cosmos.upgrade.v1beta1.MsgCancelUpgrade": {
    aminoType: "cosmos-sdk/MsgCancelUpgrade",
    toAmino: MsgCancelUpgrade.toAmino,
    fromAmino: MsgCancelUpgrade.fromAmino
  }
}, _194 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$i
}, Symbol.toStringTag, { value: "Module" })), registry$q = [["/cosmos.authz.v1beta1.MsgGrant", MsgGrant], ["/cosmos.authz.v1beta1.MsgExec", MsgExec], ["/cosmos.authz.v1beta1.MsgRevoke", MsgRevoke]], load$n = (e) => {
  registry$q.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$n = {
  encoded: {
    grant(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
        value: MsgGrant.encode(e).finish()
      };
    },
    exec(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgExec",
        value: MsgExec.encode(e).finish()
      };
    },
    revoke(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
        value: MsgRevoke.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    grant(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
        value: e
      };
    },
    exec(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgExec",
        value: e
      };
    },
    revoke(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
        value: e
      };
    }
  },
  fromPartial: {
    grant(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
        value: MsgGrant.fromPartial(e)
      };
    },
    exec(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgExec",
        value: MsgExec.fromPartial(e)
      };
    },
    revoke(e) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
        value: MsgRevoke.fromPartial(e)
      };
    }
  }
}, _195 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$n,
  load: load$n,
  registry: registry$q
}, Symbol.toStringTag, { value: "Module" })), registry$p = [["/cosmos.bank.v1beta1.MsgSend", MsgSend], ["/cosmos.bank.v1beta1.MsgMultiSend", MsgMultiSend]], load$m = (e) => {
  registry$p.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$m = {
  encoded: {
    send(e) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: MsgSend.encode(e).finish()
      };
    },
    multiSend(e) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
        value: MsgMultiSend.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    send(e) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: e
      };
    },
    multiSend(e) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
        value: e
      };
    }
  },
  fromPartial: {
    send(e) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: MsgSend.fromPartial(e)
      };
    },
    multiSend(e) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
        value: MsgMultiSend.fromPartial(e)
      };
    }
  }
}, _196 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$m,
  load: load$m,
  registry: registry$p
}, Symbol.toStringTag, { value: "Module" })), registry$o = [["/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", MsgSetWithdrawAddress], ["/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", MsgWithdrawDelegatorReward], ["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", MsgWithdrawValidatorCommission], ["/cosmos.distribution.v1beta1.MsgFundCommunityPool", MsgFundCommunityPool]], load$l = (e) => {
  registry$o.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$l = {
  encoded: {
    setWithdrawAddress(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        value: MsgSetWithdrawAddress.encode(e).finish()
      };
    },
    withdrawDelegatorReward(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: MsgWithdrawDelegatorReward.encode(e).finish()
      };
    },
    withdrawValidatorCommission(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        value: MsgWithdrawValidatorCommission.encode(e).finish()
      };
    },
    fundCommunityPool(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        value: MsgFundCommunityPool.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    setWithdrawAddress(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        value: e
      };
    },
    withdrawDelegatorReward(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: e
      };
    },
    withdrawValidatorCommission(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        value: e
      };
    },
    fundCommunityPool(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        value: e
      };
    }
  },
  fromPartial: {
    setWithdrawAddress(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        value: MsgSetWithdrawAddress.fromPartial(e)
      };
    },
    withdrawDelegatorReward(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: MsgWithdrawDelegatorReward.fromPartial(e)
      };
    },
    withdrawValidatorCommission(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        value: MsgWithdrawValidatorCommission.fromPartial(e)
      };
    },
    fundCommunityPool(e) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        value: MsgFundCommunityPool.fromPartial(e)
      };
    }
  }
}, _197 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$l,
  load: load$l,
  registry: registry$o
}, Symbol.toStringTag, { value: "Module" })), registry$n = [["/cosmos.gov.v1beta1.MsgSubmitProposal", MsgSubmitProposal$1], ["/cosmos.gov.v1beta1.MsgVote", MsgVote$1], ["/cosmos.gov.v1beta1.MsgVoteWeighted", MsgVoteWeighted$1], ["/cosmos.gov.v1beta1.MsgDeposit", MsgDeposit$1]], load$k = (e) => {
  registry$n.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$k = {
  encoded: {
    submitProposal(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value: MsgSubmitProposal$1.encode(e).finish()
      };
    },
    vote(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVote",
        value: MsgVote$1.encode(e).finish()
      };
    },
    voteWeighted(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
        value: MsgVoteWeighted$1.encode(e).finish()
      };
    },
    deposit(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value: MsgDeposit$1.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    submitProposal(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value: e
      };
    },
    vote(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVote",
        value: e
      };
    },
    voteWeighted(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
        value: e
      };
    },
    deposit(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value: e
      };
    }
  },
  fromPartial: {
    submitProposal(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value: MsgSubmitProposal$1.fromPartial(e)
      };
    },
    vote(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVote",
        value: MsgVote$1.fromPartial(e)
      };
    },
    voteWeighted(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
        value: MsgVoteWeighted$1.fromPartial(e)
      };
    },
    deposit(e) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value: MsgDeposit$1.fromPartial(e)
      };
    }
  }
}, _198 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$k,
  load: load$k,
  registry: registry$n
}, Symbol.toStringTag, { value: "Module" })), registry$m = [["/cosmos.staking.v1beta1.MsgCreateValidator", MsgCreateValidator], ["/cosmos.staking.v1beta1.MsgEditValidator", MsgEditValidator], ["/cosmos.staking.v1beta1.MsgDelegate", MsgDelegate], ["/cosmos.staking.v1beta1.MsgBeginRedelegate", MsgBeginRedelegate], ["/cosmos.staking.v1beta1.MsgUndelegate", MsgUndelegate]], load$j = (e) => {
  registry$m.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$j = {
  encoded: {
    createValidator(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
        value: MsgCreateValidator.encode(e).finish()
      };
    },
    editValidator(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
        value: MsgEditValidator.encode(e).finish()
      };
    },
    delegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: MsgDelegate.encode(e).finish()
      };
    },
    beginRedelegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value: MsgBeginRedelegate.encode(e).finish()
      };
    },
    undelegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: MsgUndelegate.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    createValidator(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
        value: e
      };
    },
    editValidator(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
        value: e
      };
    },
    delegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: e
      };
    },
    beginRedelegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value: e
      };
    },
    undelegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: e
      };
    }
  },
  fromPartial: {
    createValidator(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
        value: MsgCreateValidator.fromPartial(e)
      };
    },
    editValidator(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
        value: MsgEditValidator.fromPartial(e)
      };
    },
    delegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: MsgDelegate.fromPartial(e)
      };
    },
    beginRedelegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value: MsgBeginRedelegate.fromPartial(e)
      };
    },
    undelegate(e) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: MsgUndelegate.fromPartial(e)
      };
    }
  }
}, _199 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$j,
  load: load$j,
  registry: registry$m
}, Symbol.toStringTag, { value: "Module" })), registry$l = [["/cosmos.gov.v1.MsgSubmitProposal", MsgSubmitProposal], ["/cosmos.gov.v1.MsgExecLegacyContent", MsgExecLegacyContent], ["/cosmos.gov.v1.MsgVote", MsgVote], ["/cosmos.gov.v1.MsgVoteWeighted", MsgVoteWeighted], ["/cosmos.gov.v1.MsgDeposit", MsgDeposit]], load$i = (e) => {
  registry$l.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$i = {
  encoded: {
    submitProposal(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
        value: MsgSubmitProposal.encode(e).finish()
      };
    },
    execLegacyContent(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgExecLegacyContent",
        value: MsgExecLegacyContent.encode(e).finish()
      };
    },
    vote(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgVote",
        value: MsgVote.encode(e).finish()
      };
    },
    voteWeighted(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgVoteWeighted",
        value: MsgVoteWeighted.encode(e).finish()
      };
    },
    deposit(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgDeposit",
        value: MsgDeposit.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    submitProposal(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
        value: e
      };
    },
    execLegacyContent(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgExecLegacyContent",
        value: e
      };
    },
    vote(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgVote",
        value: e
      };
    },
    voteWeighted(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgVoteWeighted",
        value: e
      };
    },
    deposit(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgDeposit",
        value: e
      };
    }
  },
  fromPartial: {
    submitProposal(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
        value: MsgSubmitProposal.fromPartial(e)
      };
    },
    execLegacyContent(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgExecLegacyContent",
        value: MsgExecLegacyContent.fromPartial(e)
      };
    },
    vote(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgVote",
        value: MsgVote.fromPartial(e)
      };
    },
    voteWeighted(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgVoteWeighted",
        value: MsgVoteWeighted.fromPartial(e)
      };
    },
    deposit(e) {
      return {
        typeUrl: "/cosmos.gov.v1.MsgDeposit",
        value: MsgDeposit.fromPartial(e)
      };
    }
  }
}, _200 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$i,
  load: load$i,
  registry: registry$l
}, Symbol.toStringTag, { value: "Module" })), registry$k = [["/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade", MsgSoftwareUpgrade], ["/cosmos.upgrade.v1beta1.MsgCancelUpgrade", MsgCancelUpgrade]], load$h = (e) => {
  registry$k.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$h = {
  encoded: {
    softwareUpgrade(e) {
      return {
        typeUrl: "/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade",
        value: MsgSoftwareUpgrade.encode(e).finish()
      };
    },
    cancelUpgrade(e) {
      return {
        typeUrl: "/cosmos.upgrade.v1beta1.MsgCancelUpgrade",
        value: MsgCancelUpgrade.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    softwareUpgrade(e) {
      return {
        typeUrl: "/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade",
        value: e
      };
    },
    cancelUpgrade(e) {
      return {
        typeUrl: "/cosmos.upgrade.v1beta1.MsgCancelUpgrade",
        value: e
      };
    }
  },
  fromPartial: {
    softwareUpgrade(e) {
      return {
        typeUrl: "/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade",
        value: MsgSoftwareUpgrade.fromPartial(e)
      };
    },
    cancelUpgrade(e) {
      return {
        typeUrl: "/cosmos.upgrade.v1beta1.MsgCancelUpgrade",
        value: MsgCancelUpgrade.fromPartial(e)
      };
    }
  }
}, _201 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$h,
  load: load$h,
  registry: registry$k
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$y = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.accounts = this.accounts.bind(this), this.account = this.account.bind(this), this.params = this.params.bind(this), this.moduleAccounts = this.moduleAccounts.bind(this);
  }
  /* Accounts returns all the existing accounts
  
   Since: cosmos-sdk 0.43 */
  async accounts(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmos/auth/v1beta1/accounts";
    return await this.req.get(u, o);
  }
  /* Account returns account details based on address. */
  async account(n) {
    const o = `cosmos/auth/v1beta1/accounts/${n.address}`;
    return await this.req.get(o);
  }
  /* Params queries all parameters. */
  async params(n = {}) {
    const o = "cosmos/auth/v1beta1/params";
    return await this.req.get(o);
  }
  /* ModuleAccounts returns all the existing module accounts. */
  async moduleAccounts(n = {}) {
    const o = "cosmos/auth/v1beta1/module_accounts";
    return await this.req.get(o);
  }
};
const _202 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$y
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$x = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.grants = this.grants.bind(this), this.granterGrants = this.granterGrants.bind(this), this.granteeGrants = this.granteeGrants.bind(this);
  }
  /* Returns list of `Authorization`, granted to the grantee by the granter. */
  async grants(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.granter) < "u" && (o.params.granter = n.granter), typeof (n == null ? void 0 : n.grantee) < "u" && (o.params.grantee = n.grantee), typeof (n == null ? void 0 : n.msgTypeUrl) < "u" && (o.params.msg_type_url = n.msgTypeUrl), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmos/authz/v1beta1/grants";
    return await this.req.get(u, o);
  }
  /* GranterGrants returns list of `Authorization`, granted by granter. */
  async granterGrants(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/authz/v1beta1/grants/granter/${n.granter}`;
    return await this.req.get(u, o);
  }
  /* GranteeGrants returns a list of `GrantAuthorization` by grantee. */
  async granteeGrants(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/authz/v1beta1/grants/grantee/${n.grantee}`;
    return await this.req.get(u, o);
  }
};
const _203 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$x
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$w = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.balance = this.balance.bind(this), this.allBalances = this.allBalances.bind(this), this.totalSupply = this.totalSupply.bind(this), this.supplyOf = this.supplyOf.bind(this), this.totalSupplyWithoutOffset = this.totalSupplyWithoutOffset.bind(this), this.supplyOfWithoutOffset = this.supplyOfWithoutOffset.bind(this), this.params = this.params.bind(this), this.denomMetadata = this.denomMetadata.bind(this), this.denomsMetadata = this.denomsMetadata.bind(this), this.baseDenom = this.baseDenom.bind(this);
  }
  /* Balance queries the balance of a single coin for a single account. */
  async balance(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = `cosmos/bank/v1beta1/balances/${n.address}/by_denom`;
    return await this.req.get(u, o);
  }
  /* AllBalances queries the balance of all coins for a single account. */
  async allBalances(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/bank/v1beta1/balances/${n.address}`;
    return await this.req.get(u, o);
  }
  /* TotalSupply queries the total supply of all coins. */
  async totalSupply(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmos/bank/v1beta1/supply";
    return await this.req.get(u, o);
  }
  /* SupplyOf queries the supply of a single coin. */
  async supplyOf(n) {
    const o = `cosmos/bank/v1beta1/supply/${n.denom}`;
    return await this.req.get(o);
  }
  /* TotalSupplyWithoutOffset queries the total supply of all coins. */
  async totalSupplyWithoutOffset(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmos/bank/v1beta1/supply_without_offset";
    return await this.req.get(u, o);
  }
  /* SupplyOf queries the supply of a single coin. */
  async supplyOfWithoutOffset(n) {
    const o = `cosmos/bank/v1beta1/supply_without_offset/${n.denom}`;
    return await this.req.get(o);
  }
  /* Params queries the parameters of x/bank module. */
  async params(n = {}) {
    const o = "cosmos/bank/v1beta1/params";
    return await this.req.get(o);
  }
  /* DenomsMetadata queries the client metadata of a given coin denomination. */
  async denomMetadata(n) {
    const o = `cosmos/bank/v1beta1/denoms_metadata/${n.denom}`;
    return await this.req.get(o);
  }
  /* DenomsMetadata queries the client metadata for all registered coin denominations. */
  async denomsMetadata(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmos/bank/v1beta1/denoms_metadata";
    return await this.req.get(u, o);
  }
  /* BaseDenom queries for a base denomination given a denom that can either be
   the base denom itself or a metadata denom unit that maps to the base denom. */
  async baseDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = "cosmos/bank/v1beta1/base_denom";
    return await this.req.get(u, o);
  }
};
const _204 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$w
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$v = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.config = this.config.bind(this);
  }
  /* Config queries for the operator configuration. */
  async config(n = {}) {
    const o = "cosmos/base/node/v1beta1/config";
    return await this.req.get(o);
  }
};
const _205 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$v
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$u = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this), this.validatorOutstandingRewards = this.validatorOutstandingRewards.bind(this), this.validatorCommission = this.validatorCommission.bind(this), this.validatorSlashes = this.validatorSlashes.bind(this), this.delegationRewards = this.delegationRewards.bind(this), this.delegationTotalRewards = this.delegationTotalRewards.bind(this), this.delegatorValidators = this.delegatorValidators.bind(this), this.delegatorWithdrawAddress = this.delegatorWithdrawAddress.bind(this), this.communityPool = this.communityPool.bind(this);
  }
  /* Params queries params of the distribution module. */
  async params(n = {}) {
    const o = "cosmos/distribution/v1beta1/params";
    return await this.req.get(o);
  }
  /* ValidatorOutstandingRewards queries rewards of a validator address. */
  async validatorOutstandingRewards(n) {
    const o = `cosmos/distribution/v1beta1/validators/${n.validatorAddress}/outstanding_rewards`;
    return await this.req.get(o);
  }
  /* ValidatorCommission queries accumulated commission for a validator. */
  async validatorCommission(n) {
    const o = `cosmos/distribution/v1beta1/validators/${n.validatorAddress}/commission`;
    return await this.req.get(o);
  }
  /* ValidatorSlashes queries slash events of a validator. */
  async validatorSlashes(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.startingHeight) < "u" && (o.params.starting_height = n.startingHeight), typeof (n == null ? void 0 : n.endingHeight) < "u" && (o.params.ending_height = n.endingHeight), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/distribution/v1beta1/validators/${n.validatorAddress}/slashes`;
    return await this.req.get(u, o);
  }
  /* DelegationRewards queries the total rewards accrued by a delegation. */
  async delegationRewards(n) {
    const o = `cosmos/distribution/v1beta1/delegators/${n.delegatorAddress}/rewards/${n.validatorAddress}`;
    return await this.req.get(o);
  }
  /* DelegationTotalRewards queries the total rewards accrued by a each
   validator. */
  async delegationTotalRewards(n) {
    const o = `cosmos/distribution/v1beta1/delegators/${n.delegatorAddress}/rewards`;
    return await this.req.get(o);
  }
  /* DelegatorValidators queries the validators of a delegator. */
  async delegatorValidators(n) {
    const o = `cosmos/distribution/v1beta1/delegators/${n.delegatorAddress}/validators`;
    return await this.req.get(o);
  }
  /* DelegatorWithdrawAddress queries withdraw address of a delegator. */
  async delegatorWithdrawAddress(n) {
    const o = `cosmos/distribution/v1beta1/delegators/${n.delegatorAddress}/withdraw_address`;
    return await this.req.get(o);
  }
  /* CommunityPool queries the community pool coins. */
  async communityPool(n = {}) {
    const o = "cosmos/distribution/v1beta1/community_pool";
    return await this.req.get(o);
  }
};
const _206 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$u
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$t = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.proposal = this.proposal.bind(this), this.proposals = this.proposals.bind(this), this.vote = this.vote.bind(this), this.votes = this.votes.bind(this), this.params = this.params.bind(this), this.deposit = this.deposit.bind(this), this.deposits = this.deposits.bind(this), this.tallyResult = this.tallyResult.bind(this);
  }
  /* Proposal queries proposal details based on ProposalID. */
  async proposal(n) {
    const o = `cosmos/gov/v1beta1/proposals/${n.proposalId}`;
    return await this.req.get(o);
  }
  /* Proposals queries all proposals based on given status. */
  async proposals(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.proposalStatus) < "u" && (o.params.proposal_status = n.proposalStatus), typeof (n == null ? void 0 : n.voter) < "u" && (o.params.voter = n.voter), typeof (n == null ? void 0 : n.depositor) < "u" && (o.params.depositor = n.depositor), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmos/gov/v1beta1/proposals";
    return await this.req.get(u, o);
  }
  /* Vote queries voted information based on proposalID, voterAddr. */
  async vote(n) {
    const o = `cosmos/gov/v1beta1/proposals/${n.proposalId}/votes/${n.voter}`;
    return await this.req.get(o);
  }
  /* Votes queries votes of a given proposal. */
  async votes(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/gov/v1beta1/proposals/${n.proposalId}/votes`;
    return await this.req.get(u, o);
  }
  /* Params queries all parameters of the gov module. */
  async params(n) {
    const o = `cosmos/gov/v1beta1/params/${n.paramsType}`;
    return await this.req.get(o);
  }
  /* Deposit queries single deposit information based proposalID, depositAddr. */
  async deposit(n) {
    const o = `cosmos/gov/v1beta1/proposals/${n.proposalId}/deposits/${n.depositor}`;
    return await this.req.get(o);
  }
  /* Deposits queries all deposits of a single proposal. */
  async deposits(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/gov/v1beta1/proposals/${n.proposalId}/deposits`;
    return await this.req.get(u, o);
  }
  /* TallyResult queries the tally of a proposal vote. */
  async tallyResult(n) {
    const o = `cosmos/gov/v1beta1/proposals/${n.proposalId}/tally`;
    return await this.req.get(o);
  }
};
const _207 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$t
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$s = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.validators = this.validators.bind(this), this.validator = this.validator.bind(this), this.validatorDelegations = this.validatorDelegations.bind(this), this.validatorUnbondingDelegations = this.validatorUnbondingDelegations.bind(this), this.delegation = this.delegation.bind(this), this.unbondingDelegation = this.unbondingDelegation.bind(this), this.delegatorDelegations = this.delegatorDelegations.bind(this), this.delegatorUnbondingDelegations = this.delegatorUnbondingDelegations.bind(this), this.redelegations = this.redelegations.bind(this), this.delegatorValidators = this.delegatorValidators.bind(this), this.delegatorValidator = this.delegatorValidator.bind(this), this.historicalInfo = this.historicalInfo.bind(this), this.pool = this.pool.bind(this), this.params = this.params.bind(this);
  }
  /* Validators queries all validators that match the given status. */
  async validators(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.status) < "u" && (o.params.status = n.status), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmos/staking/v1beta1/validators";
    return await this.req.get(u, o);
  }
  /* Validator queries validator info for given validator address. */
  async validator(n) {
    const o = `cosmos/staking/v1beta1/validators/${n.validatorAddr}`;
    return await this.req.get(o);
  }
  /* ValidatorDelegations queries delegate info for given validator. */
  async validatorDelegations(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/staking/v1beta1/validators/${n.validatorAddr}/delegations`;
    return await this.req.get(u, o);
  }
  /* ValidatorUnbondingDelegations queries unbonding delegations of a validator. */
  async validatorUnbondingDelegations(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/staking/v1beta1/validators/${n.validatorAddr}/unbonding_delegations`;
    return await this.req.get(u, o);
  }
  /* Delegation queries delegate info for given validator delegator pair. */
  async delegation(n) {
    const o = `cosmos/staking/v1beta1/validators/${n.validatorAddr}/delegations/${n.delegatorAddr}`;
    return await this.req.get(o);
  }
  /* UnbondingDelegation queries unbonding info for given validator delegator
   pair. */
  async unbondingDelegation(n) {
    const o = `cosmos/staking/v1beta1/validators/${n.validatorAddr}/delegations/${n.delegatorAddr}/unbonding_delegation`;
    return await this.req.get(o);
  }
  /* DelegatorDelegations queries all delegations of a given delegator address. */
  async delegatorDelegations(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/staking/v1beta1/delegations/${n.delegatorAddr}`;
    return await this.req.get(u, o);
  }
  /* DelegatorUnbondingDelegations queries all unbonding delegations of a given
   delegator address. */
  async delegatorUnbondingDelegations(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/staking/v1beta1/delegators/${n.delegatorAddr}/unbonding_delegations`;
    return await this.req.get(u, o);
  }
  /* Redelegations queries redelegations of given address. */
  async redelegations(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.srcValidatorAddr) < "u" && (o.params.src_validator_addr = n.srcValidatorAddr), typeof (n == null ? void 0 : n.dstValidatorAddr) < "u" && (o.params.dst_validator_addr = n.dstValidatorAddr), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/staking/v1beta1/delegators/${n.delegatorAddr}/redelegations`;
    return await this.req.get(u, o);
  }
  /* DelegatorValidators queries all validators info for given delegator
   address. */
  async delegatorValidators(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/staking/v1beta1/delegators/${n.delegatorAddr}/validators`;
    return await this.req.get(u, o);
  }
  /* DelegatorValidator queries validator info for given delegator validator
   pair. */
  async delegatorValidator(n) {
    const o = `cosmos/staking/v1beta1/delegators/${n.delegatorAddr}/validators/${n.validatorAddr}`;
    return await this.req.get(o);
  }
  /* HistoricalInfo queries the historical info for given height. */
  async historicalInfo(n) {
    const o = `cosmos/staking/v1beta1/historical_info/${n.height}`;
    return await this.req.get(o);
  }
  /* Pool queries the pool info. */
  async pool(n = {}) {
    const o = "cosmos/staking/v1beta1/pool";
    return await this.req.get(o);
  }
  /* Parameters queries the staking parameters. */
  async params(n = {}) {
    const o = "cosmos/staking/v1beta1/params";
    return await this.req.get(o);
  }
};
const _208 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$s
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$r = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.getTx = this.getTx.bind(this), this.getTxsEvent = this.getTxsEvent.bind(this);
  }
  /* GetTx fetches a tx by hash. */
  async getTx(n) {
    const o = `cosmos/tx/v1beta1/txs/${n.hash}`;
    return await this.req.get(o);
  }
  /* GetTxsEvent fetches txs by event. */
  async getTxsEvent(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.events) < "u" && (o.params.events = n.events), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination), typeof (n == null ? void 0 : n.orderBy) < "u" && (o.params.order_by = n.orderBy);
    const u = "cosmos/tx/v1beta1/txs";
    return await this.req.get(u, o);
  }
};
const _209 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$r
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$q = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.currentPlan = this.currentPlan.bind(this), this.appliedPlan = this.appliedPlan.bind(this), this.upgradedConsensusState = this.upgradedConsensusState.bind(this), this.moduleVersions = this.moduleVersions.bind(this);
  }
  /* CurrentPlan queries the current upgrade plan. */
  async currentPlan(n = {}) {
    const o = "cosmos/upgrade/v1beta1/current_plan";
    return await this.req.get(o);
  }
  /* AppliedPlan queries a previously applied upgrade plan by its name. */
  async appliedPlan(n) {
    const o = `cosmos/upgrade/v1beta1/applied_plan/${n.name}`;
    return await this.req.get(o);
  }
  /* UpgradedConsensusState queries the consensus state that will serve
   as a trusted kernel for the next version of this chain. It will only be
   stored at the last height of this chain.
   UpgradedConsensusState RPC not supported with legacy querier
   This rpc is deprecated now that IBC has its own replacement
   (https://github.com/cosmos/ibc-go/blob/2c880a22e9f9cc75f62b527ca94aa75ce1106001/proto/ibc/core/client/v1/query.proto#L54) */
  async upgradedConsensusState(n) {
    const o = `cosmos/upgrade/v1beta1/upgraded_consensus_state/${n.lastHeight}`;
    return await this.req.get(o);
  }
  /* ModuleVersions queries the list of module versions from state.
  
   Since: cosmos-sdk 0.43 */
  async moduleVersions(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.moduleName) < "u" && (o.params.module_name = n.moduleName);
    const u = "cosmos/upgrade/v1beta1/module_versions";
    return await this.req.get(u, o);
  }
};
const _210 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$q
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$p = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.proposal = this.proposal.bind(this), this.proposals = this.proposals.bind(this), this.vote = this.vote.bind(this), this.votes = this.votes.bind(this), this.params = this.params.bind(this), this.deposit = this.deposit.bind(this), this.deposits = this.deposits.bind(this), this.tallyResult = this.tallyResult.bind(this);
  }
  /* Proposal queries proposal details based on ProposalID. */
  async proposal(n) {
    const o = `cosmos/gov/v1/proposals/${n.proposalId}`;
    return await this.req.get(o);
  }
  /* Proposals queries all proposals based on given status. */
  async proposals(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.proposalStatus) < "u" && (o.params.proposal_status = n.proposalStatus), typeof (n == null ? void 0 : n.voter) < "u" && (o.params.voter = n.voter), typeof (n == null ? void 0 : n.depositor) < "u" && (o.params.depositor = n.depositor), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmos/gov/v1/proposals";
    return await this.req.get(u, o);
  }
  /* Vote queries voted information based on proposalID, voterAddr. */
  async vote(n) {
    const o = `cosmos/gov/v1/proposals/${n.proposalId}/votes/${n.voter}`;
    return await this.req.get(o);
  }
  /* Votes queries votes of a given proposal. */
  async votes(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/gov/v1/proposals/${n.proposalId}/votes`;
    return await this.req.get(u, o);
  }
  /* Params queries all parameters of the gov module. */
  async params(n) {
    const o = `cosmos/gov/v1/params/${n.paramsType}`;
    return await this.req.get(o);
  }
  /* Deposit queries single deposit information based proposalID, depositAddr. */
  async deposit(n) {
    const o = `cosmos/gov/v1/proposals/${n.proposalId}/deposits/${n.depositor}`;
    return await this.req.get(o);
  }
  /* Deposits queries all deposits of a single proposal. */
  async deposits(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmos/gov/v1/proposals/${n.proposalId}/deposits`;
    return await this.req.get(u, o);
  }
  /* TallyResult queries the tally of a proposal vote. */
  async tallyResult(n) {
    const o = `cosmos/gov/v1/proposals/${n.proposalId}/tally`;
    return await this.req.get(o);
  }
};
const _211 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$p
}, Symbol.toStringTag, { value: "Module" }));
var build$5 = {}, accounts = {}, build$4 = {}, coins = {};
Object.defineProperty(coins, "__esModule", { value: !0 });
coins.parseCoins = void 0;
function parseCoins(e) {
  return e.replace(/\s/g, "").split(",").filter(Boolean).map((n) => {
    const o = n.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
    if (!o)
      throw new Error("Got an invalid coin string");
    return {
      amount: o[1].replace(/^0+/, "") || "0",
      denom: o[2]
    };
  });
}
coins.parseCoins = parseCoins;
var decode = {};
Object.defineProperty(decode, "__esModule", { value: !0 });
decode.decodeTxRaw = void 0;
const tx_1$c = tx$p;
function decodeTxRaw(e) {
  const n = tx_1$c.TxRaw.decode(e);
  return {
    authInfo: tx_1$c.AuthInfo.decode(n.authInfoBytes),
    body: tx_1$c.TxBody.decode(n.bodyBytes),
    signatures: n.signatures
  };
}
decode.decodeTxRaw = decodeTxRaw;
var directsecp256k1hdwallet = {}, signing = {}, long$1 = Long$1, wasm$1 = null;
try {
  wasm$1 = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch (e) {
}
function Long$1(e, n, o) {
  this.low = e | 0, this.high = n | 0, this.unsigned = !!o;
}
Long$1.prototype.__isLong__;
Object.defineProperty(Long$1.prototype, "__isLong__", { value: !0 });
function isLong$1(e) {
  return (e && e.__isLong__) === !0;
}
Long$1.isLong = isLong$1;
var INT_CACHE$1 = {}, UINT_CACHE$1 = {};
function fromInt$1(e, n) {
  var o, u, c;
  return n ? (e >>>= 0, (c = 0 <= e && e < 256) && (u = UINT_CACHE$1[e], u) ? u : (o = fromBits$1(e, (e | 0) < 0 ? -1 : 0, !0), c && (UINT_CACHE$1[e] = o), o)) : (e |= 0, (c = -128 <= e && e < 128) && (u = INT_CACHE$1[e], u) ? u : (o = fromBits$1(e, e < 0 ? -1 : 0, !1), c && (INT_CACHE$1[e] = o), o));
}
Long$1.fromInt = fromInt$1;
function fromNumber$1(e, n) {
  if (isNaN(e))
    return n ? UZERO$1 : ZERO$1;
  if (n) {
    if (e < 0)
      return UZERO$1;
    if (e >= TWO_PWR_64_DBL$1)
      return MAX_UNSIGNED_VALUE$1;
  } else {
    if (e <= -TWO_PWR_63_DBL$1)
      return MIN_VALUE$1;
    if (e + 1 >= TWO_PWR_63_DBL$1)
      return MAX_VALUE$1;
  }
  return e < 0 ? fromNumber$1(-e, n).neg() : fromBits$1(e % TWO_PWR_32_DBL$1 | 0, e / TWO_PWR_32_DBL$1 | 0, n);
}
Long$1.fromNumber = fromNumber$1;
function fromBits$1(e, n, o) {
  return new Long$1(e, n, o);
}
Long$1.fromBits = fromBits$1;
var pow_dbl$1 = Math.pow;
function fromString$1(e, n, o) {
  if (e.length === 0)
    throw Error("empty string");
  if (e === "NaN" || e === "Infinity" || e === "+Infinity" || e === "-Infinity")
    return ZERO$1;
  if (typeof n == "number" ? (o = n, n = !1) : n = !!n, o = o || 10, o < 2 || 36 < o)
    throw RangeError("radix");
  var u;
  if ((u = e.indexOf("-")) > 0)
    throw Error("interior hyphen");
  if (u === 0)
    return fromString$1(e.substring(1), n, o).neg();
  for (var c = fromNumber$1(pow_dbl$1(o, 8)), d = ZERO$1, m = 0; m < e.length; m += 8) {
    var v = Math.min(8, e.length - m), S = parseInt(e.substring(m, m + v), o);
    if (v < 8) {
      var $ = fromNumber$1(pow_dbl$1(o, v));
      d = d.mul($).add(fromNumber$1(S));
    } else
      d = d.mul(c), d = d.add(fromNumber$1(S));
  }
  return d.unsigned = n, d;
}
Long$1.fromString = fromString$1;
function fromValue$1(e, n) {
  return typeof e == "number" ? fromNumber$1(e, n) : typeof e == "string" ? fromString$1(e, n) : fromBits$1(e.low, e.high, typeof n == "boolean" ? n : e.unsigned);
}
Long$1.fromValue = fromValue$1;
var TWO_PWR_16_DBL$1 = 65536, TWO_PWR_24_DBL$1 = 1 << 24, TWO_PWR_32_DBL$1 = TWO_PWR_16_DBL$1 * TWO_PWR_16_DBL$1, TWO_PWR_64_DBL$1 = TWO_PWR_32_DBL$1 * TWO_PWR_32_DBL$1, TWO_PWR_63_DBL$1 = TWO_PWR_64_DBL$1 / 2, TWO_PWR_24$1 = fromInt$1(TWO_PWR_24_DBL$1), ZERO$1 = fromInt$1(0);
Long$1.ZERO = ZERO$1;
var UZERO$1 = fromInt$1(0, !0);
Long$1.UZERO = UZERO$1;
var ONE$1 = fromInt$1(1);
Long$1.ONE = ONE$1;
var UONE$1 = fromInt$1(1, !0);
Long$1.UONE = UONE$1;
var NEG_ONE$1 = fromInt$1(-1);
Long$1.NEG_ONE = NEG_ONE$1;
var MAX_VALUE$1 = fromBits$1(-1, 2147483647, !1);
Long$1.MAX_VALUE = MAX_VALUE$1;
var MAX_UNSIGNED_VALUE$1 = fromBits$1(-1, -1, !0);
Long$1.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE$1;
var MIN_VALUE$1 = fromBits$1(0, -2147483648, !1);
Long$1.MIN_VALUE = MIN_VALUE$1;
var LongPrototype$1 = Long$1.prototype;
LongPrototype$1.toInt = function e() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype$1.toNumber = function e() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL$1 + (this.low >>> 0) : this.high * TWO_PWR_32_DBL$1 + (this.low >>> 0);
};
LongPrototype$1.toString = function e(n) {
  if (n = n || 10, n < 2 || 36 < n)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE$1)) {
      var o = fromNumber$1(n), u = this.div(o), c = u.mul(o).sub(this);
      return u.toString(n) + c.toInt().toString(n);
    } else
      return "-" + this.neg().toString(n);
  for (var d = fromNumber$1(pow_dbl$1(n, 6), this.unsigned), m = this, v = ""; ; ) {
    var S = m.div(d), $ = m.sub(S.mul(d)).toInt() >>> 0, E = $.toString(n);
    if (m = S, m.isZero())
      return E + v;
    for (; E.length < 6; )
      E = "0" + E;
    v = "" + E + v;
  }
};
LongPrototype$1.getHighBits = function e() {
  return this.high;
};
LongPrototype$1.getHighBitsUnsigned = function e() {
  return this.high >>> 0;
};
LongPrototype$1.getLowBits = function e() {
  return this.low;
};
LongPrototype$1.getLowBitsUnsigned = function e() {
  return this.low >>> 0;
};
LongPrototype$1.getNumBitsAbs = function e() {
  if (this.isNegative())
    return this.eq(MIN_VALUE$1) ? 64 : this.neg().getNumBitsAbs();
  for (var n = this.high != 0 ? this.high : this.low, o = 31; o > 0 && !(n & 1 << o); o--)
    ;
  return this.high != 0 ? o + 33 : o + 1;
};
LongPrototype$1.isZero = function e() {
  return this.high === 0 && this.low === 0;
};
LongPrototype$1.eqz = LongPrototype$1.isZero;
LongPrototype$1.isNegative = function e() {
  return !this.unsigned && this.high < 0;
};
LongPrototype$1.isPositive = function e() {
  return this.unsigned || this.high >= 0;
};
LongPrototype$1.isOdd = function e() {
  return (this.low & 1) === 1;
};
LongPrototype$1.isEven = function e() {
  return (this.low & 1) === 0;
};
LongPrototype$1.equals = function e(n) {
  return isLong$1(n) || (n = fromValue$1(n)), this.unsigned !== n.unsigned && this.high >>> 31 === 1 && n.high >>> 31 === 1 ? !1 : this.high === n.high && this.low === n.low;
};
LongPrototype$1.eq = LongPrototype$1.equals;
LongPrototype$1.notEquals = function e(n) {
  return !this.eq(
    /* validates */
    n
  );
};
LongPrototype$1.neq = LongPrototype$1.notEquals;
LongPrototype$1.ne = LongPrototype$1.notEquals;
LongPrototype$1.lessThan = function e(n) {
  return this.comp(
    /* validates */
    n
  ) < 0;
};
LongPrototype$1.lt = LongPrototype$1.lessThan;
LongPrototype$1.lessThanOrEqual = function e(n) {
  return this.comp(
    /* validates */
    n
  ) <= 0;
};
LongPrototype$1.lte = LongPrototype$1.lessThanOrEqual;
LongPrototype$1.le = LongPrototype$1.lessThanOrEqual;
LongPrototype$1.greaterThan = function e(n) {
  return this.comp(
    /* validates */
    n
  ) > 0;
};
LongPrototype$1.gt = LongPrototype$1.greaterThan;
LongPrototype$1.greaterThanOrEqual = function e(n) {
  return this.comp(
    /* validates */
    n
  ) >= 0;
};
LongPrototype$1.gte = LongPrototype$1.greaterThanOrEqual;
LongPrototype$1.ge = LongPrototype$1.greaterThanOrEqual;
LongPrototype$1.compare = function e(n) {
  if (isLong$1(n) || (n = fromValue$1(n)), this.eq(n))
    return 0;
  var o = this.isNegative(), u = n.isNegative();
  return o && !u ? -1 : !o && u ? 1 : this.unsigned ? n.high >>> 0 > this.high >>> 0 || n.high === this.high && n.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(n).isNegative() ? -1 : 1;
};
LongPrototype$1.comp = LongPrototype$1.compare;
LongPrototype$1.negate = function e() {
  return !this.unsigned && this.eq(MIN_VALUE$1) ? MIN_VALUE$1 : this.not().add(ONE$1);
};
LongPrototype$1.neg = LongPrototype$1.negate;
LongPrototype$1.add = function e(n) {
  isLong$1(n) || (n = fromValue$1(n));
  var o = this.high >>> 16, u = this.high & 65535, c = this.low >>> 16, d = this.low & 65535, m = n.high >>> 16, v = n.high & 65535, S = n.low >>> 16, $ = n.low & 65535, E = 0, O = 0, T = 0, y = 0;
  return y += d + $, T += y >>> 16, y &= 65535, T += c + S, O += T >>> 16, T &= 65535, O += u + v, E += O >>> 16, O &= 65535, E += o + m, E &= 65535, fromBits$1(T << 16 | y, E << 16 | O, this.unsigned);
};
LongPrototype$1.subtract = function e(n) {
  return isLong$1(n) || (n = fromValue$1(n)), this.add(n.neg());
};
LongPrototype$1.sub = LongPrototype$1.subtract;
LongPrototype$1.multiply = function e(n) {
  if (this.isZero())
    return ZERO$1;
  if (isLong$1(n) || (n = fromValue$1(n)), wasm$1) {
    var o = wasm$1.mul(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits$1(o, wasm$1.get_high(), this.unsigned);
  }
  if (n.isZero())
    return ZERO$1;
  if (this.eq(MIN_VALUE$1))
    return n.isOdd() ? MIN_VALUE$1 : ZERO$1;
  if (n.eq(MIN_VALUE$1))
    return this.isOdd() ? MIN_VALUE$1 : ZERO$1;
  if (this.isNegative())
    return n.isNegative() ? this.neg().mul(n.neg()) : this.neg().mul(n).neg();
  if (n.isNegative())
    return this.mul(n.neg()).neg();
  if (this.lt(TWO_PWR_24$1) && n.lt(TWO_PWR_24$1))
    return fromNumber$1(this.toNumber() * n.toNumber(), this.unsigned);
  var u = this.high >>> 16, c = this.high & 65535, d = this.low >>> 16, m = this.low & 65535, v = n.high >>> 16, S = n.high & 65535, $ = n.low >>> 16, E = n.low & 65535, O = 0, T = 0, y = 0, V = 0;
  return V += m * E, y += V >>> 16, V &= 65535, y += d * E, T += y >>> 16, y &= 65535, y += m * $, T += y >>> 16, y &= 65535, T += c * E, O += T >>> 16, T &= 65535, T += d * $, O += T >>> 16, T &= 65535, T += m * S, O += T >>> 16, T &= 65535, O += u * E + c * $ + d * S + m * v, O &= 65535, fromBits$1(y << 16 | V, O << 16 | T, this.unsigned);
};
LongPrototype$1.mul = LongPrototype$1.multiply;
LongPrototype$1.divide = function e(n) {
  if (isLong$1(n) || (n = fromValue$1(n)), n.isZero())
    throw Error("division by zero");
  if (wasm$1) {
    if (!this.unsigned && this.high === -2147483648 && n.low === -1 && n.high === -1)
      return this;
    var o = (this.unsigned ? wasm$1.div_u : wasm$1.div_s)(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits$1(o, wasm$1.get_high(), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO$1 : ZERO$1;
  var u, c, d;
  if (this.unsigned) {
    if (n.unsigned || (n = n.toUnsigned()), n.gt(this))
      return UZERO$1;
    if (n.gt(this.shru(1)))
      return UONE$1;
    d = UZERO$1;
  } else {
    if (this.eq(MIN_VALUE$1)) {
      if (n.eq(ONE$1) || n.eq(NEG_ONE$1))
        return MIN_VALUE$1;
      if (n.eq(MIN_VALUE$1))
        return ONE$1;
      var m = this.shr(1);
      return u = m.div(n).shl(1), u.eq(ZERO$1) ? n.isNegative() ? ONE$1 : NEG_ONE$1 : (c = this.sub(n.mul(u)), d = u.add(c.div(n)), d);
    } else if (n.eq(MIN_VALUE$1))
      return this.unsigned ? UZERO$1 : ZERO$1;
    if (this.isNegative())
      return n.isNegative() ? this.neg().div(n.neg()) : this.neg().div(n).neg();
    if (n.isNegative())
      return this.div(n.neg()).neg();
    d = ZERO$1;
  }
  for (c = this; c.gte(n); ) {
    u = Math.max(1, Math.floor(c.toNumber() / n.toNumber()));
    for (var v = Math.ceil(Math.log(u) / Math.LN2), S = v <= 48 ? 1 : pow_dbl$1(2, v - 48), $ = fromNumber$1(u), E = $.mul(n); E.isNegative() || E.gt(c); )
      u -= S, $ = fromNumber$1(u, this.unsigned), E = $.mul(n);
    $.isZero() && ($ = ONE$1), d = d.add($), c = c.sub(E);
  }
  return d;
};
LongPrototype$1.div = LongPrototype$1.divide;
LongPrototype$1.modulo = function e(n) {
  if (isLong$1(n) || (n = fromValue$1(n)), wasm$1) {
    var o = (this.unsigned ? wasm$1.rem_u : wasm$1.rem_s)(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits$1(o, wasm$1.get_high(), this.unsigned);
  }
  return this.sub(this.div(n).mul(n));
};
LongPrototype$1.mod = LongPrototype$1.modulo;
LongPrototype$1.rem = LongPrototype$1.modulo;
LongPrototype$1.not = function e() {
  return fromBits$1(~this.low, ~this.high, this.unsigned);
};
LongPrototype$1.and = function e(n) {
  return isLong$1(n) || (n = fromValue$1(n)), fromBits$1(this.low & n.low, this.high & n.high, this.unsigned);
};
LongPrototype$1.or = function e(n) {
  return isLong$1(n) || (n = fromValue$1(n)), fromBits$1(this.low | n.low, this.high | n.high, this.unsigned);
};
LongPrototype$1.xor = function e(n) {
  return isLong$1(n) || (n = fromValue$1(n)), fromBits$1(this.low ^ n.low, this.high ^ n.high, this.unsigned);
};
LongPrototype$1.shiftLeft = function e(n) {
  return isLong$1(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n < 32 ? fromBits$1(this.low << n, this.high << n | this.low >>> 32 - n, this.unsigned) : fromBits$1(0, this.low << n - 32, this.unsigned);
};
LongPrototype$1.shl = LongPrototype$1.shiftLeft;
LongPrototype$1.shiftRight = function e(n) {
  return isLong$1(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n < 32 ? fromBits$1(this.low >>> n | this.high << 32 - n, this.high >> n, this.unsigned) : fromBits$1(this.high >> n - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype$1.shr = LongPrototype$1.shiftRight;
LongPrototype$1.shiftRightUnsigned = function e(n) {
  if (isLong$1(n) && (n = n.toInt()), n &= 63, n === 0)
    return this;
  var o = this.high;
  if (n < 32) {
    var u = this.low;
    return fromBits$1(u >>> n | o << 32 - n, o >>> n, this.unsigned);
  } else
    return n === 32 ? fromBits$1(o, 0, this.unsigned) : fromBits$1(o >>> n - 32, 0, this.unsigned);
};
LongPrototype$1.shru = LongPrototype$1.shiftRightUnsigned;
LongPrototype$1.shr_u = LongPrototype$1.shiftRightUnsigned;
LongPrototype$1.toSigned = function e() {
  return this.unsigned ? fromBits$1(this.low, this.high, !1) : this;
};
LongPrototype$1.toUnsigned = function e() {
  return this.unsigned ? this : fromBits$1(this.low, this.high, !0);
};
LongPrototype$1.toBytes = function e(n) {
  return n ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype$1.toBytesLE = function e() {
  var n = this.high, o = this.low;
  return [
    o & 255,
    o >>> 8 & 255,
    o >>> 16 & 255,
    o >>> 24,
    n & 255,
    n >>> 8 & 255,
    n >>> 16 & 255,
    n >>> 24
  ];
};
LongPrototype$1.toBytesBE = function e() {
  var n = this.high, o = this.low;
  return [
    n >>> 24,
    n >>> 16 & 255,
    n >>> 8 & 255,
    n & 255,
    o >>> 24,
    o >>> 16 & 255,
    o >>> 8 & 255,
    o & 255
  ];
};
Long$1.fromBytes = function e(n, o, u) {
  return u ? Long$1.fromBytesLE(n, o) : Long$1.fromBytesBE(n, o);
};
Long$1.fromBytesLE = function e(n, o) {
  return new Long$1(
    n[0] | n[1] << 8 | n[2] << 16 | n[3] << 24,
    n[4] | n[5] << 8 | n[6] << 16 | n[7] << 24,
    o
  );
};
Long$1.fromBytesBE = function e(n, o) {
  return new Long$1(
    n[4] << 24 | n[5] << 16 | n[6] << 8 | n[7],
    n[0] << 24 | n[1] << 16 | n[2] << 8 | n[3],
    o
  );
};
var __importDefault$b = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(signing, "__esModule", { value: !0 });
signing.makeSignBytes = signing.makeSignDoc = signing.makeAuthInfoBytes = void 0;
const utils_1$a = build$7, signing_1$4 = signing$3, tx_1$b = tx$p, long_1$9 = __importDefault$b(long$1);
function makeSignerInfos(e, n) {
  return e.map(({ pubkey: o, sequence: u }) => ({
    publicKey: o,
    modeInfo: {
      single: { mode: n }
    },
    sequence: long_1$9.default.fromNumber(u)
  }));
}
function makeAuthInfoBytes(e, n, o, u, c, d = signing_1$4.SignMode.SIGN_MODE_DIRECT) {
  (0, utils_1$a.assert)(u === void 0 || typeof u == "string", "feeGranter must be undefined or string"), (0, utils_1$a.assert)(c === void 0 || typeof c == "string", "feePayer must be undefined or string");
  const m = {
    signerInfos: makeSignerInfos(e, d),
    fee: {
      amount: [...n],
      gasLimit: long_1$9.default.fromNumber(o),
      granter: u,
      payer: c
    }
  };
  return tx_1$b.AuthInfo.encode(tx_1$b.AuthInfo.fromPartial(m)).finish();
}
signing.makeAuthInfoBytes = makeAuthInfoBytes;
function makeSignDoc(e, n, o, u) {
  return {
    bodyBytes: e,
    authInfoBytes: n,
    chainId: o,
    accountNumber: long_1$9.default.fromNumber(u)
  };
}
signing.makeSignDoc = makeSignDoc;
function makeSignBytes({ accountNumber: e, authInfoBytes: n, bodyBytes: o, chainId: u }) {
  const c = tx_1$b.SignDoc.fromPartial({
    accountNumber: e,
    authInfoBytes: n,
    bodyBytes: o,
    chainId: u
  });
  return tx_1$b.SignDoc.encode(c).finish();
}
signing.makeSignBytes = makeSignBytes;
var wallet = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decrypt = e.encrypt = e.supportedAlgorithms = e.executeKdf = e.cosmjsSalt = void 0;
  const n = build$8, o = build$a;
  e.cosmjsSalt = (0, o.toAscii)("The CosmJS salt.");
  async function u(m, v) {
    switch (v.algorithm) {
      case "argon2id": {
        const S = v.params;
        if (!(0, n.isArgon2idOptions)(S))
          throw new Error("Invalid format of argon2id params");
        return n.Argon2id.execute(m, e.cosmjsSalt, S);
      }
      default:
        throw new Error("Unsupported KDF algorithm");
    }
  }
  e.executeKdf = u, e.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
  };
  async function c(m, v, S) {
    switch (S.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const $ = n.Random.getBytes(n.xchacha20NonceLength);
        return new Uint8Array([
          ...$,
          ...await n.Xchacha20poly1305Ietf.encrypt(m, v, $)
        ]);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${S.algorithm}'`);
    }
  }
  e.encrypt = c;
  async function d(m, v, S) {
    switch (S.algorithm) {
      case e.supportedAlgorithms.xchacha20poly1305Ietf: {
        const $ = m.slice(0, n.xchacha20NonceLength);
        return n.Xchacha20poly1305Ietf.decrypt(m.slice(n.xchacha20NonceLength), v, $);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${S.algorithm}'`);
    }
  }
  e.decrypt = d;
})(wallet);
Object.defineProperty(directsecp256k1hdwallet, "__esModule", { value: !0 });
directsecp256k1hdwallet.DirectSecp256k1HdWallet = directsecp256k1hdwallet.extractKdfConfiguration = void 0;
const amino_1$4 = build$9, crypto_1$4 = build$8, encoding_1$d = build$a, utils_1$9 = build$7, signing_1$3 = signing, wallet_1 = wallet, serializationTypeV1 = "directsecp256k1hdwallet-v1", basicPasswordHashingOptions = {
  algorithm: "argon2id",
  params: {
    outputLength: 32,
    opsLimit: 24,
    memLimitKib: 12 * 1024
  }
};
function isDerivationJson(e) {
  return !(!(0, utils_1$9.isNonNullObject)(e) || typeof e.hdPath != "string" || typeof e.prefix != "string");
}
function extractKdfConfigurationV1(e) {
  return e.kdf;
}
function extractKdfConfiguration(e) {
  const n = JSON.parse(e);
  if (!(0, utils_1$9.isNonNullObject)(n))
    throw new Error("Root document is not an object.");
  switch (n.type) {
    case serializationTypeV1:
      return extractKdfConfigurationV1(n);
    default:
      throw new Error("Unsupported serialization type");
  }
}
directsecp256k1hdwallet.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
  bip39Password: "",
  hdPaths: [(0, amino_1$4.makeCosmoshubPath)(0)],
  prefix: "cosmos"
};
class DirectSecp256k1HdWallet {
  constructor(n, o) {
    var u, c;
    const d = (u = o.prefix) !== null && u !== void 0 ? u : defaultOptions.prefix, m = (c = o.hdPaths) !== null && c !== void 0 ? c : defaultOptions.hdPaths;
    this.secret = n, this.seed = o.seed, this.accounts = m.map((v) => ({
      hdPath: v,
      prefix: d
    }));
  }
  /**
   * Restores a wallet from the given BIP39 mnemonic.
   *
   * @param mnemonic Any valid English mnemonic.
   * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async fromMnemonic(n, o = {}) {
    const u = new crypto_1$4.EnglishMnemonic(n), c = await crypto_1$4.Bip39.mnemonicToSeed(u, o.bip39Password);
    return new DirectSecp256k1HdWallet(u, {
      ...o,
      seed: c
    });
  }
  /**
   * Generates a new wallet with a BIP39 mnemonic of the given length.
   *
   * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
   * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async generate(n = 12, o = {}) {
    const u = 4 * Math.floor(11 * n / 33), c = crypto_1$4.Random.getBytes(u), d = crypto_1$4.Bip39.encode(c);
    return DirectSecp256k1HdWallet.fromMnemonic(d.toString(), o);
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  static async deserialize(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$9.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    switch (u.type) {
      case serializationTypeV1:
        return DirectSecp256k1HdWallet.deserializeTypeV1(n, o);
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
   * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
   * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
   */
  static async deserializeWithEncryptionKey(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$9.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    const c = u;
    switch (c.type) {
      case serializationTypeV1: {
        const d = await (0, wallet_1.decrypt)((0, encoding_1$d.fromBase64)(c.data), o, c.encryption), m = JSON.parse((0, encoding_1$d.fromUtf8)(d)), { mnemonic: v, accounts: S } = m;
        if ((0, utils_1$9.assert)(typeof v == "string"), !Array.isArray(S))
          throw new Error("Property 'accounts' is not an array");
        if (!S.every((O) => isDerivationJson(O)))
          throw new Error("Account is not in the correct format.");
        const $ = S[0].prefix;
        if (!S.every(({ prefix: O }) => O === $))
          throw new Error("Accounts do not all have the same prefix");
        const E = S.map(({ hdPath: O }) => (0, crypto_1$4.stringToPath)(O));
        return DirectSecp256k1HdWallet.fromMnemonic(v, {
          hdPaths: E,
          prefix: $
        });
      }
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  static async deserializeTypeV1(n, o) {
    const u = JSON.parse(n);
    if (!(0, utils_1$9.isNonNullObject)(u))
      throw new Error("Root document is not an object.");
    const c = await (0, wallet_1.executeKdf)(o, u.kdf);
    return DirectSecp256k1HdWallet.deserializeWithEncryptionKey(n, c);
  }
  get mnemonic() {
    return this.secret.toString();
  }
  async getAccounts() {
    return (await this.getAccountsWithPrivkeys()).map(({ algo: o, pubkey: u, address: c }) => ({
      algo: o,
      pubkey: u,
      address: c
    }));
  }
  async signDirect(n, o) {
    const c = (await this.getAccountsWithPrivkeys()).find(({ address: T }) => T === n);
    if (c === void 0)
      throw new Error(`Address ${n} not found in wallet`);
    const { privkey: d, pubkey: m } = c, v = (0, signing_1$3.makeSignBytes)(o), S = (0, crypto_1$4.sha256)(v), $ = await crypto_1$4.Secp256k1.createSignature(S, d), E = new Uint8Array([...$.r(32), ...$.s(32)]), O = (0, amino_1$4.encodeSecp256k1Signature)(m, E);
    return {
      signed: o,
      signature: O
    };
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  async serialize(n) {
    const o = basicPasswordHashingOptions, u = await (0, wallet_1.executeKdf)(n, o);
    return this.serializeWithEncryptionKey(u, o);
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
   * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF options. If this
   * is not the case, the wallet cannot be restored with the original password.
   */
  async serializeWithEncryptionKey(n, o) {
    const u = {
      mnemonic: this.mnemonic,
      accounts: this.accounts.map(({ hdPath: S, prefix: $ }) => ({
        hdPath: (0, crypto_1$4.pathToString)(S),
        prefix: $
      }))
    }, c = (0, encoding_1$d.toUtf8)(JSON.stringify(u)), d = {
      algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf
    }, m = await (0, wallet_1.encrypt)(c, n, d), v = {
      type: serializationTypeV1,
      kdf: o,
      encryption: d,
      data: (0, encoding_1$d.toBase64)(m)
    };
    return JSON.stringify(v);
  }
  async getKeyPair(n) {
    const { privkey: o } = crypto_1$4.Slip10.derivePath(crypto_1$4.Slip10Curve.Secp256k1, this.seed, n), { pubkey: u } = await crypto_1$4.Secp256k1.makeKeypair(o);
    return {
      privkey: o,
      pubkey: crypto_1$4.Secp256k1.compressPubkey(u)
    };
  }
  async getAccountsWithPrivkeys() {
    return Promise.all(this.accounts.map(async ({ hdPath: n, prefix: o }) => {
      const { privkey: u, pubkey: c } = await this.getKeyPair(n), d = (0, encoding_1$d.toBech32)(o, (0, amino_1$4.rawSecp256k1PubkeyToRawAddress)(c));
      return {
        algo: "secp256k1",
        privkey: u,
        pubkey: c,
        address: d
      };
    }));
  }
}
directsecp256k1hdwallet.DirectSecp256k1HdWallet = DirectSecp256k1HdWallet;
var directsecp256k1wallet = {};
Object.defineProperty(directsecp256k1wallet, "__esModule", { value: !0 });
directsecp256k1wallet.DirectSecp256k1Wallet = void 0;
const amino_1$3 = build$9, crypto_1$3 = build$8, encoding_1$c = build$a, signing_1$2 = signing;
class DirectSecp256k1Wallet {
  constructor(n, o, u) {
    this.privkey = n, this.pubkey = o, this.prefix = u;
  }
  /**
   * Creates a DirectSecp256k1Wallet from the given private key
   *
   * @param privkey The private key.
   * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
   */
  static async fromKey(n, o = "cosmos") {
    const u = (await crypto_1$3.Secp256k1.makeKeypair(n)).pubkey;
    return new DirectSecp256k1Wallet(n, crypto_1$3.Secp256k1.compressPubkey(u), o);
  }
  get address() {
    return (0, encoding_1$c.toBech32)(this.prefix, (0, amino_1$3.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
  }
  async getAccounts() {
    return [
      {
        algo: "secp256k1",
        address: this.address,
        pubkey: this.pubkey
      }
    ];
  }
  async signDirect(n, o) {
    const u = (0, signing_1$2.makeSignBytes)(o);
    if (n !== this.address)
      throw new Error(`Address ${n} not found in wallet`);
    const c = (0, crypto_1$3.sha256)(u), d = await crypto_1$3.Secp256k1.createSignature(c, this.privkey), m = new Uint8Array([...d.r(32), ...d.s(32)]), v = (0, amino_1$3.encodeSecp256k1Signature)(this.pubkey, m);
    return {
      signed: o,
      signature: v
    };
  }
}
directsecp256k1wallet.DirectSecp256k1Wallet = DirectSecp256k1Wallet;
var paths = {};
Object.defineProperty(paths, "__esModule", { value: !0 });
paths.makeCosmoshubPath = void 0;
const crypto_1$2 = build$8;
function makeCosmoshubPath(e) {
  return [
    crypto_1$2.Slip10RawIndex.hardened(44),
    crypto_1$2.Slip10RawIndex.hardened(118),
    crypto_1$2.Slip10RawIndex.hardened(0),
    crypto_1$2.Slip10RawIndex.normal(0),
    crypto_1$2.Slip10RawIndex.normal(e)
  ];
}
paths.makeCosmoshubPath = makeCosmoshubPath;
var pubkey = {};
Object.defineProperty(pubkey, "__esModule", { value: !0 });
pubkey.decodePubkey = pubkey.anyToSinglePubkey = pubkey.encodePubkey = void 0;
const amino_1$2 = build$9, encoding_1$b = build$a, math_1$9 = build$6, keys_1 = keys$7, keys_2 = keys$6, keys_3 = keys$5, any_1$2 = any$1;
function encodePubkey(e) {
  if ((0, amino_1$2.isSecp256k1Pubkey)(e)) {
    const n = keys_3.PubKey.fromPartial({
      key: (0, encoding_1$b.fromBase64)(e.value)
    });
    return any_1$2.Any.fromPartial({
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: Uint8Array.from(keys_3.PubKey.encode(n).finish())
    });
  } else if ((0, amino_1$2.isEd25519Pubkey)(e)) {
    const n = keys_1.PubKey.fromPartial({
      key: (0, encoding_1$b.fromBase64)(e.value)
    });
    return any_1$2.Any.fromPartial({
      typeUrl: "/cosmos.crypto.ed25519.PubKey",
      value: Uint8Array.from(keys_1.PubKey.encode(n).finish())
    });
  } else if ((0, amino_1$2.isMultisigThresholdPubkey)(e)) {
    const n = keys_2.LegacyAminoPubKey.fromPartial({
      threshold: math_1$9.Uint53.fromString(e.value.threshold).toNumber(),
      publicKeys: e.value.pubkeys.map(encodePubkey)
    });
    return any_1$2.Any.fromPartial({
      typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
      value: Uint8Array.from(keys_2.LegacyAminoPubKey.encode(n).finish())
    });
  } else
    throw new Error(`Pubkey type ${e.type} not recognized`);
}
pubkey.encodePubkey = encodePubkey;
function anyToSinglePubkey(e) {
  switch (e.typeUrl) {
    case "/cosmos.crypto.secp256k1.PubKey": {
      const { key: n } = keys_3.PubKey.decode(e.value);
      return (0, amino_1$2.encodeSecp256k1Pubkey)(n);
    }
    case "/cosmos.crypto.ed25519.PubKey": {
      const { key: n } = keys_1.PubKey.decode(e.value);
      return (0, amino_1$2.encodeEd25519Pubkey)(n);
    }
    default:
      throw new Error(`Pubkey type_url ${e.typeUrl} not recognized as single public key type`);
  }
}
pubkey.anyToSinglePubkey = anyToSinglePubkey;
function decodePubkey$1(e) {
  if (!e || !e.value)
    return null;
  switch (e.typeUrl) {
    case "/cosmos.crypto.secp256k1.PubKey":
    case "/cosmos.crypto.ed25519.PubKey":
      return anyToSinglePubkey(e);
    case "/cosmos.crypto.multisig.LegacyAminoPubKey": {
      const { threshold: n, publicKeys: o } = keys_2.LegacyAminoPubKey.decode(e.value);
      return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
          threshold: n.toString(),
          pubkeys: o.map(anyToSinglePubkey)
        }
      };
    }
    default:
      throw new Error(`Pubkey type_url ${e.typeUrl} not recognized`);
  }
}
pubkey.decodePubkey = decodePubkey$1;
var registry$j = {};
Object.defineProperty(registry$j, "__esModule", { value: !0 });
registry$j.Registry = registry$j.isTxBodyEncodeObject = registry$j.isPbjsGeneratedType = registry$j.isTsProtoGeneratedType = void 0;
const tx_1$a = tx$o, coin_1 = coin$8, tx_2$2 = tx$p, any_1$1 = any$1;
function isTsProtoGeneratedType(e) {
  return typeof e.fromPartial == "function";
}
registry$j.isTsProtoGeneratedType = isTsProtoGeneratedType;
function isPbjsGeneratedType(e) {
  return !isTsProtoGeneratedType(e);
}
registry$j.isPbjsGeneratedType = isPbjsGeneratedType;
const defaultTypeUrls = {
  cosmosCoin: "/cosmos.base.v1beta1.Coin",
  cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
  cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
  googleAny: "/google.protobuf.Any"
};
function isTxBodyEncodeObject(e) {
  return e.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
registry$j.isTxBodyEncodeObject = isTxBodyEncodeObject;
class Registry {
  /**
   * Creates a new Registry for mapping protobuf type identifiers/type URLs to
   * actual implementations. Those implementations are typically generated with ts-proto
   * but we also support protobuf.js as a type generator.
   *
   * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
   * for historic reasons. Those can be overriden by customTypes.
   *
   * There are currently two methods for adding new types:
   * 1. Passing types to the constructor.
   * 2. Using the `register()` method
   */
  constructor(n) {
    const { cosmosCoin: o, cosmosMsgSend: u } = defaultTypeUrls;
    this.types = n ? new Map([...n]) : /* @__PURE__ */ new Map([
      [o, coin_1.Coin],
      [u, tx_1$a.MsgSend]
    ]);
  }
  register(n, o) {
    this.types.set(n, o);
  }
  /**
   * Looks up a type that was previously added to the registry.
   *
   * The generator information (ts-proto or pbjs) gets lost along the way.
   * If you need to work with the result type in TypeScript, you can use:
   *
   * ```
   * import { assert } from "@cosmjs/utils";
   *
   * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
   * assert(Coin); // Ensures not unset
   * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
   *
   * // Coin is typed TsProtoGeneratedType now.
   * ```
   */
  lookupType(n) {
    return this.types.get(n);
  }
  lookupTypeWithError(n) {
    const o = this.lookupType(n);
    if (!o)
      throw new Error(`Unregistered type url: ${n}`);
    return o;
  }
  /**
   * Takes a typeUrl/value pair and encodes the value to protobuf if
   * the given type was previously registered.
   *
   * If the value has to be wrapped in an Any, this needs to be done
   * manually after this call. Or use `encodeAsAny` instead.
   */
  encode(n) {
    const { value: o, typeUrl: u } = n;
    if (isTxBodyEncodeObject(n))
      return this.encodeTxBody(o);
    const c = this.lookupTypeWithError(u), d = isTsProtoGeneratedType(c) ? c.fromPartial(o) : c.create(o);
    return c.encode(d).finish();
  }
  /**
   * Takes a typeUrl/value pair and encodes the value to an Any if
   * the given type was previously registered.
   */
  encodeAsAny(n) {
    const o = this.encode(n);
    return any_1$1.Any.fromPartial({
      typeUrl: n.typeUrl,
      value: o
    });
  }
  encodeTxBody(n) {
    const o = n.messages.map((c) => this.encodeAsAny(c)), u = tx_2$2.TxBody.fromPartial({
      ...n,
      messages: o
    });
    return tx_2$2.TxBody.encode(u).finish();
  }
  decode({ typeUrl: n, value: o }) {
    if (n === defaultTypeUrls.cosmosTxBody)
      return this.decodeTxBody(o);
    const c = this.lookupTypeWithError(n).decode(o);
    return Object.entries(c).forEach(([d, m]) => {
      typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(m) && (c[d] = Uint8Array.from(m));
    }), c;
  }
  decodeTxBody(n) {
    const o = tx_2$2.TxBody.decode(n);
    return {
      ...o,
      messages: o.messages.map(({ typeUrl: u, value: c }) => {
        if (!u)
          throw new Error("Missing type_url in Any");
        if (!c)
          throw new Error("Missing value in Any");
        return this.decode({ typeUrl: u, value: c });
      })
    };
  }
}
registry$j.Registry = Registry;
var signer = {};
Object.defineProperty(signer, "__esModule", { value: !0 });
signer.isOfflineDirectSigner = void 0;
function isOfflineDirectSigner(e) {
  return e.signDirect !== void 0;
}
signer.isOfflineDirectSigner = isOfflineDirectSigner;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.coins = e.coin = e.executeKdf = e.makeSignDoc = e.makeSignBytes = e.makeAuthInfoBytes = e.isOfflineDirectSigner = e.Registry = e.isTxBodyEncodeObject = e.isTsProtoGeneratedType = e.isPbjsGeneratedType = e.encodePubkey = e.decodePubkey = e.anyToSinglePubkey = e.makeCosmoshubPath = e.DirectSecp256k1Wallet = e.extractKdfConfiguration = e.DirectSecp256k1HdWallet = e.decodeTxRaw = e.parseCoins = void 0;
  var n = coins;
  Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return n.parseCoins;
  } });
  var o = decode;
  Object.defineProperty(e, "decodeTxRaw", { enumerable: !0, get: function() {
    return o.decodeTxRaw;
  } });
  var u = directsecp256k1hdwallet;
  Object.defineProperty(e, "DirectSecp256k1HdWallet", { enumerable: !0, get: function() {
    return u.DirectSecp256k1HdWallet;
  } }), Object.defineProperty(e, "extractKdfConfiguration", { enumerable: !0, get: function() {
    return u.extractKdfConfiguration;
  } });
  var c = directsecp256k1wallet;
  Object.defineProperty(e, "DirectSecp256k1Wallet", { enumerable: !0, get: function() {
    return c.DirectSecp256k1Wallet;
  } });
  var d = paths;
  Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return d.makeCosmoshubPath;
  } });
  var m = pubkey;
  Object.defineProperty(e, "anyToSinglePubkey", { enumerable: !0, get: function() {
    return m.anyToSinglePubkey;
  } }), Object.defineProperty(e, "decodePubkey", { enumerable: !0, get: function() {
    return m.decodePubkey;
  } }), Object.defineProperty(e, "encodePubkey", { enumerable: !0, get: function() {
    return m.encodePubkey;
  } });
  var v = registry$j;
  Object.defineProperty(e, "isPbjsGeneratedType", { enumerable: !0, get: function() {
    return v.isPbjsGeneratedType;
  } }), Object.defineProperty(e, "isTsProtoGeneratedType", { enumerable: !0, get: function() {
    return v.isTsProtoGeneratedType;
  } }), Object.defineProperty(e, "isTxBodyEncodeObject", { enumerable: !0, get: function() {
    return v.isTxBodyEncodeObject;
  } }), Object.defineProperty(e, "Registry", { enumerable: !0, get: function() {
    return v.Registry;
  } });
  var S = signer;
  Object.defineProperty(e, "isOfflineDirectSigner", { enumerable: !0, get: function() {
    return S.isOfflineDirectSigner;
  } });
  var $ = signing;
  Object.defineProperty(e, "makeAuthInfoBytes", { enumerable: !0, get: function() {
    return $.makeAuthInfoBytes;
  } }), Object.defineProperty(e, "makeSignBytes", { enumerable: !0, get: function() {
    return $.makeSignBytes;
  } }), Object.defineProperty(e, "makeSignDoc", { enumerable: !0, get: function() {
    return $.makeSignDoc;
  } });
  var E = wallet;
  Object.defineProperty(e, "executeKdf", { enumerable: !0, get: function() {
    return E.executeKdf;
  } });
  var O = build$9;
  Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return O.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return O.coins;
  } });
})(build$4);
Object.defineProperty(accounts, "__esModule", { value: !0 });
accounts.accountFromAny = void 0;
const math_1$8 = build$6, proto_signing_1$4 = build$4, utils_1$8 = build$7, auth_1 = auth, vesting_1 = vesting;
function uint64FromProto(e) {
  return math_1$8.Uint64.fromString(e.toString());
}
function accountFromBaseAccount(e) {
  const { address: n, pubKey: o, accountNumber: u, sequence: c } = e, d = (0, proto_signing_1$4.decodePubkey)(o);
  return {
    address: n,
    pubkey: d,
    accountNumber: uint64FromProto(u).toNumber(),
    sequence: uint64FromProto(c).toNumber()
  };
}
function accountFromAny(e) {
  var n, o, u, c, d, m, v;
  const { typeUrl: S, value: $ } = e;
  switch (S) {
    case "/cosmos.auth.v1beta1.BaseAccount":
      return accountFromBaseAccount(auth_1.BaseAccount.decode($));
    case "/cosmos.auth.v1beta1.ModuleAccount": {
      const E = auth_1.ModuleAccount.decode($).baseAccount;
      return (0, utils_1$8.assert)(E), accountFromBaseAccount(E);
    }
    case "/cosmos.vesting.v1beta1.BaseVestingAccount": {
      const E = (n = vesting_1.BaseVestingAccount.decode($)) === null || n === void 0 ? void 0 : n.baseAccount;
      return (0, utils_1$8.assert)(E), accountFromBaseAccount(E);
    }
    case "/cosmos.vesting.v1beta1.ContinuousVestingAccount": {
      const E = (u = (o = vesting_1.ContinuousVestingAccount.decode($)) === null || o === void 0 ? void 0 : o.baseVestingAccount) === null || u === void 0 ? void 0 : u.baseAccount;
      return (0, utils_1$8.assert)(E), accountFromBaseAccount(E);
    }
    case "/cosmos.vesting.v1beta1.DelayedVestingAccount": {
      const E = (d = (c = vesting_1.DelayedVestingAccount.decode($)) === null || c === void 0 ? void 0 : c.baseVestingAccount) === null || d === void 0 ? void 0 : d.baseAccount;
      return (0, utils_1$8.assert)(E), accountFromBaseAccount(E);
    }
    case "/cosmos.vesting.v1beta1.PeriodicVestingAccount": {
      const E = (v = (m = vesting_1.PeriodicVestingAccount.decode($)) === null || m === void 0 ? void 0 : m.baseVestingAccount) === null || v === void 0 ? void 0 : v.baseAccount;
      return (0, utils_1$8.assert)(E), accountFromBaseAccount(E);
    }
    default:
      throw new Error(`Unsupported type: '${S}'`);
  }
}
accounts.accountFromAny = accountFromAny;
var aminotypes = {};
Object.defineProperty(aminotypes, "__esModule", { value: !0 });
aminotypes.AminoTypes = void 0;
function isAminoConverter(e) {
  return typeof e[1] != "string";
}
class AminoTypes {
  constructor(n) {
    this.register = n;
  }
  toAmino({ typeUrl: n, value: o }) {
    const u = this.register[n];
    if (u === "not_supported_by_chain")
      throw new Error(`The message type '${n}' cannot be signed using the Amino JSON sign mode because this is not supported by chain.`);
    if (!u)
      throw new Error(`Type URL '${n}' does not exist in the Amino message type register. If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.`);
    return {
      type: u.aminoType,
      value: u.toAmino(o)
    };
  }
  fromAmino({ type: n, value: o }) {
    const u = Object.entries(this.register).filter(isAminoConverter).filter(([c, { aminoType: d }]) => d === n);
    switch (u.length) {
      case 0:
        throw new Error(`Amino type identifier '${n}' does not exist in the Amino message type register. If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.`);
      case 1: {
        const [c, d] = u[0];
        return {
          typeUrl: c,
          value: d.fromAmino(o)
        };
      }
      default:
        throw new Error(`Multiple types are registered with Amino type identifier '${n}': '` + u.map(([c, d]) => c).sort().join("', '") + "'. Thus fromAmino cannot be performed.");
    }
  }
}
aminotypes.AminoTypes = AminoTypes;
var events = {};
Object.defineProperty(events, "__esModule", { value: !0 });
events.fromTendermint34Event = void 0;
const encoding_1$a = build$a;
function fromTendermint34Event(e) {
  return {
    type: e.type,
    attributes: e.attributes.map((n) => ({
      key: (0, encoding_1$a.fromUtf8)(n.key, !0),
      value: (0, encoding_1$a.fromUtf8)(n.value, !0)
    }))
  };
}
events.fromTendermint34Event = fromTendermint34Event;
var fee = {};
Object.defineProperty(fee, "__esModule", { value: !0 });
fee.calculateFee = fee.GasPrice = void 0;
const math_1$7 = build$6, proto_signing_1$3 = build$4;
function checkDenom(e) {
  if (e.length < 3 || e.length > 128)
    throw new Error("Denom must be between 3 and 128 characters");
}
class GasPrice {
  constructor(n, o) {
    this.amount = n, this.denom = o;
  }
  /**
   * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
   *
   * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
   * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
   *
   * Separators are not yet supported.
   */
  static fromString(n) {
    const o = n.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
    if (!o)
      throw new Error("Invalid gas price string");
    const [u, c, d] = o;
    checkDenom(d);
    const m = 18, v = math_1$7.Decimal.fromUserInput(c, m);
    return new GasPrice(v, d);
  }
  /**
   * Returns a string representation of this gas price, e.g. "0.025uatom".
   * This can be used as an input to `GasPrice.fromString`.
   */
  toString() {
    return this.amount.toString() + this.denom;
  }
}
fee.GasPrice = GasPrice;
function calculateFee(e, n) {
  const o = typeof n == "string" ? GasPrice.fromString(n) : n, { denom: u, amount: c } = o, d = c.multiply(new math_1$7.Uint53(e)).ceil().toString();
  return {
    amount: (0, proto_signing_1$3.coins)(d, u),
    gas: e.toString()
  };
}
fee.calculateFee = calculateFee;
var logs = {};
Object.defineProperty(logs, "__esModule", { value: !0 });
logs.findAttribute = logs.parseRawLog = logs.parseLogs = logs.parseLog = logs.parseEvent = logs.parseAttribute = void 0;
const utils_1$7 = build$7;
function parseAttribute(e) {
  if (!(0, utils_1$7.isNonNullObject)(e))
    throw new Error("Attribute must be a non-null object");
  const { key: n, value: o } = e;
  if (typeof n != "string" || !n)
    throw new Error("Attribute's key must be a non-empty string");
  if (typeof o != "string" && typeof o < "u")
    throw new Error("Attribute's value must be a string or unset");
  return {
    key: n,
    value: o || ""
  };
}
logs.parseAttribute = parseAttribute;
function parseEvent(e) {
  if (!(0, utils_1$7.isNonNullObject)(e))
    throw new Error("Event must be a non-null object");
  const { type: n, attributes: o } = e;
  if (typeof n != "string" || n === "")
    throw new Error("Event type must be a non-empty string");
  if (!Array.isArray(o))
    throw new Error("Event's attributes must be an array");
  return {
    type: n,
    attributes: o.map(parseAttribute)
  };
}
logs.parseEvent = parseEvent;
function parseLog(e) {
  if (!(0, utils_1$7.isNonNullObject)(e))
    throw new Error("Log must be a non-null object");
  const { msg_index: n, log: o, events: u } = e;
  if (typeof n != "number")
    throw new Error("Log's msg_index must be a number");
  if (typeof o != "string")
    throw new Error("Log's log must be a string");
  if (!Array.isArray(u))
    throw new Error("Log's events must be an array");
  return {
    msg_index: n,
    log: o,
    events: u.map(parseEvent)
  };
}
logs.parseLog = parseLog;
function parseLogs(e) {
  if (!Array.isArray(e))
    throw new Error("Logs must be an array");
  return e.map(parseLog);
}
logs.parseLogs = parseLogs;
function parseRawLog(e = "[]") {
  const n = JSON.parse(e).map(({ events: o }, u) => ({
    msg_index: u,
    events: o,
    log: ""
  }));
  return parseLogs(n);
}
logs.parseRawLog = parseRawLog;
function findAttribute(e, n, o) {
  var u;
  const c = e.find(() => !0), d = (u = c == null ? void 0 : c.events.find((m) => m.type === n)) === null || u === void 0 ? void 0 : u.attributes.find((m) => m.key === o);
  if (!d)
    throw new Error(`Could not find attribute '${o}' in first event of type '${n}' in first log.`);
  return d;
}
logs.findAttribute = findAttribute;
var modules = {}, queries$a = {}, queryclient$1 = {}, queryclient = {}, build$3 = {}, concat$1 = {};
Object.defineProperty(concat$1, "__esModule", { value: !0 });
concat$1.concat = void 0;
const xstream_1$5 = xstream;
function concat(...e) {
  const n = new Array(), o = new Array(), u = /* @__PURE__ */ new Set();
  let c = 0;
  function d() {
    for (; n.length > 0; )
      n.shift().unsubscribe();
    o.length = 0, u.clear(), c = 0;
  }
  const m = {
    start: (v) => {
      e.forEach((E) => o.push([]));
      function S(E) {
        for (; ; ) {
          const O = o[E].shift();
          if (O === void 0)
            return;
          v.next(O);
        }
      }
      function $() {
        return c >= e.length;
      }
      if ($()) {
        v.complete();
        return;
      }
      e.forEach((E, O) => {
        n.push(E.subscribe({
          next: (T) => {
            O === c ? v.next(T) : o[O].push(T);
          },
          complete: () => {
            for (u.add(O); u.has(c); )
              S(c), c++;
            $() ? v.complete() : S(c);
          },
          error: (T) => {
            v.error(T), d();
          }
        }));
      });
    },
    stop: () => {
      d();
    }
  };
  return xstream_1$5.Stream.create(m);
}
concat$1.concat = concat;
var defaultvalueproducer = {};
Object.defineProperty(defaultvalueproducer, "__esModule", { value: !0 });
defaultvalueproducer.DefaultValueProducer = void 0;
class DefaultValueProducer {
  constructor(n, o) {
    this.callbacks = o, this.internalValue = n;
  }
  get value() {
    return this.internalValue;
  }
  /**
   * Update the current value.
   *
   * If producer is active (i.e. someone is listening), this emits an event.
   * If not, just the current value is updated.
   */
  update(n) {
    this.internalValue = n, this.listener && this.listener.next(n);
  }
  /**
   * Produce an error
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error(n) {
    this.listener && this.listener.error(n);
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  start(n) {
    this.listener = n, n.next(this.internalValue), this.callbacks && this.callbacks.onStarted();
  }
  /**
   * Called by the stream. Do not call this directly.
   */
  stop() {
    this.callbacks && this.callbacks.onStop(), this.listener = void 0;
  }
}
defaultvalueproducer.DefaultValueProducer = DefaultValueProducer;
var dropduplicates = {};
Object.defineProperty(dropduplicates, "__esModule", { value: !0 });
dropduplicates.dropDuplicates = void 0;
function dropDuplicates(e) {
  return (o) => {
    const u = /* @__PURE__ */ new Set();
    return o.filter((d) => !u.has(e(d))).debug((d) => u.add(e(d)));
  };
}
dropduplicates.dropDuplicates = dropDuplicates;
var promise = {};
Object.defineProperty(promise, "__esModule", { value: !0 });
promise.firstEvent = promise.toListPromise = promise.fromListPromise = void 0;
const xstream_1$4 = xstream;
function fromListPromise(e) {
  const n = {
    start: (o) => {
      e.then((u) => {
        for (const c of u)
          o.next(c);
        o.complete();
      }).catch((u) => o.error(u));
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    stop: () => {
    }
  };
  return xstream_1$4.Stream.create(n);
}
promise.fromListPromise = fromListPromise;
async function toListPromise(e, n) {
  return new Promise((o, u) => {
    if (n === 0) {
      o([]);
      return;
    }
    const c = new Array();
    e.take(n).subscribe({
      next: (d) => {
        c.push(d), c.length === n && o(c);
      },
      complete: () => {
        u(`Stream completed before all events could be collected. Collected ${c.length}, expected ${n}`);
      },
      error: (d) => u(d)
    });
  });
}
promise.toListPromise = toListPromise;
async function firstEvent(e) {
  return (await toListPromise(e, 1))[0];
}
promise.firstEvent = firstEvent;
var reducer = {};
Object.defineProperty(reducer, "__esModule", { value: !0 });
reducer.lastValue = reducer.asArray = reducer.countStream = reducer.Reducer = void 0;
class Reducer {
  constructor(n, o, u) {
    this.stream = n, this.reducer = o, this.state = u, this.completed = new Promise((c, d) => {
      const m = this.stream.subscribe({
        next: (v) => {
          this.state = this.reducer(this.state, v);
        },
        complete: () => {
          c(), m.unsubscribe();
        },
        error: (v) => {
          d(v), m.unsubscribe();
        }
      });
    });
  }
  // value returns current materialized state
  value() {
    return this.state;
  }
  // finished resolves on completed stream, rejects on stream error
  async finished() {
    return this.completed;
  }
}
reducer.Reducer = Reducer;
function increment(e, n) {
  return e + 1;
}
function countStream(e) {
  return new Reducer(e, increment, 0);
}
reducer.countStream = countStream;
function append(e, n) {
  return [...e, n];
}
function asArray(e) {
  return new Reducer(e, append, []);
}
reducer.asArray = asArray;
function last(e, n) {
  return n;
}
function lastValue(e) {
  return new Reducer(e, last, void 0);
}
reducer.lastValue = lastValue;
var valueandupdates = {};
Object.defineProperty(valueandupdates, "__esModule", { value: !0 });
valueandupdates.ValueAndUpdates = void 0;
const xstream_1$3 = xstream;
class ValueAndUpdates {
  constructor(n) {
    this.producer = n, this.updates = xstream_1$3.MemoryStream.createWithMemory(this.producer);
  }
  get value() {
    return this.producer.value;
  }
  /**
   * Resolves as soon as search value is found.
   *
   * @param search either a value or a function that must return true when found
   * @returns the value of the update that caused the search match
   */
  async waitFor(n) {
    const o = typeof n == "function" ? n : (u) => u === n;
    return new Promise((u, c) => {
      const d = this.updates.subscribe({
        next: (m) => {
          o(m) && (u(m), setTimeout(() => d.unsubscribe(), 0));
        },
        complete: () => {
          d.unsubscribe(), c("Update stream completed without expected value");
        },
        error: (m) => {
          c(m);
        }
      });
    });
  }
}
valueandupdates.ValueAndUpdates = ValueAndUpdates;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(S, $, E, O) {
    O === void 0 && (O = E);
    var T = Object.getOwnPropertyDescriptor($, E);
    (!T || ("get" in T ? !$.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return $[E];
    } }), Object.defineProperty(S, O, T);
  } : function(S, $, E, O) {
    O === void 0 && (O = E), S[O] = $[E];
  }), o = commonjsGlobal && commonjsGlobal.__exportStar || function(S, $) {
    for (var E in S)
      E !== "default" && !Object.prototype.hasOwnProperty.call($, E) && n($, S, E);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueAndUpdates = e.toListPromise = e.fromListPromise = e.firstEvent = e.dropDuplicates = e.DefaultValueProducer = e.concat = void 0;
  var u = concat$1;
  Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
    return u.concat;
  } });
  var c = defaultvalueproducer;
  Object.defineProperty(e, "DefaultValueProducer", { enumerable: !0, get: function() {
    return c.DefaultValueProducer;
  } });
  var d = dropduplicates;
  Object.defineProperty(e, "dropDuplicates", { enumerable: !0, get: function() {
    return d.dropDuplicates;
  } });
  var m = promise;
  Object.defineProperty(e, "firstEvent", { enumerable: !0, get: function() {
    return m.firstEvent;
  } }), Object.defineProperty(e, "fromListPromise", { enumerable: !0, get: function() {
    return m.fromListPromise;
  } }), Object.defineProperty(e, "toListPromise", { enumerable: !0, get: function() {
    return m.toListPromise;
  } }), o(reducer, e);
  var v = valueandupdates;
  Object.defineProperty(e, "ValueAndUpdates", { enumerable: !0, get: function() {
    return v.ValueAndUpdates;
  } });
})(build$3);
Object.defineProperty(queryclient, "__esModule", { value: !0 });
queryclient.QueryClient = void 0;
const ics23_1 = build$E, encoding_1$9 = build$a, stream_1$2 = build$3, utils_1$6 = build$7;
function checkAndParseOp(e, n, o) {
  if (e.type !== n)
    throw new Error(`Op expected to be ${n}, got "${e.type}`);
  if (!(0, utils_1$6.arrayContentEquals)(o, e.key))
    throw new Error(`Proven key different than queried key.
Query: ${(0, encoding_1$9.toHex)(o)}
Proven: ${(0, encoding_1$9.toHex)(e.key)}`);
  return ics23_1.ics23.CommitmentProof.decode(e.data);
}
class QueryClient {
  constructor(n) {
    this.tmClient = n;
  }
  static withExtensions(n, ...o) {
    const u = new QueryClient(n), c = o.map((d) => d(u));
    for (const d of c) {
      (0, utils_1$6.assert)((0, utils_1$6.isNonNullObject)(d), "Extension must be a non-null object");
      for (const [m, v] of Object.entries(d)) {
        (0, utils_1$6.assert)((0, utils_1$6.isNonNullObject)(v), `Module must be a non-null object. Found type ${typeof v} for module "${m}".`);
        const S = u[m] || {};
        u[m] = {
          ...S,
          ...v
        };
      }
    }
    return u;
  }
  async queryVerified(n, o, u) {
    const { height: c, proof: d, value: m } = await this.queryRawProof(n, o, u), v = checkAndParseOp(d.ops[0], "ics23:iavl", o), S = checkAndParseOp(d.ops[1], "ics23:simple", (0, encoding_1$9.toAscii)(n));
    (0, utils_1$6.assert)(S.exist), (0, utils_1$6.assert)(S.exist.value), !m || m.length === 0 ? ((0, utils_1$6.assert)(v.nonexist), (0, ics23_1.verifyNonExistence)(v.nonexist, ics23_1.iavlSpec, S.exist.value, o)) : ((0, utils_1$6.assert)(v.exist), (0, utils_1$6.assert)(v.exist.value), (0, ics23_1.verifyExistence)(v.exist, ics23_1.iavlSpec, S.exist.value, o, m));
    const $ = await this.getNextHeader(c);
    return (0, ics23_1.verifyExistence)(S.exist, ics23_1.tendermintSpec, $.appHash, (0, encoding_1$9.toAscii)(n), S.exist.value), m;
  }
  async queryRawProof(n, o, u) {
    var c;
    const { key: d, value: m, height: v, proof: S, code: $, log: E } = await this.tmClient.abciQuery({
      // we need the StoreKey for the module, not the module name
      // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
      path: `/store/${n}/key`,
      data: o,
      prove: !0,
      height: u
    });
    if ($)
      throw new Error(`Query failed with (${$}): ${E}`);
    if (!(0, utils_1$6.arrayContentEquals)(o, d))
      throw new Error(`Response key ${(0, encoding_1$9.toHex)(d)} doesn't match query key ${(0, encoding_1$9.toHex)(o)}`);
    if (!v)
      throw new Error("No query height returned");
    if (!S || S.ops.length !== 2)
      throw new Error(`Expected 2 proof ops, got ${(c = S == null ? void 0 : S.ops.length) !== null && c !== void 0 ? c : 0}. Are you using stargate?`);
    return checkAndParseOp(S.ops[0], "ics23:iavl", d), checkAndParseOp(S.ops[1], "ics23:simple", (0, encoding_1$9.toAscii)(n)), {
      key: d,
      value: m,
      height: v,
      // need to clone this: readonly input / writeable output
      proof: {
        ops: [...S.ops]
      }
    };
  }
  async queryUnverified(n, o, u) {
    const c = await this.tmClient.abciQuery({
      path: n,
      data: o,
      prove: !1,
      height: u
    });
    if (c.code)
      throw new Error(`Query failed with (${c.code}): ${c.log}`);
    return c.value;
  }
  // this must return the header for height+1
  // throws an error if height is 0 or undefined
  async getNextHeader(n) {
    if ((0, utils_1$6.assertDefined)(n), n === 0)
      throw new Error("Query returned height 0, cannot prove it");
    const o = n + 1;
    let u, c;
    try {
      c = this.tmClient.subscribeNewBlockHeader();
    } catch {
    }
    if (c) {
      const d = await (0, stream_1$2.firstEvent)(c);
      d.height === o && (u = d);
    }
    for (; !u; ) {
      const d = (await this.tmClient.blockchain(n, o)).blockMetas.map((m) => m.header).find((m) => m.height === o);
      d ? u = d : await (0, utils_1$6.sleep)(1e3);
    }
    return (0, utils_1$6.assert)(u.height === o, "Got wrong header. This is a bug in the logic above."), u;
  }
}
queryclient.QueryClient = QueryClient;
var utils$m = {}, long = Long, wasm = null;
try {
  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch (e) {
}
function Long(e, n, o) {
  this.low = e | 0, this.high = n | 0, this.unsigned = !!o;
}
Long.prototype.__isLong__;
Object.defineProperty(Long.prototype, "__isLong__", { value: !0 });
function isLong(e) {
  return (e && e.__isLong__) === !0;
}
Long.isLong = isLong;
var INT_CACHE = {}, UINT_CACHE = {};
function fromInt(e, n) {
  var o, u, c;
  return n ? (e >>>= 0, (c = 0 <= e && e < 256) && (u = UINT_CACHE[e], u) ? u : (o = fromBits(e, (e | 0) < 0 ? -1 : 0, !0), c && (UINT_CACHE[e] = o), o)) : (e |= 0, (c = -128 <= e && e < 128) && (u = INT_CACHE[e], u) ? u : (o = fromBits(e, e < 0 ? -1 : 0, !1), c && (INT_CACHE[e] = o), o));
}
Long.fromInt = fromInt;
function fromNumber(e, n) {
  if (isNaN(e))
    return n ? UZERO : ZERO;
  if (n) {
    if (e < 0)
      return UZERO;
    if (e >= TWO_PWR_64_DBL)
      return MAX_UNSIGNED_VALUE;
  } else {
    if (e <= -TWO_PWR_63_DBL)
      return MIN_VALUE;
    if (e + 1 >= TWO_PWR_63_DBL)
      return MAX_VALUE;
  }
  return e < 0 ? fromNumber(-e, n).neg() : fromBits(e % TWO_PWR_32_DBL | 0, e / TWO_PWR_32_DBL | 0, n);
}
Long.fromNumber = fromNumber;
function fromBits(e, n, o) {
  return new Long(e, n, o);
}
Long.fromBits = fromBits;
var pow_dbl = Math.pow;
function fromString(e, n, o) {
  if (e.length === 0)
    throw Error("empty string");
  if (e === "NaN" || e === "Infinity" || e === "+Infinity" || e === "-Infinity")
    return ZERO;
  if (typeof n == "number" ? (o = n, n = !1) : n = !!n, o = o || 10, o < 2 || 36 < o)
    throw RangeError("radix");
  var u;
  if ((u = e.indexOf("-")) > 0)
    throw Error("interior hyphen");
  if (u === 0)
    return fromString(e.substring(1), n, o).neg();
  for (var c = fromNumber(pow_dbl(o, 8)), d = ZERO, m = 0; m < e.length; m += 8) {
    var v = Math.min(8, e.length - m), S = parseInt(e.substring(m, m + v), o);
    if (v < 8) {
      var $ = fromNumber(pow_dbl(o, v));
      d = d.mul($).add(fromNumber(S));
    } else
      d = d.mul(c), d = d.add(fromNumber(S));
  }
  return d.unsigned = n, d;
}
Long.fromString = fromString;
function fromValue(e, n) {
  return typeof e == "number" ? fromNumber(e, n) : typeof e == "string" ? fromString(e, n) : fromBits(e.low, e.high, typeof n == "boolean" ? n : e.unsigned);
}
Long.fromValue = fromValue;
var TWO_PWR_16_DBL = 65536, TWO_PWR_24_DBL = 1 << 24, TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL, TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL, TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2, TWO_PWR_24 = fromInt(TWO_PWR_24_DBL), ZERO = fromInt(0);
Long.ZERO = ZERO;
var UZERO = fromInt(0, !0);
Long.UZERO = UZERO;
var ONE = fromInt(1);
Long.ONE = ONE;
var UONE = fromInt(1, !0);
Long.UONE = UONE;
var NEG_ONE = fromInt(-1);
Long.NEG_ONE = NEG_ONE;
var MAX_VALUE = fromBits(-1, 2147483647, !1);
Long.MAX_VALUE = MAX_VALUE;
var MAX_UNSIGNED_VALUE = fromBits(-1, -1, !0);
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
var MIN_VALUE = fromBits(0, -2147483648, !1);
Long.MIN_VALUE = MIN_VALUE;
var LongPrototype = Long.prototype;
LongPrototype.toInt = function e() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype.toNumber = function e() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0) : this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};
LongPrototype.toString = function e(n) {
  if (n = n || 10, n < 2 || 36 < n)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE)) {
      var o = fromNumber(n), u = this.div(o), c = u.mul(o).sub(this);
      return u.toString(n) + c.toInt().toString(n);
    } else
      return "-" + this.neg().toString(n);
  for (var d = fromNumber(pow_dbl(n, 6), this.unsigned), m = this, v = ""; ; ) {
    var S = m.div(d), $ = m.sub(S.mul(d)).toInt() >>> 0, E = $.toString(n);
    if (m = S, m.isZero())
      return E + v;
    for (; E.length < 6; )
      E = "0" + E;
    v = "" + E + v;
  }
};
LongPrototype.getHighBits = function e() {
  return this.high;
};
LongPrototype.getHighBitsUnsigned = function e() {
  return this.high >>> 0;
};
LongPrototype.getLowBits = function e() {
  return this.low;
};
LongPrototype.getLowBitsUnsigned = function e() {
  return this.low >>> 0;
};
LongPrototype.getNumBitsAbs = function e() {
  if (this.isNegative())
    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
  for (var n = this.high != 0 ? this.high : this.low, o = 31; o > 0 && !(n & 1 << o); o--)
    ;
  return this.high != 0 ? o + 33 : o + 1;
};
LongPrototype.isZero = function e() {
  return this.high === 0 && this.low === 0;
};
LongPrototype.eqz = LongPrototype.isZero;
LongPrototype.isNegative = function e() {
  return !this.unsigned && this.high < 0;
};
LongPrototype.isPositive = function e() {
  return this.unsigned || this.high >= 0;
};
LongPrototype.isOdd = function e() {
  return (this.low & 1) === 1;
};
LongPrototype.isEven = function e() {
  return (this.low & 1) === 0;
};
LongPrototype.equals = function e(n) {
  return isLong(n) || (n = fromValue(n)), this.unsigned !== n.unsigned && this.high >>> 31 === 1 && n.high >>> 31 === 1 ? !1 : this.high === n.high && this.low === n.low;
};
LongPrototype.eq = LongPrototype.equals;
LongPrototype.notEquals = function e(n) {
  return !this.eq(
    /* validates */
    n
  );
};
LongPrototype.neq = LongPrototype.notEquals;
LongPrototype.ne = LongPrototype.notEquals;
LongPrototype.lessThan = function e(n) {
  return this.comp(
    /* validates */
    n
  ) < 0;
};
LongPrototype.lt = LongPrototype.lessThan;
LongPrototype.lessThanOrEqual = function e(n) {
  return this.comp(
    /* validates */
    n
  ) <= 0;
};
LongPrototype.lte = LongPrototype.lessThanOrEqual;
LongPrototype.le = LongPrototype.lessThanOrEqual;
LongPrototype.greaterThan = function e(n) {
  return this.comp(
    /* validates */
    n
  ) > 0;
};
LongPrototype.gt = LongPrototype.greaterThan;
LongPrototype.greaterThanOrEqual = function e(n) {
  return this.comp(
    /* validates */
    n
  ) >= 0;
};
LongPrototype.gte = LongPrototype.greaterThanOrEqual;
LongPrototype.ge = LongPrototype.greaterThanOrEqual;
LongPrototype.compare = function e(n) {
  if (isLong(n) || (n = fromValue(n)), this.eq(n))
    return 0;
  var o = this.isNegative(), u = n.isNegative();
  return o && !u ? -1 : !o && u ? 1 : this.unsigned ? n.high >>> 0 > this.high >>> 0 || n.high === this.high && n.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(n).isNegative() ? -1 : 1;
};
LongPrototype.comp = LongPrototype.compare;
LongPrototype.negate = function e() {
  return !this.unsigned && this.eq(MIN_VALUE) ? MIN_VALUE : this.not().add(ONE);
};
LongPrototype.neg = LongPrototype.negate;
LongPrototype.add = function e(n) {
  isLong(n) || (n = fromValue(n));
  var o = this.high >>> 16, u = this.high & 65535, c = this.low >>> 16, d = this.low & 65535, m = n.high >>> 16, v = n.high & 65535, S = n.low >>> 16, $ = n.low & 65535, E = 0, O = 0, T = 0, y = 0;
  return y += d + $, T += y >>> 16, y &= 65535, T += c + S, O += T >>> 16, T &= 65535, O += u + v, E += O >>> 16, O &= 65535, E += o + m, E &= 65535, fromBits(T << 16 | y, E << 16 | O, this.unsigned);
};
LongPrototype.subtract = function e(n) {
  return isLong(n) || (n = fromValue(n)), this.add(n.neg());
};
LongPrototype.sub = LongPrototype.subtract;
LongPrototype.multiply = function e(n) {
  if (this.isZero())
    return ZERO;
  if (isLong(n) || (n = fromValue(n)), wasm) {
    var o = wasm.mul(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits(o, wasm.get_high(), this.unsigned);
  }
  if (n.isZero())
    return ZERO;
  if (this.eq(MIN_VALUE))
    return n.isOdd() ? MIN_VALUE : ZERO;
  if (n.eq(MIN_VALUE))
    return this.isOdd() ? MIN_VALUE : ZERO;
  if (this.isNegative())
    return n.isNegative() ? this.neg().mul(n.neg()) : this.neg().mul(n).neg();
  if (n.isNegative())
    return this.mul(n.neg()).neg();
  if (this.lt(TWO_PWR_24) && n.lt(TWO_PWR_24))
    return fromNumber(this.toNumber() * n.toNumber(), this.unsigned);
  var u = this.high >>> 16, c = this.high & 65535, d = this.low >>> 16, m = this.low & 65535, v = n.high >>> 16, S = n.high & 65535, $ = n.low >>> 16, E = n.low & 65535, O = 0, T = 0, y = 0, V = 0;
  return V += m * E, y += V >>> 16, V &= 65535, y += d * E, T += y >>> 16, y &= 65535, y += m * $, T += y >>> 16, y &= 65535, T += c * E, O += T >>> 16, T &= 65535, T += d * $, O += T >>> 16, T &= 65535, T += m * S, O += T >>> 16, T &= 65535, O += u * E + c * $ + d * S + m * v, O &= 65535, fromBits(y << 16 | V, O << 16 | T, this.unsigned);
};
LongPrototype.mul = LongPrototype.multiply;
LongPrototype.divide = function e(n) {
  if (isLong(n) || (n = fromValue(n)), n.isZero())
    throw Error("division by zero");
  if (wasm) {
    if (!this.unsigned && this.high === -2147483648 && n.low === -1 && n.high === -1)
      return this;
    var o = (this.unsigned ? wasm.div_u : wasm.div_s)(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits(o, wasm.get_high(), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO : ZERO;
  var u, c, d;
  if (this.unsigned) {
    if (n.unsigned || (n = n.toUnsigned()), n.gt(this))
      return UZERO;
    if (n.gt(this.shru(1)))
      return UONE;
    d = UZERO;
  } else {
    if (this.eq(MIN_VALUE)) {
      if (n.eq(ONE) || n.eq(NEG_ONE))
        return MIN_VALUE;
      if (n.eq(MIN_VALUE))
        return ONE;
      var m = this.shr(1);
      return u = m.div(n).shl(1), u.eq(ZERO) ? n.isNegative() ? ONE : NEG_ONE : (c = this.sub(n.mul(u)), d = u.add(c.div(n)), d);
    } else if (n.eq(MIN_VALUE))
      return this.unsigned ? UZERO : ZERO;
    if (this.isNegative())
      return n.isNegative() ? this.neg().div(n.neg()) : this.neg().div(n).neg();
    if (n.isNegative())
      return this.div(n.neg()).neg();
    d = ZERO;
  }
  for (c = this; c.gte(n); ) {
    u = Math.max(1, Math.floor(c.toNumber() / n.toNumber()));
    for (var v = Math.ceil(Math.log(u) / Math.LN2), S = v <= 48 ? 1 : pow_dbl(2, v - 48), $ = fromNumber(u), E = $.mul(n); E.isNegative() || E.gt(c); )
      u -= S, $ = fromNumber(u, this.unsigned), E = $.mul(n);
    $.isZero() && ($ = ONE), d = d.add($), c = c.sub(E);
  }
  return d;
};
LongPrototype.div = LongPrototype.divide;
LongPrototype.modulo = function e(n) {
  if (isLong(n) || (n = fromValue(n)), wasm) {
    var o = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
      this.low,
      this.high,
      n.low,
      n.high
    );
    return fromBits(o, wasm.get_high(), this.unsigned);
  }
  return this.sub(this.div(n).mul(n));
};
LongPrototype.mod = LongPrototype.modulo;
LongPrototype.rem = LongPrototype.modulo;
LongPrototype.not = function e() {
  return fromBits(~this.low, ~this.high, this.unsigned);
};
LongPrototype.and = function e(n) {
  return isLong(n) || (n = fromValue(n)), fromBits(this.low & n.low, this.high & n.high, this.unsigned);
};
LongPrototype.or = function e(n) {
  return isLong(n) || (n = fromValue(n)), fromBits(this.low | n.low, this.high | n.high, this.unsigned);
};
LongPrototype.xor = function e(n) {
  return isLong(n) || (n = fromValue(n)), fromBits(this.low ^ n.low, this.high ^ n.high, this.unsigned);
};
LongPrototype.shiftLeft = function e(n) {
  return isLong(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n < 32 ? fromBits(this.low << n, this.high << n | this.low >>> 32 - n, this.unsigned) : fromBits(0, this.low << n - 32, this.unsigned);
};
LongPrototype.shl = LongPrototype.shiftLeft;
LongPrototype.shiftRight = function e(n) {
  return isLong(n) && (n = n.toInt()), (n &= 63) === 0 ? this : n < 32 ? fromBits(this.low >>> n | this.high << 32 - n, this.high >> n, this.unsigned) : fromBits(this.high >> n - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype.shr = LongPrototype.shiftRight;
LongPrototype.shiftRightUnsigned = function e(n) {
  if (isLong(n) && (n = n.toInt()), n &= 63, n === 0)
    return this;
  var o = this.high;
  if (n < 32) {
    var u = this.low;
    return fromBits(u >>> n | o << 32 - n, o >>> n, this.unsigned);
  } else
    return n === 32 ? fromBits(o, 0, this.unsigned) : fromBits(o >>> n - 32, 0, this.unsigned);
};
LongPrototype.shru = LongPrototype.shiftRightUnsigned;
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
LongPrototype.toSigned = function e() {
  return this.unsigned ? fromBits(this.low, this.high, !1) : this;
};
LongPrototype.toUnsigned = function e() {
  return this.unsigned ? this : fromBits(this.low, this.high, !0);
};
LongPrototype.toBytes = function e(n) {
  return n ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype.toBytesLE = function e() {
  var n = this.high, o = this.low;
  return [
    o & 255,
    o >>> 8 & 255,
    o >>> 16 & 255,
    o >>> 24,
    n & 255,
    n >>> 8 & 255,
    n >>> 16 & 255,
    n >>> 24
  ];
};
LongPrototype.toBytesBE = function e() {
  var n = this.high, o = this.low;
  return [
    n >>> 24,
    n >>> 16 & 255,
    n >>> 8 & 255,
    n & 255,
    o >>> 24,
    o >>> 16 & 255,
    o >>> 8 & 255,
    o & 255
  ];
};
Long.fromBytes = function e(n, o, u) {
  return u ? Long.fromBytesLE(n, o) : Long.fromBytesBE(n, o);
};
Long.fromBytesLE = function e(n, o) {
  return new Long(
    n[0] | n[1] << 8 | n[2] << 16 | n[3] << 24,
    n[4] | n[5] << 8 | n[6] << 16 | n[7] << 24,
    o
  );
};
Long.fromBytesBE = function e(n, o) {
  return new Long(
    n[4] << 24 | n[5] << 16 | n[6] << 8 | n[7],
    n[0] << 24 | n[1] << 16 | n[2] << 8 | n[3],
    o
  );
};
var __importDefault$a = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(utils$m, "__esModule", { value: !0 });
utils$m.decodeCosmosSdkDecFromProto = utils$m.longify = utils$m.createProtobufRpcClient = utils$m.createPagination = utils$m.toAccAddress = void 0;
const encoding_1$8 = build$a, math_1$6 = build$6, pagination_1 = pagination, long_1$8 = __importDefault$a(long);
function toAccAddress(e) {
  return (0, encoding_1$8.fromBech32)(e).data;
}
utils$m.toAccAddress = toAccAddress;
function createPagination(e) {
  return e ? pagination_1.PageRequest.fromPartial({ key: e }) : void 0;
}
utils$m.createPagination = createPagination;
function createProtobufRpcClient(e) {
  return {
    request: (n, o, u) => {
      const c = `/${n}/${o}`;
      return e.queryUnverified(c, u);
    }
  };
}
utils$m.createProtobufRpcClient = createProtobufRpcClient;
function longify(e) {
  const n = math_1$6.Uint64.fromString(e.toString());
  return long_1$8.default.fromBytesBE([...n.toBytesBigEndian()], !0);
}
utils$m.longify = longify;
function decodeCosmosSdkDecFromProto(e) {
  const n = typeof e == "string" ? e : (0, encoding_1$8.fromAscii)(e);
  return math_1$6.Decimal.fromAtomics(n, 18);
}
utils$m.decodeCosmosSdkDecFromProto = decodeCosmosSdkDecFromProto;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.longify = e.decodeCosmosSdkDecFromProto = e.createProtobufRpcClient = e.createPagination = e.QueryClient = void 0;
  var n = queryclient;
  Object.defineProperty(e, "QueryClient", { enumerable: !0, get: function() {
    return n.QueryClient;
  } });
  var o = utils$m;
  Object.defineProperty(e, "createPagination", { enumerable: !0, get: function() {
    return o.createPagination;
  } }), Object.defineProperty(e, "createProtobufRpcClient", { enumerable: !0, get: function() {
    return o.createProtobufRpcClient;
  } }), Object.defineProperty(e, "decodeCosmosSdkDecFromProto", { enumerable: !0, get: function() {
    return o.decodeCosmosSdkDecFromProto;
  } }), Object.defineProperty(e, "longify", { enumerable: !0, get: function() {
    return o.longify;
  } });
})(queryclient$1);
Object.defineProperty(queries$a, "__esModule", { value: !0 });
queries$a.setupAuthExtension = void 0;
const query_1$9 = query$d, queryclient_1$c = queryclient$1;
function setupAuthExtension(e) {
  const n = (0, queryclient_1$c.createProtobufRpcClient)(e), o = new query_1$9.QueryClientImpl(n);
  return {
    auth: {
      account: async (u) => {
        const { account: c } = await o.Account({ address: u });
        return c ?? null;
      }
    }
  };
}
queries$a.setupAuthExtension = setupAuthExtension;
var aminomessages$a = {};
Object.defineProperty(aminomessages$a, "__esModule", { value: !0 });
aminomessages$a.createAuthzAminoConverters = void 0;
function createAuthzAminoConverters() {
  return {
    "/cosmos.authz.v1beta1.MsgGrant": "not_supported_by_chain",
    "/cosmos.authz.v1beta1.MsgExec": "not_supported_by_chain",
    "/cosmos.authz.v1beta1.MsgRevoke": "not_supported_by_chain"
  };
}
aminomessages$a.createAuthzAminoConverters = createAuthzAminoConverters;
var messages$7 = {};
Object.defineProperty(messages$7, "__esModule", { value: !0 });
messages$7.authzTypes = void 0;
const tx_1$9 = tx$n;
messages$7.authzTypes = [
  ["/cosmos.authz.v1beta1.MsgExec", tx_1$9.MsgExec],
  ["/cosmos.authz.v1beta1.MsgGrant", tx_1$9.MsgGrant],
  ["/cosmos.authz.v1beta1.MsgRevoke", tx_1$9.MsgRevoke]
];
var queries$9 = {};
Object.defineProperty(queries$9, "__esModule", { value: !0 });
queries$9.setupAuthzExtension = void 0;
const query_1$8 = query$c, queryclient_1$b = queryclient$1;
function setupAuthzExtension(e) {
  const n = (0, queryclient_1$b.createProtobufRpcClient)(e), o = new query_1$8.QueryClientImpl(n);
  return {
    authz: {
      grants: async (u, c, d, m) => await o.Grants({
        granter: u,
        grantee: c,
        msgTypeUrl: d,
        pagination: (0, queryclient_1$b.createPagination)(m)
      })
    }
  };
}
queries$9.setupAuthzExtension = setupAuthzExtension;
var aminomessages$9 = {};
Object.defineProperty(aminomessages$9, "__esModule", { value: !0 });
aminomessages$9.createBankAminoConverters = aminomessages$9.isAminoMsgMultiSend = aminomessages$9.isAminoMsgSend = void 0;
function isAminoMsgSend(e) {
  return e.type === "cosmos-sdk/MsgSend";
}
aminomessages$9.isAminoMsgSend = isAminoMsgSend;
function isAminoMsgMultiSend(e) {
  return e.type === "cosmos-sdk/MsgMultiSend";
}
aminomessages$9.isAminoMsgMultiSend = isAminoMsgMultiSend;
function createBankAminoConverters() {
  return {
    "/cosmos.bank.v1beta1.MsgSend": {
      aminoType: "cosmos-sdk/MsgSend",
      toAmino: ({ fromAddress: e, toAddress: n, amount: o }) => ({
        from_address: e,
        to_address: n,
        amount: [...o]
      }),
      fromAmino: ({ from_address: e, to_address: n, amount: o }) => ({
        fromAddress: e,
        toAddress: n,
        amount: [...o]
      })
    },
    "/cosmos.bank.v1beta1.MsgMultiSend": {
      aminoType: "cosmos-sdk/MsgMultiSend",
      toAmino: ({ inputs: e, outputs: n }) => ({
        inputs: e.map((o) => ({
          address: o.address,
          coins: [...o.coins]
        })),
        outputs: n.map((o) => ({
          address: o.address,
          coins: [...o.coins]
        }))
      }),
      fromAmino: ({ inputs: e, outputs: n }) => ({
        inputs: e.map((o) => ({
          address: o.address,
          coins: [...o.coins]
        })),
        outputs: n.map((o) => ({
          address: o.address,
          coins: [...o.coins]
        }))
      })
    }
  };
}
aminomessages$9.createBankAminoConverters = createBankAminoConverters;
var messages$6 = {};
Object.defineProperty(messages$6, "__esModule", { value: !0 });
messages$6.isMsgSendEncodeObject = messages$6.bankTypes = void 0;
const tx_1$8 = tx$o;
messages$6.bankTypes = [
  ["/cosmos.bank.v1beta1.MsgMultiSend", tx_1$8.MsgMultiSend],
  ["/cosmos.bank.v1beta1.MsgSend", tx_1$8.MsgSend]
];
function isMsgSendEncodeObject(e) {
  return e.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
messages$6.isMsgSendEncodeObject = isMsgSendEncodeObject;
var queries$8 = {};
Object.defineProperty(queries$8, "__esModule", { value: !0 });
queries$8.setupBankExtension = void 0;
const utils_1$5 = build$7, query_1$7 = query$b, queryclient_1$a = queryclient$1;
function setupBankExtension(e) {
  const n = (0, queryclient_1$a.createProtobufRpcClient)(e), o = new query_1$7.QueryClientImpl(n);
  return {
    bank: {
      balance: async (u, c) => {
        const { balance: d } = await o.Balance({ address: u, denom: c });
        return (0, utils_1$5.assert)(d), d;
      },
      allBalances: async (u) => {
        const { balances: c } = await o.AllBalances({ address: u });
        return c;
      },
      totalSupply: async (u) => await o.TotalSupply({
        pagination: (0, queryclient_1$a.createPagination)(u)
      }),
      supplyOf: async (u) => {
        const { amount: c } = await o.SupplyOf({ denom: u });
        return (0, utils_1$5.assert)(c), c;
      },
      denomMetadata: async (u) => {
        const { metadata: c } = await o.DenomMetadata({ denom: u });
        return (0, utils_1$5.assert)(c), c;
      },
      denomsMetadata: async () => {
        const { metadatas: u } = await o.DenomsMetadata({
          pagination: void 0
          // Not implemented
        });
        return u;
      }
    }
  };
}
queries$8.setupBankExtension = setupBankExtension;
var aminomessages$8 = {};
Object.defineProperty(aminomessages$8, "__esModule", { value: !0 });
aminomessages$8.createCrysisAminoConverters = aminomessages$8.isAminoMsgVerifyInvariant = void 0;
function isAminoMsgVerifyInvariant(e) {
  return e.type === "cosmos-sdk/MsgVerifyInvariant";
}
aminomessages$8.isAminoMsgVerifyInvariant = isAminoMsgVerifyInvariant;
function createCrysisAminoConverters() {
  throw new Error("Not implemented");
}
aminomessages$8.createCrysisAminoConverters = createCrysisAminoConverters;
var aminomessages$7 = {};
Object.defineProperty(aminomessages$7, "__esModule", { value: !0 });
aminomessages$7.createDistributionAminoConverters = aminomessages$7.isAminoMsgFundCommunityPool = aminomessages$7.isAminoMsgWithdrawValidatorCommission = aminomessages$7.isAminoMsgWithdrawDelegatorReward = aminomessages$7.isAminoMsgSetWithdrawAddress = void 0;
function isAminoMsgSetWithdrawAddress(e) {
  return e.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
aminomessages$7.isAminoMsgSetWithdrawAddress = isAminoMsgSetWithdrawAddress;
function isAminoMsgWithdrawDelegatorReward(e) {
  return e.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
aminomessages$7.isAminoMsgWithdrawDelegatorReward = isAminoMsgWithdrawDelegatorReward;
function isAminoMsgWithdrawValidatorCommission(e) {
  return e.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
aminomessages$7.isAminoMsgWithdrawValidatorCommission = isAminoMsgWithdrawValidatorCommission;
function isAminoMsgFundCommunityPool(e) {
  return e.type === "cosmos-sdk/MsgFundCommunityPool";
}
aminomessages$7.isAminoMsgFundCommunityPool = isAminoMsgFundCommunityPool;
function createDistributionAminoConverters() {
  return {
    "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
      aminoType: "cosmos-sdk/MsgFundCommunityPool",
      toAmino: ({ amount: e, depositor: n }) => ({
        amount: [...e],
        depositor: n
      }),
      fromAmino: ({ amount: e, depositor: n }) => ({
        amount: [...e],
        depositor: n
      })
    },
    "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
      aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
      toAmino: ({ delegatorAddress: e, withdrawAddress: n }) => ({
        delegator_address: e,
        withdraw_address: n
      }),
      fromAmino: ({ delegator_address: e, withdraw_address: n }) => ({
        delegatorAddress: e,
        withdrawAddress: n
      })
    },
    "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
      aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
      toAmino: ({ delegatorAddress: e, validatorAddress: n }) => ({
        delegator_address: e,
        validator_address: n
      }),
      fromAmino: ({ delegator_address: e, validator_address: n }) => ({
        delegatorAddress: e,
        validatorAddress: n
      })
    },
    "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
      aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
      toAmino: ({ validatorAddress: e }) => ({
        validator_address: e
      }),
      fromAmino: ({ validator_address: e }) => ({
        validatorAddress: e
      })
    }
  };
}
aminomessages$7.createDistributionAminoConverters = createDistributionAminoConverters;
var messages$5 = {};
Object.defineProperty(messages$5, "__esModule", { value: !0 });
messages$5.isMsgWithdrawDelegatorRewardEncodeObject = messages$5.distributionTypes = void 0;
const tx_1$7 = tx$m;
messages$5.distributionTypes = [
  ["/cosmos.distribution.v1beta1.MsgFundCommunityPool", tx_1$7.MsgFundCommunityPool],
  ["/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", tx_1$7.MsgSetWithdrawAddress],
  ["/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", tx_1$7.MsgWithdrawDelegatorReward],
  ["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", tx_1$7.MsgWithdrawValidatorCommission]
];
function isMsgWithdrawDelegatorRewardEncodeObject(e) {
  return e.typeUrl === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
}
messages$5.isMsgWithdrawDelegatorRewardEncodeObject = isMsgWithdrawDelegatorRewardEncodeObject;
var queries$7 = {}, __importDefault$9 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries$7, "__esModule", { value: !0 });
queries$7.setupDistributionExtension = void 0;
const query_1$6 = query$a, long_1$7 = __importDefault$9(long), queryclient_1$9 = queryclient$1;
function setupDistributionExtension(e) {
  const n = (0, queryclient_1$9.createProtobufRpcClient)(e), o = new query_1$6.QueryClientImpl(n);
  return {
    distribution: {
      communityPool: async () => await o.CommunityPool({}),
      delegationRewards: async (u, c) => await o.DelegationRewards({
        delegatorAddress: u,
        validatorAddress: c
      }),
      delegationTotalRewards: async (u) => await o.DelegationTotalRewards({
        delegatorAddress: u
      }),
      delegatorValidators: async (u) => await o.DelegatorValidators({
        delegatorAddress: u
      }),
      delegatorWithdrawAddress: async (u) => await o.DelegatorWithdrawAddress({
        delegatorAddress: u
      }),
      params: async () => await o.Params({}),
      validatorCommission: async (u) => await o.ValidatorCommission({
        validatorAddress: u
      }),
      validatorOutstandingRewards: async (u) => await o.ValidatorOutstandingRewards({
        validatorAddress: u
      }),
      validatorSlashes: async (u, c, d, m) => await o.ValidatorSlashes({
        validatorAddress: u,
        startingHeight: long_1$7.default.fromNumber(c, !0),
        endingHeight: long_1$7.default.fromNumber(d, !0),
        pagination: (0, queryclient_1$9.createPagination)(m)
      })
    }
  };
}
queries$7.setupDistributionExtension = setupDistributionExtension;
var aminomessages$6 = {};
Object.defineProperty(aminomessages$6, "__esModule", { value: !0 });
aminomessages$6.createEvidenceAminoConverters = aminomessages$6.isAminoMsgSubmitEvidence = void 0;
function isAminoMsgSubmitEvidence(e) {
  return e.type === "cosmos-sdk/MsgSubmitEvidence";
}
aminomessages$6.isAminoMsgSubmitEvidence = isAminoMsgSubmitEvidence;
function createEvidenceAminoConverters() {
  throw new Error("Not implemented");
}
aminomessages$6.createEvidenceAminoConverters = createEvidenceAminoConverters;
var aminomessages$5 = {};
Object.defineProperty(aminomessages$5, "__esModule", { value: !0 });
aminomessages$5.createFeegrantAminoConverters = void 0;
function createFeegrantAminoConverters() {
  return {
    "/cosmos.feegrant.v1beta1.MsgGrantAllowance": "not_supported_by_chain",
    "/cosmos.feegrant.v1beta1.MsgRevokeAllowance": "not_supported_by_chain"
  };
}
aminomessages$5.createFeegrantAminoConverters = createFeegrantAminoConverters;
var messages$4 = {};
Object.defineProperty(messages$4, "__esModule", { value: !0 });
messages$4.feegrantTypes = void 0;
const tx_1$6 = tx$l;
messages$4.feegrantTypes = [
  ["/cosmos.feegrant.v1beta1.MsgGrantAllowance", tx_1$6.MsgGrantAllowance],
  ["/cosmos.feegrant.v1beta1.MsgRevokeAllowance", tx_1$6.MsgRevokeAllowance]
];
var queries$6 = {};
Object.defineProperty(queries$6, "__esModule", { value: !0 });
queries$6.setupFeegrantExtension = void 0;
const query_1$5 = query$9, queryclient_1$8 = queryclient$1;
function setupFeegrantExtension(e) {
  const n = (0, queryclient_1$8.createProtobufRpcClient)(e), o = new query_1$5.QueryClientImpl(n);
  return {
    feegrant: {
      allowance: async (u, c) => await o.Allowance({
        granter: u,
        grantee: c
      }),
      allowances: async (u, c) => await o.Allowances({
        grantee: u,
        pagination: (0, queryclient_1$8.createPagination)(c)
      })
    }
  };
}
queries$6.setupFeegrantExtension = setupFeegrantExtension;
var aminomessages$4 = {}, __importDefault$8 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(aminomessages$4, "__esModule", { value: !0 });
aminomessages$4.createGovAminoConverters = aminomessages$4.isAminoMsgDeposit = aminomessages$4.isAminoMsgVoteWeighted = aminomessages$4.isAminoMsgVote = aminomessages$4.isAminoMsgSubmitProposal = void 0;
const math_1$5 = build$6, utils_1$4 = build$7, gov_1 = gov$4, any_1 = any$1, long_1$6 = __importDefault$8(long), queryclient_1$7 = queryclient$1;
function isAminoMsgSubmitProposal(e) {
  return e.type === "cosmos-sdk/MsgSubmitProposal";
}
aminomessages$4.isAminoMsgSubmitProposal = isAminoMsgSubmitProposal;
function isAminoMsgVote(e) {
  return e.type === "cosmos-sdk/MsgVote";
}
aminomessages$4.isAminoMsgVote = isAminoMsgVote;
function isAminoMsgVoteWeighted(e) {
  return e.type === "cosmos-sdk/MsgVoteWeighted";
}
aminomessages$4.isAminoMsgVoteWeighted = isAminoMsgVoteWeighted;
function isAminoMsgDeposit(e) {
  return e.type === "cosmos-sdk/MsgDeposit";
}
aminomessages$4.isAminoMsgDeposit = isAminoMsgDeposit;
function createGovAminoConverters() {
  return {
    "/cosmos.gov.v1beta1.MsgDeposit": {
      aminoType: "cosmos-sdk/MsgDeposit",
      toAmino: ({ amount: e, depositor: n, proposalId: o }) => ({
        amount: e,
        depositor: n,
        proposal_id: o.toString()
      }),
      fromAmino: ({ amount: e, depositor: n, proposal_id: o }) => ({
        amount: Array.from(e),
        depositor: n,
        proposalId: long_1$6.default.fromString(o)
      })
    },
    "/cosmos.gov.v1beta1.MsgVote": {
      aminoType: "cosmos-sdk/MsgVote",
      toAmino: ({ option: e, proposalId: n, voter: o }) => ({
        option: e,
        proposal_id: n.toString(),
        voter: o
      }),
      fromAmino: ({ option: e, proposal_id: n, voter: o }) => ({
        option: (0, gov_1.voteOptionFromJSON)(e),
        proposalId: long_1$6.default.fromString(n),
        voter: o
      })
    },
    "/cosmos.gov.v1beta1.MsgVoteWeighted": {
      aminoType: "cosmos-sdk/MsgVoteWeighted",
      toAmino: ({ options: e, proposalId: n, voter: o }) => ({
        options: e.map((u) => ({
          option: u.option,
          // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
          // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
          weight: (0, queryclient_1$7.decodeCosmosSdkDecFromProto)(u.weight).toString().padEnd(20, "0")
        })),
        proposal_id: n.toString(),
        voter: o
      }),
      fromAmino: ({ options: e, proposal_id: n, voter: o }) => ({
        proposalId: long_1$6.default.fromString(n),
        voter: o,
        options: e.map((u) => ({
          option: (0, gov_1.voteOptionFromJSON)(u.option),
          weight: math_1$5.Decimal.fromUserInput(u.weight, 18).atomics
        }))
      })
    },
    "/cosmos.gov.v1beta1.MsgSubmitProposal": {
      aminoType: "cosmos-sdk/MsgSubmitProposal",
      toAmino: ({ initialDeposit: e, proposer: n, content: o }) => {
        (0, utils_1$4.assertDefinedAndNotNull)(o);
        let u;
        switch (o.typeUrl) {
          case "/cosmos.gov.v1beta1.TextProposal": {
            const c = gov_1.TextProposal.decode(o.value);
            u = {
              type: "cosmos-sdk/TextProposal",
              value: {
                description: c.description,
                title: c.title
              }
            };
            break;
          }
          default:
            throw new Error(`Unsupported proposal type: '${o.typeUrl}'`);
        }
        return {
          initial_deposit: e,
          proposer: n,
          content: u
        };
      },
      fromAmino: ({ initial_deposit: e, proposer: n, content: o }) => {
        let u;
        switch (o.type) {
          case "cosmos-sdk/TextProposal": {
            const { value: c } = o;
            (0, utils_1$4.assert)((0, utils_1$4.isNonNullObject)(c));
            const { title: d, description: m } = c;
            (0, utils_1$4.assert)(typeof d == "string"), (0, utils_1$4.assert)(typeof m == "string"), u = any_1.Any.fromPartial({
              typeUrl: "/cosmos.gov.v1beta1.TextProposal",
              value: gov_1.TextProposal.encode(gov_1.TextProposal.fromPartial({
                title: d,
                description: m
              })).finish()
            });
            break;
          }
          default:
            throw new Error(`Unsupported proposal type: '${o.type}'`);
        }
        return {
          initialDeposit: Array.from(e),
          proposer: n,
          content: u
        };
      }
    }
  };
}
aminomessages$4.createGovAminoConverters = createGovAminoConverters;
var messages$3 = {};
Object.defineProperty(messages$3, "__esModule", { value: !0 });
messages$3.isMsgVoteWeightedEncodeObject = messages$3.isMsgVoteEncodeObject = messages$3.isMsgSubmitProposalEncodeObject = messages$3.isMsgDepositEncodeObject = messages$3.govTypes = void 0;
const tx_1$5 = tx$j;
messages$3.govTypes = [
  ["/cosmos.gov.v1beta1.MsgDeposit", tx_1$5.MsgDeposit],
  ["/cosmos.gov.v1beta1.MsgSubmitProposal", tx_1$5.MsgSubmitProposal],
  ["/cosmos.gov.v1beta1.MsgVote", tx_1$5.MsgVote],
  ["/cosmos.gov.v1beta1.MsgVoteWeighted", tx_1$5.MsgVoteWeighted]
];
function isMsgDepositEncodeObject(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
messages$3.isMsgDepositEncodeObject = isMsgDepositEncodeObject;
function isMsgSubmitProposalEncodeObject(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
messages$3.isMsgSubmitProposalEncodeObject = isMsgSubmitProposalEncodeObject;
function isMsgVoteEncodeObject(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
messages$3.isMsgVoteEncodeObject = isMsgVoteEncodeObject;
function isMsgVoteWeightedEncodeObject(e) {
  return e.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
messages$3.isMsgVoteWeightedEncodeObject = isMsgVoteWeightedEncodeObject;
var queries$5 = {};
Object.defineProperty(queries$5, "__esModule", { value: !0 });
queries$5.setupGovExtension = void 0;
const query_1$4 = query$8, queryclient_1$6 = queryclient$1;
function setupGovExtension(e) {
  const n = (0, queryclient_1$6.createProtobufRpcClient)(e), o = new query_1$4.QueryClientImpl(n);
  return {
    gov: {
      params: async (u) => await o.Params({ paramsType: u }),
      proposals: async (u, c, d, m) => await o.Proposals({
        proposalStatus: u,
        depositor: c,
        voter: d,
        pagination: (0, queryclient_1$6.createPagination)(m)
      }),
      proposal: async (u) => await o.Proposal({ proposalId: (0, queryclient_1$6.longify)(u) }),
      deposits: async (u, c) => await o.Deposits({
        proposalId: (0, queryclient_1$6.longify)(u),
        pagination: (0, queryclient_1$6.createPagination)(c)
      }),
      deposit: async (u, c) => await o.Deposit({
        proposalId: (0, queryclient_1$6.longify)(u),
        depositor: c
      }),
      tally: async (u) => await o.TallyResult({
        proposalId: (0, queryclient_1$6.longify)(u)
      }),
      votes: async (u, c) => await o.Votes({
        proposalId: (0, queryclient_1$6.longify)(u),
        pagination: (0, queryclient_1$6.createPagination)(c)
      }),
      vote: async (u, c) => await o.Vote({
        proposalId: (0, queryclient_1$6.longify)(u),
        voter: c
      })
    }
  };
}
queries$5.setupGovExtension = setupGovExtension;
var aminomessages$3 = {}, __importDefault$7 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(aminomessages$3, "__esModule", { value: !0 });
aminomessages$3.createIbcAminoConverters = aminomessages$3.isAminoMsgTransfer = void 0;
const long_1$5 = __importDefault$7(long);
function isAminoMsgTransfer(e) {
  return e.type === "cosmos-sdk/MsgTransfer";
}
aminomessages$3.isAminoMsgTransfer = isAminoMsgTransfer;
function omitDefault(e) {
  if (typeof e == "string")
    return e === "" ? void 0 : e;
  if (typeof e == "number")
    return e === 0 ? void 0 : e;
  if (long_1$5.default.isLong(e))
    return e.isZero() ? void 0 : e;
  throw new Error(`Got unsupported type '${typeof e}'`);
}
function createIbcAminoConverters() {
  return {
    "/ibc.applications.transfer.v1.MsgTransfer": {
      aminoType: "cosmos-sdk/MsgTransfer",
      toAmino: ({ sourcePort: e, sourceChannel: n, token: o, sender: u, receiver: c, timeoutHeight: d, timeoutTimestamp: m }) => {
        var v, S, $;
        return {
          source_port: e,
          source_channel: n,
          token: o,
          sender: u,
          receiver: c,
          timeout_height: d ? {
            revision_height: (v = omitDefault(d.revisionHeight)) === null || v === void 0 ? void 0 : v.toString(),
            revision_number: (S = omitDefault(d.revisionNumber)) === null || S === void 0 ? void 0 : S.toString()
          } : {},
          timeout_timestamp: ($ = omitDefault(m)) === null || $ === void 0 ? void 0 : $.toString()
        };
      },
      fromAmino: ({ source_port: e, source_channel: n, token: o, sender: u, receiver: c, timeout_height: d, timeout_timestamp: m }) => ({
        sourcePort: e,
        sourceChannel: n,
        token: o,
        sender: u,
        receiver: c,
        timeoutHeight: d ? {
          revisionHeight: long_1$5.default.fromString(d.revision_height || "0", !0),
          revisionNumber: long_1$5.default.fromString(d.revision_number || "0", !0)
        } : void 0,
        timeoutTimestamp: long_1$5.default.fromString(m || "0", !0)
      })
    }
  };
}
aminomessages$3.createIbcAminoConverters = createIbcAminoConverters;
var messages$2 = {};
Object.defineProperty(messages$2, "__esModule", { value: !0 });
messages$2.isMsgTransferEncodeObject = messages$2.ibcTypes = void 0;
const tx_1$4 = tx$h, tx_2$1 = tx$g, tx_3 = tx$f, tx_4 = tx$e;
messages$2.ibcTypes = [
  ["/ibc.applications.transfer.v1.MsgTransfer", tx_1$4.MsgTransfer],
  ["/ibc.core.channel.v1.MsgAcknowledgement", tx_2$1.MsgAcknowledgement],
  ["/ibc.core.channel.v1.MsgChannelCloseConfirm", tx_2$1.MsgChannelCloseConfirm],
  ["/ibc.core.channel.v1.MsgChannelCloseInit", tx_2$1.MsgChannelCloseInit],
  ["/ibc.core.channel.v1.MsgChannelOpenAck", tx_2$1.MsgChannelOpenAck],
  ["/ibc.core.channel.v1.MsgChannelOpenConfirm", tx_2$1.MsgChannelOpenConfirm],
  ["/ibc.core.channel.v1.MsgChannelOpenInit", tx_2$1.MsgChannelOpenInit],
  ["/ibc.core.channel.v1.MsgChannelOpenTry", tx_2$1.MsgChannelOpenTry],
  ["/ibc.core.channel.v1.MsgRecvPacket", tx_2$1.MsgRecvPacket],
  ["/ibc.core.channel.v1.MsgTimeout", tx_2$1.MsgTimeout],
  ["/ibc.core.channel.v1.MsgTimeoutOnClose", tx_2$1.MsgTimeoutOnClose],
  ["/ibc.core.client.v1.MsgCreateClient", tx_3.MsgCreateClient],
  ["/ibc.core.client.v1.MsgSubmitMisbehaviour", tx_3.MsgSubmitMisbehaviour],
  ["/ibc.core.client.v1.MsgUpdateClient", tx_3.MsgUpdateClient],
  ["/ibc.core.client.v1.MsgUpgradeClient", tx_3.MsgUpgradeClient],
  ["/ibc.core.connection.v1.MsgConnectionOpenAck", tx_4.MsgConnectionOpenAck],
  ["/ibc.core.connection.v1.MsgConnectionOpenConfirm", tx_4.MsgConnectionOpenConfirm],
  ["/ibc.core.connection.v1.MsgConnectionOpenInit", tx_4.MsgConnectionOpenInit],
  ["/ibc.core.connection.v1.MsgConnectionOpenTry", tx_4.MsgConnectionOpenTry]
];
function isMsgTransferEncodeObject(e) {
  return e.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
messages$2.isMsgTransferEncodeObject = isMsgTransferEncodeObject;
var queries$4 = {}, __importDefault$6 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries$4, "__esModule", { value: !0 });
queries$4.setupIbcExtension = void 0;
const encoding_1$7 = build$a, math_1$4 = build$6, query_1$3 = query$7, channel_1 = channel, query_2 = query$6, query_3 = query$5, query_4 = query$4, tendermint_1 = tendermint$1, long_1$4 = __importDefault$6(long), queryclient_1$5 = queryclient$1;
function decodeTendermintClientStateAny(e) {
  if ((e == null ? void 0 : e.typeUrl) !== "/ibc.lightclients.tendermint.v1.ClientState")
    throw new Error(`Unexpected client state type: ${e == null ? void 0 : e.typeUrl}`);
  return tendermint_1.ClientState.decode(e.value);
}
function decodeTendermintConsensusStateAny(e) {
  if ((e == null ? void 0 : e.typeUrl) !== "/ibc.lightclients.tendermint.v1.ConsensusState")
    throw new Error(`Unexpected client state type: ${e == null ? void 0 : e.typeUrl}`);
  return tendermint_1.ConsensusState.decode(e.value);
}
function setupIbcExtension(e) {
  const n = (0, queryclient_1$5.createProtobufRpcClient)(e), o = new query_2.QueryClientImpl(n), u = new query_3.QueryClientImpl(n), c = new query_4.QueryClientImpl(n), d = new query_1$3.QueryClientImpl(n);
  return {
    ibc: {
      channel: {
        channel: async (m, v) => o.Channel({
          portId: m,
          channelId: v
        }),
        channels: async (m) => o.Channels({
          pagination: (0, queryclient_1$5.createPagination)(m)
        }),
        allChannels: async () => {
          var m;
          const v = [];
          let S, $;
          do
            S = await o.Channels({
              pagination: (0, queryclient_1$5.createPagination)($)
            }), v.push(...S.channels), $ = (m = S.pagination) === null || m === void 0 ? void 0 : m.nextKey;
          while ($ && $.length);
          return {
            channels: v,
            height: S.height
          };
        },
        connectionChannels: async (m, v) => o.ConnectionChannels({
          connection: m,
          pagination: (0, queryclient_1$5.createPagination)(v)
        }),
        allConnectionChannels: async (m) => {
          var v;
          const S = [];
          let $, E;
          do
            $ = await o.ConnectionChannels({
              connection: m,
              pagination: (0, queryclient_1$5.createPagination)(E)
            }), S.push(...$.channels), E = (v = $.pagination) === null || v === void 0 ? void 0 : v.nextKey;
          while (E && E.length);
          return {
            channels: S,
            height: $.height
          };
        },
        clientState: async (m, v) => o.ChannelClientState({
          portId: m,
          channelId: v
        }),
        consensusState: async (m, v, S, $) => o.ChannelConsensusState({
          portId: m,
          channelId: v,
          revisionNumber: long_1$4.default.fromNumber(S, !0),
          revisionHeight: long_1$4.default.fromNumber($, !0)
        }),
        packetCommitment: async (m, v, S) => o.PacketCommitment({
          portId: m,
          channelId: v,
          sequence: long_1$4.default.fromNumber(S, !0)
        }),
        packetCommitments: async (m, v, S) => o.PacketCommitments({
          channelId: v,
          portId: m,
          pagination: (0, queryclient_1$5.createPagination)(S)
        }),
        allPacketCommitments: async (m, v) => {
          var S;
          const $ = [];
          let E, O;
          do
            E = await o.PacketCommitments({
              channelId: v,
              portId: m,
              pagination: (0, queryclient_1$5.createPagination)(O)
            }), $.push(...E.commitments), O = (S = E.pagination) === null || S === void 0 ? void 0 : S.nextKey;
          while (O && O.length);
          return {
            commitments: $,
            height: E.height
          };
        },
        packetReceipt: async (m, v, S) => o.PacketReceipt({
          portId: m,
          channelId: v,
          sequence: long_1$4.default.fromNumber(S, !0)
        }),
        packetAcknowledgement: async (m, v, S) => o.PacketAcknowledgement({
          portId: m,
          channelId: v,
          sequence: long_1$4.default.fromNumber(S, !0)
        }),
        packetAcknowledgements: async (m, v, S) => {
          const $ = query_2.QueryPacketAcknowledgementsRequest.fromPartial({
            portId: m,
            channelId: v,
            pagination: (0, queryclient_1$5.createPagination)(S)
          });
          return o.PacketAcknowledgements($);
        },
        allPacketAcknowledgements: async (m, v) => {
          var S;
          const $ = [];
          let E, O;
          do {
            const T = query_2.QueryPacketAcknowledgementsRequest.fromPartial({
              channelId: v,
              portId: m,
              pagination: (0, queryclient_1$5.createPagination)(O)
            });
            E = await o.PacketAcknowledgements(T), $.push(...E.acknowledgements), O = (S = E.pagination) === null || S === void 0 ? void 0 : S.nextKey;
          } while (O && O.length);
          return {
            acknowledgements: $,
            height: E.height
          };
        },
        unreceivedPackets: async (m, v, S) => o.UnreceivedPackets({
          portId: m,
          channelId: v,
          packetCommitmentSequences: S.map(($) => long_1$4.default.fromNumber($, !0))
        }),
        unreceivedAcks: async (m, v, S) => o.UnreceivedAcks({
          portId: m,
          channelId: v,
          packetAckSequences: S.map(($) => long_1$4.default.fromNumber($, !0))
        }),
        nextSequenceReceive: async (m, v) => o.NextSequenceReceive({
          portId: m,
          channelId: v
        })
      },
      client: {
        state: async (m) => u.ClientState({ clientId: m }),
        states: async (m) => u.ClientStates({
          pagination: (0, queryclient_1$5.createPagination)(m)
        }),
        allStates: async () => {
          var m;
          const v = [];
          let S, $;
          do
            S = await u.ClientStates({
              pagination: (0, queryclient_1$5.createPagination)($)
            }), v.push(...S.clientStates), $ = (m = S.pagination) === null || m === void 0 ? void 0 : m.nextKey;
          while ($ && $.length);
          return {
            clientStates: v
          };
        },
        consensusState: async (m, v) => u.ConsensusState(query_3.QueryConsensusStateRequest.fromPartial({
          clientId: m,
          revisionHeight: v !== void 0 ? long_1$4.default.fromNumber(v, !0) : void 0,
          latestHeight: v === void 0
        })),
        consensusStates: async (m, v) => u.ConsensusStates({
          clientId: m,
          pagination: (0, queryclient_1$5.createPagination)(v)
        }),
        allConsensusStates: async (m) => {
          var v;
          const S = [];
          let $, E;
          do
            $ = await u.ConsensusStates({
              clientId: m,
              pagination: (0, queryclient_1$5.createPagination)(E)
            }), S.push(...$.consensusStates), E = (v = $.pagination) === null || v === void 0 ? void 0 : v.nextKey;
          while (E && E.length);
          return {
            consensusStates: S
          };
        },
        params: async () => u.ClientParams({}),
        stateTm: async (m) => {
          const v = await u.ClientState({ clientId: m });
          return decodeTendermintClientStateAny(v.clientState);
        },
        statesTm: async (m) => {
          const { clientStates: v } = await u.ClientStates({
            pagination: (0, queryclient_1$5.createPagination)(m)
          });
          return v.map(({ clientState: S }) => decodeTendermintClientStateAny(S));
        },
        allStatesTm: async () => {
          var m;
          const v = [];
          let S, $;
          do
            S = await u.ClientStates({
              pagination: (0, queryclient_1$5.createPagination)($)
            }), v.push(...S.clientStates), $ = (m = S.pagination) === null || m === void 0 ? void 0 : m.nextKey;
          while ($ && $.length);
          return v.map(({ clientState: E }) => decodeTendermintClientStateAny(E));
        },
        consensusStateTm: async (m, v) => {
          const S = await u.ConsensusState(query_3.QueryConsensusStateRequest.fromPartial({
            clientId: m,
            revisionHeight: v == null ? void 0 : v.revisionHeight,
            revisionNumber: v == null ? void 0 : v.revisionNumber,
            latestHeight: v === void 0
          }));
          return decodeTendermintConsensusStateAny(S.consensusState);
        }
      },
      connection: {
        connection: async (m) => c.Connection({
          connectionId: m
        }),
        connections: async (m) => c.Connections({
          pagination: (0, queryclient_1$5.createPagination)(m)
        }),
        allConnections: async () => {
          var m;
          const v = [];
          let S, $;
          do
            S = await c.Connections({
              pagination: (0, queryclient_1$5.createPagination)($)
            }), v.push(...S.connections), $ = (m = S.pagination) === null || m === void 0 ? void 0 : m.nextKey;
          while ($ && $.length);
          return {
            connections: v,
            height: S.height
          };
        },
        clientConnections: async (m) => c.ClientConnections({
          clientId: m
        }),
        clientState: async (m) => c.ConnectionClientState({
          connectionId: m
        }),
        consensusState: async (m, v) => c.ConnectionConsensusState(query_4.QueryConnectionConsensusStateRequest.fromPartial({
          connectionId: m,
          revisionHeight: long_1$4.default.fromNumber(v, !0)
        }))
      },
      transfer: {
        denomTrace: async (m) => d.DenomTrace({ hash: m }),
        denomTraces: async (m) => d.DenomTraces({
          pagination: (0, queryclient_1$5.createPagination)(m)
        }),
        allDenomTraces: async () => {
          var m;
          const v = [];
          let S, $;
          do
            S = await d.DenomTraces({
              pagination: (0, queryclient_1$5.createPagination)($)
            }), v.push(...S.denomTraces), $ = (m = S.pagination) === null || m === void 0 ? void 0 : m.nextKey;
          while ($ && $.length);
          return {
            denomTraces: v
          };
        },
        params: async () => d.Params({})
      },
      verified: {
        channel: {
          channel: async (m, v) => {
            const S = (0, encoding_1$7.toAscii)(`channelEnds/ports/${m}/channels/${v}`), $ = await e.queryVerified("ibc", S);
            return $.length ? channel_1.Channel.decode($) : null;
          },
          packetCommitment: async (m, v, S) => {
            const $ = (0, encoding_1$7.toAscii)(`commitments/ports/${m}/channels/${v}/packets/${S}`);
            return await e.queryVerified("ibc", $);
          },
          packetAcknowledgement: async (m, v, S) => {
            const $ = (0, encoding_1$7.toAscii)(`acks/ports/${m}/channels/${v}/acknowledgements/${S}`);
            return await e.queryVerified("ibc", $);
          },
          nextSequenceReceive: async (m, v) => {
            const S = (0, encoding_1$7.toAscii)(`seqAcks/ports/${m}/channels/${v}/nextSequenceAck`), $ = await e.queryVerified("ibc", S);
            return $.length ? math_1$4.Uint64.fromBytes($).toNumber() : null;
          }
        }
      }
    }
  };
}
queries$4.setupIbcExtension = setupIbcExtension;
var queries$3 = {};
Object.defineProperty(queries$3, "__esModule", { value: !0 });
queries$3.setupMintExtension = void 0;
const utils_1$3 = build$7, query_1$2 = query$3, queryclient_1$4 = queryclient$1;
function setupMintExtension(e) {
  const n = (0, queryclient_1$4.createProtobufRpcClient)(e), o = new query_1$2.QueryClientImpl(n);
  return {
    mint: {
      params: async () => {
        const { params: u } = await o.Params({});
        return (0, utils_1$3.assert)(u), {
          blocksPerYear: u.blocksPerYear,
          goalBonded: (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(u.goalBonded),
          inflationMin: (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(u.inflationMin),
          inflationMax: (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(u.inflationMax),
          inflationRateChange: (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(u.inflationRateChange),
          mintDenom: u.mintDenom
        };
      },
      inflation: async () => {
        const { inflation: u } = await o.Inflation({});
        return (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(u);
      },
      annualProvisions: async () => {
        const { annualProvisions: u } = await o.AnnualProvisions({});
        return (0, queryclient_1$4.decodeCosmosSdkDecFromProto)(u);
      }
    }
  };
}
queries$3.setupMintExtension = setupMintExtension;
var aminomessages$2 = {};
Object.defineProperty(aminomessages$2, "__esModule", { value: !0 });
aminomessages$2.createSlashingAminoConverters = aminomessages$2.isAminoMsgUnjail = void 0;
function isAminoMsgUnjail(e) {
  return e.type === "cosmos-sdk/MsgUnjail";
}
aminomessages$2.isAminoMsgUnjail = isAminoMsgUnjail;
function createSlashingAminoConverters() {
  throw new Error("Not implemented");
}
aminomessages$2.createSlashingAminoConverters = createSlashingAminoConverters;
var queries$2 = {};
Object.defineProperty(queries$2, "__esModule", { value: !0 });
queries$2.setupSlashingExtension = void 0;
const query_1$1 = query$2, queryclient_1$3 = queryclient$1;
function setupSlashingExtension(e) {
  const n = (0, queryclient_1$3.createProtobufRpcClient)(e), o = new query_1$1.QueryClientImpl(n);
  return {
    slashing: {
      signingInfo: async (u) => await o.SigningInfo({
        consAddress: u
      }),
      signingInfos: async (u) => await o.SigningInfos({
        pagination: (0, queryclient_1$3.createPagination)(u)
      }),
      params: async () => await o.Params({})
    }
  };
}
queries$2.setupSlashingExtension = setupSlashingExtension;
var aminomessages$1 = {};
Object.defineProperty(aminomessages$1, "__esModule", { value: !0 });
aminomessages$1.createStakingAminoConverters = aminomessages$1.isAminoMsgUndelegate = aminomessages$1.isAminoMsgBeginRedelegate = aminomessages$1.isAminoMsgDelegate = aminomessages$1.isAminoMsgEditValidator = aminomessages$1.isAminoMsgCreateValidator = void 0;
const math_1$3 = build$6, proto_signing_1$2 = build$4, utils_1$2 = build$7;
function protoDecimalToJson(e) {
  const n = math_1$3.Decimal.fromAtomics(e, 18), [o, u] = n.toString().split(".");
  return `${o}.${u.padEnd(18, "0")}`;
}
function jsonDecimalToProto(e) {
  return math_1$3.Decimal.fromUserInput(e, 18).atomics;
}
function isAminoMsgCreateValidator(e) {
  return e.type === "cosmos-sdk/MsgCreateValidator";
}
aminomessages$1.isAminoMsgCreateValidator = isAminoMsgCreateValidator;
function isAminoMsgEditValidator(e) {
  return e.type === "cosmos-sdk/MsgEditValidator";
}
aminomessages$1.isAminoMsgEditValidator = isAminoMsgEditValidator;
function isAminoMsgDelegate(e) {
  return e.type === "cosmos-sdk/MsgDelegate";
}
aminomessages$1.isAminoMsgDelegate = isAminoMsgDelegate;
function isAminoMsgBeginRedelegate(e) {
  return e.type === "cosmos-sdk/MsgBeginRedelegate";
}
aminomessages$1.isAminoMsgBeginRedelegate = isAminoMsgBeginRedelegate;
function isAminoMsgUndelegate(e) {
  return e.type === "cosmos-sdk/MsgUndelegate";
}
aminomessages$1.isAminoMsgUndelegate = isAminoMsgUndelegate;
function createStakingAminoConverters(e) {
  return {
    "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
      aminoType: "cosmos-sdk/MsgBeginRedelegate",
      toAmino: ({ delegatorAddress: n, validatorSrcAddress: o, validatorDstAddress: u, amount: c }) => ((0, utils_1$2.assertDefinedAndNotNull)(c, "missing amount"), {
        delegator_address: n,
        validator_src_address: o,
        validator_dst_address: u,
        amount: c
      }),
      fromAmino: ({ delegator_address: n, validator_src_address: o, validator_dst_address: u, amount: c }) => ({
        delegatorAddress: n,
        validatorSrcAddress: o,
        validatorDstAddress: u,
        amount: c
      })
    },
    "/cosmos.staking.v1beta1.MsgCreateValidator": {
      aminoType: "cosmos-sdk/MsgCreateValidator",
      toAmino: ({ description: n, commission: o, minSelfDelegation: u, delegatorAddress: c, validatorAddress: d, pubkey: m, value: v }) => ((0, utils_1$2.assertDefinedAndNotNull)(n, "missing description"), (0, utils_1$2.assertDefinedAndNotNull)(o, "missing commission"), (0, utils_1$2.assertDefinedAndNotNull)(m, "missing pubkey"), (0, utils_1$2.assertDefinedAndNotNull)(v, "missing value"), {
        description: {
          moniker: n.moniker,
          identity: n.identity,
          website: n.website,
          security_contact: n.securityContact,
          details: n.details
        },
        commission: {
          rate: protoDecimalToJson(o.rate),
          max_rate: protoDecimalToJson(o.maxRate),
          max_change_rate: protoDecimalToJson(o.maxChangeRate)
        },
        min_self_delegation: u,
        delegator_address: c,
        validator_address: d,
        pubkey: (0, proto_signing_1$2.anyToSinglePubkey)(m),
        value: v
      }),
      fromAmino: ({ description: n, commission: o, min_self_delegation: u, delegator_address: c, validator_address: d, pubkey: m, value: v }) => ({
        description: {
          moniker: n.moniker,
          identity: n.identity,
          website: n.website,
          securityContact: n.security_contact,
          details: n.details
        },
        commission: {
          rate: jsonDecimalToProto(o.rate),
          maxRate: jsonDecimalToProto(o.max_rate),
          maxChangeRate: jsonDecimalToProto(o.max_change_rate)
        },
        minSelfDelegation: u,
        delegatorAddress: c,
        validatorAddress: d,
        pubkey: (0, proto_signing_1$2.encodePubkey)(m),
        value: v
      })
    },
    "/cosmos.staking.v1beta1.MsgDelegate": {
      aminoType: "cosmos-sdk/MsgDelegate",
      toAmino: ({ delegatorAddress: n, validatorAddress: o, amount: u }) => ((0, utils_1$2.assertDefinedAndNotNull)(u, "missing amount"), {
        delegator_address: n,
        validator_address: o,
        amount: u
      }),
      fromAmino: ({ delegator_address: n, validator_address: o, amount: u }) => ({
        delegatorAddress: n,
        validatorAddress: o,
        amount: u
      })
    },
    "/cosmos.staking.v1beta1.MsgEditValidator": {
      aminoType: "cosmos-sdk/MsgEditValidator",
      toAmino: ({ description: n, commissionRate: o, minSelfDelegation: u, validatorAddress: c }) => ((0, utils_1$2.assertDefinedAndNotNull)(n, "missing description"), {
        description: {
          moniker: n.moniker,
          identity: n.identity,
          website: n.website,
          security_contact: n.securityContact,
          details: n.details
        },
        // empty string in the protobuf document means "do not change"
        commission_rate: o ? protoDecimalToJson(o) : void 0,
        // empty string in the protobuf document means "do not change"
        min_self_delegation: u || void 0,
        validator_address: c
      }),
      fromAmino: ({ description: n, commission_rate: o, min_self_delegation: u, validator_address: c }) => ({
        description: {
          moniker: n.moniker,
          identity: n.identity,
          website: n.website,
          securityContact: n.security_contact,
          details: n.details
        },
        // empty string in the protobuf document means "do not change"
        commissionRate: o ? jsonDecimalToProto(o) : "",
        // empty string in the protobuf document means "do not change"
        minSelfDelegation: u ?? "",
        validatorAddress: c
      })
    },
    "/cosmos.staking.v1beta1.MsgUndelegate": {
      aminoType: "cosmos-sdk/MsgUndelegate",
      toAmino: ({ delegatorAddress: n, validatorAddress: o, amount: u }) => ((0, utils_1$2.assertDefinedAndNotNull)(u, "missing amount"), {
        delegator_address: n,
        validator_address: o,
        amount: u
      }),
      fromAmino: ({ delegator_address: n, validator_address: o, amount: u }) => ({
        delegatorAddress: n,
        validatorAddress: o,
        amount: u
      })
    }
  };
}
aminomessages$1.createStakingAminoConverters = createStakingAminoConverters;
var messages$1 = {};
Object.defineProperty(messages$1, "__esModule", { value: !0 });
messages$1.isMsgUndelegateEncodeObject = messages$1.isMsgEditValidatorEncodeObject = messages$1.isMsgDelegateEncodeObject = messages$1.isMsgCreateValidatorEncodeObject = messages$1.isMsgBeginRedelegateEncodeObject = messages$1.stakingTypes = void 0;
const tx_1$3 = tx$d;
messages$1.stakingTypes = [
  ["/cosmos.staking.v1beta1.MsgBeginRedelegate", tx_1$3.MsgBeginRedelegate],
  ["/cosmos.staking.v1beta1.MsgCreateValidator", tx_1$3.MsgCreateValidator],
  ["/cosmos.staking.v1beta1.MsgDelegate", tx_1$3.MsgDelegate],
  ["/cosmos.staking.v1beta1.MsgEditValidator", tx_1$3.MsgEditValidator],
  ["/cosmos.staking.v1beta1.MsgUndelegate", tx_1$3.MsgUndelegate]
];
function isMsgBeginRedelegateEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
messages$1.isMsgBeginRedelegateEncodeObject = isMsgBeginRedelegateEncodeObject;
function isMsgCreateValidatorEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
messages$1.isMsgCreateValidatorEncodeObject = isMsgCreateValidatorEncodeObject;
function isMsgDelegateEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
messages$1.isMsgDelegateEncodeObject = isMsgDelegateEncodeObject;
function isMsgEditValidatorEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
messages$1.isMsgEditValidatorEncodeObject = isMsgEditValidatorEncodeObject;
function isMsgUndelegateEncodeObject(e) {
  return e.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
messages$1.isMsgUndelegateEncodeObject = isMsgUndelegateEncodeObject;
var queries$1 = {}, __importDefault$5 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries$1, "__esModule", { value: !0 });
queries$1.setupStakingExtension = void 0;
const query_1 = query$1, long_1$3 = __importDefault$5(long), queryclient_1$2 = queryclient$1;
function setupStakingExtension(e) {
  const n = (0, queryclient_1$2.createProtobufRpcClient)(e), o = new query_1.QueryClientImpl(n);
  return {
    staking: {
      delegation: async (u, c) => await o.Delegation({
        delegatorAddr: u,
        validatorAddr: c
      }),
      delegatorDelegations: async (u, c) => await o.DelegatorDelegations({
        delegatorAddr: u,
        pagination: (0, queryclient_1$2.createPagination)(c)
      }),
      delegatorUnbondingDelegations: async (u, c) => await o.DelegatorUnbondingDelegations({
        delegatorAddr: u,
        pagination: (0, queryclient_1$2.createPagination)(c)
      }),
      delegatorValidator: async (u, c) => await o.DelegatorValidator({
        delegatorAddr: u,
        validatorAddr: c
      }),
      delegatorValidators: async (u, c) => await o.DelegatorValidators({
        delegatorAddr: u,
        pagination: (0, queryclient_1$2.createPagination)(c)
      }),
      historicalInfo: async (u) => await o.HistoricalInfo({
        height: long_1$3.default.fromNumber(u, !0)
      }),
      params: async () => await o.Params({}),
      pool: async () => await o.Pool({}),
      redelegations: async (u, c, d, m) => await o.Redelegations({
        delegatorAddr: u,
        srcValidatorAddr: c,
        dstValidatorAddr: d,
        pagination: (0, queryclient_1$2.createPagination)(m)
      }),
      unbondingDelegation: async (u, c) => await o.UnbondingDelegation({
        delegatorAddr: u,
        validatorAddr: c
      }),
      validator: async (u) => await o.Validator({ validatorAddr: u }),
      validatorDelegations: async (u, c) => await o.ValidatorDelegations({
        validatorAddr: u,
        pagination: (0, queryclient_1$2.createPagination)(c)
      }),
      validators: async (u, c) => await o.Validators({
        status: u,
        pagination: (0, queryclient_1$2.createPagination)(c)
      }),
      validatorUnbondingDelegations: async (u, c) => await o.ValidatorUnbondingDelegations({
        validatorAddr: u,
        pagination: (0, queryclient_1$2.createPagination)(c)
      })
    }
  };
}
queries$1.setupStakingExtension = setupStakingExtension;
var queries = {}, __importDefault$4 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(queries, "__esModule", { value: !0 });
queries.setupTxExtension = void 0;
const proto_signing_1$1 = build$4, signing_1$1 = signing$3, service_1 = service, tx_1$2 = tx$p, long_1$2 = __importDefault$4(long), queryclient_1$1 = queryclient$1;
function setupTxExtension(e) {
  const n = (0, queryclient_1$1.createProtobufRpcClient)(e), o = new service_1.ServiceClientImpl(n);
  return {
    tx: {
      getTx: async (u) => {
        const c = {
          hash: u
        };
        return await o.GetTx(c);
      },
      simulate: async (u, c, d, m) => {
        const v = tx_1$2.Tx.fromPartial({
          authInfo: tx_1$2.AuthInfo.fromPartial({
            fee: tx_1$2.Fee.fromPartial({}),
            signerInfos: [
              {
                publicKey: (0, proto_signing_1$1.encodePubkey)(d),
                sequence: long_1$2.default.fromNumber(m, !0),
                modeInfo: { single: { mode: signing_1$1.SignMode.SIGN_MODE_UNSPECIFIED } }
              }
            ]
          }),
          body: tx_1$2.TxBody.fromPartial({
            messages: Array.from(u),
            memo: c
          }),
          signatures: [new Uint8Array()]
        }), S = service_1.SimulateRequest.fromPartial({
          txBytes: tx_1$2.Tx.encode(v).finish()
        });
        return await o.Simulate(S);
      }
    }
  };
}
queries.setupTxExtension = setupTxExtension;
var aminomessages = {}, __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(aminomessages, "__esModule", { value: !0 });
aminomessages.createVestingAminoConverters = aminomessages.isAminoMsgCreateVestingAccount = void 0;
const long_1$1 = __importDefault$3(long);
function isAminoMsgCreateVestingAccount(e) {
  return e.type === "cosmos-sdk/MsgCreateVestingAccount";
}
aminomessages.isAminoMsgCreateVestingAccount = isAminoMsgCreateVestingAccount;
function createVestingAminoConverters() {
  return {
    "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
      aminoType: "cosmos-sdk/MsgCreateVestingAccount",
      toAmino: ({ fromAddress: e, toAddress: n, amount: o, endTime: u, delayed: c }) => ({
        from_address: e,
        to_address: n,
        amount: [...o],
        end_time: u.toString(),
        delayed: c
      }),
      fromAmino: ({ from_address: e, to_address: n, amount: o, end_time: u, delayed: c }) => ({
        fromAddress: e,
        toAddress: n,
        amount: [...o],
        endTime: long_1$1.default.fromString(u),
        delayed: c
      })
    }
  };
}
aminomessages.createVestingAminoConverters = createVestingAminoConverters;
var messages = {};
Object.defineProperty(messages, "__esModule", { value: !0 });
messages.vestingTypes = void 0;
const tx_1$1 = tx$c;
messages.vestingTypes = [
  ["/cosmos.vesting.v1beta1.MsgCreateVestingAccount", tx_1$1.MsgCreateVestingAccount]
];
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isAminoMsgEditValidator = e.isAminoMsgDelegate = e.isAminoMsgCreateValidator = e.isAminoMsgBeginRedelegate = e.createStakingAminoConverters = e.setupSlashingExtension = e.isAminoMsgUnjail = e.createSlashingAminoConverters = e.setupMintExtension = e.setupIbcExtension = e.isMsgTransferEncodeObject = e.ibcTypes = e.isAminoMsgTransfer = e.createIbcAminoConverters = e.setupGovExtension = e.isMsgVoteWeightedEncodeObject = e.isMsgVoteEncodeObject = e.isMsgSubmitProposalEncodeObject = e.isMsgDepositEncodeObject = e.govTypes = e.isAminoMsgVoteWeighted = e.isAminoMsgVote = e.isAminoMsgSubmitProposal = e.isAminoMsgDeposit = e.createGovAminoConverters = e.setupFeegrantExtension = e.feegrantTypes = e.createFeegrantAminoConverters = e.isAminoMsgSubmitEvidence = e.createEvidenceAminoConverters = e.setupDistributionExtension = e.isMsgWithdrawDelegatorRewardEncodeObject = e.distributionTypes = e.isAminoMsgWithdrawValidatorCommission = e.isAminoMsgWithdrawDelegatorReward = e.isAminoMsgSetWithdrawAddress = e.isAminoMsgFundCommunityPool = e.createDistributionAminoConverters = e.isAminoMsgVerifyInvariant = e.createCrysisAminoConverters = e.setupBankExtension = e.isMsgSendEncodeObject = e.bankTypes = e.isAminoMsgSend = e.isAminoMsgMultiSend = e.createBankAminoConverters = e.setupAuthzExtension = e.authzTypes = e.createAuthzAminoConverters = e.setupAuthExtension = void 0, e.vestingTypes = e.isAminoMsgCreateVestingAccount = e.createVestingAminoConverters = e.setupTxExtension = e.setupStakingExtension = e.stakingTypes = e.isMsgUndelegateEncodeObject = e.isMsgEditValidatorEncodeObject = e.isMsgDelegateEncodeObject = e.isMsgCreateValidatorEncodeObject = e.isMsgBeginRedelegateEncodeObject = e.isAminoMsgUndelegate = void 0;
  var n = queries$a;
  Object.defineProperty(e, "setupAuthExtension", { enumerable: !0, get: function() {
    return n.setupAuthExtension;
  } });
  var o = aminomessages$a;
  Object.defineProperty(e, "createAuthzAminoConverters", { enumerable: !0, get: function() {
    return o.createAuthzAminoConverters;
  } });
  var u = messages$7;
  Object.defineProperty(e, "authzTypes", { enumerable: !0, get: function() {
    return u.authzTypes;
  } });
  var c = queries$9;
  Object.defineProperty(e, "setupAuthzExtension", { enumerable: !0, get: function() {
    return c.setupAuthzExtension;
  } });
  var d = aminomessages$9;
  Object.defineProperty(e, "createBankAminoConverters", { enumerable: !0, get: function() {
    return d.createBankAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgMultiSend", { enumerable: !0, get: function() {
    return d.isAminoMsgMultiSend;
  } }), Object.defineProperty(e, "isAminoMsgSend", { enumerable: !0, get: function() {
    return d.isAminoMsgSend;
  } });
  var m = messages$6;
  Object.defineProperty(e, "bankTypes", { enumerable: !0, get: function() {
    return m.bankTypes;
  } }), Object.defineProperty(e, "isMsgSendEncodeObject", { enumerable: !0, get: function() {
    return m.isMsgSendEncodeObject;
  } });
  var v = queries$8;
  Object.defineProperty(e, "setupBankExtension", { enumerable: !0, get: function() {
    return v.setupBankExtension;
  } });
  var S = aminomessages$8;
  Object.defineProperty(e, "createCrysisAminoConverters", { enumerable: !0, get: function() {
    return S.createCrysisAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgVerifyInvariant", { enumerable: !0, get: function() {
    return S.isAminoMsgVerifyInvariant;
  } });
  var $ = aminomessages$7;
  Object.defineProperty(e, "createDistributionAminoConverters", { enumerable: !0, get: function() {
    return $.createDistributionAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgFundCommunityPool", { enumerable: !0, get: function() {
    return $.isAminoMsgFundCommunityPool;
  } }), Object.defineProperty(e, "isAminoMsgSetWithdrawAddress", { enumerable: !0, get: function() {
    return $.isAminoMsgSetWithdrawAddress;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawDelegatorReward", { enumerable: !0, get: function() {
    return $.isAminoMsgWithdrawDelegatorReward;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawValidatorCommission", { enumerable: !0, get: function() {
    return $.isAminoMsgWithdrawValidatorCommission;
  } });
  var E = messages$5;
  Object.defineProperty(e, "distributionTypes", { enumerable: !0, get: function() {
    return E.distributionTypes;
  } }), Object.defineProperty(e, "isMsgWithdrawDelegatorRewardEncodeObject", { enumerable: !0, get: function() {
    return E.isMsgWithdrawDelegatorRewardEncodeObject;
  } });
  var O = queries$7;
  Object.defineProperty(e, "setupDistributionExtension", { enumerable: !0, get: function() {
    return O.setupDistributionExtension;
  } });
  var T = aminomessages$6;
  Object.defineProperty(e, "createEvidenceAminoConverters", { enumerable: !0, get: function() {
    return T.createEvidenceAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgSubmitEvidence", { enumerable: !0, get: function() {
    return T.isAminoMsgSubmitEvidence;
  } });
  var y = aminomessages$5;
  Object.defineProperty(e, "createFeegrantAminoConverters", { enumerable: !0, get: function() {
    return y.createFeegrantAminoConverters;
  } });
  var V = messages$4;
  Object.defineProperty(e, "feegrantTypes", { enumerable: !0, get: function() {
    return V.feegrantTypes;
  } });
  var M = queries$6;
  Object.defineProperty(e, "setupFeegrantExtension", { enumerable: !0, get: function() {
    return M.setupFeegrantExtension;
  } });
  var G = aminomessages$4;
  Object.defineProperty(e, "createGovAminoConverters", { enumerable: !0, get: function() {
    return G.createGovAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgDeposit", { enumerable: !0, get: function() {
    return G.isAminoMsgDeposit;
  } }), Object.defineProperty(e, "isAminoMsgSubmitProposal", { enumerable: !0, get: function() {
    return G.isAminoMsgSubmitProposal;
  } }), Object.defineProperty(e, "isAminoMsgVote", { enumerable: !0, get: function() {
    return G.isAminoMsgVote;
  } }), Object.defineProperty(e, "isAminoMsgVoteWeighted", { enumerable: !0, get: function() {
    return G.isAminoMsgVoteWeighted;
  } });
  var k = messages$3;
  Object.defineProperty(e, "govTypes", { enumerable: !0, get: function() {
    return k.govTypes;
  } }), Object.defineProperty(e, "isMsgDepositEncodeObject", { enumerable: !0, get: function() {
    return k.isMsgDepositEncodeObject;
  } }), Object.defineProperty(e, "isMsgSubmitProposalEncodeObject", { enumerable: !0, get: function() {
    return k.isMsgSubmitProposalEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteEncodeObject", { enumerable: !0, get: function() {
    return k.isMsgVoteEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteWeightedEncodeObject", { enumerable: !0, get: function() {
    return k.isMsgVoteWeightedEncodeObject;
  } });
  var F = queries$5;
  Object.defineProperty(e, "setupGovExtension", { enumerable: !0, get: function() {
    return F.setupGovExtension;
  } });
  var X = aminomessages$3;
  Object.defineProperty(e, "createIbcAminoConverters", { enumerable: !0, get: function() {
    return X.createIbcAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgTransfer", { enumerable: !0, get: function() {
    return X.isAminoMsgTransfer;
  } });
  var ee = messages$2;
  Object.defineProperty(e, "ibcTypes", { enumerable: !0, get: function() {
    return ee.ibcTypes;
  } }), Object.defineProperty(e, "isMsgTransferEncodeObject", { enumerable: !0, get: function() {
    return ee.isMsgTransferEncodeObject;
  } });
  var ue = queries$4;
  Object.defineProperty(e, "setupIbcExtension", { enumerable: !0, get: function() {
    return ue.setupIbcExtension;
  } });
  var Q = queries$3;
  Object.defineProperty(e, "setupMintExtension", { enumerable: !0, get: function() {
    return Q.setupMintExtension;
  } });
  var Y = aminomessages$2;
  Object.defineProperty(e, "createSlashingAminoConverters", { enumerable: !0, get: function() {
    return Y.createSlashingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgUnjail", { enumerable: !0, get: function() {
    return Y.isAminoMsgUnjail;
  } });
  var pe = queries$2;
  Object.defineProperty(e, "setupSlashingExtension", { enumerable: !0, get: function() {
    return pe.setupSlashingExtension;
  } });
  var oe = aminomessages$1;
  Object.defineProperty(e, "createStakingAminoConverters", { enumerable: !0, get: function() {
    return oe.createStakingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgBeginRedelegate", { enumerable: !0, get: function() {
    return oe.isAminoMsgBeginRedelegate;
  } }), Object.defineProperty(e, "isAminoMsgCreateValidator", { enumerable: !0, get: function() {
    return oe.isAminoMsgCreateValidator;
  } }), Object.defineProperty(e, "isAminoMsgDelegate", { enumerable: !0, get: function() {
    return oe.isAminoMsgDelegate;
  } }), Object.defineProperty(e, "isAminoMsgEditValidator", { enumerable: !0, get: function() {
    return oe.isAminoMsgEditValidator;
  } }), Object.defineProperty(e, "isAminoMsgUndelegate", { enumerable: !0, get: function() {
    return oe.isAminoMsgUndelegate;
  } });
  var ne = messages$1;
  Object.defineProperty(e, "isMsgBeginRedelegateEncodeObject", { enumerable: !0, get: function() {
    return ne.isMsgBeginRedelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgCreateValidatorEncodeObject", { enumerable: !0, get: function() {
    return ne.isMsgCreateValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgDelegateEncodeObject", { enumerable: !0, get: function() {
    return ne.isMsgDelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgEditValidatorEncodeObject", { enumerable: !0, get: function() {
    return ne.isMsgEditValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgUndelegateEncodeObject", { enumerable: !0, get: function() {
    return ne.isMsgUndelegateEncodeObject;
  } }), Object.defineProperty(e, "stakingTypes", { enumerable: !0, get: function() {
    return ne.stakingTypes;
  } });
  var H = queries$1;
  Object.defineProperty(e, "setupStakingExtension", { enumerable: !0, get: function() {
    return H.setupStakingExtension;
  } });
  var C = queries;
  Object.defineProperty(e, "setupTxExtension", { enumerable: !0, get: function() {
    return C.setupTxExtension;
  } });
  var w = aminomessages;
  Object.defineProperty(e, "createVestingAminoConverters", { enumerable: !0, get: function() {
    return w.createVestingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgCreateVestingAccount", { enumerable: !0, get: function() {
    return w.isAminoMsgCreateVestingAccount;
  } });
  var P = messages;
  Object.defineProperty(e, "vestingTypes", { enumerable: !0, get: function() {
    return P.vestingTypes;
  } });
})(modules);
var multisignature = {}, __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(multisignature, "__esModule", { value: !0 });
multisignature.makeMultisignedTxBytes = multisignature.makeMultisignedTx = multisignature.makeCompactBitArray = void 0;
const amino_1$1 = build$9, encoding_1$6 = build$a, proto_signing_1 = build$4, multisig_1 = multisig$3, signing_1 = signing$3, tx_1 = tx$p, tx_2 = tx$p, long_1 = __importDefault$2(long);
function makeCompactBitArray(e) {
  const n = Math.ceil(e.length / 8), o = e.length - Math.floor(e.length / 8) * 8, u = new Uint8Array(n);
  return e.forEach((c, d) => {
    const m = Math.floor(d / 8), v = d % 8;
    c && (u[m] |= 1 << 8 - 1 - v);
  }), multisig_1.CompactBitArray.fromPartial({ elems: u, extraBitsStored: o });
}
multisignature.makeCompactBitArray = makeCompactBitArray;
function makeMultisignedTx(e, n, o, u, c) {
  const d = Array.from(c.keys()), m = (0, encoding_1$6.fromBech32)(d[0]).prefix, v = Array(e.value.pubkeys.length).fill(!1), S = new Array();
  for (let y = 0; y < e.value.pubkeys.length; y++) {
    const V = (0, amino_1$1.pubkeyToAddress)(e.value.pubkeys[y], m), M = c.get(V);
    M && (v[y] = !0, S.push(M));
  }
  const $ = {
    publicKey: (0, proto_signing_1.encodePubkey)(e),
    modeInfo: {
      multi: {
        bitarray: makeCompactBitArray(v),
        modeInfos: S.map((y) => ({ single: { mode: signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON } }))
      }
    },
    sequence: long_1.default.fromNumber(n)
  }, E = tx_1.AuthInfo.fromPartial({
    signerInfos: [$],
    fee: {
      amount: [...o.amount],
      gasLimit: long_1.default.fromString(o.gas)
    }
  }), O = tx_1.AuthInfo.encode(E).finish();
  return tx_2.TxRaw.fromPartial({
    bodyBytes: u,
    authInfoBytes: O,
    signatures: [multisig_1.MultiSignature.encode(multisig_1.MultiSignature.fromPartial({ signatures: S })).finish()]
  });
}
multisignature.makeMultisignedTx = makeMultisignedTx;
function makeMultisignedTxBytes(e, n, o, u, c) {
  const d = makeMultisignedTx(e, n, o, u, c);
  return Uint8Array.from(tx_2.TxRaw.encode(d).finish());
}
multisignature.makeMultisignedTxBytes = makeMultisignedTxBytes;
var search = {};
Object.defineProperty(search, "__esModule", { value: !0 });
search.isSearchByTagsQuery = search.isSearchBySentFromOrToQuery = search.isSearchByHeightQuery = void 0;
function isSearchByHeightQuery(e) {
  return e.height !== void 0;
}
search.isSearchByHeightQuery = isSearchByHeightQuery;
function isSearchBySentFromOrToQuery(e) {
  return e.sentFromOrTo !== void 0;
}
search.isSearchBySentFromOrToQuery = isSearchBySentFromOrToQuery;
function isSearchByTagsQuery(e) {
  return e.tags !== void 0;
}
search.isSearchByTagsQuery = isSearchByTagsQuery;
var signingstargateclient = {}, build$2 = {}, addresses = {};
Object.defineProperty(addresses, "__esModule", { value: !0 });
addresses.pubkeyToAddress = addresses.pubkeyToRawAddress = addresses.rawSecp256k1PubkeyToRawAddress = addresses.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$1 = build$8, encoding_1$5 = build$a;
function rawEd25519PubkeyToRawAddress(e) {
  if (e.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${e.length}`);
  return (0, crypto_1$1.sha256)(e).slice(0, 20);
}
addresses.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(e) {
  if (e.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${e.length}`);
  return (0, crypto_1$1.ripemd160)((0, crypto_1$1.sha256)(e));
}
addresses.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
function pubkeyToRawAddress(e, n) {
  switch (e) {
    case "ed25519":
      return rawEd25519PubkeyToRawAddress(n);
    case "secp256k1":
      return rawSecp256k1PubkeyToRawAddress(n);
    default:
      throw new Error(`Pubkey type ${e} not supported`);
  }
}
addresses.pubkeyToRawAddress = pubkeyToRawAddress;
function pubkeyToAddress(e, n) {
  return (0, encoding_1$5.toHex)(pubkeyToRawAddress(e, n)).toUpperCase();
}
addresses.pubkeyToAddress = pubkeyToAddress;
var dates = {};
Object.defineProperty(dates, "__esModule", { value: !0 });
dates.DateTime = dates.toSeconds = dates.fromSeconds = dates.toRfc3339WithNanoseconds = dates.fromRfc3339WithNanoseconds = void 0;
const encoding_1$4 = build$a, math_1$2 = build$6;
function fromRfc3339WithNanoseconds(e) {
  const n = (0, encoding_1$4.fromRfc3339)(e), o = e.match(/\.(\d+)Z$/), u = o ? o[1].slice(3) : "";
  return n.nanoseconds = parseInt(u.padEnd(6, "0"), 10), n;
}
dates.fromRfc3339WithNanoseconds = fromRfc3339WithNanoseconds;
function toRfc3339WithNanoseconds(e) {
  var n, o;
  const u = e.toISOString(), c = (o = (n = e.nanoseconds) === null || n === void 0 ? void 0 : n.toString()) !== null && o !== void 0 ? o : "";
  return `${u.slice(0, -1)}${c.padStart(6, "0")}Z`;
}
dates.toRfc3339WithNanoseconds = toRfc3339WithNanoseconds;
function fromSeconds(e, n = 0) {
  const o = new math_1$2.Uint32(n).toNumber();
  if (o > 999999999)
    throw new Error("Nano seconds must not exceed 999999999");
  const u = new Date(e * 1e3 + Math.floor(o / 1e6));
  return u.nanoseconds = o % 1e6, u;
}
dates.fromSeconds = fromSeconds;
function toSeconds(e) {
  var n;
  return {
    seconds: Math.floor(e.getTime() / 1e3),
    nanos: e.getTime() % 1e3 * 1e6 + ((n = e.nanoseconds) !== null && n !== void 0 ? n : 0)
  };
}
dates.toSeconds = toSeconds;
class DateTime {
  /** @deprecated Use fromRfc3339WithNanoseconds instead */
  static decode(n) {
    return fromRfc3339WithNanoseconds(n);
  }
  /** @deprecated Use toRfc3339WithNanoseconds instead */
  static encode(n) {
    return toRfc3339WithNanoseconds(n);
  }
}
dates.DateTime = DateTime;
var rpcclients = {}, httpbatchclient = {}, build$1 = {}, id = {};
Object.defineProperty(id, "__esModule", { value: !0 });
id.makeJsonRpcId = void 0;
let counter = 1e4;
function makeJsonRpcId() {
  return counter += 1;
}
id.makeJsonRpcId = makeJsonRpcId;
var jsonrpcclient = {}, types$1 = {};
Object.defineProperty(types$1, "__esModule", { value: !0 });
types$1.jsonRpcCode = types$1.isJsonRpcSuccessResponse = types$1.isJsonRpcErrorResponse = void 0;
function isJsonRpcErrorResponse(e) {
  return typeof e.error == "object";
}
types$1.isJsonRpcErrorResponse = isJsonRpcErrorResponse;
function isJsonRpcSuccessResponse(e) {
  return !isJsonRpcErrorResponse(e);
}
types$1.isJsonRpcSuccessResponse = isJsonRpcSuccessResponse;
types$1.jsonRpcCode = {
  parseError: -32700,
  invalidRequest: -32600,
  methodNotFound: -32601,
  invalidParams: -32602,
  internalError: -32603,
  // server error (Reserved for implementation-defined server-errors.):
  // -32000 to -32099
  serverError: {
    default: -32e3
  }
};
Object.defineProperty(jsonrpcclient, "__esModule", { value: !0 });
jsonrpcclient.JsonRpcClient = void 0;
const stream_1$1 = build$3, types_1$1 = types$1;
class JsonRpcClient {
  constructor(n) {
    this.connection = n;
  }
  async run(n) {
    const o = this.connection.responseStream.filter((d) => d.id === n.id), u = (0, stream_1$1.firstEvent)(o);
    this.connection.sendRequest(n);
    const c = await u;
    if ((0, types_1$1.isJsonRpcErrorResponse)(c)) {
      const d = c.error;
      throw new Error(`JSON RPC error: code=${d.code}; message='${d.message}'`);
    }
    return c;
  }
}
jsonrpcclient.JsonRpcClient = JsonRpcClient;
var parse = {}, compatibility = {};
Object.defineProperty(compatibility, "__esModule", { value: !0 });
compatibility.isJsonCompatibleDictionary = compatibility.isJsonCompatibleArray = compatibility.isJsonCompatibleValue = void 0;
function isJsonCompatibleValue(e) {
  return !!(typeof e == "string" || typeof e == "number" || typeof e == "boolean" || e === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleArray(e) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isJsonCompatibleDictionary(e));
}
compatibility.isJsonCompatibleValue = isJsonCompatibleValue;
function isJsonCompatibleArray(e) {
  if (!Array.isArray(e))
    return !1;
  for (const n of e)
    if (!isJsonCompatibleValue(n))
      return !1;
  return !0;
}
compatibility.isJsonCompatibleArray = isJsonCompatibleArray;
function isJsonCompatibleDictionary(e) {
  return typeof e != "object" || e === null || Object.prototype.toString.call(e) !== "[object Object]" ? !1 : Object.values(e).every(isJsonCompatibleValue);
}
compatibility.isJsonCompatibleDictionary = isJsonCompatibleDictionary;
Object.defineProperty(parse, "__esModule", { value: !0 });
parse.parseJsonRpcResponse = parse.parseJsonRpcSuccessResponse = parse.parseJsonRpcErrorResponse = parse.parseJsonRpcRequest = parse.parseJsonRpcId = void 0;
const compatibility_1 = compatibility;
function parseJsonRpcId(e) {
  if (!(0, compatibility_1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  const n = e.id;
  return typeof n != "number" && typeof n != "string" ? null : n;
}
parse.parseJsonRpcId = parseJsonRpcId;
function parseJsonRpcRequest(e) {
  if (!(0, compatibility_1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${e.jsonrpc}`);
  const n = parseJsonRpcId(e);
  if (n === null)
    throw new Error("Invalid id field");
  const o = e.method;
  if (typeof o != "string")
    throw new Error("Invalid method field");
  if (!(0, compatibility_1.isJsonCompatibleArray)(e.params) && !(0, compatibility_1.isJsonCompatibleDictionary)(e.params))
    throw new Error("Invalid params field");
  return {
    jsonrpc: "2.0",
    id: n,
    method: o,
    params: e.params
  };
}
parse.parseJsonRpcRequest = parseJsonRpcRequest;
function parseError(e) {
  if (typeof e.code != "number")
    throw new Error("Error property 'code' is not a number");
  if (typeof e.message != "string")
    throw new Error("Error property 'message' is not a string");
  let n;
  if (e.data === void 0)
    n = void 0;
  else if ((0, compatibility_1.isJsonCompatibleValue)(e.data))
    n = e.data;
  else
    throw new Error("Error property 'data' is defined but not a JSON compatible value.");
  return {
    code: e.code,
    message: e.message,
    ...n !== void 0 ? { data: n } : {}
  };
}
function parseJsonRpcErrorResponse(e) {
  if (!(0, compatibility_1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const n = e.id;
  if (typeof n != "number" && typeof n != "string" && n !== null)
    throw new Error("Invalid id field");
  if (typeof e.error > "u" || !(0, compatibility_1.isJsonCompatibleDictionary)(e.error))
    throw new Error("Invalid error field");
  return {
    jsonrpc: "2.0",
    id: n,
    error: parseError(e.error)
  };
}
parse.parseJsonRpcErrorResponse = parseJsonRpcErrorResponse;
function parseJsonRpcSuccessResponse(e) {
  if (!(0, compatibility_1.isJsonCompatibleDictionary)(e))
    throw new Error("Data must be JSON compatible dictionary");
  if (e.jsonrpc !== "2.0")
    throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(e)}`);
  const n = e.id;
  if (typeof n != "number" && typeof n != "string")
    throw new Error("Invalid id field");
  if (typeof e.result > "u")
    throw new Error("Invalid result field");
  const o = e.result;
  return {
    jsonrpc: "2.0",
    id: n,
    result: o
  };
}
parse.parseJsonRpcSuccessResponse = parseJsonRpcSuccessResponse;
function parseJsonRpcResponse(e) {
  let n;
  try {
    n = parseJsonRpcErrorResponse(e);
  } catch {
    n = parseJsonRpcSuccessResponse(e);
  }
  return n;
}
parse.parseJsonRpcResponse = parseJsonRpcResponse;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.jsonRpcCode = e.isJsonRpcSuccessResponse = e.isJsonRpcErrorResponse = e.parseJsonRpcSuccessResponse = e.parseJsonRpcResponse = e.parseJsonRpcRequest = e.parseJsonRpcId = e.parseJsonRpcErrorResponse = e.JsonRpcClient = e.makeJsonRpcId = void 0;
  var n = id;
  Object.defineProperty(e, "makeJsonRpcId", { enumerable: !0, get: function() {
    return n.makeJsonRpcId;
  } });
  var o = jsonrpcclient;
  Object.defineProperty(e, "JsonRpcClient", { enumerable: !0, get: function() {
    return o.JsonRpcClient;
  } });
  var u = parse;
  Object.defineProperty(e, "parseJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "parseJsonRpcId", { enumerable: !0, get: function() {
    return u.parseJsonRpcId;
  } }), Object.defineProperty(e, "parseJsonRpcRequest", { enumerable: !0, get: function() {
    return u.parseJsonRpcRequest;
  } }), Object.defineProperty(e, "parseJsonRpcResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcResponse;
  } }), Object.defineProperty(e, "parseJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return u.parseJsonRpcSuccessResponse;
  } });
  var c = types$1;
  Object.defineProperty(e, "isJsonRpcErrorResponse", { enumerable: !0, get: function() {
    return c.isJsonRpcErrorResponse;
  } }), Object.defineProperty(e, "isJsonRpcSuccessResponse", { enumerable: !0, get: function() {
    return c.isJsonRpcSuccessResponse;
  } }), Object.defineProperty(e, "jsonRpcCode", { enumerable: !0, get: function() {
    return c.jsonRpcCode;
  } });
})(build$1);
var http$1 = {}, axios$6 = { exports: {} }, bind$5 = function e(n, o) {
  return function() {
    for (var c = new Array(arguments.length), d = 0; d < c.length; d++)
      c[d] = arguments[d];
    return n.apply(o, c);
  };
}, bind$4 = bind$5, toString$1 = Object.prototype.toString;
function isArray$1(e) {
  return toString$1.call(e) === "[object Array]";
}
function isUndefined$1(e) {
  return typeof e > "u";
}
function isBuffer$1(e) {
  return e !== null && !isUndefined$1(e) && e.constructor !== null && !isUndefined$1(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function isArrayBuffer$1(e) {
  return toString$1.call(e) === "[object ArrayBuffer]";
}
function isFormData$1(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
function isArrayBufferView$1(e) {
  var n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && e.buffer instanceof ArrayBuffer, n;
}
function isString$1(e) {
  return typeof e == "string";
}
function isNumber$1(e) {
  return typeof e == "number";
}
function isObject$1(e) {
  return e !== null && typeof e == "object";
}
function isPlainObject$1(e) {
  if (toString$1.call(e) !== "[object Object]")
    return !1;
  var n = Object.getPrototypeOf(e);
  return n === null || n === Object.prototype;
}
function isDate$1(e) {
  return toString$1.call(e) === "[object Date]";
}
function isFile$1(e) {
  return toString$1.call(e) === "[object File]";
}
function isBlob$1(e) {
  return toString$1.call(e) === "[object Blob]";
}
function isFunction$1(e) {
  return toString$1.call(e) === "[object Function]";
}
function isStream$1(e) {
  return isObject$1(e) && isFunction$1(e.pipe);
}
function isURLSearchParams$1(e) {
  return typeof URLSearchParams < "u" && e instanceof URLSearchParams;
}
function trim$1(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$1() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach$1(e, n) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), isArray$1(e))
      for (var o = 0, u = e.length; o < u; o++)
        n.call(null, e[o], o, e);
    else
      for (var c in e)
        Object.prototype.hasOwnProperty.call(e, c) && n.call(null, e[c], c, e);
}
function merge$1() {
  var e = {};
  function n(c, d) {
    isPlainObject$1(e[d]) && isPlainObject$1(c) ? e[d] = merge$1(e[d], c) : isPlainObject$1(c) ? e[d] = merge$1({}, c) : isArray$1(c) ? e[d] = c.slice() : e[d] = c;
  }
  for (var o = 0, u = arguments.length; o < u; o++)
    forEach$1(arguments[o], n);
  return e;
}
function extend$1(e, n, o) {
  return forEach$1(n, function(c, d) {
    o && typeof c == "function" ? e[d] = bind$4(c, o) : e[d] = c;
  }), e;
}
function stripBOM$1(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var utils$l = {
  isArray: isArray$1,
  isArrayBuffer: isArrayBuffer$1,
  isBuffer: isBuffer$1,
  isFormData: isFormData$1,
  isArrayBufferView: isArrayBufferView$1,
  isString: isString$1,
  isNumber: isNumber$1,
  isObject: isObject$1,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined$1,
  isDate: isDate$1,
  isFile: isFile$1,
  isBlob: isBlob$1,
  isFunction: isFunction$1,
  isStream: isStream$1,
  isURLSearchParams: isURLSearchParams$1,
  isStandardBrowserEnv: isStandardBrowserEnv$1,
  forEach: forEach$1,
  merge: merge$1,
  extend: extend$1,
  trim: trim$1,
  stripBOM: stripBOM$1
}, utils$k = utils$l;
function encode$1(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$3 = function e(n, o, u) {
  if (!o)
    return n;
  var c;
  if (u)
    c = u(o);
  else if (utils$k.isURLSearchParams(o))
    c = o.toString();
  else {
    var d = [];
    utils$k.forEach(o, function(S, $) {
      S === null || typeof S > "u" || (utils$k.isArray(S) ? $ = $ + "[]" : S = [S], utils$k.forEach(S, function(O) {
        utils$k.isDate(O) ? O = O.toISOString() : utils$k.isObject(O) && (O = JSON.stringify(O)), d.push(encode$1($) + "=" + encode$1(O));
      }));
    }), c = d.join("&");
  }
  if (c) {
    var m = n.indexOf("#");
    m !== -1 && (n = n.slice(0, m)), n += (n.indexOf("?") === -1 ? "?" : "&") + c;
  }
  return n;
}, utils$j = utils$l;
function InterceptorManager$3() {
  this.handlers = [];
}
InterceptorManager$3.prototype.use = function e(n, o, u) {
  return this.handlers.push({
    fulfilled: n,
    rejected: o,
    synchronous: u ? u.synchronous : !1,
    runWhen: u ? u.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$3.prototype.eject = function e(n) {
  this.handlers[n] && (this.handlers[n] = null);
};
InterceptorManager$3.prototype.forEach = function e(n) {
  utils$j.forEach(this.handlers, function(u) {
    u !== null && n(u);
  });
};
var InterceptorManager_1$1 = InterceptorManager$3, utils$i = utils$l, normalizeHeaderName$3 = function e(n, o) {
  utils$i.forEach(n, function(c, d) {
    d !== o && d.toUpperCase() === o.toUpperCase() && (n[o] = c, delete n[d]);
  });
}, enhanceError$1 = function e(n, o, u, c, d) {
  return n.config = o, u && (n.code = u), n.request = c, n.response = d, n.isAxiosError = !0, n.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, n;
}, createError, hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError)
    return createError;
  hasRequiredCreateError = 1;
  var e = enhanceError$1;
  return createError = function(o, u, c, d, m) {
    var v = new Error(o);
    return e(v, u, c, d, m);
  }, createError;
}
var settle$1, hasRequiredSettle$1;
function requireSettle$1() {
  if (hasRequiredSettle$1)
    return settle$1;
  hasRequiredSettle$1 = 1;
  var e = requireCreateError();
  return settle$1 = function(o, u, c) {
    var d = c.config.validateStatus;
    !c.status || !d || d(c.status) ? o(c) : u(e(
      "Request failed with status code " + c.status,
      c.config,
      null,
      c.request,
      c
    ));
  }, settle$1;
}
var cookies$1, hasRequiredCookies$1;
function requireCookies$1() {
  if (hasRequiredCookies$1)
    return cookies$1;
  hasRequiredCookies$1 = 1;
  var e = utils$l;
  return cookies$1 = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(u, c, d, m, v, S) {
          var $ = [];
          $.push(u + "=" + encodeURIComponent(c)), e.isNumber(d) && $.push("expires=" + new Date(d).toGMTString()), e.isString(m) && $.push("path=" + m), e.isString(v) && $.push("domain=" + v), S === !0 && $.push("secure"), document.cookie = $.join("; ");
        },
        read: function(u) {
          var c = document.cookie.match(new RegExp("(^|;\\s*)(" + u + ")=([^;]*)"));
          return c ? decodeURIComponent(c[3]) : null;
        },
        remove: function(u) {
          this.write(u, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies$1;
}
var isAbsoluteURL$2, hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  return hasRequiredIsAbsoluteURL || (hasRequiredIsAbsoluteURL = 1, isAbsoluteURL$2 = function(n) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(n);
  }), isAbsoluteURL$2;
}
var combineURLs$2, hasRequiredCombineURLs;
function requireCombineURLs() {
  return hasRequiredCombineURLs || (hasRequiredCombineURLs = 1, combineURLs$2 = function(n, o) {
    return o ? n.replace(/\/+$/, "") + "/" + o.replace(/^\/+/, "") : n;
  }), combineURLs$2;
}
var buildFullPath$2, hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath)
    return buildFullPath$2;
  hasRequiredBuildFullPath = 1;
  var e = requireIsAbsoluteURL(), n = requireCombineURLs();
  return buildFullPath$2 = function(u, c) {
    return u && !e(c) ? n(u, c) : c;
  }, buildFullPath$2;
}
var parseHeaders$1, hasRequiredParseHeaders$1;
function requireParseHeaders$1() {
  if (hasRequiredParseHeaders$1)
    return parseHeaders$1;
  hasRequiredParseHeaders$1 = 1;
  var e = utils$l, n = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders$1 = function(u) {
    var c = {}, d, m, v;
    return u && e.forEach(u.split(`
`), function($) {
      if (v = $.indexOf(":"), d = e.trim($.substr(0, v)).toLowerCase(), m = e.trim($.substr(v + 1)), d) {
        if (c[d] && n.indexOf(d) >= 0)
          return;
        d === "set-cookie" ? c[d] = (c[d] ? c[d] : []).concat([m]) : c[d] = c[d] ? c[d] + ", " + m : m;
      }
    }), c;
  }, parseHeaders$1;
}
var isURLSameOrigin$1, hasRequiredIsURLSameOrigin$1;
function requireIsURLSameOrigin$1() {
  if (hasRequiredIsURLSameOrigin$1)
    return isURLSameOrigin$1;
  hasRequiredIsURLSameOrigin$1 = 1;
  var e = utils$l;
  return isURLSameOrigin$1 = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var o = /(msie|trident)/i.test(navigator.userAgent), u = document.createElement("a"), c;
      function d(m) {
        var v = m;
        return o && (u.setAttribute("href", v), v = u.href), u.setAttribute("href", v), {
          href: u.href,
          protocol: u.protocol ? u.protocol.replace(/:$/, "") : "",
          host: u.host,
          search: u.search ? u.search.replace(/^\?/, "") : "",
          hash: u.hash ? u.hash.replace(/^#/, "") : "",
          hostname: u.hostname,
          port: u.port,
          pathname: u.pathname.charAt(0) === "/" ? u.pathname : "/" + u.pathname
        };
      }
      return c = d(window.location.href), function(v) {
        var S = e.isString(v) ? d(v) : v;
        return S.protocol === c.protocol && S.host === c.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin$1;
}
var xhr$1, hasRequiredXhr$1;
function requireXhr$1() {
  if (hasRequiredXhr$1)
    return xhr$1;
  hasRequiredXhr$1 = 1;
  var e = utils$l, n = requireSettle$1(), o = requireCookies$1(), u = buildURL$3, c = requireBuildFullPath(), d = requireParseHeaders$1(), m = requireIsURLSameOrigin$1(), v = requireCreateError();
  return xhr$1 = function($) {
    return new Promise(function(O, T) {
      var y = $.data, V = $.headers, M = $.responseType;
      e.isFormData(y) && delete V["Content-Type"];
      var G = new XMLHttpRequest();
      if ($.auth) {
        var k = $.auth.username || "", F = $.auth.password ? unescape(encodeURIComponent($.auth.password)) : "";
        V.Authorization = "Basic " + btoa(k + ":" + F);
      }
      var X = c($.baseURL, $.url);
      G.open($.method.toUpperCase(), u(X, $.params, $.paramsSerializer), !0), G.timeout = $.timeout;
      function ee() {
        if (G) {
          var Q = "getAllResponseHeaders" in G ? d(G.getAllResponseHeaders()) : null, Y = !M || M === "text" || M === "json" ? G.responseText : G.response, pe = {
            data: Y,
            status: G.status,
            statusText: G.statusText,
            headers: Q,
            config: $,
            request: G
          };
          n(O, T, pe), G = null;
        }
      }
      if ("onloadend" in G ? G.onloadend = ee : G.onreadystatechange = function() {
        !G || G.readyState !== 4 || G.status === 0 && !(G.responseURL && G.responseURL.indexOf("file:") === 0) || setTimeout(ee);
      }, G.onabort = function() {
        G && (T(v("Request aborted", $, "ECONNABORTED", G)), G = null);
      }, G.onerror = function() {
        T(v("Network Error", $, null, G)), G = null;
      }, G.ontimeout = function() {
        var Y = "timeout of " + $.timeout + "ms exceeded";
        $.timeoutErrorMessage && (Y = $.timeoutErrorMessage), T(v(
          Y,
          $,
          $.transitional && $.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          G
        )), G = null;
      }, e.isStandardBrowserEnv()) {
        var ue = ($.withCredentials || m(X)) && $.xsrfCookieName ? o.read($.xsrfCookieName) : void 0;
        ue && (V[$.xsrfHeaderName] = ue);
      }
      "setRequestHeader" in G && e.forEach(V, function(Y, pe) {
        typeof y > "u" && pe.toLowerCase() === "content-type" ? delete V[pe] : G.setRequestHeader(pe, Y);
      }), e.isUndefined($.withCredentials) || (G.withCredentials = !!$.withCredentials), M && M !== "json" && (G.responseType = $.responseType), typeof $.onDownloadProgress == "function" && G.addEventListener("progress", $.onDownloadProgress), typeof $.onUploadProgress == "function" && G.upload && G.upload.addEventListener("progress", $.onUploadProgress), $.cancelToken && $.cancelToken.promise.then(function(Y) {
        G && (G.abort(), T(Y), G = null);
      }), y || (y = null), G.send(y);
    });
  }, xhr$1;
}
var utils$h = utils$l, normalizeHeaderName$2 = normalizeHeaderName$3, enhanceError = enhanceError$1, DEFAULT_CONTENT_TYPE$1 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset$1(e, n) {
  !utils$h.isUndefined(e) && utils$h.isUndefined(e["Content-Type"]) && (e["Content-Type"] = n);
}
function getDefaultAdapter$1() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof browser$1$1 < "u" && Object.prototype.toString.call(browser$1$1) === "[object process]") && (e = requireXhr$1()), e;
}
function stringifySafely$1(e, n, o) {
  if (utils$h.isString(e))
    try {
      return (n || JSON.parse)(e), utils$h.trim(e);
    } catch (u) {
      if (u.name !== "SyntaxError")
        throw u;
    }
  return (o || JSON.stringify)(e);
}
var defaults$7 = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: getDefaultAdapter$1(),
  transformRequest: [function e(n, o) {
    return normalizeHeaderName$2(o, "Accept"), normalizeHeaderName$2(o, "Content-Type"), utils$h.isFormData(n) || utils$h.isArrayBuffer(n) || utils$h.isBuffer(n) || utils$h.isStream(n) || utils$h.isFile(n) || utils$h.isBlob(n) ? n : utils$h.isArrayBufferView(n) ? n.buffer : utils$h.isURLSearchParams(n) ? (setContentTypeIfUnset$1(o, "application/x-www-form-urlencoded;charset=utf-8"), n.toString()) : utils$h.isObject(n) || o && o["Content-Type"] === "application/json" ? (setContentTypeIfUnset$1(o, "application/json"), stringifySafely$1(n)) : n;
  }],
  transformResponse: [function e(n) {
    var o = this.transitional, u = o && o.silentJSONParsing, c = o && o.forcedJSONParsing, d = !u && this.responseType === "json";
    if (d || c && utils$h.isString(n) && n.length)
      try {
        return JSON.parse(n);
      } catch (m) {
        if (d)
          throw m.name === "SyntaxError" ? enhanceError(m, this, "E_JSON_PARSE") : m;
      }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function e(n) {
    return n >= 200 && n < 300;
  }
};
defaults$7.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
utils$h.forEach(["delete", "get", "head"], function e(n) {
  defaults$7.headers[n] = {};
});
utils$h.forEach(["post", "put", "patch"], function e(n) {
  defaults$7.headers[n] = utils$h.merge(DEFAULT_CONTENT_TYPE$1);
});
var defaults_1$1 = defaults$7, utils$g = utils$l, defaults$6 = defaults_1$1, transformData$3 = function e(n, o, u) {
  var c = this || defaults$6;
  return utils$g.forEach(u, function(m) {
    n = m.call(c, n, o);
  }), n;
}, isCancel$3, hasRequiredIsCancel$1;
function requireIsCancel$1() {
  return hasRequiredIsCancel$1 || (hasRequiredIsCancel$1 = 1, isCancel$3 = function(n) {
    return !!(n && n.__CANCEL__);
  }), isCancel$3;
}
var utils$f = utils$l, transformData$2 = transformData$3, isCancel$2 = requireIsCancel$1(), defaults$5 = defaults_1$1;
function throwIfCancellationRequested$1(e) {
  e.cancelToken && e.cancelToken.throwIfRequested();
}
var dispatchRequest$3 = function e(n) {
  throwIfCancellationRequested$1(n), n.headers = n.headers || {}, n.data = transformData$2.call(
    n,
    n.data,
    n.headers,
    n.transformRequest
  ), n.headers = utils$f.merge(
    n.headers.common || {},
    n.headers[n.method] || {},
    n.headers
  ), utils$f.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(c) {
      delete n.headers[c];
    }
  );
  var o = n.adapter || defaults$5.adapter;
  return o(n).then(function(c) {
    return throwIfCancellationRequested$1(n), c.data = transformData$2.call(
      n,
      c.data,
      c.headers,
      n.transformResponse
    ), c;
  }, function(c) {
    return isCancel$2(c) || (throwIfCancellationRequested$1(n), c && c.response && (c.response.data = transformData$2.call(
      n,
      c.response.data,
      c.response.headers,
      n.transformResponse
    ))), Promise.reject(c);
  });
}, utils$e = utils$l, mergeConfig$5 = function e(n, o) {
  o = o || {};
  var u = {}, c = ["url", "method", "data"], d = ["headers", "auth", "proxy", "params"], m = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], v = ["validateStatus"];
  function S(T, y) {
    return utils$e.isPlainObject(T) && utils$e.isPlainObject(y) ? utils$e.merge(T, y) : utils$e.isPlainObject(y) ? utils$e.merge({}, y) : utils$e.isArray(y) ? y.slice() : y;
  }
  function $(T) {
    utils$e.isUndefined(o[T]) ? utils$e.isUndefined(n[T]) || (u[T] = S(void 0, n[T])) : u[T] = S(n[T], o[T]);
  }
  utils$e.forEach(c, function(y) {
    utils$e.isUndefined(o[y]) || (u[y] = S(void 0, o[y]));
  }), utils$e.forEach(d, $), utils$e.forEach(m, function(y) {
    utils$e.isUndefined(o[y]) ? utils$e.isUndefined(n[y]) || (u[y] = S(void 0, n[y])) : u[y] = S(void 0, o[y]);
  }), utils$e.forEach(v, function(y) {
    y in o ? u[y] = S(n[y], o[y]) : y in n && (u[y] = S(void 0, n[y]));
  });
  var E = c.concat(d).concat(m).concat(v), O = Object.keys(n).concat(Object.keys(o)).filter(function(y) {
    return E.indexOf(y) === -1;
  });
  return utils$e.forEach(O, $), u;
};
const name = "axios", version = "0.21.4", description = "Promise based HTTP client for the browser and node.js", main$2 = "index.js", scripts = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, repository = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, keywords = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], author = "Matt Zabriskie", license = "MIT", bugs = {
  url: "https://github.com/axios/axios/issues"
}, homepage = "https://axios-http.com", devDependencies = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, browser = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, jsdelivr = "dist/axios.min.js", unpkg = "dist/axios.min.js", typings = "./index.d.ts", dependencies = {
  "follow-redirects": "^1.14.0"
}, bundlesize = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], require$$0 = {
  name,
  version,
  description,
  main: main$2,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  browser,
  jsdelivr,
  unpkg,
  typings,
  dependencies,
  bundlesize
};
var pkg = require$$0, validators$3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, n) {
  validators$3[e] = function(u) {
    return typeof u === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
var deprecatedWarnings$1 = {}, currentVerArr = pkg.version.split(".");
function isOlderVersion(e, n) {
  for (var o = n ? n.split(".") : currentVerArr, u = e.split("."), c = 0; c < 3; c++) {
    if (o[c] > u[c])
      return !0;
    if (o[c] < u[c])
      return !1;
  }
  return !1;
}
validators$3.transitional = function e(n, o, u) {
  var c = o && isOlderVersion(o);
  function d(m, v) {
    return "[Axios v" + pkg.version + "] Transitional option '" + m + "'" + v + (u ? ". " + u : "");
  }
  return function(m, v, S) {
    if (n === !1)
      throw new Error(d(v, " has been removed in " + o));
    return c && !deprecatedWarnings$1[v] && (deprecatedWarnings$1[v] = !0, console.warn(
      d(
        v,
        " has been deprecated since v" + o + " and will be removed in the near future"
      )
    )), n ? n(m, v, S) : !0;
  };
};
function assertOptions$1(e, n, o) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var u = Object.keys(e), c = u.length; c-- > 0; ) {
    var d = u[c], m = n[d];
    if (m) {
      var v = e[d], S = v === void 0 || m(v, d, e);
      if (S !== !0)
        throw new TypeError("option " + d + " must be " + S);
      continue;
    }
    if (o !== !0)
      throw Error("Unknown option " + d);
  }
}
var validator$3 = {
  isOlderVersion,
  assertOptions: assertOptions$1,
  validators: validators$3
}, utils$d = utils$l, buildURL$2 = buildURL$3, InterceptorManager$2 = InterceptorManager_1$1, dispatchRequest$2 = dispatchRequest$3, mergeConfig$4 = mergeConfig$5, validator$2 = validator$3, validators$2 = validator$2.validators;
function Axios$3(e) {
  this.defaults = e, this.interceptors = {
    request: new InterceptorManager$2(),
    response: new InterceptorManager$2()
  };
}
Axios$3.prototype.request = function e(n) {
  typeof n == "string" ? (n = arguments[1] || {}, n.url = arguments[0]) : n = n || {}, n = mergeConfig$4(this.defaults, n), n.method ? n.method = n.method.toLowerCase() : this.defaults.method ? n.method = this.defaults.method.toLowerCase() : n.method = "get";
  var o = n.transitional;
  o !== void 0 && validator$2.assertOptions(o, {
    silentJSONParsing: validators$2.transitional(validators$2.boolean, "1.0.0"),
    forcedJSONParsing: validators$2.transitional(validators$2.boolean, "1.0.0"),
    clarifyTimeoutError: validators$2.transitional(validators$2.boolean, "1.0.0")
  }, !1);
  var u = [], c = !0;
  this.interceptors.request.forEach(function(T) {
    typeof T.runWhen == "function" && T.runWhen(n) === !1 || (c = c && T.synchronous, u.unshift(T.fulfilled, T.rejected));
  });
  var d = [];
  this.interceptors.response.forEach(function(T) {
    d.push(T.fulfilled, T.rejected);
  });
  var m;
  if (!c) {
    var v = [dispatchRequest$2, void 0];
    for (Array.prototype.unshift.apply(v, u), v = v.concat(d), m = Promise.resolve(n); v.length; )
      m = m.then(v.shift(), v.shift());
    return m;
  }
  for (var S = n; u.length; ) {
    var $ = u.shift(), E = u.shift();
    try {
      S = $(S);
    } catch (O) {
      E(O);
      break;
    }
  }
  try {
    m = dispatchRequest$2(S);
  } catch (O) {
    return Promise.reject(O);
  }
  for (; d.length; )
    m = m.then(d.shift(), d.shift());
  return m;
};
Axios$3.prototype.getUri = function e(n) {
  return n = mergeConfig$4(this.defaults, n), buildURL$2(n.url, n.params, n.paramsSerializer).replace(/^\?/, "");
};
utils$d.forEach(["delete", "get", "head", "options"], function e(n) {
  Axios$3.prototype[n] = function(o, u) {
    return this.request(mergeConfig$4(u || {}, {
      method: n,
      url: o,
      data: (u || {}).data
    }));
  };
});
utils$d.forEach(["post", "put", "patch"], function e(n) {
  Axios$3.prototype[n] = function(o, u, c) {
    return this.request(mergeConfig$4(c || {}, {
      method: n,
      url: o,
      data: u
    }));
  };
});
var Axios_1$1 = Axios$3, Cancel_1, hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel)
    return Cancel_1;
  hasRequiredCancel = 1;
  function e(n) {
    this.message = n;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, Cancel_1 = e, Cancel_1;
}
var CancelToken_1$1, hasRequiredCancelToken$1;
function requireCancelToken$1() {
  if (hasRequiredCancelToken$1)
    return CancelToken_1$1;
  hasRequiredCancelToken$1 = 1;
  var e = requireCancel();
  function n(o) {
    if (typeof o != "function")
      throw new TypeError("executor must be a function.");
    var u;
    this.promise = new Promise(function(m) {
      u = m;
    });
    var c = this;
    o(function(m) {
      c.reason || (c.reason = new e(m), u(c.reason));
    });
  }
  return n.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, n.source = function() {
    var u, c = new n(function(m) {
      u = m;
    });
    return {
      token: c,
      cancel: u
    };
  }, CancelToken_1$1 = n, CancelToken_1$1;
}
var spread$1, hasRequiredSpread$1;
function requireSpread$1() {
  return hasRequiredSpread$1 || (hasRequiredSpread$1 = 1, spread$1 = function(n) {
    return function(u) {
      return n.apply(null, u);
    };
  }), spread$1;
}
var isAxiosError$1, hasRequiredIsAxiosError$1;
function requireIsAxiosError$1() {
  return hasRequiredIsAxiosError$1 || (hasRequiredIsAxiosError$1 = 1, isAxiosError$1 = function(n) {
    return typeof n == "object" && n.isAxiosError === !0;
  }), isAxiosError$1;
}
var utils$c = utils$l, bind$3 = bind$5, Axios$2 = Axios_1$1, mergeConfig$3 = mergeConfig$5, defaults$4 = defaults_1$1;
function createInstance$1(e) {
  var n = new Axios$2(e), o = bind$3(Axios$2.prototype.request, n);
  return utils$c.extend(o, Axios$2.prototype, n), utils$c.extend(o, n), o;
}
var axios$5 = createInstance$1(defaults$4);
axios$5.Axios = Axios$2;
axios$5.create = function e(n) {
  return createInstance$1(mergeConfig$3(axios$5.defaults, n));
};
axios$5.Cancel = requireCancel();
axios$5.CancelToken = requireCancelToken$1();
axios$5.isCancel = requireIsCancel$1();
axios$5.all = function e(n) {
  return Promise.all(n);
};
axios$5.spread = requireSpread$1();
axios$5.isAxiosError = requireIsAxiosError$1();
axios$6.exports = axios$5;
axios$6.exports.default = axios$5;
var axiosExports$1 = axios$6.exports, axios$4 = axiosExports$1, __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(http$1, "__esModule", { value: !0 });
http$1.http = void 0;
const axios_1 = __importDefault$1(axios$4);
function filterBadStatus(e) {
  if (e.status >= 400)
    throw new Error(`Bad status on response: ${e.status}`);
  return e;
}
async function http(e, n, o, u) {
  if (typeof fetch < "u") {
    const c = {
      method: e,
      body: u ? JSON.stringify(u) : void 0,
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json",
        ...o
      }
    };
    return fetch(n, c).then(filterBadStatus).then((d) => d.json());
  } else
    return axios_1.default.request({ url: n, method: e, data: u, headers: o }).then((c) => c.data);
}
http$1.http = http;
var rpcclient = {};
Object.defineProperty(rpcclient, "__esModule", { value: !0 });
rpcclient.hasProtocol = rpcclient.instanceOfRpcStreamingClient = void 0;
function instanceOfRpcStreamingClient(e) {
  return typeof e.listen == "function";
}
rpcclient.instanceOfRpcStreamingClient = instanceOfRpcStreamingClient;
function hasProtocol(e) {
  return e.search("://") !== -1;
}
rpcclient.hasProtocol = hasProtocol;
Object.defineProperty(httpbatchclient, "__esModule", { value: !0 });
httpbatchclient.HttpBatchClient = void 0;
const json_rpc_1$2 = build$1, http_1$1 = http$1, rpcclient_1$2 = rpcclient, defaultHttpBatchClientOptions = {
  dispatchInterval: 20,
  batchSizeLimit: 20
};
class HttpBatchClient {
  constructor(n, o = {}) {
    var u, c;
    this.queue = [], this.options = {
      batchSizeLimit: (u = o.batchSizeLimit) !== null && u !== void 0 ? u : defaultHttpBatchClientOptions.batchSizeLimit,
      dispatchInterval: (c = o.dispatchInterval) !== null && c !== void 0 ? c : defaultHttpBatchClientOptions.dispatchInterval
    }, typeof n == "string" ? this.url = (0, rpcclient_1$2.hasProtocol)(n) ? n : "http://" + n : (this.url = n.url, this.headers = n.headers), this.timer = setInterval(() => this.tick(), o.dispatchInterval), this.validate();
  }
  disconnect() {
    this.timer && clearInterval(this.timer), this.timer = void 0;
  }
  async execute(n) {
    return new Promise((o, u) => {
      this.queue.push({ request: n, resolve: o, reject: u }), this.queue.length >= this.options.batchSizeLimit && this.tick();
    });
  }
  validate() {
    if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1)
      throw new Error("batchSizeLimit must be a safe integer >= 1");
  }
  /**
   * This is called in an interval where promise rejections cannot be handled.
   * So this is not async and HTTP errors need to be handled by the queued promises.
   */
  tick() {
    const n = this.queue.splice(0, this.options.batchSizeLimit);
    if (!n.length)
      return;
    const o = n.map((c) => c.request), u = o.map((c) => c.id);
    (0, http_1$1.http)("POST", this.url, this.headers, o).then((c) => {
      (Array.isArray(c) ? c : [c]).forEach((m) => {
        const v = n.find((O) => O.request.id === m.id);
        if (!v)
          return;
        const { reject: S, resolve: $ } = v, E = (0, json_rpc_1$2.parseJsonRpcResponse)(m);
        (0, json_rpc_1$2.isJsonRpcErrorResponse)(E) ? S(new Error(JSON.stringify(E.error))) : $(E);
      });
    }, (c) => {
      for (const d of u) {
        const m = n.find((v) => v.request.id === d);
        if (!m)
          return;
        m.reject(c);
      }
    });
  }
}
httpbatchclient.HttpBatchClient = HttpBatchClient;
var httpclient = {};
Object.defineProperty(httpclient, "__esModule", { value: !0 });
httpclient.HttpClient = void 0;
const json_rpc_1$1 = build$1, http_1 = http$1, rpcclient_1$1 = rpcclient;
class HttpClient {
  constructor(n) {
    typeof n == "string" ? this.url = (0, rpcclient_1$1.hasProtocol)(n) ? n : "http://" + n : (this.url = n.url, this.headers = n.headers);
  }
  disconnect() {
  }
  async execute(n) {
    const o = (0, json_rpc_1$1.parseJsonRpcResponse)(await (0, http_1.http)("POST", this.url, this.headers, n));
    if ((0, json_rpc_1$1.isJsonRpcErrorResponse)(o))
      throw new Error(JSON.stringify(o.error));
    return o;
  }
}
httpclient.HttpClient = HttpClient;
var websocketclient = {}, build = {}, queueingstreamingsocket = {}, streamingsocket = {}, socketwrapper = {}, __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(socketwrapper, "__esModule", { value: !0 });
socketwrapper.SocketWrapper = void 0;
const isomorphic_ws_1 = __importDefault(browser$1);
function environmentIsNodeJs() {
  return typeof browser$1$1 < "u" && typeof browser$1$1.versions < "u" && typeof browser$1$1.versions.node < "u";
}
class SocketWrapper {
  constructor(n, o, u, c, d, m = 1e4) {
    this.closed = !1, this.connected = new Promise((v, S) => {
      this.connectedResolver = v, this.connectedRejecter = S;
    }), this.url = n, this.messageHandler = o, this.errorHandler = u, this.openHandler = c, this.closeHandler = d, this.timeout = m;
  }
  /**
   * returns a promise that resolves when connection is open
   */
  connect() {
    const n = new isomorphic_ws_1.default(this.url);
    n.onerror = (u) => {
      this.clearTimeout(), this.errorHandler && this.errorHandler(u);
    }, n.onmessage = (u) => {
      this.messageHandler({
        type: u.type,
        data: u.data
      });
    }, n.onopen = (u) => {
      this.clearTimeout(), this.connectedResolver(), this.openHandler && this.openHandler();
    }, n.onclose = (u) => {
      this.closed = !0, this.closeHandler && this.closeHandler(u);
    };
    const o = Date.now();
    this.timeoutId = setTimeout(() => {
      n.onmessage = () => 0, n.onerror = () => 0, n.onopen = () => 0, n.onclose = () => 0, n.close(), this.socket = void 0;
      const u = Math.floor(Date.now() - o);
      this.connectedRejecter(`Connection attempt timed out after ${u} ms`);
    }, this.timeout), this.socket = n;
  }
  /**
   * Closes an established connection and aborts other connection states
   */
  disconnect() {
    if (!this.socket)
      throw new Error("Socket undefined. This must be called after connecting.");
    switch (this.clearTimeout(), this.socket.readyState) {
      case isomorphic_ws_1.default.OPEN:
        this.socket.close(
          1e3
          /* Normal Closure */
        );
        break;
      case isomorphic_ws_1.default.CLOSED:
        break;
      case isomorphic_ws_1.default.CONNECTING:
        this.socket.onopen = () => 0, this.socket.onclose = () => 0, this.socket.onerror = () => 0, this.socket.onmessage = () => 0, this.socket = void 0, this.closeHandler && this.closeHandler({ wasClean: !1, code: 4001 });
        break;
      case isomorphic_ws_1.default.CLOSING:
        break;
      default:
        throw new Error(`Unknown readyState: ${this.socket.readyState}`);
    }
  }
  async send(n) {
    return new Promise((o, u) => {
      if (!this.socket)
        throw new Error("Socket undefined. This must be called after connecting.");
      if (this.closed)
        throw new Error("Socket was closed, so no data can be sent anymore.");
      if (this.socket.readyState !== isomorphic_ws_1.default.OPEN)
        throw new Error("Websocket is not open");
      environmentIsNodeJs() ? this.socket.send(n, (c) => c ? u(c) : o()) : (this.socket.send(n), o());
    });
  }
  /**
   * Clears the timeout function, such that no timeout error will be raised anymore. This should be
   * called when the connection is established, a connection error occurred or the socket is disconnected.
   *
   * This method must not be called before `connect()`.
   * This method is idempotent.
   */
  clearTimeout() {
    if (!this.timeoutId)
      throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
    clearTimeout(this.timeoutId);
  }
}
socketwrapper.SocketWrapper = SocketWrapper;
Object.defineProperty(streamingsocket, "__esModule", { value: !0 });
streamingsocket.StreamingSocket = void 0;
const xstream_1$2 = xstream, socketwrapper_1 = socketwrapper;
class StreamingSocket {
  constructor(n, o = 1e4) {
    this.socket = new socketwrapper_1.SocketWrapper(n, (c) => {
      this.eventProducerListener && this.eventProducerListener.next(c);
    }, (c) => {
      this.eventProducerListener && this.eventProducerListener.error(c);
    }, () => {
    }, (c) => {
      this.eventProducerListener && (c.wasClean ? this.eventProducerListener.complete() : this.eventProducerListener.error("Socket was closed unclean"));
    }, o), this.connected = this.socket.connected;
    const u = {
      start: (c) => this.eventProducerListener = c,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$2.Stream.create(u);
  }
  connect() {
    this.socket.connect();
  }
  disconnect() {
    this.socket.disconnect();
  }
  async send(n) {
    return this.socket.send(n);
  }
}
streamingsocket.StreamingSocket = StreamingSocket;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  const n = build$3, o = xstream, u = streamingsocket;
  var c;
  (function(m) {
    m[m.Unconnected = 0] = "Unconnected", m[m.Connecting = 1] = "Connecting", m[m.Connected = 2] = "Connected", m[m.Disconnected = 3] = "Disconnected";
  })(c = e.ConnectionStatus || (e.ConnectionStatus = {}));
  class d {
    constructor(v, S = 1e4, $) {
      this.queue = [], this.isProcessingQueue = !1, this.url = v, this.timeout = S, this.reconnectedHandler = $;
      const E = {
        start: (O) => this.eventProducerListener = O,
        stop: () => this.eventProducerListener = void 0
      };
      this.events = o.Stream.create(E), this.connectionStatusProducer = new n.DefaultValueProducer(c.Unconnected), this.connectionStatus = new n.ValueAndUpdates(this.connectionStatusProducer), this.socket = new u.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (O) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(O);
        },
        error: () => this.connectionStatusProducer.update(c.Disconnected)
      });
    }
    connect() {
      this.connectionStatusProducer.update(c.Connecting), this.socket.connected.then(async () => (this.connectionStatusProducer.update(c.Connected), this.processQueue()), () => this.connectionStatusProducer.update(c.Disconnected)), this.socket.connect();
    }
    disconnect() {
      this.connectionStatusProducer.update(c.Disconnected), this.socket.disconnect();
    }
    reconnect() {
      this.socket = new u.StreamingSocket(this.url, this.timeout), this.socket.events.subscribe({
        next: (v) => {
          if (!this.eventProducerListener)
            throw new Error("No event producer listener set");
          this.eventProducerListener.next(v);
        },
        error: () => this.connectionStatusProducer.update(c.Disconnected)
      }), this.socket.connected.then(() => {
        this.reconnectedHandler && this.reconnectedHandler();
      }), this.connect();
    }
    getQueueLength() {
      return this.queue.length;
    }
    queueRequest(v) {
      this.queue.push(v), this.processQueue();
    }
    async processQueue() {
      if (this.isProcessingQueue || this.connectionStatus.value !== c.Connected)
        return;
      this.isProcessingQueue = !0;
      let v;
      for (; v = this.queue.shift(); )
        try {
          await this.socket.send(v), this.isProcessingQueue = !1;
        } catch {
          this.queue.unshift(v), this.isProcessingQueue = !1;
          return;
        }
    }
  }
  e.QueueingStreamingSocket = d;
})(queueingstreamingsocket);
var reconnectingsocket = {};
Object.defineProperty(reconnectingsocket, "__esModule", { value: !0 });
reconnectingsocket.ReconnectingSocket = void 0;
const xstream_1$1 = xstream, queueingstreamingsocket_1 = queueingstreamingsocket;
class ReconnectingSocket {
  constructor(n, o = 1e4, u) {
    this.unconnected = !0, this.disconnected = !1, this.timeoutIndex = 0, this.reconnectTimeout = null;
    const c = {
      start: (d) => this.eventProducerListener = d,
      stop: () => this.eventProducerListener = void 0
    };
    this.events = xstream_1$1.Stream.create(c), this.socket = new queueingstreamingsocket_1.QueueingStreamingSocket(n, o, u), this.socket.events.subscribe({
      next: (d) => {
        this.eventProducerListener && this.eventProducerListener.next(d);
      },
      error: (d) => {
        this.eventProducerListener && this.eventProducerListener.error(d);
      }
    }), this.connectionStatus = this.socket.connectionStatus, this.connectionStatus.updates.subscribe({
      next: (d) => {
        d === queueingstreamingsocket_1.ConnectionStatus.Connected && (this.timeoutIndex = 0), d === queueingstreamingsocket_1.ConnectionStatus.Disconnected && (this.reconnectTimeout && (clearTimeout(this.reconnectTimeout), this.reconnectTimeout = null), this.reconnectTimeout = setTimeout(() => this.socket.reconnect(), ReconnectingSocket.calculateTimeout(this.timeoutIndex++)));
      }
    });
  }
  /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */
  static calculateTimeout(n) {
    return Math.min(2 ** n * 100, 5e3);
  }
  connect() {
    if (!this.unconnected)
      throw new Error("Cannot connect: socket has already connected");
    this.socket.connect(), this.unconnected = !1;
  }
  disconnect() {
    if (this.unconnected)
      throw new Error("Cannot disconnect: socket has not yet connected");
    this.socket.disconnect(), this.eventProducerListener && this.eventProducerListener.complete(), this.disconnected = !0;
  }
  queueRequest(n) {
    if (this.disconnected)
      throw new Error("Cannot queue request: socket has disconnected");
    this.socket.queueRequest(n);
  }
}
reconnectingsocket.ReconnectingSocket = ReconnectingSocket;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.StreamingSocket = e.SocketWrapper = e.ReconnectingSocket = e.QueueingStreamingSocket = e.ConnectionStatus = void 0;
  var n = queueingstreamingsocket;
  Object.defineProperty(e, "ConnectionStatus", { enumerable: !0, get: function() {
    return n.ConnectionStatus;
  } }), Object.defineProperty(e, "QueueingStreamingSocket", { enumerable: !0, get: function() {
    return n.QueueingStreamingSocket;
  } });
  var o = reconnectingsocket;
  Object.defineProperty(e, "ReconnectingSocket", { enumerable: !0, get: function() {
    return o.ReconnectingSocket;
  } });
  var u = socketwrapper;
  Object.defineProperty(e, "SocketWrapper", { enumerable: !0, get: function() {
    return u.SocketWrapper;
  } });
  var c = streamingsocket;
  Object.defineProperty(e, "StreamingSocket", { enumerable: !0, get: function() {
    return c.StreamingSocket;
  } });
})(build);
Object.defineProperty(websocketclient, "__esModule", { value: !0 });
websocketclient.WebsocketClient = void 0;
const json_rpc_1 = build$1, socket_1 = build, stream_1 = build$3, xstream_1 = xstream, rpcclient_1 = rpcclient;
function defaultErrorHandler(e) {
  throw e;
}
function toJsonRpcResponse(e) {
  if (e.type !== "message")
    throw new Error(`Unexcepted message type on websocket: ${e.type}`);
  return (0, json_rpc_1.parseJsonRpcResponse)(JSON.parse(e.data));
}
class RpcEventProducer {
  constructor(n, o) {
    this.running = !1, this.subscriptions = [], this.request = n, this.socket = o;
  }
  /**
   * Implementation of Producer.start
   */
  start(n) {
    if (this.running)
      throw Error("Already started. Please stop first before restarting.");
    this.running = !0, this.connectToClient(n), this.socket.queueRequest(JSON.stringify(this.request));
  }
  /**
   * Implementation of Producer.stop
   *
   * Called by the stream when the stream's last listener stopped listening
   * or when the producer completed.
   */
  stop() {
    this.running = !1;
    const n = { ...this.request, method: "unsubscribe" };
    try {
      this.socket.queueRequest(JSON.stringify(n));
    } catch (o) {
      if (!(o instanceof Error && o.message.match(/socket has disconnected/i)))
        throw o;
    }
  }
  connectToClient(n) {
    const o = this.socket.events.map(toJsonRpcResponse), u = o.filter((m) => m.id === this.request.id).subscribe({
      next: (m) => {
        (0, json_rpc_1.isJsonRpcErrorResponse)(m) && (this.closeSubscriptions(), n.error(JSON.stringify(m.error))), u.unsubscribe();
      }
    }), c = o.filter((m) => m.id === this.request.id).subscribe({
      next: (m) => {
        (0, json_rpc_1.isJsonRpcErrorResponse)(m) ? (this.closeSubscriptions(), n.error(JSON.stringify(m.error))) : n.next(m.result);
      }
    }), d = o.subscribe({
      error: (m) => {
        this.closeSubscriptions(), n.error(m);
      },
      complete: () => {
        this.closeSubscriptions(), n.complete();
      }
    });
    this.subscriptions.push(u, c, d);
  }
  closeSubscriptions() {
    for (const n of this.subscriptions)
      n.unsubscribe();
    this.subscriptions = [];
  }
}
class WebsocketClient {
  constructor(n, o = defaultErrorHandler) {
    this.subscriptionStreams = /* @__PURE__ */ new Map();
    const u = n.endsWith("/") ? "websocket" : "/websocket", c = (0, rpcclient_1.hasProtocol)(n) ? n : "ws://" + n;
    this.url = c + u, this.socket = new socket_1.ReconnectingSocket(this.url);
    const d = this.socket.events.subscribe({
      error: (m) => {
        o(m), d.unsubscribe();
      }
    });
    this.jsonRpcResponseStream = this.socket.events.map(toJsonRpcResponse), this.socket.connect();
  }
  async execute(n) {
    const o = this.responseForRequestId(n.id);
    this.socket.queueRequest(JSON.stringify(n));
    const u = await o;
    if ((0, json_rpc_1.isJsonRpcErrorResponse)(u))
      throw new Error(JSON.stringify(u.error));
    return u;
  }
  listen(n) {
    if (n.method !== "subscribe")
      throw new Error('Request method must be "subscribe" to start event listening');
    const o = n.params.query;
    if (typeof o != "string")
      throw new Error("request.params.query must be a string");
    if (!this.subscriptionStreams.has(o)) {
      const u = new RpcEventProducer(n, this.socket), c = xstream_1.Stream.create(u);
      this.subscriptionStreams.set(o, c);
    }
    return this.subscriptionStreams.get(o).filter((u) => u.query !== void 0);
  }
  /**
   * Resolves as soon as websocket is connected. execute() queues requests automatically,
   * so this should be required for testing purposes only.
   */
  async connected() {
    await this.socket.connectionStatus.waitFor(socket_1.ConnectionStatus.Connected);
  }
  disconnect() {
    this.socket.disconnect();
  }
  async responseForRequestId(n) {
    return (0, stream_1.firstEvent)(this.jsonRpcResponseStream.filter((o) => o.id === n));
  }
}
websocketclient.WebsocketClient = WebsocketClient;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.WebsocketClient = e.instanceOfRpcStreamingClient = e.HttpClient = e.HttpBatchClient = void 0;
  var n = httpbatchclient;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return n.HttpBatchClient;
  } });
  var o = httpclient;
  Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return o.HttpClient;
  } });
  var u = rpcclient;
  Object.defineProperty(e, "instanceOfRpcStreamingClient", { enumerable: !0, get: function() {
    return u.instanceOfRpcStreamingClient;
  } });
  var c = websocketclient;
  Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return c.WebsocketClient;
  } });
})(rpcclients);
var tendermint34 = {}, requests$3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.buildQuery = e.SubscriptionEventType = e.Method = void 0, function(o) {
    o.AbciInfo = "abci_info", o.AbciQuery = "abci_query", o.Block = "block", o.Blockchain = "blockchain", o.BlockResults = "block_results", o.BlockSearch = "block_search", o.BroadcastTxAsync = "broadcast_tx_async", o.BroadcastTxSync = "broadcast_tx_sync", o.BroadcastTxCommit = "broadcast_tx_commit", o.Commit = "commit", o.Genesis = "genesis", o.Health = "health", o.NumUnconfirmedTxs = "num_unconfirmed_txs", o.Status = "status", o.Subscribe = "subscribe", o.Tx = "tx", o.TxSearch = "tx_search", o.Validators = "validators", o.Unsubscribe = "unsubscribe";
  }(e.Method || (e.Method = {})), function(o) {
    o.NewBlock = "NewBlock", o.NewBlockHeader = "NewBlockHeader", o.Tx = "Tx";
  }(e.SubscriptionEventType || (e.SubscriptionEventType = {}));
  function n(o) {
    const c = (o.tags ? o.tags : []).map((m) => `${m.key}='${m.value}'`), d = o.raw ? [o.raw] : [];
    return [...c, ...d].join(" AND ");
  }
  e.buildQuery = n;
})(requests$3);
var responses$1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VoteType = e.broadcastTxCommitSuccess = e.broadcastTxSyncSuccess = void 0;
  function n(u) {
    return u.code === 0;
  }
  e.broadcastTxSyncSuccess = n;
  function o(u) {
    return u.checkTx.code === 0 && !!u.deliverTx && u.deliverTx.code === 0;
  }
  e.broadcastTxCommitSuccess = o, function(u) {
    u[u.PreVote = 1] = "PreVote", u[u.PreCommit = 2] = "PreCommit";
  }(e.VoteType || (e.VoteType = {}));
})(responses$1);
var tendermint34client = {}, jsonrpc = {};
Object.defineProperty(jsonrpc, "__esModule", { value: !0 });
jsonrpc.createJsonRpcRequest = void 0;
const numbersWithoutZero = "123456789";
function randomNumericChar() {
  return numbersWithoutZero[Math.floor(Math.random() * numbersWithoutZero.length)];
}
function randomId() {
  return parseInt(Array.from({ length: 12 }).map(() => randomNumericChar()).join(""), 10);
}
function createJsonRpcRequest(e, n) {
  const o = n ? { ...n } : {};
  return {
    jsonrpc: "2.0",
    id: randomId(),
    method: e,
    params: o
  };
}
jsonrpc.createJsonRpcRequest = createJsonRpcRequest;
var adaptor = {}, hasher = {}, encodings = {};
Object.defineProperty(encodings, "__esModule", { value: !0 });
encodings.encodeBlockId = encodings.encodeVersion = encodings.encodeBytes = encodings.encodeTime = encodings.encodeUvarint = encodings.encodeString = encodings.dictionaryToStringMap = encodings.may = encodings.assertNotEmpty = encodings.assertObject = encodings.assertArray = encodings.assertNumber = encodings.assertString = encodings.assertBoolean = encodings.assertSet = void 0;
const encoding_1$3 = build$a;
function assertSet(e) {
  if (e === void 0)
    throw new Error("Value must not be undefined");
  if (e === null)
    throw new Error("Value must not be null");
  return e;
}
encodings.assertSet = assertSet;
function assertBoolean(e) {
  if (assertSet(e), typeof e != "boolean")
    throw new Error("Value must be a boolean");
  return e;
}
encodings.assertBoolean = assertBoolean;
function assertString(e) {
  if (assertSet(e), typeof e != "string")
    throw new Error("Value must be a string");
  return e;
}
encodings.assertString = assertString;
function assertNumber(e) {
  if (assertSet(e), typeof e != "number")
    throw new Error("Value must be a number");
  return e;
}
encodings.assertNumber = assertNumber;
function assertArray(e) {
  if (assertSet(e), !Array.isArray(e))
    throw new Error("Value must be a an array");
  return e;
}
encodings.assertArray = assertArray;
function assertObject(e) {
  if (assertSet(e), typeof e != "object")
    throw new Error("Value must be an object");
  if (Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error("Value must be a simple object");
  return e;
}
encodings.assertObject = assertObject;
function assertNotEmpty(e) {
  if (assertSet(e), typeof e == "number" && e === 0)
    throw new Error("must provide a non-zero value");
  if (e.length === 0)
    throw new Error("must provide a non-empty value");
  return e;
}
encodings.assertNotEmpty = assertNotEmpty;
function may(e, n) {
  return n == null ? void 0 : e(n);
}
encodings.may = may;
function dictionaryToStringMap(e) {
  const n = /* @__PURE__ */ new Map();
  for (const o of Object.keys(e)) {
    const u = e[o];
    if (typeof u != "string")
      throw new Error("Found dictionary value of type other than string");
    n.set(o, u);
  }
  return n;
}
encodings.dictionaryToStringMap = dictionaryToStringMap;
function encodeString(e) {
  const n = (0, encoding_1$3.toUtf8)(e);
  return Uint8Array.from([n.length, ...n]);
}
encodings.encodeString = encodeString;
function encodeUvarint(e) {
  return e >= 128 ? (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255 | 128, ...encodeUvarint(e >> 7)])
  ) : (
    // eslint-disable-next-line no-bitwise
    Uint8Array.from([e & 255])
  );
}
encodings.encodeUvarint = encodeUvarint;
function encodeTime(e) {
  const n = e.getTime(), o = Math.floor(n / 1e3), u = o ? [8, ...encodeUvarint(o)] : new Uint8Array(), c = (e.nanoseconds || 0) + n % 1e3 * 1e6, d = c ? [16, ...encodeUvarint(c)] : new Uint8Array();
  return Uint8Array.from([...u, ...d]);
}
encodings.encodeTime = encodeTime;
function encodeBytes(e) {
  if (e.length >= 128)
    throw new Error("Not implemented for byte arrays of length 128 or more");
  return e.length ? Uint8Array.from([e.length, ...e]) : new Uint8Array();
}
encodings.encodeBytes = encodeBytes;
function encodeVersion(e) {
  const n = e.block ? Uint8Array.from([8, ...encodeUvarint(e.block)]) : new Uint8Array(), o = e.app ? Uint8Array.from([16, ...encodeUvarint(e.app)]) : new Uint8Array();
  return Uint8Array.from([...n, ...o]);
}
encodings.encodeVersion = encodeVersion;
function encodeBlockId(e) {
  return Uint8Array.from([
    10,
    e.hash.length,
    ...e.hash,
    18,
    e.parts.hash.length + 4,
    8,
    e.parts.total,
    18,
    e.parts.hash.length,
    ...e.parts.hash
  ]);
}
encodings.encodeBlockId = encodeBlockId;
Object.defineProperty(hasher, "__esModule", { value: !0 });
hasher.hashBlock = hasher.hashTx = void 0;
const crypto_1 = build$8, encodings_1$3 = encodings;
function hashTx(e) {
  return (0, crypto_1.sha256)(e);
}
hasher.hashTx = hashTx;
function getSplitPoint(e) {
  if (e < 1)
    throw new Error("Cannot split an empty tree");
  const n = 2 ** Math.floor(Math.log2(e));
  return n < e ? n : n / 2;
}
function hashLeaf(e) {
  const n = new crypto_1.Sha256(Uint8Array.from([0]));
  return n.update(e), n.digest();
}
function hashInner(e, n) {
  const o = new crypto_1.Sha256(Uint8Array.from([1]));
  return o.update(e), o.update(n), o.digest();
}
function hashTree(e) {
  switch (e.length) {
    case 0:
      throw new Error("Cannot hash empty tree");
    case 1:
      return hashLeaf(e[0]);
    default: {
      const n = getSplitPoint(e.length), o = hashTree(e.slice(0, n)), u = hashTree(e.slice(n));
      return hashInner(o, u);
    }
  }
}
function hashBlock(e) {
  if (!e.lastBlockId)
    throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
  const n = [
    (0, encodings_1$3.encodeVersion)(e.version),
    (0, encodings_1$3.encodeString)(e.chainId),
    (0, encodings_1$3.encodeUvarint)(e.height),
    (0, encodings_1$3.encodeTime)(e.time),
    (0, encodings_1$3.encodeBlockId)(e.lastBlockId),
    (0, encodings_1$3.encodeBytes)(e.lastCommitHash),
    (0, encodings_1$3.encodeBytes)(e.dataHash),
    (0, encodings_1$3.encodeBytes)(e.validatorsHash),
    (0, encodings_1$3.encodeBytes)(e.nextValidatorsHash),
    (0, encodings_1$3.encodeBytes)(e.consensusHash),
    (0, encodings_1$3.encodeBytes)(e.appHash),
    (0, encodings_1$3.encodeBytes)(e.lastResultsHash),
    (0, encodings_1$3.encodeBytes)(e.evidenceHash),
    (0, encodings_1$3.encodeBytes)(e.proposerAddress)
  ];
  return hashTree(n);
}
hasher.hashBlock = hashBlock;
var requests$2 = {}, inthelpers = {};
Object.defineProperty(inthelpers, "__esModule", { value: !0 });
inthelpers.smallIntToApi = inthelpers.apiToBigInt = inthelpers.apiToSmallInt = void 0;
const math_1$1 = build$6, encodings_1$2 = encodings;
function apiToSmallInt(e) {
  return (typeof e == "number" ? new math_1$1.Int53(e) : math_1$1.Int53.fromString(e)).toNumber();
}
inthelpers.apiToSmallInt = apiToSmallInt;
function apiToBigInt(e) {
  if ((0, encodings_1$2.assertString)(e), !e.match(/^-?[0-9]+$/))
    throw new Error("Invalid string format");
  return BigInt(e);
}
inthelpers.apiToBigInt = apiToBigInt;
function smallIntToApi(e) {
  return new math_1$1.Int53(e).toString();
}
inthelpers.smallIntToApi = smallIntToApi;
var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding$1(n, e, o);
  return __setModuleDefault$1(n, e), n;
};
Object.defineProperty(requests$2, "__esModule", { value: !0 });
requests$2.Params = void 0;
const encoding_1$2 = build$a, inthelpers_1$1 = inthelpers, jsonrpc_1$1 = jsonrpc, encodings_1$1 = encodings, requests$1 = __importStar$1(requests$3);
function encodeHeightParam(e) {
  return {
    height: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.height)
  };
}
function encodeBlockchainRequestParams(e) {
  return {
    minHeight: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.minHeight),
    maxHeight: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.maxHeight)
  };
}
function encodeBlockSearchParams(e) {
  return {
    query: e.query,
    page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.page),
    per_page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeAbciQueryParams(e) {
  return {
    path: (0, encodings_1$1.assertNotEmpty)(e.path),
    data: (0, encoding_1$2.toHex)(e.data),
    height: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.height),
    prove: e.prove
  };
}
function encodeBroadcastTxParams(e) {
  return {
    tx: (0, encoding_1$2.toBase64)((0, encodings_1$1.assertNotEmpty)(e.tx))
  };
}
function encodeTxParams(e) {
  return {
    hash: (0, encoding_1$2.toBase64)((0, encodings_1$1.assertNotEmpty)(e.hash)),
    prove: e.prove
  };
}
function encodeTxSearchParams(e) {
  return {
    query: e.query,
    prove: e.prove,
    page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.page),
    per_page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.per_page),
    order_by: e.order_by
  };
}
function encodeValidatorsParams(e) {
  return {
    height: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.height),
    page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.page),
    per_page: (0, encodings_1$1.may)(inthelpers_1$1.smallIntToApi, e.per_page)
  };
}
let Params$g = class {
  static encodeAbciInfo(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method);
  }
  static encodeAbciQuery(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeAbciQueryParams(n.params));
  }
  static encodeBlock(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeHeightParam(n.params));
  }
  static encodeBlockchain(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeBlockchainRequestParams(n.params));
  }
  static encodeBlockResults(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeHeightParam(n.params));
  }
  static encodeBlockSearch(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeBlockSearchParams(n.params));
  }
  static encodeBroadcastTx(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeBroadcastTxParams(n.params));
  }
  static encodeCommit(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeHeightParam(n.params));
  }
  static encodeGenesis(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method);
  }
  static encodeHealth(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method);
  }
  static encodeNumUnconfirmedTxs(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method);
  }
  static encodeStatus(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method);
  }
  static encodeSubscribe(n) {
    const o = { key: "tm.event", value: n.query.type }, u = requests$1.buildQuery({ tags: [o], raw: n.query.raw });
    return (0, jsonrpc_1$1.createJsonRpcRequest)("subscribe", { query: u });
  }
  static encodeTx(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeTxParams(n.params));
  }
  // TODO: encode params for query string???
  static encodeTxSearch(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeTxSearchParams(n.params));
  }
  static encodeValidators(n) {
    return (0, jsonrpc_1$1.createJsonRpcRequest)(n.method, encodeValidatorsParams(n.params));
  }
};
requests$2.Params = Params$g;
var responses = {}, types = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = void 0, function(n) {
    n[n.Unknown = 0] = "Unknown", n[n.Absent = 1] = "Absent", n[n.Commit = 2] = "Commit", n[n.Nil = 3] = "Nil", n[n.Unrecognized = -1] = "Unrecognized";
  }(e.BlockIdFlag || (e.BlockIdFlag = {}));
})(types);
Object.defineProperty(responses, "__esModule", { value: !0 });
responses.Responses = responses.decodeValidatorInfo = responses.decodeValidatorGenesis = responses.decodeValidatorUpdate = responses.decodeEvent = void 0;
const encoding_1$1 = build$a, utils_1$1 = build$7, dates_1 = dates, inthelpers_1 = inthelpers, types_1 = types, encodings_1 = encodings, hasher_1$1 = hasher;
function decodeAbciInfo(e) {
  return {
    data: e.data,
    lastBlockHeight: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.last_block_height),
    lastBlockAppHash: (0, encodings_1.may)(encoding_1$1.fromBase64, e.last_block_app_hash)
  };
}
function decodeQueryProof(e) {
  return {
    ops: e.ops.map((n) => ({
      type: n.type,
      key: (0, encoding_1$1.fromBase64)(n.key),
      data: (0, encoding_1$1.fromBase64)(n.data)
    }))
  };
}
function decodeAbciQuery(e) {
  var n, o, u, c;
  return {
    key: (0, encoding_1$1.fromBase64)((0, encodings_1.assertString)((n = e.key) !== null && n !== void 0 ? n : "")),
    value: (0, encoding_1$1.fromBase64)((0, encodings_1.assertString)((o = e.value) !== null && o !== void 0 ? o : "")),
    proof: (0, encodings_1.may)(decodeQueryProof, e.proofOps),
    height: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.height),
    code: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.code),
    codespace: (0, encodings_1.assertString)((u = e.codespace) !== null && u !== void 0 ? u : ""),
    index: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.index),
    log: e.log,
    info: (0, encodings_1.assertString)((c = e.info) !== null && c !== void 0 ? c : "")
  };
}
function decodeAttribute(e) {
  var n;
  return {
    key: (0, encoding_1$1.fromBase64)((0, encodings_1.assertNotEmpty)(e.key)),
    value: (0, encoding_1$1.fromBase64)((0, encodings_1.assertString)((n = e.value) !== null && n !== void 0 ? n : ""))
  };
}
function decodeAttributes(e) {
  return (0, encodings_1.assertArray)(e).map(decodeAttribute);
}
function decodeEvent(e) {
  return {
    type: e.type,
    attributes: e.attributes ? decodeAttributes(e.attributes) : []
  };
}
responses.decodeEvent = decodeEvent;
function decodeEvents(e) {
  return (0, encodings_1.assertArray)(e).map(decodeEvent);
}
function decodeTxData(e) {
  var n, o, u;
  return {
    code: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)((n = e.code) !== null && n !== void 0 ? n : 0)),
    codespace: e.codespace,
    log: e.log,
    data: (0, encodings_1.may)(encoding_1$1.fromBase64, e.data),
    events: e.events ? decodeEvents(e.events) : [],
    gasWanted: (0, inthelpers_1.apiToSmallInt)((o = e.gas_wanted) !== null && o !== void 0 ? o : "0"),
    gasUsed: (0, inthelpers_1.apiToSmallInt)((u = e.gas_used) !== null && u !== void 0 ? u : "0")
  };
}
function decodePubkey(e) {
  if ("Sum" in e) {
    const [[n, o]] = Object.entries(e.Sum.value);
    return (0, utils_1$1.assert)(n === "ed25519" || n === "secp256k1", `unknown pubkey type: ${n}`), {
      algorithm: n,
      data: (0, encoding_1$1.fromBase64)((0, encodings_1.assertNotEmpty)(o))
    };
  } else
    switch (e.type) {
      case "tendermint/PubKeyEd25519":
        return {
          algorithm: "ed25519",
          data: (0, encoding_1$1.fromBase64)((0, encodings_1.assertNotEmpty)(e.value))
        };
      case "tendermint/PubKeySecp256k1":
        return {
          algorithm: "secp256k1",
          data: (0, encoding_1$1.fromBase64)((0, encodings_1.assertNotEmpty)(e.value))
        };
      default:
        throw new Error(`unknown pubkey type: ${e.type}`);
    }
}
function decodeBlockParams(e) {
  return {
    maxBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.max_bytes)),
    maxGas: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.max_gas))
  };
}
function decodeEvidenceParams(e) {
  return {
    maxAgeNumBlocks: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.max_age_num_blocks)),
    maxAgeDuration: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.max_age_duration))
  };
}
function decodeConsensusParams(e) {
  return {
    block: decodeBlockParams((0, encodings_1.assertObject)(e.block)),
    evidence: decodeEvidenceParams((0, encodings_1.assertObject)(e.evidence))
  };
}
function decodeValidatorUpdate(e) {
  var n;
  return {
    pubkey: decodePubkey((0, encodings_1.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1.apiToBigInt)((n = e.power) !== null && n !== void 0 ? n : "0")
  };
}
responses.decodeValidatorUpdate = decodeValidatorUpdate;
function decodeBlockResults(e) {
  return {
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    results: (e.txs_results || []).map(decodeTxData),
    validatorUpdates: (e.validator_updates || []).map(decodeValidatorUpdate),
    consensusUpdates: (0, encodings_1.may)(decodeConsensusParams, e.consensus_param_updates),
    beginBlockEvents: decodeEvents(e.begin_block_events || []),
    endBlockEvents: decodeEvents(e.end_block_events || [])
  };
}
function decodeBlockId(e) {
  return {
    hash: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.hash)),
    parts: {
      total: (0, encodings_1.assertNotEmpty)(e.parts.total),
      hash: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.parts.hash))
    }
  };
}
function decodeBlockVersion(e) {
  var n;
  return {
    block: (0, inthelpers_1.apiToSmallInt)(e.block),
    app: (0, inthelpers_1.apiToSmallInt)((n = e.app) !== null && n !== void 0 ? n : 0)
  };
}
function decodeHeader(e) {
  return {
    version: decodeBlockVersion(e.version),
    chainId: (0, encodings_1.assertNotEmpty)(e.chain_id),
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    time: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(e.time)),
    // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
    // { hash: '', parts: { total: 0, hash: '' } }
    lastBlockId: e.last_block_id.hash ? decodeBlockId(e.last_block_id) : null,
    lastCommitHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.last_commit_hash)),
    dataHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.data_hash)),
    validatorsHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.validators_hash)),
    nextValidatorsHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.next_validators_hash)),
    consensusHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.consensus_hash)),
    appHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.app_hash)),
    lastResultsHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.last_results_hash)),
    evidenceHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.evidence_hash)),
    proposerAddress: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.proposer_address))
  };
}
function decodeBlockMeta(e) {
  return {
    blockId: decodeBlockId(e.block_id),
    blockSize: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.block_size)),
    header: decodeHeader(e.header),
    numTxs: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.num_txs))
  };
}
function decodeBlockchain(e) {
  return {
    lastHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.last_height)),
    blockMetas: (0, encodings_1.assertArray)(e.block_metas).map(decodeBlockMeta)
  };
}
function decodeBroadcastTxSync(e) {
  return {
    ...decodeTxData(e),
    hash: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.hash))
  };
}
function decodeBroadcastTxCommit(e) {
  return {
    height: (0, inthelpers_1.apiToSmallInt)(e.height),
    hash: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.hash)),
    checkTx: decodeTxData((0, encodings_1.assertObject)(e.check_tx)),
    deliverTx: (0, encodings_1.may)(decodeTxData, e.deliver_tx)
  };
}
function decodeBlockIdFlag(e) {
  return (0, utils_1$1.assert)(e in types_1.BlockIdFlag), e;
}
function decodeOptionalTime(e) {
  return e && !e.startsWith("0001-01-01") ? (0, dates_1.fromRfc3339WithNanoseconds)(e) : void 0;
}
function decodeCommitSignature(e) {
  return {
    blockIdFlag: decodeBlockIdFlag(e.block_id_flag),
    validatorAddress: e.validator_address ? (0, encoding_1$1.fromHex)(e.validator_address) : void 0,
    timestamp: decodeOptionalTime(e.timestamp),
    signature: e.signature ? (0, encoding_1$1.fromBase64)(e.signature) : void 0
  };
}
function decodeCommit(e) {
  return {
    blockId: decodeBlockId((0, encodings_1.assertObject)(e.block_id)),
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    round: (0, inthelpers_1.apiToSmallInt)(e.round),
    signatures: (0, encodings_1.assertArray)(e.signatures).map(decodeCommitSignature)
  };
}
function decodeCommitResponse(e) {
  return {
    canonical: (0, encodings_1.assertBoolean)(e.canonical),
    header: decodeHeader(e.signed_header.header),
    commit: decodeCommit(e.signed_header.commit)
  };
}
function decodeValidatorGenesis(e) {
  return {
    address: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.address)),
    pubkey: decodePubkey((0, encodings_1.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(e.power))
  };
}
responses.decodeValidatorGenesis = decodeValidatorGenesis;
function decodeGenesis(e) {
  return {
    genesisTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(e.genesis_time)),
    chainId: (0, encodings_1.assertNotEmpty)(e.chain_id),
    consensusParams: decodeConsensusParams(e.consensus_params),
    validators: e.validators ? (0, encodings_1.assertArray)(e.validators).map(decodeValidatorGenesis) : [],
    appHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertSet)(e.app_hash)),
    appState: e.app_state
  };
}
function decodeValidatorInfo(e) {
  return {
    pubkey: decodePubkey((0, encodings_1.assertObject)(e.pub_key)),
    votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(e.voting_power)),
    address: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.address)),
    proposerPriority: e.proposer_priority ? (0, inthelpers_1.apiToSmallInt)(e.proposer_priority) : void 0
  };
}
responses.decodeValidatorInfo = decodeValidatorInfo;
function decodeNodeInfo(e) {
  return {
    id: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.id)),
    listenAddr: (0, encodings_1.assertNotEmpty)(e.listen_addr),
    network: (0, encodings_1.assertNotEmpty)(e.network),
    version: (0, encodings_1.assertString)(e.version),
    channels: (0, encodings_1.assertNotEmpty)(e.channels),
    moniker: (0, encodings_1.assertNotEmpty)(e.moniker),
    other: (0, encodings_1.dictionaryToStringMap)(e.other),
    protocolVersion: {
      app: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.protocol_version.app)),
      block: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.protocol_version.block)),
      p2p: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.protocol_version.p2p))
    }
  };
}
function decodeSyncInfo(e) {
  return {
    latestBlockHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.latest_block_hash)),
    latestAppHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.latest_app_hash)),
    latestBlockTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(e.latest_block_time)),
    latestBlockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.latest_block_height)),
    catchingUp: (0, encodings_1.assertBoolean)(e.catching_up)
  };
}
function decodeStatus(e) {
  return {
    nodeInfo: decodeNodeInfo(e.node_info),
    syncInfo: decodeSyncInfo(e.sync_info),
    validatorInfo: decodeValidatorInfo(e.validator_info)
  };
}
function decodeTxProof(e) {
  return {
    data: (0, encoding_1$1.fromBase64)((0, encodings_1.assertNotEmpty)(e.data)),
    rootHash: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.root_hash)),
    proof: {
      total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.proof.total)),
      index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.proof.index)),
      leafHash: (0, encoding_1$1.fromBase64)((0, encodings_1.assertNotEmpty)(e.proof.leaf_hash)),
      aunts: (0, encodings_1.assertArray)(e.proof.aunts).map(encoding_1$1.fromBase64)
    }
  };
}
function decodeTxResponse(e) {
  return {
    tx: (0, encoding_1$1.fromBase64)((0, encodings_1.assertNotEmpty)(e.tx)),
    result: decodeTxData((0, encodings_1.assertObject)(e.tx_result)),
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)(e.index)),
    hash: (0, encoding_1$1.fromHex)((0, encodings_1.assertNotEmpty)(e.hash)),
    proof: (0, encodings_1.may)(decodeTxProof, e.proof)
  };
}
function decodeTxSearch(e) {
  return {
    totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total_count)),
    txs: (0, encodings_1.assertArray)(e.txs).map(decodeTxResponse)
  };
}
function decodeTxEvent(e) {
  const n = (0, encoding_1$1.fromBase64)((0, encodings_1.assertNotEmpty)(e.tx));
  return {
    tx: n,
    hash: (0, hasher_1$1.hashTx)(n),
    result: decodeTxData(e.result),
    height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.height)),
    index: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, e.index)
  };
}
function decodeValidators(e) {
  return {
    blockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.block_height)),
    validators: (0, encodings_1.assertArray)(e.validators).map(decodeValidatorInfo),
    count: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.count)),
    total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total))
  };
}
function decodeBlock(e) {
  var n, o;
  return {
    header: decodeHeader((0, encodings_1.assertObject)(e.header)),
    // For the block at height 1, last commit is not set. This is represented in an empty object like this:
    // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
    lastCommit: e.last_commit.block_id.hash ? decodeCommit((0, encodings_1.assertObject)(e.last_commit)) : null,
    txs: e.data.txs ? (0, encodings_1.assertArray)(e.data.txs).map(encoding_1$1.fromBase64) : [],
    // Lift up .evidence.evidence to just .evidence
    // See https://github.com/tendermint/tendermint/issues/7697
    evidence: (o = (n = e.evidence) === null || n === void 0 ? void 0 : n.evidence) !== null && o !== void 0 ? o : []
  };
}
function decodeBlockResponse(e) {
  return {
    blockId: decodeBlockId(e.block_id),
    block: decodeBlock(e.block)
  };
}
function decodeBlockSearch(e) {
  return {
    totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total_count)),
    blocks: (0, encodings_1.assertArray)(e.blocks).map(decodeBlockResponse)
  };
}
function decodeNumUnconfirmedTxs(e) {
  return {
    total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total)),
    totalBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(e.total_bytes))
  };
}
class Responses {
  static decodeAbciInfo(n) {
    return decodeAbciInfo((0, encodings_1.assertObject)(n.result.response));
  }
  static decodeAbciQuery(n) {
    return decodeAbciQuery((0, encodings_1.assertObject)(n.result.response));
  }
  static decodeBlock(n) {
    return decodeBlockResponse(n.result);
  }
  static decodeBlockResults(n) {
    return decodeBlockResults(n.result);
  }
  static decodeBlockSearch(n) {
    return decodeBlockSearch(n.result);
  }
  static decodeBlockchain(n) {
    return decodeBlockchain(n.result);
  }
  static decodeBroadcastTxSync(n) {
    return decodeBroadcastTxSync(n.result);
  }
  static decodeBroadcastTxAsync(n) {
    return Responses.decodeBroadcastTxSync(n);
  }
  static decodeBroadcastTxCommit(n) {
    return decodeBroadcastTxCommit(n.result);
  }
  static decodeCommit(n) {
    return decodeCommitResponse(n.result);
  }
  static decodeGenesis(n) {
    return decodeGenesis((0, encodings_1.assertObject)(n.result.genesis));
  }
  static decodeHealth() {
    return null;
  }
  static decodeNumUnconfirmedTxs(n) {
    return decodeNumUnconfirmedTxs(n.result);
  }
  static decodeStatus(n) {
    return decodeStatus(n.result);
  }
  static decodeNewBlockEvent(n) {
    return decodeBlock(n.data.value.block);
  }
  static decodeNewBlockHeaderEvent(n) {
    return decodeHeader(n.data.value.header);
  }
  static decodeTxEvent(n) {
    return decodeTxEvent(n.data.value.TxResult);
  }
  static decodeTx(n) {
    return decodeTxResponse(n.result);
  }
  static decodeTxSearch(n) {
    return decodeTxSearch(n.result);
  }
  static decodeValidators(n) {
    return decodeValidators(n.result);
  }
}
responses.Responses = Responses;
Object.defineProperty(adaptor, "__esModule", { value: !0 });
adaptor.adaptor34 = void 0;
const hasher_1 = hasher, requests_1 = requests$2, responses_1 = responses;
adaptor.adaptor34 = {
  params: requests_1.Params,
  responses: responses_1.Responses,
  hashTx: hasher_1.hashTx,
  hashBlock: hasher_1.hashBlock
};
var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e, n, o, u) {
  u === void 0 && (u = o);
  var c = Object.getOwnPropertyDescriptor(n, o);
  (!c || ("get" in c ? !n.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return n[o];
  } }), Object.defineProperty(e, u, c);
} : function(e, n, o, u) {
  u === void 0 && (u = o), e[u] = n[o];
}), __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var n = {};
  if (e != null)
    for (var o in e)
      o !== "default" && Object.prototype.hasOwnProperty.call(e, o) && __createBinding(n, e, o);
  return __setModuleDefault(n, e), n;
};
Object.defineProperty(tendermint34client, "__esModule", { value: !0 });
tendermint34client.Tendermint34Client = void 0;
const jsonrpc_1 = jsonrpc, rpcclients_1 = rpcclients, adaptor_1 = adaptor, requests = __importStar(requests$3);
class Tendermint34Client {
  /**
   * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
   */
  constructor(n) {
    this.client = n, this.p = adaptor_1.adaptor34.params, this.r = adaptor_1.adaptor34.responses;
  }
  /**
   * Creates a new Tendermint client for the given endpoint.
   *
   * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
   */
  static async connect(n) {
    if (typeof n == "object")
      return Tendermint34Client.create(new rpcclients_1.HttpClient(n));
    {
      const u = n.startsWith("http://") || n.startsWith("https://") ? new rpcclients_1.HttpClient(n) : new rpcclients_1.WebsocketClient(n);
      return Tendermint34Client.create(u);
    }
  }
  /**
   * Creates a new Tendermint client given an RPC client.
   */
  static async create(n) {
    return await this.detectVersion(n), new Tendermint34Client(n);
  }
  static async detectVersion(n) {
    const o = (0, jsonrpc_1.createJsonRpcRequest)(requests.Method.Status), c = (await n.execute(o)).result;
    if (!c || !c.node_info)
      throw new Error("Unrecognized format for status response");
    const d = c.node_info.version;
    if (typeof d != "string")
      throw new Error("Unrecognized version format: must be string");
    return d;
  }
  disconnect() {
    this.client.disconnect();
  }
  async abciInfo() {
    const n = { method: requests.Method.AbciInfo };
    return this.doCall(n, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
  }
  async abciQuery(n) {
    const o = { params: n, method: requests.Method.AbciQuery };
    return this.doCall(o, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
  }
  async block(n) {
    const o = { method: requests.Method.Block, params: { height: n } };
    return this.doCall(o, this.p.encodeBlock, this.r.decodeBlock);
  }
  async blockResults(n) {
    const o = {
      method: requests.Method.BlockResults,
      params: { height: n }
    };
    return this.doCall(o, this.p.encodeBlockResults, this.r.decodeBlockResults);
  }
  /**
   * Search for events that are in a block.
   *
   * NOTE
   * This method will error on any node that is running a Tendermint version lower than 0.34.9.
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
   */
  async blockSearch(n) {
    const o = { params: n, method: requests.Method.BlockSearch }, u = await this.doCall(o, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
    return {
      ...u,
      // make sure we sort by height, as tendermint may be sorting by string value of the height
      blocks: [...u.blocks].sort((c, d) => c.block.header.height - d.block.header.height)
    };
  }
  // this should paginate through all blockSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  //
  // NOTE
  // This method will error on any node that is running a Tendermint version lower than 0.34.9.
  async blockSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.blockSearch({ ...n, page: o });
      u.push(...d.blocks), u.length < d.totalCount ? o++ : c = !0;
    }
    return u.sort((d, m) => d.block.header.height - m.block.header.height), {
      totalCount: u.length,
      blocks: u
    };
  }
  /**
   * Queries block headers filtered by minHeight <= height <= maxHeight.
   *
   * @param minHeight The minimum height to be included in the result. Defaults to 0.
   * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
   */
  async blockchain(n, o) {
    const u = {
      method: requests.Method.Blockchain,
      params: {
        minHeight: n,
        maxHeight: o
      }
    };
    return this.doCall(u, this.p.encodeBlockchain, this.r.decodeBlockchain);
  }
  /**
   * Broadcast transaction to mempool and wait for response
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
   */
  async broadcastTxSync(n) {
    const o = { params: n, method: requests.Method.BroadcastTxSync };
    return this.doCall(o, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
  }
  /**
   * Broadcast transaction to mempool and do not wait for result
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
   */
  async broadcastTxAsync(n) {
    const o = { params: n, method: requests.Method.BroadcastTxAsync };
    return this.doCall(o, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
  }
  /**
   * Broadcast transaction to mempool and wait for block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
   */
  async broadcastTxCommit(n) {
    const o = { params: n, method: requests.Method.BroadcastTxCommit };
    return this.doCall(o, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
  }
  async commit(n) {
    const o = { method: requests.Method.Commit, params: { height: n } };
    return this.doCall(o, this.p.encodeCommit, this.r.decodeCommit);
  }
  async genesis() {
    const n = { method: requests.Method.Genesis };
    return this.doCall(n, this.p.encodeGenesis, this.r.decodeGenesis);
  }
  async health() {
    const n = { method: requests.Method.Health };
    return this.doCall(n, this.p.encodeHealth, this.r.decodeHealth);
  }
  async numUnconfirmedTxs() {
    const n = { method: requests.Method.NumUnconfirmedTxs };
    return this.doCall(n, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
  }
  async status() {
    const n = { method: requests.Method.Status };
    return this.doCall(n, this.p.encodeStatus, this.r.decodeStatus);
  }
  subscribeNewBlock() {
    const n = {
      method: requests.Method.Subscribe,
      query: { type: requests.SubscriptionEventType.NewBlock }
    };
    return this.subscribe(n, this.r.decodeNewBlockEvent);
  }
  subscribeNewBlockHeader() {
    const n = {
      method: requests.Method.Subscribe,
      query: { type: requests.SubscriptionEventType.NewBlockHeader }
    };
    return this.subscribe(n, this.r.decodeNewBlockHeaderEvent);
  }
  subscribeTx(n) {
    const o = {
      method: requests.Method.Subscribe,
      query: {
        type: requests.SubscriptionEventType.Tx,
        raw: n
      }
    };
    return this.subscribe(o, this.r.decodeTxEvent);
  }
  /**
   * Get a single transaction by hash
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx
   */
  async tx(n) {
    const o = { params: n, method: requests.Method.Tx };
    return this.doCall(o, this.p.encodeTx, this.r.decodeTx);
  }
  /**
   * Search for transactions that are in a block
   *
   * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
   */
  async txSearch(n) {
    const o = { params: n, method: requests.Method.TxSearch };
    return this.doCall(o, this.p.encodeTxSearch, this.r.decodeTxSearch);
  }
  // this should paginate through all txSearch options to ensure it returns all results.
  // starts with page 1 or whatever was provided (eg. to start on page 7)
  async txSearchAll(n) {
    let o = n.page || 1;
    const u = [];
    let c = !1;
    for (; !c; ) {
      const d = await this.txSearch({ ...n, page: o });
      u.push(...d.txs), u.length < d.totalCount ? o++ : c = !0;
    }
    return {
      totalCount: u.length,
      txs: u
    };
  }
  async validators(n) {
    const o = {
      method: requests.Method.Validators,
      params: n
    };
    return this.doCall(o, this.p.encodeValidators, this.r.decodeValidators);
  }
  async validatorsAll(n) {
    const o = [];
    let u = 1, c = !1, d = n;
    for (; !c; ) {
      const m = await this.validators({
        per_page: 50,
        height: d,
        page: u
      });
      o.push(...m.validators), d = d || m.blockHeight, o.length < m.total ? u++ : c = !0;
    }
    return {
      // NOTE: Default value is for type safety but this should always be set
      blockHeight: d ?? 0,
      count: o.length,
      total: o.length,
      validators: o
    };
  }
  // doCall is a helper to handle the encode/call/decode logic
  async doCall(n, o, u) {
    const c = o(n), d = await this.client.execute(c);
    return u(d);
  }
  subscribe(n, o) {
    if (!(0, rpcclients_1.instanceOfRpcStreamingClient)(this.client))
      throw new Error("This RPC client type cannot subscribe to events");
    const u = this.p.encodeSubscribe(n);
    return this.client.listen(u).map((d) => o(d));
  }
}
tendermint34client.Tendermint34Client = Tendermint34Client;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Tendermint34Client = e.VoteType = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.SubscriptionEventType = e.Method = void 0;
  var n = requests$3;
  Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return n.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return n.SubscriptionEventType;
  } });
  var o = responses$1;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return o.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return o.VoteType;
  } });
  var u = tendermint34client;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return u.Tendermint34Client;
  } });
})(tendermint34);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(E, O, T, y) {
    y === void 0 && (y = T);
    var V = Object.getOwnPropertyDescriptor(O, T);
    (!V || ("get" in V ? !O.__esModule : V.writable || V.configurable)) && (V = { enumerable: !0, get: function() {
      return O[T];
    } }), Object.defineProperty(E, y, V);
  } : function(E, O, T, y) {
    y === void 0 && (y = T), E[y] = O[T];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(E, O) {
    Object.defineProperty(E, "default", { enumerable: !0, value: O });
  } : function(E, O) {
    E.default = O;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(E) {
    if (E && E.__esModule)
      return E;
    var O = {};
    if (E != null)
      for (var T in E)
        T !== "default" && Object.prototype.hasOwnProperty.call(E, T) && n(O, E, T);
    return o(O, E), O;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BlockIdFlag = e.Tendermint34Client = e.tendermint34 = e.VoteType = e.SubscriptionEventType = e.Method = e.broadcastTxSyncSuccess = e.broadcastTxCommitSuccess = e.WebsocketClient = e.HttpClient = e.HttpBatchClient = e.toSeconds = e.toRfc3339WithNanoseconds = e.fromSeconds = e.fromRfc3339WithNanoseconds = e.DateTime = e.rawSecp256k1PubkeyToRawAddress = e.rawEd25519PubkeyToRawAddress = e.pubkeyToRawAddress = e.pubkeyToAddress = void 0;
  var c = addresses;
  Object.defineProperty(e, "pubkeyToAddress", { enumerable: !0, get: function() {
    return c.pubkeyToAddress;
  } }), Object.defineProperty(e, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.pubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(e, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return c.rawSecp256k1PubkeyToRawAddress;
  } });
  var d = dates;
  Object.defineProperty(e, "DateTime", { enumerable: !0, get: function() {
    return d.DateTime;
  } }), Object.defineProperty(e, "fromRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return d.fromRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "fromSeconds", { enumerable: !0, get: function() {
    return d.fromSeconds;
  } }), Object.defineProperty(e, "toRfc3339WithNanoseconds", { enumerable: !0, get: function() {
    return d.toRfc3339WithNanoseconds;
  } }), Object.defineProperty(e, "toSeconds", { enumerable: !0, get: function() {
    return d.toSeconds;
  } });
  var m = rpcclients;
  Object.defineProperty(e, "HttpBatchClient", { enumerable: !0, get: function() {
    return m.HttpBatchClient;
  } }), Object.defineProperty(e, "HttpClient", { enumerable: !0, get: function() {
    return m.HttpClient;
  } }), Object.defineProperty(e, "WebsocketClient", { enumerable: !0, get: function() {
    return m.WebsocketClient;
  } });
  var v = tendermint34;
  Object.defineProperty(e, "broadcastTxCommitSuccess", { enumerable: !0, get: function() {
    return v.broadcastTxCommitSuccess;
  } }), Object.defineProperty(e, "broadcastTxSyncSuccess", { enumerable: !0, get: function() {
    return v.broadcastTxSyncSuccess;
  } }), Object.defineProperty(e, "Method", { enumerable: !0, get: function() {
    return v.Method;
  } }), Object.defineProperty(e, "SubscriptionEventType", { enumerable: !0, get: function() {
    return v.SubscriptionEventType;
  } }), Object.defineProperty(e, "VoteType", { enumerable: !0, get: function() {
    return v.VoteType;
  } }), e.tendermint34 = u(tendermint34);
  var S = tendermint34;
  Object.defineProperty(e, "Tendermint34Client", { enumerable: !0, get: function() {
    return S.Tendermint34Client;
  } });
  var $ = types;
  Object.defineProperty(e, "BlockIdFlag", { enumerable: !0, get: function() {
    return $.BlockIdFlag;
  } });
})(build$2);
var stargateclient = {};
Object.defineProperty(stargateclient, "__esModule", { value: !0 });
stargateclient.StargateClient = stargateclient.BroadcastTxError = stargateclient.assertIsDeliverTxFailure = stargateclient.assertIsDeliverTxSuccess = stargateclient.isDeliverTxSuccess = stargateclient.isDeliverTxFailure = stargateclient.TimeoutError = void 0;
const amino_1 = build$9, encoding_1 = build$a, math_1 = build$6, tendermint_rpc_1 = build$2, utils_1 = build$7, accounts_1 = accounts, events_1 = events, modules_1 = modules, queryclient_1 = queryclient$1, search_1 = search;
class TimeoutError extends Error {
  constructor(n, o) {
    super(n), this.txId = o;
  }
}
stargateclient.TimeoutError = TimeoutError;
function isDeliverTxFailure(e) {
  return !!e.code;
}
stargateclient.isDeliverTxFailure = isDeliverTxFailure;
function isDeliverTxSuccess(e) {
  return !isDeliverTxFailure(e);
}
stargateclient.isDeliverTxSuccess = isDeliverTxSuccess;
function assertIsDeliverTxSuccess(e) {
  if (isDeliverTxFailure(e))
    throw new Error(`Error when broadcasting tx ${e.transactionHash} at height ${e.height}. Code: ${e.code}; Raw log: ${e.rawLog}`);
}
stargateclient.assertIsDeliverTxSuccess = assertIsDeliverTxSuccess;
function assertIsDeliverTxFailure(e) {
  if (isDeliverTxSuccess(e))
    throw new Error(`Transaction ${e.transactionHash} did not fail at height ${e.height}. Code: ${e.code}; Raw log: ${e.rawLog}`);
}
stargateclient.assertIsDeliverTxFailure = assertIsDeliverTxFailure;
class BroadcastTxError extends Error {
  constructor(n, o, u) {
    super(`Broadcasting transaction failed with code ${n} (codespace: ${o}). Log: ${u}`), this.code = n, this.codespace = o, this.log = u;
  }
}
stargateclient.BroadcastTxError = BroadcastTxError;
class StargateClient {
  constructor(n, o) {
    n && (this.tmClient = n, this.queryClient = queryclient_1.QueryClient.withExtensions(n, modules_1.setupAuthExtension, modules_1.setupBankExtension, modules_1.setupStakingExtension, modules_1.setupTxExtension));
    const { accountParser: u = accounts_1.accountFromAny } = o;
    this.accountParser = u;
  }
  static async connect(n, o = {}) {
    const u = await tendermint_rpc_1.Tendermint34Client.connect(n);
    return new StargateClient(u, o);
  }
  getTmClient() {
    return this.tmClient;
  }
  forceGetTmClient() {
    if (!this.tmClient)
      throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
    return this.tmClient;
  }
  getQueryClient() {
    return this.queryClient;
  }
  forceGetQueryClient() {
    if (!this.queryClient)
      throw new Error("Query client not available. You cannot use online functionality in offline mode.");
    return this.queryClient;
  }
  async getChainId() {
    if (!this.chainId) {
      const o = (await this.forceGetTmClient().status()).nodeInfo.network;
      if (!o)
        throw new Error("Chain ID must not be empty");
      this.chainId = o;
    }
    return this.chainId;
  }
  async getHeight() {
    return (await this.forceGetTmClient().status()).syncInfo.latestBlockHeight;
  }
  async getAccount(n) {
    try {
      const o = await this.forceGetQueryClient().auth.account(n);
      return o ? this.accountParser(o) : null;
    } catch (o) {
      if (/rpc error: code = NotFound/i.test(o.toString()))
        return null;
      throw o;
    }
  }
  async getSequence(n) {
    const o = await this.getAccount(n);
    if (!o)
      throw new Error(`Account '${n}' does not exist on chain. Send some tokens there before trying to query sequence.`);
    return {
      accountNumber: o.accountNumber,
      sequence: o.sequence
    };
  }
  async getBlock(n) {
    const o = await this.forceGetTmClient().block(n);
    return {
      id: (0, encoding_1.toHex)(o.blockId.hash).toUpperCase(),
      header: {
        version: {
          block: new math_1.Uint53(o.block.header.version.block).toString(),
          app: new math_1.Uint53(o.block.header.version.app).toString()
        },
        height: o.block.header.height,
        chainId: o.block.header.chainId,
        time: (0, tendermint_rpc_1.toRfc3339WithNanoseconds)(o.block.header.time)
      },
      txs: o.block.txs
    };
  }
  async getBalance(n, o) {
    return this.forceGetQueryClient().bank.balance(n, o);
  }
  /**
   * Queries all balances for all denoms that belong to this address.
   *
   * Uses the grpc queries (which iterates over the store internally), and we cannot get
   * proofs from such a method.
   */
  async getAllBalances(n) {
    return this.forceGetQueryClient().bank.allBalances(n);
  }
  async getBalanceStaked(n) {
    const o = [];
    let u;
    do {
      const { delegationResponses: d, pagination: m } = await this.forceGetQueryClient().staking.delegatorDelegations(n, u), v = d || [];
      o.push(...v), u = m == null ? void 0 : m.nextKey;
    } while (u !== void 0 && u.length !== 0);
    return o.reduce((d, m) => ((0, utils_1.assert)(m.balance), d !== null ? (0, amino_1.addCoins)(d, m.balance) : m.balance), null);
  }
  async getDelegation(n, o) {
    var u;
    let c;
    try {
      c = (u = (await this.forceGetQueryClient().staking.delegation(n, o)).delegationResponse) === null || u === void 0 ? void 0 : u.balance;
    } catch (d) {
      if (!d.toString().includes("key not found"))
        throw d;
    }
    return c || null;
  }
  async getTx(n) {
    var o;
    return (o = (await this.txsQuery(`tx.hash='${n}'`))[0]) !== null && o !== void 0 ? o : null;
  }
  async searchTx(n, o = {}) {
    const u = o.minHeight || 0, c = o.maxHeight || Number.MAX_SAFE_INTEGER;
    if (c < u)
      return [];
    function d(S) {
      return `${S} AND tx.height>=${u} AND tx.height<=${c}`;
    }
    let m;
    if ((0, search_1.isSearchByHeightQuery)(n))
      m = n.height >= u && n.height <= c ? await this.txsQuery(`tx.height=${n.height}`) : [];
    else if ((0, search_1.isSearchBySentFromOrToQuery)(n)) {
      const S = d(`message.module='bank' AND transfer.sender='${n.sentFromOrTo}'`), $ = d(`message.module='bank' AND transfer.recipient='${n.sentFromOrTo}'`), [E, O] = await Promise.all([S, $].map((y) => this.txsQuery(y))), T = E.map((y) => y.hash);
      m = [...E, ...O.filter((y) => !T.includes(y.hash))];
    } else if ((0, search_1.isSearchByTagsQuery)(n)) {
      const S = d(n.tags.map(($) => `${$.key}='${$.value}'`).join(" AND "));
      m = await this.txsQuery(S);
    } else
      throw new Error("Unknown query type");
    return m.filter((S) => S.height >= u && S.height <= c);
  }
  disconnect() {
    this.tmClient && this.tmClient.disconnect();
  }
  /**
   * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
   *
   * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
   * an error is thrown.
   *
   * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
   *
   * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
   * usually needs to check for execution success or failure.
   */
  async broadcastTx(n, o = 6e4, u = 3e3) {
    var c;
    let d = !1;
    const m = setTimeout(() => {
      d = !0;
    }, o), v = async (E) => {
      if (d)
        throw new TimeoutError(`Transaction with ID ${E} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${o / 1e3} seconds.`, E);
      await (0, utils_1.sleep)(u);
      const O = await this.getTx(E);
      return O ? {
        code: O.code,
        height: O.height,
        events: O.events,
        rawLog: O.rawLog,
        transactionHash: E,
        gasUsed: O.gasUsed,
        gasWanted: O.gasWanted
      } : v(E);
    }, S = await this.forceGetTmClient().broadcastTxSync({ tx: n });
    if (S.code)
      return Promise.reject(new BroadcastTxError(S.code, (c = S.codespace) !== null && c !== void 0 ? c : "", S.log));
    const $ = (0, encoding_1.toHex)(S.hash).toUpperCase();
    return new Promise((E, O) => v($).then((T) => {
      clearTimeout(m), E(T);
    }, (T) => {
      clearTimeout(m), O(T);
    }));
  }
  async txsQuery(n) {
    return (await this.forceGetTmClient().txSearchAll({ query: n })).txs.map((u) => ({
      height: u.height,
      hash: (0, encoding_1.toHex)(u.hash).toUpperCase(),
      code: u.result.code,
      events: u.result.events.map(events_1.fromTendermint34Event),
      rawLog: u.result.log || "",
      tx: u.tx,
      gasUsed: u.result.gasUsed,
      gasWanted: u.result.gasWanted
    }));
  }
}
stargateclient.StargateClient = StargateClient;
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__importDefault || function(Y) {
    return Y && Y.__esModule ? Y : { default: Y };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SigningStargateClient = e.defaultRegistryTypes = void 0;
  const o = build$9, u = build$a, c = build$6, d = build$4, m = build$2, v = build$7, S = coin$8, $ = tx$m, E = tx$d, O = signing$3, T = tx$p, y = tx$h, V = n(long), M = aminotypes, G = fee, k = modules, F = modules, X = stargateclient;
  e.defaultRegistryTypes = [
    ["/cosmos.base.v1beta1.Coin", S.Coin],
    ...k.authzTypes,
    ...k.bankTypes,
    ...k.distributionTypes,
    ...k.feegrantTypes,
    ...k.govTypes,
    ...k.stakingTypes,
    ...k.ibcTypes,
    ...k.vestingTypes
  ];
  function ee() {
    return new d.Registry(e.defaultRegistryTypes);
  }
  function ue(Y) {
    return {
      ...(0, F.createAuthzAminoConverters)(),
      ...(0, F.createBankAminoConverters)(),
      ...(0, F.createDistributionAminoConverters)(),
      ...(0, F.createGovAminoConverters)(),
      ...(0, F.createStakingAminoConverters)(Y),
      ...(0, F.createIbcAminoConverters)(),
      ...(0, F.createFeegrantAminoConverters)(),
      ...(0, F.createVestingAminoConverters)()
    };
  }
  class Q extends X.StargateClient {
    constructor(pe, oe, ne) {
      var H;
      super(pe, ne);
      const C = (H = ne.prefix) !== null && H !== void 0 ? H : "cosmos", { registry: w = ee(), aminoTypes: P = new M.AminoTypes(ue(C)) } = ne;
      this.registry = w, this.aminoTypes = P, this.signer = oe, this.broadcastTimeoutMs = ne.broadcastTimeoutMs, this.broadcastPollIntervalMs = ne.broadcastPollIntervalMs, this.gasPrice = ne.gasPrice;
    }
    static async connectWithSigner(pe, oe, ne = {}) {
      const H = await m.Tendermint34Client.connect(pe);
      return new Q(H, oe, ne);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */
    static async offline(pe, oe = {}) {
      return new Q(void 0, pe, oe);
    }
    async simulate(pe, oe, ne) {
      const H = oe.map((se) => this.registry.encodeAsAny(se)), C = (await this.signer.getAccounts()).find((se) => se.address === pe);
      if (!C)
        throw new Error("Failed to retrieve account from signer");
      const w = (0, o.encodeSecp256k1Pubkey)(C.pubkey), { sequence: P } = await this.getSequence(pe), { gasInfo: J } = await this.forceGetQueryClient().tx.simulate(H, ne, w, P);
      return (0, v.assertDefined)(J), c.Uint53.fromString(J.gasUsed.toString()).toNumber();
    }
    async sendTokens(pe, oe, ne, H, C = "") {
      const w = {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: {
          fromAddress: pe,
          toAddress: oe,
          amount: [...ne]
        }
      };
      return this.signAndBroadcast(pe, [w], H, C);
    }
    async delegateTokens(pe, oe, ne, H, C = "") {
      const w = {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: E.MsgDelegate.fromPartial({
          delegatorAddress: pe,
          validatorAddress: oe,
          amount: ne
        })
      };
      return this.signAndBroadcast(pe, [w], H, C);
    }
    async undelegateTokens(pe, oe, ne, H, C = "") {
      const w = {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: E.MsgUndelegate.fromPartial({
          delegatorAddress: pe,
          validatorAddress: oe,
          amount: ne
        })
      };
      return this.signAndBroadcast(pe, [w], H, C);
    }
    async withdrawRewards(pe, oe, ne, H = "") {
      const C = {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: $.MsgWithdrawDelegatorReward.fromPartial({
          delegatorAddress: pe,
          validatorAddress: oe
        })
      };
      return this.signAndBroadcast(pe, [C], ne, H);
    }
    async sendIbcTokens(pe, oe, ne, H, C, w, P, J, se = "") {
      const fe = P ? V.default.fromNumber(P).multiply(1e9) : void 0, N = {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: y.MsgTransfer.fromPartial({
          sourcePort: H,
          sourceChannel: C,
          sender: pe,
          receiver: oe,
          token: ne,
          timeoutHeight: w,
          timeoutTimestamp: fe
        })
      };
      return this.signAndBroadcast(pe, [N], J, se);
    }
    async signAndBroadcast(pe, oe, ne, H = "") {
      let C;
      if (ne == "auto" || typeof ne == "number") {
        (0, v.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
        const J = await this.simulate(pe, oe, H), se = typeof ne == "number" ? ne : 1.3;
        C = (0, G.calculateFee)(Math.round(J * se), this.gasPrice);
      } else
        C = ne;
      const w = await this.sign(pe, oe, C, H), P = T.TxRaw.encode(w).finish();
      return this.broadcastTx(P, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */
    async sign(pe, oe, ne, H, C) {
      let w;
      if (C)
        w = C;
      else {
        const { accountNumber: P, sequence: J } = await this.getSequence(pe), se = await this.getChainId();
        w = {
          accountNumber: P,
          sequence: J,
          chainId: se
        };
      }
      return (0, d.isOfflineDirectSigner)(this.signer) ? this.signDirect(pe, oe, ne, H, w) : this.signAmino(pe, oe, ne, H, w);
    }
    async signAmino(pe, oe, ne, H, { accountNumber: C, sequence: w, chainId: P }) {
      (0, v.assert)(!(0, d.isOfflineDirectSigner)(this.signer));
      const J = (await this.signer.getAccounts()).find((Qt) => Qt.address === pe);
      if (!J)
        throw new Error("Failed to retrieve account from signer");
      const se = (0, d.encodePubkey)((0, o.encodeSecp256k1Pubkey)(J.pubkey)), fe = O.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, N = oe.map((Qt) => this.aminoTypes.toAmino(Qt)), W = (0, o.makeSignDoc)(N, ne, P, H, C, w), { signature: I, signed: te } = await this.signer.signAmino(pe, W), Pe = {
        typeUrl: "/cosmos.tx.v1beta1.TxBody",
        value: {
          messages: te.msgs.map((Qt) => this.aminoTypes.fromAmino(Qt)),
          memo: te.memo
        }
      }, Ke = this.registry.encode(Pe), xe = c.Int53.fromString(te.fee.gas).toNumber(), ze = c.Int53.fromString(te.sequence).toNumber(), nt = (0, d.makeAuthInfoBytes)([{ pubkey: se, sequence: ze }], te.fee.amount, xe, te.fee.granter, te.fee.payer, fe);
      return T.TxRaw.fromPartial({
        bodyBytes: Ke,
        authInfoBytes: nt,
        signatures: [(0, u.fromBase64)(I.signature)]
      });
    }
    async signDirect(pe, oe, ne, H, { accountNumber: C, sequence: w, chainId: P }) {
      (0, v.assert)((0, d.isOfflineDirectSigner)(this.signer));
      const J = (await this.signer.getAccounts()).find((Ke) => Ke.address === pe);
      if (!J)
        throw new Error("Failed to retrieve account from signer");
      const se = (0, d.encodePubkey)((0, o.encodeSecp256k1Pubkey)(J.pubkey)), fe = {
        typeUrl: "/cosmos.tx.v1beta1.TxBody",
        value: {
          messages: oe,
          memo: H
        }
      }, N = this.registry.encode(fe), W = c.Int53.fromString(ne.gas).toNumber(), I = (0, d.makeAuthInfoBytes)([{ pubkey: se, sequence: w }], ne.amount, W, ne.granter, ne.payer), te = (0, d.makeSignDoc)(N, I, P, C), { signature: ge, signed: Pe } = await this.signer.signDirect(pe, te);
      return T.TxRaw.fromPartial({
        bodyBytes: Pe.bodyBytes,
        authInfoBytes: Pe.authInfoBytes,
        signatures: [(0, u.fromBase64)(ge.signature)]
      });
    }
  }
  e.SigningStargateClient = Q;
})(signingstargateclient);
(function(e) {
  var n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(M, G, k, F) {
    F === void 0 && (F = k);
    var X = Object.getOwnPropertyDescriptor(G, k);
    (!X || ("get" in X ? !G.__esModule : X.writable || X.configurable)) && (X = { enumerable: !0, get: function() {
      return G[k];
    } }), Object.defineProperty(M, F, X);
  } : function(M, G, k, F) {
    F === void 0 && (F = k), M[F] = G[k];
  }), o = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(M, G) {
    Object.defineProperty(M, "default", { enumerable: !0, value: G });
  } : function(M, G) {
    M.default = G;
  }), u = commonjsGlobal && commonjsGlobal.__importStar || function(M) {
    if (M && M.__esModule)
      return M;
    var G = {};
    if (M != null)
      for (var k in M)
        k !== "default" && Object.prototype.hasOwnProperty.call(M, k) && n(G, M, k);
    return o(G, M), G;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.setupAuthExtension = e.isMsgWithdrawDelegatorRewardEncodeObject = e.isMsgVoteWeightedEncodeObject = e.isMsgVoteEncodeObject = e.isMsgUndelegateEncodeObject = e.isMsgTransferEncodeObject = e.isMsgSubmitProposalEncodeObject = e.isMsgSendEncodeObject = e.isMsgEditValidatorEncodeObject = e.isMsgDepositEncodeObject = e.isMsgDelegateEncodeObject = e.isMsgCreateValidatorEncodeObject = e.isMsgBeginRedelegateEncodeObject = e.isAminoMsgWithdrawValidatorCommission = e.isAminoMsgWithdrawDelegatorReward = e.isAminoMsgVoteWeighted = e.isAminoMsgVote = e.isAminoMsgVerifyInvariant = e.isAminoMsgUnjail = e.isAminoMsgUndelegate = e.isAminoMsgTransfer = e.isAminoMsgSubmitProposal = e.isAminoMsgSubmitEvidence = e.isAminoMsgSetWithdrawAddress = e.isAminoMsgSend = e.isAminoMsgMultiSend = e.isAminoMsgFundCommunityPool = e.isAminoMsgEditValidator = e.isAminoMsgDeposit = e.isAminoMsgDelegate = e.isAminoMsgCreateVestingAccount = e.isAminoMsgCreateValidator = e.isAminoMsgBeginRedelegate = e.createVestingAminoConverters = e.createStakingAminoConverters = e.createSlashingAminoConverters = e.createIbcAminoConverters = e.createGovAminoConverters = e.createFeegrantAminoConverters = e.createEvidenceAminoConverters = e.createDistributionAminoConverters = e.createCrysisAminoConverters = e.createBankAminoConverters = e.createAuthzAminoConverters = e.logs = e.GasPrice = e.calculateFee = e.fromTendermint34Event = e.AminoTypes = e.accountFromAny = void 0, e.parseCoins = e.makeCosmoshubPath = e.coins = e.coin = e.TimeoutError = e.StargateClient = e.isDeliverTxSuccess = e.isDeliverTxFailure = e.BroadcastTxError = e.assertIsDeliverTxSuccess = e.assertIsDeliverTxFailure = e.SigningStargateClient = e.defaultRegistryTypes = e.isSearchByTagsQuery = e.isSearchBySentFromOrToQuery = e.isSearchByHeightQuery = e.QueryClient = e.decodeCosmosSdkDecFromProto = e.createProtobufRpcClient = e.createPagination = e.makeMultisignedTxBytes = e.makeMultisignedTx = e.setupTxExtension = e.setupStakingExtension = e.setupSlashingExtension = e.setupMintExtension = e.setupIbcExtension = e.setupGovExtension = e.setupFeegrantExtension = e.setupDistributionExtension = e.setupBankExtension = e.setupAuthzExtension = void 0;
  var c = accounts;
  Object.defineProperty(e, "accountFromAny", { enumerable: !0, get: function() {
    return c.accountFromAny;
  } });
  var d = aminotypes;
  Object.defineProperty(e, "AminoTypes", { enumerable: !0, get: function() {
    return d.AminoTypes;
  } });
  var m = events;
  Object.defineProperty(e, "fromTendermint34Event", { enumerable: !0, get: function() {
    return m.fromTendermint34Event;
  } });
  var v = fee;
  Object.defineProperty(e, "calculateFee", { enumerable: !0, get: function() {
    return v.calculateFee;
  } }), Object.defineProperty(e, "GasPrice", { enumerable: !0, get: function() {
    return v.GasPrice;
  } }), e.logs = u(logs);
  var S = modules;
  Object.defineProperty(e, "createAuthzAminoConverters", { enumerable: !0, get: function() {
    return S.createAuthzAminoConverters;
  } }), Object.defineProperty(e, "createBankAminoConverters", { enumerable: !0, get: function() {
    return S.createBankAminoConverters;
  } }), Object.defineProperty(e, "createCrysisAminoConverters", { enumerable: !0, get: function() {
    return S.createCrysisAminoConverters;
  } }), Object.defineProperty(e, "createDistributionAminoConverters", { enumerable: !0, get: function() {
    return S.createDistributionAminoConverters;
  } }), Object.defineProperty(e, "createEvidenceAminoConverters", { enumerable: !0, get: function() {
    return S.createEvidenceAminoConverters;
  } }), Object.defineProperty(e, "createFeegrantAminoConverters", { enumerable: !0, get: function() {
    return S.createFeegrantAminoConverters;
  } }), Object.defineProperty(e, "createGovAminoConverters", { enumerable: !0, get: function() {
    return S.createGovAminoConverters;
  } }), Object.defineProperty(e, "createIbcAminoConverters", { enumerable: !0, get: function() {
    return S.createIbcAminoConverters;
  } }), Object.defineProperty(e, "createSlashingAminoConverters", { enumerable: !0, get: function() {
    return S.createSlashingAminoConverters;
  } }), Object.defineProperty(e, "createStakingAminoConverters", { enumerable: !0, get: function() {
    return S.createStakingAminoConverters;
  } }), Object.defineProperty(e, "createVestingAminoConverters", { enumerable: !0, get: function() {
    return S.createVestingAminoConverters;
  } }), Object.defineProperty(e, "isAminoMsgBeginRedelegate", { enumerable: !0, get: function() {
    return S.isAminoMsgBeginRedelegate;
  } }), Object.defineProperty(e, "isAminoMsgCreateValidator", { enumerable: !0, get: function() {
    return S.isAminoMsgCreateValidator;
  } }), Object.defineProperty(e, "isAminoMsgCreateVestingAccount", { enumerable: !0, get: function() {
    return S.isAminoMsgCreateVestingAccount;
  } }), Object.defineProperty(e, "isAminoMsgDelegate", { enumerable: !0, get: function() {
    return S.isAminoMsgDelegate;
  } }), Object.defineProperty(e, "isAminoMsgDeposit", { enumerable: !0, get: function() {
    return S.isAminoMsgDeposit;
  } }), Object.defineProperty(e, "isAminoMsgEditValidator", { enumerable: !0, get: function() {
    return S.isAminoMsgEditValidator;
  } }), Object.defineProperty(e, "isAminoMsgFundCommunityPool", { enumerable: !0, get: function() {
    return S.isAminoMsgFundCommunityPool;
  } }), Object.defineProperty(e, "isAminoMsgMultiSend", { enumerable: !0, get: function() {
    return S.isAminoMsgMultiSend;
  } }), Object.defineProperty(e, "isAminoMsgSend", { enumerable: !0, get: function() {
    return S.isAminoMsgSend;
  } }), Object.defineProperty(e, "isAminoMsgSetWithdrawAddress", { enumerable: !0, get: function() {
    return S.isAminoMsgSetWithdrawAddress;
  } }), Object.defineProperty(e, "isAminoMsgSubmitEvidence", { enumerable: !0, get: function() {
    return S.isAminoMsgSubmitEvidence;
  } }), Object.defineProperty(e, "isAminoMsgSubmitProposal", { enumerable: !0, get: function() {
    return S.isAminoMsgSubmitProposal;
  } }), Object.defineProperty(e, "isAminoMsgTransfer", { enumerable: !0, get: function() {
    return S.isAminoMsgTransfer;
  } }), Object.defineProperty(e, "isAminoMsgUndelegate", { enumerable: !0, get: function() {
    return S.isAminoMsgUndelegate;
  } }), Object.defineProperty(e, "isAminoMsgUnjail", { enumerable: !0, get: function() {
    return S.isAminoMsgUnjail;
  } }), Object.defineProperty(e, "isAminoMsgVerifyInvariant", { enumerable: !0, get: function() {
    return S.isAminoMsgVerifyInvariant;
  } }), Object.defineProperty(e, "isAminoMsgVote", { enumerable: !0, get: function() {
    return S.isAminoMsgVote;
  } }), Object.defineProperty(e, "isAminoMsgVoteWeighted", { enumerable: !0, get: function() {
    return S.isAminoMsgVoteWeighted;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawDelegatorReward", { enumerable: !0, get: function() {
    return S.isAminoMsgWithdrawDelegatorReward;
  } }), Object.defineProperty(e, "isAminoMsgWithdrawValidatorCommission", { enumerable: !0, get: function() {
    return S.isAminoMsgWithdrawValidatorCommission;
  } }), Object.defineProperty(e, "isMsgBeginRedelegateEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgBeginRedelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgCreateValidatorEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgCreateValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgDelegateEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgDelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgDepositEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgDepositEncodeObject;
  } }), Object.defineProperty(e, "isMsgEditValidatorEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgEditValidatorEncodeObject;
  } }), Object.defineProperty(e, "isMsgSendEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgSendEncodeObject;
  } }), Object.defineProperty(e, "isMsgSubmitProposalEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgSubmitProposalEncodeObject;
  } }), Object.defineProperty(e, "isMsgTransferEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgTransferEncodeObject;
  } }), Object.defineProperty(e, "isMsgUndelegateEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgUndelegateEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgVoteEncodeObject;
  } }), Object.defineProperty(e, "isMsgVoteWeightedEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgVoteWeightedEncodeObject;
  } }), Object.defineProperty(e, "isMsgWithdrawDelegatorRewardEncodeObject", { enumerable: !0, get: function() {
    return S.isMsgWithdrawDelegatorRewardEncodeObject;
  } }), Object.defineProperty(e, "setupAuthExtension", { enumerable: !0, get: function() {
    return S.setupAuthExtension;
  } }), Object.defineProperty(e, "setupAuthzExtension", { enumerable: !0, get: function() {
    return S.setupAuthzExtension;
  } }), Object.defineProperty(e, "setupBankExtension", { enumerable: !0, get: function() {
    return S.setupBankExtension;
  } }), Object.defineProperty(e, "setupDistributionExtension", { enumerable: !0, get: function() {
    return S.setupDistributionExtension;
  } }), Object.defineProperty(e, "setupFeegrantExtension", { enumerable: !0, get: function() {
    return S.setupFeegrantExtension;
  } }), Object.defineProperty(e, "setupGovExtension", { enumerable: !0, get: function() {
    return S.setupGovExtension;
  } }), Object.defineProperty(e, "setupIbcExtension", { enumerable: !0, get: function() {
    return S.setupIbcExtension;
  } }), Object.defineProperty(e, "setupMintExtension", { enumerable: !0, get: function() {
    return S.setupMintExtension;
  } }), Object.defineProperty(e, "setupSlashingExtension", { enumerable: !0, get: function() {
    return S.setupSlashingExtension;
  } }), Object.defineProperty(e, "setupStakingExtension", { enumerable: !0, get: function() {
    return S.setupStakingExtension;
  } }), Object.defineProperty(e, "setupTxExtension", { enumerable: !0, get: function() {
    return S.setupTxExtension;
  } });
  var $ = multisignature;
  Object.defineProperty(e, "makeMultisignedTx", { enumerable: !0, get: function() {
    return $.makeMultisignedTx;
  } }), Object.defineProperty(e, "makeMultisignedTxBytes", { enumerable: !0, get: function() {
    return $.makeMultisignedTxBytes;
  } });
  var E = queryclient$1;
  Object.defineProperty(e, "createPagination", { enumerable: !0, get: function() {
    return E.createPagination;
  } }), Object.defineProperty(e, "createProtobufRpcClient", { enumerable: !0, get: function() {
    return E.createProtobufRpcClient;
  } }), Object.defineProperty(e, "decodeCosmosSdkDecFromProto", { enumerable: !0, get: function() {
    return E.decodeCosmosSdkDecFromProto;
  } }), Object.defineProperty(e, "QueryClient", { enumerable: !0, get: function() {
    return E.QueryClient;
  } });
  var O = search;
  Object.defineProperty(e, "isSearchByHeightQuery", { enumerable: !0, get: function() {
    return O.isSearchByHeightQuery;
  } }), Object.defineProperty(e, "isSearchBySentFromOrToQuery", { enumerable: !0, get: function() {
    return O.isSearchBySentFromOrToQuery;
  } }), Object.defineProperty(e, "isSearchByTagsQuery", { enumerable: !0, get: function() {
    return O.isSearchByTagsQuery;
  } });
  var T = signingstargateclient;
  Object.defineProperty(e, "defaultRegistryTypes", { enumerable: !0, get: function() {
    return T.defaultRegistryTypes;
  } }), Object.defineProperty(e, "SigningStargateClient", { enumerable: !0, get: function() {
    return T.SigningStargateClient;
  } });
  var y = stargateclient;
  Object.defineProperty(e, "assertIsDeliverTxFailure", { enumerable: !0, get: function() {
    return y.assertIsDeliverTxFailure;
  } }), Object.defineProperty(e, "assertIsDeliverTxSuccess", { enumerable: !0, get: function() {
    return y.assertIsDeliverTxSuccess;
  } }), Object.defineProperty(e, "BroadcastTxError", { enumerable: !0, get: function() {
    return y.BroadcastTxError;
  } }), Object.defineProperty(e, "isDeliverTxFailure", { enumerable: !0, get: function() {
    return y.isDeliverTxFailure;
  } }), Object.defineProperty(e, "isDeliverTxSuccess", { enumerable: !0, get: function() {
    return y.isDeliverTxSuccess;
  } }), Object.defineProperty(e, "StargateClient", { enumerable: !0, get: function() {
    return y.StargateClient;
  } }), Object.defineProperty(e, "TimeoutError", { enumerable: !0, get: function() {
    return y.TimeoutError;
  } });
  var V = build$4;
  Object.defineProperty(e, "coin", { enumerable: !0, get: function() {
    return V.coin;
  } }), Object.defineProperty(e, "coins", { enumerable: !0, get: function() {
    return V.coins;
  } }), Object.defineProperty(e, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return V.makeCosmoshubPath;
  } }), Object.defineProperty(e, "parseCoins", { enumerable: !0, get: function() {
    return V.parseCoins;
  } });
})(build$5);
let QueryClientImpl$w = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.accounts = this.accounts.bind(this), this.account = this.account.bind(this), this.params = this.params.bind(this), this.moduleAccounts = this.moduleAccounts.bind(this);
  }
  accounts(n = {
    pagination: void 0
  }) {
    const o = QueryAccountsRequest.encode(n).finish();
    return this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", o).then((c) => QueryAccountsResponse.decode(new minimal.Reader(c)));
  }
  account(n) {
    const o = QueryAccountRequest.encode(n).finish();
    return this.rpc.request("cosmos.auth.v1beta1.Query", "Account", o).then((c) => QueryAccountResponse.decode(new minimal.Reader(c)));
  }
  params(n = {}) {
    const o = QueryParamsRequest$f.encode(n).finish();
    return this.rpc.request("cosmos.auth.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse$f.decode(new minimal.Reader(c)));
  }
  moduleAccounts(n = {}) {
    const o = QueryModuleAccountsRequest.encode(n).finish();
    return this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", o).then((c) => QueryModuleAccountsResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$y = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$w(n);
  return {
    accounts(u) {
      return o.accounts(u);
    },
    account(u) {
      return o.account(u);
    },
    params(u) {
      return o.params(u);
    },
    moduleAccounts(u) {
      return o.moduleAccounts(u);
    }
  };
}, _212 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$w,
  createRpcQueryExtension: createRpcQueryExtension$y
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$v = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.grants = this.grants.bind(this), this.granterGrants = this.granterGrants.bind(this), this.granteeGrants = this.granteeGrants.bind(this);
  }
  grants(n) {
    const o = QueryGrantsRequest.encode(n).finish();
    return this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", o).then((c) => QueryGrantsResponse.decode(new minimal.Reader(c)));
  }
  granterGrants(n) {
    const o = QueryGranterGrantsRequest.encode(n).finish();
    return this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", o).then((c) => QueryGranterGrantsResponse.decode(new minimal.Reader(c)));
  }
  granteeGrants(n) {
    const o = QueryGranteeGrantsRequest.encode(n).finish();
    return this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", o).then((c) => QueryGranteeGrantsResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$x = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$v(n);
  return {
    grants(u) {
      return o.grants(u);
    },
    granterGrants(u) {
      return o.granterGrants(u);
    },
    granteeGrants(u) {
      return o.granteeGrants(u);
    }
  };
}, _213 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$v,
  createRpcQueryExtension: createRpcQueryExtension$x
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$u = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.balance = this.balance.bind(this), this.allBalances = this.allBalances.bind(this), this.totalSupply = this.totalSupply.bind(this), this.supplyOf = this.supplyOf.bind(this), this.totalSupplyWithoutOffset = this.totalSupplyWithoutOffset.bind(this), this.supplyOfWithoutOffset = this.supplyOfWithoutOffset.bind(this), this.params = this.params.bind(this), this.denomMetadata = this.denomMetadata.bind(this), this.denomsMetadata = this.denomsMetadata.bind(this), this.baseDenom = this.baseDenom.bind(this);
  }
  balance(n) {
    const o = QueryBalanceRequest.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", o).then((c) => QueryBalanceResponse.decode(new minimal.Reader(c)));
  }
  allBalances(n) {
    const o = QueryAllBalancesRequest.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", o).then((c) => QueryAllBalancesResponse.decode(new minimal.Reader(c)));
  }
  totalSupply(n = {
    pagination: void 0
  }) {
    const o = QueryTotalSupplyRequest.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", o).then((c) => QueryTotalSupplyResponse.decode(new minimal.Reader(c)));
  }
  supplyOf(n) {
    const o = QuerySupplyOfRequest.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", o).then((c) => QuerySupplyOfResponse.decode(new minimal.Reader(c)));
  }
  totalSupplyWithoutOffset(n = {
    pagination: void 0
  }) {
    const o = QueryTotalSupplyWithoutOffsetRequest.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupplyWithoutOffset", o).then((c) => QueryTotalSupplyWithoutOffsetResponse.decode(new minimal.Reader(c)));
  }
  supplyOfWithoutOffset(n) {
    const o = QuerySupplyOfWithoutOffsetRequest.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOfWithoutOffset", o).then((c) => QuerySupplyOfWithoutOffsetResponse.decode(new minimal.Reader(c)));
  }
  params(n = {}) {
    const o = QueryParamsRequest$e.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse$e.decode(new minimal.Reader(c)));
  }
  denomMetadata(n) {
    const o = QueryDenomMetadataRequest.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", o).then((c) => QueryDenomMetadataResponse.decode(new minimal.Reader(c)));
  }
  denomsMetadata(n = {
    pagination: void 0
  }) {
    const o = QueryDenomsMetadataRequest.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", o).then((c) => QueryDenomsMetadataResponse.decode(new minimal.Reader(c)));
  }
  baseDenom(n) {
    const o = QueryBaseDenomRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Query", "BaseDenom", o).then((c) => QueryBaseDenomResponse$1.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$w = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$u(n);
  return {
    balance(u) {
      return o.balance(u);
    },
    allBalances(u) {
      return o.allBalances(u);
    },
    totalSupply(u) {
      return o.totalSupply(u);
    },
    supplyOf(u) {
      return o.supplyOf(u);
    },
    totalSupplyWithoutOffset(u) {
      return o.totalSupplyWithoutOffset(u);
    },
    supplyOfWithoutOffset(u) {
      return o.supplyOfWithoutOffset(u);
    },
    params(u) {
      return o.params(u);
    },
    denomMetadata(u) {
      return o.denomMetadata(u);
    },
    denomsMetadata(u) {
      return o.denomsMetadata(u);
    },
    baseDenom(u) {
      return o.baseDenom(u);
    }
  };
}, _214 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$u,
  createRpcQueryExtension: createRpcQueryExtension$w
}, Symbol.toStringTag, { value: "Module" }));
let ServiceClientImpl$1 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.config = this.config.bind(this);
  }
  config(n = {}) {
    const o = ConfigRequest.encode(n).finish();
    return this.rpc.request("cosmos.base.node.v1beta1.Service", "Config", o).then((c) => ConfigResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$v = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new ServiceClientImpl$1(n);
  return {
    config(u) {
      return o.config(u);
    }
  };
}, _215 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ServiceClientImpl: ServiceClientImpl$1,
  createRpcQueryExtension: createRpcQueryExtension$v
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$t = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this), this.validatorOutstandingRewards = this.validatorOutstandingRewards.bind(this), this.validatorCommission = this.validatorCommission.bind(this), this.validatorSlashes = this.validatorSlashes.bind(this), this.delegationRewards = this.delegationRewards.bind(this), this.delegationTotalRewards = this.delegationTotalRewards.bind(this), this.delegatorValidators = this.delegatorValidators.bind(this), this.delegatorWithdrawAddress = this.delegatorWithdrawAddress.bind(this), this.communityPool = this.communityPool.bind(this);
  }
  params(n = {}) {
    const o = QueryParamsRequest$d.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse$d.decode(new minimal.Reader(c)));
  }
  validatorOutstandingRewards(n) {
    const o = QueryValidatorOutstandingRewardsRequest.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", o).then((c) => QueryValidatorOutstandingRewardsResponse.decode(new minimal.Reader(c)));
  }
  validatorCommission(n) {
    const o = QueryValidatorCommissionRequest.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", o).then((c) => QueryValidatorCommissionResponse.decode(new minimal.Reader(c)));
  }
  validatorSlashes(n) {
    const o = QueryValidatorSlashesRequest.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", o).then((c) => QueryValidatorSlashesResponse.decode(new minimal.Reader(c)));
  }
  delegationRewards(n) {
    const o = QueryDelegationRewardsRequest.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", o).then((c) => QueryDelegationRewardsResponse.decode(new minimal.Reader(c)));
  }
  delegationTotalRewards(n) {
    const o = QueryDelegationTotalRewardsRequest.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", o).then((c) => QueryDelegationTotalRewardsResponse.decode(new minimal.Reader(c)));
  }
  delegatorValidators(n) {
    const o = QueryDelegatorValidatorsRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", o).then((c) => QueryDelegatorValidatorsResponse$1.decode(new minimal.Reader(c)));
  }
  delegatorWithdrawAddress(n) {
    const o = QueryDelegatorWithdrawAddressRequest.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", o).then((c) => QueryDelegatorWithdrawAddressResponse.decode(new minimal.Reader(c)));
  }
  communityPool(n = {}) {
    const o = QueryCommunityPoolRequest.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", o).then((c) => QueryCommunityPoolResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$u = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$t(n);
  return {
    params(u) {
      return o.params(u);
    },
    validatorOutstandingRewards(u) {
      return o.validatorOutstandingRewards(u);
    },
    validatorCommission(u) {
      return o.validatorCommission(u);
    },
    validatorSlashes(u) {
      return o.validatorSlashes(u);
    },
    delegationRewards(u) {
      return o.delegationRewards(u);
    },
    delegationTotalRewards(u) {
      return o.delegationTotalRewards(u);
    },
    delegatorValidators(u) {
      return o.delegatorValidators(u);
    },
    delegatorWithdrawAddress(u) {
      return o.delegatorWithdrawAddress(u);
    },
    communityPool(u) {
      return o.communityPool(u);
    }
  };
}, _216 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$t,
  createRpcQueryExtension: createRpcQueryExtension$u
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$s = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.proposal = this.proposal.bind(this), this.proposals = this.proposals.bind(this), this.vote = this.vote.bind(this), this.votes = this.votes.bind(this), this.params = this.params.bind(this), this.deposit = this.deposit.bind(this), this.deposits = this.deposits.bind(this), this.tallyResult = this.tallyResult.bind(this);
  }
  proposal(n) {
    const o = QueryProposalRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", o).then((c) => QueryProposalResponse$1.decode(new minimal.Reader(c)));
  }
  proposals(n) {
    const o = QueryProposalsRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", o).then((c) => QueryProposalsResponse$1.decode(new minimal.Reader(c)));
  }
  vote(n) {
    const o = QueryVoteRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", o).then((c) => QueryVoteResponse$1.decode(new minimal.Reader(c)));
  }
  votes(n) {
    const o = QueryVotesRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", o).then((c) => QueryVotesResponse$1.decode(new minimal.Reader(c)));
  }
  params(n) {
    const o = QueryParamsRequest$c.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse$c.decode(new minimal.Reader(c)));
  }
  deposit(n) {
    const o = QueryDepositRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", o).then((c) => QueryDepositResponse$1.decode(new minimal.Reader(c)));
  }
  deposits(n) {
    const o = QueryDepositsRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", o).then((c) => QueryDepositsResponse$1.decode(new minimal.Reader(c)));
  }
  tallyResult(n) {
    const o = QueryTallyResultRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", o).then((c) => QueryTallyResultResponse$1.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$t = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$s(n);
  return {
    proposal(u) {
      return o.proposal(u);
    },
    proposals(u) {
      return o.proposals(u);
    },
    vote(u) {
      return o.vote(u);
    },
    votes(u) {
      return o.votes(u);
    },
    params(u) {
      return o.params(u);
    },
    deposit(u) {
      return o.deposit(u);
    },
    deposits(u) {
      return o.deposits(u);
    },
    tallyResult(u) {
      return o.tallyResult(u);
    }
  };
}, _217 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$s,
  createRpcQueryExtension: createRpcQueryExtension$t
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$r = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.validators = this.validators.bind(this), this.validator = this.validator.bind(this), this.validatorDelegations = this.validatorDelegations.bind(this), this.validatorUnbondingDelegations = this.validatorUnbondingDelegations.bind(this), this.delegation = this.delegation.bind(this), this.unbondingDelegation = this.unbondingDelegation.bind(this), this.delegatorDelegations = this.delegatorDelegations.bind(this), this.delegatorUnbondingDelegations = this.delegatorUnbondingDelegations.bind(this), this.redelegations = this.redelegations.bind(this), this.delegatorValidators = this.delegatorValidators.bind(this), this.delegatorValidator = this.delegatorValidator.bind(this), this.historicalInfo = this.historicalInfo.bind(this), this.pool = this.pool.bind(this), this.params = this.params.bind(this);
  }
  validators(n) {
    const o = QueryValidatorsRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", o).then((c) => QueryValidatorsResponse.decode(new minimal.Reader(c)));
  }
  validator(n) {
    const o = QueryValidatorRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", o).then((c) => QueryValidatorResponse.decode(new minimal.Reader(c)));
  }
  validatorDelegations(n) {
    const o = QueryValidatorDelegationsRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", o).then((c) => QueryValidatorDelegationsResponse.decode(new minimal.Reader(c)));
  }
  validatorUnbondingDelegations(n) {
    const o = QueryValidatorUnbondingDelegationsRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", o).then((c) => QueryValidatorUnbondingDelegationsResponse.decode(new minimal.Reader(c)));
  }
  delegation(n) {
    const o = QueryDelegationRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", o).then((c) => QueryDelegationResponse.decode(new minimal.Reader(c)));
  }
  unbondingDelegation(n) {
    const o = QueryUnbondingDelegationRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", o).then((c) => QueryUnbondingDelegationResponse.decode(new minimal.Reader(c)));
  }
  delegatorDelegations(n) {
    const o = QueryDelegatorDelegationsRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", o).then((c) => QueryDelegatorDelegationsResponse.decode(new minimal.Reader(c)));
  }
  delegatorUnbondingDelegations(n) {
    const o = QueryDelegatorUnbondingDelegationsRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", o).then((c) => QueryDelegatorUnbondingDelegationsResponse.decode(new minimal.Reader(c)));
  }
  redelegations(n) {
    const o = QueryRedelegationsRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", o).then((c) => QueryRedelegationsResponse.decode(new minimal.Reader(c)));
  }
  delegatorValidators(n) {
    const o = QueryDelegatorValidatorsRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", o).then((c) => QueryDelegatorValidatorsResponse.decode(new minimal.Reader(c)));
  }
  delegatorValidator(n) {
    const o = QueryDelegatorValidatorRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", o).then((c) => QueryDelegatorValidatorResponse.decode(new minimal.Reader(c)));
  }
  historicalInfo(n) {
    const o = QueryHistoricalInfoRequest.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", o).then((c) => QueryHistoricalInfoResponse.decode(new minimal.Reader(c)));
  }
  pool(n = {}) {
    const o = QueryPoolRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", o).then((c) => QueryPoolResponse$1.decode(new minimal.Reader(c)));
  }
  params(n = {}) {
    const o = QueryParamsRequest$a.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse$a.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$s = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$r(n);
  return {
    validators(u) {
      return o.validators(u);
    },
    validator(u) {
      return o.validator(u);
    },
    validatorDelegations(u) {
      return o.validatorDelegations(u);
    },
    validatorUnbondingDelegations(u) {
      return o.validatorUnbondingDelegations(u);
    },
    delegation(u) {
      return o.delegation(u);
    },
    unbondingDelegation(u) {
      return o.unbondingDelegation(u);
    },
    delegatorDelegations(u) {
      return o.delegatorDelegations(u);
    },
    delegatorUnbondingDelegations(u) {
      return o.delegatorUnbondingDelegations(u);
    },
    redelegations(u) {
      return o.redelegations(u);
    },
    delegatorValidators(u) {
      return o.delegatorValidators(u);
    },
    delegatorValidator(u) {
      return o.delegatorValidator(u);
    },
    historicalInfo(u) {
      return o.historicalInfo(u);
    },
    pool(u) {
      return o.pool(u);
    },
    params(u) {
      return o.params(u);
    }
  };
}, _218 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$r,
  createRpcQueryExtension: createRpcQueryExtension$s
}, Symbol.toStringTag, { value: "Module" }));
class ServiceClientImpl {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.simulate = this.simulate.bind(this), this.getTx = this.getTx.bind(this), this.broadcastTx = this.broadcastTx.bind(this), this.getTxsEvent = this.getTxsEvent.bind(this);
  }
  simulate(n) {
    const o = SimulateRequest.encode(n).finish();
    return this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", o).then((c) => SimulateResponse.decode(new minimal.Reader(c)));
  }
  getTx(n) {
    const o = GetTxRequest.encode(n).finish();
    return this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", o).then((c) => GetTxResponse.decode(new minimal.Reader(c)));
  }
  broadcastTx(n) {
    const o = BroadcastTxRequest.encode(n).finish();
    return this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", o).then((c) => BroadcastTxResponse.decode(new minimal.Reader(c)));
  }
  getTxsEvent(n) {
    const o = GetTxsEventRequest.encode(n).finish();
    return this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", o).then((c) => GetTxsEventResponse.decode(new minimal.Reader(c)));
  }
}
const createRpcQueryExtension$r = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new ServiceClientImpl(n);
  return {
    simulate(u) {
      return o.simulate(u);
    },
    getTx(u) {
      return o.getTx(u);
    },
    broadcastTx(u) {
      return o.broadcastTx(u);
    },
    getTxsEvent(u) {
      return o.getTxsEvent(u);
    }
  };
}, _219 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ServiceClientImpl,
  createRpcQueryExtension: createRpcQueryExtension$r
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$q = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.currentPlan = this.currentPlan.bind(this), this.appliedPlan = this.appliedPlan.bind(this), this.upgradedConsensusState = this.upgradedConsensusState.bind(this), this.moduleVersions = this.moduleVersions.bind(this);
  }
  currentPlan(n = {}) {
    const o = QueryCurrentPlanRequest.encode(n).finish();
    return this.rpc.request("cosmos.upgrade.v1beta1.Query", "CurrentPlan", o).then((c) => QueryCurrentPlanResponse.decode(new minimal.Reader(c)));
  }
  appliedPlan(n) {
    const o = QueryAppliedPlanRequest.encode(n).finish();
    return this.rpc.request("cosmos.upgrade.v1beta1.Query", "AppliedPlan", o).then((c) => QueryAppliedPlanResponse.decode(new minimal.Reader(c)));
  }
  upgradedConsensusState(n) {
    const o = QueryUpgradedConsensusStateRequest$1.encode(n).finish();
    return this.rpc.request("cosmos.upgrade.v1beta1.Query", "UpgradedConsensusState", o).then((c) => QueryUpgradedConsensusStateResponse$1.decode(new minimal.Reader(c)));
  }
  moduleVersions(n) {
    const o = QueryModuleVersionsRequest.encode(n).finish();
    return this.rpc.request("cosmos.upgrade.v1beta1.Query", "ModuleVersions", o).then((c) => QueryModuleVersionsResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$q = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$q(n);
  return {
    currentPlan(u) {
      return o.currentPlan(u);
    },
    appliedPlan(u) {
      return o.appliedPlan(u);
    },
    upgradedConsensusState(u) {
      return o.upgradedConsensusState(u);
    },
    moduleVersions(u) {
      return o.moduleVersions(u);
    }
  };
}, _220 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$q,
  createRpcQueryExtension: createRpcQueryExtension$q
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$p = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.proposal = this.proposal.bind(this), this.proposals = this.proposals.bind(this), this.vote = this.vote.bind(this), this.votes = this.votes.bind(this), this.params = this.params.bind(this), this.deposit = this.deposit.bind(this), this.deposits = this.deposits.bind(this), this.tallyResult = this.tallyResult.bind(this);
  }
  proposal(n) {
    const o = QueryProposalRequest.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Query", "Proposal", o).then((c) => QueryProposalResponse.decode(new minimal.Reader(c)));
  }
  proposals(n) {
    const o = QueryProposalsRequest.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Query", "Proposals", o).then((c) => QueryProposalsResponse.decode(new minimal.Reader(c)));
  }
  vote(n) {
    const o = QueryVoteRequest.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Query", "Vote", o).then((c) => QueryVoteResponse.decode(new minimal.Reader(c)));
  }
  votes(n) {
    const o = QueryVotesRequest.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Query", "Votes", o).then((c) => QueryVotesResponse.decode(new minimal.Reader(c)));
  }
  params(n) {
    const o = QueryParamsRequest$b.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Query", "Params", o).then((c) => QueryParamsResponse$b.decode(new minimal.Reader(c)));
  }
  deposit(n) {
    const o = QueryDepositRequest.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Query", "Deposit", o).then((c) => QueryDepositResponse.decode(new minimal.Reader(c)));
  }
  deposits(n) {
    const o = QueryDepositsRequest.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Query", "Deposits", o).then((c) => QueryDepositsResponse.decode(new minimal.Reader(c)));
  }
  tallyResult(n) {
    const o = QueryTallyResultRequest.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Query", "TallyResult", o).then((c) => QueryTallyResultResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$p = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$p(n);
  return {
    proposal(u) {
      return o.proposal(u);
    },
    proposals(u) {
      return o.proposals(u);
    },
    vote(u) {
      return o.vote(u);
    },
    votes(u) {
      return o.votes(u);
    },
    params(u) {
      return o.params(u);
    },
    deposit(u) {
      return o.deposit(u);
    },
    deposits(u) {
      return o.deposits(u);
    },
    tallyResult(u) {
      return o.tallyResult(u);
    }
  };
}, _221 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$p,
  createRpcQueryExtension: createRpcQueryExtension$p
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$n = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.grant = this.grant.bind(this), this.exec = this.exec.bind(this), this.revoke = this.revoke.bind(this);
  }
  grant(n) {
    const o = MsgGrant.encode(n).finish();
    return this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", o).then((c) => MsgGrantResponse.decode(new minimal.Reader(c)));
  }
  exec(n) {
    const o = MsgExec.encode(n).finish();
    return this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", o).then((c) => MsgExecResponse.decode(new minimal.Reader(c)));
  }
  revoke(n) {
    const o = MsgRevoke.encode(n).finish();
    return this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", o).then((c) => MsgRevokeResponse.decode(new minimal.Reader(c)));
  }
};
const _222 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$n
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$m = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.send = this.send.bind(this), this.multiSend = this.multiSend.bind(this);
  }
  send(n) {
    const o = MsgSend.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", o).then((c) => MsgSendResponse.decode(new minimal.Reader(c)));
  }
  multiSend(n) {
    const o = MsgMultiSend.encode(n).finish();
    return this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", o).then((c) => MsgMultiSendResponse.decode(new minimal.Reader(c)));
  }
};
const _223 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$m
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$l = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.setWithdrawAddress = this.setWithdrawAddress.bind(this), this.withdrawDelegatorReward = this.withdrawDelegatorReward.bind(this), this.withdrawValidatorCommission = this.withdrawValidatorCommission.bind(this), this.fundCommunityPool = this.fundCommunityPool.bind(this);
  }
  setWithdrawAddress(n) {
    const o = MsgSetWithdrawAddress.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", o).then((c) => MsgSetWithdrawAddressResponse.decode(new minimal.Reader(c)));
  }
  withdrawDelegatorReward(n) {
    const o = MsgWithdrawDelegatorReward.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", o).then((c) => MsgWithdrawDelegatorRewardResponse.decode(new minimal.Reader(c)));
  }
  withdrawValidatorCommission(n) {
    const o = MsgWithdrawValidatorCommission.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", o).then((c) => MsgWithdrawValidatorCommissionResponse.decode(new minimal.Reader(c)));
  }
  fundCommunityPool(n) {
    const o = MsgFundCommunityPool.encode(n).finish();
    return this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", o).then((c) => MsgFundCommunityPoolResponse.decode(new minimal.Reader(c)));
  }
};
const _224 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$l
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$k = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.submitProposal = this.submitProposal.bind(this), this.vote = this.vote.bind(this), this.voteWeighted = this.voteWeighted.bind(this), this.deposit = this.deposit.bind(this);
  }
  submitProposal(n) {
    const o = MsgSubmitProposal$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", o).then((c) => MsgSubmitProposalResponse$1.decode(new minimal.Reader(c)));
  }
  vote(n) {
    const o = MsgVote$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", o).then((c) => MsgVoteResponse$1.decode(new minimal.Reader(c)));
  }
  voteWeighted(n) {
    const o = MsgVoteWeighted$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", o).then((c) => MsgVoteWeightedResponse$1.decode(new minimal.Reader(c)));
  }
  deposit(n) {
    const o = MsgDeposit$1.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", o).then((c) => MsgDepositResponse$1.decode(new minimal.Reader(c)));
  }
};
const _225 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$k
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$j = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.createValidator = this.createValidator.bind(this), this.editValidator = this.editValidator.bind(this), this.delegate = this.delegate.bind(this), this.beginRedelegate = this.beginRedelegate.bind(this), this.undelegate = this.undelegate.bind(this);
  }
  createValidator(n) {
    const o = MsgCreateValidator.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", o).then((c) => MsgCreateValidatorResponse.decode(new minimal.Reader(c)));
  }
  editValidator(n) {
    const o = MsgEditValidator.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", o).then((c) => MsgEditValidatorResponse.decode(new minimal.Reader(c)));
  }
  delegate(n) {
    const o = MsgDelegate.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", o).then((c) => MsgDelegateResponse.decode(new minimal.Reader(c)));
  }
  beginRedelegate(n) {
    const o = MsgBeginRedelegate.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", o).then((c) => MsgBeginRedelegateResponse.decode(new minimal.Reader(c)));
  }
  undelegate(n) {
    const o = MsgUndelegate.encode(n).finish();
    return this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", o).then((c) => MsgUndelegateResponse.decode(new minimal.Reader(c)));
  }
};
const _226 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$j
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$i = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.submitProposal = this.submitProposal.bind(this), this.execLegacyContent = this.execLegacyContent.bind(this), this.vote = this.vote.bind(this), this.voteWeighted = this.voteWeighted.bind(this), this.deposit = this.deposit.bind(this);
  }
  submitProposal(n) {
    const o = MsgSubmitProposal.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Msg", "SubmitProposal", o).then((c) => MsgSubmitProposalResponse.decode(new minimal.Reader(c)));
  }
  execLegacyContent(n) {
    const o = MsgExecLegacyContent.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Msg", "ExecLegacyContent", o).then((c) => MsgExecLegacyContentResponse.decode(new minimal.Reader(c)));
  }
  vote(n) {
    const o = MsgVote.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Msg", "Vote", o).then((c) => MsgVoteResponse.decode(new minimal.Reader(c)));
  }
  voteWeighted(n) {
    const o = MsgVoteWeighted.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Msg", "VoteWeighted", o).then((c) => MsgVoteWeightedResponse.decode(new minimal.Reader(c)));
  }
  deposit(n) {
    const o = MsgDeposit.encode(n).finish();
    return this.rpc.request("cosmos.gov.v1.Msg", "Deposit", o).then((c) => MsgDepositResponse.decode(new minimal.Reader(c)));
  }
};
const _227 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$i
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$h = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.softwareUpgrade = this.softwareUpgrade.bind(this), this.cancelUpgrade = this.cancelUpgrade.bind(this);
  }
  softwareUpgrade(n) {
    const o = MsgSoftwareUpgrade.encode(n).finish();
    return this.rpc.request("cosmos.upgrade.v1beta1.Msg", "SoftwareUpgrade", o).then((c) => MsgSoftwareUpgradeResponse.decode(new minimal.Reader(c)));
  }
  cancelUpgrade(n) {
    const o = MsgCancelUpgrade.encode(n).finish();
    return this.rpc.request("cosmos.upgrade.v1beta1.Msg", "CancelUpgrade", o).then((c) => MsgCancelUpgradeResponse.decode(new minimal.Reader(c)));
  }
};
const _228 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$h
}, Symbol.toStringTag, { value: "Module" }));
var axios$3 = { exports: {} }, bind$2 = function e(n, o) {
  return function() {
    for (var c = new Array(arguments.length), d = 0; d < c.length; d++)
      c[d] = arguments[d];
    return n.apply(o, c);
  };
}, bind$1 = bind$2, toString = Object.prototype.toString, kindOf = function(e) {
  return function(n) {
    var o = toString.call(n);
    return e[o] || (e[o] = o.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function kindOfTest(e) {
  return e = e.toLowerCase(), function(o) {
    return kindOf(o) === e;
  };
}
function isArray(e) {
  return Array.isArray(e);
}
function isUndefined(e) {
  return typeof e > "u";
}
function isBuffer(e) {
  return e !== null && !isUndefined(e) && e.constructor !== null && !isUndefined(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
var isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(e) {
  var n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && isArrayBuffer(e.buffer), n;
}
function isString(e) {
  return typeof e == "string";
}
function isNumber(e) {
  return typeof e == "number";
}
function isObject(e) {
  return e !== null && typeof e == "object";
}
function isPlainObject(e) {
  if (kindOf(e) !== "object")
    return !1;
  var n = Object.getPrototypeOf(e);
  return n === null || n === Object.prototype;
}
var isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList");
function isFunction(e) {
  return toString.call(e) === "[object Function]";
}
function isStream(e) {
  return isObject(e) && isFunction(e.pipe);
}
function isFormData(e) {
  var n = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || toString.call(e) === n || isFunction(e.toString) && e.toString() === n);
}
var isURLSearchParams = kindOfTest("URLSearchParams");
function trim(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach(e, n) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), isArray(e))
      for (var o = 0, u = e.length; o < u; o++)
        n.call(null, e[o], o, e);
    else
      for (var c in e)
        Object.prototype.hasOwnProperty.call(e, c) && n.call(null, e[c], c, e);
}
function merge() {
  var e = {};
  function n(c, d) {
    isPlainObject(e[d]) && isPlainObject(c) ? e[d] = merge(e[d], c) : isPlainObject(c) ? e[d] = merge({}, c) : isArray(c) ? e[d] = c.slice() : e[d] = c;
  }
  for (var o = 0, u = arguments.length; o < u; o++)
    forEach(arguments[o], n);
  return e;
}
function extend(e, n, o) {
  return forEach(n, function(c, d) {
    o && typeof c == "function" ? e[d] = bind$1(c, o) : e[d] = c;
  }), e;
}
function stripBOM(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
function inherits(e, n, o, u) {
  e.prototype = Object.create(n.prototype, u), e.prototype.constructor = e, o && Object.assign(e.prototype, o);
}
function toFlatObject(e, n, o) {
  var u, c, d, m = {};
  n = n || {};
  do {
    for (u = Object.getOwnPropertyNames(e), c = u.length; c-- > 0; )
      d = u[c], m[d] || (n[d] = e[d], m[d] = !0);
    e = Object.getPrototypeOf(e);
  } while (e && (!o || o(e, n)) && e !== Object.prototype);
  return n;
}
function endsWith(e, n, o) {
  e = String(e), (o === void 0 || o > e.length) && (o = e.length), o -= n.length;
  var u = e.indexOf(n, o);
  return u !== -1 && u === o;
}
function toArray(e) {
  if (!e)
    return null;
  var n = e.length;
  if (isUndefined(n))
    return null;
  for (var o = new Array(n); n-- > 0; )
    o[n] = e[n];
  return o;
}
var isTypedArray = function(e) {
  return function(n) {
    return e && n instanceof e;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), utils$b = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  isTypedArray,
  isFileList
}, utils$a = utils$b;
function encode(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function e(n, o, u) {
  if (!o)
    return n;
  var c;
  if (u)
    c = u(o);
  else if (utils$a.isURLSearchParams(o))
    c = o.toString();
  else {
    var d = [];
    utils$a.forEach(o, function(S, $) {
      S === null || typeof S > "u" || (utils$a.isArray(S) ? $ = $ + "[]" : S = [S], utils$a.forEach(S, function(O) {
        utils$a.isDate(O) ? O = O.toISOString() : utils$a.isObject(O) && (O = JSON.stringify(O)), d.push(encode($) + "=" + encode(O));
      }));
    }), c = d.join("&");
  }
  if (c) {
    var m = n.indexOf("#");
    m !== -1 && (n = n.slice(0, m)), n += (n.indexOf("?") === -1 ? "?" : "&") + c;
  }
  return n;
}, utils$9 = utils$b;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function e(n, o, u) {
  return this.handlers.push({
    fulfilled: n,
    rejected: o,
    synchronous: u ? u.synchronous : !1,
    runWhen: u ? u.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function e(n) {
  this.handlers[n] && (this.handlers[n] = null);
};
InterceptorManager$1.prototype.forEach = function e(n) {
  utils$9.forEach(this.handlers, function(u) {
    u !== null && n(u);
  });
};
var InterceptorManager_1 = InterceptorManager$1, utils$8 = utils$b, normalizeHeaderName$1 = function e(n, o) {
  utils$8.forEach(n, function(c, d) {
    d !== o && d.toUpperCase() === o.toUpperCase() && (n[o] = c, delete n[d]);
  });
}, utils$7 = utils$b;
function AxiosError$2(e, n, o, u, c) {
  Error.call(this), this.message = e, this.name = "AxiosError", n && (this.code = n), o && (this.config = o), u && (this.request = u), c && (this.response = c);
}
utils$7.inherits(AxiosError$2, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var prototype = AxiosError$2.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(e) {
  descriptors[e] = { value: e };
});
Object.defineProperties(AxiosError$2, descriptors);
Object.defineProperty(prototype, "isAxiosError", { value: !0 });
AxiosError$2.from = function(e, n, o, u, c, d) {
  var m = Object.create(prototype);
  return utils$7.toFlatObject(e, m, function(S) {
    return S !== Error.prototype;
  }), AxiosError$2.call(m, e.message, n, o, u, c), m.name = e.name, d && Object.assign(m, d), m;
};
var AxiosError_1 = AxiosError$2, transitional = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, utils$6 = utils$b;
function toFormData$1(e, n) {
  n = n || new FormData();
  var o = [];
  function u(d) {
    return d === null ? "" : utils$6.isDate(d) ? d.toISOString() : utils$6.isArrayBuffer(d) || utils$6.isTypedArray(d) ? typeof Blob == "function" ? new Blob([d]) : Buffer.from(d) : d;
  }
  function c(d, m) {
    if (utils$6.isPlainObject(d) || utils$6.isArray(d)) {
      if (o.indexOf(d) !== -1)
        throw Error("Circular reference detected in " + m);
      o.push(d), utils$6.forEach(d, function(S, $) {
        if (!utils$6.isUndefined(S)) {
          var E = m ? m + "." + $ : $, O;
          if (S && !m && typeof S == "object") {
            if (utils$6.endsWith($, "{}"))
              S = JSON.stringify(S);
            else if (utils$6.endsWith($, "[]") && (O = utils$6.toArray(S))) {
              O.forEach(function(T) {
                !utils$6.isUndefined(T) && n.append(E, u(T));
              });
              return;
            }
          }
          c(S, E);
        }
      }), o.pop();
    } else
      n.append(m, u(d));
  }
  return c(e), n;
}
var toFormData_1 = toFormData$1, settle, hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle;
  hasRequiredSettle = 1;
  var e = AxiosError_1;
  return settle = function(o, u, c) {
    var d = c.config.validateStatus;
    !c.status || !d || d(c.status) ? o(c) : u(new e(
      "Request failed with status code " + c.status,
      [e.ERR_BAD_REQUEST, e.ERR_BAD_RESPONSE][Math.floor(c.status / 100) - 4],
      c.config,
      c.request,
      c
    ));
  }, settle;
}
var cookies, hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies;
  hasRequiredCookies = 1;
  var e = utils$b;
  return cookies = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(u, c, d, m, v, S) {
          var $ = [];
          $.push(u + "=" + encodeURIComponent(c)), e.isNumber(d) && $.push("expires=" + new Date(d).toGMTString()), e.isString(m) && $.push("path=" + m), e.isString(v) && $.push("domain=" + v), S === !0 && $.push("secure"), document.cookie = $.join("; ");
        },
        read: function(u) {
          var c = document.cookie.match(new RegExp("(^|;\\s*)(" + u + ")=([^;]*)"));
          return c ? decodeURIComponent(c[3]) : null;
        },
        remove: function(u) {
          this.write(u, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies;
}
var isAbsoluteURL$1 = function e(n) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(n);
}, combineURLs$1 = function e(n, o) {
  return o ? n.replace(/\/+$/, "") + "/" + o.replace(/^\/+/, "") : n;
}, isAbsoluteURL = isAbsoluteURL$1, combineURLs = combineURLs$1, buildFullPath$1 = function e(n, o) {
  return n && !isAbsoluteURL(o) ? combineURLs(n, o) : o;
}, parseHeaders, hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders;
  hasRequiredParseHeaders = 1;
  var e = utils$b, n = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders = function(u) {
    var c = {}, d, m, v;
    return u && e.forEach(u.split(`
`), function($) {
      if (v = $.indexOf(":"), d = e.trim($.substr(0, v)).toLowerCase(), m = e.trim($.substr(v + 1)), d) {
        if (c[d] && n.indexOf(d) >= 0)
          return;
        d === "set-cookie" ? c[d] = (c[d] ? c[d] : []).concat([m]) : c[d] = c[d] ? c[d] + ", " + m : m;
      }
    }), c;
  }, parseHeaders;
}
var isURLSameOrigin, hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var e = utils$b;
  return isURLSameOrigin = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var o = /(msie|trident)/i.test(navigator.userAgent), u = document.createElement("a"), c;
      function d(m) {
        var v = m;
        return o && (u.setAttribute("href", v), v = u.href), u.setAttribute("href", v), {
          href: u.href,
          protocol: u.protocol ? u.protocol.replace(/:$/, "") : "",
          host: u.host,
          search: u.search ? u.search.replace(/^\?/, "") : "",
          hash: u.hash ? u.hash.replace(/^#/, "") : "",
          hostname: u.hostname,
          port: u.port,
          pathname: u.pathname.charAt(0) === "/" ? u.pathname : "/" + u.pathname
        };
      }
      return c = d(window.location.href), function(v) {
        var S = e.isString(v) ? d(v) : v;
        return S.protocol === c.protocol && S.host === c.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin;
}
var CanceledError_1, hasRequiredCanceledError;
function requireCanceledError() {
  if (hasRequiredCanceledError)
    return CanceledError_1;
  hasRequiredCanceledError = 1;
  var e = AxiosError_1, n = utils$b;
  function o(u) {
    e.call(this, u ?? "canceled", e.ERR_CANCELED), this.name = "CanceledError";
  }
  return n.inherits(o, e, {
    __CANCEL__: !0
  }), CanceledError_1 = o, CanceledError_1;
}
var parseProtocol, hasRequiredParseProtocol;
function requireParseProtocol() {
  return hasRequiredParseProtocol || (hasRequiredParseProtocol = 1, parseProtocol = function(n) {
    var o = /^([-+\w]{1,25})(:?\/\/|:)/.exec(n);
    return o && o[1] || "";
  }), parseProtocol;
}
var xhr, hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var e = utils$b, n = requireSettle(), o = requireCookies(), u = buildURL$1, c = buildFullPath$1, d = requireParseHeaders(), m = requireIsURLSameOrigin(), v = transitional, S = AxiosError_1, $ = requireCanceledError(), E = requireParseProtocol();
  return xhr = function(T) {
    return new Promise(function(V, M) {
      var G = T.data, k = T.headers, F = T.responseType, X;
      function ee() {
        T.cancelToken && T.cancelToken.unsubscribe(X), T.signal && T.signal.removeEventListener("abort", X);
      }
      e.isFormData(G) && e.isStandardBrowserEnv() && delete k["Content-Type"];
      var ue = new XMLHttpRequest();
      if (T.auth) {
        var Q = T.auth.username || "", Y = T.auth.password ? unescape(encodeURIComponent(T.auth.password)) : "";
        k.Authorization = "Basic " + btoa(Q + ":" + Y);
      }
      var pe = c(T.baseURL, T.url);
      ue.open(T.method.toUpperCase(), u(pe, T.params, T.paramsSerializer), !0), ue.timeout = T.timeout;
      function oe() {
        if (ue) {
          var C = "getAllResponseHeaders" in ue ? d(ue.getAllResponseHeaders()) : null, w = !F || F === "text" || F === "json" ? ue.responseText : ue.response, P = {
            data: w,
            status: ue.status,
            statusText: ue.statusText,
            headers: C,
            config: T,
            request: ue
          };
          n(function(se) {
            V(se), ee();
          }, function(se) {
            M(se), ee();
          }, P), ue = null;
        }
      }
      if ("onloadend" in ue ? ue.onloadend = oe : ue.onreadystatechange = function() {
        !ue || ue.readyState !== 4 || ue.status === 0 && !(ue.responseURL && ue.responseURL.indexOf("file:") === 0) || setTimeout(oe);
      }, ue.onabort = function() {
        ue && (M(new S("Request aborted", S.ECONNABORTED, T, ue)), ue = null);
      }, ue.onerror = function() {
        M(new S("Network Error", S.ERR_NETWORK, T, ue, ue)), ue = null;
      }, ue.ontimeout = function() {
        var w = T.timeout ? "timeout of " + T.timeout + "ms exceeded" : "timeout exceeded", P = T.transitional || v;
        T.timeoutErrorMessage && (w = T.timeoutErrorMessage), M(new S(
          w,
          P.clarifyTimeoutError ? S.ETIMEDOUT : S.ECONNABORTED,
          T,
          ue
        )), ue = null;
      }, e.isStandardBrowserEnv()) {
        var ne = (T.withCredentials || m(pe)) && T.xsrfCookieName ? o.read(T.xsrfCookieName) : void 0;
        ne && (k[T.xsrfHeaderName] = ne);
      }
      "setRequestHeader" in ue && e.forEach(k, function(w, P) {
        typeof G > "u" && P.toLowerCase() === "content-type" ? delete k[P] : ue.setRequestHeader(P, w);
      }), e.isUndefined(T.withCredentials) || (ue.withCredentials = !!T.withCredentials), F && F !== "json" && (ue.responseType = T.responseType), typeof T.onDownloadProgress == "function" && ue.addEventListener("progress", T.onDownloadProgress), typeof T.onUploadProgress == "function" && ue.upload && ue.upload.addEventListener("progress", T.onUploadProgress), (T.cancelToken || T.signal) && (X = function(C) {
        ue && (M(!C || C && C.type ? new $() : C), ue.abort(), ue = null);
      }, T.cancelToken && T.cancelToken.subscribe(X), T.signal && (T.signal.aborted ? X() : T.signal.addEventListener("abort", X))), G || (G = null);
      var H = E(pe);
      if (H && ["http", "https", "file"].indexOf(H) === -1) {
        M(new S("Unsupported protocol " + H + ":", S.ERR_BAD_REQUEST, T));
        return;
      }
      ue.send(G);
    });
  }, xhr;
}
var _null, hasRequired_null;
function require_null() {
  return hasRequired_null || (hasRequired_null = 1, _null = null), _null;
}
var utils$5 = utils$b, normalizeHeaderName = normalizeHeaderName$1, AxiosError$1 = AxiosError_1, transitionalDefaults = transitional, toFormData = toFormData_1, DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(e, n) {
  !utils$5.isUndefined(e) && utils$5.isUndefined(e["Content-Type"]) && (e["Content-Type"] = n);
}
function getDefaultAdapter() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof browser$1$1 < "u" && Object.prototype.toString.call(browser$1$1) === "[object process]") && (e = requireXhr()), e;
}
function stringifySafely(e, n, o) {
  if (utils$5.isString(e))
    try {
      return (n || JSON.parse)(e), utils$5.trim(e);
    } catch (u) {
      if (u.name !== "SyntaxError")
        throw u;
    }
  return (o || JSON.stringify)(e);
}
var defaults$3 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function e(n, o) {
    if (normalizeHeaderName(o, "Accept"), normalizeHeaderName(o, "Content-Type"), utils$5.isFormData(n) || utils$5.isArrayBuffer(n) || utils$5.isBuffer(n) || utils$5.isStream(n) || utils$5.isFile(n) || utils$5.isBlob(n))
      return n;
    if (utils$5.isArrayBufferView(n))
      return n.buffer;
    if (utils$5.isURLSearchParams(n))
      return setContentTypeIfUnset(o, "application/x-www-form-urlencoded;charset=utf-8"), n.toString();
    var u = utils$5.isObject(n), c = o && o["Content-Type"], d;
    if ((d = utils$5.isFileList(n)) || u && c === "multipart/form-data") {
      var m = this.env && this.env.FormData;
      return toFormData(d ? { "files[]": n } : n, m && new m());
    } else if (u || c === "application/json")
      return setContentTypeIfUnset(o, "application/json"), stringifySafely(n);
    return n;
  }],
  transformResponse: [function e(n) {
    var o = this.transitional || defaults$3.transitional, u = o && o.silentJSONParsing, c = o && o.forcedJSONParsing, d = !u && this.responseType === "json";
    if (d || c && utils$5.isString(n) && n.length)
      try {
        return JSON.parse(n);
      } catch (m) {
        if (d)
          throw m.name === "SyntaxError" ? AxiosError$1.from(m, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response) : m;
      }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: require_null()
  },
  validateStatus: function e(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
utils$5.forEach(["delete", "get", "head"], function e(n) {
  defaults$3.headers[n] = {};
});
utils$5.forEach(["post", "put", "patch"], function e(n) {
  defaults$3.headers[n] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3, utils$4 = utils$b, defaults$2 = defaults_1, transformData$1 = function e(n, o, u) {
  var c = this || defaults$2;
  return utils$4.forEach(u, function(m) {
    n = m.call(c, n, o);
  }), n;
}, isCancel$1, hasRequiredIsCancel;
function requireIsCancel() {
  return hasRequiredIsCancel || (hasRequiredIsCancel = 1, isCancel$1 = function(n) {
    return !!(n && n.__CANCEL__);
  }), isCancel$1;
}
var utils$3 = utils$b, transformData = transformData$1, isCancel = requireIsCancel(), defaults$1 = defaults_1, CanceledError = requireCanceledError();
function throwIfCancellationRequested(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError();
}
var dispatchRequest$1 = function e(n) {
  throwIfCancellationRequested(n), n.headers = n.headers || {}, n.data = transformData.call(
    n,
    n.data,
    n.headers,
    n.transformRequest
  ), n.headers = utils$3.merge(
    n.headers.common || {},
    n.headers[n.method] || {},
    n.headers
  ), utils$3.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(c) {
      delete n.headers[c];
    }
  );
  var o = n.adapter || defaults$1.adapter;
  return o(n).then(function(c) {
    return throwIfCancellationRequested(n), c.data = transformData.call(
      n,
      c.data,
      c.headers,
      n.transformResponse
    ), c;
  }, function(c) {
    return isCancel(c) || (throwIfCancellationRequested(n), c && c.response && (c.response.data = transformData.call(
      n,
      c.response.data,
      c.response.headers,
      n.transformResponse
    ))), Promise.reject(c);
  });
}, utils$2 = utils$b, mergeConfig$2 = function e(n, o) {
  o = o || {};
  var u = {};
  function c(E, O) {
    return utils$2.isPlainObject(E) && utils$2.isPlainObject(O) ? utils$2.merge(E, O) : utils$2.isPlainObject(O) ? utils$2.merge({}, O) : utils$2.isArray(O) ? O.slice() : O;
  }
  function d(E) {
    if (utils$2.isUndefined(o[E])) {
      if (!utils$2.isUndefined(n[E]))
        return c(void 0, n[E]);
    } else
      return c(n[E], o[E]);
  }
  function m(E) {
    if (!utils$2.isUndefined(o[E]))
      return c(void 0, o[E]);
  }
  function v(E) {
    if (utils$2.isUndefined(o[E])) {
      if (!utils$2.isUndefined(n[E]))
        return c(void 0, n[E]);
    } else
      return c(void 0, o[E]);
  }
  function S(E) {
    if (E in o)
      return c(n[E], o[E]);
    if (E in n)
      return c(void 0, n[E]);
  }
  var $ = {
    url: m,
    method: m,
    data: m,
    baseURL: v,
    transformRequest: v,
    transformResponse: v,
    paramsSerializer: v,
    timeout: v,
    timeoutMessage: v,
    withCredentials: v,
    adapter: v,
    responseType: v,
    xsrfCookieName: v,
    xsrfHeaderName: v,
    onUploadProgress: v,
    onDownloadProgress: v,
    decompress: v,
    maxContentLength: v,
    maxBodyLength: v,
    beforeRedirect: v,
    transport: v,
    httpAgent: v,
    httpsAgent: v,
    cancelToken: v,
    socketPath: v,
    responseEncoding: v,
    validateStatus: S
  };
  return utils$2.forEach(Object.keys(n).concat(Object.keys(o)), function(O) {
    var T = $[O] || d, y = T(O);
    utils$2.isUndefined(y) && T !== S || (u[O] = y);
  }), u;
}, data, hasRequiredData;
function requireData() {
  return hasRequiredData || (hasRequiredData = 1, data = {
    version: "0.27.2"
  }), data;
}
var VERSION = requireData().version, AxiosError = AxiosError_1, validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, n) {
  validators$1[e] = function(u) {
    return typeof u === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function e(n, o, u) {
  function c(d, m) {
    return "[Axios v" + VERSION + "] Transitional option '" + d + "'" + m + (u ? ". " + u : "");
  }
  return function(d, m, v) {
    if (n === !1)
      throw new AxiosError(
        c(m, " has been removed" + (o ? " in " + o : "")),
        AxiosError.ERR_DEPRECATED
      );
    return o && !deprecatedWarnings[m] && (deprecatedWarnings[m] = !0, console.warn(
      c(
        m,
        " has been deprecated since v" + o + " and will be removed in the near future"
      )
    )), n ? n(d, m, v) : !0;
  };
};
function assertOptions(e, n, o) {
  if (typeof e != "object")
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  for (var u = Object.keys(e), c = u.length; c-- > 0; ) {
    var d = u[c], m = n[d];
    if (m) {
      var v = e[d], S = v === void 0 || m(v, d, e);
      if (S !== !0)
        throw new AxiosError("option " + d + " must be " + S, AxiosError.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (o !== !0)
      throw new AxiosError("Unknown option " + d, AxiosError.ERR_BAD_OPTION);
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
}, utils$1 = utils$b, buildURL = buildURL$1, InterceptorManager = InterceptorManager_1, dispatchRequest = dispatchRequest$1, mergeConfig$1 = mergeConfig$2, buildFullPath = buildFullPath$1, validator = validator$1, validators = validator.validators;
function Axios$1(e) {
  this.defaults = e, this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function e(n, o) {
  typeof n == "string" ? (o = o || {}, o.url = n) : o = n || {}, o = mergeConfig$1(this.defaults, o), o.method ? o.method = o.method.toLowerCase() : this.defaults.method ? o.method = this.defaults.method.toLowerCase() : o.method = "get";
  var u = o.transitional;
  u !== void 0 && validator.assertOptions(u, {
    silentJSONParsing: validators.transitional(validators.boolean),
    forcedJSONParsing: validators.transitional(validators.boolean),
    clarifyTimeoutError: validators.transitional(validators.boolean)
  }, !1);
  var c = [], d = !0;
  this.interceptors.request.forEach(function(y) {
    typeof y.runWhen == "function" && y.runWhen(o) === !1 || (d = d && y.synchronous, c.unshift(y.fulfilled, y.rejected));
  });
  var m = [];
  this.interceptors.response.forEach(function(y) {
    m.push(y.fulfilled, y.rejected);
  });
  var v;
  if (!d) {
    var S = [dispatchRequest, void 0];
    for (Array.prototype.unshift.apply(S, c), S = S.concat(m), v = Promise.resolve(o); S.length; )
      v = v.then(S.shift(), S.shift());
    return v;
  }
  for (var $ = o; c.length; ) {
    var E = c.shift(), O = c.shift();
    try {
      $ = E($);
    } catch (T) {
      O(T);
      break;
    }
  }
  try {
    v = dispatchRequest($);
  } catch (T) {
    return Promise.reject(T);
  }
  for (; m.length; )
    v = v.then(m.shift(), m.shift());
  return v;
};
Axios$1.prototype.getUri = function e(n) {
  n = mergeConfig$1(this.defaults, n);
  var o = buildFullPath(n.baseURL, n.url);
  return buildURL(o, n.params, n.paramsSerializer);
};
utils$1.forEach(["delete", "get", "head", "options"], function e(n) {
  Axios$1.prototype[n] = function(o, u) {
    return this.request(mergeConfig$1(u || {}, {
      method: n,
      url: o,
      data: (u || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function e(n) {
  function o(u) {
    return function(d, m, v) {
      return this.request(mergeConfig$1(v || {}, {
        method: n,
        headers: u ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: d,
        data: m
      }));
    };
  }
  Axios$1.prototype[n] = o(), Axios$1.prototype[n + "Form"] = o(!0);
});
var Axios_1 = Axios$1, CancelToken_1, hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var e = requireCanceledError();
  function n(o) {
    if (typeof o != "function")
      throw new TypeError("executor must be a function.");
    var u;
    this.promise = new Promise(function(m) {
      u = m;
    });
    var c = this;
    this.promise.then(function(d) {
      if (c._listeners) {
        var m, v = c._listeners.length;
        for (m = 0; m < v; m++)
          c._listeners[m](d);
        c._listeners = null;
      }
    }), this.promise.then = function(d) {
      var m, v = new Promise(function(S) {
        c.subscribe(S), m = S;
      }).then(d);
      return v.cancel = function() {
        c.unsubscribe(m);
      }, v;
    }, o(function(m) {
      c.reason || (c.reason = new e(m), u(c.reason));
    });
  }
  return n.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, n.prototype.subscribe = function(u) {
    if (this.reason) {
      u(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(u) : this._listeners = [u];
  }, n.prototype.unsubscribe = function(u) {
    if (this._listeners) {
      var c = this._listeners.indexOf(u);
      c !== -1 && this._listeners.splice(c, 1);
    }
  }, n.source = function() {
    var u, c = new n(function(m) {
      u = m;
    });
    return {
      token: c,
      cancel: u
    };
  }, CancelToken_1 = n, CancelToken_1;
}
var spread, hasRequiredSpread;
function requireSpread() {
  return hasRequiredSpread || (hasRequiredSpread = 1, spread = function(n) {
    return function(u) {
      return n.apply(null, u);
    };
  }), spread;
}
var isAxiosError, hasRequiredIsAxiosError;
function requireIsAxiosError() {
  if (hasRequiredIsAxiosError)
    return isAxiosError;
  hasRequiredIsAxiosError = 1;
  var e = utils$b;
  return isAxiosError = function(o) {
    return e.isObject(o) && o.isAxiosError === !0;
  }, isAxiosError;
}
var utils = utils$b, bind = bind$2, Axios = Axios_1, mergeConfig = mergeConfig$2, defaults = defaults_1;
function createInstance(e) {
  var n = new Axios(e), o = bind(Axios.prototype.request, n);
  return utils.extend(o, Axios.prototype, n), utils.extend(o, n), o.create = function(c) {
    return createInstance(mergeConfig(e, c));
  }, o;
}
var axios$2 = createInstance(defaults);
axios$2.Axios = Axios;
axios$2.CanceledError = requireCanceledError();
axios$2.CancelToken = requireCancelToken();
axios$2.isCancel = requireIsCancel();
axios$2.VERSION = requireData().version;
axios$2.toFormData = toFormData_1;
axios$2.AxiosError = AxiosError_1;
axios$2.Cancel = axios$2.CanceledError;
axios$2.all = function e(n) {
  return Promise.all(n);
};
axios$2.spread = requireSpread();
axios$2.isAxiosError = requireIsAxiosError();
axios$3.exports = axios$2;
axios$3.exports.default = axios$2;
var axiosExports = axios$3.exports, axios = axiosExports;
const axios$1 = /* @__PURE__ */ getDefaultExportFromCjs(axios);
function ownKeys$f(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$f(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$f(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$f(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
class LCDClient {
  constructor({
    restEndpoint: n
  }) {
    _defineProperty(this, "restEndpoint", void 0), _defineProperty(this, "instance", void 0), this.restEndpoint = n.endsWith("/") ? n : `${n}/`, this.instance = axios$1.create({
      baseURL: this.restEndpoint,
      timeout: 1e4,
      headers: {}
    }), this.get = this.get.bind(this), this.post = this.post.bind(this);
  }
  get(n, o = {}) {
    return new Promise(async (u, c) => {
      try {
        const d = await this.instance.get(n, _objectSpread$f({
          timeout: 1e4
        }, o));
        d && d.data ? u(d.data) : c("no response data");
      } catch (d) {
        return c(d);
      }
    });
  }
  post(n, o = {}, u = {}) {
    return new Promise(async (c, d) => {
      try {
        const m = await this.instance.post(n, o, _objectSpread$f({
          timeout: 1e4
        }, u));
        m && m.data ? c(m.data) : d("no response data");
      } catch (m) {
        return d(m);
      }
    });
  }
}
const createLCDClient$3 = async ({
  restEndpoint: e
}) => {
  const n = new LCDClient({
    restEndpoint: e
  });
  return {
    cosmos: {
      auth: {
        v1beta1: new (await Promise.resolve().then(() => _202)).LCDQueryClient({
          requestClient: n
        })
      },
      authz: {
        v1beta1: new (await Promise.resolve().then(() => _203)).LCDQueryClient({
          requestClient: n
        })
      },
      bank: {
        v1beta1: new (await Promise.resolve().then(() => _204)).LCDQueryClient({
          requestClient: n
        })
      },
      base: {
        node: {
          v1beta1: new (await Promise.resolve().then(() => _205)).LCDQueryClient({
            requestClient: n
          })
        }
      },
      distribution: {
        v1beta1: new (await Promise.resolve().then(() => _206)).LCDQueryClient({
          requestClient: n
        })
      },
      gov: {
        v1beta1: new (await Promise.resolve().then(() => _207)).LCDQueryClient({
          requestClient: n
        }),
        v1: new (await Promise.resolve().then(() => _211)).LCDQueryClient({
          requestClient: n
        })
      },
      staking: {
        v1beta1: new (await Promise.resolve().then(() => _208)).LCDQueryClient({
          requestClient: n
        })
      },
      tx: {
        v1beta1: new (await Promise.resolve().then(() => _209)).LCDQueryClient({
          requestClient: n
        })
      },
      upgrade: {
        v1beta1: new (await Promise.resolve().then(() => _210)).LCDQueryClient({
          requestClient: n
        })
      }
    }
  };
}, _335 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createLCDClient: createLCDClient$3
}, Symbol.toStringTag, { value: "Module" })), createRPCQueryClient$3 = async ({
  rpcEndpoint: e
}) => {
  const n = await build$2.Tendermint34Client.connect(e), o = new build$5.QueryClient(n);
  return {
    cosmos: {
      auth: {
        v1beta1: (await Promise.resolve().then(() => _212)).createRpcQueryExtension(o)
      },
      authz: {
        v1beta1: (await Promise.resolve().then(() => _213)).createRpcQueryExtension(o)
      },
      bank: {
        v1beta1: (await Promise.resolve().then(() => _214)).createRpcQueryExtension(o)
      },
      base: {
        node: {
          v1beta1: (await Promise.resolve().then(() => _215)).createRpcQueryExtension(o)
        }
      },
      distribution: {
        v1beta1: (await Promise.resolve().then(() => _216)).createRpcQueryExtension(o)
      },
      gov: {
        v1beta1: (await Promise.resolve().then(() => _217)).createRpcQueryExtension(o),
        v1: (await Promise.resolve().then(() => _221)).createRpcQueryExtension(o)
      },
      staking: {
        v1beta1: (await Promise.resolve().then(() => _218)).createRpcQueryExtension(o)
      },
      tx: {
        v1beta1: (await Promise.resolve().then(() => _219)).createRpcQueryExtension(o)
      },
      upgrade: {
        v1beta1: (await Promise.resolve().then(() => _220)).createRpcQueryExtension(o)
      }
    }
  };
}, _336 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRPCQueryClient: createRPCQueryClient$3
}, Symbol.toStringTag, { value: "Module" })), createRPCMsgClient$3 = async ({
  rpc: e
}) => ({
  cosmos: {
    authz: {
      v1beta1: new (await Promise.resolve().then(() => _222)).MsgClientImpl(e)
    },
    bank: {
      v1beta1: new (await Promise.resolve().then(() => _223)).MsgClientImpl(e)
    },
    distribution: {
      v1beta1: new (await Promise.resolve().then(() => _224)).MsgClientImpl(e)
    },
    gov: {
      v1beta1: new (await Promise.resolve().then(() => _225)).MsgClientImpl(e),
      v1: new (await Promise.resolve().then(() => _227)).MsgClientImpl(e)
    },
    staking: {
      v1beta1: new (await Promise.resolve().then(() => _226)).MsgClientImpl(e)
    },
    upgrade: {
      v1beta1: new (await Promise.resolve().then(() => _228)).MsgClientImpl(e)
    }
  }
}), _337 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRPCMsgClient: createRPCMsgClient$3
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$e(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$e(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$e(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$e(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
let cosmos;
(function(e) {
  let n;
  (function(T) {
    T.v1 = _objectSpread$e({}, _0);
  })(n || (n = e.ics23 || (e.ics23 = {})));
  let o;
  (function(T) {
    T.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _1), _2), _3), _202), _212);
  })(o || (o = e.auth || (e.auth = {})));
  let u;
  (function(T) {
    T.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _4), _5), _6), _7), _8), _188), _195), _203), _213), _222);
  })(u || (u = e.authz || (e.authz = {})));
  let c;
  (function(T) {
    T.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _9), _10), _11), _12), _13), _189), _196), _204), _214), _223);
  })(c || (c = e.bank || (e.bank = {})));
  let d;
  (function(T) {
    let y;
    (function(k) {
      k.v1beta1 = _objectSpread$e({}, _14);
    })(y || (y = T.abci || (T.abci = {})));
    let V;
    (function(k) {
      k.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e({}, _15), _205), _215);
    })(V || (V = T.node || (T.node = {})));
    let M;
    (function(k) {
      k.v1beta1 = _objectSpread$e({}, _16);
    })(M || (M = T.query || (T.query = {})));
    let G;
    (function(k) {
      k.v2alpha1 = _objectSpread$e({}, _17);
    })(G || (G = T.reflection || (T.reflection = {}))), T.v1beta1 = _objectSpread$e({}, _18);
  })(d || (d = e.base || (e.base = {})));
  let m;
  (function(T) {
    T.ed25519 = _objectSpread$e({}, _19), T.multisig = _objectSpread$e({}, _20), T.secp256k1 = _objectSpread$e({}, _21), T.secp256r1 = _objectSpread$e({}, _22);
    let y;
    (function(M) {
      M.v1 = _objectSpread$e({}, _23);
    })(y || (y = T.hd || (T.hd = {})));
    let V;
    (function(M) {
      M.v1 = _objectSpread$e({}, _24);
    })(V || (V = T.keyring || (T.keyring = {})));
  })(m || (m = e.crypto || (e.crypto = {})));
  let v;
  (function(T) {
    T.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _25), _26), _27), _28), _190), _197), _206), _216), _224);
  })(v || (v = e.distribution || (e.distribution = {})));
  let S;
  (function(T) {
    T.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _29), _30), _31), _32), _191), _198), _207), _217), _225), T.v1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _33), _34), _35), _36), _193), _200), _211), _221), _227);
  })(S || (S = e.gov || (e.gov = {})));
  let $;
  (function(T) {
    T.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _37), _38), _39), _40), _41), _192), _199), _208), _218), _226);
  })($ || ($ = e.staking || (e.staking = {})));
  let E;
  (function(T) {
    let y;
    (function(V) {
      V.v1beta1 = _objectSpread$e({}, _42);
    })(y || (y = T.signing || (T.signing = {}))), T.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _43), _44), _209), _219);
  })(E || (E = e.tx || (e.tx = {})));
  let O;
  (function(T) {
    T.v1beta1 = _objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e(_objectSpread$e({}, _45), _46), _47), _194), _201), _210), _220), _228);
  })(O || (O = e.upgrade || (e.upgrade = {}))), e.ClientFactory = _objectSpread$e(_objectSpread$e(_objectSpread$e({}, _335), _336), _337);
})(cosmos || (cosmos = {}));
function ownKeys$d(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$d(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$d(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$d(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
_objectSpread$d(_objectSpread$d(_objectSpread$d(_objectSpread$d(_objectSpread$d(_objectSpread$d(_objectSpread$d({}, AminoConverter$o), AminoConverter$n), AminoConverter$m), AminoConverter$l), AminoConverter$k), AminoConverter$j), AminoConverter$i);
[...registry$q, ...registry$p, ...registry$o, ...registry$n, ...registry$m, ...registry$l, ...registry$k];
const _48 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$c(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$c(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$c(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$c(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
_objectSpread$c({}, _48);
function createBaseBitArray() {
  return {
    bits: Long$2.ZERO,
    elems: []
  };
}
const BitArray = {
  typeUrl: "/tendermint.libs.bits.BitArray",
  encode(e, n = minimal.Writer.create()) {
    e.bits.isZero() || n.uint32(8).int64(e.bits), n.uint32(18).fork();
    for (const o of e.elems)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBitArray();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.bits = o.int64();
          break;
        case 2:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.elems.push(o.uint64());
          } else
            c.elems.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseBitArray();
    return o.bits = e.bits !== void 0 && e.bits !== null ? Long$2.fromValue(e.bits) : Long$2.ZERO, o.elems = ((n = e.elems) === null || n === void 0 ? void 0 : n.map((u) => Long$2.fromValue(u))) || [], o;
  },
  fromAmino(e) {
    return {
      bits: Long$2.fromString(e.bits),
      elems: Array.isArray(e == null ? void 0 : e.elems) ? e.elems.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.bits = e.bits ? e.bits.toString() : void 0, e.elems ? n.elems = e.elems.map((o) => o) : n.elems = [], n;
  },
  fromAminoMsg(e) {
    return BitArray.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return BitArray.decode(e.value);
  },
  toProto(e) {
    return BitArray.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.libs.bits.BitArray",
      value: BitArray.encode(e).finish()
    };
  }
}, _52 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BitArray
}, Symbol.toStringTag, { value: "Module" }));
function createBaseNetAddress() {
  return {
    id: "",
    ip: "",
    port: 0
  };
}
const NetAddress = {
  typeUrl: "/tendermint.p2p.NetAddress",
  encode(e, n = minimal.Writer.create()) {
    return e.id !== "" && n.uint32(10).string(e.id), e.ip !== "" && n.uint32(18).string(e.ip), e.port !== 0 && n.uint32(24).uint32(e.port), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNetAddress();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.id = o.string();
          break;
        case 2:
          c.ip = o.string();
          break;
        case 3:
          c.port = o.uint32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseNetAddress();
    return c.id = (n = e.id) !== null && n !== void 0 ? n : "", c.ip = (o = e.ip) !== null && o !== void 0 ? o : "", c.port = (u = e.port) !== null && u !== void 0 ? u : 0, c;
  },
  fromAmino(e) {
    return {
      id: e.id,
      ip: e.ip,
      port: e.port
    };
  },
  toAmino(e) {
    const n = {};
    return n.id = e.id, n.ip = e.ip, n.port = e.port, n;
  },
  fromAminoMsg(e) {
    return NetAddress.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return NetAddress.decode(e.value);
  },
  toProto(e) {
    return NetAddress.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.p2p.NetAddress",
      value: NetAddress.encode(e).finish()
    };
  }
};
function createBaseProtocolVersion() {
  return {
    p2p: Long$2.UZERO,
    block: Long$2.UZERO,
    app: Long$2.UZERO
  };
}
const ProtocolVersion = {
  typeUrl: "/tendermint.p2p.ProtocolVersion",
  encode(e, n = minimal.Writer.create()) {
    return e.p2p.isZero() || n.uint32(8).uint64(e.p2p), e.block.isZero() || n.uint32(16).uint64(e.block), e.app.isZero() || n.uint32(24).uint64(e.app), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProtocolVersion();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.p2p = o.uint64();
          break;
        case 2:
          c.block = o.uint64();
          break;
        case 3:
          c.app = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseProtocolVersion();
    return n.p2p = e.p2p !== void 0 && e.p2p !== null ? Long$2.fromValue(e.p2p) : Long$2.UZERO, n.block = e.block !== void 0 && e.block !== null ? Long$2.fromValue(e.block) : Long$2.UZERO, n.app = e.app !== void 0 && e.app !== null ? Long$2.fromValue(e.app) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      p2p: Long$2.fromString(e.p2p),
      block: Long$2.fromString(e.block),
      app: Long$2.fromString(e.app)
    };
  },
  toAmino(e) {
    const n = {};
    return n.p2p = e.p2p ? e.p2p.toString() : void 0, n.block = e.block ? e.block.toString() : void 0, n.app = e.app ? e.app.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ProtocolVersion.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ProtocolVersion.decode(e.value);
  },
  toProto(e) {
    return ProtocolVersion.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.p2p.ProtocolVersion",
      value: ProtocolVersion.encode(e).finish()
    };
  }
};
function createBaseDefaultNodeInfo() {
  return {
    protocolVersion: void 0,
    defaultNodeId: "",
    listenAddr: "",
    network: "",
    version: "",
    channels: new Uint8Array(),
    moniker: "",
    other: void 0
  };
}
const DefaultNodeInfo = {
  typeUrl: "/tendermint.p2p.DefaultNodeInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.protocolVersion !== void 0 && ProtocolVersion.encode(e.protocolVersion, n.uint32(10).fork()).ldelim(), e.defaultNodeId !== "" && n.uint32(18).string(e.defaultNodeId), e.listenAddr !== "" && n.uint32(26).string(e.listenAddr), e.network !== "" && n.uint32(34).string(e.network), e.version !== "" && n.uint32(42).string(e.version), e.channels.length !== 0 && n.uint32(50).bytes(e.channels), e.moniker !== "" && n.uint32(58).string(e.moniker), e.other !== void 0 && DefaultNodeInfoOther.encode(e.other, n.uint32(66).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDefaultNodeInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.protocolVersion = ProtocolVersion.decode(o, o.uint32());
          break;
        case 2:
          c.defaultNodeId = o.string();
          break;
        case 3:
          c.listenAddr = o.string();
          break;
        case 4:
          c.network = o.string();
          break;
        case 5:
          c.version = o.string();
          break;
        case 6:
          c.channels = o.bytes();
          break;
        case 7:
          c.moniker = o.string();
          break;
        case 8:
          c.other = DefaultNodeInfoOther.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseDefaultNodeInfo();
    return v.protocolVersion = e.protocolVersion !== void 0 && e.protocolVersion !== null ? ProtocolVersion.fromPartial(e.protocolVersion) : void 0, v.defaultNodeId = (n = e.defaultNodeId) !== null && n !== void 0 ? n : "", v.listenAddr = (o = e.listenAddr) !== null && o !== void 0 ? o : "", v.network = (u = e.network) !== null && u !== void 0 ? u : "", v.version = (c = e.version) !== null && c !== void 0 ? c : "", v.channels = (d = e.channels) !== null && d !== void 0 ? d : new Uint8Array(), v.moniker = (m = e.moniker) !== null && m !== void 0 ? m : "", v.other = e.other !== void 0 && e.other !== null ? DefaultNodeInfoOther.fromPartial(e.other) : void 0, v;
  },
  fromAmino(e) {
    return {
      protocolVersion: e != null && e.protocol_version ? ProtocolVersion.fromAmino(e.protocol_version) : void 0,
      defaultNodeId: e.default_node_id,
      listenAddr: e.listen_addr,
      network: e.network,
      version: e.version,
      channels: e.channels,
      moniker: e.moniker,
      other: e != null && e.other ? DefaultNodeInfoOther.fromAmino(e.other) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.protocol_version = e.protocolVersion ? ProtocolVersion.toAmino(e.protocolVersion) : void 0, n.default_node_id = e.defaultNodeId, n.listen_addr = e.listenAddr, n.network = e.network, n.version = e.version, n.channels = e.channels, n.moniker = e.moniker, n.other = e.other ? DefaultNodeInfoOther.toAmino(e.other) : void 0, n;
  },
  fromAminoMsg(e) {
    return DefaultNodeInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return DefaultNodeInfo.decode(e.value);
  },
  toProto(e) {
    return DefaultNodeInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.p2p.DefaultNodeInfo",
      value: DefaultNodeInfo.encode(e).finish()
    };
  }
};
function createBaseDefaultNodeInfoOther() {
  return {
    txIndex: "",
    rpcAddress: ""
  };
}
const DefaultNodeInfoOther = {
  typeUrl: "/tendermint.p2p.DefaultNodeInfoOther",
  encode(e, n = minimal.Writer.create()) {
    return e.txIndex !== "" && n.uint32(10).string(e.txIndex), e.rpcAddress !== "" && n.uint32(18).string(e.rpcAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDefaultNodeInfoOther();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.txIndex = o.string();
          break;
        case 2:
          c.rpcAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDefaultNodeInfoOther();
    return u.txIndex = (n = e.txIndex) !== null && n !== void 0 ? n : "", u.rpcAddress = (o = e.rpcAddress) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      txIndex: e.tx_index,
      rpcAddress: e.rpc_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.tx_index = e.txIndex, n.rpc_address = e.rpcAddress, n;
  },
  fromAminoMsg(e) {
    return DefaultNodeInfoOther.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return DefaultNodeInfoOther.decode(e.value);
  },
  toProto(e) {
    return DefaultNodeInfoOther.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.p2p.DefaultNodeInfoOther",
      value: DefaultNodeInfoOther.encode(e).finish()
    };
  }
}, _53 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultNodeInfo,
  DefaultNodeInfoOther,
  NetAddress,
  ProtocolVersion
}, Symbol.toStringTag, { value: "Module" }));
function createBaseEvidence() {
  return {
    duplicateVoteEvidence: void 0,
    lightClientAttackEvidence: void 0
  };
}
const Evidence = {
  typeUrl: "/tendermint.types.Evidence",
  encode(e, n = minimal.Writer.create()) {
    return e.duplicateVoteEvidence !== void 0 && DuplicateVoteEvidence.encode(e.duplicateVoteEvidence, n.uint32(10).fork()).ldelim(), e.lightClientAttackEvidence !== void 0 && LightClientAttackEvidence.encode(e.lightClientAttackEvidence, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEvidence();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.duplicateVoteEvidence = DuplicateVoteEvidence.decode(o, o.uint32());
          break;
        case 2:
          c.lightClientAttackEvidence = LightClientAttackEvidence.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseEvidence();
    return n.duplicateVoteEvidence = e.duplicateVoteEvidence !== void 0 && e.duplicateVoteEvidence !== null ? DuplicateVoteEvidence.fromPartial(e.duplicateVoteEvidence) : void 0, n.lightClientAttackEvidence = e.lightClientAttackEvidence !== void 0 && e.lightClientAttackEvidence !== null ? LightClientAttackEvidence.fromPartial(e.lightClientAttackEvidence) : void 0, n;
  },
  fromAmino(e) {
    return {
      duplicateVoteEvidence: e != null && e.duplicate_vote_evidence ? DuplicateVoteEvidence.fromAmino(e.duplicate_vote_evidence) : void 0,
      lightClientAttackEvidence: e != null && e.light_client_attack_evidence ? LightClientAttackEvidence.fromAmino(e.light_client_attack_evidence) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.duplicate_vote_evidence = e.duplicateVoteEvidence ? DuplicateVoteEvidence.toAmino(e.duplicateVoteEvidence) : void 0, n.light_client_attack_evidence = e.lightClientAttackEvidence ? LightClientAttackEvidence.toAmino(e.lightClientAttackEvidence) : void 0, n;
  },
  fromAminoMsg(e) {
    return Evidence.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Evidence.decode(e.value);
  },
  toProto(e) {
    return Evidence.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Evidence",
      value: Evidence.encode(e).finish()
    };
  }
};
function createBaseDuplicateVoteEvidence() {
  return {
    voteA: void 0,
    voteB: void 0,
    totalVotingPower: Long$2.ZERO,
    validatorPower: Long$2.ZERO,
    timestamp: void 0
  };
}
const DuplicateVoteEvidence = {
  typeUrl: "/tendermint.types.DuplicateVoteEvidence",
  encode(e, n = minimal.Writer.create()) {
    return e.voteA !== void 0 && Vote$2.encode(e.voteA, n.uint32(10).fork()).ldelim(), e.voteB !== void 0 && Vote$2.encode(e.voteB, n.uint32(18).fork()).ldelim(), e.totalVotingPower.isZero() || n.uint32(24).int64(e.totalVotingPower), e.validatorPower.isZero() || n.uint32(32).int64(e.validatorPower), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(42).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDuplicateVoteEvidence();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.voteA = Vote$2.decode(o, o.uint32());
          break;
        case 2:
          c.voteB = Vote$2.decode(o, o.uint32());
          break;
        case 3:
          c.totalVotingPower = o.int64();
          break;
        case 4:
          c.validatorPower = o.int64();
          break;
        case 5:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDuplicateVoteEvidence();
    return o.voteA = e.voteA !== void 0 && e.voteA !== null ? Vote$2.fromPartial(e.voteA) : void 0, o.voteB = e.voteB !== void 0 && e.voteB !== null ? Vote$2.fromPartial(e.voteB) : void 0, o.totalVotingPower = e.totalVotingPower !== void 0 && e.totalVotingPower !== null ? Long$2.fromValue(e.totalVotingPower) : Long$2.ZERO, o.validatorPower = e.validatorPower !== void 0 && e.validatorPower !== null ? Long$2.fromValue(e.validatorPower) : Long$2.ZERO, o.timestamp = (n = e.timestamp) !== null && n !== void 0 ? n : void 0, o;
  },
  fromAmino(e) {
    return {
      voteA: e != null && e.vote_a ? Vote$2.fromAmino(e.vote_a) : void 0,
      voteB: e != null && e.vote_b ? Vote$2.fromAmino(e.vote_b) : void 0,
      totalVotingPower: Long$2.fromString(e.total_voting_power),
      validatorPower: Long$2.fromString(e.validator_power),
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.vote_a = e.voteA ? Vote$2.toAmino(e.voteA) : void 0, n.vote_b = e.voteB ? Vote$2.toAmino(e.voteB) : void 0, n.total_voting_power = e.totalVotingPower ? e.totalVotingPower.toString() : void 0, n.validator_power = e.validatorPower ? e.validatorPower.toString() : void 0, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n;
  },
  fromAminoMsg(e) {
    return DuplicateVoteEvidence.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return DuplicateVoteEvidence.decode(e.value);
  },
  toProto(e) {
    return DuplicateVoteEvidence.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.DuplicateVoteEvidence",
      value: DuplicateVoteEvidence.encode(e).finish()
    };
  }
};
function createBaseLightClientAttackEvidence() {
  return {
    conflictingBlock: void 0,
    commonHeight: Long$2.ZERO,
    byzantineValidators: [],
    totalVotingPower: Long$2.ZERO,
    timestamp: void 0
  };
}
const LightClientAttackEvidence = {
  typeUrl: "/tendermint.types.LightClientAttackEvidence",
  encode(e, n = minimal.Writer.create()) {
    e.conflictingBlock !== void 0 && LightBlock.encode(e.conflictingBlock, n.uint32(10).fork()).ldelim(), e.commonHeight.isZero() || n.uint32(16).int64(e.commonHeight);
    for (const o of e.byzantineValidators)
      Validator$2.encode(o, n.uint32(26).fork()).ldelim();
    return e.totalVotingPower.isZero() || n.uint32(32).int64(e.totalVotingPower), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(42).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLightClientAttackEvidence();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.conflictingBlock = LightBlock.decode(o, o.uint32());
          break;
        case 2:
          c.commonHeight = o.int64();
          break;
        case 3:
          c.byzantineValidators.push(Validator$2.decode(o, o.uint32()));
          break;
        case 4:
          c.totalVotingPower = o.int64();
          break;
        case 5:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseLightClientAttackEvidence();
    return u.conflictingBlock = e.conflictingBlock !== void 0 && e.conflictingBlock !== null ? LightBlock.fromPartial(e.conflictingBlock) : void 0, u.commonHeight = e.commonHeight !== void 0 && e.commonHeight !== null ? Long$2.fromValue(e.commonHeight) : Long$2.ZERO, u.byzantineValidators = ((n = e.byzantineValidators) === null || n === void 0 ? void 0 : n.map((c) => Validator$2.fromPartial(c))) || [], u.totalVotingPower = e.totalVotingPower !== void 0 && e.totalVotingPower !== null ? Long$2.fromValue(e.totalVotingPower) : Long$2.ZERO, u.timestamp = (o = e.timestamp) !== null && o !== void 0 ? o : void 0, u;
  },
  fromAmino(e) {
    return {
      conflictingBlock: e != null && e.conflicting_block ? LightBlock.fromAmino(e.conflicting_block) : void 0,
      commonHeight: Long$2.fromString(e.common_height),
      byzantineValidators: Array.isArray(e == null ? void 0 : e.byzantine_validators) ? e.byzantine_validators.map((n) => Validator$2.fromAmino(n)) : [],
      totalVotingPower: Long$2.fromString(e.total_voting_power),
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.conflicting_block = e.conflictingBlock ? LightBlock.toAmino(e.conflictingBlock) : void 0, n.common_height = e.commonHeight ? e.commonHeight.toString() : void 0, e.byzantineValidators ? n.byzantine_validators = e.byzantineValidators.map((o) => o ? Validator$2.toAmino(o) : void 0) : n.byzantine_validators = [], n.total_voting_power = e.totalVotingPower ? e.totalVotingPower.toString() : void 0, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n;
  },
  fromAminoMsg(e) {
    return LightClientAttackEvidence.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return LightClientAttackEvidence.decode(e.value);
  },
  toProto(e) {
    return LightClientAttackEvidence.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.LightClientAttackEvidence",
      value: LightClientAttackEvidence.encode(e).finish()
    };
  }
};
function createBaseEvidenceList() {
  return {
    evidence: []
  };
}
const EvidenceList = {
  typeUrl: "/tendermint.types.EvidenceList",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.evidence)
      Evidence.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEvidenceList();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.evidence.push(Evidence.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseEvidenceList();
    return o.evidence = ((n = e.evidence) === null || n === void 0 ? void 0 : n.map((u) => Evidence.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      evidence: Array.isArray(e == null ? void 0 : e.evidence) ? e.evidence.map((n) => Evidence.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.evidence ? n.evidence = e.evidence.map((o) => o ? Evidence.toAmino(o) : void 0) : n.evidence = [], n;
  },
  fromAminoMsg(e) {
    return EvidenceList.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return EvidenceList.decode(e.value);
  },
  toProto(e) {
    return EvidenceList.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.EvidenceList",
      value: EvidenceList.encode(e).finish()
    };
  }
}, _55 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DuplicateVoteEvidence,
  Evidence,
  EvidenceList,
  LightClientAttackEvidence
}, Symbol.toStringTag, { value: "Module" }));
function createBaseBlock() {
  return {
    header: void 0,
    data: void 0,
    evidence: void 0,
    lastCommit: void 0
  };
}
const Block = {
  typeUrl: "/tendermint.types.Block",
  encode(e, n = minimal.Writer.create()) {
    return e.header !== void 0 && Header$3.encode(e.header, n.uint32(10).fork()).ldelim(), e.data !== void 0 && Data.encode(e.data, n.uint32(18).fork()).ldelim(), e.evidence !== void 0 && EvidenceList.encode(e.evidence, n.uint32(26).fork()).ldelim(), e.lastCommit !== void 0 && Commit.encode(e.lastCommit, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBlock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.header = Header$3.decode(o, o.uint32());
          break;
        case 2:
          c.data = Data.decode(o, o.uint32());
          break;
        case 3:
          c.evidence = EvidenceList.decode(o, o.uint32());
          break;
        case 4:
          c.lastCommit = Commit.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseBlock();
    return n.header = e.header !== void 0 && e.header !== null ? Header$3.fromPartial(e.header) : void 0, n.data = e.data !== void 0 && e.data !== null ? Data.fromPartial(e.data) : void 0, n.evidence = e.evidence !== void 0 && e.evidence !== null ? EvidenceList.fromPartial(e.evidence) : void 0, n.lastCommit = e.lastCommit !== void 0 && e.lastCommit !== null ? Commit.fromPartial(e.lastCommit) : void 0, n;
  },
  fromAmino(e) {
    return {
      header: e != null && e.header ? Header$3.fromAmino(e.header) : void 0,
      data: e != null && e.data ? Data.fromAmino(e.data) : void 0,
      evidence: e != null && e.evidence ? EvidenceList.fromAmino(e.evidence) : void 0,
      lastCommit: e != null && e.last_commit ? Commit.fromAmino(e.last_commit) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.header = e.header ? Header$3.toAmino(e.header) : void 0, n.data = e.data ? Data.toAmino(e.data) : void 0, n.evidence = e.evidence ? EvidenceList.toAmino(e.evidence) : void 0, n.last_commit = e.lastCommit ? Commit.toAmino(e.lastCommit) : void 0, n;
  },
  fromAminoMsg(e) {
    return Block.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Block.decode(e.value);
  },
  toProto(e) {
    return Block.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/tendermint.types.Block",
      value: Block.encode(e).finish()
    };
  }
}, _54 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Block
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$b(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$b(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$b(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$b(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
let tendermint;
(function(e) {
  e.abci = _objectSpread$b({}, _49), e.crypto = _objectSpread$b(_objectSpread$b({}, _50), _51);
  let n;
  (function(o) {
    o.bits = _objectSpread$b({}, _52);
  })(n || (n = e.libs || (e.libs = {}))), e.p2p = _objectSpread$b({}, _53), e.types = _objectSpread$b(_objectSpread$b(_objectSpread$b(_objectSpread$b(_objectSpread$b({}, _54), _55), _56), _57), _58), e.version = _objectSpread$b({}, _59);
})(tendermint || (tendermint = {}));
function createBaseCapability() {
  return {
    index: Long$2.UZERO
  };
}
const Capability = {
  typeUrl: "/capability.v1.Capability",
  encode(e, n = minimal.Writer.create()) {
    return e.index.isZero() || n.uint32(8).uint64(e.index), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCapability();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.index = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseCapability();
    return n.index = e.index !== void 0 && e.index !== null ? Long$2.fromValue(e.index) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      index: Long$2.fromString(e.index)
    };
  },
  toAmino(e) {
    const n = {};
    return n.index = e.index ? e.index.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Capability.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Capability.decode(e.value);
  },
  toProto(e) {
    return Capability.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/capability.v1.Capability",
      value: Capability.encode(e).finish()
    };
  }
};
function createBaseOwner() {
  return {
    module: "",
    name: ""
  };
}
const Owner = {
  typeUrl: "/capability.v1.Owner",
  encode(e, n = minimal.Writer.create()) {
    return e.module !== "" && n.uint32(10).string(e.module), e.name !== "" && n.uint32(18).string(e.name), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseOwner();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.module = o.string();
          break;
        case 2:
          c.name = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseOwner();
    return u.module = (n = e.module) !== null && n !== void 0 ? n : "", u.name = (o = e.name) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      module: e.module,
      name: e.name
    };
  },
  toAmino(e) {
    const n = {};
    return n.module = e.module, n.name = e.name, n;
  },
  fromAminoMsg(e) {
    return Owner.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Owner.decode(e.value);
  },
  toProto(e) {
    return Owner.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/capability.v1.Owner",
      value: Owner.encode(e).finish()
    };
  }
};
function createBaseCapabilityOwners() {
  return {
    owners: []
  };
}
const CapabilityOwners = {
  typeUrl: "/capability.v1.CapabilityOwners",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.owners)
      Owner.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCapabilityOwners();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owners.push(Owner.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseCapabilityOwners();
    return o.owners = ((n = e.owners) === null || n === void 0 ? void 0 : n.map((u) => Owner.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      owners: Array.isArray(e == null ? void 0 : e.owners) ? e.owners.map((n) => Owner.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.owners ? n.owners = e.owners.map((o) => o ? Owner.toAmino(o) : void 0) : n.owners = [], n;
  },
  fromAminoMsg(e) {
    return CapabilityOwners.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return CapabilityOwners.decode(e.value);
  },
  toProto(e) {
    return CapabilityOwners.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/capability.v1.CapabilityOwners",
      value: CapabilityOwners.encode(e).finish()
    };
  }
}, _60 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Capability,
  CapabilityOwners,
  Owner
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisOwners() {
  return {
    index: Long$2.UZERO,
    indexOwners: void 0
  };
}
const GenesisOwners = {
  typeUrl: "/capability.v1.GenesisOwners",
  encode(e, n = minimal.Writer.create()) {
    return e.index.isZero() || n.uint32(8).uint64(e.index), e.indexOwners !== void 0 && CapabilityOwners.encode(e.indexOwners, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisOwners();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.index = o.uint64();
          break;
        case 2:
          c.indexOwners = CapabilityOwners.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGenesisOwners();
    return n.index = e.index !== void 0 && e.index !== null ? Long$2.fromValue(e.index) : Long$2.UZERO, n.indexOwners = e.indexOwners !== void 0 && e.indexOwners !== null ? CapabilityOwners.fromPartial(e.indexOwners) : void 0, n;
  },
  fromAmino(e) {
    return {
      index: Long$2.fromString(e.index),
      indexOwners: e != null && e.index_owners ? CapabilityOwners.fromAmino(e.index_owners) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.index = e.index ? e.index.toString() : void 0, n.index_owners = e.indexOwners ? CapabilityOwners.toAmino(e.indexOwners) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisOwners.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return GenesisOwners.decode(e.value);
  },
  toProto(e) {
    return GenesisOwners.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/capability.v1.GenesisOwners",
      value: GenesisOwners.encode(e).finish()
    };
  }
};
function createBaseGenesisState$m() {
  return {
    index: Long$2.UZERO,
    owners: []
  };
}
const GenesisState$m = {
  typeUrl: "/capability.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.index.isZero() || n.uint32(8).uint64(e.index);
    for (const o of e.owners)
      GenesisOwners.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$m();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.index = o.uint64();
          break;
        case 2:
          c.owners.push(GenesisOwners.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$m();
    return o.index = e.index !== void 0 && e.index !== null ? Long$2.fromValue(e.index) : Long$2.UZERO, o.owners = ((n = e.owners) === null || n === void 0 ? void 0 : n.map((u) => GenesisOwners.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      index: Long$2.fromString(e.index),
      owners: Array.isArray(e == null ? void 0 : e.owners) ? e.owners.map((n) => GenesisOwners.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.index = e.index ? e.index.toString() : void 0, e.owners ? n.owners = e.owners.map((o) => o ? GenesisOwners.toAmino(o) : void 0) : n.owners = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$m.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return GenesisState$m.decode(e.value);
  },
  toProto(e) {
    return GenesisState$m.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/capability.v1.GenesisState",
      value: GenesisState$m.encode(e).finish()
    };
  }
}, _61 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisOwners,
  GenesisState: GenesisState$m
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$a(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$a(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$a(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$a(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
let capability;
(function(e) {
  e.v1 = _objectSpread$a(_objectSpread$a({}, _60), _61);
})(capability || (capability = {}));
function createBaseIncentivizedAcknowledgement() {
  return {
    appAcknowledgement: new Uint8Array(),
    forwardRelayerAddress: "",
    underlyingAppSuccess: !1
  };
}
const IncentivizedAcknowledgement = {
  typeUrl: "/ibc.applications.fee.v1.IncentivizedAcknowledgement",
  encode(e, n = minimal.Writer.create()) {
    return e.appAcknowledgement.length !== 0 && n.uint32(10).bytes(e.appAcknowledgement), e.forwardRelayerAddress !== "" && n.uint32(18).string(e.forwardRelayerAddress), e.underlyingAppSuccess === !0 && n.uint32(24).bool(e.underlyingAppSuccess), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIncentivizedAcknowledgement();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.appAcknowledgement = o.bytes();
          break;
        case 2:
          c.forwardRelayerAddress = o.string();
          break;
        case 3:
          c.underlyingAppSuccess = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseIncentivizedAcknowledgement();
    return c.appAcknowledgement = (n = e.appAcknowledgement) !== null && n !== void 0 ? n : new Uint8Array(), c.forwardRelayerAddress = (o = e.forwardRelayerAddress) !== null && o !== void 0 ? o : "", c.underlyingAppSuccess = (u = e.underlyingAppSuccess) !== null && u !== void 0 ? u : !1, c;
  },
  fromAmino(e) {
    return {
      appAcknowledgement: e.app_acknowledgement,
      forwardRelayerAddress: e.forward_relayer_address,
      underlyingAppSuccess: e.underlying_app_success
    };
  },
  toAmino(e) {
    const n = {};
    return n.app_acknowledgement = e.appAcknowledgement, n.forward_relayer_address = e.forwardRelayerAddress, n.underlying_app_success = e.underlyingAppSuccess, n;
  },
  fromAminoMsg(e) {
    return IncentivizedAcknowledgement.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/IncentivizedAcknowledgement",
      value: IncentivizedAcknowledgement.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return IncentivizedAcknowledgement.decode(e.value);
  },
  toProto(e) {
    return IncentivizedAcknowledgement.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.IncentivizedAcknowledgement",
      value: IncentivizedAcknowledgement.encode(e).finish()
    };
  }
}, _62 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IncentivizedAcknowledgement
}, Symbol.toStringTag, { value: "Module" }));
let State$1;
(function(e) {
  e[e.STATE_UNINITIALIZED_UNSPECIFIED = 0] = "STATE_UNINITIALIZED_UNSPECIFIED", e[e.STATE_INIT = 1] = "STATE_INIT", e[e.STATE_TRYOPEN = 2] = "STATE_TRYOPEN", e[e.STATE_OPEN = 3] = "STATE_OPEN", e[e.STATE_CLOSED = 4] = "STATE_CLOSED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(State$1 || (State$1 = {}));
const StateSDKType$1 = State$1, StateAmino$1 = State$1;
function stateFromJSON$1(e) {
  switch (e) {
    case 0:
    case "STATE_UNINITIALIZED_UNSPECIFIED":
      return State$1.STATE_UNINITIALIZED_UNSPECIFIED;
    case 1:
    case "STATE_INIT":
      return State$1.STATE_INIT;
    case 2:
    case "STATE_TRYOPEN":
      return State$1.STATE_TRYOPEN;
    case 3:
    case "STATE_OPEN":
      return State$1.STATE_OPEN;
    case 4:
    case "STATE_CLOSED":
      return State$1.STATE_CLOSED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return State$1.UNRECOGNIZED;
  }
}
function stateToJSON$1(e) {
  switch (e) {
    case State$1.STATE_UNINITIALIZED_UNSPECIFIED:
      return "STATE_UNINITIALIZED_UNSPECIFIED";
    case State$1.STATE_INIT:
      return "STATE_INIT";
    case State$1.STATE_TRYOPEN:
      return "STATE_TRYOPEN";
    case State$1.STATE_OPEN:
      return "STATE_OPEN";
    case State$1.STATE_CLOSED:
      return "STATE_CLOSED";
    case State$1.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let Order;
(function(e) {
  e[e.ORDER_NONE_UNSPECIFIED = 0] = "ORDER_NONE_UNSPECIFIED", e[e.ORDER_UNORDERED = 1] = "ORDER_UNORDERED", e[e.ORDER_ORDERED = 2] = "ORDER_ORDERED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(Order || (Order = {}));
const OrderSDKType = Order, OrderAmino = Order;
function orderFromJSON(e) {
  switch (e) {
    case 0:
    case "ORDER_NONE_UNSPECIFIED":
      return Order.ORDER_NONE_UNSPECIFIED;
    case 1:
    case "ORDER_UNORDERED":
      return Order.ORDER_UNORDERED;
    case 2:
    case "ORDER_ORDERED":
      return Order.ORDER_ORDERED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Order.UNRECOGNIZED;
  }
}
function orderToJSON(e) {
  switch (e) {
    case Order.ORDER_NONE_UNSPECIFIED:
      return "ORDER_NONE_UNSPECIFIED";
    case Order.ORDER_UNORDERED:
      return "ORDER_UNORDERED";
    case Order.ORDER_ORDERED:
      return "ORDER_ORDERED";
    case Order.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseChannel() {
  return {
    state: 0,
    ordering: 0,
    counterparty: void 0,
    connectionHops: [],
    version: ""
  };
}
const Channel = {
  typeUrl: "/ibc.core.channel.v1.Channel",
  encode(e, n = minimal.Writer.create()) {
    e.state !== 0 && n.uint32(8).int32(e.state), e.ordering !== 0 && n.uint32(16).int32(e.ordering), e.counterparty !== void 0 && Counterparty$1.encode(e.counterparty, n.uint32(26).fork()).ldelim();
    for (const o of e.connectionHops)
      n.uint32(34).string(o);
    return e.version !== "" && n.uint32(42).string(e.version), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseChannel();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.state = o.int32();
          break;
        case 2:
          c.ordering = o.int32();
          break;
        case 3:
          c.counterparty = Counterparty$1.decode(o, o.uint32());
          break;
        case 4:
          c.connectionHops.push(o.string());
          break;
        case 5:
          c.version = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseChannel();
    return d.state = (n = e.state) !== null && n !== void 0 ? n : 0, d.ordering = (o = e.ordering) !== null && o !== void 0 ? o : 0, d.counterparty = e.counterparty !== void 0 && e.counterparty !== null ? Counterparty$1.fromPartial(e.counterparty) : void 0, d.connectionHops = ((u = e.connectionHops) === null || u === void 0 ? void 0 : u.map((m) => m)) || [], d.version = (c = e.version) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      state: isSet(e.state) ? stateFromJSON$1(e.state) : 0,
      ordering: isSet(e.ordering) ? orderFromJSON(e.ordering) : 0,
      counterparty: e != null && e.counterparty ? Counterparty$1.fromAmino(e.counterparty) : void 0,
      connectionHops: Array.isArray(e == null ? void 0 : e.connection_hops) ? e.connection_hops.map((n) => n) : [],
      version: e.version
    };
  },
  toAmino(e) {
    const n = {};
    return n.state = e.state, n.ordering = e.ordering, n.counterparty = e.counterparty ? Counterparty$1.toAmino(e.counterparty) : void 0, e.connectionHops ? n.connection_hops = e.connectionHops.map((o) => o) : n.connection_hops = [], n.version = e.version, n;
  },
  fromAminoMsg(e) {
    return Channel.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Channel",
      value: Channel.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Channel.decode(e.value);
  },
  toProto(e) {
    return Channel.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.Channel",
      value: Channel.encode(e).finish()
    };
  }
};
function createBaseIdentifiedChannel() {
  return {
    state: 0,
    ordering: 0,
    counterparty: void 0,
    connectionHops: [],
    version: "",
    portId: "",
    channelId: ""
  };
}
const IdentifiedChannel = {
  typeUrl: "/ibc.core.channel.v1.IdentifiedChannel",
  encode(e, n = minimal.Writer.create()) {
    e.state !== 0 && n.uint32(8).int32(e.state), e.ordering !== 0 && n.uint32(16).int32(e.ordering), e.counterparty !== void 0 && Counterparty$1.encode(e.counterparty, n.uint32(26).fork()).ldelim();
    for (const o of e.connectionHops)
      n.uint32(34).string(o);
    return e.version !== "" && n.uint32(42).string(e.version), e.portId !== "" && n.uint32(50).string(e.portId), e.channelId !== "" && n.uint32(58).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIdentifiedChannel();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.state = o.int32();
          break;
        case 2:
          c.ordering = o.int32();
          break;
        case 3:
          c.counterparty = Counterparty$1.decode(o, o.uint32());
          break;
        case 4:
          c.connectionHops.push(o.string());
          break;
        case 5:
          c.version = o.string();
          break;
        case 6:
          c.portId = o.string();
          break;
        case 7:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseIdentifiedChannel();
    return v.state = (n = e.state) !== null && n !== void 0 ? n : 0, v.ordering = (o = e.ordering) !== null && o !== void 0 ? o : 0, v.counterparty = e.counterparty !== void 0 && e.counterparty !== null ? Counterparty$1.fromPartial(e.counterparty) : void 0, v.connectionHops = ((u = e.connectionHops) === null || u === void 0 ? void 0 : u.map((S) => S)) || [], v.version = (c = e.version) !== null && c !== void 0 ? c : "", v.portId = (d = e.portId) !== null && d !== void 0 ? d : "", v.channelId = (m = e.channelId) !== null && m !== void 0 ? m : "", v;
  },
  fromAmino(e) {
    return {
      state: isSet(e.state) ? stateFromJSON$1(e.state) : 0,
      ordering: isSet(e.ordering) ? orderFromJSON(e.ordering) : 0,
      counterparty: e != null && e.counterparty ? Counterparty$1.fromAmino(e.counterparty) : void 0,
      connectionHops: Array.isArray(e == null ? void 0 : e.connection_hops) ? e.connection_hops.map((n) => n) : [],
      version: e.version,
      portId: e.port_id,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.state = e.state, n.ordering = e.ordering, n.counterparty = e.counterparty ? Counterparty$1.toAmino(e.counterparty) : void 0, e.connectionHops ? n.connection_hops = e.connectionHops.map((o) => o) : n.connection_hops = [], n.version = e.version, n.port_id = e.portId, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return IdentifiedChannel.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/IdentifiedChannel",
      value: IdentifiedChannel.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return IdentifiedChannel.decode(e.value);
  },
  toProto(e) {
    return IdentifiedChannel.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.IdentifiedChannel",
      value: IdentifiedChannel.encode(e).finish()
    };
  }
};
function createBaseCounterparty$1() {
  return {
    portId: "",
    channelId: ""
  };
}
const Counterparty$1 = {
  typeUrl: "/ibc.core.channel.v1.Counterparty",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCounterparty$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCounterparty$1();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return Counterparty$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Counterparty",
      value: Counterparty$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Counterparty$1.decode(e.value);
  },
  toProto(e) {
    return Counterparty$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.Counterparty",
      value: Counterparty$1.encode(e).finish()
    };
  }
};
function createBasePacket() {
  return {
    sequence: Long$2.UZERO,
    sourcePort: "",
    sourceChannel: "",
    destinationPort: "",
    destinationChannel: "",
    data: new Uint8Array(),
    timeoutHeight: void 0,
    timeoutTimestamp: Long$2.UZERO
  };
}
const Packet = {
  typeUrl: "/ibc.core.channel.v1.Packet",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), e.sourcePort !== "" && n.uint32(18).string(e.sourcePort), e.sourceChannel !== "" && n.uint32(26).string(e.sourceChannel), e.destinationPort !== "" && n.uint32(34).string(e.destinationPort), e.destinationChannel !== "" && n.uint32(42).string(e.destinationChannel), e.data.length !== 0 && n.uint32(50).bytes(e.data), e.timeoutHeight !== void 0 && Height.encode(e.timeoutHeight, n.uint32(58).fork()).ldelim(), e.timeoutTimestamp.isZero() || n.uint32(64).uint64(e.timeoutTimestamp), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacket();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        case 2:
          c.sourcePort = o.string();
          break;
        case 3:
          c.sourceChannel = o.string();
          break;
        case 4:
          c.destinationPort = o.string();
          break;
        case 5:
          c.destinationChannel = o.string();
          break;
        case 6:
          c.data = o.bytes();
          break;
        case 7:
          c.timeoutHeight = Height.decode(o, o.uint32());
          break;
        case 8:
          c.timeoutTimestamp = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBasePacket();
    return m.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, m.sourcePort = (n = e.sourcePort) !== null && n !== void 0 ? n : "", m.sourceChannel = (o = e.sourceChannel) !== null && o !== void 0 ? o : "", m.destinationPort = (u = e.destinationPort) !== null && u !== void 0 ? u : "", m.destinationChannel = (c = e.destinationChannel) !== null && c !== void 0 ? c : "", m.data = (d = e.data) !== null && d !== void 0 ? d : new Uint8Array(), m.timeoutHeight = e.timeoutHeight !== void 0 && e.timeoutHeight !== null ? Height.fromPartial(e.timeoutHeight) : void 0, m.timeoutTimestamp = e.timeoutTimestamp !== void 0 && e.timeoutTimestamp !== null ? Long$2.fromValue(e.timeoutTimestamp) : Long$2.UZERO, m;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence),
      sourcePort: e.source_port,
      sourceChannel: e.source_channel,
      destinationPort: e.destination_port,
      destinationChannel: e.destination_channel,
      data: e.data,
      timeoutHeight: e != null && e.timeout_height ? Height.fromAmino(e.timeout_height) : void 0,
      timeoutTimestamp: Long$2.fromString(e.timeout_timestamp)
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n.source_port = e.sourcePort, n.source_channel = e.sourceChannel, n.destination_port = e.destinationPort, n.destination_channel = e.destinationChannel, n.data = e.data, n.timeout_height = e.timeoutHeight ? Height.toAmino(e.timeoutHeight) : {}, n.timeout_timestamp = e.timeoutTimestamp ? e.timeoutTimestamp.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Packet.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Packet",
      value: Packet.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Packet.decode(e.value);
  },
  toProto(e) {
    return Packet.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.Packet",
      value: Packet.encode(e).finish()
    };
  }
};
function createBasePacketState() {
  return {
    portId: "",
    channelId: "",
    sequence: Long$2.UZERO,
    data: new Uint8Array()
  };
}
const PacketState = {
  typeUrl: "/ibc.core.channel.v1.PacketState",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.sequence.isZero() || n.uint32(24).uint64(e.sequence), e.data.length !== 0 && n.uint32(34).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacketState();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.sequence = o.uint64();
          break;
        case 4:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBasePacketState();
    return c.portId = (n = e.portId) !== null && n !== void 0 ? n : "", c.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", c.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, c.data = (u = e.data) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      sequence: Long$2.fromString(e.sequence),
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.sequence = e.sequence ? e.sequence.toString() : void 0, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return PacketState.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PacketState",
      value: PacketState.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PacketState.decode(e.value);
  },
  toProto(e) {
    return PacketState.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.PacketState",
      value: PacketState.encode(e).finish()
    };
  }
};
function createBasePacketId() {
  return {
    portId: "",
    channelId: "",
    sequence: Long$2.UZERO
  };
}
const PacketId = {
  typeUrl: "/ibc.core.channel.v1.PacketId",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.sequence.isZero() || n.uint32(24).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacketId();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePacketId();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return PacketId.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PacketId",
      value: PacketId.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PacketId.decode(e.value);
  },
  toProto(e) {
    return PacketId.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.PacketId",
      value: PacketId.encode(e).finish()
    };
  }
};
function createBaseAcknowledgement() {
  return {
    result: void 0,
    error: void 0
  };
}
const Acknowledgement = {
  typeUrl: "/ibc.core.channel.v1.Acknowledgement",
  encode(e, n = minimal.Writer.create()) {
    return e.result !== void 0 && n.uint32(170).bytes(e.result), e.error !== void 0 && n.uint32(178).string(e.error), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAcknowledgement();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 21:
          c.result = o.bytes();
          break;
        case 22:
          c.error = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseAcknowledgement();
    return u.result = (n = e.result) !== null && n !== void 0 ? n : void 0, u.error = (o = e.error) !== null && o !== void 0 ? o : void 0, u;
  },
  fromAmino(e) {
    return {
      result: e == null ? void 0 : e.result,
      error: e == null ? void 0 : e.error
    };
  },
  toAmino(e) {
    const n = {};
    return n.result = e.result, n.error = e.error, n;
  },
  fromAminoMsg(e) {
    return Acknowledgement.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Acknowledgement",
      value: Acknowledgement.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Acknowledgement.decode(e.value);
  },
  toProto(e) {
    return Acknowledgement.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.Acknowledgement",
      value: Acknowledgement.encode(e).finish()
    };
  }
}, _83 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Acknowledgement,
  Channel,
  Counterparty: Counterparty$1,
  IdentifiedChannel,
  get Order() {
    return Order;
  },
  OrderAmino,
  OrderSDKType,
  Packet,
  PacketId,
  PacketState,
  get State() {
    return State$1;
  },
  StateAmino: StateAmino$1,
  StateSDKType: StateSDKType$1,
  orderFromJSON,
  orderToJSON,
  stateFromJSON: stateFromJSON$1,
  stateToJSON: stateToJSON$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseFee() {
  return {
    recvFee: [],
    ackFee: [],
    timeoutFee: []
  };
}
const Fee = {
  typeUrl: "/ibc.applications.fee.v1.Fee",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.recvFee)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.ackFee)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.timeoutFee)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFee();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.recvFee.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.ackFee.push(Coin.decode(o, o.uint32()));
          break;
        case 3:
          c.timeoutFee.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseFee();
    return c.recvFee = ((n = e.recvFee) === null || n === void 0 ? void 0 : n.map((d) => Coin.fromPartial(d))) || [], c.ackFee = ((o = e.ackFee) === null || o === void 0 ? void 0 : o.map((d) => Coin.fromPartial(d))) || [], c.timeoutFee = ((u = e.timeoutFee) === null || u === void 0 ? void 0 : u.map((d) => Coin.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      recvFee: Array.isArray(e == null ? void 0 : e.recv_fee) ? e.recv_fee.map((n) => Coin.fromAmino(n)) : [],
      ackFee: Array.isArray(e == null ? void 0 : e.ack_fee) ? e.ack_fee.map((n) => Coin.fromAmino(n)) : [],
      timeoutFee: Array.isArray(e == null ? void 0 : e.timeout_fee) ? e.timeout_fee.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.recvFee ? n.recv_fee = e.recvFee.map((o) => o ? Coin.toAmino(o) : void 0) : n.recv_fee = [], e.ackFee ? n.ack_fee = e.ackFee.map((o) => o ? Coin.toAmino(o) : void 0) : n.ack_fee = [], e.timeoutFee ? n.timeout_fee = e.timeoutFee.map((o) => o ? Coin.toAmino(o) : void 0) : n.timeout_fee = [], n;
  },
  fromAminoMsg(e) {
    return Fee.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Fee",
      value: Fee.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Fee.decode(e.value);
  },
  toProto(e) {
    return Fee.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.Fee",
      value: Fee.encode(e).finish()
    };
  }
};
function createBasePacketFee() {
  return {
    fee: void 0,
    refundAddress: "",
    relayers: []
  };
}
const PacketFee = {
  typeUrl: "/ibc.applications.fee.v1.PacketFee",
  encode(e, n = minimal.Writer.create()) {
    e.fee !== void 0 && Fee.encode(e.fee, n.uint32(10).fork()).ldelim(), e.refundAddress !== "" && n.uint32(18).string(e.refundAddress);
    for (const o of e.relayers)
      n.uint32(26).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacketFee();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.fee = Fee.decode(o, o.uint32());
          break;
        case 2:
          c.refundAddress = o.string();
          break;
        case 3:
          c.relayers.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePacketFee();
    return u.fee = e.fee !== void 0 && e.fee !== null ? Fee.fromPartial(e.fee) : void 0, u.refundAddress = (n = e.refundAddress) !== null && n !== void 0 ? n : "", u.relayers = ((o = e.relayers) === null || o === void 0 ? void 0 : o.map((c) => c)) || [], u;
  },
  fromAmino(e) {
    return {
      fee: e != null && e.fee ? Fee.fromAmino(e.fee) : void 0,
      refundAddress: e.refund_address,
      relayers: Array.isArray(e == null ? void 0 : e.relayers) ? e.relayers.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.fee = e.fee ? Fee.toAmino(e.fee) : void 0, n.refund_address = e.refundAddress, e.relayers ? n.relayers = e.relayers.map((o) => o) : n.relayers = [], n;
  },
  fromAminoMsg(e) {
    return PacketFee.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PacketFee",
      value: PacketFee.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PacketFee.decode(e.value);
  },
  toProto(e) {
    return PacketFee.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.PacketFee",
      value: PacketFee.encode(e).finish()
    };
  }
};
function createBasePacketFees() {
  return {
    packetFees: []
  };
}
const PacketFees = {
  typeUrl: "/ibc.applications.fee.v1.PacketFees",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.packetFees)
      PacketFee.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacketFees();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packetFees.push(PacketFee.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePacketFees();
    return o.packetFees = ((n = e.packetFees) === null || n === void 0 ? void 0 : n.map((u) => PacketFee.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      packetFees: Array.isArray(e == null ? void 0 : e.packet_fees) ? e.packet_fees.map((n) => PacketFee.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.packetFees ? n.packet_fees = e.packetFees.map((o) => o ? PacketFee.toAmino(o) : void 0) : n.packet_fees = [], n;
  },
  fromAminoMsg(e) {
    return PacketFees.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PacketFees",
      value: PacketFees.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PacketFees.decode(e.value);
  },
  toProto(e) {
    return PacketFees.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.PacketFees",
      value: PacketFees.encode(e).finish()
    };
  }
};
function createBaseIdentifiedPacketFees() {
  return {
    packetId: void 0,
    packetFees: []
  };
}
const IdentifiedPacketFees = {
  typeUrl: "/ibc.applications.fee.v1.IdentifiedPacketFees",
  encode(e, n = minimal.Writer.create()) {
    e.packetId !== void 0 && PacketId.encode(e.packetId, n.uint32(10).fork()).ldelim();
    for (const o of e.packetFees)
      PacketFee.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIdentifiedPacketFees();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packetId = PacketId.decode(o, o.uint32());
          break;
        case 2:
          c.packetFees.push(PacketFee.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseIdentifiedPacketFees();
    return o.packetId = e.packetId !== void 0 && e.packetId !== null ? PacketId.fromPartial(e.packetId) : void 0, o.packetFees = ((n = e.packetFees) === null || n === void 0 ? void 0 : n.map((u) => PacketFee.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      packetId: e != null && e.packet_id ? PacketId.fromAmino(e.packet_id) : void 0,
      packetFees: Array.isArray(e == null ? void 0 : e.packet_fees) ? e.packet_fees.map((n) => PacketFee.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet_id = e.packetId ? PacketId.toAmino(e.packetId) : void 0, e.packetFees ? n.packet_fees = e.packetFees.map((o) => o ? PacketFee.toAmino(o) : void 0) : n.packet_fees = [], n;
  },
  fromAminoMsg(e) {
    return IdentifiedPacketFees.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/IdentifiedPacketFees",
      value: IdentifiedPacketFees.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return IdentifiedPacketFees.decode(e.value);
  },
  toProto(e) {
    return IdentifiedPacketFees.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.IdentifiedPacketFees",
      value: IdentifiedPacketFees.encode(e).finish()
    };
  }
}, _63 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Fee,
  IdentifiedPacketFees,
  PacketFee,
  PacketFees
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$l() {
  return {
    identifiedFees: [],
    feeEnabledChannels: [],
    registeredPayees: [],
    registeredCounterpartyPayees: [],
    forwardRelayers: []
  };
}
const GenesisState$l = {
  typeUrl: "/ibc.applications.fee.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.identifiedFees)
      IdentifiedPacketFees.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.feeEnabledChannels)
      FeeEnabledChannel.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.registeredPayees)
      RegisteredPayee.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.registeredCounterpartyPayees)
      RegisteredCounterpartyPayee.encode(o, n.uint32(34).fork()).ldelim();
    for (const o of e.forwardRelayers)
      ForwardRelayerAddress.encode(o, n.uint32(42).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$l();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.identifiedFees.push(IdentifiedPacketFees.decode(o, o.uint32()));
          break;
        case 2:
          c.feeEnabledChannels.push(FeeEnabledChannel.decode(o, o.uint32()));
          break;
        case 3:
          c.registeredPayees.push(RegisteredPayee.decode(o, o.uint32()));
          break;
        case 4:
          c.registeredCounterpartyPayees.push(RegisteredCounterpartyPayee.decode(o, o.uint32()));
          break;
        case 5:
          c.forwardRelayers.push(ForwardRelayerAddress.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseGenesisState$l();
    return m.identifiedFees = ((n = e.identifiedFees) === null || n === void 0 ? void 0 : n.map((v) => IdentifiedPacketFees.fromPartial(v))) || [], m.feeEnabledChannels = ((o = e.feeEnabledChannels) === null || o === void 0 ? void 0 : o.map((v) => FeeEnabledChannel.fromPartial(v))) || [], m.registeredPayees = ((u = e.registeredPayees) === null || u === void 0 ? void 0 : u.map((v) => RegisteredPayee.fromPartial(v))) || [], m.registeredCounterpartyPayees = ((c = e.registeredCounterpartyPayees) === null || c === void 0 ? void 0 : c.map((v) => RegisteredCounterpartyPayee.fromPartial(v))) || [], m.forwardRelayers = ((d = e.forwardRelayers) === null || d === void 0 ? void 0 : d.map((v) => ForwardRelayerAddress.fromPartial(v))) || [], m;
  },
  fromAmino(e) {
    return {
      identifiedFees: Array.isArray(e == null ? void 0 : e.identified_fees) ? e.identified_fees.map((n) => IdentifiedPacketFees.fromAmino(n)) : [],
      feeEnabledChannels: Array.isArray(e == null ? void 0 : e.fee_enabled_channels) ? e.fee_enabled_channels.map((n) => FeeEnabledChannel.fromAmino(n)) : [],
      registeredPayees: Array.isArray(e == null ? void 0 : e.registered_payees) ? e.registered_payees.map((n) => RegisteredPayee.fromAmino(n)) : [],
      registeredCounterpartyPayees: Array.isArray(e == null ? void 0 : e.registered_counterparty_payees) ? e.registered_counterparty_payees.map((n) => RegisteredCounterpartyPayee.fromAmino(n)) : [],
      forwardRelayers: Array.isArray(e == null ? void 0 : e.forward_relayers) ? e.forward_relayers.map((n) => ForwardRelayerAddress.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.identifiedFees ? n.identified_fees = e.identifiedFees.map((o) => o ? IdentifiedPacketFees.toAmino(o) : void 0) : n.identified_fees = [], e.feeEnabledChannels ? n.fee_enabled_channels = e.feeEnabledChannels.map((o) => o ? FeeEnabledChannel.toAmino(o) : void 0) : n.fee_enabled_channels = [], e.registeredPayees ? n.registered_payees = e.registeredPayees.map((o) => o ? RegisteredPayee.toAmino(o) : void 0) : n.registered_payees = [], e.registeredCounterpartyPayees ? n.registered_counterparty_payees = e.registeredCounterpartyPayees.map((o) => o ? RegisteredCounterpartyPayee.toAmino(o) : void 0) : n.registered_counterparty_payees = [], e.forwardRelayers ? n.forward_relayers = e.forwardRelayers.map((o) => o ? ForwardRelayerAddress.toAmino(o) : void 0) : n.forward_relayers = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$l.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$l.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$l.decode(e.value);
  },
  toProto(e) {
    return GenesisState$l.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.GenesisState",
      value: GenesisState$l.encode(e).finish()
    };
  }
};
function createBaseFeeEnabledChannel() {
  return {
    portId: "",
    channelId: ""
  };
}
const FeeEnabledChannel = {
  typeUrl: "/ibc.applications.fee.v1.FeeEnabledChannel",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFeeEnabledChannel();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseFeeEnabledChannel();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return FeeEnabledChannel.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/FeeEnabledChannel",
      value: FeeEnabledChannel.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return FeeEnabledChannel.decode(e.value);
  },
  toProto(e) {
    return FeeEnabledChannel.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.FeeEnabledChannel",
      value: FeeEnabledChannel.encode(e).finish()
    };
  }
};
function createBaseRegisteredPayee() {
  return {
    channelId: "",
    relayer: "",
    payee: ""
  };
}
const RegisteredPayee = {
  typeUrl: "/ibc.applications.fee.v1.RegisteredPayee",
  encode(e, n = minimal.Writer.create()) {
    return e.channelId !== "" && n.uint32(10).string(e.channelId), e.relayer !== "" && n.uint32(18).string(e.relayer), e.payee !== "" && n.uint32(26).string(e.payee), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRegisteredPayee();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channelId = o.string();
          break;
        case 2:
          c.relayer = o.string();
          break;
        case 3:
          c.payee = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRegisteredPayee();
    return c.channelId = (n = e.channelId) !== null && n !== void 0 ? n : "", c.relayer = (o = e.relayer) !== null && o !== void 0 ? o : "", c.payee = (u = e.payee) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      channelId: e.channel_id,
      relayer: e.relayer,
      payee: e.payee
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel_id = e.channelId, n.relayer = e.relayer, n.payee = e.payee, n;
  },
  fromAminoMsg(e) {
    return RegisteredPayee.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/RegisteredPayee",
      value: RegisteredPayee.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RegisteredPayee.decode(e.value);
  },
  toProto(e) {
    return RegisteredPayee.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.RegisteredPayee",
      value: RegisteredPayee.encode(e).finish()
    };
  }
};
function createBaseRegisteredCounterpartyPayee() {
  return {
    channelId: "",
    relayer: "",
    counterpartyPayee: ""
  };
}
const RegisteredCounterpartyPayee = {
  typeUrl: "/ibc.applications.fee.v1.RegisteredCounterpartyPayee",
  encode(e, n = minimal.Writer.create()) {
    return e.channelId !== "" && n.uint32(10).string(e.channelId), e.relayer !== "" && n.uint32(18).string(e.relayer), e.counterpartyPayee !== "" && n.uint32(26).string(e.counterpartyPayee), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRegisteredCounterpartyPayee();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channelId = o.string();
          break;
        case 2:
          c.relayer = o.string();
          break;
        case 3:
          c.counterpartyPayee = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRegisteredCounterpartyPayee();
    return c.channelId = (n = e.channelId) !== null && n !== void 0 ? n : "", c.relayer = (o = e.relayer) !== null && o !== void 0 ? o : "", c.counterpartyPayee = (u = e.counterpartyPayee) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      channelId: e.channel_id,
      relayer: e.relayer,
      counterpartyPayee: e.counterparty_payee
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel_id = e.channelId, n.relayer = e.relayer, n.counterparty_payee = e.counterpartyPayee, n;
  },
  fromAminoMsg(e) {
    return RegisteredCounterpartyPayee.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/RegisteredCounterpartyPayee",
      value: RegisteredCounterpartyPayee.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RegisteredCounterpartyPayee.decode(e.value);
  },
  toProto(e) {
    return RegisteredCounterpartyPayee.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.RegisteredCounterpartyPayee",
      value: RegisteredCounterpartyPayee.encode(e).finish()
    };
  }
};
function createBaseForwardRelayerAddress() {
  return {
    address: "",
    packetId: void 0
  };
}
const ForwardRelayerAddress = {
  typeUrl: "/ibc.applications.fee.v1.ForwardRelayerAddress",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.packetId !== void 0 && PacketId.encode(e.packetId, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseForwardRelayerAddress();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.packetId = PacketId.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseForwardRelayerAddress();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o.packetId = e.packetId !== void 0 && e.packetId !== null ? PacketId.fromPartial(e.packetId) : void 0, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      packetId: e != null && e.packet_id ? PacketId.fromAmino(e.packet_id) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.packet_id = e.packetId ? PacketId.toAmino(e.packetId) : void 0, n;
  },
  fromAminoMsg(e) {
    return ForwardRelayerAddress.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ForwardRelayerAddress",
      value: ForwardRelayerAddress.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ForwardRelayerAddress.decode(e.value);
  },
  toProto(e) {
    return ForwardRelayerAddress.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.ForwardRelayerAddress",
      value: ForwardRelayerAddress.encode(e).finish()
    };
  }
}, _64 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FeeEnabledChannel,
  ForwardRelayerAddress,
  GenesisState: GenesisState$l,
  RegisteredCounterpartyPayee,
  RegisteredPayee
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMetadata$1() {
  return {
    feeVersion: "",
    appVersion: ""
  };
}
const Metadata$1 = {
  typeUrl: "/ibc.applications.fee.v1.Metadata",
  encode(e, n = minimal.Writer.create()) {
    return e.feeVersion !== "" && n.uint32(10).string(e.feeVersion), e.appVersion !== "" && n.uint32(18).string(e.appVersion), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMetadata$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.feeVersion = o.string();
          break;
        case 2:
          c.appVersion = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMetadata$1();
    return u.feeVersion = (n = e.feeVersion) !== null && n !== void 0 ? n : "", u.appVersion = (o = e.appVersion) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      feeVersion: e.fee_version,
      appVersion: e.app_version
    };
  },
  toAmino(e) {
    const n = {};
    return n.fee_version = e.feeVersion, n.app_version = e.appVersion, n;
  },
  fromAminoMsg(e) {
    return Metadata$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Metadata",
      value: Metadata$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Metadata$1.decode(e.value);
  },
  toProto(e) {
    return Metadata$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.Metadata",
      value: Metadata$1.encode(e).finish()
    };
  }
}, _65 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Metadata: Metadata$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryIncentivizedPacketsRequest() {
  return {
    pagination: void 0,
    queryHeight: Long$2.UZERO
  };
}
const QueryIncentivizedPacketsRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), e.queryHeight.isZero() || n.uint32(16).uint64(e.queryHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryIncentivizedPacketsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        case 2:
          c.queryHeight = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryIncentivizedPacketsRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n.queryHeight = e.queryHeight !== void 0 && e.queryHeight !== null ? Long$2.fromValue(e.queryHeight) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0,
      queryHeight: Long$2.fromString(e.query_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n.query_height = e.queryHeight ? e.queryHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryIncentivizedPacketsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketsRequest",
      value: QueryIncentivizedPacketsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryIncentivizedPacketsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryIncentivizedPacketsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsRequest",
      value: QueryIncentivizedPacketsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryIncentivizedPacketsResponse() {
  return {
    incentivizedPackets: [],
    pagination: void 0
  };
}
const QueryIncentivizedPacketsResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.incentivizedPackets)
      IdentifiedPacketFees.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryIncentivizedPacketsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.incentivizedPackets.push(IdentifiedPacketFees.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryIncentivizedPacketsResponse();
    return o.incentivizedPackets = ((n = e.incentivizedPackets) === null || n === void 0 ? void 0 : n.map((u) => IdentifiedPacketFees.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      incentivizedPackets: Array.isArray(e == null ? void 0 : e.incentivized_packets) ? e.incentivized_packets.map((n) => IdentifiedPacketFees.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.incentivizedPackets ? n.incentivized_packets = e.incentivizedPackets.map((o) => o ? IdentifiedPacketFees.toAmino(o) : void 0) : n.incentivized_packets = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryIncentivizedPacketsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketsResponse",
      value: QueryIncentivizedPacketsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryIncentivizedPacketsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryIncentivizedPacketsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsResponse",
      value: QueryIncentivizedPacketsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryIncentivizedPacketRequest() {
  return {
    packetId: void 0,
    queryHeight: Long$2.UZERO
  };
}
const QueryIncentivizedPacketRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.packetId !== void 0 && PacketId.encode(e.packetId, n.uint32(10).fork()).ldelim(), e.queryHeight.isZero() || n.uint32(16).uint64(e.queryHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryIncentivizedPacketRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packetId = PacketId.decode(o, o.uint32());
          break;
        case 2:
          c.queryHeight = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryIncentivizedPacketRequest();
    return n.packetId = e.packetId !== void 0 && e.packetId !== null ? PacketId.fromPartial(e.packetId) : void 0, n.queryHeight = e.queryHeight !== void 0 && e.queryHeight !== null ? Long$2.fromValue(e.queryHeight) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      packetId: e != null && e.packet_id ? PacketId.fromAmino(e.packet_id) : void 0,
      queryHeight: Long$2.fromString(e.query_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet_id = e.packetId ? PacketId.toAmino(e.packetId) : void 0, n.query_height = e.queryHeight ? e.queryHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryIncentivizedPacketRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketRequest",
      value: QueryIncentivizedPacketRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryIncentivizedPacketRequest.decode(e.value);
  },
  toProto(e) {
    return QueryIncentivizedPacketRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketRequest",
      value: QueryIncentivizedPacketRequest.encode(e).finish()
    };
  }
};
function createBaseQueryIncentivizedPacketResponse() {
  return {
    incentivizedPacket: void 0
  };
}
const QueryIncentivizedPacketResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.incentivizedPacket !== void 0 && IdentifiedPacketFees.encode(e.incentivizedPacket, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryIncentivizedPacketResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.incentivizedPacket = IdentifiedPacketFees.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryIncentivizedPacketResponse();
    return n.incentivizedPacket = e.incentivizedPacket !== void 0 && e.incentivizedPacket !== null ? IdentifiedPacketFees.fromPartial(e.incentivizedPacket) : void 0, n;
  },
  fromAmino(e) {
    return {
      incentivizedPacket: e != null && e.incentivized_packet ? IdentifiedPacketFees.fromAmino(e.incentivized_packet) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.incentivized_packet = e.incentivizedPacket ? IdentifiedPacketFees.toAmino(e.incentivizedPacket) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryIncentivizedPacketResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketResponse",
      value: QueryIncentivizedPacketResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryIncentivizedPacketResponse.decode(e.value);
  },
  toProto(e) {
    return QueryIncentivizedPacketResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketResponse",
      value: QueryIncentivizedPacketResponse.encode(e).finish()
    };
  }
};
function createBaseQueryIncentivizedPacketsForChannelRequest() {
  return {
    pagination: void 0,
    portId: "",
    channelId: "",
    queryHeight: Long$2.UZERO
  };
}
const QueryIncentivizedPacketsForChannelRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsForChannelRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), e.portId !== "" && n.uint32(18).string(e.portId), e.channelId !== "" && n.uint32(26).string(e.channelId), e.queryHeight.isZero() || n.uint32(32).uint64(e.queryHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryIncentivizedPacketsForChannelRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        case 2:
          c.portId = o.string();
          break;
        case 3:
          c.channelId = o.string();
          break;
        case 4:
          c.queryHeight = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryIncentivizedPacketsForChannelRequest();
    return u.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u.queryHeight = e.queryHeight !== void 0 && e.queryHeight !== null ? Long$2.fromValue(e.queryHeight) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0,
      portId: e.port_id,
      channelId: e.channel_id,
      queryHeight: Long$2.fromString(e.query_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n.port_id = e.portId, n.channel_id = e.channelId, n.query_height = e.queryHeight ? e.queryHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryIncentivizedPacketsForChannelRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketsForChannelRequest",
      value: QueryIncentivizedPacketsForChannelRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryIncentivizedPacketsForChannelRequest.decode(e.value);
  },
  toProto(e) {
    return QueryIncentivizedPacketsForChannelRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsForChannelRequest",
      value: QueryIncentivizedPacketsForChannelRequest.encode(e).finish()
    };
  }
};
function createBaseQueryIncentivizedPacketsForChannelResponse() {
  return {
    incentivizedPackets: [],
    pagination: void 0
  };
}
const QueryIncentivizedPacketsForChannelResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsForChannelResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.incentivizedPackets)
      IdentifiedPacketFees.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryIncentivizedPacketsForChannelResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.incentivizedPackets.push(IdentifiedPacketFees.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryIncentivizedPacketsForChannelResponse();
    return o.incentivizedPackets = ((n = e.incentivizedPackets) === null || n === void 0 ? void 0 : n.map((u) => IdentifiedPacketFees.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      incentivizedPackets: Array.isArray(e == null ? void 0 : e.incentivized_packets) ? e.incentivized_packets.map((n) => IdentifiedPacketFees.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.incentivizedPackets ? n.incentivized_packets = e.incentivizedPackets.map((o) => o ? IdentifiedPacketFees.toAmino(o) : void 0) : n.incentivized_packets = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryIncentivizedPacketsForChannelResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketsForChannelResponse",
      value: QueryIncentivizedPacketsForChannelResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryIncentivizedPacketsForChannelResponse.decode(e.value);
  },
  toProto(e) {
    return QueryIncentivizedPacketsForChannelResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsForChannelResponse",
      value: QueryIncentivizedPacketsForChannelResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalRecvFeesRequest() {
  return {
    packetId: void 0
  };
}
const QueryTotalRecvFeesRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalRecvFeesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.packetId !== void 0 && PacketId.encode(e.packetId, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalRecvFeesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packetId = PacketId.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTotalRecvFeesRequest();
    return n.packetId = e.packetId !== void 0 && e.packetId !== null ? PacketId.fromPartial(e.packetId) : void 0, n;
  },
  fromAmino(e) {
    return {
      packetId: e != null && e.packet_id ? PacketId.fromAmino(e.packet_id) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet_id = e.packetId ? PacketId.toAmino(e.packetId) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalRecvFeesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalRecvFeesRequest",
      value: QueryTotalRecvFeesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalRecvFeesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalRecvFeesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalRecvFeesRequest",
      value: QueryTotalRecvFeesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalRecvFeesResponse() {
  return {
    recvFees: []
  };
}
const QueryTotalRecvFeesResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalRecvFeesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.recvFees)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalRecvFeesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.recvFees.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalRecvFeesResponse();
    return o.recvFees = ((n = e.recvFees) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      recvFees: Array.isArray(e == null ? void 0 : e.recv_fees) ? e.recv_fees.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.recvFees ? n.recv_fees = e.recvFees.map((o) => o ? Coin.toAmino(o) : void 0) : n.recv_fees = [], n;
  },
  fromAminoMsg(e) {
    return QueryTotalRecvFeesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalRecvFeesResponse",
      value: QueryTotalRecvFeesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalRecvFeesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalRecvFeesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalRecvFeesResponse",
      value: QueryTotalRecvFeesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalAckFeesRequest() {
  return {
    packetId: void 0
  };
}
const QueryTotalAckFeesRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalAckFeesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.packetId !== void 0 && PacketId.encode(e.packetId, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalAckFeesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packetId = PacketId.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTotalAckFeesRequest();
    return n.packetId = e.packetId !== void 0 && e.packetId !== null ? PacketId.fromPartial(e.packetId) : void 0, n;
  },
  fromAmino(e) {
    return {
      packetId: e != null && e.packet_id ? PacketId.fromAmino(e.packet_id) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet_id = e.packetId ? PacketId.toAmino(e.packetId) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalAckFeesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalAckFeesRequest",
      value: QueryTotalAckFeesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalAckFeesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalAckFeesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalAckFeesRequest",
      value: QueryTotalAckFeesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalAckFeesResponse() {
  return {
    ackFees: []
  };
}
const QueryTotalAckFeesResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalAckFeesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.ackFees)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalAckFeesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.ackFees.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalAckFeesResponse();
    return o.ackFees = ((n = e.ackFees) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      ackFees: Array.isArray(e == null ? void 0 : e.ack_fees) ? e.ack_fees.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.ackFees ? n.ack_fees = e.ackFees.map((o) => o ? Coin.toAmino(o) : void 0) : n.ack_fees = [], n;
  },
  fromAminoMsg(e) {
    return QueryTotalAckFeesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalAckFeesResponse",
      value: QueryTotalAckFeesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalAckFeesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalAckFeesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalAckFeesResponse",
      value: QueryTotalAckFeesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalTimeoutFeesRequest() {
  return {
    packetId: void 0
  };
}
const QueryTotalTimeoutFeesRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalTimeoutFeesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.packetId !== void 0 && PacketId.encode(e.packetId, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalTimeoutFeesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packetId = PacketId.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTotalTimeoutFeesRequest();
    return n.packetId = e.packetId !== void 0 && e.packetId !== null ? PacketId.fromPartial(e.packetId) : void 0, n;
  },
  fromAmino(e) {
    return {
      packetId: e != null && e.packet_id ? PacketId.fromAmino(e.packet_id) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet_id = e.packetId ? PacketId.toAmino(e.packetId) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalTimeoutFeesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalTimeoutFeesRequest",
      value: QueryTotalTimeoutFeesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalTimeoutFeesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalTimeoutFeesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalTimeoutFeesRequest",
      value: QueryTotalTimeoutFeesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalTimeoutFeesResponse() {
  return {
    timeoutFees: []
  };
}
const QueryTotalTimeoutFeesResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalTimeoutFeesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.timeoutFees)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalTimeoutFeesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.timeoutFees.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalTimeoutFeesResponse();
    return o.timeoutFees = ((n = e.timeoutFees) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      timeoutFees: Array.isArray(e == null ? void 0 : e.timeout_fees) ? e.timeout_fees.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.timeoutFees ? n.timeout_fees = e.timeoutFees.map((o) => o ? Coin.toAmino(o) : void 0) : n.timeout_fees = [], n;
  },
  fromAminoMsg(e) {
    return QueryTotalTimeoutFeesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryTotalTimeoutFeesResponse",
      value: QueryTotalTimeoutFeesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalTimeoutFeesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalTimeoutFeesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalTimeoutFeesResponse",
      value: QueryTotalTimeoutFeesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPayeeRequest() {
  return {
    channelId: "",
    relayer: ""
  };
}
const QueryPayeeRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryPayeeRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.channelId !== "" && n.uint32(10).string(e.channelId), e.relayer !== "" && n.uint32(18).string(e.relayer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPayeeRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channelId = o.string();
          break;
        case 2:
          c.relayer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPayeeRequest();
    return u.channelId = (n = e.channelId) !== null && n !== void 0 ? n : "", u.relayer = (o = e.relayer) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      channelId: e.channel_id,
      relayer: e.relayer
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel_id = e.channelId, n.relayer = e.relayer, n;
  },
  fromAminoMsg(e) {
    return QueryPayeeRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPayeeRequest",
      value: QueryPayeeRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPayeeRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPayeeRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryPayeeRequest",
      value: QueryPayeeRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPayeeResponse() {
  return {
    payeeAddress: ""
  };
}
const QueryPayeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryPayeeResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.payeeAddress !== "" && n.uint32(10).string(e.payeeAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPayeeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.payeeAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryPayeeResponse();
    return o.payeeAddress = (n = e.payeeAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      payeeAddress: e.payee_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.payee_address = e.payeeAddress, n;
  },
  fromAminoMsg(e) {
    return QueryPayeeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPayeeResponse",
      value: QueryPayeeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPayeeResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPayeeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryPayeeResponse",
      value: QueryPayeeResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCounterpartyPayeeRequest() {
  return {
    channelId: "",
    relayer: ""
  };
}
const QueryCounterpartyPayeeRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryCounterpartyPayeeRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.channelId !== "" && n.uint32(10).string(e.channelId), e.relayer !== "" && n.uint32(18).string(e.relayer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCounterpartyPayeeRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channelId = o.string();
          break;
        case 2:
          c.relayer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryCounterpartyPayeeRequest();
    return u.channelId = (n = e.channelId) !== null && n !== void 0 ? n : "", u.relayer = (o = e.relayer) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      channelId: e.channel_id,
      relayer: e.relayer
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel_id = e.channelId, n.relayer = e.relayer, n;
  },
  fromAminoMsg(e) {
    return QueryCounterpartyPayeeRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryCounterpartyPayeeRequest",
      value: QueryCounterpartyPayeeRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCounterpartyPayeeRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCounterpartyPayeeRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryCounterpartyPayeeRequest",
      value: QueryCounterpartyPayeeRequest.encode(e).finish()
    };
  }
};
function createBaseQueryCounterpartyPayeeResponse() {
  return {
    counterpartyPayee: ""
  };
}
const QueryCounterpartyPayeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryCounterpartyPayeeResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.counterpartyPayee !== "" && n.uint32(10).string(e.counterpartyPayee), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCounterpartyPayeeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.counterpartyPayee = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCounterpartyPayeeResponse();
    return o.counterpartyPayee = (n = e.counterpartyPayee) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      counterpartyPayee: e.counterparty_payee
    };
  },
  toAmino(e) {
    const n = {};
    return n.counterparty_payee = e.counterpartyPayee, n;
  },
  fromAminoMsg(e) {
    return QueryCounterpartyPayeeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryCounterpartyPayeeResponse",
      value: QueryCounterpartyPayeeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCounterpartyPayeeResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCounterpartyPayeeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryCounterpartyPayeeResponse",
      value: QueryCounterpartyPayeeResponse.encode(e).finish()
    };
  }
};
function createBaseQueryFeeEnabledChannelsRequest() {
  return {
    pagination: void 0,
    queryHeight: Long$2.UZERO
  };
}
const QueryFeeEnabledChannelsRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), e.queryHeight.isZero() || n.uint32(16).uint64(e.queryHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryFeeEnabledChannelsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        case 2:
          c.queryHeight = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryFeeEnabledChannelsRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n.queryHeight = e.queryHeight !== void 0 && e.queryHeight !== null ? Long$2.fromValue(e.queryHeight) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0,
      queryHeight: Long$2.fromString(e.query_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n.query_height = e.queryHeight ? e.queryHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryFeeEnabledChannelsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryFeeEnabledChannelsRequest",
      value: QueryFeeEnabledChannelsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryFeeEnabledChannelsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryFeeEnabledChannelsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelsRequest",
      value: QueryFeeEnabledChannelsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryFeeEnabledChannelsResponse() {
  return {
    feeEnabledChannels: [],
    pagination: void 0
  };
}
const QueryFeeEnabledChannelsResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.feeEnabledChannels)
      FeeEnabledChannel.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryFeeEnabledChannelsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.feeEnabledChannels.push(FeeEnabledChannel.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryFeeEnabledChannelsResponse();
    return o.feeEnabledChannels = ((n = e.feeEnabledChannels) === null || n === void 0 ? void 0 : n.map((u) => FeeEnabledChannel.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      feeEnabledChannels: Array.isArray(e == null ? void 0 : e.fee_enabled_channels) ? e.fee_enabled_channels.map((n) => FeeEnabledChannel.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.feeEnabledChannels ? n.fee_enabled_channels = e.feeEnabledChannels.map((o) => o ? FeeEnabledChannel.toAmino(o) : void 0) : n.fee_enabled_channels = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryFeeEnabledChannelsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryFeeEnabledChannelsResponse",
      value: QueryFeeEnabledChannelsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryFeeEnabledChannelsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryFeeEnabledChannelsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelsResponse",
      value: QueryFeeEnabledChannelsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryFeeEnabledChannelRequest() {
  return {
    portId: "",
    channelId: ""
  };
}
const QueryFeeEnabledChannelRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryFeeEnabledChannelRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryFeeEnabledChannelRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return QueryFeeEnabledChannelRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryFeeEnabledChannelRequest",
      value: QueryFeeEnabledChannelRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryFeeEnabledChannelRequest.decode(e.value);
  },
  toProto(e) {
    return QueryFeeEnabledChannelRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelRequest",
      value: QueryFeeEnabledChannelRequest.encode(e).finish()
    };
  }
};
function createBaseQueryFeeEnabledChannelResponse() {
  return {
    feeEnabled: !1
  };
}
const QueryFeeEnabledChannelResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.feeEnabled === !0 && n.uint32(8).bool(e.feeEnabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryFeeEnabledChannelResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.feeEnabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryFeeEnabledChannelResponse();
    return o.feeEnabled = (n = e.feeEnabled) !== null && n !== void 0 ? n : !1, o;
  },
  fromAmino(e) {
    return {
      feeEnabled: e.fee_enabled
    };
  },
  toAmino(e) {
    const n = {};
    return n.fee_enabled = e.feeEnabled, n;
  },
  fromAminoMsg(e) {
    return QueryFeeEnabledChannelResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryFeeEnabledChannelResponse",
      value: QueryFeeEnabledChannelResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryFeeEnabledChannelResponse.decode(e.value);
  },
  toProto(e) {
    return QueryFeeEnabledChannelResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelResponse",
      value: QueryFeeEnabledChannelResponse.encode(e).finish()
    };
  }
}, _66 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryCounterpartyPayeeRequest,
  QueryCounterpartyPayeeResponse,
  QueryFeeEnabledChannelRequest,
  QueryFeeEnabledChannelResponse,
  QueryFeeEnabledChannelsRequest,
  QueryFeeEnabledChannelsResponse,
  QueryIncentivizedPacketRequest,
  QueryIncentivizedPacketResponse,
  QueryIncentivizedPacketsForChannelRequest,
  QueryIncentivizedPacketsForChannelResponse,
  QueryIncentivizedPacketsRequest,
  QueryIncentivizedPacketsResponse,
  QueryPayeeRequest,
  QueryPayeeResponse,
  QueryTotalAckFeesRequest,
  QueryTotalAckFeesResponse,
  QueryTotalRecvFeesRequest,
  QueryTotalRecvFeesResponse,
  QueryTotalTimeoutFeesRequest,
  QueryTotalTimeoutFeesResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgRegisterPayee() {
  return {
    portId: "",
    channelId: "",
    relayer: "",
    payee: ""
  };
}
const MsgRegisterPayee = {
  typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.relayer !== "" && n.uint32(26).string(e.relayer), e.payee !== "" && n.uint32(34).string(e.payee), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRegisterPayee();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.relayer = o.string();
          break;
        case 4:
          c.payee = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgRegisterPayee();
    return d.portId = (n = e.portId) !== null && n !== void 0 ? n : "", d.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", d.relayer = (u = e.relayer) !== null && u !== void 0 ? u : "", d.payee = (c = e.payee) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      relayer: e.relayer,
      payee: e.payee
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.relayer = e.relayer, n.payee = e.payee, n;
  },
  fromAminoMsg(e) {
    return MsgRegisterPayee.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRegisterPayee",
      value: MsgRegisterPayee.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRegisterPayee.decode(e.value);
  },
  toProto(e) {
    return MsgRegisterPayee.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
      value: MsgRegisterPayee.encode(e).finish()
    };
  }
};
function createBaseMsgRegisterPayeeResponse() {
  return {};
}
const MsgRegisterPayeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayeeResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRegisterPayeeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgRegisterPayeeResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgRegisterPayeeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRegisterPayeeResponse",
      value: MsgRegisterPayeeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRegisterPayeeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgRegisterPayeeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayeeResponse",
      value: MsgRegisterPayeeResponse.encode(e).finish()
    };
  }
};
function createBaseMsgRegisterCounterpartyPayee() {
  return {
    portId: "",
    channelId: "",
    relayer: "",
    counterpartyPayee: ""
  };
}
const MsgRegisterCounterpartyPayee = {
  typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.relayer !== "" && n.uint32(26).string(e.relayer), e.counterpartyPayee !== "" && n.uint32(34).string(e.counterpartyPayee), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRegisterCounterpartyPayee();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.relayer = o.string();
          break;
        case 4:
          c.counterpartyPayee = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgRegisterCounterpartyPayee();
    return d.portId = (n = e.portId) !== null && n !== void 0 ? n : "", d.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", d.relayer = (u = e.relayer) !== null && u !== void 0 ? u : "", d.counterpartyPayee = (c = e.counterpartyPayee) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      relayer: e.relayer,
      counterpartyPayee: e.counterparty_payee
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.relayer = e.relayer, n.counterparty_payee = e.counterpartyPayee, n;
  },
  fromAminoMsg(e) {
    return MsgRegisterCounterpartyPayee.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRegisterCounterpartyPayee",
      value: MsgRegisterCounterpartyPayee.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRegisterCounterpartyPayee.decode(e.value);
  },
  toProto(e) {
    return MsgRegisterCounterpartyPayee.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
      value: MsgRegisterCounterpartyPayee.encode(e).finish()
    };
  }
};
function createBaseMsgRegisterCounterpartyPayeeResponse() {
  return {};
}
const MsgRegisterCounterpartyPayeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayeeResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRegisterCounterpartyPayeeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgRegisterCounterpartyPayeeResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgRegisterCounterpartyPayeeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRegisterCounterpartyPayeeResponse",
      value: MsgRegisterCounterpartyPayeeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRegisterCounterpartyPayeeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgRegisterCounterpartyPayeeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayeeResponse",
      value: MsgRegisterCounterpartyPayeeResponse.encode(e).finish()
    };
  }
};
function createBaseMsgPayPacketFee() {
  return {
    fee: void 0,
    sourcePortId: "",
    sourceChannelId: "",
    signer: "",
    relayers: []
  };
}
const MsgPayPacketFee = {
  typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
  encode(e, n = minimal.Writer.create()) {
    e.fee !== void 0 && Fee.encode(e.fee, n.uint32(10).fork()).ldelim(), e.sourcePortId !== "" && n.uint32(18).string(e.sourcePortId), e.sourceChannelId !== "" && n.uint32(26).string(e.sourceChannelId), e.signer !== "" && n.uint32(34).string(e.signer);
    for (const o of e.relayers)
      n.uint32(42).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgPayPacketFee();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.fee = Fee.decode(o, o.uint32());
          break;
        case 2:
          c.sourcePortId = o.string();
          break;
        case 3:
          c.sourceChannelId = o.string();
          break;
        case 4:
          c.signer = o.string();
          break;
        case 5:
          c.relayers.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgPayPacketFee();
    return d.fee = e.fee !== void 0 && e.fee !== null ? Fee.fromPartial(e.fee) : void 0, d.sourcePortId = (n = e.sourcePortId) !== null && n !== void 0 ? n : "", d.sourceChannelId = (o = e.sourceChannelId) !== null && o !== void 0 ? o : "", d.signer = (u = e.signer) !== null && u !== void 0 ? u : "", d.relayers = ((c = e.relayers) === null || c === void 0 ? void 0 : c.map((m) => m)) || [], d;
  },
  fromAmino(e) {
    return {
      fee: e != null && e.fee ? Fee.fromAmino(e.fee) : void 0,
      sourcePortId: e.source_port_id,
      sourceChannelId: e.source_channel_id,
      signer: e.signer,
      relayers: Array.isArray(e == null ? void 0 : e.relayers) ? e.relayers.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.fee = e.fee ? Fee.toAmino(e.fee) : void 0, n.source_port_id = e.sourcePortId, n.source_channel_id = e.sourceChannelId, n.signer = e.signer, e.relayers ? n.relayers = e.relayers.map((o) => o) : n.relayers = [], n;
  },
  fromAminoMsg(e) {
    return MsgPayPacketFee.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgPayPacketFee",
      value: MsgPayPacketFee.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgPayPacketFee.decode(e.value);
  },
  toProto(e) {
    return MsgPayPacketFee.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
      value: MsgPayPacketFee.encode(e).finish()
    };
  }
};
function createBaseMsgPayPacketFeeResponse() {
  return {};
}
const MsgPayPacketFeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgPayPacketFeeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgPayPacketFeeResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgPayPacketFeeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgPayPacketFeeResponse",
      value: MsgPayPacketFeeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgPayPacketFeeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgPayPacketFeeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeResponse",
      value: MsgPayPacketFeeResponse.encode(e).finish()
    };
  }
};
function createBaseMsgPayPacketFeeAsync() {
  return {
    packetId: void 0,
    packetFee: void 0
  };
}
const MsgPayPacketFeeAsync = {
  typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
  encode(e, n = minimal.Writer.create()) {
    return e.packetId !== void 0 && PacketId.encode(e.packetId, n.uint32(10).fork()).ldelim(), e.packetFee !== void 0 && PacketFee.encode(e.packetFee, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgPayPacketFeeAsync();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packetId = PacketId.decode(o, o.uint32());
          break;
        case 2:
          c.packetFee = PacketFee.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgPayPacketFeeAsync();
    return n.packetId = e.packetId !== void 0 && e.packetId !== null ? PacketId.fromPartial(e.packetId) : void 0, n.packetFee = e.packetFee !== void 0 && e.packetFee !== null ? PacketFee.fromPartial(e.packetFee) : void 0, n;
  },
  fromAmino(e) {
    return {
      packetId: e != null && e.packet_id ? PacketId.fromAmino(e.packet_id) : void 0,
      packetFee: e != null && e.packet_fee ? PacketFee.fromAmino(e.packet_fee) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet_id = e.packetId ? PacketId.toAmino(e.packetId) : void 0, n.packet_fee = e.packetFee ? PacketFee.toAmino(e.packetFee) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgPayPacketFeeAsync.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgPayPacketFeeAsync",
      value: MsgPayPacketFeeAsync.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgPayPacketFeeAsync.decode(e.value);
  },
  toProto(e) {
    return MsgPayPacketFeeAsync.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
      value: MsgPayPacketFeeAsync.encode(e).finish()
    };
  }
};
function createBaseMsgPayPacketFeeAsyncResponse() {
  return {};
}
const MsgPayPacketFeeAsyncResponse = {
  typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsyncResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgPayPacketFeeAsyncResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgPayPacketFeeAsyncResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgPayPacketFeeAsyncResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgPayPacketFeeAsyncResponse",
      value: MsgPayPacketFeeAsyncResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgPayPacketFeeAsyncResponse.decode(e.value);
  },
  toProto(e) {
    return MsgPayPacketFeeAsyncResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsyncResponse",
      value: MsgPayPacketFeeAsyncResponse.encode(e).finish()
    };
  }
}, _67 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgPayPacketFee,
  MsgPayPacketFeeAsync,
  MsgPayPacketFeeAsyncResponse,
  MsgPayPacketFeeResponse,
  MsgRegisterCounterpartyPayee,
  MsgRegisterCounterpartyPayeeResponse,
  MsgRegisterPayee,
  MsgRegisterPayeeResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$f() {
  return {
    controllerEnabled: !1
  };
}
const Params$f = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.controllerEnabled === !0 && n.uint32(8).bool(e.controllerEnabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$f();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.controllerEnabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$f();
    return o.controllerEnabled = (n = e.controllerEnabled) !== null && n !== void 0 ? n : !1, o;
  },
  fromAmino(e) {
    return {
      controllerEnabled: e.controller_enabled
    };
  },
  toAmino(e) {
    const n = {};
    return n.controller_enabled = e.controllerEnabled, n;
  },
  fromAminoMsg(e) {
    return Params$f.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Params",
      value: Params$f.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$f.decode(e.value);
  },
  toProto(e) {
    return Params$f.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.Params",
      value: Params$f.encode(e).finish()
    };
  }
}, _68 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$f
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryInterchainAccountRequest() {
  return {
    owner: "",
    connectionId: ""
  };
}
const QueryInterchainAccountRequest = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryInterchainAccountRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.connectionId !== "" && n.uint32(18).string(e.connectionId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryInterchainAccountRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.connectionId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryInterchainAccountRequest();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.connectionId = (o = e.connectionId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      connectionId: e.connection_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.connection_id = e.connectionId, n;
  },
  fromAminoMsg(e) {
    return QueryInterchainAccountRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryInterchainAccountRequest",
      value: QueryInterchainAccountRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryInterchainAccountRequest.decode(e.value);
  },
  toProto(e) {
    return QueryInterchainAccountRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryInterchainAccountRequest",
      value: QueryInterchainAccountRequest.encode(e).finish()
    };
  }
};
function createBaseQueryInterchainAccountResponse() {
  return {
    address: ""
  };
}
const QueryInterchainAccountResponse = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryInterchainAccountResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryInterchainAccountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryInterchainAccountResponse();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      address: e.address
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n;
  },
  fromAminoMsg(e) {
    return QueryInterchainAccountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryInterchainAccountResponse",
      value: QueryInterchainAccountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryInterchainAccountResponse.decode(e.value);
  },
  toProto(e) {
    return QueryInterchainAccountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryInterchainAccountResponse",
      value: QueryInterchainAccountResponse.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$9() {
  return {};
}
const QueryParamsRequest$9 = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$9();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$9();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$9.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest$9.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$9.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$9.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryParamsRequest",
      value: QueryParamsRequest$9.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$9() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$9 = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$f.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$9();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$f.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$9();
    return n.params = e.params !== void 0 && e.params !== null ? Params$f.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$f.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$f.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$9.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse$9.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$9.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$9.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryParamsResponse",
      value: QueryParamsResponse$9.encode(e).finish()
    };
  }
}, _69 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryInterchainAccountRequest,
  QueryInterchainAccountResponse,
  QueryParamsRequest: QueryParamsRequest$9,
  QueryParamsResponse: QueryParamsResponse$9
}, Symbol.toStringTag, { value: "Module" }));
let Type;
(function(e) {
  e[e.TYPE_UNSPECIFIED = 0] = "TYPE_UNSPECIFIED", e[e.TYPE_EXECUTE_TX = 1] = "TYPE_EXECUTE_TX", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(Type || (Type = {}));
const TypeSDKType = Type, TypeAmino = Type;
function typeFromJSON(e) {
  switch (e) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return Type.TYPE_UNSPECIFIED;
    case 1:
    case "TYPE_EXECUTE_TX":
      return Type.TYPE_EXECUTE_TX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Type.UNRECOGNIZED;
  }
}
function typeToJSON(e) {
  switch (e) {
    case Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case Type.TYPE_EXECUTE_TX:
      return "TYPE_EXECUTE_TX";
    case Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseInterchainAccountPacketData() {
  return {
    type: 0,
    data: new Uint8Array(),
    memo: ""
  };
}
const InterchainAccountPacketData = {
  typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccountPacketData",
  encode(e, n = minimal.Writer.create()) {
    return e.type !== 0 && n.uint32(8).int32(e.type), e.data.length !== 0 && n.uint32(18).bytes(e.data), e.memo !== "" && n.uint32(26).string(e.memo), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInterchainAccountPacketData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.type = o.int32();
          break;
        case 2:
          c.data = o.bytes();
          break;
        case 3:
          c.memo = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseInterchainAccountPacketData();
    return c.type = (n = e.type) !== null && n !== void 0 ? n : 0, c.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), c.memo = (u = e.memo) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      type: isSet(e.type) ? typeFromJSON(e.type) : 0,
      data: e.data,
      memo: e.memo
    };
  },
  toAmino(e) {
    const n = {};
    return n.type = e.type, n.data = e.data, n.memo = e.memo, n;
  },
  fromAminoMsg(e) {
    return InterchainAccountPacketData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/InterchainAccountPacketData",
      value: InterchainAccountPacketData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InterchainAccountPacketData.decode(e.value);
  },
  toProto(e) {
    return InterchainAccountPacketData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccountPacketData",
      value: InterchainAccountPacketData.encode(e).finish()
    };
  }
};
function createBaseCosmosTx() {
  return {
    messages: []
  };
}
const CosmosTx = {
  typeUrl: "/ibc.applications.interchain_accounts.v1.CosmosTx",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.messages)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCosmosTx();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.messages.push(Any.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseCosmosTx();
    return o.messages = ((n = e.messages) === null || n === void 0 ? void 0 : n.map((u) => Any.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      messages: Array.isArray(e == null ? void 0 : e.messages) ? e.messages.map((n) => Any.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.messages ? n.messages = e.messages.map((o) => o ? Any.toAmino(o) : void 0) : n.messages = [], n;
  },
  fromAminoMsg(e) {
    return CosmosTx.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/CosmosTx",
      value: CosmosTx.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CosmosTx.decode(e.value);
  },
  toProto(e) {
    return CosmosTx.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.v1.CosmosTx",
      value: CosmosTx.encode(e).finish()
    };
  }
}, _76 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CosmosTx,
  InterchainAccountPacketData,
  get Type() {
    return Type;
  },
  TypeAmino,
  TypeSDKType,
  typeFromJSON,
  typeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgRegisterInterchainAccount() {
  return {
    owner: "",
    connectionId: "",
    version: ""
  };
}
const MsgRegisterInterchainAccount = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.connectionId !== "" && n.uint32(18).string(e.connectionId), e.version !== "" && n.uint32(26).string(e.version), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRegisterInterchainAccount();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.connectionId = o.string();
          break;
        case 3:
          c.version = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgRegisterInterchainAccount();
    return c.owner = (n = e.owner) !== null && n !== void 0 ? n : "", c.connectionId = (o = e.connectionId) !== null && o !== void 0 ? o : "", c.version = (u = e.version) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      connectionId: e.connection_id,
      version: e.version
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.connection_id = e.connectionId, n.version = e.version, n;
  },
  fromAminoMsg(e) {
    return MsgRegisterInterchainAccount.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRegisterInterchainAccount",
      value: MsgRegisterInterchainAccount.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRegisterInterchainAccount.decode(e.value);
  },
  toProto(e) {
    return MsgRegisterInterchainAccount.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
      value: MsgRegisterInterchainAccount.encode(e).finish()
    };
  }
};
function createBaseMsgRegisterInterchainAccountResponse() {
  return {
    channelId: "",
    portId: ""
  };
}
const MsgRegisterInterchainAccountResponse = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccountResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.channelId !== "" && n.uint32(10).string(e.channelId), e.portId !== "" && n.uint32(18).string(e.portId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRegisterInterchainAccountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channelId = o.string();
          break;
        case 2:
          c.portId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgRegisterInterchainAccountResponse();
    return u.channelId = (n = e.channelId) !== null && n !== void 0 ? n : "", u.portId = (o = e.portId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      channelId: e.channel_id,
      portId: e.port_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel_id = e.channelId, n.port_id = e.portId, n;
  },
  fromAminoMsg(e) {
    return MsgRegisterInterchainAccountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRegisterInterchainAccountResponse",
      value: MsgRegisterInterchainAccountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRegisterInterchainAccountResponse.decode(e.value);
  },
  toProto(e) {
    return MsgRegisterInterchainAccountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccountResponse",
      value: MsgRegisterInterchainAccountResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSendTx() {
  return {
    owner: "",
    connectionId: "",
    packetData: void 0,
    relativeTimeout: Long$2.UZERO
  };
}
const MsgSendTx = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.connectionId !== "" && n.uint32(18).string(e.connectionId), e.packetData !== void 0 && InterchainAccountPacketData.encode(e.packetData, n.uint32(26).fork()).ldelim(), e.relativeTimeout.isZero() || n.uint32(32).uint64(e.relativeTimeout), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSendTx();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.connectionId = o.string();
          break;
        case 3:
          c.packetData = InterchainAccountPacketData.decode(o, o.uint32());
          break;
        case 4:
          c.relativeTimeout = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgSendTx();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.connectionId = (o = e.connectionId) !== null && o !== void 0 ? o : "", u.packetData = e.packetData !== void 0 && e.packetData !== null ? InterchainAccountPacketData.fromPartial(e.packetData) : void 0, u.relativeTimeout = e.relativeTimeout !== void 0 && e.relativeTimeout !== null ? Long$2.fromValue(e.relativeTimeout) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      connectionId: e.connection_id,
      packetData: e != null && e.packet_data ? InterchainAccountPacketData.fromAmino(e.packet_data) : void 0,
      relativeTimeout: Long$2.fromString(e.relative_timeout)
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.connection_id = e.connectionId, n.packet_data = e.packetData ? InterchainAccountPacketData.toAmino(e.packetData) : void 0, n.relative_timeout = e.relativeTimeout ? e.relativeTimeout.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSendTx.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSendTx",
      value: MsgSendTx.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSendTx.decode(e.value);
  },
  toProto(e) {
    return MsgSendTx.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
      value: MsgSendTx.encode(e).finish()
    };
  }
};
function createBaseMsgSendTxResponse() {
  return {
    sequence: Long$2.UZERO
  };
}
const MsgSendTxResponse = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTxResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSendTxResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgSendTxResponse();
    return n.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSendTxResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSendTxResponse",
      value: MsgSendTxResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSendTxResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSendTxResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTxResponse",
      value: MsgSendTxResponse.encode(e).finish()
    };
  }
}, _70 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgRegisterInterchainAccount,
  MsgRegisterInterchainAccountResponse,
  MsgSendTx,
  MsgSendTxResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$e() {
  return {
    hostEnabled: !1,
    allowMessages: []
  };
}
const Params$e = {
  typeUrl: "/ibc.applications.interchain_accounts.host.v1.Params",
  encode(e, n = minimal.Writer.create()) {
    e.hostEnabled === !0 && n.uint32(8).bool(e.hostEnabled);
    for (const o of e.allowMessages)
      n.uint32(18).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$e();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hostEnabled = o.bool();
          break;
        case 2:
          c.allowMessages.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseParams$e();
    return u.hostEnabled = (n = e.hostEnabled) !== null && n !== void 0 ? n : !1, u.allowMessages = ((o = e.allowMessages) === null || o === void 0 ? void 0 : o.map((c) => c)) || [], u;
  },
  fromAmino(e) {
    return {
      hostEnabled: e.host_enabled,
      allowMessages: Array.isArray(e == null ? void 0 : e.allow_messages) ? e.allow_messages.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.host_enabled = e.hostEnabled, e.allowMessages ? n.allow_messages = e.allowMessages.map((o) => o) : n.allow_messages = [], n;
  },
  fromAminoMsg(e) {
    return Params$e.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Params",
      value: Params$e.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$e.decode(e.value);
  },
  toProto(e) {
    return Params$e.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.host.v1.Params",
      value: Params$e.encode(e).finish()
    };
  }
}, _72 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$e
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$k() {
  return {
    controllerGenesisState: void 0,
    hostGenesisState: void 0
  };
}
const GenesisState$k = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    return e.controllerGenesisState !== void 0 && ControllerGenesisState.encode(e.controllerGenesisState, n.uint32(10).fork()).ldelim(), e.hostGenesisState !== void 0 && HostGenesisState.encode(e.hostGenesisState, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$k();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.controllerGenesisState = ControllerGenesisState.decode(o, o.uint32());
          break;
        case 2:
          c.hostGenesisState = HostGenesisState.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGenesisState$k();
    return n.controllerGenesisState = e.controllerGenesisState !== void 0 && e.controllerGenesisState !== null ? ControllerGenesisState.fromPartial(e.controllerGenesisState) : void 0, n.hostGenesisState = e.hostGenesisState !== void 0 && e.hostGenesisState !== null ? HostGenesisState.fromPartial(e.hostGenesisState) : void 0, n;
  },
  fromAmino(e) {
    return {
      controllerGenesisState: e != null && e.controller_genesis_state ? ControllerGenesisState.fromAmino(e.controller_genesis_state) : void 0,
      hostGenesisState: e != null && e.host_genesis_state ? HostGenesisState.fromAmino(e.host_genesis_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.controller_genesis_state = e.controllerGenesisState ? ControllerGenesisState.toAmino(e.controllerGenesisState) : void 0, n.host_genesis_state = e.hostGenesisState ? HostGenesisState.toAmino(e.hostGenesisState) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$k.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$k.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$k.decode(e.value);
  },
  toProto(e) {
    return GenesisState$k.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.GenesisState",
      value: GenesisState$k.encode(e).finish()
    };
  }
};
function createBaseControllerGenesisState() {
  return {
    activeChannels: [],
    interchainAccounts: [],
    ports: [],
    params: void 0
  };
}
const ControllerGenesisState = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.ControllerGenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.activeChannels)
      ActiveChannel.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.interchainAccounts)
      RegisteredInterchainAccount.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.ports)
      n.uint32(26).string(o);
    return e.params !== void 0 && Params$f.encode(e.params, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseControllerGenesisState();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.activeChannels.push(ActiveChannel.decode(o, o.uint32()));
          break;
        case 2:
          c.interchainAccounts.push(RegisteredInterchainAccount.decode(o, o.uint32()));
          break;
        case 3:
          c.ports.push(o.string());
          break;
        case 4:
          c.params = Params$f.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseControllerGenesisState();
    return c.activeChannels = ((n = e.activeChannels) === null || n === void 0 ? void 0 : n.map((d) => ActiveChannel.fromPartial(d))) || [], c.interchainAccounts = ((o = e.interchainAccounts) === null || o === void 0 ? void 0 : o.map((d) => RegisteredInterchainAccount.fromPartial(d))) || [], c.ports = ((u = e.ports) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c.params = e.params !== void 0 && e.params !== null ? Params$f.fromPartial(e.params) : void 0, c;
  },
  fromAmino(e) {
    return {
      activeChannels: Array.isArray(e == null ? void 0 : e.active_channels) ? e.active_channels.map((n) => ActiveChannel.fromAmino(n)) : [],
      interchainAccounts: Array.isArray(e == null ? void 0 : e.interchain_accounts) ? e.interchain_accounts.map((n) => RegisteredInterchainAccount.fromAmino(n)) : [],
      ports: Array.isArray(e == null ? void 0 : e.ports) ? e.ports.map((n) => n) : [],
      params: e != null && e.params ? Params$f.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.activeChannels ? n.active_channels = e.activeChannels.map((o) => o ? ActiveChannel.toAmino(o) : void 0) : n.active_channels = [], e.interchainAccounts ? n.interchain_accounts = e.interchainAccounts.map((o) => o ? RegisteredInterchainAccount.toAmino(o) : void 0) : n.interchain_accounts = [], e.ports ? n.ports = e.ports.map((o) => o) : n.ports = [], n.params = e.params ? Params$f.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return ControllerGenesisState.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ControllerGenesisState",
      value: ControllerGenesisState.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ControllerGenesisState.decode(e.value);
  },
  toProto(e) {
    return ControllerGenesisState.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.ControllerGenesisState",
      value: ControllerGenesisState.encode(e).finish()
    };
  }
};
function createBaseHostGenesisState() {
  return {
    activeChannels: [],
    interchainAccounts: [],
    port: "",
    params: void 0
  };
}
const HostGenesisState = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.HostGenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.activeChannels)
      ActiveChannel.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.interchainAccounts)
      RegisteredInterchainAccount.encode(o, n.uint32(18).fork()).ldelim();
    return e.port !== "" && n.uint32(26).string(e.port), e.params !== void 0 && Params$e.encode(e.params, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHostGenesisState();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.activeChannels.push(ActiveChannel.decode(o, o.uint32()));
          break;
        case 2:
          c.interchainAccounts.push(RegisteredInterchainAccount.decode(o, o.uint32()));
          break;
        case 3:
          c.port = o.string();
          break;
        case 4:
          c.params = Params$e.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseHostGenesisState();
    return c.activeChannels = ((n = e.activeChannels) === null || n === void 0 ? void 0 : n.map((d) => ActiveChannel.fromPartial(d))) || [], c.interchainAccounts = ((o = e.interchainAccounts) === null || o === void 0 ? void 0 : o.map((d) => RegisteredInterchainAccount.fromPartial(d))) || [], c.port = (u = e.port) !== null && u !== void 0 ? u : "", c.params = e.params !== void 0 && e.params !== null ? Params$e.fromPartial(e.params) : void 0, c;
  },
  fromAmino(e) {
    return {
      activeChannels: Array.isArray(e == null ? void 0 : e.active_channels) ? e.active_channels.map((n) => ActiveChannel.fromAmino(n)) : [],
      interchainAccounts: Array.isArray(e == null ? void 0 : e.interchain_accounts) ? e.interchain_accounts.map((n) => RegisteredInterchainAccount.fromAmino(n)) : [],
      port: e.port,
      params: e != null && e.params ? Params$e.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.activeChannels ? n.active_channels = e.activeChannels.map((o) => o ? ActiveChannel.toAmino(o) : void 0) : n.active_channels = [], e.interchainAccounts ? n.interchain_accounts = e.interchainAccounts.map((o) => o ? RegisteredInterchainAccount.toAmino(o) : void 0) : n.interchain_accounts = [], n.port = e.port, n.params = e.params ? Params$e.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return HostGenesisState.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/HostGenesisState",
      value: HostGenesisState.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return HostGenesisState.decode(e.value);
  },
  toProto(e) {
    return HostGenesisState.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.HostGenesisState",
      value: HostGenesisState.encode(e).finish()
    };
  }
};
function createBaseActiveChannel() {
  return {
    connectionId: "",
    portId: "",
    channelId: "",
    isMiddlewareEnabled: !1
  };
}
const ActiveChannel = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.ActiveChannel",
  encode(e, n = minimal.Writer.create()) {
    return e.connectionId !== "" && n.uint32(10).string(e.connectionId), e.portId !== "" && n.uint32(18).string(e.portId), e.channelId !== "" && n.uint32(26).string(e.channelId), e.isMiddlewareEnabled === !0 && n.uint32(32).bool(e.isMiddlewareEnabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseActiveChannel();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connectionId = o.string();
          break;
        case 2:
          c.portId = o.string();
          break;
        case 3:
          c.channelId = o.string();
          break;
        case 4:
          c.isMiddlewareEnabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseActiveChannel();
    return d.connectionId = (n = e.connectionId) !== null && n !== void 0 ? n : "", d.portId = (o = e.portId) !== null && o !== void 0 ? o : "", d.channelId = (u = e.channelId) !== null && u !== void 0 ? u : "", d.isMiddlewareEnabled = (c = e.isMiddlewareEnabled) !== null && c !== void 0 ? c : !1, d;
  },
  fromAmino(e) {
    return {
      connectionId: e.connection_id,
      portId: e.port_id,
      channelId: e.channel_id,
      isMiddlewareEnabled: e.is_middleware_enabled
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection_id = e.connectionId, n.port_id = e.portId, n.channel_id = e.channelId, n.is_middleware_enabled = e.isMiddlewareEnabled, n;
  },
  fromAminoMsg(e) {
    return ActiveChannel.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ActiveChannel",
      value: ActiveChannel.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ActiveChannel.decode(e.value);
  },
  toProto(e) {
    return ActiveChannel.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.ActiveChannel",
      value: ActiveChannel.encode(e).finish()
    };
  }
};
function createBaseRegisteredInterchainAccount() {
  return {
    connectionId: "",
    portId: "",
    accountAddress: ""
  };
}
const RegisteredInterchainAccount = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.RegisteredInterchainAccount",
  encode(e, n = minimal.Writer.create()) {
    return e.connectionId !== "" && n.uint32(10).string(e.connectionId), e.portId !== "" && n.uint32(18).string(e.portId), e.accountAddress !== "" && n.uint32(26).string(e.accountAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRegisteredInterchainAccount();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connectionId = o.string();
          break;
        case 2:
          c.portId = o.string();
          break;
        case 3:
          c.accountAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRegisteredInterchainAccount();
    return c.connectionId = (n = e.connectionId) !== null && n !== void 0 ? n : "", c.portId = (o = e.portId) !== null && o !== void 0 ? o : "", c.accountAddress = (u = e.accountAddress) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      connectionId: e.connection_id,
      portId: e.port_id,
      accountAddress: e.account_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection_id = e.connectionId, n.port_id = e.portId, n.account_address = e.accountAddress, n;
  },
  fromAminoMsg(e) {
    return RegisteredInterchainAccount.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/RegisteredInterchainAccount",
      value: RegisteredInterchainAccount.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RegisteredInterchainAccount.decode(e.value);
  },
  toProto(e) {
    return RegisteredInterchainAccount.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.RegisteredInterchainAccount",
      value: RegisteredInterchainAccount.encode(e).finish()
    };
  }
}, _71 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActiveChannel,
  ControllerGenesisState,
  GenesisState: GenesisState$k,
  HostGenesisState,
  RegisteredInterchainAccount
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryParamsRequest$8() {
  return {};
}
const QueryParamsRequest$8 = {
  typeUrl: "/ibc.applications.interchain_accounts.host.v1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$8();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$8();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$8.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest$8.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$8.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$8.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.host.v1.QueryParamsRequest",
      value: QueryParamsRequest$8.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$8() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$8 = {
  typeUrl: "/ibc.applications.interchain_accounts.host.v1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$e.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$8();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$e.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$8();
    return n.params = e.params !== void 0 && e.params !== null ? Params$e.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$e.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$e.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$8.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse$8.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$8.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$8.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.host.v1.QueryParamsResponse",
      value: QueryParamsResponse$8.encode(e).finish()
    };
  }
}, _73 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryParamsRequest: QueryParamsRequest$8,
  QueryParamsResponse: QueryParamsResponse$8
}, Symbol.toStringTag, { value: "Module" }));
function createBaseInterchainAccount() {
  return {
    $typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccount",
    baseAccount: void 0,
    accountOwner: ""
  };
}
const InterchainAccount = {
  typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccount",
  encode(e, n = minimal.Writer.create()) {
    return e.baseAccount !== void 0 && BaseAccount.encode(e.baseAccount, n.uint32(10).fork()).ldelim(), e.accountOwner !== "" && n.uint32(18).string(e.accountOwner), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInterchainAccount();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.baseAccount = BaseAccount.decode(o, o.uint32());
          break;
        case 2:
          c.accountOwner = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseInterchainAccount();
    return o.baseAccount = e.baseAccount !== void 0 && e.baseAccount !== null ? BaseAccount.fromPartial(e.baseAccount) : void 0, o.accountOwner = (n = e.accountOwner) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      baseAccount: e != null && e.base_account ? BaseAccount.fromAmino(e.base_account) : void 0,
      accountOwner: e.account_owner
    };
  },
  toAmino(e) {
    const n = {};
    return n.base_account = e.baseAccount ? BaseAccount.toAmino(e.baseAccount) : void 0, n.account_owner = e.accountOwner, n;
  },
  fromAminoMsg(e) {
    return InterchainAccount.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/InterchainAccount",
      value: InterchainAccount.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return InterchainAccount.decode(e.value);
  },
  toProto(e) {
    return InterchainAccount.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccount",
      value: InterchainAccount.encode(e).finish()
    };
  }
}, _74 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InterchainAccount
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMetadata() {
  return {
    version: "",
    controllerConnectionId: "",
    hostConnectionId: "",
    address: "",
    encoding: "",
    txType: ""
  };
}
const Metadata = {
  typeUrl: "/ibc.applications.interchain_accounts.v1.Metadata",
  encode(e, n = minimal.Writer.create()) {
    return e.version !== "" && n.uint32(10).string(e.version), e.controllerConnectionId !== "" && n.uint32(18).string(e.controllerConnectionId), e.hostConnectionId !== "" && n.uint32(26).string(e.hostConnectionId), e.address !== "" && n.uint32(34).string(e.address), e.encoding !== "" && n.uint32(42).string(e.encoding), e.txType !== "" && n.uint32(50).string(e.txType), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMetadata();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.version = o.string();
          break;
        case 2:
          c.controllerConnectionId = o.string();
          break;
        case 3:
          c.hostConnectionId = o.string();
          break;
        case 4:
          c.address = o.string();
          break;
        case 5:
          c.encoding = o.string();
          break;
        case 6:
          c.txType = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseMetadata();
    return v.version = (n = e.version) !== null && n !== void 0 ? n : "", v.controllerConnectionId = (o = e.controllerConnectionId) !== null && o !== void 0 ? o : "", v.hostConnectionId = (u = e.hostConnectionId) !== null && u !== void 0 ? u : "", v.address = (c = e.address) !== null && c !== void 0 ? c : "", v.encoding = (d = e.encoding) !== null && d !== void 0 ? d : "", v.txType = (m = e.txType) !== null && m !== void 0 ? m : "", v;
  },
  fromAmino(e) {
    return {
      version: e.version,
      controllerConnectionId: e.controller_connection_id,
      hostConnectionId: e.host_connection_id,
      address: e.address,
      encoding: e.encoding,
      txType: e.tx_type
    };
  },
  toAmino(e) {
    const n = {};
    return n.version = e.version, n.controller_connection_id = e.controllerConnectionId, n.host_connection_id = e.hostConnectionId, n.address = e.address, n.encoding = e.encoding, n.tx_type = e.txType, n;
  },
  fromAminoMsg(e) {
    return Metadata.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Metadata",
      value: Metadata.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Metadata.decode(e.value);
  },
  toProto(e) {
    return Metadata.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.v1.Metadata",
      value: Metadata.encode(e).finish()
    };
  }
}, _75 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Metadata
}, Symbol.toStringTag, { value: "Module" }));
function createBaseAllocation() {
  return {
    sourcePort: "",
    sourceChannel: "",
    spendLimit: [],
    allowList: []
  };
}
const Allocation = {
  typeUrl: "/ibc.applications.transfer.v1.Allocation",
  encode(e, n = minimal.Writer.create()) {
    e.sourcePort !== "" && n.uint32(10).string(e.sourcePort), e.sourceChannel !== "" && n.uint32(18).string(e.sourceChannel);
    for (const o of e.spendLimit)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.allowList)
      n.uint32(34).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAllocation();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sourcePort = o.string();
          break;
        case 2:
          c.sourceChannel = o.string();
          break;
        case 3:
          c.spendLimit.push(Coin.decode(o, o.uint32()));
          break;
        case 4:
          c.allowList.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseAllocation();
    return d.sourcePort = (n = e.sourcePort) !== null && n !== void 0 ? n : "", d.sourceChannel = (o = e.sourceChannel) !== null && o !== void 0 ? o : "", d.spendLimit = ((u = e.spendLimit) === null || u === void 0 ? void 0 : u.map((m) => Coin.fromPartial(m))) || [], d.allowList = ((c = e.allowList) === null || c === void 0 ? void 0 : c.map((m) => m)) || [], d;
  },
  fromAmino(e) {
    return {
      sourcePort: e.source_port,
      sourceChannel: e.source_channel,
      spendLimit: Array.isArray(e == null ? void 0 : e.spend_limit) ? e.spend_limit.map((n) => Coin.fromAmino(n)) : [],
      allowList: Array.isArray(e == null ? void 0 : e.allow_list) ? e.allow_list.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.source_port = e.sourcePort, n.source_channel = e.sourceChannel, e.spendLimit ? n.spend_limit = e.spendLimit.map((o) => o ? Coin.toAmino(o) : void 0) : n.spend_limit = [], e.allowList ? n.allow_list = e.allowList.map((o) => o) : n.allow_list = [], n;
  },
  fromAminoMsg(e) {
    return Allocation.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Allocation",
      value: Allocation.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Allocation.decode(e.value);
  },
  toProto(e) {
    return Allocation.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.Allocation",
      value: Allocation.encode(e).finish()
    };
  }
};
function createBaseTransferAuthorization() {
  return {
    $typeUrl: "/ibc.applications.transfer.v1.TransferAuthorization",
    allocations: []
  };
}
const TransferAuthorization = {
  typeUrl: "/ibc.applications.transfer.v1.TransferAuthorization",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.allocations)
      Allocation.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTransferAuthorization();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.allocations.push(Allocation.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseTransferAuthorization();
    return o.allocations = ((n = e.allocations) === null || n === void 0 ? void 0 : n.map((u) => Allocation.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      allocations: Array.isArray(e == null ? void 0 : e.allocations) ? e.allocations.map((n) => Allocation.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.allocations ? n.allocations = e.allocations.map((o) => o ? Allocation.toAmino(o) : void 0) : n.allocations = [], n;
  },
  fromAminoMsg(e) {
    return TransferAuthorization.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TransferAuthorization",
      value: TransferAuthorization.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TransferAuthorization.decode(e.value);
  },
  toProto(e) {
    return TransferAuthorization.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.TransferAuthorization",
      value: TransferAuthorization.encode(e).finish()
    };
  }
}, _77 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Allocation,
  TransferAuthorization
}, Symbol.toStringTag, { value: "Module" }));
function createBaseDenomTrace() {
  return {
    path: "",
    baseDenom: ""
  };
}
const DenomTrace = {
  typeUrl: "/ibc.applications.transfer.v1.DenomTrace",
  encode(e, n = minimal.Writer.create()) {
    return e.path !== "" && n.uint32(10).string(e.path), e.baseDenom !== "" && n.uint32(18).string(e.baseDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDenomTrace();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.string();
          break;
        case 2:
          c.baseDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDenomTrace();
    return u.path = (n = e.path) !== null && n !== void 0 ? n : "", u.baseDenom = (o = e.baseDenom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      path: e.path,
      baseDenom: e.base_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n.base_denom = e.baseDenom, n;
  },
  fromAminoMsg(e) {
    return DenomTrace.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/DenomTrace",
      value: DenomTrace.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DenomTrace.decode(e.value);
  },
  toProto(e) {
    return DenomTrace.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.DenomTrace",
      value: DenomTrace.encode(e).finish()
    };
  }
};
function createBaseParams$d() {
  return {
    sendEnabled: !1,
    receiveEnabled: !1
  };
}
const Params$d = {
  typeUrl: "/ibc.applications.transfer.v1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.sendEnabled === !0 && n.uint32(8).bool(e.sendEnabled), e.receiveEnabled === !0 && n.uint32(16).bool(e.receiveEnabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$d();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sendEnabled = o.bool();
          break;
        case 2:
          c.receiveEnabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseParams$d();
    return u.sendEnabled = (n = e.sendEnabled) !== null && n !== void 0 ? n : !1, u.receiveEnabled = (o = e.receiveEnabled) !== null && o !== void 0 ? o : !1, u;
  },
  fromAmino(e) {
    return {
      sendEnabled: e.send_enabled,
      receiveEnabled: e.receive_enabled
    };
  },
  toAmino(e) {
    const n = {};
    return n.send_enabled = e.sendEnabled, n.receive_enabled = e.receiveEnabled, n;
  },
  fromAminoMsg(e) {
    return Params$d.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Params",
      value: Params$d.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$d.decode(e.value);
  },
  toProto(e) {
    return Params$d.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.Params",
      value: Params$d.encode(e).finish()
    };
  }
}, _80 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DenomTrace,
  Params: Params$d
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$j() {
  return {
    portId: "",
    denomTraces: [],
    params: void 0
  };
}
const GenesisState$j = {
  typeUrl: "/ibc.applications.transfer.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.portId !== "" && n.uint32(10).string(e.portId);
    for (const o of e.denomTraces)
      DenomTrace.encode(o, n.uint32(18).fork()).ldelim();
    return e.params !== void 0 && Params$d.encode(e.params, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$j();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.denomTraces.push(DenomTrace.decode(o, o.uint32()));
          break;
        case 3:
          c.params = Params$d.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisState$j();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.denomTraces = ((o = e.denomTraces) === null || o === void 0 ? void 0 : o.map((c) => DenomTrace.fromPartial(c))) || [], u.params = e.params !== void 0 && e.params !== null ? Params$d.fromPartial(e.params) : void 0, u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      denomTraces: Array.isArray(e == null ? void 0 : e.denom_traces) ? e.denom_traces.map((n) => DenomTrace.fromAmino(n)) : [],
      params: e != null && e.params ? Params$d.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, e.denomTraces ? n.denom_traces = e.denomTraces.map((o) => o ? DenomTrace.toAmino(o) : void 0) : n.denom_traces = [], n.params = e.params ? Params$d.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$j.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$j.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$j.decode(e.value);
  },
  toProto(e) {
    return GenesisState$j.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.GenesisState",
      value: GenesisState$j.encode(e).finish()
    };
  }
}, _78 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$j
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryDenomTraceRequest() {
  return {
    hash: ""
  };
}
const QueryDenomTraceRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.hash !== "" && n.uint32(10).string(e.hash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomTraceRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomTraceRequest();
    return o.hash = (n = e.hash) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      hash: e.hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n;
  },
  fromAminoMsg(e) {
    return QueryDenomTraceRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomTraceRequest",
      value: QueryDenomTraceRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomTraceRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomTraceRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceRequest",
      value: QueryDenomTraceRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomTraceResponse() {
  return {
    denomTrace: void 0
  };
}
const QueryDenomTraceResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.denomTrace !== void 0 && DenomTrace.encode(e.denomTrace, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomTraceResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denomTrace = DenomTrace.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDenomTraceResponse();
    return n.denomTrace = e.denomTrace !== void 0 && e.denomTrace !== null ? DenomTrace.fromPartial(e.denomTrace) : void 0, n;
  },
  fromAmino(e) {
    return {
      denomTrace: e != null && e.denom_trace ? DenomTrace.fromAmino(e.denom_trace) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom_trace = e.denomTrace ? DenomTrace.toAmino(e.denomTrace) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDenomTraceResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomTraceResponse",
      value: QueryDenomTraceResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomTraceResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomTraceResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceResponse",
      value: QueryDenomTraceResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDenomTracesRequest() {
  return {
    pagination: void 0
  };
}
const QueryDenomTracesRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomTracesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDenomTracesRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDenomTracesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomTracesRequest",
      value: QueryDenomTracesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomTracesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomTracesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesRequest",
      value: QueryDenomTracesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomTracesResponse() {
  return {
    denomTraces: [],
    pagination: void 0
  };
}
const QueryDenomTracesResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.denomTraces)
      DenomTrace.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomTracesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denomTraces.push(DenomTrace.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomTracesResponse();
    return o.denomTraces = ((n = e.denomTraces) === null || n === void 0 ? void 0 : n.map((u) => DenomTrace.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      denomTraces: Array.isArray(e == null ? void 0 : e.denom_traces) ? e.denom_traces.map((n) => DenomTrace.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.denomTraces ? n.denom_traces = e.denomTraces.map((o) => o ? DenomTrace.toAmino(o) : void 0) : n.denom_traces = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDenomTracesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomTracesResponse",
      value: QueryDenomTracesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomTracesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomTracesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesResponse",
      value: QueryDenomTracesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$7() {
  return {};
}
const QueryParamsRequest$7 = {
  typeUrl: "/ibc.applications.transfer.v1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$7();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$7();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$7.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest$7.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$7.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$7.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryParamsRequest",
      value: QueryParamsRequest$7.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$7() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$7 = {
  typeUrl: "/ibc.applications.transfer.v1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$d.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$7();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$d.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$7();
    return n.params = e.params !== void 0 && e.params !== null ? Params$d.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$d.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$d.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$7.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse$7.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$7.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$7.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryParamsResponse",
      value: QueryParamsResponse$7.encode(e).finish()
    };
  }
};
function createBaseQueryDenomHashRequest() {
  return {
    trace: ""
  };
}
const QueryDenomHashRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.trace !== "" && n.uint32(10).string(e.trace), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomHashRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.trace = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomHashRequest();
    return o.trace = (n = e.trace) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      trace: e.trace
    };
  },
  toAmino(e) {
    const n = {};
    return n.trace = e.trace, n;
  },
  fromAminoMsg(e) {
    return QueryDenomHashRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomHashRequest",
      value: QueryDenomHashRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomHashRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomHashRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashRequest",
      value: QueryDenomHashRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomHashResponse() {
  return {
    hash: ""
  };
}
const QueryDenomHashResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.hash !== "" && n.uint32(10).string(e.hash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomHashResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomHashResponse();
    return o.hash = (n = e.hash) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      hash: e.hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n;
  },
  fromAminoMsg(e) {
    return QueryDenomHashResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryDenomHashResponse",
      value: QueryDenomHashResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomHashResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomHashResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashResponse",
      value: QueryDenomHashResponse.encode(e).finish()
    };
  }
};
function createBaseQueryEscrowAddressRequest() {
  return {
    portId: "",
    channelId: ""
  };
}
const QueryEscrowAddressRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryEscrowAddressRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryEscrowAddressRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return QueryEscrowAddressRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryEscrowAddressRequest",
      value: QueryEscrowAddressRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryEscrowAddressRequest.decode(e.value);
  },
  toProto(e) {
    return QueryEscrowAddressRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressRequest",
      value: QueryEscrowAddressRequest.encode(e).finish()
    };
  }
};
function createBaseQueryEscrowAddressResponse() {
  return {
    escrowAddress: ""
  };
}
const QueryEscrowAddressResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.escrowAddress !== "" && n.uint32(10).string(e.escrowAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryEscrowAddressResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.escrowAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryEscrowAddressResponse();
    return o.escrowAddress = (n = e.escrowAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      escrowAddress: e.escrow_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.escrow_address = e.escrowAddress, n;
  },
  fromAminoMsg(e) {
    return QueryEscrowAddressResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryEscrowAddressResponse",
      value: QueryEscrowAddressResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryEscrowAddressResponse.decode(e.value);
  },
  toProto(e) {
    return QueryEscrowAddressResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressResponse",
      value: QueryEscrowAddressResponse.encode(e).finish()
    };
  }
}, _79 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryDenomHashRequest,
  QueryDenomHashResponse,
  QueryDenomTraceRequest,
  QueryDenomTraceResponse,
  QueryDenomTracesRequest,
  QueryDenomTracesResponse,
  QueryEscrowAddressRequest,
  QueryEscrowAddressResponse,
  QueryParamsRequest: QueryParamsRequest$7,
  QueryParamsResponse: QueryParamsResponse$7
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgTransfer() {
  return {
    sourcePort: "",
    sourceChannel: "",
    token: void 0,
    sender: "",
    receiver: "",
    timeoutHeight: void 0,
    timeoutTimestamp: Long$2.UZERO,
    memo: ""
  };
}
const MsgTransfer = {
  typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
  encode(e, n = minimal.Writer.create()) {
    return e.sourcePort !== "" && n.uint32(10).string(e.sourcePort), e.sourceChannel !== "" && n.uint32(18).string(e.sourceChannel), e.token !== void 0 && Coin.encode(e.token, n.uint32(26).fork()).ldelim(), e.sender !== "" && n.uint32(34).string(e.sender), e.receiver !== "" && n.uint32(42).string(e.receiver), e.timeoutHeight !== void 0 && Height.encode(e.timeoutHeight, n.uint32(50).fork()).ldelim(), e.timeoutTimestamp.isZero() || n.uint32(56).uint64(e.timeoutTimestamp), e.memo !== "" && n.uint32(66).string(e.memo), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgTransfer();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sourcePort = o.string();
          break;
        case 2:
          c.sourceChannel = o.string();
          break;
        case 3:
          c.token = Coin.decode(o, o.uint32());
          break;
        case 4:
          c.sender = o.string();
          break;
        case 5:
          c.receiver = o.string();
          break;
        case 6:
          c.timeoutHeight = Height.decode(o, o.uint32());
          break;
        case 7:
          c.timeoutTimestamp = o.uint64();
          break;
        case 8:
          c.memo = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseMsgTransfer();
    return m.sourcePort = (n = e.sourcePort) !== null && n !== void 0 ? n : "", m.sourceChannel = (o = e.sourceChannel) !== null && o !== void 0 ? o : "", m.token = e.token !== void 0 && e.token !== null ? Coin.fromPartial(e.token) : void 0, m.sender = (u = e.sender) !== null && u !== void 0 ? u : "", m.receiver = (c = e.receiver) !== null && c !== void 0 ? c : "", m.timeoutHeight = e.timeoutHeight !== void 0 && e.timeoutHeight !== null ? Height.fromPartial(e.timeoutHeight) : void 0, m.timeoutTimestamp = e.timeoutTimestamp !== void 0 && e.timeoutTimestamp !== null ? Long$2.fromValue(e.timeoutTimestamp) : Long$2.UZERO, m.memo = (d = e.memo) !== null && d !== void 0 ? d : "", m;
  },
  fromAmino(e) {
    return {
      sourcePort: e.source_port,
      sourceChannel: e.source_channel,
      token: e != null && e.token ? Coin.fromAmino(e.token) : void 0,
      sender: e.sender,
      receiver: e.receiver,
      timeoutHeight: e != null && e.timeout_height ? Height.fromAmino(e.timeout_height) : void 0,
      timeoutTimestamp: Long$2.fromString(e.timeout_timestamp),
      memo: e.memo
    };
  },
  toAmino(e) {
    const n = {};
    return n.source_port = e.sourcePort, n.source_channel = e.sourceChannel, n.token = e.token ? Coin.toAmino(e.token) : void 0, n.sender = e.sender, n.receiver = e.receiver, n.timeout_height = e.timeoutHeight ? Height.toAmino(e.timeoutHeight) : {}, n.timeout_timestamp = e.timeoutTimestamp ? e.timeoutTimestamp.toString() : void 0, n.memo = e.memo, n;
  },
  fromAminoMsg(e) {
    return MsgTransfer.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgTransfer",
      value: MsgTransfer.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgTransfer.decode(e.value);
  },
  toProto(e) {
    return MsgTransfer.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
      value: MsgTransfer.encode(e).finish()
    };
  }
};
function createBaseMsgTransferResponse() {
  return {
    sequence: Long$2.UZERO
  };
}
const MsgTransferResponse = {
  typeUrl: "/ibc.applications.transfer.v1.MsgTransferResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgTransferResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgTransferResponse();
    return n.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgTransferResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgTransferResponse",
      value: MsgTransferResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgTransferResponse.decode(e.value);
  },
  toProto(e) {
    return MsgTransferResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.MsgTransferResponse",
      value: MsgTransferResponse.encode(e).finish()
    };
  }
}, _81 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgTransfer,
  MsgTransferResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseFungibleTokenPacketData() {
  return {
    denom: "",
    amount: "",
    sender: "",
    receiver: "",
    memo: ""
  };
}
const FungibleTokenPacketData = {
  typeUrl: "/ibc.applications.transfer.v2.FungibleTokenPacketData",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.amount !== "" && n.uint32(18).string(e.amount), e.sender !== "" && n.uint32(26).string(e.sender), e.receiver !== "" && n.uint32(34).string(e.receiver), e.memo !== "" && n.uint32(42).string(e.memo), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFungibleTokenPacketData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.amount = o.string();
          break;
        case 3:
          c.sender = o.string();
          break;
        case 4:
          c.receiver = o.string();
          break;
        case 5:
          c.memo = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseFungibleTokenPacketData();
    return m.denom = (n = e.denom) !== null && n !== void 0 ? n : "", m.amount = (o = e.amount) !== null && o !== void 0 ? o : "", m.sender = (u = e.sender) !== null && u !== void 0 ? u : "", m.receiver = (c = e.receiver) !== null && c !== void 0 ? c : "", m.memo = (d = e.memo) !== null && d !== void 0 ? d : "", m;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      amount: e.amount,
      sender: e.sender,
      receiver: e.receiver,
      memo: e.memo
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.amount = e.amount, n.sender = e.sender, n.receiver = e.receiver, n.memo = e.memo, n;
  },
  fromAminoMsg(e) {
    return FungibleTokenPacketData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/FungibleTokenPacketData",
      value: FungibleTokenPacketData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return FungibleTokenPacketData.decode(e.value);
  },
  toProto(e) {
    return FungibleTokenPacketData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.applications.transfer.v2.FungibleTokenPacketData",
      value: FungibleTokenPacketData.encode(e).finish()
    };
  }
}, _82 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FungibleTokenPacketData
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$i() {
  return {
    channels: [],
    acknowledgements: [],
    commitments: [],
    receipts: [],
    sendSequences: [],
    recvSequences: [],
    ackSequences: [],
    nextChannelSequence: Long$2.UZERO
  };
}
const GenesisState$i = {
  typeUrl: "/ibc.core.channel.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.channels)
      IdentifiedChannel.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.acknowledgements)
      PacketState.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.commitments)
      PacketState.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.receipts)
      PacketState.encode(o, n.uint32(34).fork()).ldelim();
    for (const o of e.sendSequences)
      PacketSequence.encode(o, n.uint32(42).fork()).ldelim();
    for (const o of e.recvSequences)
      PacketSequence.encode(o, n.uint32(50).fork()).ldelim();
    for (const o of e.ackSequences)
      PacketSequence.encode(o, n.uint32(58).fork()).ldelim();
    return e.nextChannelSequence.isZero() || n.uint32(64).uint64(e.nextChannelSequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$i();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channels.push(IdentifiedChannel.decode(o, o.uint32()));
          break;
        case 2:
          c.acknowledgements.push(PacketState.decode(o, o.uint32()));
          break;
        case 3:
          c.commitments.push(PacketState.decode(o, o.uint32()));
          break;
        case 4:
          c.receipts.push(PacketState.decode(o, o.uint32()));
          break;
        case 5:
          c.sendSequences.push(PacketSequence.decode(o, o.uint32()));
          break;
        case 6:
          c.recvSequences.push(PacketSequence.decode(o, o.uint32()));
          break;
        case 7:
          c.ackSequences.push(PacketSequence.decode(o, o.uint32()));
          break;
        case 8:
          c.nextChannelSequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v;
    const S = createBaseGenesisState$i();
    return S.channels = ((n = e.channels) === null || n === void 0 ? void 0 : n.map(($) => IdentifiedChannel.fromPartial($))) || [], S.acknowledgements = ((o = e.acknowledgements) === null || o === void 0 ? void 0 : o.map(($) => PacketState.fromPartial($))) || [], S.commitments = ((u = e.commitments) === null || u === void 0 ? void 0 : u.map(($) => PacketState.fromPartial($))) || [], S.receipts = ((c = e.receipts) === null || c === void 0 ? void 0 : c.map(($) => PacketState.fromPartial($))) || [], S.sendSequences = ((d = e.sendSequences) === null || d === void 0 ? void 0 : d.map(($) => PacketSequence.fromPartial($))) || [], S.recvSequences = ((m = e.recvSequences) === null || m === void 0 ? void 0 : m.map(($) => PacketSequence.fromPartial($))) || [], S.ackSequences = ((v = e.ackSequences) === null || v === void 0 ? void 0 : v.map(($) => PacketSequence.fromPartial($))) || [], S.nextChannelSequence = e.nextChannelSequence !== void 0 && e.nextChannelSequence !== null ? Long$2.fromValue(e.nextChannelSequence) : Long$2.UZERO, S;
  },
  fromAmino(e) {
    return {
      channels: Array.isArray(e == null ? void 0 : e.channels) ? e.channels.map((n) => IdentifiedChannel.fromAmino(n)) : [],
      acknowledgements: Array.isArray(e == null ? void 0 : e.acknowledgements) ? e.acknowledgements.map((n) => PacketState.fromAmino(n)) : [],
      commitments: Array.isArray(e == null ? void 0 : e.commitments) ? e.commitments.map((n) => PacketState.fromAmino(n)) : [],
      receipts: Array.isArray(e == null ? void 0 : e.receipts) ? e.receipts.map((n) => PacketState.fromAmino(n)) : [],
      sendSequences: Array.isArray(e == null ? void 0 : e.send_sequences) ? e.send_sequences.map((n) => PacketSequence.fromAmino(n)) : [],
      recvSequences: Array.isArray(e == null ? void 0 : e.recv_sequences) ? e.recv_sequences.map((n) => PacketSequence.fromAmino(n)) : [],
      ackSequences: Array.isArray(e == null ? void 0 : e.ack_sequences) ? e.ack_sequences.map((n) => PacketSequence.fromAmino(n)) : [],
      nextChannelSequence: Long$2.fromString(e.next_channel_sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return e.channels ? n.channels = e.channels.map((o) => o ? IdentifiedChannel.toAmino(o) : void 0) : n.channels = [], e.acknowledgements ? n.acknowledgements = e.acknowledgements.map((o) => o ? PacketState.toAmino(o) : void 0) : n.acknowledgements = [], e.commitments ? n.commitments = e.commitments.map((o) => o ? PacketState.toAmino(o) : void 0) : n.commitments = [], e.receipts ? n.receipts = e.receipts.map((o) => o ? PacketState.toAmino(o) : void 0) : n.receipts = [], e.sendSequences ? n.send_sequences = e.sendSequences.map((o) => o ? PacketSequence.toAmino(o) : void 0) : n.send_sequences = [], e.recvSequences ? n.recv_sequences = e.recvSequences.map((o) => o ? PacketSequence.toAmino(o) : void 0) : n.recv_sequences = [], e.ackSequences ? n.ack_sequences = e.ackSequences.map((o) => o ? PacketSequence.toAmino(o) : void 0) : n.ack_sequences = [], n.next_channel_sequence = e.nextChannelSequence ? e.nextChannelSequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$i.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$i.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$i.decode(e.value);
  },
  toProto(e) {
    return GenesisState$i.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.GenesisState",
      value: GenesisState$i.encode(e).finish()
    };
  }
};
function createBasePacketSequence() {
  return {
    portId: "",
    channelId: "",
    sequence: Long$2.UZERO
  };
}
const PacketSequence = {
  typeUrl: "/ibc.core.channel.v1.PacketSequence",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.sequence.isZero() || n.uint32(24).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacketSequence();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePacketSequence();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return PacketSequence.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PacketSequence",
      value: PacketSequence.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PacketSequence.decode(e.value);
  },
  toProto(e) {
    return PacketSequence.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.PacketSequence",
      value: PacketSequence.encode(e).finish()
    };
  }
}, _84 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$i,
  PacketSequence
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryChannelRequest() {
  return {
    portId: "",
    channelId: ""
  };
}
const QueryChannelRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryChannelRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryChannelRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return QueryChannelRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryChannelRequest",
      value: QueryChannelRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryChannelRequest.decode(e.value);
  },
  toProto(e) {
    return QueryChannelRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelRequest",
      value: QueryChannelRequest.encode(e).finish()
    };
  }
};
function createBaseQueryChannelResponse() {
  return {
    channel: void 0,
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryChannelResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.channel !== void 0 && Channel.encode(e.channel, n.uint32(10).fork()).ldelim(), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryChannelResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channel = Channel.decode(o, o.uint32());
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryChannelResponse();
    return o.channel = e.channel !== void 0 && e.channel !== null ? Channel.fromPartial(e.channel) : void 0, o.proof = (n = e.proof) !== null && n !== void 0 ? n : new Uint8Array(), o.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, o;
  },
  fromAmino(e) {
    return {
      channel: e != null && e.channel ? Channel.fromAmino(e.channel) : void 0,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel = e.channel ? Channel.toAmino(e.channel) : void 0, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryChannelResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryChannelResponse",
      value: QueryChannelResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryChannelResponse.decode(e.value);
  },
  toProto(e) {
    return QueryChannelResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelResponse",
      value: QueryChannelResponse.encode(e).finish()
    };
  }
};
function createBaseQueryChannelsRequest() {
  return {
    pagination: void 0
  };
}
const QueryChannelsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryChannelsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryChannelsRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryChannelsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryChannelsRequest",
      value: QueryChannelsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryChannelsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryChannelsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelsRequest",
      value: QueryChannelsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryChannelsResponse() {
  return {
    channels: [],
    pagination: void 0,
    height: void 0
  };
}
const QueryChannelsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.channels)
      IdentifiedChannel.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), e.height !== void 0 && Height.encode(e.height, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryChannelsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channels.push(IdentifiedChannel.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        case 3:
          c.height = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryChannelsResponse();
    return o.channels = ((n = e.channels) === null || n === void 0 ? void 0 : n.map((u) => IdentifiedChannel.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o.height = e.height !== void 0 && e.height !== null ? Height.fromPartial(e.height) : void 0, o;
  },
  fromAmino(e) {
    return {
      channels: Array.isArray(e == null ? void 0 : e.channels) ? e.channels.map((n) => IdentifiedChannel.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0,
      height: e != null && e.height ? Height.fromAmino(e.height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.channels ? n.channels = e.channels.map((o) => o ? IdentifiedChannel.toAmino(o) : void 0) : n.channels = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n.height = e.height ? Height.toAmino(e.height) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryChannelsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryChannelsResponse",
      value: QueryChannelsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryChannelsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryChannelsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelsResponse",
      value: QueryChannelsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionChannelsRequest() {
  return {
    connection: "",
    pagination: void 0
  };
}
const QueryConnectionChannelsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.connection !== "" && n.uint32(10).string(e.connection), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionChannelsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connection = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConnectionChannelsRequest();
    return o.connection = (n = e.connection) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      connection: e.connection,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection = e.connection, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionChannelsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionChannelsRequest",
      value: QueryConnectionChannelsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionChannelsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionChannelsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsRequest",
      value: QueryConnectionChannelsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionChannelsResponse() {
  return {
    channels: [],
    pagination: void 0,
    height: void 0
  };
}
const QueryConnectionChannelsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.channels)
      IdentifiedChannel.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), e.height !== void 0 && Height.encode(e.height, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionChannelsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channels.push(IdentifiedChannel.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        case 3:
          c.height = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConnectionChannelsResponse();
    return o.channels = ((n = e.channels) === null || n === void 0 ? void 0 : n.map((u) => IdentifiedChannel.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o.height = e.height !== void 0 && e.height !== null ? Height.fromPartial(e.height) : void 0, o;
  },
  fromAmino(e) {
    return {
      channels: Array.isArray(e == null ? void 0 : e.channels) ? e.channels.map((n) => IdentifiedChannel.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0,
      height: e != null && e.height ? Height.fromAmino(e.height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.channels ? n.channels = e.channels.map((o) => o ? IdentifiedChannel.toAmino(o) : void 0) : n.channels = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n.height = e.height ? Height.toAmino(e.height) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionChannelsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionChannelsResponse",
      value: QueryConnectionChannelsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionChannelsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionChannelsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsResponse",
      value: QueryConnectionChannelsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryChannelClientStateRequest() {
  return {
    portId: "",
    channelId: ""
  };
}
const QueryChannelClientStateRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryChannelClientStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryChannelClientStateRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return QueryChannelClientStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryChannelClientStateRequest",
      value: QueryChannelClientStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryChannelClientStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryChannelClientStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateRequest",
      value: QueryChannelClientStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryChannelClientStateResponse() {
  return {
    identifiedClientState: void 0,
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryChannelClientStateResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.identifiedClientState !== void 0 && IdentifiedClientState.encode(e.identifiedClientState, n.uint32(10).fork()).ldelim(), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryChannelClientStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.identifiedClientState = IdentifiedClientState.decode(o, o.uint32());
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryChannelClientStateResponse();
    return o.identifiedClientState = e.identifiedClientState !== void 0 && e.identifiedClientState !== null ? IdentifiedClientState.fromPartial(e.identifiedClientState) : void 0, o.proof = (n = e.proof) !== null && n !== void 0 ? n : new Uint8Array(), o.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, o;
  },
  fromAmino(e) {
    return {
      identifiedClientState: e != null && e.identified_client_state ? IdentifiedClientState.fromAmino(e.identified_client_state) : void 0,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.identified_client_state = e.identifiedClientState ? IdentifiedClientState.toAmino(e.identifiedClientState) : void 0, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryChannelClientStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryChannelClientStateResponse",
      value: QueryChannelClientStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryChannelClientStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryChannelClientStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateResponse",
      value: QueryChannelClientStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryChannelConsensusStateRequest() {
  return {
    portId: "",
    channelId: "",
    revisionNumber: Long$2.UZERO,
    revisionHeight: Long$2.UZERO
  };
}
const QueryChannelConsensusStateRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.revisionNumber.isZero() || n.uint32(24).uint64(e.revisionNumber), e.revisionHeight.isZero() || n.uint32(32).uint64(e.revisionHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryChannelConsensusStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.revisionNumber = o.uint64();
          break;
        case 4:
          c.revisionHeight = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryChannelConsensusStateRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u.revisionNumber = e.revisionNumber !== void 0 && e.revisionNumber !== null ? Long$2.fromValue(e.revisionNumber) : Long$2.UZERO, u.revisionHeight = e.revisionHeight !== void 0 && e.revisionHeight !== null ? Long$2.fromValue(e.revisionHeight) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      revisionNumber: Long$2.fromString(e.revision_number),
      revisionHeight: Long$2.fromString(e.revision_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.revision_number = e.revisionNumber ? e.revisionNumber.toString() : void 0, n.revision_height = e.revisionHeight ? e.revisionHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryChannelConsensusStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryChannelConsensusStateRequest",
      value: QueryChannelConsensusStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryChannelConsensusStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryChannelConsensusStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateRequest",
      value: QueryChannelConsensusStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryChannelConsensusStateResponse() {
  return {
    consensusState: void 0,
    clientId: "",
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryChannelConsensusStateResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.consensusState !== void 0 && Any.encode(e.consensusState, n.uint32(10).fork()).ldelim(), e.clientId !== "" && n.uint32(18).string(e.clientId), e.proof.length !== 0 && n.uint32(26).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryChannelConsensusStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.consensusState = Any.decode(o, o.uint32());
          break;
        case 2:
          c.clientId = o.string();
          break;
        case 3:
          c.proof = o.bytes();
          break;
        case 4:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryChannelConsensusStateResponse();
    return u.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? Any.fromPartial(e.consensusState) : void 0, u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.proof = (o = e.proof) !== null && o !== void 0 ? o : new Uint8Array(), u.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, u;
  },
  fromAmino(e) {
    return {
      consensusState: e != null && e.consensus_state ? Any.fromAmino(e.consensus_state) : void 0,
      clientId: e.client_id,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.consensus_state = e.consensusState ? Any.toAmino(e.consensusState) : void 0, n.client_id = e.clientId, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryChannelConsensusStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryChannelConsensusStateResponse",
      value: QueryChannelConsensusStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryChannelConsensusStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryChannelConsensusStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateResponse",
      value: QueryChannelConsensusStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPacketCommitmentRequest() {
  return {
    portId: "",
    channelId: "",
    sequence: Long$2.UZERO
  };
}
const QueryPacketCommitmentRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.sequence.isZero() || n.uint32(24).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketCommitmentRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPacketCommitmentRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPacketCommitmentRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketCommitmentRequest",
      value: QueryPacketCommitmentRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketCommitmentRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPacketCommitmentRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentRequest",
      value: QueryPacketCommitmentRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPacketCommitmentResponse() {
  return {
    commitment: new Uint8Array(),
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryPacketCommitmentResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.commitment.length !== 0 && n.uint32(10).bytes(e.commitment), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketCommitmentResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.commitment = o.bytes();
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPacketCommitmentResponse();
    return u.commitment = (n = e.commitment) !== null && n !== void 0 ? n : new Uint8Array(), u.proof = (o = e.proof) !== null && o !== void 0 ? o : new Uint8Array(), u.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, u;
  },
  fromAmino(e) {
    return {
      commitment: e.commitment,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.commitment = e.commitment, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryPacketCommitmentResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketCommitmentResponse",
      value: QueryPacketCommitmentResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketCommitmentResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPacketCommitmentResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentResponse",
      value: QueryPacketCommitmentResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPacketCommitmentsRequest() {
  return {
    portId: "",
    channelId: "",
    pagination: void 0
  };
}
const QueryPacketCommitmentsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketCommitmentsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPacketCommitmentsRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPacketCommitmentsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketCommitmentsRequest",
      value: QueryPacketCommitmentsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketCommitmentsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPacketCommitmentsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsRequest",
      value: QueryPacketCommitmentsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPacketCommitmentsResponse() {
  return {
    commitments: [],
    pagination: void 0,
    height: void 0
  };
}
const QueryPacketCommitmentsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.commitments)
      PacketState.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), e.height !== void 0 && Height.encode(e.height, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketCommitmentsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.commitments.push(PacketState.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        case 3:
          c.height = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryPacketCommitmentsResponse();
    return o.commitments = ((n = e.commitments) === null || n === void 0 ? void 0 : n.map((u) => PacketState.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o.height = e.height !== void 0 && e.height !== null ? Height.fromPartial(e.height) : void 0, o;
  },
  fromAmino(e) {
    return {
      commitments: Array.isArray(e == null ? void 0 : e.commitments) ? e.commitments.map((n) => PacketState.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0,
      height: e != null && e.height ? Height.fromAmino(e.height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.commitments ? n.commitments = e.commitments.map((o) => o ? PacketState.toAmino(o) : void 0) : n.commitments = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n.height = e.height ? Height.toAmino(e.height) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryPacketCommitmentsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketCommitmentsResponse",
      value: QueryPacketCommitmentsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketCommitmentsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPacketCommitmentsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsResponse",
      value: QueryPacketCommitmentsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPacketReceiptRequest() {
  return {
    portId: "",
    channelId: "",
    sequence: Long$2.UZERO
  };
}
const QueryPacketReceiptRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.sequence.isZero() || n.uint32(24).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketReceiptRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPacketReceiptRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPacketReceiptRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketReceiptRequest",
      value: QueryPacketReceiptRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketReceiptRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPacketReceiptRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptRequest",
      value: QueryPacketReceiptRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPacketReceiptResponse() {
  return {
    received: !1,
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryPacketReceiptResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.received === !0 && n.uint32(16).bool(e.received), e.proof.length !== 0 && n.uint32(26).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketReceiptResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.received = o.bool();
          break;
        case 3:
          c.proof = o.bytes();
          break;
        case 4:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPacketReceiptResponse();
    return u.received = (n = e.received) !== null && n !== void 0 ? n : !1, u.proof = (o = e.proof) !== null && o !== void 0 ? o : new Uint8Array(), u.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, u;
  },
  fromAmino(e) {
    return {
      received: e.received,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.received = e.received, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryPacketReceiptResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketReceiptResponse",
      value: QueryPacketReceiptResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketReceiptResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPacketReceiptResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptResponse",
      value: QueryPacketReceiptResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPacketAcknowledgementRequest() {
  return {
    portId: "",
    channelId: "",
    sequence: Long$2.UZERO
  };
}
const QueryPacketAcknowledgementRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.sequence.isZero() || n.uint32(24).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketAcknowledgementRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPacketAcknowledgementRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPacketAcknowledgementRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketAcknowledgementRequest",
      value: QueryPacketAcknowledgementRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketAcknowledgementRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPacketAcknowledgementRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementRequest",
      value: QueryPacketAcknowledgementRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPacketAcknowledgementResponse() {
  return {
    acknowledgement: new Uint8Array(),
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryPacketAcknowledgementResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.acknowledgement.length !== 0 && n.uint32(10).bytes(e.acknowledgement), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketAcknowledgementResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.acknowledgement = o.bytes();
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPacketAcknowledgementResponse();
    return u.acknowledgement = (n = e.acknowledgement) !== null && n !== void 0 ? n : new Uint8Array(), u.proof = (o = e.proof) !== null && o !== void 0 ? o : new Uint8Array(), u.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, u;
  },
  fromAmino(e) {
    return {
      acknowledgement: e.acknowledgement,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.acknowledgement = e.acknowledgement, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryPacketAcknowledgementResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketAcknowledgementResponse",
      value: QueryPacketAcknowledgementResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketAcknowledgementResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPacketAcknowledgementResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementResponse",
      value: QueryPacketAcknowledgementResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPacketAcknowledgementsRequest() {
  return {
    portId: "",
    channelId: "",
    pagination: void 0,
    packetCommitmentSequences: []
  };
}
const QueryPacketAcknowledgementsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsRequest",
  encode(e, n = minimal.Writer.create()) {
    e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(26).fork()).ldelim(), n.uint32(34).fork();
    for (const o of e.packetCommitmentSequences)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketAcknowledgementsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        case 4:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.packetCommitmentSequences.push(o.uint64());
          } else
            c.packetCommitmentSequences.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryPacketAcknowledgementsRequest();
    return c.portId = (n = e.portId) !== null && n !== void 0 ? n : "", c.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", c.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, c.packetCommitmentSequences = ((u = e.packetCommitmentSequences) === null || u === void 0 ? void 0 : u.map((d) => Long$2.fromValue(d))) || [], c;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0,
      packetCommitmentSequences: Array.isArray(e == null ? void 0 : e.packet_commitment_sequences) ? e.packet_commitment_sequences.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, e.packetCommitmentSequences ? n.packet_commitment_sequences = e.packetCommitmentSequences.map((o) => o) : n.packet_commitment_sequences = [], n;
  },
  fromAminoMsg(e) {
    return QueryPacketAcknowledgementsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketAcknowledgementsRequest",
      value: QueryPacketAcknowledgementsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketAcknowledgementsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPacketAcknowledgementsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsRequest",
      value: QueryPacketAcknowledgementsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPacketAcknowledgementsResponse() {
  return {
    acknowledgements: [],
    pagination: void 0,
    height: void 0
  };
}
const QueryPacketAcknowledgementsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.acknowledgements)
      PacketState.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), e.height !== void 0 && Height.encode(e.height, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPacketAcknowledgementsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.acknowledgements.push(PacketState.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        case 3:
          c.height = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryPacketAcknowledgementsResponse();
    return o.acknowledgements = ((n = e.acknowledgements) === null || n === void 0 ? void 0 : n.map((u) => PacketState.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o.height = e.height !== void 0 && e.height !== null ? Height.fromPartial(e.height) : void 0, o;
  },
  fromAmino(e) {
    return {
      acknowledgements: Array.isArray(e == null ? void 0 : e.acknowledgements) ? e.acknowledgements.map((n) => PacketState.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0,
      height: e != null && e.height ? Height.fromAmino(e.height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.acknowledgements ? n.acknowledgements = e.acknowledgements.map((o) => o ? PacketState.toAmino(o) : void 0) : n.acknowledgements = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n.height = e.height ? Height.toAmino(e.height) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryPacketAcknowledgementsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryPacketAcknowledgementsResponse",
      value: QueryPacketAcknowledgementsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPacketAcknowledgementsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPacketAcknowledgementsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsResponse",
      value: QueryPacketAcknowledgementsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryUnreceivedPacketsRequest() {
  return {
    portId: "",
    channelId: "",
    packetCommitmentSequences: []
  };
}
const QueryUnreceivedPacketsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsRequest",
  encode(e, n = minimal.Writer.create()) {
    e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n.uint32(26).fork();
    for (const o of e.packetCommitmentSequences)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUnreceivedPacketsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.packetCommitmentSequences.push(o.uint64());
          } else
            c.packetCommitmentSequences.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryUnreceivedPacketsRequest();
    return c.portId = (n = e.portId) !== null && n !== void 0 ? n : "", c.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", c.packetCommitmentSequences = ((u = e.packetCommitmentSequences) === null || u === void 0 ? void 0 : u.map((d) => Long$2.fromValue(d))) || [], c;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      packetCommitmentSequences: Array.isArray(e == null ? void 0 : e.packet_commitment_sequences) ? e.packet_commitment_sequences.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, e.packetCommitmentSequences ? n.packet_commitment_sequences = e.packetCommitmentSequences.map((o) => o) : n.packet_commitment_sequences = [], n;
  },
  fromAminoMsg(e) {
    return QueryUnreceivedPacketsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUnreceivedPacketsRequest",
      value: QueryUnreceivedPacketsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUnreceivedPacketsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryUnreceivedPacketsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsRequest",
      value: QueryUnreceivedPacketsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryUnreceivedPacketsResponse() {
  return {
    sequences: [],
    height: void 0
  };
}
const QueryUnreceivedPacketsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsResponse",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.sequences)
      n.uint64(o);
    return n.ldelim(), e.height !== void 0 && Height.encode(e.height, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUnreceivedPacketsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.sequences.push(o.uint64());
          } else
            c.sequences.push(o.uint64());
          break;
        case 2:
          c.height = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryUnreceivedPacketsResponse();
    return o.sequences = ((n = e.sequences) === null || n === void 0 ? void 0 : n.map((u) => Long$2.fromValue(u))) || [], o.height = e.height !== void 0 && e.height !== null ? Height.fromPartial(e.height) : void 0, o;
  },
  fromAmino(e) {
    return {
      sequences: Array.isArray(e == null ? void 0 : e.sequences) ? e.sequences.map((n) => n) : [],
      height: e != null && e.height ? Height.fromAmino(e.height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.sequences ? n.sequences = e.sequences.map((o) => o) : n.sequences = [], n.height = e.height ? Height.toAmino(e.height) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryUnreceivedPacketsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUnreceivedPacketsResponse",
      value: QueryUnreceivedPacketsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUnreceivedPacketsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryUnreceivedPacketsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsResponse",
      value: QueryUnreceivedPacketsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryUnreceivedAcksRequest() {
  return {
    portId: "",
    channelId: "",
    packetAckSequences: []
  };
}
const QueryUnreceivedAcksRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksRequest",
  encode(e, n = minimal.Writer.create()) {
    e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n.uint32(26).fork();
    for (const o of e.packetAckSequences)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUnreceivedAcksRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.packetAckSequences.push(o.uint64());
          } else
            c.packetAckSequences.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryUnreceivedAcksRequest();
    return c.portId = (n = e.portId) !== null && n !== void 0 ? n : "", c.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", c.packetAckSequences = ((u = e.packetAckSequences) === null || u === void 0 ? void 0 : u.map((d) => Long$2.fromValue(d))) || [], c;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      packetAckSequences: Array.isArray(e == null ? void 0 : e.packet_ack_sequences) ? e.packet_ack_sequences.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, e.packetAckSequences ? n.packet_ack_sequences = e.packetAckSequences.map((o) => o) : n.packet_ack_sequences = [], n;
  },
  fromAminoMsg(e) {
    return QueryUnreceivedAcksRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUnreceivedAcksRequest",
      value: QueryUnreceivedAcksRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUnreceivedAcksRequest.decode(e.value);
  },
  toProto(e) {
    return QueryUnreceivedAcksRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksRequest",
      value: QueryUnreceivedAcksRequest.encode(e).finish()
    };
  }
};
function createBaseQueryUnreceivedAcksResponse() {
  return {
    sequences: [],
    height: void 0
  };
}
const QueryUnreceivedAcksResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksResponse",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.sequences)
      n.uint64(o);
    return n.ldelim(), e.height !== void 0 && Height.encode(e.height, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUnreceivedAcksResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.sequences.push(o.uint64());
          } else
            c.sequences.push(o.uint64());
          break;
        case 2:
          c.height = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryUnreceivedAcksResponse();
    return o.sequences = ((n = e.sequences) === null || n === void 0 ? void 0 : n.map((u) => Long$2.fromValue(u))) || [], o.height = e.height !== void 0 && e.height !== null ? Height.fromPartial(e.height) : void 0, o;
  },
  fromAmino(e) {
    return {
      sequences: Array.isArray(e == null ? void 0 : e.sequences) ? e.sequences.map((n) => n) : [],
      height: e != null && e.height ? Height.fromAmino(e.height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.sequences ? n.sequences = e.sequences.map((o) => o) : n.sequences = [], n.height = e.height ? Height.toAmino(e.height) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryUnreceivedAcksResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUnreceivedAcksResponse",
      value: QueryUnreceivedAcksResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUnreceivedAcksResponse.decode(e.value);
  },
  toProto(e) {
    return QueryUnreceivedAcksResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksResponse",
      value: QueryUnreceivedAcksResponse.encode(e).finish()
    };
  }
};
function createBaseQueryNextSequenceReceiveRequest() {
  return {
    portId: "",
    channelId: ""
  };
}
const QueryNextSequenceReceiveRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryNextSequenceReceiveRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryNextSequenceReceiveRequest();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return QueryNextSequenceReceiveRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryNextSequenceReceiveRequest",
      value: QueryNextSequenceReceiveRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryNextSequenceReceiveRequest.decode(e.value);
  },
  toProto(e) {
    return QueryNextSequenceReceiveRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveRequest",
      value: QueryNextSequenceReceiveRequest.encode(e).finish()
    };
  }
};
function createBaseQueryNextSequenceReceiveResponse() {
  return {
    nextSequenceReceive: Long$2.UZERO,
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryNextSequenceReceiveResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.nextSequenceReceive.isZero() || n.uint32(8).uint64(e.nextSequenceReceive), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryNextSequenceReceiveResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.nextSequenceReceive = o.uint64();
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryNextSequenceReceiveResponse();
    return o.nextSequenceReceive = e.nextSequenceReceive !== void 0 && e.nextSequenceReceive !== null ? Long$2.fromValue(e.nextSequenceReceive) : Long$2.UZERO, o.proof = (n = e.proof) !== null && n !== void 0 ? n : new Uint8Array(), o.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, o;
  },
  fromAmino(e) {
    return {
      nextSequenceReceive: Long$2.fromString(e.next_sequence_receive),
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.next_sequence_receive = e.nextSequenceReceive ? e.nextSequenceReceive.toString() : void 0, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryNextSequenceReceiveResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryNextSequenceReceiveResponse",
      value: QueryNextSequenceReceiveResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryNextSequenceReceiveResponse.decode(e.value);
  },
  toProto(e) {
    return QueryNextSequenceReceiveResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveResponse",
      value: QueryNextSequenceReceiveResponse.encode(e).finish()
    };
  }
}, _85 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryChannelClientStateRequest,
  QueryChannelClientStateResponse,
  QueryChannelConsensusStateRequest,
  QueryChannelConsensusStateResponse,
  QueryChannelRequest,
  QueryChannelResponse,
  QueryChannelsRequest,
  QueryChannelsResponse,
  QueryConnectionChannelsRequest,
  QueryConnectionChannelsResponse,
  QueryNextSequenceReceiveRequest,
  QueryNextSequenceReceiveResponse,
  QueryPacketAcknowledgementRequest,
  QueryPacketAcknowledgementResponse,
  QueryPacketAcknowledgementsRequest,
  QueryPacketAcknowledgementsResponse,
  QueryPacketCommitmentRequest,
  QueryPacketCommitmentResponse,
  QueryPacketCommitmentsRequest,
  QueryPacketCommitmentsResponse,
  QueryPacketReceiptRequest,
  QueryPacketReceiptResponse,
  QueryUnreceivedAcksRequest,
  QueryUnreceivedAcksResponse,
  QueryUnreceivedPacketsRequest,
  QueryUnreceivedPacketsResponse
}, Symbol.toStringTag, { value: "Module" }));
let ResponseResultType;
(function(e) {
  e[e.RESPONSE_RESULT_TYPE_UNSPECIFIED = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED", e[e.RESPONSE_RESULT_TYPE_NOOP = 1] = "RESPONSE_RESULT_TYPE_NOOP", e[e.RESPONSE_RESULT_TYPE_SUCCESS = 2] = "RESPONSE_RESULT_TYPE_SUCCESS", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ResponseResultType || (ResponseResultType = {}));
const ResponseResultTypeSDKType = ResponseResultType, ResponseResultTypeAmino = ResponseResultType;
function responseResultTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
      return ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED;
    case 1:
    case "RESPONSE_RESULT_TYPE_NOOP":
      return ResponseResultType.RESPONSE_RESULT_TYPE_NOOP;
    case 2:
    case "RESPONSE_RESULT_TYPE_SUCCESS":
      return ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseResultType.UNRECOGNIZED;
  }
}
function responseResultTypeToJSON(e) {
  switch (e) {
    case ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED:
      return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
    case ResponseResultType.RESPONSE_RESULT_TYPE_NOOP:
      return "RESPONSE_RESULT_TYPE_NOOP";
    case ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS:
      return "RESPONSE_RESULT_TYPE_SUCCESS";
    case ResponseResultType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseMsgChannelOpenInit() {
  return {
    portId: "",
    channel: void 0,
    signer: ""
  };
}
const MsgChannelOpenInit = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channel !== void 0 && Channel.encode(e.channel, n.uint32(18).fork()).ldelim(), e.signer !== "" && n.uint32(26).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelOpenInit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channel = Channel.decode(o, o.uint32());
          break;
        case 3:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgChannelOpenInit();
    return u.portId = (n = e.portId) !== null && n !== void 0 ? n : "", u.channel = e.channel !== void 0 && e.channel !== null ? Channel.fromPartial(e.channel) : void 0, u.signer = (o = e.signer) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channel: e != null && e.channel ? Channel.fromAmino(e.channel) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel = e.channel ? Channel.toAmino(e.channel) : void 0, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgChannelOpenInit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelOpenInit",
      value: MsgChannelOpenInit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelOpenInit.decode(e.value);
  },
  toProto(e) {
    return MsgChannelOpenInit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
      value: MsgChannelOpenInit.encode(e).finish()
    };
  }
};
function createBaseMsgChannelOpenInitResponse() {
  return {
    channelId: "",
    version: ""
  };
}
const MsgChannelOpenInitResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInitResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.channelId !== "" && n.uint32(10).string(e.channelId), e.version !== "" && n.uint32(18).string(e.version), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelOpenInitResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.channelId = o.string();
          break;
        case 2:
          c.version = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgChannelOpenInitResponse();
    return u.channelId = (n = e.channelId) !== null && n !== void 0 ? n : "", u.version = (o = e.version) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      channelId: e.channel_id,
      version: e.version
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel_id = e.channelId, n.version = e.version, n;
  },
  fromAminoMsg(e) {
    return MsgChannelOpenInitResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelOpenInitResponse",
      value: MsgChannelOpenInitResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelOpenInitResponse.decode(e.value);
  },
  toProto(e) {
    return MsgChannelOpenInitResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInitResponse",
      value: MsgChannelOpenInitResponse.encode(e).finish()
    };
  }
};
function createBaseMsgChannelOpenTry() {
  return {
    portId: "",
    previousChannelId: "",
    channel: void 0,
    counterpartyVersion: "",
    proofInit: new Uint8Array(),
    proofHeight: void 0,
    signer: ""
  };
}
const MsgChannelOpenTry = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.previousChannelId !== "" && n.uint32(18).string(e.previousChannelId), e.channel !== void 0 && Channel.encode(e.channel, n.uint32(26).fork()).ldelim(), e.counterpartyVersion !== "" && n.uint32(34).string(e.counterpartyVersion), e.proofInit.length !== 0 && n.uint32(42).bytes(e.proofInit), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(50).fork()).ldelim(), e.signer !== "" && n.uint32(58).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelOpenTry();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.previousChannelId = o.string();
          break;
        case 3:
          c.channel = Channel.decode(o, o.uint32());
          break;
        case 4:
          c.counterpartyVersion = o.string();
          break;
        case 5:
          c.proofInit = o.bytes();
          break;
        case 6:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 7:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseMsgChannelOpenTry();
    return m.portId = (n = e.portId) !== null && n !== void 0 ? n : "", m.previousChannelId = (o = e.previousChannelId) !== null && o !== void 0 ? o : "", m.channel = e.channel !== void 0 && e.channel !== null ? Channel.fromPartial(e.channel) : void 0, m.counterpartyVersion = (u = e.counterpartyVersion) !== null && u !== void 0 ? u : "", m.proofInit = (c = e.proofInit) !== null && c !== void 0 ? c : new Uint8Array(), m.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, m.signer = (d = e.signer) !== null && d !== void 0 ? d : "", m;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      previousChannelId: e.previous_channel_id,
      channel: e != null && e.channel ? Channel.fromAmino(e.channel) : void 0,
      counterpartyVersion: e.counterparty_version,
      proofInit: e.proof_init,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.previous_channel_id = e.previousChannelId, n.channel = e.channel ? Channel.toAmino(e.channel) : void 0, n.counterparty_version = e.counterpartyVersion, n.proof_init = e.proofInit, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgChannelOpenTry.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelOpenTry",
      value: MsgChannelOpenTry.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelOpenTry.decode(e.value);
  },
  toProto(e) {
    return MsgChannelOpenTry.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
      value: MsgChannelOpenTry.encode(e).finish()
    };
  }
};
function createBaseMsgChannelOpenTryResponse() {
  return {
    version: "",
    channelId: ""
  };
}
const MsgChannelOpenTryResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTryResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.version !== "" && n.uint32(10).string(e.version), e.channelId !== "" && n.uint32(18).string(e.channelId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelOpenTryResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.version = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgChannelOpenTryResponse();
    return u.version = (n = e.version) !== null && n !== void 0 ? n : "", u.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      version: e.version,
      channelId: e.channel_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.version = e.version, n.channel_id = e.channelId, n;
  },
  fromAminoMsg(e) {
    return MsgChannelOpenTryResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelOpenTryResponse",
      value: MsgChannelOpenTryResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelOpenTryResponse.decode(e.value);
  },
  toProto(e) {
    return MsgChannelOpenTryResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTryResponse",
      value: MsgChannelOpenTryResponse.encode(e).finish()
    };
  }
};
function createBaseMsgChannelOpenAck() {
  return {
    portId: "",
    channelId: "",
    counterpartyChannelId: "",
    counterpartyVersion: "",
    proofTry: new Uint8Array(),
    proofHeight: void 0,
    signer: ""
  };
}
const MsgChannelOpenAck = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.counterpartyChannelId !== "" && n.uint32(26).string(e.counterpartyChannelId), e.counterpartyVersion !== "" && n.uint32(34).string(e.counterpartyVersion), e.proofTry.length !== 0 && n.uint32(42).bytes(e.proofTry), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(50).fork()).ldelim(), e.signer !== "" && n.uint32(58).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelOpenAck();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.counterpartyChannelId = o.string();
          break;
        case 4:
          c.counterpartyVersion = o.string();
          break;
        case 5:
          c.proofTry = o.bytes();
          break;
        case 6:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 7:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseMsgChannelOpenAck();
    return v.portId = (n = e.portId) !== null && n !== void 0 ? n : "", v.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", v.counterpartyChannelId = (u = e.counterpartyChannelId) !== null && u !== void 0 ? u : "", v.counterpartyVersion = (c = e.counterpartyVersion) !== null && c !== void 0 ? c : "", v.proofTry = (d = e.proofTry) !== null && d !== void 0 ? d : new Uint8Array(), v.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, v.signer = (m = e.signer) !== null && m !== void 0 ? m : "", v;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      counterpartyChannelId: e.counterparty_channel_id,
      counterpartyVersion: e.counterparty_version,
      proofTry: e.proof_try,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.counterparty_channel_id = e.counterpartyChannelId, n.counterparty_version = e.counterpartyVersion, n.proof_try = e.proofTry, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgChannelOpenAck.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelOpenAck",
      value: MsgChannelOpenAck.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelOpenAck.decode(e.value);
  },
  toProto(e) {
    return MsgChannelOpenAck.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
      value: MsgChannelOpenAck.encode(e).finish()
    };
  }
};
function createBaseMsgChannelOpenAckResponse() {
  return {};
}
const MsgChannelOpenAckResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAckResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelOpenAckResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgChannelOpenAckResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgChannelOpenAckResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelOpenAckResponse",
      value: MsgChannelOpenAckResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelOpenAckResponse.decode(e.value);
  },
  toProto(e) {
    return MsgChannelOpenAckResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAckResponse",
      value: MsgChannelOpenAckResponse.encode(e).finish()
    };
  }
};
function createBaseMsgChannelOpenConfirm() {
  return {
    portId: "",
    channelId: "",
    proofAck: new Uint8Array(),
    proofHeight: void 0,
    signer: ""
  };
}
const MsgChannelOpenConfirm = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.proofAck.length !== 0 && n.uint32(26).bytes(e.proofAck), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(34).fork()).ldelim(), e.signer !== "" && n.uint32(42).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelOpenConfirm();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.proofAck = o.bytes();
          break;
        case 4:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 5:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgChannelOpenConfirm();
    return d.portId = (n = e.portId) !== null && n !== void 0 ? n : "", d.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", d.proofAck = (u = e.proofAck) !== null && u !== void 0 ? u : new Uint8Array(), d.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, d.signer = (c = e.signer) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      proofAck: e.proof_ack,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.proof_ack = e.proofAck, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgChannelOpenConfirm.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelOpenConfirm",
      value: MsgChannelOpenConfirm.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelOpenConfirm.decode(e.value);
  },
  toProto(e) {
    return MsgChannelOpenConfirm.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
      value: MsgChannelOpenConfirm.encode(e).finish()
    };
  }
};
function createBaseMsgChannelOpenConfirmResponse() {
  return {};
}
const MsgChannelOpenConfirmResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirmResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelOpenConfirmResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgChannelOpenConfirmResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgChannelOpenConfirmResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelOpenConfirmResponse",
      value: MsgChannelOpenConfirmResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelOpenConfirmResponse.decode(e.value);
  },
  toProto(e) {
    return MsgChannelOpenConfirmResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirmResponse",
      value: MsgChannelOpenConfirmResponse.encode(e).finish()
    };
  }
};
function createBaseMsgChannelCloseInit() {
  return {
    portId: "",
    channelId: "",
    signer: ""
  };
}
const MsgChannelCloseInit = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.signer !== "" && n.uint32(26).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelCloseInit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgChannelCloseInit();
    return c.portId = (n = e.portId) !== null && n !== void 0 ? n : "", c.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", c.signer = (u = e.signer) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgChannelCloseInit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelCloseInit",
      value: MsgChannelCloseInit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelCloseInit.decode(e.value);
  },
  toProto(e) {
    return MsgChannelCloseInit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
      value: MsgChannelCloseInit.encode(e).finish()
    };
  }
};
function createBaseMsgChannelCloseInitResponse() {
  return {};
}
const MsgChannelCloseInitResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInitResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelCloseInitResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgChannelCloseInitResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgChannelCloseInitResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelCloseInitResponse",
      value: MsgChannelCloseInitResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelCloseInitResponse.decode(e.value);
  },
  toProto(e) {
    return MsgChannelCloseInitResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInitResponse",
      value: MsgChannelCloseInitResponse.encode(e).finish()
    };
  }
};
function createBaseMsgChannelCloseConfirm() {
  return {
    portId: "",
    channelId: "",
    proofInit: new Uint8Array(),
    proofHeight: void 0,
    signer: ""
  };
}
const MsgChannelCloseConfirm = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
  encode(e, n = minimal.Writer.create()) {
    return e.portId !== "" && n.uint32(10).string(e.portId), e.channelId !== "" && n.uint32(18).string(e.channelId), e.proofInit.length !== 0 && n.uint32(26).bytes(e.proofInit), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(34).fork()).ldelim(), e.signer !== "" && n.uint32(42).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelCloseConfirm();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.portId = o.string();
          break;
        case 2:
          c.channelId = o.string();
          break;
        case 3:
          c.proofInit = o.bytes();
          break;
        case 4:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 5:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgChannelCloseConfirm();
    return d.portId = (n = e.portId) !== null && n !== void 0 ? n : "", d.channelId = (o = e.channelId) !== null && o !== void 0 ? o : "", d.proofInit = (u = e.proofInit) !== null && u !== void 0 ? u : new Uint8Array(), d.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, d.signer = (c = e.signer) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      portId: e.port_id,
      channelId: e.channel_id,
      proofInit: e.proof_init,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.port_id = e.portId, n.channel_id = e.channelId, n.proof_init = e.proofInit, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgChannelCloseConfirm.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelCloseConfirm",
      value: MsgChannelCloseConfirm.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelCloseConfirm.decode(e.value);
  },
  toProto(e) {
    return MsgChannelCloseConfirm.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
      value: MsgChannelCloseConfirm.encode(e).finish()
    };
  }
};
function createBaseMsgChannelCloseConfirmResponse() {
  return {};
}
const MsgChannelCloseConfirmResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirmResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChannelCloseConfirmResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgChannelCloseConfirmResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgChannelCloseConfirmResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgChannelCloseConfirmResponse",
      value: MsgChannelCloseConfirmResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChannelCloseConfirmResponse.decode(e.value);
  },
  toProto(e) {
    return MsgChannelCloseConfirmResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirmResponse",
      value: MsgChannelCloseConfirmResponse.encode(e).finish()
    };
  }
};
function createBaseMsgRecvPacket() {
  return {
    packet: void 0,
    proofCommitment: new Uint8Array(),
    proofHeight: void 0,
    signer: ""
  };
}
const MsgRecvPacket = {
  typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
  encode(e, n = minimal.Writer.create()) {
    return e.packet !== void 0 && Packet.encode(e.packet, n.uint32(10).fork()).ldelim(), e.proofCommitment.length !== 0 && n.uint32(18).bytes(e.proofCommitment), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), e.signer !== "" && n.uint32(34).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRecvPacket();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packet = Packet.decode(o, o.uint32());
          break;
        case 2:
          c.proofCommitment = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 4:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgRecvPacket();
    return u.packet = e.packet !== void 0 && e.packet !== null ? Packet.fromPartial(e.packet) : void 0, u.proofCommitment = (n = e.proofCommitment) !== null && n !== void 0 ? n : new Uint8Array(), u.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, u.signer = (o = e.signer) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      packet: e != null && e.packet ? Packet.fromAmino(e.packet) : void 0,
      proofCommitment: e.proof_commitment,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet = e.packet ? Packet.toAmino(e.packet) : void 0, n.proof_commitment = e.proofCommitment, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgRecvPacket.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRecvPacket",
      value: MsgRecvPacket.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRecvPacket.decode(e.value);
  },
  toProto(e) {
    return MsgRecvPacket.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
      value: MsgRecvPacket.encode(e).finish()
    };
  }
};
function createBaseMsgRecvPacketResponse() {
  return {
    result: 0
  };
}
const MsgRecvPacketResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgRecvPacketResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.result !== 0 && n.uint32(8).int32(e.result), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRecvPacketResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.result = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgRecvPacketResponse();
    return o.result = (n = e.result) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      result: isSet(e.result) ? responseResultTypeFromJSON(e.result) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.result = e.result, n;
  },
  fromAminoMsg(e) {
    return MsgRecvPacketResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgRecvPacketResponse",
      value: MsgRecvPacketResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRecvPacketResponse.decode(e.value);
  },
  toProto(e) {
    return MsgRecvPacketResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgRecvPacketResponse",
      value: MsgRecvPacketResponse.encode(e).finish()
    };
  }
};
function createBaseMsgTimeout() {
  return {
    packet: void 0,
    proofUnreceived: new Uint8Array(),
    proofHeight: void 0,
    nextSequenceRecv: Long$2.UZERO,
    signer: ""
  };
}
const MsgTimeout = {
  typeUrl: "/ibc.core.channel.v1.MsgTimeout",
  encode(e, n = minimal.Writer.create()) {
    return e.packet !== void 0 && Packet.encode(e.packet, n.uint32(10).fork()).ldelim(), e.proofUnreceived.length !== 0 && n.uint32(18).bytes(e.proofUnreceived), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), e.nextSequenceRecv.isZero() || n.uint32(32).uint64(e.nextSequenceRecv), e.signer !== "" && n.uint32(42).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgTimeout();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packet = Packet.decode(o, o.uint32());
          break;
        case 2:
          c.proofUnreceived = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 4:
          c.nextSequenceRecv = o.uint64();
          break;
        case 5:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgTimeout();
    return u.packet = e.packet !== void 0 && e.packet !== null ? Packet.fromPartial(e.packet) : void 0, u.proofUnreceived = (n = e.proofUnreceived) !== null && n !== void 0 ? n : new Uint8Array(), u.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, u.nextSequenceRecv = e.nextSequenceRecv !== void 0 && e.nextSequenceRecv !== null ? Long$2.fromValue(e.nextSequenceRecv) : Long$2.UZERO, u.signer = (o = e.signer) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      packet: e != null && e.packet ? Packet.fromAmino(e.packet) : void 0,
      proofUnreceived: e.proof_unreceived,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      nextSequenceRecv: Long$2.fromString(e.next_sequence_recv),
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet = e.packet ? Packet.toAmino(e.packet) : void 0, n.proof_unreceived = e.proofUnreceived, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.next_sequence_recv = e.nextSequenceRecv ? e.nextSequenceRecv.toString() : void 0, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgTimeout.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgTimeout",
      value: MsgTimeout.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgTimeout.decode(e.value);
  },
  toProto(e) {
    return MsgTimeout.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgTimeout",
      value: MsgTimeout.encode(e).finish()
    };
  }
};
function createBaseMsgTimeoutResponse() {
  return {
    result: 0
  };
}
const MsgTimeoutResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgTimeoutResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.result !== 0 && n.uint32(8).int32(e.result), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgTimeoutResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.result = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgTimeoutResponse();
    return o.result = (n = e.result) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      result: isSet(e.result) ? responseResultTypeFromJSON(e.result) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.result = e.result, n;
  },
  fromAminoMsg(e) {
    return MsgTimeoutResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgTimeoutResponse",
      value: MsgTimeoutResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgTimeoutResponse.decode(e.value);
  },
  toProto(e) {
    return MsgTimeoutResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgTimeoutResponse",
      value: MsgTimeoutResponse.encode(e).finish()
    };
  }
};
function createBaseMsgTimeoutOnClose() {
  return {
    packet: void 0,
    proofUnreceived: new Uint8Array(),
    proofClose: new Uint8Array(),
    proofHeight: void 0,
    nextSequenceRecv: Long$2.UZERO,
    signer: ""
  };
}
const MsgTimeoutOnClose = {
  typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
  encode(e, n = minimal.Writer.create()) {
    return e.packet !== void 0 && Packet.encode(e.packet, n.uint32(10).fork()).ldelim(), e.proofUnreceived.length !== 0 && n.uint32(18).bytes(e.proofUnreceived), e.proofClose.length !== 0 && n.uint32(26).bytes(e.proofClose), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(34).fork()).ldelim(), e.nextSequenceRecv.isZero() || n.uint32(40).uint64(e.nextSequenceRecv), e.signer !== "" && n.uint32(50).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgTimeoutOnClose();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packet = Packet.decode(o, o.uint32());
          break;
        case 2:
          c.proofUnreceived = o.bytes();
          break;
        case 3:
          c.proofClose = o.bytes();
          break;
        case 4:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 5:
          c.nextSequenceRecv = o.uint64();
          break;
        case 6:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgTimeoutOnClose();
    return c.packet = e.packet !== void 0 && e.packet !== null ? Packet.fromPartial(e.packet) : void 0, c.proofUnreceived = (n = e.proofUnreceived) !== null && n !== void 0 ? n : new Uint8Array(), c.proofClose = (o = e.proofClose) !== null && o !== void 0 ? o : new Uint8Array(), c.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, c.nextSequenceRecv = e.nextSequenceRecv !== void 0 && e.nextSequenceRecv !== null ? Long$2.fromValue(e.nextSequenceRecv) : Long$2.UZERO, c.signer = (u = e.signer) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      packet: e != null && e.packet ? Packet.fromAmino(e.packet) : void 0,
      proofUnreceived: e.proof_unreceived,
      proofClose: e.proof_close,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      nextSequenceRecv: Long$2.fromString(e.next_sequence_recv),
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet = e.packet ? Packet.toAmino(e.packet) : void 0, n.proof_unreceived = e.proofUnreceived, n.proof_close = e.proofClose, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.next_sequence_recv = e.nextSequenceRecv ? e.nextSequenceRecv.toString() : void 0, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgTimeoutOnClose.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgTimeoutOnClose",
      value: MsgTimeoutOnClose.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgTimeoutOnClose.decode(e.value);
  },
  toProto(e) {
    return MsgTimeoutOnClose.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
      value: MsgTimeoutOnClose.encode(e).finish()
    };
  }
};
function createBaseMsgTimeoutOnCloseResponse() {
  return {
    result: 0
  };
}
const MsgTimeoutOnCloseResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnCloseResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.result !== 0 && n.uint32(8).int32(e.result), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgTimeoutOnCloseResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.result = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgTimeoutOnCloseResponse();
    return o.result = (n = e.result) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      result: isSet(e.result) ? responseResultTypeFromJSON(e.result) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.result = e.result, n;
  },
  fromAminoMsg(e) {
    return MsgTimeoutOnCloseResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgTimeoutOnCloseResponse",
      value: MsgTimeoutOnCloseResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgTimeoutOnCloseResponse.decode(e.value);
  },
  toProto(e) {
    return MsgTimeoutOnCloseResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnCloseResponse",
      value: MsgTimeoutOnCloseResponse.encode(e).finish()
    };
  }
};
function createBaseMsgAcknowledgement() {
  return {
    packet: void 0,
    acknowledgement: new Uint8Array(),
    proofAcked: new Uint8Array(),
    proofHeight: void 0,
    signer: ""
  };
}
const MsgAcknowledgement = {
  typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
  encode(e, n = minimal.Writer.create()) {
    return e.packet !== void 0 && Packet.encode(e.packet, n.uint32(10).fork()).ldelim(), e.acknowledgement.length !== 0 && n.uint32(18).bytes(e.acknowledgement), e.proofAcked.length !== 0 && n.uint32(26).bytes(e.proofAcked), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(34).fork()).ldelim(), e.signer !== "" && n.uint32(42).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgAcknowledgement();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.packet = Packet.decode(o, o.uint32());
          break;
        case 2:
          c.acknowledgement = o.bytes();
          break;
        case 3:
          c.proofAcked = o.bytes();
          break;
        case 4:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 5:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgAcknowledgement();
    return c.packet = e.packet !== void 0 && e.packet !== null ? Packet.fromPartial(e.packet) : void 0, c.acknowledgement = (n = e.acknowledgement) !== null && n !== void 0 ? n : new Uint8Array(), c.proofAcked = (o = e.proofAcked) !== null && o !== void 0 ? o : new Uint8Array(), c.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, c.signer = (u = e.signer) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      packet: e != null && e.packet ? Packet.fromAmino(e.packet) : void 0,
      acknowledgement: e.acknowledgement,
      proofAcked: e.proof_acked,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.packet = e.packet ? Packet.toAmino(e.packet) : void 0, n.acknowledgement = e.acknowledgement, n.proof_acked = e.proofAcked, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgAcknowledgement.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgAcknowledgement",
      value: MsgAcknowledgement.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgAcknowledgement.decode(e.value);
  },
  toProto(e) {
    return MsgAcknowledgement.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
      value: MsgAcknowledgement.encode(e).finish()
    };
  }
};
function createBaseMsgAcknowledgementResponse() {
  return {
    result: 0
  };
}
const MsgAcknowledgementResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgAcknowledgementResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.result !== 0 && n.uint32(8).int32(e.result), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgAcknowledgementResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.result = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgAcknowledgementResponse();
    return o.result = (n = e.result) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      result: isSet(e.result) ? responseResultTypeFromJSON(e.result) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.result = e.result, n;
  },
  fromAminoMsg(e) {
    return MsgAcknowledgementResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgAcknowledgementResponse",
      value: MsgAcknowledgementResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgAcknowledgementResponse.decode(e.value);
  },
  toProto(e) {
    return MsgAcknowledgementResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgAcknowledgementResponse",
      value: MsgAcknowledgementResponse.encode(e).finish()
    };
  }
}, _86 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgAcknowledgement,
  MsgAcknowledgementResponse,
  MsgChannelCloseConfirm,
  MsgChannelCloseConfirmResponse,
  MsgChannelCloseInit,
  MsgChannelCloseInitResponse,
  MsgChannelOpenAck,
  MsgChannelOpenAckResponse,
  MsgChannelOpenConfirm,
  MsgChannelOpenConfirmResponse,
  MsgChannelOpenInit,
  MsgChannelOpenInitResponse,
  MsgChannelOpenTry,
  MsgChannelOpenTryResponse,
  MsgRecvPacket,
  MsgRecvPacketResponse,
  MsgTimeout,
  MsgTimeoutOnClose,
  MsgTimeoutOnCloseResponse,
  MsgTimeoutResponse,
  get ResponseResultType() {
    return ResponseResultType;
  },
  ResponseResultTypeAmino,
  ResponseResultTypeSDKType,
  responseResultTypeFromJSON,
  responseResultTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$h() {
  return {
    clients: [],
    clientsConsensus: [],
    clientsMetadata: [],
    params: void 0,
    createLocalhost: !1,
    nextClientSequence: Long$2.UZERO
  };
}
const GenesisState$h = {
  typeUrl: "/ibc.core.client.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.clients)
      IdentifiedClientState.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.clientsConsensus)
      ClientConsensusStates.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.clientsMetadata)
      IdentifiedGenesisMetadata.encode(o, n.uint32(26).fork()).ldelim();
    return e.params !== void 0 && Params$k.encode(e.params, n.uint32(34).fork()).ldelim(), e.createLocalhost === !0 && n.uint32(40).bool(e.createLocalhost), e.nextClientSequence.isZero() || n.uint32(48).uint64(e.nextClientSequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$h();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clients.push(IdentifiedClientState.decode(o, o.uint32()));
          break;
        case 2:
          c.clientsConsensus.push(ClientConsensusStates.decode(o, o.uint32()));
          break;
        case 3:
          c.clientsMetadata.push(IdentifiedGenesisMetadata.decode(o, o.uint32()));
          break;
        case 4:
          c.params = Params$k.decode(o, o.uint32());
          break;
        case 5:
          c.createLocalhost = o.bool();
          break;
        case 6:
          c.nextClientSequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseGenesisState$h();
    return d.clients = ((n = e.clients) === null || n === void 0 ? void 0 : n.map((m) => IdentifiedClientState.fromPartial(m))) || [], d.clientsConsensus = ((o = e.clientsConsensus) === null || o === void 0 ? void 0 : o.map((m) => ClientConsensusStates.fromPartial(m))) || [], d.clientsMetadata = ((u = e.clientsMetadata) === null || u === void 0 ? void 0 : u.map((m) => IdentifiedGenesisMetadata.fromPartial(m))) || [], d.params = e.params !== void 0 && e.params !== null ? Params$k.fromPartial(e.params) : void 0, d.createLocalhost = (c = e.createLocalhost) !== null && c !== void 0 ? c : !1, d.nextClientSequence = e.nextClientSequence !== void 0 && e.nextClientSequence !== null ? Long$2.fromValue(e.nextClientSequence) : Long$2.UZERO, d;
  },
  fromAmino(e) {
    return {
      clients: Array.isArray(e == null ? void 0 : e.clients) ? e.clients.map((n) => IdentifiedClientState.fromAmino(n)) : [],
      clientsConsensus: Array.isArray(e == null ? void 0 : e.clients_consensus) ? e.clients_consensus.map((n) => ClientConsensusStates.fromAmino(n)) : [],
      clientsMetadata: Array.isArray(e == null ? void 0 : e.clients_metadata) ? e.clients_metadata.map((n) => IdentifiedGenesisMetadata.fromAmino(n)) : [],
      params: e != null && e.params ? Params$k.fromAmino(e.params) : void 0,
      createLocalhost: e.create_localhost,
      nextClientSequence: Long$2.fromString(e.next_client_sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return e.clients ? n.clients = e.clients.map((o) => o ? IdentifiedClientState.toAmino(o) : void 0) : n.clients = [], e.clientsConsensus ? n.clients_consensus = e.clientsConsensus.map((o) => o ? ClientConsensusStates.toAmino(o) : void 0) : n.clients_consensus = [], e.clientsMetadata ? n.clients_metadata = e.clientsMetadata.map((o) => o ? IdentifiedGenesisMetadata.toAmino(o) : void 0) : n.clients_metadata = [], n.params = e.params ? Params$k.toAmino(e.params) : void 0, n.create_localhost = e.createLocalhost, n.next_client_sequence = e.nextClientSequence ? e.nextClientSequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$h.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$h.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$h.decode(e.value);
  },
  toProto(e) {
    return GenesisState$h.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.GenesisState",
      value: GenesisState$h.encode(e).finish()
    };
  }
};
function createBaseGenesisMetadata() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array()
  };
}
const GenesisMetadata = {
  typeUrl: "/ibc.core.client.v1.GenesisMetadata",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.value.length !== 0 && n.uint32(18).bytes(e.value), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisMetadata();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.value = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisMetadata();
    return u.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), u.value = (o = e.value) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      key: e.key,
      value: e.value
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.value = e.value, n;
  },
  fromAminoMsg(e) {
    return GenesisMetadata.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisMetadata",
      value: GenesisMetadata.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisMetadata.decode(e.value);
  },
  toProto(e) {
    return GenesisMetadata.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.GenesisMetadata",
      value: GenesisMetadata.encode(e).finish()
    };
  }
};
function createBaseIdentifiedGenesisMetadata() {
  return {
    clientId: "",
    clientMetadata: []
  };
}
const IdentifiedGenesisMetadata = {
  typeUrl: "/ibc.core.client.v1.IdentifiedGenesisMetadata",
  encode(e, n = minimal.Writer.create()) {
    e.clientId !== "" && n.uint32(10).string(e.clientId);
    for (const o of e.clientMetadata)
      GenesisMetadata.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIdentifiedGenesisMetadata();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.clientMetadata.push(GenesisMetadata.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseIdentifiedGenesisMetadata();
    return u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.clientMetadata = ((o = e.clientMetadata) === null || o === void 0 ? void 0 : o.map((c) => GenesisMetadata.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      clientMetadata: Array.isArray(e == null ? void 0 : e.client_metadata) ? e.client_metadata.map((n) => GenesisMetadata.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, e.clientMetadata ? n.client_metadata = e.clientMetadata.map((o) => o ? GenesisMetadata.toAmino(o) : void 0) : n.client_metadata = [], n;
  },
  fromAminoMsg(e) {
    return IdentifiedGenesisMetadata.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/IdentifiedGenesisMetadata",
      value: IdentifiedGenesisMetadata.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return IdentifiedGenesisMetadata.decode(e.value);
  },
  toProto(e) {
    return IdentifiedGenesisMetadata.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.IdentifiedGenesisMetadata",
      value: IdentifiedGenesisMetadata.encode(e).finish()
    };
  }
}, _88 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisMetadata,
  GenesisState: GenesisState$h,
  IdentifiedGenesisMetadata
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryClientStateRequest() {
  return {
    clientId: ""
  };
}
const QueryClientStateRequest = {
  typeUrl: "/ibc.core.client.v1.QueryClientStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryClientStateRequest();
    return o.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n;
  },
  fromAminoMsg(e) {
    return QueryClientStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientStateRequest",
      value: QueryClientStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryClientStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStateRequest",
      value: QueryClientStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryClientStateResponse() {
  return {
    clientState: void 0,
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryClientStateResponse = {
  typeUrl: "/ibc.core.client.v1.QueryClientStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.clientState !== void 0 && Any.encode(e.clientState, n.uint32(10).fork()).ldelim(), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientState = Any.decode(o, o.uint32());
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryClientStateResponse();
    return o.clientState = e.clientState !== void 0 && e.clientState !== null ? Any.fromPartial(e.clientState) : void 0, o.proof = (n = e.proof) !== null && n !== void 0 ? n : new Uint8Array(), o.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, o;
  },
  fromAmino(e) {
    return {
      clientState: e != null && e.client_state ? Any.fromAmino(e.client_state) : void 0,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_state = e.clientState ? Any.toAmino(e.clientState) : void 0, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryClientStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientStateResponse",
      value: QueryClientStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryClientStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStateResponse",
      value: QueryClientStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryClientStatesRequest() {
  return {
    pagination: void 0
  };
}
const QueryClientStatesRequest = {
  typeUrl: "/ibc.core.client.v1.QueryClientStatesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientStatesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryClientStatesRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryClientStatesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientStatesRequest",
      value: QueryClientStatesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientStatesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryClientStatesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStatesRequest",
      value: QueryClientStatesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryClientStatesResponse() {
  return {
    clientStates: [],
    pagination: void 0
  };
}
const QueryClientStatesResponse = {
  typeUrl: "/ibc.core.client.v1.QueryClientStatesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.clientStates)
      IdentifiedClientState.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientStatesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientStates.push(IdentifiedClientState.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryClientStatesResponse();
    return o.clientStates = ((n = e.clientStates) === null || n === void 0 ? void 0 : n.map((u) => IdentifiedClientState.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      clientStates: Array.isArray(e == null ? void 0 : e.client_states) ? e.client_states.map((n) => IdentifiedClientState.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.clientStates ? n.client_states = e.clientStates.map((o) => o ? IdentifiedClientState.toAmino(o) : void 0) : n.client_states = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryClientStatesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientStatesResponse",
      value: QueryClientStatesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientStatesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryClientStatesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStatesResponse",
      value: QueryClientStatesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryConsensusStateRequest() {
  return {
    clientId: "",
    revisionNumber: Long$2.UZERO,
    revisionHeight: Long$2.UZERO,
    latestHeight: !1
  };
}
const QueryConsensusStateRequest = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.revisionNumber.isZero() || n.uint32(16).uint64(e.revisionNumber), e.revisionHeight.isZero() || n.uint32(24).uint64(e.revisionHeight), e.latestHeight === !0 && n.uint32(32).bool(e.latestHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConsensusStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.revisionNumber = o.uint64();
          break;
        case 3:
          c.revisionHeight = o.uint64();
          break;
        case 4:
          c.latestHeight = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryConsensusStateRequest();
    return u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.revisionNumber = e.revisionNumber !== void 0 && e.revisionNumber !== null ? Long$2.fromValue(e.revisionNumber) : Long$2.UZERO, u.revisionHeight = e.revisionHeight !== void 0 && e.revisionHeight !== null ? Long$2.fromValue(e.revisionHeight) : Long$2.UZERO, u.latestHeight = (o = e.latestHeight) !== null && o !== void 0 ? o : !1, u;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      revisionNumber: Long$2.fromString(e.revision_number),
      revisionHeight: Long$2.fromString(e.revision_height),
      latestHeight: e.latest_height
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.revision_number = e.revisionNumber ? e.revisionNumber.toString() : void 0, n.revision_height = e.revisionHeight ? e.revisionHeight.toString() : void 0, n.latest_height = e.latestHeight, n;
  },
  fromAminoMsg(e) {
    return QueryConsensusStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConsensusStateRequest",
      value: QueryConsensusStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConsensusStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConsensusStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStateRequest",
      value: QueryConsensusStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConsensusStateResponse() {
  return {
    consensusState: void 0,
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryConsensusStateResponse = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.consensusState !== void 0 && Any.encode(e.consensusState, n.uint32(10).fork()).ldelim(), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConsensusStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.consensusState = Any.decode(o, o.uint32());
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConsensusStateResponse();
    return o.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? Any.fromPartial(e.consensusState) : void 0, o.proof = (n = e.proof) !== null && n !== void 0 ? n : new Uint8Array(), o.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, o;
  },
  fromAmino(e) {
    return {
      consensusState: e != null && e.consensus_state ? Any.fromAmino(e.consensus_state) : void 0,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.consensus_state = e.consensusState ? Any.toAmino(e.consensusState) : void 0, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryConsensusStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConsensusStateResponse",
      value: QueryConsensusStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConsensusStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConsensusStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStateResponse",
      value: QueryConsensusStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryConsensusStatesRequest() {
  return {
    clientId: "",
    pagination: void 0
  };
}
const QueryConsensusStatesRequest = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStatesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConsensusStatesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConsensusStatesRequest();
    return o.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryConsensusStatesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConsensusStatesRequest",
      value: QueryConsensusStatesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConsensusStatesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConsensusStatesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStatesRequest",
      value: QueryConsensusStatesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConsensusStatesResponse() {
  return {
    consensusStates: [],
    pagination: void 0
  };
}
const QueryConsensusStatesResponse = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStatesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.consensusStates)
      ConsensusStateWithHeight.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConsensusStatesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.consensusStates.push(ConsensusStateWithHeight.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConsensusStatesResponse();
    return o.consensusStates = ((n = e.consensusStates) === null || n === void 0 ? void 0 : n.map((u) => ConsensusStateWithHeight.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      consensusStates: Array.isArray(e == null ? void 0 : e.consensus_states) ? e.consensus_states.map((n) => ConsensusStateWithHeight.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.consensusStates ? n.consensus_states = e.consensusStates.map((o) => o ? ConsensusStateWithHeight.toAmino(o) : void 0) : n.consensus_states = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryConsensusStatesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConsensusStatesResponse",
      value: QueryConsensusStatesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConsensusStatesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConsensusStatesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStatesResponse",
      value: QueryConsensusStatesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryConsensusStateHeightsRequest() {
  return {
    clientId: "",
    pagination: void 0
  };
}
const QueryConsensusStateHeightsRequest = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConsensusStateHeightsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConsensusStateHeightsRequest();
    return o.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryConsensusStateHeightsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConsensusStateHeightsRequest",
      value: QueryConsensusStateHeightsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConsensusStateHeightsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConsensusStateHeightsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsRequest",
      value: QueryConsensusStateHeightsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConsensusStateHeightsResponse() {
  return {
    consensusStateHeights: [],
    pagination: void 0
  };
}
const QueryConsensusStateHeightsResponse = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.consensusStateHeights)
      Height.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConsensusStateHeightsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.consensusStateHeights.push(Height.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConsensusStateHeightsResponse();
    return o.consensusStateHeights = ((n = e.consensusStateHeights) === null || n === void 0 ? void 0 : n.map((u) => Height.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      consensusStateHeights: Array.isArray(e == null ? void 0 : e.consensus_state_heights) ? e.consensus_state_heights.map((n) => Height.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.consensusStateHeights ? n.consensus_state_heights = e.consensusStateHeights.map((o) => o ? Height.toAmino(o) : void 0) : n.consensus_state_heights = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryConsensusStateHeightsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConsensusStateHeightsResponse",
      value: QueryConsensusStateHeightsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConsensusStateHeightsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConsensusStateHeightsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsResponse",
      value: QueryConsensusStateHeightsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryClientStatusRequest() {
  return {
    clientId: ""
  };
}
const QueryClientStatusRequest = {
  typeUrl: "/ibc.core.client.v1.QueryClientStatusRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientStatusRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryClientStatusRequest();
    return o.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n;
  },
  fromAminoMsg(e) {
    return QueryClientStatusRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientStatusRequest",
      value: QueryClientStatusRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientStatusRequest.decode(e.value);
  },
  toProto(e) {
    return QueryClientStatusRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStatusRequest",
      value: QueryClientStatusRequest.encode(e).finish()
    };
  }
};
function createBaseQueryClientStatusResponse() {
  return {
    status: ""
  };
}
const QueryClientStatusResponse = {
  typeUrl: "/ibc.core.client.v1.QueryClientStatusResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.status !== "" && n.uint32(10).string(e.status), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientStatusResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.status = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryClientStatusResponse();
    return o.status = (n = e.status) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      status: e.status
    };
  },
  toAmino(e) {
    const n = {};
    return n.status = e.status, n;
  },
  fromAminoMsg(e) {
    return QueryClientStatusResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientStatusResponse",
      value: QueryClientStatusResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientStatusResponse.decode(e.value);
  },
  toProto(e) {
    return QueryClientStatusResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStatusResponse",
      value: QueryClientStatusResponse.encode(e).finish()
    };
  }
};
function createBaseQueryClientParamsRequest() {
  return {};
}
const QueryClientParamsRequest = {
  typeUrl: "/ibc.core.client.v1.QueryClientParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientParamsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryClientParamsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryClientParamsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientParamsRequest",
      value: QueryClientParamsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientParamsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryClientParamsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientParamsRequest",
      value: QueryClientParamsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryClientParamsResponse() {
  return {
    params: void 0
  };
}
const QueryClientParamsResponse = {
  typeUrl: "/ibc.core.client.v1.QueryClientParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$k.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientParamsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$k.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryClientParamsResponse();
    return n.params = e.params !== void 0 && e.params !== null ? Params$k.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$k.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$k.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryClientParamsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientParamsResponse",
      value: QueryClientParamsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientParamsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryClientParamsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientParamsResponse",
      value: QueryClientParamsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryUpgradedClientStateRequest() {
  return {};
}
const QueryUpgradedClientStateRequest = {
  typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUpgradedClientStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryUpgradedClientStateRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryUpgradedClientStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUpgradedClientStateRequest",
      value: QueryUpgradedClientStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUpgradedClientStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryUpgradedClientStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateRequest",
      value: QueryUpgradedClientStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryUpgradedClientStateResponse() {
  return {
    upgradedClientState: void 0
  };
}
const QueryUpgradedClientStateResponse = {
  typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.upgradedClientState !== void 0 && Any.encode(e.upgradedClientState, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUpgradedClientStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.upgradedClientState = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryUpgradedClientStateResponse();
    return n.upgradedClientState = e.upgradedClientState !== void 0 && e.upgradedClientState !== null ? Any.fromPartial(e.upgradedClientState) : void 0, n;
  },
  fromAmino(e) {
    return {
      upgradedClientState: e != null && e.upgraded_client_state ? Any.fromAmino(e.upgraded_client_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.upgraded_client_state = e.upgradedClientState ? Any.toAmino(e.upgradedClientState) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryUpgradedClientStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUpgradedClientStateResponse",
      value: QueryUpgradedClientStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUpgradedClientStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryUpgradedClientStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateResponse",
      value: QueryUpgradedClientStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryUpgradedConsensusStateRequest() {
  return {};
}
const QueryUpgradedConsensusStateRequest = {
  typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUpgradedConsensusStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryUpgradedConsensusStateRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryUpgradedConsensusStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUpgradedConsensusStateRequest",
      value: QueryUpgradedConsensusStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUpgradedConsensusStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryUpgradedConsensusStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateRequest",
      value: QueryUpgradedConsensusStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryUpgradedConsensusStateResponse() {
  return {
    upgradedConsensusState: void 0
  };
}
const QueryUpgradedConsensusStateResponse = {
  typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.upgradedConsensusState !== void 0 && Any.encode(e.upgradedConsensusState, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUpgradedConsensusStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.upgradedConsensusState = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryUpgradedConsensusStateResponse();
    return n.upgradedConsensusState = e.upgradedConsensusState !== void 0 && e.upgradedConsensusState !== null ? Any.fromPartial(e.upgradedConsensusState) : void 0, n;
  },
  fromAmino(e) {
    return {
      upgradedConsensusState: e != null && e.upgraded_consensus_state ? Any.fromAmino(e.upgraded_consensus_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.upgraded_consensus_state = e.upgradedConsensusState ? Any.toAmino(e.upgradedConsensusState) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryUpgradedConsensusStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryUpgradedConsensusStateResponse",
      value: QueryUpgradedConsensusStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUpgradedConsensusStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryUpgradedConsensusStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateResponse",
      value: QueryUpgradedConsensusStateResponse.encode(e).finish()
    };
  }
}, _89 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientParamsRequest,
  QueryClientParamsResponse,
  QueryClientStateRequest,
  QueryClientStateResponse,
  QueryClientStatesRequest,
  QueryClientStatesResponse,
  QueryClientStatusRequest,
  QueryClientStatusResponse,
  QueryConsensusStateHeightsRequest,
  QueryConsensusStateHeightsResponse,
  QueryConsensusStateRequest,
  QueryConsensusStateResponse,
  QueryConsensusStatesRequest,
  QueryConsensusStatesResponse,
  QueryUpgradedClientStateRequest,
  QueryUpgradedClientStateResponse,
  QueryUpgradedConsensusStateRequest,
  QueryUpgradedConsensusStateResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgCreateClient() {
  return {
    clientState: void 0,
    consensusState: void 0,
    signer: ""
  };
}
const MsgCreateClient = {
  typeUrl: "/ibc.core.client.v1.MsgCreateClient",
  encode(e, n = minimal.Writer.create()) {
    return e.clientState !== void 0 && Any.encode(e.clientState, n.uint32(10).fork()).ldelim(), e.consensusState !== void 0 && Any.encode(e.consensusState, n.uint32(18).fork()).ldelim(), e.signer !== "" && n.uint32(26).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateClient();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientState = Any.decode(o, o.uint32());
          break;
        case 2:
          c.consensusState = Any.decode(o, o.uint32());
          break;
        case 3:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgCreateClient();
    return o.clientState = e.clientState !== void 0 && e.clientState !== null ? Any.fromPartial(e.clientState) : void 0, o.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? Any.fromPartial(e.consensusState) : void 0, o.signer = (n = e.signer) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      clientState: e != null && e.client_state ? Any.fromAmino(e.client_state) : void 0,
      consensusState: e != null && e.consensus_state ? Any.fromAmino(e.consensus_state) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_state = e.clientState ? Any.toAmino(e.clientState) : void 0, n.consensus_state = e.consensusState ? Any.toAmino(e.consensusState) : void 0, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgCreateClient.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgCreateClient",
      value: MsgCreateClient.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateClient.decode(e.value);
  },
  toProto(e) {
    return MsgCreateClient.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgCreateClient",
      value: MsgCreateClient.encode(e).finish()
    };
  }
};
function createBaseMsgCreateClientResponse() {
  return {};
}
const MsgCreateClientResponse = {
  typeUrl: "/ibc.core.client.v1.MsgCreateClientResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateClientResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgCreateClientResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgCreateClientResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgCreateClientResponse",
      value: MsgCreateClientResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateClientResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCreateClientResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgCreateClientResponse",
      value: MsgCreateClientResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUpdateClient() {
  return {
    clientId: "",
    clientMessage: void 0,
    signer: ""
  };
}
const MsgUpdateClient = {
  typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.clientMessage !== void 0 && Any.encode(e.clientMessage, n.uint32(18).fork()).ldelim(), e.signer !== "" && n.uint32(26).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpdateClient();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.clientMessage = Any.decode(o, o.uint32());
          break;
        case 3:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgUpdateClient();
    return u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.clientMessage = e.clientMessage !== void 0 && e.clientMessage !== null ? Any.fromPartial(e.clientMessage) : void 0, u.signer = (o = e.signer) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      clientMessage: e != null && e.client_message ? Any.fromAmino(e.client_message) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.client_message = e.clientMessage ? Any.toAmino(e.clientMessage) : void 0, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgUpdateClient.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgUpdateClient",
      value: MsgUpdateClient.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpdateClient.decode(e.value);
  },
  toProto(e) {
    return MsgUpdateClient.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
      value: MsgUpdateClient.encode(e).finish()
    };
  }
};
function createBaseMsgUpdateClientResponse() {
  return {};
}
const MsgUpdateClientResponse = {
  typeUrl: "/ibc.core.client.v1.MsgUpdateClientResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpdateClientResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgUpdateClientResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgUpdateClientResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgUpdateClientResponse",
      value: MsgUpdateClientResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpdateClientResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUpdateClientResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgUpdateClientResponse",
      value: MsgUpdateClientResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUpgradeClient() {
  return {
    clientId: "",
    clientState: void 0,
    consensusState: void 0,
    proofUpgradeClient: new Uint8Array(),
    proofUpgradeConsensusState: new Uint8Array(),
    signer: ""
  };
}
const MsgUpgradeClient = {
  typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.clientState !== void 0 && Any.encode(e.clientState, n.uint32(18).fork()).ldelim(), e.consensusState !== void 0 && Any.encode(e.consensusState, n.uint32(26).fork()).ldelim(), e.proofUpgradeClient.length !== 0 && n.uint32(34).bytes(e.proofUpgradeClient), e.proofUpgradeConsensusState.length !== 0 && n.uint32(42).bytes(e.proofUpgradeConsensusState), e.signer !== "" && n.uint32(50).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpgradeClient();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.clientState = Any.decode(o, o.uint32());
          break;
        case 3:
          c.consensusState = Any.decode(o, o.uint32());
          break;
        case 4:
          c.proofUpgradeClient = o.bytes();
          break;
        case 5:
          c.proofUpgradeConsensusState = o.bytes();
          break;
        case 6:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgUpgradeClient();
    return d.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", d.clientState = e.clientState !== void 0 && e.clientState !== null ? Any.fromPartial(e.clientState) : void 0, d.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? Any.fromPartial(e.consensusState) : void 0, d.proofUpgradeClient = (o = e.proofUpgradeClient) !== null && o !== void 0 ? o : new Uint8Array(), d.proofUpgradeConsensusState = (u = e.proofUpgradeConsensusState) !== null && u !== void 0 ? u : new Uint8Array(), d.signer = (c = e.signer) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      clientState: e != null && e.client_state ? Any.fromAmino(e.client_state) : void 0,
      consensusState: e != null && e.consensus_state ? Any.fromAmino(e.consensus_state) : void 0,
      proofUpgradeClient: e.proof_upgrade_client,
      proofUpgradeConsensusState: e.proof_upgrade_consensus_state,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.client_state = e.clientState ? Any.toAmino(e.clientState) : void 0, n.consensus_state = e.consensusState ? Any.toAmino(e.consensusState) : void 0, n.proof_upgrade_client = e.proofUpgradeClient, n.proof_upgrade_consensus_state = e.proofUpgradeConsensusState, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgUpgradeClient.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgUpgradeClient",
      value: MsgUpgradeClient.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpgradeClient.decode(e.value);
  },
  toProto(e) {
    return MsgUpgradeClient.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
      value: MsgUpgradeClient.encode(e).finish()
    };
  }
};
function createBaseMsgUpgradeClientResponse() {
  return {};
}
const MsgUpgradeClientResponse = {
  typeUrl: "/ibc.core.client.v1.MsgUpgradeClientResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpgradeClientResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgUpgradeClientResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgUpgradeClientResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgUpgradeClientResponse",
      value: MsgUpgradeClientResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpgradeClientResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUpgradeClientResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgUpgradeClientResponse",
      value: MsgUpgradeClientResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSubmitMisbehaviour() {
  return {
    clientId: "",
    misbehaviour: void 0,
    signer: ""
  };
}
const MsgSubmitMisbehaviour = {
  typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.misbehaviour !== void 0 && Any.encode(e.misbehaviour, n.uint32(18).fork()).ldelim(), e.signer !== "" && n.uint32(26).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSubmitMisbehaviour();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.misbehaviour = Any.decode(o, o.uint32());
          break;
        case 3:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgSubmitMisbehaviour();
    return u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.misbehaviour = e.misbehaviour !== void 0 && e.misbehaviour !== null ? Any.fromPartial(e.misbehaviour) : void 0, u.signer = (o = e.signer) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      misbehaviour: e != null && e.misbehaviour ? Any.fromAmino(e.misbehaviour) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.misbehaviour = e.misbehaviour ? Any.toAmino(e.misbehaviour) : void 0, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgSubmitMisbehaviour.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSubmitMisbehaviour",
      value: MsgSubmitMisbehaviour.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSubmitMisbehaviour.decode(e.value);
  },
  toProto(e) {
    return MsgSubmitMisbehaviour.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
      value: MsgSubmitMisbehaviour.encode(e).finish()
    };
  }
};
function createBaseMsgSubmitMisbehaviourResponse() {
  return {};
}
const MsgSubmitMisbehaviourResponse = {
  typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviourResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSubmitMisbehaviourResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSubmitMisbehaviourResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSubmitMisbehaviourResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgSubmitMisbehaviourResponse",
      value: MsgSubmitMisbehaviourResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSubmitMisbehaviourResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSubmitMisbehaviourResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviourResponse",
      value: MsgSubmitMisbehaviourResponse.encode(e).finish()
    };
  }
}, _90 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgCreateClient,
  MsgCreateClientResponse,
  MsgSubmitMisbehaviour,
  MsgSubmitMisbehaviourResponse,
  MsgUpdateClient,
  MsgUpdateClientResponse,
  MsgUpgradeClient,
  MsgUpgradeClientResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMerkleRoot() {
  return {
    hash: new Uint8Array()
  };
}
const MerkleRoot = {
  typeUrl: "/ibc.core.commitment.v1.MerkleRoot",
  encode(e, n = minimal.Writer.create()) {
    return e.hash.length !== 0 && n.uint32(10).bytes(e.hash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMerkleRoot();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMerkleRoot();
    return o.hash = (n = e.hash) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      hash: e.hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n;
  },
  fromAminoMsg(e) {
    return MerkleRoot.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MerkleRoot",
      value: MerkleRoot.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MerkleRoot.decode(e.value);
  },
  toProto(e) {
    return MerkleRoot.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.commitment.v1.MerkleRoot",
      value: MerkleRoot.encode(e).finish()
    };
  }
};
function createBaseMerklePrefix() {
  return {
    keyPrefix: new Uint8Array()
  };
}
const MerklePrefix = {
  typeUrl: "/ibc.core.commitment.v1.MerklePrefix",
  encode(e, n = minimal.Writer.create()) {
    return e.keyPrefix.length !== 0 && n.uint32(10).bytes(e.keyPrefix), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMerklePrefix();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.keyPrefix = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMerklePrefix();
    return o.keyPrefix = (n = e.keyPrefix) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      keyPrefix: e.key_prefix
    };
  },
  toAmino(e) {
    const n = {};
    return n.key_prefix = e.keyPrefix, n;
  },
  fromAminoMsg(e) {
    return MerklePrefix.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MerklePrefix",
      value: MerklePrefix.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MerklePrefix.decode(e.value);
  },
  toProto(e) {
    return MerklePrefix.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.commitment.v1.MerklePrefix",
      value: MerklePrefix.encode(e).finish()
    };
  }
};
function createBaseMerklePath() {
  return {
    keyPath: []
  };
}
const MerklePath = {
  typeUrl: "/ibc.core.commitment.v1.MerklePath",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.keyPath)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMerklePath();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.keyPath.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMerklePath();
    return o.keyPath = ((n = e.keyPath) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      keyPath: Array.isArray(e == null ? void 0 : e.key_path) ? e.key_path.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.keyPath ? n.key_path = e.keyPath.map((o) => o) : n.key_path = [], n;
  },
  fromAminoMsg(e) {
    return MerklePath.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MerklePath",
      value: MerklePath.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MerklePath.decode(e.value);
  },
  toProto(e) {
    return MerklePath.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.commitment.v1.MerklePath",
      value: MerklePath.encode(e).finish()
    };
  }
};
function createBaseMerkleProof() {
  return {
    proofs: []
  };
}
const MerkleProof = {
  typeUrl: "/ibc.core.commitment.v1.MerkleProof",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.proofs)
      CommitmentProof$1.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMerkleProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.proofs.push(CommitmentProof$1.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMerkleProof();
    return o.proofs = ((n = e.proofs) === null || n === void 0 ? void 0 : n.map((u) => CommitmentProof$1.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      proofs: Array.isArray(e == null ? void 0 : e.proofs) ? e.proofs.map((n) => CommitmentProof$1.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.proofs ? n.proofs = e.proofs.map((o) => o ? CommitmentProof$1.toAmino(o) : void 0) : n.proofs = [], n;
  },
  fromAminoMsg(e) {
    return MerkleProof.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MerkleProof",
      value: MerkleProof.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MerkleProof.decode(e.value);
  },
  toProto(e) {
    return MerkleProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.commitment.v1.MerkleProof",
      value: MerkleProof.encode(e).finish()
    };
  }
}, _91 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MerklePath,
  MerklePrefix,
  MerkleProof,
  MerkleRoot
}, Symbol.toStringTag, { value: "Module" }));
let State;
(function(e) {
  e[e.STATE_UNINITIALIZED_UNSPECIFIED = 0] = "STATE_UNINITIALIZED_UNSPECIFIED", e[e.STATE_INIT = 1] = "STATE_INIT", e[e.STATE_TRYOPEN = 2] = "STATE_TRYOPEN", e[e.STATE_OPEN = 3] = "STATE_OPEN", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(State || (State = {}));
const StateSDKType = State, StateAmino = State;
function stateFromJSON(e) {
  switch (e) {
    case 0:
    case "STATE_UNINITIALIZED_UNSPECIFIED":
      return State.STATE_UNINITIALIZED_UNSPECIFIED;
    case 1:
    case "STATE_INIT":
      return State.STATE_INIT;
    case 2:
    case "STATE_TRYOPEN":
      return State.STATE_TRYOPEN;
    case 3:
    case "STATE_OPEN":
      return State.STATE_OPEN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return State.UNRECOGNIZED;
  }
}
function stateToJSON(e) {
  switch (e) {
    case State.STATE_UNINITIALIZED_UNSPECIFIED:
      return "STATE_UNINITIALIZED_UNSPECIFIED";
    case State.STATE_INIT:
      return "STATE_INIT";
    case State.STATE_TRYOPEN:
      return "STATE_TRYOPEN";
    case State.STATE_OPEN:
      return "STATE_OPEN";
    case State.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseConnectionEnd() {
  return {
    clientId: "",
    versions: [],
    state: 0,
    counterparty: void 0,
    delayPeriod: Long$2.UZERO
  };
}
const ConnectionEnd = {
  typeUrl: "/ibc.core.connection.v1.ConnectionEnd",
  encode(e, n = minimal.Writer.create()) {
    e.clientId !== "" && n.uint32(10).string(e.clientId);
    for (const o of e.versions)
      Version.encode(o, n.uint32(18).fork()).ldelim();
    return e.state !== 0 && n.uint32(24).int32(e.state), e.counterparty !== void 0 && Counterparty.encode(e.counterparty, n.uint32(34).fork()).ldelim(), e.delayPeriod.isZero() || n.uint32(40).uint64(e.delayPeriod), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConnectionEnd();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.versions.push(Version.decode(o, o.uint32()));
          break;
        case 3:
          c.state = o.int32();
          break;
        case 4:
          c.counterparty = Counterparty.decode(o, o.uint32());
          break;
        case 5:
          c.delayPeriod = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseConnectionEnd();
    return c.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", c.versions = ((o = e.versions) === null || o === void 0 ? void 0 : o.map((d) => Version.fromPartial(d))) || [], c.state = (u = e.state) !== null && u !== void 0 ? u : 0, c.counterparty = e.counterparty !== void 0 && e.counterparty !== null ? Counterparty.fromPartial(e.counterparty) : void 0, c.delayPeriod = e.delayPeriod !== void 0 && e.delayPeriod !== null ? Long$2.fromValue(e.delayPeriod) : Long$2.UZERO, c;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      versions: Array.isArray(e == null ? void 0 : e.versions) ? e.versions.map((n) => Version.fromAmino(n)) : [],
      state: isSet(e.state) ? stateFromJSON(e.state) : 0,
      counterparty: e != null && e.counterparty ? Counterparty.fromAmino(e.counterparty) : void 0,
      delayPeriod: Long$2.fromString(e.delay_period)
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, e.versions ? n.versions = e.versions.map((o) => o ? Version.toAmino(o) : void 0) : n.versions = [], n.state = e.state, n.counterparty = e.counterparty ? Counterparty.toAmino(e.counterparty) : void 0, n.delay_period = e.delayPeriod ? e.delayPeriod.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ConnectionEnd.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConnectionEnd",
      value: ConnectionEnd.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConnectionEnd.decode(e.value);
  },
  toProto(e) {
    return ConnectionEnd.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.ConnectionEnd",
      value: ConnectionEnd.encode(e).finish()
    };
  }
};
function createBaseIdentifiedConnection() {
  return {
    id: "",
    clientId: "",
    versions: [],
    state: 0,
    counterparty: void 0,
    delayPeriod: Long$2.UZERO
  };
}
const IdentifiedConnection = {
  typeUrl: "/ibc.core.connection.v1.IdentifiedConnection",
  encode(e, n = minimal.Writer.create()) {
    e.id !== "" && n.uint32(10).string(e.id), e.clientId !== "" && n.uint32(18).string(e.clientId);
    for (const o of e.versions)
      Version.encode(o, n.uint32(26).fork()).ldelim();
    return e.state !== 0 && n.uint32(32).int32(e.state), e.counterparty !== void 0 && Counterparty.encode(e.counterparty, n.uint32(42).fork()).ldelim(), e.delayPeriod.isZero() || n.uint32(48).uint64(e.delayPeriod), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIdentifiedConnection();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.id = o.string();
          break;
        case 2:
          c.clientId = o.string();
          break;
        case 3:
          c.versions.push(Version.decode(o, o.uint32()));
          break;
        case 4:
          c.state = o.int32();
          break;
        case 5:
          c.counterparty = Counterparty.decode(o, o.uint32());
          break;
        case 6:
          c.delayPeriod = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseIdentifiedConnection();
    return d.id = (n = e.id) !== null && n !== void 0 ? n : "", d.clientId = (o = e.clientId) !== null && o !== void 0 ? o : "", d.versions = ((u = e.versions) === null || u === void 0 ? void 0 : u.map((m) => Version.fromPartial(m))) || [], d.state = (c = e.state) !== null && c !== void 0 ? c : 0, d.counterparty = e.counterparty !== void 0 && e.counterparty !== null ? Counterparty.fromPartial(e.counterparty) : void 0, d.delayPeriod = e.delayPeriod !== void 0 && e.delayPeriod !== null ? Long$2.fromValue(e.delayPeriod) : Long$2.UZERO, d;
  },
  fromAmino(e) {
    return {
      id: e.id,
      clientId: e.client_id,
      versions: Array.isArray(e == null ? void 0 : e.versions) ? e.versions.map((n) => Version.fromAmino(n)) : [],
      state: isSet(e.state) ? stateFromJSON(e.state) : 0,
      counterparty: e != null && e.counterparty ? Counterparty.fromAmino(e.counterparty) : void 0,
      delayPeriod: Long$2.fromString(e.delay_period)
    };
  },
  toAmino(e) {
    const n = {};
    return n.id = e.id, n.client_id = e.clientId, e.versions ? n.versions = e.versions.map((o) => o ? Version.toAmino(o) : void 0) : n.versions = [], n.state = e.state, n.counterparty = e.counterparty ? Counterparty.toAmino(e.counterparty) : void 0, n.delay_period = e.delayPeriod ? e.delayPeriod.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return IdentifiedConnection.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/IdentifiedConnection",
      value: IdentifiedConnection.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return IdentifiedConnection.decode(e.value);
  },
  toProto(e) {
    return IdentifiedConnection.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.IdentifiedConnection",
      value: IdentifiedConnection.encode(e).finish()
    };
  }
};
function createBaseCounterparty() {
  return {
    clientId: "",
    connectionId: "",
    prefix: void 0
  };
}
const Counterparty = {
  typeUrl: "/ibc.core.connection.v1.Counterparty",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.connectionId !== "" && n.uint32(18).string(e.connectionId), e.prefix !== void 0 && MerklePrefix.encode(e.prefix, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCounterparty();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.connectionId = o.string();
          break;
        case 3:
          c.prefix = MerklePrefix.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCounterparty();
    return u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.connectionId = (o = e.connectionId) !== null && o !== void 0 ? o : "", u.prefix = e.prefix !== void 0 && e.prefix !== null ? MerklePrefix.fromPartial(e.prefix) : void 0, u;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      connectionId: e.connection_id,
      prefix: e != null && e.prefix ? MerklePrefix.fromAmino(e.prefix) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.connection_id = e.connectionId, n.prefix = e.prefix ? MerklePrefix.toAmino(e.prefix) : void 0, n;
  },
  fromAminoMsg(e) {
    return Counterparty.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Counterparty",
      value: Counterparty.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Counterparty.decode(e.value);
  },
  toProto(e) {
    return Counterparty.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.Counterparty",
      value: Counterparty.encode(e).finish()
    };
  }
};
function createBaseClientPaths() {
  return {
    paths: []
  };
}
const ClientPaths = {
  typeUrl: "/ibc.core.connection.v1.ClientPaths",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.paths)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClientPaths();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.paths.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseClientPaths();
    return o.paths = ((n = e.paths) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      paths: Array.isArray(e == null ? void 0 : e.paths) ? e.paths.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.paths ? n.paths = e.paths.map((o) => o) : n.paths = [], n;
  },
  fromAminoMsg(e) {
    return ClientPaths.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ClientPaths",
      value: ClientPaths.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClientPaths.decode(e.value);
  },
  toProto(e) {
    return ClientPaths.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.ClientPaths",
      value: ClientPaths.encode(e).finish()
    };
  }
};
function createBaseConnectionPaths() {
  return {
    clientId: "",
    paths: []
  };
}
const ConnectionPaths = {
  typeUrl: "/ibc.core.connection.v1.ConnectionPaths",
  encode(e, n = minimal.Writer.create()) {
    e.clientId !== "" && n.uint32(10).string(e.clientId);
    for (const o of e.paths)
      n.uint32(18).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConnectionPaths();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.paths.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseConnectionPaths();
    return u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.paths = ((o = e.paths) === null || o === void 0 ? void 0 : o.map((c) => c)) || [], u;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      paths: Array.isArray(e == null ? void 0 : e.paths) ? e.paths.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, e.paths ? n.paths = e.paths.map((o) => o) : n.paths = [], n;
  },
  fromAminoMsg(e) {
    return ConnectionPaths.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConnectionPaths",
      value: ConnectionPaths.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConnectionPaths.decode(e.value);
  },
  toProto(e) {
    return ConnectionPaths.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.ConnectionPaths",
      value: ConnectionPaths.encode(e).finish()
    };
  }
};
function createBaseVersion() {
  return {
    identifier: "",
    features: []
  };
}
const Version = {
  typeUrl: "/ibc.core.connection.v1.Version",
  encode(e, n = minimal.Writer.create()) {
    e.identifier !== "" && n.uint32(10).string(e.identifier);
    for (const o of e.features)
      n.uint32(18).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseVersion();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.identifier = o.string();
          break;
        case 2:
          c.features.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseVersion();
    return u.identifier = (n = e.identifier) !== null && n !== void 0 ? n : "", u.features = ((o = e.features) === null || o === void 0 ? void 0 : o.map((c) => c)) || [], u;
  },
  fromAmino(e) {
    return {
      identifier: e.identifier,
      features: Array.isArray(e == null ? void 0 : e.features) ? e.features.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.identifier = e.identifier, e.features ? n.features = e.features.map((o) => o) : n.features = [], n;
  },
  fromAminoMsg(e) {
    return Version.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Version",
      value: Version.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Version.decode(e.value);
  },
  toProto(e) {
    return Version.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.Version",
      value: Version.encode(e).finish()
    };
  }
};
function createBaseParams$c() {
  return {
    maxExpectedTimePerBlock: Long$2.UZERO
  };
}
const Params$c = {
  typeUrl: "/ibc.core.connection.v1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.maxExpectedTimePerBlock.isZero() || n.uint32(8).uint64(e.maxExpectedTimePerBlock), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$c();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.maxExpectedTimePerBlock = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseParams$c();
    return n.maxExpectedTimePerBlock = e.maxExpectedTimePerBlock !== void 0 && e.maxExpectedTimePerBlock !== null ? Long$2.fromValue(e.maxExpectedTimePerBlock) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      maxExpectedTimePerBlock: Long$2.fromString(e.max_expected_time_per_block)
    };
  },
  toAmino(e) {
    const n = {};
    return n.max_expected_time_per_block = e.maxExpectedTimePerBlock ? e.maxExpectedTimePerBlock.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Params$c.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Params",
      value: Params$c.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$c.decode(e.value);
  },
  toProto(e) {
    return Params$c.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.Params",
      value: Params$c.encode(e).finish()
    };
  }
}, _92 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClientPaths,
  ConnectionEnd,
  ConnectionPaths,
  Counterparty,
  IdentifiedConnection,
  Params: Params$c,
  get State() {
    return State;
  },
  StateAmino,
  StateSDKType,
  Version,
  stateFromJSON,
  stateToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$g() {
  return {
    connections: [],
    clientConnectionPaths: [],
    nextConnectionSequence: Long$2.UZERO,
    params: void 0
  };
}
const GenesisState$g = {
  typeUrl: "/ibc.core.connection.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.connections)
      IdentifiedConnection.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.clientConnectionPaths)
      ConnectionPaths.encode(o, n.uint32(18).fork()).ldelim();
    return e.nextConnectionSequence.isZero() || n.uint32(24).uint64(e.nextConnectionSequence), e.params !== void 0 && Params$c.encode(e.params, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$g();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connections.push(IdentifiedConnection.decode(o, o.uint32()));
          break;
        case 2:
          c.clientConnectionPaths.push(ConnectionPaths.decode(o, o.uint32()));
          break;
        case 3:
          c.nextConnectionSequence = o.uint64();
          break;
        case 4:
          c.params = Params$c.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisState$g();
    return u.connections = ((n = e.connections) === null || n === void 0 ? void 0 : n.map((c) => IdentifiedConnection.fromPartial(c))) || [], u.clientConnectionPaths = ((o = e.clientConnectionPaths) === null || o === void 0 ? void 0 : o.map((c) => ConnectionPaths.fromPartial(c))) || [], u.nextConnectionSequence = e.nextConnectionSequence !== void 0 && e.nextConnectionSequence !== null ? Long$2.fromValue(e.nextConnectionSequence) : Long$2.UZERO, u.params = e.params !== void 0 && e.params !== null ? Params$c.fromPartial(e.params) : void 0, u;
  },
  fromAmino(e) {
    return {
      connections: Array.isArray(e == null ? void 0 : e.connections) ? e.connections.map((n) => IdentifiedConnection.fromAmino(n)) : [],
      clientConnectionPaths: Array.isArray(e == null ? void 0 : e.client_connection_paths) ? e.client_connection_paths.map((n) => ConnectionPaths.fromAmino(n)) : [],
      nextConnectionSequence: Long$2.fromString(e.next_connection_sequence),
      params: e != null && e.params ? Params$c.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.connections ? n.connections = e.connections.map((o) => o ? IdentifiedConnection.toAmino(o) : void 0) : n.connections = [], e.clientConnectionPaths ? n.client_connection_paths = e.clientConnectionPaths.map((o) => o ? ConnectionPaths.toAmino(o) : void 0) : n.client_connection_paths = [], n.next_connection_sequence = e.nextConnectionSequence ? e.nextConnectionSequence.toString() : void 0, n.params = e.params ? Params$c.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$g.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState$g.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$g.decode(e.value);
  },
  toProto(e) {
    return GenesisState$g.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.GenesisState",
      value: GenesisState$g.encode(e).finish()
    };
  }
}, _93 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$g
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryConnectionRequest() {
  return {
    connectionId: ""
  };
}
const QueryConnectionRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.connectionId !== "" && n.uint32(10).string(e.connectionId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connectionId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConnectionRequest();
    return o.connectionId = (n = e.connectionId) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      connectionId: e.connection_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection_id = e.connectionId, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionRequest",
      value: QueryConnectionRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionRequest",
      value: QueryConnectionRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionResponse() {
  return {
    connection: void 0,
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryConnectionResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.connection !== void 0 && ConnectionEnd.encode(e.connection, n.uint32(10).fork()).ldelim(), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connection = ConnectionEnd.decode(o, o.uint32());
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConnectionResponse();
    return o.connection = e.connection !== void 0 && e.connection !== null ? ConnectionEnd.fromPartial(e.connection) : void 0, o.proof = (n = e.proof) !== null && n !== void 0 ? n : new Uint8Array(), o.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, o;
  },
  fromAmino(e) {
    return {
      connection: e != null && e.connection ? ConnectionEnd.fromAmino(e.connection) : void 0,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection = e.connection ? ConnectionEnd.toAmino(e.connection) : void 0, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionResponse",
      value: QueryConnectionResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionResponse",
      value: QueryConnectionResponse.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionsRequest() {
  return {
    pagination: void 0
  };
}
const QueryConnectionsRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryConnectionsRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionsRequest",
      value: QueryConnectionsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionsRequest",
      value: QueryConnectionsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionsResponse() {
  return {
    connections: [],
    pagination: void 0,
    height: void 0
  };
}
const QueryConnectionsResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.connections)
      IdentifiedConnection.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), e.height !== void 0 && Height.encode(e.height, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connections.push(IdentifiedConnection.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        case 3:
          c.height = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConnectionsResponse();
    return o.connections = ((n = e.connections) === null || n === void 0 ? void 0 : n.map((u) => IdentifiedConnection.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o.height = e.height !== void 0 && e.height !== null ? Height.fromPartial(e.height) : void 0, o;
  },
  fromAmino(e) {
    return {
      connections: Array.isArray(e == null ? void 0 : e.connections) ? e.connections.map((n) => IdentifiedConnection.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0,
      height: e != null && e.height ? Height.fromAmino(e.height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.connections ? n.connections = e.connections.map((o) => o ? IdentifiedConnection.toAmino(o) : void 0) : n.connections = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n.height = e.height ? Height.toAmino(e.height) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionsResponse",
      value: QueryConnectionsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionsResponse",
      value: QueryConnectionsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryClientConnectionsRequest() {
  return {
    clientId: ""
  };
}
const QueryClientConnectionsRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientConnectionsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryClientConnectionsRequest();
    return o.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n;
  },
  fromAminoMsg(e) {
    return QueryClientConnectionsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientConnectionsRequest",
      value: QueryClientConnectionsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientConnectionsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryClientConnectionsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsRequest",
      value: QueryClientConnectionsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryClientConnectionsResponse() {
  return {
    connectionPaths: [],
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryClientConnectionsResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.connectionPaths)
      n.uint32(10).string(o);
    return e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryClientConnectionsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connectionPaths.push(o.string());
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryClientConnectionsResponse();
    return u.connectionPaths = ((n = e.connectionPaths) === null || n === void 0 ? void 0 : n.map((c) => c)) || [], u.proof = (o = e.proof) !== null && o !== void 0 ? o : new Uint8Array(), u.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, u;
  },
  fromAmino(e) {
    return {
      connectionPaths: Array.isArray(e == null ? void 0 : e.connection_paths) ? e.connection_paths.map((n) => n) : [],
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.connectionPaths ? n.connection_paths = e.connectionPaths.map((o) => o) : n.connection_paths = [], n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryClientConnectionsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryClientConnectionsResponse",
      value: QueryClientConnectionsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryClientConnectionsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryClientConnectionsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsResponse",
      value: QueryClientConnectionsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionClientStateRequest() {
  return {
    connectionId: ""
  };
}
const QueryConnectionClientStateRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.connectionId !== "" && n.uint32(10).string(e.connectionId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionClientStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connectionId = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConnectionClientStateRequest();
    return o.connectionId = (n = e.connectionId) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      connectionId: e.connection_id
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection_id = e.connectionId, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionClientStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionClientStateRequest",
      value: QueryConnectionClientStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionClientStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionClientStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateRequest",
      value: QueryConnectionClientStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionClientStateResponse() {
  return {
    identifiedClientState: void 0,
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryConnectionClientStateResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.identifiedClientState !== void 0 && IdentifiedClientState.encode(e.identifiedClientState, n.uint32(10).fork()).ldelim(), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionClientStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.identifiedClientState = IdentifiedClientState.decode(o, o.uint32());
          break;
        case 2:
          c.proof = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConnectionClientStateResponse();
    return o.identifiedClientState = e.identifiedClientState !== void 0 && e.identifiedClientState !== null ? IdentifiedClientState.fromPartial(e.identifiedClientState) : void 0, o.proof = (n = e.proof) !== null && n !== void 0 ? n : new Uint8Array(), o.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, o;
  },
  fromAmino(e) {
    return {
      identifiedClientState: e != null && e.identified_client_state ? IdentifiedClientState.fromAmino(e.identified_client_state) : void 0,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.identified_client_state = e.identifiedClientState ? IdentifiedClientState.toAmino(e.identifiedClientState) : void 0, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionClientStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionClientStateResponse",
      value: QueryConnectionClientStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionClientStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionClientStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateResponse",
      value: QueryConnectionClientStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionConsensusStateRequest() {
  return {
    connectionId: "",
    revisionNumber: Long$2.UZERO,
    revisionHeight: Long$2.UZERO
  };
}
const QueryConnectionConsensusStateRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.connectionId !== "" && n.uint32(10).string(e.connectionId), e.revisionNumber.isZero() || n.uint32(16).uint64(e.revisionNumber), e.revisionHeight.isZero() || n.uint32(24).uint64(e.revisionHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionConsensusStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connectionId = o.string();
          break;
        case 2:
          c.revisionNumber = o.uint64();
          break;
        case 3:
          c.revisionHeight = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryConnectionConsensusStateRequest();
    return o.connectionId = (n = e.connectionId) !== null && n !== void 0 ? n : "", o.revisionNumber = e.revisionNumber !== void 0 && e.revisionNumber !== null ? Long$2.fromValue(e.revisionNumber) : Long$2.UZERO, o.revisionHeight = e.revisionHeight !== void 0 && e.revisionHeight !== null ? Long$2.fromValue(e.revisionHeight) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      connectionId: e.connection_id,
      revisionNumber: Long$2.fromString(e.revision_number),
      revisionHeight: Long$2.fromString(e.revision_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection_id = e.connectionId, n.revision_number = e.revisionNumber ? e.revisionNumber.toString() : void 0, n.revision_height = e.revisionHeight ? e.revisionHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionConsensusStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionConsensusStateRequest",
      value: QueryConnectionConsensusStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionConsensusStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionConsensusStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateRequest",
      value: QueryConnectionConsensusStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionConsensusStateResponse() {
  return {
    consensusState: void 0,
    clientId: "",
    proof: new Uint8Array(),
    proofHeight: void 0
  };
}
const QueryConnectionConsensusStateResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.consensusState !== void 0 && Any.encode(e.consensusState, n.uint32(10).fork()).ldelim(), e.clientId !== "" && n.uint32(18).string(e.clientId), e.proof.length !== 0 && n.uint32(26).bytes(e.proof), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionConsensusStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.consensusState = Any.decode(o, o.uint32());
          break;
        case 2:
          c.clientId = o.string();
          break;
        case 3:
          c.proof = o.bytes();
          break;
        case 4:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryConnectionConsensusStateResponse();
    return u.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? Any.fromPartial(e.consensusState) : void 0, u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.proof = (o = e.proof) !== null && o !== void 0 ? o : new Uint8Array(), u.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, u;
  },
  fromAmino(e) {
    return {
      consensusState: e != null && e.consensus_state ? Any.fromAmino(e.consensus_state) : void 0,
      clientId: e.client_id,
      proof: e.proof,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.consensus_state = e.consensusState ? Any.toAmino(e.consensusState) : void 0, n.client_id = e.clientId, n.proof = e.proof, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionConsensusStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionConsensusStateResponse",
      value: QueryConnectionConsensusStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionConsensusStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionConsensusStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateResponse",
      value: QueryConnectionConsensusStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionParamsRequest() {
  return {};
}
const QueryConnectionParamsRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionParamsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryConnectionParamsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryConnectionParamsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionParamsRequest",
      value: QueryConnectionParamsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionParamsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionParamsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsRequest",
      value: QueryConnectionParamsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryConnectionParamsResponse() {
  return {
    params: void 0
  };
}
const QueryConnectionParamsResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$k.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryConnectionParamsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$k.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryConnectionParamsResponse();
    return n.params = e.params !== void 0 && e.params !== null ? Params$k.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$k.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$k.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryConnectionParamsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/QueryConnectionParamsResponse",
      value: QueryConnectionParamsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryConnectionParamsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryConnectionParamsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsResponse",
      value: QueryConnectionParamsResponse.encode(e).finish()
    };
  }
}, _94 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientConnectionsRequest,
  QueryClientConnectionsResponse,
  QueryConnectionClientStateRequest,
  QueryConnectionClientStateResponse,
  QueryConnectionConsensusStateRequest,
  QueryConnectionConsensusStateResponse,
  QueryConnectionParamsRequest,
  QueryConnectionParamsResponse,
  QueryConnectionRequest,
  QueryConnectionResponse,
  QueryConnectionsRequest,
  QueryConnectionsResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgConnectionOpenInit() {
  return {
    clientId: "",
    counterparty: void 0,
    version: void 0,
    delayPeriod: Long$2.UZERO,
    signer: ""
  };
}
const MsgConnectionOpenInit = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.counterparty !== void 0 && Counterparty.encode(e.counterparty, n.uint32(18).fork()).ldelim(), e.version !== void 0 && Version.encode(e.version, n.uint32(26).fork()).ldelim(), e.delayPeriod.isZero() || n.uint32(32).uint64(e.delayPeriod), e.signer !== "" && n.uint32(42).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgConnectionOpenInit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.counterparty = Counterparty.decode(o, o.uint32());
          break;
        case 3:
          c.version = Version.decode(o, o.uint32());
          break;
        case 4:
          c.delayPeriod = o.uint64();
          break;
        case 5:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgConnectionOpenInit();
    return u.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", u.counterparty = e.counterparty !== void 0 && e.counterparty !== null ? Counterparty.fromPartial(e.counterparty) : void 0, u.version = e.version !== void 0 && e.version !== null ? Version.fromPartial(e.version) : void 0, u.delayPeriod = e.delayPeriod !== void 0 && e.delayPeriod !== null ? Long$2.fromValue(e.delayPeriod) : Long$2.UZERO, u.signer = (o = e.signer) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      counterparty: e != null && e.counterparty ? Counterparty.fromAmino(e.counterparty) : void 0,
      version: e != null && e.version ? Version.fromAmino(e.version) : void 0,
      delayPeriod: Long$2.fromString(e.delay_period),
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.counterparty = e.counterparty ? Counterparty.toAmino(e.counterparty) : void 0, n.version = e.version ? Version.toAmino(e.version) : void 0, n.delay_period = e.delayPeriod ? e.delayPeriod.toString() : void 0, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgConnectionOpenInit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenInit",
      value: MsgConnectionOpenInit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgConnectionOpenInit.decode(e.value);
  },
  toProto(e) {
    return MsgConnectionOpenInit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
      value: MsgConnectionOpenInit.encode(e).finish()
    };
  }
};
function createBaseMsgConnectionOpenInitResponse() {
  return {};
}
const MsgConnectionOpenInitResponse = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInitResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgConnectionOpenInitResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgConnectionOpenInitResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgConnectionOpenInitResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenInitResponse",
      value: MsgConnectionOpenInitResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgConnectionOpenInitResponse.decode(e.value);
  },
  toProto(e) {
    return MsgConnectionOpenInitResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInitResponse",
      value: MsgConnectionOpenInitResponse.encode(e).finish()
    };
  }
};
function createBaseMsgConnectionOpenTry() {
  return {
    clientId: "",
    previousConnectionId: "",
    clientState: void 0,
    counterparty: void 0,
    delayPeriod: Long$2.UZERO,
    counterpartyVersions: [],
    proofHeight: void 0,
    proofInit: new Uint8Array(),
    proofClient: new Uint8Array(),
    proofConsensus: new Uint8Array(),
    consensusHeight: void 0,
    signer: "",
    hostConsensusStateProof: new Uint8Array()
  };
}
const MsgConnectionOpenTry = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
  encode(e, n = minimal.Writer.create()) {
    e.clientId !== "" && n.uint32(10).string(e.clientId), e.previousConnectionId !== "" && n.uint32(18).string(e.previousConnectionId), e.clientState !== void 0 && Any.encode(e.clientState, n.uint32(26).fork()).ldelim(), e.counterparty !== void 0 && Counterparty.encode(e.counterparty, n.uint32(34).fork()).ldelim(), e.delayPeriod.isZero() || n.uint32(40).uint64(e.delayPeriod);
    for (const o of e.counterpartyVersions)
      Version.encode(o, n.uint32(50).fork()).ldelim();
    return e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(58).fork()).ldelim(), e.proofInit.length !== 0 && n.uint32(66).bytes(e.proofInit), e.proofClient.length !== 0 && n.uint32(74).bytes(e.proofClient), e.proofConsensus.length !== 0 && n.uint32(82).bytes(e.proofConsensus), e.consensusHeight !== void 0 && Height.encode(e.consensusHeight, n.uint32(90).fork()).ldelim(), e.signer !== "" && n.uint32(98).string(e.signer), e.hostConsensusStateProof.length !== 0 && n.uint32(106).bytes(e.hostConsensusStateProof), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgConnectionOpenTry();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.previousConnectionId = o.string();
          break;
        case 3:
          c.clientState = Any.decode(o, o.uint32());
          break;
        case 4:
          c.counterparty = Counterparty.decode(o, o.uint32());
          break;
        case 5:
          c.delayPeriod = o.uint64();
          break;
        case 6:
          c.counterpartyVersions.push(Version.decode(o, o.uint32()));
          break;
        case 7:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 8:
          c.proofInit = o.bytes();
          break;
        case 9:
          c.proofClient = o.bytes();
          break;
        case 10:
          c.proofConsensus = o.bytes();
          break;
        case 11:
          c.consensusHeight = Height.decode(o, o.uint32());
          break;
        case 12:
          c.signer = o.string();
          break;
        case 13:
          c.hostConsensusStateProof = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S;
    const $ = createBaseMsgConnectionOpenTry();
    return $.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", $.previousConnectionId = (o = e.previousConnectionId) !== null && o !== void 0 ? o : "", $.clientState = e.clientState !== void 0 && e.clientState !== null ? Any.fromPartial(e.clientState) : void 0, $.counterparty = e.counterparty !== void 0 && e.counterparty !== null ? Counterparty.fromPartial(e.counterparty) : void 0, $.delayPeriod = e.delayPeriod !== void 0 && e.delayPeriod !== null ? Long$2.fromValue(e.delayPeriod) : Long$2.UZERO, $.counterpartyVersions = ((u = e.counterpartyVersions) === null || u === void 0 ? void 0 : u.map((E) => Version.fromPartial(E))) || [], $.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, $.proofInit = (c = e.proofInit) !== null && c !== void 0 ? c : new Uint8Array(), $.proofClient = (d = e.proofClient) !== null && d !== void 0 ? d : new Uint8Array(), $.proofConsensus = (m = e.proofConsensus) !== null && m !== void 0 ? m : new Uint8Array(), $.consensusHeight = e.consensusHeight !== void 0 && e.consensusHeight !== null ? Height.fromPartial(e.consensusHeight) : void 0, $.signer = (v = e.signer) !== null && v !== void 0 ? v : "", $.hostConsensusStateProof = (S = e.hostConsensusStateProof) !== null && S !== void 0 ? S : new Uint8Array(), $;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      previousConnectionId: e.previous_connection_id,
      clientState: e != null && e.client_state ? Any.fromAmino(e.client_state) : void 0,
      counterparty: e != null && e.counterparty ? Counterparty.fromAmino(e.counterparty) : void 0,
      delayPeriod: Long$2.fromString(e.delay_period),
      counterpartyVersions: Array.isArray(e == null ? void 0 : e.counterparty_versions) ? e.counterparty_versions.map((n) => Version.fromAmino(n)) : [],
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      proofInit: e.proof_init,
      proofClient: e.proof_client,
      proofConsensus: e.proof_consensus,
      consensusHeight: e != null && e.consensus_height ? Height.fromAmino(e.consensus_height) : void 0,
      signer: e.signer,
      hostConsensusStateProof: e.host_consensus_state_proof
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.previous_connection_id = e.previousConnectionId, n.client_state = e.clientState ? Any.toAmino(e.clientState) : void 0, n.counterparty = e.counterparty ? Counterparty.toAmino(e.counterparty) : void 0, n.delay_period = e.delayPeriod ? e.delayPeriod.toString() : void 0, e.counterpartyVersions ? n.counterparty_versions = e.counterpartyVersions.map((o) => o ? Version.toAmino(o) : void 0) : n.counterparty_versions = [], n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.proof_init = e.proofInit, n.proof_client = e.proofClient, n.proof_consensus = e.proofConsensus, n.consensus_height = e.consensusHeight ? Height.toAmino(e.consensusHeight) : {}, n.signer = e.signer, n.host_consensus_state_proof = e.hostConsensusStateProof, n;
  },
  fromAminoMsg(e) {
    return MsgConnectionOpenTry.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenTry",
      value: MsgConnectionOpenTry.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgConnectionOpenTry.decode(e.value);
  },
  toProto(e) {
    return MsgConnectionOpenTry.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
      value: MsgConnectionOpenTry.encode(e).finish()
    };
  }
};
function createBaseMsgConnectionOpenTryResponse() {
  return {};
}
const MsgConnectionOpenTryResponse = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTryResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgConnectionOpenTryResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgConnectionOpenTryResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgConnectionOpenTryResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenTryResponse",
      value: MsgConnectionOpenTryResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgConnectionOpenTryResponse.decode(e.value);
  },
  toProto(e) {
    return MsgConnectionOpenTryResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTryResponse",
      value: MsgConnectionOpenTryResponse.encode(e).finish()
    };
  }
};
function createBaseMsgConnectionOpenAck() {
  return {
    connectionId: "",
    counterpartyConnectionId: "",
    version: void 0,
    clientState: void 0,
    proofHeight: void 0,
    proofTry: new Uint8Array(),
    proofClient: new Uint8Array(),
    proofConsensus: new Uint8Array(),
    consensusHeight: void 0,
    signer: "",
    hostConsensusStateProof: new Uint8Array()
  };
}
const MsgConnectionOpenAck = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
  encode(e, n = minimal.Writer.create()) {
    return e.connectionId !== "" && n.uint32(10).string(e.connectionId), e.counterpartyConnectionId !== "" && n.uint32(18).string(e.counterpartyConnectionId), e.version !== void 0 && Version.encode(e.version, n.uint32(26).fork()).ldelim(), e.clientState !== void 0 && Any.encode(e.clientState, n.uint32(34).fork()).ldelim(), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(42).fork()).ldelim(), e.proofTry.length !== 0 && n.uint32(50).bytes(e.proofTry), e.proofClient.length !== 0 && n.uint32(58).bytes(e.proofClient), e.proofConsensus.length !== 0 && n.uint32(66).bytes(e.proofConsensus), e.consensusHeight !== void 0 && Height.encode(e.consensusHeight, n.uint32(74).fork()).ldelim(), e.signer !== "" && n.uint32(82).string(e.signer), e.hostConsensusStateProof.length !== 0 && n.uint32(90).bytes(e.hostConsensusStateProof), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgConnectionOpenAck();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connectionId = o.string();
          break;
        case 2:
          c.counterpartyConnectionId = o.string();
          break;
        case 3:
          c.version = Version.decode(o, o.uint32());
          break;
        case 4:
          c.clientState = Any.decode(o, o.uint32());
          break;
        case 5:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 6:
          c.proofTry = o.bytes();
          break;
        case 7:
          c.proofClient = o.bytes();
          break;
        case 8:
          c.proofConsensus = o.bytes();
          break;
        case 9:
          c.consensusHeight = Height.decode(o, o.uint32());
          break;
        case 10:
          c.signer = o.string();
          break;
        case 11:
          c.hostConsensusStateProof = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v;
    const S = createBaseMsgConnectionOpenAck();
    return S.connectionId = (n = e.connectionId) !== null && n !== void 0 ? n : "", S.counterpartyConnectionId = (o = e.counterpartyConnectionId) !== null && o !== void 0 ? o : "", S.version = e.version !== void 0 && e.version !== null ? Version.fromPartial(e.version) : void 0, S.clientState = e.clientState !== void 0 && e.clientState !== null ? Any.fromPartial(e.clientState) : void 0, S.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, S.proofTry = (u = e.proofTry) !== null && u !== void 0 ? u : new Uint8Array(), S.proofClient = (c = e.proofClient) !== null && c !== void 0 ? c : new Uint8Array(), S.proofConsensus = (d = e.proofConsensus) !== null && d !== void 0 ? d : new Uint8Array(), S.consensusHeight = e.consensusHeight !== void 0 && e.consensusHeight !== null ? Height.fromPartial(e.consensusHeight) : void 0, S.signer = (m = e.signer) !== null && m !== void 0 ? m : "", S.hostConsensusStateProof = (v = e.hostConsensusStateProof) !== null && v !== void 0 ? v : new Uint8Array(), S;
  },
  fromAmino(e) {
    return {
      connectionId: e.connection_id,
      counterpartyConnectionId: e.counterparty_connection_id,
      version: e != null && e.version ? Version.fromAmino(e.version) : void 0,
      clientState: e != null && e.client_state ? Any.fromAmino(e.client_state) : void 0,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      proofTry: e.proof_try,
      proofClient: e.proof_client,
      proofConsensus: e.proof_consensus,
      consensusHeight: e != null && e.consensus_height ? Height.fromAmino(e.consensus_height) : void 0,
      signer: e.signer,
      hostConsensusStateProof: e.host_consensus_state_proof
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection_id = e.connectionId, n.counterparty_connection_id = e.counterpartyConnectionId, n.version = e.version ? Version.toAmino(e.version) : void 0, n.client_state = e.clientState ? Any.toAmino(e.clientState) : void 0, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.proof_try = e.proofTry, n.proof_client = e.proofClient, n.proof_consensus = e.proofConsensus, n.consensus_height = e.consensusHeight ? Height.toAmino(e.consensusHeight) : {}, n.signer = e.signer, n.host_consensus_state_proof = e.hostConsensusStateProof, n;
  },
  fromAminoMsg(e) {
    return MsgConnectionOpenAck.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenAck",
      value: MsgConnectionOpenAck.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgConnectionOpenAck.decode(e.value);
  },
  toProto(e) {
    return MsgConnectionOpenAck.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
      value: MsgConnectionOpenAck.encode(e).finish()
    };
  }
};
function createBaseMsgConnectionOpenAckResponse() {
  return {};
}
const MsgConnectionOpenAckResponse = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAckResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgConnectionOpenAckResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgConnectionOpenAckResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgConnectionOpenAckResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenAckResponse",
      value: MsgConnectionOpenAckResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgConnectionOpenAckResponse.decode(e.value);
  },
  toProto(e) {
    return MsgConnectionOpenAckResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAckResponse",
      value: MsgConnectionOpenAckResponse.encode(e).finish()
    };
  }
};
function createBaseMsgConnectionOpenConfirm() {
  return {
    connectionId: "",
    proofAck: new Uint8Array(),
    proofHeight: void 0,
    signer: ""
  };
}
const MsgConnectionOpenConfirm = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
  encode(e, n = minimal.Writer.create()) {
    return e.connectionId !== "" && n.uint32(10).string(e.connectionId), e.proofAck.length !== 0 && n.uint32(18).bytes(e.proofAck), e.proofHeight !== void 0 && Height.encode(e.proofHeight, n.uint32(26).fork()).ldelim(), e.signer !== "" && n.uint32(34).string(e.signer), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgConnectionOpenConfirm();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.connectionId = o.string();
          break;
        case 2:
          c.proofAck = o.bytes();
          break;
        case 3:
          c.proofHeight = Height.decode(o, o.uint32());
          break;
        case 4:
          c.signer = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgConnectionOpenConfirm();
    return c.connectionId = (n = e.connectionId) !== null && n !== void 0 ? n : "", c.proofAck = (o = e.proofAck) !== null && o !== void 0 ? o : new Uint8Array(), c.proofHeight = e.proofHeight !== void 0 && e.proofHeight !== null ? Height.fromPartial(e.proofHeight) : void 0, c.signer = (u = e.signer) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      connectionId: e.connection_id,
      proofAck: e.proof_ack,
      proofHeight: e != null && e.proof_height ? Height.fromAmino(e.proof_height) : void 0,
      signer: e.signer
    };
  },
  toAmino(e) {
    const n = {};
    return n.connection_id = e.connectionId, n.proof_ack = e.proofAck, n.proof_height = e.proofHeight ? Height.toAmino(e.proofHeight) : {}, n.signer = e.signer, n;
  },
  fromAminoMsg(e) {
    return MsgConnectionOpenConfirm.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenConfirm",
      value: MsgConnectionOpenConfirm.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgConnectionOpenConfirm.decode(e.value);
  },
  toProto(e) {
    return MsgConnectionOpenConfirm.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
      value: MsgConnectionOpenConfirm.encode(e).finish()
    };
  }
};
function createBaseMsgConnectionOpenConfirmResponse() {
  return {};
}
const MsgConnectionOpenConfirmResponse = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirmResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgConnectionOpenConfirmResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgConnectionOpenConfirmResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgConnectionOpenConfirmResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenConfirmResponse",
      value: MsgConnectionOpenConfirmResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgConnectionOpenConfirmResponse.decode(e.value);
  },
  toProto(e) {
    return MsgConnectionOpenConfirmResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirmResponse",
      value: MsgConnectionOpenConfirmResponse.encode(e).finish()
    };
  }
}, _95 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgConnectionOpenAck,
  MsgConnectionOpenAckResponse,
  MsgConnectionOpenConfirm,
  MsgConnectionOpenConfirmResponse,
  MsgConnectionOpenInit,
  MsgConnectionOpenInitResponse,
  MsgConnectionOpenTry,
  MsgConnectionOpenTryResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseClientState$3() {
  return {
    latestHeight: void 0
  };
}
const ClientState$3 = {
  typeUrl: "/ibc.lightclients.localhost.v2.ClientState",
  encode(e, n = minimal.Writer.create()) {
    return e.latestHeight !== void 0 && Height.encode(e.latestHeight, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClientState$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.latestHeight = Height.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseClientState$3();
    return n.latestHeight = e.latestHeight !== void 0 && e.latestHeight !== null ? Height.fromPartial(e.latestHeight) : void 0, n;
  },
  fromAmino(e) {
    return {
      latestHeight: e != null && e.latest_height ? Height.fromAmino(e.latest_height) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.latest_height = e.latestHeight ? Height.toAmino(e.latestHeight) : {}, n;
  },
  fromAminoMsg(e) {
    return ClientState$3.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ClientState",
      value: ClientState$3.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClientState$3.decode(e.value);
  },
  toProto(e) {
    return ClientState$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.localhost.v2.ClientState",
      value: ClientState$3.encode(e).finish()
    };
  }
}, _96 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClientState: ClientState$3
}, Symbol.toStringTag, { value: "Module" }));
let DataType;
(function(e) {
  e[e.DATA_TYPE_UNINITIALIZED_UNSPECIFIED = 0] = "DATA_TYPE_UNINITIALIZED_UNSPECIFIED", e[e.DATA_TYPE_CLIENT_STATE = 1] = "DATA_TYPE_CLIENT_STATE", e[e.DATA_TYPE_CONSENSUS_STATE = 2] = "DATA_TYPE_CONSENSUS_STATE", e[e.DATA_TYPE_CONNECTION_STATE = 3] = "DATA_TYPE_CONNECTION_STATE", e[e.DATA_TYPE_CHANNEL_STATE = 4] = "DATA_TYPE_CHANNEL_STATE", e[e.DATA_TYPE_PACKET_COMMITMENT = 5] = "DATA_TYPE_PACKET_COMMITMENT", e[e.DATA_TYPE_PACKET_ACKNOWLEDGEMENT = 6] = "DATA_TYPE_PACKET_ACKNOWLEDGEMENT", e[e.DATA_TYPE_PACKET_RECEIPT_ABSENCE = 7] = "DATA_TYPE_PACKET_RECEIPT_ABSENCE", e[e.DATA_TYPE_NEXT_SEQUENCE_RECV = 8] = "DATA_TYPE_NEXT_SEQUENCE_RECV", e[e.DATA_TYPE_HEADER = 9] = "DATA_TYPE_HEADER", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(DataType || (DataType = {}));
const DataTypeSDKType = DataType, DataTypeAmino = DataType;
function dataTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "DATA_TYPE_UNINITIALIZED_UNSPECIFIED":
      return DataType.DATA_TYPE_UNINITIALIZED_UNSPECIFIED;
    case 1:
    case "DATA_TYPE_CLIENT_STATE":
      return DataType.DATA_TYPE_CLIENT_STATE;
    case 2:
    case "DATA_TYPE_CONSENSUS_STATE":
      return DataType.DATA_TYPE_CONSENSUS_STATE;
    case 3:
    case "DATA_TYPE_CONNECTION_STATE":
      return DataType.DATA_TYPE_CONNECTION_STATE;
    case 4:
    case "DATA_TYPE_CHANNEL_STATE":
      return DataType.DATA_TYPE_CHANNEL_STATE;
    case 5:
    case "DATA_TYPE_PACKET_COMMITMENT":
      return DataType.DATA_TYPE_PACKET_COMMITMENT;
    case 6:
    case "DATA_TYPE_PACKET_ACKNOWLEDGEMENT":
      return DataType.DATA_TYPE_PACKET_ACKNOWLEDGEMENT;
    case 7:
    case "DATA_TYPE_PACKET_RECEIPT_ABSENCE":
      return DataType.DATA_TYPE_PACKET_RECEIPT_ABSENCE;
    case 8:
    case "DATA_TYPE_NEXT_SEQUENCE_RECV":
      return DataType.DATA_TYPE_NEXT_SEQUENCE_RECV;
    case 9:
    case "DATA_TYPE_HEADER":
      return DataType.DATA_TYPE_HEADER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataType.UNRECOGNIZED;
  }
}
function dataTypeToJSON(e) {
  switch (e) {
    case DataType.DATA_TYPE_UNINITIALIZED_UNSPECIFIED:
      return "DATA_TYPE_UNINITIALIZED_UNSPECIFIED";
    case DataType.DATA_TYPE_CLIENT_STATE:
      return "DATA_TYPE_CLIENT_STATE";
    case DataType.DATA_TYPE_CONSENSUS_STATE:
      return "DATA_TYPE_CONSENSUS_STATE";
    case DataType.DATA_TYPE_CONNECTION_STATE:
      return "DATA_TYPE_CONNECTION_STATE";
    case DataType.DATA_TYPE_CHANNEL_STATE:
      return "DATA_TYPE_CHANNEL_STATE";
    case DataType.DATA_TYPE_PACKET_COMMITMENT:
      return "DATA_TYPE_PACKET_COMMITMENT";
    case DataType.DATA_TYPE_PACKET_ACKNOWLEDGEMENT:
      return "DATA_TYPE_PACKET_ACKNOWLEDGEMENT";
    case DataType.DATA_TYPE_PACKET_RECEIPT_ABSENCE:
      return "DATA_TYPE_PACKET_RECEIPT_ABSENCE";
    case DataType.DATA_TYPE_NEXT_SEQUENCE_RECV:
      return "DATA_TYPE_NEXT_SEQUENCE_RECV";
    case DataType.DATA_TYPE_HEADER:
      return "DATA_TYPE_HEADER";
    case DataType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseClientState$2() {
  return {
    sequence: Long$2.UZERO,
    isFrozen: !1,
    consensusState: void 0,
    allowUpdateAfterProposal: !1
  };
}
const ClientState$2 = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ClientState",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), e.isFrozen === !0 && n.uint32(16).bool(e.isFrozen), e.consensusState !== void 0 && ConsensusState$2.encode(e.consensusState, n.uint32(26).fork()).ldelim(), e.allowUpdateAfterProposal === !0 && n.uint32(32).bool(e.allowUpdateAfterProposal), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClientState$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        case 2:
          c.isFrozen = o.bool();
          break;
        case 3:
          c.consensusState = ConsensusState$2.decode(o, o.uint32());
          break;
        case 4:
          c.allowUpdateAfterProposal = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseClientState$2();
    return u.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, u.isFrozen = (n = e.isFrozen) !== null && n !== void 0 ? n : !1, u.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? ConsensusState$2.fromPartial(e.consensusState) : void 0, u.allowUpdateAfterProposal = (o = e.allowUpdateAfterProposal) !== null && o !== void 0 ? o : !1, u;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence),
      isFrozen: e.is_frozen,
      consensusState: e != null && e.consensus_state ? ConsensusState$2.fromAmino(e.consensus_state) : void 0,
      allowUpdateAfterProposal: e.allow_update_after_proposal
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n.is_frozen = e.isFrozen, n.consensus_state = e.consensusState ? ConsensusState$2.toAmino(e.consensusState) : void 0, n.allow_update_after_proposal = e.allowUpdateAfterProposal, n;
  },
  fromAminoMsg(e) {
    return ClientState$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ClientState",
      value: ClientState$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClientState$2.decode(e.value);
  },
  toProto(e) {
    return ClientState$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ClientState",
      value: ClientState$2.encode(e).finish()
    };
  }
};
function createBaseConsensusState$2() {
  return {
    publicKey: void 0,
    diversifier: "",
    timestamp: Long$2.UZERO
  };
}
const ConsensusState$2 = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ConsensusState",
  encode(e, n = minimal.Writer.create()) {
    return e.publicKey !== void 0 && Any.encode(e.publicKey, n.uint32(10).fork()).ldelim(), e.diversifier !== "" && n.uint32(18).string(e.diversifier), e.timestamp.isZero() || n.uint32(24).uint64(e.timestamp), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConsensusState$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.publicKey = Any.decode(o, o.uint32());
          break;
        case 2:
          c.diversifier = o.string();
          break;
        case 3:
          c.timestamp = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseConsensusState$2();
    return o.publicKey = e.publicKey !== void 0 && e.publicKey !== null ? Any.fromPartial(e.publicKey) : void 0, o.diversifier = (n = e.diversifier) !== null && n !== void 0 ? n : "", o.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      publicKey: e != null && e.public_key ? Any.fromAmino(e.public_key) : void 0,
      diversifier: e.diversifier,
      timestamp: Long$2.fromString(e.timestamp)
    };
  },
  toAmino(e) {
    const n = {};
    return n.public_key = e.publicKey ? Any.toAmino(e.publicKey) : void 0, n.diversifier = e.diversifier, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ConsensusState$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConsensusState",
      value: ConsensusState$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConsensusState$2.decode(e.value);
  },
  toProto(e) {
    return ConsensusState$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ConsensusState",
      value: ConsensusState$2.encode(e).finish()
    };
  }
};
function createBaseHeader$2() {
  return {
    sequence: Long$2.UZERO,
    timestamp: Long$2.UZERO,
    signature: new Uint8Array(),
    newPublicKey: void 0,
    newDiversifier: ""
  };
}
const Header$2 = {
  typeUrl: "/ibc.lightclients.solomachine.v2.Header",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), e.timestamp.isZero() || n.uint32(16).uint64(e.timestamp), e.signature.length !== 0 && n.uint32(26).bytes(e.signature), e.newPublicKey !== void 0 && Any.encode(e.newPublicKey, n.uint32(34).fork()).ldelim(), e.newDiversifier !== "" && n.uint32(42).string(e.newDiversifier), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHeader$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        case 2:
          c.timestamp = o.uint64();
          break;
        case 3:
          c.signature = o.bytes();
          break;
        case 4:
          c.newPublicKey = Any.decode(o, o.uint32());
          break;
        case 5:
          c.newDiversifier = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseHeader$2();
    return u.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, u.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, u.signature = (n = e.signature) !== null && n !== void 0 ? n : new Uint8Array(), u.newPublicKey = e.newPublicKey !== void 0 && e.newPublicKey !== null ? Any.fromPartial(e.newPublicKey) : void 0, u.newDiversifier = (o = e.newDiversifier) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence),
      timestamp: Long$2.fromString(e.timestamp),
      signature: e.signature,
      newPublicKey: e != null && e.new_public_key ? Any.fromAmino(e.new_public_key) : void 0,
      newDiversifier: e.new_diversifier
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n.signature = e.signature, n.new_public_key = e.newPublicKey ? Any.toAmino(e.newPublicKey) : void 0, n.new_diversifier = e.newDiversifier, n;
  },
  fromAminoMsg(e) {
    return Header$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Header",
      value: Header$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Header$2.decode(e.value);
  },
  toProto(e) {
    return Header$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.Header",
      value: Header$2.encode(e).finish()
    };
  }
};
function createBaseMisbehaviour$2() {
  return {
    clientId: "",
    sequence: Long$2.UZERO,
    signatureOne: void 0,
    signatureTwo: void 0
  };
}
const Misbehaviour$2 = {
  typeUrl: "/ibc.lightclients.solomachine.v2.Misbehaviour",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.sequence.isZero() || n.uint32(16).uint64(e.sequence), e.signatureOne !== void 0 && SignatureAndData$1.encode(e.signatureOne, n.uint32(26).fork()).ldelim(), e.signatureTwo !== void 0 && SignatureAndData$1.encode(e.signatureTwo, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMisbehaviour$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.sequence = o.uint64();
          break;
        case 3:
          c.signatureOne = SignatureAndData$1.decode(o, o.uint32());
          break;
        case 4:
          c.signatureTwo = SignatureAndData$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMisbehaviour$2();
    return o.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", o.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, o.signatureOne = e.signatureOne !== void 0 && e.signatureOne !== null ? SignatureAndData$1.fromPartial(e.signatureOne) : void 0, o.signatureTwo = e.signatureTwo !== void 0 && e.signatureTwo !== null ? SignatureAndData$1.fromPartial(e.signatureTwo) : void 0, o;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      sequence: Long$2.fromString(e.sequence),
      signatureOne: e != null && e.signature_one ? SignatureAndData$1.fromAmino(e.signature_one) : void 0,
      signatureTwo: e != null && e.signature_two ? SignatureAndData$1.fromAmino(e.signature_two) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.sequence = e.sequence ? e.sequence.toString() : void 0, n.signature_one = e.signatureOne ? SignatureAndData$1.toAmino(e.signatureOne) : void 0, n.signature_two = e.signatureTwo ? SignatureAndData$1.toAmino(e.signatureTwo) : void 0, n;
  },
  fromAminoMsg(e) {
    return Misbehaviour$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Misbehaviour",
      value: Misbehaviour$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Misbehaviour$2.decode(e.value);
  },
  toProto(e) {
    return Misbehaviour$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.Misbehaviour",
      value: Misbehaviour$2.encode(e).finish()
    };
  }
};
function createBaseSignatureAndData$1() {
  return {
    signature: new Uint8Array(),
    dataType: 0,
    data: new Uint8Array(),
    timestamp: Long$2.UZERO
  };
}
const SignatureAndData$1 = {
  typeUrl: "/ibc.lightclients.solomachine.v2.SignatureAndData",
  encode(e, n = minimal.Writer.create()) {
    return e.signature.length !== 0 && n.uint32(10).bytes(e.signature), e.dataType !== 0 && n.uint32(16).int32(e.dataType), e.data.length !== 0 && n.uint32(26).bytes(e.data), e.timestamp.isZero() || n.uint32(32).uint64(e.timestamp), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignatureAndData$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signature = o.bytes();
          break;
        case 2:
          c.dataType = o.int32();
          break;
        case 3:
          c.data = o.bytes();
          break;
        case 4:
          c.timestamp = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSignatureAndData$1();
    return c.signature = (n = e.signature) !== null && n !== void 0 ? n : new Uint8Array(), c.dataType = (o = e.dataType) !== null && o !== void 0 ? o : 0, c.data = (u = e.data) !== null && u !== void 0 ? u : new Uint8Array(), c.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, c;
  },
  fromAmino(e) {
    return {
      signature: e.signature,
      dataType: isSet(e.data_type) ? dataTypeFromJSON(e.data_type) : 0,
      data: e.data,
      timestamp: Long$2.fromString(e.timestamp)
    };
  },
  toAmino(e) {
    const n = {};
    return n.signature = e.signature, n.data_type = e.dataType, n.data = e.data, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return SignatureAndData$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SignatureAndData",
      value: SignatureAndData$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignatureAndData$1.decode(e.value);
  },
  toProto(e) {
    return SignatureAndData$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.SignatureAndData",
      value: SignatureAndData$1.encode(e).finish()
    };
  }
};
function createBaseTimestampedSignatureData$1() {
  return {
    signatureData: new Uint8Array(),
    timestamp: Long$2.UZERO
  };
}
const TimestampedSignatureData$1 = {
  typeUrl: "/ibc.lightclients.solomachine.v2.TimestampedSignatureData",
  encode(e, n = minimal.Writer.create()) {
    return e.signatureData.length !== 0 && n.uint32(10).bytes(e.signatureData), e.timestamp.isZero() || n.uint32(16).uint64(e.timestamp), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTimestampedSignatureData$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signatureData = o.bytes();
          break;
        case 2:
          c.timestamp = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseTimestampedSignatureData$1();
    return o.signatureData = (n = e.signatureData) !== null && n !== void 0 ? n : new Uint8Array(), o.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      signatureData: e.signature_data,
      timestamp: Long$2.fromString(e.timestamp)
    };
  },
  toAmino(e) {
    const n = {};
    return n.signature_data = e.signatureData, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return TimestampedSignatureData$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TimestampedSignatureData",
      value: TimestampedSignatureData$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TimestampedSignatureData$1.decode(e.value);
  },
  toProto(e) {
    return TimestampedSignatureData$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.TimestampedSignatureData",
      value: TimestampedSignatureData$1.encode(e).finish()
    };
  }
};
function createBaseSignBytes$1() {
  return {
    sequence: Long$2.UZERO,
    timestamp: Long$2.UZERO,
    diversifier: "",
    dataType: 0,
    data: new Uint8Array()
  };
}
const SignBytes$1 = {
  typeUrl: "/ibc.lightclients.solomachine.v2.SignBytes",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), e.timestamp.isZero() || n.uint32(16).uint64(e.timestamp), e.diversifier !== "" && n.uint32(26).string(e.diversifier), e.dataType !== 0 && n.uint32(32).int32(e.dataType), e.data.length !== 0 && n.uint32(42).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignBytes$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        case 2:
          c.timestamp = o.uint64();
          break;
        case 3:
          c.diversifier = o.string();
          break;
        case 4:
          c.dataType = o.int32();
          break;
        case 5:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSignBytes$1();
    return c.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, c.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, c.diversifier = (n = e.diversifier) !== null && n !== void 0 ? n : "", c.dataType = (o = e.dataType) !== null && o !== void 0 ? o : 0, c.data = (u = e.data) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence),
      timestamp: Long$2.fromString(e.timestamp),
      diversifier: e.diversifier,
      dataType: isSet(e.data_type) ? dataTypeFromJSON(e.data_type) : 0,
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n.diversifier = e.diversifier, n.data_type = e.dataType, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return SignBytes$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SignBytes",
      value: SignBytes$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignBytes$1.decode(e.value);
  },
  toProto(e) {
    return SignBytes$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.SignBytes",
      value: SignBytes$1.encode(e).finish()
    };
  }
};
function createBaseHeaderData$1() {
  return {
    newPubKey: void 0,
    newDiversifier: ""
  };
}
const HeaderData$1 = {
  typeUrl: "/ibc.lightclients.solomachine.v2.HeaderData",
  encode(e, n = minimal.Writer.create()) {
    return e.newPubKey !== void 0 && Any.encode(e.newPubKey, n.uint32(10).fork()).ldelim(), e.newDiversifier !== "" && n.uint32(18).string(e.newDiversifier), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHeaderData$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.newPubKey = Any.decode(o, o.uint32());
          break;
        case 2:
          c.newDiversifier = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseHeaderData$1();
    return o.newPubKey = e.newPubKey !== void 0 && e.newPubKey !== null ? Any.fromPartial(e.newPubKey) : void 0, o.newDiversifier = (n = e.newDiversifier) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      newPubKey: e != null && e.new_pub_key ? Any.fromAmino(e.new_pub_key) : void 0,
      newDiversifier: e.new_diversifier
    };
  },
  toAmino(e) {
    const n = {};
    return n.new_pub_key = e.newPubKey ? Any.toAmino(e.newPubKey) : void 0, n.new_diversifier = e.newDiversifier, n;
  },
  fromAminoMsg(e) {
    return HeaderData$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/HeaderData",
      value: HeaderData$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return HeaderData$1.decode(e.value);
  },
  toProto(e) {
    return HeaderData$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.HeaderData",
      value: HeaderData$1.encode(e).finish()
    };
  }
};
function createBaseClientStateData() {
  return {
    path: new Uint8Array(),
    clientState: void 0
  };
}
const ClientStateData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ClientStateData",
  encode(e, n = minimal.Writer.create()) {
    return e.path.length !== 0 && n.uint32(10).bytes(e.path), e.clientState !== void 0 && Any.encode(e.clientState, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClientStateData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.bytes();
          break;
        case 2:
          c.clientState = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseClientStateData();
    return o.path = (n = e.path) !== null && n !== void 0 ? n : new Uint8Array(), o.clientState = e.clientState !== void 0 && e.clientState !== null ? Any.fromPartial(e.clientState) : void 0, o;
  },
  fromAmino(e) {
    return {
      path: e.path,
      clientState: e != null && e.client_state ? Any.fromAmino(e.client_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n.client_state = e.clientState ? Any.toAmino(e.clientState) : void 0, n;
  },
  fromAminoMsg(e) {
    return ClientStateData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ClientStateData",
      value: ClientStateData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClientStateData.decode(e.value);
  },
  toProto(e) {
    return ClientStateData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ClientStateData",
      value: ClientStateData.encode(e).finish()
    };
  }
};
function createBaseConsensusStateData() {
  return {
    path: new Uint8Array(),
    consensusState: void 0
  };
}
const ConsensusStateData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ConsensusStateData",
  encode(e, n = minimal.Writer.create()) {
    return e.path.length !== 0 && n.uint32(10).bytes(e.path), e.consensusState !== void 0 && Any.encode(e.consensusState, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConsensusStateData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.bytes();
          break;
        case 2:
          c.consensusState = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseConsensusStateData();
    return o.path = (n = e.path) !== null && n !== void 0 ? n : new Uint8Array(), o.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? Any.fromPartial(e.consensusState) : void 0, o;
  },
  fromAmino(e) {
    return {
      path: e.path,
      consensusState: e != null && e.consensus_state ? Any.fromAmino(e.consensus_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n.consensus_state = e.consensusState ? Any.toAmino(e.consensusState) : void 0, n;
  },
  fromAminoMsg(e) {
    return ConsensusStateData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConsensusStateData",
      value: ConsensusStateData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConsensusStateData.decode(e.value);
  },
  toProto(e) {
    return ConsensusStateData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ConsensusStateData",
      value: ConsensusStateData.encode(e).finish()
    };
  }
};
function createBaseConnectionStateData() {
  return {
    path: new Uint8Array(),
    connection: void 0
  };
}
const ConnectionStateData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ConnectionStateData",
  encode(e, n = minimal.Writer.create()) {
    return e.path.length !== 0 && n.uint32(10).bytes(e.path), e.connection !== void 0 && ConnectionEnd.encode(e.connection, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConnectionStateData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.bytes();
          break;
        case 2:
          c.connection = ConnectionEnd.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseConnectionStateData();
    return o.path = (n = e.path) !== null && n !== void 0 ? n : new Uint8Array(), o.connection = e.connection !== void 0 && e.connection !== null ? ConnectionEnd.fromPartial(e.connection) : void 0, o;
  },
  fromAmino(e) {
    return {
      path: e.path,
      connection: e != null && e.connection ? ConnectionEnd.fromAmino(e.connection) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n.connection = e.connection ? ConnectionEnd.toAmino(e.connection) : void 0, n;
  },
  fromAminoMsg(e) {
    return ConnectionStateData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConnectionStateData",
      value: ConnectionStateData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConnectionStateData.decode(e.value);
  },
  toProto(e) {
    return ConnectionStateData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ConnectionStateData",
      value: ConnectionStateData.encode(e).finish()
    };
  }
};
function createBaseChannelStateData() {
  return {
    path: new Uint8Array(),
    channel: void 0
  };
}
const ChannelStateData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ChannelStateData",
  encode(e, n = minimal.Writer.create()) {
    return e.path.length !== 0 && n.uint32(10).bytes(e.path), e.channel !== void 0 && Channel.encode(e.channel, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseChannelStateData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.bytes();
          break;
        case 2:
          c.channel = Channel.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseChannelStateData();
    return o.path = (n = e.path) !== null && n !== void 0 ? n : new Uint8Array(), o.channel = e.channel !== void 0 && e.channel !== null ? Channel.fromPartial(e.channel) : void 0, o;
  },
  fromAmino(e) {
    return {
      path: e.path,
      channel: e != null && e.channel ? Channel.fromAmino(e.channel) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n.channel = e.channel ? Channel.toAmino(e.channel) : void 0, n;
  },
  fromAminoMsg(e) {
    return ChannelStateData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ChannelStateData",
      value: ChannelStateData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ChannelStateData.decode(e.value);
  },
  toProto(e) {
    return ChannelStateData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ChannelStateData",
      value: ChannelStateData.encode(e).finish()
    };
  }
};
function createBasePacketCommitmentData() {
  return {
    path: new Uint8Array(),
    commitment: new Uint8Array()
  };
}
const PacketCommitmentData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.PacketCommitmentData",
  encode(e, n = minimal.Writer.create()) {
    return e.path.length !== 0 && n.uint32(10).bytes(e.path), e.commitment.length !== 0 && n.uint32(18).bytes(e.commitment), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacketCommitmentData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.bytes();
          break;
        case 2:
          c.commitment = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePacketCommitmentData();
    return u.path = (n = e.path) !== null && n !== void 0 ? n : new Uint8Array(), u.commitment = (o = e.commitment) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      path: e.path,
      commitment: e.commitment
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n.commitment = e.commitment, n;
  },
  fromAminoMsg(e) {
    return PacketCommitmentData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PacketCommitmentData",
      value: PacketCommitmentData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PacketCommitmentData.decode(e.value);
  },
  toProto(e) {
    return PacketCommitmentData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.PacketCommitmentData",
      value: PacketCommitmentData.encode(e).finish()
    };
  }
};
function createBasePacketAcknowledgementData() {
  return {
    path: new Uint8Array(),
    acknowledgement: new Uint8Array()
  };
}
const PacketAcknowledgementData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.PacketAcknowledgementData",
  encode(e, n = minimal.Writer.create()) {
    return e.path.length !== 0 && n.uint32(10).bytes(e.path), e.acknowledgement.length !== 0 && n.uint32(18).bytes(e.acknowledgement), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacketAcknowledgementData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.bytes();
          break;
        case 2:
          c.acknowledgement = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePacketAcknowledgementData();
    return u.path = (n = e.path) !== null && n !== void 0 ? n : new Uint8Array(), u.acknowledgement = (o = e.acknowledgement) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      path: e.path,
      acknowledgement: e.acknowledgement
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n.acknowledgement = e.acknowledgement, n;
  },
  fromAminoMsg(e) {
    return PacketAcknowledgementData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PacketAcknowledgementData",
      value: PacketAcknowledgementData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PacketAcknowledgementData.decode(e.value);
  },
  toProto(e) {
    return PacketAcknowledgementData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.PacketAcknowledgementData",
      value: PacketAcknowledgementData.encode(e).finish()
    };
  }
};
function createBasePacketReceiptAbsenceData() {
  return {
    path: new Uint8Array()
  };
}
const PacketReceiptAbsenceData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.PacketReceiptAbsenceData",
  encode(e, n = minimal.Writer.create()) {
    return e.path.length !== 0 && n.uint32(10).bytes(e.path), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePacketReceiptAbsenceData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePacketReceiptAbsenceData();
    return o.path = (n = e.path) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      path: e.path
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n;
  },
  fromAminoMsg(e) {
    return PacketReceiptAbsenceData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/PacketReceiptAbsenceData",
      value: PacketReceiptAbsenceData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PacketReceiptAbsenceData.decode(e.value);
  },
  toProto(e) {
    return PacketReceiptAbsenceData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.PacketReceiptAbsenceData",
      value: PacketReceiptAbsenceData.encode(e).finish()
    };
  }
};
function createBaseNextSequenceRecvData() {
  return {
    path: new Uint8Array(),
    nextSeqRecv: Long$2.UZERO
  };
}
const NextSequenceRecvData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.NextSequenceRecvData",
  encode(e, n = minimal.Writer.create()) {
    return e.path.length !== 0 && n.uint32(10).bytes(e.path), e.nextSeqRecv.isZero() || n.uint32(16).uint64(e.nextSeqRecv), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNextSequenceRecvData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.path = o.bytes();
          break;
        case 2:
          c.nextSeqRecv = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseNextSequenceRecvData();
    return o.path = (n = e.path) !== null && n !== void 0 ? n : new Uint8Array(), o.nextSeqRecv = e.nextSeqRecv !== void 0 && e.nextSeqRecv !== null ? Long$2.fromValue(e.nextSeqRecv) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      path: e.path,
      nextSeqRecv: Long$2.fromString(e.next_seq_recv)
    };
  },
  toAmino(e) {
    const n = {};
    return n.path = e.path, n.next_seq_recv = e.nextSeqRecv ? e.nextSeqRecv.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return NextSequenceRecvData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/NextSequenceRecvData",
      value: NextSequenceRecvData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return NextSequenceRecvData.decode(e.value);
  },
  toProto(e) {
    return NextSequenceRecvData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.NextSequenceRecvData",
      value: NextSequenceRecvData.encode(e).finish()
    };
  }
}, _97 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChannelStateData,
  ClientState: ClientState$2,
  ClientStateData,
  ConnectionStateData,
  ConsensusState: ConsensusState$2,
  ConsensusStateData,
  get DataType() {
    return DataType;
  },
  DataTypeAmino,
  DataTypeSDKType,
  Header: Header$2,
  HeaderData: HeaderData$1,
  Misbehaviour: Misbehaviour$2,
  NextSequenceRecvData,
  PacketAcknowledgementData,
  PacketCommitmentData,
  PacketReceiptAbsenceData,
  SignBytes: SignBytes$1,
  SignatureAndData: SignatureAndData$1,
  TimestampedSignatureData: TimestampedSignatureData$1,
  dataTypeFromJSON,
  dataTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseClientState$1() {
  return {
    sequence: Long$2.UZERO,
    isFrozen: !1,
    consensusState: void 0
  };
}
const ClientState$1 = {
  typeUrl: "/ibc.lightclients.solomachine.v3.ClientState",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), e.isFrozen === !0 && n.uint32(16).bool(e.isFrozen), e.consensusState !== void 0 && ConsensusState$1.encode(e.consensusState, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClientState$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        case 2:
          c.isFrozen = o.bool();
          break;
        case 3:
          c.consensusState = ConsensusState$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseClientState$1();
    return o.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, o.isFrozen = (n = e.isFrozen) !== null && n !== void 0 ? n : !1, o.consensusState = e.consensusState !== void 0 && e.consensusState !== null ? ConsensusState$1.fromPartial(e.consensusState) : void 0, o;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence),
      isFrozen: e.is_frozen,
      consensusState: e != null && e.consensus_state ? ConsensusState$1.fromAmino(e.consensus_state) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n.is_frozen = e.isFrozen, n.consensus_state = e.consensusState ? ConsensusState$1.toAmino(e.consensusState) : void 0, n;
  },
  fromAminoMsg(e) {
    return ClientState$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ClientState",
      value: ClientState$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClientState$1.decode(e.value);
  },
  toProto(e) {
    return ClientState$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.ClientState",
      value: ClientState$1.encode(e).finish()
    };
  }
};
function createBaseConsensusState$1() {
  return {
    publicKey: void 0,
    diversifier: "",
    timestamp: Long$2.UZERO
  };
}
const ConsensusState$1 = {
  typeUrl: "/ibc.lightclients.solomachine.v3.ConsensusState",
  encode(e, n = minimal.Writer.create()) {
    return e.publicKey !== void 0 && Any.encode(e.publicKey, n.uint32(10).fork()).ldelim(), e.diversifier !== "" && n.uint32(18).string(e.diversifier), e.timestamp.isZero() || n.uint32(24).uint64(e.timestamp), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConsensusState$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.publicKey = Any.decode(o, o.uint32());
          break;
        case 2:
          c.diversifier = o.string();
          break;
        case 3:
          c.timestamp = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseConsensusState$1();
    return o.publicKey = e.publicKey !== void 0 && e.publicKey !== null ? Any.fromPartial(e.publicKey) : void 0, o.diversifier = (n = e.diversifier) !== null && n !== void 0 ? n : "", o.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      publicKey: e != null && e.public_key ? Any.fromAmino(e.public_key) : void 0,
      diversifier: e.diversifier,
      timestamp: Long$2.fromString(e.timestamp)
    };
  },
  toAmino(e) {
    const n = {};
    return n.public_key = e.publicKey ? Any.toAmino(e.publicKey) : void 0, n.diversifier = e.diversifier, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ConsensusState$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConsensusState",
      value: ConsensusState$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConsensusState$1.decode(e.value);
  },
  toProto(e) {
    return ConsensusState$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.ConsensusState",
      value: ConsensusState$1.encode(e).finish()
    };
  }
};
function createBaseHeader$1() {
  return {
    timestamp: Long$2.UZERO,
    signature: new Uint8Array(),
    newPublicKey: void 0,
    newDiversifier: ""
  };
}
const Header$1 = {
  typeUrl: "/ibc.lightclients.solomachine.v3.Header",
  encode(e, n = minimal.Writer.create()) {
    return e.timestamp.isZero() || n.uint32(8).uint64(e.timestamp), e.signature.length !== 0 && n.uint32(18).bytes(e.signature), e.newPublicKey !== void 0 && Any.encode(e.newPublicKey, n.uint32(26).fork()).ldelim(), e.newDiversifier !== "" && n.uint32(34).string(e.newDiversifier), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHeader$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.timestamp = o.uint64();
          break;
        case 2:
          c.signature = o.bytes();
          break;
        case 3:
          c.newPublicKey = Any.decode(o, o.uint32());
          break;
        case 4:
          c.newDiversifier = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseHeader$1();
    return u.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, u.signature = (n = e.signature) !== null && n !== void 0 ? n : new Uint8Array(), u.newPublicKey = e.newPublicKey !== void 0 && e.newPublicKey !== null ? Any.fromPartial(e.newPublicKey) : void 0, u.newDiversifier = (o = e.newDiversifier) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      timestamp: Long$2.fromString(e.timestamp),
      signature: e.signature,
      newPublicKey: e != null && e.new_public_key ? Any.fromAmino(e.new_public_key) : void 0,
      newDiversifier: e.new_diversifier
    };
  },
  toAmino(e) {
    const n = {};
    return n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n.signature = e.signature, n.new_public_key = e.newPublicKey ? Any.toAmino(e.newPublicKey) : void 0, n.new_diversifier = e.newDiversifier, n;
  },
  fromAminoMsg(e) {
    return Header$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Header",
      value: Header$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Header$1.decode(e.value);
  },
  toProto(e) {
    return Header$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.Header",
      value: Header$1.encode(e).finish()
    };
  }
};
function createBaseMisbehaviour$1() {
  return {
    sequence: Long$2.UZERO,
    signatureOne: void 0,
    signatureTwo: void 0
  };
}
const Misbehaviour$1 = {
  typeUrl: "/ibc.lightclients.solomachine.v3.Misbehaviour",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), e.signatureOne !== void 0 && SignatureAndData.encode(e.signatureOne, n.uint32(18).fork()).ldelim(), e.signatureTwo !== void 0 && SignatureAndData.encode(e.signatureTwo, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMisbehaviour$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        case 2:
          c.signatureOne = SignatureAndData.decode(o, o.uint32());
          break;
        case 3:
          c.signatureTwo = SignatureAndData.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMisbehaviour$1();
    return n.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, n.signatureOne = e.signatureOne !== void 0 && e.signatureOne !== null ? SignatureAndData.fromPartial(e.signatureOne) : void 0, n.signatureTwo = e.signatureTwo !== void 0 && e.signatureTwo !== null ? SignatureAndData.fromPartial(e.signatureTwo) : void 0, n;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence),
      signatureOne: e != null && e.signature_one ? SignatureAndData.fromAmino(e.signature_one) : void 0,
      signatureTwo: e != null && e.signature_two ? SignatureAndData.fromAmino(e.signature_two) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n.signature_one = e.signatureOne ? SignatureAndData.toAmino(e.signatureOne) : void 0, n.signature_two = e.signatureTwo ? SignatureAndData.toAmino(e.signatureTwo) : void 0, n;
  },
  fromAminoMsg(e) {
    return Misbehaviour$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Misbehaviour",
      value: Misbehaviour$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Misbehaviour$1.decode(e.value);
  },
  toProto(e) {
    return Misbehaviour$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.Misbehaviour",
      value: Misbehaviour$1.encode(e).finish()
    };
  }
};
function createBaseSignatureAndData() {
  return {
    signature: new Uint8Array(),
    path: new Uint8Array(),
    data: new Uint8Array(),
    timestamp: Long$2.UZERO
  };
}
const SignatureAndData = {
  typeUrl: "/ibc.lightclients.solomachine.v3.SignatureAndData",
  encode(e, n = minimal.Writer.create()) {
    return e.signature.length !== 0 && n.uint32(10).bytes(e.signature), e.path.length !== 0 && n.uint32(18).bytes(e.path), e.data.length !== 0 && n.uint32(26).bytes(e.data), e.timestamp.isZero() || n.uint32(32).uint64(e.timestamp), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignatureAndData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signature = o.bytes();
          break;
        case 2:
          c.path = o.bytes();
          break;
        case 3:
          c.data = o.bytes();
          break;
        case 4:
          c.timestamp = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSignatureAndData();
    return c.signature = (n = e.signature) !== null && n !== void 0 ? n : new Uint8Array(), c.path = (o = e.path) !== null && o !== void 0 ? o : new Uint8Array(), c.data = (u = e.data) !== null && u !== void 0 ? u : new Uint8Array(), c.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, c;
  },
  fromAmino(e) {
    return {
      signature: e.signature,
      path: e.path,
      data: e.data,
      timestamp: Long$2.fromString(e.timestamp)
    };
  },
  toAmino(e) {
    const n = {};
    return n.signature = e.signature, n.path = e.path, n.data = e.data, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return SignatureAndData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SignatureAndData",
      value: SignatureAndData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignatureAndData.decode(e.value);
  },
  toProto(e) {
    return SignatureAndData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.SignatureAndData",
      value: SignatureAndData.encode(e).finish()
    };
  }
};
function createBaseTimestampedSignatureData() {
  return {
    signatureData: new Uint8Array(),
    timestamp: Long$2.UZERO
  };
}
const TimestampedSignatureData = {
  typeUrl: "/ibc.lightclients.solomachine.v3.TimestampedSignatureData",
  encode(e, n = minimal.Writer.create()) {
    return e.signatureData.length !== 0 && n.uint32(10).bytes(e.signatureData), e.timestamp.isZero() || n.uint32(16).uint64(e.timestamp), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTimestampedSignatureData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signatureData = o.bytes();
          break;
        case 2:
          c.timestamp = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseTimestampedSignatureData();
    return o.signatureData = (n = e.signatureData) !== null && n !== void 0 ? n : new Uint8Array(), o.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      signatureData: e.signature_data,
      timestamp: Long$2.fromString(e.timestamp)
    };
  },
  toAmino(e) {
    const n = {};
    return n.signature_data = e.signatureData, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return TimestampedSignatureData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/TimestampedSignatureData",
      value: TimestampedSignatureData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TimestampedSignatureData.decode(e.value);
  },
  toProto(e) {
    return TimestampedSignatureData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.TimestampedSignatureData",
      value: TimestampedSignatureData.encode(e).finish()
    };
  }
};
function createBaseSignBytes() {
  return {
    sequence: Long$2.UZERO,
    timestamp: Long$2.UZERO,
    diversifier: "",
    path: new Uint8Array(),
    data: new Uint8Array()
  };
}
const SignBytes = {
  typeUrl: "/ibc.lightclients.solomachine.v3.SignBytes",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), e.timestamp.isZero() || n.uint32(16).uint64(e.timestamp), e.diversifier !== "" && n.uint32(26).string(e.diversifier), e.path.length !== 0 && n.uint32(34).bytes(e.path), e.data.length !== 0 && n.uint32(42).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSignBytes();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        case 2:
          c.timestamp = o.uint64();
          break;
        case 3:
          c.diversifier = o.string();
          break;
        case 4:
          c.path = o.bytes();
          break;
        case 5:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSignBytes();
    return c.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, c.timestamp = e.timestamp !== void 0 && e.timestamp !== null ? Long$2.fromValue(e.timestamp) : Long$2.UZERO, c.diversifier = (n = e.diversifier) !== null && n !== void 0 ? n : "", c.path = (o = e.path) !== null && o !== void 0 ? o : new Uint8Array(), c.data = (u = e.data) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence),
      timestamp: Long$2.fromString(e.timestamp),
      diversifier: e.diversifier,
      path: e.path,
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n.timestamp = e.timestamp ? e.timestamp.toString() : void 0, n.diversifier = e.diversifier, n.path = e.path, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return SignBytes.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/SignBytes",
      value: SignBytes.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SignBytes.decode(e.value);
  },
  toProto(e) {
    return SignBytes.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.SignBytes",
      value: SignBytes.encode(e).finish()
    };
  }
};
function createBaseHeaderData() {
  return {
    newPubKey: void 0,
    newDiversifier: ""
  };
}
const HeaderData = {
  typeUrl: "/ibc.lightclients.solomachine.v3.HeaderData",
  encode(e, n = minimal.Writer.create()) {
    return e.newPubKey !== void 0 && Any.encode(e.newPubKey, n.uint32(10).fork()).ldelim(), e.newDiversifier !== "" && n.uint32(18).string(e.newDiversifier), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHeaderData();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.newPubKey = Any.decode(o, o.uint32());
          break;
        case 2:
          c.newDiversifier = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseHeaderData();
    return o.newPubKey = e.newPubKey !== void 0 && e.newPubKey !== null ? Any.fromPartial(e.newPubKey) : void 0, o.newDiversifier = (n = e.newDiversifier) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      newPubKey: e != null && e.new_pub_key ? Any.fromAmino(e.new_pub_key) : void 0,
      newDiversifier: e.new_diversifier
    };
  },
  toAmino(e) {
    const n = {};
    return n.new_pub_key = e.newPubKey ? Any.toAmino(e.newPubKey) : void 0, n.new_diversifier = e.newDiversifier, n;
  },
  fromAminoMsg(e) {
    return HeaderData.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/HeaderData",
      value: HeaderData.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return HeaderData.decode(e.value);
  },
  toProto(e) {
    return HeaderData.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.HeaderData",
      value: HeaderData.encode(e).finish()
    };
  }
}, _98 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClientState: ClientState$1,
  ConsensusState: ConsensusState$1,
  Header: Header$1,
  HeaderData,
  Misbehaviour: Misbehaviour$1,
  SignBytes,
  SignatureAndData,
  TimestampedSignatureData
}, Symbol.toStringTag, { value: "Module" }));
function createBaseClientState() {
  return {
    chainId: "",
    trustLevel: void 0,
    trustingPeriod: void 0,
    unbondingPeriod: void 0,
    maxClockDrift: void 0,
    frozenHeight: void 0,
    latestHeight: void 0,
    proofSpecs: [],
    upgradePath: [],
    allowUpdateAfterExpiry: !1,
    allowUpdateAfterMisbehaviour: !1
  };
}
const ClientState = {
  typeUrl: "/ibc.lightclients.tendermint.v1.ClientState",
  encode(e, n = minimal.Writer.create()) {
    e.chainId !== "" && n.uint32(10).string(e.chainId), e.trustLevel !== void 0 && Fraction.encode(e.trustLevel, n.uint32(18).fork()).ldelim(), e.trustingPeriod !== void 0 && Duration.encode(e.trustingPeriod, n.uint32(26).fork()).ldelim(), e.unbondingPeriod !== void 0 && Duration.encode(e.unbondingPeriod, n.uint32(34).fork()).ldelim(), e.maxClockDrift !== void 0 && Duration.encode(e.maxClockDrift, n.uint32(42).fork()).ldelim(), e.frozenHeight !== void 0 && Height.encode(e.frozenHeight, n.uint32(50).fork()).ldelim(), e.latestHeight !== void 0 && Height.encode(e.latestHeight, n.uint32(58).fork()).ldelim();
    for (const o of e.proofSpecs)
      ProofSpec$1.encode(o, n.uint32(66).fork()).ldelim();
    for (const o of e.upgradePath)
      n.uint32(74).string(o);
    return e.allowUpdateAfterExpiry === !0 && n.uint32(80).bool(e.allowUpdateAfterExpiry), e.allowUpdateAfterMisbehaviour === !0 && n.uint32(88).bool(e.allowUpdateAfterMisbehaviour), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseClientState();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.chainId = o.string();
          break;
        case 2:
          c.trustLevel = Fraction.decode(o, o.uint32());
          break;
        case 3:
          c.trustingPeriod = Duration.decode(o, o.uint32());
          break;
        case 4:
          c.unbondingPeriod = Duration.decode(o, o.uint32());
          break;
        case 5:
          c.maxClockDrift = Duration.decode(o, o.uint32());
          break;
        case 6:
          c.frozenHeight = Height.decode(o, o.uint32());
          break;
        case 7:
          c.latestHeight = Height.decode(o, o.uint32());
          break;
        case 8:
          c.proofSpecs.push(ProofSpec$1.decode(o, o.uint32()));
          break;
        case 9:
          c.upgradePath.push(o.string());
          break;
        case 10:
          c.allowUpdateAfterExpiry = o.bool();
          break;
        case 11:
          c.allowUpdateAfterMisbehaviour = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseClientState();
    return m.chainId = (n = e.chainId) !== null && n !== void 0 ? n : "", m.trustLevel = e.trustLevel !== void 0 && e.trustLevel !== null ? Fraction.fromPartial(e.trustLevel) : void 0, m.trustingPeriod = e.trustingPeriod !== void 0 && e.trustingPeriod !== null ? Duration.fromPartial(e.trustingPeriod) : void 0, m.unbondingPeriod = e.unbondingPeriod !== void 0 && e.unbondingPeriod !== null ? Duration.fromPartial(e.unbondingPeriod) : void 0, m.maxClockDrift = e.maxClockDrift !== void 0 && e.maxClockDrift !== null ? Duration.fromPartial(e.maxClockDrift) : void 0, m.frozenHeight = e.frozenHeight !== void 0 && e.frozenHeight !== null ? Height.fromPartial(e.frozenHeight) : void 0, m.latestHeight = e.latestHeight !== void 0 && e.latestHeight !== null ? Height.fromPartial(e.latestHeight) : void 0, m.proofSpecs = ((o = e.proofSpecs) === null || o === void 0 ? void 0 : o.map((v) => ProofSpec$1.fromPartial(v))) || [], m.upgradePath = ((u = e.upgradePath) === null || u === void 0 ? void 0 : u.map((v) => v)) || [], m.allowUpdateAfterExpiry = (c = e.allowUpdateAfterExpiry) !== null && c !== void 0 ? c : !1, m.allowUpdateAfterMisbehaviour = (d = e.allowUpdateAfterMisbehaviour) !== null && d !== void 0 ? d : !1, m;
  },
  fromAmino(e) {
    return {
      chainId: e.chain_id,
      trustLevel: e != null && e.trust_level ? Fraction.fromAmino(e.trust_level) : void 0,
      trustingPeriod: e != null && e.trusting_period ? Duration.fromAmino(e.trusting_period) : void 0,
      unbondingPeriod: e != null && e.unbonding_period ? Duration.fromAmino(e.unbonding_period) : void 0,
      maxClockDrift: e != null && e.max_clock_drift ? Duration.fromAmino(e.max_clock_drift) : void 0,
      frozenHeight: e != null && e.frozen_height ? Height.fromAmino(e.frozen_height) : void 0,
      latestHeight: e != null && e.latest_height ? Height.fromAmino(e.latest_height) : void 0,
      proofSpecs: Array.isArray(e == null ? void 0 : e.proof_specs) ? e.proof_specs.map((n) => ProofSpec$1.fromAmino(n)) : [],
      upgradePath: Array.isArray(e == null ? void 0 : e.upgrade_path) ? e.upgrade_path.map((n) => n) : [],
      allowUpdateAfterExpiry: e.allow_update_after_expiry,
      allowUpdateAfterMisbehaviour: e.allow_update_after_misbehaviour
    };
  },
  toAmino(e) {
    const n = {};
    return n.chain_id = e.chainId, n.trust_level = e.trustLevel ? Fraction.toAmino(e.trustLevel) : void 0, n.trusting_period = e.trustingPeriod ? Duration.toAmino(e.trustingPeriod) : void 0, n.unbonding_period = e.unbondingPeriod ? Duration.toAmino(e.unbondingPeriod) : void 0, n.max_clock_drift = e.maxClockDrift ? Duration.toAmino(e.maxClockDrift) : void 0, n.frozen_height = e.frozenHeight ? Height.toAmino(e.frozenHeight) : {}, n.latest_height = e.latestHeight ? Height.toAmino(e.latestHeight) : {}, e.proofSpecs ? n.proof_specs = e.proofSpecs.map((o) => o ? ProofSpec$1.toAmino(o) : void 0) : n.proof_specs = [], e.upgradePath ? n.upgrade_path = e.upgradePath.map((o) => o) : n.upgrade_path = [], n.allow_update_after_expiry = e.allowUpdateAfterExpiry, n.allow_update_after_misbehaviour = e.allowUpdateAfterMisbehaviour, n;
  },
  fromAminoMsg(e) {
    return ClientState.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ClientState",
      value: ClientState.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ClientState.decode(e.value);
  },
  toProto(e) {
    return ClientState.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.ClientState",
      value: ClientState.encode(e).finish()
    };
  }
};
function createBaseConsensusState() {
  return {
    timestamp: void 0,
    root: void 0,
    nextValidatorsHash: new Uint8Array()
  };
}
const ConsensusState = {
  typeUrl: "/ibc.lightclients.tendermint.v1.ConsensusState",
  encode(e, n = minimal.Writer.create()) {
    return e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(10).fork()).ldelim(), e.root !== void 0 && MerkleRoot.encode(e.root, n.uint32(18).fork()).ldelim(), e.nextValidatorsHash.length !== 0 && n.uint32(26).bytes(e.nextValidatorsHash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConsensusState();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 2:
          c.root = MerkleRoot.decode(o, o.uint32());
          break;
        case 3:
          c.nextValidatorsHash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseConsensusState();
    return u.timestamp = (n = e.timestamp) !== null && n !== void 0 ? n : void 0, u.root = e.root !== void 0 && e.root !== null ? MerkleRoot.fromPartial(e.root) : void 0, u.nextValidatorsHash = (o = e.nextValidatorsHash) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0,
      root: e != null && e.root ? MerkleRoot.fromAmino(e.root) : void 0,
      nextValidatorsHash: e.next_validators_hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n.root = e.root ? MerkleRoot.toAmino(e.root) : void 0, n.next_validators_hash = e.nextValidatorsHash, n;
  },
  fromAminoMsg(e) {
    return ConsensusState.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/ConsensusState",
      value: ConsensusState.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConsensusState.decode(e.value);
  },
  toProto(e) {
    return ConsensusState.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.ConsensusState",
      value: ConsensusState.encode(e).finish()
    };
  }
};
function createBaseMisbehaviour() {
  return {
    clientId: "",
    header1: void 0,
    header2: void 0
  };
}
const Misbehaviour = {
  typeUrl: "/ibc.lightclients.tendermint.v1.Misbehaviour",
  encode(e, n = minimal.Writer.create()) {
    return e.clientId !== "" && n.uint32(10).string(e.clientId), e.header1 !== void 0 && Header.encode(e.header1, n.uint32(18).fork()).ldelim(), e.header2 !== void 0 && Header.encode(e.header2, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMisbehaviour();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.clientId = o.string();
          break;
        case 2:
          c.header1 = Header.decode(o, o.uint32());
          break;
        case 3:
          c.header2 = Header.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMisbehaviour();
    return o.clientId = (n = e.clientId) !== null && n !== void 0 ? n : "", o.header1 = e.header1 !== void 0 && e.header1 !== null ? Header.fromPartial(e.header1) : void 0, o.header2 = e.header2 !== void 0 && e.header2 !== null ? Header.fromPartial(e.header2) : void 0, o;
  },
  fromAmino(e) {
    return {
      clientId: e.client_id,
      header_1: e != null && e.header_1 ? Header.fromAmino(e.header_1) : void 0,
      header_2: e != null && e.header_2 ? Header.fromAmino(e.header_2) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.client_id = e.clientId, n.header_1 = e.header_1 ? Header.toAmino(e.header_1) : void 0, n.header_2 = e.header_2 ? Header.toAmino(e.header_2) : void 0, n;
  },
  fromAminoMsg(e) {
    return Misbehaviour.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Misbehaviour",
      value: Misbehaviour.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Misbehaviour.decode(e.value);
  },
  toProto(e) {
    return Misbehaviour.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.Misbehaviour",
      value: Misbehaviour.encode(e).finish()
    };
  }
};
function createBaseHeader() {
  return {
    signedHeader: void 0,
    validatorSet: void 0,
    trustedHeight: void 0,
    trustedValidators: void 0
  };
}
const Header = {
  typeUrl: "/ibc.lightclients.tendermint.v1.Header",
  encode(e, n = minimal.Writer.create()) {
    return e.signedHeader !== void 0 && SignedHeader.encode(e.signedHeader, n.uint32(10).fork()).ldelim(), e.validatorSet !== void 0 && ValidatorSet.encode(e.validatorSet, n.uint32(18).fork()).ldelim(), e.trustedHeight !== void 0 && Height.encode(e.trustedHeight, n.uint32(26).fork()).ldelim(), e.trustedValidators !== void 0 && ValidatorSet.encode(e.trustedValidators, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseHeader();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.signedHeader = SignedHeader.decode(o, o.uint32());
          break;
        case 2:
          c.validatorSet = ValidatorSet.decode(o, o.uint32());
          break;
        case 3:
          c.trustedHeight = Height.decode(o, o.uint32());
          break;
        case 4:
          c.trustedValidators = ValidatorSet.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseHeader();
    return n.signedHeader = e.signedHeader !== void 0 && e.signedHeader !== null ? SignedHeader.fromPartial(e.signedHeader) : void 0, n.validatorSet = e.validatorSet !== void 0 && e.validatorSet !== null ? ValidatorSet.fromPartial(e.validatorSet) : void 0, n.trustedHeight = e.trustedHeight !== void 0 && e.trustedHeight !== null ? Height.fromPartial(e.trustedHeight) : void 0, n.trustedValidators = e.trustedValidators !== void 0 && e.trustedValidators !== null ? ValidatorSet.fromPartial(e.trustedValidators) : void 0, n;
  },
  fromAmino(e) {
    return {
      signedHeader: e != null && e.signed_header ? SignedHeader.fromAmino(e.signed_header) : void 0,
      validatorSet: e != null && e.validator_set ? ValidatorSet.fromAmino(e.validator_set) : void 0,
      trustedHeight: e != null && e.trusted_height ? Height.fromAmino(e.trusted_height) : void 0,
      trustedValidators: e != null && e.trusted_validators ? ValidatorSet.fromAmino(e.trusted_validators) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.signed_header = e.signedHeader ? SignedHeader.toAmino(e.signedHeader) : void 0, n.validator_set = e.validatorSet ? ValidatorSet.toAmino(e.validatorSet) : void 0, n.trusted_height = e.trustedHeight ? Height.toAmino(e.trustedHeight) : {}, n.trusted_validators = e.trustedValidators ? ValidatorSet.toAmino(e.trustedValidators) : void 0, n;
  },
  fromAminoMsg(e) {
    return Header.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Header",
      value: Header.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Header.decode(e.value);
  },
  toProto(e) {
    return Header.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.Header",
      value: Header.encode(e).finish()
    };
  }
};
function createBaseFraction() {
  return {
    numerator: Long$2.UZERO,
    denominator: Long$2.UZERO
  };
}
const Fraction = {
  typeUrl: "/ibc.lightclients.tendermint.v1.Fraction",
  encode(e, n = minimal.Writer.create()) {
    return e.numerator.isZero() || n.uint32(8).uint64(e.numerator), e.denominator.isZero() || n.uint32(16).uint64(e.denominator), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFraction();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.numerator = o.uint64();
          break;
        case 2:
          c.denominator = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseFraction();
    return n.numerator = e.numerator !== void 0 && e.numerator !== null ? Long$2.fromValue(e.numerator) : Long$2.UZERO, n.denominator = e.denominator !== void 0 && e.denominator !== null ? Long$2.fromValue(e.denominator) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      numerator: Long$2.fromString(e.numerator),
      denominator: Long$2.fromString(e.denominator)
    };
  },
  toAmino(e) {
    const n = {};
    return n.numerator = e.numerator ? e.numerator.toString() : void 0, n.denominator = e.denominator ? e.denominator.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Fraction.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "cosmos-sdk/Fraction",
      value: Fraction.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Fraction.decode(e.value);
  },
  toProto(e) {
    return Fraction.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.Fraction",
      value: Fraction.encode(e).finish()
    };
  }
}, _99 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClientState,
  ConsensusState,
  Fraction,
  Header,
  Misbehaviour
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$h = {
  "/ibc.applications.fee.v1.MsgRegisterPayee": {
    aminoType: "cosmos-sdk/MsgRegisterPayee",
    toAmino: MsgRegisterPayee.toAmino,
    fromAmino: MsgRegisterPayee.fromAmino
  },
  "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee": {
    aminoType: "cosmos-sdk/MsgRegisterCounterpartyPayee",
    toAmino: MsgRegisterCounterpartyPayee.toAmino,
    fromAmino: MsgRegisterCounterpartyPayee.fromAmino
  },
  "/ibc.applications.fee.v1.MsgPayPacketFee": {
    aminoType: "cosmos-sdk/MsgPayPacketFee",
    toAmino: MsgPayPacketFee.toAmino,
    fromAmino: MsgPayPacketFee.fromAmino
  },
  "/ibc.applications.fee.v1.MsgPayPacketFeeAsync": {
    aminoType: "cosmos-sdk/MsgPayPacketFeeAsync",
    toAmino: MsgPayPacketFeeAsync.toAmino,
    fromAmino: MsgPayPacketFeeAsync.fromAmino
  }
}, _229 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$h
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$g = {
  "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount": {
    aminoType: "cosmos-sdk/MsgRegisterInterchainAccount",
    toAmino: MsgRegisterInterchainAccount.toAmino,
    fromAmino: MsgRegisterInterchainAccount.fromAmino
  },
  "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx": {
    aminoType: "cosmos-sdk/MsgSendTx",
    toAmino: MsgSendTx.toAmino,
    fromAmino: MsgSendTx.fromAmino
  }
}, _230 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$g
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$f = {
  "/ibc.applications.transfer.v1.MsgTransfer": {
    aminoType: "cosmos-sdk/MsgTransfer",
    toAmino: MsgTransfer.toAmino,
    fromAmino: MsgTransfer.fromAmino
  }
}, _231 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$f
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$e = {
  "/ibc.core.channel.v1.MsgChannelOpenInit": {
    aminoType: "cosmos-sdk/MsgChannelOpenInit",
    toAmino: MsgChannelOpenInit.toAmino,
    fromAmino: MsgChannelOpenInit.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelOpenTry": {
    aminoType: "cosmos-sdk/MsgChannelOpenTry",
    toAmino: MsgChannelOpenTry.toAmino,
    fromAmino: MsgChannelOpenTry.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelOpenAck": {
    aminoType: "cosmos-sdk/MsgChannelOpenAck",
    toAmino: MsgChannelOpenAck.toAmino,
    fromAmino: MsgChannelOpenAck.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelOpenConfirm": {
    aminoType: "cosmos-sdk/MsgChannelOpenConfirm",
    toAmino: MsgChannelOpenConfirm.toAmino,
    fromAmino: MsgChannelOpenConfirm.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelCloseInit": {
    aminoType: "cosmos-sdk/MsgChannelCloseInit",
    toAmino: MsgChannelCloseInit.toAmino,
    fromAmino: MsgChannelCloseInit.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelCloseConfirm": {
    aminoType: "cosmos-sdk/MsgChannelCloseConfirm",
    toAmino: MsgChannelCloseConfirm.toAmino,
    fromAmino: MsgChannelCloseConfirm.fromAmino
  },
  "/ibc.core.channel.v1.MsgRecvPacket": {
    aminoType: "cosmos-sdk/MsgRecvPacket",
    toAmino: MsgRecvPacket.toAmino,
    fromAmino: MsgRecvPacket.fromAmino
  },
  "/ibc.core.channel.v1.MsgTimeout": {
    aminoType: "cosmos-sdk/MsgTimeout",
    toAmino: MsgTimeout.toAmino,
    fromAmino: MsgTimeout.fromAmino
  },
  "/ibc.core.channel.v1.MsgTimeoutOnClose": {
    aminoType: "cosmos-sdk/MsgTimeoutOnClose",
    toAmino: MsgTimeoutOnClose.toAmino,
    fromAmino: MsgTimeoutOnClose.fromAmino
  },
  "/ibc.core.channel.v1.MsgAcknowledgement": {
    aminoType: "cosmos-sdk/MsgAcknowledgement",
    toAmino: MsgAcknowledgement.toAmino,
    fromAmino: MsgAcknowledgement.fromAmino
  }
}, _232 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$e
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$d = {
  "/ibc.core.client.v1.MsgCreateClient": {
    aminoType: "cosmos-sdk/MsgCreateClient",
    toAmino: MsgCreateClient.toAmino,
    fromAmino: MsgCreateClient.fromAmino
  },
  "/ibc.core.client.v1.MsgUpdateClient": {
    aminoType: "cosmos-sdk/MsgUpdateClient",
    toAmino: MsgUpdateClient.toAmino,
    fromAmino: MsgUpdateClient.fromAmino
  },
  "/ibc.core.client.v1.MsgUpgradeClient": {
    aminoType: "cosmos-sdk/MsgUpgradeClient",
    toAmino: MsgUpgradeClient.toAmino,
    fromAmino: MsgUpgradeClient.fromAmino
  },
  "/ibc.core.client.v1.MsgSubmitMisbehaviour": {
    aminoType: "cosmos-sdk/MsgSubmitMisbehaviour",
    toAmino: MsgSubmitMisbehaviour.toAmino,
    fromAmino: MsgSubmitMisbehaviour.fromAmino
  }
}, _233 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$d
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$c = {
  "/ibc.core.connection.v1.MsgConnectionOpenInit": {
    aminoType: "cosmos-sdk/MsgConnectionOpenInit",
    toAmino: MsgConnectionOpenInit.toAmino,
    fromAmino: MsgConnectionOpenInit.fromAmino
  },
  "/ibc.core.connection.v1.MsgConnectionOpenTry": {
    aminoType: "cosmos-sdk/MsgConnectionOpenTry",
    toAmino: MsgConnectionOpenTry.toAmino,
    fromAmino: MsgConnectionOpenTry.fromAmino
  },
  "/ibc.core.connection.v1.MsgConnectionOpenAck": {
    aminoType: "cosmos-sdk/MsgConnectionOpenAck",
    toAmino: MsgConnectionOpenAck.toAmino,
    fromAmino: MsgConnectionOpenAck.fromAmino
  },
  "/ibc.core.connection.v1.MsgConnectionOpenConfirm": {
    aminoType: "cosmos-sdk/MsgConnectionOpenConfirm",
    toAmino: MsgConnectionOpenConfirm.toAmino,
    fromAmino: MsgConnectionOpenConfirm.fromAmino
  }
}, _234 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$c
}, Symbol.toStringTag, { value: "Module" })), registry$i = [["/ibc.applications.fee.v1.MsgRegisterPayee", MsgRegisterPayee], ["/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee", MsgRegisterCounterpartyPayee], ["/ibc.applications.fee.v1.MsgPayPacketFee", MsgPayPacketFee], ["/ibc.applications.fee.v1.MsgPayPacketFeeAsync", MsgPayPacketFeeAsync]], load$g = (e) => {
  registry$i.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$g = {
  encoded: {
    registerPayee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
        value: MsgRegisterPayee.encode(e).finish()
      };
    },
    registerCounterpartyPayee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
        value: MsgRegisterCounterpartyPayee.encode(e).finish()
      };
    },
    payPacketFee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
        value: MsgPayPacketFee.encode(e).finish()
      };
    },
    payPacketFeeAsync(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
        value: MsgPayPacketFeeAsync.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    registerPayee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
        value: e
      };
    },
    registerCounterpartyPayee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
        value: e
      };
    },
    payPacketFee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
        value: e
      };
    },
    payPacketFeeAsync(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
        value: e
      };
    }
  },
  fromPartial: {
    registerPayee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
        value: MsgRegisterPayee.fromPartial(e)
      };
    },
    registerCounterpartyPayee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
        value: MsgRegisterCounterpartyPayee.fromPartial(e)
      };
    },
    payPacketFee(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
        value: MsgPayPacketFee.fromPartial(e)
      };
    },
    payPacketFeeAsync(e) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
        value: MsgPayPacketFeeAsync.fromPartial(e)
      };
    }
  }
}, _235 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$g,
  load: load$g,
  registry: registry$i
}, Symbol.toStringTag, { value: "Module" })), registry$h = [["/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount", MsgRegisterInterchainAccount], ["/ibc.applications.interchain_accounts.controller.v1.MsgSendTx", MsgSendTx]], load$f = (e) => {
  registry$h.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$f = {
  encoded: {
    registerInterchainAccount(e) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
        value: MsgRegisterInterchainAccount.encode(e).finish()
      };
    },
    sendTx(e) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
        value: MsgSendTx.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    registerInterchainAccount(e) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
        value: e
      };
    },
    sendTx(e) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
        value: e
      };
    }
  },
  fromPartial: {
    registerInterchainAccount(e) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
        value: MsgRegisterInterchainAccount.fromPartial(e)
      };
    },
    sendTx(e) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
        value: MsgSendTx.fromPartial(e)
      };
    }
  }
}, _236 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$f,
  load: load$f,
  registry: registry$h
}, Symbol.toStringTag, { value: "Module" })), registry$g = [["/ibc.applications.transfer.v1.MsgTransfer", MsgTransfer]], load$e = (e) => {
  registry$g.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$e = {
  encoded: {
    transfer(e) {
      return {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: MsgTransfer.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    transfer(e) {
      return {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: e
      };
    }
  },
  fromPartial: {
    transfer(e) {
      return {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: MsgTransfer.fromPartial(e)
      };
    }
  }
}, _237 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$e,
  load: load$e,
  registry: registry$g
}, Symbol.toStringTag, { value: "Module" })), registry$f = [["/ibc.core.channel.v1.MsgChannelOpenInit", MsgChannelOpenInit], ["/ibc.core.channel.v1.MsgChannelOpenTry", MsgChannelOpenTry], ["/ibc.core.channel.v1.MsgChannelOpenAck", MsgChannelOpenAck], ["/ibc.core.channel.v1.MsgChannelOpenConfirm", MsgChannelOpenConfirm], ["/ibc.core.channel.v1.MsgChannelCloseInit", MsgChannelCloseInit], ["/ibc.core.channel.v1.MsgChannelCloseConfirm", MsgChannelCloseConfirm], ["/ibc.core.channel.v1.MsgRecvPacket", MsgRecvPacket], ["/ibc.core.channel.v1.MsgTimeout", MsgTimeout], ["/ibc.core.channel.v1.MsgTimeoutOnClose", MsgTimeoutOnClose], ["/ibc.core.channel.v1.MsgAcknowledgement", MsgAcknowledgement]], load$d = (e) => {
  registry$f.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$d = {
  encoded: {
    channelOpenInit(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
        value: MsgChannelOpenInit.encode(e).finish()
      };
    },
    channelOpenTry(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
        value: MsgChannelOpenTry.encode(e).finish()
      };
    },
    channelOpenAck(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
        value: MsgChannelOpenAck.encode(e).finish()
      };
    },
    channelOpenConfirm(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        value: MsgChannelOpenConfirm.encode(e).finish()
      };
    },
    channelCloseInit(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
        value: MsgChannelCloseInit.encode(e).finish()
      };
    },
    channelCloseConfirm(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        value: MsgChannelCloseConfirm.encode(e).finish()
      };
    },
    recvPacket(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
        value: MsgRecvPacket.encode(e).finish()
      };
    },
    timeout(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeout",
        value: MsgTimeout.encode(e).finish()
      };
    },
    timeoutOnClose(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
        value: MsgTimeoutOnClose.encode(e).finish()
      };
    },
    acknowledgement(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
        value: MsgAcknowledgement.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    channelOpenInit(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
        value: e
      };
    },
    channelOpenTry(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
        value: e
      };
    },
    channelOpenAck(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
        value: e
      };
    },
    channelOpenConfirm(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        value: e
      };
    },
    channelCloseInit(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
        value: e
      };
    },
    channelCloseConfirm(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        value: e
      };
    },
    recvPacket(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
        value: e
      };
    },
    timeout(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeout",
        value: e
      };
    },
    timeoutOnClose(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
        value: e
      };
    },
    acknowledgement(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
        value: e
      };
    }
  },
  fromPartial: {
    channelOpenInit(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
        value: MsgChannelOpenInit.fromPartial(e)
      };
    },
    channelOpenTry(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
        value: MsgChannelOpenTry.fromPartial(e)
      };
    },
    channelOpenAck(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
        value: MsgChannelOpenAck.fromPartial(e)
      };
    },
    channelOpenConfirm(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        value: MsgChannelOpenConfirm.fromPartial(e)
      };
    },
    channelCloseInit(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
        value: MsgChannelCloseInit.fromPartial(e)
      };
    },
    channelCloseConfirm(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        value: MsgChannelCloseConfirm.fromPartial(e)
      };
    },
    recvPacket(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
        value: MsgRecvPacket.fromPartial(e)
      };
    },
    timeout(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeout",
        value: MsgTimeout.fromPartial(e)
      };
    },
    timeoutOnClose(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
        value: MsgTimeoutOnClose.fromPartial(e)
      };
    },
    acknowledgement(e) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
        value: MsgAcknowledgement.fromPartial(e)
      };
    }
  }
}, _238 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$d,
  load: load$d,
  registry: registry$f
}, Symbol.toStringTag, { value: "Module" })), registry$e = [["/ibc.core.client.v1.MsgCreateClient", MsgCreateClient], ["/ibc.core.client.v1.MsgUpdateClient", MsgUpdateClient], ["/ibc.core.client.v1.MsgUpgradeClient", MsgUpgradeClient], ["/ibc.core.client.v1.MsgSubmitMisbehaviour", MsgSubmitMisbehaviour]], load$c = (e) => {
  registry$e.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$c = {
  encoded: {
    createClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgCreateClient",
        value: MsgCreateClient.encode(e).finish()
      };
    },
    updateClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
        value: MsgUpdateClient.encode(e).finish()
      };
    },
    upgradeClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
        value: MsgUpgradeClient.encode(e).finish()
      };
    },
    submitMisbehaviour(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        value: MsgSubmitMisbehaviour.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    createClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgCreateClient",
        value: e
      };
    },
    updateClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
        value: e
      };
    },
    upgradeClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
        value: e
      };
    },
    submitMisbehaviour(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        value: e
      };
    }
  },
  fromPartial: {
    createClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgCreateClient",
        value: MsgCreateClient.fromPartial(e)
      };
    },
    updateClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
        value: MsgUpdateClient.fromPartial(e)
      };
    },
    upgradeClient(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
        value: MsgUpgradeClient.fromPartial(e)
      };
    },
    submitMisbehaviour(e) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        value: MsgSubmitMisbehaviour.fromPartial(e)
      };
    }
  }
}, _239 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$c,
  load: load$c,
  registry: registry$e
}, Symbol.toStringTag, { value: "Module" })), registry$d = [["/ibc.core.connection.v1.MsgConnectionOpenInit", MsgConnectionOpenInit], ["/ibc.core.connection.v1.MsgConnectionOpenTry", MsgConnectionOpenTry], ["/ibc.core.connection.v1.MsgConnectionOpenAck", MsgConnectionOpenAck], ["/ibc.core.connection.v1.MsgConnectionOpenConfirm", MsgConnectionOpenConfirm]], load$b = (e) => {
  registry$d.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$b = {
  encoded: {
    connectionOpenInit(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
        value: MsgConnectionOpenInit.encode(e).finish()
      };
    },
    connectionOpenTry(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
        value: MsgConnectionOpenTry.encode(e).finish()
      };
    },
    connectionOpenAck(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
        value: MsgConnectionOpenAck.encode(e).finish()
      };
    },
    connectionOpenConfirm(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        value: MsgConnectionOpenConfirm.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    connectionOpenInit(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
        value: e
      };
    },
    connectionOpenTry(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
        value: e
      };
    },
    connectionOpenAck(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
        value: e
      };
    },
    connectionOpenConfirm(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        value: e
      };
    }
  },
  fromPartial: {
    connectionOpenInit(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
        value: MsgConnectionOpenInit.fromPartial(e)
      };
    },
    connectionOpenTry(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
        value: MsgConnectionOpenTry.fromPartial(e)
      };
    },
    connectionOpenAck(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
        value: MsgConnectionOpenAck.fromPartial(e)
      };
    },
    connectionOpenConfirm(e) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        value: MsgConnectionOpenConfirm.fromPartial(e)
      };
    }
  }
}, _240 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$b,
  load: load$b,
  registry: registry$d
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$o = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.incentivizedPackets = this.incentivizedPackets.bind(this), this.incentivizedPacket = this.incentivizedPacket.bind(this), this.incentivizedPacketsForChannel = this.incentivizedPacketsForChannel.bind(this), this.totalRecvFees = this.totalRecvFees.bind(this), this.totalAckFees = this.totalAckFees.bind(this), this.totalTimeoutFees = this.totalTimeoutFees.bind(this), this.payee = this.payee.bind(this), this.counterpartyPayee = this.counterpartyPayee.bind(this), this.feeEnabledChannels = this.feeEnabledChannels.bind(this), this.feeEnabledChannel = this.feeEnabledChannel.bind(this);
  }
  /* IncentivizedPackets returns all incentivized packets and their associated fees */
  async incentivizedPackets(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination), typeof (n == null ? void 0 : n.queryHeight) < "u" && (o.params.query_height = n.queryHeight);
    const u = "ibc/apps/fee/v1/incentivized_packets";
    return await this.req.get(u, o);
  }
  /* IncentivizedPacket returns all packet fees for a packet given its identifier */
  async incentivizedPacket(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.packetId) < "u" && (o.params.packet_id = n.packetId), typeof (n == null ? void 0 : n.queryHeight) < "u" && (o.params.query_height = n.queryHeight);
    const u = `ibc/apps/fee/v1/channels/${n.packetId.channel_id}/ports/${n.packetId.port_id}/sequences/${n.packetId.sequence}/incentivized_packet`;
    return await this.req.get(u, o);
  }
  /* Gets all incentivized packets for a specific channel */
  async incentivizedPacketsForChannel(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination), typeof (n == null ? void 0 : n.queryHeight) < "u" && (o.params.query_height = n.queryHeight);
    const u = `ibc/apps/fee/v1/channels/${n.channelId}/ports/${n.portId}/incentivized_packets`;
    return await this.req.get(u, o);
  }
  /* TotalRecvFees returns the total receive fees for a packet given its identifier */
  async totalRecvFees(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.packetId) < "u" && (o.params.packet_id = n.packetId);
    const u = `ibc/apps/fee/v1/channels/${n.packetId.channel_id}/ports/${n.packetId.port_id}/sequences/${n.packetId.sequence}/total_recv_fees`;
    return await this.req.get(u, o);
  }
  /* TotalAckFees returns the total acknowledgement fees for a packet given its identifier */
  async totalAckFees(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.packetId) < "u" && (o.params.packet_id = n.packetId);
    const u = `ibc/apps/fee/v1/channels/${n.packetId.channel_id}/ports/${n.packetId.port_id}/sequences/${n.packetId.sequence}/total_ack_fees`;
    return await this.req.get(u, o);
  }
  /* TotalTimeoutFees returns the total timeout fees for a packet given its identifier */
  async totalTimeoutFees(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.packetId) < "u" && (o.params.packet_id = n.packetId);
    const u = `ibc/apps/fee/v1/channels/${n.packetId.channel_id}/ports/${n.packetId.port_id}/sequences/${n.packetId.sequence}/total_timeout_fees`;
    return await this.req.get(u, o);
  }
  /* Payee returns the registered payee address for a specific channel given the relayer address */
  async payee(n) {
    const o = `ibc/apps/fee/v1/channels/${n.channelId}/relayers/${n.relayer}/payee`;
    return await this.req.get(o);
  }
  /* CounterpartyPayee returns the registered counterparty payee for forward relaying */
  async counterpartyPayee(n) {
    const o = `ibc/apps/fee/v1/channels/${n.channelId}/relayers/${n.relayer}/counterparty_payee`;
    return await this.req.get(o);
  }
  /* FeeEnabledChannels returns a list of all fee enabled channels */
  async feeEnabledChannels(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination), typeof (n == null ? void 0 : n.queryHeight) < "u" && (o.params.query_height = n.queryHeight);
    const u = "ibc/apps/fee/v1/fee_enabled";
    return await this.req.get(u, o);
  }
  /* FeeEnabledChannel returns true if the provided port and channel identifiers belong to a fee enabled channel */
  async feeEnabledChannel(n) {
    const o = `ibc/apps/fee/v1/channels/${n.channelId}/ports/${n.portId}/fee_enabled`;
    return await this.req.get(o);
  }
};
const _241 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$o
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$n = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.interchainAccount = this.interchainAccount.bind(this), this.params = this.params.bind(this);
  }
  /* InterchainAccount returns the interchain account address for a given owner address on a given connection */
  async interchainAccount(n) {
    const o = `ibc/apps/interchain_accounts/controller/v1/owners/${n.owner}/connections/${n.connectionId}`;
    return await this.req.get(o);
  }
  /* Params queries all parameters of the ICA controller submodule. */
  async params(n = {}) {
    const o = "ibc/apps/interchain_accounts/controller/v1/params";
    return await this.req.get(o);
  }
};
const _242 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$n
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$m = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this);
  }
  /* Params queries all parameters of the ICA host submodule. */
  async params(n = {}) {
    const o = "ibc/apps/interchain_accounts/host/v1/params";
    return await this.req.get(o);
  }
};
const _243 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$m
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$l = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.denomTrace = this.denomTrace.bind(this), this.denomTraces = this.denomTraces.bind(this), this.params = this.params.bind(this), this.denomHash = this.denomHash.bind(this), this.escrowAddress = this.escrowAddress.bind(this);
  }
  /* DenomTrace queries a denomination trace information. */
  async denomTrace(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.hash) < "u" && (o.params.hash = n.hash);
    const u = `ibc/apps/transfer/v1/denom_traces/${n.hash}`;
    return await this.req.get(u, o);
  }
  /* DenomTraces queries all denomination traces. */
  async denomTraces(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "ibc/apps/transfer/v1/denom_traces";
    return await this.req.get(u, o);
  }
  /* Params queries all parameters of the ibc-transfer module. */
  async params(n = {}) {
    const o = "ibc/apps/transfer/v1/params";
    return await this.req.get(o);
  }
  /* DenomHash queries a denomination hash information. */
  async denomHash(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.trace) < "u" && (o.params.trace = n.trace);
    const u = `ibc/apps/transfer/v1/denom_hashes/${n.trace}`;
    return await this.req.get(u, o);
  }
  /* EscrowAddress returns the escrow address for a particular port and channel id. */
  async escrowAddress(n) {
    const o = `ibc/apps/transfer/v1/channels/${n.channelId}/ports/${n.portId}/escrow_address`;
    return await this.req.get(o);
  }
};
const _244 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$l
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$k = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.channel = this.channel.bind(this), this.channels = this.channels.bind(this), this.connectionChannels = this.connectionChannels.bind(this), this.channelClientState = this.channelClientState.bind(this), this.channelConsensusState = this.channelConsensusState.bind(this), this.packetCommitment = this.packetCommitment.bind(this), this.packetCommitments = this.packetCommitments.bind(this), this.packetReceipt = this.packetReceipt.bind(this), this.packetAcknowledgement = this.packetAcknowledgement.bind(this), this.packetAcknowledgements = this.packetAcknowledgements.bind(this), this.unreceivedPackets = this.unreceivedPackets.bind(this), this.unreceivedAcks = this.unreceivedAcks.bind(this), this.nextSequenceReceive = this.nextSequenceReceive.bind(this);
  }
  /* Channel queries an IBC Channel. */
  async channel(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}`;
    return await this.req.get(o);
  }
  /* Channels queries all the IBC channels of a chain. */
  async channels(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "ibc/core/channel/v1/channels";
    return await this.req.get(u, o);
  }
  /* ConnectionChannels queries all the channels associated with a connection
   end. */
  async connectionChannels(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `ibc/core/channel/v1/connections/${n.connection}/channels`;
    return await this.req.get(u, o);
  }
  /* ChannelClientState queries for the client state for the channel associated
   with the provided channel identifiers. */
  async channelClientState(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/client_state`;
    return await this.req.get(o);
  }
  /* ChannelConsensusState queries for the consensus state for the channel
   associated with the provided channel identifiers. */
  async channelConsensusState(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/consensus_state/revision/${n.revisionNumber}/height/${n.revisionHeight}`;
    return await this.req.get(o);
  }
  /* PacketCommitment queries a stored packet commitment hash. */
  async packetCommitment(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/packet_commitments/${n.sequence}`;
    return await this.req.get(o);
  }
  /* PacketCommitments returns all the packet commitments hashes associated
   with a channel. */
  async packetCommitments(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/packet_commitments`;
    return await this.req.get(u, o);
  }
  /* PacketReceipt queries if a given packet sequence has been received on the
   queried chain */
  async packetReceipt(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/packet_receipts/${n.sequence}`;
    return await this.req.get(o);
  }
  /* PacketAcknowledgement queries a stored packet acknowledgement hash. */
  async packetAcknowledgement(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/packet_acks/${n.sequence}`;
    return await this.req.get(o);
  }
  /* PacketAcknowledgements returns all the packet acknowledgements associated
   with a channel. */
  async packetAcknowledgements(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination), typeof (n == null ? void 0 : n.packetCommitmentSequences) < "u" && (o.params.packet_commitment_sequences = n.packetCommitmentSequences);
    const u = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/packet_acknowledgements`;
    return await this.req.get(u, o);
  }
  /* UnreceivedPackets returns all the unreceived IBC packets associated with a
   channel and sequences. */
  async unreceivedPackets(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/packet_commitments/${n.packetCommitmentSequences}/unreceived_packets`;
    return await this.req.get(o);
  }
  /* UnreceivedAcks returns all the unreceived IBC acknowledgements associated
   with a channel and sequences. */
  async unreceivedAcks(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/packet_commitments/${n.packetAckSequences}/unreceived_acks`;
    return await this.req.get(o);
  }
  /* NextSequenceReceive returns the next receive sequence for a given channel. */
  async nextSequenceReceive(n) {
    const o = `ibc/core/channel/v1/channels/${n.channelId}/ports/${n.portId}/next_sequence`;
    return await this.req.get(o);
  }
};
const _245 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$k
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$j = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.clientState = this.clientState.bind(this), this.clientStates = this.clientStates.bind(this), this.consensusState = this.consensusState.bind(this), this.consensusStates = this.consensusStates.bind(this), this.consensusStateHeights = this.consensusStateHeights.bind(this), this.clientStatus = this.clientStatus.bind(this), this.clientParams = this.clientParams.bind(this), this.upgradedClientState = this.upgradedClientState.bind(this), this.upgradedConsensusState = this.upgradedConsensusState.bind(this);
  }
  /* ClientState queries an IBC light client. */
  async clientState(n) {
    const o = `ibc/core/client/v1/client_states/${n.clientId}`;
    return await this.req.get(o);
  }
  /* ClientStates queries all the IBC light clients of a chain. */
  async clientStates(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "ibc/core/client/v1/client_states";
    return await this.req.get(u, o);
  }
  /* ConsensusState queries a consensus state associated with a client state at
   a given height. */
  async consensusState(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.latestHeight) < "u" && (o.params.latest_height = n.latestHeight);
    const u = `ibc/core/client/v1/consensus_states/${n.clientId}/revision/${n.revisionNumber}/height/${n.revisionHeight}`;
    return await this.req.get(u, o);
  }
  /* ConsensusStates queries all the consensus state associated with a given
   client. */
  async consensusStates(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `ibc/core/client/v1/consensus_states/${n.clientId}`;
    return await this.req.get(u, o);
  }
  /* ConsensusStateHeights queries the height of every consensus states associated with a given client. */
  async consensusStateHeights(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `ibc/core/client/v1/consensus_states/${n.clientId}/heights`;
    return await this.req.get(u, o);
  }
  /* Status queries the status of an IBC client. */
  async clientStatus(n) {
    const o = `ibc/core/client/v1/client_status/${n.clientId}`;
    return await this.req.get(o);
  }
  /* ClientParams queries all parameters of the ibc client submodule. */
  async clientParams(n = {}) {
    const o = "ibc/core/client/v1/params";
    return await this.req.get(o);
  }
  /* UpgradedClientState queries an Upgraded IBC light client. */
  async upgradedClientState(n = {}) {
    const o = "ibc/core/client/v1/upgraded_client_states";
    return await this.req.get(o);
  }
  /* UpgradedConsensusState queries an Upgraded IBC consensus state. */
  async upgradedConsensusState(n = {}) {
    const o = "ibc/core/client/v1/upgraded_consensus_states";
    return await this.req.get(o);
  }
};
const _246 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$j
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$i = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.connection = this.connection.bind(this), this.connections = this.connections.bind(this), this.clientConnections = this.clientConnections.bind(this), this.connectionClientState = this.connectionClientState.bind(this), this.connectionConsensusState = this.connectionConsensusState.bind(this), this.connectionParams = this.connectionParams.bind(this);
  }
  /* Connection queries an IBC connection end. */
  async connection(n) {
    const o = `ibc/core/connection/v1/connections/${n.connectionId}`;
    return await this.req.get(o);
  }
  /* Connections queries all the IBC connections of a chain. */
  async connections(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "ibc/core/connection/v1/connections";
    return await this.req.get(u, o);
  }
  /* ClientConnections queries the connection paths associated with a client
   state. */
  async clientConnections(n) {
    const o = `ibc/core/connection/v1/client_connections/${n.clientId}`;
    return await this.req.get(o);
  }
  /* ConnectionClientState queries the client state associated with the
   connection. */
  async connectionClientState(n) {
    const o = `ibc/core/connection/v1/connections/${n.connectionId}/client_state`;
    return await this.req.get(o);
  }
  /* ConnectionConsensusState queries the consensus state associated with the
   connection. */
  async connectionConsensusState(n) {
    const o = `ibc/core/connection/v1/connections/${n.connectionId}/consensus_state/revision/${n.revisionNumber}/height/${n.revisionHeight}`;
    return await this.req.get(o);
  }
  /* ConnectionParams queries all parameters of the ibc connection submodule. */
  async connectionParams(n = {}) {
    const o = "ibc/core/connection/v1/params";
    return await this.req.get(o);
  }
};
const _247 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$i
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$o = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.incentivizedPackets = this.incentivizedPackets.bind(this), this.incentivizedPacket = this.incentivizedPacket.bind(this), this.incentivizedPacketsForChannel = this.incentivizedPacketsForChannel.bind(this), this.totalRecvFees = this.totalRecvFees.bind(this), this.totalAckFees = this.totalAckFees.bind(this), this.totalTimeoutFees = this.totalTimeoutFees.bind(this), this.payee = this.payee.bind(this), this.counterpartyPayee = this.counterpartyPayee.bind(this), this.feeEnabledChannels = this.feeEnabledChannels.bind(this), this.feeEnabledChannel = this.feeEnabledChannel.bind(this);
  }
  incentivizedPackets(n) {
    const o = QueryIncentivizedPacketsRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "IncentivizedPackets", o).then((c) => QueryIncentivizedPacketsResponse.decode(new minimal.Reader(c)));
  }
  incentivizedPacket(n) {
    const o = QueryIncentivizedPacketRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "IncentivizedPacket", o).then((c) => QueryIncentivizedPacketResponse.decode(new minimal.Reader(c)));
  }
  incentivizedPacketsForChannel(n) {
    const o = QueryIncentivizedPacketsForChannelRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "IncentivizedPacketsForChannel", o).then((c) => QueryIncentivizedPacketsForChannelResponse.decode(new minimal.Reader(c)));
  }
  totalRecvFees(n) {
    const o = QueryTotalRecvFeesRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "TotalRecvFees", o).then((c) => QueryTotalRecvFeesResponse.decode(new minimal.Reader(c)));
  }
  totalAckFees(n) {
    const o = QueryTotalAckFeesRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "TotalAckFees", o).then((c) => QueryTotalAckFeesResponse.decode(new minimal.Reader(c)));
  }
  totalTimeoutFees(n) {
    const o = QueryTotalTimeoutFeesRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "TotalTimeoutFees", o).then((c) => QueryTotalTimeoutFeesResponse.decode(new minimal.Reader(c)));
  }
  payee(n) {
    const o = QueryPayeeRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "Payee", o).then((c) => QueryPayeeResponse.decode(new minimal.Reader(c)));
  }
  counterpartyPayee(n) {
    const o = QueryCounterpartyPayeeRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "CounterpartyPayee", o).then((c) => QueryCounterpartyPayeeResponse.decode(new minimal.Reader(c)));
  }
  feeEnabledChannels(n) {
    const o = QueryFeeEnabledChannelsRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "FeeEnabledChannels", o).then((c) => QueryFeeEnabledChannelsResponse.decode(new minimal.Reader(c)));
  }
  feeEnabledChannel(n) {
    const o = QueryFeeEnabledChannelRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Query", "FeeEnabledChannel", o).then((c) => QueryFeeEnabledChannelResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$o = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$o(n);
  return {
    incentivizedPackets(u) {
      return o.incentivizedPackets(u);
    },
    incentivizedPacket(u) {
      return o.incentivizedPacket(u);
    },
    incentivizedPacketsForChannel(u) {
      return o.incentivizedPacketsForChannel(u);
    },
    totalRecvFees(u) {
      return o.totalRecvFees(u);
    },
    totalAckFees(u) {
      return o.totalAckFees(u);
    },
    totalTimeoutFees(u) {
      return o.totalTimeoutFees(u);
    },
    payee(u) {
      return o.payee(u);
    },
    counterpartyPayee(u) {
      return o.counterpartyPayee(u);
    },
    feeEnabledChannels(u) {
      return o.feeEnabledChannels(u);
    },
    feeEnabledChannel(u) {
      return o.feeEnabledChannel(u);
    }
  };
}, _248 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$o,
  createRpcQueryExtension: createRpcQueryExtension$o
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$n = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.interchainAccount = this.interchainAccount.bind(this), this.params = this.params.bind(this);
  }
  interchainAccount(n) {
    const o = QueryInterchainAccountRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.interchain_accounts.controller.v1.Query", "InterchainAccount", o).then((c) => QueryInterchainAccountResponse.decode(new minimal.Reader(c)));
  }
  params(n = {}) {
    const o = QueryParamsRequest$9.encode(n).finish();
    return this.rpc.request("ibc.applications.interchain_accounts.controller.v1.Query", "Params", o).then((c) => QueryParamsResponse$9.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$n = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$n(n);
  return {
    interchainAccount(u) {
      return o.interchainAccount(u);
    },
    params(u) {
      return o.params(u);
    }
  };
}, _249 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$n,
  createRpcQueryExtension: createRpcQueryExtension$n
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$m = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this);
  }
  params(n = {}) {
    const o = QueryParamsRequest$8.encode(n).finish();
    return this.rpc.request("ibc.applications.interchain_accounts.host.v1.Query", "Params", o).then((c) => QueryParamsResponse$8.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$m = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$m(n);
  return {
    params(u) {
      return o.params(u);
    }
  };
}, _250 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$m,
  createRpcQueryExtension: createRpcQueryExtension$m
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$l = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.denomTrace = this.denomTrace.bind(this), this.denomTraces = this.denomTraces.bind(this), this.params = this.params.bind(this), this.denomHash = this.denomHash.bind(this), this.escrowAddress = this.escrowAddress.bind(this);
  }
  denomTrace(n) {
    const o = QueryDenomTraceRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", o).then((c) => QueryDenomTraceResponse.decode(new minimal.Reader(c)));
  }
  denomTraces(n = {
    pagination: void 0
  }) {
    const o = QueryDenomTracesRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", o).then((c) => QueryDenomTracesResponse.decode(new minimal.Reader(c)));
  }
  params(n = {}) {
    const o = QueryParamsRequest$7.encode(n).finish();
    return this.rpc.request("ibc.applications.transfer.v1.Query", "Params", o).then((c) => QueryParamsResponse$7.decode(new minimal.Reader(c)));
  }
  denomHash(n) {
    const o = QueryDenomHashRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", o).then((c) => QueryDenomHashResponse.decode(new minimal.Reader(c)));
  }
  escrowAddress(n) {
    const o = QueryEscrowAddressRequest.encode(n).finish();
    return this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", o).then((c) => QueryEscrowAddressResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$l = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$l(n);
  return {
    denomTrace(u) {
      return o.denomTrace(u);
    },
    denomTraces(u) {
      return o.denomTraces(u);
    },
    params(u) {
      return o.params(u);
    },
    denomHash(u) {
      return o.denomHash(u);
    },
    escrowAddress(u) {
      return o.escrowAddress(u);
    }
  };
}, _251 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$l,
  createRpcQueryExtension: createRpcQueryExtension$l
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$k = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.channel = this.channel.bind(this), this.channels = this.channels.bind(this), this.connectionChannels = this.connectionChannels.bind(this), this.channelClientState = this.channelClientState.bind(this), this.channelConsensusState = this.channelConsensusState.bind(this), this.packetCommitment = this.packetCommitment.bind(this), this.packetCommitments = this.packetCommitments.bind(this), this.packetReceipt = this.packetReceipt.bind(this), this.packetAcknowledgement = this.packetAcknowledgement.bind(this), this.packetAcknowledgements = this.packetAcknowledgements.bind(this), this.unreceivedPackets = this.unreceivedPackets.bind(this), this.unreceivedAcks = this.unreceivedAcks.bind(this), this.nextSequenceReceive = this.nextSequenceReceive.bind(this);
  }
  channel(n) {
    const o = QueryChannelRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "Channel", o).then((c) => QueryChannelResponse.decode(new minimal.Reader(c)));
  }
  channels(n = {
    pagination: void 0
  }) {
    const o = QueryChannelsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "Channels", o).then((c) => QueryChannelsResponse.decode(new minimal.Reader(c)));
  }
  connectionChannels(n) {
    const o = QueryConnectionChannelsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", o).then((c) => QueryConnectionChannelsResponse.decode(new minimal.Reader(c)));
  }
  channelClientState(n) {
    const o = QueryChannelClientStateRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", o).then((c) => QueryChannelClientStateResponse.decode(new minimal.Reader(c)));
  }
  channelConsensusState(n) {
    const o = QueryChannelConsensusStateRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", o).then((c) => QueryChannelConsensusStateResponse.decode(new minimal.Reader(c)));
  }
  packetCommitment(n) {
    const o = QueryPacketCommitmentRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", o).then((c) => QueryPacketCommitmentResponse.decode(new minimal.Reader(c)));
  }
  packetCommitments(n) {
    const o = QueryPacketCommitmentsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", o).then((c) => QueryPacketCommitmentsResponse.decode(new minimal.Reader(c)));
  }
  packetReceipt(n) {
    const o = QueryPacketReceiptRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", o).then((c) => QueryPacketReceiptResponse.decode(new minimal.Reader(c)));
  }
  packetAcknowledgement(n) {
    const o = QueryPacketAcknowledgementRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", o).then((c) => QueryPacketAcknowledgementResponse.decode(new minimal.Reader(c)));
  }
  packetAcknowledgements(n) {
    const o = QueryPacketAcknowledgementsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", o).then((c) => QueryPacketAcknowledgementsResponse.decode(new minimal.Reader(c)));
  }
  unreceivedPackets(n) {
    const o = QueryUnreceivedPacketsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", o).then((c) => QueryUnreceivedPacketsResponse.decode(new minimal.Reader(c)));
  }
  unreceivedAcks(n) {
    const o = QueryUnreceivedAcksRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", o).then((c) => QueryUnreceivedAcksResponse.decode(new minimal.Reader(c)));
  }
  nextSequenceReceive(n) {
    const o = QueryNextSequenceReceiveRequest.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", o).then((c) => QueryNextSequenceReceiveResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$k = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$k(n);
  return {
    channel(u) {
      return o.channel(u);
    },
    channels(u) {
      return o.channels(u);
    },
    connectionChannels(u) {
      return o.connectionChannels(u);
    },
    channelClientState(u) {
      return o.channelClientState(u);
    },
    channelConsensusState(u) {
      return o.channelConsensusState(u);
    },
    packetCommitment(u) {
      return o.packetCommitment(u);
    },
    packetCommitments(u) {
      return o.packetCommitments(u);
    },
    packetReceipt(u) {
      return o.packetReceipt(u);
    },
    packetAcknowledgement(u) {
      return o.packetAcknowledgement(u);
    },
    packetAcknowledgements(u) {
      return o.packetAcknowledgements(u);
    },
    unreceivedPackets(u) {
      return o.unreceivedPackets(u);
    },
    unreceivedAcks(u) {
      return o.unreceivedAcks(u);
    },
    nextSequenceReceive(u) {
      return o.nextSequenceReceive(u);
    }
  };
}, _252 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$k,
  createRpcQueryExtension: createRpcQueryExtension$k
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$j = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.clientState = this.clientState.bind(this), this.clientStates = this.clientStates.bind(this), this.consensusState = this.consensusState.bind(this), this.consensusStates = this.consensusStates.bind(this), this.consensusStateHeights = this.consensusStateHeights.bind(this), this.clientStatus = this.clientStatus.bind(this), this.clientParams = this.clientParams.bind(this), this.upgradedClientState = this.upgradedClientState.bind(this), this.upgradedConsensusState = this.upgradedConsensusState.bind(this);
  }
  clientState(n) {
    const o = QueryClientStateRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "ClientState", o).then((c) => QueryClientStateResponse.decode(new minimal.Reader(c)));
  }
  clientStates(n = {
    pagination: void 0
  }) {
    const o = QueryClientStatesRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "ClientStates", o).then((c) => QueryClientStatesResponse.decode(new minimal.Reader(c)));
  }
  consensusState(n) {
    const o = QueryConsensusStateRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", o).then((c) => QueryConsensusStateResponse.decode(new minimal.Reader(c)));
  }
  consensusStates(n) {
    const o = QueryConsensusStatesRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", o).then((c) => QueryConsensusStatesResponse.decode(new minimal.Reader(c)));
  }
  consensusStateHeights(n) {
    const o = QueryConsensusStateHeightsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", o).then((c) => QueryConsensusStateHeightsResponse.decode(new minimal.Reader(c)));
  }
  clientStatus(n) {
    const o = QueryClientStatusRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", o).then((c) => QueryClientStatusResponse.decode(new minimal.Reader(c)));
  }
  clientParams(n = {}) {
    const o = QueryClientParamsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "ClientParams", o).then((c) => QueryClientParamsResponse.decode(new minimal.Reader(c)));
  }
  upgradedClientState(n = {}) {
    const o = QueryUpgradedClientStateRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", o).then((c) => QueryUpgradedClientStateResponse.decode(new minimal.Reader(c)));
  }
  upgradedConsensusState(n = {}) {
    const o = QueryUpgradedConsensusStateRequest.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", o).then((c) => QueryUpgradedConsensusStateResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$j = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$j(n);
  return {
    clientState(u) {
      return o.clientState(u);
    },
    clientStates(u) {
      return o.clientStates(u);
    },
    consensusState(u) {
      return o.consensusState(u);
    },
    consensusStates(u) {
      return o.consensusStates(u);
    },
    consensusStateHeights(u) {
      return o.consensusStateHeights(u);
    },
    clientStatus(u) {
      return o.clientStatus(u);
    },
    clientParams(u) {
      return o.clientParams(u);
    },
    upgradedClientState(u) {
      return o.upgradedClientState(u);
    },
    upgradedConsensusState(u) {
      return o.upgradedConsensusState(u);
    }
  };
}, _253 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$j,
  createRpcQueryExtension: createRpcQueryExtension$j
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$i = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.connection = this.connection.bind(this), this.connections = this.connections.bind(this), this.clientConnections = this.clientConnections.bind(this), this.connectionClientState = this.connectionClientState.bind(this), this.connectionConsensusState = this.connectionConsensusState.bind(this), this.connectionParams = this.connectionParams.bind(this);
  }
  connection(n) {
    const o = QueryConnectionRequest.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Query", "Connection", o).then((c) => QueryConnectionResponse.decode(new minimal.Reader(c)));
  }
  connections(n = {
    pagination: void 0
  }) {
    const o = QueryConnectionsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Query", "Connections", o).then((c) => QueryConnectionsResponse.decode(new minimal.Reader(c)));
  }
  clientConnections(n) {
    const o = QueryClientConnectionsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", o).then((c) => QueryClientConnectionsResponse.decode(new minimal.Reader(c)));
  }
  connectionClientState(n) {
    const o = QueryConnectionClientStateRequest.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", o).then((c) => QueryConnectionClientStateResponse.decode(new minimal.Reader(c)));
  }
  connectionConsensusState(n) {
    const o = QueryConnectionConsensusStateRequest.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", o).then((c) => QueryConnectionConsensusStateResponse.decode(new minimal.Reader(c)));
  }
  connectionParams(n = {}) {
    const o = QueryConnectionParamsRequest.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", o).then((c) => QueryConnectionParamsResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$i = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$i(n);
  return {
    connection(u) {
      return o.connection(u);
    },
    connections(u) {
      return o.connections(u);
    },
    clientConnections(u) {
      return o.clientConnections(u);
    },
    connectionClientState(u) {
      return o.connectionClientState(u);
    },
    connectionConsensusState(u) {
      return o.connectionConsensusState(u);
    },
    connectionParams(u) {
      return o.connectionParams(u);
    }
  };
}, _254 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$i,
  createRpcQueryExtension: createRpcQueryExtension$i
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$g = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.registerPayee = this.registerPayee.bind(this), this.registerCounterpartyPayee = this.registerCounterpartyPayee.bind(this), this.payPacketFee = this.payPacketFee.bind(this), this.payPacketFeeAsync = this.payPacketFeeAsync.bind(this);
  }
  registerPayee(n) {
    const o = MsgRegisterPayee.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Msg", "RegisterPayee", o).then((c) => MsgRegisterPayeeResponse.decode(new minimal.Reader(c)));
  }
  registerCounterpartyPayee(n) {
    const o = MsgRegisterCounterpartyPayee.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Msg", "RegisterCounterpartyPayee", o).then((c) => MsgRegisterCounterpartyPayeeResponse.decode(new minimal.Reader(c)));
  }
  payPacketFee(n) {
    const o = MsgPayPacketFee.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Msg", "PayPacketFee", o).then((c) => MsgPayPacketFeeResponse.decode(new minimal.Reader(c)));
  }
  payPacketFeeAsync(n) {
    const o = MsgPayPacketFeeAsync.encode(n).finish();
    return this.rpc.request("ibc.applications.fee.v1.Msg", "PayPacketFeeAsync", o).then((c) => MsgPayPacketFeeAsyncResponse.decode(new minimal.Reader(c)));
  }
};
const _255 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$g
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$f = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.registerInterchainAccount = this.registerInterchainAccount.bind(this), this.sendTx = this.sendTx.bind(this);
  }
  registerInterchainAccount(n) {
    const o = MsgRegisterInterchainAccount.encode(n).finish();
    return this.rpc.request("ibc.applications.interchain_accounts.controller.v1.Msg", "RegisterInterchainAccount", o).then((c) => MsgRegisterInterchainAccountResponse.decode(new minimal.Reader(c)));
  }
  sendTx(n) {
    const o = MsgSendTx.encode(n).finish();
    return this.rpc.request("ibc.applications.interchain_accounts.controller.v1.Msg", "SendTx", o).then((c) => MsgSendTxResponse.decode(new minimal.Reader(c)));
  }
};
const _256 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$f
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$e = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.transfer = this.transfer.bind(this);
  }
  transfer(n) {
    const o = MsgTransfer.encode(n).finish();
    return this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", o).then((c) => MsgTransferResponse.decode(new minimal.Reader(c)));
  }
};
const _257 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$e
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$d = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.channelOpenInit = this.channelOpenInit.bind(this), this.channelOpenTry = this.channelOpenTry.bind(this), this.channelOpenAck = this.channelOpenAck.bind(this), this.channelOpenConfirm = this.channelOpenConfirm.bind(this), this.channelCloseInit = this.channelCloseInit.bind(this), this.channelCloseConfirm = this.channelCloseConfirm.bind(this), this.recvPacket = this.recvPacket.bind(this), this.timeout = this.timeout.bind(this), this.timeoutOnClose = this.timeoutOnClose.bind(this), this.acknowledgement = this.acknowledgement.bind(this);
  }
  channelOpenInit(n) {
    const o = MsgChannelOpenInit.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", o).then((c) => MsgChannelOpenInitResponse.decode(new minimal.Reader(c)));
  }
  channelOpenTry(n) {
    const o = MsgChannelOpenTry.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", o).then((c) => MsgChannelOpenTryResponse.decode(new minimal.Reader(c)));
  }
  channelOpenAck(n) {
    const o = MsgChannelOpenAck.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", o).then((c) => MsgChannelOpenAckResponse.decode(new minimal.Reader(c)));
  }
  channelOpenConfirm(n) {
    const o = MsgChannelOpenConfirm.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", o).then((c) => MsgChannelOpenConfirmResponse.decode(new minimal.Reader(c)));
  }
  channelCloseInit(n) {
    const o = MsgChannelCloseInit.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", o).then((c) => MsgChannelCloseInitResponse.decode(new minimal.Reader(c)));
  }
  channelCloseConfirm(n) {
    const o = MsgChannelCloseConfirm.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", o).then((c) => MsgChannelCloseConfirmResponse.decode(new minimal.Reader(c)));
  }
  recvPacket(n) {
    const o = MsgRecvPacket.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", o).then((c) => MsgRecvPacketResponse.decode(new minimal.Reader(c)));
  }
  timeout(n) {
    const o = MsgTimeout.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", o).then((c) => MsgTimeoutResponse.decode(new minimal.Reader(c)));
  }
  timeoutOnClose(n) {
    const o = MsgTimeoutOnClose.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", o).then((c) => MsgTimeoutOnCloseResponse.decode(new minimal.Reader(c)));
  }
  acknowledgement(n) {
    const o = MsgAcknowledgement.encode(n).finish();
    return this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", o).then((c) => MsgAcknowledgementResponse.decode(new minimal.Reader(c)));
  }
};
const _258 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$d
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$c = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.createClient = this.createClient.bind(this), this.updateClient = this.updateClient.bind(this), this.upgradeClient = this.upgradeClient.bind(this), this.submitMisbehaviour = this.submitMisbehaviour.bind(this);
  }
  createClient(n) {
    const o = MsgCreateClient.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", o).then((c) => MsgCreateClientResponse.decode(new minimal.Reader(c)));
  }
  updateClient(n) {
    const o = MsgUpdateClient.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", o).then((c) => MsgUpdateClientResponse.decode(new minimal.Reader(c)));
  }
  upgradeClient(n) {
    const o = MsgUpgradeClient.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", o).then((c) => MsgUpgradeClientResponse.decode(new minimal.Reader(c)));
  }
  submitMisbehaviour(n) {
    const o = MsgSubmitMisbehaviour.encode(n).finish();
    return this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", o).then((c) => MsgSubmitMisbehaviourResponse.decode(new minimal.Reader(c)));
  }
};
const _259 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$c
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$b = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.connectionOpenInit = this.connectionOpenInit.bind(this), this.connectionOpenTry = this.connectionOpenTry.bind(this), this.connectionOpenAck = this.connectionOpenAck.bind(this), this.connectionOpenConfirm = this.connectionOpenConfirm.bind(this);
  }
  connectionOpenInit(n) {
    const o = MsgConnectionOpenInit.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", o).then((c) => MsgConnectionOpenInitResponse.decode(new minimal.Reader(c)));
  }
  connectionOpenTry(n) {
    const o = MsgConnectionOpenTry.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", o).then((c) => MsgConnectionOpenTryResponse.decode(new minimal.Reader(c)));
  }
  connectionOpenAck(n) {
    const o = MsgConnectionOpenAck.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", o).then((c) => MsgConnectionOpenAckResponse.decode(new minimal.Reader(c)));
  }
  connectionOpenConfirm(n) {
    const o = MsgConnectionOpenConfirm.encode(n).finish();
    return this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", o).then((c) => MsgConnectionOpenConfirmResponse.decode(new minimal.Reader(c)));
  }
};
const _260 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$b
}, Symbol.toStringTag, { value: "Module" })), createLCDClient$2 = async ({
  restEndpoint: e
}) => {
  const n = new LCDClient({
    restEndpoint: e
  });
  return {
    cosmos: {
      auth: {
        v1beta1: new (await Promise.resolve().then(() => _202)).LCDQueryClient({
          requestClient: n
        })
      },
      authz: {
        v1beta1: new (await Promise.resolve().then(() => _203)).LCDQueryClient({
          requestClient: n
        })
      },
      bank: {
        v1beta1: new (await Promise.resolve().then(() => _204)).LCDQueryClient({
          requestClient: n
        })
      },
      base: {
        node: {
          v1beta1: new (await Promise.resolve().then(() => _205)).LCDQueryClient({
            requestClient: n
          })
        }
      },
      distribution: {
        v1beta1: new (await Promise.resolve().then(() => _206)).LCDQueryClient({
          requestClient: n
        })
      },
      gov: {
        v1beta1: new (await Promise.resolve().then(() => _207)).LCDQueryClient({
          requestClient: n
        }),
        v1: new (await Promise.resolve().then(() => _211)).LCDQueryClient({
          requestClient: n
        })
      },
      staking: {
        v1beta1: new (await Promise.resolve().then(() => _208)).LCDQueryClient({
          requestClient: n
        })
      },
      tx: {
        v1beta1: new (await Promise.resolve().then(() => _209)).LCDQueryClient({
          requestClient: n
        })
      },
      upgrade: {
        v1beta1: new (await Promise.resolve().then(() => _210)).LCDQueryClient({
          requestClient: n
        })
      }
    },
    ibc: {
      applications: {
        fee: {
          v1: new (await Promise.resolve().then(() => _241)).LCDQueryClient({
            requestClient: n
          })
        },
        interchain_accounts: {
          controller: {
            v1: new (await Promise.resolve().then(() => _242)).LCDQueryClient({
              requestClient: n
            })
          },
          host: {
            v1: new (await Promise.resolve().then(() => _243)).LCDQueryClient({
              requestClient: n
            })
          }
        },
        transfer: {
          v1: new (await Promise.resolve().then(() => _244)).LCDQueryClient({
            requestClient: n
          })
        }
      },
      core: {
        channel: {
          v1: new (await Promise.resolve().then(() => _245)).LCDQueryClient({
            requestClient: n
          })
        },
        client: {
          v1: new (await Promise.resolve().then(() => _246)).LCDQueryClient({
            requestClient: n
          })
        },
        connection: {
          v1: new (await Promise.resolve().then(() => _247)).LCDQueryClient({
            requestClient: n
          })
        }
      }
    }
  };
}, _338 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createLCDClient: createLCDClient$2
}, Symbol.toStringTag, { value: "Module" })), createRPCQueryClient$2 = async ({
  rpcEndpoint: e
}) => {
  const n = await build$2.Tendermint34Client.connect(e), o = new build$5.QueryClient(n);
  return {
    cosmos: {
      auth: {
        v1beta1: (await Promise.resolve().then(() => _212)).createRpcQueryExtension(o)
      },
      authz: {
        v1beta1: (await Promise.resolve().then(() => _213)).createRpcQueryExtension(o)
      },
      bank: {
        v1beta1: (await Promise.resolve().then(() => _214)).createRpcQueryExtension(o)
      },
      base: {
        node: {
          v1beta1: (await Promise.resolve().then(() => _215)).createRpcQueryExtension(o)
        }
      },
      distribution: {
        v1beta1: (await Promise.resolve().then(() => _216)).createRpcQueryExtension(o)
      },
      gov: {
        v1beta1: (await Promise.resolve().then(() => _217)).createRpcQueryExtension(o),
        v1: (await Promise.resolve().then(() => _221)).createRpcQueryExtension(o)
      },
      staking: {
        v1beta1: (await Promise.resolve().then(() => _218)).createRpcQueryExtension(o)
      },
      tx: {
        v1beta1: (await Promise.resolve().then(() => _219)).createRpcQueryExtension(o)
      },
      upgrade: {
        v1beta1: (await Promise.resolve().then(() => _220)).createRpcQueryExtension(o)
      }
    },
    ibc: {
      applications: {
        fee: {
          v1: (await Promise.resolve().then(() => _248)).createRpcQueryExtension(o)
        },
        interchain_accounts: {
          controller: {
            v1: (await Promise.resolve().then(() => _249)).createRpcQueryExtension(o)
          },
          host: {
            v1: (await Promise.resolve().then(() => _250)).createRpcQueryExtension(o)
          }
        },
        transfer: {
          v1: (await Promise.resolve().then(() => _251)).createRpcQueryExtension(o)
        }
      },
      core: {
        channel: {
          v1: (await Promise.resolve().then(() => _252)).createRpcQueryExtension(o)
        },
        client: {
          v1: (await Promise.resolve().then(() => _253)).createRpcQueryExtension(o)
        },
        connection: {
          v1: (await Promise.resolve().then(() => _254)).createRpcQueryExtension(o)
        }
      }
    }
  };
}, _339 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRPCQueryClient: createRPCQueryClient$2
}, Symbol.toStringTag, { value: "Module" })), createRPCMsgClient$2 = async ({
  rpc: e
}) => ({
  cosmos: {
    authz: {
      v1beta1: new (await Promise.resolve().then(() => _222)).MsgClientImpl(e)
    },
    bank: {
      v1beta1: new (await Promise.resolve().then(() => _223)).MsgClientImpl(e)
    },
    distribution: {
      v1beta1: new (await Promise.resolve().then(() => _224)).MsgClientImpl(e)
    },
    gov: {
      v1beta1: new (await Promise.resolve().then(() => _225)).MsgClientImpl(e),
      v1: new (await Promise.resolve().then(() => _227)).MsgClientImpl(e)
    },
    staking: {
      v1beta1: new (await Promise.resolve().then(() => _226)).MsgClientImpl(e)
    },
    upgrade: {
      v1beta1: new (await Promise.resolve().then(() => _228)).MsgClientImpl(e)
    }
  },
  ibc: {
    applications: {
      fee: {
        v1: new (await Promise.resolve().then(() => _255)).MsgClientImpl(e)
      },
      interchain_accounts: {
        controller: {
          v1: new (await Promise.resolve().then(() => _256)).MsgClientImpl(e)
        }
      },
      transfer: {
        v1: new (await Promise.resolve().then(() => _257)).MsgClientImpl(e)
      }
    },
    core: {
      channel: {
        v1: new (await Promise.resolve().then(() => _258)).MsgClientImpl(e)
      },
      client: {
        v1: new (await Promise.resolve().then(() => _259)).MsgClientImpl(e)
      },
      connection: {
        v1: new (await Promise.resolve().then(() => _260)).MsgClientImpl(e)
      }
    }
  }
}), _340 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRPCMsgClient: createRPCMsgClient$2
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$9(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$9(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$9(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$9(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
let ibc;
(function(e) {
  let n;
  (function(c) {
    let d;
    (function(S) {
      S.v1 = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, _62), _63), _64), _65), _66), _67), _229), _235), _241), _248), _255);
    })(d || (d = c.fee || (c.fee = {})));
    let m;
    (function(S) {
      let $;
      (function(T) {
        T.v1 = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, _68), _69), _70), _230), _236), _242), _249), _256);
      })($ || ($ = S.controller || (S.controller = {})));
      let E;
      (function(T) {
        T.v1 = _objectSpread$9({}, _71);
      })(E || (E = S.genesis || (S.genesis = {})));
      let O;
      (function(T) {
        T.v1 = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, _72), _73), _243), _250);
      })(O || (O = S.host || (S.host = {}))), S.v1 = _objectSpread$9(_objectSpread$9(_objectSpread$9({}, _74), _75), _76);
    })(m || (m = c.interchain_accounts || (c.interchain_accounts = {})));
    let v;
    (function(S) {
      S.v1 = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, _77), _78), _79), _80), _81), _231), _237), _244), _251), _257), S.v2 = _objectSpread$9({}, _82);
    })(v || (v = c.transfer || (c.transfer = {})));
  })(n || (n = e.applications || (e.applications = {})));
  let o;
  (function(c) {
    let d;
    (function($) {
      $.v1 = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, _83), _84), _85), _86), _232), _238), _245), _252), _258);
    })(d || (d = c.channel || (c.channel = {})));
    let m;
    (function($) {
      $.v1 = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, _87), _88), _89), _90), _233), _239), _246), _253), _259);
    })(m || (m = c.client || (c.client = {})));
    let v;
    (function($) {
      $.v1 = _objectSpread$9({}, _91);
    })(v || (v = c.commitment || (c.commitment = {})));
    let S;
    (function($) {
      $.v1 = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, _92), _93), _94), _95), _234), _240), _247), _254), _260);
    })(S || (S = c.connection || (c.connection = {})));
  })(o || (o = e.core || (e.core = {})));
  let u;
  (function(c) {
    let d;
    (function(S) {
      S.v2 = _objectSpread$9({}, _96);
    })(d || (d = c.localhost || (c.localhost = {})));
    let m;
    (function(S) {
      S.v2 = _objectSpread$9({}, _97), S.v3 = _objectSpread$9({}, _98);
    })(m || (m = c.solomachine || (c.solomachine = {})));
    let v;
    (function(S) {
      S.v1 = _objectSpread$9({}, _99);
    })(v || (v = c.tendermint || (c.tendermint = {})));
  })(u || (u = e.lightclients || (e.lightclients = {}))), e.ClientFactory = _objectSpread$9(_objectSpread$9(_objectSpread$9({}, _338), _339), _340);
})(ibc || (ibc = {}));
function ownKeys$8(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$8(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$8(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$8(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
_objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8({}, AminoConverter$h), AminoConverter$g), AminoConverter$f), AminoConverter$e), AminoConverter$d), AminoConverter$c);
[...registry$i, ...registry$h, ...registry$g, ...registry$f, ...registry$e, ...registry$d];
function createBaseContractExecutionAuthorization() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.ContractExecutionAuthorization",
    grants: []
  };
}
const ContractExecutionAuthorization = {
  typeUrl: "/cosmwasm.wasm.v1.ContractExecutionAuthorization",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.grants)
      ContractGrant.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseContractExecutionAuthorization();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.grants.push(ContractGrant.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseContractExecutionAuthorization();
    return o.grants = ((n = e.grants) === null || n === void 0 ? void 0 : n.map((u) => ContractGrant.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      grants: Array.isArray(e == null ? void 0 : e.grants) ? e.grants.map((n) => ContractGrant.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.grants ? n.grants = e.grants.map((o) => o ? ContractGrant.toAmino(o) : void 0) : n.grants = [], n;
  },
  fromAminoMsg(e) {
    return ContractExecutionAuthorization.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/ContractExecutionAuthorization",
      value: ContractExecutionAuthorization.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ContractExecutionAuthorization.decode(e.value);
  },
  toProto(e) {
    return ContractExecutionAuthorization.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractExecutionAuthorization",
      value: ContractExecutionAuthorization.encode(e).finish()
    };
  }
};
function createBaseContractMigrationAuthorization() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.ContractMigrationAuthorization",
    grants: []
  };
}
const ContractMigrationAuthorization = {
  typeUrl: "/cosmwasm.wasm.v1.ContractMigrationAuthorization",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.grants)
      ContractGrant.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseContractMigrationAuthorization();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.grants.push(ContractGrant.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseContractMigrationAuthorization();
    return o.grants = ((n = e.grants) === null || n === void 0 ? void 0 : n.map((u) => ContractGrant.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      grants: Array.isArray(e == null ? void 0 : e.grants) ? e.grants.map((n) => ContractGrant.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.grants ? n.grants = e.grants.map((o) => o ? ContractGrant.toAmino(o) : void 0) : n.grants = [], n;
  },
  fromAminoMsg(e) {
    return ContractMigrationAuthorization.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/ContractMigrationAuthorization",
      value: ContractMigrationAuthorization.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ContractMigrationAuthorization.decode(e.value);
  },
  toProto(e) {
    return ContractMigrationAuthorization.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractMigrationAuthorization",
      value: ContractMigrationAuthorization.encode(e).finish()
    };
  }
};
function createBaseContractGrant() {
  return {
    contract: "",
    limit: void 0,
    filter: void 0
  };
}
const ContractGrant = {
  typeUrl: "/cosmwasm.wasm.v1.ContractGrant",
  encode(e, n = minimal.Writer.create()) {
    return e.contract !== "" && n.uint32(10).string(e.contract), e.limit !== void 0 && Any.encode(e.limit, n.uint32(18).fork()).ldelim(), e.filter !== void 0 && Any.encode(e.filter, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseContractGrant();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.contract = o.string();
          break;
        case 2:
          c.limit = Cosmwasm_wasmv1ContractAuthzLimitX_InterfaceDecoder(o);
          break;
        case 3:
          c.filter = Cosmwasm_wasmv1ContractAuthzFilterX_InterfaceDecoder(o);
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseContractGrant();
    return o.contract = (n = e.contract) !== null && n !== void 0 ? n : "", o.limit = e.limit !== void 0 && e.limit !== null ? Any.fromPartial(e.limit) : void 0, o.filter = e.filter !== void 0 && e.filter !== null ? Any.fromPartial(e.filter) : void 0, o;
  },
  fromAmino(e) {
    return {
      contract: e.contract,
      limit: e != null && e.limit ? Cosmwasm_wasmv1ContractAuthzLimitX_FromAmino(e.limit) : void 0,
      filter: e != null && e.filter ? Cosmwasm_wasmv1ContractAuthzFilterX_FromAmino(e.filter) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.contract = e.contract, n.limit = e.limit ? Cosmwasm_wasmv1ContractAuthzLimitX_ToAmino(e.limit) : void 0, n.filter = e.filter ? Cosmwasm_wasmv1ContractAuthzFilterX_ToAmino(e.filter) : void 0, n;
  },
  fromAminoMsg(e) {
    return ContractGrant.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/ContractGrant",
      value: ContractGrant.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ContractGrant.decode(e.value);
  },
  toProto(e) {
    return ContractGrant.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractGrant",
      value: ContractGrant.encode(e).finish()
    };
  }
};
function createBaseMaxCallsLimit() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.MaxCallsLimit",
    remaining: Long$2.UZERO
  };
}
const MaxCallsLimit = {
  typeUrl: "/cosmwasm.wasm.v1.MaxCallsLimit",
  encode(e, n = minimal.Writer.create()) {
    return e.remaining.isZero() || n.uint32(8).uint64(e.remaining), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMaxCallsLimit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.remaining = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMaxCallsLimit();
    return n.remaining = e.remaining !== void 0 && e.remaining !== null ? Long$2.fromValue(e.remaining) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      remaining: Long$2.fromString(e.remaining)
    };
  },
  toAmino(e) {
    const n = {};
    return n.remaining = e.remaining ? e.remaining.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MaxCallsLimit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MaxCallsLimit",
      value: MaxCallsLimit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MaxCallsLimit.decode(e.value);
  },
  toProto(e) {
    return MaxCallsLimit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MaxCallsLimit",
      value: MaxCallsLimit.encode(e).finish()
    };
  }
};
function createBaseMaxFundsLimit() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",
    amounts: []
  };
}
const MaxFundsLimit = {
  typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.amounts)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMaxFundsLimit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amounts.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMaxFundsLimit();
    return o.amounts = ((n = e.amounts) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      amounts: Array.isArray(e == null ? void 0 : e.amounts) ? e.amounts.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.amounts ? n.amounts = e.amounts.map((o) => o ? Coin.toAmino(o) : void 0) : n.amounts = [], n;
  },
  fromAminoMsg(e) {
    return MaxFundsLimit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MaxFundsLimit",
      value: MaxFundsLimit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MaxFundsLimit.decode(e.value);
  },
  toProto(e) {
    return MaxFundsLimit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",
      value: MaxFundsLimit.encode(e).finish()
    };
  }
};
function createBaseCombinedLimit() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.CombinedLimit",
    callsRemaining: Long$2.UZERO,
    amounts: []
  };
}
const CombinedLimit = {
  typeUrl: "/cosmwasm.wasm.v1.CombinedLimit",
  encode(e, n = minimal.Writer.create()) {
    e.callsRemaining.isZero() || n.uint32(8).uint64(e.callsRemaining);
    for (const o of e.amounts)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCombinedLimit();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.callsRemaining = o.uint64();
          break;
        case 2:
          c.amounts.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseCombinedLimit();
    return o.callsRemaining = e.callsRemaining !== void 0 && e.callsRemaining !== null ? Long$2.fromValue(e.callsRemaining) : Long$2.UZERO, o.amounts = ((n = e.amounts) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      callsRemaining: Long$2.fromString(e.calls_remaining),
      amounts: Array.isArray(e == null ? void 0 : e.amounts) ? e.amounts.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.calls_remaining = e.callsRemaining ? e.callsRemaining.toString() : void 0, e.amounts ? n.amounts = e.amounts.map((o) => o ? Coin.toAmino(o) : void 0) : n.amounts = [], n;
  },
  fromAminoMsg(e) {
    return CombinedLimit.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/CombinedLimit",
      value: CombinedLimit.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CombinedLimit.decode(e.value);
  },
  toProto(e) {
    return CombinedLimit.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.CombinedLimit",
      value: CombinedLimit.encode(e).finish()
    };
  }
};
function createBaseAllowAllMessagesFilter() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.AllowAllMessagesFilter"
  };
}
const AllowAllMessagesFilter = {
  typeUrl: "/cosmwasm.wasm.v1.AllowAllMessagesFilter",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAllowAllMessagesFilter();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseAllowAllMessagesFilter();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return AllowAllMessagesFilter.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/AllowAllMessagesFilter",
      value: AllowAllMessagesFilter.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AllowAllMessagesFilter.decode(e.value);
  },
  toProto(e) {
    return AllowAllMessagesFilter.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AllowAllMessagesFilter",
      value: AllowAllMessagesFilter.encode(e).finish()
    };
  }
};
function createBaseAcceptedMessageKeysFilter() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",
    keys: []
  };
}
const AcceptedMessageKeysFilter = {
  typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.keys)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAcceptedMessageKeysFilter();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.keys.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAcceptedMessageKeysFilter();
    return o.keys = ((n = e.keys) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      keys: Array.isArray(e == null ? void 0 : e.keys) ? e.keys.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.keys ? n.keys = e.keys.map((o) => o) : n.keys = [], n;
  },
  fromAminoMsg(e) {
    return AcceptedMessageKeysFilter.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/AcceptedMessageKeysFilter",
      value: AcceptedMessageKeysFilter.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AcceptedMessageKeysFilter.decode(e.value);
  },
  toProto(e) {
    return AcceptedMessageKeysFilter.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",
      value: AcceptedMessageKeysFilter.encode(e).finish()
    };
  }
};
function createBaseAcceptedMessagesFilter() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.AcceptedMessagesFilter",
    messages: []
  };
}
const AcceptedMessagesFilter = {
  typeUrl: "/cosmwasm.wasm.v1.AcceptedMessagesFilter",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.messages)
      n.uint32(10).bytes(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAcceptedMessagesFilter();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.messages.push(o.bytes());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAcceptedMessagesFilter();
    return o.messages = ((n = e.messages) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      messages: Array.isArray(e == null ? void 0 : e.messages) ? e.messages.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.messages ? n.messages = e.messages.map((o) => o) : n.messages = [], n;
  },
  fromAminoMsg(e) {
    return AcceptedMessagesFilter.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/AcceptedMessagesFilter",
      value: AcceptedMessagesFilter.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AcceptedMessagesFilter.decode(e.value);
  },
  toProto(e) {
    return AcceptedMessagesFilter.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AcceptedMessagesFilter",
      value: AcceptedMessagesFilter.encode(e).finish()
    };
  }
}, Cosmwasm_wasmv1ContractAuthzLimitX_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/cosmwasm.wasm.v1.MaxCallsLimit":
      return MaxCallsLimit.decode(o.value);
    case "/cosmwasm.wasm.v1.MaxFundsLimit":
      return MaxFundsLimit.decode(o.value);
    case "/cosmwasm.wasm.v1.CombinedLimit":
      return CombinedLimit.decode(o.value);
    default:
      return o;
  }
}, Cosmwasm_wasmv1ContractAuthzLimitX_FromAmino = (e) => {
  switch (e.type) {
    case "wasm/MaxCallsLimit":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MaxCallsLimit",
        value: MaxCallsLimit.encode(MaxCallsLimit.fromPartial(MaxCallsLimit.fromAmino(e.value))).finish()
      });
    case "wasm/MaxFundsLimit":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",
        value: MaxFundsLimit.encode(MaxFundsLimit.fromPartial(MaxFundsLimit.fromAmino(e.value))).finish()
      });
    case "wasm/CombinedLimit":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.CombinedLimit",
        value: CombinedLimit.encode(CombinedLimit.fromPartial(CombinedLimit.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, Cosmwasm_wasmv1ContractAuthzLimitX_ToAmino = (e) => {
  switch (e.typeUrl) {
    case "/cosmwasm.wasm.v1.MaxCallsLimit":
      return {
        type: "wasm/MaxCallsLimit",
        value: MaxCallsLimit.toAmino(MaxCallsLimit.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.MaxFundsLimit":
      return {
        type: "wasm/MaxFundsLimit",
        value: MaxFundsLimit.toAmino(MaxFundsLimit.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.CombinedLimit":
      return {
        type: "wasm/CombinedLimit",
        value: CombinedLimit.toAmino(CombinedLimit.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, Cosmwasm_wasmv1ContractAuthzFilterX_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/cosmwasm.wasm.v1.AllowAllMessagesFilter":
      return AllowAllMessagesFilter.decode(o.value);
    case "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter":
      return AcceptedMessageKeysFilter.decode(o.value);
    case "/cosmwasm.wasm.v1.AcceptedMessagesFilter":
      return AcceptedMessagesFilter.decode(o.value);
    default:
      return o;
  }
}, Cosmwasm_wasmv1ContractAuthzFilterX_FromAmino = (e) => {
  switch (e.type) {
    case "wasm/AllowAllMessagesFilter":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.AllowAllMessagesFilter",
        value: AllowAllMessagesFilter.encode(AllowAllMessagesFilter.fromPartial(AllowAllMessagesFilter.fromAmino(e.value))).finish()
      });
    case "wasm/AcceptedMessageKeysFilter":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",
        value: AcceptedMessageKeysFilter.encode(AcceptedMessageKeysFilter.fromPartial(AcceptedMessageKeysFilter.fromAmino(e.value))).finish()
      });
    case "wasm/AcceptedMessagesFilter":
      return Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.AcceptedMessagesFilter",
        value: AcceptedMessagesFilter.encode(AcceptedMessagesFilter.fromPartial(AcceptedMessagesFilter.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, Cosmwasm_wasmv1ContractAuthzFilterX_ToAmino = (e) => {
  switch (e.typeUrl) {
    case "/cosmwasm.wasm.v1.AllowAllMessagesFilter":
      return {
        type: "wasm/AllowAllMessagesFilter",
        value: AllowAllMessagesFilter.toAmino(AllowAllMessagesFilter.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter":
      return {
        type: "wasm/AcceptedMessageKeysFilter",
        value: AcceptedMessageKeysFilter.toAmino(AcceptedMessageKeysFilter.decode(e.value))
      };
    case "/cosmwasm.wasm.v1.AcceptedMessagesFilter":
      return {
        type: "wasm/AcceptedMessagesFilter",
        value: AcceptedMessagesFilter.toAmino(AcceptedMessagesFilter.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _100 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AcceptedMessageKeysFilter,
  AcceptedMessagesFilter,
  AllowAllMessagesFilter,
  CombinedLimit,
  ContractExecutionAuthorization,
  ContractGrant,
  ContractMigrationAuthorization,
  Cosmwasm_wasmv1ContractAuthzFilterX_FromAmino,
  Cosmwasm_wasmv1ContractAuthzFilterX_InterfaceDecoder,
  Cosmwasm_wasmv1ContractAuthzFilterX_ToAmino,
  Cosmwasm_wasmv1ContractAuthzLimitX_FromAmino,
  Cosmwasm_wasmv1ContractAuthzLimitX_InterfaceDecoder,
  Cosmwasm_wasmv1ContractAuthzLimitX_ToAmino,
  MaxCallsLimit,
  MaxFundsLimit
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$f() {
  return {
    params: void 0,
    codes: [],
    contracts: [],
    sequences: []
  };
}
const GenesisState$f = {
  typeUrl: "/cosmwasm.wasm.v1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$j.encode(e.params, n.uint32(10).fork()).ldelim();
    for (const o of e.codes)
      Code.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.contracts)
      Contract.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.sequences)
      Sequence.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$f();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$j.decode(o, o.uint32());
          break;
        case 2:
          c.codes.push(Code.decode(o, o.uint32()));
          break;
        case 3:
          c.contracts.push(Contract.decode(o, o.uint32()));
          break;
        case 4:
          c.sequences.push(Sequence.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseGenesisState$f();
    return c.params = e.params !== void 0 && e.params !== null ? Params$j.fromPartial(e.params) : void 0, c.codes = ((n = e.codes) === null || n === void 0 ? void 0 : n.map((d) => Code.fromPartial(d))) || [], c.contracts = ((o = e.contracts) === null || o === void 0 ? void 0 : o.map((d) => Contract.fromPartial(d))) || [], c.sequences = ((u = e.sequences) === null || u === void 0 ? void 0 : u.map((d) => Sequence.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$j.fromAmino(e.params) : void 0,
      codes: Array.isArray(e == null ? void 0 : e.codes) ? e.codes.map((n) => Code.fromAmino(n)) : [],
      contracts: Array.isArray(e == null ? void 0 : e.contracts) ? e.contracts.map((n) => Contract.fromAmino(n)) : [],
      sequences: Array.isArray(e == null ? void 0 : e.sequences) ? e.sequences.map((n) => Sequence.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$j.toAmino(e.params) : void 0, e.codes ? n.codes = e.codes.map((o) => o ? Code.toAmino(o) : void 0) : n.codes = [], e.contracts ? n.contracts = e.contracts.map((o) => o ? Contract.toAmino(o) : void 0) : n.contracts = [], e.sequences ? n.sequences = e.sequences.map((o) => o ? Sequence.toAmino(o) : void 0) : n.sequences = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$f.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/GenesisState",
      value: GenesisState$f.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$f.decode(e.value);
  },
  toProto(e) {
    return GenesisState$f.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.GenesisState",
      value: GenesisState$f.encode(e).finish()
    };
  }
};
function createBaseCode() {
  return {
    codeId: Long$2.UZERO,
    codeInfo: void 0,
    codeBytes: new Uint8Array(),
    pinned: !1
  };
}
const Code = {
  typeUrl: "/cosmwasm.wasm.v1.Code",
  encode(e, n = minimal.Writer.create()) {
    return e.codeId.isZero() || n.uint32(8).uint64(e.codeId), e.codeInfo !== void 0 && CodeInfo.encode(e.codeInfo, n.uint32(18).fork()).ldelim(), e.codeBytes.length !== 0 && n.uint32(26).bytes(e.codeBytes), e.pinned === !0 && n.uint32(32).bool(e.pinned), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCode();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeId = o.uint64();
          break;
        case 2:
          c.codeInfo = CodeInfo.decode(o, o.uint32());
          break;
        case 3:
          c.codeBytes = o.bytes();
          break;
        case 4:
          c.pinned = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCode();
    return u.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, u.codeInfo = e.codeInfo !== void 0 && e.codeInfo !== null ? CodeInfo.fromPartial(e.codeInfo) : void 0, u.codeBytes = (n = e.codeBytes) !== null && n !== void 0 ? n : new Uint8Array(), u.pinned = (o = e.pinned) !== null && o !== void 0 ? o : !1, u;
  },
  fromAmino(e) {
    return {
      codeId: Long$2.fromString(e.code_id),
      codeInfo: e != null && e.code_info ? CodeInfo.fromAmino(e.code_info) : void 0,
      codeBytes: e.code_bytes,
      pinned: e.pinned
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_id = e.codeId ? e.codeId.toString() : void 0, n.code_info = e.codeInfo ? CodeInfo.toAmino(e.codeInfo) : void 0, n.code_bytes = e.codeBytes, n.pinned = e.pinned, n;
  },
  fromAminoMsg(e) {
    return Code.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/Code",
      value: Code.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Code.decode(e.value);
  },
  toProto(e) {
    return Code.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Code",
      value: Code.encode(e).finish()
    };
  }
};
function createBaseContract() {
  return {
    contractAddress: "",
    contractInfo: void 0,
    contractState: [],
    contractCodeHistory: []
  };
}
const Contract = {
  typeUrl: "/cosmwasm.wasm.v1.Contract",
  encode(e, n = minimal.Writer.create()) {
    e.contractAddress !== "" && n.uint32(10).string(e.contractAddress), e.contractInfo !== void 0 && ContractInfo.encode(e.contractInfo, n.uint32(18).fork()).ldelim();
    for (const o of e.contractState)
      Model.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.contractCodeHistory)
      ContractCodeHistoryEntry.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseContract();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.contractAddress = o.string();
          break;
        case 2:
          c.contractInfo = ContractInfo.decode(o, o.uint32());
          break;
        case 3:
          c.contractState.push(Model.decode(o, o.uint32()));
          break;
        case 4:
          c.contractCodeHistory.push(ContractCodeHistoryEntry.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseContract();
    return c.contractAddress = (n = e.contractAddress) !== null && n !== void 0 ? n : "", c.contractInfo = e.contractInfo !== void 0 && e.contractInfo !== null ? ContractInfo.fromPartial(e.contractInfo) : void 0, c.contractState = ((o = e.contractState) === null || o === void 0 ? void 0 : o.map((d) => Model.fromPartial(d))) || [], c.contractCodeHistory = ((u = e.contractCodeHistory) === null || u === void 0 ? void 0 : u.map((d) => ContractCodeHistoryEntry.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      contractAddress: e.contract_address,
      contractInfo: e != null && e.contract_info ? ContractInfo.fromAmino(e.contract_info) : void 0,
      contractState: Array.isArray(e == null ? void 0 : e.contract_state) ? e.contract_state.map((n) => Model.fromAmino(n)) : [],
      contractCodeHistory: Array.isArray(e == null ? void 0 : e.contract_code_history) ? e.contract_code_history.map((n) => ContractCodeHistoryEntry.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.contract_address = e.contractAddress, n.contract_info = e.contractInfo ? ContractInfo.toAmino(e.contractInfo) : void 0, e.contractState ? n.contract_state = e.contractState.map((o) => o ? Model.toAmino(o) : void 0) : n.contract_state = [], e.contractCodeHistory ? n.contract_code_history = e.contractCodeHistory.map((o) => o ? ContractCodeHistoryEntry.toAmino(o) : void 0) : n.contract_code_history = [], n;
  },
  fromAminoMsg(e) {
    return Contract.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/Contract",
      value: Contract.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Contract.decode(e.value);
  },
  toProto(e) {
    return Contract.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Contract",
      value: Contract.encode(e).finish()
    };
  }
};
function createBaseSequence() {
  return {
    idKey: new Uint8Array(),
    value: Long$2.UZERO
  };
}
const Sequence = {
  typeUrl: "/cosmwasm.wasm.v1.Sequence",
  encode(e, n = minimal.Writer.create()) {
    return e.idKey.length !== 0 && n.uint32(10).bytes(e.idKey), e.value.isZero() || n.uint32(16).uint64(e.value), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSequence();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.idKey = o.bytes();
          break;
        case 2:
          c.value = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSequence();
    return o.idKey = (n = e.idKey) !== null && n !== void 0 ? n : new Uint8Array(), o.value = e.value !== void 0 && e.value !== null ? Long$2.fromValue(e.value) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      idKey: e.id_key,
      value: Long$2.fromString(e.value)
    };
  },
  toAmino(e) {
    const n = {};
    return n.id_key = e.idKey, n.value = e.value ? e.value.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Sequence.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/Sequence",
      value: Sequence.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Sequence.decode(e.value);
  },
  toProto(e) {
    return Sequence.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Sequence",
      value: Sequence.encode(e).finish()
    };
  }
}, _101 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Code,
  Contract,
  GenesisState: GenesisState$f,
  Sequence
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgIBCSend() {
  return {
    channel: "",
    timeoutHeight: Long$2.UZERO,
    timeoutTimestamp: Long$2.UZERO,
    data: new Uint8Array()
  };
}
const MsgIBCSend = {
  typeUrl: "/cosmwasm.wasm.v1.MsgIBCSend",
  encode(e, n = minimal.Writer.create()) {
    return e.channel !== "" && n.uint32(18).string(e.channel), e.timeoutHeight.isZero() || n.uint32(32).uint64(e.timeoutHeight), e.timeoutTimestamp.isZero() || n.uint32(40).uint64(e.timeoutTimestamp), e.data.length !== 0 && n.uint32(50).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgIBCSend();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.channel = o.string();
          break;
        case 4:
          c.timeoutHeight = o.uint64();
          break;
        case 5:
          c.timeoutTimestamp = o.uint64();
          break;
        case 6:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgIBCSend();
    return u.channel = (n = e.channel) !== null && n !== void 0 ? n : "", u.timeoutHeight = e.timeoutHeight !== void 0 && e.timeoutHeight !== null ? Long$2.fromValue(e.timeoutHeight) : Long$2.UZERO, u.timeoutTimestamp = e.timeoutTimestamp !== void 0 && e.timeoutTimestamp !== null ? Long$2.fromValue(e.timeoutTimestamp) : Long$2.UZERO, u.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      channel: e.channel,
      timeoutHeight: Long$2.fromString(e.timeout_height),
      timeoutTimestamp: Long$2.fromString(e.timeout_timestamp),
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel = e.channel, n.timeout_height = e.timeoutHeight ? e.timeoutHeight.toString() : void 0, n.timeout_timestamp = e.timeoutTimestamp ? e.timeoutTimestamp.toString() : void 0, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return MsgIBCSend.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgIBCSend",
      value: MsgIBCSend.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgIBCSend.decode(e.value);
  },
  toProto(e) {
    return MsgIBCSend.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgIBCSend",
      value: MsgIBCSend.encode(e).finish()
    };
  }
};
function createBaseMsgIBCSendResponse() {
  return {
    sequence: Long$2.UZERO
  };
}
const MsgIBCSendResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgIBCSendResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.sequence.isZero() || n.uint32(8).uint64(e.sequence), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgIBCSendResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sequence = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgIBCSendResponse();
    return n.sequence = e.sequence !== void 0 && e.sequence !== null ? Long$2.fromValue(e.sequence) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      sequence: Long$2.fromString(e.sequence)
    };
  },
  toAmino(e) {
    const n = {};
    return n.sequence = e.sequence ? e.sequence.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgIBCSendResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgIBCSendResponse",
      value: MsgIBCSendResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgIBCSendResponse.decode(e.value);
  },
  toProto(e) {
    return MsgIBCSendResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgIBCSendResponse",
      value: MsgIBCSendResponse.encode(e).finish()
    };
  }
};
function createBaseMsgIBCCloseChannel() {
  return {
    channel: ""
  };
}
const MsgIBCCloseChannel = {
  typeUrl: "/cosmwasm.wasm.v1.MsgIBCCloseChannel",
  encode(e, n = minimal.Writer.create()) {
    return e.channel !== "" && n.uint32(18).string(e.channel), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgIBCCloseChannel();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.channel = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgIBCCloseChannel();
    return o.channel = (n = e.channel) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      channel: e.channel
    };
  },
  toAmino(e) {
    const n = {};
    return n.channel = e.channel, n;
  },
  fromAminoMsg(e) {
    return MsgIBCCloseChannel.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgIBCCloseChannel",
      value: MsgIBCCloseChannel.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgIBCCloseChannel.decode(e.value);
  },
  toProto(e) {
    return MsgIBCCloseChannel.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgIBCCloseChannel",
      value: MsgIBCCloseChannel.encode(e).finish()
    };
  }
}, _102 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgIBCCloseChannel,
  MsgIBCSend,
  MsgIBCSendResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryContractInfoRequest() {
  return {
    address: ""
  };
}
const QueryContractInfoRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryContractInfoRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryContractInfoRequest();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      address: e.address
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n;
  },
  fromAminoMsg(e) {
    return QueryContractInfoRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryContractInfoRequest",
      value: QueryContractInfoRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryContractInfoRequest.decode(e.value);
  },
  toProto(e) {
    return QueryContractInfoRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoRequest",
      value: QueryContractInfoRequest.encode(e).finish()
    };
  }
};
function createBaseQueryContractInfoResponse() {
  return {
    address: "",
    contractInfo: void 0
  };
}
const QueryContractInfoResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.contractInfo !== void 0 && ContractInfo.encode(e.contractInfo, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryContractInfoResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.contractInfo = ContractInfo.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryContractInfoResponse();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o.contractInfo = e.contractInfo !== void 0 && e.contractInfo !== null ? ContractInfo.fromPartial(e.contractInfo) : void 0, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      contractInfo: e != null && e.contract_info ? ContractInfo.fromAmino(e.contract_info) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.contract_info = e.contractInfo ? ContractInfo.toAmino(e.contractInfo) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryContractInfoResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryContractInfoResponse",
      value: QueryContractInfoResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryContractInfoResponse.decode(e.value);
  },
  toProto(e) {
    return QueryContractInfoResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoResponse",
      value: QueryContractInfoResponse.encode(e).finish()
    };
  }
};
function createBaseQueryContractHistoryRequest() {
  return {
    address: "",
    pagination: void 0
  };
}
const QueryContractHistoryRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryContractHistoryRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryContractHistoryRequest();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryContractHistoryRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryContractHistoryRequest",
      value: QueryContractHistoryRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryContractHistoryRequest.decode(e.value);
  },
  toProto(e) {
    return QueryContractHistoryRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryRequest",
      value: QueryContractHistoryRequest.encode(e).finish()
    };
  }
};
function createBaseQueryContractHistoryResponse() {
  return {
    entries: [],
    pagination: void 0
  };
}
const QueryContractHistoryResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.entries)
      ContractCodeHistoryEntry.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryContractHistoryResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.entries.push(ContractCodeHistoryEntry.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryContractHistoryResponse();
    return o.entries = ((n = e.entries) === null || n === void 0 ? void 0 : n.map((u) => ContractCodeHistoryEntry.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      entries: Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => ContractCodeHistoryEntry.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.entries ? n.entries = e.entries.map((o) => o ? ContractCodeHistoryEntry.toAmino(o) : void 0) : n.entries = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryContractHistoryResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryContractHistoryResponse",
      value: QueryContractHistoryResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryContractHistoryResponse.decode(e.value);
  },
  toProto(e) {
    return QueryContractHistoryResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryResponse",
      value: QueryContractHistoryResponse.encode(e).finish()
    };
  }
};
function createBaseQueryContractsByCodeRequest() {
  return {
    codeId: Long$2.UZERO,
    pagination: void 0
  };
}
const QueryContractsByCodeRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.codeId.isZero() || n.uint32(8).uint64(e.codeId), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryContractsByCodeRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeId = o.uint64();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryContractsByCodeRequest();
    return n.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      codeId: Long$2.fromString(e.code_id),
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_id = e.codeId ? e.codeId.toString() : void 0, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryContractsByCodeRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryContractsByCodeRequest",
      value: QueryContractsByCodeRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryContractsByCodeRequest.decode(e.value);
  },
  toProto(e) {
    return QueryContractsByCodeRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeRequest",
      value: QueryContractsByCodeRequest.encode(e).finish()
    };
  }
};
function createBaseQueryContractsByCodeResponse() {
  return {
    contracts: [],
    pagination: void 0
  };
}
const QueryContractsByCodeResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.contracts)
      n.uint32(10).string(o);
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryContractsByCodeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.contracts.push(o.string());
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryContractsByCodeResponse();
    return o.contracts = ((n = e.contracts) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      contracts: Array.isArray(e == null ? void 0 : e.contracts) ? e.contracts.map((n) => n) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.contracts ? n.contracts = e.contracts.map((o) => o) : n.contracts = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryContractsByCodeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryContractsByCodeResponse",
      value: QueryContractsByCodeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryContractsByCodeResponse.decode(e.value);
  },
  toProto(e) {
    return QueryContractsByCodeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeResponse",
      value: QueryContractsByCodeResponse.encode(e).finish()
    };
  }
};
function createBaseQueryAllContractStateRequest() {
  return {
    address: "",
    pagination: void 0
  };
}
const QueryAllContractStateRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAllContractStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryAllContractStateRequest();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      address: e.address,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryAllContractStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryAllContractStateRequest",
      value: QueryAllContractStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAllContractStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryAllContractStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateRequest",
      value: QueryAllContractStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryAllContractStateResponse() {
  return {
    models: [],
    pagination: void 0
  };
}
const QueryAllContractStateResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.models)
      Model.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryAllContractStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.models.push(Model.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryAllContractStateResponse();
    return o.models = ((n = e.models) === null || n === void 0 ? void 0 : n.map((u) => Model.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      models: Array.isArray(e == null ? void 0 : e.models) ? e.models.map((n) => Model.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.models ? n.models = e.models.map((o) => o ? Model.toAmino(o) : void 0) : n.models = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryAllContractStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryAllContractStateResponse",
      value: QueryAllContractStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryAllContractStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryAllContractStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateResponse",
      value: QueryAllContractStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryRawContractStateRequest() {
  return {
    address: "",
    queryData: new Uint8Array()
  };
}
const QueryRawContractStateRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.queryData.length !== 0 && n.uint32(18).bytes(e.queryData), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryRawContractStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.queryData = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryRawContractStateRequest();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.queryData = (o = e.queryData) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      queryData: e.query_data
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.query_data = e.queryData, n;
  },
  fromAminoMsg(e) {
    return QueryRawContractStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryRawContractStateRequest",
      value: QueryRawContractStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryRawContractStateRequest.decode(e.value);
  },
  toProto(e) {
    return QueryRawContractStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateRequest",
      value: QueryRawContractStateRequest.encode(e).finish()
    };
  }
};
function createBaseQueryRawContractStateResponse() {
  return {
    data: new Uint8Array()
  };
}
const QueryRawContractStateResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.data.length !== 0 && n.uint32(10).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryRawContractStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryRawContractStateResponse();
    return o.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return QueryRawContractStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryRawContractStateResponse",
      value: QueryRawContractStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryRawContractStateResponse.decode(e.value);
  },
  toProto(e) {
    return QueryRawContractStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateResponse",
      value: QueryRawContractStateResponse.encode(e).finish()
    };
  }
};
function createBaseQuerySmartContractStateRequest() {
  return {
    address: "",
    queryData: new Uint8Array()
  };
}
const QuerySmartContractStateRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.queryData.length !== 0 && n.uint32(18).bytes(e.queryData), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySmartContractStateRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.queryData = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQuerySmartContractStateRequest();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.queryData = (o = e.queryData) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      queryData: build$a.toUtf8(JSON.stringify(e.query_data))
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.query_data = e.queryData ? JSON.parse(build$a.fromUtf8(e.queryData)) : void 0, n;
  },
  fromAminoMsg(e) {
    return QuerySmartContractStateRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QuerySmartContractStateRequest",
      value: QuerySmartContractStateRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySmartContractStateRequest.decode(e.value);
  },
  toProto(e) {
    return QuerySmartContractStateRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateRequest",
      value: QuerySmartContractStateRequest.encode(e).finish()
    };
  }
};
function createBaseQuerySmartContractStateResponse() {
  return {
    data: new Uint8Array()
  };
}
const QuerySmartContractStateResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.data.length !== 0 && n.uint32(10).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySmartContractStateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQuerySmartContractStateResponse();
    return o.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      data: build$a.toUtf8(JSON.stringify(e.data))
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data ? JSON.parse(build$a.fromUtf8(e.data)) : void 0, n;
  },
  fromAminoMsg(e) {
    return QuerySmartContractStateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QuerySmartContractStateResponse",
      value: QuerySmartContractStateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySmartContractStateResponse.decode(e.value);
  },
  toProto(e) {
    return QuerySmartContractStateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateResponse",
      value: QuerySmartContractStateResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCodeRequest() {
  return {
    codeId: Long$2.UZERO
  };
}
const QueryCodeRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryCodeRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.codeId.isZero() || n.uint32(8).uint64(e.codeId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCodeRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryCodeRequest();
    return n.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      codeId: Long$2.fromString(e.code_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_id = e.codeId ? e.codeId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryCodeRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryCodeRequest",
      value: QueryCodeRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCodeRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCodeRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryCodeRequest",
      value: QueryCodeRequest.encode(e).finish()
    };
  }
};
function createBaseCodeInfoResponse() {
  return {
    codeId: Long$2.UZERO,
    creator: "",
    dataHash: new Uint8Array(),
    instantiatePermission: void 0
  };
}
const CodeInfoResponse = {
  typeUrl: "/cosmwasm.wasm.v1.CodeInfoResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.codeId.isZero() || n.uint32(8).uint64(e.codeId), e.creator !== "" && n.uint32(18).string(e.creator), e.dataHash.length !== 0 && n.uint32(26).bytes(e.dataHash), e.instantiatePermission !== void 0 && AccessConfig.encode(e.instantiatePermission, n.uint32(50).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCodeInfoResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeId = o.uint64();
          break;
        case 2:
          c.creator = o.string();
          break;
        case 3:
          c.dataHash = o.bytes();
          break;
        case 6:
          c.instantiatePermission = AccessConfig.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCodeInfoResponse();
    return u.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, u.creator = (n = e.creator) !== null && n !== void 0 ? n : "", u.dataHash = (o = e.dataHash) !== null && o !== void 0 ? o : new Uint8Array(), u.instantiatePermission = e.instantiatePermission !== void 0 && e.instantiatePermission !== null ? AccessConfig.fromPartial(e.instantiatePermission) : void 0, u;
  },
  fromAmino(e) {
    return {
      codeId: Long$2.fromString(e.code_id),
      creator: e.creator,
      dataHash: e.data_hash,
      instantiatePermission: e != null && e.instantiate_permission ? AccessConfig.fromAmino(e.instantiate_permission) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_id = e.codeId ? e.codeId.toString() : void 0, n.creator = e.creator, n.data_hash = e.dataHash, n.instantiate_permission = e.instantiatePermission ? AccessConfig.toAmino(e.instantiatePermission) : void 0, n;
  },
  fromAminoMsg(e) {
    return CodeInfoResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/CodeInfoResponse",
      value: CodeInfoResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CodeInfoResponse.decode(e.value);
  },
  toProto(e) {
    return CodeInfoResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.CodeInfoResponse",
      value: CodeInfoResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCodeResponse() {
  return {
    codeInfo: void 0,
    data: new Uint8Array()
  };
}
const QueryCodeResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryCodeResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.codeInfo !== void 0 && CodeInfoResponse.encode(e.codeInfo, n.uint32(10).fork()).ldelim(), e.data.length !== 0 && n.uint32(18).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCodeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeInfo = CodeInfoResponse.decode(o, o.uint32());
          break;
        case 2:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCodeResponse();
    return o.codeInfo = e.codeInfo !== void 0 && e.codeInfo !== null ? CodeInfoResponse.fromPartial(e.codeInfo) : void 0, o.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      codeInfo: e != null && e.code_info ? CodeInfoResponse.fromAmino(e.code_info) : void 0,
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_info = e.codeInfo ? CodeInfoResponse.toAmino(e.codeInfo) : void 0, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return QueryCodeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryCodeResponse",
      value: QueryCodeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCodeResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCodeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryCodeResponse",
      value: QueryCodeResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCodesRequest() {
  return {
    pagination: void 0
  };
}
const QueryCodesRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryCodesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCodesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryCodesRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryCodesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryCodesRequest",
      value: QueryCodesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCodesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCodesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryCodesRequest",
      value: QueryCodesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryCodesResponse() {
  return {
    codeInfos: [],
    pagination: void 0
  };
}
const QueryCodesResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryCodesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.codeInfos)
      CodeInfoResponse.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCodesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeInfos.push(CodeInfoResponse.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCodesResponse();
    return o.codeInfos = ((n = e.codeInfos) === null || n === void 0 ? void 0 : n.map((u) => CodeInfoResponse.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      codeInfos: Array.isArray(e == null ? void 0 : e.code_infos) ? e.code_infos.map((n) => CodeInfoResponse.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.codeInfos ? n.code_infos = e.codeInfos.map((o) => o ? CodeInfoResponse.toAmino(o) : void 0) : n.code_infos = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryCodesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryCodesResponse",
      value: QueryCodesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCodesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCodesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryCodesResponse",
      value: QueryCodesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPinnedCodesRequest() {
  return {
    pagination: void 0
  };
}
const QueryPinnedCodesRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPinnedCodesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryPinnedCodesRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPinnedCodesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryPinnedCodesRequest",
      value: QueryPinnedCodesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPinnedCodesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPinnedCodesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesRequest",
      value: QueryPinnedCodesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPinnedCodesResponse() {
  return {
    codeIds: [],
    pagination: void 0
  };
}
const QueryPinnedCodesResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesResponse",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.codeIds)
      n.uint64(o);
    return n.ldelim(), e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPinnedCodesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.codeIds.push(o.uint64());
          } else
            c.codeIds.push(o.uint64());
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryPinnedCodesResponse();
    return o.codeIds = ((n = e.codeIds) === null || n === void 0 ? void 0 : n.map((u) => Long$2.fromValue(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      codeIds: Array.isArray(e == null ? void 0 : e.code_ids) ? e.code_ids.map((n) => n) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.codeIds ? n.code_ids = e.codeIds.map((o) => o) : n.code_ids = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPinnedCodesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryPinnedCodesResponse",
      value: QueryPinnedCodesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPinnedCodesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPinnedCodesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesResponse",
      value: QueryPinnedCodesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$6() {
  return {};
}
const QueryParamsRequest$6 = {
  typeUrl: "/cosmwasm.wasm.v1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$6();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$6();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$6.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryParamsRequest",
      value: QueryParamsRequest$6.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$6.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$6.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryParamsRequest",
      value: QueryParamsRequest$6.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$6() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$6 = {
  typeUrl: "/cosmwasm.wasm.v1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$j.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$6();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$j.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$6();
    return n.params = e.params !== void 0 && e.params !== null ? Params$j.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$j.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$j.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$6.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryParamsResponse",
      value: QueryParamsResponse$6.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$6.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$6.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryParamsResponse",
      value: QueryParamsResponse$6.encode(e).finish()
    };
  }
};
function createBaseQueryContractsByCreatorRequest() {
  return {
    creatorAddress: "",
    pagination: void 0
  };
}
const QueryContractsByCreatorRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.creatorAddress !== "" && n.uint32(10).string(e.creatorAddress), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryContractsByCreatorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.creatorAddress = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryContractsByCreatorRequest();
    return o.creatorAddress = (n = e.creatorAddress) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      creatorAddress: e.creator_address,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.creator_address = e.creatorAddress, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryContractsByCreatorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryContractsByCreatorRequest",
      value: QueryContractsByCreatorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryContractsByCreatorRequest.decode(e.value);
  },
  toProto(e) {
    return QueryContractsByCreatorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorRequest",
      value: QueryContractsByCreatorRequest.encode(e).finish()
    };
  }
};
function createBaseQueryContractsByCreatorResponse() {
  return {
    contractAddresses: [],
    pagination: void 0
  };
}
const QueryContractsByCreatorResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.contractAddresses)
      n.uint32(10).string(o);
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryContractsByCreatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.contractAddresses.push(o.string());
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryContractsByCreatorResponse();
    return o.contractAddresses = ((n = e.contractAddresses) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      contractAddresses: Array.isArray(e == null ? void 0 : e.contract_addresses) ? e.contract_addresses.map((n) => n) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.contractAddresses ? n.contract_addresses = e.contractAddresses.map((o) => o) : n.contract_addresses = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryContractsByCreatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/QueryContractsByCreatorResponse",
      value: QueryContractsByCreatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryContractsByCreatorResponse.decode(e.value);
  },
  toProto(e) {
    return QueryContractsByCreatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorResponse",
      value: QueryContractsByCreatorResponse.encode(e).finish()
    };
  }
}, _104 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CodeInfoResponse,
  QueryAllContractStateRequest,
  QueryAllContractStateResponse,
  QueryCodeRequest,
  QueryCodeResponse,
  QueryCodesRequest,
  QueryCodesResponse,
  QueryContractHistoryRequest,
  QueryContractHistoryResponse,
  QueryContractInfoRequest,
  QueryContractInfoResponse,
  QueryContractsByCodeRequest,
  QueryContractsByCodeResponse,
  QueryContractsByCreatorRequest,
  QueryContractsByCreatorResponse,
  QueryParamsRequest: QueryParamsRequest$6,
  QueryParamsResponse: QueryParamsResponse$6,
  QueryPinnedCodesRequest,
  QueryPinnedCodesResponse,
  QueryRawContractStateRequest,
  QueryRawContractStateResponse,
  QuerySmartContractStateRequest,
  QuerySmartContractStateResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgStoreCode() {
  return {
    sender: "",
    wasmByteCode: new Uint8Array(),
    instantiatePermission: void 0
  };
}
const MsgStoreCode = {
  typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.wasmByteCode.length !== 0 && n.uint32(18).bytes(e.wasmByteCode), e.instantiatePermission !== void 0 && AccessConfig.encode(e.instantiatePermission, n.uint32(42).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgStoreCode();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.wasmByteCode = o.bytes();
          break;
        case 5:
          c.instantiatePermission = AccessConfig.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgStoreCode();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.wasmByteCode = (o = e.wasmByteCode) !== null && o !== void 0 ? o : new Uint8Array(), u.instantiatePermission = e.instantiatePermission !== void 0 && e.instantiatePermission !== null ? AccessConfig.fromPartial(e.instantiatePermission) : void 0, u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      wasmByteCode: build$a.fromBase64(e.wasm_byte_code),
      instantiatePermission: e != null && e.instantiate_permission ? AccessConfig.fromAmino(e.instantiate_permission) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.wasm_byte_code = e.wasmByteCode ? build$a.toBase64(e.wasmByteCode) : void 0, n.instantiate_permission = e.instantiatePermission ? AccessConfig.toAmino(e.instantiatePermission) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgStoreCode.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgStoreCode",
      value: MsgStoreCode.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgStoreCode.decode(e.value);
  },
  toProto(e) {
    return MsgStoreCode.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
      value: MsgStoreCode.encode(e).finish()
    };
  }
};
function createBaseMsgStoreCodeResponse() {
  return {
    codeId: Long$2.UZERO,
    checksum: new Uint8Array()
  };
}
const MsgStoreCodeResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgStoreCodeResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.codeId.isZero() || n.uint32(8).uint64(e.codeId), e.checksum.length !== 0 && n.uint32(18).bytes(e.checksum), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgStoreCodeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeId = o.uint64();
          break;
        case 2:
          c.checksum = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgStoreCodeResponse();
    return o.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, o.checksum = (n = e.checksum) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      codeId: Long$2.fromString(e.code_id),
      checksum: e.checksum
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_id = e.codeId ? e.codeId.toString() : void 0, n.checksum = e.checksum, n;
  },
  fromAminoMsg(e) {
    return MsgStoreCodeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgStoreCodeResponse",
      value: MsgStoreCodeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgStoreCodeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgStoreCodeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreCodeResponse",
      value: MsgStoreCodeResponse.encode(e).finish()
    };
  }
};
function createBaseMsgInstantiateContract() {
  return {
    sender: "",
    admin: "",
    codeId: Long$2.UZERO,
    label: "",
    msg: new Uint8Array(),
    funds: []
  };
}
const MsgInstantiateContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.admin !== "" && n.uint32(18).string(e.admin), e.codeId.isZero() || n.uint32(24).uint64(e.codeId), e.label !== "" && n.uint32(34).string(e.label), e.msg.length !== 0 && n.uint32(42).bytes(e.msg);
    for (const o of e.funds)
      Coin.encode(o, n.uint32(50).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgInstantiateContract();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.admin = o.string();
          break;
        case 3:
          c.codeId = o.uint64();
          break;
        case 4:
          c.label = o.string();
          break;
        case 5:
          c.msg = o.bytes();
          break;
        case 6:
          c.funds.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseMsgInstantiateContract();
    return m.sender = (n = e.sender) !== null && n !== void 0 ? n : "", m.admin = (o = e.admin) !== null && o !== void 0 ? o : "", m.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, m.label = (u = e.label) !== null && u !== void 0 ? u : "", m.msg = (c = e.msg) !== null && c !== void 0 ? c : new Uint8Array(), m.funds = ((d = e.funds) === null || d === void 0 ? void 0 : d.map((v) => Coin.fromPartial(v))) || [], m;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      admin: e.admin,
      codeId: Long$2.fromString(e.code_id),
      label: e.label,
      msg: build$a.toUtf8(JSON.stringify(e.msg)),
      funds: Array.isArray(e == null ? void 0 : e.funds) ? e.funds.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.admin = e.admin, n.code_id = e.codeId ? e.codeId.toString() : void 0, n.label = e.label, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, e.funds ? n.funds = e.funds.map((o) => o ? Coin.toAmino(o) : void 0) : n.funds = [], n;
  },
  fromAminoMsg(e) {
    return MsgInstantiateContract.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgInstantiateContract",
      value: MsgInstantiateContract.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgInstantiateContract.decode(e.value);
  },
  toProto(e) {
    return MsgInstantiateContract.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
      value: MsgInstantiateContract.encode(e).finish()
    };
  }
};
function createBaseMsgInstantiateContractResponse() {
  return {
    address: "",
    data: new Uint8Array()
  };
}
const MsgInstantiateContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContractResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.data.length !== 0 && n.uint32(18).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgInstantiateContractResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgInstantiateContractResponse();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return MsgInstantiateContractResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgInstantiateContractResponse",
      value: MsgInstantiateContractResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgInstantiateContractResponse.decode(e.value);
  },
  toProto(e) {
    return MsgInstantiateContractResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContractResponse",
      value: MsgInstantiateContractResponse.encode(e).finish()
    };
  }
};
function createBaseMsgInstantiateContract2() {
  return {
    sender: "",
    admin: "",
    codeId: Long$2.UZERO,
    label: "",
    msg: new Uint8Array(),
    funds: [],
    salt: new Uint8Array(),
    fixMsg: !1
  };
}
const MsgInstantiateContract2 = {
  typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.admin !== "" && n.uint32(18).string(e.admin), e.codeId.isZero() || n.uint32(24).uint64(e.codeId), e.label !== "" && n.uint32(34).string(e.label), e.msg.length !== 0 && n.uint32(42).bytes(e.msg);
    for (const o of e.funds)
      Coin.encode(o, n.uint32(50).fork()).ldelim();
    return e.salt.length !== 0 && n.uint32(58).bytes(e.salt), e.fixMsg === !0 && n.uint32(64).bool(e.fixMsg), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgInstantiateContract2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.admin = o.string();
          break;
        case 3:
          c.codeId = o.uint64();
          break;
        case 4:
          c.label = o.string();
          break;
        case 5:
          c.msg = o.bytes();
          break;
        case 6:
          c.funds.push(Coin.decode(o, o.uint32()));
          break;
        case 7:
          c.salt = o.bytes();
          break;
        case 8:
          c.fixMsg = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v;
    const S = createBaseMsgInstantiateContract2();
    return S.sender = (n = e.sender) !== null && n !== void 0 ? n : "", S.admin = (o = e.admin) !== null && o !== void 0 ? o : "", S.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, S.label = (u = e.label) !== null && u !== void 0 ? u : "", S.msg = (c = e.msg) !== null && c !== void 0 ? c : new Uint8Array(), S.funds = ((d = e.funds) === null || d === void 0 ? void 0 : d.map(($) => Coin.fromPartial($))) || [], S.salt = (m = e.salt) !== null && m !== void 0 ? m : new Uint8Array(), S.fixMsg = (v = e.fixMsg) !== null && v !== void 0 ? v : !1, S;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      admin: e.admin,
      codeId: Long$2.fromString(e.code_id),
      label: e.label,
      msg: build$a.toUtf8(JSON.stringify(e.msg)),
      funds: Array.isArray(e == null ? void 0 : e.funds) ? e.funds.map((n) => Coin.fromAmino(n)) : [],
      salt: e.salt,
      fixMsg: e.fix_msg
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.admin = e.admin, n.code_id = e.codeId ? e.codeId.toString() : void 0, n.label = e.label, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, e.funds ? n.funds = e.funds.map((o) => o ? Coin.toAmino(o) : void 0) : n.funds = [], n.salt = e.salt, n.fix_msg = e.fixMsg, n;
  },
  fromAminoMsg(e) {
    return MsgInstantiateContract2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgInstantiateContract2",
      value: MsgInstantiateContract2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgInstantiateContract2.decode(e.value);
  },
  toProto(e) {
    return MsgInstantiateContract2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
      value: MsgInstantiateContract2.encode(e).finish()
    };
  }
};
function createBaseMsgInstantiateContract2Response() {
  return {
    address: "",
    data: new Uint8Array()
  };
}
const MsgInstantiateContract2Response = {
  typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2Response",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.data.length !== 0 && n.uint32(18).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgInstantiateContract2Response();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgInstantiateContract2Response();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return MsgInstantiateContract2Response.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgInstantiateContract2Response",
      value: MsgInstantiateContract2Response.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgInstantiateContract2Response.decode(e.value);
  },
  toProto(e) {
    return MsgInstantiateContract2Response.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2Response",
      value: MsgInstantiateContract2Response.encode(e).finish()
    };
  }
};
function createBaseMsgExecuteContract() {
  return {
    sender: "",
    contract: "",
    msg: new Uint8Array(),
    funds: []
  };
}
const MsgExecuteContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.contract !== "" && n.uint32(18).string(e.contract), e.msg.length !== 0 && n.uint32(26).bytes(e.msg);
    for (const o of e.funds)
      Coin.encode(o, n.uint32(42).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExecuteContract();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.contract = o.string();
          break;
        case 3:
          c.msg = o.bytes();
          break;
        case 5:
          c.funds.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgExecuteContract();
    return d.sender = (n = e.sender) !== null && n !== void 0 ? n : "", d.contract = (o = e.contract) !== null && o !== void 0 ? o : "", d.msg = (u = e.msg) !== null && u !== void 0 ? u : new Uint8Array(), d.funds = ((c = e.funds) === null || c === void 0 ? void 0 : c.map((m) => Coin.fromPartial(m))) || [], d;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      contract: e.contract,
      msg: build$a.toUtf8(JSON.stringify(e.msg)),
      funds: Array.isArray(e == null ? void 0 : e.funds) ? e.funds.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.contract = e.contract, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, e.funds ? n.funds = e.funds.map((o) => o ? Coin.toAmino(o) : void 0) : n.funds = [], n;
  },
  fromAminoMsg(e) {
    return MsgExecuteContract.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgExecuteContract",
      value: MsgExecuteContract.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExecuteContract.decode(e.value);
  },
  toProto(e) {
    return MsgExecuteContract.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: MsgExecuteContract.encode(e).finish()
    };
  }
};
function createBaseMsgExecuteContractResponse() {
  return {
    data: new Uint8Array()
  };
}
const MsgExecuteContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContractResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.data.length !== 0 && n.uint32(10).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExecuteContractResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgExecuteContractResponse();
    return o.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return MsgExecuteContractResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgExecuteContractResponse",
      value: MsgExecuteContractResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExecuteContractResponse.decode(e.value);
  },
  toProto(e) {
    return MsgExecuteContractResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContractResponse",
      value: MsgExecuteContractResponse.encode(e).finish()
    };
  }
};
function createBaseMsgMigrateContract() {
  return {
    sender: "",
    contract: "",
    codeId: Long$2.UZERO,
    msg: new Uint8Array()
  };
}
const MsgMigrateContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.contract !== "" && n.uint32(18).string(e.contract), e.codeId.isZero() || n.uint32(24).uint64(e.codeId), e.msg.length !== 0 && n.uint32(34).bytes(e.msg), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgMigrateContract();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.contract = o.string();
          break;
        case 3:
          c.codeId = o.uint64();
          break;
        case 4:
          c.msg = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgMigrateContract();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.contract = (o = e.contract) !== null && o !== void 0 ? o : "", c.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, c.msg = (u = e.msg) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      contract: e.contract,
      codeId: Long$2.fromString(e.code_id),
      msg: build$a.toUtf8(JSON.stringify(e.msg))
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.contract = e.contract, n.code_id = e.codeId ? e.codeId.toString() : void 0, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgMigrateContract.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgMigrateContract",
      value: MsgMigrateContract.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgMigrateContract.decode(e.value);
  },
  toProto(e) {
    return MsgMigrateContract.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
      value: MsgMigrateContract.encode(e).finish()
    };
  }
};
function createBaseMsgMigrateContractResponse() {
  return {
    data: new Uint8Array()
  };
}
const MsgMigrateContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContractResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.data.length !== 0 && n.uint32(10).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgMigrateContractResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgMigrateContractResponse();
    return o.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return MsgMigrateContractResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgMigrateContractResponse",
      value: MsgMigrateContractResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgMigrateContractResponse.decode(e.value);
  },
  toProto(e) {
    return MsgMigrateContractResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContractResponse",
      value: MsgMigrateContractResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUpdateAdmin() {
  return {
    sender: "",
    newAdmin: "",
    contract: ""
  };
}
const MsgUpdateAdmin = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.newAdmin !== "" && n.uint32(18).string(e.newAdmin), e.contract !== "" && n.uint32(26).string(e.contract), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpdateAdmin();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.newAdmin = o.string();
          break;
        case 3:
          c.contract = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgUpdateAdmin();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.newAdmin = (o = e.newAdmin) !== null && o !== void 0 ? o : "", c.contract = (u = e.contract) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      newAdmin: e.new_admin,
      contract: e.contract
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.new_admin = e.newAdmin, n.contract = e.contract, n;
  },
  fromAminoMsg(e) {
    return MsgUpdateAdmin.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgUpdateAdmin",
      value: MsgUpdateAdmin.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpdateAdmin.decode(e.value);
  },
  toProto(e) {
    return MsgUpdateAdmin.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
      value: MsgUpdateAdmin.encode(e).finish()
    };
  }
};
function createBaseMsgUpdateAdminResponse() {
  return {};
}
const MsgUpdateAdminResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdminResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpdateAdminResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgUpdateAdminResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgUpdateAdminResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgUpdateAdminResponse",
      value: MsgUpdateAdminResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpdateAdminResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUpdateAdminResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdminResponse",
      value: MsgUpdateAdminResponse.encode(e).finish()
    };
  }
};
function createBaseMsgClearAdmin() {
  return {
    sender: "",
    contract: ""
  };
}
const MsgClearAdmin = {
  typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.contract !== "" && n.uint32(26).string(e.contract), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgClearAdmin();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 3:
          c.contract = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgClearAdmin();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.contract = (o = e.contract) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      contract: e.contract
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.contract = e.contract, n;
  },
  fromAminoMsg(e) {
    return MsgClearAdmin.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgClearAdmin",
      value: MsgClearAdmin.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgClearAdmin.decode(e.value);
  },
  toProto(e) {
    return MsgClearAdmin.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
      value: MsgClearAdmin.encode(e).finish()
    };
  }
};
function createBaseMsgClearAdminResponse() {
  return {};
}
const MsgClearAdminResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgClearAdminResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgClearAdminResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgClearAdminResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgClearAdminResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgClearAdminResponse",
      value: MsgClearAdminResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgClearAdminResponse.decode(e.value);
  },
  toProto(e) {
    return MsgClearAdminResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgClearAdminResponse",
      value: MsgClearAdminResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUpdateInstantiateConfig() {
  return {
    sender: "",
    codeId: Long$2.UZERO,
    newInstantiatePermission: void 0
  };
}
const MsgUpdateInstantiateConfig = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.codeId.isZero() || n.uint32(16).uint64(e.codeId), e.newInstantiatePermission !== void 0 && AccessConfig.encode(e.newInstantiatePermission, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpdateInstantiateConfig();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.codeId = o.uint64();
          break;
        case 3:
          c.newInstantiatePermission = AccessConfig.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgUpdateInstantiateConfig();
    return o.sender = (n = e.sender) !== null && n !== void 0 ? n : "", o.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, o.newInstantiatePermission = e.newInstantiatePermission !== void 0 && e.newInstantiatePermission !== null ? AccessConfig.fromPartial(e.newInstantiatePermission) : void 0, o;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      codeId: Long$2.fromString(e.code_id),
      newInstantiatePermission: e != null && e.new_instantiate_permission ? AccessConfig.fromAmino(e.new_instantiate_permission) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.code_id = e.codeId ? e.codeId.toString() : void 0, n.new_instantiate_permission = e.newInstantiatePermission ? AccessConfig.toAmino(e.newInstantiatePermission) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgUpdateInstantiateConfig.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgUpdateInstantiateConfig",
      value: MsgUpdateInstantiateConfig.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpdateInstantiateConfig.decode(e.value);
  },
  toProto(e) {
    return MsgUpdateInstantiateConfig.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
      value: MsgUpdateInstantiateConfig.encode(e).finish()
    };
  }
};
function createBaseMsgUpdateInstantiateConfigResponse() {
  return {};
}
const MsgUpdateInstantiateConfigResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfigResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpdateInstantiateConfigResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgUpdateInstantiateConfigResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgUpdateInstantiateConfigResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgUpdateInstantiateConfigResponse",
      value: MsgUpdateInstantiateConfigResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpdateInstantiateConfigResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUpdateInstantiateConfigResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfigResponse",
      value: MsgUpdateInstantiateConfigResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUpdateParams() {
  return {
    authority: "",
    params: void 0
  };
}
const MsgUpdateParams = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
  encode(e, n = minimal.Writer.create()) {
    return e.authority !== "" && n.uint32(10).string(e.authority), e.params !== void 0 && Params$j.encode(e.params, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpdateParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authority = o.string();
          break;
        case 2:
          c.params = Params$j.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgUpdateParams();
    return o.authority = (n = e.authority) !== null && n !== void 0 ? n : "", o.params = e.params !== void 0 && e.params !== null ? Params$j.fromPartial(e.params) : void 0, o;
  },
  fromAmino(e) {
    return {
      authority: e.authority,
      params: e != null && e.params ? Params$j.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.authority = e.authority, n.params = e.params ? Params$j.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgUpdateParams.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgUpdateParams",
      value: MsgUpdateParams.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpdateParams.decode(e.value);
  },
  toProto(e) {
    return MsgUpdateParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
      value: MsgUpdateParams.encode(e).finish()
    };
  }
};
function createBaseMsgUpdateParamsResponse() {
  return {};
}
const MsgUpdateParamsResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUpdateParamsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgUpdateParamsResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgUpdateParamsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgUpdateParamsResponse",
      value: MsgUpdateParamsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUpdateParamsResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUpdateParamsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParamsResponse",
      value: MsgUpdateParamsResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSudoContract() {
  return {
    authority: "",
    contract: "",
    msg: new Uint8Array()
  };
}
const MsgSudoContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
  encode(e, n = minimal.Writer.create()) {
    return e.authority !== "" && n.uint32(10).string(e.authority), e.contract !== "" && n.uint32(18).string(e.contract), e.msg.length !== 0 && n.uint32(26).bytes(e.msg), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSudoContract();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authority = o.string();
          break;
        case 2:
          c.contract = o.string();
          break;
        case 3:
          c.msg = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgSudoContract();
    return c.authority = (n = e.authority) !== null && n !== void 0 ? n : "", c.contract = (o = e.contract) !== null && o !== void 0 ? o : "", c.msg = (u = e.msg) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      authority: e.authority,
      contract: e.contract,
      msg: build$a.toUtf8(JSON.stringify(e.msg))
    };
  },
  toAmino(e) {
    const n = {};
    return n.authority = e.authority, n.contract = e.contract, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSudoContract.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgSudoContract",
      value: MsgSudoContract.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSudoContract.decode(e.value);
  },
  toProto(e) {
    return MsgSudoContract.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
      value: MsgSudoContract.encode(e).finish()
    };
  }
};
function createBaseMsgSudoContractResponse() {
  return {
    data: new Uint8Array()
  };
}
const MsgSudoContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgSudoContractResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.data.length !== 0 && n.uint32(10).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSudoContractResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSudoContractResponse();
    return o.data = (n = e.data) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return MsgSudoContractResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgSudoContractResponse",
      value: MsgSudoContractResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSudoContractResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSudoContractResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgSudoContractResponse",
      value: MsgSudoContractResponse.encode(e).finish()
    };
  }
};
function createBaseMsgPinCodes() {
  return {
    authority: "",
    codeIds: []
  };
}
const MsgPinCodes = {
  typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
  encode(e, n = minimal.Writer.create()) {
    e.authority !== "" && n.uint32(10).string(e.authority), n.uint32(18).fork();
    for (const o of e.codeIds)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgPinCodes();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authority = o.string();
          break;
        case 2:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.codeIds.push(o.uint64());
          } else
            c.codeIds.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgPinCodes();
    return u.authority = (n = e.authority) !== null && n !== void 0 ? n : "", u.codeIds = ((o = e.codeIds) === null || o === void 0 ? void 0 : o.map((c) => Long$2.fromValue(c))) || [], u;
  },
  fromAmino(e) {
    return {
      authority: e.authority,
      codeIds: Array.isArray(e == null ? void 0 : e.code_ids) ? e.code_ids.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.authority = e.authority, e.codeIds ? n.code_ids = e.codeIds.map((o) => o) : n.code_ids = [], n;
  },
  fromAminoMsg(e) {
    return MsgPinCodes.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgPinCodes",
      value: MsgPinCodes.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgPinCodes.decode(e.value);
  },
  toProto(e) {
    return MsgPinCodes.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
      value: MsgPinCodes.encode(e).finish()
    };
  }
};
function createBaseMsgPinCodesResponse() {
  return {};
}
const MsgPinCodesResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgPinCodesResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgPinCodesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgPinCodesResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgPinCodesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgPinCodesResponse",
      value: MsgPinCodesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgPinCodesResponse.decode(e.value);
  },
  toProto(e) {
    return MsgPinCodesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgPinCodesResponse",
      value: MsgPinCodesResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUnpinCodes() {
  return {
    authority: "",
    codeIds: []
  };
}
const MsgUnpinCodes = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
  encode(e, n = minimal.Writer.create()) {
    e.authority !== "" && n.uint32(10).string(e.authority), n.uint32(18).fork();
    for (const o of e.codeIds)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUnpinCodes();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authority = o.string();
          break;
        case 2:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.codeIds.push(o.uint64());
          } else
            c.codeIds.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgUnpinCodes();
    return u.authority = (n = e.authority) !== null && n !== void 0 ? n : "", u.codeIds = ((o = e.codeIds) === null || o === void 0 ? void 0 : o.map((c) => Long$2.fromValue(c))) || [], u;
  },
  fromAmino(e) {
    return {
      authority: e.authority,
      codeIds: Array.isArray(e == null ? void 0 : e.code_ids) ? e.code_ids.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.authority = e.authority, e.codeIds ? n.code_ids = e.codeIds.map((o) => o) : n.code_ids = [], n;
  },
  fromAminoMsg(e) {
    return MsgUnpinCodes.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgUnpinCodes",
      value: MsgUnpinCodes.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUnpinCodes.decode(e.value);
  },
  toProto(e) {
    return MsgUnpinCodes.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
      value: MsgUnpinCodes.encode(e).finish()
    };
  }
};
function createBaseMsgUnpinCodesResponse() {
  return {};
}
const MsgUnpinCodesResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodesResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUnpinCodesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgUnpinCodesResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgUnpinCodesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgUnpinCodesResponse",
      value: MsgUnpinCodesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUnpinCodesResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUnpinCodesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodesResponse",
      value: MsgUnpinCodesResponse.encode(e).finish()
    };
  }
};
function createBaseMsgStoreAndInstantiateContract() {
  return {
    authority: "",
    wasmByteCode: new Uint8Array(),
    instantiatePermission: void 0,
    unpinCode: !1,
    admin: "",
    label: "",
    msg: new Uint8Array(),
    funds: [],
    source: "",
    builder: "",
    codeHash: new Uint8Array()
  };
}
const MsgStoreAndInstantiateContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
  encode(e, n = minimal.Writer.create()) {
    e.authority !== "" && n.uint32(10).string(e.authority), e.wasmByteCode.length !== 0 && n.uint32(26).bytes(e.wasmByteCode), e.instantiatePermission !== void 0 && AccessConfig.encode(e.instantiatePermission, n.uint32(34).fork()).ldelim(), e.unpinCode === !0 && n.uint32(40).bool(e.unpinCode), e.admin !== "" && n.uint32(50).string(e.admin), e.label !== "" && n.uint32(58).string(e.label), e.msg.length !== 0 && n.uint32(66).bytes(e.msg);
    for (const o of e.funds)
      Coin.encode(o, n.uint32(74).fork()).ldelim();
    return e.source !== "" && n.uint32(82).string(e.source), e.builder !== "" && n.uint32(90).string(e.builder), e.codeHash.length !== 0 && n.uint32(98).bytes(e.codeHash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgStoreAndInstantiateContract();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authority = o.string();
          break;
        case 3:
          c.wasmByteCode = o.bytes();
          break;
        case 4:
          c.instantiatePermission = AccessConfig.decode(o, o.uint32());
          break;
        case 5:
          c.unpinCode = o.bool();
          break;
        case 6:
          c.admin = o.string();
          break;
        case 7:
          c.label = o.string();
          break;
        case 8:
          c.msg = o.bytes();
          break;
        case 9:
          c.funds.push(Coin.decode(o, o.uint32()));
          break;
        case 10:
          c.source = o.string();
          break;
        case 11:
          c.builder = o.string();
          break;
        case 12:
          c.codeHash = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $, E;
    const O = createBaseMsgStoreAndInstantiateContract();
    return O.authority = (n = e.authority) !== null && n !== void 0 ? n : "", O.wasmByteCode = (o = e.wasmByteCode) !== null && o !== void 0 ? o : new Uint8Array(), O.instantiatePermission = e.instantiatePermission !== void 0 && e.instantiatePermission !== null ? AccessConfig.fromPartial(e.instantiatePermission) : void 0, O.unpinCode = (u = e.unpinCode) !== null && u !== void 0 ? u : !1, O.admin = (c = e.admin) !== null && c !== void 0 ? c : "", O.label = (d = e.label) !== null && d !== void 0 ? d : "", O.msg = (m = e.msg) !== null && m !== void 0 ? m : new Uint8Array(), O.funds = ((v = e.funds) === null || v === void 0 ? void 0 : v.map((T) => Coin.fromPartial(T))) || [], O.source = (S = e.source) !== null && S !== void 0 ? S : "", O.builder = ($ = e.builder) !== null && $ !== void 0 ? $ : "", O.codeHash = (E = e.codeHash) !== null && E !== void 0 ? E : new Uint8Array(), O;
  },
  fromAmino(e) {
    return {
      authority: e.authority,
      wasmByteCode: build$a.fromBase64(e.wasm_byte_code),
      instantiatePermission: e != null && e.instantiate_permission ? AccessConfig.fromAmino(e.instantiate_permission) : void 0,
      unpinCode: e.unpin_code,
      admin: e.admin,
      label: e.label,
      msg: build$a.toUtf8(JSON.stringify(e.msg)),
      funds: Array.isArray(e == null ? void 0 : e.funds) ? e.funds.map((n) => Coin.fromAmino(n)) : [],
      source: e.source,
      builder: e.builder,
      codeHash: e.code_hash
    };
  },
  toAmino(e) {
    const n = {};
    return n.authority = e.authority, n.wasm_byte_code = e.wasmByteCode ? build$a.toBase64(e.wasmByteCode) : void 0, n.instantiate_permission = e.instantiatePermission ? AccessConfig.toAmino(e.instantiatePermission) : void 0, n.unpin_code = e.unpinCode, n.admin = e.admin, n.label = e.label, n.msg = e.msg ? JSON.parse(build$a.fromUtf8(e.msg)) : void 0, e.funds ? n.funds = e.funds.map((o) => o ? Coin.toAmino(o) : void 0) : n.funds = [], n.source = e.source, n.builder = e.builder, n.code_hash = e.codeHash, n;
  },
  fromAminoMsg(e) {
    return MsgStoreAndInstantiateContract.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgStoreAndInstantiateContract",
      value: MsgStoreAndInstantiateContract.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgStoreAndInstantiateContract.decode(e.value);
  },
  toProto(e) {
    return MsgStoreAndInstantiateContract.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
      value: MsgStoreAndInstantiateContract.encode(e).finish()
    };
  }
};
function createBaseMsgStoreAndInstantiateContractResponse() {
  return {
    address: "",
    data: new Uint8Array()
  };
}
const MsgStoreAndInstantiateContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContractResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.data.length !== 0 && n.uint32(18).bytes(e.data), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgStoreAndInstantiateContractResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.data = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgStoreAndInstantiateContractResponse();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.data = (o = e.data) !== null && o !== void 0 ? o : new Uint8Array(), u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      data: e.data
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.data = e.data, n;
  },
  fromAminoMsg(e) {
    return MsgStoreAndInstantiateContractResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "wasm/MsgStoreAndInstantiateContractResponse",
      value: MsgStoreAndInstantiateContractResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgStoreAndInstantiateContractResponse.decode(e.value);
  },
  toProto(e) {
    return MsgStoreAndInstantiateContractResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContractResponse",
      value: MsgStoreAndInstantiateContractResponse.encode(e).finish()
    };
  }
}, _105 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClearAdmin,
  MsgClearAdminResponse,
  MsgExecuteContract,
  MsgExecuteContractResponse,
  MsgInstantiateContract,
  MsgInstantiateContract2,
  MsgInstantiateContract2Response,
  MsgInstantiateContractResponse,
  MsgMigrateContract,
  MsgMigrateContractResponse,
  MsgPinCodes,
  MsgPinCodesResponse,
  MsgStoreAndInstantiateContract,
  MsgStoreAndInstantiateContractResponse,
  MsgStoreCode,
  MsgStoreCodeResponse,
  MsgSudoContract,
  MsgSudoContractResponse,
  MsgUnpinCodes,
  MsgUnpinCodesResponse,
  MsgUpdateAdmin,
  MsgUpdateAdminResponse,
  MsgUpdateInstantiateConfig,
  MsgUpdateInstantiateConfigResponse,
  MsgUpdateParams,
  MsgUpdateParamsResponse
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$b = {
  "/cosmwasm.wasm.v1.MsgStoreCode": {
    aminoType: "wasm/MsgStoreCode",
    toAmino: MsgStoreCode.toAmino,
    fromAmino: MsgStoreCode.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgInstantiateContract": {
    aminoType: "wasm/MsgInstantiateContract",
    toAmino: MsgInstantiateContract.toAmino,
    fromAmino: MsgInstantiateContract.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgInstantiateContract2": {
    aminoType: "wasm/MsgInstantiateContract2",
    toAmino: MsgInstantiateContract2.toAmino,
    fromAmino: MsgInstantiateContract2.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgExecuteContract": {
    aminoType: "wasm/MsgExecuteContract",
    toAmino: MsgExecuteContract.toAmino,
    fromAmino: MsgExecuteContract.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgMigrateContract": {
    aminoType: "wasm/MsgMigrateContract",
    toAmino: MsgMigrateContract.toAmino,
    fromAmino: MsgMigrateContract.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgUpdateAdmin": {
    aminoType: "wasm/MsgUpdateAdmin",
    toAmino: MsgUpdateAdmin.toAmino,
    fromAmino: MsgUpdateAdmin.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgClearAdmin": {
    aminoType: "wasm/MsgClearAdmin",
    toAmino: MsgClearAdmin.toAmino,
    fromAmino: MsgClearAdmin.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig": {
    aminoType: "wasm/MsgUpdateInstantiateConfig",
    toAmino: MsgUpdateInstantiateConfig.toAmino,
    fromAmino: MsgUpdateInstantiateConfig.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgUpdateParams": {
    aminoType: "wasm/MsgUpdateParams",
    toAmino: MsgUpdateParams.toAmino,
    fromAmino: MsgUpdateParams.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgSudoContract": {
    aminoType: "wasm/MsgSudoContract",
    toAmino: MsgSudoContract.toAmino,
    fromAmino: MsgSudoContract.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgPinCodes": {
    aminoType: "wasm/MsgPinCodes",
    toAmino: MsgPinCodes.toAmino,
    fromAmino: MsgPinCodes.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgUnpinCodes": {
    aminoType: "wasm/MsgUnpinCodes",
    toAmino: MsgUnpinCodes.toAmino,
    fromAmino: MsgUnpinCodes.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract": {
    aminoType: "wasm/MsgStoreAndInstantiateContract",
    toAmino: MsgStoreAndInstantiateContract.toAmino,
    fromAmino: MsgStoreAndInstantiateContract.fromAmino
  }
}, _261 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$b
}, Symbol.toStringTag, { value: "Module" })), registry$c = [["/cosmwasm.wasm.v1.MsgStoreCode", MsgStoreCode], ["/cosmwasm.wasm.v1.MsgInstantiateContract", MsgInstantiateContract], ["/cosmwasm.wasm.v1.MsgInstantiateContract2", MsgInstantiateContract2], ["/cosmwasm.wasm.v1.MsgExecuteContract", MsgExecuteContract], ["/cosmwasm.wasm.v1.MsgMigrateContract", MsgMigrateContract], ["/cosmwasm.wasm.v1.MsgUpdateAdmin", MsgUpdateAdmin], ["/cosmwasm.wasm.v1.MsgClearAdmin", MsgClearAdmin], ["/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig", MsgUpdateInstantiateConfig], ["/cosmwasm.wasm.v1.MsgUpdateParams", MsgUpdateParams], ["/cosmwasm.wasm.v1.MsgSudoContract", MsgSudoContract], ["/cosmwasm.wasm.v1.MsgPinCodes", MsgPinCodes], ["/cosmwasm.wasm.v1.MsgUnpinCodes", MsgUnpinCodes], ["/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract", MsgStoreAndInstantiateContract]], load$a = (e) => {
  registry$c.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$a = {
  encoded: {
    storeCode(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
        value: MsgStoreCode.encode(e).finish()
      };
    },
    instantiateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value: MsgInstantiateContract.encode(e).finish()
      };
    },
    instantiateContract2(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
        value: MsgInstantiateContract2.encode(e).finish()
      };
    },
    executeContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value: MsgExecuteContract.encode(e).finish()
      };
    },
    migrateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value: MsgMigrateContract.encode(e).finish()
      };
    },
    updateAdmin(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value: MsgUpdateAdmin.encode(e).finish()
      };
    },
    clearAdmin(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value: MsgClearAdmin.encode(e).finish()
      };
    },
    updateInstantiateConfig(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
        value: MsgUpdateInstantiateConfig.encode(e).finish()
      };
    },
    updateParams(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
        value: MsgUpdateParams.encode(e).finish()
      };
    },
    sudoContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
        value: MsgSudoContract.encode(e).finish()
      };
    },
    pinCodes(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
        value: MsgPinCodes.encode(e).finish()
      };
    },
    unpinCodes(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
        value: MsgUnpinCodes.encode(e).finish()
      };
    },
    storeAndInstantiateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
        value: MsgStoreAndInstantiateContract.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    storeCode(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
        value: e
      };
    },
    instantiateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value: e
      };
    },
    instantiateContract2(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
        value: e
      };
    },
    executeContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value: e
      };
    },
    migrateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value: e
      };
    },
    updateAdmin(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value: e
      };
    },
    clearAdmin(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value: e
      };
    },
    updateInstantiateConfig(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
        value: e
      };
    },
    updateParams(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
        value: e
      };
    },
    sudoContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
        value: e
      };
    },
    pinCodes(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
        value: e
      };
    },
    unpinCodes(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
        value: e
      };
    },
    storeAndInstantiateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
        value: e
      };
    }
  },
  fromPartial: {
    storeCode(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
        value: MsgStoreCode.fromPartial(e)
      };
    },
    instantiateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value: MsgInstantiateContract.fromPartial(e)
      };
    },
    instantiateContract2(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
        value: MsgInstantiateContract2.fromPartial(e)
      };
    },
    executeContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value: MsgExecuteContract.fromPartial(e)
      };
    },
    migrateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value: MsgMigrateContract.fromPartial(e)
      };
    },
    updateAdmin(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value: MsgUpdateAdmin.fromPartial(e)
      };
    },
    clearAdmin(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value: MsgClearAdmin.fromPartial(e)
      };
    },
    updateInstantiateConfig(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
        value: MsgUpdateInstantiateConfig.fromPartial(e)
      };
    },
    updateParams(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
        value: MsgUpdateParams.fromPartial(e)
      };
    },
    sudoContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
        value: MsgSudoContract.fromPartial(e)
      };
    },
    pinCodes(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
        value: MsgPinCodes.fromPartial(e)
      };
    },
    unpinCodes(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
        value: MsgUnpinCodes.fromPartial(e)
      };
    },
    storeAndInstantiateContract(e) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
        value: MsgStoreAndInstantiateContract.fromPartial(e)
      };
    }
  }
}, _262 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$a,
  load: load$a,
  registry: registry$c
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$h = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.contractInfo = this.contractInfo.bind(this), this.contractHistory = this.contractHistory.bind(this), this.contractsByCode = this.contractsByCode.bind(this), this.allContractState = this.allContractState.bind(this), this.rawContractState = this.rawContractState.bind(this), this.smartContractState = this.smartContractState.bind(this), this.code = this.code.bind(this), this.codes = this.codes.bind(this), this.pinnedCodes = this.pinnedCodes.bind(this), this.params = this.params.bind(this), this.contractsByCreator = this.contractsByCreator.bind(this);
  }
  /* ContractInfo gets the contract meta data */
  async contractInfo(n) {
    const o = `cosmwasm/wasm/v1/contract/${n.address}`;
    return await this.req.get(o);
  }
  /* ContractHistory gets the contract code history */
  async contractHistory(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmwasm/wasm/v1/contract/${n.address}/history`;
    return await this.req.get(u, o);
  }
  /* ContractsByCode lists all smart contracts for a code id */
  async contractsByCode(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmwasm/wasm/v1/code/${n.codeId}/contracts`;
    return await this.req.get(u, o);
  }
  /* AllContractState gets all raw store data for a single contract */
  async allContractState(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmwasm/wasm/v1/contract/${n.address}/state`;
    return await this.req.get(u, o);
  }
  /* RawContractState gets single key from the raw store data of a contract */
  async rawContractState(n) {
    const o = `cosmwasm/wasm/v1/contract/${n.address}/raw/${n.queryData}`;
    return await this.req.get(o);
  }
  /* SmartContractState get smart query result from the contract */
  async smartContractState(n) {
    const o = `cosmwasm/wasm/v1/contract/${n.address}/smart/${n.queryData}`;
    return await this.req.get(o);
  }
  /* Code gets the binary code and metadata for a singe wasm code */
  async code(n) {
    const o = `cosmwasm/wasm/v1/code/${n.codeId}`;
    return await this.req.get(o);
  }
  /* Codes gets the metadata for all stored wasm codes */
  async codes(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmwasm/wasm/v1/code";
    return await this.req.get(u, o);
  }
  /* PinnedCodes gets the pinned code ids */
  async pinnedCodes(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "cosmwasm/wasm/v1/codes/pinned";
    return await this.req.get(u, o);
  }
  /* Params gets the module params */
  async params(n = {}) {
    const o = "cosmwasm/wasm/v1/codes/params";
    return await this.req.get(o);
  }
  /* ContractsByCreator gets the contracts by creator */
  async contractsByCreator(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = `cosmwasm/wasm/v1/contracts/creator/${n.creatorAddress}`;
    return await this.req.get(u, o);
  }
};
const _263 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$h
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$h = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.contractInfo = this.contractInfo.bind(this), this.contractHistory = this.contractHistory.bind(this), this.contractsByCode = this.contractsByCode.bind(this), this.allContractState = this.allContractState.bind(this), this.rawContractState = this.rawContractState.bind(this), this.smartContractState = this.smartContractState.bind(this), this.code = this.code.bind(this), this.codes = this.codes.bind(this), this.pinnedCodes = this.pinnedCodes.bind(this), this.params = this.params.bind(this), this.contractsByCreator = this.contractsByCreator.bind(this);
  }
  contractInfo(n) {
    const o = QueryContractInfoRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractInfo", o).then((c) => QueryContractInfoResponse.decode(new minimal.Reader(c)));
  }
  contractHistory(n) {
    const o = QueryContractHistoryRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractHistory", o).then((c) => QueryContractHistoryResponse.decode(new minimal.Reader(c)));
  }
  contractsByCode(n) {
    const o = QueryContractsByCodeRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCode", o).then((c) => QueryContractsByCodeResponse.decode(new minimal.Reader(c)));
  }
  allContractState(n) {
    const o = QueryAllContractStateRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "AllContractState", o).then((c) => QueryAllContractStateResponse.decode(new minimal.Reader(c)));
  }
  rawContractState(n) {
    const o = QueryRawContractStateRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "RawContractState", o).then((c) => QueryRawContractStateResponse.decode(new minimal.Reader(c)));
  }
  smartContractState(n) {
    const o = QuerySmartContractStateRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "SmartContractState", o).then((c) => QuerySmartContractStateResponse.decode(new minimal.Reader(c)));
  }
  code(n) {
    const o = QueryCodeRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "Code", o).then((c) => QueryCodeResponse.decode(new minimal.Reader(c)));
  }
  codes(n = {
    pagination: void 0
  }) {
    const o = QueryCodesRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "Codes", o).then((c) => QueryCodesResponse.decode(new minimal.Reader(c)));
  }
  pinnedCodes(n = {
    pagination: void 0
  }) {
    const o = QueryPinnedCodesRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "PinnedCodes", o).then((c) => QueryPinnedCodesResponse.decode(new minimal.Reader(c)));
  }
  params(n = {}) {
    const o = QueryParamsRequest$6.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "Params", o).then((c) => QueryParamsResponse$6.decode(new minimal.Reader(c)));
  }
  contractsByCreator(n) {
    const o = QueryContractsByCreatorRequest.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCreator", o).then((c) => QueryContractsByCreatorResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$h = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$h(n);
  return {
    contractInfo(u) {
      return o.contractInfo(u);
    },
    contractHistory(u) {
      return o.contractHistory(u);
    },
    contractsByCode(u) {
      return o.contractsByCode(u);
    },
    allContractState(u) {
      return o.allContractState(u);
    },
    rawContractState(u) {
      return o.rawContractState(u);
    },
    smartContractState(u) {
      return o.smartContractState(u);
    },
    code(u) {
      return o.code(u);
    },
    codes(u) {
      return o.codes(u);
    },
    pinnedCodes(u) {
      return o.pinnedCodes(u);
    },
    params(u) {
      return o.params(u);
    },
    contractsByCreator(u) {
      return o.contractsByCreator(u);
    }
  };
}, _264 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$h,
  createRpcQueryExtension: createRpcQueryExtension$h
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$a = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.storeCode = this.storeCode.bind(this), this.instantiateContract = this.instantiateContract.bind(this), this.instantiateContract2 = this.instantiateContract2.bind(this), this.executeContract = this.executeContract.bind(this), this.migrateContract = this.migrateContract.bind(this), this.updateAdmin = this.updateAdmin.bind(this), this.clearAdmin = this.clearAdmin.bind(this), this.updateInstantiateConfig = this.updateInstantiateConfig.bind(this), this.updateParams = this.updateParams.bind(this), this.sudoContract = this.sudoContract.bind(this), this.pinCodes = this.pinCodes.bind(this), this.unpinCodes = this.unpinCodes.bind(this), this.storeAndInstantiateContract = this.storeAndInstantiateContract.bind(this);
  }
  storeCode(n) {
    const o = MsgStoreCode.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", o).then((c) => MsgStoreCodeResponse.decode(new minimal.Reader(c)));
  }
  instantiateContract(n) {
    const o = MsgInstantiateContract.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", o).then((c) => MsgInstantiateContractResponse.decode(new minimal.Reader(c)));
  }
  instantiateContract2(n) {
    const o = MsgInstantiateContract2.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract2", o).then((c) => MsgInstantiateContract2Response.decode(new minimal.Reader(c)));
  }
  executeContract(n) {
    const o = MsgExecuteContract.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", o).then((c) => MsgExecuteContractResponse.decode(new minimal.Reader(c)));
  }
  migrateContract(n) {
    const o = MsgMigrateContract.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", o).then((c) => MsgMigrateContractResponse.decode(new minimal.Reader(c)));
  }
  updateAdmin(n) {
    const o = MsgUpdateAdmin.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", o).then((c) => MsgUpdateAdminResponse.decode(new minimal.Reader(c)));
  }
  clearAdmin(n) {
    const o = MsgClearAdmin.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", o).then((c) => MsgClearAdminResponse.decode(new minimal.Reader(c)));
  }
  updateInstantiateConfig(n) {
    const o = MsgUpdateInstantiateConfig.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateInstantiateConfig", o).then((c) => MsgUpdateInstantiateConfigResponse.decode(new minimal.Reader(c)));
  }
  updateParams(n) {
    const o = MsgUpdateParams.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateParams", o).then((c) => MsgUpdateParamsResponse.decode(new minimal.Reader(c)));
  }
  sudoContract(n) {
    const o = MsgSudoContract.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "SudoContract", o).then((c) => MsgSudoContractResponse.decode(new minimal.Reader(c)));
  }
  pinCodes(n) {
    const o = MsgPinCodes.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "PinCodes", o).then((c) => MsgPinCodesResponse.decode(new minimal.Reader(c)));
  }
  unpinCodes(n) {
    const o = MsgUnpinCodes.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "UnpinCodes", o).then((c) => MsgUnpinCodesResponse.decode(new minimal.Reader(c)));
  }
  storeAndInstantiateContract(n) {
    const o = MsgStoreAndInstantiateContract.encode(n).finish();
    return this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreAndInstantiateContract", o).then((c) => MsgStoreAndInstantiateContractResponse.decode(new minimal.Reader(c)));
  }
};
const _265 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$a
}, Symbol.toStringTag, { value: "Module" })), createLCDClient$1 = async ({
  restEndpoint: e
}) => {
  const n = new LCDClient({
    restEndpoint: e
  });
  return {
    cosmos: {
      auth: {
        v1beta1: new (await Promise.resolve().then(() => _202)).LCDQueryClient({
          requestClient: n
        })
      },
      authz: {
        v1beta1: new (await Promise.resolve().then(() => _203)).LCDQueryClient({
          requestClient: n
        })
      },
      bank: {
        v1beta1: new (await Promise.resolve().then(() => _204)).LCDQueryClient({
          requestClient: n
        })
      },
      base: {
        node: {
          v1beta1: new (await Promise.resolve().then(() => _205)).LCDQueryClient({
            requestClient: n
          })
        }
      },
      distribution: {
        v1beta1: new (await Promise.resolve().then(() => _206)).LCDQueryClient({
          requestClient: n
        })
      },
      gov: {
        v1beta1: new (await Promise.resolve().then(() => _207)).LCDQueryClient({
          requestClient: n
        }),
        v1: new (await Promise.resolve().then(() => _211)).LCDQueryClient({
          requestClient: n
        })
      },
      staking: {
        v1beta1: new (await Promise.resolve().then(() => _208)).LCDQueryClient({
          requestClient: n
        })
      },
      tx: {
        v1beta1: new (await Promise.resolve().then(() => _209)).LCDQueryClient({
          requestClient: n
        })
      },
      upgrade: {
        v1beta1: new (await Promise.resolve().then(() => _210)).LCDQueryClient({
          requestClient: n
        })
      }
    },
    cosmwasm: {
      wasm: {
        v1: new (await Promise.resolve().then(() => _263)).LCDQueryClient({
          requestClient: n
        })
      }
    }
  };
}, _341 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createLCDClient: createLCDClient$1
}, Symbol.toStringTag, { value: "Module" })), createRPCQueryClient$1 = async ({
  rpcEndpoint: e
}) => {
  const n = await build$2.Tendermint34Client.connect(e), o = new build$5.QueryClient(n);
  return {
    cosmos: {
      auth: {
        v1beta1: (await Promise.resolve().then(() => _212)).createRpcQueryExtension(o)
      },
      authz: {
        v1beta1: (await Promise.resolve().then(() => _213)).createRpcQueryExtension(o)
      },
      bank: {
        v1beta1: (await Promise.resolve().then(() => _214)).createRpcQueryExtension(o)
      },
      base: {
        node: {
          v1beta1: (await Promise.resolve().then(() => _215)).createRpcQueryExtension(o)
        }
      },
      distribution: {
        v1beta1: (await Promise.resolve().then(() => _216)).createRpcQueryExtension(o)
      },
      gov: {
        v1beta1: (await Promise.resolve().then(() => _217)).createRpcQueryExtension(o),
        v1: (await Promise.resolve().then(() => _221)).createRpcQueryExtension(o)
      },
      staking: {
        v1beta1: (await Promise.resolve().then(() => _218)).createRpcQueryExtension(o)
      },
      tx: {
        v1beta1: (await Promise.resolve().then(() => _219)).createRpcQueryExtension(o)
      },
      upgrade: {
        v1beta1: (await Promise.resolve().then(() => _220)).createRpcQueryExtension(o)
      }
    },
    cosmwasm: {
      wasm: {
        v1: (await Promise.resolve().then(() => _264)).createRpcQueryExtension(o)
      }
    }
  };
}, _342 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRPCQueryClient: createRPCQueryClient$1
}, Symbol.toStringTag, { value: "Module" })), createRPCMsgClient$1 = async ({
  rpc: e
}) => ({
  cosmos: {
    authz: {
      v1beta1: new (await Promise.resolve().then(() => _222)).MsgClientImpl(e)
    },
    bank: {
      v1beta1: new (await Promise.resolve().then(() => _223)).MsgClientImpl(e)
    },
    distribution: {
      v1beta1: new (await Promise.resolve().then(() => _224)).MsgClientImpl(e)
    },
    gov: {
      v1beta1: new (await Promise.resolve().then(() => _225)).MsgClientImpl(e),
      v1: new (await Promise.resolve().then(() => _227)).MsgClientImpl(e)
    },
    staking: {
      v1beta1: new (await Promise.resolve().then(() => _226)).MsgClientImpl(e)
    },
    upgrade: {
      v1beta1: new (await Promise.resolve().then(() => _228)).MsgClientImpl(e)
    }
  },
  cosmwasm: {
    wasm: {
      v1: new (await Promise.resolve().then(() => _265)).MsgClientImpl(e)
    }
  }
}), _343 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRPCMsgClient: createRPCMsgClient$1
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$7(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$7(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$7(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$7(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
let cosmwasm;
(function(e) {
  let n;
  (function(o) {
    o.v1 = _objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7(_objectSpread$7({}, _100), _101), _102), _103), _104), _105), _106), _261), _262), _263), _264), _265);
  })(n || (n = e.wasm || (e.wasm = {}))), e.ClientFactory = _objectSpread$7(_objectSpread$7(_objectSpread$7({}, _341), _342), _343);
})(cosmwasm || (cosmwasm = {}));
function ownKeys$6(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$6(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$6(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$6(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
_objectSpread$6({}, AminoConverter$b);
[...registry$c];
function createBaseAccumulatorContent() {
  return {
    accumValue: [],
    totalShares: ""
  };
}
const AccumulatorContent = {
  typeUrl: "/osmosis.accum.v1beta1.AccumulatorContent",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.accumValue)
      DecCoin.encode(o, n.uint32(10).fork()).ldelim();
    return e.totalShares !== "" && n.uint32(18).string(e.totalShares), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccumulatorContent();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.accumValue.push(DecCoin.decode(o, o.uint32()));
          break;
        case 2:
          c.totalShares = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseAccumulatorContent();
    return u.accumValue = ((n = e.accumValue) === null || n === void 0 ? void 0 : n.map((c) => DecCoin.fromPartial(c))) || [], u.totalShares = (o = e.totalShares) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      accumValue: Array.isArray(e == null ? void 0 : e.accum_value) ? e.accum_value.map((n) => DecCoin.fromAmino(n)) : [],
      totalShares: e.total_shares
    };
  },
  toAmino(e) {
    const n = {};
    return e.accumValue ? n.accum_value = e.accumValue.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.accum_value = [], n.total_shares = e.totalShares, n;
  },
  fromAminoMsg(e) {
    return AccumulatorContent.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/accum/accumulator-content",
      value: AccumulatorContent.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccumulatorContent.decode(e.value);
  },
  toProto(e) {
    return AccumulatorContent.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.accum.v1beta1.AccumulatorContent",
      value: AccumulatorContent.encode(e).finish()
    };
  }
};
function createBaseOptions() {
  return {};
}
const Options = {
  typeUrl: "/osmosis.accum.v1beta1.Options",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseOptions();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return Options.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/accum/options",
      value: Options.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Options.decode(e.value);
  },
  toProto(e) {
    return Options.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.accum.v1beta1.Options",
      value: Options.encode(e).finish()
    };
  }
};
function createBaseRecord() {
  return {
    numShares: "",
    initAccumValue: [],
    unclaimedRewards: [],
    options: void 0
  };
}
const Record = {
  typeUrl: "/osmosis.accum.v1beta1.Record",
  encode(e, n = minimal.Writer.create()) {
    e.numShares !== "" && n.uint32(10).string(e.numShares);
    for (const o of e.initAccumValue)
      DecCoin.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.unclaimedRewards)
      DecCoin.encode(o, n.uint32(26).fork()).ldelim();
    return e.options !== void 0 && Options.encode(e.options, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.numShares = o.string();
          break;
        case 2:
          c.initAccumValue.push(DecCoin.decode(o, o.uint32()));
          break;
        case 3:
          c.unclaimedRewards.push(DecCoin.decode(o, o.uint32()));
          break;
        case 4:
          c.options = Options.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRecord();
    return c.numShares = (n = e.numShares) !== null && n !== void 0 ? n : "", c.initAccumValue = ((o = e.initAccumValue) === null || o === void 0 ? void 0 : o.map((d) => DecCoin.fromPartial(d))) || [], c.unclaimedRewards = ((u = e.unclaimedRewards) === null || u === void 0 ? void 0 : u.map((d) => DecCoin.fromPartial(d))) || [], c.options = e.options !== void 0 && e.options !== null ? Options.fromPartial(e.options) : void 0, c;
  },
  fromAmino(e) {
    return {
      numShares: e.num_shares,
      initAccumValue: Array.isArray(e == null ? void 0 : e.init_accum_value) ? e.init_accum_value.map((n) => DecCoin.fromAmino(n)) : [],
      unclaimedRewards: Array.isArray(e == null ? void 0 : e.unclaimed_rewards) ? e.unclaimed_rewards.map((n) => DecCoin.fromAmino(n)) : [],
      options: e != null && e.options ? Options.fromAmino(e.options) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.num_shares = e.numShares, e.initAccumValue ? n.init_accum_value = e.initAccumValue.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.init_accum_value = [], e.unclaimedRewards ? n.unclaimed_rewards = e.unclaimedRewards.map((o) => o ? DecCoin.toAmino(o) : void 0) : n.unclaimed_rewards = [], n.options = e.options ? Options.toAmino(e.options) : void 0, n;
  },
  fromAminoMsg(e) {
    return Record.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/accum/record",
      value: Record.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Record.decode(e.value);
  },
  toProto(e) {
    return Record.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.accum.v1beta1.Record",
      value: Record.encode(e).finish()
    };
  }
}, _107 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccumulatorContent,
  Options,
  Record
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$b() {
  return {
    authorizedTickSpacing: [],
    authorizedSwapFees: []
  };
}
const Params$b = {
  typeUrl: "/osmosis.concentratedliquidity.Params",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.authorizedTickSpacing)
      n.uint64(o);
    n.ldelim();
    for (const o of e.authorizedSwapFees)
      n.uint32(18).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$b();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.authorizedTickSpacing.push(o.uint64());
          } else
            c.authorizedTickSpacing.push(o.uint64());
          break;
        case 2:
          c.authorizedSwapFees.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseParams$b();
    return u.authorizedTickSpacing = ((n = e.authorizedTickSpacing) === null || n === void 0 ? void 0 : n.map((c) => Long$2.fromValue(c))) || [], u.authorizedSwapFees = ((o = e.authorizedSwapFees) === null || o === void 0 ? void 0 : o.map((c) => c)) || [], u;
  },
  fromAmino(e) {
    return {
      authorizedTickSpacing: Array.isArray(e == null ? void 0 : e.authorized_tick_spacing) ? e.authorized_tick_spacing.map((n) => n) : [],
      authorizedSwapFees: Array.isArray(e == null ? void 0 : e.authorized_swap_fees) ? e.authorized_swap_fees.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.authorizedTickSpacing ? n.authorized_tick_spacing = e.authorizedTickSpacing.map((o) => o) : n.authorized_tick_spacing = [], e.authorizedSwapFees ? n.authorized_swap_fees = e.authorizedSwapFees.map((o) => o) : n.authorized_swap_fees = [], n;
  },
  fromAminoMsg(e) {
    return Params$b.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/params",
      value: Params$b.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$b.decode(e.value);
  },
  toProto(e) {
    return Params$b.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.Params",
      value: Params$b.encode(e).finish()
    };
  }
}, _108 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$b
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$a() {
  return {};
}
const Params$a = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$a();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseParams$a();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return Params$a.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/cosmwasmpool/params",
      value: Params$a.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$a.decode(e.value);
  },
  toProto(e) {
    return Params$a.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.Params",
      value: Params$a.encode(e).finish()
    };
  }
};
function createBaseGenesisState$e() {
  return {
    params: void 0
  };
}
const GenesisState$e = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$a.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$e();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$a.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGenesisState$e();
    return n.params = e.params !== void 0 && e.params !== null ? Params$a.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$a.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$a.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$e.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/cosmwasmpool/genesis-state",
      value: GenesisState$e.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$e.decode(e.value);
  },
  toProto(e) {
    return GenesisState$e.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.GenesisState",
      value: GenesisState$e.encode(e).finish()
    };
  }
}, _109 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$e,
  Params: Params$a
}, Symbol.toStringTag, { value: "Module" }));
function createBaseCosmWasmPool() {
  return {
    $typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
    poolAddress: "",
    contractAddress: "",
    poolId: Long$2.UZERO,
    codeId: Long$2.UZERO
  };
}
const CosmWasmPool = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
  encode(e, n = minimal.Writer.create()) {
    return e.poolAddress !== "" && n.uint32(10).string(e.poolAddress), e.contractAddress !== "" && n.uint32(18).string(e.contractAddress), e.poolId.isZero() || n.uint32(24).uint64(e.poolId), e.codeId.isZero() || n.uint32(32).uint64(e.codeId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCosmWasmPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolAddress = o.string();
          break;
        case 2:
          c.contractAddress = o.string();
          break;
        case 3:
          c.poolId = o.uint64();
          break;
        case 4:
          c.codeId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCosmWasmPool();
    return u.poolAddress = (n = e.poolAddress) !== null && n !== void 0 ? n : "", u.contractAddress = (o = e.contractAddress) !== null && o !== void 0 ? o : "", u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      poolAddress: e.pool_address,
      contractAddress: e.contract_address,
      poolId: Long$2.fromString(e.pool_id),
      codeId: Long$2.fromString(e.code_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_address = e.poolAddress, n.contract_address = e.contractAddress, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.code_id = e.codeId ? e.codeId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return CosmWasmPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/cosmwasmpool/cosm-wasm-pool",
      value: CosmWasmPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return CosmWasmPool.decode(e.value);
  },
  toProto(e) {
    return CosmWasmPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
      value: CosmWasmPool.encode(e).finish()
    };
  }
}, _110 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CosmWasmPool
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgCreateCosmWasmPool() {
  return {
    codeId: Long$2.UZERO,
    instantiateMsg: new Uint8Array(),
    sender: ""
  };
}
const MsgCreateCosmWasmPool = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.MsgCreateCosmWasmPool",
  encode(e, n = minimal.Writer.create()) {
    return e.codeId.isZero() || n.uint32(8).uint64(e.codeId), e.instantiateMsg.length !== 0 && n.uint32(18).bytes(e.instantiateMsg), e.sender !== "" && n.uint32(26).string(e.sender), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateCosmWasmPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.codeId = o.uint64();
          break;
        case 2:
          c.instantiateMsg = o.bytes();
          break;
        case 3:
          c.sender = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgCreateCosmWasmPool();
    return u.codeId = e.codeId !== void 0 && e.codeId !== null ? Long$2.fromValue(e.codeId) : Long$2.UZERO, u.instantiateMsg = (n = e.instantiateMsg) !== null && n !== void 0 ? n : new Uint8Array(), u.sender = (o = e.sender) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      codeId: Long$2.fromString(e.code_id),
      instantiateMsg: e.instantiate_msg,
      sender: e.sender
    };
  },
  toAmino(e) {
    const n = {};
    return n.code_id = e.codeId ? e.codeId.toString() : void 0, n.instantiate_msg = e.instantiateMsg, n.sender = e.sender, n;
  },
  fromAminoMsg(e) {
    return MsgCreateCosmWasmPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/cosmwasmpool/create-cosm-wasm-pool",
      value: MsgCreateCosmWasmPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateCosmWasmPool.decode(e.value);
  },
  toProto(e) {
    return MsgCreateCosmWasmPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.MsgCreateCosmWasmPool",
      value: MsgCreateCosmWasmPool.encode(e).finish()
    };
  }
};
function createBaseMsgCreateCosmWasmPoolResponse() {
  return {
    poolId: Long$2.UZERO
  };
}
const MsgCreateCosmWasmPoolResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.MsgCreateCosmWasmPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateCosmWasmPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgCreateCosmWasmPoolResponse();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgCreateCosmWasmPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/cosmwasmpool/create-cosm-wasm-pool-response",
      value: MsgCreateCosmWasmPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateCosmWasmPoolResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCreateCosmWasmPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.MsgCreateCosmWasmPoolResponse",
      value: MsgCreateCosmWasmPoolResponse.encode(e).finish()
    };
  }
}, _111 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgCreateCosmWasmPool,
  MsgCreateCosmWasmPoolResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParamsRequest$3() {
  return {};
}
const ParamsRequest$3 = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParamsRequest$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseParamsRequest$3();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ParamsRequest$3.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/cosmwasmpool/params-request",
      value: ParamsRequest$3.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ParamsRequest$3.decode(e.value);
  },
  toProto(e) {
    return ParamsRequest$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ParamsRequest",
      value: ParamsRequest$3.encode(e).finish()
    };
  }
};
function createBaseParamsResponse$3() {
  return {
    params: void 0
  };
}
const ParamsResponse$3 = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$a.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParamsResponse$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$a.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseParamsResponse$3();
    return n.params = e.params !== void 0 && e.params !== null ? Params$a.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$a.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$a.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return ParamsResponse$3.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/cosmwasmpool/params-response",
      value: ParamsResponse$3.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ParamsResponse$3.decode(e.value);
  },
  toProto(e) {
    return ParamsResponse$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ParamsResponse",
      value: ParamsResponse$3.encode(e).finish()
    };
  }
}, _112 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ParamsRequest: ParamsRequest$3,
  ParamsResponse: ParamsResponse$3
}, Symbol.toStringTag, { value: "Module" })), _113 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
let Downtime;
(function(e) {
  e[e.DURATION_30S = 0] = "DURATION_30S", e[e.DURATION_1M = 1] = "DURATION_1M", e[e.DURATION_2M = 2] = "DURATION_2M", e[e.DURATION_3M = 3] = "DURATION_3M", e[e.DURATION_4M = 4] = "DURATION_4M", e[e.DURATION_5M = 5] = "DURATION_5M", e[e.DURATION_10M = 6] = "DURATION_10M", e[e.DURATION_20M = 7] = "DURATION_20M", e[e.DURATION_30M = 8] = "DURATION_30M", e[e.DURATION_40M = 9] = "DURATION_40M", e[e.DURATION_50M = 10] = "DURATION_50M", e[e.DURATION_1H = 11] = "DURATION_1H", e[e.DURATION_1_5H = 12] = "DURATION_1_5H", e[e.DURATION_2H = 13] = "DURATION_2H", e[e.DURATION_2_5H = 14] = "DURATION_2_5H", e[e.DURATION_3H = 15] = "DURATION_3H", e[e.DURATION_4H = 16] = "DURATION_4H", e[e.DURATION_5H = 17] = "DURATION_5H", e[e.DURATION_6H = 18] = "DURATION_6H", e[e.DURATION_9H = 19] = "DURATION_9H", e[e.DURATION_12H = 20] = "DURATION_12H", e[e.DURATION_18H = 21] = "DURATION_18H", e[e.DURATION_24H = 22] = "DURATION_24H", e[e.DURATION_36H = 23] = "DURATION_36H", e[e.DURATION_48H = 24] = "DURATION_48H", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(Downtime || (Downtime = {}));
const DowntimeSDKType = Downtime, DowntimeAmino = Downtime;
function downtimeFromJSON(e) {
  switch (e) {
    case 0:
    case "DURATION_30S":
      return Downtime.DURATION_30S;
    case 1:
    case "DURATION_1M":
      return Downtime.DURATION_1M;
    case 2:
    case "DURATION_2M":
      return Downtime.DURATION_2M;
    case 3:
    case "DURATION_3M":
      return Downtime.DURATION_3M;
    case 4:
    case "DURATION_4M":
      return Downtime.DURATION_4M;
    case 5:
    case "DURATION_5M":
      return Downtime.DURATION_5M;
    case 6:
    case "DURATION_10M":
      return Downtime.DURATION_10M;
    case 7:
    case "DURATION_20M":
      return Downtime.DURATION_20M;
    case 8:
    case "DURATION_30M":
      return Downtime.DURATION_30M;
    case 9:
    case "DURATION_40M":
      return Downtime.DURATION_40M;
    case 10:
    case "DURATION_50M":
      return Downtime.DURATION_50M;
    case 11:
    case "DURATION_1H":
      return Downtime.DURATION_1H;
    case 12:
    case "DURATION_1_5H":
      return Downtime.DURATION_1_5H;
    case 13:
    case "DURATION_2H":
      return Downtime.DURATION_2H;
    case 14:
    case "DURATION_2_5H":
      return Downtime.DURATION_2_5H;
    case 15:
    case "DURATION_3H":
      return Downtime.DURATION_3H;
    case 16:
    case "DURATION_4H":
      return Downtime.DURATION_4H;
    case 17:
    case "DURATION_5H":
      return Downtime.DURATION_5H;
    case 18:
    case "DURATION_6H":
      return Downtime.DURATION_6H;
    case 19:
    case "DURATION_9H":
      return Downtime.DURATION_9H;
    case 20:
    case "DURATION_12H":
      return Downtime.DURATION_12H;
    case 21:
    case "DURATION_18H":
      return Downtime.DURATION_18H;
    case 22:
    case "DURATION_24H":
      return Downtime.DURATION_24H;
    case 23:
    case "DURATION_36H":
      return Downtime.DURATION_36H;
    case 24:
    case "DURATION_48H":
      return Downtime.DURATION_48H;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Downtime.UNRECOGNIZED;
  }
}
function downtimeToJSON(e) {
  switch (e) {
    case Downtime.DURATION_30S:
      return "DURATION_30S";
    case Downtime.DURATION_1M:
      return "DURATION_1M";
    case Downtime.DURATION_2M:
      return "DURATION_2M";
    case Downtime.DURATION_3M:
      return "DURATION_3M";
    case Downtime.DURATION_4M:
      return "DURATION_4M";
    case Downtime.DURATION_5M:
      return "DURATION_5M";
    case Downtime.DURATION_10M:
      return "DURATION_10M";
    case Downtime.DURATION_20M:
      return "DURATION_20M";
    case Downtime.DURATION_30M:
      return "DURATION_30M";
    case Downtime.DURATION_40M:
      return "DURATION_40M";
    case Downtime.DURATION_50M:
      return "DURATION_50M";
    case Downtime.DURATION_1H:
      return "DURATION_1H";
    case Downtime.DURATION_1_5H:
      return "DURATION_1_5H";
    case Downtime.DURATION_2H:
      return "DURATION_2H";
    case Downtime.DURATION_2_5H:
      return "DURATION_2_5H";
    case Downtime.DURATION_3H:
      return "DURATION_3H";
    case Downtime.DURATION_4H:
      return "DURATION_4H";
    case Downtime.DURATION_5H:
      return "DURATION_5H";
    case Downtime.DURATION_6H:
      return "DURATION_6H";
    case Downtime.DURATION_9H:
      return "DURATION_9H";
    case Downtime.DURATION_12H:
      return "DURATION_12H";
    case Downtime.DURATION_18H:
      return "DURATION_18H";
    case Downtime.DURATION_24H:
      return "DURATION_24H";
    case Downtime.DURATION_36H:
      return "DURATION_36H";
    case Downtime.DURATION_48H:
      return "DURATION_48H";
    case Downtime.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
const _114 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get Downtime() {
    return Downtime;
  },
  DowntimeAmino,
  DowntimeSDKType,
  downtimeFromJSON,
  downtimeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisDowntimeEntry() {
  return {
    duration: 0,
    lastDowntime: void 0
  };
}
const GenesisDowntimeEntry = {
  typeUrl: "/osmosis.downtimedetector.v1beta1.GenesisDowntimeEntry",
  encode(e, n = minimal.Writer.create()) {
    return e.duration !== 0 && n.uint32(8).int32(e.duration), e.lastDowntime !== void 0 && Timestamp.encode(toTimestamp(e.lastDowntime), n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisDowntimeEntry();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.duration = o.int32();
          break;
        case 2:
          c.lastDowntime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisDowntimeEntry();
    return u.duration = (n = e.duration) !== null && n !== void 0 ? n : 0, u.lastDowntime = (o = e.lastDowntime) !== null && o !== void 0 ? o : void 0, u;
  },
  fromAmino(e) {
    return {
      duration: isSet(e.duration) ? downtimeFromJSON(e.duration) : 0,
      lastDowntime: e != null && e.last_downtime ? Timestamp.fromAmino(e.last_downtime) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.duration = e.duration, n.last_downtime = e.lastDowntime ? Timestamp.toAmino(e.lastDowntime) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisDowntimeEntry.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/downtimedetector/genesis-downtime-entry",
      value: GenesisDowntimeEntry.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisDowntimeEntry.decode(e.value);
  },
  toProto(e) {
    return GenesisDowntimeEntry.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.downtimedetector.v1beta1.GenesisDowntimeEntry",
      value: GenesisDowntimeEntry.encode(e).finish()
    };
  }
};
function createBaseGenesisState$d() {
  return {
    downtimes: [],
    lastBlockTime: void 0
  };
}
const GenesisState$d = {
  typeUrl: "/osmosis.downtimedetector.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.downtimes)
      GenesisDowntimeEntry.encode(o, n.uint32(10).fork()).ldelim();
    return e.lastBlockTime !== void 0 && Timestamp.encode(toTimestamp(e.lastBlockTime), n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$d();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.downtimes.push(GenesisDowntimeEntry.decode(o, o.uint32()));
          break;
        case 2:
          c.lastBlockTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisState$d();
    return u.downtimes = ((n = e.downtimes) === null || n === void 0 ? void 0 : n.map((c) => GenesisDowntimeEntry.fromPartial(c))) || [], u.lastBlockTime = (o = e.lastBlockTime) !== null && o !== void 0 ? o : void 0, u;
  },
  fromAmino(e) {
    return {
      downtimes: Array.isArray(e == null ? void 0 : e.downtimes) ? e.downtimes.map((n) => GenesisDowntimeEntry.fromAmino(n)) : [],
      lastBlockTime: e != null && e.last_block_time ? Timestamp.fromAmino(e.last_block_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.downtimes ? n.downtimes = e.downtimes.map((o) => o ? GenesisDowntimeEntry.toAmino(o) : void 0) : n.downtimes = [], n.last_block_time = e.lastBlockTime ? Timestamp.toAmino(e.lastBlockTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$d.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/downtimedetector/genesis-state",
      value: GenesisState$d.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$d.decode(e.value);
  },
  toProto(e) {
    return GenesisState$d.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.downtimedetector.v1beta1.GenesisState",
      value: GenesisState$d.encode(e).finish()
    };
  }
}, _115 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisDowntimeEntry,
  GenesisState: GenesisState$d
}, Symbol.toStringTag, { value: "Module" }));
function createBaseRecoveredSinceDowntimeOfLengthRequest() {
  return {
    downtime: 0,
    recovery: void 0
  };
}
const RecoveredSinceDowntimeOfLengthRequest = {
  typeUrl: "/osmosis.downtimedetector.v1beta1.RecoveredSinceDowntimeOfLengthRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.downtime !== 0 && n.uint32(8).int32(e.downtime), e.recovery !== void 0 && Duration.encode(e.recovery, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRecoveredSinceDowntimeOfLengthRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.downtime = o.int32();
          break;
        case 2:
          c.recovery = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRecoveredSinceDowntimeOfLengthRequest();
    return o.downtime = (n = e.downtime) !== null && n !== void 0 ? n : 0, o.recovery = e.recovery !== void 0 && e.recovery !== null ? Duration.fromPartial(e.recovery) : void 0, o;
  },
  fromAmino(e) {
    return {
      downtime: isSet(e.downtime) ? downtimeFromJSON(e.downtime) : 0,
      recovery: e != null && e.recovery ? Duration.fromAmino(e.recovery) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.downtime = e.downtime, n.recovery = e.recovery ? Duration.toAmino(e.recovery) : void 0, n;
  },
  fromAminoMsg(e) {
    return RecoveredSinceDowntimeOfLengthRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/downtimedetector/recovered-since-downtime-of-length-request",
      value: RecoveredSinceDowntimeOfLengthRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RecoveredSinceDowntimeOfLengthRequest.decode(e.value);
  },
  toProto(e) {
    return RecoveredSinceDowntimeOfLengthRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.downtimedetector.v1beta1.RecoveredSinceDowntimeOfLengthRequest",
      value: RecoveredSinceDowntimeOfLengthRequest.encode(e).finish()
    };
  }
};
function createBaseRecoveredSinceDowntimeOfLengthResponse() {
  return {
    succesfullyRecovered: !1
  };
}
const RecoveredSinceDowntimeOfLengthResponse = {
  typeUrl: "/osmosis.downtimedetector.v1beta1.RecoveredSinceDowntimeOfLengthResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.succesfullyRecovered === !0 && n.uint32(8).bool(e.succesfullyRecovered), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRecoveredSinceDowntimeOfLengthResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.succesfullyRecovered = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRecoveredSinceDowntimeOfLengthResponse();
    return o.succesfullyRecovered = (n = e.succesfullyRecovered) !== null && n !== void 0 ? n : !1, o;
  },
  fromAmino(e) {
    return {
      succesfullyRecovered: e.succesfully_recovered
    };
  },
  toAmino(e) {
    const n = {};
    return n.succesfully_recovered = e.succesfullyRecovered, n;
  },
  fromAminoMsg(e) {
    return RecoveredSinceDowntimeOfLengthResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/downtimedetector/recovered-since-downtime-of-length-response",
      value: RecoveredSinceDowntimeOfLengthResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RecoveredSinceDowntimeOfLengthResponse.decode(e.value);
  },
  toProto(e) {
    return RecoveredSinceDowntimeOfLengthResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.downtimedetector.v1beta1.RecoveredSinceDowntimeOfLengthResponse",
      value: RecoveredSinceDowntimeOfLengthResponse.encode(e).finish()
    };
  }
}, _116 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RecoveredSinceDowntimeOfLengthRequest,
  RecoveredSinceDowntimeOfLengthResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseEpochInfo() {
  return {
    identifier: "",
    startTime: void 0,
    duration: void 0,
    currentEpoch: Long$2.ZERO,
    currentEpochStartTime: void 0,
    epochCountingStarted: !1,
    currentEpochStartHeight: Long$2.ZERO
  };
}
const EpochInfo = {
  typeUrl: "/osmosis.epochs.v1beta1.EpochInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.identifier !== "" && n.uint32(10).string(e.identifier), e.startTime !== void 0 && Timestamp.encode(toTimestamp(e.startTime), n.uint32(18).fork()).ldelim(), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(26).fork()).ldelim(), e.currentEpoch.isZero() || n.uint32(32).int64(e.currentEpoch), e.currentEpochStartTime !== void 0 && Timestamp.encode(toTimestamp(e.currentEpochStartTime), n.uint32(42).fork()).ldelim(), e.epochCountingStarted === !0 && n.uint32(48).bool(e.epochCountingStarted), e.currentEpochStartHeight.isZero() || n.uint32(64).int64(e.currentEpochStartHeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEpochInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.identifier = o.string();
          break;
        case 2:
          c.startTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 3:
          c.duration = Duration.decode(o, o.uint32());
          break;
        case 4:
          c.currentEpoch = o.int64();
          break;
        case 5:
          c.currentEpochStartTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 6:
          c.epochCountingStarted = o.bool();
          break;
        case 8:
          c.currentEpochStartHeight = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseEpochInfo();
    return d.identifier = (n = e.identifier) !== null && n !== void 0 ? n : "", d.startTime = (o = e.startTime) !== null && o !== void 0 ? o : void 0, d.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, d.currentEpoch = e.currentEpoch !== void 0 && e.currentEpoch !== null ? Long$2.fromValue(e.currentEpoch) : Long$2.ZERO, d.currentEpochStartTime = (u = e.currentEpochStartTime) !== null && u !== void 0 ? u : void 0, d.epochCountingStarted = (c = e.epochCountingStarted) !== null && c !== void 0 ? c : !1, d.currentEpochStartHeight = e.currentEpochStartHeight !== void 0 && e.currentEpochStartHeight !== null ? Long$2.fromValue(e.currentEpochStartHeight) : Long$2.ZERO, d;
  },
  fromAmino(e) {
    return {
      identifier: e.identifier,
      startTime: e != null && e.start_time ? Timestamp.fromAmino(e.start_time) : void 0,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0,
      currentEpoch: Long$2.fromString(e.current_epoch),
      currentEpochStartTime: e != null && e.current_epoch_start_time ? Timestamp.fromAmino(e.current_epoch_start_time) : void 0,
      epochCountingStarted: e.epoch_counting_started,
      currentEpochStartHeight: Long$2.fromString(e.current_epoch_start_height)
    };
  },
  toAmino(e) {
    const n = {};
    return n.identifier = e.identifier, n.start_time = e.startTime ? Timestamp.toAmino(e.startTime) : void 0, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n.current_epoch = e.currentEpoch ? e.currentEpoch.toString() : void 0, n.current_epoch_start_time = e.currentEpochStartTime ? Timestamp.toAmino(e.currentEpochStartTime) : void 0, n.epoch_counting_started = e.epochCountingStarted, n.current_epoch_start_height = e.currentEpochStartHeight ? e.currentEpochStartHeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return EpochInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/epochs/epoch-info",
      value: EpochInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EpochInfo.decode(e.value);
  },
  toProto(e) {
    return EpochInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.EpochInfo",
      value: EpochInfo.encode(e).finish()
    };
  }
};
function createBaseGenesisState$c() {
  return {
    epochs: []
  };
}
const GenesisState$c = {
  typeUrl: "/osmosis.epochs.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.epochs)
      EpochInfo.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$c();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.epochs.push(EpochInfo.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$c();
    return o.epochs = ((n = e.epochs) === null || n === void 0 ? void 0 : n.map((u) => EpochInfo.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      epochs: Array.isArray(e == null ? void 0 : e.epochs) ? e.epochs.map((n) => EpochInfo.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.epochs ? n.epochs = e.epochs.map((o) => o ? EpochInfo.toAmino(o) : void 0) : n.epochs = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$c.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/epochs/genesis-state",
      value: GenesisState$c.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$c.decode(e.value);
  },
  toProto(e) {
    return GenesisState$c.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.GenesisState",
      value: GenesisState$c.encode(e).finish()
    };
  }
}, _117 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EpochInfo,
  GenesisState: GenesisState$c
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryEpochsInfoRequest() {
  return {};
}
const QueryEpochsInfoRequest = {
  typeUrl: "/osmosis.epochs.v1beta1.QueryEpochsInfoRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryEpochsInfoRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryEpochsInfoRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryEpochsInfoRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/epochs/query-epochs-info-request",
      value: QueryEpochsInfoRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryEpochsInfoRequest.decode(e.value);
  },
  toProto(e) {
    return QueryEpochsInfoRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.QueryEpochsInfoRequest",
      value: QueryEpochsInfoRequest.encode(e).finish()
    };
  }
};
function createBaseQueryEpochsInfoResponse() {
  return {
    epochs: []
  };
}
const QueryEpochsInfoResponse = {
  typeUrl: "/osmosis.epochs.v1beta1.QueryEpochsInfoResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.epochs)
      EpochInfo.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryEpochsInfoResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.epochs.push(EpochInfo.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryEpochsInfoResponse();
    return o.epochs = ((n = e.epochs) === null || n === void 0 ? void 0 : n.map((u) => EpochInfo.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      epochs: Array.isArray(e == null ? void 0 : e.epochs) ? e.epochs.map((n) => EpochInfo.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.epochs ? n.epochs = e.epochs.map((o) => o ? EpochInfo.toAmino(o) : void 0) : n.epochs = [], n;
  },
  fromAminoMsg(e) {
    return QueryEpochsInfoResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/epochs/query-epochs-info-response",
      value: QueryEpochsInfoResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryEpochsInfoResponse.decode(e.value);
  },
  toProto(e) {
    return QueryEpochsInfoResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.QueryEpochsInfoResponse",
      value: QueryEpochsInfoResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCurrentEpochRequest() {
  return {
    identifier: ""
  };
}
const QueryCurrentEpochRequest = {
  typeUrl: "/osmosis.epochs.v1beta1.QueryCurrentEpochRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.identifier !== "" && n.uint32(10).string(e.identifier), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCurrentEpochRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.identifier = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCurrentEpochRequest();
    return o.identifier = (n = e.identifier) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      identifier: e.identifier
    };
  },
  toAmino(e) {
    const n = {};
    return n.identifier = e.identifier, n;
  },
  fromAminoMsg(e) {
    return QueryCurrentEpochRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/epochs/query-current-epoch-request",
      value: QueryCurrentEpochRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCurrentEpochRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCurrentEpochRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.QueryCurrentEpochRequest",
      value: QueryCurrentEpochRequest.encode(e).finish()
    };
  }
};
function createBaseQueryCurrentEpochResponse() {
  return {
    currentEpoch: Long$2.ZERO
  };
}
const QueryCurrentEpochResponse = {
  typeUrl: "/osmosis.epochs.v1beta1.QueryCurrentEpochResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.currentEpoch.isZero() || n.uint32(8).int64(e.currentEpoch), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCurrentEpochResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.currentEpoch = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryCurrentEpochResponse();
    return n.currentEpoch = e.currentEpoch !== void 0 && e.currentEpoch !== null ? Long$2.fromValue(e.currentEpoch) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      currentEpoch: Long$2.fromString(e.current_epoch)
    };
  },
  toAmino(e) {
    const n = {};
    return n.current_epoch = e.currentEpoch ? e.currentEpoch.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryCurrentEpochResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/epochs/query-current-epoch-response",
      value: QueryCurrentEpochResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCurrentEpochResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCurrentEpochResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.QueryCurrentEpochResponse",
      value: QueryCurrentEpochResponse.encode(e).finish()
    };
  }
}, _118 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryCurrentEpochRequest,
  QueryCurrentEpochResponse,
  QueryEpochsInfoRequest,
  QueryEpochsInfoResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseSmoothWeightChangeParams() {
  return {
    startTime: void 0,
    duration: void 0,
    initialPoolWeights: [],
    targetPoolWeights: []
  };
}
const SmoothWeightChangeParams = {
  typeUrl: "/osmosis.gamm.v1beta1.SmoothWeightChangeParams",
  encode(e, n = minimal.Writer.create()) {
    e.startTime !== void 0 && Timestamp.encode(toTimestamp(e.startTime), n.uint32(10).fork()).ldelim(), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(18).fork()).ldelim();
    for (const o of e.initialPoolWeights)
      PoolAsset.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.targetPoolWeights)
      PoolAsset.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSmoothWeightChangeParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.startTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 2:
          c.duration = Duration.decode(o, o.uint32());
          break;
        case 3:
          c.initialPoolWeights.push(PoolAsset.decode(o, o.uint32()));
          break;
        case 4:
          c.targetPoolWeights.push(PoolAsset.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSmoothWeightChangeParams();
    return c.startTime = (n = e.startTime) !== null && n !== void 0 ? n : void 0, c.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, c.initialPoolWeights = ((o = e.initialPoolWeights) === null || o === void 0 ? void 0 : o.map((d) => PoolAsset.fromPartial(d))) || [], c.targetPoolWeights = ((u = e.targetPoolWeights) === null || u === void 0 ? void 0 : u.map((d) => PoolAsset.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      startTime: e != null && e.start_time ? Timestamp.fromAmino(e.start_time) : void 0,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0,
      initialPoolWeights: Array.isArray(e == null ? void 0 : e.initial_pool_weights) ? e.initial_pool_weights.map((n) => PoolAsset.fromAmino(n)) : [],
      targetPoolWeights: Array.isArray(e == null ? void 0 : e.target_pool_weights) ? e.target_pool_weights.map((n) => PoolAsset.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.start_time = e.startTime ? Timestamp.toAmino(e.startTime) : void 0, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, e.initialPoolWeights ? n.initial_pool_weights = e.initialPoolWeights.map((o) => o ? PoolAsset.toAmino(o) : void 0) : n.initial_pool_weights = [], e.targetPoolWeights ? n.target_pool_weights = e.targetPoolWeights.map((o) => o ? PoolAsset.toAmino(o) : void 0) : n.target_pool_weights = [], n;
  },
  fromAminoMsg(e) {
    return SmoothWeightChangeParams.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/smooth-weight-change-params",
      value: SmoothWeightChangeParams.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SmoothWeightChangeParams.decode(e.value);
  },
  toProto(e) {
    return SmoothWeightChangeParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.SmoothWeightChangeParams",
      value: SmoothWeightChangeParams.encode(e).finish()
    };
  }
};
function createBasePoolParams$1() {
  return {
    swapFee: "",
    exitFee: "",
    smoothWeightChangeParams: void 0
  };
}
const PoolParams$1 = {
  typeUrl: "/osmosis.gamm.v1beta1.PoolParams",
  encode(e, n = minimal.Writer.create()) {
    return e.swapFee !== "" && n.uint32(10).string(e.swapFee), e.exitFee !== "" && n.uint32(18).string(e.exitFee), e.smoothWeightChangeParams !== void 0 && SmoothWeightChangeParams.encode(e.smoothWeightChangeParams, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePoolParams$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.swapFee = o.string();
          break;
        case 2:
          c.exitFee = o.string();
          break;
        case 3:
          c.smoothWeightChangeParams = SmoothWeightChangeParams.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePoolParams$1();
    return u.swapFee = (n = e.swapFee) !== null && n !== void 0 ? n : "", u.exitFee = (o = e.exitFee) !== null && o !== void 0 ? o : "", u.smoothWeightChangeParams = e.smoothWeightChangeParams !== void 0 && e.smoothWeightChangeParams !== null ? SmoothWeightChangeParams.fromPartial(e.smoothWeightChangeParams) : void 0, u;
  },
  fromAmino(e) {
    return {
      swapFee: e.swap_fee,
      exitFee: e.exit_fee,
      smoothWeightChangeParams: e != null && e.smooth_weight_change_params ? SmoothWeightChangeParams.fromAmino(e.smooth_weight_change_params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.swap_fee = e.swapFee, n.exit_fee = e.exitFee, n.smooth_weight_change_params = e.smoothWeightChangeParams ? SmoothWeightChangeParams.toAmino(e.smoothWeightChangeParams) : void 0, n;
  },
  fromAminoMsg(e) {
    return PoolParams$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/BalancerPoolParams",
      value: PoolParams$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PoolParams$1.decode(e.value);
  },
  toProto(e) {
    return PoolParams$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.PoolParams",
      value: PoolParams$1.encode(e).finish()
    };
  }
};
function createBasePoolAsset() {
  return {
    token: void 0,
    weight: ""
  };
}
const PoolAsset = {
  typeUrl: "/osmosis.gamm.v1beta1.PoolAsset",
  encode(e, n = minimal.Writer.create()) {
    return e.token !== void 0 && Coin.encode(e.token, n.uint32(10).fork()).ldelim(), e.weight !== "" && n.uint32(18).string(e.weight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePoolAsset();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.token = Coin.decode(o, o.uint32());
          break;
        case 2:
          c.weight = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBasePoolAsset();
    return o.token = e.token !== void 0 && e.token !== null ? Coin.fromPartial(e.token) : void 0, o.weight = (n = e.weight) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      token: e != null && e.token ? Coin.fromAmino(e.token) : void 0,
      weight: e.weight
    };
  },
  toAmino(e) {
    const n = {};
    return n.token = e.token ? Coin.toAmino(e.token) : void 0, n.weight = e.weight, n;
  },
  fromAminoMsg(e) {
    return PoolAsset.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/pool-asset",
      value: PoolAsset.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PoolAsset.decode(e.value);
  },
  toProto(e) {
    return PoolAsset.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.PoolAsset",
      value: PoolAsset.encode(e).finish()
    };
  }
};
function createBasePool$2() {
  return {
    $typeUrl: "/osmosis.gamm.v1beta1.Pool",
    address: "",
    id: Long$2.UZERO,
    poolParams: void 0,
    futurePoolGovernor: "",
    totalShares: void 0,
    poolAssets: [],
    totalWeight: ""
  };
}
const Pool$2 = {
  typeUrl: "/osmosis.gamm.v1beta1.Pool",
  encode(e, n = minimal.Writer.create()) {
    e.address !== "" && n.uint32(10).string(e.address), e.id.isZero() || n.uint32(16).uint64(e.id), e.poolParams !== void 0 && PoolParams$1.encode(e.poolParams, n.uint32(26).fork()).ldelim(), e.futurePoolGovernor !== "" && n.uint32(34).string(e.futurePoolGovernor), e.totalShares !== void 0 && Coin.encode(e.totalShares, n.uint32(42).fork()).ldelim();
    for (const o of e.poolAssets)
      PoolAsset.encode(o, n.uint32(50).fork()).ldelim();
    return e.totalWeight !== "" && n.uint32(58).string(e.totalWeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePool$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.id = o.uint64();
          break;
        case 3:
          c.poolParams = PoolParams$1.decode(o, o.uint32());
          break;
        case 4:
          c.futurePoolGovernor = o.string();
          break;
        case 5:
          c.totalShares = Coin.decode(o, o.uint32());
          break;
        case 6:
          c.poolAssets.push(PoolAsset.decode(o, o.uint32()));
          break;
        case 7:
          c.totalWeight = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBasePool$2();
    return d.address = (n = e.address) !== null && n !== void 0 ? n : "", d.id = e.id !== void 0 && e.id !== null ? Long$2.fromValue(e.id) : Long$2.UZERO, d.poolParams = e.poolParams !== void 0 && e.poolParams !== null ? PoolParams$1.fromPartial(e.poolParams) : void 0, d.futurePoolGovernor = (o = e.futurePoolGovernor) !== null && o !== void 0 ? o : "", d.totalShares = e.totalShares !== void 0 && e.totalShares !== null ? Coin.fromPartial(e.totalShares) : void 0, d.poolAssets = ((u = e.poolAssets) === null || u === void 0 ? void 0 : u.map((m) => PoolAsset.fromPartial(m))) || [], d.totalWeight = (c = e.totalWeight) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      address: e.address,
      id: Long$2.fromString(e.id),
      poolParams: e != null && e.pool_params ? PoolParams$1.fromAmino(e.pool_params) : void 0,
      futurePoolGovernor: e.future_pool_governor,
      totalShares: e != null && e.total_shares ? Coin.fromAmino(e.total_shares) : void 0,
      poolAssets: Array.isArray(e == null ? void 0 : e.pool_assets) ? e.pool_assets.map((n) => PoolAsset.fromAmino(n)) : [],
      totalWeight: e.total_weight
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.id = e.id ? e.id.toString() : void 0, n.pool_params = e.poolParams ? PoolParams$1.toAmino(e.poolParams) : void 0, n.future_pool_governor = e.futurePoolGovernor, n.total_shares = e.totalShares ? Coin.toAmino(e.totalShares) : void 0, e.poolAssets ? n.pool_assets = e.poolAssets.map((o) => o ? PoolAsset.toAmino(o) : void 0) : n.pool_assets = [], n.total_weight = e.totalWeight, n;
  },
  fromAminoMsg(e) {
    return Pool$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/BalancerPool",
      value: Pool$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Pool$2.decode(e.value);
  },
  toProto(e) {
    return Pool$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.Pool",
      value: Pool$2.encode(e).finish()
    };
  }
}, _119 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Pool: Pool$2,
  PoolAsset,
  PoolParams: PoolParams$1,
  SmoothWeightChangeParams
}, Symbol.toStringTag, { value: "Module" }));
function createBasePool$1() {
  return {
    $typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
    address: "",
    incentivesAddress: "",
    id: Long$2.UZERO,
    currentTickLiquidity: "",
    token0: "",
    token1: "",
    currentSqrtPrice: "",
    currentTick: "",
    tickSpacing: Long$2.UZERO,
    exponentAtPriceOne: "",
    swapFee: "",
    lastLiquidityUpdate: void 0
  };
}
const Pool$1 = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.incentivesAddress !== "" && n.uint32(18).string(e.incentivesAddress), e.id.isZero() || n.uint32(24).uint64(e.id), e.currentTickLiquidity !== "" && n.uint32(34).string(e.currentTickLiquidity), e.token0 !== "" && n.uint32(42).string(e.token0), e.token1 !== "" && n.uint32(50).string(e.token1), e.currentSqrtPrice !== "" && n.uint32(58).string(e.currentSqrtPrice), e.currentTick !== "" && n.uint32(66).string(e.currentTick), e.tickSpacing.isZero() || n.uint32(72).uint64(e.tickSpacing), e.exponentAtPriceOne !== "" && n.uint32(82).string(e.exponentAtPriceOne), e.swapFee !== "" && n.uint32(90).string(e.swapFee), e.lastLiquidityUpdate !== void 0 && Timestamp.encode(toTimestamp(e.lastLiquidityUpdate), n.uint32(98).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePool$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.incentivesAddress = o.string();
          break;
        case 3:
          c.id = o.uint64();
          break;
        case 4:
          c.currentTickLiquidity = o.string();
          break;
        case 5:
          c.token0 = o.string();
          break;
        case 6:
          c.token1 = o.string();
          break;
        case 7:
          c.currentSqrtPrice = o.string();
          break;
        case 8:
          c.currentTick = o.string();
          break;
        case 9:
          c.tickSpacing = o.uint64();
          break;
        case 10:
          c.exponentAtPriceOne = o.string();
          break;
        case 11:
          c.swapFee = o.string();
          break;
        case 12:
          c.lastLiquidityUpdate = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $, E;
    const O = createBasePool$1();
    return O.address = (n = e.address) !== null && n !== void 0 ? n : "", O.incentivesAddress = (o = e.incentivesAddress) !== null && o !== void 0 ? o : "", O.id = e.id !== void 0 && e.id !== null ? Long$2.fromValue(e.id) : Long$2.UZERO, O.currentTickLiquidity = (u = e.currentTickLiquidity) !== null && u !== void 0 ? u : "", O.token0 = (c = e.token0) !== null && c !== void 0 ? c : "", O.token1 = (d = e.token1) !== null && d !== void 0 ? d : "", O.currentSqrtPrice = (m = e.currentSqrtPrice) !== null && m !== void 0 ? m : "", O.currentTick = (v = e.currentTick) !== null && v !== void 0 ? v : "", O.tickSpacing = e.tickSpacing !== void 0 && e.tickSpacing !== null ? Long$2.fromValue(e.tickSpacing) : Long$2.UZERO, O.exponentAtPriceOne = (S = e.exponentAtPriceOne) !== null && S !== void 0 ? S : "", O.swapFee = ($ = e.swapFee) !== null && $ !== void 0 ? $ : "", O.lastLiquidityUpdate = (E = e.lastLiquidityUpdate) !== null && E !== void 0 ? E : void 0, O;
  },
  fromAmino(e) {
    return {
      address: e.address,
      incentivesAddress: e.incentives_address,
      id: Long$2.fromString(e.id),
      currentTickLiquidity: e.current_tick_liquidity,
      token0: e.token0,
      token1: e.token1,
      currentSqrtPrice: e.current_sqrt_price,
      currentTick: e.current_tick,
      tickSpacing: Long$2.fromString(e.tick_spacing),
      exponentAtPriceOne: e.exponent_at_price_one,
      swapFee: e.swap_fee,
      lastLiquidityUpdate: e != null && e.last_liquidity_update ? Timestamp.fromAmino(e.last_liquidity_update) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.incentives_address = e.incentivesAddress, n.id = e.id ? e.id.toString() : void 0, n.current_tick_liquidity = e.currentTickLiquidity, n.token0 = e.token0, n.token1 = e.token1, n.current_sqrt_price = e.currentSqrtPrice, n.current_tick = e.currentTick, n.tick_spacing = e.tickSpacing ? e.tickSpacing.toString() : void 0, n.exponent_at_price_one = e.exponentAtPriceOne, n.swap_fee = e.swapFee, n.last_liquidity_update = e.lastLiquidityUpdate ? Timestamp.toAmino(e.lastLiquidityUpdate) : void 0, n;
  },
  fromAminoMsg(e) {
    return Pool$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/pool",
      value: Pool$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Pool$1.decode(e.value);
  },
  toProto(e) {
    return Pool$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
      value: Pool$1.encode(e).finish()
    };
  }
};
function createBasePoolParams() {
  return {
    swapFee: "",
    exitFee: ""
  };
}
const PoolParams = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.PoolParams",
  encode(e, n = minimal.Writer.create()) {
    return e.swapFee !== "" && n.uint32(10).string(e.swapFee), e.exitFee !== "" && n.uint32(18).string(e.exitFee), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePoolParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.swapFee = o.string();
          break;
        case 2:
          c.exitFee = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBasePoolParams();
    return u.swapFee = (n = e.swapFee) !== null && n !== void 0 ? n : "", u.exitFee = (o = e.exitFee) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      swapFee: e.swap_fee,
      exitFee: e.exit_fee
    };
  },
  toAmino(e) {
    const n = {};
    return n.swap_fee = e.swapFee, n.exit_fee = e.exitFee, n;
  },
  fromAminoMsg(e) {
    return PoolParams.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/StableswapPoolParams",
      value: PoolParams.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PoolParams.decode(e.value);
  },
  toProto(e) {
    return PoolParams.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.PoolParams",
      value: PoolParams.encode(e).finish()
    };
  }
};
function createBasePool() {
  return {
    $typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
    address: "",
    id: Long$2.UZERO,
    poolParams: void 0,
    futurePoolGovernor: "",
    totalShares: void 0,
    poolLiquidity: [],
    scalingFactors: [],
    scalingFactorController: ""
  };
}
const Pool = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
  encode(e, n = minimal.Writer.create()) {
    e.address !== "" && n.uint32(10).string(e.address), e.id.isZero() || n.uint32(16).uint64(e.id), e.poolParams !== void 0 && PoolParams.encode(e.poolParams, n.uint32(26).fork()).ldelim(), e.futurePoolGovernor !== "" && n.uint32(34).string(e.futurePoolGovernor), e.totalShares !== void 0 && Coin.encode(e.totalShares, n.uint32(42).fork()).ldelim();
    for (const o of e.poolLiquidity)
      Coin.encode(o, n.uint32(50).fork()).ldelim();
    n.uint32(58).fork();
    for (const o of e.scalingFactors)
      n.uint64(o);
    return n.ldelim(), e.scalingFactorController !== "" && n.uint32(66).string(e.scalingFactorController), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.id = o.uint64();
          break;
        case 3:
          c.poolParams = PoolParams.decode(o, o.uint32());
          break;
        case 4:
          c.futurePoolGovernor = o.string();
          break;
        case 5:
          c.totalShares = Coin.decode(o, o.uint32());
          break;
        case 6:
          c.poolLiquidity.push(Coin.decode(o, o.uint32()));
          break;
        case 7:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.scalingFactors.push(o.uint64());
          } else
            c.scalingFactors.push(o.uint64());
          break;
        case 8:
          c.scalingFactorController = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBasePool();
    return m.address = (n = e.address) !== null && n !== void 0 ? n : "", m.id = e.id !== void 0 && e.id !== null ? Long$2.fromValue(e.id) : Long$2.UZERO, m.poolParams = e.poolParams !== void 0 && e.poolParams !== null ? PoolParams.fromPartial(e.poolParams) : void 0, m.futurePoolGovernor = (o = e.futurePoolGovernor) !== null && o !== void 0 ? o : "", m.totalShares = e.totalShares !== void 0 && e.totalShares !== null ? Coin.fromPartial(e.totalShares) : void 0, m.poolLiquidity = ((u = e.poolLiquidity) === null || u === void 0 ? void 0 : u.map((v) => Coin.fromPartial(v))) || [], m.scalingFactors = ((c = e.scalingFactors) === null || c === void 0 ? void 0 : c.map((v) => Long$2.fromValue(v))) || [], m.scalingFactorController = (d = e.scalingFactorController) !== null && d !== void 0 ? d : "", m;
  },
  fromAmino(e) {
    return {
      address: e.address,
      id: Long$2.fromString(e.id),
      poolParams: e != null && e.pool_params ? PoolParams.fromAmino(e.pool_params) : void 0,
      futurePoolGovernor: e.future_pool_governor,
      totalShares: e != null && e.total_shares ? Coin.fromAmino(e.total_shares) : void 0,
      poolLiquidity: Array.isArray(e == null ? void 0 : e.pool_liquidity) ? e.pool_liquidity.map((n) => Coin.fromAmino(n)) : [],
      scalingFactors: Array.isArray(e == null ? void 0 : e.scaling_factors) ? e.scaling_factors.map((n) => n) : [],
      scalingFactorController: e.scaling_factor_controller
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.id = e.id ? e.id.toString() : void 0, n.pool_params = e.poolParams ? PoolParams.toAmino(e.poolParams) : void 0, n.future_pool_governor = e.futurePoolGovernor, n.total_shares = e.totalShares ? Coin.toAmino(e.totalShares) : void 0, e.poolLiquidity ? n.pool_liquidity = e.poolLiquidity.map((o) => o ? Coin.toAmino(o) : void 0) : n.pool_liquidity = [], e.scalingFactors ? n.scaling_factors = e.scalingFactors.map((o) => o) : n.scaling_factors = [], n.scaling_factor_controller = e.scalingFactorController, n;
  },
  fromAminoMsg(e) {
    return Pool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/StableswapPool",
      value: Pool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Pool.decode(e.value);
  },
  toProto(e) {
    return Pool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
      value: Pool.encode(e).finish()
    };
  }
}, _125 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Pool,
  PoolParams
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$9() {
  return {
    poolCreationFee: []
  };
}
const Params$9 = {
  typeUrl: "/osmosis.gamm.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.poolCreationFee)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$9();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolCreationFee.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$9();
    return o.poolCreationFee = ((n = e.poolCreationFee) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      poolCreationFee: Array.isArray(e == null ? void 0 : e.pool_creation_fee) ? e.pool_creation_fee.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.poolCreationFee ? n.pool_creation_fee = e.poolCreationFee.map((o) => o ? Coin.toAmino(o) : void 0) : n.pool_creation_fee = [], n;
  },
  fromAminoMsg(e) {
    return Params$9.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/params",
      value: Params$9.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$9.decode(e.value);
  },
  toProto(e) {
    return Params$9.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.Params",
      value: Params$9.encode(e).finish()
    };
  }
};
function createBaseGenesisState$b() {
  return {
    pools: [],
    nextPoolNumber: Long$2.UZERO,
    params: void 0,
    migrationRecords: void 0
  };
}
const GenesisState$b = {
  typeUrl: "/osmosis.gamm.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.pools)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    return e.nextPoolNumber.isZero() || n.uint32(16).uint64(e.nextPoolNumber), e.params !== void 0 && Params$9.encode(e.params, n.uint32(26).fork()).ldelim(), e.migrationRecords !== void 0 && MigrationRecords.encode(e.migrationRecords, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$b();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pools.push(PoolI_InterfaceDecoder$2(o));
          break;
        case 2:
          c.nextPoolNumber = o.uint64();
          break;
        case 3:
          c.params = Params$9.decode(o, o.uint32());
          break;
        case 4:
          c.migrationRecords = MigrationRecords.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$b();
    return o.pools = ((n = e.pools) === null || n === void 0 ? void 0 : n.map((u) => Any.fromPartial(u))) || [], o.nextPoolNumber = e.nextPoolNumber !== void 0 && e.nextPoolNumber !== null ? Long$2.fromValue(e.nextPoolNumber) : Long$2.UZERO, o.params = e.params !== void 0 && e.params !== null ? Params$9.fromPartial(e.params) : void 0, o.migrationRecords = e.migrationRecords !== void 0 && e.migrationRecords !== null ? MigrationRecords.fromPartial(e.migrationRecords) : void 0, o;
  },
  fromAmino(e) {
    return {
      pools: Array.isArray(e == null ? void 0 : e.pools) ? e.pools.map((n) => PoolI_FromAmino$2(n)) : [],
      nextPoolNumber: Long$2.fromString(e.next_pool_number),
      params: e != null && e.params ? Params$9.fromAmino(e.params) : void 0,
      migrationRecords: e != null && e.migration_records ? MigrationRecords.fromAmino(e.migration_records) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.pools ? n.pools = e.pools.map((o) => o ? PoolI_ToAmino$2(o) : void 0) : n.pools = [], n.next_pool_number = e.nextPoolNumber ? e.nextPoolNumber.toString() : void 0, n.params = e.params ? Params$9.toAmino(e.params) : void 0, n.migration_records = e.migrationRecords ? MigrationRecords.toAmino(e.migrationRecords) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$b.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/genesis-state",
      value: GenesisState$b.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$b.decode(e.value);
  },
  toProto(e) {
    return GenesisState$b.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.GenesisState",
      value: GenesisState$b.encode(e).finish()
    };
  }
};
function createBaseMigrationRecords() {
  return {
    balancerToConcentratedPoolLinks: []
  };
}
const MigrationRecords = {
  typeUrl: "/osmosis.gamm.v1beta1.MigrationRecords",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.balancerToConcentratedPoolLinks)
      BalancerToConcentratedPoolLink.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMigrationRecords();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.balancerToConcentratedPoolLinks.push(BalancerToConcentratedPoolLink.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMigrationRecords();
    return o.balancerToConcentratedPoolLinks = ((n = e.balancerToConcentratedPoolLinks) === null || n === void 0 ? void 0 : n.map((u) => BalancerToConcentratedPoolLink.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      balancerToConcentratedPoolLinks: Array.isArray(e == null ? void 0 : e.balancer_to_concentrated_pool_links) ? e.balancer_to_concentrated_pool_links.map((n) => BalancerToConcentratedPoolLink.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.balancerToConcentratedPoolLinks ? n.balancer_to_concentrated_pool_links = e.balancerToConcentratedPoolLinks.map((o) => o ? BalancerToConcentratedPoolLink.toAmino(o) : void 0) : n.balancer_to_concentrated_pool_links = [], n;
  },
  fromAminoMsg(e) {
    return MigrationRecords.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/migration-records",
      value: MigrationRecords.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MigrationRecords.decode(e.value);
  },
  toProto(e) {
    return MigrationRecords.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MigrationRecords",
      value: MigrationRecords.encode(e).finish()
    };
  }
};
function createBaseBalancerToConcentratedPoolLink() {
  return {
    balancerPoolId: Long$2.UZERO,
    clPoolId: Long$2.UZERO
  };
}
const BalancerToConcentratedPoolLink = {
  typeUrl: "/osmosis.gamm.v1beta1.BalancerToConcentratedPoolLink",
  encode(e, n = minimal.Writer.create()) {
    return e.balancerPoolId.isZero() || n.uint32(8).uint64(e.balancerPoolId), e.clPoolId.isZero() || n.uint32(16).uint64(e.clPoolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBalancerToConcentratedPoolLink();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.balancerPoolId = o.uint64();
          break;
        case 2:
          c.clPoolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseBalancerToConcentratedPoolLink();
    return n.balancerPoolId = e.balancerPoolId !== void 0 && e.balancerPoolId !== null ? Long$2.fromValue(e.balancerPoolId) : Long$2.UZERO, n.clPoolId = e.clPoolId !== void 0 && e.clPoolId !== null ? Long$2.fromValue(e.clPoolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      balancerPoolId: Long$2.fromString(e.balancer_pool_id),
      clPoolId: Long$2.fromString(e.cl_pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.balancer_pool_id = e.balancerPoolId ? e.balancerPoolId.toString() : void 0, n.cl_pool_id = e.clPoolId ? e.clPoolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return BalancerToConcentratedPoolLink.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/balancer-to-concentrated-pool-link",
      value: BalancerToConcentratedPoolLink.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return BalancerToConcentratedPoolLink.decode(e.value);
  },
  toProto(e) {
    return BalancerToConcentratedPoolLink.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.BalancerToConcentratedPoolLink",
      value: BalancerToConcentratedPoolLink.encode(e).finish()
    };
  }
}, PoolI_InterfaceDecoder$2 = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return Pool$1.decode(o.value);
    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return CosmWasmPool.decode(o.value);
    case "/osmosis.gamm.v1beta1.Pool":
      return Pool$2.decode(o.value);
    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return Pool.decode(o.value);
    default:
      return o;
  }
}, PoolI_FromAmino$2 = (e) => {
  switch (e.type) {
    case "osmosis/concentratedliquidity/pool":
      return Any.fromPartial({
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
        value: Pool$1.encode(Pool$1.fromPartial(Pool$1.fromAmino(e.value))).finish()
      });
    case "osmosis/cosmwasmpool/cosm-wasm-pool":
      return Any.fromPartial({
        typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
        value: CosmWasmPool.encode(CosmWasmPool.fromPartial(CosmWasmPool.fromAmino(e.value))).finish()
      });
    case "osmosis/gamm/BalancerPool":
      return Any.fromPartial({
        typeUrl: "/osmosis.gamm.v1beta1.Pool",
        value: Pool$2.encode(Pool$2.fromPartial(Pool$2.fromAmino(e.value))).finish()
      });
    case "osmosis/gamm/StableswapPool":
      return Any.fromPartial({
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
        value: Pool.encode(Pool.fromPartial(Pool.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, PoolI_ToAmino$2 = (e) => {
  switch (e.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return {
        type: "osmosis/concentratedliquidity/pool",
        value: Pool$1.toAmino(Pool$1.decode(e.value))
      };
    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return {
        type: "osmosis/cosmwasmpool/cosm-wasm-pool",
        value: CosmWasmPool.toAmino(CosmWasmPool.decode(e.value))
      };
    case "/osmosis.gamm.v1beta1.Pool":
      return {
        type: "osmosis/gamm/BalancerPool",
        value: Pool$2.toAmino(Pool$2.decode(e.value))
      };
    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return {
        type: "osmosis/gamm/StableswapPool",
        value: Pool.toAmino(Pool.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _120 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BalancerToConcentratedPoolLink,
  GenesisState: GenesisState$b,
  MigrationRecords,
  Params: Params$9,
  PoolI_FromAmino: PoolI_FromAmino$2,
  PoolI_InterfaceDecoder: PoolI_InterfaceDecoder$2,
  PoolI_ToAmino: PoolI_ToAmino$2
}, Symbol.toStringTag, { value: "Module" }));
function createBaseReplaceMigrationRecordsProposal() {
  return {
    title: "",
    description: "",
    records: []
  };
}
const ReplaceMigrationRecordsProposal = {
  typeUrl: "/osmosis.gamm.v1beta1.ReplaceMigrationRecordsProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description);
    for (const o of e.records)
      BalancerToConcentratedPoolLink.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseReplaceMigrationRecordsProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.records.push(BalancerToConcentratedPoolLink.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseReplaceMigrationRecordsProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.records = ((u = e.records) === null || u === void 0 ? void 0 : u.map((d) => BalancerToConcentratedPoolLink.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      records: Array.isArray(e == null ? void 0 : e.records) ? e.records.map((n) => BalancerToConcentratedPoolLink.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.records ? n.records = e.records.map((o) => o ? BalancerToConcentratedPoolLink.toAmino(o) : void 0) : n.records = [], n;
  },
  fromAminoMsg(e) {
    return ReplaceMigrationRecordsProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/replace-migration-records-proposal",
      value: ReplaceMigrationRecordsProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ReplaceMigrationRecordsProposal.decode(e.value);
  },
  toProto(e) {
    return ReplaceMigrationRecordsProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.ReplaceMigrationRecordsProposal",
      value: ReplaceMigrationRecordsProposal.encode(e).finish()
    };
  }
};
function createBaseUpdateMigrationRecordsProposal() {
  return {
    title: "",
    description: "",
    records: []
  };
}
const UpdateMigrationRecordsProposal = {
  typeUrl: "/osmosis.gamm.v1beta1.UpdateMigrationRecordsProposal",
  encode(e, n = minimal.Writer.create()) {
    e.title !== "" && n.uint32(10).string(e.title), e.description !== "" && n.uint32(18).string(e.description);
    for (const o of e.records)
      BalancerToConcentratedPoolLink.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpdateMigrationRecordsProposal();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.title = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          c.records.push(BalancerToConcentratedPoolLink.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseUpdateMigrationRecordsProposal();
    return c.title = (n = e.title) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.records = ((u = e.records) === null || u === void 0 ? void 0 : u.map((d) => BalancerToConcentratedPoolLink.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      title: e.title,
      description: e.description,
      records: Array.isArray(e == null ? void 0 : e.records) ? e.records.map((n) => BalancerToConcentratedPoolLink.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.title = e.title, n.description = e.description, e.records ? n.records = e.records.map((o) => o ? BalancerToConcentratedPoolLink.toAmino(o) : void 0) : n.records = [], n;
  },
  fromAminoMsg(e) {
    return UpdateMigrationRecordsProposal.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/update-migration-records-proposal",
      value: UpdateMigrationRecordsProposal.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpdateMigrationRecordsProposal.decode(e.value);
  },
  toProto(e) {
    return UpdateMigrationRecordsProposal.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.UpdateMigrationRecordsProposal",
      value: UpdateMigrationRecordsProposal.encode(e).finish()
    };
  }
}, _121 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ReplaceMigrationRecordsProposal,
  UpdateMigrationRecordsProposal
}, Symbol.toStringTag, { value: "Module" }));
function createBaseSwapAmountInRoute() {
  return {
    poolId: Long$2.UZERO,
    tokenOutDenom: ""
  };
}
const SwapAmountInRoute = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountInRoute",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.tokenOutDenom !== "" && n.uint32(18).string(e.tokenOutDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSwapAmountInRoute();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.tokenOutDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSwapAmountInRoute();
    return o.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, o.tokenOutDenom = (n = e.tokenOutDenom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      tokenOutDenom: e.token_out_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_out_denom = e.tokenOutDenom, n;
  },
  fromAminoMsg(e) {
    return SwapAmountInRoute.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/swap-amount-in-route",
      value: SwapAmountInRoute.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SwapAmountInRoute.decode(e.value);
  },
  toProto(e) {
    return SwapAmountInRoute.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountInRoute",
      value: SwapAmountInRoute.encode(e).finish()
    };
  }
};
function createBaseSwapAmountOutRoute() {
  return {
    poolId: Long$2.UZERO,
    tokenInDenom: ""
  };
}
const SwapAmountOutRoute = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountOutRoute",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.tokenInDenom !== "" && n.uint32(18).string(e.tokenInDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSwapAmountOutRoute();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.tokenInDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSwapAmountOutRoute();
    return o.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, o.tokenInDenom = (n = e.tokenInDenom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      tokenInDenom: e.token_in_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_in_denom = e.tokenInDenom, n;
  },
  fromAminoMsg(e) {
    return SwapAmountOutRoute.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/swap-amount-out-route",
      value: SwapAmountOutRoute.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SwapAmountOutRoute.decode(e.value);
  },
  toProto(e) {
    return SwapAmountOutRoute.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountOutRoute",
      value: SwapAmountOutRoute.encode(e).finish()
    };
  }
}, _151 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SwapAmountInRoute,
  SwapAmountOutRoute
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryPoolRequest() {
  return {
    poolId: Long$2.UZERO
  };
}
const QueryPoolRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryPoolRequest();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pool-request",
      value: QueryPoolRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPoolRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolRequest",
      value: QueryPoolRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPoolResponse() {
  return {
    pool: void 0
  };
}
const QueryPoolResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.pool !== void 0 && Any.encode(e.pool, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pool = PoolI_InterfaceDecoder$1(o);
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryPoolResponse();
    return n.pool = e.pool !== void 0 && e.pool !== null ? Any.fromPartial(e.pool) : void 0, n;
  },
  fromAmino(e) {
    return {
      pool: e != null && e.pool ? PoolI_FromAmino$1(e.pool) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool = e.pool ? PoolI_ToAmino$1(e.pool) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pool-response",
      value: QueryPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolResponse",
      value: QueryPoolResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPoolsRequest() {
  return {
    pagination: void 0
  };
}
const QueryPoolsRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryPoolsRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pools-request",
      value: QueryPoolsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPoolsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsRequest",
      value: QueryPoolsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPoolsResponse() {
  return {
    pools: [],
    pagination: void 0
  };
}
const QueryPoolsResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.pools)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pools.push(PoolI_InterfaceDecoder$1(o));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryPoolsResponse();
    return o.pools = ((n = e.pools) === null || n === void 0 ? void 0 : n.map((u) => Any.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      pools: Array.isArray(e == null ? void 0 : e.pools) ? e.pools.map((n) => PoolI_FromAmino$1(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.pools ? n.pools = e.pools.map((o) => o ? PoolI_ToAmino$1(o) : void 0) : n.pools = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pools-response",
      value: QueryPoolsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPoolsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsResponse",
      value: QueryPoolsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryNumPoolsRequest() {
  return {};
}
const QueryNumPoolsRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryNumPoolsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryNumPoolsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryNumPoolsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryNumPoolsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-num-pools-request",
      value: QueryNumPoolsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryNumPoolsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryNumPoolsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryNumPoolsRequest",
      value: QueryNumPoolsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryNumPoolsResponse() {
  return {
    numPools: Long$2.UZERO
  };
}
const QueryNumPoolsResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryNumPoolsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.numPools.isZero() || n.uint32(8).uint64(e.numPools), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryNumPoolsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.numPools = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryNumPoolsResponse();
    return n.numPools = e.numPools !== void 0 && e.numPools !== null ? Long$2.fromValue(e.numPools) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      numPools: Long$2.fromString(e.num_pools)
    };
  },
  toAmino(e) {
    const n = {};
    return n.num_pools = e.numPools ? e.numPools.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryNumPoolsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-num-pools-response",
      value: QueryNumPoolsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryNumPoolsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryNumPoolsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryNumPoolsResponse",
      value: QueryNumPoolsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPoolTypeRequest() {
  return {
    poolId: Long$2.UZERO
  };
}
const QueryPoolTypeRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolTypeRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolTypeRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryPoolTypeRequest();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolTypeRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pool-type-request",
      value: QueryPoolTypeRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolTypeRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPoolTypeRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolTypeRequest",
      value: QueryPoolTypeRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPoolTypeResponse() {
  return {
    poolType: ""
  };
}
const QueryPoolTypeResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolTypeResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.poolType !== "" && n.uint32(10).string(e.poolType), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolTypeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolType = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryPoolTypeResponse();
    return o.poolType = (n = e.poolType) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      poolType: e.pool_type
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_type = e.poolType, n;
  },
  fromAminoMsg(e) {
    return QueryPoolTypeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pool-type-response",
      value: QueryPoolTypeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolTypeResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPoolTypeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolTypeResponse",
      value: QueryPoolTypeResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCalcJoinPoolSharesRequest() {
  return {
    poolId: Long$2.UZERO,
    tokensIn: []
  };
}
const QueryCalcJoinPoolSharesRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolSharesRequest",
  encode(e, n = minimal.Writer.create()) {
    e.poolId.isZero() || n.uint32(8).uint64(e.poolId);
    for (const o of e.tokensIn)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCalcJoinPoolSharesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.tokensIn.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCalcJoinPoolSharesRequest();
    return o.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, o.tokensIn = ((n = e.tokensIn) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      tokensIn: Array.isArray(e == null ? void 0 : e.tokens_in) ? e.tokens_in.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, e.tokensIn ? n.tokens_in = e.tokensIn.map((o) => o ? Coin.toAmino(o) : void 0) : n.tokens_in = [], n;
  },
  fromAminoMsg(e) {
    return QueryCalcJoinPoolSharesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-calc-join-pool-shares-request",
      value: QueryCalcJoinPoolSharesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCalcJoinPoolSharesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCalcJoinPoolSharesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolSharesRequest",
      value: QueryCalcJoinPoolSharesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryCalcJoinPoolSharesResponse() {
  return {
    shareOutAmount: "",
    tokensOut: []
  };
}
const QueryCalcJoinPoolSharesResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolSharesResponse",
  encode(e, n = minimal.Writer.create()) {
    e.shareOutAmount !== "" && n.uint32(10).string(e.shareOutAmount);
    for (const o of e.tokensOut)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCalcJoinPoolSharesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.shareOutAmount = o.string();
          break;
        case 2:
          c.tokensOut.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryCalcJoinPoolSharesResponse();
    return u.shareOutAmount = (n = e.shareOutAmount) !== null && n !== void 0 ? n : "", u.tokensOut = ((o = e.tokensOut) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      shareOutAmount: e.share_out_amount,
      tokensOut: Array.isArray(e == null ? void 0 : e.tokens_out) ? e.tokens_out.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.share_out_amount = e.shareOutAmount, e.tokensOut ? n.tokens_out = e.tokensOut.map((o) => o ? Coin.toAmino(o) : void 0) : n.tokens_out = [], n;
  },
  fromAminoMsg(e) {
    return QueryCalcJoinPoolSharesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-calc-join-pool-shares-response",
      value: QueryCalcJoinPoolSharesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCalcJoinPoolSharesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCalcJoinPoolSharesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolSharesResponse",
      value: QueryCalcJoinPoolSharesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCalcExitPoolCoinsFromSharesRequest() {
  return {
    poolId: Long$2.UZERO,
    shareInAmount: ""
  };
}
const QueryCalcExitPoolCoinsFromSharesRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcExitPoolCoinsFromSharesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.shareInAmount !== "" && n.uint32(18).string(e.shareInAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCalcExitPoolCoinsFromSharesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.shareInAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCalcExitPoolCoinsFromSharesRequest();
    return o.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, o.shareInAmount = (n = e.shareInAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      shareInAmount: e.share_in_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.share_in_amount = e.shareInAmount, n;
  },
  fromAminoMsg(e) {
    return QueryCalcExitPoolCoinsFromSharesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-calc-exit-pool-coins-from-shares-request",
      value: QueryCalcExitPoolCoinsFromSharesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCalcExitPoolCoinsFromSharesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCalcExitPoolCoinsFromSharesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcExitPoolCoinsFromSharesRequest",
      value: QueryCalcExitPoolCoinsFromSharesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryCalcExitPoolCoinsFromSharesResponse() {
  return {
    tokensOut: []
  };
}
const QueryCalcExitPoolCoinsFromSharesResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcExitPoolCoinsFromSharesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.tokensOut)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCalcExitPoolCoinsFromSharesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokensOut.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCalcExitPoolCoinsFromSharesResponse();
    return o.tokensOut = ((n = e.tokensOut) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      tokensOut: Array.isArray(e == null ? void 0 : e.tokens_out) ? e.tokens_out.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.tokensOut ? n.tokens_out = e.tokensOut.map((o) => o ? Coin.toAmino(o) : void 0) : n.tokens_out = [], n;
  },
  fromAminoMsg(e) {
    return QueryCalcExitPoolCoinsFromSharesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-calc-exit-pool-coins-from-shares-response",
      value: QueryCalcExitPoolCoinsFromSharesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCalcExitPoolCoinsFromSharesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCalcExitPoolCoinsFromSharesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcExitPoolCoinsFromSharesResponse",
      value: QueryCalcExitPoolCoinsFromSharesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryPoolParamsRequest() {
  return {
    poolId: Long$2.UZERO
  };
}
const QueryPoolParamsRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolParamsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryPoolParamsRequest();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolParamsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pool-params-request",
      value: QueryPoolParamsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolParamsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPoolParamsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolParamsRequest",
      value: QueryPoolParamsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPoolParamsResponse() {
  return {
    params: void 0
  };
}
const QueryPoolParamsResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Any.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolParamsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Any.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryPoolParamsResponse();
    return n.params = e.params !== void 0 && e.params !== null ? Any.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Any.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Any.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolParamsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pool-params-response",
      value: QueryPoolParamsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolParamsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPoolParamsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolParamsResponse",
      value: QueryPoolParamsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalPoolLiquidityRequest() {
  return {
    poolId: Long$2.UZERO
  };
}
const QueryTotalPoolLiquidityRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalPoolLiquidityRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalPoolLiquidityRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTotalPoolLiquidityRequest();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalPoolLiquidityRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-total-pool-liquidity-request",
      value: QueryTotalPoolLiquidityRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalPoolLiquidityRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalPoolLiquidityRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalPoolLiquidityRequest",
      value: QueryTotalPoolLiquidityRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalPoolLiquidityResponse() {
  return {
    liquidity: []
  };
}
const QueryTotalPoolLiquidityResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalPoolLiquidityResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.liquidity)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalPoolLiquidityResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.liquidity.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalPoolLiquidityResponse();
    return o.liquidity = ((n = e.liquidity) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      liquidity: Array.isArray(e == null ? void 0 : e.liquidity) ? e.liquidity.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.liquidity ? n.liquidity = e.liquidity.map((o) => o ? Coin.toAmino(o) : void 0) : n.liquidity = [], n;
  },
  fromAminoMsg(e) {
    return QueryTotalPoolLiquidityResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-total-pool-liquidity-response",
      value: QueryTotalPoolLiquidityResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalPoolLiquidityResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalPoolLiquidityResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalPoolLiquidityResponse",
      value: QueryTotalPoolLiquidityResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalSharesRequest() {
  return {
    poolId: Long$2.UZERO
  };
}
const QueryTotalSharesRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalSharesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalSharesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTotalSharesRequest();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalSharesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-total-shares-request",
      value: QueryTotalSharesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalSharesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalSharesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalSharesRequest",
      value: QueryTotalSharesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalSharesResponse() {
  return {
    totalShares: void 0
  };
}
const QueryTotalSharesResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalSharesResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.totalShares !== void 0 && Coin.encode(e.totalShares, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalSharesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.totalShares = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryTotalSharesResponse();
    return n.totalShares = e.totalShares !== void 0 && e.totalShares !== null ? Coin.fromPartial(e.totalShares) : void 0, n;
  },
  fromAmino(e) {
    return {
      totalShares: e != null && e.total_shares ? Coin.fromAmino(e.total_shares) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.total_shares = e.totalShares ? Coin.toAmino(e.totalShares) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalSharesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-total-shares-response",
      value: QueryTotalSharesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalSharesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalSharesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalSharesResponse",
      value: QueryTotalSharesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryCalcJoinPoolNoSwapSharesRequest() {
  return {
    poolId: Long$2.UZERO,
    tokensIn: []
  };
}
const QueryCalcJoinPoolNoSwapSharesRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolNoSwapSharesRequest",
  encode(e, n = minimal.Writer.create()) {
    e.poolId.isZero() || n.uint32(8).uint64(e.poolId);
    for (const o of e.tokensIn)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCalcJoinPoolNoSwapSharesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.tokensIn.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryCalcJoinPoolNoSwapSharesRequest();
    return o.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, o.tokensIn = ((n = e.tokensIn) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      tokensIn: Array.isArray(e == null ? void 0 : e.tokens_in) ? e.tokens_in.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, e.tokensIn ? n.tokens_in = e.tokensIn.map((o) => o ? Coin.toAmino(o) : void 0) : n.tokens_in = [], n;
  },
  fromAminoMsg(e) {
    return QueryCalcJoinPoolNoSwapSharesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-calc-join-pool-no-swap-shares-request",
      value: QueryCalcJoinPoolNoSwapSharesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCalcJoinPoolNoSwapSharesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryCalcJoinPoolNoSwapSharesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolNoSwapSharesRequest",
      value: QueryCalcJoinPoolNoSwapSharesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryCalcJoinPoolNoSwapSharesResponse() {
  return {
    tokensOut: [],
    sharesOut: ""
  };
}
const QueryCalcJoinPoolNoSwapSharesResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolNoSwapSharesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.tokensOut)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return e.sharesOut !== "" && n.uint32(18).string(e.sharesOut), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCalcJoinPoolNoSwapSharesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokensOut.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.sharesOut = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryCalcJoinPoolNoSwapSharesResponse();
    return u.tokensOut = ((n = e.tokensOut) === null || n === void 0 ? void 0 : n.map((c) => Coin.fromPartial(c))) || [], u.sharesOut = (o = e.sharesOut) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      tokensOut: Array.isArray(e == null ? void 0 : e.tokens_out) ? e.tokens_out.map((n) => Coin.fromAmino(n)) : [],
      sharesOut: e.shares_out
    };
  },
  toAmino(e) {
    const n = {};
    return e.tokensOut ? n.tokens_out = e.tokensOut.map((o) => o ? Coin.toAmino(o) : void 0) : n.tokens_out = [], n.shares_out = e.sharesOut, n;
  },
  fromAminoMsg(e) {
    return QueryCalcJoinPoolNoSwapSharesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-calc-join-pool-no-swap-shares-response",
      value: QueryCalcJoinPoolNoSwapSharesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCalcJoinPoolNoSwapSharesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryCalcJoinPoolNoSwapSharesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolNoSwapSharesResponse",
      value: QueryCalcJoinPoolNoSwapSharesResponse.encode(e).finish()
    };
  }
};
function createBaseQuerySpotPriceRequest$1() {
  return {
    poolId: Long$2.UZERO,
    baseAssetDenom: "",
    quoteAssetDenom: ""
  };
}
const QuerySpotPriceRequest$1 = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySpotPriceRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.baseAssetDenom !== "" && n.uint32(18).string(e.baseAssetDenom), e.quoteAssetDenom !== "" && n.uint32(26).string(e.quoteAssetDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySpotPriceRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.baseAssetDenom = o.string();
          break;
        case 3:
          c.quoteAssetDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQuerySpotPriceRequest$1();
    return u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.baseAssetDenom = (n = e.baseAssetDenom) !== null && n !== void 0 ? n : "", u.quoteAssetDenom = (o = e.quoteAssetDenom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      baseAssetDenom: e.base_asset_denom,
      quoteAssetDenom: e.quote_asset_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.base_asset_denom = e.baseAssetDenom, n.quote_asset_denom = e.quoteAssetDenom, n;
  },
  fromAminoMsg(e) {
    return QuerySpotPriceRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-spot-price-request",
      value: QuerySpotPriceRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySpotPriceRequest$1.decode(e.value);
  },
  toProto(e) {
    return QuerySpotPriceRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySpotPriceRequest",
      value: QuerySpotPriceRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryPoolsWithFilterRequest() {
  return {
    minLiquidity: "",
    poolType: "",
    pagination: void 0
  };
}
const QueryPoolsWithFilterRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsWithFilterRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.minLiquidity !== "" && n.uint32(10).string(e.minLiquidity), e.poolType !== "" && n.uint32(18).string(e.poolType), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolsWithFilterRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.minLiquidity = o.string();
          break;
        case 2:
          c.poolType = o.string();
          break;
        case 3:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQueryPoolsWithFilterRequest();
    return u.minLiquidity = (n = e.minLiquidity) !== null && n !== void 0 ? n : "", u.poolType = (o = e.poolType) !== null && o !== void 0 ? o : "", u.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, u;
  },
  fromAmino(e) {
    return {
      minLiquidity: e.min_liquidity,
      poolType: e.pool_type,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.min_liquidity = e.minLiquidity, n.pool_type = e.poolType, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolsWithFilterRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pools-with-filter-request",
      value: QueryPoolsWithFilterRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolsWithFilterRequest.decode(e.value);
  },
  toProto(e) {
    return QueryPoolsWithFilterRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsWithFilterRequest",
      value: QueryPoolsWithFilterRequest.encode(e).finish()
    };
  }
};
function createBaseQueryPoolsWithFilterResponse() {
  return {
    pools: [],
    pagination: void 0
  };
}
const QueryPoolsWithFilterResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsWithFilterResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.pools)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryPoolsWithFilterResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pools.push(PoolI_InterfaceDecoder$1(o));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryPoolsWithFilterResponse();
    return o.pools = ((n = e.pools) === null || n === void 0 ? void 0 : n.map((u) => Any.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      pools: Array.isArray(e == null ? void 0 : e.pools) ? e.pools.map((n) => PoolI_FromAmino$1(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.pools ? n.pools = e.pools.map((o) => o ? PoolI_ToAmino$1(o) : void 0) : n.pools = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryPoolsWithFilterResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-pools-with-filter-response",
      value: QueryPoolsWithFilterResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryPoolsWithFilterResponse.decode(e.value);
  },
  toProto(e) {
    return QueryPoolsWithFilterResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsWithFilterResponse",
      value: QueryPoolsWithFilterResponse.encode(e).finish()
    };
  }
};
function createBaseQuerySpotPriceResponse$1() {
  return {
    spotPrice: ""
  };
}
const QuerySpotPriceResponse$1 = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySpotPriceResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.spotPrice !== "" && n.uint32(10).string(e.spotPrice), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySpotPriceResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.spotPrice = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQuerySpotPriceResponse$1();
    return o.spotPrice = (n = e.spotPrice) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      spotPrice: e.spot_price
    };
  },
  toAmino(e) {
    const n = {};
    return n.spot_price = e.spotPrice, n;
  },
  fromAminoMsg(e) {
    return QuerySpotPriceResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-spot-price-response",
      value: QuerySpotPriceResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySpotPriceResponse$1.decode(e.value);
  },
  toProto(e) {
    return QuerySpotPriceResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySpotPriceResponse",
      value: QuerySpotPriceResponse$1.encode(e).finish()
    };
  }
};
function createBaseQuerySwapExactAmountInRequest() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    tokenIn: "",
    routes: []
  };
}
const QuerySwapExactAmountInRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountInRequest",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), e.tokenIn !== "" && n.uint32(26).string(e.tokenIn);
    for (const o of e.routes)
      SwapAmountInRoute.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySwapExactAmountInRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.tokenIn = o.string();
          break;
        case 4:
          c.routes.push(SwapAmountInRoute.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQuerySwapExactAmountInRequest();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, c.tokenIn = (o = e.tokenIn) !== null && o !== void 0 ? o : "", c.routes = ((u = e.routes) === null || u === void 0 ? void 0 : u.map((d) => SwapAmountInRoute.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      tokenIn: e.token_in,
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => SwapAmountInRoute.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_in = e.tokenIn, e.routes ? n.routes = e.routes.map((o) => o ? SwapAmountInRoute.toAmino(o) : void 0) : n.routes = [], n;
  },
  fromAminoMsg(e) {
    return QuerySwapExactAmountInRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-swap-exact-amount-in-request",
      value: QuerySwapExactAmountInRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySwapExactAmountInRequest.decode(e.value);
  },
  toProto(e) {
    return QuerySwapExactAmountInRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountInRequest",
      value: QuerySwapExactAmountInRequest.encode(e).finish()
    };
  }
};
function createBaseQuerySwapExactAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}
const QuerySwapExactAmountInResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountInResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenOutAmount !== "" && n.uint32(10).string(e.tokenOutAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySwapExactAmountInResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenOutAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQuerySwapExactAmountInResponse();
    return o.tokenOutAmount = (n = e.tokenOutAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenOutAmount: e.token_out_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_out_amount = e.tokenOutAmount, n;
  },
  fromAminoMsg(e) {
    return QuerySwapExactAmountInResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-swap-exact-amount-in-response",
      value: QuerySwapExactAmountInResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySwapExactAmountInResponse.decode(e.value);
  },
  toProto(e) {
    return QuerySwapExactAmountInResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountInResponse",
      value: QuerySwapExactAmountInResponse.encode(e).finish()
    };
  }
};
function createBaseQuerySwapExactAmountOutRequest() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    routes: [],
    tokenOut: ""
  };
}
const QuerySwapExactAmountOutRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountOutRequest",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId);
    for (const o of e.routes)
      SwapAmountOutRoute.encode(o, n.uint32(26).fork()).ldelim();
    return e.tokenOut !== "" && n.uint32(34).string(e.tokenOut), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySwapExactAmountOutRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.routes.push(SwapAmountOutRoute.decode(o, o.uint32()));
          break;
        case 4:
          c.tokenOut = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQuerySwapExactAmountOutRequest();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, c.routes = ((o = e.routes) === null || o === void 0 ? void 0 : o.map((d) => SwapAmountOutRoute.fromPartial(d))) || [], c.tokenOut = (u = e.tokenOut) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => SwapAmountOutRoute.fromAmino(n)) : [],
      tokenOut: e.token_out
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, e.routes ? n.routes = e.routes.map((o) => o ? SwapAmountOutRoute.toAmino(o) : void 0) : n.routes = [], n.token_out = e.tokenOut, n;
  },
  fromAminoMsg(e) {
    return QuerySwapExactAmountOutRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-swap-exact-amount-out-request",
      value: QuerySwapExactAmountOutRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySwapExactAmountOutRequest.decode(e.value);
  },
  toProto(e) {
    return QuerySwapExactAmountOutRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountOutRequest",
      value: QuerySwapExactAmountOutRequest.encode(e).finish()
    };
  }
};
function createBaseQuerySwapExactAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}
const QuerySwapExactAmountOutResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountOutResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenInAmount !== "" && n.uint32(10).string(e.tokenInAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySwapExactAmountOutResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenInAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQuerySwapExactAmountOutResponse();
    return o.tokenInAmount = (n = e.tokenInAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenInAmount: e.token_in_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_in_amount = e.tokenInAmount, n;
  },
  fromAminoMsg(e) {
    return QuerySwapExactAmountOutResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-swap-exact-amount-out-response",
      value: QuerySwapExactAmountOutResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySwapExactAmountOutResponse.decode(e.value);
  },
  toProto(e) {
    return QuerySwapExactAmountOutResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountOutResponse",
      value: QuerySwapExactAmountOutResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalLiquidityRequest() {
  return {};
}
const QueryTotalLiquidityRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalLiquidityRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalLiquidityRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryTotalLiquidityRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryTotalLiquidityRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-total-liquidity-request",
      value: QueryTotalLiquidityRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalLiquidityRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalLiquidityRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalLiquidityRequest",
      value: QueryTotalLiquidityRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalLiquidityResponse() {
  return {
    liquidity: []
  };
}
const QueryTotalLiquidityResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalLiquidityResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.liquidity)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalLiquidityResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.liquidity.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalLiquidityResponse();
    return o.liquidity = ((n = e.liquidity) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      liquidity: Array.isArray(e == null ? void 0 : e.liquidity) ? e.liquidity.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.liquidity ? n.liquidity = e.liquidity.map((o) => o ? Coin.toAmino(o) : void 0) : n.liquidity = [], n;
  },
  fromAminoMsg(e) {
    return QueryTotalLiquidityResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/query-total-liquidity-response",
      value: QueryTotalLiquidityResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalLiquidityResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalLiquidityResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalLiquidityResponse",
      value: QueryTotalLiquidityResponse.encode(e).finish()
    };
  }
}, PoolI_InterfaceDecoder$1 = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return Pool$1.decode(o.value);
    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return CosmWasmPool.decode(o.value);
    case "/osmosis.gamm.v1beta1.Pool":
      return Pool$2.decode(o.value);
    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return Pool.decode(o.value);
    default:
      return o;
  }
}, PoolI_FromAmino$1 = (e) => {
  switch (e.type) {
    case "osmosis/concentratedliquidity/pool":
      return Any.fromPartial({
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
        value: Pool$1.encode(Pool$1.fromPartial(Pool$1.fromAmino(e.value))).finish()
      });
    case "osmosis/cosmwasmpool/cosm-wasm-pool":
      return Any.fromPartial({
        typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
        value: CosmWasmPool.encode(CosmWasmPool.fromPartial(CosmWasmPool.fromAmino(e.value))).finish()
      });
    case "osmosis/gamm/BalancerPool":
      return Any.fromPartial({
        typeUrl: "/osmosis.gamm.v1beta1.Pool",
        value: Pool$2.encode(Pool$2.fromPartial(Pool$2.fromAmino(e.value))).finish()
      });
    case "osmosis/gamm/StableswapPool":
      return Any.fromPartial({
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
        value: Pool.encode(Pool.fromPartial(Pool.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, PoolI_ToAmino$1 = (e) => {
  switch (e.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return {
        type: "osmosis/concentratedliquidity/pool",
        value: Pool$1.toAmino(Pool$1.decode(e.value))
      };
    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return {
        type: "osmosis/cosmwasmpool/cosm-wasm-pool",
        value: CosmWasmPool.toAmino(CosmWasmPool.decode(e.value))
      };
    case "/osmosis.gamm.v1beta1.Pool":
      return {
        type: "osmosis/gamm/BalancerPool",
        value: Pool$2.toAmino(Pool$2.decode(e.value))
      };
    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return {
        type: "osmosis/gamm/StableswapPool",
        value: Pool.toAmino(Pool.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _122 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PoolI_FromAmino: PoolI_FromAmino$1,
  PoolI_InterfaceDecoder: PoolI_InterfaceDecoder$1,
  PoolI_ToAmino: PoolI_ToAmino$1,
  QueryCalcExitPoolCoinsFromSharesRequest,
  QueryCalcExitPoolCoinsFromSharesResponse,
  QueryCalcJoinPoolNoSwapSharesRequest,
  QueryCalcJoinPoolNoSwapSharesResponse,
  QueryCalcJoinPoolSharesRequest,
  QueryCalcJoinPoolSharesResponse,
  QueryNumPoolsRequest,
  QueryNumPoolsResponse,
  QueryPoolParamsRequest,
  QueryPoolParamsResponse,
  QueryPoolRequest,
  QueryPoolResponse,
  QueryPoolTypeRequest,
  QueryPoolTypeResponse,
  QueryPoolsRequest,
  QueryPoolsResponse,
  QueryPoolsWithFilterRequest,
  QueryPoolsWithFilterResponse,
  QuerySpotPriceRequest: QuerySpotPriceRequest$1,
  QuerySpotPriceResponse: QuerySpotPriceResponse$1,
  QuerySwapExactAmountInRequest,
  QuerySwapExactAmountInResponse,
  QuerySwapExactAmountOutRequest,
  QuerySwapExactAmountOutResponse,
  QueryTotalLiquidityRequest,
  QueryTotalLiquidityResponse,
  QueryTotalPoolLiquidityRequest,
  QueryTotalPoolLiquidityResponse,
  QueryTotalSharesRequest,
  QueryTotalSharesResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgJoinPool() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    shareOutAmount: "",
    tokenInMaxs: []
  };
}
const MsgJoinPool = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), e.shareOutAmount !== "" && n.uint32(26).string(e.shareOutAmount);
    for (const o of e.tokenInMaxs)
      Coin.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgJoinPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.shareOutAmount = o.string();
          break;
        case 4:
          c.tokenInMaxs.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgJoinPool();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, c.shareOutAmount = (o = e.shareOutAmount) !== null && o !== void 0 ? o : "", c.tokenInMaxs = ((u = e.tokenInMaxs) === null || u === void 0 ? void 0 : u.map((d) => Coin.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      shareOutAmount: e.share_out_amount,
      tokenInMaxs: Array.isArray(e == null ? void 0 : e.token_in_maxs) ? e.token_in_maxs.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.share_out_amount = e.shareOutAmount, e.tokenInMaxs ? n.token_in_maxs = e.tokenInMaxs.map((o) => o ? Coin.toAmino(o) : void 0) : n.token_in_maxs = [], n;
  },
  fromAminoMsg(e) {
    return MsgJoinPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/join-pool",
      value: MsgJoinPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgJoinPool.decode(e.value);
  },
  toProto(e) {
    return MsgJoinPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
      value: MsgJoinPool.encode(e).finish()
    };
  }
};
function createBaseMsgJoinPoolResponse() {
  return {
    shareOutAmount: "",
    tokenIn: []
  };
}
const MsgJoinPoolResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    e.shareOutAmount !== "" && n.uint32(10).string(e.shareOutAmount);
    for (const o of e.tokenIn)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgJoinPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.shareOutAmount = o.string();
          break;
        case 2:
          c.tokenIn.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgJoinPoolResponse();
    return u.shareOutAmount = (n = e.shareOutAmount) !== null && n !== void 0 ? n : "", u.tokenIn = ((o = e.tokenIn) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      shareOutAmount: e.share_out_amount,
      tokenIn: Array.isArray(e == null ? void 0 : e.token_in) ? e.token_in.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.share_out_amount = e.shareOutAmount, e.tokenIn ? n.token_in = e.tokenIn.map((o) => o ? Coin.toAmino(o) : void 0) : n.token_in = [], n;
  },
  fromAminoMsg(e) {
    return MsgJoinPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/join-pool-response",
      value: MsgJoinPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgJoinPoolResponse.decode(e.value);
  },
  toProto(e) {
    return MsgJoinPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPoolResponse",
      value: MsgJoinPoolResponse.encode(e).finish()
    };
  }
};
function createBaseMsgExitPool() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    shareInAmount: "",
    tokenOutMins: []
  };
}
const MsgExitPool = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), e.shareInAmount !== "" && n.uint32(26).string(e.shareInAmount);
    for (const o of e.tokenOutMins)
      Coin.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExitPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.shareInAmount = o.string();
          break;
        case 4:
          c.tokenOutMins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgExitPool();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, c.shareInAmount = (o = e.shareInAmount) !== null && o !== void 0 ? o : "", c.tokenOutMins = ((u = e.tokenOutMins) === null || u === void 0 ? void 0 : u.map((d) => Coin.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      shareInAmount: e.share_in_amount,
      tokenOutMins: Array.isArray(e == null ? void 0 : e.token_out_mins) ? e.token_out_mins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.share_in_amount = e.shareInAmount, e.tokenOutMins ? n.token_out_mins = e.tokenOutMins.map((o) => o ? Coin.toAmino(o) : void 0) : n.token_out_mins = [], n;
  },
  fromAminoMsg(e) {
    return MsgExitPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/exit-pool",
      value: MsgExitPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExitPool.decode(e.value);
  },
  toProto(e) {
    return MsgExitPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
      value: MsgExitPool.encode(e).finish()
    };
  }
};
function createBaseMsgExitPoolResponse() {
  return {
    tokenOut: []
  };
}
const MsgExitPoolResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.tokenOut)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExitPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenOut.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgExitPoolResponse();
    return o.tokenOut = ((n = e.tokenOut) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      tokenOut: Array.isArray(e == null ? void 0 : e.token_out) ? e.token_out.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.tokenOut ? n.token_out = e.tokenOut.map((o) => o ? Coin.toAmino(o) : void 0) : n.token_out = [], n;
  },
  fromAminoMsg(e) {
    return MsgExitPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/exit-pool-response",
      value: MsgExitPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExitPoolResponse.decode(e.value);
  },
  toProto(e) {
    return MsgExitPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitPoolResponse",
      value: MsgExitPoolResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSwapExactAmountIn$1() {
  return {
    sender: "",
    routes: [],
    tokenIn: void 0,
    tokenOutMinAmount: ""
  };
}
const MsgSwapExactAmountIn$1 = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender);
    for (const o of e.routes)
      SwapAmountInRoute.encode(o, n.uint32(18).fork()).ldelim();
    return e.tokenIn !== void 0 && Coin.encode(e.tokenIn, n.uint32(26).fork()).ldelim(), e.tokenOutMinAmount !== "" && n.uint32(34).string(e.tokenOutMinAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSwapExactAmountIn$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.routes.push(SwapAmountInRoute.decode(o, o.uint32()));
          break;
        case 3:
          c.tokenIn = Coin.decode(o, o.uint32());
          break;
        case 4:
          c.tokenOutMinAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgSwapExactAmountIn$1();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.routes = ((o = e.routes) === null || o === void 0 ? void 0 : o.map((d) => SwapAmountInRoute.fromPartial(d))) || [], c.tokenIn = e.tokenIn !== void 0 && e.tokenIn !== null ? Coin.fromPartial(e.tokenIn) : void 0, c.tokenOutMinAmount = (u = e.tokenOutMinAmount) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => SwapAmountInRoute.fromAmino(n)) : [],
      tokenIn: e != null && e.token_in ? Coin.fromAmino(e.token_in) : void 0,
      tokenOutMinAmount: e.token_out_min_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, e.routes ? n.routes = e.routes.map((o) => o ? SwapAmountInRoute.toAmino(o) : void 0) : n.routes = [], n.token_in = e.tokenIn ? Coin.toAmino(e.tokenIn) : void 0, n.token_out_min_amount = e.tokenOutMinAmount, n;
  },
  fromAminoMsg(e) {
    return MsgSwapExactAmountIn$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/swap-exact-amount-in",
      value: MsgSwapExactAmountIn$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSwapExactAmountIn$1.decode(e.value);
  },
  toProto(e) {
    return MsgSwapExactAmountIn$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
      value: MsgSwapExactAmountIn$1.encode(e).finish()
    };
  }
};
function createBaseMsgSwapExactAmountInResponse$1() {
  return {
    tokenOutAmount: ""
  };
}
const MsgSwapExactAmountInResponse$1 = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountInResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenOutAmount !== "" && n.uint32(10).string(e.tokenOutAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSwapExactAmountInResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenOutAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSwapExactAmountInResponse$1();
    return o.tokenOutAmount = (n = e.tokenOutAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenOutAmount: e.token_out_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_out_amount = e.tokenOutAmount, n;
  },
  fromAminoMsg(e) {
    return MsgSwapExactAmountInResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/swap-exact-amount-in-response",
      value: MsgSwapExactAmountInResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSwapExactAmountInResponse$1.decode(e.value);
  },
  toProto(e) {
    return MsgSwapExactAmountInResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountInResponse",
      value: MsgSwapExactAmountInResponse$1.encode(e).finish()
    };
  }
};
function createBaseMsgSwapExactAmountOut$1() {
  return {
    sender: "",
    routes: [],
    tokenInMaxAmount: "",
    tokenOut: void 0
  };
}
const MsgSwapExactAmountOut$1 = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender);
    for (const o of e.routes)
      SwapAmountOutRoute.encode(o, n.uint32(18).fork()).ldelim();
    return e.tokenInMaxAmount !== "" && n.uint32(26).string(e.tokenInMaxAmount), e.tokenOut !== void 0 && Coin.encode(e.tokenOut, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSwapExactAmountOut$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.routes.push(SwapAmountOutRoute.decode(o, o.uint32()));
          break;
        case 3:
          c.tokenInMaxAmount = o.string();
          break;
        case 4:
          c.tokenOut = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgSwapExactAmountOut$1();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.routes = ((o = e.routes) === null || o === void 0 ? void 0 : o.map((d) => SwapAmountOutRoute.fromPartial(d))) || [], c.tokenInMaxAmount = (u = e.tokenInMaxAmount) !== null && u !== void 0 ? u : "", c.tokenOut = e.tokenOut !== void 0 && e.tokenOut !== null ? Coin.fromPartial(e.tokenOut) : void 0, c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => SwapAmountOutRoute.fromAmino(n)) : [],
      tokenInMaxAmount: e.token_in_max_amount,
      tokenOut: e != null && e.token_out ? Coin.fromAmino(e.token_out) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, e.routes ? n.routes = e.routes.map((o) => o ? SwapAmountOutRoute.toAmino(o) : void 0) : n.routes = [], n.token_in_max_amount = e.tokenInMaxAmount, n.token_out = e.tokenOut ? Coin.toAmino(e.tokenOut) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSwapExactAmountOut$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/swap-exact-amount-out",
      value: MsgSwapExactAmountOut$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSwapExactAmountOut$1.decode(e.value);
  },
  toProto(e) {
    return MsgSwapExactAmountOut$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
      value: MsgSwapExactAmountOut$1.encode(e).finish()
    };
  }
};
function createBaseMsgSwapExactAmountOutResponse$1() {
  return {
    tokenInAmount: ""
  };
}
const MsgSwapExactAmountOutResponse$1 = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOutResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenInAmount !== "" && n.uint32(10).string(e.tokenInAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSwapExactAmountOutResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenInAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSwapExactAmountOutResponse$1();
    return o.tokenInAmount = (n = e.tokenInAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenInAmount: e.token_in_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_in_amount = e.tokenInAmount, n;
  },
  fromAminoMsg(e) {
    return MsgSwapExactAmountOutResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/swap-exact-amount-out-response",
      value: MsgSwapExactAmountOutResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSwapExactAmountOutResponse$1.decode(e.value);
  },
  toProto(e) {
    return MsgSwapExactAmountOutResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOutResponse",
      value: MsgSwapExactAmountOutResponse$1.encode(e).finish()
    };
  }
};
function createBaseMsgJoinSwapExternAmountIn() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    tokenIn: void 0,
    shareOutMinAmount: ""
  };
}
const MsgJoinSwapExternAmountIn = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), e.tokenIn !== void 0 && Coin.encode(e.tokenIn, n.uint32(26).fork()).ldelim(), e.shareOutMinAmount !== "" && n.uint32(34).string(e.shareOutMinAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgJoinSwapExternAmountIn();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.tokenIn = Coin.decode(o, o.uint32());
          break;
        case 4:
          c.shareOutMinAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgJoinSwapExternAmountIn();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.tokenIn = e.tokenIn !== void 0 && e.tokenIn !== null ? Coin.fromPartial(e.tokenIn) : void 0, u.shareOutMinAmount = (o = e.shareOutMinAmount) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      tokenIn: e != null && e.token_in ? Coin.fromAmino(e.token_in) : void 0,
      shareOutMinAmount: e.share_out_min_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_in = e.tokenIn ? Coin.toAmino(e.tokenIn) : void 0, n.share_out_min_amount = e.shareOutMinAmount, n;
  },
  fromAminoMsg(e) {
    return MsgJoinSwapExternAmountIn.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/join-swap-extern-amount-in",
      value: MsgJoinSwapExternAmountIn.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgJoinSwapExternAmountIn.decode(e.value);
  },
  toProto(e) {
    return MsgJoinSwapExternAmountIn.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
      value: MsgJoinSwapExternAmountIn.encode(e).finish()
    };
  }
};
function createBaseMsgJoinSwapExternAmountInResponse() {
  return {
    shareOutAmount: ""
  };
}
const MsgJoinSwapExternAmountInResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountInResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.shareOutAmount !== "" && n.uint32(10).string(e.shareOutAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgJoinSwapExternAmountInResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.shareOutAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgJoinSwapExternAmountInResponse();
    return o.shareOutAmount = (n = e.shareOutAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      shareOutAmount: e.share_out_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.share_out_amount = e.shareOutAmount, n;
  },
  fromAminoMsg(e) {
    return MsgJoinSwapExternAmountInResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/join-swap-extern-amount-in-response",
      value: MsgJoinSwapExternAmountInResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgJoinSwapExternAmountInResponse.decode(e.value);
  },
  toProto(e) {
    return MsgJoinSwapExternAmountInResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountInResponse",
      value: MsgJoinSwapExternAmountInResponse.encode(e).finish()
    };
  }
};
function createBaseMsgJoinSwapShareAmountOut() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    tokenInDenom: "",
    shareOutAmount: "",
    tokenInMaxAmount: ""
  };
}
const MsgJoinSwapShareAmountOut = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), e.tokenInDenom !== "" && n.uint32(26).string(e.tokenInDenom), e.shareOutAmount !== "" && n.uint32(34).string(e.shareOutAmount), e.tokenInMaxAmount !== "" && n.uint32(42).string(e.tokenInMaxAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgJoinSwapShareAmountOut();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.tokenInDenom = o.string();
          break;
        case 4:
          c.shareOutAmount = o.string();
          break;
        case 5:
          c.tokenInMaxAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgJoinSwapShareAmountOut();
    return d.sender = (n = e.sender) !== null && n !== void 0 ? n : "", d.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, d.tokenInDenom = (o = e.tokenInDenom) !== null && o !== void 0 ? o : "", d.shareOutAmount = (u = e.shareOutAmount) !== null && u !== void 0 ? u : "", d.tokenInMaxAmount = (c = e.tokenInMaxAmount) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      tokenInDenom: e.token_in_denom,
      shareOutAmount: e.share_out_amount,
      tokenInMaxAmount: e.token_in_max_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_in_denom = e.tokenInDenom, n.share_out_amount = e.shareOutAmount, n.token_in_max_amount = e.tokenInMaxAmount, n;
  },
  fromAminoMsg(e) {
    return MsgJoinSwapShareAmountOut.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/join-swap-share-amount-out",
      value: MsgJoinSwapShareAmountOut.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgJoinSwapShareAmountOut.decode(e.value);
  },
  toProto(e) {
    return MsgJoinSwapShareAmountOut.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
      value: MsgJoinSwapShareAmountOut.encode(e).finish()
    };
  }
};
function createBaseMsgJoinSwapShareAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}
const MsgJoinSwapShareAmountOutResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOutResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenInAmount !== "" && n.uint32(10).string(e.tokenInAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgJoinSwapShareAmountOutResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenInAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgJoinSwapShareAmountOutResponse();
    return o.tokenInAmount = (n = e.tokenInAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenInAmount: e.token_in_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_in_amount = e.tokenInAmount, n;
  },
  fromAminoMsg(e) {
    return MsgJoinSwapShareAmountOutResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/join-swap-share-amount-out-response",
      value: MsgJoinSwapShareAmountOutResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgJoinSwapShareAmountOutResponse.decode(e.value);
  },
  toProto(e) {
    return MsgJoinSwapShareAmountOutResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOutResponse",
      value: MsgJoinSwapShareAmountOutResponse.encode(e).finish()
    };
  }
};
function createBaseMsgExitSwapShareAmountIn() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    tokenOutDenom: "",
    shareInAmount: "",
    tokenOutMinAmount: ""
  };
}
const MsgExitSwapShareAmountIn = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), e.tokenOutDenom !== "" && n.uint32(26).string(e.tokenOutDenom), e.shareInAmount !== "" && n.uint32(34).string(e.shareInAmount), e.tokenOutMinAmount !== "" && n.uint32(42).string(e.tokenOutMinAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExitSwapShareAmountIn();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.tokenOutDenom = o.string();
          break;
        case 4:
          c.shareInAmount = o.string();
          break;
        case 5:
          c.tokenOutMinAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgExitSwapShareAmountIn();
    return d.sender = (n = e.sender) !== null && n !== void 0 ? n : "", d.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, d.tokenOutDenom = (o = e.tokenOutDenom) !== null && o !== void 0 ? o : "", d.shareInAmount = (u = e.shareInAmount) !== null && u !== void 0 ? u : "", d.tokenOutMinAmount = (c = e.tokenOutMinAmount) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      tokenOutDenom: e.token_out_denom,
      shareInAmount: e.share_in_amount,
      tokenOutMinAmount: e.token_out_min_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_out_denom = e.tokenOutDenom, n.share_in_amount = e.shareInAmount, n.token_out_min_amount = e.tokenOutMinAmount, n;
  },
  fromAminoMsg(e) {
    return MsgExitSwapShareAmountIn.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/exit-swap-share-amount-in",
      value: MsgExitSwapShareAmountIn.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExitSwapShareAmountIn.decode(e.value);
  },
  toProto(e) {
    return MsgExitSwapShareAmountIn.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
      value: MsgExitSwapShareAmountIn.encode(e).finish()
    };
  }
};
function createBaseMsgExitSwapShareAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}
const MsgExitSwapShareAmountInResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountInResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenOutAmount !== "" && n.uint32(10).string(e.tokenOutAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExitSwapShareAmountInResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenOutAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgExitSwapShareAmountInResponse();
    return o.tokenOutAmount = (n = e.tokenOutAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenOutAmount: e.token_out_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_out_amount = e.tokenOutAmount, n;
  },
  fromAminoMsg(e) {
    return MsgExitSwapShareAmountInResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/exit-swap-share-amount-in-response",
      value: MsgExitSwapShareAmountInResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExitSwapShareAmountInResponse.decode(e.value);
  },
  toProto(e) {
    return MsgExitSwapShareAmountInResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountInResponse",
      value: MsgExitSwapShareAmountInResponse.encode(e).finish()
    };
  }
};
function createBaseMsgExitSwapExternAmountOut() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    tokenOut: void 0,
    shareInMaxAmount: ""
  };
}
const MsgExitSwapExternAmountOut = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), e.tokenOut !== void 0 && Coin.encode(e.tokenOut, n.uint32(26).fork()).ldelim(), e.shareInMaxAmount !== "" && n.uint32(34).string(e.shareInMaxAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExitSwapExternAmountOut();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.tokenOut = Coin.decode(o, o.uint32());
          break;
        case 4:
          c.shareInMaxAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgExitSwapExternAmountOut();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.tokenOut = e.tokenOut !== void 0 && e.tokenOut !== null ? Coin.fromPartial(e.tokenOut) : void 0, u.shareInMaxAmount = (o = e.shareInMaxAmount) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      tokenOut: e != null && e.token_out ? Coin.fromAmino(e.token_out) : void 0,
      shareInMaxAmount: e.share_in_max_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_out = e.tokenOut ? Coin.toAmino(e.tokenOut) : void 0, n.share_in_max_amount = e.shareInMaxAmount, n;
  },
  fromAminoMsg(e) {
    return MsgExitSwapExternAmountOut.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/exit-swap-extern-amount-out",
      value: MsgExitSwapExternAmountOut.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExitSwapExternAmountOut.decode(e.value);
  },
  toProto(e) {
    return MsgExitSwapExternAmountOut.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
      value: MsgExitSwapExternAmountOut.encode(e).finish()
    };
  }
};
function createBaseMsgExitSwapExternAmountOutResponse() {
  return {
    shareInAmount: ""
  };
}
const MsgExitSwapExternAmountOutResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOutResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.shareInAmount !== "" && n.uint32(10).string(e.shareInAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExitSwapExternAmountOutResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.shareInAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgExitSwapExternAmountOutResponse();
    return o.shareInAmount = (n = e.shareInAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      shareInAmount: e.share_in_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.share_in_amount = e.shareInAmount, n;
  },
  fromAminoMsg(e) {
    return MsgExitSwapExternAmountOutResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/exit-swap-extern-amount-out-response",
      value: MsgExitSwapExternAmountOutResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExitSwapExternAmountOutResponse.decode(e.value);
  },
  toProto(e) {
    return MsgExitSwapExternAmountOutResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOutResponse",
      value: MsgExitSwapExternAmountOutResponse.encode(e).finish()
    };
  }
}, _123 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgExitPool,
  MsgExitPoolResponse,
  MsgExitSwapExternAmountOut,
  MsgExitSwapExternAmountOutResponse,
  MsgExitSwapShareAmountIn,
  MsgExitSwapShareAmountInResponse,
  MsgJoinPool,
  MsgJoinPoolResponse,
  MsgJoinSwapExternAmountIn,
  MsgJoinSwapExternAmountInResponse,
  MsgJoinSwapShareAmountOut,
  MsgJoinSwapShareAmountOutResponse,
  MsgSwapExactAmountIn: MsgSwapExactAmountIn$1,
  MsgSwapExactAmountInResponse: MsgSwapExactAmountInResponse$1,
  MsgSwapExactAmountOut: MsgSwapExactAmountOut$1,
  MsgSwapExactAmountOutResponse: MsgSwapExactAmountOutResponse$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgCreateBalancerPool() {
  return {
    sender: "",
    poolParams: void 0,
    poolAssets: [],
    futurePoolGovernor: ""
  };
}
const MsgCreateBalancerPool = {
  typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.poolParams !== void 0 && PoolParams$1.encode(e.poolParams, n.uint32(18).fork()).ldelim();
    for (const o of e.poolAssets)
      PoolAsset.encode(o, n.uint32(26).fork()).ldelim();
    return e.futurePoolGovernor !== "" && n.uint32(34).string(e.futurePoolGovernor), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateBalancerPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolParams = PoolParams$1.decode(o, o.uint32());
          break;
        case 3:
          c.poolAssets.push(PoolAsset.decode(o, o.uint32()));
          break;
        case 4:
          c.futurePoolGovernor = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgCreateBalancerPool();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.poolParams = e.poolParams !== void 0 && e.poolParams !== null ? PoolParams$1.fromPartial(e.poolParams) : void 0, c.poolAssets = ((o = e.poolAssets) === null || o === void 0 ? void 0 : o.map((d) => PoolAsset.fromPartial(d))) || [], c.futurePoolGovernor = (u = e.futurePoolGovernor) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolParams: e != null && e.pool_params ? PoolParams$1.fromAmino(e.pool_params) : void 0,
      poolAssets: Array.isArray(e == null ? void 0 : e.pool_assets) ? e.pool_assets.map((n) => PoolAsset.fromAmino(n)) : [],
      futurePoolGovernor: e.future_pool_governor
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_params = e.poolParams ? PoolParams$1.toAmino(e.poolParams) : void 0, e.poolAssets ? n.pool_assets = e.poolAssets.map((o) => o ? PoolAsset.toAmino(o) : void 0) : n.pool_assets = [], n.future_pool_governor = e.futurePoolGovernor, n;
  },
  fromAminoMsg(e) {
    return MsgCreateBalancerPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/create-balancer-pool",
      value: MsgCreateBalancerPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateBalancerPool.decode(e.value);
  },
  toProto(e) {
    return MsgCreateBalancerPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
      value: MsgCreateBalancerPool.encode(e).finish()
    };
  }
};
function createBaseMsgCreateBalancerPoolResponse() {
  return {
    poolId: Long$2.UZERO
  };
}
const MsgCreateBalancerPoolResponse = {
  typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateBalancerPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgCreateBalancerPoolResponse();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgCreateBalancerPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/poolmodels/balancer/create-balancer-pool-response",
      value: MsgCreateBalancerPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateBalancerPoolResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCreateBalancerPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPoolResponse",
      value: MsgCreateBalancerPoolResponse.encode(e).finish()
    };
  }
};
function createBaseMsgMigrateSharesToFullRangeConcentratedPosition() {
  return {
    sender: "",
    sharesToMigrate: void 0
  };
}
const MsgMigrateSharesToFullRangeConcentratedPosition = {
  typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPosition",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.sharesToMigrate !== void 0 && Coin.encode(e.sharesToMigrate, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgMigrateSharesToFullRangeConcentratedPosition();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.sharesToMigrate = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgMigrateSharesToFullRangeConcentratedPosition();
    return o.sender = (n = e.sender) !== null && n !== void 0 ? n : "", o.sharesToMigrate = e.sharesToMigrate !== void 0 && e.sharesToMigrate !== null ? Coin.fromPartial(e.sharesToMigrate) : void 0, o;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      sharesToMigrate: e != null && e.shares_to_migrate ? Coin.fromAmino(e.shares_to_migrate) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.shares_to_migrate = e.sharesToMigrate ? Coin.toAmino(e.sharesToMigrate) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgMigrateSharesToFullRangeConcentratedPosition.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/poolmodels/balancer/migrate-shares-to-full-range-concentrated-position",
      value: MsgMigrateSharesToFullRangeConcentratedPosition.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgMigrateSharesToFullRangeConcentratedPosition.decode(e.value);
  },
  toProto(e) {
    return MsgMigrateSharesToFullRangeConcentratedPosition.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPosition",
      value: MsgMigrateSharesToFullRangeConcentratedPosition.encode(e).finish()
    };
  }
};
function createBaseMsgMigrateSharesToFullRangeConcentratedPositionResponse() {
  return {
    amount0: "",
    amount1: "",
    liquidityCreated: "",
    joinTime: void 0
  };
}
const MsgMigrateSharesToFullRangeConcentratedPositionResponse = {
  typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPositionResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.amount0 !== "" && n.uint32(10).string(e.amount0), e.amount1 !== "" && n.uint32(18).string(e.amount1), e.liquidityCreated !== "" && n.uint32(26).string(e.liquidityCreated), e.joinTime !== void 0 && Timestamp.encode(toTimestamp(e.joinTime), n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgMigrateSharesToFullRangeConcentratedPositionResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount0 = o.string();
          break;
        case 2:
          c.amount1 = o.string();
          break;
        case 3:
          c.liquidityCreated = o.string();
          break;
        case 4:
          c.joinTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgMigrateSharesToFullRangeConcentratedPositionResponse();
    return d.amount0 = (n = e.amount0) !== null && n !== void 0 ? n : "", d.amount1 = (o = e.amount1) !== null && o !== void 0 ? o : "", d.liquidityCreated = (u = e.liquidityCreated) !== null && u !== void 0 ? u : "", d.joinTime = (c = e.joinTime) !== null && c !== void 0 ? c : void 0, d;
  },
  fromAmino(e) {
    return {
      amount0: e.amount0,
      amount1: e.amount1,
      liquidityCreated: e.liquidity_created,
      joinTime: e != null && e.join_time ? Timestamp.fromAmino(e.join_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.amount0 = e.amount0, n.amount1 = e.amount1, n.liquidity_created = e.liquidityCreated, n.join_time = e.joinTime ? Timestamp.toAmino(e.joinTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgMigrateSharesToFullRangeConcentratedPositionResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/poolmodels/balancer/migrate-shares-to-full-range-concentrated-position-response",
      value: MsgMigrateSharesToFullRangeConcentratedPositionResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgMigrateSharesToFullRangeConcentratedPositionResponse.decode(e.value);
  },
  toProto(e) {
    return MsgMigrateSharesToFullRangeConcentratedPositionResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPositionResponse",
      value: MsgMigrateSharesToFullRangeConcentratedPositionResponse.encode(e).finish()
    };
  }
}, _124 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgCreateBalancerPool,
  MsgCreateBalancerPoolResponse,
  MsgMigrateSharesToFullRangeConcentratedPosition,
  MsgMigrateSharesToFullRangeConcentratedPositionResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgCreateStableswapPool() {
  return {
    sender: "",
    poolParams: void 0,
    initialPoolLiquidity: [],
    scalingFactors: [],
    futurePoolGovernor: "",
    scalingFactorController: ""
  };
}
const MsgCreateStableswapPool = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.poolParams !== void 0 && PoolParams.encode(e.poolParams, n.uint32(18).fork()).ldelim();
    for (const o of e.initialPoolLiquidity)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    n.uint32(34).fork();
    for (const o of e.scalingFactors)
      n.uint64(o);
    return n.ldelim(), e.futurePoolGovernor !== "" && n.uint32(42).string(e.futurePoolGovernor), e.scalingFactorController !== "" && n.uint32(50).string(e.scalingFactorController), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateStableswapPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolParams = PoolParams.decode(o, o.uint32());
          break;
        case 3:
          c.initialPoolLiquidity.push(Coin.decode(o, o.uint32()));
          break;
        case 4:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.scalingFactors.push(o.uint64());
          } else
            c.scalingFactors.push(o.uint64());
          break;
        case 5:
          c.futurePoolGovernor = o.string();
          break;
        case 6:
          c.scalingFactorController = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseMsgCreateStableswapPool();
    return m.sender = (n = e.sender) !== null && n !== void 0 ? n : "", m.poolParams = e.poolParams !== void 0 && e.poolParams !== null ? PoolParams.fromPartial(e.poolParams) : void 0, m.initialPoolLiquidity = ((o = e.initialPoolLiquidity) === null || o === void 0 ? void 0 : o.map((v) => Coin.fromPartial(v))) || [], m.scalingFactors = ((u = e.scalingFactors) === null || u === void 0 ? void 0 : u.map((v) => Long$2.fromValue(v))) || [], m.futurePoolGovernor = (c = e.futurePoolGovernor) !== null && c !== void 0 ? c : "", m.scalingFactorController = (d = e.scalingFactorController) !== null && d !== void 0 ? d : "", m;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolParams: e != null && e.pool_params ? PoolParams.fromAmino(e.pool_params) : void 0,
      initialPoolLiquidity: Array.isArray(e == null ? void 0 : e.initial_pool_liquidity) ? e.initial_pool_liquidity.map((n) => Coin.fromAmino(n)) : [],
      scalingFactors: Array.isArray(e == null ? void 0 : e.scaling_factors) ? e.scaling_factors.map((n) => n) : [],
      futurePoolGovernor: e.future_pool_governor,
      scalingFactorController: e.scaling_factor_controller
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_params = e.poolParams ? PoolParams.toAmino(e.poolParams) : void 0, e.initialPoolLiquidity ? n.initial_pool_liquidity = e.initialPoolLiquidity.map((o) => o ? Coin.toAmino(o) : void 0) : n.initial_pool_liquidity = [], e.scalingFactors ? n.scaling_factors = e.scalingFactors.map((o) => o) : n.scaling_factors = [], n.future_pool_governor = e.futurePoolGovernor, n.scaling_factor_controller = e.scalingFactorController, n;
  },
  fromAminoMsg(e) {
    return MsgCreateStableswapPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/create-stableswap-pool",
      value: MsgCreateStableswapPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateStableswapPool.decode(e.value);
  },
  toProto(e) {
    return MsgCreateStableswapPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
      value: MsgCreateStableswapPool.encode(e).finish()
    };
  }
};
function createBaseMsgCreateStableswapPoolResponse() {
  return {
    poolId: Long$2.UZERO
  };
}
const MsgCreateStableswapPoolResponse = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateStableswapPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgCreateStableswapPoolResponse();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgCreateStableswapPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/create-stableswap-pool-response",
      value: MsgCreateStableswapPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateStableswapPoolResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCreateStableswapPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPoolResponse",
      value: MsgCreateStableswapPoolResponse.encode(e).finish()
    };
  }
};
function createBaseMsgStableSwapAdjustScalingFactors() {
  return {
    sender: "",
    poolId: Long$2.UZERO,
    scalingFactors: []
  };
}
const MsgStableSwapAdjustScalingFactors = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), n.uint32(26).fork();
    for (const o of e.scalingFactors)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgStableSwapAdjustScalingFactors();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.scalingFactors.push(o.uint64());
          } else
            c.scalingFactors.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgStableSwapAdjustScalingFactors();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.scalingFactors = ((o = e.scalingFactors) === null || o === void 0 ? void 0 : o.map((c) => Long$2.fromValue(c))) || [], u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id),
      scalingFactors: Array.isArray(e == null ? void 0 : e.scaling_factors) ? e.scaling_factors.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, e.scalingFactors ? n.scaling_factors = e.scalingFactors.map((o) => o) : n.scaling_factors = [], n;
  },
  fromAminoMsg(e) {
    return MsgStableSwapAdjustScalingFactors.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/stableswap-adjust-scaling-factors",
      value: MsgStableSwapAdjustScalingFactors.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgStableSwapAdjustScalingFactors.decode(e.value);
  },
  toProto(e) {
    return MsgStableSwapAdjustScalingFactors.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
      value: MsgStableSwapAdjustScalingFactors.encode(e).finish()
    };
  }
};
function createBaseMsgStableSwapAdjustScalingFactorsResponse() {
  return {};
}
const MsgStableSwapAdjustScalingFactorsResponse = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactorsResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgStableSwapAdjustScalingFactorsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgStableSwapAdjustScalingFactorsResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgStableSwapAdjustScalingFactorsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/stable-swap-adjust-scaling-factors-response",
      value: MsgStableSwapAdjustScalingFactorsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgStableSwapAdjustScalingFactorsResponse.decode(e.value);
  },
  toProto(e) {
    return MsgStableSwapAdjustScalingFactorsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactorsResponse",
      value: MsgStableSwapAdjustScalingFactorsResponse.encode(e).finish()
    };
  }
}, _126 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgCreateStableswapPool,
  MsgCreateStableswapPoolResponse,
  MsgStableSwapAdjustScalingFactors,
  MsgStableSwapAdjustScalingFactorsResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQuerySpotPriceRequest() {
  return {
    poolId: Long$2.UZERO,
    baseAssetDenom: "",
    quoteAssetDenom: ""
  };
}
const QuerySpotPriceRequest = {
  typeUrl: "/osmosis.gamm.v2.QuerySpotPriceRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.baseAssetDenom !== "" && n.uint32(18).string(e.baseAssetDenom), e.quoteAssetDenom !== "" && n.uint32(26).string(e.quoteAssetDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySpotPriceRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.baseAssetDenom = o.string();
          break;
        case 3:
          c.quoteAssetDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseQuerySpotPriceRequest();
    return u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.baseAssetDenom = (n = e.baseAssetDenom) !== null && n !== void 0 ? n : "", u.quoteAssetDenom = (o = e.quoteAssetDenom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      baseAssetDenom: e.base_asset_denom,
      quoteAssetDenom: e.quote_asset_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.base_asset_denom = e.baseAssetDenom, n.quote_asset_denom = e.quoteAssetDenom, n;
  },
  fromAminoMsg(e) {
    return QuerySpotPriceRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/v2/query-spot-price-request",
      value: QuerySpotPriceRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySpotPriceRequest.decode(e.value);
  },
  toProto(e) {
    return QuerySpotPriceRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v2.QuerySpotPriceRequest",
      value: QuerySpotPriceRequest.encode(e).finish()
    };
  }
};
function createBaseQuerySpotPriceResponse() {
  return {
    spotPrice: ""
  };
}
const QuerySpotPriceResponse = {
  typeUrl: "/osmosis.gamm.v2.QuerySpotPriceResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.spotPrice !== "" && n.uint32(10).string(e.spotPrice), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQuerySpotPriceResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.spotPrice = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQuerySpotPriceResponse();
    return o.spotPrice = (n = e.spotPrice) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      spotPrice: e.spot_price
    };
  },
  toAmino(e) {
    const n = {};
    return n.spot_price = e.spotPrice, n;
  },
  fromAminoMsg(e) {
    return QuerySpotPriceResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/gamm/v2/query-spot-price-response",
      value: QuerySpotPriceResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QuerySpotPriceResponse.decode(e.value);
  },
  toProto(e) {
    return QuerySpotPriceResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.gamm.v2.QuerySpotPriceResponse",
      value: QuerySpotPriceResponse.encode(e).finish()
    };
  }
}, _127 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QuerySpotPriceRequest,
  QuerySpotPriceResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$8() {
  return {
    contractAddress: ""
  };
}
const Params$8 = {
  typeUrl: "/osmosis.ibcratelimit.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.contractAddress !== "" && n.uint32(10).string(e.contractAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$8();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.contractAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$8();
    return o.contractAddress = (n = e.contractAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      contractAddress: e.contract_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.contract_address = e.contractAddress, n;
  },
  fromAminoMsg(e) {
    return Params$8.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/ibcratelimit/params",
      value: Params$8.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$8.decode(e.value);
  },
  toProto(e) {
    return Params$8.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.ibcratelimit.v1beta1.Params",
      value: Params$8.encode(e).finish()
    };
  }
}, _129 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$8
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$a() {
  return {
    params: void 0
  };
}
const GenesisState$a = {
  typeUrl: "/osmosis.ibcratelimit.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$8.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$a();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$8.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGenesisState$a();
    return n.params = e.params !== void 0 && e.params !== null ? Params$8.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$8.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$8.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$a.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/ibcratelimit/genesis-state",
      value: GenesisState$a.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$a.decode(e.value);
  },
  toProto(e) {
    return GenesisState$a.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.ibcratelimit.v1beta1.GenesisState",
      value: GenesisState$a.encode(e).finish()
    };
  }
}, _128 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$a
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParamsRequest$2() {
  return {};
}
const ParamsRequest$2 = {
  typeUrl: "/osmosis.ibcratelimit.v1beta1.ParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParamsRequest$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseParamsRequest$2();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ParamsRequest$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/ibcratelimit/params-request",
      value: ParamsRequest$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ParamsRequest$2.decode(e.value);
  },
  toProto(e) {
    return ParamsRequest$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.ibcratelimit.v1beta1.ParamsRequest",
      value: ParamsRequest$2.encode(e).finish()
    };
  }
};
function createBaseParamsResponse$2() {
  return {
    params: void 0
  };
}
const ParamsResponse$2 = {
  typeUrl: "/osmosis.ibcratelimit.v1beta1.ParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$8.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParamsResponse$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$8.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseParamsResponse$2();
    return n.params = e.params !== void 0 && e.params !== null ? Params$8.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$8.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$8.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return ParamsResponse$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/ibcratelimit/params-response",
      value: ParamsResponse$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ParamsResponse$2.decode(e.value);
  },
  toProto(e) {
    return ParamsResponse$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.ibcratelimit.v1beta1.ParamsResponse",
      value: ParamsResponse$2.encode(e).finish()
    };
  }
}, _130 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ParamsRequest: ParamsRequest$2,
  ParamsResponse: ParamsResponse$2
}, Symbol.toStringTag, { value: "Module" }));
let LockQueryType;
(function(e) {
  e[e.ByDuration = 0] = "ByDuration", e[e.ByTime = 1] = "ByTime", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(LockQueryType || (LockQueryType = {}));
const LockQueryTypeSDKType = LockQueryType, LockQueryTypeAmino = LockQueryType;
function lockQueryTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "ByDuration":
      return LockQueryType.ByDuration;
    case 1:
    case "ByTime":
      return LockQueryType.ByTime;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LockQueryType.UNRECOGNIZED;
  }
}
function lockQueryTypeToJSON(e) {
  switch (e) {
    case LockQueryType.ByDuration:
      return "ByDuration";
    case LockQueryType.ByTime:
      return "ByTime";
    case LockQueryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBasePeriodLock() {
  return {
    ID: Long$2.UZERO,
    owner: "",
    duration: void 0,
    endTime: void 0,
    coins: []
  };
}
const PeriodLock = {
  typeUrl: "/osmosis.lockup.PeriodLock",
  encode(e, n = minimal.Writer.create()) {
    e.ID.isZero() || n.uint32(8).uint64(e.ID), e.owner !== "" && n.uint32(18).string(e.owner), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(26).fork()).ldelim(), e.endTime !== void 0 && Timestamp.encode(toTimestamp(e.endTime), n.uint32(34).fork()).ldelim();
    for (const o of e.coins)
      Coin.encode(o, n.uint32(42).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePeriodLock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.ID = o.uint64();
          break;
        case 2:
          c.owner = o.string();
          break;
        case 3:
          c.duration = Duration.decode(o, o.uint32());
          break;
        case 4:
          c.endTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 5:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBasePeriodLock();
    return c.ID = e.ID !== void 0 && e.ID !== null ? Long$2.fromValue(e.ID) : Long$2.UZERO, c.owner = (n = e.owner) !== null && n !== void 0 ? n : "", c.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, c.endTime = (o = e.endTime) !== null && o !== void 0 ? o : void 0, c.coins = ((u = e.coins) === null || u === void 0 ? void 0 : u.map((d) => Coin.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      ID: Long$2.fromString(e.ID),
      owner: e.owner,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0,
      endTime: e != null && e.end_time ? Timestamp.fromAmino(e.end_time) : void 0,
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.ID = e.ID ? e.ID.toString() : void 0, n.owner = e.owner, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n.end_time = e.endTime ? Timestamp.toAmino(e.endTime) : void 0, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return PeriodLock.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/period-lock",
      value: PeriodLock.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PeriodLock.decode(e.value);
  },
  toProto(e) {
    return PeriodLock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.PeriodLock",
      value: PeriodLock.encode(e).finish()
    };
  }
};
function createBaseQueryCondition() {
  return {
    lockQueryType: 0,
    denom: "",
    duration: void 0,
    timestamp: void 0
  };
}
const QueryCondition = {
  typeUrl: "/osmosis.lockup.QueryCondition",
  encode(e, n = minimal.Writer.create()) {
    return e.lockQueryType !== 0 && n.uint32(8).int32(e.lockQueryType), e.denom !== "" && n.uint32(18).string(e.denom), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(26).fork()).ldelim(), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryCondition();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockQueryType = o.int32();
          break;
        case 2:
          c.denom = o.string();
          break;
        case 3:
          c.duration = Duration.decode(o, o.uint32());
          break;
        case 4:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryCondition();
    return c.lockQueryType = (n = e.lockQueryType) !== null && n !== void 0 ? n : 0, c.denom = (o = e.denom) !== null && o !== void 0 ? o : "", c.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, c.timestamp = (u = e.timestamp) !== null && u !== void 0 ? u : void 0, c;
  },
  fromAmino(e) {
    return {
      lockQueryType: isSet(e.lock_query_type) ? lockQueryTypeFromJSON(e.lock_query_type) : 0,
      denom: e.denom,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0,
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.lock_query_type = e.lockQueryType, n.denom = e.denom, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryCondition.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/query-condition",
      value: QueryCondition.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryCondition.decode(e.value);
  },
  toProto(e) {
    return QueryCondition.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.QueryCondition",
      value: QueryCondition.encode(e).finish()
    };
  }
};
function createBaseSyntheticLock() {
  return {
    underlyingLockId: Long$2.UZERO,
    synthDenom: "",
    endTime: void 0,
    duration: void 0
  };
}
const SyntheticLock = {
  typeUrl: "/osmosis.lockup.SyntheticLock",
  encode(e, n = minimal.Writer.create()) {
    return e.underlyingLockId.isZero() || n.uint32(8).uint64(e.underlyingLockId), e.synthDenom !== "" && n.uint32(18).string(e.synthDenom), e.endTime !== void 0 && Timestamp.encode(toTimestamp(e.endTime), n.uint32(26).fork()).ldelim(), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSyntheticLock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.underlyingLockId = o.uint64();
          break;
        case 2:
          c.synthDenom = o.string();
          break;
        case 3:
          c.endTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 4:
          c.duration = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSyntheticLock();
    return u.underlyingLockId = e.underlyingLockId !== void 0 && e.underlyingLockId !== null ? Long$2.fromValue(e.underlyingLockId) : Long$2.UZERO, u.synthDenom = (n = e.synthDenom) !== null && n !== void 0 ? n : "", u.endTime = (o = e.endTime) !== null && o !== void 0 ? o : void 0, u.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, u;
  },
  fromAmino(e) {
    return {
      underlyingLockId: Long$2.fromString(e.underlying_lock_id),
      synthDenom: e.synth_denom,
      endTime: e != null && e.end_time ? Timestamp.fromAmino(e.end_time) : void 0,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.underlying_lock_id = e.underlyingLockId ? e.underlyingLockId.toString() : void 0, n.synth_denom = e.synthDenom, n.end_time = e.endTime ? Timestamp.toAmino(e.endTime) : void 0, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n;
  },
  fromAminoMsg(e) {
    return SyntheticLock.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/synthetic-lock",
      value: SyntheticLock.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SyntheticLock.decode(e.value);
  },
  toProto(e) {
    return SyntheticLock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.SyntheticLock",
      value: SyntheticLock.encode(e).finish()
    };
  }
}, _137 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get LockQueryType() {
    return LockQueryType;
  },
  LockQueryTypeAmino,
  LockQueryTypeSDKType,
  PeriodLock,
  QueryCondition,
  SyntheticLock,
  lockQueryTypeFromJSON,
  lockQueryTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGauge() {
  return {
    id: Long$2.UZERO,
    isPerpetual: !1,
    distributeTo: void 0,
    coins: [],
    startTime: void 0,
    numEpochsPaidOver: Long$2.UZERO,
    filledEpochs: Long$2.UZERO,
    distributedCoins: []
  };
}
const Gauge = {
  typeUrl: "/osmosis.incentives.Gauge",
  encode(e, n = minimal.Writer.create()) {
    e.id.isZero() || n.uint32(8).uint64(e.id), e.isPerpetual === !0 && n.uint32(16).bool(e.isPerpetual), e.distributeTo !== void 0 && QueryCondition.encode(e.distributeTo, n.uint32(26).fork()).ldelim();
    for (const o of e.coins)
      Coin.encode(o, n.uint32(34).fork()).ldelim();
    e.startTime !== void 0 && Timestamp.encode(toTimestamp(e.startTime), n.uint32(42).fork()).ldelim(), e.numEpochsPaidOver.isZero() || n.uint32(48).uint64(e.numEpochsPaidOver), e.filledEpochs.isZero() || n.uint32(56).uint64(e.filledEpochs);
    for (const o of e.distributedCoins)
      Coin.encode(o, n.uint32(66).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGauge();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.id = o.uint64();
          break;
        case 2:
          c.isPerpetual = o.bool();
          break;
        case 3:
          c.distributeTo = QueryCondition.decode(o, o.uint32());
          break;
        case 4:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        case 5:
          c.startTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 6:
          c.numEpochsPaidOver = o.uint64();
          break;
        case 7:
          c.filledEpochs = o.uint64();
          break;
        case 8:
          c.distributedCoins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseGauge();
    return d.id = e.id !== void 0 && e.id !== null ? Long$2.fromValue(e.id) : Long$2.UZERO, d.isPerpetual = (n = e.isPerpetual) !== null && n !== void 0 ? n : !1, d.distributeTo = e.distributeTo !== void 0 && e.distributeTo !== null ? QueryCondition.fromPartial(e.distributeTo) : void 0, d.coins = ((o = e.coins) === null || o === void 0 ? void 0 : o.map((m) => Coin.fromPartial(m))) || [], d.startTime = (u = e.startTime) !== null && u !== void 0 ? u : void 0, d.numEpochsPaidOver = e.numEpochsPaidOver !== void 0 && e.numEpochsPaidOver !== null ? Long$2.fromValue(e.numEpochsPaidOver) : Long$2.UZERO, d.filledEpochs = e.filledEpochs !== void 0 && e.filledEpochs !== null ? Long$2.fromValue(e.filledEpochs) : Long$2.UZERO, d.distributedCoins = ((c = e.distributedCoins) === null || c === void 0 ? void 0 : c.map((m) => Coin.fromPartial(m))) || [], d;
  },
  fromAmino(e) {
    return {
      id: Long$2.fromString(e.id),
      isPerpetual: e.is_perpetual,
      distributeTo: e != null && e.distribute_to ? QueryCondition.fromAmino(e.distribute_to) : void 0,
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : [],
      startTime: e != null && e.start_time ? Timestamp.fromAmino(e.start_time) : void 0,
      numEpochsPaidOver: Long$2.fromString(e.num_epochs_paid_over),
      filledEpochs: Long$2.fromString(e.filled_epochs),
      distributedCoins: Array.isArray(e == null ? void 0 : e.distributed_coins) ? e.distributed_coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.id = e.id ? e.id.toString() : void 0, n.is_perpetual = e.isPerpetual, n.distribute_to = e.distributeTo ? QueryCondition.toAmino(e.distributeTo) : void 0, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n.start_time = e.startTime ? Timestamp.toAmino(e.startTime) : void 0, n.num_epochs_paid_over = e.numEpochsPaidOver ? e.numEpochsPaidOver.toString() : void 0, n.filled_epochs = e.filledEpochs ? e.filledEpochs.toString() : void 0, e.distributedCoins ? n.distributed_coins = e.distributedCoins.map((o) => o ? Coin.toAmino(o) : void 0) : n.distributed_coins = [], n;
  },
  fromAminoMsg(e) {
    return Gauge.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/gauge",
      value: Gauge.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Gauge.decode(e.value);
  },
  toProto(e) {
    return Gauge.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.Gauge",
      value: Gauge.encode(e).finish()
    };
  }
};
function createBaseLockableDurationsInfo() {
  return {
    lockableDurations: []
  };
}
const LockableDurationsInfo = {
  typeUrl: "/osmosis.incentives.LockableDurationsInfo",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.lockableDurations)
      Duration.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLockableDurationsInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockableDurations.push(Duration.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseLockableDurationsInfo();
    return o.lockableDurations = ((n = e.lockableDurations) === null || n === void 0 ? void 0 : n.map((u) => Duration.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      lockableDurations: Array.isArray(e == null ? void 0 : e.lockable_durations) ? e.lockable_durations.map((n) => Duration.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.lockableDurations ? n.lockable_durations = e.lockableDurations.map((o) => o ? Duration.toAmino(o) : void 0) : n.lockable_durations = [], n;
  },
  fromAminoMsg(e) {
    return LockableDurationsInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/lockable-durations-info",
      value: LockableDurationsInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LockableDurationsInfo.decode(e.value);
  },
  toProto(e) {
    return LockableDurationsInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.LockableDurationsInfo",
      value: LockableDurationsInfo.encode(e).finish()
    };
  }
}, _131 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Gauge,
  LockableDurationsInfo
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$7() {
  return {
    distrEpochIdentifier: ""
  };
}
const Params$7 = {
  typeUrl: "/osmosis.incentives.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.distrEpochIdentifier !== "" && n.uint32(10).string(e.distrEpochIdentifier), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$7();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.distrEpochIdentifier = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$7();
    return o.distrEpochIdentifier = (n = e.distrEpochIdentifier) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      distrEpochIdentifier: e.distr_epoch_identifier
    };
  },
  toAmino(e) {
    const n = {};
    return n.distr_epoch_identifier = e.distrEpochIdentifier, n;
  },
  fromAminoMsg(e) {
    return Params$7.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/params",
      value: Params$7.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$7.decode(e.value);
  },
  toProto(e) {
    return Params$7.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.Params",
      value: Params$7.encode(e).finish()
    };
  }
}, _133 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$7
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$9() {
  return {
    params: void 0,
    gauges: [],
    lockableDurations: [],
    lastGaugeId: Long$2.UZERO
  };
}
const GenesisState$9 = {
  typeUrl: "/osmosis.incentives.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$7.encode(e.params, n.uint32(10).fork()).ldelim();
    for (const o of e.gauges)
      Gauge.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.lockableDurations)
      Duration.encode(o, n.uint32(26).fork()).ldelim();
    return e.lastGaugeId.isZero() || n.uint32(32).uint64(e.lastGaugeId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$9();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$7.decode(o, o.uint32());
          break;
        case 2:
          c.gauges.push(Gauge.decode(o, o.uint32()));
          break;
        case 3:
          c.lockableDurations.push(Duration.decode(o, o.uint32()));
          break;
        case 4:
          c.lastGaugeId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisState$9();
    return u.params = e.params !== void 0 && e.params !== null ? Params$7.fromPartial(e.params) : void 0, u.gauges = ((n = e.gauges) === null || n === void 0 ? void 0 : n.map((c) => Gauge.fromPartial(c))) || [], u.lockableDurations = ((o = e.lockableDurations) === null || o === void 0 ? void 0 : o.map((c) => Duration.fromPartial(c))) || [], u.lastGaugeId = e.lastGaugeId !== void 0 && e.lastGaugeId !== null ? Long$2.fromValue(e.lastGaugeId) : Long$2.UZERO, u;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$7.fromAmino(e.params) : void 0,
      gauges: Array.isArray(e == null ? void 0 : e.gauges) ? e.gauges.map((n) => Gauge.fromAmino(n)) : [],
      lockableDurations: Array.isArray(e == null ? void 0 : e.lockable_durations) ? e.lockable_durations.map((n) => Duration.fromAmino(n)) : [],
      lastGaugeId: Long$2.fromString(e.last_gauge_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$7.toAmino(e.params) : void 0, e.gauges ? n.gauges = e.gauges.map((o) => o ? Gauge.toAmino(o) : void 0) : n.gauges = [], e.lockableDurations ? n.lockable_durations = e.lockableDurations.map((o) => o ? Duration.toAmino(o) : void 0) : n.lockable_durations = [], n.last_gauge_id = e.lastGaugeId ? e.lastGaugeId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$9.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/genesis-state",
      value: GenesisState$9.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$9.decode(e.value);
  },
  toProto(e) {
    return GenesisState$9.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.GenesisState",
      value: GenesisState$9.encode(e).finish()
    };
  }
}, _132 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$9
}, Symbol.toStringTag, { value: "Module" }));
function createBaseModuleToDistributeCoinsRequest() {
  return {};
}
const ModuleToDistributeCoinsRequest = {
  typeUrl: "/osmosis.incentives.ModuleToDistributeCoinsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleToDistributeCoinsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseModuleToDistributeCoinsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ModuleToDistributeCoinsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/module-to-distribute-coins-request",
      value: ModuleToDistributeCoinsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleToDistributeCoinsRequest.decode(e.value);
  },
  toProto(e) {
    return ModuleToDistributeCoinsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.ModuleToDistributeCoinsRequest",
      value: ModuleToDistributeCoinsRequest.encode(e).finish()
    };
  }
};
function createBaseModuleToDistributeCoinsResponse() {
  return {
    coins: []
  };
}
const ModuleToDistributeCoinsResponse = {
  typeUrl: "/osmosis.incentives.ModuleToDistributeCoinsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.coins)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleToDistributeCoinsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseModuleToDistributeCoinsResponse();
    return o.coins = ((n = e.coins) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return ModuleToDistributeCoinsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/module-to-distribute-coins-response",
      value: ModuleToDistributeCoinsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleToDistributeCoinsResponse.decode(e.value);
  },
  toProto(e) {
    return ModuleToDistributeCoinsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.ModuleToDistributeCoinsResponse",
      value: ModuleToDistributeCoinsResponse.encode(e).finish()
    };
  }
};
function createBaseGaugeByIDRequest() {
  return {
    id: Long$2.UZERO
  };
}
const GaugeByIDRequest = {
  typeUrl: "/osmosis.incentives.GaugeByIDRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.id.isZero() || n.uint32(8).uint64(e.id), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGaugeByIDRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.id = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGaugeByIDRequest();
    return n.id = e.id !== void 0 && e.id !== null ? Long$2.fromValue(e.id) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      id: Long$2.fromString(e.id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.id = e.id ? e.id.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return GaugeByIDRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/gauge-by-id-request",
      value: GaugeByIDRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GaugeByIDRequest.decode(e.value);
  },
  toProto(e) {
    return GaugeByIDRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.GaugeByIDRequest",
      value: GaugeByIDRequest.encode(e).finish()
    };
  }
};
function createBaseGaugeByIDResponse() {
  return {
    gauge: void 0
  };
}
const GaugeByIDResponse = {
  typeUrl: "/osmosis.incentives.GaugeByIDResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.gauge !== void 0 && Gauge.encode(e.gauge, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGaugeByIDResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.gauge = Gauge.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGaugeByIDResponse();
    return n.gauge = e.gauge !== void 0 && e.gauge !== null ? Gauge.fromPartial(e.gauge) : void 0, n;
  },
  fromAmino(e) {
    return {
      gauge: e != null && e.gauge ? Gauge.fromAmino(e.gauge) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.gauge = e.gauge ? Gauge.toAmino(e.gauge) : void 0, n;
  },
  fromAminoMsg(e) {
    return GaugeByIDResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/gauge-by-id-response",
      value: GaugeByIDResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GaugeByIDResponse.decode(e.value);
  },
  toProto(e) {
    return GaugeByIDResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.GaugeByIDResponse",
      value: GaugeByIDResponse.encode(e).finish()
    };
  }
};
function createBaseGaugesRequest() {
  return {
    pagination: void 0
  };
}
const GaugesRequest = {
  typeUrl: "/osmosis.incentives.GaugesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGaugesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGaugesRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return GaugesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/gauges-request",
      value: GaugesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GaugesRequest.decode(e.value);
  },
  toProto(e) {
    return GaugesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.GaugesRequest",
      value: GaugesRequest.encode(e).finish()
    };
  }
};
function createBaseGaugesResponse() {
  return {
    data: [],
    pagination: void 0
  };
}
const GaugesResponse = {
  typeUrl: "/osmosis.incentives.GaugesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.data)
      Gauge.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGaugesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data.push(Gauge.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGaugesResponse();
    return o.data = ((n = e.data) === null || n === void 0 ? void 0 : n.map((u) => Gauge.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      data: Array.isArray(e == null ? void 0 : e.data) ? e.data.map((n) => Gauge.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.data ? n.data = e.data.map((o) => o ? Gauge.toAmino(o) : void 0) : n.data = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return GaugesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/gauges-response",
      value: GaugesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GaugesResponse.decode(e.value);
  },
  toProto(e) {
    return GaugesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.GaugesResponse",
      value: GaugesResponse.encode(e).finish()
    };
  }
};
function createBaseActiveGaugesRequest() {
  return {
    pagination: void 0
  };
}
const ActiveGaugesRequest = {
  typeUrl: "/osmosis.incentives.ActiveGaugesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseActiveGaugesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseActiveGaugesRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return ActiveGaugesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/active-gauges-request",
      value: ActiveGaugesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ActiveGaugesRequest.decode(e.value);
  },
  toProto(e) {
    return ActiveGaugesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.ActiveGaugesRequest",
      value: ActiveGaugesRequest.encode(e).finish()
    };
  }
};
function createBaseActiveGaugesResponse() {
  return {
    data: [],
    pagination: void 0
  };
}
const ActiveGaugesResponse = {
  typeUrl: "/osmosis.incentives.ActiveGaugesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.data)
      Gauge.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseActiveGaugesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data.push(Gauge.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseActiveGaugesResponse();
    return o.data = ((n = e.data) === null || n === void 0 ? void 0 : n.map((u) => Gauge.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      data: Array.isArray(e == null ? void 0 : e.data) ? e.data.map((n) => Gauge.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.data ? n.data = e.data.map((o) => o ? Gauge.toAmino(o) : void 0) : n.data = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return ActiveGaugesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/active-gauges-response",
      value: ActiveGaugesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ActiveGaugesResponse.decode(e.value);
  },
  toProto(e) {
    return ActiveGaugesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.ActiveGaugesResponse",
      value: ActiveGaugesResponse.encode(e).finish()
    };
  }
};
function createBaseActiveGaugesPerDenomRequest() {
  return {
    denom: "",
    pagination: void 0
  };
}
const ActiveGaugesPerDenomRequest = {
  typeUrl: "/osmosis.incentives.ActiveGaugesPerDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseActiveGaugesPerDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseActiveGaugesPerDenomRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return ActiveGaugesPerDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/active-gauges-per-denom-request",
      value: ActiveGaugesPerDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ActiveGaugesPerDenomRequest.decode(e.value);
  },
  toProto(e) {
    return ActiveGaugesPerDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.ActiveGaugesPerDenomRequest",
      value: ActiveGaugesPerDenomRequest.encode(e).finish()
    };
  }
};
function createBaseActiveGaugesPerDenomResponse() {
  return {
    data: [],
    pagination: void 0
  };
}
const ActiveGaugesPerDenomResponse = {
  typeUrl: "/osmosis.incentives.ActiveGaugesPerDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.data)
      Gauge.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseActiveGaugesPerDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data.push(Gauge.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseActiveGaugesPerDenomResponse();
    return o.data = ((n = e.data) === null || n === void 0 ? void 0 : n.map((u) => Gauge.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      data: Array.isArray(e == null ? void 0 : e.data) ? e.data.map((n) => Gauge.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.data ? n.data = e.data.map((o) => o ? Gauge.toAmino(o) : void 0) : n.data = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return ActiveGaugesPerDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/active-gauges-per-denom-response",
      value: ActiveGaugesPerDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ActiveGaugesPerDenomResponse.decode(e.value);
  },
  toProto(e) {
    return ActiveGaugesPerDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.ActiveGaugesPerDenomResponse",
      value: ActiveGaugesPerDenomResponse.encode(e).finish()
    };
  }
};
function createBaseUpcomingGaugesRequest() {
  return {
    pagination: void 0
  };
}
const UpcomingGaugesRequest = {
  typeUrl: "/osmosis.incentives.UpcomingGaugesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpcomingGaugesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseUpcomingGaugesRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return UpcomingGaugesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/upcoming-gauges-request",
      value: UpcomingGaugesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpcomingGaugesRequest.decode(e.value);
  },
  toProto(e) {
    return UpcomingGaugesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.UpcomingGaugesRequest",
      value: UpcomingGaugesRequest.encode(e).finish()
    };
  }
};
function createBaseUpcomingGaugesResponse() {
  return {
    data: [],
    pagination: void 0
  };
}
const UpcomingGaugesResponse = {
  typeUrl: "/osmosis.incentives.UpcomingGaugesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.data)
      Gauge.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpcomingGaugesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data.push(Gauge.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseUpcomingGaugesResponse();
    return o.data = ((n = e.data) === null || n === void 0 ? void 0 : n.map((u) => Gauge.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      data: Array.isArray(e == null ? void 0 : e.data) ? e.data.map((n) => Gauge.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.data ? n.data = e.data.map((o) => o ? Gauge.toAmino(o) : void 0) : n.data = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return UpcomingGaugesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/upcoming-gauges-response",
      value: UpcomingGaugesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpcomingGaugesResponse.decode(e.value);
  },
  toProto(e) {
    return UpcomingGaugesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.UpcomingGaugesResponse",
      value: UpcomingGaugesResponse.encode(e).finish()
    };
  }
};
function createBaseUpcomingGaugesPerDenomRequest() {
  return {
    denom: "",
    pagination: void 0
  };
}
const UpcomingGaugesPerDenomRequest = {
  typeUrl: "/osmosis.incentives.UpcomingGaugesPerDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpcomingGaugesPerDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseUpcomingGaugesPerDenomRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return UpcomingGaugesPerDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/upcoming-gauges-per-denom-request",
      value: UpcomingGaugesPerDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpcomingGaugesPerDenomRequest.decode(e.value);
  },
  toProto(e) {
    return UpcomingGaugesPerDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.UpcomingGaugesPerDenomRequest",
      value: UpcomingGaugesPerDenomRequest.encode(e).finish()
    };
  }
};
function createBaseUpcomingGaugesPerDenomResponse() {
  return {
    upcomingGauges: [],
    pagination: void 0
  };
}
const UpcomingGaugesPerDenomResponse = {
  typeUrl: "/osmosis.incentives.UpcomingGaugesPerDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.upcomingGauges)
      Gauge.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUpcomingGaugesPerDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.upcomingGauges.push(Gauge.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseUpcomingGaugesPerDenomResponse();
    return o.upcomingGauges = ((n = e.upcomingGauges) === null || n === void 0 ? void 0 : n.map((u) => Gauge.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      upcomingGauges: Array.isArray(e == null ? void 0 : e.upcoming_gauges) ? e.upcoming_gauges.map((n) => Gauge.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.upcomingGauges ? n.upcoming_gauges = e.upcomingGauges.map((o) => o ? Gauge.toAmino(o) : void 0) : n.upcoming_gauges = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return UpcomingGaugesPerDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/upcoming-gauges-per-denom-response",
      value: UpcomingGaugesPerDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UpcomingGaugesPerDenomResponse.decode(e.value);
  },
  toProto(e) {
    return UpcomingGaugesPerDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.UpcomingGaugesPerDenomResponse",
      value: UpcomingGaugesPerDenomResponse.encode(e).finish()
    };
  }
};
function createBaseRewardsEstRequest() {
  return {
    owner: "",
    lockIds: [],
    endEpoch: Long$2.ZERO
  };
}
const RewardsEstRequest = {
  typeUrl: "/osmosis.incentives.RewardsEstRequest",
  encode(e, n = minimal.Writer.create()) {
    e.owner !== "" && n.uint32(10).string(e.owner), n.uint32(18).fork();
    for (const o of e.lockIds)
      n.uint64(o);
    return n.ldelim(), e.endEpoch.isZero() || n.uint32(24).int64(e.endEpoch), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRewardsEstRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.lockIds.push(o.uint64());
          } else
            c.lockIds.push(o.uint64());
          break;
        case 3:
          c.endEpoch = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseRewardsEstRequest();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.lockIds = ((o = e.lockIds) === null || o === void 0 ? void 0 : o.map((c) => Long$2.fromValue(c))) || [], u.endEpoch = e.endEpoch !== void 0 && e.endEpoch !== null ? Long$2.fromValue(e.endEpoch) : Long$2.ZERO, u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      lockIds: Array.isArray(e == null ? void 0 : e.lock_ids) ? e.lock_ids.map((n) => n) : [],
      endEpoch: Long$2.fromString(e.end_epoch)
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, e.lockIds ? n.lock_ids = e.lockIds.map((o) => o) : n.lock_ids = [], n.end_epoch = e.endEpoch ? e.endEpoch.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return RewardsEstRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/rewards-est-request",
      value: RewardsEstRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RewardsEstRequest.decode(e.value);
  },
  toProto(e) {
    return RewardsEstRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.RewardsEstRequest",
      value: RewardsEstRequest.encode(e).finish()
    };
  }
};
function createBaseRewardsEstResponse() {
  return {
    coins: []
  };
}
const RewardsEstResponse = {
  typeUrl: "/osmosis.incentives.RewardsEstResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.coins)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRewardsEstResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseRewardsEstResponse();
    return o.coins = ((n = e.coins) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return RewardsEstResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/rewards-est-response",
      value: RewardsEstResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RewardsEstResponse.decode(e.value);
  },
  toProto(e) {
    return RewardsEstResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.RewardsEstResponse",
      value: RewardsEstResponse.encode(e).finish()
    };
  }
};
function createBaseQueryLockableDurationsRequest$1() {
  return {};
}
const QueryLockableDurationsRequest$1 = {
  typeUrl: "/osmosis.incentives.QueryLockableDurationsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryLockableDurationsRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryLockableDurationsRequest$1();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryLockableDurationsRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/query-lockable-durations-request",
      value: QueryLockableDurationsRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryLockableDurationsRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryLockableDurationsRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.QueryLockableDurationsRequest",
      value: QueryLockableDurationsRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryLockableDurationsResponse$1() {
  return {
    lockableDurations: []
  };
}
const QueryLockableDurationsResponse$1 = {
  typeUrl: "/osmosis.incentives.QueryLockableDurationsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.lockableDurations)
      Duration.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryLockableDurationsResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockableDurations.push(Duration.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryLockableDurationsResponse$1();
    return o.lockableDurations = ((n = e.lockableDurations) === null || n === void 0 ? void 0 : n.map((u) => Duration.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      lockableDurations: Array.isArray(e == null ? void 0 : e.lockable_durations) ? e.lockable_durations.map((n) => Duration.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.lockableDurations ? n.lockable_durations = e.lockableDurations.map((o) => o ? Duration.toAmino(o) : void 0) : n.lockable_durations = [], n;
  },
  fromAminoMsg(e) {
    return QueryLockableDurationsResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/query-lockable-durations-response",
      value: QueryLockableDurationsResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryLockableDurationsResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryLockableDurationsResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.QueryLockableDurationsResponse",
      value: QueryLockableDurationsResponse$1.encode(e).finish()
    };
  }
}, _134 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActiveGaugesPerDenomRequest,
  ActiveGaugesPerDenomResponse,
  ActiveGaugesRequest,
  ActiveGaugesResponse,
  GaugeByIDRequest,
  GaugeByIDResponse,
  GaugesRequest,
  GaugesResponse,
  ModuleToDistributeCoinsRequest,
  ModuleToDistributeCoinsResponse,
  QueryLockableDurationsRequest: QueryLockableDurationsRequest$1,
  QueryLockableDurationsResponse: QueryLockableDurationsResponse$1,
  RewardsEstRequest,
  RewardsEstResponse,
  UpcomingGaugesPerDenomRequest,
  UpcomingGaugesPerDenomResponse,
  UpcomingGaugesRequest,
  UpcomingGaugesResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgCreateGauge() {
  return {
    isPerpetual: !1,
    owner: "",
    distributeTo: void 0,
    coins: [],
    startTime: void 0,
    numEpochsPaidOver: Long$2.UZERO
  };
}
const MsgCreateGauge = {
  typeUrl: "/osmosis.incentives.MsgCreateGauge",
  encode(e, n = minimal.Writer.create()) {
    e.isPerpetual === !0 && n.uint32(8).bool(e.isPerpetual), e.owner !== "" && n.uint32(18).string(e.owner), e.distributeTo !== void 0 && QueryCondition.encode(e.distributeTo, n.uint32(26).fork()).ldelim();
    for (const o of e.coins)
      Coin.encode(o, n.uint32(34).fork()).ldelim();
    return e.startTime !== void 0 && Timestamp.encode(toTimestamp(e.startTime), n.uint32(42).fork()).ldelim(), e.numEpochsPaidOver.isZero() || n.uint32(48).uint64(e.numEpochsPaidOver), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateGauge();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.isPerpetual = o.bool();
          break;
        case 2:
          c.owner = o.string();
          break;
        case 3:
          c.distributeTo = QueryCondition.decode(o, o.uint32());
          break;
        case 4:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        case 5:
          c.startTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 6:
          c.numEpochsPaidOver = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgCreateGauge();
    return d.isPerpetual = (n = e.isPerpetual) !== null && n !== void 0 ? n : !1, d.owner = (o = e.owner) !== null && o !== void 0 ? o : "", d.distributeTo = e.distributeTo !== void 0 && e.distributeTo !== null ? QueryCondition.fromPartial(e.distributeTo) : void 0, d.coins = ((u = e.coins) === null || u === void 0 ? void 0 : u.map((m) => Coin.fromPartial(m))) || [], d.startTime = (c = e.startTime) !== null && c !== void 0 ? c : void 0, d.numEpochsPaidOver = e.numEpochsPaidOver !== void 0 && e.numEpochsPaidOver !== null ? Long$2.fromValue(e.numEpochsPaidOver) : Long$2.UZERO, d;
  },
  fromAmino(e) {
    return {
      isPerpetual: e.is_perpetual,
      owner: e.owner,
      distributeTo: e != null && e.distribute_to ? QueryCondition.fromAmino(e.distribute_to) : void 0,
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : [],
      startTime: e != null && e.start_time ? Timestamp.fromAmino(e.start_time) : void 0,
      numEpochsPaidOver: Long$2.fromString(e.num_epochs_paid_over)
    };
  },
  toAmino(e) {
    const n = {};
    return n.is_perpetual = e.isPerpetual, n.owner = e.owner, n.distribute_to = e.distributeTo ? QueryCondition.toAmino(e.distributeTo) : void 0, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n.start_time = e.startTime ? Timestamp.toAmino(e.startTime) : void 0, n.num_epochs_paid_over = e.numEpochsPaidOver ? e.numEpochsPaidOver.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgCreateGauge.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/create-gauge",
      value: MsgCreateGauge.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateGauge.decode(e.value);
  },
  toProto(e) {
    return MsgCreateGauge.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.MsgCreateGauge",
      value: MsgCreateGauge.encode(e).finish()
    };
  }
};
function createBaseMsgCreateGaugeResponse() {
  return {};
}
const MsgCreateGaugeResponse = {
  typeUrl: "/osmosis.incentives.MsgCreateGaugeResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateGaugeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgCreateGaugeResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgCreateGaugeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/create-gauge-response",
      value: MsgCreateGaugeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateGaugeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCreateGaugeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.MsgCreateGaugeResponse",
      value: MsgCreateGaugeResponse.encode(e).finish()
    };
  }
};
function createBaseMsgAddToGauge() {
  return {
    owner: "",
    gaugeId: Long$2.UZERO,
    rewards: []
  };
}
const MsgAddToGauge = {
  typeUrl: "/osmosis.incentives.MsgAddToGauge",
  encode(e, n = minimal.Writer.create()) {
    e.owner !== "" && n.uint32(10).string(e.owner), e.gaugeId.isZero() || n.uint32(16).uint64(e.gaugeId);
    for (const o of e.rewards)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgAddToGauge();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.gaugeId = o.uint64();
          break;
        case 3:
          c.rewards.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgAddToGauge();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.gaugeId = e.gaugeId !== void 0 && e.gaugeId !== null ? Long$2.fromValue(e.gaugeId) : Long$2.UZERO, u.rewards = ((o = e.rewards) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      gaugeId: Long$2.fromString(e.gauge_id),
      rewards: Array.isArray(e == null ? void 0 : e.rewards) ? e.rewards.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.gauge_id = e.gaugeId ? e.gaugeId.toString() : void 0, e.rewards ? n.rewards = e.rewards.map((o) => o ? Coin.toAmino(o) : void 0) : n.rewards = [], n;
  },
  fromAminoMsg(e) {
    return MsgAddToGauge.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/add-to-gauge",
      value: MsgAddToGauge.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgAddToGauge.decode(e.value);
  },
  toProto(e) {
    return MsgAddToGauge.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.MsgAddToGauge",
      value: MsgAddToGauge.encode(e).finish()
    };
  }
};
function createBaseMsgAddToGaugeResponse() {
  return {};
}
const MsgAddToGaugeResponse = {
  typeUrl: "/osmosis.incentives.MsgAddToGaugeResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgAddToGaugeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgAddToGaugeResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgAddToGaugeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/incentives/add-to-gauge-response",
      value: MsgAddToGaugeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgAddToGaugeResponse.decode(e.value);
  },
  toProto(e) {
    return MsgAddToGaugeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.incentives.MsgAddToGaugeResponse",
      value: MsgAddToGaugeResponse.encode(e).finish()
    };
  }
}, _135 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgAddToGauge,
  MsgAddToGaugeResponse,
  MsgCreateGauge,
  MsgCreateGaugeResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$8() {
  return {
    lastLockId: Long$2.UZERO,
    locks: [],
    syntheticLocks: []
  };
}
const GenesisState$8 = {
  typeUrl: "/osmosis.lockup.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.lastLockId.isZero() || n.uint32(8).uint64(e.lastLockId);
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.syntheticLocks)
      SyntheticLock.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$8();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lastLockId = o.uint64();
          break;
        case 2:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        case 3:
          c.syntheticLocks.push(SyntheticLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisState$8();
    return u.lastLockId = e.lastLockId !== void 0 && e.lastLockId !== null ? Long$2.fromValue(e.lastLockId) : Long$2.UZERO, u.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((c) => PeriodLock.fromPartial(c))) || [], u.syntheticLocks = ((o = e.syntheticLocks) === null || o === void 0 ? void 0 : o.map((c) => SyntheticLock.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      lastLockId: Long$2.fromString(e.last_lock_id),
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : [],
      syntheticLocks: Array.isArray(e == null ? void 0 : e.synthetic_locks) ? e.synthetic_locks.map((n) => SyntheticLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.last_lock_id = e.lastLockId ? e.lastLockId.toString() : void 0, e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], e.syntheticLocks ? n.synthetic_locks = e.syntheticLocks.map((o) => o ? SyntheticLock.toAmino(o) : void 0) : n.synthetic_locks = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$8.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/genesis-state",
      value: GenesisState$8.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$8.decode(e.value);
  },
  toProto(e) {
    return GenesisState$8.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.GenesisState",
      value: GenesisState$8.encode(e).finish()
    };
  }
}, _136 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$8
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$6() {
  return {
    forceUnlockAllowedAddresses: []
  };
}
const Params$6 = {
  typeUrl: "/osmosis.lockup.Params",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.forceUnlockAllowedAddresses)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$6();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.forceUnlockAllowedAddresses.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$6();
    return o.forceUnlockAllowedAddresses = ((n = e.forceUnlockAllowedAddresses) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      forceUnlockAllowedAddresses: Array.isArray(e == null ? void 0 : e.force_unlock_allowed_addresses) ? e.force_unlock_allowed_addresses.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.forceUnlockAllowedAddresses ? n.force_unlock_allowed_addresses = e.forceUnlockAllowedAddresses.map((o) => o) : n.force_unlock_allowed_addresses = [], n;
  },
  fromAminoMsg(e) {
    return Params$6.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/params",
      value: Params$6.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$6.decode(e.value);
  },
  toProto(e) {
    return Params$6.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.Params",
      value: Params$6.encode(e).finish()
    };
  }
}, _138 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$6
}, Symbol.toStringTag, { value: "Module" }));
function createBaseModuleBalanceRequest() {
  return {};
}
const ModuleBalanceRequest = {
  typeUrl: "/osmosis.lockup.ModuleBalanceRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleBalanceRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseModuleBalanceRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ModuleBalanceRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/module-balance-request",
      value: ModuleBalanceRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleBalanceRequest.decode(e.value);
  },
  toProto(e) {
    return ModuleBalanceRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.ModuleBalanceRequest",
      value: ModuleBalanceRequest.encode(e).finish()
    };
  }
};
function createBaseModuleBalanceResponse() {
  return {
    coins: []
  };
}
const ModuleBalanceResponse = {
  typeUrl: "/osmosis.lockup.ModuleBalanceResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.coins)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleBalanceResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseModuleBalanceResponse();
    return o.coins = ((n = e.coins) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return ModuleBalanceResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/module-balance-response",
      value: ModuleBalanceResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleBalanceResponse.decode(e.value);
  },
  toProto(e) {
    return ModuleBalanceResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.ModuleBalanceResponse",
      value: ModuleBalanceResponse.encode(e).finish()
    };
  }
};
function createBaseModuleLockedAmountRequest() {
  return {};
}
const ModuleLockedAmountRequest = {
  typeUrl: "/osmosis.lockup.ModuleLockedAmountRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleLockedAmountRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseModuleLockedAmountRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ModuleLockedAmountRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/module-locked-amount-request",
      value: ModuleLockedAmountRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleLockedAmountRequest.decode(e.value);
  },
  toProto(e) {
    return ModuleLockedAmountRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.ModuleLockedAmountRequest",
      value: ModuleLockedAmountRequest.encode(e).finish()
    };
  }
};
function createBaseModuleLockedAmountResponse() {
  return {
    coins: []
  };
}
const ModuleLockedAmountResponse = {
  typeUrl: "/osmosis.lockup.ModuleLockedAmountResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.coins)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleLockedAmountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseModuleLockedAmountResponse();
    return o.coins = ((n = e.coins) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return ModuleLockedAmountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/module-locked-amount-response",
      value: ModuleLockedAmountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleLockedAmountResponse.decode(e.value);
  },
  toProto(e) {
    return ModuleLockedAmountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.ModuleLockedAmountResponse",
      value: ModuleLockedAmountResponse.encode(e).finish()
    };
  }
};
function createBaseAccountUnlockableCoinsRequest() {
  return {
    owner: ""
  };
}
const AccountUnlockableCoinsRequest = {
  typeUrl: "/osmosis.lockup.AccountUnlockableCoinsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountUnlockableCoinsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountUnlockableCoinsRequest();
    return o.owner = (n = e.owner) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      owner: e.owner
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n;
  },
  fromAminoMsg(e) {
    return AccountUnlockableCoinsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-unlockable-coins-request",
      value: AccountUnlockableCoinsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountUnlockableCoinsRequest.decode(e.value);
  },
  toProto(e) {
    return AccountUnlockableCoinsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockableCoinsRequest",
      value: AccountUnlockableCoinsRequest.encode(e).finish()
    };
  }
};
function createBaseAccountUnlockableCoinsResponse() {
  return {
    coins: []
  };
}
const AccountUnlockableCoinsResponse = {
  typeUrl: "/osmosis.lockup.AccountUnlockableCoinsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.coins)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountUnlockableCoinsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountUnlockableCoinsResponse();
    return o.coins = ((n = e.coins) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return AccountUnlockableCoinsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-unlockable-coins-response",
      value: AccountUnlockableCoinsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountUnlockableCoinsResponse.decode(e.value);
  },
  toProto(e) {
    return AccountUnlockableCoinsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockableCoinsResponse",
      value: AccountUnlockableCoinsResponse.encode(e).finish()
    };
  }
};
function createBaseAccountUnlockingCoinsRequest() {
  return {
    owner: ""
  };
}
const AccountUnlockingCoinsRequest = {
  typeUrl: "/osmosis.lockup.AccountUnlockingCoinsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountUnlockingCoinsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountUnlockingCoinsRequest();
    return o.owner = (n = e.owner) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      owner: e.owner
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n;
  },
  fromAminoMsg(e) {
    return AccountUnlockingCoinsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-unlocking-coins-request",
      value: AccountUnlockingCoinsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountUnlockingCoinsRequest.decode(e.value);
  },
  toProto(e) {
    return AccountUnlockingCoinsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockingCoinsRequest",
      value: AccountUnlockingCoinsRequest.encode(e).finish()
    };
  }
};
function createBaseAccountUnlockingCoinsResponse() {
  return {
    coins: []
  };
}
const AccountUnlockingCoinsResponse = {
  typeUrl: "/osmosis.lockup.AccountUnlockingCoinsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.coins)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountUnlockingCoinsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountUnlockingCoinsResponse();
    return o.coins = ((n = e.coins) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return AccountUnlockingCoinsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-unlocking-coins-response",
      value: AccountUnlockingCoinsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountUnlockingCoinsResponse.decode(e.value);
  },
  toProto(e) {
    return AccountUnlockingCoinsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockingCoinsResponse",
      value: AccountUnlockingCoinsResponse.encode(e).finish()
    };
  }
};
function createBaseAccountLockedCoinsRequest() {
  return {
    owner: ""
  };
}
const AccountLockedCoinsRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedCoinsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedCoinsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedCoinsRequest();
    return o.owner = (n = e.owner) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      owner: e.owner
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n;
  },
  fromAminoMsg(e) {
    return AccountLockedCoinsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-coins-request",
      value: AccountLockedCoinsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedCoinsRequest.decode(e.value);
  },
  toProto(e) {
    return AccountLockedCoinsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedCoinsRequest",
      value: AccountLockedCoinsRequest.encode(e).finish()
    };
  }
};
function createBaseAccountLockedCoinsResponse() {
  return {
    coins: []
  };
}
const AccountLockedCoinsResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedCoinsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.coins)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedCoinsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedCoinsResponse();
    return o.coins = ((n = e.coins) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return AccountLockedCoinsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-coins-response",
      value: AccountLockedCoinsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedCoinsResponse.decode(e.value);
  },
  toProto(e) {
    return AccountLockedCoinsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedCoinsResponse",
      value: AccountLockedCoinsResponse.encode(e).finish()
    };
  }
};
function createBaseAccountLockedPastTimeRequest() {
  return {
    owner: "",
    timestamp: void 0
  };
}
const AccountLockedPastTimeRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedPastTimeRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseAccountLockedPastTimeRequest();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.timestamp = (o = e.timestamp) !== null && o !== void 0 ? o : void 0, u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n;
  },
  fromAminoMsg(e) {
    return AccountLockedPastTimeRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-past-time-request",
      value: AccountLockedPastTimeRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedPastTimeRequest.decode(e.value);
  },
  toProto(e) {
    return AccountLockedPastTimeRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeRequest",
      value: AccountLockedPastTimeRequest.encode(e).finish()
    };
  }
};
function createBaseAccountLockedPastTimeResponse() {
  return {
    locks: []
  };
}
const AccountLockedPastTimeResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedPastTimeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedPastTimeResponse();
    return o.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], n;
  },
  fromAminoMsg(e) {
    return AccountLockedPastTimeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-past-time-response",
      value: AccountLockedPastTimeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedPastTimeResponse.decode(e.value);
  },
  toProto(e) {
    return AccountLockedPastTimeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeResponse",
      value: AccountLockedPastTimeResponse.encode(e).finish()
    };
  }
};
function createBaseAccountLockedPastTimeNotUnlockingOnlyRequest() {
  return {
    owner: "",
    timestamp: void 0
  };
}
const AccountLockedPastTimeNotUnlockingOnlyRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeNotUnlockingOnlyRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedPastTimeNotUnlockingOnlyRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseAccountLockedPastTimeNotUnlockingOnlyRequest();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.timestamp = (o = e.timestamp) !== null && o !== void 0 ? o : void 0, u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n;
  },
  fromAminoMsg(e) {
    return AccountLockedPastTimeNotUnlockingOnlyRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-past-time-not-unlocking-only-request",
      value: AccountLockedPastTimeNotUnlockingOnlyRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedPastTimeNotUnlockingOnlyRequest.decode(e.value);
  },
  toProto(e) {
    return AccountLockedPastTimeNotUnlockingOnlyRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeNotUnlockingOnlyRequest",
      value: AccountLockedPastTimeNotUnlockingOnlyRequest.encode(e).finish()
    };
  }
};
function createBaseAccountLockedPastTimeNotUnlockingOnlyResponse() {
  return {
    locks: []
  };
}
const AccountLockedPastTimeNotUnlockingOnlyResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeNotUnlockingOnlyResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedPastTimeNotUnlockingOnlyResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedPastTimeNotUnlockingOnlyResponse();
    return o.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], n;
  },
  fromAminoMsg(e) {
    return AccountLockedPastTimeNotUnlockingOnlyResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-past-time-not-unlocking-only-response",
      value: AccountLockedPastTimeNotUnlockingOnlyResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedPastTimeNotUnlockingOnlyResponse.decode(e.value);
  },
  toProto(e) {
    return AccountLockedPastTimeNotUnlockingOnlyResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeNotUnlockingOnlyResponse",
      value: AccountLockedPastTimeNotUnlockingOnlyResponse.encode(e).finish()
    };
  }
};
function createBaseAccountUnlockedBeforeTimeRequest() {
  return {
    owner: "",
    timestamp: void 0
  };
}
const AccountUnlockedBeforeTimeRequest = {
  typeUrl: "/osmosis.lockup.AccountUnlockedBeforeTimeRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountUnlockedBeforeTimeRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseAccountUnlockedBeforeTimeRequest();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.timestamp = (o = e.timestamp) !== null && o !== void 0 ? o : void 0, u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n;
  },
  fromAminoMsg(e) {
    return AccountUnlockedBeforeTimeRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-unlocked-before-time-request",
      value: AccountUnlockedBeforeTimeRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountUnlockedBeforeTimeRequest.decode(e.value);
  },
  toProto(e) {
    return AccountUnlockedBeforeTimeRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockedBeforeTimeRequest",
      value: AccountUnlockedBeforeTimeRequest.encode(e).finish()
    };
  }
};
function createBaseAccountUnlockedBeforeTimeResponse() {
  return {
    locks: []
  };
}
const AccountUnlockedBeforeTimeResponse = {
  typeUrl: "/osmosis.lockup.AccountUnlockedBeforeTimeResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountUnlockedBeforeTimeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountUnlockedBeforeTimeResponse();
    return o.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], n;
  },
  fromAminoMsg(e) {
    return AccountUnlockedBeforeTimeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-unlocked-before-time-response",
      value: AccountUnlockedBeforeTimeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountUnlockedBeforeTimeResponse.decode(e.value);
  },
  toProto(e) {
    return AccountUnlockedBeforeTimeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockedBeforeTimeResponse",
      value: AccountUnlockedBeforeTimeResponse.encode(e).finish()
    };
  }
};
function createBaseAccountLockedPastTimeDenomRequest() {
  return {
    owner: "",
    timestamp: void 0,
    denom: ""
  };
}
const AccountLockedPastTimeDenomRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.timestamp !== void 0 && Timestamp.encode(toTimestamp(e.timestamp), n.uint32(18).fork()).ldelim(), e.denom !== "" && n.uint32(26).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedPastTimeDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.timestamp = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 3:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseAccountLockedPastTimeDenomRequest();
    return c.owner = (n = e.owner) !== null && n !== void 0 ? n : "", c.timestamp = (o = e.timestamp) !== null && o !== void 0 ? o : void 0, c.denom = (u = e.denom) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      timestamp: e != null && e.timestamp ? Timestamp.fromAmino(e.timestamp) : void 0,
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.timestamp = e.timestamp ? Timestamp.toAmino(e.timestamp) : void 0, n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return AccountLockedPastTimeDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-past-time-denom-request",
      value: AccountLockedPastTimeDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedPastTimeDenomRequest.decode(e.value);
  },
  toProto(e) {
    return AccountLockedPastTimeDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeDenomRequest",
      value: AccountLockedPastTimeDenomRequest.encode(e).finish()
    };
  }
};
function createBaseAccountLockedPastTimeDenomResponse() {
  return {
    locks: []
  };
}
const AccountLockedPastTimeDenomResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedPastTimeDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedPastTimeDenomResponse();
    return o.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], n;
  },
  fromAminoMsg(e) {
    return AccountLockedPastTimeDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-past-time-denom-response",
      value: AccountLockedPastTimeDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedPastTimeDenomResponse.decode(e.value);
  },
  toProto(e) {
    return AccountLockedPastTimeDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeDenomResponse",
      value: AccountLockedPastTimeDenomResponse.encode(e).finish()
    };
  }
};
function createBaseLockedDenomRequest() {
  return {
    denom: "",
    duration: void 0
  };
}
const LockedDenomRequest = {
  typeUrl: "/osmosis.lockup.LockedDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLockedDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.duration = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseLockedDenomRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, o;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n;
  },
  fromAminoMsg(e) {
    return LockedDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/locked-denom-request",
      value: LockedDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LockedDenomRequest.decode(e.value);
  },
  toProto(e) {
    return LockedDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.LockedDenomRequest",
      value: LockedDenomRequest.encode(e).finish()
    };
  }
};
function createBaseLockedDenomResponse() {
  return {
    amount: ""
  };
}
const LockedDenomResponse = {
  typeUrl: "/osmosis.lockup.LockedDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.amount !== "" && n.uint32(10).string(e.amount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLockedDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseLockedDenomResponse();
    return o.amount = (n = e.amount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      amount: e.amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.amount = e.amount, n;
  },
  fromAminoMsg(e) {
    return LockedDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/locked-denom-response",
      value: LockedDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LockedDenomResponse.decode(e.value);
  },
  toProto(e) {
    return LockedDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.LockedDenomResponse",
      value: LockedDenomResponse.encode(e).finish()
    };
  }
};
function createBaseLockedRequest() {
  return {
    lockId: Long$2.UZERO
  };
}
const LockedRequest = {
  typeUrl: "/osmosis.lockup.LockedRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.lockId.isZero() || n.uint32(8).uint64(e.lockId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLockedRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseLockedRequest();
    return n.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      lockId: Long$2.fromString(e.lock_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.lock_id = e.lockId ? e.lockId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return LockedRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/locked-request",
      value: LockedRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LockedRequest.decode(e.value);
  },
  toProto(e) {
    return LockedRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.LockedRequest",
      value: LockedRequest.encode(e).finish()
    };
  }
};
function createBaseLockedResponse() {
  return {
    lock: void 0
  };
}
const LockedResponse = {
  typeUrl: "/osmosis.lockup.LockedResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.lock !== void 0 && PeriodLock.encode(e.lock, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLockedResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lock = PeriodLock.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseLockedResponse();
    return n.lock = e.lock !== void 0 && e.lock !== null ? PeriodLock.fromPartial(e.lock) : void 0, n;
  },
  fromAmino(e) {
    return {
      lock: e != null && e.lock ? PeriodLock.fromAmino(e.lock) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.lock = e.lock ? PeriodLock.toAmino(e.lock) : void 0, n;
  },
  fromAminoMsg(e) {
    return LockedResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/locked-response",
      value: LockedResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return LockedResponse.decode(e.value);
  },
  toProto(e) {
    return LockedResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.LockedResponse",
      value: LockedResponse.encode(e).finish()
    };
  }
};
function createBaseNextLockIDRequest() {
  return {};
}
const NextLockIDRequest = {
  typeUrl: "/osmosis.lockup.NextLockIDRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNextLockIDRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseNextLockIDRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return NextLockIDRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/next-lock-id-request",
      value: NextLockIDRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return NextLockIDRequest.decode(e.value);
  },
  toProto(e) {
    return NextLockIDRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.NextLockIDRequest",
      value: NextLockIDRequest.encode(e).finish()
    };
  }
};
function createBaseNextLockIDResponse() {
  return {
    lockId: Long$2.UZERO
  };
}
const NextLockIDResponse = {
  typeUrl: "/osmosis.lockup.NextLockIDResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.lockId.isZero() || n.uint32(8).uint64(e.lockId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNextLockIDResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseNextLockIDResponse();
    return n.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      lockId: Long$2.fromString(e.lock_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.lock_id = e.lockId ? e.lockId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return NextLockIDResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/next-lock-id-response",
      value: NextLockIDResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return NextLockIDResponse.decode(e.value);
  },
  toProto(e) {
    return NextLockIDResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.NextLockIDResponse",
      value: NextLockIDResponse.encode(e).finish()
    };
  }
};
function createBaseSyntheticLockupsByLockupIDRequest() {
  return {
    lockId: Long$2.UZERO
  };
}
const SyntheticLockupsByLockupIDRequest = {
  typeUrl: "/osmosis.lockup.SyntheticLockupsByLockupIDRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.lockId.isZero() || n.uint32(8).uint64(e.lockId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSyntheticLockupsByLockupIDRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseSyntheticLockupsByLockupIDRequest();
    return n.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      lockId: Long$2.fromString(e.lock_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.lock_id = e.lockId ? e.lockId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return SyntheticLockupsByLockupIDRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/synthetic-lockups-by-lockup-id-request",
      value: SyntheticLockupsByLockupIDRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SyntheticLockupsByLockupIDRequest.decode(e.value);
  },
  toProto(e) {
    return SyntheticLockupsByLockupIDRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.SyntheticLockupsByLockupIDRequest",
      value: SyntheticLockupsByLockupIDRequest.encode(e).finish()
    };
  }
};
function createBaseSyntheticLockupsByLockupIDResponse() {
  return {
    syntheticLocks: []
  };
}
const SyntheticLockupsByLockupIDResponse = {
  typeUrl: "/osmosis.lockup.SyntheticLockupsByLockupIDResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.syntheticLocks)
      SyntheticLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSyntheticLockupsByLockupIDResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.syntheticLocks.push(SyntheticLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSyntheticLockupsByLockupIDResponse();
    return o.syntheticLocks = ((n = e.syntheticLocks) === null || n === void 0 ? void 0 : n.map((u) => SyntheticLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      syntheticLocks: Array.isArray(e == null ? void 0 : e.synthetic_locks) ? e.synthetic_locks.map((n) => SyntheticLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.syntheticLocks ? n.synthetic_locks = e.syntheticLocks.map((o) => o ? SyntheticLock.toAmino(o) : void 0) : n.synthetic_locks = [], n;
  },
  fromAminoMsg(e) {
    return SyntheticLockupsByLockupIDResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/synthetic-lockups-by-lockup-id-response",
      value: SyntheticLockupsByLockupIDResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SyntheticLockupsByLockupIDResponse.decode(e.value);
  },
  toProto(e) {
    return SyntheticLockupsByLockupIDResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.SyntheticLockupsByLockupIDResponse",
      value: SyntheticLockupsByLockupIDResponse.encode(e).finish()
    };
  }
};
function createBaseAccountLockedLongerDurationRequest() {
  return {
    owner: "",
    duration: void 0
  };
}
const AccountLockedLongerDurationRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedLongerDurationRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.duration = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedLongerDurationRequest();
    return o.owner = (n = e.owner) !== null && n !== void 0 ? n : "", o.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, o;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n;
  },
  fromAminoMsg(e) {
    return AccountLockedLongerDurationRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-request",
      value: AccountLockedLongerDurationRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedLongerDurationRequest.decode(e.value);
  },
  toProto(e) {
    return AccountLockedLongerDurationRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationRequest",
      value: AccountLockedLongerDurationRequest.encode(e).finish()
    };
  }
};
function createBaseAccountLockedLongerDurationResponse() {
  return {
    locks: []
  };
}
const AccountLockedLongerDurationResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedLongerDurationResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedLongerDurationResponse();
    return o.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], n;
  },
  fromAminoMsg(e) {
    return AccountLockedLongerDurationResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-response",
      value: AccountLockedLongerDurationResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedLongerDurationResponse.decode(e.value);
  },
  toProto(e) {
    return AccountLockedLongerDurationResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationResponse",
      value: AccountLockedLongerDurationResponse.encode(e).finish()
    };
  }
};
function createBaseAccountLockedDurationRequest() {
  return {
    owner: "",
    duration: void 0
  };
}
const AccountLockedDurationRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedDurationRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedDurationRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.duration = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedDurationRequest();
    return o.owner = (n = e.owner) !== null && n !== void 0 ? n : "", o.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, o;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n;
  },
  fromAminoMsg(e) {
    return AccountLockedDurationRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-duration-request",
      value: AccountLockedDurationRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedDurationRequest.decode(e.value);
  },
  toProto(e) {
    return AccountLockedDurationRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedDurationRequest",
      value: AccountLockedDurationRequest.encode(e).finish()
    };
  }
};
function createBaseAccountLockedDurationResponse() {
  return {
    locks: []
  };
}
const AccountLockedDurationResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedDurationResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedDurationResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedDurationResponse();
    return o.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], n;
  },
  fromAminoMsg(e) {
    return AccountLockedDurationResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-duration-response",
      value: AccountLockedDurationResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedDurationResponse.decode(e.value);
  },
  toProto(e) {
    return AccountLockedDurationResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedDurationResponse",
      value: AccountLockedDurationResponse.encode(e).finish()
    };
  }
};
function createBaseAccountLockedLongerDurationNotUnlockingOnlyRequest() {
  return {
    owner: "",
    duration: void 0
  };
}
const AccountLockedLongerDurationNotUnlockingOnlyRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationNotUnlockingOnlyRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedLongerDurationNotUnlockingOnlyRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.duration = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedLongerDurationNotUnlockingOnlyRequest();
    return o.owner = (n = e.owner) !== null && n !== void 0 ? n : "", o.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, o;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n;
  },
  fromAminoMsg(e) {
    return AccountLockedLongerDurationNotUnlockingOnlyRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-not-unlocking-only-request",
      value: AccountLockedLongerDurationNotUnlockingOnlyRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedLongerDurationNotUnlockingOnlyRequest.decode(e.value);
  },
  toProto(e) {
    return AccountLockedLongerDurationNotUnlockingOnlyRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationNotUnlockingOnlyRequest",
      value: AccountLockedLongerDurationNotUnlockingOnlyRequest.encode(e).finish()
    };
  }
};
function createBaseAccountLockedLongerDurationNotUnlockingOnlyResponse() {
  return {
    locks: []
  };
}
const AccountLockedLongerDurationNotUnlockingOnlyResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationNotUnlockingOnlyResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedLongerDurationNotUnlockingOnlyResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedLongerDurationNotUnlockingOnlyResponse();
    return o.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], n;
  },
  fromAminoMsg(e) {
    return AccountLockedLongerDurationNotUnlockingOnlyResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-not-unlocking-only-response",
      value: AccountLockedLongerDurationNotUnlockingOnlyResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedLongerDurationNotUnlockingOnlyResponse.decode(e.value);
  },
  toProto(e) {
    return AccountLockedLongerDurationNotUnlockingOnlyResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationNotUnlockingOnlyResponse",
      value: AccountLockedLongerDurationNotUnlockingOnlyResponse.encode(e).finish()
    };
  }
};
function createBaseAccountLockedLongerDurationDenomRequest() {
  return {
    owner: "",
    duration: void 0,
    denom: ""
  };
}
const AccountLockedLongerDurationDenomRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(18).fork()).ldelim(), e.denom !== "" && n.uint32(26).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedLongerDurationDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.duration = Duration.decode(o, o.uint32());
          break;
        case 3:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseAccountLockedLongerDurationDenomRequest();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, u.denom = (o = e.denom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0,
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return AccountLockedLongerDurationDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-denom-request",
      value: AccountLockedLongerDurationDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedLongerDurationDenomRequest.decode(e.value);
  },
  toProto(e) {
    return AccountLockedLongerDurationDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationDenomRequest",
      value: AccountLockedLongerDurationDenomRequest.encode(e).finish()
    };
  }
};
function createBaseAccountLockedLongerDurationDenomResponse() {
  return {
    locks: []
  };
}
const AccountLockedLongerDurationDenomResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.locks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAccountLockedLongerDurationDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.locks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAccountLockedLongerDurationDenomResponse();
    return o.locks = ((n = e.locks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      locks: Array.isArray(e == null ? void 0 : e.locks) ? e.locks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.locks ? n.locks = e.locks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.locks = [], n;
  },
  fromAminoMsg(e) {
    return AccountLockedLongerDurationDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-denom-response",
      value: AccountLockedLongerDurationDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AccountLockedLongerDurationDenomResponse.decode(e.value);
  },
  toProto(e) {
    return AccountLockedLongerDurationDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationDenomResponse",
      value: AccountLockedLongerDurationDenomResponse.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$5() {
  return {};
}
const QueryParamsRequest$5 = {
  typeUrl: "/osmosis.lockup.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$5();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$5();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$5.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/query-params-request",
      value: QueryParamsRequest$5.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$5.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$5.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.QueryParamsRequest",
      value: QueryParamsRequest$5.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$5() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$5 = {
  typeUrl: "/osmosis.lockup.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$6.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$5();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$6.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$5();
    return n.params = e.params !== void 0 && e.params !== null ? Params$6.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$6.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$6.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$5.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/query-params-response",
      value: QueryParamsResponse$5.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$5.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$5.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.QueryParamsResponse",
      value: QueryParamsResponse$5.encode(e).finish()
    };
  }
}, _139 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountLockedCoinsRequest,
  AccountLockedCoinsResponse,
  AccountLockedDurationRequest,
  AccountLockedDurationResponse,
  AccountLockedLongerDurationDenomRequest,
  AccountLockedLongerDurationDenomResponse,
  AccountLockedLongerDurationNotUnlockingOnlyRequest,
  AccountLockedLongerDurationNotUnlockingOnlyResponse,
  AccountLockedLongerDurationRequest,
  AccountLockedLongerDurationResponse,
  AccountLockedPastTimeDenomRequest,
  AccountLockedPastTimeDenomResponse,
  AccountLockedPastTimeNotUnlockingOnlyRequest,
  AccountLockedPastTimeNotUnlockingOnlyResponse,
  AccountLockedPastTimeRequest,
  AccountLockedPastTimeResponse,
  AccountUnlockableCoinsRequest,
  AccountUnlockableCoinsResponse,
  AccountUnlockedBeforeTimeRequest,
  AccountUnlockedBeforeTimeResponse,
  AccountUnlockingCoinsRequest,
  AccountUnlockingCoinsResponse,
  LockedDenomRequest,
  LockedDenomResponse,
  LockedRequest,
  LockedResponse,
  ModuleBalanceRequest,
  ModuleBalanceResponse,
  ModuleLockedAmountRequest,
  ModuleLockedAmountResponse,
  NextLockIDRequest,
  NextLockIDResponse,
  QueryParamsRequest: QueryParamsRequest$5,
  QueryParamsResponse: QueryParamsResponse$5,
  SyntheticLockupsByLockupIDRequest,
  SyntheticLockupsByLockupIDResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgLockTokens() {
  return {
    owner: "",
    duration: void 0,
    coins: []
  };
}
const MsgLockTokens = {
  typeUrl: "/osmosis.lockup.MsgLockTokens",
  encode(e, n = minimal.Writer.create()) {
    e.owner !== "" && n.uint32(10).string(e.owner), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(18).fork()).ldelim();
    for (const o of e.coins)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgLockTokens();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.duration = Duration.decode(o, o.uint32());
          break;
        case 3:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgLockTokens();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, u.coins = ((o = e.coins) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0,
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return MsgLockTokens.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/lock-tokens",
      value: MsgLockTokens.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgLockTokens.decode(e.value);
  },
  toProto(e) {
    return MsgLockTokens.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgLockTokens",
      value: MsgLockTokens.encode(e).finish()
    };
  }
};
function createBaseMsgLockTokensResponse() {
  return {
    ID: Long$2.UZERO
  };
}
const MsgLockTokensResponse = {
  typeUrl: "/osmosis.lockup.MsgLockTokensResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.ID.isZero() || n.uint32(8).uint64(e.ID), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgLockTokensResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.ID = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgLockTokensResponse();
    return n.ID = e.ID !== void 0 && e.ID !== null ? Long$2.fromValue(e.ID) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      ID: Long$2.fromString(e.ID)
    };
  },
  toAmino(e) {
    const n = {};
    return n.ID = e.ID ? e.ID.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgLockTokensResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/lock-tokens-response",
      value: MsgLockTokensResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgLockTokensResponse.decode(e.value);
  },
  toProto(e) {
    return MsgLockTokensResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgLockTokensResponse",
      value: MsgLockTokensResponse.encode(e).finish()
    };
  }
};
function createBaseMsgBeginUnlockingAll() {
  return {
    owner: ""
  };
}
const MsgBeginUnlockingAll = {
  typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgBeginUnlockingAll();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgBeginUnlockingAll();
    return o.owner = (n = e.owner) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      owner: e.owner
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n;
  },
  fromAminoMsg(e) {
    return MsgBeginUnlockingAll.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/begin-unlock-tokens",
      value: MsgBeginUnlockingAll.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgBeginUnlockingAll.decode(e.value);
  },
  toProto(e) {
    return MsgBeginUnlockingAll.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
      value: MsgBeginUnlockingAll.encode(e).finish()
    };
  }
};
function createBaseMsgBeginUnlockingAllResponse() {
  return {
    unlocks: []
  };
}
const MsgBeginUnlockingAllResponse = {
  typeUrl: "/osmosis.lockup.MsgBeginUnlockingAllResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.unlocks)
      PeriodLock.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgBeginUnlockingAllResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.unlocks.push(PeriodLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgBeginUnlockingAllResponse();
    return o.unlocks = ((n = e.unlocks) === null || n === void 0 ? void 0 : n.map((u) => PeriodLock.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      unlocks: Array.isArray(e == null ? void 0 : e.unlocks) ? e.unlocks.map((n) => PeriodLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.unlocks ? n.unlocks = e.unlocks.map((o) => o ? PeriodLock.toAmino(o) : void 0) : n.unlocks = [], n;
  },
  fromAminoMsg(e) {
    return MsgBeginUnlockingAllResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/begin-unlocking-all-response",
      value: MsgBeginUnlockingAllResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgBeginUnlockingAllResponse.decode(e.value);
  },
  toProto(e) {
    return MsgBeginUnlockingAllResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgBeginUnlockingAllResponse",
      value: MsgBeginUnlockingAllResponse.encode(e).finish()
    };
  }
};
function createBaseMsgBeginUnlocking() {
  return {
    owner: "",
    ID: Long$2.UZERO,
    coins: []
  };
}
const MsgBeginUnlocking = {
  typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
  encode(e, n = minimal.Writer.create()) {
    e.owner !== "" && n.uint32(10).string(e.owner), e.ID.isZero() || n.uint32(16).uint64(e.ID);
    for (const o of e.coins)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgBeginUnlocking();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.ID = o.uint64();
          break;
        case 3:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgBeginUnlocking();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.ID = e.ID !== void 0 && e.ID !== null ? Long$2.fromValue(e.ID) : Long$2.UZERO, u.coins = ((o = e.coins) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      ID: Long$2.fromString(e.ID),
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.ID = e.ID ? e.ID.toString() : void 0, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return MsgBeginUnlocking.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/begin-unlock-period-lock",
      value: MsgBeginUnlocking.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgBeginUnlocking.decode(e.value);
  },
  toProto(e) {
    return MsgBeginUnlocking.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
      value: MsgBeginUnlocking.encode(e).finish()
    };
  }
};
function createBaseMsgBeginUnlockingResponse() {
  return {
    success: !1,
    unlockingLockID: Long$2.UZERO
  };
}
const MsgBeginUnlockingResponse = {
  typeUrl: "/osmosis.lockup.MsgBeginUnlockingResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.success === !0 && n.uint32(8).bool(e.success), e.unlockingLockID.isZero() || n.uint32(16).uint64(e.unlockingLockID), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgBeginUnlockingResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.success = o.bool();
          break;
        case 2:
          c.unlockingLockID = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgBeginUnlockingResponse();
    return o.success = (n = e.success) !== null && n !== void 0 ? n : !1, o.unlockingLockID = e.unlockingLockID !== void 0 && e.unlockingLockID !== null ? Long$2.fromValue(e.unlockingLockID) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      success: e.success,
      unlockingLockID: Long$2.fromString(e.unlockingLockID)
    };
  },
  toAmino(e) {
    const n = {};
    return n.success = e.success, n.unlockingLockID = e.unlockingLockID ? e.unlockingLockID.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgBeginUnlockingResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/begin-unlocking-response",
      value: MsgBeginUnlockingResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgBeginUnlockingResponse.decode(e.value);
  },
  toProto(e) {
    return MsgBeginUnlockingResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgBeginUnlockingResponse",
      value: MsgBeginUnlockingResponse.encode(e).finish()
    };
  }
};
function createBaseMsgExtendLockup() {
  return {
    owner: "",
    ID: Long$2.UZERO,
    duration: void 0
  };
}
const MsgExtendLockup = {
  typeUrl: "/osmosis.lockup.MsgExtendLockup",
  encode(e, n = minimal.Writer.create()) {
    return e.owner !== "" && n.uint32(10).string(e.owner), e.ID.isZero() || n.uint32(16).uint64(e.ID), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExtendLockup();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.ID = o.uint64();
          break;
        case 3:
          c.duration = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgExtendLockup();
    return o.owner = (n = e.owner) !== null && n !== void 0 ? n : "", o.ID = e.ID !== void 0 && e.ID !== null ? Long$2.fromValue(e.ID) : Long$2.UZERO, o.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, o;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      ID: Long$2.fromString(e.ID),
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.ID = e.ID ? e.ID.toString() : void 0, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgExtendLockup.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/extend-lockup",
      value: MsgExtendLockup.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExtendLockup.decode(e.value);
  },
  toProto(e) {
    return MsgExtendLockup.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgExtendLockup",
      value: MsgExtendLockup.encode(e).finish()
    };
  }
};
function createBaseMsgExtendLockupResponse() {
  return {
    success: !1
  };
}
const MsgExtendLockupResponse = {
  typeUrl: "/osmosis.lockup.MsgExtendLockupResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.success === !0 && n.uint32(8).bool(e.success), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgExtendLockupResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.success = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgExtendLockupResponse();
    return o.success = (n = e.success) !== null && n !== void 0 ? n : !1, o;
  },
  fromAmino(e) {
    return {
      success: e.success
    };
  },
  toAmino(e) {
    const n = {};
    return n.success = e.success, n;
  },
  fromAminoMsg(e) {
    return MsgExtendLockupResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/extend-lockup-response",
      value: MsgExtendLockupResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgExtendLockupResponse.decode(e.value);
  },
  toProto(e) {
    return MsgExtendLockupResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgExtendLockupResponse",
      value: MsgExtendLockupResponse.encode(e).finish()
    };
  }
};
function createBaseMsgForceUnlock() {
  return {
    owner: "",
    ID: Long$2.UZERO,
    coins: []
  };
}
const MsgForceUnlock = {
  typeUrl: "/osmosis.lockup.MsgForceUnlock",
  encode(e, n = minimal.Writer.create()) {
    e.owner !== "" && n.uint32(10).string(e.owner), e.ID.isZero() || n.uint32(16).uint64(e.ID);
    for (const o of e.coins)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgForceUnlock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.owner = o.string();
          break;
        case 2:
          c.ID = o.uint64();
          break;
        case 3:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgForceUnlock();
    return u.owner = (n = e.owner) !== null && n !== void 0 ? n : "", u.ID = e.ID !== void 0 && e.ID !== null ? Long$2.fromValue(e.ID) : Long$2.UZERO, u.coins = ((o = e.coins) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      owner: e.owner,
      ID: Long$2.fromString(e.ID),
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.owner = e.owner, n.ID = e.ID ? e.ID.toString() : void 0, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n;
  },
  fromAminoMsg(e) {
    return MsgForceUnlock.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/force-unlock",
      value: MsgForceUnlock.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgForceUnlock.decode(e.value);
  },
  toProto(e) {
    return MsgForceUnlock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgForceUnlock",
      value: MsgForceUnlock.encode(e).finish()
    };
  }
};
function createBaseMsgForceUnlockResponse() {
  return {
    success: !1
  };
}
const MsgForceUnlockResponse = {
  typeUrl: "/osmosis.lockup.MsgForceUnlockResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.success === !0 && n.uint32(8).bool(e.success), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgForceUnlockResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.success = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgForceUnlockResponse();
    return o.success = (n = e.success) !== null && n !== void 0 ? n : !1, o;
  },
  fromAmino(e) {
    return {
      success: e.success
    };
  },
  toAmino(e) {
    const n = {};
    return n.success = e.success, n;
  },
  fromAminoMsg(e) {
    return MsgForceUnlockResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lockup/force-unlock-response",
      value: MsgForceUnlockResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgForceUnlockResponse.decode(e.value);
  },
  toProto(e) {
    return MsgForceUnlockResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.lockup.MsgForceUnlockResponse",
      value: MsgForceUnlockResponse.encode(e).finish()
    };
  }
}, _140 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgBeginUnlocking,
  MsgBeginUnlockingAll,
  MsgBeginUnlockingAllResponse,
  MsgBeginUnlockingResponse,
  MsgExtendLockup,
  MsgExtendLockupResponse,
  MsgForceUnlock,
  MsgForceUnlockResponse,
  MsgLockTokens,
  MsgLockTokensResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMinter() {
  return {
    epochProvisions: ""
  };
}
const Minter = {
  typeUrl: "/osmosis.mint.v1beta1.Minter",
  encode(e, n = minimal.Writer.create()) {
    return e.epochProvisions !== "" && n.uint32(10).string(e.epochProvisions), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMinter();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.epochProvisions = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMinter();
    return o.epochProvisions = (n = e.epochProvisions) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      epochProvisions: e.epoch_provisions
    };
  },
  toAmino(e) {
    const n = {};
    return n.epoch_provisions = e.epochProvisions, n;
  },
  fromAminoMsg(e) {
    return Minter.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/minter",
      value: Minter.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Minter.decode(e.value);
  },
  toProto(e) {
    return Minter.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.Minter",
      value: Minter.encode(e).finish()
    };
  }
};
function createBaseWeightedAddress() {
  return {
    address: "",
    weight: ""
  };
}
const WeightedAddress = {
  typeUrl: "/osmosis.mint.v1beta1.WeightedAddress",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.weight !== "" && n.uint32(18).string(e.weight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseWeightedAddress();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        case 2:
          c.weight = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseWeightedAddress();
    return u.address = (n = e.address) !== null && n !== void 0 ? n : "", u.weight = (o = e.weight) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      address: e.address,
      weight: e.weight
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n.weight = e.weight, n;
  },
  fromAminoMsg(e) {
    return WeightedAddress.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/weighted-address",
      value: WeightedAddress.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return WeightedAddress.decode(e.value);
  },
  toProto(e) {
    return WeightedAddress.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.WeightedAddress",
      value: WeightedAddress.encode(e).finish()
    };
  }
};
function createBaseDistributionProportions() {
  return {
    staking: "",
    poolIncentives: "",
    developerRewards: "",
    communityPool: ""
  };
}
const DistributionProportions = {
  typeUrl: "/osmosis.mint.v1beta1.DistributionProportions",
  encode(e, n = minimal.Writer.create()) {
    return e.staking !== "" && n.uint32(10).string(e.staking), e.poolIncentives !== "" && n.uint32(18).string(e.poolIncentives), e.developerRewards !== "" && n.uint32(26).string(e.developerRewards), e.communityPool !== "" && n.uint32(34).string(e.communityPool), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDistributionProportions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.staking = o.string();
          break;
        case 2:
          c.poolIncentives = o.string();
          break;
        case 3:
          c.developerRewards = o.string();
          break;
        case 4:
          c.communityPool = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseDistributionProportions();
    return d.staking = (n = e.staking) !== null && n !== void 0 ? n : "", d.poolIncentives = (o = e.poolIncentives) !== null && o !== void 0 ? o : "", d.developerRewards = (u = e.developerRewards) !== null && u !== void 0 ? u : "", d.communityPool = (c = e.communityPool) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      staking: e.staking,
      poolIncentives: e.pool_incentives,
      developerRewards: e.developer_rewards,
      communityPool: e.community_pool
    };
  },
  toAmino(e) {
    const n = {};
    return n.staking = e.staking, n.pool_incentives = e.poolIncentives, n.developer_rewards = e.developerRewards, n.community_pool = e.communityPool, n;
  },
  fromAminoMsg(e) {
    return DistributionProportions.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/distribution-proportions",
      value: DistributionProportions.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DistributionProportions.decode(e.value);
  },
  toProto(e) {
    return DistributionProportions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.DistributionProportions",
      value: DistributionProportions.encode(e).finish()
    };
  }
};
function createBaseParams$5() {
  return {
    mintDenom: "",
    genesisEpochProvisions: "",
    epochIdentifier: "",
    reductionPeriodInEpochs: Long$2.ZERO,
    reductionFactor: "",
    distributionProportions: void 0,
    weightedDeveloperRewardsReceivers: [],
    mintingRewardsDistributionStartEpoch: Long$2.ZERO
  };
}
const Params$5 = {
  typeUrl: "/osmosis.mint.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    e.mintDenom !== "" && n.uint32(10).string(e.mintDenom), e.genesisEpochProvisions !== "" && n.uint32(18).string(e.genesisEpochProvisions), e.epochIdentifier !== "" && n.uint32(26).string(e.epochIdentifier), e.reductionPeriodInEpochs.isZero() || n.uint32(32).int64(e.reductionPeriodInEpochs), e.reductionFactor !== "" && n.uint32(42).string(e.reductionFactor), e.distributionProportions !== void 0 && DistributionProportions.encode(e.distributionProportions, n.uint32(50).fork()).ldelim();
    for (const o of e.weightedDeveloperRewardsReceivers)
      WeightedAddress.encode(o, n.uint32(58).fork()).ldelim();
    return e.mintingRewardsDistributionStartEpoch.isZero() || n.uint32(64).int64(e.mintingRewardsDistributionStartEpoch), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$5();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.mintDenom = o.string();
          break;
        case 2:
          c.genesisEpochProvisions = o.string();
          break;
        case 3:
          c.epochIdentifier = o.string();
          break;
        case 4:
          c.reductionPeriodInEpochs = o.int64();
          break;
        case 5:
          c.reductionFactor = o.string();
          break;
        case 6:
          c.distributionProportions = DistributionProportions.decode(o, o.uint32());
          break;
        case 7:
          c.weightedDeveloperRewardsReceivers.push(WeightedAddress.decode(o, o.uint32()));
          break;
        case 8:
          c.mintingRewardsDistributionStartEpoch = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseParams$5();
    return m.mintDenom = (n = e.mintDenom) !== null && n !== void 0 ? n : "", m.genesisEpochProvisions = (o = e.genesisEpochProvisions) !== null && o !== void 0 ? o : "", m.epochIdentifier = (u = e.epochIdentifier) !== null && u !== void 0 ? u : "", m.reductionPeriodInEpochs = e.reductionPeriodInEpochs !== void 0 && e.reductionPeriodInEpochs !== null ? Long$2.fromValue(e.reductionPeriodInEpochs) : Long$2.ZERO, m.reductionFactor = (c = e.reductionFactor) !== null && c !== void 0 ? c : "", m.distributionProportions = e.distributionProportions !== void 0 && e.distributionProportions !== null ? DistributionProportions.fromPartial(e.distributionProportions) : void 0, m.weightedDeveloperRewardsReceivers = ((d = e.weightedDeveloperRewardsReceivers) === null || d === void 0 ? void 0 : d.map((v) => WeightedAddress.fromPartial(v))) || [], m.mintingRewardsDistributionStartEpoch = e.mintingRewardsDistributionStartEpoch !== void 0 && e.mintingRewardsDistributionStartEpoch !== null ? Long$2.fromValue(e.mintingRewardsDistributionStartEpoch) : Long$2.ZERO, m;
  },
  fromAmino(e) {
    return {
      mintDenom: e.mint_denom,
      genesisEpochProvisions: e.genesis_epoch_provisions,
      epochIdentifier: e.epoch_identifier,
      reductionPeriodInEpochs: Long$2.fromString(e.reduction_period_in_epochs),
      reductionFactor: e.reduction_factor,
      distributionProportions: e != null && e.distribution_proportions ? DistributionProportions.fromAmino(e.distribution_proportions) : void 0,
      weightedDeveloperRewardsReceivers: Array.isArray(e == null ? void 0 : e.weighted_developer_rewards_receivers) ? e.weighted_developer_rewards_receivers.map((n) => WeightedAddress.fromAmino(n)) : [],
      mintingRewardsDistributionStartEpoch: Long$2.fromString(e.minting_rewards_distribution_start_epoch)
    };
  },
  toAmino(e) {
    const n = {};
    return n.mint_denom = e.mintDenom, n.genesis_epoch_provisions = e.genesisEpochProvisions, n.epoch_identifier = e.epochIdentifier, n.reduction_period_in_epochs = e.reductionPeriodInEpochs ? e.reductionPeriodInEpochs.toString() : void 0, n.reduction_factor = e.reductionFactor, n.distribution_proportions = e.distributionProportions ? DistributionProportions.toAmino(e.distributionProportions) : void 0, e.weightedDeveloperRewardsReceivers ? n.weighted_developer_rewards_receivers = e.weightedDeveloperRewardsReceivers.map((o) => o ? WeightedAddress.toAmino(o) : void 0) : n.weighted_developer_rewards_receivers = [], n.minting_rewards_distribution_start_epoch = e.mintingRewardsDistributionStartEpoch ? e.mintingRewardsDistributionStartEpoch.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return Params$5.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/params",
      value: Params$5.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$5.decode(e.value);
  },
  toProto(e) {
    return Params$5.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.Params",
      value: Params$5.encode(e).finish()
    };
  }
}, _142 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DistributionProportions,
  Minter,
  Params: Params$5,
  WeightedAddress
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$7() {
  return {
    minter: void 0,
    params: void 0,
    reductionStartedEpoch: Long$2.ZERO
  };
}
const GenesisState$7 = {
  typeUrl: "/osmosis.mint.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    return e.minter !== void 0 && Minter.encode(e.minter, n.uint32(10).fork()).ldelim(), e.params !== void 0 && Params$5.encode(e.params, n.uint32(18).fork()).ldelim(), e.reductionStartedEpoch.isZero() || n.uint32(24).int64(e.reductionStartedEpoch), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$7();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.minter = Minter.decode(o, o.uint32());
          break;
        case 2:
          c.params = Params$5.decode(o, o.uint32());
          break;
        case 3:
          c.reductionStartedEpoch = o.int64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseGenesisState$7();
    return n.minter = e.minter !== void 0 && e.minter !== null ? Minter.fromPartial(e.minter) : void 0, n.params = e.params !== void 0 && e.params !== null ? Params$5.fromPartial(e.params) : void 0, n.reductionStartedEpoch = e.reductionStartedEpoch !== void 0 && e.reductionStartedEpoch !== null ? Long$2.fromValue(e.reductionStartedEpoch) : Long$2.ZERO, n;
  },
  fromAmino(e) {
    return {
      minter: e != null && e.minter ? Minter.fromAmino(e.minter) : void 0,
      params: e != null && e.params ? Params$5.fromAmino(e.params) : void 0,
      reductionStartedEpoch: Long$2.fromString(e.reduction_started_epoch)
    };
  },
  toAmino(e) {
    const n = {};
    return n.minter = e.minter ? Minter.toAmino(e.minter) : void 0, n.params = e.params ? Params$5.toAmino(e.params) : void 0, n.reduction_started_epoch = e.reductionStartedEpoch ? e.reductionStartedEpoch.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$7.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/genesis-state",
      value: GenesisState$7.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$7.decode(e.value);
  },
  toProto(e) {
    return GenesisState$7.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.GenesisState",
      value: GenesisState$7.encode(e).finish()
    };
  }
}, _141 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$7
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryParamsRequest$4() {
  return {};
}
const QueryParamsRequest$4 = {
  typeUrl: "/osmosis.mint.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$4();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$4();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$4.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/query-params-request",
      value: QueryParamsRequest$4.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$4.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$4.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest$4.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$4() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$4 = {
  typeUrl: "/osmosis.mint.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$5.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$4();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$5.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$4();
    return n.params = e.params !== void 0 && e.params !== null ? Params$5.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$5.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$5.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$4.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/query-params-response",
      value: QueryParamsResponse$4.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$4.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$4.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse$4.encode(e).finish()
    };
  }
};
function createBaseQueryEpochProvisionsRequest() {
  return {};
}
const QueryEpochProvisionsRequest = {
  typeUrl: "/osmosis.mint.v1beta1.QueryEpochProvisionsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryEpochProvisionsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryEpochProvisionsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryEpochProvisionsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/query-epoch-provisions-request",
      value: QueryEpochProvisionsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryEpochProvisionsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryEpochProvisionsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.QueryEpochProvisionsRequest",
      value: QueryEpochProvisionsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryEpochProvisionsResponse() {
  return {
    epochProvisions: new Uint8Array()
  };
}
const QueryEpochProvisionsResponse = {
  typeUrl: "/osmosis.mint.v1beta1.QueryEpochProvisionsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.epochProvisions.length !== 0 && n.uint32(10).bytes(e.epochProvisions), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryEpochProvisionsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.epochProvisions = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryEpochProvisionsResponse();
    return o.epochProvisions = (n = e.epochProvisions) !== null && n !== void 0 ? n : new Uint8Array(), o;
  },
  fromAmino(e) {
    return {
      epochProvisions: e.epoch_provisions
    };
  },
  toAmino(e) {
    const n = {};
    return n.epoch_provisions = e.epochProvisions, n;
  },
  fromAminoMsg(e) {
    return QueryEpochProvisionsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/mint/query-epoch-provisions-response",
      value: QueryEpochProvisionsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryEpochProvisionsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryEpochProvisionsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.QueryEpochProvisionsResponse",
      value: QueryEpochProvisionsResponse.encode(e).finish()
    };
  }
}, _143 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryEpochProvisionsRequest,
  QueryEpochProvisionsResponse,
  QueryParamsRequest: QueryParamsRequest$4,
  QueryParamsResponse: QueryParamsResponse$4
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$6() {
  return {
    params: void 0,
    lockableDurations: [],
    distrInfo: void 0,
    poolToGauges: void 0
  };
}
const GenesisState$6 = {
  typeUrl: "/osmosis.poolincentives.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$i.encode(e.params, n.uint32(10).fork()).ldelim();
    for (const o of e.lockableDurations)
      Duration.encode(o, n.uint32(18).fork()).ldelim();
    return e.distrInfo !== void 0 && DistrInfo.encode(e.distrInfo, n.uint32(26).fork()).ldelim(), e.poolToGauges !== void 0 && PoolToGauges.encode(e.poolToGauges, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$6();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$i.decode(o, o.uint32());
          break;
        case 2:
          c.lockableDurations.push(Duration.decode(o, o.uint32()));
          break;
        case 3:
          c.distrInfo = DistrInfo.decode(o, o.uint32());
          break;
        case 4:
          c.poolToGauges = PoolToGauges.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$6();
    return o.params = e.params !== void 0 && e.params !== null ? Params$i.fromPartial(e.params) : void 0, o.lockableDurations = ((n = e.lockableDurations) === null || n === void 0 ? void 0 : n.map((u) => Duration.fromPartial(u))) || [], o.distrInfo = e.distrInfo !== void 0 && e.distrInfo !== null ? DistrInfo.fromPartial(e.distrInfo) : void 0, o.poolToGauges = e.poolToGauges !== void 0 && e.poolToGauges !== null ? PoolToGauges.fromPartial(e.poolToGauges) : void 0, o;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$i.fromAmino(e.params) : void 0,
      lockableDurations: Array.isArray(e == null ? void 0 : e.lockable_durations) ? e.lockable_durations.map((n) => Duration.fromAmino(n)) : [],
      distrInfo: e != null && e.distr_info ? DistrInfo.fromAmino(e.distr_info) : void 0,
      poolToGauges: e != null && e.pool_to_gauges ? PoolToGauges.fromAmino(e.pool_to_gauges) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$i.toAmino(e.params) : void 0, e.lockableDurations ? n.lockable_durations = e.lockableDurations.map((o) => o ? Duration.toAmino(o) : void 0) : n.lockable_durations = [], n.distr_info = e.distrInfo ? DistrInfo.toAmino(e.distrInfo) : void 0, n.pool_to_gauges = e.poolToGauges ? PoolToGauges.toAmino(e.poolToGauges) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$6.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/genesis-state",
      value: GenesisState$6.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$6.decode(e.value);
  },
  toProto(e) {
    return GenesisState$6.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.GenesisState",
      value: GenesisState$6.encode(e).finish()
    };
  }
}, _144 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$6
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryGaugeIdsRequest() {
  return {
    poolId: Long$2.UZERO
  };
}
const QueryGaugeIdsRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryGaugeIdsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGaugeIdsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryGaugeIdsRequest();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGaugeIdsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-gauge-ids-request",
      value: QueryGaugeIdsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGaugeIdsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGaugeIdsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryGaugeIdsRequest",
      value: QueryGaugeIdsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGaugeIdsResponse() {
  return {
    gaugeIdsWithDuration: []
  };
}
const QueryGaugeIdsResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryGaugeIdsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.gaugeIdsWithDuration)
      QueryGaugeIdsResponse_GaugeIdWithDuration.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGaugeIdsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.gaugeIdsWithDuration.push(QueryGaugeIdsResponse_GaugeIdWithDuration.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGaugeIdsResponse();
    return o.gaugeIdsWithDuration = ((n = e.gaugeIdsWithDuration) === null || n === void 0 ? void 0 : n.map((u) => QueryGaugeIdsResponse_GaugeIdWithDuration.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      gaugeIdsWithDuration: Array.isArray(e == null ? void 0 : e.gauge_ids_with_duration) ? e.gauge_ids_with_duration.map((n) => QueryGaugeIdsResponse_GaugeIdWithDuration.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.gaugeIdsWithDuration ? n.gauge_ids_with_duration = e.gaugeIdsWithDuration.map((o) => o ? QueryGaugeIdsResponse_GaugeIdWithDuration.toAmino(o) : void 0) : n.gauge_ids_with_duration = [], n;
  },
  fromAminoMsg(e) {
    return QueryGaugeIdsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-gauge-ids-response",
      value: QueryGaugeIdsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGaugeIdsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGaugeIdsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryGaugeIdsResponse",
      value: QueryGaugeIdsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGaugeIdsResponse_GaugeIdWithDuration() {
  return {
    gaugeId: Long$2.UZERO,
    duration: void 0,
    gaugeIncentivePercentage: ""
  };
}
const QueryGaugeIdsResponse_GaugeIdWithDuration = {
  typeUrl: "/osmosis.poolincentives.v1beta1.GaugeIdWithDuration",
  encode(e, n = minimal.Writer.create()) {
    return e.gaugeId.isZero() || n.uint32(8).uint64(e.gaugeId), e.duration !== void 0 && Duration.encode(e.duration, n.uint32(18).fork()).ldelim(), e.gaugeIncentivePercentage !== "" && n.uint32(26).string(e.gaugeIncentivePercentage), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGaugeIdsResponse_GaugeIdWithDuration();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.gaugeId = o.uint64();
          break;
        case 2:
          c.duration = Duration.decode(o, o.uint32());
          break;
        case 3:
          c.gaugeIncentivePercentage = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGaugeIdsResponse_GaugeIdWithDuration();
    return o.gaugeId = e.gaugeId !== void 0 && e.gaugeId !== null ? Long$2.fromValue(e.gaugeId) : Long$2.UZERO, o.duration = e.duration !== void 0 && e.duration !== null ? Duration.fromPartial(e.duration) : void 0, o.gaugeIncentivePercentage = (n = e.gaugeIncentivePercentage) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      gaugeId: Long$2.fromString(e.gauge_id),
      duration: e != null && e.duration ? Duration.fromAmino(e.duration) : void 0,
      gaugeIncentivePercentage: e.gauge_incentive_percentage
    };
  },
  toAmino(e) {
    const n = {};
    return n.gauge_id = e.gaugeId ? e.gaugeId.toString() : void 0, n.duration = e.duration ? Duration.toAmino(e.duration) : void 0, n.gauge_incentive_percentage = e.gaugeIncentivePercentage, n;
  },
  fromAminoMsg(e) {
    return QueryGaugeIdsResponse_GaugeIdWithDuration.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/gauge-id-with-duration",
      value: QueryGaugeIdsResponse_GaugeIdWithDuration.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGaugeIdsResponse_GaugeIdWithDuration.decode(e.value);
  },
  toProto(e) {
    return QueryGaugeIdsResponse_GaugeIdWithDuration.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.GaugeIdWithDuration",
      value: QueryGaugeIdsResponse_GaugeIdWithDuration.encode(e).finish()
    };
  }
};
function createBaseQueryDistrInfoRequest() {
  return {};
}
const QueryDistrInfoRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryDistrInfoRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDistrInfoRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryDistrInfoRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryDistrInfoRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-distr-info-request",
      value: QueryDistrInfoRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDistrInfoRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDistrInfoRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryDistrInfoRequest",
      value: QueryDistrInfoRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDistrInfoResponse() {
  return {
    distrInfo: void 0
  };
}
const QueryDistrInfoResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryDistrInfoResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.distrInfo !== void 0 && DistrInfo.encode(e.distrInfo, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDistrInfoResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.distrInfo = DistrInfo.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDistrInfoResponse();
    return n.distrInfo = e.distrInfo !== void 0 && e.distrInfo !== null ? DistrInfo.fromPartial(e.distrInfo) : void 0, n;
  },
  fromAmino(e) {
    return {
      distrInfo: e != null && e.distr_info ? DistrInfo.fromAmino(e.distr_info) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.distr_info = e.distrInfo ? DistrInfo.toAmino(e.distrInfo) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDistrInfoResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-distr-info-response",
      value: QueryDistrInfoResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDistrInfoResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDistrInfoResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryDistrInfoResponse",
      value: QueryDistrInfoResponse.encode(e).finish()
    };
  }
};
function createBaseQueryParamsRequest$3() {
  return {};
}
const QueryParamsRequest$3 = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$3();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$3.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-params-request",
      value: QueryParamsRequest$3.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$3.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest$3.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$3() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$3 = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$i.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$i.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$3();
    return n.params = e.params !== void 0 && e.params !== null ? Params$i.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$i.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$i.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$3.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-params-response",
      value: QueryParamsResponse$3.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$3.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse$3.encode(e).finish()
    };
  }
};
function createBaseQueryLockableDurationsRequest() {
  return {};
}
const QueryLockableDurationsRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryLockableDurationsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryLockableDurationsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryLockableDurationsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryLockableDurationsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-lockable-durations-request",
      value: QueryLockableDurationsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryLockableDurationsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryLockableDurationsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryLockableDurationsRequest",
      value: QueryLockableDurationsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryLockableDurationsResponse() {
  return {
    lockableDurations: []
  };
}
const QueryLockableDurationsResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryLockableDurationsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.lockableDurations)
      Duration.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryLockableDurationsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockableDurations.push(Duration.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryLockableDurationsResponse();
    return o.lockableDurations = ((n = e.lockableDurations) === null || n === void 0 ? void 0 : n.map((u) => Duration.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      lockableDurations: Array.isArray(e == null ? void 0 : e.lockable_durations) ? e.lockable_durations.map((n) => Duration.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.lockableDurations ? n.lockable_durations = e.lockableDurations.map((o) => o ? Duration.toAmino(o) : void 0) : n.lockable_durations = [], n;
  },
  fromAminoMsg(e) {
    return QueryLockableDurationsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-lockable-durations-response",
      value: QueryLockableDurationsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryLockableDurationsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryLockableDurationsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryLockableDurationsResponse",
      value: QueryLockableDurationsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryIncentivizedPoolsRequest() {
  return {};
}
const QueryIncentivizedPoolsRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryIncentivizedPoolsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryIncentivizedPoolsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryIncentivizedPoolsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryIncentivizedPoolsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-incentivized-pools-request",
      value: QueryIncentivizedPoolsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryIncentivizedPoolsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryIncentivizedPoolsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryIncentivizedPoolsRequest",
      value: QueryIncentivizedPoolsRequest.encode(e).finish()
    };
  }
};
function createBaseIncentivizedPool() {
  return {
    poolId: Long$2.UZERO,
    lockableDuration: void 0,
    gaugeId: Long$2.UZERO
  };
}
const IncentivizedPool = {
  typeUrl: "/osmosis.poolincentives.v1beta1.IncentivizedPool",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.lockableDuration !== void 0 && Duration.encode(e.lockableDuration, n.uint32(18).fork()).ldelim(), e.gaugeId.isZero() || n.uint32(24).uint64(e.gaugeId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseIncentivizedPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.lockableDuration = Duration.decode(o, o.uint32());
          break;
        case 3:
          c.gaugeId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseIncentivizedPool();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n.lockableDuration = e.lockableDuration !== void 0 && e.lockableDuration !== null ? Duration.fromPartial(e.lockableDuration) : void 0, n.gaugeId = e.gaugeId !== void 0 && e.gaugeId !== null ? Long$2.fromValue(e.gaugeId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      lockableDuration: e != null && e.lockable_duration ? Duration.fromAmino(e.lockable_duration) : void 0,
      gaugeId: Long$2.fromString(e.gauge_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.lockable_duration = e.lockableDuration ? Duration.toAmino(e.lockableDuration) : void 0, n.gauge_id = e.gaugeId ? e.gaugeId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return IncentivizedPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/incentivized-pool",
      value: IncentivizedPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return IncentivizedPool.decode(e.value);
  },
  toProto(e) {
    return IncentivizedPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.IncentivizedPool",
      value: IncentivizedPool.encode(e).finish()
    };
  }
};
function createBaseQueryIncentivizedPoolsResponse() {
  return {
    incentivizedPools: []
  };
}
const QueryIncentivizedPoolsResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryIncentivizedPoolsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.incentivizedPools)
      IncentivizedPool.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryIncentivizedPoolsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.incentivizedPools.push(IncentivizedPool.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryIncentivizedPoolsResponse();
    return o.incentivizedPools = ((n = e.incentivizedPools) === null || n === void 0 ? void 0 : n.map((u) => IncentivizedPool.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      incentivizedPools: Array.isArray(e == null ? void 0 : e.incentivized_pools) ? e.incentivized_pools.map((n) => IncentivizedPool.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.incentivizedPools ? n.incentivized_pools = e.incentivizedPools.map((o) => o ? IncentivizedPool.toAmino(o) : void 0) : n.incentivized_pools = [], n;
  },
  fromAminoMsg(e) {
    return QueryIncentivizedPoolsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-incentivized-pools-response",
      value: QueryIncentivizedPoolsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryIncentivizedPoolsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryIncentivizedPoolsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryIncentivizedPoolsResponse",
      value: QueryIncentivizedPoolsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryExternalIncentiveGaugesRequest() {
  return {};
}
const QueryExternalIncentiveGaugesRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryExternalIncentiveGaugesRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryExternalIncentiveGaugesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryExternalIncentiveGaugesRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryExternalIncentiveGaugesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-external-incentive-gauges-request",
      value: QueryExternalIncentiveGaugesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryExternalIncentiveGaugesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryExternalIncentiveGaugesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryExternalIncentiveGaugesRequest",
      value: QueryExternalIncentiveGaugesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryExternalIncentiveGaugesResponse() {
  return {
    data: []
  };
}
const QueryExternalIncentiveGaugesResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryExternalIncentiveGaugesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.data)
      Gauge.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryExternalIncentiveGaugesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.data.push(Gauge.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryExternalIncentiveGaugesResponse();
    return o.data = ((n = e.data) === null || n === void 0 ? void 0 : n.map((u) => Gauge.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      data: Array.isArray(e == null ? void 0 : e.data) ? e.data.map((n) => Gauge.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.data ? n.data = e.data.map((o) => o ? Gauge.toAmino(o) : void 0) : n.data = [], n;
  },
  fromAminoMsg(e) {
    return QueryExternalIncentiveGaugesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolincentives/query-external-incentive-gauges-response",
      value: QueryExternalIncentiveGaugesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryExternalIncentiveGaugesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryExternalIncentiveGaugesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryExternalIncentiveGaugesResponse",
      value: QueryExternalIncentiveGaugesResponse.encode(e).finish()
    };
  }
}, _147 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IncentivizedPool,
  QueryDistrInfoRequest,
  QueryDistrInfoResponse,
  QueryExternalIncentiveGaugesRequest,
  QueryExternalIncentiveGaugesResponse,
  QueryGaugeIdsRequest,
  QueryGaugeIdsResponse,
  QueryGaugeIdsResponse_GaugeIdWithDuration,
  QueryIncentivizedPoolsRequest,
  QueryIncentivizedPoolsResponse,
  QueryLockableDurationsRequest,
  QueryLockableDurationsResponse,
  QueryParamsRequest: QueryParamsRequest$3,
  QueryParamsResponse: QueryParamsResponse$3
}, Symbol.toStringTag, { value: "Module" }));
let PoolType;
(function(e) {
  e[e.Balancer = 0] = "Balancer", e[e.Stableswap = 1] = "Stableswap", e[e.Concentrated = 2] = "Concentrated", e[e.CosmWasm = 3] = "CosmWasm", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(PoolType || (PoolType = {}));
const PoolTypeSDKType = PoolType, PoolTypeAmino = PoolType;
function poolTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "Balancer":
      return PoolType.Balancer;
    case 1:
    case "Stableswap":
      return PoolType.Stableswap;
    case 2:
    case "Concentrated":
      return PoolType.Concentrated;
    case 3:
    case "CosmWasm":
      return PoolType.CosmWasm;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PoolType.UNRECOGNIZED;
  }
}
function poolTypeToJSON(e) {
  switch (e) {
    case PoolType.Balancer:
      return "Balancer";
    case PoolType.Stableswap:
      return "Stableswap";
    case PoolType.Concentrated:
      return "Concentrated";
    case PoolType.CosmWasm:
      return "CosmWasm";
    case PoolType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseModuleRoute() {
  return {
    poolType: 0,
    poolId: void 0
  };
}
const ModuleRoute = {
  typeUrl: "/osmosis.poolmanager.v1beta1.ModuleRoute",
  encode(e, n = minimal.Writer.create()) {
    return e.poolType !== 0 && n.uint32(8).int32(e.poolType), e.poolId !== void 0 && n.uint32(16).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseModuleRoute();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolType = o.int32();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseModuleRoute();
    return o.poolType = (n = e.poolType) !== null && n !== void 0 ? n : 0, o.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : void 0, o;
  },
  fromAmino(e) {
    return {
      poolType: isSet(e.pool_type) ? poolTypeFromJSON(e.pool_type) : 0,
      poolId: e != null && e.pool_id ? Long$2.fromString(e.pool_id) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_type = e.poolType, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ModuleRoute.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/module-route",
      value: ModuleRoute.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ModuleRoute.decode(e.value);
  },
  toProto(e) {
    return ModuleRoute.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.ModuleRoute",
      value: ModuleRoute.encode(e).finish()
    };
  }
}, _149 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ModuleRoute,
  get PoolType() {
    return PoolType;
  },
  PoolTypeAmino,
  PoolTypeSDKType,
  poolTypeFromJSON,
  poolTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$4() {
  return {
    poolCreationFee: []
  };
}
const Params$4 = {
  typeUrl: "/osmosis.poolmanager.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.poolCreationFee)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$4();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolCreationFee.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$4();
    return o.poolCreationFee = ((n = e.poolCreationFee) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      poolCreationFee: Array.isArray(e == null ? void 0 : e.pool_creation_fee) ? e.pool_creation_fee.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.poolCreationFee ? n.pool_creation_fee = e.poolCreationFee.map((o) => o ? Coin.toAmino(o) : void 0) : n.pool_creation_fee = [], n;
  },
  fromAminoMsg(e) {
    return Params$4.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/params",
      value: Params$4.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$4.decode(e.value);
  },
  toProto(e) {
    return Params$4.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.Params",
      value: Params$4.encode(e).finish()
    };
  }
};
function createBaseGenesisState$5() {
  return {
    nextPoolId: Long$2.UZERO,
    params: void 0,
    poolRoutes: []
  };
}
const GenesisState$5 = {
  typeUrl: "/osmosis.poolmanager.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.nextPoolId.isZero() || n.uint32(8).uint64(e.nextPoolId), e.params !== void 0 && Params$4.encode(e.params, n.uint32(18).fork()).ldelim();
    for (const o of e.poolRoutes)
      ModuleRoute.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$5();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.nextPoolId = o.uint64();
          break;
        case 2:
          c.params = Params$4.decode(o, o.uint32());
          break;
        case 3:
          c.poolRoutes.push(ModuleRoute.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$5();
    return o.nextPoolId = e.nextPoolId !== void 0 && e.nextPoolId !== null ? Long$2.fromValue(e.nextPoolId) : Long$2.UZERO, o.params = e.params !== void 0 && e.params !== null ? Params$4.fromPartial(e.params) : void 0, o.poolRoutes = ((n = e.poolRoutes) === null || n === void 0 ? void 0 : n.map((u) => ModuleRoute.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      nextPoolId: Long$2.fromString(e.next_pool_id),
      params: e != null && e.params ? Params$4.fromAmino(e.params) : void 0,
      poolRoutes: Array.isArray(e == null ? void 0 : e.pool_routes) ? e.pool_routes.map((n) => ModuleRoute.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.next_pool_id = e.nextPoolId ? e.nextPoolId.toString() : void 0, n.params = e.params ? Params$4.toAmino(e.params) : void 0, e.poolRoutes ? n.pool_routes = e.poolRoutes.map((o) => o ? ModuleRoute.toAmino(o) : void 0) : n.pool_routes = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$5.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/genesis-state",
      value: GenesisState$5.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$5.decode(e.value);
  },
  toProto(e) {
    return GenesisState$5.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.GenesisState",
      value: GenesisState$5.encode(e).finish()
    };
  }
}, _148 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$5,
  Params: Params$4
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParamsRequest$1() {
  return {};
}
const ParamsRequest$1 = {
  typeUrl: "/osmosis.poolmanager.v1beta1.ParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParamsRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseParamsRequest$1();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ParamsRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/params-request",
      value: ParamsRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ParamsRequest$1.decode(e.value);
  },
  toProto(e) {
    return ParamsRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.ParamsRequest",
      value: ParamsRequest$1.encode(e).finish()
    };
  }
};
function createBaseParamsResponse$1() {
  return {
    params: void 0
  };
}
const ParamsResponse$1 = {
  typeUrl: "/osmosis.poolmanager.v1beta1.ParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$4.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParamsResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$4.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseParamsResponse$1();
    return n.params = e.params !== void 0 && e.params !== null ? Params$4.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$4.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$4.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return ParamsResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/params-response",
      value: ParamsResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ParamsResponse$1.decode(e.value);
  },
  toProto(e) {
    return ParamsResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.ParamsResponse",
      value: ParamsResponse$1.encode(e).finish()
    };
  }
};
function createBaseEstimateSwapExactAmountInRequest() {
  return {
    poolId: Long$2.UZERO,
    tokenIn: "",
    routes: []
  };
}
const EstimateSwapExactAmountInRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountInRequest",
  encode(e, n = minimal.Writer.create()) {
    e.poolId.isZero() || n.uint32(16).uint64(e.poolId), e.tokenIn !== "" && n.uint32(26).string(e.tokenIn);
    for (const o of e.routes)
      SwapAmountInRoute.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEstimateSwapExactAmountInRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.tokenIn = o.string();
          break;
        case 4:
          c.routes.push(SwapAmountInRoute.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEstimateSwapExactAmountInRequest();
    return u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.tokenIn = (n = e.tokenIn) !== null && n !== void 0 ? n : "", u.routes = ((o = e.routes) === null || o === void 0 ? void 0 : o.map((c) => SwapAmountInRoute.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      tokenIn: e.token_in,
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => SwapAmountInRoute.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_in = e.tokenIn, e.routes ? n.routes = e.routes.map((o) => o ? SwapAmountInRoute.toAmino(o) : void 0) : n.routes = [], n;
  },
  fromAminoMsg(e) {
    return EstimateSwapExactAmountInRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/estimate-swap-exact-amount-in-request",
      value: EstimateSwapExactAmountInRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EstimateSwapExactAmountInRequest.decode(e.value);
  },
  toProto(e) {
    return EstimateSwapExactAmountInRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountInRequest",
      value: EstimateSwapExactAmountInRequest.encode(e).finish()
    };
  }
};
function createBaseEstimateSinglePoolSwapExactAmountInRequest() {
  return {
    poolId: Long$2.UZERO,
    tokenIn: "",
    tokenOutDenom: ""
  };
}
const EstimateSinglePoolSwapExactAmountInRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSinglePoolSwapExactAmountInRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.tokenIn !== "" && n.uint32(18).string(e.tokenIn), e.tokenOutDenom !== "" && n.uint32(26).string(e.tokenOutDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEstimateSinglePoolSwapExactAmountInRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.tokenIn = o.string();
          break;
        case 3:
          c.tokenOutDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEstimateSinglePoolSwapExactAmountInRequest();
    return u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.tokenIn = (n = e.tokenIn) !== null && n !== void 0 ? n : "", u.tokenOutDenom = (o = e.tokenOutDenom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      tokenIn: e.token_in,
      tokenOutDenom: e.token_out_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_in = e.tokenIn, n.token_out_denom = e.tokenOutDenom, n;
  },
  fromAminoMsg(e) {
    return EstimateSinglePoolSwapExactAmountInRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/estimate-single-pool-swap-exact-amount-in-request",
      value: EstimateSinglePoolSwapExactAmountInRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EstimateSinglePoolSwapExactAmountInRequest.decode(e.value);
  },
  toProto(e) {
    return EstimateSinglePoolSwapExactAmountInRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSinglePoolSwapExactAmountInRequest",
      value: EstimateSinglePoolSwapExactAmountInRequest.encode(e).finish()
    };
  }
};
function createBaseEstimateSwapExactAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}
const EstimateSwapExactAmountInResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountInResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenOutAmount !== "" && n.uint32(10).string(e.tokenOutAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEstimateSwapExactAmountInResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenOutAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseEstimateSwapExactAmountInResponse();
    return o.tokenOutAmount = (n = e.tokenOutAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenOutAmount: e.token_out_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_out_amount = e.tokenOutAmount, n;
  },
  fromAminoMsg(e) {
    return EstimateSwapExactAmountInResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/estimate-swap-exact-amount-in-response",
      value: EstimateSwapExactAmountInResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EstimateSwapExactAmountInResponse.decode(e.value);
  },
  toProto(e) {
    return EstimateSwapExactAmountInResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountInResponse",
      value: EstimateSwapExactAmountInResponse.encode(e).finish()
    };
  }
};
function createBaseEstimateSwapExactAmountOutRequest() {
  return {
    poolId: Long$2.UZERO,
    routes: [],
    tokenOut: ""
  };
}
const EstimateSwapExactAmountOutRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountOutRequest",
  encode(e, n = minimal.Writer.create()) {
    e.poolId.isZero() || n.uint32(16).uint64(e.poolId);
    for (const o of e.routes)
      SwapAmountOutRoute.encode(o, n.uint32(26).fork()).ldelim();
    return e.tokenOut !== "" && n.uint32(34).string(e.tokenOut), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEstimateSwapExactAmountOutRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.poolId = o.uint64();
          break;
        case 3:
          c.routes.push(SwapAmountOutRoute.decode(o, o.uint32()));
          break;
        case 4:
          c.tokenOut = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEstimateSwapExactAmountOutRequest();
    return u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.routes = ((n = e.routes) === null || n === void 0 ? void 0 : n.map((c) => SwapAmountOutRoute.fromPartial(c))) || [], u.tokenOut = (o = e.tokenOut) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => SwapAmountOutRoute.fromAmino(n)) : [],
      tokenOut: e.token_out
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, e.routes ? n.routes = e.routes.map((o) => o ? SwapAmountOutRoute.toAmino(o) : void 0) : n.routes = [], n.token_out = e.tokenOut, n;
  },
  fromAminoMsg(e) {
    return EstimateSwapExactAmountOutRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/estimate-swap-exact-amount-out-request",
      value: EstimateSwapExactAmountOutRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EstimateSwapExactAmountOutRequest.decode(e.value);
  },
  toProto(e) {
    return EstimateSwapExactAmountOutRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountOutRequest",
      value: EstimateSwapExactAmountOutRequest.encode(e).finish()
    };
  }
};
function createBaseEstimateSinglePoolSwapExactAmountOutRequest() {
  return {
    poolId: Long$2.UZERO,
    tokenInDenom: "",
    tokenOut: ""
  };
}
const EstimateSinglePoolSwapExactAmountOutRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSinglePoolSwapExactAmountOutRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.tokenInDenom !== "" && n.uint32(18).string(e.tokenInDenom), e.tokenOut !== "" && n.uint32(26).string(e.tokenOut), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEstimateSinglePoolSwapExactAmountOutRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.tokenInDenom = o.string();
          break;
        case 3:
          c.tokenOut = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEstimateSinglePoolSwapExactAmountOutRequest();
    return u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.tokenInDenom = (n = e.tokenInDenom) !== null && n !== void 0 ? n : "", u.tokenOut = (o = e.tokenOut) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      tokenInDenom: e.token_in_denom,
      tokenOut: e.token_out
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.token_in_denom = e.tokenInDenom, n.token_out = e.tokenOut, n;
  },
  fromAminoMsg(e) {
    return EstimateSinglePoolSwapExactAmountOutRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/estimate-single-pool-swap-exact-amount-out-request",
      value: EstimateSinglePoolSwapExactAmountOutRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EstimateSinglePoolSwapExactAmountOutRequest.decode(e.value);
  },
  toProto(e) {
    return EstimateSinglePoolSwapExactAmountOutRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSinglePoolSwapExactAmountOutRequest",
      value: EstimateSinglePoolSwapExactAmountOutRequest.encode(e).finish()
    };
  }
};
function createBaseEstimateSwapExactAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}
const EstimateSwapExactAmountOutResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountOutResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenInAmount !== "" && n.uint32(10).string(e.tokenInAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEstimateSwapExactAmountOutResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenInAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseEstimateSwapExactAmountOutResponse();
    return o.tokenInAmount = (n = e.tokenInAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenInAmount: e.token_in_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_in_amount = e.tokenInAmount, n;
  },
  fromAminoMsg(e) {
    return EstimateSwapExactAmountOutResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/estimate-swap-exact-amount-out-response",
      value: EstimateSwapExactAmountOutResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EstimateSwapExactAmountOutResponse.decode(e.value);
  },
  toProto(e) {
    return EstimateSwapExactAmountOutResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountOutResponse",
      value: EstimateSwapExactAmountOutResponse.encode(e).finish()
    };
  }
};
function createBaseNumPoolsRequest() {
  return {};
}
const NumPoolsRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.NumPoolsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNumPoolsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseNumPoolsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return NumPoolsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/num-pools-request",
      value: NumPoolsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return NumPoolsRequest.decode(e.value);
  },
  toProto(e) {
    return NumPoolsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.NumPoolsRequest",
      value: NumPoolsRequest.encode(e).finish()
    };
  }
};
function createBaseNumPoolsResponse() {
  return {
    numPools: Long$2.UZERO
  };
}
const NumPoolsResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.NumPoolsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.numPools.isZero() || n.uint32(8).uint64(e.numPools), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNumPoolsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.numPools = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseNumPoolsResponse();
    return n.numPools = e.numPools !== void 0 && e.numPools !== null ? Long$2.fromValue(e.numPools) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      numPools: Long$2.fromString(e.num_pools)
    };
  },
  toAmino(e) {
    const n = {};
    return n.num_pools = e.numPools ? e.numPools.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return NumPoolsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/num-pools-response",
      value: NumPoolsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return NumPoolsResponse.decode(e.value);
  },
  toProto(e) {
    return NumPoolsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.NumPoolsResponse",
      value: NumPoolsResponse.encode(e).finish()
    };
  }
};
function createBasePoolRequest() {
  return {
    poolId: Long$2.UZERO
  };
}
const PoolRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.PoolRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePoolRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBasePoolRequest();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return PoolRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/pool-request",
      value: PoolRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PoolRequest.decode(e.value);
  },
  toProto(e) {
    return PoolRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.PoolRequest",
      value: PoolRequest.encode(e).finish()
    };
  }
};
function createBasePoolResponse() {
  return {
    pool: void 0
  };
}
const PoolResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.PoolResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.pool !== void 0 && Any.encode(e.pool, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pool = PoolI_InterfaceDecoder(o);
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBasePoolResponse();
    return n.pool = e.pool !== void 0 && e.pool !== null ? Any.fromPartial(e.pool) : void 0, n;
  },
  fromAmino(e) {
    return {
      pool: e != null && e.pool ? PoolI_FromAmino(e.pool) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool = e.pool ? PoolI_ToAmino(e.pool) : void 0, n;
  },
  fromAminoMsg(e) {
    return PoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/pool-response",
      value: PoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PoolResponse.decode(e.value);
  },
  toProto(e) {
    return PoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.PoolResponse",
      value: PoolResponse.encode(e).finish()
    };
  }
};
function createBaseAllPoolsRequest() {
  return {
    poolId: Long$2.UZERO
  };
}
const AllPoolsRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.AllPoolsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAllPoolsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseAllPoolsRequest();
    return n.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return AllPoolsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/all-pools-request",
      value: AllPoolsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AllPoolsRequest.decode(e.value);
  },
  toProto(e) {
    return AllPoolsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.AllPoolsRequest",
      value: AllPoolsRequest.encode(e).finish()
    };
  }
};
function createBaseAllPoolsResponse() {
  return {
    pools: []
  };
}
const AllPoolsResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.AllPoolsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.pools)
      Any.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAllPoolsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pools.push(PoolI_InterfaceDecoder(o));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAllPoolsResponse();
    return o.pools = ((n = e.pools) === null || n === void 0 ? void 0 : n.map((u) => Any.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      pools: Array.isArray(e == null ? void 0 : e.pools) ? e.pools.map((n) => PoolI_FromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.pools ? n.pools = e.pools.map((o) => o ? PoolI_ToAmino(o) : void 0) : n.pools = [], n;
  },
  fromAminoMsg(e) {
    return AllPoolsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/all-pools-response",
      value: AllPoolsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AllPoolsResponse.decode(e.value);
  },
  toProto(e) {
    return AllPoolsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.AllPoolsResponse",
      value: AllPoolsResponse.encode(e).finish()
    };
  }
};
function createBaseSpotPriceRequest() {
  return {
    poolId: Long$2.UZERO,
    baseAssetDenom: "",
    quoteAssetDenom: ""
  };
}
const SpotPriceRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SpotPriceRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.baseAssetDenom !== "" && n.uint32(18).string(e.baseAssetDenom), e.quoteAssetDenom !== "" && n.uint32(26).string(e.quoteAssetDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSpotPriceRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.baseAssetDenom = o.string();
          break;
        case 3:
          c.quoteAssetDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSpotPriceRequest();
    return u.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, u.baseAssetDenom = (n = e.baseAssetDenom) !== null && n !== void 0 ? n : "", u.quoteAssetDenom = (o = e.quoteAssetDenom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      baseAssetDenom: e.base_asset_denom,
      quoteAssetDenom: e.quote_asset_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.base_asset_denom = e.baseAssetDenom, n.quote_asset_denom = e.quoteAssetDenom, n;
  },
  fromAminoMsg(e) {
    return SpotPriceRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/spot-price-request",
      value: SpotPriceRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SpotPriceRequest.decode(e.value);
  },
  toProto(e) {
    return SpotPriceRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SpotPriceRequest",
      value: SpotPriceRequest.encode(e).finish()
    };
  }
};
function createBaseSpotPriceResponse() {
  return {
    spotPrice: ""
  };
}
const SpotPriceResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SpotPriceResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.spotPrice !== "" && n.uint32(10).string(e.spotPrice), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSpotPriceResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.spotPrice = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSpotPriceResponse();
    return o.spotPrice = (n = e.spotPrice) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      spotPrice: e.spot_price
    };
  },
  toAmino(e) {
    const n = {};
    return n.spot_price = e.spotPrice, n;
  },
  fromAminoMsg(e) {
    return SpotPriceResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/spot-price-response",
      value: SpotPriceResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SpotPriceResponse.decode(e.value);
  },
  toProto(e) {
    return SpotPriceResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SpotPriceResponse",
      value: SpotPriceResponse.encode(e).finish()
    };
  }
}, PoolI_InterfaceDecoder = (e) => {
  const n = e instanceof minimal.Reader ? e : new minimal.Reader(e), o = Any.decode(n, n.uint32());
  switch (o.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return Pool$1.decode(o.value);
    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return CosmWasmPool.decode(o.value);
    case "/osmosis.gamm.v1beta1.Pool":
      return Pool$2.decode(o.value);
    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return Pool.decode(o.value);
    default:
      return o;
  }
}, PoolI_FromAmino = (e) => {
  switch (e.type) {
    case "osmosis/concentratedliquidity/pool":
      return Any.fromPartial({
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
        value: Pool$1.encode(Pool$1.fromPartial(Pool$1.fromAmino(e.value))).finish()
      });
    case "osmosis/cosmwasmpool/cosm-wasm-pool":
      return Any.fromPartial({
        typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
        value: CosmWasmPool.encode(CosmWasmPool.fromPartial(CosmWasmPool.fromAmino(e.value))).finish()
      });
    case "osmosis/gamm/BalancerPool":
      return Any.fromPartial({
        typeUrl: "/osmosis.gamm.v1beta1.Pool",
        value: Pool$2.encode(Pool$2.fromPartial(Pool$2.fromAmino(e.value))).finish()
      });
    case "osmosis/gamm/StableswapPool":
      return Any.fromPartial({
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
        value: Pool.encode(Pool.fromPartial(Pool.fromAmino(e.value))).finish()
      });
    default:
      return Any.fromAmino(e);
  }
}, PoolI_ToAmino = (e) => {
  switch (e.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return {
        type: "osmosis/concentratedliquidity/pool",
        value: Pool$1.toAmino(Pool$1.decode(e.value))
      };
    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return {
        type: "osmosis/cosmwasmpool/cosm-wasm-pool",
        value: CosmWasmPool.toAmino(CosmWasmPool.decode(e.value))
      };
    case "/osmosis.gamm.v1beta1.Pool":
      return {
        type: "osmosis/gamm/BalancerPool",
        value: Pool$2.toAmino(Pool$2.decode(e.value))
      };
    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return {
        type: "osmosis/gamm/StableswapPool",
        value: Pool.toAmino(Pool.decode(e.value))
      };
    default:
      return Any.toAmino(e);
  }
}, _150 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AllPoolsRequest,
  AllPoolsResponse,
  EstimateSinglePoolSwapExactAmountInRequest,
  EstimateSinglePoolSwapExactAmountOutRequest,
  EstimateSwapExactAmountInRequest,
  EstimateSwapExactAmountInResponse,
  EstimateSwapExactAmountOutRequest,
  EstimateSwapExactAmountOutResponse,
  NumPoolsRequest,
  NumPoolsResponse,
  ParamsRequest: ParamsRequest$1,
  ParamsResponse: ParamsResponse$1,
  PoolI_FromAmino,
  PoolI_InterfaceDecoder,
  PoolI_ToAmino,
  PoolRequest,
  PoolResponse,
  SpotPriceRequest,
  SpotPriceResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSwapExactAmountIn() {
  return {
    sender: "",
    routes: [],
    tokenIn: void 0,
    tokenOutMinAmount: ""
  };
}
const MsgSwapExactAmountIn = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender);
    for (const o of e.routes)
      SwapAmountInRoute.encode(o, n.uint32(18).fork()).ldelim();
    return e.tokenIn !== void 0 && Coin.encode(e.tokenIn, n.uint32(26).fork()).ldelim(), e.tokenOutMinAmount !== "" && n.uint32(34).string(e.tokenOutMinAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSwapExactAmountIn();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.routes.push(SwapAmountInRoute.decode(o, o.uint32()));
          break;
        case 3:
          c.tokenIn = Coin.decode(o, o.uint32());
          break;
        case 4:
          c.tokenOutMinAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgSwapExactAmountIn();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.routes = ((o = e.routes) === null || o === void 0 ? void 0 : o.map((d) => SwapAmountInRoute.fromPartial(d))) || [], c.tokenIn = e.tokenIn !== void 0 && e.tokenIn !== null ? Coin.fromPartial(e.tokenIn) : void 0, c.tokenOutMinAmount = (u = e.tokenOutMinAmount) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => SwapAmountInRoute.fromAmino(n)) : [],
      tokenIn: e != null && e.token_in ? Coin.fromAmino(e.token_in) : void 0,
      tokenOutMinAmount: e.token_out_min_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, e.routes ? n.routes = e.routes.map((o) => o ? SwapAmountInRoute.toAmino(o) : void 0) : n.routes = [], n.token_in = e.tokenIn ? Coin.toAmino(e.tokenIn) : void 0, n.token_out_min_amount = e.tokenOutMinAmount, n;
  },
  fromAminoMsg(e) {
    return MsgSwapExactAmountIn.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/swap-exact-amount-in",
      value: MsgSwapExactAmountIn.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSwapExactAmountIn.decode(e.value);
  },
  toProto(e) {
    return MsgSwapExactAmountIn.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
      value: MsgSwapExactAmountIn.encode(e).finish()
    };
  }
};
function createBaseMsgSwapExactAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}
const MsgSwapExactAmountInResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountInResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenOutAmount !== "" && n.uint32(10).string(e.tokenOutAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSwapExactAmountInResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenOutAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSwapExactAmountInResponse();
    return o.tokenOutAmount = (n = e.tokenOutAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenOutAmount: e.token_out_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_out_amount = e.tokenOutAmount, n;
  },
  fromAminoMsg(e) {
    return MsgSwapExactAmountInResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/swap-exact-amount-in-response",
      value: MsgSwapExactAmountInResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSwapExactAmountInResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSwapExactAmountInResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountInResponse",
      value: MsgSwapExactAmountInResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSwapExactAmountOut() {
  return {
    sender: "",
    routes: [],
    tokenInMaxAmount: "",
    tokenOut: void 0
  };
}
const MsgSwapExactAmountOut = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender);
    for (const o of e.routes)
      SwapAmountOutRoute.encode(o, n.uint32(18).fork()).ldelim();
    return e.tokenInMaxAmount !== "" && n.uint32(26).string(e.tokenInMaxAmount), e.tokenOut !== void 0 && Coin.encode(e.tokenOut, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSwapExactAmountOut();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.routes.push(SwapAmountOutRoute.decode(o, o.uint32()));
          break;
        case 3:
          c.tokenInMaxAmount = o.string();
          break;
        case 4:
          c.tokenOut = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgSwapExactAmountOut();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.routes = ((o = e.routes) === null || o === void 0 ? void 0 : o.map((d) => SwapAmountOutRoute.fromPartial(d))) || [], c.tokenInMaxAmount = (u = e.tokenInMaxAmount) !== null && u !== void 0 ? u : "", c.tokenOut = e.tokenOut !== void 0 && e.tokenOut !== null ? Coin.fromPartial(e.tokenOut) : void 0, c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => SwapAmountOutRoute.fromAmino(n)) : [],
      tokenInMaxAmount: e.token_in_max_amount,
      tokenOut: e != null && e.token_out ? Coin.fromAmino(e.token_out) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, e.routes ? n.routes = e.routes.map((o) => o ? SwapAmountOutRoute.toAmino(o) : void 0) : n.routes = [], n.token_in_max_amount = e.tokenInMaxAmount, n.token_out = e.tokenOut ? Coin.toAmino(e.tokenOut) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSwapExactAmountOut.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/swap-exact-amount-out",
      value: MsgSwapExactAmountOut.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSwapExactAmountOut.decode(e.value);
  },
  toProto(e) {
    return MsgSwapExactAmountOut.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
      value: MsgSwapExactAmountOut.encode(e).finish()
    };
  }
};
function createBaseMsgSwapExactAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}
const MsgSwapExactAmountOutResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOutResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.tokenInAmount !== "" && n.uint32(10).string(e.tokenInAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSwapExactAmountOutResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.tokenInAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSwapExactAmountOutResponse();
    return o.tokenInAmount = (n = e.tokenInAmount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      tokenInAmount: e.token_in_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.token_in_amount = e.tokenInAmount, n;
  },
  fromAminoMsg(e) {
    return MsgSwapExactAmountOutResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/poolmanager/swap-exact-amount-out-response",
      value: MsgSwapExactAmountOutResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSwapExactAmountOutResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSwapExactAmountOutResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOutResponse",
      value: MsgSwapExactAmountOutResponse.encode(e).finish()
    };
  }
}, _152 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgSwapExactAmountIn,
  MsgSwapExactAmountInResponse,
  MsgSwapExactAmountOut,
  MsgSwapExactAmountOutResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$3() {
  return {
    enabled: !1,
    admin: ""
  };
}
const Params$3 = {
  typeUrl: "/osmosis.protorev.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.enabled === !0 && n.uint32(8).bool(e.enabled), e.admin !== "" && n.uint32(18).string(e.admin), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.enabled = o.bool();
          break;
        case 2:
          c.admin = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseParams$3();
    return u.enabled = (n = e.enabled) !== null && n !== void 0 ? n : !1, u.admin = (o = e.admin) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      enabled: e.enabled,
      admin: e.admin
    };
  },
  toAmino(e) {
    const n = {};
    return n.enabled = e.enabled, n.admin = e.admin, n;
  },
  fromAminoMsg(e) {
    return Params$3.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/params",
      value: Params$3.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$3.decode(e.value);
  },
  toProto(e) {
    return Params$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.Params",
      value: Params$3.encode(e).finish()
    };
  }
}, _155 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$3
}, Symbol.toStringTag, { value: "Module" }));
function createBaseTokenPairArbRoutes() {
  return {
    arbRoutes: [],
    tokenIn: "",
    tokenOut: ""
  };
}
const TokenPairArbRoutes = {
  typeUrl: "/osmosis.protorev.v1beta1.TokenPairArbRoutes",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.arbRoutes)
      Route.encode(o, n.uint32(10).fork()).ldelim();
    return e.tokenIn !== "" && n.uint32(18).string(e.tokenIn), e.tokenOut !== "" && n.uint32(26).string(e.tokenOut), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTokenPairArbRoutes();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.arbRoutes.push(Route.decode(o, o.uint32()));
          break;
        case 2:
          c.tokenIn = o.string();
          break;
        case 3:
          c.tokenOut = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseTokenPairArbRoutes();
    return c.arbRoutes = ((n = e.arbRoutes) === null || n === void 0 ? void 0 : n.map((d) => Route.fromPartial(d))) || [], c.tokenIn = (o = e.tokenIn) !== null && o !== void 0 ? o : "", c.tokenOut = (u = e.tokenOut) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      arbRoutes: Array.isArray(e == null ? void 0 : e.arb_routes) ? e.arb_routes.map((n) => Route.fromAmino(n)) : [],
      tokenIn: e.token_in,
      tokenOut: e.token_out
    };
  },
  toAmino(e) {
    const n = {};
    return e.arbRoutes ? n.arb_routes = e.arbRoutes.map((o) => o ? Route.toAmino(o) : void 0) : n.arb_routes = [], n.token_in = e.tokenIn, n.token_out = e.tokenOut, n;
  },
  fromAminoMsg(e) {
    return TokenPairArbRoutes.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/token-pair-arb-routes",
      value: TokenPairArbRoutes.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TokenPairArbRoutes.decode(e.value);
  },
  toProto(e) {
    return TokenPairArbRoutes.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.TokenPairArbRoutes",
      value: TokenPairArbRoutes.encode(e).finish()
    };
  }
};
function createBaseRoute() {
  return {
    trades: [],
    stepSize: ""
  };
}
const Route = {
  typeUrl: "/osmosis.protorev.v1beta1.Route",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.trades)
      Trade.encode(o, n.uint32(10).fork()).ldelim();
    return e.stepSize !== "" && n.uint32(18).string(e.stepSize), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRoute();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.trades.push(Trade.decode(o, o.uint32()));
          break;
        case 2:
          c.stepSize = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseRoute();
    return u.trades = ((n = e.trades) === null || n === void 0 ? void 0 : n.map((c) => Trade.fromPartial(c))) || [], u.stepSize = (o = e.stepSize) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      trades: Array.isArray(e == null ? void 0 : e.trades) ? e.trades.map((n) => Trade.fromAmino(n)) : [],
      stepSize: e.step_size
    };
  },
  toAmino(e) {
    const n = {};
    return e.trades ? n.trades = e.trades.map((o) => o ? Trade.toAmino(o) : void 0) : n.trades = [], n.step_size = e.stepSize, n;
  },
  fromAminoMsg(e) {
    return Route.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/route",
      value: Route.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Route.decode(e.value);
  },
  toProto(e) {
    return Route.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.Route",
      value: Route.encode(e).finish()
    };
  }
};
function createBaseTrade() {
  return {
    pool: Long$2.UZERO,
    tokenIn: "",
    tokenOut: ""
  };
}
const Trade = {
  typeUrl: "/osmosis.protorev.v1beta1.Trade",
  encode(e, n = minimal.Writer.create()) {
    return e.pool.isZero() || n.uint32(8).uint64(e.pool), e.tokenIn !== "" && n.uint32(18).string(e.tokenIn), e.tokenOut !== "" && n.uint32(26).string(e.tokenOut), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTrade();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pool = o.uint64();
          break;
        case 2:
          c.tokenIn = o.string();
          break;
        case 3:
          c.tokenOut = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseTrade();
    return u.pool = e.pool !== void 0 && e.pool !== null ? Long$2.fromValue(e.pool) : Long$2.UZERO, u.tokenIn = (n = e.tokenIn) !== null && n !== void 0 ? n : "", u.tokenOut = (o = e.tokenOut) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      pool: Long$2.fromString(e.pool),
      tokenIn: e.token_in,
      tokenOut: e.token_out
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool = e.pool ? e.pool.toString() : void 0, n.token_in = e.tokenIn, n.token_out = e.tokenOut, n;
  },
  fromAminoMsg(e) {
    return Trade.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/trade",
      value: Trade.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Trade.decode(e.value);
  },
  toProto(e) {
    return Trade.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.Trade",
      value: Trade.encode(e).finish()
    };
  }
};
function createBaseRouteStatistics() {
  return {
    profits: [],
    numberOfTrades: "",
    route: []
  };
}
const RouteStatistics = {
  typeUrl: "/osmosis.protorev.v1beta1.RouteStatistics",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.profits)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    e.numberOfTrades !== "" && n.uint32(18).string(e.numberOfTrades), n.uint32(26).fork();
    for (const o of e.route)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseRouteStatistics();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.profits.push(Coin.decode(o, o.uint32()));
          break;
        case 2:
          c.numberOfTrades = o.string();
          break;
        case 3:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.route.push(o.uint64());
          } else
            c.route.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseRouteStatistics();
    return c.profits = ((n = e.profits) === null || n === void 0 ? void 0 : n.map((d) => Coin.fromPartial(d))) || [], c.numberOfTrades = (o = e.numberOfTrades) !== null && o !== void 0 ? o : "", c.route = ((u = e.route) === null || u === void 0 ? void 0 : u.map((d) => Long$2.fromValue(d))) || [], c;
  },
  fromAmino(e) {
    return {
      profits: Array.isArray(e == null ? void 0 : e.profits) ? e.profits.map((n) => Coin.fromAmino(n)) : [],
      numberOfTrades: e.number_of_trades,
      route: Array.isArray(e == null ? void 0 : e.route) ? e.route.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.profits ? n.profits = e.profits.map((o) => o ? Coin.toAmino(o) : void 0) : n.profits = [], n.number_of_trades = e.numberOfTrades, e.route ? n.route = e.route.map((o) => o) : n.route = [], n;
  },
  fromAminoMsg(e) {
    return RouteStatistics.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/route-statistics",
      value: RouteStatistics.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return RouteStatistics.decode(e.value);
  },
  toProto(e) {
    return RouteStatistics.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.RouteStatistics",
      value: RouteStatistics.encode(e).finish()
    };
  }
};
function createBasePoolWeights() {
  return {
    stableWeight: Long$2.UZERO,
    balancerWeight: Long$2.UZERO,
    concentratedWeight: Long$2.UZERO
  };
}
const PoolWeights = {
  typeUrl: "/osmosis.protorev.v1beta1.PoolWeights",
  encode(e, n = minimal.Writer.create()) {
    return e.stableWeight.isZero() || n.uint32(8).uint64(e.stableWeight), e.balancerWeight.isZero() || n.uint32(16).uint64(e.balancerWeight), e.concentratedWeight.isZero() || n.uint32(24).uint64(e.concentratedWeight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBasePoolWeights();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.stableWeight = o.uint64();
          break;
        case 2:
          c.balancerWeight = o.uint64();
          break;
        case 3:
          c.concentratedWeight = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBasePoolWeights();
    return n.stableWeight = e.stableWeight !== void 0 && e.stableWeight !== null ? Long$2.fromValue(e.stableWeight) : Long$2.UZERO, n.balancerWeight = e.balancerWeight !== void 0 && e.balancerWeight !== null ? Long$2.fromValue(e.balancerWeight) : Long$2.UZERO, n.concentratedWeight = e.concentratedWeight !== void 0 && e.concentratedWeight !== null ? Long$2.fromValue(e.concentratedWeight) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      stableWeight: Long$2.fromString(e.stable_weight),
      balancerWeight: Long$2.fromString(e.balancer_weight),
      concentratedWeight: Long$2.fromString(e.concentrated_weight)
    };
  },
  toAmino(e) {
    const n = {};
    return n.stable_weight = e.stableWeight ? e.stableWeight.toString() : void 0, n.balancer_weight = e.balancerWeight ? e.balancerWeight.toString() : void 0, n.concentrated_weight = e.concentratedWeight ? e.concentratedWeight.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return PoolWeights.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/pool-weights",
      value: PoolWeights.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return PoolWeights.decode(e.value);
  },
  toProto(e) {
    return PoolWeights.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.PoolWeights",
      value: PoolWeights.encode(e).finish()
    };
  }
};
function createBaseBaseDenom() {
  return {
    denom: "",
    stepSize: ""
  };
}
const BaseDenom = {
  typeUrl: "/osmosis.protorev.v1beta1.BaseDenom",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.stepSize !== "" && n.uint32(18).string(e.stepSize), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBaseDenom();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.stepSize = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseBaseDenom();
    return u.denom = (n = e.denom) !== null && n !== void 0 ? n : "", u.stepSize = (o = e.stepSize) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      stepSize: e.step_size
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.step_size = e.stepSize, n;
  },
  fromAminoMsg(e) {
    return BaseDenom.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/base-denom",
      value: BaseDenom.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return BaseDenom.decode(e.value);
  },
  toProto(e) {
    return BaseDenom.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.BaseDenom",
      value: BaseDenom.encode(e).finish()
    };
  }
}, _156 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseDenom,
  PoolWeights,
  Route,
  RouteStatistics,
  TokenPairArbRoutes,
  Trade
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$4() {
  return {
    params: void 0,
    tokenPairArbRoutes: [],
    baseDenoms: [],
    poolWeights: void 0,
    daysSinceModuleGenesis: Long$2.UZERO,
    developerFees: [],
    latestBlockHeight: Long$2.UZERO,
    developerAddress: "",
    maxPoolPointsPerBlock: Long$2.UZERO,
    maxPoolPointsPerTx: Long$2.UZERO,
    pointCountForBlock: Long$2.UZERO
  };
}
const GenesisState$4 = {
  typeUrl: "/osmosis.protorev.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$3.encode(e.params, n.uint32(10).fork()).ldelim();
    for (const o of e.tokenPairArbRoutes)
      TokenPairArbRoutes.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.baseDenoms)
      BaseDenom.encode(o, n.uint32(26).fork()).ldelim();
    e.poolWeights !== void 0 && PoolWeights.encode(e.poolWeights, n.uint32(34).fork()).ldelim(), e.daysSinceModuleGenesis.isZero() || n.uint32(40).uint64(e.daysSinceModuleGenesis);
    for (const o of e.developerFees)
      Coin.encode(o, n.uint32(50).fork()).ldelim();
    return e.latestBlockHeight.isZero() || n.uint32(56).uint64(e.latestBlockHeight), e.developerAddress !== "" && n.uint32(66).string(e.developerAddress), e.maxPoolPointsPerBlock.isZero() || n.uint32(72).uint64(e.maxPoolPointsPerBlock), e.maxPoolPointsPerTx.isZero() || n.uint32(80).uint64(e.maxPoolPointsPerTx), e.pointCountForBlock.isZero() || n.uint32(88).uint64(e.pointCountForBlock), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$4();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$3.decode(o, o.uint32());
          break;
        case 2:
          c.tokenPairArbRoutes.push(TokenPairArbRoutes.decode(o, o.uint32()));
          break;
        case 3:
          c.baseDenoms.push(BaseDenom.decode(o, o.uint32()));
          break;
        case 4:
          c.poolWeights = PoolWeights.decode(o, o.uint32());
          break;
        case 5:
          c.daysSinceModuleGenesis = o.uint64();
          break;
        case 6:
          c.developerFees.push(Coin.decode(o, o.uint32()));
          break;
        case 7:
          c.latestBlockHeight = o.uint64();
          break;
        case 8:
          c.developerAddress = o.string();
          break;
        case 9:
          c.maxPoolPointsPerBlock = o.uint64();
          break;
        case 10:
          c.maxPoolPointsPerTx = o.uint64();
          break;
        case 11:
          c.pointCountForBlock = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseGenesisState$4();
    return d.params = e.params !== void 0 && e.params !== null ? Params$3.fromPartial(e.params) : void 0, d.tokenPairArbRoutes = ((n = e.tokenPairArbRoutes) === null || n === void 0 ? void 0 : n.map((m) => TokenPairArbRoutes.fromPartial(m))) || [], d.baseDenoms = ((o = e.baseDenoms) === null || o === void 0 ? void 0 : o.map((m) => BaseDenom.fromPartial(m))) || [], d.poolWeights = e.poolWeights !== void 0 && e.poolWeights !== null ? PoolWeights.fromPartial(e.poolWeights) : void 0, d.daysSinceModuleGenesis = e.daysSinceModuleGenesis !== void 0 && e.daysSinceModuleGenesis !== null ? Long$2.fromValue(e.daysSinceModuleGenesis) : Long$2.UZERO, d.developerFees = ((u = e.developerFees) === null || u === void 0 ? void 0 : u.map((m) => Coin.fromPartial(m))) || [], d.latestBlockHeight = e.latestBlockHeight !== void 0 && e.latestBlockHeight !== null ? Long$2.fromValue(e.latestBlockHeight) : Long$2.UZERO, d.developerAddress = (c = e.developerAddress) !== null && c !== void 0 ? c : "", d.maxPoolPointsPerBlock = e.maxPoolPointsPerBlock !== void 0 && e.maxPoolPointsPerBlock !== null ? Long$2.fromValue(e.maxPoolPointsPerBlock) : Long$2.UZERO, d.maxPoolPointsPerTx = e.maxPoolPointsPerTx !== void 0 && e.maxPoolPointsPerTx !== null ? Long$2.fromValue(e.maxPoolPointsPerTx) : Long$2.UZERO, d.pointCountForBlock = e.pointCountForBlock !== void 0 && e.pointCountForBlock !== null ? Long$2.fromValue(e.pointCountForBlock) : Long$2.UZERO, d;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$3.fromAmino(e.params) : void 0,
      tokenPairArbRoutes: Array.isArray(e == null ? void 0 : e.token_pair_arb_routes) ? e.token_pair_arb_routes.map((n) => TokenPairArbRoutes.fromAmino(n)) : [],
      baseDenoms: Array.isArray(e == null ? void 0 : e.base_denoms) ? e.base_denoms.map((n) => BaseDenom.fromAmino(n)) : [],
      poolWeights: e != null && e.pool_weights ? PoolWeights.fromAmino(e.pool_weights) : void 0,
      daysSinceModuleGenesis: Long$2.fromString(e.days_since_module_genesis),
      developerFees: Array.isArray(e == null ? void 0 : e.developer_fees) ? e.developer_fees.map((n) => Coin.fromAmino(n)) : [],
      latestBlockHeight: Long$2.fromString(e.latest_block_height),
      developerAddress: e.developer_address,
      maxPoolPointsPerBlock: Long$2.fromString(e.max_pool_points_per_block),
      maxPoolPointsPerTx: Long$2.fromString(e.max_pool_points_per_tx),
      pointCountForBlock: Long$2.fromString(e.point_count_for_block)
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$3.toAmino(e.params) : void 0, e.tokenPairArbRoutes ? n.token_pair_arb_routes = e.tokenPairArbRoutes.map((o) => o ? TokenPairArbRoutes.toAmino(o) : void 0) : n.token_pair_arb_routes = [], e.baseDenoms ? n.base_denoms = e.baseDenoms.map((o) => o ? BaseDenom.toAmino(o) : void 0) : n.base_denoms = [], n.pool_weights = e.poolWeights ? PoolWeights.toAmino(e.poolWeights) : void 0, n.days_since_module_genesis = e.daysSinceModuleGenesis ? e.daysSinceModuleGenesis.toString() : void 0, e.developerFees ? n.developer_fees = e.developerFees.map((o) => o ? Coin.toAmino(o) : void 0) : n.developer_fees = [], n.latest_block_height = e.latestBlockHeight ? e.latestBlockHeight.toString() : void 0, n.developer_address = e.developerAddress, n.max_pool_points_per_block = e.maxPoolPointsPerBlock ? e.maxPoolPointsPerBlock.toString() : void 0, n.max_pool_points_per_tx = e.maxPoolPointsPerTx ? e.maxPoolPointsPerTx.toString() : void 0, n.point_count_for_block = e.pointCountForBlock ? e.pointCountForBlock.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$4.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/genesis-state",
      value: GenesisState$4.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$4.decode(e.value);
  },
  toProto(e) {
    return GenesisState$4.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.GenesisState",
      value: GenesisState$4.encode(e).finish()
    };
  }
}, _153 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$4
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryParamsRequest$2() {
  return {};
}
const QueryParamsRequest$2 = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$2();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-params-request",
      value: QueryParamsRequest$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$2.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest$2.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$2() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$2 = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$3.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$3.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$2();
    return n.params = e.params !== void 0 && e.params !== null ? Params$3.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$3.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$3.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-params-response",
      value: QueryParamsResponse$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$2.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse$2.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevNumberOfTradesRequest() {
  return {};
}
const QueryGetProtoRevNumberOfTradesRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevNumberOfTradesRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevNumberOfTradesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevNumberOfTradesRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevNumberOfTradesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-number-of-trades-request",
      value: QueryGetProtoRevNumberOfTradesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevNumberOfTradesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevNumberOfTradesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevNumberOfTradesRequest",
      value: QueryGetProtoRevNumberOfTradesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevNumberOfTradesResponse() {
  return {
    numberOfTrades: ""
  };
}
const QueryGetProtoRevNumberOfTradesResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevNumberOfTradesResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.numberOfTrades !== "" && n.uint32(10).string(e.numberOfTrades), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevNumberOfTradesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.numberOfTrades = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevNumberOfTradesResponse();
    return o.numberOfTrades = (n = e.numberOfTrades) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      numberOfTrades: e.number_of_trades
    };
  },
  toAmino(e) {
    const n = {};
    return n.number_of_trades = e.numberOfTrades, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevNumberOfTradesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-number-of-trades-response",
      value: QueryGetProtoRevNumberOfTradesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevNumberOfTradesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevNumberOfTradesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevNumberOfTradesResponse",
      value: QueryGetProtoRevNumberOfTradesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevProfitsByDenomRequest() {
  return {
    denom: ""
  };
}
const QueryGetProtoRevProfitsByDenomRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevProfitsByDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevProfitsByDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevProfitsByDenomRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevProfitsByDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-profits-by-denom-request",
      value: QueryGetProtoRevProfitsByDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevProfitsByDenomRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevProfitsByDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevProfitsByDenomRequest",
      value: QueryGetProtoRevProfitsByDenomRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevProfitsByDenomResponse() {
  return {
    profit: void 0
  };
}
const QueryGetProtoRevProfitsByDenomResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevProfitsByDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.profit !== void 0 && Coin.encode(e.profit, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevProfitsByDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.profit = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryGetProtoRevProfitsByDenomResponse();
    return n.profit = e.profit !== void 0 && e.profit !== null ? Coin.fromPartial(e.profit) : void 0, n;
  },
  fromAmino(e) {
    return {
      profit: e != null && e.profit ? Coin.fromAmino(e.profit) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.profit = e.profit ? Coin.toAmino(e.profit) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevProfitsByDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-profits-by-denom-response",
      value: QueryGetProtoRevProfitsByDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevProfitsByDenomResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevProfitsByDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevProfitsByDenomResponse",
      value: QueryGetProtoRevProfitsByDenomResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevAllProfitsRequest() {
  return {};
}
const QueryGetProtoRevAllProfitsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllProfitsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevAllProfitsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevAllProfitsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevAllProfitsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-all-profits-request",
      value: QueryGetProtoRevAllProfitsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevAllProfitsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevAllProfitsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllProfitsRequest",
      value: QueryGetProtoRevAllProfitsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevAllProfitsResponse() {
  return {
    profits: []
  };
}
const QueryGetProtoRevAllProfitsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllProfitsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.profits)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevAllProfitsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.profits.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevAllProfitsResponse();
    return o.profits = ((n = e.profits) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      profits: Array.isArray(e == null ? void 0 : e.profits) ? e.profits.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.profits ? n.profits = e.profits.map((o) => o ? Coin.toAmino(o) : void 0) : n.profits = [], n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevAllProfitsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-all-profits-response",
      value: QueryGetProtoRevAllProfitsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevAllProfitsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevAllProfitsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllProfitsResponse",
      value: QueryGetProtoRevAllProfitsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevStatisticsByRouteRequest() {
  return {
    route: []
  };
}
const QueryGetProtoRevStatisticsByRouteRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevStatisticsByRouteRequest",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.route)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevStatisticsByRouteRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.route.push(o.uint64());
          } else
            c.route.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevStatisticsByRouteRequest();
    return o.route = ((n = e.route) === null || n === void 0 ? void 0 : n.map((u) => Long$2.fromValue(u))) || [], o;
  },
  fromAmino(e) {
    return {
      route: Array.isArray(e == null ? void 0 : e.route) ? e.route.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.route ? n.route = e.route.map((o) => o) : n.route = [], n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevStatisticsByRouteRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-statistics-by-route-request",
      value: QueryGetProtoRevStatisticsByRouteRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevStatisticsByRouteRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevStatisticsByRouteRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevStatisticsByRouteRequest",
      value: QueryGetProtoRevStatisticsByRouteRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevStatisticsByRouteResponse() {
  return {
    statistics: void 0
  };
}
const QueryGetProtoRevStatisticsByRouteResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevStatisticsByRouteResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.statistics !== void 0 && RouteStatistics.encode(e.statistics, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevStatisticsByRouteResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.statistics = RouteStatistics.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryGetProtoRevStatisticsByRouteResponse();
    return n.statistics = e.statistics !== void 0 && e.statistics !== null ? RouteStatistics.fromPartial(e.statistics) : void 0, n;
  },
  fromAmino(e) {
    return {
      statistics: e != null && e.statistics ? RouteStatistics.fromAmino(e.statistics) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.statistics = e.statistics ? RouteStatistics.toAmino(e.statistics) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevStatisticsByRouteResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-statistics-by-route-response",
      value: QueryGetProtoRevStatisticsByRouteResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevStatisticsByRouteResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevStatisticsByRouteResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevStatisticsByRouteResponse",
      value: QueryGetProtoRevStatisticsByRouteResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevAllRouteStatisticsRequest() {
  return {};
}
const QueryGetProtoRevAllRouteStatisticsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllRouteStatisticsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevAllRouteStatisticsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevAllRouteStatisticsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevAllRouteStatisticsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-all-route-statistics-request",
      value: QueryGetProtoRevAllRouteStatisticsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevAllRouteStatisticsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevAllRouteStatisticsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllRouteStatisticsRequest",
      value: QueryGetProtoRevAllRouteStatisticsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevAllRouteStatisticsResponse() {
  return {
    statistics: []
  };
}
const QueryGetProtoRevAllRouteStatisticsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllRouteStatisticsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.statistics)
      RouteStatistics.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevAllRouteStatisticsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.statistics.push(RouteStatistics.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevAllRouteStatisticsResponse();
    return o.statistics = ((n = e.statistics) === null || n === void 0 ? void 0 : n.map((u) => RouteStatistics.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      statistics: Array.isArray(e == null ? void 0 : e.statistics) ? e.statistics.map((n) => RouteStatistics.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.statistics ? n.statistics = e.statistics.map((o) => o ? RouteStatistics.toAmino(o) : void 0) : n.statistics = [], n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevAllRouteStatisticsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-all-route-statistics-response",
      value: QueryGetProtoRevAllRouteStatisticsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevAllRouteStatisticsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevAllRouteStatisticsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllRouteStatisticsResponse",
      value: QueryGetProtoRevAllRouteStatisticsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevTokenPairArbRoutesRequest() {
  return {};
}
const QueryGetProtoRevTokenPairArbRoutesRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevTokenPairArbRoutesRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevTokenPairArbRoutesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevTokenPairArbRoutesRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevTokenPairArbRoutesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-token-pair-arb-routes-request",
      value: QueryGetProtoRevTokenPairArbRoutesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevTokenPairArbRoutesRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevTokenPairArbRoutesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevTokenPairArbRoutesRequest",
      value: QueryGetProtoRevTokenPairArbRoutesRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevTokenPairArbRoutesResponse() {
  return {
    routes: []
  };
}
const QueryGetProtoRevTokenPairArbRoutesResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevTokenPairArbRoutesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.routes)
      TokenPairArbRoutes.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevTokenPairArbRoutesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.routes.push(TokenPairArbRoutes.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevTokenPairArbRoutesResponse();
    return o.routes = ((n = e.routes) === null || n === void 0 ? void 0 : n.map((u) => TokenPairArbRoutes.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      routes: Array.isArray(e == null ? void 0 : e.routes) ? e.routes.map((n) => TokenPairArbRoutes.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.routes ? n.routes = e.routes.map((o) => o ? TokenPairArbRoutes.toAmino(o) : void 0) : n.routes = [], n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevTokenPairArbRoutesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-token-pair-arb-routes-response",
      value: QueryGetProtoRevTokenPairArbRoutesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevTokenPairArbRoutesResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevTokenPairArbRoutesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevTokenPairArbRoutesResponse",
      value: QueryGetProtoRevTokenPairArbRoutesResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevAdminAccountRequest() {
  return {};
}
const QueryGetProtoRevAdminAccountRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAdminAccountRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevAdminAccountRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevAdminAccountRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevAdminAccountRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-admin-account-request",
      value: QueryGetProtoRevAdminAccountRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevAdminAccountRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevAdminAccountRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAdminAccountRequest",
      value: QueryGetProtoRevAdminAccountRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevAdminAccountResponse() {
  return {
    adminAccount: ""
  };
}
const QueryGetProtoRevAdminAccountResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAdminAccountResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.adminAccount !== "" && n.uint32(10).string(e.adminAccount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevAdminAccountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.adminAccount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevAdminAccountResponse();
    return o.adminAccount = (n = e.adminAccount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      adminAccount: e.admin_account
    };
  },
  toAmino(e) {
    const n = {};
    return n.admin_account = e.adminAccount, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevAdminAccountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-admin-account-response",
      value: QueryGetProtoRevAdminAccountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevAdminAccountResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevAdminAccountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAdminAccountResponse",
      value: QueryGetProtoRevAdminAccountResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevDeveloperAccountRequest() {
  return {};
}
const QueryGetProtoRevDeveloperAccountRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevDeveloperAccountRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevDeveloperAccountRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevDeveloperAccountRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevDeveloperAccountRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-developer-account-request",
      value: QueryGetProtoRevDeveloperAccountRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevDeveloperAccountRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevDeveloperAccountRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevDeveloperAccountRequest",
      value: QueryGetProtoRevDeveloperAccountRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevDeveloperAccountResponse() {
  return {
    developerAccount: ""
  };
}
const QueryGetProtoRevDeveloperAccountResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevDeveloperAccountResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.developerAccount !== "" && n.uint32(10).string(e.developerAccount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevDeveloperAccountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.developerAccount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevDeveloperAccountResponse();
    return o.developerAccount = (n = e.developerAccount) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      developerAccount: e.developer_account
    };
  },
  toAmino(e) {
    const n = {};
    return n.developer_account = e.developerAccount, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevDeveloperAccountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-developer-account-response",
      value: QueryGetProtoRevDeveloperAccountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevDeveloperAccountResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevDeveloperAccountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevDeveloperAccountResponse",
      value: QueryGetProtoRevDeveloperAccountResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevPoolWeightsRequest() {
  return {};
}
const QueryGetProtoRevPoolWeightsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolWeightsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevPoolWeightsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevPoolWeightsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevPoolWeightsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-pool-weights-request",
      value: QueryGetProtoRevPoolWeightsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevPoolWeightsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevPoolWeightsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolWeightsRequest",
      value: QueryGetProtoRevPoolWeightsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevPoolWeightsResponse() {
  return {
    poolWeights: void 0
  };
}
const QueryGetProtoRevPoolWeightsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolWeightsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.poolWeights !== void 0 && PoolWeights.encode(e.poolWeights, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevPoolWeightsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolWeights = PoolWeights.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryGetProtoRevPoolWeightsResponse();
    return n.poolWeights = e.poolWeights !== void 0 && e.poolWeights !== null ? PoolWeights.fromPartial(e.poolWeights) : void 0, n;
  },
  fromAmino(e) {
    return {
      poolWeights: e != null && e.pool_weights ? PoolWeights.fromAmino(e.pool_weights) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_weights = e.poolWeights ? PoolWeights.toAmino(e.poolWeights) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevPoolWeightsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-pool-weights-response",
      value: QueryGetProtoRevPoolWeightsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevPoolWeightsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevPoolWeightsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolWeightsResponse",
      value: QueryGetProtoRevPoolWeightsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevMaxPoolPointsPerBlockRequest() {
  return {};
}
const QueryGetProtoRevMaxPoolPointsPerBlockRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerBlockRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevMaxPoolPointsPerBlockRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevMaxPoolPointsPerBlockRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevMaxPoolPointsPerBlockRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-max-pool-points-per-block-request",
      value: QueryGetProtoRevMaxPoolPointsPerBlockRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevMaxPoolPointsPerBlockRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevMaxPoolPointsPerBlockRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerBlockRequest",
      value: QueryGetProtoRevMaxPoolPointsPerBlockRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevMaxPoolPointsPerBlockResponse() {
  return {
    maxPoolPointsPerBlock: Long$2.UZERO
  };
}
const QueryGetProtoRevMaxPoolPointsPerBlockResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerBlockResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.maxPoolPointsPerBlock.isZero() || n.uint32(8).uint64(e.maxPoolPointsPerBlock), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevMaxPoolPointsPerBlockResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.maxPoolPointsPerBlock = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryGetProtoRevMaxPoolPointsPerBlockResponse();
    return n.maxPoolPointsPerBlock = e.maxPoolPointsPerBlock !== void 0 && e.maxPoolPointsPerBlock !== null ? Long$2.fromValue(e.maxPoolPointsPerBlock) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      maxPoolPointsPerBlock: Long$2.fromString(e.max_pool_points_per_block)
    };
  },
  toAmino(e) {
    const n = {};
    return n.max_pool_points_per_block = e.maxPoolPointsPerBlock ? e.maxPoolPointsPerBlock.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevMaxPoolPointsPerBlockResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-max-pool-points-per-block-response",
      value: QueryGetProtoRevMaxPoolPointsPerBlockResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevMaxPoolPointsPerBlockResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevMaxPoolPointsPerBlockResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerBlockResponse",
      value: QueryGetProtoRevMaxPoolPointsPerBlockResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevMaxPoolPointsPerTxRequest() {
  return {};
}
const QueryGetProtoRevMaxPoolPointsPerTxRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerTxRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevMaxPoolPointsPerTxRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevMaxPoolPointsPerTxRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevMaxPoolPointsPerTxRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-max-pool-points-per-tx-request",
      value: QueryGetProtoRevMaxPoolPointsPerTxRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevMaxPoolPointsPerTxRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevMaxPoolPointsPerTxRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerTxRequest",
      value: QueryGetProtoRevMaxPoolPointsPerTxRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevMaxPoolPointsPerTxResponse() {
  return {
    maxPoolPointsPerTx: Long$2.UZERO
  };
}
const QueryGetProtoRevMaxPoolPointsPerTxResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerTxResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.maxPoolPointsPerTx.isZero() || n.uint32(8).uint64(e.maxPoolPointsPerTx), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevMaxPoolPointsPerTxResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.maxPoolPointsPerTx = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryGetProtoRevMaxPoolPointsPerTxResponse();
    return n.maxPoolPointsPerTx = e.maxPoolPointsPerTx !== void 0 && e.maxPoolPointsPerTx !== null ? Long$2.fromValue(e.maxPoolPointsPerTx) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      maxPoolPointsPerTx: Long$2.fromString(e.max_pool_points_per_tx)
    };
  },
  toAmino(e) {
    const n = {};
    return n.max_pool_points_per_tx = e.maxPoolPointsPerTx ? e.maxPoolPointsPerTx.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevMaxPoolPointsPerTxResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-max-pool-points-per-tx-response",
      value: QueryGetProtoRevMaxPoolPointsPerTxResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevMaxPoolPointsPerTxResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevMaxPoolPointsPerTxResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerTxResponse",
      value: QueryGetProtoRevMaxPoolPointsPerTxResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevBaseDenomsRequest() {
  return {};
}
const QueryGetProtoRevBaseDenomsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevBaseDenomsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevBaseDenomsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevBaseDenomsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevBaseDenomsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-base-denoms-request",
      value: QueryGetProtoRevBaseDenomsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevBaseDenomsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevBaseDenomsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevBaseDenomsRequest",
      value: QueryGetProtoRevBaseDenomsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevBaseDenomsResponse() {
  return {
    baseDenoms: []
  };
}
const QueryGetProtoRevBaseDenomsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevBaseDenomsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.baseDenoms)
      BaseDenom.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevBaseDenomsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.baseDenoms.push(BaseDenom.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevBaseDenomsResponse();
    return o.baseDenoms = ((n = e.baseDenoms) === null || n === void 0 ? void 0 : n.map((u) => BaseDenom.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      baseDenoms: Array.isArray(e == null ? void 0 : e.base_denoms) ? e.base_denoms.map((n) => BaseDenom.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.baseDenoms ? n.base_denoms = e.baseDenoms.map((o) => o ? BaseDenom.toAmino(o) : void 0) : n.base_denoms = [], n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevBaseDenomsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-base-denoms-response",
      value: QueryGetProtoRevBaseDenomsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevBaseDenomsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevBaseDenomsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevBaseDenomsResponse",
      value: QueryGetProtoRevBaseDenomsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevEnabledRequest() {
  return {};
}
const QueryGetProtoRevEnabledRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevEnabledRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevEnabledRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryGetProtoRevEnabledRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevEnabledRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-enabled-request",
      value: QueryGetProtoRevEnabledRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevEnabledRequest.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevEnabledRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevEnabledRequest",
      value: QueryGetProtoRevEnabledRequest.encode(e).finish()
    };
  }
};
function createBaseQueryGetProtoRevEnabledResponse() {
  return {
    enabled: !1
  };
}
const QueryGetProtoRevEnabledResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevEnabledResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.enabled === !0 && n.uint32(8).bool(e.enabled), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryGetProtoRevEnabledResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.enabled = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryGetProtoRevEnabledResponse();
    return o.enabled = (n = e.enabled) !== null && n !== void 0 ? n : !1, o;
  },
  fromAmino(e) {
    return {
      enabled: e.enabled
    };
  },
  toAmino(e) {
    const n = {};
    return n.enabled = e.enabled, n;
  },
  fromAminoMsg(e) {
    return QueryGetProtoRevEnabledResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-enabled-response",
      value: QueryGetProtoRevEnabledResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryGetProtoRevEnabledResponse.decode(e.value);
  },
  toProto(e) {
    return QueryGetProtoRevEnabledResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevEnabledResponse",
      value: QueryGetProtoRevEnabledResponse.encode(e).finish()
    };
  }
}, _157 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryGetProtoRevAdminAccountRequest,
  QueryGetProtoRevAdminAccountResponse,
  QueryGetProtoRevAllProfitsRequest,
  QueryGetProtoRevAllProfitsResponse,
  QueryGetProtoRevAllRouteStatisticsRequest,
  QueryGetProtoRevAllRouteStatisticsResponse,
  QueryGetProtoRevBaseDenomsRequest,
  QueryGetProtoRevBaseDenomsResponse,
  QueryGetProtoRevDeveloperAccountRequest,
  QueryGetProtoRevDeveloperAccountResponse,
  QueryGetProtoRevEnabledRequest,
  QueryGetProtoRevEnabledResponse,
  QueryGetProtoRevMaxPoolPointsPerBlockRequest,
  QueryGetProtoRevMaxPoolPointsPerBlockResponse,
  QueryGetProtoRevMaxPoolPointsPerTxRequest,
  QueryGetProtoRevMaxPoolPointsPerTxResponse,
  QueryGetProtoRevNumberOfTradesRequest,
  QueryGetProtoRevNumberOfTradesResponse,
  QueryGetProtoRevPoolWeightsRequest,
  QueryGetProtoRevPoolWeightsResponse,
  QueryGetProtoRevProfitsByDenomRequest,
  QueryGetProtoRevProfitsByDenomResponse,
  QueryGetProtoRevStatisticsByRouteRequest,
  QueryGetProtoRevStatisticsByRouteResponse,
  QueryGetProtoRevTokenPairArbRoutesRequest,
  QueryGetProtoRevTokenPairArbRoutesResponse,
  QueryParamsRequest: QueryParamsRequest$2,
  QueryParamsResponse: QueryParamsResponse$2
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSetHotRoutes() {
  return {
    admin: "",
    hotRoutes: []
  };
}
const MsgSetHotRoutes = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
  encode(e, n = minimal.Writer.create()) {
    e.admin !== "" && n.uint32(10).string(e.admin);
    for (const o of e.hotRoutes)
      TokenPairArbRoutes.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetHotRoutes();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.admin = o.string();
          break;
        case 2:
          c.hotRoutes.push(TokenPairArbRoutes.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgSetHotRoutes();
    return u.admin = (n = e.admin) !== null && n !== void 0 ? n : "", u.hotRoutes = ((o = e.hotRoutes) === null || o === void 0 ? void 0 : o.map((c) => TokenPairArbRoutes.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      admin: e.admin,
      hotRoutes: Array.isArray(e == null ? void 0 : e.hot_routes) ? e.hot_routes.map((n) => TokenPairArbRoutes.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.admin = e.admin, e.hotRoutes ? n.hot_routes = e.hotRoutes.map((o) => o ? TokenPairArbRoutes.toAmino(o) : void 0) : n.hot_routes = [], n;
  },
  fromAminoMsg(e) {
    return MsgSetHotRoutes.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/MsgSetHotRoutes",
      value: MsgSetHotRoutes.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetHotRoutes.decode(e.value);
  },
  toProto(e) {
    return MsgSetHotRoutes.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
      value: MsgSetHotRoutes.encode(e).finish()
    };
  }
};
function createBaseMsgSetHotRoutesResponse() {
  return {};
}
const MsgSetHotRoutesResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutesResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetHotRoutesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetHotRoutesResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetHotRoutesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-hot-routes-response",
      value: MsgSetHotRoutesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetHotRoutesResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetHotRoutesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutesResponse",
      value: MsgSetHotRoutesResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSetDeveloperAccount() {
  return {
    admin: "",
    developerAccount: ""
  };
}
const MsgSetDeveloperAccount = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
  encode(e, n = minimal.Writer.create()) {
    return e.admin !== "" && n.uint32(10).string(e.admin), e.developerAccount !== "" && n.uint32(18).string(e.developerAccount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetDeveloperAccount();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.admin = o.string();
          break;
        case 2:
          c.developerAccount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgSetDeveloperAccount();
    return u.admin = (n = e.admin) !== null && n !== void 0 ? n : "", u.developerAccount = (o = e.developerAccount) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      admin: e.admin,
      developerAccount: e.developer_account
    };
  },
  toAmino(e) {
    const n = {};
    return n.admin = e.admin, n.developer_account = e.developerAccount, n;
  },
  fromAminoMsg(e) {
    return MsgSetDeveloperAccount.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/MsgSetDeveloperAccount",
      value: MsgSetDeveloperAccount.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetDeveloperAccount.decode(e.value);
  },
  toProto(e) {
    return MsgSetDeveloperAccount.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
      value: MsgSetDeveloperAccount.encode(e).finish()
    };
  }
};
function createBaseMsgSetDeveloperAccountResponse() {
  return {};
}
const MsgSetDeveloperAccountResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccountResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetDeveloperAccountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetDeveloperAccountResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetDeveloperAccountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-developer-account-response",
      value: MsgSetDeveloperAccountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetDeveloperAccountResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetDeveloperAccountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccountResponse",
      value: MsgSetDeveloperAccountResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSetPoolWeights() {
  return {
    admin: "",
    poolWeights: void 0
  };
}
const MsgSetPoolWeights = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
  encode(e, n = minimal.Writer.create()) {
    return e.admin !== "" && n.uint32(10).string(e.admin), e.poolWeights !== void 0 && PoolWeights.encode(e.poolWeights, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetPoolWeights();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.admin = o.string();
          break;
        case 2:
          c.poolWeights = PoolWeights.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSetPoolWeights();
    return o.admin = (n = e.admin) !== null && n !== void 0 ? n : "", o.poolWeights = e.poolWeights !== void 0 && e.poolWeights !== null ? PoolWeights.fromPartial(e.poolWeights) : void 0, o;
  },
  fromAmino(e) {
    return {
      admin: e.admin,
      poolWeights: e != null && e.pool_weights ? PoolWeights.fromAmino(e.pool_weights) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.admin = e.admin, n.pool_weights = e.poolWeights ? PoolWeights.toAmino(e.poolWeights) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSetPoolWeights.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-pool-weights",
      value: MsgSetPoolWeights.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetPoolWeights.decode(e.value);
  },
  toProto(e) {
    return MsgSetPoolWeights.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
      value: MsgSetPoolWeights.encode(e).finish()
    };
  }
};
function createBaseMsgSetPoolWeightsResponse() {
  return {};
}
const MsgSetPoolWeightsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeightsResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetPoolWeightsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetPoolWeightsResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetPoolWeightsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-pool-weights-response",
      value: MsgSetPoolWeightsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetPoolWeightsResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetPoolWeightsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeightsResponse",
      value: MsgSetPoolWeightsResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSetMaxPoolPointsPerTx() {
  return {
    admin: "",
    maxPoolPointsPerTx: Long$2.UZERO
  };
}
const MsgSetMaxPoolPointsPerTx = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
  encode(e, n = minimal.Writer.create()) {
    return e.admin !== "" && n.uint32(10).string(e.admin), e.maxPoolPointsPerTx.isZero() || n.uint32(16).uint64(e.maxPoolPointsPerTx), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetMaxPoolPointsPerTx();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.admin = o.string();
          break;
        case 2:
          c.maxPoolPointsPerTx = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSetMaxPoolPointsPerTx();
    return o.admin = (n = e.admin) !== null && n !== void 0 ? n : "", o.maxPoolPointsPerTx = e.maxPoolPointsPerTx !== void 0 && e.maxPoolPointsPerTx !== null ? Long$2.fromValue(e.maxPoolPointsPerTx) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      admin: e.admin,
      maxPoolPointsPerTx: Long$2.fromString(e.max_pool_points_per_tx)
    };
  },
  toAmino(e) {
    const n = {};
    return n.admin = e.admin, n.max_pool_points_per_tx = e.maxPoolPointsPerTx ? e.maxPoolPointsPerTx.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSetMaxPoolPointsPerTx.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-max-pool-points-per-tx",
      value: MsgSetMaxPoolPointsPerTx.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetMaxPoolPointsPerTx.decode(e.value);
  },
  toProto(e) {
    return MsgSetMaxPoolPointsPerTx.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
      value: MsgSetMaxPoolPointsPerTx.encode(e).finish()
    };
  }
};
function createBaseMsgSetMaxPoolPointsPerTxResponse() {
  return {};
}
const MsgSetMaxPoolPointsPerTxResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTxResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetMaxPoolPointsPerTxResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetMaxPoolPointsPerTxResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetMaxPoolPointsPerTxResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-max-pool-points-per-tx-response",
      value: MsgSetMaxPoolPointsPerTxResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetMaxPoolPointsPerTxResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetMaxPoolPointsPerTxResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTxResponse",
      value: MsgSetMaxPoolPointsPerTxResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSetMaxPoolPointsPerBlock() {
  return {
    admin: "",
    maxPoolPointsPerBlock: Long$2.UZERO
  };
}
const MsgSetMaxPoolPointsPerBlock = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
  encode(e, n = minimal.Writer.create()) {
    return e.admin !== "" && n.uint32(10).string(e.admin), e.maxPoolPointsPerBlock.isZero() || n.uint32(16).uint64(e.maxPoolPointsPerBlock), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetMaxPoolPointsPerBlock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.admin = o.string();
          break;
        case 2:
          c.maxPoolPointsPerBlock = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSetMaxPoolPointsPerBlock();
    return o.admin = (n = e.admin) !== null && n !== void 0 ? n : "", o.maxPoolPointsPerBlock = e.maxPoolPointsPerBlock !== void 0 && e.maxPoolPointsPerBlock !== null ? Long$2.fromValue(e.maxPoolPointsPerBlock) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      admin: e.admin,
      maxPoolPointsPerBlock: Long$2.fromString(e.max_pool_points_per_block)
    };
  },
  toAmino(e) {
    const n = {};
    return n.admin = e.admin, n.max_pool_points_per_block = e.maxPoolPointsPerBlock ? e.maxPoolPointsPerBlock.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSetMaxPoolPointsPerBlock.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-max-pool-points-per-block",
      value: MsgSetMaxPoolPointsPerBlock.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetMaxPoolPointsPerBlock.decode(e.value);
  },
  toProto(e) {
    return MsgSetMaxPoolPointsPerBlock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
      value: MsgSetMaxPoolPointsPerBlock.encode(e).finish()
    };
  }
};
function createBaseMsgSetMaxPoolPointsPerBlockResponse() {
  return {};
}
const MsgSetMaxPoolPointsPerBlockResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlockResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetMaxPoolPointsPerBlockResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetMaxPoolPointsPerBlockResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetMaxPoolPointsPerBlockResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-max-pool-points-per-block-response",
      value: MsgSetMaxPoolPointsPerBlockResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetMaxPoolPointsPerBlockResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetMaxPoolPointsPerBlockResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlockResponse",
      value: MsgSetMaxPoolPointsPerBlockResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSetBaseDenoms() {
  return {
    admin: "",
    baseDenoms: []
  };
}
const MsgSetBaseDenoms = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
  encode(e, n = minimal.Writer.create()) {
    e.admin !== "" && n.uint32(10).string(e.admin);
    for (const o of e.baseDenoms)
      BaseDenom.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetBaseDenoms();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.admin = o.string();
          break;
        case 2:
          c.baseDenoms.push(BaseDenom.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgSetBaseDenoms();
    return u.admin = (n = e.admin) !== null && n !== void 0 ? n : "", u.baseDenoms = ((o = e.baseDenoms) === null || o === void 0 ? void 0 : o.map((c) => BaseDenom.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      admin: e.admin,
      baseDenoms: Array.isArray(e == null ? void 0 : e.base_denoms) ? e.base_denoms.map((n) => BaseDenom.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.admin = e.admin, e.baseDenoms ? n.base_denoms = e.baseDenoms.map((o) => o ? BaseDenom.toAmino(o) : void 0) : n.base_denoms = [], n;
  },
  fromAminoMsg(e) {
    return MsgSetBaseDenoms.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-base-denoms",
      value: MsgSetBaseDenoms.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetBaseDenoms.decode(e.value);
  },
  toProto(e) {
    return MsgSetBaseDenoms.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
      value: MsgSetBaseDenoms.encode(e).finish()
    };
  }
};
function createBaseMsgSetBaseDenomsResponse() {
  return {};
}
const MsgSetBaseDenomsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenomsResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetBaseDenomsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetBaseDenomsResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetBaseDenomsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/protorev/set-base-denoms-response",
      value: MsgSetBaseDenomsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetBaseDenomsResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetBaseDenomsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenomsResponse",
      value: MsgSetBaseDenomsResponse.encode(e).finish()
    };
  }
}, _158 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgSetBaseDenoms,
  MsgSetBaseDenomsResponse,
  MsgSetDeveloperAccount,
  MsgSetDeveloperAccountResponse,
  MsgSetHotRoutes,
  MsgSetHotRoutesResponse,
  MsgSetMaxPoolPointsPerBlock,
  MsgSetMaxPoolPointsPerBlockResponse,
  MsgSetMaxPoolPointsPerTx,
  MsgSetMaxPoolPointsPerTxResponse,
  MsgSetPoolWeights,
  MsgSetPoolWeightsResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseNode() {
  return {
    children: []
  };
}
const Node$1 = {
  typeUrl: "/osmosis.store.v1beta1.Node",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.children)
      Child.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNode();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.children.push(Child.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseNode();
    return o.children = ((n = e.children) === null || n === void 0 ? void 0 : n.map((u) => Child.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      children: Array.isArray(e == null ? void 0 : e.children) ? e.children.map((n) => Child.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.children ? n.children = e.children.map((o) => o ? Child.toAmino(o) : void 0) : n.children = [], n;
  },
  fromAminoMsg(e) {
    return Node$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/store/node",
      value: Node$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Node$1.decode(e.value);
  },
  toProto(e) {
    return Node$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.store.v1beta1.Node",
      value: Node$1.encode(e).finish()
    };
  }
};
function createBaseChild() {
  return {
    index: new Uint8Array(),
    accumulation: ""
  };
}
const Child = {
  typeUrl: "/osmosis.store.v1beta1.Child",
  encode(e, n = minimal.Writer.create()) {
    return e.index.length !== 0 && n.uint32(10).bytes(e.index), e.accumulation !== "" && n.uint32(18).string(e.accumulation), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseChild();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.index = o.bytes();
          break;
        case 2:
          c.accumulation = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseChild();
    return u.index = (n = e.index) !== null && n !== void 0 ? n : new Uint8Array(), u.accumulation = (o = e.accumulation) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      index: e.index,
      accumulation: e.accumulation
    };
  },
  toAmino(e) {
    const n = {};
    return n.index = e.index, n.accumulation = e.accumulation, n;
  },
  fromAminoMsg(e) {
    return Child.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/store/child",
      value: Child.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Child.decode(e.value);
  },
  toProto(e) {
    return Child.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.store.v1beta1.Child",
      value: Child.encode(e).finish()
    };
  }
};
function createBaseLeaf() {
  return {
    leaf: void 0
  };
}
const Leaf = {
  typeUrl: "/osmosis.store.v1beta1.Leaf",
  encode(e, n = minimal.Writer.create()) {
    return e.leaf !== void 0 && Child.encode(e.leaf, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLeaf();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.leaf = Child.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseLeaf();
    return n.leaf = e.leaf !== void 0 && e.leaf !== null ? Child.fromPartial(e.leaf) : void 0, n;
  },
  fromAmino(e) {
    return {
      leaf: e != null && e.leaf ? Child.fromAmino(e.leaf) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.leaf = e.leaf ? Child.toAmino(e.leaf) : void 0, n;
  },
  fromAminoMsg(e) {
    return Leaf.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/store/leaf",
      value: Leaf.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Leaf.decode(e.value);
  },
  toProto(e) {
    return Leaf.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.store.v1beta1.Leaf",
      value: Leaf.encode(e).finish()
    };
  }
}, _159 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Child,
  Leaf,
  Node: Node$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$2() {
  return {
    minimumRiskFactor: ""
  };
}
const Params$2 = {
  typeUrl: "/osmosis.superfluid.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.minimumRiskFactor !== "" && n.uint32(10).string(e.minimumRiskFactor), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.minimumRiskFactor = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$2();
    return o.minimumRiskFactor = (n = e.minimumRiskFactor) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      minimumRiskFactor: e.minimum_risk_factor
    };
  },
  toAmino(e) {
    const n = {};
    return n.minimum_risk_factor = e.minimumRiskFactor, n;
  },
  fromAminoMsg(e) {
    return Params$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/params",
      value: Params$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$2.decode(e.value);
  },
  toProto(e) {
    return Params$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.Params",
      value: Params$2.encode(e).finish()
    };
  }
}, _161 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$2
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$3() {
  return {
    params: void 0,
    superfluidAssets: [],
    osmoEquivalentMultipliers: [],
    intermediaryAccounts: [],
    intemediaryAccountConnections: []
  };
}
const GenesisState$3 = {
  typeUrl: "/osmosis.superfluid.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$2.encode(e.params, n.uint32(10).fork()).ldelim();
    for (const o of e.superfluidAssets)
      SuperfluidAsset.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.osmoEquivalentMultipliers)
      OsmoEquivalentMultiplierRecord.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.intermediaryAccounts)
      SuperfluidIntermediaryAccount.encode(o, n.uint32(34).fork()).ldelim();
    for (const o of e.intemediaryAccountConnections)
      LockIdIntermediaryAccountConnection.encode(o, n.uint32(42).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$3();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$2.decode(o, o.uint32());
          break;
        case 2:
          c.superfluidAssets.push(SuperfluidAsset.decode(o, o.uint32()));
          break;
        case 3:
          c.osmoEquivalentMultipliers.push(OsmoEquivalentMultiplierRecord.decode(o, o.uint32()));
          break;
        case 4:
          c.intermediaryAccounts.push(SuperfluidIntermediaryAccount.decode(o, o.uint32()));
          break;
        case 5:
          c.intemediaryAccountConnections.push(LockIdIntermediaryAccountConnection.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseGenesisState$3();
    return d.params = e.params !== void 0 && e.params !== null ? Params$2.fromPartial(e.params) : void 0, d.superfluidAssets = ((n = e.superfluidAssets) === null || n === void 0 ? void 0 : n.map((m) => SuperfluidAsset.fromPartial(m))) || [], d.osmoEquivalentMultipliers = ((o = e.osmoEquivalentMultipliers) === null || o === void 0 ? void 0 : o.map((m) => OsmoEquivalentMultiplierRecord.fromPartial(m))) || [], d.intermediaryAccounts = ((u = e.intermediaryAccounts) === null || u === void 0 ? void 0 : u.map((m) => SuperfluidIntermediaryAccount.fromPartial(m))) || [], d.intemediaryAccountConnections = ((c = e.intemediaryAccountConnections) === null || c === void 0 ? void 0 : c.map((m) => LockIdIntermediaryAccountConnection.fromPartial(m))) || [], d;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$2.fromAmino(e.params) : void 0,
      superfluidAssets: Array.isArray(e == null ? void 0 : e.superfluid_assets) ? e.superfluid_assets.map((n) => SuperfluidAsset.fromAmino(n)) : [],
      osmoEquivalentMultipliers: Array.isArray(e == null ? void 0 : e.osmo_equivalent_multipliers) ? e.osmo_equivalent_multipliers.map((n) => OsmoEquivalentMultiplierRecord.fromAmino(n)) : [],
      intermediaryAccounts: Array.isArray(e == null ? void 0 : e.intermediary_accounts) ? e.intermediary_accounts.map((n) => SuperfluidIntermediaryAccount.fromAmino(n)) : [],
      intemediaryAccountConnections: Array.isArray(e == null ? void 0 : e.intemediary_account_connections) ? e.intemediary_account_connections.map((n) => LockIdIntermediaryAccountConnection.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$2.toAmino(e.params) : void 0, e.superfluidAssets ? n.superfluid_assets = e.superfluidAssets.map((o) => o ? SuperfluidAsset.toAmino(o) : void 0) : n.superfluid_assets = [], e.osmoEquivalentMultipliers ? n.osmo_equivalent_multipliers = e.osmoEquivalentMultipliers.map((o) => o ? OsmoEquivalentMultiplierRecord.toAmino(o) : void 0) : n.osmo_equivalent_multipliers = [], e.intermediaryAccounts ? n.intermediary_accounts = e.intermediaryAccounts.map((o) => o ? SuperfluidIntermediaryAccount.toAmino(o) : void 0) : n.intermediary_accounts = [], e.intemediaryAccountConnections ? n.intemediary_account_connections = e.intemediaryAccountConnections.map((o) => o ? LockIdIntermediaryAccountConnection.toAmino(o) : void 0) : n.intemediary_account_connections = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$3.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/genesis-state",
      value: GenesisState$3.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$3.decode(e.value);
  },
  toProto(e) {
    return GenesisState$3.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.GenesisState",
      value: GenesisState$3.encode(e).finish()
    };
  }
}, _160 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$3
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryParamsRequest$1() {
  return {};
}
const QueryParamsRequest$1 = {
  typeUrl: "/osmosis.superfluid.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest$1();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/query-params-request",
      value: QueryParamsRequest$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest$1.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.QueryParamsRequest",
      value: QueryParamsRequest$1.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse$1() {
  return {
    params: void 0
  };
}
const QueryParamsResponse$1 = {
  typeUrl: "/osmosis.superfluid.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$2.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$2.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse$1();
    return n.params = e.params !== void 0 && e.params !== null ? Params$2.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$2.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$2.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/query-params-response",
      value: QueryParamsResponse$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse$1.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.QueryParamsResponse",
      value: QueryParamsResponse$1.encode(e).finish()
    };
  }
};
function createBaseAssetTypeRequest() {
  return {
    denom: ""
  };
}
const AssetTypeRequest = {
  typeUrl: "/osmosis.superfluid.AssetTypeRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAssetTypeRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAssetTypeRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return AssetTypeRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/asset-type-request",
      value: AssetTypeRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AssetTypeRequest.decode(e.value);
  },
  toProto(e) {
    return AssetTypeRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.AssetTypeRequest",
      value: AssetTypeRequest.encode(e).finish()
    };
  }
};
function createBaseAssetTypeResponse() {
  return {
    assetType: 0
  };
}
const AssetTypeResponse = {
  typeUrl: "/osmosis.superfluid.AssetTypeResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.assetType !== 0 && n.uint32(8).int32(e.assetType), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAssetTypeResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.assetType = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAssetTypeResponse();
    return o.assetType = (n = e.assetType) !== null && n !== void 0 ? n : 0, o;
  },
  fromAmino(e) {
    return {
      assetType: isSet(e.asset_type) ? superfluidAssetTypeFromJSON(e.asset_type) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.asset_type = e.assetType, n;
  },
  fromAminoMsg(e) {
    return AssetTypeResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/asset-type-response",
      value: AssetTypeResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AssetTypeResponse.decode(e.value);
  },
  toProto(e) {
    return AssetTypeResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.AssetTypeResponse",
      value: AssetTypeResponse.encode(e).finish()
    };
  }
};
function createBaseAllAssetsRequest() {
  return {};
}
const AllAssetsRequest = {
  typeUrl: "/osmosis.superfluid.AllAssetsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAllAssetsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseAllAssetsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return AllAssetsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/all-assets-request",
      value: AllAssetsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AllAssetsRequest.decode(e.value);
  },
  toProto(e) {
    return AllAssetsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.AllAssetsRequest",
      value: AllAssetsRequest.encode(e).finish()
    };
  }
};
function createBaseAllAssetsResponse() {
  return {
    assets: []
  };
}
const AllAssetsResponse = {
  typeUrl: "/osmosis.superfluid.AllAssetsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.assets)
      SuperfluidAsset.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAllAssetsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.assets.push(SuperfluidAsset.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAllAssetsResponse();
    return o.assets = ((n = e.assets) === null || n === void 0 ? void 0 : n.map((u) => SuperfluidAsset.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      assets: Array.isArray(e == null ? void 0 : e.assets) ? e.assets.map((n) => SuperfluidAsset.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.assets ? n.assets = e.assets.map((o) => o ? SuperfluidAsset.toAmino(o) : void 0) : n.assets = [], n;
  },
  fromAminoMsg(e) {
    return AllAssetsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/all-assets-response",
      value: AllAssetsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AllAssetsResponse.decode(e.value);
  },
  toProto(e) {
    return AllAssetsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.AllAssetsResponse",
      value: AllAssetsResponse.encode(e).finish()
    };
  }
};
function createBaseAssetMultiplierRequest() {
  return {
    denom: ""
  };
}
const AssetMultiplierRequest = {
  typeUrl: "/osmosis.superfluid.AssetMultiplierRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAssetMultiplierRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAssetMultiplierRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return AssetMultiplierRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/asset-multiplier-request",
      value: AssetMultiplierRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AssetMultiplierRequest.decode(e.value);
  },
  toProto(e) {
    return AssetMultiplierRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.AssetMultiplierRequest",
      value: AssetMultiplierRequest.encode(e).finish()
    };
  }
};
function createBaseAssetMultiplierResponse() {
  return {
    osmoEquivalentMultiplier: void 0
  };
}
const AssetMultiplierResponse = {
  typeUrl: "/osmosis.superfluid.AssetMultiplierResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.osmoEquivalentMultiplier !== void 0 && OsmoEquivalentMultiplierRecord.encode(e.osmoEquivalentMultiplier, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAssetMultiplierResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.osmoEquivalentMultiplier = OsmoEquivalentMultiplierRecord.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseAssetMultiplierResponse();
    return n.osmoEquivalentMultiplier = e.osmoEquivalentMultiplier !== void 0 && e.osmoEquivalentMultiplier !== null ? OsmoEquivalentMultiplierRecord.fromPartial(e.osmoEquivalentMultiplier) : void 0, n;
  },
  fromAmino(e) {
    return {
      osmoEquivalentMultiplier: e != null && e.osmo_equivalent_multiplier ? OsmoEquivalentMultiplierRecord.fromAmino(e.osmo_equivalent_multiplier) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.osmo_equivalent_multiplier = e.osmoEquivalentMultiplier ? OsmoEquivalentMultiplierRecord.toAmino(e.osmoEquivalentMultiplier) : void 0, n;
  },
  fromAminoMsg(e) {
    return AssetMultiplierResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/asset-multiplier-response",
      value: AssetMultiplierResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AssetMultiplierResponse.decode(e.value);
  },
  toProto(e) {
    return AssetMultiplierResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.AssetMultiplierResponse",
      value: AssetMultiplierResponse.encode(e).finish()
    };
  }
};
function createBaseSuperfluidIntermediaryAccountInfo() {
  return {
    denom: "",
    valAddr: "",
    gaugeId: Long$2.UZERO,
    address: ""
  };
}
const SuperfluidIntermediaryAccountInfo = {
  typeUrl: "/osmosis.superfluid.SuperfluidIntermediaryAccountInfo",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.valAddr !== "" && n.uint32(18).string(e.valAddr), e.gaugeId.isZero() || n.uint32(24).uint64(e.gaugeId), e.address !== "" && n.uint32(34).string(e.address), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidIntermediaryAccountInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.valAddr = o.string();
          break;
        case 3:
          c.gaugeId = o.uint64();
          break;
        case 4:
          c.address = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSuperfluidIntermediaryAccountInfo();
    return c.denom = (n = e.denom) !== null && n !== void 0 ? n : "", c.valAddr = (o = e.valAddr) !== null && o !== void 0 ? o : "", c.gaugeId = e.gaugeId !== void 0 && e.gaugeId !== null ? Long$2.fromValue(e.gaugeId) : Long$2.UZERO, c.address = (u = e.address) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      valAddr: e.val_addr,
      gaugeId: Long$2.fromString(e.gauge_id),
      address: e.address
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.val_addr = e.valAddr, n.gauge_id = e.gaugeId ? e.gaugeId.toString() : void 0, n.address = e.address, n;
  },
  fromAminoMsg(e) {
    return SuperfluidIntermediaryAccountInfo.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-intermediary-account-info",
      value: SuperfluidIntermediaryAccountInfo.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidIntermediaryAccountInfo.decode(e.value);
  },
  toProto(e) {
    return SuperfluidIntermediaryAccountInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidIntermediaryAccountInfo",
      value: SuperfluidIntermediaryAccountInfo.encode(e).finish()
    };
  }
};
function createBaseAllIntermediaryAccountsRequest() {
  return {
    pagination: void 0
  };
}
const AllIntermediaryAccountsRequest = {
  typeUrl: "/osmosis.superfluid.AllIntermediaryAccountsRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.pagination !== void 0 && PageRequest.encode(e.pagination, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAllIntermediaryAccountsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pagination = PageRequest.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseAllIntermediaryAccountsRequest();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? PageRequest.fromPartial(e.pagination) : void 0, n;
  },
  fromAmino(e) {
    return {
      pagination: e != null && e.pagination ? PageRequest.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pagination = e.pagination ? PageRequest.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return AllIntermediaryAccountsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/all-intermediary-accounts-request",
      value: AllIntermediaryAccountsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AllIntermediaryAccountsRequest.decode(e.value);
  },
  toProto(e) {
    return AllIntermediaryAccountsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.AllIntermediaryAccountsRequest",
      value: AllIntermediaryAccountsRequest.encode(e).finish()
    };
  }
};
function createBaseAllIntermediaryAccountsResponse() {
  return {
    accounts: [],
    pagination: void 0
  };
}
const AllIntermediaryAccountsResponse = {
  typeUrl: "/osmosis.superfluid.AllIntermediaryAccountsResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.accounts)
      SuperfluidIntermediaryAccountInfo.encode(o, n.uint32(10).fork()).ldelim();
    return e.pagination !== void 0 && PageResponse.encode(e.pagination, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseAllIntermediaryAccountsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.accounts.push(SuperfluidIntermediaryAccountInfo.decode(o, o.uint32()));
          break;
        case 2:
          c.pagination = PageResponse.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseAllIntermediaryAccountsResponse();
    return o.accounts = ((n = e.accounts) === null || n === void 0 ? void 0 : n.map((u) => SuperfluidIntermediaryAccountInfo.fromPartial(u))) || [], o.pagination = e.pagination !== void 0 && e.pagination !== null ? PageResponse.fromPartial(e.pagination) : void 0, o;
  },
  fromAmino(e) {
    return {
      accounts: Array.isArray(e == null ? void 0 : e.accounts) ? e.accounts.map((n) => SuperfluidIntermediaryAccountInfo.fromAmino(n)) : [],
      pagination: e != null && e.pagination ? PageResponse.fromAmino(e.pagination) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.accounts ? n.accounts = e.accounts.map((o) => o ? SuperfluidIntermediaryAccountInfo.toAmino(o) : void 0) : n.accounts = [], n.pagination = e.pagination ? PageResponse.toAmino(e.pagination) : void 0, n;
  },
  fromAminoMsg(e) {
    return AllIntermediaryAccountsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/all-intermediary-accounts-response",
      value: AllIntermediaryAccountsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return AllIntermediaryAccountsResponse.decode(e.value);
  },
  toProto(e) {
    return AllIntermediaryAccountsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.AllIntermediaryAccountsResponse",
      value: AllIntermediaryAccountsResponse.encode(e).finish()
    };
  }
};
function createBaseConnectedIntermediaryAccountRequest() {
  return {
    lockId: Long$2.UZERO
  };
}
const ConnectedIntermediaryAccountRequest = {
  typeUrl: "/osmosis.superfluid.ConnectedIntermediaryAccountRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.lockId.isZero() || n.uint32(8).uint64(e.lockId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConnectedIntermediaryAccountRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.lockId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseConnectedIntermediaryAccountRequest();
    return n.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      lockId: Long$2.fromString(e.lock_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.lock_id = e.lockId ? e.lockId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return ConnectedIntermediaryAccountRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/connected-intermediary-account-request",
      value: ConnectedIntermediaryAccountRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConnectedIntermediaryAccountRequest.decode(e.value);
  },
  toProto(e) {
    return ConnectedIntermediaryAccountRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.ConnectedIntermediaryAccountRequest",
      value: ConnectedIntermediaryAccountRequest.encode(e).finish()
    };
  }
};
function createBaseConnectedIntermediaryAccountResponse() {
  return {
    account: void 0
  };
}
const ConnectedIntermediaryAccountResponse = {
  typeUrl: "/osmosis.superfluid.ConnectedIntermediaryAccountResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.account !== void 0 && SuperfluidIntermediaryAccountInfo.encode(e.account, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseConnectedIntermediaryAccountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.account = SuperfluidIntermediaryAccountInfo.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseConnectedIntermediaryAccountResponse();
    return n.account = e.account !== void 0 && e.account !== null ? SuperfluidIntermediaryAccountInfo.fromPartial(e.account) : void 0, n;
  },
  fromAmino(e) {
    return {
      account: e != null && e.account ? SuperfluidIntermediaryAccountInfo.fromAmino(e.account) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.account = e.account ? SuperfluidIntermediaryAccountInfo.toAmino(e.account) : void 0, n;
  },
  fromAminoMsg(e) {
    return ConnectedIntermediaryAccountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/connected-intermediary-account-response",
      value: ConnectedIntermediaryAccountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ConnectedIntermediaryAccountResponse.decode(e.value);
  },
  toProto(e) {
    return ConnectedIntermediaryAccountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.ConnectedIntermediaryAccountResponse",
      value: ConnectedIntermediaryAccountResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalDelegationByValidatorForDenomRequest() {
  return {
    denom: ""
  };
}
const QueryTotalDelegationByValidatorForDenomRequest = {
  typeUrl: "/osmosis.superfluid.QueryTotalDelegationByValidatorForDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalDelegationByValidatorForDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalDelegationByValidatorForDenomRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryTotalDelegationByValidatorForDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/query-total-delegation-by-validator-for-denom-request",
      value: QueryTotalDelegationByValidatorForDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalDelegationByValidatorForDenomRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalDelegationByValidatorForDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.QueryTotalDelegationByValidatorForDenomRequest",
      value: QueryTotalDelegationByValidatorForDenomRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalDelegationByValidatorForDenomResponse() {
  return {
    assets: []
  };
}
const QueryTotalDelegationByValidatorForDenomResponse = {
  typeUrl: "/osmosis.superfluid.QueryTotalDelegationByValidatorForDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.assets)
      Delegations.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalDelegationByValidatorForDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.assets.push(Delegations.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalDelegationByValidatorForDenomResponse();
    return o.assets = ((n = e.assets) === null || n === void 0 ? void 0 : n.map((u) => Delegations.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      assets: Array.isArray(e == null ? void 0 : e.assets) ? e.assets.map((n) => Delegations.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.assets ? n.assets = e.assets.map((o) => o ? Delegations.toAmino(o) : void 0) : n.assets = [], n;
  },
  fromAminoMsg(e) {
    return QueryTotalDelegationByValidatorForDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/query-total-delegation-by-validator-for-denom-response",
      value: QueryTotalDelegationByValidatorForDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalDelegationByValidatorForDenomResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalDelegationByValidatorForDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.QueryTotalDelegationByValidatorForDenomResponse",
      value: QueryTotalDelegationByValidatorForDenomResponse.encode(e).finish()
    };
  }
};
function createBaseDelegations() {
  return {
    valAddr: "",
    amountSfsd: "",
    osmoEquivalent: ""
  };
}
const Delegations = {
  typeUrl: "/osmosis.superfluid.Delegations",
  encode(e, n = minimal.Writer.create()) {
    return e.valAddr !== "" && n.uint32(10).string(e.valAddr), e.amountSfsd !== "" && n.uint32(18).string(e.amountSfsd), e.osmoEquivalent !== "" && n.uint32(26).string(e.osmoEquivalent), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDelegations();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.valAddr = o.string();
          break;
        case 2:
          c.amountSfsd = o.string();
          break;
        case 3:
          c.osmoEquivalent = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseDelegations();
    return c.valAddr = (n = e.valAddr) !== null && n !== void 0 ? n : "", c.amountSfsd = (o = e.amountSfsd) !== null && o !== void 0 ? o : "", c.osmoEquivalent = (u = e.osmoEquivalent) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      valAddr: e.val_addr,
      amountSfsd: e.amount_sfsd,
      osmoEquivalent: e.osmo_equivalent
    };
  },
  toAmino(e) {
    const n = {};
    return n.val_addr = e.valAddr, n.amount_sfsd = e.amountSfsd, n.osmo_equivalent = e.osmoEquivalent, n;
  },
  fromAminoMsg(e) {
    return Delegations.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/delegations",
      value: Delegations.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Delegations.decode(e.value);
  },
  toProto(e) {
    return Delegations.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.Delegations",
      value: Delegations.encode(e).finish()
    };
  }
};
function createBaseTotalSuperfluidDelegationsRequest() {
  return {};
}
const TotalSuperfluidDelegationsRequest = {
  typeUrl: "/osmosis.superfluid.TotalSuperfluidDelegationsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTotalSuperfluidDelegationsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseTotalSuperfluidDelegationsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return TotalSuperfluidDelegationsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/total-superfluid-delegations-request",
      value: TotalSuperfluidDelegationsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TotalSuperfluidDelegationsRequest.decode(e.value);
  },
  toProto(e) {
    return TotalSuperfluidDelegationsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.TotalSuperfluidDelegationsRequest",
      value: TotalSuperfluidDelegationsRequest.encode(e).finish()
    };
  }
};
function createBaseTotalSuperfluidDelegationsResponse() {
  return {
    totalDelegations: ""
  };
}
const TotalSuperfluidDelegationsResponse = {
  typeUrl: "/osmosis.superfluid.TotalSuperfluidDelegationsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.totalDelegations !== "" && n.uint32(10).string(e.totalDelegations), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTotalSuperfluidDelegationsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.totalDelegations = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseTotalSuperfluidDelegationsResponse();
    return o.totalDelegations = (n = e.totalDelegations) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      totalDelegations: e.total_delegations
    };
  },
  toAmino(e) {
    const n = {};
    return n.total_delegations = e.totalDelegations, n;
  },
  fromAminoMsg(e) {
    return TotalSuperfluidDelegationsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/total-superfluid-delegations-response",
      value: TotalSuperfluidDelegationsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TotalSuperfluidDelegationsResponse.decode(e.value);
  },
  toProto(e) {
    return TotalSuperfluidDelegationsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.TotalSuperfluidDelegationsResponse",
      value: TotalSuperfluidDelegationsResponse.encode(e).finish()
    };
  }
};
function createBaseSuperfluidDelegationAmountRequest() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    denom: ""
  };
}
const SuperfluidDelegationAmountRequest = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationAmountRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.denom !== "" && n.uint32(26).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidDelegationAmountRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.validatorAddress = o.string();
          break;
        case 3:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSuperfluidDelegationAmountRequest();
    return c.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", c.validatorAddress = (o = e.validatorAddress) !== null && o !== void 0 ? o : "", c.denom = (u = e.denom) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address,
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.validator_address = e.validatorAddress, n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return SuperfluidDelegationAmountRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegation-amount-request",
      value: SuperfluidDelegationAmountRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidDelegationAmountRequest.decode(e.value);
  },
  toProto(e) {
    return SuperfluidDelegationAmountRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationAmountRequest",
      value: SuperfluidDelegationAmountRequest.encode(e).finish()
    };
  }
};
function createBaseSuperfluidDelegationAmountResponse() {
  return {
    amount: []
  };
}
const SuperfluidDelegationAmountResponse = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationAmountResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.amount)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidDelegationAmountResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSuperfluidDelegationAmountResponse();
    return o.amount = ((n = e.amount) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      amount: Array.isArray(e == null ? void 0 : e.amount) ? e.amount.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.amount ? n.amount = e.amount.map((o) => o ? Coin.toAmino(o) : void 0) : n.amount = [], n;
  },
  fromAminoMsg(e) {
    return SuperfluidDelegationAmountResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegation-amount-response",
      value: SuperfluidDelegationAmountResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidDelegationAmountResponse.decode(e.value);
  },
  toProto(e) {
    return SuperfluidDelegationAmountResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationAmountResponse",
      value: SuperfluidDelegationAmountResponse.encode(e).finish()
    };
  }
};
function createBaseSuperfluidDelegationsByDelegatorRequest() {
  return {
    delegatorAddress: ""
  };
}
const SuperfluidDelegationsByDelegatorRequest = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByDelegatorRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidDelegationsByDelegatorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSuperfluidDelegationsByDelegatorRequest();
    return o.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n;
  },
  fromAminoMsg(e) {
    return SuperfluidDelegationsByDelegatorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegations-by-delegator-request",
      value: SuperfluidDelegationsByDelegatorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidDelegationsByDelegatorRequest.decode(e.value);
  },
  toProto(e) {
    return SuperfluidDelegationsByDelegatorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByDelegatorRequest",
      value: SuperfluidDelegationsByDelegatorRequest.encode(e).finish()
    };
  }
};
function createBaseSuperfluidDelegationsByDelegatorResponse() {
  return {
    superfluidDelegationRecords: [],
    totalDelegatedCoins: [],
    totalEquivalentStakedAmount: void 0
  };
}
const SuperfluidDelegationsByDelegatorResponse = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByDelegatorResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.superfluidDelegationRecords)
      SuperfluidDelegationRecord.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.totalDelegatedCoins)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return e.totalEquivalentStakedAmount !== void 0 && Coin.encode(e.totalEquivalentStakedAmount, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidDelegationsByDelegatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.superfluidDelegationRecords.push(SuperfluidDelegationRecord.decode(o, o.uint32()));
          break;
        case 2:
          c.totalDelegatedCoins.push(Coin.decode(o, o.uint32()));
          break;
        case 3:
          c.totalEquivalentStakedAmount = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSuperfluidDelegationsByDelegatorResponse();
    return u.superfluidDelegationRecords = ((n = e.superfluidDelegationRecords) === null || n === void 0 ? void 0 : n.map((c) => SuperfluidDelegationRecord.fromPartial(c))) || [], u.totalDelegatedCoins = ((o = e.totalDelegatedCoins) === null || o === void 0 ? void 0 : o.map((c) => Coin.fromPartial(c))) || [], u.totalEquivalentStakedAmount = e.totalEquivalentStakedAmount !== void 0 && e.totalEquivalentStakedAmount !== null ? Coin.fromPartial(e.totalEquivalentStakedAmount) : void 0, u;
  },
  fromAmino(e) {
    return {
      superfluidDelegationRecords: Array.isArray(e == null ? void 0 : e.superfluid_delegation_records) ? e.superfluid_delegation_records.map((n) => SuperfluidDelegationRecord.fromAmino(n)) : [],
      totalDelegatedCoins: Array.isArray(e == null ? void 0 : e.total_delegated_coins) ? e.total_delegated_coins.map((n) => Coin.fromAmino(n)) : [],
      totalEquivalentStakedAmount: e != null && e.total_equivalent_staked_amount ? Coin.fromAmino(e.total_equivalent_staked_amount) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.superfluidDelegationRecords ? n.superfluid_delegation_records = e.superfluidDelegationRecords.map((o) => o ? SuperfluidDelegationRecord.toAmino(o) : void 0) : n.superfluid_delegation_records = [], e.totalDelegatedCoins ? n.total_delegated_coins = e.totalDelegatedCoins.map((o) => o ? Coin.toAmino(o) : void 0) : n.total_delegated_coins = [], n.total_equivalent_staked_amount = e.totalEquivalentStakedAmount ? Coin.toAmino(e.totalEquivalentStakedAmount) : void 0, n;
  },
  fromAminoMsg(e) {
    return SuperfluidDelegationsByDelegatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegations-by-delegator-response",
      value: SuperfluidDelegationsByDelegatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidDelegationsByDelegatorResponse.decode(e.value);
  },
  toProto(e) {
    return SuperfluidDelegationsByDelegatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByDelegatorResponse",
      value: SuperfluidDelegationsByDelegatorResponse.encode(e).finish()
    };
  }
};
function createBaseSuperfluidUndelegationsByDelegatorRequest() {
  return {
    delegatorAddress: "",
    denom: ""
  };
}
const SuperfluidUndelegationsByDelegatorRequest = {
  typeUrl: "/osmosis.superfluid.SuperfluidUndelegationsByDelegatorRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.denom !== "" && n.uint32(18).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidUndelegationsByDelegatorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        case 2:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSuperfluidUndelegationsByDelegatorRequest();
    return u.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", u.denom = (o = e.denom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address,
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return SuperfluidUndelegationsByDelegatorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-undelegations-by-delegator-request",
      value: SuperfluidUndelegationsByDelegatorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidUndelegationsByDelegatorRequest.decode(e.value);
  },
  toProto(e) {
    return SuperfluidUndelegationsByDelegatorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidUndelegationsByDelegatorRequest",
      value: SuperfluidUndelegationsByDelegatorRequest.encode(e).finish()
    };
  }
};
function createBaseSuperfluidUndelegationsByDelegatorResponse() {
  return {
    superfluidDelegationRecords: [],
    totalUndelegatedCoins: [],
    syntheticLocks: []
  };
}
const SuperfluidUndelegationsByDelegatorResponse = {
  typeUrl: "/osmosis.superfluid.SuperfluidUndelegationsByDelegatorResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.superfluidDelegationRecords)
      SuperfluidDelegationRecord.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.totalUndelegatedCoins)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.syntheticLocks)
      SyntheticLock.encode(o, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidUndelegationsByDelegatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.superfluidDelegationRecords.push(SuperfluidDelegationRecord.decode(o, o.uint32()));
          break;
        case 2:
          c.totalUndelegatedCoins.push(Coin.decode(o, o.uint32()));
          break;
        case 3:
          c.syntheticLocks.push(SyntheticLock.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseSuperfluidUndelegationsByDelegatorResponse();
    return c.superfluidDelegationRecords = ((n = e.superfluidDelegationRecords) === null || n === void 0 ? void 0 : n.map((d) => SuperfluidDelegationRecord.fromPartial(d))) || [], c.totalUndelegatedCoins = ((o = e.totalUndelegatedCoins) === null || o === void 0 ? void 0 : o.map((d) => Coin.fromPartial(d))) || [], c.syntheticLocks = ((u = e.syntheticLocks) === null || u === void 0 ? void 0 : u.map((d) => SyntheticLock.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      superfluidDelegationRecords: Array.isArray(e == null ? void 0 : e.superfluid_delegation_records) ? e.superfluid_delegation_records.map((n) => SuperfluidDelegationRecord.fromAmino(n)) : [],
      totalUndelegatedCoins: Array.isArray(e == null ? void 0 : e.total_undelegated_coins) ? e.total_undelegated_coins.map((n) => Coin.fromAmino(n)) : [],
      syntheticLocks: Array.isArray(e == null ? void 0 : e.synthetic_locks) ? e.synthetic_locks.map((n) => SyntheticLock.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.superfluidDelegationRecords ? n.superfluid_delegation_records = e.superfluidDelegationRecords.map((o) => o ? SuperfluidDelegationRecord.toAmino(o) : void 0) : n.superfluid_delegation_records = [], e.totalUndelegatedCoins ? n.total_undelegated_coins = e.totalUndelegatedCoins.map((o) => o ? Coin.toAmino(o) : void 0) : n.total_undelegated_coins = [], e.syntheticLocks ? n.synthetic_locks = e.syntheticLocks.map((o) => o ? SyntheticLock.toAmino(o) : void 0) : n.synthetic_locks = [], n;
  },
  fromAminoMsg(e) {
    return SuperfluidUndelegationsByDelegatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-undelegations-by-delegator-response",
      value: SuperfluidUndelegationsByDelegatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidUndelegationsByDelegatorResponse.decode(e.value);
  },
  toProto(e) {
    return SuperfluidUndelegationsByDelegatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidUndelegationsByDelegatorResponse",
      value: SuperfluidUndelegationsByDelegatorResponse.encode(e).finish()
    };
  }
};
function createBaseSuperfluidDelegationsByValidatorDenomRequest() {
  return {
    validatorAddress: "",
    denom: ""
  };
}
const SuperfluidDelegationsByValidatorDenomRequest = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByValidatorDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), e.denom !== "" && n.uint32(18).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidDelegationsByValidatorDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseSuperfluidDelegationsByValidatorDenomRequest();
    return u.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", u.denom = (o = e.denom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return SuperfluidDelegationsByValidatorDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegations-by-validator-denom-request",
      value: SuperfluidDelegationsByValidatorDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidDelegationsByValidatorDenomRequest.decode(e.value);
  },
  toProto(e) {
    return SuperfluidDelegationsByValidatorDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByValidatorDenomRequest",
      value: SuperfluidDelegationsByValidatorDenomRequest.encode(e).finish()
    };
  }
};
function createBaseSuperfluidDelegationsByValidatorDenomResponse() {
  return {
    superfluidDelegationRecords: []
  };
}
const SuperfluidDelegationsByValidatorDenomResponse = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByValidatorDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.superfluidDelegationRecords)
      SuperfluidDelegationRecord.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSuperfluidDelegationsByValidatorDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.superfluidDelegationRecords.push(SuperfluidDelegationRecord.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSuperfluidDelegationsByValidatorDenomResponse();
    return o.superfluidDelegationRecords = ((n = e.superfluidDelegationRecords) === null || n === void 0 ? void 0 : n.map((u) => SuperfluidDelegationRecord.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      superfluidDelegationRecords: Array.isArray(e == null ? void 0 : e.superfluid_delegation_records) ? e.superfluid_delegation_records.map((n) => SuperfluidDelegationRecord.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.superfluidDelegationRecords ? n.superfluid_delegation_records = e.superfluidDelegationRecords.map((o) => o ? SuperfluidDelegationRecord.toAmino(o) : void 0) : n.superfluid_delegation_records = [], n;
  },
  fromAminoMsg(e) {
    return SuperfluidDelegationsByValidatorDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegations-by-validator-denom-response",
      value: SuperfluidDelegationsByValidatorDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return SuperfluidDelegationsByValidatorDenomResponse.decode(e.value);
  },
  toProto(e) {
    return SuperfluidDelegationsByValidatorDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByValidatorDenomResponse",
      value: SuperfluidDelegationsByValidatorDenomResponse.encode(e).finish()
    };
  }
};
function createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomRequest() {
  return {
    validatorAddress: "",
    denom: ""
  };
}
const EstimateSuperfluidDelegatedAmountByValidatorDenomRequest = {
  typeUrl: "/osmosis.superfluid.EstimateSuperfluidDelegatedAmountByValidatorDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.validatorAddress !== "" && n.uint32(10).string(e.validatorAddress), e.denom !== "" && n.uint32(18).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.validatorAddress = o.string();
          break;
        case 2:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomRequest();
    return u.validatorAddress = (n = e.validatorAddress) !== null && n !== void 0 ? n : "", u.denom = (o = e.denom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      validatorAddress: e.validator_address,
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.validator_address = e.validatorAddress, n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/estimate-superfluid-delegated-amount-by-validator-denom-request",
      value: EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.decode(e.value);
  },
  toProto(e) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.EstimateSuperfluidDelegatedAmountByValidatorDenomRequest",
      value: EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.encode(e).finish()
    };
  }
};
function createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomResponse() {
  return {
    totalDelegatedCoins: []
  };
}
const EstimateSuperfluidDelegatedAmountByValidatorDenomResponse = {
  typeUrl: "/osmosis.superfluid.EstimateSuperfluidDelegatedAmountByValidatorDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.totalDelegatedCoins)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.totalDelegatedCoins.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomResponse();
    return o.totalDelegatedCoins = ((n = e.totalDelegatedCoins) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      totalDelegatedCoins: Array.isArray(e == null ? void 0 : e.total_delegated_coins) ? e.total_delegated_coins.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.totalDelegatedCoins ? n.total_delegated_coins = e.totalDelegatedCoins.map((o) => o ? Coin.toAmino(o) : void 0) : n.total_delegated_coins = [], n;
  },
  fromAminoMsg(e) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/estimate-superfluid-delegated-amount-by-validator-denom-response",
      value: EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.decode(e.value);
  },
  toProto(e) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.EstimateSuperfluidDelegatedAmountByValidatorDenomResponse",
      value: EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.encode(e).finish()
    };
  }
};
function createBaseQueryTotalDelegationByDelegatorRequest() {
  return {
    delegatorAddress: ""
  };
}
const QueryTotalDelegationByDelegatorRequest = {
  typeUrl: "/osmosis.superfluid.QueryTotalDelegationByDelegatorRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalDelegationByDelegatorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegatorAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryTotalDelegationByDelegatorRequest();
    return o.delegatorAddress = (n = e.delegatorAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      delegatorAddress: e.delegator_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator_address = e.delegatorAddress, n;
  },
  fromAminoMsg(e) {
    return QueryTotalDelegationByDelegatorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/query-total-delegation-by-delegator-request",
      value: QueryTotalDelegationByDelegatorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalDelegationByDelegatorRequest.decode(e.value);
  },
  toProto(e) {
    return QueryTotalDelegationByDelegatorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.QueryTotalDelegationByDelegatorRequest",
      value: QueryTotalDelegationByDelegatorRequest.encode(e).finish()
    };
  }
};
function createBaseQueryTotalDelegationByDelegatorResponse() {
  return {
    superfluidDelegationRecords: [],
    delegationResponse: [],
    totalDelegatedCoins: [],
    totalEquivalentStakedAmount: void 0
  };
}
const QueryTotalDelegationByDelegatorResponse = {
  typeUrl: "/osmosis.superfluid.QueryTotalDelegationByDelegatorResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.superfluidDelegationRecords)
      SuperfluidDelegationRecord.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.delegationResponse)
      DelegationResponse.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.totalDelegatedCoins)
      Coin.encode(o, n.uint32(26).fork()).ldelim();
    return e.totalEquivalentStakedAmount !== void 0 && Coin.encode(e.totalEquivalentStakedAmount, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryTotalDelegationByDelegatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.superfluidDelegationRecords.push(SuperfluidDelegationRecord.decode(o, o.uint32()));
          break;
        case 2:
          c.delegationResponse.push(DelegationResponse.decode(o, o.uint32()));
          break;
        case 3:
          c.totalDelegatedCoins.push(Coin.decode(o, o.uint32()));
          break;
        case 4:
          c.totalEquivalentStakedAmount = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseQueryTotalDelegationByDelegatorResponse();
    return c.superfluidDelegationRecords = ((n = e.superfluidDelegationRecords) === null || n === void 0 ? void 0 : n.map((d) => SuperfluidDelegationRecord.fromPartial(d))) || [], c.delegationResponse = ((o = e.delegationResponse) === null || o === void 0 ? void 0 : o.map((d) => DelegationResponse.fromPartial(d))) || [], c.totalDelegatedCoins = ((u = e.totalDelegatedCoins) === null || u === void 0 ? void 0 : u.map((d) => Coin.fromPartial(d))) || [], c.totalEquivalentStakedAmount = e.totalEquivalentStakedAmount !== void 0 && e.totalEquivalentStakedAmount !== null ? Coin.fromPartial(e.totalEquivalentStakedAmount) : void 0, c;
  },
  fromAmino(e) {
    return {
      superfluidDelegationRecords: Array.isArray(e == null ? void 0 : e.superfluid_delegation_records) ? e.superfluid_delegation_records.map((n) => SuperfluidDelegationRecord.fromAmino(n)) : [],
      delegationResponse: Array.isArray(e == null ? void 0 : e.delegation_response) ? e.delegation_response.map((n) => DelegationResponse.fromAmino(n)) : [],
      totalDelegatedCoins: Array.isArray(e == null ? void 0 : e.total_delegated_coins) ? e.total_delegated_coins.map((n) => Coin.fromAmino(n)) : [],
      totalEquivalentStakedAmount: e != null && e.total_equivalent_staked_amount ? Coin.fromAmino(e.total_equivalent_staked_amount) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.superfluidDelegationRecords ? n.superfluid_delegation_records = e.superfluidDelegationRecords.map((o) => o ? SuperfluidDelegationRecord.toAmino(o) : void 0) : n.superfluid_delegation_records = [], e.delegationResponse ? n.delegation_response = e.delegationResponse.map((o) => o ? DelegationResponse.toAmino(o) : void 0) : n.delegation_response = [], e.totalDelegatedCoins ? n.total_delegated_coins = e.totalDelegatedCoins.map((o) => o ? Coin.toAmino(o) : void 0) : n.total_delegated_coins = [], n.total_equivalent_staked_amount = e.totalEquivalentStakedAmount ? Coin.toAmino(e.totalEquivalentStakedAmount) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryTotalDelegationByDelegatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/query-total-delegation-by-delegator-response",
      value: QueryTotalDelegationByDelegatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryTotalDelegationByDelegatorResponse.decode(e.value);
  },
  toProto(e) {
    return QueryTotalDelegationByDelegatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.QueryTotalDelegationByDelegatorResponse",
      value: QueryTotalDelegationByDelegatorResponse.encode(e).finish()
    };
  }
};
function createBaseQueryUnpoolWhitelistRequest() {
  return {};
}
const QueryUnpoolWhitelistRequest = {
  typeUrl: "/osmosis.superfluid.QueryUnpoolWhitelistRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUnpoolWhitelistRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryUnpoolWhitelistRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryUnpoolWhitelistRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/query-unpool-whitelist-request",
      value: QueryUnpoolWhitelistRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUnpoolWhitelistRequest.decode(e.value);
  },
  toProto(e) {
    return QueryUnpoolWhitelistRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.QueryUnpoolWhitelistRequest",
      value: QueryUnpoolWhitelistRequest.encode(e).finish()
    };
  }
};
function createBaseQueryUnpoolWhitelistResponse() {
  return {
    poolIds: []
  };
}
const QueryUnpoolWhitelistResponse = {
  typeUrl: "/osmosis.superfluid.QueryUnpoolWhitelistResponse",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.poolIds)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryUnpoolWhitelistResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.poolIds.push(o.uint64());
          } else
            c.poolIds.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryUnpoolWhitelistResponse();
    return o.poolIds = ((n = e.poolIds) === null || n === void 0 ? void 0 : n.map((u) => Long$2.fromValue(u))) || [], o;
  },
  fromAmino(e) {
    return {
      poolIds: Array.isArray(e == null ? void 0 : e.pool_ids) ? e.pool_ids.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.poolIds ? n.pool_ids = e.poolIds.map((o) => o) : n.pool_ids = [], n;
  },
  fromAminoMsg(e) {
    return QueryUnpoolWhitelistResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/query-unpool-whitelist-response",
      value: QueryUnpoolWhitelistResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryUnpoolWhitelistResponse.decode(e.value);
  },
  toProto(e) {
    return QueryUnpoolWhitelistResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.QueryUnpoolWhitelistResponse",
      value: QueryUnpoolWhitelistResponse.encode(e).finish()
    };
  }
}, _162 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AllAssetsRequest,
  AllAssetsResponse,
  AllIntermediaryAccountsRequest,
  AllIntermediaryAccountsResponse,
  AssetMultiplierRequest,
  AssetMultiplierResponse,
  AssetTypeRequest,
  AssetTypeResponse,
  ConnectedIntermediaryAccountRequest,
  ConnectedIntermediaryAccountResponse,
  Delegations,
  EstimateSuperfluidDelegatedAmountByValidatorDenomRequest,
  EstimateSuperfluidDelegatedAmountByValidatorDenomResponse,
  QueryParamsRequest: QueryParamsRequest$1,
  QueryParamsResponse: QueryParamsResponse$1,
  QueryTotalDelegationByDelegatorRequest,
  QueryTotalDelegationByDelegatorResponse,
  QueryTotalDelegationByValidatorForDenomRequest,
  QueryTotalDelegationByValidatorForDenomResponse,
  QueryUnpoolWhitelistRequest,
  QueryUnpoolWhitelistResponse,
  SuperfluidDelegationAmountRequest,
  SuperfluidDelegationAmountResponse,
  SuperfluidDelegationsByDelegatorRequest,
  SuperfluidDelegationsByDelegatorResponse,
  SuperfluidDelegationsByValidatorDenomRequest,
  SuperfluidDelegationsByValidatorDenomResponse,
  SuperfluidIntermediaryAccountInfo,
  SuperfluidUndelegationsByDelegatorRequest,
  SuperfluidUndelegationsByDelegatorResponse,
  TotalSuperfluidDelegationsRequest,
  TotalSuperfluidDelegationsResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSuperfluidDelegate() {
  return {
    sender: "",
    lockId: Long$2.UZERO,
    valAddr: ""
  };
}
const MsgSuperfluidDelegate = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.lockId.isZero() || n.uint32(16).uint64(e.lockId), e.valAddr !== "" && n.uint32(26).string(e.valAddr), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSuperfluidDelegate();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.lockId = o.uint64();
          break;
        case 3:
          c.valAddr = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgSuperfluidDelegate();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, u.valAddr = (o = e.valAddr) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      lockId: Long$2.fromString(e.lock_id),
      valAddr: e.val_addr
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.lock_id = e.lockId ? e.lockId.toString() : void 0, n.val_addr = e.valAddr, n;
  },
  fromAminoMsg(e) {
    return MsgSuperfluidDelegate.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegate",
      value: MsgSuperfluidDelegate.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSuperfluidDelegate.decode(e.value);
  },
  toProto(e) {
    return MsgSuperfluidDelegate.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
      value: MsgSuperfluidDelegate.encode(e).finish()
    };
  }
};
function createBaseMsgSuperfluidDelegateResponse() {
  return {};
}
const MsgSuperfluidDelegateResponse = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegateResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSuperfluidDelegateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSuperfluidDelegateResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSuperfluidDelegateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-delegate-response",
      value: MsgSuperfluidDelegateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSuperfluidDelegateResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSuperfluidDelegateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegateResponse",
      value: MsgSuperfluidDelegateResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSuperfluidUndelegate() {
  return {
    sender: "",
    lockId: Long$2.UZERO
  };
}
const MsgSuperfluidUndelegate = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.lockId.isZero() || n.uint32(16).uint64(e.lockId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSuperfluidUndelegate();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.lockId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSuperfluidUndelegate();
    return o.sender = (n = e.sender) !== null && n !== void 0 ? n : "", o.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      lockId: Long$2.fromString(e.lock_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.lock_id = e.lockId ? e.lockId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSuperfluidUndelegate.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-undelegate",
      value: MsgSuperfluidUndelegate.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSuperfluidUndelegate.decode(e.value);
  },
  toProto(e) {
    return MsgSuperfluidUndelegate.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
      value: MsgSuperfluidUndelegate.encode(e).finish()
    };
  }
};
function createBaseMsgSuperfluidUndelegateResponse() {
  return {};
}
const MsgSuperfluidUndelegateResponse = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSuperfluidUndelegateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSuperfluidUndelegateResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSuperfluidUndelegateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-undelegate-response",
      value: MsgSuperfluidUndelegateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSuperfluidUndelegateResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSuperfluidUndelegateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateResponse",
      value: MsgSuperfluidUndelegateResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSuperfluidUnbondLock() {
  return {
    sender: "",
    lockId: Long$2.UZERO
  };
}
const MsgSuperfluidUnbondLock = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.lockId.isZero() || n.uint32(16).uint64(e.lockId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSuperfluidUnbondLock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.lockId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSuperfluidUnbondLock();
    return o.sender = (n = e.sender) !== null && n !== void 0 ? n : "", o.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      lockId: Long$2.fromString(e.lock_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.lock_id = e.lockId ? e.lockId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSuperfluidUnbondLock.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-unbond-lock",
      value: MsgSuperfluidUnbondLock.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSuperfluidUnbondLock.decode(e.value);
  },
  toProto(e) {
    return MsgSuperfluidUnbondLock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
      value: MsgSuperfluidUnbondLock.encode(e).finish()
    };
  }
};
function createBaseMsgSuperfluidUnbondLockResponse() {
  return {};
}
const MsgSuperfluidUnbondLockResponse = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLockResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSuperfluidUnbondLockResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSuperfluidUnbondLockResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSuperfluidUnbondLockResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-unbond-lock-response",
      value: MsgSuperfluidUnbondLockResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSuperfluidUnbondLockResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSuperfluidUnbondLockResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLockResponse",
      value: MsgSuperfluidUnbondLockResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSuperfluidUndelegateAndUnbondLock() {
  return {
    sender: "",
    lockId: Long$2.UZERO,
    coin: void 0
  };
}
const MsgSuperfluidUndelegateAndUnbondLock = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.lockId.isZero() || n.uint32(16).uint64(e.lockId), e.coin !== void 0 && Coin.encode(e.coin, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSuperfluidUndelegateAndUnbondLock();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.lockId = o.uint64();
          break;
        case 3:
          c.coin = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSuperfluidUndelegateAndUnbondLock();
    return o.sender = (n = e.sender) !== null && n !== void 0 ? n : "", o.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, o.coin = e.coin !== void 0 && e.coin !== null ? Coin.fromPartial(e.coin) : void 0, o;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      lockId: Long$2.fromString(e.lock_id),
      coin: e != null && e.coin ? Coin.fromAmino(e.coin) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.lock_id = e.lockId ? e.lockId.toString() : void 0, n.coin = e.coin ? Coin.toAmino(e.coin) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSuperfluidUndelegateAndUnbondLock.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-undelegate-and-unbond-lock",
      value: MsgSuperfluidUndelegateAndUnbondLock.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSuperfluidUndelegateAndUnbondLock.decode(e.value);
  },
  toProto(e) {
    return MsgSuperfluidUndelegateAndUnbondLock.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
      value: MsgSuperfluidUndelegateAndUnbondLock.encode(e).finish()
    };
  }
};
function createBaseMsgSuperfluidUndelegateAndUnbondLockResponse() {
  return {};
}
const MsgSuperfluidUndelegateAndUnbondLockResponse = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLockResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSuperfluidUndelegateAndUnbondLockResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSuperfluidUndelegateAndUnbondLockResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSuperfluidUndelegateAndUnbondLockResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/superfluid-undelegate-and-unbond-lock-response",
      value: MsgSuperfluidUndelegateAndUnbondLockResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSuperfluidUndelegateAndUnbondLockResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSuperfluidUndelegateAndUnbondLockResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLockResponse",
      value: MsgSuperfluidUndelegateAndUnbondLockResponse.encode(e).finish()
    };
  }
};
function createBaseMsgLockAndSuperfluidDelegate() {
  return {
    sender: "",
    coins: [],
    valAddr: ""
  };
}
const MsgLockAndSuperfluidDelegate = {
  typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
  encode(e, n = minimal.Writer.create()) {
    e.sender !== "" && n.uint32(10).string(e.sender);
    for (const o of e.coins)
      Coin.encode(o, n.uint32(18).fork()).ldelim();
    return e.valAddr !== "" && n.uint32(26).string(e.valAddr), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgLockAndSuperfluidDelegate();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.coins.push(Coin.decode(o, o.uint32()));
          break;
        case 3:
          c.valAddr = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgLockAndSuperfluidDelegate();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.coins = ((o = e.coins) === null || o === void 0 ? void 0 : o.map((d) => Coin.fromPartial(d))) || [], c.valAddr = (u = e.valAddr) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      coins: Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => Coin.fromAmino(n)) : [],
      valAddr: e.val_addr
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, e.coins ? n.coins = e.coins.map((o) => o ? Coin.toAmino(o) : void 0) : n.coins = [], n.val_addr = e.valAddr, n;
  },
  fromAminoMsg(e) {
    return MsgLockAndSuperfluidDelegate.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lock-and-superfluid-delegate",
      value: MsgLockAndSuperfluidDelegate.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgLockAndSuperfluidDelegate.decode(e.value);
  },
  toProto(e) {
    return MsgLockAndSuperfluidDelegate.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
      value: MsgLockAndSuperfluidDelegate.encode(e).finish()
    };
  }
};
function createBaseMsgLockAndSuperfluidDelegateResponse() {
  return {
    ID: Long$2.UZERO
  };
}
const MsgLockAndSuperfluidDelegateResponse = {
  typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegateResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.ID.isZero() || n.uint32(8).uint64(e.ID), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgLockAndSuperfluidDelegateResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.ID = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgLockAndSuperfluidDelegateResponse();
    return n.ID = e.ID !== void 0 && e.ID !== null ? Long$2.fromValue(e.ID) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      ID: Long$2.fromString(e.ID)
    };
  },
  toAmino(e) {
    const n = {};
    return n.ID = e.ID ? e.ID.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgLockAndSuperfluidDelegateResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/lock-and-superfluid-delegate-response",
      value: MsgLockAndSuperfluidDelegateResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgLockAndSuperfluidDelegateResponse.decode(e.value);
  },
  toProto(e) {
    return MsgLockAndSuperfluidDelegateResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegateResponse",
      value: MsgLockAndSuperfluidDelegateResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUnPoolWhitelistedPool() {
  return {
    sender: "",
    poolId: Long$2.UZERO
  };
}
const MsgUnPoolWhitelistedPool = {
  typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.poolId.isZero() || n.uint32(16).uint64(e.poolId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUnPoolWhitelistedPool();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.poolId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgUnPoolWhitelistedPool();
    return o.sender = (n = e.sender) !== null && n !== void 0 ? n : "", o.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      poolId: Long$2.fromString(e.pool_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.pool_id = e.poolId ? e.poolId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgUnPoolWhitelistedPool.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/unpool-whitelisted-pool",
      value: MsgUnPoolWhitelistedPool.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUnPoolWhitelistedPool.decode(e.value);
  },
  toProto(e) {
    return MsgUnPoolWhitelistedPool.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
      value: MsgUnPoolWhitelistedPool.encode(e).finish()
    };
  }
};
function createBaseMsgUnPoolWhitelistedPoolResponse() {
  return {
    exitedLockIds: []
  };
}
const MsgUnPoolWhitelistedPoolResponse = {
  typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPoolResponse",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.exitedLockIds)
      n.uint64(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUnPoolWhitelistedPoolResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.exitedLockIds.push(o.uint64());
          } else
            c.exitedLockIds.push(o.uint64());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgUnPoolWhitelistedPoolResponse();
    return o.exitedLockIds = ((n = e.exitedLockIds) === null || n === void 0 ? void 0 : n.map((u) => Long$2.fromValue(u))) || [], o;
  },
  fromAmino(e) {
    return {
      exitedLockIds: Array.isArray(e == null ? void 0 : e.exited_lock_ids) ? e.exited_lock_ids.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.exitedLockIds ? n.exited_lock_ids = e.exitedLockIds.map((o) => o) : n.exited_lock_ids = [], n;
  },
  fromAminoMsg(e) {
    return MsgUnPoolWhitelistedPoolResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/un-pool-whitelisted-pool-response",
      value: MsgUnPoolWhitelistedPoolResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUnPoolWhitelistedPoolResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUnPoolWhitelistedPoolResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPoolResponse",
      value: MsgUnPoolWhitelistedPoolResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPosition() {
  return {
    sender: "",
    lockId: Long$2.UZERO,
    sharesToMigrate: void 0
  };
}
const MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition = {
  typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.lockId.isZero() || n.uint32(16).uint64(e.lockId), e.sharesToMigrate !== void 0 && Coin.encode(e.sharesToMigrate, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPosition();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.lockId = o.uint64();
          break;
        case 3:
          c.sharesToMigrate = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPosition();
    return o.sender = (n = e.sender) !== null && n !== void 0 ? n : "", o.lockId = e.lockId !== void 0 && e.lockId !== null ? Long$2.fromValue(e.lockId) : Long$2.UZERO, o.sharesToMigrate = e.sharesToMigrate !== void 0 && e.sharesToMigrate !== null ? Coin.fromPartial(e.sharesToMigrate) : void 0, o;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      lockId: Long$2.fromString(e.lock_id),
      sharesToMigrate: e != null && e.shares_to_migrate ? Coin.fromAmino(e.shares_to_migrate) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.lock_id = e.lockId ? e.lockId.toString() : void 0, n.shares_to_migrate = e.sharesToMigrate ? Coin.toAmino(e.sharesToMigrate) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/unlock-and-migrate-shares-to-full-range-concentrated-position",
      value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.decode(e.value);
  },
  toProto(e) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
      value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.encode(e).finish()
    };
  }
};
function createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse() {
  return {
    amount0: "",
    amount1: "",
    liquidityCreated: "",
    joinTime: void 0
  };
}
const MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse = {
  typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.amount0 !== "" && n.uint32(10).string(e.amount0), e.amount1 !== "" && n.uint32(18).string(e.amount1), e.liquidityCreated !== "" && n.uint32(26).string(e.liquidityCreated), e.joinTime !== void 0 && Timestamp.encode(toTimestamp(e.joinTime), n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount0 = o.string();
          break;
        case 2:
          c.amount1 = o.string();
          break;
        case 3:
          c.liquidityCreated = o.string();
          break;
        case 4:
          c.joinTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse();
    return d.amount0 = (n = e.amount0) !== null && n !== void 0 ? n : "", d.amount1 = (o = e.amount1) !== null && o !== void 0 ? o : "", d.liquidityCreated = (u = e.liquidityCreated) !== null && u !== void 0 ? u : "", d.joinTime = (c = e.joinTime) !== null && c !== void 0 ? c : void 0, d;
  },
  fromAmino(e) {
    return {
      amount0: e.amount0,
      amount1: e.amount1,
      liquidityCreated: e.liquidity_created,
      joinTime: e != null && e.join_time ? Timestamp.fromAmino(e.join_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.amount0 = e.amount0, n.amount1 = e.amount1, n.liquidity_created = e.liquidityCreated, n.join_time = e.joinTime ? Timestamp.toAmino(e.joinTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/unlock-and-migrate-shares-to-full-range-concentrated-position-response",
      value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse",
      value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.encode(e).finish()
    };
  }
}, _164 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgLockAndSuperfluidDelegate,
  MsgLockAndSuperfluidDelegateResponse,
  MsgSuperfluidDelegate,
  MsgSuperfluidDelegateResponse,
  MsgSuperfluidUnbondLock,
  MsgSuperfluidUnbondLockResponse,
  MsgSuperfluidUndelegate,
  MsgSuperfluidUndelegateAndUnbondLock,
  MsgSuperfluidUndelegateAndUnbondLockResponse,
  MsgSuperfluidUndelegateResponse,
  MsgUnPoolWhitelistedPool,
  MsgUnPoolWhitelistedPoolResponse,
  MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition,
  MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseDenomAuthorityMetadata() {
  return {
    admin: ""
  };
}
const DenomAuthorityMetadata = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.DenomAuthorityMetadata",
  encode(e, n = minimal.Writer.create()) {
    return e.admin !== "" && n.uint32(10).string(e.admin), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDenomAuthorityMetadata();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.admin = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseDenomAuthorityMetadata();
    return o.admin = (n = e.admin) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      admin: e.admin
    };
  },
  toAmino(e) {
    const n = {};
    return n.admin = e.admin, n;
  },
  fromAminoMsg(e) {
    return DenomAuthorityMetadata.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/denom-authority-metadata",
      value: DenomAuthorityMetadata.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return DenomAuthorityMetadata.decode(e.value);
  },
  toProto(e) {
    return DenomAuthorityMetadata.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.DenomAuthorityMetadata",
      value: DenomAuthorityMetadata.encode(e).finish()
    };
  }
}, _165 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DenomAuthorityMetadata
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams$1() {
  return {
    denomCreationFee: []
  };
}
const Params$1 = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.denomCreationFee)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denomCreationFee.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams$1();
    return o.denomCreationFee = ((n = e.denomCreationFee) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      denomCreationFee: Array.isArray(e == null ? void 0 : e.denom_creation_fee) ? e.denom_creation_fee.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.denomCreationFee ? n.denom_creation_fee = e.denomCreationFee.map((o) => o ? Coin.toAmino(o) : void 0) : n.denom_creation_fee = [], n;
  },
  fromAminoMsg(e) {
    return Params$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/params",
      value: Params$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params$1.decode(e.value);
  },
  toProto(e) {
    return Params$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.Params",
      value: Params$1.encode(e).finish()
    };
  }
}, _167 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Params: Params$1
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState$2() {
  return {
    params: void 0,
    factoryDenoms: []
  };
}
const GenesisState$2 = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.params !== void 0 && Params$1.encode(e.params, n.uint32(10).fork()).ldelim();
    for (const o of e.factoryDenoms)
      GenesisDenom.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$2();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$1.decode(o, o.uint32());
          break;
        case 2:
          c.factoryDenoms.push(GenesisDenom.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$2();
    return o.params = e.params !== void 0 && e.params !== null ? Params$1.fromPartial(e.params) : void 0, o.factoryDenoms = ((n = e.factoryDenoms) === null || n === void 0 ? void 0 : n.map((u) => GenesisDenom.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$1.fromAmino(e.params) : void 0,
      factoryDenoms: Array.isArray(e == null ? void 0 : e.factory_denoms) ? e.factory_denoms.map((n) => GenesisDenom.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$1.toAmino(e.params) : void 0, e.factoryDenoms ? n.factory_denoms = e.factoryDenoms.map((o) => o ? GenesisDenom.toAmino(o) : void 0) : n.factory_denoms = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState$2.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/genesis-state",
      value: GenesisState$2.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$2.decode(e.value);
  },
  toProto(e) {
    return GenesisState$2.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.GenesisState",
      value: GenesisState$2.encode(e).finish()
    };
  }
};
function createBaseGenesisDenom() {
  return {
    denom: "",
    authorityMetadata: void 0
  };
}
const GenesisDenom = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.GenesisDenom",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.authorityMetadata !== void 0 && DenomAuthorityMetadata.encode(e.authorityMetadata, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisDenom();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        case 2:
          c.authorityMetadata = DenomAuthorityMetadata.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisDenom();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o.authorityMetadata = e.authorityMetadata !== void 0 && e.authorityMetadata !== null ? DenomAuthorityMetadata.fromPartial(e.authorityMetadata) : void 0, o;
  },
  fromAmino(e) {
    return {
      denom: e.denom,
      authorityMetadata: e != null && e.authority_metadata ? DenomAuthorityMetadata.fromAmino(e.authority_metadata) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n.authority_metadata = e.authorityMetadata ? DenomAuthorityMetadata.toAmino(e.authorityMetadata) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisDenom.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/genesis-denom",
      value: GenesisDenom.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisDenom.decode(e.value);
  },
  toProto(e) {
    return GenesisDenom.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.GenesisDenom",
      value: GenesisDenom.encode(e).finish()
    };
  }
}, _166 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisDenom,
  GenesisState: GenesisState$2
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryParamsRequest() {
  return {};
}
const QueryParamsRequest = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryParamsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryParamsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/query-params-request",
      value: QueryParamsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsRequest.decode(e.value);
  },
  toProto(e) {
    return QueryParamsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(e).finish()
    };
  }
};
function createBaseQueryParamsResponse() {
  return {
    params: void 0
  };
}
const QueryParamsResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params$1.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryParamsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params$1.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryParamsResponse();
    return n.params = e.params !== void 0 && e.params !== null ? Params$1.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params$1.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params$1.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryParamsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/query-params-response",
      value: QueryParamsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryParamsResponse.decode(e.value);
  },
  toProto(e) {
    return QueryParamsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDenomAuthorityMetadataRequest() {
  return {
    denom: ""
  };
}
const QueryDenomAuthorityMetadataRequest = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomAuthorityMetadataRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomAuthorityMetadataRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomAuthorityMetadataRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryDenomAuthorityMetadataRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/query-denom-authority-metadata-request",
      value: QueryDenomAuthorityMetadataRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomAuthorityMetadataRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomAuthorityMetadataRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomAuthorityMetadataRequest",
      value: QueryDenomAuthorityMetadataRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomAuthorityMetadataResponse() {
  return {
    authorityMetadata: void 0
  };
}
const QueryDenomAuthorityMetadataResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomAuthorityMetadataResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.authorityMetadata !== void 0 && DenomAuthorityMetadata.encode(e.authorityMetadata, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomAuthorityMetadataResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.authorityMetadata = DenomAuthorityMetadata.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDenomAuthorityMetadataResponse();
    return n.authorityMetadata = e.authorityMetadata !== void 0 && e.authorityMetadata !== null ? DenomAuthorityMetadata.fromPartial(e.authorityMetadata) : void 0, n;
  },
  fromAmino(e) {
    return {
      authorityMetadata: e != null && e.authority_metadata ? DenomAuthorityMetadata.fromAmino(e.authority_metadata) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.authority_metadata = e.authorityMetadata ? DenomAuthorityMetadata.toAmino(e.authorityMetadata) : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDenomAuthorityMetadataResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/query-denom-authority-metadata-response",
      value: QueryDenomAuthorityMetadataResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomAuthorityMetadataResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomAuthorityMetadataResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomAuthorityMetadataResponse",
      value: QueryDenomAuthorityMetadataResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDenomsFromCreatorRequest() {
  return {
    creator: ""
  };
}
const QueryDenomsFromCreatorRequest = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomsFromCreatorRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.creator !== "" && n.uint32(10).string(e.creator), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomsFromCreatorRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.creator = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomsFromCreatorRequest();
    return o.creator = (n = e.creator) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      creator: e.creator
    };
  },
  toAmino(e) {
    const n = {};
    return n.creator = e.creator, n;
  },
  fromAminoMsg(e) {
    return QueryDenomsFromCreatorRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/query-denoms-from-creator-request",
      value: QueryDenomsFromCreatorRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomsFromCreatorRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomsFromCreatorRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomsFromCreatorRequest",
      value: QueryDenomsFromCreatorRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomsFromCreatorResponse() {
  return {
    denoms: []
  };
}
const QueryDenomsFromCreatorResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomsFromCreatorResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.denoms)
      n.uint32(10).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomsFromCreatorResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denoms.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomsFromCreatorResponse();
    return o.denoms = ((n = e.denoms) === null || n === void 0 ? void 0 : n.map((u) => u)) || [], o;
  },
  fromAmino(e) {
    return {
      denoms: Array.isArray(e == null ? void 0 : e.denoms) ? e.denoms.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.denoms ? n.denoms = e.denoms.map((o) => o) : n.denoms = [], n;
  },
  fromAminoMsg(e) {
    return QueryDenomsFromCreatorResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/query-denoms-from-creator-response",
      value: QueryDenomsFromCreatorResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomsFromCreatorResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomsFromCreatorResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomsFromCreatorResponse",
      value: QueryDenomsFromCreatorResponse.encode(e).finish()
    };
  }
};
function createBaseQueryBeforeSendHookAddressRequest() {
  return {
    denom: ""
  };
}
const QueryBeforeSendHookAddressRequest = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryBeforeSendHookAddressRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryBeforeSendHookAddressRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryBeforeSendHookAddressRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryBeforeSendHookAddressRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/query-before-send-hook-address-request",
      value: QueryBeforeSendHookAddressRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryBeforeSendHookAddressRequest.decode(e.value);
  },
  toProto(e) {
    return QueryBeforeSendHookAddressRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryBeforeSendHookAddressRequest",
      value: QueryBeforeSendHookAddressRequest.encode(e).finish()
    };
  }
};
function createBaseQueryBeforeSendHookAddressResponse() {
  return {
    cosmwasmAddress: ""
  };
}
const QueryBeforeSendHookAddressResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryBeforeSendHookAddressResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.cosmwasmAddress !== "" && n.uint32(10).string(e.cosmwasmAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryBeforeSendHookAddressResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.cosmwasmAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryBeforeSendHookAddressResponse();
    return o.cosmwasmAddress = (n = e.cosmwasmAddress) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      cosmwasmAddress: e.cosmwasm_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.cosmwasm_address = e.cosmwasmAddress, n;
  },
  fromAminoMsg(e) {
    return QueryBeforeSendHookAddressResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/query-before-send-hook-address-response",
      value: QueryBeforeSendHookAddressResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryBeforeSendHookAddressResponse.decode(e.value);
  },
  toProto(e) {
    return QueryBeforeSendHookAddressResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryBeforeSendHookAddressResponse",
      value: QueryBeforeSendHookAddressResponse.encode(e).finish()
    };
  }
}, _168 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryBeforeSendHookAddressRequest,
  QueryBeforeSendHookAddressResponse,
  QueryDenomAuthorityMetadataRequest,
  QueryDenomAuthorityMetadataResponse,
  QueryDenomsFromCreatorRequest,
  QueryDenomsFromCreatorResponse,
  QueryParamsRequest,
  QueryParamsResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgCreateDenom() {
  return {
    sender: "",
    subdenom: ""
  };
}
const MsgCreateDenom = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.subdenom !== "" && n.uint32(18).string(e.subdenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateDenom();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.subdenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgCreateDenom();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.subdenom = (o = e.subdenom) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      subdenom: e.subdenom
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.subdenom = e.subdenom, n;
  },
  fromAminoMsg(e) {
    return MsgCreateDenom.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/create-denom",
      value: MsgCreateDenom.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateDenom.decode(e.value);
  },
  toProto(e) {
    return MsgCreateDenom.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
      value: MsgCreateDenom.encode(e).finish()
    };
  }
};
function createBaseMsgCreateDenomResponse() {
  return {
    newTokenDenom: ""
  };
}
const MsgCreateDenomResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.newTokenDenom !== "" && n.uint32(10).string(e.newTokenDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreateDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.newTokenDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgCreateDenomResponse();
    return o.newTokenDenom = (n = e.newTokenDenom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      newTokenDenom: e.new_token_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.new_token_denom = e.newTokenDenom, n;
  },
  fromAminoMsg(e) {
    return MsgCreateDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/create-denom-response",
      value: MsgCreateDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreateDenomResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCreateDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenomResponse",
      value: MsgCreateDenomResponse.encode(e).finish()
    };
  }
};
function createBaseMsgMint() {
  return {
    sender: "",
    amount: void 0,
    mintToAddress: ""
  };
}
const MsgMint = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.amount !== void 0 && Coin.encode(e.amount, n.uint32(18).fork()).ldelim(), e.mintToAddress !== "" && n.uint32(26).string(e.mintToAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgMint();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.amount = Coin.decode(o, o.uint32());
          break;
        case 3:
          c.mintToAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgMint();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.amount = e.amount !== void 0 && e.amount !== null ? Coin.fromPartial(e.amount) : void 0, u.mintToAddress = (o = e.mintToAddress) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      amount: e != null && e.amount ? Coin.fromAmino(e.amount) : void 0,
      mintToAddress: e.mintToAddress
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.amount = e.amount ? Coin.toAmino(e.amount) : void 0, n.mintToAddress = e.mintToAddress, n;
  },
  fromAminoMsg(e) {
    return MsgMint.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/mint",
      value: MsgMint.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgMint.decode(e.value);
  },
  toProto(e) {
    return MsgMint.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
      value: MsgMint.encode(e).finish()
    };
  }
};
function createBaseMsgMintResponse() {
  return {};
}
const MsgMintResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMintResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgMintResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgMintResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgMintResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/mint-response",
      value: MsgMintResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgMintResponse.decode(e.value);
  },
  toProto(e) {
    return MsgMintResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMintResponse",
      value: MsgMintResponse.encode(e).finish()
    };
  }
};
function createBaseMsgBurn() {
  return {
    sender: "",
    amount: void 0,
    burnFromAddress: ""
  };
}
const MsgBurn = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.amount !== void 0 && Coin.encode(e.amount, n.uint32(18).fork()).ldelim(), e.burnFromAddress !== "" && n.uint32(26).string(e.burnFromAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgBurn();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.amount = Coin.decode(o, o.uint32());
          break;
        case 3:
          c.burnFromAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgBurn();
    return u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.amount = e.amount !== void 0 && e.amount !== null ? Coin.fromPartial(e.amount) : void 0, u.burnFromAddress = (o = e.burnFromAddress) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      amount: e != null && e.amount ? Coin.fromAmino(e.amount) : void 0,
      burnFromAddress: e.burnFromAddress
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.amount = e.amount ? Coin.toAmino(e.amount) : void 0, n.burnFromAddress = e.burnFromAddress, n;
  },
  fromAminoMsg(e) {
    return MsgBurn.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/burn",
      value: MsgBurn.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgBurn.decode(e.value);
  },
  toProto(e) {
    return MsgBurn.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
      value: MsgBurn.encode(e).finish()
    };
  }
};
function createBaseMsgBurnResponse() {
  return {};
}
const MsgBurnResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurnResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgBurnResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgBurnResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgBurnResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/burn-response",
      value: MsgBurnResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgBurnResponse.decode(e.value);
  },
  toProto(e) {
    return MsgBurnResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurnResponse",
      value: MsgBurnResponse.encode(e).finish()
    };
  }
};
function createBaseMsgChangeAdmin() {
  return {
    sender: "",
    denom: "",
    newAdmin: ""
  };
}
const MsgChangeAdmin = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.denom !== "" && n.uint32(18).string(e.denom), e.newAdmin !== "" && n.uint32(26).string(e.newAdmin), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChangeAdmin();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.denom = o.string();
          break;
        case 3:
          c.newAdmin = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgChangeAdmin();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.denom = (o = e.denom) !== null && o !== void 0 ? o : "", c.newAdmin = (u = e.newAdmin) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      denom: e.denom,
      newAdmin: e.new_admin
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.denom = e.denom, n.new_admin = e.newAdmin, n;
  },
  fromAminoMsg(e) {
    return MsgChangeAdmin.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/change-admin",
      value: MsgChangeAdmin.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChangeAdmin.decode(e.value);
  },
  toProto(e) {
    return MsgChangeAdmin.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
      value: MsgChangeAdmin.encode(e).finish()
    };
  }
};
function createBaseMsgChangeAdminResponse() {
  return {};
}
const MsgChangeAdminResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdminResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgChangeAdminResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgChangeAdminResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgChangeAdminResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/change-admin-response",
      value: MsgChangeAdminResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgChangeAdminResponse.decode(e.value);
  },
  toProto(e) {
    return MsgChangeAdminResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdminResponse",
      value: MsgChangeAdminResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSetBeforeSendHook() {
  return {
    sender: "",
    denom: "",
    cosmwasmAddress: ""
  };
}
const MsgSetBeforeSendHook = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.denom !== "" && n.uint32(18).string(e.denom), e.cosmwasmAddress !== "" && n.uint32(26).string(e.cosmwasmAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetBeforeSendHook();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.denom = o.string();
          break;
        case 3:
          c.cosmwasmAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgSetBeforeSendHook();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.denom = (o = e.denom) !== null && o !== void 0 ? o : "", c.cosmwasmAddress = (u = e.cosmwasmAddress) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      denom: e.denom,
      cosmwasmAddress: e.cosmwasm_address
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.denom = e.denom, n.cosmwasm_address = e.cosmwasmAddress, n;
  },
  fromAminoMsg(e) {
    return MsgSetBeforeSendHook.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/set-before-send-hook",
      value: MsgSetBeforeSendHook.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetBeforeSendHook.decode(e.value);
  },
  toProto(e) {
    return MsgSetBeforeSendHook.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
      value: MsgSetBeforeSendHook.encode(e).finish()
    };
  }
};
function createBaseMsgSetBeforeSendHookResponse() {
  return {};
}
const MsgSetBeforeSendHookResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHookResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetBeforeSendHookResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetBeforeSendHookResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetBeforeSendHookResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/set-before-send-hook-response",
      value: MsgSetBeforeSendHookResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetBeforeSendHookResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetBeforeSendHookResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHookResponse",
      value: MsgSetBeforeSendHookResponse.encode(e).finish()
    };
  }
};
function createBaseMsgSetDenomMetadata() {
  return {
    sender: "",
    metadata: void 0
  };
}
const MsgSetDenomMetadata = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.metadata !== void 0 && Metadata$2.encode(e.metadata, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetDenomMetadata();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.metadata = Metadata$2.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgSetDenomMetadata();
    return o.sender = (n = e.sender) !== null && n !== void 0 ? n : "", o.metadata = e.metadata !== void 0 && e.metadata !== null ? Metadata$2.fromPartial(e.metadata) : void 0, o;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      metadata: e != null && e.metadata ? Metadata$2.fromAmino(e.metadata) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.metadata = e.metadata ? Metadata$2.toAmino(e.metadata) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgSetDenomMetadata.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/set-denom-metadata",
      value: MsgSetDenomMetadata.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetDenomMetadata.decode(e.value);
  },
  toProto(e) {
    return MsgSetDenomMetadata.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
      value: MsgSetDenomMetadata.encode(e).finish()
    };
  }
};
function createBaseMsgSetDenomMetadataResponse() {
  return {};
}
const MsgSetDenomMetadataResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadataResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetDenomMetadataResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetDenomMetadataResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetDenomMetadataResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/set-denom-metadata-response",
      value: MsgSetDenomMetadataResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetDenomMetadataResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetDenomMetadataResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadataResponse",
      value: MsgSetDenomMetadataResponse.encode(e).finish()
    };
  }
};
function createBaseMsgForceTransfer() {
  return {
    sender: "",
    amount: void 0,
    transferFromAddress: "",
    transferToAddress: ""
  };
}
const MsgForceTransfer = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
  encode(e, n = minimal.Writer.create()) {
    return e.sender !== "" && n.uint32(10).string(e.sender), e.amount !== void 0 && Coin.encode(e.amount, n.uint32(18).fork()).ldelim(), e.transferFromAddress !== "" && n.uint32(26).string(e.transferFromAddress), e.transferToAddress !== "" && n.uint32(34).string(e.transferToAddress), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgForceTransfer();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.sender = o.string();
          break;
        case 2:
          c.amount = Coin.decode(o, o.uint32());
          break;
        case 3:
          c.transferFromAddress = o.string();
          break;
        case 4:
          c.transferToAddress = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgForceTransfer();
    return c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.amount = e.amount !== void 0 && e.amount !== null ? Coin.fromPartial(e.amount) : void 0, c.transferFromAddress = (o = e.transferFromAddress) !== null && o !== void 0 ? o : "", c.transferToAddress = (u = e.transferToAddress) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      sender: e.sender,
      amount: e != null && e.amount ? Coin.fromAmino(e.amount) : void 0,
      transferFromAddress: e.transferFromAddress,
      transferToAddress: e.transferToAddress
    };
  },
  toAmino(e) {
    const n = {};
    return n.sender = e.sender, n.amount = e.amount ? Coin.toAmino(e.amount) : void 0, n.transferFromAddress = e.transferFromAddress, n.transferToAddress = e.transferToAddress, n;
  },
  fromAminoMsg(e) {
    return MsgForceTransfer.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/force-transfer",
      value: MsgForceTransfer.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgForceTransfer.decode(e.value);
  },
  toProto(e) {
    return MsgForceTransfer.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
      value: MsgForceTransfer.encode(e).finish()
    };
  }
};
function createBaseMsgForceTransferResponse() {
  return {};
}
const MsgForceTransferResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransferResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgForceTransferResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgForceTransferResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgForceTransferResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/tokenfactory/force-transfer-response",
      value: MsgForceTransferResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgForceTransferResponse.decode(e.value);
  },
  toProto(e) {
    return MsgForceTransferResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransferResponse",
      value: MsgForceTransferResponse.encode(e).finish()
    };
  }
}, _169 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgBurn,
  MsgBurnResponse,
  MsgChangeAdmin,
  MsgChangeAdminResponse,
  MsgCreateDenom,
  MsgCreateDenomResponse,
  MsgForceTransfer,
  MsgForceTransferResponse,
  MsgMint,
  MsgMintResponse,
  MsgSetBeforeSendHook,
  MsgSetBeforeSendHookResponse,
  MsgSetDenomMetadata,
  MsgSetDenomMetadataResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseTwapRecord() {
  return {
    poolId: Long$2.UZERO,
    asset0Denom: "",
    asset1Denom: "",
    height: Long$2.ZERO,
    time: void 0,
    p0LastSpotPrice: "",
    p1LastSpotPrice: "",
    p0ArithmeticTwapAccumulator: "",
    p1ArithmeticTwapAccumulator: "",
    geometricTwapAccumulator: "",
    lastErrorTime: void 0
  };
}
const TwapRecord = {
  typeUrl: "/osmosis.twap.v1beta1.TwapRecord",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.asset0Denom !== "" && n.uint32(18).string(e.asset0Denom), e.asset1Denom !== "" && n.uint32(26).string(e.asset1Denom), e.height.isZero() || n.uint32(32).int64(e.height), e.time !== void 0 && Timestamp.encode(toTimestamp(e.time), n.uint32(42).fork()).ldelim(), e.p0LastSpotPrice !== "" && n.uint32(50).string(e.p0LastSpotPrice), e.p1LastSpotPrice !== "" && n.uint32(58).string(e.p1LastSpotPrice), e.p0ArithmeticTwapAccumulator !== "" && n.uint32(66).string(e.p0ArithmeticTwapAccumulator), e.p1ArithmeticTwapAccumulator !== "" && n.uint32(74).string(e.p1ArithmeticTwapAccumulator), e.geometricTwapAccumulator !== "" && n.uint32(82).string(e.geometricTwapAccumulator), e.lastErrorTime !== void 0 && Timestamp.encode(toTimestamp(e.lastErrorTime), n.uint32(90).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseTwapRecord();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.asset0Denom = o.string();
          break;
        case 3:
          c.asset1Denom = o.string();
          break;
        case 4:
          c.height = o.int64();
          break;
        case 5:
          c.time = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 6:
          c.p0LastSpotPrice = o.string();
          break;
        case 7:
          c.p1LastSpotPrice = o.string();
          break;
        case 8:
          c.p0ArithmeticTwapAccumulator = o.string();
          break;
        case 9:
          c.p1ArithmeticTwapAccumulator = o.string();
          break;
        case 10:
          c.geometricTwapAccumulator = o.string();
          break;
        case 11:
          c.lastErrorTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $;
    const E = createBaseTwapRecord();
    return E.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, E.asset0Denom = (n = e.asset0Denom) !== null && n !== void 0 ? n : "", E.asset1Denom = (o = e.asset1Denom) !== null && o !== void 0 ? o : "", E.height = e.height !== void 0 && e.height !== null ? Long$2.fromValue(e.height) : Long$2.ZERO, E.time = (u = e.time) !== null && u !== void 0 ? u : void 0, E.p0LastSpotPrice = (c = e.p0LastSpotPrice) !== null && c !== void 0 ? c : "", E.p1LastSpotPrice = (d = e.p1LastSpotPrice) !== null && d !== void 0 ? d : "", E.p0ArithmeticTwapAccumulator = (m = e.p0ArithmeticTwapAccumulator) !== null && m !== void 0 ? m : "", E.p1ArithmeticTwapAccumulator = (v = e.p1ArithmeticTwapAccumulator) !== null && v !== void 0 ? v : "", E.geometricTwapAccumulator = (S = e.geometricTwapAccumulator) !== null && S !== void 0 ? S : "", E.lastErrorTime = ($ = e.lastErrorTime) !== null && $ !== void 0 ? $ : void 0, E;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      asset0Denom: e.asset0_denom,
      asset1Denom: e.asset1_denom,
      height: Long$2.fromString(e.height),
      time: e != null && e.time ? Timestamp.fromAmino(e.time) : void 0,
      p0LastSpotPrice: e.p0_last_spot_price,
      p1LastSpotPrice: e.p1_last_spot_price,
      p0ArithmeticTwapAccumulator: e.p0_arithmetic_twap_accumulator,
      p1ArithmeticTwapAccumulator: e.p1_arithmetic_twap_accumulator,
      geometricTwapAccumulator: e.geometric_twap_accumulator,
      lastErrorTime: e != null && e.last_error_time ? Timestamp.fromAmino(e.last_error_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.asset0_denom = e.asset0Denom, n.asset1_denom = e.asset1Denom, n.height = e.height ? e.height.toString() : void 0, n.time = e.time ? Timestamp.toAmino(e.time) : void 0, n.p0_last_spot_price = e.p0LastSpotPrice, n.p1_last_spot_price = e.p1LastSpotPrice, n.p0_arithmetic_twap_accumulator = e.p0ArithmeticTwapAccumulator, n.p1_arithmetic_twap_accumulator = e.p1ArithmeticTwapAccumulator, n.geometric_twap_accumulator = e.geometricTwapAccumulator, n.last_error_time = e.lastErrorTime ? Timestamp.toAmino(e.lastErrorTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return TwapRecord.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/twap-record",
      value: TwapRecord.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return TwapRecord.decode(e.value);
  },
  toProto(e) {
    return TwapRecord.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.TwapRecord",
      value: TwapRecord.encode(e).finish()
    };
  }
}, _172 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TwapRecord
}, Symbol.toStringTag, { value: "Module" }));
function createBaseParams() {
  return {
    pruneEpochIdentifier: "",
    recordHistoryKeepPeriod: void 0
  };
}
const Params = {
  typeUrl: "/osmosis.twap.v1beta1.Params",
  encode(e, n = minimal.Writer.create()) {
    return e.pruneEpochIdentifier !== "" && n.uint32(10).string(e.pruneEpochIdentifier), e.recordHistoryKeepPeriod !== void 0 && Duration.encode(e.recordHistoryKeepPeriod, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParams();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.pruneEpochIdentifier = o.string();
          break;
        case 2:
          c.recordHistoryKeepPeriod = Duration.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseParams();
    return o.pruneEpochIdentifier = (n = e.pruneEpochIdentifier) !== null && n !== void 0 ? n : "", o.recordHistoryKeepPeriod = e.recordHistoryKeepPeriod !== void 0 && e.recordHistoryKeepPeriod !== null ? Duration.fromPartial(e.recordHistoryKeepPeriod) : void 0, o;
  },
  fromAmino(e) {
    return {
      pruneEpochIdentifier: e.prune_epoch_identifier,
      recordHistoryKeepPeriod: e != null && e.record_history_keep_period ? Duration.fromAmino(e.record_history_keep_period) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.prune_epoch_identifier = e.pruneEpochIdentifier, n.record_history_keep_period = e.recordHistoryKeepPeriod ? Duration.toAmino(e.recordHistoryKeepPeriod) : void 0, n;
  },
  fromAminoMsg(e) {
    return Params.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/params",
      value: Params.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return Params.decode(e.value);
  },
  toProto(e) {
    return Params.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.Params",
      value: Params.encode(e).finish()
    };
  }
};
function createBaseGenesisState$1() {
  return {
    twaps: [],
    params: void 0
  };
}
const GenesisState$1 = {
  typeUrl: "/osmosis.twap.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.twaps)
      TwapRecord.encode(o, n.uint32(10).fork()).ldelim();
    return e.params !== void 0 && Params.encode(e.params, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState$1();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.twaps.push(TwapRecord.decode(o, o.uint32()));
          break;
        case 2:
          c.params = Params.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGenesisState$1();
    return o.twaps = ((n = e.twaps) === null || n === void 0 ? void 0 : n.map((u) => TwapRecord.fromPartial(u))) || [], o.params = e.params !== void 0 && e.params !== null ? Params.fromPartial(e.params) : void 0, o;
  },
  fromAmino(e) {
    return {
      twaps: Array.isArray(e == null ? void 0 : e.twaps) ? e.twaps.map((n) => TwapRecord.fromAmino(n)) : [],
      params: e != null && e.params ? Params.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.twaps ? n.twaps = e.twaps.map((o) => o ? TwapRecord.toAmino(o) : void 0) : n.twaps = [], n.params = e.params ? Params.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return GenesisState$1.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/genesis-state",
      value: GenesisState$1.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState$1.decode(e.value);
  },
  toProto(e) {
    return GenesisState$1.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GenesisState",
      value: GenesisState$1.encode(e).finish()
    };
  }
}, _170 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState: GenesisState$1,
  Params
}, Symbol.toStringTag, { value: "Module" }));
function createBaseArithmeticTwapRequest() {
  return {
    poolId: Long$2.UZERO,
    baseAsset: "",
    quoteAsset: "",
    startTime: void 0,
    endTime: void 0
  };
}
const ArithmeticTwapRequest = {
  typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.baseAsset !== "" && n.uint32(18).string(e.baseAsset), e.quoteAsset !== "" && n.uint32(26).string(e.quoteAsset), e.startTime !== void 0 && Timestamp.encode(toTimestamp(e.startTime), n.uint32(34).fork()).ldelim(), e.endTime !== void 0 && Timestamp.encode(toTimestamp(e.endTime), n.uint32(42).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseArithmeticTwapRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.baseAsset = o.string();
          break;
        case 3:
          c.quoteAsset = o.string();
          break;
        case 4:
          c.startTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 5:
          c.endTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseArithmeticTwapRequest();
    return d.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, d.baseAsset = (n = e.baseAsset) !== null && n !== void 0 ? n : "", d.quoteAsset = (o = e.quoteAsset) !== null && o !== void 0 ? o : "", d.startTime = (u = e.startTime) !== null && u !== void 0 ? u : void 0, d.endTime = (c = e.endTime) !== null && c !== void 0 ? c : void 0, d;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      baseAsset: e.base_asset,
      quoteAsset: e.quote_asset,
      startTime: e != null && e.start_time ? Timestamp.fromAmino(e.start_time) : void 0,
      endTime: e != null && e.end_time ? Timestamp.fromAmino(e.end_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.base_asset = e.baseAsset, n.quote_asset = e.quoteAsset, n.start_time = e.startTime ? Timestamp.toAmino(e.startTime) : void 0, n.end_time = e.endTime ? Timestamp.toAmino(e.endTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return ArithmeticTwapRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/arithmetic-twap-request",
      value: ArithmeticTwapRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ArithmeticTwapRequest.decode(e.value);
  },
  toProto(e) {
    return ArithmeticTwapRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapRequest",
      value: ArithmeticTwapRequest.encode(e).finish()
    };
  }
};
function createBaseArithmeticTwapResponse() {
  return {
    arithmeticTwap: ""
  };
}
const ArithmeticTwapResponse = {
  typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.arithmeticTwap !== "" && n.uint32(10).string(e.arithmeticTwap), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseArithmeticTwapResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.arithmeticTwap = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseArithmeticTwapResponse();
    return o.arithmeticTwap = (n = e.arithmeticTwap) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      arithmeticTwap: e.arithmetic_twap
    };
  },
  toAmino(e) {
    const n = {};
    return n.arithmetic_twap = e.arithmeticTwap, n;
  },
  fromAminoMsg(e) {
    return ArithmeticTwapResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/arithmetic-twap-response",
      value: ArithmeticTwapResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ArithmeticTwapResponse.decode(e.value);
  },
  toProto(e) {
    return ArithmeticTwapResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapResponse",
      value: ArithmeticTwapResponse.encode(e).finish()
    };
  }
};
function createBaseArithmeticTwapToNowRequest() {
  return {
    poolId: Long$2.UZERO,
    baseAsset: "",
    quoteAsset: "",
    startTime: void 0
  };
}
const ArithmeticTwapToNowRequest = {
  typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapToNowRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.baseAsset !== "" && n.uint32(18).string(e.baseAsset), e.quoteAsset !== "" && n.uint32(26).string(e.quoteAsset), e.startTime !== void 0 && Timestamp.encode(toTimestamp(e.startTime), n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseArithmeticTwapToNowRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.baseAsset = o.string();
          break;
        case 3:
          c.quoteAsset = o.string();
          break;
        case 4:
          c.startTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseArithmeticTwapToNowRequest();
    return c.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, c.baseAsset = (n = e.baseAsset) !== null && n !== void 0 ? n : "", c.quoteAsset = (o = e.quoteAsset) !== null && o !== void 0 ? o : "", c.startTime = (u = e.startTime) !== null && u !== void 0 ? u : void 0, c;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      baseAsset: e.base_asset,
      quoteAsset: e.quote_asset,
      startTime: e != null && e.start_time ? Timestamp.fromAmino(e.start_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.base_asset = e.baseAsset, n.quote_asset = e.quoteAsset, n.start_time = e.startTime ? Timestamp.toAmino(e.startTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return ArithmeticTwapToNowRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/arithmetic-twap-to-now-request",
      value: ArithmeticTwapToNowRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ArithmeticTwapToNowRequest.decode(e.value);
  },
  toProto(e) {
    return ArithmeticTwapToNowRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapToNowRequest",
      value: ArithmeticTwapToNowRequest.encode(e).finish()
    };
  }
};
function createBaseArithmeticTwapToNowResponse() {
  return {
    arithmeticTwap: ""
  };
}
const ArithmeticTwapToNowResponse = {
  typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapToNowResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.arithmeticTwap !== "" && n.uint32(10).string(e.arithmeticTwap), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseArithmeticTwapToNowResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.arithmeticTwap = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseArithmeticTwapToNowResponse();
    return o.arithmeticTwap = (n = e.arithmeticTwap) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      arithmeticTwap: e.arithmetic_twap
    };
  },
  toAmino(e) {
    const n = {};
    return n.arithmetic_twap = e.arithmeticTwap, n;
  },
  fromAminoMsg(e) {
    return ArithmeticTwapToNowResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/arithmetic-twap-to-now-response",
      value: ArithmeticTwapToNowResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ArithmeticTwapToNowResponse.decode(e.value);
  },
  toProto(e) {
    return ArithmeticTwapToNowResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapToNowResponse",
      value: ArithmeticTwapToNowResponse.encode(e).finish()
    };
  }
};
function createBaseGeometricTwapRequest() {
  return {
    poolId: Long$2.UZERO,
    baseAsset: "",
    quoteAsset: "",
    startTime: void 0,
    endTime: void 0
  };
}
const GeometricTwapRequest = {
  typeUrl: "/osmosis.twap.v1beta1.GeometricTwapRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.baseAsset !== "" && n.uint32(18).string(e.baseAsset), e.quoteAsset !== "" && n.uint32(26).string(e.quoteAsset), e.startTime !== void 0 && Timestamp.encode(toTimestamp(e.startTime), n.uint32(34).fork()).ldelim(), e.endTime !== void 0 && Timestamp.encode(toTimestamp(e.endTime), n.uint32(42).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGeometricTwapRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.baseAsset = o.string();
          break;
        case 3:
          c.quoteAsset = o.string();
          break;
        case 4:
          c.startTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 5:
          c.endTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseGeometricTwapRequest();
    return d.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, d.baseAsset = (n = e.baseAsset) !== null && n !== void 0 ? n : "", d.quoteAsset = (o = e.quoteAsset) !== null && o !== void 0 ? o : "", d.startTime = (u = e.startTime) !== null && u !== void 0 ? u : void 0, d.endTime = (c = e.endTime) !== null && c !== void 0 ? c : void 0, d;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      baseAsset: e.base_asset,
      quoteAsset: e.quote_asset,
      startTime: e != null && e.start_time ? Timestamp.fromAmino(e.start_time) : void 0,
      endTime: e != null && e.end_time ? Timestamp.fromAmino(e.end_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.base_asset = e.baseAsset, n.quote_asset = e.quoteAsset, n.start_time = e.startTime ? Timestamp.toAmino(e.startTime) : void 0, n.end_time = e.endTime ? Timestamp.toAmino(e.endTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return GeometricTwapRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/geometric-twap-request",
      value: GeometricTwapRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GeometricTwapRequest.decode(e.value);
  },
  toProto(e) {
    return GeometricTwapRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GeometricTwapRequest",
      value: GeometricTwapRequest.encode(e).finish()
    };
  }
};
function createBaseGeometricTwapResponse() {
  return {
    geometricTwap: ""
  };
}
const GeometricTwapResponse = {
  typeUrl: "/osmosis.twap.v1beta1.GeometricTwapResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.geometricTwap !== "" && n.uint32(10).string(e.geometricTwap), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGeometricTwapResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.geometricTwap = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGeometricTwapResponse();
    return o.geometricTwap = (n = e.geometricTwap) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      geometricTwap: e.geometric_twap
    };
  },
  toAmino(e) {
    const n = {};
    return n.geometric_twap = e.geometricTwap, n;
  },
  fromAminoMsg(e) {
    return GeometricTwapResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/geometric-twap-response",
      value: GeometricTwapResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GeometricTwapResponse.decode(e.value);
  },
  toProto(e) {
    return GeometricTwapResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GeometricTwapResponse",
      value: GeometricTwapResponse.encode(e).finish()
    };
  }
};
function createBaseGeometricTwapToNowRequest() {
  return {
    poolId: Long$2.UZERO,
    baseAsset: "",
    quoteAsset: "",
    startTime: void 0
  };
}
const GeometricTwapToNowRequest = {
  typeUrl: "/osmosis.twap.v1beta1.GeometricTwapToNowRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.baseAsset !== "" && n.uint32(18).string(e.baseAsset), e.quoteAsset !== "" && n.uint32(26).string(e.quoteAsset), e.startTime !== void 0 && Timestamp.encode(toTimestamp(e.startTime), n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGeometricTwapToNowRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.baseAsset = o.string();
          break;
        case 3:
          c.quoteAsset = o.string();
          break;
        case 4:
          c.startTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseGeometricTwapToNowRequest();
    return c.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, c.baseAsset = (n = e.baseAsset) !== null && n !== void 0 ? n : "", c.quoteAsset = (o = e.quoteAsset) !== null && o !== void 0 ? o : "", c.startTime = (u = e.startTime) !== null && u !== void 0 ? u : void 0, c;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      baseAsset: e.base_asset,
      quoteAsset: e.quote_asset,
      startTime: e != null && e.start_time ? Timestamp.fromAmino(e.start_time) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.base_asset = e.baseAsset, n.quote_asset = e.quoteAsset, n.start_time = e.startTime ? Timestamp.toAmino(e.startTime) : void 0, n;
  },
  fromAminoMsg(e) {
    return GeometricTwapToNowRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/geometric-twap-to-now-request",
      value: GeometricTwapToNowRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GeometricTwapToNowRequest.decode(e.value);
  },
  toProto(e) {
    return GeometricTwapToNowRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GeometricTwapToNowRequest",
      value: GeometricTwapToNowRequest.encode(e).finish()
    };
  }
};
function createBaseGeometricTwapToNowResponse() {
  return {
    geometricTwap: ""
  };
}
const GeometricTwapToNowResponse = {
  typeUrl: "/osmosis.twap.v1beta1.GeometricTwapToNowResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.geometricTwap !== "" && n.uint32(10).string(e.geometricTwap), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGeometricTwapToNowResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.geometricTwap = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGeometricTwapToNowResponse();
    return o.geometricTwap = (n = e.geometricTwap) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      geometricTwap: e.geometric_twap
    };
  },
  toAmino(e) {
    const n = {};
    return n.geometric_twap = e.geometricTwap, n;
  },
  fromAminoMsg(e) {
    return GeometricTwapToNowResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/geometric-twap-to-now-response",
      value: GeometricTwapToNowResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GeometricTwapToNowResponse.decode(e.value);
  },
  toProto(e) {
    return GeometricTwapToNowResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GeometricTwapToNowResponse",
      value: GeometricTwapToNowResponse.encode(e).finish()
    };
  }
};
function createBaseParamsRequest() {
  return {};
}
const ParamsRequest = {
  typeUrl: "/osmosis.twap.v1beta1.ParamsRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParamsRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseParamsRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return ParamsRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/params-request",
      value: ParamsRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ParamsRequest.decode(e.value);
  },
  toProto(e) {
    return ParamsRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ParamsRequest",
      value: ParamsRequest.encode(e).finish()
    };
  }
};
function createBaseParamsResponse() {
  return {
    params: void 0
  };
}
const ParamsResponse = {
  typeUrl: "/osmosis.twap.v1beta1.ParamsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.params !== void 0 && Params.encode(e.params, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseParamsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.params = Params.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseParamsResponse();
    return n.params = e.params !== void 0 && e.params !== null ? Params.fromPartial(e.params) : void 0, n;
  },
  fromAmino(e) {
    return {
      params: e != null && e.params ? Params.fromAmino(e.params) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.params = e.params ? Params.toAmino(e.params) : void 0, n;
  },
  fromAminoMsg(e) {
    return ParamsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/twap/params-response",
      value: ParamsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ParamsResponse.decode(e.value);
  },
  toProto(e) {
    return ParamsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ParamsResponse",
      value: ParamsResponse.encode(e).finish()
    };
  }
}, _171 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ArithmeticTwapRequest,
  ArithmeticTwapResponse,
  ArithmeticTwapToNowRequest,
  ArithmeticTwapToNowResponse,
  GeometricTwapRequest,
  GeometricTwapResponse,
  GeometricTwapToNowRequest,
  GeometricTwapToNowResponse,
  ParamsRequest,
  ParamsResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseGenesisState() {
  return {
    basedenom: "",
    feetokens: []
  };
}
const GenesisState = {
  typeUrl: "/osmosis.txfees.v1beta1.GenesisState",
  encode(e, n = minimal.Writer.create()) {
    e.basedenom !== "" && n.uint32(10).string(e.basedenom);
    for (const o of e.feetokens)
      FeeToken.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGenesisState();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.basedenom = o.string();
          break;
        case 2:
          c.feetokens.push(FeeToken.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseGenesisState();
    return u.basedenom = (n = e.basedenom) !== null && n !== void 0 ? n : "", u.feetokens = ((o = e.feetokens) === null || o === void 0 ? void 0 : o.map((c) => FeeToken.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      basedenom: e.basedenom,
      feetokens: Array.isArray(e == null ? void 0 : e.feetokens) ? e.feetokens.map((n) => FeeToken.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.basedenom = e.basedenom, e.feetokens ? n.feetokens = e.feetokens.map((o) => o ? FeeToken.toAmino(o) : void 0) : n.feetokens = [], n;
  },
  fromAminoMsg(e) {
    return GenesisState.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/genesis-state",
      value: GenesisState.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return GenesisState.decode(e.value);
  },
  toProto(e) {
    return GenesisState.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.GenesisState",
      value: GenesisState.encode(e).finish()
    };
  }
}, _174 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenesisState
}, Symbol.toStringTag, { value: "Module" }));
function createBaseQueryFeeTokensRequest() {
  return {};
}
const QueryFeeTokensRequest = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryFeeTokensRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryFeeTokensRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryFeeTokensRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryFeeTokensRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/query-fee-tokens-request",
      value: QueryFeeTokensRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryFeeTokensRequest.decode(e.value);
  },
  toProto(e) {
    return QueryFeeTokensRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryFeeTokensRequest",
      value: QueryFeeTokensRequest.encode(e).finish()
    };
  }
};
function createBaseQueryFeeTokensResponse() {
  return {
    feeTokens: []
  };
}
const QueryFeeTokensResponse = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryFeeTokensResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.feeTokens)
      FeeToken.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryFeeTokensResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.feeTokens.push(FeeToken.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryFeeTokensResponse();
    return o.feeTokens = ((n = e.feeTokens) === null || n === void 0 ? void 0 : n.map((u) => FeeToken.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      feeTokens: Array.isArray(e == null ? void 0 : e.fee_tokens) ? e.fee_tokens.map((n) => FeeToken.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.feeTokens ? n.fee_tokens = e.feeTokens.map((o) => o ? FeeToken.toAmino(o) : void 0) : n.fee_tokens = [], n;
  },
  fromAminoMsg(e) {
    return QueryFeeTokensResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/query-fee-tokens-response",
      value: QueryFeeTokensResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryFeeTokensResponse.decode(e.value);
  },
  toProto(e) {
    return QueryFeeTokensResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryFeeTokensResponse",
      value: QueryFeeTokensResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDenomSpotPriceRequest() {
  return {
    denom: ""
  };
}
const QueryDenomSpotPriceRequest = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryDenomSpotPriceRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomSpotPriceRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomSpotPriceRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryDenomSpotPriceRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/query-denom-spot-price-request",
      value: QueryDenomSpotPriceRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomSpotPriceRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomSpotPriceRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryDenomSpotPriceRequest",
      value: QueryDenomSpotPriceRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomSpotPriceResponse() {
  return {
    poolID: Long$2.UZERO,
    spotPrice: ""
  };
}
const QueryDenomSpotPriceResponse = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryDenomSpotPriceResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.poolID.isZero() || n.uint32(8).uint64(e.poolID), e.spotPrice !== "" && n.uint32(18).string(e.spotPrice), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomSpotPriceResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolID = o.uint64();
          break;
        case 2:
          c.spotPrice = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomSpotPriceResponse();
    return o.poolID = e.poolID !== void 0 && e.poolID !== null ? Long$2.fromValue(e.poolID) : Long$2.UZERO, o.spotPrice = (n = e.spotPrice) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      poolID: Long$2.fromString(e.poolID),
      spotPrice: e.spot_price
    };
  },
  toAmino(e) {
    const n = {};
    return n.poolID = e.poolID ? e.poolID.toString() : void 0, n.spot_price = e.spotPrice, n;
  },
  fromAminoMsg(e) {
    return QueryDenomSpotPriceResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/query-denom-spot-price-response",
      value: QueryDenomSpotPriceResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomSpotPriceResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomSpotPriceResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryDenomSpotPriceResponse",
      value: QueryDenomSpotPriceResponse.encode(e).finish()
    };
  }
};
function createBaseQueryDenomPoolIdRequest() {
  return {
    denom: ""
  };
}
const QueryDenomPoolIdRequest = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryDenomPoolIdRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomPoolIdRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.denom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryDenomPoolIdRequest();
    return o.denom = (n = e.denom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      denom: e.denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.denom = e.denom, n;
  },
  fromAminoMsg(e) {
    return QueryDenomPoolIdRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/query-denom-pool-id-request",
      value: QueryDenomPoolIdRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomPoolIdRequest.decode(e.value);
  },
  toProto(e) {
    return QueryDenomPoolIdRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryDenomPoolIdRequest",
      value: QueryDenomPoolIdRequest.encode(e).finish()
    };
  }
};
function createBaseQueryDenomPoolIdResponse() {
  return {
    poolID: Long$2.UZERO
  };
}
const QueryDenomPoolIdResponse = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryDenomPoolIdResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.poolID.isZero() || n.uint32(8).uint64(e.poolID), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryDenomPoolIdResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolID = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseQueryDenomPoolIdResponse();
    return n.poolID = e.poolID !== void 0 && e.poolID !== null ? Long$2.fromValue(e.poolID) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      poolID: Long$2.fromString(e.poolID)
    };
  },
  toAmino(e) {
    const n = {};
    return n.poolID = e.poolID ? e.poolID.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return QueryDenomPoolIdResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/query-denom-pool-id-response",
      value: QueryDenomPoolIdResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryDenomPoolIdResponse.decode(e.value);
  },
  toProto(e) {
    return QueryDenomPoolIdResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryDenomPoolIdResponse",
      value: QueryDenomPoolIdResponse.encode(e).finish()
    };
  }
};
function createBaseQueryBaseDenomRequest() {
  return {};
}
const QueryBaseDenomRequest = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryBaseDenomRequest",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryBaseDenomRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseQueryBaseDenomRequest();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return QueryBaseDenomRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/query-base-denom-request",
      value: QueryBaseDenomRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryBaseDenomRequest.decode(e.value);
  },
  toProto(e) {
    return QueryBaseDenomRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryBaseDenomRequest",
      value: QueryBaseDenomRequest.encode(e).finish()
    };
  }
};
function createBaseQueryBaseDenomResponse() {
  return {
    baseDenom: ""
  };
}
const QueryBaseDenomResponse = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryBaseDenomResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.baseDenom !== "" && n.uint32(10).string(e.baseDenom), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseQueryBaseDenomResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.baseDenom = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseQueryBaseDenomResponse();
    return o.baseDenom = (n = e.baseDenom) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      baseDenom: e.base_denom
    };
  },
  toAmino(e) {
    const n = {};
    return n.base_denom = e.baseDenom, n;
  },
  fromAminoMsg(e) {
    return QueryBaseDenomResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/txfees/query-base-denom-response",
      value: QueryBaseDenomResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return QueryBaseDenomResponse.decode(e.value);
  },
  toProto(e) {
    return QueryBaseDenomResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryBaseDenomResponse",
      value: QueryBaseDenomResponse.encode(e).finish()
    };
  }
}, _176 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryBaseDenomRequest,
  QueryBaseDenomResponse,
  QueryDenomPoolIdRequest,
  QueryDenomPoolIdResponse,
  QueryDenomSpotPriceRequest,
  QueryDenomSpotPriceResponse,
  QueryFeeTokensRequest,
  QueryFeeTokensResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseValidatorPreference() {
  return {
    valOperAddress: "",
    weight: ""
  };
}
const ValidatorPreference = {
  typeUrl: "/osmosis.valsetpref.v1beta1.ValidatorPreference",
  encode(e, n = minimal.Writer.create()) {
    return e.valOperAddress !== "" && n.uint32(10).string(e.valOperAddress), e.weight !== "" && n.uint32(18).string(e.weight), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorPreference();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.valOperAddress = o.string();
          break;
        case 2:
          c.weight = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseValidatorPreference();
    return u.valOperAddress = (n = e.valOperAddress) !== null && n !== void 0 ? n : "", u.weight = (o = e.weight) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      valOperAddress: e.val_oper_address,
      weight: e.weight
    };
  },
  toAmino(e) {
    const n = {};
    return n.val_oper_address = e.valOperAddress, n.weight = e.weight, n;
  },
  fromAminoMsg(e) {
    return ValidatorPreference.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/validator-preference",
      value: ValidatorPreference.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorPreference.decode(e.value);
  },
  toProto(e) {
    return ValidatorPreference.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.ValidatorPreference",
      value: ValidatorPreference.encode(e).finish()
    };
  }
};
function createBaseValidatorSetPreferences() {
  return {
    preferences: []
  };
}
const ValidatorSetPreferences = {
  typeUrl: "/osmosis.valsetpref.v1beta1.ValidatorSetPreferences",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.preferences)
      ValidatorPreference.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseValidatorSetPreferences();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.preferences.push(ValidatorPreference.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseValidatorSetPreferences();
    return o.preferences = ((n = e.preferences) === null || n === void 0 ? void 0 : n.map((u) => ValidatorPreference.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      preferences: Array.isArray(e == null ? void 0 : e.preferences) ? e.preferences.map((n) => ValidatorPreference.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.preferences ? n.preferences = e.preferences.map((o) => o ? ValidatorPreference.toAmino(o) : void 0) : n.preferences = [], n;
  },
  fromAminoMsg(e) {
    return ValidatorSetPreferences.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/validator-set-preferences",
      value: ValidatorSetPreferences.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return ValidatorSetPreferences.decode(e.value);
  },
  toProto(e) {
    return ValidatorSetPreferences.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.ValidatorSetPreferences",
      value: ValidatorSetPreferences.encode(e).finish()
    };
  }
}, _178 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ValidatorPreference,
  ValidatorSetPreferences
}, Symbol.toStringTag, { value: "Module" }));
function createBaseUserValidatorPreferencesRequest() {
  return {
    address: ""
  };
}
const UserValidatorPreferencesRequest = {
  typeUrl: "/osmosis.valsetpref.v1beta1.UserValidatorPreferencesRequest",
  encode(e, n = minimal.Writer.create()) {
    return e.address !== "" && n.uint32(10).string(e.address), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUserValidatorPreferencesRequest();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.address = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseUserValidatorPreferencesRequest();
    return o.address = (n = e.address) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      address: e.address
    };
  },
  toAmino(e) {
    const n = {};
    return n.address = e.address, n;
  },
  fromAminoMsg(e) {
    return UserValidatorPreferencesRequest.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/user-validator-preferences-request",
      value: UserValidatorPreferencesRequest.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UserValidatorPreferencesRequest.decode(e.value);
  },
  toProto(e) {
    return UserValidatorPreferencesRequest.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.UserValidatorPreferencesRequest",
      value: UserValidatorPreferencesRequest.encode(e).finish()
    };
  }
};
function createBaseUserValidatorPreferencesResponse() {
  return {
    preferences: []
  };
}
const UserValidatorPreferencesResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.UserValidatorPreferencesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.preferences)
      ValidatorPreference.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUserValidatorPreferencesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.preferences.push(ValidatorPreference.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseUserValidatorPreferencesResponse();
    return o.preferences = ((n = e.preferences) === null || n === void 0 ? void 0 : n.map((u) => ValidatorPreference.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      preferences: Array.isArray(e == null ? void 0 : e.preferences) ? e.preferences.map((n) => ValidatorPreference.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.preferences ? n.preferences = e.preferences.map((o) => o ? ValidatorPreference.toAmino(o) : void 0) : n.preferences = [], n;
  },
  fromAminoMsg(e) {
    return UserValidatorPreferencesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/user-validator-preferences-response",
      value: UserValidatorPreferencesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return UserValidatorPreferencesResponse.decode(e.value);
  },
  toProto(e) {
    return UserValidatorPreferencesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.UserValidatorPreferencesResponse",
      value: UserValidatorPreferencesResponse.encode(e).finish()
    };
  }
}, _177 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UserValidatorPreferencesRequest,
  UserValidatorPreferencesResponse
}, Symbol.toStringTag, { value: "Module" }));
function createBaseMsgSetValidatorSetPreference() {
  return {
    delegator: "",
    preferences: []
  };
}
const MsgSetValidatorSetPreference = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
  encode(e, n = minimal.Writer.create()) {
    e.delegator !== "" && n.uint32(10).string(e.delegator);
    for (const o of e.preferences)
      ValidatorPreference.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetValidatorSetPreference();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegator = o.string();
          break;
        case 2:
          c.preferences.push(ValidatorPreference.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgSetValidatorSetPreference();
    return u.delegator = (n = e.delegator) !== null && n !== void 0 ? n : "", u.preferences = ((o = e.preferences) === null || o === void 0 ? void 0 : o.map((c) => ValidatorPreference.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      delegator: e.delegator,
      preferences: Array.isArray(e == null ? void 0 : e.preferences) ? e.preferences.map((n) => ValidatorPreference.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator = e.delegator, e.preferences ? n.preferences = e.preferences.map((o) => o ? ValidatorPreference.toAmino(o) : void 0) : n.preferences = [], n;
  },
  fromAminoMsg(e) {
    return MsgSetValidatorSetPreference.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valset-pref/MsgSetValidatorSetPreference",
      value: MsgSetValidatorSetPreference.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetValidatorSetPreference.decode(e.value);
  },
  toProto(e) {
    return MsgSetValidatorSetPreference.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
      value: MsgSetValidatorSetPreference.encode(e).finish()
    };
  }
};
function createBaseMsgSetValidatorSetPreferenceResponse() {
  return {};
}
const MsgSetValidatorSetPreferenceResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreferenceResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgSetValidatorSetPreferenceResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgSetValidatorSetPreferenceResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgSetValidatorSetPreferenceResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/set-validator-set-preference-response",
      value: MsgSetValidatorSetPreferenceResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgSetValidatorSetPreferenceResponse.decode(e.value);
  },
  toProto(e) {
    return MsgSetValidatorSetPreferenceResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreferenceResponse",
      value: MsgSetValidatorSetPreferenceResponse.encode(e).finish()
    };
  }
};
function createBaseMsgDelegateToValidatorSet() {
  return {
    delegator: "",
    coin: void 0
  };
}
const MsgDelegateToValidatorSet = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
  encode(e, n = minimal.Writer.create()) {
    return e.delegator !== "" && n.uint32(10).string(e.delegator), e.coin !== void 0 && Coin.encode(e.coin, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDelegateToValidatorSet();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegator = o.string();
          break;
        case 2:
          c.coin = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgDelegateToValidatorSet();
    return o.delegator = (n = e.delegator) !== null && n !== void 0 ? n : "", o.coin = e.coin !== void 0 && e.coin !== null ? Coin.fromPartial(e.coin) : void 0, o;
  },
  fromAmino(e) {
    return {
      delegator: e.delegator,
      coin: e != null && e.coin ? Coin.fromAmino(e.coin) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator = e.delegator, n.coin = e.coin ? Coin.toAmino(e.coin) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgDelegateToValidatorSet.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valset-pref/MsgDelegateToValidatorSet",
      value: MsgDelegateToValidatorSet.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDelegateToValidatorSet.decode(e.value);
  },
  toProto(e) {
    return MsgDelegateToValidatorSet.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
      value: MsgDelegateToValidatorSet.encode(e).finish()
    };
  }
};
function createBaseMsgDelegateToValidatorSetResponse() {
  return {};
}
const MsgDelegateToValidatorSetResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSetResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDelegateToValidatorSetResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgDelegateToValidatorSetResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgDelegateToValidatorSetResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/delegate-to-validator-set-response",
      value: MsgDelegateToValidatorSetResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDelegateToValidatorSetResponse.decode(e.value);
  },
  toProto(e) {
    return MsgDelegateToValidatorSetResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSetResponse",
      value: MsgDelegateToValidatorSetResponse.encode(e).finish()
    };
  }
};
function createBaseMsgUndelegateFromValidatorSet() {
  return {
    delegator: "",
    coin: void 0
  };
}
const MsgUndelegateFromValidatorSet = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
  encode(e, n = minimal.Writer.create()) {
    return e.delegator !== "" && n.uint32(10).string(e.delegator), e.coin !== void 0 && Coin.encode(e.coin, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUndelegateFromValidatorSet();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegator = o.string();
          break;
        case 3:
          c.coin = Coin.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgUndelegateFromValidatorSet();
    return o.delegator = (n = e.delegator) !== null && n !== void 0 ? n : "", o.coin = e.coin !== void 0 && e.coin !== null ? Coin.fromPartial(e.coin) : void 0, o;
  },
  fromAmino(e) {
    return {
      delegator: e.delegator,
      coin: e != null && e.coin ? Coin.fromAmino(e.coin) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator = e.delegator, n.coin = e.coin ? Coin.toAmino(e.coin) : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgUndelegateFromValidatorSet.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valset-pref/MsgUndelegateFromValidatorSet",
      value: MsgUndelegateFromValidatorSet.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUndelegateFromValidatorSet.decode(e.value);
  },
  toProto(e) {
    return MsgUndelegateFromValidatorSet.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
      value: MsgUndelegateFromValidatorSet.encode(e).finish()
    };
  }
};
function createBaseMsgUndelegateFromValidatorSetResponse() {
  return {};
}
const MsgUndelegateFromValidatorSetResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSetResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgUndelegateFromValidatorSetResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgUndelegateFromValidatorSetResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgUndelegateFromValidatorSetResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/undelegate-from-validator-set-response",
      value: MsgUndelegateFromValidatorSetResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgUndelegateFromValidatorSetResponse.decode(e.value);
  },
  toProto(e) {
    return MsgUndelegateFromValidatorSetResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSetResponse",
      value: MsgUndelegateFromValidatorSetResponse.encode(e).finish()
    };
  }
};
function createBaseMsgRedelegateValidatorSet() {
  return {
    delegator: "",
    preferences: []
  };
}
const MsgRedelegateValidatorSet = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
  encode(e, n = minimal.Writer.create()) {
    e.delegator !== "" && n.uint32(10).string(e.delegator);
    for (const o of e.preferences)
      ValidatorPreference.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRedelegateValidatorSet();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegator = o.string();
          break;
        case 2:
          c.preferences.push(ValidatorPreference.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgRedelegateValidatorSet();
    return u.delegator = (n = e.delegator) !== null && n !== void 0 ? n : "", u.preferences = ((o = e.preferences) === null || o === void 0 ? void 0 : o.map((c) => ValidatorPreference.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      delegator: e.delegator,
      preferences: Array.isArray(e == null ? void 0 : e.preferences) ? e.preferences.map((n) => ValidatorPreference.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator = e.delegator, e.preferences ? n.preferences = e.preferences.map((o) => o ? ValidatorPreference.toAmino(o) : void 0) : n.preferences = [], n;
  },
  fromAminoMsg(e) {
    return MsgRedelegateValidatorSet.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/redelegate-validator-set",
      value: MsgRedelegateValidatorSet.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRedelegateValidatorSet.decode(e.value);
  },
  toProto(e) {
    return MsgRedelegateValidatorSet.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
      value: MsgRedelegateValidatorSet.encode(e).finish()
    };
  }
};
function createBaseMsgRedelegateValidatorSetResponse() {
  return {};
}
const MsgRedelegateValidatorSetResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSetResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgRedelegateValidatorSetResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgRedelegateValidatorSetResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgRedelegateValidatorSetResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/redelegate-validator-set-response",
      value: MsgRedelegateValidatorSetResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgRedelegateValidatorSetResponse.decode(e.value);
  },
  toProto(e) {
    return MsgRedelegateValidatorSetResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSetResponse",
      value: MsgRedelegateValidatorSetResponse.encode(e).finish()
    };
  }
};
function createBaseMsgWithdrawDelegationRewards() {
  return {
    delegator: ""
  };
}
const MsgWithdrawDelegationRewards = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
  encode(e, n = minimal.Writer.create()) {
    return e.delegator !== "" && n.uint32(10).string(e.delegator), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgWithdrawDelegationRewards();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegator = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgWithdrawDelegationRewards();
    return o.delegator = (n = e.delegator) !== null && n !== void 0 ? n : "", o;
  },
  fromAmino(e) {
    return {
      delegator: e.delegator
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator = e.delegator, n;
  },
  fromAminoMsg(e) {
    return MsgWithdrawDelegationRewards.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valset-pref/MsgWithdrawDelegationRewards",
      value: MsgWithdrawDelegationRewards.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgWithdrawDelegationRewards.decode(e.value);
  },
  toProto(e) {
    return MsgWithdrawDelegationRewards.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
      value: MsgWithdrawDelegationRewards.encode(e).finish()
    };
  }
};
function createBaseMsgWithdrawDelegationRewardsResponse() {
  return {};
}
const MsgWithdrawDelegationRewardsResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewardsResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgWithdrawDelegationRewardsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgWithdrawDelegationRewardsResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgWithdrawDelegationRewardsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/withdraw-delegation-rewards-response",
      value: MsgWithdrawDelegationRewardsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgWithdrawDelegationRewardsResponse.decode(e.value);
  },
  toProto(e) {
    return MsgWithdrawDelegationRewardsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewardsResponse",
      value: MsgWithdrawDelegationRewardsResponse.encode(e).finish()
    };
  }
};
function createBaseMsgDelegateBondedTokens() {
  return {
    delegator: "",
    lockID: Long$2.UZERO
  };
}
const MsgDelegateBondedTokens = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
  encode(e, n = minimal.Writer.create()) {
    return e.delegator !== "" && n.uint32(10).string(e.delegator), e.lockID.isZero() || n.uint32(16).uint64(e.lockID), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDelegateBondedTokens();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.delegator = o.string();
          break;
        case 2:
          c.lockID = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgDelegateBondedTokens();
    return o.delegator = (n = e.delegator) !== null && n !== void 0 ? n : "", o.lockID = e.lockID !== void 0 && e.lockID !== null ? Long$2.fromValue(e.lockID) : Long$2.UZERO, o;
  },
  fromAmino(e) {
    return {
      delegator: e.delegator,
      lockID: Long$2.fromString(e.lockID)
    };
  },
  toAmino(e) {
    const n = {};
    return n.delegator = e.delegator, n.lockID = e.lockID ? e.lockID.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgDelegateBondedTokens.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/delegate-bonded-tokens",
      value: MsgDelegateBondedTokens.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDelegateBondedTokens.decode(e.value);
  },
  toProto(e) {
    return MsgDelegateBondedTokens.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
      value: MsgDelegateBondedTokens.encode(e).finish()
    };
  }
};
function createBaseMsgDelegateBondedTokensResponse() {
  return {};
}
const MsgDelegateBondedTokensResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokensResponse",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgDelegateBondedTokensResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseMsgDelegateBondedTokensResponse();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return MsgDelegateBondedTokensResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/valsetpref/delegate-bonded-tokens-response",
      value: MsgDelegateBondedTokensResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgDelegateBondedTokensResponse.decode(e.value);
  },
  toProto(e) {
    return MsgDelegateBondedTokensResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokensResponse",
      value: MsgDelegateBondedTokensResponse.encode(e).finish()
    };
  }
}, _179 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgDelegateBondedTokens,
  MsgDelegateBondedTokensResponse,
  MsgDelegateToValidatorSet,
  MsgDelegateToValidatorSetResponse,
  MsgRedelegateValidatorSet,
  MsgRedelegateValidatorSetResponse,
  MsgSetValidatorSetPreference,
  MsgSetValidatorSetPreferenceResponse,
  MsgUndelegateFromValidatorSet,
  MsgUndelegateFromValidatorSetResponse,
  MsgWithdrawDelegationRewards,
  MsgWithdrawDelegationRewardsResponse
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$a = {
  "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool": {
    aminoType: "osmosis/gamm/create-balancer-pool",
    toAmino: MsgCreateBalancerPool.toAmino,
    fromAmino: MsgCreateBalancerPool.fromAmino
  },
  "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPosition": {
    aminoType: "osmosis/gamm/poolmodels/balancer/migrate-shares-to-full-range-concentrated-position",
    toAmino: MsgMigrateSharesToFullRangeConcentratedPosition.toAmino,
    fromAmino: MsgMigrateSharesToFullRangeConcentratedPosition.fromAmino
  }
}, _267 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$a
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$9 = {
  "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool": {
    aminoType: "osmosis/gamm/create-stableswap-pool",
    toAmino: MsgCreateStableswapPool.toAmino,
    fromAmino: MsgCreateStableswapPool.fromAmino
  },
  "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors": {
    aminoType: "osmosis/gamm/stableswap-adjust-scaling-factors",
    toAmino: MsgStableSwapAdjustScalingFactors.toAmino,
    fromAmino: MsgStableSwapAdjustScalingFactors.fromAmino
  }
}, _268 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$9
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$8 = {
  "/osmosis.gamm.v1beta1.MsgJoinPool": {
    aminoType: "osmosis/gamm/join-pool",
    toAmino: MsgJoinPool.toAmino,
    fromAmino: MsgJoinPool.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgExitPool": {
    aminoType: "osmosis/gamm/exit-pool",
    toAmino: MsgExitPool.toAmino,
    fromAmino: MsgExitPool.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn": {
    aminoType: "osmosis/gamm/swap-exact-amount-in",
    toAmino: MsgSwapExactAmountIn$1.toAmino,
    fromAmino: MsgSwapExactAmountIn$1.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut": {
    aminoType: "osmosis/gamm/swap-exact-amount-out",
    toAmino: MsgSwapExactAmountOut$1.toAmino,
    fromAmino: MsgSwapExactAmountOut$1.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn": {
    aminoType: "osmosis/gamm/join-swap-extern-amount-in",
    toAmino: MsgJoinSwapExternAmountIn.toAmino,
    fromAmino: MsgJoinSwapExternAmountIn.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut": {
    aminoType: "osmosis/gamm/join-swap-share-amount-out",
    toAmino: MsgJoinSwapShareAmountOut.toAmino,
    fromAmino: MsgJoinSwapShareAmountOut.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut": {
    aminoType: "osmosis/gamm/exit-swap-extern-amount-out",
    toAmino: MsgExitSwapExternAmountOut.toAmino,
    fromAmino: MsgExitSwapExternAmountOut.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn": {
    aminoType: "osmosis/gamm/exit-swap-share-amount-in",
    toAmino: MsgExitSwapShareAmountIn.toAmino,
    fromAmino: MsgExitSwapShareAmountIn.fromAmino
  }
}, _269 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$8
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$7 = {
  "/osmosis.incentives.MsgCreateGauge": {
    aminoType: "osmosis/incentives/create-gauge",
    toAmino: MsgCreateGauge.toAmino,
    fromAmino: MsgCreateGauge.fromAmino
  },
  "/osmosis.incentives.MsgAddToGauge": {
    aminoType: "osmosis/incentives/add-to-gauge",
    toAmino: MsgAddToGauge.toAmino,
    fromAmino: MsgAddToGauge.fromAmino
  }
}, _270 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$7
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$6 = {
  "/osmosis.lockup.MsgLockTokens": {
    aminoType: "osmosis/lockup/lock-tokens",
    toAmino: MsgLockTokens.toAmino,
    fromAmino: MsgLockTokens.fromAmino
  },
  "/osmosis.lockup.MsgBeginUnlockingAll": {
    aminoType: "osmosis/lockup/begin-unlock-tokens",
    toAmino: MsgBeginUnlockingAll.toAmino,
    fromAmino: MsgBeginUnlockingAll.fromAmino
  },
  "/osmosis.lockup.MsgBeginUnlocking": {
    aminoType: "osmosis/lockup/begin-unlock-period-lock",
    toAmino: MsgBeginUnlocking.toAmino,
    fromAmino: MsgBeginUnlocking.fromAmino
  },
  "/osmosis.lockup.MsgExtendLockup": {
    aminoType: "osmosis/lockup/extend-lockup",
    toAmino: MsgExtendLockup.toAmino,
    fromAmino: MsgExtendLockup.fromAmino
  },
  "/osmosis.lockup.MsgForceUnlock": {
    aminoType: "osmosis/lockup/force-unlock",
    toAmino: MsgForceUnlock.toAmino,
    fromAmino: MsgForceUnlock.fromAmino
  }
}, _271 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$6
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$5 = {
  "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn": {
    aminoType: "osmosis/poolmanager/swap-exact-amount-in",
    toAmino: MsgSwapExactAmountIn.toAmino,
    fromAmino: MsgSwapExactAmountIn.fromAmino
  },
  "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut": {
    aminoType: "osmosis/poolmanager/swap-exact-amount-out",
    toAmino: MsgSwapExactAmountOut.toAmino,
    fromAmino: MsgSwapExactAmountOut.fromAmino
  }
}, _272 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$5
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$4 = {
  "/osmosis.protorev.v1beta1.MsgSetHotRoutes": {
    aminoType: "osmosis/MsgSetHotRoutes",
    toAmino: MsgSetHotRoutes.toAmino,
    fromAmino: MsgSetHotRoutes.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount": {
    aminoType: "osmosis/MsgSetDeveloperAccount",
    toAmino: MsgSetDeveloperAccount.toAmino,
    fromAmino: MsgSetDeveloperAccount.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx": {
    aminoType: "osmosis/protorev/set-max-pool-points-per-tx",
    toAmino: MsgSetMaxPoolPointsPerTx.toAmino,
    fromAmino: MsgSetMaxPoolPointsPerTx.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock": {
    aminoType: "osmosis/protorev/set-max-pool-points-per-block",
    toAmino: MsgSetMaxPoolPointsPerBlock.toAmino,
    fromAmino: MsgSetMaxPoolPointsPerBlock.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetPoolWeights": {
    aminoType: "osmosis/protorev/set-pool-weights",
    toAmino: MsgSetPoolWeights.toAmino,
    fromAmino: MsgSetPoolWeights.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetBaseDenoms": {
    aminoType: "osmosis/protorev/set-base-denoms",
    toAmino: MsgSetBaseDenoms.toAmino,
    fromAmino: MsgSetBaseDenoms.fromAmino
  }
}, _273 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$4
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$3 = {
  "/osmosis.superfluid.MsgSuperfluidDelegate": {
    aminoType: "osmosis/superfluid-delegate",
    toAmino: MsgSuperfluidDelegate.toAmino,
    fromAmino: MsgSuperfluidDelegate.fromAmino
  },
  "/osmosis.superfluid.MsgSuperfluidUndelegate": {
    aminoType: "osmosis/superfluid-undelegate",
    toAmino: MsgSuperfluidUndelegate.toAmino,
    fromAmino: MsgSuperfluidUndelegate.fromAmino
  },
  "/osmosis.superfluid.MsgSuperfluidUnbondLock": {
    aminoType: "osmosis/superfluid-unbond-lock",
    toAmino: MsgSuperfluidUnbondLock.toAmino,
    fromAmino: MsgSuperfluidUnbondLock.fromAmino
  },
  "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock": {
    aminoType: "osmosis/superfluid-undelegate-and-unbond-lock",
    toAmino: MsgSuperfluidUndelegateAndUnbondLock.toAmino,
    fromAmino: MsgSuperfluidUndelegateAndUnbondLock.fromAmino
  },
  "/osmosis.superfluid.MsgLockAndSuperfluidDelegate": {
    aminoType: "osmosis/lock-and-superfluid-delegate",
    toAmino: MsgLockAndSuperfluidDelegate.toAmino,
    fromAmino: MsgLockAndSuperfluidDelegate.fromAmino
  },
  "/osmosis.superfluid.MsgUnPoolWhitelistedPool": {
    aminoType: "osmosis/unpool-whitelisted-pool",
    toAmino: MsgUnPoolWhitelistedPool.toAmino,
    fromAmino: MsgUnPoolWhitelistedPool.fromAmino
  },
  "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition": {
    aminoType: "osmosis/unlock-and-migrate-shares-to-full-range-concentrated-position",
    toAmino: MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.toAmino,
    fromAmino: MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.fromAmino
  }
}, _274 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$3
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$2 = {
  "/osmosis.tokenfactory.v1beta1.MsgCreateDenom": {
    aminoType: "osmosis/tokenfactory/create-denom",
    toAmino: MsgCreateDenom.toAmino,
    fromAmino: MsgCreateDenom.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgMint": {
    aminoType: "osmosis/tokenfactory/mint",
    toAmino: MsgMint.toAmino,
    fromAmino: MsgMint.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgBurn": {
    aminoType: "osmosis/tokenfactory/burn",
    toAmino: MsgBurn.toAmino,
    fromAmino: MsgBurn.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin": {
    aminoType: "osmosis/tokenfactory/change-admin",
    toAmino: MsgChangeAdmin.toAmino,
    fromAmino: MsgChangeAdmin.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata": {
    aminoType: "osmosis/tokenfactory/set-denom-metadata",
    toAmino: MsgSetDenomMetadata.toAmino,
    fromAmino: MsgSetDenomMetadata.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook": {
    aminoType: "osmosis/tokenfactory/set-before-send-hook",
    toAmino: MsgSetBeforeSendHook.toAmino,
    fromAmino: MsgSetBeforeSendHook.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgForceTransfer": {
    aminoType: "osmosis/tokenfactory/force-transfer",
    toAmino: MsgForceTransfer.toAmino,
    fromAmino: MsgForceTransfer.fromAmino
  }
}, _275 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$2
}, Symbol.toStringTag, { value: "Module" })), AminoConverter$1 = {
  "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference": {
    aminoType: "osmosis/valset-pref/MsgSetValidatorSetPreference",
    toAmino: MsgSetValidatorSetPreference.toAmino,
    fromAmino: MsgSetValidatorSetPreference.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet": {
    aminoType: "osmosis/valset-pref/MsgDelegateToValidatorSet",
    toAmino: MsgDelegateToValidatorSet.toAmino,
    fromAmino: MsgDelegateToValidatorSet.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet": {
    aminoType: "osmosis/valset-pref/MsgUndelegateFromValidatorSet",
    toAmino: MsgUndelegateFromValidatorSet.toAmino,
    fromAmino: MsgUndelegateFromValidatorSet.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet": {
    aminoType: "osmosis/valsetpref/redelegate-validator-set",
    toAmino: MsgRedelegateValidatorSet.toAmino,
    fromAmino: MsgRedelegateValidatorSet.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards": {
    aminoType: "osmosis/valset-pref/MsgWithdrawDelegationRewards",
    toAmino: MsgWithdrawDelegationRewards.toAmino,
    fromAmino: MsgWithdrawDelegationRewards.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens": {
    aminoType: "osmosis/valsetpref/delegate-bonded-tokens",
    toAmino: MsgDelegateBondedTokens.toAmino,
    fromAmino: MsgDelegateBondedTokens.fromAmino
  }
}, _276 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AminoConverter: AminoConverter$1
}, Symbol.toStringTag, { value: "Module" })), registry$b = [["/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool", MsgCreateBalancerPool], ["/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPosition", MsgMigrateSharesToFullRangeConcentratedPosition]], load$9 = (e) => {
  registry$b.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$9 = {
  encoded: {
    createBalancerPool(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
        value: MsgCreateBalancerPool.encode(e).finish()
      };
    },
    migrateSharesToFullRangeConcentratedPosition(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPosition",
        value: MsgMigrateSharesToFullRangeConcentratedPosition.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    createBalancerPool(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
        value: e
      };
    },
    migrateSharesToFullRangeConcentratedPosition(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPosition",
        value: e
      };
    }
  },
  fromPartial: {
    createBalancerPool(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
        value: MsgCreateBalancerPool.fromPartial(e)
      };
    },
    migrateSharesToFullRangeConcentratedPosition(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgMigrateSharesToFullRangeConcentratedPosition",
        value: MsgMigrateSharesToFullRangeConcentratedPosition.fromPartial(e)
      };
    }
  }
}, _278 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$9,
  load: load$9,
  registry: registry$b
}, Symbol.toStringTag, { value: "Module" })), registry$a = [["/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool", MsgCreateStableswapPool], ["/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors", MsgStableSwapAdjustScalingFactors]], load$8 = (e) => {
  registry$a.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$8 = {
  encoded: {
    createStableswapPool(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
        value: MsgCreateStableswapPool.encode(e).finish()
      };
    },
    stableSwapAdjustScalingFactors(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
        value: MsgStableSwapAdjustScalingFactors.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    createStableswapPool(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
        value: e
      };
    },
    stableSwapAdjustScalingFactors(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
        value: e
      };
    }
  },
  fromPartial: {
    createStableswapPool(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
        value: MsgCreateStableswapPool.fromPartial(e)
      };
    },
    stableSwapAdjustScalingFactors(e) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
        value: MsgStableSwapAdjustScalingFactors.fromPartial(e)
      };
    }
  }
}, _279 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$8,
  load: load$8,
  registry: registry$a
}, Symbol.toStringTag, { value: "Module" })), registry$9 = [["/osmosis.gamm.v1beta1.MsgJoinPool", MsgJoinPool], ["/osmosis.gamm.v1beta1.MsgExitPool", MsgExitPool], ["/osmosis.gamm.v1beta1.MsgSwapExactAmountIn", MsgSwapExactAmountIn$1], ["/osmosis.gamm.v1beta1.MsgSwapExactAmountOut", MsgSwapExactAmountOut$1], ["/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn", MsgJoinSwapExternAmountIn], ["/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut", MsgJoinSwapShareAmountOut], ["/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut", MsgExitSwapExternAmountOut], ["/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn", MsgExitSwapShareAmountIn]], load$7 = (e) => {
  registry$9.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$7 = {
  encoded: {
    joinPool(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
        value: MsgJoinPool.encode(e).finish()
      };
    },
    exitPool(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
        value: MsgExitPool.encode(e).finish()
      };
    },
    swapExactAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
        value: MsgSwapExactAmountIn$1.encode(e).finish()
      };
    },
    swapExactAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
        value: MsgSwapExactAmountOut$1.encode(e).finish()
      };
    },
    joinSwapExternAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
        value: MsgJoinSwapExternAmountIn.encode(e).finish()
      };
    },
    joinSwapShareAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
        value: MsgJoinSwapShareAmountOut.encode(e).finish()
      };
    },
    exitSwapExternAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
        value: MsgExitSwapExternAmountOut.encode(e).finish()
      };
    },
    exitSwapShareAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
        value: MsgExitSwapShareAmountIn.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    joinPool(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
        value: e
      };
    },
    exitPool(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
        value: e
      };
    },
    swapExactAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
        value: e
      };
    },
    swapExactAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
        value: e
      };
    },
    joinSwapExternAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
        value: e
      };
    },
    joinSwapShareAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
        value: e
      };
    },
    exitSwapExternAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
        value: e
      };
    },
    exitSwapShareAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
        value: e
      };
    }
  },
  fromPartial: {
    joinPool(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
        value: MsgJoinPool.fromPartial(e)
      };
    },
    exitPool(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
        value: MsgExitPool.fromPartial(e)
      };
    },
    swapExactAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
        value: MsgSwapExactAmountIn$1.fromPartial(e)
      };
    },
    swapExactAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
        value: MsgSwapExactAmountOut$1.fromPartial(e)
      };
    },
    joinSwapExternAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
        value: MsgJoinSwapExternAmountIn.fromPartial(e)
      };
    },
    joinSwapShareAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
        value: MsgJoinSwapShareAmountOut.fromPartial(e)
      };
    },
    exitSwapExternAmountOut(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
        value: MsgExitSwapExternAmountOut.fromPartial(e)
      };
    },
    exitSwapShareAmountIn(e) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
        value: MsgExitSwapShareAmountIn.fromPartial(e)
      };
    }
  }
}, _280 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$7,
  load: load$7,
  registry: registry$9
}, Symbol.toStringTag, { value: "Module" })), registry$8 = [["/osmosis.incentives.MsgCreateGauge", MsgCreateGauge], ["/osmosis.incentives.MsgAddToGauge", MsgAddToGauge]], load$6 = (e) => {
  registry$8.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$6 = {
  encoded: {
    createGauge(e) {
      return {
        typeUrl: "/osmosis.incentives.MsgCreateGauge",
        value: MsgCreateGauge.encode(e).finish()
      };
    },
    addToGauge(e) {
      return {
        typeUrl: "/osmosis.incentives.MsgAddToGauge",
        value: MsgAddToGauge.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    createGauge(e) {
      return {
        typeUrl: "/osmosis.incentives.MsgCreateGauge",
        value: e
      };
    },
    addToGauge(e) {
      return {
        typeUrl: "/osmosis.incentives.MsgAddToGauge",
        value: e
      };
    }
  },
  fromPartial: {
    createGauge(e) {
      return {
        typeUrl: "/osmosis.incentives.MsgCreateGauge",
        value: MsgCreateGauge.fromPartial(e)
      };
    },
    addToGauge(e) {
      return {
        typeUrl: "/osmosis.incentives.MsgAddToGauge",
        value: MsgAddToGauge.fromPartial(e)
      };
    }
  }
}, _281 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$6,
  load: load$6,
  registry: registry$8
}, Symbol.toStringTag, { value: "Module" })), registry$7 = [["/osmosis.lockup.MsgLockTokens", MsgLockTokens], ["/osmosis.lockup.MsgBeginUnlockingAll", MsgBeginUnlockingAll], ["/osmosis.lockup.MsgBeginUnlocking", MsgBeginUnlocking], ["/osmosis.lockup.MsgExtendLockup", MsgExtendLockup], ["/osmosis.lockup.MsgForceUnlock", MsgForceUnlock]], load$5 = (e) => {
  registry$7.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$5 = {
  encoded: {
    lockTokens(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgLockTokens",
        value: MsgLockTokens.encode(e).finish()
      };
    },
    beginUnlockingAll(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
        value: MsgBeginUnlockingAll.encode(e).finish()
      };
    },
    beginUnlocking(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
        value: MsgBeginUnlocking.encode(e).finish()
      };
    },
    extendLockup(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgExtendLockup",
        value: MsgExtendLockup.encode(e).finish()
      };
    },
    forceUnlock(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgForceUnlock",
        value: MsgForceUnlock.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    lockTokens(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgLockTokens",
        value: e
      };
    },
    beginUnlockingAll(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
        value: e
      };
    },
    beginUnlocking(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
        value: e
      };
    },
    extendLockup(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgExtendLockup",
        value: e
      };
    },
    forceUnlock(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgForceUnlock",
        value: e
      };
    }
  },
  fromPartial: {
    lockTokens(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgLockTokens",
        value: MsgLockTokens.fromPartial(e)
      };
    },
    beginUnlockingAll(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
        value: MsgBeginUnlockingAll.fromPartial(e)
      };
    },
    beginUnlocking(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
        value: MsgBeginUnlocking.fromPartial(e)
      };
    },
    extendLockup(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgExtendLockup",
        value: MsgExtendLockup.fromPartial(e)
      };
    },
    forceUnlock(e) {
      return {
        typeUrl: "/osmosis.lockup.MsgForceUnlock",
        value: MsgForceUnlock.fromPartial(e)
      };
    }
  }
}, _282 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$5,
  load: load$5,
  registry: registry$7
}, Symbol.toStringTag, { value: "Module" })), registry$6 = [["/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn", MsgSwapExactAmountIn], ["/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut", MsgSwapExactAmountOut]], load$4 = (e) => {
  registry$6.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$4 = {
  encoded: {
    swapExactAmountIn(e) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
        value: MsgSwapExactAmountIn.encode(e).finish()
      };
    },
    swapExactAmountOut(e) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
        value: MsgSwapExactAmountOut.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    swapExactAmountIn(e) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
        value: e
      };
    },
    swapExactAmountOut(e) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
        value: e
      };
    }
  },
  fromPartial: {
    swapExactAmountIn(e) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
        value: MsgSwapExactAmountIn.fromPartial(e)
      };
    },
    swapExactAmountOut(e) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
        value: MsgSwapExactAmountOut.fromPartial(e)
      };
    }
  }
}, _283 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$4,
  load: load$4,
  registry: registry$6
}, Symbol.toStringTag, { value: "Module" })), registry$5 = [["/osmosis.protorev.v1beta1.MsgSetHotRoutes", MsgSetHotRoutes], ["/osmosis.protorev.v1beta1.MsgSetDeveloperAccount", MsgSetDeveloperAccount], ["/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx", MsgSetMaxPoolPointsPerTx], ["/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock", MsgSetMaxPoolPointsPerBlock], ["/osmosis.protorev.v1beta1.MsgSetPoolWeights", MsgSetPoolWeights], ["/osmosis.protorev.v1beta1.MsgSetBaseDenoms", MsgSetBaseDenoms]], load$3 = (e) => {
  registry$5.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$3 = {
  encoded: {
    setHotRoutes(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
        value: MsgSetHotRoutes.encode(e).finish()
      };
    },
    setDeveloperAccount(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
        value: MsgSetDeveloperAccount.encode(e).finish()
      };
    },
    setMaxPoolPointsPerTx(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
        value: MsgSetMaxPoolPointsPerTx.encode(e).finish()
      };
    },
    setMaxPoolPointsPerBlock(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
        value: MsgSetMaxPoolPointsPerBlock.encode(e).finish()
      };
    },
    setPoolWeights(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
        value: MsgSetPoolWeights.encode(e).finish()
      };
    },
    setBaseDenoms(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
        value: MsgSetBaseDenoms.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    setHotRoutes(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
        value: e
      };
    },
    setDeveloperAccount(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
        value: e
      };
    },
    setMaxPoolPointsPerTx(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
        value: e
      };
    },
    setMaxPoolPointsPerBlock(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
        value: e
      };
    },
    setPoolWeights(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
        value: e
      };
    },
    setBaseDenoms(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
        value: e
      };
    }
  },
  fromPartial: {
    setHotRoutes(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
        value: MsgSetHotRoutes.fromPartial(e)
      };
    },
    setDeveloperAccount(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
        value: MsgSetDeveloperAccount.fromPartial(e)
      };
    },
    setMaxPoolPointsPerTx(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
        value: MsgSetMaxPoolPointsPerTx.fromPartial(e)
      };
    },
    setMaxPoolPointsPerBlock(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
        value: MsgSetMaxPoolPointsPerBlock.fromPartial(e)
      };
    },
    setPoolWeights(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
        value: MsgSetPoolWeights.fromPartial(e)
      };
    },
    setBaseDenoms(e) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
        value: MsgSetBaseDenoms.fromPartial(e)
      };
    }
  }
}, _284 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$3,
  load: load$3,
  registry: registry$5
}, Symbol.toStringTag, { value: "Module" })), registry$4 = [["/osmosis.superfluid.MsgSuperfluidDelegate", MsgSuperfluidDelegate], ["/osmosis.superfluid.MsgSuperfluidUndelegate", MsgSuperfluidUndelegate], ["/osmosis.superfluid.MsgSuperfluidUnbondLock", MsgSuperfluidUnbondLock], ["/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock", MsgSuperfluidUndelegateAndUnbondLock], ["/osmosis.superfluid.MsgLockAndSuperfluidDelegate", MsgLockAndSuperfluidDelegate], ["/osmosis.superfluid.MsgUnPoolWhitelistedPool", MsgUnPoolWhitelistedPool], ["/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition", MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition]], load$2 = (e) => {
  registry$4.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$2 = {
  encoded: {
    superfluidDelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
        value: MsgSuperfluidDelegate.encode(e).finish()
      };
    },
    superfluidUndelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
        value: MsgSuperfluidUndelegate.encode(e).finish()
      };
    },
    superfluidUnbondLock(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
        value: MsgSuperfluidUnbondLock.encode(e).finish()
      };
    },
    superfluidUndelegateAndUnbondLock(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
        value: MsgSuperfluidUndelegateAndUnbondLock.encode(e).finish()
      };
    },
    lockAndSuperfluidDelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
        value: MsgLockAndSuperfluidDelegate.encode(e).finish()
      };
    },
    unPoolWhitelistedPool(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
        value: MsgUnPoolWhitelistedPool.encode(e).finish()
      };
    },
    unlockAndMigrateSharesToFullRangeConcentratedPosition(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
        value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    superfluidDelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
        value: e
      };
    },
    superfluidUndelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
        value: e
      };
    },
    superfluidUnbondLock(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
        value: e
      };
    },
    superfluidUndelegateAndUnbondLock(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
        value: e
      };
    },
    lockAndSuperfluidDelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
        value: e
      };
    },
    unPoolWhitelistedPool(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
        value: e
      };
    },
    unlockAndMigrateSharesToFullRangeConcentratedPosition(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
        value: e
      };
    }
  },
  fromPartial: {
    superfluidDelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
        value: MsgSuperfluidDelegate.fromPartial(e)
      };
    },
    superfluidUndelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
        value: MsgSuperfluidUndelegate.fromPartial(e)
      };
    },
    superfluidUnbondLock(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
        value: MsgSuperfluidUnbondLock.fromPartial(e)
      };
    },
    superfluidUndelegateAndUnbondLock(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
        value: MsgSuperfluidUndelegateAndUnbondLock.fromPartial(e)
      };
    },
    lockAndSuperfluidDelegate(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
        value: MsgLockAndSuperfluidDelegate.fromPartial(e)
      };
    },
    unPoolWhitelistedPool(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
        value: MsgUnPoolWhitelistedPool.fromPartial(e)
      };
    },
    unlockAndMigrateSharesToFullRangeConcentratedPosition(e) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
        value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.fromPartial(e)
      };
    }
  }
}, _285 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$2,
  load: load$2,
  registry: registry$4
}, Symbol.toStringTag, { value: "Module" })), registry$3 = [["/osmosis.tokenfactory.v1beta1.MsgCreateDenom", MsgCreateDenom], ["/osmosis.tokenfactory.v1beta1.MsgMint", MsgMint], ["/osmosis.tokenfactory.v1beta1.MsgBurn", MsgBurn], ["/osmosis.tokenfactory.v1beta1.MsgChangeAdmin", MsgChangeAdmin], ["/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata", MsgSetDenomMetadata], ["/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook", MsgSetBeforeSendHook], ["/osmosis.tokenfactory.v1beta1.MsgForceTransfer", MsgForceTransfer]], load$1 = (e) => {
  registry$3.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer$1 = {
  encoded: {
    createDenom(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
        value: MsgCreateDenom.encode(e).finish()
      };
    },
    mint(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
        value: MsgMint.encode(e).finish()
      };
    },
    burn(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
        value: MsgBurn.encode(e).finish()
      };
    },
    changeAdmin(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
        value: MsgChangeAdmin.encode(e).finish()
      };
    },
    setDenomMetadata(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
        value: MsgSetDenomMetadata.encode(e).finish()
      };
    },
    setBeforeSendHook(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
        value: MsgSetBeforeSendHook.encode(e).finish()
      };
    },
    forceTransfer(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
        value: MsgForceTransfer.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    createDenom(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
        value: e
      };
    },
    mint(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
        value: e
      };
    },
    burn(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
        value: e
      };
    },
    changeAdmin(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
        value: e
      };
    },
    setDenomMetadata(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
        value: e
      };
    },
    setBeforeSendHook(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
        value: e
      };
    },
    forceTransfer(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
        value: e
      };
    }
  },
  fromPartial: {
    createDenom(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
        value: MsgCreateDenom.fromPartial(e)
      };
    },
    mint(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
        value: MsgMint.fromPartial(e)
      };
    },
    burn(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
        value: MsgBurn.fromPartial(e)
      };
    },
    changeAdmin(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
        value: MsgChangeAdmin.fromPartial(e)
      };
    },
    setDenomMetadata(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
        value: MsgSetDenomMetadata.fromPartial(e)
      };
    },
    setBeforeSendHook(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
        value: MsgSetBeforeSendHook.fromPartial(e)
      };
    },
    forceTransfer(e) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
        value: MsgForceTransfer.fromPartial(e)
      };
    }
  }
}, _286 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer: MessageComposer$1,
  load: load$1,
  registry: registry$3
}, Symbol.toStringTag, { value: "Module" })), registry$2 = [["/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference", MsgSetValidatorSetPreference], ["/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet", MsgDelegateToValidatorSet], ["/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet", MsgUndelegateFromValidatorSet], ["/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet", MsgRedelegateValidatorSet], ["/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards", MsgWithdrawDelegationRewards], ["/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens", MsgDelegateBondedTokens]], load = (e) => {
  registry$2.forEach(([n, o]) => {
    e.register(n, o);
  });
}, MessageComposer = {
  encoded: {
    setValidatorSetPreference(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
        value: MsgSetValidatorSetPreference.encode(e).finish()
      };
    },
    delegateToValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
        value: MsgDelegateToValidatorSet.encode(e).finish()
      };
    },
    undelegateFromValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
        value: MsgUndelegateFromValidatorSet.encode(e).finish()
      };
    },
    redelegateValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
        value: MsgRedelegateValidatorSet.encode(e).finish()
      };
    },
    withdrawDelegationRewards(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
        value: MsgWithdrawDelegationRewards.encode(e).finish()
      };
    },
    delegateBondedTokens(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
        value: MsgDelegateBondedTokens.encode(e).finish()
      };
    }
  },
  withTypeUrl: {
    setValidatorSetPreference(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
        value: e
      };
    },
    delegateToValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
        value: e
      };
    },
    undelegateFromValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
        value: e
      };
    },
    redelegateValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
        value: e
      };
    },
    withdrawDelegationRewards(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
        value: e
      };
    },
    delegateBondedTokens(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
        value: e
      };
    }
  },
  fromPartial: {
    setValidatorSetPreference(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
        value: MsgSetValidatorSetPreference.fromPartial(e)
      };
    },
    delegateToValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
        value: MsgDelegateToValidatorSet.fromPartial(e)
      };
    },
    undelegateFromValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
        value: MsgUndelegateFromValidatorSet.fromPartial(e)
      };
    },
    redelegateValidatorSet(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
        value: MsgRedelegateValidatorSet.fromPartial(e)
      };
    },
    withdrawDelegationRewards(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
        value: MsgWithdrawDelegationRewards.fromPartial(e)
      };
    },
    delegateBondedTokens(e) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
        value: MsgDelegateBondedTokens.fromPartial(e)
      };
    }
  }
}, _287 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MessageComposer,
  load,
  registry: registry$2
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$g = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this);
  }
  /* Params */
  async params(n = {}) {
    const o = "osmosis/cosmwasmpool/v1beta1/Params";
    return await this.req.get(o);
  }
};
const _289 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$g
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$f = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.recoveredSinceDowntimeOfLength = this.recoveredSinceDowntimeOfLength.bind(this);
  }
  /* RecoveredSinceDowntimeOfLength */
  async recoveredSinceDowntimeOfLength(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.downtime) < "u" && (o.params.downtime = n.downtime), typeof (n == null ? void 0 : n.recovery) < "u" && (o.params.recovery = n.recovery);
    const u = "osmosis/downtime-detector/v1beta1/RecoveredSinceDowntimeOfLength";
    return await this.req.get(u, o);
  }
};
const _290 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$f
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$e = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.epochInfos = this.epochInfos.bind(this), this.currentEpoch = this.currentEpoch.bind(this);
  }
  /* EpochInfos provide running epochInfos */
  async epochInfos(n = {}) {
    const o = "osmosis/epochs/v1beta1/epochs";
    return await this.req.get(o);
  }
  /* CurrentEpoch provide current epoch of specified identifier */
  async currentEpoch(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.identifier) < "u" && (o.params.identifier = n.identifier);
    const u = "osmosis/epochs/v1beta1/current_epoch";
    return await this.req.get(u, o);
  }
};
const _291 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$e
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$d = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.pools = this.pools.bind(this), this.numPools = this.numPools.bind(this), this.totalLiquidity = this.totalLiquidity.bind(this), this.poolsWithFilter = this.poolsWithFilter.bind(this), this.pool = this.pool.bind(this), this.poolType = this.poolType.bind(this), this.calcJoinPoolShares = this.calcJoinPoolShares.bind(this), this.calcExitPoolCoinsFromShares = this.calcExitPoolCoinsFromShares.bind(this), this.poolParams = this.poolParams.bind(this), this.totalPoolLiquidity = this.totalPoolLiquidity.bind(this), this.totalShares = this.totalShares.bind(this), this.spotPrice = this.spotPrice.bind(this), this.estimateSwapExactAmountIn = this.estimateSwapExactAmountIn.bind(this), this.estimateSwapExactAmountOut = this.estimateSwapExactAmountOut.bind(this);
  }
  /* Pools */
  async pools(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "osmosis/gamm/v1beta1/pools";
    return await this.req.get(u, o);
  }
  /* Deprecated: please use the alternative in x/poolmanager */
  async numPools(n = {}) {
    const o = "osmosis/gamm/v1beta1/num_pools";
    return await this.req.get(o);
  }
  /* TotalLiquidity */
  async totalLiquidity(n = {}) {
    const o = "osmosis/gamm/v1beta1/total_liquidity";
    return await this.req.get(o);
  }
  /* PoolsWithFilter allows you to query specific pools with requested
   parameters */
  async poolsWithFilter(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.minLiquidity) < "u" && (o.params.min_liquidity = n.minLiquidity), typeof (n == null ? void 0 : n.poolType) < "u" && (o.params.pool_type = n.poolType), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "osmosis/gamm/v1beta1/filtered_pools";
    return await this.req.get(u, o);
  }
  /* Deprecated: please use the alternative in x/poolmanager */
  async pool(n) {
    const o = `osmosis/gamm/v1beta1/pools/${n.poolId}`;
    return await this.req.get(o);
  }
  /* PoolType returns the type of the pool.
   Returns "Balancer" as a string literal when the pool is a balancer pool.
   Errors if the pool is failed to be type caseted. */
  async poolType(n) {
    const o = `osmosis/gamm/v1beta1/pool_type/${n.poolId}`;
    return await this.req.get(o);
  }
  /* CalcJoinPoolShares */
  async calcJoinPoolShares(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.tokensIn) < "u" && (o.params.tokens_in = n.tokensIn);
    const u = `osmosis/gamm/v1beta1/pools/${n.poolId}/join_swap_exact_in`;
    return await this.req.get(u, o);
  }
  /* CalcExitPoolCoinsFromShares */
  async calcExitPoolCoinsFromShares(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.shareInAmount) < "u" && (o.params.share_in_amount = n.shareInAmount);
    const u = `osmosis/gamm/v1beta1/pools/${n.poolId}/exit_swap_share_amount_in`;
    return await this.req.get(u, o);
  }
  /* PoolParams */
  async poolParams(n) {
    const o = `osmosis/gamm/v1beta1/pools/${n.poolId}/params`;
    return await this.req.get(o);
  }
  /* TotalPoolLiquidity */
  async totalPoolLiquidity(n) {
    const o = `osmosis/gamm/v1beta1/pools/${n.poolId}/total_pool_liquidity`;
    return await this.req.get(o);
  }
  /* TotalShares */
  async totalShares(n) {
    const o = `osmosis/gamm/v1beta1/pools/${n.poolId}/total_shares`;
    return await this.req.get(o);
  }
  /* SpotPrice defines a gRPC query handler that returns the spot price given
   a base denomination and a quote denomination. */
  async spotPrice(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.baseAssetDenom) < "u" && (o.params.base_asset_denom = n.baseAssetDenom), typeof (n == null ? void 0 : n.quoteAssetDenom) < "u" && (o.params.quote_asset_denom = n.quoteAssetDenom);
    const u = `osmosis/gamm/v1beta1/pools/${n.poolId}/prices`;
    return await this.req.get(u, o);
  }
  /* Deprecated: please use the alternative in x/poolmanager */
  async estimateSwapExactAmountIn(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.sender) < "u" && (o.params.sender = n.sender), typeof (n == null ? void 0 : n.tokenIn) < "u" && (o.params.token_in = n.tokenIn), typeof (n == null ? void 0 : n.routes) < "u" && (o.params.routes = n.routes);
    const u = `osmosis/gamm/v1beta1/${n.poolId}/estimate/swap_exact_amount_in`;
    return await this.req.get(u, o);
  }
  /* Deprecated: please use the alternative in x/poolmanager */
  async estimateSwapExactAmountOut(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.sender) < "u" && (o.params.sender = n.sender), typeof (n == null ? void 0 : n.routes) < "u" && (o.params.routes = n.routes), typeof (n == null ? void 0 : n.tokenOut) < "u" && (o.params.token_out = n.tokenOut);
    const u = `osmosis/gamm/v1beta1/${n.poolId}/estimate/swap_exact_amount_out`;
    return await this.req.get(u, o);
  }
};
const _292 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$d
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$c = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.spotPrice = this.spotPrice.bind(this);
  }
  /* Deprecated: please use alternate in x/poolmanager */
  async spotPrice(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.baseAssetDenom) < "u" && (o.params.base_asset_denom = n.baseAssetDenom), typeof (n == null ? void 0 : n.quoteAssetDenom) < "u" && (o.params.quote_asset_denom = n.quoteAssetDenom);
    const u = `osmosis/gamm/v2/pools/${n.poolId}/prices`;
    return await this.req.get(u, o);
  }
};
const _293 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$c
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$b = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this);
  }
  /* Params defines a gRPC query method that returns the ibc-rate-limit module's
   parameters. */
  async params(n = {}) {
    const o = "osmosis/ibc-rate-limit/v1beta1/params";
    return await this.req.get(o);
  }
};
const _294 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$b
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$a = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.moduleToDistributeCoins = this.moduleToDistributeCoins.bind(this), this.gaugeByID = this.gaugeByID.bind(this), this.gauges = this.gauges.bind(this), this.activeGauges = this.activeGauges.bind(this), this.activeGaugesPerDenom = this.activeGaugesPerDenom.bind(this), this.upcomingGauges = this.upcomingGauges.bind(this), this.upcomingGaugesPerDenom = this.upcomingGaugesPerDenom.bind(this), this.rewardsEst = this.rewardsEst.bind(this), this.lockableDurations = this.lockableDurations.bind(this);
  }
  /* ModuleToDistributeCoins returns coins that are going to be distributed */
  async moduleToDistributeCoins(n = {}) {
    const o = "osmosis/incentives/v1beta1/module_to_distribute_coins";
    return await this.req.get(o);
  }
  /* GaugeByID returns gauges by their respective ID */
  async gaugeByID(n) {
    const o = `osmosis/incentives/v1beta1/gauge_by_id/${n.id}`;
    return await this.req.get(o);
  }
  /* Gauges returns both upcoming and active gauges */
  async gauges(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "osmosis/incentives/v1beta1/gauges";
    return await this.req.get(u, o);
  }
  /* ActiveGauges returns active gauges */
  async activeGauges(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "osmosis/incentives/v1beta1/active_gauges";
    return await this.req.get(u, o);
  }
  /* ActiveGaugesPerDenom returns active gauges by denom */
  async activeGaugesPerDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "osmosis/incentives/v1beta1/active_gauges_per_denom";
    return await this.req.get(u, o);
  }
  /* Returns scheduled gauges that have not yet occured */
  async upcomingGauges(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "osmosis/incentives/v1beta1/upcoming_gauges";
    return await this.req.get(u, o);
  }
  /* UpcomingGaugesPerDenom returns scheduled gauges that have not yet occured
   by denom */
  async upcomingGaugesPerDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom), typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "osmosis/incentives/v1beta1/upcoming_gauges_per_denom";
    return await this.req.get(u, o);
  }
  /* RewardsEst returns an estimate of the rewards from now until a specified
   time in the future The querier either provides an address or a set of locks
   for which they want to find the associated rewards */
  async rewardsEst(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.lockIds) < "u" && (o.params.lock_ids = n.lockIds), typeof (n == null ? void 0 : n.endEpoch) < "u" && (o.params.end_epoch = n.endEpoch);
    const u = `osmosis/incentives/v1beta1/rewards_est/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* LockableDurations returns lockable durations that are valid to distribute
   incentives for */
  async lockableDurations(n = {}) {
    const o = "osmosis/incentives/v1beta1/lockable_durations";
    return await this.req.get(o);
  }
};
const _295 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$a
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$9 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.moduleBalance = this.moduleBalance.bind(this), this.moduleLockedAmount = this.moduleLockedAmount.bind(this), this.accountUnlockableCoins = this.accountUnlockableCoins.bind(this), this.accountUnlockingCoins = this.accountUnlockingCoins.bind(this), this.accountLockedCoins = this.accountLockedCoins.bind(this), this.accountLockedPastTime = this.accountLockedPastTime.bind(this), this.accountLockedPastTimeNotUnlockingOnly = this.accountLockedPastTimeNotUnlockingOnly.bind(this), this.accountUnlockedBeforeTime = this.accountUnlockedBeforeTime.bind(this), this.accountLockedPastTimeDenom = this.accountLockedPastTimeDenom.bind(this), this.lockedDenom = this.lockedDenom.bind(this), this.lockedByID = this.lockedByID.bind(this), this.nextLockID = this.nextLockID.bind(this), this.syntheticLockupsByLockupID = this.syntheticLockupsByLockupID.bind(this), this.accountLockedLongerDuration = this.accountLockedLongerDuration.bind(this), this.accountLockedDuration = this.accountLockedDuration.bind(this), this.accountLockedLongerDurationNotUnlockingOnly = this.accountLockedLongerDurationNotUnlockingOnly.bind(this), this.accountLockedLongerDurationDenom = this.accountLockedLongerDurationDenom.bind(this), this.params = this.params.bind(this);
  }
  /* Return full balance of the module */
  async moduleBalance(n = {}) {
    const o = "osmosis/lockup/v1beta1/module_balance";
    return await this.req.get(o);
  }
  /* Return locked balance of the module */
  async moduleLockedAmount(n = {}) {
    const o = "osmosis/lockup/v1beta1/module_locked_amount";
    return await this.req.get(o);
  }
  /* Returns unlockable coins which are not withdrawn yet */
  async accountUnlockableCoins(n) {
    const o = `osmosis/lockup/v1beta1/account_unlockable_coins/${n.owner}`;
    return await this.req.get(o);
  }
  /* Returns unlocking coins */
  async accountUnlockingCoins(n) {
    const o = `osmosis/lockup/v1beta1/account_unlocking_coins/${n.owner}`;
    return await this.req.get(o);
  }
  /* Return a locked coins that can't be withdrawn */
  async accountLockedCoins(n) {
    const o = `osmosis/lockup/v1beta1/account_locked_coins/${n.owner}`;
    return await this.req.get(o);
  }
  /* Returns locked records of an account with unlock time beyond timestamp */
  async accountLockedPastTime(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.timestamp) < "u" && (o.params.timestamp = n.timestamp);
    const u = `osmosis/lockup/v1beta1/account_locked_pasttime/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* Returns locked records of an account with unlock time beyond timestamp
   excluding tokens started unlocking */
  async accountLockedPastTimeNotUnlockingOnly(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.timestamp) < "u" && (o.params.timestamp = n.timestamp);
    const u = `osmosis/lockup/v1beta1/account_locked_pasttime_not_unlocking_only/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* Returns unlocked records with unlock time before timestamp */
  async accountUnlockedBeforeTime(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.timestamp) < "u" && (o.params.timestamp = n.timestamp);
    const u = `osmosis/lockup/v1beta1/account_unlocked_before_time/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* Returns lock records by address, timestamp, denom */
  async accountLockedPastTimeDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.timestamp) < "u" && (o.params.timestamp = n.timestamp), typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = `osmosis/lockup/v1beta1/account_locked_pasttime_denom/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* Returns total locked per denom with longer past given time */
  async lockedDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom), typeof (n == null ? void 0 : n.duration) < "u" && (o.params.duration = n.duration);
    const u = "osmosis/lockup/v1beta1/locked_denom";
    return await this.req.get(u, o);
  }
  /* Returns lock record by id */
  async lockedByID(n) {
    const o = `osmosis/lockup/v1beta1/locked_by_id/${n.lockId}`;
    return await this.req.get(o);
  }
  /* Returns next lock ID */
  async nextLockID(n = {}) {
    const o = "osmosis/lockup/v1beta1/next_lock_id";
    return await this.req.get(o);
  }
  /* Returns synthetic lockups by native lockup id */
  async syntheticLockupsByLockupID(n) {
    const o = `osmosis/lockup/v1beta1/synthetic_lockups_by_lock_id/${n.lockId}`;
    return await this.req.get(o);
  }
  /* Returns account locked records with longer duration */
  async accountLockedLongerDuration(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.duration) < "u" && (o.params.duration = n.duration);
    const u = `osmosis/lockup/v1beta1/account_locked_longer_duration/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* Returns account locked records with a specific duration */
  async accountLockedDuration(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.duration) < "u" && (o.params.duration = n.duration);
    const u = `osmosis/lockup/v1beta1/account_locked_duration/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* Returns account locked records with longer duration excluding tokens
   started unlocking */
  async accountLockedLongerDurationNotUnlockingOnly(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.duration) < "u" && (o.params.duration = n.duration);
    const u = `osmosis/lockup/v1beta1/account_locked_longer_duration_not_unlocking_only/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* Returns account's locked records for a denom with longer duration */
  async accountLockedLongerDurationDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.duration) < "u" && (o.params.duration = n.duration), typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = `osmosis/lockup/v1beta1/account_locked_longer_duration_denom/${n.owner}`;
    return await this.req.get(u, o);
  }
  /* Params returns lockup params. */
  async params(n = {}) {
    const o = "osmosis/lockup/v1beta1/params";
    return await this.req.get(o);
  }
};
const _296 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$9
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$8 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this), this.epochProvisions = this.epochProvisions.bind(this);
  }
  /* Params returns the total set of minting parameters. */
  async params(n = {}) {
    const o = "osmosis/mint/v1beta1/params";
    return await this.req.get(o);
  }
  /* EpochProvisions returns the current minting epoch provisions value. */
  async epochProvisions(n = {}) {
    const o = "osmosis/mint/v1beta1/epoch_provisions";
    return await this.req.get(o);
  }
};
const _297 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$8
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$7 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.gaugeIds = this.gaugeIds.bind(this), this.distrInfo = this.distrInfo.bind(this), this.params = this.params.bind(this), this.lockableDurations = this.lockableDurations.bind(this), this.incentivizedPools = this.incentivizedPools.bind(this), this.externalIncentiveGauges = this.externalIncentiveGauges.bind(this);
  }
  /* GaugeIds takes the pool id and returns the matching gauge ids and durations */
  async gaugeIds(n) {
    const o = `osmosis/pool-incentives/v1beta1/gauge-ids/${n.poolId}`;
    return await this.req.get(o);
  }
  /* DistrInfo returns the pool's matching gauge ids and weights. */
  async distrInfo(n = {}) {
    const o = "osmosis/pool-incentives/v1beta1/distr_info";
    return await this.req.get(o);
  }
  /* Params returns pool incentives params. */
  async params(n = {}) {
    const o = "osmosis/pool-incentives/v1beta1/params";
    return await this.req.get(o);
  }
  /* LockableDurations returns lock durations for pools. */
  async lockableDurations(n = {}) {
    const o = "osmosis/pool-incentives/v1beta1/lockable_durations";
    return await this.req.get(o);
  }
  /* IncentivizedPools returns currently incentivized pools */
  async incentivizedPools(n = {}) {
    const o = "osmosis/pool-incentives/v1beta1/incentivized_pools";
    return await this.req.get(o);
  }
  /* ExternalIncentiveGauges returns external incentive gauges. */
  async externalIncentiveGauges(n = {}) {
    const o = "osmosis/pool-incentives/v1beta1/external_incentive_gauges";
    return await this.req.get(o);
  }
};
const _298 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$7
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$6 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this), this.estimateSwapExactAmountIn = this.estimateSwapExactAmountIn.bind(this), this.estimateSinglePoolSwapExactAmountIn = this.estimateSinglePoolSwapExactAmountIn.bind(this), this.estimateSwapExactAmountOut = this.estimateSwapExactAmountOut.bind(this), this.estimateSinglePoolSwapExactAmountOut = this.estimateSinglePoolSwapExactAmountOut.bind(this), this.numPools = this.numPools.bind(this), this.pool = this.pool.bind(this), this.allPools = this.allPools.bind(this), this.spotPrice = this.spotPrice.bind(this);
  }
  /* Params */
  async params(n = {}) {
    const o = "osmosis/poolmanager/v1beta1/Params";
    return await this.req.get(o);
  }
  /* Estimates swap amount out given in. */
  async estimateSwapExactAmountIn(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.tokenIn) < "u" && (o.params.token_in = n.tokenIn), typeof (n == null ? void 0 : n.routes) < "u" && (o.params.routes = n.routes);
    const u = `osmosis/poolmanager/v1beta1/${n.poolId}/estimate/swap_exact_amount_in`;
    return await this.req.get(u, o);
  }
  /* EstimateSinglePoolSwapExactAmountIn */
  async estimateSinglePoolSwapExactAmountIn(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.tokenIn) < "u" && (o.params.token_in = n.tokenIn), typeof (n == null ? void 0 : n.tokenOutDenom) < "u" && (o.params.token_out_denom = n.tokenOutDenom);
    const u = `osmosis/poolmanager/v1beta1/${n.poolId}/estimate/single_pool_swap_exact_amount_in`;
    return await this.req.get(u, o);
  }
  /* Estimates swap amount in given out. */
  async estimateSwapExactAmountOut(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.routes) < "u" && (o.params.routes = n.routes), typeof (n == null ? void 0 : n.tokenOut) < "u" && (o.params.token_out = n.tokenOut);
    const u = `osmosis/poolmanager/v1beta1/${n.poolId}/estimate/swap_exact_amount_out`;
    return await this.req.get(u, o);
  }
  /* EstimateSinglePoolSwapExactAmountOut */
  async estimateSinglePoolSwapExactAmountOut(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.tokenInDenom) < "u" && (o.params.token_in_denom = n.tokenInDenom), typeof (n == null ? void 0 : n.tokenOut) < "u" && (o.params.token_out = n.tokenOut);
    const u = `osmosis/poolmanager/v1beta1/${n.poolId}/estimate_out/single_pool_swap_exact_amount_out`;
    return await this.req.get(u, o);
  }
  /* Returns the total number of pools existing in Osmosis. */
  async numPools(n = {}) {
    const o = "osmosis/poolmanager/v1beta1/num_pools";
    return await this.req.get(o);
  }
  /* Pool returns the Pool specified by the pool id */
  async pool(n) {
    const o = `osmosis/poolmanager/v1beta1/pools/${n.poolId}`;
    return await this.req.get(o);
  }
  /* AllPools returns all pools on the Osmosis chain sorted by IDs. */
  async allPools(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.poolId) < "u" && (o.params.pool_id = n.poolId);
    const u = "osmosis/poolmanager/v1beta1/all-pools";
    return await this.req.get(u, o);
  }
  /* SpotPrice defines a gRPC query handler that returns the spot price given
   a base denomination and a quote denomination. */
  async spotPrice(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.baseAssetDenom) < "u" && (o.params.base_asset_denom = n.baseAssetDenom), typeof (n == null ? void 0 : n.quoteAssetDenom) < "u" && (o.params.quote_asset_denom = n.quoteAssetDenom);
    const u = `osmosis/poolmanager/pools/${n.poolId}/prices`;
    return await this.req.get(u, o);
  }
};
const _299 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$6
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$5 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this), this.getProtoRevNumberOfTrades = this.getProtoRevNumberOfTrades.bind(this), this.getProtoRevProfitsByDenom = this.getProtoRevProfitsByDenom.bind(this), this.getProtoRevAllProfits = this.getProtoRevAllProfits.bind(this), this.getProtoRevStatisticsByRoute = this.getProtoRevStatisticsByRoute.bind(this), this.getProtoRevAllRouteStatistics = this.getProtoRevAllRouteStatistics.bind(this), this.getProtoRevTokenPairArbRoutes = this.getProtoRevTokenPairArbRoutes.bind(this), this.getProtoRevAdminAccount = this.getProtoRevAdminAccount.bind(this), this.getProtoRevDeveloperAccount = this.getProtoRevDeveloperAccount.bind(this), this.getProtoRevPoolWeights = this.getProtoRevPoolWeights.bind(this), this.getProtoRevMaxPoolPointsPerTx = this.getProtoRevMaxPoolPointsPerTx.bind(this), this.getProtoRevMaxPoolPointsPerBlock = this.getProtoRevMaxPoolPointsPerBlock.bind(this), this.getProtoRevBaseDenoms = this.getProtoRevBaseDenoms.bind(this), this.getProtoRevEnabled = this.getProtoRevEnabled.bind(this);
  }
  /* Params queries the parameters of the module. */
  async params(n = {}) {
    const o = "osmosis/v14/protorev/params";
    return await this.req.get(o);
  }
  /* GetProtoRevNumberOfTrades queries the number of arbitrage trades the module
   has executed */
  async getProtoRevNumberOfTrades(n = {}) {
    const o = "osmosis/v14/protorev/number_of_trades";
    return await this.req.get(o);
  }
  /* GetProtoRevProfitsByDenom queries the profits of the module by denom */
  async getProtoRevProfitsByDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = "osmosis/v14/protorev/profits_by_denom";
    return await this.req.get(u, o);
  }
  /* GetProtoRevAllProfits queries all of the profits from the module */
  async getProtoRevAllProfits(n = {}) {
    const o = "osmosis/v14/protorev/all_profits";
    return await this.req.get(o);
  }
  /* GetProtoRevStatisticsByRoute queries the number of arbitrages and profits
   that have been executed for a given route */
  async getProtoRevStatisticsByRoute(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.route) < "u" && (o.params.route = n.route);
    const u = "osmosis/v14/protorev/statistics_by_route";
    return await this.req.get(u, o);
  }
  /* GetProtoRevAllRouteStatistics queries all of routes that the module has
   arbitraged against and the number of trades and profits that have been
   accumulated for each route */
  async getProtoRevAllRouteStatistics(n = {}) {
    const o = "osmosis/v14/protorev/all_route_statistics";
    return await this.req.get(o);
  }
  /* GetProtoRevTokenPairArbRoutes queries all of the hot routes that the module
   is currently arbitraging */
  async getProtoRevTokenPairArbRoutes(n = {}) {
    const o = "osmosis/v14/protorev/token_pair_arb_routes";
    return await this.req.get(o);
  }
  /* GetProtoRevAdminAccount queries the admin account of the module */
  async getProtoRevAdminAccount(n = {}) {
    const o = "osmosis/v14/protorev/admin_account";
    return await this.req.get(o);
  }
  /* GetProtoRevDeveloperAccount queries the developer account of the module */
  async getProtoRevDeveloperAccount(n = {}) {
    const o = "osmosis/v14/protorev/developer_account";
    return await this.req.get(o);
  }
  /* GetProtoRevPoolWeights queries the weights of each pool type currently
   being used by the module */
  async getProtoRevPoolWeights(n = {}) {
    const o = "osmosis/v14/protorev/pool_weights";
    return await this.req.get(o);
  }
  /* GetProtoRevMaxPoolPointsPerTx queries the maximum number of pool points
   that can be consumed per transaction */
  async getProtoRevMaxPoolPointsPerTx(n = {}) {
    const o = "osmosis/v14/protorev/max_pool_points_per_tx";
    return await this.req.get(o);
  }
  /* GetProtoRevMaxPoolPointsPerBlock queries the maximum number of pool points
   that can consumed per block */
  async getProtoRevMaxPoolPointsPerBlock(n = {}) {
    const o = "osmosis/v14/protorev/max_pool_points_per_block";
    return await this.req.get(o);
  }
  /* GetProtoRevBaseDenoms queries the base denoms that the module is currently
   utilizing for arbitrage */
  async getProtoRevBaseDenoms(n = {}) {
    const o = "osmosis/v14/protorev/base_denoms";
    return await this.req.get(o);
  }
  /* GetProtoRevEnabled queries whether the module is enabled or not */
  async getProtoRevEnabled(n = {}) {
    const o = "osmosis/v14/protorev/enabled";
    return await this.req.get(o);
  }
};
const _300 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$5
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$4 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this), this.assetType = this.assetType.bind(this), this.allAssets = this.allAssets.bind(this), this.assetMultiplier = this.assetMultiplier.bind(this), this.allIntermediaryAccounts = this.allIntermediaryAccounts.bind(this), this.connectedIntermediaryAccount = this.connectedIntermediaryAccount.bind(this), this.totalSuperfluidDelegations = this.totalSuperfluidDelegations.bind(this), this.superfluidDelegationAmount = this.superfluidDelegationAmount.bind(this), this.superfluidDelegationsByDelegator = this.superfluidDelegationsByDelegator.bind(this), this.superfluidUndelegationsByDelegator = this.superfluidUndelegationsByDelegator.bind(this), this.superfluidDelegationsByValidatorDenom = this.superfluidDelegationsByValidatorDenom.bind(this), this.estimateSuperfluidDelegatedAmountByValidatorDenom = this.estimateSuperfluidDelegatedAmountByValidatorDenom.bind(this), this.totalDelegationByDelegator = this.totalDelegationByDelegator.bind(this), this.unpoolWhitelist = this.unpoolWhitelist.bind(this);
  }
  /* Params returns the total set of superfluid parameters. */
  async params(n = {}) {
    const o = "osmosis/superfluid/v1beta1/params";
    return await this.req.get(o);
  }
  /* Returns superfluid asset type, whether if it's a native asset or an lp
   share. */
  async assetType(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = "osmosis/superfluid/v1beta1/asset_type";
    return await this.req.get(u, o);
  }
  /* Returns all registered superfluid assets. */
  async allAssets(n = {}) {
    const o = "osmosis/superfluid/v1beta1/all_assets";
    return await this.req.get(o);
  }
  /* Returns the osmo equivalent multiplier used in the most recent epoch. */
  async assetMultiplier(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = "osmosis/superfluid/v1beta1/asset_multiplier";
    return await this.req.get(u, o);
  }
  /* Returns all superfluid intermediary accounts. */
  async allIntermediaryAccounts(n = {
    pagination: void 0
  }) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.pagination) < "u" && setPaginationParams(o, n.pagination);
    const u = "osmosis/superfluid/v1beta1/all_intermediary_accounts";
    return await this.req.get(u, o);
  }
  /* Returns intermediary account connected to a superfluid staked lock by id */
  async connectedIntermediaryAccount(n) {
    const o = `osmosis/superfluid/v1beta1/connected_intermediary_account/${n.lockId}`;
    return await this.req.get(o);
  }
  /* Returns the total amount of osmo superfluidly staked.
   Response is denominated in uosmo. */
  async totalSuperfluidDelegations(n = {}) {
    const o = "osmosis/superfluid/v1beta1/all_superfluid_delegations";
    return await this.req.get(o);
  }
  /* Returns the coins superfluid delegated for the delegator, validator, denom
   triplet */
  async superfluidDelegationAmount(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.delegatorAddress) < "u" && (o.params.delegator_address = n.delegatorAddress), typeof (n == null ? void 0 : n.validatorAddress) < "u" && (o.params.validator_address = n.validatorAddress), typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = "osmosis/superfluid/v1beta1/superfluid_delegation_amount";
    return await this.req.get(u, o);
  }
  /* Returns all the delegated superfluid poistions for a specific delegator. */
  async superfluidDelegationsByDelegator(n) {
    const o = `osmosis/superfluid/v1beta1/superfluid_delegations/${n.delegatorAddress}`;
    return await this.req.get(o);
  }
  /* Returns all the undelegating superfluid poistions for a specific delegator. */
  async superfluidUndelegationsByDelegator(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = `osmosis/superfluid/v1beta1/superfluid_undelegations_by_delegator/${n.delegatorAddress}`;
    return await this.req.get(u, o);
  }
  /* Returns all the superfluid positions of a specific denom delegated to one
   validator */
  async superfluidDelegationsByValidatorDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.validatorAddress) < "u" && (o.params.validator_address = n.validatorAddress), typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = "osmosis/superfluid/v1beta1/superfluid_delegations_by_validator_denom";
    return await this.req.get(u, o);
  }
  /* Returns the amount of a specific denom delegated to a specific validator
   This is labeled an estimate, because the way it calculates the amount can
   lead rounding errors from the true delegated amount */
  async estimateSuperfluidDelegatedAmountByValidatorDenom(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.validatorAddress) < "u" && (o.params.validator_address = n.validatorAddress), typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = "osmosis/superfluid/v1beta1/estimate_superfluid_delegation_amount_by_validator_denom";
    return await this.req.get(u, o);
  }
  /* Returns the specified delegations for a specific delegator */
  async totalDelegationByDelegator(n) {
    const o = `osmosis/superfluid/v1beta1/total_delegation_by_delegator/${n.delegatorAddress}`;
    return await this.req.get(o);
  }
  /* Returns a list of whitelisted pool ids to unpool. */
  async unpoolWhitelist(n = {}) {
    const o = "osmosis/superfluid/v1beta1/unpool_whitelist";
    return await this.req.get(o);
  }
};
const _301 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$4
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$3 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this), this.denomAuthorityMetadata = this.denomAuthorityMetadata.bind(this), this.denomsFromCreator = this.denomsFromCreator.bind(this), this.beforeSendHookAddress = this.beforeSendHookAddress.bind(this);
  }
  /* Params defines a gRPC query method that returns the tokenfactory module's
   parameters. */
  async params(n = {}) {
    const o = "osmosis/tokenfactory/v1beta1/params";
    return await this.req.get(o);
  }
  /* DenomAuthorityMetadata defines a gRPC query method for fetching
   DenomAuthorityMetadata for a particular denom. */
  async denomAuthorityMetadata(n) {
    const o = `osmosis/tokenfactory/v1beta1/denoms/${n.denom}/authority_metadata`;
    return await this.req.get(o);
  }
  /* DenomsFromCreator defines a gRPC query method for fetching all
   denominations created by a specific admin/creator. */
  async denomsFromCreator(n) {
    const o = `osmosis/tokenfactory/v1beta1/denoms_from_creator/${n.creator}`;
    return await this.req.get(o);
  }
  /* BeforeSendHookAddress defines a gRPC query method for
   getting the address registered for the before send hook. */
  async beforeSendHookAddress(n) {
    const o = `osmosis/tokenfactory/v1beta1/denoms/${n.denom}/before_send_hook`;
    return await this.req.get(o);
  }
};
const _302 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$3
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$2 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.params = this.params.bind(this), this.arithmeticTwap = this.arithmeticTwap.bind(this), this.arithmeticTwapToNow = this.arithmeticTwapToNow.bind(this), this.geometricTwap = this.geometricTwap.bind(this), this.geometricTwapToNow = this.geometricTwapToNow.bind(this);
  }
  /* Params */
  async params(n = {}) {
    const o = "osmosis/twap/v1beta1/Params";
    return await this.req.get(o);
  }
  /* ArithmeticTwap */
  async arithmeticTwap(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.poolId) < "u" && (o.params.pool_id = n.poolId), typeof (n == null ? void 0 : n.baseAsset) < "u" && (o.params.base_asset = n.baseAsset), typeof (n == null ? void 0 : n.quoteAsset) < "u" && (o.params.quote_asset = n.quoteAsset), typeof (n == null ? void 0 : n.startTime) < "u" && (o.params.start_time = n.startTime), typeof (n == null ? void 0 : n.endTime) < "u" && (o.params.end_time = n.endTime);
    const u = "osmosis/twap/v1beta1/ArithmeticTwap";
    return await this.req.get(u, o);
  }
  /* ArithmeticTwapToNow */
  async arithmeticTwapToNow(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.poolId) < "u" && (o.params.pool_id = n.poolId), typeof (n == null ? void 0 : n.baseAsset) < "u" && (o.params.base_asset = n.baseAsset), typeof (n == null ? void 0 : n.quoteAsset) < "u" && (o.params.quote_asset = n.quoteAsset), typeof (n == null ? void 0 : n.startTime) < "u" && (o.params.start_time = n.startTime);
    const u = "osmosis/twap/v1beta1/ArithmeticTwapToNow";
    return await this.req.get(u, o);
  }
  /* GeometricTwap */
  async geometricTwap(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.poolId) < "u" && (o.params.pool_id = n.poolId), typeof (n == null ? void 0 : n.baseAsset) < "u" && (o.params.base_asset = n.baseAsset), typeof (n == null ? void 0 : n.quoteAsset) < "u" && (o.params.quote_asset = n.quoteAsset), typeof (n == null ? void 0 : n.startTime) < "u" && (o.params.start_time = n.startTime), typeof (n == null ? void 0 : n.endTime) < "u" && (o.params.end_time = n.endTime);
    const u = "osmosis/twap/v1beta1/GeometricTwap";
    return await this.req.get(u, o);
  }
  /* GeometricTwapToNow */
  async geometricTwapToNow(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.poolId) < "u" && (o.params.pool_id = n.poolId), typeof (n == null ? void 0 : n.baseAsset) < "u" && (o.params.base_asset = n.baseAsset), typeof (n == null ? void 0 : n.quoteAsset) < "u" && (o.params.quote_asset = n.quoteAsset), typeof (n == null ? void 0 : n.startTime) < "u" && (o.params.start_time = n.startTime);
    const u = "osmosis/twap/v1beta1/GeometricTwapToNow";
    return await this.req.get(u, o);
  }
};
const _303 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$2
}, Symbol.toStringTag, { value: "Module" }));
let LCDQueryClient$1 = class {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.feeTokens = this.feeTokens.bind(this), this.denomSpotPrice = this.denomSpotPrice.bind(this), this.denomPoolId = this.denomPoolId.bind(this), this.baseDenom = this.baseDenom.bind(this);
  }
  /* FeeTokens returns a list of all the whitelisted fee tokens and their
   corresponding pools. It does not include the BaseDenom, which has its own
   query endpoint */
  async feeTokens(n = {}) {
    const o = "osmosis/txfees/v1beta1/fee_tokens";
    return await this.req.get(o);
  }
  /* DenomSpotPrice returns all spot prices by each registered token denom. */
  async denomSpotPrice(n) {
    const o = {
      params: {}
    };
    typeof (n == null ? void 0 : n.denom) < "u" && (o.params.denom = n.denom);
    const u = "osmosis/txfees/v1beta1/spot_price_by_denom";
    return await this.req.get(u, o);
  }
  /* Returns the poolID for a specified denom input. */
  async denomPoolId(n) {
    const o = `osmosis/txfees/v1beta1/denom_pool_id/${n.denom}`;
    return await this.req.get(o);
  }
  /* Returns a list of all base denom tokens and their corresponding pools. */
  async baseDenom(n = {}) {
    const o = "osmosis/txfees/v1beta1/base_denom";
    return await this.req.get(o);
  }
};
const _304 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient: LCDQueryClient$1
}, Symbol.toStringTag, { value: "Module" }));
class LCDQueryClient {
  constructor({
    requestClient: n
  }) {
    _defineProperty(this, "req", void 0), this.req = n, this.userValidatorPreferences = this.userValidatorPreferences.bind(this);
  }
  /* Returns the list of ValidatorPreferences for the user. */
  async userValidatorPreferences(n) {
    const o = `osmosis/valset-pref/v1beta1/${n.address}`;
    return await this.req.get(o);
  }
}
const _305 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LCDQueryClient
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$g = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this);
  }
  params(n = {}) {
    const o = ParamsRequest$3.encode(n).finish();
    return this.rpc.request("osmosis.cosmwasmpool.v1beta1.Query", "Params", o).then((c) => ParamsResponse$3.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$g = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$g(n);
  return {
    params(u) {
      return o.params(u);
    }
  };
}, _307 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$g,
  createRpcQueryExtension: createRpcQueryExtension$g
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$f = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.recoveredSinceDowntimeOfLength = this.recoveredSinceDowntimeOfLength.bind(this);
  }
  recoveredSinceDowntimeOfLength(n) {
    const o = RecoveredSinceDowntimeOfLengthRequest.encode(n).finish();
    return this.rpc.request("osmosis.downtimedetector.v1beta1.Query", "RecoveredSinceDowntimeOfLength", o).then((c) => RecoveredSinceDowntimeOfLengthResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$f = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$f(n);
  return {
    recoveredSinceDowntimeOfLength(u) {
      return o.recoveredSinceDowntimeOfLength(u);
    }
  };
}, _308 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$f,
  createRpcQueryExtension: createRpcQueryExtension$f
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$e = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.epochInfos = this.epochInfos.bind(this), this.currentEpoch = this.currentEpoch.bind(this);
  }
  epochInfos(n = {}) {
    const o = QueryEpochsInfoRequest.encode(n).finish();
    return this.rpc.request("osmosis.epochs.v1beta1.Query", "EpochInfos", o).then((c) => QueryEpochsInfoResponse.decode(new minimal.Reader(c)));
  }
  currentEpoch(n) {
    const o = QueryCurrentEpochRequest.encode(n).finish();
    return this.rpc.request("osmosis.epochs.v1beta1.Query", "CurrentEpoch", o).then((c) => QueryCurrentEpochResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$e = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$e(n);
  return {
    epochInfos(u) {
      return o.epochInfos(u);
    },
    currentEpoch(u) {
      return o.currentEpoch(u);
    }
  };
}, _309 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$e,
  createRpcQueryExtension: createRpcQueryExtension$e
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$d = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.pools = this.pools.bind(this), this.numPools = this.numPools.bind(this), this.totalLiquidity = this.totalLiquidity.bind(this), this.poolsWithFilter = this.poolsWithFilter.bind(this), this.pool = this.pool.bind(this), this.poolType = this.poolType.bind(this), this.calcJoinPoolNoSwapShares = this.calcJoinPoolNoSwapShares.bind(this), this.calcJoinPoolShares = this.calcJoinPoolShares.bind(this), this.calcExitPoolCoinsFromShares = this.calcExitPoolCoinsFromShares.bind(this), this.poolParams = this.poolParams.bind(this), this.totalPoolLiquidity = this.totalPoolLiquidity.bind(this), this.totalShares = this.totalShares.bind(this), this.spotPrice = this.spotPrice.bind(this), this.estimateSwapExactAmountIn = this.estimateSwapExactAmountIn.bind(this), this.estimateSwapExactAmountOut = this.estimateSwapExactAmountOut.bind(this);
  }
  pools(n = {
    pagination: void 0
  }) {
    const o = QueryPoolsRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "Pools", o).then((c) => QueryPoolsResponse.decode(new minimal.Reader(c)));
  }
  numPools(n = {}) {
    const o = QueryNumPoolsRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "NumPools", o).then((c) => QueryNumPoolsResponse.decode(new minimal.Reader(c)));
  }
  totalLiquidity(n = {}) {
    const o = QueryTotalLiquidityRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "TotalLiquidity", o).then((c) => QueryTotalLiquidityResponse.decode(new minimal.Reader(c)));
  }
  poolsWithFilter(n) {
    const o = QueryPoolsWithFilterRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "PoolsWithFilter", o).then((c) => QueryPoolsWithFilterResponse.decode(new minimal.Reader(c)));
  }
  pool(n) {
    const o = QueryPoolRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "Pool", o).then((c) => QueryPoolResponse.decode(new minimal.Reader(c)));
  }
  poolType(n) {
    const o = QueryPoolTypeRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "PoolType", o).then((c) => QueryPoolTypeResponse.decode(new minimal.Reader(c)));
  }
  calcJoinPoolNoSwapShares(n) {
    const o = QueryCalcJoinPoolNoSwapSharesRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "CalcJoinPoolNoSwapShares", o).then((c) => QueryCalcJoinPoolNoSwapSharesResponse.decode(new minimal.Reader(c)));
  }
  calcJoinPoolShares(n) {
    const o = QueryCalcJoinPoolSharesRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "CalcJoinPoolShares", o).then((c) => QueryCalcJoinPoolSharesResponse.decode(new minimal.Reader(c)));
  }
  calcExitPoolCoinsFromShares(n) {
    const o = QueryCalcExitPoolCoinsFromSharesRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "CalcExitPoolCoinsFromShares", o).then((c) => QueryCalcExitPoolCoinsFromSharesResponse.decode(new minimal.Reader(c)));
  }
  poolParams(n) {
    const o = QueryPoolParamsRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "PoolParams", o).then((c) => QueryPoolParamsResponse.decode(new minimal.Reader(c)));
  }
  totalPoolLiquidity(n) {
    const o = QueryTotalPoolLiquidityRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "TotalPoolLiquidity", o).then((c) => QueryTotalPoolLiquidityResponse.decode(new minimal.Reader(c)));
  }
  totalShares(n) {
    const o = QueryTotalSharesRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "TotalShares", o).then((c) => QueryTotalSharesResponse.decode(new minimal.Reader(c)));
  }
  spotPrice(n) {
    const o = QuerySpotPriceRequest$1.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "SpotPrice", o).then((c) => QuerySpotPriceResponse$1.decode(new minimal.Reader(c)));
  }
  estimateSwapExactAmountIn(n) {
    const o = QuerySwapExactAmountInRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "EstimateSwapExactAmountIn", o).then((c) => QuerySwapExactAmountInResponse.decode(new minimal.Reader(c)));
  }
  estimateSwapExactAmountOut(n) {
    const o = QuerySwapExactAmountOutRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Query", "EstimateSwapExactAmountOut", o).then((c) => QuerySwapExactAmountOutResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$d = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$d(n);
  return {
    pools(u) {
      return o.pools(u);
    },
    numPools(u) {
      return o.numPools(u);
    },
    totalLiquidity(u) {
      return o.totalLiquidity(u);
    },
    poolsWithFilter(u) {
      return o.poolsWithFilter(u);
    },
    pool(u) {
      return o.pool(u);
    },
    poolType(u) {
      return o.poolType(u);
    },
    calcJoinPoolNoSwapShares(u) {
      return o.calcJoinPoolNoSwapShares(u);
    },
    calcJoinPoolShares(u) {
      return o.calcJoinPoolShares(u);
    },
    calcExitPoolCoinsFromShares(u) {
      return o.calcExitPoolCoinsFromShares(u);
    },
    poolParams(u) {
      return o.poolParams(u);
    },
    totalPoolLiquidity(u) {
      return o.totalPoolLiquidity(u);
    },
    totalShares(u) {
      return o.totalShares(u);
    },
    spotPrice(u) {
      return o.spotPrice(u);
    },
    estimateSwapExactAmountIn(u) {
      return o.estimateSwapExactAmountIn(u);
    },
    estimateSwapExactAmountOut(u) {
      return o.estimateSwapExactAmountOut(u);
    }
  };
}, _310 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$d,
  createRpcQueryExtension: createRpcQueryExtension$d
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$c = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.spotPrice = this.spotPrice.bind(this);
  }
  spotPrice(n) {
    const o = QuerySpotPriceRequest.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v2.Query", "SpotPrice", o).then((c) => QuerySpotPriceResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$c = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$c(n);
  return {
    spotPrice(u) {
      return o.spotPrice(u);
    }
  };
}, _311 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$c,
  createRpcQueryExtension: createRpcQueryExtension$c
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$b = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this);
  }
  params(n = {}) {
    const o = ParamsRequest$2.encode(n).finish();
    return this.rpc.request("osmosis.ibcratelimit.v1beta1.Query", "Params", o).then((c) => ParamsResponse$2.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$b = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$b(n);
  return {
    params(u) {
      return o.params(u);
    }
  };
}, _312 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$b,
  createRpcQueryExtension: createRpcQueryExtension$b
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$a = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.moduleToDistributeCoins = this.moduleToDistributeCoins.bind(this), this.gaugeByID = this.gaugeByID.bind(this), this.gauges = this.gauges.bind(this), this.activeGauges = this.activeGauges.bind(this), this.activeGaugesPerDenom = this.activeGaugesPerDenom.bind(this), this.upcomingGauges = this.upcomingGauges.bind(this), this.upcomingGaugesPerDenom = this.upcomingGaugesPerDenom.bind(this), this.rewardsEst = this.rewardsEst.bind(this), this.lockableDurations = this.lockableDurations.bind(this);
  }
  moduleToDistributeCoins(n = {}) {
    const o = ModuleToDistributeCoinsRequest.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "ModuleToDistributeCoins", o).then((c) => ModuleToDistributeCoinsResponse.decode(new minimal.Reader(c)));
  }
  gaugeByID(n) {
    const o = GaugeByIDRequest.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "GaugeByID", o).then((c) => GaugeByIDResponse.decode(new minimal.Reader(c)));
  }
  gauges(n = {
    pagination: void 0
  }) {
    const o = GaugesRequest.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "Gauges", o).then((c) => GaugesResponse.decode(new minimal.Reader(c)));
  }
  activeGauges(n = {
    pagination: void 0
  }) {
    const o = ActiveGaugesRequest.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "ActiveGauges", o).then((c) => ActiveGaugesResponse.decode(new minimal.Reader(c)));
  }
  activeGaugesPerDenom(n) {
    const o = ActiveGaugesPerDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "ActiveGaugesPerDenom", o).then((c) => ActiveGaugesPerDenomResponse.decode(new minimal.Reader(c)));
  }
  upcomingGauges(n = {
    pagination: void 0
  }) {
    const o = UpcomingGaugesRequest.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "UpcomingGauges", o).then((c) => UpcomingGaugesResponse.decode(new minimal.Reader(c)));
  }
  upcomingGaugesPerDenom(n) {
    const o = UpcomingGaugesPerDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "UpcomingGaugesPerDenom", o).then((c) => UpcomingGaugesPerDenomResponse.decode(new minimal.Reader(c)));
  }
  rewardsEst(n) {
    const o = RewardsEstRequest.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "RewardsEst", o).then((c) => RewardsEstResponse.decode(new minimal.Reader(c)));
  }
  lockableDurations(n = {}) {
    const o = QueryLockableDurationsRequest$1.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Query", "LockableDurations", o).then((c) => QueryLockableDurationsResponse$1.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$a = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$a(n);
  return {
    moduleToDistributeCoins(u) {
      return o.moduleToDistributeCoins(u);
    },
    gaugeByID(u) {
      return o.gaugeByID(u);
    },
    gauges(u) {
      return o.gauges(u);
    },
    activeGauges(u) {
      return o.activeGauges(u);
    },
    activeGaugesPerDenom(u) {
      return o.activeGaugesPerDenom(u);
    },
    upcomingGauges(u) {
      return o.upcomingGauges(u);
    },
    upcomingGaugesPerDenom(u) {
      return o.upcomingGaugesPerDenom(u);
    },
    rewardsEst(u) {
      return o.rewardsEst(u);
    },
    lockableDurations(u) {
      return o.lockableDurations(u);
    }
  };
}, _313 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$a,
  createRpcQueryExtension: createRpcQueryExtension$a
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$9 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.moduleBalance = this.moduleBalance.bind(this), this.moduleLockedAmount = this.moduleLockedAmount.bind(this), this.accountUnlockableCoins = this.accountUnlockableCoins.bind(this), this.accountUnlockingCoins = this.accountUnlockingCoins.bind(this), this.accountLockedCoins = this.accountLockedCoins.bind(this), this.accountLockedPastTime = this.accountLockedPastTime.bind(this), this.accountLockedPastTimeNotUnlockingOnly = this.accountLockedPastTimeNotUnlockingOnly.bind(this), this.accountUnlockedBeforeTime = this.accountUnlockedBeforeTime.bind(this), this.accountLockedPastTimeDenom = this.accountLockedPastTimeDenom.bind(this), this.lockedDenom = this.lockedDenom.bind(this), this.lockedByID = this.lockedByID.bind(this), this.nextLockID = this.nextLockID.bind(this), this.syntheticLockupsByLockupID = this.syntheticLockupsByLockupID.bind(this), this.accountLockedLongerDuration = this.accountLockedLongerDuration.bind(this), this.accountLockedDuration = this.accountLockedDuration.bind(this), this.accountLockedLongerDurationNotUnlockingOnly = this.accountLockedLongerDurationNotUnlockingOnly.bind(this), this.accountLockedLongerDurationDenom = this.accountLockedLongerDurationDenom.bind(this), this.params = this.params.bind(this);
  }
  moduleBalance(n = {}) {
    const o = ModuleBalanceRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "ModuleBalance", o).then((c) => ModuleBalanceResponse.decode(new minimal.Reader(c)));
  }
  moduleLockedAmount(n = {}) {
    const o = ModuleLockedAmountRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "ModuleLockedAmount", o).then((c) => ModuleLockedAmountResponse.decode(new minimal.Reader(c)));
  }
  accountUnlockableCoins(n) {
    const o = AccountUnlockableCoinsRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountUnlockableCoins", o).then((c) => AccountUnlockableCoinsResponse.decode(new minimal.Reader(c)));
  }
  accountUnlockingCoins(n) {
    const o = AccountUnlockingCoinsRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountUnlockingCoins", o).then((c) => AccountUnlockingCoinsResponse.decode(new minimal.Reader(c)));
  }
  accountLockedCoins(n) {
    const o = AccountLockedCoinsRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountLockedCoins", o).then((c) => AccountLockedCoinsResponse.decode(new minimal.Reader(c)));
  }
  accountLockedPastTime(n) {
    const o = AccountLockedPastTimeRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountLockedPastTime", o).then((c) => AccountLockedPastTimeResponse.decode(new minimal.Reader(c)));
  }
  accountLockedPastTimeNotUnlockingOnly(n) {
    const o = AccountLockedPastTimeNotUnlockingOnlyRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountLockedPastTimeNotUnlockingOnly", o).then((c) => AccountLockedPastTimeNotUnlockingOnlyResponse.decode(new minimal.Reader(c)));
  }
  accountUnlockedBeforeTime(n) {
    const o = AccountUnlockedBeforeTimeRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountUnlockedBeforeTime", o).then((c) => AccountUnlockedBeforeTimeResponse.decode(new minimal.Reader(c)));
  }
  accountLockedPastTimeDenom(n) {
    const o = AccountLockedPastTimeDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountLockedPastTimeDenom", o).then((c) => AccountLockedPastTimeDenomResponse.decode(new minimal.Reader(c)));
  }
  lockedDenom(n) {
    const o = LockedDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "LockedDenom", o).then((c) => LockedDenomResponse.decode(new minimal.Reader(c)));
  }
  lockedByID(n) {
    const o = LockedRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "LockedByID", o).then((c) => LockedResponse.decode(new minimal.Reader(c)));
  }
  nextLockID(n = {}) {
    const o = NextLockIDRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "NextLockID", o).then((c) => NextLockIDResponse.decode(new minimal.Reader(c)));
  }
  syntheticLockupsByLockupID(n) {
    const o = SyntheticLockupsByLockupIDRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "SyntheticLockupsByLockupID", o).then((c) => SyntheticLockupsByLockupIDResponse.decode(new minimal.Reader(c)));
  }
  accountLockedLongerDuration(n) {
    const o = AccountLockedLongerDurationRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountLockedLongerDuration", o).then((c) => AccountLockedLongerDurationResponse.decode(new minimal.Reader(c)));
  }
  accountLockedDuration(n) {
    const o = AccountLockedDurationRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountLockedDuration", o).then((c) => AccountLockedDurationResponse.decode(new minimal.Reader(c)));
  }
  accountLockedLongerDurationNotUnlockingOnly(n) {
    const o = AccountLockedLongerDurationNotUnlockingOnlyRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountLockedLongerDurationNotUnlockingOnly", o).then((c) => AccountLockedLongerDurationNotUnlockingOnlyResponse.decode(new minimal.Reader(c)));
  }
  accountLockedLongerDurationDenom(n) {
    const o = AccountLockedLongerDurationDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "AccountLockedLongerDurationDenom", o).then((c) => AccountLockedLongerDurationDenomResponse.decode(new minimal.Reader(c)));
  }
  params(n = {}) {
    const o = QueryParamsRequest$5.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Query", "Params", o).then((c) => QueryParamsResponse$5.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$9 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$9(n);
  return {
    moduleBalance(u) {
      return o.moduleBalance(u);
    },
    moduleLockedAmount(u) {
      return o.moduleLockedAmount(u);
    },
    accountUnlockableCoins(u) {
      return o.accountUnlockableCoins(u);
    },
    accountUnlockingCoins(u) {
      return o.accountUnlockingCoins(u);
    },
    accountLockedCoins(u) {
      return o.accountLockedCoins(u);
    },
    accountLockedPastTime(u) {
      return o.accountLockedPastTime(u);
    },
    accountLockedPastTimeNotUnlockingOnly(u) {
      return o.accountLockedPastTimeNotUnlockingOnly(u);
    },
    accountUnlockedBeforeTime(u) {
      return o.accountUnlockedBeforeTime(u);
    },
    accountLockedPastTimeDenom(u) {
      return o.accountLockedPastTimeDenom(u);
    },
    lockedDenom(u) {
      return o.lockedDenom(u);
    },
    lockedByID(u) {
      return o.lockedByID(u);
    },
    nextLockID(u) {
      return o.nextLockID(u);
    },
    syntheticLockupsByLockupID(u) {
      return o.syntheticLockupsByLockupID(u);
    },
    accountLockedLongerDuration(u) {
      return o.accountLockedLongerDuration(u);
    },
    accountLockedDuration(u) {
      return o.accountLockedDuration(u);
    },
    accountLockedLongerDurationNotUnlockingOnly(u) {
      return o.accountLockedLongerDurationNotUnlockingOnly(u);
    },
    accountLockedLongerDurationDenom(u) {
      return o.accountLockedLongerDurationDenom(u);
    },
    params(u) {
      return o.params(u);
    }
  };
}, _314 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$9,
  createRpcQueryExtension: createRpcQueryExtension$9
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$8 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this), this.epochProvisions = this.epochProvisions.bind(this);
  }
  params(n = {}) {
    const o = QueryParamsRequest$4.encode(n).finish();
    return this.rpc.request("osmosis.mint.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse$4.decode(new minimal.Reader(c)));
  }
  epochProvisions(n = {}) {
    const o = QueryEpochProvisionsRequest.encode(n).finish();
    return this.rpc.request("osmosis.mint.v1beta1.Query", "EpochProvisions", o).then((c) => QueryEpochProvisionsResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$8 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$8(n);
  return {
    params(u) {
      return o.params(u);
    },
    epochProvisions(u) {
      return o.epochProvisions(u);
    }
  };
}, _315 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$8,
  createRpcQueryExtension: createRpcQueryExtension$8
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$7 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.gaugeIds = this.gaugeIds.bind(this), this.distrInfo = this.distrInfo.bind(this), this.params = this.params.bind(this), this.lockableDurations = this.lockableDurations.bind(this), this.incentivizedPools = this.incentivizedPools.bind(this), this.externalIncentiveGauges = this.externalIncentiveGauges.bind(this);
  }
  gaugeIds(n) {
    const o = QueryGaugeIdsRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolincentives.v1beta1.Query", "GaugeIds", o).then((c) => QueryGaugeIdsResponse.decode(new minimal.Reader(c)));
  }
  distrInfo(n = {}) {
    const o = QueryDistrInfoRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolincentives.v1beta1.Query", "DistrInfo", o).then((c) => QueryDistrInfoResponse.decode(new minimal.Reader(c)));
  }
  params(n = {}) {
    const o = QueryParamsRequest$3.encode(n).finish();
    return this.rpc.request("osmosis.poolincentives.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse$3.decode(new minimal.Reader(c)));
  }
  lockableDurations(n = {}) {
    const o = QueryLockableDurationsRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolincentives.v1beta1.Query", "LockableDurations", o).then((c) => QueryLockableDurationsResponse.decode(new minimal.Reader(c)));
  }
  incentivizedPools(n = {}) {
    const o = QueryIncentivizedPoolsRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolincentives.v1beta1.Query", "IncentivizedPools", o).then((c) => QueryIncentivizedPoolsResponse.decode(new minimal.Reader(c)));
  }
  externalIncentiveGauges(n = {}) {
    const o = QueryExternalIncentiveGaugesRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolincentives.v1beta1.Query", "ExternalIncentiveGauges", o).then((c) => QueryExternalIncentiveGaugesResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$7 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$7(n);
  return {
    gaugeIds(u) {
      return o.gaugeIds(u);
    },
    distrInfo(u) {
      return o.distrInfo(u);
    },
    params(u) {
      return o.params(u);
    },
    lockableDurations(u) {
      return o.lockableDurations(u);
    },
    incentivizedPools(u) {
      return o.incentivizedPools(u);
    },
    externalIncentiveGauges(u) {
      return o.externalIncentiveGauges(u);
    }
  };
}, _316 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$7,
  createRpcQueryExtension: createRpcQueryExtension$7
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$6 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this), this.estimateSwapExactAmountIn = this.estimateSwapExactAmountIn.bind(this), this.estimateSinglePoolSwapExactAmountIn = this.estimateSinglePoolSwapExactAmountIn.bind(this), this.estimateSwapExactAmountOut = this.estimateSwapExactAmountOut.bind(this), this.estimateSinglePoolSwapExactAmountOut = this.estimateSinglePoolSwapExactAmountOut.bind(this), this.numPools = this.numPools.bind(this), this.pool = this.pool.bind(this), this.allPools = this.allPools.bind(this), this.spotPrice = this.spotPrice.bind(this);
  }
  params(n = {}) {
    const o = ParamsRequest$1.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "Params", o).then((c) => ParamsResponse$1.decode(new minimal.Reader(c)));
  }
  estimateSwapExactAmountIn(n) {
    const o = EstimateSwapExactAmountInRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "EstimateSwapExactAmountIn", o).then((c) => EstimateSwapExactAmountInResponse.decode(new minimal.Reader(c)));
  }
  estimateSinglePoolSwapExactAmountIn(n) {
    const o = EstimateSinglePoolSwapExactAmountInRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "EstimateSinglePoolSwapExactAmountIn", o).then((c) => EstimateSwapExactAmountInResponse.decode(new minimal.Reader(c)));
  }
  estimateSwapExactAmountOut(n) {
    const o = EstimateSwapExactAmountOutRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "EstimateSwapExactAmountOut", o).then((c) => EstimateSwapExactAmountOutResponse.decode(new minimal.Reader(c)));
  }
  estimateSinglePoolSwapExactAmountOut(n) {
    const o = EstimateSinglePoolSwapExactAmountOutRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "EstimateSinglePoolSwapExactAmountOut", o).then((c) => EstimateSwapExactAmountOutResponse.decode(new minimal.Reader(c)));
  }
  numPools(n = {}) {
    const o = NumPoolsRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "NumPools", o).then((c) => NumPoolsResponse.decode(new minimal.Reader(c)));
  }
  pool(n) {
    const o = PoolRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "Pool", o).then((c) => PoolResponse.decode(new minimal.Reader(c)));
  }
  allPools(n) {
    const o = AllPoolsRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "AllPools", o).then((c) => AllPoolsResponse.decode(new minimal.Reader(c)));
  }
  spotPrice(n) {
    const o = SpotPriceRequest.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Query", "SpotPrice", o).then((c) => SpotPriceResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$6 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$6(n);
  return {
    params(u) {
      return o.params(u);
    },
    estimateSwapExactAmountIn(u) {
      return o.estimateSwapExactAmountIn(u);
    },
    estimateSinglePoolSwapExactAmountIn(u) {
      return o.estimateSinglePoolSwapExactAmountIn(u);
    },
    estimateSwapExactAmountOut(u) {
      return o.estimateSwapExactAmountOut(u);
    },
    estimateSinglePoolSwapExactAmountOut(u) {
      return o.estimateSinglePoolSwapExactAmountOut(u);
    },
    numPools(u) {
      return o.numPools(u);
    },
    pool(u) {
      return o.pool(u);
    },
    allPools(u) {
      return o.allPools(u);
    },
    spotPrice(u) {
      return o.spotPrice(u);
    }
  };
}, _317 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$6,
  createRpcQueryExtension: createRpcQueryExtension$6
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$5 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this), this.getProtoRevNumberOfTrades = this.getProtoRevNumberOfTrades.bind(this), this.getProtoRevProfitsByDenom = this.getProtoRevProfitsByDenom.bind(this), this.getProtoRevAllProfits = this.getProtoRevAllProfits.bind(this), this.getProtoRevStatisticsByRoute = this.getProtoRevStatisticsByRoute.bind(this), this.getProtoRevAllRouteStatistics = this.getProtoRevAllRouteStatistics.bind(this), this.getProtoRevTokenPairArbRoutes = this.getProtoRevTokenPairArbRoutes.bind(this), this.getProtoRevAdminAccount = this.getProtoRevAdminAccount.bind(this), this.getProtoRevDeveloperAccount = this.getProtoRevDeveloperAccount.bind(this), this.getProtoRevPoolWeights = this.getProtoRevPoolWeights.bind(this), this.getProtoRevMaxPoolPointsPerTx = this.getProtoRevMaxPoolPointsPerTx.bind(this), this.getProtoRevMaxPoolPointsPerBlock = this.getProtoRevMaxPoolPointsPerBlock.bind(this), this.getProtoRevBaseDenoms = this.getProtoRevBaseDenoms.bind(this), this.getProtoRevEnabled = this.getProtoRevEnabled.bind(this);
  }
  params(n = {}) {
    const o = QueryParamsRequest$2.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse$2.decode(new minimal.Reader(c)));
  }
  getProtoRevNumberOfTrades(n = {}) {
    const o = QueryGetProtoRevNumberOfTradesRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevNumberOfTrades", o).then((c) => QueryGetProtoRevNumberOfTradesResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevProfitsByDenom(n) {
    const o = QueryGetProtoRevProfitsByDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevProfitsByDenom", o).then((c) => QueryGetProtoRevProfitsByDenomResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevAllProfits(n = {}) {
    const o = QueryGetProtoRevAllProfitsRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevAllProfits", o).then((c) => QueryGetProtoRevAllProfitsResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevStatisticsByRoute(n) {
    const o = QueryGetProtoRevStatisticsByRouteRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevStatisticsByRoute", o).then((c) => QueryGetProtoRevStatisticsByRouteResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevAllRouteStatistics(n = {}) {
    const o = QueryGetProtoRevAllRouteStatisticsRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevAllRouteStatistics", o).then((c) => QueryGetProtoRevAllRouteStatisticsResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevTokenPairArbRoutes(n = {}) {
    const o = QueryGetProtoRevTokenPairArbRoutesRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevTokenPairArbRoutes", o).then((c) => QueryGetProtoRevTokenPairArbRoutesResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevAdminAccount(n = {}) {
    const o = QueryGetProtoRevAdminAccountRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevAdminAccount", o).then((c) => QueryGetProtoRevAdminAccountResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevDeveloperAccount(n = {}) {
    const o = QueryGetProtoRevDeveloperAccountRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevDeveloperAccount", o).then((c) => QueryGetProtoRevDeveloperAccountResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevPoolWeights(n = {}) {
    const o = QueryGetProtoRevPoolWeightsRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevPoolWeights", o).then((c) => QueryGetProtoRevPoolWeightsResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevMaxPoolPointsPerTx(n = {}) {
    const o = QueryGetProtoRevMaxPoolPointsPerTxRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevMaxPoolPointsPerTx", o).then((c) => QueryGetProtoRevMaxPoolPointsPerTxResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevMaxPoolPointsPerBlock(n = {}) {
    const o = QueryGetProtoRevMaxPoolPointsPerBlockRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevMaxPoolPointsPerBlock", o).then((c) => QueryGetProtoRevMaxPoolPointsPerBlockResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevBaseDenoms(n = {}) {
    const o = QueryGetProtoRevBaseDenomsRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevBaseDenoms", o).then((c) => QueryGetProtoRevBaseDenomsResponse.decode(new minimal.Reader(c)));
  }
  getProtoRevEnabled(n = {}) {
    const o = QueryGetProtoRevEnabledRequest.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevEnabled", o).then((c) => QueryGetProtoRevEnabledResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$5 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$5(n);
  return {
    params(u) {
      return o.params(u);
    },
    getProtoRevNumberOfTrades(u) {
      return o.getProtoRevNumberOfTrades(u);
    },
    getProtoRevProfitsByDenom(u) {
      return o.getProtoRevProfitsByDenom(u);
    },
    getProtoRevAllProfits(u) {
      return o.getProtoRevAllProfits(u);
    },
    getProtoRevStatisticsByRoute(u) {
      return o.getProtoRevStatisticsByRoute(u);
    },
    getProtoRevAllRouteStatistics(u) {
      return o.getProtoRevAllRouteStatistics(u);
    },
    getProtoRevTokenPairArbRoutes(u) {
      return o.getProtoRevTokenPairArbRoutes(u);
    },
    getProtoRevAdminAccount(u) {
      return o.getProtoRevAdminAccount(u);
    },
    getProtoRevDeveloperAccount(u) {
      return o.getProtoRevDeveloperAccount(u);
    },
    getProtoRevPoolWeights(u) {
      return o.getProtoRevPoolWeights(u);
    },
    getProtoRevMaxPoolPointsPerTx(u) {
      return o.getProtoRevMaxPoolPointsPerTx(u);
    },
    getProtoRevMaxPoolPointsPerBlock(u) {
      return o.getProtoRevMaxPoolPointsPerBlock(u);
    },
    getProtoRevBaseDenoms(u) {
      return o.getProtoRevBaseDenoms(u);
    },
    getProtoRevEnabled(u) {
      return o.getProtoRevEnabled(u);
    }
  };
}, _318 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$5,
  createRpcQueryExtension: createRpcQueryExtension$5
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$4 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this), this.assetType = this.assetType.bind(this), this.allAssets = this.allAssets.bind(this), this.assetMultiplier = this.assetMultiplier.bind(this), this.allIntermediaryAccounts = this.allIntermediaryAccounts.bind(this), this.connectedIntermediaryAccount = this.connectedIntermediaryAccount.bind(this), this.totalDelegationByValidatorForDenom = this.totalDelegationByValidatorForDenom.bind(this), this.totalSuperfluidDelegations = this.totalSuperfluidDelegations.bind(this), this.superfluidDelegationAmount = this.superfluidDelegationAmount.bind(this), this.superfluidDelegationsByDelegator = this.superfluidDelegationsByDelegator.bind(this), this.superfluidUndelegationsByDelegator = this.superfluidUndelegationsByDelegator.bind(this), this.superfluidDelegationsByValidatorDenom = this.superfluidDelegationsByValidatorDenom.bind(this), this.estimateSuperfluidDelegatedAmountByValidatorDenom = this.estimateSuperfluidDelegatedAmountByValidatorDenom.bind(this), this.totalDelegationByDelegator = this.totalDelegationByDelegator.bind(this), this.unpoolWhitelist = this.unpoolWhitelist.bind(this);
  }
  params(n = {}) {
    const o = QueryParamsRequest$1.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "Params", o).then((c) => QueryParamsResponse$1.decode(new minimal.Reader(c)));
  }
  assetType(n) {
    const o = AssetTypeRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "AssetType", o).then((c) => AssetTypeResponse.decode(new minimal.Reader(c)));
  }
  allAssets(n = {}) {
    const o = AllAssetsRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "AllAssets", o).then((c) => AllAssetsResponse.decode(new minimal.Reader(c)));
  }
  assetMultiplier(n) {
    const o = AssetMultiplierRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "AssetMultiplier", o).then((c) => AssetMultiplierResponse.decode(new minimal.Reader(c)));
  }
  allIntermediaryAccounts(n = {
    pagination: void 0
  }) {
    const o = AllIntermediaryAccountsRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "AllIntermediaryAccounts", o).then((c) => AllIntermediaryAccountsResponse.decode(new minimal.Reader(c)));
  }
  connectedIntermediaryAccount(n) {
    const o = ConnectedIntermediaryAccountRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "ConnectedIntermediaryAccount", o).then((c) => ConnectedIntermediaryAccountResponse.decode(new minimal.Reader(c)));
  }
  totalDelegationByValidatorForDenom(n) {
    const o = QueryTotalDelegationByValidatorForDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "TotalDelegationByValidatorForDenom", o).then((c) => QueryTotalDelegationByValidatorForDenomResponse.decode(new minimal.Reader(c)));
  }
  totalSuperfluidDelegations(n = {}) {
    const o = TotalSuperfluidDelegationsRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "TotalSuperfluidDelegations", o).then((c) => TotalSuperfluidDelegationsResponse.decode(new minimal.Reader(c)));
  }
  superfluidDelegationAmount(n) {
    const o = SuperfluidDelegationAmountRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "SuperfluidDelegationAmount", o).then((c) => SuperfluidDelegationAmountResponse.decode(new minimal.Reader(c)));
  }
  superfluidDelegationsByDelegator(n) {
    const o = SuperfluidDelegationsByDelegatorRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "SuperfluidDelegationsByDelegator", o).then((c) => SuperfluidDelegationsByDelegatorResponse.decode(new minimal.Reader(c)));
  }
  superfluidUndelegationsByDelegator(n) {
    const o = SuperfluidUndelegationsByDelegatorRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "SuperfluidUndelegationsByDelegator", o).then((c) => SuperfluidUndelegationsByDelegatorResponse.decode(new minimal.Reader(c)));
  }
  superfluidDelegationsByValidatorDenom(n) {
    const o = SuperfluidDelegationsByValidatorDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "SuperfluidDelegationsByValidatorDenom", o).then((c) => SuperfluidDelegationsByValidatorDenomResponse.decode(new minimal.Reader(c)));
  }
  estimateSuperfluidDelegatedAmountByValidatorDenom(n) {
    const o = EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "EstimateSuperfluidDelegatedAmountByValidatorDenom", o).then((c) => EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.decode(new minimal.Reader(c)));
  }
  totalDelegationByDelegator(n) {
    const o = QueryTotalDelegationByDelegatorRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "TotalDelegationByDelegator", o).then((c) => QueryTotalDelegationByDelegatorResponse.decode(new minimal.Reader(c)));
  }
  unpoolWhitelist(n = {}) {
    const o = QueryUnpoolWhitelistRequest.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Query", "UnpoolWhitelist", o).then((c) => QueryUnpoolWhitelistResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$4 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$4(n);
  return {
    params(u) {
      return o.params(u);
    },
    assetType(u) {
      return o.assetType(u);
    },
    allAssets(u) {
      return o.allAssets(u);
    },
    assetMultiplier(u) {
      return o.assetMultiplier(u);
    },
    allIntermediaryAccounts(u) {
      return o.allIntermediaryAccounts(u);
    },
    connectedIntermediaryAccount(u) {
      return o.connectedIntermediaryAccount(u);
    },
    totalDelegationByValidatorForDenom(u) {
      return o.totalDelegationByValidatorForDenom(u);
    },
    totalSuperfluidDelegations(u) {
      return o.totalSuperfluidDelegations(u);
    },
    superfluidDelegationAmount(u) {
      return o.superfluidDelegationAmount(u);
    },
    superfluidDelegationsByDelegator(u) {
      return o.superfluidDelegationsByDelegator(u);
    },
    superfluidUndelegationsByDelegator(u) {
      return o.superfluidUndelegationsByDelegator(u);
    },
    superfluidDelegationsByValidatorDenom(u) {
      return o.superfluidDelegationsByValidatorDenom(u);
    },
    estimateSuperfluidDelegatedAmountByValidatorDenom(u) {
      return o.estimateSuperfluidDelegatedAmountByValidatorDenom(u);
    },
    totalDelegationByDelegator(u) {
      return o.totalDelegationByDelegator(u);
    },
    unpoolWhitelist(u) {
      return o.unpoolWhitelist(u);
    }
  };
}, _319 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$4,
  createRpcQueryExtension: createRpcQueryExtension$4
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$3 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this), this.denomAuthorityMetadata = this.denomAuthorityMetadata.bind(this), this.denomsFromCreator = this.denomsFromCreator.bind(this), this.beforeSendHookAddress = this.beforeSendHookAddress.bind(this);
  }
  params(n = {}) {
    const o = QueryParamsRequest.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Query", "Params", o).then((c) => QueryParamsResponse.decode(new minimal.Reader(c)));
  }
  denomAuthorityMetadata(n) {
    const o = QueryDenomAuthorityMetadataRequest.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Query", "DenomAuthorityMetadata", o).then((c) => QueryDenomAuthorityMetadataResponse.decode(new minimal.Reader(c)));
  }
  denomsFromCreator(n) {
    const o = QueryDenomsFromCreatorRequest.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Query", "DenomsFromCreator", o).then((c) => QueryDenomsFromCreatorResponse.decode(new minimal.Reader(c)));
  }
  beforeSendHookAddress(n) {
    const o = QueryBeforeSendHookAddressRequest.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Query", "BeforeSendHookAddress", o).then((c) => QueryBeforeSendHookAddressResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$3 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$3(n);
  return {
    params(u) {
      return o.params(u);
    },
    denomAuthorityMetadata(u) {
      return o.denomAuthorityMetadata(u);
    },
    denomsFromCreator(u) {
      return o.denomsFromCreator(u);
    },
    beforeSendHookAddress(u) {
      return o.beforeSendHookAddress(u);
    }
  };
}, _320 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$3,
  createRpcQueryExtension: createRpcQueryExtension$3
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$2 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.params = this.params.bind(this), this.arithmeticTwap = this.arithmeticTwap.bind(this), this.arithmeticTwapToNow = this.arithmeticTwapToNow.bind(this), this.geometricTwap = this.geometricTwap.bind(this), this.geometricTwapToNow = this.geometricTwapToNow.bind(this);
  }
  params(n = {}) {
    const o = ParamsRequest.encode(n).finish();
    return this.rpc.request("osmosis.twap.v1beta1.Query", "Params", o).then((c) => ParamsResponse.decode(new minimal.Reader(c)));
  }
  arithmeticTwap(n) {
    const o = ArithmeticTwapRequest.encode(n).finish();
    return this.rpc.request("osmosis.twap.v1beta1.Query", "ArithmeticTwap", o).then((c) => ArithmeticTwapResponse.decode(new minimal.Reader(c)));
  }
  arithmeticTwapToNow(n) {
    const o = ArithmeticTwapToNowRequest.encode(n).finish();
    return this.rpc.request("osmosis.twap.v1beta1.Query", "ArithmeticTwapToNow", o).then((c) => ArithmeticTwapToNowResponse.decode(new minimal.Reader(c)));
  }
  geometricTwap(n) {
    const o = GeometricTwapRequest.encode(n).finish();
    return this.rpc.request("osmosis.twap.v1beta1.Query", "GeometricTwap", o).then((c) => GeometricTwapResponse.decode(new minimal.Reader(c)));
  }
  geometricTwapToNow(n) {
    const o = GeometricTwapToNowRequest.encode(n).finish();
    return this.rpc.request("osmosis.twap.v1beta1.Query", "GeometricTwapToNow", o).then((c) => GeometricTwapToNowResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$2 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$2(n);
  return {
    params(u) {
      return o.params(u);
    },
    arithmeticTwap(u) {
      return o.arithmeticTwap(u);
    },
    arithmeticTwapToNow(u) {
      return o.arithmeticTwapToNow(u);
    },
    geometricTwap(u) {
      return o.geometricTwap(u);
    },
    geometricTwapToNow(u) {
      return o.geometricTwapToNow(u);
    }
  };
}, _321 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$2,
  createRpcQueryExtension: createRpcQueryExtension$2
}, Symbol.toStringTag, { value: "Module" }));
let QueryClientImpl$1 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.feeTokens = this.feeTokens.bind(this), this.denomSpotPrice = this.denomSpotPrice.bind(this), this.denomPoolId = this.denomPoolId.bind(this), this.baseDenom = this.baseDenom.bind(this);
  }
  feeTokens(n = {}) {
    const o = QueryFeeTokensRequest.encode(n).finish();
    return this.rpc.request("osmosis.txfees.v1beta1.Query", "FeeTokens", o).then((c) => QueryFeeTokensResponse.decode(new minimal.Reader(c)));
  }
  denomSpotPrice(n) {
    const o = QueryDenomSpotPriceRequest.encode(n).finish();
    return this.rpc.request("osmosis.txfees.v1beta1.Query", "DenomSpotPrice", o).then((c) => QueryDenomSpotPriceResponse.decode(new minimal.Reader(c)));
  }
  denomPoolId(n) {
    const o = QueryDenomPoolIdRequest.encode(n).finish();
    return this.rpc.request("osmosis.txfees.v1beta1.Query", "DenomPoolId", o).then((c) => QueryDenomPoolIdResponse.decode(new minimal.Reader(c)));
  }
  baseDenom(n = {}) {
    const o = QueryBaseDenomRequest.encode(n).finish();
    return this.rpc.request("osmosis.txfees.v1beta1.Query", "BaseDenom", o).then((c) => QueryBaseDenomResponse.decode(new minimal.Reader(c)));
  }
};
const createRpcQueryExtension$1 = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl$1(n);
  return {
    feeTokens(u) {
      return o.feeTokens(u);
    },
    denomSpotPrice(u) {
      return o.denomSpotPrice(u);
    },
    denomPoolId(u) {
      return o.denomPoolId(u);
    },
    baseDenom(u) {
      return o.baseDenom(u);
    }
  };
}, _322 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl: QueryClientImpl$1,
  createRpcQueryExtension: createRpcQueryExtension$1
}, Symbol.toStringTag, { value: "Module" }));
class QueryClientImpl {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.userValidatorPreferences = this.userValidatorPreferences.bind(this);
  }
  userValidatorPreferences(n) {
    const o = UserValidatorPreferencesRequest.encode(n).finish();
    return this.rpc.request("osmosis.valsetpref.v1beta1.Query", "UserValidatorPreferences", o).then((c) => UserValidatorPreferencesResponse.decode(new minimal.Reader(c)));
  }
}
const createRpcQueryExtension = (e) => {
  const n = build$5.createProtobufRpcClient(e), o = new QueryClientImpl(n);
  return {
    userValidatorPreferences(u) {
      return o.userValidatorPreferences(u);
    }
  };
}, _323 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QueryClientImpl,
  createRpcQueryExtension
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$9 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.createBalancerPool = this.createBalancerPool.bind(this), this.migrateSharesToFullRangeConcentratedPosition = this.migrateSharesToFullRangeConcentratedPosition.bind(this);
  }
  createBalancerPool(n) {
    const o = MsgCreateBalancerPool.encode(n).finish();
    return this.rpc.request("osmosis.gamm.poolmodels.balancer.v1beta1.Msg", "CreateBalancerPool", o).then((c) => MsgCreateBalancerPoolResponse.decode(new minimal.Reader(c)));
  }
  migrateSharesToFullRangeConcentratedPosition(n) {
    const o = MsgMigrateSharesToFullRangeConcentratedPosition.encode(n).finish();
    return this.rpc.request("osmosis.gamm.poolmodels.balancer.v1beta1.Msg", "MigrateSharesToFullRangeConcentratedPosition", o).then((c) => MsgMigrateSharesToFullRangeConcentratedPositionResponse.decode(new minimal.Reader(c)));
  }
};
const _325 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$9
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$8 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.createStableswapPool = this.createStableswapPool.bind(this), this.stableSwapAdjustScalingFactors = this.stableSwapAdjustScalingFactors.bind(this);
  }
  createStableswapPool(n) {
    const o = MsgCreateStableswapPool.encode(n).finish();
    return this.rpc.request("osmosis.gamm.poolmodels.stableswap.v1beta1.Msg", "CreateStableswapPool", o).then((c) => MsgCreateStableswapPoolResponse.decode(new minimal.Reader(c)));
  }
  stableSwapAdjustScalingFactors(n) {
    const o = MsgStableSwapAdjustScalingFactors.encode(n).finish();
    return this.rpc.request("osmosis.gamm.poolmodels.stableswap.v1beta1.Msg", "StableSwapAdjustScalingFactors", o).then((c) => MsgStableSwapAdjustScalingFactorsResponse.decode(new minimal.Reader(c)));
  }
};
const _326 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$8
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$7 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.joinPool = this.joinPool.bind(this), this.exitPool = this.exitPool.bind(this), this.swapExactAmountIn = this.swapExactAmountIn.bind(this), this.swapExactAmountOut = this.swapExactAmountOut.bind(this), this.joinSwapExternAmountIn = this.joinSwapExternAmountIn.bind(this), this.joinSwapShareAmountOut = this.joinSwapShareAmountOut.bind(this), this.exitSwapExternAmountOut = this.exitSwapExternAmountOut.bind(this), this.exitSwapShareAmountIn = this.exitSwapShareAmountIn.bind(this);
  }
  joinPool(n) {
    const o = MsgJoinPool.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Msg", "JoinPool", o).then((c) => MsgJoinPoolResponse.decode(new minimal.Reader(c)));
  }
  exitPool(n) {
    const o = MsgExitPool.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Msg", "ExitPool", o).then((c) => MsgExitPoolResponse.decode(new minimal.Reader(c)));
  }
  swapExactAmountIn(n) {
    const o = MsgSwapExactAmountIn$1.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Msg", "SwapExactAmountIn", o).then((c) => MsgSwapExactAmountInResponse$1.decode(new minimal.Reader(c)));
  }
  swapExactAmountOut(n) {
    const o = MsgSwapExactAmountOut$1.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Msg", "SwapExactAmountOut", o).then((c) => MsgSwapExactAmountOutResponse$1.decode(new minimal.Reader(c)));
  }
  joinSwapExternAmountIn(n) {
    const o = MsgJoinSwapExternAmountIn.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Msg", "JoinSwapExternAmountIn", o).then((c) => MsgJoinSwapExternAmountInResponse.decode(new minimal.Reader(c)));
  }
  joinSwapShareAmountOut(n) {
    const o = MsgJoinSwapShareAmountOut.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Msg", "JoinSwapShareAmountOut", o).then((c) => MsgJoinSwapShareAmountOutResponse.decode(new minimal.Reader(c)));
  }
  exitSwapExternAmountOut(n) {
    const o = MsgExitSwapExternAmountOut.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Msg", "ExitSwapExternAmountOut", o).then((c) => MsgExitSwapExternAmountOutResponse.decode(new minimal.Reader(c)));
  }
  exitSwapShareAmountIn(n) {
    const o = MsgExitSwapShareAmountIn.encode(n).finish();
    return this.rpc.request("osmosis.gamm.v1beta1.Msg", "ExitSwapShareAmountIn", o).then((c) => MsgExitSwapShareAmountInResponse.decode(new minimal.Reader(c)));
  }
};
const _327 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$7
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$6 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.createGauge = this.createGauge.bind(this), this.addToGauge = this.addToGauge.bind(this);
  }
  createGauge(n) {
    const o = MsgCreateGauge.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Msg", "CreateGauge", o).then((c) => MsgCreateGaugeResponse.decode(new minimal.Reader(c)));
  }
  addToGauge(n) {
    const o = MsgAddToGauge.encode(n).finish();
    return this.rpc.request("osmosis.incentives.Msg", "AddToGauge", o).then((c) => MsgAddToGaugeResponse.decode(new minimal.Reader(c)));
  }
};
const _328 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$6
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$5 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.lockTokens = this.lockTokens.bind(this), this.beginUnlockingAll = this.beginUnlockingAll.bind(this), this.beginUnlocking = this.beginUnlocking.bind(this), this.extendLockup = this.extendLockup.bind(this), this.forceUnlock = this.forceUnlock.bind(this);
  }
  lockTokens(n) {
    const o = MsgLockTokens.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Msg", "LockTokens", o).then((c) => MsgLockTokensResponse.decode(new minimal.Reader(c)));
  }
  beginUnlockingAll(n) {
    const o = MsgBeginUnlockingAll.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Msg", "BeginUnlockingAll", o).then((c) => MsgBeginUnlockingAllResponse.decode(new minimal.Reader(c)));
  }
  beginUnlocking(n) {
    const o = MsgBeginUnlocking.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Msg", "BeginUnlocking", o).then((c) => MsgBeginUnlockingResponse.decode(new minimal.Reader(c)));
  }
  extendLockup(n) {
    const o = MsgExtendLockup.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Msg", "ExtendLockup", o).then((c) => MsgExtendLockupResponse.decode(new minimal.Reader(c)));
  }
  forceUnlock(n) {
    const o = MsgForceUnlock.encode(n).finish();
    return this.rpc.request("osmosis.lockup.Msg", "ForceUnlock", o).then((c) => MsgForceUnlockResponse.decode(new minimal.Reader(c)));
  }
};
const _329 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$5
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$4 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.swapExactAmountIn = this.swapExactAmountIn.bind(this), this.swapExactAmountOut = this.swapExactAmountOut.bind(this);
  }
  swapExactAmountIn(n) {
    const o = MsgSwapExactAmountIn.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Msg", "SwapExactAmountIn", o).then((c) => MsgSwapExactAmountInResponse.decode(new minimal.Reader(c)));
  }
  swapExactAmountOut(n) {
    const o = MsgSwapExactAmountOut.encode(n).finish();
    return this.rpc.request("osmosis.poolmanager.v1beta1.Msg", "SwapExactAmountOut", o).then((c) => MsgSwapExactAmountOutResponse.decode(new minimal.Reader(c)));
  }
};
const _330 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$4
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$3 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.setHotRoutes = this.setHotRoutes.bind(this), this.setDeveloperAccount = this.setDeveloperAccount.bind(this), this.setMaxPoolPointsPerTx = this.setMaxPoolPointsPerTx.bind(this), this.setMaxPoolPointsPerBlock = this.setMaxPoolPointsPerBlock.bind(this), this.setPoolWeights = this.setPoolWeights.bind(this), this.setBaseDenoms = this.setBaseDenoms.bind(this);
  }
  setHotRoutes(n) {
    const o = MsgSetHotRoutes.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetHotRoutes", o).then((c) => MsgSetHotRoutesResponse.decode(new minimal.Reader(c)));
  }
  setDeveloperAccount(n) {
    const o = MsgSetDeveloperAccount.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetDeveloperAccount", o).then((c) => MsgSetDeveloperAccountResponse.decode(new minimal.Reader(c)));
  }
  setMaxPoolPointsPerTx(n) {
    const o = MsgSetMaxPoolPointsPerTx.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetMaxPoolPointsPerTx", o).then((c) => MsgSetMaxPoolPointsPerTxResponse.decode(new minimal.Reader(c)));
  }
  setMaxPoolPointsPerBlock(n) {
    const o = MsgSetMaxPoolPointsPerBlock.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetMaxPoolPointsPerBlock", o).then((c) => MsgSetMaxPoolPointsPerBlockResponse.decode(new minimal.Reader(c)));
  }
  setPoolWeights(n) {
    const o = MsgSetPoolWeights.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetPoolWeights", o).then((c) => MsgSetPoolWeightsResponse.decode(new minimal.Reader(c)));
  }
  setBaseDenoms(n) {
    const o = MsgSetBaseDenoms.encode(n).finish();
    return this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetBaseDenoms", o).then((c) => MsgSetBaseDenomsResponse.decode(new minimal.Reader(c)));
  }
};
const _331 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$3
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$2 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.superfluidDelegate = this.superfluidDelegate.bind(this), this.superfluidUndelegate = this.superfluidUndelegate.bind(this), this.superfluidUnbondLock = this.superfluidUnbondLock.bind(this), this.superfluidUndelegateAndUnbondLock = this.superfluidUndelegateAndUnbondLock.bind(this), this.lockAndSuperfluidDelegate = this.lockAndSuperfluidDelegate.bind(this), this.unPoolWhitelistedPool = this.unPoolWhitelistedPool.bind(this), this.unlockAndMigrateSharesToFullRangeConcentratedPosition = this.unlockAndMigrateSharesToFullRangeConcentratedPosition.bind(this);
  }
  superfluidDelegate(n) {
    const o = MsgSuperfluidDelegate.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Msg", "SuperfluidDelegate", o).then((c) => MsgSuperfluidDelegateResponse.decode(new minimal.Reader(c)));
  }
  superfluidUndelegate(n) {
    const o = MsgSuperfluidUndelegate.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Msg", "SuperfluidUndelegate", o).then((c) => MsgSuperfluidUndelegateResponse.decode(new minimal.Reader(c)));
  }
  superfluidUnbondLock(n) {
    const o = MsgSuperfluidUnbondLock.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Msg", "SuperfluidUnbondLock", o).then((c) => MsgSuperfluidUnbondLockResponse.decode(new minimal.Reader(c)));
  }
  superfluidUndelegateAndUnbondLock(n) {
    const o = MsgSuperfluidUndelegateAndUnbondLock.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Msg", "SuperfluidUndelegateAndUnbondLock", o).then((c) => MsgSuperfluidUndelegateAndUnbondLockResponse.decode(new minimal.Reader(c)));
  }
  lockAndSuperfluidDelegate(n) {
    const o = MsgLockAndSuperfluidDelegate.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Msg", "LockAndSuperfluidDelegate", o).then((c) => MsgLockAndSuperfluidDelegateResponse.decode(new minimal.Reader(c)));
  }
  unPoolWhitelistedPool(n) {
    const o = MsgUnPoolWhitelistedPool.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Msg", "UnPoolWhitelistedPool", o).then((c) => MsgUnPoolWhitelistedPoolResponse.decode(new minimal.Reader(c)));
  }
  unlockAndMigrateSharesToFullRangeConcentratedPosition(n) {
    const o = MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.encode(n).finish();
    return this.rpc.request("osmosis.superfluid.Msg", "UnlockAndMigrateSharesToFullRangeConcentratedPosition", o).then((c) => MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.decode(new minimal.Reader(c)));
  }
};
const _332 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$2
}, Symbol.toStringTag, { value: "Module" }));
let MsgClientImpl$1 = class {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.createDenom = this.createDenom.bind(this), this.mint = this.mint.bind(this), this.burn = this.burn.bind(this), this.changeAdmin = this.changeAdmin.bind(this), this.setDenomMetadata = this.setDenomMetadata.bind(this), this.setBeforeSendHook = this.setBeforeSendHook.bind(this), this.forceTransfer = this.forceTransfer.bind(this);
  }
  createDenom(n) {
    const o = MsgCreateDenom.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "CreateDenom", o).then((c) => MsgCreateDenomResponse.decode(new minimal.Reader(c)));
  }
  mint(n) {
    const o = MsgMint.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "Mint", o).then((c) => MsgMintResponse.decode(new minimal.Reader(c)));
  }
  burn(n) {
    const o = MsgBurn.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "Burn", o).then((c) => MsgBurnResponse.decode(new minimal.Reader(c)));
  }
  changeAdmin(n) {
    const o = MsgChangeAdmin.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "ChangeAdmin", o).then((c) => MsgChangeAdminResponse.decode(new minimal.Reader(c)));
  }
  setDenomMetadata(n) {
    const o = MsgSetDenomMetadata.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "SetDenomMetadata", o).then((c) => MsgSetDenomMetadataResponse.decode(new minimal.Reader(c)));
  }
  setBeforeSendHook(n) {
    const o = MsgSetBeforeSendHook.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "SetBeforeSendHook", o).then((c) => MsgSetBeforeSendHookResponse.decode(new minimal.Reader(c)));
  }
  forceTransfer(n) {
    const o = MsgForceTransfer.encode(n).finish();
    return this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "ForceTransfer", o).then((c) => MsgForceTransferResponse.decode(new minimal.Reader(c)));
  }
};
const _333 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: MsgClientImpl$1
}, Symbol.toStringTag, { value: "Module" }));
class MsgClientImpl {
  constructor(n) {
    _defineProperty(this, "rpc", void 0), this.rpc = n, this.setValidatorSetPreference = this.setValidatorSetPreference.bind(this), this.delegateToValidatorSet = this.delegateToValidatorSet.bind(this), this.undelegateFromValidatorSet = this.undelegateFromValidatorSet.bind(this), this.redelegateValidatorSet = this.redelegateValidatorSet.bind(this), this.withdrawDelegationRewards = this.withdrawDelegationRewards.bind(this), this.delegateBondedTokens = this.delegateBondedTokens.bind(this);
  }
  setValidatorSetPreference(n) {
    const o = MsgSetValidatorSetPreference.encode(n).finish();
    return this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "SetValidatorSetPreference", o).then((c) => MsgSetValidatorSetPreferenceResponse.decode(new minimal.Reader(c)));
  }
  delegateToValidatorSet(n) {
    const o = MsgDelegateToValidatorSet.encode(n).finish();
    return this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "DelegateToValidatorSet", o).then((c) => MsgDelegateToValidatorSetResponse.decode(new minimal.Reader(c)));
  }
  undelegateFromValidatorSet(n) {
    const o = MsgUndelegateFromValidatorSet.encode(n).finish();
    return this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "UndelegateFromValidatorSet", o).then((c) => MsgUndelegateFromValidatorSetResponse.decode(new minimal.Reader(c)));
  }
  redelegateValidatorSet(n) {
    const o = MsgRedelegateValidatorSet.encode(n).finish();
    return this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "RedelegateValidatorSet", o).then((c) => MsgRedelegateValidatorSetResponse.decode(new minimal.Reader(c)));
  }
  withdrawDelegationRewards(n) {
    const o = MsgWithdrawDelegationRewards.encode(n).finish();
    return this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "WithdrawDelegationRewards", o).then((c) => MsgWithdrawDelegationRewardsResponse.decode(new minimal.Reader(c)));
  }
  delegateBondedTokens(n) {
    const o = MsgDelegateBondedTokens.encode(n).finish();
    return this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "DelegateBondedTokens", o).then((c) => MsgDelegateBondedTokensResponse.decode(new minimal.Reader(c)));
  }
}
const _334 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl
}, Symbol.toStringTag, { value: "Module" })), createLCDClient = async ({
  restEndpoint: e
}) => {
  const n = new LCDClient({
    restEndpoint: e
  });
  return {
    cosmos: {
      auth: {
        v1beta1: new (await Promise.resolve().then(() => _202)).LCDQueryClient({
          requestClient: n
        })
      },
      authz: {
        v1beta1: new (await Promise.resolve().then(() => _203)).LCDQueryClient({
          requestClient: n
        })
      },
      bank: {
        v1beta1: new (await Promise.resolve().then(() => _204)).LCDQueryClient({
          requestClient: n
        })
      },
      base: {
        node: {
          v1beta1: new (await Promise.resolve().then(() => _205)).LCDQueryClient({
            requestClient: n
          })
        }
      },
      distribution: {
        v1beta1: new (await Promise.resolve().then(() => _206)).LCDQueryClient({
          requestClient: n
        })
      },
      gov: {
        v1beta1: new (await Promise.resolve().then(() => _207)).LCDQueryClient({
          requestClient: n
        }),
        v1: new (await Promise.resolve().then(() => _211)).LCDQueryClient({
          requestClient: n
        })
      },
      staking: {
        v1beta1: new (await Promise.resolve().then(() => _208)).LCDQueryClient({
          requestClient: n
        })
      },
      tx: {
        v1beta1: new (await Promise.resolve().then(() => _209)).LCDQueryClient({
          requestClient: n
        })
      },
      upgrade: {
        v1beta1: new (await Promise.resolve().then(() => _210)).LCDQueryClient({
          requestClient: n
        })
      }
    },
    osmosis: {
      concentratedliquidity: {
        v1beta1: new (await import("./query.lcd-40127582.js")).LCDQueryClient({
          requestClient: n
        })
      },
      cosmwasmpool: {
        v1beta1: new (await Promise.resolve().then(() => _289)).LCDQueryClient({
          requestClient: n
        })
      },
      downtimedetector: {
        v1beta1: new (await Promise.resolve().then(() => _290)).LCDQueryClient({
          requestClient: n
        })
      },
      epochs: {
        v1beta1: new (await Promise.resolve().then(() => _291)).LCDQueryClient({
          requestClient: n
        })
      },
      gamm: {
        v1beta1: new (await Promise.resolve().then(() => _292)).LCDQueryClient({
          requestClient: n
        }),
        v2: new (await Promise.resolve().then(() => _293)).LCDQueryClient({
          requestClient: n
        })
      },
      ibcratelimit: {
        v1beta1: new (await Promise.resolve().then(() => _294)).LCDQueryClient({
          requestClient: n
        })
      },
      incentives: new (await Promise.resolve().then(() => _295)).LCDQueryClient({
        requestClient: n
      }),
      lockup: new (await Promise.resolve().then(() => _296)).LCDQueryClient({
        requestClient: n
      }),
      mint: {
        v1beta1: new (await Promise.resolve().then(() => _297)).LCDQueryClient({
          requestClient: n
        })
      },
      poolincentives: {
        v1beta1: new (await Promise.resolve().then(() => _298)).LCDQueryClient({
          requestClient: n
        })
      },
      poolmanager: {
        v1beta1: new (await Promise.resolve().then(() => _299)).LCDQueryClient({
          requestClient: n
        })
      },
      protorev: {
        v1beta1: new (await Promise.resolve().then(() => _300)).LCDQueryClient({
          requestClient: n
        })
      },
      superfluid: new (await Promise.resolve().then(() => _301)).LCDQueryClient({
        requestClient: n
      }),
      tokenfactory: {
        v1beta1: new (await Promise.resolve().then(() => _302)).LCDQueryClient({
          requestClient: n
        })
      },
      twap: {
        v1beta1: new (await Promise.resolve().then(() => _303)).LCDQueryClient({
          requestClient: n
        })
      },
      txfees: {
        v1beta1: new (await Promise.resolve().then(() => _304)).LCDQueryClient({
          requestClient: n
        })
      },
      valsetpref: {
        v1beta1: new (await Promise.resolve().then(() => _305)).LCDQueryClient({
          requestClient: n
        })
      }
    }
  };
}, _344 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createLCDClient
}, Symbol.toStringTag, { value: "Module" })), createRPCQueryClient = async ({
  rpcEndpoint: e
}) => {
  const n = await build$2.Tendermint34Client.connect(e), o = new build$5.QueryClient(n);
  return {
    cosmos: {
      auth: {
        v1beta1: (await Promise.resolve().then(() => _212)).createRpcQueryExtension(o)
      },
      authz: {
        v1beta1: (await Promise.resolve().then(() => _213)).createRpcQueryExtension(o)
      },
      bank: {
        v1beta1: (await Promise.resolve().then(() => _214)).createRpcQueryExtension(o)
      },
      base: {
        node: {
          v1beta1: (await Promise.resolve().then(() => _215)).createRpcQueryExtension(o)
        }
      },
      distribution: {
        v1beta1: (await Promise.resolve().then(() => _216)).createRpcQueryExtension(o)
      },
      gov: {
        v1beta1: (await Promise.resolve().then(() => _217)).createRpcQueryExtension(o),
        v1: (await Promise.resolve().then(() => _221)).createRpcQueryExtension(o)
      },
      staking: {
        v1beta1: (await Promise.resolve().then(() => _218)).createRpcQueryExtension(o)
      },
      tx: {
        v1beta1: (await Promise.resolve().then(() => _219)).createRpcQueryExtension(o)
      },
      upgrade: {
        v1beta1: (await Promise.resolve().then(() => _220)).createRpcQueryExtension(o)
      }
    },
    osmosis: {
      concentratedliquidity: {
        v1beta1: (await import("./query.rpc.Query-4ee3e00b.js")).createRpcQueryExtension(o)
      },
      cosmwasmpool: {
        v1beta1: (await Promise.resolve().then(() => _307)).createRpcQueryExtension(o)
      },
      downtimedetector: {
        v1beta1: (await Promise.resolve().then(() => _308)).createRpcQueryExtension(o)
      },
      epochs: {
        v1beta1: (await Promise.resolve().then(() => _309)).createRpcQueryExtension(o)
      },
      gamm: {
        v1beta1: (await Promise.resolve().then(() => _310)).createRpcQueryExtension(o),
        v2: (await Promise.resolve().then(() => _311)).createRpcQueryExtension(o)
      },
      ibcratelimit: {
        v1beta1: (await Promise.resolve().then(() => _312)).createRpcQueryExtension(o)
      },
      incentives: (await Promise.resolve().then(() => _313)).createRpcQueryExtension(o),
      lockup: (await Promise.resolve().then(() => _314)).createRpcQueryExtension(o),
      mint: {
        v1beta1: (await Promise.resolve().then(() => _315)).createRpcQueryExtension(o)
      },
      poolincentives: {
        v1beta1: (await Promise.resolve().then(() => _316)).createRpcQueryExtension(o)
      },
      poolmanager: {
        v1beta1: (await Promise.resolve().then(() => _317)).createRpcQueryExtension(o)
      },
      protorev: {
        v1beta1: (await Promise.resolve().then(() => _318)).createRpcQueryExtension(o)
      },
      superfluid: (await Promise.resolve().then(() => _319)).createRpcQueryExtension(o),
      tokenfactory: {
        v1beta1: (await Promise.resolve().then(() => _320)).createRpcQueryExtension(o)
      },
      twap: {
        v1beta1: (await Promise.resolve().then(() => _321)).createRpcQueryExtension(o)
      },
      txfees: {
        v1beta1: (await Promise.resolve().then(() => _322)).createRpcQueryExtension(o)
      },
      valsetpref: {
        v1beta1: (await Promise.resolve().then(() => _323)).createRpcQueryExtension(o)
      }
    }
  };
}, _345 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRPCQueryClient
}, Symbol.toStringTag, { value: "Module" })), createRPCMsgClient = async ({
  rpc: e
}) => ({
  cosmos: {
    authz: {
      v1beta1: new (await Promise.resolve().then(() => _222)).MsgClientImpl(e)
    },
    bank: {
      v1beta1: new (await Promise.resolve().then(() => _223)).MsgClientImpl(e)
    },
    distribution: {
      v1beta1: new (await Promise.resolve().then(() => _224)).MsgClientImpl(e)
    },
    gov: {
      v1beta1: new (await Promise.resolve().then(() => _225)).MsgClientImpl(e),
      v1: new (await Promise.resolve().then(() => _227)).MsgClientImpl(e)
    },
    staking: {
      v1beta1: new (await Promise.resolve().then(() => _226)).MsgClientImpl(e)
    },
    upgrade: {
      v1beta1: new (await Promise.resolve().then(() => _228)).MsgClientImpl(e)
    }
  },
  osmosis: {
    concentratedliquidity: {
      v1beta1: new (await import("./tx.rpc.msg-ec79efbf.js")).MsgClientImpl(e)
    },
    gamm: {
      poolmodels: {
        balancer: {
          v1beta1: new (await Promise.resolve().then(() => _325)).MsgClientImpl(e)
        },
        stableswap: {
          v1beta1: new (await Promise.resolve().then(() => _326)).MsgClientImpl(e)
        }
      },
      v1beta1: new (await Promise.resolve().then(() => _327)).MsgClientImpl(e)
    },
    incentives: new (await Promise.resolve().then(() => _328)).MsgClientImpl(e),
    lockup: new (await Promise.resolve().then(() => _329)).MsgClientImpl(e),
    poolmanager: {
      v1beta1: new (await Promise.resolve().then(() => _330)).MsgClientImpl(e)
    },
    protorev: {
      v1beta1: new (await Promise.resolve().then(() => _331)).MsgClientImpl(e)
    },
    superfluid: new (await Promise.resolve().then(() => _332)).MsgClientImpl(e),
    tokenfactory: {
      v1beta1: new (await Promise.resolve().then(() => _333)).MsgClientImpl(e)
    },
    valsetpref: {
      v1beta1: new (await Promise.resolve().then(() => _334)).MsgClientImpl(e)
    }
  }
}), _346 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRPCMsgClient
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$5(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$5(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$5(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$5(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
let osmosis;
(function(e) {
  let n;
  (function(G) {
    G.v1beta1 = _objectSpread$5({}, _107);
  })(n || (n = e.accum || (e.accum = {}))), e.concentratedliquidity = _objectSpread$5({}, _108);
  let o;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _109), _110), _111), _112), _113), _289), _307);
  })(o || (o = e.cosmwasmpool || (e.cosmwasmpool = {})));
  let u;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _114), _115), _116), _290), _308);
  })(u || (u = e.downtimedetector || (e.downtimedetector = {})));
  let c;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _117), _118), _291), _309);
  })(c || (c = e.epochs || (e.epochs = {})));
  let d;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _119), _120), _121), _122), _123), _269), _280), _292), _310), _327);
    let k;
    (function(F) {
      let X;
      (function(ue) {
        ue.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _124), _267), _278), _325);
      })(X || (X = F.balancer || (F.balancer = {})));
      let ee;
      (function(ue) {
        ue.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _125), _126), _268), _279), _326);
      })(ee || (ee = F.stableswap || (F.stableswap = {})));
    })(k || (k = G.poolmodels || (G.poolmodels = {}))), G.v2 = _objectSpread$5(_objectSpread$5(_objectSpread$5({}, _127), _293), _311);
  })(d || (d = e.gamm || (e.gamm = {})));
  let m;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _128), _129), _130), _294), _312);
  })(m || (m = e.ibcratelimit || (e.ibcratelimit = {}))), e.incentives = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _131), _132), _133), _134), _135), _270), _281), _295), _313), _328), e.lockup = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _136), _137), _138), _139), _140), _271), _282), _296), _314), _329);
  let v;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _141), _142), _143), _297), _315);
  })(v || (v = e.mint || (e.mint = {})));
  let S;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _144), _145), _146), _147), _298), _316);
  })(S || (S = e.poolincentives || (e.poolincentives = {})));
  let $;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _148), _149), _150), _151), _152), _272), _283), _299), _317), _330);
  })($ || ($ = e.poolmanager || (e.poolmanager = {})));
  let E;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _153), _154), _155), _156), _157), _158), _273), _284), _300), _318), _331);
  })(E || (E = e.protorev || (e.protorev = {})));
  let O;
  (function(G) {
    G.v1beta1 = _objectSpread$5({}, _159);
  })(O || (O = e.store || (e.store = {}))), e.superfluid = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _160), _161), _162), _163), _164), _274), _285), _301), _319), _332);
  let T;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _165), _166), _167), _168), _169), _275), _286), _302), _320), _333);
  })(T || (T = e.tokenfactory || (e.tokenfactory = {})));
  let y;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _170), _171), _172), _303), _321);
  })(y || (y = e.twap || (e.twap = {})));
  let V;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _173), _174), _175), _176), _304), _322);
  })(V || (V = e.txfees || (e.txfees = {})));
  let M;
  (function(G) {
    G.v1beta1 = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, _177), _178), _179), _276), _287), _305), _323), _334);
  })(M || (M = e.valsetpref || (e.valsetpref = {}))), e.ClientFactory = _objectSpread$5(_objectSpread$5(_objectSpread$5({}, _344), _345), _346);
})(osmosis || (osmosis = {}));
function createBaseMsgCreatePosition() {
  return {
    poolId: Long$2.UZERO,
    sender: "",
    lowerTick: Long$2.ZERO,
    upperTick: Long$2.ZERO,
    tokenDesired0: void 0,
    tokenDesired1: void 0,
    tokenMinAmount0: "",
    tokenMinAmount1: ""
  };
}
const MsgCreatePosition = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition",
  encode(e, n = minimal.Writer.create()) {
    return e.poolId.isZero() || n.uint32(8).uint64(e.poolId), e.sender !== "" && n.uint32(18).string(e.sender), e.lowerTick.isZero() || n.uint32(24).int64(e.lowerTick), e.upperTick.isZero() || n.uint32(32).int64(e.upperTick), e.tokenDesired0 !== void 0 && Coin.encode(e.tokenDesired0, n.uint32(42).fork()).ldelim(), e.tokenDesired1 !== void 0 && Coin.encode(e.tokenDesired1, n.uint32(50).fork()).ldelim(), e.tokenMinAmount0 !== "" && n.uint32(58).string(e.tokenMinAmount0), e.tokenMinAmount1 !== "" && n.uint32(66).string(e.tokenMinAmount1), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreatePosition();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.poolId = o.uint64();
          break;
        case 2:
          c.sender = o.string();
          break;
        case 3:
          c.lowerTick = o.int64();
          break;
        case 4:
          c.upperTick = o.int64();
          break;
        case 5:
          c.tokenDesired0 = Coin.decode(o, o.uint32());
          break;
        case 6:
          c.tokenDesired1 = Coin.decode(o, o.uint32());
          break;
        case 7:
          c.tokenMinAmount0 = o.string();
          break;
        case 8:
          c.tokenMinAmount1 = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMsgCreatePosition();
    return c.poolId = e.poolId !== void 0 && e.poolId !== null ? Long$2.fromValue(e.poolId) : Long$2.UZERO, c.sender = (n = e.sender) !== null && n !== void 0 ? n : "", c.lowerTick = e.lowerTick !== void 0 && e.lowerTick !== null ? Long$2.fromValue(e.lowerTick) : Long$2.ZERO, c.upperTick = e.upperTick !== void 0 && e.upperTick !== null ? Long$2.fromValue(e.upperTick) : Long$2.ZERO, c.tokenDesired0 = e.tokenDesired0 !== void 0 && e.tokenDesired0 !== null ? Coin.fromPartial(e.tokenDesired0) : void 0, c.tokenDesired1 = e.tokenDesired1 !== void 0 && e.tokenDesired1 !== null ? Coin.fromPartial(e.tokenDesired1) : void 0, c.tokenMinAmount0 = (o = e.tokenMinAmount0) !== null && o !== void 0 ? o : "", c.tokenMinAmount1 = (u = e.tokenMinAmount1) !== null && u !== void 0 ? u : "", c;
  },
  fromAmino(e) {
    return {
      poolId: Long$2.fromString(e.pool_id),
      sender: e.sender,
      lowerTick: Long$2.fromString(e.lower_tick),
      upperTick: Long$2.fromString(e.upper_tick),
      tokenDesired0: e != null && e.token_desired0 ? Coin.fromAmino(e.token_desired0) : void 0,
      tokenDesired1: e != null && e.token_desired1 ? Coin.fromAmino(e.token_desired1) : void 0,
      tokenMinAmount0: e.token_min_amount0,
      tokenMinAmount1: e.token_min_amount1
    };
  },
  toAmino(e) {
    const n = {};
    return n.pool_id = e.poolId ? e.poolId.toString() : void 0, n.sender = e.sender, n.lower_tick = e.lowerTick ? e.lowerTick.toString() : void 0, n.upper_tick = e.upperTick ? e.upperTick.toString() : void 0, n.token_desired0 = e.tokenDesired0 ? Coin.toAmino(e.tokenDesired0) : void 0, n.token_desired1 = e.tokenDesired1 ? Coin.toAmino(e.tokenDesired1) : void 0, n.token_min_amount0 = e.tokenMinAmount0, n.token_min_amount1 = e.tokenMinAmount1, n;
  },
  fromAminoMsg(e) {
    return MsgCreatePosition.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/create-position",
      value: MsgCreatePosition.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreatePosition.decode(e.value);
  },
  toProto(e) {
    return MsgCreatePosition.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition",
      value: MsgCreatePosition.encode(e).finish()
    };
  }
};
function createBaseMsgCreatePositionResponse() {
  return {
    positionId: Long$2.UZERO,
    amount0: "",
    amount1: "",
    joinTime: void 0,
    liquidityCreated: ""
  };
}
const MsgCreatePositionResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePositionResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.positionId.isZero() || n.uint32(8).uint64(e.positionId), e.amount0 !== "" && n.uint32(18).string(e.amount0), e.amount1 !== "" && n.uint32(26).string(e.amount1), e.joinTime !== void 0 && Timestamp.encode(toTimestamp(e.joinTime), n.uint32(34).fork()).ldelim(), e.liquidityCreated !== "" && n.uint32(42).string(e.liquidityCreated), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCreatePositionResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.positionId = o.uint64();
          break;
        case 2:
          c.amount0 = o.string();
          break;
        case 3:
          c.amount1 = o.string();
          break;
        case 4:
          c.joinTime = fromTimestamp(Timestamp.decode(o, o.uint32()));
          break;
        case 5:
          c.liquidityCreated = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseMsgCreatePositionResponse();
    return d.positionId = e.positionId !== void 0 && e.positionId !== null ? Long$2.fromValue(e.positionId) : Long$2.UZERO, d.amount0 = (n = e.amount0) !== null && n !== void 0 ? n : "", d.amount1 = (o = e.amount1) !== null && o !== void 0 ? o : "", d.joinTime = (u = e.joinTime) !== null && u !== void 0 ? u : void 0, d.liquidityCreated = (c = e.liquidityCreated) !== null && c !== void 0 ? c : "", d;
  },
  fromAmino(e) {
    return {
      positionId: Long$2.fromString(e.position_id),
      amount0: e.amount0,
      amount1: e.amount1,
      joinTime: e != null && e.join_time ? Timestamp.fromAmino(e.join_time) : void 0,
      liquidityCreated: e.liquidity_created
    };
  },
  toAmino(e) {
    const n = {};
    return n.position_id = e.positionId ? e.positionId.toString() : void 0, n.amount0 = e.amount0, n.amount1 = e.amount1, n.join_time = e.joinTime ? Timestamp.toAmino(e.joinTime) : void 0, n.liquidity_created = e.liquidityCreated, n;
  },
  fromAminoMsg(e) {
    return MsgCreatePositionResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/create-position-response",
      value: MsgCreatePositionResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCreatePositionResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCreatePositionResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePositionResponse",
      value: MsgCreatePositionResponse.encode(e).finish()
    };
  }
};
function createBaseMsgWithdrawPosition() {
  return {
    positionId: Long$2.UZERO,
    sender: "",
    liquidityAmount: ""
  };
}
const MsgWithdrawPosition = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition",
  encode(e, n = minimal.Writer.create()) {
    return e.positionId.isZero() || n.uint32(8).uint64(e.positionId), e.sender !== "" && n.uint32(18).string(e.sender), e.liquidityAmount !== "" && n.uint32(26).string(e.liquidityAmount), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgWithdrawPosition();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.positionId = o.uint64();
          break;
        case 2:
          c.sender = o.string();
          break;
        case 3:
          c.liquidityAmount = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgWithdrawPosition();
    return u.positionId = e.positionId !== void 0 && e.positionId !== null ? Long$2.fromValue(e.positionId) : Long$2.UZERO, u.sender = (n = e.sender) !== null && n !== void 0 ? n : "", u.liquidityAmount = (o = e.liquidityAmount) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      positionId: Long$2.fromString(e.position_id),
      sender: e.sender,
      liquidityAmount: e.liquidity_amount
    };
  },
  toAmino(e) {
    const n = {};
    return n.position_id = e.positionId ? e.positionId.toString() : void 0, n.sender = e.sender, n.liquidity_amount = e.liquidityAmount, n;
  },
  fromAminoMsg(e) {
    return MsgWithdrawPosition.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/withdraw-position",
      value: MsgWithdrawPosition.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgWithdrawPosition.decode(e.value);
  },
  toProto(e) {
    return MsgWithdrawPosition.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition",
      value: MsgWithdrawPosition.encode(e).finish()
    };
  }
};
function createBaseMsgWithdrawPositionResponse() {
  return {
    amount0: "",
    amount1: ""
  };
}
const MsgWithdrawPositionResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPositionResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.amount0 !== "" && n.uint32(10).string(e.amount0), e.amount1 !== "" && n.uint32(18).string(e.amount1), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgWithdrawPositionResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.amount0 = o.string();
          break;
        case 2:
          c.amount1 = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgWithdrawPositionResponse();
    return u.amount0 = (n = e.amount0) !== null && n !== void 0 ? n : "", u.amount1 = (o = e.amount1) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      amount0: e.amount0,
      amount1: e.amount1
    };
  },
  toAmino(e) {
    const n = {};
    return n.amount0 = e.amount0, n.amount1 = e.amount1, n;
  },
  fromAminoMsg(e) {
    return MsgWithdrawPositionResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/withdraw-position-response",
      value: MsgWithdrawPositionResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgWithdrawPositionResponse.decode(e.value);
  },
  toProto(e) {
    return MsgWithdrawPositionResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPositionResponse",
      value: MsgWithdrawPositionResponse.encode(e).finish()
    };
  }
};
function createBaseMsgCollectFees() {
  return {
    positionIds: [],
    sender: ""
  };
}
const MsgCollectFees = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectFees",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.positionIds)
      n.uint64(o);
    return n.ldelim(), e.sender !== "" && n.uint32(18).string(e.sender), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCollectFees();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.positionIds.push(o.uint64());
          } else
            c.positionIds.push(o.uint64());
          break;
        case 2:
          c.sender = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgCollectFees();
    return u.positionIds = ((n = e.positionIds) === null || n === void 0 ? void 0 : n.map((c) => Long$2.fromValue(c))) || [], u.sender = (o = e.sender) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      positionIds: Array.isArray(e == null ? void 0 : e.position_ids) ? e.position_ids.map((n) => n) : [],
      sender: e.sender
    };
  },
  toAmino(e) {
    const n = {};
    return e.positionIds ? n.position_ids = e.positionIds.map((o) => o) : n.position_ids = [], n.sender = e.sender, n;
  },
  fromAminoMsg(e) {
    return MsgCollectFees.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/collect-fees",
      value: MsgCollectFees.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCollectFees.decode(e.value);
  },
  toProto(e) {
    return MsgCollectFees.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectFees",
      value: MsgCollectFees.encode(e).finish()
    };
  }
};
function createBaseMsgCollectFeesResponse() {
  return {
    collectedFees: []
  };
}
const MsgCollectFeesResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectFeesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.collectedFees)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCollectFeesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.collectedFees.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgCollectFeesResponse();
    return o.collectedFees = ((n = e.collectedFees) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      collectedFees: Array.isArray(e == null ? void 0 : e.collected_fees) ? e.collected_fees.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.collectedFees ? n.collected_fees = e.collectedFees.map((o) => o ? Coin.toAmino(o) : void 0) : n.collected_fees = [], n;
  },
  fromAminoMsg(e) {
    return MsgCollectFeesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/collect-fees-response",
      value: MsgCollectFeesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCollectFeesResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCollectFeesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectFeesResponse",
      value: MsgCollectFeesResponse.encode(e).finish()
    };
  }
};
function createBaseMsgCollectIncentives() {
  return {
    positionIds: [],
    sender: ""
  };
}
const MsgCollectIncentives = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.positionIds)
      n.uint64(o);
    return n.ldelim(), e.sender !== "" && n.uint32(18).string(e.sender), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCollectIncentives();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.positionIds.push(o.uint64());
          } else
            c.positionIds.push(o.uint64());
          break;
        case 2:
          c.sender = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgCollectIncentives();
    return u.positionIds = ((n = e.positionIds) === null || n === void 0 ? void 0 : n.map((c) => Long$2.fromValue(c))) || [], u.sender = (o = e.sender) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      positionIds: Array.isArray(e == null ? void 0 : e.position_ids) ? e.position_ids.map((n) => n) : [],
      sender: e.sender
    };
  },
  toAmino(e) {
    const n = {};
    return e.positionIds ? n.position_ids = e.positionIds.map((o) => o) : n.position_ids = [], n.sender = e.sender, n;
  },
  fromAminoMsg(e) {
    return MsgCollectIncentives.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/collect-incentives",
      value: MsgCollectIncentives.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCollectIncentives.decode(e.value);
  },
  toProto(e) {
    return MsgCollectIncentives.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives",
      value: MsgCollectIncentives.encode(e).finish()
    };
  }
};
function createBaseMsgCollectIncentivesResponse() {
  return {
    collectedIncentives: []
  };
}
const MsgCollectIncentivesResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentivesResponse",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.collectedIncentives)
      Coin.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgCollectIncentivesResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.collectedIncentives.push(Coin.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseMsgCollectIncentivesResponse();
    return o.collectedIncentives = ((n = e.collectedIncentives) === null || n === void 0 ? void 0 : n.map((u) => Coin.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      collectedIncentives: Array.isArray(e == null ? void 0 : e.collected_incentives) ? e.collected_incentives.map((n) => Coin.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.collectedIncentives ? n.collected_incentives = e.collectedIncentives.map((o) => o ? Coin.toAmino(o) : void 0) : n.collected_incentives = [], n;
  },
  fromAminoMsg(e) {
    return MsgCollectIncentivesResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/collect-incentives-response",
      value: MsgCollectIncentivesResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgCollectIncentivesResponse.decode(e.value);
  },
  toProto(e) {
    return MsgCollectIncentivesResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentivesResponse",
      value: MsgCollectIncentivesResponse.encode(e).finish()
    };
  }
};
function createBaseMsgFungifyChargedPositions() {
  return {
    positionIds: [],
    sender: ""
  };
}
const MsgFungifyChargedPositions = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositions",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.positionIds)
      n.uint64(o);
    return n.ldelim(), e.sender !== "" && n.uint32(18).string(e.sender), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgFungifyChargedPositions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.positionIds.push(o.uint64());
          } else
            c.positionIds.push(o.uint64());
          break;
        case 2:
          c.sender = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseMsgFungifyChargedPositions();
    return u.positionIds = ((n = e.positionIds) === null || n === void 0 ? void 0 : n.map((c) => Long$2.fromValue(c))) || [], u.sender = (o = e.sender) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      positionIds: Array.isArray(e == null ? void 0 : e.position_ids) ? e.position_ids.map((n) => n) : [],
      sender: e.sender
    };
  },
  toAmino(e) {
    const n = {};
    return e.positionIds ? n.position_ids = e.positionIds.map((o) => o) : n.position_ids = [], n.sender = e.sender, n;
  },
  fromAminoMsg(e) {
    return MsgFungifyChargedPositions.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/fungify-charged-positions",
      value: MsgFungifyChargedPositions.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgFungifyChargedPositions.decode(e.value);
  },
  toProto(e) {
    return MsgFungifyChargedPositions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositions",
      value: MsgFungifyChargedPositions.encode(e).finish()
    };
  }
};
function createBaseMsgFungifyChargedPositionsResponse() {
  return {
    newPositionId: Long$2.UZERO
  };
}
const MsgFungifyChargedPositionsResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositionsResponse",
  encode(e, n = minimal.Writer.create()) {
    return e.newPositionId.isZero() || n.uint32(8).uint64(e.newPositionId), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMsgFungifyChargedPositionsResponse();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.newPositionId = o.uint64();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseMsgFungifyChargedPositionsResponse();
    return n.newPositionId = e.newPositionId !== void 0 && e.newPositionId !== null ? Long$2.fromValue(e.newPositionId) : Long$2.UZERO, n;
  },
  fromAmino(e) {
    return {
      newPositionId: Long$2.fromString(e.new_position_id)
    };
  },
  toAmino(e) {
    const n = {};
    return n.new_position_id = e.newPositionId ? e.newPositionId.toString() : void 0, n;
  },
  fromAminoMsg(e) {
    return MsgFungifyChargedPositionsResponse.fromAmino(e.value);
  },
  toAminoMsg(e) {
    return {
      type: "osmosis/concentratedliquidity/fungify-charged-positions-response",
      value: MsgFungifyChargedPositionsResponse.toAmino(e)
    };
  },
  fromProtoMsg(e) {
    return MsgFungifyChargedPositionsResponse.decode(e.value);
  },
  toProto(e) {
    return MsgFungifyChargedPositionsResponse.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositionsResponse",
      value: MsgFungifyChargedPositionsResponse.encode(e).finish()
    };
  }
}, registry$1 = [["/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition", MsgCreatePosition], ["/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition", MsgWithdrawPosition], ["/osmosis.concentratedliquidity.v1beta1.MsgCollectFees", MsgCollectFees], ["/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives", MsgCollectIncentives], ["/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositions", MsgFungifyChargedPositions]], AminoConverter = {
  "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition": {
    aminoType: "osmosis/concentratedliquidity/create-position",
    toAmino: MsgCreatePosition.toAmino,
    fromAmino: MsgCreatePosition.fromAmino
  },
  "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition": {
    aminoType: "osmosis/concentratedliquidity/withdraw-position",
    toAmino: MsgWithdrawPosition.toAmino,
    fromAmino: MsgWithdrawPosition.fromAmino
  },
  "/osmosis.concentratedliquidity.v1beta1.MsgCollectFees": {
    aminoType: "osmosis/concentratedliquidity/collect-fees",
    toAmino: MsgCollectFees.toAmino,
    fromAmino: MsgCollectFees.fromAmino
  },
  "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives": {
    aminoType: "osmosis/concentratedliquidity/collect-incentives",
    toAmino: MsgCollectIncentives.toAmino,
    fromAmino: MsgCollectIncentives.fromAmino
  },
  "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositions": {
    aminoType: "osmosis/concentratedliquidity/fungify-charged-positions",
    toAmino: MsgFungifyChargedPositions.toAmino,
    fromAmino: MsgFungifyChargedPositions.fromAmino
  }
};
function ownKeys$4(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$4(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$4(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$4(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
const osmosisAminoConverters = _objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4({}, AminoConverter), AminoConverter$a), AminoConverter$9), AminoConverter$8), AminoConverter$7), AminoConverter$6), AminoConverter$5), AminoConverter$4), AminoConverter$3), AminoConverter$2), AminoConverter$1), osmosisProtoRegistry = [...registry$1, ...registry$b, ...registry$a, ...registry$9, ...registry$8, ...registry$7, ...registry$6, ...registry$5, ...registry$4, ...registry$3, ...registry$2], getSigningOsmosisClientOptions = ({
  defaultTypes: e = build$5.defaultRegistryTypes
} = {}) => {
  const n = new build$4.Registry([...e, ...osmosisProtoRegistry]), o = new build$5.AminoTypes(_objectSpread$4({}, osmosisAminoConverters));
  return {
    registry: n,
    aminoTypes: o
  };
}, getSigningOsmosisClient = async ({
  rpcEndpoint: e,
  signer: n,
  defaultTypes: o = build$5.defaultRegistryTypes
}) => {
  const {
    registry: u,
    aminoTypes: c
  } = getSigningOsmosisClientOptions({
    defaultTypes: o
  });
  return await build$5.SigningStargateClient.connectWithSigner(e, n, {
    registry: u,
    aminoTypes: c
  });
};
let HashOp;
(function(e) {
  e[e.NO_HASH = 0] = "NO_HASH", e[e.SHA256 = 1] = "SHA256", e[e.SHA512 = 2] = "SHA512", e[e.KECCAK = 3] = "KECCAK", e[e.RIPEMD160 = 4] = "RIPEMD160", e[e.BITCOIN = 5] = "BITCOIN", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(HashOp || (HashOp = {}));
const HashOpSDKType = HashOp, HashOpAmino = HashOp;
function hashOpFromJSON(e) {
  switch (e) {
    case 0:
    case "NO_HASH":
      return HashOp.NO_HASH;
    case 1:
    case "SHA256":
      return HashOp.SHA256;
    case 2:
    case "SHA512":
      return HashOp.SHA512;
    case 3:
    case "KECCAK":
      return HashOp.KECCAK;
    case 4:
    case "RIPEMD160":
      return HashOp.RIPEMD160;
    case 5:
    case "BITCOIN":
      return HashOp.BITCOIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HashOp.UNRECOGNIZED;
  }
}
function hashOpToJSON(e) {
  switch (e) {
    case HashOp.NO_HASH:
      return "NO_HASH";
    case HashOp.SHA256:
      return "SHA256";
    case HashOp.SHA512:
      return "SHA512";
    case HashOp.KECCAK:
      return "KECCAK";
    case HashOp.RIPEMD160:
      return "RIPEMD160";
    case HashOp.BITCOIN:
      return "BITCOIN";
    case HashOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let LengthOp;
(function(e) {
  e[e.NO_PREFIX = 0] = "NO_PREFIX", e[e.VAR_PROTO = 1] = "VAR_PROTO", e[e.VAR_RLP = 2] = "VAR_RLP", e[e.FIXED32_BIG = 3] = "FIXED32_BIG", e[e.FIXED32_LITTLE = 4] = "FIXED32_LITTLE", e[e.FIXED64_BIG = 5] = "FIXED64_BIG", e[e.FIXED64_LITTLE = 6] = "FIXED64_LITTLE", e[e.REQUIRE_32_BYTES = 7] = "REQUIRE_32_BYTES", e[e.REQUIRE_64_BYTES = 8] = "REQUIRE_64_BYTES", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(LengthOp || (LengthOp = {}));
const LengthOpSDKType = LengthOp, LengthOpAmino = LengthOp;
function lengthOpFromJSON(e) {
  switch (e) {
    case 0:
    case "NO_PREFIX":
      return LengthOp.NO_PREFIX;
    case 1:
    case "VAR_PROTO":
      return LengthOp.VAR_PROTO;
    case 2:
    case "VAR_RLP":
      return LengthOp.VAR_RLP;
    case 3:
    case "FIXED32_BIG":
      return LengthOp.FIXED32_BIG;
    case 4:
    case "FIXED32_LITTLE":
      return LengthOp.FIXED32_LITTLE;
    case 5:
    case "FIXED64_BIG":
      return LengthOp.FIXED64_BIG;
    case 6:
    case "FIXED64_LITTLE":
      return LengthOp.FIXED64_LITTLE;
    case 7:
    case "REQUIRE_32_BYTES":
      return LengthOp.REQUIRE_32_BYTES;
    case 8:
    case "REQUIRE_64_BYTES":
      return LengthOp.REQUIRE_64_BYTES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LengthOp.UNRECOGNIZED;
  }
}
function lengthOpToJSON(e) {
  switch (e) {
    case LengthOp.NO_PREFIX:
      return "NO_PREFIX";
    case LengthOp.VAR_PROTO:
      return "VAR_PROTO";
    case LengthOp.VAR_RLP:
      return "VAR_RLP";
    case LengthOp.FIXED32_BIG:
      return "FIXED32_BIG";
    case LengthOp.FIXED32_LITTLE:
      return "FIXED32_LITTLE";
    case LengthOp.FIXED64_BIG:
      return "FIXED64_BIG";
    case LengthOp.FIXED64_LITTLE:
      return "FIXED64_LITTLE";
    case LengthOp.REQUIRE_32_BYTES:
      return "REQUIRE_32_BYTES";
    case LengthOp.REQUIRE_64_BYTES:
      return "REQUIRE_64_BYTES";
    case LengthOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseExistenceProof() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array(),
    leaf: void 0,
    path: []
  };
}
const ExistenceProof = {
  typeUrl: "/ics23.ExistenceProof",
  encode(e, n = minimal.Writer.create()) {
    e.key.length !== 0 && n.uint32(10).bytes(e.key), e.value.length !== 0 && n.uint32(18).bytes(e.value), e.leaf !== void 0 && LeafOp.encode(e.leaf, n.uint32(26).fork()).ldelim();
    for (const o of e.path)
      InnerOp.encode(o, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseExistenceProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.value = o.bytes();
          break;
        case 3:
          c.leaf = LeafOp.decode(o, o.uint32());
          break;
        case 4:
          c.path.push(InnerOp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseExistenceProof();
    return c.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), c.value = (o = e.value) !== null && o !== void 0 ? o : new Uint8Array(), c.leaf = e.leaf !== void 0 && e.leaf !== null ? LeafOp.fromPartial(e.leaf) : void 0, c.path = ((u = e.path) === null || u === void 0 ? void 0 : u.map((d) => InnerOp.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      key: e.key,
      value: e.value,
      leaf: e != null && e.leaf ? LeafOp.fromAmino(e.leaf) : void 0,
      path: Array.isArray(e == null ? void 0 : e.path) ? e.path.map((n) => InnerOp.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.value = e.value, n.leaf = e.leaf ? LeafOp.toAmino(e.leaf) : void 0, e.path ? n.path = e.path.map((o) => o ? InnerOp.toAmino(o) : void 0) : n.path = [], n;
  },
  fromAminoMsg(e) {
    return ExistenceProof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ExistenceProof.decode(e.value);
  },
  toProto(e) {
    return ExistenceProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.ExistenceProof",
      value: ExistenceProof.encode(e).finish()
    };
  }
};
function createBaseNonExistenceProof() {
  return {
    key: new Uint8Array(),
    left: void 0,
    right: void 0
  };
}
const NonExistenceProof = {
  typeUrl: "/ics23.NonExistenceProof",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.left !== void 0 && ExistenceProof.encode(e.left, n.uint32(18).fork()).ldelim(), e.right !== void 0 && ExistenceProof.encode(e.right, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseNonExistenceProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.left = ExistenceProof.decode(o, o.uint32());
          break;
        case 3:
          c.right = ExistenceProof.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseNonExistenceProof();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o.left = e.left !== void 0 && e.left !== null ? ExistenceProof.fromPartial(e.left) : void 0, o.right = e.right !== void 0 && e.right !== null ? ExistenceProof.fromPartial(e.right) : void 0, o;
  },
  fromAmino(e) {
    return {
      key: e.key,
      left: e != null && e.left ? ExistenceProof.fromAmino(e.left) : void 0,
      right: e != null && e.right ? ExistenceProof.fromAmino(e.right) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.left = e.left ? ExistenceProof.toAmino(e.left) : void 0, n.right = e.right ? ExistenceProof.toAmino(e.right) : void 0, n;
  },
  fromAminoMsg(e) {
    return NonExistenceProof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return NonExistenceProof.decode(e.value);
  },
  toProto(e) {
    return NonExistenceProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.NonExistenceProof",
      value: NonExistenceProof.encode(e).finish()
    };
  }
};
function createBaseCommitmentProof() {
  return {
    exist: void 0,
    nonexist: void 0,
    batch: void 0,
    compressed: void 0
  };
}
const CommitmentProof = {
  typeUrl: "/ics23.CommitmentProof",
  encode(e, n = minimal.Writer.create()) {
    return e.exist !== void 0 && ExistenceProof.encode(e.exist, n.uint32(10).fork()).ldelim(), e.nonexist !== void 0 && NonExistenceProof.encode(e.nonexist, n.uint32(18).fork()).ldelim(), e.batch !== void 0 && BatchProof.encode(e.batch, n.uint32(26).fork()).ldelim(), e.compressed !== void 0 && CompressedBatchProof.encode(e.compressed, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCommitmentProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.exist = ExistenceProof.decode(o, o.uint32());
          break;
        case 2:
          c.nonexist = NonExistenceProof.decode(o, o.uint32());
          break;
        case 3:
          c.batch = BatchProof.decode(o, o.uint32());
          break;
        case 4:
          c.compressed = CompressedBatchProof.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseCommitmentProof();
    return n.exist = e.exist !== void 0 && e.exist !== null ? ExistenceProof.fromPartial(e.exist) : void 0, n.nonexist = e.nonexist !== void 0 && e.nonexist !== null ? NonExistenceProof.fromPartial(e.nonexist) : void 0, n.batch = e.batch !== void 0 && e.batch !== null ? BatchProof.fromPartial(e.batch) : void 0, n.compressed = e.compressed !== void 0 && e.compressed !== null ? CompressedBatchProof.fromPartial(e.compressed) : void 0, n;
  },
  fromAmino(e) {
    return {
      exist: e != null && e.exist ? ExistenceProof.fromAmino(e.exist) : void 0,
      nonexist: e != null && e.nonexist ? NonExistenceProof.fromAmino(e.nonexist) : void 0,
      batch: e != null && e.batch ? BatchProof.fromAmino(e.batch) : void 0,
      compressed: e != null && e.compressed ? CompressedBatchProof.fromAmino(e.compressed) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.exist = e.exist ? ExistenceProof.toAmino(e.exist) : void 0, n.nonexist = e.nonexist ? NonExistenceProof.toAmino(e.nonexist) : void 0, n.batch = e.batch ? BatchProof.toAmino(e.batch) : void 0, n.compressed = e.compressed ? CompressedBatchProof.toAmino(e.compressed) : void 0, n;
  },
  fromAminoMsg(e) {
    return CommitmentProof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return CommitmentProof.decode(e.value);
  },
  toProto(e) {
    return CommitmentProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.CommitmentProof",
      value: CommitmentProof.encode(e).finish()
    };
  }
};
function createBaseLeafOp() {
  return {
    hash: 0,
    prehashKey: 0,
    prehashValue: 0,
    length: 0,
    prefix: new Uint8Array()
  };
}
const LeafOp = {
  typeUrl: "/ics23.LeafOp",
  encode(e, n = minimal.Writer.create()) {
    return e.hash !== 0 && n.uint32(8).int32(e.hash), e.prehashKey !== 0 && n.uint32(16).int32(e.prehashKey), e.prehashValue !== 0 && n.uint32(24).int32(e.prehashValue), e.length !== 0 && n.uint32(32).int32(e.length), e.prefix.length !== 0 && n.uint32(42).bytes(e.prefix), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseLeafOp();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.int32();
          break;
        case 2:
          c.prehashKey = o.int32();
          break;
        case 3:
          c.prehashValue = o.int32();
          break;
        case 4:
          c.length = o.int32();
          break;
        case 5:
          c.prefix = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseLeafOp();
    return m.hash = (n = e.hash) !== null && n !== void 0 ? n : 0, m.prehashKey = (o = e.prehashKey) !== null && o !== void 0 ? o : 0, m.prehashValue = (u = e.prehashValue) !== null && u !== void 0 ? u : 0, m.length = (c = e.length) !== null && c !== void 0 ? c : 0, m.prefix = (d = e.prefix) !== null && d !== void 0 ? d : new Uint8Array(), m;
  },
  fromAmino(e) {
    return {
      hash: isSet(e.hash) ? hashOpFromJSON(e.hash) : 0,
      prehashKey: isSet(e.prehash_key) ? hashOpFromJSON(e.prehash_key) : 0,
      prehashValue: isSet(e.prehash_value) ? hashOpFromJSON(e.prehash_value) : 0,
      length: isSet(e.length) ? lengthOpFromJSON(e.length) : 0,
      prefix: e.prefix
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n.prehash_key = e.prehashKey, n.prehash_value = e.prehashValue, n.length = e.length, n.prefix = e.prefix, n;
  },
  fromAminoMsg(e) {
    return LeafOp.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return LeafOp.decode(e.value);
  },
  toProto(e) {
    return LeafOp.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.LeafOp",
      value: LeafOp.encode(e).finish()
    };
  }
};
function createBaseInnerOp() {
  return {
    hash: 0,
    prefix: new Uint8Array(),
    suffix: new Uint8Array()
  };
}
const InnerOp = {
  typeUrl: "/ics23.InnerOp",
  encode(e, n = minimal.Writer.create()) {
    return e.hash !== 0 && n.uint32(8).int32(e.hash), e.prefix.length !== 0 && n.uint32(18).bytes(e.prefix), e.suffix.length !== 0 && n.uint32(26).bytes(e.suffix), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInnerOp();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.hash = o.int32();
          break;
        case 2:
          c.prefix = o.bytes();
          break;
        case 3:
          c.suffix = o.bytes();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseInnerOp();
    return c.hash = (n = e.hash) !== null && n !== void 0 ? n : 0, c.prefix = (o = e.prefix) !== null && o !== void 0 ? o : new Uint8Array(), c.suffix = (u = e.suffix) !== null && u !== void 0 ? u : new Uint8Array(), c;
  },
  fromAmino(e) {
    return {
      hash: isSet(e.hash) ? hashOpFromJSON(e.hash) : 0,
      prefix: e.prefix,
      suffix: e.suffix
    };
  },
  toAmino(e) {
    const n = {};
    return n.hash = e.hash, n.prefix = e.prefix, n.suffix = e.suffix, n;
  },
  fromAminoMsg(e) {
    return InnerOp.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return InnerOp.decode(e.value);
  },
  toProto(e) {
    return InnerOp.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.InnerOp",
      value: InnerOp.encode(e).finish()
    };
  }
};
function createBaseProofSpec() {
  return {
    leafSpec: void 0,
    innerSpec: void 0,
    maxDepth: 0,
    minDepth: 0
  };
}
const ProofSpec = {
  typeUrl: "/ics23.ProofSpec",
  encode(e, n = minimal.Writer.create()) {
    return e.leafSpec !== void 0 && LeafOp.encode(e.leafSpec, n.uint32(10).fork()).ldelim(), e.innerSpec !== void 0 && InnerSpec.encode(e.innerSpec, n.uint32(18).fork()).ldelim(), e.maxDepth !== 0 && n.uint32(24).int32(e.maxDepth), e.minDepth !== 0 && n.uint32(32).int32(e.minDepth), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseProofSpec();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.leafSpec = LeafOp.decode(o, o.uint32());
          break;
        case 2:
          c.innerSpec = InnerSpec.decode(o, o.uint32());
          break;
        case 3:
          c.maxDepth = o.int32();
          break;
        case 4:
          c.minDepth = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseProofSpec();
    return u.leafSpec = e.leafSpec !== void 0 && e.leafSpec !== null ? LeafOp.fromPartial(e.leafSpec) : void 0, u.innerSpec = e.innerSpec !== void 0 && e.innerSpec !== null ? InnerSpec.fromPartial(e.innerSpec) : void 0, u.maxDepth = (n = e.maxDepth) !== null && n !== void 0 ? n : 0, u.minDepth = (o = e.minDepth) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      leafSpec: e != null && e.leaf_spec ? LeafOp.fromAmino(e.leaf_spec) : void 0,
      innerSpec: e != null && e.inner_spec ? InnerSpec.fromAmino(e.inner_spec) : void 0,
      maxDepth: e.max_depth,
      minDepth: e.min_depth
    };
  },
  toAmino(e) {
    const n = {};
    return n.leaf_spec = e.leafSpec ? LeafOp.toAmino(e.leafSpec) : void 0, n.inner_spec = e.innerSpec ? InnerSpec.toAmino(e.innerSpec) : void 0, n.max_depth = e.maxDepth, n.min_depth = e.minDepth, n;
  },
  fromAminoMsg(e) {
    return ProofSpec.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ProofSpec.decode(e.value);
  },
  toProto(e) {
    return ProofSpec.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.ProofSpec",
      value: ProofSpec.encode(e).finish()
    };
  }
};
function createBaseInnerSpec() {
  return {
    childOrder: [],
    childSize: 0,
    minPrefixLength: 0,
    maxPrefixLength: 0,
    emptyChild: new Uint8Array(),
    hash: 0
  };
}
const InnerSpec = {
  typeUrl: "/ics23.InnerSpec",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.childOrder)
      n.int32(o);
    return n.ldelim(), e.childSize !== 0 && n.uint32(16).int32(e.childSize), e.minPrefixLength !== 0 && n.uint32(24).int32(e.minPrefixLength), e.maxPrefixLength !== 0 && n.uint32(32).int32(e.maxPrefixLength), e.emptyChild.length !== 0 && n.uint32(42).bytes(e.emptyChild), e.hash !== 0 && n.uint32(48).int32(e.hash), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInnerSpec();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.childOrder.push(o.int32());
          } else
            c.childOrder.push(o.int32());
          break;
        case 2:
          c.childSize = o.int32();
          break;
        case 3:
          c.minPrefixLength = o.int32();
          break;
        case 4:
          c.maxPrefixLength = o.int32();
          break;
        case 5:
          c.emptyChild = o.bytes();
          break;
        case 6:
          c.hash = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m;
    const v = createBaseInnerSpec();
    return v.childOrder = ((n = e.childOrder) === null || n === void 0 ? void 0 : n.map((S) => S)) || [], v.childSize = (o = e.childSize) !== null && o !== void 0 ? o : 0, v.minPrefixLength = (u = e.minPrefixLength) !== null && u !== void 0 ? u : 0, v.maxPrefixLength = (c = e.maxPrefixLength) !== null && c !== void 0 ? c : 0, v.emptyChild = (d = e.emptyChild) !== null && d !== void 0 ? d : new Uint8Array(), v.hash = (m = e.hash) !== null && m !== void 0 ? m : 0, v;
  },
  fromAmino(e) {
    return {
      childOrder: Array.isArray(e == null ? void 0 : e.child_order) ? e.child_order.map((n) => n) : [],
      childSize: e.child_size,
      minPrefixLength: e.min_prefix_length,
      maxPrefixLength: e.max_prefix_length,
      emptyChild: e.empty_child,
      hash: isSet(e.hash) ? hashOpFromJSON(e.hash) : 0
    };
  },
  toAmino(e) {
    const n = {};
    return e.childOrder ? n.child_order = e.childOrder.map((o) => o) : n.child_order = [], n.child_size = e.childSize, n.min_prefix_length = e.minPrefixLength, n.max_prefix_length = e.maxPrefixLength, n.empty_child = e.emptyChild, n.hash = e.hash, n;
  },
  fromAminoMsg(e) {
    return InnerSpec.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return InnerSpec.decode(e.value);
  },
  toProto(e) {
    return InnerSpec.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.InnerSpec",
      value: InnerSpec.encode(e).finish()
    };
  }
};
function createBaseBatchProof() {
  return {
    entries: []
  };
}
const BatchProof = {
  typeUrl: "/ics23.BatchProof",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.entries)
      BatchEntry.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBatchProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.entries.push(BatchEntry.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseBatchProof();
    return o.entries = ((n = e.entries) === null || n === void 0 ? void 0 : n.map((u) => BatchEntry.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      entries: Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => BatchEntry.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.entries ? n.entries = e.entries.map((o) => o ? BatchEntry.toAmino(o) : void 0) : n.entries = [], n;
  },
  fromAminoMsg(e) {
    return BatchProof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return BatchProof.decode(e.value);
  },
  toProto(e) {
    return BatchProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.BatchProof",
      value: BatchProof.encode(e).finish()
    };
  }
};
function createBaseBatchEntry() {
  return {
    exist: void 0,
    nonexist: void 0
  };
}
const BatchEntry = {
  typeUrl: "/ics23.BatchEntry",
  encode(e, n = minimal.Writer.create()) {
    return e.exist !== void 0 && ExistenceProof.encode(e.exist, n.uint32(10).fork()).ldelim(), e.nonexist !== void 0 && NonExistenceProof.encode(e.nonexist, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseBatchEntry();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.exist = ExistenceProof.decode(o, o.uint32());
          break;
        case 2:
          c.nonexist = NonExistenceProof.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseBatchEntry();
    return n.exist = e.exist !== void 0 && e.exist !== null ? ExistenceProof.fromPartial(e.exist) : void 0, n.nonexist = e.nonexist !== void 0 && e.nonexist !== null ? NonExistenceProof.fromPartial(e.nonexist) : void 0, n;
  },
  fromAmino(e) {
    return {
      exist: e != null && e.exist ? ExistenceProof.fromAmino(e.exist) : void 0,
      nonexist: e != null && e.nonexist ? NonExistenceProof.fromAmino(e.nonexist) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.exist = e.exist ? ExistenceProof.toAmino(e.exist) : void 0, n.nonexist = e.nonexist ? NonExistenceProof.toAmino(e.nonexist) : void 0, n;
  },
  fromAminoMsg(e) {
    return BatchEntry.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return BatchEntry.decode(e.value);
  },
  toProto(e) {
    return BatchEntry.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.BatchEntry",
      value: BatchEntry.encode(e).finish()
    };
  }
};
function createBaseCompressedBatchProof() {
  return {
    entries: [],
    lookupInners: []
  };
}
const CompressedBatchProof = {
  typeUrl: "/ics23.CompressedBatchProof",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.entries)
      CompressedBatchEntry.encode(o, n.uint32(10).fork()).ldelim();
    for (const o of e.lookupInners)
      InnerOp.encode(o, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompressedBatchProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.entries.push(CompressedBatchEntry.decode(o, o.uint32()));
          break;
        case 2:
          c.lookupInners.push(InnerOp.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseCompressedBatchProof();
    return u.entries = ((n = e.entries) === null || n === void 0 ? void 0 : n.map((c) => CompressedBatchEntry.fromPartial(c))) || [], u.lookupInners = ((o = e.lookupInners) === null || o === void 0 ? void 0 : o.map((c) => InnerOp.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      entries: Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => CompressedBatchEntry.fromAmino(n)) : [],
      lookupInners: Array.isArray(e == null ? void 0 : e.lookup_inners) ? e.lookup_inners.map((n) => InnerOp.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.entries ? n.entries = e.entries.map((o) => o ? CompressedBatchEntry.toAmino(o) : void 0) : n.entries = [], e.lookupInners ? n.lookup_inners = e.lookupInners.map((o) => o ? InnerOp.toAmino(o) : void 0) : n.lookup_inners = [], n;
  },
  fromAminoMsg(e) {
    return CompressedBatchProof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return CompressedBatchProof.decode(e.value);
  },
  toProto(e) {
    return CompressedBatchProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.CompressedBatchProof",
      value: CompressedBatchProof.encode(e).finish()
    };
  }
};
function createBaseCompressedBatchEntry() {
  return {
    exist: void 0,
    nonexist: void 0
  };
}
const CompressedBatchEntry = {
  typeUrl: "/ics23.CompressedBatchEntry",
  encode(e, n = minimal.Writer.create()) {
    return e.exist !== void 0 && CompressedExistenceProof.encode(e.exist, n.uint32(10).fork()).ldelim(), e.nonexist !== void 0 && CompressedNonExistenceProof.encode(e.nonexist, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompressedBatchEntry();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.exist = CompressedExistenceProof.decode(o, o.uint32());
          break;
        case 2:
          c.nonexist = CompressedNonExistenceProof.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    const n = createBaseCompressedBatchEntry();
    return n.exist = e.exist !== void 0 && e.exist !== null ? CompressedExistenceProof.fromPartial(e.exist) : void 0, n.nonexist = e.nonexist !== void 0 && e.nonexist !== null ? CompressedNonExistenceProof.fromPartial(e.nonexist) : void 0, n;
  },
  fromAmino(e) {
    return {
      exist: e != null && e.exist ? CompressedExistenceProof.fromAmino(e.exist) : void 0,
      nonexist: e != null && e.nonexist ? CompressedNonExistenceProof.fromAmino(e.nonexist) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.exist = e.exist ? CompressedExistenceProof.toAmino(e.exist) : void 0, n.nonexist = e.nonexist ? CompressedNonExistenceProof.toAmino(e.nonexist) : void 0, n;
  },
  fromAminoMsg(e) {
    return CompressedBatchEntry.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return CompressedBatchEntry.decode(e.value);
  },
  toProto(e) {
    return CompressedBatchEntry.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.CompressedBatchEntry",
      value: CompressedBatchEntry.encode(e).finish()
    };
  }
};
function createBaseCompressedExistenceProof() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array(),
    leaf: void 0,
    path: []
  };
}
const CompressedExistenceProof = {
  typeUrl: "/ics23.CompressedExistenceProof",
  encode(e, n = minimal.Writer.create()) {
    e.key.length !== 0 && n.uint32(10).bytes(e.key), e.value.length !== 0 && n.uint32(18).bytes(e.value), e.leaf !== void 0 && LeafOp.encode(e.leaf, n.uint32(26).fork()).ldelim(), n.uint32(34).fork();
    for (const o of e.path)
      n.int32(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompressedExistenceProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.value = o.bytes();
          break;
        case 3:
          c.leaf = LeafOp.decode(o, o.uint32());
          break;
        case 4:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.path.push(o.int32());
          } else
            c.path.push(o.int32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseCompressedExistenceProof();
    return c.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), c.value = (o = e.value) !== null && o !== void 0 ? o : new Uint8Array(), c.leaf = e.leaf !== void 0 && e.leaf !== null ? LeafOp.fromPartial(e.leaf) : void 0, c.path = ((u = e.path) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c;
  },
  fromAmino(e) {
    return {
      key: e.key,
      value: e.value,
      leaf: e != null && e.leaf ? LeafOp.fromAmino(e.leaf) : void 0,
      path: Array.isArray(e == null ? void 0 : e.path) ? e.path.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.value = e.value, n.leaf = e.leaf ? LeafOp.toAmino(e.leaf) : void 0, e.path ? n.path = e.path.map((o) => o) : n.path = [], n;
  },
  fromAminoMsg(e) {
    return CompressedExistenceProof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return CompressedExistenceProof.decode(e.value);
  },
  toProto(e) {
    return CompressedExistenceProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.CompressedExistenceProof",
      value: CompressedExistenceProof.encode(e).finish()
    };
  }
};
function createBaseCompressedNonExistenceProof() {
  return {
    key: new Uint8Array(),
    left: void 0,
    right: void 0
  };
}
const CompressedNonExistenceProof = {
  typeUrl: "/ics23.CompressedNonExistenceProof",
  encode(e, n = minimal.Writer.create()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.left !== void 0 && CompressedExistenceProof.encode(e.left, n.uint32(18).fork()).ldelim(), e.right !== void 0 && CompressedExistenceProof.encode(e.right, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseCompressedNonExistenceProof();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.key = o.bytes();
          break;
        case 2:
          c.left = CompressedExistenceProof.decode(o, o.uint32());
          break;
        case 3:
          c.right = CompressedExistenceProof.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseCompressedNonExistenceProof();
    return o.key = (n = e.key) !== null && n !== void 0 ? n : new Uint8Array(), o.left = e.left !== void 0 && e.left !== null ? CompressedExistenceProof.fromPartial(e.left) : void 0, o.right = e.right !== void 0 && e.right !== null ? CompressedExistenceProof.fromPartial(e.right) : void 0, o;
  },
  fromAmino(e) {
    return {
      key: e.key,
      left: e != null && e.left ? CompressedExistenceProof.fromAmino(e.left) : void 0,
      right: e != null && e.right ? CompressedExistenceProof.fromAmino(e.right) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.key = e.key, n.left = e.left ? CompressedExistenceProof.toAmino(e.left) : void 0, n.right = e.right ? CompressedExistenceProof.toAmino(e.right) : void 0, n;
  },
  fromAminoMsg(e) {
    return CompressedNonExistenceProof.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return CompressedNonExistenceProof.decode(e.value);
  },
  toProto(e) {
    return CompressedNonExistenceProof.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/ics23.CompressedNonExistenceProof",
      value: CompressedNonExistenceProof.encode(e).finish()
    };
  }
}, _180 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BatchEntry,
  BatchProof,
  CommitmentProof,
  CompressedBatchEntry,
  CompressedBatchProof,
  CompressedExistenceProof,
  CompressedNonExistenceProof,
  ExistenceProof,
  get HashOp() {
    return HashOp;
  },
  HashOpAmino,
  HashOpSDKType,
  InnerOp,
  InnerSpec,
  LeafOp,
  get LengthOp() {
    return LengthOp;
  },
  LengthOpAmino,
  LengthOpSDKType,
  NonExistenceProof,
  ProofSpec,
  hashOpFromJSON,
  hashOpToJSON,
  lengthOpFromJSON,
  lengthOpToJSON
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$3(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$3(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$3(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$3(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
_objectSpread$3({}, _180);
let ScalarType;
(function(e) {
  e[e.SCALAR_TYPE_UNSPECIFIED = 0] = "SCALAR_TYPE_UNSPECIFIED", e[e.SCALAR_TYPE_STRING = 1] = "SCALAR_TYPE_STRING", e[e.SCALAR_TYPE_BYTES = 2] = "SCALAR_TYPE_BYTES", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(ScalarType || (ScalarType = {}));
const ScalarTypeSDKType = ScalarType, ScalarTypeAmino = ScalarType;
function scalarTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "SCALAR_TYPE_UNSPECIFIED":
      return ScalarType.SCALAR_TYPE_UNSPECIFIED;
    case 1:
    case "SCALAR_TYPE_STRING":
      return ScalarType.SCALAR_TYPE_STRING;
    case 2:
    case "SCALAR_TYPE_BYTES":
      return ScalarType.SCALAR_TYPE_BYTES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScalarType.UNRECOGNIZED;
  }
}
function scalarTypeToJSON(e) {
  switch (e) {
    case ScalarType.SCALAR_TYPE_UNSPECIFIED:
      return "SCALAR_TYPE_UNSPECIFIED";
    case ScalarType.SCALAR_TYPE_STRING:
      return "SCALAR_TYPE_STRING";
    case ScalarType.SCALAR_TYPE_BYTES:
      return "SCALAR_TYPE_BYTES";
    case ScalarType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseInterfaceDescriptor() {
  return {
    name: "",
    description: ""
  };
}
const InterfaceDescriptor = {
  typeUrl: "/cosmos_proto.InterfaceDescriptor",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.description !== "" && n.uint32(18).string(e.description), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseInterfaceDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseInterfaceDescriptor();
    return u.name = (n = e.name) !== null && n !== void 0 ? n : "", u.description = (o = e.description) !== null && o !== void 0 ? o : "", u;
  },
  fromAmino(e) {
    return {
      name: e.name,
      description: e.description
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.description = e.description, n;
  },
  fromAminoMsg(e) {
    return InterfaceDescriptor.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return InterfaceDescriptor.decode(e.value);
  },
  toProto(e) {
    return InterfaceDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos_proto.InterfaceDescriptor",
      value: InterfaceDescriptor.encode(e).finish()
    };
  }
};
function createBaseScalarDescriptor() {
  return {
    name: "",
    description: "",
    fieldType: []
  };
}
const ScalarDescriptor = {
  typeUrl: "/cosmos_proto.ScalarDescriptor",
  encode(e, n = minimal.Writer.create()) {
    e.name !== "" && n.uint32(10).string(e.name), e.description !== "" && n.uint32(18).string(e.description), n.uint32(26).fork();
    for (const o of e.fieldType)
      n.int32(o);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseScalarDescriptor();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.description = o.string();
          break;
        case 3:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.fieldType.push(o.int32());
          } else
            c.fieldType.push(o.int32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseScalarDescriptor();
    return c.name = (n = e.name) !== null && n !== void 0 ? n : "", c.description = (o = e.description) !== null && o !== void 0 ? o : "", c.fieldType = ((u = e.fieldType) === null || u === void 0 ? void 0 : u.map((d) => d)) || [], c;
  },
  fromAmino(e) {
    return {
      name: e.name,
      description: e.description,
      fieldType: Array.isArray(e == null ? void 0 : e.field_type) ? e.field_type.map((n) => scalarTypeFromJSON(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.description = e.description, e.fieldType ? n.field_type = e.fieldType.map((o) => scalarTypeToJSON(o)) : n.field_type = [], n;
  },
  fromAminoMsg(e) {
    return ScalarDescriptor.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ScalarDescriptor.decode(e.value);
  },
  toProto(e) {
    return ScalarDescriptor.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/cosmos_proto.ScalarDescriptor",
      value: ScalarDescriptor.encode(e).finish()
    };
  }
}, _181 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InterfaceDescriptor,
  ScalarDescriptor,
  get ScalarType() {
    return ScalarType;
  },
  ScalarTypeAmino,
  ScalarTypeSDKType,
  scalarTypeFromJSON,
  scalarTypeToJSON
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$2(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$2(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$2(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$2(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
_objectSpread$2({}, _181);
const _182 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys$1(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread$1(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys$1(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$1(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
_objectSpread$1({}, _182);
let FieldDescriptorProto_Type;
(function(e) {
  e[e.TYPE_DOUBLE = 1] = "TYPE_DOUBLE", e[e.TYPE_FLOAT = 2] = "TYPE_FLOAT", e[e.TYPE_INT64 = 3] = "TYPE_INT64", e[e.TYPE_UINT64 = 4] = "TYPE_UINT64", e[e.TYPE_INT32 = 5] = "TYPE_INT32", e[e.TYPE_FIXED64 = 6] = "TYPE_FIXED64", e[e.TYPE_FIXED32 = 7] = "TYPE_FIXED32", e[e.TYPE_BOOL = 8] = "TYPE_BOOL", e[e.TYPE_STRING = 9] = "TYPE_STRING", e[e.TYPE_GROUP = 10] = "TYPE_GROUP", e[e.TYPE_MESSAGE = 11] = "TYPE_MESSAGE", e[e.TYPE_BYTES = 12] = "TYPE_BYTES", e[e.TYPE_UINT32 = 13] = "TYPE_UINT32", e[e.TYPE_ENUM = 14] = "TYPE_ENUM", e[e.TYPE_SFIXED32 = 15] = "TYPE_SFIXED32", e[e.TYPE_SFIXED64 = 16] = "TYPE_SFIXED64", e[e.TYPE_SINT32 = 17] = "TYPE_SINT32", e[e.TYPE_SINT64 = 18] = "TYPE_SINT64", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FieldDescriptorProto_Type || (FieldDescriptorProto_Type = {}));
const FieldDescriptorProto_TypeSDKType = FieldDescriptorProto_Type, FieldDescriptorProto_TypeAmino = FieldDescriptorProto_Type;
function fieldDescriptorProto_TypeFromJSON(e) {
  switch (e) {
    case 1:
    case "TYPE_DOUBLE":
      return FieldDescriptorProto_Type.TYPE_DOUBLE;
    case 2:
    case "TYPE_FLOAT":
      return FieldDescriptorProto_Type.TYPE_FLOAT;
    case 3:
    case "TYPE_INT64":
      return FieldDescriptorProto_Type.TYPE_INT64;
    case 4:
    case "TYPE_UINT64":
      return FieldDescriptorProto_Type.TYPE_UINT64;
    case 5:
    case "TYPE_INT32":
      return FieldDescriptorProto_Type.TYPE_INT32;
    case 6:
    case "TYPE_FIXED64":
      return FieldDescriptorProto_Type.TYPE_FIXED64;
    case 7:
    case "TYPE_FIXED32":
      return FieldDescriptorProto_Type.TYPE_FIXED32;
    case 8:
    case "TYPE_BOOL":
      return FieldDescriptorProto_Type.TYPE_BOOL;
    case 9:
    case "TYPE_STRING":
      return FieldDescriptorProto_Type.TYPE_STRING;
    case 10:
    case "TYPE_GROUP":
      return FieldDescriptorProto_Type.TYPE_GROUP;
    case 11:
    case "TYPE_MESSAGE":
      return FieldDescriptorProto_Type.TYPE_MESSAGE;
    case 12:
    case "TYPE_BYTES":
      return FieldDescriptorProto_Type.TYPE_BYTES;
    case 13:
    case "TYPE_UINT32":
      return FieldDescriptorProto_Type.TYPE_UINT32;
    case 14:
    case "TYPE_ENUM":
      return FieldDescriptorProto_Type.TYPE_ENUM;
    case 15:
    case "TYPE_SFIXED32":
      return FieldDescriptorProto_Type.TYPE_SFIXED32;
    case 16:
    case "TYPE_SFIXED64":
      return FieldDescriptorProto_Type.TYPE_SFIXED64;
    case 17:
    case "TYPE_SINT32":
      return FieldDescriptorProto_Type.TYPE_SINT32;
    case 18:
    case "TYPE_SINT64":
      return FieldDescriptorProto_Type.TYPE_SINT64;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldDescriptorProto_Type.UNRECOGNIZED;
  }
}
function fieldDescriptorProto_TypeToJSON(e) {
  switch (e) {
    case FieldDescriptorProto_Type.TYPE_DOUBLE:
      return "TYPE_DOUBLE";
    case FieldDescriptorProto_Type.TYPE_FLOAT:
      return "TYPE_FLOAT";
    case FieldDescriptorProto_Type.TYPE_INT64:
      return "TYPE_INT64";
    case FieldDescriptorProto_Type.TYPE_UINT64:
      return "TYPE_UINT64";
    case FieldDescriptorProto_Type.TYPE_INT32:
      return "TYPE_INT32";
    case FieldDescriptorProto_Type.TYPE_FIXED64:
      return "TYPE_FIXED64";
    case FieldDescriptorProto_Type.TYPE_FIXED32:
      return "TYPE_FIXED32";
    case FieldDescriptorProto_Type.TYPE_BOOL:
      return "TYPE_BOOL";
    case FieldDescriptorProto_Type.TYPE_STRING:
      return "TYPE_STRING";
    case FieldDescriptorProto_Type.TYPE_GROUP:
      return "TYPE_GROUP";
    case FieldDescriptorProto_Type.TYPE_MESSAGE:
      return "TYPE_MESSAGE";
    case FieldDescriptorProto_Type.TYPE_BYTES:
      return "TYPE_BYTES";
    case FieldDescriptorProto_Type.TYPE_UINT32:
      return "TYPE_UINT32";
    case FieldDescriptorProto_Type.TYPE_ENUM:
      return "TYPE_ENUM";
    case FieldDescriptorProto_Type.TYPE_SFIXED32:
      return "TYPE_SFIXED32";
    case FieldDescriptorProto_Type.TYPE_SFIXED64:
      return "TYPE_SFIXED64";
    case FieldDescriptorProto_Type.TYPE_SINT32:
      return "TYPE_SINT32";
    case FieldDescriptorProto_Type.TYPE_SINT64:
      return "TYPE_SINT64";
    case FieldDescriptorProto_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let FieldDescriptorProto_Label;
(function(e) {
  e[e.LABEL_OPTIONAL = 1] = "LABEL_OPTIONAL", e[e.LABEL_REQUIRED = 2] = "LABEL_REQUIRED", e[e.LABEL_REPEATED = 3] = "LABEL_REPEATED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FieldDescriptorProto_Label || (FieldDescriptorProto_Label = {}));
const FieldDescriptorProto_LabelSDKType = FieldDescriptorProto_Label, FieldDescriptorProto_LabelAmino = FieldDescriptorProto_Label;
function fieldDescriptorProto_LabelFromJSON(e) {
  switch (e) {
    case 1:
    case "LABEL_OPTIONAL":
      return FieldDescriptorProto_Label.LABEL_OPTIONAL;
    case 2:
    case "LABEL_REQUIRED":
      return FieldDescriptorProto_Label.LABEL_REQUIRED;
    case 3:
    case "LABEL_REPEATED":
      return FieldDescriptorProto_Label.LABEL_REPEATED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldDescriptorProto_Label.UNRECOGNIZED;
  }
}
function fieldDescriptorProto_LabelToJSON(e) {
  switch (e) {
    case FieldDescriptorProto_Label.LABEL_OPTIONAL:
      return "LABEL_OPTIONAL";
    case FieldDescriptorProto_Label.LABEL_REQUIRED:
      return "LABEL_REQUIRED";
    case FieldDescriptorProto_Label.LABEL_REPEATED:
      return "LABEL_REPEATED";
    case FieldDescriptorProto_Label.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let FileOptions_OptimizeMode;
(function(e) {
  e[e.SPEED = 1] = "SPEED", e[e.CODE_SIZE = 2] = "CODE_SIZE", e[e.LITE_RUNTIME = 3] = "LITE_RUNTIME", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FileOptions_OptimizeMode || (FileOptions_OptimizeMode = {}));
const FileOptions_OptimizeModeSDKType = FileOptions_OptimizeMode, FileOptions_OptimizeModeAmino = FileOptions_OptimizeMode;
function fileOptions_OptimizeModeFromJSON(e) {
  switch (e) {
    case 1:
    case "SPEED":
      return FileOptions_OptimizeMode.SPEED;
    case 2:
    case "CODE_SIZE":
      return FileOptions_OptimizeMode.CODE_SIZE;
    case 3:
    case "LITE_RUNTIME":
      return FileOptions_OptimizeMode.LITE_RUNTIME;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FileOptions_OptimizeMode.UNRECOGNIZED;
  }
}
function fileOptions_OptimizeModeToJSON(e) {
  switch (e) {
    case FileOptions_OptimizeMode.SPEED:
      return "SPEED";
    case FileOptions_OptimizeMode.CODE_SIZE:
      return "CODE_SIZE";
    case FileOptions_OptimizeMode.LITE_RUNTIME:
      return "LITE_RUNTIME";
    case FileOptions_OptimizeMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let FieldOptions_CType;
(function(e) {
  e[e.STRING = 0] = "STRING", e[e.CORD = 1] = "CORD", e[e.STRING_PIECE = 2] = "STRING_PIECE", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FieldOptions_CType || (FieldOptions_CType = {}));
const FieldOptions_CTypeSDKType = FieldOptions_CType, FieldOptions_CTypeAmino = FieldOptions_CType;
function fieldOptions_CTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "STRING":
      return FieldOptions_CType.STRING;
    case 1:
    case "CORD":
      return FieldOptions_CType.CORD;
    case 2:
    case "STRING_PIECE":
      return FieldOptions_CType.STRING_PIECE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldOptions_CType.UNRECOGNIZED;
  }
}
function fieldOptions_CTypeToJSON(e) {
  switch (e) {
    case FieldOptions_CType.STRING:
      return "STRING";
    case FieldOptions_CType.CORD:
      return "CORD";
    case FieldOptions_CType.STRING_PIECE:
      return "STRING_PIECE";
    case FieldOptions_CType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let FieldOptions_JSType;
(function(e) {
  e[e.JS_NORMAL = 0] = "JS_NORMAL", e[e.JS_STRING = 1] = "JS_STRING", e[e.JS_NUMBER = 2] = "JS_NUMBER", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(FieldOptions_JSType || (FieldOptions_JSType = {}));
const FieldOptions_JSTypeSDKType = FieldOptions_JSType, FieldOptions_JSTypeAmino = FieldOptions_JSType;
function fieldOptions_JSTypeFromJSON(e) {
  switch (e) {
    case 0:
    case "JS_NORMAL":
      return FieldOptions_JSType.JS_NORMAL;
    case 1:
    case "JS_STRING":
      return FieldOptions_JSType.JS_STRING;
    case 2:
    case "JS_NUMBER":
      return FieldOptions_JSType.JS_NUMBER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldOptions_JSType.UNRECOGNIZED;
  }
}
function fieldOptions_JSTypeToJSON(e) {
  switch (e) {
    case FieldOptions_JSType.JS_NORMAL:
      return "JS_NORMAL";
    case FieldOptions_JSType.JS_STRING:
      return "JS_STRING";
    case FieldOptions_JSType.JS_NUMBER:
      return "JS_NUMBER";
    case FieldOptions_JSType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let MethodOptions_IdempotencyLevel;
(function(e) {
  e[e.IDEMPOTENCY_UNKNOWN = 0] = "IDEMPOTENCY_UNKNOWN", e[e.NO_SIDE_EFFECTS = 1] = "NO_SIDE_EFFECTS", e[e.IDEMPOTENT = 2] = "IDEMPOTENT", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED";
})(MethodOptions_IdempotencyLevel || (MethodOptions_IdempotencyLevel = {}));
const MethodOptions_IdempotencyLevelSDKType = MethodOptions_IdempotencyLevel, MethodOptions_IdempotencyLevelAmino = MethodOptions_IdempotencyLevel;
function methodOptions_IdempotencyLevelFromJSON(e) {
  switch (e) {
    case 0:
    case "IDEMPOTENCY_UNKNOWN":
      return MethodOptions_IdempotencyLevel.IDEMPOTENCY_UNKNOWN;
    case 1:
    case "NO_SIDE_EFFECTS":
      return MethodOptions_IdempotencyLevel.NO_SIDE_EFFECTS;
    case 2:
    case "IDEMPOTENT":
      return MethodOptions_IdempotencyLevel.IDEMPOTENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MethodOptions_IdempotencyLevel.UNRECOGNIZED;
  }
}
function methodOptions_IdempotencyLevelToJSON(e) {
  switch (e) {
    case MethodOptions_IdempotencyLevel.IDEMPOTENCY_UNKNOWN:
      return "IDEMPOTENCY_UNKNOWN";
    case MethodOptions_IdempotencyLevel.NO_SIDE_EFFECTS:
      return "NO_SIDE_EFFECTS";
    case MethodOptions_IdempotencyLevel.IDEMPOTENT:
      return "IDEMPOTENT";
    case MethodOptions_IdempotencyLevel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseFileDescriptorSet() {
  return {
    file: []
  };
}
const FileDescriptorSet = {
  typeUrl: "/google.protobuf.FileDescriptorSet",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.file)
      FileDescriptorProto.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFileDescriptorSet();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.file.push(FileDescriptorProto.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseFileDescriptorSet();
    return o.file = ((n = e.file) === null || n === void 0 ? void 0 : n.map((u) => FileDescriptorProto.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      file: Array.isArray(e == null ? void 0 : e.file) ? e.file.map((n) => FileDescriptorProto.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.file ? n.file = e.file.map((o) => o ? FileDescriptorProto.toAmino(o) : void 0) : n.file = [], n;
  },
  fromAminoMsg(e) {
    return FileDescriptorSet.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return FileDescriptorSet.decode(e.value);
  },
  toProto(e) {
    return FileDescriptorSet.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.FileDescriptorSet",
      value: FileDescriptorSet.encode(e).finish()
    };
  }
};
function createBaseFileDescriptorProto() {
  return {
    name: "",
    package: "",
    dependency: [],
    publicDependency: [],
    weakDependency: [],
    messageType: [],
    enumType: [],
    service: [],
    extension: [],
    options: void 0,
    sourceCodeInfo: void 0,
    syntax: ""
  };
}
const FileDescriptorProto = {
  typeUrl: "/google.protobuf.FileDescriptorProto",
  encode(e, n = minimal.Writer.create()) {
    e.name !== "" && n.uint32(10).string(e.name), e.package !== "" && n.uint32(18).string(e.package);
    for (const o of e.dependency)
      n.uint32(26).string(o);
    n.uint32(82).fork();
    for (const o of e.publicDependency)
      n.int32(o);
    n.ldelim(), n.uint32(90).fork();
    for (const o of e.weakDependency)
      n.int32(o);
    n.ldelim();
    for (const o of e.messageType)
      DescriptorProto.encode(o, n.uint32(34).fork()).ldelim();
    for (const o of e.enumType)
      EnumDescriptorProto.encode(o, n.uint32(42).fork()).ldelim();
    for (const o of e.service)
      ServiceDescriptorProto.encode(o, n.uint32(50).fork()).ldelim();
    for (const o of e.extension)
      FieldDescriptorProto.encode(o, n.uint32(58).fork()).ldelim();
    return e.options !== void 0 && FileOptions.encode(e.options, n.uint32(66).fork()).ldelim(), e.sourceCodeInfo !== void 0 && SourceCodeInfo.encode(e.sourceCodeInfo, n.uint32(74).fork()).ldelim(), e.syntax !== "" && n.uint32(98).string(e.syntax), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFileDescriptorProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.package = o.string();
          break;
        case 3:
          c.dependency.push(o.string());
          break;
        case 10:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.publicDependency.push(o.int32());
          } else
            c.publicDependency.push(o.int32());
          break;
        case 11:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.weakDependency.push(o.int32());
          } else
            c.weakDependency.push(o.int32());
          break;
        case 4:
          c.messageType.push(DescriptorProto.decode(o, o.uint32()));
          break;
        case 5:
          c.enumType.push(EnumDescriptorProto.decode(o, o.uint32()));
          break;
        case 6:
          c.service.push(ServiceDescriptorProto.decode(o, o.uint32()));
          break;
        case 7:
          c.extension.push(FieldDescriptorProto.decode(o, o.uint32()));
          break;
        case 8:
          c.options = FileOptions.decode(o, o.uint32());
          break;
        case 9:
          c.sourceCodeInfo = SourceCodeInfo.decode(o, o.uint32());
          break;
        case 12:
          c.syntax = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $, E;
    const O = createBaseFileDescriptorProto();
    return O.name = (n = e.name) !== null && n !== void 0 ? n : "", O.package = (o = e.package) !== null && o !== void 0 ? o : "", O.dependency = ((u = e.dependency) === null || u === void 0 ? void 0 : u.map((T) => T)) || [], O.publicDependency = ((c = e.publicDependency) === null || c === void 0 ? void 0 : c.map((T) => T)) || [], O.weakDependency = ((d = e.weakDependency) === null || d === void 0 ? void 0 : d.map((T) => T)) || [], O.messageType = ((m = e.messageType) === null || m === void 0 ? void 0 : m.map((T) => DescriptorProto.fromPartial(T))) || [], O.enumType = ((v = e.enumType) === null || v === void 0 ? void 0 : v.map((T) => EnumDescriptorProto.fromPartial(T))) || [], O.service = ((S = e.service) === null || S === void 0 ? void 0 : S.map((T) => ServiceDescriptorProto.fromPartial(T))) || [], O.extension = (($ = e.extension) === null || $ === void 0 ? void 0 : $.map((T) => FieldDescriptorProto.fromPartial(T))) || [], O.options = e.options !== void 0 && e.options !== null ? FileOptions.fromPartial(e.options) : void 0, O.sourceCodeInfo = e.sourceCodeInfo !== void 0 && e.sourceCodeInfo !== null ? SourceCodeInfo.fromPartial(e.sourceCodeInfo) : void 0, O.syntax = (E = e.syntax) !== null && E !== void 0 ? E : "", O;
  },
  fromAmino(e) {
    return {
      name: e.name,
      package: e.package,
      dependency: Array.isArray(e == null ? void 0 : e.dependency) ? e.dependency.map((n) => n) : [],
      publicDependency: Array.isArray(e == null ? void 0 : e.public_dependency) ? e.public_dependency.map((n) => n) : [],
      weakDependency: Array.isArray(e == null ? void 0 : e.weak_dependency) ? e.weak_dependency.map((n) => n) : [],
      messageType: Array.isArray(e == null ? void 0 : e.message_type) ? e.message_type.map((n) => DescriptorProto.fromAmino(n)) : [],
      enumType: Array.isArray(e == null ? void 0 : e.enum_type) ? e.enum_type.map((n) => EnumDescriptorProto.fromAmino(n)) : [],
      service: Array.isArray(e == null ? void 0 : e.service) ? e.service.map((n) => ServiceDescriptorProto.fromAmino(n)) : [],
      extension: Array.isArray(e == null ? void 0 : e.extension) ? e.extension.map((n) => FieldDescriptorProto.fromAmino(n)) : [],
      options: e != null && e.options ? FileOptions.fromAmino(e.options) : void 0,
      sourceCodeInfo: e != null && e.source_code_info ? SourceCodeInfo.fromAmino(e.source_code_info) : void 0,
      syntax: e.syntax
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.package = e.package, e.dependency ? n.dependency = e.dependency.map((o) => o) : n.dependency = [], e.publicDependency ? n.public_dependency = e.publicDependency.map((o) => o) : n.public_dependency = [], e.weakDependency ? n.weak_dependency = e.weakDependency.map((o) => o) : n.weak_dependency = [], e.messageType ? n.message_type = e.messageType.map((o) => o ? DescriptorProto.toAmino(o) : void 0) : n.message_type = [], e.enumType ? n.enum_type = e.enumType.map((o) => o ? EnumDescriptorProto.toAmino(o) : void 0) : n.enum_type = [], e.service ? n.service = e.service.map((o) => o ? ServiceDescriptorProto.toAmino(o) : void 0) : n.service = [], e.extension ? n.extension = e.extension.map((o) => o ? FieldDescriptorProto.toAmino(o) : void 0) : n.extension = [], n.options = e.options ? FileOptions.toAmino(e.options) : void 0, n.source_code_info = e.sourceCodeInfo ? SourceCodeInfo.toAmino(e.sourceCodeInfo) : void 0, n.syntax = e.syntax, n;
  },
  fromAminoMsg(e) {
    return FileDescriptorProto.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return FileDescriptorProto.decode(e.value);
  },
  toProto(e) {
    return FileDescriptorProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.FileDescriptorProto",
      value: FileDescriptorProto.encode(e).finish()
    };
  }
};
function createBaseDescriptorProto() {
  return {
    name: "",
    field: [],
    extension: [],
    nestedType: [],
    enumType: [],
    extensionRange: [],
    oneofDecl: [],
    options: void 0,
    reservedRange: [],
    reservedName: []
  };
}
const DescriptorProto = {
  typeUrl: "/google.protobuf.DescriptorProto",
  encode(e, n = minimal.Writer.create()) {
    e.name !== "" && n.uint32(10).string(e.name);
    for (const o of e.field)
      FieldDescriptorProto.encode(o, n.uint32(18).fork()).ldelim();
    for (const o of e.extension)
      FieldDescriptorProto.encode(o, n.uint32(50).fork()).ldelim();
    for (const o of e.nestedType)
      DescriptorProto.encode(o, n.uint32(26).fork()).ldelim();
    for (const o of e.enumType)
      EnumDescriptorProto.encode(o, n.uint32(34).fork()).ldelim();
    for (const o of e.extensionRange)
      DescriptorProto_ExtensionRange.encode(o, n.uint32(42).fork()).ldelim();
    for (const o of e.oneofDecl)
      OneofDescriptorProto.encode(o, n.uint32(66).fork()).ldelim();
    e.options !== void 0 && MessageOptions.encode(e.options, n.uint32(58).fork()).ldelim();
    for (const o of e.reservedRange)
      DescriptorProto_ReservedRange.encode(o, n.uint32(74).fork()).ldelim();
    for (const o of e.reservedName)
      n.uint32(82).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDescriptorProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.field.push(FieldDescriptorProto.decode(o, o.uint32()));
          break;
        case 6:
          c.extension.push(FieldDescriptorProto.decode(o, o.uint32()));
          break;
        case 3:
          c.nestedType.push(DescriptorProto.decode(o, o.uint32()));
          break;
        case 4:
          c.enumType.push(EnumDescriptorProto.decode(o, o.uint32()));
          break;
        case 5:
          c.extensionRange.push(DescriptorProto_ExtensionRange.decode(o, o.uint32()));
          break;
        case 8:
          c.oneofDecl.push(OneofDescriptorProto.decode(o, o.uint32()));
          break;
        case 7:
          c.options = MessageOptions.decode(o, o.uint32());
          break;
        case 9:
          c.reservedRange.push(DescriptorProto_ReservedRange.decode(o, o.uint32()));
          break;
        case 10:
          c.reservedName.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $;
    const E = createBaseDescriptorProto();
    return E.name = (n = e.name) !== null && n !== void 0 ? n : "", E.field = ((o = e.field) === null || o === void 0 ? void 0 : o.map((O) => FieldDescriptorProto.fromPartial(O))) || [], E.extension = ((u = e.extension) === null || u === void 0 ? void 0 : u.map((O) => FieldDescriptorProto.fromPartial(O))) || [], E.nestedType = ((c = e.nestedType) === null || c === void 0 ? void 0 : c.map((O) => DescriptorProto.fromPartial(O))) || [], E.enumType = ((d = e.enumType) === null || d === void 0 ? void 0 : d.map((O) => EnumDescriptorProto.fromPartial(O))) || [], E.extensionRange = ((m = e.extensionRange) === null || m === void 0 ? void 0 : m.map((O) => DescriptorProto_ExtensionRange.fromPartial(O))) || [], E.oneofDecl = ((v = e.oneofDecl) === null || v === void 0 ? void 0 : v.map((O) => OneofDescriptorProto.fromPartial(O))) || [], E.options = e.options !== void 0 && e.options !== null ? MessageOptions.fromPartial(e.options) : void 0, E.reservedRange = ((S = e.reservedRange) === null || S === void 0 ? void 0 : S.map((O) => DescriptorProto_ReservedRange.fromPartial(O))) || [], E.reservedName = (($ = e.reservedName) === null || $ === void 0 ? void 0 : $.map((O) => O)) || [], E;
  },
  fromAmino(e) {
    return {
      name: e.name,
      field: Array.isArray(e == null ? void 0 : e.field) ? e.field.map((n) => FieldDescriptorProto.fromAmino(n)) : [],
      extension: Array.isArray(e == null ? void 0 : e.extension) ? e.extension.map((n) => FieldDescriptorProto.fromAmino(n)) : [],
      nestedType: Array.isArray(e == null ? void 0 : e.nested_type) ? e.nested_type.map((n) => DescriptorProto.fromAmino(n)) : [],
      enumType: Array.isArray(e == null ? void 0 : e.enum_type) ? e.enum_type.map((n) => EnumDescriptorProto.fromAmino(n)) : [],
      extensionRange: Array.isArray(e == null ? void 0 : e.extension_range) ? e.extension_range.map((n) => DescriptorProto_ExtensionRange.fromAmino(n)) : [],
      oneofDecl: Array.isArray(e == null ? void 0 : e.oneof_decl) ? e.oneof_decl.map((n) => OneofDescriptorProto.fromAmino(n)) : [],
      options: e != null && e.options ? MessageOptions.fromAmino(e.options) : void 0,
      reservedRange: Array.isArray(e == null ? void 0 : e.reserved_range) ? e.reserved_range.map((n) => DescriptorProto_ReservedRange.fromAmino(n)) : [],
      reservedName: Array.isArray(e == null ? void 0 : e.reserved_name) ? e.reserved_name.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, e.field ? n.field = e.field.map((o) => o ? FieldDescriptorProto.toAmino(o) : void 0) : n.field = [], e.extension ? n.extension = e.extension.map((o) => o ? FieldDescriptorProto.toAmino(o) : void 0) : n.extension = [], e.nestedType ? n.nested_type = e.nestedType.map((o) => o ? DescriptorProto.toAmino(o) : void 0) : n.nested_type = [], e.enumType ? n.enum_type = e.enumType.map((o) => o ? EnumDescriptorProto.toAmino(o) : void 0) : n.enum_type = [], e.extensionRange ? n.extension_range = e.extensionRange.map((o) => o ? DescriptorProto_ExtensionRange.toAmino(o) : void 0) : n.extension_range = [], e.oneofDecl ? n.oneof_decl = e.oneofDecl.map((o) => o ? OneofDescriptorProto.toAmino(o) : void 0) : n.oneof_decl = [], n.options = e.options ? MessageOptions.toAmino(e.options) : void 0, e.reservedRange ? n.reserved_range = e.reservedRange.map((o) => o ? DescriptorProto_ReservedRange.toAmino(o) : void 0) : n.reserved_range = [], e.reservedName ? n.reserved_name = e.reservedName.map((o) => o) : n.reserved_name = [], n;
  },
  fromAminoMsg(e) {
    return DescriptorProto.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return DescriptorProto.decode(e.value);
  },
  toProto(e) {
    return DescriptorProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.DescriptorProto",
      value: DescriptorProto.encode(e).finish()
    };
  }
};
function createBaseDescriptorProto_ExtensionRange() {
  return {
    start: 0,
    end: 0,
    options: void 0
  };
}
const DescriptorProto_ExtensionRange = {
  typeUrl: "/google.protobuf.ExtensionRange",
  encode(e, n = minimal.Writer.create()) {
    return e.start !== 0 && n.uint32(8).int32(e.start), e.end !== 0 && n.uint32(16).int32(e.end), e.options !== void 0 && ExtensionRangeOptions.encode(e.options, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDescriptorProto_ExtensionRange();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.start = o.int32();
          break;
        case 2:
          c.end = o.int32();
          break;
        case 3:
          c.options = ExtensionRangeOptions.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDescriptorProto_ExtensionRange();
    return u.start = (n = e.start) !== null && n !== void 0 ? n : 0, u.end = (o = e.end) !== null && o !== void 0 ? o : 0, u.options = e.options !== void 0 && e.options !== null ? ExtensionRangeOptions.fromPartial(e.options) : void 0, u;
  },
  fromAmino(e) {
    return {
      start: e.start,
      end: e.end,
      options: e != null && e.options ? ExtensionRangeOptions.fromAmino(e.options) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.start = e.start, n.end = e.end, n.options = e.options ? ExtensionRangeOptions.toAmino(e.options) : void 0, n;
  },
  fromAminoMsg(e) {
    return DescriptorProto_ExtensionRange.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return DescriptorProto_ExtensionRange.decode(e.value);
  },
  toProto(e) {
    return DescriptorProto_ExtensionRange.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.ExtensionRange",
      value: DescriptorProto_ExtensionRange.encode(e).finish()
    };
  }
};
function createBaseDescriptorProto_ReservedRange() {
  return {
    start: 0,
    end: 0
  };
}
const DescriptorProto_ReservedRange = {
  typeUrl: "/google.protobuf.ReservedRange",
  encode(e, n = minimal.Writer.create()) {
    return e.start !== 0 && n.uint32(8).int32(e.start), e.end !== 0 && n.uint32(16).int32(e.end), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseDescriptorProto_ReservedRange();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.start = o.int32();
          break;
        case 2:
          c.end = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseDescriptorProto_ReservedRange();
    return u.start = (n = e.start) !== null && n !== void 0 ? n : 0, u.end = (o = e.end) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      start: e.start,
      end: e.end
    };
  },
  toAmino(e) {
    const n = {};
    return n.start = e.start, n.end = e.end, n;
  },
  fromAminoMsg(e) {
    return DescriptorProto_ReservedRange.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return DescriptorProto_ReservedRange.decode(e.value);
  },
  toProto(e) {
    return DescriptorProto_ReservedRange.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.ReservedRange",
      value: DescriptorProto_ReservedRange.encode(e).finish()
    };
  }
};
function createBaseExtensionRangeOptions() {
  return {
    uninterpretedOption: []
  };
}
const ExtensionRangeOptions = {
  typeUrl: "/google.protobuf.ExtensionRangeOptions",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseExtensionRangeOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseExtensionRangeOptions();
    return o.uninterpretedOption = ((n = e.uninterpretedOption) === null || n === void 0 ? void 0 : n.map((u) => UninterpretedOption.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return ExtensionRangeOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ExtensionRangeOptions.decode(e.value);
  },
  toProto(e) {
    return ExtensionRangeOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.ExtensionRangeOptions",
      value: ExtensionRangeOptions.encode(e).finish()
    };
  }
};
function createBaseFieldDescriptorProto() {
  return {
    name: "",
    number: 0,
    label: 1,
    type: 1,
    typeName: "",
    extendee: "",
    defaultValue: "",
    oneofIndex: 0,
    jsonName: "",
    options: void 0
  };
}
const FieldDescriptorProto = {
  typeUrl: "/google.protobuf.FieldDescriptorProto",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.number !== 0 && n.uint32(24).int32(e.number), e.label !== 1 && n.uint32(32).int32(e.label), e.type !== 1 && n.uint32(40).int32(e.type), e.typeName !== "" && n.uint32(50).string(e.typeName), e.extendee !== "" && n.uint32(18).string(e.extendee), e.defaultValue !== "" && n.uint32(58).string(e.defaultValue), e.oneofIndex !== 0 && n.uint32(72).int32(e.oneofIndex), e.jsonName !== "" && n.uint32(82).string(e.jsonName), e.options !== void 0 && FieldOptions.encode(e.options, n.uint32(66).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFieldDescriptorProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 3:
          c.number = o.int32();
          break;
        case 4:
          c.label = o.int32();
          break;
        case 5:
          c.type = o.int32();
          break;
        case 6:
          c.typeName = o.string();
          break;
        case 2:
          c.extendee = o.string();
          break;
        case 7:
          c.defaultValue = o.string();
          break;
        case 9:
          c.oneofIndex = o.int32();
          break;
        case 10:
          c.jsonName = o.string();
          break;
        case 8:
          c.options = FieldOptions.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $;
    const E = createBaseFieldDescriptorProto();
    return E.name = (n = e.name) !== null && n !== void 0 ? n : "", E.number = (o = e.number) !== null && o !== void 0 ? o : 0, E.label = (u = e.label) !== null && u !== void 0 ? u : 1, E.type = (c = e.type) !== null && c !== void 0 ? c : 1, E.typeName = (d = e.typeName) !== null && d !== void 0 ? d : "", E.extendee = (m = e.extendee) !== null && m !== void 0 ? m : "", E.defaultValue = (v = e.defaultValue) !== null && v !== void 0 ? v : "", E.oneofIndex = (S = e.oneofIndex) !== null && S !== void 0 ? S : 0, E.jsonName = ($ = e.jsonName) !== null && $ !== void 0 ? $ : "", E.options = e.options !== void 0 && e.options !== null ? FieldOptions.fromPartial(e.options) : void 0, E;
  },
  fromAmino(e) {
    return {
      name: e.name,
      number: e.number,
      label: isSet(e.label) ? fieldDescriptorProto_LabelFromJSON(e.label) : 0,
      type: isSet(e.type) ? fieldDescriptorProto_TypeFromJSON(e.type) : 0,
      typeName: e.type_name,
      extendee: e.extendee,
      defaultValue: e.default_value,
      oneofIndex: e.oneof_index,
      jsonName: e.json_name,
      options: e != null && e.options ? FieldOptions.fromAmino(e.options) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.number = e.number, n.label = e.label, n.type = e.type, n.type_name = e.typeName, n.extendee = e.extendee, n.default_value = e.defaultValue, n.oneof_index = e.oneofIndex, n.json_name = e.jsonName, n.options = e.options ? FieldOptions.toAmino(e.options) : void 0, n;
  },
  fromAminoMsg(e) {
    return FieldDescriptorProto.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return FieldDescriptorProto.decode(e.value);
  },
  toProto(e) {
    return FieldDescriptorProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.FieldDescriptorProto",
      value: FieldDescriptorProto.encode(e).finish()
    };
  }
};
function createBaseOneofDescriptorProto() {
  return {
    name: "",
    options: void 0
  };
}
const OneofDescriptorProto = {
  typeUrl: "/google.protobuf.OneofDescriptorProto",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.options !== void 0 && OneofOptions.encode(e.options, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseOneofDescriptorProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.options = OneofOptions.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseOneofDescriptorProto();
    return o.name = (n = e.name) !== null && n !== void 0 ? n : "", o.options = e.options !== void 0 && e.options !== null ? OneofOptions.fromPartial(e.options) : void 0, o;
  },
  fromAmino(e) {
    return {
      name: e.name,
      options: e != null && e.options ? OneofOptions.fromAmino(e.options) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.options = e.options ? OneofOptions.toAmino(e.options) : void 0, n;
  },
  fromAminoMsg(e) {
    return OneofDescriptorProto.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return OneofDescriptorProto.decode(e.value);
  },
  toProto(e) {
    return OneofDescriptorProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.OneofDescriptorProto",
      value: OneofDescriptorProto.encode(e).finish()
    };
  }
};
function createBaseEnumDescriptorProto() {
  return {
    name: "",
    value: [],
    options: void 0,
    reservedRange: [],
    reservedName: []
  };
}
const EnumDescriptorProto = {
  typeUrl: "/google.protobuf.EnumDescriptorProto",
  encode(e, n = minimal.Writer.create()) {
    e.name !== "" && n.uint32(10).string(e.name);
    for (const o of e.value)
      EnumValueDescriptorProto.encode(o, n.uint32(18).fork()).ldelim();
    e.options !== void 0 && EnumOptions.encode(e.options, n.uint32(26).fork()).ldelim();
    for (const o of e.reservedRange)
      EnumDescriptorProto_EnumReservedRange.encode(o, n.uint32(34).fork()).ldelim();
    for (const o of e.reservedName)
      n.uint32(42).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEnumDescriptorProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.value.push(EnumValueDescriptorProto.decode(o, o.uint32()));
          break;
        case 3:
          c.options = EnumOptions.decode(o, o.uint32());
          break;
        case 4:
          c.reservedRange.push(EnumDescriptorProto_EnumReservedRange.decode(o, o.uint32()));
          break;
        case 5:
          c.reservedName.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseEnumDescriptorProto();
    return d.name = (n = e.name) !== null && n !== void 0 ? n : "", d.value = ((o = e.value) === null || o === void 0 ? void 0 : o.map((m) => EnumValueDescriptorProto.fromPartial(m))) || [], d.options = e.options !== void 0 && e.options !== null ? EnumOptions.fromPartial(e.options) : void 0, d.reservedRange = ((u = e.reservedRange) === null || u === void 0 ? void 0 : u.map((m) => EnumDescriptorProto_EnumReservedRange.fromPartial(m))) || [], d.reservedName = ((c = e.reservedName) === null || c === void 0 ? void 0 : c.map((m) => m)) || [], d;
  },
  fromAmino(e) {
    return {
      name: e.name,
      value: Array.isArray(e == null ? void 0 : e.value) ? e.value.map((n) => EnumValueDescriptorProto.fromAmino(n)) : [],
      options: e != null && e.options ? EnumOptions.fromAmino(e.options) : void 0,
      reservedRange: Array.isArray(e == null ? void 0 : e.reserved_range) ? e.reserved_range.map((n) => EnumDescriptorProto_EnumReservedRange.fromAmino(n)) : [],
      reservedName: Array.isArray(e == null ? void 0 : e.reserved_name) ? e.reserved_name.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, e.value ? n.value = e.value.map((o) => o ? EnumValueDescriptorProto.toAmino(o) : void 0) : n.value = [], n.options = e.options ? EnumOptions.toAmino(e.options) : void 0, e.reservedRange ? n.reserved_range = e.reservedRange.map((o) => o ? EnumDescriptorProto_EnumReservedRange.toAmino(o) : void 0) : n.reserved_range = [], e.reservedName ? n.reserved_name = e.reservedName.map((o) => o) : n.reserved_name = [], n;
  },
  fromAminoMsg(e) {
    return EnumDescriptorProto.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return EnumDescriptorProto.decode(e.value);
  },
  toProto(e) {
    return EnumDescriptorProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.EnumDescriptorProto",
      value: EnumDescriptorProto.encode(e).finish()
    };
  }
};
function createBaseEnumDescriptorProto_EnumReservedRange() {
  return {
    start: 0,
    end: 0
  };
}
const EnumDescriptorProto_EnumReservedRange = {
  typeUrl: "/google.protobuf.EnumReservedRange",
  encode(e, n = minimal.Writer.create()) {
    return e.start !== 0 && n.uint32(8).int32(e.start), e.end !== 0 && n.uint32(16).int32(e.end), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEnumDescriptorProto_EnumReservedRange();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.start = o.int32();
          break;
        case 2:
          c.end = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEnumDescriptorProto_EnumReservedRange();
    return u.start = (n = e.start) !== null && n !== void 0 ? n : 0, u.end = (o = e.end) !== null && o !== void 0 ? o : 0, u;
  },
  fromAmino(e) {
    return {
      start: e.start,
      end: e.end
    };
  },
  toAmino(e) {
    const n = {};
    return n.start = e.start, n.end = e.end, n;
  },
  fromAminoMsg(e) {
    return EnumDescriptorProto_EnumReservedRange.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return EnumDescriptorProto_EnumReservedRange.decode(e.value);
  },
  toProto(e) {
    return EnumDescriptorProto_EnumReservedRange.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.EnumReservedRange",
      value: EnumDescriptorProto_EnumReservedRange.encode(e).finish()
    };
  }
};
function createBaseEnumValueDescriptorProto() {
  return {
    name: "",
    number: 0,
    options: void 0
  };
}
const EnumValueDescriptorProto = {
  typeUrl: "/google.protobuf.EnumValueDescriptorProto",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.number !== 0 && n.uint32(16).int32(e.number), e.options !== void 0 && EnumValueOptions.encode(e.options, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEnumValueDescriptorProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.number = o.int32();
          break;
        case 3:
          c.options = EnumValueOptions.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEnumValueDescriptorProto();
    return u.name = (n = e.name) !== null && n !== void 0 ? n : "", u.number = (o = e.number) !== null && o !== void 0 ? o : 0, u.options = e.options !== void 0 && e.options !== null ? EnumValueOptions.fromPartial(e.options) : void 0, u;
  },
  fromAmino(e) {
    return {
      name: e.name,
      number: e.number,
      options: e != null && e.options ? EnumValueOptions.fromAmino(e.options) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.number = e.number, n.options = e.options ? EnumValueOptions.toAmino(e.options) : void 0, n;
  },
  fromAminoMsg(e) {
    return EnumValueDescriptorProto.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return EnumValueDescriptorProto.decode(e.value);
  },
  toProto(e) {
    return EnumValueDescriptorProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.EnumValueDescriptorProto",
      value: EnumValueDescriptorProto.encode(e).finish()
    };
  }
};
function createBaseServiceDescriptorProto() {
  return {
    name: "",
    method: [],
    options: void 0
  };
}
const ServiceDescriptorProto = {
  typeUrl: "/google.protobuf.ServiceDescriptorProto",
  encode(e, n = minimal.Writer.create()) {
    e.name !== "" && n.uint32(10).string(e.name);
    for (const o of e.method)
      MethodDescriptorProto.encode(o, n.uint32(18).fork()).ldelim();
    return e.options !== void 0 && ServiceOptions.encode(e.options, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseServiceDescriptorProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.method.push(MethodDescriptorProto.decode(o, o.uint32()));
          break;
        case 3:
          c.options = ServiceOptions.decode(o, o.uint32());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseServiceDescriptorProto();
    return u.name = (n = e.name) !== null && n !== void 0 ? n : "", u.method = ((o = e.method) === null || o === void 0 ? void 0 : o.map((c) => MethodDescriptorProto.fromPartial(c))) || [], u.options = e.options !== void 0 && e.options !== null ? ServiceOptions.fromPartial(e.options) : void 0, u;
  },
  fromAmino(e) {
    return {
      name: e.name,
      method: Array.isArray(e == null ? void 0 : e.method) ? e.method.map((n) => MethodDescriptorProto.fromAmino(n)) : [],
      options: e != null && e.options ? ServiceOptions.fromAmino(e.options) : void 0
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, e.method ? n.method = e.method.map((o) => o ? MethodDescriptorProto.toAmino(o) : void 0) : n.method = [], n.options = e.options ? ServiceOptions.toAmino(e.options) : void 0, n;
  },
  fromAminoMsg(e) {
    return ServiceDescriptorProto.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ServiceDescriptorProto.decode(e.value);
  },
  toProto(e) {
    return ServiceDescriptorProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.ServiceDescriptorProto",
      value: ServiceDescriptorProto.encode(e).finish()
    };
  }
};
function createBaseMethodDescriptorProto() {
  return {
    name: "",
    inputType: "",
    outputType: "",
    options: void 0,
    clientStreaming: !1,
    serverStreaming: !1
  };
}
const MethodDescriptorProto = {
  typeUrl: "/google.protobuf.MethodDescriptorProto",
  encode(e, n = minimal.Writer.create()) {
    return e.name !== "" && n.uint32(10).string(e.name), e.inputType !== "" && n.uint32(18).string(e.inputType), e.outputType !== "" && n.uint32(26).string(e.outputType), e.options !== void 0 && MethodOptions.encode(e.options, n.uint32(34).fork()).ldelim(), e.clientStreaming === !0 && n.uint32(40).bool(e.clientStreaming), e.serverStreaming === !0 && n.uint32(48).bool(e.serverStreaming), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMethodDescriptorProto();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.name = o.string();
          break;
        case 2:
          c.inputType = o.string();
          break;
        case 3:
          c.outputType = o.string();
          break;
        case 4:
          c.options = MethodOptions.decode(o, o.uint32());
          break;
        case 5:
          c.clientStreaming = o.bool();
          break;
        case 6:
          c.serverStreaming = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseMethodDescriptorProto();
    return m.name = (n = e.name) !== null && n !== void 0 ? n : "", m.inputType = (o = e.inputType) !== null && o !== void 0 ? o : "", m.outputType = (u = e.outputType) !== null && u !== void 0 ? u : "", m.options = e.options !== void 0 && e.options !== null ? MethodOptions.fromPartial(e.options) : void 0, m.clientStreaming = (c = e.clientStreaming) !== null && c !== void 0 ? c : !1, m.serverStreaming = (d = e.serverStreaming) !== null && d !== void 0 ? d : !1, m;
  },
  fromAmino(e) {
    return {
      name: e.name,
      inputType: e.input_type,
      outputType: e.output_type,
      options: e != null && e.options ? MethodOptions.fromAmino(e.options) : void 0,
      clientStreaming: e.client_streaming,
      serverStreaming: e.server_streaming
    };
  },
  toAmino(e) {
    const n = {};
    return n.name = e.name, n.input_type = e.inputType, n.output_type = e.outputType, n.options = e.options ? MethodOptions.toAmino(e.options) : void 0, n.client_streaming = e.clientStreaming, n.server_streaming = e.serverStreaming, n;
  },
  fromAminoMsg(e) {
    return MethodDescriptorProto.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return MethodDescriptorProto.decode(e.value);
  },
  toProto(e) {
    return MethodDescriptorProto.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.MethodDescriptorProto",
      value: MethodDescriptorProto.encode(e).finish()
    };
  }
};
function createBaseFileOptions() {
  return {
    javaPackage: "",
    javaOuterClassname: "",
    javaMultipleFiles: !1,
    javaGenerateEqualsAndHash: !1,
    javaStringCheckUtf8: !1,
    optimizeFor: 1,
    goPackage: "",
    ccGenericServices: !1,
    javaGenericServices: !1,
    pyGenericServices: !1,
    phpGenericServices: !1,
    deprecated: !1,
    ccEnableArenas: !1,
    objcClassPrefix: "",
    csharpNamespace: "",
    swiftPrefix: "",
    phpClassPrefix: "",
    phpNamespace: "",
    phpMetadataNamespace: "",
    rubyPackage: "",
    uninterpretedOption: []
  };
}
const FileOptions = {
  typeUrl: "/google.protobuf.FileOptions",
  encode(e, n = minimal.Writer.create()) {
    e.javaPackage !== "" && n.uint32(10).string(e.javaPackage), e.javaOuterClassname !== "" && n.uint32(66).string(e.javaOuterClassname), e.javaMultipleFiles === !0 && n.uint32(80).bool(e.javaMultipleFiles), e.javaGenerateEqualsAndHash === !0 && n.uint32(160).bool(e.javaGenerateEqualsAndHash), e.javaStringCheckUtf8 === !0 && n.uint32(216).bool(e.javaStringCheckUtf8), e.optimizeFor !== 1 && n.uint32(72).int32(e.optimizeFor), e.goPackage !== "" && n.uint32(90).string(e.goPackage), e.ccGenericServices === !0 && n.uint32(128).bool(e.ccGenericServices), e.javaGenericServices === !0 && n.uint32(136).bool(e.javaGenericServices), e.pyGenericServices === !0 && n.uint32(144).bool(e.pyGenericServices), e.phpGenericServices === !0 && n.uint32(336).bool(e.phpGenericServices), e.deprecated === !0 && n.uint32(184).bool(e.deprecated), e.ccEnableArenas === !0 && n.uint32(248).bool(e.ccEnableArenas), e.objcClassPrefix !== "" && n.uint32(290).string(e.objcClassPrefix), e.csharpNamespace !== "" && n.uint32(298).string(e.csharpNamespace), e.swiftPrefix !== "" && n.uint32(314).string(e.swiftPrefix), e.phpClassPrefix !== "" && n.uint32(322).string(e.phpClassPrefix), e.phpNamespace !== "" && n.uint32(330).string(e.phpNamespace), e.phpMetadataNamespace !== "" && n.uint32(354).string(e.phpMetadataNamespace), e.rubyPackage !== "" && n.uint32(362).string(e.rubyPackage);
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFileOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.javaPackage = o.string();
          break;
        case 8:
          c.javaOuterClassname = o.string();
          break;
        case 10:
          c.javaMultipleFiles = o.bool();
          break;
        case 20:
          c.javaGenerateEqualsAndHash = o.bool();
          break;
        case 27:
          c.javaStringCheckUtf8 = o.bool();
          break;
        case 9:
          c.optimizeFor = o.int32();
          break;
        case 11:
          c.goPackage = o.string();
          break;
        case 16:
          c.ccGenericServices = o.bool();
          break;
        case 17:
          c.javaGenericServices = o.bool();
          break;
        case 18:
          c.pyGenericServices = o.bool();
          break;
        case 42:
          c.phpGenericServices = o.bool();
          break;
        case 23:
          c.deprecated = o.bool();
          break;
        case 31:
          c.ccEnableArenas = o.bool();
          break;
        case 36:
          c.objcClassPrefix = o.string();
          break;
        case 37:
          c.csharpNamespace = o.string();
          break;
        case 39:
          c.swiftPrefix = o.string();
          break;
        case 40:
          c.phpClassPrefix = o.string();
          break;
        case 41:
          c.phpNamespace = o.string();
          break;
        case 44:
          c.phpMetadataNamespace = o.string();
          break;
        case 45:
          c.rubyPackage = o.string();
          break;
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v, S, $, E, O, T, y, V, M, G, k, F, X, ee, ue;
    const Q = createBaseFileOptions();
    return Q.javaPackage = (n = e.javaPackage) !== null && n !== void 0 ? n : "", Q.javaOuterClassname = (o = e.javaOuterClassname) !== null && o !== void 0 ? o : "", Q.javaMultipleFiles = (u = e.javaMultipleFiles) !== null && u !== void 0 ? u : !1, Q.javaGenerateEqualsAndHash = (c = e.javaGenerateEqualsAndHash) !== null && c !== void 0 ? c : !1, Q.javaStringCheckUtf8 = (d = e.javaStringCheckUtf8) !== null && d !== void 0 ? d : !1, Q.optimizeFor = (m = e.optimizeFor) !== null && m !== void 0 ? m : 1, Q.goPackage = (v = e.goPackage) !== null && v !== void 0 ? v : "", Q.ccGenericServices = (S = e.ccGenericServices) !== null && S !== void 0 ? S : !1, Q.javaGenericServices = ($ = e.javaGenericServices) !== null && $ !== void 0 ? $ : !1, Q.pyGenericServices = (E = e.pyGenericServices) !== null && E !== void 0 ? E : !1, Q.phpGenericServices = (O = e.phpGenericServices) !== null && O !== void 0 ? O : !1, Q.deprecated = (T = e.deprecated) !== null && T !== void 0 ? T : !1, Q.ccEnableArenas = (y = e.ccEnableArenas) !== null && y !== void 0 ? y : !1, Q.objcClassPrefix = (V = e.objcClassPrefix) !== null && V !== void 0 ? V : "", Q.csharpNamespace = (M = e.csharpNamespace) !== null && M !== void 0 ? M : "", Q.swiftPrefix = (G = e.swiftPrefix) !== null && G !== void 0 ? G : "", Q.phpClassPrefix = (k = e.phpClassPrefix) !== null && k !== void 0 ? k : "", Q.phpNamespace = (F = e.phpNamespace) !== null && F !== void 0 ? F : "", Q.phpMetadataNamespace = (X = e.phpMetadataNamespace) !== null && X !== void 0 ? X : "", Q.rubyPackage = (ee = e.rubyPackage) !== null && ee !== void 0 ? ee : "", Q.uninterpretedOption = ((ue = e.uninterpretedOption) === null || ue === void 0 ? void 0 : ue.map((Y) => UninterpretedOption.fromPartial(Y))) || [], Q;
  },
  fromAmino(e) {
    return {
      javaPackage: e.java_package,
      javaOuterClassname: e.java_outer_classname,
      javaMultipleFiles: e.java_multiple_files,
      javaGenerateEqualsAndHash: e.java_generate_equals_and_hash,
      javaStringCheckUtf8: e.java_string_check_utf8,
      optimizeFor: isSet(e.optimize_for) ? fileOptions_OptimizeModeFromJSON(e.optimize_for) : 0,
      goPackage: e.go_package,
      ccGenericServices: e.cc_generic_services,
      javaGenericServices: e.java_generic_services,
      pyGenericServices: e.py_generic_services,
      phpGenericServices: e.php_generic_services,
      deprecated: e.deprecated,
      ccEnableArenas: e.cc_enable_arenas,
      objcClassPrefix: e.objc_class_prefix,
      csharpNamespace: e.csharp_namespace,
      swiftPrefix: e.swift_prefix,
      phpClassPrefix: e.php_class_prefix,
      phpNamespace: e.php_namespace,
      phpMetadataNamespace: e.php_metadata_namespace,
      rubyPackage: e.ruby_package,
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.java_package = e.javaPackage, n.java_outer_classname = e.javaOuterClassname, n.java_multiple_files = e.javaMultipleFiles, n.java_generate_equals_and_hash = e.javaGenerateEqualsAndHash, n.java_string_check_utf8 = e.javaStringCheckUtf8, n.optimize_for = e.optimizeFor, n.go_package = e.goPackage, n.cc_generic_services = e.ccGenericServices, n.java_generic_services = e.javaGenericServices, n.py_generic_services = e.pyGenericServices, n.php_generic_services = e.phpGenericServices, n.deprecated = e.deprecated, n.cc_enable_arenas = e.ccEnableArenas, n.objc_class_prefix = e.objcClassPrefix, n.csharp_namespace = e.csharpNamespace, n.swift_prefix = e.swiftPrefix, n.php_class_prefix = e.phpClassPrefix, n.php_namespace = e.phpNamespace, n.php_metadata_namespace = e.phpMetadataNamespace, n.ruby_package = e.rubyPackage, e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return FileOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return FileOptions.decode(e.value);
  },
  toProto(e) {
    return FileOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.FileOptions",
      value: FileOptions.encode(e).finish()
    };
  }
};
function createBaseMessageOptions() {
  return {
    messageSetWireFormat: !1,
    noStandardDescriptorAccessor: !1,
    deprecated: !1,
    mapEntry: !1,
    uninterpretedOption: []
  };
}
const MessageOptions = {
  typeUrl: "/google.protobuf.MessageOptions",
  encode(e, n = minimal.Writer.create()) {
    e.messageSetWireFormat === !0 && n.uint32(8).bool(e.messageSetWireFormat), e.noStandardDescriptorAccessor === !0 && n.uint32(16).bool(e.noStandardDescriptorAccessor), e.deprecated === !0 && n.uint32(24).bool(e.deprecated), e.mapEntry === !0 && n.uint32(56).bool(e.mapEntry);
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMessageOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.messageSetWireFormat = o.bool();
          break;
        case 2:
          c.noStandardDescriptorAccessor = o.bool();
          break;
        case 3:
          c.deprecated = o.bool();
          break;
        case 7:
          c.mapEntry = o.bool();
          break;
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseMessageOptions();
    return m.messageSetWireFormat = (n = e.messageSetWireFormat) !== null && n !== void 0 ? n : !1, m.noStandardDescriptorAccessor = (o = e.noStandardDescriptorAccessor) !== null && o !== void 0 ? o : !1, m.deprecated = (u = e.deprecated) !== null && u !== void 0 ? u : !1, m.mapEntry = (c = e.mapEntry) !== null && c !== void 0 ? c : !1, m.uninterpretedOption = ((d = e.uninterpretedOption) === null || d === void 0 ? void 0 : d.map((v) => UninterpretedOption.fromPartial(v))) || [], m;
  },
  fromAmino(e) {
    return {
      messageSetWireFormat: e.message_set_wire_format,
      noStandardDescriptorAccessor: e.no_standard_descriptor_accessor,
      deprecated: e.deprecated,
      mapEntry: e.map_entry,
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.message_set_wire_format = e.messageSetWireFormat, n.no_standard_descriptor_accessor = e.noStandardDescriptorAccessor, n.deprecated = e.deprecated, n.map_entry = e.mapEntry, e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return MessageOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return MessageOptions.decode(e.value);
  },
  toProto(e) {
    return MessageOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.MessageOptions",
      value: MessageOptions.encode(e).finish()
    };
  }
};
function createBaseFieldOptions() {
  return {
    ctype: 1,
    packed: !1,
    jstype: 1,
    lazy: !1,
    deprecated: !1,
    weak: !1,
    uninterpretedOption: []
  };
}
const FieldOptions = {
  typeUrl: "/google.protobuf.FieldOptions",
  encode(e, n = minimal.Writer.create()) {
    e.ctype !== 1 && n.uint32(8).int32(e.ctype), e.packed === !0 && n.uint32(16).bool(e.packed), e.jstype !== 1 && n.uint32(48).int32(e.jstype), e.lazy === !0 && n.uint32(40).bool(e.lazy), e.deprecated === !0 && n.uint32(24).bool(e.deprecated), e.weak === !0 && n.uint32(80).bool(e.weak);
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseFieldOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.ctype = o.int32();
          break;
        case 2:
          c.packed = o.bool();
          break;
        case 6:
          c.jstype = o.int32();
          break;
        case 5:
          c.lazy = o.bool();
          break;
        case 3:
          c.deprecated = o.bool();
          break;
        case 10:
          c.weak = o.bool();
          break;
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d, m, v;
    const S = createBaseFieldOptions();
    return S.ctype = (n = e.ctype) !== null && n !== void 0 ? n : 1, S.packed = (o = e.packed) !== null && o !== void 0 ? o : !1, S.jstype = (u = e.jstype) !== null && u !== void 0 ? u : 1, S.lazy = (c = e.lazy) !== null && c !== void 0 ? c : !1, S.deprecated = (d = e.deprecated) !== null && d !== void 0 ? d : !1, S.weak = (m = e.weak) !== null && m !== void 0 ? m : !1, S.uninterpretedOption = ((v = e.uninterpretedOption) === null || v === void 0 ? void 0 : v.map(($) => UninterpretedOption.fromPartial($))) || [], S;
  },
  fromAmino(e) {
    return {
      ctype: isSet(e.ctype) ? fieldOptions_CTypeFromJSON(e.ctype) : 0,
      packed: e.packed,
      jstype: isSet(e.jstype) ? fieldOptions_JSTypeFromJSON(e.jstype) : 0,
      lazy: e.lazy,
      deprecated: e.deprecated,
      weak: e.weak,
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.ctype = e.ctype, n.packed = e.packed, n.jstype = e.jstype, n.lazy = e.lazy, n.deprecated = e.deprecated, n.weak = e.weak, e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return FieldOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return FieldOptions.decode(e.value);
  },
  toProto(e) {
    return FieldOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.FieldOptions",
      value: FieldOptions.encode(e).finish()
    };
  }
};
function createBaseOneofOptions() {
  return {
    uninterpretedOption: []
  };
}
const OneofOptions = {
  typeUrl: "/google.protobuf.OneofOptions",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseOneofOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseOneofOptions();
    return o.uninterpretedOption = ((n = e.uninterpretedOption) === null || n === void 0 ? void 0 : n.map((u) => UninterpretedOption.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return OneofOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return OneofOptions.decode(e.value);
  },
  toProto(e) {
    return OneofOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.OneofOptions",
      value: OneofOptions.encode(e).finish()
    };
  }
};
function createBaseEnumOptions() {
  return {
    allowAlias: !1,
    deprecated: !1,
    uninterpretedOption: []
  };
}
const EnumOptions = {
  typeUrl: "/google.protobuf.EnumOptions",
  encode(e, n = minimal.Writer.create()) {
    e.allowAlias === !0 && n.uint32(16).bool(e.allowAlias), e.deprecated === !0 && n.uint32(24).bool(e.deprecated);
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEnumOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.allowAlias = o.bool();
          break;
        case 3:
          c.deprecated = o.bool();
          break;
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseEnumOptions();
    return c.allowAlias = (n = e.allowAlias) !== null && n !== void 0 ? n : !1, c.deprecated = (o = e.deprecated) !== null && o !== void 0 ? o : !1, c.uninterpretedOption = ((u = e.uninterpretedOption) === null || u === void 0 ? void 0 : u.map((d) => UninterpretedOption.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      allowAlias: e.allow_alias,
      deprecated: e.deprecated,
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.allow_alias = e.allowAlias, n.deprecated = e.deprecated, e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return EnumOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return EnumOptions.decode(e.value);
  },
  toProto(e) {
    return EnumOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.EnumOptions",
      value: EnumOptions.encode(e).finish()
    };
  }
};
function createBaseEnumValueOptions() {
  return {
    deprecated: !1,
    uninterpretedOption: []
  };
}
const EnumValueOptions = {
  typeUrl: "/google.protobuf.EnumValueOptions",
  encode(e, n = minimal.Writer.create()) {
    e.deprecated === !0 && n.uint32(8).bool(e.deprecated);
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEnumValueOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.deprecated = o.bool();
          break;
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseEnumValueOptions();
    return u.deprecated = (n = e.deprecated) !== null && n !== void 0 ? n : !1, u.uninterpretedOption = ((o = e.uninterpretedOption) === null || o === void 0 ? void 0 : o.map((c) => UninterpretedOption.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      deprecated: e.deprecated,
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.deprecated = e.deprecated, e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return EnumValueOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return EnumValueOptions.decode(e.value);
  },
  toProto(e) {
    return EnumValueOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.EnumValueOptions",
      value: EnumValueOptions.encode(e).finish()
    };
  }
};
function createBaseServiceOptions() {
  return {
    deprecated: !1,
    uninterpretedOption: []
  };
}
const ServiceOptions = {
  typeUrl: "/google.protobuf.ServiceOptions",
  encode(e, n = minimal.Writer.create()) {
    e.deprecated === !0 && n.uint32(264).bool(e.deprecated);
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseServiceOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 33:
          c.deprecated = o.bool();
          break;
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseServiceOptions();
    return u.deprecated = (n = e.deprecated) !== null && n !== void 0 ? n : !1, u.uninterpretedOption = ((o = e.uninterpretedOption) === null || o === void 0 ? void 0 : o.map((c) => UninterpretedOption.fromPartial(c))) || [], u;
  },
  fromAmino(e) {
    return {
      deprecated: e.deprecated,
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.deprecated = e.deprecated, e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return ServiceOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return ServiceOptions.decode(e.value);
  },
  toProto(e) {
    return ServiceOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.ServiceOptions",
      value: ServiceOptions.encode(e).finish()
    };
  }
};
function createBaseMethodOptions() {
  return {
    deprecated: !1,
    idempotencyLevel: 1,
    uninterpretedOption: []
  };
}
const MethodOptions = {
  typeUrl: "/google.protobuf.MethodOptions",
  encode(e, n = minimal.Writer.create()) {
    e.deprecated === !0 && n.uint32(264).bool(e.deprecated), e.idempotencyLevel !== 1 && n.uint32(272).int32(e.idempotencyLevel);
    for (const o of e.uninterpretedOption)
      UninterpretedOption.encode(o, n.uint32(7994).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseMethodOptions();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 33:
          c.deprecated = o.bool();
          break;
        case 34:
          c.idempotencyLevel = o.int32();
          break;
        case 999:
          c.uninterpretedOption.push(UninterpretedOption.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u;
    const c = createBaseMethodOptions();
    return c.deprecated = (n = e.deprecated) !== null && n !== void 0 ? n : !1, c.idempotencyLevel = (o = e.idempotencyLevel) !== null && o !== void 0 ? o : 1, c.uninterpretedOption = ((u = e.uninterpretedOption) === null || u === void 0 ? void 0 : u.map((d) => UninterpretedOption.fromPartial(d))) || [], c;
  },
  fromAmino(e) {
    return {
      deprecated: e.deprecated,
      idempotencyLevel: isSet(e.idempotency_level) ? methodOptions_IdempotencyLevelFromJSON(e.idempotency_level) : 0,
      uninterpretedOption: Array.isArray(e == null ? void 0 : e.uninterpreted_option) ? e.uninterpreted_option.map((n) => UninterpretedOption.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return n.deprecated = e.deprecated, n.idempotency_level = e.idempotencyLevel, e.uninterpretedOption ? n.uninterpreted_option = e.uninterpretedOption.map((o) => o ? UninterpretedOption.toAmino(o) : void 0) : n.uninterpreted_option = [], n;
  },
  fromAminoMsg(e) {
    return MethodOptions.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return MethodOptions.decode(e.value);
  },
  toProto(e) {
    return MethodOptions.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.MethodOptions",
      value: MethodOptions.encode(e).finish()
    };
  }
};
function createBaseUninterpretedOption() {
  return {
    name: [],
    identifierValue: "",
    positiveIntValue: Long$2.UZERO,
    negativeIntValue: Long$2.ZERO,
    doubleValue: 0,
    stringValue: new Uint8Array(),
    aggregateValue: ""
  };
}
const UninterpretedOption = {
  typeUrl: "/google.protobuf.UninterpretedOption",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.name)
      UninterpretedOption_NamePart.encode(o, n.uint32(18).fork()).ldelim();
    return e.identifierValue !== "" && n.uint32(26).string(e.identifierValue), e.positiveIntValue.isZero() || n.uint32(32).uint64(e.positiveIntValue), e.negativeIntValue.isZero() || n.uint32(40).int64(e.negativeIntValue), e.doubleValue !== 0 && n.uint32(49).double(e.doubleValue), e.stringValue.length !== 0 && n.uint32(58).bytes(e.stringValue), e.aggregateValue !== "" && n.uint32(66).string(e.aggregateValue), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUninterpretedOption();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 2:
          c.name.push(UninterpretedOption_NamePart.decode(o, o.uint32()));
          break;
        case 3:
          c.identifierValue = o.string();
          break;
        case 4:
          c.positiveIntValue = o.uint64();
          break;
        case 5:
          c.negativeIntValue = o.int64();
          break;
        case 6:
          c.doubleValue = o.double();
          break;
        case 7:
          c.stringValue = o.bytes();
          break;
        case 8:
          c.aggregateValue = o.string();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseUninterpretedOption();
    return m.name = ((n = e.name) === null || n === void 0 ? void 0 : n.map((v) => UninterpretedOption_NamePart.fromPartial(v))) || [], m.identifierValue = (o = e.identifierValue) !== null && o !== void 0 ? o : "", m.positiveIntValue = e.positiveIntValue !== void 0 && e.positiveIntValue !== null ? Long$2.fromValue(e.positiveIntValue) : Long$2.UZERO, m.negativeIntValue = e.negativeIntValue !== void 0 && e.negativeIntValue !== null ? Long$2.fromValue(e.negativeIntValue) : Long$2.ZERO, m.doubleValue = (u = e.doubleValue) !== null && u !== void 0 ? u : 0, m.stringValue = (c = e.stringValue) !== null && c !== void 0 ? c : new Uint8Array(), m.aggregateValue = (d = e.aggregateValue) !== null && d !== void 0 ? d : "", m;
  },
  fromAmino(e) {
    return {
      name: Array.isArray(e == null ? void 0 : e.name) ? e.name.map((n) => UninterpretedOption_NamePart.fromAmino(n)) : [],
      identifierValue: e.identifier_value,
      positiveIntValue: Long$2.fromString(e.positive_int_value),
      negativeIntValue: Long$2.fromString(e.negative_int_value),
      doubleValue: e.double_value,
      stringValue: e.string_value,
      aggregateValue: e.aggregate_value
    };
  },
  toAmino(e) {
    const n = {};
    return e.name ? n.name = e.name.map((o) => o ? UninterpretedOption_NamePart.toAmino(o) : void 0) : n.name = [], n.identifier_value = e.identifierValue, n.positive_int_value = e.positiveIntValue ? e.positiveIntValue.toString() : void 0, n.negative_int_value = e.negativeIntValue ? e.negativeIntValue.toString() : void 0, n.double_value = e.doubleValue, n.string_value = e.stringValue, n.aggregate_value = e.aggregateValue, n;
  },
  fromAminoMsg(e) {
    return UninterpretedOption.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return UninterpretedOption.decode(e.value);
  },
  toProto(e) {
    return UninterpretedOption.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.UninterpretedOption",
      value: UninterpretedOption.encode(e).finish()
    };
  }
};
function createBaseUninterpretedOption_NamePart() {
  return {
    namePart: "",
    isExtension: !1
  };
}
const UninterpretedOption_NamePart = {
  typeUrl: "/google.protobuf.NamePart",
  encode(e, n = minimal.Writer.create()) {
    return e.namePart !== "" && n.uint32(10).string(e.namePart), e.isExtension === !0 && n.uint32(16).bool(e.isExtension), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseUninterpretedOption_NamePart();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.namePart = o.string();
          break;
        case 2:
          c.isExtension = o.bool();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o;
    const u = createBaseUninterpretedOption_NamePart();
    return u.namePart = (n = e.namePart) !== null && n !== void 0 ? n : "", u.isExtension = (o = e.isExtension) !== null && o !== void 0 ? o : !1, u;
  },
  fromAmino(e) {
    return {
      namePart: e.name_part,
      isExtension: e.is_extension
    };
  },
  toAmino(e) {
    const n = {};
    return n.name_part = e.namePart, n.is_extension = e.isExtension, n;
  },
  fromAminoMsg(e) {
    return UninterpretedOption_NamePart.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return UninterpretedOption_NamePart.decode(e.value);
  },
  toProto(e) {
    return UninterpretedOption_NamePart.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.NamePart",
      value: UninterpretedOption_NamePart.encode(e).finish()
    };
  }
};
function createBaseSourceCodeInfo() {
  return {
    location: []
  };
}
const SourceCodeInfo = {
  typeUrl: "/google.protobuf.SourceCodeInfo",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.location)
      SourceCodeInfo_Location.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSourceCodeInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.location.push(SourceCodeInfo_Location.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseSourceCodeInfo();
    return o.location = ((n = e.location) === null || n === void 0 ? void 0 : n.map((u) => SourceCodeInfo_Location.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      location: Array.isArray(e == null ? void 0 : e.location) ? e.location.map((n) => SourceCodeInfo_Location.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.location ? n.location = e.location.map((o) => o ? SourceCodeInfo_Location.toAmino(o) : void 0) : n.location = [], n;
  },
  fromAminoMsg(e) {
    return SourceCodeInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return SourceCodeInfo.decode(e.value);
  },
  toProto(e) {
    return SourceCodeInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.SourceCodeInfo",
      value: SourceCodeInfo.encode(e).finish()
    };
  }
};
function createBaseSourceCodeInfo_Location() {
  return {
    path: [],
    span: [],
    leadingComments: "",
    trailingComments: "",
    leadingDetachedComments: []
  };
}
const SourceCodeInfo_Location = {
  typeUrl: "/google.protobuf.Location",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.path)
      n.int32(o);
    n.ldelim(), n.uint32(18).fork();
    for (const o of e.span)
      n.int32(o);
    n.ldelim(), e.leadingComments !== "" && n.uint32(26).string(e.leadingComments), e.trailingComments !== "" && n.uint32(34).string(e.trailingComments);
    for (const o of e.leadingDetachedComments)
      n.uint32(50).string(o);
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseSourceCodeInfo_Location();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.path.push(o.int32());
          } else
            c.path.push(o.int32());
          break;
        case 2:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.span.push(o.int32());
          } else
            c.span.push(o.int32());
          break;
        case 3:
          c.leadingComments = o.string();
          break;
        case 4:
          c.trailingComments = o.string();
          break;
        case 6:
          c.leadingDetachedComments.push(o.string());
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c, d;
    const m = createBaseSourceCodeInfo_Location();
    return m.path = ((n = e.path) === null || n === void 0 ? void 0 : n.map((v) => v)) || [], m.span = ((o = e.span) === null || o === void 0 ? void 0 : o.map((v) => v)) || [], m.leadingComments = (u = e.leadingComments) !== null && u !== void 0 ? u : "", m.trailingComments = (c = e.trailingComments) !== null && c !== void 0 ? c : "", m.leadingDetachedComments = ((d = e.leadingDetachedComments) === null || d === void 0 ? void 0 : d.map((v) => v)) || [], m;
  },
  fromAmino(e) {
    return {
      path: Array.isArray(e == null ? void 0 : e.path) ? e.path.map((n) => n) : [],
      span: Array.isArray(e == null ? void 0 : e.span) ? e.span.map((n) => n) : [],
      leadingComments: e.leading_comments,
      trailingComments: e.trailing_comments,
      leadingDetachedComments: Array.isArray(e == null ? void 0 : e.leading_detached_comments) ? e.leading_detached_comments.map((n) => n) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.path ? n.path = e.path.map((o) => o) : n.path = [], e.span ? n.span = e.span.map((o) => o) : n.span = [], n.leading_comments = e.leadingComments, n.trailing_comments = e.trailingComments, e.leadingDetachedComments ? n.leading_detached_comments = e.leadingDetachedComments.map((o) => o) : n.leading_detached_comments = [], n;
  },
  fromAminoMsg(e) {
    return SourceCodeInfo_Location.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return SourceCodeInfo_Location.decode(e.value);
  },
  toProto(e) {
    return SourceCodeInfo_Location.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.Location",
      value: SourceCodeInfo_Location.encode(e).finish()
    };
  }
};
function createBaseGeneratedCodeInfo() {
  return {
    annotation: []
  };
}
const GeneratedCodeInfo = {
  typeUrl: "/google.protobuf.GeneratedCodeInfo",
  encode(e, n = minimal.Writer.create()) {
    for (const o of e.annotation)
      GeneratedCodeInfo_Annotation.encode(o, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGeneratedCodeInfo();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          c.annotation.push(GeneratedCodeInfo_Annotation.decode(o, o.uint32()));
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n;
    const o = createBaseGeneratedCodeInfo();
    return o.annotation = ((n = e.annotation) === null || n === void 0 ? void 0 : n.map((u) => GeneratedCodeInfo_Annotation.fromPartial(u))) || [], o;
  },
  fromAmino(e) {
    return {
      annotation: Array.isArray(e == null ? void 0 : e.annotation) ? e.annotation.map((n) => GeneratedCodeInfo_Annotation.fromAmino(n)) : []
    };
  },
  toAmino(e) {
    const n = {};
    return e.annotation ? n.annotation = e.annotation.map((o) => o ? GeneratedCodeInfo_Annotation.toAmino(o) : void 0) : n.annotation = [], n;
  },
  fromAminoMsg(e) {
    return GeneratedCodeInfo.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return GeneratedCodeInfo.decode(e.value);
  },
  toProto(e) {
    return GeneratedCodeInfo.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.GeneratedCodeInfo",
      value: GeneratedCodeInfo.encode(e).finish()
    };
  }
};
function createBaseGeneratedCodeInfo_Annotation() {
  return {
    path: [],
    sourceFile: "",
    begin: 0,
    end: 0
  };
}
const GeneratedCodeInfo_Annotation = {
  typeUrl: "/google.protobuf.Annotation",
  encode(e, n = minimal.Writer.create()) {
    n.uint32(10).fork();
    for (const o of e.path)
      n.int32(o);
    return n.ldelim(), e.sourceFile !== "" && n.uint32(18).string(e.sourceFile), e.begin !== 0 && n.uint32(24).int32(e.begin), e.end !== 0 && n.uint32(32).int32(e.end), n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseGeneratedCodeInfo_Annotation();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        case 1:
          if ((d & 7) === 2) {
            const m = o.uint32() + o.pos;
            for (; o.pos < m; )
              c.path.push(o.int32());
          } else
            c.path.push(o.int32());
          break;
        case 2:
          c.sourceFile = o.string();
          break;
        case 3:
          c.begin = o.int32();
          break;
        case 4:
          c.end = o.int32();
          break;
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    var n, o, u, c;
    const d = createBaseGeneratedCodeInfo_Annotation();
    return d.path = ((n = e.path) === null || n === void 0 ? void 0 : n.map((m) => m)) || [], d.sourceFile = (o = e.sourceFile) !== null && o !== void 0 ? o : "", d.begin = (u = e.begin) !== null && u !== void 0 ? u : 0, d.end = (c = e.end) !== null && c !== void 0 ? c : 0, d;
  },
  fromAmino(e) {
    return {
      path: Array.isArray(e == null ? void 0 : e.path) ? e.path.map((n) => n) : [],
      sourceFile: e.source_file,
      begin: e.begin,
      end: e.end
    };
  },
  toAmino(e) {
    const n = {};
    return e.path ? n.path = e.path.map((o) => o) : n.path = [], n.source_file = e.sourceFile, n.begin = e.begin, n.end = e.end, n;
  },
  fromAminoMsg(e) {
    return GeneratedCodeInfo_Annotation.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return GeneratedCodeInfo_Annotation.decode(e.value);
  },
  toProto(e) {
    return GeneratedCodeInfo_Annotation.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.Annotation",
      value: GeneratedCodeInfo_Annotation.encode(e).finish()
    };
  }
}, _184 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DescriptorProto,
  DescriptorProto_ExtensionRange,
  DescriptorProto_ReservedRange,
  EnumDescriptorProto,
  EnumDescriptorProto_EnumReservedRange,
  EnumOptions,
  EnumValueDescriptorProto,
  EnumValueOptions,
  ExtensionRangeOptions,
  FieldDescriptorProto,
  get FieldDescriptorProto_Label() {
    return FieldDescriptorProto_Label;
  },
  FieldDescriptorProto_LabelAmino,
  FieldDescriptorProto_LabelSDKType,
  get FieldDescriptorProto_Type() {
    return FieldDescriptorProto_Type;
  },
  FieldDescriptorProto_TypeAmino,
  FieldDescriptorProto_TypeSDKType,
  FieldOptions,
  get FieldOptions_CType() {
    return FieldOptions_CType;
  },
  FieldOptions_CTypeAmino,
  FieldOptions_CTypeSDKType,
  get FieldOptions_JSType() {
    return FieldOptions_JSType;
  },
  FieldOptions_JSTypeAmino,
  FieldOptions_JSTypeSDKType,
  FileDescriptorProto,
  FileDescriptorSet,
  FileOptions,
  get FileOptions_OptimizeMode() {
    return FileOptions_OptimizeMode;
  },
  FileOptions_OptimizeModeAmino,
  FileOptions_OptimizeModeSDKType,
  GeneratedCodeInfo,
  GeneratedCodeInfo_Annotation,
  MessageOptions,
  MethodDescriptorProto,
  MethodOptions,
  get MethodOptions_IdempotencyLevel() {
    return MethodOptions_IdempotencyLevel;
  },
  MethodOptions_IdempotencyLevelAmino,
  MethodOptions_IdempotencyLevelSDKType,
  OneofDescriptorProto,
  OneofOptions,
  ServiceDescriptorProto,
  ServiceOptions,
  SourceCodeInfo,
  SourceCodeInfo_Location,
  UninterpretedOption,
  UninterpretedOption_NamePart,
  fieldDescriptorProto_LabelFromJSON,
  fieldDescriptorProto_LabelToJSON,
  fieldDescriptorProto_TypeFromJSON,
  fieldDescriptorProto_TypeToJSON,
  fieldOptions_CTypeFromJSON,
  fieldOptions_CTypeToJSON,
  fieldOptions_JSTypeFromJSON,
  fieldOptions_JSTypeToJSON,
  fileOptions_OptimizeModeFromJSON,
  fileOptions_OptimizeModeToJSON,
  methodOptions_IdempotencyLevelFromJSON,
  methodOptions_IdempotencyLevelToJSON
}, Symbol.toStringTag, { value: "Module" }));
function createBaseEmpty() {
  return {};
}
const Empty = {
  typeUrl: "/google.protobuf.Empty",
  encode(e, n = minimal.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const o = e instanceof minimal.Reader ? e : new minimal.Reader(e);
    let u = n === void 0 ? o.len : o.pos + n;
    const c = createBaseEmpty();
    for (; o.pos < u; ) {
      const d = o.uint32();
      switch (d >>> 3) {
        default:
          o.skipType(d & 7);
          break;
      }
    }
    return c;
  },
  fromPartial(e) {
    return createBaseEmpty();
  },
  fromAmino(e) {
    return {};
  },
  toAmino(e) {
    return {};
  },
  fromAminoMsg(e) {
    return Empty.fromAmino(e.value);
  },
  fromProtoMsg(e) {
    return Empty.decode(e.value);
  },
  toProto(e) {
    return Empty.encode(e).finish();
  },
  toProtoMsg(e) {
    return {
      typeUrl: "/google.protobuf.Empty",
      value: Empty.encode(e).finish()
    };
  }
}, _186 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Empty
}, Symbol.toStringTag, { value: "Module" }));
function ownKeys(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    n && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, u);
  }
  return o;
}
function _objectSpread(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ownKeys(Object(o), !0).forEach(function(u) {
      _defineProperty(e, u, o[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys(Object(o)).forEach(function(u) {
      Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(o, u));
    });
  }
  return e;
}
let google;
(function(e) {
  e.protobuf = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _183), _184), _185), _186), _187);
})(google || (google = {}));
const tokens = [
  {
    denom: "uosmo",
    symbol: "OSMO",
    ibcDenom: "uosmo",
    // use base denom for native token 
    decimals: 6,
    coinImageUrl: "https://app.osmosis.zone/tokens/osmo.svg"
  },
  {
    denom: "uatom",
    symbol: "ATOM",
    ibcDenom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
    sourceChannelId: "channel-0",
    destChannelId: "channel-141",
    decimals: 6,
    coinImageUrl: "https://app.osmosis.zone/tokens/atom.svg"
  },
  {
    denom: "uusdc",
    symbol: "USDC",
    ibcDenom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858",
    sourceChannelId: "channel-208",
    destChannelId: "",
    decimals: 6,
    coinImageUrl: "https://app.osmosis.zone/tokens/usdc.svg"
  }
], _hoisted_1$1 = {
  for: "PingTokenConvert",
  class: "modal cursor-pointer"
}, _hoisted_2$1 = {
  class: "modal-box dark:bg-[#2a2a3a] rounded-lg",
  for: ""
}, _hoisted_3$1 = /* @__PURE__ */ createStaticVNode('<div class="absolute right-4 top-4 dropdown dropdown-end dropdown-hover"><label tabindex="0" class="text-info"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="w-6 h-6 stroke-current"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></label><div tabindex="0" class="card compact dropdown-content dark:bg-info-content bg-slate-300 shadow rounded-box w-64 z-40"><div class="card-body"><ul class="text-right"><li>Liquidity is provided by Osmosis</li><li>Powered by Ping.pub</li></ul></div></div></div><h3 class="text-xl font-semibold">Token Convert</h3>', 2), _hoisted_5$1 = {
  key: 0,
  class: "text-error mt-3"
}, _hoisted_6$1 = { class: "flex items-center relative h-14 bg-gray-100 dark:bg-[#232333] rounded-tl-lg rounded-tr-lg mt-4" }, _hoisted_7$1 = { class: "dropdown" }, _hoisted_8$1 = {
  tabindex: "0",
  class: "flex items-center h-12 px-4 cursor-pointer"
}, _hoisted_9$1 = ["src"], _hoisted_10$1 = { class: "text-lg font-semibold mr-2" }, _hoisted_11$1 = {
  tabindex: "0",
  class: "dropdown-content shadow bg-base-100 rounded-lg w-64 z-40"
}, _hoisted_12$1 = { class: "py-2" }, _hoisted_13$1 = ["onClick"], _hoisted_14$1 = ["src"], _hoisted_15$1 = { class: "flex-1 text-sm" }, _hoisted_16$1 = { class: "text-sm font-semibold text-gray-600" }, _hoisted_17$1 = { class: "flex items-center py-2 px-4 bg-gray-200 dark:bg-[#171721] rounded-bl-lg rounded-br-lg" }, _hoisted_18$1 = /* @__PURE__ */ createBaseVNode("div", { class: "mr-3 text-sm" }, "Balance:", -1), _hoisted_19$1 = { class: "text-base font-semibold" }, _hoisted_20$1 = { class: "flex items-center justify-center -mt-3 -mb-3" }, _hoisted_21$1 = { class: "flex items-center h-14 rounded-tl-lg rounded-tr-lg bg-gray-100 dark:bg-[#232333]" }, _hoisted_22$1 = { key: 0 }, _hoisted_23$1 = {
  key: 0,
  class: "text-red-500"
}, _hoisted_24$1 = {
  key: 1,
  class: "dropdown"
}, _hoisted_25$1 = {
  tabindex: "0",
  class: "flex items-center h-12 px-4 cursor-pointer"
}, _hoisted_26$1 = ["src"], _hoisted_27$1 = { class: "text-lg font-semibold mr-2" }, _hoisted_28$1 = {
  tabindex: "0",
  class: "compact dropdown-content shadow bg-base-100 w-64 rounded-lg"
}, _hoisted_29$1 = { class: "py-2 max-h-40 overflow-y-auto" }, _hoisted_30$1 = ["onClick"], _hoisted_31$1 = ["src"], _hoisted_32$1 = { class: "flex-1 text-sm" }, _hoisted_33$1 = { class: "text-sm font-semibold text-gray-600" }, _hoisted_34$1 = { class: "flex-1 w-0 text-xl text-right font-semibold text-gray-600 dark:text-gray-50 pr-4" }, _hoisted_35$1 = { class: "flex items-center py-2 px-4 bg-gray-200 dark:bg-[#171721] rounded-bl-lg rounded-br-lg" }, _hoisted_36$1 = /* @__PURE__ */ createBaseVNode("div", { class: "mr-3 text-sm dark:text-gray-400" }, " Balance: ", -1), _hoisted_37$1 = { class: "text-base font-semibold dark:text-gray-200" }, _hoisted_38$1 = { class: "px-4 mt-4" }, _hoisted_39$1 = { class: "flex items-center justify-between" }, _hoisted_40$1 = /* @__PURE__ */ createBaseVNode("div", { class: "text-sm text-gray-600 dark:text-gray-400" }, " Swap Fee ", -1), _hoisted_41$1 = { class: "text-base text-gray-800 dark:text-gray-200" }, _hoisted_42 = {
  key: 1,
  class: "text-error mt-3"
}, _hoisted_43 = { class: "mt-5" }, _hoisted_44 = ["disabled"], _hoisted_45 = {
  key: 0,
  class: "loading loading-spinner"
}, _hoisted_46 = { class: "text-xl font-semibold flex" }, _hoisted_47 = { class: "form-control" }, _hoisted_48 = { class: "label" }, _hoisted_49 = /* @__PURE__ */ createBaseVNode("span", { class: "label-text" }, "Deposit assets into Osmosis:", -1), _hoisted_50 = { class: "lable-text" }, _hoisted_51 = ["value"], _hoisted_52 = { class: "flex items-center relative h-14 bg-gray-100 dark:bg-[#232333] rounded-tl-lg rounded-tr-lg mt-4" }, _hoisted_53 = {
  tabindex: "0",
  class: "flex items-center h-12 px-4 cursor-pointer"
}, _hoisted_54 = ["src"], _hoisted_55 = { class: "text-lg font-semibold mr-2" }, _hoisted_56 = { class: "flex flex-row-reverse items-center py-2 px-4 bg-gray-200 dark:bg-[#171721] rounded-bl-lg rounded-br-lg" }, _hoisted_57 = { class: "text-base font-semibold" }, _hoisted_58 = /* @__PURE__ */ createBaseVNode("div", { class: "mr-3 text-sm" }, "Balance:", -1), _hoisted_59 = {
  key: 0,
  class: "text-error mt-3"
}, _hoisted_60 = { class: "mt-5 flex" }, _hoisted_61 = /* @__PURE__ */ createBaseVNode("svg", {
  fill: "#ffffff",
  height: "20px",
  width: "20px",
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 330 330",
  "xml:space": "preserve"
}, [
  /* @__PURE__ */ createBaseVNode("g", {
    id: "SVGRepo_bgCarrier",
    "stroke-width": "0"
  }),
  /* @__PURE__ */ createBaseVNode("g", {
    id: "SVGRepo_tracerCarrier",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /* @__PURE__ */ createBaseVNode("g", { id: "SVGRepo_iconCarrier" }, [
    /* @__PURE__ */ createBaseVNode("path", {
      id: "XMLID_6_",
      d: "M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M205.606,234.394 c5.858,5.857,5.858,15.355,0,21.213C202.678,258.535,198.839,260,195,260s-7.678-1.464-10.606-4.394l-80-79.998 c-2.813-2.813-4.394-6.628-4.394-10.606c0-3.978,1.58-7.794,4.394-10.607l80-80.002c5.857-5.858,15.355-5.858,21.213,0 c5.858,5.857,5.858,15.355,0,21.213l-69.393,69.396L205.606,234.394z"
    })
  ])
], -1), _hoisted_62 = [
  _hoisted_61
], _hoisted_63 = ["disabled"], _hoisted_64 = {
  key: 0,
  class: "loading loading-spinner"
}, _hoisted_65 = { class: "text-xl font-semibold flex" }, _hoisted_66 = { class: "flex justify-between j items-center py-2 px-4 bg-gray-200 dark:bg-[#171721] rounded-tl-lg rounded-tr-lg mt-4" }, _hoisted_67 = /* @__PURE__ */ createBaseVNode("div", { class: "text-sm" }, "Withdrawable Balance:", -1), _hoisted_68 = { class: "text-base font-semibold" }, _hoisted_69 = { class: "flex items-center relative h-14 bg-gray-100 dark:bg-[#232333] rounded-bl-lg rounded-br-lg" }, _hoisted_70 = {
  tabindex: "0",
  class: "flex items-center h-12 px-4 cursor-pointer"
}, _hoisted_71 = ["src"], _hoisted_72 = { class: "text-lg font-semibold mr-2" }, _hoisted_73 = { class: "form-control" }, _hoisted_74 = { class: "label" }, _hoisted_75 = { class: "label-text" }, _hoisted_76 = { class: "lable-text" }, _hoisted_77 = {
  key: 0,
  class: "text-error mt-3"
}, _hoisted_78 = { class: "mt-5 flex" }, _hoisted_79 = /* @__PURE__ */ createBaseVNode("svg", {
  fill: "#ffffff",
  height: "20px",
  width: "20px",
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 330 330",
  "xml:space": "preserve"
}, [
  /* @__PURE__ */ createBaseVNode("g", {
    id: "SVGRepo_bgCarrier",
    "stroke-width": "0"
  }),
  /* @__PURE__ */ createBaseVNode("g", {
    id: "SVGRepo_tracerCarrier",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /* @__PURE__ */ createBaseVNode("g", { id: "SVGRepo_iconCarrier" }, [
    /* @__PURE__ */ createBaseVNode("path", {
      id: "XMLID_6_",
      d: "M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M205.606,234.394 c5.858,5.857,5.858,15.355,0,21.213C202.678,258.535,198.839,260,195,260s-7.678-1.464-10.606-4.394l-80-79.998 c-2.813-2.813-4.394-6.628-4.394-10.606c0-3.978,1.58-7.794,4.394-10.607l80-80.002c5.857-5.858,15.355-5.858,21.213,0 c5.858,5.857,5.858,15.355,0,21.213l-69.393,69.396L205.606,234.394z"
    })
  ])
], -1), _hoisted_80 = [
  _hoisted_79
], _hoisted_81 = ["disabled"], _hoisted_82 = {
  key: 0,
  class: "loading loading-spinner"
}, _hoisted_83 = /* @__PURE__ */ createBaseVNode("h3", { class: "text-xl font-semibold flex" }, "Connect Wallet", -1), _hoisted_84 = /* @__PURE__ */ createBaseVNode("div", { class: "form-control mt-5" }, [
  /* @__PURE__ */ createBaseVNode("select", { class: "select" }, [
    /* @__PURE__ */ createBaseVNode("option", null, "Keplr")
  ])
], -1), _hoisted_85 = {
  key: 0,
  class: "text-error mt-3"
}, _hoisted_86 = { class: "mt-5" }, _hoisted_87 = {
  key: 0,
  class: "loading loading-spinner"
}, _hoisted_88 = { class: "mt-10 mb-6" }, _hoisted_89 = {
  key: 0,
  class: "my-5 text-center text-red-500"
}, _hoisted_90 = {
  key: 1,
  class: "my-5 text-center text-lg text-green-500"
}, _hoisted_91 = { class: "overflow-hidden h-5 mb-2 text-xs flex rounded bg-green-100" }, _hoisted_92 = { class: "flex items-center justify-between" }, _hoisted_93 = /* @__PURE__ */ createBaseVNode("div", null, [
  /* @__PURE__ */ createBaseVNode("span", { class: "text-xs font-semibold inline-block py-1 px-2 rounded text-gray-600 dark:text-white" }, " Submitted ")
], -1), _hoisted_94 = { class: "text-right" }, _hoisted_95 = { class: "text-xs font-semibold inline-block text-gray-600 dark:text-white" }, _hoisted_96 = { class: "mb-0 text-center" }, __default__$1 = {
  name: "TokenConvert"
}, _sfc_main$1 = /* @__PURE__ */ defineComponent({
  ...__default__$1,
  props: {
    chainName: { type: String, required: !0 },
    endpoint: { type: String, required: !0 },
    hdPath: String
  },
  emits: ["completed"],
  setup(e, { emit: n }) {
    const o = e, u = "https://rpc.osmosis.zone", c = "https://lcd.osmosis.zone", d = "m/44'/118/0'/0/0", m = ref("connect");
    function v($t) {
      m.value = $t;
    }
    const S = ref("buy"), $ = ref(!1), E = ref(!1), O = ref(""), T = ref([]), y = ref({}), V = ref({}), M = ref(""), G = ref({}), k = ref([]), F = ref([]), X = ref({}), ee = ref([]), ue = ref({}), Q = ref({}), Y = ref(""), pe = ref([]), oe = new ChainRegistryClient();
    async function ne() {
      if (O.value = "", G.value = readWallet(o.hdPath), !G.value.cosmosAddress) {
        m.value = "connect";
        return;
      }
      E.value && (m.value = "swap", X.value = {}, ee.value = [], kt.value = C(G.value.cosmosAddress), await oe.fetchChainInfo(o.chainName).then(($t) => {
        X.value = $t, Number($t.slip44) !== 118 && (O.value, `${$t.slip44}`);
      }).catch(() => {
        O.value = "Not found IBC Path";
      }), getBalance(c, H(G.value.cosmosAddress)).then(
        ($t) => {
          F.value = $t.balances.filter(
            (Lt) => !Lt.denom.startsWith("gamm")
          );
        }
      ), getBalance(
        o.endpoint,
        C(G.value.cosmosAddress)
      ).then(($t) => {
        k.value = $t.balances;
      }), oe.fetchAssetsList(o.chainName).then(($t) => {
        ee.value = $t.assets;
      }), getStakingParam(o.endpoint).then(($t) => {
        M.value = $t.params.bondDenom;
      }), getOsmosisPools(c).then(($t) => {
        pe.value = $t.pools;
      }), oe.fetchIBCPaths().then(($t) => {
        T.value = $t.filter(
          (Qn) => Qn.from === o.chainName || Qn.to === o.chainName
        );
        const Lt = T.value.find(
          (Qn) => Qn.from === "osmosis" || Qn.to === "osmosis"
        );
        Lt && (y.value = Lt, oe.fetchIBCPathInfo(Lt.path).then((Qn) => {
          V.value = Qn;
        }));
      }));
    }
    function H($t) {
      if (!$t)
        return "";
      const { data: Lt } = build$V.fromBech32($t);
      return build$V.toBech32("osmo", Lt);
    }
    function C($t) {
      var ce;
      if (!$t)
        return "";
      const { data: Lt } = build$V.fromBech32($t), Qn = ((ce = X.value) == null ? void 0 : ce.bech32_prefix) || "cosmos";
      return build$V.toBech32(Qn, Lt);
    }
    function w($t, Lt = 0) {
      const Qn = F.value.find((ce) => ce.denom === $t || "");
      return Qn ? Number(Qn.amount) / 10 ** Lt : 0;
    }
    function P($t) {
      const Lt = ee.value.find((Qn) => Qn.base === $t);
      if (Lt) {
        const Qn = Lt.denom_units.find(
          (ce) => ce.denom === Lt.symbol.toLowerCase()
        );
        if (Qn)
          return Qn.exponent;
      }
      return 0;
    }
    function J($t) {
      var Qn, ce, Ze;
      const Lt = ((Qn = $t == null ? void 0 : $t.logo_URIs) == null ? void 0 : Qn.svg) || ((ce = $t == null ? void 0 : $t.logo_URIs) == null ? void 0 : ce.png) || ((Ze = $t == null ? void 0 : $t.logo_URIs) == null ? void 0 : Ze.jpeg);
      return Lt ? Lt.replace(
        "https://raw.githubusercontent.com/cosmos/chain-registry/master",
        "https://registry.ping.pub"
      ) : "";
    }
    const se = computed(() => {
      var ce, Ze, ft;
      const $t = (ce = V.value.channels) == null ? void 0 : ce.find(
        (It) => It.chain_1.port_id === "transfer"
      ), Lt = ((Ze = V.value.chain_1) == null ? void 0 : Ze.chain_name) === "osmosis" ? $t == null ? void 0 : $t.chain_1.channel_id : $t == null ? void 0 : $t.chain_2.channel_id, Qn = build$V.toHex(
        build$W.sha256(
          new TextEncoder().encode(
            `transfer/${Lt}/${M.value}`
          )
        )
      ).toUpperCase();
      return (ft = ee.value) == null ? void 0 : ft.map((It) => ({
        denom: M.value,
        symbol: It.symbol || "",
        ibcDenom: `ibc/${Qn}`,
        sourceChannelId: Lt,
        decimals: P(M.value),
        coinImageUrl: J(It)
      }));
    }), fe = computed(() => {
      var Qn, ce;
      const $t = (Qn = V.value.channels) == null ? void 0 : Qn.find(
        (Ze) => Ze.chain_1.port_id === "transfer"
      );
      return ((ce = V.value.chain_1) == null ? void 0 : ce.chain_name) === "osmosis" ? $t == null ? void 0 : $t.chain_2.channel_id : $t == null ? void 0 : $t.chain_1.channel_id;
    }), N = computed(() => se.value.findIndex(
      ($t) => {
        var Lt;
        return $t.denom === ((Lt = Q.value) == null ? void 0 : Lt.denom);
      }
    ) > -1), W = computed(() => se.value.findIndex(
      ($t) => {
        var Lt;
        return $t.denom === ((Lt = ue.value) == null ? void 0 : Lt.denom);
      }
    ) > -1), I = computed(() => S.value === "buy" ? (ue.value = tokens[0], tokens) : (ue.value = se.value[0], se.value)), te = computed(() => S.value === "buy" ? (Q.value = se.value[0], se.value) : (Q.value = tokens[0], tokens));
    function ge($t) {
      ue.value = $t, Y.value = "";
    }
    function Pe($t) {
      Q.value = $t, Y.value = "";
    }
    const Ke = computed(() => {
      const $t = pe.value.filter(
        (Lt) => {
          var Qn;
          return ((Qn = Lt.pool_assets) == null ? void 0 : Qn.findIndex(
            (ce) => {
              var Ze;
              return ce.token.denom === ((Ze = ue.value) == null ? void 0 : Ze.ibcDenom);
            }
          )) > -1;
        }
      ).filter(
        (Lt) => {
          var Qn;
          return ((Qn = Lt.pool_assets) == null ? void 0 : Qn.findIndex(
            (ce) => {
              var Ze;
              return ce.token.denom === ((Ze = Q.value) == null ? void 0 : Ze.ibcDenom);
            }
          )) > -1;
        }
      ).sort(
        (Lt, Qn) => Number(Qn.total_shares.amount) - Number(Lt.total_shares.amount)
      );
      return $t.length > 0 ? $t[0] : null;
    });
    function xe() {
      S.value = S.value === "buy" ? "sell" : "buy";
    }
    const ze = computed(() => {
      const $t = Number(Y.value || 0);
      if ($t <= 0 || nt.value <= 0)
        return !0;
      const Lt = ue.value, Qn = F.value.find((ce) => ce.denom === (Lt == null ? void 0 : Lt.ibcDenom) || "");
      return Qn && Lt ? Number(Qn.amount) < $t * 10 ** Lt.decimals : !0;
    }), nt = computed(() => {
      var Lt, Qn;
      const $t = Ke.value;
      if ($t) {
        const ce = (Lt = $t.pool_assets) == null ? void 0 : Lt.find(
          (ft) => {
            var It;
            return ft.token.denom === ((It = Q.value) == null ? void 0 : It.ibcDenom);
          }
        ), Ze = (Qn = $t.pool_assets) == null ? void 0 : Qn.find(
          (ft) => {
            var It;
            return ft.token.denom === ((It = ue.value) == null ? void 0 : It.ibcDenom);
          }
        );
        if (Ze && ce) {
          const ft = Number(ce.token.amount), It = Number(Ze.token.amount), rn = Number(ce.weight), Ln = Number(Ze.weight), Pn = Number($t.pool_params.swap_fee), Ae = Number(Y.value) * (1 - Pn);
          return ft * (1 - It / (It + Ae) ** (Ln / rn));
        }
      }
      return 0;
    });
    async function Qt() {
      $.value = !0;
      try {
        const $t = await getLatestBlock(c), Lt = await getSigningOsmosisClient({
          rpcEndpoint: u,
          // @ts-ignore
          signer: window.getOfflineSigner($t.block.header.chain_id)
        }), Qn = H(G.value.cosmosAddress);
        if (!ue.value || !Q.value || !Qn)
          return;
        const { swapExactAmountIn: ce } = osmosis.gamm.v1beta1.MessageComposer.withTypeUrl, Ze = Number(Y.value || 0), ft = ce({
          sender: Qn,
          routes: [
            {
              poolId: Long$2.fromNumber(Ke.value.id),
              tokenOutDenom: Q.value.ibcDenom
            }
          ],
          tokenIn: {
            amount: (Ze * 10 ** ue.value.decimals).toFixed(),
            denom: ue.value.ibcDenom
          },
          tokenOutMinAmount: (nt.value * 0.99 * 10 ** Q.value.decimals).toFixed()
          // slippage: 1%
        }), It = await Lt.simulate(Qn, [ft], ""), rn = {
          amount: [
            {
              denom: "uosmo",
              amount: "864"
            }
          ],
          gas: (It * 1.25).toFixed()
        }, Ln = await Lt.signAndBroadcast(
          Qn,
          [ft],
          rn,
          "Token Convert from ping.pub"
        );
        Ln.code === 0 ? (await At(Ln.transactionHash), await getBalance(
          c,
          H(G.value.cosmosAddress)
        ).then((Pn) => {
          F.value = Pn.balances.filter(
            (Ae) => !Ae.denom.startsWith("gamm")
          );
        })) : Ln.rawLog && (O.value = Ln.rawLog);
      } catch ($t) {
        O.value = $t;
      }
      $.value = !1;
    }
    const Et = ref("");
    function zt($t = "", Lt = 0) {
      var ce;
      const Qn = (ce = k.value) == null ? void 0 : ce.find((Ze) => Ze.denom === $t);
      return Qn ? Number(Qn.amount) / 10 ** Lt : 0;
    }
    const Nt = computed(() => {
      var Lt;
      const $t = ue.value;
      if ($t) {
        const Qn = (Lt = k.value) == null ? void 0 : Lt.find((ce) => ce.denom === $t.denom);
        if (Qn) {
          const ce = Number(Et.value || 0);
          return ce <= 0 || Number(Qn.amount) < ce * 10 ** $t.decimals;
        }
      }
      return !0;
    });
    async function pt() {
      $.value = !0;
      const $t = C(G.value.cosmosAddress);
      if (!ue.value || !$t)
        return;
      const Lt = await getLatestBlock(o.endpoint), Qn = await getAccount(o.endpoint, $t), ce = Lt.block.header.chainId, Ze = Date.now() + (/* @__PURE__ */ new Date()).getTimezoneOffset() + 36e5, ft = Number(Et.value || 0) * 10 ** ue.value.decimals, It = {
        chainId: ce,
        signerAddress: $t,
        messages: [
          {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: {
              sourcePort: "transfer",
              sourceChannel: fe.value || "",
              token: {
                amount: String(ft),
                denom: ue.value.denom
              },
              sender: $t,
              receiver: H($t),
              timeoutTimestamp: `${Ze}000000`
            }
          }
        ],
        fee: {
          gas: "200000",
          amount: [{ amount: "5000", denom: ue.value.denom }]
        },
        memo: "",
        signerData: {
          accountNumber: Number(Qn == null ? void 0 : Qn.accountNumber),
          sequence: Number(Qn == null ? void 0 : Qn.sequence),
          chainId: ce
        }
      };
      try {
        const rn = new UniClient(WalletName.Keplr, { chainId: ce }), Ln = await rn.sign(It);
        (await rn.broadcastTx(o.endpoint, Ln)).code === 0 && setTimeout(async () => {
          await getBalance(
            c,
            H(G.value.cosmosAddress)
          ).then((Ae) => {
            F.value = Ae.balances.filter(
              (Me) => !Me.denom.startsWith("gamm")
            );
          }), await getBalance(
            o.endpoint,
            C(G.value.cosmosAddress)
          ).then((Ae) => {
            k.value = Ae.balances;
          });
        }, 6e3);
      } catch (rn) {
        $.value = !1, O.value = rn, setTimeout(() => O.value = "", 5e3);
      }
      $.value = !1;
    }
    const at = ref(""), kt = ref(C(G.value.cosmosAddress)), Ut = computed(() => {
      var Lt;
      const $t = Q.value;
      if ($t) {
        const Qn = (Lt = F.value) == null ? void 0 : Lt.find((ce) => ce.denom === $t.ibcDenom);
        if (Qn) {
          const ce = Number(at.value || 0);
          return ce <= 0 || Number(Qn.amount) < ce * 10 ** $t.decimals;
        }
      }
      return !0;
    });
    async function dn() {
      $.value = !0;
      try {
        const $t = await getLatestBlock(c), Lt = await getSigningOsmosisClient({
          rpcEndpoint: u,
          // @ts-ignore
          signer: window.getOfflineSigner($t.block.header.chain_id)
        }), Qn = H(G.value.cosmosAddress);
        if (!ue.value || !Q.value || !Qn)
          return;
        const ce = Date.now() + (/* @__PURE__ */ new Date()).getTimezoneOffset() + 36e5, Ze = Number(at.value || 0), { transfer: ft } = ibc.applications.transfer.v1.MessageComposer.withTypeUrl, It = ft({
          sender: Qn,
          sourceChannel: Q.value.sourceChannelId || "",
          sourcePort: "transfer",
          token: {
            amount: (Ze * 10 ** Q.value.decimals).toFixed(),
            denom: Q.value.ibcDenom
          },
          receiver: kt.value,
          timeoutTimestamp: Long$2.fromString(`${ce}000000`),
          timeoutHeight: {
            revisionHeight: Long$2.fromNumber(0),
            revisionNumber: Long$2.fromNumber(0)
          },
          memo: ""
        }), rn = await Lt.simulate(Qn, [It], ""), Ln = {
          amount: [
            {
              denom: "uosmo",
              amount: "1864"
            }
          ],
          gas: (rn * 1.25).toFixed()
        }, Pn = await Lt.signAndBroadcast(
          Qn,
          [It],
          Ln,
          "Convert on ping.pub"
        );
        Pn.code === 0 ? (await getBalance(
          c,
          H(G.value.cosmosAddress)
        ).then((Ae) => {
          F.value = Ae.balances.filter(
            (Me) => !Me.denom.startsWith("gamm")
          );
        }), await getBalance(
          o.endpoint,
          C(G.value.cosmosAddress)
        ).then((Ae) => {
          k.value = Ae.balances;
        })) : Pn.rawLog && (O.value = Pn.rawLog);
      } catch ($t) {
        O.value = $t;
      }
      $.value = !1;
    }
    async function En() {
      $.value = !0;
      let $t = [];
      try {
        const Lt = await getLatestBlock(o.endpoint);
        await createWallet(WalletName.Keplr, {
          chainId: Lt.block.header.chainId,
          hdPath: o.hdPath || d
        }).getAccounts().then((ce) => {
          if ($t = ce, $t.length > 0) {
            const [Ze] = $t, ft = {
              wallet: WalletName.Keplr,
              cosmosAddress: Ze.address,
              hdPath: o.hdPath || d
            };
            writeWallet(ft, o.hdPath || d);
          }
        }).catch((ce) => {
          O.value = ce;
        }), ne(), m.value = "swap";
      } catch (Lt) {
        O.value = Lt.message;
      }
      $.value = !1;
    }
    const Ht = ref(0), Xt = ref(0), On = ref(""), sn = 6e3;
    function At($t) {
      m.value = "submitting", Ht.value = 1, Xt.value = 20, O.value = "", On.value = "Proccessing...", setTimeout(() => {
        hn($t);
      }, sn);
    }
    function hn($t) {
      Ht.value += 1, Xt.value += 20, getTxByHash(c, $t).then((Lt) => {
        var Qn, ce;
        Xt.value = 100, Lt.txResponse && ((Qn = Lt.txResponse) == null ? void 0 : Qn.code) > 0 ? O.value = (ce = Lt.txResponse) == null ? void 0 : ce.rawLog : (On.value = "Congratulations! Swap completed successfully.", n("completed", { hash: $t }));
      }).catch(() => {
        Ht.value < 5 ? setTimeout(() => hn($t), sn) : O.value = "Timeout";
      });
    }
    return ($t, Lt) => {
      var Qn, ce, Ze, ft, It, rn, Ln, Pn, Ae, Me, He, cn, Wt, yn, pr, Uo, ar, Sr, Jo, fr, Er;
      return openBlock(), createElementBlock("div", null, [
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": Lt[0] || (Lt[0] = (vo) => E.value = vo),
          type: "checkbox",
          id: "PingTokenConvert",
          class: "modal-toggle",
          onChange: Lt[1] || (Lt[1] = (vo) => ne())
        }, null, 544), [
          [vModelCheckbox, E.value]
        ]),
        createBaseVNode("label", _hoisted_1$1, [
          createBaseVNode("label", _hoisted_2$1, [
            withDirectives(createBaseVNode("div", null, [
              _hoisted_3$1,
              !y.value || e.chainName === "osmosis" ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
                createBaseVNode("span", null, "This feature is not available [" + toDisplayString(e.chainName) + "]", 1)
              ])) : createCommentVNode("", !0),
              createBaseVNode("div", _hoisted_6$1, [
                createBaseVNode("div", _hoisted_7$1, [
                  createBaseVNode("label", _hoisted_8$1, [
                    createBaseVNode("img", {
                      src: (Qn = ue.value) == null ? void 0 : Qn.coinImageUrl,
                      class: "w-8 h-8 mr-3 rounded-full"
                    }, null, 8, _hoisted_9$1),
                    createBaseVNode("div", _hoisted_10$1, toDisplayString((ce = ue.value) == null ? void 0 : ce.symbol), 1),
                    createVNode(unref(Icon), {
                      icon: "mdi:chevron-down",
                      class: "text-lg"
                    })
                  ]),
                  createBaseVNode("div", _hoisted_11$1, [
                    createBaseVNode("div", _hoisted_12$1, [
                      (openBlock(!0), createElementBlock(Fragment, null, renderList(I.value, (vo, lr) => (openBlock(), createElementBlock("div", {
                        key: lr,
                        class: "flex items-center px-4 py-2 hover:bg-gray-200 dark:hover:bg-[#232333] cursor-pointer",
                        onClick: ($r) => ge(vo)
                      }, [
                        createBaseVNode("img", {
                          class: "w-7 h-7 rounded-full mr-2",
                          src: vo.coinImageUrl
                        }, null, 8, _hoisted_14$1),
                        createBaseVNode("div", _hoisted_15$1, toDisplayString(vo.symbol), 1),
                        createBaseVNode("div", _hoisted_16$1, toDisplayString(w(
                          vo.ibcDenom || vo.denom,
                          vo.decimals
                        )), 1)
                      ], 8, _hoisted_13$1))), 128))
                    ])
                  ])
                ]),
                withDirectives(createBaseVNode("input", {
                  "onUpdate:modelValue": Lt[2] || (Lt[2] = (vo) => Y.value = vo),
                  type: "number",
                  placeholder: "1",
                  class: "input bg-transparent flex-1 h-14 text-right text-lg font-bold"
                }, null, 512), [
                  [vModelText, Y.value]
                ])
              ]),
              createBaseVNode("div", _hoisted_17$1, [
                _hoisted_18$1,
                createBaseVNode("div", _hoisted_19$1, toDisplayString(w((Ze = ue.value) == null ? void 0 : Ze.ibcDenom, (ft = ue.value) == null ? void 0 : ft.decimals)), 1),
                W.value ? (openBlock(), createBlock(unref(Icon), {
                  key: 0,
                  icon: "mdi:plus-box-outline",
                  class: "ml-2 cursor-pointer",
                  onClick: Lt[3] || (Lt[3] = (vo) => v("deposit"))
                })) : createCommentVNode("", !0)
              ]),
              createBaseVNode("div", _hoisted_20$1, [
                createBaseVNode("div", {
                  class: "inline-block px-4 cursor-pointer",
                  onClick: xe
                }, [
                  createVNode(unref(Icon), {
                    icon: "mdi:arrow-down-circle",
                    color: "#676cf6",
                    class: "text-4xl dark:bg-gray-50 rounded-full origin-center duration-300 transform hover:rotate-180"
                  })
                ])
              ]),
              createBaseVNode("div", _hoisted_21$1, [
                te.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_22$1, [
                  O.value ? (openBlock(), createElementBlock("span", _hoisted_23$1, "No tradable tokens found.")) : (openBlock(), createElementBlock("button", {
                    key: 1,
                    class: normalizeClass(["btn btn-ghost", { "loading relative start-0": $.value }])
                  }, " loading... ", 2))
                ])) : createCommentVNode("", !0),
                te.value && te.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_24$1, [
                  createBaseVNode("label", _hoisted_25$1, [
                    createBaseVNode("img", {
                      src: (It = Q.value) == null ? void 0 : It.coinImageUrl,
                      class: "w-8 h-8 mr-3 rounded-full"
                    }, null, 8, _hoisted_26$1),
                    createBaseVNode("div", _hoisted_27$1, toDisplayString((rn = Q.value) == null ? void 0 : rn.symbol), 1),
                    createVNode(unref(Icon), {
                      icon: "mdi:chevron-down",
                      class: "text-lg"
                    })
                  ]),
                  createBaseVNode("div", _hoisted_28$1, [
                    createBaseVNode("div", _hoisted_29$1, [
                      (openBlock(!0), createElementBlock(Fragment, null, renderList(te.value, (vo, lr) => (openBlock(), createElementBlock("div", {
                        key: lr,
                        onClick: ($r) => Pe(vo),
                        class: "flex items-center px-4 py-2 max-h-36 overflow-y-auto hover:bg-gray-200 dark:hover:bg-[#232333] cursor-pointer"
                      }, [
                        createBaseVNode("img", {
                          class: "w-7 h-7 rounded-full mr-2",
                          src: vo.coinImageUrl
                        }, null, 8, _hoisted_31$1),
                        createBaseVNode("div", _hoisted_32$1, toDisplayString(vo.symbol), 1),
                        createBaseVNode("div", _hoisted_33$1, toDisplayString(w(
                          vo.ibcDenom || vo.denom,
                          vo.decimals
                        )), 1)
                      ], 8, _hoisted_30$1))), 128))
                    ])
                  ])
                ])) : createCommentVNode("", !0),
                createBaseVNode("div", _hoisted_34$1, toDisplayString(`≈ ${parseFloat(nt.value.toFixed(6))}`), 1)
              ]),
              createBaseVNode("div", _hoisted_35$1, [
                _hoisted_36$1,
                createBaseVNode("div", _hoisted_37$1, toDisplayString(w(
                  (Ln = Q.value) == null ? void 0 : Ln.ibcDenom,
                  (Pn = Q.value) == null ? void 0 : Pn.decimals
                )), 1),
                N.value ? (openBlock(), createBlock(unref(Icon), {
                  key: 0,
                  icon: "mdi:minus-box-outline",
                  class: "ml-2 cursor-pointer",
                  onClick: Lt[4] || (Lt[4] = (vo) => v("withdraw"))
                })) : createCommentVNode("", !0)
              ]),
              createBaseVNode("div", _hoisted_38$1, [
                createBaseVNode("div", _hoisted_39$1, [
                  _hoisted_40$1,
                  createBaseVNode("div", _hoisted_41$1, toDisplayString(unref(decimal2percent)((Ae = Ke.value) == null ? void 0 : Ae.pool_params.swap_fee)) + "% ", 1)
                ])
              ]),
              O.value ? (openBlock(), createElementBlock("div", _hoisted_42, [
                createBaseVNode("span", null, toDisplayString(O.value) + ".", 1)
              ])) : createCommentVNode("", !0),
              createBaseVNode("div", _hoisted_43, [
                createBaseVNode("button", {
                  class: "btn btn-primary w-full ping-connect-confirm capitalize text-base",
                  disabled: ze.value,
                  onClick: Qt
                }, [
                  $.value ? (openBlock(), createElementBlock("span", _hoisted_45)) : createCommentVNode("", !0),
                  createTextVNode(" Convert ")
                ], 8, _hoisted_44)
              ])
            ], 512), [
              [vShow, m.value === "swap"]
            ]),
            withDirectives(createBaseVNode("div", null, [
              createBaseVNode("h3", _hoisted_46, [
                createVNode(unref(Icon), {
                  class: "mt-1",
                  icon: "mdi:chevron-left",
                  onClick: Lt[5] || (Lt[5] = (vo) => v("swap"))
                }),
                createTextVNode(" Deposit ")
              ]),
              createBaseVNode("div", _hoisted_47, [
                createBaseVNode("label", _hoisted_48, [
                  _hoisted_49,
                  createBaseVNode("span", _hoisted_50, toDisplayString(w((Me = ue.value) == null ? void 0 : Me.ibcDenom, (He = ue.value) == null ? void 0 : He.decimals)), 1)
                ]),
                createBaseVNode("input", {
                  value: H(G.value.cosmosAddress),
                  readonly: "",
                  type: "text",
                  class: "input border border-gray-300 dark:border-gray-600"
                }, null, 8, _hoisted_51)
              ]),
              createBaseVNode("div", _hoisted_52, [
                createBaseVNode("label", _hoisted_53, [
                  createBaseVNode("img", {
                    src: (cn = ue.value) == null ? void 0 : cn.coinImageUrl,
                    class: "w-8 h-8 mr-3 rounded-full"
                  }, null, 8, _hoisted_54),
                  createBaseVNode("div", _hoisted_55, toDisplayString((Wt = ue.value) == null ? void 0 : Wt.symbol), 1)
                ]),
                withDirectives(createBaseVNode("input", {
                  "onUpdate:modelValue": Lt[6] || (Lt[6] = (vo) => Et.value = vo),
                  type: "number",
                  placeholder: "1",
                  class: "input bg-transparent flex-1 h-14 text-right text-lg font-bold"
                }, null, 512), [
                  [vModelText, Et.value]
                ])
              ]),
              createBaseVNode("div", _hoisted_56, [
                createBaseVNode("div", _hoisted_57, toDisplayString(zt(
                  (yn = ue.value) == null ? void 0 : yn.denom,
                  (pr = ue.value) == null ? void 0 : pr.decimals
                )), 1),
                _hoisted_58
              ]),
              O.value ? (openBlock(), createElementBlock("div", _hoisted_59, [
                createBaseVNode("span", null, toDisplayString(O.value) + ".", 1)
              ])) : createCommentVNode("", !0),
              createBaseVNode("div", _hoisted_60, [
                createBaseVNode("label", {
                  class: "btn mr-1",
                  onClick: Lt[7] || (Lt[7] = (vo) => v("swap"))
                }, _hoisted_62),
                createBaseVNode("button", {
                  class: "btn btn-primary grow ping-connect-confirm capitalize text-base",
                  disabled: Nt.value,
                  onClick: pt
                }, [
                  $.value ? (openBlock(), createElementBlock("span", _hoisted_64)) : createCommentVNode("", !0),
                  createTextVNode(" Deposit ")
                ], 8, _hoisted_63)
              ])
            ], 512), [
              [vShow, m.value === "deposit"]
            ]),
            withDirectives(createBaseVNode("div", null, [
              createBaseVNode("h3", _hoisted_65, [
                createVNode(unref(Icon), {
                  class: "mt-1",
                  icon: "mdi:chevron-left",
                  onClick: Lt[8] || (Lt[8] = (vo) => v("swap"))
                }),
                createTextVNode(" Withdraw ")
              ]),
              createBaseVNode("div", _hoisted_66, [
                _hoisted_67,
                createBaseVNode("div", _hoisted_68, toDisplayString(w(
                  (Uo = Q.value) == null ? void 0 : Uo.ibcDenom,
                  (ar = Q.value) == null ? void 0 : ar.decimals
                )), 1)
              ]),
              createBaseVNode("div", _hoisted_69, [
                createBaseVNode("label", _hoisted_70, [
                  createBaseVNode("img", {
                    src: (Sr = Q.value) == null ? void 0 : Sr.coinImageUrl,
                    class: "w-8 h-8 mr-3 rounded-full"
                  }, null, 8, _hoisted_71),
                  createBaseVNode("div", _hoisted_72, toDisplayString((Jo = Q.value) == null ? void 0 : Jo.symbol), 1)
                ]),
                withDirectives(createBaseVNode("input", {
                  "onUpdate:modelValue": Lt[9] || (Lt[9] = (vo) => at.value = vo),
                  type: "number",
                  placeholder: "1",
                  class: "input bg-transparent flex-1 h-14 text-right text-lg font-bold"
                }, null, 512), [
                  [vModelText, at.value]
                ])
              ]),
              createBaseVNode("div", _hoisted_73, [
                createBaseVNode("label", _hoisted_74, [
                  createBaseVNode("span", _hoisted_75, "Recipient on " + toDisplayString(X.value.pretty_name), 1),
                  createBaseVNode("span", _hoisted_76, toDisplayString(zt(
                    (fr = Q.value) == null ? void 0 : fr.denom,
                    (Er = Q.value) == null ? void 0 : Er.decimals
                  )), 1)
                ]),
                withDirectives(createBaseVNode("input", {
                  "onUpdate:modelValue": Lt[10] || (Lt[10] = (vo) => kt.value = vo),
                  type: "text",
                  class: "input border border-gray-300 dark:border-gray-600"
                }, null, 512), [
                  [vModelText, kt.value]
                ])
              ]),
              O.value ? (openBlock(), createElementBlock("div", _hoisted_77, [
                createBaseVNode("span", null, toDisplayString(O.value) + ".", 1)
              ])) : createCommentVNode("", !0),
              createBaseVNode("div", _hoisted_78, [
                createBaseVNode("label", {
                  class: "btn mr-1",
                  onClick: Lt[11] || (Lt[11] = (vo) => v("swap"))
                }, _hoisted_80),
                createBaseVNode("button", {
                  class: "btn btn-primary grow ping-connect-confirm capitalize text-base",
                  disabled: Ut.value,
                  onClick: Lt[12] || (Lt[12] = (vo) => dn())
                }, [
                  $.value ? (openBlock(), createElementBlock("span", _hoisted_82)) : createCommentVNode("", !0),
                  createTextVNode(" Withdraw ")
                ], 8, _hoisted_81)
              ])
            ], 512), [
              [vShow, m.value === "withdraw"]
            ]),
            withDirectives(createBaseVNode("div", null, [
              _hoisted_83,
              _hoisted_84,
              O.value ? (openBlock(), createElementBlock("div", _hoisted_85, [
                createBaseVNode("span", null, toDisplayString(O.value) + ".", 1)
              ])) : createCommentVNode("", !0),
              createBaseVNode("div", _hoisted_86, [
                createBaseVNode("button", {
                  class: "btn btn-primary w-full ping-connect-confirm capitalize text-base",
                  onClick: Lt[13] || (Lt[13] = (vo) => En())
                }, [
                  $.value ? (openBlock(), createElementBlock("span", _hoisted_87)) : createCommentVNode("", !0),
                  createTextVNode(" Connect ")
                ])
              ])
            ], 512), [
              [vShow, m.value === "connect"]
            ]),
            withDirectives(createBaseVNode("div", null, [
              createBaseVNode("div", _hoisted_88, [
                O.value ? (openBlock(), createElementBlock("div", _hoisted_89, toDisplayString(O.value), 1)) : (openBlock(), createElementBlock("div", _hoisted_90, toDisplayString(On.value), 1)),
                createBaseVNode("div", _hoisted_91, [
                  createBaseVNode("div", {
                    style: normalizeStyle(`width: ${Xt.value}%`),
                    class: "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-400"
                  }, null, 4)
                ]),
                createBaseVNode("div", _hoisted_92, [
                  _hoisted_93,
                  createBaseVNode("div", _hoisted_94, [
                    createBaseVNode("span", _hoisted_95, toDisplayString(Xt.value) + "% ", 1)
                  ])
                ])
              ]),
              createBaseVNode("div", _hoisted_96, [
                createBaseVNode("label", {
                  class: "btn btn-link",
                  onClick: Lt[14] || (Lt[14] = (vo) => m.value = "swap")
                }, "Continue")
              ])
            ], 512), [
              [vShow, m.value === "submitting"]
            ])
          ])
        ])
      ]);
    };
  }
});
var params = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ParamChange = e.ParameterChangeProposal = e.protobufPackage = void 0;
  const n = binary, o = helpers;
  e.protobufPackage = "cosmos.params.v1beta1";
  function u() {
    return {
      title: "",
      description: "",
      changes: []
    };
  }
  e.ParameterChangeProposal = {
    typeUrl: "/cosmos.params.v1beta1.ParameterChangeProposal",
    encode(d, m = n.BinaryWriter.create()) {
      d.title !== "" && m.uint32(10).string(d.title), d.description !== "" && m.uint32(18).string(d.description);
      for (const v of d.changes)
        e.ParamChange.encode(v, m.uint32(26).fork()).ldelim();
      return m;
    },
    decode(d, m) {
      const v = d instanceof n.BinaryReader ? d : new n.BinaryReader(d);
      let S = m === void 0 ? v.len : v.pos + m;
      const $ = u();
      for (; v.pos < S; ) {
        const E = v.uint32();
        switch (E >>> 3) {
          case 1:
            $.title = v.string();
            break;
          case 2:
            $.description = v.string();
            break;
          case 3:
            $.changes.push(e.ParamChange.decode(v, v.uint32()));
            break;
          default:
            v.skipType(E & 7);
            break;
        }
      }
      return $;
    },
    fromJSON(d) {
      const m = u();
      return (0, o.isSet)(d.title) && (m.title = String(d.title)), (0, o.isSet)(d.description) && (m.description = String(d.description)), Array.isArray(d == null ? void 0 : d.changes) && (m.changes = d.changes.map((v) => e.ParamChange.fromJSON(v))), m;
    },
    toJSON(d) {
      const m = {};
      return d.title !== void 0 && (m.title = d.title), d.description !== void 0 && (m.description = d.description), d.changes ? m.changes = d.changes.map((v) => v ? e.ParamChange.toJSON(v) : void 0) : m.changes = [], m;
    },
    fromPartial(d) {
      var v;
      const m = u();
      return m.title = d.title ?? "", m.description = d.description ?? "", m.changes = ((v = d.changes) == null ? void 0 : v.map((S) => e.ParamChange.fromPartial(S))) || [], m;
    }
  };
  function c() {
    return {
      subspace: "",
      key: "",
      value: ""
    };
  }
  e.ParamChange = {
    typeUrl: "/cosmos.params.v1beta1.ParamChange",
    encode(d, m = n.BinaryWriter.create()) {
      return d.subspace !== "" && m.uint32(10).string(d.subspace), d.key !== "" && m.uint32(18).string(d.key), d.value !== "" && m.uint32(26).string(d.value), m;
    },
    decode(d, m) {
      const v = d instanceof n.BinaryReader ? d : new n.BinaryReader(d);
      let S = m === void 0 ? v.len : v.pos + m;
      const $ = c();
      for (; v.pos < S; ) {
        const E = v.uint32();
        switch (E >>> 3) {
          case 1:
            $.subspace = v.string();
            break;
          case 2:
            $.key = v.string();
            break;
          case 3:
            $.value = v.string();
            break;
          default:
            v.skipType(E & 7);
            break;
        }
      }
      return $;
    },
    fromJSON(d) {
      const m = c();
      return (0, o.isSet)(d.subspace) && (m.subspace = String(d.subspace)), (0, o.isSet)(d.key) && (m.key = String(d.key)), (0, o.isSet)(d.value) && (m.value = String(d.value)), m;
    },
    toJSON(d) {
      const m = {};
      return d.subspace !== void 0 && (m.subspace = d.subspace), d.key !== void 0 && (m.key = d.key), d.value !== void 0 && (m.value = d.value), m;
    },
    fromPartial(d) {
      const m = c();
      return m.subspace = d.subspace ?? "", m.key = d.key ?? "", m.value = d.value ?? "", m;
    }
  };
})(params);
class WalletStation {
  constructor() {
    fi(this, "collectWallet", async (n) => window.getOfflineSigner(n));
    fi(this, "signerClient", async (n, o, u) => {
      const c = new build$S.AminoTypes({
        ...build$S.createStakingAminoConverters(),
        ...build$S.createDistributionAminoConverters(),
        ...build$S.createBankAminoConverters(),
        ...build$o.createWasmAminoConverters(),
        ...build$S.createGovAminoConverters()
      });
      return await build$o.SigningCosmWasmClient.connectWithSigner(
        n,
        o,
        {
          gasPrice: new build$S.GasPrice(build$T.Decimal.fromUserInput("0", 6), u),
          prefix: u,
          aminoTypes: c
        }
      );
    });
    fi(this, "signAndBroadCast", async (n, o, u, c) => {
      try {
        const d = await this.collectWallet(n == null ? void 0 : n.chainId);
        console.log({ wallet: d });
        const m = await this.signerClient(
          n == null ? void 0 : n.urlRpc,
          d,
          o
        );
        console.log({ client: m });
        const v = await m.signAndBroadcast(
          u,
          c,
          "auto"
        );
        return console.log({ result: v }), v;
      } catch (d) {
        throw console.log("signAndBroadcast msg error: ", d), d;
      }
    });
    fi(this, "textProposal", async (n, o, u, c) => {
      const d = gov$4.TextProposal.fromPartial({
        title: u.title,
        description: u.description
      }), m = {
        typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
        value: tx$k.MsgSubmitProposal.fromPartial({
          messages: [
            {
              typeUrl: "/cosmos.gov.v1.MsgExecLegacyContent",
              value: tx$k.MsgExecLegacyContent.encode({
                authority: o,
                content: {
                  typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                  value: gov$4.TextProposal.encode(
                    d
                  ).finish()
                }
              }).finish()
            }
          ],
          initialDeposit: [build$P.coin(u.amount, u.denom)],
          proposer: n,
          title: d.title,
          summary: d.description,
          metadata: ""
        })
      };
      return this.signAndBroadCast(
        c,
        u.denom,
        n,
        [m]
      );
    });
    fi(this, "updateAdminProposal", async (n, o, u, c) => {
      const d = {
        typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
        value: tx$k.MsgSubmitProposal.fromPartial({
          messages: [
            {
              typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
              value: tx$b.MsgUpdateAdmin.encode({
                contract: u.contract,
                newAdmin: u.newAdmin,
                sender: o
              }).finish()
            }
          ],
          initialDeposit: [build$P.coin(u.amount, u.denom)],
          proposer: n,
          title: u.title,
          summary: u.description,
          metadata: "",
          expedited: !0
        })
      };
      return this.signAndBroadCast(
        c,
        u.denom,
        n,
        [d]
      );
    });
    fi(this, "communityPoolSpendProposal", async (n, o, u, c) => {
      const d = tx$m.MsgCommunityPoolSpend.fromPartial({
        amount: [
          {
            amount: u.amount,
            denom: u.denom
          }
        ],
        authority: o,
        recipient: u.recipient
      }), m = {
        typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
        value: tx$k.MsgSubmitProposal.fromPartial({
          messages: [
            {
              typeUrl: "/cosmos.distribution.v1beta1.MsgCommunityPoolSpend",
              value: tx$m.MsgCommunityPoolSpend.encode(
                d
              ).finish()
            }
          ],
          initialDeposit: [build$P.coin(u.deposit, u.denom)],
          proposer: n,
          title: u.title,
          summary: u.description,
          metadata: ""
        })
      };
      return this.signAndBroadCast(
        c,
        u.denom,
        n,
        [m]
      );
    });
    fi(this, "parameterChangeProposal", async (n, o, u, c) => {
      console.log({ sender: n, govAddress: o, changeInfo: u, chainInfo: c });
      const d = params.ParameterChangeProposal.fromPartial({
        title: u.title,
        description: u.description,
        changes: [
          params.ParamChange.fromPartial({
            subspace: u.subspace,
            key: u.key,
            value: u.value
          })
        ]
      });
      console.log({ paramChangeInfo: d });
      const m = {
        typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
        value: tx$k.MsgSubmitProposal.fromPartial({
          messages: [
            {
              typeUrl: "/cosmos.gov.v1.MsgExecLegacyContent",
              value: tx$k.MsgExecLegacyContent.encode({
                authority: o,
                content: {
                  typeUrl: "/cosmos.params.v1beta1.ParameterChangeProposal",
                  value: params.ParameterChangeProposal.encode(
                    d
                  ).finish()
                }
              }).finish()
            }
          ],
          initialDeposit: [build$P.coin(u.amount, u.denom)],
          proposer: n,
          title: d.title,
          summary: d.description,
          metadata: ""
        })
      };
      return console.log({ message: m }), this.signAndBroadCast(
        c,
        u.denom,
        n,
        [m]
      );
    });
  }
}
const walletStation = new WalletStation();
var vue3Editor_common = { exports: {} }, quill = { exports: {} }, hasRequiredQuill;
function requireQuill() {
  return hasRequiredQuill || (hasRequiredQuill = 1, function(e, n) {
    (function(u, c) {
      e.exports = c();
    })(typeof self < "u" ? self : commonjsGlobal, function() {
      return (
        /******/
        function(o) {
          var u = {};
          function c(d) {
            if (u[d])
              return u[d].exports;
            var m = u[d] = {
              /******/
              i: d,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return o[d].call(m.exports, m, m.exports, c), m.l = !0, m.exports;
          }
          return c.m = o, c.c = u, c.d = function(d, m, v) {
            c.o(d, m) || Object.defineProperty(d, m, {
              /******/
              configurable: !1,
              /******/
              enumerable: !0,
              /******/
              get: v
              /******/
            });
          }, c.n = function(d) {
            var m = d && d.__esModule ? (
              /******/
              function() {
                return d.default;
              }
            ) : (
              /******/
              function() {
                return d;
              }
            );
            return c.d(m, "a", m), m;
          }, c.o = function(d, m) {
            return Object.prototype.hasOwnProperty.call(d, m);
          }, c.p = "", c(c.s = 109);
        }([
          /* 0 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", { value: !0 });
            var d = c(17), m = c(18), v = c(19), S = c(45), $ = c(46), E = c(47), O = c(48), T = c(49), y = c(12), V = c(32), M = c(33), G = c(31), k = c(1), F = {
              Scope: k.Scope,
              create: k.create,
              find: k.find,
              query: k.query,
              register: k.register,
              Container: d.default,
              Format: m.default,
              Leaf: v.default,
              Embed: O.default,
              Scroll: S.default,
              Block: E.default,
              Inline: $.default,
              Text: T.default,
              Attributor: {
                Attribute: y.default,
                Class: V.default,
                Style: M.default,
                Store: G.default
              }
            };
            u.default = F;
          },
          /* 1 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var G = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(k, F) {
                k.__proto__ = F;
              } || function(k, F) {
                for (var X in F)
                  F.hasOwnProperty(X) && (k[X] = F[X]);
              };
              return function(k, F) {
                G(k, F);
                function X() {
                  this.constructor = k;
                }
                k.prototype = F === null ? Object.create(F) : (X.prototype = F.prototype, new X());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = (
              /** @class */
              function(G) {
                d(k, G);
                function k(F) {
                  var X = this;
                  return F = "[Parchment] " + F, X = G.call(this, F) || this, X.message = F, X.name = X.constructor.name, X;
                }
                return k;
              }(Error)
            );
            u.ParchmentError = m;
            var v = {}, S = {}, $ = {}, E = {};
            u.DATA_KEY = "__blot";
            var O;
            (function(G) {
              G[G.TYPE = 3] = "TYPE", G[G.LEVEL = 12] = "LEVEL", G[G.ATTRIBUTE = 13] = "ATTRIBUTE", G[G.BLOT = 14] = "BLOT", G[G.INLINE = 7] = "INLINE", G[G.BLOCK = 11] = "BLOCK", G[G.BLOCK_BLOT = 10] = "BLOCK_BLOT", G[G.INLINE_BLOT = 6] = "INLINE_BLOT", G[G.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", G[G.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", G[G.ANY = 15] = "ANY";
            })(O = u.Scope || (u.Scope = {}));
            function T(G, k) {
              var F = V(G);
              if (F == null)
                throw new m("Unable to create " + G + " blot");
              var X = F, ee = (
                // @ts-ignore
                G instanceof Node || G.nodeType === Node.TEXT_NODE ? G : X.create(k)
              );
              return new X(ee, k);
            }
            u.create = T;
            function y(G, k) {
              return k === void 0 && (k = !1), G == null ? null : G[u.DATA_KEY] != null ? G[u.DATA_KEY].blot : k ? y(G.parentNode, k) : null;
            }
            u.find = y;
            function V(G, k) {
              k === void 0 && (k = O.ANY);
              var F;
              if (typeof G == "string")
                F = E[G] || v[G];
              else if (G instanceof Text || G.nodeType === Node.TEXT_NODE)
                F = E.text;
              else if (typeof G == "number")
                G & O.LEVEL & O.BLOCK ? F = E.block : G & O.LEVEL & O.INLINE && (F = E.inline);
              else if (G instanceof HTMLElement) {
                var X = (G.getAttribute("class") || "").split(/\s+/);
                for (var ee in X)
                  if (F = S[X[ee]], F)
                    break;
                F = F || $[G.tagName];
              }
              return F == null ? null : k & O.LEVEL & F.scope && k & O.TYPE & F.scope ? F : null;
            }
            u.query = V;
            function M() {
              for (var G = [], k = 0; k < arguments.length; k++)
                G[k] = arguments[k];
              if (G.length > 1)
                return G.map(function(ee) {
                  return M(ee);
                });
              var F = G[0];
              if (typeof F.blotName != "string" && typeof F.attrName != "string")
                throw new m("Invalid definition");
              if (F.blotName === "abstract")
                throw new m("Cannot register abstract class");
              if (E[F.blotName || F.attrName] = F, typeof F.keyName == "string")
                v[F.keyName] = F;
              else if (F.className != null && (S[F.className] = F), F.tagName != null) {
                Array.isArray(F.tagName) ? F.tagName = F.tagName.map(function(ee) {
                  return ee.toUpperCase();
                }) : F.tagName = F.tagName.toUpperCase();
                var X = Array.isArray(F.tagName) ? F.tagName : [F.tagName];
                X.forEach(function(ee) {
                  ($[ee] == null || F.className == null) && ($[ee] = F);
                });
              }
              return F;
            }
            u.register = M;
          },
          /* 2 */
          /***/
          function(o, u, c) {
            var d = c(51), m = c(11), v = c(3), S = c(20), $ = String.fromCharCode(0), E = function(O) {
              Array.isArray(O) ? this.ops = O : O != null && Array.isArray(O.ops) ? this.ops = O.ops : this.ops = [];
            };
            E.prototype.insert = function(O, T) {
              var y = {};
              return O.length === 0 ? this : (y.insert = O, T != null && typeof T == "object" && Object.keys(T).length > 0 && (y.attributes = T), this.push(y));
            }, E.prototype.delete = function(O) {
              return O <= 0 ? this : this.push({ delete: O });
            }, E.prototype.retain = function(O, T) {
              if (O <= 0)
                return this;
              var y = { retain: O };
              return T != null && typeof T == "object" && Object.keys(T).length > 0 && (y.attributes = T), this.push(y);
            }, E.prototype.push = function(O) {
              var T = this.ops.length, y = this.ops[T - 1];
              if (O = v(!0, {}, O), typeof y == "object") {
                if (typeof O.delete == "number" && typeof y.delete == "number")
                  return this.ops[T - 1] = { delete: y.delete + O.delete }, this;
                if (typeof y.delete == "number" && O.insert != null && (T -= 1, y = this.ops[T - 1], typeof y != "object"))
                  return this.ops.unshift(O), this;
                if (m(O.attributes, y.attributes)) {
                  if (typeof O.insert == "string" && typeof y.insert == "string")
                    return this.ops[T - 1] = { insert: y.insert + O.insert }, typeof O.attributes == "object" && (this.ops[T - 1].attributes = O.attributes), this;
                  if (typeof O.retain == "number" && typeof y.retain == "number")
                    return this.ops[T - 1] = { retain: y.retain + O.retain }, typeof O.attributes == "object" && (this.ops[T - 1].attributes = O.attributes), this;
                }
              }
              return T === this.ops.length ? this.ops.push(O) : this.ops.splice(T, 0, O), this;
            }, E.prototype.chop = function() {
              var O = this.ops[this.ops.length - 1];
              return O && O.retain && !O.attributes && this.ops.pop(), this;
            }, E.prototype.filter = function(O) {
              return this.ops.filter(O);
            }, E.prototype.forEach = function(O) {
              this.ops.forEach(O);
            }, E.prototype.map = function(O) {
              return this.ops.map(O);
            }, E.prototype.partition = function(O) {
              var T = [], y = [];
              return this.forEach(function(V) {
                var M = O(V) ? T : y;
                M.push(V);
              }), [T, y];
            }, E.prototype.reduce = function(O, T) {
              return this.ops.reduce(O, T);
            }, E.prototype.changeLength = function() {
              return this.reduce(function(O, T) {
                return T.insert ? O + S.length(T) : T.delete ? O - T.delete : O;
              }, 0);
            }, E.prototype.length = function() {
              return this.reduce(function(O, T) {
                return O + S.length(T);
              }, 0);
            }, E.prototype.slice = function(O, T) {
              O = O || 0, typeof T != "number" && (T = 1 / 0);
              for (var y = [], V = S.iterator(this.ops), M = 0; M < T && V.hasNext(); ) {
                var G;
                M < O ? G = V.next(O - M) : (G = V.next(T - M), y.push(G)), M += S.length(G);
              }
              return new E(y);
            }, E.prototype.compose = function(O) {
              var T = S.iterator(this.ops), y = S.iterator(O.ops), V = [], M = y.peek();
              if (M != null && typeof M.retain == "number" && M.attributes == null) {
                for (var G = M.retain; T.peekType() === "insert" && T.peekLength() <= G; )
                  G -= T.peekLength(), V.push(T.next());
                M.retain - G > 0 && y.next(M.retain - G);
              }
              for (var k = new E(V); T.hasNext() || y.hasNext(); )
                if (y.peekType() === "insert")
                  k.push(y.next());
                else if (T.peekType() === "delete")
                  k.push(T.next());
                else {
                  var F = Math.min(T.peekLength(), y.peekLength()), X = T.next(F), ee = y.next(F);
                  if (typeof ee.retain == "number") {
                    var ue = {};
                    typeof X.retain == "number" ? ue.retain = F : ue.insert = X.insert;
                    var Q = S.attributes.compose(X.attributes, ee.attributes, typeof X.retain == "number");
                    if (Q && (ue.attributes = Q), k.push(ue), !y.hasNext() && m(k.ops[k.ops.length - 1], ue)) {
                      var Y = new E(T.rest());
                      return k.concat(Y).chop();
                    }
                  } else
                    typeof ee.delete == "number" && typeof X.retain == "number" && k.push(ee);
                }
              return k.chop();
            }, E.prototype.concat = function(O) {
              var T = new E(this.ops.slice());
              return O.ops.length > 0 && (T.push(O.ops[0]), T.ops = T.ops.concat(O.ops.slice(1))), T;
            }, E.prototype.diff = function(O, T) {
              if (this.ops === O.ops)
                return new E();
              var y = [this, O].map(function(F) {
                return F.map(function(X) {
                  if (X.insert != null)
                    return typeof X.insert == "string" ? X.insert : $;
                  var ee = F === O ? "on" : "with";
                  throw new Error("diff() called " + ee + " non-document");
                }).join("");
              }), V = new E(), M = d(y[0], y[1], T), G = S.iterator(this.ops), k = S.iterator(O.ops);
              return M.forEach(function(F) {
                for (var X = F[1].length; X > 0; ) {
                  var ee = 0;
                  switch (F[0]) {
                    case d.INSERT:
                      ee = Math.min(k.peekLength(), X), V.push(k.next(ee));
                      break;
                    case d.DELETE:
                      ee = Math.min(X, G.peekLength()), G.next(ee), V.delete(ee);
                      break;
                    case d.EQUAL:
                      ee = Math.min(G.peekLength(), k.peekLength(), X);
                      var ue = G.next(ee), Q = k.next(ee);
                      m(ue.insert, Q.insert) ? V.retain(ee, S.attributes.diff(ue.attributes, Q.attributes)) : V.push(Q).delete(ee);
                      break;
                  }
                  X -= ee;
                }
              }), V.chop();
            }, E.prototype.eachLine = function(O, T) {
              T = T || `
`;
              for (var y = S.iterator(this.ops), V = new E(), M = 0; y.hasNext(); ) {
                if (y.peekType() !== "insert")
                  return;
                var G = y.peek(), k = S.length(G) - y.peekLength(), F = typeof G.insert == "string" ? G.insert.indexOf(T, k) - k : -1;
                if (F < 0)
                  V.push(y.next());
                else if (F > 0)
                  V.push(y.next(F));
                else {
                  if (O(V, y.next(1).attributes || {}, M) === !1)
                    return;
                  M += 1, V = new E();
                }
              }
              V.length() > 0 && O(V, {}, M);
            }, E.prototype.transform = function(O, T) {
              if (T = !!T, typeof O == "number")
                return this.transformPosition(O, T);
              for (var y = S.iterator(this.ops), V = S.iterator(O.ops), M = new E(); y.hasNext() || V.hasNext(); )
                if (y.peekType() === "insert" && (T || V.peekType() !== "insert"))
                  M.retain(S.length(y.next()));
                else if (V.peekType() === "insert")
                  M.push(V.next());
                else {
                  var G = Math.min(y.peekLength(), V.peekLength()), k = y.next(G), F = V.next(G);
                  if (k.delete)
                    continue;
                  F.delete ? M.push(F) : M.retain(G, S.attributes.transform(k.attributes, F.attributes, T));
                }
              return M.chop();
            }, E.prototype.transformPosition = function(O, T) {
              T = !!T;
              for (var y = S.iterator(this.ops), V = 0; y.hasNext() && V <= O; ) {
                var M = y.peekLength(), G = y.peekType();
                if (y.next(), G === "delete") {
                  O -= Math.min(M, O - V);
                  continue;
                } else
                  G === "insert" && (V < O || !T) && (O += M);
                V += M;
              }
              return O;
            }, o.exports = E;
          },
          /* 3 */
          /***/
          function(o, u) {
            var c = Object.prototype.hasOwnProperty, d = Object.prototype.toString, m = Object.defineProperty, v = Object.getOwnPropertyDescriptor, S = function(y) {
              return typeof Array.isArray == "function" ? Array.isArray(y) : d.call(y) === "[object Array]";
            }, $ = function(y) {
              if (!y || d.call(y) !== "[object Object]")
                return !1;
              var V = c.call(y, "constructor"), M = y.constructor && y.constructor.prototype && c.call(y.constructor.prototype, "isPrototypeOf");
              if (y.constructor && !V && !M)
                return !1;
              var G;
              for (G in y)
                ;
              return typeof G > "u" || c.call(y, G);
            }, E = function(y, V) {
              m && V.name === "__proto__" ? m(y, V.name, {
                enumerable: !0,
                configurable: !0,
                value: V.newValue,
                writable: !0
              }) : y[V.name] = V.newValue;
            }, O = function(y, V) {
              if (V === "__proto__")
                if (c.call(y, V)) {
                  if (v)
                    return v(y, V).value;
                } else
                  return;
              return y[V];
            };
            o.exports = function T() {
              var y, V, M, G, k, F, X = arguments[0], ee = 1, ue = arguments.length, Q = !1;
              for (typeof X == "boolean" && (Q = X, X = arguments[1] || {}, ee = 2), (X == null || typeof X != "object" && typeof X != "function") && (X = {}); ee < ue; ++ee)
                if (y = arguments[ee], y != null)
                  for (V in y)
                    M = O(X, V), G = O(y, V), X !== G && (Q && G && ($(G) || (k = S(G))) ? (k ? (k = !1, F = M && S(M) ? M : []) : F = M && $(M) ? M : {}, E(X, { name: V, newValue: T(Q, F, G) })) : typeof G < "u" && E(X, { name: V, newValue: G }));
              return X;
            };
          },
          /* 4 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.BlockEmbed = u.bubbleFormats = void 0;
            var d = function() {
              function H(C, w) {
                for (var P = 0; P < w.length; P++) {
                  var J = w[P];
                  J.enumerable = J.enumerable || !1, J.configurable = !0, "value" in J && (J.writable = !0), Object.defineProperty(C, J.key, J);
                }
              }
              return function(C, w, P) {
                return w && H(C.prototype, w), P && H(C, P), C;
              };
            }(), m = function H(C, w, P) {
              C === null && (C = Function.prototype);
              var J = Object.getOwnPropertyDescriptor(C, w);
              if (J === void 0) {
                var se = Object.getPrototypeOf(C);
                return se === null ? void 0 : H(se, w, P);
              } else {
                if ("value" in J)
                  return J.value;
                var fe = J.get;
                return fe === void 0 ? void 0 : fe.call(P);
              }
            }, v = c(3), S = X(v), $ = c(2), E = X($), O = c(0), T = X(O), y = c(16), V = X(y), M = c(6), G = X(M), k = c(7), F = X(k);
            function X(H) {
              return H && H.__esModule ? H : { default: H };
            }
            function ee(H, C) {
              if (!(H instanceof C))
                throw new TypeError("Cannot call a class as a function");
            }
            function ue(H, C) {
              if (!H)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return C && (typeof C == "object" || typeof C == "function") ? C : H;
            }
            function Q(H, C) {
              if (typeof C != "function" && C !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof C);
              H.prototype = Object.create(C && C.prototype, { constructor: { value: H, enumerable: !1, writable: !0, configurable: !0 } }), C && (Object.setPrototypeOf ? Object.setPrototypeOf(H, C) : H.__proto__ = C);
            }
            var Y = 1, pe = function(H) {
              Q(C, H);
              function C() {
                return ee(this, C), ue(this, (C.__proto__ || Object.getPrototypeOf(C)).apply(this, arguments));
              }
              return d(C, [{
                key: "attach",
                value: function() {
                  m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "attach", this).call(this), this.attributes = new T.default.Attributor.Store(this.domNode);
                }
              }, {
                key: "delta",
                value: function() {
                  return new E.default().insert(this.value(), (0, S.default)(this.formats(), this.attributes.values()));
                }
              }, {
                key: "format",
                value: function(P, J) {
                  var se = T.default.query(P, T.default.Scope.BLOCK_ATTRIBUTE);
                  se != null && this.attributes.attribute(se, J);
                }
              }, {
                key: "formatAt",
                value: function(P, J, se, fe) {
                  this.format(se, fe);
                }
              }, {
                key: "insertAt",
                value: function(P, J, se) {
                  if (typeof J == "string" && J.endsWith(`
`)) {
                    var fe = T.default.create(oe.blotName);
                    this.parent.insertBefore(fe, P === 0 ? this : this.next), fe.insertAt(0, J.slice(0, -1));
                  } else
                    m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "insertAt", this).call(this, P, J, se);
                }
              }]), C;
            }(T.default.Embed);
            pe.scope = T.default.Scope.BLOCK_BLOT;
            var oe = function(H) {
              Q(C, H);
              function C(w) {
                ee(this, C);
                var P = ue(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, w));
                return P.cache = {}, P;
              }
              return d(C, [{
                key: "delta",
                value: function() {
                  return this.cache.delta == null && (this.cache.delta = this.descendants(T.default.Leaf).reduce(function(P, J) {
                    return J.length() === 0 ? P : P.insert(J.value(), ne(J));
                  }, new E.default()).insert(`
`, ne(this))), this.cache.delta;
                }
              }, {
                key: "deleteAt",
                value: function(P, J) {
                  m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "deleteAt", this).call(this, P, J), this.cache = {};
                }
              }, {
                key: "formatAt",
                value: function(P, J, se, fe) {
                  J <= 0 || (T.default.query(se, T.default.Scope.BLOCK) ? P + J === this.length() && this.format(se, fe) : m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "formatAt", this).call(this, P, Math.min(J, this.length() - P - 1), se, fe), this.cache = {});
                }
              }, {
                key: "insertAt",
                value: function(P, J, se) {
                  if (se != null)
                    return m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "insertAt", this).call(this, P, J, se);
                  if (J.length !== 0) {
                    var fe = J.split(`
`), N = fe.shift();
                    N.length > 0 && (P < this.length() - 1 || this.children.tail == null ? m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "insertAt", this).call(this, Math.min(P, this.length() - 1), N) : this.children.tail.insertAt(this.children.tail.length(), N), this.cache = {});
                    var W = this;
                    fe.reduce(function(I, te) {
                      return W = W.split(I, !0), W.insertAt(0, te), te.length;
                    }, P + N.length);
                  }
                }
              }, {
                key: "insertBefore",
                value: function(P, J) {
                  var se = this.children.head;
                  m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "insertBefore", this).call(this, P, J), se instanceof V.default && se.remove(), this.cache = {};
                }
              }, {
                key: "length",
                value: function() {
                  return this.cache.length == null && (this.cache.length = m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "length", this).call(this) + Y), this.cache.length;
                }
              }, {
                key: "moveChildren",
                value: function(P, J) {
                  m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "moveChildren", this).call(this, P, J), this.cache = {};
                }
              }, {
                key: "optimize",
                value: function(P) {
                  m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "optimize", this).call(this, P), this.cache = {};
                }
              }, {
                key: "path",
                value: function(P) {
                  return m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "path", this).call(this, P, !0);
                }
              }, {
                key: "removeChild",
                value: function(P) {
                  m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "removeChild", this).call(this, P), this.cache = {};
                }
              }, {
                key: "split",
                value: function(P) {
                  var J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                  if (J && (P === 0 || P >= this.length() - Y)) {
                    var se = this.clone();
                    return P === 0 ? (this.parent.insertBefore(se, this), this) : (this.parent.insertBefore(se, this.next), se);
                  } else {
                    var fe = m(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "split", this).call(this, P, J);
                    return this.cache = {}, fe;
                  }
                }
              }]), C;
            }(T.default.Block);
            oe.blotName = "block", oe.tagName = "P", oe.defaultChild = "break", oe.allowedChildren = [G.default, T.default.Embed, F.default];
            function ne(H) {
              var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              return H == null || (typeof H.formats == "function" && (C = (0, S.default)(C, H.formats())), H.parent == null || H.parent.blotName == "scroll" || H.parent.statics.scope !== H.statics.scope) ? C : ne(H.parent, C);
            }
            u.bubbleFormats = ne, u.BlockEmbed = pe, u.default = oe;
          },
          /* 5 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.overload = u.expandConfig = void 0;
            var d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(W) {
              return typeof W;
            } : function(W) {
              return W && typeof Symbol == "function" && W.constructor === Symbol && W !== Symbol.prototype ? "symbol" : typeof W;
            }, m = function() {
              function W(I, te) {
                var ge = [], Pe = !0, Ke = !1, xe = void 0;
                try {
                  for (var ze = I[Symbol.iterator](), nt; !(Pe = (nt = ze.next()).done) && (ge.push(nt.value), !(te && ge.length === te)); Pe = !0)
                    ;
                } catch (Qt) {
                  Ke = !0, xe = Qt;
                } finally {
                  try {
                    !Pe && ze.return && ze.return();
                  } finally {
                    if (Ke)
                      throw xe;
                  }
                }
                return ge;
              }
              return function(I, te) {
                if (Array.isArray(I))
                  return I;
                if (Symbol.iterator in Object(I))
                  return W(I, te);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), v = function() {
              function W(I, te) {
                for (var ge = 0; ge < te.length; ge++) {
                  var Pe = te[ge];
                  Pe.enumerable = Pe.enumerable || !1, Pe.configurable = !0, "value" in Pe && (Pe.writable = !0), Object.defineProperty(I, Pe.key, Pe);
                }
              }
              return function(I, te, ge) {
                return te && W(I.prototype, te), ge && W(I, ge), I;
              };
            }();
            c(50);
            var S = c(2), $ = ne(S), E = c(14), O = ne(E), T = c(8), y = ne(T), V = c(9), M = ne(V), G = c(0), k = ne(G), F = c(15), X = ne(F), ee = c(3), ue = ne(ee), Q = c(10), Y = ne(Q), pe = c(34), oe = ne(pe);
            function ne(W) {
              return W && W.__esModule ? W : { default: W };
            }
            function H(W, I, te) {
              return I in W ? Object.defineProperty(W, I, { value: te, enumerable: !0, configurable: !0, writable: !0 }) : W[I] = te, W;
            }
            function C(W, I) {
              if (!(W instanceof I))
                throw new TypeError("Cannot call a class as a function");
            }
            var w = (0, Y.default)("quill"), P = function() {
              v(W, null, [{
                key: "debug",
                value: function(te) {
                  te === !0 && (te = "log"), Y.default.level(te);
                }
              }, {
                key: "find",
                value: function(te) {
                  return te.__quill || k.default.find(te);
                }
              }, {
                key: "import",
                value: function(te) {
                  return this.imports[te] == null && w.error("Cannot import " + te + ". Are you sure it was registered?"), this.imports[te];
                }
              }, {
                key: "register",
                value: function(te, ge) {
                  var Pe = this, Ke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                  if (typeof te != "string") {
                    var xe = te.attrName || te.blotName;
                    typeof xe == "string" ? this.register("formats/" + xe, te, ge) : Object.keys(te).forEach(function(ze) {
                      Pe.register(ze, te[ze], ge);
                    });
                  } else
                    this.imports[te] != null && !Ke && w.warn("Overwriting " + te + " with", ge), this.imports[te] = ge, (te.startsWith("blots/") || te.startsWith("formats/")) && ge.blotName !== "abstract" ? k.default.register(ge) : te.startsWith("modules") && typeof ge.register == "function" && ge.register();
                }
              }]);
              function W(I) {
                var te = this, ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (C(this, W), this.options = J(I, ge), this.container = this.options.container, this.container == null)
                  return w.error("Invalid Quill container", I);
                this.options.debug && W.debug(this.options.debug);
                var Pe = this.container.innerHTML.trim();
                this.container.classList.add("ql-container"), this.container.innerHTML = "", this.container.__quill = this, this.root = this.addContainer("ql-editor"), this.root.classList.add("ql-blank"), this.root.setAttribute("data-gramm", !1), this.scrollingContainer = this.options.scrollingContainer || this.root, this.emitter = new y.default(), this.scroll = k.default.create(this.root, {
                  emitter: this.emitter,
                  whitelist: this.options.formats
                }), this.editor = new O.default(this.scroll), this.selection = new X.default(this.scroll, this.emitter), this.theme = new this.options.theme(this, this.options), this.keyboard = this.theme.addModule("keyboard"), this.clipboard = this.theme.addModule("clipboard"), this.history = this.theme.addModule("history"), this.theme.init(), this.emitter.on(y.default.events.EDITOR_CHANGE, function(xe) {
                  xe === y.default.events.TEXT_CHANGE && te.root.classList.toggle("ql-blank", te.editor.isBlank());
                }), this.emitter.on(y.default.events.SCROLL_UPDATE, function(xe, ze) {
                  var nt = te.selection.lastRange, Qt = nt && nt.length === 0 ? nt.index : void 0;
                  se.call(te, function() {
                    return te.editor.update(null, ze, Qt);
                  }, xe);
                });
                var Ke = this.clipboard.convert(`<div class='ql-editor' style="white-space: normal;">` + Pe + "<p><br></p></div>");
                this.setContents(Ke), this.history.clear(), this.options.placeholder && this.root.setAttribute("data-placeholder", this.options.placeholder), this.options.readOnly && this.disable();
              }
              return v(W, [{
                key: "addContainer",
                value: function(te) {
                  var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                  if (typeof te == "string") {
                    var Pe = te;
                    te = document.createElement("div"), te.classList.add(Pe);
                  }
                  return this.container.insertBefore(te, ge), te;
                }
              }, {
                key: "blur",
                value: function() {
                  this.selection.setRange(null);
                }
              }, {
                key: "deleteText",
                value: function(te, ge, Pe) {
                  var Ke = this, xe = fe(te, ge, Pe), ze = m(xe, 4);
                  return te = ze[0], ge = ze[1], Pe = ze[3], se.call(this, function() {
                    return Ke.editor.deleteText(te, ge);
                  }, Pe, te, -1 * ge);
                }
              }, {
                key: "disable",
                value: function() {
                  this.enable(!1);
                }
              }, {
                key: "enable",
                value: function() {
                  var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                  this.scroll.enable(te), this.container.classList.toggle("ql-disabled", !te);
                }
              }, {
                key: "focus",
                value: function() {
                  var te = this.scrollingContainer.scrollTop;
                  this.selection.focus(), this.scrollingContainer.scrollTop = te, this.scrollIntoView();
                }
              }, {
                key: "format",
                value: function(te, ge) {
                  var Pe = this, Ke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : y.default.sources.API;
                  return se.call(this, function() {
                    var xe = Pe.getSelection(!0), ze = new $.default();
                    if (xe == null)
                      return ze;
                    if (k.default.query(te, k.default.Scope.BLOCK))
                      ze = Pe.editor.formatLine(xe.index, xe.length, H({}, te, ge));
                    else {
                      if (xe.length === 0)
                        return Pe.selection.format(te, ge), ze;
                      ze = Pe.editor.formatText(xe.index, xe.length, H({}, te, ge));
                    }
                    return Pe.setSelection(xe, y.default.sources.SILENT), ze;
                  }, Ke);
                }
              }, {
                key: "formatLine",
                value: function(te, ge, Pe, Ke, xe) {
                  var ze = this, nt = void 0, Qt = fe(te, ge, Pe, Ke, xe), Et = m(Qt, 4);
                  return te = Et[0], ge = Et[1], nt = Et[2], xe = Et[3], se.call(this, function() {
                    return ze.editor.formatLine(te, ge, nt);
                  }, xe, te, 0);
                }
              }, {
                key: "formatText",
                value: function(te, ge, Pe, Ke, xe) {
                  var ze = this, nt = void 0, Qt = fe(te, ge, Pe, Ke, xe), Et = m(Qt, 4);
                  return te = Et[0], ge = Et[1], nt = Et[2], xe = Et[3], se.call(this, function() {
                    return ze.editor.formatText(te, ge, nt);
                  }, xe, te, 0);
                }
              }, {
                key: "getBounds",
                value: function(te) {
                  var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Pe = void 0;
                  typeof te == "number" ? Pe = this.selection.getBounds(te, ge) : Pe = this.selection.getBounds(te.index, te.length);
                  var Ke = this.container.getBoundingClientRect();
                  return {
                    bottom: Pe.bottom - Ke.top,
                    height: Pe.height,
                    left: Pe.left - Ke.left,
                    right: Pe.right - Ke.left,
                    top: Pe.top - Ke.top,
                    width: Pe.width
                  };
                }
              }, {
                key: "getContents",
                value: function() {
                  var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - te, Pe = fe(te, ge), Ke = m(Pe, 2);
                  return te = Ke[0], ge = Ke[1], this.editor.getContents(te, ge);
                }
              }, {
                key: "getFormat",
                value: function() {
                  var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getSelection(!0), ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                  return typeof te == "number" ? this.editor.getFormat(te, ge) : this.editor.getFormat(te.index, te.length);
                }
              }, {
                key: "getIndex",
                value: function(te) {
                  return te.offset(this.scroll);
                }
              }, {
                key: "getLength",
                value: function() {
                  return this.scroll.length();
                }
              }, {
                key: "getLeaf",
                value: function(te) {
                  return this.scroll.leaf(te);
                }
              }, {
                key: "getLine",
                value: function(te) {
                  return this.scroll.line(te);
                }
              }, {
                key: "getLines",
                value: function() {
                  var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
                  return typeof te != "number" ? this.scroll.lines(te.index, te.length) : this.scroll.lines(te, ge);
                }
              }, {
                key: "getModule",
                value: function(te) {
                  return this.theme.modules[te];
                }
              }, {
                key: "getSelection",
                value: function() {
                  var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                  return te && this.focus(), this.update(), this.selection.getRange()[0];
                }
              }, {
                key: "getText",
                value: function() {
                  var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - te, Pe = fe(te, ge), Ke = m(Pe, 2);
                  return te = Ke[0], ge = Ke[1], this.editor.getText(te, ge);
                }
              }, {
                key: "hasFocus",
                value: function() {
                  return this.selection.hasFocus();
                }
              }, {
                key: "insertEmbed",
                value: function(te, ge, Pe) {
                  var Ke = this, xe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : W.sources.API;
                  return se.call(this, function() {
                    return Ke.editor.insertEmbed(te, ge, Pe);
                  }, xe, te);
                }
              }, {
                key: "insertText",
                value: function(te, ge, Pe, Ke, xe) {
                  var ze = this, nt = void 0, Qt = fe(te, 0, Pe, Ke, xe), Et = m(Qt, 4);
                  return te = Et[0], nt = Et[2], xe = Et[3], se.call(this, function() {
                    return ze.editor.insertText(te, ge, nt);
                  }, xe, te, ge.length);
                }
              }, {
                key: "isEnabled",
                value: function() {
                  return !this.container.classList.contains("ql-disabled");
                }
              }, {
                key: "off",
                value: function() {
                  return this.emitter.off.apply(this.emitter, arguments);
                }
              }, {
                key: "on",
                value: function() {
                  return this.emitter.on.apply(this.emitter, arguments);
                }
              }, {
                key: "once",
                value: function() {
                  return this.emitter.once.apply(this.emitter, arguments);
                }
              }, {
                key: "pasteHTML",
                value: function(te, ge, Pe) {
                  this.clipboard.dangerouslyPasteHTML(te, ge, Pe);
                }
              }, {
                key: "removeFormat",
                value: function(te, ge, Pe) {
                  var Ke = this, xe = fe(te, ge, Pe), ze = m(xe, 4);
                  return te = ze[0], ge = ze[1], Pe = ze[3], se.call(this, function() {
                    return Ke.editor.removeFormat(te, ge);
                  }, Pe, te);
                }
              }, {
                key: "scrollIntoView",
                value: function() {
                  this.selection.scrollIntoView(this.scrollingContainer);
                }
              }, {
                key: "setContents",
                value: function(te) {
                  var ge = this, Pe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : y.default.sources.API;
                  return se.call(this, function() {
                    te = new $.default(te);
                    var Ke = ge.getLength(), xe = ge.editor.deleteText(0, Ke), ze = ge.editor.applyDelta(te), nt = ze.ops[ze.ops.length - 1];
                    nt != null && typeof nt.insert == "string" && nt.insert[nt.insert.length - 1] === `
` && (ge.editor.deleteText(ge.getLength() - 1, 1), ze.delete(1));
                    var Qt = xe.compose(ze);
                    return Qt;
                  }, Pe);
                }
              }, {
                key: "setSelection",
                value: function(te, ge, Pe) {
                  if (te == null)
                    this.selection.setRange(null, ge || W.sources.API);
                  else {
                    var Ke = fe(te, ge, Pe), xe = m(Ke, 4);
                    te = xe[0], ge = xe[1], Pe = xe[3], this.selection.setRange(new F.Range(te, ge), Pe), Pe !== y.default.sources.SILENT && this.selection.scrollIntoView(this.scrollingContainer);
                  }
                }
              }, {
                key: "setText",
                value: function(te) {
                  var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : y.default.sources.API, Pe = new $.default().insert(te);
                  return this.setContents(Pe, ge);
                }
              }, {
                key: "update",
                value: function() {
                  var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : y.default.sources.USER, ge = this.scroll.update(te);
                  return this.selection.update(te), ge;
                }
              }, {
                key: "updateContents",
                value: function(te) {
                  var ge = this, Pe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : y.default.sources.API;
                  return se.call(this, function() {
                    return te = new $.default(te), ge.editor.applyDelta(te, Pe);
                  }, Pe, !0);
                }
              }]), W;
            }();
            P.DEFAULTS = {
              bounds: null,
              formats: null,
              modules: {},
              placeholder: "",
              readOnly: !1,
              scrollingContainer: null,
              strict: !0,
              theme: "default"
            }, P.events = y.default.events, P.sources = y.default.sources, P.version = "1.3.7", P.imports = {
              delta: $.default,
              parchment: k.default,
              "core/module": M.default,
              "core/theme": oe.default
            };
            function J(W, I) {
              if (I = (0, ue.default)(!0, {
                container: W,
                modules: {
                  clipboard: !0,
                  keyboard: !0,
                  history: !0
                }
              }, I), !I.theme || I.theme === P.DEFAULTS.theme)
                I.theme = oe.default;
              else if (I.theme = P.import("themes/" + I.theme), I.theme == null)
                throw new Error("Invalid theme " + I.theme + ". Did you register it?");
              var te = (0, ue.default)(!0, {}, I.theme.DEFAULTS);
              [te, I].forEach(function(Ke) {
                Ke.modules = Ke.modules || {}, Object.keys(Ke.modules).forEach(function(xe) {
                  Ke.modules[xe] === !0 && (Ke.modules[xe] = {});
                });
              });
              var ge = Object.keys(te.modules).concat(Object.keys(I.modules)), Pe = ge.reduce(function(Ke, xe) {
                var ze = P.import("modules/" + xe);
                return ze == null ? w.error("Cannot load " + xe + " module. Are you sure you registered it?") : Ke[xe] = ze.DEFAULTS || {}, Ke;
              }, {});
              return I.modules != null && I.modules.toolbar && I.modules.toolbar.constructor !== Object && (I.modules.toolbar = {
                container: I.modules.toolbar
              }), I = (0, ue.default)(!0, {}, P.DEFAULTS, { modules: Pe }, te, I), ["bounds", "container", "scrollingContainer"].forEach(function(Ke) {
                typeof I[Ke] == "string" && (I[Ke] = document.querySelector(I[Ke]));
              }), I.modules = Object.keys(I.modules).reduce(function(Ke, xe) {
                return I.modules[xe] && (Ke[xe] = I.modules[xe]), Ke;
              }, {}), I;
            }
            function se(W, I, te, ge) {
              if (this.options.strict && !this.isEnabled() && I === y.default.sources.USER)
                return new $.default();
              var Pe = te == null ? null : this.getSelection(), Ke = this.editor.delta, xe = W();
              if (Pe != null && (te === !0 && (te = Pe.index), ge == null ? Pe = N(Pe, xe, I) : ge !== 0 && (Pe = N(Pe, te, ge, I)), this.setSelection(Pe, y.default.sources.SILENT)), xe.length() > 0) {
                var ze, nt = [y.default.events.TEXT_CHANGE, xe, Ke, I];
                if ((ze = this.emitter).emit.apply(ze, [y.default.events.EDITOR_CHANGE].concat(nt)), I !== y.default.sources.SILENT) {
                  var Qt;
                  (Qt = this.emitter).emit.apply(Qt, nt);
                }
              }
              return xe;
            }
            function fe(W, I, te, ge, Pe) {
              var Ke = {};
              return typeof W.index == "number" && typeof W.length == "number" ? typeof I != "number" ? (Pe = ge, ge = te, te = I, I = W.length, W = W.index) : (I = W.length, W = W.index) : typeof I != "number" && (Pe = ge, ge = te, te = I, I = 0), (typeof te > "u" ? "undefined" : d(te)) === "object" ? (Ke = te, Pe = ge) : typeof te == "string" && (ge != null ? Ke[te] = ge : Pe = te), Pe = Pe || y.default.sources.API, [W, I, Ke, Pe];
            }
            function N(W, I, te, ge) {
              if (W == null)
                return null;
              var Pe = void 0, Ke = void 0;
              if (I instanceof $.default) {
                var xe = [W.index, W.index + W.length].map(function(Et) {
                  return I.transformPosition(Et, ge !== y.default.sources.USER);
                }), ze = m(xe, 2);
                Pe = ze[0], Ke = ze[1];
              } else {
                var nt = [W.index, W.index + W.length].map(function(Et) {
                  return Et < I || Et === I && ge === y.default.sources.USER ? Et : te >= 0 ? Et + te : Math.max(I, Et + te);
                }), Qt = m(nt, 2);
                Pe = Qt[0], Ke = Qt[1];
              }
              return new F.Range(Pe, Ke - Pe);
            }
            u.expandConfig = J, u.overload = fe, u.default = P;
          },
          /* 6 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function G(k, F) {
                for (var X = 0; X < F.length; X++) {
                  var ee = F[X];
                  ee.enumerable = ee.enumerable || !1, ee.configurable = !0, "value" in ee && (ee.writable = !0), Object.defineProperty(k, ee.key, ee);
                }
              }
              return function(k, F, X) {
                return F && G(k.prototype, F), X && G(k, X), k;
              };
            }(), m = function G(k, F, X) {
              k === null && (k = Function.prototype);
              var ee = Object.getOwnPropertyDescriptor(k, F);
              if (ee === void 0) {
                var ue = Object.getPrototypeOf(k);
                return ue === null ? void 0 : G(ue, F, X);
              } else {
                if ("value" in ee)
                  return ee.value;
                var Q = ee.get;
                return Q === void 0 ? void 0 : Q.call(X);
              }
            }, v = c(7), S = O(v), $ = c(0), E = O($);
            function O(G) {
              return G && G.__esModule ? G : { default: G };
            }
            function T(G, k) {
              if (!(G instanceof k))
                throw new TypeError("Cannot call a class as a function");
            }
            function y(G, k) {
              if (!G)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return k && (typeof k == "object" || typeof k == "function") ? k : G;
            }
            function V(G, k) {
              if (typeof k != "function" && k !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof k);
              G.prototype = Object.create(k && k.prototype, { constructor: { value: G, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(G, k) : G.__proto__ = k);
            }
            var M = function(G) {
              V(k, G);
              function k() {
                return T(this, k), y(this, (k.__proto__ || Object.getPrototypeOf(k)).apply(this, arguments));
              }
              return d(k, [{
                key: "formatAt",
                value: function(X, ee, ue, Q) {
                  if (k.compare(this.statics.blotName, ue) < 0 && E.default.query(ue, E.default.Scope.BLOT)) {
                    var Y = this.isolate(X, ee);
                    Q && Y.wrap(ue, Q);
                  } else
                    m(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "formatAt", this).call(this, X, ee, ue, Q);
                }
              }, {
                key: "optimize",
                value: function(X) {
                  if (m(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "optimize", this).call(this, X), this.parent instanceof k && k.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                    var ee = this.parent.isolate(this.offset(), this.length());
                    this.moveChildren(ee), ee.wrap(this);
                  }
                }
              }], [{
                key: "compare",
                value: function(X, ee) {
                  var ue = k.order.indexOf(X), Q = k.order.indexOf(ee);
                  return ue >= 0 || Q >= 0 ? ue - Q : X === ee ? 0 : X < ee ? -1 : 1;
                }
              }]), k;
            }(E.default.Inline);
            M.allowedChildren = [M, E.default.Embed, S.default], M.order = [
              "cursor",
              "inline",
              // Must be lower
              "underline",
              "strike",
              "italic",
              "bold",
              "script",
              "link",
              "code"
              // Must be higher
            ], u.default = M;
          },
          /* 7 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = c(0), m = v(d);
            function v(T) {
              return T && T.__esModule ? T : { default: T };
            }
            function S(T, y) {
              if (!(T instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function $(T, y) {
              if (!T)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y && (typeof y == "object" || typeof y == "function") ? y : T;
            }
            function E(T, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof y);
              T.prototype = Object.create(y && y.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(T, y) : T.__proto__ = y);
            }
            var O = function(T) {
              E(y, T);
              function y() {
                return S(this, y), $(this, (y.__proto__ || Object.getPrototypeOf(y)).apply(this, arguments));
              }
              return y;
            }(m.default.Text);
            u.default = O;
          },
          /* 8 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function F(X, ee) {
                for (var ue = 0; ue < ee.length; ue++) {
                  var Q = ee[ue];
                  Q.enumerable = Q.enumerable || !1, Q.configurable = !0, "value" in Q && (Q.writable = !0), Object.defineProperty(X, Q.key, Q);
                }
              }
              return function(X, ee, ue) {
                return ee && F(X.prototype, ee), ue && F(X, ue), X;
              };
            }(), m = function F(X, ee, ue) {
              X === null && (X = Function.prototype);
              var Q = Object.getOwnPropertyDescriptor(X, ee);
              if (Q === void 0) {
                var Y = Object.getPrototypeOf(X);
                return Y === null ? void 0 : F(Y, ee, ue);
              } else {
                if ("value" in Q)
                  return Q.value;
                var pe = Q.get;
                return pe === void 0 ? void 0 : pe.call(ue);
              }
            }, v = c(54), S = O(v), $ = c(10), E = O($);
            function O(F) {
              return F && F.__esModule ? F : { default: F };
            }
            function T(F, X) {
              if (!(F instanceof X))
                throw new TypeError("Cannot call a class as a function");
            }
            function y(F, X) {
              if (!F)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return X && (typeof X == "object" || typeof X == "function") ? X : F;
            }
            function V(F, X) {
              if (typeof X != "function" && X !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof X);
              F.prototype = Object.create(X && X.prototype, { constructor: { value: F, enumerable: !1, writable: !0, configurable: !0 } }), X && (Object.setPrototypeOf ? Object.setPrototypeOf(F, X) : F.__proto__ = X);
            }
            var M = (0, E.default)("quill:events"), G = ["selectionchange", "mousedown", "mouseup", "click"];
            G.forEach(function(F) {
              document.addEventListener(F, function() {
                for (var X = arguments.length, ee = Array(X), ue = 0; ue < X; ue++)
                  ee[ue] = arguments[ue];
                [].slice.call(document.querySelectorAll(".ql-container")).forEach(function(Q) {
                  if (Q.__quill && Q.__quill.emitter) {
                    var Y;
                    (Y = Q.__quill.emitter).handleDOM.apply(Y, ee);
                  }
                });
              });
            });
            var k = function(F) {
              V(X, F);
              function X() {
                T(this, X);
                var ee = y(this, (X.__proto__ || Object.getPrototypeOf(X)).call(this));
                return ee.listeners = {}, ee.on("error", M.error), ee;
              }
              return d(X, [{
                key: "emit",
                value: function() {
                  M.log.apply(M, arguments), m(X.prototype.__proto__ || Object.getPrototypeOf(X.prototype), "emit", this).apply(this, arguments);
                }
              }, {
                key: "handleDOM",
                value: function(ue) {
                  for (var Q = arguments.length, Y = Array(Q > 1 ? Q - 1 : 0), pe = 1; pe < Q; pe++)
                    Y[pe - 1] = arguments[pe];
                  (this.listeners[ue.type] || []).forEach(function(oe) {
                    var ne = oe.node, H = oe.handler;
                    (ue.target === ne || ne.contains(ue.target)) && H.apply(void 0, [ue].concat(Y));
                  });
                }
              }, {
                key: "listenDOM",
                value: function(ue, Q, Y) {
                  this.listeners[ue] || (this.listeners[ue] = []), this.listeners[ue].push({ node: Q, handler: Y });
                }
              }]), X;
            }(S.default);
            k.events = {
              EDITOR_CHANGE: "editor-change",
              SCROLL_BEFORE_UPDATE: "scroll-before-update",
              SCROLL_OPTIMIZE: "scroll-optimize",
              SCROLL_UPDATE: "scroll-update",
              SELECTION_CHANGE: "selection-change",
              TEXT_CHANGE: "text-change"
            }, k.sources = {
              API: "api",
              SILENT: "silent",
              USER: "user"
            }, u.default = k;
          },
          /* 9 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            function d(v, S) {
              if (!(v instanceof S))
                throw new TypeError("Cannot call a class as a function");
            }
            var m = function v(S) {
              var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              d(this, v), this.quill = S, this.options = $;
            };
            m.DEFAULTS = {}, u.default = m;
          },
          /* 10 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = ["error", "warn", "log", "info"], m = "warn";
            function v($) {
              if (d.indexOf($) <= d.indexOf(m)) {
                for (var E, O = arguments.length, T = Array(O > 1 ? O - 1 : 0), y = 1; y < O; y++)
                  T[y - 1] = arguments[y];
                (E = console)[$].apply(E, T);
              }
            }
            function S($) {
              return d.reduce(function(E, O) {
                return E[O] = v.bind(console, O, $), E;
              }, {});
            }
            v.level = S.level = function($) {
              m = $;
            }, u.default = S;
          },
          /* 11 */
          /***/
          function(o, u, c) {
            var d = Array.prototype.slice, m = c(52), v = c(53), S = o.exports = function(T, y, V) {
              return V || (V = {}), T === y ? !0 : T instanceof Date && y instanceof Date ? T.getTime() === y.getTime() : !T || !y || typeof T != "object" && typeof y != "object" ? V.strict ? T === y : T == y : O(T, y, V);
            };
            function $(T) {
              return T == null;
            }
            function E(T) {
              return !(!T || typeof T != "object" || typeof T.length != "number" || typeof T.copy != "function" || typeof T.slice != "function" || T.length > 0 && typeof T[0] != "number");
            }
            function O(T, y, V) {
              var M, G;
              if ($(T) || $(y) || T.prototype !== y.prototype)
                return !1;
              if (v(T))
                return v(y) ? (T = d.call(T), y = d.call(y), S(T, y, V)) : !1;
              if (E(T)) {
                if (!E(y) || T.length !== y.length)
                  return !1;
                for (M = 0; M < T.length; M++)
                  if (T[M] !== y[M])
                    return !1;
                return !0;
              }
              try {
                var k = m(T), F = m(y);
              } catch {
                return !1;
              }
              if (k.length != F.length)
                return !1;
              for (k.sort(), F.sort(), M = k.length - 1; M >= 0; M--)
                if (k[M] != F[M])
                  return !1;
              for (M = k.length - 1; M >= 0; M--)
                if (G = k[M], !S(T[G], y[G], V))
                  return !1;
              return typeof T == typeof y;
            }
          },
          /* 12 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", { value: !0 });
            var d = c(1), m = (
              /** @class */
              function() {
                function v(S, $, E) {
                  E === void 0 && (E = {}), this.attrName = S, this.keyName = $;
                  var O = d.Scope.TYPE & d.Scope.ATTRIBUTE;
                  E.scope != null ? this.scope = E.scope & d.Scope.LEVEL | O : this.scope = d.Scope.ATTRIBUTE, E.whitelist != null && (this.whitelist = E.whitelist);
                }
                return v.keys = function(S) {
                  return [].map.call(S.attributes, function($) {
                    return $.name;
                  });
                }, v.prototype.add = function(S, $) {
                  return this.canAdd(S, $) ? (S.setAttribute(this.keyName, $), !0) : !1;
                }, v.prototype.canAdd = function(S, $) {
                  var E = d.query(S, d.Scope.BLOT & (this.scope | d.Scope.TYPE));
                  return E == null ? !1 : this.whitelist == null ? !0 : typeof $ == "string" ? this.whitelist.indexOf($.replace(/["']/g, "")) > -1 : this.whitelist.indexOf($) > -1;
                }, v.prototype.remove = function(S) {
                  S.removeAttribute(this.keyName);
                }, v.prototype.value = function(S) {
                  var $ = S.getAttribute(this.keyName);
                  return this.canAdd(S, $) && $ ? $ : "";
                }, v;
              }()
            );
            u.default = m;
          },
          /* 13 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.Code = void 0;
            var d = function() {
              function pe(oe, ne) {
                var H = [], C = !0, w = !1, P = void 0;
                try {
                  for (var J = oe[Symbol.iterator](), se; !(C = (se = J.next()).done) && (H.push(se.value), !(ne && H.length === ne)); C = !0)
                    ;
                } catch (fe) {
                  w = !0, P = fe;
                } finally {
                  try {
                    !C && J.return && J.return();
                  } finally {
                    if (w)
                      throw P;
                  }
                }
                return H;
              }
              return function(oe, ne) {
                if (Array.isArray(oe))
                  return oe;
                if (Symbol.iterator in Object(oe))
                  return pe(oe, ne);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), m = function() {
              function pe(oe, ne) {
                for (var H = 0; H < ne.length; H++) {
                  var C = ne[H];
                  C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(oe, C.key, C);
                }
              }
              return function(oe, ne, H) {
                return ne && pe(oe.prototype, ne), H && pe(oe, H), oe;
              };
            }(), v = function pe(oe, ne, H) {
              oe === null && (oe = Function.prototype);
              var C = Object.getOwnPropertyDescriptor(oe, ne);
              if (C === void 0) {
                var w = Object.getPrototypeOf(oe);
                return w === null ? void 0 : pe(w, ne, H);
              } else {
                if ("value" in C)
                  return C.value;
                var P = C.get;
                return P === void 0 ? void 0 : P.call(H);
              }
            }, S = c(2), $ = F(S), E = c(0), O = F(E), T = c(4), y = F(T), V = c(6), M = F(V), G = c(7), k = F(G);
            function F(pe) {
              return pe && pe.__esModule ? pe : { default: pe };
            }
            function X(pe, oe) {
              if (!(pe instanceof oe))
                throw new TypeError("Cannot call a class as a function");
            }
            function ee(pe, oe) {
              if (!pe)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return oe && (typeof oe == "object" || typeof oe == "function") ? oe : pe;
            }
            function ue(pe, oe) {
              if (typeof oe != "function" && oe !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof oe);
              pe.prototype = Object.create(oe && oe.prototype, { constructor: { value: pe, enumerable: !1, writable: !0, configurable: !0 } }), oe && (Object.setPrototypeOf ? Object.setPrototypeOf(pe, oe) : pe.__proto__ = oe);
            }
            var Q = function(pe) {
              ue(oe, pe);
              function oe() {
                return X(this, oe), ee(this, (oe.__proto__ || Object.getPrototypeOf(oe)).apply(this, arguments));
              }
              return oe;
            }(M.default);
            Q.blotName = "code", Q.tagName = "CODE";
            var Y = function(pe) {
              ue(oe, pe);
              function oe() {
                return X(this, oe), ee(this, (oe.__proto__ || Object.getPrototypeOf(oe)).apply(this, arguments));
              }
              return m(oe, [{
                key: "delta",
                value: function() {
                  var H = this, C = this.domNode.textContent;
                  return C.endsWith(`
`) && (C = C.slice(0, -1)), C.split(`
`).reduce(function(w, P) {
                    return w.insert(P).insert(`
`, H.formats());
                  }, new $.default());
                }
              }, {
                key: "format",
                value: function(H, C) {
                  if (!(H === this.statics.blotName && C)) {
                    var w = this.descendant(k.default, this.length() - 1), P = d(w, 1), J = P[0];
                    J != null && J.deleteAt(J.length() - 1, 1), v(oe.prototype.__proto__ || Object.getPrototypeOf(oe.prototype), "format", this).call(this, H, C);
                  }
                }
              }, {
                key: "formatAt",
                value: function(H, C, w, P) {
                  if (C !== 0 && !(O.default.query(w, O.default.Scope.BLOCK) == null || w === this.statics.blotName && P === this.statics.formats(this.domNode))) {
                    var J = this.newlineIndex(H);
                    if (!(J < 0 || J >= H + C)) {
                      var se = this.newlineIndex(H, !0) + 1, fe = J - se + 1, N = this.isolate(se, fe), W = N.next;
                      N.format(w, P), W instanceof oe && W.formatAt(0, H - se + C - fe, w, P);
                    }
                  }
                }
              }, {
                key: "insertAt",
                value: function(H, C, w) {
                  if (w == null) {
                    var P = this.descendant(k.default, H), J = d(P, 2), se = J[0], fe = J[1];
                    se.insertAt(fe, C);
                  }
                }
              }, {
                key: "length",
                value: function() {
                  var H = this.domNode.textContent.length;
                  return this.domNode.textContent.endsWith(`
`) ? H : H + 1;
                }
              }, {
                key: "newlineIndex",
                value: function(H) {
                  var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                  if (C)
                    return this.domNode.textContent.slice(0, H).lastIndexOf(`
`);
                  var w = this.domNode.textContent.slice(H).indexOf(`
`);
                  return w > -1 ? H + w : -1;
                }
              }, {
                key: "optimize",
                value: function(H) {
                  this.domNode.textContent.endsWith(`
`) || this.appendChild(O.default.create("text", `
`)), v(oe.prototype.__proto__ || Object.getPrototypeOf(oe.prototype), "optimize", this).call(this, H);
                  var C = this.next;
                  C != null && C.prev === this && C.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === C.statics.formats(C.domNode) && (C.optimize(H), C.moveChildren(this), C.remove());
                }
              }, {
                key: "replace",
                value: function(H) {
                  v(oe.prototype.__proto__ || Object.getPrototypeOf(oe.prototype), "replace", this).call(this, H), [].slice.call(this.domNode.querySelectorAll("*")).forEach(function(C) {
                    var w = O.default.find(C);
                    w == null ? C.parentNode.removeChild(C) : w instanceof O.default.Embed ? w.remove() : w.unwrap();
                  });
                }
              }], [{
                key: "create",
                value: function(H) {
                  var C = v(oe.__proto__ || Object.getPrototypeOf(oe), "create", this).call(this, H);
                  return C.setAttribute("spellcheck", !1), C;
                }
              }, {
                key: "formats",
                value: function() {
                  return !0;
                }
              }]), oe;
            }(y.default);
            Y.blotName = "code-block", Y.tagName = "PRE", Y.TAB = "  ", u.Code = Q, u.default = Y;
          },
          /* 14 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(W) {
              return typeof W;
            } : function(W) {
              return W && typeof Symbol == "function" && W.constructor === Symbol && W !== Symbol.prototype ? "symbol" : typeof W;
            }, m = function() {
              function W(I, te) {
                var ge = [], Pe = !0, Ke = !1, xe = void 0;
                try {
                  for (var ze = I[Symbol.iterator](), nt; !(Pe = (nt = ze.next()).done) && (ge.push(nt.value), !(te && ge.length === te)); Pe = !0)
                    ;
                } catch (Qt) {
                  Ke = !0, xe = Qt;
                } finally {
                  try {
                    !Pe && ze.return && ze.return();
                  } finally {
                    if (Ke)
                      throw xe;
                  }
                }
                return ge;
              }
              return function(I, te) {
                if (Array.isArray(I))
                  return I;
                if (Symbol.iterator in Object(I))
                  return W(I, te);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), v = function() {
              function W(I, te) {
                for (var ge = 0; ge < te.length; ge++) {
                  var Pe = te[ge];
                  Pe.enumerable = Pe.enumerable || !1, Pe.configurable = !0, "value" in Pe && (Pe.writable = !0), Object.defineProperty(I, Pe.key, Pe);
                }
              }
              return function(I, te, ge) {
                return te && W(I.prototype, te), ge && W(I, ge), I;
              };
            }(), S = c(2), $ = C(S), E = c(20), O = C(E), T = c(0), y = C(T), V = c(13), M = C(V), G = c(24), k = C(G), F = c(4), X = C(F), ee = c(16), ue = C(ee), Q = c(21), Y = C(Q), pe = c(11), oe = C(pe), ne = c(3), H = C(ne);
            function C(W) {
              return W && W.__esModule ? W : { default: W };
            }
            function w(W, I, te) {
              return I in W ? Object.defineProperty(W, I, { value: te, enumerable: !0, configurable: !0, writable: !0 }) : W[I] = te, W;
            }
            function P(W, I) {
              if (!(W instanceof I))
                throw new TypeError("Cannot call a class as a function");
            }
            var J = /^[ -~]*$/, se = function() {
              function W(I) {
                P(this, W), this.scroll = I, this.delta = this.getDelta();
              }
              return v(W, [{
                key: "applyDelta",
                value: function(te) {
                  var ge = this, Pe = !1;
                  this.scroll.update();
                  var Ke = this.scroll.length();
                  return this.scroll.batchStart(), te = N(te), te.reduce(function(xe, ze) {
                    var nt = ze.retain || ze.delete || ze.insert.length || 1, Qt = ze.attributes || {};
                    if (ze.insert != null) {
                      if (typeof ze.insert == "string") {
                        var Et = ze.insert;
                        Et.endsWith(`
`) && Pe && (Pe = !1, Et = Et.slice(0, -1)), xe >= Ke && !Et.endsWith(`
`) && (Pe = !0), ge.scroll.insertAt(xe, Et);
                        var zt = ge.scroll.line(xe), Nt = m(zt, 2), pt = Nt[0], at = Nt[1], kt = (0, H.default)({}, (0, F.bubbleFormats)(pt));
                        if (pt instanceof X.default) {
                          var Ut = pt.descendant(y.default.Leaf, at), dn = m(Ut, 1), En = dn[0];
                          kt = (0, H.default)(kt, (0, F.bubbleFormats)(En));
                        }
                        Qt = O.default.attributes.diff(kt, Qt) || {};
                      } else if (d(ze.insert) === "object") {
                        var Ht = Object.keys(ze.insert)[0];
                        if (Ht == null)
                          return xe;
                        ge.scroll.insertAt(xe, Ht, ze.insert[Ht]);
                      }
                      Ke += nt;
                    }
                    return Object.keys(Qt).forEach(function(Xt) {
                      ge.scroll.formatAt(xe, nt, Xt, Qt[Xt]);
                    }), xe + nt;
                  }, 0), te.reduce(function(xe, ze) {
                    return typeof ze.delete == "number" ? (ge.scroll.deleteAt(xe, ze.delete), xe) : xe + (ze.retain || ze.insert.length || 1);
                  }, 0), this.scroll.batchEnd(), this.update(te);
                }
              }, {
                key: "deleteText",
                value: function(te, ge) {
                  return this.scroll.deleteAt(te, ge), this.update(new $.default().retain(te).delete(ge));
                }
              }, {
                key: "formatLine",
                value: function(te, ge) {
                  var Pe = this, Ke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                  return this.scroll.update(), Object.keys(Ke).forEach(function(xe) {
                    if (!(Pe.scroll.whitelist != null && !Pe.scroll.whitelist[xe])) {
                      var ze = Pe.scroll.lines(te, Math.max(ge, 1)), nt = ge;
                      ze.forEach(function(Qt) {
                        var Et = Qt.length();
                        if (!(Qt instanceof M.default))
                          Qt.format(xe, Ke[xe]);
                        else {
                          var zt = te - Qt.offset(Pe.scroll), Nt = Qt.newlineIndex(zt + nt) - zt + 1;
                          Qt.formatAt(zt, Nt, xe, Ke[xe]);
                        }
                        nt -= Et;
                      });
                    }
                  }), this.scroll.optimize(), this.update(new $.default().retain(te).retain(ge, (0, Y.default)(Ke)));
                }
              }, {
                key: "formatText",
                value: function(te, ge) {
                  var Pe = this, Ke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                  return Object.keys(Ke).forEach(function(xe) {
                    Pe.scroll.formatAt(te, ge, xe, Ke[xe]);
                  }), this.update(new $.default().retain(te).retain(ge, (0, Y.default)(Ke)));
                }
              }, {
                key: "getContents",
                value: function(te, ge) {
                  return this.delta.slice(te, te + ge);
                }
              }, {
                key: "getDelta",
                value: function() {
                  return this.scroll.lines().reduce(function(te, ge) {
                    return te.concat(ge.delta());
                  }, new $.default());
                }
              }, {
                key: "getFormat",
                value: function(te) {
                  var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Pe = [], Ke = [];
                  ge === 0 ? this.scroll.path(te).forEach(function(ze) {
                    var nt = m(ze, 1), Qt = nt[0];
                    Qt instanceof X.default ? Pe.push(Qt) : Qt instanceof y.default.Leaf && Ke.push(Qt);
                  }) : (Pe = this.scroll.lines(te, ge), Ke = this.scroll.descendants(y.default.Leaf, te, ge));
                  var xe = [Pe, Ke].map(function(ze) {
                    if (ze.length === 0)
                      return {};
                    for (var nt = (0, F.bubbleFormats)(ze.shift()); Object.keys(nt).length > 0; ) {
                      var Qt = ze.shift();
                      if (Qt == null)
                        return nt;
                      nt = fe((0, F.bubbleFormats)(Qt), nt);
                    }
                    return nt;
                  });
                  return H.default.apply(H.default, xe);
                }
              }, {
                key: "getText",
                value: function(te, ge) {
                  return this.getContents(te, ge).filter(function(Pe) {
                    return typeof Pe.insert == "string";
                  }).map(function(Pe) {
                    return Pe.insert;
                  }).join("");
                }
              }, {
                key: "insertEmbed",
                value: function(te, ge, Pe) {
                  return this.scroll.insertAt(te, ge, Pe), this.update(new $.default().retain(te).insert(w({}, ge, Pe)));
                }
              }, {
                key: "insertText",
                value: function(te, ge) {
                  var Pe = this, Ke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                  return ge = ge.replace(/\r\n/g, `
`).replace(/\r/g, `
`), this.scroll.insertAt(te, ge), Object.keys(Ke).forEach(function(xe) {
                    Pe.scroll.formatAt(te, ge.length, xe, Ke[xe]);
                  }), this.update(new $.default().retain(te).insert(ge, (0, Y.default)(Ke)));
                }
              }, {
                key: "isBlank",
                value: function() {
                  if (this.scroll.children.length == 0)
                    return !0;
                  if (this.scroll.children.length > 1)
                    return !1;
                  var te = this.scroll.children.head;
                  return te.statics.blotName !== X.default.blotName || te.children.length > 1 ? !1 : te.children.head instanceof ue.default;
                }
              }, {
                key: "removeFormat",
                value: function(te, ge) {
                  var Pe = this.getText(te, ge), Ke = this.scroll.line(te + ge), xe = m(Ke, 2), ze = xe[0], nt = xe[1], Qt = 0, Et = new $.default();
                  ze != null && (ze instanceof M.default ? Qt = ze.newlineIndex(nt) - nt + 1 : Qt = ze.length() - nt, Et = ze.delta().slice(nt, nt + Qt - 1).insert(`
`));
                  var zt = this.getContents(te, ge + Qt), Nt = zt.diff(new $.default().insert(Pe).concat(Et)), pt = new $.default().retain(te).concat(Nt);
                  return this.applyDelta(pt);
                }
              }, {
                key: "update",
                value: function(te) {
                  var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], Pe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, Ke = this.delta;
                  if (ge.length === 1 && ge[0].type === "characterData" && ge[0].target.data.match(J) && y.default.find(ge[0].target)) {
                    var xe = y.default.find(ge[0].target), ze = (0, F.bubbleFormats)(xe), nt = xe.offset(this.scroll), Qt = ge[0].oldValue.replace(k.default.CONTENTS, ""), Et = new $.default().insert(Qt), zt = new $.default().insert(xe.value()), Nt = new $.default().retain(nt).concat(Et.diff(zt, Pe));
                    te = Nt.reduce(function(pt, at) {
                      return at.insert ? pt.insert(at.insert, ze) : pt.push(at);
                    }, new $.default()), this.delta = Ke.compose(te);
                  } else
                    this.delta = this.getDelta(), (!te || !(0, oe.default)(Ke.compose(te), this.delta)) && (te = Ke.diff(this.delta, Pe));
                  return te;
                }
              }]), W;
            }();
            function fe(W, I) {
              return Object.keys(I).reduce(function(te, ge) {
                return W[ge] == null || (I[ge] === W[ge] ? te[ge] = I[ge] : Array.isArray(I[ge]) ? I[ge].indexOf(W[ge]) < 0 && (te[ge] = I[ge].concat([W[ge]])) : te[ge] = [I[ge], W[ge]]), te;
              }, {});
            }
            function N(W) {
              return W.reduce(function(I, te) {
                if (te.insert === 1) {
                  var ge = (0, Y.default)(te.attributes);
                  return delete ge.image, I.insert({ image: te.attributes.image }, ge);
                }
                if (te.attributes != null && (te.attributes.list === !0 || te.attributes.bullet === !0) && (te = (0, Y.default)(te), te.attributes.list ? te.attributes.list = "ordered" : (te.attributes.list = "bullet", delete te.attributes.bullet)), typeof te.insert == "string") {
                  var Pe = te.insert.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
                  return I.insert(Pe, te.attributes);
                }
                return I.push(te);
              }, new $.default());
            }
            u.default = se;
          },
          /* 15 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.Range = void 0;
            var d = function() {
              function pe(oe, ne) {
                var H = [], C = !0, w = !1, P = void 0;
                try {
                  for (var J = oe[Symbol.iterator](), se; !(C = (se = J.next()).done) && (H.push(se.value), !(ne && H.length === ne)); C = !0)
                    ;
                } catch (fe) {
                  w = !0, P = fe;
                } finally {
                  try {
                    !C && J.return && J.return();
                  } finally {
                    if (w)
                      throw P;
                  }
                }
                return H;
              }
              return function(oe, ne) {
                if (Array.isArray(oe))
                  return oe;
                if (Symbol.iterator in Object(oe))
                  return pe(oe, ne);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), m = function() {
              function pe(oe, ne) {
                for (var H = 0; H < ne.length; H++) {
                  var C = ne[H];
                  C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(oe, C.key, C);
                }
              }
              return function(oe, ne, H) {
                return ne && pe(oe.prototype, ne), H && pe(oe, H), oe;
              };
            }(), v = c(0), S = k(v), $ = c(21), E = k($), O = c(11), T = k(O), y = c(8), V = k(y), M = c(10), G = k(M);
            function k(pe) {
              return pe && pe.__esModule ? pe : { default: pe };
            }
            function F(pe) {
              if (Array.isArray(pe)) {
                for (var oe = 0, ne = Array(pe.length); oe < pe.length; oe++)
                  ne[oe] = pe[oe];
                return ne;
              } else
                return Array.from(pe);
            }
            function X(pe, oe) {
              if (!(pe instanceof oe))
                throw new TypeError("Cannot call a class as a function");
            }
            var ee = (0, G.default)("quill:selection"), ue = function pe(oe) {
              var ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
              X(this, pe), this.index = oe, this.length = ne;
            }, Q = function() {
              function pe(oe, ne) {
                var H = this;
                X(this, pe), this.emitter = ne, this.scroll = oe, this.composing = !1, this.mouseDown = !1, this.root = this.scroll.domNode, this.cursor = S.default.create("cursor", this), this.lastRange = this.savedRange = new ue(0, 0), this.handleComposition(), this.handleDragging(), this.emitter.listenDOM("selectionchange", document, function() {
                  H.mouseDown || setTimeout(H.update.bind(H, V.default.sources.USER), 1);
                }), this.emitter.on(V.default.events.EDITOR_CHANGE, function(C, w) {
                  C === V.default.events.TEXT_CHANGE && w.length() > 0 && H.update(V.default.sources.SILENT);
                }), this.emitter.on(V.default.events.SCROLL_BEFORE_UPDATE, function() {
                  if (H.hasFocus()) {
                    var C = H.getNativeRange();
                    C != null && C.start.node !== H.cursor.textNode && H.emitter.once(V.default.events.SCROLL_UPDATE, function() {
                      try {
                        H.setNativeRange(C.start.node, C.start.offset, C.end.node, C.end.offset);
                      } catch {
                      }
                    });
                  }
                }), this.emitter.on(V.default.events.SCROLL_OPTIMIZE, function(C, w) {
                  if (w.range) {
                    var P = w.range, J = P.startNode, se = P.startOffset, fe = P.endNode, N = P.endOffset;
                    H.setNativeRange(J, se, fe, N);
                  }
                }), this.update(V.default.sources.SILENT);
              }
              return m(pe, [{
                key: "handleComposition",
                value: function() {
                  var ne = this;
                  this.root.addEventListener("compositionstart", function() {
                    ne.composing = !0;
                  }), this.root.addEventListener("compositionend", function() {
                    if (ne.composing = !1, ne.cursor.parent) {
                      var H = ne.cursor.restore();
                      if (!H)
                        return;
                      setTimeout(function() {
                        ne.setNativeRange(H.startNode, H.startOffset, H.endNode, H.endOffset);
                      }, 1);
                    }
                  });
                }
              }, {
                key: "handleDragging",
                value: function() {
                  var ne = this;
                  this.emitter.listenDOM("mousedown", document.body, function() {
                    ne.mouseDown = !0;
                  }), this.emitter.listenDOM("mouseup", document.body, function() {
                    ne.mouseDown = !1, ne.update(V.default.sources.USER);
                  });
                }
              }, {
                key: "focus",
                value: function() {
                  this.hasFocus() || (this.root.focus(), this.setRange(this.savedRange));
                }
              }, {
                key: "format",
                value: function(ne, H) {
                  if (!(this.scroll.whitelist != null && !this.scroll.whitelist[ne])) {
                    this.scroll.update();
                    var C = this.getNativeRange();
                    if (!(C == null || !C.native.collapsed || S.default.query(ne, S.default.Scope.BLOCK))) {
                      if (C.start.node !== this.cursor.textNode) {
                        var w = S.default.find(C.start.node, !1);
                        if (w == null)
                          return;
                        if (w instanceof S.default.Leaf) {
                          var P = w.split(C.start.offset);
                          w.parent.insertBefore(this.cursor, P);
                        } else
                          w.insertBefore(this.cursor, C.start.node);
                        this.cursor.attach();
                      }
                      this.cursor.format(ne, H), this.scroll.optimize(), this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length), this.update();
                    }
                  }
                }
              }, {
                key: "getBounds",
                value: function(ne) {
                  var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, C = this.scroll.length();
                  ne = Math.min(ne, C - 1), H = Math.min(ne + H, C - 1) - ne;
                  var w = void 0, P = this.scroll.leaf(ne), J = d(P, 2), se = J[0], fe = J[1];
                  if (se == null)
                    return null;
                  var N = se.position(fe, !0), W = d(N, 2);
                  w = W[0], fe = W[1];
                  var I = document.createRange();
                  if (H > 0) {
                    I.setStart(w, fe);
                    var te = this.scroll.leaf(ne + H), ge = d(te, 2);
                    if (se = ge[0], fe = ge[1], se == null)
                      return null;
                    var Pe = se.position(fe, !0), Ke = d(Pe, 2);
                    return w = Ke[0], fe = Ke[1], I.setEnd(w, fe), I.getBoundingClientRect();
                  } else {
                    var xe = "left", ze = void 0;
                    return w instanceof Text ? (fe < w.data.length ? (I.setStart(w, fe), I.setEnd(w, fe + 1)) : (I.setStart(w, fe - 1), I.setEnd(w, fe), xe = "right"), ze = I.getBoundingClientRect()) : (ze = se.domNode.getBoundingClientRect(), fe > 0 && (xe = "right")), {
                      bottom: ze.top + ze.height,
                      height: ze.height,
                      left: ze[xe],
                      right: ze[xe],
                      top: ze.top,
                      width: 0
                    };
                  }
                }
              }, {
                key: "getNativeRange",
                value: function() {
                  var ne = document.getSelection();
                  if (ne == null || ne.rangeCount <= 0)
                    return null;
                  var H = ne.getRangeAt(0);
                  if (H == null)
                    return null;
                  var C = this.normalizeNative(H);
                  return ee.info("getNativeRange", C), C;
                }
              }, {
                key: "getRange",
                value: function() {
                  var ne = this.getNativeRange();
                  if (ne == null)
                    return [null, null];
                  var H = this.normalizedToRange(ne);
                  return [H, ne];
                }
              }, {
                key: "hasFocus",
                value: function() {
                  return document.activeElement === this.root;
                }
              }, {
                key: "normalizedToRange",
                value: function(ne) {
                  var H = this, C = [[ne.start.node, ne.start.offset]];
                  ne.native.collapsed || C.push([ne.end.node, ne.end.offset]);
                  var w = C.map(function(se) {
                    var fe = d(se, 2), N = fe[0], W = fe[1], I = S.default.find(N, !0), te = I.offset(H.scroll);
                    return W === 0 ? te : I instanceof S.default.Container ? te + I.length() : te + I.index(N, W);
                  }), P = Math.min(Math.max.apply(Math, F(w)), this.scroll.length() - 1), J = Math.min.apply(Math, [P].concat(F(w)));
                  return new ue(J, P - J);
                }
              }, {
                key: "normalizeNative",
                value: function(ne) {
                  if (!Y(this.root, ne.startContainer) || !ne.collapsed && !Y(this.root, ne.endContainer))
                    return null;
                  var H = {
                    start: { node: ne.startContainer, offset: ne.startOffset },
                    end: { node: ne.endContainer, offset: ne.endOffset },
                    native: ne
                  };
                  return [H.start, H.end].forEach(function(C) {
                    for (var w = C.node, P = C.offset; !(w instanceof Text) && w.childNodes.length > 0; )
                      if (w.childNodes.length > P)
                        w = w.childNodes[P], P = 0;
                      else if (w.childNodes.length === P)
                        w = w.lastChild, P = w instanceof Text ? w.data.length : w.childNodes.length + 1;
                      else
                        break;
                    C.node = w, C.offset = P;
                  }), H;
                }
              }, {
                key: "rangeToNative",
                value: function(ne) {
                  var H = this, C = ne.collapsed ? [ne.index] : [ne.index, ne.index + ne.length], w = [], P = this.scroll.length();
                  return C.forEach(function(J, se) {
                    J = Math.min(P - 1, J);
                    var fe = void 0, N = H.scroll.leaf(J), W = d(N, 2), I = W[0], te = W[1], ge = I.position(te, se !== 0), Pe = d(ge, 2);
                    fe = Pe[0], te = Pe[1], w.push(fe, te);
                  }), w.length < 2 && (w = w.concat(w)), w;
                }
              }, {
                key: "scrollIntoView",
                value: function(ne) {
                  var H = this.lastRange;
                  if (H != null) {
                    var C = this.getBounds(H.index, H.length);
                    if (C != null) {
                      var w = this.scroll.length() - 1, P = this.scroll.line(Math.min(H.index, w)), J = d(P, 1), se = J[0], fe = se;
                      if (H.length > 0) {
                        var N = this.scroll.line(Math.min(H.index + H.length, w)), W = d(N, 1);
                        fe = W[0];
                      }
                      if (!(se == null || fe == null)) {
                        var I = ne.getBoundingClientRect();
                        C.top < I.top ? ne.scrollTop -= I.top - C.top : C.bottom > I.bottom && (ne.scrollTop += C.bottom - I.bottom);
                      }
                    }
                  }
                }
              }, {
                key: "setNativeRange",
                value: function(ne, H) {
                  var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ne, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : H, P = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
                  if (ee.info("setNativeRange", ne, H, C, w), !(ne != null && (this.root.parentNode == null || ne.parentNode == null || C.parentNode == null))) {
                    var J = document.getSelection();
                    if (J != null)
                      if (ne != null) {
                        this.hasFocus() || this.root.focus();
                        var se = (this.getNativeRange() || {}).native;
                        if (se == null || P || ne !== se.startContainer || H !== se.startOffset || C !== se.endContainer || w !== se.endOffset) {
                          ne.tagName == "BR" && (H = [].indexOf.call(ne.parentNode.childNodes, ne), ne = ne.parentNode), C.tagName == "BR" && (w = [].indexOf.call(C.parentNode.childNodes, C), C = C.parentNode);
                          var fe = document.createRange();
                          fe.setStart(ne, H), fe.setEnd(C, w), J.removeAllRanges(), J.addRange(fe);
                        }
                      } else
                        J.removeAllRanges(), this.root.blur(), document.body.focus();
                  }
                }
              }, {
                key: "setRange",
                value: function(ne) {
                  var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : V.default.sources.API;
                  if (typeof H == "string" && (C = H, H = !1), ee.info("setRange", ne), ne != null) {
                    var w = this.rangeToNative(ne);
                    this.setNativeRange.apply(this, F(w).concat([H]));
                  } else
                    this.setNativeRange(null);
                  this.update(C);
                }
              }, {
                key: "update",
                value: function() {
                  var ne = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : V.default.sources.USER, H = this.lastRange, C = this.getRange(), w = d(C, 2), P = w[0], J = w[1];
                  if (this.lastRange = P, this.lastRange != null && (this.savedRange = this.lastRange), !(0, T.default)(H, this.lastRange)) {
                    var se;
                    !this.composing && J != null && J.native.collapsed && J.start.node !== this.cursor.textNode && this.cursor.restore();
                    var fe = [V.default.events.SELECTION_CHANGE, (0, E.default)(this.lastRange), (0, E.default)(H), ne];
                    if ((se = this.emitter).emit.apply(se, [V.default.events.EDITOR_CHANGE].concat(fe)), ne !== V.default.sources.SILENT) {
                      var N;
                      (N = this.emitter).emit.apply(N, fe);
                    }
                  }
                }
              }]), pe;
            }();
            function Y(pe, oe) {
              try {
                oe.parentNode;
              } catch {
                return !1;
              }
              return oe instanceof Text && (oe = oe.parentNode), pe.contains(oe);
            }
            u.Range = ue, u.default = Q;
          },
          /* 16 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function V(M, G) {
                for (var k = 0; k < G.length; k++) {
                  var F = G[k];
                  F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(M, F.key, F);
                }
              }
              return function(M, G, k) {
                return G && V(M.prototype, G), k && V(M, k), M;
              };
            }(), m = function V(M, G, k) {
              M === null && (M = Function.prototype);
              var F = Object.getOwnPropertyDescriptor(M, G);
              if (F === void 0) {
                var X = Object.getPrototypeOf(M);
                return X === null ? void 0 : V(X, G, k);
              } else {
                if ("value" in F)
                  return F.value;
                var ee = F.get;
                return ee === void 0 ? void 0 : ee.call(k);
              }
            }, v = c(0), S = $(v);
            function $(V) {
              return V && V.__esModule ? V : { default: V };
            }
            function E(V, M) {
              if (!(V instanceof M))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(V, M) {
              if (!V)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return M && (typeof M == "object" || typeof M == "function") ? M : V;
            }
            function T(V, M) {
              if (typeof M != "function" && M !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof M);
              V.prototype = Object.create(M && M.prototype, { constructor: { value: V, enumerable: !1, writable: !0, configurable: !0 } }), M && (Object.setPrototypeOf ? Object.setPrototypeOf(V, M) : V.__proto__ = M);
            }
            var y = function(V) {
              T(M, V);
              function M() {
                return E(this, M), O(this, (M.__proto__ || Object.getPrototypeOf(M)).apply(this, arguments));
              }
              return d(M, [{
                key: "insertInto",
                value: function(k, F) {
                  k.children.length === 0 ? m(M.prototype.__proto__ || Object.getPrototypeOf(M.prototype), "insertInto", this).call(this, k, F) : this.remove();
                }
              }, {
                key: "length",
                value: function() {
                  return 0;
                }
              }, {
                key: "value",
                value: function() {
                  return "";
                }
              }], [{
                key: "value",
                value: function() {
                }
              }]), M;
            }(S.default.Embed);
            y.blotName = "break", y.tagName = "BR", u.default = y;
          },
          /* 17 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var O = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(T, y) {
                T.__proto__ = y;
              } || function(T, y) {
                for (var V in y)
                  y.hasOwnProperty(V) && (T[V] = y[V]);
              };
              return function(T, y) {
                O(T, y);
                function V() {
                  this.constructor = T;
                }
                T.prototype = y === null ? Object.create(y) : (V.prototype = y.prototype, new V());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(44), v = c(30), S = c(1), $ = (
              /** @class */
              function(O) {
                d(T, O);
                function T(y) {
                  var V = O.call(this, y) || this;
                  return V.build(), V;
                }
                return T.prototype.appendChild = function(y) {
                  this.insertBefore(y);
                }, T.prototype.attach = function() {
                  O.prototype.attach.call(this), this.children.forEach(function(y) {
                    y.attach();
                  });
                }, T.prototype.build = function() {
                  var y = this;
                  this.children = new m.default(), [].slice.call(this.domNode.childNodes).reverse().forEach(function(V) {
                    try {
                      var M = E(V);
                      y.insertBefore(M, y.children.head || void 0);
                    } catch (G) {
                      if (G instanceof S.ParchmentError)
                        return;
                      throw G;
                    }
                  });
                }, T.prototype.deleteAt = function(y, V) {
                  if (y === 0 && V === this.length())
                    return this.remove();
                  this.children.forEachAt(y, V, function(M, G, k) {
                    M.deleteAt(G, k);
                  });
                }, T.prototype.descendant = function(y, V) {
                  var M = this.children.find(V), G = M[0], k = M[1];
                  return y.blotName == null && y(G) || y.blotName != null && G instanceof y ? [G, k] : G instanceof T ? G.descendant(y, k) : [null, -1];
                }, T.prototype.descendants = function(y, V, M) {
                  V === void 0 && (V = 0), M === void 0 && (M = Number.MAX_VALUE);
                  var G = [], k = M;
                  return this.children.forEachAt(V, M, function(F, X, ee) {
                    (y.blotName == null && y(F) || y.blotName != null && F instanceof y) && G.push(F), F instanceof T && (G = G.concat(F.descendants(y, X, k))), k -= ee;
                  }), G;
                }, T.prototype.detach = function() {
                  this.children.forEach(function(y) {
                    y.detach();
                  }), O.prototype.detach.call(this);
                }, T.prototype.formatAt = function(y, V, M, G) {
                  this.children.forEachAt(y, V, function(k, F, X) {
                    k.formatAt(F, X, M, G);
                  });
                }, T.prototype.insertAt = function(y, V, M) {
                  var G = this.children.find(y), k = G[0], F = G[1];
                  if (k)
                    k.insertAt(F, V, M);
                  else {
                    var X = M == null ? S.create("text", V) : S.create(V, M);
                    this.appendChild(X);
                  }
                }, T.prototype.insertBefore = function(y, V) {
                  if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(M) {
                    return y instanceof M;
                  }))
                    throw new S.ParchmentError("Cannot insert " + y.statics.blotName + " into " + this.statics.blotName);
                  y.insertInto(this, V);
                }, T.prototype.length = function() {
                  return this.children.reduce(function(y, V) {
                    return y + V.length();
                  }, 0);
                }, T.prototype.moveChildren = function(y, V) {
                  this.children.forEach(function(M) {
                    y.insertBefore(M, V);
                  });
                }, T.prototype.optimize = function(y) {
                  if (O.prototype.optimize.call(this, y), this.children.length === 0)
                    if (this.statics.defaultChild != null) {
                      var V = S.create(this.statics.defaultChild);
                      this.appendChild(V), V.optimize(y);
                    } else
                      this.remove();
                }, T.prototype.path = function(y, V) {
                  V === void 0 && (V = !1);
                  var M = this.children.find(y, V), G = M[0], k = M[1], F = [[this, y]];
                  return G instanceof T ? F.concat(G.path(k, V)) : (G != null && F.push([G, k]), F);
                }, T.prototype.removeChild = function(y) {
                  this.children.remove(y);
                }, T.prototype.replace = function(y) {
                  y instanceof T && y.moveChildren(this), O.prototype.replace.call(this, y);
                }, T.prototype.split = function(y, V) {
                  if (V === void 0 && (V = !1), !V) {
                    if (y === 0)
                      return this;
                    if (y === this.length())
                      return this.next;
                  }
                  var M = this.clone();
                  return this.parent.insertBefore(M, this.next), this.children.forEachAt(y, this.length(), function(G, k, F) {
                    G = G.split(k, V), M.appendChild(G);
                  }), M;
                }, T.prototype.unwrap = function() {
                  this.moveChildren(this.parent, this.next), this.remove();
                }, T.prototype.update = function(y, V) {
                  var M = this, G = [], k = [];
                  y.forEach(function(F) {
                    F.target === M.domNode && F.type === "childList" && (G.push.apply(G, F.addedNodes), k.push.apply(k, F.removedNodes));
                  }), k.forEach(function(F) {
                    if (!(F.parentNode != null && // @ts-ignore
                    F.tagName !== "IFRAME" && document.body.compareDocumentPosition(F) & Node.DOCUMENT_POSITION_CONTAINED_BY)) {
                      var X = S.find(F);
                      X != null && (X.domNode.parentNode == null || X.domNode.parentNode === M.domNode) && X.detach();
                    }
                  }), G.filter(function(F) {
                    return F.parentNode == M.domNode;
                  }).sort(function(F, X) {
                    return F === X ? 0 : F.compareDocumentPosition(X) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1;
                  }).forEach(function(F) {
                    var X = null;
                    F.nextSibling != null && (X = S.find(F.nextSibling));
                    var ee = E(F);
                    (ee.next != X || ee.next == null) && (ee.parent != null && ee.parent.removeChild(M), M.insertBefore(ee, X || void 0));
                  });
                }, T;
              }(v.default)
            );
            function E(O) {
              var T = S.find(O);
              if (T == null)
                try {
                  T = S.create(O);
                } catch {
                  T = S.create(S.Scope.INLINE), [].slice.call(O.childNodes).forEach(function(V) {
                    T.domNode.appendChild(V);
                  }), O.parentNode && O.parentNode.replaceChild(T.domNode, O), T.attach();
                }
              return T;
            }
            u.default = $;
          },
          /* 18 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var O = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(T, y) {
                T.__proto__ = y;
              } || function(T, y) {
                for (var V in y)
                  y.hasOwnProperty(V) && (T[V] = y[V]);
              };
              return function(T, y) {
                O(T, y);
                function V() {
                  this.constructor = T;
                }
                T.prototype = y === null ? Object.create(y) : (V.prototype = y.prototype, new V());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(12), v = c(31), S = c(17), $ = c(1), E = (
              /** @class */
              function(O) {
                d(T, O);
                function T(y) {
                  var V = O.call(this, y) || this;
                  return V.attributes = new v.default(V.domNode), V;
                }
                return T.formats = function(y) {
                  if (typeof this.tagName == "string")
                    return !0;
                  if (Array.isArray(this.tagName))
                    return y.tagName.toLowerCase();
                }, T.prototype.format = function(y, V) {
                  var M = $.query(y);
                  M instanceof m.default ? this.attributes.attribute(M, V) : V && M != null && (y !== this.statics.blotName || this.formats()[y] !== V) && this.replaceWith(y, V);
                }, T.prototype.formats = function() {
                  var y = this.attributes.values(), V = this.statics.formats(this.domNode);
                  return V != null && (y[this.statics.blotName] = V), y;
                }, T.prototype.replaceWith = function(y, V) {
                  var M = O.prototype.replaceWith.call(this, y, V);
                  return this.attributes.copy(M), M;
                }, T.prototype.update = function(y, V) {
                  var M = this;
                  O.prototype.update.call(this, y, V), y.some(function(G) {
                    return G.target === M.domNode && G.type === "attributes";
                  }) && this.attributes.build();
                }, T.prototype.wrap = function(y, V) {
                  var M = O.prototype.wrap.call(this, y, V);
                  return M instanceof T && M.statics.scope === this.statics.scope && this.attributes.move(M), M;
                }, T;
              }(S.default)
            );
            u.default = E;
          },
          /* 19 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, O) {
                E.__proto__ = O;
              } || function(E, O) {
                for (var T in O)
                  O.hasOwnProperty(T) && (E[T] = O[T]);
              };
              return function(E, O) {
                $(E, O);
                function T() {
                  this.constructor = E;
                }
                E.prototype = O === null ? Object.create(O) : (T.prototype = O.prototype, new T());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(30), v = c(1), S = (
              /** @class */
              function($) {
                d(E, $);
                function E() {
                  return $ !== null && $.apply(this, arguments) || this;
                }
                return E.value = function(O) {
                  return !0;
                }, E.prototype.index = function(O, T) {
                  return this.domNode === O || this.domNode.compareDocumentPosition(O) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(T, 1) : -1;
                }, E.prototype.position = function(O, T) {
                  var y = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                  return O > 0 && (y += 1), [this.parent.domNode, y];
                }, E.prototype.value = function() {
                  var O;
                  return O = {}, O[this.statics.blotName] = this.statics.value(this.domNode) || !0, O;
                }, E.scope = v.Scope.INLINE_BLOT, E;
              }(m.default)
            );
            u.default = S;
          },
          /* 20 */
          /***/
          function(o, u, c) {
            var d = c(11), m = c(3), v = {
              attributes: {
                compose: function($, E, O) {
                  typeof $ != "object" && ($ = {}), typeof E != "object" && (E = {});
                  var T = m(!0, {}, E);
                  O || (T = Object.keys(T).reduce(function(V, M) {
                    return T[M] != null && (V[M] = T[M]), V;
                  }, {}));
                  for (var y in $)
                    $[y] !== void 0 && E[y] === void 0 && (T[y] = $[y]);
                  return Object.keys(T).length > 0 ? T : void 0;
                },
                diff: function($, E) {
                  typeof $ != "object" && ($ = {}), typeof E != "object" && (E = {});
                  var O = Object.keys($).concat(Object.keys(E)).reduce(function(T, y) {
                    return d($[y], E[y]) || (T[y] = E[y] === void 0 ? null : E[y]), T;
                  }, {});
                  return Object.keys(O).length > 0 ? O : void 0;
                },
                transform: function($, E, O) {
                  if (typeof $ != "object")
                    return E;
                  if (typeof E == "object") {
                    if (!O)
                      return E;
                    var T = Object.keys(E).reduce(function(y, V) {
                      return $[V] === void 0 && (y[V] = E[V]), y;
                    }, {});
                    return Object.keys(T).length > 0 ? T : void 0;
                  }
                }
              },
              iterator: function($) {
                return new S($);
              },
              length: function($) {
                return typeof $.delete == "number" ? $.delete : typeof $.retain == "number" ? $.retain : typeof $.insert == "string" ? $.insert.length : 1;
              }
            };
            function S($) {
              this.ops = $, this.index = 0, this.offset = 0;
            }
            S.prototype.hasNext = function() {
              return this.peekLength() < 1 / 0;
            }, S.prototype.next = function($) {
              $ || ($ = 1 / 0);
              var E = this.ops[this.index];
              if (E) {
                var O = this.offset, T = v.length(E);
                if ($ >= T - O ? ($ = T - O, this.index += 1, this.offset = 0) : this.offset += $, typeof E.delete == "number")
                  return { delete: $ };
                var y = {};
                return E.attributes && (y.attributes = E.attributes), typeof E.retain == "number" ? y.retain = $ : typeof E.insert == "string" ? y.insert = E.insert.substr(O, $) : y.insert = E.insert, y;
              } else
                return { retain: 1 / 0 };
            }, S.prototype.peek = function() {
              return this.ops[this.index];
            }, S.prototype.peekLength = function() {
              return this.ops[this.index] ? v.length(this.ops[this.index]) - this.offset : 1 / 0;
            }, S.prototype.peekType = function() {
              return this.ops[this.index] ? typeof this.ops[this.index].delete == "number" ? "delete" : typeof this.ops[this.index].retain == "number" ? "retain" : "insert" : "retain";
            }, S.prototype.rest = function() {
              if (this.hasNext()) {
                if (this.offset === 0)
                  return this.ops.slice(this.index);
                var $ = this.offset, E = this.index, O = this.next(), T = this.ops.slice(this.index);
                return this.offset = $, this.index = E, [O].concat(T);
              } else
                return [];
            }, o.exports = v;
          },
          /* 21 */
          /***/
          function(o, u) {
            var c = function() {
              function d(M, G) {
                return G != null && M instanceof G;
              }
              var m;
              try {
                m = Map;
              } catch {
                m = function() {
                };
              }
              var v;
              try {
                v = Set;
              } catch {
                v = function() {
                };
              }
              var S;
              try {
                S = Promise;
              } catch {
                S = function() {
                };
              }
              function $(M, G, k, F, X) {
                typeof G == "object" && (k = G.depth, F = G.prototype, X = G.includeNonEnumerable, G = G.circular);
                var ee = [], ue = [], Q = typeof Buffer < "u";
                typeof G > "u" && (G = !0), typeof k > "u" && (k = 1 / 0);
                function Y(pe, oe) {
                  if (pe === null)
                    return null;
                  if (oe === 0)
                    return pe;
                  var ne, H;
                  if (typeof pe != "object")
                    return pe;
                  if (d(pe, m))
                    ne = new m();
                  else if (d(pe, v))
                    ne = new v();
                  else if (d(pe, S))
                    ne = new S(function(I, te) {
                      pe.then(function(ge) {
                        I(Y(ge, oe - 1));
                      }, function(ge) {
                        te(Y(ge, oe - 1));
                      });
                    });
                  else if ($.__isArray(pe))
                    ne = [];
                  else if ($.__isRegExp(pe))
                    ne = new RegExp(pe.source, V(pe)), pe.lastIndex && (ne.lastIndex = pe.lastIndex);
                  else if ($.__isDate(pe))
                    ne = new Date(pe.getTime());
                  else {
                    if (Q && Buffer.isBuffer(pe))
                      return Buffer.allocUnsafe ? ne = Buffer.allocUnsafe(pe.length) : ne = new Buffer(pe.length), pe.copy(ne), ne;
                    d(pe, Error) ? ne = Object.create(pe) : typeof F > "u" ? (H = Object.getPrototypeOf(pe), ne = Object.create(H)) : (ne = Object.create(F), H = F);
                  }
                  if (G) {
                    var C = ee.indexOf(pe);
                    if (C != -1)
                      return ue[C];
                    ee.push(pe), ue.push(ne);
                  }
                  d(pe, m) && pe.forEach(function(I, te) {
                    var ge = Y(te, oe - 1), Pe = Y(I, oe - 1);
                    ne.set(ge, Pe);
                  }), d(pe, v) && pe.forEach(function(I) {
                    var te = Y(I, oe - 1);
                    ne.add(te);
                  });
                  for (var w in pe) {
                    var P;
                    H && (P = Object.getOwnPropertyDescriptor(H, w)), !(P && P.set == null) && (ne[w] = Y(pe[w], oe - 1));
                  }
                  if (Object.getOwnPropertySymbols)
                    for (var J = Object.getOwnPropertySymbols(pe), w = 0; w < J.length; w++) {
                      var se = J[w], fe = Object.getOwnPropertyDescriptor(pe, se);
                      fe && !fe.enumerable && !X || (ne[se] = Y(pe[se], oe - 1), fe.enumerable || Object.defineProperty(ne, se, {
                        enumerable: !1
                      }));
                    }
                  if (X)
                    for (var N = Object.getOwnPropertyNames(pe), w = 0; w < N.length; w++) {
                      var W = N[w], fe = Object.getOwnPropertyDescriptor(pe, W);
                      fe && fe.enumerable || (ne[W] = Y(pe[W], oe - 1), Object.defineProperty(ne, W, {
                        enumerable: !1
                      }));
                    }
                  return ne;
                }
                return Y(M, k);
              }
              $.clonePrototype = function(G) {
                if (G === null)
                  return null;
                var k = function() {
                };
                return k.prototype = G, new k();
              };
              function E(M) {
                return Object.prototype.toString.call(M);
              }
              $.__objToStr = E;
              function O(M) {
                return typeof M == "object" && E(M) === "[object Date]";
              }
              $.__isDate = O;
              function T(M) {
                return typeof M == "object" && E(M) === "[object Array]";
              }
              $.__isArray = T;
              function y(M) {
                return typeof M == "object" && E(M) === "[object RegExp]";
              }
              $.__isRegExp = y;
              function V(M) {
                var G = "";
                return M.global && (G += "g"), M.ignoreCase && (G += "i"), M.multiline && (G += "m"), G;
              }
              return $.__getRegExpFlags = V, $;
            }();
            typeof o == "object" && o.exports && (o.exports = c);
          },
          /* 22 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function ne(H, C) {
                var w = [], P = !0, J = !1, se = void 0;
                try {
                  for (var fe = H[Symbol.iterator](), N; !(P = (N = fe.next()).done) && (w.push(N.value), !(C && w.length === C)); P = !0)
                    ;
                } catch (W) {
                  J = !0, se = W;
                } finally {
                  try {
                    !P && fe.return && fe.return();
                  } finally {
                    if (J)
                      throw se;
                  }
                }
                return w;
              }
              return function(H, C) {
                if (Array.isArray(H))
                  return H;
                if (Symbol.iterator in Object(H))
                  return ne(H, C);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), m = function() {
              function ne(H, C) {
                for (var w = 0; w < C.length; w++) {
                  var P = C[w];
                  P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(H, P.key, P);
                }
              }
              return function(H, C, w) {
                return C && ne(H.prototype, C), w && ne(H, w), H;
              };
            }(), v = function ne(H, C, w) {
              H === null && (H = Function.prototype);
              var P = Object.getOwnPropertyDescriptor(H, C);
              if (P === void 0) {
                var J = Object.getPrototypeOf(H);
                return J === null ? void 0 : ne(J, C, w);
              } else {
                if ("value" in P)
                  return P.value;
                var se = P.get;
                return se === void 0 ? void 0 : se.call(w);
              }
            }, S = c(0), $ = ee(S), E = c(8), O = ee(E), T = c(4), y = ee(T), V = c(16), M = ee(V), G = c(13), k = ee(G), F = c(25), X = ee(F);
            function ee(ne) {
              return ne && ne.__esModule ? ne : { default: ne };
            }
            function ue(ne, H) {
              if (!(ne instanceof H))
                throw new TypeError("Cannot call a class as a function");
            }
            function Q(ne, H) {
              if (!ne)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return H && (typeof H == "object" || typeof H == "function") ? H : ne;
            }
            function Y(ne, H) {
              if (typeof H != "function" && H !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof H);
              ne.prototype = Object.create(H && H.prototype, { constructor: { value: ne, enumerable: !1, writable: !0, configurable: !0 } }), H && (Object.setPrototypeOf ? Object.setPrototypeOf(ne, H) : ne.__proto__ = H);
            }
            function pe(ne) {
              return ne instanceof y.default || ne instanceof T.BlockEmbed;
            }
            var oe = function(ne) {
              Y(H, ne);
              function H(C, w) {
                ue(this, H);
                var P = Q(this, (H.__proto__ || Object.getPrototypeOf(H)).call(this, C));
                return P.emitter = w.emitter, Array.isArray(w.whitelist) && (P.whitelist = w.whitelist.reduce(function(J, se) {
                  return J[se] = !0, J;
                }, {})), P.domNode.addEventListener("DOMNodeInserted", function() {
                }), P.optimize(), P.enable(), P;
              }
              return m(H, [{
                key: "batchStart",
                value: function() {
                  this.batch = !0;
                }
              }, {
                key: "batchEnd",
                value: function() {
                  this.batch = !1, this.optimize();
                }
              }, {
                key: "deleteAt",
                value: function(w, P) {
                  var J = this.line(w), se = d(J, 2), fe = se[0], N = se[1], W = this.line(w + P), I = d(W, 1), te = I[0];
                  if (v(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "deleteAt", this).call(this, w, P), te != null && fe !== te && N > 0) {
                    if (fe instanceof T.BlockEmbed || te instanceof T.BlockEmbed) {
                      this.optimize();
                      return;
                    }
                    if (fe instanceof k.default) {
                      var ge = fe.newlineIndex(fe.length(), !0);
                      if (ge > -1 && (fe = fe.split(ge + 1), fe === te)) {
                        this.optimize();
                        return;
                      }
                    } else if (te instanceof k.default) {
                      var Pe = te.newlineIndex(0);
                      Pe > -1 && te.split(Pe + 1);
                    }
                    var Ke = te.children.head instanceof M.default ? null : te.children.head;
                    fe.moveChildren(te, Ke), fe.remove();
                  }
                  this.optimize();
                }
              }, {
                key: "enable",
                value: function() {
                  var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                  this.domNode.setAttribute("contenteditable", w);
                }
              }, {
                key: "formatAt",
                value: function(w, P, J, se) {
                  this.whitelist != null && !this.whitelist[J] || (v(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "formatAt", this).call(this, w, P, J, se), this.optimize());
                }
              }, {
                key: "insertAt",
                value: function(w, P, J) {
                  if (!(J != null && this.whitelist != null && !this.whitelist[P])) {
                    if (w >= this.length())
                      if (J == null || $.default.query(P, $.default.Scope.BLOCK) == null) {
                        var se = $.default.create(this.statics.defaultChild);
                        this.appendChild(se), J == null && P.endsWith(`
`) && (P = P.slice(0, -1)), se.insertAt(0, P, J);
                      } else {
                        var fe = $.default.create(P, J);
                        this.appendChild(fe);
                      }
                    else
                      v(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "insertAt", this).call(this, w, P, J);
                    this.optimize();
                  }
                }
              }, {
                key: "insertBefore",
                value: function(w, P) {
                  if (w.statics.scope === $.default.Scope.INLINE_BLOT) {
                    var J = $.default.create(this.statics.defaultChild);
                    J.appendChild(w), w = J;
                  }
                  v(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "insertBefore", this).call(this, w, P);
                }
              }, {
                key: "leaf",
                value: function(w) {
                  return this.path(w).pop() || [null, -1];
                }
              }, {
                key: "line",
                value: function(w) {
                  return w === this.length() ? this.line(w - 1) : this.descendant(pe, w);
                }
              }, {
                key: "lines",
                value: function() {
                  var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE, J = function se(fe, N, W) {
                    var I = [], te = W;
                    return fe.children.forEachAt(N, W, function(ge, Pe, Ke) {
                      pe(ge) ? I.push(ge) : ge instanceof $.default.Container && (I = I.concat(se(ge, Pe, te))), te -= Ke;
                    }), I;
                  };
                  return J(this, w, P);
                }
              }, {
                key: "optimize",
                value: function() {
                  var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  this.batch !== !0 && (v(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "optimize", this).call(this, w, P), w.length > 0 && this.emitter.emit(O.default.events.SCROLL_OPTIMIZE, w, P));
                }
              }, {
                key: "path",
                value: function(w) {
                  return v(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "path", this).call(this, w).slice(1);
                }
              }, {
                key: "update",
                value: function(w) {
                  if (this.batch !== !0) {
                    var P = O.default.sources.USER;
                    typeof w == "string" && (P = w), Array.isArray(w) || (w = this.observer.takeRecords()), w.length > 0 && this.emitter.emit(O.default.events.SCROLL_BEFORE_UPDATE, P, w), v(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "update", this).call(this, w.concat([])), w.length > 0 && this.emitter.emit(O.default.events.SCROLL_UPDATE, P, w);
                  }
                }
              }]), H;
            }($.default.Scroll);
            oe.blotName = "scroll", oe.className = "ql-editor", oe.tagName = "DIV", oe.defaultChild = "block", oe.allowedChildren = [y.default, T.BlockEmbed, X.default], u.default = oe;
          },
          /* 23 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.SHORTKEY = u.default = void 0;
            var d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ze) {
              return typeof ze;
            } : function(ze) {
              return ze && typeof Symbol == "function" && ze.constructor === Symbol && ze !== Symbol.prototype ? "symbol" : typeof ze;
            }, m = function() {
              function ze(nt, Qt) {
                var Et = [], zt = !0, Nt = !1, pt = void 0;
                try {
                  for (var at = nt[Symbol.iterator](), kt; !(zt = (kt = at.next()).done) && (Et.push(kt.value), !(Qt && Et.length === Qt)); zt = !0)
                    ;
                } catch (Ut) {
                  Nt = !0, pt = Ut;
                } finally {
                  try {
                    !zt && at.return && at.return();
                  } finally {
                    if (Nt)
                      throw pt;
                  }
                }
                return Et;
              }
              return function(nt, Qt) {
                if (Array.isArray(nt))
                  return nt;
                if (Symbol.iterator in Object(nt))
                  return ze(nt, Qt);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), v = function() {
              function ze(nt, Qt) {
                for (var Et = 0; Et < Qt.length; Et++) {
                  var zt = Qt[Et];
                  zt.enumerable = zt.enumerable || !1, zt.configurable = !0, "value" in zt && (zt.writable = !0), Object.defineProperty(nt, zt.key, zt);
                }
              }
              return function(nt, Qt, Et) {
                return Qt && ze(nt.prototype, Qt), Et && ze(nt, Et), nt;
              };
            }(), S = c(21), $ = ne(S), E = c(11), O = ne(E), T = c(3), y = ne(T), V = c(2), M = ne(V), G = c(20), k = ne(G), F = c(0), X = ne(F), ee = c(5), ue = ne(ee), Q = c(10), Y = ne(Q), pe = c(9), oe = ne(pe);
            function ne(ze) {
              return ze && ze.__esModule ? ze : { default: ze };
            }
            function H(ze, nt, Qt) {
              return nt in ze ? Object.defineProperty(ze, nt, { value: Qt, enumerable: !0, configurable: !0, writable: !0 }) : ze[nt] = Qt, ze;
            }
            function C(ze, nt) {
              if (!(ze instanceof nt))
                throw new TypeError("Cannot call a class as a function");
            }
            function w(ze, nt) {
              if (!ze)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return nt && (typeof nt == "object" || typeof nt == "function") ? nt : ze;
            }
            function P(ze, nt) {
              if (typeof nt != "function" && nt !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof nt);
              ze.prototype = Object.create(nt && nt.prototype, { constructor: { value: ze, enumerable: !1, writable: !0, configurable: !0 } }), nt && (Object.setPrototypeOf ? Object.setPrototypeOf(ze, nt) : ze.__proto__ = nt);
            }
            var J = (0, Y.default)("quill:keyboard"), se = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey", fe = function(ze) {
              P(nt, ze), v(nt, null, [{
                key: "match",
                value: function(Et, zt) {
                  return zt = xe(zt), ["altKey", "ctrlKey", "metaKey", "shiftKey"].some(function(Nt) {
                    return !!zt[Nt] !== Et[Nt] && zt[Nt] !== null;
                  }) ? !1 : zt.key === (Et.which || Et.keyCode);
                }
              }]);
              function nt(Qt, Et) {
                C(this, nt);
                var zt = w(this, (nt.__proto__ || Object.getPrototypeOf(nt)).call(this, Qt, Et));
                return zt.bindings = {}, Object.keys(zt.options.bindings).forEach(function(Nt) {
                  Nt === "list autofill" && Qt.scroll.whitelist != null && !Qt.scroll.whitelist.list || zt.options.bindings[Nt] && zt.addBinding(zt.options.bindings[Nt]);
                }), zt.addBinding({ key: nt.keys.ENTER, shiftKey: null }, ge), zt.addBinding({ key: nt.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function() {
                }), /Firefox/i.test(navigator.userAgent) ? (zt.addBinding({ key: nt.keys.BACKSPACE }, { collapsed: !0 }, W), zt.addBinding({ key: nt.keys.DELETE }, { collapsed: !0 }, I)) : (zt.addBinding({ key: nt.keys.BACKSPACE }, { collapsed: !0, prefix: /^.?$/ }, W), zt.addBinding({ key: nt.keys.DELETE }, { collapsed: !0, suffix: /^.?$/ }, I)), zt.addBinding({ key: nt.keys.BACKSPACE }, { collapsed: !1 }, te), zt.addBinding({ key: nt.keys.DELETE }, { collapsed: !1 }, te), zt.addBinding({ key: nt.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: !0, offset: 0 }, W), zt.listen(), zt;
              }
              return v(nt, [{
                key: "addBinding",
                value: function(Et) {
                  var zt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Nt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, pt = xe(Et);
                  if (pt == null || pt.key == null)
                    return J.warn("Attempted to add invalid keyboard binding", pt);
                  typeof zt == "function" && (zt = { handler: zt }), typeof Nt == "function" && (Nt = { handler: Nt }), pt = (0, y.default)(pt, zt, Nt), this.bindings[pt.key] = this.bindings[pt.key] || [], this.bindings[pt.key].push(pt);
                }
              }, {
                key: "listen",
                value: function() {
                  var Et = this;
                  this.quill.root.addEventListener("keydown", function(zt) {
                    if (!zt.defaultPrevented) {
                      var Nt = zt.which || zt.keyCode, pt = (Et.bindings[Nt] || []).filter(function(It) {
                        return nt.match(zt, It);
                      });
                      if (pt.length !== 0) {
                        var at = Et.quill.getSelection();
                        if (!(at == null || !Et.quill.hasFocus())) {
                          var kt = Et.quill.getLine(at.index), Ut = m(kt, 2), dn = Ut[0], En = Ut[1], Ht = Et.quill.getLeaf(at.index), Xt = m(Ht, 2), On = Xt[0], sn = Xt[1], At = at.length === 0 ? [On, sn] : Et.quill.getLeaf(at.index + at.length), hn = m(At, 2), $t = hn[0], Lt = hn[1], Qn = On instanceof X.default.Text ? On.value().slice(0, sn) : "", ce = $t instanceof X.default.Text ? $t.value().slice(Lt) : "", Ze = {
                            collapsed: at.length === 0,
                            empty: at.length === 0 && dn.length() <= 1,
                            format: Et.quill.getFormat(at),
                            offset: En,
                            prefix: Qn,
                            suffix: ce
                          }, ft = pt.some(function(It) {
                            if (It.collapsed != null && It.collapsed !== Ze.collapsed || It.empty != null && It.empty !== Ze.empty || It.offset != null && It.offset !== Ze.offset)
                              return !1;
                            if (Array.isArray(It.format)) {
                              if (It.format.every(function(rn) {
                                return Ze.format[rn] == null;
                              }))
                                return !1;
                            } else if (d(It.format) === "object" && !Object.keys(It.format).every(function(rn) {
                              return It.format[rn] === !0 ? Ze.format[rn] != null : It.format[rn] === !1 ? Ze.format[rn] == null : (0, O.default)(It.format[rn], Ze.format[rn]);
                            }))
                              return !1;
                            return It.prefix != null && !It.prefix.test(Ze.prefix) || It.suffix != null && !It.suffix.test(Ze.suffix) ? !1 : It.handler.call(Et, at, Ze) !== !0;
                          });
                          ft && zt.preventDefault();
                        }
                      }
                    }
                  });
                }
              }]), nt;
            }(oe.default);
            fe.keys = {
              BACKSPACE: 8,
              TAB: 9,
              ENTER: 13,
              ESCAPE: 27,
              LEFT: 37,
              UP: 38,
              RIGHT: 39,
              DOWN: 40,
              DELETE: 46
            }, fe.DEFAULTS = {
              bindings: {
                bold: Ke("bold"),
                italic: Ke("italic"),
                underline: Ke("underline"),
                indent: {
                  // highlight tab or tab at beginning of list, indent or blockquote
                  key: fe.keys.TAB,
                  format: ["blockquote", "indent", "list"],
                  handler: function(nt, Qt) {
                    if (Qt.collapsed && Qt.offset !== 0)
                      return !0;
                    this.quill.format("indent", "+1", ue.default.sources.USER);
                  }
                },
                outdent: {
                  key: fe.keys.TAB,
                  shiftKey: !0,
                  format: ["blockquote", "indent", "list"],
                  // highlight tab or tab at beginning of list, indent or blockquote
                  handler: function(nt, Qt) {
                    if (Qt.collapsed && Qt.offset !== 0)
                      return !0;
                    this.quill.format("indent", "-1", ue.default.sources.USER);
                  }
                },
                "outdent backspace": {
                  key: fe.keys.BACKSPACE,
                  collapsed: !0,
                  shiftKey: null,
                  metaKey: null,
                  ctrlKey: null,
                  altKey: null,
                  format: ["indent", "list"],
                  offset: 0,
                  handler: function(nt, Qt) {
                    Qt.format.indent != null ? this.quill.format("indent", "-1", ue.default.sources.USER) : Qt.format.list != null && this.quill.format("list", !1, ue.default.sources.USER);
                  }
                },
                "indent code-block": Pe(!0),
                "outdent code-block": Pe(!1),
                "remove tab": {
                  key: fe.keys.TAB,
                  shiftKey: !0,
                  collapsed: !0,
                  prefix: /\t$/,
                  handler: function(nt) {
                    this.quill.deleteText(nt.index - 1, 1, ue.default.sources.USER);
                  }
                },
                tab: {
                  key: fe.keys.TAB,
                  handler: function(nt) {
                    this.quill.history.cutoff();
                    var Qt = new M.default().retain(nt.index).delete(nt.length).insert("	");
                    this.quill.updateContents(Qt, ue.default.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(nt.index + 1, ue.default.sources.SILENT);
                  }
                },
                "list empty enter": {
                  key: fe.keys.ENTER,
                  collapsed: !0,
                  format: ["list"],
                  empty: !0,
                  handler: function(nt, Qt) {
                    this.quill.format("list", !1, ue.default.sources.USER), Qt.format.indent && this.quill.format("indent", !1, ue.default.sources.USER);
                  }
                },
                "checklist enter": {
                  key: fe.keys.ENTER,
                  collapsed: !0,
                  format: { list: "checked" },
                  handler: function(nt) {
                    var Qt = this.quill.getLine(nt.index), Et = m(Qt, 2), zt = Et[0], Nt = Et[1], pt = (0, y.default)({}, zt.formats(), { list: "checked" }), at = new M.default().retain(nt.index).insert(`
`, pt).retain(zt.length() - Nt - 1).retain(1, { list: "unchecked" });
                    this.quill.updateContents(at, ue.default.sources.USER), this.quill.setSelection(nt.index + 1, ue.default.sources.SILENT), this.quill.scrollIntoView();
                  }
                },
                "header enter": {
                  key: fe.keys.ENTER,
                  collapsed: !0,
                  format: ["header"],
                  suffix: /^$/,
                  handler: function(nt, Qt) {
                    var Et = this.quill.getLine(nt.index), zt = m(Et, 2), Nt = zt[0], pt = zt[1], at = new M.default().retain(nt.index).insert(`
`, Qt.format).retain(Nt.length() - pt - 1).retain(1, { header: null });
                    this.quill.updateContents(at, ue.default.sources.USER), this.quill.setSelection(nt.index + 1, ue.default.sources.SILENT), this.quill.scrollIntoView();
                  }
                },
                "list autofill": {
                  key: " ",
                  collapsed: !0,
                  format: { list: !1 },
                  prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                  handler: function(nt, Qt) {
                    var Et = Qt.prefix.length, zt = this.quill.getLine(nt.index), Nt = m(zt, 2), pt = Nt[0], at = Nt[1];
                    if (at > Et)
                      return !0;
                    var kt = void 0;
                    switch (Qt.prefix.trim()) {
                      case "[]":
                      case "[ ]":
                        kt = "unchecked";
                        break;
                      case "[x]":
                        kt = "checked";
                        break;
                      case "-":
                      case "*":
                        kt = "bullet";
                        break;
                      default:
                        kt = "ordered";
                    }
                    this.quill.insertText(nt.index, " ", ue.default.sources.USER), this.quill.history.cutoff();
                    var Ut = new M.default().retain(nt.index - at).delete(Et + 1).retain(pt.length() - 2 - at).retain(1, { list: kt });
                    this.quill.updateContents(Ut, ue.default.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(nt.index - Et, ue.default.sources.SILENT);
                  }
                },
                "code exit": {
                  key: fe.keys.ENTER,
                  collapsed: !0,
                  format: ["code-block"],
                  prefix: /\n\n$/,
                  suffix: /^\s+$/,
                  handler: function(nt) {
                    var Qt = this.quill.getLine(nt.index), Et = m(Qt, 2), zt = Et[0], Nt = Et[1], pt = new M.default().retain(nt.index + zt.length() - Nt - 2).retain(1, { "code-block": null }).delete(1);
                    this.quill.updateContents(pt, ue.default.sources.USER);
                  }
                },
                "embed left": N(fe.keys.LEFT, !1),
                "embed left shift": N(fe.keys.LEFT, !0),
                "embed right": N(fe.keys.RIGHT, !1),
                "embed right shift": N(fe.keys.RIGHT, !0)
              }
            };
            function N(ze, nt) {
              var Qt, Et = ze === fe.keys.LEFT ? "prefix" : "suffix";
              return Qt = {
                key: ze,
                shiftKey: nt,
                altKey: null
              }, H(Qt, Et, /^$/), H(Qt, "handler", function(Nt) {
                var pt = Nt.index;
                ze === fe.keys.RIGHT && (pt += Nt.length + 1);
                var at = this.quill.getLeaf(pt), kt = m(at, 1), Ut = kt[0];
                return Ut instanceof X.default.Embed ? (ze === fe.keys.LEFT ? nt ? this.quill.setSelection(Nt.index - 1, Nt.length + 1, ue.default.sources.USER) : this.quill.setSelection(Nt.index - 1, ue.default.sources.USER) : nt ? this.quill.setSelection(Nt.index, Nt.length + 1, ue.default.sources.USER) : this.quill.setSelection(Nt.index + Nt.length + 1, ue.default.sources.USER), !1) : !0;
              }), Qt;
            }
            function W(ze, nt) {
              if (!(ze.index === 0 || this.quill.getLength() <= 1)) {
                var Qt = this.quill.getLine(ze.index), Et = m(Qt, 1), zt = Et[0], Nt = {};
                if (nt.offset === 0) {
                  var pt = this.quill.getLine(ze.index - 1), at = m(pt, 1), kt = at[0];
                  if (kt != null && kt.length() > 1) {
                    var Ut = zt.formats(), dn = this.quill.getFormat(ze.index - 1, 1);
                    Nt = k.default.attributes.diff(Ut, dn) || {};
                  }
                }
                var En = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(nt.prefix) ? 2 : 1;
                this.quill.deleteText(ze.index - En, En, ue.default.sources.USER), Object.keys(Nt).length > 0 && this.quill.formatLine(ze.index - En, En, Nt, ue.default.sources.USER), this.quill.focus();
              }
            }
            function I(ze, nt) {
              var Qt = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(nt.suffix) ? 2 : 1;
              if (!(ze.index >= this.quill.getLength() - Qt)) {
                var Et = {}, zt = 0, Nt = this.quill.getLine(ze.index), pt = m(Nt, 1), at = pt[0];
                if (nt.offset >= at.length() - 1) {
                  var kt = this.quill.getLine(ze.index + 1), Ut = m(kt, 1), dn = Ut[0];
                  if (dn) {
                    var En = at.formats(), Ht = this.quill.getFormat(ze.index, 1);
                    Et = k.default.attributes.diff(En, Ht) || {}, zt = dn.length();
                  }
                }
                this.quill.deleteText(ze.index, Qt, ue.default.sources.USER), Object.keys(Et).length > 0 && this.quill.formatLine(ze.index + zt - 1, Qt, Et, ue.default.sources.USER);
              }
            }
            function te(ze) {
              var nt = this.quill.getLines(ze), Qt = {};
              if (nt.length > 1) {
                var Et = nt[0].formats(), zt = nt[nt.length - 1].formats();
                Qt = k.default.attributes.diff(zt, Et) || {};
              }
              this.quill.deleteText(ze, ue.default.sources.USER), Object.keys(Qt).length > 0 && this.quill.formatLine(ze.index, 1, Qt, ue.default.sources.USER), this.quill.setSelection(ze.index, ue.default.sources.SILENT), this.quill.focus();
            }
            function ge(ze, nt) {
              var Qt = this;
              ze.length > 0 && this.quill.scroll.deleteAt(ze.index, ze.length);
              var Et = Object.keys(nt.format).reduce(function(zt, Nt) {
                return X.default.query(Nt, X.default.Scope.BLOCK) && !Array.isArray(nt.format[Nt]) && (zt[Nt] = nt.format[Nt]), zt;
              }, {});
              this.quill.insertText(ze.index, `
`, Et, ue.default.sources.USER), this.quill.setSelection(ze.index + 1, ue.default.sources.SILENT), this.quill.focus(), Object.keys(nt.format).forEach(function(zt) {
                Et[zt] == null && (Array.isArray(nt.format[zt]) || zt !== "link" && Qt.quill.format(zt, nt.format[zt], ue.default.sources.USER));
              });
            }
            function Pe(ze) {
              return {
                key: fe.keys.TAB,
                shiftKey: !ze,
                format: { "code-block": !0 },
                handler: function(Qt) {
                  var Et = X.default.query("code-block"), zt = Qt.index, Nt = Qt.length, pt = this.quill.scroll.descendant(Et, zt), at = m(pt, 2), kt = at[0], Ut = at[1];
                  if (kt != null) {
                    var dn = this.quill.getIndex(kt), En = kt.newlineIndex(Ut, !0) + 1, Ht = kt.newlineIndex(dn + Ut + Nt), Xt = kt.domNode.textContent.slice(En, Ht).split(`
`);
                    Ut = 0, Xt.forEach(function(On, sn) {
                      ze ? (kt.insertAt(En + Ut, Et.TAB), Ut += Et.TAB.length, sn === 0 ? zt += Et.TAB.length : Nt += Et.TAB.length) : On.startsWith(Et.TAB) && (kt.deleteAt(En + Ut, Et.TAB.length), Ut -= Et.TAB.length, sn === 0 ? zt -= Et.TAB.length : Nt -= Et.TAB.length), Ut += On.length + 1;
                    }), this.quill.update(ue.default.sources.USER), this.quill.setSelection(zt, Nt, ue.default.sources.SILENT);
                  }
                }
              };
            }
            function Ke(ze) {
              return {
                key: ze[0].toUpperCase(),
                shortKey: !0,
                handler: function(Qt, Et) {
                  this.quill.format(ze, !Et.format[ze], ue.default.sources.USER);
                }
              };
            }
            function xe(ze) {
              if (typeof ze == "string" || typeof ze == "number")
                return xe({ key: ze });
              if ((typeof ze > "u" ? "undefined" : d(ze)) === "object" && (ze = (0, $.default)(ze, !1)), typeof ze.key == "string")
                if (fe.keys[ze.key.toUpperCase()] != null)
                  ze.key = fe.keys[ze.key.toUpperCase()];
                else if (ze.key.length === 1)
                  ze.key = ze.key.toUpperCase().charCodeAt(0);
                else
                  return null;
              return ze.shortKey && (ze[se] = ze.shortKey, delete ze.shortKey), ze;
            }
            u.default = fe, u.SHORTKEY = se;
          },
          /* 24 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function k(F, X) {
                var ee = [], ue = !0, Q = !1, Y = void 0;
                try {
                  for (var pe = F[Symbol.iterator](), oe; !(ue = (oe = pe.next()).done) && (ee.push(oe.value), !(X && ee.length === X)); ue = !0)
                    ;
                } catch (ne) {
                  Q = !0, Y = ne;
                } finally {
                  try {
                    !ue && pe.return && pe.return();
                  } finally {
                    if (Q)
                      throw Y;
                  }
                }
                return ee;
              }
              return function(F, X) {
                if (Array.isArray(F))
                  return F;
                if (Symbol.iterator in Object(F))
                  return k(F, X);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), m = function k(F, X, ee) {
              F === null && (F = Function.prototype);
              var ue = Object.getOwnPropertyDescriptor(F, X);
              if (ue === void 0) {
                var Q = Object.getPrototypeOf(F);
                return Q === null ? void 0 : k(Q, X, ee);
              } else {
                if ("value" in ue)
                  return ue.value;
                var Y = ue.get;
                return Y === void 0 ? void 0 : Y.call(ee);
              }
            }, v = function() {
              function k(F, X) {
                for (var ee = 0; ee < X.length; ee++) {
                  var ue = X[ee];
                  ue.enumerable = ue.enumerable || !1, ue.configurable = !0, "value" in ue && (ue.writable = !0), Object.defineProperty(F, ue.key, ue);
                }
              }
              return function(F, X, ee) {
                return X && k(F.prototype, X), ee && k(F, ee), F;
              };
            }(), S = c(0), $ = T(S), E = c(7), O = T(E);
            function T(k) {
              return k && k.__esModule ? k : { default: k };
            }
            function y(k, F) {
              if (!(k instanceof F))
                throw new TypeError("Cannot call a class as a function");
            }
            function V(k, F) {
              if (!k)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return F && (typeof F == "object" || typeof F == "function") ? F : k;
            }
            function M(k, F) {
              if (typeof F != "function" && F !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof F);
              k.prototype = Object.create(F && F.prototype, { constructor: { value: k, enumerable: !1, writable: !0, configurable: !0 } }), F && (Object.setPrototypeOf ? Object.setPrototypeOf(k, F) : k.__proto__ = F);
            }
            var G = function(k) {
              M(F, k), v(F, null, [{
                key: "value",
                value: function() {
                }
              }]);
              function F(X, ee) {
                y(this, F);
                var ue = V(this, (F.__proto__ || Object.getPrototypeOf(F)).call(this, X));
                return ue.selection = ee, ue.textNode = document.createTextNode(F.CONTENTS), ue.domNode.appendChild(ue.textNode), ue._length = 0, ue;
              }
              return v(F, [{
                key: "detach",
                value: function() {
                  this.parent != null && this.parent.removeChild(this);
                }
              }, {
                key: "format",
                value: function(ee, ue) {
                  if (this._length !== 0)
                    return m(F.prototype.__proto__ || Object.getPrototypeOf(F.prototype), "format", this).call(this, ee, ue);
                  for (var Q = this, Y = 0; Q != null && Q.statics.scope !== $.default.Scope.BLOCK_BLOT; )
                    Y += Q.offset(Q.parent), Q = Q.parent;
                  Q != null && (this._length = F.CONTENTS.length, Q.optimize(), Q.formatAt(Y, F.CONTENTS.length, ee, ue), this._length = 0);
                }
              }, {
                key: "index",
                value: function(ee, ue) {
                  return ee === this.textNode ? 0 : m(F.prototype.__proto__ || Object.getPrototypeOf(F.prototype), "index", this).call(this, ee, ue);
                }
              }, {
                key: "length",
                value: function() {
                  return this._length;
                }
              }, {
                key: "position",
                value: function() {
                  return [this.textNode, this.textNode.data.length];
                }
              }, {
                key: "remove",
                value: function() {
                  m(F.prototype.__proto__ || Object.getPrototypeOf(F.prototype), "remove", this).call(this), this.parent = null;
                }
              }, {
                key: "restore",
                value: function() {
                  if (!(this.selection.composing || this.parent == null)) {
                    var ee = this.textNode, ue = this.selection.getNativeRange(), Q = void 0, Y = void 0, pe = void 0;
                    if (ue != null && ue.start.node === ee && ue.end.node === ee) {
                      var oe = [ee, ue.start.offset, ue.end.offset];
                      Q = oe[0], Y = oe[1], pe = oe[2];
                    }
                    for (; this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode; )
                      this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                    if (this.textNode.data !== F.CONTENTS) {
                      var ne = this.textNode.data.split(F.CONTENTS).join("");
                      this.next instanceof O.default ? (Q = this.next.domNode, this.next.insertAt(0, ne), this.textNode.data = F.CONTENTS) : (this.textNode.data = ne, this.parent.insertBefore($.default.create(this.textNode), this), this.textNode = document.createTextNode(F.CONTENTS), this.domNode.appendChild(this.textNode));
                    }
                    if (this.remove(), Y != null) {
                      var H = [Y, pe].map(function(w) {
                        return Math.max(0, Math.min(Q.data.length, w - 1));
                      }), C = d(H, 2);
                      return Y = C[0], pe = C[1], {
                        startNode: Q,
                        startOffset: Y,
                        endNode: Q,
                        endOffset: pe
                      };
                    }
                  }
                }
              }, {
                key: "update",
                value: function(ee, ue) {
                  var Q = this;
                  if (ee.some(function(pe) {
                    return pe.type === "characterData" && pe.target === Q.textNode;
                  })) {
                    var Y = this.restore();
                    Y && (ue.range = Y);
                  }
                }
              }, {
                key: "value",
                value: function() {
                  return "";
                }
              }]), F;
            }($.default.Embed);
            G.blotName = "cursor", G.className = "ql-cursor", G.tagName = "span", G.CONTENTS = "\uFEFF", u.default = G;
          },
          /* 25 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = c(0), m = $(d), v = c(4), S = $(v);
            function $(V) {
              return V && V.__esModule ? V : { default: V };
            }
            function E(V, M) {
              if (!(V instanceof M))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(V, M) {
              if (!V)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return M && (typeof M == "object" || typeof M == "function") ? M : V;
            }
            function T(V, M) {
              if (typeof M != "function" && M !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof M);
              V.prototype = Object.create(M && M.prototype, { constructor: { value: V, enumerable: !1, writable: !0, configurable: !0 } }), M && (Object.setPrototypeOf ? Object.setPrototypeOf(V, M) : V.__proto__ = M);
            }
            var y = function(V) {
              T(M, V);
              function M() {
                return E(this, M), O(this, (M.__proto__ || Object.getPrototypeOf(M)).apply(this, arguments));
              }
              return M;
            }(m.default.Container);
            y.allowedChildren = [S.default, v.BlockEmbed, y], u.default = y;
          },
          /* 26 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.ColorStyle = u.ColorClass = u.ColorAttributor = void 0;
            var d = function() {
              function G(k, F) {
                for (var X = 0; X < F.length; X++) {
                  var ee = F[X];
                  ee.enumerable = ee.enumerable || !1, ee.configurable = !0, "value" in ee && (ee.writable = !0), Object.defineProperty(k, ee.key, ee);
                }
              }
              return function(k, F, X) {
                return F && G(k.prototype, F), X && G(k, X), k;
              };
            }(), m = function G(k, F, X) {
              k === null && (k = Function.prototype);
              var ee = Object.getOwnPropertyDescriptor(k, F);
              if (ee === void 0) {
                var ue = Object.getPrototypeOf(k);
                return ue === null ? void 0 : G(ue, F, X);
              } else {
                if ("value" in ee)
                  return ee.value;
                var Q = ee.get;
                return Q === void 0 ? void 0 : Q.call(X);
              }
            }, v = c(0), S = $(v);
            function $(G) {
              return G && G.__esModule ? G : { default: G };
            }
            function E(G, k) {
              if (!(G instanceof k))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(G, k) {
              if (!G)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return k && (typeof k == "object" || typeof k == "function") ? k : G;
            }
            function T(G, k) {
              if (typeof k != "function" && k !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof k);
              G.prototype = Object.create(k && k.prototype, { constructor: { value: G, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(G, k) : G.__proto__ = k);
            }
            var y = function(G) {
              T(k, G);
              function k() {
                return E(this, k), O(this, (k.__proto__ || Object.getPrototypeOf(k)).apply(this, arguments));
              }
              return d(k, [{
                key: "value",
                value: function(X) {
                  var ee = m(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "value", this).call(this, X);
                  return ee.startsWith("rgb(") ? (ee = ee.replace(/^[^\d]+/, "").replace(/[^\d]+$/, ""), "#" + ee.split(",").map(function(ue) {
                    return ("00" + parseInt(ue).toString(16)).slice(-2);
                  }).join("")) : ee;
                }
              }]), k;
            }(S.default.Attributor.Style), V = new S.default.Attributor.Class("color", "ql-color", {
              scope: S.default.Scope.INLINE
            }), M = new y("color", "color", {
              scope: S.default.Scope.INLINE
            });
            u.ColorAttributor = y, u.ColorClass = V, u.ColorStyle = M;
          },
          /* 27 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.sanitize = u.default = void 0;
            var d = function() {
              function M(G, k) {
                for (var F = 0; F < k.length; F++) {
                  var X = k[F];
                  X.enumerable = X.enumerable || !1, X.configurable = !0, "value" in X && (X.writable = !0), Object.defineProperty(G, X.key, X);
                }
              }
              return function(G, k, F) {
                return k && M(G.prototype, k), F && M(G, F), G;
              };
            }(), m = function M(G, k, F) {
              G === null && (G = Function.prototype);
              var X = Object.getOwnPropertyDescriptor(G, k);
              if (X === void 0) {
                var ee = Object.getPrototypeOf(G);
                return ee === null ? void 0 : M(ee, k, F);
              } else {
                if ("value" in X)
                  return X.value;
                var ue = X.get;
                return ue === void 0 ? void 0 : ue.call(F);
              }
            }, v = c(6), S = $(v);
            function $(M) {
              return M && M.__esModule ? M : { default: M };
            }
            function E(M, G) {
              if (!(M instanceof G))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(M, G) {
              if (!M)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return G && (typeof G == "object" || typeof G == "function") ? G : M;
            }
            function T(M, G) {
              if (typeof G != "function" && G !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof G);
              M.prototype = Object.create(G && G.prototype, { constructor: { value: M, enumerable: !1, writable: !0, configurable: !0 } }), G && (Object.setPrototypeOf ? Object.setPrototypeOf(M, G) : M.__proto__ = G);
            }
            var y = function(M) {
              T(G, M);
              function G() {
                return E(this, G), O(this, (G.__proto__ || Object.getPrototypeOf(G)).apply(this, arguments));
              }
              return d(G, [{
                key: "format",
                value: function(F, X) {
                  if (F !== this.statics.blotName || !X)
                    return m(G.prototype.__proto__ || Object.getPrototypeOf(G.prototype), "format", this).call(this, F, X);
                  X = this.constructor.sanitize(X), this.domNode.setAttribute("href", X);
                }
              }], [{
                key: "create",
                value: function(F) {
                  var X = m(G.__proto__ || Object.getPrototypeOf(G), "create", this).call(this, F);
                  return F = this.sanitize(F), X.setAttribute("href", F), X.setAttribute("rel", "noopener noreferrer"), X.setAttribute("target", "_blank"), X;
                }
              }, {
                key: "formats",
                value: function(F) {
                  return F.getAttribute("href");
                }
              }, {
                key: "sanitize",
                value: function(F) {
                  return V(F, this.PROTOCOL_WHITELIST) ? F : this.SANITIZED_URL;
                }
              }]), G;
            }(S.default);
            y.blotName = "link", y.tagName = "A", y.SANITIZED_URL = "about:blank", y.PROTOCOL_WHITELIST = ["http", "https", "mailto", "tel"];
            function V(M, G) {
              var k = document.createElement("a");
              k.href = M;
              var F = k.href.slice(0, k.href.indexOf(":"));
              return G.indexOf(F) > -1;
            }
            u.default = y, u.sanitize = V;
          },
          /* 28 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(G) {
              return typeof G;
            } : function(G) {
              return G && typeof Symbol == "function" && G.constructor === Symbol && G !== Symbol.prototype ? "symbol" : typeof G;
            }, m = function() {
              function G(k, F) {
                for (var X = 0; X < F.length; X++) {
                  var ee = F[X];
                  ee.enumerable = ee.enumerable || !1, ee.configurable = !0, "value" in ee && (ee.writable = !0), Object.defineProperty(k, ee.key, ee);
                }
              }
              return function(k, F, X) {
                return F && G(k.prototype, F), X && G(k, X), k;
              };
            }(), v = c(23), S = O(v), $ = c(107), E = O($);
            function O(G) {
              return G && G.__esModule ? G : { default: G };
            }
            function T(G, k) {
              if (!(G instanceof k))
                throw new TypeError("Cannot call a class as a function");
            }
            var y = 0;
            function V(G, k) {
              G.setAttribute(k, G.getAttribute(k) !== "true");
            }
            var M = function() {
              function G(k) {
                var F = this;
                T(this, G), this.select = k, this.container = document.createElement("span"), this.buildPicker(), this.select.style.display = "none", this.select.parentNode.insertBefore(this.container, this.select), this.label.addEventListener("mousedown", function() {
                  F.togglePicker();
                }), this.label.addEventListener("keydown", function(X) {
                  switch (X.keyCode) {
                    case S.default.keys.ENTER:
                      F.togglePicker();
                      break;
                    case S.default.keys.ESCAPE:
                      F.escape(), X.preventDefault();
                      break;
                  }
                }), this.select.addEventListener("change", this.update.bind(this));
              }
              return m(G, [{
                key: "togglePicker",
                value: function() {
                  this.container.classList.toggle("ql-expanded"), V(this.label, "aria-expanded"), V(this.options, "aria-hidden");
                }
              }, {
                key: "buildItem",
                value: function(F) {
                  var X = this, ee = document.createElement("span");
                  return ee.tabIndex = "0", ee.setAttribute("role", "button"), ee.classList.add("ql-picker-item"), F.hasAttribute("value") && ee.setAttribute("data-value", F.getAttribute("value")), F.textContent && ee.setAttribute("data-label", F.textContent), ee.addEventListener("click", function() {
                    X.selectItem(ee, !0);
                  }), ee.addEventListener("keydown", function(ue) {
                    switch (ue.keyCode) {
                      case S.default.keys.ENTER:
                        X.selectItem(ee, !0), ue.preventDefault();
                        break;
                      case S.default.keys.ESCAPE:
                        X.escape(), ue.preventDefault();
                        break;
                    }
                  }), ee;
                }
              }, {
                key: "buildLabel",
                value: function() {
                  var F = document.createElement("span");
                  return F.classList.add("ql-picker-label"), F.innerHTML = E.default, F.tabIndex = "0", F.setAttribute("role", "button"), F.setAttribute("aria-expanded", "false"), this.container.appendChild(F), F;
                }
              }, {
                key: "buildOptions",
                value: function() {
                  var F = this, X = document.createElement("span");
                  X.classList.add("ql-picker-options"), X.setAttribute("aria-hidden", "true"), X.tabIndex = "-1", X.id = "ql-picker-options-" + y, y += 1, this.label.setAttribute("aria-controls", X.id), this.options = X, [].slice.call(this.select.options).forEach(function(ee) {
                    var ue = F.buildItem(ee);
                    X.appendChild(ue), ee.selected === !0 && F.selectItem(ue);
                  }), this.container.appendChild(X);
                }
              }, {
                key: "buildPicker",
                value: function() {
                  var F = this;
                  [].slice.call(this.select.attributes).forEach(function(X) {
                    F.container.setAttribute(X.name, X.value);
                  }), this.container.classList.add("ql-picker"), this.label = this.buildLabel(), this.buildOptions();
                }
              }, {
                key: "escape",
                value: function() {
                  var F = this;
                  this.close(), setTimeout(function() {
                    return F.label.focus();
                  }, 1);
                }
              }, {
                key: "close",
                value: function() {
                  this.container.classList.remove("ql-expanded"), this.label.setAttribute("aria-expanded", "false"), this.options.setAttribute("aria-hidden", "true");
                }
              }, {
                key: "selectItem",
                value: function(F) {
                  var X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, ee = this.container.querySelector(".ql-selected");
                  if (F !== ee && (ee != null && ee.classList.remove("ql-selected"), F != null && (F.classList.add("ql-selected"), this.select.selectedIndex = [].indexOf.call(F.parentNode.children, F), F.hasAttribute("data-value") ? this.label.setAttribute("data-value", F.getAttribute("data-value")) : this.label.removeAttribute("data-value"), F.hasAttribute("data-label") ? this.label.setAttribute("data-label", F.getAttribute("data-label")) : this.label.removeAttribute("data-label"), X))) {
                    if (typeof Event == "function")
                      this.select.dispatchEvent(new Event("change"));
                    else if ((typeof Event > "u" ? "undefined" : d(Event)) === "object") {
                      var ue = document.createEvent("Event");
                      ue.initEvent("change", !0, !0), this.select.dispatchEvent(ue);
                    }
                    this.close();
                  }
                }
              }, {
                key: "update",
                value: function() {
                  var F = void 0;
                  if (this.select.selectedIndex > -1) {
                    var X = this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
                    F = this.select.options[this.select.selectedIndex], this.selectItem(X);
                  } else
                    this.selectItem(null);
                  var ee = F != null && F !== this.select.querySelector("option[selected]");
                  this.label.classList.toggle("ql-active", ee);
                }
              }]), G;
            }();
            u.default = M;
          },
          /* 29 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = c(0), m = J(d), v = c(5), S = J(v), $ = c(4), E = J($), O = c(16), T = J(O), y = c(25), V = J(y), M = c(24), G = J(M), k = c(35), F = J(k), X = c(6), ee = J(X), ue = c(22), Q = J(ue), Y = c(7), pe = J(Y), oe = c(55), ne = J(oe), H = c(42), C = J(H), w = c(23), P = J(w);
            function J(se) {
              return se && se.__esModule ? se : { default: se };
            }
            S.default.register({
              "blots/block": E.default,
              "blots/block/embed": $.BlockEmbed,
              "blots/break": T.default,
              "blots/container": V.default,
              "blots/cursor": G.default,
              "blots/embed": F.default,
              "blots/inline": ee.default,
              "blots/scroll": Q.default,
              "blots/text": pe.default,
              "modules/clipboard": ne.default,
              "modules/history": C.default,
              "modules/keyboard": P.default
            }), m.default.register(E.default, T.default, G.default, ee.default, Q.default, pe.default), u.default = S.default;
          },
          /* 30 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", { value: !0 });
            var d = c(1), m = (
              /** @class */
              function() {
                function v(S) {
                  this.domNode = S, this.domNode[d.DATA_KEY] = { blot: this };
                }
                return Object.defineProperty(v.prototype, "statics", {
                  // Hack for accessing inherited static methods
                  get: function() {
                    return this.constructor;
                  },
                  enumerable: !0,
                  configurable: !0
                }), v.create = function(S) {
                  if (this.tagName == null)
                    throw new d.ParchmentError("Blot definition missing tagName");
                  var $;
                  return Array.isArray(this.tagName) ? (typeof S == "string" && (S = S.toUpperCase(), parseInt(S).toString() === S && (S = parseInt(S))), typeof S == "number" ? $ = document.createElement(this.tagName[S - 1]) : this.tagName.indexOf(S) > -1 ? $ = document.createElement(S) : $ = document.createElement(this.tagName[0])) : $ = document.createElement(this.tagName), this.className && $.classList.add(this.className), $;
                }, v.prototype.attach = function() {
                  this.parent != null && (this.scroll = this.parent.scroll);
                }, v.prototype.clone = function() {
                  var S = this.domNode.cloneNode(!1);
                  return d.create(S);
                }, v.prototype.detach = function() {
                  this.parent != null && this.parent.removeChild(this), delete this.domNode[d.DATA_KEY];
                }, v.prototype.deleteAt = function(S, $) {
                  var E = this.isolate(S, $);
                  E.remove();
                }, v.prototype.formatAt = function(S, $, E, O) {
                  var T = this.isolate(S, $);
                  if (d.query(E, d.Scope.BLOT) != null && O)
                    T.wrap(E, O);
                  else if (d.query(E, d.Scope.ATTRIBUTE) != null) {
                    var y = d.create(this.statics.scope);
                    T.wrap(y), y.format(E, O);
                  }
                }, v.prototype.insertAt = function(S, $, E) {
                  var O = E == null ? d.create("text", $) : d.create($, E), T = this.split(S);
                  this.parent.insertBefore(O, T);
                }, v.prototype.insertInto = function(S, $) {
                  $ === void 0 && ($ = null), this.parent != null && this.parent.children.remove(this);
                  var E = null;
                  S.children.insertBefore(this, $), $ != null && (E = $.domNode), (this.domNode.parentNode != S.domNode || this.domNode.nextSibling != E) && S.domNode.insertBefore(this.domNode, E), this.parent = S, this.attach();
                }, v.prototype.isolate = function(S, $) {
                  var E = this.split(S);
                  return E.split($), E;
                }, v.prototype.length = function() {
                  return 1;
                }, v.prototype.offset = function(S) {
                  return S === void 0 && (S = this.parent), this.parent == null || this == S ? 0 : this.parent.children.offset(this) + this.parent.offset(S);
                }, v.prototype.optimize = function(S) {
                  this.domNode[d.DATA_KEY] != null && delete this.domNode[d.DATA_KEY].mutations;
                }, v.prototype.remove = function() {
                  this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
                }, v.prototype.replace = function(S) {
                  S.parent != null && (S.parent.insertBefore(this, S.next), S.remove());
                }, v.prototype.replaceWith = function(S, $) {
                  var E = typeof S == "string" ? d.create(S, $) : S;
                  return E.replace(this), E;
                }, v.prototype.split = function(S, $) {
                  return S === 0 ? this : this.next;
                }, v.prototype.update = function(S, $) {
                }, v.prototype.wrap = function(S, $) {
                  var E = typeof S == "string" ? d.create(S, $) : S;
                  return this.parent != null && this.parent.insertBefore(E, this.next), E.appendChild(this), E;
                }, v.blotName = "abstract", v;
              }()
            );
            u.default = m;
          },
          /* 31 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", { value: !0 });
            var d = c(12), m = c(32), v = c(33), S = c(1), $ = (
              /** @class */
              function() {
                function E(O) {
                  this.attributes = {}, this.domNode = O, this.build();
                }
                return E.prototype.attribute = function(O, T) {
                  T ? O.add(this.domNode, T) && (O.value(this.domNode) != null ? this.attributes[O.attrName] = O : delete this.attributes[O.attrName]) : (O.remove(this.domNode), delete this.attributes[O.attrName]);
                }, E.prototype.build = function() {
                  var O = this;
                  this.attributes = {};
                  var T = d.default.keys(this.domNode), y = m.default.keys(this.domNode), V = v.default.keys(this.domNode);
                  T.concat(y).concat(V).forEach(function(M) {
                    var G = S.query(M, S.Scope.ATTRIBUTE);
                    G instanceof d.default && (O.attributes[G.attrName] = G);
                  });
                }, E.prototype.copy = function(O) {
                  var T = this;
                  Object.keys(this.attributes).forEach(function(y) {
                    var V = T.attributes[y].value(T.domNode);
                    O.format(y, V);
                  });
                }, E.prototype.move = function(O) {
                  var T = this;
                  this.copy(O), Object.keys(this.attributes).forEach(function(y) {
                    T.attributes[y].remove(T.domNode);
                  }), this.attributes = {};
                }, E.prototype.values = function() {
                  var O = this;
                  return Object.keys(this.attributes).reduce(function(T, y) {
                    return T[y] = O.attributes[y].value(O.domNode), T;
                  }, {});
                }, E;
              }()
            );
            u.default = $;
          },
          /* 32 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, O) {
                E.__proto__ = O;
              } || function(E, O) {
                for (var T in O)
                  O.hasOwnProperty(T) && (E[T] = O[T]);
              };
              return function(E, O) {
                $(E, O);
                function T() {
                  this.constructor = E;
                }
                E.prototype = O === null ? Object.create(O) : (T.prototype = O.prototype, new T());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(12);
            function v($, E) {
              var O = $.getAttribute("class") || "";
              return O.split(/\s+/).filter(function(T) {
                return T.indexOf(E + "-") === 0;
              });
            }
            var S = (
              /** @class */
              function($) {
                d(E, $);
                function E() {
                  return $ !== null && $.apply(this, arguments) || this;
                }
                return E.keys = function(O) {
                  return (O.getAttribute("class") || "").split(/\s+/).map(function(T) {
                    return T.split("-").slice(0, -1).join("-");
                  });
                }, E.prototype.add = function(O, T) {
                  return this.canAdd(O, T) ? (this.remove(O), O.classList.add(this.keyName + "-" + T), !0) : !1;
                }, E.prototype.remove = function(O) {
                  var T = v(O, this.keyName);
                  T.forEach(function(y) {
                    O.classList.remove(y);
                  }), O.classList.length === 0 && O.removeAttribute("class");
                }, E.prototype.value = function(O) {
                  var T = v(O, this.keyName)[0] || "", y = T.slice(this.keyName.length + 1);
                  return this.canAdd(O, y) ? y : "";
                }, E;
              }(m.default)
            );
            u.default = S;
          },
          /* 33 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, O) {
                E.__proto__ = O;
              } || function(E, O) {
                for (var T in O)
                  O.hasOwnProperty(T) && (E[T] = O[T]);
              };
              return function(E, O) {
                $(E, O);
                function T() {
                  this.constructor = E;
                }
                E.prototype = O === null ? Object.create(O) : (T.prototype = O.prototype, new T());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(12);
            function v($) {
              var E = $.split("-"), O = E.slice(1).map(function(T) {
                return T[0].toUpperCase() + T.slice(1);
              }).join("");
              return E[0] + O;
            }
            var S = (
              /** @class */
              function($) {
                d(E, $);
                function E() {
                  return $ !== null && $.apply(this, arguments) || this;
                }
                return E.keys = function(O) {
                  return (O.getAttribute("style") || "").split(";").map(function(T) {
                    var y = T.split(":");
                    return y[0].trim();
                  });
                }, E.prototype.add = function(O, T) {
                  return this.canAdd(O, T) ? (O.style[v(this.keyName)] = T, !0) : !1;
                }, E.prototype.remove = function(O) {
                  O.style[v(this.keyName)] = "", O.getAttribute("style") || O.removeAttribute("style");
                }, E.prototype.value = function(O) {
                  var T = O.style[v(this.keyName)];
                  return this.canAdd(O, T) ? T : "";
                }, E;
              }(m.default)
            );
            u.default = S;
          },
          /* 34 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function S($, E) {
                for (var O = 0; O < E.length; O++) {
                  var T = E[O];
                  T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty($, T.key, T);
                }
              }
              return function($, E, O) {
                return E && S($.prototype, E), O && S($, O), $;
              };
            }();
            function m(S, $) {
              if (!(S instanceof $))
                throw new TypeError("Cannot call a class as a function");
            }
            var v = function() {
              function S($, E) {
                m(this, S), this.quill = $, this.options = E, this.modules = {};
              }
              return d(S, [{
                key: "init",
                value: function() {
                  var E = this;
                  Object.keys(this.options.modules).forEach(function(O) {
                    E.modules[O] == null && E.addModule(O);
                  });
                }
              }, {
                key: "addModule",
                value: function(E) {
                  var O = this.quill.constructor.import("modules/" + E);
                  return this.modules[E] = new O(this.quill, this.options.modules[E] || {}), this.modules[E];
                }
              }]), S;
            }();
            v.DEFAULTS = {
              modules: {}
            }, v.themes = {
              default: v
            }, u.default = v;
          },
          /* 35 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function k(F, X) {
                for (var ee = 0; ee < X.length; ee++) {
                  var ue = X[ee];
                  ue.enumerable = ue.enumerable || !1, ue.configurable = !0, "value" in ue && (ue.writable = !0), Object.defineProperty(F, ue.key, ue);
                }
              }
              return function(F, X, ee) {
                return X && k(F.prototype, X), ee && k(F, ee), F;
              };
            }(), m = function k(F, X, ee) {
              F === null && (F = Function.prototype);
              var ue = Object.getOwnPropertyDescriptor(F, X);
              if (ue === void 0) {
                var Q = Object.getPrototypeOf(F);
                return Q === null ? void 0 : k(Q, X, ee);
              } else {
                if ("value" in ue)
                  return ue.value;
                var Y = ue.get;
                return Y === void 0 ? void 0 : Y.call(ee);
              }
            }, v = c(0), S = O(v), $ = c(7), E = O($);
            function O(k) {
              return k && k.__esModule ? k : { default: k };
            }
            function T(k, F) {
              if (!(k instanceof F))
                throw new TypeError("Cannot call a class as a function");
            }
            function y(k, F) {
              if (!k)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return F && (typeof F == "object" || typeof F == "function") ? F : k;
            }
            function V(k, F) {
              if (typeof F != "function" && F !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof F);
              k.prototype = Object.create(F && F.prototype, { constructor: { value: k, enumerable: !1, writable: !0, configurable: !0 } }), F && (Object.setPrototypeOf ? Object.setPrototypeOf(k, F) : k.__proto__ = F);
            }
            var M = "\uFEFF", G = function(k) {
              V(F, k);
              function F(X) {
                T(this, F);
                var ee = y(this, (F.__proto__ || Object.getPrototypeOf(F)).call(this, X));
                return ee.contentNode = document.createElement("span"), ee.contentNode.setAttribute("contenteditable", !1), [].slice.call(ee.domNode.childNodes).forEach(function(ue) {
                  ee.contentNode.appendChild(ue);
                }), ee.leftGuard = document.createTextNode(M), ee.rightGuard = document.createTextNode(M), ee.domNode.appendChild(ee.leftGuard), ee.domNode.appendChild(ee.contentNode), ee.domNode.appendChild(ee.rightGuard), ee;
              }
              return d(F, [{
                key: "index",
                value: function(ee, ue) {
                  return ee === this.leftGuard ? 0 : ee === this.rightGuard ? 1 : m(F.prototype.__proto__ || Object.getPrototypeOf(F.prototype), "index", this).call(this, ee, ue);
                }
              }, {
                key: "restore",
                value: function(ee) {
                  var ue = void 0, Q = void 0, Y = ee.data.split(M).join("");
                  if (ee === this.leftGuard)
                    if (this.prev instanceof E.default) {
                      var pe = this.prev.length();
                      this.prev.insertAt(pe, Y), ue = {
                        startNode: this.prev.domNode,
                        startOffset: pe + Y.length
                      };
                    } else
                      Q = document.createTextNode(Y), this.parent.insertBefore(S.default.create(Q), this), ue = {
                        startNode: Q,
                        startOffset: Y.length
                      };
                  else
                    ee === this.rightGuard && (this.next instanceof E.default ? (this.next.insertAt(0, Y), ue = {
                      startNode: this.next.domNode,
                      startOffset: Y.length
                    }) : (Q = document.createTextNode(Y), this.parent.insertBefore(S.default.create(Q), this.next), ue = {
                      startNode: Q,
                      startOffset: Y.length
                    }));
                  return ee.data = M, ue;
                }
              }, {
                key: "update",
                value: function(ee, ue) {
                  var Q = this;
                  ee.forEach(function(Y) {
                    if (Y.type === "characterData" && (Y.target === Q.leftGuard || Y.target === Q.rightGuard)) {
                      var pe = Q.restore(Y.target);
                      pe && (ue.range = pe);
                    }
                  });
                }
              }]), F;
            }(S.default.Embed);
            u.default = G;
          },
          /* 36 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.AlignStyle = u.AlignClass = u.AlignAttribute = void 0;
            var d = c(0), m = v(d);
            function v(T) {
              return T && T.__esModule ? T : { default: T };
            }
            var S = {
              scope: m.default.Scope.BLOCK,
              whitelist: ["right", "center", "justify"]
            }, $ = new m.default.Attributor.Attribute("align", "align", S), E = new m.default.Attributor.Class("align", "ql-align", S), O = new m.default.Attributor.Style("align", "text-align", S);
            u.AlignAttribute = $, u.AlignClass = E, u.AlignStyle = O;
          },
          /* 37 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.BackgroundStyle = u.BackgroundClass = void 0;
            var d = c(0), m = S(d), v = c(26);
            function S(O) {
              return O && O.__esModule ? O : { default: O };
            }
            var $ = new m.default.Attributor.Class("background", "ql-bg", {
              scope: m.default.Scope.INLINE
            }), E = new v.ColorAttributor("background", "background-color", {
              scope: m.default.Scope.INLINE
            });
            u.BackgroundClass = $, u.BackgroundStyle = E;
          },
          /* 38 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.DirectionStyle = u.DirectionClass = u.DirectionAttribute = void 0;
            var d = c(0), m = v(d);
            function v(T) {
              return T && T.__esModule ? T : { default: T };
            }
            var S = {
              scope: m.default.Scope.BLOCK,
              whitelist: ["rtl"]
            }, $ = new m.default.Attributor.Attribute("direction", "dir", S), E = new m.default.Attributor.Class("direction", "ql-direction", S), O = new m.default.Attributor.Style("direction", "direction", S);
            u.DirectionAttribute = $, u.DirectionClass = E, u.DirectionStyle = O;
          },
          /* 39 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.FontClass = u.FontStyle = void 0;
            var d = function() {
              function k(F, X) {
                for (var ee = 0; ee < X.length; ee++) {
                  var ue = X[ee];
                  ue.enumerable = ue.enumerable || !1, ue.configurable = !0, "value" in ue && (ue.writable = !0), Object.defineProperty(F, ue.key, ue);
                }
              }
              return function(F, X, ee) {
                return X && k(F.prototype, X), ee && k(F, ee), F;
              };
            }(), m = function k(F, X, ee) {
              F === null && (F = Function.prototype);
              var ue = Object.getOwnPropertyDescriptor(F, X);
              if (ue === void 0) {
                var Q = Object.getPrototypeOf(F);
                return Q === null ? void 0 : k(Q, X, ee);
              } else {
                if ("value" in ue)
                  return ue.value;
                var Y = ue.get;
                return Y === void 0 ? void 0 : Y.call(ee);
              }
            }, v = c(0), S = $(v);
            function $(k) {
              return k && k.__esModule ? k : { default: k };
            }
            function E(k, F) {
              if (!(k instanceof F))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(k, F) {
              if (!k)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return F && (typeof F == "object" || typeof F == "function") ? F : k;
            }
            function T(k, F) {
              if (typeof F != "function" && F !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof F);
              k.prototype = Object.create(F && F.prototype, { constructor: { value: k, enumerable: !1, writable: !0, configurable: !0 } }), F && (Object.setPrototypeOf ? Object.setPrototypeOf(k, F) : k.__proto__ = F);
            }
            var y = {
              scope: S.default.Scope.INLINE,
              whitelist: ["serif", "monospace"]
            }, V = new S.default.Attributor.Class("font", "ql-font", y), M = function(k) {
              T(F, k);
              function F() {
                return E(this, F), O(this, (F.__proto__ || Object.getPrototypeOf(F)).apply(this, arguments));
              }
              return d(F, [{
                key: "value",
                value: function(ee) {
                  return m(F.prototype.__proto__ || Object.getPrototypeOf(F.prototype), "value", this).call(this, ee).replace(/["']/g, "");
                }
              }]), F;
            }(S.default.Attributor.Style), G = new M("font", "font-family", y);
            u.FontStyle = G, u.FontClass = V;
          },
          /* 40 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.SizeStyle = u.SizeClass = void 0;
            var d = c(0), m = v(d);
            function v(E) {
              return E && E.__esModule ? E : { default: E };
            }
            var S = new m.default.Attributor.Class("size", "ql-size", {
              scope: m.default.Scope.INLINE,
              whitelist: ["small", "large", "huge"]
            }), $ = new m.default.Attributor.Style("size", "font-size", {
              scope: m.default.Scope.INLINE,
              whitelist: ["10px", "18px", "32px"]
            });
            u.SizeClass = S, u.SizeStyle = $;
          },
          /* 41 */
          /***/
          function(o, u, c) {
            o.exports = {
              align: {
                "": c(76),
                center: c(77),
                right: c(78),
                justify: c(79)
              },
              background: c(80),
              blockquote: c(81),
              bold: c(82),
              clean: c(83),
              code: c(58),
              "code-block": c(58),
              color: c(84),
              direction: {
                "": c(85),
                rtl: c(86)
              },
              float: {
                center: c(87),
                full: c(88),
                left: c(89),
                right: c(90)
              },
              formula: c(91),
              header: {
                1: c(92),
                2: c(93)
              },
              italic: c(94),
              image: c(95),
              indent: {
                "+1": c(96),
                "-1": c(97)
              },
              link: c(98),
              list: {
                ordered: c(99),
                bullet: c(100),
                check: c(101)
              },
              script: {
                sub: c(102),
                super: c(103)
              },
              strike: c(104),
              underline: c(105),
              video: c(106)
            };
          },
          /* 42 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.getLastChangeIndex = u.default = void 0;
            var d = function() {
              function X(ee, ue) {
                for (var Q = 0; Q < ue.length; Q++) {
                  var Y = ue[Q];
                  Y.enumerable = Y.enumerable || !1, Y.configurable = !0, "value" in Y && (Y.writable = !0), Object.defineProperty(ee, Y.key, Y);
                }
              }
              return function(ee, ue, Q) {
                return ue && X(ee.prototype, ue), Q && X(ee, Q), ee;
              };
            }(), m = c(0), v = T(m), S = c(5), $ = T(S), E = c(9), O = T(E);
            function T(X) {
              return X && X.__esModule ? X : { default: X };
            }
            function y(X, ee) {
              if (!(X instanceof ee))
                throw new TypeError("Cannot call a class as a function");
            }
            function V(X, ee) {
              if (!X)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return ee && (typeof ee == "object" || typeof ee == "function") ? ee : X;
            }
            function M(X, ee) {
              if (typeof ee != "function" && ee !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof ee);
              X.prototype = Object.create(ee && ee.prototype, { constructor: { value: X, enumerable: !1, writable: !0, configurable: !0 } }), ee && (Object.setPrototypeOf ? Object.setPrototypeOf(X, ee) : X.__proto__ = ee);
            }
            var G = function(X) {
              M(ee, X);
              function ee(ue, Q) {
                y(this, ee);
                var Y = V(this, (ee.__proto__ || Object.getPrototypeOf(ee)).call(this, ue, Q));
                return Y.lastRecorded = 0, Y.ignoreChange = !1, Y.clear(), Y.quill.on($.default.events.EDITOR_CHANGE, function(pe, oe, ne, H) {
                  pe !== $.default.events.TEXT_CHANGE || Y.ignoreChange || (!Y.options.userOnly || H === $.default.sources.USER ? Y.record(oe, ne) : Y.transform(oe));
                }), Y.quill.keyboard.addBinding({ key: "Z", shortKey: !0 }, Y.undo.bind(Y)), Y.quill.keyboard.addBinding({ key: "Z", shortKey: !0, shiftKey: !0 }, Y.redo.bind(Y)), /Win/i.test(navigator.platform) && Y.quill.keyboard.addBinding({ key: "Y", shortKey: !0 }, Y.redo.bind(Y)), Y;
              }
              return d(ee, [{
                key: "change",
                value: function(Q, Y) {
                  if (this.stack[Q].length !== 0) {
                    var pe = this.stack[Q].pop();
                    this.stack[Y].push(pe), this.lastRecorded = 0, this.ignoreChange = !0, this.quill.updateContents(pe[Q], $.default.sources.USER), this.ignoreChange = !1;
                    var oe = F(pe[Q]);
                    this.quill.setSelection(oe);
                  }
                }
              }, {
                key: "clear",
                value: function() {
                  this.stack = { undo: [], redo: [] };
                }
              }, {
                key: "cutoff",
                value: function() {
                  this.lastRecorded = 0;
                }
              }, {
                key: "record",
                value: function(Q, Y) {
                  if (Q.ops.length !== 0) {
                    this.stack.redo = [];
                    var pe = this.quill.getContents().diff(Y), oe = Date.now();
                    if (this.lastRecorded + this.options.delay > oe && this.stack.undo.length > 0) {
                      var ne = this.stack.undo.pop();
                      pe = pe.compose(ne.undo), Q = ne.redo.compose(Q);
                    } else
                      this.lastRecorded = oe;
                    this.stack.undo.push({
                      redo: Q,
                      undo: pe
                    }), this.stack.undo.length > this.options.maxStack && this.stack.undo.shift();
                  }
                }
              }, {
                key: "redo",
                value: function() {
                  this.change("redo", "undo");
                }
              }, {
                key: "transform",
                value: function(Q) {
                  this.stack.undo.forEach(function(Y) {
                    Y.undo = Q.transform(Y.undo, !0), Y.redo = Q.transform(Y.redo, !0);
                  }), this.stack.redo.forEach(function(Y) {
                    Y.undo = Q.transform(Y.undo, !0), Y.redo = Q.transform(Y.redo, !0);
                  });
                }
              }, {
                key: "undo",
                value: function() {
                  this.change("undo", "redo");
                }
              }]), ee;
            }(O.default);
            G.DEFAULTS = {
              delay: 1e3,
              maxStack: 100,
              userOnly: !1
            };
            function k(X) {
              var ee = X.ops[X.ops.length - 1];
              return ee == null ? !1 : ee.insert != null ? typeof ee.insert == "string" && ee.insert.endsWith(`
`) : ee.attributes != null ? Object.keys(ee.attributes).some(function(ue) {
                return v.default.query(ue, v.default.Scope.BLOCK) != null;
              }) : !1;
            }
            function F(X) {
              var ee = X.reduce(function(Q, Y) {
                return Q += Y.delete || 0, Q;
              }, 0), ue = X.length() - ee;
              return k(X) && (ue -= 1), ue;
            }
            u.default = G, u.getLastChangeIndex = F;
          },
          /* 43 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.BaseTooltip = void 0;
            var d = function() {
              function ge(Pe, Ke) {
                for (var xe = 0; xe < Ke.length; xe++) {
                  var ze = Ke[xe];
                  ze.enumerable = ze.enumerable || !1, ze.configurable = !0, "value" in ze && (ze.writable = !0), Object.defineProperty(Pe, ze.key, ze);
                }
              }
              return function(Pe, Ke, xe) {
                return Ke && ge(Pe.prototype, Ke), xe && ge(Pe, xe), Pe;
              };
            }(), m = function ge(Pe, Ke, xe) {
              Pe === null && (Pe = Function.prototype);
              var ze = Object.getOwnPropertyDescriptor(Pe, Ke);
              if (ze === void 0) {
                var nt = Object.getPrototypeOf(Pe);
                return nt === null ? void 0 : ge(nt, Ke, xe);
              } else {
                if ("value" in ze)
                  return ze.value;
                var Qt = ze.get;
                return Qt === void 0 ? void 0 : Qt.call(xe);
              }
            }, v = c(3), S = oe(v), $ = c(2), E = oe($), O = c(8), T = oe(O), y = c(23), V = oe(y), M = c(34), G = oe(M), k = c(59), F = oe(k), X = c(60), ee = oe(X), ue = c(28), Q = oe(ue), Y = c(61), pe = oe(Y);
            function oe(ge) {
              return ge && ge.__esModule ? ge : { default: ge };
            }
            function ne(ge, Pe) {
              if (!(ge instanceof Pe))
                throw new TypeError("Cannot call a class as a function");
            }
            function H(ge, Pe) {
              if (!ge)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return Pe && (typeof Pe == "object" || typeof Pe == "function") ? Pe : ge;
            }
            function C(ge, Pe) {
              if (typeof Pe != "function" && Pe !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof Pe);
              ge.prototype = Object.create(Pe && Pe.prototype, { constructor: { value: ge, enumerable: !1, writable: !0, configurable: !0 } }), Pe && (Object.setPrototypeOf ? Object.setPrototypeOf(ge, Pe) : ge.__proto__ = Pe);
            }
            var w = [!1, "center", "right", "justify"], P = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"], J = [!1, "serif", "monospace"], se = ["1", "2", "3", !1], fe = ["small", !1, "large", "huge"], N = function(ge) {
              C(Pe, ge);
              function Pe(Ke, xe) {
                ne(this, Pe);
                var ze = H(this, (Pe.__proto__ || Object.getPrototypeOf(Pe)).call(this, Ke, xe)), nt = function Qt(Et) {
                  if (!document.body.contains(Ke.root))
                    return document.body.removeEventListener("click", Qt);
                  ze.tooltip != null && !ze.tooltip.root.contains(Et.target) && document.activeElement !== ze.tooltip.textbox && !ze.quill.hasFocus() && ze.tooltip.hide(), ze.pickers != null && ze.pickers.forEach(function(zt) {
                    zt.container.contains(Et.target) || zt.close();
                  });
                };
                return Ke.emitter.listenDOM("click", document.body, nt), ze;
              }
              return d(Pe, [{
                key: "addModule",
                value: function(xe) {
                  var ze = m(Pe.prototype.__proto__ || Object.getPrototypeOf(Pe.prototype), "addModule", this).call(this, xe);
                  return xe === "toolbar" && this.extendToolbar(ze), ze;
                }
              }, {
                key: "buildButtons",
                value: function(xe, ze) {
                  xe.forEach(function(nt) {
                    var Qt = nt.getAttribute("class") || "";
                    Qt.split(/\s+/).forEach(function(Et) {
                      if (Et.startsWith("ql-") && (Et = Et.slice(3), ze[Et] != null))
                        if (Et === "direction")
                          nt.innerHTML = ze[Et][""] + ze[Et].rtl;
                        else if (typeof ze[Et] == "string")
                          nt.innerHTML = ze[Et];
                        else {
                          var zt = nt.value || "";
                          zt != null && ze[Et][zt] && (nt.innerHTML = ze[Et][zt]);
                        }
                    });
                  });
                }
              }, {
                key: "buildPickers",
                value: function(xe, ze) {
                  var nt = this;
                  this.pickers = xe.map(function(Et) {
                    if (Et.classList.contains("ql-align"))
                      return Et.querySelector("option") == null && te(Et, w), new ee.default(Et, ze.align);
                    if (Et.classList.contains("ql-background") || Et.classList.contains("ql-color")) {
                      var zt = Et.classList.contains("ql-background") ? "background" : "color";
                      return Et.querySelector("option") == null && te(Et, P, zt === "background" ? "#ffffff" : "#000000"), new F.default(Et, ze[zt]);
                    } else
                      return Et.querySelector("option") == null && (Et.classList.contains("ql-font") ? te(Et, J) : Et.classList.contains("ql-header") ? te(Et, se) : Et.classList.contains("ql-size") && te(Et, fe)), new Q.default(Et);
                  });
                  var Qt = function() {
                    nt.pickers.forEach(function(zt) {
                      zt.update();
                    });
                  };
                  this.quill.on(T.default.events.EDITOR_CHANGE, Qt);
                }
              }]), Pe;
            }(G.default);
            N.DEFAULTS = (0, S.default)(!0, {}, G.default.DEFAULTS, {
              modules: {
                toolbar: {
                  handlers: {
                    formula: function() {
                      this.quill.theme.tooltip.edit("formula");
                    },
                    image: function() {
                      var Pe = this, Ke = this.container.querySelector("input.ql-image[type=file]");
                      Ke == null && (Ke = document.createElement("input"), Ke.setAttribute("type", "file"), Ke.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon"), Ke.classList.add("ql-image"), Ke.addEventListener("change", function() {
                        if (Ke.files != null && Ke.files[0] != null) {
                          var xe = new FileReader();
                          xe.onload = function(ze) {
                            var nt = Pe.quill.getSelection(!0);
                            Pe.quill.updateContents(new E.default().retain(nt.index).delete(nt.length).insert({ image: ze.target.result }), T.default.sources.USER), Pe.quill.setSelection(nt.index + 1, T.default.sources.SILENT), Ke.value = "";
                          }, xe.readAsDataURL(Ke.files[0]);
                        }
                      }), this.container.appendChild(Ke)), Ke.click();
                    },
                    video: function() {
                      this.quill.theme.tooltip.edit("video");
                    }
                  }
                }
              }
            });
            var W = function(ge) {
              C(Pe, ge);
              function Pe(Ke, xe) {
                ne(this, Pe);
                var ze = H(this, (Pe.__proto__ || Object.getPrototypeOf(Pe)).call(this, Ke, xe));
                return ze.textbox = ze.root.querySelector('input[type="text"]'), ze.listen(), ze;
              }
              return d(Pe, [{
                key: "listen",
                value: function() {
                  var xe = this;
                  this.textbox.addEventListener("keydown", function(ze) {
                    V.default.match(ze, "enter") ? (xe.save(), ze.preventDefault()) : V.default.match(ze, "escape") && (xe.cancel(), ze.preventDefault());
                  });
                }
              }, {
                key: "cancel",
                value: function() {
                  this.hide();
                }
              }, {
                key: "edit",
                value: function() {
                  var xe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "link", ze = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                  this.root.classList.remove("ql-hidden"), this.root.classList.add("ql-editing"), ze != null ? this.textbox.value = ze : xe !== this.root.getAttribute("data-mode") && (this.textbox.value = ""), this.position(this.quill.getBounds(this.quill.selection.savedRange)), this.textbox.select(), this.textbox.setAttribute("placeholder", this.textbox.getAttribute("data-" + xe) || ""), this.root.setAttribute("data-mode", xe);
                }
              }, {
                key: "restoreFocus",
                value: function() {
                  var xe = this.quill.scrollingContainer.scrollTop;
                  this.quill.focus(), this.quill.scrollingContainer.scrollTop = xe;
                }
              }, {
                key: "save",
                value: function() {
                  var xe = this.textbox.value;
                  switch (this.root.getAttribute("data-mode")) {
                    case "link": {
                      var ze = this.quill.root.scrollTop;
                      this.linkRange ? (this.quill.formatText(this.linkRange, "link", xe, T.default.sources.USER), delete this.linkRange) : (this.restoreFocus(), this.quill.format("link", xe, T.default.sources.USER)), this.quill.root.scrollTop = ze;
                      break;
                    }
                    case "video":
                      xe = I(xe);
                    case "formula": {
                      if (!xe)
                        break;
                      var nt = this.quill.getSelection(!0);
                      if (nt != null) {
                        var Qt = nt.index + nt.length;
                        this.quill.insertEmbed(Qt, this.root.getAttribute("data-mode"), xe, T.default.sources.USER), this.root.getAttribute("data-mode") === "formula" && this.quill.insertText(Qt + 1, " ", T.default.sources.USER), this.quill.setSelection(Qt + 2, T.default.sources.USER);
                      }
                      break;
                    }
                  }
                  this.textbox.value = "", this.hide();
                }
              }]), Pe;
            }(pe.default);
            function I(ge) {
              var Pe = ge.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || ge.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
              return Pe ? (Pe[1] || "https") + "://www.youtube.com/embed/" + Pe[2] + "?showinfo=0" : (Pe = ge.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) ? (Pe[1] || "https") + "://player.vimeo.com/video/" + Pe[2] + "/" : ge;
            }
            function te(ge, Pe) {
              var Ke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              Pe.forEach(function(xe) {
                var ze = document.createElement("option");
                xe === Ke ? ze.setAttribute("selected", "selected") : ze.setAttribute("value", xe), ge.appendChild(ze);
              });
            }
            u.BaseTooltip = W, u.default = N;
          },
          /* 44 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", { value: !0 });
            var d = (
              /** @class */
              function() {
                function m() {
                  this.head = this.tail = null, this.length = 0;
                }
                return m.prototype.append = function() {
                  for (var v = [], S = 0; S < arguments.length; S++)
                    v[S] = arguments[S];
                  this.insertBefore(v[0], null), v.length > 1 && this.append.apply(this, v.slice(1));
                }, m.prototype.contains = function(v) {
                  for (var S, $ = this.iterator(); S = $(); )
                    if (S === v)
                      return !0;
                  return !1;
                }, m.prototype.insertBefore = function(v, S) {
                  v && (v.next = S, S != null ? (v.prev = S.prev, S.prev != null && (S.prev.next = v), S.prev = v, S === this.head && (this.head = v)) : this.tail != null ? (this.tail.next = v, v.prev = this.tail, this.tail = v) : (v.prev = null, this.head = this.tail = v), this.length += 1);
                }, m.prototype.offset = function(v) {
                  for (var S = 0, $ = this.head; $ != null; ) {
                    if ($ === v)
                      return S;
                    S += $.length(), $ = $.next;
                  }
                  return -1;
                }, m.prototype.remove = function(v) {
                  this.contains(v) && (v.prev != null && (v.prev.next = v.next), v.next != null && (v.next.prev = v.prev), v === this.head && (this.head = v.next), v === this.tail && (this.tail = v.prev), this.length -= 1);
                }, m.prototype.iterator = function(v) {
                  return v === void 0 && (v = this.head), function() {
                    var S = v;
                    return v != null && (v = v.next), S;
                  };
                }, m.prototype.find = function(v, S) {
                  S === void 0 && (S = !1);
                  for (var $, E = this.iterator(); $ = E(); ) {
                    var O = $.length();
                    if (v < O || S && v === O && ($.next == null || $.next.length() !== 0))
                      return [$, v];
                    v -= O;
                  }
                  return [null, 0];
                }, m.prototype.forEach = function(v) {
                  for (var S, $ = this.iterator(); S = $(); )
                    v(S);
                }, m.prototype.forEachAt = function(v, S, $) {
                  if (!(S <= 0))
                    for (var E = this.find(v), O = E[0], T = E[1], y, V = v - T, M = this.iterator(O); (y = M()) && V < v + S; ) {
                      var G = y.length();
                      v > V ? $(y, v - V, Math.min(S, V + G - v)) : $(y, 0, Math.min(G, v + S - V)), V += G;
                    }
                }, m.prototype.map = function(v) {
                  return this.reduce(function(S, $) {
                    return S.push(v($)), S;
                  }, []);
                }, m.prototype.reduce = function(v, S) {
                  for (var $, E = this.iterator(); $ = E(); )
                    S = v(S, $);
                  return S;
                }, m;
              }()
            );
            u.default = d;
          },
          /* 45 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var O = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(T, y) {
                T.__proto__ = y;
              } || function(T, y) {
                for (var V in y)
                  y.hasOwnProperty(V) && (T[V] = y[V]);
              };
              return function(T, y) {
                O(T, y);
                function V() {
                  this.constructor = T;
                }
                T.prototype = y === null ? Object.create(y) : (V.prototype = y.prototype, new V());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(17), v = c(1), S = {
              attributes: !0,
              characterData: !0,
              characterDataOldValue: !0,
              childList: !0,
              subtree: !0
            }, $ = 100, E = (
              /** @class */
              function(O) {
                d(T, O);
                function T(y) {
                  var V = O.call(this, y) || this;
                  return V.scroll = V, V.observer = new MutationObserver(function(M) {
                    V.update(M);
                  }), V.observer.observe(V.domNode, S), V.attach(), V;
                }
                return T.prototype.detach = function() {
                  O.prototype.detach.call(this), this.observer.disconnect();
                }, T.prototype.deleteAt = function(y, V) {
                  this.update(), y === 0 && V === this.length() ? this.children.forEach(function(M) {
                    M.remove();
                  }) : O.prototype.deleteAt.call(this, y, V);
                }, T.prototype.formatAt = function(y, V, M, G) {
                  this.update(), O.prototype.formatAt.call(this, y, V, M, G);
                }, T.prototype.insertAt = function(y, V, M) {
                  this.update(), O.prototype.insertAt.call(this, y, V, M);
                }, T.prototype.optimize = function(y, V) {
                  var M = this;
                  y === void 0 && (y = []), V === void 0 && (V = {}), O.prototype.optimize.call(this, V);
                  for (var G = [].slice.call(this.observer.takeRecords()); G.length > 0; )
                    y.push(G.pop());
                  for (var k = function(ue, Q) {
                    Q === void 0 && (Q = !0), !(ue == null || ue === M) && ue.domNode.parentNode != null && (ue.domNode[v.DATA_KEY].mutations == null && (ue.domNode[v.DATA_KEY].mutations = []), Q && k(ue.parent));
                  }, F = function(ue) {
                    // @ts-ignore
                    ue.domNode[v.DATA_KEY] == null || // @ts-ignore
                    ue.domNode[v.DATA_KEY].mutations == null || (ue instanceof m.default && ue.children.forEach(F), ue.optimize(V));
                  }, X = y, ee = 0; X.length > 0; ee += 1) {
                    if (ee >= $)
                      throw new Error("[Parchment] Maximum optimize iterations reached");
                    for (X.forEach(function(ue) {
                      var Q = v.find(ue.target, !0);
                      Q != null && (Q.domNode === ue.target && (ue.type === "childList" ? (k(v.find(ue.previousSibling, !1)), [].forEach.call(ue.addedNodes, function(Y) {
                        var pe = v.find(Y, !1);
                        k(pe, !1), pe instanceof m.default && pe.children.forEach(function(oe) {
                          k(oe, !1);
                        });
                      })) : ue.type === "attributes" && k(Q.prev)), k(Q));
                    }), this.children.forEach(F), X = [].slice.call(this.observer.takeRecords()), G = X.slice(); G.length > 0; )
                      y.push(G.pop());
                  }
                }, T.prototype.update = function(y, V) {
                  var M = this;
                  V === void 0 && (V = {}), y = y || this.observer.takeRecords(), y.map(function(G) {
                    var k = v.find(G.target, !0);
                    return k == null ? null : k.domNode[v.DATA_KEY].mutations == null ? (k.domNode[v.DATA_KEY].mutations = [G], k) : (k.domNode[v.DATA_KEY].mutations.push(G), null);
                  }).forEach(function(G) {
                    G == null || G === M || //@ts-ignore
                    G.domNode[v.DATA_KEY] == null || G.update(G.domNode[v.DATA_KEY].mutations || [], V);
                  }), this.domNode[v.DATA_KEY].mutations != null && O.prototype.update.call(this, this.domNode[v.DATA_KEY].mutations, V), this.optimize(y, V);
                }, T.blotName = "scroll", T.defaultChild = "block", T.scope = v.Scope.BLOCK_BLOT, T.tagName = "DIV", T;
              }(m.default)
            );
            u.default = E;
          },
          /* 46 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var E = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(O, T) {
                O.__proto__ = T;
              } || function(O, T) {
                for (var y in T)
                  T.hasOwnProperty(y) && (O[y] = T[y]);
              };
              return function(O, T) {
                E(O, T);
                function y() {
                  this.constructor = O;
                }
                O.prototype = T === null ? Object.create(T) : (y.prototype = T.prototype, new y());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(18), v = c(1);
            function S(E, O) {
              if (Object.keys(E).length !== Object.keys(O).length)
                return !1;
              for (var T in E)
                if (E[T] !== O[T])
                  return !1;
              return !0;
            }
            var $ = (
              /** @class */
              function(E) {
                d(O, E);
                function O() {
                  return E !== null && E.apply(this, arguments) || this;
                }
                return O.formats = function(T) {
                  if (T.tagName !== O.tagName)
                    return E.formats.call(this, T);
                }, O.prototype.format = function(T, y) {
                  var V = this;
                  T === this.statics.blotName && !y ? (this.children.forEach(function(M) {
                    M instanceof m.default || (M = M.wrap(O.blotName, !0)), V.attributes.copy(M);
                  }), this.unwrap()) : E.prototype.format.call(this, T, y);
                }, O.prototype.formatAt = function(T, y, V, M) {
                  if (this.formats()[V] != null || v.query(V, v.Scope.ATTRIBUTE)) {
                    var G = this.isolate(T, y);
                    G.format(V, M);
                  } else
                    E.prototype.formatAt.call(this, T, y, V, M);
                }, O.prototype.optimize = function(T) {
                  E.prototype.optimize.call(this, T);
                  var y = this.formats();
                  if (Object.keys(y).length === 0)
                    return this.unwrap();
                  var V = this.next;
                  V instanceof O && V.prev === this && S(y, V.formats()) && (V.moveChildren(this), V.remove());
                }, O.blotName = "inline", O.scope = v.Scope.INLINE_BLOT, O.tagName = "SPAN", O;
              }(m.default)
            );
            u.default = $;
          },
          /* 47 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, O) {
                E.__proto__ = O;
              } || function(E, O) {
                for (var T in O)
                  O.hasOwnProperty(T) && (E[T] = O[T]);
              };
              return function(E, O) {
                $(E, O);
                function T() {
                  this.constructor = E;
                }
                E.prototype = O === null ? Object.create(O) : (T.prototype = O.prototype, new T());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(18), v = c(1), S = (
              /** @class */
              function($) {
                d(E, $);
                function E() {
                  return $ !== null && $.apply(this, arguments) || this;
                }
                return E.formats = function(O) {
                  var T = v.query(E.blotName).tagName;
                  if (O.tagName !== T)
                    return $.formats.call(this, O);
                }, E.prototype.format = function(O, T) {
                  v.query(O, v.Scope.BLOCK) != null && (O === this.statics.blotName && !T ? this.replaceWith(E.blotName) : $.prototype.format.call(this, O, T));
                }, E.prototype.formatAt = function(O, T, y, V) {
                  v.query(y, v.Scope.BLOCK) != null ? this.format(y, V) : $.prototype.formatAt.call(this, O, T, y, V);
                }, E.prototype.insertAt = function(O, T, y) {
                  if (y == null || v.query(T, v.Scope.INLINE) != null)
                    $.prototype.insertAt.call(this, O, T, y);
                  else {
                    var V = this.split(O), M = v.create(T, y);
                    V.parent.insertBefore(M, V);
                  }
                }, E.prototype.update = function(O, T) {
                  navigator.userAgent.match(/Trident/) ? this.build() : $.prototype.update.call(this, O, T);
                }, E.blotName = "block", E.scope = v.Scope.BLOCK_BLOT, E.tagName = "P", E;
              }(m.default)
            );
            u.default = S;
          },
          /* 48 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var S = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function($, E) {
                $.__proto__ = E;
              } || function($, E) {
                for (var O in E)
                  E.hasOwnProperty(O) && ($[O] = E[O]);
              };
              return function($, E) {
                S($, E);
                function O() {
                  this.constructor = $;
                }
                $.prototype = E === null ? Object.create(E) : (O.prototype = E.prototype, new O());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(19), v = (
              /** @class */
              function(S) {
                d($, S);
                function $() {
                  return S !== null && S.apply(this, arguments) || this;
                }
                return $.formats = function(E) {
                }, $.prototype.format = function(E, O) {
                  S.prototype.formatAt.call(this, 0, this.length(), E, O);
                }, $.prototype.formatAt = function(E, O, T, y) {
                  E === 0 && O === this.length() ? this.format(T, y) : S.prototype.formatAt.call(this, E, O, T, y);
                }, $.prototype.formats = function() {
                  return this.statics.formats(this.domNode);
                }, $;
              }(m.default)
            );
            u.default = v;
          },
          /* 49 */
          /***/
          function(o, u, c) {
            var d = this && this.__extends || function() {
              var $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, O) {
                E.__proto__ = O;
              } || function(E, O) {
                for (var T in O)
                  O.hasOwnProperty(T) && (E[T] = O[T]);
              };
              return function(E, O) {
                $(E, O);
                function T() {
                  this.constructor = E;
                }
                E.prototype = O === null ? Object.create(O) : (T.prototype = O.prototype, new T());
              };
            }();
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = c(19), v = c(1), S = (
              /** @class */
              function($) {
                d(E, $);
                function E(O) {
                  var T = $.call(this, O) || this;
                  return T.text = T.statics.value(T.domNode), T;
                }
                return E.create = function(O) {
                  return document.createTextNode(O);
                }, E.value = function(O) {
                  var T = O.data;
                  return T.normalize && (T = T.normalize()), T;
                }, E.prototype.deleteAt = function(O, T) {
                  this.domNode.data = this.text = this.text.slice(0, O) + this.text.slice(O + T);
                }, E.prototype.index = function(O, T) {
                  return this.domNode === O ? T : -1;
                }, E.prototype.insertAt = function(O, T, y) {
                  y == null ? (this.text = this.text.slice(0, O) + T + this.text.slice(O), this.domNode.data = this.text) : $.prototype.insertAt.call(this, O, T, y);
                }, E.prototype.length = function() {
                  return this.text.length;
                }, E.prototype.optimize = function(O) {
                  $.prototype.optimize.call(this, O), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof E && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
                }, E.prototype.position = function(O, T) {
                  return [this.domNode, O];
                }, E.prototype.split = function(O, T) {
                  if (T === void 0 && (T = !1), !T) {
                    if (O === 0)
                      return this;
                    if (O === this.length())
                      return this.next;
                  }
                  var y = v.create(this.domNode.splitText(O));
                  return this.parent.insertBefore(y, this.next), this.text = this.statics.value(this.domNode), y;
                }, E.prototype.update = function(O, T) {
                  var y = this;
                  O.some(function(V) {
                    return V.type === "characterData" && V.target === y.domNode;
                  }) && (this.text = this.statics.value(this.domNode));
                }, E.prototype.value = function() {
                  return this.text;
                }, E.blotName = "text", E.scope = v.Scope.INLINE_BLOT, E;
              }(m.default)
            );
            u.default = S;
          },
          /* 50 */
          /***/
          function(o, u, c) {
            var d = document.createElement("div");
            if (d.classList.toggle("test-class", !1), d.classList.contains("test-class")) {
              var m = DOMTokenList.prototype.toggle;
              DOMTokenList.prototype.toggle = function(v, S) {
                return arguments.length > 1 && !this.contains(v) == !S ? S : m.call(this, v);
              };
            }
            String.prototype.startsWith || (String.prototype.startsWith = function(v, S) {
              return S = S || 0, this.substr(S, v.length) === v;
            }), String.prototype.endsWith || (String.prototype.endsWith = function(v, S) {
              var $ = this.toString();
              (typeof S != "number" || !isFinite(S) || Math.floor(S) !== S || S > $.length) && (S = $.length), S -= v.length;
              var E = $.indexOf(v, S);
              return E !== -1 && E === S;
            }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
              value: function(S) {
                if (this === null)
                  throw new TypeError("Array.prototype.find called on null or undefined");
                if (typeof S != "function")
                  throw new TypeError("predicate must be a function");
                for (var $ = Object(this), E = $.length >>> 0, O = arguments[1], T, y = 0; y < E; y++)
                  if (T = $[y], S.call(O, T, y, $))
                    return T;
              }
            }), document.addEventListener("DOMContentLoaded", function() {
              document.execCommand("enableObjectResizing", !1, !1), document.execCommand("autoUrlDetect", !1, !1);
            });
          },
          /* 51 */
          /***/
          function(o, u) {
            var c = -1, d = 1, m = 0;
            function v(ee, ue, Q) {
              if (ee == ue)
                return ee ? [[m, ee]] : [];
              (Q < 0 || ee.length < Q) && (Q = null);
              var Y = O(ee, ue), pe = ee.substring(0, Y);
              ee = ee.substring(Y), ue = ue.substring(Y), Y = T(ee, ue);
              var oe = ee.substring(ee.length - Y);
              ee = ee.substring(0, ee.length - Y), ue = ue.substring(0, ue.length - Y);
              var ne = S(ee, ue);
              return pe && ne.unshift([m, pe]), oe && ne.push([m, oe]), V(ne), Q != null && (ne = k(ne, Q)), ne = F(ne), ne;
            }
            function S(ee, ue) {
              var Q;
              if (!ee)
                return [[d, ue]];
              if (!ue)
                return [[c, ee]];
              var Y = ee.length > ue.length ? ee : ue, pe = ee.length > ue.length ? ue : ee, oe = Y.indexOf(pe);
              if (oe != -1)
                return Q = [
                  [d, Y.substring(0, oe)],
                  [m, pe],
                  [d, Y.substring(oe + pe.length)]
                ], ee.length > ue.length && (Q[0][0] = Q[2][0] = c), Q;
              if (pe.length == 1)
                return [[c, ee], [d, ue]];
              var ne = y(ee, ue);
              if (ne) {
                var H = ne[0], C = ne[1], w = ne[2], P = ne[3], J = ne[4], se = v(H, w), fe = v(C, P);
                return se.concat([[m, J]], fe);
              }
              return $(ee, ue);
            }
            function $(ee, ue) {
              for (var Q = ee.length, Y = ue.length, pe = Math.ceil((Q + Y) / 2), oe = pe, ne = 2 * pe, H = new Array(ne), C = new Array(ne), w = 0; w < ne; w++)
                H[w] = -1, C[w] = -1;
              H[oe + 1] = 0, C[oe + 1] = 0;
              for (var P = Q - Y, J = P % 2 != 0, se = 0, fe = 0, N = 0, W = 0, I = 0; I < pe; I++) {
                for (var te = -I + se; te <= I - fe; te += 2) {
                  var ge = oe + te, Pe;
                  te == -I || te != I && H[ge - 1] < H[ge + 1] ? Pe = H[ge + 1] : Pe = H[ge - 1] + 1;
                  for (var Ke = Pe - te; Pe < Q && Ke < Y && ee.charAt(Pe) == ue.charAt(Ke); )
                    Pe++, Ke++;
                  if (H[ge] = Pe, Pe > Q)
                    fe += 2;
                  else if (Ke > Y)
                    se += 2;
                  else if (J) {
                    var xe = oe + P - te;
                    if (xe >= 0 && xe < ne && C[xe] != -1) {
                      var ze = Q - C[xe];
                      if (Pe >= ze)
                        return E(ee, ue, Pe, Ke);
                    }
                  }
                }
                for (var nt = -I + N; nt <= I - W; nt += 2) {
                  var xe = oe + nt, ze;
                  nt == -I || nt != I && C[xe - 1] < C[xe + 1] ? ze = C[xe + 1] : ze = C[xe - 1] + 1;
                  for (var Qt = ze - nt; ze < Q && Qt < Y && ee.charAt(Q - ze - 1) == ue.charAt(Y - Qt - 1); )
                    ze++, Qt++;
                  if (C[xe] = ze, ze > Q)
                    W += 2;
                  else if (Qt > Y)
                    N += 2;
                  else if (!J) {
                    var ge = oe + P - nt;
                    if (ge >= 0 && ge < ne && H[ge] != -1) {
                      var Pe = H[ge], Ke = oe + Pe - ge;
                      if (ze = Q - ze, Pe >= ze)
                        return E(ee, ue, Pe, Ke);
                    }
                  }
                }
              }
              return [[c, ee], [d, ue]];
            }
            function E(ee, ue, Q, Y) {
              var pe = ee.substring(0, Q), oe = ue.substring(0, Y), ne = ee.substring(Q), H = ue.substring(Y), C = v(pe, oe), w = v(ne, H);
              return C.concat(w);
            }
            function O(ee, ue) {
              if (!ee || !ue || ee.charAt(0) != ue.charAt(0))
                return 0;
              for (var Q = 0, Y = Math.min(ee.length, ue.length), pe = Y, oe = 0; Q < pe; )
                ee.substring(oe, pe) == ue.substring(oe, pe) ? (Q = pe, oe = Q) : Y = pe, pe = Math.floor((Y - Q) / 2 + Q);
              return pe;
            }
            function T(ee, ue) {
              if (!ee || !ue || ee.charAt(ee.length - 1) != ue.charAt(ue.length - 1))
                return 0;
              for (var Q = 0, Y = Math.min(ee.length, ue.length), pe = Y, oe = 0; Q < pe; )
                ee.substring(ee.length - pe, ee.length - oe) == ue.substring(ue.length - pe, ue.length - oe) ? (Q = pe, oe = Q) : Y = pe, pe = Math.floor((Y - Q) / 2 + Q);
              return pe;
            }
            function y(ee, ue) {
              var Q = ee.length > ue.length ? ee : ue, Y = ee.length > ue.length ? ue : ee;
              if (Q.length < 4 || Y.length * 2 < Q.length)
                return null;
              function pe(fe, N, W) {
                for (var I = fe.substring(W, W + Math.floor(fe.length / 4)), te = -1, ge = "", Pe, Ke, xe, ze; (te = N.indexOf(I, te + 1)) != -1; ) {
                  var nt = O(
                    fe.substring(W),
                    N.substring(te)
                  ), Qt = T(
                    fe.substring(0, W),
                    N.substring(0, te)
                  );
                  ge.length < Qt + nt && (ge = N.substring(te - Qt, te) + N.substring(te, te + nt), Pe = fe.substring(0, W - Qt), Ke = fe.substring(W + nt), xe = N.substring(0, te - Qt), ze = N.substring(te + nt));
                }
                return ge.length * 2 >= fe.length ? [
                  Pe,
                  Ke,
                  xe,
                  ze,
                  ge
                ] : null;
              }
              var oe = pe(
                Q,
                Y,
                Math.ceil(Q.length / 4)
              ), ne = pe(
                Q,
                Y,
                Math.ceil(Q.length / 2)
              ), H;
              if (!oe && !ne)
                return null;
              ne ? oe ? H = oe[4].length > ne[4].length ? oe : ne : H = ne : H = oe;
              var C, w, P, J;
              ee.length > ue.length ? (C = H[0], w = H[1], P = H[2], J = H[3]) : (P = H[0], J = H[1], C = H[2], w = H[3]);
              var se = H[4];
              return [C, w, P, J, se];
            }
            function V(ee) {
              ee.push([m, ""]);
              for (var ue = 0, Q = 0, Y = 0, pe = "", oe = "", ne; ue < ee.length; )
                switch (ee[ue][0]) {
                  case d:
                    Y++, oe += ee[ue][1], ue++;
                    break;
                  case c:
                    Q++, pe += ee[ue][1], ue++;
                    break;
                  case m:
                    Q + Y > 1 ? (Q !== 0 && Y !== 0 && (ne = O(oe, pe), ne !== 0 && (ue - Q - Y > 0 && ee[ue - Q - Y - 1][0] == m ? ee[ue - Q - Y - 1][1] += oe.substring(0, ne) : (ee.splice(0, 0, [
                      m,
                      oe.substring(0, ne)
                    ]), ue++), oe = oe.substring(ne), pe = pe.substring(ne)), ne = T(oe, pe), ne !== 0 && (ee[ue][1] = oe.substring(oe.length - ne) + ee[ue][1], oe = oe.substring(0, oe.length - ne), pe = pe.substring(0, pe.length - ne))), Q === 0 ? ee.splice(
                      ue - Y,
                      Q + Y,
                      [d, oe]
                    ) : Y === 0 ? ee.splice(
                      ue - Q,
                      Q + Y,
                      [c, pe]
                    ) : ee.splice(
                      ue - Q - Y,
                      Q + Y,
                      [c, pe],
                      [d, oe]
                    ), ue = ue - Q - Y + (Q ? 1 : 0) + (Y ? 1 : 0) + 1) : ue !== 0 && ee[ue - 1][0] == m ? (ee[ue - 1][1] += ee[ue][1], ee.splice(ue, 1)) : ue++, Y = 0, Q = 0, pe = "", oe = "";
                    break;
                }
              ee[ee.length - 1][1] === "" && ee.pop();
              var H = !1;
              for (ue = 1; ue < ee.length - 1; )
                ee[ue - 1][0] == m && ee[ue + 1][0] == m && (ee[ue][1].substring(ee[ue][1].length - ee[ue - 1][1].length) == ee[ue - 1][1] ? (ee[ue][1] = ee[ue - 1][1] + ee[ue][1].substring(0, ee[ue][1].length - ee[ue - 1][1].length), ee[ue + 1][1] = ee[ue - 1][1] + ee[ue + 1][1], ee.splice(ue - 1, 1), H = !0) : ee[ue][1].substring(0, ee[ue + 1][1].length) == ee[ue + 1][1] && (ee[ue - 1][1] += ee[ue + 1][1], ee[ue][1] = ee[ue][1].substring(ee[ue + 1][1].length) + ee[ue + 1][1], ee.splice(ue + 1, 1), H = !0)), ue++;
              H && V(ee);
            }
            var M = v;
            M.INSERT = d, M.DELETE = c, M.EQUAL = m, o.exports = M;
            function G(ee, ue) {
              if (ue === 0)
                return [m, ee];
              for (var Q = 0, Y = 0; Y < ee.length; Y++) {
                var pe = ee[Y];
                if (pe[0] === c || pe[0] === m) {
                  var oe = Q + pe[1].length;
                  if (ue === oe)
                    return [Y + 1, ee];
                  if (ue < oe) {
                    ee = ee.slice();
                    var ne = ue - Q, H = [pe[0], pe[1].slice(0, ne)], C = [pe[0], pe[1].slice(ne)];
                    return ee.splice(Y, 1, H, C), [Y + 1, ee];
                  } else
                    Q = oe;
                }
              }
              throw new Error("cursor_pos is out of bounds!");
            }
            function k(ee, ue) {
              var Q = G(ee, ue), Y = Q[1], pe = Q[0], oe = Y[pe], ne = Y[pe + 1];
              if (oe == null)
                return ee;
              if (oe[0] !== m)
                return ee;
              if (ne != null && oe[1] + ne[1] === ne[1] + oe[1])
                return Y.splice(pe, 2, ne, oe), X(Y, pe, 2);
              if (ne != null && ne[1].indexOf(oe[1]) === 0) {
                Y.splice(pe, 2, [ne[0], oe[1]], [0, oe[1]]);
                var H = ne[1].slice(oe[1].length);
                return H.length > 0 && Y.splice(pe + 2, 0, [ne[0], H]), X(Y, pe, 3);
              } else
                return ee;
            }
            function F(ee) {
              for (var ue = !1, Q = function(ne) {
                return ne.charCodeAt(0) >= 56320 && ne.charCodeAt(0) <= 57343;
              }, Y = function(ne) {
                return ne.charCodeAt(ne.length - 1) >= 55296 && ne.charCodeAt(ne.length - 1) <= 56319;
              }, pe = 2; pe < ee.length; pe += 1)
                ee[pe - 2][0] === m && Y(ee[pe - 2][1]) && ee[pe - 1][0] === c && Q(ee[pe - 1][1]) && ee[pe][0] === d && Q(ee[pe][1]) && (ue = !0, ee[pe - 1][1] = ee[pe - 2][1].slice(-1) + ee[pe - 1][1], ee[pe][1] = ee[pe - 2][1].slice(-1) + ee[pe][1], ee[pe - 2][1] = ee[pe - 2][1].slice(0, -1));
              if (!ue)
                return ee;
              for (var oe = [], pe = 0; pe < ee.length; pe += 1)
                ee[pe][1].length > 0 && oe.push(ee[pe]);
              return oe;
            }
            function X(ee, ue, Q) {
              for (var Y = ue + Q - 1; Y >= 0 && Y >= ue - 1; Y--)
                if (Y + 1 < ee.length) {
                  var pe = ee[Y], oe = ee[Y + 1];
                  pe[0] === oe[1] && ee.splice(Y, 2, [pe[0], pe[1] + oe[1]]);
                }
              return ee;
            }
          },
          /* 52 */
          /***/
          function(o, u) {
            u = o.exports = typeof Object.keys == "function" ? Object.keys : c, u.shim = c;
            function c(d) {
              var m = [];
              for (var v in d)
                m.push(v);
              return m;
            }
          },
          /* 53 */
          /***/
          function(o, u) {
            var c = function() {
              return Object.prototype.toString.call(arguments);
            }() == "[object Arguments]";
            u = o.exports = c ? d : m, u.supported = d;
            function d(v) {
              return Object.prototype.toString.call(v) == "[object Arguments]";
            }
            u.unsupported = m;
            function m(v) {
              return v && typeof v == "object" && typeof v.length == "number" && Object.prototype.hasOwnProperty.call(v, "callee") && !Object.prototype.propertyIsEnumerable.call(v, "callee") || !1;
            }
          },
          /* 54 */
          /***/
          function(o, u) {
            var c = Object.prototype.hasOwnProperty, d = "~";
            function m() {
            }
            Object.create && (m.prototype = /* @__PURE__ */ Object.create(null), new m().__proto__ || (d = !1));
            function v($, E, O) {
              this.fn = $, this.context = E, this.once = O || !1;
            }
            function S() {
              this._events = new m(), this._eventsCount = 0;
            }
            S.prototype.eventNames = function() {
              var E = [], O, T;
              if (this._eventsCount === 0)
                return E;
              for (T in O = this._events)
                c.call(O, T) && E.push(d ? T.slice(1) : T);
              return Object.getOwnPropertySymbols ? E.concat(Object.getOwnPropertySymbols(O)) : E;
            }, S.prototype.listeners = function(E, O) {
              var T = d ? d + E : E, y = this._events[T];
              if (O)
                return !!y;
              if (!y)
                return [];
              if (y.fn)
                return [y.fn];
              for (var V = 0, M = y.length, G = new Array(M); V < M; V++)
                G[V] = y[V].fn;
              return G;
            }, S.prototype.emit = function(E, O, T, y, V, M) {
              var G = d ? d + E : E;
              if (!this._events[G])
                return !1;
              var k = this._events[G], F = arguments.length, X, ee;
              if (k.fn) {
                switch (k.once && this.removeListener(E, k.fn, void 0, !0), F) {
                  case 1:
                    return k.fn.call(k.context), !0;
                  case 2:
                    return k.fn.call(k.context, O), !0;
                  case 3:
                    return k.fn.call(k.context, O, T), !0;
                  case 4:
                    return k.fn.call(k.context, O, T, y), !0;
                  case 5:
                    return k.fn.call(k.context, O, T, y, V), !0;
                  case 6:
                    return k.fn.call(k.context, O, T, y, V, M), !0;
                }
                for (ee = 1, X = new Array(F - 1); ee < F; ee++)
                  X[ee - 1] = arguments[ee];
                k.fn.apply(k.context, X);
              } else {
                var ue = k.length, Q;
                for (ee = 0; ee < ue; ee++)
                  switch (k[ee].once && this.removeListener(E, k[ee].fn, void 0, !0), F) {
                    case 1:
                      k[ee].fn.call(k[ee].context);
                      break;
                    case 2:
                      k[ee].fn.call(k[ee].context, O);
                      break;
                    case 3:
                      k[ee].fn.call(k[ee].context, O, T);
                      break;
                    case 4:
                      k[ee].fn.call(k[ee].context, O, T, y);
                      break;
                    default:
                      if (!X)
                        for (Q = 1, X = new Array(F - 1); Q < F; Q++)
                          X[Q - 1] = arguments[Q];
                      k[ee].fn.apply(k[ee].context, X);
                  }
              }
              return !0;
            }, S.prototype.on = function(E, O, T) {
              var y = new v(O, T || this), V = d ? d + E : E;
              return this._events[V] ? this._events[V].fn ? this._events[V] = [this._events[V], y] : this._events[V].push(y) : (this._events[V] = y, this._eventsCount++), this;
            }, S.prototype.once = function(E, O, T) {
              var y = new v(O, T || this, !0), V = d ? d + E : E;
              return this._events[V] ? this._events[V].fn ? this._events[V] = [this._events[V], y] : this._events[V].push(y) : (this._events[V] = y, this._eventsCount++), this;
            }, S.prototype.removeListener = function(E, O, T, y) {
              var V = d ? d + E : E;
              if (!this._events[V])
                return this;
              if (!O)
                return --this._eventsCount === 0 ? this._events = new m() : delete this._events[V], this;
              var M = this._events[V];
              if (M.fn)
                M.fn === O && (!y || M.once) && (!T || M.context === T) && (--this._eventsCount === 0 ? this._events = new m() : delete this._events[V]);
              else {
                for (var G = 0, k = [], F = M.length; G < F; G++)
                  (M[G].fn !== O || y && !M[G].once || T && M[G].context !== T) && k.push(M[G]);
                k.length ? this._events[V] = k.length === 1 ? k[0] : k : --this._eventsCount === 0 ? this._events = new m() : delete this._events[V];
              }
              return this;
            }, S.prototype.removeAllListeners = function(E) {
              var O;
              return E ? (O = d ? d + E : E, this._events[O] && (--this._eventsCount === 0 ? this._events = new m() : delete this._events[O])) : (this._events = new m(), this._eventsCount = 0), this;
            }, S.prototype.off = S.prototype.removeListener, S.prototype.addListener = S.prototype.on, S.prototype.setMaxListeners = function() {
              return this;
            }, S.prefixed = d, S.EventEmitter = S, typeof o < "u" && (o.exports = S);
          },
          /* 55 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.matchText = u.matchSpacing = u.matchNewline = u.matchBlot = u.matchAttributor = u.default = void 0;
            var d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ht) {
              return typeof Ht;
            } : function(Ht) {
              return Ht && typeof Symbol == "function" && Ht.constructor === Symbol && Ht !== Symbol.prototype ? "symbol" : typeof Ht;
            }, m = function() {
              function Ht(Xt, On) {
                var sn = [], At = !0, hn = !1, $t = void 0;
                try {
                  for (var Lt = Xt[Symbol.iterator](), Qn; !(At = (Qn = Lt.next()).done) && (sn.push(Qn.value), !(On && sn.length === On)); At = !0)
                    ;
                } catch (ce) {
                  hn = !0, $t = ce;
                } finally {
                  try {
                    !At && Lt.return && Lt.return();
                  } finally {
                    if (hn)
                      throw $t;
                  }
                }
                return sn;
              }
              return function(Xt, On) {
                if (Array.isArray(Xt))
                  return Xt;
                if (Symbol.iterator in Object(Xt))
                  return Ht(Xt, On);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), v = function() {
              function Ht(Xt, On) {
                for (var sn = 0; sn < On.length; sn++) {
                  var At = On[sn];
                  At.enumerable = At.enumerable || !1, At.configurable = !0, "value" in At && (At.writable = !0), Object.defineProperty(Xt, At.key, At);
                }
              }
              return function(Xt, On, sn) {
                return On && Ht(Xt.prototype, On), sn && Ht(Xt, sn), Xt;
              };
            }(), S = c(3), $ = C(S), E = c(2), O = C(E), T = c(0), y = C(T), V = c(5), M = C(V), G = c(10), k = C(G), F = c(9), X = C(F), ee = c(36), ue = c(37), Q = c(13), Y = C(Q), pe = c(26), oe = c(38), ne = c(39), H = c(40);
            function C(Ht) {
              return Ht && Ht.__esModule ? Ht : { default: Ht };
            }
            function w(Ht, Xt, On) {
              return Xt in Ht ? Object.defineProperty(Ht, Xt, { value: On, enumerable: !0, configurable: !0, writable: !0 }) : Ht[Xt] = On, Ht;
            }
            function P(Ht, Xt) {
              if (!(Ht instanceof Xt))
                throw new TypeError("Cannot call a class as a function");
            }
            function J(Ht, Xt) {
              if (!Ht)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return Xt && (typeof Xt == "object" || typeof Xt == "function") ? Xt : Ht;
            }
            function se(Ht, Xt) {
              if (typeof Xt != "function" && Xt !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof Xt);
              Ht.prototype = Object.create(Xt && Xt.prototype, { constructor: { value: Ht, enumerable: !1, writable: !0, configurable: !0 } }), Xt && (Object.setPrototypeOf ? Object.setPrototypeOf(Ht, Xt) : Ht.__proto__ = Xt);
            }
            var fe = (0, k.default)("quill:clipboard"), N = "__ql-matcher", W = [[Node.TEXT_NODE, En], [Node.TEXT_NODE, kt], ["br", Nt], [Node.ELEMENT_NODE, kt], [Node.ELEMENT_NODE, zt], [Node.ELEMENT_NODE, Ut], [Node.ELEMENT_NODE, Et], [Node.ELEMENT_NODE, dn], ["li", at], ["b", Qt.bind(Qt, "bold")], ["i", Qt.bind(Qt, "italic")], ["style", pt]], I = [ee.AlignAttribute, oe.DirectionAttribute].reduce(function(Ht, Xt) {
              return Ht[Xt.keyName] = Xt, Ht;
            }, {}), te = [ee.AlignStyle, ue.BackgroundStyle, pe.ColorStyle, oe.DirectionStyle, ne.FontStyle, H.SizeStyle].reduce(function(Ht, Xt) {
              return Ht[Xt.keyName] = Xt, Ht;
            }, {}), ge = function(Ht) {
              se(Xt, Ht);
              function Xt(On, sn) {
                P(this, Xt);
                var At = J(this, (Xt.__proto__ || Object.getPrototypeOf(Xt)).call(this, On, sn));
                return At.quill.root.addEventListener("paste", At.onPaste.bind(At)), At.container = At.quill.addContainer("ql-clipboard"), At.container.setAttribute("contenteditable", !0), At.container.setAttribute("tabindex", -1), At.matchers = [], W.concat(At.options.matchers).forEach(function(hn) {
                  var $t = m(hn, 2), Lt = $t[0], Qn = $t[1];
                  !sn.matchVisual && Qn === Ut || At.addMatcher(Lt, Qn);
                }), At;
              }
              return v(Xt, [{
                key: "addMatcher",
                value: function(sn, At) {
                  this.matchers.push([sn, At]);
                }
              }, {
                key: "convert",
                value: function(sn) {
                  if (typeof sn == "string")
                    return this.container.innerHTML = sn.replace(/\>\r?\n +\</g, "><"), this.convert();
                  var At = this.quill.getFormat(this.quill.selection.savedRange.index);
                  if (At[Y.default.blotName]) {
                    var hn = this.container.innerText;
                    return this.container.innerHTML = "", new O.default().insert(hn, w({}, Y.default.blotName, At[Y.default.blotName]));
                  }
                  var $t = this.prepareMatching(), Lt = m($t, 2), Qn = Lt[0], ce = Lt[1], Ze = nt(this.container, Qn, ce);
                  return xe(Ze, `
`) && Ze.ops[Ze.ops.length - 1].attributes == null && (Ze = Ze.compose(new O.default().retain(Ze.length() - 1).delete(1))), fe.log("convert", this.container.innerHTML, Ze), this.container.innerHTML = "", Ze;
                }
              }, {
                key: "dangerouslyPasteHTML",
                value: function(sn, At) {
                  var hn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : M.default.sources.API;
                  if (typeof sn == "string")
                    this.quill.setContents(this.convert(sn), At), this.quill.setSelection(0, M.default.sources.SILENT);
                  else {
                    var $t = this.convert(At);
                    this.quill.updateContents(new O.default().retain(sn).concat($t), hn), this.quill.setSelection(sn + $t.length(), M.default.sources.SILENT);
                  }
                }
              }, {
                key: "onPaste",
                value: function(sn) {
                  var At = this;
                  if (!(sn.defaultPrevented || !this.quill.isEnabled())) {
                    var hn = this.quill.getSelection(), $t = new O.default().retain(hn.index), Lt = this.quill.scrollingContainer.scrollTop;
                    this.container.focus(), this.quill.selection.update(M.default.sources.SILENT), setTimeout(function() {
                      $t = $t.concat(At.convert()).delete(hn.length), At.quill.updateContents($t, M.default.sources.USER), At.quill.setSelection($t.length() - hn.length, M.default.sources.SILENT), At.quill.scrollingContainer.scrollTop = Lt, At.quill.focus();
                    }, 1);
                  }
                }
              }, {
                key: "prepareMatching",
                value: function() {
                  var sn = this, At = [], hn = [];
                  return this.matchers.forEach(function($t) {
                    var Lt = m($t, 2), Qn = Lt[0], ce = Lt[1];
                    switch (Qn) {
                      case Node.TEXT_NODE:
                        hn.push(ce);
                        break;
                      case Node.ELEMENT_NODE:
                        At.push(ce);
                        break;
                      default:
                        [].forEach.call(sn.container.querySelectorAll(Qn), function(Ze) {
                          Ze[N] = Ze[N] || [], Ze[N].push(ce);
                        });
                        break;
                    }
                  }), [At, hn];
                }
              }]), Xt;
            }(X.default);
            ge.DEFAULTS = {
              matchers: [],
              matchVisual: !0
            };
            function Pe(Ht, Xt, On) {
              return (typeof Xt > "u" ? "undefined" : d(Xt)) === "object" ? Object.keys(Xt).reduce(function(sn, At) {
                return Pe(sn, At, Xt[At]);
              }, Ht) : Ht.reduce(function(sn, At) {
                return At.attributes && At.attributes[Xt] ? sn.push(At) : sn.insert(At.insert, (0, $.default)({}, w({}, Xt, On), At.attributes));
              }, new O.default());
            }
            function Ke(Ht) {
              if (Ht.nodeType !== Node.ELEMENT_NODE)
                return {};
              var Xt = "__ql-computed-style";
              return Ht[Xt] || (Ht[Xt] = window.getComputedStyle(Ht));
            }
            function xe(Ht, Xt) {
              for (var On = "", sn = Ht.ops.length - 1; sn >= 0 && On.length < Xt.length; --sn) {
                var At = Ht.ops[sn];
                if (typeof At.insert != "string")
                  break;
                On = At.insert + On;
              }
              return On.slice(-1 * Xt.length) === Xt;
            }
            function ze(Ht) {
              if (Ht.childNodes.length === 0)
                return !1;
              var Xt = Ke(Ht);
              return ["block", "list-item"].indexOf(Xt.display) > -1;
            }
            function nt(Ht, Xt, On) {
              return Ht.nodeType === Ht.TEXT_NODE ? On.reduce(function(sn, At) {
                return At(Ht, sn);
              }, new O.default()) : Ht.nodeType === Ht.ELEMENT_NODE ? [].reduce.call(Ht.childNodes || [], function(sn, At) {
                var hn = nt(At, Xt, On);
                return At.nodeType === Ht.ELEMENT_NODE && (hn = Xt.reduce(function($t, Lt) {
                  return Lt(At, $t);
                }, hn), hn = (At[N] || []).reduce(function($t, Lt) {
                  return Lt(At, $t);
                }, hn)), sn.concat(hn);
              }, new O.default()) : new O.default();
            }
            function Qt(Ht, Xt, On) {
              return Pe(On, Ht, !0);
            }
            function Et(Ht, Xt) {
              var On = y.default.Attributor.Attribute.keys(Ht), sn = y.default.Attributor.Class.keys(Ht), At = y.default.Attributor.Style.keys(Ht), hn = {};
              return On.concat(sn).concat(At).forEach(function($t) {
                var Lt = y.default.query($t, y.default.Scope.ATTRIBUTE);
                Lt != null && (hn[Lt.attrName] = Lt.value(Ht), hn[Lt.attrName]) || (Lt = I[$t], Lt != null && (Lt.attrName === $t || Lt.keyName === $t) && (hn[Lt.attrName] = Lt.value(Ht) || void 0), Lt = te[$t], Lt != null && (Lt.attrName === $t || Lt.keyName === $t) && (Lt = te[$t], hn[Lt.attrName] = Lt.value(Ht) || void 0));
              }), Object.keys(hn).length > 0 && (Xt = Pe(Xt, hn)), Xt;
            }
            function zt(Ht, Xt) {
              var On = y.default.query(Ht);
              if (On == null)
                return Xt;
              if (On.prototype instanceof y.default.Embed) {
                var sn = {}, At = On.value(Ht);
                At != null && (sn[On.blotName] = At, Xt = new O.default().insert(sn, On.formats(Ht)));
              } else
                typeof On.formats == "function" && (Xt = Pe(Xt, On.blotName, On.formats(Ht)));
              return Xt;
            }
            function Nt(Ht, Xt) {
              return xe(Xt, `
`) || Xt.insert(`
`), Xt;
            }
            function pt() {
              return new O.default();
            }
            function at(Ht, Xt) {
              var On = y.default.query(Ht);
              if (On == null || On.blotName !== "list-item" || !xe(Xt, `
`))
                return Xt;
              for (var sn = -1, At = Ht.parentNode; !At.classList.contains("ql-clipboard"); )
                (y.default.query(At) || {}).blotName === "list" && (sn += 1), At = At.parentNode;
              return sn <= 0 ? Xt : Xt.compose(new O.default().retain(Xt.length() - 1).retain(1, { indent: sn }));
            }
            function kt(Ht, Xt) {
              return xe(Xt, `
`) || (ze(Ht) || Xt.length() > 0 && Ht.nextSibling && ze(Ht.nextSibling)) && Xt.insert(`
`), Xt;
            }
            function Ut(Ht, Xt) {
              if (ze(Ht) && Ht.nextElementSibling != null && !xe(Xt, `

`)) {
                var On = Ht.offsetHeight + parseFloat(Ke(Ht).marginTop) + parseFloat(Ke(Ht).marginBottom);
                Ht.nextElementSibling.offsetTop > Ht.offsetTop + On * 1.5 && Xt.insert(`
`);
              }
              return Xt;
            }
            function dn(Ht, Xt) {
              var On = {}, sn = Ht.style || {};
              return sn.fontStyle && Ke(Ht).fontStyle === "italic" && (On.italic = !0), sn.fontWeight && (Ke(Ht).fontWeight.startsWith("bold") || parseInt(Ke(Ht).fontWeight) >= 700) && (On.bold = !0), Object.keys(On).length > 0 && (Xt = Pe(Xt, On)), parseFloat(sn.textIndent || 0) > 0 && (Xt = new O.default().insert("	").concat(Xt)), Xt;
            }
            function En(Ht, Xt) {
              var On = Ht.data;
              if (Ht.parentNode.tagName === "O:P")
                return Xt.insert(On.trim());
              if (On.trim().length === 0 && Ht.parentNode.classList.contains("ql-clipboard"))
                return Xt;
              if (!Ke(Ht.parentNode).whiteSpace.startsWith("pre")) {
                var sn = function(hn, $t) {
                  return $t = $t.replace(/[^\u00a0]/g, ""), $t.length < 1 && hn ? " " : $t;
                };
                On = On.replace(/\r\n/g, " ").replace(/\n/g, " "), On = On.replace(/\s\s+/g, sn.bind(sn, !0)), (Ht.previousSibling == null && ze(Ht.parentNode) || Ht.previousSibling != null && ze(Ht.previousSibling)) && (On = On.replace(/^\s+/, sn.bind(sn, !1))), (Ht.nextSibling == null && ze(Ht.parentNode) || Ht.nextSibling != null && ze(Ht.nextSibling)) && (On = On.replace(/\s+$/, sn.bind(sn, !1)));
              }
              return Xt.insert(On);
            }
            u.default = ge, u.matchAttributor = Et, u.matchBlot = zt, u.matchNewline = kt, u.matchSpacing = Ut, u.matchText = En;
          },
          /* 56 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function V(M, G) {
                for (var k = 0; k < G.length; k++) {
                  var F = G[k];
                  F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(M, F.key, F);
                }
              }
              return function(M, G, k) {
                return G && V(M.prototype, G), k && V(M, k), M;
              };
            }(), m = function V(M, G, k) {
              M === null && (M = Function.prototype);
              var F = Object.getOwnPropertyDescriptor(M, G);
              if (F === void 0) {
                var X = Object.getPrototypeOf(M);
                return X === null ? void 0 : V(X, G, k);
              } else {
                if ("value" in F)
                  return F.value;
                var ee = F.get;
                return ee === void 0 ? void 0 : ee.call(k);
              }
            }, v = c(6), S = $(v);
            function $(V) {
              return V && V.__esModule ? V : { default: V };
            }
            function E(V, M) {
              if (!(V instanceof M))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(V, M) {
              if (!V)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return M && (typeof M == "object" || typeof M == "function") ? M : V;
            }
            function T(V, M) {
              if (typeof M != "function" && M !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof M);
              V.prototype = Object.create(M && M.prototype, { constructor: { value: V, enumerable: !1, writable: !0, configurable: !0 } }), M && (Object.setPrototypeOf ? Object.setPrototypeOf(V, M) : V.__proto__ = M);
            }
            var y = function(V) {
              T(M, V);
              function M() {
                return E(this, M), O(this, (M.__proto__ || Object.getPrototypeOf(M)).apply(this, arguments));
              }
              return d(M, [{
                key: "optimize",
                value: function(k) {
                  m(M.prototype.__proto__ || Object.getPrototypeOf(M.prototype), "optimize", this).call(this, k), this.domNode.tagName !== this.statics.tagName[0] && this.replaceWith(this.statics.blotName);
                }
              }], [{
                key: "create",
                value: function() {
                  return m(M.__proto__ || Object.getPrototypeOf(M), "create", this).call(this);
                }
              }, {
                key: "formats",
                value: function() {
                  return !0;
                }
              }]), M;
            }(S.default);
            y.blotName = "bold", y.tagName = ["STRONG", "B"], u.default = y;
          },
          /* 57 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.addControls = u.default = void 0;
            var d = function() {
              function H(C, w) {
                var P = [], J = !0, se = !1, fe = void 0;
                try {
                  for (var N = C[Symbol.iterator](), W; !(J = (W = N.next()).done) && (P.push(W.value), !(w && P.length === w)); J = !0)
                    ;
                } catch (I) {
                  se = !0, fe = I;
                } finally {
                  try {
                    !J && N.return && N.return();
                  } finally {
                    if (se)
                      throw fe;
                  }
                }
                return P;
              }
              return function(C, w) {
                if (Array.isArray(C))
                  return C;
                if (Symbol.iterator in Object(C))
                  return H(C, w);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), m = function() {
              function H(C, w) {
                for (var P = 0; P < w.length; P++) {
                  var J = w[P];
                  J.enumerable = J.enumerable || !1, J.configurable = !0, "value" in J && (J.writable = !0), Object.defineProperty(C, J.key, J);
                }
              }
              return function(C, w, P) {
                return w && H(C.prototype, w), P && H(C, P), C;
              };
            }(), v = c(2), S = k(v), $ = c(0), E = k($), O = c(5), T = k(O), y = c(10), V = k(y), M = c(9), G = k(M);
            function k(H) {
              return H && H.__esModule ? H : { default: H };
            }
            function F(H, C, w) {
              return C in H ? Object.defineProperty(H, C, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : H[C] = w, H;
            }
            function X(H, C) {
              if (!(H instanceof C))
                throw new TypeError("Cannot call a class as a function");
            }
            function ee(H, C) {
              if (!H)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return C && (typeof C == "object" || typeof C == "function") ? C : H;
            }
            function ue(H, C) {
              if (typeof C != "function" && C !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof C);
              H.prototype = Object.create(C && C.prototype, { constructor: { value: H, enumerable: !1, writable: !0, configurable: !0 } }), C && (Object.setPrototypeOf ? Object.setPrototypeOf(H, C) : H.__proto__ = C);
            }
            var Q = (0, V.default)("quill:toolbar"), Y = function(H) {
              ue(C, H);
              function C(w, P) {
                X(this, C);
                var J = ee(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, w, P));
                if (Array.isArray(J.options.container)) {
                  var se = document.createElement("div");
                  oe(se, J.options.container), w.container.parentNode.insertBefore(se, w.container), J.container = se;
                } else
                  typeof J.options.container == "string" ? J.container = document.querySelector(J.options.container) : J.container = J.options.container;
                if (!(J.container instanceof HTMLElement)) {
                  var fe;
                  return fe = Q.error("Container required for toolbar", J.options), ee(J, fe);
                }
                return J.container.classList.add("ql-toolbar"), J.controls = [], J.handlers = {}, Object.keys(J.options.handlers).forEach(function(N) {
                  J.addHandler(N, J.options.handlers[N]);
                }), [].forEach.call(J.container.querySelectorAll("button, select"), function(N) {
                  J.attach(N);
                }), J.quill.on(T.default.events.EDITOR_CHANGE, function(N, W) {
                  N === T.default.events.SELECTION_CHANGE && J.update(W);
                }), J.quill.on(T.default.events.SCROLL_OPTIMIZE, function() {
                  var N = J.quill.selection.getRange(), W = d(N, 1), I = W[0];
                  J.update(I);
                }), J;
              }
              return m(C, [{
                key: "addHandler",
                value: function(P, J) {
                  this.handlers[P] = J;
                }
              }, {
                key: "attach",
                value: function(P) {
                  var J = this, se = [].find.call(P.classList, function(N) {
                    return N.indexOf("ql-") === 0;
                  });
                  if (se) {
                    if (se = se.slice(3), P.tagName === "BUTTON" && P.setAttribute("type", "button"), this.handlers[se] == null) {
                      if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[se] == null) {
                        Q.warn("ignoring attaching to disabled format", se, P);
                        return;
                      }
                      if (E.default.query(se) == null) {
                        Q.warn("ignoring attaching to nonexistent format", se, P);
                        return;
                      }
                    }
                    var fe = P.tagName === "SELECT" ? "change" : "click";
                    P.addEventListener(fe, function(N) {
                      var W = void 0;
                      if (P.tagName === "SELECT") {
                        if (P.selectedIndex < 0)
                          return;
                        var I = P.options[P.selectedIndex];
                        I.hasAttribute("selected") ? W = !1 : W = I.value || !1;
                      } else
                        P.classList.contains("ql-active") ? W = !1 : W = P.value || !P.hasAttribute("value"), N.preventDefault();
                      J.quill.focus();
                      var te = J.quill.selection.getRange(), ge = d(te, 1), Pe = ge[0];
                      if (J.handlers[se] != null)
                        J.handlers[se].call(J, W);
                      else if (E.default.query(se).prototype instanceof E.default.Embed) {
                        if (W = prompt("Enter " + se), !W)
                          return;
                        J.quill.updateContents(new S.default().retain(Pe.index).delete(Pe.length).insert(F({}, se, W)), T.default.sources.USER);
                      } else
                        J.quill.format(se, W, T.default.sources.USER);
                      J.update(Pe);
                    }), this.controls.push([se, P]);
                  }
                }
              }, {
                key: "update",
                value: function(P) {
                  var J = P == null ? {} : this.quill.getFormat(P);
                  this.controls.forEach(function(se) {
                    var fe = d(se, 2), N = fe[0], W = fe[1];
                    if (W.tagName === "SELECT") {
                      var I = void 0;
                      if (P == null)
                        I = null;
                      else if (J[N] == null)
                        I = W.querySelector("option[selected]");
                      else if (!Array.isArray(J[N])) {
                        var te = J[N];
                        typeof te == "string" && (te = te.replace(/\"/g, '\\"')), I = W.querySelector('option[value="' + te + '"]');
                      }
                      I == null ? (W.value = "", W.selectedIndex = -1) : I.selected = !0;
                    } else if (P == null)
                      W.classList.remove("ql-active");
                    else if (W.hasAttribute("value")) {
                      var ge = J[N] === W.getAttribute("value") || J[N] != null && J[N].toString() === W.getAttribute("value") || J[N] == null && !W.getAttribute("value");
                      W.classList.toggle("ql-active", ge);
                    } else
                      W.classList.toggle("ql-active", J[N] != null);
                  });
                }
              }]), C;
            }(G.default);
            Y.DEFAULTS = {};
            function pe(H, C, w) {
              var P = document.createElement("button");
              P.setAttribute("type", "button"), P.classList.add("ql-" + C), w != null && (P.value = w), H.appendChild(P);
            }
            function oe(H, C) {
              Array.isArray(C[0]) || (C = [C]), C.forEach(function(w) {
                var P = document.createElement("span");
                P.classList.add("ql-formats"), w.forEach(function(J) {
                  if (typeof J == "string")
                    pe(P, J);
                  else {
                    var se = Object.keys(J)[0], fe = J[se];
                    Array.isArray(fe) ? ne(P, se, fe) : pe(P, se, fe);
                  }
                }), H.appendChild(P);
              });
            }
            function ne(H, C, w) {
              var P = document.createElement("select");
              P.classList.add("ql-" + C), w.forEach(function(J) {
                var se = document.createElement("option");
                J !== !1 ? se.setAttribute("value", J) : se.setAttribute("selected", "selected"), P.appendChild(se);
              }), H.appendChild(P);
            }
            Y.DEFAULTS = {
              container: null,
              handlers: {
                clean: function() {
                  var C = this, w = this.quill.getSelection();
                  if (w != null)
                    if (w.length == 0) {
                      var P = this.quill.getFormat();
                      Object.keys(P).forEach(function(J) {
                        E.default.query(J, E.default.Scope.INLINE) != null && C.quill.format(J, !1);
                      });
                    } else
                      this.quill.removeFormat(w, T.default.sources.USER);
                },
                direction: function(C) {
                  var w = this.quill.getFormat().align;
                  C === "rtl" && w == null ? this.quill.format("align", "right", T.default.sources.USER) : !C && w === "right" && this.quill.format("align", !1, T.default.sources.USER), this.quill.format("direction", C, T.default.sources.USER);
                },
                indent: function(C) {
                  var w = this.quill.getSelection(), P = this.quill.getFormat(w), J = parseInt(P.indent || 0);
                  if (C === "+1" || C === "-1") {
                    var se = C === "+1" ? 1 : -1;
                    P.direction === "rtl" && (se *= -1), this.quill.format("indent", J + se, T.default.sources.USER);
                  }
                },
                link: function(C) {
                  C === !0 && (C = prompt("Enter link URL:")), this.quill.format("link", C, T.default.sources.USER);
                },
                list: function(C) {
                  var w = this.quill.getSelection(), P = this.quill.getFormat(w);
                  C === "check" ? P.list === "checked" || P.list === "unchecked" ? this.quill.format("list", !1, T.default.sources.USER) : this.quill.format("list", "unchecked", T.default.sources.USER) : this.quill.format("list", C, T.default.sources.USER);
                }
              }
            }, u.default = Y, u.addControls = oe;
          },
          /* 58 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>';
          },
          /* 59 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function V(M, G) {
                for (var k = 0; k < G.length; k++) {
                  var F = G[k];
                  F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(M, F.key, F);
                }
              }
              return function(M, G, k) {
                return G && V(M.prototype, G), k && V(M, k), M;
              };
            }(), m = function V(M, G, k) {
              M === null && (M = Function.prototype);
              var F = Object.getOwnPropertyDescriptor(M, G);
              if (F === void 0) {
                var X = Object.getPrototypeOf(M);
                return X === null ? void 0 : V(X, G, k);
              } else {
                if ("value" in F)
                  return F.value;
                var ee = F.get;
                return ee === void 0 ? void 0 : ee.call(k);
              }
            }, v = c(28), S = $(v);
            function $(V) {
              return V && V.__esModule ? V : { default: V };
            }
            function E(V, M) {
              if (!(V instanceof M))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(V, M) {
              if (!V)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return M && (typeof M == "object" || typeof M == "function") ? M : V;
            }
            function T(V, M) {
              if (typeof M != "function" && M !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof M);
              V.prototype = Object.create(M && M.prototype, { constructor: { value: V, enumerable: !1, writable: !0, configurable: !0 } }), M && (Object.setPrototypeOf ? Object.setPrototypeOf(V, M) : V.__proto__ = M);
            }
            var y = function(V) {
              T(M, V);
              function M(G, k) {
                E(this, M);
                var F = O(this, (M.__proto__ || Object.getPrototypeOf(M)).call(this, G));
                return F.label.innerHTML = k, F.container.classList.add("ql-color-picker"), [].slice.call(F.container.querySelectorAll(".ql-picker-item"), 0, 7).forEach(function(X) {
                  X.classList.add("ql-primary");
                }), F;
              }
              return d(M, [{
                key: "buildItem",
                value: function(k) {
                  var F = m(M.prototype.__proto__ || Object.getPrototypeOf(M.prototype), "buildItem", this).call(this, k);
                  return F.style.backgroundColor = k.getAttribute("value") || "", F;
                }
              }, {
                key: "selectItem",
                value: function(k, F) {
                  m(M.prototype.__proto__ || Object.getPrototypeOf(M.prototype), "selectItem", this).call(this, k, F);
                  var X = this.label.querySelector(".ql-color-label"), ee = k && k.getAttribute("data-value") || "";
                  X && (X.tagName === "line" ? X.style.stroke = ee : X.style.fill = ee);
                }
              }]), M;
            }(S.default);
            u.default = y;
          },
          /* 60 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function V(M, G) {
                for (var k = 0; k < G.length; k++) {
                  var F = G[k];
                  F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(M, F.key, F);
                }
              }
              return function(M, G, k) {
                return G && V(M.prototype, G), k && V(M, k), M;
              };
            }(), m = function V(M, G, k) {
              M === null && (M = Function.prototype);
              var F = Object.getOwnPropertyDescriptor(M, G);
              if (F === void 0) {
                var X = Object.getPrototypeOf(M);
                return X === null ? void 0 : V(X, G, k);
              } else {
                if ("value" in F)
                  return F.value;
                var ee = F.get;
                return ee === void 0 ? void 0 : ee.call(k);
              }
            }, v = c(28), S = $(v);
            function $(V) {
              return V && V.__esModule ? V : { default: V };
            }
            function E(V, M) {
              if (!(V instanceof M))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(V, M) {
              if (!V)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return M && (typeof M == "object" || typeof M == "function") ? M : V;
            }
            function T(V, M) {
              if (typeof M != "function" && M !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof M);
              V.prototype = Object.create(M && M.prototype, { constructor: { value: V, enumerable: !1, writable: !0, configurable: !0 } }), M && (Object.setPrototypeOf ? Object.setPrototypeOf(V, M) : V.__proto__ = M);
            }
            var y = function(V) {
              T(M, V);
              function M(G, k) {
                E(this, M);
                var F = O(this, (M.__proto__ || Object.getPrototypeOf(M)).call(this, G));
                return F.container.classList.add("ql-icon-picker"), [].forEach.call(F.container.querySelectorAll(".ql-picker-item"), function(X) {
                  X.innerHTML = k[X.getAttribute("data-value") || ""];
                }), F.defaultItem = F.container.querySelector(".ql-selected"), F.selectItem(F.defaultItem), F;
              }
              return d(M, [{
                key: "selectItem",
                value: function(k, F) {
                  m(M.prototype.__proto__ || Object.getPrototypeOf(M.prototype), "selectItem", this).call(this, k, F), k = k || this.defaultItem, this.label.innerHTML = k.innerHTML;
                }
              }]), M;
            }(S.default);
            u.default = y;
          },
          /* 61 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function S($, E) {
                for (var O = 0; O < E.length; O++) {
                  var T = E[O];
                  T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty($, T.key, T);
                }
              }
              return function($, E, O) {
                return E && S($.prototype, E), O && S($, O), $;
              };
            }();
            function m(S, $) {
              if (!(S instanceof $))
                throw new TypeError("Cannot call a class as a function");
            }
            var v = function() {
              function S($, E) {
                var O = this;
                m(this, S), this.quill = $, this.boundsContainer = E || document.body, this.root = $.addContainer("ql-tooltip"), this.root.innerHTML = this.constructor.TEMPLATE, this.quill.root === this.quill.scrollingContainer && this.quill.root.addEventListener("scroll", function() {
                  O.root.style.marginTop = -1 * O.quill.root.scrollTop + "px";
                }), this.hide();
              }
              return d(S, [{
                key: "hide",
                value: function() {
                  this.root.classList.add("ql-hidden");
                }
              }, {
                key: "position",
                value: function(E) {
                  var O = E.left + E.width / 2 - this.root.offsetWidth / 2, T = E.bottom + this.quill.root.scrollTop;
                  this.root.style.left = O + "px", this.root.style.top = T + "px", this.root.classList.remove("ql-flip");
                  var y = this.boundsContainer.getBoundingClientRect(), V = this.root.getBoundingClientRect(), M = 0;
                  if (V.right > y.right && (M = y.right - V.right, this.root.style.left = O + M + "px"), V.left < y.left && (M = y.left - V.left, this.root.style.left = O + M + "px"), V.bottom > y.bottom) {
                    var G = V.bottom - V.top, k = E.bottom - E.top + G;
                    this.root.style.top = T - k + "px", this.root.classList.add("ql-flip");
                  }
                  return M;
                }
              }, {
                key: "show",
                value: function() {
                  this.root.classList.remove("ql-editing"), this.root.classList.remove("ql-hidden");
                }
              }]), S;
            }();
            u.default = v;
          },
          /* 62 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function ne(H, C) {
                var w = [], P = !0, J = !1, se = void 0;
                try {
                  for (var fe = H[Symbol.iterator](), N; !(P = (N = fe.next()).done) && (w.push(N.value), !(C && w.length === C)); P = !0)
                    ;
                } catch (W) {
                  J = !0, se = W;
                } finally {
                  try {
                    !P && fe.return && fe.return();
                  } finally {
                    if (J)
                      throw se;
                  }
                }
                return w;
              }
              return function(H, C) {
                if (Array.isArray(H))
                  return H;
                if (Symbol.iterator in Object(H))
                  return ne(H, C);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(), m = function ne(H, C, w) {
              H === null && (H = Function.prototype);
              var P = Object.getOwnPropertyDescriptor(H, C);
              if (P === void 0) {
                var J = Object.getPrototypeOf(H);
                return J === null ? void 0 : ne(J, C, w);
              } else {
                if ("value" in P)
                  return P.value;
                var se = P.get;
                return se === void 0 ? void 0 : se.call(w);
              }
            }, v = function() {
              function ne(H, C) {
                for (var w = 0; w < C.length; w++) {
                  var P = C[w];
                  P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(H, P.key, P);
                }
              }
              return function(H, C, w) {
                return C && ne(H.prototype, C), w && ne(H, w), H;
              };
            }(), S = c(3), $ = X(S), E = c(8), O = X(E), T = c(43), y = X(T), V = c(27), M = X(V), G = c(15), k = c(41), F = X(k);
            function X(ne) {
              return ne && ne.__esModule ? ne : { default: ne };
            }
            function ee(ne, H) {
              if (!(ne instanceof H))
                throw new TypeError("Cannot call a class as a function");
            }
            function ue(ne, H) {
              if (!ne)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return H && (typeof H == "object" || typeof H == "function") ? H : ne;
            }
            function Q(ne, H) {
              if (typeof H != "function" && H !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof H);
              ne.prototype = Object.create(H && H.prototype, { constructor: { value: ne, enumerable: !1, writable: !0, configurable: !0 } }), H && (Object.setPrototypeOf ? Object.setPrototypeOf(ne, H) : ne.__proto__ = H);
            }
            var Y = [[{ header: ["1", "2", "3", !1] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]], pe = function(ne) {
              Q(H, ne);
              function H(C, w) {
                ee(this, H), w.modules.toolbar != null && w.modules.toolbar.container == null && (w.modules.toolbar.container = Y);
                var P = ue(this, (H.__proto__ || Object.getPrototypeOf(H)).call(this, C, w));
                return P.quill.container.classList.add("ql-snow"), P;
              }
              return v(H, [{
                key: "extendToolbar",
                value: function(w) {
                  w.container.classList.add("ql-snow"), this.buildButtons([].slice.call(w.container.querySelectorAll("button")), F.default), this.buildPickers([].slice.call(w.container.querySelectorAll("select")), F.default), this.tooltip = new oe(this.quill, this.options.bounds), w.container.querySelector(".ql-link") && this.quill.keyboard.addBinding({ key: "K", shortKey: !0 }, function(P, J) {
                    w.handlers.link.call(w, !J.format.link);
                  });
                }
              }]), H;
            }(y.default);
            pe.DEFAULTS = (0, $.default)(!0, {}, y.default.DEFAULTS, {
              modules: {
                toolbar: {
                  handlers: {
                    link: function(H) {
                      if (H) {
                        var C = this.quill.getSelection();
                        if (C == null || C.length == 0)
                          return;
                        var w = this.quill.getText(C);
                        /^\S+@\S+\.\S+$/.test(w) && w.indexOf("mailto:") !== 0 && (w = "mailto:" + w);
                        var P = this.quill.theme.tooltip;
                        P.edit("link", w);
                      } else
                        this.quill.format("link", !1);
                    }
                  }
                }
              }
            });
            var oe = function(ne) {
              Q(H, ne);
              function H(C, w) {
                ee(this, H);
                var P = ue(this, (H.__proto__ || Object.getPrototypeOf(H)).call(this, C, w));
                return P.preview = P.root.querySelector("a.ql-preview"), P;
              }
              return v(H, [{
                key: "listen",
                value: function() {
                  var w = this;
                  m(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "listen", this).call(this), this.root.querySelector("a.ql-action").addEventListener("click", function(P) {
                    w.root.classList.contains("ql-editing") ? w.save() : w.edit("link", w.preview.textContent), P.preventDefault();
                  }), this.root.querySelector("a.ql-remove").addEventListener("click", function(P) {
                    if (w.linkRange != null) {
                      var J = w.linkRange;
                      w.restoreFocus(), w.quill.formatText(J, "link", !1, O.default.sources.USER), delete w.linkRange;
                    }
                    P.preventDefault(), w.hide();
                  }), this.quill.on(O.default.events.SELECTION_CHANGE, function(P, J, se) {
                    if (P != null) {
                      if (P.length === 0 && se === O.default.sources.USER) {
                        var fe = w.quill.scroll.descendant(M.default, P.index), N = d(fe, 2), W = N[0], I = N[1];
                        if (W != null) {
                          w.linkRange = new G.Range(P.index - I, W.length());
                          var te = M.default.formats(W.domNode);
                          w.preview.textContent = te, w.preview.setAttribute("href", te), w.show(), w.position(w.quill.getBounds(w.linkRange));
                          return;
                        }
                      } else
                        delete w.linkRange;
                      w.hide();
                    }
                  });
                }
              }, {
                key: "show",
                value: function() {
                  m(H.prototype.__proto__ || Object.getPrototypeOf(H.prototype), "show", this).call(this), this.root.removeAttribute("data-mode");
                }
              }]), H;
            }(T.BaseTooltip);
            oe.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join(""), u.default = pe;
          },
          /* 63 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = c(29), m = At(d), v = c(36), S = c(38), $ = c(64), E = c(65), O = At(E), T = c(66), y = At(T), V = c(67), M = At(V), G = c(37), k = c(26), F = c(39), X = c(40), ee = c(56), ue = At(ee), Q = c(68), Y = At(Q), pe = c(27), oe = At(pe), ne = c(69), H = At(ne), C = c(70), w = At(C), P = c(71), J = At(P), se = c(72), fe = At(se), N = c(73), W = At(N), I = c(13), te = At(I), ge = c(74), Pe = At(ge), Ke = c(75), xe = At(Ke), ze = c(57), nt = At(ze), Qt = c(41), Et = At(Qt), zt = c(28), Nt = At(zt), pt = c(59), at = At(pt), kt = c(60), Ut = At(kt), dn = c(61), En = At(dn), Ht = c(108), Xt = At(Ht), On = c(62), sn = At(On);
            function At(hn) {
              return hn && hn.__esModule ? hn : { default: hn };
            }
            m.default.register({
              "attributors/attribute/direction": S.DirectionAttribute,
              "attributors/class/align": v.AlignClass,
              "attributors/class/background": G.BackgroundClass,
              "attributors/class/color": k.ColorClass,
              "attributors/class/direction": S.DirectionClass,
              "attributors/class/font": F.FontClass,
              "attributors/class/size": X.SizeClass,
              "attributors/style/align": v.AlignStyle,
              "attributors/style/background": G.BackgroundStyle,
              "attributors/style/color": k.ColorStyle,
              "attributors/style/direction": S.DirectionStyle,
              "attributors/style/font": F.FontStyle,
              "attributors/style/size": X.SizeStyle
            }, !0), m.default.register({
              "formats/align": v.AlignClass,
              "formats/direction": S.DirectionClass,
              "formats/indent": $.IndentClass,
              "formats/background": G.BackgroundStyle,
              "formats/color": k.ColorStyle,
              "formats/font": F.FontClass,
              "formats/size": X.SizeClass,
              "formats/blockquote": O.default,
              "formats/code-block": te.default,
              "formats/header": y.default,
              "formats/list": M.default,
              "formats/bold": ue.default,
              "formats/code": I.Code,
              "formats/italic": Y.default,
              "formats/link": oe.default,
              "formats/script": H.default,
              "formats/strike": w.default,
              "formats/underline": J.default,
              "formats/image": fe.default,
              "formats/video": W.default,
              "formats/list/item": V.ListItem,
              "modules/formula": Pe.default,
              "modules/syntax": xe.default,
              "modules/toolbar": nt.default,
              "themes/bubble": Xt.default,
              "themes/snow": sn.default,
              "ui/icons": Et.default,
              "ui/picker": Nt.default,
              "ui/icon-picker": Ut.default,
              "ui/color-picker": at.default,
              "ui/tooltip": En.default
            }, !0), u.default = m.default;
          },
          /* 64 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.IndentClass = void 0;
            var d = function() {
              function M(G, k) {
                for (var F = 0; F < k.length; F++) {
                  var X = k[F];
                  X.enumerable = X.enumerable || !1, X.configurable = !0, "value" in X && (X.writable = !0), Object.defineProperty(G, X.key, X);
                }
              }
              return function(G, k, F) {
                return k && M(G.prototype, k), F && M(G, F), G;
              };
            }(), m = function M(G, k, F) {
              G === null && (G = Function.prototype);
              var X = Object.getOwnPropertyDescriptor(G, k);
              if (X === void 0) {
                var ee = Object.getPrototypeOf(G);
                return ee === null ? void 0 : M(ee, k, F);
              } else {
                if ("value" in X)
                  return X.value;
                var ue = X.get;
                return ue === void 0 ? void 0 : ue.call(F);
              }
            }, v = c(0), S = $(v);
            function $(M) {
              return M && M.__esModule ? M : { default: M };
            }
            function E(M, G) {
              if (!(M instanceof G))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(M, G) {
              if (!M)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return G && (typeof G == "object" || typeof G == "function") ? G : M;
            }
            function T(M, G) {
              if (typeof G != "function" && G !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof G);
              M.prototype = Object.create(G && G.prototype, { constructor: { value: M, enumerable: !1, writable: !0, configurable: !0 } }), G && (Object.setPrototypeOf ? Object.setPrototypeOf(M, G) : M.__proto__ = G);
            }
            var y = function(M) {
              T(G, M);
              function G() {
                return E(this, G), O(this, (G.__proto__ || Object.getPrototypeOf(G)).apply(this, arguments));
              }
              return d(G, [{
                key: "add",
                value: function(F, X) {
                  if (X === "+1" || X === "-1") {
                    var ee = this.value(F) || 0;
                    X = X === "+1" ? ee + 1 : ee - 1;
                  }
                  return X === 0 ? (this.remove(F), !0) : m(G.prototype.__proto__ || Object.getPrototypeOf(G.prototype), "add", this).call(this, F, X);
                }
              }, {
                key: "canAdd",
                value: function(F, X) {
                  return m(G.prototype.__proto__ || Object.getPrototypeOf(G.prototype), "canAdd", this).call(this, F, X) || m(G.prototype.__proto__ || Object.getPrototypeOf(G.prototype), "canAdd", this).call(this, F, parseInt(X));
                }
              }, {
                key: "value",
                value: function(F) {
                  return parseInt(m(G.prototype.__proto__ || Object.getPrototypeOf(G.prototype), "value", this).call(this, F)) || void 0;
                }
              }]), G;
            }(S.default.Attributor.Class), V = new y("indent", "ql-indent", {
              scope: S.default.Scope.BLOCK,
              whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
            });
            u.IndentClass = V;
          },
          /* 65 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = c(4), m = v(d);
            function v(T) {
              return T && T.__esModule ? T : { default: T };
            }
            function S(T, y) {
              if (!(T instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function $(T, y) {
              if (!T)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y && (typeof y == "object" || typeof y == "function") ? y : T;
            }
            function E(T, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof y);
              T.prototype = Object.create(y && y.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(T, y) : T.__proto__ = y);
            }
            var O = function(T) {
              E(y, T);
              function y() {
                return S(this, y), $(this, (y.__proto__ || Object.getPrototypeOf(y)).apply(this, arguments));
              }
              return y;
            }(m.default);
            O.blotName = "blockquote", O.tagName = "blockquote", u.default = O;
          },
          /* 66 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function y(V, M) {
                for (var G = 0; G < M.length; G++) {
                  var k = M[G];
                  k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(V, k.key, k);
                }
              }
              return function(V, M, G) {
                return M && y(V.prototype, M), G && y(V, G), V;
              };
            }(), m = c(4), v = S(m);
            function S(y) {
              return y && y.__esModule ? y : { default: y };
            }
            function $(y, V) {
              if (!(y instanceof V))
                throw new TypeError("Cannot call a class as a function");
            }
            function E(y, V) {
              if (!y)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return V && (typeof V == "object" || typeof V == "function") ? V : y;
            }
            function O(y, V) {
              if (typeof V != "function" && V !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof V);
              y.prototype = Object.create(V && V.prototype, { constructor: { value: y, enumerable: !1, writable: !0, configurable: !0 } }), V && (Object.setPrototypeOf ? Object.setPrototypeOf(y, V) : y.__proto__ = V);
            }
            var T = function(y) {
              O(V, y);
              function V() {
                return $(this, V), E(this, (V.__proto__ || Object.getPrototypeOf(V)).apply(this, arguments));
              }
              return d(V, null, [{
                key: "formats",
                value: function(G) {
                  return this.tagName.indexOf(G.tagName) + 1;
                }
              }]), V;
            }(v.default);
            T.blotName = "header", T.tagName = ["H1", "H2", "H3", "H4", "H5", "H6"], u.default = T;
          },
          /* 67 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.ListItem = void 0;
            var d = function() {
              function ee(ue, Q) {
                for (var Y = 0; Y < Q.length; Y++) {
                  var pe = Q[Y];
                  pe.enumerable = pe.enumerable || !1, pe.configurable = !0, "value" in pe && (pe.writable = !0), Object.defineProperty(ue, pe.key, pe);
                }
              }
              return function(ue, Q, Y) {
                return Q && ee(ue.prototype, Q), Y && ee(ue, Y), ue;
              };
            }(), m = function ee(ue, Q, Y) {
              ue === null && (ue = Function.prototype);
              var pe = Object.getOwnPropertyDescriptor(ue, Q);
              if (pe === void 0) {
                var oe = Object.getPrototypeOf(ue);
                return oe === null ? void 0 : ee(oe, Q, Y);
              } else {
                if ("value" in pe)
                  return pe.value;
                var ne = pe.get;
                return ne === void 0 ? void 0 : ne.call(Y);
              }
            }, v = c(0), S = y(v), $ = c(4), E = y($), O = c(25), T = y(O);
            function y(ee) {
              return ee && ee.__esModule ? ee : { default: ee };
            }
            function V(ee, ue, Q) {
              return ue in ee ? Object.defineProperty(ee, ue, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : ee[ue] = Q, ee;
            }
            function M(ee, ue) {
              if (!(ee instanceof ue))
                throw new TypeError("Cannot call a class as a function");
            }
            function G(ee, ue) {
              if (!ee)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return ue && (typeof ue == "object" || typeof ue == "function") ? ue : ee;
            }
            function k(ee, ue) {
              if (typeof ue != "function" && ue !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
              ee.prototype = Object.create(ue && ue.prototype, { constructor: { value: ee, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(ee, ue) : ee.__proto__ = ue);
            }
            var F = function(ee) {
              k(ue, ee);
              function ue() {
                return M(this, ue), G(this, (ue.__proto__ || Object.getPrototypeOf(ue)).apply(this, arguments));
              }
              return d(ue, [{
                key: "format",
                value: function(Y, pe) {
                  Y === X.blotName && !pe ? this.replaceWith(S.default.create(this.statics.scope)) : m(ue.prototype.__proto__ || Object.getPrototypeOf(ue.prototype), "format", this).call(this, Y, pe);
                }
              }, {
                key: "remove",
                value: function() {
                  this.prev == null && this.next == null ? this.parent.remove() : m(ue.prototype.__proto__ || Object.getPrototypeOf(ue.prototype), "remove", this).call(this);
                }
              }, {
                key: "replaceWith",
                value: function(Y, pe) {
                  return this.parent.isolate(this.offset(this.parent), this.length()), Y === this.parent.statics.blotName ? (this.parent.replaceWith(Y, pe), this) : (this.parent.unwrap(), m(ue.prototype.__proto__ || Object.getPrototypeOf(ue.prototype), "replaceWith", this).call(this, Y, pe));
                }
              }], [{
                key: "formats",
                value: function(Y) {
                  return Y.tagName === this.tagName ? void 0 : m(ue.__proto__ || Object.getPrototypeOf(ue), "formats", this).call(this, Y);
                }
              }]), ue;
            }(E.default);
            F.blotName = "list-item", F.tagName = "LI";
            var X = function(ee) {
              k(ue, ee), d(ue, null, [{
                key: "create",
                value: function(Y) {
                  var pe = Y === "ordered" ? "OL" : "UL", oe = m(ue.__proto__ || Object.getPrototypeOf(ue), "create", this).call(this, pe);
                  return (Y === "checked" || Y === "unchecked") && oe.setAttribute("data-checked", Y === "checked"), oe;
                }
              }, {
                key: "formats",
                value: function(Y) {
                  if (Y.tagName === "OL")
                    return "ordered";
                  if (Y.tagName === "UL")
                    return Y.hasAttribute("data-checked") ? Y.getAttribute("data-checked") === "true" ? "checked" : "unchecked" : "bullet";
                }
              }]);
              function ue(Q) {
                M(this, ue);
                var Y = G(this, (ue.__proto__ || Object.getPrototypeOf(ue)).call(this, Q)), pe = function(ne) {
                  if (ne.target.parentNode === Q) {
                    var H = Y.statics.formats(Q), C = S.default.find(ne.target);
                    H === "checked" ? C.format("list", "unchecked") : H === "unchecked" && C.format("list", "checked");
                  }
                };
                return Q.addEventListener("touchstart", pe), Q.addEventListener("mousedown", pe), Y;
              }
              return d(ue, [{
                key: "format",
                value: function(Y, pe) {
                  this.children.length > 0 && this.children.tail.format(Y, pe);
                }
              }, {
                key: "formats",
                value: function() {
                  return V({}, this.statics.blotName, this.statics.formats(this.domNode));
                }
              }, {
                key: "insertBefore",
                value: function(Y, pe) {
                  if (Y instanceof F)
                    m(ue.prototype.__proto__ || Object.getPrototypeOf(ue.prototype), "insertBefore", this).call(this, Y, pe);
                  else {
                    var oe = pe == null ? this.length() : pe.offset(this), ne = this.split(oe);
                    ne.parent.insertBefore(Y, ne);
                  }
                }
              }, {
                key: "optimize",
                value: function(Y) {
                  m(ue.prototype.__proto__ || Object.getPrototypeOf(ue.prototype), "optimize", this).call(this, Y);
                  var pe = this.next;
                  pe != null && pe.prev === this && pe.statics.blotName === this.statics.blotName && pe.domNode.tagName === this.domNode.tagName && pe.domNode.getAttribute("data-checked") === this.domNode.getAttribute("data-checked") && (pe.moveChildren(this), pe.remove());
                }
              }, {
                key: "replace",
                value: function(Y) {
                  if (Y.statics.blotName !== this.statics.blotName) {
                    var pe = S.default.create(this.statics.defaultChild);
                    Y.moveChildren(pe), this.appendChild(pe);
                  }
                  m(ue.prototype.__proto__ || Object.getPrototypeOf(ue.prototype), "replace", this).call(this, Y);
                }
              }]), ue;
            }(T.default);
            X.blotName = "list", X.scope = S.default.Scope.BLOCK_BLOT, X.tagName = ["OL", "UL"], X.defaultChild = "list-item", X.allowedChildren = [F], u.ListItem = F, u.default = X;
          },
          /* 68 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = c(56), m = v(d);
            function v(T) {
              return T && T.__esModule ? T : { default: T };
            }
            function S(T, y) {
              if (!(T instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function $(T, y) {
              if (!T)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y && (typeof y == "object" || typeof y == "function") ? y : T;
            }
            function E(T, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof y);
              T.prototype = Object.create(y && y.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(T, y) : T.__proto__ = y);
            }
            var O = function(T) {
              E(y, T);
              function y() {
                return S(this, y), $(this, (y.__proto__ || Object.getPrototypeOf(y)).apply(this, arguments));
              }
              return y;
            }(m.default);
            O.blotName = "italic", O.tagName = ["EM", "I"], u.default = O;
          },
          /* 69 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function V(M, G) {
                for (var k = 0; k < G.length; k++) {
                  var F = G[k];
                  F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(M, F.key, F);
                }
              }
              return function(M, G, k) {
                return G && V(M.prototype, G), k && V(M, k), M;
              };
            }(), m = function V(M, G, k) {
              M === null && (M = Function.prototype);
              var F = Object.getOwnPropertyDescriptor(M, G);
              if (F === void 0) {
                var X = Object.getPrototypeOf(M);
                return X === null ? void 0 : V(X, G, k);
              } else {
                if ("value" in F)
                  return F.value;
                var ee = F.get;
                return ee === void 0 ? void 0 : ee.call(k);
              }
            }, v = c(6), S = $(v);
            function $(V) {
              return V && V.__esModule ? V : { default: V };
            }
            function E(V, M) {
              if (!(V instanceof M))
                throw new TypeError("Cannot call a class as a function");
            }
            function O(V, M) {
              if (!V)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return M && (typeof M == "object" || typeof M == "function") ? M : V;
            }
            function T(V, M) {
              if (typeof M != "function" && M !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof M);
              V.prototype = Object.create(M && M.prototype, { constructor: { value: V, enumerable: !1, writable: !0, configurable: !0 } }), M && (Object.setPrototypeOf ? Object.setPrototypeOf(V, M) : V.__proto__ = M);
            }
            var y = function(V) {
              T(M, V);
              function M() {
                return E(this, M), O(this, (M.__proto__ || Object.getPrototypeOf(M)).apply(this, arguments));
              }
              return d(M, null, [{
                key: "create",
                value: function(k) {
                  return k === "super" ? document.createElement("sup") : k === "sub" ? document.createElement("sub") : m(M.__proto__ || Object.getPrototypeOf(M), "create", this).call(this, k);
                }
              }, {
                key: "formats",
                value: function(k) {
                  if (k.tagName === "SUB")
                    return "sub";
                  if (k.tagName === "SUP")
                    return "super";
                }
              }]), M;
            }(S.default);
            y.blotName = "script", y.tagName = ["SUB", "SUP"], u.default = y;
          },
          /* 70 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = c(6), m = v(d);
            function v(T) {
              return T && T.__esModule ? T : { default: T };
            }
            function S(T, y) {
              if (!(T instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function $(T, y) {
              if (!T)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y && (typeof y == "object" || typeof y == "function") ? y : T;
            }
            function E(T, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof y);
              T.prototype = Object.create(y && y.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(T, y) : T.__proto__ = y);
            }
            var O = function(T) {
              E(y, T);
              function y() {
                return S(this, y), $(this, (y.__proto__ || Object.getPrototypeOf(y)).apply(this, arguments));
              }
              return y;
            }(m.default);
            O.blotName = "strike", O.tagName = "S", u.default = O;
          },
          /* 71 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = c(6), m = v(d);
            function v(T) {
              return T && T.__esModule ? T : { default: T };
            }
            function S(T, y) {
              if (!(T instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function $(T, y) {
              if (!T)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y && (typeof y == "object" || typeof y == "function") ? y : T;
            }
            function E(T, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof y);
              T.prototype = Object.create(y && y.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(T, y) : T.__proto__ = y);
            }
            var O = function(T) {
              E(y, T);
              function y() {
                return S(this, y), $(this, (y.__proto__ || Object.getPrototypeOf(y)).apply(this, arguments));
              }
              return y;
            }(m.default);
            O.blotName = "underline", O.tagName = "U", u.default = O;
          },
          /* 72 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function G(k, F) {
                for (var X = 0; X < F.length; X++) {
                  var ee = F[X];
                  ee.enumerable = ee.enumerable || !1, ee.configurable = !0, "value" in ee && (ee.writable = !0), Object.defineProperty(k, ee.key, ee);
                }
              }
              return function(k, F, X) {
                return F && G(k.prototype, F), X && G(k, X), k;
              };
            }(), m = function G(k, F, X) {
              k === null && (k = Function.prototype);
              var ee = Object.getOwnPropertyDescriptor(k, F);
              if (ee === void 0) {
                var ue = Object.getPrototypeOf(k);
                return ue === null ? void 0 : G(ue, F, X);
              } else {
                if ("value" in ee)
                  return ee.value;
                var Q = ee.get;
                return Q === void 0 ? void 0 : Q.call(X);
              }
            }, v = c(0), S = E(v), $ = c(27);
            function E(G) {
              return G && G.__esModule ? G : { default: G };
            }
            function O(G, k) {
              if (!(G instanceof k))
                throw new TypeError("Cannot call a class as a function");
            }
            function T(G, k) {
              if (!G)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return k && (typeof k == "object" || typeof k == "function") ? k : G;
            }
            function y(G, k) {
              if (typeof k != "function" && k !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof k);
              G.prototype = Object.create(k && k.prototype, { constructor: { value: G, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(G, k) : G.__proto__ = k);
            }
            var V = ["alt", "height", "width"], M = function(G) {
              y(k, G);
              function k() {
                return O(this, k), T(this, (k.__proto__ || Object.getPrototypeOf(k)).apply(this, arguments));
              }
              return d(k, [{
                key: "format",
                value: function(X, ee) {
                  V.indexOf(X) > -1 ? ee ? this.domNode.setAttribute(X, ee) : this.domNode.removeAttribute(X) : m(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "format", this).call(this, X, ee);
                }
              }], [{
                key: "create",
                value: function(X) {
                  var ee = m(k.__proto__ || Object.getPrototypeOf(k), "create", this).call(this, X);
                  return typeof X == "string" && ee.setAttribute("src", this.sanitize(X)), ee;
                }
              }, {
                key: "formats",
                value: function(X) {
                  return V.reduce(function(ee, ue) {
                    return X.hasAttribute(ue) && (ee[ue] = X.getAttribute(ue)), ee;
                  }, {});
                }
              }, {
                key: "match",
                value: function(X) {
                  return /\.(jpe?g|gif|png)$/.test(X) || /^data:image\/.+;base64/.test(X);
                }
              }, {
                key: "sanitize",
                value: function(X) {
                  return (0, $.sanitize)(X, ["http", "https", "data"]) ? X : "//:0";
                }
              }, {
                key: "value",
                value: function(X) {
                  return X.getAttribute("src");
                }
              }]), k;
            }(S.default.Embed);
            M.blotName = "image", M.tagName = "IMG", u.default = M;
          },
          /* 73 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            });
            var d = function() {
              function G(k, F) {
                for (var X = 0; X < F.length; X++) {
                  var ee = F[X];
                  ee.enumerable = ee.enumerable || !1, ee.configurable = !0, "value" in ee && (ee.writable = !0), Object.defineProperty(k, ee.key, ee);
                }
              }
              return function(k, F, X) {
                return F && G(k.prototype, F), X && G(k, X), k;
              };
            }(), m = function G(k, F, X) {
              k === null && (k = Function.prototype);
              var ee = Object.getOwnPropertyDescriptor(k, F);
              if (ee === void 0) {
                var ue = Object.getPrototypeOf(k);
                return ue === null ? void 0 : G(ue, F, X);
              } else {
                if ("value" in ee)
                  return ee.value;
                var Q = ee.get;
                return Q === void 0 ? void 0 : Q.call(X);
              }
            }, v = c(4), S = c(27), $ = E(S);
            function E(G) {
              return G && G.__esModule ? G : { default: G };
            }
            function O(G, k) {
              if (!(G instanceof k))
                throw new TypeError("Cannot call a class as a function");
            }
            function T(G, k) {
              if (!G)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return k && (typeof k == "object" || typeof k == "function") ? k : G;
            }
            function y(G, k) {
              if (typeof k != "function" && k !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof k);
              G.prototype = Object.create(k && k.prototype, { constructor: { value: G, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(G, k) : G.__proto__ = k);
            }
            var V = ["height", "width"], M = function(G) {
              y(k, G);
              function k() {
                return O(this, k), T(this, (k.__proto__ || Object.getPrototypeOf(k)).apply(this, arguments));
              }
              return d(k, [{
                key: "format",
                value: function(X, ee) {
                  V.indexOf(X) > -1 ? ee ? this.domNode.setAttribute(X, ee) : this.domNode.removeAttribute(X) : m(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "format", this).call(this, X, ee);
                }
              }], [{
                key: "create",
                value: function(X) {
                  var ee = m(k.__proto__ || Object.getPrototypeOf(k), "create", this).call(this, X);
                  return ee.setAttribute("frameborder", "0"), ee.setAttribute("allowfullscreen", !0), ee.setAttribute("src", this.sanitize(X)), ee;
                }
              }, {
                key: "formats",
                value: function(X) {
                  return V.reduce(function(ee, ue) {
                    return X.hasAttribute(ue) && (ee[ue] = X.getAttribute(ue)), ee;
                  }, {});
                }
              }, {
                key: "sanitize",
                value: function(X) {
                  return $.default.sanitize(X);
                }
              }, {
                key: "value",
                value: function(X) {
                  return X.getAttribute("src");
                }
              }]), k;
            }(v.BlockEmbed);
            M.blotName = "video", M.className = "ql-video", M.tagName = "IFRAME", u.default = M;
          },
          /* 74 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.FormulaBlot = void 0;
            var d = function() {
              function X(ee, ue) {
                for (var Q = 0; Q < ue.length; Q++) {
                  var Y = ue[Q];
                  Y.enumerable = Y.enumerable || !1, Y.configurable = !0, "value" in Y && (Y.writable = !0), Object.defineProperty(ee, Y.key, Y);
                }
              }
              return function(ee, ue, Q) {
                return ue && X(ee.prototype, ue), Q && X(ee, Q), ee;
              };
            }(), m = function X(ee, ue, Q) {
              ee === null && (ee = Function.prototype);
              var Y = Object.getOwnPropertyDescriptor(ee, ue);
              if (Y === void 0) {
                var pe = Object.getPrototypeOf(ee);
                return pe === null ? void 0 : X(pe, ue, Q);
              } else {
                if ("value" in Y)
                  return Y.value;
                var oe = Y.get;
                return oe === void 0 ? void 0 : oe.call(Q);
              }
            }, v = c(35), S = y(v), $ = c(5), E = y($), O = c(9), T = y(O);
            function y(X) {
              return X && X.__esModule ? X : { default: X };
            }
            function V(X, ee) {
              if (!(X instanceof ee))
                throw new TypeError("Cannot call a class as a function");
            }
            function M(X, ee) {
              if (!X)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return ee && (typeof ee == "object" || typeof ee == "function") ? ee : X;
            }
            function G(X, ee) {
              if (typeof ee != "function" && ee !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof ee);
              X.prototype = Object.create(ee && ee.prototype, { constructor: { value: X, enumerable: !1, writable: !0, configurable: !0 } }), ee && (Object.setPrototypeOf ? Object.setPrototypeOf(X, ee) : X.__proto__ = ee);
            }
            var k = function(X) {
              G(ee, X);
              function ee() {
                return V(this, ee), M(this, (ee.__proto__ || Object.getPrototypeOf(ee)).apply(this, arguments));
              }
              return d(ee, null, [{
                key: "create",
                value: function(Q) {
                  var Y = m(ee.__proto__ || Object.getPrototypeOf(ee), "create", this).call(this, Q);
                  return typeof Q == "string" && (window.katex.render(Q, Y, {
                    throwOnError: !1,
                    errorColor: "#f00"
                  }), Y.setAttribute("data-value", Q)), Y;
                }
              }, {
                key: "value",
                value: function(Q) {
                  return Q.getAttribute("data-value");
                }
              }]), ee;
            }(S.default);
            k.blotName = "formula", k.className = "ql-formula", k.tagName = "SPAN";
            var F = function(X) {
              G(ee, X), d(ee, null, [{
                key: "register",
                value: function() {
                  E.default.register(k, !0);
                }
              }]);
              function ee() {
                V(this, ee);
                var ue = M(this, (ee.__proto__ || Object.getPrototypeOf(ee)).call(this));
                if (window.katex == null)
                  throw new Error("Formula module requires KaTeX.");
                return ue;
              }
              return ee;
            }(T.default);
            u.FormulaBlot = k, u.default = F;
          },
          /* 75 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.CodeToken = u.CodeBlock = void 0;
            var d = function() {
              function Q(Y, pe) {
                for (var oe = 0; oe < pe.length; oe++) {
                  var ne = pe[oe];
                  ne.enumerable = ne.enumerable || !1, ne.configurable = !0, "value" in ne && (ne.writable = !0), Object.defineProperty(Y, ne.key, ne);
                }
              }
              return function(Y, pe, oe) {
                return pe && Q(Y.prototype, pe), oe && Q(Y, oe), Y;
              };
            }(), m = function Q(Y, pe, oe) {
              Y === null && (Y = Function.prototype);
              var ne = Object.getOwnPropertyDescriptor(Y, pe);
              if (ne === void 0) {
                var H = Object.getPrototypeOf(Y);
                return H === null ? void 0 : Q(H, pe, oe);
              } else {
                if ("value" in ne)
                  return ne.value;
                var C = ne.get;
                return C === void 0 ? void 0 : C.call(oe);
              }
            }, v = c(0), S = M(v), $ = c(5), E = M($), O = c(9), T = M(O), y = c(13), V = M(y);
            function M(Q) {
              return Q && Q.__esModule ? Q : { default: Q };
            }
            function G(Q, Y) {
              if (!(Q instanceof Y))
                throw new TypeError("Cannot call a class as a function");
            }
            function k(Q, Y) {
              if (!Q)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return Y && (typeof Y == "object" || typeof Y == "function") ? Y : Q;
            }
            function F(Q, Y) {
              if (typeof Y != "function" && Y !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof Y);
              Q.prototype = Object.create(Y && Y.prototype, { constructor: { value: Q, enumerable: !1, writable: !0, configurable: !0 } }), Y && (Object.setPrototypeOf ? Object.setPrototypeOf(Q, Y) : Q.__proto__ = Y);
            }
            var X = function(Q) {
              F(Y, Q);
              function Y() {
                return G(this, Y), k(this, (Y.__proto__ || Object.getPrototypeOf(Y)).apply(this, arguments));
              }
              return d(Y, [{
                key: "replaceWith",
                value: function(oe) {
                  this.domNode.textContent = this.domNode.textContent, this.attach(), m(Y.prototype.__proto__ || Object.getPrototypeOf(Y.prototype), "replaceWith", this).call(this, oe);
                }
              }, {
                key: "highlight",
                value: function(oe) {
                  var ne = this.domNode.textContent;
                  this.cachedText !== ne && ((ne.trim().length > 0 || this.cachedText == null) && (this.domNode.innerHTML = oe(ne), this.domNode.normalize(), this.attach()), this.cachedText = ne);
                }
              }]), Y;
            }(V.default);
            X.className = "ql-syntax";
            var ee = new S.default.Attributor.Class("token", "hljs", {
              scope: S.default.Scope.INLINE
            }), ue = function(Q) {
              F(Y, Q), d(Y, null, [{
                key: "register",
                value: function() {
                  E.default.register(ee, !0), E.default.register(X, !0);
                }
              }]);
              function Y(pe, oe) {
                G(this, Y);
                var ne = k(this, (Y.__proto__ || Object.getPrototypeOf(Y)).call(this, pe, oe));
                if (typeof ne.options.highlight != "function")
                  throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
                var H = null;
                return ne.quill.on(E.default.events.SCROLL_OPTIMIZE, function() {
                  clearTimeout(H), H = setTimeout(function() {
                    ne.highlight(), H = null;
                  }, ne.options.interval);
                }), ne.highlight(), ne;
              }
              return d(Y, [{
                key: "highlight",
                value: function() {
                  var oe = this;
                  if (!this.quill.selection.composing) {
                    this.quill.update(E.default.sources.USER);
                    var ne = this.quill.getSelection();
                    this.quill.scroll.descendants(X).forEach(function(H) {
                      H.highlight(oe.options.highlight);
                    }), this.quill.update(E.default.sources.SILENT), ne != null && this.quill.setSelection(ne, E.default.sources.SILENT);
                  }
                }
              }]), Y;
            }(T.default);
            ue.DEFAULTS = {
              highlight: function() {
                return window.hljs == null ? null : function(Q) {
                  var Y = window.hljs.highlightAuto(Q);
                  return Y.value;
                };
              }(),
              interval: 1e3
            }, u.CodeBlock = X, u.CodeToken = ee, u.default = ue;
          },
          /* 76 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>';
          },
          /* 77 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>';
          },
          /* 78 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>';
          },
          /* 79 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>';
          },
          /* 80 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>';
          },
          /* 81 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>';
          },
          /* 82 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>';
          },
          /* 83 */
          /***/
          function(o, u) {
            o.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>';
          },
          /* 84 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>';
          },
          /* 85 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>';
          },
          /* 86 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>';
          },
          /* 87 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>';
          },
          /* 88 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>';
          },
          /* 89 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>';
          },
          /* 90 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>';
          },
          /* 91 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>';
          },
          /* 92 */
          /***/
          function(o, u) {
            o.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>';
          },
          /* 93 */
          /***/
          function(o, u) {
            o.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>';
          },
          /* 94 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>';
          },
          /* 95 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>';
          },
          /* 96 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>';
          },
          /* 97 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>';
          },
          /* 98 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>';
          },
          /* 99 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>';
          },
          /* 100 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>';
          },
          /* 101 */
          /***/
          function(o, u) {
            o.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>';
          },
          /* 102 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>';
          },
          /* 103 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>';
          },
          /* 104 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>';
          },
          /* 105 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>';
          },
          /* 106 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>';
          },
          /* 107 */
          /***/
          function(o, u) {
            o.exports = '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>';
          },
          /* 108 */
          /***/
          function(o, u, c) {
            Object.defineProperty(u, "__esModule", {
              value: !0
            }), u.default = u.BubbleTooltip = void 0;
            var d = function Y(pe, oe, ne) {
              pe === null && (pe = Function.prototype);
              var H = Object.getOwnPropertyDescriptor(pe, oe);
              if (H === void 0) {
                var C = Object.getPrototypeOf(pe);
                return C === null ? void 0 : Y(C, oe, ne);
              } else {
                if ("value" in H)
                  return H.value;
                var w = H.get;
                return w === void 0 ? void 0 : w.call(ne);
              }
            }, m = function() {
              function Y(pe, oe) {
                for (var ne = 0; ne < oe.length; ne++) {
                  var H = oe[ne];
                  H.enumerable = H.enumerable || !1, H.configurable = !0, "value" in H && (H.writable = !0), Object.defineProperty(pe, H.key, H);
                }
              }
              return function(pe, oe, ne) {
                return oe && Y(pe.prototype, oe), ne && Y(pe, ne), pe;
              };
            }(), v = c(3), S = G(v), $ = c(8), E = G($), O = c(43), T = G(O), y = c(15), V = c(41), M = G(V);
            function G(Y) {
              return Y && Y.__esModule ? Y : { default: Y };
            }
            function k(Y, pe) {
              if (!(Y instanceof pe))
                throw new TypeError("Cannot call a class as a function");
            }
            function F(Y, pe) {
              if (!Y)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return pe && (typeof pe == "object" || typeof pe == "function") ? pe : Y;
            }
            function X(Y, pe) {
              if (typeof pe != "function" && pe !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof pe);
              Y.prototype = Object.create(pe && pe.prototype, { constructor: { value: Y, enumerable: !1, writable: !0, configurable: !0 } }), pe && (Object.setPrototypeOf ? Object.setPrototypeOf(Y, pe) : Y.__proto__ = pe);
            }
            var ee = [["bold", "italic", "link"], [{ header: 1 }, { header: 2 }, "blockquote"]], ue = function(Y) {
              X(pe, Y);
              function pe(oe, ne) {
                k(this, pe), ne.modules.toolbar != null && ne.modules.toolbar.container == null && (ne.modules.toolbar.container = ee);
                var H = F(this, (pe.__proto__ || Object.getPrototypeOf(pe)).call(this, oe, ne));
                return H.quill.container.classList.add("ql-bubble"), H;
              }
              return m(pe, [{
                key: "extendToolbar",
                value: function(ne) {
                  this.tooltip = new Q(this.quill, this.options.bounds), this.tooltip.root.appendChild(ne.container), this.buildButtons([].slice.call(ne.container.querySelectorAll("button")), M.default), this.buildPickers([].slice.call(ne.container.querySelectorAll("select")), M.default);
                }
              }]), pe;
            }(T.default);
            ue.DEFAULTS = (0, S.default)(!0, {}, T.default.DEFAULTS, {
              modules: {
                toolbar: {
                  handlers: {
                    link: function(pe) {
                      pe ? this.quill.theme.tooltip.edit() : this.quill.format("link", !1);
                    }
                  }
                }
              }
            });
            var Q = function(Y) {
              X(pe, Y);
              function pe(oe, ne) {
                k(this, pe);
                var H = F(this, (pe.__proto__ || Object.getPrototypeOf(pe)).call(this, oe, ne));
                return H.quill.on(E.default.events.EDITOR_CHANGE, function(C, w, P, J) {
                  if (C === E.default.events.SELECTION_CHANGE)
                    if (w != null && w.length > 0 && J === E.default.sources.USER) {
                      H.show(), H.root.style.left = "0px", H.root.style.width = "", H.root.style.width = H.root.offsetWidth + "px";
                      var se = H.quill.getLines(w.index, w.length);
                      if (se.length === 1)
                        H.position(H.quill.getBounds(w));
                      else {
                        var fe = se[se.length - 1], N = H.quill.getIndex(fe), W = Math.min(fe.length() - 1, w.index + w.length - N), I = H.quill.getBounds(new y.Range(N, W));
                        H.position(I);
                      }
                    } else
                      document.activeElement !== H.textbox && H.quill.hasFocus() && H.hide();
                }), H;
              }
              return m(pe, [{
                key: "listen",
                value: function() {
                  var ne = this;
                  d(pe.prototype.__proto__ || Object.getPrototypeOf(pe.prototype), "listen", this).call(this), this.root.querySelector(".ql-close").addEventListener("click", function() {
                    ne.root.classList.remove("ql-editing");
                  }), this.quill.on(E.default.events.SCROLL_OPTIMIZE, function() {
                    setTimeout(function() {
                      if (!ne.root.classList.contains("ql-hidden")) {
                        var H = ne.quill.getSelection();
                        H != null && ne.position(ne.quill.getBounds(H));
                      }
                    }, 1);
                  });
                }
              }, {
                key: "cancel",
                value: function() {
                  this.show();
                }
              }, {
                key: "position",
                value: function(ne) {
                  var H = d(pe.prototype.__proto__ || Object.getPrototypeOf(pe.prototype), "position", this).call(this, ne), C = this.root.querySelector(".ql-tooltip-arrow");
                  if (C.style.marginLeft = "", H === 0)
                    return H;
                  C.style.marginLeft = -1 * H - C.offsetWidth / 2 + "px";
                }
              }]), pe;
            }(O.BaseTooltip);
            Q.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join(""), u.BubbleTooltip = Q, u.default = ue;
          },
          /* 109 */
          /***/
          function(o, u, c) {
            o.exports = c(63);
          }
          /******/
        ]).default
      );
    });
  }(quill)), quill.exports;
}
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(vue_runtime_esmBundler);
(function(e) {
  e.exports = /******/
  function(n) {
    var o = {};
    function u(c) {
      if (o[c])
        return o[c].exports;
      var d = o[c] = {
        /******/
        i: c,
        /******/
        l: !1,
        /******/
        exports: {}
        /******/
      };
      return n[c].call(d.exports, d, d.exports, u), d.l = !0, d.exports;
    }
    return u.m = n, u.c = o, u.d = function(c, d, m) {
      u.o(c, d) || Object.defineProperty(c, d, { enumerable: !0, get: m });
    }, u.r = function(c) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(c, "__esModule", { value: !0 });
    }, u.t = function(c, d) {
      if (d & 1 && (c = u(c)), d & 8 || d & 4 && typeof c == "object" && c && c.__esModule)
        return c;
      var m = /* @__PURE__ */ Object.create(null);
      if (u.r(m), Object.defineProperty(m, "default", { enumerable: !0, value: c }), d & 2 && typeof c != "string")
        for (var v in c)
          u.d(m, v, function(S) {
            return c[S];
          }.bind(null, v));
      return m;
    }, u.n = function(c) {
      var d = c && c.__esModule ? (
        /******/
        function() {
          return c.default;
        }
      ) : (
        /******/
        function() {
          return c;
        }
      );
      return u.d(d, "a", d), d;
    }, u.o = function(c, d) {
      return Object.prototype.hasOwnProperty.call(c, d);
    }, u.p = "", u(u.s = "fb15");
  }({
    /***/
    "00ee": (
      /***/
      function(n, o, u) {
        var c = u("b622"), d = c("toStringTag"), m = {};
        m[d] = "z", n.exports = String(m) === "[object z]";
      }
    ),
    /***/
    "0366": (
      /***/
      function(n, o, u) {
        var c = u("1c0b");
        n.exports = function(d, m, v) {
          if (c(d), m === void 0)
            return d;
          switch (v) {
            case 0:
              return function() {
                return d.call(m);
              };
            case 1:
              return function(S) {
                return d.call(m, S);
              };
            case 2:
              return function(S, $) {
                return d.call(m, S, $);
              };
            case 3:
              return function(S, $, E) {
                return d.call(m, S, $, E);
              };
          }
          return function() {
            return d.apply(m, arguments);
          };
        };
      }
    ),
    /***/
    "0538": (
      /***/
      function(n, o, u) {
        var c = u("1c0b"), d = u("861d"), m = [].slice, v = {}, S = function($, E, O) {
          if (!(E in v)) {
            for (var T = [], y = 0; y < E; y++)
              T[y] = "a[" + y + "]";
            v[E] = Function("C,a", "return new C(" + T.join(",") + ")");
          }
          return v[E]($, O);
        };
        n.exports = Function.bind || function(E) {
          var O = c(this), T = m.call(arguments, 1), y = function() {
            var M = T.concat(m.call(arguments));
            return this instanceof y ? S(O, M.length, M) : O.apply(E, M);
          };
          return d(O.prototype) && (y.prototype = O.prototype), y;
        };
      }
    ),
    /***/
    "057f": (
      /***/
      function(n, o, u) {
        var c = u("fc6a"), d = u("241c").f, m = {}.toString, v = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], S = function($) {
          try {
            return d($);
          } catch {
            return v.slice();
          }
        };
        n.exports.f = function(E) {
          return v && m.call(E) == "[object Window]" ? S(E) : d(c(E));
        };
      }
    ),
    /***/
    "06cf": (
      /***/
      function(n, o, u) {
        var c = u("83ab"), d = u("d1e7"), m = u("5c6c"), v = u("fc6a"), S = u("c04e"), $ = u("5135"), E = u("0cfb"), O = Object.getOwnPropertyDescriptor;
        o.f = c ? O : function(y, V) {
          if (y = v(y), V = S(V, !0), E)
            try {
              return O(y, V);
            } catch {
            }
          if ($(y, V))
            return m(!d.f.call(y, V), y[V]);
        };
      }
    ),
    /***/
    "0cfb": (
      /***/
      function(n, o, u) {
        var c = u("83ab"), d = u("d039"), m = u("cc12");
        n.exports = !c && !d(function() {
          return Object.defineProperty(m("div"), "a", {
            get: function() {
              return 7;
            }
          }).a != 7;
        });
      }
    ),
    /***/
    "0d26": (
      /***/
      function(n, o, u) {
        var c = u("24fb");
        o = c(!1), o.push([n.i, `/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;-o-tab-size:4;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:"\\2022"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:"\\2611"}.ql-editor ul[data-checked=false]>li:before{content:"\\2610"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) ". "}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) ". "}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) ". "}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) ". "}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) ". "}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) ". "}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) ". "}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) ". "}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) ". "}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) ". "}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.ql-snow.ql-toolbar:after,.ql-snow .ql-toolbar:after{clear:both;content:"";display:table}.ql-snow.ql-toolbar button,.ql-snow .ql-toolbar button{background:none;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-snow.ql-toolbar button svg,.ql-snow .ql-toolbar button svg{float:left;height:100%}.ql-snow.ql-toolbar button:active:hover,.ql-snow .ql-toolbar button:active:hover{outline:none}.ql-snow.ql-toolbar input.ql-image[type=file],.ql-snow .ql-toolbar input.ql-image[type=file]{display:none}.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar button:focus,.ql-snow .ql-toolbar button:focus,.ql-snow.ql-toolbar button:hover,.ql-snow .ql-toolbar button:hover{color:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill{fill:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke-miter{stroke:#06c}@media (pointer:coarse){.ql-snow.ql-toolbar button:hover:not(.ql-active),.ql-snow .ql-toolbar button:hover:not(.ql-active){color:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#444}}.ql-snow,.ql-snow *{box-sizing:border-box}.ql-snow .ql-hidden{display:none}.ql-snow .ql-out-bottom,.ql-snow .ql-out-top{visibility:hidden}.ql-snow .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-snow .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-snow .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-snow .ql-formats{display:inline-block;vertical-align:middle}.ql-snow .ql-formats:after{clear:both;content:"";display:table}.ql-snow .ql-stroke{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-snow .ql-stroke-miter{fill:none;stroke:#444;stroke-miterlimit:10;stroke-width:2}.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-empty{fill:none}.ql-snow .ql-even{fill-rule:evenodd}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1}.ql-snow .ql-transparent{opacity:.4}.ql-snow .ql-direction svg:last-child{display:none}.ql-snow .ql-direction.ql-active svg:last-child{display:inline}.ql-snow .ql-direction.ql-active svg:first-child{display:none}.ql-snow .ql-editor h1{font-size:2em}.ql-snow .ql-editor h2{font-size:1.5em}.ql-snow .ql-editor h3{font-size:1.17em}.ql-snow .ql-editor h4{font-size:1em}.ql-snow .ql-editor h5{font-size:.83em}.ql-snow .ql-editor h6{font-size:.67em}.ql-snow .ql-editor a{text-decoration:underline}.ql-snow .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-snow .ql-editor code,.ql-snow .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-snow .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-snow .ql-editor code{font-size:85%;padding:2px 4px}.ql-snow .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-snow .ql-editor img{max-width:100%}.ql-snow .ql-picker{color:#444;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-snow .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-snow .ql-picker-label:before{display:inline-block;line-height:22px}.ql-snow .ql-picker-options{background-color:#fff;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-snow .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-snow .ql-picker.ql-expanded .ql-picker-label{color:#ccc;z-index:2}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker{width:28px}.ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg{right:4px}.ql-snow .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-snow .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-snow .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""]):before{content:attr(data-label)}.ql-snow .ql-picker.ql-header{width:98px}.ql-snow .ql-picker.ql-header .ql-picker-item:before,.ql-snow .ql-picker.ql-header .ql-picker-label:before{content:"Normal"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]:before{content:"Heading 1"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]:before{content:"Heading 2"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]:before{content:"Heading 3"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]:before{content:"Heading 4"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]:before{content:"Heading 5"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]:before{content:"Heading 6"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before{font-size:2em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before{font-size:1.5em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before{font-size:1.17em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before{font-size:1em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before{font-size:.83em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before{font-size:.67em}.ql-snow .ql-picker.ql-font{width:108px}.ql-snow .ql-picker.ql-font .ql-picker-item:before,.ql-snow .ql-picker.ql-font .ql-picker-label:before{content:"Sans Serif"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before{content:"Serif"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before{content:"Monospace"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{font-family:Georgia,Times New Roman,serif}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{font-family:Monaco,Courier New,monospace}.ql-snow .ql-picker.ql-size{width:98px}.ql-snow .ql-picker.ql-size .ql-picker-item:before,.ql-snow .ql-picker.ql-size .ql-picker-label:before{content:"Normal"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before{content:"Small"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before{content:"Large"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before{content:"Huge"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before{font-size:10px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before{font-size:18px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{font-size:32px}.ql-snow .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-snow .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-toolbar.ql-snow{border:1px solid #ccc;box-sizing:border-box;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:8px}.ql-toolbar.ql-snow .ql-formats{margin-right:15px}.ql-toolbar.ql-snow .ql-picker-label{border:1px solid transparent}.ql-toolbar.ql-snow .ql-picker-options{border:1px solid transparent;box-shadow:0 2px 8px rgba(0,0,0,.2)}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color:#ccc}.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover{border-color:#000}.ql-toolbar.ql-snow+.ql-container.ql-snow{border-top:0}.ql-snow .ql-tooltip{background-color:#fff;border:1px solid #ccc;box-shadow:0 0 5px #ddd;color:#444;padding:5px 12px;white-space:nowrap}.ql-snow .ql-tooltip:before{content:"Visit URL:";line-height:26px;margin-right:8px}.ql-snow .ql-tooltip input[type=text]{display:none;border:1px solid #ccc;font-size:13px;height:26px;margin:0;padding:3px 5px;width:170px}.ql-snow .ql-tooltip a.ql-preview{display:inline-block;max-width:200px;overflow-x:hidden;text-overflow:ellipsis;vertical-align:top}.ql-snow .ql-tooltip a.ql-action:after{border-right:1px solid #ccc;content:"Edit";margin-left:16px;padding-right:8px}.ql-snow .ql-tooltip a.ql-remove:before{content:"Remove";margin-left:8px}.ql-snow .ql-tooltip a{line-height:26px}.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove{display:none}.ql-snow .ql-tooltip.ql-editing input[type=text]{display:inline-block}.ql-snow .ql-tooltip.ql-editing a.ql-action:after{border-right:0;content:"Save";padding-right:0}.ql-snow .ql-tooltip[data-mode=link]:before{content:"Enter link:"}.ql-snow .ql-tooltip[data-mode=formula]:before{content:"Enter formula:"}.ql-snow .ql-tooltip[data-mode=video]:before{content:"Enter video:"}.ql-snow a{color:#06c}.ql-container.ql-snow{border:1px solid #ccc}`, ""]), n.exports = o;
      }
    ),
    /***/
    "129f": (
      /***/
      function(n, o) {
        n.exports = Object.is || function(c, d) {
          return c === d ? c !== 0 || 1 / c === 1 / d : c != c && d != d;
        };
      }
    ),
    /***/
    "14c3": (
      /***/
      function(n, o, u) {
        var c = u("c6b6"), d = u("9263");
        n.exports = function(m, v) {
          var S = m.exec;
          if (typeof S == "function") {
            var $ = S.call(m, v);
            if (typeof $ != "object")
              throw TypeError("RegExp exec method returned something other than an Object or null");
            return $;
          }
          if (c(m) !== "RegExp")
            throw TypeError("RegExp#exec called on incompatible receiver");
          return d.call(m, v);
        };
      }
    ),
    /***/
    "159b": (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("fdbc"), m = u("17c2"), v = u("9112");
        for (var S in d) {
          var $ = c[S], E = $ && $.prototype;
          if (E && E.forEach !== m)
            try {
              v(E, "forEach", m);
            } catch {
              E.forEach = m;
            }
        }
      }
    ),
    /***/
    "17c2": (
      /***/
      function(n, o, u) {
        var c = u("b727").forEach, d = u("a640"), m = u("ae40"), v = d("forEach"), S = m("forEach");
        n.exports = !v || !S ? function(E) {
          return c(this, E, arguments.length > 1 ? arguments[1] : void 0);
        } : [].forEach;
      }
    ),
    /***/
    "1be4": (
      /***/
      function(n, o, u) {
        var c = u("d066");
        n.exports = c("document", "documentElement");
      }
    ),
    /***/
    "1c0b": (
      /***/
      function(n, o) {
        n.exports = function(u) {
          if (typeof u != "function")
            throw TypeError(String(u) + " is not a function");
          return u;
        };
      }
    ),
    /***/
    "1c7e": (
      /***/
      function(n, o, u) {
        var c = u("b622"), d = c("iterator"), m = !1;
        try {
          var v = 0, S = {
            next: function() {
              return { done: !!v++ };
            },
            return: function() {
              m = !0;
            }
          };
          S[d] = function() {
            return this;
          }, Array.from(S, function() {
            throw 2;
          });
        } catch {
        }
        n.exports = function($, E) {
          if (!E && !m)
            return !1;
          var O = !1;
          try {
            var T = {};
            T[d] = function() {
              return {
                next: function() {
                  return { done: O = !0 };
                }
              };
            }, $(T);
          } catch {
          }
          return O;
        };
      }
    ),
    /***/
    "1d80": (
      /***/
      function(n, o) {
        n.exports = function(u) {
          if (u == null)
            throw TypeError("Can't call method on " + u);
          return u;
        };
      }
    ),
    /***/
    "1dde": (
      /***/
      function(n, o, u) {
        var c = u("d039"), d = u("b622"), m = u("2d00"), v = d("species");
        n.exports = function(S) {
          return m >= 51 || !c(function() {
            var $ = [], E = $.constructor = {};
            return E[v] = function() {
              return { foo: 1 };
            }, $[S](Boolean).foo !== 1;
          });
        };
      }
    ),
    /***/
    "23cb": (
      /***/
      function(n, o, u) {
        var c = u("a691"), d = Math.max, m = Math.min;
        n.exports = function(v, S) {
          var $ = c(v);
          return $ < 0 ? d($ + S, 0) : m($, S);
        };
      }
    ),
    /***/
    "23e7": (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("06cf").f, m = u("9112"), v = u("6eeb"), S = u("ce4e"), $ = u("e893"), E = u("94ca");
        n.exports = function(O, T) {
          var y = O.target, V = O.global, M = O.stat, G, k, F, X, ee, ue;
          if (V ? k = c : M ? k = c[y] || S(y, {}) : k = (c[y] || {}).prototype, k)
            for (F in T) {
              if (ee = T[F], O.noTargetGet ? (ue = d(k, F), X = ue && ue.value) : X = k[F], G = E(V ? F : y + (M ? "." : "#") + F, O.forced), !G && X !== void 0) {
                if (typeof ee == typeof X)
                  continue;
                $(ee, X);
              }
              (O.sham || X && X.sham) && m(ee, "sham", !0), v(k, F, ee, O);
            }
        };
      }
    ),
    /***/
    "241c": (
      /***/
      function(n, o, u) {
        var c = u("ca84"), d = u("7839"), m = d.concat("length", "prototype");
        o.f = Object.getOwnPropertyNames || function(S) {
          return c(S, m);
        };
      }
    ),
    /***/
    "24fb": (
      /***/
      function(n, o, u) {
        n.exports = function(m) {
          var v = [];
          return v.toString = function() {
            return this.map(function($) {
              var E = c($, m);
              return $[2] ? "@media ".concat($[2], " {").concat(E, "}") : E;
            }).join("");
          }, v.i = function(S, $, E) {
            typeof S == "string" && (S = [[null, S, ""]]);
            var O = {};
            if (E)
              for (var T = 0; T < this.length; T++) {
                var y = this[T][0];
                y != null && (O[y] = !0);
              }
            for (var V = 0; V < S.length; V++) {
              var M = [].concat(S[V]);
              E && O[M[0]] || ($ && (M[2] ? M[2] = "".concat($, " and ").concat(M[2]) : M[2] = $), v.push(M));
            }
          }, v;
        };
        function c(m, v) {
          var S = m[1] || "", $ = m[3];
          if (!$)
            return S;
          if (v && typeof btoa == "function") {
            var E = d($), O = $.sources.map(function(T) {
              return "/*# sourceURL=".concat($.sourceRoot || "").concat(T, " */");
            });
            return [S].concat(O).concat([E]).join(`
`);
          }
          return [S].join(`
`);
        }
        function d(m) {
          var v = btoa(unescape(encodeURIComponent(JSON.stringify(m)))), S = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(v);
          return "/*# ".concat(S, " */");
        }
      }
    ),
    /***/
    "25f0": (
      /***/
      function(n, o, u) {
        var c = u("6eeb"), d = u("825a"), m = u("d039"), v = u("ad6d"), S = "toString", $ = RegExp.prototype, E = $[S], O = m(function() {
          return E.call({ source: "a", flags: "b" }) != "/a/b";
        }), T = E.name != S;
        (O || T) && c(RegExp.prototype, S, function() {
          var V = d(this), M = String(V.source), G = V.flags, k = String(G === void 0 && V instanceof RegExp && !("flags" in $) ? v.call(V) : G);
          return "/" + M + "/" + k;
        }, { unsafe: !0 });
      }
    ),
    /***/
    "261e": (
      /***/
      function(n, o, u) {
        var c = u("24fb");
        o = c(!1), o.push([n.i, ".ql-editor{min-height:200px;font-size:16px}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1px!important}.quillWrapper .ql-snow.ql-toolbar{padding-top:8px;padding-bottom:4px}.quillWrapper .ql-snow.ql-toolbar .ql-formats{margin-bottom:10px}.ql-snow .ql-toolbar button svg,.quillWrapper .ql-snow.ql-toolbar button svg{width:22px;height:22px}.quillWrapper .ql-editor ul[data-checked=false]>li:before,.quillWrapper .ql-editor ul[data-checked=true]>li:before{font-size:1.35em;vertical-align:baseline;bottom:-.065em;font-weight:900;color:#222}.quillWrapper .ql-snow .ql-stroke{stroke:rgba(63,63,63,.95);stroke-linecap:square;stroke-linejoin:initial;stroke-width:1.7px}.quillWrapper .ql-picker-label{font-size:15px}.quillWrapper .ql-snow .ql-active .ql-stroke{stroke-width:2.25px}.quillWrapper .ql-toolbar.ql-snow .ql-formats{vertical-align:top}.ql-picker:not(.ql-background){position:relative;top:2px}.ql-picker.ql-color-picker svg{width:22px!important;height:22px!important}.quillWrapper .imageResizeActive img{display:block;cursor:pointer}.quillWrapper .imageResizeActive~div svg{cursor:pointer}", ""]), n.exports = o;
      }
    ),
    /***/
    "2ca0": (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("06cf").f, m = u("50c4"), v = u("5a34"), S = u("1d80"), $ = u("ab13"), E = u("c430"), O = "".startsWith, T = Math.min, y = $("startsWith"), V = !E && !y && !!function() {
          var M = d(String.prototype, "startsWith");
          return M && !M.writable;
        }();
        c({ target: "String", proto: !0, forced: !V && !y }, {
          startsWith: function(G) {
            var k = String(S(this));
            v(G);
            var F = m(T(arguments.length > 1 ? arguments[1] : void 0, k.length)), X = String(G);
            return O ? O.call(k, X, F) : k.slice(F, F + X.length) === X;
          }
        });
      }
    ),
    /***/
    "2d00": (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("342f"), m = c.process, v = m && m.versions, S = v && v.v8, $, E;
        S ? ($ = S.split("."), E = $[0] + $[1]) : d && ($ = d.match(/Edge\/(\d+)/), (!$ || $[1] >= 74) && ($ = d.match(/Chrome\/(\d+)/), $ && (E = $[1]))), n.exports = E && +E;
      }
    ),
    /***/
    3410: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("d039"), m = u("7b0b"), v = u("e163"), S = u("e177"), $ = d(function() {
          v(1);
        });
        c({ target: "Object", stat: !0, forced: $, sham: !S }, {
          getPrototypeOf: function(O) {
            return v(m(O));
          }
        });
      }
    ),
    /***/
    "342f": (
      /***/
      function(n, o, u) {
        var c = u("d066");
        n.exports = c("navigator", "userAgent") || "";
      }
    ),
    /***/
    "35a1": (
      /***/
      function(n, o, u) {
        var c = u("f5df"), d = u("3f8c"), m = u("b622"), v = m("iterator");
        n.exports = function(S) {
          if (S != null)
            return S[v] || S["@@iterator"] || d[c(S)];
        };
      }
    ),
    /***/
    "37e8": (
      /***/
      function(n, o, u) {
        var c = u("83ab"), d = u("9bf2"), m = u("825a"), v = u("df75");
        n.exports = c ? Object.defineProperties : function($, E) {
          m($);
          for (var O = v(E), T = O.length, y = 0, V; T > y; )
            d.f($, V = O[y++], E[V]);
          return $;
        };
      }
    ),
    /***/
    "3bbe": (
      /***/
      function(n, o, u) {
        var c = u("861d");
        n.exports = function(d) {
          if (!c(d) && d !== null)
            throw TypeError("Can't set " + String(d) + " as a prototype");
          return d;
        };
      }
    ),
    /***/
    "3ca3": (
      /***/
      function(n, o, u) {
        var c = u("6547").charAt, d = u("69f3"), m = u("7dd0"), v = "String Iterator", S = d.set, $ = d.getterFor(v);
        m(String, "String", function(E) {
          S(this, {
            type: v,
            string: String(E),
            index: 0
          });
        }, function() {
          var O = $(this), T = O.string, y = O.index, V;
          return y >= T.length ? { value: void 0, done: !0 } : (V = c(T, y), O.index += V.length, { value: V, done: !1 });
        });
      }
    ),
    /***/
    "3f8c": (
      /***/
      function(n, o) {
        n.exports = {};
      }
    ),
    /***/
    4160: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("17c2");
        c({ target: "Array", proto: !0, forced: [].forEach != d }, {
          forEach: d
        });
      }
    ),
    /***/
    "428f": (
      /***/
      function(n, o, u) {
        var c = u("da84");
        n.exports = c;
      }
    ),
    /***/
    "44ad": (
      /***/
      function(n, o, u) {
        var c = u("d039"), d = u("c6b6"), m = "".split;
        n.exports = c(function() {
          return !Object("z").propertyIsEnumerable(0);
        }) ? function(v) {
          return d(v) == "String" ? m.call(v, "") : Object(v);
        } : Object;
      }
    ),
    /***/
    "44d2": (
      /***/
      function(n, o, u) {
        var c = u("b622"), d = u("7c73"), m = u("9bf2"), v = c("unscopables"), S = Array.prototype;
        S[v] == null && m.f(S, v, {
          configurable: !0,
          value: d(null)
        }), n.exports = function($) {
          S[v][$] = !0;
        };
      }
    ),
    /***/
    "44e7": (
      /***/
      function(n, o, u) {
        var c = u("861d"), d = u("c6b6"), m = u("b622"), v = m("match");
        n.exports = function(S) {
          var $;
          return c(S) && (($ = S[v]) !== void 0 ? !!$ : d(S) == "RegExp");
        };
      }
    ),
    /***/
    "466d": (
      /***/
      function(n, o, u) {
        var c = u("d784"), d = u("825a"), m = u("50c4"), v = u("1d80"), S = u("8aa5"), $ = u("14c3");
        c("match", 1, function(E, O, T) {
          return [
            // `String.prototype.match` method
            // https://tc39.github.io/ecma262/#sec-string.prototype.match
            function(V) {
              var M = v(this), G = V == null ? void 0 : V[E];
              return G !== void 0 ? G.call(V, M) : new RegExp(V)[E](String(M));
            },
            // `RegExp.prototype[@@match]` method
            // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
            function(y) {
              var V = T(O, y, this);
              if (V.done)
                return V.value;
              var M = d(y), G = String(this);
              if (!M.global)
                return $(M, G);
              var k = M.unicode;
              M.lastIndex = 0;
              for (var F = [], X = 0, ee; (ee = $(M, G)) !== null; ) {
                var ue = String(ee[0]);
                F[X] = ue, ue === "" && (M.lastIndex = S(G, m(M.lastIndex), k)), X++;
              }
              return X === 0 ? null : F;
            }
          ];
        });
      }
    ),
    /***/
    4930: (
      /***/
      function(n, o, u) {
        var c = u("d039");
        n.exports = !!Object.getOwnPropertySymbols && !c(function() {
          return !String(Symbol());
        });
      }
    ),
    /***/
    "499e": (
      /***/
      function(n, o, u) {
        u.r(o), u.d(o, "default", function() {
          return (
            /* binding */
            M
          );
        });
        function c(Q, Y) {
          for (var pe = [], oe = {}, ne = 0; ne < Y.length; ne++) {
            var H = Y[ne], C = H[0], w = H[1], P = H[2], J = H[3], se = {
              id: Q + ":" + ne,
              css: w,
              media: P,
              sourceMap: J
            };
            oe[C] ? oe[C].parts.push(se) : pe.push(oe[C] = { id: C, parts: [se] });
          }
          return pe;
        }
        var d = typeof document < "u";
        if (typeof DEBUG < "u" && DEBUG && !d)
          throw new Error(
            "vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
          );
        var m = {
          /*
            [id: number]: {
              id: number,
              refs: number,
              parts: Array<(obj?: StyleObjectPart) => void>
            }
          */
        }, v = d && (document.head || document.getElementsByTagName("head")[0]), S = null, $ = 0, E = !1, O = function() {
        }, T = null, y = "data-vue-ssr-id", V = typeof navigator < "u" && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());
        function M(Q, Y, pe, oe) {
          E = pe, T = oe || {};
          var ne = c(Q, Y);
          return G(ne), function(C) {
            for (var w = [], P = 0; P < ne.length; P++) {
              var J = ne[P], se = m[J.id];
              se.refs--, w.push(se);
            }
            C ? (ne = c(Q, C), G(ne)) : ne = [];
            for (var P = 0; P < w.length; P++) {
              var se = w[P];
              if (se.refs === 0) {
                for (var fe = 0; fe < se.parts.length; fe++)
                  se.parts[fe]();
                delete m[se.id];
              }
            }
          };
        }
        function G(Q) {
          for (var Y = 0; Y < Q.length; Y++) {
            var pe = Q[Y], oe = m[pe.id];
            if (oe) {
              oe.refs++;
              for (var ne = 0; ne < oe.parts.length; ne++)
                oe.parts[ne](pe.parts[ne]);
              for (; ne < pe.parts.length; ne++)
                oe.parts.push(F(pe.parts[ne]));
              oe.parts.length > pe.parts.length && (oe.parts.length = pe.parts.length);
            } else {
              for (var H = [], ne = 0; ne < pe.parts.length; ne++)
                H.push(F(pe.parts[ne]));
              m[pe.id] = { id: pe.id, refs: 1, parts: H };
            }
          }
        }
        function k() {
          var Q = document.createElement("style");
          return Q.type = "text/css", v.appendChild(Q), Q;
        }
        function F(Q) {
          var Y, pe, oe = document.querySelector("style[" + y + '~="' + Q.id + '"]');
          if (oe) {
            if (E)
              return O;
            oe.parentNode.removeChild(oe);
          }
          if (V) {
            var ne = $++;
            oe = S || (S = k()), Y = ee.bind(null, oe, ne, !1), pe = ee.bind(null, oe, ne, !0);
          } else
            oe = k(), Y = ue.bind(null, oe), pe = function() {
              oe.parentNode.removeChild(oe);
            };
          return Y(Q), function(C) {
            if (C) {
              if (C.css === Q.css && C.media === Q.media && C.sourceMap === Q.sourceMap)
                return;
              Y(Q = C);
            } else
              pe();
          };
        }
        var X = function() {
          var Q = [];
          return function(Y, pe) {
            return Q[Y] = pe, Q.filter(Boolean).join(`
`);
          };
        }();
        function ee(Q, Y, pe, oe) {
          var ne = pe ? "" : oe.css;
          if (Q.styleSheet)
            Q.styleSheet.cssText = X(Y, ne);
          else {
            var H = document.createTextNode(ne), C = Q.childNodes;
            C[Y] && Q.removeChild(C[Y]), C.length ? Q.insertBefore(H, C[Y]) : Q.appendChild(H);
          }
        }
        function ue(Q, Y) {
          var pe = Y.css, oe = Y.media, ne = Y.sourceMap;
          if (oe && Q.setAttribute("media", oe), T.ssrId && Q.setAttribute(y, Y.id), ne && (pe += `
/*# sourceURL=` + ne.sources[0] + " */", pe += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(ne)))) + " */"), Q.styleSheet)
            Q.styleSheet.cssText = pe;
          else {
            for (; Q.firstChild; )
              Q.removeChild(Q.firstChild);
            Q.appendChild(document.createTextNode(pe));
          }
        }
      }
    ),
    /***/
    "4a60": (
      /***/
      function(n, o, u) {
        var c = u("261e");
        typeof c == "string" && (c = [[n.i, c, ""]]), c.locals && (n.exports = c.locals);
        var d = u("499e").default;
        d("34354984", c, !0, { sourceMap: !1, shadowMode: !1 });
      }
    ),
    /***/
    "4ae1": (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("d066"), m = u("1c0b"), v = u("825a"), S = u("861d"), $ = u("7c73"), E = u("0538"), O = u("d039"), T = d("Reflect", "construct"), y = O(function() {
          function G() {
          }
          return !(T(function() {
          }, [], G) instanceof G);
        }), V = !O(function() {
          T(function() {
          });
        }), M = y || V;
        c({ target: "Reflect", stat: !0, forced: M, sham: M }, {
          construct: function(k, F) {
            m(k), v(F);
            var X = arguments.length < 3 ? k : m(arguments[2]);
            if (V && !y)
              return T(k, F, X);
            if (k == X) {
              switch (F.length) {
                case 0:
                  return new k();
                case 1:
                  return new k(F[0]);
                case 2:
                  return new k(F[0], F[1]);
                case 3:
                  return new k(F[0], F[1], F[2]);
                case 4:
                  return new k(F[0], F[1], F[2], F[3]);
              }
              var ee = [null];
              return ee.push.apply(ee, F), new (E.apply(k, ee))();
            }
            var ue = X.prototype, Q = $(S(ue) ? ue : Object.prototype), Y = Function.apply.call(k, Q, F);
            return S(Y) ? Y : Q;
          }
        });
      }
    ),
    /***/
    "4aea": (
      /***/
      function(n, o, u) {
        u("7781");
      }
    ),
    /***/
    "4d64": (
      /***/
      function(n, o, u) {
        var c = u("fc6a"), d = u("50c4"), m = u("23cb"), v = function(S) {
          return function($, E, O) {
            var T = c($), y = d(T.length), V = m(O, y), M;
            if (S && E != E) {
              for (; y > V; )
                if (M = T[V++], M != M)
                  return !0;
            } else
              for (; y > V; V++)
                if ((S || V in T) && T[V] === E)
                  return S || V || 0;
            return !S && -1;
          };
        };
        n.exports = {
          // `Array.prototype.includes` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.includes
          includes: v(!0),
          // `Array.prototype.indexOf` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
          indexOf: v(!1)
        };
      }
    ),
    /***/
    "4df4": (
      /***/
      function(n, o, u) {
        var c = u("0366"), d = u("7b0b"), m = u("9bdd"), v = u("e95a"), S = u("50c4"), $ = u("8418"), E = u("35a1");
        n.exports = function(T) {
          var y = d(T), V = typeof this == "function" ? this : Array, M = arguments.length, G = M > 1 ? arguments[1] : void 0, k = G !== void 0, F = E(y), X = 0, ee, ue, Q, Y, pe, oe;
          if (k && (G = c(G, M > 2 ? arguments[2] : void 0, 2)), F != null && !(V == Array && v(F)))
            for (Y = F.call(y), pe = Y.next, ue = new V(); !(Q = pe.call(Y)).done; X++)
              oe = k ? m(Y, G, [Q.value, X], !0) : Q.value, $(ue, X, oe);
          else
            for (ee = S(y.length), ue = new V(ee); ee > X; X++)
              oe = k ? G(y[X], X) : y[X], $(ue, X, oe);
          return ue.length = X, ue;
        };
      }
    ),
    /***/
    "50c4": (
      /***/
      function(n, o, u) {
        var c = u("a691"), d = Math.min;
        n.exports = function(m) {
          return m > 0 ? d(c(m), 9007199254740991) : 0;
        };
      }
    ),
    /***/
    5135: (
      /***/
      function(n, o) {
        var u = {}.hasOwnProperty;
        n.exports = function(c, d) {
          return u.call(c, d);
        };
      }
    ),
    /***/
    5692: (
      /***/
      function(n, o, u) {
        var c = u("c430"), d = u("c6cd");
        (n.exports = function(m, v) {
          return d[m] || (d[m] = v !== void 0 ? v : {});
        })("versions", []).push({
          version: "3.6.5",
          mode: c ? "pure" : "global",
          copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
        });
      }
    ),
    /***/
    "56ef": (
      /***/
      function(n, o, u) {
        var c = u("d066"), d = u("241c"), m = u("7418"), v = u("825a");
        n.exports = c("Reflect", "ownKeys") || function($) {
          var E = d.f(v($)), O = m.f;
          return O ? E.concat(O($)) : E;
        };
      }
    ),
    /***/
    "5a34": (
      /***/
      function(n, o, u) {
        var c = u("44e7");
        n.exports = function(d) {
          if (c(d))
            throw TypeError("The method doesn't accept regular expressions");
          return d;
        };
      }
    ),
    /***/
    "5c6c": (
      /***/
      function(n, o) {
        n.exports = function(u, c) {
          return {
            enumerable: !(u & 1),
            configurable: !(u & 2),
            writable: !(u & 4),
            value: c
          };
        };
      }
    ),
    /***/
    "5d41": (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("861d"), m = u("825a"), v = u("5135"), S = u("06cf"), $ = u("e163");
        function E(O, T) {
          var y = arguments.length < 3 ? O : arguments[2], V, M;
          if (m(O) === y)
            return O[T];
          if (V = S.f(O, T))
            return v(V, "value") ? V.value : V.get === void 0 ? void 0 : V.get.call(y);
          if (d(M = $(O)))
            return E(M, T, y);
        }
        c({ target: "Reflect", stat: !0 }, {
          get: E
        });
      }
    ),
    /***/
    "60da": (
      /***/
      function(n, o, u) {
        var c = u("83ab"), d = u("d039"), m = u("df75"), v = u("7418"), S = u("d1e7"), $ = u("7b0b"), E = u("44ad"), O = Object.assign, T = Object.defineProperty;
        n.exports = !O || d(function() {
          if (c && O({ b: 1 }, O(T({}, "a", {
            enumerable: !0,
            get: function() {
              T(this, "b", {
                value: 3,
                enumerable: !1
              });
            }
          }), { b: 2 })).b !== 1)
            return !0;
          var y = {}, V = {}, M = Symbol(), G = "abcdefghijklmnopqrst";
          return y[M] = 7, G.split("").forEach(function(k) {
            V[k] = k;
          }), O({}, y)[M] != 7 || m(O({}, V)).join("") != G;
        }) ? function(V, M) {
          for (var G = $(V), k = arguments.length, F = 1, X = v.f, ee = S.f; k > F; )
            for (var ue = E(arguments[F++]), Q = X ? m(ue).concat(X(ue)) : m(ue), Y = Q.length, pe = 0, oe; Y > pe; )
              oe = Q[pe++], (!c || ee.call(ue, oe)) && (G[oe] = ue[oe]);
          return G;
        } : O;
      }
    ),
    /***/
    6547: (
      /***/
      function(n, o, u) {
        var c = u("a691"), d = u("1d80"), m = function(v) {
          return function(S, $) {
            var E = String(d(S)), O = c($), T = E.length, y, V;
            return O < 0 || O >= T ? v ? "" : void 0 : (y = E.charCodeAt(O), y < 55296 || y > 56319 || O + 1 === T || (V = E.charCodeAt(O + 1)) < 56320 || V > 57343 ? v ? E.charAt(O) : y : v ? E.slice(O, O + 2) : (y - 55296 << 10) + (V - 56320) + 65536);
          };
        };
        n.exports = {
          // `String.prototype.codePointAt` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
          codeAt: m(!1),
          // `String.prototype.at` method
          // https://github.com/mathiasbynens/String.prototype.at
          charAt: m(!0)
        };
      }
    ),
    /***/
    "65f0": (
      /***/
      function(n, o, u) {
        var c = u("861d"), d = u("e8b5"), m = u("b622"), v = m("species");
        n.exports = function(S, $) {
          var E;
          return d(S) && (E = S.constructor, typeof E == "function" && (E === Array || d(E.prototype)) ? E = void 0 : c(E) && (E = E[v], E === null && (E = void 0))), new (E === void 0 ? Array : E)($ === 0 ? 0 : $);
        };
      }
    ),
    /***/
    "69de": (
      /***/
      function(n, o, u) {
        u("4a60");
      }
    ),
    /***/
    "69f3": (
      /***/
      function(n, o, u) {
        var c = u("7f9a"), d = u("da84"), m = u("861d"), v = u("9112"), S = u("5135"), $ = u("f772"), E = u("d012"), O = d.WeakMap, T, y, V, M = function(Q) {
          return V(Q) ? y(Q) : T(Q, {});
        }, G = function(Q) {
          return function(Y) {
            var pe;
            if (!m(Y) || (pe = y(Y)).type !== Q)
              throw TypeError("Incompatible receiver, " + Q + " required");
            return pe;
          };
        };
        if (c) {
          var k = new O(), F = k.get, X = k.has, ee = k.set;
          T = function(Q, Y) {
            return ee.call(k, Q, Y), Y;
          }, y = function(Q) {
            return F.call(k, Q) || {};
          }, V = function(Q) {
            return X.call(k, Q);
          };
        } else {
          var ue = $("state");
          E[ue] = !0, T = function(Q, Y) {
            return v(Q, ue, Y), Y;
          }, y = function(Q) {
            return S(Q, ue) ? Q[ue] : {};
          }, V = function(Q) {
            return S(Q, ue);
          };
        }
        n.exports = {
          set: T,
          get: y,
          has: V,
          enforce: M,
          getterFor: G
        };
      }
    ),
    /***/
    "6c81": (
      /***/
      function(n, o) {
        n.exports = requireQuill();
      }
    ),
    /***/
    "6eeb": (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("9112"), m = u("5135"), v = u("ce4e"), S = u("8925"), $ = u("69f3"), E = $.get, O = $.enforce, T = String(String).split("String");
        (n.exports = function(y, V, M, G) {
          var k = G ? !!G.unsafe : !1, F = G ? !!G.enumerable : !1, X = G ? !!G.noTargetGet : !1;
          if (typeof M == "function" && (typeof V == "string" && !m(M, "name") && d(M, "name", V), O(M).source = T.join(typeof V == "string" ? V : "")), y === c) {
            F ? y[V] = M : v(V, M);
            return;
          } else
            k ? !X && y[V] && (F = !0) : delete y[V];
          F ? y[V] = M : d(y, V, M);
        })(Function.prototype, "toString", function() {
          return typeof this == "function" && E(this).source || S(this);
        });
      }
    ),
    /***/
    7418: (
      /***/
      function(n, o) {
        o.f = Object.getOwnPropertySymbols;
      }
    ),
    /***/
    "746f": (
      /***/
      function(n, o, u) {
        var c = u("428f"), d = u("5135"), m = u("e538"), v = u("9bf2").f;
        n.exports = function(S) {
          var $ = c.Symbol || (c.Symbol = {});
          d($, S) || v($, S, {
            value: m.f(S)
          });
        };
      }
    ),
    /***/
    7781: (
      /***/
      function(n, o, u) {
        var c = u("0d26");
        typeof c == "string" && (c = [[n.i, c, ""]]), c.locals && (n.exports = c.locals);
        var d = u("499e").default;
        d("147ee04a", c, !0, { sourceMap: !1, shadowMode: !1 });
      }
    ),
    /***/
    7839: (
      /***/
      function(n, o) {
        n.exports = [
          "constructor",
          "hasOwnProperty",
          "isPrototypeOf",
          "propertyIsEnumerable",
          "toLocaleString",
          "toString",
          "valueOf"
        ];
      }
    ),
    /***/
    "7b0b": (
      /***/
      function(n, o, u) {
        var c = u("1d80");
        n.exports = function(d) {
          return Object(c(d));
        };
      }
    ),
    /***/
    "7c73": (
      /***/
      function(n, o, u) {
        var c = u("825a"), d = u("37e8"), m = u("7839"), v = u("d012"), S = u("1be4"), $ = u("cc12"), E = u("f772"), O = ">", T = "<", y = "prototype", V = "script", M = E("IE_PROTO"), G = function() {
        }, k = function(Q) {
          return T + V + O + Q + T + "/" + V + O;
        }, F = function(Q) {
          Q.write(k("")), Q.close();
          var Y = Q.parentWindow.Object;
          return Q = null, Y;
        }, X = function() {
          var Q = $("iframe"), Y = "java" + V + ":", pe;
          return Q.style.display = "none", S.appendChild(Q), Q.src = String(Y), pe = Q.contentWindow.document, pe.open(), pe.write(k("document.F=Object")), pe.close(), pe.F;
        }, ee, ue = function() {
          try {
            ee = document.domain && new ActiveXObject("htmlfile");
          } catch {
          }
          ue = ee ? F(ee) : X();
          for (var Q = m.length; Q--; )
            delete ue[y][m[Q]];
          return ue();
        };
        v[M] = !0, n.exports = Object.create || function(Y, pe) {
          var oe;
          return Y !== null ? (G[y] = c(Y), oe = new G(), G[y] = null, oe[M] = Y) : oe = ue(), pe === void 0 ? oe : d(oe, pe);
        };
      }
    ),
    /***/
    "7dd0": (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("9ed3"), m = u("e163"), v = u("d2bb"), S = u("d44e"), $ = u("9112"), E = u("6eeb"), O = u("b622"), T = u("c430"), y = u("3f8c"), V = u("ae93"), M = V.IteratorPrototype, G = V.BUGGY_SAFARI_ITERATORS, k = O("iterator"), F = "keys", X = "values", ee = "entries", ue = function() {
          return this;
        };
        n.exports = function(Q, Y, pe, oe, ne, H, C) {
          d(pe, Y, oe);
          var w = function(Pe) {
            if (Pe === ne && N)
              return N;
            if (!G && Pe in se)
              return se[Pe];
            switch (Pe) {
              case F:
                return function() {
                  return new pe(this, Pe);
                };
              case X:
                return function() {
                  return new pe(this, Pe);
                };
              case ee:
                return function() {
                  return new pe(this, Pe);
                };
            }
            return function() {
              return new pe(this);
            };
          }, P = Y + " Iterator", J = !1, se = Q.prototype, fe = se[k] || se["@@iterator"] || ne && se[ne], N = !G && fe || w(ne), W = Y == "Array" && se.entries || fe, I, te, ge;
          if (W && (I = m(W.call(new Q())), M !== Object.prototype && I.next && (!T && m(I) !== M && (v ? v(I, M) : typeof I[k] != "function" && $(I, k, ue)), S(I, P, !0, !0), T && (y[P] = ue))), ne == X && fe && fe.name !== X && (J = !0, N = function() {
            return fe.call(this);
          }), (!T || C) && se[k] !== N && $(se, k, N), y[Y] = N, ne)
            if (te = {
              values: w(X),
              keys: H ? N : w(F),
              entries: w(ee)
            }, C)
              for (ge in te)
                (G || J || !(ge in se)) && E(se, ge, te[ge]);
            else
              c({ target: Y, proto: !0, forced: G || J }, te);
          return te;
        };
      }
    ),
    /***/
    "7f9a": (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("8925"), m = c.WeakMap;
        n.exports = typeof m == "function" && /native code/.test(d(m));
      }
    ),
    /***/
    "825a": (
      /***/
      function(n, o, u) {
        var c = u("861d");
        n.exports = function(d) {
          if (!c(d))
            throw TypeError(String(d) + " is not an object");
          return d;
        };
      }
    ),
    /***/
    "83ab": (
      /***/
      function(n, o, u) {
        var c = u("d039");
        n.exports = !c(function() {
          return Object.defineProperty({}, 1, { get: function() {
            return 7;
          } })[1] != 7;
        });
      }
    ),
    /***/
    8418: (
      /***/
      function(n, o, u) {
        var c = u("c04e"), d = u("9bf2"), m = u("5c6c");
        n.exports = function(v, S, $) {
          var E = c(S);
          E in v ? d.f(v, E, m(0, $)) : v[E] = $;
        };
      }
    ),
    /***/
    "841c": (
      /***/
      function(n, o, u) {
        var c = u("d784"), d = u("825a"), m = u("1d80"), v = u("129f"), S = u("14c3");
        c("search", 1, function($, E, O) {
          return [
            // `String.prototype.search` method
            // https://tc39.github.io/ecma262/#sec-string.prototype.search
            function(y) {
              var V = m(this), M = y == null ? void 0 : y[$];
              return M !== void 0 ? M.call(y, V) : new RegExp(y)[$](String(V));
            },
            // `RegExp.prototype[@@search]` method
            // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
            function(T) {
              var y = O(E, T, this);
              if (y.done)
                return y.value;
              var V = d(T), M = String(this), G = V.lastIndex;
              v(G, 0) || (V.lastIndex = 0);
              var k = S(V, M);
              return v(V.lastIndex, G) || (V.lastIndex = G), k === null ? -1 : k.index;
            }
          ];
        });
      }
    ),
    /***/
    "861d": (
      /***/
      function(n, o) {
        n.exports = function(u) {
          return typeof u == "object" ? u !== null : typeof u == "function";
        };
      }
    ),
    /***/
    8875: (
      /***/
      function(n, o, u) {
        var c, d, m;
        (function(v, S) {
          d = [], c = S, m = typeof c == "function" ? c.apply(o, d) : c, m !== void 0 && (n.exports = m);
        })(typeof self < "u" ? self : this, function() {
          function v() {
            var S = Object.getOwnPropertyDescriptor(document, "currentScript");
            if (!S && "currentScript" in document && document.currentScript || S && S.get !== v && document.currentScript)
              return document.currentScript;
            try {
              throw new Error();
            } catch (ee) {
              var $ = /.*at [^(]*\((.*):(.+):(.+)\)$/ig, E = /@([^@]*):(\d+):(\d+)\s*$/ig, O = $.exec(ee.stack) || E.exec(ee.stack), T = O && O[1] || !1, y = O && O[2] || !1, V = document.location.href.replace(document.location.hash, ""), M, G, k, F = document.getElementsByTagName("script");
              T === V && (M = document.documentElement.outerHTML, G = new RegExp("(?:[^\\n]+?\\n){0," + (y - 2) + "}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*", "i"), k = M.replace(G, "$1").trim());
              for (var X = 0; X < F.length; X++)
                if (F[X].readyState === "interactive" || F[X].src === T || T === V && F[X].innerHTML && F[X].innerHTML.trim() === k)
                  return F[X];
              return null;
            }
          }
          return v;
        });
      }
    ),
    /***/
    8925: (
      /***/
      function(n, o, u) {
        var c = u("c6cd"), d = Function.toString;
        typeof c.inspectSource != "function" && (c.inspectSource = function(m) {
          return d.call(m);
        }), n.exports = c.inspectSource;
      }
    ),
    /***/
    "8aa5": (
      /***/
      function(n, o, u) {
        var c = u("6547").charAt;
        n.exports = function(d, m, v) {
          return m + (v ? c(d, m).length : 1);
        };
      }
    ),
    /***/
    "8bbf": (
      /***/
      function(n, o) {
        n.exports = require$$1;
      }
    ),
    /***/
    "90e3": (
      /***/
      function(n, o) {
        var u = 0, c = Math.random();
        n.exports = function(d) {
          return "Symbol(" + String(d === void 0 ? "" : d) + ")_" + (++u + c).toString(36);
        };
      }
    ),
    /***/
    9112: (
      /***/
      function(n, o, u) {
        var c = u("83ab"), d = u("9bf2"), m = u("5c6c");
        n.exports = c ? function(v, S, $) {
          return d.f(v, S, m(1, $));
        } : function(v, S, $) {
          return v[S] = $, v;
        };
      }
    ),
    /***/
    9263: (
      /***/
      function(n, o, u) {
        var c = u("ad6d"), d = u("9f7f"), m = RegExp.prototype.exec, v = String.prototype.replace, S = m, $ = function() {
          var y = /a/, V = /b*/g;
          return m.call(y, "a"), m.call(V, "a"), y.lastIndex !== 0 || V.lastIndex !== 0;
        }(), E = d.UNSUPPORTED_Y || d.BROKEN_CARET, O = /()??/.exec("")[1] !== void 0, T = $ || O || E;
        T && (S = function(V) {
          var M = this, G, k, F, X, ee = E && M.sticky, ue = c.call(M), Q = M.source, Y = 0, pe = V;
          return ee && (ue = ue.replace("y", ""), ue.indexOf("g") === -1 && (ue += "g"), pe = String(V).slice(M.lastIndex), M.lastIndex > 0 && (!M.multiline || M.multiline && V[M.lastIndex - 1] !== `
`) && (Q = "(?: " + Q + ")", pe = " " + pe, Y++), k = new RegExp("^(?:" + Q + ")", ue)), O && (k = new RegExp("^" + Q + "$(?!\\s)", ue)), $ && (G = M.lastIndex), F = m.call(ee ? k : M, pe), ee ? F ? (F.input = F.input.slice(Y), F[0] = F[0].slice(Y), F.index = M.lastIndex, M.lastIndex += F[0].length) : M.lastIndex = 0 : $ && F && (M.lastIndex = M.global ? F.index + F[0].length : G), O && F && F.length > 1 && v.call(F[0], k, function() {
            for (X = 1; X < arguments.length - 2; X++)
              arguments[X] === void 0 && (F[X] = void 0);
          }), F;
        }), n.exports = S;
      }
    ),
    /***/
    "94ca": (
      /***/
      function(n, o, u) {
        var c = u("d039"), d = /#|\.prototype\./, m = function(O, T) {
          var y = S[v(O)];
          return y == E ? !0 : y == $ ? !1 : typeof T == "function" ? c(T) : !!T;
        }, v = m.normalize = function(O) {
          return String(O).replace(d, ".").toLowerCase();
        }, S = m.data = {}, $ = m.NATIVE = "N", E = m.POLYFILL = "P";
        n.exports = m;
      }
    ),
    /***/
    "99af": (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("d039"), m = u("e8b5"), v = u("861d"), S = u("7b0b"), $ = u("50c4"), E = u("8418"), O = u("65f0"), T = u("1dde"), y = u("b622"), V = u("2d00"), M = y("isConcatSpreadable"), G = 9007199254740991, k = "Maximum allowed index exceeded", F = V >= 51 || !d(function() {
          var Q = [];
          return Q[M] = !1, Q.concat()[0] !== Q;
        }), X = T("concat"), ee = function(Q) {
          if (!v(Q))
            return !1;
          var Y = Q[M];
          return Y !== void 0 ? !!Y : m(Q);
        }, ue = !F || !X;
        c({ target: "Array", proto: !0, forced: ue }, {
          concat: function(Y) {
            var pe = S(this), oe = O(pe, 0), ne = 0, H, C, w, P, J;
            for (H = -1, w = arguments.length; H < w; H++)
              if (J = H === -1 ? pe : arguments[H], ee(J)) {
                if (P = $(J.length), ne + P > G)
                  throw TypeError(k);
                for (C = 0; C < P; C++, ne++)
                  C in J && E(oe, ne, J[C]);
              } else {
                if (ne >= G)
                  throw TypeError(k);
                E(oe, ne++, J);
              }
            return oe.length = ne, oe;
          }
        });
      }
    ),
    /***/
    "9bdd": (
      /***/
      function(n, o, u) {
        var c = u("825a");
        n.exports = function(d, m, v, S) {
          try {
            return S ? m(c(v)[0], v[1]) : m(v);
          } catch (E) {
            var $ = d.return;
            throw $ !== void 0 && c($.call(d)), E;
          }
        };
      }
    ),
    /***/
    "9bf2": (
      /***/
      function(n, o, u) {
        var c = u("83ab"), d = u("0cfb"), m = u("825a"), v = u("c04e"), S = Object.defineProperty;
        o.f = c ? S : function(E, O, T) {
          if (m(E), O = v(O, !0), m(T), d)
            try {
              return S(E, O, T);
            } catch {
            }
          if ("get" in T || "set" in T)
            throw TypeError("Accessors not supported");
          return "value" in T && (E[O] = T.value), E;
        };
      }
    ),
    /***/
    "9ed3": (
      /***/
      function(n, o, u) {
        var c = u("ae93").IteratorPrototype, d = u("7c73"), m = u("5c6c"), v = u("d44e"), S = u("3f8c"), $ = function() {
          return this;
        };
        n.exports = function(E, O, T) {
          var y = O + " Iterator";
          return E.prototype = d(c, { next: m(1, T) }), v(E, y, !1, !0), S[y] = $, E;
        };
      }
    ),
    /***/
    "9f7f": (
      /***/
      function(n, o, u) {
        var c = u("d039");
        function d(m, v) {
          return RegExp(m, v);
        }
        o.UNSUPPORTED_Y = c(function() {
          var m = d("a", "y");
          return m.lastIndex = 2, m.exec("abcd") != null;
        }), o.BROKEN_CARET = c(function() {
          var m = d("^r", "gy");
          return m.lastIndex = 2, m.exec("str") != null;
        });
      }
    ),
    /***/
    a4d3: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("da84"), m = u("d066"), v = u("c430"), S = u("83ab"), $ = u("4930"), E = u("fdbf"), O = u("d039"), T = u("5135"), y = u("e8b5"), V = u("861d"), M = u("825a"), G = u("7b0b"), k = u("fc6a"), F = u("c04e"), X = u("5c6c"), ee = u("7c73"), ue = u("df75"), Q = u("241c"), Y = u("057f"), pe = u("7418"), oe = u("06cf"), ne = u("9bf2"), H = u("d1e7"), C = u("9112"), w = u("6eeb"), P = u("5692"), J = u("f772"), se = u("d012"), fe = u("90e3"), N = u("b622"), W = u("e538"), I = u("746f"), te = u("d44e"), ge = u("69f3"), Pe = u("b727").forEach, Ke = J("hidden"), xe = "Symbol", ze = "prototype", nt = N("toPrimitive"), Qt = ge.set, Et = ge.getterFor(xe), zt = Object[ze], Nt = d.Symbol, pt = m("JSON", "stringify"), at = oe.f, kt = ne.f, Ut = Y.f, dn = H.f, En = P("symbols"), Ht = P("op-symbols"), Xt = P("string-to-symbol-registry"), On = P("symbol-to-string-registry"), sn = P("wks"), At = d.QObject, hn = !At || !At[ze] || !At[ze].findChild, $t = S && O(function() {
          return ee(kt({}, "a", {
            get: function() {
              return kt(this, "a", { value: 7 }).a;
            }
          })).a != 7;
        }) ? function(Me, He, cn) {
          var Wt = at(zt, He);
          Wt && delete zt[He], kt(Me, He, cn), Wt && Me !== zt && kt(zt, He, Wt);
        } : kt, Lt = function(Me, He) {
          var cn = En[Me] = ee(Nt[ze]);
          return Qt(cn, {
            type: xe,
            tag: Me,
            description: He
          }), S || (cn.description = He), cn;
        }, Qn = E ? function(Me) {
          return typeof Me == "symbol";
        } : function(Me) {
          return Object(Me) instanceof Nt;
        }, ce = function(He, cn, Wt) {
          He === zt && ce(Ht, cn, Wt), M(He);
          var yn = F(cn, !0);
          return M(Wt), T(En, yn) ? (Wt.enumerable ? (T(He, Ke) && He[Ke][yn] && (He[Ke][yn] = !1), Wt = ee(Wt, { enumerable: X(0, !1) })) : (T(He, Ke) || kt(He, Ke, X(1, {})), He[Ke][yn] = !0), $t(He, yn, Wt)) : kt(He, yn, Wt);
        }, Ze = function(He, cn) {
          M(He);
          var Wt = k(cn), yn = ue(Wt).concat(Pn(Wt));
          return Pe(yn, function(pr) {
            (!S || It.call(Wt, pr)) && ce(He, pr, Wt[pr]);
          }), He;
        }, ft = function(He, cn) {
          return cn === void 0 ? ee(He) : Ze(ee(He), cn);
        }, It = function(He) {
          var cn = F(He, !0), Wt = dn.call(this, cn);
          return this === zt && T(En, cn) && !T(Ht, cn) ? !1 : Wt || !T(this, cn) || !T(En, cn) || T(this, Ke) && this[Ke][cn] ? Wt : !0;
        }, rn = function(He, cn) {
          var Wt = k(He), yn = F(cn, !0);
          if (!(Wt === zt && T(En, yn) && !T(Ht, yn))) {
            var pr = at(Wt, yn);
            return pr && T(En, yn) && !(T(Wt, Ke) && Wt[Ke][yn]) && (pr.enumerable = !0), pr;
          }
        }, Ln = function(He) {
          var cn = Ut(k(He)), Wt = [];
          return Pe(cn, function(yn) {
            !T(En, yn) && !T(se, yn) && Wt.push(yn);
          }), Wt;
        }, Pn = function(He) {
          var cn = He === zt, Wt = Ut(cn ? Ht : k(He)), yn = [];
          return Pe(Wt, function(pr) {
            T(En, pr) && (!cn || T(zt, pr)) && yn.push(En[pr]);
          }), yn;
        };
        if ($ || (Nt = function() {
          if (this instanceof Nt)
            throw TypeError("Symbol is not a constructor");
          var He = !arguments.length || arguments[0] === void 0 ? void 0 : String(arguments[0]), cn = fe(He), Wt = function(yn) {
            this === zt && Wt.call(Ht, yn), T(this, Ke) && T(this[Ke], cn) && (this[Ke][cn] = !1), $t(this, cn, X(1, yn));
          };
          return S && hn && $t(zt, cn, { configurable: !0, set: Wt }), Lt(cn, He);
        }, w(Nt[ze], "toString", function() {
          return Et(this).tag;
        }), w(Nt, "withoutSetter", function(Me) {
          return Lt(fe(Me), Me);
        }), H.f = It, ne.f = ce, oe.f = rn, Q.f = Y.f = Ln, pe.f = Pn, W.f = function(Me) {
          return Lt(N(Me), Me);
        }, S && (kt(Nt[ze], "description", {
          configurable: !0,
          get: function() {
            return Et(this).description;
          }
        }), v || w(zt, "propertyIsEnumerable", It, { unsafe: !0 }))), c({ global: !0, wrap: !0, forced: !$, sham: !$ }, {
          Symbol: Nt
        }), Pe(ue(sn), function(Me) {
          I(Me);
        }), c({ target: xe, stat: !0, forced: !$ }, {
          // `Symbol.for` method
          // https://tc39.github.io/ecma262/#sec-symbol.for
          for: function(Me) {
            var He = String(Me);
            if (T(Xt, He))
              return Xt[He];
            var cn = Nt(He);
            return Xt[He] = cn, On[cn] = He, cn;
          },
          // `Symbol.keyFor` method
          // https://tc39.github.io/ecma262/#sec-symbol.keyfor
          keyFor: function(He) {
            if (!Qn(He))
              throw TypeError(He + " is not a symbol");
            if (T(On, He))
              return On[He];
          },
          useSetter: function() {
            hn = !0;
          },
          useSimple: function() {
            hn = !1;
          }
        }), c({ target: "Object", stat: !0, forced: !$, sham: !S }, {
          // `Object.create` method
          // https://tc39.github.io/ecma262/#sec-object.create
          create: ft,
          // `Object.defineProperty` method
          // https://tc39.github.io/ecma262/#sec-object.defineproperty
          defineProperty: ce,
          // `Object.defineProperties` method
          // https://tc39.github.io/ecma262/#sec-object.defineproperties
          defineProperties: Ze,
          // `Object.getOwnPropertyDescriptor` method
          // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
          getOwnPropertyDescriptor: rn
        }), c({ target: "Object", stat: !0, forced: !$ }, {
          // `Object.getOwnPropertyNames` method
          // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
          getOwnPropertyNames: Ln,
          // `Object.getOwnPropertySymbols` method
          // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
          getOwnPropertySymbols: Pn
        }), c({ target: "Object", stat: !0, forced: O(function() {
          pe.f(1);
        }) }, {
          getOwnPropertySymbols: function(He) {
            return pe.f(G(He));
          }
        }), pt) {
          var Ae = !$ || O(function() {
            var Me = Nt();
            return pt([Me]) != "[null]" || pt({ a: Me }) != "{}" || pt(Object(Me)) != "{}";
          });
          c({ target: "JSON", stat: !0, forced: Ae }, {
            // eslint-disable-next-line no-unused-vars
            stringify: function(He, cn, Wt) {
              for (var yn = [He], pr = 1, Uo; arguments.length > pr; )
                yn.push(arguments[pr++]);
              if (Uo = cn, !(!V(cn) && He === void 0 || Qn(He)))
                return y(cn) || (cn = function(ar, Sr) {
                  if (typeof Uo == "function" && (Sr = Uo.call(this, ar, Sr)), !Qn(Sr))
                    return Sr;
                }), yn[1] = cn, pt.apply(null, yn);
            }
          });
        }
        Nt[ze][nt] || C(Nt[ze], nt, Nt[ze].valueOf), te(Nt, xe), se[Ke] = !0;
      }
    ),
    /***/
    a630: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("4df4"), m = u("1c7e"), v = !m(function(S) {
          Array.from(S);
        });
        c({ target: "Array", stat: !0, forced: v }, {
          from: d
        });
      }
    ),
    /***/
    a640: (
      /***/
      function(n, o, u) {
        var c = u("d039");
        n.exports = function(d, m) {
          var v = [][d];
          return !!v && c(function() {
            v.call(null, m || function() {
              throw 1;
            }, 1);
          });
        };
      }
    ),
    /***/
    a691: (
      /***/
      function(n, o) {
        var u = Math.ceil, c = Math.floor;
        n.exports = function(d) {
          return isNaN(d = +d) ? 0 : (d > 0 ? c : u)(d);
        };
      }
    ),
    /***/
    ab13: (
      /***/
      function(n, o, u) {
        var c = u("b622"), d = c("match");
        n.exports = function(m) {
          var v = /./;
          try {
            "/./"[m](v);
          } catch {
            try {
              return v[d] = !1, "/./"[m](v);
            } catch {
            }
          }
          return !1;
        };
      }
    ),
    /***/
    ac1f: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("9263");
        c({ target: "RegExp", proto: !0, forced: /./.exec !== d }, {
          exec: d
        });
      }
    ),
    /***/
    ad6d: (
      /***/
      function(n, o, u) {
        var c = u("825a");
        n.exports = function() {
          var d = c(this), m = "";
          return d.global && (m += "g"), d.ignoreCase && (m += "i"), d.multiline && (m += "m"), d.dotAll && (m += "s"), d.unicode && (m += "u"), d.sticky && (m += "y"), m;
        };
      }
    ),
    /***/
    ae40: (
      /***/
      function(n, o, u) {
        var c = u("83ab"), d = u("d039"), m = u("5135"), v = Object.defineProperty, S = {}, $ = function(E) {
          throw E;
        };
        n.exports = function(E, O) {
          if (m(S, E))
            return S[E];
          O || (O = {});
          var T = [][E], y = m(O, "ACCESSORS") ? O.ACCESSORS : !1, V = m(O, 0) ? O[0] : $, M = m(O, 1) ? O[1] : void 0;
          return S[E] = !!T && !d(function() {
            if (y && !c)
              return !0;
            var G = { length: -1 };
            y ? v(G, 1, { enumerable: !0, get: $ }) : G[1] = 1, T.call(G, V, M);
          });
        };
      }
    ),
    /***/
    ae93: (
      /***/
      function(n, o, u) {
        var c = u("e163"), d = u("9112"), m = u("5135"), v = u("b622"), S = u("c430"), $ = v("iterator"), E = !1, O = function() {
          return this;
        }, T, y, V;
        [].keys && (V = [].keys(), "next" in V ? (y = c(c(V)), y !== Object.prototype && (T = y)) : E = !0), T == null && (T = {}), !S && !m(T, $) && d(T, $, O), n.exports = {
          IteratorPrototype: T,
          BUGGY_SAFARI_ITERATORS: E
        };
      }
    ),
    /***/
    b041: (
      /***/
      function(n, o, u) {
        var c = u("00ee"), d = u("f5df");
        n.exports = c ? {}.toString : function() {
          return "[object " + d(this) + "]";
        };
      }
    ),
    /***/
    b0c0: (
      /***/
      function(n, o, u) {
        var c = u("83ab"), d = u("9bf2").f, m = Function.prototype, v = m.toString, S = /^\s*function ([^ (]*)/, $ = "name";
        c && !($ in m) && d(m, $, {
          configurable: !0,
          get: function() {
            try {
              return v.call(this).match(S)[1];
            } catch {
              return "";
            }
          }
        });
      }
    ),
    /***/
    b622: (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("5692"), m = u("5135"), v = u("90e3"), S = u("4930"), $ = u("fdbf"), E = d("wks"), O = c.Symbol, T = $ ? O : O && O.withoutSetter || v;
        n.exports = function(y) {
          return m(E, y) || (S && m(O, y) ? E[y] = O[y] : E[y] = T("Symbol." + y)), E[y];
        };
      }
    ),
    /***/
    b64b: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("7b0b"), m = u("df75"), v = u("d039"), S = v(function() {
          m(1);
        });
        c({ target: "Object", stat: !0, forced: S }, {
          keys: function(E) {
            return m(d(E));
          }
        });
      }
    ),
    /***/
    b727: (
      /***/
      function(n, o, u) {
        var c = u("0366"), d = u("44ad"), m = u("7b0b"), v = u("50c4"), S = u("65f0"), $ = [].push, E = function(O) {
          var T = O == 1, y = O == 2, V = O == 3, M = O == 4, G = O == 6, k = O == 5 || G;
          return function(F, X, ee, ue) {
            for (var Q = m(F), Y = d(Q), pe = c(X, ee, 3), oe = v(Y.length), ne = 0, H = ue || S, C = T ? H(F, oe) : y ? H(F, 0) : void 0, w, P; oe > ne; ne++)
              if ((k || ne in Y) && (w = Y[ne], P = pe(w, ne, Q), O)) {
                if (T)
                  C[ne] = P;
                else if (P)
                  switch (O) {
                    case 3:
                      return !0;
                    case 5:
                      return w;
                    case 6:
                      return ne;
                    case 2:
                      $.call(C, w);
                  }
                else if (M)
                  return !1;
              }
            return G ? -1 : V || M ? M : C;
          };
        };
        n.exports = {
          // `Array.prototype.forEach` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
          forEach: E(0),
          // `Array.prototype.map` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.map
          map: E(1),
          // `Array.prototype.filter` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.filter
          filter: E(2),
          // `Array.prototype.some` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.some
          some: E(3),
          // `Array.prototype.every` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.every
          every: E(4),
          // `Array.prototype.find` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.find
          find: E(5),
          // `Array.prototype.findIndex` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
          findIndex: E(6)
        };
      }
    ),
    /***/
    c04e: (
      /***/
      function(n, o, u) {
        var c = u("861d");
        n.exports = function(d, m) {
          if (!c(d))
            return d;
          var v, S;
          if (m && typeof (v = d.toString) == "function" && !c(S = v.call(d)) || typeof (v = d.valueOf) == "function" && !c(S = v.call(d)) || !m && typeof (v = d.toString) == "function" && !c(S = v.call(d)))
            return S;
          throw TypeError("Can't convert object to primitive value");
        };
      }
    ),
    /***/
    c430: (
      /***/
      function(n, o) {
        n.exports = !1;
      }
    ),
    /***/
    c6b6: (
      /***/
      function(n, o) {
        var u = {}.toString;
        n.exports = function(c) {
          return u.call(c).slice(8, -1);
        };
      }
    ),
    /***/
    c6cd: (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("ce4e"), m = "__core-js_shared__", v = c[m] || d(m, {});
        n.exports = v;
      }
    ),
    /***/
    c8ba: (
      /***/
      function(n, o) {
        var u;
        u = function() {
          return this;
        }();
        try {
          u = u || new Function("return this")();
        } catch {
          typeof window == "object" && (u = window);
        }
        n.exports = u;
      }
    ),
    /***/
    c975: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("4d64").indexOf, m = u("a640"), v = u("ae40"), S = [].indexOf, $ = !!S && 1 / [1].indexOf(1, -0) < 0, E = m("indexOf"), O = v("indexOf", { ACCESSORS: !0, 1: 0 });
        c({ target: "Array", proto: !0, forced: $ || !E || !O }, {
          indexOf: function(y) {
            return $ ? S.apply(this, arguments) || 0 : d(this, y, arguments.length > 1 ? arguments[1] : void 0);
          }
        });
      }
    ),
    /***/
    ca84: (
      /***/
      function(n, o, u) {
        var c = u("5135"), d = u("fc6a"), m = u("4d64").indexOf, v = u("d012");
        n.exports = function(S, $) {
          var E = d(S), O = 0, T = [], y;
          for (y in E)
            !c(v, y) && c(E, y) && T.push(y);
          for (; $.length > O; )
            c(E, y = $[O++]) && (~m(T, y) || T.push(y));
          return T;
        };
      }
    ),
    /***/
    cc12: (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("861d"), m = c.document, v = d(m) && d(m.createElement);
        n.exports = function(S) {
          return v ? m.createElement(S) : {};
        };
      }
    ),
    /***/
    cca6: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("60da");
        c({ target: "Object", stat: !0, forced: Object.assign !== d }, {
          assign: d
        });
      }
    ),
    /***/
    ce4e: (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("9112");
        n.exports = function(m, v) {
          try {
            d(c, m, v);
          } catch {
            c[m] = v;
          }
          return v;
        };
      }
    ),
    /***/
    d012: (
      /***/
      function(n, o) {
        n.exports = {};
      }
    ),
    /***/
    d039: (
      /***/
      function(n, o) {
        n.exports = function(u) {
          try {
            return !!u();
          } catch {
            return !0;
          }
        };
      }
    ),
    /***/
    d066: (
      /***/
      function(n, o, u) {
        var c = u("428f"), d = u("da84"), m = function(v) {
          return typeof v == "function" ? v : void 0;
        };
        n.exports = function(v, S) {
          return arguments.length < 2 ? m(c[v]) || m(d[v]) : c[v] && c[v][S] || d[v] && d[v][S];
        };
      }
    ),
    /***/
    d1e7: (
      /***/
      function(n, o, u) {
        var c = {}.propertyIsEnumerable, d = Object.getOwnPropertyDescriptor, m = d && !c.call({ 1: 2 }, 1);
        o.f = m ? function(S) {
          var $ = d(this, S);
          return !!$ && $.enumerable;
        } : c;
      }
    ),
    /***/
    d28b: (
      /***/
      function(n, o, u) {
        var c = u("746f");
        c("iterator");
      }
    ),
    /***/
    d2bb: (
      /***/
      function(n, o, u) {
        var c = u("825a"), d = u("3bbe");
        n.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
          var m = !1, v = {}, S;
          try {
            S = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, S.call(v, []), m = v instanceof Array;
          } catch {
          }
          return function(E, O) {
            return c(E), d(O), m ? S.call(E, O) : E.__proto__ = O, E;
          };
        }() : void 0);
      }
    ),
    /***/
    d3b7: (
      /***/
      function(n, o, u) {
        var c = u("00ee"), d = u("6eeb"), m = u("b041");
        c || d(Object.prototype, "toString", m, { unsafe: !0 });
      }
    ),
    /***/
    d44e: (
      /***/
      function(n, o, u) {
        var c = u("9bf2").f, d = u("5135"), m = u("b622"), v = m("toStringTag");
        n.exports = function(S, $, E) {
          S && !d(S = E ? S : S.prototype, v) && c(S, v, { configurable: !0, value: $ });
        };
      }
    ),
    /***/
    d784: (
      /***/
      function(n, o, u) {
        u("ac1f");
        var c = u("6eeb"), d = u("d039"), m = u("b622"), v = u("9263"), S = u("9112"), $ = m("species"), E = !d(function() {
          var M = /./;
          return M.exec = function() {
            var G = [];
            return G.groups = { a: "7" }, G;
          }, "".replace(M, "$<a>") !== "7";
        }), O = function() {
          return "a".replace(/./, "$0") === "$0";
        }(), T = m("replace"), y = function() {
          return /./[T] ? /./[T]("a", "$0") === "" : !1;
        }(), V = !d(function() {
          var M = /(?:)/, G = M.exec;
          M.exec = function() {
            return G.apply(this, arguments);
          };
          var k = "ab".split(M);
          return k.length !== 2 || k[0] !== "a" || k[1] !== "b";
        });
        n.exports = function(M, G, k, F) {
          var X = m(M), ee = !d(function() {
            var ne = {};
            return ne[X] = function() {
              return 7;
            }, ""[M](ne) != 7;
          }), ue = ee && !d(function() {
            var ne = !1, H = /a/;
            return M === "split" && (H = {}, H.constructor = {}, H.constructor[$] = function() {
              return H;
            }, H.flags = "", H[X] = /./[X]), H.exec = function() {
              return ne = !0, null;
            }, H[X](""), !ne;
          });
          if (!ee || !ue || M === "replace" && !(E && O && !y) || M === "split" && !V) {
            var Q = /./[X], Y = k(X, ""[M], function(ne, H, C, w, P) {
              return H.exec === v ? ee && !P ? { done: !0, value: Q.call(H, C, w) } : { done: !0, value: ne.call(C, H, w) } : { done: !1 };
            }, {
              REPLACE_KEEPS_$0: O,
              REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: y
            }), pe = Y[0], oe = Y[1];
            c(String.prototype, M, pe), c(
              RegExp.prototype,
              X,
              G == 2 ? function(ne, H) {
                return oe.call(ne, this, H);
              } : function(ne) {
                return oe.call(ne, this);
              }
            );
          }
          F && S(RegExp.prototype[X], "sham", !0);
        };
      }
    ),
    /***/
    d81d: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("b727").map, m = u("1dde"), v = u("ae40"), S = m("map"), $ = v("map");
        c({ target: "Array", proto: !0, forced: !S || !$ }, {
          map: function(O) {
            return d(this, O, arguments.length > 1 ? arguments[1] : void 0);
          }
        });
      }
    ),
    /***/
    da84: (
      /***/
      function(n, o, u) {
        (function(c) {
          var d = function(m) {
            return m && m.Math == Math && m;
          };
          n.exports = // eslint-disable-next-line no-undef
          d(typeof globalThis == "object" && globalThis) || d(typeof window == "object" && window) || d(typeof self == "object" && self) || d(typeof c == "object" && c) || // eslint-disable-next-line no-new-func
          Function("return this")();
        }).call(this, u("c8ba"));
      }
    ),
    /***/
    ddb0: (
      /***/
      function(n, o, u) {
        var c = u("da84"), d = u("fdbc"), m = u("e260"), v = u("9112"), S = u("b622"), $ = S("iterator"), E = S("toStringTag"), O = m.values;
        for (var T in d) {
          var y = c[T], V = y && y.prototype;
          if (V) {
            if (V[$] !== O)
              try {
                v(V, $, O);
              } catch {
                V[$] = O;
              }
            if (V[E] || v(V, E, T), d[T]) {
              for (var M in m)
                if (V[M] !== m[M])
                  try {
                    v(V, M, m[M]);
                  } catch {
                    V[M] = m[M];
                  }
            }
          }
        }
      }
    ),
    /***/
    df75: (
      /***/
      function(n, o, u) {
        var c = u("ca84"), d = u("7839");
        n.exports = Object.keys || function(v) {
          return c(v, d);
        };
      }
    ),
    /***/
    e01a: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("83ab"), m = u("da84"), v = u("5135"), S = u("861d"), $ = u("9bf2").f, E = u("e893"), O = m.Symbol;
        if (d && typeof O == "function" && (!("description" in O.prototype) || // Safari 12 bug
        O().description !== void 0)) {
          var T = {}, y = function() {
            var X = arguments.length < 1 || arguments[0] === void 0 ? void 0 : String(arguments[0]), ee = this instanceof y ? new O(X) : X === void 0 ? O() : O(X);
            return X === "" && (T[ee] = !0), ee;
          };
          E(y, O);
          var V = y.prototype = O.prototype;
          V.constructor = y;
          var M = V.toString, G = String(O("test")) == "Symbol(test)", k = /^Symbol\((.*)\)[^)]+$/;
          $(V, "description", {
            configurable: !0,
            get: function() {
              var X = S(this) ? this.valueOf() : this, ee = M.call(X);
              if (v(T, X))
                return "";
              var ue = G ? ee.slice(7, -1) : ee.replace(k, "$1");
              return ue === "" ? void 0 : ue;
            }
          }), c({ global: !0, forced: !0 }, {
            Symbol: y
          });
        }
      }
    ),
    /***/
    e163: (
      /***/
      function(n, o, u) {
        var c = u("5135"), d = u("7b0b"), m = u("f772"), v = u("e177"), S = m("IE_PROTO"), $ = Object.prototype;
        n.exports = v ? Object.getPrototypeOf : function(E) {
          return E = d(E), c(E, S) ? E[S] : typeof E.constructor == "function" && E instanceof E.constructor ? E.constructor.prototype : E instanceof Object ? $ : null;
        };
      }
    ),
    /***/
    e177: (
      /***/
      function(n, o, u) {
        var c = u("d039");
        n.exports = !c(function() {
          function d() {
          }
          return d.prototype.constructor = null, Object.getPrototypeOf(new d()) !== d.prototype;
        });
      }
    ),
    /***/
    e260: (
      /***/
      function(n, o, u) {
        var c = u("fc6a"), d = u("44d2"), m = u("3f8c"), v = u("69f3"), S = u("7dd0"), $ = "Array Iterator", E = v.set, O = v.getterFor($);
        n.exports = S(Array, "Array", function(T, y) {
          E(this, {
            type: $,
            target: c(T),
            // target
            index: 0,
            // next index
            kind: y
            // kind
          });
        }, function() {
          var T = O(this), y = T.target, V = T.kind, M = T.index++;
          return !y || M >= y.length ? (T.target = void 0, { value: void 0, done: !0 }) : V == "keys" ? { value: M, done: !1 } : V == "values" ? { value: y[M], done: !1 } : { value: [M, y[M]], done: !1 };
        }, "values"), m.Arguments = m.Array, d("keys"), d("values"), d("entries");
      }
    ),
    /***/
    e439: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("d039"), m = u("fc6a"), v = u("06cf").f, S = u("83ab"), $ = d(function() {
          v(1);
        }), E = !S || $;
        c({ target: "Object", stat: !0, forced: E, sham: !S }, {
          getOwnPropertyDescriptor: function(T, y) {
            return v(m(T), y);
          }
        });
      }
    ),
    /***/
    e538: (
      /***/
      function(n, o, u) {
        var c = u("b622");
        o.f = c;
      }
    ),
    /***/
    e893: (
      /***/
      function(n, o, u) {
        var c = u("5135"), d = u("56ef"), m = u("06cf"), v = u("9bf2");
        n.exports = function(S, $) {
          for (var E = d($), O = v.f, T = m.f, y = 0; y < E.length; y++) {
            var V = E[y];
            c(S, V) || O(S, V, T($, V));
          }
        };
      }
    ),
    /***/
    e8b5: (
      /***/
      function(n, o, u) {
        var c = u("c6b6");
        n.exports = Array.isArray || function(m) {
          return c(m) == "Array";
        };
      }
    ),
    /***/
    e95a: (
      /***/
      function(n, o, u) {
        var c = u("b622"), d = u("3f8c"), m = c("iterator"), v = Array.prototype;
        n.exports = function(S) {
          return S !== void 0 && (d.Array === S || v[m] === S);
        };
      }
    ),
    /***/
    f5df: (
      /***/
      function(n, o, u) {
        var c = u("00ee"), d = u("c6b6"), m = u("b622"), v = m("toStringTag"), S = d(function() {
          return arguments;
        }()) == "Arguments", $ = function(E, O) {
          try {
            return E[O];
          } catch {
          }
        };
        n.exports = c ? d : function(E) {
          var O, T, y;
          return E === void 0 ? "Undefined" : E === null ? "Null" : typeof (T = $(O = Object(E), v)) == "string" ? T : S ? d(O) : (y = d(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : y;
        };
      }
    ),
    /***/
    f772: (
      /***/
      function(n, o, u) {
        var c = u("5692"), d = u("90e3"), m = c("keys");
        n.exports = function(v) {
          return m[v] || (m[v] = d(v));
        };
      }
    ),
    /***/
    fb15: (
      /***/
      function(n, o, u) {
        if (u.r(o), u.d(o, "install", function() {
          return (
            /* reexport */
            Et
          );
        }), u.d(o, "VueEditor", function() {
          return (
            /* reexport */
            nt
          );
        }), u.d(o, "Quill", function() {
          return (
            /* reexport */
            S.a
          );
        }), typeof window < "u") {
          var c = window.document.currentScript;
          {
            var d = u("8875");
            c = d(), "currentScript" in document || Object.defineProperty(document, "currentScript", { get: d });
          }
          var m = c && c.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
          m && (u.p = m[1]);
        }
        var v = u("6c81"), S = /* @__PURE__ */ u.n(v), $ = u("8bbf"), E = {
          class: "quillWrapper"
        };
        function O(pt, at, kt, Ut, dn, En) {
          return Object($.openBlock)(), Object($.createBlock)("div", E, [Object($.renderSlot)(pt.$slots, "toolbar"), Object($.createVNode)("div", {
            id: kt.id,
            ref: "quillContainer"
          }, null, 8, ["id"]), kt.useCustomImageHandler ? (Object($.openBlock)(), Object($.createBlock)("input", {
            key: 0,
            id: "file-upload",
            ref: "fileInput",
            type: "file",
            accept: "image/*",
            style: {
              display: "none"
            },
            onChange: at[1] || (at[1] = function(Ht) {
              return En.emitImageInfo(Ht);
            })
          }, null, 544)) : Object($.createCommentVNode)("", !0)]);
        }
        u("99af"), u("d81d"), u("b64b");
        var T = [
          [{
            header: [!1, 1, 2, 3, 4, 5, 6]
          }],
          ["bold", "italic", "underline", "strike"],
          // toggled buttons
          [{
            align: ""
          }, {
            align: "center"
          }, {
            align: "right"
          }, {
            align: "justify"
          }],
          ["blockquote", "code-block"],
          [{
            list: "ordered"
          }, {
            list: "bullet"
          }, {
            list: "check"
          }],
          [{
            indent: "-1"
          }, {
            indent: "+1"
          }],
          // outdent/indent
          [{
            color: []
          }, {
            background: []
          }],
          // dropdown with defaults from theme
          ["link", "image", "video"],
          ["clean"]
          // remove formatting button
        ], y = T;
        u("4160"), u("159b");
        var V = {
          props: {
            customModules: Array
          },
          methods: {
            registerCustomModules: function(at) {
              this.customModules !== void 0 && this.customModules.forEach(function(kt) {
                at.register("modules/" + kt.alias, kt.module);
              });
            }
          }
        };
        u("cca6"), u("a4d3"), u("e01a"), u("d28b"), u("e260"), u("d3b7"), u("3ca3"), u("ddb0");
        function M(pt) {
          "@babel/helpers - typeof";
          return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? M = function(kt) {
            return typeof kt;
          } : M = function(kt) {
            return kt && typeof Symbol == "function" && kt.constructor === Symbol && kt !== Symbol.prototype ? "symbol" : typeof kt;
          }, M(pt);
        }
        function G(pt, at) {
          var kt = function(dn) {
            return dn && M(dn) === "object";
          };
          return !kt(pt) || !kt(at) ? at : (Object.keys(at).forEach(function(Ut) {
            var dn = pt[Ut], En = at[Ut];
            Array.isArray(dn) && Array.isArray(En) ? pt[Ut] = dn.concat(En) : kt(dn) && kt(En) ? pt[Ut] = G(Object.assign({}, dn), En) : pt[Ut] = En;
          }), pt);
        }
        u("c975"), u("fb6a"), u("b0c0"), u("ac1f"), u("466d"), u("841c"), u("a630"), u("25f0");
        function k(pt, at) {
          (at == null || at > pt.length) && (at = pt.length);
          for (var kt = 0, Ut = new Array(at); kt < at; kt++)
            Ut[kt] = pt[kt];
          return Ut;
        }
        function F(pt, at) {
          if (pt) {
            if (typeof pt == "string")
              return k(pt, at);
            var kt = Object.prototype.toString.call(pt).slice(8, -1);
            if (kt === "Object" && pt.constructor && (kt = pt.constructor.name), kt === "Map" || kt === "Set")
              return Array.from(pt);
            if (kt === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(kt))
              return k(pt, at);
          }
        }
        function X(pt, at) {
          var kt;
          if (typeof Symbol > "u" || pt[Symbol.iterator] == null) {
            if (Array.isArray(pt) || (kt = F(pt)) || at && pt && typeof pt.length == "number") {
              kt && (pt = kt);
              var Ut = 0, dn = function() {
              };
              return {
                s: dn,
                n: function() {
                  return Ut >= pt.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: pt[Ut++]
                  };
                },
                e: function(sn) {
                  throw sn;
                },
                f: dn
              };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var En = !0, Ht = !1, Xt;
          return {
            s: function() {
              kt = pt[Symbol.iterator]();
            },
            n: function() {
              var sn = kt.next();
              return En = sn.done, sn;
            },
            e: function(sn) {
              Ht = !0, Xt = sn;
            },
            f: function() {
              try {
                !En && kt.return != null && kt.return();
              } finally {
                if (Ht)
                  throw Xt;
              }
            }
          };
        }
        function ee(pt) {
          if (Array.isArray(pt))
            return pt;
        }
        function ue(pt, at) {
          if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(pt)))) {
            var kt = [], Ut = !0, dn = !1, En = void 0;
            try {
              for (var Ht = pt[Symbol.iterator](), Xt; !(Ut = (Xt = Ht.next()).done) && (kt.push(Xt.value), !(at && kt.length === at)); Ut = !0)
                ;
            } catch (On) {
              dn = !0, En = On;
            } finally {
              try {
                !Ut && Ht.return != null && Ht.return();
              } finally {
                if (dn)
                  throw En;
              }
            }
            return kt;
          }
        }
        function Q() {
          throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        function Y(pt, at) {
          return ee(pt) || ue(pt, at) || F(pt, at) || Q();
        }
        function pe(pt, at) {
          for (var kt = 0; kt < at.length; kt++) {
            var Ut = at[kt];
            Ut.enumerable = Ut.enumerable || !1, Ut.configurable = !0, "value" in Ut && (Ut.writable = !0), Object.defineProperty(pt, Ut.key, Ut);
          }
        }
        function oe(pt, at, kt) {
          return at && pe(pt.prototype, at), kt && pe(pt, kt), pt;
        }
        function ne(pt, at) {
          if (!(pt instanceof at))
            throw new TypeError("Cannot call a class as a function");
        }
        function H(pt, at) {
          return H = Object.setPrototypeOf || function(Ut, dn) {
            return Ut.__proto__ = dn, Ut;
          }, H(pt, at);
        }
        function C(pt, at) {
          if (typeof at != "function" && at !== null)
            throw new TypeError("Super expression must either be null or a function");
          pt.prototype = Object.create(at && at.prototype, {
            constructor: {
              value: pt,
              writable: !0,
              configurable: !0
            }
          }), at && H(pt, at);
        }
        u("4ae1"), u("3410");
        function w(pt) {
          return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(kt) {
            return kt.__proto__ || Object.getPrototypeOf(kt);
          }, w(pt);
        }
        function P() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }
        function J(pt) {
          if (pt === void 0)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return pt;
        }
        function se(pt, at) {
          return at && (M(at) === "object" || typeof at == "function") ? at : J(pt);
        }
        function fe(pt) {
          var at = P();
          return function() {
            var Ut = w(pt), dn;
            if (at) {
              var En = w(this).constructor;
              dn = Reflect.construct(Ut, arguments, En);
            } else
              dn = Ut.apply(this, arguments);
            return se(this, dn);
          };
        }
        var N = S.a.import("blots/block/embed"), W = /* @__PURE__ */ function(pt) {
          C(kt, pt);
          var at = fe(kt);
          function kt() {
            return ne(this, kt), at.apply(this, arguments);
          }
          return kt;
        }(N);
        W.blotName = "hr", W.tagName = "hr", S.a.register("formats/horizontal", W);
        var I = /* @__PURE__ */ function() {
          function pt(at, kt) {
            var Ut = this;
            ne(this, pt), this.quill = at, this.options = kt, this.ignoreTags = ["PRE"], this.matches = [{
              name: "header",
              pattern: /^(#){1,6}\s/g,
              action: function(En, Ht, Xt) {
                var On = Xt.exec(En);
                if (On) {
                  var sn = On[0].length;
                  setTimeout(function() {
                    Ut.quill.formatLine(Ht.index, 0, "header", sn - 1), Ut.quill.deleteText(Ht.index - sn, sn);
                  }, 0);
                }
              }
            }, {
              name: "blockquote",
              pattern: /^(>)\s/g,
              action: function(En, Ht) {
                setTimeout(function() {
                  Ut.quill.formatLine(Ht.index, 1, "blockquote", !0), Ut.quill.deleteText(Ht.index - 2, 2);
                }, 0);
              }
            }, {
              name: "code-block",
              pattern: /^`{3}(?:\s|\n)/g,
              action: function(En, Ht) {
                setTimeout(function() {
                  Ut.quill.formatLine(Ht.index, 1, "code-block", !0), Ut.quill.deleteText(Ht.index - 4, 4);
                }, 0);
              }
            }, {
              name: "bolditalic",
              pattern: /(?:\*|_){3}(.+?)(?:\*|_){3}/g,
              action: function(En, Ht, Xt, On) {
                var sn = Xt.exec(En), At = sn[0], hn = sn[1], $t = On + sn.index;
                En.match(/^([*_ \n]+)$/g) || setTimeout(function() {
                  Ut.quill.deleteText($t, At.length), Ut.quill.insertText($t, hn, {
                    bold: !0,
                    italic: !0
                  }), Ut.quill.format("bold", !1);
                }, 0);
              }
            }, {
              name: "bold",
              pattern: /(?:\*|_){2}(.+?)(?:\*|_){2}/g,
              action: function(En, Ht, Xt, On) {
                var sn = Xt.exec(En), At = sn[0], hn = sn[1], $t = On + sn.index;
                En.match(/^([*_ \n]+)$/g) || setTimeout(function() {
                  Ut.quill.deleteText($t, At.length), Ut.quill.insertText($t, hn, {
                    bold: !0
                  }), Ut.quill.format("bold", !1);
                }, 0);
              }
            }, {
              name: "italic",
              pattern: /(?:\*|_){1}(.+?)(?:\*|_){1}/g,
              action: function(En, Ht, Xt, On) {
                var sn = Xt.exec(En), At = sn[0], hn = sn[1], $t = On + sn.index;
                En.match(/^([*_ \n]+)$/g) || setTimeout(function() {
                  Ut.quill.deleteText($t, At.length), Ut.quill.insertText($t, hn, {
                    italic: !0
                  }), Ut.quill.format("italic", !1);
                }, 0);
              }
            }, {
              name: "strikethrough",
              pattern: /(?:~~)(.+?)(?:~~)/g,
              action: function(En, Ht, Xt, On) {
                var sn = Xt.exec(En), At = sn[0], hn = sn[1], $t = On + sn.index;
                En.match(/^([*_ \n]+)$/g) || setTimeout(function() {
                  Ut.quill.deleteText($t, At.length), Ut.quill.insertText($t, hn, {
                    strike: !0
                  }), Ut.quill.format("strike", !1);
                }, 0);
              }
            }, {
              name: "code",
              pattern: /(?:`)(.+?)(?:`)/g,
              action: function(En, Ht, Xt, On) {
                var sn = Xt.exec(En), At = sn[0], hn = sn[1], $t = On + sn.index;
                En.match(/^([*_ \n]+)$/g) || setTimeout(function() {
                  Ut.quill.deleteText($t, At.length), Ut.quill.insertText($t, hn, {
                    code: !0
                  }), Ut.quill.format("code", !1), Ut.quill.insertText(Ut.quill.getSelection(), " ");
                }, 0);
              }
            }, {
              name: "hr",
              pattern: /^([-*]\s?){3}/g,
              action: function(En, Ht) {
                var Xt = Ht.index - En.length;
                setTimeout(function() {
                  Ut.quill.deleteText(Xt, En.length), Ut.quill.insertEmbed(Xt + 1, "hr", !0, S.a.sources.USER), Ut.quill.insertText(Xt + 2, `
`, S.a.sources.SILENT), Ut.quill.setSelection(Xt + 2, S.a.sources.SILENT);
                }, 0);
              }
            }, {
              name: "asterisk-ul",
              pattern: /^(\*|\+)\s$/g,
              action: function(En, Ht, Xt) {
                setTimeout(function() {
                  Ut.quill.formatLine(Ht.index, 1, "list", "unordered"), Ut.quill.deleteText(Ht.index - 2, 2);
                }, 0);
              }
            }, {
              name: "image",
              pattern: /(?:!\[(.+?)\])(?:\((.+?)\))/g,
              action: function(En, Ht, Xt) {
                var On = En.search(Xt), sn = En.match(Xt)[0], At = En.match(/(?:\((.*?)\))/g)[0], hn = Ht.index - sn.length - 1;
                On !== -1 && setTimeout(function() {
                  Ut.quill.deleteText(hn, sn.length), Ut.quill.insertEmbed(hn, "image", At.slice(1, At.length - 1));
                }, 0);
              }
            }, {
              name: "link",
              pattern: /(?:\[(.+?)\])(?:\((.+?)\))/g,
              action: function(En, Ht, Xt) {
                var On = En.search(Xt), sn = En.match(Xt)[0], At = En.match(/(?:\[(.*?)\])/g)[0], hn = En.match(/(?:\((.*?)\))/g)[0], $t = Ht.index - sn.length - 1;
                On !== -1 && setTimeout(function() {
                  Ut.quill.deleteText($t, sn.length), Ut.quill.insertText($t, At.slice(1, At.length - 1), "link", hn.slice(1, hn.length - 1));
                }, 0);
              }
            }], this.quill.on("text-change", function(dn, En, Ht) {
              for (var Xt = 0; Xt < dn.ops.length; Xt++)
                dn.ops[Xt].hasOwnProperty("insert") && (dn.ops[Xt].insert === " " ? Ut.onSpace() : dn.ops[Xt].insert === `
` && Ut.onEnter());
            });
          }
          return oe(pt, [{
            key: "isValid",
            value: function(kt, Ut) {
              return typeof kt < "u" && kt && this.ignoreTags.indexOf(Ut) === -1;
            }
          }, {
            key: "onSpace",
            value: function() {
              var kt = this.quill.getSelection();
              if (kt) {
                var Ut = this.quill.getLine(kt.index), dn = Y(Ut, 2), En = dn[0], Ht = dn[1], Xt = En.domNode.textContent, On = kt.index - Ht;
                if (this.isValid(Xt, En.domNode.tagName)) {
                  var sn = X(this.matches), At;
                  try {
                    for (sn.s(); !(At = sn.n()).done; ) {
                      var hn = At.value, $t = Xt.match(hn.pattern);
                      if ($t) {
                        console.log("matched:", hn.name, Xt), hn.action(Xt, kt, hn.pattern, On);
                        return;
                      }
                    }
                  } catch (Lt) {
                    sn.e(Lt);
                  } finally {
                    sn.f();
                  }
                }
              }
            }
          }, {
            key: "onEnter",
            value: function() {
              var kt = this.quill.getSelection();
              if (kt) {
                var Ut = this.quill.getLine(kt.index), dn = Y(Ut, 2), En = dn[0], Ht = dn[1], Xt = En.domNode.textContent + " ", On = kt.index - Ht;
                if (kt.length = kt.index++, this.isValid(Xt, En.domNode.tagName)) {
                  var sn = X(this.matches), At;
                  try {
                    for (sn.s(); !(At = sn.n()).done; ) {
                      var hn = At.value, $t = Xt.match(hn.pattern);
                      if ($t) {
                        console.log("matched", hn.name, Xt), hn.action(Xt, kt, hn.pattern, On);
                        return;
                      }
                    }
                  } catch (Lt) {
                    sn.e(Lt);
                  } finally {
                    sn.f();
                  }
                }
              }
            }
          }]), pt;
        }(), te = I;
        u("2ca0"), u("e439"), u("5d41");
        function ge(pt, at) {
          for (; !Object.prototype.hasOwnProperty.call(pt, at) && (pt = w(pt), pt !== null); )
            ;
          return pt;
        }
        function Pe(pt, at, kt) {
          return typeof Reflect < "u" && Reflect.get ? Pe = Reflect.get : Pe = function(dn, En, Ht) {
            var Xt = ge(dn, En);
            if (Xt) {
              var On = Object.getOwnPropertyDescriptor(Xt, En);
              return On.get ? On.get.call(Ht) : On.value;
            }
          }, Pe(pt, at, kt || pt);
        }
        var Ke = S.a.import("formats/link"), xe = /* @__PURE__ */ function(pt) {
          C(kt, pt);
          var at = fe(kt);
          function kt() {
            return ne(this, kt), at.apply(this, arguments);
          }
          return oe(kt, null, [{
            key: "sanitize",
            value: function(dn) {
              var En = Pe(w(kt), "sanitize", this).call(this, dn);
              if (En) {
                for (var Ht = 0; Ht < this.PROTOCOL_WHITELIST.length; Ht++)
                  if (En.startsWith(this.PROTOCOL_WHITELIST[Ht]))
                    return En;
                return "https://".concat(En);
              }
              return En;
            }
          }]), kt;
        }(Ke), ze = {
          name: "VueEditor",
          emits: ["ready", "editor-change", "focus", "selection-change", "text-change", "blur", "input", "image-removed", "image-added", "update:modelValue"],
          mixins: [V],
          props: {
            id: {
              type: String,
              default: "quill-container"
            },
            placeholder: {
              type: String,
              default: ""
            },
            modelValue: {
              type: String,
              default: ""
            },
            disabled: {
              type: Boolean
            },
            editorToolbar: {
              type: [Array, Object],
              default: function() {
                return [];
              }
            },
            editorOptions: {
              type: Object,
              required: !1,
              default: function() {
                return {};
              }
            },
            useCustomImageHandler: {
              type: Boolean,
              default: !1
            },
            useMarkdownShortcuts: {
              type: Boolean,
              default: !1
            },
            prependLinksHttps: {
              type: Boolean,
              default: !1
            }
          },
          data: function() {
            return {
              quill: null
            };
          },
          watch: {
            modelValue: function(at) {
              at != this.quill.root.innerHTML && !this.quill.hasFocus() && (this.quill.root.innerHTML = at);
            },
            disabled: function(at) {
              this.quill.enable(!at);
            }
          },
          mounted: function() {
            this.registerCustomModules(S.a), this.registerPrototypes(), this.initializeEditor();
          },
          beforeUnmount: function() {
            this.quill = null, delete this.quill;
          },
          methods: {
            initializeEditor: function() {
              this.setupQuillEditor(), this.checkForCustomImageHandler(), this.handleInitialContent(), this.registerEditorEventListeners(), this.$emit("ready", this.quill);
            },
            setupQuillEditor: function() {
              var at = {
                debug: !1,
                modules: this.setModules(),
                theme: "snow",
                placeholder: this.placeholder ? this.placeholder : "",
                readOnly: this.disabled ? this.disabled : !1
              };
              this.prepareEditorConfig(at), this.quill = new S.a(this.$refs.quillContainer, at);
            },
            setModules: function() {
              var at = {
                toolbar: this.editorToolbar.length ? this.editorToolbar : y
              };
              return this.useMarkdownShortcuts && (S.a.register("modules/markdownShortcuts", te, !0), at.markdownShortcuts = {}), this.prependLinksHttps && S.a.register("formats/link", xe, !0), at;
            },
            prepareEditorConfig: function(at) {
              Object.keys(this.editorOptions).length > 0 && this.editorOptions.constructor === Object && (this.editorOptions.modules && typeof this.editorOptions.modules.toolbar < "u" && delete at.modules.toolbar, G(at, this.editorOptions));
            },
            registerPrototypes: function() {
              S.a.prototype.getHTML = function() {
                return this.container.querySelector(".ql-editor").innerHTML;
              }, S.a.prototype.getWordCount = function() {
                return this.container.querySelector(".ql-editor").innerText.length;
              };
            },
            registerEditorEventListeners: function() {
              this.quill.on("text-change", this.handleTextChange), this.quill.on("selection-change", this.handleSelectionChange), this.listenForEditorEvent("text-change"), this.listenForEditorEvent("selection-change"), this.listenForEditorEvent("editor-change");
            },
            listenForEditorEvent: function(at) {
              var kt = this;
              this.quill.on(at, function() {
                for (var Ut = arguments.length, dn = new Array(Ut), En = 0; En < Ut; En++)
                  dn[En] = arguments[En];
                kt.$emit.apply(kt, [at].concat(dn));
              });
            },
            handleInitialContent: function() {
              this.modelValue && (this.quill.root.innerHTML = this.modelValue);
            },
            handleSelectionChange: function(at, kt) {
              !at && kt ? this.$emit("blur", this.quill) : at && !kt && this.$emit("focus", this.quill);
            },
            handleTextChange: function(at, kt) {
              var Ut = this.quill.getHTML() === "<p><br></p>" ? "" : this.quill.getHTML();
              this.$emit("update:modelValue", Ut), this.useCustomImageHandler && this.handleImageRemoved(at, kt);
            },
            handleImageRemoved: function(at, kt) {
              var Ut = this, dn = this.quill.getContents(), En = dn.diff(kt), Ht = En.ops;
              Ht.map(function(Xt) {
                if (Xt.insert && Xt.insert.hasOwnProperty("image")) {
                  var On = Xt.insert.image;
                  Ut.$emit("image-removed", On);
                }
              });
            },
            checkForCustomImageHandler: function() {
              this.useCustomImageHandler === !0 && this.setupCustomImageHandler();
            },
            setupCustomImageHandler: function() {
              var at = this.quill.getModule("toolbar");
              at.addHandler("image", this.customImageHandler);
            },
            customImageHandler: function() {
              this.$refs.fileInput.click();
            },
            emitImageInfo: function(at) {
              var kt = function() {
                var On = document.getElementById("file-upload");
                On.value = "";
              }, Ut = at.target.files[0], dn = this.quill, En = dn.getSelection(), Ht = En.index;
              this.$emit("image-added", Ut, dn, Ht, kt);
            }
          }
        };
        u("4aea"), u("69de"), ze.render = O;
        var nt = ze, Qt = "0.1.0-alpha.2";
        function Et(pt) {
          Et.installed || (Et.installed = !0, pt.component("VueEditor", nt));
        }
        var zt = {
          install: Et,
          version: Qt,
          Quill: S.a,
          VueEditor: nt
        }, Nt = zt;
        o.default = Nt;
      }
    ),
    /***/
    fb6a: (
      /***/
      function(n, o, u) {
        var c = u("23e7"), d = u("861d"), m = u("e8b5"), v = u("23cb"), S = u("50c4"), $ = u("fc6a"), E = u("8418"), O = u("b622"), T = u("1dde"), y = u("ae40"), V = T("slice"), M = y("slice", { ACCESSORS: !0, 0: 0, 1: 2 }), G = O("species"), k = [].slice, F = Math.max;
        c({ target: "Array", proto: !0, forced: !V || !M }, {
          slice: function(ee, ue) {
            var Q = $(this), Y = S(Q.length), pe = v(ee, Y), oe = v(ue === void 0 ? Y : ue, Y), ne, H, C;
            if (m(Q) && (ne = Q.constructor, typeof ne == "function" && (ne === Array || m(ne.prototype)) ? ne = void 0 : d(ne) && (ne = ne[G], ne === null && (ne = void 0)), ne === Array || ne === void 0))
              return k.call(Q, pe, oe);
            for (H = new (ne === void 0 ? Array : ne)(F(oe - pe, 0)), C = 0; pe < oe; pe++, C++)
              pe in Q && E(H, C, Q[pe]);
            return H.length = C, H;
          }
        });
      }
    ),
    /***/
    fc6a: (
      /***/
      function(n, o, u) {
        var c = u("44ad"), d = u("1d80");
        n.exports = function(m) {
          return c(d(m));
        };
      }
    ),
    /***/
    fdbc: (
      /***/
      function(n, o) {
        n.exports = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0
        };
      }
    ),
    /***/
    fdbf: (
      /***/
      function(n, o, u) {
        var c = u("4930");
        n.exports = c && !Symbol.sham && typeof Symbol.iterator == "symbol";
      }
    )
    /******/
  });
})(vue3Editor_common);
var vue3Editor_commonExports = vue3Editor_common.exports;
const TYPE_PROPOSAL = {
  TEXT_PROPOSAL: "TextProposal",
  UNBONDING_TIME: "UnbondingTime",
  VOTING_PERIOD: "votingparams",
  COMMUNITY_TAX: "communitytax",
  INFLATION_MIN: "InflationMin",
  INFLATION_MAX: "InflationMax",
  DEPOSIT_PARAMS: "depositparams",
  UPDATE_ADMIN_PROPOSAL: "UpdateAdminProposal",
  COMMUNITY_POOL_SPEND_PROPOSAL: "communityPoolSpendProposal"
}, VOTING_PERIOD_OPTIONS = {
  VOTING_DAY: "voting_period_day",
  VOTING_TIME: "voting_period_time"
}, _hoisted_1 = {
  key: 0,
  for: "CreateProposal",
  class: "modal cursor-pointer"
}, _hoisted_2 = {
  key: 0,
  class: "modal-box bg-base-100 rounded-lg",
  for: ""
}, _hoisted_3 = {
  key: 0,
  class: "text-center h-16 items-center"
}, _hoisted_4 = /* @__PURE__ */ createBaseVNode("h1", { class: "text-white text-2xl" }, "Create Proposal", -1), _hoisted_5 = { class: "flex flex-col gap-2" }, _hoisted_6 = /* @__PURE__ */ createBaseVNode("h2", null, "Type Proposal", -1), _hoisted_7 = ["value"], _hoisted_8 = { class: "flex flex-col gap-2" }, _hoisted_9 = /* @__PURE__ */ createBaseVNode("h2", null, "Title", -1), _hoisted_10 = { class: "flex flex-col gap-2" }, _hoisted_11 = /* @__PURE__ */ createBaseVNode("h2", null, "Description", -1), _hoisted_12 = { class: "flex flex-col gap-2" }, _hoisted_13 = {
  key: 0,
  class: "flex flex-col gap-2"
}, _hoisted_14 = /* @__PURE__ */ createBaseVNode("h2", null, "Unbonding time", -1), _hoisted_15 = {
  key: 1,
  class: "flex flex-col gap-2"
}, _hoisted_16 = /* @__PURE__ */ createBaseVNode("h2", null, "Voting Period", -1), _hoisted_17 = { class: "flex gap-2" }, _hoisted_18 = ["value"], _hoisted_19 = {
  key: 2,
  class: "flex flex-col gap-2"
}, _hoisted_20 = /* @__PURE__ */ createBaseVNode("h2", null, "Community Tax (%)", -1), _hoisted_21 = {
  key: 3,
  class: "flex flex-col gap-2"
}, _hoisted_22 = /* @__PURE__ */ createBaseVNode("h2", null, "Minimum Inflation (%)", -1), _hoisted_23 = {
  key: 4,
  class: "flex flex-col gap-2"
}, _hoisted_24 = /* @__PURE__ */ createBaseVNode("h2", null, "Maximum Inflation (%)", -1), _hoisted_25 = {
  key: 5,
  class: "flex flex-col gap-2"
}, _hoisted_26 = {
  key: 6,
  class: "flex flex-col gap-2"
}, _hoisted_27 = /* @__PURE__ */ createBaseVNode("h2", null, "New Admin", -1), _hoisted_28 = {
  key: 7,
  class: "flex flex-col gap-2"
}, _hoisted_29 = /* @__PURE__ */ createBaseVNode("h2", null, "Contract", -1), _hoisted_30 = {
  key: 8,
  class: "flex flex-col gap-2"
}, _hoisted_31 = /* @__PURE__ */ createBaseVNode("h2", null, "Recipient", -1), _hoisted_32 = {
  key: 9,
  class: "flex flex-col gap-2"
}, _hoisted_33 = /* @__PURE__ */ createBaseVNode("div", { class: "flex flex-col gap-2" }, [
  /* @__PURE__ */ createBaseVNode("h2", null, "Notes"),
  /* @__PURE__ */ createBaseVNode("p", { class: "text-sm" }, "If the proposal cannot pass the deposit period, then all the deposited tokens will be burned. So please create & choose the proposals wisely!")
], -1), _hoisted_34 = { class: "flex" }, _hoisted_35 = /* @__PURE__ */ createBaseVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "stroke-current flex-shrink-0 h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ createBaseVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1), _hoisted_36 = {
  class: "!text-white btn grow bg-primary border-0 hover:brightness-150 hover:bg-primary",
  type: "submit"
}, _hoisted_37 = {
  key: 1,
  class: "modal-box bg-base-100 rounded-lg",
  for: ""
}, _hoisted_38 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-5 w-full"
}, _hoisted_39 = /* @__PURE__ */ createBaseVNode("p", { class: "font-bold text-green-500" }, "Create Proposal Successfully", -1), _hoisted_40 = { key: 1 }, _hoisted_41 = /* @__PURE__ */ createBaseVNode("p", { class: "font-bold text-red-500" }, "Create Proposal Failed", -1), __default__ = {
  name: "CreateProposal"
}, _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    sender: { type: String, required: !0 },
    denom: { type: String, required: !0 },
    chainId: { type: String, required: !0 },
    urlRpc: { type: String, required: !0 }
  },
  emits: ["viewTraction", "viewProposal"],
  setup(e, { emit: n }) {
    const o = e, { TEXT_PROPOSAL: u, UNBONDING_TIME: c, VOTING_PERIOD: d, COMMUNITY_TAX: m, INFLATION_MIN: v, INFLATION_MAX: S, DEPOSIT_PARAMS: $, UPDATE_ADMIN_PROPOSAL: E, COMMUNITY_POOL_SPEND_PROPOSAL: O } = TYPE_PROPOSAL, { VOTING_DAY: T, VOTING_TIME: y } = VOTING_PERIOD_OPTIONS, V = [
      { label: "Text Proposal", value: u },
      { label: "Unbonding Time", value: c },
      { label: "Voting Period", value: d },
      { label: "Community Tax", value: m },
      { label: "Minimum Inflation", value: v },
      { label: "Maximum Inflation", value: S },
      { label: "Minimum Deposit Amount", value: $ },
      { label: "Update Admin Proposal", value: E },
      { label: "DAO Treasury Spend Proposal", value: O }
    ], M = [
      {
        label: "Day",
        value: T
      },
      {
        label: "Time",
        value: y
      }
    ], G = {
      title: "",
      description: "",
      amount: 10,
      unbondingTime: 1209600,
      votingPeriodTime: "01:00:00",
      votingPeriodDay: 1,
      communityTax: 1,
      inflationMin: 1,
      inflationMax: 1,
      minDeposit: 10,
      newAdmin: "",
      contract: "",
      recipient: "",
      receiveAmount: 10
    }, k = ref(!1), F = ref(u), X = ref(T), ee = ref(""), ue = ref(!1), Q = ref(!1), Y = ref(!1), pe = ref("");
    let oe = reactive({ ...G });
    watch(k, () => {
      k.value || (Object.assign(oe, { ...G }), Q.value = !1, ee.value = "");
    });
    const ne = (se) => {
      const fe = se.split(":"), N = +fe[0] * 60 * 60 + +fe[1] * 60 + +fe[2];
      return new BigNumber(N).multipliedBy(new BigNumber(Math.pow(10, 9))).toFixed(0);
    }, H = (se, fe) => se ? new BigNumber(Math.round(se * 24 * 60 * 60)).multipliedBy(new BigNumber(Math.pow(10, 9))).toFixed(0) : ne(fe), C = (se) => {
      switch (se.amount *= 10 ** 6, F.value) {
        case d:
          const { votingPeriodDay: fe, votingPeriodTime: N } = se;
          return {
            ...se,
            subspace: "gov",
            key: d,
            value: JSON.stringify({
              voting_period: H(fe, N)
            })
          };
        case $:
          return {
            ...se,
            subspace: "gov",
            key: $,
            value: JSON.stringify({
              min_deposit: [{ denom: o.denom, amount: (se.minDeposit * 10 ** 6).toString() }]
            })
          };
        case m:
          return {
            ...se,
            subspace: "distribution",
            key: m,
            value: JSON.stringify(JSON.stringify((se == null ? void 0 : se.communityTax) / 100))
          };
        case v:
          return {
            ...se,
            subspace: "mint",
            key: v,
            value: JSON.stringify(JSON.stringify((se == null ? void 0 : se.inflationMin) / 100))
          };
        case S:
          return {
            ...se,
            subspace: "mint",
            key: S,
            value: JSON.stringify(JSON.stringify((se == null ? void 0 : se.inflationMax) / 100))
          };
        case u:
          return {
            ...se,
            key: u
          };
        case E:
          return {
            ...se,
            key: E
          };
        case O:
          return {
            ...se,
            key: O
          };
        default:
          return {
            ...se,
            subspace: "staking",
            key: c,
            value: JSON.stringify(new BigNumber(+(se == null ? void 0 : se.unbondingTime) * Math.pow(10, 9)).toFixed(0))
          };
      }
    }, w = async (se) => {
      se.preventDefault(), ue.value = !0, ee.value = "";
      const fe = { ...oe }, N = C(fe), { title: W, description: I, subspace: te, key: ge, value: Pe, amount: Ke, newAdmin: xe, contract: ze, recipient: nt, receiveAmount: Qt } = N, { urlRpc: Et, chainId: zt, sender: Nt, denom: pt } = o, at = "orai10d07y265gmmuvt4z0w9aw880jnsr700jf39xhq";
      let kt;
      try {
        ge === u ? kt = await walletStation.textProposal(Nt, at, { title: W, description: I, amount: Ke, denom: pt }, { urlRpc: Et, chainId: zt }) : ge == E ? kt = await walletStation.updateAdminProposal(Nt, at, {
          title: W,
          description: I.trim(),
          newAdmin: xe,
          contract: ze,
          denom: pt,
          amount: Ke
        }, { urlRpc: Et, chainId: zt }) : ge == O ? kt = await walletStation.communityPoolSpendProposal(
          Nt,
          at,
          {
            title: W,
            description: I.trim(),
            recipient: nt,
            deposit: Ke,
            amount: (Qt * Math.pow(10, 6)).toString(),
            denom: pt
          },
          { urlRpc: Et, chainId: zt }
        ) : kt = await walletStation.parameterChangeProposal(Nt, at, {
          title: W,
          description: I,
          amount: Ke,
          denom: pt,
          subspace: te,
          value: Pe,
          key: ge
        }, { urlRpc: Et, chainId: zt }), Q.value = !0;
      } catch (Ut) {
        console.log({ err: Ut }), ee.value = Ut;
      }
      pe.value = kt == null ? void 0 : kt.transactionHash, (kt == null ? void 0 : kt.code) === 0 ? Y.value = !0 : Y.value = !1, ue.value = !1;
    }, P = () => {
      n("viewTraction", { txhash: pe.value }), k.value = !1;
    }, J = () => {
      k.value = !1, n("viewProposal");
    };
    return (se, fe) => (openBlock(), createElementBlock("div", null, [
      withDirectives(createBaseVNode("input", {
        "onUpdate:modelValue": fe[0] || (fe[0] = (N) => k.value = N),
        type: "checkbox",
        id: "CreateProposal",
        class: "modal-toggle"
      }, null, 512), [
        [vModelCheckbox, k.value]
      ]),
      k.value ? (openBlock(), createElementBlock("label", _hoisted_1, [
        Q.value ? (openBlock(), createElementBlock("label", _hoisted_37, [
          Y.value ? (openBlock(), createElementBlock("div", _hoisted_38, [
            _hoisted_39,
            createBaseVNode("button", {
              class: "!text-white btn grow bg-primary border-0 hover:brightness-150 hover:bg-primary w-full",
              onClick: J
            }, "View Proposal")
          ])) : (openBlock(), createElementBlock("div", _hoisted_40, [
            _hoisted_41,
            createBaseVNode("button", {
              class: "!text-white btn grow bg-primary border-0 hover:brightness-150 hover:bg-primary w-full",
              onClick: P
            }, "View Transaction")
          ]))
        ])) : (openBlock(), createElementBlock("label", _hoisted_2, [
          e.sender ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", _hoisted_3, " No wallet connected! ")),
          e.sender ? (openBlock(), createElementBlock("form", {
            key: 1,
            class: "flex gap-5 flex-col",
            onsubmit: w,
            method: "get"
          }, [
            _hoisted_4,
            createBaseVNode("div", _hoisted_5, [
              _hoisted_6,
              withDirectives(createBaseVNode("select", {
                "onUpdate:modelValue": fe[1] || (fe[1] = (N) => F.value = N),
                class: "h-10 w-1/2 border p-2 rounded-lg border-base-300 outline-none hover:cursor-pointer text-white"
              }, [
                (openBlock(), createElementBlock(Fragment, null, renderList(V, (N) => createBaseVNode("option", {
                  value: N.value
                }, toDisplayString(N.label), 9, _hoisted_7)), 64))
              ], 512), [
                [vModelSelect, F.value]
              ])
            ]),
            createBaseVNode("div", _hoisted_8, [
              _hoisted_9,
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[2] || (fe[2] = (N) => unref(oe).title = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter title proposal",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).title]
              ])
            ]),
            createBaseVNode("div", _hoisted_10, [
              _hoisted_11,
              createVNode(unref(vue3Editor_commonExports.VueEditor), {
                id: "editor",
                useCustomImageHandler: "false",
                modelValue: unref(oe).description,
                "onUpdate:modelValue": fe[3] || (fe[3] = (N) => unref(oe).description = N)
              }, null, 8, ["modelValue"])
            ]),
            createBaseVNode("div", _hoisted_12, [
              createBaseVNode("h2", null, "Deposit Amount (" + toDisplayString(e.denom) + ")", 1),
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[4] || (fe[4] = (N) => unref(oe).amount = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter deposit amount",
                type: "number",
                step: 1e-8,
                min: "0",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).amount]
              ])
            ]),
            F.value === unref(c) ? (openBlock(), createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[5] || (fe[5] = (N) => unref(oe).unbondingTime = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter unbonding time",
                type: "number",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).unbondingTime]
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref(d) ? (openBlock(), createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              createBaseVNode("div", _hoisted_17, [
                withDirectives(createBaseVNode("select", {
                  "onUpdate:modelValue": fe[6] || (fe[6] = (N) => X.value = N),
                  class: "h-10 w-1/3 border p-2 rounded-lg border-base-300 outline-none hover:cursor-pointer text-white"
                }, [
                  (openBlock(), createElementBlock(Fragment, null, renderList(M, (N) => createBaseVNode("option", {
                    value: N.value
                  }, toDisplayString(N.label), 9, _hoisted_18)), 64))
                ], 512), [
                  [vModelSelect, X.value]
                ]),
                X.value === unref(T) ? withDirectives((openBlock(), createElementBlock("input", {
                  key: 0,
                  class: "h-10 w-2/3 rounded-lg border border-base-300 outline-none p-2 text-white",
                  type: "number",
                  min: "1",
                  "onUpdate:modelValue": fe[7] || (fe[7] = (N) => unref(oe).votingPeriodDay = N),
                  required: ""
                }, null, 512)), [
                  [vModelText, unref(oe).votingPeriodDay]
                ]) : withDirectives((openBlock(), createElementBlock("input", {
                  key: 1,
                  class: "h-10 w-2/3 rounded-lg border border-base-300 outline-none p-2 text-white",
                  "onUpdate:modelValue": fe[8] || (fe[8] = (N) => unref(oe).votingPeriodTime = N),
                  type: "time",
                  step: "1",
                  required: ""
                }, null, 512)), [
                  [vModelText, unref(oe).votingPeriodTime]
                ])
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref(m) ? (openBlock(), createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[9] || (fe[9] = (N) => unref(oe).communityTax = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter community tax",
                type: "number",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).communityTax]
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref(v) ? (openBlock(), createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[10] || (fe[10] = (N) => unref(oe).inflationMin = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter minimum inflation",
                type: "number",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).inflationMin]
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref(S) ? (openBlock(), createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[11] || (fe[11] = (N) => unref(oe).inflationMax = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter maximum inflation",
                type: "number",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).inflationMax]
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref($) ? (openBlock(), createElementBlock("div", _hoisted_25, [
              createBaseVNode("h2", null, "Minimum Deposit Amount (" + toDisplayString(e.denom) + ")", 1),
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[12] || (fe[12] = (N) => unref(oe).minDeposit = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter minimum deposit amount",
                type: "number",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).minDeposit]
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref(E) ? (openBlock(), createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[13] || (fe[13] = (N) => unref(oe).newAdmin = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter new admin",
                type: "text",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).newAdmin]
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref(E) ? (openBlock(), createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[14] || (fe[14] = (N) => unref(oe).contract = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter contract",
                type: "text",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).contract]
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref(O) ? (openBlock(), createElementBlock("div", _hoisted_30, [
              _hoisted_31,
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[15] || (fe[15] = (N) => unref(oe).recipient = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter recipient",
                type: "text",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).recipient]
              ])
            ])) : createCommentVNode("", !0),
            F.value === unref(O) ? (openBlock(), createElementBlock("div", _hoisted_32, [
              createBaseVNode("h2", null, "Amount(" + toDisplayString(e.denom) + ")", 1),
              withDirectives(createBaseVNode("input", {
                "onUpdate:modelValue": fe[16] || (fe[16] = (N) => unref(oe).receiveAmount = N),
                class: "w-full h-10 rounded-lg border border-base-300 outline-none p-2 text-white",
                placeholder: "Enter amount",
                type: "number",
                min: "0",
                required: ""
              }, null, 512), [
                [vModelText, unref(oe).receiveAmount]
              ])
            ])) : createCommentVNode("", !0),
            _hoisted_33,
            withDirectives(createBaseVNode("div", {
              class: "alert alert-error shadow-lg",
              onClick: fe[17] || (fe[17] = (N) => ee.value = "")
            }, [
              createBaseVNode("div", _hoisted_34, [
                _hoisted_35,
                createBaseVNode("span", null, toDisplayString(ee.value) + ".", 1)
              ])
            ], 512), [
              [vShow, ee.value]
            ]),
            createBaseVNode("button", _hoisted_36, [
              ue.value ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass(ue.value ? "loading loading-spinner" : "")
              }, null, 2)) : createCommentVNode("", !0),
              createTextVNode(" Create")
            ])
          ])) : createCommentVNode("", !0)
        ]))
      ])) : createCommentVNode("", !0)
    ]));
  }
}), CreateProposal_vue_vue_type_style_index_0_lang = "", main$1 = "";
function registry(e, n) {
  if (!window.customElements.get(e)) {
    const o = wrapper(n, createApp, h);
    window.customElements.define(e, o);
  }
}
registry("ping-tx-dialog", _sfc_main$3);
registry("ping-connect-wallet", _sfc_main$2);
registry("ping-token-convert", _sfc_main$1);
registry("ping-create-proposal", _sfc_main);
const main = {
  version: "0.0.5"
};
export {
  Any as A,
  Coin as C,
  Long$2 as L,
  MsgCreatePosition as M,
  PageRequest as P,
  Timestamp as T,
  _defineProperty as _,
  PageResponse as a,
  Params$b as b,
  Pool as c,
  Pool$2 as d,
  CosmWasmPool as e,
  fromTimestamp as f,
  Pool$1 as g,
  build$5 as h,
  MsgCreatePositionResponse as i,
  MsgWithdrawPosition as j,
  MsgWithdrawPositionResponse as k,
  MsgCollectFees as l,
  minimal as m,
  MsgCollectFeesResponse as n,
  MsgCollectIncentives as o,
  MsgCollectIncentivesResponse as p,
  MsgFungifyChargedPositions as q,
  MsgFungifyChargedPositionsResponse as r,
  setPaginationParams as s,
  toTimestamp as t,
  main as u
};
